(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec044"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec044"] = parcelRequire;
}
parcelRequire.register("dYG3T", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $a2d18189ffab5937$export$ffb0004e005737fa; });
$parcel$export(module.exports, "jsx", function () { return $a2d18189ffab5937$export$34b9dba7ce09269b; });
$parcel$export(module.exports, "jsxs", function () { return $a2d18189ffab5937$export$25062201e9e25d76; });

var $3DnwL = parcelRequire("3DnwL");

var $lvueV = parcelRequire("lvueV");
parcelRequire("fV3WI");
parcelRequire("kMyao");
parcelRequire("b0Oht");
parcelRequire("KeUL6");

parcelRequire("OTT3m");
parcelRequire("lbaR7");
parcelRequire("cNCY5");
parcelRequire("6THgH");
var $a2d18189ffab5937$export$ffb0004e005737fa = $3DnwL.Fragment;
function $a2d18189ffab5937$export$34b9dba7ce09269b(type, props, key) {
    if (!(0, $lvueV.h).call(props, "css")) return $3DnwL.jsx(type, props, key);
    return $3DnwL.jsx((0, $lvueV.E), (0, $lvueV.c)(type, props), key);
}
function $a2d18189ffab5937$export$25062201e9e25d76(type, props, key) {
    if (!(0, $lvueV.h).call(props, "css")) return $3DnwL.jsxs(type, props, key);
    return $3DnwL.jsxs((0, $lvueV.E), (0, $lvueV.c)(type, props), key);
}

});
parcelRequire.register("3DnwL", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3MQlC"));

});
parcelRequire.register("3MQlC", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $2c1e75ee91ac0ffe$export$ffb0004e005737fa; }, function (v) { return $2c1e75ee91ac0ffe$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $2c1e75ee91ac0ffe$export$34b9dba7ce09269b; }, function (v) { return $2c1e75ee91ac0ffe$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $2c1e75ee91ac0ffe$export$25062201e9e25d76; }, function (v) { return $2c1e75ee91ac0ffe$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2c1e75ee91ac0ffe$export$ffb0004e005737fa;
var $2c1e75ee91ac0ffe$export$34b9dba7ce09269b;
var $2c1e75ee91ac0ffe$export$25062201e9e25d76;
"use strict";

var $fV3WI = parcelRequire("fV3WI");
var $2c1e75ee91ac0ffe$var$k = Symbol.for("react.element"), $2c1e75ee91ac0ffe$var$l = Symbol.for("react.fragment"), $2c1e75ee91ac0ffe$var$m = Object.prototype.hasOwnProperty, $2c1e75ee91ac0ffe$var$n = $fV3WI.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $2c1e75ee91ac0ffe$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $2c1e75ee91ac0ffe$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$2c1e75ee91ac0ffe$var$m.call(a, b) && !$2c1e75ee91ac0ffe$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $2c1e75ee91ac0ffe$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $2c1e75ee91ac0ffe$var$n.current
    };
}
$2c1e75ee91ac0ffe$export$ffb0004e005737fa = $2c1e75ee91ac0ffe$var$l;
$2c1e75ee91ac0ffe$export$34b9dba7ce09269b = $2c1e75ee91ac0ffe$var$q;
$2c1e75ee91ac0ffe$export$25062201e9e25d76 = $2c1e75ee91ac0ffe$var$q;

});
parcelRequire.register("fV3WI", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fZGOL"));

});
parcelRequire.register("fZGOL", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $ba4dc43dc54c3787$export$dca3b0875bd9a954; }, function (v) { return $ba4dc43dc54c3787$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $ba4dc43dc54c3787$export$16fa2f45be04daa8; }, function (v) { return $ba4dc43dc54c3787$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $ba4dc43dc54c3787$export$ffb0004e005737fa; }, function (v) { return $ba4dc43dc54c3787$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $ba4dc43dc54c3787$export$e2c29f18771995cb; }, function (v) { return $ba4dc43dc54c3787$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $ba4dc43dc54c3787$export$221d75b3f55bb0bd; }, function (v) { return $ba4dc43dc54c3787$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $ba4dc43dc54c3787$export$5f8d39834fd61797; }, function (v) { return $ba4dc43dc54c3787$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $ba4dc43dc54c3787$export$74bf444e3cd11ea5; }, function (v) { return $ba4dc43dc54c3787$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $ba4dc43dc54c3787$export$ae55be85d98224ed; }, function (v) { return $ba4dc43dc54c3787$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $ba4dc43dc54c3787$export$e530037191fcd5d7; }, function (v) { return $ba4dc43dc54c3787$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $ba4dc43dc54c3787$export$fd42f52fd3ae1109; }, function (v) { return $ba4dc43dc54c3787$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $ba4dc43dc54c3787$export$c8a8987d4410bf2d; }, function (v) { return $ba4dc43dc54c3787$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $ba4dc43dc54c3787$export$d38cd72104c1f0e9; }, function (v) { return $ba4dc43dc54c3787$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $ba4dc43dc54c3787$export$7d1e3a5e95ceca43; }, function (v) { return $ba4dc43dc54c3787$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $ba4dc43dc54c3787$export$257a8862b851cb5b; }, function (v) { return $ba4dc43dc54c3787$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $ba4dc43dc54c3787$export$a8257692ac88316c; }, function (v) { return $ba4dc43dc54c3787$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $ba4dc43dc54c3787$export$488013bae63b21da; }, function (v) { return $ba4dc43dc54c3787$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $ba4dc43dc54c3787$export$7c73462e0d25e514; }, function (v) { return $ba4dc43dc54c3787$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $ba4dc43dc54c3787$export$7568632d0d33d16d; }, function (v) { return $ba4dc43dc54c3787$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $ba4dc43dc54c3787$export$88948ce120ea2619; }, function (v) { return $ba4dc43dc54c3787$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $ba4dc43dc54c3787$export$35808ee640e87ca7; }, function (v) { return $ba4dc43dc54c3787$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $ba4dc43dc54c3787$export$fae74005e78b1a27; }, function (v) { return $ba4dc43dc54c3787$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $ba4dc43dc54c3787$export$dc8fbce3eb94dc1e; }, function (v) { return $ba4dc43dc54c3787$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $ba4dc43dc54c3787$export$6a7bc4e911dc01cf; }, function (v) { return $ba4dc43dc54c3787$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $ba4dc43dc54c3787$export$6d9c69b0de29b591; }, function (v) { return $ba4dc43dc54c3787$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $ba4dc43dc54c3787$export$f680877a34711e37; }, function (v) { return $ba4dc43dc54c3787$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $ba4dc43dc54c3787$export$d5a552a76deda3c2; }, function (v) { return $ba4dc43dc54c3787$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $ba4dc43dc54c3787$export$aaabe4eda9ed9969; }, function (v) { return $ba4dc43dc54c3787$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $ba4dc43dc54c3787$export$e5c5a5f917a5871c; }, function (v) { return $ba4dc43dc54c3787$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $ba4dc43dc54c3787$export$1538c33de8887b59; }, function (v) { return $ba4dc43dc54c3787$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $ba4dc43dc54c3787$export$13e3392192263954; }, function (v) { return $ba4dc43dc54c3787$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $ba4dc43dc54c3787$export$b8f5890fc79d6aca; }, function (v) { return $ba4dc43dc54c3787$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $ba4dc43dc54c3787$export$60241385465d0a34; }, function (v) { return $ba4dc43dc54c3787$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $ba4dc43dc54c3787$export$306c0aa65ff9ec16; }, function (v) { return $ba4dc43dc54c3787$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $ba4dc43dc54c3787$export$7b286972b8d8ccbf; }, function (v) { return $ba4dc43dc54c3787$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $ba4dc43dc54c3787$export$83d89fbfd8236492; }, function (v) { return $ba4dc43dc54c3787$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ba4dc43dc54c3787$export$dca3b0875bd9a954;
var $ba4dc43dc54c3787$export$16fa2f45be04daa8;
var $ba4dc43dc54c3787$export$ffb0004e005737fa;
var $ba4dc43dc54c3787$export$e2c29f18771995cb;
var $ba4dc43dc54c3787$export$221d75b3f55bb0bd;
var $ba4dc43dc54c3787$export$5f8d39834fd61797;
var $ba4dc43dc54c3787$export$74bf444e3cd11ea5;
var $ba4dc43dc54c3787$export$ae55be85d98224ed;
var $ba4dc43dc54c3787$export$e530037191fcd5d7;
var $ba4dc43dc54c3787$export$fd42f52fd3ae1109;
var $ba4dc43dc54c3787$export$c8a8987d4410bf2d;
var $ba4dc43dc54c3787$export$d38cd72104c1f0e9;
var $ba4dc43dc54c3787$export$7d1e3a5e95ceca43;
var $ba4dc43dc54c3787$export$257a8862b851cb5b;
var $ba4dc43dc54c3787$export$a8257692ac88316c;
var $ba4dc43dc54c3787$export$488013bae63b21da;
var $ba4dc43dc54c3787$export$7c73462e0d25e514;
var $ba4dc43dc54c3787$export$7568632d0d33d16d;
var $ba4dc43dc54c3787$export$88948ce120ea2619;
var $ba4dc43dc54c3787$export$35808ee640e87ca7;
var $ba4dc43dc54c3787$export$fae74005e78b1a27;
var $ba4dc43dc54c3787$export$dc8fbce3eb94dc1e;
var $ba4dc43dc54c3787$export$6a7bc4e911dc01cf;
var $ba4dc43dc54c3787$export$6d9c69b0de29b591;
var $ba4dc43dc54c3787$export$f680877a34711e37;
var $ba4dc43dc54c3787$export$d5a552a76deda3c2;
var $ba4dc43dc54c3787$export$aaabe4eda9ed9969;
var $ba4dc43dc54c3787$export$e5c5a5f917a5871c;
var $ba4dc43dc54c3787$export$1538c33de8887b59;
var $ba4dc43dc54c3787$export$13e3392192263954;
var $ba4dc43dc54c3787$export$b8f5890fc79d6aca;
var $ba4dc43dc54c3787$export$60241385465d0a34;
var $ba4dc43dc54c3787$export$306c0aa65ff9ec16;
var $ba4dc43dc54c3787$export$7b286972b8d8ccbf;
var $ba4dc43dc54c3787$export$83d89fbfd8236492;
"use strict";
var $ba4dc43dc54c3787$var$l = Symbol.for("react.element"), $ba4dc43dc54c3787$var$n = Symbol.for("react.portal"), $ba4dc43dc54c3787$var$p = Symbol.for("react.fragment"), $ba4dc43dc54c3787$var$q = Symbol.for("react.strict_mode"), $ba4dc43dc54c3787$var$r = Symbol.for("react.profiler"), $ba4dc43dc54c3787$var$t = Symbol.for("react.provider"), $ba4dc43dc54c3787$var$u = Symbol.for("react.context"), $ba4dc43dc54c3787$var$v = Symbol.for("react.forward_ref"), $ba4dc43dc54c3787$var$w = Symbol.for("react.suspense"), $ba4dc43dc54c3787$var$x = Symbol.for("react.memo"), $ba4dc43dc54c3787$var$y = Symbol.for("react.lazy"), $ba4dc43dc54c3787$var$z = Symbol.iterator;
function $ba4dc43dc54c3787$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $ba4dc43dc54c3787$var$z && a[$ba4dc43dc54c3787$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $ba4dc43dc54c3787$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $ba4dc43dc54c3787$var$C = Object.assign, $ba4dc43dc54c3787$var$D = {};
function $ba4dc43dc54c3787$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $ba4dc43dc54c3787$var$D;
    this.updater = e || $ba4dc43dc54c3787$var$B;
}
$ba4dc43dc54c3787$var$E.prototype.isReactComponent = {};
$ba4dc43dc54c3787$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$ba4dc43dc54c3787$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $ba4dc43dc54c3787$var$F() {}
$ba4dc43dc54c3787$var$F.prototype = $ba4dc43dc54c3787$var$E.prototype;
function $ba4dc43dc54c3787$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $ba4dc43dc54c3787$var$D;
    this.updater = e || $ba4dc43dc54c3787$var$B;
}
var $ba4dc43dc54c3787$var$H = $ba4dc43dc54c3787$var$G.prototype = new $ba4dc43dc54c3787$var$F;
$ba4dc43dc54c3787$var$H.constructor = $ba4dc43dc54c3787$var$G;
$ba4dc43dc54c3787$var$C($ba4dc43dc54c3787$var$H, $ba4dc43dc54c3787$var$E.prototype);
$ba4dc43dc54c3787$var$H.isPureReactComponent = !0;
var $ba4dc43dc54c3787$var$I = Array.isArray, $ba4dc43dc54c3787$var$J = Object.prototype.hasOwnProperty, $ba4dc43dc54c3787$var$K = {
    current: null
}, $ba4dc43dc54c3787$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $ba4dc43dc54c3787$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$ba4dc43dc54c3787$var$J.call(b, d) && !$ba4dc43dc54c3787$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $ba4dc43dc54c3787$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $ba4dc43dc54c3787$var$K.current
    };
}
function $ba4dc43dc54c3787$var$N(a, b) {
    return {
        $$typeof: $ba4dc43dc54c3787$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $ba4dc43dc54c3787$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ba4dc43dc54c3787$var$l;
}
function $ba4dc43dc54c3787$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $ba4dc43dc54c3787$var$P = /\/+/g;
function $ba4dc43dc54c3787$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $ba4dc43dc54c3787$var$escape("" + a.key) : b.toString(36);
}
function $ba4dc43dc54c3787$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $ba4dc43dc54c3787$var$l:
                case $ba4dc43dc54c3787$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $ba4dc43dc54c3787$var$Q(h, 0) : d, $ba4dc43dc54c3787$var$I(c) ? (e = "", null != a && (e = a.replace($ba4dc43dc54c3787$var$P, "$&/") + "/"), $ba4dc43dc54c3787$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($ba4dc43dc54c3787$var$O(c) && (c = $ba4dc43dc54c3787$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($ba4dc43dc54c3787$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($ba4dc43dc54c3787$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $ba4dc43dc54c3787$var$Q(k, g);
        h += $ba4dc43dc54c3787$var$R(k, b, e, f, c);
    }
    else if (f = $ba4dc43dc54c3787$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $ba4dc43dc54c3787$var$Q(k, g++), h += $ba4dc43dc54c3787$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $ba4dc43dc54c3787$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $ba4dc43dc54c3787$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $ba4dc43dc54c3787$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $ba4dc43dc54c3787$var$U = {
    current: null
}, $ba4dc43dc54c3787$var$V = {
    transition: null
}, $ba4dc43dc54c3787$var$W = {
    ReactCurrentDispatcher: $ba4dc43dc54c3787$var$U,
    ReactCurrentBatchConfig: $ba4dc43dc54c3787$var$V,
    ReactCurrentOwner: $ba4dc43dc54c3787$var$K
};
$ba4dc43dc54c3787$export$dca3b0875bd9a954 = {
    map: $ba4dc43dc54c3787$var$S,
    forEach: function(a, b, e) {
        $ba4dc43dc54c3787$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $ba4dc43dc54c3787$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $ba4dc43dc54c3787$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$ba4dc43dc54c3787$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$ba4dc43dc54c3787$export$16fa2f45be04daa8 = $ba4dc43dc54c3787$var$E;
$ba4dc43dc54c3787$export$ffb0004e005737fa = $ba4dc43dc54c3787$var$p;
$ba4dc43dc54c3787$export$e2c29f18771995cb = $ba4dc43dc54c3787$var$r;
$ba4dc43dc54c3787$export$221d75b3f55bb0bd = $ba4dc43dc54c3787$var$G;
$ba4dc43dc54c3787$export$5f8d39834fd61797 = $ba4dc43dc54c3787$var$q;
$ba4dc43dc54c3787$export$74bf444e3cd11ea5 = $ba4dc43dc54c3787$var$w;
$ba4dc43dc54c3787$export$ae55be85d98224ed = $ba4dc43dc54c3787$var$W;
$ba4dc43dc54c3787$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $ba4dc43dc54c3787$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $ba4dc43dc54c3787$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$ba4dc43dc54c3787$var$J.call(b, f) && !$ba4dc43dc54c3787$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $ba4dc43dc54c3787$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$ba4dc43dc54c3787$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $ba4dc43dc54c3787$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $ba4dc43dc54c3787$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$ba4dc43dc54c3787$export$c8a8987d4410bf2d = $ba4dc43dc54c3787$var$M;
$ba4dc43dc54c3787$export$d38cd72104c1f0e9 = function(a) {
    var b = $ba4dc43dc54c3787$var$M.bind(null, a);
    b.type = a;
    return b;
};
$ba4dc43dc54c3787$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$ba4dc43dc54c3787$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $ba4dc43dc54c3787$var$v,
        render: a
    };
};
$ba4dc43dc54c3787$export$a8257692ac88316c = $ba4dc43dc54c3787$var$O;
$ba4dc43dc54c3787$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $ba4dc43dc54c3787$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $ba4dc43dc54c3787$var$T
    };
};
$ba4dc43dc54c3787$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $ba4dc43dc54c3787$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$ba4dc43dc54c3787$export$7568632d0d33d16d = function(a) {
    var b = $ba4dc43dc54c3787$var$V.transition;
    $ba4dc43dc54c3787$var$V.transition = {};
    try {
        a();
    } finally{
        $ba4dc43dc54c3787$var$V.transition = b;
    }
};
$ba4dc43dc54c3787$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$ba4dc43dc54c3787$export$35808ee640e87ca7 = function(a, b) {
    return $ba4dc43dc54c3787$var$U.current.useCallback(a, b);
};
$ba4dc43dc54c3787$export$fae74005e78b1a27 = function(a) {
    return $ba4dc43dc54c3787$var$U.current.useContext(a);
};
$ba4dc43dc54c3787$export$dc8fbce3eb94dc1e = function() {};
$ba4dc43dc54c3787$export$6a7bc4e911dc01cf = function(a) {
    return $ba4dc43dc54c3787$var$U.current.useDeferredValue(a);
};
$ba4dc43dc54c3787$export$6d9c69b0de29b591 = function(a, b) {
    return $ba4dc43dc54c3787$var$U.current.useEffect(a, b);
};
$ba4dc43dc54c3787$export$f680877a34711e37 = function() {
    return $ba4dc43dc54c3787$var$U.current.useId();
};
$ba4dc43dc54c3787$export$d5a552a76deda3c2 = function(a, b, e) {
    return $ba4dc43dc54c3787$var$U.current.useImperativeHandle(a, b, e);
};
$ba4dc43dc54c3787$export$aaabe4eda9ed9969 = function(a, b) {
    return $ba4dc43dc54c3787$var$U.current.useInsertionEffect(a, b);
};
$ba4dc43dc54c3787$export$e5c5a5f917a5871c = function(a, b) {
    return $ba4dc43dc54c3787$var$U.current.useLayoutEffect(a, b);
};
$ba4dc43dc54c3787$export$1538c33de8887b59 = function(a, b) {
    return $ba4dc43dc54c3787$var$U.current.useMemo(a, b);
};
$ba4dc43dc54c3787$export$13e3392192263954 = function(a, b, e) {
    return $ba4dc43dc54c3787$var$U.current.useReducer(a, b, e);
};
$ba4dc43dc54c3787$export$b8f5890fc79d6aca = function(a) {
    return $ba4dc43dc54c3787$var$U.current.useRef(a);
};
$ba4dc43dc54c3787$export$60241385465d0a34 = function(a) {
    return $ba4dc43dc54c3787$var$U.current.useState(a);
};
$ba4dc43dc54c3787$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $ba4dc43dc54c3787$var$U.current.useSyncExternalStore(a, b, e);
};
$ba4dc43dc54c3787$export$7b286972b8d8ccbf = function() {
    return $ba4dc43dc54c3787$var$U.current.useTransition();
};
$ba4dc43dc54c3787$export$83d89fbfd8236492 = "18.2.0";

});




parcelRequire.register("lvueV", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $fa83f33601782aca$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $fa83f33601782aca$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "C", function () { return $fa83f33601782aca$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $fa83f33601782aca$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $fa83f33601782aca$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $fa83f33601782aca$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $fa83f33601782aca$export$a9c23c6ac3fc3eca; });

var $fV3WI = parcelRequire("fV3WI");

var $kMyao = parcelRequire("kMyao");

var $j5tUA = parcelRequire("j5tUA");

var $KeUL6 = parcelRequire("KeUL6");

var $3OTkt = parcelRequire("3OTkt");

var $lbaR7 = parcelRequire("lbaR7");

var $cNCY5 = parcelRequire("cNCY5");

var $6THgH = parcelRequire("6THgH");
var $fa83f33601782aca$export$23f2a1d2818174ef = true;
var $fa83f33601782aca$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $fa83f33601782aca$var$EmotionCacheContext = /* #__PURE__ */ $fV3WI.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $kMyao.default)({
    key: "css"
}) : null);
var $fa83f33601782aca$export$e7094788287c5e9b = $fa83f33601782aca$var$EmotionCacheContext.Provider;
var $fa83f33601782aca$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $fV3WI.useContext)($fa83f33601782aca$var$EmotionCacheContext);
};
var $fa83f33601782aca$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $fV3WI.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $fV3WI.useContext)($fa83f33601782aca$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$fa83f33601782aca$export$23f2a1d2818174ef) $fa83f33601782aca$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $fV3WI.useContext)($fa83f33601782aca$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $kMyao.default)({
                key: "css"
            });
            return /*#__PURE__*/ $fV3WI.createElement($fa83f33601782aca$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $fa83f33601782aca$export$971d5caa766a69d7 = /* #__PURE__ */ $fV3WI.createContext({});
var $fa83f33601782aca$export$3b14a55fb2447963 = function useTheme() {
    return $fV3WI.useContext($fa83f33601782aca$export$971d5caa766a69d7);
};
var $fa83f33601782aca$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $j5tUA.default)({}, outerTheme, theme);
};
var $fa83f33601782aca$var$createCacheWithTheme = /* #__PURE__ */ (0, $KeUL6.default)(function(outerTheme) {
    return (0, $KeUL6.default)(function(theme) {
        return $fa83f33601782aca$var$getTheme(outerTheme, theme);
    });
});
var $fa83f33601782aca$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $fV3WI.useContext($fa83f33601782aca$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $fa83f33601782aca$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $fV3WI.createElement($fa83f33601782aca$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $fa83f33601782aca$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $fV3WI.useContext($fa83f33601782aca$export$971d5caa766a69d7);
        return /*#__PURE__*/ $fV3WI.createElement(Component, (0, $j5tUA.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $fV3WI.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $3OTkt.default)(WithTheme, Component);
}
var $fa83f33601782aca$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $fa83f33601782aca$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $fa83f33601782aca$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $fa83f33601782aca$var$getLastPart(match[1]);
    return undefined;
};
var $fa83f33601782aca$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $fa83f33601782aca$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $fa83f33601782aca$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $fa83f33601782aca$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($fa83f33601782aca$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $fa83f33601782aca$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $fa83f33601782aca$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $fa83f33601782aca$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $fa83f33601782aca$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($fa83f33601782aca$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$fa83f33601782aca$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $fa83f33601782aca$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $lbaR7.registerStyles)(cache, serialized, isStringTag);
    (0, $6THgH.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $lbaR7.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $fa83f33601782aca$var$Emotion = /* #__PURE__ */ $fa83f33601782aca$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$fa83f33601782aca$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $lbaR7.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $cNCY5.serializeStyles)(registeredStyles, undefined, $fV3WI.useContext($fa83f33601782aca$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($fa83f33601782aca$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $fa83f33601782aca$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $fV3WI.createElement($fV3WI.Fragment, null, /*#__PURE__*/ $fV3WI.createElement($fa83f33601782aca$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $fV3WI.createElement(WrappedComponent, newProps));
});
var $fa83f33601782aca$export$a9c23c6ac3fc3eca = $fa83f33601782aca$var$Emotion;

});
parcelRequire.register("kMyao", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f212cb236f8fdfb8$export$2e2bcd8739ae039; });

var $bLVZZ = parcelRequire("bLVZZ");

var $kOODn = parcelRequire("kOODn");
parcelRequire("KeUL6");
parcelRequire("6R5Uq");
var $f212cb236f8fdfb8$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $kOODn.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $kOODn.token)(character)) break;
        (0, $kOODn.next)();
    }
    return (0, $kOODn.slice)(begin, (0, $kOODn.position));
};
var $f212cb236f8fdfb8$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $kOODn.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $kOODn.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $f212cb236f8fdfb8$var$identifierWithPointTracking((0, $kOODn.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $kOODn.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $kOODn.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $kOODn.from)(character);
    }
    while (character = (0, $kOODn.next)());
    return parsed;
};
var $f212cb236f8fdfb8$var$getRules = function getRules(value, points) {
    return (0, $kOODn.dealloc)($f212cb236f8fdfb8$var$toRules((0, $kOODn.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $f212cb236f8fdfb8$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $f212cb236f8fdfb8$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$f212cb236f8fdfb8$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $f212cb236f8fdfb8$var$fixedElements.set(element, true);
    var points = [];
    var rules = $f212cb236f8fdfb8$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $f212cb236f8fdfb8$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $f212cb236f8fdfb8$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $f212cb236f8fdfb8$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($f212cb236f8fdfb8$var$ignoreFlag) > -1;
};
var $f212cb236f8fdfb8$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($f212cb236f8fdfb8$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $f212cb236f8fdfb8$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $f212cb236f8fdfb8$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$f212cb236f8fdfb8$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $f212cb236f8fdfb8$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $f212cb236f8fdfb8$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$f212cb236f8fdfb8$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $f212cb236f8fdfb8$var$nullifyElement(element);
    } else if ($f212cb236f8fdfb8$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $f212cb236f8fdfb8$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $f212cb236f8fdfb8$var$prefix(value, length) {
    switch((0, $kOODn.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $kOODn.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $kOODn.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $kOODn.WEBKIT) + value + (0, $kOODn.MOZ) + value + (0, $kOODn.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $kOODn.WEBKIT) + value + (0, $kOODn.MS) + value + value;
        // order
        case 6165:
            return (0, $kOODn.WEBKIT) + value + (0, $kOODn.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $kOODn.WEBKIT) + value + (0, $kOODn.replace)(value, /(\w+).+(:[^]+)/, (0, $kOODn.WEBKIT) + "box-$1$2" + (0, $kOODn.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $kOODn.WEBKIT) + value + (0, $kOODn.MS) + "flex-item-" + (0, $kOODn.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $kOODn.WEBKIT) + value + (0, $kOODn.MS) + "flex-line-pack" + (0, $kOODn.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $kOODn.WEBKIT) + value + (0, $kOODn.MS) + (0, $kOODn.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $kOODn.WEBKIT) + value + (0, $kOODn.MS) + (0, $kOODn.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $kOODn.WEBKIT) + "box-" + (0, $kOODn.replace)(value, "-grow", "") + (0, $kOODn.WEBKIT) + value + (0, $kOODn.MS) + (0, $kOODn.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $kOODn.WEBKIT) + (0, $kOODn.replace)(value, /([^-])(transform)/g, "$1" + (0, $kOODn.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $kOODn.replace)((0, $kOODn.replace)((0, $kOODn.replace)(value, /(zoom-|grab)/, (0, $kOODn.WEBKIT) + "$1"), /(image-set)/, (0, $kOODn.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $kOODn.replace)(value, /(image-set\([^]*)/, (0, $kOODn.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $kOODn.replace)((0, $kOODn.replace)(value, /(.+:)(flex-)?(.*)/, (0, $kOODn.WEBKIT) + "box-pack:$3" + (0, $kOODn.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $kOODn.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $kOODn.replace)(value, /(.+)-inline(.+)/, (0, $kOODn.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $kOODn.strlen)(value) - 1 - length > 6) switch((0, $kOODn.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $kOODn.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $kOODn.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $kOODn.WEBKIT) + "$2-$3" + "$1" + (0, $kOODn.MOZ) + ((0, $kOODn.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $kOODn.indexof)(value, "stretch") ? $f212cb236f8fdfb8$var$prefix((0, $kOODn.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $kOODn.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $kOODn.charat)(value, (0, $kOODn.strlen)(value) - 3 - (~(0, $kOODn.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $kOODn.replace)(value, ":", ":" + (0, $kOODn.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $kOODn.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $kOODn.WEBKIT) + ((0, $kOODn.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $kOODn.WEBKIT) + "$2$3" + "$1" + (0, $kOODn.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $kOODn.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $kOODn.WEBKIT) + value + (0, $kOODn.MS) + (0, $kOODn.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $kOODn.WEBKIT) + value + (0, $kOODn.MS) + (0, $kOODn.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $kOODn.WEBKIT) + value + (0, $kOODn.MS) + (0, $kOODn.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $kOODn.WEBKIT) + value + (0, $kOODn.MS) + value + value;
    }
    return value;
}
var $f212cb236f8fdfb8$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $kOODn.DECLARATION:
                element["return"] = $f212cb236f8fdfb8$var$prefix(element.value, element.length);
                break;
            case 0, $kOODn.KEYFRAMES:
                return (0, $kOODn.serialize)([
                    (0, $kOODn.copy)(element, {
                        value: (0, $kOODn.replace)(element.value, "@", "@" + (0, $kOODn.WEBKIT))
                    })
                ], callback);
            case 0, $kOODn.RULESET:
                if (element.length) return (0, $kOODn.combine)(element.props, function(value) {
                    switch((0, $kOODn.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $kOODn.serialize)([
                                (0, $kOODn.copy)(element, {
                                    props: [
                                        (0, $kOODn.replace)(value, /:(read-\w+)/, ":" + (0, $kOODn.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $kOODn.serialize)([
                                (0, $kOODn.copy)(element, {
                                    props: [
                                        (0, $kOODn.replace)(value, /:(plac\w+)/, ":" + (0, $kOODn.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $kOODn.copy)(element, {
                                    props: [
                                        (0, $kOODn.replace)(value, /:(plac\w+)/, ":" + (0, $kOODn.MOZ) + "$1")
                                    ]
                                }),
                                (0, $kOODn.copy)(element, {
                                    props: [
                                        (0, $kOODn.replace)(value, /:(plac\w+)/, (0, $kOODn.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $f212cb236f8fdfb8$var$defaultStylisPlugins = [
    $f212cb236f8fdfb8$var$prefixer
];
var $f212cb236f8fdfb8$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $f212cb236f8fdfb8$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $f212cb236f8fdfb8$var$compat,
        $f212cb236f8fdfb8$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $kOODn.stringify),
        (0, $kOODn.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $kOODn.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $kOODn.serialize)((0, $kOODn.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $bLVZZ.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRequire.register("bLVZZ", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $892112db82ea073f$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $892112db82ea073f$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $892112db82ea073f$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $892112db82ea073f$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($892112db82ea073f$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $892112db82ea073f$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRequire.register("kOODn", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $92c791839dc1485e$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $92c791839dc1485e$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $92c791839dc1485e$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $92c791839dc1485e$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $92c791839dc1485e$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $92c791839dc1485e$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $92c791839dc1485e$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $92c791839dc1485e$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $92c791839dc1485e$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $92c791839dc1485e$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $92c791839dc1485e$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $92c791839dc1485e$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $92c791839dc1485e$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $92c791839dc1485e$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $92c791839dc1485e$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $92c791839dc1485e$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $92c791839dc1485e$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $92c791839dc1485e$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $92c791839dc1485e$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $92c791839dc1485e$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $92c791839dc1485e$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $92c791839dc1485e$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $92c791839dc1485e$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $92c791839dc1485e$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $92c791839dc1485e$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $92c791839dc1485e$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $92c791839dc1485e$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $92c791839dc1485e$export$38bcb760f1d4871c; });
var $92c791839dc1485e$export$71ad59f2e432cfe8 = "-ms-";
var $92c791839dc1485e$export$2c0f367103c8d01c = "-moz-";
var $92c791839dc1485e$export$39dfd62a25e0fe93 = "-webkit-";
var $92c791839dc1485e$export$a29989082612d0d9 = "comm";
var $92c791839dc1485e$export$aa3a2e812ca8570d = "rule";
var $92c791839dc1485e$export$527d108ccf083c2b = "decl";
var $92c791839dc1485e$export$d3d35020fa5b54f0 = "@page";
var $92c791839dc1485e$export$500415a86c544f73 = "@media";
var $92c791839dc1485e$export$a763edbf796b780a = "@import";
var $92c791839dc1485e$export$2790aeb8b4e5c826 = "@charset";
var $92c791839dc1485e$export$1cc683e23b84b133 = "@viewport";
var $92c791839dc1485e$export$9447a5efea57e862 = "@supports";
var $92c791839dc1485e$export$ef011b4e114b1fba = "@document";
var $92c791839dc1485e$export$6aad947bda0f3f46 = "@namespace";
var $92c791839dc1485e$export$b44a8529a35fcb60 = "@keyframes";
var $92c791839dc1485e$export$2c16de31893252e6 = "@font-face";
var $92c791839dc1485e$export$3d846dd52e150c6f = "@counter-style";
var $92c791839dc1485e$export$22314bfbb57653fe = "@font-feature-values";
var $92c791839dc1485e$export$d773506282b3cfe6 = "@layer";
var $92c791839dc1485e$export$2335f513bbd82c6d = Math.abs;
var $92c791839dc1485e$export$6788812c4e6611e6 = String.fromCharCode;
var $92c791839dc1485e$export$e6e34fd1f2686227 = Object.assign;
function $92c791839dc1485e$export$d6af199866bfb566(e, r) {
    return $92c791839dc1485e$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $92c791839dc1485e$export$a9db5e087081082d(e, 0)) << 2 ^ $92c791839dc1485e$export$a9db5e087081082d(e, 1)) << 2 ^ $92c791839dc1485e$export$a9db5e087081082d(e, 2)) << 2 ^ $92c791839dc1485e$export$a9db5e087081082d(e, 3) : 0;
}
function $92c791839dc1485e$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $92c791839dc1485e$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $92c791839dc1485e$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $92c791839dc1485e$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $92c791839dc1485e$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $92c791839dc1485e$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $92c791839dc1485e$export$36776f635604f274(e) {
    return e.length;
}
function $92c791839dc1485e$export$f9084667e487ed46(e) {
    return e.length;
}
function $92c791839dc1485e$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $92c791839dc1485e$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $92c791839dc1485e$export$53f1d5ea8de3d7c = 1;
var $92c791839dc1485e$export$4e0c71f277ca26b3 = 1;
var $92c791839dc1485e$export$f24224f1c91d8156 = 0;
var $92c791839dc1485e$export$5880b8b5730aff45 = 0;
var $92c791839dc1485e$export$c0306caf338ac095 = 0;
var $92c791839dc1485e$export$30a86d91af8ff6e6 = "";
function $92c791839dc1485e$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $92c791839dc1485e$export$53f1d5ea8de3d7c,
        column: $92c791839dc1485e$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $92c791839dc1485e$export$784d13d8ee351f07(e, r) {
    return $92c791839dc1485e$export$e6e34fd1f2686227($92c791839dc1485e$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $92c791839dc1485e$export$eba6f6f03b0a92e7() {
    return $92c791839dc1485e$export$c0306caf338ac095;
}
function $92c791839dc1485e$export$232faf9add678146() {
    $92c791839dc1485e$export$c0306caf338ac095 = $92c791839dc1485e$export$5880b8b5730aff45 > 0 ? $92c791839dc1485e$export$a9db5e087081082d($92c791839dc1485e$export$30a86d91af8ff6e6, --$92c791839dc1485e$export$5880b8b5730aff45) : 0;
    if ($92c791839dc1485e$export$4e0c71f277ca26b3--, $92c791839dc1485e$export$c0306caf338ac095 === 10) $92c791839dc1485e$export$4e0c71f277ca26b3 = 1, $92c791839dc1485e$export$53f1d5ea8de3d7c--;
    return $92c791839dc1485e$export$c0306caf338ac095;
}
function $92c791839dc1485e$export$48cfd1e771a65c4f() {
    $92c791839dc1485e$export$c0306caf338ac095 = $92c791839dc1485e$export$5880b8b5730aff45 < $92c791839dc1485e$export$f24224f1c91d8156 ? $92c791839dc1485e$export$a9db5e087081082d($92c791839dc1485e$export$30a86d91af8ff6e6, $92c791839dc1485e$export$5880b8b5730aff45++) : 0;
    if ($92c791839dc1485e$export$4e0c71f277ca26b3++, $92c791839dc1485e$export$c0306caf338ac095 === 10) $92c791839dc1485e$export$4e0c71f277ca26b3 = 1, $92c791839dc1485e$export$53f1d5ea8de3d7c++;
    return $92c791839dc1485e$export$c0306caf338ac095;
}
function $92c791839dc1485e$export$4d3fb11e950abb9e() {
    return $92c791839dc1485e$export$a9db5e087081082d($92c791839dc1485e$export$30a86d91af8ff6e6, $92c791839dc1485e$export$5880b8b5730aff45);
}
function $92c791839dc1485e$export$e88cb2efb12ae807() {
    return $92c791839dc1485e$export$5880b8b5730aff45;
}
function $92c791839dc1485e$export$58adb3bec8346d0f(e, r) {
    return $92c791839dc1485e$export$2f35ab04d2335697($92c791839dc1485e$export$30a86d91af8ff6e6, e, r);
}
function $92c791839dc1485e$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $92c791839dc1485e$export$2de70f21292aac9e(e) {
    return $92c791839dc1485e$export$53f1d5ea8de3d7c = $92c791839dc1485e$export$4e0c71f277ca26b3 = 1, $92c791839dc1485e$export$f24224f1c91d8156 = $92c791839dc1485e$export$36776f635604f274($92c791839dc1485e$export$30a86d91af8ff6e6 = e), $92c791839dc1485e$export$5880b8b5730aff45 = 0, [];
}
function $92c791839dc1485e$export$45918ac1574455b1(e) {
    return $92c791839dc1485e$export$30a86d91af8ff6e6 = "", e;
}
function $92c791839dc1485e$export$410ac95b9ec204b8(e) {
    return $92c791839dc1485e$export$87c2784dc9fc4ab($92c791839dc1485e$export$58adb3bec8346d0f($92c791839dc1485e$export$5880b8b5730aff45 - 1, $92c791839dc1485e$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $92c791839dc1485e$export$660b2ee2d4fb4eff(e) {
    return $92c791839dc1485e$export$45918ac1574455b1($92c791839dc1485e$export$5f8c09e3ae6f64e1($92c791839dc1485e$export$2de70f21292aac9e(e)));
}
function $92c791839dc1485e$export$7af1228ff777d175(e) {
    while($92c791839dc1485e$export$c0306caf338ac095 = $92c791839dc1485e$export$4d3fb11e950abb9e())if ($92c791839dc1485e$export$c0306caf338ac095 < 33) $92c791839dc1485e$export$48cfd1e771a65c4f();
    else break;
    return $92c791839dc1485e$export$9e1725a4cfeada27(e) > 2 || $92c791839dc1485e$export$9e1725a4cfeada27($92c791839dc1485e$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $92c791839dc1485e$export$5f8c09e3ae6f64e1(e) {
    while($92c791839dc1485e$export$48cfd1e771a65c4f())switch($92c791839dc1485e$export$9e1725a4cfeada27($92c791839dc1485e$export$c0306caf338ac095)){
        case 0:
            $92c791839dc1485e$export$10d8903dec122b9d($92c791839dc1485e$export$c2ab62c7bf24634($92c791839dc1485e$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $92c791839dc1485e$export$10d8903dec122b9d($92c791839dc1485e$export$410ac95b9ec204b8($92c791839dc1485e$export$c0306caf338ac095), e);
            break;
        default:
            $92c791839dc1485e$export$10d8903dec122b9d($92c791839dc1485e$export$6788812c4e6611e6($92c791839dc1485e$export$c0306caf338ac095), e);
    }
    return e;
}
function $92c791839dc1485e$export$955ba06d119e085e(e, r) {
    while(--r && $92c791839dc1485e$export$48cfd1e771a65c4f())if ($92c791839dc1485e$export$c0306caf338ac095 < 48 || $92c791839dc1485e$export$c0306caf338ac095 > 102 || $92c791839dc1485e$export$c0306caf338ac095 > 57 && $92c791839dc1485e$export$c0306caf338ac095 < 65 || $92c791839dc1485e$export$c0306caf338ac095 > 70 && $92c791839dc1485e$export$c0306caf338ac095 < 97) break;
    return $92c791839dc1485e$export$58adb3bec8346d0f(e, $92c791839dc1485e$export$e88cb2efb12ae807() + (r < 6 && $92c791839dc1485e$export$4d3fb11e950abb9e() == 32 && $92c791839dc1485e$export$48cfd1e771a65c4f() == 32));
}
function $92c791839dc1485e$export$c889f2fcc19dbf12(e) {
    while($92c791839dc1485e$export$48cfd1e771a65c4f())switch($92c791839dc1485e$export$c0306caf338ac095){
        case e:
            return $92c791839dc1485e$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $92c791839dc1485e$export$c889f2fcc19dbf12($92c791839dc1485e$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $92c791839dc1485e$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $92c791839dc1485e$export$48cfd1e771a65c4f();
            break;
    }
    return $92c791839dc1485e$export$5880b8b5730aff45;
}
function $92c791839dc1485e$export$4254d4e2b3745c4c(e, r) {
    while($92c791839dc1485e$export$48cfd1e771a65c4f())if (e + $92c791839dc1485e$export$c0306caf338ac095 === 57) break;
    else if (e + $92c791839dc1485e$export$c0306caf338ac095 === 84 && $92c791839dc1485e$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $92c791839dc1485e$export$58adb3bec8346d0f(r, $92c791839dc1485e$export$5880b8b5730aff45 - 1) + "*" + $92c791839dc1485e$export$6788812c4e6611e6(e === 47 ? e : $92c791839dc1485e$export$48cfd1e771a65c4f());
}
function $92c791839dc1485e$export$c2ab62c7bf24634(e) {
    while(!$92c791839dc1485e$export$9e1725a4cfeada27($92c791839dc1485e$export$4d3fb11e950abb9e()))$92c791839dc1485e$export$48cfd1e771a65c4f();
    return $92c791839dc1485e$export$58adb3bec8346d0f(e, $92c791839dc1485e$export$5880b8b5730aff45);
}
function $92c791839dc1485e$export$ef7acd7185315e22(e) {
    return $92c791839dc1485e$export$45918ac1574455b1($92c791839dc1485e$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $92c791839dc1485e$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $92c791839dc1485e$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $92c791839dc1485e$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $92c791839dc1485e$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($92c791839dc1485e$export$f8e21b1e77979a08(j += $92c791839dc1485e$export$77ad94ebf1c2b9ed($92c791839dc1485e$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $92c791839dc1485e$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $92c791839dc1485e$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $92c791839dc1485e$export$955ba06d119e085e($92c791839dc1485e$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($92c791839dc1485e$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $92c791839dc1485e$export$10d8903dec122b9d($92c791839dc1485e$export$4a34f930e789283c($92c791839dc1485e$export$4254d4e2b3745c4c($92c791839dc1485e$export$48cfd1e771a65c4f(), $92c791839dc1485e$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $92c791839dc1485e$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $92c791839dc1485e$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $92c791839dc1485e$export$36776f635604f274(j) - l) $92c791839dc1485e$export$10d8903dec122b9d(p > 32 ? $92c791839dc1485e$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $92c791839dc1485e$export$f8483753829ec8f3($92c791839dc1485e$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $92c791839dc1485e$export$10d8903dec122b9d(y = $92c791839dc1485e$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $92c791839dc1485e$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $92c791839dc1485e$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $92c791839dc1485e$export$98e6a39c04603d36(e, y, y, n && $92c791839dc1485e$export$10d8903dec122b9d($92c791839dc1485e$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $92c791839dc1485e$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $92c791839dc1485e$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $92c791839dc1485e$export$232faf9add678146() == 125) continue;
            }
            switch(j += $92c791839dc1485e$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($92c791839dc1485e$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($92c791839dc1485e$export$4d3fb11e950abb9e() === 45) j += $92c791839dc1485e$export$410ac95b9ec204b8($92c791839dc1485e$export$48cfd1e771a65c4f());
                    v = $92c791839dc1485e$export$4d3fb11e950abb9e(), o = l = $92c791839dc1485e$export$36776f635604f274(g = j += $92c791839dc1485e$export$c2ab62c7bf24634($92c791839dc1485e$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $92c791839dc1485e$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $92c791839dc1485e$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $92c791839dc1485e$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $92c791839dc1485e$export$2f35ab04d2335697(e, v + 1, v = $92c791839dc1485e$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $92c791839dc1485e$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $92c791839dc1485e$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $92c791839dc1485e$export$35059013cd4a06db(e, r, a, s === 0 ? $92c791839dc1485e$export$aa3a2e812ca8570d : i, f, o, l);
}
function $92c791839dc1485e$export$4a34f930e789283c(e, r, a) {
    return $92c791839dc1485e$export$35059013cd4a06db(e, r, a, $92c791839dc1485e$export$a29989082612d0d9, $92c791839dc1485e$export$6788812c4e6611e6($92c791839dc1485e$export$eba6f6f03b0a92e7()), $92c791839dc1485e$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $92c791839dc1485e$export$f8483753829ec8f3(e, r, a, n) {
    return $92c791839dc1485e$export$35059013cd4a06db(e, r, a, $92c791839dc1485e$export$527d108ccf083c2b, $92c791839dc1485e$export$2f35ab04d2335697(e, 0, n), $92c791839dc1485e$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $92c791839dc1485e$export$82e9f45cca5ba907(n, c, s) {
    switch($92c791839dc1485e$export$d6af199866bfb566(n, c)){
        case 5103:
            return $92c791839dc1485e$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $92c791839dc1485e$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $92c791839dc1485e$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $92c791839dc1485e$export$39dfd62a25e0fe93 + n + $92c791839dc1485e$export$2c0f367103c8d01c + n + $92c791839dc1485e$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($92c791839dc1485e$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $92c791839dc1485e$export$39dfd62a25e0fe93 + n + $92c791839dc1485e$export$71ad59f2e432cfe8 + $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $92c791839dc1485e$export$39dfd62a25e0fe93 + n + $92c791839dc1485e$export$71ad59f2e432cfe8 + $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $92c791839dc1485e$export$39dfd62a25e0fe93 + n + $92c791839dc1485e$export$71ad59f2e432cfe8 + $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $92c791839dc1485e$export$39dfd62a25e0fe93 + n + $92c791839dc1485e$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $92c791839dc1485e$export$39dfd62a25e0fe93 + n + $92c791839dc1485e$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $92c791839dc1485e$export$39dfd62a25e0fe93 + n + $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $92c791839dc1485e$export$39dfd62a25e0fe93 + "box-$1$2" + $92c791839dc1485e$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $92c791839dc1485e$export$39dfd62a25e0fe93 + n + $92c791839dc1485e$export$71ad59f2e432cfe8 + "flex-item-" + $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$92c791839dc1485e$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $92c791839dc1485e$export$71ad59f2e432cfe8 + "grid-row-" + $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $92c791839dc1485e$export$39dfd62a25e0fe93 + n + $92c791839dc1485e$export$71ad59f2e432cfe8 + "flex-line-pack" + $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $92c791839dc1485e$export$39dfd62a25e0fe93 + n + $92c791839dc1485e$export$71ad59f2e432cfe8 + $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $92c791839dc1485e$export$39dfd62a25e0fe93 + n + $92c791839dc1485e$export$71ad59f2e432cfe8 + $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $92c791839dc1485e$export$39dfd62a25e0fe93 + "box-" + $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, "-grow", "") + $92c791839dc1485e$export$39dfd62a25e0fe93 + n + $92c791839dc1485e$export$71ad59f2e432cfe8 + $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $92c791839dc1485e$export$39dfd62a25e0fe93 + $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $92c791839dc1485e$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $92c791839dc1485e$export$77ad94ebf1c2b9ed($92c791839dc1485e$export$77ad94ebf1c2b9ed($92c791839dc1485e$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $92c791839dc1485e$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $92c791839dc1485e$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $92c791839dc1485e$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $92c791839dc1485e$export$77ad94ebf1c2b9ed($92c791839dc1485e$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $92c791839dc1485e$export$39dfd62a25e0fe93 + "box-pack:$3" + $92c791839dc1485e$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $92c791839dc1485e$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$92c791839dc1485e$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $92c791839dc1485e$export$71ad59f2e432cfe8 + "grid-column-align" + $92c791839dc1485e$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $92c791839dc1485e$export$71ad59f2e432cfe8 + $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $92c791839dc1485e$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$92c791839dc1485e$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $92c791839dc1485e$export$71ad59f2e432cfe8 + $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $92c791839dc1485e$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$92c791839dc1485e$export$f8e21b1e77979a08(s, "span") ? $92c791839dc1485e$export$4659b591c19bdf3d(s, /\d+/) : +$92c791839dc1485e$export$4659b591c19bdf3d(s, /\d+/) - +$92c791839dc1485e$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $92c791839dc1485e$export$71ad59f2e432cfe8 + $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $92c791839dc1485e$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $92c791839dc1485e$export$71ad59f2e432cfe8 + $92c791839dc1485e$export$77ad94ebf1c2b9ed($92c791839dc1485e$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $92c791839dc1485e$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($92c791839dc1485e$export$36776f635604f274(n) - 1 - c > 6) switch($92c791839dc1485e$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($92c791839dc1485e$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $92c791839dc1485e$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $92c791839dc1485e$export$2c0f367103c8d01c + ($92c791839dc1485e$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$92c791839dc1485e$export$f8e21b1e77979a08(n, "stretch") ? $92c791839dc1485e$export$82e9f45cca5ba907($92c791839dc1485e$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $92c791839dc1485e$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $92c791839dc1485e$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($92c791839dc1485e$export$a9db5e087081082d(n, c + 6) === 121) return $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, ":", ":" + $92c791839dc1485e$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($92c791839dc1485e$export$a9db5e087081082d(n, $92c791839dc1485e$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $92c791839dc1485e$export$39dfd62a25e0fe93 + ($92c791839dc1485e$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $92c791839dc1485e$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $92c791839dc1485e$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, ":", ":" + $92c791839dc1485e$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $92c791839dc1485e$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $92c791839dc1485e$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $92c791839dc1485e$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $92c791839dc1485e$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $92c791839dc1485e$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $92c791839dc1485e$export$a763edbf796b780a:
        case $92c791839dc1485e$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $92c791839dc1485e$export$a29989082612d0d9:
            return "";
        case $92c791839dc1485e$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $92c791839dc1485e$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $92c791839dc1485e$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $92c791839dc1485e$export$36776f635604f274(a = $92c791839dc1485e$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $92c791839dc1485e$export$5a7767152ae0305f(e) {
    var r = $92c791839dc1485e$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $92c791839dc1485e$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $92c791839dc1485e$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $92c791839dc1485e$export$527d108ccf083c2b:
                n.return = $92c791839dc1485e$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $92c791839dc1485e$export$b44a8529a35fcb60:
                return $92c791839dc1485e$export$dfdc1655ccc5b9cb([
                    $92c791839dc1485e$export$784d13d8ee351f07(n, {
                        value: $92c791839dc1485e$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $92c791839dc1485e$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $92c791839dc1485e$export$aa3a2e812ca8570d:
                if (n.length) return $92c791839dc1485e$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($92c791839dc1485e$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $92c791839dc1485e$export$dfdc1655ccc5b9cb([
                                $92c791839dc1485e$export$784d13d8ee351f07(n, {
                                    props: [
                                        $92c791839dc1485e$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $92c791839dc1485e$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $92c791839dc1485e$export$dfdc1655ccc5b9cb([
                                $92c791839dc1485e$export$784d13d8ee351f07(n, {
                                    props: [
                                        $92c791839dc1485e$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $92c791839dc1485e$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $92c791839dc1485e$export$784d13d8ee351f07(n, {
                                    props: [
                                        $92c791839dc1485e$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $92c791839dc1485e$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $92c791839dc1485e$export$784d13d8ee351f07(n, {
                                    props: [
                                        $92c791839dc1485e$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $92c791839dc1485e$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $92c791839dc1485e$export$76a88f7de6507443(e) {
    switch(e.type){
        case $92c791839dc1485e$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $92c791839dc1485e$export$1be1fc439b849fdf($92c791839dc1485e$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($92c791839dc1485e$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $92c791839dc1485e$export$2f35ab04d2335697(r, 1, $92c791839dc1485e$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $92c791839dc1485e$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $92c791839dc1485e$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $92c791839dc1485e$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRequire.register("KeUL6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08afddb1c147cb94$export$2e2bcd8739ae039; });
var $08afddb1c147cb94$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRequire.register("6R5Uq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fdc46bc5b2e97cf$export$2e2bcd8739ae039; });
function $4fdc46bc5b2e97cf$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRequire.register("j5tUA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de55afccd79f67be$export$2e2bcd8739ae039; });
function $de55afccd79f67be$export$2e2bcd8739ae039() {
    $de55afccd79f67be$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $de55afccd79f67be$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRequire.register("3OTkt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c80f5dd59f35bef$export$2e2bcd8739ae039; });

var $OTT3m = parcelRequire("OTT3m");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $2c80f5dd59f35bef$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($OTT3m)))(targetComponent, sourceComponent);
};

});
parcelRequire.register("OTT3m", function(module, exports) {
"use strict";

var $jSLUN = parcelRequire("jSLUN");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $0990059c78432d97$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $0990059c78432d97$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $0990059c78432d97$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $0990059c78432d97$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $0990059c78432d97$var$TYPE_STATICS = {};
$0990059c78432d97$var$TYPE_STATICS[$jSLUN.ForwardRef] = $0990059c78432d97$var$FORWARD_REF_STATICS;
$0990059c78432d97$var$TYPE_STATICS[$jSLUN.Memo] = $0990059c78432d97$var$MEMO_STATICS;
function $0990059c78432d97$var$getStatics(component) {
    // React v16.11 and below
    if ($jSLUN.isMemo(component)) return $0990059c78432d97$var$MEMO_STATICS;
     // React v16.12 and above
    return $0990059c78432d97$var$TYPE_STATICS[component["$$typeof"]] || $0990059c78432d97$var$REACT_STATICS;
}
var $0990059c78432d97$var$defineProperty = Object.defineProperty;
var $0990059c78432d97$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $0990059c78432d97$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $0990059c78432d97$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $0990059c78432d97$var$getPrototypeOf = Object.getPrototypeOf;
var $0990059c78432d97$var$objectPrototype = Object.prototype;
function $0990059c78432d97$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($0990059c78432d97$var$objectPrototype) {
            var inheritedComponent = $0990059c78432d97$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $0990059c78432d97$var$objectPrototype) $0990059c78432d97$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $0990059c78432d97$var$getOwnPropertyNames(sourceComponent);
        if ($0990059c78432d97$var$getOwnPropertySymbols) keys = keys.concat($0990059c78432d97$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $0990059c78432d97$var$getStatics(targetComponent);
        var sourceStatics = $0990059c78432d97$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$0990059c78432d97$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $0990059c78432d97$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $0990059c78432d97$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $0990059c78432d97$var$hoistNonReactStatics;

});
parcelRequire.register("jSLUN", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6JzZt"));

});
parcelRequire.register("6JzZt", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $4e72dd010dcb6e94$export$2b8d127b894957b9; }, function (v) { return $4e72dd010dcb6e94$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $4e72dd010dcb6e94$export$cea3a54a6425200c; }, function (v) { return $4e72dd010dcb6e94$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $4e72dd010dcb6e94$export$a7c73072b1a182ae; }, function (v) { return $4e72dd010dcb6e94$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $4e72dd010dcb6e94$export$9f27bc3417b4524d; }, function (v) { return $4e72dd010dcb6e94$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $4e72dd010dcb6e94$export$db77ccec0bb4ccac; }, function (v) { return $4e72dd010dcb6e94$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $4e72dd010dcb6e94$export$8392c0c9d3dcbd35; }, function (v) { return $4e72dd010dcb6e94$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $4e72dd010dcb6e94$export$ffb0004e005737fa; }, function (v) { return $4e72dd010dcb6e94$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $4e72dd010dcb6e94$export$b624eff549462981; }, function (v) { return $4e72dd010dcb6e94$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $4e72dd010dcb6e94$export$7897aa7841a5380c; }, function (v) { return $4e72dd010dcb6e94$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $4e72dd010dcb6e94$export$602eac185826482c; }, function (v) { return $4e72dd010dcb6e94$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $4e72dd010dcb6e94$export$e2c29f18771995cb; }, function (v) { return $4e72dd010dcb6e94$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $4e72dd010dcb6e94$export$5f8d39834fd61797; }, function (v) { return $4e72dd010dcb6e94$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $4e72dd010dcb6e94$export$74bf444e3cd11ea5; }, function (v) { return $4e72dd010dcb6e94$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $4e72dd010dcb6e94$export$92387174baf9b227; }, function (v) { return $4e72dd010dcb6e94$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $4e72dd010dcb6e94$export$ec112efeb987d9c6; }, function (v) { return $4e72dd010dcb6e94$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $4e72dd010dcb6e94$export$b706b080d889d2c9; }, function (v) { return $4e72dd010dcb6e94$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $4e72dd010dcb6e94$export$5be5a87408f70ddc; }, function (v) { return $4e72dd010dcb6e94$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $4e72dd010dcb6e94$export$45a5e7f76e0caa8d; }, function (v) { return $4e72dd010dcb6e94$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $4e72dd010dcb6e94$export$455c2e768291efa6; }, function (v) { return $4e72dd010dcb6e94$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $4e72dd010dcb6e94$export$9522e17588c12572; }, function (v) { return $4e72dd010dcb6e94$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $4e72dd010dcb6e94$export$2110ac352bb060b9; }, function (v) { return $4e72dd010dcb6e94$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $4e72dd010dcb6e94$export$56885ab8b9c456ab; }, function (v) { return $4e72dd010dcb6e94$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $4e72dd010dcb6e94$export$d927fcb6adf8f9de; }, function (v) { return $4e72dd010dcb6e94$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $4e72dd010dcb6e94$export$b82d16f27459e05a; }, function (v) { return $4e72dd010dcb6e94$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $4e72dd010dcb6e94$export$522c17b4f5e123e8; }, function (v) { return $4e72dd010dcb6e94$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $4e72dd010dcb6e94$export$1aabd8a0274ecfd6; }, function (v) { return $4e72dd010dcb6e94$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $4e72dd010dcb6e94$export$9b621391a187a31a; }, function (v) { return $4e72dd010dcb6e94$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $4e72dd010dcb6e94$export$f5bbd400c2f4426f; }, function (v) { return $4e72dd010dcb6e94$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4e72dd010dcb6e94$export$2b8d127b894957b9;
var $4e72dd010dcb6e94$export$cea3a54a6425200c;
var $4e72dd010dcb6e94$export$a7c73072b1a182ae;
var $4e72dd010dcb6e94$export$9f27bc3417b4524d;
var $4e72dd010dcb6e94$export$db77ccec0bb4ccac;
var $4e72dd010dcb6e94$export$8392c0c9d3dcbd35;
var $4e72dd010dcb6e94$export$ffb0004e005737fa;
var $4e72dd010dcb6e94$export$b624eff549462981;
var $4e72dd010dcb6e94$export$7897aa7841a5380c;
var $4e72dd010dcb6e94$export$602eac185826482c;
var $4e72dd010dcb6e94$export$e2c29f18771995cb;
var $4e72dd010dcb6e94$export$5f8d39834fd61797;
var $4e72dd010dcb6e94$export$74bf444e3cd11ea5;
var $4e72dd010dcb6e94$export$92387174baf9b227;
var $4e72dd010dcb6e94$export$ec112efeb987d9c6;
var $4e72dd010dcb6e94$export$b706b080d889d2c9;
var $4e72dd010dcb6e94$export$5be5a87408f70ddc;
var $4e72dd010dcb6e94$export$45a5e7f76e0caa8d;
var $4e72dd010dcb6e94$export$455c2e768291efa6;
var $4e72dd010dcb6e94$export$9522e17588c12572;
var $4e72dd010dcb6e94$export$2110ac352bb060b9;
var $4e72dd010dcb6e94$export$56885ab8b9c456ab;
var $4e72dd010dcb6e94$export$d927fcb6adf8f9de;
var $4e72dd010dcb6e94$export$b82d16f27459e05a;
var $4e72dd010dcb6e94$export$522c17b4f5e123e8;
var $4e72dd010dcb6e94$export$1aabd8a0274ecfd6;
var $4e72dd010dcb6e94$export$9b621391a187a31a;
var $4e72dd010dcb6e94$export$f5bbd400c2f4426f;
"use strict";
var $4e72dd010dcb6e94$var$b = "function" === typeof Symbol && Symbol.for, $4e72dd010dcb6e94$var$c = $4e72dd010dcb6e94$var$b ? Symbol.for("react.element") : 60103, $4e72dd010dcb6e94$var$d = $4e72dd010dcb6e94$var$b ? Symbol.for("react.portal") : 60106, $4e72dd010dcb6e94$var$e = $4e72dd010dcb6e94$var$b ? Symbol.for("react.fragment") : 60107, $4e72dd010dcb6e94$var$f = $4e72dd010dcb6e94$var$b ? Symbol.for("react.strict_mode") : 60108, $4e72dd010dcb6e94$var$g = $4e72dd010dcb6e94$var$b ? Symbol.for("react.profiler") : 60114, $4e72dd010dcb6e94$var$h = $4e72dd010dcb6e94$var$b ? Symbol.for("react.provider") : 60109, $4e72dd010dcb6e94$var$k = $4e72dd010dcb6e94$var$b ? Symbol.for("react.context") : 60110, $4e72dd010dcb6e94$var$l = $4e72dd010dcb6e94$var$b ? Symbol.for("react.async_mode") : 60111, $4e72dd010dcb6e94$var$m = $4e72dd010dcb6e94$var$b ? Symbol.for("react.concurrent_mode") : 60111, $4e72dd010dcb6e94$var$n = $4e72dd010dcb6e94$var$b ? Symbol.for("react.forward_ref") : 60112, $4e72dd010dcb6e94$var$p = $4e72dd010dcb6e94$var$b ? Symbol.for("react.suspense") : 60113, $4e72dd010dcb6e94$var$q = $4e72dd010dcb6e94$var$b ? Symbol.for("react.suspense_list") : 60120, $4e72dd010dcb6e94$var$r = $4e72dd010dcb6e94$var$b ? Symbol.for("react.memo") : 60115, $4e72dd010dcb6e94$var$t = $4e72dd010dcb6e94$var$b ? Symbol.for("react.lazy") : 60116, $4e72dd010dcb6e94$var$v = $4e72dd010dcb6e94$var$b ? Symbol.for("react.block") : 60121, $4e72dd010dcb6e94$var$w = $4e72dd010dcb6e94$var$b ? Symbol.for("react.fundamental") : 60117, $4e72dd010dcb6e94$var$x = $4e72dd010dcb6e94$var$b ? Symbol.for("react.responder") : 60118, $4e72dd010dcb6e94$var$y = $4e72dd010dcb6e94$var$b ? Symbol.for("react.scope") : 60119;
function $4e72dd010dcb6e94$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $4e72dd010dcb6e94$var$c:
                switch(a = a.type, a){
                    case $4e72dd010dcb6e94$var$l:
                    case $4e72dd010dcb6e94$var$m:
                    case $4e72dd010dcb6e94$var$e:
                    case $4e72dd010dcb6e94$var$g:
                    case $4e72dd010dcb6e94$var$f:
                    case $4e72dd010dcb6e94$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $4e72dd010dcb6e94$var$k:
                            case $4e72dd010dcb6e94$var$n:
                            case $4e72dd010dcb6e94$var$t:
                            case $4e72dd010dcb6e94$var$r:
                            case $4e72dd010dcb6e94$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $4e72dd010dcb6e94$var$d:
                return u;
        }
    }
}
function $4e72dd010dcb6e94$var$A(a) {
    return $4e72dd010dcb6e94$var$z(a) === $4e72dd010dcb6e94$var$m;
}
$4e72dd010dcb6e94$export$2b8d127b894957b9 = $4e72dd010dcb6e94$var$l;
$4e72dd010dcb6e94$export$cea3a54a6425200c = $4e72dd010dcb6e94$var$m;
$4e72dd010dcb6e94$export$a7c73072b1a182ae = $4e72dd010dcb6e94$var$k;
$4e72dd010dcb6e94$export$9f27bc3417b4524d = $4e72dd010dcb6e94$var$h;
$4e72dd010dcb6e94$export$db77ccec0bb4ccac = $4e72dd010dcb6e94$var$c;
$4e72dd010dcb6e94$export$8392c0c9d3dcbd35 = $4e72dd010dcb6e94$var$n;
$4e72dd010dcb6e94$export$ffb0004e005737fa = $4e72dd010dcb6e94$var$e;
$4e72dd010dcb6e94$export$b624eff549462981 = $4e72dd010dcb6e94$var$t;
$4e72dd010dcb6e94$export$7897aa7841a5380c = $4e72dd010dcb6e94$var$r;
$4e72dd010dcb6e94$export$602eac185826482c = $4e72dd010dcb6e94$var$d;
$4e72dd010dcb6e94$export$e2c29f18771995cb = $4e72dd010dcb6e94$var$g;
$4e72dd010dcb6e94$export$5f8d39834fd61797 = $4e72dd010dcb6e94$var$f;
$4e72dd010dcb6e94$export$74bf444e3cd11ea5 = $4e72dd010dcb6e94$var$p;
$4e72dd010dcb6e94$export$92387174baf9b227 = function(a) {
    return $4e72dd010dcb6e94$var$A(a) || $4e72dd010dcb6e94$var$z(a) === $4e72dd010dcb6e94$var$l;
};
$4e72dd010dcb6e94$export$ec112efeb987d9c6 = $4e72dd010dcb6e94$var$A;
$4e72dd010dcb6e94$export$b706b080d889d2c9 = function(a) {
    return $4e72dd010dcb6e94$var$z(a) === $4e72dd010dcb6e94$var$k;
};
$4e72dd010dcb6e94$export$5be5a87408f70ddc = function(a) {
    return $4e72dd010dcb6e94$var$z(a) === $4e72dd010dcb6e94$var$h;
};
$4e72dd010dcb6e94$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $4e72dd010dcb6e94$var$c;
};
$4e72dd010dcb6e94$export$455c2e768291efa6 = function(a) {
    return $4e72dd010dcb6e94$var$z(a) === $4e72dd010dcb6e94$var$n;
};
$4e72dd010dcb6e94$export$9522e17588c12572 = function(a) {
    return $4e72dd010dcb6e94$var$z(a) === $4e72dd010dcb6e94$var$e;
};
$4e72dd010dcb6e94$export$2110ac352bb060b9 = function(a) {
    return $4e72dd010dcb6e94$var$z(a) === $4e72dd010dcb6e94$var$t;
};
$4e72dd010dcb6e94$export$56885ab8b9c456ab = function(a) {
    return $4e72dd010dcb6e94$var$z(a) === $4e72dd010dcb6e94$var$r;
};
$4e72dd010dcb6e94$export$d927fcb6adf8f9de = function(a) {
    return $4e72dd010dcb6e94$var$z(a) === $4e72dd010dcb6e94$var$d;
};
$4e72dd010dcb6e94$export$b82d16f27459e05a = function(a) {
    return $4e72dd010dcb6e94$var$z(a) === $4e72dd010dcb6e94$var$g;
};
$4e72dd010dcb6e94$export$522c17b4f5e123e8 = function(a) {
    return $4e72dd010dcb6e94$var$z(a) === $4e72dd010dcb6e94$var$f;
};
$4e72dd010dcb6e94$export$1aabd8a0274ecfd6 = function(a) {
    return $4e72dd010dcb6e94$var$z(a) === $4e72dd010dcb6e94$var$p;
};
$4e72dd010dcb6e94$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $4e72dd010dcb6e94$var$e || a === $4e72dd010dcb6e94$var$m || a === $4e72dd010dcb6e94$var$g || a === $4e72dd010dcb6e94$var$f || a === $4e72dd010dcb6e94$var$p || a === $4e72dd010dcb6e94$var$q || "object" === typeof a && null !== a && (a.$$typeof === $4e72dd010dcb6e94$var$t || a.$$typeof === $4e72dd010dcb6e94$var$r || a.$$typeof === $4e72dd010dcb6e94$var$h || a.$$typeof === $4e72dd010dcb6e94$var$k || a.$$typeof === $4e72dd010dcb6e94$var$n || a.$$typeof === $4e72dd010dcb6e94$var$w || a.$$typeof === $4e72dd010dcb6e94$var$x || a.$$typeof === $4e72dd010dcb6e94$var$y || a.$$typeof === $4e72dd010dcb6e94$var$v);
};
$4e72dd010dcb6e94$export$f5bbd400c2f4426f = $4e72dd010dcb6e94$var$z;

});




parcelRequire.register("lbaR7", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $f6b30bc311e424ed$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $f6b30bc311e424ed$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $f6b30bc311e424ed$export$6f077d94b33a01aa; });
var $f6b30bc311e424ed$var$isBrowser = true;
function $f6b30bc311e424ed$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $f6b30bc311e424ed$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $f6b30bc311e424ed$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $f6b30bc311e424ed$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $f6b30bc311e424ed$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRequire.register("cNCY5", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $951849ea0fed34cd$export$6321afa313b251b5; });

var $43IDQ = parcelRequire("43IDQ");

var $9hxet = parcelRequire("9hxet");

var $6R5Uq = parcelRequire("6R5Uq");
var $951849ea0fed34cd$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $951849ea0fed34cd$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $951849ea0fed34cd$var$hyphenateRegex = /[A-Z]|^ms/g;
var $951849ea0fed34cd$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $951849ea0fed34cd$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $951849ea0fed34cd$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $951849ea0fed34cd$var$processStyleName = /* #__PURE__ */ (0, $6R5Uq.default)(function(styleName) {
    return $951849ea0fed34cd$var$isCustomProperty(styleName) ? styleName : styleName.replace($951849ea0fed34cd$var$hyphenateRegex, "-$&").toLowerCase();
});
var $951849ea0fed34cd$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($951849ea0fed34cd$var$animationRegex, function(match, p1, p2) {
                $951849ea0fed34cd$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $951849ea0fed34cd$var$cursor
                };
                return p1;
            });
    }
    if ((0, $9hxet.default)[key] !== 1 && !$951849ea0fed34cd$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $951849ea0fed34cd$var$contentValuePattern, $951849ea0fed34cd$var$contentValues, $951849ea0fed34cd$var$oldProcessStyleValue, $951849ea0fed34cd$var$msPattern, $951849ea0fed34cd$var$hyphenPattern, $951849ea0fed34cd$var$hyphenatedCache;
var $951849ea0fed34cd$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $951849ea0fed34cd$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $951849ea0fed34cd$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $951849ea0fed34cd$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $951849ea0fed34cd$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $951849ea0fed34cd$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $951849ea0fed34cd$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $951849ea0fed34cd$var$cursor;
                var result = interpolation(mergedProps);
                $951849ea0fed34cd$var$cursor = previousCursor;
                return $951849ea0fed34cd$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $951849ea0fed34cd$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $951849ea0fed34cd$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($951849ea0fed34cd$var$isProcessableValue(value)) string += $951849ea0fed34cd$var$processStyleName(_key) + ":" + $951849ea0fed34cd$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($951849ea0fed34cd$var$isProcessableValue(value[_i])) string += $951849ea0fed34cd$var$processStyleName(_key) + ":" + $951849ea0fed34cd$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $951849ea0fed34cd$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $951849ea0fed34cd$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $951849ea0fed34cd$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $951849ea0fed34cd$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $951849ea0fed34cd$var$cursor;
var $951849ea0fed34cd$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $951849ea0fed34cd$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $951849ea0fed34cd$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $951849ea0fed34cd$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $951849ea0fed34cd$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $951849ea0fed34cd$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $43IDQ.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $951849ea0fed34cd$var$cursor
    };
};

});
parcelRequire.register("43IDQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f4a12253be48018$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $2f4a12253be48018$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRequire.register("9hxet", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c1f7adbba0dfd7b$export$2e2bcd8739ae039; });
var $6c1f7adbba0dfd7b$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRequire.register("6THgH", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $5059714c8468f8b8$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $5059714c8468f8b8$export$811a713a7276cb9d; });

var $fV3WI = parcelRequire("fV3WI");
var $5059714c8468f8b8$var$syncFallback = function syncFallback(create) {
    return create();
};
var $5059714c8468f8b8$var$useInsertionEffect = $fV3WI.useInsertionEffect ? $fV3WI.useInsertionEffect : false;
var $5059714c8468f8b8$export$db21c7ffa21794e7 = $5059714c8468f8b8$var$useInsertionEffect || $5059714c8468f8b8$var$syncFallback;
var $5059714c8468f8b8$export$811a713a7276cb9d = $5059714c8468f8b8$var$useInsertionEffect || $fV3WI.useLayoutEffect;

});


parcelRequire.register("b0Oht", function(module, exports) {
function $8046b28accc6c82c$var$_extends() {
    module.exports = $8046b28accc6c82c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $8046b28accc6c82c$var$_extends.apply(this, arguments);
}
module.exports = $8046b28accc6c82c$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("1eN5H", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $0e6d2da9c09dac01$export$ae55be85d98224ed; }, function (v) { return $0e6d2da9c09dac01$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $0e6d2da9c09dac01$export$d39a5bbd09211389; }, function (v) { return $0e6d2da9c09dac01$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $0e6d2da9c09dac01$export$882461b6382ed46c; }, function (v) { return $0e6d2da9c09dac01$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $0e6d2da9c09dac01$export$466bfc07425424d5; }, function (v) { return $0e6d2da9c09dac01$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $0e6d2da9c09dac01$export$cd75ccfd720a3cd4; }, function (v) { return $0e6d2da9c09dac01$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $0e6d2da9c09dac01$export$fa8d919ba61d84db; }, function (v) { return $0e6d2da9c09dac01$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $0e6d2da9c09dac01$export$757ceba2d55c277e; }, function (v) { return $0e6d2da9c09dac01$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $0e6d2da9c09dac01$export$b3890eb0ae9dca99; }, function (v) { return $0e6d2da9c09dac01$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $0e6d2da9c09dac01$export$502457920280e6be; }, function (v) { return $0e6d2da9c09dac01$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $0e6d2da9c09dac01$export$c78a37762a8d58e1; }, function (v) { return $0e6d2da9c09dac01$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $0e6d2da9c09dac01$export$dc54d992c10e8a18; }, function (v) { return $0e6d2da9c09dac01$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $0e6d2da9c09dac01$export$83d89fbfd8236492; }, function (v) { return $0e6d2da9c09dac01$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0e6d2da9c09dac01$export$ae55be85d98224ed;
var $0e6d2da9c09dac01$export$d39a5bbd09211389;
var $0e6d2da9c09dac01$export$882461b6382ed46c;
var $0e6d2da9c09dac01$export$466bfc07425424d5;
var $0e6d2da9c09dac01$export$cd75ccfd720a3cd4;
var $0e6d2da9c09dac01$export$fa8d919ba61d84db;
var $0e6d2da9c09dac01$export$757ceba2d55c277e;
var $0e6d2da9c09dac01$export$b3890eb0ae9dca99;
var $0e6d2da9c09dac01$export$502457920280e6be;
var $0e6d2da9c09dac01$export$c78a37762a8d58e1;
var $0e6d2da9c09dac01$export$dc54d992c10e8a18;
var $0e6d2da9c09dac01$export$83d89fbfd8236492;
"use strict";

var $fV3WI = parcelRequire("fV3WI");

var $8nAnF = parcelRequire("8nAnF");
function $0e6d2da9c09dac01$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0e6d2da9c09dac01$var$da = new Set, $0e6d2da9c09dac01$var$ea = {};
function $0e6d2da9c09dac01$var$fa(a, b) {
    $0e6d2da9c09dac01$var$ha(a, b);
    $0e6d2da9c09dac01$var$ha(a + "Capture", b);
}
function $0e6d2da9c09dac01$var$ha(a, b) {
    $0e6d2da9c09dac01$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0e6d2da9c09dac01$var$da.add(b[a]);
}
var $0e6d2da9c09dac01$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0e6d2da9c09dac01$var$ja = Object.prototype.hasOwnProperty, $0e6d2da9c09dac01$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0e6d2da9c09dac01$var$la = {}, $0e6d2da9c09dac01$var$ma = {};
function $0e6d2da9c09dac01$var$oa(a) {
    if ($0e6d2da9c09dac01$var$ja.call($0e6d2da9c09dac01$var$ma, a)) return !0;
    if ($0e6d2da9c09dac01$var$ja.call($0e6d2da9c09dac01$var$la, a)) return !1;
    if ($0e6d2da9c09dac01$var$ka.test(a)) return $0e6d2da9c09dac01$var$ma[a] = !0;
    $0e6d2da9c09dac01$var$la[a] = !0;
    return !1;
}
function $0e6d2da9c09dac01$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0e6d2da9c09dac01$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0e6d2da9c09dac01$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0e6d2da9c09dac01$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0e6d2da9c09dac01$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0e6d2da9c09dac01$var$z[a] = new $0e6d2da9c09dac01$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0e6d2da9c09dac01$var$z[b] = new $0e6d2da9c09dac01$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0e6d2da9c09dac01$var$z[a] = new $0e6d2da9c09dac01$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0e6d2da9c09dac01$var$z[a] = new $0e6d2da9c09dac01$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0e6d2da9c09dac01$var$z[a] = new $0e6d2da9c09dac01$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0e6d2da9c09dac01$var$z[a] = new $0e6d2da9c09dac01$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0e6d2da9c09dac01$var$z[a] = new $0e6d2da9c09dac01$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0e6d2da9c09dac01$var$z[a] = new $0e6d2da9c09dac01$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0e6d2da9c09dac01$var$z[a] = new $0e6d2da9c09dac01$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0e6d2da9c09dac01$var$ra = /[\-:]([a-z])/g;
function $0e6d2da9c09dac01$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0e6d2da9c09dac01$var$ra, $0e6d2da9c09dac01$var$sa);
    $0e6d2da9c09dac01$var$z[b] = new $0e6d2da9c09dac01$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0e6d2da9c09dac01$var$ra, $0e6d2da9c09dac01$var$sa);
    $0e6d2da9c09dac01$var$z[b] = new $0e6d2da9c09dac01$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0e6d2da9c09dac01$var$ra, $0e6d2da9c09dac01$var$sa);
    $0e6d2da9c09dac01$var$z[b] = new $0e6d2da9c09dac01$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0e6d2da9c09dac01$var$z[a] = new $0e6d2da9c09dac01$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0e6d2da9c09dac01$var$z.xlinkHref = new $0e6d2da9c09dac01$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0e6d2da9c09dac01$var$z[a] = new $0e6d2da9c09dac01$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0e6d2da9c09dac01$var$ta(a, b, c, d) {
    var e = $0e6d2da9c09dac01$var$z.hasOwnProperty(b) ? $0e6d2da9c09dac01$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0e6d2da9c09dac01$var$qa(b, c, e, d) && (c = null), d || null === e ? $0e6d2da9c09dac01$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0e6d2da9c09dac01$var$ua = $fV3WI.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0e6d2da9c09dac01$var$va = Symbol.for("react.element"), $0e6d2da9c09dac01$var$wa = Symbol.for("react.portal"), $0e6d2da9c09dac01$var$ya = Symbol.for("react.fragment"), $0e6d2da9c09dac01$var$za = Symbol.for("react.strict_mode"), $0e6d2da9c09dac01$var$Aa = Symbol.for("react.profiler"), $0e6d2da9c09dac01$var$Ba = Symbol.for("react.provider"), $0e6d2da9c09dac01$var$Ca = Symbol.for("react.context"), $0e6d2da9c09dac01$var$Da = Symbol.for("react.forward_ref"), $0e6d2da9c09dac01$var$Ea = Symbol.for("react.suspense"), $0e6d2da9c09dac01$var$Fa = Symbol.for("react.suspense_list"), $0e6d2da9c09dac01$var$Ga = Symbol.for("react.memo"), $0e6d2da9c09dac01$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0e6d2da9c09dac01$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0e6d2da9c09dac01$var$Ja = Symbol.iterator;
function $0e6d2da9c09dac01$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0e6d2da9c09dac01$var$Ja && a[$0e6d2da9c09dac01$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0e6d2da9c09dac01$var$A = Object.assign, $0e6d2da9c09dac01$var$La;
function $0e6d2da9c09dac01$var$Ma(a) {
    if (void 0 === $0e6d2da9c09dac01$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0e6d2da9c09dac01$var$La = b && b[1] || "";
    }
    return "\n" + $0e6d2da9c09dac01$var$La + a;
}
var $0e6d2da9c09dac01$var$Na = !1;
function $0e6d2da9c09dac01$var$Oa(a, b) {
    if (!a || $0e6d2da9c09dac01$var$Na) return "";
    $0e6d2da9c09dac01$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0e6d2da9c09dac01$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0e6d2da9c09dac01$var$Ma(a) : "";
}
function $0e6d2da9c09dac01$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0e6d2da9c09dac01$var$Ma(a.type);
        case 16:
            return $0e6d2da9c09dac01$var$Ma("Lazy");
        case 13:
            return $0e6d2da9c09dac01$var$Ma("Suspense");
        case 19:
            return $0e6d2da9c09dac01$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0e6d2da9c09dac01$var$Oa(a.type, !1), a;
        case 11:
            return a = $0e6d2da9c09dac01$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0e6d2da9c09dac01$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0e6d2da9c09dac01$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0e6d2da9c09dac01$var$ya:
            return "Fragment";
        case $0e6d2da9c09dac01$var$wa:
            return "Portal";
        case $0e6d2da9c09dac01$var$Aa:
            return "Profiler";
        case $0e6d2da9c09dac01$var$za:
            return "StrictMode";
        case $0e6d2da9c09dac01$var$Ea:
            return "Suspense";
        case $0e6d2da9c09dac01$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0e6d2da9c09dac01$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0e6d2da9c09dac01$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0e6d2da9c09dac01$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0e6d2da9c09dac01$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0e6d2da9c09dac01$var$Qa(a.type) || "Memo";
        case $0e6d2da9c09dac01$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0e6d2da9c09dac01$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0e6d2da9c09dac01$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0e6d2da9c09dac01$var$Qa(b);
        case 8:
            return b === $0e6d2da9c09dac01$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0e6d2da9c09dac01$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0e6d2da9c09dac01$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0e6d2da9c09dac01$var$Ua(a) {
    var b = $0e6d2da9c09dac01$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0e6d2da9c09dac01$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0e6d2da9c09dac01$var$Ua(a));
}
function $0e6d2da9c09dac01$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0e6d2da9c09dac01$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0e6d2da9c09dac01$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0e6d2da9c09dac01$var$Ya(a, b) {
    var c = b.checked;
    return $0e6d2da9c09dac01$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0e6d2da9c09dac01$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0e6d2da9c09dac01$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0e6d2da9c09dac01$var$ab(a, b) {
    b = b.checked;
    null != b && $0e6d2da9c09dac01$var$ta(a, "checked", b, !1);
}
function $0e6d2da9c09dac01$var$bb(a, b) {
    $0e6d2da9c09dac01$var$ab(a, b);
    var c = $0e6d2da9c09dac01$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0e6d2da9c09dac01$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0e6d2da9c09dac01$var$cb(a, b.type, $0e6d2da9c09dac01$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0e6d2da9c09dac01$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0e6d2da9c09dac01$var$cb(a, b, c) {
    if ("number" !== b || $0e6d2da9c09dac01$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0e6d2da9c09dac01$var$eb = Array.isArray;
function $0e6d2da9c09dac01$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0e6d2da9c09dac01$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0e6d2da9c09dac01$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0e6d2da9c09dac01$var$p(91));
    return $0e6d2da9c09dac01$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0e6d2da9c09dac01$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0e6d2da9c09dac01$var$p(92));
            if ($0e6d2da9c09dac01$var$eb(c)) {
                if (1 < c.length) throw Error($0e6d2da9c09dac01$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0e6d2da9c09dac01$var$Sa(c)
    };
}
function $0e6d2da9c09dac01$var$ib(a, b) {
    var c = $0e6d2da9c09dac01$var$Sa(b.value), d = $0e6d2da9c09dac01$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0e6d2da9c09dac01$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0e6d2da9c09dac01$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0e6d2da9c09dac01$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0e6d2da9c09dac01$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0e6d2da9c09dac01$var$mb, $0e6d2da9c09dac01$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0e6d2da9c09dac01$var$mb = $0e6d2da9c09dac01$var$mb || document.createElement("div");
        $0e6d2da9c09dac01$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0e6d2da9c09dac01$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0e6d2da9c09dac01$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0e6d2da9c09dac01$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0e6d2da9c09dac01$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0e6d2da9c09dac01$var$pb).forEach(function(a) {
    $0e6d2da9c09dac01$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0e6d2da9c09dac01$var$pb[b] = $0e6d2da9c09dac01$var$pb[a];
    });
});
function $0e6d2da9c09dac01$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0e6d2da9c09dac01$var$pb.hasOwnProperty(a) && $0e6d2da9c09dac01$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0e6d2da9c09dac01$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0e6d2da9c09dac01$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0e6d2da9c09dac01$var$tb = $0e6d2da9c09dac01$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0e6d2da9c09dac01$var$ub(a, b) {
    if (b) {
        if ($0e6d2da9c09dac01$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0e6d2da9c09dac01$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0e6d2da9c09dac01$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0e6d2da9c09dac01$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0e6d2da9c09dac01$var$p(62));
    }
}
function $0e6d2da9c09dac01$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0e6d2da9c09dac01$var$wb = null;
function $0e6d2da9c09dac01$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0e6d2da9c09dac01$var$yb = null, $0e6d2da9c09dac01$var$zb = null, $0e6d2da9c09dac01$var$Ab = null;
function $0e6d2da9c09dac01$var$Bb(a) {
    if (a = $0e6d2da9c09dac01$var$Cb(a)) {
        if ("function" !== typeof $0e6d2da9c09dac01$var$yb) throw Error($0e6d2da9c09dac01$var$p(280));
        var b = a.stateNode;
        b && (b = $0e6d2da9c09dac01$var$Db(b), $0e6d2da9c09dac01$var$yb(a.stateNode, a.type, b));
    }
}
function $0e6d2da9c09dac01$var$Eb(a) {
    $0e6d2da9c09dac01$var$zb ? $0e6d2da9c09dac01$var$Ab ? $0e6d2da9c09dac01$var$Ab.push(a) : $0e6d2da9c09dac01$var$Ab = [
        a
    ] : $0e6d2da9c09dac01$var$zb = a;
}
function $0e6d2da9c09dac01$var$Fb() {
    if ($0e6d2da9c09dac01$var$zb) {
        var a = $0e6d2da9c09dac01$var$zb, b = $0e6d2da9c09dac01$var$Ab;
        $0e6d2da9c09dac01$var$Ab = $0e6d2da9c09dac01$var$zb = null;
        $0e6d2da9c09dac01$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0e6d2da9c09dac01$var$Bb(b[a]);
    }
}
function $0e6d2da9c09dac01$var$Gb(a, b) {
    return a(b);
}
function $0e6d2da9c09dac01$var$Hb() {}
var $0e6d2da9c09dac01$var$Ib = !1;
function $0e6d2da9c09dac01$var$Jb(a, b, c) {
    if ($0e6d2da9c09dac01$var$Ib) return a(b, c);
    $0e6d2da9c09dac01$var$Ib = !0;
    try {
        return $0e6d2da9c09dac01$var$Gb(a, b, c);
    } finally{
        if ($0e6d2da9c09dac01$var$Ib = !1, null !== $0e6d2da9c09dac01$var$zb || null !== $0e6d2da9c09dac01$var$Ab) $0e6d2da9c09dac01$var$Hb(), $0e6d2da9c09dac01$var$Fb();
    }
}
function $0e6d2da9c09dac01$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0e6d2da9c09dac01$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0e6d2da9c09dac01$var$p(231, b, typeof c));
    return c;
}
var $0e6d2da9c09dac01$var$Lb = !1;
if ($0e6d2da9c09dac01$var$ia) try {
    var $0e6d2da9c09dac01$var$Mb = {};
    Object.defineProperty($0e6d2da9c09dac01$var$Mb, "passive", {
        get: function() {
            $0e6d2da9c09dac01$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0e6d2da9c09dac01$var$Mb, $0e6d2da9c09dac01$var$Mb);
    window.removeEventListener("test", $0e6d2da9c09dac01$var$Mb, $0e6d2da9c09dac01$var$Mb);
} catch (a) {
    $0e6d2da9c09dac01$var$Lb = !1;
}
function $0e6d2da9c09dac01$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0e6d2da9c09dac01$var$Ob = !1, $0e6d2da9c09dac01$var$Pb = null, $0e6d2da9c09dac01$var$Qb = !1, $0e6d2da9c09dac01$var$Rb = null, $0e6d2da9c09dac01$var$Sb = {
    onError: function(a) {
        $0e6d2da9c09dac01$var$Ob = !0;
        $0e6d2da9c09dac01$var$Pb = a;
    }
};
function $0e6d2da9c09dac01$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0e6d2da9c09dac01$var$Ob = !1;
    $0e6d2da9c09dac01$var$Pb = null;
    $0e6d2da9c09dac01$var$Nb.apply($0e6d2da9c09dac01$var$Sb, arguments);
}
function $0e6d2da9c09dac01$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0e6d2da9c09dac01$var$Tb.apply(this, arguments);
    if ($0e6d2da9c09dac01$var$Ob) {
        if ($0e6d2da9c09dac01$var$Ob) {
            var l = $0e6d2da9c09dac01$var$Pb;
            $0e6d2da9c09dac01$var$Ob = !1;
            $0e6d2da9c09dac01$var$Pb = null;
        } else throw Error($0e6d2da9c09dac01$var$p(198));
        $0e6d2da9c09dac01$var$Qb || ($0e6d2da9c09dac01$var$Qb = !0, $0e6d2da9c09dac01$var$Rb = l);
    }
}
function $0e6d2da9c09dac01$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0e6d2da9c09dac01$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0e6d2da9c09dac01$var$Xb(a) {
    if ($0e6d2da9c09dac01$var$Vb(a) !== a) throw Error($0e6d2da9c09dac01$var$p(188));
}
function $0e6d2da9c09dac01$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0e6d2da9c09dac01$var$Vb(a);
        if (null === b) throw Error($0e6d2da9c09dac01$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0e6d2da9c09dac01$var$Xb(e), a;
                if (f === d) return $0e6d2da9c09dac01$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0e6d2da9c09dac01$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0e6d2da9c09dac01$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0e6d2da9c09dac01$var$p(190));
    }
    if (3 !== c.tag) throw Error($0e6d2da9c09dac01$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0e6d2da9c09dac01$var$Zb(a) {
    a = $0e6d2da9c09dac01$var$Yb(a);
    return null !== a ? $0e6d2da9c09dac01$var$$b(a) : null;
}
function $0e6d2da9c09dac01$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0e6d2da9c09dac01$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0e6d2da9c09dac01$var$ac = $8nAnF.unstable_scheduleCallback, $0e6d2da9c09dac01$var$bc = $8nAnF.unstable_cancelCallback, $0e6d2da9c09dac01$var$cc = $8nAnF.unstable_shouldYield, $0e6d2da9c09dac01$var$dc = $8nAnF.unstable_requestPaint, $0e6d2da9c09dac01$var$B = $8nAnF.unstable_now, $0e6d2da9c09dac01$var$ec = $8nAnF.unstable_getCurrentPriorityLevel, $0e6d2da9c09dac01$var$fc = $8nAnF.unstable_ImmediatePriority, $0e6d2da9c09dac01$var$gc = $8nAnF.unstable_UserBlockingPriority, $0e6d2da9c09dac01$var$hc = $8nAnF.unstable_NormalPriority, $0e6d2da9c09dac01$var$ic = $8nAnF.unstable_LowPriority, $0e6d2da9c09dac01$var$jc = $8nAnF.unstable_IdlePriority, $0e6d2da9c09dac01$var$kc = null, $0e6d2da9c09dac01$var$lc = null;
function $0e6d2da9c09dac01$var$mc(a) {
    if ($0e6d2da9c09dac01$var$lc && "function" === typeof $0e6d2da9c09dac01$var$lc.onCommitFiberRoot) try {
        $0e6d2da9c09dac01$var$lc.onCommitFiberRoot($0e6d2da9c09dac01$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0e6d2da9c09dac01$var$oc = Math.clz32 ? Math.clz32 : $0e6d2da9c09dac01$var$nc, $0e6d2da9c09dac01$var$pc = Math.log, $0e6d2da9c09dac01$var$qc = Math.LN2;
function $0e6d2da9c09dac01$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0e6d2da9c09dac01$var$pc(a) / $0e6d2da9c09dac01$var$qc | 0) | 0;
}
var $0e6d2da9c09dac01$var$rc = 64, $0e6d2da9c09dac01$var$sc = 4194304;
function $0e6d2da9c09dac01$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0e6d2da9c09dac01$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0e6d2da9c09dac01$var$tc(h) : (f &= g, 0 !== f && (d = $0e6d2da9c09dac01$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0e6d2da9c09dac01$var$tc(g) : 0 !== f && (d = $0e6d2da9c09dac01$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0e6d2da9c09dac01$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0e6d2da9c09dac01$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0e6d2da9c09dac01$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0e6d2da9c09dac01$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0e6d2da9c09dac01$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0e6d2da9c09dac01$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0e6d2da9c09dac01$var$yc() {
    var a = $0e6d2da9c09dac01$var$rc;
    $0e6d2da9c09dac01$var$rc <<= 1;
    0 === ($0e6d2da9c09dac01$var$rc & 4194240) && ($0e6d2da9c09dac01$var$rc = 64);
    return a;
}
function $0e6d2da9c09dac01$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0e6d2da9c09dac01$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0e6d2da9c09dac01$var$oc(b);
    a[b] = c;
}
function $0e6d2da9c09dac01$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0e6d2da9c09dac01$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0e6d2da9c09dac01$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0e6d2da9c09dac01$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0e6d2da9c09dac01$var$C = 0;
function $0e6d2da9c09dac01$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0e6d2da9c09dac01$var$Ec, $0e6d2da9c09dac01$var$Fc, $0e6d2da9c09dac01$var$Gc, $0e6d2da9c09dac01$var$Hc, $0e6d2da9c09dac01$var$Ic, $0e6d2da9c09dac01$var$Jc = !1, $0e6d2da9c09dac01$var$Kc = [], $0e6d2da9c09dac01$var$Lc = null, $0e6d2da9c09dac01$var$Mc = null, $0e6d2da9c09dac01$var$Nc = null, $0e6d2da9c09dac01$var$Oc = new Map, $0e6d2da9c09dac01$var$Pc = new Map, $0e6d2da9c09dac01$var$Qc = [], $0e6d2da9c09dac01$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0e6d2da9c09dac01$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0e6d2da9c09dac01$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0e6d2da9c09dac01$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0e6d2da9c09dac01$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0e6d2da9c09dac01$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0e6d2da9c09dac01$var$Pc.delete(b.pointerId);
    }
}
function $0e6d2da9c09dac01$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0e6d2da9c09dac01$var$Cb(b), null !== b && $0e6d2da9c09dac01$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0e6d2da9c09dac01$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0e6d2da9c09dac01$var$Lc = $0e6d2da9c09dac01$var$Tc($0e6d2da9c09dac01$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0e6d2da9c09dac01$var$Mc = $0e6d2da9c09dac01$var$Tc($0e6d2da9c09dac01$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0e6d2da9c09dac01$var$Nc = $0e6d2da9c09dac01$var$Tc($0e6d2da9c09dac01$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0e6d2da9c09dac01$var$Oc.set(f, $0e6d2da9c09dac01$var$Tc($0e6d2da9c09dac01$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0e6d2da9c09dac01$var$Pc.set(f, $0e6d2da9c09dac01$var$Tc($0e6d2da9c09dac01$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0e6d2da9c09dac01$var$Vc(a) {
    var b = $0e6d2da9c09dac01$var$Wc(a.target);
    if (null !== b) {
        var c = $0e6d2da9c09dac01$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0e6d2da9c09dac01$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0e6d2da9c09dac01$var$Ic(a.priority, function() {
                        $0e6d2da9c09dac01$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0e6d2da9c09dac01$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0e6d2da9c09dac01$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0e6d2da9c09dac01$var$wb = d;
            c.target.dispatchEvent(d);
            $0e6d2da9c09dac01$var$wb = null;
        } else return b = $0e6d2da9c09dac01$var$Cb(c), null !== b && $0e6d2da9c09dac01$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0e6d2da9c09dac01$var$Zc(a, b, c) {
    $0e6d2da9c09dac01$var$Xc(a) && c.delete(b);
}
function $0e6d2da9c09dac01$var$$c() {
    $0e6d2da9c09dac01$var$Jc = !1;
    null !== $0e6d2da9c09dac01$var$Lc && $0e6d2da9c09dac01$var$Xc($0e6d2da9c09dac01$var$Lc) && ($0e6d2da9c09dac01$var$Lc = null);
    null !== $0e6d2da9c09dac01$var$Mc && $0e6d2da9c09dac01$var$Xc($0e6d2da9c09dac01$var$Mc) && ($0e6d2da9c09dac01$var$Mc = null);
    null !== $0e6d2da9c09dac01$var$Nc && $0e6d2da9c09dac01$var$Xc($0e6d2da9c09dac01$var$Nc) && ($0e6d2da9c09dac01$var$Nc = null);
    $0e6d2da9c09dac01$var$Oc.forEach($0e6d2da9c09dac01$var$Zc);
    $0e6d2da9c09dac01$var$Pc.forEach($0e6d2da9c09dac01$var$Zc);
}
function $0e6d2da9c09dac01$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0e6d2da9c09dac01$var$Jc || ($0e6d2da9c09dac01$var$Jc = !0, $8nAnF.unstable_scheduleCallback($8nAnF.unstable_NormalPriority, $0e6d2da9c09dac01$var$$c)));
}
function $0e6d2da9c09dac01$var$bd(a) {
    function b(b) {
        return $0e6d2da9c09dac01$var$ad(b, a);
    }
    if (0 < $0e6d2da9c09dac01$var$Kc.length) {
        $0e6d2da9c09dac01$var$ad($0e6d2da9c09dac01$var$Kc[0], a);
        for(var c = 1; c < $0e6d2da9c09dac01$var$Kc.length; c++){
            var d = $0e6d2da9c09dac01$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0e6d2da9c09dac01$var$Lc && $0e6d2da9c09dac01$var$ad($0e6d2da9c09dac01$var$Lc, a);
    null !== $0e6d2da9c09dac01$var$Mc && $0e6d2da9c09dac01$var$ad($0e6d2da9c09dac01$var$Mc, a);
    null !== $0e6d2da9c09dac01$var$Nc && $0e6d2da9c09dac01$var$ad($0e6d2da9c09dac01$var$Nc, a);
    $0e6d2da9c09dac01$var$Oc.forEach(b);
    $0e6d2da9c09dac01$var$Pc.forEach(b);
    for(c = 0; c < $0e6d2da9c09dac01$var$Qc.length; c++)d = $0e6d2da9c09dac01$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0e6d2da9c09dac01$var$Qc.length && (c = $0e6d2da9c09dac01$var$Qc[0], null === c.blockedOn);)$0e6d2da9c09dac01$var$Vc(c), null === c.blockedOn && $0e6d2da9c09dac01$var$Qc.shift();
}
var $0e6d2da9c09dac01$var$cd = $0e6d2da9c09dac01$var$ua.ReactCurrentBatchConfig, $0e6d2da9c09dac01$var$dd = !0;
function $0e6d2da9c09dac01$var$ed(a, b, c, d) {
    var e = $0e6d2da9c09dac01$var$C, f = $0e6d2da9c09dac01$var$cd.transition;
    $0e6d2da9c09dac01$var$cd.transition = null;
    try {
        $0e6d2da9c09dac01$var$C = 1, $0e6d2da9c09dac01$var$fd(a, b, c, d);
    } finally{
        $0e6d2da9c09dac01$var$C = e, $0e6d2da9c09dac01$var$cd.transition = f;
    }
}
function $0e6d2da9c09dac01$var$gd(a, b, c, d) {
    var e = $0e6d2da9c09dac01$var$C, f = $0e6d2da9c09dac01$var$cd.transition;
    $0e6d2da9c09dac01$var$cd.transition = null;
    try {
        $0e6d2da9c09dac01$var$C = 4, $0e6d2da9c09dac01$var$fd(a, b, c, d);
    } finally{
        $0e6d2da9c09dac01$var$C = e, $0e6d2da9c09dac01$var$cd.transition = f;
    }
}
function $0e6d2da9c09dac01$var$fd(a, b, c, d) {
    if ($0e6d2da9c09dac01$var$dd) {
        var e = $0e6d2da9c09dac01$var$Yc(a, b, c, d);
        if (null === e) $0e6d2da9c09dac01$var$hd(a, b, d, $0e6d2da9c09dac01$var$id, c), $0e6d2da9c09dac01$var$Sc(a, d);
        else if ($0e6d2da9c09dac01$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0e6d2da9c09dac01$var$Sc(a, d), b & 4 && -1 < $0e6d2da9c09dac01$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0e6d2da9c09dac01$var$Cb(e);
                null !== f && $0e6d2da9c09dac01$var$Ec(f);
                f = $0e6d2da9c09dac01$var$Yc(a, b, c, d);
                null === f && $0e6d2da9c09dac01$var$hd(a, b, d, $0e6d2da9c09dac01$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0e6d2da9c09dac01$var$hd(a, b, d, null, c);
    }
}
var $0e6d2da9c09dac01$var$id = null;
function $0e6d2da9c09dac01$var$Yc(a, b, c, d) {
    $0e6d2da9c09dac01$var$id = null;
    a = $0e6d2da9c09dac01$var$xb(d);
    a = $0e6d2da9c09dac01$var$Wc(a);
    if (null !== a) {
        if (b = $0e6d2da9c09dac01$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0e6d2da9c09dac01$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0e6d2da9c09dac01$var$id = a;
    return null;
}
function $0e6d2da9c09dac01$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0e6d2da9c09dac01$var$ec()){
                case $0e6d2da9c09dac01$var$fc:
                    return 1;
                case $0e6d2da9c09dac01$var$gc:
                    return 4;
                case $0e6d2da9c09dac01$var$hc:
                case $0e6d2da9c09dac01$var$ic:
                    return 16;
                case $0e6d2da9c09dac01$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0e6d2da9c09dac01$var$kd = null, $0e6d2da9c09dac01$var$ld = null, $0e6d2da9c09dac01$var$md = null;
function $0e6d2da9c09dac01$var$nd() {
    if ($0e6d2da9c09dac01$var$md) return $0e6d2da9c09dac01$var$md;
    var a, b = $0e6d2da9c09dac01$var$ld, c = b.length, d, e = "value" in $0e6d2da9c09dac01$var$kd ? $0e6d2da9c09dac01$var$kd.value : $0e6d2da9c09dac01$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0e6d2da9c09dac01$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0e6d2da9c09dac01$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0e6d2da9c09dac01$var$pd() {
    return !0;
}
function $0e6d2da9c09dac01$var$qd() {
    return !1;
}
function $0e6d2da9c09dac01$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0e6d2da9c09dac01$var$pd : $0e6d2da9c09dac01$var$qd;
        this.isPropagationStopped = $0e6d2da9c09dac01$var$qd;
        return this;
    }
    $0e6d2da9c09dac01$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0e6d2da9c09dac01$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0e6d2da9c09dac01$var$pd);
        },
        persist: function() {},
        isPersistent: $0e6d2da9c09dac01$var$pd
    });
    return b;
}
var $0e6d2da9c09dac01$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0e6d2da9c09dac01$var$td = $0e6d2da9c09dac01$var$rd($0e6d2da9c09dac01$var$sd), $0e6d2da9c09dac01$var$ud = $0e6d2da9c09dac01$var$A({}, $0e6d2da9c09dac01$var$sd, {
    view: 0,
    detail: 0
}), $0e6d2da9c09dac01$var$vd = $0e6d2da9c09dac01$var$rd($0e6d2da9c09dac01$var$ud), $0e6d2da9c09dac01$var$wd, $0e6d2da9c09dac01$var$xd, $0e6d2da9c09dac01$var$yd, $0e6d2da9c09dac01$var$Ad = $0e6d2da9c09dac01$var$A({}, $0e6d2da9c09dac01$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0e6d2da9c09dac01$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0e6d2da9c09dac01$var$yd && ($0e6d2da9c09dac01$var$yd && "mousemove" === a.type ? ($0e6d2da9c09dac01$var$wd = a.screenX - $0e6d2da9c09dac01$var$yd.screenX, $0e6d2da9c09dac01$var$xd = a.screenY - $0e6d2da9c09dac01$var$yd.screenY) : $0e6d2da9c09dac01$var$xd = $0e6d2da9c09dac01$var$wd = 0, $0e6d2da9c09dac01$var$yd = a);
        return $0e6d2da9c09dac01$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0e6d2da9c09dac01$var$xd;
    }
}), $0e6d2da9c09dac01$var$Bd = $0e6d2da9c09dac01$var$rd($0e6d2da9c09dac01$var$Ad), $0e6d2da9c09dac01$var$Cd = $0e6d2da9c09dac01$var$A({}, $0e6d2da9c09dac01$var$Ad, {
    dataTransfer: 0
}), $0e6d2da9c09dac01$var$Dd = $0e6d2da9c09dac01$var$rd($0e6d2da9c09dac01$var$Cd), $0e6d2da9c09dac01$var$Ed = $0e6d2da9c09dac01$var$A({}, $0e6d2da9c09dac01$var$ud, {
    relatedTarget: 0
}), $0e6d2da9c09dac01$var$Fd = $0e6d2da9c09dac01$var$rd($0e6d2da9c09dac01$var$Ed), $0e6d2da9c09dac01$var$Gd = $0e6d2da9c09dac01$var$A({}, $0e6d2da9c09dac01$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0e6d2da9c09dac01$var$Hd = $0e6d2da9c09dac01$var$rd($0e6d2da9c09dac01$var$Gd), $0e6d2da9c09dac01$var$Id = $0e6d2da9c09dac01$var$A({}, $0e6d2da9c09dac01$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0e6d2da9c09dac01$var$Jd = $0e6d2da9c09dac01$var$rd($0e6d2da9c09dac01$var$Id), $0e6d2da9c09dac01$var$Kd = $0e6d2da9c09dac01$var$A({}, $0e6d2da9c09dac01$var$sd, {
    data: 0
}), $0e6d2da9c09dac01$var$Ld = $0e6d2da9c09dac01$var$rd($0e6d2da9c09dac01$var$Kd), $0e6d2da9c09dac01$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0e6d2da9c09dac01$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0e6d2da9c09dac01$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0e6d2da9c09dac01$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0e6d2da9c09dac01$var$Od[a]) ? !!b[a] : !1;
}
function $0e6d2da9c09dac01$var$zd() {
    return $0e6d2da9c09dac01$var$Pd;
}
var $0e6d2da9c09dac01$var$Qd = $0e6d2da9c09dac01$var$A({}, $0e6d2da9c09dac01$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0e6d2da9c09dac01$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0e6d2da9c09dac01$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0e6d2da9c09dac01$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0e6d2da9c09dac01$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0e6d2da9c09dac01$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0e6d2da9c09dac01$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0e6d2da9c09dac01$var$Rd = $0e6d2da9c09dac01$var$rd($0e6d2da9c09dac01$var$Qd), $0e6d2da9c09dac01$var$Sd = $0e6d2da9c09dac01$var$A({}, $0e6d2da9c09dac01$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0e6d2da9c09dac01$var$Td = $0e6d2da9c09dac01$var$rd($0e6d2da9c09dac01$var$Sd), $0e6d2da9c09dac01$var$Ud = $0e6d2da9c09dac01$var$A({}, $0e6d2da9c09dac01$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0e6d2da9c09dac01$var$zd
}), $0e6d2da9c09dac01$var$Vd = $0e6d2da9c09dac01$var$rd($0e6d2da9c09dac01$var$Ud), $0e6d2da9c09dac01$var$Wd = $0e6d2da9c09dac01$var$A({}, $0e6d2da9c09dac01$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0e6d2da9c09dac01$var$Xd = $0e6d2da9c09dac01$var$rd($0e6d2da9c09dac01$var$Wd), $0e6d2da9c09dac01$var$Yd = $0e6d2da9c09dac01$var$A({}, $0e6d2da9c09dac01$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0e6d2da9c09dac01$var$Zd = $0e6d2da9c09dac01$var$rd($0e6d2da9c09dac01$var$Yd), $0e6d2da9c09dac01$var$$d = [
    9,
    13,
    27,
    32
], $0e6d2da9c09dac01$var$ae = $0e6d2da9c09dac01$var$ia && "CompositionEvent" in window, $0e6d2da9c09dac01$var$be = null;
$0e6d2da9c09dac01$var$ia && "documentMode" in document && ($0e6d2da9c09dac01$var$be = document.documentMode);
var $0e6d2da9c09dac01$var$ce = $0e6d2da9c09dac01$var$ia && "TextEvent" in window && !$0e6d2da9c09dac01$var$be, $0e6d2da9c09dac01$var$de = $0e6d2da9c09dac01$var$ia && (!$0e6d2da9c09dac01$var$ae || $0e6d2da9c09dac01$var$be && 8 < $0e6d2da9c09dac01$var$be && 11 >= $0e6d2da9c09dac01$var$be), $0e6d2da9c09dac01$var$ee = String.fromCharCode(32), $0e6d2da9c09dac01$var$fe = !1;
function $0e6d2da9c09dac01$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0e6d2da9c09dac01$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0e6d2da9c09dac01$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0e6d2da9c09dac01$var$ie = !1;
function $0e6d2da9c09dac01$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0e6d2da9c09dac01$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0e6d2da9c09dac01$var$fe = !0;
            return $0e6d2da9c09dac01$var$ee;
        case "textInput":
            return a = b.data, a === $0e6d2da9c09dac01$var$ee && $0e6d2da9c09dac01$var$fe ? null : a;
        default:
            return null;
    }
}
function $0e6d2da9c09dac01$var$ke(a, b) {
    if ($0e6d2da9c09dac01$var$ie) return "compositionend" === a || !$0e6d2da9c09dac01$var$ae && $0e6d2da9c09dac01$var$ge(a, b) ? (a = $0e6d2da9c09dac01$var$nd(), $0e6d2da9c09dac01$var$md = $0e6d2da9c09dac01$var$ld = $0e6d2da9c09dac01$var$kd = null, $0e6d2da9c09dac01$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0e6d2da9c09dac01$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0e6d2da9c09dac01$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0e6d2da9c09dac01$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0e6d2da9c09dac01$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0e6d2da9c09dac01$var$ne(a, b, c, d) {
    $0e6d2da9c09dac01$var$Eb(d);
    b = $0e6d2da9c09dac01$var$oe(b, "onChange");
    0 < b.length && (c = new $0e6d2da9c09dac01$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0e6d2da9c09dac01$var$pe = null, $0e6d2da9c09dac01$var$qe = null;
function $0e6d2da9c09dac01$var$re(a) {
    $0e6d2da9c09dac01$var$se(a, 0);
}
function $0e6d2da9c09dac01$var$te(a) {
    var b = $0e6d2da9c09dac01$var$ue(a);
    if ($0e6d2da9c09dac01$var$Wa(b)) return a;
}
function $0e6d2da9c09dac01$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0e6d2da9c09dac01$var$we = !1;
if ($0e6d2da9c09dac01$var$ia) {
    var $0e6d2da9c09dac01$var$xe;
    if ($0e6d2da9c09dac01$var$ia) {
        var $0e6d2da9c09dac01$var$ye = "oninput" in document;
        if (!$0e6d2da9c09dac01$var$ye) {
            var $0e6d2da9c09dac01$var$ze = document.createElement("div");
            $0e6d2da9c09dac01$var$ze.setAttribute("oninput", "return;");
            $0e6d2da9c09dac01$var$ye = "function" === typeof $0e6d2da9c09dac01$var$ze.oninput;
        }
        $0e6d2da9c09dac01$var$xe = $0e6d2da9c09dac01$var$ye;
    } else $0e6d2da9c09dac01$var$xe = !1;
    $0e6d2da9c09dac01$var$we = $0e6d2da9c09dac01$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0e6d2da9c09dac01$var$Ae() {
    $0e6d2da9c09dac01$var$pe && ($0e6d2da9c09dac01$var$pe.detachEvent("onpropertychange", $0e6d2da9c09dac01$var$Be), $0e6d2da9c09dac01$var$qe = $0e6d2da9c09dac01$var$pe = null);
}
function $0e6d2da9c09dac01$var$Be(a) {
    if ("value" === a.propertyName && $0e6d2da9c09dac01$var$te($0e6d2da9c09dac01$var$qe)) {
        var b = [];
        $0e6d2da9c09dac01$var$ne(b, $0e6d2da9c09dac01$var$qe, a, $0e6d2da9c09dac01$var$xb(a));
        $0e6d2da9c09dac01$var$Jb($0e6d2da9c09dac01$var$re, b);
    }
}
function $0e6d2da9c09dac01$var$Ce(a, b, c) {
    "focusin" === a ? ($0e6d2da9c09dac01$var$Ae(), $0e6d2da9c09dac01$var$pe = b, $0e6d2da9c09dac01$var$qe = c, $0e6d2da9c09dac01$var$pe.attachEvent("onpropertychange", $0e6d2da9c09dac01$var$Be)) : "focusout" === a && $0e6d2da9c09dac01$var$Ae();
}
function $0e6d2da9c09dac01$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0e6d2da9c09dac01$var$te($0e6d2da9c09dac01$var$qe);
}
function $0e6d2da9c09dac01$var$Ee(a, b) {
    if ("click" === a) return $0e6d2da9c09dac01$var$te(b);
}
function $0e6d2da9c09dac01$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0e6d2da9c09dac01$var$te(b);
}
function $0e6d2da9c09dac01$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0e6d2da9c09dac01$var$He = "function" === typeof Object.is ? Object.is : $0e6d2da9c09dac01$var$Ge;
function $0e6d2da9c09dac01$var$Ie(a, b) {
    if ($0e6d2da9c09dac01$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0e6d2da9c09dac01$var$ja.call(b, e) || !$0e6d2da9c09dac01$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0e6d2da9c09dac01$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0e6d2da9c09dac01$var$Ke(a, b) {
    var c = $0e6d2da9c09dac01$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0e6d2da9c09dac01$var$Je(c);
    }
}
function $0e6d2da9c09dac01$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0e6d2da9c09dac01$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0e6d2da9c09dac01$var$Me() {
    for(var a = window, b = $0e6d2da9c09dac01$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0e6d2da9c09dac01$var$Xa(a.document);
    }
    return b;
}
function $0e6d2da9c09dac01$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0e6d2da9c09dac01$var$Oe(a) {
    var b = $0e6d2da9c09dac01$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0e6d2da9c09dac01$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0e6d2da9c09dac01$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0e6d2da9c09dac01$var$Ke(c, f);
                var g = $0e6d2da9c09dac01$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0e6d2da9c09dac01$var$Pe = $0e6d2da9c09dac01$var$ia && "documentMode" in document && 11 >= document.documentMode, $0e6d2da9c09dac01$var$Qe = null, $0e6d2da9c09dac01$var$Re = null, $0e6d2da9c09dac01$var$Se = null, $0e6d2da9c09dac01$var$Te = !1;
function $0e6d2da9c09dac01$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0e6d2da9c09dac01$var$Te || null == $0e6d2da9c09dac01$var$Qe || $0e6d2da9c09dac01$var$Qe !== $0e6d2da9c09dac01$var$Xa(d) || (d = $0e6d2da9c09dac01$var$Qe, "selectionStart" in d && $0e6d2da9c09dac01$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0e6d2da9c09dac01$var$Se && $0e6d2da9c09dac01$var$Ie($0e6d2da9c09dac01$var$Se, d) || ($0e6d2da9c09dac01$var$Se = d, d = $0e6d2da9c09dac01$var$oe($0e6d2da9c09dac01$var$Re, "onSelect"), 0 < d.length && (b = new $0e6d2da9c09dac01$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0e6d2da9c09dac01$var$Qe)));
}
function $0e6d2da9c09dac01$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0e6d2da9c09dac01$var$We = {
    animationend: $0e6d2da9c09dac01$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0e6d2da9c09dac01$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0e6d2da9c09dac01$var$Ve("Animation", "AnimationStart"),
    transitionend: $0e6d2da9c09dac01$var$Ve("Transition", "TransitionEnd")
}, $0e6d2da9c09dac01$var$Xe = {}, $0e6d2da9c09dac01$var$Ye = {};
$0e6d2da9c09dac01$var$ia && ($0e6d2da9c09dac01$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0e6d2da9c09dac01$var$We.animationend.animation, delete $0e6d2da9c09dac01$var$We.animationiteration.animation, delete $0e6d2da9c09dac01$var$We.animationstart.animation), "TransitionEvent" in window || delete $0e6d2da9c09dac01$var$We.transitionend.transition);
function $0e6d2da9c09dac01$var$Ze(a) {
    if ($0e6d2da9c09dac01$var$Xe[a]) return $0e6d2da9c09dac01$var$Xe[a];
    if (!$0e6d2da9c09dac01$var$We[a]) return a;
    var b = $0e6d2da9c09dac01$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0e6d2da9c09dac01$var$Ye) return $0e6d2da9c09dac01$var$Xe[a] = b[c];
    return a;
}
var $0e6d2da9c09dac01$var$$e = $0e6d2da9c09dac01$var$Ze("animationend"), $0e6d2da9c09dac01$var$af = $0e6d2da9c09dac01$var$Ze("animationiteration"), $0e6d2da9c09dac01$var$bf = $0e6d2da9c09dac01$var$Ze("animationstart"), $0e6d2da9c09dac01$var$cf = $0e6d2da9c09dac01$var$Ze("transitionend"), $0e6d2da9c09dac01$var$df = new Map, $0e6d2da9c09dac01$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0e6d2da9c09dac01$var$ff(a, b) {
    $0e6d2da9c09dac01$var$df.set(a, b);
    $0e6d2da9c09dac01$var$fa(b, [
        a
    ]);
}
for(var $0e6d2da9c09dac01$var$gf = 0; $0e6d2da9c09dac01$var$gf < $0e6d2da9c09dac01$var$ef.length; $0e6d2da9c09dac01$var$gf++){
    var $0e6d2da9c09dac01$var$hf = $0e6d2da9c09dac01$var$ef[$0e6d2da9c09dac01$var$gf], $0e6d2da9c09dac01$var$jf = $0e6d2da9c09dac01$var$hf.toLowerCase(), $0e6d2da9c09dac01$var$kf = $0e6d2da9c09dac01$var$hf[0].toUpperCase() + $0e6d2da9c09dac01$var$hf.slice(1);
    $0e6d2da9c09dac01$var$ff($0e6d2da9c09dac01$var$jf, "on" + $0e6d2da9c09dac01$var$kf);
}
$0e6d2da9c09dac01$var$ff($0e6d2da9c09dac01$var$$e, "onAnimationEnd");
$0e6d2da9c09dac01$var$ff($0e6d2da9c09dac01$var$af, "onAnimationIteration");
$0e6d2da9c09dac01$var$ff($0e6d2da9c09dac01$var$bf, "onAnimationStart");
$0e6d2da9c09dac01$var$ff("dblclick", "onDoubleClick");
$0e6d2da9c09dac01$var$ff("focusin", "onFocus");
$0e6d2da9c09dac01$var$ff("focusout", "onBlur");
$0e6d2da9c09dac01$var$ff($0e6d2da9c09dac01$var$cf, "onTransitionEnd");
$0e6d2da9c09dac01$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0e6d2da9c09dac01$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0e6d2da9c09dac01$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0e6d2da9c09dac01$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0e6d2da9c09dac01$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0e6d2da9c09dac01$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0e6d2da9c09dac01$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0e6d2da9c09dac01$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0e6d2da9c09dac01$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0e6d2da9c09dac01$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0e6d2da9c09dac01$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0e6d2da9c09dac01$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0e6d2da9c09dac01$var$lf));
function $0e6d2da9c09dac01$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0e6d2da9c09dac01$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0e6d2da9c09dac01$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0e6d2da9c09dac01$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0e6d2da9c09dac01$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0e6d2da9c09dac01$var$Qb) throw a = $0e6d2da9c09dac01$var$Rb, $0e6d2da9c09dac01$var$Qb = !1, $0e6d2da9c09dac01$var$Rb = null, a;
}
function $0e6d2da9c09dac01$var$D(a, b) {
    var c = b[$0e6d2da9c09dac01$var$of];
    void 0 === c && (c = b[$0e6d2da9c09dac01$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0e6d2da9c09dac01$var$pf(b, a, 2, !1), c.add(d));
}
function $0e6d2da9c09dac01$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0e6d2da9c09dac01$var$pf(c, a, d, b);
}
var $0e6d2da9c09dac01$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0e6d2da9c09dac01$var$sf(a) {
    if (!a[$0e6d2da9c09dac01$var$rf]) {
        a[$0e6d2da9c09dac01$var$rf] = !0;
        $0e6d2da9c09dac01$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0e6d2da9c09dac01$var$mf.has(b) || $0e6d2da9c09dac01$var$qf(b, !1, a), $0e6d2da9c09dac01$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0e6d2da9c09dac01$var$rf] || (b[$0e6d2da9c09dac01$var$rf] = !0, $0e6d2da9c09dac01$var$qf("selectionchange", !1, b));
    }
}
function $0e6d2da9c09dac01$var$pf(a, b, c, d) {
    switch($0e6d2da9c09dac01$var$jd(b)){
        case 1:
            var e = $0e6d2da9c09dac01$var$ed;
            break;
        case 4:
            e = $0e6d2da9c09dac01$var$gd;
            break;
        default:
            e = $0e6d2da9c09dac01$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0e6d2da9c09dac01$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0e6d2da9c09dac01$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0e6d2da9c09dac01$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0e6d2da9c09dac01$var$Jb(function() {
        var d = f, e = $0e6d2da9c09dac01$var$xb(c), g = [];
        a: {
            var h = $0e6d2da9c09dac01$var$df.get(a);
            if (void 0 !== h) {
                var k = $0e6d2da9c09dac01$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0e6d2da9c09dac01$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0e6d2da9c09dac01$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0e6d2da9c09dac01$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0e6d2da9c09dac01$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0e6d2da9c09dac01$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0e6d2da9c09dac01$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0e6d2da9c09dac01$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0e6d2da9c09dac01$var$Vd;
                        break;
                    case $0e6d2da9c09dac01$var$$e:
                    case $0e6d2da9c09dac01$var$af:
                    case $0e6d2da9c09dac01$var$bf:
                        k = $0e6d2da9c09dac01$var$Hd;
                        break;
                    case $0e6d2da9c09dac01$var$cf:
                        k = $0e6d2da9c09dac01$var$Xd;
                        break;
                    case "scroll":
                        k = $0e6d2da9c09dac01$var$vd;
                        break;
                    case "wheel":
                        k = $0e6d2da9c09dac01$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0e6d2da9c09dac01$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0e6d2da9c09dac01$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0e6d2da9c09dac01$var$Kb(w, x), null != F && t.push($0e6d2da9c09dac01$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0e6d2da9c09dac01$var$wb && (n = c.relatedTarget || c.fromElement) && ($0e6d2da9c09dac01$var$Wc(n) || n[$0e6d2da9c09dac01$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0e6d2da9c09dac01$var$Wc(n) : null, null !== n && (J = $0e6d2da9c09dac01$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0e6d2da9c09dac01$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0e6d2da9c09dac01$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0e6d2da9c09dac01$var$ue(k);
                        u = null == n ? h : $0e6d2da9c09dac01$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0e6d2da9c09dac01$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0e6d2da9c09dac01$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0e6d2da9c09dac01$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0e6d2da9c09dac01$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0e6d2da9c09dac01$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0e6d2da9c09dac01$var$vf(t);
                                x = $0e6d2da9c09dac01$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0e6d2da9c09dac01$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0e6d2da9c09dac01$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0e6d2da9c09dac01$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0e6d2da9c09dac01$var$ve;
                else if ($0e6d2da9c09dac01$var$me(h)) {
                    if ($0e6d2da9c09dac01$var$we) na = $0e6d2da9c09dac01$var$Fe;
                    else {
                        na = $0e6d2da9c09dac01$var$De;
                        var xa = $0e6d2da9c09dac01$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0e6d2da9c09dac01$var$Ee);
                if (na && (na = na(a, d))) {
                    $0e6d2da9c09dac01$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0e6d2da9c09dac01$var$cb(h, "number", h.value);
            }
            xa = d ? $0e6d2da9c09dac01$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0e6d2da9c09dac01$var$me(xa) || "true" === xa.contentEditable) $0e6d2da9c09dac01$var$Qe = xa, $0e6d2da9c09dac01$var$Re = d, $0e6d2da9c09dac01$var$Se = null;
                    break;
                case "focusout":
                    $0e6d2da9c09dac01$var$Se = $0e6d2da9c09dac01$var$Re = $0e6d2da9c09dac01$var$Qe = null;
                    break;
                case "mousedown":
                    $0e6d2da9c09dac01$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0e6d2da9c09dac01$var$Te = !1;
                    $0e6d2da9c09dac01$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0e6d2da9c09dac01$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0e6d2da9c09dac01$var$Ue(g, c, e);
            }
            var $a;
            if ($0e6d2da9c09dac01$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0e6d2da9c09dac01$var$ie ? $0e6d2da9c09dac01$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0e6d2da9c09dac01$var$de && "ko" !== c.locale && ($0e6d2da9c09dac01$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0e6d2da9c09dac01$var$ie && ($a = $0e6d2da9c09dac01$var$nd()) : ($0e6d2da9c09dac01$var$kd = e, $0e6d2da9c09dac01$var$ld = "value" in $0e6d2da9c09dac01$var$kd ? $0e6d2da9c09dac01$var$kd.value : $0e6d2da9c09dac01$var$kd.textContent, $0e6d2da9c09dac01$var$ie = !0)), xa = $0e6d2da9c09dac01$var$oe(d, ba), 0 < xa.length && (ba = new $0e6d2da9c09dac01$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0e6d2da9c09dac01$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0e6d2da9c09dac01$var$ce ? $0e6d2da9c09dac01$var$je(a, c) : $0e6d2da9c09dac01$var$ke(a, c)) d = $0e6d2da9c09dac01$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0e6d2da9c09dac01$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0e6d2da9c09dac01$var$se(g, b);
    });
}
function $0e6d2da9c09dac01$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0e6d2da9c09dac01$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0e6d2da9c09dac01$var$Kb(a, c), null != f && d.unshift($0e6d2da9c09dac01$var$tf(a, f, e)), f = $0e6d2da9c09dac01$var$Kb(a, b), null != f && d.push($0e6d2da9c09dac01$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0e6d2da9c09dac01$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0e6d2da9c09dac01$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0e6d2da9c09dac01$var$Kb(c, f), null != k && g.unshift($0e6d2da9c09dac01$var$tf(c, k, h))) : e || (k = $0e6d2da9c09dac01$var$Kb(c, f), null != k && g.push($0e6d2da9c09dac01$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0e6d2da9c09dac01$var$xf = /\r\n?/g, $0e6d2da9c09dac01$var$yf = /\u0000|\uFFFD/g;
function $0e6d2da9c09dac01$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0e6d2da9c09dac01$var$xf, "\n").replace($0e6d2da9c09dac01$var$yf, "");
}
function $0e6d2da9c09dac01$var$Af(a, b, c) {
    b = $0e6d2da9c09dac01$var$zf(b);
    if ($0e6d2da9c09dac01$var$zf(a) !== b && c) throw Error($0e6d2da9c09dac01$var$p(425));
}
function $0e6d2da9c09dac01$var$Bf() {}
var $0e6d2da9c09dac01$var$Cf = null, $0e6d2da9c09dac01$var$Df = null;
function $0e6d2da9c09dac01$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0e6d2da9c09dac01$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0e6d2da9c09dac01$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0e6d2da9c09dac01$var$Hf = "function" === typeof Promise ? Promise : void 0, $0e6d2da9c09dac01$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0e6d2da9c09dac01$var$Hf ? function(a) {
    return $0e6d2da9c09dac01$var$Hf.resolve(null).then(a).catch($0e6d2da9c09dac01$var$If);
} : $0e6d2da9c09dac01$var$Ff;
function $0e6d2da9c09dac01$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0e6d2da9c09dac01$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0e6d2da9c09dac01$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0e6d2da9c09dac01$var$bd(b);
}
function $0e6d2da9c09dac01$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0e6d2da9c09dac01$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0e6d2da9c09dac01$var$Nf = Math.random().toString(36).slice(2), $0e6d2da9c09dac01$var$Of = "__reactFiber$" + $0e6d2da9c09dac01$var$Nf, $0e6d2da9c09dac01$var$Pf = "__reactProps$" + $0e6d2da9c09dac01$var$Nf, $0e6d2da9c09dac01$var$uf = "__reactContainer$" + $0e6d2da9c09dac01$var$Nf, $0e6d2da9c09dac01$var$of = "__reactEvents$" + $0e6d2da9c09dac01$var$Nf, $0e6d2da9c09dac01$var$Qf = "__reactListeners$" + $0e6d2da9c09dac01$var$Nf, $0e6d2da9c09dac01$var$Rf = "__reactHandles$" + $0e6d2da9c09dac01$var$Nf;
function $0e6d2da9c09dac01$var$Wc(a) {
    var b = a[$0e6d2da9c09dac01$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0e6d2da9c09dac01$var$uf] || c[$0e6d2da9c09dac01$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0e6d2da9c09dac01$var$Mf(a); null !== a;){
                if (c = a[$0e6d2da9c09dac01$var$Of]) return c;
                a = $0e6d2da9c09dac01$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0e6d2da9c09dac01$var$Cb(a) {
    a = a[$0e6d2da9c09dac01$var$Of] || a[$0e6d2da9c09dac01$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0e6d2da9c09dac01$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0e6d2da9c09dac01$var$p(33));
}
function $0e6d2da9c09dac01$var$Db(a) {
    return a[$0e6d2da9c09dac01$var$Pf] || null;
}
var $0e6d2da9c09dac01$var$Sf = [], $0e6d2da9c09dac01$var$Tf = -1;
function $0e6d2da9c09dac01$var$Uf(a) {
    return {
        current: a
    };
}
function $0e6d2da9c09dac01$var$E(a) {
    0 > $0e6d2da9c09dac01$var$Tf || (a.current = $0e6d2da9c09dac01$var$Sf[$0e6d2da9c09dac01$var$Tf], $0e6d2da9c09dac01$var$Sf[$0e6d2da9c09dac01$var$Tf] = null, $0e6d2da9c09dac01$var$Tf--);
}
function $0e6d2da9c09dac01$var$G(a, b) {
    $0e6d2da9c09dac01$var$Tf++;
    $0e6d2da9c09dac01$var$Sf[$0e6d2da9c09dac01$var$Tf] = a.current;
    a.current = b;
}
var $0e6d2da9c09dac01$var$Vf = {}, $0e6d2da9c09dac01$var$H = $0e6d2da9c09dac01$var$Uf($0e6d2da9c09dac01$var$Vf), $0e6d2da9c09dac01$var$Wf = $0e6d2da9c09dac01$var$Uf(!1), $0e6d2da9c09dac01$var$Xf = $0e6d2da9c09dac01$var$Vf;
function $0e6d2da9c09dac01$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0e6d2da9c09dac01$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0e6d2da9c09dac01$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0e6d2da9c09dac01$var$$f() {
    $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$Wf);
    $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$H);
}
function $0e6d2da9c09dac01$var$ag(a, b, c) {
    if ($0e6d2da9c09dac01$var$H.current !== $0e6d2da9c09dac01$var$Vf) throw Error($0e6d2da9c09dac01$var$p(168));
    $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$H, b);
    $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$Wf, c);
}
function $0e6d2da9c09dac01$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0e6d2da9c09dac01$var$p(108, $0e6d2da9c09dac01$var$Ra(a) || "Unknown", e));
    return $0e6d2da9c09dac01$var$A({}, c, d);
}
function $0e6d2da9c09dac01$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0e6d2da9c09dac01$var$Vf;
    $0e6d2da9c09dac01$var$Xf = $0e6d2da9c09dac01$var$H.current;
    $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$H, a);
    $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$Wf, $0e6d2da9c09dac01$var$Wf.current);
    return !0;
}
function $0e6d2da9c09dac01$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0e6d2da9c09dac01$var$p(169));
    c ? (a = $0e6d2da9c09dac01$var$bg(a, b, $0e6d2da9c09dac01$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$Wf), $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$H), $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$H, a)) : $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$Wf);
    $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$Wf, c);
}
var $0e6d2da9c09dac01$var$eg = null, $0e6d2da9c09dac01$var$fg = !1, $0e6d2da9c09dac01$var$gg = !1;
function $0e6d2da9c09dac01$var$hg(a) {
    null === $0e6d2da9c09dac01$var$eg ? $0e6d2da9c09dac01$var$eg = [
        a
    ] : $0e6d2da9c09dac01$var$eg.push(a);
}
function $0e6d2da9c09dac01$var$ig(a) {
    $0e6d2da9c09dac01$var$fg = !0;
    $0e6d2da9c09dac01$var$hg(a);
}
function $0e6d2da9c09dac01$var$jg() {
    if (!$0e6d2da9c09dac01$var$gg && null !== $0e6d2da9c09dac01$var$eg) {
        $0e6d2da9c09dac01$var$gg = !0;
        var a = 0, b = $0e6d2da9c09dac01$var$C;
        try {
            var c = $0e6d2da9c09dac01$var$eg;
            for($0e6d2da9c09dac01$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0e6d2da9c09dac01$var$eg = null;
            $0e6d2da9c09dac01$var$fg = !1;
        } catch (e) {
            throw null !== $0e6d2da9c09dac01$var$eg && ($0e6d2da9c09dac01$var$eg = $0e6d2da9c09dac01$var$eg.slice(a + 1)), $0e6d2da9c09dac01$var$ac($0e6d2da9c09dac01$var$fc, $0e6d2da9c09dac01$var$jg), e;
        } finally{
            $0e6d2da9c09dac01$var$C = b, $0e6d2da9c09dac01$var$gg = !1;
        }
    }
    return null;
}
var $0e6d2da9c09dac01$var$kg = [], $0e6d2da9c09dac01$var$lg = 0, $0e6d2da9c09dac01$var$mg = null, $0e6d2da9c09dac01$var$ng = 0, $0e6d2da9c09dac01$var$og = [], $0e6d2da9c09dac01$var$pg = 0, $0e6d2da9c09dac01$var$qg = null, $0e6d2da9c09dac01$var$rg = 1, $0e6d2da9c09dac01$var$sg = "";
function $0e6d2da9c09dac01$var$tg(a, b) {
    $0e6d2da9c09dac01$var$kg[$0e6d2da9c09dac01$var$lg++] = $0e6d2da9c09dac01$var$ng;
    $0e6d2da9c09dac01$var$kg[$0e6d2da9c09dac01$var$lg++] = $0e6d2da9c09dac01$var$mg;
    $0e6d2da9c09dac01$var$mg = a;
    $0e6d2da9c09dac01$var$ng = b;
}
function $0e6d2da9c09dac01$var$ug(a, b, c) {
    $0e6d2da9c09dac01$var$og[$0e6d2da9c09dac01$var$pg++] = $0e6d2da9c09dac01$var$rg;
    $0e6d2da9c09dac01$var$og[$0e6d2da9c09dac01$var$pg++] = $0e6d2da9c09dac01$var$sg;
    $0e6d2da9c09dac01$var$og[$0e6d2da9c09dac01$var$pg++] = $0e6d2da9c09dac01$var$qg;
    $0e6d2da9c09dac01$var$qg = a;
    var d = $0e6d2da9c09dac01$var$rg;
    a = $0e6d2da9c09dac01$var$sg;
    var e = 32 - $0e6d2da9c09dac01$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0e6d2da9c09dac01$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0e6d2da9c09dac01$var$rg = 1 << 32 - $0e6d2da9c09dac01$var$oc(b) + e | c << e | d;
        $0e6d2da9c09dac01$var$sg = f + a;
    } else $0e6d2da9c09dac01$var$rg = 1 << f | c << e | d, $0e6d2da9c09dac01$var$sg = a;
}
function $0e6d2da9c09dac01$var$vg(a) {
    null !== a.return && ($0e6d2da9c09dac01$var$tg(a, 1), $0e6d2da9c09dac01$var$ug(a, 1, 0));
}
function $0e6d2da9c09dac01$var$wg(a) {
    for(; a === $0e6d2da9c09dac01$var$mg;)$0e6d2da9c09dac01$var$mg = $0e6d2da9c09dac01$var$kg[--$0e6d2da9c09dac01$var$lg], $0e6d2da9c09dac01$var$kg[$0e6d2da9c09dac01$var$lg] = null, $0e6d2da9c09dac01$var$ng = $0e6d2da9c09dac01$var$kg[--$0e6d2da9c09dac01$var$lg], $0e6d2da9c09dac01$var$kg[$0e6d2da9c09dac01$var$lg] = null;
    for(; a === $0e6d2da9c09dac01$var$qg;)$0e6d2da9c09dac01$var$qg = $0e6d2da9c09dac01$var$og[--$0e6d2da9c09dac01$var$pg], $0e6d2da9c09dac01$var$og[$0e6d2da9c09dac01$var$pg] = null, $0e6d2da9c09dac01$var$sg = $0e6d2da9c09dac01$var$og[--$0e6d2da9c09dac01$var$pg], $0e6d2da9c09dac01$var$og[$0e6d2da9c09dac01$var$pg] = null, $0e6d2da9c09dac01$var$rg = $0e6d2da9c09dac01$var$og[--$0e6d2da9c09dac01$var$pg], $0e6d2da9c09dac01$var$og[$0e6d2da9c09dac01$var$pg] = null;
}
var $0e6d2da9c09dac01$var$xg = null, $0e6d2da9c09dac01$var$yg = null, $0e6d2da9c09dac01$var$I = !1, $0e6d2da9c09dac01$var$zg = null;
function $0e6d2da9c09dac01$var$Ag(a, b) {
    var c = $0e6d2da9c09dac01$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0e6d2da9c09dac01$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0e6d2da9c09dac01$var$xg = a, $0e6d2da9c09dac01$var$yg = $0e6d2da9c09dac01$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0e6d2da9c09dac01$var$xg = a, $0e6d2da9c09dac01$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0e6d2da9c09dac01$var$qg ? {
                id: $0e6d2da9c09dac01$var$rg,
                overflow: $0e6d2da9c09dac01$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0e6d2da9c09dac01$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0e6d2da9c09dac01$var$xg = a, $0e6d2da9c09dac01$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0e6d2da9c09dac01$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0e6d2da9c09dac01$var$Eg(a) {
    if ($0e6d2da9c09dac01$var$I) {
        var b = $0e6d2da9c09dac01$var$yg;
        if (b) {
            var c = b;
            if (!$0e6d2da9c09dac01$var$Cg(a, b)) {
                if ($0e6d2da9c09dac01$var$Dg(a)) throw Error($0e6d2da9c09dac01$var$p(418));
                b = $0e6d2da9c09dac01$var$Lf(c.nextSibling);
                var d = $0e6d2da9c09dac01$var$xg;
                b && $0e6d2da9c09dac01$var$Cg(a, b) ? $0e6d2da9c09dac01$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0e6d2da9c09dac01$var$I = !1, $0e6d2da9c09dac01$var$xg = a);
            }
        } else {
            if ($0e6d2da9c09dac01$var$Dg(a)) throw Error($0e6d2da9c09dac01$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0e6d2da9c09dac01$var$I = !1;
            $0e6d2da9c09dac01$var$xg = a;
        }
    }
}
function $0e6d2da9c09dac01$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0e6d2da9c09dac01$var$xg = a;
}
function $0e6d2da9c09dac01$var$Gg(a) {
    if (a !== $0e6d2da9c09dac01$var$xg) return !1;
    if (!$0e6d2da9c09dac01$var$I) return $0e6d2da9c09dac01$var$Fg(a), $0e6d2da9c09dac01$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0e6d2da9c09dac01$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0e6d2da9c09dac01$var$yg)) {
        if ($0e6d2da9c09dac01$var$Dg(a)) throw $0e6d2da9c09dac01$var$Hg(), Error($0e6d2da9c09dac01$var$p(418));
        for(; b;)$0e6d2da9c09dac01$var$Ag(a, b), b = $0e6d2da9c09dac01$var$Lf(b.nextSibling);
    }
    $0e6d2da9c09dac01$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0e6d2da9c09dac01$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0e6d2da9c09dac01$var$yg = $0e6d2da9c09dac01$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0e6d2da9c09dac01$var$yg = null;
        }
    } else $0e6d2da9c09dac01$var$yg = $0e6d2da9c09dac01$var$xg ? $0e6d2da9c09dac01$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0e6d2da9c09dac01$var$Hg() {
    for(var a = $0e6d2da9c09dac01$var$yg; a;)a = $0e6d2da9c09dac01$var$Lf(a.nextSibling);
}
function $0e6d2da9c09dac01$var$Ig() {
    $0e6d2da9c09dac01$var$yg = $0e6d2da9c09dac01$var$xg = null;
    $0e6d2da9c09dac01$var$I = !1;
}
function $0e6d2da9c09dac01$var$Jg(a) {
    null === $0e6d2da9c09dac01$var$zg ? $0e6d2da9c09dac01$var$zg = [
        a
    ] : $0e6d2da9c09dac01$var$zg.push(a);
}
var $0e6d2da9c09dac01$var$Kg = $0e6d2da9c09dac01$var$ua.ReactCurrentBatchConfig;
function $0e6d2da9c09dac01$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0e6d2da9c09dac01$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0e6d2da9c09dac01$var$Mg = $0e6d2da9c09dac01$var$Uf(null), $0e6d2da9c09dac01$var$Ng = null, $0e6d2da9c09dac01$var$Og = null, $0e6d2da9c09dac01$var$Pg = null;
function $0e6d2da9c09dac01$var$Qg() {
    $0e6d2da9c09dac01$var$Pg = $0e6d2da9c09dac01$var$Og = $0e6d2da9c09dac01$var$Ng = null;
}
function $0e6d2da9c09dac01$var$Rg(a) {
    var b = $0e6d2da9c09dac01$var$Mg.current;
    $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$Mg);
    a._currentValue = b;
}
function $0e6d2da9c09dac01$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0e6d2da9c09dac01$var$Tg(a, b) {
    $0e6d2da9c09dac01$var$Ng = a;
    $0e6d2da9c09dac01$var$Pg = $0e6d2da9c09dac01$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0e6d2da9c09dac01$var$Ug = !0), a.firstContext = null);
}
function $0e6d2da9c09dac01$var$Vg(a) {
    var b = a._currentValue;
    if ($0e6d2da9c09dac01$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0e6d2da9c09dac01$var$Og) {
            if (null === $0e6d2da9c09dac01$var$Ng) throw Error($0e6d2da9c09dac01$var$p(308));
            $0e6d2da9c09dac01$var$Og = a;
            $0e6d2da9c09dac01$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0e6d2da9c09dac01$var$Og = $0e6d2da9c09dac01$var$Og.next = a;
    }
    return b;
}
var $0e6d2da9c09dac01$var$Wg = null;
function $0e6d2da9c09dac01$var$Xg(a) {
    null === $0e6d2da9c09dac01$var$Wg ? $0e6d2da9c09dac01$var$Wg = [
        a
    ] : $0e6d2da9c09dac01$var$Wg.push(a);
}
function $0e6d2da9c09dac01$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0e6d2da9c09dac01$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0e6d2da9c09dac01$var$Zg(a, d);
}
function $0e6d2da9c09dac01$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0e6d2da9c09dac01$var$$g = !1;
function $0e6d2da9c09dac01$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0e6d2da9c09dac01$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0e6d2da9c09dac01$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0e6d2da9c09dac01$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0e6d2da9c09dac01$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0e6d2da9c09dac01$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0e6d2da9c09dac01$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0e6d2da9c09dac01$var$Zg(a, c);
}
function $0e6d2da9c09dac01$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0e6d2da9c09dac01$var$Cc(a, c);
    }
}
function $0e6d2da9c09dac01$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0e6d2da9c09dac01$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0e6d2da9c09dac01$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0e6d2da9c09dac01$var$A({}, q, r);
                            break a;
                        case 2:
                            $0e6d2da9c09dac01$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0e6d2da9c09dac01$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0e6d2da9c09dac01$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0e6d2da9c09dac01$var$p(191, e));
            e.call(d);
        }
    }
}
var $0e6d2da9c09dac01$var$jh = (new $fV3WI.Component).refs;
function $0e6d2da9c09dac01$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0e6d2da9c09dac01$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0e6d2da9c09dac01$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0e6d2da9c09dac01$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0e6d2da9c09dac01$var$L(), e = $0e6d2da9c09dac01$var$lh(a), f = $0e6d2da9c09dac01$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0e6d2da9c09dac01$var$dh(a, f, e);
        null !== b && ($0e6d2da9c09dac01$var$mh(b, a, e, d), $0e6d2da9c09dac01$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0e6d2da9c09dac01$var$L(), e = $0e6d2da9c09dac01$var$lh(a), f = $0e6d2da9c09dac01$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0e6d2da9c09dac01$var$dh(a, f, e);
        null !== b && ($0e6d2da9c09dac01$var$mh(b, a, e, d), $0e6d2da9c09dac01$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0e6d2da9c09dac01$var$L(), d = $0e6d2da9c09dac01$var$lh(a), e = $0e6d2da9c09dac01$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0e6d2da9c09dac01$var$dh(a, e, d);
        null !== b && ($0e6d2da9c09dac01$var$mh(b, a, d, c), $0e6d2da9c09dac01$var$eh(b, a, d));
    }
};
function $0e6d2da9c09dac01$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0e6d2da9c09dac01$var$Ie(c, d) || !$0e6d2da9c09dac01$var$Ie(e, f) : !0;
}
function $0e6d2da9c09dac01$var$ph(a, b, c) {
    var d = !1, e = $0e6d2da9c09dac01$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0e6d2da9c09dac01$var$Vg(f) : (e = $0e6d2da9c09dac01$var$Zf(b) ? $0e6d2da9c09dac01$var$Xf : $0e6d2da9c09dac01$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0e6d2da9c09dac01$var$Yf(a, e) : $0e6d2da9c09dac01$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0e6d2da9c09dac01$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0e6d2da9c09dac01$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0e6d2da9c09dac01$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0e6d2da9c09dac01$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0e6d2da9c09dac01$var$jh;
    $0e6d2da9c09dac01$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0e6d2da9c09dac01$var$Vg(f) : (f = $0e6d2da9c09dac01$var$Zf(b) ? $0e6d2da9c09dac01$var$Xf : $0e6d2da9c09dac01$var$H.current, e.context = $0e6d2da9c09dac01$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0e6d2da9c09dac01$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0e6d2da9c09dac01$var$nh.enqueueReplaceState(e, e.state, null), $0e6d2da9c09dac01$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0e6d2da9c09dac01$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0e6d2da9c09dac01$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0e6d2da9c09dac01$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0e6d2da9c09dac01$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0e6d2da9c09dac01$var$p(284));
        if (!c._owner) throw Error($0e6d2da9c09dac01$var$p(290, a));
    }
    return a;
}
function $0e6d2da9c09dac01$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0e6d2da9c09dac01$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0e6d2da9c09dac01$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0e6d2da9c09dac01$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0e6d2da9c09dac01$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0e6d2da9c09dac01$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0e6d2da9c09dac01$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0e6d2da9c09dac01$var$Ha && $0e6d2da9c09dac01$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0e6d2da9c09dac01$var$sh(a, b, c), d.return = a, d;
        d = $0e6d2da9c09dac01$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0e6d2da9c09dac01$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0e6d2da9c09dac01$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0e6d2da9c09dac01$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0e6d2da9c09dac01$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0e6d2da9c09dac01$var$va:
                    return c = $0e6d2da9c09dac01$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0e6d2da9c09dac01$var$sh(a, null, b), c.return = a, c;
                case $0e6d2da9c09dac01$var$wa:
                    return b = $0e6d2da9c09dac01$var$zh(b, a.mode, c), b.return = a, b;
                case $0e6d2da9c09dac01$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0e6d2da9c09dac01$var$eb(b) || $0e6d2da9c09dac01$var$Ka(b)) return b = $0e6d2da9c09dac01$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0e6d2da9c09dac01$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0e6d2da9c09dac01$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0e6d2da9c09dac01$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0e6d2da9c09dac01$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0e6d2da9c09dac01$var$eb(c) || $0e6d2da9c09dac01$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0e6d2da9c09dac01$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0e6d2da9c09dac01$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0e6d2da9c09dac01$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0e6d2da9c09dac01$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0e6d2da9c09dac01$var$eb(d) || $0e6d2da9c09dac01$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0e6d2da9c09dac01$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0e6d2da9c09dac01$var$I && $0e6d2da9c09dac01$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0e6d2da9c09dac01$var$I && $0e6d2da9c09dac01$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0e6d2da9c09dac01$var$I && $0e6d2da9c09dac01$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0e6d2da9c09dac01$var$Ka(h);
        if ("function" !== typeof l) throw Error($0e6d2da9c09dac01$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0e6d2da9c09dac01$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0e6d2da9c09dac01$var$I && $0e6d2da9c09dac01$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0e6d2da9c09dac01$var$I && $0e6d2da9c09dac01$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0e6d2da9c09dac01$var$I && $0e6d2da9c09dac01$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0e6d2da9c09dac01$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0e6d2da9c09dac01$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0e6d2da9c09dac01$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0e6d2da9c09dac01$var$Ha && $0e6d2da9c09dac01$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0e6d2da9c09dac01$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0e6d2da9c09dac01$var$ya ? (d = $0e6d2da9c09dac01$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0e6d2da9c09dac01$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0e6d2da9c09dac01$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0e6d2da9c09dac01$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0e6d2da9c09dac01$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0e6d2da9c09dac01$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0e6d2da9c09dac01$var$eb(f)) return n(a, d, f, h);
            if ($0e6d2da9c09dac01$var$Ka(f)) return t(a, d, f, h);
            $0e6d2da9c09dac01$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0e6d2da9c09dac01$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0e6d2da9c09dac01$var$Bh = $0e6d2da9c09dac01$var$vh(!0), $0e6d2da9c09dac01$var$Ch = $0e6d2da9c09dac01$var$vh(!1), $0e6d2da9c09dac01$var$Dh = {}, $0e6d2da9c09dac01$var$Eh = $0e6d2da9c09dac01$var$Uf($0e6d2da9c09dac01$var$Dh), $0e6d2da9c09dac01$var$Fh = $0e6d2da9c09dac01$var$Uf($0e6d2da9c09dac01$var$Dh), $0e6d2da9c09dac01$var$Gh = $0e6d2da9c09dac01$var$Uf($0e6d2da9c09dac01$var$Dh);
function $0e6d2da9c09dac01$var$Hh(a) {
    if (a === $0e6d2da9c09dac01$var$Dh) throw Error($0e6d2da9c09dac01$var$p(174));
    return a;
}
function $0e6d2da9c09dac01$var$Ih(a, b) {
    $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$Gh, b);
    $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$Fh, a);
    $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$Eh, $0e6d2da9c09dac01$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0e6d2da9c09dac01$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0e6d2da9c09dac01$var$lb(b, a);
    }
    $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$Eh);
    $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$Eh, b);
}
function $0e6d2da9c09dac01$var$Jh() {
    $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$Eh);
    $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$Fh);
    $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$Gh);
}
function $0e6d2da9c09dac01$var$Kh(a) {
    $0e6d2da9c09dac01$var$Hh($0e6d2da9c09dac01$var$Gh.current);
    var b = $0e6d2da9c09dac01$var$Hh($0e6d2da9c09dac01$var$Eh.current);
    var c = $0e6d2da9c09dac01$var$lb(b, a.type);
    b !== c && ($0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$Fh, a), $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$Eh, c));
}
function $0e6d2da9c09dac01$var$Lh(a) {
    $0e6d2da9c09dac01$var$Fh.current === a && ($0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$Eh), $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$Fh));
}
var $0e6d2da9c09dac01$var$M = $0e6d2da9c09dac01$var$Uf(0);
function $0e6d2da9c09dac01$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0e6d2da9c09dac01$var$Nh = [];
function $0e6d2da9c09dac01$var$Oh() {
    for(var a = 0; a < $0e6d2da9c09dac01$var$Nh.length; a++)$0e6d2da9c09dac01$var$Nh[a]._workInProgressVersionPrimary = null;
    $0e6d2da9c09dac01$var$Nh.length = 0;
}
var $0e6d2da9c09dac01$var$Ph = $0e6d2da9c09dac01$var$ua.ReactCurrentDispatcher, $0e6d2da9c09dac01$var$Qh = $0e6d2da9c09dac01$var$ua.ReactCurrentBatchConfig, $0e6d2da9c09dac01$var$Rh = 0, $0e6d2da9c09dac01$var$N = null, $0e6d2da9c09dac01$var$O = null, $0e6d2da9c09dac01$var$P = null, $0e6d2da9c09dac01$var$Sh = !1, $0e6d2da9c09dac01$var$Th = !1, $0e6d2da9c09dac01$var$Uh = 0, $0e6d2da9c09dac01$var$Vh = 0;
function $0e6d2da9c09dac01$var$Q() {
    throw Error($0e6d2da9c09dac01$var$p(321));
}
function $0e6d2da9c09dac01$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0e6d2da9c09dac01$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0e6d2da9c09dac01$var$Xh(a, b, c, d, e, f) {
    $0e6d2da9c09dac01$var$Rh = f;
    $0e6d2da9c09dac01$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0e6d2da9c09dac01$var$Ph.current = null === a || null === a.memoizedState ? $0e6d2da9c09dac01$var$Yh : $0e6d2da9c09dac01$var$Zh;
    a = c(d, e);
    if ($0e6d2da9c09dac01$var$Th) {
        f = 0;
        do {
            $0e6d2da9c09dac01$var$Th = !1;
            $0e6d2da9c09dac01$var$Uh = 0;
            if (25 <= f) throw Error($0e6d2da9c09dac01$var$p(301));
            f += 1;
            $0e6d2da9c09dac01$var$P = $0e6d2da9c09dac01$var$O = null;
            b.updateQueue = null;
            $0e6d2da9c09dac01$var$Ph.current = $0e6d2da9c09dac01$var$$h;
            a = c(d, e);
        }while ($0e6d2da9c09dac01$var$Th);
    }
    $0e6d2da9c09dac01$var$Ph.current = $0e6d2da9c09dac01$var$ai;
    b = null !== $0e6d2da9c09dac01$var$O && null !== $0e6d2da9c09dac01$var$O.next;
    $0e6d2da9c09dac01$var$Rh = 0;
    $0e6d2da9c09dac01$var$P = $0e6d2da9c09dac01$var$O = $0e6d2da9c09dac01$var$N = null;
    $0e6d2da9c09dac01$var$Sh = !1;
    if (b) throw Error($0e6d2da9c09dac01$var$p(300));
    return a;
}
function $0e6d2da9c09dac01$var$bi() {
    var a = 0 !== $0e6d2da9c09dac01$var$Uh;
    $0e6d2da9c09dac01$var$Uh = 0;
    return a;
}
function $0e6d2da9c09dac01$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0e6d2da9c09dac01$var$P ? $0e6d2da9c09dac01$var$N.memoizedState = $0e6d2da9c09dac01$var$P = a : $0e6d2da9c09dac01$var$P = $0e6d2da9c09dac01$var$P.next = a;
    return $0e6d2da9c09dac01$var$P;
}
function $0e6d2da9c09dac01$var$di() {
    if (null === $0e6d2da9c09dac01$var$O) {
        var a = $0e6d2da9c09dac01$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0e6d2da9c09dac01$var$O.next;
    var b = null === $0e6d2da9c09dac01$var$P ? $0e6d2da9c09dac01$var$N.memoizedState : $0e6d2da9c09dac01$var$P.next;
    if (null !== b) $0e6d2da9c09dac01$var$P = b, $0e6d2da9c09dac01$var$O = a;
    else {
        if (null === a) throw Error($0e6d2da9c09dac01$var$p(310));
        $0e6d2da9c09dac01$var$O = a;
        a = {
            memoizedState: $0e6d2da9c09dac01$var$O.memoizedState,
            baseState: $0e6d2da9c09dac01$var$O.baseState,
            baseQueue: $0e6d2da9c09dac01$var$O.baseQueue,
            queue: $0e6d2da9c09dac01$var$O.queue,
            next: null
        };
        null === $0e6d2da9c09dac01$var$P ? $0e6d2da9c09dac01$var$N.memoizedState = $0e6d2da9c09dac01$var$P = a : $0e6d2da9c09dac01$var$P = $0e6d2da9c09dac01$var$P.next = a;
    }
    return $0e6d2da9c09dac01$var$P;
}
function $0e6d2da9c09dac01$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0e6d2da9c09dac01$var$fi(a) {
    var b = $0e6d2da9c09dac01$var$di(), c = b.queue;
    if (null === c) throw Error($0e6d2da9c09dac01$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0e6d2da9c09dac01$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0e6d2da9c09dac01$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0e6d2da9c09dac01$var$N.lanes |= m;
                $0e6d2da9c09dac01$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0e6d2da9c09dac01$var$He(d, b.memoizedState) || ($0e6d2da9c09dac01$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0e6d2da9c09dac01$var$N.lanes |= f, $0e6d2da9c09dac01$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0e6d2da9c09dac01$var$gi(a) {
    var b = $0e6d2da9c09dac01$var$di(), c = b.queue;
    if (null === c) throw Error($0e6d2da9c09dac01$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0e6d2da9c09dac01$var$He(f, b.memoizedState) || ($0e6d2da9c09dac01$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0e6d2da9c09dac01$var$hi() {}
function $0e6d2da9c09dac01$var$ii(a, b) {
    var c = $0e6d2da9c09dac01$var$N, d = $0e6d2da9c09dac01$var$di(), e = b(), f = !$0e6d2da9c09dac01$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0e6d2da9c09dac01$var$Ug = !0);
    d = d.queue;
    $0e6d2da9c09dac01$var$ji($0e6d2da9c09dac01$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0e6d2da9c09dac01$var$P && $0e6d2da9c09dac01$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0e6d2da9c09dac01$var$li(9, $0e6d2da9c09dac01$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0e6d2da9c09dac01$var$R) throw Error($0e6d2da9c09dac01$var$p(349));
        0 !== ($0e6d2da9c09dac01$var$Rh & 30) || $0e6d2da9c09dac01$var$ni(c, b, e);
    }
    return e;
}
function $0e6d2da9c09dac01$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0e6d2da9c09dac01$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0e6d2da9c09dac01$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0e6d2da9c09dac01$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0e6d2da9c09dac01$var$oi(b) && $0e6d2da9c09dac01$var$pi(a);
}
function $0e6d2da9c09dac01$var$ki(a, b, c) {
    return c(function() {
        $0e6d2da9c09dac01$var$oi(b) && $0e6d2da9c09dac01$var$pi(a);
    });
}
function $0e6d2da9c09dac01$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0e6d2da9c09dac01$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0e6d2da9c09dac01$var$pi(a) {
    var b = $0e6d2da9c09dac01$var$Zg(a, 1);
    null !== b && $0e6d2da9c09dac01$var$mh(b, a, 1, -1);
}
function $0e6d2da9c09dac01$var$qi(a) {
    var b = $0e6d2da9c09dac01$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0e6d2da9c09dac01$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0e6d2da9c09dac01$var$ri.bind(null, $0e6d2da9c09dac01$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0e6d2da9c09dac01$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0e6d2da9c09dac01$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0e6d2da9c09dac01$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0e6d2da9c09dac01$var$si() {
    return $0e6d2da9c09dac01$var$di().memoizedState;
}
function $0e6d2da9c09dac01$var$ti(a, b, c, d) {
    var e = $0e6d2da9c09dac01$var$ci();
    $0e6d2da9c09dac01$var$N.flags |= a;
    e.memoizedState = $0e6d2da9c09dac01$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0e6d2da9c09dac01$var$ui(a, b, c, d) {
    var e = $0e6d2da9c09dac01$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0e6d2da9c09dac01$var$O) {
        var g = $0e6d2da9c09dac01$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0e6d2da9c09dac01$var$Wh(d, g.deps)) {
            e.memoizedState = $0e6d2da9c09dac01$var$li(b, c, f, d);
            return;
        }
    }
    $0e6d2da9c09dac01$var$N.flags |= a;
    e.memoizedState = $0e6d2da9c09dac01$var$li(1 | b, c, f, d);
}
function $0e6d2da9c09dac01$var$vi(a, b) {
    return $0e6d2da9c09dac01$var$ti(8390656, 8, a, b);
}
function $0e6d2da9c09dac01$var$ji(a, b) {
    return $0e6d2da9c09dac01$var$ui(2048, 8, a, b);
}
function $0e6d2da9c09dac01$var$wi(a, b) {
    return $0e6d2da9c09dac01$var$ui(4, 2, a, b);
}
function $0e6d2da9c09dac01$var$xi(a, b) {
    return $0e6d2da9c09dac01$var$ui(4, 4, a, b);
}
function $0e6d2da9c09dac01$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0e6d2da9c09dac01$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0e6d2da9c09dac01$var$ui(4, 4, $0e6d2da9c09dac01$var$yi.bind(null, b, a), c);
}
function $0e6d2da9c09dac01$var$Ai() {}
function $0e6d2da9c09dac01$var$Bi(a, b) {
    var c = $0e6d2da9c09dac01$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0e6d2da9c09dac01$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0e6d2da9c09dac01$var$Ci(a, b) {
    var c = $0e6d2da9c09dac01$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0e6d2da9c09dac01$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0e6d2da9c09dac01$var$Di(a, b, c) {
    if (0 === ($0e6d2da9c09dac01$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0e6d2da9c09dac01$var$Ug = !0), a.memoizedState = c;
    $0e6d2da9c09dac01$var$He(c, b) || (c = $0e6d2da9c09dac01$var$yc(), $0e6d2da9c09dac01$var$N.lanes |= c, $0e6d2da9c09dac01$var$hh |= c, a.baseState = !0);
    return b;
}
function $0e6d2da9c09dac01$var$Ei(a, b) {
    var c = $0e6d2da9c09dac01$var$C;
    $0e6d2da9c09dac01$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0e6d2da9c09dac01$var$Qh.transition;
    $0e6d2da9c09dac01$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0e6d2da9c09dac01$var$C = c, $0e6d2da9c09dac01$var$Qh.transition = d;
    }
}
function $0e6d2da9c09dac01$var$Fi() {
    return $0e6d2da9c09dac01$var$di().memoizedState;
}
function $0e6d2da9c09dac01$var$Gi(a, b, c) {
    var d = $0e6d2da9c09dac01$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0e6d2da9c09dac01$var$Hi(a)) $0e6d2da9c09dac01$var$Ii(b, c);
    else if (c = $0e6d2da9c09dac01$var$Yg(a, b, c, d), null !== c) {
        var e = $0e6d2da9c09dac01$var$L();
        $0e6d2da9c09dac01$var$mh(c, a, d, e);
        $0e6d2da9c09dac01$var$Ji(c, b, d);
    }
}
function $0e6d2da9c09dac01$var$ri(a, b, c) {
    var d = $0e6d2da9c09dac01$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0e6d2da9c09dac01$var$Hi(a)) $0e6d2da9c09dac01$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0e6d2da9c09dac01$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0e6d2da9c09dac01$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0e6d2da9c09dac01$var$Yg(a, b, e, d);
        null !== c && (e = $0e6d2da9c09dac01$var$L(), $0e6d2da9c09dac01$var$mh(c, a, d, e), $0e6d2da9c09dac01$var$Ji(c, b, d));
    }
}
function $0e6d2da9c09dac01$var$Hi(a) {
    var b = a.alternate;
    return a === $0e6d2da9c09dac01$var$N || null !== b && b === $0e6d2da9c09dac01$var$N;
}
function $0e6d2da9c09dac01$var$Ii(a, b) {
    $0e6d2da9c09dac01$var$Th = $0e6d2da9c09dac01$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0e6d2da9c09dac01$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0e6d2da9c09dac01$var$Cc(a, c);
    }
}
var $0e6d2da9c09dac01$var$ai = {
    readContext: $0e6d2da9c09dac01$var$Vg,
    useCallback: $0e6d2da9c09dac01$var$Q,
    useContext: $0e6d2da9c09dac01$var$Q,
    useEffect: $0e6d2da9c09dac01$var$Q,
    useImperativeHandle: $0e6d2da9c09dac01$var$Q,
    useInsertionEffect: $0e6d2da9c09dac01$var$Q,
    useLayoutEffect: $0e6d2da9c09dac01$var$Q,
    useMemo: $0e6d2da9c09dac01$var$Q,
    useReducer: $0e6d2da9c09dac01$var$Q,
    useRef: $0e6d2da9c09dac01$var$Q,
    useState: $0e6d2da9c09dac01$var$Q,
    useDebugValue: $0e6d2da9c09dac01$var$Q,
    useDeferredValue: $0e6d2da9c09dac01$var$Q,
    useTransition: $0e6d2da9c09dac01$var$Q,
    useMutableSource: $0e6d2da9c09dac01$var$Q,
    useSyncExternalStore: $0e6d2da9c09dac01$var$Q,
    useId: $0e6d2da9c09dac01$var$Q,
    unstable_isNewReconciler: !1
}, $0e6d2da9c09dac01$var$Yh = {
    readContext: $0e6d2da9c09dac01$var$Vg,
    useCallback: function(a, b) {
        $0e6d2da9c09dac01$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0e6d2da9c09dac01$var$Vg,
    useEffect: $0e6d2da9c09dac01$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0e6d2da9c09dac01$var$ti(4194308, 4, $0e6d2da9c09dac01$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0e6d2da9c09dac01$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0e6d2da9c09dac01$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0e6d2da9c09dac01$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0e6d2da9c09dac01$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0e6d2da9c09dac01$var$Gi.bind(null, $0e6d2da9c09dac01$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0e6d2da9c09dac01$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0e6d2da9c09dac01$var$qi,
    useDebugValue: $0e6d2da9c09dac01$var$Ai,
    useDeferredValue: function(a) {
        return $0e6d2da9c09dac01$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0e6d2da9c09dac01$var$qi(!1), b = a[0];
        a = $0e6d2da9c09dac01$var$Ei.bind(null, a[1]);
        $0e6d2da9c09dac01$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0e6d2da9c09dac01$var$N, e = $0e6d2da9c09dac01$var$ci();
        if ($0e6d2da9c09dac01$var$I) {
            if (void 0 === c) throw Error($0e6d2da9c09dac01$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0e6d2da9c09dac01$var$R) throw Error($0e6d2da9c09dac01$var$p(349));
            0 !== ($0e6d2da9c09dac01$var$Rh & 30) || $0e6d2da9c09dac01$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0e6d2da9c09dac01$var$vi($0e6d2da9c09dac01$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0e6d2da9c09dac01$var$li(9, $0e6d2da9c09dac01$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0e6d2da9c09dac01$var$ci(), b = $0e6d2da9c09dac01$var$R.identifierPrefix;
        if ($0e6d2da9c09dac01$var$I) {
            var c = $0e6d2da9c09dac01$var$sg;
            var d = $0e6d2da9c09dac01$var$rg;
            c = (d & ~(1 << 32 - $0e6d2da9c09dac01$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0e6d2da9c09dac01$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0e6d2da9c09dac01$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0e6d2da9c09dac01$var$Zh = {
    readContext: $0e6d2da9c09dac01$var$Vg,
    useCallback: $0e6d2da9c09dac01$var$Bi,
    useContext: $0e6d2da9c09dac01$var$Vg,
    useEffect: $0e6d2da9c09dac01$var$ji,
    useImperativeHandle: $0e6d2da9c09dac01$var$zi,
    useInsertionEffect: $0e6d2da9c09dac01$var$wi,
    useLayoutEffect: $0e6d2da9c09dac01$var$xi,
    useMemo: $0e6d2da9c09dac01$var$Ci,
    useReducer: $0e6d2da9c09dac01$var$fi,
    useRef: $0e6d2da9c09dac01$var$si,
    useState: function() {
        return $0e6d2da9c09dac01$var$fi($0e6d2da9c09dac01$var$ei);
    },
    useDebugValue: $0e6d2da9c09dac01$var$Ai,
    useDeferredValue: function(a) {
        var b = $0e6d2da9c09dac01$var$di();
        return $0e6d2da9c09dac01$var$Di(b, $0e6d2da9c09dac01$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0e6d2da9c09dac01$var$fi($0e6d2da9c09dac01$var$ei)[0], b = $0e6d2da9c09dac01$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0e6d2da9c09dac01$var$hi,
    useSyncExternalStore: $0e6d2da9c09dac01$var$ii,
    useId: $0e6d2da9c09dac01$var$Fi,
    unstable_isNewReconciler: !1
}, $0e6d2da9c09dac01$var$$h = {
    readContext: $0e6d2da9c09dac01$var$Vg,
    useCallback: $0e6d2da9c09dac01$var$Bi,
    useContext: $0e6d2da9c09dac01$var$Vg,
    useEffect: $0e6d2da9c09dac01$var$ji,
    useImperativeHandle: $0e6d2da9c09dac01$var$zi,
    useInsertionEffect: $0e6d2da9c09dac01$var$wi,
    useLayoutEffect: $0e6d2da9c09dac01$var$xi,
    useMemo: $0e6d2da9c09dac01$var$Ci,
    useReducer: $0e6d2da9c09dac01$var$gi,
    useRef: $0e6d2da9c09dac01$var$si,
    useState: function() {
        return $0e6d2da9c09dac01$var$gi($0e6d2da9c09dac01$var$ei);
    },
    useDebugValue: $0e6d2da9c09dac01$var$Ai,
    useDeferredValue: function(a) {
        var b = $0e6d2da9c09dac01$var$di();
        return null === $0e6d2da9c09dac01$var$O ? b.memoizedState = a : $0e6d2da9c09dac01$var$Di(b, $0e6d2da9c09dac01$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0e6d2da9c09dac01$var$gi($0e6d2da9c09dac01$var$ei)[0], b = $0e6d2da9c09dac01$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0e6d2da9c09dac01$var$hi,
    useSyncExternalStore: $0e6d2da9c09dac01$var$ii,
    useId: $0e6d2da9c09dac01$var$Fi,
    unstable_isNewReconciler: !1
};
function $0e6d2da9c09dac01$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0e6d2da9c09dac01$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0e6d2da9c09dac01$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0e6d2da9c09dac01$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0e6d2da9c09dac01$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0e6d2da9c09dac01$var$Oi(a, b, c) {
    c = $0e6d2da9c09dac01$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0e6d2da9c09dac01$var$Pi || ($0e6d2da9c09dac01$var$Pi = !0, $0e6d2da9c09dac01$var$Qi = d);
        $0e6d2da9c09dac01$var$Mi(a, b);
    };
    return c;
}
function $0e6d2da9c09dac01$var$Ri(a, b, c) {
    c = $0e6d2da9c09dac01$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0e6d2da9c09dac01$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0e6d2da9c09dac01$var$Mi(a, b);
        "function" !== typeof d && (null === $0e6d2da9c09dac01$var$Si ? $0e6d2da9c09dac01$var$Si = new Set([
            this
        ]) : $0e6d2da9c09dac01$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0e6d2da9c09dac01$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0e6d2da9c09dac01$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0e6d2da9c09dac01$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0e6d2da9c09dac01$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0e6d2da9c09dac01$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0e6d2da9c09dac01$var$ch(-1, 1), b.tag = 2, $0e6d2da9c09dac01$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0e6d2da9c09dac01$var$Xi = $0e6d2da9c09dac01$var$ua.ReactCurrentOwner, $0e6d2da9c09dac01$var$Ug = !1;
function $0e6d2da9c09dac01$var$Yi(a, b, c, d) {
    b.child = null === a ? $0e6d2da9c09dac01$var$Ch(b, null, c, d) : $0e6d2da9c09dac01$var$Bh(b, a.child, c, d);
}
function $0e6d2da9c09dac01$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0e6d2da9c09dac01$var$Tg(b, e);
    d = $0e6d2da9c09dac01$var$Xh(a, b, c, d, f, e);
    c = $0e6d2da9c09dac01$var$bi();
    if (null !== a && !$0e6d2da9c09dac01$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0e6d2da9c09dac01$var$$i(a, b, e);
    $0e6d2da9c09dac01$var$I && c && $0e6d2da9c09dac01$var$vg(b);
    b.flags |= 1;
    $0e6d2da9c09dac01$var$Yi(a, b, d, e);
    return b.child;
}
function $0e6d2da9c09dac01$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0e6d2da9c09dac01$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0e6d2da9c09dac01$var$cj(a, b, f, d, e);
        a = $0e6d2da9c09dac01$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0e6d2da9c09dac01$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0e6d2da9c09dac01$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0e6d2da9c09dac01$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0e6d2da9c09dac01$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0e6d2da9c09dac01$var$Ie(f, d) && a.ref === b.ref) {
            if ($0e6d2da9c09dac01$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0e6d2da9c09dac01$var$Ug = !0);
            else return b.lanes = a.lanes, $0e6d2da9c09dac01$var$$i(a, b, e);
        }
    }
    return $0e6d2da9c09dac01$var$dj(a, b, c, d, e);
}
function $0e6d2da9c09dac01$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$fj, $0e6d2da9c09dac01$var$gj), $0e6d2da9c09dac01$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$fj, $0e6d2da9c09dac01$var$gj), $0e6d2da9c09dac01$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$fj, $0e6d2da9c09dac01$var$gj);
            $0e6d2da9c09dac01$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$fj, $0e6d2da9c09dac01$var$gj), $0e6d2da9c09dac01$var$gj |= d;
    $0e6d2da9c09dac01$var$Yi(a, b, e, c);
    return b.child;
}
function $0e6d2da9c09dac01$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0e6d2da9c09dac01$var$dj(a, b, c, d, e) {
    var f = $0e6d2da9c09dac01$var$Zf(c) ? $0e6d2da9c09dac01$var$Xf : $0e6d2da9c09dac01$var$H.current;
    f = $0e6d2da9c09dac01$var$Yf(b, f);
    $0e6d2da9c09dac01$var$Tg(b, e);
    c = $0e6d2da9c09dac01$var$Xh(a, b, c, d, f, e);
    d = $0e6d2da9c09dac01$var$bi();
    if (null !== a && !$0e6d2da9c09dac01$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0e6d2da9c09dac01$var$$i(a, b, e);
    $0e6d2da9c09dac01$var$I && d && $0e6d2da9c09dac01$var$vg(b);
    b.flags |= 1;
    $0e6d2da9c09dac01$var$Yi(a, b, c, e);
    return b.child;
}
function $0e6d2da9c09dac01$var$ij(a, b, c, d, e) {
    if ($0e6d2da9c09dac01$var$Zf(c)) {
        var f = !0;
        $0e6d2da9c09dac01$var$cg(b);
    } else f = !1;
    $0e6d2da9c09dac01$var$Tg(b, e);
    if (null === b.stateNode) $0e6d2da9c09dac01$var$jj(a, b), $0e6d2da9c09dac01$var$ph(b, c, d), $0e6d2da9c09dac01$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0e6d2da9c09dac01$var$Vg(l) : (l = $0e6d2da9c09dac01$var$Zf(c) ? $0e6d2da9c09dac01$var$Xf : $0e6d2da9c09dac01$var$H.current, l = $0e6d2da9c09dac01$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0e6d2da9c09dac01$var$qh(b, g, d, l);
        $0e6d2da9c09dac01$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0e6d2da9c09dac01$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0e6d2da9c09dac01$var$Wf.current || $0e6d2da9c09dac01$var$$g ? ("function" === typeof m && ($0e6d2da9c09dac01$var$kh(b, c, m, d), k = b.memoizedState), (h = $0e6d2da9c09dac01$var$$g || $0e6d2da9c09dac01$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0e6d2da9c09dac01$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0e6d2da9c09dac01$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0e6d2da9c09dac01$var$Vg(k) : (k = $0e6d2da9c09dac01$var$Zf(c) ? $0e6d2da9c09dac01$var$Xf : $0e6d2da9c09dac01$var$H.current, k = $0e6d2da9c09dac01$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0e6d2da9c09dac01$var$qh(b, g, d, k);
        $0e6d2da9c09dac01$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0e6d2da9c09dac01$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0e6d2da9c09dac01$var$Wf.current || $0e6d2da9c09dac01$var$$g ? ("function" === typeof y && ($0e6d2da9c09dac01$var$kh(b, c, y, d), n = b.memoizedState), (l = $0e6d2da9c09dac01$var$$g || $0e6d2da9c09dac01$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0e6d2da9c09dac01$var$kj(a, b, c, d, f, e);
}
function $0e6d2da9c09dac01$var$kj(a, b, c, d, e, f) {
    $0e6d2da9c09dac01$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0e6d2da9c09dac01$var$dg(b, c, !1), $0e6d2da9c09dac01$var$$i(a, b, f);
    d = b.stateNode;
    $0e6d2da9c09dac01$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0e6d2da9c09dac01$var$Bh(b, a.child, null, f), b.child = $0e6d2da9c09dac01$var$Bh(b, null, h, f)) : $0e6d2da9c09dac01$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0e6d2da9c09dac01$var$dg(b, c, !0);
    return b.child;
}
function $0e6d2da9c09dac01$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0e6d2da9c09dac01$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0e6d2da9c09dac01$var$ag(a, b.context, !1);
    $0e6d2da9c09dac01$var$Ih(a, b.containerInfo);
}
function $0e6d2da9c09dac01$var$mj(a, b, c, d, e) {
    $0e6d2da9c09dac01$var$Ig();
    $0e6d2da9c09dac01$var$Jg(e);
    b.flags |= 256;
    $0e6d2da9c09dac01$var$Yi(a, b, c, d);
    return b.child;
}
var $0e6d2da9c09dac01$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0e6d2da9c09dac01$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0e6d2da9c09dac01$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0e6d2da9c09dac01$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$M, e & 1);
    if (null === a) {
        $0e6d2da9c09dac01$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0e6d2da9c09dac01$var$qj(g, d, 0, null), a = $0e6d2da9c09dac01$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0e6d2da9c09dac01$var$oj(c), b.memoizedState = $0e6d2da9c09dac01$var$nj, a) : $0e6d2da9c09dac01$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0e6d2da9c09dac01$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0e6d2da9c09dac01$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0e6d2da9c09dac01$var$wh(h, f) : (f = $0e6d2da9c09dac01$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0e6d2da9c09dac01$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0e6d2da9c09dac01$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0e6d2da9c09dac01$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0e6d2da9c09dac01$var$rj(a, b) {
    b = $0e6d2da9c09dac01$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0e6d2da9c09dac01$var$tj(a, b, c, d) {
    null !== d && $0e6d2da9c09dac01$var$Jg(d);
    $0e6d2da9c09dac01$var$Bh(b, a.child, null, c);
    a = $0e6d2da9c09dac01$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0e6d2da9c09dac01$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0e6d2da9c09dac01$var$Li(Error($0e6d2da9c09dac01$var$p(422))), $0e6d2da9c09dac01$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0e6d2da9c09dac01$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0e6d2da9c09dac01$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0e6d2da9c09dac01$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0e6d2da9c09dac01$var$oj(g);
        b.memoizedState = $0e6d2da9c09dac01$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0e6d2da9c09dac01$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0e6d2da9c09dac01$var$p(419));
        d = $0e6d2da9c09dac01$var$Li(f, d, void 0);
        return $0e6d2da9c09dac01$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0e6d2da9c09dac01$var$Ug || h) {
        d = $0e6d2da9c09dac01$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0e6d2da9c09dac01$var$Zg(a, e), $0e6d2da9c09dac01$var$mh(d, a, e, -1));
        }
        $0e6d2da9c09dac01$var$uj();
        d = $0e6d2da9c09dac01$var$Li(Error($0e6d2da9c09dac01$var$p(421)));
        return $0e6d2da9c09dac01$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0e6d2da9c09dac01$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0e6d2da9c09dac01$var$yg = $0e6d2da9c09dac01$var$Lf(e.nextSibling);
    $0e6d2da9c09dac01$var$xg = b;
    $0e6d2da9c09dac01$var$I = !0;
    $0e6d2da9c09dac01$var$zg = null;
    null !== a && ($0e6d2da9c09dac01$var$og[$0e6d2da9c09dac01$var$pg++] = $0e6d2da9c09dac01$var$rg, $0e6d2da9c09dac01$var$og[$0e6d2da9c09dac01$var$pg++] = $0e6d2da9c09dac01$var$sg, $0e6d2da9c09dac01$var$og[$0e6d2da9c09dac01$var$pg++] = $0e6d2da9c09dac01$var$qg, $0e6d2da9c09dac01$var$rg = a.id, $0e6d2da9c09dac01$var$sg = a.overflow, $0e6d2da9c09dac01$var$qg = b);
    b = $0e6d2da9c09dac01$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0e6d2da9c09dac01$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0e6d2da9c09dac01$var$Sg(a.return, b, c);
}
function $0e6d2da9c09dac01$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0e6d2da9c09dac01$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0e6d2da9c09dac01$var$Yi(a, b, d.children, c);
    d = $0e6d2da9c09dac01$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0e6d2da9c09dac01$var$wj(a, c, b);
            else if (19 === a.tag) $0e6d2da9c09dac01$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0e6d2da9c09dac01$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0e6d2da9c09dac01$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0e6d2da9c09dac01$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0e6d2da9c09dac01$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0e6d2da9c09dac01$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0e6d2da9c09dac01$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0e6d2da9c09dac01$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0e6d2da9c09dac01$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0e6d2da9c09dac01$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0e6d2da9c09dac01$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0e6d2da9c09dac01$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0e6d2da9c09dac01$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0e6d2da9c09dac01$var$lj(b);
            $0e6d2da9c09dac01$var$Ig();
            break;
        case 5:
            $0e6d2da9c09dac01$var$Kh(b);
            break;
        case 1:
            $0e6d2da9c09dac01$var$Zf(b.type) && $0e6d2da9c09dac01$var$cg(b);
            break;
        case 4:
            $0e6d2da9c09dac01$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$M, $0e6d2da9c09dac01$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0e6d2da9c09dac01$var$pj(a, b, c);
                $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$M, $0e6d2da9c09dac01$var$M.current & 1);
                a = $0e6d2da9c09dac01$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$M, $0e6d2da9c09dac01$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0e6d2da9c09dac01$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$M, $0e6d2da9c09dac01$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0e6d2da9c09dac01$var$ej(a, b, c);
    }
    return $0e6d2da9c09dac01$var$$i(a, b, c);
}
var $0e6d2da9c09dac01$var$Aj, $0e6d2da9c09dac01$var$Bj, $0e6d2da9c09dac01$var$Cj, $0e6d2da9c09dac01$var$Dj;
$0e6d2da9c09dac01$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0e6d2da9c09dac01$var$Bj = function() {};
$0e6d2da9c09dac01$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0e6d2da9c09dac01$var$Hh($0e6d2da9c09dac01$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0e6d2da9c09dac01$var$Ya(a, e);
                d = $0e6d2da9c09dac01$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0e6d2da9c09dac01$var$A({}, e, {
                    value: void 0
                });
                d = $0e6d2da9c09dac01$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0e6d2da9c09dac01$var$gb(a, e);
                d = $0e6d2da9c09dac01$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0e6d2da9c09dac01$var$Bf);
        }
        $0e6d2da9c09dac01$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0e6d2da9c09dac01$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0e6d2da9c09dac01$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0e6d2da9c09dac01$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0e6d2da9c09dac01$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0e6d2da9c09dac01$var$Ej(a, b) {
    if (!$0e6d2da9c09dac01$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0e6d2da9c09dac01$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0e6d2da9c09dac01$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0e6d2da9c09dac01$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0e6d2da9c09dac01$var$S(b), null;
        case 1:
            return $0e6d2da9c09dac01$var$Zf(b.type) && $0e6d2da9c09dac01$var$$f(), $0e6d2da9c09dac01$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0e6d2da9c09dac01$var$Jh();
            $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$Wf);
            $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$H);
            $0e6d2da9c09dac01$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0e6d2da9c09dac01$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0e6d2da9c09dac01$var$zg && ($0e6d2da9c09dac01$var$Gj($0e6d2da9c09dac01$var$zg), $0e6d2da9c09dac01$var$zg = null));
            $0e6d2da9c09dac01$var$Bj(a, b);
            $0e6d2da9c09dac01$var$S(b);
            return null;
        case 5:
            $0e6d2da9c09dac01$var$Lh(b);
            var e = $0e6d2da9c09dac01$var$Hh($0e6d2da9c09dac01$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0e6d2da9c09dac01$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0e6d2da9c09dac01$var$p(166));
                    $0e6d2da9c09dac01$var$S(b);
                    return null;
                }
                a = $0e6d2da9c09dac01$var$Hh($0e6d2da9c09dac01$var$Eh.current);
                if ($0e6d2da9c09dac01$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0e6d2da9c09dac01$var$Of] = b;
                    d[$0e6d2da9c09dac01$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0e6d2da9c09dac01$var$D("cancel", d);
                            $0e6d2da9c09dac01$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0e6d2da9c09dac01$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0e6d2da9c09dac01$var$lf.length; e++)$0e6d2da9c09dac01$var$D($0e6d2da9c09dac01$var$lf[e], d);
                            break;
                        case "source":
                            $0e6d2da9c09dac01$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0e6d2da9c09dac01$var$D("error", d);
                            $0e6d2da9c09dac01$var$D("load", d);
                            break;
                        case "details":
                            $0e6d2da9c09dac01$var$D("toggle", d);
                            break;
                        case "input":
                            $0e6d2da9c09dac01$var$Za(d, f);
                            $0e6d2da9c09dac01$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0e6d2da9c09dac01$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0e6d2da9c09dac01$var$hb(d, f), $0e6d2da9c09dac01$var$D("invalid", d);
                    }
                    $0e6d2da9c09dac01$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0e6d2da9c09dac01$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0e6d2da9c09dac01$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0e6d2da9c09dac01$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0e6d2da9c09dac01$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0e6d2da9c09dac01$var$Va(d);
                            $0e6d2da9c09dac01$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0e6d2da9c09dac01$var$Va(d);
                            $0e6d2da9c09dac01$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0e6d2da9c09dac01$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0e6d2da9c09dac01$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0e6d2da9c09dac01$var$Of] = b;
                    a[$0e6d2da9c09dac01$var$Pf] = d;
                    $0e6d2da9c09dac01$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0e6d2da9c09dac01$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0e6d2da9c09dac01$var$D("cancel", a);
                                $0e6d2da9c09dac01$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0e6d2da9c09dac01$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0e6d2da9c09dac01$var$lf.length; e++)$0e6d2da9c09dac01$var$D($0e6d2da9c09dac01$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0e6d2da9c09dac01$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0e6d2da9c09dac01$var$D("error", a);
                                $0e6d2da9c09dac01$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0e6d2da9c09dac01$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0e6d2da9c09dac01$var$Za(a, d);
                                e = $0e6d2da9c09dac01$var$Ya(a, d);
                                $0e6d2da9c09dac01$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0e6d2da9c09dac01$var$A({}, d, {
                                    value: void 0
                                });
                                $0e6d2da9c09dac01$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0e6d2da9c09dac01$var$hb(a, d);
                                e = $0e6d2da9c09dac01$var$gb(a, d);
                                $0e6d2da9c09dac01$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0e6d2da9c09dac01$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0e6d2da9c09dac01$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0e6d2da9c09dac01$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0e6d2da9c09dac01$var$ob(a, k) : "number" === typeof k && $0e6d2da9c09dac01$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0e6d2da9c09dac01$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0e6d2da9c09dac01$var$D("scroll", a) : null != k && $0e6d2da9c09dac01$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0e6d2da9c09dac01$var$Va(a);
                                $0e6d2da9c09dac01$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0e6d2da9c09dac01$var$Va(a);
                                $0e6d2da9c09dac01$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0e6d2da9c09dac01$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0e6d2da9c09dac01$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0e6d2da9c09dac01$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0e6d2da9c09dac01$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0e6d2da9c09dac01$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0e6d2da9c09dac01$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0e6d2da9c09dac01$var$p(166));
                c = $0e6d2da9c09dac01$var$Hh($0e6d2da9c09dac01$var$Gh.current);
                $0e6d2da9c09dac01$var$Hh($0e6d2da9c09dac01$var$Eh.current);
                if ($0e6d2da9c09dac01$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0e6d2da9c09dac01$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0e6d2da9c09dac01$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0e6d2da9c09dac01$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0e6d2da9c09dac01$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0e6d2da9c09dac01$var$Of] = b, b.stateNode = d;
            }
            $0e6d2da9c09dac01$var$S(b);
            return null;
        case 13:
            $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0e6d2da9c09dac01$var$I && null !== $0e6d2da9c09dac01$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0e6d2da9c09dac01$var$Hg(), $0e6d2da9c09dac01$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0e6d2da9c09dac01$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0e6d2da9c09dac01$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0e6d2da9c09dac01$var$p(317));
                        f[$0e6d2da9c09dac01$var$Of] = b;
                    } else $0e6d2da9c09dac01$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0e6d2da9c09dac01$var$S(b);
                    f = !1;
                } else null !== $0e6d2da9c09dac01$var$zg && ($0e6d2da9c09dac01$var$Gj($0e6d2da9c09dac01$var$zg), $0e6d2da9c09dac01$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0e6d2da9c09dac01$var$M.current & 1) ? 0 === $0e6d2da9c09dac01$var$T && ($0e6d2da9c09dac01$var$T = 3) : $0e6d2da9c09dac01$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0e6d2da9c09dac01$var$S(b);
            return null;
        case 4:
            return $0e6d2da9c09dac01$var$Jh(), $0e6d2da9c09dac01$var$Bj(a, b), null === a && $0e6d2da9c09dac01$var$sf(b.stateNode.containerInfo), $0e6d2da9c09dac01$var$S(b), null;
        case 10:
            return $0e6d2da9c09dac01$var$Rg(b.type._context), $0e6d2da9c09dac01$var$S(b), null;
        case 17:
            return $0e6d2da9c09dac01$var$Zf(b.type) && $0e6d2da9c09dac01$var$$f(), $0e6d2da9c09dac01$var$S(b), null;
        case 19:
            $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$M);
            f = b.memoizedState;
            if (null === f) return $0e6d2da9c09dac01$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0e6d2da9c09dac01$var$Ej(f, !1);
                else {
                    if (0 !== $0e6d2da9c09dac01$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0e6d2da9c09dac01$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0e6d2da9c09dac01$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$M, $0e6d2da9c09dac01$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0e6d2da9c09dac01$var$B() > $0e6d2da9c09dac01$var$Hj && (b.flags |= 128, d = !0, $0e6d2da9c09dac01$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0e6d2da9c09dac01$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0e6d2da9c09dac01$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0e6d2da9c09dac01$var$I) return $0e6d2da9c09dac01$var$S(b), null;
                    } else 2 * $0e6d2da9c09dac01$var$B() - f.renderingStartTime > $0e6d2da9c09dac01$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0e6d2da9c09dac01$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0e6d2da9c09dac01$var$B(), b.sibling = null, c = $0e6d2da9c09dac01$var$M.current, $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$M, d ? c & 1 | 2 : c & 1), b;
            $0e6d2da9c09dac01$var$S(b);
            return null;
        case 22:
        case 23:
            return $0e6d2da9c09dac01$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0e6d2da9c09dac01$var$gj & 1073741824) && ($0e6d2da9c09dac01$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0e6d2da9c09dac01$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0e6d2da9c09dac01$var$p(156, b.tag));
}
function $0e6d2da9c09dac01$var$Jj(a, b) {
    $0e6d2da9c09dac01$var$wg(b);
    switch(b.tag){
        case 1:
            return $0e6d2da9c09dac01$var$Zf(b.type) && $0e6d2da9c09dac01$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0e6d2da9c09dac01$var$Jh(), $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$Wf), $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$H), $0e6d2da9c09dac01$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0e6d2da9c09dac01$var$Lh(b), null;
        case 13:
            $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0e6d2da9c09dac01$var$p(340));
                $0e6d2da9c09dac01$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$M), null;
        case 4:
            return $0e6d2da9c09dac01$var$Jh(), null;
        case 10:
            return $0e6d2da9c09dac01$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0e6d2da9c09dac01$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0e6d2da9c09dac01$var$Kj = !1, $0e6d2da9c09dac01$var$U = !1, $0e6d2da9c09dac01$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0e6d2da9c09dac01$var$V = null;
function $0e6d2da9c09dac01$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0e6d2da9c09dac01$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0e6d2da9c09dac01$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0e6d2da9c09dac01$var$W(a, b, d);
    }
}
var $0e6d2da9c09dac01$var$Oj = !1;
function $0e6d2da9c09dac01$var$Pj(a, b) {
    $0e6d2da9c09dac01$var$Cf = $0e6d2da9c09dac01$var$dd;
    a = $0e6d2da9c09dac01$var$Me();
    if ($0e6d2da9c09dac01$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0e6d2da9c09dac01$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0e6d2da9c09dac01$var$dd = !1;
    for($0e6d2da9c09dac01$var$V = b; null !== $0e6d2da9c09dac01$var$V;)if (b = $0e6d2da9c09dac01$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0e6d2da9c09dac01$var$V = a;
    else for(; null !== $0e6d2da9c09dac01$var$V;){
        b = $0e6d2da9c09dac01$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0e6d2da9c09dac01$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0e6d2da9c09dac01$var$p(163));
            }
        } catch (F) {
            $0e6d2da9c09dac01$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0e6d2da9c09dac01$var$V = a;
            break;
        }
        $0e6d2da9c09dac01$var$V = b.return;
    }
    n = $0e6d2da9c09dac01$var$Oj;
    $0e6d2da9c09dac01$var$Oj = !1;
    return n;
}
function $0e6d2da9c09dac01$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0e6d2da9c09dac01$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0e6d2da9c09dac01$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0e6d2da9c09dac01$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0e6d2da9c09dac01$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0e6d2da9c09dac01$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0e6d2da9c09dac01$var$Of], delete b[$0e6d2da9c09dac01$var$Pf], delete b[$0e6d2da9c09dac01$var$of], delete b[$0e6d2da9c09dac01$var$Qf], delete b[$0e6d2da9c09dac01$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0e6d2da9c09dac01$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0e6d2da9c09dac01$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0e6d2da9c09dac01$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0e6d2da9c09dac01$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0e6d2da9c09dac01$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0e6d2da9c09dac01$var$Wj(a, b, c), a = a.sibling; null !== a;)$0e6d2da9c09dac01$var$Wj(a, b, c), a = a.sibling;
}
function $0e6d2da9c09dac01$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0e6d2da9c09dac01$var$Xj(a, b, c), a = a.sibling; null !== a;)$0e6d2da9c09dac01$var$Xj(a, b, c), a = a.sibling;
}
var $0e6d2da9c09dac01$var$X = null, $0e6d2da9c09dac01$var$Yj = !1;
function $0e6d2da9c09dac01$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0e6d2da9c09dac01$var$ak(a, b, c), c = c.sibling;
}
function $0e6d2da9c09dac01$var$ak(a, b, c) {
    if ($0e6d2da9c09dac01$var$lc && "function" === typeof $0e6d2da9c09dac01$var$lc.onCommitFiberUnmount) try {
        $0e6d2da9c09dac01$var$lc.onCommitFiberUnmount($0e6d2da9c09dac01$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0e6d2da9c09dac01$var$U || $0e6d2da9c09dac01$var$Mj(c, b);
        case 6:
            var d = $0e6d2da9c09dac01$var$X, e = $0e6d2da9c09dac01$var$Yj;
            $0e6d2da9c09dac01$var$X = null;
            $0e6d2da9c09dac01$var$Zj(a, b, c);
            $0e6d2da9c09dac01$var$X = d;
            $0e6d2da9c09dac01$var$Yj = e;
            null !== $0e6d2da9c09dac01$var$X && ($0e6d2da9c09dac01$var$Yj ? (a = $0e6d2da9c09dac01$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0e6d2da9c09dac01$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0e6d2da9c09dac01$var$X && ($0e6d2da9c09dac01$var$Yj ? (a = $0e6d2da9c09dac01$var$X, c = c.stateNode, 8 === a.nodeType ? $0e6d2da9c09dac01$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0e6d2da9c09dac01$var$Kf(a, c), $0e6d2da9c09dac01$var$bd(a)) : $0e6d2da9c09dac01$var$Kf($0e6d2da9c09dac01$var$X, c.stateNode));
            break;
        case 4:
            d = $0e6d2da9c09dac01$var$X;
            e = $0e6d2da9c09dac01$var$Yj;
            $0e6d2da9c09dac01$var$X = c.stateNode.containerInfo;
            $0e6d2da9c09dac01$var$Yj = !0;
            $0e6d2da9c09dac01$var$Zj(a, b, c);
            $0e6d2da9c09dac01$var$X = d;
            $0e6d2da9c09dac01$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0e6d2da9c09dac01$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0e6d2da9c09dac01$var$Nj(c, b, g) : 0 !== (f & 4) && $0e6d2da9c09dac01$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0e6d2da9c09dac01$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0e6d2da9c09dac01$var$U && ($0e6d2da9c09dac01$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0e6d2da9c09dac01$var$W(c, b, h);
            }
            $0e6d2da9c09dac01$var$Zj(a, b, c);
            break;
        case 21:
            $0e6d2da9c09dac01$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0e6d2da9c09dac01$var$U = (d = $0e6d2da9c09dac01$var$U) || null !== c.memoizedState, $0e6d2da9c09dac01$var$Zj(a, b, c), $0e6d2da9c09dac01$var$U = d) : $0e6d2da9c09dac01$var$Zj(a, b, c);
            break;
        default:
            $0e6d2da9c09dac01$var$Zj(a, b, c);
    }
}
function $0e6d2da9c09dac01$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0e6d2da9c09dac01$var$Lj);
        b.forEach(function(b) {
            var d = $0e6d2da9c09dac01$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0e6d2da9c09dac01$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0e6d2da9c09dac01$var$X = h.stateNode;
                        $0e6d2da9c09dac01$var$Yj = !1;
                        break a;
                    case 3:
                        $0e6d2da9c09dac01$var$X = h.stateNode.containerInfo;
                        $0e6d2da9c09dac01$var$Yj = !0;
                        break a;
                    case 4:
                        $0e6d2da9c09dac01$var$X = h.stateNode.containerInfo;
                        $0e6d2da9c09dac01$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0e6d2da9c09dac01$var$X) throw Error($0e6d2da9c09dac01$var$p(160));
            $0e6d2da9c09dac01$var$ak(f, g, e);
            $0e6d2da9c09dac01$var$X = null;
            $0e6d2da9c09dac01$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0e6d2da9c09dac01$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0e6d2da9c09dac01$var$ek(b, a), b = b.sibling;
}
function $0e6d2da9c09dac01$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0e6d2da9c09dac01$var$dk(b, a);
            $0e6d2da9c09dac01$var$fk(a);
            if (d & 4) {
                try {
                    $0e6d2da9c09dac01$var$Qj(3, a, a.return), $0e6d2da9c09dac01$var$Rj(3, a);
                } catch (t) {
                    $0e6d2da9c09dac01$var$W(a, a.return, t);
                }
                try {
                    $0e6d2da9c09dac01$var$Qj(5, a, a.return);
                } catch (t) {
                    $0e6d2da9c09dac01$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0e6d2da9c09dac01$var$dk(b, a);
            $0e6d2da9c09dac01$var$fk(a);
            d & 512 && null !== c && $0e6d2da9c09dac01$var$Mj(c, c.return);
            break;
        case 5:
            $0e6d2da9c09dac01$var$dk(b, a);
            $0e6d2da9c09dac01$var$fk(a);
            d & 512 && null !== c && $0e6d2da9c09dac01$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0e6d2da9c09dac01$var$ob(e, "");
                } catch (t) {
                    $0e6d2da9c09dac01$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0e6d2da9c09dac01$var$ab(e, f);
                    $0e6d2da9c09dac01$var$vb(h, g);
                    var l = $0e6d2da9c09dac01$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0e6d2da9c09dac01$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0e6d2da9c09dac01$var$nb(e, q) : "children" === m ? $0e6d2da9c09dac01$var$ob(e, q) : $0e6d2da9c09dac01$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0e6d2da9c09dac01$var$bb(e, f);
                            break;
                        case "textarea":
                            $0e6d2da9c09dac01$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0e6d2da9c09dac01$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0e6d2da9c09dac01$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0e6d2da9c09dac01$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0e6d2da9c09dac01$var$Pf] = f;
                } catch (t) {
                    $0e6d2da9c09dac01$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0e6d2da9c09dac01$var$dk(b, a);
            $0e6d2da9c09dac01$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0e6d2da9c09dac01$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0e6d2da9c09dac01$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0e6d2da9c09dac01$var$dk(b, a);
            $0e6d2da9c09dac01$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0e6d2da9c09dac01$var$bd(b.containerInfo);
            } catch (t) {
                $0e6d2da9c09dac01$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0e6d2da9c09dac01$var$dk(b, a);
            $0e6d2da9c09dac01$var$fk(a);
            break;
        case 13:
            $0e6d2da9c09dac01$var$dk(b, a);
            $0e6d2da9c09dac01$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0e6d2da9c09dac01$var$gk = $0e6d2da9c09dac01$var$B()));
            d & 4 && $0e6d2da9c09dac01$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0e6d2da9c09dac01$var$U = (l = $0e6d2da9c09dac01$var$U) || m, $0e6d2da9c09dac01$var$dk(b, a), $0e6d2da9c09dac01$var$U = l) : $0e6d2da9c09dac01$var$dk(b, a);
            $0e6d2da9c09dac01$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0e6d2da9c09dac01$var$V = a, m = a.child; null !== m;){
                    for(q = $0e6d2da9c09dac01$var$V = m; null !== $0e6d2da9c09dac01$var$V;){
                        r = $0e6d2da9c09dac01$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0e6d2da9c09dac01$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0e6d2da9c09dac01$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0e6d2da9c09dac01$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0e6d2da9c09dac01$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0e6d2da9c09dac01$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0e6d2da9c09dac01$var$V = y) : $0e6d2da9c09dac01$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0e6d2da9c09dac01$var$rb("display", g));
                            } catch (t) {
                                $0e6d2da9c09dac01$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0e6d2da9c09dac01$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0e6d2da9c09dac01$var$dk(b, a);
            $0e6d2da9c09dac01$var$fk(a);
            d & 4 && $0e6d2da9c09dac01$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0e6d2da9c09dac01$var$dk(b, a), $0e6d2da9c09dac01$var$fk(a);
    }
}
function $0e6d2da9c09dac01$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0e6d2da9c09dac01$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0e6d2da9c09dac01$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0e6d2da9c09dac01$var$ob(e, ""), d.flags &= -33);
                    var f = $0e6d2da9c09dac01$var$Vj(a);
                    $0e6d2da9c09dac01$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0e6d2da9c09dac01$var$Vj(a);
                    $0e6d2da9c09dac01$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0e6d2da9c09dac01$var$p(161));
            }
        } catch (k) {
            $0e6d2da9c09dac01$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0e6d2da9c09dac01$var$ik(a, b, c) {
    $0e6d2da9c09dac01$var$V = a;
    $0e6d2da9c09dac01$var$jk(a, b, c);
}
function $0e6d2da9c09dac01$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0e6d2da9c09dac01$var$V;){
        var e = $0e6d2da9c09dac01$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0e6d2da9c09dac01$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0e6d2da9c09dac01$var$U;
                h = $0e6d2da9c09dac01$var$Kj;
                var l = $0e6d2da9c09dac01$var$U;
                $0e6d2da9c09dac01$var$Kj = g;
                if (($0e6d2da9c09dac01$var$U = k) && !l) for($0e6d2da9c09dac01$var$V = e; null !== $0e6d2da9c09dac01$var$V;)g = $0e6d2da9c09dac01$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0e6d2da9c09dac01$var$kk(e) : null !== k ? (k.return = g, $0e6d2da9c09dac01$var$V = k) : $0e6d2da9c09dac01$var$kk(e);
                for(; null !== f;)$0e6d2da9c09dac01$var$V = f, $0e6d2da9c09dac01$var$jk(f, b, c), f = f.sibling;
                $0e6d2da9c09dac01$var$V = e;
                $0e6d2da9c09dac01$var$Kj = h;
                $0e6d2da9c09dac01$var$U = l;
            }
            $0e6d2da9c09dac01$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0e6d2da9c09dac01$var$V = f) : $0e6d2da9c09dac01$var$lk(a, b, c);
    }
}
function $0e6d2da9c09dac01$var$lk(a) {
    for(; null !== $0e6d2da9c09dac01$var$V;){
        var b = $0e6d2da9c09dac01$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0e6d2da9c09dac01$var$U || $0e6d2da9c09dac01$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0e6d2da9c09dac01$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0e6d2da9c09dac01$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0e6d2da9c09dac01$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0e6d2da9c09dac01$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0e6d2da9c09dac01$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0e6d2da9c09dac01$var$p(163));
                }
                $0e6d2da9c09dac01$var$U || b.flags & 512 && $0e6d2da9c09dac01$var$Sj(b);
            } catch (r) {
                $0e6d2da9c09dac01$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0e6d2da9c09dac01$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0e6d2da9c09dac01$var$V = c;
            break;
        }
        $0e6d2da9c09dac01$var$V = b.return;
    }
}
function $0e6d2da9c09dac01$var$hk(a) {
    for(; null !== $0e6d2da9c09dac01$var$V;){
        var b = $0e6d2da9c09dac01$var$V;
        if (b === a) {
            $0e6d2da9c09dac01$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0e6d2da9c09dac01$var$V = c;
            break;
        }
        $0e6d2da9c09dac01$var$V = b.return;
    }
}
function $0e6d2da9c09dac01$var$kk(a) {
    for(; null !== $0e6d2da9c09dac01$var$V;){
        var b = $0e6d2da9c09dac01$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0e6d2da9c09dac01$var$Rj(4, b);
                    } catch (k) {
                        $0e6d2da9c09dac01$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0e6d2da9c09dac01$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0e6d2da9c09dac01$var$Sj(b);
                    } catch (k) {
                        $0e6d2da9c09dac01$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0e6d2da9c09dac01$var$Sj(b);
                    } catch (k) {
                        $0e6d2da9c09dac01$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0e6d2da9c09dac01$var$W(b, b.return, k);
        }
        if (b === a) {
            $0e6d2da9c09dac01$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0e6d2da9c09dac01$var$V = h;
            break;
        }
        $0e6d2da9c09dac01$var$V = b.return;
    }
}
var $0e6d2da9c09dac01$var$mk = Math.ceil, $0e6d2da9c09dac01$var$nk = $0e6d2da9c09dac01$var$ua.ReactCurrentDispatcher, $0e6d2da9c09dac01$var$ok = $0e6d2da9c09dac01$var$ua.ReactCurrentOwner, $0e6d2da9c09dac01$var$pk = $0e6d2da9c09dac01$var$ua.ReactCurrentBatchConfig, $0e6d2da9c09dac01$var$K = 0, $0e6d2da9c09dac01$var$R = null, $0e6d2da9c09dac01$var$Y = null, $0e6d2da9c09dac01$var$Z = 0, $0e6d2da9c09dac01$var$gj = 0, $0e6d2da9c09dac01$var$fj = $0e6d2da9c09dac01$var$Uf(0), $0e6d2da9c09dac01$var$T = 0, $0e6d2da9c09dac01$var$qk = null, $0e6d2da9c09dac01$var$hh = 0, $0e6d2da9c09dac01$var$rk = 0, $0e6d2da9c09dac01$var$sk = 0, $0e6d2da9c09dac01$var$tk = null, $0e6d2da9c09dac01$var$uk = null, $0e6d2da9c09dac01$var$gk = 0, $0e6d2da9c09dac01$var$Hj = Infinity, $0e6d2da9c09dac01$var$vk = null, $0e6d2da9c09dac01$var$Pi = !1, $0e6d2da9c09dac01$var$Qi = null, $0e6d2da9c09dac01$var$Si = null, $0e6d2da9c09dac01$var$wk = !1, $0e6d2da9c09dac01$var$xk = null, $0e6d2da9c09dac01$var$yk = 0, $0e6d2da9c09dac01$var$zk = 0, $0e6d2da9c09dac01$var$Ak = null, $0e6d2da9c09dac01$var$Bk = -1, $0e6d2da9c09dac01$var$Ck = 0;
function $0e6d2da9c09dac01$var$L() {
    return 0 !== ($0e6d2da9c09dac01$var$K & 6) ? $0e6d2da9c09dac01$var$B() : -1 !== $0e6d2da9c09dac01$var$Bk ? $0e6d2da9c09dac01$var$Bk : $0e6d2da9c09dac01$var$Bk = $0e6d2da9c09dac01$var$B();
}
function $0e6d2da9c09dac01$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0e6d2da9c09dac01$var$K & 2) && 0 !== $0e6d2da9c09dac01$var$Z) return $0e6d2da9c09dac01$var$Z & -$0e6d2da9c09dac01$var$Z;
    if (null !== $0e6d2da9c09dac01$var$Kg.transition) return 0 === $0e6d2da9c09dac01$var$Ck && ($0e6d2da9c09dac01$var$Ck = $0e6d2da9c09dac01$var$yc()), $0e6d2da9c09dac01$var$Ck;
    a = $0e6d2da9c09dac01$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0e6d2da9c09dac01$var$jd(a.type);
    return a;
}
function $0e6d2da9c09dac01$var$mh(a, b, c, d) {
    if (50 < $0e6d2da9c09dac01$var$zk) throw $0e6d2da9c09dac01$var$zk = 0, $0e6d2da9c09dac01$var$Ak = null, Error($0e6d2da9c09dac01$var$p(185));
    $0e6d2da9c09dac01$var$Ac(a, c, d);
    if (0 === ($0e6d2da9c09dac01$var$K & 2) || a !== $0e6d2da9c09dac01$var$R) a === $0e6d2da9c09dac01$var$R && (0 === ($0e6d2da9c09dac01$var$K & 2) && ($0e6d2da9c09dac01$var$rk |= c), 4 === $0e6d2da9c09dac01$var$T && $0e6d2da9c09dac01$var$Dk(a, $0e6d2da9c09dac01$var$Z)), $0e6d2da9c09dac01$var$Ek(a, d), 1 === c && 0 === $0e6d2da9c09dac01$var$K && 0 === (b.mode & 1) && ($0e6d2da9c09dac01$var$Hj = $0e6d2da9c09dac01$var$B() + 500, $0e6d2da9c09dac01$var$fg && $0e6d2da9c09dac01$var$jg());
}
function $0e6d2da9c09dac01$var$Ek(a, b) {
    var c = a.callbackNode;
    $0e6d2da9c09dac01$var$wc(a, b);
    var d = $0e6d2da9c09dac01$var$uc(a, a === $0e6d2da9c09dac01$var$R ? $0e6d2da9c09dac01$var$Z : 0);
    if (0 === d) null !== c && $0e6d2da9c09dac01$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0e6d2da9c09dac01$var$bc(c);
        if (1 === b) 0 === a.tag ? $0e6d2da9c09dac01$var$ig($0e6d2da9c09dac01$var$Fk.bind(null, a)) : $0e6d2da9c09dac01$var$hg($0e6d2da9c09dac01$var$Fk.bind(null, a)), $0e6d2da9c09dac01$var$Jf(function() {
            0 === ($0e6d2da9c09dac01$var$K & 6) && $0e6d2da9c09dac01$var$jg();
        }), c = null;
        else {
            switch($0e6d2da9c09dac01$var$Dc(d)){
                case 1:
                    c = $0e6d2da9c09dac01$var$fc;
                    break;
                case 4:
                    c = $0e6d2da9c09dac01$var$gc;
                    break;
                case 16:
                    c = $0e6d2da9c09dac01$var$hc;
                    break;
                case 536870912:
                    c = $0e6d2da9c09dac01$var$jc;
                    break;
                default:
                    c = $0e6d2da9c09dac01$var$hc;
            }
            c = $0e6d2da9c09dac01$var$Gk(c, $0e6d2da9c09dac01$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0e6d2da9c09dac01$var$Hk(a, b) {
    $0e6d2da9c09dac01$var$Bk = -1;
    $0e6d2da9c09dac01$var$Ck = 0;
    if (0 !== ($0e6d2da9c09dac01$var$K & 6)) throw Error($0e6d2da9c09dac01$var$p(327));
    var c = a.callbackNode;
    if ($0e6d2da9c09dac01$var$Ik() && a.callbackNode !== c) return null;
    var d = $0e6d2da9c09dac01$var$uc(a, a === $0e6d2da9c09dac01$var$R ? $0e6d2da9c09dac01$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0e6d2da9c09dac01$var$Jk(a, d);
    else {
        b = d;
        var e = $0e6d2da9c09dac01$var$K;
        $0e6d2da9c09dac01$var$K |= 2;
        var f = $0e6d2da9c09dac01$var$Kk();
        if ($0e6d2da9c09dac01$var$R !== a || $0e6d2da9c09dac01$var$Z !== b) $0e6d2da9c09dac01$var$vk = null, $0e6d2da9c09dac01$var$Hj = $0e6d2da9c09dac01$var$B() + 500, $0e6d2da9c09dac01$var$Lk(a, b);
        for(;;)try {
            $0e6d2da9c09dac01$var$Mk();
            break;
        } catch (h) {
            $0e6d2da9c09dac01$var$Nk(a, h);
        }
        $0e6d2da9c09dac01$var$Qg();
        $0e6d2da9c09dac01$var$nk.current = f;
        $0e6d2da9c09dac01$var$K = e;
        null !== $0e6d2da9c09dac01$var$Y ? b = 0 : ($0e6d2da9c09dac01$var$R = null, $0e6d2da9c09dac01$var$Z = 0, b = $0e6d2da9c09dac01$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0e6d2da9c09dac01$var$xc(a), 0 !== e && (d = e, b = $0e6d2da9c09dac01$var$Ok(a, e)));
        if (1 === b) throw c = $0e6d2da9c09dac01$var$qk, $0e6d2da9c09dac01$var$Lk(a, 0), $0e6d2da9c09dac01$var$Dk(a, d), $0e6d2da9c09dac01$var$Ek(a, $0e6d2da9c09dac01$var$B()), c;
        if (6 === b) $0e6d2da9c09dac01$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0e6d2da9c09dac01$var$Pk(e) && (b = $0e6d2da9c09dac01$var$Jk(a, d), 2 === b && (f = $0e6d2da9c09dac01$var$xc(a), 0 !== f && (d = f, b = $0e6d2da9c09dac01$var$Ok(a, f))), 1 === b)) throw c = $0e6d2da9c09dac01$var$qk, $0e6d2da9c09dac01$var$Lk(a, 0), $0e6d2da9c09dac01$var$Dk(a, d), $0e6d2da9c09dac01$var$Ek(a, $0e6d2da9c09dac01$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0e6d2da9c09dac01$var$p(345));
                case 2:
                    $0e6d2da9c09dac01$var$Qk(a, $0e6d2da9c09dac01$var$uk, $0e6d2da9c09dac01$var$vk);
                    break;
                case 3:
                    $0e6d2da9c09dac01$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0e6d2da9c09dac01$var$gk + 500 - $0e6d2da9c09dac01$var$B(), 10 < b)) {
                        if (0 !== $0e6d2da9c09dac01$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0e6d2da9c09dac01$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0e6d2da9c09dac01$var$Ff($0e6d2da9c09dac01$var$Qk.bind(null, a, $0e6d2da9c09dac01$var$uk, $0e6d2da9c09dac01$var$vk), b);
                        break;
                    }
                    $0e6d2da9c09dac01$var$Qk(a, $0e6d2da9c09dac01$var$uk, $0e6d2da9c09dac01$var$vk);
                    break;
                case 4:
                    $0e6d2da9c09dac01$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0e6d2da9c09dac01$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0e6d2da9c09dac01$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0e6d2da9c09dac01$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0e6d2da9c09dac01$var$Ff($0e6d2da9c09dac01$var$Qk.bind(null, a, $0e6d2da9c09dac01$var$uk, $0e6d2da9c09dac01$var$vk), d);
                        break;
                    }
                    $0e6d2da9c09dac01$var$Qk(a, $0e6d2da9c09dac01$var$uk, $0e6d2da9c09dac01$var$vk);
                    break;
                case 5:
                    $0e6d2da9c09dac01$var$Qk(a, $0e6d2da9c09dac01$var$uk, $0e6d2da9c09dac01$var$vk);
                    break;
                default:
                    throw Error($0e6d2da9c09dac01$var$p(329));
            }
        }
    }
    $0e6d2da9c09dac01$var$Ek(a, $0e6d2da9c09dac01$var$B());
    return a.callbackNode === c ? $0e6d2da9c09dac01$var$Hk.bind(null, a) : null;
}
function $0e6d2da9c09dac01$var$Ok(a, b) {
    var c = $0e6d2da9c09dac01$var$tk;
    a.current.memoizedState.isDehydrated && ($0e6d2da9c09dac01$var$Lk(a, b).flags |= 256);
    a = $0e6d2da9c09dac01$var$Jk(a, b);
    2 !== a && (b = $0e6d2da9c09dac01$var$uk, $0e6d2da9c09dac01$var$uk = c, null !== b && $0e6d2da9c09dac01$var$Gj(b));
    return a;
}
function $0e6d2da9c09dac01$var$Gj(a) {
    null === $0e6d2da9c09dac01$var$uk ? $0e6d2da9c09dac01$var$uk = a : $0e6d2da9c09dac01$var$uk.push.apply($0e6d2da9c09dac01$var$uk, a);
}
function $0e6d2da9c09dac01$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0e6d2da9c09dac01$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0e6d2da9c09dac01$var$Dk(a, b) {
    b &= ~$0e6d2da9c09dac01$var$sk;
    b &= ~$0e6d2da9c09dac01$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0e6d2da9c09dac01$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0e6d2da9c09dac01$var$Fk(a) {
    if (0 !== ($0e6d2da9c09dac01$var$K & 6)) throw Error($0e6d2da9c09dac01$var$p(327));
    $0e6d2da9c09dac01$var$Ik();
    var b = $0e6d2da9c09dac01$var$uc(a, 0);
    if (0 === (b & 1)) return $0e6d2da9c09dac01$var$Ek(a, $0e6d2da9c09dac01$var$B()), null;
    var c = $0e6d2da9c09dac01$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0e6d2da9c09dac01$var$xc(a);
        0 !== d && (b = d, c = $0e6d2da9c09dac01$var$Ok(a, d));
    }
    if (1 === c) throw c = $0e6d2da9c09dac01$var$qk, $0e6d2da9c09dac01$var$Lk(a, 0), $0e6d2da9c09dac01$var$Dk(a, b), $0e6d2da9c09dac01$var$Ek(a, $0e6d2da9c09dac01$var$B()), c;
    if (6 === c) throw Error($0e6d2da9c09dac01$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0e6d2da9c09dac01$var$Qk(a, $0e6d2da9c09dac01$var$uk, $0e6d2da9c09dac01$var$vk);
    $0e6d2da9c09dac01$var$Ek(a, $0e6d2da9c09dac01$var$B());
    return null;
}
function $0e6d2da9c09dac01$var$Rk(a, b) {
    var c = $0e6d2da9c09dac01$var$K;
    $0e6d2da9c09dac01$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0e6d2da9c09dac01$var$K = c, 0 === $0e6d2da9c09dac01$var$K && ($0e6d2da9c09dac01$var$Hj = $0e6d2da9c09dac01$var$B() + 500, $0e6d2da9c09dac01$var$fg && $0e6d2da9c09dac01$var$jg());
    }
}
function $0e6d2da9c09dac01$var$Sk(a) {
    null !== $0e6d2da9c09dac01$var$xk && 0 === $0e6d2da9c09dac01$var$xk.tag && 0 === ($0e6d2da9c09dac01$var$K & 6) && $0e6d2da9c09dac01$var$Ik();
    var b = $0e6d2da9c09dac01$var$K;
    $0e6d2da9c09dac01$var$K |= 1;
    var c = $0e6d2da9c09dac01$var$pk.transition, d = $0e6d2da9c09dac01$var$C;
    try {
        if ($0e6d2da9c09dac01$var$pk.transition = null, $0e6d2da9c09dac01$var$C = 1, a) return a();
    } finally{
        $0e6d2da9c09dac01$var$C = d, $0e6d2da9c09dac01$var$pk.transition = c, $0e6d2da9c09dac01$var$K = b, 0 === ($0e6d2da9c09dac01$var$K & 6) && $0e6d2da9c09dac01$var$jg();
    }
}
function $0e6d2da9c09dac01$var$Ij() {
    $0e6d2da9c09dac01$var$gj = $0e6d2da9c09dac01$var$fj.current;
    $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$fj);
}
function $0e6d2da9c09dac01$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0e6d2da9c09dac01$var$Gf(c));
    if (null !== $0e6d2da9c09dac01$var$Y) for(c = $0e6d2da9c09dac01$var$Y.return; null !== c;){
        var d = c;
        $0e6d2da9c09dac01$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0e6d2da9c09dac01$var$$f();
                break;
            case 3:
                $0e6d2da9c09dac01$var$Jh();
                $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$Wf);
                $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$H);
                $0e6d2da9c09dac01$var$Oh();
                break;
            case 5:
                $0e6d2da9c09dac01$var$Lh(d);
                break;
            case 4:
                $0e6d2da9c09dac01$var$Jh();
                break;
            case 13:
                $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$M);
                break;
            case 19:
                $0e6d2da9c09dac01$var$E($0e6d2da9c09dac01$var$M);
                break;
            case 10:
                $0e6d2da9c09dac01$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0e6d2da9c09dac01$var$Ij();
        }
        c = c.return;
    }
    $0e6d2da9c09dac01$var$R = a;
    $0e6d2da9c09dac01$var$Y = a = $0e6d2da9c09dac01$var$wh(a.current, null);
    $0e6d2da9c09dac01$var$Z = $0e6d2da9c09dac01$var$gj = b;
    $0e6d2da9c09dac01$var$T = 0;
    $0e6d2da9c09dac01$var$qk = null;
    $0e6d2da9c09dac01$var$sk = $0e6d2da9c09dac01$var$rk = $0e6d2da9c09dac01$var$hh = 0;
    $0e6d2da9c09dac01$var$uk = $0e6d2da9c09dac01$var$tk = null;
    if (null !== $0e6d2da9c09dac01$var$Wg) {
        for(b = 0; b < $0e6d2da9c09dac01$var$Wg.length; b++)if (c = $0e6d2da9c09dac01$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0e6d2da9c09dac01$var$Wg = null;
    }
    return a;
}
function $0e6d2da9c09dac01$var$Nk(a, b) {
    do {
        var c = $0e6d2da9c09dac01$var$Y;
        try {
            $0e6d2da9c09dac01$var$Qg();
            $0e6d2da9c09dac01$var$Ph.current = $0e6d2da9c09dac01$var$ai;
            if ($0e6d2da9c09dac01$var$Sh) {
                for(var d = $0e6d2da9c09dac01$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0e6d2da9c09dac01$var$Sh = !1;
            }
            $0e6d2da9c09dac01$var$Rh = 0;
            $0e6d2da9c09dac01$var$P = $0e6d2da9c09dac01$var$O = $0e6d2da9c09dac01$var$N = null;
            $0e6d2da9c09dac01$var$Th = !1;
            $0e6d2da9c09dac01$var$Uh = 0;
            $0e6d2da9c09dac01$var$ok.current = null;
            if (null === c || null === c.return) {
                $0e6d2da9c09dac01$var$T = 1;
                $0e6d2da9c09dac01$var$qk = b;
                $0e6d2da9c09dac01$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0e6d2da9c09dac01$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0e6d2da9c09dac01$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0e6d2da9c09dac01$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0e6d2da9c09dac01$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0e6d2da9c09dac01$var$Ti(f, l, b);
                            $0e6d2da9c09dac01$var$uj();
                            break a;
                        }
                        k = Error($0e6d2da9c09dac01$var$p(426));
                    }
                } else if ($0e6d2da9c09dac01$var$I && h.mode & 1) {
                    var J = $0e6d2da9c09dac01$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0e6d2da9c09dac01$var$Wi(J, g, h, f, b);
                        $0e6d2da9c09dac01$var$Jg($0e6d2da9c09dac01$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0e6d2da9c09dac01$var$Ki(k, h);
                4 !== $0e6d2da9c09dac01$var$T && ($0e6d2da9c09dac01$var$T = 2);
                null === $0e6d2da9c09dac01$var$tk ? $0e6d2da9c09dac01$var$tk = [
                    f
                ] : $0e6d2da9c09dac01$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0e6d2da9c09dac01$var$Oi(f, k, b);
                            $0e6d2da9c09dac01$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0e6d2da9c09dac01$var$Si || !$0e6d2da9c09dac01$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0e6d2da9c09dac01$var$Ri(f, h, b);
                                $0e6d2da9c09dac01$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0e6d2da9c09dac01$var$Tk(c);
        } catch (na) {
            b = na;
            $0e6d2da9c09dac01$var$Y === c && null !== c && ($0e6d2da9c09dac01$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0e6d2da9c09dac01$var$Kk() {
    var a = $0e6d2da9c09dac01$var$nk.current;
    $0e6d2da9c09dac01$var$nk.current = $0e6d2da9c09dac01$var$ai;
    return null === a ? $0e6d2da9c09dac01$var$ai : a;
}
function $0e6d2da9c09dac01$var$uj() {
    if (0 === $0e6d2da9c09dac01$var$T || 3 === $0e6d2da9c09dac01$var$T || 2 === $0e6d2da9c09dac01$var$T) $0e6d2da9c09dac01$var$T = 4;
    null === $0e6d2da9c09dac01$var$R || 0 === ($0e6d2da9c09dac01$var$hh & 268435455) && 0 === ($0e6d2da9c09dac01$var$rk & 268435455) || $0e6d2da9c09dac01$var$Dk($0e6d2da9c09dac01$var$R, $0e6d2da9c09dac01$var$Z);
}
function $0e6d2da9c09dac01$var$Jk(a, b) {
    var c = $0e6d2da9c09dac01$var$K;
    $0e6d2da9c09dac01$var$K |= 2;
    var d = $0e6d2da9c09dac01$var$Kk();
    if ($0e6d2da9c09dac01$var$R !== a || $0e6d2da9c09dac01$var$Z !== b) $0e6d2da9c09dac01$var$vk = null, $0e6d2da9c09dac01$var$Lk(a, b);
    for(;;)try {
        $0e6d2da9c09dac01$var$Uk();
        break;
    } catch (e) {
        $0e6d2da9c09dac01$var$Nk(a, e);
    }
    $0e6d2da9c09dac01$var$Qg();
    $0e6d2da9c09dac01$var$K = c;
    $0e6d2da9c09dac01$var$nk.current = d;
    if (null !== $0e6d2da9c09dac01$var$Y) throw Error($0e6d2da9c09dac01$var$p(261));
    $0e6d2da9c09dac01$var$R = null;
    $0e6d2da9c09dac01$var$Z = 0;
    return $0e6d2da9c09dac01$var$T;
}
function $0e6d2da9c09dac01$var$Uk() {
    for(; null !== $0e6d2da9c09dac01$var$Y;)$0e6d2da9c09dac01$var$Vk($0e6d2da9c09dac01$var$Y);
}
function $0e6d2da9c09dac01$var$Mk() {
    for(; null !== $0e6d2da9c09dac01$var$Y && !$0e6d2da9c09dac01$var$cc();)$0e6d2da9c09dac01$var$Vk($0e6d2da9c09dac01$var$Y);
}
function $0e6d2da9c09dac01$var$Vk(a) {
    var b = $0e6d2da9c09dac01$var$Wk(a.alternate, a, $0e6d2da9c09dac01$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0e6d2da9c09dac01$var$Tk(a) : $0e6d2da9c09dac01$var$Y = b;
    $0e6d2da9c09dac01$var$ok.current = null;
}
function $0e6d2da9c09dac01$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0e6d2da9c09dac01$var$Fj(c, b, $0e6d2da9c09dac01$var$gj), null !== c) {
                $0e6d2da9c09dac01$var$Y = c;
                return;
            }
        } else {
            c = $0e6d2da9c09dac01$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0e6d2da9c09dac01$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0e6d2da9c09dac01$var$T = 6;
                $0e6d2da9c09dac01$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0e6d2da9c09dac01$var$Y = b;
            return;
        }
        $0e6d2da9c09dac01$var$Y = b = a;
    }while (null !== b);
    0 === $0e6d2da9c09dac01$var$T && ($0e6d2da9c09dac01$var$T = 5);
}
function $0e6d2da9c09dac01$var$Qk(a, b, c) {
    var d = $0e6d2da9c09dac01$var$C, e = $0e6d2da9c09dac01$var$pk.transition;
    try {
        $0e6d2da9c09dac01$var$pk.transition = null, $0e6d2da9c09dac01$var$C = 1, $0e6d2da9c09dac01$var$Xk(a, b, c, d);
    } finally{
        $0e6d2da9c09dac01$var$pk.transition = e, $0e6d2da9c09dac01$var$C = d;
    }
    return null;
}
function $0e6d2da9c09dac01$var$Xk(a, b, c, d) {
    do $0e6d2da9c09dac01$var$Ik();
    while (null !== $0e6d2da9c09dac01$var$xk);
    if (0 !== ($0e6d2da9c09dac01$var$K & 6)) throw Error($0e6d2da9c09dac01$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0e6d2da9c09dac01$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0e6d2da9c09dac01$var$Bc(a, f);
    a === $0e6d2da9c09dac01$var$R && ($0e6d2da9c09dac01$var$Y = $0e6d2da9c09dac01$var$R = null, $0e6d2da9c09dac01$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0e6d2da9c09dac01$var$wk || ($0e6d2da9c09dac01$var$wk = !0, $0e6d2da9c09dac01$var$Gk($0e6d2da9c09dac01$var$hc, function() {
        $0e6d2da9c09dac01$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0e6d2da9c09dac01$var$pk.transition;
        $0e6d2da9c09dac01$var$pk.transition = null;
        var g = $0e6d2da9c09dac01$var$C;
        $0e6d2da9c09dac01$var$C = 1;
        var h = $0e6d2da9c09dac01$var$K;
        $0e6d2da9c09dac01$var$K |= 4;
        $0e6d2da9c09dac01$var$ok.current = null;
        $0e6d2da9c09dac01$var$Pj(a, c);
        $0e6d2da9c09dac01$var$ek(c, a);
        $0e6d2da9c09dac01$var$Oe($0e6d2da9c09dac01$var$Df);
        $0e6d2da9c09dac01$var$dd = !!$0e6d2da9c09dac01$var$Cf;
        $0e6d2da9c09dac01$var$Df = $0e6d2da9c09dac01$var$Cf = null;
        a.current = c;
        $0e6d2da9c09dac01$var$ik(c, a, e);
        $0e6d2da9c09dac01$var$dc();
        $0e6d2da9c09dac01$var$K = h;
        $0e6d2da9c09dac01$var$C = g;
        $0e6d2da9c09dac01$var$pk.transition = f;
    } else a.current = c;
    $0e6d2da9c09dac01$var$wk && ($0e6d2da9c09dac01$var$wk = !1, $0e6d2da9c09dac01$var$xk = a, $0e6d2da9c09dac01$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0e6d2da9c09dac01$var$Si = null);
    $0e6d2da9c09dac01$var$mc(c.stateNode, d);
    $0e6d2da9c09dac01$var$Ek(a, $0e6d2da9c09dac01$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0e6d2da9c09dac01$var$Pi) throw $0e6d2da9c09dac01$var$Pi = !1, a = $0e6d2da9c09dac01$var$Qi, $0e6d2da9c09dac01$var$Qi = null, a;
    0 !== ($0e6d2da9c09dac01$var$yk & 1) && 0 !== a.tag && $0e6d2da9c09dac01$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0e6d2da9c09dac01$var$Ak ? $0e6d2da9c09dac01$var$zk++ : ($0e6d2da9c09dac01$var$zk = 0, $0e6d2da9c09dac01$var$Ak = a) : $0e6d2da9c09dac01$var$zk = 0;
    $0e6d2da9c09dac01$var$jg();
    return null;
}
function $0e6d2da9c09dac01$var$Ik() {
    if (null !== $0e6d2da9c09dac01$var$xk) {
        var a = $0e6d2da9c09dac01$var$Dc($0e6d2da9c09dac01$var$yk), b = $0e6d2da9c09dac01$var$pk.transition, c = $0e6d2da9c09dac01$var$C;
        try {
            $0e6d2da9c09dac01$var$pk.transition = null;
            $0e6d2da9c09dac01$var$C = 16 > a ? 16 : a;
            if (null === $0e6d2da9c09dac01$var$xk) var d = !1;
            else {
                a = $0e6d2da9c09dac01$var$xk;
                $0e6d2da9c09dac01$var$xk = null;
                $0e6d2da9c09dac01$var$yk = 0;
                if (0 !== ($0e6d2da9c09dac01$var$K & 6)) throw Error($0e6d2da9c09dac01$var$p(331));
                var e = $0e6d2da9c09dac01$var$K;
                $0e6d2da9c09dac01$var$K |= 4;
                for($0e6d2da9c09dac01$var$V = a.current; null !== $0e6d2da9c09dac01$var$V;){
                    var f = $0e6d2da9c09dac01$var$V, g = f.child;
                    if (0 !== ($0e6d2da9c09dac01$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0e6d2da9c09dac01$var$V = l; null !== $0e6d2da9c09dac01$var$V;){
                                    var m = $0e6d2da9c09dac01$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0e6d2da9c09dac01$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0e6d2da9c09dac01$var$V = q;
                                    else for(; null !== $0e6d2da9c09dac01$var$V;){
                                        m = $0e6d2da9c09dac01$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0e6d2da9c09dac01$var$Tj(m);
                                        if (m === l) {
                                            $0e6d2da9c09dac01$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0e6d2da9c09dac01$var$V = r;
                                            break;
                                        }
                                        $0e6d2da9c09dac01$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0e6d2da9c09dac01$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0e6d2da9c09dac01$var$V = g;
                    else b: for(; null !== $0e6d2da9c09dac01$var$V;){
                        f = $0e6d2da9c09dac01$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0e6d2da9c09dac01$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0e6d2da9c09dac01$var$V = x;
                            break b;
                        }
                        $0e6d2da9c09dac01$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0e6d2da9c09dac01$var$V = w; null !== $0e6d2da9c09dac01$var$V;){
                    g = $0e6d2da9c09dac01$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0e6d2da9c09dac01$var$V = u;
                    else b: for(g = w; null !== $0e6d2da9c09dac01$var$V;){
                        h = $0e6d2da9c09dac01$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0e6d2da9c09dac01$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0e6d2da9c09dac01$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0e6d2da9c09dac01$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0e6d2da9c09dac01$var$V = F;
                            break b;
                        }
                        $0e6d2da9c09dac01$var$V = h.return;
                    }
                }
                $0e6d2da9c09dac01$var$K = e;
                $0e6d2da9c09dac01$var$jg();
                if ($0e6d2da9c09dac01$var$lc && "function" === typeof $0e6d2da9c09dac01$var$lc.onPostCommitFiberRoot) try {
                    $0e6d2da9c09dac01$var$lc.onPostCommitFiberRoot($0e6d2da9c09dac01$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0e6d2da9c09dac01$var$C = c, $0e6d2da9c09dac01$var$pk.transition = b;
        }
    }
    return !1;
}
function $0e6d2da9c09dac01$var$Yk(a, b, c) {
    b = $0e6d2da9c09dac01$var$Ki(c, b);
    b = $0e6d2da9c09dac01$var$Oi(a, b, 1);
    a = $0e6d2da9c09dac01$var$dh(a, b, 1);
    b = $0e6d2da9c09dac01$var$L();
    null !== a && ($0e6d2da9c09dac01$var$Ac(a, 1, b), $0e6d2da9c09dac01$var$Ek(a, b));
}
function $0e6d2da9c09dac01$var$W(a, b, c) {
    if (3 === a.tag) $0e6d2da9c09dac01$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0e6d2da9c09dac01$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0e6d2da9c09dac01$var$Si || !$0e6d2da9c09dac01$var$Si.has(d))) {
                a = $0e6d2da9c09dac01$var$Ki(c, a);
                a = $0e6d2da9c09dac01$var$Ri(b, a, 1);
                b = $0e6d2da9c09dac01$var$dh(b, a, 1);
                a = $0e6d2da9c09dac01$var$L();
                null !== b && ($0e6d2da9c09dac01$var$Ac(b, 1, a), $0e6d2da9c09dac01$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0e6d2da9c09dac01$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0e6d2da9c09dac01$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0e6d2da9c09dac01$var$R === a && ($0e6d2da9c09dac01$var$Z & c) === c && (4 === $0e6d2da9c09dac01$var$T || 3 === $0e6d2da9c09dac01$var$T && ($0e6d2da9c09dac01$var$Z & 130023424) === $0e6d2da9c09dac01$var$Z && 500 > $0e6d2da9c09dac01$var$B() - $0e6d2da9c09dac01$var$gk ? $0e6d2da9c09dac01$var$Lk(a, 0) : $0e6d2da9c09dac01$var$sk |= c);
    $0e6d2da9c09dac01$var$Ek(a, b);
}
function $0e6d2da9c09dac01$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0e6d2da9c09dac01$var$sc, $0e6d2da9c09dac01$var$sc <<= 1, 0 === ($0e6d2da9c09dac01$var$sc & 130023424) && ($0e6d2da9c09dac01$var$sc = 4194304)));
    var c = $0e6d2da9c09dac01$var$L();
    a = $0e6d2da9c09dac01$var$Zg(a, b);
    null !== a && ($0e6d2da9c09dac01$var$Ac(a, b, c), $0e6d2da9c09dac01$var$Ek(a, c));
}
function $0e6d2da9c09dac01$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0e6d2da9c09dac01$var$Zk(a, c);
}
function $0e6d2da9c09dac01$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0e6d2da9c09dac01$var$p(314));
    }
    null !== d && d.delete(b);
    $0e6d2da9c09dac01$var$Zk(a, c);
}
var $0e6d2da9c09dac01$var$Wk;
$0e6d2da9c09dac01$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0e6d2da9c09dac01$var$Wf.current) $0e6d2da9c09dac01$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0e6d2da9c09dac01$var$Ug = !1, $0e6d2da9c09dac01$var$zj(a, b, c);
            $0e6d2da9c09dac01$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0e6d2da9c09dac01$var$Ug = !1, $0e6d2da9c09dac01$var$I && 0 !== (b.flags & 1048576) && $0e6d2da9c09dac01$var$ug(b, $0e6d2da9c09dac01$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0e6d2da9c09dac01$var$jj(a, b);
            a = b.pendingProps;
            var e = $0e6d2da9c09dac01$var$Yf(b, $0e6d2da9c09dac01$var$H.current);
            $0e6d2da9c09dac01$var$Tg(b, c);
            e = $0e6d2da9c09dac01$var$Xh(null, b, d, a, e, c);
            var f = $0e6d2da9c09dac01$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0e6d2da9c09dac01$var$Zf(d) ? (f = !0, $0e6d2da9c09dac01$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0e6d2da9c09dac01$var$ah(b), e.updater = $0e6d2da9c09dac01$var$nh, b.stateNode = e, e._reactInternals = b, $0e6d2da9c09dac01$var$rh(b, d, a, c), b = $0e6d2da9c09dac01$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0e6d2da9c09dac01$var$I && f && $0e6d2da9c09dac01$var$vg(b), $0e6d2da9c09dac01$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0e6d2da9c09dac01$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0e6d2da9c09dac01$var$$k(d);
                a = $0e6d2da9c09dac01$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0e6d2da9c09dac01$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0e6d2da9c09dac01$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0e6d2da9c09dac01$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0e6d2da9c09dac01$var$aj(null, b, d, $0e6d2da9c09dac01$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0e6d2da9c09dac01$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0e6d2da9c09dac01$var$Lg(d, e), $0e6d2da9c09dac01$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0e6d2da9c09dac01$var$Lg(d, e), $0e6d2da9c09dac01$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0e6d2da9c09dac01$var$lj(b);
                if (null === a) throw Error($0e6d2da9c09dac01$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0e6d2da9c09dac01$var$bh(a, b);
                $0e6d2da9c09dac01$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0e6d2da9c09dac01$var$Ki(Error($0e6d2da9c09dac01$var$p(423)), b);
                        b = $0e6d2da9c09dac01$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0e6d2da9c09dac01$var$Ki(Error($0e6d2da9c09dac01$var$p(424)), b);
                        b = $0e6d2da9c09dac01$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0e6d2da9c09dac01$var$yg = $0e6d2da9c09dac01$var$Lf(b.stateNode.containerInfo.firstChild), $0e6d2da9c09dac01$var$xg = b, $0e6d2da9c09dac01$var$I = !0, $0e6d2da9c09dac01$var$zg = null, c = $0e6d2da9c09dac01$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0e6d2da9c09dac01$var$Ig();
                    if (d === e) {
                        b = $0e6d2da9c09dac01$var$$i(a, b, c);
                        break a;
                    }
                    $0e6d2da9c09dac01$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0e6d2da9c09dac01$var$Kh(b), null === a && $0e6d2da9c09dac01$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0e6d2da9c09dac01$var$Ef(d, e) ? g = null : null !== f && $0e6d2da9c09dac01$var$Ef(d, f) && (b.flags |= 32), $0e6d2da9c09dac01$var$hj(a, b), $0e6d2da9c09dac01$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0e6d2da9c09dac01$var$Eg(b), null;
        case 13:
            return $0e6d2da9c09dac01$var$pj(a, b, c);
        case 4:
            return $0e6d2da9c09dac01$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0e6d2da9c09dac01$var$Bh(b, null, d, c) : $0e6d2da9c09dac01$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0e6d2da9c09dac01$var$Lg(d, e), $0e6d2da9c09dac01$var$Zi(a, b, d, e, c);
        case 7:
            return $0e6d2da9c09dac01$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0e6d2da9c09dac01$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0e6d2da9c09dac01$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0e6d2da9c09dac01$var$G($0e6d2da9c09dac01$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0e6d2da9c09dac01$var$He(f.value, g)) {
                        if (f.children === e.children && !$0e6d2da9c09dac01$var$Wf.current) {
                            b = $0e6d2da9c09dac01$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0e6d2da9c09dac01$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0e6d2da9c09dac01$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0e6d2da9c09dac01$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0e6d2da9c09dac01$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0e6d2da9c09dac01$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0e6d2da9c09dac01$var$Tg(b, c), e = $0e6d2da9c09dac01$var$Vg(e), d = d(e), b.flags |= 1, $0e6d2da9c09dac01$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0e6d2da9c09dac01$var$Lg(d, b.pendingProps), e = $0e6d2da9c09dac01$var$Lg(d.type, e), $0e6d2da9c09dac01$var$aj(a, b, d, e, c);
        case 15:
            return $0e6d2da9c09dac01$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0e6d2da9c09dac01$var$Lg(d, e), $0e6d2da9c09dac01$var$jj(a, b), b.tag = 1, $0e6d2da9c09dac01$var$Zf(d) ? (a = !0, $0e6d2da9c09dac01$var$cg(b)) : a = !1, $0e6d2da9c09dac01$var$Tg(b, c), $0e6d2da9c09dac01$var$ph(b, d, e), $0e6d2da9c09dac01$var$rh(b, d, e, c), $0e6d2da9c09dac01$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0e6d2da9c09dac01$var$yj(a, b, c);
        case 22:
            return $0e6d2da9c09dac01$var$ej(a, b, c);
    }
    throw Error($0e6d2da9c09dac01$var$p(156, b.tag));
};
function $0e6d2da9c09dac01$var$Gk(a, b) {
    return $0e6d2da9c09dac01$var$ac(a, b);
}
function $0e6d2da9c09dac01$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0e6d2da9c09dac01$var$Bg(a, b, c, d) {
    return new $0e6d2da9c09dac01$var$al(a, b, c, d);
}
function $0e6d2da9c09dac01$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0e6d2da9c09dac01$var$$k(a) {
    if ("function" === typeof a) return $0e6d2da9c09dac01$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0e6d2da9c09dac01$var$Da) return 11;
        if (a === $0e6d2da9c09dac01$var$Ga) return 14;
    }
    return 2;
}
function $0e6d2da9c09dac01$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0e6d2da9c09dac01$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0e6d2da9c09dac01$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0e6d2da9c09dac01$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0e6d2da9c09dac01$var$ya:
            return $0e6d2da9c09dac01$var$Ah(c.children, e, f, b);
        case $0e6d2da9c09dac01$var$za:
            g = 8;
            e |= 8;
            break;
        case $0e6d2da9c09dac01$var$Aa:
            return a = $0e6d2da9c09dac01$var$Bg(12, c, b, e | 2), a.elementType = $0e6d2da9c09dac01$var$Aa, a.lanes = f, a;
        case $0e6d2da9c09dac01$var$Ea:
            return a = $0e6d2da9c09dac01$var$Bg(13, c, b, e), a.elementType = $0e6d2da9c09dac01$var$Ea, a.lanes = f, a;
        case $0e6d2da9c09dac01$var$Fa:
            return a = $0e6d2da9c09dac01$var$Bg(19, c, b, e), a.elementType = $0e6d2da9c09dac01$var$Fa, a.lanes = f, a;
        case $0e6d2da9c09dac01$var$Ia:
            return $0e6d2da9c09dac01$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0e6d2da9c09dac01$var$Ba:
                    g = 10;
                    break a;
                case $0e6d2da9c09dac01$var$Ca:
                    g = 9;
                    break a;
                case $0e6d2da9c09dac01$var$Da:
                    g = 11;
                    break a;
                case $0e6d2da9c09dac01$var$Ga:
                    g = 14;
                    break a;
                case $0e6d2da9c09dac01$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0e6d2da9c09dac01$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0e6d2da9c09dac01$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0e6d2da9c09dac01$var$Ah(a, b, c, d) {
    a = $0e6d2da9c09dac01$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0e6d2da9c09dac01$var$qj(a, b, c, d) {
    a = $0e6d2da9c09dac01$var$Bg(22, a, d, b);
    a.elementType = $0e6d2da9c09dac01$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0e6d2da9c09dac01$var$xh(a, b, c) {
    a = $0e6d2da9c09dac01$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0e6d2da9c09dac01$var$zh(a, b, c) {
    b = $0e6d2da9c09dac01$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0e6d2da9c09dac01$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0e6d2da9c09dac01$var$zc(0);
    this.expirationTimes = $0e6d2da9c09dac01$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0e6d2da9c09dac01$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0e6d2da9c09dac01$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0e6d2da9c09dac01$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0e6d2da9c09dac01$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0e6d2da9c09dac01$var$ah(f);
    return a;
}
function $0e6d2da9c09dac01$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0e6d2da9c09dac01$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0e6d2da9c09dac01$var$el(a) {
    if (!a) return $0e6d2da9c09dac01$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0e6d2da9c09dac01$var$Vb(a) !== a || 1 !== a.tag) throw Error($0e6d2da9c09dac01$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0e6d2da9c09dac01$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0e6d2da9c09dac01$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0e6d2da9c09dac01$var$Zf(c)) return $0e6d2da9c09dac01$var$bg(a, c, b);
    }
    return b;
}
function $0e6d2da9c09dac01$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0e6d2da9c09dac01$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0e6d2da9c09dac01$var$el(null);
    c = a.current;
    d = $0e6d2da9c09dac01$var$L();
    e = $0e6d2da9c09dac01$var$lh(c);
    f = $0e6d2da9c09dac01$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0e6d2da9c09dac01$var$dh(c, f, e);
    a.current.lanes = e;
    $0e6d2da9c09dac01$var$Ac(a, e, d);
    $0e6d2da9c09dac01$var$Ek(a, d);
    return a;
}
function $0e6d2da9c09dac01$var$gl(a, b, c, d) {
    var e = b.current, f = $0e6d2da9c09dac01$var$L(), g = $0e6d2da9c09dac01$var$lh(e);
    c = $0e6d2da9c09dac01$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0e6d2da9c09dac01$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0e6d2da9c09dac01$var$dh(e, b, g);
    null !== a && ($0e6d2da9c09dac01$var$mh(a, e, g, f), $0e6d2da9c09dac01$var$eh(a, e, g));
    return g;
}
function $0e6d2da9c09dac01$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0e6d2da9c09dac01$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0e6d2da9c09dac01$var$jl(a, b) {
    $0e6d2da9c09dac01$var$il(a, b);
    (a = a.alternate) && $0e6d2da9c09dac01$var$il(a, b);
}
function $0e6d2da9c09dac01$var$kl() {
    return null;
}
var $0e6d2da9c09dac01$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0e6d2da9c09dac01$var$ml(a) {
    this._internalRoot = a;
}
$0e6d2da9c09dac01$var$nl.prototype.render = $0e6d2da9c09dac01$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0e6d2da9c09dac01$var$p(409));
    $0e6d2da9c09dac01$var$gl(a, b, null, null);
};
$0e6d2da9c09dac01$var$nl.prototype.unmount = $0e6d2da9c09dac01$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0e6d2da9c09dac01$var$Sk(function() {
            $0e6d2da9c09dac01$var$gl(null, a, null, null);
        });
        b[$0e6d2da9c09dac01$var$uf] = null;
    }
};
function $0e6d2da9c09dac01$var$nl(a) {
    this._internalRoot = a;
}
$0e6d2da9c09dac01$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0e6d2da9c09dac01$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0e6d2da9c09dac01$var$Qc.length && 0 !== b && b < $0e6d2da9c09dac01$var$Qc[c].priority; c++);
        $0e6d2da9c09dac01$var$Qc.splice(c, 0, a);
        0 === c && $0e6d2da9c09dac01$var$Vc(a);
    }
};
function $0e6d2da9c09dac01$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0e6d2da9c09dac01$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0e6d2da9c09dac01$var$ql() {}
function $0e6d2da9c09dac01$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0e6d2da9c09dac01$var$hl(g);
                f.call(a);
            };
        }
        var g = $0e6d2da9c09dac01$var$fl(b, d, a, 0, null, !1, !1, "", $0e6d2da9c09dac01$var$ql);
        a._reactRootContainer = g;
        a[$0e6d2da9c09dac01$var$uf] = g.current;
        $0e6d2da9c09dac01$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0e6d2da9c09dac01$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0e6d2da9c09dac01$var$hl(k);
            h.call(a);
        };
    }
    var k = $0e6d2da9c09dac01$var$cl(a, 0, !1, null, null, !1, !1, "", $0e6d2da9c09dac01$var$ql);
    a._reactRootContainer = k;
    a[$0e6d2da9c09dac01$var$uf] = k.current;
    $0e6d2da9c09dac01$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0e6d2da9c09dac01$var$Sk(function() {
        $0e6d2da9c09dac01$var$gl(b, k, c, d);
    });
    return k;
}
function $0e6d2da9c09dac01$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0e6d2da9c09dac01$var$hl(g);
                h.call(a);
            };
        }
        $0e6d2da9c09dac01$var$gl(b, g, a, e);
    } else g = $0e6d2da9c09dac01$var$rl(c, b, a, e, d);
    return $0e6d2da9c09dac01$var$hl(g);
}
$0e6d2da9c09dac01$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0e6d2da9c09dac01$var$tc(b.pendingLanes);
                0 !== c && ($0e6d2da9c09dac01$var$Cc(b, c | 1), $0e6d2da9c09dac01$var$Ek(b, $0e6d2da9c09dac01$var$B()), 0 === ($0e6d2da9c09dac01$var$K & 6) && ($0e6d2da9c09dac01$var$Hj = $0e6d2da9c09dac01$var$B() + 500, $0e6d2da9c09dac01$var$jg()));
            }
            break;
        case 13:
            $0e6d2da9c09dac01$var$Sk(function() {
                var b = $0e6d2da9c09dac01$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0e6d2da9c09dac01$var$L();
                    $0e6d2da9c09dac01$var$mh(b, a, 1, c);
                }
            }), $0e6d2da9c09dac01$var$jl(a, 1);
    }
};
$0e6d2da9c09dac01$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0e6d2da9c09dac01$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0e6d2da9c09dac01$var$L();
            $0e6d2da9c09dac01$var$mh(b, a, 134217728, c);
        }
        $0e6d2da9c09dac01$var$jl(a, 134217728);
    }
};
$0e6d2da9c09dac01$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0e6d2da9c09dac01$var$lh(a), c = $0e6d2da9c09dac01$var$Zg(a, b);
        if (null !== c) {
            var d = $0e6d2da9c09dac01$var$L();
            $0e6d2da9c09dac01$var$mh(c, a, b, d);
        }
        $0e6d2da9c09dac01$var$jl(a, b);
    }
};
$0e6d2da9c09dac01$var$Hc = function() {
    return $0e6d2da9c09dac01$var$C;
};
$0e6d2da9c09dac01$var$Ic = function(a, b) {
    var c = $0e6d2da9c09dac01$var$C;
    try {
        return $0e6d2da9c09dac01$var$C = a, b();
    } finally{
        $0e6d2da9c09dac01$var$C = c;
    }
};
$0e6d2da9c09dac01$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0e6d2da9c09dac01$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0e6d2da9c09dac01$var$Db(d);
                        if (!e) throw Error($0e6d2da9c09dac01$var$p(90));
                        $0e6d2da9c09dac01$var$Wa(d);
                        $0e6d2da9c09dac01$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0e6d2da9c09dac01$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0e6d2da9c09dac01$var$fb(a, !!c.multiple, b, !1);
    }
};
$0e6d2da9c09dac01$var$Gb = $0e6d2da9c09dac01$var$Rk;
$0e6d2da9c09dac01$var$Hb = $0e6d2da9c09dac01$var$Sk;
var $0e6d2da9c09dac01$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0e6d2da9c09dac01$var$Cb,
        $0e6d2da9c09dac01$var$ue,
        $0e6d2da9c09dac01$var$Db,
        $0e6d2da9c09dac01$var$Eb,
        $0e6d2da9c09dac01$var$Fb,
        $0e6d2da9c09dac01$var$Rk
    ]
}, $0e6d2da9c09dac01$var$ul = {
    findFiberByHostInstance: $0e6d2da9c09dac01$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0e6d2da9c09dac01$var$vl = {
    bundleType: $0e6d2da9c09dac01$var$ul.bundleType,
    version: $0e6d2da9c09dac01$var$ul.version,
    rendererPackageName: $0e6d2da9c09dac01$var$ul.rendererPackageName,
    rendererConfig: $0e6d2da9c09dac01$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0e6d2da9c09dac01$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0e6d2da9c09dac01$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0e6d2da9c09dac01$var$ul.findFiberByHostInstance || $0e6d2da9c09dac01$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0e6d2da9c09dac01$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0e6d2da9c09dac01$var$wl.isDisabled && $0e6d2da9c09dac01$var$wl.supportsFiber) try {
        $0e6d2da9c09dac01$var$kc = $0e6d2da9c09dac01$var$wl.inject($0e6d2da9c09dac01$var$vl), $0e6d2da9c09dac01$var$lc = $0e6d2da9c09dac01$var$wl;
    } catch (a) {}
}
$0e6d2da9c09dac01$export$ae55be85d98224ed = $0e6d2da9c09dac01$var$tl;
$0e6d2da9c09dac01$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0e6d2da9c09dac01$var$ol(b)) throw Error($0e6d2da9c09dac01$var$p(200));
    return $0e6d2da9c09dac01$var$dl(a, b, null, c);
};
$0e6d2da9c09dac01$export$882461b6382ed46c = function(a, b) {
    if (!$0e6d2da9c09dac01$var$ol(a)) throw Error($0e6d2da9c09dac01$var$p(299));
    var c = !1, d = "", e = $0e6d2da9c09dac01$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0e6d2da9c09dac01$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0e6d2da9c09dac01$var$uf] = b.current;
    $0e6d2da9c09dac01$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0e6d2da9c09dac01$var$ml(b);
};
$0e6d2da9c09dac01$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0e6d2da9c09dac01$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0e6d2da9c09dac01$var$p(268, a));
    }
    a = $0e6d2da9c09dac01$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0e6d2da9c09dac01$export$cd75ccfd720a3cd4 = function(a) {
    return $0e6d2da9c09dac01$var$Sk(a);
};
$0e6d2da9c09dac01$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0e6d2da9c09dac01$var$pl(b)) throw Error($0e6d2da9c09dac01$var$p(200));
    return $0e6d2da9c09dac01$var$sl(null, a, b, !0, c);
};
$0e6d2da9c09dac01$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0e6d2da9c09dac01$var$ol(a)) throw Error($0e6d2da9c09dac01$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0e6d2da9c09dac01$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0e6d2da9c09dac01$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0e6d2da9c09dac01$var$uf] = b.current;
    $0e6d2da9c09dac01$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0e6d2da9c09dac01$var$nl(b);
};
$0e6d2da9c09dac01$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0e6d2da9c09dac01$var$pl(b)) throw Error($0e6d2da9c09dac01$var$p(200));
    return $0e6d2da9c09dac01$var$sl(null, a, b, !1, c);
};
$0e6d2da9c09dac01$export$502457920280e6be = function(a) {
    if (!$0e6d2da9c09dac01$var$pl(a)) throw Error($0e6d2da9c09dac01$var$p(40));
    return a._reactRootContainer ? ($0e6d2da9c09dac01$var$Sk(function() {
        $0e6d2da9c09dac01$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0e6d2da9c09dac01$var$uf] = null;
        });
    }), !0) : !1;
};
$0e6d2da9c09dac01$export$c78a37762a8d58e1 = $0e6d2da9c09dac01$var$Rk;
$0e6d2da9c09dac01$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0e6d2da9c09dac01$var$pl(c)) throw Error($0e6d2da9c09dac01$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0e6d2da9c09dac01$var$p(38));
    return $0e6d2da9c09dac01$var$sl(a, b, c, !1, d);
};
$0e6d2da9c09dac01$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("8nAnF", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fjx7a"));

});
parcelRequire.register("fjx7a", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $b2625140b03e059d$export$c4744153514ff05d; }, function (v) { return $b2625140b03e059d$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $b2625140b03e059d$export$3e506c1ccc9cc1a7; }, function (v) { return $b2625140b03e059d$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $b2625140b03e059d$export$e26fe2ed2fa76875; }, function (v) { return $b2625140b03e059d$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $b2625140b03e059d$export$502329bbf4b505b1; }, function (v) { return $b2625140b03e059d$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $b2625140b03e059d$export$6e3807111c4874c4; }, function (v) { return $b2625140b03e059d$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $b2625140b03e059d$export$c27134553091fb3a; }, function (v) { return $b2625140b03e059d$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $b2625140b03e059d$export$33ee1acdc04fd2a2; }, function (v) { return $b2625140b03e059d$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $b2625140b03e059d$export$b00a404bbd5edef2; }, function (v) { return $b2625140b03e059d$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $b2625140b03e059d$export$8352ce38b91d0c62; }, function (v) { return $b2625140b03e059d$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $b2625140b03e059d$export$d66a1c1c77bd778b; }, function (v) { return $b2625140b03e059d$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $b2625140b03e059d$export$d3dfb8e4810cb555; }, function (v) { return $b2625140b03e059d$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $b2625140b03e059d$export$839f9183b0465a69; }, function (v) { return $b2625140b03e059d$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $b2625140b03e059d$export$72fdf0e06517287b; }, function (v) { return $b2625140b03e059d$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $b2625140b03e059d$export$4b844e58a3e414b4; }, function (v) { return $b2625140b03e059d$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $b2625140b03e059d$export$816d2913ae6b83b1; }, function (v) { return $b2625140b03e059d$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $b2625140b03e059d$export$61bcfe829111a1d0; }, function (v) { return $b2625140b03e059d$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $b2625140b03e059d$export$7ee8c9beb337bc3f; }, function (v) { return $b2625140b03e059d$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $b2625140b03e059d$export$b5836b71941fa3ed; }, function (v) { return $b2625140b03e059d$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $b2625140b03e059d$export$cf845f2c119da08a; }, function (v) { return $b2625140b03e059d$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b2625140b03e059d$export$c4744153514ff05d;
var $b2625140b03e059d$export$3e506c1ccc9cc1a7;
var $b2625140b03e059d$export$e26fe2ed2fa76875;
var $b2625140b03e059d$export$502329bbf4b505b1;
var $b2625140b03e059d$export$6e3807111c4874c4;
var $b2625140b03e059d$export$c27134553091fb3a;
var $b2625140b03e059d$export$33ee1acdc04fd2a2;
var $b2625140b03e059d$export$b00a404bbd5edef2;
var $b2625140b03e059d$export$8352ce38b91d0c62;
var $b2625140b03e059d$export$d66a1c1c77bd778b;
var $b2625140b03e059d$export$d3dfb8e4810cb555;
var $b2625140b03e059d$export$839f9183b0465a69;
var $b2625140b03e059d$export$72fdf0e06517287b;
var $b2625140b03e059d$export$4b844e58a3e414b4;
var $b2625140b03e059d$export$816d2913ae6b83b1;
var $b2625140b03e059d$export$61bcfe829111a1d0;
var $b2625140b03e059d$export$7ee8c9beb337bc3f;
var $b2625140b03e059d$export$b5836b71941fa3ed;
var $b2625140b03e059d$export$cf845f2c119da08a;
"use strict";
function $b2625140b03e059d$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $b2625140b03e059d$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $b2625140b03e059d$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $b2625140b03e059d$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $b2625140b03e059d$var$g(C, c)) n < e && 0 > $b2625140b03e059d$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $b2625140b03e059d$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $b2625140b03e059d$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $b2625140b03e059d$var$l = performance;
    $b2625140b03e059d$export$c4744153514ff05d = function() {
        return $b2625140b03e059d$var$l.now();
    };
} else {
    var $b2625140b03e059d$var$p = Date, $b2625140b03e059d$var$q = $b2625140b03e059d$var$p.now();
    $b2625140b03e059d$export$c4744153514ff05d = function() {
        return $b2625140b03e059d$var$p.now() - $b2625140b03e059d$var$q;
    };
}
var $b2625140b03e059d$var$r = [], $b2625140b03e059d$var$t = [], $b2625140b03e059d$var$u = 1, $b2625140b03e059d$var$v = null, $b2625140b03e059d$var$y = 3, $b2625140b03e059d$var$z = !1, $b2625140b03e059d$var$A = !1, $b2625140b03e059d$var$B = !1, $b2625140b03e059d$var$D = "function" === typeof setTimeout ? setTimeout : null, $b2625140b03e059d$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $b2625140b03e059d$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $b2625140b03e059d$var$G(a) {
    for(var b = $b2625140b03e059d$var$h($b2625140b03e059d$var$t); null !== b;){
        if (null === b.callback) $b2625140b03e059d$var$k($b2625140b03e059d$var$t);
        else if (b.startTime <= a) $b2625140b03e059d$var$k($b2625140b03e059d$var$t), b.sortIndex = b.expirationTime, $b2625140b03e059d$var$f($b2625140b03e059d$var$r, b);
        else break;
        b = $b2625140b03e059d$var$h($b2625140b03e059d$var$t);
    }
}
function $b2625140b03e059d$var$H(a) {
    $b2625140b03e059d$var$B = !1;
    $b2625140b03e059d$var$G(a);
    if (!$b2625140b03e059d$var$A) {
        if (null !== $b2625140b03e059d$var$h($b2625140b03e059d$var$r)) $b2625140b03e059d$var$A = !0, $b2625140b03e059d$var$I($b2625140b03e059d$var$J);
        else {
            var b = $b2625140b03e059d$var$h($b2625140b03e059d$var$t);
            null !== b && $b2625140b03e059d$var$K($b2625140b03e059d$var$H, b.startTime - a);
        }
    }
}
function $b2625140b03e059d$var$J(a, b) {
    $b2625140b03e059d$var$A = !1;
    $b2625140b03e059d$var$B && ($b2625140b03e059d$var$B = !1, $b2625140b03e059d$var$E($b2625140b03e059d$var$L), $b2625140b03e059d$var$L = -1);
    $b2625140b03e059d$var$z = !0;
    var c = $b2625140b03e059d$var$y;
    try {
        $b2625140b03e059d$var$G(b);
        for($b2625140b03e059d$var$v = $b2625140b03e059d$var$h($b2625140b03e059d$var$r); null !== $b2625140b03e059d$var$v && (!($b2625140b03e059d$var$v.expirationTime > b) || a && !$b2625140b03e059d$var$M());){
            var d = $b2625140b03e059d$var$v.callback;
            if ("function" === typeof d) {
                $b2625140b03e059d$var$v.callback = null;
                $b2625140b03e059d$var$y = $b2625140b03e059d$var$v.priorityLevel;
                var e = d($b2625140b03e059d$var$v.expirationTime <= b);
                b = $b2625140b03e059d$export$c4744153514ff05d();
                "function" === typeof e ? $b2625140b03e059d$var$v.callback = e : $b2625140b03e059d$var$v === $b2625140b03e059d$var$h($b2625140b03e059d$var$r) && $b2625140b03e059d$var$k($b2625140b03e059d$var$r);
                $b2625140b03e059d$var$G(b);
            } else $b2625140b03e059d$var$k($b2625140b03e059d$var$r);
            $b2625140b03e059d$var$v = $b2625140b03e059d$var$h($b2625140b03e059d$var$r);
        }
        if (null !== $b2625140b03e059d$var$v) var w = !0;
        else {
            var m = $b2625140b03e059d$var$h($b2625140b03e059d$var$t);
            null !== m && $b2625140b03e059d$var$K($b2625140b03e059d$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $b2625140b03e059d$var$v = null, $b2625140b03e059d$var$y = c, $b2625140b03e059d$var$z = !1;
    }
}
var $b2625140b03e059d$var$N = !1, $b2625140b03e059d$var$O = null, $b2625140b03e059d$var$L = -1, $b2625140b03e059d$var$P = 5, $b2625140b03e059d$var$Q = -1;
function $b2625140b03e059d$var$M() {
    return $b2625140b03e059d$export$c4744153514ff05d() - $b2625140b03e059d$var$Q < $b2625140b03e059d$var$P ? !1 : !0;
}
function $b2625140b03e059d$var$R() {
    if (null !== $b2625140b03e059d$var$O) {
        var a = $b2625140b03e059d$export$c4744153514ff05d();
        $b2625140b03e059d$var$Q = a;
        var b = !0;
        try {
            b = $b2625140b03e059d$var$O(!0, a);
        } finally{
            b ? $b2625140b03e059d$var$S() : ($b2625140b03e059d$var$N = !1, $b2625140b03e059d$var$O = null);
        }
    } else $b2625140b03e059d$var$N = !1;
}
var $b2625140b03e059d$var$S;
if ("function" === typeof $b2625140b03e059d$var$F) $b2625140b03e059d$var$S = function() {
    $b2625140b03e059d$var$F($b2625140b03e059d$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $b2625140b03e059d$var$T = new MessageChannel, $b2625140b03e059d$var$U = $b2625140b03e059d$var$T.port2;
    $b2625140b03e059d$var$T.port1.onmessage = $b2625140b03e059d$var$R;
    $b2625140b03e059d$var$S = function() {
        $b2625140b03e059d$var$U.postMessage(null);
    };
} else $b2625140b03e059d$var$S = function() {
    $b2625140b03e059d$var$D($b2625140b03e059d$var$R, 0);
};
function $b2625140b03e059d$var$I(a) {
    $b2625140b03e059d$var$O = a;
    $b2625140b03e059d$var$N || ($b2625140b03e059d$var$N = !0, $b2625140b03e059d$var$S());
}
function $b2625140b03e059d$var$K(a, b) {
    $b2625140b03e059d$var$L = $b2625140b03e059d$var$D(function() {
        a($b2625140b03e059d$export$c4744153514ff05d());
    }, b);
}
$b2625140b03e059d$export$3e506c1ccc9cc1a7 = 5;
$b2625140b03e059d$export$e26fe2ed2fa76875 = 1;
$b2625140b03e059d$export$502329bbf4b505b1 = 4;
$b2625140b03e059d$export$6e3807111c4874c4 = 3;
$b2625140b03e059d$export$c27134553091fb3a = null;
$b2625140b03e059d$export$33ee1acdc04fd2a2 = 2;
$b2625140b03e059d$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$b2625140b03e059d$export$8352ce38b91d0c62 = function() {
    $b2625140b03e059d$var$A || $b2625140b03e059d$var$z || ($b2625140b03e059d$var$A = !0, $b2625140b03e059d$var$I($b2625140b03e059d$var$J));
};
$b2625140b03e059d$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $b2625140b03e059d$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$b2625140b03e059d$export$d3dfb8e4810cb555 = function() {
    return $b2625140b03e059d$var$y;
};
$b2625140b03e059d$export$839f9183b0465a69 = function() {
    return $b2625140b03e059d$var$h($b2625140b03e059d$var$r);
};
$b2625140b03e059d$export$72fdf0e06517287b = function(a) {
    switch($b2625140b03e059d$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $b2625140b03e059d$var$y;
    }
    var c = $b2625140b03e059d$var$y;
    $b2625140b03e059d$var$y = b;
    try {
        return a();
    } finally{
        $b2625140b03e059d$var$y = c;
    }
};
$b2625140b03e059d$export$4b844e58a3e414b4 = function() {};
$b2625140b03e059d$export$816d2913ae6b83b1 = function() {};
$b2625140b03e059d$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $b2625140b03e059d$var$y;
    $b2625140b03e059d$var$y = a;
    try {
        return b();
    } finally{
        $b2625140b03e059d$var$y = c;
    }
};
$b2625140b03e059d$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $b2625140b03e059d$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $b2625140b03e059d$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $b2625140b03e059d$var$f($b2625140b03e059d$var$t, a), null === $b2625140b03e059d$var$h($b2625140b03e059d$var$r) && a === $b2625140b03e059d$var$h($b2625140b03e059d$var$t) && ($b2625140b03e059d$var$B ? ($b2625140b03e059d$var$E($b2625140b03e059d$var$L), $b2625140b03e059d$var$L = -1) : $b2625140b03e059d$var$B = !0, $b2625140b03e059d$var$K($b2625140b03e059d$var$H, c - d))) : (a.sortIndex = e, $b2625140b03e059d$var$f($b2625140b03e059d$var$r, a), $b2625140b03e059d$var$A || $b2625140b03e059d$var$z || ($b2625140b03e059d$var$A = !0, $b2625140b03e059d$var$I($b2625140b03e059d$var$J)));
    return a;
};
$b2625140b03e059d$export$b5836b71941fa3ed = $b2625140b03e059d$var$M;
$b2625140b03e059d$export$cf845f2c119da08a = function(a) {
    var b = $b2625140b03e059d$var$y;
    return function() {
        var c = $b2625140b03e059d$var$y;
        $b2625140b03e059d$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $b2625140b03e059d$var$y = c;
        }
    };
};

});



parcelRequire.register("gAFWW", function(module, exports) {
"use strict";
var $c1408c7a7f065d51$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c1408c7a7f065d51$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c1408c7a7f065d51$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c1408c7a7f065d51$var$__exportStar((parcelRequire("75AKJ")), module.exports);

$c1408c7a7f065d51$var$__exportStar((parcelRequire("baaaw")), module.exports);

$c1408c7a7f065d51$var$__exportStar((parcelRequire("1Zlyw")), module.exports);

$c1408c7a7f065d51$var$__exportStar((parcelRequire("gwewq")), module.exports);

});
parcelRequire.register("75AKJ", function(module, exports) {

$parcel$export(module.exports, "useMount", function () { return $52958257575e8d33$export$17f7c8f694d207ce; });
$parcel$export(module.exports, "useMediaQuery", function () { return $52958257575e8d33$export$32d5543ab307c01; });
$parcel$export(module.exports, "breakpointsTailwind", function () { return $52958257575e8d33$export$1e7f3da0afb51c4; });
$parcel$export(module.exports, "breakpointsBootstrapV5", function () { return $52958257575e8d33$export$ab05426c509559f5; });
$parcel$export(module.exports, "breakpointsVuetify", function () { return $52958257575e8d33$export$e826524d50707be3; });
$parcel$export(module.exports, "breakpointsAntDesign", function () { return $52958257575e8d33$export$913d30ac358ba918; });
$parcel$export(module.exports, "breakpointsSematic", function () { return $52958257575e8d33$export$b4376e330fd9cda3; });
$parcel$export(module.exports, "BreakPointHooks", function () { return $52958257575e8d33$export$dbe0b65badc3ec0e; });
$parcel$export(module.exports, "useEventListener", function () { return $52958257575e8d33$export$7080b3e976bc91ab; });
$parcel$export(module.exports, "useActiveElement", function () { return $52958257575e8d33$export$4e1875a4b2b1434f; });
$parcel$export(module.exports, "useAsyncCallback", function () { return $52958257575e8d33$export$fbeb804c371ac8d; });
$parcel$export(module.exports, "useClickOutside", function () { return $52958257575e8d33$export$1896bab46732d207; });
$parcel$export(module.exports, "useDebounce", function () { return $52958257575e8d33$export$21805fee57372823; });
$parcel$export(module.exports, "useEffectAfterMount", function () { return $52958257575e8d33$export$5c116da254669509; });
$parcel$export(module.exports, "useFont", function () { return $52958257575e8d33$export$26ca5b065308b0d1; });
$parcel$export(module.exports, "useHasMounted", function () { return $52958257575e8d33$export$c274b64ff9bf1d68; });
$parcel$export(module.exports, "useHover", function () { return $52958257575e8d33$export$ae780daf29e6d456; });
$parcel$export(module.exports, "useIsSupported", function () { return $52958257575e8d33$export$3537a97f5e69af55; });
$parcel$export(module.exports, "useUnMount", function () { return $52958257575e8d33$export$c9775f574d6946a; });
$parcel$export(module.exports, "useIntersectionObserver", function () { return $52958257575e8d33$export$a7395f9832c00176; });
$parcel$export(module.exports, "useInterval", function () { return $52958257575e8d33$export$f4b266cd2aae9cb1; });
$parcel$export(module.exports, "useKeyStroke", function () { return $52958257575e8d33$export$7063de29218d981c; });
$parcel$export(module.exports, "useKeyDown", function () { return $52958257575e8d33$export$2833a5916919d1a6; });
$parcel$export(module.exports, "useKeyPressed", function () { return $52958257575e8d33$export$88fe03a37d9981dd; });
$parcel$export(module.exports, "useKeyUp", function () { return $52958257575e8d33$export$7ed39601d10cfc78; });
$parcel$export(module.exports, "useLocalStorage", function () { return $52958257575e8d33$export$86e2cef2561044ac; });
$parcel$export(module.exports, "useLocation", function () { return $52958257575e8d33$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useMediaStream", function () { return $52958257575e8d33$export$7c2480e3c8c31328; });
$parcel$export(module.exports, "useMountSync", function () { return $52958257575e8d33$export$b2824085ba6f4489; });
$parcel$export(module.exports, "useMouse", function () { return $52958257575e8d33$export$70811b4970b0f258; });
$parcel$export(module.exports, "useMutationObserver", function () { return $52958257575e8d33$export$8ecdcf3bb089e9cd; });
$parcel$export(module.exports, "useNetwork", function () { return $52958257575e8d33$export$553aaf59afc1a2d8; });
$parcel$export(module.exports, "useOnline", function () { return $52958257575e8d33$export$6feb6ada280bcdab; });
$parcel$export(module.exports, "usePreferredColorScheme", function () { return $52958257575e8d33$export$7c3b8f854ca5e941; });
$parcel$export(module.exports, "usePrevious", function () { return $52958257575e8d33$export$5cae361ad82dce8b; });
$parcel$export(module.exports, "useScreenShare", function () { return $52958257575e8d33$export$c27cf6c2ce7eaf62; });
$parcel$export(module.exports, "useScroll", function () { return $52958257575e8d33$export$d928051c8cd740b; });
$parcel$export(module.exports, "useScrollIntoView", function () { return $52958257575e8d33$export$c05432b4b8843105; });
$parcel$export(module.exports, "useSessionStorage", function () { return $52958257575e8d33$export$864b6828bd07eda6; });
$parcel$export(module.exports, "useStateCompare", function () { return $52958257575e8d33$export$df00f37a0b0b8ef7; });
$parcel$export(module.exports, "useStateHistory", function () { return $52958257575e8d33$export$b4effed71825dc9c; });
$parcel$export(module.exports, "useTitle", function () { return $52958257575e8d33$export$bc98e171e8c82a3d; });
$parcel$export(module.exports, "useToggle", function () { return $52958257575e8d33$export$cbe85ee05b554577; });
$parcel$export(module.exports, "useWindowSize", function () { return $52958257575e8d33$export$42c02f33970a2afa; });

var $fV3WI = parcelRequire("fV3WI");
/**
 * Run a function when a component is mounted.
 *
 * @deprecated This hook breaks in React 18's strict mode, since it's not idempotent
 *
 * @param callback function to be executed
 */ function $52958257575e8d33$export$17f7c8f694d207ce(callback) {
    (0, $fV3WI.useEffect)(callback, []);
}
/**
 * Reactive media query hook that returns the truthy value of the media query.
 *
 * @param {string} query
 * @returns {boolean} boolean value of the query
 *
 * @see https://react-hooks-library.vercel.app/core/useMediaQuery
 */ function $52958257575e8d33$export$32d5543ab307c01(query) {
    const [matches, setMatches] = (0, $fV3WI.useState)(false);
    $52958257575e8d33$export$17f7c8f694d207ce(()=>{
        setMatches(window.matchMedia(query).matches);
    });
    (0, $fV3WI.useEffect)(()=>{
        const mediaQuery = window.matchMedia(query);
        const handler = (event)=>{
            setMatches(event.matches);
        };
        // Add event listener for old safari browsers
        "addEventListener" in mediaQuery ? mediaQuery.addEventListener("change", handler) : mediaQuery.addListener(handler);
        return ()=>{
            "addEventListener" in mediaQuery ? mediaQuery.removeEventListener("change", handler) : mediaQuery.removeListener(handler);
        };
    }, [
        query
    ]);
    return matches;
}
/**
 * Breakpoints from Tailwind V2
 *
 * @see https://tailwindcss.com/docs/breakpoints
 */ const $52958257575e8d33$export$1e7f3da0afb51c4 = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    "2xl": 1536
};
/**
 * Breakpoints from Bootstrap V5
 *
 * @see https://getbootstrap.com/docs/5.0/layout/breakpoints
 */ const $52958257575e8d33$export$ab05426c509559f5 = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
};
/**
 * Breakpoints from Vuetify V2
 *
 * @see https://vuetifyjs.com/en/features/breakpoints
 */ const $52958257575e8d33$export$e826524d50707be3 = {
    xs: 600,
    sm: 960,
    md: 1264,
    lg: 1904
};
/**
 * Breakpoints from Ant Design
 *
 * @see https://ant.design/components/layout/#breakpoint-width
 */ const $52958257575e8d33$export$913d30ac358ba918 = {
    xs: 480,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1600
};
/**
 * Sematic Breakpoints
 */ const $52958257575e8d33$export$b4376e330fd9cda3 = {
    mobileS: 320,
    mobileM: 375,
    mobileL: 425,
    tablet: 768,
    laptop: 1024,
    laptopL: 1440,
    desktop4K: 2560
};
/* eslint-disable @typescript-eslint/ban-types */ /**
 * Check if we're on the server or client side
 */ const $52958257575e8d33$var$isClient = typeof window !== "undefined";
/**
 * Check if object is a react ref
 */ const $52958257575e8d33$var$isRef = (obj)=>obj !== null && typeof obj === "object" && Object.prototype.hasOwnProperty.call(obj, "current");
const $52958257575e8d33$var$isFunction = (val)=>typeof val === "function";
const $52958257575e8d33$var$isString = (val)=>typeof val === "string";
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $52958257575e8d33$var$noop = ()=>{};
const $52958257575e8d33$var$round = (num)=>Math.round(num * 1e2) / 1e2;
/**
 * Accepts either a ref object or a dom node and returns a dom node
 *
 * @param target - ref or a dom node
 * @returns dom noe
 */ function $52958257575e8d33$var$unRef(target) {
    const element = $52958257575e8d33$var$isRef(target) ? target.current : target;
    return element;
}
const $52958257575e8d33$var$_window = $52958257575e8d33$var$isClient ? window : undefined;
const $52958257575e8d33$var$_document = $52958257575e8d33$var$isClient ? window.document : undefined;
const $52958257575e8d33$var$_navigator = $52958257575e8d33$var$isClient ? window.navigator : undefined;
function $52958257575e8d33$var$match(query) {
    if (!$52958257575e8d33$var$_window) return false;
    return $52958257575e8d33$var$_window.matchMedia(query).matches;
}
/**
 * Reactive hooks and utilities to be used with user provided breakpoints.
 *
 * @param {string} breakpoints
 * @returns functions to be used as hooks
 *
 * @see https://react-hooks-library.vercel.app/core/BreakPointHooks
 */ function $52958257575e8d33$export$dbe0b65badc3ec0e(breakpoints) {
    return {
        /**
         * Hook that returns a boolean if screen width is greater than given breakpoint.
         *
         * @param k {string} breakpoint
         * @returns boolean
         *
         * @see https://react-hooks-library.vercel.app/core/BreakPointHooks
         **/ useGreater: (k)=>{
            return $52958257575e8d33$export$32d5543ab307c01(`(min-width: ${breakpoints[k]}px)`);
        },
        /**
         * Hook that returns a boolean if screen width is smaller than given breakpoint.
         *
         * @param k {string} breakpoint
         * @param k {string} breakpoint
         *
         * @returns boolean
         *
         * @see https://react-hooks-library.vercel.app/core/BreakPointHooks
         **/ useSmaller: (k)=>{
            return $52958257575e8d33$export$32d5543ab307c01(`(max-width: ${breakpoints[k]}px)`);
        },
        /**
         * Hook that returns a boolean if screen width is between two given breakpoint.
         *
         * @param a {string} breakpoint
         * @param b {string} breakpoint
         *
         * @returns boolean
         *
         * @see https://react-hooks-library.vercel.app/core/BreakPointHooks
         **/ useBetween: (a, b)=>{
            return $52958257575e8d33$export$32d5543ab307c01(`(min-width: ${breakpoints[a]}px) and (max-width: ${breakpoints[b]}px)`);
        },
        /**
         * Utility function that returns a boolean if screen width is greater than given breakpoint.
         *
         * @param k {string} breakpoint
         *
         * @see https://react-hooks-library.vercel.app/core/BreakPointHooks
         **/ isGreater (k) {
            return $52958257575e8d33$var$match(`(min-width: ${breakpoints[k]}px)`);
        },
        /**
         * Utility function that returns a boolean if screen width is smaller than given breakpoint.
         *
         * @param k {string} breakpoint
         *
         * @see https://react-hooks-library.vercel.app/core/BreakPointHooks
         **/ isSmaller (k) {
            return $52958257575e8d33$var$match(`(max-width: ${breakpoints[k]}px)`);
        },
        /**
         * Utility function that returns a boolean if screen width is between two given breakpoint.
         *
         * @param k {string} breakpoint
         *
         * @see https://react-hooks-library.vercel.app/core/BreakPointHooks
         **/ isInBetween (a, b) {
            return $52958257575e8d33$var$match(`(min-width: ${breakpoints[a]}px) and (max-width: ${breakpoints[b]}px)`);
        }
    };
}
function $52958257575e8d33$export$7080b3e976bc91ab(...args) {
    let target = $52958257575e8d33$var$_window;
    let event;
    let listener;
    let options;
    $52958257575e8d33$var$isString(args[0]) ? [event, listener, options] = args : [target, event, listener, options] = args;
    const savedListener = (0, $fV3WI.useRef)(listener);
    const cleanup = (0, $fV3WI.useRef)($52958257575e8d33$var$noop);
    (0, $fV3WI.useEffect)(()=>{
        savedListener.current = listener;
    }, [
        listener
    ]);
    (0, $fV3WI.useEffect)(()=>{
        const el = $52958257575e8d33$var$unRef(target);
        if (!$52958257575e8d33$var$isClient || !el) return;
        el.addEventListener(event, savedListener.current, options);
        cleanup.current = ()=>{
            el.removeEventListener(event, savedListener.current, options);
        };
        return cleanup.current;
    }, [
        event,
        target,
        options
    ]);
    return cleanup.current;
}
/**
 * Reactive document.activeElement, returns a reference to current active element
 *
 * @returns current active element (DOM node)
 **/ function $52958257575e8d33$export$4e1875a4b2b1434f() {
    const [activeElement, setActiveElement] = (0, $fV3WI.useState)(()=>$52958257575e8d33$var$_document === null || $52958257575e8d33$var$_document === void 0 ? void 0 : $52958257575e8d33$var$_document.activeElement);
    $52958257575e8d33$export$7080b3e976bc91ab("focus", ()=>setActiveElement($52958257575e8d33$var$_document === null || $52958257575e8d33$var$_document === void 0 ? void 0 : $52958257575e8d33$var$_document.activeElement), true);
    $52958257575e8d33$export$7080b3e976bc91ab("blur", ()=>setActiveElement(null), true);
    return {
        activeElement: activeElement
    };
}
/**
 * Returns a current execution state of an async function.
 * Use it to orchestrate async actions in UI.
 *
 * @see https://react-hooks-library.vercel.app/core/useAsyncCallback
 */ function $52958257575e8d33$export$fbeb804c371ac8d(callback) {
    const [isLoading, setIsLoading] = (0, $fV3WI.useState)(false);
    const [isSuccess, setIsSuccess] = (0, $fV3WI.useState)(false);
    const [error, setError] = (0, $fV3WI.useState)(false);
    const [data, setData] = (0, $fV3WI.useState)();
    const _callback = (0, $fV3WI.useCallback)(async (...args)=>{
        try {
            setIsLoading(true);
            const results = await callback(...args);
            setData(results);
            setIsSuccess(true);
            return results;
        } catch (e) {
            setError(true);
            throw e;
        } finally{
            setIsLoading(false);
        }
    }, [
        callback
    ]);
    return [
        {
            data: data,
            error: error,
            isLoading: isLoading,
            isSuccess: isSuccess
        },
        _callback
    ];
}
/**
 * Listen for clicks outside of an element.
 *
 * @param target
 * @param handler
 * @param options
 *
 * @see https://react-hooks-library.vercel.app/core/onClickOutside
 */ function $52958257575e8d33$export$1896bab46732d207(target, handler, options = {}) {
    const { event: event = "pointerdown"  } = options;
    const listener = (0, $fV3WI.useCallback)((event)=>{
        const el = $52958257575e8d33$var$unRef(target);
        if (!el) return;
        if (el === event.target || event.composedPath().includes(el)) return;
        handler(event);
    }, [
        handler,
        target
    ]);
    return $52958257575e8d33$export$7080b3e976bc91ab($52958257575e8d33$var$_window, event, listener, {
        passive: true
    });
}
/**
 * Used to debounce a quickly changing value.
 * Will return the latest value after a specified amount of time.
 *
 * @param {T} value
 * @param timeout
 * @returns {Readonly<T>} latest value
 * @see https://react-hooks-library.vercel.app/core/useDebounce
 */ function $52958257575e8d33$export$21805fee57372823(value, timeout) {
    const [state, setState] = (0, $fV3WI.useState)(value);
    (0, $fV3WI.useEffect)(()=>{
        const tick = setTimeout(()=>setState(value), timeout);
        return ()=>clearTimeout(tick);
    }, [
        value,
        timeout
    ]);
    if (timeout <= 0) return value;
    return state;
}
/**
 * A useEffect hook does that not run on mount, but only on subsequent updates.
 *
 * @deprecated This hook breaks in React 18's strict mode, since it's not idempotent
 *
 * @param effect
 * @param deps
 *
 * @see https://react-hooks-library.vercel.app/core/useEffectAfterMount
 */ function $52958257575e8d33$export$5c116da254669509(effect, deps) {
    const isMounted = (0, $fV3WI.useRef)(false);
    (0, $fV3WI.useEffect)(()=>{
        let cleanup = undefined;
        if (isMounted.current) cleanup = effect();
        isMounted.current = true;
        return cleanup;
    }, deps);
}
/**
 * React FontFace, a hook to load fonts asynchronously
 *
 * @param family
 * @param source
 * @param descriptors
 *
 * @see https://react-hooks-library.vercel.app/core/useFont
 */ function $52958257575e8d33$export$26ca5b065308b0d1(family, source, descriptors) {
    const [loaded, setLoaded] = (0, $fV3WI.useState)(true);
    const [error, setError] = (0, $fV3WI.useState)(false);
    const [font, setFont] = (0, $fV3WI.useState)(null);
    (0, $fV3WI.useEffect)(()=>{
        const font = new FontFace(family, `url(${source})`, descriptors);
        setFont(font);
        setLoaded(false);
        font.load().then(()=>document.fonts.add(font)).catch(()=>setError(true)).finally(()=>setLoaded(true));
    }, [
        descriptors,
        family,
        source
    ]);
    return {
        loaded: loaded,
        error: error,
        font: font
    };
}
/**
 * Hook that returns whether or not the component has mounted.
 * Useful in SSR frameworks like Next or Gatsby.
 *
 * @returns hasMounted
 */ function $52958257575e8d33$export$c274b64ff9bf1d68() {
    const [hasMounted, setHasMounted] = (0, $fV3WI.useState)(false);
    $52958257575e8d33$export$17f7c8f694d207ce(()=>{
        setHasMounted(true);
    });
    return hasMounted;
}
/**
 *
 * Detect if a dom element is hovered
 *
 * @param target - The element to listen to
 * @returns
 */ function $52958257575e8d33$export$ae780daf29e6d456(target) {
    const [isHovered, setIsHovered] = (0, $fV3WI.useState)(false);
    (0, $fV3WI.useEffect)(()=>{
        const el = $52958257575e8d33$var$unRef(target);
        if (!el) return;
        const onMouseEnter = ()=>setIsHovered(true);
        const onMouseLeave = ()=>setIsHovered(false);
        el.addEventListener("mouseenter", onMouseEnter);
        el.addEventListener("mouseleave", onMouseLeave);
        return ()=>{
            el.removeEventListener("mouseenter", onMouseEnter);
            el.removeEventListener("mouseleave", onMouseLeave);
        };
    }, [
        target
    ]);
    return isHovered;
}
/**
 * Is a feature supported in the browser or not
 *
 * @param predicate - predicate to check if the feature is supported
 *
 * @see https://react-hooks-library.vercel.app/core/useIsSupported
 */ function $52958257575e8d33$export$3537a97f5e69af55(predicate) {
    const [isSupported, setIsSupported] = (0, $fV3WI.useState)(false);
    $52958257575e8d33$export$17f7c8f694d207ce(()=>{
        setIsSupported(predicate());
    });
    return isSupported;
}
/**
 * Run a function when component is unmounted.
 *
 * @deprecated This hook breaks in React 18's strict mode, since it's not idempotent
 *
 * @param callback function to be executed
 */ function $52958257575e8d33$export$c9775f574d6946a(func) {
    (0, $fV3WI.useEffect)(()=>{
        return func;
    }, [
        func
    ]);
}
/**
 * Reactive intersection observer.
 *
 * @param target - React ref or DOM node
 * @param options - Options passed to mutation observer
 * @param callback - callback to execute when mutations are observed
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver IntersectionObserver MDN
 * @see https://react-hooks-library.vercel.app/core/useIntersectionObserver
 */ function $52958257575e8d33$export$a7395f9832c00176(target, options = {}, callback = $52958257575e8d33$var$noop) {
    const { root: root = $52958257575e8d33$var$_document , rootMargin: rootMargin = "0px" , threshold: threshold = 0  } = options;
    const [inView, setInView] = (0, $fV3WI.useState)(false);
    const [entry, setEntry] = (0, $fV3WI.useState)(null);
    const isSupported = $52958257575e8d33$export$3537a97f5e69af55(()=>"IntersectionObserver" in window);
    const observer = (0, $fV3WI.useRef)(null);
    const stop = (0, $fV3WI.useCallback)(()=>{
        if (!observer.current) return;
        observer.current.disconnect();
        observer.current = null;
    }, []);
    $52958257575e8d33$export$c9775f574d6946a(stop);
    (0, $fV3WI.useEffect)(()=>{
        var _a;
        const el = $52958257575e8d33$var$unRef(target);
        const rootEl = $52958257575e8d33$var$unRef(root);
        if (!(isSupported && el && rootEl)) return;
        observer.current = new window.IntersectionObserver((entries, observer)=>{
            const thresholds = Array.isArray(threshold) ? threshold : [
                threshold
            ];
            entries.forEach((entry)=>{
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                setInView(inView);
                setEntry(entry);
            });
            callback(entries, observer);
        }, {
            root: rootEl,
            rootMargin: rootMargin,
            threshold: threshold
        });
        (_a = observer.current) === null || _a === void 0 || _a.observe(el);
        return stop;
    }, [
        callback,
        isSupported,
        root,
        rootMargin,
        stop,
        target,
        threshold
    ]);
    return {
        isSupported: isSupported,
        stop: stop,
        inView: inView,
        entry: entry
    };
}
/**
 * Run a function repeatedly at a specified interval.
 *
 * @see https://react-hooks-library.vercel.app/core/useInterval
 */ function $52958257575e8d33$export$f4b266cd2aae9cb1(callback, delay, options) {
    const { immediate: immediate = false , paused: paused = false  } = options || {};
    const savedCallback = (0, $fV3WI.useRef)(callback);
    const tickId = (0, $fV3WI.useRef)();
    (0, $fV3WI.useEffect)(()=>{
        savedCallback.current = callback;
        if (!paused && immediate) callback();
    }, [
        callback,
        immediate,
        paused
    ]);
    (0, $fV3WI.useEffect)(()=>{
        if (tickId.current && paused) {
            clearInterval(tickId.current);
            return;
        }
        tickId.current = setInterval(()=>savedCallback.current(), delay);
        return ()=>tickId.current && clearInterval(tickId.current);
    }, [
        delay,
        paused
    ]);
}
/**
 * Listen for keyboard keys being stroked.
 *
 * @param keys
 * @param handler
 * @param options
 *
 * @see https://react-hooks-library.vercel.app/core/useKeyStroke
 */ function $52958257575e8d33$export$7063de29218d981c(keys, handler, options = {}) {
    const { target: target = $52958257575e8d33$var$_window , eventName: eventName = "keydown" , passive: passive = false , code: code = false  } = options;
    const listener = (0, $fV3WI.useCallback)((e)=>{
        const eventKey = code ? e.code : e.key;
        keys.includes(eventKey) && handler(e);
    }, [
        code,
        handler,
        keys
    ]);
    return $52958257575e8d33$export$7080b3e976bc91ab(target, eventName, listener, {
        passive: passive
    });
}
/**
 * Listen for keyboard keys on keydown.
 *
 * @param keys
 * @param handler
 * @param options
 *
 * @see https://react-hooks-library.vercel.app/core/useKeyStroke
 */ function $52958257575e8d33$export$2833a5916919d1a6(keys, handler, options = {}) {
    return $52958257575e8d33$export$7063de29218d981c(keys, handler, Object.assign(Object.assign({}, options), {
        eventName: "keydown"
    }));
}
/**
 * Listen for keyboard keys on keypress.
 *
 * @param keys
 * @param handler
 * @param options
 *
 * @see https://react-hooks-library.vercel.app/core/onKeyStroke
 */ function $52958257575e8d33$export$88fe03a37d9981dd(keys, handler, options = {}) {
    return $52958257575e8d33$export$7063de29218d981c(keys, handler, Object.assign(Object.assign({}, options), {
        eventName: "keypress"
    }));
}
/**
 * Listen for keyboard keys on keyup.
 *
 * @param keys
 * @param handler
 * @param options
 *
 * @see https://react-hooks-library.vercel.app/core/onKeyStroke
 */ function $52958257575e8d33$export$7ed39601d10cfc78(keys, handler, options = {}) {
    return $52958257575e8d33$export$7063de29218d981c(keys, handler, Object.assign(Object.assign({}, options), {
        eventName: "keyup"
    }));
}
/**
 * Modified `useState` hook that syncs with localStorage.
 *
 * @param key
 * @param initialValue
 * @param options
 *
 * @see https://react-hooks-library.vercel.app/core/useLocalStorage
 */ function $52958257575e8d33$export$86e2cef2561044ac(key, initialValue, options) {
    const [storedValue, setStoredValue] = (0, $fV3WI.useState)(initialValue);
    const { deserialize: deserialize = JSON.parse , serialize: serialize = JSON.stringify  } = options || {};
    $52958257575e8d33$export$17f7c8f694d207ce(()=>{
        try {
            const item = localStorage.getItem(key);
            item && setStoredValue(deserialize(item));
        } catch (error) {
            console.error(error);
        }
    });
    const setValue = (0, $fV3WI.useCallback)((value)=>{
        try {
            localStorage.setItem(key, serialize(value));
            setStoredValue(value);
        } catch (error) {
            console.error(error);
        }
    }, [
        key,
        serialize
    ]);
    return [
        storedValue,
        setValue
    ];
}
const $52958257575e8d33$var$buildState = (trigger)=>{
    const { state: state , length: length  } = ($52958257575e8d33$var$_window === null || $52958257575e8d33$var$_window === void 0 ? void 0 : $52958257575e8d33$var$_window.history) || {};
    const { hash: hash , host: host , hostname: hostname , href: href , origin: origin , pathname: pathname , port: port , protocol: protocol , search: search  } = ($52958257575e8d33$var$_window === null || $52958257575e8d33$var$_window === void 0 ? void 0 : $52958257575e8d33$var$_window.location) || {};
    return {
        trigger: trigger,
        state: state,
        length: length,
        hash: hash,
        host: host,
        hostname: hostname,
        href: href,
        origin: origin,
        pathname: pathname,
        port: port,
        protocol: protocol,
        search: search
    };
};
/**
 * Reactive browser location.
 *
 * @see https://react-hooks-library.vercel.app/core/useLocation
 *
 */ function $52958257575e8d33$export$45d76561a5302f2b() {
    const [state, setState] = (0, $fV3WI.useState)(null);
    $52958257575e8d33$export$17f7c8f694d207ce(()=>{
        setState($52958257575e8d33$var$buildState("load"));
    });
    $52958257575e8d33$export$7080b3e976bc91ab("popstate", ()=>setState($52958257575e8d33$var$buildState("popstate")), {
        passive: true
    });
    $52958257575e8d33$export$7080b3e976bc91ab("hashchange", ()=>setState($52958257575e8d33$var$buildState("hashchange")), {
        passive: true
    });
    return state;
}
/**
 * Reactive `mediaDevices.getUserMedia` streaming
 *
 * @param options
 *
 * @see https://react-hooks-library.vercel.app/core/useMediaStream
 */ function $52958257575e8d33$export$7c2480e3c8c31328(options = {}) {
    const { audioDeviceId: audioDeviceId , videoDeviceId: videoDeviceId , autoSwitch: autoSwitch  } = options;
    const isSupported = $52958257575e8d33$export$3537a97f5e69af55(()=>{
        var _a;
        return !!((_a = $52958257575e8d33$var$_navigator === null || $52958257575e8d33$var$_navigator === void 0 ? void 0 : $52958257575e8d33$var$_navigator.mediaDevices) === null || _a === void 0 ? void 0 : _a.getUserMedia);
    });
    const stream = (0, $fV3WI.useRef)(null);
    const ref = (0, $fV3WI.useRef)(null);
    const [isPlaying, setPlaying] = (0, $fV3WI.useState)(false);
    const [isAudioMuted, setAudioMuted] = (0, $fV3WI.useState)(false);
    const [isVideoMuted, setVideoMuted] = (0, $fV3WI.useState)(false);
    const getDeviceOptions = (0, $fV3WI.useCallback)((device)=>{
        if (device === "none" || device === false) return false;
        if (device === null) return true;
        return {
            deviceId: device
        };
    }, []);
    const play = (0, $fV3WI.useCallback)(async ()=>{
        var _a;
        if (!isSupported || stream.current) return;
        stream.current = (_a = await ($52958257575e8d33$var$_navigator === null || $52958257575e8d33$var$_navigator === void 0 ? void 0 : $52958257575e8d33$var$_navigator.mediaDevices.getUserMedia({
            video: getDeviceOptions(videoDeviceId),
            audio: getDeviceOptions(audioDeviceId)
        }))) !== null && _a !== void 0 ? _a : null;
        setPlaying(true);
        return stream.current;
    }, [
        audioDeviceId,
        getDeviceOptions,
        isSupported,
        videoDeviceId
    ]);
    const stop = (0, $fV3WI.useCallback)(()=>{
        var _a;
        setPlaying(false);
        (_a = stream.current) === null || _a === void 0 || _a.getTracks().forEach((t)=>t.stop());
        stream.current = null;
    }, []);
    const restart = (0, $fV3WI.useCallback)(async ()=>{
        stop();
        return await play();
    }, [
        play,
        stop
    ]);
    const muteAudio = (0, $fV3WI.useCallback)(()=>{
        var _a;
        setAudioMuted(true);
        (_a = stream.current) === null || _a === void 0 || _a.getAudioTracks().forEach((t)=>t.enabled = false);
    }, []);
    const unMuteAudio = (0, $fV3WI.useCallback)(()=>{
        var _a;
        setAudioMuted(false);
        (_a = stream.current) === null || _a === void 0 || _a.getAudioTracks().forEach((t)=>t.enabled = true);
    }, []);
    const muteVideo = (0, $fV3WI.useCallback)(()=>{
        var _a;
        setVideoMuted(true);
        (_a = stream.current) === null || _a === void 0 || _a.getVideoTracks().forEach((t)=>t.enabled = false);
    }, []);
    const unMuteVideo = (0, $fV3WI.useCallback)(()=>{
        var _a;
        setVideoMuted(false);
        (_a = stream.current) === null || _a === void 0 || _a.getVideoTracks().forEach((t)=>t.enabled = true);
    }, []);
    const pause = (0, $fV3WI.useCallback)(()=>{
        muteAudio();
        muteVideo();
    }, [
        muteAudio,
        muteVideo
    ]);
    const resume = (0, $fV3WI.useCallback)(()=>{
        unMuteAudio();
        unMuteVideo();
    }, [
        unMuteAudio,
        unMuteVideo
    ]);
    (0, $fV3WI.useEffect)(()=>{
        if (!ref.current) return;
        ref.current.srcObject = stream.current;
    }, [
        isPlaying
    ]);
    (0, $fV3WI.useEffect)(()=>{
        if (autoSwitch && stream.current) restart();
    }, [
        videoDeviceId,
        audioDeviceId,
        autoSwitch,
        restart
    ]);
    return {
        isSupported: isSupported,
        ref: ref,
        stream: stream,
        isPlaying: isPlaying,
        play: play,
        stop: stop,
        restart: restart,
        isAudioMuted: isAudioMuted,
        muteAudio: muteAudio,
        unMuteAudio: unMuteAudio,
        isVideoMuted: isVideoMuted,
        muteVideo: muteVideo,
        unMuteVideo: unMuteVideo,
        pause: pause,
        resume: resume,
        isPaused: isAudioMuted && isVideoMuted
    };
}
/**
 * Run a function synchronously when a component is mounted and after DOM is painted.
 *
 * @deprecated This hook breaks in React 18's strict mode, since it's not idempotent
 *
 * @param callback function to be executed
 */ function $52958257575e8d33$export$b2824085ba6f4489(callback) {
    (0, $fV3WI.useLayoutEffect)(callback, []);
}
/**
 *
 * Reactive mouse position based by page or client
 *
 * @param options
 *
 * @see https://react-hooks-library.vercel.app/core/useMouse
 */ function $52958257575e8d33$export$70811b4970b0f258(options = {}) {
    const { touch: touch = true , type: type = "client" , resetOnTouchEnds: resetOnTouchEnds = false , initialValue: initialValue = {
        x: 0,
        y: 0
    }  } = options;
    const [x, setX] = (0, $fV3WI.useState)(initialValue.x);
    const [y, setY] = (0, $fV3WI.useState)(initialValue.y);
    const [source, setSource] = (0, $fV3WI.useState)(null);
    (0, $fV3WI.useEffect)(()=>{
        const mouseHandler = (event)=>{
            setSource("mouse");
            if (type === "page") {
                setX(event.pageX);
                setY(event.pageY);
            } else if (type === "client") {
                setX(event.clientX);
                setY(event.clientY);
            }
        };
        const reset = ()=>{
            setX(initialValue.x);
            setY(initialValue.y);
        };
        const touchHandler = (event)=>{
            if (event.touches.length > 0) {
                setSource("touch");
                if (type === "page") {
                    setX(event.touches[0].pageX);
                    setY(event.touches[0].pageY);
                } else if (type === "client") {
                    setX(event.touches[0].clientX);
                    setY(event.touches[0].clientY);
                }
            }
        };
        window.addEventListener("mousemove", mouseHandler, {
            passive: true
        });
        window.addEventListener("dragover", mouseHandler, {
            passive: true
        });
        if (touch) {
            window.addEventListener("touchstart", touchHandler, {
                passive: true
            });
            window.addEventListener("touchmove", touchHandler, {
                passive: true
            });
            if (resetOnTouchEnds) window.addEventListener("touchend", reset, {
                passive: true
            });
        }
        return ()=>{
            window.removeEventListener("mousemove", mouseHandler);
            window.removeEventListener("dragover", mouseHandler);
            if (touch) {
                window.removeEventListener("touchstart", touchHandler);
                window.removeEventListener("touchmove", touchHandler);
                if (resetOnTouchEnds) window.removeEventListener("touchend", reset);
            }
        };
    }, [
        initialValue.x,
        initialValue.y,
        resetOnTouchEnds,
        touch,
        type
    ]);
    return {
        x: x,
        y: y,
        source: source
    };
}
/**
 * Watch for changes being made to the DOM tree.
 *
 * @param target - React ref or DOM node
 * @param callback - callback to execute when mutations are observed
 * @param options - Options passed to mutation observer
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver MutationObserver MDN
 * @see https://react-hooks-library.vercel.app/core/useMutationObserver
 */ function $52958257575e8d33$export$8ecdcf3bb089e9cd(target, callback, options = {}) {
    const observer = (0, $fV3WI.useRef)(null);
    const isSupported = $52958257575e8d33$export$3537a97f5e69af55(()=>!!($52958257575e8d33$var$_window === null || $52958257575e8d33$var$_window === void 0 ? void 0 : $52958257575e8d33$var$_window.IntersectionObserver));
    const stop = (0, $fV3WI.useCallback)(()=>{
        if (!observer.current) return;
        observer.current.disconnect();
        observer.current = null;
    }, []);
    $52958257575e8d33$export$c9775f574d6946a(stop);
    (0, $fV3WI.useEffect)(()=>{
        var _a;
        const el = $52958257575e8d33$var$unRef(target);
        if (!(isSupported && el && $52958257575e8d33$var$_window)) return;
        observer.current = new $52958257575e8d33$var$_window.MutationObserver(callback);
        (_a = observer.current) === null || _a === void 0 || _a.observe(el, options);
        return stop;
    }, [
        callback,
        stop,
        options,
        target,
        isSupported
    ]);
    return {
        isSupported: isSupported,
        stop: stop
    };
}
/**
 * Reactive Network status.
 *
 * @see https://react-hooks-library.vercel.app/core/useNetwork
 */ function $52958257575e8d33$export$553aaf59afc1a2d8() {
    var _a, _b, _c, _d, _e, _f;
    const isSupported = $52958257575e8d33$export$3537a97f5e69af55(()=>!!($52958257575e8d33$var$_navigator === null || $52958257575e8d33$var$_navigator === void 0 ? void 0 : $52958257575e8d33$var$_navigator.connection));
    const [isOnline, setIsOnline] = (0, $fV3WI.useState)(true);
    const [offlineAt, setOfflineAt] = (0, $fV3WI.useState)(undefined);
    const connection = (0, $fV3WI.useRef)(undefined);
    const rerender = (0, $fV3WI.useState)({})[1];
    $52958257575e8d33$export$17f7c8f694d207ce(()=>{
        if (!$52958257575e8d33$var$_navigator) return;
        setIsOnline($52958257575e8d33$var$_navigator.onLine);
        setOfflineAt(isOnline ? undefined : Date.now());
        const _connection = $52958257575e8d33$var$_navigator === null || $52958257575e8d33$var$_navigator === void 0 ? void 0 : $52958257575e8d33$var$_navigator.connection;
        if (!_connection) return;
        connection.current = _connection;
        connection.current.onchange = ()=>rerender({});
    });
    $52958257575e8d33$export$7080b3e976bc91ab("offline", ()=>{
        setIsOnline(false);
        setOfflineAt(Date.now());
    });
    $52958257575e8d33$export$7080b3e976bc91ab("online", ()=>{
        setIsOnline(true);
    });
    return {
        isSupported: isSupported,
        isOnline: isOnline,
        offlineAt: offlineAt,
        saveData: (_a = connection.current) === null || _a === void 0 ? void 0 : _a.saveData,
        rtt: (_b = connection.current) === null || _b === void 0 ? void 0 : _b.rtt,
        downlink: (_c = connection.current) === null || _c === void 0 ? void 0 : _c.downlink,
        downlinkMax: (_d = connection.current) === null || _d === void 0 ? void 0 : _d.downlinkMax,
        effectiveType: (_e = connection.current) === null || _e === void 0 ? void 0 : _e.effectiveType,
        type: (_f = connection.current) === null || _f === void 0 ? void 0 : _f.type
    };
}
/**
 * Reactive online status
 *
 * @see https://react-hooks-library.vercel.app/core/useOnline
 */ function $52958257575e8d33$export$6feb6ada280bcdab() {
    const [online, setOnline] = (0, $fV3WI.useState)(false);
    $52958257575e8d33$export$17f7c8f694d207ce(()=>{
        setOnline(navigator.onLine);
    });
    $52958257575e8d33$export$7080b3e976bc91ab("offline", ()=>{
        setOnline(false);
    });
    $52958257575e8d33$export$7080b3e976bc91ab("online", ()=>{
        setOnline(true);
    });
    return online;
}
/**
 * Reactive prefers-color-scheme media query.
 *
 * @see https://react-hooks-library.vercel.app/core/usePreferredColorScheme
 */ function $52958257575e8d33$export$7c3b8f854ca5e941() {
    const isDark = $52958257575e8d33$export$32d5543ab307c01("(prefers-color-scheme: dark)");
    return isDark ? "dark" : "light";
}
/**
 * Returns the value of the argument from the previous render
 * @param {T} value
 * @returns {T | undefined} previous value
 * @see https://react-hooks-library.vercel.app/core/usePrevious
 */ function $52958257575e8d33$export$5cae361ad82dce8b(value) {
    const ref = (0, $fV3WI.useRef)();
    (0, $fV3WI.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
/**
 * Reactive screen sharing
 *
 * @param options
 *
 * @see https://react-hooks-library.vercel.app/core/useScreenShare
 */ function $52958257575e8d33$export$c27cf6c2ce7eaf62(options = {}) {
    const { audio: audio = true , video: video = true  } = options;
    const isSupported = $52958257575e8d33$export$3537a97f5e69af55(()=>{
        var _a;
        return !!((_a = $52958257575e8d33$var$_navigator === null || $52958257575e8d33$var$_navigator === void 0 ? void 0 : $52958257575e8d33$var$_navigator.mediaDevices) === null || _a === void 0 ? void 0 : _a.getDisplayMedia);
    });
    const stream = (0, $fV3WI.useRef)(null);
    const ref = (0, $fV3WI.useRef)(null);
    const [isPlaying, setPlaying] = (0, $fV3WI.useState)(false);
    const play = (0, $fV3WI.useCallback)(async ()=>{
        var _a;
        if (!isSupported || !ref.current) return;
        stream.current = (_a = await ($52958257575e8d33$var$_navigator === null || $52958257575e8d33$var$_navigator === void 0 ? void 0 : $52958257575e8d33$var$_navigator.mediaDevices.getDisplayMedia({
            audio: audio,
            video: video
        }))) !== null && _a !== void 0 ? _a : null;
        setPlaying(true);
        return stream.current;
    }, [
        audio,
        isSupported,
        video
    ]);
    const stop = (0, $fV3WI.useCallback)(()=>{
        var _a;
        (_a = stream.current) === null || _a === void 0 || _a.getTracks().forEach((t)=>t.stop());
        stream.current = null;
        setPlaying(false);
    }, []);
    (0, $fV3WI.useEffect)(()=>{
        var _a;
        if (!ref.current) return;
        ref.current.srcObject = stream.current;
        // Handle os native stop screen sharing buttons
        (_a = stream.current) === null || _a === void 0 || _a.getVideoTracks()[0].addEventListener("ended", stop);
    }, [
        isPlaying,
        stop
    ]);
    return {
        isSupported: isSupported,
        isPlaying: isPlaying,
        ref: ref,
        stream: stream,
        play: play,
        stop: stop
    };
}
/**
 * Reactive scroll values for a react ref or a dom node
 *
 * @param target - dom node or react ref
 * @param callback - callback to run on scroll
 *
 * @see https://react-hooks-library.vercel.app/core/useScroll
 */ function $52958257575e8d33$export$d928051c8cd740b(target = $52958257575e8d33$var$_document === null || $52958257575e8d33$var$_document === void 0 ? void 0 : $52958257575e8d33$var$_document.documentElement, callback) {
    const getPositions = ()=>{
        const el = $52958257575e8d33$var$unRef(target);
        if (!el) return;
        return {
            x: $52958257575e8d33$var$round(el.scrollLeft / (el.scrollWidth - el.clientWidth)),
            y: $52958257575e8d33$var$round(el.scrollTop / (el.scrollHeight - el.clientHeight))
        };
    };
    $52958257575e8d33$export$7080b3e976bc91ab(target, "scroll", ()=>{
        const newScrollValues = getPositions();
        if (!newScrollValues) return;
        const { x: x , y: y  } = newScrollValues;
        callback({
            scrollX: x,
            scrollY: y
        });
    }, {
        capture: false,
        passive: true
    });
}
/**
 *
 * A hook to scroll an element into view on mounting.
 *
 * @param options {UseScrollIntoViewOptions}
 *
 * @see https://react-hooks-library.vercel.app/core/useScrollIntoView
 */ function $52958257575e8d33$export$c05432b4b8843105(target, options = {}) {
    const { behavior: behavior = "auto" , block: block = "start" , inline: inline = "nearest" , scrollMargin: scrollMargin = "0px" , predicate: predicate = true  } = options;
    $52958257575e8d33$export$17f7c8f694d207ce(()=>{
        const el = $52958257575e8d33$var$unRef(target);
        if (!(el && ($52958257575e8d33$var$isFunction(predicate) ? predicate() : predicate))) return;
        el.style.scrollMargin = scrollMargin;
        el.scrollIntoView({
            behavior: behavior,
            block: block,
            inline: inline
        });
    });
}
/**
 * Modified `useState` hook that syncs with useSessionStorage.
 *
 * @param key
 * @param initialValue
 * @param options
 *
 * @see https://react-hooks-library.vercel.app/core/useSessionStorage
 */ function $52958257575e8d33$export$864b6828bd07eda6(key, initialValue, options) {
    const [storedValue, setStoredValue] = (0, $fV3WI.useState)(initialValue);
    const { deserialize: deserialize = JSON.parse , serialize: serialize = JSON.stringify  } = options || {};
    $52958257575e8d33$export$17f7c8f694d207ce(()=>{
        try {
            const item = sessionStorage.getItem(key);
            item && setStoredValue(deserialize(item));
        } catch (error) {
            console.error(error);
        }
    });
    const setValue = (0, $fV3WI.useCallback)((value)=>{
        try {
            setStoredValue(value);
            sessionStorage.setItem(key, serialize(value));
        } catch (error) {
            console.error(error);
        }
    }, [
        key,
        serialize
    ]);
    return [
        storedValue,
        setValue
    ];
}
/**
 * useState hook with custom compare function to avoid re-rendering
 * when state is the same, compares with previous state
 *
 *
 * Note: create a custom compare function, outside of the hook to keep
 * a stable reference, otherwise it will be recreated on every render
 *
 * @see https://react-hooks-library.vercel.app/core/useStateCompare
 */ function $52958257575e8d33$export$df00f37a0b0b8ef7({ initialValue: initialValue , compare: compare  }) {
    const [state, _setState] = (0, $fV3WI.useState)(initialValue);
    const setState = (0, $fV3WI.useCallback)((value)=>{
        typeof value === "function" ? _setState(value) : _setState((oldValue)=>compare(oldValue, value));
    }, [
        compare
    ]);
    return [
        state,
        setState
    ];
}
/**
 *
 * useState with built in undo and redo history control
 *
 * @param defaultValue
 * @param options
 * @returns
 */ function $52958257575e8d33$export$b4effed71825dc9c(defaultValue, options = {}) {
    const { maxHistory: maxHistory = 10  } = options;
    const [state, setState] = (0, $fV3WI.useState)(defaultValue);
    const lastSaved = (0, $fV3WI.useRef)($52958257575e8d33$var$isFunction(defaultValue) ? defaultValue() : defaultValue);
    const rerender = (0, $fV3WI.useState)({})[1];
    const actionHistory = (0, $fV3WI.useRef)([]);
    const redoHistory = (0, $fV3WI.useRef)([]);
    const redoAllowed = (0, $fV3WI.useRef)(false);
    const push = (0, $fV3WI.useCallback)((value)=>{
        if (actionHistory.current.length < maxHistory) actionHistory.current.push(value);
        else {
            actionHistory.current = [
                ...actionHistory.current.slice(1),
                value
            ];
            lastSaved.current = actionHistory.current[0];
        }
        redoAllowed.current = false;
        setState(value);
    }, [
        maxHistory
    ]);
    const redo = (0, $fV3WI.useCallback)(()=>{
        if (!(redoHistory.current.length && redoAllowed.current)) return;
        const lastUndoState = redoHistory.current.pop();
        lastUndoState && push(lastUndoState);
        redoAllowed.current = true;
    }, [
        push
    ]);
    const undo = (0, $fV3WI.useCallback)(()=>{
        if (actionHistory.current.length < 1) return;
        const lastState = actionHistory.current.pop();
        lastState && redoHistory.current.push(lastState);
        const prev = actionHistory.current[actionHistory.current.length - 1];
        prev ? setState(prev) : setState(lastSaved.current);
        rerender({});
        redoAllowed.current = true;
    }, [
        rerender
    ]);
    const reset = (0, $fV3WI.useCallback)(()=>{
        var _a;
        if (!((_a = actionHistory.current) === null || _a === void 0 ? void 0 : _a.length)) return;
        setState(actionHistory.current[0]);
        actionHistory.current = [
            actionHistory.current[0]
        ];
    }, []);
    return {
        state: state,
        push: push,
        undo: undo,
        redo: redo,
        reset: reset,
        history: actionHistory.current,
        redoAllowed: redoAllowed.current
    };
}
/**
 * Reactive document title hook
 *
 * Set title or observe dom mutation reactively
 *
 * @param newTitle optional
 * @see https://react-hooks-library.vercel.app/core/useTitle
 */ function $52958257575e8d33$export$bc98e171e8c82a3d(newTitle) {
    const [title, setTitle] = (0, $fV3WI.useState)(newTitle !== null && newTitle !== void 0 ? newTitle : "");
    $52958257575e8d33$export$17f7c8f694d207ce(()=>{
        var _a;
        setTitle((_a = newTitle || ($52958257575e8d33$var$_document === null || $52958257575e8d33$var$_document === void 0 ? void 0 : $52958257575e8d33$var$_document.title)) !== null && _a !== void 0 ? _a : "");
    });
    (0, $fV3WI.useEffect)(()=>{
        document.title = title;
    }, [
        title
    ]);
    $52958257575e8d33$export$8ecdcf3bb089e9cd($52958257575e8d33$var$_document === null || $52958257575e8d33$var$_document === void 0 ? void 0 : $52958257575e8d33$var$_document.head.querySelector("title"), ()=>{
        if (document.title !== title) setTitle(document.title);
    }, {
        childList: true
    });
    return {
        title: title,
        setTitle: setTitle
    };
}
/**
 * A state toggle hook
 *
 * @param defaultValue
 * @default false
 *
 * @see https://react-hooks-library.vercel.app/core/useToggle
 */ function $52958257575e8d33$export$cbe85ee05b554577(defaultValue = false) {
    const [bool, setBool] = (0, $fV3WI.useState)(defaultValue);
    const toggle = (0, $fV3WI.useCallback)(()=>setBool((s)=>!s), []);
    const setTrue = (0, $fV3WI.useCallback)(()=>setBool(true), []);
    const setFalse = (0, $fV3WI.useCallback)(()=>setBool(false), []);
    return {
        bool: bool,
        toggle: toggle,
        setTrue: setTrue,
        setFalse: setFalse
    };
}
/**
 * Reactive window size.
 *
 * @param options
 *
 * @see https://react-hooks-library.vercel.app/core/useWindowSize
 */ function $52958257575e8d33$export$42c02f33970a2afa({ initialWidth: initialWidth = Infinity , initialHeight: initialHeight = Infinity  } = {}) {
    const [width, setWidth] = (0, $fV3WI.useState)(initialWidth);
    const [height, setHeight] = (0, $fV3WI.useState)(initialHeight);
    $52958257575e8d33$export$17f7c8f694d207ce(()=>{
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    });
    $52958257575e8d33$export$7080b3e976bc91ab("resize", ()=>{
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    }, {
        passive: true
    });
    return {
        width: width,
        height: height
    };
}

});

parcelRequire.register("baaaw", function(module, exports) {

$parcel$export(module.exports, "isClient", function () { return $8208842742b698a5$export$7383f122bf48ec30; });
$parcel$export(module.exports, "isRef", function () { return $8208842742b698a5$export$4f9f5282de18fc69; });
$parcel$export(module.exports, "isBoolean", function () { return $8208842742b698a5$export$f9ce7b637dfbe238; });
$parcel$export(module.exports, "isFunction", function () { return $8208842742b698a5$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isNumber", function () { return $8208842742b698a5$export$7e4aa119212bc614; });
$parcel$export(module.exports, "isString", function () { return $8208842742b698a5$export$844ec244b1367d54; });
$parcel$export(module.exports, "isObject", function () { return $8208842742b698a5$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isWindow", function () { return $8208842742b698a5$export$5a096129d439f843; });
$parcel$export(module.exports, "noop", function () { return $8208842742b698a5$export$8793edee2d425525; });
$parcel$export(module.exports, "rand", function () { return $8208842742b698a5$export$bb0a9c36cf454ea0; });
$parcel$export(module.exports, "round", function () { return $8208842742b698a5$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "unRef", function () { return $8208842742b698a5$export$bc8cb0924aed6c5e; });
/* eslint-disable @typescript-eslint/ban-types */ /**
 * Check if we're on the server or client side
 */ const $8208842742b698a5$export$7383f122bf48ec30 = typeof window !== "undefined";
/**
 * Check if object is a react ref
 */ const $8208842742b698a5$export$4f9f5282de18fc69 = (obj)=>obj !== null && typeof obj === "object" && Object.prototype.hasOwnProperty.call(obj, "current");
const $8208842742b698a5$var$toString = Object.prototype.toString;
const $8208842742b698a5$export$f9ce7b637dfbe238 = (val)=>typeof val === "boolean";
const $8208842742b698a5$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $8208842742b698a5$export$7e4aa119212bc614 = (val)=>typeof val === "number";
const $8208842742b698a5$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $8208842742b698a5$export$a6cdc56e425d0d0a = (val)=>$8208842742b698a5$var$toString.call(val) === "[object Object]";
const $8208842742b698a5$export$5a096129d439f843 = (val)=>typeof window !== "undefined" && $8208842742b698a5$var$toString.call(val) === "[object Window]";
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $8208842742b698a5$export$8793edee2d425525 = ()=>{};
const $8208842742b698a5$export$bb0a9c36cf454ea0 = (min, max)=>{
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
const $8208842742b698a5$export$2077e0241d6afd3c = (num)=>Math.round(num * 1e2) / 1e2;
/**
 * Accepts either a ref object or a dom node and returns a dom node
 *
 * @param target - ref or a dom node
 * @returns dom noe
 */ function $8208842742b698a5$export$bc8cb0924aed6c5e(target) {
    const element = $8208842742b698a5$export$4f9f5282de18fc69(target) ? target.current : target;
    return element;
}

});

parcelRequire.register("1Zlyw", function(module, exports) {
"use strict";
var $172c35760c65afcd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $172c35760c65afcd$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $172c35760c65afcd$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$172c35760c65afcd$var$__exportStar((parcelRequire("bmiAM")), module.exports);

});
parcelRequire.register("bmiAM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigProvider = module.exports.ConfigContext = void 0;

var $3DnwL = parcelRequire("3DnwL");

var $fV3WI = parcelRequire("fV3WI");
module.exports.ConfigContext = (0, $fV3WI.createContext)(undefined);
const $84502bd54c7f1504$var$fetchConfig = (name, url)=>fetch(url).then((response)=>response.json()).then((config)=>[
            name,
            config
        ]);
const $84502bd54c7f1504$var$ConfigProvider = ({ items: items , children: children  })=>{
    const [config, setConfig] = (0, $fV3WI.useState)(null);
    (0, $fV3WI.useEffect)(()=>{
        Promise.all(items.map(({ name: name , url: url  })=>$84502bd54c7f1504$var$fetchConfig(name, url))).then((results)=>{
            setConfig(Object.fromEntries(results));
        }).catch((error)=>{
            setConfig(error);
        });
    }, [
        items
    ]);
    return (0, $3DnwL.jsx)(module.exports.ConfigContext.Provider, {
        value: config,
        children: children
    });
};
module.exports.ConfigProvider = $84502bd54c7f1504$var$ConfigProvider;

});


parcelRequire.register("gwewq", function(module, exports) {
"use strict";
var $c06ae63f9e71601f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c06ae63f9e71601f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c06ae63f9e71601f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c06ae63f9e71601f$var$__exportStar((parcelRequire("hSRrZ")), module.exports);

$c06ae63f9e71601f$var$__exportStar((parcelRequire("jvPlR")), module.exports);

$c06ae63f9e71601f$var$__exportStar((parcelRequire("4CCI3")), module.exports);

$c06ae63f9e71601f$var$__exportStar((parcelRequire("fwYWm")), module.exports);

$c06ae63f9e71601f$var$__exportStar((parcelRequire("buU4n")), module.exports);

$c06ae63f9e71601f$var$__exportStar((parcelRequire("mwWAD")), module.exports);

});
parcelRequire.register("hSRrZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useConfig = void 0;

var $fV3WI = parcelRequire("fV3WI");

var $1Zlyw = parcelRequire("1Zlyw");
const $d050f0f5f3e8850b$var$useConfig = ()=>{
    const config = (0, $fV3WI.useContext)($1Zlyw.ConfigContext);
    if (config instanceof Error) {
        config.message = `Error while fetching the application config: ${config.message}`;
        throw config;
    }
    if (config === undefined) throw Error("useConfig must be used within a ConfigProvider tag");
    return config;
};
module.exports.useConfig = $d050f0f5f3e8850b$var$useConfig;

});

parcelRequire.register("jvPlR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useDocumentTitle = module.exports.usePureDocumentTitle = void 0;

var $fV3WI = parcelRequire("fV3WI");
function $e348beec7853632e$var$usePureDocumentTitle(title, retainOnUnmount = false) {
    const defaultTitle = (0, $fV3WI.useRef)(document.title);
    (0, $fV3WI.useEffect)(()=>{
        document.title = title;
    }, [
        title
    ]);
    (0, $fV3WI.useEffect)(()=>{
        return ()=>{
            if (!retainOnUnmount) document.title = defaultTitle.current;
        };
    }, []);
}
module.exports.usePureDocumentTitle = $e348beec7853632e$var$usePureDocumentTitle;
const $e348beec7853632e$var$useDocumentTitle = (value)=>{
    let pageTitle = "Mineko.de";
    if (value) pageTitle = `${value} | ${pageTitle}`;
    $e348beec7853632e$var$usePureDocumentTitle(pageTitle);
};
module.exports.useDocumentTitle = $e348beec7853632e$var$useDocumentTitle;

});

parcelRequire.register("4CCI3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useQueryParams = void 0;
const $35d8bcf2ff730ef1$var$useQueryParams = ()=>{
    const urlParams = new URLSearchParams(window.location.search);
    return Array.from(new URLSearchParams(window.location.search).entries()).reduce((prev, [key])=>{
        let keyValue = urlParams.get(key);
        if (key.endsWith("[]")) keyValue = urlParams.getAll(key);
        return {
            ...prev,
            [`${key.replace("[]", "")}`]: keyValue
        };
    }, {});
};
module.exports.useQueryParams = $35d8bcf2ff730ef1$var$useQueryParams;

});

parcelRequire.register("fwYWm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFormState = void 0;

var $fV3WI = parcelRequire("fV3WI");
const $b4e91dac3f8cb4c1$var$useFormState = (initialState = "")=>{
    const [state, setState] = (0, $fV3WI.useState)(initialState);
    const setFormState = (e)=>setState(e.target.value);
    return [
        state,
        setFormState
    ];
};
module.exports.useFormState = $b4e91dac3f8cb4c1$var$useFormState;

});

parcelRequire.register("buU4n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useKeyPress = void 0;

var $fV3WI = parcelRequire("fV3WI");
const $85edfd490cbb66e6$var$useKeyPress = (targetKey)=>{
    const [keyPressed, setKeyPressed] = (0, $fV3WI.useState)(false);
    (0, $fV3WI.useEffect)(()=>{
        const handler = (val)=>({ key: key  })=>key === targetKey && setKeyPressed(val);
        const downHandler = handler(true);
        const upHandler = handler(false);
        window.addEventListener("keydown", downHandler);
        window.addEventListener("keyup", upHandler);
        return ()=>{
            window.removeEventListener("keydown", downHandler);
            window.removeEventListener("keyup", upHandler);
        };
    }, [
        targetKey
    ]);
    return keyPressed;
};
module.exports.useKeyPress = $85edfd490cbb66e6$var$useKeyPress;

});

parcelRequire.register("mwWAD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useOnBeforeUnload = void 0;

var $fV3WI = parcelRequire("fV3WI");
const $043b9c2e4fa7bc3f$var$useOnBeforeUnload = (callback)=>{
    const callbackRef = (0, $fV3WI.useRef)(callback);
    (0, $fV3WI.useEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    (0, $fV3WI.useEffect)(()=>{
        const cb = ()=>{
            callbackRef.current();
        };
        window.addEventListener("beforeunload", cb);
        return ()=>{
            window.removeEventListener("beforeunload", cb);
        };
    }, []);
};
module.exports.useOnBeforeUnload = $043b9c2e4fa7bc3f$var$useOnBeforeUnload;

});



parcelRequire.register("67qMW", function(module, exports) {
/* global window */ 
var $i5gZK = parcelRequire("i5gZK");
var root;
if (typeof self !== "undefined") root = self;
else if (typeof window !== "undefined") root = window;
else if (typeof $parcel$global !== "undefined") root = $parcel$global;
else root = module;
var result = (0, $i5gZK.default)(root);
var $47482d1f46af603d$export$2e2bcd8739ae039 = result;

});
parcelRequire.register("i5gZK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2a5e07bdda27618$export$2e2bcd8739ae039; });
function $d2a5e07bdda27618$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === "function") {
        if (Symbol.observable) result = Symbol.observable;
        else {
            if (typeof Symbol.for === "function") // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = Symbol.for("https://github.com/benlesh/symbol-observable");
            else // Symbol.for didn't exist! The best we can do at this point is a totally 
            // unique symbol. Note that the string argument here is a descriptor, not
            // an identifier. This symbol is unique.
            result = Symbol("https://github.com/benlesh/symbol-observable");
            try {
                Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = "@@observable";
    return result;
}

});


parcelRequire.register("66QfP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/*
Copyright 2017 - 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with the License. A copy of the License is located at
    http://aws.amazon.com/apache2.0/
or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and limitations under the License.
*/ $parcel$global.Buffer = $parcel$global.Buffer || (parcelRequire("5oOz5")).Buffer; // Required for aws sigv4 signing

var $i3eDV = parcelRequire("i3eDV");

var $6wRaM = parcelRequire("6wRaM");
var $472bd6403c95718e$require$Sha256 = $6wRaM.Sha256;

var $7QIMp = parcelRequire("7QIMp");
var $472bd6403c95718e$require$toHex = $7QIMp.toHex;
var $472bd6403c95718e$var$encrypt = function(key, src, encoding) {
    if (encoding === void 0) encoding = "";
    var hash = new $472bd6403c95718e$require$Sha256(key);
    hash.update(src);
    var result = hash.digestSync();
    if (encoding === "hex") return $472bd6403c95718e$require$toHex(result);
    return result;
};
var $472bd6403c95718e$var$hash = function(src) {
    var arg = src || "";
    var hash = new $472bd6403c95718e$require$Sha256();
    hash.update(arg);
    return $472bd6403c95718e$require$toHex(hash.digestSync());
};
/**
* @private
* Create canonical headers
*
<pre>
CanonicalHeaders =
    CanonicalHeadersEntry0 + CanonicalHeadersEntry1 + ... + CanonicalHeadersEntryN
CanonicalHeadersEntry =
    Lowercase(HeaderName) + ':' + Trimall(HeaderValue) + '\n'
</pre>
*/ var $472bd6403c95718e$var$canonical_headers = function(headers) {
    if (!headers || Object.keys(headers).length === 0) return "";
    return Object.keys(headers).map(function(key) {
        return {
            key: key.toLowerCase(),
            value: headers[key] ? headers[key].trim().replace(/\s+/g, " ") : ""
        };
    }).sort(function(a, b) {
        return a.key < b.key ? -1 : 1;
    }).map(function(item) {
        return item.key + ":" + item.value;
    }).join("\n") + "\n";
};
/**
* List of header keys included in the canonical headers.
* @access private
*/ var $472bd6403c95718e$var$signed_headers = function(headers) {
    return Object.keys(headers).map(function(key) {
        return key.toLowerCase();
    }).sort().join(";");
};
/**
* @private
* Create canonical request
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-canonical-request.html|Create a Canonical Request}
*
<pre>
CanonicalRequest =
    HTTPRequestMethod + '\n' +
    CanonicalURI + '\n' +
    CanonicalQueryString + '\n' +
    CanonicalHeaders + '\n' +
    SignedHeaders + '\n' +
    HexEncode(Hash(RequestPayload))
</pre>
*/ var $472bd6403c95718e$var$canonical_request = function(request) {
    var url_info = $i3eDV.parse(request.url);
    return [
        request.method || "/",
        url_info.path,
        url_info.query,
        $472bd6403c95718e$var$canonical_headers(request.headers),
        $472bd6403c95718e$var$signed_headers(request.headers),
        $472bd6403c95718e$var$hash(request.body)
    ].join("\n");
};
var $472bd6403c95718e$var$parse_service_info = function(request) {
    var url_info = $i3eDV.parse(request.url), host = url_info.host;
    var matched = host.match(/([^.]+)\.(?:([^.]*)\.)?amazonaws\.com$/), parsed = (matched || []).slice(1, 3);
    if (parsed[1] === "es") parsed = parsed.reverse();
    return {
        service: request.service || parsed[0],
        region: request.region || parsed[1]
    };
};
var $472bd6403c95718e$var$credential_scope = function(d_str, region, service) {
    return [
        d_str,
        region,
        service,
        "aws4_request"
    ].join("/");
};
/**
* @private
* Create a string to sign
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-string-to-sign.html|Create String to Sign}
*
<pre>
StringToSign =
    Algorithm + \n +
    RequestDateTime + \n +
    CredentialScope + \n +
    HashedCanonicalRequest
</pre>
*/ var $472bd6403c95718e$var$string_to_sign = function(algorithm, canonical_request, dt_str, scope) {
    return [
        algorithm,
        dt_str,
        scope,
        $472bd6403c95718e$var$hash(canonical_request)
    ].join("\n");
};
/**
* @private
* Create signing key
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-calculate-signature.html|Calculate Signature}
*
<pre>
kSecret = your secret access key
kDate = HMAC("AWS4" + kSecret, Date)
kRegion = HMAC(kDate, Region)
kService = HMAC(kRegion, Service)
kSigning = HMAC(kService, "aws4_request")
</pre>
*/ var $472bd6403c95718e$var$get_signing_key = function(secret_key, d_str, service_info) {
    if (secret_key === void 0) secret_key = "";
    var k = "AWS4" + secret_key, k_date = $472bd6403c95718e$var$encrypt(k, d_str), k_region = $472bd6403c95718e$var$encrypt(k_date, service_info.region), k_service = $472bd6403c95718e$var$encrypt(k_region, service_info.service), k_signing = $472bd6403c95718e$var$encrypt(k_service, "aws4_request");
    return k_signing;
};
var $472bd6403c95718e$var$get_signature = function(signing_key, str_to_sign) {
    return $472bd6403c95718e$var$encrypt(signing_key, str_to_sign, "hex");
};
/**
* @private
* Create authorization header
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html|Add the Signing Information}
*/ var $472bd6403c95718e$var$get_authorization_header = function(algorithm, access_key, scope, signed_headers, signature) {
    if (access_key === void 0) access_key = "";
    return [
        algorithm + " " + "Credential=" + access_key + "/" + scope,
        "SignedHeaders=" + signed_headers,
        "Signature=" + signature
    ].join(", ");
};
/**
* Sign a HTTP request, add 'Authorization' header to request param
* @method sign
* @memberof Signer
* @static
*
* @param {object} request - HTTP request object
<pre>
request: {
    method: GET | POST | PUT ...
    url: ...,
    headers: {
        header1: ...
    },
    body: data
}
</pre>
* @param {object} access_info - AWS access credential info
<pre>
access_info: {
    access_key: ...,
    secret_key: ...,
    session_token: ...
}
</pre>
* @param {object} [service_info] - AWS service type and region, optional,
*                                  if not provided then parse out from url
<pre>
service_info: {
    service: ...,
    region: ...
}
</pre>
*
* @returns {object} Signed HTTP request
*/ var $472bd6403c95718e$var$sign = function(request, access_info, service_info) {
    if (service_info === void 0) service_info = null;
    request.headers = request.headers || {};
    // datetime string and date string
    var dt = new Date(), dt_str = dt.toISOString().replace(/[:-]|\.\d{3}/g, ""), d_str = dt_str.substr(0, 8), algorithm = "AWS4-HMAC-SHA256";
    var url_info = $i3eDV.parse(request.url);
    request.headers["host"] = url_info.host;
    request.headers["x-amz-date"] = dt_str;
    if (access_info.session_token) request.headers["X-Amz-Security-Token"] = access_info.session_token;
    // Task 1: Create a Canonical Request
    var request_str = $472bd6403c95718e$var$canonical_request(request);
    // Task 2: Create a String to Sign
    service_info = service_info || $472bd6403c95718e$var$parse_service_info(request);
    var scope = $472bd6403c95718e$var$credential_scope(d_str, service_info.region, service_info.service);
    var str_to_sign = $472bd6403c95718e$var$string_to_sign(algorithm, request_str, dt_str, scope);
    // Task 3: Calculate the Signature
    var signing_key = $472bd6403c95718e$var$get_signing_key(access_info.secret_key, d_str, service_info), signature = $472bd6403c95718e$var$get_signature(signing_key, str_to_sign);
    // Task 4: Adding the Signing information to the Request
    var authorization_header = $472bd6403c95718e$var$get_authorization_header(algorithm, access_info.access_key, scope, $472bd6403c95718e$var$signed_headers(request.headers), signature);
    request.headers["Authorization"] = authorization_header;
    return request;
};
/**
* AWS request signer.
* Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4_signing.html|Signature Version 4}
*
* @class Signer
*/ var $472bd6403c95718e$var$Signer = /** @class */ function() {
    function Signer() {}
    Signer.sign = $472bd6403c95718e$var$sign;
    return Signer;
}();
module.exports.Signer = $472bd6403c95718e$var$Signer;
module.exports.default = $472bd6403c95718e$var$Signer;

});
parcelRequire.register("5oOz5", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $3ee66ac28ed7332d$export$a143d493d941bafc; }, function (v) { return $3ee66ac28ed7332d$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $3ee66ac28ed7332d$export$f99ded8fe4b79145; }, function (v) { return $3ee66ac28ed7332d$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $3ee66ac28ed7332d$export$a143d493d941bafc;
var $3ee66ac28ed7332d$export$e4cf37d7f6fb9e0a;
var $3ee66ac28ed7332d$export$f99ded8fe4b79145;
var $3ee66ac28ed7332d$export$599f31c3813fae4d;
"use strict";

var $RyRJ6 = parcelRequire("RyRJ6");

var $kjGnt = parcelRequire("kjGnt");
const $3ee66ac28ed7332d$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$3ee66ac28ed7332d$export$a143d493d941bafc = $3ee66ac28ed7332d$var$Buffer;
$3ee66ac28ed7332d$export$e4cf37d7f6fb9e0a = $3ee66ac28ed7332d$var$SlowBuffer;
$3ee66ac28ed7332d$export$f99ded8fe4b79145 = 50;
const $3ee66ac28ed7332d$var$K_MAX_LENGTH = 0x7fffffff;
$3ee66ac28ed7332d$export$599f31c3813fae4d = $3ee66ac28ed7332d$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $3ee66ac28ed7332d$var$Buffer.TYPED_ARRAY_SUPPORT = $3ee66ac28ed7332d$var$typedArraySupport();
if (!$3ee66ac28ed7332d$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $3ee66ac28ed7332d$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($3ee66ac28ed7332d$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$3ee66ac28ed7332d$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($3ee66ac28ed7332d$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$3ee66ac28ed7332d$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $3ee66ac28ed7332d$var$createBuffer(length) {
    if (length > $3ee66ac28ed7332d$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $3ee66ac28ed7332d$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $3ee66ac28ed7332d$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $3ee66ac28ed7332d$var$allocUnsafe(arg);
    }
    return $3ee66ac28ed7332d$var$from(arg, encodingOrOffset, length);
}
$3ee66ac28ed7332d$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $3ee66ac28ed7332d$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $3ee66ac28ed7332d$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $3ee66ac28ed7332d$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($3ee66ac28ed7332d$var$isInstance(value, ArrayBuffer) || value && $3ee66ac28ed7332d$var$isInstance(value.buffer, ArrayBuffer)) return $3ee66ac28ed7332d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($3ee66ac28ed7332d$var$isInstance(value, SharedArrayBuffer) || value && $3ee66ac28ed7332d$var$isInstance(value.buffer, SharedArrayBuffer))) return $3ee66ac28ed7332d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $3ee66ac28ed7332d$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $3ee66ac28ed7332d$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $3ee66ac28ed7332d$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $3ee66ac28ed7332d$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $3ee66ac28ed7332d$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($3ee66ac28ed7332d$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($3ee66ac28ed7332d$var$Buffer, Uint8Array);
function $3ee66ac28ed7332d$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $3ee66ac28ed7332d$var$alloc(size, fill, encoding) {
    $3ee66ac28ed7332d$var$assertSize(size);
    if (size <= 0) return $3ee66ac28ed7332d$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $3ee66ac28ed7332d$var$createBuffer(size).fill(fill, encoding) : $3ee66ac28ed7332d$var$createBuffer(size).fill(fill);
    return $3ee66ac28ed7332d$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $3ee66ac28ed7332d$var$Buffer.alloc = function(size, fill, encoding) {
    return $3ee66ac28ed7332d$var$alloc(size, fill, encoding);
};
function $3ee66ac28ed7332d$var$allocUnsafe(size) {
    $3ee66ac28ed7332d$var$assertSize(size);
    return $3ee66ac28ed7332d$var$createBuffer(size < 0 ? 0 : $3ee66ac28ed7332d$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $3ee66ac28ed7332d$var$Buffer.allocUnsafe = function(size) {
    return $3ee66ac28ed7332d$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $3ee66ac28ed7332d$var$Buffer.allocUnsafeSlow = function(size) {
    return $3ee66ac28ed7332d$var$allocUnsafe(size);
};
function $3ee66ac28ed7332d$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$3ee66ac28ed7332d$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $3ee66ac28ed7332d$var$byteLength(string, encoding) | 0;
    let buf = $3ee66ac28ed7332d$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $3ee66ac28ed7332d$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $3ee66ac28ed7332d$var$checked(array.length) | 0;
    const buf = $3ee66ac28ed7332d$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $3ee66ac28ed7332d$var$fromArrayView(arrayView) {
    if ($3ee66ac28ed7332d$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $3ee66ac28ed7332d$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $3ee66ac28ed7332d$var$fromArrayLike(arrayView);
}
function $3ee66ac28ed7332d$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $3ee66ac28ed7332d$var$Buffer.prototype);
    return buf;
}
function $3ee66ac28ed7332d$var$fromObject(obj) {
    if ($3ee66ac28ed7332d$var$Buffer.isBuffer(obj)) {
        const len = $3ee66ac28ed7332d$var$checked(obj.length) | 0;
        const buf = $3ee66ac28ed7332d$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $3ee66ac28ed7332d$var$numberIsNaN(obj.length)) return $3ee66ac28ed7332d$var$createBuffer(0);
        return $3ee66ac28ed7332d$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $3ee66ac28ed7332d$var$fromArrayLike(obj.data);
}
function $3ee66ac28ed7332d$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $3ee66ac28ed7332d$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $3ee66ac28ed7332d$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $3ee66ac28ed7332d$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $3ee66ac28ed7332d$var$Buffer.alloc(+length);
}
$3ee66ac28ed7332d$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $3ee66ac28ed7332d$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$3ee66ac28ed7332d$var$Buffer.compare = function compare(a, b) {
    if ($3ee66ac28ed7332d$var$isInstance(a, Uint8Array)) a = $3ee66ac28ed7332d$var$Buffer.from(a, a.offset, a.byteLength);
    if ($3ee66ac28ed7332d$var$isInstance(b, Uint8Array)) b = $3ee66ac28ed7332d$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$3ee66ac28ed7332d$var$Buffer.isBuffer(a) || !$3ee66ac28ed7332d$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$3ee66ac28ed7332d$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$3ee66ac28ed7332d$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $3ee66ac28ed7332d$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $3ee66ac28ed7332d$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($3ee66ac28ed7332d$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$3ee66ac28ed7332d$var$Buffer.isBuffer(buf)) buf = $3ee66ac28ed7332d$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$3ee66ac28ed7332d$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $3ee66ac28ed7332d$var$byteLength(string, encoding) {
    if ($3ee66ac28ed7332d$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $3ee66ac28ed7332d$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $3ee66ac28ed7332d$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $3ee66ac28ed7332d$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $3ee66ac28ed7332d$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$3ee66ac28ed7332d$var$Buffer.byteLength = $3ee66ac28ed7332d$var$byteLength;
function $3ee66ac28ed7332d$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $3ee66ac28ed7332d$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $3ee66ac28ed7332d$var$utf8Slice(this, start, end);
        case "ascii":
            return $3ee66ac28ed7332d$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $3ee66ac28ed7332d$var$latin1Slice(this, start, end);
        case "base64":
            return $3ee66ac28ed7332d$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $3ee66ac28ed7332d$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$3ee66ac28ed7332d$var$Buffer.prototype._isBuffer = true;
function $3ee66ac28ed7332d$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$3ee66ac28ed7332d$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$3ee66ac28ed7332d$var$swap(this, i, i + 1);
    return this;
};
$3ee66ac28ed7332d$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $3ee66ac28ed7332d$var$swap(this, i, i + 3);
        $3ee66ac28ed7332d$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$3ee66ac28ed7332d$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $3ee66ac28ed7332d$var$swap(this, i, i + 7);
        $3ee66ac28ed7332d$var$swap(this, i + 1, i + 6);
        $3ee66ac28ed7332d$var$swap(this, i + 2, i + 5);
        $3ee66ac28ed7332d$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$3ee66ac28ed7332d$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $3ee66ac28ed7332d$var$utf8Slice(this, 0, length);
    return $3ee66ac28ed7332d$var$slowToString.apply(this, arguments);
};
$3ee66ac28ed7332d$var$Buffer.prototype.toLocaleString = $3ee66ac28ed7332d$var$Buffer.prototype.toString;
$3ee66ac28ed7332d$var$Buffer.prototype.equals = function equals(b) {
    if (!$3ee66ac28ed7332d$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $3ee66ac28ed7332d$var$Buffer.compare(this, b) === 0;
};
$3ee66ac28ed7332d$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $3ee66ac28ed7332d$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($3ee66ac28ed7332d$var$customInspectSymbol) $3ee66ac28ed7332d$var$Buffer.prototype[$3ee66ac28ed7332d$var$customInspectSymbol] = $3ee66ac28ed7332d$var$Buffer.prototype.inspect;
$3ee66ac28ed7332d$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($3ee66ac28ed7332d$var$isInstance(target, Uint8Array)) target = $3ee66ac28ed7332d$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$3ee66ac28ed7332d$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $3ee66ac28ed7332d$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($3ee66ac28ed7332d$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $3ee66ac28ed7332d$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($3ee66ac28ed7332d$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $3ee66ac28ed7332d$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $3ee66ac28ed7332d$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $3ee66ac28ed7332d$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$3ee66ac28ed7332d$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$3ee66ac28ed7332d$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $3ee66ac28ed7332d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$3ee66ac28ed7332d$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $3ee66ac28ed7332d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $3ee66ac28ed7332d$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($3ee66ac28ed7332d$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $3ee66ac28ed7332d$var$utf8Write(buf, string, offset, length) {
    return $3ee66ac28ed7332d$var$blitBuffer($3ee66ac28ed7332d$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $3ee66ac28ed7332d$var$asciiWrite(buf, string, offset, length) {
    return $3ee66ac28ed7332d$var$blitBuffer($3ee66ac28ed7332d$var$asciiToBytes(string), buf, offset, length);
}
function $3ee66ac28ed7332d$var$base64Write(buf, string, offset, length) {
    return $3ee66ac28ed7332d$var$blitBuffer($3ee66ac28ed7332d$var$base64ToBytes(string), buf, offset, length);
}
function $3ee66ac28ed7332d$var$ucs2Write(buf, string, offset, length) {
    return $3ee66ac28ed7332d$var$blitBuffer($3ee66ac28ed7332d$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$3ee66ac28ed7332d$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $3ee66ac28ed7332d$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $3ee66ac28ed7332d$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $3ee66ac28ed7332d$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $3ee66ac28ed7332d$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $3ee66ac28ed7332d$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$3ee66ac28ed7332d$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $3ee66ac28ed7332d$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $RyRJ6.fromByteArray(buf);
    else return $RyRJ6.fromByteArray(buf.slice(start, end));
}
function $3ee66ac28ed7332d$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $3ee66ac28ed7332d$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $3ee66ac28ed7332d$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $3ee66ac28ed7332d$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $3ee66ac28ed7332d$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $3ee66ac28ed7332d$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $3ee66ac28ed7332d$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $3ee66ac28ed7332d$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $3ee66ac28ed7332d$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $3ee66ac28ed7332d$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $3ee66ac28ed7332d$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$3ee66ac28ed7332d$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $3ee66ac28ed7332d$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $3ee66ac28ed7332d$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$3ee66ac28ed7332d$var$Buffer.prototype.readUintLE = $3ee66ac28ed7332d$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$3ee66ac28ed7332d$var$Buffer.prototype.readUintBE = $3ee66ac28ed7332d$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$3ee66ac28ed7332d$var$Buffer.prototype.readUint8 = $3ee66ac28ed7332d$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$3ee66ac28ed7332d$var$Buffer.prototype.readUint16LE = $3ee66ac28ed7332d$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$3ee66ac28ed7332d$var$Buffer.prototype.readUint16BE = $3ee66ac28ed7332d$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$3ee66ac28ed7332d$var$Buffer.prototype.readUint32LE = $3ee66ac28ed7332d$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$3ee66ac28ed7332d$var$Buffer.prototype.readUint32BE = $3ee66ac28ed7332d$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$3ee66ac28ed7332d$var$Buffer.prototype.readBigUInt64LE = $3ee66ac28ed7332d$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $3ee66ac28ed7332d$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3ee66ac28ed7332d$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$3ee66ac28ed7332d$var$Buffer.prototype.readBigUInt64BE = $3ee66ac28ed7332d$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $3ee66ac28ed7332d$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3ee66ac28ed7332d$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$3ee66ac28ed7332d$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3ee66ac28ed7332d$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$3ee66ac28ed7332d$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$3ee66ac28ed7332d$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3ee66ac28ed7332d$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$3ee66ac28ed7332d$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$3ee66ac28ed7332d$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$3ee66ac28ed7332d$var$Buffer.prototype.readBigInt64LE = $3ee66ac28ed7332d$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $3ee66ac28ed7332d$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3ee66ac28ed7332d$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$3ee66ac28ed7332d$var$Buffer.prototype.readBigInt64BE = $3ee66ac28ed7332d$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $3ee66ac28ed7332d$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $3ee66ac28ed7332d$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$3ee66ac28ed7332d$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkOffset(offset, 4, this.length);
    return $kjGnt.read(this, offset, true, 23, 4);
};
$3ee66ac28ed7332d$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkOffset(offset, 4, this.length);
    return $kjGnt.read(this, offset, false, 23, 4);
};
$3ee66ac28ed7332d$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkOffset(offset, 8, this.length);
    return $kjGnt.read(this, offset, true, 52, 8);
};
$3ee66ac28ed7332d$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkOffset(offset, 8, this.length);
    return $kjGnt.read(this, offset, false, 52, 8);
};
function $3ee66ac28ed7332d$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$3ee66ac28ed7332d$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$3ee66ac28ed7332d$var$Buffer.prototype.writeUintLE = $3ee66ac28ed7332d$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3ee66ac28ed7332d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3ee66ac28ed7332d$var$Buffer.prototype.writeUintBE = $3ee66ac28ed7332d$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $3ee66ac28ed7332d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$3ee66ac28ed7332d$var$Buffer.prototype.writeUint8 = $3ee66ac28ed7332d$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$3ee66ac28ed7332d$var$Buffer.prototype.writeUint16LE = $3ee66ac28ed7332d$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3ee66ac28ed7332d$var$Buffer.prototype.writeUint16BE = $3ee66ac28ed7332d$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3ee66ac28ed7332d$var$Buffer.prototype.writeUint32LE = $3ee66ac28ed7332d$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$3ee66ac28ed7332d$var$Buffer.prototype.writeUint32BE = $3ee66ac28ed7332d$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $3ee66ac28ed7332d$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $3ee66ac28ed7332d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $3ee66ac28ed7332d$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $3ee66ac28ed7332d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$3ee66ac28ed7332d$var$Buffer.prototype.writeBigUInt64LE = $3ee66ac28ed7332d$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $3ee66ac28ed7332d$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$3ee66ac28ed7332d$var$Buffer.prototype.writeBigUInt64BE = $3ee66ac28ed7332d$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $3ee66ac28ed7332d$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$3ee66ac28ed7332d$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3ee66ac28ed7332d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3ee66ac28ed7332d$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $3ee66ac28ed7332d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$3ee66ac28ed7332d$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$3ee66ac28ed7332d$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$3ee66ac28ed7332d$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$3ee66ac28ed7332d$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$3ee66ac28ed7332d$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$3ee66ac28ed7332d$var$Buffer.prototype.writeBigInt64LE = $3ee66ac28ed7332d$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $3ee66ac28ed7332d$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$3ee66ac28ed7332d$var$Buffer.prototype.writeBigInt64BE = $3ee66ac28ed7332d$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $3ee66ac28ed7332d$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $3ee66ac28ed7332d$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $3ee66ac28ed7332d$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $kjGnt.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$3ee66ac28ed7332d$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $3ee66ac28ed7332d$var$writeFloat(this, value, offset, true, noAssert);
};
$3ee66ac28ed7332d$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $3ee66ac28ed7332d$var$writeFloat(this, value, offset, false, noAssert);
};
function $3ee66ac28ed7332d$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $3ee66ac28ed7332d$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $kjGnt.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$3ee66ac28ed7332d$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $3ee66ac28ed7332d$var$writeDouble(this, value, offset, true, noAssert);
};
$3ee66ac28ed7332d$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $3ee66ac28ed7332d$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$3ee66ac28ed7332d$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$3ee66ac28ed7332d$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$3ee66ac28ed7332d$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$3ee66ac28ed7332d$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $3ee66ac28ed7332d$var$Buffer.isBuffer(val) ? val : $3ee66ac28ed7332d$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $3ee66ac28ed7332d$var$errors = {};
function $3ee66ac28ed7332d$var$E(sym, getMessage, Base) {
    $3ee66ac28ed7332d$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$3ee66ac28ed7332d$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$3ee66ac28ed7332d$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$3ee66ac28ed7332d$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $3ee66ac28ed7332d$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $3ee66ac28ed7332d$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $3ee66ac28ed7332d$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $3ee66ac28ed7332d$var$checkBounds(buf, offset, byteLength) {
    $3ee66ac28ed7332d$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $3ee66ac28ed7332d$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $3ee66ac28ed7332d$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $3ee66ac28ed7332d$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $3ee66ac28ed7332d$var$checkBounds(buf, offset, byteLength);
}
function $3ee66ac28ed7332d$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $3ee66ac28ed7332d$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $3ee66ac28ed7332d$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $3ee66ac28ed7332d$var$validateNumber(value, type);
        throw new $3ee66ac28ed7332d$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $3ee66ac28ed7332d$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $3ee66ac28ed7332d$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $3ee66ac28ed7332d$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $3ee66ac28ed7332d$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($3ee66ac28ed7332d$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $3ee66ac28ed7332d$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $3ee66ac28ed7332d$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $3ee66ac28ed7332d$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $3ee66ac28ed7332d$var$base64ToBytes(str) {
    return $RyRJ6.toByteArray($3ee66ac28ed7332d$var$base64clean(str));
}
function $3ee66ac28ed7332d$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $3ee66ac28ed7332d$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $3ee66ac28ed7332d$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $3ee66ac28ed7332d$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $3ee66ac28ed7332d$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $3ee66ac28ed7332d$var$BufferBigIntNotDefined : fn;
}
function $3ee66ac28ed7332d$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRequire.register("RyRJ6", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $0a0ffeecb862b12b$export$d622b2ad8d90c771; }, function (v) { return $0a0ffeecb862b12b$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $0a0ffeecb862b12b$export$6100ba28696e12de; }, function (v) { return $0a0ffeecb862b12b$export$6100ba28696e12de = v; });
var $0a0ffeecb862b12b$export$a48f0734ac7c2329;
var $0a0ffeecb862b12b$export$d622b2ad8d90c771;
var $0a0ffeecb862b12b$export$6100ba28696e12de;
"use strict";
$0a0ffeecb862b12b$export$a48f0734ac7c2329 = $0a0ffeecb862b12b$var$byteLength;
$0a0ffeecb862b12b$export$d622b2ad8d90c771 = $0a0ffeecb862b12b$var$toByteArray;
$0a0ffeecb862b12b$export$6100ba28696e12de = $0a0ffeecb862b12b$var$fromByteArray;
var $0a0ffeecb862b12b$var$lookup = [];
var $0a0ffeecb862b12b$var$revLookup = [];
var $0a0ffeecb862b12b$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $0a0ffeecb862b12b$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $0a0ffeecb862b12b$var$i = 0, $0a0ffeecb862b12b$var$len = $0a0ffeecb862b12b$var$code.length; $0a0ffeecb862b12b$var$i < $0a0ffeecb862b12b$var$len; ++$0a0ffeecb862b12b$var$i){
    $0a0ffeecb862b12b$var$lookup[$0a0ffeecb862b12b$var$i] = $0a0ffeecb862b12b$var$code[$0a0ffeecb862b12b$var$i];
    $0a0ffeecb862b12b$var$revLookup[$0a0ffeecb862b12b$var$code.charCodeAt($0a0ffeecb862b12b$var$i)] = $0a0ffeecb862b12b$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$0a0ffeecb862b12b$var$revLookup["-".charCodeAt(0)] = 62;
$0a0ffeecb862b12b$var$revLookup["_".charCodeAt(0)] = 63;
function $0a0ffeecb862b12b$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $0a0ffeecb862b12b$var$byteLength(b64) {
    var lens = $0a0ffeecb862b12b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $0a0ffeecb862b12b$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $0a0ffeecb862b12b$var$toByteArray(b64) {
    var tmp;
    var lens = $0a0ffeecb862b12b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $0a0ffeecb862b12b$var$Arr($0a0ffeecb862b12b$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $0a0ffeecb862b12b$var$revLookup[b64.charCodeAt(i)] << 18 | $0a0ffeecb862b12b$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $0a0ffeecb862b12b$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $0a0ffeecb862b12b$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $0a0ffeecb862b12b$var$revLookup[b64.charCodeAt(i)] << 2 | $0a0ffeecb862b12b$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $0a0ffeecb862b12b$var$revLookup[b64.charCodeAt(i)] << 10 | $0a0ffeecb862b12b$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $0a0ffeecb862b12b$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $0a0ffeecb862b12b$var$tripletToBase64(num) {
    return $0a0ffeecb862b12b$var$lookup[num >> 18 & 0x3F] + $0a0ffeecb862b12b$var$lookup[num >> 12 & 0x3F] + $0a0ffeecb862b12b$var$lookup[num >> 6 & 0x3F] + $0a0ffeecb862b12b$var$lookup[num & 0x3F];
}
function $0a0ffeecb862b12b$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($0a0ffeecb862b12b$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $0a0ffeecb862b12b$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($0a0ffeecb862b12b$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($0a0ffeecb862b12b$var$lookup[tmp >> 2] + $0a0ffeecb862b12b$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($0a0ffeecb862b12b$var$lookup[tmp >> 10] + $0a0ffeecb862b12b$var$lookup[tmp >> 4 & 0x3F] + $0a0ffeecb862b12b$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("kjGnt", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $eca67449edf76edb$export$aafa59e2e03f2942; }, function (v) { return $eca67449edf76edb$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $eca67449edf76edb$export$68d8715fc104d294; }, function (v) { return $eca67449edf76edb$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $eca67449edf76edb$export$aafa59e2e03f2942;
var $eca67449edf76edb$export$68d8715fc104d294;
$eca67449edf76edb$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$eca67449edf76edb$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRequire.register("i3eDV", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $d243dd94f5bd2dc3$export$98e6a39c04603d36; }, function (v) { return $d243dd94f5bd2dc3$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "format", function () { return $d243dd94f5bd2dc3$export$d9468344d3651243; }, function (v) { return $d243dd94f5bd2dc3$export$d9468344d3651243 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $d243dd94f5bd2dc3$export$98e6a39c04603d36;
var $d243dd94f5bd2dc3$export$f7ad0328861e2f03;
var $d243dd94f5bd2dc3$export$7daf1a5d2f4dd018;
var $d243dd94f5bd2dc3$export$d9468344d3651243;
var $d243dd94f5bd2dc3$export$59d795186a5d3f58;
"use strict";

var $61ywB = parcelRequire("61ywB");

var $avRzg = parcelRequire("avRzg");
$d243dd94f5bd2dc3$export$98e6a39c04603d36 = $d243dd94f5bd2dc3$var$urlParse;
$d243dd94f5bd2dc3$export$f7ad0328861e2f03 = $d243dd94f5bd2dc3$var$urlResolve;
$d243dd94f5bd2dc3$export$7daf1a5d2f4dd018 = $d243dd94f5bd2dc3$var$urlResolveObject;
$d243dd94f5bd2dc3$export$d9468344d3651243 = $d243dd94f5bd2dc3$var$urlFormat;
$d243dd94f5bd2dc3$export$59d795186a5d3f58 = $d243dd94f5bd2dc3$var$Url;
function $d243dd94f5bd2dc3$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $d243dd94f5bd2dc3$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $d243dd94f5bd2dc3$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$d243dd94f5bd2dc3$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$d243dd94f5bd2dc3$var$delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
$d243dd94f5bd2dc3$var$unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat($d243dd94f5bd2dc3$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$d243dd94f5bd2dc3$var$autoEscape = [
    "'"
].concat($d243dd94f5bd2dc3$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$d243dd94f5bd2dc3$var$nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat($d243dd94f5bd2dc3$var$autoEscape), $d243dd94f5bd2dc3$var$hostEndingChars = [
    "/",
    "?",
    "#"
], $d243dd94f5bd2dc3$var$hostnameMaxLen = 255, $d243dd94f5bd2dc3$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $d243dd94f5bd2dc3$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
$d243dd94f5bd2dc3$var$unsafeProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that never have a hostname.
$d243dd94f5bd2dc3$var$hostlessProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that always contain a // bit.
$d243dd94f5bd2dc3$var$slashedProtocol = {
    "http": true,
    "https": true,
    "ftp": true,
    "gopher": true,
    "file": true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};

var $4zfGi = parcelRequire("4zfGi");
function $d243dd94f5bd2dc3$var$urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && $avRzg.isObject(url) && url instanceof $d243dd94f5bd2dc3$var$Url) return url;
    var u = new $d243dd94f5bd2dc3$var$Url;
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
$d243dd94f5bd2dc3$var$Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (!$avRzg.isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = $d243dd94f5bd2dc3$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $4zfGi.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = $d243dd94f5bd2dc3$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && $d243dd94f5bd2dc3$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$d243dd94f5bd2dc3$var$hostlessProtocol[proto] && (slashes || proto && !$d243dd94f5bd2dc3$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < $d243dd94f5bd2dc3$var$hostEndingChars.length; i++){
            var hec = rest.indexOf($d243dd94f5bd2dc3$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf("@", hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < $d243dd94f5bd2dc3$var$nonHostChars.length; i++){
            var hec = rest.indexOf($d243dd94f5bd2dc3$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || "";
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($d243dd94f5bd2dc3$var$hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($d243dd94f5bd2dc3$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($d243dd94f5bd2dc3$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $d243dd94f5bd2dc3$var$hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) // IDNA Support: Returns a punycoded representation of "domain".
        // It only converts parts of the domain name that
        // have non-ASCII characters, i.e. it doesn't matter if
        // you call it with a domain that already is ASCII-only.
        this.hostname = $61ywB.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    // now rest is set to the post-host stuff.
    // chop off any delim chars.
    if (!$d243dd94f5bd2dc3$var$unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for(var i = 0, l = $d243dd94f5bd2dc3$var$autoEscape.length; i < l; i++){
        var ae = $d243dd94f5bd2dc3$var$autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $4zfGi.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if ($d243dd94f5bd2dc3$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    //to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function $d243dd94f5bd2dc3$var$urlFormat(obj) {
    // ensure it's an object, and not a string url.
    // If it's an obj, this is a no-op.
    // this way, you can call url_format() on strings
    // to clean up potentially wonky urls.
    if ($avRzg.isString(obj)) obj = $d243dd94f5bd2dc3$var$urlParse(obj);
    if (!(obj instanceof $d243dd94f5bd2dc3$var$Url)) return $d243dd94f5bd2dc3$var$Url.prototype.format.call(obj);
    return obj.format();
}
$d243dd94f5bd2dc3$var$Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && $avRzg.isObject(this.query) && Object.keys(this.query).length) query = $4zfGi.stringify(this.query);
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
    // unless they had them to begin with.
    if (this.slashes || (!protocol || $d243dd94f5bd2dc3$var$slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function $d243dd94f5bd2dc3$var$urlResolve(source, relative) {
    return $d243dd94f5bd2dc3$var$urlParse(source, false, true).resolve(relative);
}
$d243dd94f5bd2dc3$var$Url.prototype.resolve = function(relative) {
    return this.resolveObject($d243dd94f5bd2dc3$var$urlParse(relative, false, true)).format();
};
function $d243dd94f5bd2dc3$var$urlResolveObject(source, relative) {
    if (!source) return relative;
    return $d243dd94f5bd2dc3$var$urlParse(source, false, true).resolveObject(relative);
}
$d243dd94f5bd2dc3$var$Url.prototype.resolveObject = function(relative) {
    if ($avRzg.isString(relative)) {
        var rel = new $d243dd94f5bd2dc3$var$Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new $d243dd94f5bd2dc3$var$Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    // hash is always overridden, no matter what.
    // even href="" will remove it.
    result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        //urlParse appends trailing / to urls like http://www.example.com
        if ($d243dd94f5bd2dc3$var$slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = "/";
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        // if it's a known url protocol, then changing
        // the protocol does weird things
        // first, if it's not file:, then we MUST have a host,
        // and if there was a path
        // to begin with, then we MUST have a path.
        // if it is file:, then the host is dropped,
        // because that's known to be hostless.
        // anything else is assumed to be absolute.
        if (!$d243dd94f5bd2dc3$var$slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !$d243dd94f5bd2dc3$var$hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !$d243dd94f5bd2dc3$var$slashedProtocol[result.protocol];
    // if the url is a non-slashed url, then relative
    // links like ../.. should be able
    // to crawl up to the hostname, as well.  This is strange.
    // result.protocol has already been set by now.
    // Later on, put the first path part into the host field.
    if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        // it's relative
        // throw away the existing file, and take the new path instead.
        if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (!$avRzg.isNullOrUndefined(relative.search)) {
        // just pull out the search.
        // like href='?foo'.
        // Put this after the other two cases because it simplifies the booleans
        if (psychotic) {
            result.hostname = result.host = srcPath.shift();
            //occationaly the auth can get stuck only in host
            //this especially happens in cases like
            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
            var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.host = result.hostname = authInHost.shift();
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        //to support http.request
        if (!$avRzg.isNull(result.pathname) || !$avRzg.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        // no path at all.  easy.
        // we've already handled the other stuff above.
        result.pathname = null;
        //to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    // if a url ENDs in . or .., then it must get a trailing slash.
    // however, if it ends in anything else non-slashy,
    // then it must NOT get a trailing slash.
    var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    // strip single dots, resolve double dots to parent dir
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = result.host = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        //occationaly the auth can get stuck only in host
        //this especially happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
        var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
    } else result.pathname = srcPath.join("/");
    //to support request.http
    if (!$avRzg.isNull(result.pathname) || !$avRzg.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
$d243dd94f5bd2dc3$var$Url.prototype.parseHost = function() {
    var host = this.host;
    var port = $d243dd94f5bd2dc3$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};

});
parcelRequire.register("61ywB", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.3.2",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) freeModule.exports = punycode;
        else for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else root.punycode = punycode;
})(this);

});

parcelRequire.register("avRzg", function(module, exports) {
"use strict";
module.exports = {
    isString: function(arg) {
        return typeof arg === "string";
    },
    isObject: function(arg) {
        return typeof arg === "object" && arg !== null;
    },
    isNull: function(arg) {
        return arg === null;
    },
    isNullOrUndefined: function(arg) {
        return arg == null;
    }
};

});

parcelRequire.register("4zfGi", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $353698421ada60c8$export$98e6a39c04603d36; }, function (v) { return $353698421ada60c8$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $353698421ada60c8$export$fac44ee5b035f737; }, function (v) { return $353698421ada60c8$export$fac44ee5b035f737 = v; });
var $353698421ada60c8$export$2f872c0f2117be69;
var $353698421ada60c8$export$98e6a39c04603d36;
var $353698421ada60c8$export$c564cdbbe6da493;
var $353698421ada60c8$export$fac44ee5b035f737;
"use strict";

$353698421ada60c8$export$2f872c0f2117be69 = $353698421ada60c8$export$98e6a39c04603d36 = (parcelRequire("kuK7R"));

$353698421ada60c8$export$c564cdbbe6da493 = $353698421ada60c8$export$fac44ee5b035f737 = (parcelRequire("dtpHb"));

});
parcelRequire.register("kuK7R", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $eeba63984378447d$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || "&";
    eq = eq || "=";
    var obj = {};
    if (typeof qs !== "string" || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === "number") maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, "%20"), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = "";
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$eeba63984378447d$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($eeba63984378447d$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $eeba63984378447d$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};

});

parcelRequire.register("dtpHb", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $9cf1ea6866ca84fa$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case "string":
            return v;
        case "boolean":
            return v ? "true" : "false";
        case "number":
            return isFinite(v) ? v : "";
        default:
            return "";
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || "&";
    eq = eq || "=";
    if (obj === null) obj = undefined;
    if (typeof obj === "object") return $9cf1ea6866ca84fa$var$map($9cf1ea6866ca84fa$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($9cf1ea6866ca84fa$var$stringifyPrimitive(k)) + eq;
        if ($9cf1ea6866ca84fa$var$isArray(obj[k])) return $9cf1ea6866ca84fa$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($9cf1ea6866ca84fa$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($9cf1ea6866ca84fa$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return "";
    return encodeURIComponent($9cf1ea6866ca84fa$var$stringifyPrimitive(name)) + eq + encodeURIComponent($9cf1ea6866ca84fa$var$stringifyPrimitive(obj));
};
var $9cf1ea6866ca84fa$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};
function $9cf1ea6866ca84fa$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $9cf1ea6866ca84fa$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});



parcelRequire.register("6wRaM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5b7Wy = parcelRequire("5b7Wy");

(0, $5b7Wy.__exportStar)((parcelRequire("6qglx")), module.exports);

});
parcelRequire.register("5b7Wy", function(module, exports) {

$parcel$export(module.exports, "__awaiter", function () { return $3c54243bf00766d8$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $3c54243bf00766d8$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__exportStar", function () { return $3c54243bf00766d8$export$f33643c0debef087; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $3c54243bf00766d8$var$extendStatics = function(d, b) {
    $3c54243bf00766d8$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $3c54243bf00766d8$var$extendStatics(d, b);
};
function $3c54243bf00766d8$export$a8ba968b8961cb8a(d, b) {
    $3c54243bf00766d8$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3c54243bf00766d8$export$18ce0697a983be9b = function() {
    $3c54243bf00766d8$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3c54243bf00766d8$export$18ce0697a983be9b.apply(this, arguments);
};
function $3c54243bf00766d8$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3c54243bf00766d8$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3c54243bf00766d8$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3c54243bf00766d8$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3c54243bf00766d8$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3c54243bf00766d8$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $3c54243bf00766d8$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $3c54243bf00766d8$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $3c54243bf00766d8$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3c54243bf00766d8$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3c54243bf00766d8$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3c54243bf00766d8$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3c54243bf00766d8$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3c54243bf00766d8$export$10c90e4f7922046c(v) {
    return this instanceof $3c54243bf00766d8$export$10c90e4f7922046c ? (this.v = v, this) : new $3c54243bf00766d8$export$10c90e4f7922046c(v);
}
function $3c54243bf00766d8$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3c54243bf00766d8$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3c54243bf00766d8$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3c54243bf00766d8$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $3c54243bf00766d8$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3c54243bf00766d8$export$19a8beecd37a4c45 === "function" ? $3c54243bf00766d8$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3c54243bf00766d8$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $3c54243bf00766d8$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $3c54243bf00766d8$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3c54243bf00766d8$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $3c54243bf00766d8$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRequire.register("6qglx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Sha256 = void 0;

var $5b7Wy = parcelRequire("5b7Wy");

var $c6hof = parcelRequire("c6hof");

var $efLWP = parcelRequire("efLWP");

var $5drBp = parcelRequire("5drBp");
var $4ad1d9d896e5c78e$var$Sha256 = /** @class */ function() {
    function Sha256(secret) {
        this.hash = new $efLWP.RawSha256();
        if (secret) {
            this.outer = new $efLWP.RawSha256();
            var inner = $4ad1d9d896e5c78e$var$bufferFromSecret(secret);
            var outer = new Uint8Array($c6hof.BLOCK_SIZE);
            outer.set(inner);
            for(var i = 0; i < $c6hof.BLOCK_SIZE; i++){
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
        }
    }
    Sha256.prototype.update = function(toHash) {
        if ((0, $5drBp.isEmptyData)(toHash) || this.error) return;
        try {
            this.hash.update((0, $5drBp.convertToBuffer)(toHash));
        } catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */ Sha256.prototype.digestSync = function() {
        if (this.error) throw this.error;
        if (this.outer) {
            if (!this.outer.finished) this.outer.update(this.hash.digest());
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */ Sha256.prototype.digest = function() {
        return (0, $5b7Wy.__awaiter)(this, void 0, void 0, function() {
            return (0, $5b7Wy.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.digestSync()
                ];
            });
        });
    };
    return Sha256;
}();
module.exports.Sha256 = $4ad1d9d896e5c78e$var$Sha256;
function $4ad1d9d896e5c78e$var$bufferFromSecret(secret) {
    var input = (0, $5drBp.convertToBuffer)(secret);
    if (input.byteLength > $c6hof.BLOCK_SIZE) {
        var bufferHash = new $efLWP.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array($c6hof.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

});
parcelRequire.register("c6hof", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_HASHABLE_LENGTH = module.exports.INIT = module.exports.KEY = module.exports.DIGEST_LENGTH = module.exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */ module.exports.BLOCK_SIZE = 64;
/**
 * @internal
 */ module.exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */ module.exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */ module.exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */ module.exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;

});

parcelRequire.register("efLWP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawSha256 = void 0;

var $c6hof = parcelRequire("c6hof");
/**
 * @internal
 */ var $a607a8db57834b8c$var$RawSha256 = /** @class */ function() {
    function RawSha256() {
        this.state = Int32Array.from($c6hof.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */ this.finished = false;
    }
    RawSha256.prototype.update = function(data) {
        if (this.finished) throw new Error("Attempted to update an already finished hash.");
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > $c6hof.MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
        while(byteLength > 0){
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === $c6hof.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function() {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % $c6hof.BLOCK_SIZE >= $c6hof.BLOCK_SIZE - 8) {
                for(var i = this.bufferLength; i < $c6hof.BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for(var i = this.bufferLength; i < $c6hof.BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
            bufferView.setUint32($c6hof.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32($c6hof.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array($c6hof.DIGEST_LENGTH);
        for(var i = 0; i < 8; i++){
            out[i * 4] = this.state[i] >>> 24 & 0xff;
            out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
            out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
            out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function() {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for(var i = 0; i < $c6hof.BLOCK_SIZE; i++){
            if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
            else {
                var u = this.temp[i - 2];
                var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                u = this.temp[i - 15];
                var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
            }
            var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + ($c6hof.KEY[i] + this.temp[i] | 0) | 0) | 0;
            var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = state3 + t1 | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}();
module.exports.RawSha256 = $a607a8db57834b8c$var$RawSha256;

});

parcelRequire.register("5drBp", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = module.exports.numToUint8 = module.exports.isEmptyData = module.exports.convertToBuffer = void 0;

var $ISZlg = parcelRequire("ISZlg");
Object.defineProperty(module.exports, "convertToBuffer", {
    enumerable: true,
    get: function() {
        return $ISZlg.convertToBuffer;
    }
});

var $dDB6D = parcelRequire("dDB6D");
Object.defineProperty(module.exports, "isEmptyData", {
    enumerable: true,
    get: function() {
        return $dDB6D.isEmptyData;
    }
});

var $hZekZ = parcelRequire("hZekZ");
Object.defineProperty(module.exports, "numToUint8", {
    enumerable: true,
    get: function() {
        return $hZekZ.numToUint8;
    }
});

var $ctSi3 = parcelRequire("ctSi3");
Object.defineProperty(module.exports, "uint32ArrayFrom", {
    enumerable: true,
    get: function() {
        return $ctSi3.uint32ArrayFrom;
    }
});

});
parcelRequire.register("ISZlg", function(module, exports) {

var $5oOz5 = parcelRequire("5oOz5");
var $086ec3b94de10554$require$Buffer = $5oOz5.Buffer;
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertToBuffer = void 0;

var $bhBSc = parcelRequire("bhBSc");
// Quick polyfill
var $086ec3b94de10554$var$fromUtf8 = typeof $086ec3b94de10554$require$Buffer !== "undefined" && $086ec3b94de10554$require$Buffer.from ? function(input) {
    return $086ec3b94de10554$require$Buffer.from(input, "utf8");
} : $bhBSc.fromUtf8;
function $086ec3b94de10554$var$convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array) return data;
    if (typeof data === "string") return $086ec3b94de10554$var$fromUtf8(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
module.exports.convertToBuffer = $086ec3b94de10554$var$convertToBuffer;

});
parcelRequire.register("bhBSc", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $836ea90af6fc34aa$export$c7c5cef950a4d2fc; });

var $f8N6f = parcelRequire("f8N6f");

var $cOQXa = parcelRequire("cOQXa");
var $836ea90af6fc34aa$export$c7c5cef950a4d2fc = function(input) {
    return typeof TextEncoder === "function" ? (0, $cOQXa.fromUtf8)(input) : (0, $f8N6f.fromUtf8)(input);
};
var $836ea90af6fc34aa$export$b4b216764bb846eb = function(input) {
    return typeof TextDecoder === "function" ? (0, $cOQXa.toUtf8)(input) : (0, $f8N6f.toUtf8)(input);
};

});
parcelRequire.register("f8N6f", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $b05db08a17dafd84$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $b05db08a17dafd84$export$b4b216764bb846eb; });
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */ var $b05db08a17dafd84$export$c7c5cef950a4d2fc = function(input) {
    var bytes = [];
    for(var i = 0, len = input.length; i < len; i++){
        var value = input.charCodeAt(i);
        if (value < 0x80) bytes.push(value);
        else if (value < 0x800) bytes.push(value >> 6 | 192, value & 63 | 128);
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
        } else bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
    return Uint8Array.from(bytes);
};
var $b05db08a17dafd84$export$b4b216764bb846eb = function(input) {
    var decoded = "";
    for(var i = 0, len = input.length; i < len; i++){
        var byte = input[i];
        if (byte < 0x80) decoded += String.fromCharCode(byte);
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
        } else if (240 <= byte && byte < 365) {
            var surrogatePair = [
                byte,
                input[++i],
                input[++i],
                input[++i]
            ];
            var encoded = "%" + surrogatePair.map(function(byteValue) {
                return byteValue.toString(16);
            }).join("%");
            decoded += decodeURIComponent(encoded);
        } else decoded += String.fromCharCode((byte & 15) << 12 | (input[++i] & 63) << 6 | input[++i] & 63);
    }
    return decoded;
};

});

parcelRequire.register("cOQXa", function(module, exports) {

$parcel$export(module.exports, "fromUtf8", function () { return $95533afad763af24$export$c7c5cef950a4d2fc; });
$parcel$export(module.exports, "toUtf8", function () { return $95533afad763af24$export$b4b216764bb846eb; });
function $95533afad763af24$export$c7c5cef950a4d2fc(input) {
    return new TextEncoder().encode(input);
}
function $95533afad763af24$export$b4b216764bb846eb(input) {
    return new TextDecoder("utf-8").decode(input);
}

});



parcelRequire.register("dDB6D", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEmptyData = void 0;
function $9edbb35ea5f7f868$var$isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
module.exports.isEmptyData = $9edbb35ea5f7f868$var$isEmptyData;

});

parcelRequire.register("hZekZ", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.numToUint8 = void 0;
function $d183415419147103$var$numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff
    ]);
}
module.exports.numToUint8 = $d183415419147103$var$numToUint8;

});

parcelRequire.register("ctSi3", function(module, exports) {
"use strict";
// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function $91624e61f898f9f9$var$uint32ArrayFrom(a_lookUpTable) {
    if (!Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while(a_index < a_lookUpTable.length)return_array[a_index] = a_lookUpTable[a_index];
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
module.exports.uint32ArrayFrom = $91624e61f898f9f9$var$uint32ArrayFrom;

});




parcelRequire.register("7QIMp", function(module, exports) {

$parcel$export(module.exports, "toHex", function () { return $5b702015846bae7f$export$7ea66e3774a60b67; });
const $5b702015846bae7f$var$SHORT_TO_HEX = {};
const $5b702015846bae7f$var$HEX_TO_SHORT = {};
for(let i = 0; i < 256; i++){
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) encodedByte = `0${encodedByte}`;
    $5b702015846bae7f$var$SHORT_TO_HEX[i] = encodedByte;
    $5b702015846bae7f$var$HEX_TO_SHORT[encodedByte] = i;
}
function $5b702015846bae7f$export$1a8ceedbd5845648(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    const out = new Uint8Array(encoded.length / 2);
    for(let i = 0; i < encoded.length; i += 2){
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in $5b702015846bae7f$var$HEX_TO_SHORT) out[i / 2] = $5b702015846bae7f$var$HEX_TO_SHORT[encodedByte];
        else throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
    return out;
}
function $5b702015846bae7f$export$7ea66e3774a60b67(bytes) {
    let out = "";
    for(let i = 0; i < bytes.byteLength; i++)out += $5b702015846bae7f$var$SHORT_TO_HEX[bytes[i]];
    return out;
}

});


parcelRequire.register("52JFH", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return dateTimestampInSeconds; });
$parcel$export(module.exports, "timestampInSeconds", function () { return timestampInSeconds; });
$parcel$export(module.exports, "browserPerformanceTimeOrigin", function () { return browserPerformanceTimeOrigin; });

var $6QG3c = parcelRequire("6QG3c");

var $bayd0 = parcelRequire("bayd0");
// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0, $bayd0.getGlobalObject)();
/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */ /**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ const dateTimestampSource = {
    nowSeconds: ()=>Date.now() / 1000
};
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    const { performance  } = WINDOW;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    const timeOrigin = Date.now() - performance.now();
    return {
        now: ()=>performance.now(),
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        const perfHooks = (0, $6QG3c.dynamicRequire)(module, "perf_hooks");
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ const platformPerformance = (0, $6QG3c.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
const timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: ()=>(platformPerformance.timeOrigin + platformPerformance.now()) / 1000
};
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const timestampWithMs = timestampInSeconds;
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */ const usingPerformanceAPI = platformPerformance !== undefined;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const browserPerformanceTimeOrigin = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance  } = WINDOW;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = "timeOrigin";
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = "dateNow";
    return dateNow;
})();

});
parcelRequire.register("6QG3c", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });
$parcel$export(module.exports, "dynamicRequire", function () { return dynamicRequire; });
$parcel$export(module.exports, "loadModule", function () { return loadModule; });

var $42Tef = parcelRequire("42Tef");

var $e67mm = parcelRequire("e67mm");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $42Tef.isBrowserBundle)() && Object.prototype.toString.call(typeof $e67mm !== "undefined" ? $e67mm : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd  } = dynamicRequire(module, "process");
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRequire.register("42Tef", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $2f22309d367b9855$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $2f22309d367b9855$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $2f22309d367b9855$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $2f22309d367b9855$export$8ad33f488b1ab046() {
    // @ts-ignore "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRequire.register("e67mm", function(module, exports) {
// shim for using process in browser
var $a43755b23264201d$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $a43755b23264201d$var$cachedSetTimeout;
var $a43755b23264201d$var$cachedClearTimeout;
function $a43755b23264201d$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $a43755b23264201d$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $a43755b23264201d$var$cachedSetTimeout = setTimeout;
        else $a43755b23264201d$var$cachedSetTimeout = $a43755b23264201d$var$defaultSetTimout;
    } catch (e) {
        $a43755b23264201d$var$cachedSetTimeout = $a43755b23264201d$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $a43755b23264201d$var$cachedClearTimeout = clearTimeout;
        else $a43755b23264201d$var$cachedClearTimeout = $a43755b23264201d$var$defaultClearTimeout;
    } catch (e) {
        $a43755b23264201d$var$cachedClearTimeout = $a43755b23264201d$var$defaultClearTimeout;
    }
})();
function $a43755b23264201d$var$runTimeout(fun) {
    if ($a43755b23264201d$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($a43755b23264201d$var$cachedSetTimeout === $a43755b23264201d$var$defaultSetTimout || !$a43755b23264201d$var$cachedSetTimeout) && setTimeout) {
        $a43755b23264201d$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $a43755b23264201d$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $a43755b23264201d$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $a43755b23264201d$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $a43755b23264201d$var$runClearTimeout(marker) {
    if ($a43755b23264201d$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($a43755b23264201d$var$cachedClearTimeout === $a43755b23264201d$var$defaultClearTimeout || !$a43755b23264201d$var$cachedClearTimeout) && clearTimeout) {
        $a43755b23264201d$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $a43755b23264201d$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $a43755b23264201d$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $a43755b23264201d$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $a43755b23264201d$var$queue = [];
var $a43755b23264201d$var$draining = false;
var $a43755b23264201d$var$currentQueue;
var $a43755b23264201d$var$queueIndex = -1;
function $a43755b23264201d$var$cleanUpNextTick() {
    if (!$a43755b23264201d$var$draining || !$a43755b23264201d$var$currentQueue) return;
    $a43755b23264201d$var$draining = false;
    if ($a43755b23264201d$var$currentQueue.length) $a43755b23264201d$var$queue = $a43755b23264201d$var$currentQueue.concat($a43755b23264201d$var$queue);
    else $a43755b23264201d$var$queueIndex = -1;
    if ($a43755b23264201d$var$queue.length) $a43755b23264201d$var$drainQueue();
}
function $a43755b23264201d$var$drainQueue() {
    if ($a43755b23264201d$var$draining) return;
    var timeout = $a43755b23264201d$var$runTimeout($a43755b23264201d$var$cleanUpNextTick);
    $a43755b23264201d$var$draining = true;
    var len = $a43755b23264201d$var$queue.length;
    while(len){
        $a43755b23264201d$var$currentQueue = $a43755b23264201d$var$queue;
        $a43755b23264201d$var$queue = [];
        while(++$a43755b23264201d$var$queueIndex < len)if ($a43755b23264201d$var$currentQueue) $a43755b23264201d$var$currentQueue[$a43755b23264201d$var$queueIndex].run();
        $a43755b23264201d$var$queueIndex = -1;
        len = $a43755b23264201d$var$queue.length;
    }
    $a43755b23264201d$var$currentQueue = null;
    $a43755b23264201d$var$draining = false;
    $a43755b23264201d$var$runClearTimeout(timeout);
}
$a43755b23264201d$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $a43755b23264201d$var$queue.push(new $a43755b23264201d$var$Item(fun, args));
    if ($a43755b23264201d$var$queue.length === 1 && !$a43755b23264201d$var$draining) $a43755b23264201d$var$runTimeout($a43755b23264201d$var$drainQueue);
};
// v8 likes predictible objects
function $a43755b23264201d$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$a43755b23264201d$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$a43755b23264201d$var$process.title = "browser";
$a43755b23264201d$var$process.browser = true;
$a43755b23264201d$var$process.env = {};
$a43755b23264201d$var$process.argv = [];
$a43755b23264201d$var$process.version = ""; // empty string to avoid regexp issues
$a43755b23264201d$var$process.versions = {};
function $a43755b23264201d$var$noop() {}
$a43755b23264201d$var$process.on = $a43755b23264201d$var$noop;
$a43755b23264201d$var$process.addListener = $a43755b23264201d$var$noop;
$a43755b23264201d$var$process.once = $a43755b23264201d$var$noop;
$a43755b23264201d$var$process.off = $a43755b23264201d$var$noop;
$a43755b23264201d$var$process.removeListener = $a43755b23264201d$var$noop;
$a43755b23264201d$var$process.removeAllListeners = $a43755b23264201d$var$noop;
$a43755b23264201d$var$process.emit = $a43755b23264201d$var$noop;
$a43755b23264201d$var$process.prependListener = $a43755b23264201d$var$noop;
$a43755b23264201d$var$process.prependOnceListener = $a43755b23264201d$var$noop;
$a43755b23264201d$var$process.listeners = function(name) {
    return [];
};
$a43755b23264201d$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$a43755b23264201d$var$process.cwd = function() {
    return "/";
};
$a43755b23264201d$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$a43755b23264201d$var$process.umask = function() {
    return 0;
};

});


parcelRequire.register("bayd0", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $821b2a0d80ea0aa0$export$f1a6cdb1459e81d1; });
$parcel$export(module.exports, "getGlobalObject", function () { return $821b2a0d80ea0aa0$export$256479dc0cea61c4; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $821b2a0d80ea0aa0$export$7e223ec222791509; });
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $821b2a0d80ea0aa0$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $821b2a0d80ea0aa0$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $821b2a0d80ea0aa0$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $821b2a0d80ea0aa0$var$isGlobalObj(window) || typeof self == "object" && $821b2a0d80ea0aa0$var$isGlobalObj(self) || typeof $parcel$global == "object" && $821b2a0d80ea0aa0$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $821b2a0d80ea0aa0$export$256479dc0cea61c4() {
    return $821b2a0d80ea0aa0$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $821b2a0d80ea0aa0$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $821b2a0d80ea0aa0$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});


parcelRequire.register("5Jhw0", function(module, exports) {

$parcel$export(module.exports, "addExtensionMethods", function () { return addExtensionMethods; });

var $78QsC = parcelRequire("78QsC");
var $kDFdm = parcelRequire("kDFdm");

var $6QG3c = parcelRequire("6QG3c");
/**
 * @private
 */ function _autoloadDatabaseIntegrations() {
    const carrier = (0, $kDFdm.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    const packageToIntegrationMapping = {
        mongodb () {
            const integration = (0, $6QG3c.dynamicRequire)(module, "./node/integrations/mongo");
            return new integration.Mongo();
        },
        mongoose () {
            const integration = (0, $6QG3c.dynamicRequire)(module, "./node/integrations/mongo");
            return new integration.Mongo();
        },
        mysql () {
            const integration = (0, $6QG3c.dynamicRequire)(module, "./node/integrations/mysql");
            return new integration.Mysql();
        },
        pg () {
            const integration = (0, $6QG3c.dynamicRequire)(module, "./node/integrations/postgres");
            return new integration.Postgres();
        }
    };
    const mappedPackages = Object.keys(packageToIntegrationMapping).filter((moduleName)=>!!(0, $6QG3c.loadModule)(moduleName)).map((pkg)=>{
        try {
            return packageToIntegrationMapping[pkg]();
        } catch (e) {
            return undefined;
        }
    }).filter((p)=>p);
    if (mappedPackages.length > 0) carrier.__SENTRY__.integrations = [
        ...carrier.__SENTRY__.integrations || [],
        ...mappedPackages
    ];
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */ function addExtensionMethods() {
    (0, $78QsC.addTracingExtensions)();
    // Detect and automatically load specified integrations.
    if ((0, $6QG3c.isNodeEnv)()) _autoloadDatabaseIntegrations();
}

});
parcelRequire.register("78QsC", function(module, exports) {

$parcel$export(module.exports, "startIdleTransaction", function () { return $5331f956410e03cb$export$479dbd817e392a4f; });
$parcel$export(module.exports, "addTracingExtensions", function () { return $5331f956410e03cb$export$653d0ef2bad9cdf9; });

var $d2unA = parcelRequire("d2unA");
var $3lHwZ = parcelRequire("3lHwZ");

var $kDFdm = parcelRequire("kDFdm");

var $1DvVX = parcelRequire("1DvVX");

var $4MUrP = parcelRequire("4MUrP");

var $5vcgO = parcelRequire("5vcgO");

var $lOd6Z = parcelRequire("lOd6Z");
/** Returns all trace headers that are currently on the top scope. */ function $5331f956410e03cb$var$traceHeaders() {
    const scope = this.getScope();
    const span = scope.getSpan();
    return span ? {
        "sentry-trace": span.toTraceparent()
    } : {};
}
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */ function $5331f956410e03cb$var$sample(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $1DvVX.hasTracingEnabled)(options)) {
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    if (transaction.sampled !== undefined) {
        transaction.setMetadata({
            sampleRate: Number(transaction.sampled)
        });
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setMetadata({
            sampleRate: Number(sampleRate)
        });
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setMetadata({
            sampleRate: Number(sampleRate)
        });
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setMetadata({
            sampleRate: sampleRate
        });
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$5331f956410e03cb$var$isValidSampleRate(sampleRate)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    if (!transaction.sampled) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $5331f956410e03cb$var$isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $d2unA.isNaN)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $5331f956410e03cb$var$_startTransaction(transactionContext, customSamplingContext) {
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || "sentry";
    const transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        transactionContext.sampled = false;
    }
    let transaction = new (0, $lOd6Z.Transaction)(transactionContext, this);
    transaction = $5331f956410e03cb$var$sample(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $5331f956410e03cb$export$479dbd817e392a4f(hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval) {
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    let transaction = new (0, $5vcgO.IdleTransaction)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope);
    transaction = $5331f956410e03cb$var$sample(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $5331f956410e03cb$export$653d0ef2bad9cdf9() {
    const carrier = (0, $kDFdm.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $5331f956410e03cb$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $5331f956410e03cb$var$traceHeaders;
    (0, $4MUrP.registerErrorInstrumentation)();
}

});
parcelRequire.register("d2unA", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $97e30701d4a5e4f3$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $97e30701d4a5e4f3$export$49034edbe6b62415; });
$parcel$export(module.exports, "isErrorEvent", function () { return $97e30701d4a5e4f3$export$9f9636d330b71954; });
$parcel$export(module.exports, "isDOMError", function () { return $97e30701d4a5e4f3$export$ef9e2056653f0c8e; });
$parcel$export(module.exports, "isDOMException", function () { return $97e30701d4a5e4f3$export$12e869b2a583f783; });
$parcel$export(module.exports, "isString", function () { return $97e30701d4a5e4f3$export$844ec244b1367d54; });
$parcel$export(module.exports, "isPrimitive", function () { return $97e30701d4a5e4f3$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $97e30701d4a5e4f3$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $97e30701d4a5e4f3$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $97e30701d4a5e4f3$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $97e30701d4a5e4f3$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $97e30701d4a5e4f3$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $97e30701d4a5e4f3$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isNaN", function () { return $97e30701d4a5e4f3$export$c9f5652083b8129d; });
// eslint-disable-next-line @typescript-eslint/unbound-method
const $97e30701d4a5e4f3$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $97e30701d4a5e4f3$export$e6127cc7fe7395c3(wat) {
    switch($97e30701d4a5e4f3$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $97e30701d4a5e4f3$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $97e30701d4a5e4f3$var$isBuiltin(wat, className) {
    return $97e30701d4a5e4f3$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $97e30701d4a5e4f3$export$9f9636d330b71954(wat) {
    return $97e30701d4a5e4f3$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $97e30701d4a5e4f3$export$ef9e2056653f0c8e(wat) {
    return $97e30701d4a5e4f3$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $97e30701d4a5e4f3$export$12e869b2a583f783(wat) {
    return $97e30701d4a5e4f3$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $97e30701d4a5e4f3$export$844ec244b1367d54(wat) {
    return $97e30701d4a5e4f3$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $97e30701d4a5e4f3$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $97e30701d4a5e4f3$export$53b83ca8eaab0383(wat) {
    return $97e30701d4a5e4f3$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $97e30701d4a5e4f3$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $97e30701d4a5e4f3$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $97e30701d4a5e4f3$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $97e30701d4a5e4f3$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $97e30701d4a5e4f3$export$49841c62b9eff15(wat) {
    return $97e30701d4a5e4f3$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $97e30701d4a5e4f3$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $97e30701d4a5e4f3$export$bc2894c7158efbac(wat) {
    return $97e30701d4a5e4f3$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $97e30701d4a5e4f3$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $97e30701d4a5e4f3$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRequire.register("3lHwZ", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", function () { return $2705199d1e565a82$export$2a2b1d2252a69ecb; });
$parcel$export(module.exports, "consoleSandbox", function () { return $2705199d1e565a82$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $2705199d1e565a82$export$af88d00dbe7f521; });

var $bayd0 = parcelRequire("bayd0");
/** Prefix for logging strings */ const $2705199d1e565a82$var$PREFIX = "Sentry Logger ";
const $2705199d1e565a82$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $2705199d1e565a82$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $bayd0.GLOBAL_OBJ))) return callback();
    const originalConsole = (0, $bayd0.GLOBAL_OBJ).console;
    const wrappedLevels = {};
    // Restore all wrapped console methods
    $2705199d1e565a82$export$2a2b1d2252a69ecb.forEach((level)=>{
        // TODO(v7): Remove this check as it's only needed for Node 6
        const originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in originalConsole && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach((level)=>{
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $2705199d1e565a82$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        }
    };
    if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) $2705199d1e565a82$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $2705199d1e565a82$export$cda52e2a8927a2ca(()=>{
                (0, $bayd0.GLOBAL_OBJ).console[name](`${$2705199d1e565a82$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $2705199d1e565a82$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let $2705199d1e565a82$export$af88d00dbe7f521;
if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) $2705199d1e565a82$export$af88d00dbe7f521 = (0, $bayd0.getGlobalSingleton)("logger", $2705199d1e565a82$var$makeLogger);
else $2705199d1e565a82$export$af88d00dbe7f521 = $2705199d1e565a82$var$makeLogger();

});

parcelRequire.register("kDFdm", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", function () { return $f0676b84910d0b8a$export$19eade501500c6c1; });
$parcel$export(module.exports, "getCurrentHub", function () { return $f0676b84910d0b8a$export$a07cdf6544bbd7c; });

var $3lHwZ = parcelRequire("3lHwZ");
var $52JFH = parcelRequire("52JFH");
var $bayd0 = parcelRequire("bayd0");
var $iMHif = parcelRequire("iMHif");

var $gmhqD = parcelRequire("gmhqD");

var $f3hBG = parcelRequire("f3hBG");

var $dOBEf = parcelRequire("dOBEf");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $f0676b84910d0b8a$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $f0676b84910d0b8a$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ class $f0676b84910d0b8a$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */ constructor(client, scope = new (0, $f3hBG.Scope)(), _version = $f0676b84910d0b8a$export$24a86ef7798177e4){
        this._version = _version;
        this._stack = [
            {
                scope: scope
            }
        ];
        if (client) this.bindClient(client);
    }
    /**
   * @inheritDoc
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * @inheritDoc
   */ bindClient(client) {
        const top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    }
    /**
   * @inheritDoc
   */ pushScope() {
        // We want to clone the content of prev scope
        const scope = (0, $f3hBG.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   */ popScope() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   */ withScope(callback) {
        const scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this.getStackTop().client;
    }
    /** Returns the scope of the top stack. */ getScope() {
        return this.getStackTop().scope;
    }
    /** Returns the scope stack for domains or the process. */ getStack() {
        return this._stack;
    }
    /** Returns the topmost scope layer in the order domain > local > process. */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $iMHif.uuid4)();
        const syntheticException = new Error("Sentry syntheticException");
        this._withClient((client, scope)=>{
            client.captureException(exception, {
                originalException: exception,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $iMHif.uuid4)();
        const syntheticException = new Error(message);
        this._withClient((client, scope)=>{
            client.captureMessage(message, level, {
                originalException: message,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $iMHif.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        this._withClient((client, scope)=>{
            client.captureEvent(event, {
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, hint) {
        const { scope: scope , client: client  } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null , maxBreadcrumbs: maxBreadcrumbs = $f0676b84910d0b8a$var$DEFAULT_BREADCRUMBS  } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $52JFH.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $3lHwZ.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        this.getScope().setUser(user);
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this.getScope().setTags(tags);
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this.getScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this.getScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this.getScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        this.getScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   */ configureScope(callback) {
        const { scope: scope , client: client  } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ run(callback) {
        const oldHub = $f0676b84910d0b8a$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $f0676b84910d0b8a$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   */ getIntegration(integration) {
        const client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && !result) // eslint-disable-next-line no-console
        console.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        return result;
    }
    /**
   * @inheritDoc
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   */ endSession() {
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $dOBEf.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   */ startSession(context) {
        const { scope: scope , client: client  } = this.getStackTop();
        const { release: release , environment: environment = (0, $gmhqD.DEFAULT_ENVIRONMENT)  } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent  } = (0, $bayd0.GLOBAL_OBJ).navigator || {};
        const session = (0, $dOBEf.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $dOBEf.updateSession)(currentSession, {
            status: "exited"
        });
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */ shouldSendDefaultPii() {
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        const { scope: scope , client: client  } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */ _withClient(callback) {
        const { scope: scope , client: client  } = this.getStackTop();
        if (client) callback(client, scope);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $f0676b84910d0b8a$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $f0676b84910d0b8a$export$19eade501500c6c1() {
    (0, $bayd0.GLOBAL_OBJ).__SENTRY__ = (0, $bayd0.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $bayd0.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */ function $f0676b84910d0b8a$export$4188a14ad302d1bc(hub) {
    const registry = $f0676b84910d0b8a$export$19eade501500c6c1();
    const oldHub = $f0676b84910d0b8a$export$bfa8a924a84a76b7(registry);
    $f0676b84910d0b8a$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */ function $f0676b84910d0b8a$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $f0676b84910d0b8a$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $f0676b84910d0b8a$var$getGlobalHub(registry);
}
function $f0676b84910d0b8a$var$getGlobalHub(registry = $f0676b84910d0b8a$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$f0676b84910d0b8a$var$hasHubOnCarrier(registry) || $f0676b84910d0b8a$export$bfa8a924a84a76b7(registry).isOlderThan($f0676b84910d0b8a$export$24a86ef7798177e4)) $f0676b84910d0b8a$export$849f05434e95d2f2(registry, new $f0676b84910d0b8a$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $f0676b84910d0b8a$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ function $f0676b84910d0b8a$export$236689a79f5aa020(carrier, parent = $f0676b84910d0b8a$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$f0676b84910d0b8a$var$hasHubOnCarrier(carrier) || $f0676b84910d0b8a$export$bfa8a924a84a76b7(carrier).isOlderThan($f0676b84910d0b8a$export$24a86ef7798177e4)) {
        const globalHubTopStack = parent.getStackTop();
        $f0676b84910d0b8a$export$849f05434e95d2f2(carrier, new $f0676b84910d0b8a$export$8c41bb232f1008b1(globalHubTopStack.client, (0, $f3hBG.Scope).clone(globalHubTopStack.scope)));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $f0676b84910d0b8a$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $f0676b84910d0b8a$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $f0676b84910d0b8a$export$70d775fb1f267027(callback, options = {}) {
    const registry = $f0676b84910d0b8a$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $f0676b84910d0b8a$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ function $f0676b84910d0b8a$export$bfa8a924a84a76b7(carrier) {
    return (0, $bayd0.getGlobalSingleton)("hub", ()=>new $f0676b84910d0b8a$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ function $f0676b84910d0b8a$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRequire.register("iMHif", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $dace4ad76a7240bc$export$19f53698e68b2496; });
$parcel$export(module.exports, "getEventDescription", function () { return $dace4ad76a7240bc$export$4157119e2b157127; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return $dace4ad76a7240bc$export$f26508487bf83ee7; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $dace4ad76a7240bc$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "checkOrSetAlreadyCaught", function () { return $dace4ad76a7240bc$export$6de4ffac6a2f1098; });
$parcel$export(module.exports, "arrayify", function () { return $dace4ad76a7240bc$export$3131421a7d01b4fb; });

var $jl9W5 = parcelRequire("jl9W5");

var $geIBs = parcelRequire("geIBs");

var $bayd0 = parcelRequire("bayd0");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $dace4ad76a7240bc$export$19f53698e68b2496() {
    const gbl = (0, $bayd0.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
    const getRandomByte = crypto && crypto.getRandomValues ? ()=>crypto.getRandomValues(new Uint8Array(1))[0] : ()=>Math.random() * 16;
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $dace4ad76a7240bc$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $dace4ad76a7240bc$export$4157119e2b157127(event) {
    const { message: message , event_id: eventId  } = event;
    if (message) return message;
    const firstException = $dace4ad76a7240bc$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $dace4ad76a7240bc$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $dace4ad76a7240bc$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $dace4ad76a7240bc$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $dace4ad76a7240bc$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $dace4ad76a7240bc$export$d364f2020ab30578(input) {
    const match = input.match($dace4ad76a7240bc$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $dace4ad76a7240bc$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $geIBs.snipLine)(line, 0));
    frame.context_line = (0, $geIBs.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $geIBs.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $dace4ad76a7240bc$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $jl9W5.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $dace4ad76a7240bc$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRequire.register("jl9W5", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $e147af8df5a9c6e0$export$9563e054e6f787fb; });
$parcel$export(module.exports, "markFunctionWrapped", function () { return $e147af8df5a9c6e0$export$5c1499e2e5d010ae; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $e147af8df5a9c6e0$export$e73679ffaf56810e; });
$parcel$export(module.exports, "getOriginalFunction", function () { return $e147af8df5a9c6e0$export$e6cc1e135e2092e5; });
$parcel$export(module.exports, "urlEncode", function () { return $e147af8df5a9c6e0$export$9ef804feabbcbaf1; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $e147af8df5a9c6e0$export$62ff257738bf57f5; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return $e147af8df5a9c6e0$export$b0244d5063c0b61b; });
$parcel$export(module.exports, "dropUndefinedKeys", function () { return $e147af8df5a9c6e0$export$d25f2688db1bb433; });

var $iTlxf = parcelRequire("iTlxf");

var $d2unA = parcelRequire("d2unA");

var $geIBs = parcelRequire("geIBs");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $e147af8df5a9c6e0$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") try {
        $e147af8df5a9c6e0$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $e147af8df5a9c6e0$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $e147af8df5a9c6e0$export$5c1499e2e5d010ae(wrapped, original) {
    const proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $e147af8df5a9c6e0$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $e147af8df5a9c6e0$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $e147af8df5a9c6e0$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $e147af8df5a9c6e0$export$62ff257738bf57f5(value) {
    if ((0, $d2unA.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$e147af8df5a9c6e0$var$getOwnProperties(value)
    };
    else if ((0, $d2unA.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $e147af8df5a9c6e0$var$serializeEventTarget(value.target),
            currentTarget: $e147af8df5a9c6e0$var$serializeEventTarget(value.currentTarget),
            ...$e147af8df5a9c6e0$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $d2unA.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $e147af8df5a9c6e0$var$serializeEventTarget(target) {
    try {
        return (0, $d2unA.isElement)(target) ? (0, $iTlxf.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $e147af8df5a9c6e0$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $e147af8df5a9c6e0$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($e147af8df5a9c6e0$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $geIBs.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $geIBs.truncate)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $e147af8df5a9c6e0$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $e147af8df5a9c6e0$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $e147af8df5a9c6e0$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ((0, $d2unA.isPlainObject)(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $e147af8df5a9c6e0$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($e147af8df5a9c6e0$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $e147af8df5a9c6e0$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $d2unA.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRequire.register("iTlxf", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $dc0e117ccfaff665$export$5647df6b7814ac86; });
$parcel$export(module.exports, "getLocationHref", function () { return $dc0e117ccfaff665$export$1cfafeee2987818b; });
$parcel$export(module.exports, "getDomElement", function () { return $dc0e117ccfaff665$export$c660c1f3ab49225c; });

var $d2unA = parcelRequire("d2unA");

var $bayd0 = parcelRequire("bayd0");
// eslint-disable-next-line deprecation/deprecation
const $dc0e117ccfaff665$var$WINDOW = (0, $bayd0.getGlobalObject)();
const $dc0e117ccfaff665$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $dc0e117ccfaff665$export$5647df6b7814ac86(elem, options = {}) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $dc0e117ccfaff665$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $dc0e117ccfaff665$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $dc0e117ccfaff665$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $d2unA.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $dc0e117ccfaff665$export$1cfafeee2987818b() {
    try {
        return $dc0e117ccfaff665$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $dc0e117ccfaff665$export$c660c1f3ab49225c(selector) {
    if ($dc0e117ccfaff665$var$WINDOW.document && $dc0e117ccfaff665$var$WINDOW.document.querySelector) return $dc0e117ccfaff665$var$WINDOW.document.querySelector(selector);
    return null;
}

});

parcelRequire.register("geIBs", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $bd208d6627ec0a28$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $bd208d6627ec0a28$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $bd208d6627ec0a28$export$465e9d514283d4fd; });
$parcel$export(module.exports, "stringMatchesSomePattern", function () { return $bd208d6627ec0a28$export$a7a5ec66062ea5d; });

var $d2unA = parcelRequire("d2unA");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $bd208d6627ec0a28$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $bd208d6627ec0a28$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $bd208d6627ec0a28$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $bd208d6627ec0a28$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $d2unA.isString)(value)) return false;
    if ((0, $d2unA.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $d2unA.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $bd208d6627ec0a28$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$bd208d6627ec0a28$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRequire.register("gmhqD", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $be8c385d50b4e754$export$849dbeeeda01ae98; });
const $be8c385d50b4e754$export$849dbeeeda01ae98 = "production";

});

parcelRequire.register("f3hBG", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $af54cb2878804273$export$775b6bb06e53a214; });
$parcel$export(module.exports, "addGlobalEventProcessor", function () { return $af54cb2878804273$export$8e4e25f54d456511; });

var $iMHif = parcelRequire("iMHif");
var $52JFH = parcelRequire("52JFH");
var $bayd0 = parcelRequire("bayd0");
var $d2unA = parcelRequire("d2unA");
var $3lHwZ = parcelRequire("3lHwZ");
var $3tE1b = parcelRequire("3tE1b");

var $dOBEf = parcelRequire("dOBEf");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $af54cb2878804273$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $af54cb2878804273$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /** Transaction Name */ /** Span */ /** Session */ /** Request Mode Session Status */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
    }
    /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */ static clone(scope) {
        const newScope = new $af54cb2878804273$export$775b6bb06e53a214();
        if (scope) {
            newScope._breadcrumbs = [
                ...scope._breadcrumbs
            ];
            newScope._tags = {
                ...scope._tags
            };
            newScope._extra = {
                ...scope._extra
            };
            newScope._contexts = {
                ...scope._contexts
            };
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = [
                ...scope._eventProcessors
            ];
            newScope._requestSession = scope._requestSession;
            newScope._attachments = [
                ...scope._attachments
            ];
            newScope._sdkProcessingMetadata = {
                ...scope._sdkProcessingMetadata
            };
        }
        return newScope;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        this._user = user || {};
        if (this._session) (0, $dOBEf.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSpan() {
        return this._span;
    }
    /**
   * @inheritDoc
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this.getSpan();
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === "function") {
            const updatedScope = captureContext(this);
            return updatedScope instanceof $af54cb2878804273$export$775b6bb06e53a214 ? updatedScope : this;
        }
        if (captureContext instanceof $af54cb2878804273$export$775b6bb06e53a214) {
            this._tags = {
                ...this._tags,
                ...captureContext._tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext._extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext._contexts
            };
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $d2unA.isPlainObject)(captureContext)) {
            captureContext;
            this._tags = {
                ...this._tags,
                ...captureContext.tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext.contexts
            };
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $af54cb2878804273$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $52JFH.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        this._breadcrumbs = [
            ...this._breadcrumbs,
            mergedBreadcrumb
        ].slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ getAttachments() {
        return this._attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */ applyToEvent(event, hint = {}) {
        if (this._extra && Object.keys(this._extra).length) event.extra = {
            ...this._extra,
            ...event.extra
        };
        if (this._tags && Object.keys(this._tags).length) event.tags = {
            ...this._tags,
            ...event.tags
        };
        if (this._user && Object.keys(this._user).length) event.user = {
            ...this._user,
            ...event.user
        };
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = {
            ...this._contexts,
            ...event.contexts
        };
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = {
                trace: this._span.getTraceContext(),
                ...event.contexts
            };
            const transaction = this._span.transaction;
            if (transaction) {
                event.sdkProcessingMetadata = {
                    dynamicSamplingContext: transaction.getDynamicSamplingContext(),
                    ...event.sdkProcessingMetadata
                };
                const transactionName = transaction.name;
                if (transactionName) event.tags = {
                    transaction: transactionName,
                    ...event.tags
                };
            }
        }
        this._applyFingerprint(event);
        event.breadcrumbs = [
            ...event.breadcrumbs || [],
            ...this._breadcrumbs
        ];
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = {
            ...event.sdkProcessingMetadata,
            ...this._sdkProcessingMetadata
        };
        return this._notifyEventProcessors([
            ...$af54cb2878804273$var$getGlobalEventProcessors(),
            ...this._eventProcessors
        ], event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * This will be called after {@link applyToEvent} is finished.
   */ _notifyEventProcessors(processors, event, hint, index = 0) {
        return new (0, $3tE1b.SyncPromise)((resolve, reject)=>{
            const processor = processors[index];
            if (event === null || typeof processor !== "function") resolve(event);
            else {
                const result = processor({
                    ...event
                }, hint);
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && processor.id && result === null && (0, $3lHwZ.logger).log(`Event processor "${processor.id}" dropped event`);
                if ((0, $d2unA.isThenable)(result)) result.then((final)=>this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve)).then(null, reject);
                else this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
    /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */ _applyFingerprint(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? (0, $iMHif.arrayify)(event.fingerprint) : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    }
}
/**
 * Returns the global event processors.
 */ function $af54cb2878804273$var$getGlobalEventProcessors() {
    return (0, $bayd0.getGlobalSingleton)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */ function $af54cb2878804273$export$8e4e25f54d456511(callback) {
    $af54cb2878804273$var$getGlobalEventProcessors().push(callback);
}

});
parcelRequire.register("3tE1b", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", function () { return $28831f47d5129de2$export$1fda8aa4d135f8aa; });
$parcel$export(module.exports, "SyncPromise", function () { return $28831f47d5129de2$export$6f292d4960313241; });
$parcel$export(module.exports, "rejectedSyncPromise", function () { return $28831f47d5129de2$export$78e43115b553f358; });

var $d2unA = parcelRequire("d2unA");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $28831f47d5129de2$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($28831f47d5129de2$var$States || ($28831f47d5129de2$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $28831f47d5129de2$export$1fda8aa4d135f8aa(value) {
    return new $28831f47d5129de2$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $28831f47d5129de2$export$78e43115b553f358(reason) {
    return new $28831f47d5129de2$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $28831f47d5129de2$export$6f292d4960313241 {
    __init() {
        this._state = $28831f47d5129de2$var$States.PENDING;
    }
    __init2() {
        this._handlers = [];
    }
    constructor(executor){
        $28831f47d5129de2$export$6f292d4960313241.prototype.__init.call(this);
        $28831f47d5129de2$export$6f292d4960313241.prototype.__init2.call(this);
        $28831f47d5129de2$export$6f292d4960313241.prototype.__init3.call(this);
        $28831f47d5129de2$export$6f292d4960313241.prototype.__init4.call(this);
        $28831f47d5129de2$export$6f292d4960313241.prototype.__init5.call(this);
        $28831f47d5129de2$export$6f292d4960313241.prototype.__init6.call(this);
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $28831f47d5129de2$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $28831f47d5129de2$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init3() {
        this._resolve = (value)=>{
            this._setResult($28831f47d5129de2$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init4() {
        this._reject = (reason)=>{
            this._setResult($28831f47d5129de2$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init5() {
        this._setResult = (state, value)=>{
            if (this._state !== $28831f47d5129de2$var$States.PENDING) return;
            if ((0, $d2unA.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init6() {
        this._executeHandlers = ()=>{
            if (this._state === $28831f47d5129de2$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $28831f47d5129de2$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $28831f47d5129de2$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});

parcelRequire.register("dOBEf", function(module, exports) {

$parcel$export(module.exports, "makeSession", function () { return $a0ed26018bee0fb1$export$14a186326edbb264; });
$parcel$export(module.exports, "updateSession", function () { return $a0ed26018bee0fb1$export$531818e825e774db; });
$parcel$export(module.exports, "closeSession", function () { return $a0ed26018bee0fb1$export$56521d9ba90f62ee; });

var $jl9W5 = parcelRequire("jl9W5");
var $52JFH = parcelRequire("52JFH");
var $iMHif = parcelRequire("iMHif");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $a0ed26018bee0fb1$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $52JFH.timestampInSeconds)();
    const session = {
        sid: (0, $iMHif.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$a0ed26018bee0fb1$var$sessionToJSON(session)
    };
    if (context) $a0ed26018bee0fb1$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $a0ed26018bee0fb1$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $52JFH.timestampInSeconds)();
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $iMHif.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $a0ed26018bee0fb1$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $a0ed26018bee0fb1$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $a0ed26018bee0fb1$var$sessionToJSON(session) {
    return (0, $jl9W5.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});



parcelRequire.register("1DvVX", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", function () { return $1312345a6106f5f9$export$5008da00b1b6dee6; });

var $kDFdm = parcelRequire("kDFdm");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $1312345a6106f5f9$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $kDFdm.getCurrentHub)().getClient();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}

});

parcelRequire.register("4MUrP", function(module, exports) {

$parcel$export(module.exports, "registerErrorInstrumentation", function () { return $37c76e7750a4669c$export$637857c1d87b640c; });

var $cIWhk = parcelRequire("cIWhk");
var $3lHwZ = parcelRequire("3lHwZ");

var $7JOCn = parcelRequire("7JOCn");
let $37c76e7750a4669c$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $37c76e7750a4669c$export$637857c1d87b640c() {
    if ($37c76e7750a4669c$var$errorsInstrumented) return;
    $37c76e7750a4669c$var$errorsInstrumented = true;
    (0, $cIWhk.addInstrumentationHandler)("error", $37c76e7750a4669c$var$errorCallback);
    (0, $cIWhk.addInstrumentationHandler)("unhandledrejection", $37c76e7750a4669c$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $37c76e7750a4669c$var$errorCallback() {
    const activeTransaction = (0, $7JOCn.getActiveTransaction)();
    if (activeTransaction) {
        const status = "internal_error";
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$37c76e7750a4669c$var$errorCallback.tag = "sentry_tracingErrorCallback";

});
parcelRequire.register("cIWhk", function(module, exports) {

$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", function () { return $9436cd011c13f1ca$export$55b6bb1e45c6cf59; });
$parcel$export(module.exports, "addInstrumentationHandler", function () { return $9436cd011c13f1ca$export$285b9172a3741fb7; });

var $d2unA = parcelRequire("d2unA");

var $3lHwZ = parcelRequire("3lHwZ");

var $jl9W5 = parcelRequire("jl9W5");

var $5GZga = parcelRequire("5GZga");

var $e8jUR = parcelRequire("e8jUR");

var $bayd0 = parcelRequire("bayd0");

var $8GJ4r = parcelRequire("8GJ4r");
// eslint-disable-next-line deprecation/deprecation
const $9436cd011c13f1ca$var$WINDOW = (0, $bayd0.getGlobalObject)();
const $9436cd011c13f1ca$export$55b6bb1e45c6cf59 = "__sentry_xhr_v2__";
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ const $9436cd011c13f1ca$var$handlers = {};
const $9436cd011c13f1ca$var$instrumented = {};
/** Instruments given API */ function $9436cd011c13f1ca$var$instrument(type) {
    if ($9436cd011c13f1ca$var$instrumented[type]) return;
    $9436cd011c13f1ca$var$instrumented[type] = true;
    switch(type){
        case "console":
            $9436cd011c13f1ca$var$instrumentConsole();
            break;
        case "dom":
            $9436cd011c13f1ca$var$instrumentDOM();
            break;
        case "xhr":
            $9436cd011c13f1ca$var$instrumentXHR();
            break;
        case "fetch":
            $9436cd011c13f1ca$var$instrumentFetch();
            break;
        case "history":
            $9436cd011c13f1ca$var$instrumentHistory();
            break;
        case "error":
            $9436cd011c13f1ca$var$instrumentError();
            break;
        case "unhandledrejection":
            $9436cd011c13f1ca$var$instrumentUnhandledRejection();
            break;
        default:
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn("unknown instrumentation type:", type);
            return;
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $9436cd011c13f1ca$export$285b9172a3741fb7(type, callback) {
    $9436cd011c13f1ca$var$handlers[type] = $9436cd011c13f1ca$var$handlers[type] || [];
    $9436cd011c13f1ca$var$handlers[type].push(callback);
    $9436cd011c13f1ca$var$instrument(type);
}
/** JSDoc */ function $9436cd011c13f1ca$var$triggerHandlers(type, data) {
    if (!type || !$9436cd011c13f1ca$var$handlers[type]) return;
    for (const handler of $9436cd011c13f1ca$var$handlers[type] || [])try {
        handler(data);
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $5GZga.getFunctionName)(handler)}\nError:`, e);
    }
}
/** JSDoc */ function $9436cd011c13f1ca$var$instrumentConsole() {
    if (!("console" in $9436cd011c13f1ca$var$WINDOW)) return;
    (0, $3lHwZ.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $9436cd011c13f1ca$var$WINDOW.console)) return;
        (0, $jl9W5.fill)($9436cd011c13f1ca$var$WINDOW.console, level, function(originalConsoleMethod) {
            return function(...args) {
                $9436cd011c13f1ca$var$triggerHandlers("console", {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($9436cd011c13f1ca$var$WINDOW.console, args);
            };
        });
    });
}
/** JSDoc */ function $9436cd011c13f1ca$var$instrumentFetch() {
    if (!(0, $e8jUR.supportsNativeFetch)()) return;
    (0, $jl9W5.fill)($9436cd011c13f1ca$var$WINDOW, "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method , url: url  } = $9436cd011c13f1ca$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            $9436cd011c13f1ca$var$triggerHandlers("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($9436cd011c13f1ca$var$WINDOW, args).then((response)=>{
                $9436cd011c13f1ca$var$triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                });
                return response;
            }, (error)=>{
                $9436cd011c13f1ca$var$triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                });
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $9436cd011c13f1ca$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $9436cd011c13f1ca$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($9436cd011c13f1ca$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request
 */ function $9436cd011c13f1ca$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $9436cd011c13f1ca$var$getUrlFromResource(url),
            method: $9436cd011c13f1ca$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $9436cd011c13f1ca$var$getUrlFromResource(arg),
        method: $9436cd011c13f1ca$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
/** JSDoc */ function $9436cd011c13f1ca$var$instrumentXHR() {
    if (!("XMLHttpRequest" in $9436cd011c13f1ca$var$WINDOW)) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $jl9W5.fill)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const url = args[1];
            const xhrInfo = this[$9436cd011c13f1ca$export$55b6bb1e45c6cf59] = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $d2unA.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $d2unA.isString)(url) && xhrInfo.method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$9436cd011c13f1ca$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    $9436cd011c13f1ca$var$triggerHandlers("xhr", {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: this
                    });
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $jl9W5.fill)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $jl9W5.fill)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$9436cd011c13f1ca$export$55b6bb1e45c6cf59];
                    if (xhrInfo) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $jl9W5.fill)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$9436cd011c13f1ca$export$55b6bb1e45c6cf59];
            if (sentryXhrData && args[0] !== undefined) sentryXhrData.body = args[0];
            $9436cd011c13f1ca$var$triggerHandlers("xhr", {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
let $9436cd011c13f1ca$var$lastHref;
/** JSDoc */ function $9436cd011c13f1ca$var$instrumentHistory() {
    if (!(0, $8GJ4r.supportsHistory)()) return;
    const oldOnPopState = $9436cd011c13f1ca$var$WINDOW.onpopstate;
    $9436cd011c13f1ca$var$WINDOW.onpopstate = function(...args) {
        const to = $9436cd011c13f1ca$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $9436cd011c13f1ca$var$lastHref;
        $9436cd011c13f1ca$var$lastHref = to;
        $9436cd011c13f1ca$var$triggerHandlers("history", {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $9436cd011c13f1ca$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $9436cd011c13f1ca$var$lastHref = to;
                $9436cd011c13f1ca$var$triggerHandlers("history", {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $jl9W5.fill)($9436cd011c13f1ca$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $jl9W5.fill)($9436cd011c13f1ca$var$WINDOW.history, "replaceState", historyReplacementFunction);
}
const $9436cd011c13f1ca$var$debounceDuration = 1000;
let $9436cd011c13f1ca$var$debounceTimerID;
let $9436cd011c13f1ca$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $9436cd011c13f1ca$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $9436cd011c13f1ca$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== "keypress") return false;
    try {
        const target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $9436cd011c13f1ca$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $9436cd011c13f1ca$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($9436cd011c13f1ca$var$shouldSkipDOMEvent(event)) return;
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($9436cd011c13f1ca$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $9436cd011c13f1ca$var$lastCapturedEvent = event;
        } else if ($9436cd011c13f1ca$var$shouldShortcircuitPreviousDebounce($9436cd011c13f1ca$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $9436cd011c13f1ca$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($9436cd011c13f1ca$var$debounceTimerID);
        $9436cd011c13f1ca$var$debounceTimerID = $9436cd011c13f1ca$var$WINDOW.setTimeout(()=>{
            $9436cd011c13f1ca$var$debounceTimerID = undefined;
        }, $9436cd011c13f1ca$var$debounceDuration);
    };
}
/** JSDoc */ function $9436cd011c13f1ca$var$instrumentDOM() {
    if (!("document" in $9436cd011c13f1ca$var$WINDOW)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = $9436cd011c13f1ca$var$triggerHandlers.bind(null, "dom");
    const globalDOMEventHandler = $9436cd011c13f1ca$var$makeDOMEventHandler(triggerDOMHandler, true);
    $9436cd011c13f1ca$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $9436cd011c13f1ca$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $9436cd011c13f1ca$var$WINDOW[target] && $9436cd011c13f1ca$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $jl9W5.fill)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $9436cd011c13f1ca$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $jl9W5.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
let $9436cd011c13f1ca$var$_oldOnErrorHandler = null;
/** JSDoc */ function $9436cd011c13f1ca$var$instrumentError() {
    $9436cd011c13f1ca$var$_oldOnErrorHandler = $9436cd011c13f1ca$var$WINDOW.onerror;
    $9436cd011c13f1ca$var$WINDOW.onerror = function(msg, url, line, column, error) {
        $9436cd011c13f1ca$var$triggerHandlers("error", {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($9436cd011c13f1ca$var$_oldOnErrorHandler && !$9436cd011c13f1ca$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $9436cd011c13f1ca$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    $9436cd011c13f1ca$var$WINDOW.onerror.__SENTRY_INSTRUMENTED__ = true;
}
let $9436cd011c13f1ca$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $9436cd011c13f1ca$var$instrumentUnhandledRejection() {
    $9436cd011c13f1ca$var$_oldOnUnhandledRejectionHandler = $9436cd011c13f1ca$var$WINDOW.onunhandledrejection;
    $9436cd011c13f1ca$var$WINDOW.onunhandledrejection = function(e) {
        $9436cd011c13f1ca$var$triggerHandlers("unhandledrejection", e);
        if ($9436cd011c13f1ca$var$_oldOnUnhandledRejectionHandler && !$9436cd011c13f1ca$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $9436cd011c13f1ca$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    $9436cd011c13f1ca$var$WINDOW.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});
parcelRequire.register("5GZga", function(module, exports) {

$parcel$export(module.exports, "createStackParser", function () { return $425064ed8be9d93c$export$a5739666fb2d03d4; });
$parcel$export(module.exports, "stackParserFromStackParserOptions", function () { return $425064ed8be9d93c$export$1d5cf88b347146d4; });
$parcel$export(module.exports, "getFunctionName", function () { return $425064ed8be9d93c$export$aad197c7121a6651; });

var $axlwk = parcelRequire("axlwk");
const $425064ed8be9d93c$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $425064ed8be9d93c$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $425064ed8be9d93c$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $425064ed8be9d93c$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($425064ed8be9d93c$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $425064ed8be9d93c$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $425064ed8be9d93c$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $425064ed8be9d93c$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $425064ed8be9d93c$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $425064ed8be9d93c$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = stack.slice(0, $425064ed8be9d93c$var$STACKTRACE_FRAME_LIMIT);
    const lastFrameFunction = localStack[localStack.length - 1].function;
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (lastFrameFunction && /sentryWrapped/.test(lastFrameFunction)) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    const firstFrameFunction = localStack[localStack.length - 1].function;
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (firstFrameFunction && /captureMessage|captureException/.test(firstFrameFunction)) localStack.pop();
    return localStack.map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $425064ed8be9d93c$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $425064ed8be9d93c$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $425064ed8be9d93c$var$defaultFunctionName;
        return fn.name || $425064ed8be9d93c$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $425064ed8be9d93c$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $425064ed8be9d93c$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $axlwk.node)(getModule)
    ];
}

});
parcelRequire.register("axlwk", function(module, exports) {

$parcel$export(module.exports, "node", function () { return $7abdadfa94551a99$export$35059013cd4a06db; });
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $7abdadfa94551a99$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
            !filename.startsWith("/") && // It's not internal if it's an absolute windows path
            !filename.includes(":\\") && // It's not internal if the path is starting with a dot
            !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
            !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
            // in_app is all that's not an internal Node function or a module within node_modules
            // note that isNative appears to return true even for node core libraries
            // see https://github.com/getsentry/raven-node/issues/176
            const in_app = !isInternal && filename !== undefined && !filename.includes("node_modules/");
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: in_app
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});


parcelRequire.register("e8jUR", function(module, exports) {

$parcel$export(module.exports, "supportsFetch", function () { return $a4a142f831a23d95$export$edf3cb81fd7d2a3e; });
$parcel$export(module.exports, "isNativeFetch", function () { return $a4a142f831a23d95$export$18cf36ed71d733e7; });
$parcel$export(module.exports, "supportsNativeFetch", function () { return $a4a142f831a23d95$export$c82d238e23c40b21; });

var $3lHwZ = parcelRequire("3lHwZ");

var $bayd0 = parcelRequire("bayd0");
// eslint-disable-next-line deprecation/deprecation
const $a4a142f831a23d95$var$WINDOW = (0, $bayd0.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $a4a142f831a23d95$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $a4a142f831a23d95$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $a4a142f831a23d95$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $a4a142f831a23d95$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $a4a142f831a23d95$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $a4a142f831a23d95$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $a4a142f831a23d95$export$c82d238e23c40b21() {
    if (!$a4a142f831a23d95$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($a4a142f831a23d95$export$18cf36ed71d733e7($a4a142f831a23d95$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $a4a142f831a23d95$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $a4a142f831a23d95$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $a4a142f831a23d95$export$531055a6c684a70a() {
    return "ReportingObserver" in $a4a142f831a23d95$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $a4a142f831a23d95$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$a4a142f831a23d95$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRequire.register("8GJ4r", function(module, exports) {

$parcel$export(module.exports, "supportsHistory", function () { return $65353509e999e4a1$export$67fc34576016d6ec; });

var $bayd0 = parcelRequire("bayd0");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $65353509e999e4a1$var$WINDOW = (0, $bayd0.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $65353509e999e4a1$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chrome = $65353509e999e4a1$var$WINDOW.chrome;
    const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $65353509e999e4a1$var$WINDOW && !!$65353509e999e4a1$var$WINDOW.history.pushState && !!$65353509e999e4a1$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRequire.register("7JOCn", function(module, exports) {

$parcel$export(module.exports, "getActiveTransaction", function () { return $5a24000d3d6f9747$export$a7feb32fdd923295; });

var $kDFdm = parcelRequire("kDFdm");

/** Grabs active transaction off scope, if any */ function $5a24000d3d6f9747$export$a7feb32fdd923295(maybeHub) {
    const hub = maybeHub || (0, $kDFdm.getCurrentHub)();
    const scope = hub.getScope();
    return scope.getTransaction();
}

});


parcelRequire.register("5vcgO", function(module, exports) {

$parcel$export(module.exports, "TRACING_DEFAULTS", function () { return $40195d94700cd147$export$809a2b7987fd5306; });
$parcel$export(module.exports, "IdleTransaction", function () { return $40195d94700cd147$export$b279e6bd7040371f; });

var $3lHwZ = parcelRequire("3lHwZ");
var $52JFH = parcelRequire("52JFH");

var $iT1V4 = parcelRequire("iT1V4");

var $lOd6Z = parcelRequire("lOd6Z");
const $40195d94700cd147$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $40195d94700cd147$var$FINISH_REASON_TAG = "finishReason";
const $40195d94700cd147$var$IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled"
];
/**
 * @inheritDoc
 */ class $40195d94700cd147$export$370d6113c18ba86c extends (0, $iT1V4.SpanRecorder) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanId !== this.transactionSpanId) {
            // We patch span.finish() to pop an activity after setting an endTimestamp.
            span.finish = (endTimestamp)=>{
                span.endTimestamp = typeof endTimestamp === "number" ? endTimestamp : (0, $52JFH.timestampInSeconds)();
                this._popActivity(span.spanId);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if (span.endTimestamp === undefined) this._pushActivity(span.spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $40195d94700cd147$export$b279e6bd7040371f extends (0, $lOd6Z.Transaction) {
    // Activities store a list of active spans
    __init() {
        this.activities = {};
    }
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    __init2() {
        this._heartbeatCounter = 0;
    }
    // We should not use heartbeat if we finished a transaction
    __init3() {
        this._finished = false;
    }
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    __init4() {
        this._idleTimeoutCanceledPermanently = false;
    }
    __init5() {
        this._beforeFinishCallbacks = [];
    }
    /**
   * Timer that tracks Transaction idleTimeout
   */ __init6() {
        this._finishReason = $40195d94700cd147$var$IDLE_TRANSACTION_FINISH_REASONS[4];
    }
    constructor(transactionContext, _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $40195d94700cd147$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $40195d94700cd147$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $40195d94700cd147$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        $40195d94700cd147$export$b279e6bd7040371f.prototype.__init.call(this);
        $40195d94700cd147$export$b279e6bd7040371f.prototype.__init2.call(this);
        $40195d94700cd147$export$b279e6bd7040371f.prototype.__init3.call(this);
        $40195d94700cd147$export$b279e6bd7040371f.prototype.__init4.call(this);
        $40195d94700cd147$export$b279e6bd7040371f.prototype.__init5.call(this);
        $40195d94700cd147$export$b279e6bd7040371f.prototype.__init6.call(this);
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
            _idleHub.configureScope((scope)=>scope.setSpan(this));
        }
        this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus("deadline_exceeded");
                this._finishReason = $40195d94700cd147$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.finish();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ finish(endTimestamp = (0, $52JFH.timestampInSeconds)()) {
        this._finished = true;
        this.activities = {};
        if (this.op === "ui.action.click") this.setTag($40195d94700cd147$var$FINISH_REASON_TAG, this._finishReason);
        if (this.spanRecorder) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Tracing] finishing IdleTransaction", new Date(endTimestamp * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestamp);
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanId === this.spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!span.endTimestamp) {
                    span.endTimestamp = endTimestamp;
                    span.setStatus("cancelled");
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                const keepSpan = span.startTimestamp < endTimestamp;
                if (!keepSpan) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Tracing] discarding Span since it happened after Transaction was finished", JSON.stringify(span, undefined, 2));
                return keepSpan;
            });
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Tracing] flushing IdleTransaction");
        } else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Tracing] No active IdleTransaction");
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            const scope = this._idleHub.getScope();
            if (scope.getTransaction() === this) scope.setSpan(undefined);
        }
        return super.finish(endTimestamp);
    }
    /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            this.spanRecorder = new $40195d94700cd147$export$370d6113c18ba86c(pushActivity, popActivity, this.spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange  } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $40195d94700cd147$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.finish(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $40195d94700cd147$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.finish(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $52JFH.timestampInSeconds)();
            if (this._idleTimeoutCanceledPermanently) {
                this._finishReason = $40195d94700cd147$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.finish(endTimestamp);
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join("");
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Tracing] Transaction finished because of no change for 3 heart beats");
            this.setStatus("deadline_exceeded");
            this._finishReason = $40195d94700cd147$var$IDLE_TRANSACTION_FINISH_REASONS[0];
            this.finish();
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}

});
parcelRequire.register("iT1V4", function(module, exports) {

$parcel$export(module.exports, "SpanRecorder", function () { return $dbfeda3ec58d32cf$export$10c95c129cd0d4fe; });
$parcel$export(module.exports, "Span", function () { return $dbfeda3ec58d32cf$export$5f1714a13ed34c01; });
$parcel$export(module.exports, "spanStatusfromHttpCode", function () { return $dbfeda3ec58d32cf$export$ac65c70d78fcdb55; });

var $jl9W5 = parcelRequire("jl9W5");
var $3lHwZ = parcelRequire("3lHwZ");
var $52JFH = parcelRequire("52JFH");
var $iMHif = parcelRequire("iMHif");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $dbfeda3ec58d32cf$export$10c95c129cd0d4fe {
    __init() {
        this.spans = [];
    }
    constructor(maxlen = 1000){
        $dbfeda3ec58d32cf$export$10c95c129cd0d4fe.prototype.__init.call(this);
        this._maxlen = maxlen;
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $dbfeda3ec58d32cf$export$5f1714a13ed34c01 {
    /**
   * @inheritDoc
   */ __init2() {
        this.traceId = (0, $iMHif.uuid4)();
    }
    /**
   * @inheritDoc
   */ __init3() {
        this.spanId = (0, $iMHif.uuid4)().substring(16);
    }
    /**
   * @inheritDoc
   */ /**
   * Internal keeper of the status
   */ /**
   * @inheritDoc
   */ /**
   * Timestamp in seconds when the span was created.
   */ __init4() {
        this.startTimestamp = (0, $52JFH.timestampInSeconds)();
    }
    /**
   * Timestamp in seconds when the span ended.
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ __init5() {
        this.tags = {};
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    __init6() {
        this.data = {};
    }
    /**
   * List of spans that were finalized
   */ /**
   * @inheritDoc
   */ /**
   * The instrumenter that created this span.
   */ __init7() {
        this.instrumenter = "sentry";
    }
    /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext){
        $dbfeda3ec58d32cf$export$5f1714a13ed34c01.prototype.__init2.call(this);
        $dbfeda3ec58d32cf$export$5f1714a13ed34c01.prototype.__init3.call(this);
        $dbfeda3ec58d32cf$export$5f1714a13ed34c01.prototype.__init4.call(this);
        $dbfeda3ec58d32cf$export$5f1714a13ed34c01.prototype.__init5.call(this);
        $dbfeda3ec58d32cf$export$5f1714a13ed34c01.prototype.__init6.call(this);
        $dbfeda3ec58d32cf$export$5f1714a13ed34c01.prototype.__init7.call(this);
        if (!spanContext) return this;
        if (spanContext.traceId) this.traceId = spanContext.traceId;
        if (spanContext.spanId) this.spanId = spanContext.spanId;
        if (spanContext.parentSpanId) this.parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this.sampled = spanContext.sampled;
        if (spanContext.op) this.op = spanContext.op;
        if (spanContext.description) this.description = spanContext.description;
        if (spanContext.data) this.data = spanContext.data;
        if (spanContext.tags) this.tags = spanContext.tags;
        if (spanContext.status) this.status = spanContext.status;
        if (spanContext.startTimestamp) this.startTimestamp = spanContext.startTimestamp;
        if (spanContext.endTimestamp) this.endTimestamp = spanContext.endTimestamp;
        if (spanContext.instrumenter) this.instrumenter = spanContext.instrumenter;
    }
    /**
   * @inheritDoc
   */ startChild(spanContext) {
        const childSpan = new $dbfeda3ec58d32cf$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this.spanId,
            sampled: this.sampled,
            traceId: this.traceId
        });
        childSpan.spanRecorder = this.spanRecorder;
        if (childSpan.spanRecorder) childSpan.spanRecorder.add(childSpan);
        childSpan.transaction = this.transaction;
        if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && childSpan.transaction) {
            const opStr = spanContext && spanContext.op || "< unknown op >";
            const nameStr = childSpan.transaction.name || "< unknown name >";
            const idStr = childSpan.transaction.spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = {
                logMessage: logMessage
            };
            (0, $3lHwZ.logger).log(logMessage);
        }
        return childSpan;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    setData(key, value) {
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this.status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ setHttpStatus(httpStatus) {
        this.setTag("http.status_code", String(httpStatus));
        const spanStatus = $dbfeda3ec58d32cf$export$ac65c70d78fcdb55(httpStatus);
        if (spanStatus !== "unknown_error") this.setStatus(spanStatus);
        return this;
    }
    /**
   * @inheritDoc
   */ isSuccess() {
        return this.status === "ok";
    }
    /**
   * @inheritDoc
   */ finish(endTimestamp) {
        if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && // Don't call this for transactions
        this.transaction && this.transaction.spanId !== this.spanId) {
            const { logMessage: logMessage  } = this.transaction.metadata.spanMetadata[this.spanId];
            if (logMessage) (0, $3lHwZ.logger).log(logMessage.replace("Starting", "Finishing"));
        }
        this.endTimestamp = typeof endTimestamp === "number" ? endTimestamp : (0, $52JFH.timestampInSeconds)();
    }
    /**
   * @inheritDoc
   */ toTraceparent() {
        let sampledString = "";
        if (this.sampled !== undefined) sampledString = this.sampled ? "-1" : "-0";
        return `${this.traceId}-${this.spanId}${sampledString}`;
    }
    /**
   * @inheritDoc
   */ toContext() {
        return (0, $jl9W5.dropUndefinedKeys)({
            data: this.data,
            description: this.description,
            endTimestamp: this.endTimestamp,
            op: this.op,
            parentSpanId: this.parentSpanId,
            sampled: this.sampled,
            spanId: this.spanId,
            startTimestamp: this.startTimestamp,
            status: this.status,
            tags: this.tags,
            traceId: this.traceId
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(spanContext) {
        this.data = spanContext.data || {};
        this.description = spanContext.description;
        this.endTimestamp = spanContext.endTimestamp;
        this.op = spanContext.op;
        this.parentSpanId = spanContext.parentSpanId;
        this.sampled = spanContext.sampled;
        this.spanId = spanContext.spanId || this.spanId;
        this.startTimestamp = spanContext.startTimestamp || this.startTimestamp;
        this.status = spanContext.status;
        this.tags = spanContext.tags || {};
        this.traceId = spanContext.traceId || this.traceId;
        return this;
    }
    /**
   * @inheritDoc
   */ getTraceContext() {
        return (0, $jl9W5.dropUndefinedKeys)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            trace_id: this.traceId
        });
    }
    /**
   * @inheritDoc
   */ toJSON() {
        return (0, $jl9W5.dropUndefinedKeys)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            start_timestamp: this.startTimestamp,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this.endTimestamp,
            trace_id: this.traceId
        });
    }
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $dbfeda3ec58d32cf$export$ac65c70d78fcdb55(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}

});

parcelRequire.register("lOd6Z", function(module, exports) {

$parcel$export(module.exports, "Transaction", function () { return $fe0870310ada00db$export$febc5573c75cefb0; });

var $jl9W5 = parcelRequire("jl9W5");
var $3lHwZ = parcelRequire("3lHwZ");

var $gmhqD = parcelRequire("gmhqD");

var $kDFdm = parcelRequire("kDFdm");

var $iT1V4 = parcelRequire("iT1V4");
/** JSDoc */ class $fe0870310ada00db$export$febc5573c75cefb0 extends (0, $iT1V4.Span) {
    /**
   * The reference to the current hub.
   */ __init() {
        this._measurements = {};
    }
    __init2() {
        this._contexts = {};
    }
    __init3() {
        this._frozenDynamicSamplingContext = undefined;
    }
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(transactionContext, hub){
        super(transactionContext);
        $fe0870310ada00db$export$febc5573c75cefb0.prototype.__init.call(this);
        $fe0870310ada00db$export$febc5573c75cefb0.prototype.__init2.call(this);
        $fe0870310ada00db$export$febc5573c75cefb0.prototype.__init3.call(this);
        this._hub = hub || (0, $kDFdm.getCurrentHub)();
        this._name = transactionContext.name || "";
        this.metadata = {
            source: "custom",
            ...transactionContext.metadata,
            spanMetadata: {}
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this.metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    /** Getter for `name` property */ get name() {
        return this._name;
    }
    /** Setter for `name` property, which also sets `source` as custom */ set name(newName) {
        this.setName(newName);
    }
    /**
   * JSDoc
   */ setName(name, source = "custom") {
        this._name = name;
        this.metadata.source = source;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        if (!this.spanRecorder) this.spanRecorder = new (0, $iT1V4.SpanRecorder)(maxlen);
        this.spanRecorder.add(this);
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   */ setMeasurement(name, value, unit = "") {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * @inheritDoc
   */ setMetadata(newMetadata) {
        this.metadata = {
            ...this.metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ finish(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this.endTimestamp !== undefined) return undefined;
        if (!this.name) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this.name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        super.finish(endTimestamp);
        const client = this._hub.getClient();
        if (client && client.emit) client.emit("finishTransaction", this);
        if (this.sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((s)=>s !== this && s.endTimestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) this.endTimestamp = finishedSpans.reduce((prev, current)=>{
            if (prev.endTimestamp && current.endTimestamp) return prev.endTimestamp > current.endTimestamp ? prev : current;
            return prev;
        }).endTimestamp;
        const metadata = this.metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: this.getTraceContext()
            },
            spans: finishedSpans,
            start_timestamp: this.startTimestamp,
            tags: this.tags,
            timestamp: this.endTimestamp,
            transaction: this.name,
            type: "transaction",
            sdkProcessingMetadata: {
                ...metadata,
                dynamicSamplingContext: this.getDynamicSamplingContext()
            },
            ...metadata.source && {
                transaction_info: {
                    source: metadata.source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        const spanContext = super.toContext();
        return (0, $jl9W5.dropUndefinedKeys)({
            ...spanContext,
            name: this.name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        super.updateWithContext(transactionContext);
        this.name = transactionContext.name || "";
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   */ getDynamicSamplingContext() {
        if (this._frozenDynamicSamplingContext) return this._frozenDynamicSamplingContext;
        const hub = this._hub || (0, $kDFdm.getCurrentHub)();
        const client = hub && hub.getClient();
        if (!client) return {};
        const { environment: environment , release: release  } = client.getOptions() || {};
        const { publicKey: public_key  } = client.getDsn() || {};
        const maybeSampleRate = this.metadata.sampleRate;
        const sample_rate = maybeSampleRate !== undefined ? maybeSampleRate.toString() : undefined;
        const { segment: user_segment  } = hub.getScope().getUser() || {};
        const source = this.metadata.source;
        // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
        const transaction = source && source !== "url" ? this.name : undefined;
        const dsc = (0, $jl9W5.dropUndefinedKeys)({
            environment: environment || (0, $gmhqD.DEFAULT_ENVIRONMENT),
            release: release,
            transaction: transaction,
            user_segment: user_segment,
            public_key: public_key,
            trace_id: this.traceId,
            sample_rate: sample_rate
        });
        // Uncomment if we want to make DSC immutable
        // this._frozenDynamicSamplingContext = dsc;
        client.emit && client.emit("createDsc", dsc);
        return dsc;
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ setHub(hub) {
        this._hub = hub;
    }
}

});




parcelRequire.register("ghI6l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.TagManager = void 0;

var $bdb0717ed04b399a$var$_reactGtmModule = $bdb0717ed04b399a$var$_interopRequireDefault((parcelRequire("9wcIQ")));

var $bdb0717ed04b399a$var$_Util = $bdb0717ed04b399a$var$_interopRequireDefault((parcelRequire("iIFwd")));
function $bdb0717ed04b399a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $bdb0717ed04b399a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bdb0717ed04b399a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $bdb0717ed04b399a$var$ownKeys(source, true).forEach(function(key) {
            $bdb0717ed04b399a$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $bdb0717ed04b399a$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bdb0717ed04b399a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bdb0717ed04b399a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bdb0717ed04b399a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bdb0717ed04b399a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bdb0717ed04b399a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $bdb0717ed04b399a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $bdb0717ed04b399a$var$TagManager = /*#__PURE__*/ function() {
    function TagManager(config, tagManager, window1) {
        $bdb0717ed04b399a$var$_classCallCheck(this, TagManager);
        $bdb0717ed04b399a$var$_defineProperty(this, "config", void 0);
        $bdb0717ed04b399a$var$_defineProperty(this, "tagManager", void 0);
        $bdb0717ed04b399a$var$_defineProperty(this, "window", void 0);
        this.config = config;
        this.window = window1;
        this.tagManager = tagManager;
        this.tagManager.initialize($bdb0717ed04b399a$var$_objectSpread({
            gtmId: this.config.containerId
        }, this.config));
    }
    $bdb0717ed04b399a$var$_createClass(TagManager, [
        {
            key: "log",
            value: function log(msg) {
                if (this.config.debug) $bdb0717ed04b399a$var$_Util["default"].log(msg);
            }
        },
        {
            key: "getGTMEventCallback",
            value: function getGTMEventCallback(customEventCallback, resolve) {
                var _this = this;
                return function(containerId) {
                    if (!_this.config.containerId || _this.config.containerId === containerId) {
                        _this.log("GTM callback");
                        resolve(customEventCallback(containerId));
                    }
                };
            }
        },
        {
            key: "getDataLayerPromise",
            value: function getDataLayerPromise(dataLayer, eventCallback) {
                var _this2 = this;
                return new Promise(function(resolve) {
                    if (!_this2.window.google_tag_manager) {
                        _this2.log("No GTM loaded, will resolve.");
                        return resolve(eventCallback());
                    }
                    return _this2.tagManager.dataLayer({
                        dataLayer: $bdb0717ed04b399a$var$_objectSpread({}, dataLayer, {
                            eventCallback: _this2.getGTMEventCallback(eventCallback, resolve)
                        })
                    });
                });
            }
        },
        {
            key: "dataLayer",
            value: function dataLayer(_dataLayer) {
                var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1500;
                var _dataLayer$eventCallb = _dataLayer.eventCallback, eventCallback = _dataLayer$eventCallb === void 0 ? function() {} : _dataLayer$eventCallb, _dataLayer$eventTimeo = _dataLayer.eventTimeout, eventTimeout = _dataLayer$eventTimeo === void 0 ? timeout : _dataLayer$eventTimeo;
                return $bdb0717ed04b399a$var$_Util["default"].promiseTimeout(timeout, this.getDataLayerPromise($bdb0717ed04b399a$var$_objectSpread({}, _dataLayer, {
                    eventTimeout: eventTimeout
                }), eventCallback), eventCallback);
            }
        }
    ], [
        {
            key: "getInstance",
            value: function getInstance(config, tagManager, window1) {
                if (!TagManager.instance) TagManager.instance = new TagManager(config, tagManager, window1);
                return TagManager.instance;
            }
        },
        {
            key: "getInitializedInstance",
            value: function getInitializedInstance() {
                if (!TagManager.instance) throw new Error("TagManger not initialized");
                return TagManager.instance;
            }
        }
    ]);
    return TagManager;
}();
module.exports.TagManager = $bdb0717ed04b399a$var$TagManager;
$bdb0717ed04b399a$var$_defineProperty($bdb0717ed04b399a$var$TagManager, "instance", void 0);
var $bdb0717ed04b399a$var$init = function init(config) {
    return $bdb0717ed04b399a$var$TagManager.getInstance(config, $bdb0717ed04b399a$var$_reactGtmModule["default"], window);
};
var $bdb0717ed04b399a$var$getInstance = function getInstance() {
    return $bdb0717ed04b399a$var$TagManager.getInitializedInstance();
};
var $bdb0717ed04b399a$var$_default = {
    init: $bdb0717ed04b399a$var$init,
    getInstance: $bdb0717ed04b399a$var$getInstance
};
module.exports["default"] = $bdb0717ed04b399a$var$_default;

});
parcelRequire.register("9wcIQ", function(module, exports) {
"use strict";

var $jsLjg = parcelRequire("jsLjg");
var $6ee0f899117752ab$var$_TagManager2 = $6ee0f899117752ab$var$_interopRequireDefault($jsLjg);
function $6ee0f899117752ab$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports = $6ee0f899117752ab$var$_TagManager2.default;

});
parcelRequire.register("jsLjg", function(module, exports) {
"use strict";

var $2zKdX = parcelRequire("2zKdX");
var $e2b554955b5a7d5b$var$_Snippets2 = $e2b554955b5a7d5b$var$_interopRequireDefault($2zKdX);
function $e2b554955b5a7d5b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e2b554955b5a7d5b$var$TagManager = {
    dataScript: function dataScript(dataLayer) {
        var script = document.createElement("script");
        script.innerHTML = dataLayer;
        return script;
    },
    gtm: function gtm(args) {
        var snippets = $e2b554955b5a7d5b$var$_Snippets2.default.tags(args);
        var noScript = function noScript() {
            var noscript = document.createElement("noscript");
            noscript.innerHTML = snippets.iframe;
            return noscript;
        };
        var consentScript = function consentScript() {
            var script = document.createElement("script");
            script.innerHTML = snippets.consentScript;
            return script;
        };
        var script = function script() {
            var script = document.createElement("script");
            script.innerHTML = snippets.script;
            return script;
        };
        var dataScript = this.dataScript(snippets.dataLayerVar);
        return {
            noScript: noScript,
            script: script,
            consentScript: consentScript,
            dataScript: dataScript
        };
    },
    initialize: function initialize(_ref) {
        var gtmId = _ref.gtmId, _ref$events = _ref.events, events = _ref$events === undefined ? {} : _ref$events, dataLayer = _ref.dataLayer, _ref$dataLayerName = _ref.dataLayerName, dataLayerName = _ref$dataLayerName === undefined ? "dataLayer" : _ref$dataLayerName, _ref$auth = _ref.auth, auth = _ref$auth === undefined ? "" : _ref$auth, _ref$preview = _ref.preview, preview = _ref$preview === undefined ? "" : _ref$preview;
        var gtm = this.gtm({
            id: gtmId,
            events: events,
            dataLayer: dataLayer || undefined,
            dataLayerName: dataLayerName,
            auth: auth,
            preview: preview
        });
        if (dataLayer) document.head.appendChild(gtm.dataScript);
        document.head.insertBefore(gtm.consentScript(), document.head.childNodes[0]);
        document.head.insertBefore(gtm.script(), document.head.childNodes[1]);
        document.body.insertBefore(gtm.noScript(), document.body.childNodes[0]);
    },
    dataLayer: function dataLayer(_ref2) {
        var _dataLayer = _ref2.dataLayer, _ref2$dataLayerName = _ref2.dataLayerName, dataLayerName = _ref2$dataLayerName === undefined ? "dataLayer" : _ref2$dataLayerName;
        if (window[dataLayerName]) return window[dataLayerName].push(_dataLayer);
        var snippets = $e2b554955b5a7d5b$var$_Snippets2.default.dataLayer(_dataLayer, dataLayerName);
        var dataScript = this.dataScript(snippets);
        document.head.insertBefore(dataScript, document.head.childNodes[0]);
    }
};
module.exports = $e2b554955b5a7d5b$var$TagManager;

});
parcelRequire.register("2zKdX", function(module, exports) {
"use strict";

var $8iTuQ = parcelRequire("8iTuQ");
var $1e02b4c769413203$var$_warn2 = $1e02b4c769413203$var$_interopRequireDefault($8iTuQ);
function $1e02b4c769413203$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// https://developers.google.com/tag-manager/quickstart
var $1e02b4c769413203$var$Snippets = {
    tags: function tags(_ref) {
        var id = _ref.id, events = _ref.events, dataLayer = _ref.dataLayer, dataLayerName = _ref.dataLayerName, preview = _ref.preview, auth = _ref.auth;
        var gtm_auth = "&gtm_auth=" + auth;
        var gtm_preview = "&gtm_preview=" + preview;
        if (!id) (0, $1e02b4c769413203$var$_warn2.default)("GTM Id is required");
        var iframe = '\n      <iframe src="https://www.googletagmanager.com/ns.html?id=' + id + gtm_auth + gtm_preview + '&gtm_cookies_win=x"\n        height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>';
        var consentScript = "\n      window.dataLayer = window.dataLayer || [];\n      function gtag(){dataLayer.push(arguments);}\n      gtag('consent', 'default', {'ad_storage': 'denied', 'analytics_storage': 'denied', 'wait_for_update': 500});\n    ";
        var script = "\n      (function(w,d,s,l,i){w[l]=w[l]||[];\n        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js', " + JSON.stringify(events).slice(1, -1) + "});\n        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';\n        j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+'" + gtm_auth + gtm_preview + "&gtm_cookies_win=x';\n        f.parentNode.insertBefore(j,f);\n      })(window,document,'script','" + dataLayerName + "','" + id + "');";
        var dataLayerVar = this.dataLayer(dataLayer, dataLayerName);
        return {
            iframe: iframe,
            consentScript: consentScript,
            script: script,
            dataLayerVar: dataLayerVar
        };
    },
    dataLayer: function dataLayer(_dataLayer, dataLayerName) {
        return "\n      window." + dataLayerName + " = window." + dataLayerName + " || [];\n      window." + dataLayerName + ".push(" + JSON.stringify(_dataLayer) + ")";
    }
};
module.exports = $1e02b4c769413203$var$Snippets;

});
parcelRequire.register("8iTuQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $60bb0d9a88d76da8$var$warn = function warn(s) {
    console.warn("[react-gtm]", s);
};
module.exports.default = $60bb0d9a88d76da8$var$warn;

});




parcelRequire.register("iIFwd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $da0c8acaedb02723$var$log = function log(msg) {
    return console.debug(msg);
};
var $da0c8acaedb02723$var$promiseTimeout = function promiseTimeout(ms, promise, eventCallback) {
    var id;
    var timeout = new Promise(function(resolve) {
        id = setTimeout(function() {
            $da0c8acaedb02723$var$log("Forced resolve");
            resolve(eventCallback());
        }, ms);
    });
    return Promise.race([
        promise,
        timeout
    ]).then(function(result) {
        clearTimeout(id);
        return result;
    });
};
var $da0c8acaedb02723$var$_default = {
    log: $da0c8acaedb02723$var$log,
    promiseTimeout: $da0c8acaedb02723$var$promiseTimeout
};
module.exports["default"] = $da0c8acaedb02723$var$_default;

});


parcelRequire.register("2EKye", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $1ef36d43a6d49b42$var$_TagManager = $1ef36d43a6d49b42$var$_interopRequireDefault((parcelRequire("ghI6l")));
function $1ef36d43a6d49b42$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $1ef36d43a6d49b42$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $1ef36d43a6d49b42$var$push = function push(type, data, event) {
    var instance = $1ef36d43a6d49b42$var$_TagManager["default"].getInstance();
    var args = {
        ecommerce: $1ef36d43a6d49b42$var$_defineProperty({}, type, data)
    };
    if (event) args.event = event;
    return instance.dataLayer(args);
};
var $1ef36d43a6d49b42$var$ProductImpressions = function ProductImpressions(data) {
    return $1ef36d43a6d49b42$var$push("impressions", data, "impressions");
};
var $1ef36d43a6d49b42$var$ProductClicks = function ProductClicks(data) {
    return $1ef36d43a6d49b42$var$push("impressions", data, "productClick");
};
var $1ef36d43a6d49b42$var$Checkout = function Checkout(data) {
    return $1ef36d43a6d49b42$var$push("checkout", data, "checkout");
};
var $1ef36d43a6d49b42$var$CheckoutOptions = function CheckoutOptions(data) {
    return $1ef36d43a6d49b42$var$push("checkout_option", data, "checkoutOption");
};
var $1ef36d43a6d49b42$var$Purchase = function Purchase(data) {
    return $1ef36d43a6d49b42$var$push("purchase", data, "purchase");
};
var $1ef36d43a6d49b42$var$Refund = function Refund(data) {
    return $1ef36d43a6d49b42$var$push("refund", data, "refund");
};
var $1ef36d43a6d49b42$var$_default = {
    ProductImpressions: $1ef36d43a6d49b42$var$ProductImpressions,
    ProductClicks: $1ef36d43a6d49b42$var$ProductClicks,
    Checkout: $1ef36d43a6d49b42$var$Checkout,
    CheckoutOptions: $1ef36d43a6d49b42$var$CheckoutOptions,
    Purchase: $1ef36d43a6d49b42$var$Purchase,
    Refund: $1ef36d43a6d49b42$var$Refund
};
module.exports["default"] = $1ef36d43a6d49b42$var$_default;

});

parcelRequire.register("gVgA5", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c51ed4da4bfe2c31$var$ReactIs, $c51ed4da4bfe2c31$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("bfKyA"))();

});
parcelRequire.register("bfKyA", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $fOADP = parcelRequire("fOADP");
function $831535a188574758$var$emptyFunction() {}
function $831535a188574758$var$emptyFunctionWithReset() {}
$831535a188574758$var$emptyFunctionWithReset.resetWarningCache = $831535a188574758$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $fOADP) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $831535a188574758$var$emptyFunctionWithReset,
        resetWarningCache: $831535a188574758$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("fOADP", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $b837f2c34f33927d$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $b837f2c34f33927d$var$ReactPropTypesSecret;

});



parcelRequire.register("64S8Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46cd1d9a26c74473$export$2e2bcd8739ae039; });
function $46cd1d9a26c74473$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRequire.register("h0s6D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6183d0bd56aa53d$export$2e2bcd8739ae039; });
function $c6183d0bd56aa53d$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $c6183d0bd56aa53d$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $c6183d0bd56aa53d$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $c6183d0bd56aa53d$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $c6183d0bd56aa53d$export$2e2bcd8739ae039 = $c6183d0bd56aa53d$export$4f5d2d50c9deca37;

});

parcelRequire.register("js0sS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e290fe1e0b2df2c7$export$2e2bcd8739ae039; });
function $e290fe1e0b2df2c7$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRequire.register("auxfn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a367ee74e971e9f$export$2e2bcd8739ae039; });

var $k8bs6 = parcelRequire("k8bs6");
const $7a367ee74e971e9f$var$globalStateClassesMapping = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    readOnly: "readOnly",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    required: "required",
    selected: "selected"
};
function $7a367ee74e971e9f$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $7a367ee74e971e9f$var$globalStateClassesMapping[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $k8bs6.default).generate(componentName)}-${slot}`;
}

});
parcelRequire.register("k8bs6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea7d7035bdcf1625$export$2e2bcd8739ae039; });
const $ea7d7035bdcf1625$var$defaultGenerator = (componentName)=>componentName;
const $ea7d7035bdcf1625$var$createClassNameGenerator = ()=>{
    let generate = $ea7d7035bdcf1625$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $ea7d7035bdcf1625$var$defaultGenerator;
        }
    };
};
const $ea7d7035bdcf1625$var$ClassNameGenerator = $ea7d7035bdcf1625$var$createClassNameGenerator();
var $ea7d7035bdcf1625$export$2e2bcd8739ae039 = $ea7d7035bdcf1625$var$ClassNameGenerator;

});


parcelRequire.register("265Xa", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $1870c2801e8b3e80$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $1870c2801e8b3e80$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $1870c2801e8b3e80$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $1870c2801e8b3e80$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $1870c2801e8b3e80$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $1870c2801e8b3e80$export$980e6a259d807490; });

var $j5tUA = parcelRequire("j5tUA");


var $dbzFE = parcelRequire("dbzFE");

var $gFm7x = parcelRequire("gFm7x");
const $1870c2801e8b3e80$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $1870c2801e8b3e80$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$1870c2801e8b3e80$export$68c286be0e7e55b7[key]}px)`
};
function $1870c2801e8b3e80$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $1870c2801e8b3e80$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $1870c2801e8b3e80$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $1870c2801e8b3e80$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $1870c2801e8b3e80$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $1870c2801e8b3e80$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $j5tUA.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $gFm7x.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $1870c2801e8b3e80$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $1870c2801e8b3e80$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $1870c2801e8b3e80$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $1870c2801e8b3e80$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $dbzFE.default)(prev, next), {});
    return $1870c2801e8b3e80$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $1870c2801e8b3e80$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $1870c2801e8b3e80$export$980e6a259d807490({ values: breakpointValues , breakpoints: themeBreakpoints , base: customBase  }) {
    const base = customBase || $1870c2801e8b3e80$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $1870c2801e8b3e80$export$2e2bcd8739ae039 = $1870c2801e8b3e80$var$breakpoints;

});
parcelRequire.register("dbzFE", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $9997f8ea7129a24f$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $9997f8ea7129a24f$export$2e2bcd8739ae039; });
function $9997f8ea7129a24f$export$53b83ca8eaab0383(item) {
    return item !== null && typeof item === "object" && item.constructor === Object;
}
function $9997f8ea7129a24f$var$deepClone(source) {
    if (!$9997f8ea7129a24f$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $9997f8ea7129a24f$var$deepClone(source[key]);
    });
    return output;
}
function $9997f8ea7129a24f$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($9997f8ea7129a24f$export$53b83ca8eaab0383(target) && $9997f8ea7129a24f$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($9997f8ea7129a24f$export$53b83ca8eaab0383(source[key]) && key in target && $9997f8ea7129a24f$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $9997f8ea7129a24f$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $9997f8ea7129a24f$export$53b83ca8eaab0383(source[key]) ? $9997f8ea7129a24f$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRequire.register("gFm7x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c221a25caa05e743$export$2e2bcd8739ae039; });

var $dbzFE = parcelRequire("dbzFE");
function $c221a25caa05e743$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $dbzFE.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $c221a25caa05e743$export$2e2bcd8739ae039 = $c221a25caa05e743$var$merge;

});


parcelRequire.register("hhXI3", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $c9625741afb10dc2$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $c9625741afb10dc2$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $c9625741afb10dc2$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("lvueV")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("lvueV")).w; });

var $lvueV = parcelRequire("lvueV");

var $fV3WI = parcelRequire("fV3WI");

var $lbaR7 = parcelRequire("lbaR7");

var $6THgH = parcelRequire("6THgH");

var $cNCY5 = parcelRequire("cNCY5");
parcelRequire("kMyao");
parcelRequire("b0Oht");
parcelRequire("KeUL6");

parcelRequire("OTT3m");
var $c9625741afb10dc2$var$pkg = {
    name: "@emotion/react",
    version: "11.11.0",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $c9625741afb10dc2$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $lvueV.h).call(props, "css")) // $FlowFixMe
    return $fV3WI.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $lvueV.E);
    createElementArgArray[1] = (0, $lvueV.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $fV3WI.createElement.apply(null, createElementArgArray);
};
var $c9625741afb10dc2$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $c9625741afb10dc2$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $lvueV.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $cNCY5.serializeStyles)([
        styles
    ], undefined, $fV3WI.useContext((0, $lvueV.T)));
    if (!(0, $lvueV.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $fV3WI.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $fV3WI.useRef();
    (0, $6THgH.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $6THgH.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $lbaR7.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $c9625741afb10dc2$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $cNCY5.serializeStyles)(args);
}
var $c9625741afb10dc2$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $c9625741afb10dc2$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $c9625741afb10dc2$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $c9625741afb10dc2$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $lbaR7.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $c9625741afb10dc2$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $6THgH.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $lbaR7.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $c9625741afb10dc2$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $lvueV.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $cNCY5.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $lbaR7.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $c9625741afb10dc2$var$merge(cache.registered, css, $c9625741afb10dc2$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $fV3WI.useContext((0, $lvueV.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $fV3WI.createElement($fV3WI.Fragment, null, /*#__PURE__*/ $fV3WI.createElement($c9625741afb10dc2$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $c9625741afb10dc2$var$isBrowser, $c9625741afb10dc2$var$isTestEnv, $c9625741afb10dc2$var$globalContext, $c9625741afb10dc2$var$globalKey;

});

parcelRequire.register("ZXS89", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ba423f74fde20e6$export$2e2bcd8739ae039; });

var $69iCy = parcelRequire("69iCy");
var $0ba423f74fde20e6$export$2e2bcd8739ae039 = (0, $69iCy.default);

});
parcelRequire.register("69iCy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47a2070a2315f25e$export$2e2bcd8739ae039; });

var $2RrcA = parcelRequire("2RrcA");
function $47a2070a2315f25e$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $2RrcA.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRequire.register("2RrcA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2155a1be051406c9$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $2155a1be051406c9$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRequire.register("aF4Kv", function(module, exports) {

$parcel$export(module.exports, "rootShouldForwardProp", function () { return $7c316ac7b4f987f7$export$effb20ecdbf4d6aa; });
$parcel$export(module.exports, "slotShouldForwardProp", function () { return $7c316ac7b4f987f7$export$f10c5a10d27438e5; });
$parcel$export(module.exports, "default", function () { return $7c316ac7b4f987f7$export$2e2bcd8739ae039; });

var $4auXB = parcelRequire("4auXB");

var $2G9ow = parcelRequire("2G9ow");

var $4owFt = parcelRequire("4owFt");
const $7c316ac7b4f987f7$export$effb20ecdbf4d6aa = (prop)=>(0, $4auXB.shouldForwardProp)(prop) && prop !== "classes";
const $7c316ac7b4f987f7$export$f10c5a10d27438e5 = (0, $4auXB.shouldForwardProp);
const $7c316ac7b4f987f7$var$styled = (0, $4auXB.default)({
    themeId: (0, $4owFt.default),
    defaultTheme: $2G9ow.default,
    rootShouldForwardProp: $7c316ac7b4f987f7$export$effb20ecdbf4d6aa
});
var $7c316ac7b4f987f7$export$2e2bcd8739ae039 = $7c316ac7b4f987f7$var$styled;

});
parcelRequire.register("4auXB", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", function () { return $30901cad9669fa10$export$3ba67b570e26eea0; });
$parcel$export(module.exports, "default", function () { return $30901cad9669fa10$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $azJRZ = parcelRequire("azJRZ");


var $34rWH = parcelRequire("34rWH");

var $biHIj = parcelRequire("biHIj");

var $feQFB = parcelRequire("feQFB");
const $30901cad9669fa10$var$_excluded = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $30901cad9669fa10$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $30901cad9669fa10$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
const $30901cad9669fa10$var$getStyleOverrides = (name, theme)=>{
    if (theme.components && theme.components[name] && theme.components[name].styleOverrides) return theme.components[name].styleOverrides;
    return null;
};
const $30901cad9669fa10$var$getVariantStyles = (name, theme)=>{
    let variants = [];
    if (theme && theme.components && theme.components[name] && theme.components[name].variants) variants = theme.components[name].variants;
    const variantsStyles = {};
    variants.forEach((definition)=>{
        const key = (0, $biHIj.default)(definition.props);
        variantsStyles[key] = definition.style;
    });
    return variantsStyles;
};
const $30901cad9669fa10$var$variantsResolver = (props, styles, theme, name)=>{
    var _theme$components, _theme$components$nam;
    const { ownerState: ownerState = {}  } = props;
    const variantsStyles = [];
    const themeVariants = theme == null ? void 0 : (_theme$components = theme.components) == null ? void 0 : (_theme$components$nam = _theme$components[name]) == null ? void 0 : _theme$components$nam.variants;
    if (themeVariants) themeVariants.forEach((themeVariant)=>{
        let isMatch = true;
        Object.keys(themeVariant.props).forEach((key)=>{
            if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) isMatch = false;
        });
        if (isMatch) variantsStyles.push(styles[(0, $biHIj.default)(themeVariant.props)]);
    });
    return variantsStyles;
};
function $30901cad9669fa10$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $30901cad9669fa10$export$35e57303dbd8a66 = (0, $34rWH.default)();
const $30901cad9669fa10$var$lowercaseFirstLetter = (string)=>{
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $30901cad9669fa10$var$resolveTheme({ defaultTheme: defaultTheme , theme: theme , themeId: themeId  }) {
    return $30901cad9669fa10$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $30901cad9669fa10$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId , defaultTheme: defaultTheme = $30901cad9669fa10$export$35e57303dbd8a66 , rootShouldForwardProp: rootShouldForwardProp = $30901cad9669fa10$export$3ba67b570e26eea0 , slotShouldForwardProp: slotShouldForwardProp = $30901cad9669fa10$export$3ba67b570e26eea0  } = input;
    const systemSx = (props)=>{
        return (0, $feQFB.default)((0, $j5tUA.default)({}, props, {
            theme: $30901cad9669fa10$var$resolveTheme((0, $j5tUA.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $azJRZ.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName , slot: componentSlot , skipVariantsResolver: inputSkipVariantsResolver , skipSx: inputSkipSx , overridesResolver: overridesResolver  } = inputOptions, options = (0, $64S8Y.default)(inputOptions, $30901cad9669fa10$var$_excluded);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : componentSlot && componentSlot !== "Root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $30901cad9669fa10$export$3ba67b570e26eea0;
        if (componentSlot === "Root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($30901cad9669fa10$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $azJRZ.default)(tag, (0, $j5tUA.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const muiStyledResolver = (styleArg, ...expressions)=>{
            const expressionsWithDefaultTheme = expressions ? expressions.map((stylesArg)=>{
                // On the server Emotion doesn't use React.forwardRef for creating components, so the created
                // component stays as a function. This condition makes sure that we do not interpolate functions
                // which are basically components used as a selectors.
                return typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg ? (props)=>{
                    return stylesArg((0, $j5tUA.default)({}, props, {
                        theme: $30901cad9669fa10$var$resolveTheme((0, $j5tUA.default)({}, props, {
                            defaultTheme: defaultTheme,
                            themeId: themeId
                        }))
                    }));
                } : stylesArg;
            }) : [];
            let transformedStyleArg = styleArg;
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $30901cad9669fa10$var$resolveTheme((0, $j5tUA.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const styleOverrides = $30901cad9669fa10$var$getStyleOverrides(componentName, theme);
                if (styleOverrides) {
                    const resolvedStyleOverrides = {};
                    Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                        resolvedStyleOverrides[slotKey] = typeof slotStyle === "function" ? slotStyle((0, $j5tUA.default)({}, props, {
                            theme: theme
                        })) : slotStyle;
                    });
                    return overridesResolver(props, resolvedStyleOverrides);
                }
                return null;
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $30901cad9669fa10$var$resolveTheme((0, $j5tUA.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                return $30901cad9669fa10$var$variantsResolver(props, $30901cad9669fa10$var$getVariantStyles(componentName, theme), theme, componentName);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            } else if (typeof styleArg === "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            styleArg.__emotion_real !== styleArg) // If the type is function, we need to define the default theme.
            transformedStyleArg = (props)=>styleArg((0, $j5tUA.default)({}, props, {
                    theme: $30901cad9669fa10$var$resolveTheme((0, $j5tUA.default)({}, props, {
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    }))
                }));
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRequire.register("azJRZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b30c10d8e6049b9$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $7b30c10d8e6049b9$export$e00380445f2b9e0c; });
/**
 * @mui/styled-engine v5.13.2
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 
var $75sxg = parcelRequire("75sxg");
parcelRequire("hhXI3");
var $lvueV = parcelRequire("lvueV");
var $hhXI3 = parcelRequire("hhXI3");

var $gb45a = parcelRequire("gb45a");

var $cC1Xp = parcelRequire("cC1Xp");
function $7b30c10d8e6049b9$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $75sxg.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $7b30c10d8e6049b9$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRequire.register("75sxg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $528f229aaf4c2e18$export$2e2bcd8739ae039; });

var $eRUKO = parcelRequire("eRUKO");
parcelRequire("b0Oht");
parcelRequire("fV3WI");
parcelRequire("l8ItF");

parcelRequire("lbaR7");
parcelRequire("cNCY5");
parcelRequire("6THgH");
var $528f229aaf4c2e18$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $528f229aaf4c2e18$export$2e2bcd8739ae039 = (0, $eRUKO.default).bind();
$528f229aaf4c2e18$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $528f229aaf4c2e18$export$2e2bcd8739ae039[tagName] = $528f229aaf4c2e18$export$2e2bcd8739ae039(tagName);
});

});
parcelRequire.register("eRUKO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad320a18e260e6bd$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");

var $l8ItF = parcelRequire("l8ItF");
parcelRequire("hhXI3");
var $lvueV = parcelRequire("lvueV");

var $lbaR7 = parcelRequire("lbaR7");

var $cNCY5 = parcelRequire("cNCY5");

var $6THgH = parcelRequire("6THgH");
var $ad320a18e260e6bd$var$testOmitPropsOnStringTag = (0, $l8ItF.default);
var $ad320a18e260e6bd$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $ad320a18e260e6bd$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $ad320a18e260e6bd$var$testOmitPropsOnStringTag : $ad320a18e260e6bd$var$testOmitPropsOnComponent;
};
var $ad320a18e260e6bd$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $ad320a18e260e6bd$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $ad320a18e260e6bd$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $lbaR7.registerStyles)(cache, serialized, isStringTag);
    (0, $6THgH.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $lbaR7.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $ad320a18e260e6bd$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $ad320a18e260e6bd$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $ad320a18e260e6bd$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $lvueV.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $fV3WI.useContext((0, $lvueV.T));
            }
            if (typeof props.className === "string") className = (0, $lbaR7.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $cNCY5.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $ad320a18e260e6bd$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $fV3WI.createElement($fV3WI.Fragment, null, /*#__PURE__*/ $fV3WI.createElement($ad320a18e260e6bd$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $fV3WI.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $j5tUA.default)({}, options, nextOptions, {
                shouldForwardProp: $ad320a18e260e6bd$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRequire.register("l8ItF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f63cd8a53c8e7fd7$export$2e2bcd8739ae039; });

var $6R5Uq = parcelRequire("6R5Uq");
var $f63cd8a53c8e7fd7$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $f63cd8a53c8e7fd7$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $6R5Uq.default)(function(prop) {
    return $f63cd8a53c8e7fd7$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRequire.register("gb45a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc70d71508688e45$export$2e2bcd8739ae039; });
parcelRequire("fV3WI");


var $lvueV = parcelRequire("lvueV");

var $kMyao = parcelRequire("kMyao");

var $3DnwL = parcelRequire("3DnwL");
let $bc70d71508688e45$var$cache;
if (typeof document === "object") $bc70d71508688e45$var$cache = (0, $kMyao.default)({
    key: "css",
    prepend: true
});
function $bc70d71508688e45$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst , children: children  } = props;
    return injectFirst && $bc70d71508688e45$var$cache ? /*#__PURE__*/ (0, $3DnwL.jsx)((0, $lvueV.C), {
        value: $bc70d71508688e45$var$cache,
        children: children
    }) : children;
}

});

parcelRequire.register("cC1Xp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92ea8d50eab466e6$export$2e2bcd8739ae039; });
parcelRequire("fV3WI");


var $hhXI3 = parcelRequire("hhXI3");

var $3DnwL = parcelRequire("3DnwL");
function $92ea8d50eab466e6$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $92ea8d50eab466e6$export$2e2bcd8739ae039(props) {
    const { styles: styles , defaultTheme: defaultTheme = {}  } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($92ea8d50eab466e6$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $3DnwL.jsx)((0, $hhXI3.Global), {
        styles: globalStyles
    });
}

});


parcelRequire.register("34rWH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23c76c460ef78ec8$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $dbzFE = parcelRequire("dbzFE");

var $j5sKL = parcelRequire("j5sKL");

var $fsKKI = parcelRequire("fsKKI");

var $ciZ6X = parcelRequire("ciZ6X");

var $feQFB = parcelRequire("feQFB");

var $luGzF = parcelRequire("luGzF");
const $23c76c460ef78ec8$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $23c76c460ef78ec8$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {} , palette: paletteInput = {} , spacing: spacingInput , shape: shapeInput = {}  } = options, other = (0, $64S8Y.default)(options, $23c76c460ef78ec8$var$_excluded);
    const breakpoints = (0, $j5sKL.default)(breakpointsInput);
    const spacing = (0, $ciZ6X.default)(spacingInput);
    let muiTheme = (0, $dbzFE.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $j5tUA.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $j5tUA.default)({}, (0, $fsKKI.default), shapeInput)
    }, other);
    muiTheme = args.reduce((acc, argument)=>(0, $dbzFE.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $j5tUA.default)({}, (0, $luGzF.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $feQFB.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $23c76c460ef78ec8$export$2e2bcd8739ae039 = $23c76c460ef78ec8$var$createTheme;

});
parcelRequire.register("j5sKL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de54c9c60a2b0c29$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");
const $de54c9c60a2b0c29$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $de54c9c60a2b0c29$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $de54c9c60a2b0c29$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $j5tUA.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $de54c9c60a2b0c29$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    } , unit: unit = "px" , step: step = 5  } = breakpoints, other = (0, $64S8Y.default)(breakpoints, $de54c9c60a2b0c29$var$_excluded);
    const sortedValues = $de54c9c60a2b0c29$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $j5tUA.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRequire.register("fsKKI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b41dbc9c1ef92741$export$2e2bcd8739ae039; });
const $b41dbc9c1ef92741$var$shape = {
    borderRadius: 4
};
var $b41dbc9c1ef92741$export$2e2bcd8739ae039 = $b41dbc9c1ef92741$var$shape;

});

parcelRequire.register("ciZ6X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f5691e3637af579$export$2e2bcd8739ae039; });

var $ioiN6 = parcelRequire("ioiN6");
function $8f5691e3637af579$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $ioiN6.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRequire.register("ioiN6", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $d6390b60293fc289$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $d6390b60293fc289$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $d6390b60293fc289$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $d6390b60293fc289$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $d6390b60293fc289$export$6f98e8eaf0be1996; });


var $265Xa = parcelRequire("265Xa");

var $hv9Gs = parcelRequire("hv9Gs");

var $gFm7x = parcelRequire("gFm7x");

var $3kyp2 = parcelRequire("3kyp2");
const $d6390b60293fc289$var$properties = {
    m: "margin",
    p: "padding"
};
const $d6390b60293fc289$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $d6390b60293fc289$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $d6390b60293fc289$var$getCssProperties = (0, $3kyp2.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($d6390b60293fc289$var$aliases[prop]) prop = $d6390b60293fc289$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $d6390b60293fc289$var$properties[a];
    const direction = $d6390b60293fc289$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $d6390b60293fc289$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $d6390b60293fc289$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $d6390b60293fc289$var$spacingKeys = [
    ...$d6390b60293fc289$export$aab52a0dde05ad8a,
    ...$d6390b60293fc289$export$f8397d44f03ab6ad
];
function $d6390b60293fc289$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $hv9Gs.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $d6390b60293fc289$export$1def6f833384e3d1(theme) {
    return $d6390b60293fc289$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $d6390b60293fc289$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $d6390b60293fc289$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $d6390b60293fc289$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $d6390b60293fc289$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $d6390b60293fc289$var$getCssProperties(prop);
    const styleFromPropValue = $d6390b60293fc289$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $265Xa.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $d6390b60293fc289$var$style(props, keys) {
    const transformer = $d6390b60293fc289$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$d6390b60293fc289$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $gFm7x.default), {});
}
function $d6390b60293fc289$export$7ede87f9b603dd3c(props) {
    return $d6390b60293fc289$var$style(props, $d6390b60293fc289$export$aab52a0dde05ad8a);
}
$d6390b60293fc289$export$7ede87f9b603dd3c.propTypes = {};
$d6390b60293fc289$export$7ede87f9b603dd3c.filterProps = $d6390b60293fc289$export$aab52a0dde05ad8a;
function $d6390b60293fc289$export$6f98e8eaf0be1996(props) {
    return $d6390b60293fc289$var$style(props, $d6390b60293fc289$export$f8397d44f03ab6ad);
}
$d6390b60293fc289$export$6f98e8eaf0be1996.propTypes = {};
$d6390b60293fc289$export$6f98e8eaf0be1996.filterProps = $d6390b60293fc289$export$f8397d44f03ab6ad;
function $d6390b60293fc289$var$spacing(props) {
    return $d6390b60293fc289$var$style(props, $d6390b60293fc289$var$spacingKeys);
}
$d6390b60293fc289$var$spacing.propTypes = {};
$d6390b60293fc289$var$spacing.filterProps = $d6390b60293fc289$var$spacingKeys;
var $d6390b60293fc289$export$2e2bcd8739ae039 = $d6390b60293fc289$var$spacing;

});
parcelRequire.register("hv9Gs", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $cbdcd7e830b87644$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $cbdcd7e830b87644$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $cbdcd7e830b87644$export$2e2bcd8739ae039; });

var $69iCy = parcelRequire("69iCy");


var $265Xa = parcelRequire("265Xa");
function $cbdcd7e830b87644$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $cbdcd7e830b87644$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $cbdcd7e830b87644$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $cbdcd7e830b87644$var$style(options) {
    const { prop: prop , cssProperty: cssProperty = options.prop , themeKey: themeKey , transform: transform  } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $cbdcd7e830b87644$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $cbdcd7e830b87644$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $cbdcd7e830b87644$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $69iCy.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $265Xa.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $cbdcd7e830b87644$export$2e2bcd8739ae039 = $cbdcd7e830b87644$var$style;

});

parcelRequire.register("3kyp2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26cded0a61063a05$export$2e2bcd8739ae039; });
function $26cded0a61063a05$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRequire.register("feQFB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b18104fdd9503389$export$2e2bcd8739ae039; });

var $69iCy = parcelRequire("69iCy");

var $gFm7x = parcelRequire("gFm7x");

var $hv9Gs = parcelRequire("hv9Gs");

var $265Xa = parcelRequire("265Xa");

var $luGzF = parcelRequire("luGzF");
function $b18104fdd9503389$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $b18104fdd9503389$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $b18104fdd9503389$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop , themeKey: themeKey , transform: transform , style: style  } = options;
        if (val == null) return null;
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $hv9Gs.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $hv9Gs.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $hv9Gs.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $69iCy.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $265Xa.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx , theme: theme = {}  } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $luGzF.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $265Xa.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $b18104fdd9503389$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $gFm7x.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $265Xa.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($b18104fdd9503389$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $gFm7x.default)(css, breakpointsValues);
                        }
                    } else css = (0, $gFm7x.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $265Xa.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $b18104fdd9503389$var$styleFunctionSx = $b18104fdd9503389$export$7d53d8bf2911e013();
$b18104fdd9503389$var$styleFunctionSx.filterProps = [
    "sx"
];
var $b18104fdd9503389$export$2e2bcd8739ae039 = $b18104fdd9503389$var$styleFunctionSx;

});
parcelRequire.register("luGzF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa5d6ca7bbc64a1d$export$2e2bcd8739ae039; });

var $ioiN6 = parcelRequire("ioiN6");

var $1Kjk9 = parcelRequire("1Kjk9");

var $1fStL = parcelRequire("1fStL");

var $2gPqm = parcelRequire("2gPqm");

var $ecQCj = parcelRequire("ecQCj");
const $fa5d6ca7bbc64a1d$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $1Kjk9.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $1Kjk9.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $1Kjk9.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $1Kjk9.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $1Kjk9.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $1Kjk9.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $2gPqm.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $2gPqm.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $2gPqm.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $ioiN6.padding)
    },
    pt: {
        style: (0, $ioiN6.padding)
    },
    pr: {
        style: (0, $ioiN6.padding)
    },
    pb: {
        style: (0, $ioiN6.padding)
    },
    pl: {
        style: (0, $ioiN6.padding)
    },
    px: {
        style: (0, $ioiN6.padding)
    },
    py: {
        style: (0, $ioiN6.padding)
    },
    padding: {
        style: (0, $ioiN6.padding)
    },
    paddingTop: {
        style: (0, $ioiN6.padding)
    },
    paddingRight: {
        style: (0, $ioiN6.padding)
    },
    paddingBottom: {
        style: (0, $ioiN6.padding)
    },
    paddingLeft: {
        style: (0, $ioiN6.padding)
    },
    paddingX: {
        style: (0, $ioiN6.padding)
    },
    paddingY: {
        style: (0, $ioiN6.padding)
    },
    paddingInline: {
        style: (0, $ioiN6.padding)
    },
    paddingInlineStart: {
        style: (0, $ioiN6.padding)
    },
    paddingInlineEnd: {
        style: (0, $ioiN6.padding)
    },
    paddingBlock: {
        style: (0, $ioiN6.padding)
    },
    paddingBlockStart: {
        style: (0, $ioiN6.padding)
    },
    paddingBlockEnd: {
        style: (0, $ioiN6.padding)
    },
    m: {
        style: (0, $ioiN6.margin)
    },
    mt: {
        style: (0, $ioiN6.margin)
    },
    mr: {
        style: (0, $ioiN6.margin)
    },
    mb: {
        style: (0, $ioiN6.margin)
    },
    ml: {
        style: (0, $ioiN6.margin)
    },
    mx: {
        style: (0, $ioiN6.margin)
    },
    my: {
        style: (0, $ioiN6.margin)
    },
    margin: {
        style: (0, $ioiN6.margin)
    },
    marginTop: {
        style: (0, $ioiN6.margin)
    },
    marginRight: {
        style: (0, $ioiN6.margin)
    },
    marginBottom: {
        style: (0, $ioiN6.margin)
    },
    marginLeft: {
        style: (0, $ioiN6.margin)
    },
    marginX: {
        style: (0, $ioiN6.margin)
    },
    marginY: {
        style: (0, $ioiN6.margin)
    },
    marginInline: {
        style: (0, $ioiN6.margin)
    },
    marginInlineStart: {
        style: (0, $ioiN6.margin)
    },
    marginInlineEnd: {
        style: (0, $ioiN6.margin)
    },
    marginBlock: {
        style: (0, $ioiN6.margin)
    },
    marginBlockStart: {
        style: (0, $ioiN6.margin)
    },
    marginBlockEnd: {
        style: (0, $ioiN6.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $1fStL.gap)
    },
    rowGap: {
        style: (0, $1fStL.rowGap)
    },
    columnGap: {
        style: (0, $1fStL.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $ecQCj.sizingTransform)
    },
    maxWidth: {
        style: (0, $ecQCj.maxWidth)
    },
    minWidth: {
        transform: (0, $ecQCj.sizingTransform)
    },
    height: {
        transform: (0, $ecQCj.sizingTransform)
    },
    maxHeight: {
        transform: (0, $ecQCj.sizingTransform)
    },
    minHeight: {
        transform: (0, $ecQCj.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $fa5d6ca7bbc64a1d$export$2e2bcd8739ae039 = $fa5d6ca7bbc64a1d$var$defaultSxConfig;

});
parcelRequire.register("1Kjk9", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $145913a63fc2f41b$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $145913a63fc2f41b$export$7a57f79000377ca2; });


var $hv9Gs = parcelRequire("hv9Gs");

var $53qwI = parcelRequire("53qwI");

var $ioiN6 = parcelRequire("ioiN6");

var $265Xa = parcelRequire("265Xa");
function $145913a63fc2f41b$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
const $145913a63fc2f41b$export$1edee58a52776cd9 = (0, $hv9Gs.default)({
    prop: "border",
    themeKey: "borders",
    transform: $145913a63fc2f41b$export$34e2febe53ae29cc
});
const $145913a63fc2f41b$export$f9a7b6bd24892946 = (0, $hv9Gs.default)({
    prop: "borderTop",
    themeKey: "borders",
    transform: $145913a63fc2f41b$export$34e2febe53ae29cc
});
const $145913a63fc2f41b$export$5abca33e6be905d2 = (0, $hv9Gs.default)({
    prop: "borderRight",
    themeKey: "borders",
    transform: $145913a63fc2f41b$export$34e2febe53ae29cc
});
const $145913a63fc2f41b$export$e2ce9f12a980a822 = (0, $hv9Gs.default)({
    prop: "borderBottom",
    themeKey: "borders",
    transform: $145913a63fc2f41b$export$34e2febe53ae29cc
});
const $145913a63fc2f41b$export$47658cca1a909427 = (0, $hv9Gs.default)({
    prop: "borderLeft",
    themeKey: "borders",
    transform: $145913a63fc2f41b$export$34e2febe53ae29cc
});
const $145913a63fc2f41b$export$e7fb0694ba2404fc = (0, $hv9Gs.default)({
    prop: "borderColor",
    themeKey: "palette"
});
const $145913a63fc2f41b$export$126a92c968acdb85 = (0, $hv9Gs.default)({
    prop: "borderTopColor",
    themeKey: "palette"
});
const $145913a63fc2f41b$export$85cc51cb8fbb8c0e = (0, $hv9Gs.default)({
    prop: "borderRightColor",
    themeKey: "palette"
});
const $145913a63fc2f41b$export$340b0327727f6d1a = (0, $hv9Gs.default)({
    prop: "borderBottomColor",
    themeKey: "palette"
});
const $145913a63fc2f41b$export$60beef91a985b4bf = (0, $hv9Gs.default)({
    prop: "borderLeftColor",
    themeKey: "palette"
});
const $145913a63fc2f41b$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $ioiN6.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $ioiN6.getValue)(transformer, propValue)
            });
        return (0, $265Xa.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$145913a63fc2f41b$export$7a57f79000377ca2.propTypes = {};
$145913a63fc2f41b$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $145913a63fc2f41b$var$borders = (0, $53qwI.default)($145913a63fc2f41b$export$1edee58a52776cd9, $145913a63fc2f41b$export$f9a7b6bd24892946, $145913a63fc2f41b$export$5abca33e6be905d2, $145913a63fc2f41b$export$e2ce9f12a980a822, $145913a63fc2f41b$export$47658cca1a909427, $145913a63fc2f41b$export$e7fb0694ba2404fc, $145913a63fc2f41b$export$126a92c968acdb85, $145913a63fc2f41b$export$85cc51cb8fbb8c0e, $145913a63fc2f41b$export$340b0327727f6d1a, $145913a63fc2f41b$export$60beef91a985b4bf, $145913a63fc2f41b$export$7a57f79000377ca2);
var $145913a63fc2f41b$export$2e2bcd8739ae039 = $145913a63fc2f41b$var$borders;

});
parcelRequire.register("53qwI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ae1cf306731225c$export$2e2bcd8739ae039; });

var $gFm7x = parcelRequire("gFm7x");
function $3ae1cf306731225c$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $gFm7x.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $3ae1cf306731225c$export$2e2bcd8739ae039 = $3ae1cf306731225c$var$compose;

});


parcelRequire.register("1fStL", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $0ea173978a9cada3$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $0ea173978a9cada3$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $0ea173978a9cada3$export$8a833ffa5f5dbeda; });

var $hv9Gs = parcelRequire("hv9Gs");

var $53qwI = parcelRequire("53qwI");

var $ioiN6 = parcelRequire("ioiN6");

var $265Xa = parcelRequire("265Xa");

const $0ea173978a9cada3$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $ioiN6.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $ioiN6.getValue)(transformer, propValue)
            });
        return (0, $265Xa.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$0ea173978a9cada3$export$5df9adcb0db95e1e.propTypes = {};
$0ea173978a9cada3$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $0ea173978a9cada3$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $ioiN6.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $ioiN6.getValue)(transformer, propValue)
            });
        return (0, $265Xa.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$0ea173978a9cada3$export$ec60d70ff941a580.propTypes = {};
$0ea173978a9cada3$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $0ea173978a9cada3$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $ioiN6.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $ioiN6.getValue)(transformer, propValue)
            });
        return (0, $265Xa.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$0ea173978a9cada3$export$8a833ffa5f5dbeda.propTypes = {};
$0ea173978a9cada3$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $0ea173978a9cada3$export$baf44164ca3a34e8 = (0, $hv9Gs.default)({
    prop: "gridColumn"
});
const $0ea173978a9cada3$export$8f7213a1cd01e832 = (0, $hv9Gs.default)({
    prop: "gridRow"
});
const $0ea173978a9cada3$export$b0e0abbc49ba668 = (0, $hv9Gs.default)({
    prop: "gridAutoFlow"
});
const $0ea173978a9cada3$export$bcd8b929d4b4142 = (0, $hv9Gs.default)({
    prop: "gridAutoColumns"
});
const $0ea173978a9cada3$export$e5039a674e14c828 = (0, $hv9Gs.default)({
    prop: "gridAutoRows"
});
const $0ea173978a9cada3$export$42bd9088661ffb03 = (0, $hv9Gs.default)({
    prop: "gridTemplateColumns"
});
const $0ea173978a9cada3$export$920682ae05b999bc = (0, $hv9Gs.default)({
    prop: "gridTemplateRows"
});
const $0ea173978a9cada3$export$1b88fbdd482fd33a = (0, $hv9Gs.default)({
    prop: "gridTemplateAreas"
});
const $0ea173978a9cada3$export$bdb486e40d52d26f = (0, $hv9Gs.default)({
    prop: "gridArea"
});
const $0ea173978a9cada3$var$grid = (0, $53qwI.default)($0ea173978a9cada3$export$5df9adcb0db95e1e, $0ea173978a9cada3$export$ec60d70ff941a580, $0ea173978a9cada3$export$8a833ffa5f5dbeda, $0ea173978a9cada3$export$baf44164ca3a34e8, $0ea173978a9cada3$export$8f7213a1cd01e832, $0ea173978a9cada3$export$b0e0abbc49ba668, $0ea173978a9cada3$export$bcd8b929d4b4142, $0ea173978a9cada3$export$e5039a674e14c828, $0ea173978a9cada3$export$42bd9088661ffb03, $0ea173978a9cada3$export$920682ae05b999bc, $0ea173978a9cada3$export$1b88fbdd482fd33a, $0ea173978a9cada3$export$bdb486e40d52d26f);
var $0ea173978a9cada3$export$2e2bcd8739ae039 = $0ea173978a9cada3$var$grid;

});

parcelRequire.register("2gPqm", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $1a74f730807bf1bd$export$dbaffd4420ea0ac6; });

var $hv9Gs = parcelRequire("hv9Gs");

var $53qwI = parcelRequire("53qwI");
function $1a74f730807bf1bd$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $1a74f730807bf1bd$export$35e9368ef982300f = (0, $hv9Gs.default)({
    prop: "color",
    themeKey: "palette",
    transform: $1a74f730807bf1bd$export$dbaffd4420ea0ac6
});
const $1a74f730807bf1bd$export$2506f56c10355b33 = (0, $hv9Gs.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $1a74f730807bf1bd$export$dbaffd4420ea0ac6
});
const $1a74f730807bf1bd$export$8c5a050822fd698c = (0, $hv9Gs.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $1a74f730807bf1bd$export$dbaffd4420ea0ac6
});
const $1a74f730807bf1bd$var$palette = (0, $53qwI.default)($1a74f730807bf1bd$export$35e9368ef982300f, $1a74f730807bf1bd$export$2506f56c10355b33, $1a74f730807bf1bd$export$8c5a050822fd698c);
var $1a74f730807bf1bd$export$2e2bcd8739ae039 = $1a74f730807bf1bd$var$palette;

});

parcelRequire.register("ecQCj", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $a57b004d6f6547dd$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $a57b004d6f6547dd$export$488fda99655ff65a; });

var $hv9Gs = parcelRequire("hv9Gs");

var $53qwI = parcelRequire("53qwI");

var $265Xa = parcelRequire("265Xa");
function $a57b004d6f6547dd$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $a57b004d6f6547dd$export$7e3df82ee760448c = (0, $hv9Gs.default)({
    prop: "width",
    transform: $a57b004d6f6547dd$export$8afece71750ec241
});
const $a57b004d6f6547dd$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme$breakpoi, _props$theme$breakpoi2;
            const breakpoint = ((_props$theme = props.theme) == null ? void 0 : (_props$theme$breakpoi = _props$theme.breakpoints) == null ? void 0 : (_props$theme$breakpoi2 = _props$theme$breakpoi.values) == null ? void 0 : _props$theme$breakpoi2[propValue]) || (0, $265Xa.values)[propValue];
            return {
                maxWidth: breakpoint || $a57b004d6f6547dd$export$8afece71750ec241(propValue)
            };
        };
        return (0, $265Xa.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$a57b004d6f6547dd$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $a57b004d6f6547dd$export$ee148fbbe8357dd2 = (0, $hv9Gs.default)({
    prop: "minWidth",
    transform: $a57b004d6f6547dd$export$8afece71750ec241
});
const $a57b004d6f6547dd$export$ac607276a8fe9f0a = (0, $hv9Gs.default)({
    prop: "height",
    transform: $a57b004d6f6547dd$export$8afece71750ec241
});
const $a57b004d6f6547dd$export$dc0d8bd0b94f8570 = (0, $hv9Gs.default)({
    prop: "maxHeight",
    transform: $a57b004d6f6547dd$export$8afece71750ec241
});
const $a57b004d6f6547dd$export$a43cf604e12f3b17 = (0, $hv9Gs.default)({
    prop: "minHeight",
    transform: $a57b004d6f6547dd$export$8afece71750ec241
});
const $a57b004d6f6547dd$export$ffed9f14fb65e276 = (0, $hv9Gs.default)({
    prop: "size",
    cssProperty: "width",
    transform: $a57b004d6f6547dd$export$8afece71750ec241
});
const $a57b004d6f6547dd$export$905076ed6620e671 = (0, $hv9Gs.default)({
    prop: "size",
    cssProperty: "height",
    transform: $a57b004d6f6547dd$export$8afece71750ec241
});
const $a57b004d6f6547dd$export$6ccc93f785106a58 = (0, $hv9Gs.default)({
    prop: "boxSizing"
});
const $a57b004d6f6547dd$var$sizing = (0, $53qwI.default)($a57b004d6f6547dd$export$7e3df82ee760448c, $a57b004d6f6547dd$export$488fda99655ff65a, $a57b004d6f6547dd$export$ee148fbbe8357dd2, $a57b004d6f6547dd$export$ac607276a8fe9f0a, $a57b004d6f6547dd$export$dc0d8bd0b94f8570, $a57b004d6f6547dd$export$a43cf604e12f3b17, $a57b004d6f6547dd$export$6ccc93f785106a58);
var $a57b004d6f6547dd$export$2e2bcd8739ae039 = $a57b004d6f6547dd$var$sizing;

});




parcelRequire.register("biHIj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83a348cc01ff1fd9$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $69iCy = parcelRequire("69iCy");
const $83a348cc01ff1fd9$var$_excluded = [
    "variant"
];
function $83a348cc01ff1fd9$var$isEmpty(string) {
    return string.length === 0;
}
function $83a348cc01ff1fd9$export$2e2bcd8739ae039(props) {
    const { variant: variant  } = props, other = (0, $64S8Y.default)(props, $83a348cc01ff1fd9$var$_excluded);
    let classKey = variant || "";
    Object.keys(other).sort().forEach((key)=>{
        if (key === "color") classKey += $83a348cc01ff1fd9$var$isEmpty(classKey) ? props[key] : (0, $69iCy.default)(props[key]);
        else classKey += `${$83a348cc01ff1fd9$var$isEmpty(classKey) ? key : (0, $69iCy.default)(key)}${(0, $69iCy.default)(props[key].toString())}`;
    });
    return classKey;
}

});


parcelRequire.register("2G9ow", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f36ca917f66aa9a$export$2e2bcd8739ae039; });

var $aRufz = parcelRequire("aRufz");
const $1f36ca917f66aa9a$var$defaultTheme = (0, $aRufz.default)();
var $1f36ca917f66aa9a$export$2e2bcd8739ae039 = $1f36ca917f66aa9a$var$defaultTheme;

});
parcelRequire.register("aRufz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e8651a7d51750e7$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $dbzFE = parcelRequire("dbzFE");
var $2RrcA = parcelRequire("2RrcA");

var $34rWH = parcelRequire("34rWH");
var $luGzF = parcelRequire("luGzF");
var $feQFB = parcelRequire("feQFB");


var $8adSk = parcelRequire("8adSk");

var $3Hi1e = parcelRequire("3Hi1e");

var $h3VS2 = parcelRequire("h3VS2");

var $7x676 = parcelRequire("7x676");

var $jvsL9 = parcelRequire("jvsL9");

var $kgwYi = parcelRequire("kgwYi");
const $7e8651a7d51750e7$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $7e8651a7d51750e7$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {} , palette: paletteInput = {} , transitions: transitionsInput = {} , typography: typographyInput = {}  } = options, other = (0, $64S8Y.default)(options, $7e8651a7d51750e7$var$_excluded);
    if (options.vars) throw new Error((0, $2RrcA.default)(18));
    const palette = (0, $3Hi1e.default)(paletteInput);
    const systemTheme = (0, $34rWH.default)(options);
    let muiTheme = (0, $dbzFE.default)(systemTheme, {
        mixins: (0, $8adSk.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $7x676.default).slice(),
        typography: (0, $h3VS2.default)(palette, typographyInput),
        transitions: (0, $jvsL9.default)(transitionsInput),
        zIndex: (0, $j5tUA.default)({}, (0, $kgwYi.default))
    });
    muiTheme = (0, $dbzFE.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $dbzFE.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $j5tUA.default)({}, (0, $luGzF.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $feQFB.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $7e8651a7d51750e7$var$warnedOnce = false;
function $7e8651a7d51750e7$export$c469355549431d9b(...args) {
    return $7e8651a7d51750e7$var$createTheme(...args);
}
var $7e8651a7d51750e7$export$2e2bcd8739ae039 = $7e8651a7d51750e7$var$createTheme;

});
parcelRequire.register("8adSk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f1a053d71085e73$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");
function $5f1a053d71085e73$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $j5tUA.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRequire.register("3Hi1e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b135d71bf6d691f$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $dbzFE = parcelRequire("dbzFE");
var $2RrcA = parcelRequire("2RrcA");

var $74s0b = parcelRequire("74s0b");

var $c3K1G = parcelRequire("c3K1G");

var $kx7HT = parcelRequire("kx7HT");

var $5sVdS = parcelRequire("5sVdS");

var $9app1 = parcelRequire("9app1");

var $bC7a7 = parcelRequire("bC7a7");

var $6353f = parcelRequire("6353f");

var $h6Rfd = parcelRequire("h6Rfd");

var $7uQlQ = parcelRequire("7uQlQ");
const $2b135d71bf6d691f$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $2b135d71bf6d691f$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $c3K1G.default).white,
        default: (0, $c3K1G.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $2b135d71bf6d691f$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $c3K1G.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $c3K1G.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $2b135d71bf6d691f$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $74s0b.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $74s0b.darken)(intent.main, tonalOffsetDark);
    }
}
function $2b135d71bf6d691f$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $6353f.default)[200],
        light: (0, $6353f.default)[50],
        dark: (0, $6353f.default)[400]
    };
    return {
        main: (0, $6353f.default)[700],
        light: (0, $6353f.default)[400],
        dark: (0, $6353f.default)[800]
    };
}
function $2b135d71bf6d691f$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $5sVdS.default)[200],
        light: (0, $5sVdS.default)[50],
        dark: (0, $5sVdS.default)[400]
    };
    return {
        main: (0, $5sVdS.default)[500],
        light: (0, $5sVdS.default)[300],
        dark: (0, $5sVdS.default)[700]
    };
}
function $2b135d71bf6d691f$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $9app1.default)[500],
        light: (0, $9app1.default)[300],
        dark: (0, $9app1.default)[700]
    };
    return {
        main: (0, $9app1.default)[700],
        light: (0, $9app1.default)[400],
        dark: (0, $9app1.default)[800]
    };
}
function $2b135d71bf6d691f$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $h6Rfd.default)[400],
        light: (0, $h6Rfd.default)[300],
        dark: (0, $h6Rfd.default)[700]
    };
    return {
        main: (0, $h6Rfd.default)[700],
        light: (0, $h6Rfd.default)[500],
        dark: (0, $h6Rfd.default)[900]
    };
}
function $2b135d71bf6d691f$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $7uQlQ.default)[400],
        light: (0, $7uQlQ.default)[300],
        dark: (0, $7uQlQ.default)[700]
    };
    return {
        main: (0, $7uQlQ.default)[800],
        light: (0, $7uQlQ.default)[500],
        dark: (0, $7uQlQ.default)[900]
    };
}
function $2b135d71bf6d691f$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $bC7a7.default)[400],
        light: (0, $bC7a7.default)[300],
        dark: (0, $bC7a7.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $bC7a7.default)[500],
        dark: (0, $bC7a7.default)[900]
    };
}
function $2b135d71bf6d691f$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light" , contrastThreshold: contrastThreshold = 3 , tonalOffset: tonalOffset = 0.2  } = palette, other = (0, $64S8Y.default)(palette, $2b135d71bf6d691f$var$_excluded);
    const primary = palette.primary || $2b135d71bf6d691f$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $2b135d71bf6d691f$var$getDefaultSecondary(mode);
    const error = palette.error || $2b135d71bf6d691f$var$getDefaultError(mode);
    const info = palette.info || $2b135d71bf6d691f$var$getDefaultInfo(mode);
    const success = palette.success || $2b135d71bf6d691f$var$getDefaultSuccess(mode);
    const warning = palette.warning || $2b135d71bf6d691f$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $74s0b.getContrastRatio)(background, $2b135d71bf6d691f$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $2b135d71bf6d691f$export$55ce6f3a06c59543.text.primary : $2b135d71bf6d691f$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color , name: name , mainShade: mainShade = 500 , lightShade: lightShade = 300 , darkShade: darkShade = 700  })=>{
        color = (0, $j5tUA.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $2RrcA.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $2RrcA.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $2b135d71bf6d691f$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $2b135d71bf6d691f$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $2b135d71bf6d691f$export$55ce6f3a06c59543,
        light: $2b135d71bf6d691f$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $dbzFE.default)((0, $j5tUA.default)({
        // A collection of common colors.
        common: (0, $j5tUA.default)({}, (0, $c3K1G.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $kx7HT.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRequire.register("74s0b", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $525ea0bcec83f3ca$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $525ea0bcec83f3ca$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "darken", function () { return $525ea0bcec83f3ca$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $525ea0bcec83f3ca$export$c0816ed86df316af; });

var $2RrcA = parcelRequire("2RrcA");
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $525ea0bcec83f3ca$var$clamp(value, min = 0, max = 1) {
    return Math.min(Math.max(min, value), max);
}
function $525ea0bcec83f3ca$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $525ea0bcec83f3ca$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $525ea0bcec83f3ca$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $525ea0bcec83f3ca$export$677b39864803984e($525ea0bcec83f3ca$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $2RrcA.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $2RrcA.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $525ea0bcec83f3ca$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $525ea0bcec83f3ca$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $525ea0bcec83f3ca$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $525ea0bcec83f3ca$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $525ea0bcec83f3ca$export$211a73f2b8c10ce4(color) {
    const { type: type , colorSpace: colorSpace  } = color;
    let { values: values  } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $525ea0bcec83f3ca$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values  } = $525ea0bcec83f3ca$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$525ea0bcec83f3ca$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $525ea0bcec83f3ca$export$29fb7152bd3f781a(color) {
    color = $525ea0bcec83f3ca$export$677b39864803984e(color);
    const { values: values  } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $525ea0bcec83f3ca$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $525ea0bcec83f3ca$export$c852d90bf7403b62(color) {
    color = $525ea0bcec83f3ca$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $525ea0bcec83f3ca$export$677b39864803984e($525ea0bcec83f3ca$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $525ea0bcec83f3ca$export$d061e26956a60b0a(foreground, background) {
    const lumA = $525ea0bcec83f3ca$export$c852d90bf7403b62(foreground);
    const lumB = $525ea0bcec83f3ca$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $525ea0bcec83f3ca$export$58f0f39f63f3cf42(color, value) {
    color = $525ea0bcec83f3ca$export$677b39864803984e(color);
    value = $525ea0bcec83f3ca$var$clamp(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $525ea0bcec83f3ca$export$211a73f2b8c10ce4(color);
}
function $525ea0bcec83f3ca$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $525ea0bcec83f3ca$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $525ea0bcec83f3ca$export$4b073707ff63303(color, coefficient) {
    color = $525ea0bcec83f3ca$export$677b39864803984e(color);
    coefficient = $525ea0bcec83f3ca$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $525ea0bcec83f3ca$export$211a73f2b8c10ce4(color);
}
function $525ea0bcec83f3ca$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $525ea0bcec83f3ca$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $525ea0bcec83f3ca$export$c0816ed86df316af(color, coefficient) {
    color = $525ea0bcec83f3ca$export$677b39864803984e(color);
    coefficient = $525ea0bcec83f3ca$var$clamp(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $525ea0bcec83f3ca$export$211a73f2b8c10ce4(color);
}
function $525ea0bcec83f3ca$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $525ea0bcec83f3ca$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $525ea0bcec83f3ca$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $525ea0bcec83f3ca$export$c852d90bf7403b62(color) > 0.5 ? $525ea0bcec83f3ca$export$4b073707ff63303(color, coefficient) : $525ea0bcec83f3ca$export$c0816ed86df316af(color, coefficient);
}
function $525ea0bcec83f3ca$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $525ea0bcec83f3ca$export$11bb74ba10c85505(color, coefficient);
    } catch (error) {
        return color;
    }
}

});

parcelRequire.register("c3K1G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c7977aca32d4faf$export$2e2bcd8739ae039; });
const $8c7977aca32d4faf$var$common = {
    black: "#000",
    white: "#fff"
};
var $8c7977aca32d4faf$export$2e2bcd8739ae039 = $8c7977aca32d4faf$var$common;

});

parcelRequire.register("kx7HT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef2cde2abe19034a$export$2e2bcd8739ae039; });
const $ef2cde2abe19034a$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $ef2cde2abe19034a$export$2e2bcd8739ae039 = $ef2cde2abe19034a$var$grey;

});

parcelRequire.register("5sVdS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fabf48df25b087b$export$2e2bcd8739ae039; });
const $3fabf48df25b087b$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $3fabf48df25b087b$export$2e2bcd8739ae039 = $3fabf48df25b087b$var$purple;

});

parcelRequire.register("9app1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ac8c0a345b9003f$export$2e2bcd8739ae039; });
const $6ac8c0a345b9003f$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $6ac8c0a345b9003f$export$2e2bcd8739ae039 = $6ac8c0a345b9003f$var$red;

});

parcelRequire.register("bC7a7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8748cc9111165750$export$2e2bcd8739ae039; });
const $8748cc9111165750$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $8748cc9111165750$export$2e2bcd8739ae039 = $8748cc9111165750$var$orange;

});

parcelRequire.register("6353f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4676f0f6b2bce5fa$export$2e2bcd8739ae039; });
const $4676f0f6b2bce5fa$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $4676f0f6b2bce5fa$export$2e2bcd8739ae039 = $4676f0f6b2bce5fa$var$blue;

});

parcelRequire.register("h6Rfd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c74c4c6ac5e58354$export$2e2bcd8739ae039; });
const $c74c4c6ac5e58354$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $c74c4c6ac5e58354$export$2e2bcd8739ae039 = $c74c4c6ac5e58354$var$lightBlue;

});

parcelRequire.register("7uQlQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5753f1a253ea11bc$export$2e2bcd8739ae039; });
const $5753f1a253ea11bc$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $5753f1a253ea11bc$export$2e2bcd8739ae039 = $5753f1a253ea11bc$var$green;

});


parcelRequire.register("h3VS2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6bf9b5c7263c59a$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $dbzFE = parcelRequire("dbzFE");
const $c6bf9b5c7263c59a$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $c6bf9b5c7263c59a$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $c6bf9b5c7263c59a$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $c6bf9b5c7263c59a$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $c6bf9b5c7263c59a$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $c6bf9b5c7263c59a$var$defaultFontFamily , fontSize: // The default font size of the Material Specification.
    fontSize = 14 , fontWeightLight: // px
    fontWeightLight = 300 , fontWeightRegular: fontWeightRegular = 400 , fontWeightMedium: fontWeightMedium = 500 , fontWeightBold: fontWeightBold = 700 , htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16 , allVariants: // Apply the CSS properties to all the variants.
    allVariants , pxToRem: pxToRem2  } = _ref, other = (0, $64S8Y.default)(_ref, $c6bf9b5c7263c59a$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $j5tUA.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $c6bf9b5c7263c59a$var$defaultFontFamily ? {
            letterSpacing: `${$c6bf9b5c7263c59a$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $c6bf9b5c7263c59a$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $c6bf9b5c7263c59a$var$caseAllCaps),
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $dbzFE.default)((0, $j5tUA.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRequire.register("7x676", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57c05b80df611455$export$2e2bcd8739ae039; });
const $57c05b80df611455$var$shadowKeyUmbraOpacity = 0.2;
const $57c05b80df611455$var$shadowKeyPenumbraOpacity = 0.14;
const $57c05b80df611455$var$shadowAmbientShadowOpacity = 0.12;
function $57c05b80df611455$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$57c05b80df611455$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$57c05b80df611455$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$57c05b80df611455$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $57c05b80df611455$var$shadows = [
    "none",
    $57c05b80df611455$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $57c05b80df611455$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $57c05b80df611455$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $57c05b80df611455$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $57c05b80df611455$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $57c05b80df611455$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $57c05b80df611455$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $57c05b80df611455$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $57c05b80df611455$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $57c05b80df611455$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $57c05b80df611455$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $57c05b80df611455$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $57c05b80df611455$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $57c05b80df611455$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $57c05b80df611455$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $57c05b80df611455$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $57c05b80df611455$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $57c05b80df611455$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $57c05b80df611455$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $57c05b80df611455$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $57c05b80df611455$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $57c05b80df611455$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $57c05b80df611455$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $57c05b80df611455$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $57c05b80df611455$export$2e2bcd8739ae039 = $57c05b80df611455$var$shadows;

});

parcelRequire.register("jvsL9", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $e337389dff13c1e1$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $e337389dff13c1e1$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");
const $e337389dff13c1e1$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $e337389dff13c1e1$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $e337389dff13c1e1$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $e337389dff13c1e1$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $e337389dff13c1e1$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $e337389dff13c1e1$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $j5tUA.default)({}, $e337389dff13c1e1$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $j5tUA.default)({}, $e337389dff13c1e1$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard , easing: easingOption = mergedEasing.easeInOut , delay: delay = 0  } = options, other = (0, $64S8Y.default)(options, $e337389dff13c1e1$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $e337389dff13c1e1$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $e337389dff13c1e1$var$formatMs(delay)}`).join(",");
    };
    return (0, $j5tUA.default)({
        getAutoHeightDuration: $e337389dff13c1e1$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRequire.register("kgwYi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec0ee0b522c3726b$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $ec0ee0b522c3726b$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $ec0ee0b522c3726b$export$2e2bcd8739ae039 = $ec0ee0b522c3726b$var$zIndex;

});



parcelRequire.register("4owFt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3332be7d28939713$export$2e2bcd8739ae039; });
var $3332be7d28939713$export$2e2bcd8739ae039 = "$$material";

});


parcelRequire.register("05gnM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00fd2cfe211052a6$export$2e2bcd8739ae039; });

var $3IDET = parcelRequire("3IDET");

var $2G9ow = parcelRequire("2G9ow");

var $4owFt = parcelRequire("4owFt");
function $00fd2cfe211052a6$export$2e2bcd8739ae039({ props: props , name: name  }) {
    return (0, $3IDET.default)({
        props: props,
        name: name,
        defaultTheme: $2G9ow.default,
        themeId: (0, $4owFt.default)
    });
}

});
parcelRequire.register("3IDET", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b543e841a04f717$export$2e2bcd8739ae039; });

var $hCfWo = parcelRequire("hCfWo");

var $dZEln = parcelRequire("dZEln");
function $2b543e841a04f717$export$2e2bcd8739ae039({ props: props , name: name , defaultTheme: defaultTheme , themeId: themeId  }) {
    let theme = (0, $dZEln.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $hCfWo.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRequire.register("hCfWo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd3259cebcb74f7b$export$2e2bcd8739ae039; });

var $1Bp3D = parcelRequire("1Bp3D");
function $cd3259cebcb74f7b$export$2e2bcd8739ae039(params) {
    const { theme: theme , name: name , props: props  } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $1Bp3D.default)(theme.components[name].defaultProps, props);
}

});
parcelRequire.register("1Bp3D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12acaf1440037cfe$export$2e2bcd8739ae039; });
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param {object} defaultProps
 * @param {object} props
 * @returns {object} resolved props
 */ function $12acaf1440037cfe$export$2e2bcd8739ae039(defaultProps, props) {
    const output = {
        ...props
    };
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $12acaf1440037cfe$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRequire.register("dZEln", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a300444a803fb341$export$2e2bcd8739ae039; });

var $34rWH = parcelRequire("34rWH");

var $3UagE = parcelRequire("3UagE");
const $a300444a803fb341$export$35e57303dbd8a66 = (0, $34rWH.default)();
function $a300444a803fb341$var$useTheme(defaultTheme = $a300444a803fb341$export$35e57303dbd8a66) {
    return (0, $3UagE.default)(defaultTheme);
}
var $a300444a803fb341$export$2e2bcd8739ae039 = $a300444a803fb341$var$useTheme;

});
parcelRequire.register("3UagE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d7e90fdf0d1cbcd$export$2e2bcd8739ae039; });

var $fV3WI = parcelRequire("fV3WI");
parcelRequire("hhXI3");
var $lvueV = parcelRequire("lvueV");
function $2d7e90fdf0d1cbcd$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $2d7e90fdf0d1cbcd$var$useTheme(defaultTheme = null) {
    const contextTheme = $fV3WI.useContext((0, $lvueV.T));
    return !contextTheme || $2d7e90fdf0d1cbcd$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $2d7e90fdf0d1cbcd$export$2e2bcd8739ae039 = $2d7e90fdf0d1cbcd$var$useTheme;

});




parcelRequire.register("d4TrX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $iEw4v.default;
    }
});

var $iEw4v = parcelRequire("iEw4v");

});
parcelRequire.register("iEw4v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d944d72a27304c3c$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");

var $QRUfq = parcelRequire("QRUfq");

var $3DnwL = parcelRequire("3DnwL");
function $d944d72a27304c3c$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $3DnwL.jsx)((0, $QRUfq.default), (0, $j5tUA.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $QRUfq.default).muiName;
    return /*#__PURE__*/ $fV3WI.memo(/*#__PURE__*/ $fV3WI.forwardRef(Component));
}

});
parcelRequire.register("QRUfq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09eeac18987360ce$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $js0sS = parcelRequire("js0sS");

var $ZXS89 = parcelRequire("ZXS89");

var $05gnM = parcelRequire("05gnM");

var $aF4Kv = parcelRequire("aF4Kv");

var $2EPr4 = parcelRequire("2EPr4");

var $3DnwL = parcelRequire("3DnwL");
const $09eeac18987360ce$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $09eeac18987360ce$var$useUtilityClasses = (ownerState)=>{
    const { color: color , fontSize: fontSize , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $ZXS89.default)(color)}`,
            `fontSize${(0, $ZXS89.default)(fontSize)}`
        ]
    };
    return (0, $js0sS.default)(slots, (0, $2EPr4.getSvgIconUtilityClass), classes);
};
const $09eeac18987360ce$var$SvgIconRoot = (0, $aF4Kv.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $ZXS89.default)(ownerState.color)}`],
            styles[`fontSize${(0, $ZXS89.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$transitions2$d, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette$ownerState$c2, _palette2, _palette2$action, _palette3, _palette3$action;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        fill: "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null ? void 0 : (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null ? void 0 : (_theme$transitions2$d = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2$d.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null ? void 0 : (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null ? void 0 : (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null ? void 0 : (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null ? void 0 : (_palette$ownerState$c2 = _palette[ownerState.color]) == null ? void 0 : _palette$ownerState$c2.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null ? void 0 : (_palette2$action = _palette2.action) == null ? void 0 : _palette2$action.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null ? void 0 : (_palette3$action = _palette3.action) == null ? void 0 : _palette3$action.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $09eeac18987360ce$var$SvgIcon = /*#__PURE__*/ $fV3WI.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children , className: className , color: color = "inherit" , component: component = "svg" , fontSize: fontSize = "medium" , htmlColor: htmlColor , inheritViewBox: inheritViewBox = false , titleAccess: titleAccess , viewBox: viewBox = "0 0 24 24"  } = props, other = (0, $64S8Y.default)(props, $09eeac18987360ce$var$_excluded);
    const ownerState = (0, $j5tUA.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $09eeac18987360ce$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3DnwL.jsxs)($09eeac18987360ce$var$SvgIconRoot, (0, $j5tUA.default)({
        as: component,
        className: (0, $h0s6D.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, {
        ownerState: ownerState,
        children: [
            children,
            titleAccess ? /*#__PURE__*/ (0, $3DnwL.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$09eeac18987360ce$var$SvgIcon.muiName = "SvgIcon";
var $09eeac18987360ce$export$2e2bcd8739ae039 = $09eeac18987360ce$var$SvgIcon;

});
parcelRequire.register("2EPr4", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $1ef7373a8ef6bc05$export$c7c50641356bdfa5; });

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $1ef7373a8ef6bc05$export$c7c50641356bdfa5(slot) {
    return (0, $auxfn.default)("MuiSvgIcon", slot);
}
const $1ef7373a8ef6bc05$var$svgIconClasses = (0, $dxVxC.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $1ef7373a8ef6bc05$export$2e2bcd8739ae039 = $1ef7373a8ef6bc05$var$svgIconClasses;

});
parcelRequire.register("dxVxC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9dcafdea7d40f591$export$2e2bcd8739ae039; });

var $auxfn = parcelRequire("auxfn");
function $9dcafdea7d40f591$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $auxfn.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});





parcelRequire.register("4uBZf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34576e2ad3235f98$export$2e2bcd8739ae039; });
parcelRequire("fV3WI");

var $dZEln = parcelRequire("dZEln");

var $2G9ow = parcelRequire("2G9ow");

var $4owFt = parcelRequire("4owFt");
function $34576e2ad3235f98$export$2e2bcd8739ae039() {
    const theme = (0, $dZEln.default)((0, $2G9ow.default));
    return theme[0, $4owFt.default] || theme;
}

});

parcelRequire.register("czyq6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92737401d7ed8ad0$export$2e2bcd8739ae039; });

var $eFiOq = parcelRequire("eFiOq");
var $92737401d7ed8ad0$export$2e2bcd8739ae039 = (0, $eFiOq.default);

});
parcelRequire.register("eFiOq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aad37cc52e86b302$export$2e2bcd8739ae039; });

var $fV3WI = parcelRequire("fV3WI");

var $zuYi8 = parcelRequire("zuYi8");
function $aad37cc52e86b302$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $fV3WI.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $zuYi8.default)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});
parcelRequire.register("zuYi8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06ab4b484ec11ee4$export$2e2bcd8739ae039; });
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $06ab4b484ec11ee4$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}

});



parcelRequire.register("7wjDG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $579ac17940ee20ba$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");


var $js0sS = parcelRequire("js0sS");

var $hhXI3 = parcelRequire("hhXI3");

var $ZXS89 = parcelRequire("ZXS89");

var $05gnM = parcelRequire("05gnM");

var $aF4Kv = parcelRequire("aF4Kv");

var $jXUYu = parcelRequire("jXUYu");

var $3DnwL = parcelRequire("3DnwL");
const $579ac17940ee20ba$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $579ac17940ee20ba$var$_ = (t)=>t, $579ac17940ee20ba$var$_t, $579ac17940ee20ba$var$_t2, $579ac17940ee20ba$var$_t3, $579ac17940ee20ba$var$_t4;
const $579ac17940ee20ba$var$SIZE = 44;
const $579ac17940ee20ba$var$circularRotateKeyframe = (0, $hhXI3.keyframes)($579ac17940ee20ba$var$_t || ($579ac17940ee20ba$var$_t = $579ac17940ee20ba$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $579ac17940ee20ba$var$circularDashKeyframe = (0, $hhXI3.keyframes)($579ac17940ee20ba$var$_t2 || ($579ac17940ee20ba$var$_t2 = $579ac17940ee20ba$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $579ac17940ee20ba$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , variant: variant , color: color , disableShrink: disableShrink  } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `color${(0, $ZXS89.default)(color)}`
        ],
        svg: [
            "svg"
        ],
        circle: [
            "circle",
            `circle${(0, $ZXS89.default)(variant)}`,
            disableShrink && "circleDisableShrink"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $jXUYu.getCircularProgressUtilityClass), classes);
};
const $579ac17940ee20ba$var$CircularProgressRoot = (0, $aF4Kv.default)("span", {
    name: "MuiCircularProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $ZXS89.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState , theme: theme  })=>(0, $j5tUA.default)({
        display: "inline-block"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("transform")
    }, ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState  })=>ownerState.variant === "indeterminate" && (0, $hhXI3.css)($579ac17940ee20ba$var$_t3 || ($579ac17940ee20ba$var$_t3 = $579ac17940ee20ba$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $579ac17940ee20ba$var$circularRotateKeyframe));
const $579ac17940ee20ba$var$CircularProgressSVG = (0, $aF4Kv.default)("svg", {
    name: "MuiCircularProgress",
    slot: "Svg",
    overridesResolver: (props, styles)=>styles.svg
})({
    display: "block" // Keeps the progress centered
});
const $579ac17940ee20ba$var$CircularProgressCircle = (0, $aF4Kv.default)("circle", {
    name: "MuiCircularProgress",
    slot: "Circle",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.circle,
            styles[`circle${(0, $ZXS89.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState , theme: theme  })=>(0, $j5tUA.default)({
        stroke: "currentColor"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("stroke-dashoffset")
    }, ownerState.variant === "indeterminate" && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: "80px, 200px",
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState  })=>ownerState.variant === "indeterminate" && !ownerState.disableShrink && (0, $hhXI3.css)($579ac17940ee20ba$var$_t4 || ($579ac17940ee20ba$var$_t4 = $579ac17940ee20ba$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $579ac17940ee20ba$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $579ac17940ee20ba$var$CircularProgress = /*#__PURE__*/ $fV3WI.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiCircularProgress"
    });
    const { className: className , color: color = "primary" , disableShrink: disableShrink = false , size: size = 40 , style: style , thickness: thickness = 3.6 , value: value = 0 , variant: variant = "indeterminate"  } = props, other = (0, $64S8Y.default)(props, $579ac17940ee20ba$var$_excluded);
    const ownerState = (0, $j5tUA.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $579ac17940ee20ba$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === "determinate") {
        const circumference = 2 * Math.PI * (($579ac17940ee20ba$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ (0, $3DnwL.jsx)($579ac17940ee20ba$var$CircularProgressRoot, (0, $j5tUA.default)({
        className: (0, $h0s6D.default)(classes.root, className),
        style: (0, $j5tUA.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $3DnwL.jsx)($579ac17940ee20ba$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$579ac17940ee20ba$var$SIZE / 2} ${$579ac17940ee20ba$var$SIZE / 2} ${$579ac17940ee20ba$var$SIZE} ${$579ac17940ee20ba$var$SIZE}`,
            children: /*#__PURE__*/ (0, $3DnwL.jsx)($579ac17940ee20ba$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $579ac17940ee20ba$var$SIZE,
                cy: $579ac17940ee20ba$var$SIZE,
                r: ($579ac17940ee20ba$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $579ac17940ee20ba$export$2e2bcd8739ae039 = $579ac17940ee20ba$var$CircularProgress;

});
parcelRequire.register("jXUYu", function(module, exports) {

$parcel$export(module.exports, "getCircularProgressUtilityClass", function () { return $e88fb8fcb5e3b506$export$29cad1383b3f235d; });

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $e88fb8fcb5e3b506$export$29cad1383b3f235d(slot) {
    return (0, $auxfn.default)("MuiCircularProgress", slot);
}
const $e88fb8fcb5e3b506$var$circularProgressClasses = (0, $dxVxC.default)("MuiCircularProgress", [
    "root",
    "determinate",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "svg",
    "circle",
    "circleDeterminate",
    "circleIndeterminate",
    "circleDisableShrink"
]);
var $e88fb8fcb5e3b506$export$2e2bcd8739ae039 = $e88fb8fcb5e3b506$var$circularProgressClasses;

});


parcelRequire.register("ezkpc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9b429a9c6381e33$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $dbzFE = parcelRequire("dbzFE");

var $luGzF = parcelRequire("luGzF");
const $a9b429a9c6381e33$var$_excluded = [
    "sx"
];
const $a9b429a9c6381e33$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null ? void 0 : (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $luGzF.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $a9b429a9c6381e33$export$2e2bcd8739ae039(props) {
    const { sx: inSx  } = props, other = (0, $64S8Y.default)(props, $a9b429a9c6381e33$var$_excluded);
    const { systemProps: systemProps , otherProps: otherProps  } = $a9b429a9c6381e33$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $dbzFE.isPlainObject)(result)) return systemProps;
        return (0, $j5tUA.default)({}, systemProps, result);
    };
    else finalSx = (0, $j5tUA.default)({}, systemProps, inSx);
    return (0, $j5tUA.default)({}, otherProps, {
        sx: finalSx
    });
}

});

parcelRequire.register("hScOl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0316ad5d4fed239$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $ezkpc = parcelRequire("ezkpc");

var $js0sS = parcelRequire("js0sS");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");

var $ZXS89 = parcelRequire("ZXS89");

var $3slQz = parcelRequire("3slQz");

var $3DnwL = parcelRequire("3DnwL");
const $d0316ad5d4fed239$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $d0316ad5d4fed239$var$useUtilityClasses = (ownerState)=>{
    const { align: align , gutterBottom: gutterBottom , noWrap: noWrap , paragraph: paragraph , variant: variant , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $ZXS89.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $3slQz.getTypographyUtilityClass), classes);
};
const $d0316ad5d4fed239$export$140e2f5526d3cad8 = (0, $aF4Kv.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $ZXS89.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({
        margin: 0
    }, ownerState.variant && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $d0316ad5d4fed239$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $d0316ad5d4fed239$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $d0316ad5d4fed239$var$transformDeprecatedColors = (color)=>{
    return $d0316ad5d4fed239$var$colorTransformations[color] || color;
};
const $d0316ad5d4fed239$var$Typography = /*#__PURE__*/ $fV3WI.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $05gnM.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $d0316ad5d4fed239$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $ezkpc.default)((0, $j5tUA.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit" , className: className , component: component , gutterBottom: gutterBottom = false , noWrap: noWrap = false , paragraph: paragraph = false , variant: variant = "body1" , variantMapping: variantMapping = $d0316ad5d4fed239$var$defaultVariantMapping  } = props, other = (0, $64S8Y.default)(props, $d0316ad5d4fed239$var$_excluded);
    const ownerState = (0, $j5tUA.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $d0316ad5d4fed239$var$defaultVariantMapping[variant]) || "span";
    const classes = $d0316ad5d4fed239$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3DnwL.jsx)($d0316ad5d4fed239$export$140e2f5526d3cad8, (0, $j5tUA.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $h0s6D.default)(classes.root, className)
    }, other));
});
var $d0316ad5d4fed239$export$2e2bcd8739ae039 = $d0316ad5d4fed239$var$Typography;

});
parcelRequire.register("3slQz", function(module, exports) {

$parcel$export(module.exports, "getTypographyUtilityClass", function () { return $2844eef73f45c94c$export$24c1f8f60cbac79e; });

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $2844eef73f45c94c$export$24c1f8f60cbac79e(slot) {
    return (0, $auxfn.default)("MuiTypography", slot);
}
const $2844eef73f45c94c$var$typographyClasses = (0, $dxVxC.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $2844eef73f45c94c$export$2e2bcd8739ae039 = $2844eef73f45c94c$var$typographyClasses;

});


parcelRequire.register("7KC5x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a4a5fd099aa2f4b$export$2e2bcd8739ae039; });

var $bE74s = parcelRequire("bE74s");


var $k8bs6 = parcelRequire("k8bs6");

var $aRufz = parcelRequire("aRufz");

var $4owFt = parcelRequire("4owFt");
const $5a4a5fd099aa2f4b$var$defaultTheme = (0, $aRufz.default)();
const $5a4a5fd099aa2f4b$var$Box = (0, $bE74s.default)({
    themeId: (0, $4owFt.default),
    defaultTheme: $5a4a5fd099aa2f4b$var$defaultTheme,
    defaultClassName: "MuiBox-root",
    generateClassName: (0, $k8bs6.default).generate
});
var $5a4a5fd099aa2f4b$export$2e2bcd8739ae039 = $5a4a5fd099aa2f4b$var$Box;

});
parcelRequire.register("bE74s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87a8ea3e7cce4bbc$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $fV3WI = parcelRequire("fV3WI");

var $h0s6D = parcelRequire("h0s6D");

var $azJRZ = parcelRequire("azJRZ");

var $feQFB = parcelRequire("feQFB");
var $ezkpc = parcelRequire("ezkpc");

var $dZEln = parcelRequire("dZEln");

var $3DnwL = parcelRequire("3DnwL");
const $87a8ea3e7cce4bbc$var$_excluded = [
    "className",
    "component"
];
function $87a8ea3e7cce4bbc$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId , defaultTheme: defaultTheme , defaultClassName: defaultClassName = "MuiBox-root" , generateClassName: generateClassName  } = options;
    const BoxRoot = (0, $azJRZ.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $feQFB.default));
    const Box = /*#__PURE__*/ $fV3WI.forwardRef(function Box(inProps, ref) {
        const theme = (0, $dZEln.default)(defaultTheme);
        const _extendSxProp = (0, $ezkpc.default)(inProps), { className: className , component: component = "div"  } = _extendSxProp, other = (0, $64S8Y.default)(_extendSxProp, $87a8ea3e7cce4bbc$var$_excluded);
        return /*#__PURE__*/ (0, $3DnwL.jsx)(BoxRoot, (0, $j5tUA.default)({
            as: component,
            ref: ref,
            className: (0, $h0s6D.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}

});


parcelRequire.register("5UdlT", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $44cc8a2f3319f574$export$a7c73072b1a182ae; }, function (v) { return $44cc8a2f3319f574$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $44cc8a2f3319f574$export$9f27bc3417b4524d; }, function (v) { return $44cc8a2f3319f574$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $44cc8a2f3319f574$export$db77ccec0bb4ccac; }, function (v) { return $44cc8a2f3319f574$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $44cc8a2f3319f574$export$8392c0c9d3dcbd35; }, function (v) { return $44cc8a2f3319f574$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $44cc8a2f3319f574$export$ffb0004e005737fa; }, function (v) { return $44cc8a2f3319f574$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $44cc8a2f3319f574$export$b624eff549462981; }, function (v) { return $44cc8a2f3319f574$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $44cc8a2f3319f574$export$7897aa7841a5380c; }, function (v) { return $44cc8a2f3319f574$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $44cc8a2f3319f574$export$602eac185826482c; }, function (v) { return $44cc8a2f3319f574$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $44cc8a2f3319f574$export$e2c29f18771995cb; }, function (v) { return $44cc8a2f3319f574$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $44cc8a2f3319f574$export$5f8d39834fd61797; }, function (v) { return $44cc8a2f3319f574$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $44cc8a2f3319f574$export$74bf444e3cd11ea5; }, function (v) { return $44cc8a2f3319f574$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $44cc8a2f3319f574$export$998bcd577473dd93; }, function (v) { return $44cc8a2f3319f574$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $44cc8a2f3319f574$export$92387174baf9b227; }, function (v) { return $44cc8a2f3319f574$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $44cc8a2f3319f574$export$ec112efeb987d9c6; }, function (v) { return $44cc8a2f3319f574$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $44cc8a2f3319f574$export$b706b080d889d2c9; }, function (v) { return $44cc8a2f3319f574$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $44cc8a2f3319f574$export$5be5a87408f70ddc; }, function (v) { return $44cc8a2f3319f574$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $44cc8a2f3319f574$export$45a5e7f76e0caa8d; }, function (v) { return $44cc8a2f3319f574$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $44cc8a2f3319f574$export$455c2e768291efa6; }, function (v) { return $44cc8a2f3319f574$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $44cc8a2f3319f574$export$9522e17588c12572; }, function (v) { return $44cc8a2f3319f574$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $44cc8a2f3319f574$export$2110ac352bb060b9; }, function (v) { return $44cc8a2f3319f574$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $44cc8a2f3319f574$export$56885ab8b9c456ab; }, function (v) { return $44cc8a2f3319f574$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $44cc8a2f3319f574$export$d927fcb6adf8f9de; }, function (v) { return $44cc8a2f3319f574$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $44cc8a2f3319f574$export$b82d16f27459e05a; }, function (v) { return $44cc8a2f3319f574$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $44cc8a2f3319f574$export$522c17b4f5e123e8; }, function (v) { return $44cc8a2f3319f574$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $44cc8a2f3319f574$export$1aabd8a0274ecfd6; }, function (v) { return $44cc8a2f3319f574$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $44cc8a2f3319f574$export$3d6c20d97e46b957; }, function (v) { return $44cc8a2f3319f574$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $44cc8a2f3319f574$export$9b621391a187a31a; }, function (v) { return $44cc8a2f3319f574$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $44cc8a2f3319f574$export$f5bbd400c2f4426f; }, function (v) { return $44cc8a2f3319f574$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $44cc8a2f3319f574$export$a7c73072b1a182ae;
var $44cc8a2f3319f574$export$9f27bc3417b4524d;
var $44cc8a2f3319f574$export$db77ccec0bb4ccac;
var $44cc8a2f3319f574$export$8392c0c9d3dcbd35;
var $44cc8a2f3319f574$export$ffb0004e005737fa;
var $44cc8a2f3319f574$export$b624eff549462981;
var $44cc8a2f3319f574$export$7897aa7841a5380c;
var $44cc8a2f3319f574$export$602eac185826482c;
var $44cc8a2f3319f574$export$e2c29f18771995cb;
var $44cc8a2f3319f574$export$5f8d39834fd61797;
var $44cc8a2f3319f574$export$74bf444e3cd11ea5;
var $44cc8a2f3319f574$export$998bcd577473dd93;
var $44cc8a2f3319f574$export$92387174baf9b227;
var $44cc8a2f3319f574$export$ec112efeb987d9c6;
var $44cc8a2f3319f574$export$b706b080d889d2c9;
var $44cc8a2f3319f574$export$5be5a87408f70ddc;
var $44cc8a2f3319f574$export$45a5e7f76e0caa8d;
var $44cc8a2f3319f574$export$455c2e768291efa6;
var $44cc8a2f3319f574$export$9522e17588c12572;
var $44cc8a2f3319f574$export$2110ac352bb060b9;
var $44cc8a2f3319f574$export$56885ab8b9c456ab;
var $44cc8a2f3319f574$export$d927fcb6adf8f9de;
var $44cc8a2f3319f574$export$b82d16f27459e05a;
var $44cc8a2f3319f574$export$522c17b4f5e123e8;
var $44cc8a2f3319f574$export$1aabd8a0274ecfd6;
var $44cc8a2f3319f574$export$3d6c20d97e46b957;
var $44cc8a2f3319f574$export$9b621391a187a31a;
var $44cc8a2f3319f574$export$f5bbd400c2f4426f;
"use strict";
var $44cc8a2f3319f574$var$b = Symbol.for("react.element"), $44cc8a2f3319f574$var$c = Symbol.for("react.portal"), $44cc8a2f3319f574$var$d = Symbol.for("react.fragment"), $44cc8a2f3319f574$var$e = Symbol.for("react.strict_mode"), $44cc8a2f3319f574$var$f = Symbol.for("react.profiler"), $44cc8a2f3319f574$var$g = Symbol.for("react.provider"), $44cc8a2f3319f574$var$h = Symbol.for("react.context"), $44cc8a2f3319f574$var$k = Symbol.for("react.server_context"), $44cc8a2f3319f574$var$l = Symbol.for("react.forward_ref"), $44cc8a2f3319f574$var$m = Symbol.for("react.suspense"), $44cc8a2f3319f574$var$n = Symbol.for("react.suspense_list"), $44cc8a2f3319f574$var$p = Symbol.for("react.memo"), $44cc8a2f3319f574$var$q = Symbol.for("react.lazy"), $44cc8a2f3319f574$var$t = Symbol.for("react.offscreen"), $44cc8a2f3319f574$var$u;
$44cc8a2f3319f574$var$u = Symbol.for("react.module.reference");
function $44cc8a2f3319f574$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $44cc8a2f3319f574$var$b:
                switch(a = a.type, a){
                    case $44cc8a2f3319f574$var$d:
                    case $44cc8a2f3319f574$var$f:
                    case $44cc8a2f3319f574$var$e:
                    case $44cc8a2f3319f574$var$m:
                    case $44cc8a2f3319f574$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $44cc8a2f3319f574$var$k:
                            case $44cc8a2f3319f574$var$h:
                            case $44cc8a2f3319f574$var$l:
                            case $44cc8a2f3319f574$var$q:
                            case $44cc8a2f3319f574$var$p:
                            case $44cc8a2f3319f574$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $44cc8a2f3319f574$var$c:
                return r;
        }
    }
}
$44cc8a2f3319f574$export$a7c73072b1a182ae = $44cc8a2f3319f574$var$h;
$44cc8a2f3319f574$export$9f27bc3417b4524d = $44cc8a2f3319f574$var$g;
$44cc8a2f3319f574$export$db77ccec0bb4ccac = $44cc8a2f3319f574$var$b;
$44cc8a2f3319f574$export$8392c0c9d3dcbd35 = $44cc8a2f3319f574$var$l;
$44cc8a2f3319f574$export$ffb0004e005737fa = $44cc8a2f3319f574$var$d;
$44cc8a2f3319f574$export$b624eff549462981 = $44cc8a2f3319f574$var$q;
$44cc8a2f3319f574$export$7897aa7841a5380c = $44cc8a2f3319f574$var$p;
$44cc8a2f3319f574$export$602eac185826482c = $44cc8a2f3319f574$var$c;
$44cc8a2f3319f574$export$e2c29f18771995cb = $44cc8a2f3319f574$var$f;
$44cc8a2f3319f574$export$5f8d39834fd61797 = $44cc8a2f3319f574$var$e;
$44cc8a2f3319f574$export$74bf444e3cd11ea5 = $44cc8a2f3319f574$var$m;
$44cc8a2f3319f574$export$998bcd577473dd93 = $44cc8a2f3319f574$var$n;
$44cc8a2f3319f574$export$92387174baf9b227 = function() {
    return !1;
};
$44cc8a2f3319f574$export$ec112efeb987d9c6 = function() {
    return !1;
};
$44cc8a2f3319f574$export$b706b080d889d2c9 = function(a) {
    return $44cc8a2f3319f574$var$v(a) === $44cc8a2f3319f574$var$h;
};
$44cc8a2f3319f574$export$5be5a87408f70ddc = function(a) {
    return $44cc8a2f3319f574$var$v(a) === $44cc8a2f3319f574$var$g;
};
$44cc8a2f3319f574$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $44cc8a2f3319f574$var$b;
};
$44cc8a2f3319f574$export$455c2e768291efa6 = function(a) {
    return $44cc8a2f3319f574$var$v(a) === $44cc8a2f3319f574$var$l;
};
$44cc8a2f3319f574$export$9522e17588c12572 = function(a) {
    return $44cc8a2f3319f574$var$v(a) === $44cc8a2f3319f574$var$d;
};
$44cc8a2f3319f574$export$2110ac352bb060b9 = function(a) {
    return $44cc8a2f3319f574$var$v(a) === $44cc8a2f3319f574$var$q;
};
$44cc8a2f3319f574$export$56885ab8b9c456ab = function(a) {
    return $44cc8a2f3319f574$var$v(a) === $44cc8a2f3319f574$var$p;
};
$44cc8a2f3319f574$export$d927fcb6adf8f9de = function(a) {
    return $44cc8a2f3319f574$var$v(a) === $44cc8a2f3319f574$var$c;
};
$44cc8a2f3319f574$export$b82d16f27459e05a = function(a) {
    return $44cc8a2f3319f574$var$v(a) === $44cc8a2f3319f574$var$f;
};
$44cc8a2f3319f574$export$522c17b4f5e123e8 = function(a) {
    return $44cc8a2f3319f574$var$v(a) === $44cc8a2f3319f574$var$e;
};
$44cc8a2f3319f574$export$1aabd8a0274ecfd6 = function(a) {
    return $44cc8a2f3319f574$var$v(a) === $44cc8a2f3319f574$var$m;
};
$44cc8a2f3319f574$export$3d6c20d97e46b957 = function(a) {
    return $44cc8a2f3319f574$var$v(a) === $44cc8a2f3319f574$var$n;
};
$44cc8a2f3319f574$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $44cc8a2f3319f574$var$d || a === $44cc8a2f3319f574$var$f || a === $44cc8a2f3319f574$var$e || a === $44cc8a2f3319f574$var$m || a === $44cc8a2f3319f574$var$n || a === $44cc8a2f3319f574$var$t || "object" === typeof a && null !== a && (a.$$typeof === $44cc8a2f3319f574$var$q || a.$$typeof === $44cc8a2f3319f574$var$p || a.$$typeof === $44cc8a2f3319f574$var$g || a.$$typeof === $44cc8a2f3319f574$var$h || a.$$typeof === $44cc8a2f3319f574$var$l || a.$$typeof === $44cc8a2f3319f574$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$44cc8a2f3319f574$export$f5bbd400c2f4426f = $44cc8a2f3319f574$var$v;

});

parcelRequire.register("83gz5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5dcb74037e0008aa$export$2e2bcd8739ae039; });
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $5dcb74037e0008aa$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});

parcelRequire.register("58XPl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bec1b81cdab5f43$export$2e2bcd8739ae039; });

var $fV3WI = parcelRequire("fV3WI");
let $3bec1b81cdab5f43$var$globalId = 0;
function $3bec1b81cdab5f43$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $fV3WI.useState(idOverride);
    const id = idOverride || defaultId;
    $fV3WI.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $3bec1b81cdab5f43$var$globalId += 1;
            setDefaultId(`mui-${$3bec1b81cdab5f43$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $3bec1b81cdab5f43$var$maybeReactUseId = $fV3WI["useId".toString()];
function $3bec1b81cdab5f43$export$2e2bcd8739ae039(idOverride) {
    if ($3bec1b81cdab5f43$var$maybeReactUseId !== undefined) {
        const reactId = $3bec1b81cdab5f43$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $3bec1b81cdab5f43$var$useGlobalId(idOverride);
}

});

parcelRequire.register("76UN0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52d52521ed968f55$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $dbzFE = parcelRequire("dbzFE");

var $himqN = parcelRequire("himqN");

var $7a74J = parcelRequire("7a74J");

var $24RkK = parcelRequire("24RkK");

var $1yAKJ = parcelRequire("1yAKJ");

var $ljYhS = parcelRequire("ljYhS");

var $9Th25 = parcelRequire("9Th25");

var $9TEpO = parcelRequire("9TEpO");

var $76Hzh = parcelRequire("76Hzh");

var $05gnM = parcelRequire("05gnM");

var $czyq6 = parcelRequire("czyq6");

var $aF4Kv = parcelRequire("aF4Kv");

var $3DnwL = parcelRequire("3DnwL");
const $52d52521ed968f55$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
];
const $52d52521ed968f55$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes  } = ownerState;
    return classes;
};
const $52d52521ed968f55$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $aF4Kv.rootShouldForwardProp)(prop) && prop !== "variant",
    slot: "Root"
};
const $52d52521ed968f55$var$StyledInput = (0, $aF4Kv.default)((0, $ljYhS.default), $52d52521ed968f55$var$styledRootConfig)("");
const $52d52521ed968f55$var$StyledOutlinedInput = (0, $aF4Kv.default)((0, $76Hzh.default), $52d52521ed968f55$var$styledRootConfig)("");
const $52d52521ed968f55$var$StyledFilledInput = (0, $aF4Kv.default)((0, $9TEpO.default), $52d52521ed968f55$var$styledRootConfig)("");
const $52d52521ed968f55$var$Select = /*#__PURE__*/ $fV3WI.forwardRef(function Select(inProps, ref) {
    const props = (0, $05gnM.default)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false , children: children , classes: classesProp = {} , className: className , defaultOpen: defaultOpen = false , displayEmpty: displayEmpty = false , IconComponent: IconComponent = (0, $1yAKJ.default) , id: id , input: input , inputProps: inputProps , label: label , labelId: labelId , MenuProps: MenuProps , multiple: multiple = false , native: native = false , onClose: onClose , onOpen: onOpen , open: open , renderValue: renderValue , SelectDisplayProps: SelectDisplayProps , variant: variantProp = "outlined"  } = props, other = (0, $64S8Y.default)(props, $52d52521ed968f55$var$_excluded);
    const inputComponent = native ? (0, $9Th25.default) : (0, $himqN.default);
    const muiFormControl = (0, $24RkK.default)();
    const fcs = (0, $7a74J.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $j5tUA.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $52d52521ed968f55$var$useUtilityClasses(ownerState);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $3DnwL.jsx)($52d52521ed968f55$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $3DnwL.jsx)($52d52521ed968f55$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $3DnwL.jsx)($52d52521ed968f55$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $czyq6.default)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $3DnwL.jsx)($fV3WI.Fragment, {
        children: /*#__PURE__*/ $fV3WI.cloneElement(InputComponent, (0, $j5tUA.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $j5tUA.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $j5tUA.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $dbzFE.default)(classes, inputProps.classes) : classes
            }, input ? input.props.inputProps : {})
        }, multiple && native && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $h0s6D.default)(InputComponent.props.className, className)
        }, !input && {
            variant: variant
        }, other))
    });
});
$52d52521ed968f55$var$Select.muiName = "Select";
var $52d52521ed968f55$export$2e2bcd8739ae039 = $52d52521ed968f55$var$Select;

});
parcelRequire.register("himqN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9758477536fa388$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $2RrcA = parcelRequire("2RrcA");

var $fV3WI = parcelRequire("fV3WI");
parcelRequire("2xEDb");


var $h0s6D = parcelRequire("h0s6D");

var $js0sS = parcelRequire("js0sS");

var $a6tvC = parcelRequire("a6tvC");

var $ZXS89 = parcelRequire("ZXS89");

var $6r3xg = parcelRequire("6r3xg");

var $9Th25 = parcelRequire("9Th25");

var $aK99b = parcelRequire("aK99b");

var $aF4Kv = parcelRequire("aF4Kv");

var $czyq6 = parcelRequire("czyq6");

var $btPGR = parcelRequire("btPGR");

var $7Hm6A = parcelRequire("7Hm6A");

var $3DnwL = parcelRequire("3DnwL");
var $c9758477536fa388$var$_span;
const $c9758477536fa388$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $c9758477536fa388$var$SelectSelect = (0, $aF4Kv.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $7Hm6A.default).select}`]: styles.select
            },
            {
                [`&.${(0, $7Hm6A.default).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $7Hm6A.default).error}`]: styles.error
            },
            {
                [`&.${(0, $7Hm6A.default).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $9Th25.nativeSelectSelectStyles), {
    // Win specificity over the input base
    [`&.${(0, $7Hm6A.default).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $c9758477536fa388$var$SelectIcon = (0, $aF4Kv.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $ZXS89.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $9Th25.nativeSelectIconStyles));
const $c9758477536fa388$var$SelectNativeInput = (0, $aF4Kv.default)("input", {
    shouldForwardProp: (prop)=>(0, $aF4Kv.slotShouldForwardProp)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $c9758477536fa388$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $c9758477536fa388$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $c9758477536fa388$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , variant: variant , disabled: disabled , multiple: multiple , open: open , error: error  } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $ZXS89.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $7Hm6A.getSelectUtilityClasses), classes);
};
/**
 * @ignore - internal component.
 */ const $c9758477536fa388$var$SelectInput = /*#__PURE__*/ $fV3WI.forwardRef(function SelectInput(props, ref) {
    const { "aria-describedby": ariaDescribedby , "aria-label": ariaLabel , autoFocus: autoFocus , autoWidth: autoWidth , children: children , className: className , defaultOpen: defaultOpen , defaultValue: defaultValue , disabled: disabled , displayEmpty: displayEmpty , error: error = false , IconComponent: IconComponent , inputRef: inputRefProp , labelId: labelId , MenuProps: MenuProps = {} , multiple: multiple , name: name , onBlur: onBlur , onChange: onChange , onClose: onClose , onFocus: onFocus , onOpen: onOpen , open: openProp , readOnly: readOnly , renderValue: renderValue , SelectDisplayProps: SelectDisplayProps = {} , tabIndex: tabIndexProp , value: valueProp , variant: variant = "standard"  } = props, other = (0, $64S8Y.default)(props, $c9758477536fa388$var$_excluded);
    const [value, setValueState] = (0, $btPGR.default)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $btPGR.default)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $fV3WI.useRef(null);
    const displayRef = $fV3WI.useRef(null);
    const [displayNode, setDisplayNode] = $fV3WI.useState(null);
    const { current: isOpenControlled  } = $fV3WI.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $fV3WI.useState();
    const handleRef = (0, $czyq6.default)(ref, inputRefProp);
    const handleDisplayRef = $fV3WI.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $fV3WI.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $fV3WI.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $fV3WI.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $fV3WI.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $a6tvC.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $fV3WI.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $aK99b.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $fV3WI.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $2RrcA.default)(2));
            selected = value.some((v)=>$c9758477536fa388$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $c9758477536fa388$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $fV3WI.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $j5tUA.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $c9758477536fa388$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3DnwL.jsxs)($fV3WI.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3DnwL.jsx)($c9758477536fa388$var$SelectSelect, (0, $j5tUA.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "button",
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $h0s6D.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $c9758477536fa388$var$isEmpty(display) ? $c9758477536fa388$var$_span || ($c9758477536fa388$var$_span = /*#__PURE__*/ (0, $3DnwL.jsx)("span", {
                    className: "notranslate",
                    children: "​"
                })) : display
            })),
            /*#__PURE__*/ (0, $3DnwL.jsx)($c9758477536fa388$var$SelectNativeInput, (0, $j5tUA.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $3DnwL.jsx)($c9758477536fa388$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $3DnwL.jsx)((0, $6r3xg.default), (0, $j5tUA.default)({
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $j5tUA.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    disableListWrap: true
                }, MenuProps.MenuListProps),
                PaperProps: (0, $j5tUA.default)({}, MenuProps.PaperProps, {
                    style: (0, $j5tUA.default)({
                        minWidth: menuMinWidth
                    }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
                }),
                children: items
            }))
        ]
    });
});
var $c9758477536fa388$export$2e2bcd8739ae039 = $c9758477536fa388$var$SelectInput;

});
parcelRequire.register("2xEDb", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5UdlT"));

});

parcelRequire.register("a6tvC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75b15ac6b4f1fa89$export$2e2bcd8739ae039; });

var $77gjj = parcelRequire("77gjj");
var $75b15ac6b4f1fa89$export$2e2bcd8739ae039 = (0, $77gjj.default);

});
parcelRequire.register("77gjj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52e5d6c5f8f2e0bd$export$2e2bcd8739ae039; });
function $52e5d6c5f8f2e0bd$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});


parcelRequire.register("6r3xg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4af801c4760d27bf$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $fV3WI = parcelRequire("fV3WI");
parcelRequire("2xEDb");


var $h0s6D = parcelRequire("h0s6D");

var $js0sS = parcelRequire("js0sS");


var $lSSXo = parcelRequire("lSSXo");

var $fVlEp = parcelRequire("fVlEp");

var $aF4Kv = parcelRequire("aF4Kv");

var $4uBZf = parcelRequire("4uBZf");

var $05gnM = parcelRequire("05gnM");

var $1PYNf = parcelRequire("1PYNf");

var $3DnwL = parcelRequire("3DnwL");
const $4af801c4760d27bf$var$_excluded = [
    "onEntering"
], $4af801c4760d27bf$var$_excluded2 = [
    "autoFocus",
    "children",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant"
];
const $4af801c4760d27bf$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $4af801c4760d27bf$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $4af801c4760d27bf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes  } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $1PYNf.getMenuUtilityClass), classes);
};
const $4af801c4760d27bf$var$MenuRoot = (0, $aF4Kv.default)((0, $fVlEp.default), {
    shouldForwardProp: (prop)=>(0, $aF4Kv.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $4af801c4760d27bf$export$4f7c51a5920c9f33 = (0, $aF4Kv.default)((0, $fVlEp.PopoverPaper), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $4af801c4760d27bf$var$MenuMenuList = (0, $aF4Kv.default)((0, $lSSXo.default), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $4af801c4760d27bf$var$Menu = /*#__PURE__*/ $fV3WI.forwardRef(function Menu(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true , children: children , disableAutoFocusItem: disableAutoFocusItem = false , MenuListProps: MenuListProps = {} , onClose: onClose , open: open , PaperProps: PaperProps = {} , PopoverClasses: PopoverClasses , transitionDuration: transitionDuration = "auto" , TransitionProps: { onEntering: onEntering  } = {} , variant: variant = "selectedMenu"  } = props, TransitionProps = (0, $64S8Y.default)(props.TransitionProps, $4af801c4760d27bf$var$_excluded), other = (0, $64S8Y.default)(props, $4af801c4760d27bf$var$_excluded2);
    const theme = (0, $4uBZf.default)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $j5tUA.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $4af801c4760d27bf$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $fV3WI.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $fV3WI.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $fV3WI.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    return /*#__PURE__*/ (0, $3DnwL.jsx)($4af801c4760d27bf$var$MenuRoot, (0, $j5tUA.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $4af801c4760d27bf$var$RTL_ORIGIN : $4af801c4760d27bf$var$LTR_ORIGIN,
        slots: {
            paper: $4af801c4760d27bf$export$4f7c51a5920c9f33
        },
        slotProps: {
            paper: (0, $j5tUA.default)({}, PaperProps, {
                classes: (0, $j5tUA.default)({}, PaperProps.classes, {
                    root: classes.paper
                })
            })
        },
        className: classes.root,
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $j5tUA.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $3DnwL.jsx)($4af801c4760d27bf$var$MenuMenuList, (0, $j5tUA.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $h0s6D.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $4af801c4760d27bf$export$2e2bcd8739ae039 = $4af801c4760d27bf$var$Menu;

});
parcelRequire.register("lSSXo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fee9456e671ee8e3$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $fV3WI = parcelRequire("fV3WI");
parcelRequire("2xEDb");


var $a6tvC = parcelRequire("a6tvC");

var $jv2Pm = parcelRequire("jv2Pm");

var $dLCE0 = parcelRequire("dLCE0");

var $czyq6 = parcelRequire("czyq6");

var $fR16U = parcelRequire("fR16U");

var $3DnwL = parcelRequire("3DnwL");
const $fee9456e671ee8e3$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $fee9456e671ee8e3$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $fee9456e671ee8e3$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $fee9456e671ee8e3$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $fee9456e671ee8e3$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$fee9456e671ee8e3$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $fee9456e671ee8e3$var$MenuList = /*#__PURE__*/ $fV3WI.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions , autoFocus: autoFocus = false , autoFocusItem: autoFocusItem = false , children: children , className: className , disabledItemsFocusable: disabledItemsFocusable = false , disableListWrap: disableListWrap = false , onKeyDown: onKeyDown , variant: variant = "selectedMenu"  } = props, other = (0, $64S8Y.default)(props, $fee9456e671ee8e3$var$_excluded);
    const listRef = $fV3WI.useRef(null);
    const textCriteriaRef = $fV3WI.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $fR16U.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $fV3WI.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $dLCE0.default)((0, $a6tvC.default)(containerElement))}px`;
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $a6tvC.default)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $fee9456e671ee8e3$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fee9456e671ee8e3$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $fee9456e671ee8e3$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fee9456e671ee8e3$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $fee9456e671ee8e3$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fee9456e671ee8e3$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $fee9456e671ee8e3$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fee9456e671ee8e3$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $fee9456e671ee8e3$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $fee9456e671ee8e3$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $fee9456e671ee8e3$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $czyq6.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $fV3WI.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $fV3WI.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $fV3WI.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $fV3WI.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $3DnwL.jsx)((0, $jv2Pm.default), (0, $j5tUA.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $fee9456e671ee8e3$export$2e2bcd8739ae039 = $fee9456e671ee8e3$var$MenuList;

});
parcelRequire.register("jv2Pm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3231b098fed5e95$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $js0sS = parcelRequire("js0sS");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");

var $fdeY0 = parcelRequire("fdeY0");

var $jRuCE = parcelRequire("jRuCE");

var $3DnwL = parcelRequire("3DnwL");
const $e3231b098fed5e95$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $e3231b098fed5e95$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disablePadding: disablePadding , dense: dense , subheader: subheader  } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $jRuCE.getListUtilityClass), classes);
};
const $e3231b098fed5e95$var$ListRoot = (0, $aF4Kv.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState  })=>(0, $j5tUA.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $e3231b098fed5e95$var$List = /*#__PURE__*/ $fV3WI.forwardRef(function List(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children , className: className , component: component = "ul" , dense: dense = false , disablePadding: disablePadding = false , subheader: subheader  } = props, other = (0, $64S8Y.default)(props, $e3231b098fed5e95$var$_excluded);
    const context = $fV3WI.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $j5tUA.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $e3231b098fed5e95$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3DnwL.jsx)((0, $fdeY0.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $3DnwL.jsxs)($e3231b098fed5e95$var$ListRoot, (0, $j5tUA.default)({
            as: component,
            className: (0, $h0s6D.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $e3231b098fed5e95$export$2e2bcd8739ae039 = $e3231b098fed5e95$var$List;

});
parcelRequire.register("fdeY0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b133ae0737c8bc3e$export$2e2bcd8739ae039; });

var $fV3WI = parcelRequire("fV3WI");
/**
 * @ignore - internal component.
 */ const $b133ae0737c8bc3e$var$ListContext = /*#__PURE__*/ $fV3WI.createContext({});
var $b133ae0737c8bc3e$export$2e2bcd8739ae039 = $b133ae0737c8bc3e$var$ListContext;

});

parcelRequire.register("jRuCE", function(module, exports) {

$parcel$export(module.exports, "getListUtilityClass", function () { return $e75ab88b8226459f$export$c6bd6795ed6e3203; });

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $e75ab88b8226459f$export$c6bd6795ed6e3203(slot) {
    return (0, $auxfn.default)("MuiList", slot);
}
const $e75ab88b8226459f$var$listClasses = (0, $dxVxC.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $e75ab88b8226459f$export$2e2bcd8739ae039 = $e75ab88b8226459f$var$listClasses;

});


parcelRequire.register("dLCE0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a05da41b4c8afe2d$export$2e2bcd8739ae039; });

var $lbGsp = parcelRequire("lbGsp");
var $a05da41b4c8afe2d$export$2e2bcd8739ae039 = (0, $lbGsp.default);

});
parcelRequire.register("lbGsp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6cb8f2d924a3867$export$2e2bcd8739ae039; });
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $f6cb8f2d924a3867$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}

});


parcelRequire.register("fR16U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8acaac14fe8aa07$export$2e2bcd8739ae039; });

var $3kcer = parcelRequire("3kcer");
var $b8acaac14fe8aa07$export$2e2bcd8739ae039 = (0, $3kcer.default);

});
parcelRequire.register("3kcer", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26bcba5ae0b303ac$export$2e2bcd8739ae039; });

var $fV3WI = parcelRequire("fV3WI");
const $26bcba5ae0b303ac$var$useEnhancedEffect = typeof window !== "undefined" ? $fV3WI.useLayoutEffect : $fV3WI.useEffect;
var $26bcba5ae0b303ac$export$2e2bcd8739ae039 = $26bcba5ae0b303ac$var$useEnhancedEffect;

});



parcelRequire.register("fVlEp", function(module, exports) {

$parcel$export(module.exports, "PopoverPaper", function () { return $b97cf9417e4051c1$export$821346c38a2d9390; });
$parcel$export(module.exports, "default", function () { return $b97cf9417e4051c1$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $dTXtf = parcelRequire("dTXtf");
var $js0sS = parcelRequire("js0sS");
var $4NVxb = parcelRequire("4NVxb");


var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");

var $8ojVT = parcelRequire("8ojVT");

var $a6tvC = parcelRequire("a6tvC");

var $fZzy1 = parcelRequire("fZzy1");

var $czyq6 = parcelRequire("czyq6");

var $jlVep = parcelRequire("jlVep");

var $1CLOS = parcelRequire("1CLOS");

var $eKfJS = parcelRequire("eKfJS");

var $gvx9Q = parcelRequire("gvx9Q");

var $3DnwL = parcelRequire("3DnwL");
const $b97cf9417e4051c1$var$_excluded = [
    "onEntering"
], $b97cf9417e4051c1$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
], $b97cf9417e4051c1$var$_excluded3 = [
    "slotProps"
];
function $b97cf9417e4051c1$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $b97cf9417e4051c1$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $b97cf9417e4051c1$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $b97cf9417e4051c1$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $b97cf9417e4051c1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes  } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $gvx9Q.getPopoverUtilityClass), classes);
};
const $b97cf9417e4051c1$export$bcce13685275fc99 = (0, $aF4Kv.default)((0, $1CLOS.default), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $b97cf9417e4051c1$export$821346c38a2d9390 = (0, $aF4Kv.default)((0, $eKfJS.default), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $b97cf9417e4051c1$var$Popover = /*#__PURE__*/ $fV3WI.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action , anchorEl: anchorEl , anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    } , anchorPosition: anchorPosition , anchorReference: anchorReference = "anchorEl" , children: children , className: className , container: containerProp , elevation: elevation = 8 , marginThreshold: marginThreshold = 16 , open: open , PaperProps: PaperPropsProp = {} , slots: slots , slotProps: slotProps , transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    } , TransitionComponent: TransitionComponent = (0, $jlVep.default) , transitionDuration: transitionDurationProp = "auto" , TransitionProps: { onEntering: onEntering  } = {}  } = props, TransitionProps = (0, $64S8Y.default)(props.TransitionProps, $b97cf9417e4051c1$var$_excluded), other = (0, $64S8Y.default)(props, $b97cf9417e4051c1$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $fV3WI.useRef();
    const handlePaperRef = (0, $czyq6.default)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $j5tUA.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $b97cf9417e4051c1$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $fV3WI.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $b97cf9417e4051c1$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $a6tvC.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $b97cf9417e4051c1$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $b97cf9417e4051c1$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $fV3WI.useCallback((elemRect)=>{
        return {
            vertical: $b97cf9417e4051c1$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $b97cf9417e4051c1$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $fV3WI.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $b97cf9417e4051c1$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $fZzy1.default)($b97cf9417e4051c1$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $b97cf9417e4051c1$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $fV3WI.useState(open);
    const setPositioningStyles = $fV3WI.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $fV3WI.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $fV3WI.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $fV3WI.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $8ojVT.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $fZzy1.default)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $a6tvC.default)($b97cf9417e4051c1$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $b97cf9417e4051c1$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $b97cf9417e4051c1$export$821346c38a2d9390;
    const paperProps = (0, $4NVxb.default)({
        elementType: PaperSlot,
        externalSlotProps: (0, $j5tUA.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $j5tUA.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $h0s6D.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $4NVxb.default)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $h0s6D.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp  } = _useSlotProps, rootProps = (0, $64S8Y.default)(_useSlotProps, $b97cf9417e4051c1$var$_excluded3);
    return /*#__PURE__*/ (0, $3DnwL.jsx)(RootSlot, (0, $j5tUA.default)({}, rootProps, !(0, $dTXtf.default)(RootSlot) && {
        slotProps: rootSlotPropsProp
    }, {
        children: /*#__PURE__*/ (0, $3DnwL.jsx)(TransitionComponent, (0, $j5tUA.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $3DnwL.jsx)(PaperSlot, (0, $j5tUA.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $b97cf9417e4051c1$export$2e2bcd8739ae039 = $b97cf9417e4051c1$var$Popover;

});
parcelRequire.register("dTXtf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1ee8b1098fcf8e2$export$2e2bcd8739ae039; });
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $a1ee8b1098fcf8e2$export$2e2bcd8739ae039(element) {
    return typeof element === "string";
}

});

parcelRequire.register("4NVxb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37f85e215e300c7d$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $eFiOq = parcelRequire("eFiOq");

var $fhJrz = parcelRequire("fhJrz");

var $9WIrS = parcelRequire("9WIrS");

var $jJSFZ = parcelRequire("jJSFZ");
const $37f85e215e300c7d$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState"
];
function $37f85e215e300c7d$export$2e2bcd8739ae039(parameters) {
    var _parameters$additiona;
    const { elementType: elementType , externalSlotProps: externalSlotProps , ownerState: ownerState  } = parameters, rest = (0, $64S8Y.default)(parameters, $37f85e215e300c7d$var$_excluded);
    const resolvedComponentsProps = (0, $jJSFZ.default)(externalSlotProps, ownerState);
    const { props: mergedProps , internalRef: internalRef  } = (0, $9WIrS.default)((0, $j5tUA.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $eFiOq.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $fhJrz.default)(elementType, (0, $j5tUA.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}

});
parcelRequire.register("fhJrz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b20bb1b8f9b4a7e0$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $dTXtf = parcelRequire("dTXtf");
function $b20bb1b8f9b4a7e0$export$2e2bcd8739ae039(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $dTXtf.default)(elementType)) return otherProps;
    return (0, $j5tUA.default)({}, otherProps, {
        ownerState: (0, $j5tUA.default)({}, otherProps.ownerState, ownerState)
    });
}

});

parcelRequire.register("9WIrS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73dc0268891212fc$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $h0s6D = parcelRequire("h0s6D");

var $cV24z = parcelRequire("cV24z");

var $bOOna = parcelRequire("bOOna");
function $73dc0268891212fc$export$2e2bcd8739ae039(parameters) {
    const { getSlotProps: getSlotProps , additionalProps: additionalProps , externalSlotProps: externalSlotProps , externalForwardedProps: externalForwardedProps , className: className  } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $h0s6D.default)(externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className, className, additionalProps == null ? void 0 : additionalProps.className);
        const mergedStyle = (0, $j5tUA.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $j5tUA.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $cV24z.default)((0, $j5tUA.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $bOOna.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $bOOna.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $h0s6D.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $j5tUA.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $j5tUA.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}

});
parcelRequire.register("cV24z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $967c6a7e4f7eefd4$export$2e2bcd8739ae039; });
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $967c6a7e4f7eefd4$export$2e2bcd8739ae039(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}

});

parcelRequire.register("bOOna", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89ab7030b6dce338$export$2e2bcd8739ae039; });
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $89ab7030b6dce338$export$2e2bcd8739ae039(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}

});


parcelRequire.register("jJSFZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5eca1e16db7ca27$export$2e2bcd8739ae039; });
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $e5eca1e16db7ca27$export$2e2bcd8739ae039(componentProps, ownerState) {
    if (typeof componentProps === "function") return componentProps(ownerState);
    return componentProps;
}

});


parcelRequire.register("8ojVT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61c006dcc00d0fd7$export$2e2bcd8739ae039; });

var $5rLmm = parcelRequire("5rLmm");
var $61c006dcc00d0fd7$export$2e2bcd8739ae039 = (0, $5rLmm.default);

});
parcelRequire.register("5rLmm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f7435fba9907602$export$2e2bcd8739ae039; });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $3f7435fba9907602$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});


parcelRequire.register("fZzy1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba48208dcc785540$export$2e2bcd8739ae039; });

var $3Wn11 = parcelRequire("3Wn11");
var $ba48208dcc785540$export$2e2bcd8739ae039 = (0, $3Wn11.default);

});
parcelRequire.register("3Wn11", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2de8a4428aa920af$export$2e2bcd8739ae039; });

var $77gjj = parcelRequire("77gjj");
function $2de8a4428aa920af$export$2e2bcd8739ae039(node) {
    const doc = (0, $77gjj.default)(node);
    return doc.defaultView || window;
}

});


parcelRequire.register("jlVep", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e16c5f7633ba106b$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $fV3WI = parcelRequire("fV3WI");



var $bzLsd = parcelRequire("bzLsd");

var $4uBZf = parcelRequire("4uBZf");

var $8Ewcq = parcelRequire("8Ewcq");

var $czyq6 = parcelRequire("czyq6");

var $3DnwL = parcelRequire("3DnwL");
const $e16c5f7633ba106b$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $e16c5f7633ba106b$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $e16c5f7633ba106b$var$styles = {
    entering: {
        opacity: 1,
        transform: $e16c5f7633ba106b$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $e16c5f7633ba106b$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $e16c5f7633ba106b$var$Grow = /*#__PURE__*/ $fV3WI.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener , appear: appear = true , children: children , easing: easing , in: inProp , onEnter: onEnter , onEntered: onEntered , onEntering: onEntering , onExit: onExit , onExited: onExited , onExiting: onExiting , style: style , timeout: timeout = "auto" , TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $bzLsd.default)  } = props, other = (0, $64S8Y.default)(props, $e16c5f7633ba106b$var$_excluded);
    const timer = $fV3WI.useRef();
    const autoTimeout = $fV3WI.useRef();
    const theme = (0, $4uBZf.default)();
    const nodeRef = $fV3WI.useRef(null);
    const handleRef = (0, $czyq6.default)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $8Ewcq.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration , delay: delay , easing: transitionTimingFunction  } = (0, $8Ewcq.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $e16c5f7633ba106b$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration , delay: delay , easing: transitionTimingFunction  } = (0, $8Ewcq.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $e16c5f7633ba106b$var$isWebKit154 ? duration : duration * 0.666,
                delay: $e16c5f7633ba106b$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $e16c5f7633ba106b$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.current = setTimeout(next, autoTimeout.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    $fV3WI.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $3DnwL.jsx)(TransitionComponent, (0, $j5tUA.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $fV3WI.cloneElement(children, (0, $j5tUA.default)({
                style: (0, $j5tUA.default)({
                    opacity: 0,
                    transform: $e16c5f7633ba106b$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $e16c5f7633ba106b$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$e16c5f7633ba106b$var$Grow.muiSupportAuto = true;
var $e16c5f7633ba106b$export$2e2bcd8739ae039 = $e16c5f7633ba106b$var$Grow;

});
parcelRequire.register("bzLsd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86d7c5f66b7850ab$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $cYTW9 = parcelRequire("cYTW9");


var $fV3WI = parcelRequire("fV3WI");

var $fXLKn = parcelRequire("fXLKn");

var $3SFoQ = parcelRequire("3SFoQ");


var $1NpCL = parcelRequire("1NpCL");

var $gsauU = parcelRequire("gsauU");
var $86d7c5f66b7850ab$export$bb38bb9a1161268 = "unmounted";
var $86d7c5f66b7850ab$export$84cbff306f539230 = "exited";
var $86d7c5f66b7850ab$export$df38205c966be359 = "entering";
var $86d7c5f66b7850ab$export$78e9e6e3e014d60a = "entered";
var $86d7c5f66b7850ab$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $86d7c5f66b7850ab$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $cYTW9.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $86d7c5f66b7850ab$export$84cbff306f539230;
                _this.appearStatus = $86d7c5f66b7850ab$export$df38205c966be359;
            } else initialStatus = $86d7c5f66b7850ab$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $86d7c5f66b7850ab$export$bb38bb9a1161268;
        else initialStatus = $86d7c5f66b7850ab$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $86d7c5f66b7850ab$export$bb38bb9a1161268) return {
            status: $86d7c5f66b7850ab$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $86d7c5f66b7850ab$export$df38205c966be359 && status !== $86d7c5f66b7850ab$export$78e9e6e3e014d60a) nextStatus = $86d7c5f66b7850ab$export$df38205c966be359;
            } else if (status === $86d7c5f66b7850ab$export$df38205c966be359 || status === $86d7c5f66b7850ab$export$78e9e6e3e014d60a) nextStatus = $86d7c5f66b7850ab$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $86d7c5f66b7850ab$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fXLKn))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $gsauU.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $86d7c5f66b7850ab$export$84cbff306f539230) this.setState({
            status: $86d7c5f66b7850ab$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($fXLKn))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $3SFoQ.default).disabled) {
            this.safeSetState({
                status: $86d7c5f66b7850ab$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $86d7c5f66b7850ab$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $86d7c5f66b7850ab$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($fXLKn))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $3SFoQ.default).disabled) {
            this.safeSetState({
                status: $86d7c5f66b7850ab$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $86d7c5f66b7850ab$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $86d7c5f66b7850ab$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fXLKn))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $86d7c5f66b7850ab$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $64S8Y.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement((0, $1NpCL.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).Component);
$86d7c5f66b7850ab$var$Transition.contextType = (0, $1NpCL.default);
$86d7c5f66b7850ab$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $86d7c5f66b7850ab$var$noop() {}
$86d7c5f66b7850ab$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $86d7c5f66b7850ab$var$noop,
    onEntering: $86d7c5f66b7850ab$var$noop,
    onEntered: $86d7c5f66b7850ab$var$noop,
    onExit: $86d7c5f66b7850ab$var$noop,
    onExiting: $86d7c5f66b7850ab$var$noop,
    onExited: $86d7c5f66b7850ab$var$noop
};
$86d7c5f66b7850ab$var$Transition.UNMOUNTED = $86d7c5f66b7850ab$export$bb38bb9a1161268;
$86d7c5f66b7850ab$var$Transition.EXITED = $86d7c5f66b7850ab$export$84cbff306f539230;
$86d7c5f66b7850ab$var$Transition.ENTERING = $86d7c5f66b7850ab$export$df38205c966be359;
$86d7c5f66b7850ab$var$Transition.ENTERED = $86d7c5f66b7850ab$export$78e9e6e3e014d60a;
$86d7c5f66b7850ab$var$Transition.EXITING = $86d7c5f66b7850ab$export$4aacc83d4d59139f;
var $86d7c5f66b7850ab$export$2e2bcd8739ae039 = $86d7c5f66b7850ab$var$Transition;

});
parcelRequire.register("cYTW9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97367a88955a8161$export$2e2bcd8739ae039; });

var $lY8R5 = parcelRequire("lY8R5");
function $97367a88955a8161$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $lY8R5.default)(subClass, superClass);
}

});
parcelRequire.register("lY8R5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffe612048341994b$export$2e2bcd8739ae039; });
function $ffe612048341994b$export$2e2bcd8739ae039(o, p) {
    $ffe612048341994b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ffe612048341994b$export$2e2bcd8739ae039(o, p);
}

});


parcelRequire.register("fXLKn", function(module, exports) {
"use strict";
function $b9f16744c25b65b6$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b9f16744c25b65b6$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b9f16744c25b65b6$var$checkDCE();

module.exports = (parcelRequire("1eN5H"));

});

parcelRequire.register("3SFoQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d368763c2f9e94a$export$2e2bcd8739ae039; });
var $2d368763c2f9e94a$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRequire.register("1NpCL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14ee3e789c3955e2$export$2e2bcd8739ae039; });

var $fV3WI = parcelRequire("fV3WI");
var $14ee3e789c3955e2$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createContext(null);

});

parcelRequire.register("gsauU", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $bfa767793c9ab234$export$7d26bbb1236dafd6; });
var $bfa767793c9ab234$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRequire.register("8Ewcq", function(module, exports) {

$parcel$export(module.exports, "reflow", function () { return $64cb094aff24aec0$export$b7a864e1eaef9de5; });
$parcel$export(module.exports, "getTransitionProps", function () { return $64cb094aff24aec0$export$8cb1e9b404609ae9; });
const $64cb094aff24aec0$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $64cb094aff24aec0$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout , easing: easing , style: style = {}  } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}

});


parcelRequire.register("1CLOS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12ee6f02656f134e$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $1XFo3 = parcelRequire("1XFo3");
var $9qxob = parcelRequire("9qxob");

var $dTXtf = parcelRequire("dTXtf");
var $jJSFZ = parcelRequire("jJSFZ");


var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");

var $8qu0S = parcelRequire("8qu0S");

var $3DnwL = parcelRequire("3DnwL");
const $12ee6f02656f134e$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $12ee6f02656f134e$export$eb211a494147b724 = (0, $9qxob.default);
const $12ee6f02656f134e$var$ModalRoot = (0, $aF4Kv.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $12ee6f02656f134e$var$ModalBackdrop = (0, $aF4Kv.default)((0, $8qu0S.default), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $12ee6f02656f134e$var$Modal = /*#__PURE__*/ $fV3WI.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $05gnM.default)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $12ee6f02656f134e$var$ModalBackdrop , BackdropProps: BackdropProps , classes: classes , className: className , closeAfterTransition: closeAfterTransition = false , children: children , container: container , component: component , components: components = {} , componentsProps: componentsProps = {} , disableAutoFocus: disableAutoFocus = false , disableEnforceFocus: disableEnforceFocus = false , disableEscapeKeyDown: disableEscapeKeyDown = false , disablePortal: disablePortal = false , disableRestoreFocus: disableRestoreFocus = false , disableScrollLock: disableScrollLock = false , hideBackdrop: hideBackdrop = false , keepMounted: keepMounted = false , onBackdropClick: onBackdropClick , onClose: onClose , open: open , slotProps: slotProps , slots: slots , theme: // eslint-disable-next-line react/prop-types
    theme  } = props, other = (0, $64S8Y.default)(props, $12ee6f02656f134e$var$_excluded);
    const [exited, setExited] = $fV3WI.useState(true);
    const commonProps = {
        container: container,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted,
        onBackdropClick: onBackdropClick,
        onClose: onClose,
        open: open
    };
    const ownerState = (0, $j5tUA.default)({}, props, commonProps, {
        exited: exited
    });
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $12ee6f02656f134e$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    return /*#__PURE__*/ (0, $3DnwL.jsx)((0, $1XFo3.default), (0, $j5tUA.default)({
        slots: {
            root: RootSlot,
            backdrop: BackdropSlot
        },
        slotProps: {
            root: ()=>(0, $j5tUA.default)({}, (0, $jJSFZ.default)(rootSlotProps, ownerState), !(0, $dTXtf.default)(RootSlot) && {
                    as: component,
                    theme: theme
                }, {
                    className: (0, $h0s6D.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
                }),
            backdrop: ()=>(0, $j5tUA.default)({}, BackdropProps, (0, $jJSFZ.default)(backdropSlotProps, ownerState), {
                    className: (0, $h0s6D.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop)
                })
        },
        onTransitionEnter: ()=>setExited(false),
        onTransitionExited: ()=>setExited(true),
        ref: ref
    }, other, commonProps, {
        children: children
    }));
});
var $12ee6f02656f134e$export$2e2bcd8739ae039 = $12ee6f02656f134e$var$Modal;

});
parcelRequire.register("1XFo3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16db67ba08337374$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $fV3WI = parcelRequire("fV3WI");


var $83gz5 = parcelRequire("83gz5");
var $77gjj = parcelRequire("77gjj");
var $4lsKM = parcelRequire("4lsKM");
var $eFiOq = parcelRequire("eFiOq");

var $js0sS = parcelRequire("js0sS");

var $7tRYJ = parcelRequire("7tRYJ");

var $50lsj = parcelRequire("50lsj");

var $bP9ss = parcelRequire("bP9ss");

var $9qxob = parcelRequire("9qxob");

var $4NVxb = parcelRequire("4NVxb");

var $eyzqE = parcelRequire("eyzqE");

var $3DnwL = parcelRequire("3DnwL");
const $16db67ba08337374$var$_excluded = [
    "children",
    "closeAfterTransition",
    "container",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "manager",
    "onBackdropClick",
    "onClose",
    "onKeyDown",
    "open",
    "onTransitionEnter",
    "onTransitionExited",
    "slotProps",
    "slots"
];
const $16db67ba08337374$var$useUtilityClasses = (ownerState)=>{
    const { open: open , exited: exited  } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $eyzqE.useClassNamesOverride)((0, $9qxob.getModalUtilityClass)));
};
function $16db67ba08337374$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $16db67ba08337374$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $16db67ba08337374$var$defaultManager = new (0, $50lsj.default)();
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * *   [Dialog](https://mui.com/material-ui/api/dialog/)
 * *   [Drawer](https://mui.com/material-ui/api/drawer/)
 * *   [Menu](https://mui.com/material-ui/api/menu/)
 * *   [Popover](https://mui.com/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](https://mui.com/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base/react-modal/)
 *
 * API:
 *
 * - [Modal API](https://mui.com/base/react-modal/components-api/#modal)
 */ const $16db67ba08337374$var$Modal = /*#__PURE__*/ $fV3WI.forwardRef(function Modal(props, forwardedRef) {
    var _props$ariaHidden, _slots$root;
    const { children: children , closeAfterTransition: closeAfterTransition = false , container: container , disableAutoFocus: disableAutoFocus = false , disableEnforceFocus: disableEnforceFocus = false , disableEscapeKeyDown: disableEscapeKeyDown = false , disablePortal: disablePortal = false , disableRestoreFocus: disableRestoreFocus = false , disableScrollLock: disableScrollLock = false , hideBackdrop: hideBackdrop = false , keepMounted: keepMounted = false , // private
    manager: managerProp = $16db67ba08337374$var$defaultManager , onBackdropClick: onBackdropClick , onClose: onClose , onKeyDown: onKeyDown , open: open , onTransitionEnter: onTransitionEnter , onTransitionExited: onTransitionExited , slotProps: slotProps = {} , slots: slots = {}  } = props, other = (0, $64S8Y.default)(props, $16db67ba08337374$var$_excluded);
    // TODO: `modal`` must change its type in this file to match the type of methods
    // provided by `ModalManager`
    const manager = managerProp;
    const [exited, setExited] = $fV3WI.useState(!open);
    const modal = $fV3WI.useRef({});
    const mountNodeRef = $fV3WI.useRef(null);
    const modalRef = $fV3WI.useRef(null);
    const handleRef = (0, $eFiOq.default)(modalRef, forwardedRef);
    const hasTransition = $16db67ba08337374$var$getHasTransition(children);
    const ariaHiddenProp = (_props$ariaHidden = props["aria-hidden"]) != null ? _props$ariaHidden : true;
    const getDoc = ()=>(0, $77gjj.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $4lsKM.default)(()=>{
        const resolvedContainer = $16db67ba08337374$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $fV3WI.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $4lsKM.default)((node)=>{
        mountNodeRef.current = node;
        if (!node || !modalRef.current) return;
        if (open && isTopModal()) handleMounted();
        else (0, $50lsj.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $fV3WI.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        manager,
        ariaHiddenProp
    ]);
    $fV3WI.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $fV3WI.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const ownerState = (0, $j5tUA.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        exited: exited,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const classes = $16db67ba08337374$var$useUtilityClasses(ownerState);
    const handleEnter = ()=>{
        setExited(false);
        if (onTransitionEnter) onTransitionEnter();
    };
    const handleExited = ()=>{
        setExited(true);
        if (onTransitionExited) onTransitionExited();
        if (closeAfterTransition) handleClose();
    };
    const handleBackdropClick = (event)=>{
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const handleKeyDown = (event)=>{
        if (onKeyDown) onKeyDown(event);
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviors like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== "Escape" || !isTopModal()) return;
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, "escapeKeyDown");
        }
    };
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $83gz5.default)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $83gz5.default)(handleExited, children.props.onExited);
    }
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $4NVxb.default)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRef,
            role: "presentation",
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: ownerState
    });
    const BackdropComponent = slots.backdrop;
    const backdropProps = (0, $4NVxb.default)({
        elementType: BackdropComponent,
        externalSlotProps: slotProps.backdrop,
        additionalProps: {
            "aria-hidden": true,
            onClick: handleBackdropClick,
            open: open
        },
        className: classes.backdrop,
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $3DnwL.jsx)((0, $7tRYJ.default), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $3DnwL.jsxs)(Root, (0, $j5tUA.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $3DnwL.jsx)(BackdropComponent, (0, $j5tUA.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $3DnwL.jsx)((0, $bP9ss.default), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $fV3WI.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $16db67ba08337374$export$2e2bcd8739ae039 = $16db67ba08337374$var$Modal;

});
parcelRequire.register("4lsKM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $329f6d6be0b00e89$export$2e2bcd8739ae039; });

var $fV3WI = parcelRequire("fV3WI");

var $3kcer = parcelRequire("3kcer");
function $329f6d6be0b00e89$export$2e2bcd8739ae039(fn) {
    const ref = $fV3WI.useRef(fn);
    (0, $3kcer.default)(()=>{
        ref.current = fn;
    });
    return $fV3WI.useCallback((...args)=>// @ts-expect-error hide `this`
        // tslint:disable-next-line:ban-comma-operator
        (0, ref.current)(...args), []);
}

});

parcelRequire.register("7tRYJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57251cdaa9f36ae2$export$2e2bcd8739ae039; });

var $fV3WI = parcelRequire("fV3WI");

var $fXLKn = parcelRequire("fXLKn");


var $zuYi8 = parcelRequire("zuYi8");
var $3kcer = parcelRequire("3kcer");
var $eFiOq = parcelRequire("eFiOq");

var $3DnwL = parcelRequire("3DnwL");
function $57251cdaa9f36ae2$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base/react-portal/components-api/#portal)
 */ const $57251cdaa9f36ae2$var$Portal = /*#__PURE__*/ $fV3WI.forwardRef(function Portal(props, forwardedRef) {
    const { children: children , container: container , disablePortal: disablePortal = false  } = props;
    const [mountNode, setMountNode] = $fV3WI.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $eFiOq.default)(/*#__PURE__*/ $fV3WI.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $3kcer.default)(()=>{
        if (!disablePortal) setMountNode($57251cdaa9f36ae2$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $3kcer.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $zuYi8.default)(forwardedRef, mountNode);
            return ()=>{
                (0, $zuYi8.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $fV3WI.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $fV3WI.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $3DnwL.jsx)($fV3WI.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $3DnwL.jsx)($fV3WI.Fragment, {
        children: mountNode ? /*#__PURE__*/ $fXLKn.createPortal(children, mountNode) : mountNode
    });
});
var $57251cdaa9f36ae2$export$2e2bcd8739ae039 = $57251cdaa9f36ae2$var$Portal;

});

parcelRequire.register("50lsj", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", function () { return $3a4d987f32066a66$export$e1bd0c6150f13d96; });
$parcel$export(module.exports, "default", function () { return $3a4d987f32066a66$export$2e2bcd8739ae039; });

var $lbGsp = parcelRequire("lbGsp");
var $77gjj = parcelRequire("77gjj");
var $3Wn11 = parcelRequire("3Wn11");
// Is a vertical scrollbar displayed?
function $3a4d987f32066a66$var$isOverflowing(container) {
    const doc = (0, $77gjj.default)(container);
    if (doc.body === container) return (0, $3Wn11.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $3a4d987f32066a66$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $3a4d987f32066a66$var$getPaddingRight(element) {
    return parseInt((0, $3Wn11.default)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $3a4d987f32066a66$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $3a4d987f32066a66$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$3a4d987f32066a66$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $3a4d987f32066a66$export$e1bd0c6150f13d96(element, show);
    });
}
function $3a4d987f32066a66$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $3a4d987f32066a66$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($3a4d987f32066a66$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $lbGsp.default)((0, $77gjj.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$3a4d987f32066a66$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $77gjj.default)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$3a4d987f32066a66$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $77gjj.default)(container).body;
        else {
            // Improve Gatsby support
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $3Wn11.default)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value , el: el , property: property  })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $3a4d987f32066a66$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $3a4d987f32066a66$export$2e2bcd8739ae039 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $3a4d987f32066a66$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $3a4d987f32066a66$var$getHiddenSiblings(container);
        $3a4d987f32066a66$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $3a4d987f32066a66$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $3a4d987f32066a66$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $3a4d987f32066a66$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $3a4d987f32066a66$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $3a4d987f32066a66$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $3a4d987f32066a66$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $3a4d987f32066a66$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}

});

parcelRequire.register("bP9ss", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89bbcb46dcd96589$export$2e2bcd8739ae039; });
/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */ 
var $fV3WI = parcelRequire("fV3WI");


var $77gjj = parcelRequire("77gjj");
var $eFiOq = parcelRequire("eFiOq");

var $3DnwL = parcelRequire("3DnwL");
// Inspired by https://github.com/focus-trap/tabbable
const $89bbcb46dcd96589$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $89bbcb46dcd96589$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $89bbcb46dcd96589$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $89bbcb46dcd96589$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $89bbcb46dcd96589$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $89bbcb46dcd96589$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($89bbcb46dcd96589$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $89bbcb46dcd96589$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$89bbcb46dcd96589$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $89bbcb46dcd96589$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base/react-focus-trap/components-api/#focus-trap)
 */ function $89bbcb46dcd96589$var$FocusTrap(props) {
    const { children: children , disableAutoFocus: disableAutoFocus = false , disableEnforceFocus: disableEnforceFocus = false , disableRestoreFocus: disableRestoreFocus = false , getTabbable: getTabbable = $89bbcb46dcd96589$var$defaultGetTabbable , isEnabled: isEnabled = $89bbcb46dcd96589$var$defaultIsEnabled , open: open  } = props;
    const ignoreNextEnforceFocus = $fV3WI.useRef(false);
    const sentinelStart = $fV3WI.useRef(null);
    const sentinelEnd = $fV3WI.useRef(null);
    const nodeToRestore = $fV3WI.useRef(null);
    const reactFocusEventTarget = $fV3WI.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $fV3WI.useRef(false);
    const rootRef = $fV3WI.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $eFiOq.default)(children.ref, rootRef);
    const lastKeydown = $fV3WI.useRef(null);
    $fV3WI.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $fV3WI.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $77gjj.default)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $fV3WI.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $77gjj.default)(rootRef.current);
        const contain = (nativeEvent)=>{
            const { current: rootElement  } = rootRef;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (!rootElement.contains(doc.activeElement)) {
                // if the focus event is not coming from inside the children's react tree, reset the refs
                if (nativeEvent && reactFocusEventTarget.current !== nativeEvent.target || doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
                else if (reactFocusEventTarget.current !== null) return;
                if (!activated.current) return;
                let tabbable = [];
                if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
                if (tabbable.length > 0) {
                    var _lastKeydown$current, _lastKeydown$current2;
                    const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                    const focusNext = tabbable[0];
                    const focusPrevious = tabbable[tabbable.length - 1];
                    if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                        if (isShiftTab) focusPrevious.focus();
                        else focusNext.focus();
                    }
                } else rootElement.focus();
            }
        };
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain(null);
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $3DnwL.jsxs)($fV3WI.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3DnwL.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $fV3WI.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $3DnwL.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $89bbcb46dcd96589$export$2e2bcd8739ae039 = $89bbcb46dcd96589$var$FocusTrap;

});

parcelRequire.register("9qxob", function(module, exports) {

$parcel$export(module.exports, "getModalUtilityClass", function () { return $6dd071205866cef3$export$67960e22b12a638d; });
$parcel$export(module.exports, "default", function () { return $6dd071205866cef3$export$2e2bcd8739ae039; });

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $6dd071205866cef3$export$67960e22b12a638d(slot) {
    return (0, $auxfn.default)("MuiModal", slot);
}
const $6dd071205866cef3$var$modalClasses = (0, $dxVxC.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $6dd071205866cef3$export$2e2bcd8739ae039 = $6dd071205866cef3$var$modalClasses;

});

parcelRequire.register("eyzqE", function(module, exports) {

$parcel$export(module.exports, "useClassNamesOverride", function () { return $02bc1fe384e21021$export$b0f7603cd2f9ee15; });

var $fV3WI = parcelRequire("fV3WI");

var $3DnwL = parcelRequire("3DnwL");
const $02bc1fe384e21021$var$defaultContextValue = {
    disableDefaultClasses: false
};
const $02bc1fe384e21021$var$ClassNameConfiguratorContext = /*#__PURE__*/ $fV3WI.createContext($02bc1fe384e21021$var$defaultContextValue);
function $02bc1fe384e21021$export$b0f7603cd2f9ee15(generateUtilityClass) {
    const { disableDefaultClasses: disableDefaultClasses  } = $fV3WI.useContext($02bc1fe384e21021$var$ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return "";
        return generateUtilityClass(slot);
    };
}
function $02bc1fe384e21021$export$2e2bcd8739ae039(props) {
    const { disableDefaultClasses: disableDefaultClasses , children: children  } = props;
    const contextValue = $fV3WI.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, $3DnwL.jsx)($02bc1fe384e21021$var$ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}

});


parcelRequire.register("8qu0S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6228086d78dce54e$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $js0sS = parcelRequire("js0sS");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");

var $6PHZV = parcelRequire("6PHZV");

var $8z2vF = parcelRequire("8z2vF");

var $3DnwL = parcelRequire("3DnwL");
const $6228086d78dce54e$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $6228086d78dce54e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , invisible: invisible  } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $8z2vF.getBackdropUtilityClass), classes);
};
const $6228086d78dce54e$var$BackdropRoot = (0, $aF4Kv.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState  })=>(0, $j5tUA.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $6228086d78dce54e$var$Backdrop = /*#__PURE__*/ $fV3WI.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children , className: className , component: component = "div" , components: components = {} , componentsProps: componentsProps = {} , invisible: invisible = false , open: open , slotProps: slotProps = {} , slots: slots = {} , TransitionComponent: TransitionComponent = (0, $6PHZV.default) , transitionDuration: transitionDuration  } = props, other = (0, $64S8Y.default)(props, $6228086d78dce54e$var$_excluded);
    const ownerState = (0, $j5tUA.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $6228086d78dce54e$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $3DnwL.jsx)(TransitionComponent, (0, $j5tUA.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $3DnwL.jsx)($6228086d78dce54e$var$BackdropRoot, (0, $j5tUA.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $h0s6D.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $j5tUA.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $6228086d78dce54e$export$2e2bcd8739ae039 = $6228086d78dce54e$var$Backdrop;

});
parcelRequire.register("6PHZV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f99a28e9692946f$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $fV3WI = parcelRequire("fV3WI");


var $bzLsd = parcelRequire("bzLsd");


var $4uBZf = parcelRequire("4uBZf");

var $8Ewcq = parcelRequire("8Ewcq");

var $czyq6 = parcelRequire("czyq6");

var $3DnwL = parcelRequire("3DnwL");
const $4f99a28e9692946f$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $4f99a28e9692946f$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $4f99a28e9692946f$var$Fade = /*#__PURE__*/ $fV3WI.forwardRef(function Fade(props, ref) {
    const theme = (0, $4uBZf.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener , appear: appear = true , children: children , easing: easing , in: inProp , onEnter: onEnter , onEntered: onEntered , onEntering: onEntering , onExit: onExit , onExited: onExited , onExiting: onExiting , style: style , timeout: timeout = defaultTimeout , TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $bzLsd.default)  } = props, other = (0, $64S8Y.default)(props, $4f99a28e9692946f$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $fV3WI.useRef(null);
    const handleRef = (0, $czyq6.default)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $8Ewcq.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $8Ewcq.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $8Ewcq.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $3DnwL.jsx)(TransitionComponent, (0, $j5tUA.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $fV3WI.cloneElement(children, (0, $j5tUA.default)({
                style: (0, $j5tUA.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $4f99a28e9692946f$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $4f99a28e9692946f$export$2e2bcd8739ae039 = $4f99a28e9692946f$var$Fade;

});

parcelRequire.register("8z2vF", function(module, exports) {

$parcel$export(module.exports, "getBackdropUtilityClass", function () { return $63c389ff06159893$export$9927a91fd93152bd; });

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $63c389ff06159893$export$9927a91fd93152bd(slot) {
    return (0, $auxfn.default)("MuiBackdrop", slot);
}
const $63c389ff06159893$var$backdropClasses = (0, $dxVxC.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $63c389ff06159893$export$2e2bcd8739ae039 = $63c389ff06159893$var$backdropClasses;

});



parcelRequire.register("eKfJS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abc191fbab8cf585$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");


var $js0sS = parcelRequire("js0sS");

var $74s0b = parcelRequire("74s0b");

var $aF4Kv = parcelRequire("aF4Kv");

var $56wtS = parcelRequire("56wtS");

var $05gnM = parcelRequire("05gnM");


var $cR13i = parcelRequire("cR13i");

var $3DnwL = parcelRequire("3DnwL");
const $abc191fbab8cf585$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $abc191fbab8cf585$var$useUtilityClasses = (ownerState)=>{
    const { square: square , elevation: elevation , variant: variant , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $js0sS.default)(slots, (0, $cR13i.getPaperUtilityClass), classes);
};
const $abc191fbab8cf585$var$PaperRoot = (0, $aF4Kv.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    var _theme$vars$overlays;
    return (0, $j5tUA.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $j5tUA.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $74s0b.alpha)("#fff", (0, $56wtS.default)(ownerState.elevation))}, ${(0, $74s0b.alpha)("#fff", (0, $56wtS.default)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $abc191fbab8cf585$var$Paper = /*#__PURE__*/ $fV3WI.forwardRef(function Paper(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className , component: component = "div" , elevation: elevation = 1 , square: square = false , variant: variant = "elevation"  } = props, other = (0, $64S8Y.default)(props, $abc191fbab8cf585$var$_excluded);
    const ownerState = (0, $j5tUA.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $abc191fbab8cf585$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3DnwL.jsx)($abc191fbab8cf585$var$PaperRoot, (0, $j5tUA.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $h0s6D.default)(classes.root, className),
        ref: ref
    }, other));
});
var $abc191fbab8cf585$export$2e2bcd8739ae039 = $abc191fbab8cf585$var$Paper;

});
parcelRequire.register("56wtS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b76b55392978a2f$export$2e2bcd8739ae039; });
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $3b76b55392978a2f$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $3b76b55392978a2f$export$2e2bcd8739ae039 = $3b76b55392978a2f$var$getOverlayAlpha;

});

parcelRequire.register("cR13i", function(module, exports) {

$parcel$export(module.exports, "getPaperUtilityClass", function () { return $95bb4039c215c110$export$29cdb466b9b6f20b; });

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $95bb4039c215c110$export$29cdb466b9b6f20b(slot) {
    return (0, $auxfn.default)("MuiPaper", slot);
}
const $95bb4039c215c110$var$paperClasses = (0, $dxVxC.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $95bb4039c215c110$export$2e2bcd8739ae039 = $95bb4039c215c110$var$paperClasses;

});


parcelRequire.register("gvx9Q", function(module, exports) {

$parcel$export(module.exports, "getPopoverUtilityClass", function () { return $c0494309ca8bb0e3$export$88f455dd56c95edb; });

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $c0494309ca8bb0e3$export$88f455dd56c95edb(slot) {
    return (0, $auxfn.default)("MuiPopover", slot);
}
const $c0494309ca8bb0e3$var$popoverClasses = (0, $dxVxC.default)("MuiPopover", [
    "root",
    "paper"
]);
var $c0494309ca8bb0e3$export$2e2bcd8739ae039 = $c0494309ca8bb0e3$var$popoverClasses;

});


parcelRequire.register("1PYNf", function(module, exports) {

$parcel$export(module.exports, "getMenuUtilityClass", function () { return $1569b620cdb582e0$export$2cf86a63a84fe23d; });

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $1569b620cdb582e0$export$2cf86a63a84fe23d(slot) {
    return (0, $auxfn.default)("MuiMenu", slot);
}
const $1569b620cdb582e0$var$menuClasses = (0, $dxVxC.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $1569b620cdb582e0$export$2e2bcd8739ae039 = $1569b620cdb582e0$var$menuClasses;

});


parcelRequire.register("9Th25", function(module, exports) {

$parcel$export(module.exports, "nativeSelectSelectStyles", function () { return $733676756e21e599$export$c1eccd1617458c87; });
$parcel$export(module.exports, "nativeSelectIconStyles", function () { return $733676756e21e599$export$e7a817afd12a40d0; });
$parcel$export(module.exports, "default", function () { return $733676756e21e599$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");


var $js0sS = parcelRequire("js0sS");

var $ZXS89 = parcelRequire("ZXS89");

var $eCUn2 = parcelRequire("eCUn2");

var $aF4Kv = parcelRequire("aF4Kv");

var $3DnwL = parcelRequire("3DnwL");
const $733676756e21e599$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $733676756e21e599$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , variant: variant , disabled: disabled , multiple: multiple , open: open , error: error  } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $ZXS89.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $eCUn2.getNativeSelectUtilityClasses), classes);
};
const $733676756e21e599$export$c1eccd1617458c87 = ({ ownerState: ownerState , theme: theme  })=>(0, $j5tUA.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, $j5tUA.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $eCUn2.default).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $733676756e21e599$var$NativeSelectSelect = (0, $aF4Kv.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $aF4Kv.rootShouldForwardProp),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $eCUn2.default).multiple}`]: styles.multiple
            }
        ];
    }
})($733676756e21e599$export$c1eccd1617458c87);
const $733676756e21e599$export$e7a817afd12a40d0 = ({ ownerState: ownerState , theme: theme  })=>(0, $j5tUA.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $eCUn2.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $733676756e21e599$var$NativeSelectIcon = (0, $aF4Kv.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $ZXS89.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($733676756e21e599$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $733676756e21e599$var$NativeSelectInput = /*#__PURE__*/ $fV3WI.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className , disabled: disabled , error: error , IconComponent: IconComponent , inputRef: inputRef , variant: variant = "standard"  } = props, other = (0, $64S8Y.default)(props, $733676756e21e599$var$_excluded);
    const ownerState = (0, $j5tUA.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $733676756e21e599$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3DnwL.jsxs)($fV3WI.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3DnwL.jsx)($733676756e21e599$var$NativeSelectSelect, (0, $j5tUA.default)({
                ownerState: ownerState,
                className: (0, $h0s6D.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $3DnwL.jsx)($733676756e21e599$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $733676756e21e599$export$2e2bcd8739ae039 = $733676756e21e599$var$NativeSelectInput;

});
parcelRequire.register("eCUn2", function(module, exports) {

$parcel$export(module.exports, "getNativeSelectUtilityClasses", function () { return $aa6057578cfa0420$export$1ee13051fd9e2ab5; });
$parcel$export(module.exports, "default", function () { return $aa6057578cfa0420$export$2e2bcd8739ae039; });

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $aa6057578cfa0420$export$1ee13051fd9e2ab5(slot) {
    return (0, $auxfn.default)("MuiNativeSelect", slot);
}
const $aa6057578cfa0420$var$nativeSelectClasses = (0, $dxVxC.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $aa6057578cfa0420$export$2e2bcd8739ae039 = $aa6057578cfa0420$var$nativeSelectClasses;

});


parcelRequire.register("aK99b", function(module, exports) {

$parcel$export(module.exports, "isFilled", function () { return $7d254bb4e26c1979$export$d652b828d7fdeff8; });
$parcel$export(module.exports, "isAdornedStart", function () { return $7d254bb4e26c1979$export$1b68bdfa56faeb5d; });
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $7d254bb4e26c1979$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $7d254bb4e26c1979$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($7d254bb4e26c1979$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $7d254bb4e26c1979$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $7d254bb4e26c1979$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});

parcelRequire.register("btPGR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85ba7fbd4b07ba24$export$2e2bcd8739ae039; });

var $YB8rF = parcelRequire("YB8rF");
var $85ba7fbd4b07ba24$export$2e2bcd8739ae039 = (0, $YB8rF.default);

});
parcelRequire.register("YB8rF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b6268fdd0fcf2cd$export$2e2bcd8739ae039; });
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ 
var $fV3WI = parcelRequire("fV3WI");
function $0b6268fdd0fcf2cd$export$2e2bcd8739ae039({ controlled: controlled , default: defaultProp , name: name , state: state = "value"  }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled  } = $fV3WI.useRef(controlled !== undefined);
    const [valueState, setValue] = $fV3WI.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $fV3WI.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRequire.register("7Hm6A", function(module, exports) {

$parcel$export(module.exports, "getSelectUtilityClasses", function () { return $59adb23312b6b46f$export$2c0c1ee5a3392e; });
$parcel$export(module.exports, "default", function () { return $59adb23312b6b46f$export$2e2bcd8739ae039; });

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $59adb23312b6b46f$export$2c0c1ee5a3392e(slot) {
    return (0, $auxfn.default)("MuiSelect", slot);
}
const $59adb23312b6b46f$var$selectClasses = (0, $dxVxC.default)("MuiSelect", [
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $59adb23312b6b46f$export$2e2bcd8739ae039 = $59adb23312b6b46f$var$selectClasses;

});


parcelRequire.register("7a74J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $536ef493f0369cfe$export$2e2bcd8739ae039; });
function $536ef493f0369cfe$export$2e2bcd8739ae039({ props: props , states: states , muiFormControl: muiFormControl  }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRequire.register("24RkK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $183553720f8312ba$export$2e2bcd8739ae039; });

var $fV3WI = parcelRequire("fV3WI");

var $1mEQu = parcelRequire("1mEQu");
function $183553720f8312ba$export$2e2bcd8739ae039() {
    return $fV3WI.useContext((0, $1mEQu.default));
}

});
parcelRequire.register("1mEQu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fe78797873acddc$export$2e2bcd8739ae039; });

var $fV3WI = parcelRequire("fV3WI");
/**
 * @ignore - internal component.
 */ const $0fe78797873acddc$var$FormControlContext = /*#__PURE__*/ $fV3WI.createContext(undefined);
var $0fe78797873acddc$export$2e2bcd8739ae039 = $0fe78797873acddc$var$FormControlContext;

});


parcelRequire.register("1yAKJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $122579c44fb3d717$export$2e2bcd8739ae039; });
parcelRequire("fV3WI");

var $iEw4v = parcelRequire("iEw4v");

var $3DnwL = parcelRequire("3DnwL");
var $122579c44fb3d717$export$2e2bcd8739ae039 = (0, $iEw4v.default)(/*#__PURE__*/ (0, $3DnwL.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");

});

parcelRequire.register("ljYhS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f85a231e3e7c2c38$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $js0sS = parcelRequire("js0sS");

var $dbzFE = parcelRequire("dbzFE");

var $jOTqg = parcelRequire("jOTqg");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");

var $eMZla = parcelRequire("eMZla");

var $jOTqg = parcelRequire("jOTqg");

var $3DnwL = parcelRequire("3DnwL");
const $f85a231e3e7c2c38$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $f85a231e3e7c2c38$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disableUnderline: disableUnderline  } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $js0sS.default)(slots, (0, $eMZla.getInputUtilityClass), classes);
    return (0, $j5tUA.default)({}, classes, composedClasses);
};
const $f85a231e3e7c2c38$var$InputRoot = (0, $aF4Kv.default)((0, $jOTqg.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $aF4Kv.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            ...(0, $jOTqg.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $j5tUA.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $eMZla.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $eMZla.default).error}`]: {
            "&:before, &:after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&:before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $eMZla.default).disabled}, .${(0, $eMZla.default).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $eMZla.default).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $f85a231e3e7c2c38$var$InputInput = (0, $aF4Kv.default)((0, $jOTqg.InputBaseComponent), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $jOTqg.inputOverridesResolver)
})({});
const $f85a231e3e7c2c38$var$Input = /*#__PURE__*/ $fV3WI.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline , components: components = {} , componentsProps: componentsPropsProp , fullWidth: fullWidth = false , inputComponent: inputComponent = "input" , multiline: multiline = false , slotProps: slotProps , slots: slots = {} , type: type = "text"  } = props, other = (0, $64S8Y.default)(props, $f85a231e3e7c2c38$var$_excluded);
    const classes = $f85a231e3e7c2c38$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $dbzFE.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $f85a231e3e7c2c38$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $f85a231e3e7c2c38$var$InputInput;
    return /*#__PURE__*/ (0, $3DnwL.jsx)((0, $jOTqg.default), (0, $j5tUA.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$f85a231e3e7c2c38$var$Input.muiName = "Input";
var $f85a231e3e7c2c38$export$2e2bcd8739ae039 = $f85a231e3e7c2c38$var$Input;

});
parcelRequire.register("jOTqg", function(module, exports) {

$parcel$export(module.exports, "rootOverridesResolver", function () { return $e6ddad9964aef97e$export$965edad20a84fa75; });
$parcel$export(module.exports, "inputOverridesResolver", function () { return $e6ddad9964aef97e$export$cf507b112810e72d; });
$parcel$export(module.exports, "InputBaseRoot", function () { return $e6ddad9964aef97e$export$298a043133d72a38; });
$parcel$export(module.exports, "InputBaseComponent", function () { return $e6ddad9964aef97e$export$a1ad29c901026019; });
$parcel$export(module.exports, "default", function () { return $e6ddad9964aef97e$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $2RrcA = parcelRequire("2RrcA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $dTXtf = parcelRequire("dTXtf");
var $65pXC = parcelRequire("65pXC");
var $js0sS = parcelRequire("js0sS");

var $7a74J = parcelRequire("7a74J");

var $1mEQu = parcelRequire("1mEQu");

var $24RkK = parcelRequire("24RkK");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");

var $ZXS89 = parcelRequire("ZXS89");

var $czyq6 = parcelRequire("czyq6");

var $fR16U = parcelRequire("fR16U");

var $lbyvF = parcelRequire("lbyvF");

var $aK99b = parcelRequire("aK99b");

var $bm0ya = parcelRequire("bm0ya");

var $3DnwL = parcelRequire("3DnwL");
const $e6ddad9964aef97e$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $e6ddad9964aef97e$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState  } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $ZXS89.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $e6ddad9964aef97e$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState  } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $e6ddad9964aef97e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , color: color , disabled: disabled , error: error , endAdornment: endAdornment , focused: focused , formControl: formControl , fullWidth: fullWidth , hiddenLabel: hiddenLabel , multiline: multiline , readOnly: readOnly , size: size , startAdornment: startAdornment , type: type  } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $ZXS89.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size === "small" && "sizeSmall",
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $bm0ya.getInputBaseUtilityClass), classes);
};
const $e6ddad9964aef97e$export$298a043133d72a38 = (0, $aF4Kv.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $e6ddad9964aef97e$export$965edad20a84fa75
})(({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $bm0ya.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $j5tUA.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $e6ddad9964aef97e$export$a1ad29c901026019 = (0, $aF4Kv.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $e6ddad9964aef97e$export$cf507b112810e72d
})(({ theme: theme , ownerState: ownerState  })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, $j5tUA.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $j5tUA.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $bm0ya.default).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $bm0ya.default).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $e6ddad9964aef97e$var$inputGlobalStyles = /*#__PURE__*/ (0, $3DnwL.jsx)((0, $lbyvF.default), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $e6ddad9964aef97e$var$InputBase = /*#__PURE__*/ $fV3WI.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby , autoComplete: autoComplete , autoFocus: autoFocus , className: className , components: components = {} , componentsProps: componentsProps = {} , defaultValue: defaultValue , disabled: disabled , disableInjectingGlobalStyles: disableInjectingGlobalStyles , endAdornment: endAdornment , fullWidth: fullWidth = false , id: id , inputComponent: inputComponent = "input" , inputProps: inputPropsProp = {} , inputRef: inputRefProp , maxRows: maxRows , minRows: minRows , multiline: multiline = false , name: name , onBlur: onBlur , onChange: onChange , onClick: onClick , onFocus: onFocus , onKeyDown: onKeyDown , onKeyUp: onKeyUp , placeholder: placeholder , readOnly: readOnly , renderSuffix: renderSuffix , rows: rows , slotProps: slotProps = {} , slots: slots = {} , startAdornment: startAdornment , type: type = "text" , value: valueProp  } = props, other = (0, $64S8Y.default)(props, $e6ddad9964aef97e$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled  } = $fV3WI.useRef(value != null);
    const inputRef = $fV3WI.useRef();
    const handleInputRefWarning = $fV3WI.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $czyq6.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $fV3WI.useState(false);
    const muiFormControl = (0, $24RkK.default)();
    const fcs = (0, $7a74J.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $fV3WI.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $fV3WI.useCallback((obj)=>{
        if ((0, $aK99b.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $fR16U.default)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $2RrcA.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $fV3WI.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick && !fcs.disabled) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $j5tUA.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $j5tUA.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $65pXC.default);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $fV3WI.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $j5tUA.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $e6ddad9964aef97e$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $e6ddad9964aef97e$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $e6ddad9964aef97e$export$a1ad29c901026019;
    inputProps = (0, $j5tUA.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $3DnwL.jsxs)($fV3WI.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $e6ddad9964aef97e$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $3DnwL.jsxs)(Root, (0, $j5tUA.default)({}, rootProps, !(0, $dTXtf.default)(Root) && {
                ownerState: (0, $j5tUA.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $h0s6D.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $3DnwL.jsx)((0, $1mEQu.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $3DnwL.jsx)(Input, (0, $j5tUA.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $dTXtf.default)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $j5tUA.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $h0s6D.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $j5tUA.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $e6ddad9964aef97e$export$2e2bcd8739ae039 = $e6ddad9964aef97e$var$InputBase;

});
parcelRequire.register("65pXC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46e758eff78aed2f$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $fV3WI = parcelRequire("fV3WI");


var $fXLKn = parcelRequire("fXLKn");

var $5rLmm = parcelRequire("5rLmm");
var $3Wn11 = parcelRequire("3Wn11");
var $3kcer = parcelRequire("3kcer");
var $eFiOq = parcelRequire("eFiOq");

var $3DnwL = parcelRequire("3DnwL");
const $46e758eff78aed2f$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $46e758eff78aed2f$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $46e758eff78aed2f$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $46e758eff78aed2f$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflow;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base/react-textarea-autosize/components-api/#textarea-autosize)
 */ const $46e758eff78aed2f$var$TextareaAutosize = /*#__PURE__*/ $fV3WI.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange , maxRows: maxRows , minRows: minRows = 1 , style: style , value: value  } = props, other = (0, $64S8Y.default)(props, $46e758eff78aed2f$var$_excluded);
    const { current: isControlled  } = $fV3WI.useRef(value != null);
    const inputRef = $fV3WI.useRef(null);
    const handleRef = (0, $eFiOq.default)(forwardedRef, inputRef);
    const shadowRef = $fV3WI.useRef(null);
    const renders = $fV3WI.useRef(0);
    const [state, setState] = $fV3WI.useState({
        outerHeightStyle: 0
    });
    const getUpdatedState = $fV3WI.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $3Wn11.default)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $46e758eff78aed2f$var$getStyleValue(computedStyle.paddingBottom) + $46e758eff78aed2f$var$getStyleValue(computedStyle.paddingTop);
        const border = $46e758eff78aed2f$var$getStyleValue(computedStyle.borderBottomWidth) + $46e758eff78aed2f$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflow = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflow: overflow
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const updateState = (prevState, newState)=>{
        const { outerHeightStyle: outerHeightStyle , overflow: overflow  } = newState;
        // Need a large enough difference to update the height.
        // This prevents infinite rendering loop.
        if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
            renders.current += 1;
            return {
                overflow: overflow,
                outerHeightStyle: outerHeightStyle
            };
        }
        return prevState;
    };
    const syncHeight = $fV3WI.useCallback(()=>{
        const newState = getUpdatedState();
        if ($46e758eff78aed2f$var$isEmpty(newState)) return;
        setState((prevState)=>{
            return updateState(prevState, newState);
        });
    }, [
        getUpdatedState
    ]);
    const syncHeightWithFlushSync = ()=>{
        const newState = getUpdatedState();
        if ($46e758eff78aed2f$var$isEmpty(newState)) return;
        // In React 18, state updates in a ResizeObserver's callback are happening after the paint which causes flickering
        // when doing some visual updates in it. Using flushSync ensures that the dom will be painted after the states updates happen
        // Related issue - https://github.com/facebook/react/issues/24331
        $fXLKn.flushSync(()=>{
            setState((prevState)=>{
                return updateState(prevState, newState);
            });
        });
    };
    $fV3WI.useEffect(()=>{
        const handleResize = (0, $5rLmm.default)(()=>{
            renders.current = 0;
            // If the TextareaAutosize component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/32640
            if (inputRef.current) syncHeightWithFlushSync();
        });
        let resizeObserver;
        const input = inputRef.current;
        const containerWindow = (0, $3Wn11.default)(input);
        containerWindow.addEventListener("resize", handleResize);
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    });
    (0, $3kcer.default)(()=>{
        syncHeight();
    });
    $fV3WI.useEffect(()=>{
        renders.current = 0;
    }, [
        value
    ]);
    const handleChange = (event)=>{
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $3DnwL.jsxs)($fV3WI.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3DnwL.jsx)("textarea", (0, $j5tUA.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: (0, $j5tUA.default)({
                    height: state.outerHeightStyle,
                    // Need a large enough difference to allow scrolling.
                    // This prevents infinite rendering loop.
                    overflow: state.overflow ? "hidden" : undefined
                }, style)
            }, other)),
            /*#__PURE__*/ (0, $3DnwL.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $j5tUA.default)({}, $46e758eff78aed2f$var$styles.shadow, style, {
                    padding: 0
                })
            })
        ]
    });
});
var $46e758eff78aed2f$export$2e2bcd8739ae039 = $46e758eff78aed2f$var$TextareaAutosize;

});

parcelRequire.register("lbyvF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6c564f7f5fcf804$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");
parcelRequire("fV3WI");


var $3DhF1 = parcelRequire("3DhF1");

var $2G9ow = parcelRequire("2G9ow");

var $4owFt = parcelRequire("4owFt");

var $3DnwL = parcelRequire("3DnwL");
function $f6c564f7f5fcf804$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $3DnwL.jsx)((0, $3DhF1.default), (0, $j5tUA.default)({}, props, {
        defaultTheme: (0, $2G9ow.default),
        themeId: (0, $4owFt.default)
    }));
}
var $f6c564f7f5fcf804$export$2e2bcd8739ae039 = $f6c564f7f5fcf804$var$GlobalStyles;

});
parcelRequire.register("3DhF1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a52b6aa82317a3f$export$2e2bcd8739ae039; });
parcelRequire("fV3WI");


var $cC1Xp = parcelRequire("cC1Xp");

var $dZEln = parcelRequire("dZEln");

var $3DnwL = parcelRequire("3DnwL");
function $2a52b6aa82317a3f$var$GlobalStyles({ styles: styles , themeId: themeId , defaultTheme: defaultTheme = {}  }) {
    const upperTheme = (0, $dZEln.default)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $3DnwL.jsx)((0, $cC1Xp.default), {
        styles: globalStyles
    });
}
var $2a52b6aa82317a3f$export$2e2bcd8739ae039 = $2a52b6aa82317a3f$var$GlobalStyles;

});


parcelRequire.register("bm0ya", function(module, exports) {

$parcel$export(module.exports, "getInputBaseUtilityClass", function () { return $84422d02ce827014$export$ef57d5c8ca2278f6; });
$parcel$export(module.exports, "default", function () { return $84422d02ce827014$export$2e2bcd8739ae039; });

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $84422d02ce827014$export$ef57d5c8ca2278f6(slot) {
    return (0, $auxfn.default)("MuiInputBase", slot);
}
const $84422d02ce827014$var$inputBaseClasses = (0, $dxVxC.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $84422d02ce827014$export$2e2bcd8739ae039 = $84422d02ce827014$var$inputBaseClasses;

});


parcelRequire.register("eMZla", function(module, exports) {

$parcel$export(module.exports, "getInputUtilityClass", function () { return $ac452154e5c1405b$export$cdb270390122322b; });
$parcel$export(module.exports, "default", function () { return $ac452154e5c1405b$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");

var $bm0ya = parcelRequire("bm0ya");
function $ac452154e5c1405b$export$cdb270390122322b(slot) {
    return (0, $auxfn.default)("MuiInput", slot);
}
const $ac452154e5c1405b$var$inputClasses = (0, $j5tUA.default)({}, (0, $bm0ya.default), (0, $dxVxC.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $ac452154e5c1405b$export$2e2bcd8739ae039 = $ac452154e5c1405b$var$inputClasses;

});


parcelRequire.register("9TEpO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $734899bcece65946$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");

var $dbzFE = parcelRequire("dbzFE");


var $js0sS = parcelRequire("js0sS");

var $jOTqg = parcelRequire("jOTqg");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");

var $6DfYo = parcelRequire("6DfYo");

var $jOTqg = parcelRequire("jOTqg");

var $3DnwL = parcelRequire("3DnwL");
const $734899bcece65946$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $734899bcece65946$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disableUnderline: disableUnderline  } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $js0sS.default)(slots, (0, $6DfYo.getFilledInputUtilityClass), classes);
    return (0, $j5tUA.default)({}, classes, composedClasses);
};
const $734899bcece65946$var$FilledInputRoot = (0, $aF4Kv.default)((0, $jOTqg.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $aF4Kv.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            ...(0, $jOTqg.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, $j5tUA.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $6DfYo.default).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $6DfYo.default).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&:after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $6DfYo.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $6DfYo.default).error}`]: {
            "&:before, &:after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&:before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $6DfYo.default).disabled}, .${(0, $6DfYo.default).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $6DfYo.default).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $j5tUA.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }));
});
const $734899bcece65946$var$FilledInputInput = (0, $aF4Kv.default)((0, $jOTqg.InputBaseComponent), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $jOTqg.inputOverridesResolver)
})(({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
const $734899bcece65946$var$FilledInput = /*#__PURE__*/ $fV3WI.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {} , componentsProps: componentsPropsProp , fullWidth: fullWidth = false , inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input" , multiline: multiline = false , slotProps: slotProps , slots: slots = {} , type: type = "text"  } = props, other = (0, $64S8Y.default)(props, $734899bcece65946$var$_excluded);
    const ownerState = (0, $j5tUA.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $734899bcece65946$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $dbzFE.default)(slotProps != null ? slotProps : componentsPropsProp, filledInputComponentsProps) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $734899bcece65946$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $734899bcece65946$var$FilledInputInput;
    return /*#__PURE__*/ (0, $3DnwL.jsx)((0, $jOTqg.default), (0, $j5tUA.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$734899bcece65946$var$FilledInput.muiName = "Input";
var $734899bcece65946$export$2e2bcd8739ae039 = $734899bcece65946$var$FilledInput;

});
parcelRequire.register("6DfYo", function(module, exports) {

$parcel$export(module.exports, "getFilledInputUtilityClass", function () { return $4d42c688f26ab71e$export$3331e419f1a48437; });
$parcel$export(module.exports, "default", function () { return $4d42c688f26ab71e$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");

var $bm0ya = parcelRequire("bm0ya");
function $4d42c688f26ab71e$export$3331e419f1a48437(slot) {
    return (0, $auxfn.default)("MuiFilledInput", slot);
}
const $4d42c688f26ab71e$var$filledInputClasses = (0, $j5tUA.default)({}, (0, $bm0ya.default), (0, $dxVxC.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $4d42c688f26ab71e$export$2e2bcd8739ae039 = $4d42c688f26ab71e$var$filledInputClasses;

});


parcelRequire.register("76Hzh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52cae3a4e7893744$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");



var $js0sS = parcelRequire("js0sS");

var $hu8s2 = parcelRequire("hu8s2");

var $24RkK = parcelRequire("24RkK");

var $7a74J = parcelRequire("7a74J");

var $aF4Kv = parcelRequire("aF4Kv");

var $7uK9m = parcelRequire("7uK9m");

var $jOTqg = parcelRequire("jOTqg");

var $05gnM = parcelRequire("05gnM");

var $3DnwL = parcelRequire("3DnwL");
const $52cae3a4e7893744$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $52cae3a4e7893744$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes  } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $js0sS.default)(slots, (0, $7uK9m.getOutlinedInputUtilityClass), classes);
    return (0, $j5tUA.default)({}, classes, composedClasses);
};
const $52cae3a4e7893744$var$OutlinedInputRoot = (0, $aF4Kv.default)((0, $jOTqg.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $aF4Kv.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $jOTqg.rootOverridesResolver)
})(({ theme: theme , ownerState: ownerState  })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $j5tUA.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $7uK9m.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $7uK9m.default).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $7uK9m.default).focused} .${(0, $7uK9m.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $7uK9m.default).error} .${(0, $7uK9m.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $7uK9m.default).disabled} .${(0, $7uK9m.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $j5tUA.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $52cae3a4e7893744$var$NotchedOutlineRoot = (0, $aF4Kv.default)((0, $hu8s2.default), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme  })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $52cae3a4e7893744$var$OutlinedInputInput = (0, $aF4Kv.default)((0, $jOTqg.InputBaseComponent), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $jOTqg.inputOverridesResolver)
})(({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $52cae3a4e7893744$var$OutlinedInput = /*#__PURE__*/ $fV3WI.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {} , fullWidth: fullWidth = false , inputComponent: inputComponent = "input" , label: label , multiline: multiline = false , notched: notched , slots: slots = {} , type: type = "text"  } = props, other = (0, $64S8Y.default)(props, $52cae3a4e7893744$var$_excluded);
    const classes = $52cae3a4e7893744$var$useUtilityClasses(props);
    const muiFormControl = (0, $24RkK.default)();
    const fcs = (0, $7a74J.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "required"
        ]
    });
    const ownerState = (0, $j5tUA.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $52cae3a4e7893744$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $52cae3a4e7893744$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $3DnwL.jsx)((0, $jOTqg.default), (0, $j5tUA.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $3DnwL.jsx)($52cae3a4e7893744$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $3DnwL.jsxs)($fV3WI.Fragment, {
                    children: [
                        label,
                        " ",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $j5tUA.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$52cae3a4e7893744$var$OutlinedInput.muiName = "Input";
var $52cae3a4e7893744$export$2e2bcd8739ae039 = $52cae3a4e7893744$var$OutlinedInput;

});
parcelRequire.register("hu8s2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbabcb39f65e3f11$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");
parcelRequire("fV3WI");


var $aF4Kv = parcelRequire("aF4Kv");

var $3DnwL = parcelRequire("3DnwL");
var $cbabcb39f65e3f11$var$_span;
const $cbabcb39f65e3f11$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $cbabcb39f65e3f11$var$NotchedOutlineRoot = (0, $aF4Kv.default)("fieldset")({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $cbabcb39f65e3f11$var$NotchedOutlineLegend = (0, $aF4Kv.default)("legend")(({ ownerState: ownerState , theme: theme  })=>(0, $j5tUA.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $j5tUA.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $cbabcb39f65e3f11$export$2e2bcd8739ae039(props) {
    const { className: className , label: label , notched: notched  } = props, other = (0, $64S8Y.default)(props, $cbabcb39f65e3f11$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $j5tUA.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $3DnwL.jsx)($cbabcb39f65e3f11$var$NotchedOutlineRoot, (0, $j5tUA.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $3DnwL.jsx)($cbabcb39f65e3f11$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $3DnwL.jsx)("span", {
                children: label
            }) : $cbabcb39f65e3f11$var$_span || ($cbabcb39f65e3f11$var$_span = /*#__PURE__*/ (0, $3DnwL.jsx)("span", {
                className: "notranslate",
                children: "​"
            }))
        })
    }));
}

});

parcelRequire.register("7uK9m", function(module, exports) {

$parcel$export(module.exports, "getOutlinedInputUtilityClass", function () { return $574f222cd56306a1$export$89922944c7227687; });
$parcel$export(module.exports, "default", function () { return $574f222cd56306a1$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");

var $bm0ya = parcelRequire("bm0ya");
function $574f222cd56306a1$export$89922944c7227687(slot) {
    return (0, $auxfn.default)("MuiOutlinedInput", slot);
}
const $574f222cd56306a1$var$outlinedInputClasses = (0, $j5tUA.default)({}, (0, $bm0ya.default), (0, $dxVxC.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $574f222cd56306a1$export$2e2bcd8739ae039 = $574f222cd56306a1$var$outlinedInputClasses;

});



parcelRequire.register("6eY2U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48b2a0ba835699e8$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");


var $js0sS = parcelRequire("js0sS");

var $74s0b = parcelRequire("74s0b");

var $abEyA = parcelRequire("abEyA");

var $fYVaO = parcelRequire("fYVaO");

var $30I9e = parcelRequire("30I9e");

var $b36As = parcelRequire("b36As");

var $ZXS89 = parcelRequire("ZXS89");

var $05gnM = parcelRequire("05gnM");

var $aF4Kv = parcelRequire("aF4Kv");

var $bHpIT = parcelRequire("bHpIT");

var $3DnwL = parcelRequire("3DnwL");
const $48b2a0ba835699e8$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $48b2a0ba835699e8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , indeterminate: indeterminate , color: color  } = ownerState;
    const slots = {
        root: [
            "root",
            indeterminate && "indeterminate",
            `color${(0, $ZXS89.default)(color)}`
        ]
    };
    const composedClasses = (0, $js0sS.default)(slots, (0, $bHpIT.getCheckboxUtilityClass), classes);
    return (0, $j5tUA.default)({}, classes, composedClasses);
};
const $48b2a0ba835699e8$var$CheckboxRoot = (0, $aF4Kv.default)((0, $abEyA.default), {
    shouldForwardProp: (prop)=>(0, $aF4Kv.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiCheckbox",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            ownerState.color !== "default" && styles[`color${(0, $ZXS89.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $74s0b.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $bHpIT.default).checked}, &.${(0, $bHpIT.default).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $bHpIT.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $48b2a0ba835699e8$var$defaultCheckedIcon = /*#__PURE__*/ (0, $3DnwL.jsx)((0, $30I9e.default), {});
const $48b2a0ba835699e8$var$defaultIcon = /*#__PURE__*/ (0, $3DnwL.jsx)((0, $fYVaO.default), {});
const $48b2a0ba835699e8$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $3DnwL.jsx)((0, $b36As.default), {});
const $48b2a0ba835699e8$var$Checkbox = /*#__PURE__*/ $fV3WI.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiCheckbox"
    });
    const { checkedIcon: checkedIcon = $48b2a0ba835699e8$var$defaultCheckedIcon , color: color = "primary" , icon: iconProp = $48b2a0ba835699e8$var$defaultIcon , indeterminate: indeterminate = false , indeterminateIcon: indeterminateIconProp = $48b2a0ba835699e8$var$defaultIndeterminateIcon , inputProps: inputProps , size: size = "medium" , className: className  } = props, other = (0, $64S8Y.default)(props, $48b2a0ba835699e8$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $j5tUA.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $48b2a0ba835699e8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3DnwL.jsx)($48b2a0ba835699e8$var$CheckboxRoot, (0, $j5tUA.default)({
        type: "checkbox",
        inputProps: (0, $j5tUA.default)({
            "data-indeterminate": indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $fV3WI.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $fV3WI.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $h0s6D.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $48b2a0ba835699e8$export$2e2bcd8739ae039 = $48b2a0ba835699e8$var$Checkbox;

});
parcelRequire.register("abEyA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76aa6437faec3e51$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");


var $js0sS = parcelRequire("js0sS");

var $ZXS89 = parcelRequire("ZXS89");

var $aF4Kv = parcelRequire("aF4Kv");

var $btPGR = parcelRequire("btPGR");

var $24RkK = parcelRequire("24RkK");

var $gScpF = parcelRequire("gScpF");

var $1AE8T = parcelRequire("1AE8T");

var $3DnwL = parcelRequire("3DnwL");
const $76aa6437faec3e51$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $76aa6437faec3e51$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , checked: checked , disabled: disabled , edge: edge  } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, $ZXS89.default)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $1AE8T.getSwitchBaseUtilityClass), classes);
};
const $76aa6437faec3e51$var$SwitchBaseRoot = (0, $aF4Kv.default)((0, $gScpF.default))(({ ownerState: ownerState  })=>(0, $j5tUA.default)({
        padding: 9,
        borderRadius: "50%"
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }));
const $76aa6437faec3e51$var$SwitchBaseInput = (0, $aF4Kv.default)("input")({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $76aa6437faec3e51$var$SwitchBase = /*#__PURE__*/ $fV3WI.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus , checked: checkedProp , checkedIcon: checkedIcon , className: className , defaultChecked: defaultChecked , disabled: disabledProp , disableFocusRipple: disableFocusRipple = false , edge: edge = false , icon: icon , id: id , inputProps: inputProps , inputRef: inputRef , name: name , onBlur: onBlur , onChange: onChange , onFocus: onFocus , readOnly: readOnly , required: required = false , tabIndex: tabIndex , type: type , value: value  } = props, other = (0, $64S8Y.default)(props, $76aa6437faec3e51$var$_excluded);
    const [checked, setCheckedState] = (0, $btPGR.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, $24RkK.default)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = (0, $j5tUA.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $76aa6437faec3e51$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3DnwL.jsxs)($76aa6437faec3e51$var$SwitchBaseRoot, (0, $j5tUA.default)({
        component: "span",
        className: (0, $h0s6D.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $3DnwL.jsx)($76aa6437faec3e51$var$SwitchBaseInput, (0, $j5tUA.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === "checkbox" && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $76aa6437faec3e51$export$2e2bcd8739ae039 = $76aa6437faec3e51$var$SwitchBase;

});
parcelRequire.register("gScpF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c48b5171b14eb6f9$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");


var $js0sS = parcelRequire("js0sS");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");

var $czyq6 = parcelRequire("czyq6");

var $lLEpW = parcelRequire("lLEpW");

var $3OsDj = parcelRequire("3OsDj");

var $k9jor = parcelRequire("k9jor");

var $7sReI = parcelRequire("7sReI");

var $3DnwL = parcelRequire("3DnwL");
const $c48b5171b14eb6f9$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $c48b5171b14eb6f9$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled , focusVisible: focusVisible , focusVisibleClassName: focusVisibleClassName , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $js0sS.default)(slots, (0, $7sReI.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $c48b5171b14eb6f9$export$7ec0dcc5e3cdcd36 = (0, $aF4Kv.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $7sReI.default).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $c48b5171b14eb6f9$var$ButtonBase = /*#__PURE__*/ $fV3WI.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action , centerRipple: centerRipple = false , children: children , className: className , component: component = "button" , disabled: disabled = false , disableRipple: disableRipple = false , disableTouchRipple: disableTouchRipple = false , focusRipple: focusRipple = false , LinkComponent: LinkComponent = "a" , onBlur: onBlur , onClick: onClick , onContextMenu: onContextMenu , onDragLeave: onDragLeave , onFocus: onFocus , onFocusVisible: onFocusVisible , onKeyDown: onKeyDown , onKeyUp: onKeyUp , onMouseDown: onMouseDown , onMouseLeave: onMouseLeave , onMouseUp: onMouseUp , onTouchEnd: onTouchEnd , onTouchMove: onTouchMove , onTouchStart: onTouchStart , tabIndex: tabIndex = 0 , TouchRippleProps: TouchRippleProps , touchRippleRef: touchRippleRef , type: type  } = props, other = (0, $64S8Y.default)(props, $c48b5171b14eb6f9$var$_excluded);
    const buttonRef = $fV3WI.useRef(null);
    const rippleRef = $fV3WI.useRef(null);
    const handleRippleRef = (0, $czyq6.default)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef , onFocus: handleFocusVisible , onBlur: handleBlurVisible , ref: focusVisibleRef  } = (0, $3OsDj.default)();
    const [focusVisible, setFocusVisible] = $fV3WI.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $fV3WI.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $fV3WI.useState(false);
    $fV3WI.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $fV3WI.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $lLEpW.default)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $lLEpW.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $fV3WI.useRef(false);
    const handleKeyDown = (0, $lLEpW.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $lLEpW.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $czyq6.default)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $j5tUA.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $c48b5171b14eb6f9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3DnwL.jsxs)($c48b5171b14eb6f9$export$7ec0dcc5e3cdcd36, (0, $j5tUA.default)({
        as: ComponentProp,
        className: (0, $h0s6D.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $3DnwL.jsx)((0, $k9jor.default), (0, $j5tUA.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $c48b5171b14eb6f9$export$2e2bcd8739ae039 = $c48b5171b14eb6f9$var$ButtonBase;

});
parcelRequire.register("lLEpW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd8d56cf7dd3c7ca$export$2e2bcd8739ae039; });

var $4lsKM = parcelRequire("4lsKM");
var $fd8d56cf7dd3c7ca$export$2e2bcd8739ae039 = (0, $4lsKM.default);

});

parcelRequire.register("3OsDj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c6c40864bc9edbc$export$2e2bcd8739ae039; });

var $hvkX4 = parcelRequire("hvkX4");
var $2c6c40864bc9edbc$export$2e2bcd8739ae039 = (0, $hvkX4.default);

});
parcelRequire.register("hvkX4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbe59582961c8f3d$export$2e2bcd8739ae039; });
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $fV3WI = parcelRequire("fV3WI");
let $cbe59582961c8f3d$var$hadKeyboardEvent = true;
let $cbe59582961c8f3d$var$hadFocusVisibleRecently = false;
let $cbe59582961c8f3d$var$hadFocusVisibleRecentlyTimeout;
const $cbe59582961c8f3d$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $cbe59582961c8f3d$var$focusTriggersKeyboardModality(node) {
    const { type: type , tagName: tagName  } = node;
    if (tagName === "INPUT" && $cbe59582961c8f3d$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $cbe59582961c8f3d$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $cbe59582961c8f3d$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $cbe59582961c8f3d$var$handlePointerDown() {
    $cbe59582961c8f3d$var$hadKeyboardEvent = false;
}
function $cbe59582961c8f3d$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($cbe59582961c8f3d$var$hadFocusVisibleRecently) $cbe59582961c8f3d$var$hadKeyboardEvent = true;
    }
}
function $cbe59582961c8f3d$var$prepare(doc) {
    doc.addEventListener("keydown", $cbe59582961c8f3d$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $cbe59582961c8f3d$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $cbe59582961c8f3d$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $cbe59582961c8f3d$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $cbe59582961c8f3d$var$handleVisibilityChange, true);
}
function $cbe59582961c8f3d$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $cbe59582961c8f3d$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $cbe59582961c8f3d$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $cbe59582961c8f3d$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $cbe59582961c8f3d$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $cbe59582961c8f3d$var$handleVisibilityChange, true);
}
function $cbe59582961c8f3d$var$isFocusVisible(event) {
    const { target: target  } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $cbe59582961c8f3d$var$hadKeyboardEvent || $cbe59582961c8f3d$var$focusTriggersKeyboardModality(target);
}
function $cbe59582961c8f3d$export$2e2bcd8739ae039() {
    const ref = $fV3WI.useCallback((node)=>{
        if (node != null) $cbe59582961c8f3d$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $fV3WI.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $cbe59582961c8f3d$var$hadFocusVisibleRecently = true;
            window.clearTimeout($cbe59582961c8f3d$var$hadFocusVisibleRecentlyTimeout);
            $cbe59582961c8f3d$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(()=>{
                $cbe59582961c8f3d$var$hadFocusVisibleRecently = false;
            }, 100);
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($cbe59582961c8f3d$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}

});


parcelRequire.register("k9jor", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eab3b0fbc577e867$export$2e2bcd8739ae039; });

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $fV3WI = parcelRequire("fV3WI");


var $1GnAR = parcelRequire("1GnAR");

var $h0s6D = parcelRequire("h0s6D");

var $hhXI3 = parcelRequire("hhXI3");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");

var $2Jsgn = parcelRequire("2Jsgn");

var $5Xb9f = parcelRequire("5Xb9f");

var $3DnwL = parcelRequire("3DnwL");
const $eab3b0fbc577e867$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $eab3b0fbc577e867$var$_ = (t)=>t, $eab3b0fbc577e867$var$_t, $eab3b0fbc577e867$var$_t2, $eab3b0fbc577e867$var$_t3, $eab3b0fbc577e867$var$_t4;
const $eab3b0fbc577e867$var$DURATION = 550;
const $eab3b0fbc577e867$export$95d0c9356b2231a3 = 80;
const $eab3b0fbc577e867$var$enterKeyframe = (0, $hhXI3.keyframes)($eab3b0fbc577e867$var$_t || ($eab3b0fbc577e867$var$_t = $eab3b0fbc577e867$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $eab3b0fbc577e867$var$exitKeyframe = (0, $hhXI3.keyframes)($eab3b0fbc577e867$var$_t2 || ($eab3b0fbc577e867$var$_t2 = $eab3b0fbc577e867$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $eab3b0fbc577e867$var$pulsateKeyframe = (0, $hhXI3.keyframes)($eab3b0fbc577e867$var$_t3 || ($eab3b0fbc577e867$var$_t3 = $eab3b0fbc577e867$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $eab3b0fbc577e867$export$f6b7418508c72c25 = (0, $aF4Kv.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $eab3b0fbc577e867$export$676cfe7b12693c4b = (0, $aF4Kv.default)((0, $2Jsgn.default), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($eab3b0fbc577e867$var$_t4 || ($eab3b0fbc577e867$var$_t4 = $eab3b0fbc577e867$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $5Xb9f.default).rippleVisible, $eab3b0fbc577e867$var$enterKeyframe, $eab3b0fbc577e867$var$DURATION, ({ theme: theme  })=>theme.transitions.easing.easeInOut, (0, $5Xb9f.default).ripplePulsate, ({ theme: theme  })=>theme.transitions.duration.shorter, (0, $5Xb9f.default).child, (0, $5Xb9f.default).childLeaving, $eab3b0fbc577e867$var$exitKeyframe, $eab3b0fbc577e867$var$DURATION, ({ theme: theme  })=>theme.transitions.easing.easeInOut, (0, $5Xb9f.default).childPulsate, $eab3b0fbc577e867$var$pulsateKeyframe, ({ theme: theme  })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $eab3b0fbc577e867$var$TouchRipple = /*#__PURE__*/ $fV3WI.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false , classes: classes = {} , className: className  } = props, other = (0, $64S8Y.default)(props, $eab3b0fbc577e867$var$_excluded);
    const [ripples, setRipples] = $fV3WI.useState([]);
    const nextKey = $fV3WI.useRef(0);
    const rippleCallback = $fV3WI.useRef(null);
    $fV3WI.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $fV3WI.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = $fV3WI.useRef(null);
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $fV3WI.useRef(null);
    const container = $fV3WI.useRef(null);
    $fV3WI.useEffect(()=>{
        return ()=>{
            clearTimeout(startTimer.current);
        };
    }, []);
    const startCommit = $fV3WI.useCallback((params)=>{
        const { pulsate: pulsate , rippleX: rippleX , rippleY: rippleY , rippleSize: rippleSize , cb: cb  } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $3DnwL.jsx)($eab3b0fbc577e867$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $h0s6D.default)(classes.ripple, (0, $5Xb9f.default).ripple),
                        rippleVisible: (0, $h0s6D.default)(classes.rippleVisible, (0, $5Xb9f.default).rippleVisible),
                        ripplePulsate: (0, $h0s6D.default)(classes.ripplePulsate, (0, $5Xb9f.default).ripplePulsate),
                        child: (0, $h0s6D.default)(classes.child, (0, $5Xb9f.default).child),
                        childLeaving: (0, $h0s6D.default)(classes.childLeaving, (0, $5Xb9f.default).childLeaving),
                        childPulsate: (0, $h0s6D.default)(classes.childPulsate, (0, $5Xb9f.default).childPulsate)
                    },
                    timeout: $eab3b0fbc577e867$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $fV3WI.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false , center: center = centerProp || options.pulsate , fakeElement: fakeElement = false // For test purposes
          } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX , clientY: clientY  } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $eab3b0fbc577e867$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    const pulsate = $fV3WI.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $fV3WI.useCallback((event, cb)=>{
        clearTimeout(startTimer.current);
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $fV3WI.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $3DnwL.jsx)($eab3b0fbc577e867$export$f6b7418508c72c25, (0, $j5tUA.default)({
        className: (0, $h0s6D.default)((0, $5Xb9f.default).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $3DnwL.jsx)((0, $1GnAR.default), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $eab3b0fbc577e867$export$2e2bcd8739ae039 = $eab3b0fbc577e867$var$TouchRipple;

});
parcelRequire.register("1GnAR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $139c03e22916364b$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $9Yx8X = parcelRequire("9Yx8X");

var $cYTW9 = parcelRequire("cYTW9");


var $fV3WI = parcelRequire("fV3WI");

var $1NpCL = parcelRequire("1NpCL");

var $hNEG5 = parcelRequire("hNEG5");
var $139c03e22916364b$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $139c03e22916364b$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $139c03e22916364b$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $cYTW9.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $9Yx8X.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $hNEG5.getInitialChildMapping)(nextProps, handleExited) : (0, $hNEG5.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $hNEG5.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $j5tUA.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $64S8Y.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $139c03e22916364b$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement((0, $1NpCL.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement((0, $1NpCL.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).Component);
$139c03e22916364b$var$TransitionGroup.propTypes = {};
$139c03e22916364b$var$TransitionGroup.defaultProps = $139c03e22916364b$var$defaultProps;
var $139c03e22916364b$export$2e2bcd8739ae039 = $139c03e22916364b$var$TransitionGroup;

});
parcelRequire.register("9Yx8X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74336d3cd2922da6$export$2e2bcd8739ae039; });
function $74336d3cd2922da6$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRequire.register("hNEG5", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $cf56910684d4389b$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $cf56910684d4389b$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $cf56910684d4389b$export$36fd1af28d383ec0; });

var $fV3WI = parcelRequire("fV3WI");
function $cf56910684d4389b$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $fV3WI.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $fV3WI.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $cf56910684d4389b$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $cf56910684d4389b$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $cf56910684d4389b$export$fa71e2345c31d7a2(props, onExited) {
    return $cf56910684d4389b$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $fV3WI.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $cf56910684d4389b$var$getProp(child, "appear", props),
            enter: $cf56910684d4389b$var$getProp(child, "enter", props),
            exit: $cf56910684d4389b$var$getProp(child, "exit", props)
        });
    });
}
function $cf56910684d4389b$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $cf56910684d4389b$export$bbc8a025727ea824(nextProps.children);
    var children = $cf56910684d4389b$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $fV3WI.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $fV3WI.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $fV3WI.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $cf56910684d4389b$var$getProp(child, "exit", nextProps),
            enter: $cf56910684d4389b$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $fV3WI.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $fV3WI.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $fV3WI.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $cf56910684d4389b$var$getProp(child, "exit", nextProps),
            enter: $cf56910684d4389b$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});


parcelRequire.register("2Jsgn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fd5b536a62d2410$export$2e2bcd8739ae039; });

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $3DnwL = parcelRequire("3DnwL");
function $1fd5b536a62d2410$var$Ripple(props) {
    const { className: className , classes: classes , pulsate: pulsate = false , rippleX: rippleX , rippleY: rippleY , rippleSize: rippleSize , in: inProp , onExited: onExited , timeout: timeout  } = props;
    const [leaving, setLeaving] = $fV3WI.useState(false);
    const rippleClassName = (0, $h0s6D.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $h0s6D.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $fV3WI.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $3DnwL.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $3DnwL.jsx)("span", {
            className: childClassName
        })
    });
}
var $1fd5b536a62d2410$export$2e2bcd8739ae039 = $1fd5b536a62d2410$var$Ripple;

});

parcelRequire.register("5Xb9f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $455b1c3c0f4dfb9e$export$2e2bcd8739ae039; });

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $455b1c3c0f4dfb9e$export$b464606f735ab902(slot) {
    return (0, $auxfn.default)("MuiTouchRipple", slot);
}
const $455b1c3c0f4dfb9e$var$touchRippleClasses = (0, $dxVxC.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $455b1c3c0f4dfb9e$export$2e2bcd8739ae039 = $455b1c3c0f4dfb9e$var$touchRippleClasses;

});


parcelRequire.register("7sReI", function(module, exports) {

$parcel$export(module.exports, "getButtonBaseUtilityClass", function () { return $56f471901953a27f$export$fccb0498dcd99783; });
$parcel$export(module.exports, "default", function () { return $56f471901953a27f$export$2e2bcd8739ae039; });

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $56f471901953a27f$export$fccb0498dcd99783(slot) {
    return (0, $auxfn.default)("MuiButtonBase", slot);
}
const $56f471901953a27f$var$buttonBaseClasses = (0, $dxVxC.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $56f471901953a27f$export$2e2bcd8739ae039 = $56f471901953a27f$var$buttonBaseClasses;

});


parcelRequire.register("1AE8T", function(module, exports) {

$parcel$export(module.exports, "getSwitchBaseUtilityClass", function () { return $12884ab176e47ad6$export$baa0faa0c7ad8085; });

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $12884ab176e47ad6$export$baa0faa0c7ad8085(slot) {
    return (0, $auxfn.default)("PrivateSwitchBase", slot);
}
const $12884ab176e47ad6$var$switchBaseClasses = (0, $dxVxC.default)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
var $12884ab176e47ad6$export$2e2bcd8739ae039 = $12884ab176e47ad6$var$switchBaseClasses;

});


parcelRequire.register("fYVaO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba28cf0c5f77b374$export$2e2bcd8739ae039; });
parcelRequire("fV3WI");

var $iEw4v = parcelRequire("iEw4v");

var $3DnwL = parcelRequire("3DnwL");
var $ba28cf0c5f77b374$export$2e2bcd8739ae039 = (0, $iEw4v.default)(/*#__PURE__*/ (0, $3DnwL.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank");

});

parcelRequire.register("30I9e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23139e0f4b70ded3$export$2e2bcd8739ae039; });
parcelRequire("fV3WI");

var $iEw4v = parcelRequire("iEw4v");

var $3DnwL = parcelRequire("3DnwL");
var $23139e0f4b70ded3$export$2e2bcd8739ae039 = (0, $iEw4v.default)(/*#__PURE__*/ (0, $3DnwL.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox");

});

parcelRequire.register("b36As", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80b5159432a29c28$export$2e2bcd8739ae039; });
parcelRequire("fV3WI");

var $iEw4v = parcelRequire("iEw4v");

var $3DnwL = parcelRequire("3DnwL");
var $80b5159432a29c28$export$2e2bcd8739ae039 = (0, $iEw4v.default)(/*#__PURE__*/ (0, $3DnwL.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");

});

parcelRequire.register("bHpIT", function(module, exports) {

$parcel$export(module.exports, "getCheckboxUtilityClass", function () { return $8847a9f11e082533$export$6c57c6e16b4063b; });
$parcel$export(module.exports, "default", function () { return $8847a9f11e082533$export$2e2bcd8739ae039; });

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $8847a9f11e082533$export$6c57c6e16b4063b(slot) {
    return (0, $auxfn.default)("MuiCheckbox", slot);
}
const $8847a9f11e082533$var$checkboxClasses = (0, $dxVxC.default)("MuiCheckbox", [
    "root",
    "checked",
    "disabled",
    "indeterminate",
    "colorPrimary",
    "colorSecondary"
]);
var $8847a9f11e082533$export$2e2bcd8739ae039 = $8847a9f11e082533$var$checkboxClasses;

});


parcelRequire.register("b65DB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8144a0c6b9099815$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $1Bp3D = parcelRequire("1Bp3D");

var $js0sS = parcelRequire("js0sS");

var $74s0b = parcelRequire("74s0b");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");

var $gScpF = parcelRequire("gScpF");

var $ZXS89 = parcelRequire("ZXS89");

var $3nCdv = parcelRequire("3nCdv");

var $8dwl6 = parcelRequire("8dwl6");

var $3DnwL = parcelRequire("3DnwL");
const $8144a0c6b9099815$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $8144a0c6b9099815$var$useUtilityClasses = (ownerState)=>{
    const { color: color , disableElevation: disableElevation , fullWidth: fullWidth , size: size , variant: variant , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $ZXS89.default)(color)}`,
            `size${(0, $ZXS89.default)(size)}`,
            `${variant}Size${(0, $ZXS89.default)(size)}`,
            color === "inherit" && "colorInherit",
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "startIcon",
            `iconSize${(0, $ZXS89.default)(size)}`
        ],
        endIcon: [
            "endIcon",
            `iconSize${(0, $ZXS89.default)(size)}`
        ]
    };
    const composedClasses = (0, $js0sS.default)(slots, (0, $3nCdv.getButtonUtilityClass), classes);
    return (0, $j5tUA.default)({}, classes, composedClasses);
};
const $8144a0c6b9099815$var$commonIconStyles = (ownerState)=>(0, $j5tUA.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $8144a0c6b9099815$var$ButtonRoot = (0, $aF4Kv.default)((0, $gScpF.default), {
    shouldForwardProp: (prop)=>(0, $aF4Kv.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $ZXS89.default)(ownerState.color)}`],
            styles[`size${(0, $ZXS89.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $ZXS89.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $j5tUA.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $j5tUA.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $74s0b.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $74s0b.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $74s0b.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $j5tUA.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $3nCdv.default).focusVisible}`]: (0, $j5tUA.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $3nCdv.default).disabled}`]: (0, $j5tUA.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $74s0b.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState  })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $3nCdv.default).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $3nCdv.default).disabled}`]: {
            boxShadow: "none"
        }
    });
const $8144a0c6b9099815$var$ButtonStartIcon = (0, $aF4Kv.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $ZXS89.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState  })=>(0, $j5tUA.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $8144a0c6b9099815$var$commonIconStyles(ownerState)));
const $8144a0c6b9099815$var$ButtonEndIcon = (0, $aF4Kv.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $ZXS89.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState  })=>(0, $j5tUA.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $8144a0c6b9099815$var$commonIconStyles(ownerState)));
const $8144a0c6b9099815$var$Button = /*#__PURE__*/ $fV3WI.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $fV3WI.useContext((0, $8dwl6.default));
    const resolvedProps = (0, $1Bp3D.default)(contextProps, inProps);
    const props = (0, $05gnM.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children , color: color = "primary" , component: component = "button" , className: className , disabled: disabled = false , disableElevation: disableElevation = false , disableFocusRipple: disableFocusRipple = false , endIcon: endIconProp , focusVisibleClassName: focusVisibleClassName , fullWidth: fullWidth = false , size: size = "medium" , startIcon: startIconProp , type: type , variant: variant = "text"  } = props, other = (0, $64S8Y.default)(props, $8144a0c6b9099815$var$_excluded);
    const ownerState = (0, $j5tUA.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $8144a0c6b9099815$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $3DnwL.jsx)($8144a0c6b9099815$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $3DnwL.jsx)($8144a0c6b9099815$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    return /*#__PURE__*/ (0, $3DnwL.jsxs)($8144a0c6b9099815$var$ButtonRoot, (0, $j5tUA.default)({
        ownerState: ownerState,
        className: (0, $h0s6D.default)(contextProps.className, classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $h0s6D.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $8144a0c6b9099815$export$2e2bcd8739ae039 = $8144a0c6b9099815$var$Button;

});
parcelRequire.register("3nCdv", function(module, exports) {

$parcel$export(module.exports, "getButtonUtilityClass", function () { return $27612a2b2015bfa9$export$5a6f9035944c8119; });
$parcel$export(module.exports, "default", function () { return $27612a2b2015bfa9$export$2e2bcd8739ae039; });

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $27612a2b2015bfa9$export$5a6f9035944c8119(slot) {
    return (0, $auxfn.default)("MuiButton", slot);
}
const $27612a2b2015bfa9$var$buttonClasses = (0, $dxVxC.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $27612a2b2015bfa9$export$2e2bcd8739ae039 = $27612a2b2015bfa9$var$buttonClasses;

});

parcelRequire.register("8dwl6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fb89f91a5d112cd$export$2e2bcd8739ae039; });

var $fV3WI = parcelRequire("fV3WI");
/**
 * @ignore - internal component.
 */ const $5fb89f91a5d112cd$var$ButtonGroupContext = /*#__PURE__*/ $fV3WI.createContext({});
var $5fb89f91a5d112cd$export$2e2bcd8739ae039 = $5fb89f91a5d112cd$var$ButtonGroupContext;

});


parcelRequire.register("g32wE", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", function () { return $baeee2acf0ffd2a0$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $baeee2acf0ffd2a0$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("8ffEw")).useNavigate; });
/**
 * React Router DOM v6.12.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $fV3WI = parcelRequire("fV3WI");

var $h9h89 = parcelRequire("h9h89");
var $8ffEw = parcelRequire("8ffEw");

var $h9h89 = parcelRequire("h9h89");
function $baeee2acf0ffd2a0$var$_extends() {
    $baeee2acf0ffd2a0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $baeee2acf0ffd2a0$var$_extends.apply(this, arguments);
}
function $baeee2acf0ffd2a0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $baeee2acf0ffd2a0$var$defaultMethod = "get";
const $baeee2acf0ffd2a0$var$defaultEncType = "application/x-www-form-urlencoded";
function $baeee2acf0ffd2a0$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $baeee2acf0ffd2a0$var$isButtonElement(object) {
    return $baeee2acf0ffd2a0$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $baeee2acf0ffd2a0$var$isFormElement(object) {
    return $baeee2acf0ffd2a0$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $baeee2acf0ffd2a0$var$isInputElement(object) {
    return $baeee2acf0ffd2a0$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $baeee2acf0ffd2a0$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $baeee2acf0ffd2a0$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$baeee2acf0ffd2a0$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $baeee2acf0ffd2a0$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $baeee2acf0ffd2a0$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $baeee2acf0ffd2a0$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    }
    return searchParams;
}
function $baeee2acf0ffd2a0$var$getFormSubmissionInfo(target, options, basename) {
    let method;
    let action = null;
    let encType;
    let formData;
    if ($baeee2acf0ffd2a0$var$isFormElement(target)) {
        let submissionTrigger = options.submissionTrigger;
        if (options.action) action = options.action;
        else {
            // When grabbing the action from the element, it will have had the basename
            // prefixed to ensure non-JS scenarios work, so strip it since we'll
            // re-prefix in the router
            let attr = target.getAttribute("action");
            action = attr ? (0, $h9h89.stripBasename)(attr, basename) : null;
        }
        method = options.method || target.getAttribute("method") || $baeee2acf0ffd2a0$var$defaultMethod;
        encType = options.encType || target.getAttribute("enctype") || $baeee2acf0ffd2a0$var$defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if ($baeee2acf0ffd2a0$var$isButtonElement(target) || $baeee2acf0ffd2a0$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        if (options.action) action = options.action;
        else {
            // When grabbing the action from the element, it will have had the basename
            // prefixed to ensure non-JS scenarios work, so strip it since we'll
            // re-prefix in the router
            let attr = target.getAttribute("formaction") || form.getAttribute("action");
            action = attr ? (0, $h9h89.stripBasename)(attr, basename) : null;
        }
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || $baeee2acf0ffd2a0$var$defaultMethod;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || $baeee2acf0ffd2a0$var$defaultEncType;
        formData = new FormData(form);
        // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if ($baeee2acf0ffd2a0$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || $baeee2acf0ffd2a0$var$defaultMethod;
        action = options.action || null;
        encType = options.encType || $baeee2acf0ffd2a0$var$defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            if (target instanceof URLSearchParams) for (let [name, value] of target)formData.append(name, value);
            else if (target != null) for (let name of Object.keys(target))formData.append(name, target[name]);
        }
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData
    };
}
const $baeee2acf0ffd2a0$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $baeee2acf0ffd2a0$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $baeee2acf0ffd2a0$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative",
    "preventScrollReset"
];
function $baeee2acf0ffd2a0$export$1f3f55432a00e06d(routes, opts) {
    return (0, $h9h89.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $baeee2acf0ffd2a0$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $h9h89.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $baeee2acf0ffd2a0$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $8ffEw.UNSAFE_mapRouteProperties)
    }).initialize();
}
function $baeee2acf0ffd2a0$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $h9h89.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $baeee2acf0ffd2a0$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $h9h89.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $baeee2acf0ffd2a0$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $8ffEw.UNSAFE_mapRouteProperties)
    }).initialize();
}
function $baeee2acf0ffd2a0$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $baeee2acf0ffd2a0$var$_extends({}, state, {
        errors: $baeee2acf0ffd2a0$var$deserializeErrors(state.errors)
    });
    return state;
}
function $baeee2acf0ffd2a0$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $h9h89.ErrorResponse)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            let error = new Error(val.message);
            // Wipe away the client-side stack trace.  Nothing to fill it in with
            // because we don't serialize SSR stack traces for security reasons
            error.stack = "";
            serialized[key] = error;
        } else serialized[key] = val;
    }
    return serialized;
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $baeee2acf0ffd2a0$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename , children: children , window: window1  } = _ref;
    let historyRef = $fV3WI.useRef();
    if (historyRef.current == null) historyRef.current = (0, $h9h89.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $fV3WI.useState({
        action: history.action,
        location: history.location
    });
    let setState = $fV3WI.useCallback((newState)=>{
        "startTransition" in $fV3WI ? $fV3WI.startTransition(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl
    ]);
    $fV3WI.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $fV3WI.createElement((0, $8ffEw.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $baeee2acf0ffd2a0$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename , children: children , window: window1  } = _ref2;
    let historyRef = $fV3WI.useRef();
    if (historyRef.current == null) historyRef.current = (0, $h9h89.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $fV3WI.useState({
        action: history.action,
        location: history.location
    });
    let setState = $fV3WI.useCallback((newState)=>{
        "startTransition" in $fV3WI ? $fV3WI.startTransition(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl
    ]);
    $fV3WI.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $fV3WI.createElement((0, $8ffEw.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $baeee2acf0ffd2a0$export$eefb0c834599897e(_ref3) {
    let { basename: basename , children: children , history: history  } = _ref3;
    let [state, setStateImpl] = $fV3WI.useState({
        action: history.action,
        location: history.location
    });
    let setState = $fV3WI.useCallback((newState)=>{
        "startTransition" in $fV3WI ? $fV3WI.startTransition(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl
    ]);
    $fV3WI.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $fV3WI.createElement((0, $8ffEw.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $baeee2acf0ffd2a0$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $baeee2acf0ffd2a0$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $baeee2acf0ffd2a0$export$a6c7ac8248d6e38a = /*#__PURE__*/ $fV3WI.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick , relative: relative , reloadDocument: reloadDocument , replace: replace , state: state , target: target , to: to , preventScrollReset: preventScrollReset  } = _ref4, rest = $baeee2acf0ffd2a0$var$_objectWithoutPropertiesLoose(_ref4, $baeee2acf0ffd2a0$var$_excluded);
    let { basename: basename  } = $fV3WI.useContext((0, $8ffEw.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $baeee2acf0ffd2a0$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($baeee2acf0ffd2a0$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $h9h89.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $8ffEw.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $baeee2acf0ffd2a0$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $fV3WI.createElement("a", $baeee2acf0ffd2a0$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $baeee2acf0ffd2a0$export$b0d92dbee9b5b60d = /*#__PURE__*/ $fV3WI.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page" , caseSensitive: caseSensitive = false , className: classNameProp = "" , end: end = false , style: styleProp , to: to , children: children  } = _ref5, rest = $baeee2acf0ffd2a0$var$_objectWithoutPropertiesLoose(_ref5, $baeee2acf0ffd2a0$var$_excluded2);
    let path = (0, $8ffEw.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $8ffEw.useLocation)();
    let routerState = $fV3WI.useContext((0, $8ffEw.UNSAFE_DataRouterStateContext));
    let { navigator: navigator  } = $fV3WI.useContext((0, $8ffEw.UNSAFE_NavigationContext));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $fV3WI.createElement($baeee2acf0ffd2a0$export$a6c7ac8248d6e38a, $baeee2acf0ffd2a0$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $baeee2acf0ffd2a0$export$a7fed597f4b8afd8 = /*#__PURE__*/ $fV3WI.forwardRef((props, ref)=>{
    return /*#__PURE__*/ $fV3WI.createElement($baeee2acf0ffd2a0$var$FormImpl, $baeee2acf0ffd2a0$var$_extends({}, props, {
        ref: ref
    }));
});
const $baeee2acf0ffd2a0$var$FormImpl = /*#__PURE__*/ $fV3WI.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument , replace: replace , method: method = $baeee2acf0ffd2a0$var$defaultMethod , action: action , onSubmit: onSubmit , fetcherKey: fetcherKey , routeId: routeId , relative: relative , preventScrollReset: preventScrollReset  } = _ref6, props = $baeee2acf0ffd2a0$var$_objectWithoutPropertiesLoose(_ref6, $baeee2acf0ffd2a0$var$_excluded3);
    let submit = $baeee2acf0ffd2a0$var$useSubmitImpl(fetcherKey, routeId);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $baeee2acf0ffd2a0$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $fV3WI.createElement("form", $baeee2acf0ffd2a0$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $baeee2acf0ffd2a0$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey , storageKey: storageKey  } = _ref7;
    $baeee2acf0ffd2a0$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $baeee2acf0ffd2a0$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmitImpl"] = "useSubmitImpl";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($baeee2acf0ffd2a0$var$DataRouterHook || ($baeee2acf0ffd2a0$var$DataRouterHook = {}));
var $baeee2acf0ffd2a0$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($baeee2acf0ffd2a0$var$DataRouterStateHook || ($baeee2acf0ffd2a0$var$DataRouterStateHook = {}));
function $baeee2acf0ffd2a0$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $baeee2acf0ffd2a0$var$useDataRouterContext(hookName) {
    let ctx = $fV3WI.useContext((0, $8ffEw.UNSAFE_DataRouterContext));
    !ctx && (0, $h9h89.UNSAFE_invariant)(false);
    return ctx;
}
function $baeee2acf0ffd2a0$var$useDataRouterState(hookName) {
    let state = $fV3WI.useContext((0, $8ffEw.UNSAFE_DataRouterStateContext));
    !state && (0, $h9h89.UNSAFE_invariant)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $baeee2acf0ffd2a0$export$67621102c14d847(to, _temp) {
    let { target: target , replace: replaceProp , state: state , preventScrollReset: preventScrollReset , relative: relative  } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $8ffEw.useNavigate)();
    let location = (0, $8ffEw.useLocation)();
    let path = (0, $8ffEw.useResolvedPath)(to, {
        relative: relative
    });
    return $fV3WI.useCallback((event)=>{
        if ($baeee2acf0ffd2a0$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $h9h89.createPath)(location) === (0, $h9h89.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $baeee2acf0ffd2a0$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $fV3WI.useRef($baeee2acf0ffd2a0$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $fV3WI.useRef(false);
    let location = (0, $8ffEw.useLocation)();
    let searchParams = $fV3WI.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $baeee2acf0ffd2a0$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $8ffEw.useNavigate)();
    let setSearchParams = $fV3WI.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $baeee2acf0ffd2a0$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $baeee2acf0ffd2a0$export$47c85c6e3a081d3() {
    return $baeee2acf0ffd2a0$var$useSubmitImpl();
}
function $baeee2acf0ffd2a0$var$useSubmitImpl(fetcherKey, fetcherRouteId) {
    let { router: router  } = $baeee2acf0ffd2a0$var$useDataRouterContext($baeee2acf0ffd2a0$var$DataRouterHook.UseSubmitImpl);
    let { basename: basename  } = $fV3WI.useContext((0, $8ffEw.UNSAFE_NavigationContext));
    let currentRouteId = (0, $8ffEw.UNSAFE_useRouteId)();
    return $fV3WI.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        let { action: action , method: method , encType: encType , formData: formData  } = $baeee2acf0ffd2a0$var$getFormSubmissionInfo(target, options, basename);
        // Base options shared between fetch() and navigate()
        let opts = {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(fetcherRouteId != null) && (0, $h9h89.UNSAFE_invariant)(false);
            router.fetch(fetcherKey, fetcherRouteId, action, opts);
        } else router.navigate(action, $baeee2acf0ffd2a0$var$_extends({}, opts, {
            replace: options.replace,
            fromRouteId: currentRouteId
        }));
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $baeee2acf0ffd2a0$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative  } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename  } = $fV3WI.useContext((0, $8ffEw.UNSAFE_NavigationContext));
    let routeContext = $fV3WI.useContext((0, $8ffEw.UNSAFE_RouteContext));
    !routeContext && (0, $h9h89.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $baeee2acf0ffd2a0$var$_extends({}, (0, $8ffEw.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $8ffEw.useLocation)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $h9h89.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $h9h89.createPath)(path);
}
function $baeee2acf0ffd2a0$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $fV3WI.forwardRef((props, ref)=>{
        return /*#__PURE__*/ $fV3WI.createElement($baeee2acf0ffd2a0$var$FormImpl, $baeee2acf0ffd2a0$var$_extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
let $baeee2acf0ffd2a0$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $baeee2acf0ffd2a0$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router  } = $baeee2acf0ffd2a0$var$useDataRouterContext($baeee2acf0ffd2a0$var$DataRouterHook.UseFetcher);
    let route = $fV3WI.useContext((0, $8ffEw.UNSAFE_RouteContext));
    !route && (0, $h9h89.UNSAFE_invariant)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $h9h89.UNSAFE_invariant)(false);
    let [fetcherKey] = $fV3WI.useState(()=>String(++$baeee2acf0ffd2a0$var$fetcherId));
    let [Form] = $fV3WI.useState(()=>{
        !routeId && (0, $h9h89.UNSAFE_invariant)(false);
        return $baeee2acf0ffd2a0$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $fV3WI.useState(()=>(href)=>{
            !router && (0, $h9h89.UNSAFE_invariant)(false);
            !routeId && (0, $h9h89.UNSAFE_invariant)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $baeee2acf0ffd2a0$var$useSubmitImpl(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $fV3WI.useMemo(()=>$baeee2acf0ffd2a0$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $fV3WI.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $baeee2acf0ffd2a0$export$fa996778a3a31087() {
    let state = $baeee2acf0ffd2a0$var$useDataRouterState($baeee2acf0ffd2a0$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $baeee2acf0ffd2a0$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $baeee2acf0ffd2a0$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $baeee2acf0ffd2a0$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey , storageKey: storageKey  } = _temp3 === void 0 ? {} : _temp3;
    let { router: router  } = $baeee2acf0ffd2a0$var$useDataRouterContext($baeee2acf0ffd2a0$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition , preventScrollReset: preventScrollReset  } = $baeee2acf0ffd2a0$var$useDataRouterState($baeee2acf0ffd2a0$var$DataRouterStateHook.UseScrollRestoration);
    let location = (0, $8ffEw.useLocation)();
    let matches = (0, $8ffEw.useMatches)();
    let navigation = (0, $8ffEw.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $fV3WI.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $baeee2acf0ffd2a0$var$usePageHide($fV3WI.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $baeee2acf0ffd2a0$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $baeee2acf0ffd2a0$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($baeee2acf0ffd2a0$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $fV3WI.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $baeee2acf0ffd2a0$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $baeee2acf0ffd2a0$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $fV3WI.useLayoutEffect(()=>{
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($baeee2acf0ffd2a0$var$savedScrollPositions, ()=>window.scrollY, getKey);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $fV3WI.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $baeee2acf0ffd2a0$export$c0a586b329cae57d(callback, options) {
    let { capture: capture  } = options || {};
    $fV3WI.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $baeee2acf0ffd2a0$var$usePageHide(callback, options) {
    let { capture: capture  } = options || {};
    $fV3WI.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $baeee2acf0ffd2a0$export$39f4eb3dbd812741(_ref8) {
    let { when: when , message: message  } = _ref8;
    let blocker = (0, $8ffEw.unstable_useBlocker)(when);
    $fV3WI.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $fV3WI.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}

});
parcelRequire.register("h9h89", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $c7c090aa562a34c0$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $c7c090aa562a34c0$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $c7c090aa562a34c0$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $c7c090aa562a34c0$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $c7c090aa562a34c0$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $c7c090aa562a34c0$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $c7c090aa562a34c0$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $c7c090aa562a34c0$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $c7c090aa562a34c0$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "joinPaths", function () { return $c7c090aa562a34c0$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $c7c090aa562a34c0$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getPathContributingMatches", function () { return $c7c090aa562a34c0$export$90ba53ce1c7fdff2; });
$parcel$export(module.exports, "resolveTo", function () { return $c7c090aa562a34c0$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $c7c090aa562a34c0$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "ErrorResponse", function () { return $c7c090aa562a34c0$export$acf1a680051f5031; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $c7c090aa562a34c0$export$972111febbeef05b; });
$parcel$export(module.exports, "createRouter", function () { return $c7c090aa562a34c0$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.6.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $c7c090aa562a34c0$var$_extends() {
    $c7c090aa562a34c0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c7c090aa562a34c0$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $c7c090aa562a34c0$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($c7c090aa562a34c0$export$e19cd5f9376f8cee || ($c7c090aa562a34c0$export$e19cd5f9376f8cee = {}));
const $c7c090aa562a34c0$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $c7c090aa562a34c0$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ] , initialIndex: initialIndex , v5Compat: v5Compat = false  } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $c7c090aa562a34c0$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $c7c090aa562a34c0$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $c7c090aa562a34c0$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $c7c090aa562a34c0$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $c7c090aa562a34c0$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $c7c090aa562a34c0$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $c7c090aa562a34c0$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $c7c090aa562a34c0$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $c7c090aa562a34c0$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname , search: search , hash: hash  } = window1.location;
        return $c7c090aa562a34c0$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $c7c090aa562a34c0$export$fe53371bee54353d(to);
    }
    return $c7c090aa562a34c0$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $c7c090aa562a34c0$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/" , search: search = "" , hash: hash = ""  } = $c7c090aa562a34c0$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $c7c090aa562a34c0$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $c7c090aa562a34c0$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $c7c090aa562a34c0$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $c7c090aa562a34c0$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $c7c090aa562a34c0$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $c7c090aa562a34c0$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $c7c090aa562a34c0$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $c7c090aa562a34c0$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $c7c090aa562a34c0$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $c7c090aa562a34c0$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $c7c090aa562a34c0$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $c7c090aa562a34c0$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $c7c090aa562a34c0$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/" , search: search = "" , hash: hash = ""  } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $c7c090aa562a34c0$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $c7c090aa562a34c0$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView , v5Compat: v5Compat = false  } = options;
    let globalHistory = window1.history;
    let action = $c7c090aa562a34c0$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($c7c090aa562a34c0$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $c7c090aa562a34c0$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $c7c090aa562a34c0$export$e19cd5f9376f8cee.Push;
        let location = $c7c090aa562a34c0$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $c7c090aa562a34c0$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $c7c090aa562a34c0$export$e19cd5f9376f8cee.Replace;
        let location = $c7c090aa562a34c0$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $c7c090aa562a34c0$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $c7c090aa562a34c0$export$fe53371bee54353d(to);
        $c7c090aa562a34c0$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($c7c090aa562a34c0$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($c7c090aa562a34c0$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $c7c090aa562a34c0$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($c7c090aa562a34c0$var$ResultType || ($c7c090aa562a34c0$var$ResultType = {}));
const $c7c090aa562a34c0$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $c7c090aa562a34c0$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $c7c090aa562a34c0$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $c7c090aa562a34c0$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $c7c090aa562a34c0$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($c7c090aa562a34c0$var$isIndexRoute(route)) {
            let indexRoute = $c7c090aa562a34c0$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $c7c090aa562a34c0$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $c7c090aa562a34c0$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $c7c090aa562a34c0$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $c7c090aa562a34c0$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $c7c090aa562a34c0$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $c7c090aa562a34c0$var$flattenRoutes(routes);
    $c7c090aa562a34c0$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $c7c090aa562a34c0$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $c7c090aa562a34c0$var$safelyDecodeURI(pathname));
    return matches;
}
function $c7c090aa562a34c0$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $c7c090aa562a34c0$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $c7c090aa562a34c0$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $c7c090aa562a34c0$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $c7c090aa562a34c0$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $c7c090aa562a34c0$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $c7c090aa562a34c0$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $c7c090aa562a34c0$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $c7c090aa562a34c0$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $c7c090aa562a34c0$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $c7c090aa562a34c0$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $c7c090aa562a34c0$var$paramRe = /^:\w+$/;
const $c7c090aa562a34c0$var$dynamicSegmentValue = 3;
const $c7c090aa562a34c0$var$indexRouteValue = 2;
const $c7c090aa562a34c0$var$emptySegmentValue = 1;
const $c7c090aa562a34c0$var$staticSegmentValue = 10;
const $c7c090aa562a34c0$var$splatPenalty = -2;
const $c7c090aa562a34c0$var$isSplat = (s)=>s === "*";
function $c7c090aa562a34c0$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($c7c090aa562a34c0$var$isSplat)) initialScore += $c7c090aa562a34c0$var$splatPenalty;
    if (index) initialScore += $c7c090aa562a34c0$var$indexRouteValue;
    return segments.filter((s)=>!$c7c090aa562a34c0$var$isSplat(s)).reduce((score, segment)=>score + ($c7c090aa562a34c0$var$paramRe.test(segment) ? $c7c090aa562a34c0$var$dynamicSegmentValue : segment === "" ? $c7c090aa562a34c0$var$emptySegmentValue : $c7c090aa562a34c0$var$staticSegmentValue), initialScore);
}
function $c7c090aa562a34c0$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $c7c090aa562a34c0$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta  } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $c7c090aa562a34c0$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $c7c090aa562a34c0$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $c7c090aa562a34c0$export$a5c6d149b50c1d86($c7c090aa562a34c0$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $c7c090aa562a34c0$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $c7c090aa562a34c0$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $c7c090aa562a34c0$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            const starParam = params[star];
            // Apply the splat
            return starParam;
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            if (optional === "?") return param == null ? "" : param;
            if (param == null) $c7c090aa562a34c0$export$3e9cee6b33872309(false, 'Missing ":' + key + '" param');
            return param;
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $c7c090aa562a34c0$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $c7c090aa562a34c0$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $c7c090aa562a34c0$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $c7c090aa562a34c0$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $c7c090aa562a34c0$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $c7c090aa562a34c0$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $c7c090aa562a34c0$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $c7c090aa562a34c0$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $c7c090aa562a34c0$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $c7c090aa562a34c0$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $c7c090aa562a34c0$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname , search: search = "" , hash: hash = ""  } = typeof to === "string" ? $c7c090aa562a34c0$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $c7c090aa562a34c0$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $c7c090aa562a34c0$var$normalizeSearch(search),
        hash: $c7c090aa562a34c0$var$normalizeHash(hash)
    };
}
function $c7c090aa562a34c0$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $c7c090aa562a34c0$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $c7c090aa562a34c0$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $c7c090aa562a34c0$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $c7c090aa562a34c0$export$8ccf933b0513f8d0(toArg);
    else {
        to = $c7c090aa562a34c0$var$_extends({}, toArg);
        $c7c090aa562a34c0$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $c7c090aa562a34c0$var$getInvalidPathError("?", "pathname", "search", to));
        $c7c090aa562a34c0$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $c7c090aa562a34c0$var$getInvalidPathError("#", "pathname", "hash", to));
        $c7c090aa562a34c0$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $c7c090aa562a34c0$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $c7c090aa562a34c0$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $c7c090aa562a34c0$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $c7c090aa562a34c0$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $c7c090aa562a34c0$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $c7c090aa562a34c0$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $c7c090aa562a34c0$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $c7c090aa562a34c0$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $c7c090aa562a34c0$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $c7c090aa562a34c0$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $c7c090aa562a34c0$export$42a99a7a4bc0e76a extends Error {
}
class $c7c090aa562a34c0$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $c7c090aa562a34c0$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $c7c090aa562a34c0$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $c7c090aa562a34c0$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $c7c090aa562a34c0$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $c7c090aa562a34c0$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $c7c090aa562a34c0$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $c7c090aa562a34c0$var$unwrapTrackedPromise(value) {
    if (!$c7c090aa562a34c0$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $c7c090aa562a34c0$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $c7c090aa562a34c0$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $c7c090aa562a34c0$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $c7c090aa562a34c0$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $c7c090aa562a34c0$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $c7c090aa562a34c0$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $c7c090aa562a34c0$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $c7c090aa562a34c0$var$validMutationMethods = new Set($c7c090aa562a34c0$var$validMutationMethodsArr);
const $c7c090aa562a34c0$var$validRequestMethodsArr = [
    "get",
    ...$c7c090aa562a34c0$var$validMutationMethodsArr
];
const $c7c090aa562a34c0$var$validRequestMethods = new Set($c7c090aa562a34c0$var$validRequestMethodsArr);
const $c7c090aa562a34c0$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $c7c090aa562a34c0$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $c7c090aa562a34c0$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $c7c090aa562a34c0$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $c7c090aa562a34c0$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $c7c090aa562a34c0$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $c7c090aa562a34c0$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $c7c090aa562a34c0$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $c7c090aa562a34c0$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $c7c090aa562a34c0$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $c7c090aa562a34c0$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $c7c090aa562a34c0$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $c7c090aa562a34c0$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $c7c090aa562a34c0$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches , route: route  } = $c7c090aa562a34c0$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $c7c090aa562a34c0$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $c7c090aa562a34c0$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction , location: location , delta: delta  } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $c7c090aa562a34c0$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        deleteBlocker(blockerKey);
                        updateState({
                            blockers: new Map(router.state.blockers)
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($c7c090aa562a34c0$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $c7c090aa562a34c0$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $c7c090aa562a34c0$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $c7c090aa562a34c0$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        for (let [key] of blockerFunctions)deleteBlocker(key);
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $c7c090aa562a34c0$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        updateState($c7c090aa562a34c0$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $c7c090aa562a34c0$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: new Map(state.blockers)
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $c7c090aa562a34c0$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $c7c090aa562a34c0$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $c7c090aa562a34c0$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        // Reset stateful navigation vars
        pendingAction = $c7c090aa562a34c0$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $c7c090aa562a34c0$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path , submission: submission , error: error  } = $c7c090aa562a34c0$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $c7c090aa562a34c0$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $c7c090aa562a34c0$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $c7c090aa562a34c0$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $c7c090aa562a34c0$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $c7c090aa562a34c0$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $c7c090aa562a34c0$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    deleteBlocker(blockerKey);
                    updateState({
                        blockers: new Map(state.blockers)
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $c7c090aa562a34c0$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $c7c090aa562a34c0$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches , route: route  } = $c7c090aa562a34c0$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $c7c090aa562a34c0$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $c7c090aa562a34c0$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $c7c090aa562a34c0$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$c7c090aa562a34c0$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $c7c090aa562a34c0$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            let navigation = $c7c090aa562a34c0$var$_extends({
                state: "loading",
                location: location
            }, opts.submission);
            loadingNavigation = navigation;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited , loaderData: loaderData , errors: errors  } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $c7c090aa562a34c0$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $c7c090aa562a34c0$var$_extends({
            state: "submitting",
            location: location
        }, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $c7c090aa562a34c0$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $c7c090aa562a34c0$var$ResultType.error,
            error: $c7c090aa562a34c0$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $c7c090aa562a34c0$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($c7c090aa562a34c0$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($c7c090aa562a34c0$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $c7c090aa562a34c0$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $c7c090aa562a34c0$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($c7c090aa562a34c0$var$isDeferredResult(result)) throw $c7c090aa562a34c0$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation;
        if (!loadingNavigation) {
            let navigation = $c7c090aa562a34c0$var$_extends({
                state: "loading",
                location: location,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            }, submission);
            loadingNavigation = navigation;
        }
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission ? submission || fetcherSubmission : loadingNavigation.formMethod && loadingNavigation.formAction && loadingNavigation.formData && loadingNavigation.formEncType ? {
            formMethod: loadingNavigation.formMethod,
            formAction: loadingNavigation.formAction,
            formData: loadingNavigation.formData,
            formEncType: loadingNavigation.formEncType
        } : undefined;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $c7c090aa562a34c0$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $c7c090aa562a34c0$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = {
                    state: "loading",
                    data: fetcher && fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined,
                    " _hasFetcherDoneAnything ": true
                };
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($c7c090aa562a34c0$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((rf)=>{
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results , loaderResults: loaderResults , fetcherResults: fetcherResults  } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $c7c090aa562a34c0$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData , errors: errors  } = $c7c090aa562a34c0$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $c7c090aa562a34c0$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $c7c090aa562a34c0$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $c7c090aa562a34c0$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $c7c090aa562a34c0$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $c7c090aa562a34c0$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path , submission: submission  } = $c7c090aa562a34c0$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        let match = $c7c090aa562a34c0$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $c7c090aa562a34c0$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $c7c090aa562a34c0$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $c7c090aa562a34c0$var$_extends({
            state: "submitting"
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $c7c090aa562a34c0$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $c7c090aa562a34c0$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($c7c090aa562a34c0$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $c7c090aa562a34c0$var$_extends({
                state: "loading"
            }, submission, {
                data: undefined,
                " _hasFetcherDoneAnything ": true
            });
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult, {
                submission: submission,
                isFetchActionRedirect: true
            });
        }
        // Process any non-redirect errors thrown
        if ($c7c090aa562a34c0$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($c7c090aa562a34c0$var$isDeferredResult(actionResult)) throw $c7c090aa562a34c0$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $c7c090aa562a34c0$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $c7c090aa562a34c0$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $c7c090aa562a34c0$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $c7c090aa562a34c0$var$_extends({
            state: "loading",
            data: actionResult.data
        }, submission, {
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $c7c090aa562a34c0$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = {
                state: "loading",
                data: existingFetcher && existingFetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results , loaderResults: loaderResults , fetcherResults: fetcherResults  } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $c7c090aa562a34c0$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
        // Process and commit output from loaders
        let { loaderData: loaderData , errors: errors  } = $c7c090aa562a34c0$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = {
                state: "idle",
                data: actionResult.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $c7c090aa562a34c0$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($c7c090aa562a34c0$var$_extends({
                errors: errors,
                loaderData: $c7c090aa562a34c0$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $c7c090aa562a34c0$var$_extends({
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $c7c090aa562a34c0$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $c7c090aa562a34c0$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($c7c090aa562a34c0$var$isDeferredResult(result)) result = await $c7c090aa562a34c0$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($c7c090aa562a34c0$var$isRedirectResult(result)) {
            fetchRedirectIds.add(key);
            await startRedirectNavigation(state, result);
            return;
        }
        // Process any non-redirect errors thrown
        if ($c7c090aa562a34c0$var$isErrorResult(result)) {
            let boundaryMatch = $c7c090aa562a34c0$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $c7c090aa562a34c0$export$3e9cee6b33872309(!$c7c090aa562a34c0$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = {
            state: "idle",
            data: result.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission , replace: replace , isFetchActionRedirect: isFetchActionRedirect  } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $c7c090aa562a34c0$var$createLocation(state.location, redirect.location, $c7c090aa562a34c0$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $c7c090aa562a34c0$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        // Check if this an absolute external redirect that goes to a new origin
        if ($c7c090aa562a34c0$var$ABSOLUTE_URL_REGEX.test(redirect.location) && isBrowser) {
            let url = init.history.createURL(redirect.location);
            let isDifferentBasename = $c7c090aa562a34c0$export$b69e3301ce081aa3(url.pathname, basename) == null;
            if (routerWindow.location.origin !== url.origin || isDifferentBasename) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $c7c090aa562a34c0$export$e19cd5f9376f8cee.Replace : $c7c090aa562a34c0$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod , formAction: formAction , formEncType: formEncType , formData: formData  } = state.navigation;
        if (!submission && formMethod && formAction && formData && formEncType) submission = {
            formMethod: formMethod,
            formAction: formAction,
            formEncType: formEncType,
            formData: formData
        };
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($c7c090aa562a34c0$var$redirectPreserveMethodStatusCodes.has(redirect.status) && submission && $c7c090aa562a34c0$var$isMutationMethod(submission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $c7c090aa562a34c0$var$_extends({}, submission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else if (isFetchActionRedirect) // For a fetch action redirect, we kick off a new loading navigation
        // without the fetcher submission, but we send it along for shouldRevalidate
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            },
            fetcherSubmission: submission,
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else // Otherwise, we kick off a new loading navigation, preserving the
        // submission info for the duration of this navigation
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: submission ? submission.formMethod : undefined,
                formAction: submission ? submission.formAction : undefined,
                formEncType: submission ? submission.formEncType : undefined,
                formData: submission ? submission.formData : undefined
            },
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$c7c090aa562a34c0$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $c7c090aa562a34c0$var$callLoaderOrAction("loader", $c7c090aa562a34c0$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $c7c090aa562a34c0$var$ResultType.error,
                        error: $c7c090aa562a34c0$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $c7c090aa562a34c0$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $c7c090aa562a34c0$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $c7c090aa562a34c0$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $c7c090aa562a34c0$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = {
                state: "idle",
                data: fetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $c7c090aa562a34c0$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $c7c090aa562a34c0$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $c7c090aa562a34c0$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $c7c090aa562a34c0$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $c7c090aa562a34c0$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        state.blockers.set(key, newBlocker);
        updateState({
            blockers: new Map(state.blockers)
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation , nextLocation: nextLocation , historyAction: historyAction  } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $c7c090aa562a34c0$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || ((location)=>location.key);
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $c7c090aa562a34c0$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$c7c090aa562a34c0$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$c7c090aa562a34c0$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $c7c090aa562a34c0$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $c7c090aa562a34c0$export$4d0306f8f6a4585b = Symbol("deferred");
function $c7c090aa562a34c0$export$3336b097a6fbc59a(routes, opts) {
    $c7c090aa562a34c0$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $c7c090aa562a34c0$var$defaultMapRouteProperties;
    let dataRoutes = $c7c090aa562a34c0$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext  } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $c7c090aa562a34c0$var$createLocation("", $c7c090aa562a34c0$export$fe53371bee54353d(url), null, "default");
        let matches = $c7c090aa562a34c0$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$c7c090aa562a34c0$var$isValidMethod(method) && method !== "HEAD") {
            let error = $c7c090aa562a34c0$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches , route: route  } = $c7c090aa562a34c0$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $c7c090aa562a34c0$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches , route: route  } = $c7c090aa562a34c0$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($c7c090aa562a34c0$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $c7c090aa562a34c0$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId , requestContext: requestContext  } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $c7c090aa562a34c0$var$createLocation("", $c7c090aa562a34c0$export$fe53371bee54353d(url), null, "default");
        let matches = $c7c090aa562a34c0$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$c7c090aa562a34c0$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $c7c090aa562a34c0$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $c7c090aa562a34c0$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $c7c090aa562a34c0$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $c7c090aa562a34c0$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $c7c090aa562a34c0$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($c7c090aa562a34c0$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$c7c090aa562a34c0$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $c7c090aa562a34c0$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($c7c090aa562a34c0$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $c7c090aa562a34c0$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $c7c090aa562a34c0$var$isResponse(result) ? result : $c7c090aa562a34c0$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($c7c090aa562a34c0$var$isQueryRouteResponse(e)) {
                if (e.type === $c7c090aa562a34c0$var$ResultType.error && !$c7c090aa562a34c0$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($c7c090aa562a34c0$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $c7c090aa562a34c0$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $c7c090aa562a34c0$var$ResultType.error,
                error: error
            };
        } else {
            result = await $c7c090aa562a34c0$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, true, isRouteRequest, requestContext);
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($c7c090aa562a34c0$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($c7c090aa562a34c0$var$isDeferredResult(result)) {
            let error = $c7c090aa562a34c0$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $c7c090aa562a34c0$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($c7c090aa562a34c0$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($c7c090aa562a34c0$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $c7c090aa562a34c0$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $c7c090aa562a34c0$var$_extends({}, context, {
                statusCode: $c7c090aa562a34c0$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $c7c090aa562a34c0$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $c7c090aa562a34c0$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $c7c090aa562a34c0$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $c7c090aa562a34c0$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $c7c090aa562a34c0$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$c7c090aa562a34c0$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, true, isRouteRequest, requestContext))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $c7c090aa562a34c0$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $c7c090aa562a34c0$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $c7c090aa562a34c0$export$fec11da027c70692(routes, context, error) {
    let newContext = $c7c090aa562a34c0$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $c7c090aa562a34c0$var$isSubmissionNavigation(opts) {
    return opts != null && "formData" in opts;
}
function $c7c090aa562a34c0$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $c7c090aa562a34c0$export$cae722b0cc860f13(to ? to : ".", $c7c090aa562a34c0$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $c7c090aa562a34c0$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$c7c090aa562a34c0$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $c7c090aa562a34c0$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $c7c090aa562a34c0$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $c7c090aa562a34c0$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$c7c090aa562a34c0$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$c7c090aa562a34c0$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $c7c090aa562a34c0$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    // Create a Submission on non-GET navigations
    let submission;
    if (opts.formData) {
        let formMethod = opts.formMethod || "get";
        submission = {
            formMethod: normalizeFormMethod ? formMethod.toUpperCase() : formMethod.toLowerCase(),
            formAction: $c7c090aa562a34c0$var$stripHashFromPath(path),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        };
        if ($c7c090aa562a34c0$var$isMutationMethod(submission.formMethod)) return {
            path: path,
            submission: submission
        };
    }
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $c7c090aa562a34c0$export$8ccf933b0513f8d0(path);
    let searchParams = $c7c090aa562a34c0$var$convertFormDataToSearchParams(opts.formData);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $c7c090aa562a34c0$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $c7c090aa562a34c0$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $c7c090aa562a34c0$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $c7c090aa562a34c0$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $c7c090aa562a34c0$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($c7c090aa562a34c0$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $c7c090aa562a34c0$var$shouldRevalidateLoader(match, $c7c090aa562a34c0$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $c7c090aa562a34c0$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $c7c090aa562a34c0$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        let fetcherMatch = $c7c090aa562a34c0$var$getTargetMatch(fetcherMatches, f.path);
        if (cancelledFetcherLoads.includes(key)) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: fetcherMatches,
                match: fetcherMatch,
                controller: new AbortController()
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // hit a static href, so they _always_ check shouldRevalidate and the
        // default is strictly if a revalidation is explicitly required (action
        // submissions, useRevalidator, X-Remix-Revalidate).
        let shouldRevalidate = $c7c090aa562a34c0$var$shouldRevalidateLoader(fetcherMatch, $c7c090aa562a34c0$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $c7c090aa562a34c0$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $c7c090aa562a34c0$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $c7c090aa562a34c0$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $c7c090aa562a34c0$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $c7c090aa562a34c0$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $c7c090aa562a34c0$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$c7c090aa562a34c0$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $c7c090aa562a34c0$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $c7c090aa562a34c0$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, isStaticRequest, isRouteRequest, requestContext) {
    if (isStaticRequest === void 0) isStaticRequest = false;
    if (isRouteRequest === void 0) isRouteRequest = false;
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let values = await Promise.all([
                    runHandler(handler),
                    $c7c090aa562a34c0$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $c7c090aa562a34c0$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $c7c090aa562a34c0$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $c7c090aa562a34c0$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $c7c090aa562a34c0$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $c7c090aa562a34c0$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $c7c090aa562a34c0$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($c7c090aa562a34c0$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($c7c090aa562a34c0$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $c7c090aa562a34c0$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$c7c090aa562a34c0$var$ABSOLUTE_URL_REGEX.test(location)) location = $c7c090aa562a34c0$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $c7c090aa562a34c0$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $c7c090aa562a34c0$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $c7c090aa562a34c0$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $c7c090aa562a34c0$var$ResultType.error) return {
            type: resultType,
            error: new $c7c090aa562a34c0$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $c7c090aa562a34c0$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $c7c090aa562a34c0$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($c7c090aa562a34c0$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $c7c090aa562a34c0$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $c7c090aa562a34c0$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $c7c090aa562a34c0$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($c7c090aa562a34c0$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $c7c090aa562a34c0$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod , formEncType: formEncType , formData: formData  } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? $c7c090aa562a34c0$var$convertFormDataToSearchParams(formData) : formData;
    }
    // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function $c7c090aa562a34c0$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, value instanceof File ? value.name : value);
    return searchParams;
}
function $c7c090aa562a34c0$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $c7c090aa562a34c0$export$3e9cee6b33872309(!$c7c090aa562a34c0$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($c7c090aa562a34c0$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $c7c090aa562a34c0$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $c7c090aa562a34c0$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($c7c090aa562a34c0$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $c7c090aa562a34c0$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData , errors: errors  } = $c7c090aa562a34c0$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key , match: match , controller: controller  } = revalidatingFetchers[index];
        $c7c090aa562a34c0$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($c7c090aa562a34c0$var$isErrorResult(result)) {
            let boundaryMatch = $c7c090aa562a34c0$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $c7c090aa562a34c0$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($c7c090aa562a34c0$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $c7c090aa562a34c0$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($c7c090aa562a34c0$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $c7c090aa562a34c0$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $c7c090aa562a34c0$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $c7c090aa562a34c0$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $c7c090aa562a34c0$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $c7c090aa562a34c0$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $c7c090aa562a34c0$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname , routeId: routeId , method: method , type: type  } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $c7c090aa562a34c0$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $c7c090aa562a34c0$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($c7c090aa562a34c0$var$isRedirectResult(result)) return result;
    }
}
function $c7c090aa562a34c0$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $c7c090aa562a34c0$export$8ccf933b0513f8d0(path) : path;
    return $c7c090aa562a34c0$export$fe53371bee54353d($c7c090aa562a34c0$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $c7c090aa562a34c0$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $c7c090aa562a34c0$var$isDeferredResult(result) {
    return result.type === $c7c090aa562a34c0$var$ResultType.deferred;
}
function $c7c090aa562a34c0$var$isErrorResult(result) {
    return result.type === $c7c090aa562a34c0$var$ResultType.error;
}
function $c7c090aa562a34c0$var$isRedirectResult(result) {
    return (result && result.type) === $c7c090aa562a34c0$var$ResultType.redirect;
}
function $c7c090aa562a34c0$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $c7c090aa562a34c0$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $c7c090aa562a34c0$var$isRedirectResponse(result) {
    if (!$c7c090aa562a34c0$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $c7c090aa562a34c0$var$isQueryRouteResponse(obj) {
    return obj && $c7c090aa562a34c0$var$isResponse(obj.response) && (obj.type === $c7c090aa562a34c0$var$ResultType.data || $c7c090aa562a34c0$var$ResultType.error);
}
function $c7c090aa562a34c0$var$isValidMethod(method) {
    return $c7c090aa562a34c0$var$validRequestMethods.has(method.toLowerCase());
}
function $c7c090aa562a34c0$var$isMutationMethod(method) {
    return $c7c090aa562a34c0$var$validMutationMethods.has(method.toLowerCase());
}
async function $c7c090aa562a34c0$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$c7c090aa562a34c0$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($c7c090aa562a34c0$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $c7c090aa562a34c0$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $c7c090aa562a34c0$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $c7c090aa562a34c0$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $c7c090aa562a34c0$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $c7c090aa562a34c0$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $c7c090aa562a34c0$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $c7c090aa562a34c0$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
// Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $c7c090aa562a34c0$var$createUseMatchesMatch(match, loaderData) {
    let { route: route , pathname: pathname , params: params  } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $c7c090aa562a34c0$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $c7c090aa562a34c0$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $c7c090aa562a34c0$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $c7c090aa562a34c0$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}

});

parcelRequire.register("8ffEw", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $600bddb47034aa11$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $600bddb47034aa11$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $600bddb47034aa11$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $600bddb47034aa11$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $600bddb47034aa11$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $600bddb47034aa11$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $600bddb47034aa11$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useMatch", function () { return $600bddb47034aa11$export$6c330e8992e8a295; });
$parcel$export(module.exports, "useNavigate", function () { return $600bddb47034aa11$export$9770f232ac06a008; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $600bddb47034aa11$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $600bddb47034aa11$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $600bddb47034aa11$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "unstable_useBlocker", function () { return $600bddb47034aa11$export$2af03a1de5c0910; });
$parcel$export(module.exports, "Router", function () { return $600bddb47034aa11$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Navigate", function () { return $600bddb47034aa11$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Route", function () { return $600bddb47034aa11$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $600bddb47034aa11$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $600bddb47034aa11$export$52b333d321859367; });
/**
 * React Router v6.12.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $fV3WI = parcelRequire("fV3WI");

var $h9h89 = parcelRequire("h9h89");
function $600bddb47034aa11$var$_extends() {
    $600bddb47034aa11$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $600bddb47034aa11$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $600bddb47034aa11$export$3add0d5dce533e2e = /*#__PURE__*/ $fV3WI.createContext(null);
const $600bddb47034aa11$export$145dfa71566a64dc = /*#__PURE__*/ $fV3WI.createContext(null);
const $600bddb47034aa11$var$AwaitContext = /*#__PURE__*/ $fV3WI.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $600bddb47034aa11$export$26749e8557646306 = /*#__PURE__*/ $fV3WI.createContext(null);
const $600bddb47034aa11$export$c7914228fb69b0f5 = /*#__PURE__*/ $fV3WI.createContext(null);
const $600bddb47034aa11$export$9072aa6dd1f93057 = /*#__PURE__*/ $fV3WI.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $600bddb47034aa11$var$RouteErrorContext = /*#__PURE__*/ $fV3WI.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $600bddb47034aa11$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative  } = _temp === void 0 ? {} : _temp;
    !$600bddb47034aa11$export$9c954a9d03d32f4a() && (0, $h9h89.UNSAFE_invariant)(false);
    let { basename: basename , navigator: navigator  } = $fV3WI.useContext($600bddb47034aa11$export$26749e8557646306);
    let { hash: hash , pathname: pathname , search: search  } = $600bddb47034aa11$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $h9h89.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $600bddb47034aa11$export$9c954a9d03d32f4a() {
    return $fV3WI.useContext($600bddb47034aa11$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $600bddb47034aa11$export$45d76561a5302f2b() {
    !$600bddb47034aa11$export$9c954a9d03d32f4a() && (0, $h9h89.UNSAFE_invariant)(false);
    return $fV3WI.useContext($600bddb47034aa11$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $600bddb47034aa11$export$1b3f31771c5d07c() {
    return $fV3WI.useContext($600bddb47034aa11$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $600bddb47034aa11$export$6c330e8992e8a295(pattern) {
    !$600bddb47034aa11$export$9c954a9d03d32f4a() && (0, $h9h89.UNSAFE_invariant)(false);
    let { pathname: pathname  } = $600bddb47034aa11$export$45d76561a5302f2b();
    return $fV3WI.useMemo(()=>(0, $h9h89.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $600bddb47034aa11$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $600bddb47034aa11$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $fV3WI.useContext($600bddb47034aa11$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $fV3WI.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $600bddb47034aa11$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute  } = $fV3WI.useContext($600bddb47034aa11$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $600bddb47034aa11$var$useNavigateStable() : $600bddb47034aa11$var$useNavigateUnstable();
}
function $600bddb47034aa11$var$useNavigateUnstable() {
    !$600bddb47034aa11$export$9c954a9d03d32f4a() && (0, $h9h89.UNSAFE_invariant)(false);
    let dataRouterContext = $fV3WI.useContext($600bddb47034aa11$export$3add0d5dce533e2e);
    let { basename: basename , navigator: navigator  } = $fV3WI.useContext($600bddb47034aa11$export$26749e8557646306);
    let { matches: matches  } = $fV3WI.useContext($600bddb47034aa11$export$9072aa6dd1f93057);
    let { pathname: locationPathname  } = $600bddb47034aa11$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $h9h89.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    let activeRef = $fV3WI.useRef(false);
    $600bddb47034aa11$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $fV3WI.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $h9h89.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $h9h89.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $600bddb47034aa11$var$OutletContext = /*#__PURE__*/ $fV3WI.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $600bddb47034aa11$export$4138103a3ae699cc() {
    return $fV3WI.useContext($600bddb47034aa11$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $600bddb47034aa11$export$a3be3530d8e40d0b(context) {
    let outlet = $fV3WI.useContext($600bddb47034aa11$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $fV3WI.createElement($600bddb47034aa11$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $600bddb47034aa11$export$99eaa27ddbbb95ef() {
    let { matches: matches  } = $fV3WI.useContext($600bddb47034aa11$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $600bddb47034aa11$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative  } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches  } = $fV3WI.useContext($600bddb47034aa11$export$9072aa6dd1f93057);
    let { pathname: locationPathname  } = $600bddb47034aa11$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $h9h89.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    return $fV3WI.useMemo(()=>(0, $h9h89.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $600bddb47034aa11$export$5d3fca4a98652595(routes, locationArg) {
    return $600bddb47034aa11$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $600bddb47034aa11$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$600bddb47034aa11$export$9c954a9d03d32f4a() && (0, $h9h89.UNSAFE_invariant)(false);
    let { navigator: navigator  } = $fV3WI.useContext($600bddb47034aa11$export$26749e8557646306);
    let { matches: parentMatches  } = $fV3WI.useContext($600bddb47034aa11$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $600bddb47034aa11$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $h9h89.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $h9h89.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $h9h89.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $600bddb47034aa11$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $h9h89.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $h9h89.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $fV3WI.createElement($600bddb47034aa11$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $600bddb47034aa11$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $h9h89.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $600bddb47034aa11$var$DefaultErrorComponent() {
    let error = $600bddb47034aa11$export$ed527bf60f6e05f2();
    let message = (0, $h9h89.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $fV3WI.createElement($fV3WI.Fragment, null, /*#__PURE__*/ $fV3WI.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $fV3WI.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $fV3WI.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $600bddb47034aa11$var$defaultErrorElement = /*#__PURE__*/ $fV3WI.createElement($600bddb47034aa11$var$DefaultErrorComponent, null);
class $600bddb47034aa11$var$RenderErrorBoundary extends $fV3WI.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $fV3WI.createElement($600bddb47034aa11$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $fV3WI.createElement($600bddb47034aa11$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $600bddb47034aa11$var$RenderedRoute(_ref) {
    let { routeContext: routeContext , match: match , children: children  } = _ref;
    let dataRouterContext = $fV3WI.useContext($600bddb47034aa11$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $fV3WI.createElement($600bddb47034aa11$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $600bddb47034aa11$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $h9h89.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $600bddb47034aa11$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $fV3WI.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $fV3WI.createElement($600bddb47034aa11$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $fV3WI.createElement($600bddb47034aa11$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $600bddb47034aa11$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
})($600bddb47034aa11$var$DataRouterHook || ($600bddb47034aa11$var$DataRouterHook = {}));
var $600bddb47034aa11$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
})($600bddb47034aa11$var$DataRouterStateHook || ($600bddb47034aa11$var$DataRouterStateHook = {}));
function $600bddb47034aa11$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $600bddb47034aa11$var$useDataRouterContext(hookName) {
    let ctx = $fV3WI.useContext($600bddb47034aa11$export$3add0d5dce533e2e);
    !ctx && (0, $h9h89.UNSAFE_invariant)(false);
    return ctx;
}
function $600bddb47034aa11$var$useDataRouterState(hookName) {
    let state = $fV3WI.useContext($600bddb47034aa11$export$145dfa71566a64dc);
    !state && (0, $h9h89.UNSAFE_invariant)(false);
    return state;
}
function $600bddb47034aa11$var$useRouteContext(hookName) {
    let route = $fV3WI.useContext($600bddb47034aa11$export$9072aa6dd1f93057);
    !route && (0, $h9h89.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $600bddb47034aa11$var$useCurrentRouteId(hookName) {
    let route = $600bddb47034aa11$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $h9h89.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $600bddb47034aa11$export$5fc8298006ad9e58() {
    return $600bddb47034aa11$var$useCurrentRouteId($600bddb47034aa11$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $600bddb47034aa11$export$d0fd4b7106de2769() {
    let state = $600bddb47034aa11$var$useDataRouterState($600bddb47034aa11$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $600bddb47034aa11$export$600dc272ed516c15() {
    let dataRouterContext = $600bddb47034aa11$var$useDataRouterContext($600bddb47034aa11$var$DataRouterHook.UseRevalidator);
    let state = $600bddb47034aa11$var$useDataRouterState($600bddb47034aa11$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $600bddb47034aa11$export$2378eb7f5ff86053() {
    let { matches: matches , loaderData: loaderData  } = $600bddb47034aa11$var$useDataRouterState($600bddb47034aa11$var$DataRouterStateHook.UseMatches);
    return $fV3WI.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname , params: params  } = match;
            // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $600bddb47034aa11$export$1448a5050d252c4d() {
    let state = $600bddb47034aa11$var$useDataRouterState($600bddb47034aa11$var$DataRouterStateHook.UseLoaderData);
    let routeId = $600bddb47034aa11$var$useCurrentRouteId($600bddb47034aa11$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $600bddb47034aa11$export$fd5d37484eab868d(routeId) {
    let state = $600bddb47034aa11$var$useDataRouterState($600bddb47034aa11$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $600bddb47034aa11$export$fdc00f3f26066d5e() {
    let state = $600bddb47034aa11$var$useDataRouterState($600bddb47034aa11$var$DataRouterStateHook.UseActionData);
    let route = $fV3WI.useContext($600bddb47034aa11$export$9072aa6dd1f93057);
    !route && (0, $h9h89.UNSAFE_invariant)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $600bddb47034aa11$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $fV3WI.useContext($600bddb47034aa11$var$RouteErrorContext);
    let state = $600bddb47034aa11$var$useDataRouterState($600bddb47034aa11$var$DataRouterStateHook.UseRouteError);
    let routeId = $600bddb47034aa11$var$useCurrentRouteId($600bddb47034aa11$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $600bddb47034aa11$export$78a72ddb39bdd145() {
    let value = $fV3WI.useContext($600bddb47034aa11$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $600bddb47034aa11$export$17f53340677d5831() {
    let value = $fV3WI.useContext($600bddb47034aa11$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $600bddb47034aa11$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $600bddb47034aa11$export$2af03a1de5c0910(shouldBlock) {
    let { router: router  } = $600bddb47034aa11$var$useDataRouterContext($600bddb47034aa11$var$DataRouterHook.UseBlocker);
    let state = $600bddb47034aa11$var$useDataRouterState($600bddb47034aa11$var$DataRouterStateHook.UseBlocker);
    let [blockerKey] = $fV3WI.useState(()=>String(++$600bddb47034aa11$var$blockerId));
    let blockerFunction = $fV3WI.useCallback((args)=>{
        return typeof shouldBlock === "function" ? !!shouldBlock(args) : !!shouldBlock;
    }, [
        shouldBlock
    ]);
    let blocker = router.getBlocker(blockerKey, blockerFunction);
    // Cleanup on unmount
    $fV3WI.useEffect(()=>()=>router.deleteBlocker(blockerKey), [
        router,
        blockerKey
    ]);
    // Prefer the blocker from state since DataRouterContext is memoized so this
    // ensures we update on blocker state updates
    return state.blockers.get(blockerKey) || blocker;
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $600bddb47034aa11$var$useNavigateStable() {
    let { router: router  } = $600bddb47034aa11$var$useDataRouterContext($600bddb47034aa11$var$DataRouterHook.UseNavigateStable);
    let id = $600bddb47034aa11$var$useCurrentRouteId($600bddb47034aa11$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $fV3WI.useRef(false);
    $600bddb47034aa11$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $fV3WI.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $600bddb47034aa11$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $600bddb47034aa11$var$alreadyWarned = {};
function $600bddb47034aa11$var$warningOnce(key, cond, message) {
    if (!cond && !$600bddb47034aa11$var$alreadyWarned[key]) $600bddb47034aa11$var$alreadyWarned[key] = true;
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $600bddb47034aa11$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement , router: router  } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setStateImpl] = $fV3WI.useState(router.state);
    let setState = $fV3WI.useCallback((newState)=>{
        "startTransition" in $fV3WI ? $fV3WI.startTransition(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl
    ]);
    $fV3WI.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $fV3WI.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $fV3WI.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $fV3WI.createElement($fV3WI.Fragment, null, /*#__PURE__*/ $fV3WI.createElement($600bddb47034aa11$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $fV3WI.createElement($600bddb47034aa11$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $fV3WI.createElement($600bddb47034aa11$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $fV3WI.createElement($600bddb47034aa11$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $600bddb47034aa11$var$DataRoutes(_ref2) {
    let { routes: routes , state: state  } = _ref2;
    return $600bddb47034aa11$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $600bddb47034aa11$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename , children: children , initialEntries: initialEntries , initialIndex: initialIndex  } = _ref3;
    let historyRef = $fV3WI.useRef();
    if (historyRef.current == null) historyRef.current = (0, $h9h89.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $fV3WI.useState({
        action: history.action,
        location: history.location
    });
    let setState = $fV3WI.useCallback((newState)=>{
        "startTransition" in $fV3WI ? $fV3WI.startTransition(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl
    ]);
    $fV3WI.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $fV3WI.createElement($600bddb47034aa11$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $600bddb47034aa11$export$444b3ab0cb9aec40(_ref4) {
    let { to: to , replace: replace , state: state , relative: relative  } = _ref4;
    !$600bddb47034aa11$export$9c954a9d03d32f4a() && (0, $h9h89.UNSAFE_invariant)(false);
    let { matches: matches  } = $fV3WI.useContext($600bddb47034aa11$export$9072aa6dd1f93057);
    let { pathname: locationPathname  } = $600bddb47034aa11$export$45d76561a5302f2b();
    let navigate = $600bddb47034aa11$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $h9h89.resolveTo)(to, (0, $h9h89.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $fV3WI.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $600bddb47034aa11$export$910ae8079b2c2852(props) {
    return $600bddb47034aa11$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $600bddb47034aa11$export$e7b0ac011bb776c6(_props) {
    (0, $h9h89.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $600bddb47034aa11$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/" , children: children = null , location: locationProp , navigationType: navigationType = (0, $h9h89.Action).Pop , navigator: navigator , static: staticProp = false  } = _ref5;
    !!$600bddb47034aa11$export$9c954a9d03d32f4a() && (0, $h9h89.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $fV3WI.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $h9h89.parsePath)(locationProp);
    let { pathname: pathname = "/" , search: search = "" , hash: hash = "" , state: state = null , key: key = "default"  } = locationProp;
    let locationContext = $fV3WI.useMemo(()=>{
        let trailingPathname = (0, $h9h89.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $fV3WI.createElement($600bddb47034aa11$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $fV3WI.createElement($600bddb47034aa11$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $600bddb47034aa11$export$3565eb3d00ca5a74(_ref6) {
    let { children: children , location: location  } = _ref6;
    return $600bddb47034aa11$export$5d3fca4a98652595($600bddb47034aa11$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $600bddb47034aa11$export$6ddabde395c8c576(_ref7) {
    let { children: children , errorElement: errorElement , resolve: resolve  } = _ref7;
    return /*#__PURE__*/ $fV3WI.createElement($600bddb47034aa11$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $fV3WI.createElement($600bddb47034aa11$var$ResolveAwait, null, children));
}
var $600bddb47034aa11$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($600bddb47034aa11$var$AwaitRenderStatus || ($600bddb47034aa11$var$AwaitRenderStatus = {}));
const $600bddb47034aa11$var$neverSettledPromise = new Promise(()=>{});
class $600bddb47034aa11$var$AwaitErrorBoundary extends $fV3WI.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children , errorElement: errorElement , resolve: resolve  } = this.props;
        let promise = null;
        let status = $600bddb47034aa11$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $600bddb47034aa11$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $600bddb47034aa11$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $600bddb47034aa11$var$AwaitRenderStatus.error : promise._data !== undefined ? $600bddb47034aa11$var$AwaitRenderStatus.success : $600bddb47034aa11$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $600bddb47034aa11$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $600bddb47034aa11$var$AwaitRenderStatus.error && promise._error instanceof (0, $h9h89.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $600bddb47034aa11$var$neverSettledPromise;
        if (status === $600bddb47034aa11$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $600bddb47034aa11$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $fV3WI.createElement($600bddb47034aa11$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $600bddb47034aa11$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $fV3WI.createElement($600bddb47034aa11$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $600bddb47034aa11$var$ResolveAwait(_ref8) {
    let { children: children  } = _ref8;
    let data = $600bddb47034aa11$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $fV3WI.createElement($fV3WI.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $600bddb47034aa11$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $fV3WI.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $fV3WI.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $fV3WI.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $600bddb47034aa11$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $600bddb47034aa11$export$e7b0ac011bb776c6) && (0, $h9h89.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $h9h89.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $600bddb47034aa11$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $600bddb47034aa11$export$daf73786167a7f72(matches) {
    return $600bddb47034aa11$var$_renderMatches(matches);
}
function $600bddb47034aa11$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $fV3WI.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $fV3WI.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $600bddb47034aa11$export$f30f7e456d254e83(routes, opts) {
    return (0, $h9h89.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $600bddb47034aa11$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $h9h89.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $600bddb47034aa11$export$52b333d321859367
    }).initialize();
}

});


parcelRequire.register("1L1yK", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return (parcelRequire("jJ5yG")).Trans; });
$parcel$export(module.exports, "useTranslation", function () { return (parcelRequire("b3xDI")).useTranslation; });
$parcel$export(module.exports, "initReactI18next", function () { return (parcelRequire("ajWkC")).initReactI18next; });

var $jJ5yG = parcelRequire("jJ5yG");

var $l5C1Q = parcelRequire("l5C1Q");

var $b3xDI = parcelRequire("b3xDI");

var $1FdFQ = parcelRequire("1FdFQ");

var $1irYj = parcelRequire("1irYj");

var $gxZFI = parcelRequire("gxZFI");

var $i38j6 = parcelRequire("i38j6");

var $44LNg = parcelRequire("44LNg");

var $ajWkC = parcelRequire("ajWkC");

var $gx7GD = parcelRequire("gx7GD");

var $4UxvB = parcelRequire("4UxvB");

var $02p0u = parcelRequire("02p0u");
var $147b63ecb935965f$export$324d90190a8b822a = function date() {
    return "";
};
var $147b63ecb935965f$export$2da9be4cfdb689b1 = function time() {
    return "";
};
var $147b63ecb935965f$export$98e628dec113755e = function number() {
    return "";
};
var $147b63ecb935965f$export$2e6c959c16ff56b8 = function select() {
    return "";
};
var $147b63ecb935965f$export$4e35d5c922a95490 = function plural() {
    return "";
};
var $147b63ecb935965f$export$720a3b9db04b7a0f = function selectOrdinal() {
    return "";
};

});
parcelRequire.register("jJ5yG", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return $e5c6881825538c8a$export$8d6a9236f2e3f2ce; });

var $acWJh = parcelRequire("acWJh");

var $WALeC = parcelRequire("WALeC");

var $fV3WI = parcelRequire("fV3WI");

var $l5C1Q = parcelRequire("l5C1Q");

var $02p0u = parcelRequire("02p0u");
var $4UxvB = parcelRequire("4UxvB");
var $e5c6881825538c8a$var$_excluded = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $e5c6881825538c8a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e5c6881825538c8a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e5c6881825538c8a$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($acWJh)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e5c6881825538c8a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e5c6881825538c8a$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, (/*@__PURE__*/$parcel$interopDefault($WALeC)))(_ref, $e5c6881825538c8a$var$_excluded);
    var _ref2 = (0, $fV3WI.useContext)((0, $02p0u.I18nContext)) || {}, i18nFromContext = _ref2.i18n, defaultNSFromContext = _ref2.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $4UxvB.getI18n)();
    var t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $l5C1Q.Trans)($e5c6881825538c8a$var$_objectSpread({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape
    }, additionalProps));
}

});
parcelRequire.register("acWJh", function(module, exports) {

var $w20G7 = parcelRequire("w20G7");
function $76e894c6829763b0$var$_defineProperty(obj, key, value) {
    key = $w20G7(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $76e894c6829763b0$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("w20G7", function(module, exports) {

var $jCtuL = parcelRequire("jCtuL");
var $06048c67ffbb2780$var$_typeof = $jCtuL.default;

var $91ID5 = parcelRequire("91ID5");
function $06048c67ffbb2780$var$_toPropertyKey(arg) {
    var key = $91ID5(arg, "string");
    return $06048c67ffbb2780$var$_typeof(key) === "symbol" ? key : String(key);
}
module.exports = $06048c67ffbb2780$var$_toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("jCtuL", function(module, exports) {
function $e488721483829360$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return module.exports = $e488721483829360$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $e488721483829360$var$_typeof(obj);
}
module.exports = $e488721483829360$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("91ID5", function(module, exports) {

var $jCtuL = parcelRequire("jCtuL");
var $6926d38b4c989646$var$_typeof = $jCtuL.default;
function $6926d38b4c989646$var$_toPrimitive(input, hint) {
    if ($6926d38b4c989646$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6926d38b4c989646$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
module.exports = $6926d38b4c989646$var$_toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRequire.register("WALeC", function(module, exports) {

var $6idua = parcelRequire("6idua");
function $0b01eed56325b5e5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6idua(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
module.exports = $0b01eed56325b5e5$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("6idua", function(module, exports) {
function $494ee2776ae0a6d7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $494ee2776ae0a6d7$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("l5C1Q", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return $03f650c7740098dd$export$8d6a9236f2e3f2ce; });

var $WALeC = parcelRequire("WALeC");

var $jCtuL = parcelRequire("jCtuL");

var $acWJh = parcelRequire("acWJh");

var $fV3WI = parcelRequire("fV3WI");

var $9l4QP = parcelRequire("9l4QP");

var $1ueIB = parcelRequire("1ueIB");

var $gx7GD = parcelRequire("gx7GD");

var $4UxvB = parcelRequire("4UxvB");
var $03f650c7740098dd$var$_excluded = [
    "format"
], $03f650c7740098dd$var$_excluded2 = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $03f650c7740098dd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $03f650c7740098dd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $03f650c7740098dd$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($acWJh)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $03f650c7740098dd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $03f650c7740098dd$var$hasChildren(node, checkLength) {
    if (!node) return false;
    var base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $03f650c7740098dd$var$getChildren(node) {
    if (!node) return [];
    return node.props ? node.props.children : node.children;
}
function $03f650c7740098dd$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every(function(child) {
        return (0, $fV3WI.isValidElement)(child);
    });
}
function $03f650c7740098dd$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $03f650c7740098dd$var$mergeProps(source, target) {
    var newTarget = $03f650c7740098dd$var$_objectSpread({}, target);
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $03f650c7740098dd$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    var stringNode = "";
    var childrenArray = $03f650c7740098dd$var$getAsArray(children);
    var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach(function(child, childIndex) {
        if (typeof child === "string") stringNode += "".concat(child);
        else if ((0, $fV3WI.isValidElement)(child)) {
            var childPropsCount = Object.keys(child.props).length;
            var shouldKeepChild = keepArray.indexOf(child.type) > -1;
            var childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += "<".concat(child.type, "/>");
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (child.props.i18nIsDynamicList) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
            else {
                var content = $03f650c7740098dd$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
            }
        } else if (child === null) (0, $1ueIB.warn)("Trans: the passed in value is invalid - seems you passed in a null child.");
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($jCtuL)))(child) === "object") {
            var format = child.format, clone = (0, (/*@__PURE__*/$parcel$interopDefault($WALeC)))(child, $03f650c7740098dd$var$_excluded);
            var keys = Object.keys(clone);
            if (keys.length === 1) {
                var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
                stringNode += "{{".concat(value, "}}");
            } else (0, $1ueIB.warn)("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
        } else (0, $1ueIB.warn)("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    });
    return stringNode;
}
function $03f650c7740098dd$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling) return [
        targetString
    ];
    var data = {};
    function getData(childs) {
        var childrenArray = $03f650c7740098dd$var$getAsArray(childs);
        childrenArray.forEach(function(child) {
            if (typeof child === "string") return;
            if ($03f650c7740098dd$var$hasChildren(child)) getData($03f650c7740098dd$var$getChildren(child));
            else if ((0, (/*@__PURE__*/$parcel$interopDefault($jCtuL)))(child) === "object" && !(0, $fV3WI.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    var ast = (0, $9l4QP.default).parse("<0>".concat(targetString, "</0>"));
    var opts = $03f650c7740098dd$var$_objectSpread($03f650c7740098dd$var$_objectSpread({}, data), combinedTOpts);
    function renderInner(child, node, rootReactNode) {
        var childs = $03f650c7740098dd$var$getChildren(child);
        var mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $03f650c7740098dd$var$hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) child.children = inner;
        mem.push((0, $fV3WI.cloneElement)(child, $03f650c7740098dd$var$_objectSpread($03f650c7740098dd$var$_objectSpread({}, child.props), {}, {
            key: i
        }), isVoid ? undefined : inner));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        var reactNodes = $03f650c7740098dd$var$getAsArray(reactNode);
        var astNodes = $03f650c7740098dd$var$getAsArray(astNode);
        return astNodes.reduce(function(mem, node, i) {
            var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                var tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                var child = Object.keys(node.attrs).length !== 0 ? $03f650c7740098dd$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                var isElement = (0, $fV3WI.isValidElement)(child);
                var isValidTranslationWithChildren = isElement && $03f650c7740098dd$var$hasChildren(node, true) && !node.voidElement;
                var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, (/*@__PURE__*/$parcel$interopDefault($jCtuL)))(child) === "object" && child.dummy && !isElement;
                var isKnownComponent = (0, (/*@__PURE__*/$parcel$interopDefault($jCtuL)))(children) === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($03f650c7740098dd$var$hasChildren(child) || isValidTranslationWithChildren) {
                    var inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    var _inner = mapAST(reactNodes, node.children, rootReactNode);
                    mem.push((0, $fV3WI.cloneElement)(child, $03f650c7740098dd$var$_objectSpread($03f650c7740098dd$var$_objectSpread({}, child.props), {}, {
                        key: i
                    }), _inner));
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        var _inner2 = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $fV3WI.createElement)(node.name, {
                            key: "".concat(node.name, "-").concat(i)
                        }));
                        else {
                            var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $fV3WI.createElement)(node.name, {
                                key: "".concat(node.name, "-").concat(i)
                            }, _inner3));
                        }
                    } else if (node.voidElement) mem.push("<".concat(node.name, " />"));
                    else {
                        var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
                    }
                } else if ((0, (/*@__PURE__*/$parcel$interopDefault($jCtuL)))(child) === "object" && !isElement) {
                    var content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else if (node.children.length === 1 && translationContent) mem.push((0, $fV3WI.cloneElement)(child, $03f650c7740098dd$var$_objectSpread($03f650c7740098dd$var$_objectSpread({}, child.props), {}, {
                    key: i
                }), translationContent));
                else mem.push((0, $fV3WI.cloneElement)(child, $03f650c7740098dd$var$_objectSpread($03f650c7740098dd$var$_objectSpread({}, child.props), {}, {
                    key: i
                })));
            } else if (node.type === "text") {
                var wrapTextNodes = i18nOptions.transWrapTextNodes;
                var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $fV3WI.createElement)(wrapTextNodes, {
                    key: "".concat(node.name, "-").concat(i)
                }, _content));
                else mem.push(_content);
            }
            return mem;
        }, []);
    }
    var result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $03f650c7740098dd$var$getAsArray(children || []));
    return $03f650c7740098dd$var$getChildren(result[0]);
}
function $03f650c7740098dd$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, (/*@__PURE__*/$parcel$interopDefault($WALeC)))(_ref, $03f650c7740098dd$var$_excluded2);
    var i18n = i18nFromProps || (0, $4UxvB.getI18n)();
    if (!i18n) {
        (0, $1ueIB.warnOnce)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    var t = tFromProps || i18n.t.bind(i18n) || function(k) {
        return k;
    };
    if (context) tOptions.context = context;
    var reactI18nextOptions = $03f650c7740098dd$var$_objectSpread($03f650c7740098dd$var$_objectSpread({}, (0, $gx7GD.getDefaults)()), i18n.options && i18n.options.react);
    var namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    var defaultValue = defaults || $03f650c7740098dd$export$4f7a36dd898f1267(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    var hashTransKey = reactI18nextOptions.hashTransKey;
    var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
    var interpolationOverride = values ? tOptions.interpolation : {
        interpolation: $03f650c7740098dd$var$_objectSpread($03f650c7740098dd$var$_objectSpread({}, tOptions.interpolation), {}, {
            prefix: "#$?",
            suffix: "?$#"
        })
    };
    var combinedTOpts = $03f650c7740098dd$var$_objectSpread($03f650c7740098dd$var$_objectSpread($03f650c7740098dd$var$_objectSpread($03f650c7740098dd$var$_objectSpread({}, tOptions), {}, {
        count: count
    }, values), interpolationOverride), {}, {
        defaultValue: defaultValue,
        ns: namespaces
    });
    var translation = key ? t(key, combinedTOpts) : defaultValue;
    var content = $03f650c7740098dd$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $fV3WI.createElement)(useAsParent, additionalProps, content) : content;
}

});
parcelRequire.register("9l4QP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cc9d684d121dd8a$export$2e2bcd8739ae039; });

var $2gGOI = parcelRequire("2gGOI");
var $6cc9d684d121dd8a$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $6cc9d684d121dd8a$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($2gGOI)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($6cc9d684d121dd8a$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $6cc9d684d121dd8a$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $6cc9d684d121dd8a$var$i = /^\s*$/, $6cc9d684d121dd8a$var$s = Object.create(null);
function $6cc9d684d121dd8a$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($6cc9d684d121dd8a$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $6cc9d684d121dd8a$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $6cc9d684d121dd8a$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($6cc9d684d121dd8a$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $6cc9d684d121dd8a$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $6cc9d684d121dd8a$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $6cc9d684d121dd8a$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $6cc9d684d121dd8a$var$a("", t);
        }, "");
    }
};
var $6cc9d684d121dd8a$export$2e2bcd8739ae039 = $6cc9d684d121dd8a$var$c;

});
parcelRequire.register("2gGOI", function(module, exports) {
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ module.exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};

});


parcelRequire.register("1ueIB", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $115402886a94d142$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "warnOnce", function () { return $115402886a94d142$export$5b28268982f175ba; });
$parcel$export(module.exports, "loadNamespaces", function () { return $115402886a94d142$export$83be934b53fff43b; });
$parcel$export(module.exports, "loadLanguages", function () { return $115402886a94d142$export$8cd7e7a54fa865bc; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return $115402886a94d142$export$93d9ee97c1ad3f31; });
$parcel$export(module.exports, "getDisplayName", function () { return $115402886a94d142$export$be63e0664592e141; });
function $115402886a94d142$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $115402886a94d142$var$alreadyWarned = {};
function $115402886a94d142$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $115402886a94d142$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $115402886a94d142$var$alreadyWarned[args[0]] = new Date();
    $115402886a94d142$export$c106dd0671a0fc2d.apply(void 0, args);
}
var $115402886a94d142$var$loadedClb = function loadedClb(i18n, cb) {
    return function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    };
};
function $115402886a94d142$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $115402886a94d142$var$loadedClb(i18n, cb));
}
function $115402886a94d142$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === "string") ns = [
        ns
    ];
    ns.forEach(function(n) {
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $115402886a94d142$var$loadedClb(i18n, cb));
}
function $115402886a94d142$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $115402886a94d142$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $115402886a94d142$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $115402886a94d142$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $115402886a94d142$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}

});

parcelRequire.register("gx7GD", function(module, exports) {

$parcel$export(module.exports, "setDefaults", function () { return $c095b0cc77ef7ef7$export$2e2366488d12e20d; });
$parcel$export(module.exports, "getDefaults", function () { return $c095b0cc77ef7ef7$export$212bb2fc580a90a8; });

var $acWJh = parcelRequire("acWJh");

var $59DND = parcelRequire("59DND");
function $c095b0cc77ef7ef7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c095b0cc77ef7ef7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $c095b0cc77ef7ef7$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($acWJh)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $c095b0cc77ef7ef7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $c095b0cc77ef7ef7$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: (0, $59DND.unescape)
};
function $c095b0cc77ef7ef7$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $c095b0cc77ef7ef7$var$defaultOptions = $c095b0cc77ef7ef7$var$_objectSpread($c095b0cc77ef7ef7$var$_objectSpread({}, $c095b0cc77ef7ef7$var$defaultOptions), options);
}
function $c095b0cc77ef7ef7$export$212bb2fc580a90a8() {
    return $c095b0cc77ef7ef7$var$defaultOptions;
}

});
parcelRequire.register("59DND", function(module, exports) {

$parcel$export(module.exports, "unescape", function () { return $3c0caa5a5658effd$export$e8bacd2802a88316; });
var $3c0caa5a5658effd$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $3c0caa5a5658effd$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "…",
    "&#8230;": "…",
    "&#x2F;": "/",
    "&#47;": "/"
};
var $3c0caa5a5658effd$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $3c0caa5a5658effd$var$htmlEntities[m];
};
var $3c0caa5a5658effd$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($3c0caa5a5658effd$var$matchHtmlEntity, $3c0caa5a5658effd$var$unescapeHtmlEntity);
};

});


parcelRequire.register("4UxvB", function(module, exports) {

$parcel$export(module.exports, "setI18n", function () { return $3936628390e00eac$export$a039134f2fc7e0; });
$parcel$export(module.exports, "getI18n", function () { return $3936628390e00eac$export$64af334f494c2f47; });
var $3936628390e00eac$var$i18nInstance;
function $3936628390e00eac$export$a039134f2fc7e0(instance) {
    $3936628390e00eac$var$i18nInstance = instance;
}
function $3936628390e00eac$export$64af334f494c2f47() {
    return $3936628390e00eac$var$i18nInstance;
}

});


parcelRequire.register("02p0u", function(module, exports) {

$parcel$export(module.exports, "I18nContext", function () { return $007395d9955ce9f1$export$5603ab5ced17ce64; });
$parcel$export(module.exports, "ReportNamespaces", function () { return $007395d9955ce9f1$export$ea171b67e3820290; });
$parcel$export(module.exports, "composeInitialProps", function () { return $007395d9955ce9f1$export$30ff0342ccf735a; });
$parcel$export(module.exports, "getDefaults", function () { return (parcelRequire("gx7GD")).getDefaults; });
$parcel$export(module.exports, "getI18n", function () { return (parcelRequire("4UxvB")).getI18n; });

var $acWJh = parcelRequire("acWJh");

var $fYuhQ = parcelRequire("fYuhQ");

var $cw8sH = parcelRequire("cw8sH");

var $fV3WI = parcelRequire("fV3WI");

var $gx7GD = parcelRequire("gx7GD");

var $4UxvB = parcelRequire("4UxvB");

var $ajWkC = parcelRequire("ajWkC");
function $007395d9955ce9f1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $007395d9955ce9f1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $007395d9955ce9f1$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($acWJh)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $007395d9955ce9f1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $007395d9955ce9f1$export$5603ab5ced17ce64 = (0, $fV3WI.createContext)();
var $007395d9955ce9f1$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fYuhQ)))(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cw8sH)))(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $007395d9955ce9f1$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $007395d9955ce9f1$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($007395d9955ce9f1$var$_objectSpread($007395d9955ce9f1$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $007395d9955ce9f1$export$704200e5d0b9e8f() {
    var i18n = (0, $4UxvB.getI18n)();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}

});
parcelRequire.register("fYuhQ", function(module, exports) {
function $ba13f3f799fe1094$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $ba13f3f799fe1094$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("cw8sH", function(module, exports) {

var $w20G7 = parcelRequire("w20G7");
function $91cf098be8d120d4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $w20G7(descriptor.key), descriptor);
    }
}
function $91cf098be8d120d4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $91cf098be8d120d4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $91cf098be8d120d4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $91cf098be8d120d4$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("ajWkC", function(module, exports) {

$parcel$export(module.exports, "initReactI18next", function () { return $7838ed28afbdba7a$export$ae7e14d40d89f296; });

var $gx7GD = parcelRequire("gx7GD");

var $4UxvB = parcelRequire("4UxvB");
var $7838ed28afbdba7a$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init: function init(instance) {
        (0, $gx7GD.setDefaults)(instance.options.react);
        (0, $4UxvB.setI18n)(instance);
    }
};

});



parcelRequire.register("b3xDI", function(module, exports) {

$parcel$export(module.exports, "useTranslation", function () { return $80ca11a6821d3304$export$9fc83ad70ead8663; });

var $4HM57 = parcelRequire("4HM57");

var $acWJh = parcelRequire("acWJh");

var $jCtuL = parcelRequire("jCtuL");

var $fV3WI = parcelRequire("fV3WI");

var $02p0u = parcelRequire("02p0u");
var $4UxvB = parcelRequire("4UxvB");
var $gx7GD = parcelRequire("gx7GD");

var $1ueIB = parcelRequire("1ueIB");
function $80ca11a6821d3304$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $80ca11a6821d3304$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $80ca11a6821d3304$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($acWJh)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $80ca11a6821d3304$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $80ca11a6821d3304$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $fV3WI.useRef)();
    (0, $fV3WI.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $80ca11a6821d3304$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $fV3WI.useContext)((0, $02p0u.I18nContext)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $4UxvB.getI18n)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $02p0u.ReportNamespaces)();
    if (!i18n) {
        (0, $1ueIB.warnOnce)("You will need to pass in an i18next instance by using initReactI18next");
        var notReadyT = function notReadyT(k, optsOrDefaultValue) {
            if (typeof optsOrDefaultValue === "string") return optsOrDefaultValue;
            if (optsOrDefaultValue && (0, (/*@__PURE__*/$parcel$interopDefault($jCtuL)))(optsOrDefaultValue) === "object" && typeof optsOrDefaultValue.defaultValue === "string") return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $1ueIB.warnOnce)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    var i18nOptions = $80ca11a6821d3304$var$_objectSpread($80ca11a6821d3304$var$_objectSpread($80ca11a6821d3304$var$_objectSpread({}, (0, $gx7GD.getDefaults)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $1ueIB.hasLoadedNamespace)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $fV3WI.useState)(getT), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($4HM57)))(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    if (props.lng) joinedNS = "".concat(props.lng).concat(joinedNS);
    var previousJoinedNS = $80ca11a6821d3304$var$usePrevious(joinedNS);
    var isMounted = (0, $fV3WI.useRef)(true);
    (0, $fV3WI.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $1ueIB.loadLanguages)(i18n, props.lng, namespaces, function() {
                if (isMounted.current) setT(getT);
            });
            else (0, $1ueIB.loadNamespaces)(i18n, namespaces, function() {
                if (isMounted.current) setT(getT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $fV3WI.useRef)(true);
    (0, $fV3WI.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        if (props.lng) (0, $1ueIB.loadLanguages)(i18n, props.lng, namespaces, function() {
            return resolve();
        });
        else (0, $1ueIB.loadNamespaces)(i18n, namespaces, function() {
            return resolve();
        });
    });
}

});
parcelRequire.register("4HM57", function(module, exports) {

var $g8oC7 = parcelRequire("g8oC7");

var $1zMwW = parcelRequire("1zMwW");

var $5lS7O = parcelRequire("5lS7O");

var $7fDhP = parcelRequire("7fDhP");
function $36d07993cd67d4db$var$_slicedToArray(arr, i) {
    return $g8oC7(arr) || $1zMwW(arr, i) || $5lS7O(arr, i) || $7fDhP();
}
module.exports = $36d07993cd67d4db$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("g8oC7", function(module, exports) {
function $03080202088a0712$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
module.exports = $03080202088a0712$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("1zMwW", function(module, exports) {
function $125eb46aa17c6fee$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
module.exports = $125eb46aa17c6fee$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("5lS7O", function(module, exports) {

var $d8kSM = parcelRequire("d8kSM");
function $3e58e5fde8fedfc7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d8kSM(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d8kSM(o, minLen);
}
module.exports = $3e58e5fde8fedfc7$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("d8kSM", function(module, exports) {
function $98fc38920b2bd4b8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = $98fc38920b2bd4b8$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("7fDhP", function(module, exports) {
function $547868a2660ea24e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $547868a2660ea24e$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRequire.register("1FdFQ", function(module, exports) {

var $acWJh = parcelRequire("acWJh");

var $4HM57 = parcelRequire("4HM57");

var $WALeC = parcelRequire("WALeC");

var $fV3WI = parcelRequire("fV3WI");

var $b3xDI = parcelRequire("b3xDI");

var $1ueIB = parcelRequire("1ueIB");
var $13643a24c759d11d$var$_excluded = [
    "forwardedRef"
];
function $13643a24c759d11d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $13643a24c759d11d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $13643a24c759d11d$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($acWJh)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $13643a24c759d11d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $13643a24c759d11d$export$2dcb0053efd21124(ns) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            var forwardedRef = _ref.forwardedRef, rest = (0, (/*@__PURE__*/$parcel$interopDefault($WALeC)))(_ref, $13643a24c759d11d$var$_excluded);
            var _useTranslation = (0, $b3xDI.useTranslation)(ns, $13643a24c759d11d$var$_objectSpread($13643a24c759d11d$var$_objectSpread({}, rest), {}, {
                keyPrefix: options.keyPrefix
            })), _useTranslation2 = (0, (/*@__PURE__*/$parcel$interopDefault($4HM57)))(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
            var passDownProps = $13643a24c759d11d$var$_objectSpread($13643a24c759d11d$var$_objectSpread({}, rest), {}, {
                t: t,
                i18n: i18n,
                tReady: ready
            });
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $fV3WI.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = "withI18nextTranslation(".concat((0, $1ueIB.getDisplayName)(WrappedComponent), ")");
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        var forwardRef = function forwardRef(props, ref) {
            return (0, $fV3WI.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        };
        return options.withRef ? (0, $fV3WI.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}

});

parcelRequire.register("1irYj", function(module, exports) {

var $4HM57 = parcelRequire("4HM57");

var $WALeC = parcelRequire("WALeC");

var $b3xDI = parcelRequire("b3xDI");
var $0f1d2b7c8692135e$var$_excluded = [
    "ns",
    "children"
];
function $0f1d2b7c8692135e$export$b63289fbda65eed1(props) {
    var ns = props.ns, children = props.children, options = (0, (/*@__PURE__*/$parcel$interopDefault($WALeC)))(props, $0f1d2b7c8692135e$var$_excluded);
    var _useTranslation = (0, $b3xDI.useTranslation)(ns, options), _useTranslation2 = (0, (/*@__PURE__*/$parcel$interopDefault($4HM57)))(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}

});

parcelRequire.register("gxZFI", function(module, exports) {

var $fV3WI = parcelRequire("fV3WI");

var $02p0u = parcelRequire("02p0u");
function $c0bf9122e2bae0d7$export$1325e8699caa160f(_ref) {
    var i18n = _ref.i18n, defaultNS = _ref.defaultNS, children = _ref.children;
    var value = (0, $fV3WI.useMemo)(function() {
        return {
            i18n: i18n,
            defaultNS: defaultNS
        };
    }, [
        i18n,
        defaultNS
    ]);
    return (0, $fV3WI.createElement)((0, $02p0u.I18nContext).Provider, {
        value: value
    }, children);
}

});

parcelRequire.register("i38j6", function(module, exports) {

var $acWJh = parcelRequire("acWJh");

var $WALeC = parcelRequire("WALeC");

var $fV3WI = parcelRequire("fV3WI");

var $44LNg = parcelRequire("44LNg");

var $02p0u = parcelRequire("02p0u");

var $1ueIB = parcelRequire("1ueIB");
var $d23ef3686a53af32$var$_excluded = [
    "initialI18nStore",
    "initialLanguage"
];
function $d23ef3686a53af32$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d23ef3686a53af32$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d23ef3686a53af32$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($acWJh)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d23ef3686a53af32$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d23ef3686a53af32$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            var initialI18nStore = _ref.initialI18nStore, initialLanguage = _ref.initialLanguage, rest = (0, (/*@__PURE__*/$parcel$interopDefault($WALeC)))(_ref, $d23ef3686a53af32$var$_excluded);
            (0, $44LNg.useSSR)(initialI18nStore, initialLanguage);
            return (0, $fV3WI.createElement)(WrappedComponent, $d23ef3686a53af32$var$_objectSpread({}, rest));
        }
        I18nextWithSSR.getInitialProps = (0, $02p0u.composeInitialProps)(WrappedComponent);
        I18nextWithSSR.displayName = "withI18nextSSR(".concat((0, $1ueIB.getDisplayName)(WrappedComponent), ")");
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}

});
parcelRequire.register("44LNg", function(module, exports) {

$parcel$export(module.exports, "useSSR", function () { return $2f7c9bf87638e171$export$3526fb65ade8d8b7; });

var $fV3WI = parcelRequire("fV3WI");

var $02p0u = parcelRequire("02p0u");
var $4UxvB = parcelRequire("4UxvB");
function $2f7c9bf87638e171$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $fV3WI.useContext)((0, $02p0u.I18nContext)) || {}, i18nFromContext = _ref.i18n;
    var i18n = i18nFromProps || i18nFromContext || (0, $4UxvB.getI18n)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce(function(mem, lngResources) {
            Object.keys(lngResources).forEach(function(ns) {
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}

});



parcelRequire.register("l3z4m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f54514d7c8465ac5$export$2e2bcd8739ae039; });

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");


var $js0sS = parcelRequire("js0sS");

var $ZXS89 = parcelRequire("ZXS89");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");

var $3OsDj = parcelRequire("3OsDj");

var $czyq6 = parcelRequire("czyq6");

var $hScOl = parcelRequire("hScOl");

var $Nsk37 = parcelRequire("Nsk37");

var $ftmyq = parcelRequire("ftmyq");

var $3DnwL = parcelRequire("3DnwL");
const $f54514d7c8465ac5$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $f54514d7c8465ac5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , component: component , focusVisible: focusVisible , underline: underline  } = ownerState;
    const slots = {
        root: [
            "root",
            `underline${(0, $ZXS89.default)(underline)}`,
            component === "button" && "button",
            focusVisible && "focusVisible"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $Nsk37.getLinkUtilityClass), classes);
};
const $f54514d7c8465ac5$var$LinkRoot = (0, $aF4Kv.default)((0, $hScOl.default), {
    name: "MuiLink",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            styles[`underline${(0, $ZXS89.default)(ownerState.underline)}`],
            ownerState.component === "button" && styles.button
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    return (0, $j5tUA.default)({}, ownerState.underline === "none" && {
        textDecoration: "none"
    }, ownerState.underline === "hover" && {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    }, ownerState.underline === "always" && (0, $j5tUA.default)({
        textDecoration: "underline"
    }, ownerState.color !== "inherit" && {
        textDecorationColor: (0, $ftmyq.default)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        "&:hover": {
            textDecorationColor: "inherit"
        }
    }), ownerState.component === "button" && {
        position: "relative",
        WebkitTapHighlightColor: "transparent",
        backgroundColor: "transparent",
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: "pointer",
        userSelect: "none",
        verticalAlign: "middle",
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        "&::-moz-focus-inner": {
            borderStyle: "none" // Remove Firefox dotted outline.
        },
        [`&.${(0, $Nsk37.default).focusVisible}`]: {
            outline: "auto"
        }
    });
});
const $f54514d7c8465ac5$var$Link = /*#__PURE__*/ $fV3WI.forwardRef(function Link(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiLink"
    });
    const { className: className , color: color = "primary" , component: component = "a" , onBlur: onBlur , onFocus: onFocus , TypographyClasses: TypographyClasses , underline: underline = "always" , variant: variant = "inherit" , sx: sx  } = props, other = (0, $64S8Y.default)(props, $f54514d7c8465ac5$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef , onBlur: handleBlurVisible , onFocus: handleFocusVisible , ref: focusVisibleRef  } = (0, $3OsDj.default)();
    const [focusVisible, setFocusVisible] = $fV3WI.useState(false);
    const handlerRef = (0, $czyq6.default)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $j5tUA.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $f54514d7c8465ac5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3DnwL.jsx)($f54514d7c8465ac5$var$LinkRoot, (0, $j5tUA.default)({
        color: color,
        className: (0, $h0s6D.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $ftmyq.colorTransformations)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
var $f54514d7c8465ac5$export$2e2bcd8739ae039 = $f54514d7c8465ac5$var$Link;

});
parcelRequire.register("Nsk37", function(module, exports) {

$parcel$export(module.exports, "getLinkUtilityClass", function () { return $094a8bf3a16f7ce1$export$d6efab9620b78fec; });
$parcel$export(module.exports, "default", function () { return $094a8bf3a16f7ce1$export$2e2bcd8739ae039; });

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $094a8bf3a16f7ce1$export$d6efab9620b78fec(slot) {
    return (0, $auxfn.default)("MuiLink", slot);
}
const $094a8bf3a16f7ce1$var$linkClasses = (0, $dxVxC.default)("MuiLink", [
    "root",
    "underlineNone",
    "underlineHover",
    "underlineAlways",
    "button",
    "focusVisible"
]);
var $094a8bf3a16f7ce1$export$2e2bcd8739ae039 = $094a8bf3a16f7ce1$var$linkClasses;

});

parcelRequire.register("ftmyq", function(module, exports) {

$parcel$export(module.exports, "colorTransformations", function () { return $b43b0f459774a9fa$export$c4e140d5d351182b; });
$parcel$export(module.exports, "default", function () { return $b43b0f459774a9fa$export$2e2bcd8739ae039; });

var $74s0b = parcelRequire("74s0b");
var $hv9Gs = parcelRequire("hv9Gs");
const $b43b0f459774a9fa$export$c4e140d5d351182b = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $b43b0f459774a9fa$var$transformDeprecatedColors = (color)=>{
    return $b43b0f459774a9fa$export$c4e140d5d351182b[color] || color;
};
const $b43b0f459774a9fa$var$getTextDecoration = ({ theme: theme , ownerState: ownerState  })=>{
    const transformedColor = $b43b0f459774a9fa$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $hv9Gs.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $hv9Gs.getPath)(theme, `palette.${transformedColor}Channel`);
    if ("vars" in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $74s0b.alpha)(color, 0.4);
};
var $b43b0f459774a9fa$export$2e2bcd8739ae039 = $b43b0f459774a9fa$var$getTextDecoration;

});


parcelRequire.register("hc6sd", function(module, exports) {
$parcel$export(module.exports, "useNotifications", function () { return (parcelRequire("bqOhJ")).useNotifications; });
$parcel$export(module.exports, "useLoginSuccess", function () { return (parcelRequire("9bG6e")).useLoginSuccess; });
$parcel$export(module.exports, "useConfig", function () { return (parcelRequire("lpNwr")).useConfig; });
$parcel$export(module.exports, "useInitialData", function () { return (parcelRequire("a9kEu")).useInitialData; });
$parcel$export(module.exports, "useValidationRules", function () { return (parcelRequire("gv64I")).useValidationRules; });
parcelRequire("bqOhJ");
parcelRequire("9bG6e");
parcelRequire("lpNwr");
parcelRequire("a9kEu");
parcelRequire("gv64I");

});
parcelRequire.register("bqOhJ", function(module, exports) {

$parcel$export(module.exports, "useNotifications", function () { return $86928de034129a1f$export$53d5ca6c3f53e109; });

var $f1uOs = parcelRequire("f1uOs");
parcelRequire("1L1yK");
var $b3xDI = parcelRequire("b3xDI");
function $86928de034129a1f$export$53d5ca6c3f53e109() {
    const { t: t  } = (0, $b3xDI.useTranslation)();
    const { enqueueSnackbar: enqueueSnackbar  } = (0, $f1uOs.useSnackbar)();
    function showError(error) {
        console.log(error);
        enqueueSnackbar(t(`Errors.${error?.message || "generic_error"}`), {
            variant: "error"
        });
    }
    function showWarning(message) {
        enqueueSnackbar(message, {
            variant: "warning"
        });
    }
    function showSuccess(message) {
        enqueueSnackbar(message, {
            variant: "success"
        });
    }
    return {
        showError: showError,
        showWarning: showWarning,
        showSuccess: showSuccess
    };
}

});
parcelRequire.register("f1uOs", function(module, exports) {

$parcel$export(module.exports, "SnackbarProvider", function () { return $aefed9d008d35275$export$d1e619fddc3508ce; });
$parcel$export(module.exports, "useSnackbar", function () { return $aefed9d008d35275$export$1c97ac2c9a6e7c09; });

var $fV3WI = parcelRequire("fV3WI");

var $fXLKn = parcelRequire("fXLKn");

var $h0s6D = parcelRequire("h0s6D");

var $3olSk = parcelRequire("3olSk");
function $aefed9d008d35275$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $aefed9d008d35275$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $aefed9d008d35275$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $aefed9d008d35275$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $aefed9d008d35275$var$_extends() {
    $aefed9d008d35275$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $aefed9d008d35275$var$_extends.apply(this, arguments);
}
function $aefed9d008d35275$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $aefed9d008d35275$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $aefed9d008d35275$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $aefed9d008d35275$var$noOp = function noOp() {
    return "";
};
var $aefed9d008d35275$var$SnackbarContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createContext({
    enqueueSnackbar: $aefed9d008d35275$var$noOp,
    closeSnackbar: $aefed9d008d35275$var$noOp
});
var $aefed9d008d35275$var$breakpoints = {
    downXs: "@media (max-width:599.95px)",
    upSm: "@media (min-width:600px)"
};
var $aefed9d008d35275$var$capitalise = function capitalise(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
var $aefed9d008d35275$var$originKeyExtractor = function originKeyExtractor(anchor) {
    return "" + $aefed9d008d35275$var$capitalise(anchor.vertical) + $aefed9d008d35275$var$capitalise(anchor.horizontal);
};
var $aefed9d008d35275$var$isDefined = function isDefined(value) {
    return !!value || value === 0;
};
var $aefed9d008d35275$var$UNMOUNTED = "unmounted";
var $aefed9d008d35275$var$EXITED = "exited";
var $aefed9d008d35275$var$ENTERING = "entering";
var $aefed9d008d35275$var$ENTERED = "entered";
var $aefed9d008d35275$var$EXITING = "exiting";
var $aefed9d008d35275$export$be58926105124dd4 = /*#__PURE__*/ function(_React$Component) {
    $aefed9d008d35275$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var appear = props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props["in"]) {
            if (appear) {
                initialStatus = $aefed9d008d35275$var$EXITED;
                _this.appearStatus = $aefed9d008d35275$var$ENTERING;
            } else initialStatus = $aefed9d008d35275$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $aefed9d008d35275$var$UNMOUNTED;
        else initialStatus = $aefed9d008d35275$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref["in"];
        if (nextIn && prevState.status === $aefed9d008d35275$var$UNMOUNTED) return {
            status: $aefed9d008d35275$var$EXITED
        };
        return null;
    };
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props["in"]) {
                if (status !== $aefed9d008d35275$var$ENTERING && status !== $aefed9d008d35275$var$ENTERED) nextStatus = $aefed9d008d35275$var$ENTERING;
            } else if (status === $aefed9d008d35275$var$ENTERING || status === $aefed9d008d35275$var$ENTERED) nextStatus = $aefed9d008d35275$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var enter = timeout;
        var exit = timeout;
        if (timeout != null && typeof timeout !== "number" && typeof timeout !== "string") {
            exit = timeout.exit;
            enter = timeout.enter;
        }
        return {
            exit: exit,
            enter: enter
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            this.cancelNextCallback();
            if (nextStatus === $aefed9d008d35275$var$ENTERING) this.performEnter(mounting);
            else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $aefed9d008d35275$var$EXITED) this.setState({
            status: $aefed9d008d35275$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var isAppearing = mounting;
        var timeouts = this.getTimeouts();
        if (!mounting && !enter) {
            this.safeSetState({
                status: $aefed9d008d35275$var$ENTERED
            }, function() {
                if (_this2.props.onEntered) _this2.props.onEntered(_this2.node, isAppearing);
            });
            return;
        }
        if (this.props.onEnter) this.props.onEnter(this.node, isAppearing);
        this.safeSetState({
            status: $aefed9d008d35275$var$ENTERING
        }, function() {
            if (_this2.props.onEntering) _this2.props.onEntering(_this2.node, isAppearing);
            _this2.onTransitionEnd(timeouts.enter, function() {
                _this2.safeSetState({
                    status: $aefed9d008d35275$var$ENTERED
                }, function() {
                    if (_this2.props.onEntered) _this2.props.onEntered(_this2.node, isAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $aefed9d008d35275$var$EXITED
            }, function() {
                if (_this3.props.onExited) _this3.props.onExited(_this3.node);
            });
            return;
        }
        if (this.props.onExit) this.props.onExit(this.node);
        this.safeSetState({
            status: $aefed9d008d35275$var$EXITING
        }, function() {
            if (_this3.props.onExiting) _this3.props.onExiting(_this3.node);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $aefed9d008d35275$var$EXITED
                }, function() {
                    if (_this3.props.onExited) _this3.props.onExited(_this3.node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null && this.nextCallback.cancel) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function() {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback();
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!this.node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(this.node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $aefed9d008d35275$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $aefed9d008d35275$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return children(status, childProps);
    };
    $aefed9d008d35275$var$_createClass(Transition, [
        {
            key: "node",
            get: function get() {
                var _this$props$nodeRef;
                var node = (_this$props$nodeRef = this.props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current;
                if (!node) throw new Error("notistack - Custom snackbar is not refForwarding");
                return node;
            }
        }
    ]);
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).Component);
function $aefed9d008d35275$var$noop() {}
$aefed9d008d35275$export$be58926105124dd4.defaultProps = {
    "in": false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $aefed9d008d35275$var$noop,
    onEntering: $aefed9d008d35275$var$noop,
    onEntered: $aefed9d008d35275$var$noop,
    onExit: $aefed9d008d35275$var$noop,
    onExiting: $aefed9d008d35275$var$noop,
    onExited: $aefed9d008d35275$var$noop
};
/**
 * Credit to MUI team @ https://mui.com
 */ /**
 * passes {value} to {ref}
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $aefed9d008d35275$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function $aefed9d008d35275$var$useForkRef(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return (0, $fV3WI.useMemo)(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            $aefed9d008d35275$var$setRef(refA, refValue);
            $aefed9d008d35275$var$setRef(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}
function $aefed9d008d35275$var$getTransitionProps(props) {
    var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style, mode = props.mode;
    return {
        duration: typeof timeout === "object" ? timeout[mode] || 0 : timeout,
        easing: style.transitionTimingFunction,
        delay: style.transitionDelay
    };
}
/**
 * Credit to MUI team @ https://mui.com
 */ var $aefed9d008d35275$var$defaultEasing = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
/**
 * CSS hack to force a repaint
 */ var $aefed9d008d35275$var$reflow = function reflow(node) {
    // We have to do something with node.scrollTop.
    // Otherwise it's removed from the compiled code by optimisers
    // eslint-disable-next-line no-self-assign
    node.scrollTop = node.scrollTop;
};
var $aefed9d008d35275$var$formatMs = function formatMs(milliseconds) {
    return Math.round(milliseconds) + "ms";
};
function $aefed9d008d35275$var$createTransition(props, options) {
    if (props === void 0) props = [
        "all"
    ];
    var _ref = options || {}, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 300 : _ref$duration, _ref$easing = _ref.easing, easing = _ref$easing === void 0 ? $aefed9d008d35275$var$defaultEasing.easeInOut : _ref$easing, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay;
    var properties = Array.isArray(props) ? props : [
        props
    ];
    return properties.map(function(animatedProp) {
        var formattedDuration = typeof duration === "string" ? duration : $aefed9d008d35275$var$formatMs(duration);
        var formattedDelay = typeof delay === "string" ? delay : $aefed9d008d35275$var$formatMs(delay);
        return animatedProp + " " + formattedDuration + " " + easing + " " + formattedDelay;
    }).join(",");
}
function $aefed9d008d35275$var$ownerDocument(node) {
    return node && node.ownerDocument || document;
}
function $aefed9d008d35275$var$ownerWindow(node) {
    var doc = $aefed9d008d35275$var$ownerDocument(node);
    return doc.defaultView || window;
}
/**
 * Corresponds to 10 frames at 60 Hz.
 * A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
 */ function $aefed9d008d35275$var$debounce(func, wait) {
    if (wait === void 0) wait = 166;
    var timeout;
    function debounced() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var later = function later() {
            // @ts-ignore
            func.apply(_this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}
/**
 * Translate the node so it can't be seen on the screen.
 * Later, we're going to translate the node back to its original location with `none`.
 */ function $aefed9d008d35275$var$getTranslateValue(direction, node) {
    var rect = node.getBoundingClientRect();
    var containerWindow = $aefed9d008d35275$var$ownerWindow(node);
    var transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        var computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue("-webkit-transform") || computedStyle.getPropertyValue("transform");
    }
    var offsetX = 0;
    var offsetY = 0;
    if (transform && transform !== "none" && typeof transform === "string") {
        var transformValues = transform.split("(")[1].split(")")[0].split(",");
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    switch(direction){
        case "left":
            return "translateX(" + (containerWindow.innerWidth + offsetX - rect.left) + "px)";
        case "right":
            return "translateX(-" + (rect.left + rect.width - offsetX) + "px)";
        case "up":
            return "translateY(" + (containerWindow.innerHeight + offsetY - rect.top) + "px)";
        default:
            // down
            return "translateY(-" + (rect.top + rect.height - offsetY) + "px)";
    }
}
function $aefed9d008d35275$var$setTranslateValue(direction, node) {
    if (!node) return;
    var transform = $aefed9d008d35275$var$getTranslateValue(direction, node);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
var $aefed9d008d35275$var$Slide = /*#__PURE__*/ (0, $fV3WI.forwardRef)(function(props, ref) {
    var children = props.children, _props$direction = props.direction, direction = _props$direction === void 0 ? "down" : _props$direction, inProp = props["in"], style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? 0 : _props$timeout, onEnter = props.onEnter, onEntered = props.onEntered, onExit = props.onExit, onExited = props.onExited, other = $aefed9d008d35275$var$_objectWithoutPropertiesLoose(props, [
        "children",
        "direction",
        "in",
        "style",
        "timeout",
        "onEnter",
        "onEntered",
        "onExit",
        "onExited"
    ]);
    var nodeRef = (0, $fV3WI.useRef)(null);
    var handleRefIntermediary = $aefed9d008d35275$var$useForkRef(children.ref, nodeRef);
    var handleRef = $aefed9d008d35275$var$useForkRef(handleRefIntermediary, ref);
    var handleEnter = function handleEnter(node, isAppearing) {
        $aefed9d008d35275$var$setTranslateValue(direction, node);
        $aefed9d008d35275$var$reflow(node);
        if (onEnter) onEnter(node, isAppearing);
    };
    var handleEntering = function handleEntering(node) {
        var easing = (style === null || style === void 0 ? void 0 : style.transitionTimingFunction) || $aefed9d008d35275$var$defaultEasing.easeOut;
        var transitionProps = $aefed9d008d35275$var$getTransitionProps({
            timeout: timeout,
            mode: "enter",
            style: $aefed9d008d35275$var$_extends({}, style, {
                transitionTimingFunction: easing
            })
        });
        node.style.webkitTransition = $aefed9d008d35275$var$createTransition("-webkit-transform", transitionProps);
        node.style.transition = $aefed9d008d35275$var$createTransition("transform", transitionProps);
        node.style.webkitTransform = "none";
        node.style.transform = "none";
    };
    var handleExit = function handleExit(node) {
        var easing = (style === null || style === void 0 ? void 0 : style.transitionTimingFunction) || $aefed9d008d35275$var$defaultEasing.sharp;
        var transitionProps = $aefed9d008d35275$var$getTransitionProps({
            timeout: timeout,
            mode: "exit",
            style: $aefed9d008d35275$var$_extends({}, style, {
                transitionTimingFunction: easing
            })
        });
        node.style.webkitTransition = $aefed9d008d35275$var$createTransition("-webkit-transform", transitionProps);
        node.style.transition = $aefed9d008d35275$var$createTransition("transform", transitionProps);
        $aefed9d008d35275$var$setTranslateValue(direction, node);
        if (onExit) onExit(node);
    };
    var handleExited = function handleExited(node) {
        // No need for transitions when the component is hidden
        node.style.webkitTransition = "";
        node.style.transition = "";
        if (onExited) onExited(node);
    };
    var updatePosition = (0, $fV3WI.useCallback)(function() {
        if (nodeRef.current) $aefed9d008d35275$var$setTranslateValue(direction, nodeRef.current);
    }, [
        direction
    ]);
    (0, $fV3WI.useEffect)(function() {
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === "down" || direction === "right") return undefined;
        var handleResize = $aefed9d008d35275$var$debounce(function() {
            if (nodeRef.current) $aefed9d008d35275$var$setTranslateValue(direction, nodeRef.current);
        });
        var containerWindow = $aefed9d008d35275$var$ownerWindow(nodeRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return function() {
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        direction,
        inProp
    ]);
    (0, $fV3WI.useEffect)(function() {
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return (0, $fV3WI.createElement)($aefed9d008d35275$export$be58926105124dd4, Object.assign({
        appear: true,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: onEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        "in": inProp,
        timeout: timeout
    }, other), function(state, childProps) {
        return (0, $fV3WI.cloneElement)(children, $aefed9d008d35275$var$_extends({
            ref: handleRef,
            style: $aefed9d008d35275$var$_extends({
                visibility: state === "exited" && !inProp ? "hidden" : undefined
            }, style, {}, children.props.style)
        }, childProps));
    });
});
$aefed9d008d35275$var$Slide.displayName = "Slide";
var $aefed9d008d35275$var$SvgIcon = function SvgIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement("svg", Object.assign({
        viewBox: "0 0 24 24",
        focusable: "false",
        style: {
            fontSize: 20,
            marginInlineEnd: 8,
            userSelect: "none",
            width: "1em",
            height: "1em",
            display: "inline-block",
            fill: "currentColor",
            flexShrink: 0
        }
    }, props));
};
var $aefed9d008d35275$var$CheckIcon = function CheckIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement($aefed9d008d35275$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement("path", {
        d: "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41\n        10.59L10 14.17L17.59 6.58L19 8L10 17Z"
    }));
};
var $aefed9d008d35275$var$WarningIcon = function WarningIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement($aefed9d008d35275$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement("path", {
        d: "M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"
    }));
};
var $aefed9d008d35275$var$ErrorIcon = function ErrorIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement($aefed9d008d35275$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement("path", {
        d: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,\n        6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,\n        13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
    }));
};
var $aefed9d008d35275$var$InfoIcon = function InfoIcon() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement($aefed9d008d35275$var$SvgIcon, null, (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement("path", {
        d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,\n        0 22,12A10,10 0 0,0 12,2Z"
    }));
};
var $aefed9d008d35275$var$defaultIconVariants = {
    "default": undefined,
    success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement($aefed9d008d35275$var$CheckIcon, null),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement($aefed9d008d35275$var$WarningIcon, null),
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement($aefed9d008d35275$var$ErrorIcon, null),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement($aefed9d008d35275$var$InfoIcon, null)
};
var $aefed9d008d35275$var$defaults = {
    maxSnack: 3,
    persist: false,
    hideIconVariant: false,
    disableWindowBlurListener: false,
    variant: "default",
    autoHideDuration: 5000,
    iconVariant: $aefed9d008d35275$var$defaultIconVariants,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
    },
    TransitionComponent: $aefed9d008d35275$var$Slide,
    transitionDuration: {
        enter: 225,
        exit: 195
    }
};
/**
 * Derives the right autoHideDuration taking into account the following
 * prority order: 1: Options, 2: Props, 3: default fallback
 */ var $aefed9d008d35275$var$getAutoHideDuration = function getAutoHideDuration(optionsDuration, propsDuration) {
    var isNumberOrNull = function isNumberOrNull(numberish) {
        return typeof numberish === "number" || numberish === null;
    };
    if (isNumberOrNull(optionsDuration)) return optionsDuration;
    if (isNumberOrNull(propsDuration)) return propsDuration;
    return $aefed9d008d35275$var$defaults.autoHideDuration;
};
/**
 * Derives the right transitionDuration taking into account the following
 * prority order: 1: Options, 2: Props, 3: default fallback
 */ var $aefed9d008d35275$var$getTransitionDuration = function getTransitionDuration(optionsDuration, propsDuration) {
    var is = function is(item, types) {
        return types.some(function(t) {
            return typeof item === t;
        });
    };
    if (is(optionsDuration, [
        "string",
        "number"
    ])) return optionsDuration;
    if (is(optionsDuration, [
        "object"
    ])) return $aefed9d008d35275$var$_extends({}, $aefed9d008d35275$var$defaults.transitionDuration, {}, is(propsDuration, [
        "object"
    ]) && propsDuration, {}, optionsDuration);
    if (is(propsDuration, [
        "string",
        "number"
    ])) return propsDuration;
    if (is(propsDuration, [
        "object"
    ])) return $aefed9d008d35275$var$_extends({}, $aefed9d008d35275$var$defaults.transitionDuration, {}, propsDuration);
    return $aefed9d008d35275$var$defaults.transitionDuration;
};
var $aefed9d008d35275$var$merge = function merge(options, props) {
    return function(name, shouldObjectMerge) {
        if (shouldObjectMerge === void 0) shouldObjectMerge = false;
        if (shouldObjectMerge) return $aefed9d008d35275$var$_extends({}, $aefed9d008d35275$var$defaults[name], {}, props[name], {}, options[name]);
        if (name === "autoHideDuration") return $aefed9d008d35275$var$getAutoHideDuration(options.autoHideDuration, props.autoHideDuration);
        if (name === "transitionDuration") return $aefed9d008d35275$var$getTransitionDuration(options.transitionDuration, props.transitionDuration);
        return options[name] || props[name] || $aefed9d008d35275$var$defaults[name];
    };
};
function $aefed9d008d35275$var$makeStyles(styles) {
    return Object.entries(styles).reduce(function(acc, _ref) {
        var _extends2;
        var key = _ref[0], value = _ref[1];
        return $aefed9d008d35275$var$_extends({}, acc, (_extends2 = {}, _extends2[key] = (0, $3olSk.css)(value), _extends2));
    }, {});
}
var $aefed9d008d35275$var$ComponentClasses = {
    SnackbarContainer: "notistack-SnackbarContainer",
    Snackbar: "notistack-Snackbar",
    CollapseWrapper: "notistack-CollapseWrapper",
    MuiContent: "notistack-MuiContent",
    MuiContentVariant: function MuiContentVariant(variant) {
        return "notistack-MuiContent-" + variant;
    }
};
var $aefed9d008d35275$var$classes = /*#__PURE__*/ $aefed9d008d35275$var$makeStyles({
    root: {
        height: 0
    },
    entered: {
        height: "auto"
    }
});
var $aefed9d008d35275$var$collapsedSize = "0px";
var $aefed9d008d35275$var$timeout = 175;
var $aefed9d008d35275$var$Collapse = /*#__PURE__*/ (0, $fV3WI.forwardRef)(function(props, ref) {
    var children = props.children, inProp = props["in"], onExited = props.onExited;
    var wrapperRef = (0, $fV3WI.useRef)(null);
    var nodeRef = (0, $fV3WI.useRef)(null);
    var handleRef = $aefed9d008d35275$var$useForkRef(ref, nodeRef);
    var getWrapperSize = function getWrapperSize() {
        return wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    };
    var handleEnter = function handleEnter(node) {
        node.style.height = $aefed9d008d35275$var$collapsedSize;
    };
    var handleEntering = function handleEntering(node) {
        var wrapperSize = getWrapperSize();
        var _getTransitionProps = $aefed9d008d35275$var$getTransitionProps({
            timeout: $aefed9d008d35275$var$timeout,
            mode: "enter"
        }), transitionDuration = _getTransitionProps.duration, easing = _getTransitionProps.easing;
        node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : transitionDuration + "ms";
        node.style.height = wrapperSize + "px";
        node.style.transitionTimingFunction = easing || "";
    };
    var handleEntered = function handleEntered(node) {
        node.style.height = "auto";
    };
    var handleExit = function handleExit(node) {
        node.style.height = getWrapperSize() + "px";
    };
    var handleExiting = function handleExiting(node) {
        $aefed9d008d35275$var$reflow(node);
        var _getTransitionProps2 = $aefed9d008d35275$var$getTransitionProps({
            timeout: $aefed9d008d35275$var$timeout,
            mode: "exit"
        }), transitionDuration = _getTransitionProps2.duration, easing = _getTransitionProps2.easing;
        node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : transitionDuration + "ms";
        node.style.height = $aefed9d008d35275$var$collapsedSize;
        node.style.transitionTimingFunction = easing || "";
    };
    return (0, $fV3WI.createElement)($aefed9d008d35275$export$be58926105124dd4, {
        "in": inProp,
        unmountOnExit: true,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: onExited,
        onExiting: handleExiting,
        nodeRef: nodeRef,
        timeout: $aefed9d008d35275$var$timeout
    }, function(state, childProps) {
        return (0, $fV3WI.createElement)("div", Object.assign({
            ref: handleRef,
            className: (0, $h0s6D.default)($aefed9d008d35275$var$classes.root, state === "entered" && $aefed9d008d35275$var$classes.entered),
            style: $aefed9d008d35275$var$_extends({
                pointerEvents: "all",
                overflow: "hidden",
                minHeight: $aefed9d008d35275$var$collapsedSize,
                transition: $aefed9d008d35275$var$createTransition("height")
            }, state === "entered" && {
                overflow: "visible"
            }, {}, state === "exited" && !inProp && {
                visibility: "hidden"
            })
        }, childProps), (0, $fV3WI.createElement)("div", {
            ref: wrapperRef,
            className: $aefed9d008d35275$var$ComponentClasses.CollapseWrapper,
            // Hack to get children with a negative margin to not falsify the height computation.
            style: {
                display: "flex",
                width: "100%"
            }
        }, children));
    });
});
$aefed9d008d35275$var$Collapse.displayName = "Collapse";
var $aefed9d008d35275$var$direction = {
    right: "left",
    left: "right",
    bottom: "up",
    top: "down"
};
var $aefed9d008d35275$var$getSlideDirection = function getSlideDirection(anchorOrigin) {
    if (anchorOrigin.horizontal !== "center") return $aefed9d008d35275$var$direction[anchorOrigin.horizontal];
    return $aefed9d008d35275$var$direction[anchorOrigin.vertical];
};
/** Tranforms classes name */ var $aefed9d008d35275$var$toSnackbarAnchorOrigin = function toSnackbarAnchorOrigin(anchorOrigin) {
    return "anchorOrigin" + $aefed9d008d35275$var$originKeyExtractor(anchorOrigin);
};
/**
 * Omit SnackbarContainer class keys that are not needed for SnackbarItem
 */ var $aefed9d008d35275$var$keepSnackbarClassKeys = function keepSnackbarClassKeys(classes) {
    if (classes === void 0) classes = {};
    var containerClasses = {
        containerRoot: true,
        containerAnchorOriginTopCenter: true,
        containerAnchorOriginBottomCenter: true,
        containerAnchorOriginTopRight: true,
        containerAnchorOriginBottomRight: true,
        containerAnchorOriginTopLeft: true,
        containerAnchorOriginBottomLeft: true
    };
    return Object.keys(classes).filter(function(key) {
        return !containerClasses[key];
    }).reduce(function(obj, key) {
        var _extends2;
        return $aefed9d008d35275$var$_extends({}, obj, (_extends2 = {}, _extends2[key] = classes[key], _extends2));
    }, {});
};
var $aefed9d008d35275$var$noOp$1 = function noOp() {
/* */ };
/**
 * Credit to MUI team @ https://mui.com
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $aefed9d008d35275$var$createChainedFunction(funcs, snackbarId) {
    // @ts-ignore
    return funcs.reduce(function(acc, func) {
        if (func === null || func === undefined) return acc;
        return function chainedFunction() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var argums = [].concat(args);
            if (snackbarId && argums.indexOf(snackbarId) === -1) argums.push(snackbarId);
             // @ts-ignore
            acc.apply(this, argums);
            func.apply(this, argums);
        };
    }, $aefed9d008d35275$var$noOp$1);
}
/**
 * Credit to MUI team @ https://mui.com
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 */ var $aefed9d008d35275$var$useEnhancedEffect = typeof window !== "undefined" ? (0, $fV3WI.useLayoutEffect) : (0, $fV3WI.useEffect);
function $aefed9d008d35275$var$useEventCallback(fn) {
    var ref = (0, $fV3WI.useRef)(fn);
    $aefed9d008d35275$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return (0, $fV3WI.useCallback)(function() {
        return ref.current.apply(void 0, arguments);
    }, []);
}
/**
 * Credit to MUI team @ https://mui.com
 */ var $aefed9d008d35275$var$Snackbar = /*#__PURE__*/ (0, $fV3WI.forwardRef)(function(props, ref) {
    var children = props.children, className = props.className, autoHideDuration = props.autoHideDuration, _props$disableWindowB = props.disableWindowBlurListener, disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB, onClose = props.onClose, id = props.id, open = props.open, _props$SnackbarProps = props.SnackbarProps, SnackbarProps = _props$SnackbarProps === void 0 ? {} : _props$SnackbarProps;
    var timerAutoHide = (0, $fV3WI.useRef)();
    var handleClose = $aefed9d008d35275$var$useEventCallback(function() {
        if (onClose) onClose.apply(void 0, arguments);
    });
    var setAutoHideTimer = $aefed9d008d35275$var$useEventCallback(function(autoHideDurationParam) {
        if (!onClose || autoHideDurationParam == null) return;
        if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(function() {
            handleClose(null, "timeout", id);
        }, autoHideDurationParam);
    });
    (0, $fV3WI.useEffect)(function() {
        if (open) setAutoHideTimer(autoHideDuration);
        return function() {
            if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]);
    /**
   * Pause the timer when the user is interacting with the Snackbar
   * or when the user hide the window.
   */ var handlePause = function handlePause() {
        if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
    };
    /**
   * Restart the timer when the user is no longer interacting with the Snackbar
   * or when the window is shown back.
   */ var handleResume = (0, $fV3WI.useCallback)(function() {
        if (autoHideDuration != null) setAutoHideTimer(autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        setAutoHideTimer
    ]);
    var handleMouseEnter = function handleMouseEnter(event) {
        if (SnackbarProps.onMouseEnter) SnackbarProps.onMouseEnter(event);
        handlePause();
    };
    var handleMouseLeave = function handleMouseLeave(event) {
        if (SnackbarProps.onMouseLeave) SnackbarProps.onMouseLeave(event);
        handleResume();
    };
    (0, $fV3WI.useEffect)(function() {
        if (!disableWindowBlurListener && open) {
            window.addEventListener("focus", handleResume);
            window.addEventListener("blur", handlePause);
            return function() {
                window.removeEventListener("focus", handleResume);
                window.removeEventListener("blur", handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]);
    return (0, $fV3WI.createElement)("div", Object.assign({
        ref: ref
    }, SnackbarProps, {
        className: (0, $h0s6D.default)($aefed9d008d35275$var$ComponentClasses.Snackbar, className),
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
    }), children);
});
$aefed9d008d35275$var$Snackbar.displayName = "Snackbar";
var $aefed9d008d35275$var$_root;
var $aefed9d008d35275$var$classes$1 = /*#__PURE__*/ $aefed9d008d35275$var$makeStyles({
    root: ($aefed9d008d35275$var$_root = {
        display: "flex",
        flexWrap: "wrap",
        flexGrow: 1
    }, $aefed9d008d35275$var$_root[$aefed9d008d35275$var$breakpoints.upSm] = {
        flexGrow: "initial",
        minWidth: "288px"
    }, $aefed9d008d35275$var$_root)
});
var $aefed9d008d35275$export$860cef82710cac7 = /*#__PURE__*/ (0, $fV3WI.forwardRef)(function(_ref, ref) {
    var className = _ref.className, props = $aefed9d008d35275$var$_objectWithoutPropertiesLoose(_ref, [
        "className"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement("div", Object.assign({
        ref: ref,
        className: (0, $h0s6D.default)($aefed9d008d35275$var$classes$1.root, className)
    }, props));
});
$aefed9d008d35275$export$860cef82710cac7.displayName = "SnackbarContent";
var $aefed9d008d35275$var$classes$2 = /*#__PURE__*/ $aefed9d008d35275$var$makeStyles({
    root: {
        backgroundColor: "#313131",
        fontSize: "0.875rem",
        lineHeight: 1.43,
        letterSpacing: "0.01071em",
        color: "#fff",
        alignItems: "center",
        padding: "6px 16px",
        borderRadius: "4px",
        boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)"
    },
    lessPadding: {
        paddingLeft: "20px"
    },
    "default": {
        backgroundColor: "#313131"
    },
    success: {
        backgroundColor: "#43a047"
    },
    error: {
        backgroundColor: "#d32f2f"
    },
    warning: {
        backgroundColor: "#ff9800"
    },
    info: {
        backgroundColor: "#2196f3"
    },
    message: {
        display: "flex",
        alignItems: "center",
        padding: "8px 0"
    },
    action: {
        display: "flex",
        alignItems: "center",
        marginLeft: "auto",
        paddingLeft: "16px",
        marginRight: "-8px"
    }
});
var $aefed9d008d35275$var$ariaDescribedby = "notistack-snackbar";
var $aefed9d008d35275$var$MaterialDesignContent = /*#__PURE__*/ (0, $fV3WI.forwardRef)(function(props, forwardedRef) {
    var id = props.id, message = props.message, componentOrFunctionAction = props.action, iconVariant = props.iconVariant, variant = props.variant, hideIconVariant = props.hideIconVariant, style = props.style, className = props.className;
    var icon = iconVariant[variant];
    var action = componentOrFunctionAction;
    if (typeof action === "function") action = action(id);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement($aefed9d008d35275$export$860cef82710cac7, {
        ref: forwardedRef,
        role: "alert",
        "aria-describedby": $aefed9d008d35275$var$ariaDescribedby,
        style: style,
        className: (0, $h0s6D.default)($aefed9d008d35275$var$ComponentClasses.MuiContent, $aefed9d008d35275$var$ComponentClasses.MuiContentVariant(variant), $aefed9d008d35275$var$classes$2.root, $aefed9d008d35275$var$classes$2[variant], className, !hideIconVariant && icon && $aefed9d008d35275$var$classes$2.lessPadding)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement("div", {
        id: $aefed9d008d35275$var$ariaDescribedby,
        className: $aefed9d008d35275$var$classes$2.message
    }, !hideIconVariant ? icon : null, message), action && (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement("div", {
        className: $aefed9d008d35275$var$classes$2.action
    }, action));
});
$aefed9d008d35275$var$MaterialDesignContent.displayName = "MaterialDesignContent";
var $aefed9d008d35275$export$407b0b907b65dfeb = /*#__PURE__*/ (0, $fV3WI.memo)($aefed9d008d35275$var$MaterialDesignContent);
var $aefed9d008d35275$var$styles = /*#__PURE__*/ $aefed9d008d35275$var$makeStyles({
    wrappedRoot: {
        width: "100%",
        position: "relative",
        transform: "translateX(0)",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        minWidth: "288px"
    }
});
var $aefed9d008d35275$var$SnackbarItem = function SnackbarItem(props) {
    var timeout = (0, $fV3WI.useRef)();
    var _useState = (0, $fV3WI.useState)(true), collapsed = _useState[0], setCollapsed = _useState[1];
    var handleClose = $aefed9d008d35275$var$createChainedFunction([
        props.snack.onClose,
        props.onClose
    ]);
    var handleEntered = function handleEntered() {
        if (props.snack.requestClose) handleClose(null, "instructed", props.snack.id);
    };
    var handleExitedScreen = (0, $fV3WI.useCallback)(function() {
        timeout.current = setTimeout(function() {
            setCollapsed(function(col) {
                return !col;
            });
        }, 125);
    }, []);
    (0, $fV3WI.useEffect)(function() {
        return function() {
            if (timeout.current) clearTimeout(timeout.current);
        };
    }, []);
    var snack = props.snack, allClasses = props.classes, _props$Component = props.Component, Component = _props$Component === void 0 ? $aefed9d008d35275$export$407b0b907b65dfeb : _props$Component;
    var classes = (0, $fV3WI.useMemo)(function() {
        return $aefed9d008d35275$var$keepSnackbarClassKeys(allClasses);
    }, [
        allClasses
    ]);
    var open = snack.open, SnackbarProps = snack.SnackbarProps, TransitionComponent = snack.TransitionComponent, TransitionProps = snack.TransitionProps, transitionDuration = snack.transitionDuration, disableWindowBlurListener = snack.disableWindowBlurListener, componentOrFunctionContent = snack.content, otherSnack = $aefed9d008d35275$var$_objectWithoutPropertiesLoose(snack, [
        "open",
        "SnackbarProps",
        "TransitionComponent",
        "TransitionProps",
        "transitionDuration",
        "disableWindowBlurListener",
        "content",
        "entered",
        "requestClose",
        "onEnter",
        "onEntered",
        "onExit",
        "onExited"
    ]);
    var transitionProps = $aefed9d008d35275$var$_extends({
        direction: $aefed9d008d35275$var$getSlideDirection(otherSnack.anchorOrigin),
        timeout: transitionDuration
    }, TransitionProps);
    var content = componentOrFunctionContent;
    if (typeof content === "function") content = content(otherSnack.id, otherSnack.message);
    var callbacks = [
        "onEnter",
        "onEntered",
        "onExit",
        "onExited"
    ].reduce(function(acc, cbName) {
        var _extends2;
        return $aefed9d008d35275$var$_extends({}, acc, (_extends2 = {}, _extends2[cbName] = $aefed9d008d35275$var$createChainedFunction([
            props.snack[cbName],
            props[cbName]
        ], otherSnack.id), _extends2));
    }, {});
    return (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement($aefed9d008d35275$var$Collapse, {
        "in": collapsed,
        onExited: callbacks.onExited
    }, (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement($aefed9d008d35275$var$Snackbar, {
        open: open,
        id: otherSnack.id,
        disableWindowBlurListener: disableWindowBlurListener,
        autoHideDuration: otherSnack.autoHideDuration,
        className: (0, $h0s6D.default)($aefed9d008d35275$var$styles.wrappedRoot, classes.root, classes[$aefed9d008d35275$var$toSnackbarAnchorOrigin(otherSnack.anchorOrigin)]),
        SnackbarProps: SnackbarProps,
        onClose: handleClose
    }, (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement(TransitionComponent, Object.assign({}, transitionProps, {
        appear: true,
        "in": open,
        onExit: callbacks.onExit,
        onExited: handleExitedScreen,
        onEnter: callbacks.onEnter,
        // order matters. first callbacks.onEntered to set entered: true,
        // then handleEntered to check if there's a request for closing
        onEntered: $aefed9d008d35275$var$createChainedFunction([
            callbacks.onEntered,
            handleEntered
        ], otherSnack.id)
    }), content || (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement(Component, Object.assign({}, otherSnack)))));
};
var $aefed9d008d35275$var$_root$1, $aefed9d008d35275$var$_rootDense, $aefed9d008d35275$var$_left, $aefed9d008d35275$var$_right, $aefed9d008d35275$var$_center;
var $aefed9d008d35275$var$indents = {
    view: {
        "default": 20,
        dense: 4
    },
    snackbar: {
        "default": 6,
        dense: 2
    }
};
var $aefed9d008d35275$var$collapseWrapper = "." + $aefed9d008d35275$var$ComponentClasses.CollapseWrapper;
var $aefed9d008d35275$var$xsWidthMargin = 16;
var $aefed9d008d35275$var$styles$1 = /*#__PURE__*/ $aefed9d008d35275$var$makeStyles({
    root: ($aefed9d008d35275$var$_root$1 = {
        boxSizing: "border-box",
        display: "flex",
        maxHeight: "100%",
        position: "fixed",
        zIndex: 1400,
        height: "auto",
        width: "auto",
        transition: /*#__PURE__*/ $aefed9d008d35275$var$createTransition([
            "top",
            "right",
            "bottom",
            "left",
            "max-width"
        ], {
            duration: 300,
            easing: "ease"
        }),
        // container itself is invisible and should not block clicks, clicks should be passed to its children
        // a pointerEvents: all is applied in the collapse component
        pointerEvents: "none"
    }, $aefed9d008d35275$var$_root$1[$aefed9d008d35275$var$collapseWrapper] = {
        padding: $aefed9d008d35275$var$indents.snackbar["default"] + "px 0px",
        transition: "padding 300ms ease 0ms"
    }, $aefed9d008d35275$var$_root$1.maxWidth = "calc(100% - " + $aefed9d008d35275$var$indents.view["default"] * 2 + "px)", $aefed9d008d35275$var$_root$1[$aefed9d008d35275$var$breakpoints.downXs] = {
        width: "100%",
        maxWidth: "calc(100% - " + $aefed9d008d35275$var$xsWidthMargin * 2 + "px)"
    }, $aefed9d008d35275$var$_root$1),
    rootDense: ($aefed9d008d35275$var$_rootDense = {}, $aefed9d008d35275$var$_rootDense[$aefed9d008d35275$var$collapseWrapper] = {
        padding: $aefed9d008d35275$var$indents.snackbar.dense + "px 0px"
    }, $aefed9d008d35275$var$_rootDense),
    top: {
        top: $aefed9d008d35275$var$indents.view["default"] - $aefed9d008d35275$var$indents.snackbar["default"] + "px",
        flexDirection: "column"
    },
    bottom: {
        bottom: $aefed9d008d35275$var$indents.view["default"] - $aefed9d008d35275$var$indents.snackbar["default"] + "px",
        flexDirection: "column-reverse"
    },
    left: ($aefed9d008d35275$var$_left = {
        left: $aefed9d008d35275$var$indents.view["default"] + "px"
    }, $aefed9d008d35275$var$_left[$aefed9d008d35275$var$breakpoints.upSm] = {
        alignItems: "flex-start"
    }, $aefed9d008d35275$var$_left[$aefed9d008d35275$var$breakpoints.downXs] = {
        left: $aefed9d008d35275$var$xsWidthMargin + "px"
    }, $aefed9d008d35275$var$_left),
    right: ($aefed9d008d35275$var$_right = {
        right: $aefed9d008d35275$var$indents.view["default"] + "px"
    }, $aefed9d008d35275$var$_right[$aefed9d008d35275$var$breakpoints.upSm] = {
        alignItems: "flex-end"
    }, $aefed9d008d35275$var$_right[$aefed9d008d35275$var$breakpoints.downXs] = {
        right: $aefed9d008d35275$var$xsWidthMargin + "px"
    }, $aefed9d008d35275$var$_right),
    center: ($aefed9d008d35275$var$_center = {
        left: "50%",
        transform: "translateX(-50%)"
    }, $aefed9d008d35275$var$_center[$aefed9d008d35275$var$breakpoints.upSm] = {
        alignItems: "center"
    }, $aefed9d008d35275$var$_center)
});
var $aefed9d008d35275$var$SnackbarContainer = function SnackbarContainer(props) {
    var _props$classes = props.classes, classes = _props$classes === void 0 ? {} : _props$classes, anchorOrigin = props.anchorOrigin, dense = props.dense, children = props.children;
    var combinedClassname = (0, $h0s6D.default)($aefed9d008d35275$var$ComponentClasses.SnackbarContainer, $aefed9d008d35275$var$styles$1[anchorOrigin.vertical], $aefed9d008d35275$var$styles$1[anchorOrigin.horizontal], $aefed9d008d35275$var$styles$1.root, classes.containerRoot, classes["containerAnchorOrigin" + $aefed9d008d35275$var$originKeyExtractor(anchorOrigin)], dense && $aefed9d008d35275$var$styles$1.rootDense);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement("div", {
        className: combinedClassname
    }, children);
};
var $aefed9d008d35275$var$SnackbarContainer$1 = /*#__PURE__*/ (0, $fV3WI.memo)($aefed9d008d35275$var$SnackbarContainer);
/* eslint-disable */ var $aefed9d008d35275$var$__DEV__ = false;
var $aefed9d008d35275$var$messages = {
    NO_PERSIST_ALL: "Reached maxSnack while all enqueued snackbars have 'persist' flag. Notistack will dismiss the oldest snackbar anyway to allow other ones in the queue to be presented."
};
var $aefed9d008d35275$var$warning = function(messageKey) {
    if (!$aefed9d008d35275$var$__DEV__) return;
    var message = $aefed9d008d35275$var$messages[messageKey];
    if (typeof console !== "undefined") console.error("WARNING - notistack: " + message);
    try {
        throw new Error(message);
    } catch (x) {}
};
var $aefed9d008d35275$var$isOptions = function isOptions(messageOrOptions) {
    var isMessage = typeof messageOrOptions === "string" || (0, $fV3WI.isValidElement)(messageOrOptions);
    return !isMessage;
};
var $aefed9d008d35275$export$9d70c354f0150b1b;
var $aefed9d008d35275$export$823cdc5238933767;
var $aefed9d008d35275$export$d1e619fddc3508ce = /*#__PURE__*/ function(_Component) {
    $aefed9d008d35275$var$_inheritsLoose(SnackbarProvider, _Component);
    function SnackbarProvider(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        /**
     * Adds a new snackbar to the queue to be presented.
     * Returns generated or user defined key referencing the new snackbar or null
     */ _this.enqueueSnackbar = function(messageOrOptions, optsOrUndefined) {
            if (optsOrUndefined === void 0) optsOrUndefined = {};
            if (messageOrOptions === undefined || messageOrOptions === null) throw new Error("enqueueSnackbar called with invalid argument");
            var opts = $aefed9d008d35275$var$isOptions(messageOrOptions) ? messageOrOptions : optsOrUndefined;
            var message = $aefed9d008d35275$var$isOptions(messageOrOptions) ? messageOrOptions.message : messageOrOptions;
            var key = opts.key, preventDuplicate = opts.preventDuplicate, options = $aefed9d008d35275$var$_objectWithoutPropertiesLoose(opts, [
                "key",
                "preventDuplicate"
            ]);
            var hasSpecifiedKey = $aefed9d008d35275$var$isDefined(key);
            var id = hasSpecifiedKey ? key : new Date().getTime() + Math.random();
            var merger = $aefed9d008d35275$var$merge(options, _this.props);
            var snack = $aefed9d008d35275$var$_extends({
                id: id
            }, options, {
                message: message,
                open: true,
                entered: false,
                requestClose: false,
                persist: merger("persist"),
                action: merger("action"),
                content: merger("content"),
                variant: merger("variant"),
                anchorOrigin: merger("anchorOrigin"),
                disableWindowBlurListener: merger("disableWindowBlurListener"),
                autoHideDuration: merger("autoHideDuration"),
                hideIconVariant: merger("hideIconVariant"),
                TransitionComponent: merger("TransitionComponent"),
                transitionDuration: merger("transitionDuration"),
                TransitionProps: merger("TransitionProps", true),
                iconVariant: merger("iconVariant", true),
                style: merger("style", true),
                SnackbarProps: merger("SnackbarProps", true),
                className: (0, $h0s6D.default)(_this.props.className, options.className)
            });
            if (snack.persist) snack.autoHideDuration = undefined;
            _this.setState(function(state) {
                if (preventDuplicate === undefined && _this.props.preventDuplicate || preventDuplicate) {
                    var compareFunction = function compareFunction(item) {
                        return hasSpecifiedKey ? item.id === id : item.message === message;
                    };
                    var inQueue = state.queue.findIndex(compareFunction) > -1;
                    var inView = state.snacks.findIndex(compareFunction) > -1;
                    if (inQueue || inView) return state;
                }
                return _this.handleDisplaySnack($aefed9d008d35275$var$_extends({}, state, {
                    queue: [].concat(state.queue, [
                        snack
                    ])
                }));
            });
            return id;
        };
        /**
     * Reducer: Display snack if there's space for it. Otherwise, immediately
     * begin dismissing the oldest message to start showing the new one.
     */ _this.handleDisplaySnack = function(state) {
            var snacks = state.snacks;
            if (snacks.length >= _this.maxSnack) return _this.handleDismissOldest(state);
            return _this.processQueue(state);
        };
        /**
     * Reducer: Display items (notifications) in the queue if there's space for them.
     */ _this.processQueue = function(state) {
            var queue = state.queue, snacks = state.snacks;
            if (queue.length > 0) return $aefed9d008d35275$var$_extends({}, state, {
                snacks: [].concat(snacks, [
                    queue[0]
                ]),
                queue: queue.slice(1, queue.length)
            });
            return state;
        };
        /**
     * Reducer: Hide oldest snackbar on the screen because there exists a new one which we have to display.
     * (ignoring the one with 'persist' flag. i.e. explicitly told by user not to get dismissed).
     *
     * Note 1: If there is already a message leaving the screen, no new messages are dismissed.
     * Note 2: If the oldest message has not yet entered the screen, only a request to close the
     *         snackbar is made. Once it entered the screen, it will be immediately dismissed.
     */ _this.handleDismissOldest = function(state) {
            if (state.snacks.some(function(item) {
                return !item.open || item.requestClose;
            })) return state;
            var popped = false;
            var ignore = false;
            var persistentCount = state.snacks.reduce(function(acc, current) {
                return acc + (current.open && current.persist ? 1 : 0);
            }, 0);
            if (persistentCount === _this.maxSnack) ignore = true;
            var snacks = state.snacks.map(function(item) {
                if (!popped && (!item.persist || ignore)) {
                    popped = true;
                    if (!item.entered) return $aefed9d008d35275$var$_extends({}, item, {
                        requestClose: true
                    });
                    if (item.onClose) item.onClose(null, "maxsnack", item.id);
                    if (_this.props.onClose) _this.props.onClose(null, "maxsnack", item.id);
                    return $aefed9d008d35275$var$_extends({}, item, {
                        open: false
                    });
                }
                return $aefed9d008d35275$var$_extends({}, item);
            });
            return $aefed9d008d35275$var$_extends({}, state, {
                snacks: snacks
            });
        };
        /**
     * Set the entered state of the snackbar with the given key.
     */ _this.handleEnteredSnack = function(node, isAppearing, key) {
            if (!$aefed9d008d35275$var$isDefined(key)) throw new Error("handleEnteredSnack Cannot be called with undefined key");
            _this.setState(function(_ref) {
                var snacks = _ref.snacks;
                return {
                    snacks: snacks.map(function(item) {
                        return item.id === key ? $aefed9d008d35275$var$_extends({}, item, {
                            entered: true
                        }) : $aefed9d008d35275$var$_extends({}, item);
                    })
                };
            });
        };
        /**
     * Hide a snackbar after its timeout.
     */ _this.handleCloseSnack = function(event, reason, key) {
            // should not use createChainedFunction for onClose.
            // because this.closeSnackbar called this function
            if (_this.props.onClose) _this.props.onClose(event, reason, key);
            var shouldCloseAll = key === undefined;
            _this.setState(function(_ref2) {
                var snacks = _ref2.snacks, queue = _ref2.queue;
                return {
                    snacks: snacks.map(function(item) {
                        if (!shouldCloseAll && item.id !== key) return $aefed9d008d35275$var$_extends({}, item);
                        return item.entered ? $aefed9d008d35275$var$_extends({}, item, {
                            open: false
                        }) : $aefed9d008d35275$var$_extends({}, item, {
                            requestClose: true
                        });
                    }),
                    queue: queue.filter(function(item) {
                        return item.id !== key;
                    })
                };
            });
        };
        /**
     * Close snackbar with the given key
     */ _this.closeSnackbar = function(key) {
            // call individual snackbar onClose callback passed through options parameter
            var toBeClosed = _this.state.snacks.find(function(item) {
                return item.id === key;
            });
            if ($aefed9d008d35275$var$isDefined(key) && toBeClosed && toBeClosed.onClose) toBeClosed.onClose(null, "instructed", key);
            _this.handleCloseSnack(null, "instructed", key);
        };
        /**
     * When we set open attribute of a snackbar to false (i.e. after we hide a snackbar),
     * it leaves the screen and immediately after leaving animation is done, this method
     * gets called. We remove the hidden snackbar from state and then display notifications
     * waiting in the queue (if any). If after this process the queue is not empty, the
     * oldest message is dismissed.
     */ _this.handleExitedSnack = function(node, key) {
            if (!$aefed9d008d35275$var$isDefined(key)) throw new Error("handleExitedSnack Cannot be called with undefined key");
            _this.setState(function(state) {
                var newState = _this.processQueue($aefed9d008d35275$var$_extends({}, state, {
                    snacks: state.snacks.filter(function(item) {
                        return item.id !== key;
                    })
                }));
                if (newState.queue.length === 0) return newState;
                return _this.handleDismissOldest(newState);
            });
        };
        $aefed9d008d35275$export$9d70c354f0150b1b = _this.enqueueSnackbar;
        $aefed9d008d35275$export$823cdc5238933767 = _this.closeSnackbar;
        _this.state = {
            snacks: [],
            queue: [],
            contextValue: {
                enqueueSnackbar: _this.enqueueSnackbar.bind($aefed9d008d35275$var$_assertThisInitialized(_this)),
                closeSnackbar: _this.closeSnackbar.bind($aefed9d008d35275$var$_assertThisInitialized(_this))
            }
        };
        return _this;
    }
    var _proto = SnackbarProvider.prototype;
    _proto.render = function render() {
        var _this2 = this;
        var contextValue = this.state.contextValue;
        var _this$props = this.props, domRoot = _this$props.domRoot, children = _this$props.children, _this$props$dense = _this$props.dense, dense = _this$props$dense === void 0 ? false : _this$props$dense, _this$props$Component = _this$props.Components, Components = _this$props$Component === void 0 ? {} : _this$props$Component, classes = _this$props.classes;
        var categ = this.state.snacks.reduce(function(acc, current) {
            var _extends2;
            var category = $aefed9d008d35275$var$originKeyExtractor(current.anchorOrigin);
            var existingOfCategory = acc[category] || [];
            return $aefed9d008d35275$var$_extends({}, acc, (_extends2 = {}, _extends2[category] = [].concat(existingOfCategory, [
                current
            ]), _extends2));
        }, {});
        var snackbars = Object.keys(categ).map(function(origin) {
            var snacks = categ[origin];
            var nomineeSnack = snacks[0];
            return (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement($aefed9d008d35275$var$SnackbarContainer$1, {
                key: origin,
                dense: dense,
                anchorOrigin: nomineeSnack.anchorOrigin,
                classes: classes
            }, snacks.map(function(snack) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement($aefed9d008d35275$var$SnackbarItem, {
                    key: snack.id,
                    snack: snack,
                    classes: classes,
                    Component: Components[snack.variant],
                    onClose: _this2.handleCloseSnack,
                    onEnter: _this2.props.onEnter,
                    onExit: _this2.props.onExit,
                    onExited: $aefed9d008d35275$var$createChainedFunction([
                        _this2.handleExitedSnack,
                        _this2.props.onExited
                    ], snack.id),
                    onEntered: $aefed9d008d35275$var$createChainedFunction([
                        _this2.handleEnteredSnack,
                        _this2.props.onEntered
                    ], snack.id)
                });
            }));
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement($aefed9d008d35275$var$SnackbarContext.Provider, {
            value: contextValue
        }, children, domRoot ? (0, $fXLKn.createPortal)(snackbars, domRoot) : snackbars);
    };
    $aefed9d008d35275$var$_createClass(SnackbarProvider, [
        {
            key: "maxSnack",
            get: function get() {
                return this.props.maxSnack || $aefed9d008d35275$var$defaults.maxSnack;
            }
        }
    ]);
    return SnackbarProvider;
}((0, $fV3WI.Component));
var $aefed9d008d35275$export$1c97ac2c9a6e7c09 = function() {
    return (0, $fV3WI.useContext)($aefed9d008d35275$var$SnackbarContext);
};

});
parcelRequire.register("3olSk", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $278494fbb2991833$export$dbf350e5966cf602; });
let $278494fbb2991833$var$e = {
    data: ""
}, $278494fbb2991833$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $278494fbb2991833$var$e, $278494fbb2991833$export$54aba348a7896325 = (e)=>{
    let r = $278494fbb2991833$var$t(e), l = r.data;
    return r.data = "", l;
}, $278494fbb2991833$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $278494fbb2991833$var$a = /\/\*[^]*?\*\/|  +/g, $278494fbb2991833$var$n = /\n+/g, $278494fbb2991833$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $278494fbb2991833$var$o(c, n) : n + "{" + $278494fbb2991833$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $278494fbb2991833$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/(^:.*)|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $278494fbb2991833$var$o.p ? $278494fbb2991833$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $278494fbb2991833$var$c = {}, $278494fbb2991833$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $278494fbb2991833$var$s(e[r]);
        return t;
    }
    return e;
}, $278494fbb2991833$var$i = (e, t, r, i, p)=>{
    let u = $278494fbb2991833$var$s(e), d = $278494fbb2991833$var$c[u] || ($278494fbb2991833$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$278494fbb2991833$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $278494fbb2991833$var$l.exec(e.replace($278494fbb2991833$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($278494fbb2991833$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($278494fbb2991833$var$n, " ").trim();
            return o[0];
        })(e);
        $278494fbb2991833$var$c[d] = $278494fbb2991833$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $278494fbb2991833$var$c.g ? $278494fbb2991833$var$c.g : null;
    return r && ($278494fbb2991833$var$c.g = $278494fbb2991833$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($278494fbb2991833$var$c[d], t, i, f), d;
}, $278494fbb2991833$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $278494fbb2991833$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $278494fbb2991833$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $278494fbb2991833$var$i(l.unshift ? l.raw ? $278494fbb2991833$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $278494fbb2991833$var$t(r.target), r.g, r.o, r.k);
}
let $278494fbb2991833$var$d, $278494fbb2991833$var$f, $278494fbb2991833$var$g, $278494fbb2991833$export$442f1a04865e4790 = $278494fbb2991833$export$dbf350e5966cf602.bind({
    g: 1
}), $278494fbb2991833$export$d25ddfdf17c3ad3e = $278494fbb2991833$export$dbf350e5966cf602.bind({
    k: 1
});
function $278494fbb2991833$export$de27182ff8187d6c(e, t, r, l) {
    $278494fbb2991833$var$o.p = t, $278494fbb2991833$var$d = e, $278494fbb2991833$var$f = r, $278494fbb2991833$var$g = l;
}
function $278494fbb2991833$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $278494fbb2991833$var$f && $278494fbb2991833$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $278494fbb2991833$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $278494fbb2991833$var$g && i[0] && $278494fbb2991833$var$g(c), $278494fbb2991833$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}

});



parcelRequire.register("9bG6e", function(module, exports) {

$parcel$export(module.exports, "useLoginSuccess", function () { return $4c3c5e46df865b18$export$c8d382062aadc958; });
function $4c3c5e46df865b18$export$c8d382062aadc958() {
    return ({ redirectUrl: redirectUrl  })=>{
        localStorage.removeItem("authData");
        window.location.assign(redirectUrl);
    };
}

});

parcelRequire.register("lpNwr", function(module, exports) {

$parcel$export(module.exports, "useConfig", function () { return $6c3720407e78797e$export$b3611e87cd5ba6ce; });

var $gAFWW = parcelRequire("gAFWW");
const $6c3720407e78797e$export$b3611e87cd5ba6ce = ()=>{
    const config = (0, $gAFWW.useConfig)();
    const { COGNITO_REGION: COGNITO_REGION , COGNITO_USER_POOL_ID: COGNITO_USER_POOL_ID , COGNITO_USER_POOL_CLIENT_ID: COGNITO_USER_POOL_CLIENT_ID , ENABLE_REGISTRATION: ENABLE_REGISTRATION , STRONG_PASSWORD_VALIDATION: STRONG_PASSWORD_VALIDATION , DEFAULT_REGISTRATION_ROUTES: DEFAULT_REGISTRATION_ROUTES , IDENTITY_PROVIDERS: IDENTITY_PROVIDERS , REACT_APP_GTM_ID: REACT_APP_GTM_ID , REACT_APP_GTM_PREVIEW: REACT_APP_GTM_PREVIEW , REACT_APP_GTM_AUTH: REACT_APP_GTM_AUTH  } = config?.ENV || {};
    const { REACT_APP_ENV: REACT_APP_ENV , REACT_APP_SENTRY_DSN: REACT_APP_SENTRY_DSN  } = config?.APP || {};
    const amplifyConfig = COGNITO_REGION && COGNITO_USER_POOL_ID && COGNITO_USER_POOL_CLIENT_ID ? {
        region: COGNITO_REGION,
        userPoolId: COGNITO_USER_POOL_ID,
        userPoolWebClientId: COGNITO_USER_POOL_CLIENT_ID
    } : undefined;
    const gtm = REACT_APP_GTM_ID && REACT_APP_GTM_PREVIEW && REACT_APP_GTM_AUTH ? {
        REACT_APP_GTM_ID: REACT_APP_GTM_ID,
        REACT_APP_GTM_PREVIEW: REACT_APP_GTM_PREVIEW,
        REACT_APP_GTM_AUTH: REACT_APP_GTM_AUTH
    } : undefined;
    return !!config ? {
        isRegistrationEnabled: !!ENABLE_REGISTRATION,
        isStrongPasswordEnabled: !!STRONG_PASSWORD_VALIDATION,
        defaultRegistrationRoutes: DEFAULT_REGISTRATION_ROUTES ?? [],
        identityProviders: {
            email: IDENTITY_PROVIDERS.includes("EMAIL") ? "Email" : undefined,
            google: IDENTITY_PROVIDERS.includes("GOOGLE") ? "Google" : undefined,
            googleWorkspace: IDENTITY_PROVIDERS.includes("GOOGLE-WORKSPACE") ? "Google-Workspace" : undefined
        },
        amplifyConfig: amplifyConfig,
        APP_ENV: REACT_APP_ENV,
        SENTRY_DSN: REACT_APP_SENTRY_DSN,
        gtm: gtm
    } : null;
};

});

parcelRequire.register("a9kEu", function(module, exports) {

$parcel$export(module.exports, "useInitialData", function () { return $e493515bc2ba58a6$export$5523c5f3222291d0; });

var $gAFWW = parcelRequire("gAFWW");
const $e493515bc2ba58a6$var$initialQueryParams = Object.fromEntries(new URLSearchParams(location.search.substring(1)));
function $e493515bc2ba58a6$export$5523c5f3222291d0() {
    const params = (0, $gAFWW.useQueryParams)();
    const userMetaData = JSON.parse(localStorage.getItem("user-meta-data")) || {};
    return {
        ...$e493515bc2ba58a6$var$initialQueryParams,
        ...userMetaData,
        ...params
    };
}

});

parcelRequire.register("gv64I", function(module, exports) {

$parcel$export(module.exports, "useValidationRules", function () { return $4f0ca6c0c2876c1c$export$a6bfe9cb80b3c9d9; });
parcelRequire("1L1yK");
var $b3xDI = parcelRequire("b3xDI");
const $4f0ca6c0c2876c1c$export$410493acafbd4752 = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[=+\-^$*.\[\]{}()?"!@#%&/\\,><':;|_~`])\S{8,99}$/);
function $4f0ca6c0c2876c1c$export$a6bfe9cb80b3c9d9() {
    const { t: t  } = (0, $b3xDI.useTranslation)();
    const EMAIL = {
        required: {
            value: true,
            message: t("Validation.email.required")
        },
        pattern: {
            value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: t("Validation.email.format")
        }
    };
    const PASSWORD_BASIC = {
        required: {
            value: true,
            message: t("Validation.password.required")
        }
    };
    const PASSWORD_ADVANCED = {
        required: {
            value: true,
            message: t("Validation.password.required")
        },
        pattern: {
            value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s).{8,}$/,
            message: t("Validation.password.format")
        }
    };
    const PASSWORD_ADVANCED_STRONG = {
        required: {
            value: true,
            message: t("Validation.password.required")
        },
        pattern: {
            value: $4f0ca6c0c2876c1c$export$410493acafbd4752,
            message: t("Validation.password.format_strong")
        }
    };
    const CODE = {
        required: {
            value: true,
            message: t("Validation.code.required")
        },
        pattern: {
            value: /^[0-9]{6}$/g,
            message: t("Validation.code.format")
        }
    };
    const PASSWORD_CONFIRMATION = {
        required: {
            value: true,
            message: t("Validation.confirm_password.required")
        }
    };
    const FIRST_NAME = {
        required: {
            value: true,
            message: t("Validation.first_name.required")
        }
    };
    const LAST_NAME = {
        required: {
            value: true,
            message: t("Validation.last_name.required")
        }
    };
    const SALUTATION = {
        required: {
            value: true,
            message: t("Validation.salutation.required")
        }
    };
    const ACCEPT = {
        required: {
            value: true,
            message: t("Validation.accept.required")
        }
    };
    return {
        EMAIL: EMAIL,
        PASSWORD_BASIC: PASSWORD_BASIC,
        PASSWORD_ADVANCED: PASSWORD_ADVANCED,
        PASSWORD_ADVANCED_STRONG: PASSWORD_ADVANCED_STRONG,
        CODE: CODE,
        PASSWORD_CONFIRMATION: PASSWORD_CONFIRMATION,
        FIRST_NAME: FIRST_NAME,
        LAST_NAME: LAST_NAME,
        SALUTATION: SALUTATION,
        ACCEPT: ACCEPT
    };
}

});


parcelRequire.register("2bgZK", function(module, exports) {

$parcel$export(module.exports, "configure", function () { return $edb3831cbf295161$export$8d21e34596265fa2; });
$parcel$export(module.exports, "default", function () { return $edb3831cbf295161$export$2e2bcd8739ae039; });

var $ghNo7 = parcelRequire("ghNo7");
var $hbz3E = parcelRequire("hbz3E");
const $edb3831cbf295161$export$8d21e34596265fa2 = ({ amplifyConfig: { region: region , userPoolId: userPoolId , userPoolWebClientId: userPoolWebClientId  }  })=>{
    (0, $ghNo7.default).configure({
        Auth: {
            region: region,
            userPoolId: userPoolId,
            userPoolWebClientId: userPoolWebClientId
        }
    });
};
const $edb3831cbf295161$var$ERROR_MESSAGE_MAP = [
    {
        message: "temporary_password_expired",
        regex: /temporary.*password.*expired/i
    },
    {
        message: "user_does_not_exist",
        regex: /user.*not.*exist/i
    },
    {
        message: "user_already_exist",
        regex: /user.*already.*exist/i
    },
    {
        message: "incorrect_password",
        regex: /incorrect.*username.*password/i
    },
    {
        message: "incorrect_password_format",
        regex: /validation.*password/i
    },
    {
        message: "invalid_phone_number_format",
        regex: /invalid.*phone/i
    },
    {
        message: "user_cannot_confirm",
        regex: /user.*cannot.*confirm.*/i
    },
    {
        message: "user_cannot_confirm",
        regex: /username.*cannot.*empty.*/i
    },
    {
        message: "invalid_verfication_code",
        regex: /invalid.*code.*/i
    },
    {
        message: "username_client_id_combination_not_found",
        regex: /username.*client.*combination.*not.*/i
    },
    {
        message: "user_already_exist",
        regex: /.*account.*already.*exist.*/i
    },
    {
        message: "not_yet_confirmed_reset_password",
        regex: /.*reset.*password.*no.*verified.*email/i
    },
    {
        message: "not_yet_confirmed",
        regex: /.*user.*not.*confirmed/i
    },
    {
        message: "request_limit_exceeded",
        regex: /.*limit.*exceeded/i
    },
    {
        message: "request_limit_exceeded",
        regex: /.*quota.*exceeded/i
    },
    {
        message: "request_limit_exceeded",
        regex: /.*attempts.*exceeded/i
    },
    {
        message: "generic_error",
        regex: /.*amazon.*ses.*sandbox/i
    },
    {
        message: "user_not_found_or_federated_external",
        regex: /.*user.*not.*found.*federated/i
    },
    {
        message: "user_disabled",
        regex: /.*user.*disabled/i
    }
];
function $edb3831cbf295161$var$parseError(error) {
    const match = $edb3831cbf295161$var$ERROR_MESSAGE_MAP.filter((entry)=>entry.regex.test(error.message));
    if (match && match.length === 0) throw error;
    throw Error(match[0].message);
}
function $edb3831cbf295161$var$parseBody(response) {
    if (response.body?.errors?.[0]) return $edb3831cbf295161$var$parseError(Error(response.body?.errors?.[0] || "generic_error"));
    if (response.status === 400) return $edb3831cbf295161$var$parseError(Error("generic_error"));
    return response.body;
}
function $edb3831cbf295161$var$parseResponse(response) {
    if (response.status == 401) throw Error("unauthorized");
    if (!response.ok && response.status !== 400) throw Error("generic_error");
    else return response.json().then((body)=>({
            status: response.status,
            body: body
        }));
}
function $edb3831cbf295161$var$parseCsrf(response) {
    const { csrf: csrf , ...rest } = response.body || response;
    csrf && localStorage.setItem("CSRF", csrf);
    return rest;
}
const $edb3831cbf295161$var$signIn = (data)=>fetch("/auth-signin", {
        method: "POST",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    }).then($edb3831cbf295161$var$parseResponse).then($edb3831cbf295161$var$parseBody).then($edb3831cbf295161$var$parseCsrf);
const $edb3831cbf295161$var$changePassword = (data)=>fetch("/auth-signin", {
        method: "PUT",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    }).then($edb3831cbf295161$var$parseResponse).then($edb3831cbf295161$var$parseBody);
const $edb3831cbf295161$var$callVerifyEndpoint = (data)=>fetch("/auth-verify", {
        method: "POST",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    }).then($edb3831cbf295161$var$parseResponse).then($edb3831cbf295161$var$parseBody);
const $edb3831cbf295161$var$validateEmail = (email)=>fetch("https://order.mineko.io/graphql", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            query: `query EmailValidator($email: String!) {
        EmailValidator(email: $email) {
          isValid
          didYouMean
        }
      }`,
            variables: {
                email: email
            }
        })
    }).then($edb3831cbf295161$var$parseResponse).then($edb3831cbf295161$var$parseBody).then(({ data: data  })=>data.EmailValidator);
const $edb3831cbf295161$var$initUrl = new URL("/auth-signin", window.location.origin);
const $edb3831cbf295161$var$init = (requestedUri = "")=>{
    $edb3831cbf295161$var$initUrl.searchParams.set("requestedUri", requestedUri);
    return fetch($edb3831cbf295161$var$initUrl.toString(), {
        method: "GET",
        credentials: "same-origin"
    }).then($edb3831cbf295161$var$parseResponse).then($edb3831cbf295161$var$parseCsrf);
};
const $edb3831cbf295161$var$run = (method)=>(...props)=>(0, $hbz3E.default)[method](...props).catch($edb3831cbf295161$var$parseError);
var $edb3831cbf295161$export$2e2bcd8739ae039 = {
    forgotPassword: (data)=>$edb3831cbf295161$var$callVerifyEndpoint({
            ...data,
            requestNewPassword: true
        }),
    forgotPasswordSubmit: (data)=>$edb3831cbf295161$var$callVerifyEndpoint(data),
    signUp: $edb3831cbf295161$var$run("signUp"),
    changePassword: $edb3831cbf295161$var$changePassword,
    signIn: $edb3831cbf295161$var$signIn,
    init: $edb3831cbf295161$var$init,
    verifyEmail: $edb3831cbf295161$var$callVerifyEndpoint,
    validateEmail: $edb3831cbf295161$var$validateEmail
};

});
parcelRequire.register("ghNo7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdb48b537f2089e9$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Auth", function () { return (parcelRequire("hbz3E")).default; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $jNB5L = parcelRequire("jNB5L");

var $hbz3E = parcelRequire("hbz3E");

var $axy8Q = parcelRequire("axy8Q");

var $5Q7Dg = parcelRequire("5Q7Dg");

var $72iLF = parcelRequire("72iLF");

var $9x214 = parcelRequire("9x214");

var $6i0dT = parcelRequire("6i0dT");

var $kLzjU = parcelRequire("kLzjU");

var $7aWDl = parcelRequire("7aWDl");

var $519yT = parcelRequire("519yT");
parcelRequire("aVHtR");
var $fT5s7 = parcelRequire("fT5s7");

var $2hWDt = parcelRequire("2hWDt");
var $f70Ze = parcelRequire("f70Ze");
var $gBqCF = parcelRequire("gBqCF");
var $hk5A5 = parcelRequire("hk5A5");
var $bdb48b537f2089e9$export$2e2bcd8739ae039 = (0, $2hWDt.default);
(0, $2hWDt.default).Auth = (0, $hbz3E.default);
(0, $2hWDt.default).Analytics = (0, $jNB5L.default);
(0, $2hWDt.default).API = (0, $5Q7Dg.default);
(0, $2hWDt.default).Storage = (0, $axy8Q.default);
(0, $2hWDt.default).I18n = (0, $f70Ze.default);
(0, $2hWDt.default).Cache = (0, $9x214.default);
(0, $2hWDt.default).PubSub = (0, $72iLF.default);
(0, $2hWDt.default).Logger = (0, $gBqCF.ConsoleLogger);
(0, $2hWDt.default).ServiceWorker = (0, $hk5A5.default);
(0, $2hWDt.default).Interactions = (0, $6i0dT.default);
(0, $2hWDt.default).UI = $kLzjU;
(0, $2hWDt.default).XR = (0, $7aWDl.default);
(0, $2hWDt.default).Predictions = (0, $519yT.default);
(0, $2hWDt.default).DataStore = (0, $fT5s7.DataStore);

});
parcelRequire.register("jNB5L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e69f5d9856d91d62$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "AnalyticsClass", function () { return (parcelRequire("fqHRk")).default; }, function (v) { return (parcelRequire("fqHRk")).default = v; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $fqHRk = parcelRequire("fqHRk");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $2hWDt = parcelRequire("2hWDt");
var $iZUWK = parcelRequire("iZUWK");
parcelRequire("1M8si");
var $e69f5d9856d91d62$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e69f5d9856d91d62$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $e69f5d9856d91d62$var$logger = new (0, $gBqCF.ConsoleLogger)("Analytics");
var $e69f5d9856d91d62$var$endpointUpdated = false;
var $e69f5d9856d91d62$var$authConfigured = false;
var $e69f5d9856d91d62$var$analyticsConfigured = false;
var $e69f5d9856d91d62$var$_instance = null;
if (!$e69f5d9856d91d62$var$_instance) {
    $e69f5d9856d91d62$var$logger.debug("Create Analytics Instance");
    $e69f5d9856d91d62$var$_instance = new (0, $fqHRk.default)();
}
var $e69f5d9856d91d62$var$Analytics = $e69f5d9856d91d62$var$_instance;
(0, $2hWDt.default).register($e69f5d9856d91d62$var$Analytics);
var $e69f5d9856d91d62$export$2e2bcd8739ae039 = $e69f5d9856d91d62$var$Analytics;
var $e69f5d9856d91d62$var$listener = function(capsule) {
    var channel = capsule.channel, payload = capsule.payload, source = capsule.source;
    $e69f5d9856d91d62$var$logger.debug("on hub capsule " + channel, payload);
    switch(channel){
        case "auth":
            $e69f5d9856d91d62$var$authEvent(payload);
            break;
        case "storage":
            $e69f5d9856d91d62$var$storageEvent(payload);
            break;
        case "analytics":
            $e69f5d9856d91d62$var$analyticsEvent(payload);
            break;
        default:
            break;
    }
};
var $e69f5d9856d91d62$var$storageEvent = function(payload) {
    var _a = payload.data, attrs = _a.attrs, metrics = _a.metrics;
    if (!attrs) return;
    if ($e69f5d9856d91d62$var$analyticsConfigured) $e69f5d9856d91d62$var$Analytics.record({
        name: "Storage",
        attributes: attrs,
        metrics: metrics
    }).catch(function(e) {
        $e69f5d9856d91d62$var$logger.debug("Failed to send the storage event automatically", e);
    });
};
var $e69f5d9856d91d62$var$authEvent = function(payload) {
    var event = payload.event;
    if (!event) return;
    var recordAuthEvent = function(eventName) {
        return $e69f5d9856d91d62$var$__awaiter(void 0, void 0, void 0, function() {
            var err_1;
            return $e69f5d9856d91d62$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!($e69f5d9856d91d62$var$authConfigured && $e69f5d9856d91d62$var$analyticsConfigured)) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $e69f5d9856d91d62$var$Analytics.record({
                                name: "_userauth." + eventName
                            })
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 3:
                        err_1 = _a.sent();
                        $e69f5d9856d91d62$var$logger.debug("Failed to send the " + eventName + " event automatically", err_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    switch(event){
        case "signIn":
            return recordAuthEvent("sign_in");
        case "signUp":
            return recordAuthEvent("sign_up");
        case "signOut":
            return recordAuthEvent("sign_out");
        case "signIn_failure":
            return recordAuthEvent("auth_fail");
        case "configured":
            $e69f5d9856d91d62$var$authConfigured = true;
            if ($e69f5d9856d91d62$var$authConfigured && $e69f5d9856d91d62$var$analyticsConfigured) $e69f5d9856d91d62$var$sendEvents();
            break;
    }
};
var $e69f5d9856d91d62$var$analyticsEvent = function(payload) {
    var event = payload.event;
    if (!event) return;
    switch(event){
        case "pinpointProvider_configured":
            $e69f5d9856d91d62$var$analyticsConfigured = true;
            if ($e69f5d9856d91d62$var$authConfigured && $e69f5d9856d91d62$var$analyticsConfigured) $e69f5d9856d91d62$var$sendEvents();
            break;
    }
};
var $e69f5d9856d91d62$var$sendEvents = function() {
    var config = $e69f5d9856d91d62$var$Analytics.configure();
    if (!$e69f5d9856d91d62$var$endpointUpdated && config["autoSessionRecord"]) {
        $e69f5d9856d91d62$var$Analytics.updateEndpoint({
            immediate: true
        }).catch(function(e) {
            $e69f5d9856d91d62$var$logger.debug("Failed to update the endpoint", e);
        });
        $e69f5d9856d91d62$var$endpointUpdated = true;
    }
    $e69f5d9856d91d62$var$Analytics.autoTrack("session", {
        enable: config["autoSessionRecord"]
    });
};
(0, $iZUWK.default).listen("auth", $e69f5d9856d91d62$var$listener);
(0, $iZUWK.default).listen("storage", $e69f5d9856d91d62$var$listener);
(0, $iZUWK.default).listen("analytics", $e69f5d9856d91d62$var$listener);

});
parcelRequire.register("fqHRk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3bb4e3c578d5586$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $iZUWK = parcelRequire("iZUWK");
var $hlQms = parcelRequire("hlQms");

var $7r2po = parcelRequire("7r2po");
parcelRequire("5g5jW");
var $7q5hq = parcelRequire("7q5hq");
var $e73gb = parcelRequire("e73gb");
var $7gn03 = parcelRequire("7gn03");
var $b3bb4e3c578d5586$var$__assign = undefined && undefined.__assign || function() {
    $b3bb4e3c578d5586$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b3bb4e3c578d5586$var$__assign.apply(this, arguments);
};
var $b3bb4e3c578d5586$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b3bb4e3c578d5586$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $b3bb4e3c578d5586$var$logger = new (0, $gBqCF.ConsoleLogger)("AnalyticsClass");
var $b3bb4e3c578d5586$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var $b3bb4e3c578d5586$var$dispatchAnalyticsEvent = function(event, data, message) {
    (0, $iZUWK.default).dispatch("analytics", {
        event: event,
        data: data,
        message: message
    }, "Analytics", $b3bb4e3c578d5586$var$AMPLIFY_SYMBOL);
};
var $b3bb4e3c578d5586$var$trackers = {
    pageView: (0, $7q5hq.default),
    event: (0, $e73gb.default),
    session: (0, $7gn03.default)
};
/**
 * Provide mobile analytics client functions
 */ var $b3bb4e3c578d5586$var$AnalyticsClass = /** @class */ function() {
    /**
     * Initialize Analtyics
     * @param config - Configuration of the Analytics
     */ function AnalyticsClass() {
        this._config = {};
        this._pluggables = [];
        this._disabled = false;
        this._trackers = {};
        this.record = this.record.bind(this);
    }
    AnalyticsClass.prototype.getModuleName = function() {
        return "Analytics";
    };
    /**
     * configure Analytics
     * @param {Object} config - Configuration of the Analytics
     */ AnalyticsClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config;
        $b3bb4e3c578d5586$var$logger.debug("configure Analytics", config);
        var amplifyConfig = (0, $hlQms.default).parseMobilehubConfig(config);
        this._config = Object.assign({}, this._config, amplifyConfig.Analytics, config);
        if (this._config["disabled"]) this._disabled = true;
        this._pluggables.forEach(function(pluggable) {
            // for backward compatibility
            var providerConfig = pluggable.getProviderName() === "AWSPinpoint" && !_this._config["AWSPinpoint"] ? _this._config : _this._config[pluggable.getProviderName()];
            pluggable.configure($b3bb4e3c578d5586$var$__assign({
                disabled: _this._config["disabled"]
            }, providerConfig));
        });
        if (this._pluggables.length === 0) this.addPluggable(new (0, $7r2po.default)());
        // turn on the autoSessionRecord if not specified
        if (this._config["autoSessionRecord"] === undefined) this._config["autoSessionRecord"] = true;
        $b3bb4e3c578d5586$var$dispatchAnalyticsEvent("configured", null, "The Analytics category has been configured successfully");
        $b3bb4e3c578d5586$var$logger.debug("current configuration", this._config);
        return this._config;
    };
    /**
     * add plugin into Analytics category
     * @param {Object} pluggable - an instance of the plugin
     */ AnalyticsClass.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategory() === "Analytics") {
            this._pluggables.push(pluggable);
            // for backward compatibility
            var providerConfig = pluggable.getProviderName() === "AWSPinpoint" && !this._config["AWSPinpoint"] ? this._config : this._config[pluggable.getProviderName()];
            var config = $b3bb4e3c578d5586$var$__assign({
                disabled: this._config["disabled"]
            }, providerConfig);
            pluggable.configure(config);
            return config;
        }
    };
    /**
     * Get the plugin object
     * @param providerName - the name of the plugin
     */ AnalyticsClass.prototype.getPluggable = function(providerName) {
        for(var i = 0; i < this._pluggables.length; i += 1){
            var pluggable = this._pluggables[i];
            if (pluggable.getProviderName() === providerName) return pluggable;
        }
        $b3bb4e3c578d5586$var$logger.debug("No plugin found with providerName", providerName);
        return null;
    };
    /**
     * Remove the plugin object
     * @param providerName - the name of the plugin
     */ AnalyticsClass.prototype.removePluggable = function(providerName) {
        var idx = 0;
        while(idx < this._pluggables.length){
            if (this._pluggables[idx].getProviderName() === providerName) break;
            idx += 1;
        }
        if (idx === this._pluggables.length) {
            $b3bb4e3c578d5586$var$logger.debug("No plugin found with providerName", providerName);
            return;
        } else {
            this._pluggables.splice(idx, idx + 1);
            return;
        }
    };
    /**
     * stop sending events
     */ AnalyticsClass.prototype.disable = function() {
        this._disabled = true;
    };
    /**
     * start sending events
     */ AnalyticsClass.prototype.enable = function() {
        this._disabled = false;
    };
    /**
     * Record Session start
     * @return - A promise which resolves if buffer doesn't overflow
     */ AnalyticsClass.prototype.startSession = function(provider) {
        return $b3bb4e3c578d5586$var$__awaiter(this, void 0, void 0, function() {
            var params;
            return $b3bb4e3c578d5586$var$__generator(this, function(_a) {
                params = {
                    event: {
                        name: "_session.start"
                    },
                    provider: provider
                };
                return [
                    2 /*return*/ ,
                    this._sendEvent(params)
                ];
            });
        });
    };
    /**
     * Record Session stop
     * @return - A promise which resolves if buffer doesn't overflow
     */ AnalyticsClass.prototype.stopSession = function(provider) {
        return $b3bb4e3c578d5586$var$__awaiter(this, void 0, void 0, function() {
            var params;
            return $b3bb4e3c578d5586$var$__generator(this, function(_a) {
                params = {
                    event: {
                        name: "_session.stop"
                    },
                    provider: provider
                };
                return [
                    2 /*return*/ ,
                    this._sendEvent(params)
                ];
            });
        });
    };
    /**
     * Record one analytic event and send it to Pinpoint
     * @param {String} name - The name of the event
     * @param {Object} [attributs] - Attributes of the event
     * @param {Object} [metrics] - Event metrics
     * @return - A promise which resolves if buffer doesn't overflow
     */ AnalyticsClass.prototype.record = function(event, provider, metrics) {
        return $b3bb4e3c578d5586$var$__awaiter(this, void 0, void 0, function() {
            var errMsg, params;
            return $b3bb4e3c578d5586$var$__generator(this, function(_a) {
                if (!this.isAnalyticsConfigured()) {
                    errMsg = "Analytics has not been configured";
                    $b3bb4e3c578d5586$var$logger.debug(errMsg);
                    return [
                        2 /*return*/ ,
                        Promise.reject(new Error(errMsg))
                    ];
                }
                params = null;
                // this is just for compatibility, going to be deprecated
                if (typeof event === "string") params = {
                    event: {
                        name: event,
                        attributes: provider,
                        metrics: metrics
                    },
                    provider: "AWSPinpoint"
                };
                else params = {
                    event: event,
                    provider: provider
                };
                return [
                    2 /*return*/ ,
                    this._sendEvent(params)
                ];
            });
        });
    };
    AnalyticsClass.prototype.updateEndpoint = function(attrs, provider) {
        return $b3bb4e3c578d5586$var$__awaiter(this, void 0, void 0, function() {
            var event;
            return $b3bb4e3c578d5586$var$__generator(this, function(_a) {
                event = $b3bb4e3c578d5586$var$__assign($b3bb4e3c578d5586$var$__assign({}, attrs), {
                    name: "_update_endpoint"
                });
                return [
                    2 /*return*/ ,
                    this.record(event, provider)
                ];
            });
        });
    };
    AnalyticsClass.prototype._sendEvent = function(params) {
        var _this = this;
        if (!this.isAnalyticsConfigured()) {
            var errMsg = "Analytics has not been configured";
            $b3bb4e3c578d5586$var$logger.debug(errMsg);
            return Promise.reject(new Error(errMsg));
        }
        if (this._disabled) {
            $b3bb4e3c578d5586$var$logger.debug("Analytics has been disabled");
            return Promise.resolve();
        }
        var provider = params.provider ? params.provider : "AWSPinpoint";
        return new Promise(function(resolve, reject) {
            _this._pluggables.forEach(function(pluggable) {
                if (pluggable.getProviderName() === provider) pluggable.record(params, {
                    resolve: resolve,
                    reject: reject
                });
            });
        });
    };
    AnalyticsClass.prototype.autoTrack = function(trackerType, opts) {
        if (!$b3bb4e3c578d5586$var$trackers[trackerType]) {
            $b3bb4e3c578d5586$var$logger.debug("invalid tracker type");
            return;
        }
        // to sync up two different configuration ways of auto session tracking
        if (trackerType === "session") this._config["autoSessionRecord"] = opts["enable"];
        var tracker = this._trackers[trackerType];
        if (!tracker) this._trackers[trackerType] = new $b3bb4e3c578d5586$var$trackers[trackerType](this.record, opts);
        else tracker.configure(opts);
    };
    AnalyticsClass.prototype.isAnalyticsConfigured = function() {
        return this._config && Object.entries(this._config).length > 0;
    };
    return AnalyticsClass;
}();
var $b3bb4e3c578d5586$export$2e2bcd8739ae039 = $b3bb4e3c578d5586$var$AnalyticsClass;

});
parcelRequire.register("2hWDt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "AWS", function () { return (parcelRequire("blxMe")); });
$parcel$export(module.exports, "INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER", function () { return (parcelRequire("2SWCi")).INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER; });
$parcel$export(module.exports, "INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER", function () { return (parcelRequire("2SWCi")).INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER; });
$parcel$export(module.exports, "USER_AGENT_HEADER", function () { return (parcelRequire("2SWCi")).USER_AGENT_HEADER; });

$parcel$export(module.exports, "Constants", function () { return $1aaaa71c0e06834b$export$a002182e51710d39; });
$parcel$export(module.exports, "default", function () { return $1aaaa71c0e06834b$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ClientDevice", function () { return (parcelRequire("egl3L")).default; });
$parcel$export(module.exports, "ConsoleLogger", function () { return (parcelRequire("gBqCF")).ConsoleLogger; });
$parcel$export(module.exports, "Logger", function () { return (parcelRequire("gBqCF")).ConsoleLogger; });
$parcel$export(module.exports, "Hub", function () { return (parcelRequire("iZUWK")).default; });
$parcel$export(module.exports, "I18n", function () { return (parcelRequire("f70Ze")).default; });
$parcel$export(module.exports, "JS", function () { return (parcelRequire("gssgp")).default; });
$parcel$export(module.exports, "Signer", function () { return (parcelRequire("kP2rz")).default; });
$parcel$export(module.exports, "Parser", function () { return (parcelRequire("hlQms")).default; });
$parcel$export(module.exports, "Credentials", function () { return (parcelRequire("aCVDw")).default; });
$parcel$export(module.exports, "ServiceWorker", function () { return (parcelRequire("hk5A5")).default; });
$parcel$export(module.exports, "StorageHelper", function () { return (parcelRequire("33IrZ")).default; });
$parcel$export(module.exports, "Platform", function () { return (parcelRequire("imZy6")).default; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("iBT7b");
var $blxMe = parcelRequire("blxMe");
parcelRequire("gkIJB");
var $gBqCF = parcelRequire("gBqCF");

var $8Xt9v = parcelRequire("8Xt9v");

var $egl3L = parcelRequire("egl3L");
parcelRequire("cZG7C");

var $iZUWK = parcelRequire("iZUWK");

var $f70Ze = parcelRequire("f70Ze");

var $gssgp = parcelRequire("gssgp");

var $kP2rz = parcelRequire("kP2rz");

var $hlQms = parcelRequire("hlQms");

var $i22q0 = parcelRequire("i22q0");
parcelRequire("j8co1");

var $aCVDw = parcelRequire("aCVDw");
parcelRequire("3gtMd");
var $hk5A5 = parcelRequire("hk5A5");

var $33IrZ = parcelRequire("33IrZ");

var $imZy6 = parcelRequire("imZy6");
parcelRequire("2SWCi");

var $eHBkL = parcelRequire("eHBkL");
var $1aaaa71c0e06834b$export$a002182e51710d39 = {
    userAgent: (0, $imZy6.default).userAgent
};
var $1aaaa71c0e06834b$export$2e2bcd8739ae039 = (0, $8Xt9v.default);
var $1aaaa71c0e06834b$var$logger = new (0, $gBqCF.ConsoleLogger)("Core");
if ((0, $blxMe)["util"]) (0, $blxMe)["util"].userAgent = function() {
    return $1aaaa71c0e06834b$export$a002182e51710d39.userAgent;
};
else if ((0, $blxMe).config) (0, $blxMe).config.update({
    customUserAgent: $1aaaa71c0e06834b$export$a002182e51710d39.userAgent
});
else $1aaaa71c0e06834b$var$logger.warn("No AWS.config");
$parcel$exportWildcard(module.exports, $eHBkL);

});
parcelRequire.register("iBT7b", function(module, exports) {

$parcel$export(module.exports, "AWS", function () { return (parcelRequire("blxMe")); });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ // import * as S3 from 'aws-sdk/clients/s3';

var $blxMe = parcelRequire("blxMe");

});
parcelRequire.register("blxMe", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
if (typeof window !== "undefined") window.AWS = $dbC7k;
module.exports = $dbC7k;
if (typeof self !== "undefined") self.AWS = $dbC7k;

});
parcelRequire.register("hDDYX", function(module, exports) {

var $5DMlf = parcelRequire("5DMlf");

// browser specific modules
$5DMlf.crypto.lib = (parcelRequire("iJyoZ"));

$5DMlf.Buffer = (parcelRequire("2xBj3")).Buffer;

$5DMlf.url = (parcelRequire("g1P72"));

$5DMlf.querystring = (parcelRequire("kCuzU"));

$5DMlf.realClock = (parcelRequire("48XNY"));
$5DMlf.environment = "js";

$5DMlf.createEventStream = (parcelRequire("bjVXf")).createEventStream;
$5DMlf.isBrowser = function() {
    return true;
};
$5DMlf.isNode = function() {
    return false;
};

var $dbC7k = parcelRequire("dbC7k");
/**
 * @api private
 */ module.exports = $dbC7k;
parcelRequire("bph5V");
parcelRequire("1KJHg");
parcelRequire("80SUB");
parcelRequire("lO2Eh");
parcelRequire("7O5d0");
parcelRequire("4LDe2");
parcelRequire("5JwBe");

// Load the DOMParser XML parser
$dbC7k.XML.Parser = (parcelRequire("dys5Z"));
parcelRequire("9d3sY");
if (typeof $cd7517ce69b359c0$var$process === "undefined") var $cd7517ce69b359c0$var$process = {
    browser: true
};

});
parcelRequire.register("5DMlf", function(module, exports) {
/* eslint guard-for-in:0 */ 
var $e67mm = parcelRequire("e67mm");
var $41b617f21eee7602$var$AWS;







/**
 * A set of utility methods for use with the AWS SDK.
 *
 * @!attribute abort
 *   Return this value from an iterator function {each} or {arrayEach}
 *   to break out of the iteration.
 *   @example Breaking out of an iterator function
 *     AWS.util.each({a: 1, b: 2, c: 3}, function(key, value) {
 *       if (key == 'b') return AWS.util.abort;
 *     });
 *   @see each
 *   @see arrayEach
 * @api private
 */ var $41b617f21eee7602$var$util = {
    environment: "nodejs",
    engine: function engine() {
        if ($41b617f21eee7602$var$util.isBrowser() && typeof navigator !== "undefined") return navigator.userAgent;
        else {
            var engine = $e67mm.platform + "/" + $e67mm.version;
            return engine;
        }
    },
    userAgent: function userAgent() {
        var name = $41b617f21eee7602$var$util.environment;
        var agent = "aws-sdk-" + name + "/" + (parcelRequire("dbC7k")).VERSION;
        if (name === "nodejs") agent += " " + $41b617f21eee7602$var$util.engine();
        return agent;
    },
    uriEscape: function uriEscape(string) {
        var output = encodeURIComponent(string);
        output = output.replace(/[^A-Za-z0-9_.~\-%]+/g, escape);
        // AWS percent-encodes some extra non-standard characters in a URI
        output = output.replace(/[*]/g, function(ch) {
            return "%" + ch.charCodeAt(0).toString(16).toUpperCase();
        });
        return output;
    },
    uriEscapePath: function uriEscapePath(string) {
        var parts = [];
        $41b617f21eee7602$var$util.arrayEach(string.split("/"), function(part) {
            parts.push($41b617f21eee7602$var$util.uriEscape(part));
        });
        return parts.join("/");
    },
    urlParse: function urlParse(url) {
        return $41b617f21eee7602$var$util.url.parse(url);
    },
    urlFormat: function urlFormat(url) {
        return $41b617f21eee7602$var$util.url.format(url);
    },
    queryStringParse: function queryStringParse(qs) {
        return $41b617f21eee7602$var$util.querystring.parse(qs);
    },
    queryParamsToString: function queryParamsToString(params) {
        var items = [];
        var escape1 = $41b617f21eee7602$var$util.uriEscape;
        var sortedKeys = Object.keys(params).sort();
        $41b617f21eee7602$var$util.arrayEach(sortedKeys, function(name) {
            var value = params[name];
            var ename = escape1(name);
            var result = ename + "=";
            if (Array.isArray(value)) {
                var vals = [];
                $41b617f21eee7602$var$util.arrayEach(value, function(item) {
                    vals.push(escape1(item));
                });
                result = ename + "=" + vals.sort().join("&" + ename + "=");
            } else if (value !== undefined && value !== null) result = ename + "=" + escape1(value);
            items.push(result);
        });
        return items.join("&");
    },
    readFileSync: function readFileSync(path) {
        if ($41b617f21eee7602$var$util.isBrowser()) return null;
        return (parcelRequire("6BE6r")).readFileSync(path, "utf-8");
    },
    base64: {
        encode: function encode64(string) {
            if (typeof string === "number") throw $41b617f21eee7602$var$util.error(new Error("Cannot base64 encode number " + string));
            if (string === null || typeof string === "undefined") return string;
            var buf = $41b617f21eee7602$var$util.buffer.toBuffer(string);
            return buf.toString("base64");
        },
        decode: function decode64(string) {
            if (typeof string === "number") throw $41b617f21eee7602$var$util.error(new Error("Cannot base64 decode number " + string));
            if (string === null || typeof string === "undefined") return string;
            return $41b617f21eee7602$var$util.buffer.toBuffer(string, "base64");
        }
    },
    buffer: {
        /**
     * Buffer constructor for Node buffer and buffer pollyfill
     */ toBuffer: function(data, encoding) {
            return typeof $41b617f21eee7602$var$util.Buffer.from === "function" && $41b617f21eee7602$var$util.Buffer.from !== Uint8Array.from ? $41b617f21eee7602$var$util.Buffer.from(data, encoding) : new $41b617f21eee7602$var$util.Buffer(data, encoding);
        },
        alloc: function(size, fill, encoding) {
            if (typeof size !== "number") throw new Error("size passed to alloc must be a number.");
            if (typeof $41b617f21eee7602$var$util.Buffer.alloc === "function") return $41b617f21eee7602$var$util.Buffer.alloc(size, fill, encoding);
            else {
                var buf = new $41b617f21eee7602$var$util.Buffer(size);
                if (fill !== undefined && typeof buf.fill === "function") buf.fill(fill, undefined, undefined, encoding);
                return buf;
            }
        },
        toStream: function toStream(buffer) {
            if (!$41b617f21eee7602$var$util.Buffer.isBuffer(buffer)) buffer = $41b617f21eee7602$var$util.buffer.toBuffer(buffer);
            var readable = new $41b617f21eee7602$var$util.stream.Readable();
            var pos = 0;
            readable._read = function(size) {
                if (pos >= buffer.length) return readable.push(null);
                var end = pos + size;
                if (end > buffer.length) end = buffer.length;
                readable.push(buffer.slice(pos, end));
                pos = end;
            };
            return readable;
        },
        /**
     * Concatenates a list of Buffer objects.
     */ concat: function(buffers) {
            var length = 0, offset = 0, buffer = null, i;
            for(i = 0; i < buffers.length; i++)length += buffers[i].length;
            buffer = $41b617f21eee7602$var$util.buffer.alloc(length);
            for(i = 0; i < buffers.length; i++){
                buffers[i].copy(buffer, offset);
                offset += buffers[i].length;
            }
            return buffer;
        }
    },
    string: {
        byteLength: function byteLength(string) {
            if (string === null || string === undefined) return 0;
            if (typeof string === "string") string = $41b617f21eee7602$var$util.buffer.toBuffer(string);
            if (typeof string.byteLength === "number") return string.byteLength;
            else if (typeof string.length === "number") return string.length;
            else if (typeof string.size === "number") return string.size;
            else if (typeof string.path === "string") return (parcelRequire("6BE6r")).lstatSync(string.path).size;
            else throw $41b617f21eee7602$var$util.error(new Error("Cannot determine length of " + string), {
                object: string
            });
        },
        upperFirst: function upperFirst(string) {
            return string[0].toUpperCase() + string.substr(1);
        },
        lowerFirst: function lowerFirst(string) {
            return string[0].toLowerCase() + string.substr(1);
        }
    },
    ini: {
        parse: function string(ini) {
            var currentSection, map = {};
            $41b617f21eee7602$var$util.arrayEach(ini.split(/\r?\n/), function(line) {
                line = line.split(/(^|\s)[;#]/)[0]; // remove comments
                var section = line.match(/^\s*\[([^\[\]]+)\]\s*$/);
                if (section) currentSection = section[1];
                else if (currentSection) {
                    var item = line.match(/^\s*(.+?)\s*=\s*(.+?)\s*$/);
                    if (item) {
                        map[currentSection] = map[currentSection] || {};
                        map[currentSection][item[1]] = item[2];
                    }
                }
            });
            return map;
        }
    },
    fn: {
        noop: function() {},
        callback: function(err) {
            if (err) throw err;
        },
        /**
     * Turn a synchronous function into as "async" function by making it call
     * a callback. The underlying function is called with all but the last argument,
     * which is treated as the callback. The callback is passed passed a first argument
     * of null on success to mimick standard node callbacks.
     */ makeAsync: function makeAsync(fn, expectedArgs) {
            if (expectedArgs && expectedArgs <= fn.length) return fn;
            return function() {
                var args = Array.prototype.slice.call(arguments, 0);
                var callback = args.pop();
                var result = fn.apply(null, args);
                callback(result);
            };
        }
    },
    /**
   * Date and time utility functions.
   */ date: {
        /**
     * @return [Date] the current JavaScript date object. Since all
     *   AWS services rely on this date object, you can override
     *   this function to provide a special time value to AWS service
     *   requests.
     */ getDate: function getDate() {
            if (!$41b617f21eee7602$var$AWS) $41b617f21eee7602$var$AWS = (parcelRequire("dbC7k"));
            if ($41b617f21eee7602$var$AWS.config.systemClockOffset) return new Date(new Date().getTime() + $41b617f21eee7602$var$AWS.config.systemClockOffset);
            else return new Date();
        },
        /**
     * @return [String] the date in ISO-8601 format
     */ iso8601: function iso8601(date) {
            if (date === undefined) date = $41b617f21eee7602$var$util.date.getDate();
            return date.toISOString().replace(/\.\d{3}Z$/, "Z");
        },
        /**
     * @return [String] the date in RFC 822 format
     */ rfc822: function rfc822(date) {
            if (date === undefined) date = $41b617f21eee7602$var$util.date.getDate();
            return date.toUTCString();
        },
        /**
     * @return [Integer] the UNIX timestamp value for the current time
     */ unixTimestamp: function unixTimestamp(date) {
            if (date === undefined) date = $41b617f21eee7602$var$util.date.getDate();
            return date.getTime() / 1000;
        },
        /**
     * @param [String,number,Date] date
     * @return [Date]
     */ from: function format(date) {
            if (typeof date === "number") return new Date(date * 1000); // unix timestamp
            else return new Date(date);
        },
        /**
     * Given a Date or date-like value, this function formats the
     * date into a string of the requested value.
     * @param [String,number,Date] date
     * @param [String] formatter Valid formats are:
     #   * 'iso8601'
     #   * 'rfc822'
     #   * 'unixTimestamp'
     * @return [String]
     */ format: function format(date, formatter) {
            if (!formatter) formatter = "iso8601";
            return $41b617f21eee7602$var$util.date[formatter]($41b617f21eee7602$var$util.date.from(date));
        },
        parseTimestamp: function parseTimestamp(value) {
            if (typeof value === "number") return new Date(value * 1000);
            else if (value.match(/^\d+$/)) return new Date(value * 1000);
            else if (value.match(/^\d{4}/)) return new Date(value);
            else if (value.match(/^\w{3},/)) return new Date(value);
            else throw $41b617f21eee7602$var$util.error(new Error("unhandled timestamp format: " + value), {
                code: "TimestampParserError"
            });
        }
    },
    crypto: {
        crc32Table: [
            0x00000000,
            0x77073096,
            0xEE0E612C,
            0x990951BA,
            0x076DC419,
            0x706AF48F,
            0xE963A535,
            0x9E6495A3,
            0x0EDB8832,
            0x79DCB8A4,
            0xE0D5E91E,
            0x97D2D988,
            0x09B64C2B,
            0x7EB17CBD,
            0xE7B82D07,
            0x90BF1D91,
            0x1DB71064,
            0x6AB020F2,
            0xF3B97148,
            0x84BE41DE,
            0x1ADAD47D,
            0x6DDDE4EB,
            0xF4D4B551,
            0x83D385C7,
            0x136C9856,
            0x646BA8C0,
            0xFD62F97A,
            0x8A65C9EC,
            0x14015C4F,
            0x63066CD9,
            0xFA0F3D63,
            0x8D080DF5,
            0x3B6E20C8,
            0x4C69105E,
            0xD56041E4,
            0xA2677172,
            0x3C03E4D1,
            0x4B04D447,
            0xD20D85FD,
            0xA50AB56B,
            0x35B5A8FA,
            0x42B2986C,
            0xDBBBC9D6,
            0xACBCF940,
            0x32D86CE3,
            0x45DF5C75,
            0xDCD60DCF,
            0xABD13D59,
            0x26D930AC,
            0x51DE003A,
            0xC8D75180,
            0xBFD06116,
            0x21B4F4B5,
            0x56B3C423,
            0xCFBA9599,
            0xB8BDA50F,
            0x2802B89E,
            0x5F058808,
            0xC60CD9B2,
            0xB10BE924,
            0x2F6F7C87,
            0x58684C11,
            0xC1611DAB,
            0xB6662D3D,
            0x76DC4190,
            0x01DB7106,
            0x98D220BC,
            0xEFD5102A,
            0x71B18589,
            0x06B6B51F,
            0x9FBFE4A5,
            0xE8B8D433,
            0x7807C9A2,
            0x0F00F934,
            0x9609A88E,
            0xE10E9818,
            0x7F6A0DBB,
            0x086D3D2D,
            0x91646C97,
            0xE6635C01,
            0x6B6B51F4,
            0x1C6C6162,
            0x856530D8,
            0xF262004E,
            0x6C0695ED,
            0x1B01A57B,
            0x8208F4C1,
            0xF50FC457,
            0x65B0D9C6,
            0x12B7E950,
            0x8BBEB8EA,
            0xFCB9887C,
            0x62DD1DDF,
            0x15DA2D49,
            0x8CD37CF3,
            0xFBD44C65,
            0x4DB26158,
            0x3AB551CE,
            0xA3BC0074,
            0xD4BB30E2,
            0x4ADFA541,
            0x3DD895D7,
            0xA4D1C46D,
            0xD3D6F4FB,
            0x4369E96A,
            0x346ED9FC,
            0xAD678846,
            0xDA60B8D0,
            0x44042D73,
            0x33031DE5,
            0xAA0A4C5F,
            0xDD0D7CC9,
            0x5005713C,
            0x270241AA,
            0xBE0B1010,
            0xC90C2086,
            0x5768B525,
            0x206F85B3,
            0xB966D409,
            0xCE61E49F,
            0x5EDEF90E,
            0x29D9C998,
            0xB0D09822,
            0xC7D7A8B4,
            0x59B33D17,
            0x2EB40D81,
            0xB7BD5C3B,
            0xC0BA6CAD,
            0xEDB88320,
            0x9ABFB3B6,
            0x03B6E20C,
            0x74B1D29A,
            0xEAD54739,
            0x9DD277AF,
            0x04DB2615,
            0x73DC1683,
            0xE3630B12,
            0x94643B84,
            0x0D6D6A3E,
            0x7A6A5AA8,
            0xE40ECF0B,
            0x9309FF9D,
            0x0A00AE27,
            0x7D079EB1,
            0xF00F9344,
            0x8708A3D2,
            0x1E01F268,
            0x6906C2FE,
            0xF762575D,
            0x806567CB,
            0x196C3671,
            0x6E6B06E7,
            0xFED41B76,
            0x89D32BE0,
            0x10DA7A5A,
            0x67DD4ACC,
            0xF9B9DF6F,
            0x8EBEEFF9,
            0x17B7BE43,
            0x60B08ED5,
            0xD6D6A3E8,
            0xA1D1937E,
            0x38D8C2C4,
            0x4FDFF252,
            0xD1BB67F1,
            0xA6BC5767,
            0x3FB506DD,
            0x48B2364B,
            0xD80D2BDA,
            0xAF0A1B4C,
            0x36034AF6,
            0x41047A60,
            0xDF60EFC3,
            0xA867DF55,
            0x316E8EEF,
            0x4669BE79,
            0xCB61B38C,
            0xBC66831A,
            0x256FD2A0,
            0x5268E236,
            0xCC0C7795,
            0xBB0B4703,
            0x220216B9,
            0x5505262F,
            0xC5BA3BBE,
            0xB2BD0B28,
            0x2BB45A92,
            0x5CB36A04,
            0xC2D7FFA7,
            0xB5D0CF31,
            0x2CD99E8B,
            0x5BDEAE1D,
            0x9B64C2B0,
            0xEC63F226,
            0x756AA39C,
            0x026D930A,
            0x9C0906A9,
            0xEB0E363F,
            0x72076785,
            0x05005713,
            0x95BF4A82,
            0xE2B87A14,
            0x7BB12BAE,
            0x0CB61B38,
            0x92D28E9B,
            0xE5D5BE0D,
            0x7CDCEFB7,
            0x0BDBDF21,
            0x86D3D2D4,
            0xF1D4E242,
            0x68DDB3F8,
            0x1FDA836E,
            0x81BE16CD,
            0xF6B9265B,
            0x6FB077E1,
            0x18B74777,
            0x88085AE6,
            0xFF0F6A70,
            0x66063BCA,
            0x11010B5C,
            0x8F659EFF,
            0xF862AE69,
            0x616BFFD3,
            0x166CCF45,
            0xA00AE278,
            0xD70DD2EE,
            0x4E048354,
            0x3903B3C2,
            0xA7672661,
            0xD06016F7,
            0x4969474D,
            0x3E6E77DB,
            0xAED16A4A,
            0xD9D65ADC,
            0x40DF0B66,
            0x37D83BF0,
            0xA9BCAE53,
            0xDEBB9EC5,
            0x47B2CF7F,
            0x30B5FFE9,
            0xBDBDF21C,
            0xCABAC28A,
            0x53B39330,
            0x24B4A3A6,
            0xBAD03605,
            0xCDD70693,
            0x54DE5729,
            0x23D967BF,
            0xB3667A2E,
            0xC4614AB8,
            0x5D681B02,
            0x2A6F2B94,
            0xB40BBE37,
            0xC30C8EA1,
            0x5A05DF1B,
            0x2D02EF8D
        ],
        crc32: function crc32(data) {
            var tbl = $41b617f21eee7602$var$util.crypto.crc32Table;
            var crc = -1;
            if (typeof data === "string") data = $41b617f21eee7602$var$util.buffer.toBuffer(data);
            for(var i = 0; i < data.length; i++){
                var code = data.readUInt8(i);
                crc = crc >>> 8 ^ tbl[(crc ^ code) & 0xFF];
            }
            return (crc ^ -1) >>> 0;
        },
        hmac: function hmac(key, string, digest, fn) {
            if (!digest) digest = "binary";
            if (digest === "buffer") digest = undefined;
            if (!fn) fn = "sha256";
            if (typeof string === "string") string = $41b617f21eee7602$var$util.buffer.toBuffer(string);
            return $41b617f21eee7602$var$util.crypto.lib.createHmac(fn, key).update(string).digest(digest);
        },
        md5: function md5(data, digest, callback) {
            return $41b617f21eee7602$var$util.crypto.hash("md5", data, digest, callback);
        },
        sha256: function sha256(data, digest, callback) {
            return $41b617f21eee7602$var$util.crypto.hash("sha256", data, digest, callback);
        },
        hash: function(algorithm, data, digest, callback) {
            var hash = $41b617f21eee7602$var$util.crypto.createHash(algorithm);
            if (!digest) digest = "binary";
            if (digest === "buffer") digest = undefined;
            if (typeof data === "string") data = $41b617f21eee7602$var$util.buffer.toBuffer(data);
            var sliceFn = $41b617f21eee7602$var$util.arraySliceFn(data);
            var isBuffer = $41b617f21eee7602$var$util.Buffer.isBuffer(data);
            //Identifying objects with an ArrayBuffer as buffers
            if ($41b617f21eee7602$var$util.isBrowser() && typeof ArrayBuffer !== "undefined" && data && data.buffer instanceof ArrayBuffer) isBuffer = true;
            if (callback && typeof data === "object" && typeof data.on === "function" && !isBuffer) {
                data.on("data", function(chunk) {
                    hash.update(chunk);
                });
                data.on("error", function(err) {
                    callback(err);
                });
                data.on("end", function() {
                    callback(null, hash.digest(digest));
                });
            } else if (callback && sliceFn && !isBuffer && typeof FileReader !== "undefined") {
                // this might be a File/Blob
                var index = 0, size = 524288;
                var reader = new FileReader();
                reader.onerror = function() {
                    callback(new Error("Failed to read data."));
                };
                reader.onload = function() {
                    var buf = new $41b617f21eee7602$var$util.Buffer(new Uint8Array(reader.result));
                    hash.update(buf);
                    index += buf.length;
                    reader._continueReading();
                };
                reader._continueReading = function() {
                    if (index >= data.size) {
                        callback(null, hash.digest(digest));
                        return;
                    }
                    var back = index + size;
                    if (back > data.size) back = data.size;
                    reader.readAsArrayBuffer(sliceFn.call(data, index, back));
                };
                reader._continueReading();
            } else {
                if ($41b617f21eee7602$var$util.isBrowser() && typeof data === "object" && !isBuffer) data = new $41b617f21eee7602$var$util.Buffer(new Uint8Array(data));
                var out = hash.update(data).digest(digest);
                if (callback) callback(null, out);
                return out;
            }
        },
        toHex: function toHex(data) {
            var out = [];
            for(var i = 0; i < data.length; i++)out.push(("0" + data.charCodeAt(i).toString(16)).substr(-2, 2));
            return out.join("");
        },
        createHash: function createHash(algorithm) {
            return $41b617f21eee7602$var$util.crypto.lib.createHash(algorithm);
        }
    },
    /** @!ignore */ /* Abort constant */ abort: {},
    each: function each(object, iterFunction) {
        for(var key in object)if (Object.prototype.hasOwnProperty.call(object, key)) {
            var ret = iterFunction.call(this, key, object[key]);
            if (ret === $41b617f21eee7602$var$util.abort) break;
        }
    },
    arrayEach: function arrayEach(array, iterFunction) {
        for(var idx in array)if (Object.prototype.hasOwnProperty.call(array, idx)) {
            var ret = iterFunction.call(this, array[idx], parseInt(idx, 10));
            if (ret === $41b617f21eee7602$var$util.abort) break;
        }
    },
    update: function update(obj1, obj2) {
        $41b617f21eee7602$var$util.each(obj2, function iterator(key, item) {
            obj1[key] = item;
        });
        return obj1;
    },
    merge: function merge(obj1, obj2) {
        return $41b617f21eee7602$var$util.update($41b617f21eee7602$var$util.copy(obj1), obj2);
    },
    copy: function copy(object) {
        if (object === null || object === undefined) return object;
        var dupe = {};
        // jshint forin:false
        for(var key in object)dupe[key] = object[key];
        return dupe;
    },
    isEmpty: function isEmpty(obj) {
        for(var prop in obj){
            if (Object.prototype.hasOwnProperty.call(obj, prop)) return false;
        }
        return true;
    },
    arraySliceFn: function arraySliceFn(obj) {
        var fn = obj.slice || obj.webkitSlice || obj.mozSlice;
        return typeof fn === "function" ? fn : null;
    },
    isType: function isType(obj, type) {
        // handle cross-"frame" objects
        if (typeof type === "function") type = $41b617f21eee7602$var$util.typeName(type);
        return Object.prototype.toString.call(obj) === "[object " + type + "]";
    },
    typeName: function typeName(type) {
        if (Object.prototype.hasOwnProperty.call(type, "name")) return type.name;
        var str = type.toString();
        var match = str.match(/^\s*function (.+)\(/);
        return match ? match[1] : str;
    },
    error: function error(err, options) {
        var originalError = null;
        if (typeof err.message === "string" && err.message !== "") {
            if (typeof options === "string" || options && options.message) {
                originalError = $41b617f21eee7602$var$util.copy(err);
                originalError.message = err.message;
            }
        }
        err.message = err.message || null;
        if (typeof options === "string") err.message = options;
        else if (typeof options === "object" && options !== null) {
            $41b617f21eee7602$var$util.update(err, options);
            if (options.message) err.message = options.message;
            if (options.code || options.name) err.code = options.code || options.name;
            if (options.stack) err.stack = options.stack;
        }
        if (typeof Object.defineProperty === "function") {
            Object.defineProperty(err, "name", {
                writable: true,
                enumerable: false
            });
            Object.defineProperty(err, "message", {
                enumerable: true
            });
        }
        err.name = options && options.name || err.name || err.code || "Error";
        err.time = new Date();
        if (originalError) err.originalError = originalError;
        return err;
    },
    /**
   * @api private
   */ inherit: function inherit(klass, features) {
        var newObject = null;
        if (features === undefined) {
            features = klass;
            klass = Object;
            newObject = {};
        } else {
            var ctor = function ConstructorWrapper() {};
            ctor.prototype = klass.prototype;
            newObject = new ctor();
        }
        // constructor not supplied, create pass-through ctor
        if (features.constructor === Object) features.constructor = function() {
            if (klass !== Object) return klass.apply(this, arguments);
        };
        features.constructor.prototype = newObject;
        $41b617f21eee7602$var$util.update(features.constructor.prototype, features);
        features.constructor.__super__ = klass;
        return features.constructor;
    },
    /**
   * @api private
   */ mixin: function mixin() {
        var klass = arguments[0];
        for(var i = 1; i < arguments.length; i++)// jshint forin:false
        for(var prop in arguments[i].prototype){
            var fn = arguments[i].prototype[prop];
            if (prop !== "constructor") klass.prototype[prop] = fn;
        }
        return klass;
    },
    /**
   * @api private
   */ hideProperties: function hideProperties(obj, props) {
        if (typeof Object.defineProperty !== "function") return;
        $41b617f21eee7602$var$util.arrayEach(props, function(key) {
            Object.defineProperty(obj, key, {
                enumerable: false,
                writable: true,
                configurable: true
            });
        });
    },
    /**
   * @api private
   */ property: function property(obj, name, value, enumerable, isValue) {
        var opts = {
            configurable: true,
            enumerable: enumerable !== undefined ? enumerable : true
        };
        if (typeof value === "function" && !isValue) opts.get = value;
        else {
            opts.value = value;
            opts.writable = true;
        }
        Object.defineProperty(obj, name, opts);
    },
    /**
   * @api private
   */ memoizedProperty: function memoizedProperty(obj, name, get, enumerable) {
        var cachedValue = null;
        // build enumerable attribute for each value with lazy accessor.
        $41b617f21eee7602$var$util.property(obj, name, function() {
            if (cachedValue === null) cachedValue = get();
            return cachedValue;
        }, enumerable);
    },
    /**
   * TODO Remove in major version revision
   * This backfill populates response data without the
   * top-level payload name.
   *
   * @api private
   */ hoistPayloadMember: function hoistPayloadMember(resp) {
        var req = resp.request;
        var operationName = req.operation;
        var operation = req.service.api.operations[operationName];
        var output = operation.output;
        if (output.payload && !operation.hasEventOutput) {
            var payloadMember = output.members[output.payload];
            var responsePayload = resp.data[output.payload];
            if (payloadMember.type === "structure") $41b617f21eee7602$var$util.each(responsePayload, function(key, value) {
                $41b617f21eee7602$var$util.property(resp.data, key, value, false);
            });
        }
    },
    /**
   * Compute SHA-256 checksums of streams
   *
   * @api private
   */ computeSha256: function computeSha256(body, done) {
        if ($41b617f21eee7602$var$util.isNode()) {
            var Stream = $41b617f21eee7602$var$util.stream.Stream;
            var fs = (parcelRequire("6BE6r"));
            if (typeof Stream === "function" && body instanceof Stream) {
                if (typeof body.path === "string") {
                    var settings = {};
                    if (typeof body.start === "number") settings.start = body.start;
                    if (typeof body.end === "number") settings.end = body.end;
                    body = fs.createReadStream(body.path, settings);
                } else return done(new Error("Non-file stream objects are not supported with SigV4"));
            }
        }
        $41b617f21eee7602$var$util.crypto.sha256(body, "hex", function(err, sha) {
            if (err) done(err);
            else done(null, sha);
        });
    },
    /**
   * @api private
   */ isClockSkewed: function isClockSkewed(serverTime) {
        if (serverTime) {
            $41b617f21eee7602$var$util.property($41b617f21eee7602$var$AWS.config, "isClockSkewed", Math.abs(new Date().getTime() - serverTime) >= 300000, false);
            return $41b617f21eee7602$var$AWS.config.isClockSkewed;
        }
    },
    applyClockOffset: function applyClockOffset(serverTime) {
        if (serverTime) $41b617f21eee7602$var$AWS.config.systemClockOffset = serverTime - new Date().getTime();
    },
    /**
   * @api private
   */ extractRequestId: function extractRequestId(resp) {
        var requestId = resp.httpResponse.headers["x-amz-request-id"] || resp.httpResponse.headers["x-amzn-requestid"];
        if (!requestId && resp.data && resp.data.ResponseMetadata) requestId = resp.data.ResponseMetadata.RequestId;
        if (requestId) resp.requestId = requestId;
        if (resp.error) resp.error.requestId = requestId;
    },
    /**
   * @api private
   */ addPromises: function addPromises(constructors, PromiseDependency) {
        var deletePromises = false;
        if (PromiseDependency === undefined && $41b617f21eee7602$var$AWS && $41b617f21eee7602$var$AWS.config) PromiseDependency = $41b617f21eee7602$var$AWS.config.getPromisesDependency();
        if (PromiseDependency === undefined && typeof Promise !== "undefined") PromiseDependency = Promise;
        if (typeof PromiseDependency !== "function") deletePromises = true;
        if (!Array.isArray(constructors)) constructors = [
            constructors
        ];
        for(var ind = 0; ind < constructors.length; ind++){
            var constructor = constructors[ind];
            if (deletePromises) {
                if (constructor.deletePromisesFromClass) constructor.deletePromisesFromClass();
            } else if (constructor.addPromisesToClass) constructor.addPromisesToClass(PromiseDependency);
        }
    },
    /**
   * @api private
   */ promisifyMethod: function promisifyMethod(methodName, PromiseDependency) {
        return function promise() {
            var self = this;
            return new PromiseDependency(function(resolve, reject) {
                self[methodName](function(err, data) {
                    if (err) reject(err);
                    else resolve(data);
                });
            });
        };
    },
    /**
   * @api private
   */ isDualstackAvailable: function isDualstackAvailable(service) {
        if (!service) return false;
        var metadata = (parcelRequire("1R1lB"));
        if (typeof service !== "string") service = service.serviceIdentifier;
        if (typeof service !== "string" || !metadata.hasOwnProperty(service)) return false;
        return !!metadata[service].dualstackAvailable;
    },
    /**
   * @api private
   */ calculateRetryDelay: function calculateRetryDelay(retryCount, retryDelayOptions) {
        if (!retryDelayOptions) retryDelayOptions = {};
        var customBackoff = retryDelayOptions.customBackoff || null;
        if (typeof customBackoff === "function") return customBackoff(retryCount);
        var base = typeof retryDelayOptions.base === "number" ? retryDelayOptions.base : 100;
        var delay = Math.random() * (Math.pow(2, retryCount) * base);
        return delay;
    },
    /**
   * @api private
   */ handleRequestWithRetries: function handleRequestWithRetries(httpRequest, options, cb) {
        if (!options) options = {};
        var http = $41b617f21eee7602$var$AWS.HttpClient.getInstance();
        var httpOptions = options.httpOptions || {};
        var retryCount = 0;
        var errCallback = function(err) {
            var maxRetries = options.maxRetries || 0;
            if (err && err.code === "TimeoutError") err.retryable = true;
            if (err && err.retryable && retryCount < maxRetries) {
                retryCount++;
                var delay = $41b617f21eee7602$var$util.calculateRetryDelay(retryCount, options.retryDelayOptions);
                setTimeout(sendRequest, delay + (err.retryAfter || 0));
            } else cb(err);
        };
        var sendRequest = function() {
            var data = "";
            http.handleRequest(httpRequest, httpOptions, function(httpResponse) {
                httpResponse.on("data", function(chunk) {
                    data += chunk.toString();
                });
                httpResponse.on("end", function() {
                    var statusCode = httpResponse.statusCode;
                    if (statusCode < 300) cb(null, data);
                    else {
                        var retryAfter = parseInt(httpResponse.headers["retry-after"], 10) * 1000 || 0;
                        var err = $41b617f21eee7602$var$util.error(new Error(), {
                            retryable: statusCode >= 500 || statusCode === 429
                        });
                        if (retryAfter && err.retryable) err.retryAfter = retryAfter;
                        errCallback(err);
                    }
                });
            }, errCallback);
        };
        $41b617f21eee7602$var$AWS.util.defer(sendRequest);
    },
    /**
   * @api private
   */ uuid: {
        v4: function uuidV4() {
            return (parcelRequire("9rAOB")).v4();
        }
    },
    /**
   * @api private
   */ convertPayloadToString: function convertPayloadToString(resp) {
        var req = resp.request;
        var operation = req.operation;
        var rules = req.service.api.operations[operation].output || {};
        if (rules.payload && resp.data[rules.payload]) resp.data[rules.payload] = resp.data[rules.payload].toString();
    },
    /**
   * @api private
   */ defer: function defer(callback) {
        if (typeof $e67mm === "object" && typeof $e67mm.nextTick === "function") $e67mm.nextTick(callback);
        else if (typeof setImmediate === "function") setImmediate(callback);
        else setTimeout(callback, 0);
    },
    /**
   * @api private
   */ getRequestPayloadShape: function getRequestPayloadShape(req) {
        var operations = req.service.api.operations;
        if (!operations) return undefined;
        var operation = (operations || {})[req.operation];
        if (!operation || !operation.input || !operation.input.payload) return undefined;
        return operation.input.members[operation.input.payload];
    },
    getProfilesFromSharedConfig: function getProfilesFromSharedConfig(iniLoader, filename) {
        var profiles = {};
        var profilesFromConfig = {};
        if ($e67mm.env[$41b617f21eee7602$var$util.configOptInEnv]) var profilesFromConfig = iniLoader.loadFrom({
            isConfig: true,
            filename: $e67mm.env[$41b617f21eee7602$var$util.sharedConfigFileEnv]
        });
        var profilesFromCreds = iniLoader.loadFrom({
            filename: filename || $e67mm.env[$41b617f21eee7602$var$util.configOptInEnv] && $e67mm.env[$41b617f21eee7602$var$util.sharedCredentialsFileEnv]
        });
        for(var i = 0, profileNames = Object.keys(profilesFromConfig); i < profileNames.length; i++)profiles[profileNames[i]] = profilesFromConfig[profileNames[i]];
        for(var i = 0, profileNames = Object.keys(profilesFromCreds); i < profileNames.length; i++)profiles[profileNames[i]] = profilesFromCreds[profileNames[i]];
        return profiles;
    },
    /**
   * @api private
   */ defaultProfile: "default",
    /**
   * @api private
   */ configOptInEnv: "AWS_SDK_LOAD_CONFIG",
    /**
   * @api private
   */ sharedCredentialsFileEnv: "AWS_SHARED_CREDENTIALS_FILE",
    /**
   * @api private
   */ sharedConfigFileEnv: "AWS_CONFIG_FILE",
    /**
   * @api private
   */ imdsDisabledEnv: "AWS_EC2_METADATA_DISABLED"
};
/**
 * @api private
 */ module.exports = $41b617f21eee7602$var$util;

});
parcelRequire.register("dbC7k", function(module, exports) {
/**
 * The main AWS namespace
 */ 
var $9999deb3e57615d2$var$AWS = {
    util: (parcelRequire("5DMlf"))
};
/**
 * @api private
 * @!macro [new] nobrowser
 *   @note This feature is not supported in the browser environment of the SDK.
 */ var $9999deb3e57615d2$var$_hidden = {};
$9999deb3e57615d2$var$_hidden.toString(); // hack to parse macro
/**
 * @api private
 */ module.exports = $9999deb3e57615d2$var$AWS;















$9999deb3e57615d2$var$AWS.util.update($9999deb3e57615d2$var$AWS, {
    /**
   * @constant
   */ VERSION: "2.518.0",
    /**
   * @api private
   */ Signers: {},
    /**
   * @api private
   */ Protocol: {
        Json: (parcelRequire("5cMk6")),
        Query: (parcelRequire("gIynQ")),
        Rest: (parcelRequire("8x3DS")),
        RestJson: (parcelRequire("9KxRK")),
        RestXml: (parcelRequire("73Rhe"))
    },
    /**
   * @api private
   */ XML: {
        Builder: (parcelRequire("2sAhn")),
        Parser: null // conditionally set based on environment
    },
    /**
   * @api private
   */ JSON: {
        Builder: (parcelRequire("iOPOl")),
        Parser: (parcelRequire("f8sev"))
    },
    /**
   * @api private
   */ Model: {
        Api: (parcelRequire("6vhZq")),
        Operation: (parcelRequire("3HcKm")),
        Shape: (parcelRequire("DT6jw")),
        Paginator: (parcelRequire("3MQqb")),
        ResourceWaiter: (parcelRequire("8PmBH"))
    },
    /**
   * @api private
   */ apiLoader: (parcelRequire("30b5a")),
    /**
   * @api private
   */ EndpointCache: (parcelRequire("jf0Hu")).EndpointCache
});
parcelRequire("gOH6p");
parcelRequire("jnxjr");
parcelRequire("85vkQ");
parcelRequire("huvQa");
parcelRequire("jlqYn");
parcelRequire("hVwZR");
parcelRequire("lw5In");
parcelRequire("dygj6");
parcelRequire("cqL7q");
parcelRequire("idU0U");
/**
 * @readonly
 * @return [AWS.SequentialExecutor] a collection of global event listeners that
 *   are attached to every sent request.
 * @see AWS.Request AWS.Request for a list of events to listen for
 * @example Logging the time taken to send a request
 *   AWS.events.on('send', function startSend(resp) {
 *     resp.startTime = new Date().getTime();
 *   }).on('complete', function calculateTime(resp) {
 *     var time = (new Date().getTime() - resp.startTime) / 1000;
 *     console.log('Request took ' + time + ' seconds');
 *   });
 *
 *   new AWS.S3().listBuckets(); // prints 'Request took 0.285 seconds'
 */ $9999deb3e57615d2$var$AWS.events = new $9999deb3e57615d2$var$AWS.SequentialExecutor();
//create endpoint cache lazily
$9999deb3e57615d2$var$AWS.util.memoizedProperty($9999deb3e57615d2$var$AWS, "endpointCache", function() {
    return new $9999deb3e57615d2$var$AWS.EndpointCache($9999deb3e57615d2$var$AWS.config.endpointCacheSize);
}, true);

});
parcelRequire.register("5cMk6", function(module, exports) {

var $5DMlf = parcelRequire("5DMlf");

var $iOPOl = parcelRequire("iOPOl");

var $f8sev = parcelRequire("f8sev");

var $kiItS = parcelRequire("kiItS");
var $3ca38eba2f7d8d56$require$populateHostPrefix = $kiItS.populateHostPrefix;
function $3ca38eba2f7d8d56$var$buildRequest(req) {
    var httpRequest = req.httpRequest;
    var api = req.service.api;
    var target = api.targetPrefix + "." + api.operations[req.operation].name;
    var version = api.jsonVersion || "1.0";
    var input = api.operations[req.operation].input;
    var builder = new $iOPOl();
    if (version === 1) version = "1.0";
    httpRequest.body = builder.build(req.params || {}, input);
    httpRequest.headers["Content-Type"] = "application/x-amz-json-" + version;
    httpRequest.headers["X-Amz-Target"] = target;
    $3ca38eba2f7d8d56$require$populateHostPrefix(req);
}
function $3ca38eba2f7d8d56$var$extractError(resp) {
    var error = {};
    var httpResponse = resp.httpResponse;
    error.code = httpResponse.headers["x-amzn-errortype"] || "UnknownError";
    if (typeof error.code === "string") error.code = error.code.split(":")[0];
    if (httpResponse.body.length > 0) try {
        var e = JSON.parse(httpResponse.body.toString());
        if (e.__type || e.code) error.code = (e.__type || e.code).split("#").pop();
        if (error.code === "RequestEntityTooLarge") error.message = "Request body must be less than 1 MB";
        else error.message = e.message || e.Message || null;
    } catch (e) {
        error.statusCode = httpResponse.statusCode;
        error.message = httpResponse.statusMessage;
    }
    else {
        error.statusCode = httpResponse.statusCode;
        error.message = httpResponse.statusCode.toString();
    }
    resp.error = $5DMlf.error(new Error(), error);
}
function $3ca38eba2f7d8d56$var$extractData(resp) {
    var body = resp.httpResponse.body.toString() || "{}";
    if (resp.request.service.config.convertResponseTypes === false) resp.data = JSON.parse(body);
    else {
        var operation = resp.request.service.api.operations[resp.request.operation];
        var shape = operation.output || {};
        var parser = new $f8sev();
        resp.data = parser.parse(body, shape);
    }
}
/**
 * @api private
 */ module.exports = {
    buildRequest: $3ca38eba2f7d8d56$var$buildRequest,
    extractError: $3ca38eba2f7d8d56$var$extractError,
    extractData: $3ca38eba2f7d8d56$var$extractData
};

});
parcelRequire.register("iOPOl", function(module, exports) {

var $5DMlf = parcelRequire("5DMlf");
function $db35161e66b63e26$var$JsonBuilder() {}
$db35161e66b63e26$var$JsonBuilder.prototype.build = function(value, shape) {
    return JSON.stringify($db35161e66b63e26$var$translate(value, shape));
};
function $db35161e66b63e26$var$translate(value, shape) {
    if (!shape || value === undefined || value === null) return undefined;
    switch(shape.type){
        case "structure":
            return $db35161e66b63e26$var$translateStructure(value, shape);
        case "map":
            return $db35161e66b63e26$var$translateMap(value, shape);
        case "list":
            return $db35161e66b63e26$var$translateList(value, shape);
        default:
            return $db35161e66b63e26$var$translateScalar(value, shape);
    }
}
function $db35161e66b63e26$var$translateStructure(structure, shape) {
    var struct = {};
    $5DMlf.each(structure, function(name, value) {
        var memberShape = shape.members[name];
        if (memberShape) {
            if (memberShape.location !== "body") return;
            var locationName = memberShape.isLocationName ? memberShape.name : name;
            var result = $db35161e66b63e26$var$translate(value, memberShape);
            if (result !== undefined) struct[locationName] = result;
        }
    });
    return struct;
}
function $db35161e66b63e26$var$translateList(list, shape) {
    var out = [];
    $5DMlf.arrayEach(list, function(value) {
        var result = $db35161e66b63e26$var$translate(value, shape.member);
        if (result !== undefined) out.push(result);
    });
    return out;
}
function $db35161e66b63e26$var$translateMap(map, shape) {
    var out = {};
    $5DMlf.each(map, function(key, value) {
        var result = $db35161e66b63e26$var$translate(value, shape.value);
        if (result !== undefined) out[key] = result;
    });
    return out;
}
function $db35161e66b63e26$var$translateScalar(value, shape) {
    return shape.toWireFormat(value);
}
/**
 * @api private
 */ module.exports = $db35161e66b63e26$var$JsonBuilder;

});

parcelRequire.register("f8sev", function(module, exports) {

var $5DMlf = parcelRequire("5DMlf");
function $b04d80d962ed9298$var$JsonParser() {}
$b04d80d962ed9298$var$JsonParser.prototype.parse = function(value, shape) {
    return $b04d80d962ed9298$var$translate(JSON.parse(value), shape);
};
function $b04d80d962ed9298$var$translate(value, shape) {
    if (!shape || value === undefined) return undefined;
    switch(shape.type){
        case "structure":
            return $b04d80d962ed9298$var$translateStructure(value, shape);
        case "map":
            return $b04d80d962ed9298$var$translateMap(value, shape);
        case "list":
            return $b04d80d962ed9298$var$translateList(value, shape);
        default:
            return $b04d80d962ed9298$var$translateScalar(value, shape);
    }
}
function $b04d80d962ed9298$var$translateStructure(structure, shape) {
    if (structure == null) return undefined;
    var struct = {};
    var shapeMembers = shape.members;
    $5DMlf.each(shapeMembers, function(name, memberShape) {
        var locationName = memberShape.isLocationName ? memberShape.name : name;
        if (Object.prototype.hasOwnProperty.call(structure, locationName)) {
            var value = structure[locationName];
            var result = $b04d80d962ed9298$var$translate(value, memberShape);
            if (result !== undefined) struct[name] = result;
        }
    });
    return struct;
}
function $b04d80d962ed9298$var$translateList(list, shape) {
    if (list == null) return undefined;
    var out = [];
    $5DMlf.arrayEach(list, function(value) {
        var result = $b04d80d962ed9298$var$translate(value, shape.member);
        if (result === undefined) out.push(null);
        else out.push(result);
    });
    return out;
}
function $b04d80d962ed9298$var$translateMap(map, shape) {
    if (map == null) return undefined;
    var out = {};
    $5DMlf.each(map, function(key, value) {
        var result = $b04d80d962ed9298$var$translate(value, shape.value);
        if (result === undefined) out[key] = null;
        else out[key] = result;
    });
    return out;
}
function $b04d80d962ed9298$var$translateScalar(value, shape) {
    return shape.toType(value);
}
/**
 * @api private
 */ module.exports = $b04d80d962ed9298$var$JsonParser;

});

parcelRequire.register("kiItS", function(module, exports) {

var $5DMlf = parcelRequire("5DMlf");

var $dbC7k = parcelRequire("dbC7k");
/**
 * Prepend prefix defined by API model to endpoint that's already
 * constructed. This feature does not apply to operations using
 * endpoint discovery and can be disabled.
 * @api private
 */ function $ec77fe10916eef5a$var$populateHostPrefix(request) {
    var enabled = request.service.config.hostPrefixEnabled;
    if (!enabled) return request;
    var operationModel = request.service.api.operations[request.operation];
    //don't marshal host prefix when operation has endpoint discovery traits
    if ($ec77fe10916eef5a$var$hasEndpointDiscover(request)) return request;
    if (operationModel.endpoint && operationModel.endpoint.hostPrefix) {
        var hostPrefixNotation = operationModel.endpoint.hostPrefix;
        var hostPrefix = $ec77fe10916eef5a$var$expandHostPrefix(hostPrefixNotation, request.params, operationModel.input);
        $ec77fe10916eef5a$var$prependEndpointPrefix(request.httpRequest.endpoint, hostPrefix);
        $ec77fe10916eef5a$var$validateHostname(request.httpRequest.endpoint.hostname);
    }
    return request;
}
/**
 * @api private
 */ function $ec77fe10916eef5a$var$hasEndpointDiscover(request) {
    var api = request.service.api;
    var operationModel = api.operations[request.operation];
    var isEndpointOperation = api.endpointOperation && api.endpointOperation === $5DMlf.string.lowerFirst(operationModel.name);
    return operationModel.endpointDiscoveryRequired !== "NULL" || isEndpointOperation === true;
}
/**
 * @api private
 */ function $ec77fe10916eef5a$var$expandHostPrefix(hostPrefixNotation, params, shape) {
    $5DMlf.each(shape.members, function(name, member) {
        if (member.hostLabel === true) {
            if (typeof params[name] !== "string" || params[name] === "") throw $5DMlf.error(new Error(), {
                message: "Parameter " + name + " should be a non-empty string.",
                code: "InvalidParameter"
            });
            var regex = new RegExp("\\{" + name + "\\}", "g");
            hostPrefixNotation = hostPrefixNotation.replace(regex, params[name]);
        }
    });
    return hostPrefixNotation;
}
/**
 * @api private
 */ function $ec77fe10916eef5a$var$prependEndpointPrefix(endpoint, prefix) {
    if (endpoint.host) endpoint.host = prefix + endpoint.host;
    if (endpoint.hostname) endpoint.hostname = prefix + endpoint.hostname;
}
/**
 * @api private
 */ function $ec77fe10916eef5a$var$validateHostname(hostname) {
    var labels = hostname.split(".");
    //Reference: https://tools.ietf.org/html/rfc1123#section-2
    var hostPattern = /^[a-zA-Z0-9]{1}$|^[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9]$/;
    $5DMlf.arrayEach(labels, function(label) {
        if (!label.length || label.length < 1 || label.length > 63) throw $5DMlf.error(new Error(), {
            code: "ValidationError",
            message: "Hostname label length should be between 1 to 63 characters, inclusive."
        });
        if (!hostPattern.test(label)) throw $dbC7k.util.error(new Error(), {
            code: "ValidationError",
            message: label + " is not hostname compatible."
        });
    });
}
module.exports = {
    populateHostPrefix: $ec77fe10916eef5a$var$populateHostPrefix
};

});


parcelRequire.register("gIynQ", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");

var $5DMlf = parcelRequire("5DMlf");

var $8HXFZ = parcelRequire("8HXFZ");

var $DT6jw = parcelRequire("DT6jw");

var $kiItS = parcelRequire("kiItS");
var $c2bb6d3ef430ae73$require$populateHostPrefix = $kiItS.populateHostPrefix;
function $c2bb6d3ef430ae73$var$buildRequest(req) {
    var operation = req.service.api.operations[req.operation];
    var httpRequest = req.httpRequest;
    httpRequest.headers["Content-Type"] = "application/x-www-form-urlencoded; charset=utf-8";
    httpRequest.params = {
        Version: req.service.api.apiVersion,
        Action: operation.name
    };
    // convert the request parameters into a list of query params,
    // e.g. Deeply.NestedParam.0.Name=value
    var builder = new $8HXFZ();
    builder.serialize(req.params, operation.input, function(name, value) {
        httpRequest.params[name] = value;
    });
    httpRequest.body = $5DMlf.queryParamsToString(httpRequest.params);
    $c2bb6d3ef430ae73$require$populateHostPrefix(req);
}
function $c2bb6d3ef430ae73$var$extractError(resp) {
    var data, body = resp.httpResponse.body.toString();
    if (body.match("<UnknownOperationException")) data = {
        Code: "UnknownOperation",
        Message: "Unknown operation " + resp.request.operation
    };
    else try {
        data = new $dbC7k.XML.Parser().parse(body);
    } catch (e) {
        data = {
            Code: resp.httpResponse.statusCode,
            Message: resp.httpResponse.statusMessage
        };
    }
    if (data.requestId && !resp.requestId) resp.requestId = data.requestId;
    if (data.Errors) data = data.Errors;
    if (data.Error) data = data.Error;
    if (data.Code) resp.error = $5DMlf.error(new Error(), {
        code: data.Code,
        message: data.Message
    });
    else resp.error = $5DMlf.error(new Error(), {
        code: resp.httpResponse.statusCode,
        message: null
    });
}
function $c2bb6d3ef430ae73$var$extractData(resp) {
    var req = resp.request;
    var operation = req.service.api.operations[req.operation];
    var shape = operation.output || {};
    var origRules = shape;
    if (origRules.resultWrapper) {
        var tmp = $DT6jw.create({
            type: "structure"
        });
        tmp.members[origRules.resultWrapper] = shape;
        tmp.memberNames = [
            origRules.resultWrapper
        ];
        $5DMlf.property(shape, "name", shape.resultWrapper);
        shape = tmp;
    }
    var parser = new $dbC7k.XML.Parser();
    // TODO: Refactor XML Parser to parse RequestId from response.
    if (shape && shape.members && !shape.members._XAMZRequestId) {
        var requestIdShape = $DT6jw.create({
            type: "string"
        }, {
            api: {
                protocol: "query"
            }
        }, "requestId");
        shape.members._XAMZRequestId = requestIdShape;
    }
    var data = parser.parse(resp.httpResponse.body.toString(), shape);
    resp.requestId = data._XAMZRequestId || data.requestId;
    if (data._XAMZRequestId) delete data._XAMZRequestId;
    if (origRules.resultWrapper) {
        if (data[origRules.resultWrapper]) {
            $5DMlf.update(data, data[origRules.resultWrapper]);
            delete data[origRules.resultWrapper];
        }
    }
    resp.data = data;
}
/**
 * @api private
 */ module.exports = {
    buildRequest: $c2bb6d3ef430ae73$var$buildRequest,
    extractError: $c2bb6d3ef430ae73$var$extractError,
    extractData: $c2bb6d3ef430ae73$var$extractData
};

});
parcelRequire.register("8HXFZ", function(module, exports) {

var $5DMlf = parcelRequire("5DMlf");
function $6570a15bf8469cf4$var$QueryParamSerializer() {}
$6570a15bf8469cf4$var$QueryParamSerializer.prototype.serialize = function(params, shape, fn) {
    $6570a15bf8469cf4$var$serializeStructure("", params, shape, fn);
};
function $6570a15bf8469cf4$var$ucfirst(shape) {
    if (shape.isQueryName || shape.api.protocol !== "ec2") return shape.name;
    else return shape.name[0].toUpperCase() + shape.name.substr(1);
}
function $6570a15bf8469cf4$var$serializeStructure(prefix, struct, rules, fn) {
    $5DMlf.each(rules.members, function(name, member) {
        var value = struct[name];
        if (value === null || value === undefined) return;
        var memberName = $6570a15bf8469cf4$var$ucfirst(member);
        memberName = prefix ? prefix + "." + memberName : memberName;
        $6570a15bf8469cf4$var$serializeMember(memberName, value, member, fn);
    });
}
function $6570a15bf8469cf4$var$serializeMap(name, map, rules, fn) {
    var i = 1;
    $5DMlf.each(map, function(key, value) {
        var prefix = rules.flattened ? "." : ".entry.";
        var position = prefix + i++ + ".";
        var keyName = position + (rules.key.name || "key");
        var valueName = position + (rules.value.name || "value");
        $6570a15bf8469cf4$var$serializeMember(name + keyName, key, rules.key, fn);
        $6570a15bf8469cf4$var$serializeMember(name + valueName, value, rules.value, fn);
    });
}
function $6570a15bf8469cf4$var$serializeList(name, list, rules, fn) {
    var memberRules = rules.member || {};
    if (list.length === 0) {
        fn.call(this, name, null);
        return;
    }
    $5DMlf.arrayEach(list, function(v, n) {
        var suffix = "." + (n + 1);
        if (rules.api.protocol === "ec2") // Do nothing for EC2
        suffix = suffix + ""; // make linter happy
        else if (rules.flattened) {
            if (memberRules.name) {
                var parts = name.split(".");
                parts.pop();
                parts.push($6570a15bf8469cf4$var$ucfirst(memberRules));
                name = parts.join(".");
            }
        } else suffix = "." + (memberRules.name ? memberRules.name : "member") + suffix;
        $6570a15bf8469cf4$var$serializeMember(name + suffix, v, memberRules, fn);
    });
}
function $6570a15bf8469cf4$var$serializeMember(name, value, rules, fn) {
    if (value === null || value === undefined) return;
    if (rules.type === "structure") $6570a15bf8469cf4$var$serializeStructure(name, value, rules, fn);
    else if (rules.type === "list") $6570a15bf8469cf4$var$serializeList(name, value, rules, fn);
    else if (rules.type === "map") $6570a15bf8469cf4$var$serializeMap(name, value, rules, fn);
    else fn(name, rules.toWireFormat(value).toString());
}
/**
 * @api private
 */ module.exports = $6570a15bf8469cf4$var$QueryParamSerializer;

});

parcelRequire.register("DT6jw", function(module, exports) {

var $7T5Qb = parcelRequire("7T5Qb");

var $5DMlf = parcelRequire("5DMlf");
function $077e6283032aefb4$var$property(obj, name, value) {
    if (value !== null && value !== undefined) $5DMlf.property.apply(this, arguments);
}
function $077e6283032aefb4$var$memoizedProperty(obj, name) {
    if (!obj.constructor.prototype[name]) $5DMlf.memoizedProperty.apply(this, arguments);
}
function $077e6283032aefb4$var$Shape(shape, options, memberName) {
    options = options || {};
    $077e6283032aefb4$var$property(this, "shape", shape.shape);
    $077e6283032aefb4$var$property(this, "api", options.api, false);
    $077e6283032aefb4$var$property(this, "type", shape.type);
    $077e6283032aefb4$var$property(this, "enum", shape.enum);
    $077e6283032aefb4$var$property(this, "min", shape.min);
    $077e6283032aefb4$var$property(this, "max", shape.max);
    $077e6283032aefb4$var$property(this, "pattern", shape.pattern);
    $077e6283032aefb4$var$property(this, "location", shape.location || this.location || "body");
    $077e6283032aefb4$var$property(this, "name", this.name || shape.xmlName || shape.queryName || shape.locationName || memberName);
    $077e6283032aefb4$var$property(this, "isStreaming", shape.streaming || this.isStreaming || false);
    $077e6283032aefb4$var$property(this, "requiresLength", shape.requiresLength, false);
    $077e6283032aefb4$var$property(this, "isComposite", shape.isComposite || false);
    $077e6283032aefb4$var$property(this, "isShape", true, false);
    $077e6283032aefb4$var$property(this, "isQueryName", Boolean(shape.queryName), false);
    $077e6283032aefb4$var$property(this, "isLocationName", Boolean(shape.locationName), false);
    $077e6283032aefb4$var$property(this, "isIdempotent", shape.idempotencyToken === true);
    $077e6283032aefb4$var$property(this, "isJsonValue", shape.jsonvalue === true);
    $077e6283032aefb4$var$property(this, "isSensitive", shape.sensitive === true || shape.prototype && shape.prototype.sensitive === true);
    $077e6283032aefb4$var$property(this, "isEventStream", Boolean(shape.eventstream), false);
    $077e6283032aefb4$var$property(this, "isEvent", Boolean(shape.event), false);
    $077e6283032aefb4$var$property(this, "isEventPayload", Boolean(shape.eventpayload), false);
    $077e6283032aefb4$var$property(this, "isEventHeader", Boolean(shape.eventheader), false);
    $077e6283032aefb4$var$property(this, "isTimestampFormatSet", Boolean(shape.timestampFormat) || shape.prototype && shape.prototype.isTimestampFormatSet === true, false);
    $077e6283032aefb4$var$property(this, "endpointDiscoveryId", Boolean(shape.endpointdiscoveryid), false);
    $077e6283032aefb4$var$property(this, "hostLabel", Boolean(shape.hostLabel), false);
    if (options.documentation) {
        $077e6283032aefb4$var$property(this, "documentation", shape.documentation);
        $077e6283032aefb4$var$property(this, "documentationUrl", shape.documentationUrl);
    }
    if (shape.xmlAttribute) $077e6283032aefb4$var$property(this, "isXmlAttribute", shape.xmlAttribute || false);
    // type conversion and parsing
    $077e6283032aefb4$var$property(this, "defaultValue", null);
    this.toWireFormat = function(value) {
        if (value === null || value === undefined) return "";
        return value;
    };
    this.toType = function(value) {
        return value;
    };
}
/**
 * @api private
 */ $077e6283032aefb4$var$Shape.normalizedTypes = {
    character: "string",
    double: "float",
    long: "integer",
    short: "integer",
    biginteger: "integer",
    bigdecimal: "float",
    blob: "binary"
};
/**
 * @api private
 */ $077e6283032aefb4$var$Shape.types = {
    "structure": $077e6283032aefb4$var$StructureShape,
    "list": $077e6283032aefb4$var$ListShape,
    "map": $077e6283032aefb4$var$MapShape,
    "boolean": $077e6283032aefb4$var$BooleanShape,
    "timestamp": $077e6283032aefb4$var$TimestampShape,
    "float": $077e6283032aefb4$var$FloatShape,
    "integer": $077e6283032aefb4$var$IntegerShape,
    "string": $077e6283032aefb4$var$StringShape,
    "base64": $077e6283032aefb4$var$Base64Shape,
    "binary": $077e6283032aefb4$var$BinaryShape
};
$077e6283032aefb4$var$Shape.resolve = function resolve(shape, options) {
    if (shape.shape) {
        var refShape = options.api.shapes[shape.shape];
        if (!refShape) throw new Error("Cannot find shape reference: " + shape.shape);
        return refShape;
    } else return null;
};
$077e6283032aefb4$var$Shape.create = function create(shape, options, memberName) {
    if (shape.isShape) return shape;
    var refShape = $077e6283032aefb4$var$Shape.resolve(shape, options);
    if (refShape) {
        var filteredKeys = Object.keys(shape);
        if (!options.documentation) filteredKeys = filteredKeys.filter(function(name) {
            return !name.match(/documentation/);
        });
        // create an inline shape with extra members
        var InlineShape = function() {
            refShape.constructor.call(this, shape, options, memberName);
        };
        InlineShape.prototype = refShape;
        return new InlineShape();
    } else {
        // set type if not set
        if (!shape.type) {
            if (shape.members) shape.type = "structure";
            else if (shape.member) shape.type = "list";
            else if (shape.key) shape.type = "map";
            else shape.type = "string";
        }
        // normalize types
        var origType = shape.type;
        if ($077e6283032aefb4$var$Shape.normalizedTypes[shape.type]) shape.type = $077e6283032aefb4$var$Shape.normalizedTypes[shape.type];
        if ($077e6283032aefb4$var$Shape.types[shape.type]) return new $077e6283032aefb4$var$Shape.types[shape.type](shape, options, memberName);
        else throw new Error("Unrecognized shape type: " + origType);
    }
};
function $077e6283032aefb4$var$CompositeShape(shape) {
    $077e6283032aefb4$var$Shape.apply(this, arguments);
    $077e6283032aefb4$var$property(this, "isComposite", true);
    if (shape.flattened) $077e6283032aefb4$var$property(this, "flattened", shape.flattened || false);
}
function $077e6283032aefb4$var$StructureShape(shape, options) {
    var self = this;
    var requiredMap = null, firstInit = !this.isShape;
    $077e6283032aefb4$var$CompositeShape.apply(this, arguments);
    if (firstInit) {
        $077e6283032aefb4$var$property(this, "defaultValue", function() {
            return {};
        });
        $077e6283032aefb4$var$property(this, "members", {});
        $077e6283032aefb4$var$property(this, "memberNames", []);
        $077e6283032aefb4$var$property(this, "required", []);
        $077e6283032aefb4$var$property(this, "isRequired", function() {
            return false;
        });
    }
    if (shape.members) {
        $077e6283032aefb4$var$property(this, "members", new $7T5Qb(shape.members, options, function(name, member) {
            return $077e6283032aefb4$var$Shape.create(member, options, name);
        }));
        $077e6283032aefb4$var$memoizedProperty(this, "memberNames", function() {
            return shape.xmlOrder || Object.keys(shape.members);
        });
        if (shape.event) {
            $077e6283032aefb4$var$memoizedProperty(this, "eventPayloadMemberName", function() {
                var members = self.members;
                var memberNames = self.memberNames;
                // iterate over members to find ones that are event payloads
                for(var i = 0, iLen = memberNames.length; i < iLen; i++){
                    if (members[memberNames[i]].isEventPayload) return memberNames[i];
                }
            });
            $077e6283032aefb4$var$memoizedProperty(this, "eventHeaderMemberNames", function() {
                var members = self.members;
                var memberNames = self.memberNames;
                var eventHeaderMemberNames = [];
                // iterate over members to find ones that are event headers
                for(var i = 0, iLen = memberNames.length; i < iLen; i++)if (members[memberNames[i]].isEventHeader) eventHeaderMemberNames.push(memberNames[i]);
                return eventHeaderMemberNames;
            });
        }
    }
    if (shape.required) {
        $077e6283032aefb4$var$property(this, "required", shape.required);
        $077e6283032aefb4$var$property(this, "isRequired", function(name) {
            if (!requiredMap) {
                requiredMap = {};
                for(var i = 0; i < shape.required.length; i++)requiredMap[shape.required[i]] = true;
            }
            return requiredMap[name];
        }, false, true);
    }
    $077e6283032aefb4$var$property(this, "resultWrapper", shape.resultWrapper || null);
    if (shape.payload) $077e6283032aefb4$var$property(this, "payload", shape.payload);
    if (typeof shape.xmlNamespace === "string") $077e6283032aefb4$var$property(this, "xmlNamespaceUri", shape.xmlNamespace);
    else if (typeof shape.xmlNamespace === "object") {
        $077e6283032aefb4$var$property(this, "xmlNamespacePrefix", shape.xmlNamespace.prefix);
        $077e6283032aefb4$var$property(this, "xmlNamespaceUri", shape.xmlNamespace.uri);
    }
}
function $077e6283032aefb4$var$ListShape(shape, options) {
    var self = this, firstInit = !this.isShape;
    $077e6283032aefb4$var$CompositeShape.apply(this, arguments);
    if (firstInit) $077e6283032aefb4$var$property(this, "defaultValue", function() {
        return [];
    });
    if (shape.member) $077e6283032aefb4$var$memoizedProperty(this, "member", function() {
        return $077e6283032aefb4$var$Shape.create(shape.member, options);
    });
    if (this.flattened) {
        var oldName = this.name;
        $077e6283032aefb4$var$memoizedProperty(this, "name", function() {
            return self.member.name || oldName;
        });
    }
}
function $077e6283032aefb4$var$MapShape(shape, options) {
    var firstInit = !this.isShape;
    $077e6283032aefb4$var$CompositeShape.apply(this, arguments);
    if (firstInit) {
        $077e6283032aefb4$var$property(this, "defaultValue", function() {
            return {};
        });
        $077e6283032aefb4$var$property(this, "key", $077e6283032aefb4$var$Shape.create({
            type: "string"
        }, options));
        $077e6283032aefb4$var$property(this, "value", $077e6283032aefb4$var$Shape.create({
            type: "string"
        }, options));
    }
    if (shape.key) $077e6283032aefb4$var$memoizedProperty(this, "key", function() {
        return $077e6283032aefb4$var$Shape.create(shape.key, options);
    });
    if (shape.value) $077e6283032aefb4$var$memoizedProperty(this, "value", function() {
        return $077e6283032aefb4$var$Shape.create(shape.value, options);
    });
}
function $077e6283032aefb4$var$TimestampShape(shape) {
    var self = this;
    $077e6283032aefb4$var$Shape.apply(this, arguments);
    if (shape.timestampFormat) $077e6283032aefb4$var$property(this, "timestampFormat", shape.timestampFormat);
    else if (self.isTimestampFormatSet && this.timestampFormat) $077e6283032aefb4$var$property(this, "timestampFormat", this.timestampFormat);
    else if (this.location === "header") $077e6283032aefb4$var$property(this, "timestampFormat", "rfc822");
    else if (this.location === "querystring") $077e6283032aefb4$var$property(this, "timestampFormat", "iso8601");
    else if (this.api) switch(this.api.protocol){
        case "json":
        case "rest-json":
            $077e6283032aefb4$var$property(this, "timestampFormat", "unixTimestamp");
            break;
        case "rest-xml":
        case "query":
        case "ec2":
            $077e6283032aefb4$var$property(this, "timestampFormat", "iso8601");
            break;
    }
    this.toType = function(value) {
        if (value === null || value === undefined) return null;
        if (typeof value.toUTCString === "function") return value;
        return typeof value === "string" || typeof value === "number" ? $5DMlf.date.parseTimestamp(value) : null;
    };
    this.toWireFormat = function(value) {
        return $5DMlf.date.format(value, self.timestampFormat);
    };
}
function $077e6283032aefb4$var$StringShape() {
    $077e6283032aefb4$var$Shape.apply(this, arguments);
    var nullLessProtocols = [
        "rest-xml",
        "query",
        "ec2"
    ];
    this.toType = function(value) {
        value = this.api && nullLessProtocols.indexOf(this.api.protocol) > -1 ? value || "" : value;
        if (this.isJsonValue) return JSON.parse(value);
        return value && typeof value.toString === "function" ? value.toString() : value;
    };
    this.toWireFormat = function(value) {
        return this.isJsonValue ? JSON.stringify(value) : value;
    };
}
function $077e6283032aefb4$var$FloatShape() {
    $077e6283032aefb4$var$Shape.apply(this, arguments);
    this.toType = function(value) {
        if (value === null || value === undefined) return null;
        return parseFloat(value);
    };
    this.toWireFormat = this.toType;
}
function $077e6283032aefb4$var$IntegerShape() {
    $077e6283032aefb4$var$Shape.apply(this, arguments);
    this.toType = function(value) {
        if (value === null || value === undefined) return null;
        return parseInt(value, 10);
    };
    this.toWireFormat = this.toType;
}
function $077e6283032aefb4$var$BinaryShape() {
    $077e6283032aefb4$var$Shape.apply(this, arguments);
    this.toType = function(value) {
        var buf = $5DMlf.base64.decode(value);
        if (this.isSensitive && $5DMlf.isNode() && typeof $5DMlf.Buffer.alloc === "function") {
            /* Node.js can create a Buffer that is not isolated.
   * i.e. buf.byteLength !== buf.buffer.byteLength
   * This means that the sensitive data is accessible to anyone with access to buf.buffer.
   * If this is the node shared Buffer, then other code within this process _could_ find this secret.
   * Copy sensitive data to an isolated Buffer and zero the sensitive data.
   * While this is safe to do here, copying this code somewhere else may produce unexpected results.
   */ var secureBuf = $5DMlf.Buffer.alloc(buf.length, buf);
            buf.fill(0);
            buf = secureBuf;
        }
        return buf;
    };
    this.toWireFormat = $5DMlf.base64.encode;
}
function $077e6283032aefb4$var$Base64Shape() {
    $077e6283032aefb4$var$BinaryShape.apply(this, arguments);
}
function $077e6283032aefb4$var$BooleanShape() {
    $077e6283032aefb4$var$Shape.apply(this, arguments);
    this.toType = function(value) {
        if (typeof value === "boolean") return value;
        if (value === null || value === undefined) return null;
        return value === "true";
    };
}
/**
 * @api private
 */ $077e6283032aefb4$var$Shape.shapes = {
    StructureShape: $077e6283032aefb4$var$StructureShape,
    ListShape: $077e6283032aefb4$var$ListShape,
    MapShape: $077e6283032aefb4$var$MapShape,
    StringShape: $077e6283032aefb4$var$StringShape,
    BooleanShape: $077e6283032aefb4$var$BooleanShape,
    Base64Shape: $077e6283032aefb4$var$Base64Shape
};
/**
 * @api private
 */ module.exports = $077e6283032aefb4$var$Shape;

});
parcelRequire.register("7T5Qb", function(module, exports) {

var $5DMlf = parcelRequire("5DMlf");
var $5be2334cabc60051$require$memoizedProperty = $5DMlf.memoizedProperty;
function $5be2334cabc60051$var$memoize(name, value, factory, nameTr) {
    $5be2334cabc60051$require$memoizedProperty(this, nameTr(name), function() {
        return factory(name, value);
    });
}
function $5be2334cabc60051$var$Collection(iterable, options, factory, nameTr, callback) {
    nameTr = nameTr || String;
    var self = this;
    for(var id in iterable)if (Object.prototype.hasOwnProperty.call(iterable, id)) {
        $5be2334cabc60051$var$memoize.call(self, id, iterable[id], factory, nameTr);
        if (callback) callback(id, iterable[id]);
    }
}
/**
 * @api private
 */ module.exports = $5be2334cabc60051$var$Collection;

});



parcelRequire.register("8x3DS", function(module, exports) {

var $5DMlf = parcelRequire("5DMlf");

var $kiItS = parcelRequire("kiItS");
var $63643b14334f9992$require$populateHostPrefix = $kiItS.populateHostPrefix;
function $63643b14334f9992$var$populateMethod(req) {
    req.httpRequest.method = req.service.api.operations[req.operation].httpMethod;
}
function $63643b14334f9992$var$generateURI(endpointPath, operationPath, input, params) {
    var uri = [
        endpointPath,
        operationPath
    ].join("/");
    uri = uri.replace(/\/+/g, "/");
    var queryString = {}, queryStringSet = false;
    $5DMlf.each(input.members, function(name, member) {
        var paramValue = params[name];
        if (paramValue === null || paramValue === undefined) return;
        if (member.location === "uri") {
            var regex = new RegExp("\\{" + member.name + "(\\+)?\\}");
            uri = uri.replace(regex, function(_, plus) {
                var fn = plus ? $5DMlf.uriEscapePath : $5DMlf.uriEscape;
                return fn(String(paramValue));
            });
        } else if (member.location === "querystring") {
            queryStringSet = true;
            if (member.type === "list") queryString[member.name] = paramValue.map(function(val) {
                return $5DMlf.uriEscape(member.member.toWireFormat(val).toString());
            });
            else if (member.type === "map") $5DMlf.each(paramValue, function(key, value) {
                if (Array.isArray(value)) queryString[key] = value.map(function(val) {
                    return $5DMlf.uriEscape(String(val));
                });
                else queryString[key] = $5DMlf.uriEscape(String(value));
            });
            else queryString[member.name] = $5DMlf.uriEscape(member.toWireFormat(paramValue).toString());
        }
    });
    if (queryStringSet) {
        uri += uri.indexOf("?") >= 0 ? "&" : "?";
        var parts = [];
        $5DMlf.arrayEach(Object.keys(queryString).sort(), function(key) {
            if (!Array.isArray(queryString[key])) queryString[key] = [
                queryString[key]
            ];
            for(var i = 0; i < queryString[key].length; i++)parts.push($5DMlf.uriEscape(String(key)) + "=" + queryString[key][i]);
        });
        uri += parts.join("&");
    }
    return uri;
}
function $63643b14334f9992$var$populateURI(req) {
    var operation = req.service.api.operations[req.operation];
    var input = operation.input;
    var uri = $63643b14334f9992$var$generateURI(req.httpRequest.endpoint.path, operation.httpPath, input, req.params);
    req.httpRequest.path = uri;
}
function $63643b14334f9992$var$populateHeaders(req) {
    var operation = req.service.api.operations[req.operation];
    $5DMlf.each(operation.input.members, function(name, member) {
        var value = req.params[name];
        if (value === null || value === undefined) return;
        if (member.location === "headers" && member.type === "map") $5DMlf.each(value, function(key, memberValue) {
            req.httpRequest.headers[member.name + key] = memberValue;
        });
        else if (member.location === "header") {
            value = member.toWireFormat(value).toString();
            if (member.isJsonValue) value = $5DMlf.base64.encode(value);
            req.httpRequest.headers[member.name] = value;
        }
    });
}
function $63643b14334f9992$var$buildRequest(req) {
    $63643b14334f9992$var$populateMethod(req);
    $63643b14334f9992$var$populateURI(req);
    $63643b14334f9992$var$populateHeaders(req);
    $63643b14334f9992$require$populateHostPrefix(req);
}
function $63643b14334f9992$var$extractError() {}
function $63643b14334f9992$var$extractData(resp) {
    var req = resp.request;
    var data = {};
    var r = resp.httpResponse;
    var operation = req.service.api.operations[req.operation];
    var output = operation.output;
    // normalize headers names to lower-cased keys for matching
    var headers = {};
    $5DMlf.each(r.headers, function(k, v) {
        headers[k.toLowerCase()] = v;
    });
    $5DMlf.each(output.members, function(name, member) {
        var header = (member.name || name).toLowerCase();
        if (member.location === "headers" && member.type === "map") {
            data[name] = {};
            var location = member.isLocationName ? member.name : "";
            var pattern = new RegExp("^" + location + "(.+)", "i");
            $5DMlf.each(r.headers, function(k, v) {
                var result = k.match(pattern);
                if (result !== null) data[name][result[1]] = v;
            });
        } else if (member.location === "header") {
            if (headers[header] !== undefined) {
                var value = member.isJsonValue ? $5DMlf.base64.decode(headers[header]) : headers[header];
                data[name] = member.toType(value);
            }
        } else if (member.location === "statusCode") data[name] = parseInt(r.statusCode, 10);
    });
    resp.data = data;
}
/**
 * @api private
 */ module.exports = {
    buildRequest: $63643b14334f9992$var$buildRequest,
    extractError: $63643b14334f9992$var$extractError,
    extractData: $63643b14334f9992$var$extractData,
    generateURI: $63643b14334f9992$var$generateURI
};

});

parcelRequire.register("9KxRK", function(module, exports) {

var $5DMlf = parcelRequire("5DMlf");

var $8x3DS = parcelRequire("8x3DS");

var $5cMk6 = parcelRequire("5cMk6");

var $iOPOl = parcelRequire("iOPOl");

var $f8sev = parcelRequire("f8sev");
function $7192adfa58c63e9f$var$populateBody(req) {
    var builder = new $iOPOl();
    var input = req.service.api.operations[req.operation].input;
    if (input.payload) {
        var params = {};
        var payloadShape = input.members[input.payload];
        params = req.params[input.payload];
        if (params === undefined) return;
        if (payloadShape.type === "structure") {
            req.httpRequest.body = builder.build(params, payloadShape);
            $7192adfa58c63e9f$var$applyContentTypeHeader(req);
        } else {
            req.httpRequest.body = params;
            if (payloadShape.type === "binary" || payloadShape.isStreaming) $7192adfa58c63e9f$var$applyContentTypeHeader(req, true);
        }
    } else {
        var body = builder.build(req.params, input);
        if (body !== "{}" || req.httpRequest.method !== "GET") req.httpRequest.body = body;
        $7192adfa58c63e9f$var$applyContentTypeHeader(req);
    }
}
function $7192adfa58c63e9f$var$applyContentTypeHeader(req, isBinary) {
    var operation = req.service.api.operations[req.operation];
    var input = operation.input;
    if (!req.httpRequest.headers["Content-Type"]) {
        var type = isBinary ? "binary/octet-stream" : "application/json";
        req.httpRequest.headers["Content-Type"] = type;
    }
}
function $7192adfa58c63e9f$var$buildRequest(req) {
    $8x3DS.buildRequest(req);
    // never send body payload on HEAD/DELETE
    if ([
        "HEAD",
        "DELETE"
    ].indexOf(req.httpRequest.method) < 0) $7192adfa58c63e9f$var$populateBody(req);
}
function $7192adfa58c63e9f$var$extractError(resp) {
    $5cMk6.extractError(resp);
}
function $7192adfa58c63e9f$var$extractData(resp) {
    $8x3DS.extractData(resp);
    var req = resp.request;
    var operation = req.service.api.operations[req.operation];
    var rules = req.service.api.operations[req.operation].output || {};
    var parser;
    var hasEventOutput = operation.hasEventOutput;
    if (rules.payload) {
        var payloadMember = rules.members[rules.payload];
        var body = resp.httpResponse.body;
        if (payloadMember.isEventStream) {
            parser = new $f8sev();
            resp.data[payload] = $5DMlf.createEventStream(AWS.HttpClient.streamsApiVersion === 2 ? resp.httpResponse.stream : body, parser, payloadMember);
        } else if (payloadMember.type === "structure" || payloadMember.type === "list") {
            var parser = new $f8sev();
            resp.data[rules.payload] = parser.parse(body, payloadMember);
        } else if (payloadMember.type === "binary" || payloadMember.isStreaming) resp.data[rules.payload] = body;
        else resp.data[rules.payload] = payloadMember.toType(body);
    } else {
        var data = resp.data;
        $5cMk6.extractData(resp);
        resp.data = $5DMlf.merge(data, resp.data);
    }
}
/**
 * @api private
 */ module.exports = {
    buildRequest: $7192adfa58c63e9f$var$buildRequest,
    extractError: $7192adfa58c63e9f$var$extractError,
    extractData: $7192adfa58c63e9f$var$extractData
};

});

parcelRequire.register("73Rhe", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");

var $5DMlf = parcelRequire("5DMlf");

var $8x3DS = parcelRequire("8x3DS");
function $524223ede10bf303$var$populateBody(req) {
    var input = req.service.api.operations[req.operation].input;
    var builder = new $dbC7k.XML.Builder();
    var params = req.params;
    var payload = input.payload;
    if (payload) {
        var payloadMember = input.members[payload];
        params = params[payload];
        if (params === undefined) return;
        if (payloadMember.type === "structure") {
            var rootElement = payloadMember.name;
            req.httpRequest.body = builder.toXML(params, payloadMember, rootElement, true);
        } else req.httpRequest.body = params;
    } else req.httpRequest.body = builder.toXML(params, input, input.name || input.shape || $5DMlf.string.upperFirst(req.operation) + "Request");
}
function $524223ede10bf303$var$buildRequest(req) {
    $8x3DS.buildRequest(req);
    // never send body payload on GET/HEAD
    if ([
        "GET",
        "HEAD"
    ].indexOf(req.httpRequest.method) < 0) $524223ede10bf303$var$populateBody(req);
}
function $524223ede10bf303$var$extractError(resp) {
    $8x3DS.extractError(resp);
    var data;
    try {
        data = new $dbC7k.XML.Parser().parse(resp.httpResponse.body.toString());
    } catch (e) {
        data = {
            Code: resp.httpResponse.statusCode,
            Message: resp.httpResponse.statusMessage
        };
    }
    if (data.Errors) data = data.Errors;
    if (data.Error) data = data.Error;
    if (data.Code) resp.error = $5DMlf.error(new Error(), {
        code: data.Code,
        message: data.Message
    });
    else resp.error = $5DMlf.error(new Error(), {
        code: resp.httpResponse.statusCode,
        message: null
    });
}
function $524223ede10bf303$var$extractData(resp) {
    $8x3DS.extractData(resp);
    var parser;
    var req = resp.request;
    var body = resp.httpResponse.body;
    var operation = req.service.api.operations[req.operation];
    var output = operation.output;
    var hasEventOutput = operation.hasEventOutput;
    var payload = output.payload;
    if (payload) {
        var payloadMember = output.members[payload];
        if (payloadMember.isEventStream) {
            parser = new $dbC7k.XML.Parser();
            resp.data[payload] = $5DMlf.createEventStream($dbC7k.HttpClient.streamsApiVersion === 2 ? resp.httpResponse.stream : resp.httpResponse.body, parser, payloadMember);
        } else if (payloadMember.type === "structure") {
            parser = new $dbC7k.XML.Parser();
            resp.data[payload] = parser.parse(body.toString(), payloadMember);
        } else if (payloadMember.type === "binary" || payloadMember.isStreaming) resp.data[payload] = body;
        else resp.data[payload] = payloadMember.toType(body);
    } else if (body.length > 0) {
        parser = new $dbC7k.XML.Parser();
        var data = parser.parse(body.toString(), output);
        $5DMlf.update(resp.data, data);
    }
}
/**
 * @api private
 */ module.exports = {
    buildRequest: $524223ede10bf303$var$buildRequest,
    extractError: $524223ede10bf303$var$extractError,
    extractData: $524223ede10bf303$var$extractData
};

});

parcelRequire.register("2sAhn", function(module, exports) {

var $5DMlf = parcelRequire("5DMlf");

var $how9J = parcelRequire("how9J");
var $1caa569e2705f03a$require$XmlNode = $how9J.XmlNode;

var $edaYN = parcelRequire("edaYN");
var $1caa569e2705f03a$require$XmlText = $edaYN.XmlText;
function $1caa569e2705f03a$var$XmlBuilder() {}
$1caa569e2705f03a$var$XmlBuilder.prototype.toXML = function(params, shape, rootElement, noEmpty) {
    var xml = new $1caa569e2705f03a$require$XmlNode(rootElement);
    $1caa569e2705f03a$var$applyNamespaces(xml, shape, true);
    $1caa569e2705f03a$var$serialize(xml, params, shape);
    return xml.children.length > 0 || noEmpty ? xml.toString() : "";
};
function $1caa569e2705f03a$var$serialize(xml, value, shape) {
    switch(shape.type){
        case "structure":
            return $1caa569e2705f03a$var$serializeStructure(xml, value, shape);
        case "map":
            return $1caa569e2705f03a$var$serializeMap(xml, value, shape);
        case "list":
            return $1caa569e2705f03a$var$serializeList(xml, value, shape);
        default:
            return $1caa569e2705f03a$var$serializeScalar(xml, value, shape);
    }
}
function $1caa569e2705f03a$var$serializeStructure(xml, params, shape) {
    $5DMlf.arrayEach(shape.memberNames, function(memberName) {
        var memberShape = shape.members[memberName];
        if (memberShape.location !== "body") return;
        var value = params[memberName];
        var name = memberShape.name;
        if (value !== undefined && value !== null) {
            if (memberShape.isXmlAttribute) xml.addAttribute(name, value);
            else if (memberShape.flattened) $1caa569e2705f03a$var$serialize(xml, value, memberShape);
            else {
                var element = new $1caa569e2705f03a$require$XmlNode(name);
                xml.addChildNode(element);
                $1caa569e2705f03a$var$applyNamespaces(element, memberShape);
                $1caa569e2705f03a$var$serialize(element, value, memberShape);
            }
        }
    });
}
function $1caa569e2705f03a$var$serializeMap(xml, map, shape) {
    var xmlKey = shape.key.name || "key";
    var xmlValue = shape.value.name || "value";
    $5DMlf.each(map, function(key, value) {
        var entry = new $1caa569e2705f03a$require$XmlNode(shape.flattened ? shape.name : "entry");
        xml.addChildNode(entry);
        var entryKey = new $1caa569e2705f03a$require$XmlNode(xmlKey);
        var entryValue = new $1caa569e2705f03a$require$XmlNode(xmlValue);
        entry.addChildNode(entryKey);
        entry.addChildNode(entryValue);
        $1caa569e2705f03a$var$serialize(entryKey, key, shape.key);
        $1caa569e2705f03a$var$serialize(entryValue, value, shape.value);
    });
}
function $1caa569e2705f03a$var$serializeList(xml, list, shape) {
    if (shape.flattened) $5DMlf.arrayEach(list, function(value) {
        var name = shape.member.name || shape.name;
        var element = new $1caa569e2705f03a$require$XmlNode(name);
        xml.addChildNode(element);
        $1caa569e2705f03a$var$serialize(element, value, shape.member);
    });
    else $5DMlf.arrayEach(list, function(value) {
        var name = shape.member.name || "member";
        var element = new $1caa569e2705f03a$require$XmlNode(name);
        xml.addChildNode(element);
        $1caa569e2705f03a$var$serialize(element, value, shape.member);
    });
}
function $1caa569e2705f03a$var$serializeScalar(xml, value, shape) {
    xml.addChildNode(new $1caa569e2705f03a$require$XmlText(shape.toWireFormat(value)));
}
function $1caa569e2705f03a$var$applyNamespaces(xml, shape, isRoot) {
    var uri, prefix = "xmlns";
    if (shape.xmlNamespaceUri) {
        uri = shape.xmlNamespaceUri;
        if (shape.xmlNamespacePrefix) prefix += ":" + shape.xmlNamespacePrefix;
    } else if (isRoot && shape.api.xmlNamespaceUri) uri = shape.api.xmlNamespaceUri;
    if (uri) xml.addAttribute(prefix, uri);
}
/**
 * @api private
 */ module.exports = $1caa569e2705f03a$var$XmlBuilder;

});
parcelRequire.register("how9J", function(module, exports) {

var $2JuOM = parcelRequire("2JuOM");
var $ca9d9f0df9e2a045$require$escapeAttribute = $2JuOM.escapeAttribute;
/**
 * Represents an XML node.
 * @api private
 */ function $ca9d9f0df9e2a045$var$XmlNode(name, children) {
    if (children === void 0) children = [];
    this.name = name;
    this.children = children;
    this.attributes = {};
}
$ca9d9f0df9e2a045$var$XmlNode.prototype.addAttribute = function(name, value) {
    this.attributes[name] = value;
    return this;
};
$ca9d9f0df9e2a045$var$XmlNode.prototype.addChildNode = function(child) {
    this.children.push(child);
    return this;
};
$ca9d9f0df9e2a045$var$XmlNode.prototype.removeAttribute = function(name) {
    delete this.attributes[name];
    return this;
};
$ca9d9f0df9e2a045$var$XmlNode.prototype.toString = function() {
    var hasChildren = Boolean(this.children.length);
    var xmlText = "<" + this.name;
    // add attributes
    var attributes = this.attributes;
    for(var i = 0, attributeNames = Object.keys(attributes); i < attributeNames.length; i++){
        var attributeName = attributeNames[i];
        var attribute = attributes[attributeName];
        if (typeof attribute !== "undefined" && attribute !== null) xmlText += " " + attributeName + '="' + $ca9d9f0df9e2a045$require$escapeAttribute("" + attribute) + '"';
    }
    return xmlText += !hasChildren ? "/>" : ">" + this.children.map(function(c) {
        return c.toString();
    }).join("") + "</" + this.name + ">";
};
/**
 * @api private
 */ module.exports = {
    XmlNode: $ca9d9f0df9e2a045$var$XmlNode
};

});
parcelRequire.register("2JuOM", function(module, exports) {
/**
 * Escapes characters that can not be in an XML attribute.
 */ function $1fd7b08c7f354a91$var$escapeAttribute(value) {
    return value.replace(/&/g, "&amp;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
/**
 * @api private
 */ module.exports = {
    escapeAttribute: $1fd7b08c7f354a91$var$escapeAttribute
};

});


parcelRequire.register("edaYN", function(module, exports) {

var $ebND8 = parcelRequire("ebND8");
var $02ab876adacd250f$require$escapeElement = $ebND8.escapeElement;
/**
 * Represents an XML text value.
 * @api private
 */ function $02ab876adacd250f$var$XmlText(value) {
    this.value = value;
}
$02ab876adacd250f$var$XmlText.prototype.toString = function() {
    return $02ab876adacd250f$require$escapeElement("" + this.value);
};
/**
 * @api private
 */ module.exports = {
    XmlText: $02ab876adacd250f$var$XmlText
};

});
parcelRequire.register("ebND8", function(module, exports) {
/**
 * Escapes characters that can not be in an XML element.
 */ function $a54897488a5caa51$var$escapeElement(value) {
    return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
/**
 * @api private
 */ module.exports = {
    escapeElement: $a54897488a5caa51$var$escapeElement
};

});



parcelRequire.register("6vhZq", function(module, exports) {

var $7T5Qb = parcelRequire("7T5Qb");

var $3HcKm = parcelRequire("3HcKm");

var $DT6jw = parcelRequire("DT6jw");

var $3MQqb = parcelRequire("3MQqb");

var $8PmBH = parcelRequire("8PmBH");

var $5DMlf = parcelRequire("5DMlf");
var $4bc397b2c99ca4b4$var$property = $5DMlf.property;
var $4bc397b2c99ca4b4$var$memoizedProperty = $5DMlf.memoizedProperty;
function $4bc397b2c99ca4b4$var$Api(api, options) {
    var self = this;
    api = api || {};
    options = options || {};
    options.api = this;
    api.metadata = api.metadata || {};
    $4bc397b2c99ca4b4$var$property(this, "isApi", true, false);
    $4bc397b2c99ca4b4$var$property(this, "apiVersion", api.metadata.apiVersion);
    $4bc397b2c99ca4b4$var$property(this, "endpointPrefix", api.metadata.endpointPrefix);
    $4bc397b2c99ca4b4$var$property(this, "signingName", api.metadata.signingName);
    $4bc397b2c99ca4b4$var$property(this, "globalEndpoint", api.metadata.globalEndpoint);
    $4bc397b2c99ca4b4$var$property(this, "signatureVersion", api.metadata.signatureVersion);
    $4bc397b2c99ca4b4$var$property(this, "jsonVersion", api.metadata.jsonVersion);
    $4bc397b2c99ca4b4$var$property(this, "targetPrefix", api.metadata.targetPrefix);
    $4bc397b2c99ca4b4$var$property(this, "protocol", api.metadata.protocol);
    $4bc397b2c99ca4b4$var$property(this, "timestampFormat", api.metadata.timestampFormat);
    $4bc397b2c99ca4b4$var$property(this, "xmlNamespaceUri", api.metadata.xmlNamespace);
    $4bc397b2c99ca4b4$var$property(this, "abbreviation", api.metadata.serviceAbbreviation);
    $4bc397b2c99ca4b4$var$property(this, "fullName", api.metadata.serviceFullName);
    $4bc397b2c99ca4b4$var$property(this, "serviceId", api.metadata.serviceId);
    $4bc397b2c99ca4b4$var$memoizedProperty(this, "className", function() {
        var name = api.metadata.serviceAbbreviation || api.metadata.serviceFullName;
        if (!name) return null;
        name = name.replace(/^Amazon|AWS\s*|\(.*|\s+|\W+/g, "");
        if (name === "ElasticLoadBalancing") name = "ELB";
        return name;
    });
    function addEndpointOperation(name, operation) {
        if (operation.endpointoperation === true) $4bc397b2c99ca4b4$var$property(self, "endpointOperation", $5DMlf.string.lowerFirst(name));
    }
    $4bc397b2c99ca4b4$var$property(this, "operations", new $7T5Qb(api.operations, options, function(name, operation) {
        return new $3HcKm(name, operation, options);
    }, $5DMlf.string.lowerFirst, addEndpointOperation));
    $4bc397b2c99ca4b4$var$property(this, "shapes", new $7T5Qb(api.shapes, options, function(name, shape) {
        return $DT6jw.create(shape, options);
    }));
    $4bc397b2c99ca4b4$var$property(this, "paginators", new $7T5Qb(api.paginators, options, function(name, paginator) {
        return new $3MQqb(name, paginator, options);
    }));
    $4bc397b2c99ca4b4$var$property(this, "waiters", new $7T5Qb(api.waiters, options, function(name, waiter) {
        return new $8PmBH(name, waiter, options);
    }, $5DMlf.string.lowerFirst));
    if (options.documentation) {
        $4bc397b2c99ca4b4$var$property(this, "documentation", api.documentation);
        $4bc397b2c99ca4b4$var$property(this, "documentationUrl", api.documentationUrl);
    }
}
/**
 * @api private
 */ module.exports = $4bc397b2c99ca4b4$var$Api;

});
parcelRequire.register("3HcKm", function(module, exports) {

var $DT6jw = parcelRequire("DT6jw");

var $5DMlf = parcelRequire("5DMlf");
var $2b0f467b6a7ecd03$var$property = $5DMlf.property;
var $2b0f467b6a7ecd03$var$memoizedProperty = $5DMlf.memoizedProperty;
function $2b0f467b6a7ecd03$var$Operation(name, operation, options) {
    var self = this;
    options = options || {};
    $2b0f467b6a7ecd03$var$property(this, "name", operation.name || name);
    $2b0f467b6a7ecd03$var$property(this, "api", options.api, false);
    operation.http = operation.http || {};
    $2b0f467b6a7ecd03$var$property(this, "endpoint", operation.endpoint);
    $2b0f467b6a7ecd03$var$property(this, "httpMethod", operation.http.method || "POST");
    $2b0f467b6a7ecd03$var$property(this, "httpPath", operation.http.requestUri || "/");
    $2b0f467b6a7ecd03$var$property(this, "authtype", operation.authtype || "");
    $2b0f467b6a7ecd03$var$property(this, "endpointDiscoveryRequired", operation.endpointdiscovery ? operation.endpointdiscovery.required ? "REQUIRED" : "OPTIONAL" : "NULL");
    $2b0f467b6a7ecd03$var$memoizedProperty(this, "input", function() {
        if (!operation.input) return new $DT6jw.create({
            type: "structure"
        }, options);
        return $DT6jw.create(operation.input, options);
    });
    $2b0f467b6a7ecd03$var$memoizedProperty(this, "output", function() {
        if (!operation.output) return new $DT6jw.create({
            type: "structure"
        }, options);
        return $DT6jw.create(operation.output, options);
    });
    $2b0f467b6a7ecd03$var$memoizedProperty(this, "errors", function() {
        var list = [];
        if (!operation.errors) return null;
        for(var i = 0; i < operation.errors.length; i++)list.push($DT6jw.create(operation.errors[i], options));
        return list;
    });
    $2b0f467b6a7ecd03$var$memoizedProperty(this, "paginator", function() {
        return options.api.paginators[name];
    });
    if (options.documentation) {
        $2b0f467b6a7ecd03$var$property(this, "documentation", operation.documentation);
        $2b0f467b6a7ecd03$var$property(this, "documentationUrl", operation.documentationUrl);
    }
    // idempotentMembers only tracks top-level input shapes
    $2b0f467b6a7ecd03$var$memoizedProperty(this, "idempotentMembers", function() {
        var idempotentMembers = [];
        var input = self.input;
        var members = input.members;
        if (!input.members) return idempotentMembers;
        for(var name in members){
            if (!members.hasOwnProperty(name)) continue;
            if (members[name].isIdempotent === true) idempotentMembers.push(name);
        }
        return idempotentMembers;
    });
    $2b0f467b6a7ecd03$var$memoizedProperty(this, "hasEventOutput", function() {
        var output = self.output;
        return $2b0f467b6a7ecd03$var$hasEventStream(output);
    });
}
function $2b0f467b6a7ecd03$var$hasEventStream(topLevelShape) {
    var members = topLevelShape.members;
    var payload = topLevelShape.payload;
    if (!topLevelShape.members) return false;
    if (payload) {
        var payloadMember = members[payload];
        return payloadMember.isEventStream;
    }
    // check if any member is an event stream
    for(var name in members)if (!members.hasOwnProperty(name)) {
        if (members[name].isEventStream === true) return true;
    }
    return false;
}
/**
 * @api private
 */ module.exports = $2b0f467b6a7ecd03$var$Operation;

});

parcelRequire.register("3MQqb", function(module, exports) {

var $5DMlf = parcelRequire("5DMlf");
var $2c1e84921634c7c9$require$property = $5DMlf.property;
function $2c1e84921634c7c9$var$Paginator(name, paginator) {
    $2c1e84921634c7c9$require$property(this, "inputToken", paginator.input_token);
    $2c1e84921634c7c9$require$property(this, "limitKey", paginator.limit_key);
    $2c1e84921634c7c9$require$property(this, "moreResults", paginator.more_results);
    $2c1e84921634c7c9$require$property(this, "outputToken", paginator.output_token);
    $2c1e84921634c7c9$require$property(this, "resultKey", paginator.result_key);
}
/**
 * @api private
 */ module.exports = $2c1e84921634c7c9$var$Paginator;

});

parcelRequire.register("8PmBH", function(module, exports) {

var $5DMlf = parcelRequire("5DMlf");
var $66d49f6a5dfd9c81$var$property = $5DMlf.property;
function $66d49f6a5dfd9c81$var$ResourceWaiter(name, waiter, options) {
    options = options || {};
    $66d49f6a5dfd9c81$var$property(this, "name", name);
    $66d49f6a5dfd9c81$var$property(this, "api", options.api, false);
    if (waiter.operation) $66d49f6a5dfd9c81$var$property(this, "operation", $5DMlf.string.lowerFirst(waiter.operation));
    var self = this;
    var keys = [
        "type",
        "description",
        "delay",
        "maxAttempts",
        "acceptors"
    ];
    keys.forEach(function(key) {
        var value = waiter[key];
        if (value) $66d49f6a5dfd9c81$var$property(self, key, value);
    });
}
/**
 * @api private
 */ module.exports = $66d49f6a5dfd9c81$var$ResourceWaiter;

});


parcelRequire.register("30b5a", function(module, exports) {
function $22f9f7e9849e9bba$var$apiLoader(svc, version) {
    if (!$22f9f7e9849e9bba$var$apiLoader.services.hasOwnProperty(svc)) throw new Error("InvalidService: Failed to load api for " + svc);
    return $22f9f7e9849e9bba$var$apiLoader.services[svc][version];
}
/**
 * @api private
 *
 * This member of AWS.apiLoader is private, but changing it will necessitate a
 * change to ../scripts/services-table-generator.ts
 */ $22f9f7e9849e9bba$var$apiLoader.services = {};
/**
 * @api private
 */ module.exports = $22f9f7e9849e9bba$var$apiLoader;

});

parcelRequire.register("jf0Hu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5LscX = parcelRequire("5LscX");
var $e01ff61f93bab788$var$CACHE_SIZE = 1000;
/**
 * Inspired node-lru-cache[https://github.com/isaacs/node-lru-cache]
 */ var $e01ff61f93bab788$var$EndpointCache = /** @class */ function() {
    function EndpointCache(maxSize) {
        if (maxSize === void 0) maxSize = $e01ff61f93bab788$var$CACHE_SIZE;
        this.maxSize = maxSize;
        this.cache = new $5LscX.LRUCache(maxSize);
    }
    Object.defineProperty(EndpointCache.prototype, "size", {
        get: function() {
            return this.cache.length;
        },
        enumerable: true,
        configurable: true
    });
    EndpointCache.prototype.put = function(key, value) {
        var keyString = typeof key !== "string" ? EndpointCache.getKeyString(key) : key;
        var endpointRecord = this.populateValue(value);
        this.cache.put(keyString, endpointRecord);
    };
    EndpointCache.prototype.get = function(key) {
        var keyString = typeof key !== "string" ? EndpointCache.getKeyString(key) : key;
        var now = Date.now();
        var records = this.cache.get(keyString);
        if (records) for(var i = 0; i < records.length; i++){
            var record = records[i];
            if (record.Expire < now) {
                this.cache.remove(keyString);
                return undefined;
            }
        }
        return records;
    };
    EndpointCache.getKeyString = function(key) {
        var identifiers = [];
        var identifierNames = Object.keys(key).sort();
        for(var i = 0; i < identifierNames.length; i++){
            var identifierName = identifierNames[i];
            if (key[identifierName] === undefined) continue;
            identifiers.push(key[identifierName]);
        }
        return identifiers.join(" ");
    };
    EndpointCache.prototype.populateValue = function(endpoints) {
        var now = Date.now();
        return endpoints.map(function(endpoint) {
            return {
                Address: endpoint.Address || "",
                Expire: now + (endpoint.CachePeriodInMinutes || 1) * 60000
            };
        });
    };
    EndpointCache.prototype.empty = function() {
        this.cache.empty();
    };
    EndpointCache.prototype.remove = function(key) {
        var keyString = typeof key !== "string" ? EndpointCache.getKeyString(key) : key;
        this.cache.remove(keyString);
    };
    return EndpointCache;
}();
module.exports.EndpointCache = $e01ff61f93bab788$var$EndpointCache;

});
parcelRequire.register("5LscX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $432739088b45713a$var$LinkedListNode = /** @class */ function() {
    function LinkedListNode(key, value) {
        this.key = key;
        this.value = value;
    }
    return LinkedListNode;
}();
var $432739088b45713a$var$LRUCache = /** @class */ function() {
    function LRUCache(size) {
        this.nodeMap = {};
        this.size = 0;
        if (typeof size !== "number" || size < 1) throw new Error("Cache size can only be positive number");
        this.sizeLimit = size;
    }
    Object.defineProperty(LRUCache.prototype, "length", {
        get: function() {
            return this.size;
        },
        enumerable: true,
        configurable: true
    });
    LRUCache.prototype.prependToList = function(node) {
        if (!this.headerNode) this.tailNode = node;
        else {
            this.headerNode.prev = node;
            node.next = this.headerNode;
        }
        this.headerNode = node;
        this.size++;
    };
    LRUCache.prototype.removeFromTail = function() {
        if (!this.tailNode) return undefined;
        var node = this.tailNode;
        var prevNode = node.prev;
        if (prevNode) prevNode.next = undefined;
        node.prev = undefined;
        this.tailNode = prevNode;
        this.size--;
        return node;
    };
    LRUCache.prototype.detachFromList = function(node) {
        if (this.headerNode === node) this.headerNode = node.next;
        if (this.tailNode === node) this.tailNode = node.prev;
        if (node.prev) node.prev.next = node.next;
        if (node.next) node.next.prev = node.prev;
        node.next = undefined;
        node.prev = undefined;
        this.size--;
    };
    LRUCache.prototype.get = function(key) {
        if (this.nodeMap[key]) {
            var node = this.nodeMap[key];
            this.detachFromList(node);
            this.prependToList(node);
            return node.value;
        }
    };
    LRUCache.prototype.remove = function(key) {
        if (this.nodeMap[key]) {
            var node = this.nodeMap[key];
            this.detachFromList(node);
            delete this.nodeMap[key];
        }
    };
    LRUCache.prototype.put = function(key, value) {
        if (this.nodeMap[key]) this.remove(key);
        else if (this.size === this.sizeLimit) {
            var tailNode = this.removeFromTail();
            var key_1 = tailNode.key;
            delete this.nodeMap[key_1];
        }
        var newNode = new $432739088b45713a$var$LinkedListNode(key, value);
        this.nodeMap[key] = newNode;
        this.prependToList(newNode);
    };
    LRUCache.prototype.empty = function() {
        var keys = Object.keys(this.nodeMap);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var node = this.nodeMap[key];
            this.detachFromList(node);
            delete this.nodeMap[key];
        }
    };
    return LRUCache;
}();
module.exports.LRUCache = $432739088b45713a$var$LRUCache;

});


parcelRequire.register("gOH6p", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
/**
 * @api private
 * @!method on(eventName, callback)
 *   Registers an event listener callback for the event given by `eventName`.
 *   Parameters passed to the callback function depend on the individual event
 *   being triggered. See the event documentation for those parameters.
 *
 *   @param eventName [String] the event name to register the listener for
 *   @param callback [Function] the listener callback function
 *   @param toHead [Boolean] attach the listener callback to the head of callback array if set to true.
 *     Default to be false.
 *   @return [AWS.SequentialExecutor] the same object for chaining
 */ $dbC7k.SequentialExecutor = $dbC7k.util.inherit({
    constructor: function SequentialExecutor() {
        this._events = {};
    },
    /**
   * @api private
   */ listeners: function listeners(eventName) {
        return this._events[eventName] ? this._events[eventName].slice(0) : [];
    },
    on: function on(eventName, listener, toHead) {
        if (this._events[eventName]) toHead ? this._events[eventName].unshift(listener) : this._events[eventName].push(listener);
        else this._events[eventName] = [
            listener
        ];
        return this;
    },
    onAsync: function onAsync(eventName, listener, toHead) {
        listener._isAsync = true;
        return this.on(eventName, listener, toHead);
    },
    removeListener: function removeListener(eventName, listener) {
        var listeners = this._events[eventName];
        if (listeners) {
            var length = listeners.length;
            var position = -1;
            for(var i = 0; i < length; ++i)if (listeners[i] === listener) position = i;
            if (position > -1) listeners.splice(position, 1);
        }
        return this;
    },
    removeAllListeners: function removeAllListeners(eventName) {
        if (eventName) delete this._events[eventName];
        else this._events = {};
        return this;
    },
    /**
   * @api private
   */ emit: function emit(eventName, eventArgs, doneCallback) {
        if (!doneCallback) doneCallback = function() {};
        var listeners = this.listeners(eventName);
        var count = listeners.length;
        this.callListeners(listeners, eventArgs, doneCallback);
        return count > 0;
    },
    /**
   * @api private
   */ callListeners: function callListeners(listeners, args, doneCallback, prevError) {
        var self = this;
        var error = prevError || null;
        function callNextListener(err) {
            if (err) {
                error = $dbC7k.util.error(error || new Error(), err);
                if (self._haltHandlersOnError) return doneCallback.call(self, error);
            }
            self.callListeners(listeners, args, doneCallback, error);
        }
        while(listeners.length > 0){
            var listener = listeners.shift();
            if (listener._isAsync) {
                listener.apply(self, args.concat([
                    callNextListener
                ]));
                return; // stop here, callNextListener will continue
            } else {
                try {
                    listener.apply(self, args);
                } catch (err) {
                    error = $dbC7k.util.error(error || new Error(), err);
                }
                if (error && self._haltHandlersOnError) {
                    doneCallback.call(self, error);
                    return;
                }
            }
        }
        doneCallback.call(self, error);
    },
    /**
   * Adds or copies a set of listeners from another list of
   * listeners or SequentialExecutor object.
   *
   * @param listeners [map<String,Array<Function>>, AWS.SequentialExecutor]
   *   a list of events and callbacks, or an event emitter object
   *   containing listeners to add to this emitter object.
   * @return [AWS.SequentialExecutor] the emitter object, for chaining.
   * @example Adding listeners from a map of listeners
   *   emitter.addListeners({
   *     event1: [function() { ... }, function() { ... }],
   *     event2: [function() { ... }]
   *   });
   *   emitter.emit('event1'); // emitter has event1
   *   emitter.emit('event2'); // emitter has event2
   * @example Adding listeners from another emitter object
   *   var emitter1 = new AWS.SequentialExecutor();
   *   emitter1.on('event1', function() { ... });
   *   emitter1.on('event2', function() { ... });
   *   var emitter2 = new AWS.SequentialExecutor();
   *   emitter2.addListeners(emitter1);
   *   emitter2.emit('event1'); // emitter2 has event1
   *   emitter2.emit('event2'); // emitter2 has event2
   */ addListeners: function addListeners(listeners) {
        var self = this;
        // extract listeners if parameter is an SequentialExecutor object
        if (listeners._events) listeners = listeners._events;
        $dbC7k.util.each(listeners, function(event, callbacks) {
            if (typeof callbacks === "function") callbacks = [
                callbacks
            ];
            $dbC7k.util.arrayEach(callbacks, function(callback) {
                self.on(event, callback);
            });
        });
        return self;
    },
    /**
   * Registers an event with {on} and saves the callback handle function
   * as a property on the emitter object using a given `name`.
   *
   * @param name [String] the property name to set on this object containing
   *   the callback function handle so that the listener can be removed in
   *   the future.
   * @param (see on)
   * @return (see on)
   * @example Adding a named listener DATA_CALLBACK
   *   var listener = function() { doSomething(); };
   *   emitter.addNamedListener('DATA_CALLBACK', 'data', listener);
   *
   *   // the following prints: true
   *   console.log(emitter.DATA_CALLBACK == listener);
   */ addNamedListener: function addNamedListener(name, eventName, callback, toHead) {
        this[name] = callback;
        this.addListener(eventName, callback, toHead);
        return this;
    },
    /**
   * @api private
   */ addNamedAsyncListener: function addNamedAsyncListener(name, eventName, callback, toHead) {
        callback._isAsync = true;
        return this.addNamedListener(name, eventName, callback, toHead);
    },
    /**
   * Helper method to add a set of named listeners using
   * {addNamedListener}. The callback contains a parameter
   * with a handle to the `addNamedListener` method.
   *
   * @callback callback function(add)
   *   The callback function is called immediately in order to provide
   *   the `add` function to the block. This simplifies the addition of
   *   a large group of named listeners.
   *   @param add [Function] the {addNamedListener} function to call
   *     when registering listeners.
   * @example Adding a set of named listeners
   *   emitter.addNamedListeners(function(add) {
   *     add('DATA_CALLBACK', 'data', function() { ... });
   *     add('OTHER', 'otherEvent', function() { ... });
   *     add('LAST', 'lastEvent', function() { ... });
   *   });
   *
   *   // these properties are now set:
   *   emitter.DATA_CALLBACK;
   *   emitter.OTHER;
   *   emitter.LAST;
   */ addNamedListeners: function addNamedListeners(callback) {
        var self = this;
        callback(function() {
            self.addNamedListener.apply(self, arguments);
        }, function() {
            self.addNamedAsyncListener.apply(self, arguments);
        });
        return this;
    }
});
/**
 * {on} is the prefered method.
 * @api private
 */ $dbC7k.SequentialExecutor.prototype.addListener = $dbC7k.SequentialExecutor.prototype.on;
/**
 * @api private
 */ module.exports = $dbC7k.SequentialExecutor;

});

parcelRequire.register("jnxjr", function(module, exports) {

var $e67mm = parcelRequire("e67mm");

var $dbC7k = parcelRequire("dbC7k");

var $6vhZq = parcelRequire("6vhZq");

var $6AFYk = parcelRequire("6AFYk");
var $e1ba01761963e22f$var$inherit = $dbC7k.util.inherit;
var $e1ba01761963e22f$var$clientCount = 0;
/**
 * The service class representing an AWS service.
 *
 * @class_abstract This class is an abstract class.
 *
 * @!attribute apiVersions
 *   @return [Array<String>] the list of API versions supported by this service.
 *   @readonly
 */ $dbC7k.Service = $e1ba01761963e22f$var$inherit({
    /**
   * Create a new service object with a configuration object
   *
   * @param config [map] a map of configuration options
   */ constructor: function Service(config) {
        if (!this.loadServiceClass) throw $dbC7k.util.error(new Error(), "Service must be constructed with `new' operator");
        var ServiceClass = this.loadServiceClass(config || {});
        if (ServiceClass) {
            var originalConfig = $dbC7k.util.copy(config);
            var svc = new ServiceClass(config);
            Object.defineProperty(svc, "_originalConfig", {
                get: function() {
                    return originalConfig;
                },
                enumerable: false,
                configurable: true
            });
            svc._clientId = ++$e1ba01761963e22f$var$clientCount;
            return svc;
        }
        this.initialize(config);
    },
    /**
   * @api private
   */ initialize: function initialize(config) {
        var svcConfig = $dbC7k.config[this.serviceIdentifier];
        this.config = new $dbC7k.Config($dbC7k.config);
        if (svcConfig) this.config.update(svcConfig, true);
        if (config) this.config.update(config, true);
        this.validateService();
        if (!this.config.endpoint) $6AFYk(this);
        this.config.endpoint = this.endpointFromTemplate(this.config.endpoint);
        this.setEndpoint(this.config.endpoint);
        //enable attaching listeners to service client
        $dbC7k.SequentialExecutor.call(this);
        $dbC7k.Service.addDefaultMonitoringListeners(this);
        if ((this.config.clientSideMonitoring || $dbC7k.Service._clientSideMonitoring) && this.publisher) {
            var publisher = this.publisher;
            this.addNamedListener("PUBLISH_API_CALL", "apiCall", function PUBLISH_API_CALL(event) {
                $e67mm.nextTick(function() {
                    publisher.eventHandler(event);
                });
            });
            this.addNamedListener("PUBLISH_API_ATTEMPT", "apiCallAttempt", function PUBLISH_API_ATTEMPT(event) {
                $e67mm.nextTick(function() {
                    publisher.eventHandler(event);
                });
            });
        }
    },
    /**
   * @api private
   */ validateService: function validateService() {},
    /**
   * @api private
   */ loadServiceClass: function loadServiceClass(serviceConfig) {
        var config = serviceConfig;
        if (!$dbC7k.util.isEmpty(this.api)) return null;
        else if (config.apiConfig) return $dbC7k.Service.defineServiceApi(this.constructor, config.apiConfig);
        else if (!this.constructor.services) return null;
        else {
            config = new $dbC7k.Config($dbC7k.config);
            config.update(serviceConfig, true);
            var version = config.apiVersions[this.constructor.serviceIdentifier];
            version = version || config.apiVersion;
            return this.getLatestServiceClass(version);
        }
    },
    /**
   * @api private
   */ getLatestServiceClass: function getLatestServiceClass(version) {
        version = this.getLatestServiceVersion(version);
        if (this.constructor.services[version] === null) $dbC7k.Service.defineServiceApi(this.constructor, version);
        return this.constructor.services[version];
    },
    /**
   * @api private
   */ getLatestServiceVersion: function getLatestServiceVersion(version) {
        if (!this.constructor.services || this.constructor.services.length === 0) throw new Error("No services defined on " + this.constructor.serviceIdentifier);
        if (!version) version = "latest";
        else if ($dbC7k.util.isType(version, Date)) version = $dbC7k.util.date.iso8601(version).split("T")[0];
        if (Object.hasOwnProperty(this.constructor.services, version)) return version;
        var keys = Object.keys(this.constructor.services).sort();
        var selectedVersion = null;
        for(var i = keys.length - 1; i >= 0; i--){
            // versions that end in "*" are not available on disk and can be
            // skipped, so do not choose these as selectedVersions
            if (keys[i][keys[i].length - 1] !== "*") selectedVersion = keys[i];
            if (keys[i].substr(0, 10) <= version) return selectedVersion;
        }
        throw new Error("Could not find " + this.constructor.serviceIdentifier + " API to satisfy version constraint `" + version + "'");
    },
    /**
   * @api private
   */ api: {},
    /**
   * @api private
   */ defaultRetryCount: 3,
    /**
   * @api private
   */ customizeRequests: function customizeRequests(callback) {
        if (!callback) this.customRequestHandler = null;
        else if (typeof callback === "function") this.customRequestHandler = callback;
        else throw new Error("Invalid callback type '" + typeof callback + "' provided in customizeRequests");
    },
    /**
   * Calls an operation on a service with the given input parameters.
   *
   * @param operation [String] the name of the operation to call on the service.
   * @param params [map] a map of input options for the operation
   * @callback callback function(err, data)
   *   If a callback is supplied, it is called when a response is returned
   *   from the service.
   *   @param err [Error] the error object returned from the request.
   *     Set to `null` if the request is successful.
   *   @param data [Object] the de-serialized data returned from
   *     the request. Set to `null` if a request error occurs.
   */ makeRequest: function makeRequest(operation, params, callback) {
        if (typeof params === "function") {
            callback = params;
            params = null;
        }
        params = params || {};
        if (this.config.params) {
            var rules = this.api.operations[operation];
            if (rules) {
                params = $dbC7k.util.copy(params);
                $dbC7k.util.each(this.config.params, function(key, value) {
                    if (rules.input.members[key]) {
                        if (params[key] === undefined || params[key] === null) params[key] = value;
                    }
                });
            }
        }
        var request = new $dbC7k.Request(this, operation, params);
        this.addAllRequestListeners(request);
        this.attachMonitoringEmitter(request);
        if (callback) request.send(callback);
        return request;
    },
    /**
   * Calls an operation on a service with the given input parameters, without
   * any authentication data. This method is useful for "public" API operations.
   *
   * @param operation [String] the name of the operation to call on the service.
   * @param params [map] a map of input options for the operation
   * @callback callback function(err, data)
   *   If a callback is supplied, it is called when a response is returned
   *   from the service.
   *   @param err [Error] the error object returned from the request.
   *     Set to `null` if the request is successful.
   *   @param data [Object] the de-serialized data returned from
   *     the request. Set to `null` if a request error occurs.
   */ makeUnauthenticatedRequest: function makeUnauthenticatedRequest(operation, params, callback) {
        if (typeof params === "function") {
            callback = params;
            params = {};
        }
        var request = this.makeRequest(operation, params).toUnauthenticated();
        return callback ? request.send(callback) : request;
    },
    /**
   * Waits for a given state
   *
   * @param state [String] the state on the service to wait for
   * @param params [map] a map of parameters to pass with each request
   * @option params $waiter [map] a map of configuration options for the waiter
   * @option params $waiter.delay [Number] The number of seconds to wait between
   *                                       requests
   * @option params $waiter.maxAttempts [Number] The maximum number of requests
   *                                             to send while waiting
   * @callback callback function(err, data)
   *   If a callback is supplied, it is called when a response is returned
   *   from the service.
   *   @param err [Error] the error object returned from the request.
   *     Set to `null` if the request is successful.
   *   @param data [Object] the de-serialized data returned from
   *     the request. Set to `null` if a request error occurs.
   */ waitFor: function waitFor(state, params, callback) {
        var waiter = new $dbC7k.ResourceWaiter(this, state);
        return waiter.wait(params, callback);
    },
    /**
   * @api private
   */ addAllRequestListeners: function addAllRequestListeners(request) {
        var list = [
            $dbC7k.events,
            $dbC7k.EventListeners.Core,
            this.serviceInterface(),
            $dbC7k.EventListeners.CorePost
        ];
        for(var i = 0; i < list.length; i++)if (list[i]) request.addListeners(list[i]);
        // disable parameter validation
        if (!this.config.paramValidation) request.removeListener("validate", $dbC7k.EventListeners.Core.VALIDATE_PARAMETERS);
        if (this.config.logger) request.addListeners($dbC7k.EventListeners.Logger);
        this.setupRequestListeners(request);
        // call prototype's customRequestHandler
        if (typeof this.constructor.prototype.customRequestHandler === "function") this.constructor.prototype.customRequestHandler(request);
        // call instance's customRequestHandler
        if (Object.prototype.hasOwnProperty.call(this, "customRequestHandler") && typeof this.customRequestHandler === "function") this.customRequestHandler(request);
    },
    /**
   * Event recording metrics for a whole API call.
   * @returns {object} a subset of api call metrics
   * @api private
   */ apiCallEvent: function apiCallEvent(request) {
        var api = request.service.api.operations[request.operation];
        var monitoringEvent = {
            Type: "ApiCall",
            Api: api ? api.name : request.operation,
            Version: 1,
            Service: request.service.api.serviceId || request.service.api.endpointPrefix,
            Region: request.httpRequest.region,
            MaxRetriesExceeded: 0,
            UserAgent: request.httpRequest.getUserAgent()
        };
        var response = request.response;
        if (response.httpResponse.statusCode) monitoringEvent.FinalHttpStatusCode = response.httpResponse.statusCode;
        if (response.error) {
            var error = response.error;
            var statusCode = response.httpResponse.statusCode;
            if (statusCode > 299) {
                if (error.code) monitoringEvent.FinalAwsException = error.code;
                if (error.message) monitoringEvent.FinalAwsExceptionMessage = error.message;
            } else {
                if (error.code || error.name) monitoringEvent.FinalSdkException = error.code || error.name;
                if (error.message) monitoringEvent.FinalSdkExceptionMessage = error.message;
            }
        }
        return monitoringEvent;
    },
    /**
   * Event recording metrics for an API call attempt.
   * @returns {object} a subset of api call attempt metrics
   * @api private
   */ apiAttemptEvent: function apiAttemptEvent(request) {
        var api = request.service.api.operations[request.operation];
        var monitoringEvent = {
            Type: "ApiCallAttempt",
            Api: api ? api.name : request.operation,
            Version: 1,
            Service: request.service.api.serviceId || request.service.api.endpointPrefix,
            Fqdn: request.httpRequest.endpoint.hostname,
            UserAgent: request.httpRequest.getUserAgent()
        };
        var response = request.response;
        if (response.httpResponse.statusCode) monitoringEvent.HttpStatusCode = response.httpResponse.statusCode;
        if (!request._unAuthenticated && request.service.config.credentials && request.service.config.credentials.accessKeyId) monitoringEvent.AccessKey = request.service.config.credentials.accessKeyId;
        if (!response.httpResponse.headers) return monitoringEvent;
        if (request.httpRequest.headers["x-amz-security-token"]) monitoringEvent.SessionToken = request.httpRequest.headers["x-amz-security-token"];
        if (response.httpResponse.headers["x-amzn-requestid"]) monitoringEvent.XAmznRequestId = response.httpResponse.headers["x-amzn-requestid"];
        if (response.httpResponse.headers["x-amz-request-id"]) monitoringEvent.XAmzRequestId = response.httpResponse.headers["x-amz-request-id"];
        if (response.httpResponse.headers["x-amz-id-2"]) monitoringEvent.XAmzId2 = response.httpResponse.headers["x-amz-id-2"];
        return monitoringEvent;
    },
    /**
   * Add metrics of failed request.
   * @api private
   */ attemptFailEvent: function attemptFailEvent(request) {
        var monitoringEvent = this.apiAttemptEvent(request);
        var response = request.response;
        var error = response.error;
        if (response.httpResponse.statusCode > 299) {
            if (error.code) monitoringEvent.AwsException = error.code;
            if (error.message) monitoringEvent.AwsExceptionMessage = error.message;
        } else {
            if (error.code || error.name) monitoringEvent.SdkException = error.code || error.name;
            if (error.message) monitoringEvent.SdkExceptionMessage = error.message;
        }
        return monitoringEvent;
    },
    /**
   * Attach listeners to request object to fetch metrics of each request
   * and emit data object through \'ApiCall\' and \'ApiCallAttempt\' events.
   * @api private
   */ attachMonitoringEmitter: function attachMonitoringEmitter(request) {
        var attemptTimestamp; //timestamp marking the beginning of a request attempt
        var attemptStartRealTime; //Start time of request attempt. Used to calculating attemptLatency
        var attemptLatency; //latency from request sent out to http response reaching SDK
        var callStartRealTime; //Start time of API call. Used to calculating API call latency
        var attemptCount = 0; //request.retryCount is not reliable here
        var region; //region cache region for each attempt since it can be updated in plase (e.g. s3)
        var callTimestamp; //timestamp when the request is created
        var self = this;
        var addToHead = true;
        request.on("validate", function() {
            callStartRealTime = $dbC7k.util.realClock.now();
            callTimestamp = Date.now();
        }, addToHead);
        request.on("sign", function() {
            attemptStartRealTime = $dbC7k.util.realClock.now();
            attemptTimestamp = Date.now();
            region = request.httpRequest.region;
            attemptCount++;
        }, addToHead);
        request.on("validateResponse", function() {
            attemptLatency = Math.round($dbC7k.util.realClock.now() - attemptStartRealTime);
        });
        request.addNamedListener("API_CALL_ATTEMPT", "success", function API_CALL_ATTEMPT() {
            var apiAttemptEvent = self.apiAttemptEvent(request);
            apiAttemptEvent.Timestamp = attemptTimestamp;
            apiAttemptEvent.AttemptLatency = attemptLatency >= 0 ? attemptLatency : 0;
            apiAttemptEvent.Region = region;
            self.emit("apiCallAttempt", [
                apiAttemptEvent
            ]);
        });
        request.addNamedListener("API_CALL_ATTEMPT_RETRY", "retry", function API_CALL_ATTEMPT_RETRY() {
            var apiAttemptEvent = self.attemptFailEvent(request);
            apiAttemptEvent.Timestamp = attemptTimestamp;
            //attemptLatency may not be available if fail before response
            attemptLatency = attemptLatency || Math.round($dbC7k.util.realClock.now() - attemptStartRealTime);
            apiAttemptEvent.AttemptLatency = attemptLatency >= 0 ? attemptLatency : 0;
            apiAttemptEvent.Region = region;
            self.emit("apiCallAttempt", [
                apiAttemptEvent
            ]);
        });
        request.addNamedListener("API_CALL", "complete", function API_CALL() {
            var apiCallEvent = self.apiCallEvent(request);
            apiCallEvent.AttemptCount = attemptCount;
            if (apiCallEvent.AttemptCount <= 0) return;
            apiCallEvent.Timestamp = callTimestamp;
            var latency = Math.round($dbC7k.util.realClock.now() - callStartRealTime);
            apiCallEvent.Latency = latency >= 0 ? latency : 0;
            var response = request.response;
            if (typeof response.retryCount === "number" && typeof response.maxRetries === "number" && response.retryCount >= response.maxRetries) apiCallEvent.MaxRetriesExceeded = 1;
            self.emit("apiCall", [
                apiCallEvent
            ]);
        });
    },
    /**
   * Override this method to setup any custom request listeners for each
   * new request to the service.
   *
   * @method_abstract This is an abstract method.
   */ setupRequestListeners: function setupRequestListeners(request) {},
    /**
   * Gets the signer class for a given request
   * @api private
   */ getSignerClass: function getSignerClass(request) {
        var version;
        // get operation authtype if present
        var operation = null;
        var authtype = "";
        if (request) {
            var operations = request.service.api.operations || {};
            operation = operations[request.operation] || null;
            authtype = operation ? operation.authtype : "";
        }
        if (this.config.signatureVersion) version = this.config.signatureVersion;
        else if (authtype === "v4" || authtype === "v4-unsigned-body") version = "v4";
        else version = this.api.signatureVersion;
        return $dbC7k.Signers.RequestSigner.getVersion(version);
    },
    /**
   * @api private
   */ serviceInterface: function serviceInterface() {
        switch(this.api.protocol){
            case "ec2":
                return $dbC7k.EventListeners.Query;
            case "query":
                return $dbC7k.EventListeners.Query;
            case "json":
                return $dbC7k.EventListeners.Json;
            case "rest-json":
                return $dbC7k.EventListeners.RestJson;
            case "rest-xml":
                return $dbC7k.EventListeners.RestXml;
        }
        if (this.api.protocol) throw new Error("Invalid service `protocol' " + this.api.protocol + " in API config");
    },
    /**
   * @api private
   */ successfulResponse: function successfulResponse(resp) {
        return resp.httpResponse.statusCode < 300;
    },
    /**
   * How many times a failed request should be retried before giving up.
   * the defaultRetryCount can be overriden by service classes.
   *
   * @api private
   */ numRetries: function numRetries() {
        if (this.config.maxRetries !== undefined) return this.config.maxRetries;
        else return this.defaultRetryCount;
    },
    /**
   * @api private
   */ retryDelays: function retryDelays(retryCount) {
        return $dbC7k.util.calculateRetryDelay(retryCount, this.config.retryDelayOptions);
    },
    /**
   * @api private
   */ retryableError: function retryableError(error) {
        if (this.timeoutError(error)) return true;
        if (this.networkingError(error)) return true;
        if (this.expiredCredentialsError(error)) return true;
        if (this.throttledError(error)) return true;
        if (error.statusCode >= 500) return true;
        return false;
    },
    /**
   * @api private
   */ networkingError: function networkingError(error) {
        return error.code === "NetworkingError";
    },
    /**
   * @api private
   */ timeoutError: function timeoutError(error) {
        return error.code === "TimeoutError";
    },
    /**
   * @api private
   */ expiredCredentialsError: function expiredCredentialsError(error) {
        // TODO : this only handles *one* of the expired credential codes
        return error.code === "ExpiredTokenException";
    },
    /**
   * @api private
   */ clockSkewError: function clockSkewError(error) {
        switch(error.code){
            case "RequestTimeTooSkewed":
            case "RequestExpired":
            case "InvalidSignatureException":
            case "SignatureDoesNotMatch":
            case "AuthFailure":
            case "RequestInTheFuture":
                return true;
            default:
                return false;
        }
    },
    /**
   * @api private
   */ getSkewCorrectedDate: function getSkewCorrectedDate() {
        return new Date(Date.now() + this.config.systemClockOffset);
    },
    /**
   * @api private
   */ applyClockOffset: function applyClockOffset(newServerTime) {
        if (newServerTime) this.config.systemClockOffset = newServerTime - Date.now();
    },
    /**
   * @api private
   */ isClockSkewed: function isClockSkewed(newServerTime) {
        if (newServerTime) return Math.abs(this.getSkewCorrectedDate().getTime() - newServerTime) >= 30000;
    },
    /**
   * @api private
   */ throttledError: function throttledError(error) {
        // this logic varies between services
        switch(error.code){
            case "ProvisionedThroughputExceededException":
            case "Throttling":
            case "ThrottlingException":
            case "RequestLimitExceeded":
            case "RequestThrottled":
            case "RequestThrottledException":
            case "TooManyRequestsException":
            case "TransactionInProgressException":
                return true;
            default:
                return false;
        }
    },
    /**
   * @api private
   */ endpointFromTemplate: function endpointFromTemplate(endpoint) {
        if (typeof endpoint !== "string") return endpoint;
        var e = endpoint;
        e = e.replace(/\{service\}/g, this.api.endpointPrefix);
        e = e.replace(/\{region\}/g, this.config.region);
        e = e.replace(/\{scheme\}/g, this.config.sslEnabled ? "https" : "http");
        return e;
    },
    /**
   * @api private
   */ setEndpoint: function setEndpoint(endpoint) {
        this.endpoint = new $dbC7k.Endpoint(endpoint, this.config);
    },
    /**
   * @api private
   */ paginationConfig: function paginationConfig(operation, throwException) {
        var paginator = this.api.operations[operation].paginator;
        if (!paginator) {
            if (throwException) {
                var e = new Error();
                throw $dbC7k.util.error(e, "No pagination configuration for " + operation);
            }
            return null;
        }
        return paginator;
    }
});
$dbC7k.util.update($dbC7k.Service, {
    /**
   * Adds one method for each operation described in the api configuration
   *
   * @api private
   */ defineMethods: function defineMethods(svc) {
        $dbC7k.util.each(svc.prototype.api.operations, function iterator(method) {
            if (svc.prototype[method]) return;
            var operation = svc.prototype.api.operations[method];
            if (operation.authtype === "none") svc.prototype[method] = function(params, callback) {
                return this.makeUnauthenticatedRequest(method, params, callback);
            };
            else svc.prototype[method] = function(params, callback) {
                return this.makeRequest(method, params, callback);
            };
        });
    },
    /**
   * Defines a new Service class using a service identifier and list of versions
   * including an optional set of features (functions) to apply to the class
   * prototype.
   *
   * @param serviceIdentifier [String] the identifier for the service
   * @param versions [Array<String>] a list of versions that work with this
   *   service
   * @param features [Object] an object to attach to the prototype
   * @return [Class<Service>] the service class defined by this function.
   */ defineService: function defineService(serviceIdentifier, versions, features) {
        $dbC7k.Service._serviceMap[serviceIdentifier] = true;
        if (!Array.isArray(versions)) {
            features = versions;
            versions = [];
        }
        var svc = $e1ba01761963e22f$var$inherit($dbC7k.Service, features || {});
        if (typeof serviceIdentifier === "string") {
            $dbC7k.Service.addVersions(svc, versions);
            var identifier = svc.serviceIdentifier || serviceIdentifier;
            svc.serviceIdentifier = identifier;
        } else {
            svc.prototype.api = serviceIdentifier;
            $dbC7k.Service.defineMethods(svc);
        }
        $dbC7k.SequentialExecutor.call(this.prototype);
        //util.clientSideMonitoring is only available in node
        if (!this.prototype.publisher && $dbC7k.util.clientSideMonitoring) {
            var Publisher = $dbC7k.util.clientSideMonitoring.Publisher;
            var configProvider = $dbC7k.util.clientSideMonitoring.configProvider;
            var publisherConfig = configProvider();
            this.prototype.publisher = new Publisher(publisherConfig);
            if (publisherConfig.enabled) //if csm is enabled in environment, SDK should send all metrics
            $dbC7k.Service._clientSideMonitoring = true;
        }
        $dbC7k.SequentialExecutor.call(svc.prototype);
        $dbC7k.Service.addDefaultMonitoringListeners(svc.prototype);
        return svc;
    },
    /**
   * @api private
   */ addVersions: function addVersions(svc, versions) {
        if (!Array.isArray(versions)) versions = [
            versions
        ];
        svc.services = svc.services || {};
        for(var i = 0; i < versions.length; i++)if (svc.services[versions[i]] === undefined) svc.services[versions[i]] = null;
        svc.apiVersions = Object.keys(svc.services).sort();
    },
    /**
   * @api private
   */ defineServiceApi: function defineServiceApi(superclass, version, apiConfig) {
        var svc = $e1ba01761963e22f$var$inherit(superclass, {
            serviceIdentifier: superclass.serviceIdentifier
        });
        function setApi(api) {
            if (api.isApi) svc.prototype.api = api;
            else svc.prototype.api = new $6vhZq(api);
        }
        if (typeof version === "string") {
            if (apiConfig) setApi(apiConfig);
            else try {
                setApi($dbC7k.apiLoader(superclass.serviceIdentifier, version));
            } catch (err) {
                throw $dbC7k.util.error(err, {
                    message: "Could not find API configuration " + superclass.serviceIdentifier + "-" + version
                });
            }
            if (!Object.prototype.hasOwnProperty.call(superclass.services, version)) superclass.apiVersions = superclass.apiVersions.concat(version).sort();
            superclass.services[version] = svc;
        } else setApi(version);
        $dbC7k.Service.defineMethods(svc);
        return svc;
    },
    /**
   * @api private
   */ hasService: function(identifier) {
        return Object.prototype.hasOwnProperty.call($dbC7k.Service._serviceMap, identifier);
    },
    /**
   * @param attachOn attach default monitoring listeners to object
   *
   * Each monitoring event should be emitted from service client to service constructor prototype and then
   * to global service prototype like bubbling up. These default monitoring events listener will transfer
   * the monitoring events to the upper layer.
   * @api private
   */ addDefaultMonitoringListeners: function addDefaultMonitoringListeners(attachOn) {
        attachOn.addNamedListener("MONITOR_EVENTS_BUBBLE", "apiCallAttempt", function EVENTS_BUBBLE(event) {
            var baseClass = Object.getPrototypeOf(attachOn);
            if (baseClass._events) baseClass.emit("apiCallAttempt", [
                event
            ]);
        });
        attachOn.addNamedListener("CALL_EVENTS_BUBBLE", "apiCall", function CALL_EVENTS_BUBBLE(event) {
            var baseClass = Object.getPrototypeOf(attachOn);
            if (baseClass._events) baseClass.emit("apiCall", [
                event
            ]);
        });
    },
    /**
   * @api private
   */ _serviceMap: {}
});
$dbC7k.util.mixin($dbC7k.Service, $dbC7k.SequentialExecutor);
/**
 * @api private
 */ module.exports = $dbC7k.Service;

});
parcelRequire.register("6AFYk", function(module, exports) {

var $5DMlf = parcelRequire("5DMlf");

var $iz1fI = parcelRequire("iz1fI");
function $4cc6a99f03a232ac$var$generateRegionPrefix(region) {
    if (!region) return null;
    var parts = region.split("-");
    if (parts.length < 3) return null;
    return parts.slice(0, parts.length - 2).join("-") + "-*";
}
function $4cc6a99f03a232ac$var$derivedKeys(service) {
    var region = service.config.region;
    var regionPrefix = $4cc6a99f03a232ac$var$generateRegionPrefix(region);
    var endpointPrefix = service.api.endpointPrefix;
    return [
        [
            region,
            endpointPrefix
        ],
        [
            regionPrefix,
            endpointPrefix
        ],
        [
            region,
            "*"
        ],
        [
            regionPrefix,
            "*"
        ],
        [
            "*",
            endpointPrefix
        ],
        [
            "*",
            "*"
        ]
    ].map(function(item) {
        return item[0] && item[1] ? item.join("/") : null;
    });
}
function $4cc6a99f03a232ac$var$applyConfig(service, config) {
    $5DMlf.each(config, function(key, value) {
        if (key === "globalEndpoint") return;
        if (service.config[key] === undefined || service.config[key] === null) service.config[key] = value;
    });
}
function $4cc6a99f03a232ac$var$configureEndpoint(service) {
    var keys = $4cc6a99f03a232ac$var$derivedKeys(service);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!key) continue;
        if (Object.prototype.hasOwnProperty.call($iz1fI.rules, key)) {
            var config = $iz1fI.rules[key];
            if (typeof config === "string") config = $iz1fI.patterns[config];
            // set dualstack endpoint
            if (service.config.useDualstack && $5DMlf.isDualstackAvailable(service)) {
                config = $5DMlf.copy(config);
                config.endpoint = "{service}.dualstack.{region}.amazonaws.com";
            }
            // set global endpoint
            service.isGlobalEndpoint = !!config.globalEndpoint;
            // signature version
            if (!config.signatureVersion) config.signatureVersion = "v4";
            // merge config
            $4cc6a99f03a232ac$var$applyConfig(service, config);
            return;
        }
    }
}
/**
 * @api private
 */ module.exports = $4cc6a99f03a232ac$var$configureEndpoint;

});
parcelRequire.register("iz1fI", function(module, exports) {
module.exports = JSON.parse('{"rules":{"*/*":{"endpoint":"{service}.{region}.amazonaws.com"},"cn-*/*":{"endpoint":"{service}.{region}.amazonaws.com.cn"},"*/budgets":"globalSSL","*/cloudfront":"globalSSL","*/iam":"globalSSL","*/sts":"globalSSL","*/importexport":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2","globalEndpoint":true},"*/route53":{"endpoint":"https://{service}.amazonaws.com","signatureVersion":"v3https","globalEndpoint":true},"*/waf":"globalSSL","us-gov-*/iam":"globalGovCloud","us-gov-*/sts":{"endpoint":"{service}.{region}.amazonaws.com"},"us-gov-west-1/s3":"s3signature","us-west-1/s3":"s3signature","us-west-2/s3":"s3signature","eu-west-1/s3":"s3signature","ap-southeast-1/s3":"s3signature","ap-southeast-2/s3":"s3signature","ap-northeast-1/s3":"s3signature","sa-east-1/s3":"s3signature","us-east-1/s3":{"endpoint":"{service}.amazonaws.com","signatureVersion":"s3"},"us-east-1/sdb":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2"},"*/sdb":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"v2"}},"patterns":{"globalSSL":{"endpoint":"https://{service}.amazonaws.com","globalEndpoint":true},"globalGovCloud":{"endpoint":"{service}.us-gov.amazonaws.com"},"s3signature":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"s3"}}}');

});



parcelRequire.register("85vkQ", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
parcelRequire("bph5V");
parcelRequire("1KJHg");
var $5e3718da5ab6b157$var$PromisesDependency;
/**
 * The main configuration class used by all service objects to set
 * the region, credentials, and other options for requests.
 *
 * By default, credentials and region settings are left unconfigured.
 * This should be configured by the application before using any
 * AWS service APIs.
 *
 * In order to set global configuration options, properties should
 * be assigned to the global {AWS.config} object.
 *
 * @see AWS.config
 *
 * @!group General Configuration Options
 *
 * @!attribute credentials
 *   @return [AWS.Credentials] the AWS credentials to sign requests with.
 *
 * @!attribute region
 *   @example Set the global region setting to us-west-2
 *     AWS.config.update({region: 'us-west-2'});
 *   @return [AWS.Credentials] The region to send service requests to.
 *   @see http://docs.amazonwebservices.com/general/latest/gr/rande.html
 *     A list of available endpoints for each AWS service
 *
 * @!attribute maxRetries
 *   @return [Integer] the maximum amount of retries to perform for a
 *     service request. By default this value is calculated by the specific
 *     service object that the request is being made to.
 *
 * @!attribute maxRedirects
 *   @return [Integer] the maximum amount of redirects to follow for a
 *     service request. Defaults to 10.
 *
 * @!attribute paramValidation
 *   @return [Boolean|map] whether input parameters should be validated against
 *     the operation description before sending the request. Defaults to true.
 *     Pass a map to enable any of the following specific validation features:
 *
 *     * **min** [Boolean] &mdash; Validates that a value meets the min
 *       constraint. This is enabled by default when paramValidation is set
 *       to `true`.
 *     * **max** [Boolean] &mdash; Validates that a value meets the max
 *       constraint.
 *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
 *       regular expression.
 *     * **enum** [Boolean] &mdash; Validates that a string value matches one
 *       of the allowable enum values.
 *
 * @!attribute computeChecksums
 *   @return [Boolean] whether to compute checksums for payload bodies when
 *     the service accepts it (currently supported in S3 only).
 *
 * @!attribute convertResponseTypes
 *   @return [Boolean] whether types are converted when parsing response data.
 *     Currently only supported for JSON based services. Turning this off may
 *     improve performance on large response payloads. Defaults to `true`.
 *
 * @!attribute correctClockSkew
 *   @return [Boolean] whether to apply a clock skew correction and retry
 *     requests that fail because of an skewed client clock. Defaults to
 *     `false`.
 *
 * @!attribute sslEnabled
 *   @return [Boolean] whether SSL is enabled for requests
 *
 * @!attribute s3ForcePathStyle
 *   @return [Boolean] whether to force path style URLs for S3 objects
 *
 * @!attribute s3BucketEndpoint
 *   @note Setting this configuration option requires an `endpoint` to be
 *     provided explicitly to the service constructor.
 *   @return [Boolean] whether the provided endpoint addresses an individual
 *     bucket (false if it addresses the root API endpoint).
 *
 * @!attribute s3DisableBodySigning
 *   @return [Boolean] whether to disable S3 body signing when using signature version `v4`.
 *     Body signing can only be disabled when using https. Defaults to `true`.
 *
 * @!attribute useAccelerateEndpoint
 *   @note This configuration option is only compatible with S3 while accessing
 *     dns-compatible buckets.
 *   @return [Boolean] Whether to use the Accelerate endpoint with the S3 service.
 *     Defaults to `false`.
 *
 * @!attribute retryDelayOptions
 *   @example Set the base retry delay for all services to 300 ms
 *     AWS.config.update({retryDelayOptions: {base: 300}});
 *     // Delays with maxRetries = 3: 300, 600, 1200
 *   @example Set a custom backoff function to provide delay values on retries
 *     AWS.config.update({retryDelayOptions: {customBackoff: function(retryCount) {
 *       // returns delay in ms
 *     }}});
 *   @return [map] A set of options to configure the retry delay on retryable errors.
 *     Currently supported options are:
 *
 *     * **base** [Integer] &mdash; The base number of milliseconds to use in the
 *       exponential backoff for operation retries. Defaults to 100 ms for all services except
 *       DynamoDB, where it defaults to 50ms.
 *     * **customBackoff ** [function] &mdash; A custom function that accepts a retry count
 *       and returns the amount of time to delay in milliseconds. The `base` option will be
 *       ignored if this option is supplied.
 *
 * @!attribute httpOptions
 *   @return [map] A set of options to pass to the low-level HTTP request.
 *     Currently supported options are:
 *
 *     * **proxy** [String] &mdash; the URL to proxy requests through
 *     * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
 *       HTTP requests with. Used for connection pooling. Note that for
 *       SSL connections, a special Agent object is used in order to enable
 *       peer certificate verification. This feature is only supported in the
 *       Node.js environment.
 *     * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
 *       failing to establish a connection with the server after
 *       `connectTimeout` milliseconds. This timeout has no effect once a socket
 *       connection has been established.
 *     * **timeout** [Integer] &mdash; Sets the socket to timeout after timeout
 *       milliseconds of inactivity on the socket. Defaults to two minutes
 *       (120000)
 *     * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
 *       HTTP requests. Used in the browser environment only. Set to false to
 *       send requests synchronously. Defaults to true (async on).
 *     * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
 *       property of an XMLHttpRequest object. Used in the browser environment
 *       only. Defaults to false.
 * @!attribute logger
 *   @return [#write,#log] an object that responds to .write() (like a stream)
 *     or .log() (like the console object) in order to log information about
 *     requests
 *
 * @!attribute systemClockOffset
 *   @return [Number] an offset value in milliseconds to apply to all signing
 *     times. Use this to compensate for clock skew when your system may be
 *     out of sync with the service time. Note that this configuration option
 *     can only be applied to the global `AWS.config` object and cannot be
 *     overridden in service-specific configuration. Defaults to 0 milliseconds.
 *
 * @!attribute signatureVersion
 *   @return [String] the signature version to sign requests with (overriding
 *     the API configuration). Possible values are: 'v2', 'v3', 'v4'.
 *
 * @!attribute signatureCache
 *   @return [Boolean] whether the signature to sign requests with (overriding
 *     the API configuration) is cached. Only applies to the signature version 'v4'.
 *     Defaults to `true`.
 *
 * @!attribute endpointDiscoveryEnabled
 *   @return [Boolean] whether to enable endpoint discovery for operations that
 *     allow optionally using an endpoint returned by the service.
 *     Defaults to 'false'
 *
 * @!attribute endpointCacheSize
 *   @return [Number] the size of the global cache storing endpoints from endpoint
 *     discovery operations. Once endpoint cache is created, updating this setting
 *     cannot change existing cache size.
 *     Defaults to 1000
 *
 * @!attribute hostPrefixEnabled
 *   @return [Boolean] whether to marshal request parameters to the prefix of
 *     hostname. Defaults to `true`.
 */ $dbC7k.Config = $dbC7k.util.inherit({
    /**
   * @!endgroup
   */ /**
   * Creates a new configuration object. This is the object that passes
   * option data along to service requests, including credentials, security,
   * region information, and some service specific settings.
   *
   * @example Creating a new configuration object with credentials and region
   *   var config = new AWS.Config({
   *     accessKeyId: 'AKID', secretAccessKey: 'SECRET', region: 'us-west-2'
   *   });
   * @option options accessKeyId [String] your AWS access key ID.
   * @option options secretAccessKey [String] your AWS secret access key.
   * @option options sessionToken [AWS.Credentials] the optional AWS
   *   session token to sign requests with.
   * @option options credentials [AWS.Credentials] the AWS credentials
   *   to sign requests with. You can either specify this object, or
   *   specify the accessKeyId and secretAccessKey options directly.
   * @option options credentialProvider [AWS.CredentialProviderChain] the
   *   provider chain used to resolve credentials if no static `credentials`
   *   property is set.
   * @option options region [String] the region to send service requests to.
   *   See {region} for more information.
   * @option options maxRetries [Integer] the maximum amount of retries to
   *   attempt with a request. See {maxRetries} for more information.
   * @option options maxRedirects [Integer] the maximum amount of redirects to
   *   follow with a request. See {maxRedirects} for more information.
   * @option options sslEnabled [Boolean] whether to enable SSL for
   *   requests.
   * @option options paramValidation [Boolean|map] whether input parameters
   *   should be validated against the operation description before sending
   *   the request. Defaults to true. Pass a map to enable any of the
   *   following specific validation features:
   *
   *   * **min** [Boolean] &mdash; Validates that a value meets the min
   *     constraint. This is enabled by default when paramValidation is set
   *     to `true`.
   *   * **max** [Boolean] &mdash; Validates that a value meets the max
   *     constraint.
   *   * **pattern** [Boolean] &mdash; Validates that a string value matches a
   *     regular expression.
   *   * **enum** [Boolean] &mdash; Validates that a string value matches one
   *     of the allowable enum values.
   * @option options computeChecksums [Boolean] whether to compute checksums
   *   for payload bodies when the service accepts it (currently supported
   *   in S3 only)
   * @option options convertResponseTypes [Boolean] whether types are converted
   *     when parsing response data. Currently only supported for JSON based
   *     services. Turning this off may improve performance on large response
   *     payloads. Defaults to `true`.
   * @option options correctClockSkew [Boolean] whether to apply a clock skew
   *     correction and retry requests that fail because of an skewed client
   *     clock. Defaults to `false`.
   * @option options s3ForcePathStyle [Boolean] whether to force path
   *   style URLs for S3 objects.
   * @option options s3BucketEndpoint [Boolean] whether the provided endpoint
   *   addresses an individual bucket (false if it addresses the root API
   *   endpoint). Note that setting this configuration option requires an
   *   `endpoint` to be provided explicitly to the service constructor.
   * @option options s3DisableBodySigning [Boolean] whether S3 body signing
   *   should be disabled when using signature version `v4`. Body signing
   *   can only be disabled when using https. Defaults to `true`.
   *
   * @option options retryDelayOptions [map] A set of options to configure
   *   the retry delay on retryable errors. Currently supported options are:
   *
   *   * **base** [Integer] &mdash; The base number of milliseconds to use in the
   *     exponential backoff for operation retries. Defaults to 100 ms for all
   *     services except DynamoDB, where it defaults to 50ms.
   *   * **customBackoff ** [function] &mdash; A custom function that accepts a retry count
   *     and returns the amount of time to delay in milliseconds. The `base` option will be
   *     ignored if this option is supplied.
   * @option options httpOptions [map] A set of options to pass to the low-level
   *   HTTP request. Currently supported options are:
   *
   *   * **proxy** [String] &mdash; the URL to proxy requests through
   *   * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
   *     HTTP requests with. Used for connection pooling. Defaults to the global
   *     agent (`http.globalAgent`) for non-SSL connections. Note that for
   *     SSL connections, a special Agent object is used in order to enable
   *     peer certificate verification. This feature is only available in the
   *     Node.js environment.
   *   * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
   *     failing to establish a connection with the server after
   *     `connectTimeout` milliseconds. This timeout has no effect once a socket
   *     connection has been established.
   *   * **timeout** [Integer] &mdash; Sets the socket to timeout after timeout
   *     milliseconds of inactivity on the socket. Defaults to two minutes
   *     (120000).
   *   * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
   *     HTTP requests. Used in the browser environment only. Set to false to
   *     send requests synchronously. Defaults to true (async on).
   *   * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
   *     property of an XMLHttpRequest object. Used in the browser environment
   *     only. Defaults to false.
   * @option options apiVersion [String, Date] a String in YYYY-MM-DD format
   *   (or a date) that represents the latest possible API version that can be
   *   used in all services (unless overridden by `apiVersions`). Specify
   *   'latest' to use the latest possible version.
   * @option options apiVersions [map<String, String|Date>] a map of service
   *   identifiers (the lowercase service class name) with the API version to
   *   use when instantiating a service. Specify 'latest' for each individual
   *   that can use the latest available version.
   * @option options logger [#write,#log] an object that responds to .write()
   *   (like a stream) or .log() (like the console object) in order to log
   *   information about requests
   * @option options systemClockOffset [Number] an offset value in milliseconds
   *   to apply to all signing times. Use this to compensate for clock skew
   *   when your system may be out of sync with the service time. Note that
   *   this configuration option can only be applied to the global `AWS.config`
   *   object and cannot be overridden in service-specific configuration.
   *   Defaults to 0 milliseconds.
   * @option options signatureVersion [String] the signature version to sign
   *   requests with (overriding the API configuration). Possible values are:
   *   'v2', 'v3', 'v4'.
   * @option options signatureCache [Boolean] whether the signature to sign
   *   requests with (overriding the API configuration) is cached. Only applies
   *   to the signature version 'v4'. Defaults to `true`.
   * @option options dynamoDbCrc32 [Boolean] whether to validate the CRC32
   *   checksum of HTTP response bodies returned by DynamoDB. Default: `true`.
   * @option options useAccelerateEndpoint [Boolean] Whether to use the
   *   S3 Transfer Acceleration endpoint with the S3 service. Default: `false`.
   * @option options clientSideMonitoring [Boolean] whether to collect and
   *   publish this client's performance metrics of all its API requests.
   * @option options endpointDiscoveryEnabled [Boolean] whether to enable endpoint
   *   discovery for operations that allow optionally using an endpoint returned by
   *   the service.
   *   Defaults to 'false'
   * @option options endpointCacheSize [Number] the size of the global cache storing
   *   endpoints from endpoint discovery operations. Once endpoint cache is created,
   *   updating this setting cannot change existing cache size.
   *   Defaults to 1000
   * @option options hostPrefixEnabled [Boolean] whether to marshal request
   *   parameters to the prefix of hostname.
   *   Defaults to `true`.
   */ constructor: function Config(options) {
        if (options === undefined) options = {};
        options = this.extractCredentials(options);
        $dbC7k.util.each.call(this, this.keys, function(key, value) {
            this.set(key, options[key], value);
        });
    },
    /**
   * @!group Managing Credentials
   */ /**
   * Loads credentials from the configuration object. This is used internally
   * by the SDK to ensure that refreshable {Credentials} objects are properly
   * refreshed and loaded when sending a request. If you want to ensure that
   * your credentials are loaded prior to a request, you can use this method
   * directly to provide accurate credential data stored in the object.
   *
   * @note If you configure the SDK with static or environment credentials,
   *   the credential data should already be present in {credentials} attribute.
   *   This method is primarily necessary to load credentials from asynchronous
   *   sources, or sources that can refresh credentials periodically.
   * @example Getting your access key
   *   AWS.config.getCredentials(function(err) {
   *     if (err) console.log(err.stack); // credentials not loaded
   *     else console.log("Access Key:", AWS.config.credentials.accessKeyId);
   *   })
   * @callback callback function(err)
   *   Called when the {credentials} have been properly set on the configuration
   *   object.
   *
   *   @param err [Error] if this is set, credentials were not successfully
   *     loaded and this error provides information why.
   * @see credentials
   * @see Credentials
   */ getCredentials: function getCredentials(callback) {
        var self = this;
        function finish(err) {
            callback(err, err ? null : self.credentials);
        }
        function credError(msg, err) {
            return new $dbC7k.util.error(err || new Error(), {
                code: "CredentialsError",
                message: msg,
                name: "CredentialsError"
            });
        }
        function getAsyncCredentials() {
            self.credentials.get(function(err) {
                if (err) {
                    var msg = "Could not load credentials from " + self.credentials.constructor.name;
                    err = credError(msg, err);
                }
                finish(err);
            });
        }
        function getStaticCredentials() {
            var err = null;
            if (!self.credentials.accessKeyId || !self.credentials.secretAccessKey) err = credError("Missing credentials");
            finish(err);
        }
        if (self.credentials) {
            if (typeof self.credentials.get === "function") getAsyncCredentials();
            else getStaticCredentials();
        } else if (self.credentialProvider) self.credentialProvider.resolve(function(err, creds) {
            if (err) err = credError("Could not load credentials from any providers", err);
            self.credentials = creds;
            finish(err);
        });
        else finish(credError("No credentials to load"));
    },
    /**
   * @!group Loading and Setting Configuration Options
   */ /**
   * @overload update(options, allowUnknownKeys = false)
   *   Updates the current configuration object with new options.
   *
   *   @example Update maxRetries property of a configuration object
   *     config.update({maxRetries: 10});
   *   @param [Object] options a map of option keys and values.
   *   @param [Boolean] allowUnknownKeys whether unknown keys can be set on
   *     the configuration object. Defaults to `false`.
   *   @see constructor
   */ update: function update(options, allowUnknownKeys) {
        allowUnknownKeys = allowUnknownKeys || false;
        options = this.extractCredentials(options);
        $dbC7k.util.each.call(this, options, function(key, value) {
            if (allowUnknownKeys || Object.prototype.hasOwnProperty.call(this.keys, key) || $dbC7k.Service.hasService(key)) this.set(key, value);
        });
    },
    /**
   * Loads configuration data from a JSON file into this config object.
   * @note Loading configuration will reset all existing configuration
   *   on the object.
   * @!macro nobrowser
   * @param path [String] the path relative to your process's current
   *    working directory to load configuration from.
   * @return [AWS.Config] the same configuration object
   */ loadFromPath: function loadFromPath(path) {
        this.clear();
        var options = JSON.parse($dbC7k.util.readFileSync(path));
        var fileSystemCreds = new $dbC7k.FileSystemCredentials(path);
        var chain = new $dbC7k.CredentialProviderChain();
        chain.providers.unshift(fileSystemCreds);
        chain.resolve(function(err, creds) {
            if (err) throw err;
            else options.credentials = creds;
        });
        this.constructor(options);
        return this;
    },
    /**
   * Clears configuration data on this object
   *
   * @api private
   */ clear: function clear() {
        /*jshint forin:false */ $dbC7k.util.each.call(this, this.keys, function(key) {
            delete this[key];
        });
        // reset credential provider
        this.set("credentials", undefined);
        this.set("credentialProvider", undefined);
    },
    /**
   * Sets a property on the configuration object, allowing for a
   * default value
   * @api private
   */ set: function set(property, value, defaultValue) {
        if (value === undefined) {
            if (defaultValue === undefined) defaultValue = this.keys[property];
            if (typeof defaultValue === "function") this[property] = defaultValue.call(this);
            else this[property] = defaultValue;
        } else if (property === "httpOptions" && this[property]) // deep merge httpOptions
        this[property] = $dbC7k.util.merge(this[property], value);
        else this[property] = value;
    },
    /**
   * All of the keys with their default values.
   *
   * @constant
   * @api private
   */ keys: {
        credentials: null,
        credentialProvider: null,
        region: null,
        logger: null,
        apiVersions: {},
        apiVersion: null,
        endpoint: undefined,
        httpOptions: {
            timeout: 120000
        },
        maxRetries: undefined,
        maxRedirects: 10,
        paramValidation: true,
        sslEnabled: true,
        s3ForcePathStyle: false,
        s3BucketEndpoint: false,
        s3DisableBodySigning: true,
        computeChecksums: true,
        convertResponseTypes: true,
        correctClockSkew: false,
        customUserAgent: null,
        dynamoDbCrc32: true,
        systemClockOffset: 0,
        signatureVersion: null,
        signatureCache: true,
        retryDelayOptions: {},
        useAccelerateEndpoint: false,
        clientSideMonitoring: false,
        endpointDiscoveryEnabled: false,
        endpointCacheSize: 1000,
        hostPrefixEnabled: true
    },
    /**
   * Extracts accessKeyId, secretAccessKey and sessionToken
   * from a configuration hash.
   *
   * @api private
   */ extractCredentials: function extractCredentials(options) {
        if (options.accessKeyId && options.secretAccessKey) {
            options = $dbC7k.util.copy(options);
            options.credentials = new $dbC7k.Credentials(options);
        }
        return options;
    },
    /**
   * Sets the promise dependency the SDK will use wherever Promises are returned.
   * Passing `null` will force the SDK to use native Promises if they are available.
   * If native Promises are not available, passing `null` will have no effect.
   * @param [Constructor] dep A reference to a Promise constructor
   */ setPromisesDependency: function setPromisesDependency(dep) {
        $5e3718da5ab6b157$var$PromisesDependency = dep;
        // if null was passed in, we should try to use native promises
        if (dep === null && typeof Promise === "function") $5e3718da5ab6b157$var$PromisesDependency = Promise;
        var constructors = [
            $dbC7k.Request,
            $dbC7k.Credentials,
            $dbC7k.CredentialProviderChain
        ];
        if ($dbC7k.S3 && $dbC7k.S3.ManagedUpload) constructors.push($dbC7k.S3.ManagedUpload);
        $dbC7k.util.addPromises(constructors, $5e3718da5ab6b157$var$PromisesDependency);
    },
    /**
   * Gets the promise dependency set by `AWS.config.setPromisesDependency`.
   */ getPromisesDependency: function getPromisesDependency() {
        return $5e3718da5ab6b157$var$PromisesDependency;
    }
});
/**
 * @return [AWS.Config] The global configuration object singleton instance
 * @readonly
 * @see AWS.Config
 */ $dbC7k.config = new $dbC7k.Config();

});
parcelRequire.register("bph5V", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
/**
 * Represents your AWS security credentials, specifically the
 * {accessKeyId}, {secretAccessKey}, and optional {sessionToken}.
 * Creating a `Credentials` object allows you to pass around your
 * security information to configuration and service objects.
 *
 * Note that this class typically does not need to be constructed manually,
 * as the {AWS.Config} and {AWS.Service} classes both accept simple
 * options hashes with the three keys. These structures will be converted
 * into Credentials objects automatically.
 *
 * ## Expiring and Refreshing Credentials
 *
 * Occasionally credentials can expire in the middle of a long-running
 * application. In this case, the SDK will automatically attempt to
 * refresh the credentials from the storage location if the Credentials
 * class implements the {refresh} method.
 *
 * If you are implementing a credential storage location, you
 * will want to create a subclass of the `Credentials` class and
 * override the {refresh} method. This method allows credentials to be
 * retrieved from the backing store, be it a file system, database, or
 * some network storage. The method should reset the credential attributes
 * on the object.
 *
 * @!attribute expired
 *   @return [Boolean] whether the credentials have been expired and
 *     require a refresh. Used in conjunction with {expireTime}.
 * @!attribute expireTime
 *   @return [Date] a time when credentials should be considered expired. Used
 *     in conjunction with {expired}.
 * @!attribute accessKeyId
 *   @return [String] the AWS access key ID
 * @!attribute secretAccessKey
 *   @return [String] the AWS secret access key
 * @!attribute sessionToken
 *   @return [String] an optional AWS session token
 */ $dbC7k.Credentials = $dbC7k.util.inherit({
    /**
   * A credentials object can be created using positional arguments or an options
   * hash.
   *
   * @overload AWS.Credentials(accessKeyId, secretAccessKey, sessionToken=null)
   *   Creates a Credentials object with a given set of credential information
   *   as positional arguments.
   *   @param accessKeyId [String] the AWS access key ID
   *   @param secretAccessKey [String] the AWS secret access key
   *   @param sessionToken [String] the optional AWS session token
   *   @example Create a credentials object with AWS credentials
   *     var creds = new AWS.Credentials('akid', 'secret', 'session');
   * @overload AWS.Credentials(options)
   *   Creates a Credentials object with a given set of credential information
   *   as an options hash.
   *   @option options accessKeyId [String] the AWS access key ID
   *   @option options secretAccessKey [String] the AWS secret access key
   *   @option options sessionToken [String] the optional AWS session token
   *   @example Create a credentials object with AWS credentials
   *     var creds = new AWS.Credentials({
   *       accessKeyId: 'akid', secretAccessKey: 'secret', sessionToken: 'session'
   *     });
   */ constructor: function Credentials() {
        // hide secretAccessKey from being displayed with util.inspect
        $dbC7k.util.hideProperties(this, [
            "secretAccessKey"
        ]);
        this.expired = false;
        this.expireTime = null;
        this.refreshCallbacks = [];
        if (arguments.length === 1 && typeof arguments[0] === "object") {
            var creds = arguments[0].credentials || arguments[0];
            this.accessKeyId = creds.accessKeyId;
            this.secretAccessKey = creds.secretAccessKey;
            this.sessionToken = creds.sessionToken;
        } else {
            this.accessKeyId = arguments[0];
            this.secretAccessKey = arguments[1];
            this.sessionToken = arguments[2];
        }
    },
    /**
   * @return [Integer] the number of seconds before {expireTime} during which
   *   the credentials will be considered expired.
   */ expiryWindow: 15,
    /**
   * @return [Boolean] whether the credentials object should call {refresh}
   * @note Subclasses should override this method to provide custom refresh
   *   logic.
   */ needsRefresh: function needsRefresh() {
        var currentTime = $dbC7k.util.date.getDate().getTime();
        var adjustedTime = new Date(currentTime + this.expiryWindow * 1000);
        if (this.expireTime && adjustedTime > this.expireTime) return true;
        else return this.expired || !this.accessKeyId || !this.secretAccessKey;
    },
    /**
   * Gets the existing credentials, refreshing them if they are not yet loaded
   * or have expired. Users should call this method before using {refresh},
   * as this will not attempt to reload credentials when they are already
   * loaded into the object.
   *
   * @callback callback function(err)
   *   When this callback is called with no error, it means either credentials
   *   do not need to be refreshed or refreshed credentials information has
   *   been loaded into the object (as the `accessKeyId`, `secretAccessKey`,
   *   and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   */ get: function get(callback) {
        var self = this;
        if (this.needsRefresh()) this.refresh(function(err) {
            if (!err) self.expired = false; // reset expired flag
            if (callback) callback(err);
        });
        else if (callback) callback();
    },
    /**
   * @!method  getPromise()
   *   Returns a 'thenable' promise.
   *   Gets the existing credentials, refreshing them if they are not yet loaded
   *   or have expired. Users should call this method before using {refresh},
   *   as this will not attempt to reload credentials when they are already
   *   loaded into the object.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function()
   *     Called if the promise is fulfilled. When this callback is called, it
   *     means either credentials do not need to be refreshed or refreshed
   *     credentials information has been loaded into the object (as the
   *     `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
   *   @callback rejectedCallback function(err)
   *     Called if the promise is rejected.
   *     @param err [Error] if an error occurred, this value will be filled
   *   @return [Promise] A promise that represents the state of the `get` call.
   *   @example Calling the `getPromise` method.
   *     var promise = credProvider.getPromise();
   *     promise.then(function() { ... }, function(err) { ... });
   */ /**
   * @!method  refreshPromise()
   *   Returns a 'thenable' promise.
   *   Refreshes the credentials. Users should call {get} before attempting
   *   to forcibly refresh credentials.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function()
   *     Called if the promise is fulfilled. When this callback is called, it
   *     means refreshed credentials information has been loaded into the object
   *     (as the `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
   *   @callback rejectedCallback function(err)
   *     Called if the promise is rejected.
   *     @param err [Error] if an error occurred, this value will be filled
   *   @return [Promise] A promise that represents the state of the `refresh` call.
   *   @example Calling the `refreshPromise` method.
   *     var promise = credProvider.refreshPromise();
   *     promise.then(function() { ... }, function(err) { ... });
   */ /**
   * Refreshes the credentials. Users should call {get} before attempting
   * to forcibly refresh credentials.
   *
   * @callback callback function(err)
   *   When this callback is called with no error, it means refreshed
   *   credentials information has been loaded into the object (as the
   *   `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @note Subclasses should override this class to reset the
   *   {accessKeyId}, {secretAccessKey} and optional {sessionToken}
   *   on the credentials object and then call the callback with
   *   any error information.
   * @see get
   */ refresh: function refresh(callback) {
        this.expired = false;
        callback();
    },
    /**
   * @api private
   * @param callback
   */ coalesceRefresh: function coalesceRefresh(callback, sync) {
        var self = this;
        if (self.refreshCallbacks.push(callback) === 1) self.load(function onLoad(err) {
            $dbC7k.util.arrayEach(self.refreshCallbacks, function(callback) {
                if (sync) callback(err);
                else // callback could throw, so defer to ensure all callbacks are notified
                $dbC7k.util.defer(function() {
                    callback(err);
                });
            });
            self.refreshCallbacks.length = 0;
        });
    },
    /**
   * @api private
   * @param callback
   */ load: function load(callback) {
        callback();
    }
});
/**
 * @api private
 */ $dbC7k.Credentials.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
    this.prototype.getPromise = $dbC7k.util.promisifyMethod("get", PromiseDependency);
    this.prototype.refreshPromise = $dbC7k.util.promisifyMethod("refresh", PromiseDependency);
};
/**
 * @api private
 */ $dbC7k.Credentials.deletePromisesFromClass = function deletePromisesFromClass() {
    delete this.prototype.getPromise;
    delete this.prototype.refreshPromise;
};
$dbC7k.util.addPromises($dbC7k.Credentials);

});

parcelRequire.register("1KJHg", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
/**
 * Creates a credential provider chain that searches for AWS credentials
 * in a list of credential providers specified by the {providers} property.
 *
 * By default, the chain will use the {defaultProviders} to resolve credentials.
 * These providers will look in the environment using the
 * {AWS.EnvironmentCredentials} class with the 'AWS' and 'AMAZON' prefixes.
 *
 * ## Setting Providers
 *
 * Each provider in the {providers} list should be a function that returns
 * a {AWS.Credentials} object, or a hardcoded credentials object. The function
 * form allows for delayed execution of the credential construction.
 *
 * ## Resolving Credentials from a Chain
 *
 * Call {resolve} to return the first valid credential object that can be
 * loaded by the provider chain.
 *
 * For example, to resolve a chain with a custom provider that checks a file
 * on disk after the set of {defaultProviders}:
 *
 * ```javascript
 * var diskProvider = new AWS.FileSystemCredentials('./creds.json');
 * var chain = new AWS.CredentialProviderChain();
 * chain.providers.push(diskProvider);
 * chain.resolve();
 * ```
 *
 * The above code will return the `diskProvider` object if the
 * file contains credentials and the `defaultProviders` do not contain
 * any credential settings.
 *
 * @!attribute providers
 *   @return [Array<AWS.Credentials, Function>]
 *     a list of credentials objects or functions that return credentials
 *     objects. If the provider is a function, the function will be
 *     executed lazily when the provider needs to be checked for valid
 *     credentials. By default, this object will be set to the
 *     {defaultProviders}.
 *   @see defaultProviders
 */ $dbC7k.CredentialProviderChain = $dbC7k.util.inherit($dbC7k.Credentials, {
    /**
   * Creates a new CredentialProviderChain with a default set of providers
   * specified by {defaultProviders}.
   */ constructor: function CredentialProviderChain(providers) {
        if (providers) this.providers = providers;
        else this.providers = $dbC7k.CredentialProviderChain.defaultProviders.slice(0);
        this.resolveCallbacks = [];
    },
    /**
   * @!method  resolvePromise()
   *   Returns a 'thenable' promise.
   *   Resolves the provider chain by searching for the first set of
   *   credentials in {providers}.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function(credentials)
   *     Called if the promise is fulfilled and the provider resolves the chain
   *     to a credentials object
   *     @param credentials [AWS.Credentials] the credentials object resolved
   *       by the provider chain.
   *   @callback rejectedCallback function(error)
   *     Called if the promise is rejected.
   *     @param err [Error] the error object returned if no credentials are found.
   *   @return [Promise] A promise that represents the state of the `resolve` method call.
   *   @example Calling the `resolvePromise` method.
   *     var promise = chain.resolvePromise();
   *     promise.then(function(credentials) { ... }, function(err) { ... });
   */ /**
   * Resolves the provider chain by searching for the first set of
   * credentials in {providers}.
   *
   * @callback callback function(err, credentials)
   *   Called when the provider resolves the chain to a credentials object
   *   or null if no credentials can be found.
   *
   *   @param err [Error] the error object returned if no credentials are
   *     found.
   *   @param credentials [AWS.Credentials] the credentials object resolved
   *     by the provider chain.
   * @return [AWS.CredentialProviderChain] the provider, for chaining.
   */ resolve: function resolve(callback) {
        var self = this;
        if (self.providers.length === 0) {
            callback(new Error("No providers"));
            return self;
        }
        if (self.resolveCallbacks.push(callback) === 1) {
            var index = 0;
            var providers = self.providers.slice(0);
            function resolveNext(err, creds) {
                if (!err && creds || index === providers.length) {
                    $dbC7k.util.arrayEach(self.resolveCallbacks, function(callback) {
                        callback(err, creds);
                    });
                    self.resolveCallbacks.length = 0;
                    return;
                }
                var provider = providers[index++];
                if (typeof provider === "function") creds = provider.call();
                else creds = provider;
                if (creds.get) creds.get(function(getErr) {
                    resolveNext(getErr, getErr ? null : creds);
                });
                else resolveNext(null, creds);
            }
            resolveNext();
        }
        return self;
    }
});
/**
 * The default set of providers used by a vanilla CredentialProviderChain.
 *
 * In the browser:
 *
 * ```javascript
 * AWS.CredentialProviderChain.defaultProviders = []
 * ```
 *
 * In Node.js:
 *
 * ```javascript
 * AWS.CredentialProviderChain.defaultProviders = [
 *   function () { return new AWS.EnvironmentCredentials('AWS'); },
 *   function () { return new AWS.EnvironmentCredentials('AMAZON'); },
 *   function () { return new AWS.SharedIniFileCredentials(); },
 *   function () { return new AWS.ECSCredentials(); },
 *   function () { return new AWS.ProcessCredentials(); },
 *   function () { return new AWS.EC2MetadataCredentials() }
 * ]
 * ```
 */ $dbC7k.CredentialProviderChain.defaultProviders = [];
/**
 * @api private
 */ $dbC7k.CredentialProviderChain.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
    this.prototype.resolvePromise = $dbC7k.util.promisifyMethod("resolve", PromiseDependency);
};
/**
 * @api private
 */ $dbC7k.CredentialProviderChain.deletePromisesFromClass = function deletePromisesFromClass() {
    delete this.prototype.resolvePromise;
};
$dbC7k.util.addPromises($dbC7k.CredentialProviderChain);

});


parcelRequire.register("huvQa", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
var $cbbdefd7b55cbb12$var$inherit = $dbC7k.util.inherit;
/**
 * The endpoint that a service will talk to, for example,
 * `'https://ec2.ap-southeast-1.amazonaws.com'`. If
 * you need to override an endpoint for a service, you can
 * set the endpoint on a service by passing the endpoint
 * object with the `endpoint` option key:
 *
 * ```javascript
 * var ep = new AWS.Endpoint('awsproxy.example.com');
 * var s3 = new AWS.S3({endpoint: ep});
 * s3.service.endpoint.hostname == 'awsproxy.example.com'
 * ```
 *
 * Note that if you do not specify a protocol, the protocol will
 * be selected based on your current {AWS.config} configuration.
 *
 * @!attribute protocol
 *   @return [String] the protocol (http or https) of the endpoint
 *     URL
 * @!attribute hostname
 *   @return [String] the host portion of the endpoint, e.g.,
 *     example.com
 * @!attribute host
 *   @return [String] the host portion of the endpoint including
 *     the port, e.g., example.com:80
 * @!attribute port
 *   @return [Integer] the port of the endpoint
 * @!attribute href
 *   @return [String] the full URL of the endpoint
 */ $dbC7k.Endpoint = $cbbdefd7b55cbb12$var$inherit({
    /**
   * @overload Endpoint(endpoint)
   *   Constructs a new endpoint given an endpoint URL. If the
   *   URL omits a protocol (http or https), the default protocol
   *   set in the global {AWS.config} will be used.
   *   @param endpoint [String] the URL to construct an endpoint from
   */ constructor: function Endpoint(endpoint, config) {
        $dbC7k.util.hideProperties(this, [
            "slashes",
            "auth",
            "hash",
            "search",
            "query"
        ]);
        if (typeof endpoint === "undefined" || endpoint === null) throw new Error("Invalid endpoint: " + endpoint);
        else if (typeof endpoint !== "string") return $dbC7k.util.copy(endpoint);
        if (!endpoint.match(/^http/)) {
            var useSSL = config && config.sslEnabled !== undefined ? config.sslEnabled : $dbC7k.config.sslEnabled;
            endpoint = (useSSL ? "https" : "http") + "://" + endpoint;
        }
        $dbC7k.util.update(this, $dbC7k.util.urlParse(endpoint));
        // Ensure the port property is set as an integer
        if (this.port) this.port = parseInt(this.port, 10);
        else this.port = this.protocol === "https:" ? 443 : 80;
    }
});
/**
 * The low level HTTP request object, encapsulating all HTTP header
 * and body data sent by a service request.
 *
 * @!attribute method
 *   @return [String] the HTTP method of the request
 * @!attribute path
 *   @return [String] the path portion of the URI, e.g.,
 *     "/list/?start=5&num=10"
 * @!attribute headers
 *   @return [map<String,String>]
 *     a map of header keys and their respective values
 * @!attribute body
 *   @return [String] the request body payload
 * @!attribute endpoint
 *   @return [AWS.Endpoint] the endpoint for the request
 * @!attribute region
 *   @api private
 *   @return [String] the region, for signing purposes only.
 */ $dbC7k.HttpRequest = $cbbdefd7b55cbb12$var$inherit({
    /**
   * @api private
   */ constructor: function HttpRequest(endpoint, region) {
        endpoint = new $dbC7k.Endpoint(endpoint);
        this.method = "POST";
        this.path = endpoint.path || "/";
        this.headers = {};
        this.body = "";
        this.endpoint = endpoint;
        this.region = region;
        this._userAgent = "";
        this.setUserAgent();
    },
    /**
   * @api private
   */ setUserAgent: function setUserAgent() {
        this._userAgent = this.headers[this.getUserAgentHeaderName()] = $dbC7k.util.userAgent();
    },
    getUserAgentHeaderName: function getUserAgentHeaderName() {
        var prefix = $dbC7k.util.isBrowser() ? "X-Amz-" : "";
        return prefix + "User-Agent";
    },
    /**
   * @api private
   */ appendToUserAgent: function appendToUserAgent(agentPartial) {
        if (typeof agentPartial === "string" && agentPartial) this._userAgent += " " + agentPartial;
        this.headers[this.getUserAgentHeaderName()] = this._userAgent;
    },
    /**
   * @api private
   */ getUserAgent: function getUserAgent() {
        return this._userAgent;
    },
    /**
   * @return [String] the part of the {path} excluding the
   *   query string
   */ pathname: function pathname() {
        return this.path.split("?", 1)[0];
    },
    /**
   * @return [String] the query string portion of the {path}
   */ search: function search() {
        var query = this.path.split("?", 2)[1];
        if (query) {
            query = $dbC7k.util.queryStringParse(query);
            return $dbC7k.util.queryParamsToString(query);
        }
        return "";
    },
    /**
   * @api private
   * update httpRequest endpoint with endpoint string
   */ updateEndpoint: function updateEndpoint(endpointStr) {
        var newEndpoint = new $dbC7k.Endpoint(endpointStr);
        this.endpoint = newEndpoint;
        this.path = newEndpoint.path || "/";
    }
});
/**
 * The low level HTTP response object, encapsulating all HTTP header
 * and body data returned from the request.
 *
 * @!attribute statusCode
 *   @return [Integer] the HTTP status code of the response (e.g., 200, 404)
 * @!attribute headers
 *   @return [map<String,String>]
 *      a map of response header keys and their respective values
 * @!attribute body
 *   @return [String] the response body payload
 * @!attribute [r] streaming
 *   @return [Boolean] whether this response is being streamed at a low-level.
 *     Defaults to `false` (buffered reads). Do not modify this manually, use
 *     {createUnbufferedStream} to convert the stream to unbuffered mode
 *     instead.
 */ $dbC7k.HttpResponse = $cbbdefd7b55cbb12$var$inherit({
    /**
   * @api private
   */ constructor: function HttpResponse() {
        this.statusCode = undefined;
        this.headers = {};
        this.body = undefined;
        this.streaming = false;
        this.stream = null;
    },
    /**
   * Disables buffering on the HTTP response and returns the stream for reading.
   * @return [Stream, XMLHttpRequest, null] the underlying stream object.
   *   Use this object to directly read data off of the stream.
   * @note This object is only available after the {AWS.Request~httpHeaders}
   *   event has fired. This method must be called prior to
   *   {AWS.Request~httpData}.
   * @example Taking control of a stream
   *   request.on('httpHeaders', function(statusCode, headers) {
   *     if (statusCode < 300) {
   *       if (headers.etag === 'xyz') {
   *         // pipe the stream, disabling buffering
   *         var stream = this.response.httpResponse.createUnbufferedStream();
   *         stream.pipe(process.stdout);
   *       } else { // abort this request and set a better error message
   *         this.abort();
   *         this.response.error = new Error('Invalid ETag');
   *       }
   *     }
   *   }).send(console.log);
   */ createUnbufferedStream: function createUnbufferedStream() {
        this.streaming = true;
        return this.stream;
    }
});
$dbC7k.HttpClient = $cbbdefd7b55cbb12$var$inherit({});
/**
 * @api private
 */ $dbC7k.HttpClient.getInstance = function getInstance() {
    if (this.singleton === undefined) this.singleton = new this();
    return this.singleton;
};

});

parcelRequire.register("jlqYn", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");

var $gOH6p = parcelRequire("gOH6p");

var $43w6M = parcelRequire("43w6M");
var $e154e6bd6ec428c2$require$DISCOVER_ENDPOINT = $43w6M.discoverEndpoint;
/**
 * The namespace used to register global event listeners for request building
 * and sending.
 */ $dbC7k.EventListeners = {
    /**
   * @!attribute VALIDATE_CREDENTIALS
   *   A request listener that validates whether the request is being
   *   sent with credentials.
   *   Handles the {AWS.Request~validate 'validate' Request event}
   *   @example Sending a request without validating credentials
   *     var listener = AWS.EventListeners.Core.VALIDATE_CREDENTIALS;
   *     request.removeListener('validate', listener);
   *   @readonly
   *   @return [Function]
   * @!attribute VALIDATE_REGION
   *   A request listener that validates whether the region is set
   *   for a request.
   *   Handles the {AWS.Request~validate 'validate' Request event}
   *   @example Sending a request without validating region configuration
   *     var listener = AWS.EventListeners.Core.VALIDATE_REGION;
   *     request.removeListener('validate', listener);
   *   @readonly
   *   @return [Function]
   * @!attribute VALIDATE_PARAMETERS
   *   A request listener that validates input parameters in a request.
   *   Handles the {AWS.Request~validate 'validate' Request event}
   *   @example Sending a request without validating parameters
   *     var listener = AWS.EventListeners.Core.VALIDATE_PARAMETERS;
   *     request.removeListener('validate', listener);
   *   @example Disable parameter validation globally
   *     AWS.EventListeners.Core.removeListener('validate',
   *       AWS.EventListeners.Core.VALIDATE_REGION);
   *   @readonly
   *   @return [Function]
   * @!attribute SEND
   *   A request listener that initiates the HTTP connection for a
   *   request being sent. Handles the {AWS.Request~send 'send' Request event}
   *   @example Replacing the HTTP handler
   *     var listener = AWS.EventListeners.Core.SEND;
   *     request.removeListener('send', listener);
   *     request.on('send', function(response) {
   *       customHandler.send(response);
   *     });
   *   @return [Function]
   *   @readonly
   * @!attribute HTTP_DATA
   *   A request listener that reads data from the HTTP connection in order
   *   to build the response data.
   *   Handles the {AWS.Request~httpData 'httpData' Request event}.
   *   Remove this handler if you are overriding the 'httpData' event and
   *   do not want extra data processing and buffering overhead.
   *   @example Disabling default data processing
   *     var listener = AWS.EventListeners.Core.HTTP_DATA;
   *     request.removeListener('httpData', listener);
   *   @return [Function]
   *   @readonly
   */ Core: {} /* doc hack */ 
};
/**
 * @api private
 */ function $e154e6bd6ec428c2$var$getOperationAuthtype(req) {
    if (!req.service.api.operations) return "";
    var operation = req.service.api.operations[req.operation];
    return operation ? operation.authtype : "";
}






$dbC7k.EventListeners = {
    Core: new $gOH6p().addNamedListeners(function(add, addAsync) {
        addAsync("VALIDATE_CREDENTIALS", "validate", function VALIDATE_CREDENTIALS(req, done) {
            if (!req.service.api.signatureVersion) return done(); // none
            req.service.config.getCredentials(function(err) {
                if (err) req.response.error = $dbC7k.util.error(err, {
                    code: "CredentialsError",
                    message: "Missing credentials in config"
                });
                done();
            });
        });
        add("VALIDATE_REGION", "validate", function VALIDATE_REGION(req) {
            if (!req.service.config.region && !req.service.isGlobalEndpoint) req.response.error = $dbC7k.util.error(new Error(), {
                code: "ConfigError",
                message: "Missing region in config"
            });
        });
        add("BUILD_IDEMPOTENCY_TOKENS", "validate", function BUILD_IDEMPOTENCY_TOKENS(req) {
            if (!req.service.api.operations) return;
            var operation = req.service.api.operations[req.operation];
            if (!operation) return;
            var idempotentMembers = operation.idempotentMembers;
            if (!idempotentMembers.length) return;
            // creates a copy of params so user's param object isn't mutated
            var params = $dbC7k.util.copy(req.params);
            for(var i = 0, iLen = idempotentMembers.length; i < iLen; i++)if (!params[idempotentMembers[i]]) // add the member
            params[idempotentMembers[i]] = $dbC7k.util.uuid.v4();
            req.params = params;
        });
        add("VALIDATE_PARAMETERS", "validate", function VALIDATE_PARAMETERS(req) {
            if (!req.service.api.operations) return;
            var rules = req.service.api.operations[req.operation].input;
            var validation = req.service.config.paramValidation;
            new $dbC7k.ParamValidator(validation).validate(rules, req.params);
        });
        addAsync("COMPUTE_SHA256", "afterBuild", function COMPUTE_SHA256(req, done) {
            req.haltHandlersOnError();
            if (!req.service.api.operations) return;
            var operation = req.service.api.operations[req.operation];
            var authtype = operation ? operation.authtype : "";
            if (!req.service.api.signatureVersion && !authtype) return done(); // none
            if (req.service.getSignerClass(req) === $dbC7k.Signers.V4) {
                var body = req.httpRequest.body || "";
                if (authtype.indexOf("unsigned-body") >= 0) {
                    req.httpRequest.headers["X-Amz-Content-Sha256"] = "UNSIGNED-PAYLOAD";
                    return done();
                }
                $dbC7k.util.computeSha256(body, function(err, sha) {
                    if (err) done(err);
                    else {
                        req.httpRequest.headers["X-Amz-Content-Sha256"] = sha;
                        done();
                    }
                });
            } else done();
        });
        add("SET_CONTENT_LENGTH", "afterBuild", function SET_CONTENT_LENGTH(req) {
            var authtype = $e154e6bd6ec428c2$var$getOperationAuthtype(req);
            var payloadMember = $dbC7k.util.getRequestPayloadShape(req);
            if (req.httpRequest.headers["Content-Length"] === undefined) try {
                var length = $dbC7k.util.string.byteLength(req.httpRequest.body);
                req.httpRequest.headers["Content-Length"] = length;
            } catch (err) {
                if (payloadMember && payloadMember.isStreaming) {
                    if (payloadMember.requiresLength) //streaming payload requires length(s3, glacier)
                    throw err;
                    else if (authtype.indexOf("unsigned-body") >= 0) {
                        //unbounded streaming payload(lex, mediastore)
                        req.httpRequest.headers["Transfer-Encoding"] = "chunked";
                        return;
                    } else throw err;
                }
                throw err;
            }
        });
        add("SET_HTTP_HOST", "afterBuild", function SET_HTTP_HOST(req) {
            req.httpRequest.headers["Host"] = req.httpRequest.endpoint.host;
        });
        add("RESTART", "restart", function RESTART() {
            var err = this.response.error;
            if (!err || !err.retryable) return;
            this.httpRequest = new $dbC7k.HttpRequest(this.service.endpoint, this.service.region);
            if (this.response.retryCount < this.service.config.maxRetries) this.response.retryCount++;
            else this.response.error = null;
        });
        var addToHead = true;
        addAsync("DISCOVER_ENDPOINT", "sign", $e154e6bd6ec428c2$require$DISCOVER_ENDPOINT, addToHead);
        addAsync("SIGN", "sign", function SIGN(req, done) {
            var service = req.service;
            var operations = req.service.api.operations || {};
            var operation = operations[req.operation];
            var authtype = operation ? operation.authtype : "";
            if (!service.api.signatureVersion && !authtype) return done(); // none
            service.config.getCredentials(function(err, credentials) {
                if (err) {
                    req.response.error = err;
                    return done();
                }
                try {
                    var date = service.getSkewCorrectedDate();
                    var SignerClass = service.getSignerClass(req);
                    var signer = new SignerClass(req.httpRequest, service.api.signingName || service.api.endpointPrefix, {
                        signatureCache: service.config.signatureCache,
                        operation: operation,
                        signatureVersion: service.api.signatureVersion
                    });
                    signer.setServiceClientId(service._clientId);
                    // clear old authorization headers
                    delete req.httpRequest.headers["Authorization"];
                    delete req.httpRequest.headers["Date"];
                    delete req.httpRequest.headers["X-Amz-Date"];
                    // add new authorization
                    signer.addAuthorization(credentials, date);
                    req.signedAt = date;
                } catch (e) {
                    req.response.error = e;
                }
                done();
            });
        });
        add("VALIDATE_RESPONSE", "validateResponse", function VALIDATE_RESPONSE(resp) {
            if (this.service.successfulResponse(resp, this)) {
                resp.data = {};
                resp.error = null;
            } else {
                resp.data = null;
                resp.error = $dbC7k.util.error(new Error(), {
                    code: "UnknownError",
                    message: "An unknown error occurred."
                });
            }
        });
        addAsync("SEND", "send", function SEND(resp, done) {
            resp.httpResponse._abortCallback = done;
            resp.error = null;
            resp.data = null;
            function callback(httpResp) {
                resp.httpResponse.stream = httpResp;
                var stream = resp.request.httpRequest.stream;
                var service = resp.request.service;
                var api = service.api;
                var operationName = resp.request.operation;
                var operation = api.operations[operationName] || {};
                httpResp.on("headers", function onHeaders(statusCode, headers, statusMessage) {
                    resp.request.emit("httpHeaders", [
                        statusCode,
                        headers,
                        resp,
                        statusMessage
                    ]);
                    if (!resp.httpResponse.streaming) {
                        if ($dbC7k.HttpClient.streamsApiVersion === 2) {
                            // if we detect event streams, we're going to have to
                            // return the stream immediately
                            if (operation.hasEventOutput && service.successfulResponse(resp)) {
                                // skip reading the IncomingStream
                                resp.request.emit("httpDone");
                                done();
                                return;
                            }
                            httpResp.on("readable", function onReadable() {
                                var data = httpResp.read();
                                if (data !== null) resp.request.emit("httpData", [
                                    data,
                                    resp
                                ]);
                            });
                        } else httpResp.on("data", function onData(data) {
                            resp.request.emit("httpData", [
                                data,
                                resp
                            ]);
                        });
                    }
                });
                httpResp.on("end", function onEnd() {
                    if (!stream || !stream.didCallback) {
                        if ($dbC7k.HttpClient.streamsApiVersion === 2 && operation.hasEventOutput && service.successfulResponse(resp)) // don't concatenate response chunks when streaming event stream data when response is successful
                        return;
                        resp.request.emit("httpDone");
                        done();
                    }
                });
            }
            function progress(httpResp) {
                httpResp.on("sendProgress", function onSendProgress(value) {
                    resp.request.emit("httpUploadProgress", [
                        value,
                        resp
                    ]);
                });
                httpResp.on("receiveProgress", function onReceiveProgress(value) {
                    resp.request.emit("httpDownloadProgress", [
                        value,
                        resp
                    ]);
                });
            }
            function error(err) {
                if (err.code !== "RequestAbortedError") {
                    var errCode = err.code === "TimeoutError" ? err.code : "NetworkingError";
                    err = $dbC7k.util.error(err, {
                        code: errCode,
                        region: resp.request.httpRequest.region,
                        hostname: resp.request.httpRequest.endpoint.hostname,
                        retryable: true
                    });
                }
                resp.error = err;
                resp.request.emit("httpError", [
                    resp.error,
                    resp
                ], function() {
                    done();
                });
            }
            function executeSend() {
                var http = $dbC7k.HttpClient.getInstance();
                var httpOptions = resp.request.service.config.httpOptions || {};
                try {
                    var stream = http.handleRequest(resp.request.httpRequest, httpOptions, callback, error);
                    progress(stream);
                } catch (err) {
                    error(err);
                }
            }
            var timeDiff = (resp.request.service.getSkewCorrectedDate() - this.signedAt) / 1000;
            if (timeDiff >= 600) this.emit("sign", [
                this
            ], function(err) {
                if (err) done(err);
                else executeSend();
            });
            else executeSend();
        });
        add("HTTP_HEADERS", "httpHeaders", function HTTP_HEADERS(statusCode, headers, resp, statusMessage) {
            resp.httpResponse.statusCode = statusCode;
            resp.httpResponse.statusMessage = statusMessage;
            resp.httpResponse.headers = headers;
            resp.httpResponse.body = $dbC7k.util.buffer.toBuffer("");
            resp.httpResponse.buffers = [];
            resp.httpResponse.numBytes = 0;
            var dateHeader = headers.date || headers.Date;
            var service = resp.request.service;
            if (dateHeader) {
                var serverTime = Date.parse(dateHeader);
                if (service.config.correctClockSkew && service.isClockSkewed(serverTime)) service.applyClockOffset(serverTime);
            }
        });
        add("HTTP_DATA", "httpData", function HTTP_DATA(chunk, resp) {
            if (chunk) {
                if ($dbC7k.util.isNode()) {
                    resp.httpResponse.numBytes += chunk.length;
                    var total = resp.httpResponse.headers["content-length"];
                    var progress = {
                        loaded: resp.httpResponse.numBytes,
                        total: total
                    };
                    resp.request.emit("httpDownloadProgress", [
                        progress,
                        resp
                    ]);
                }
                resp.httpResponse.buffers.push($dbC7k.util.buffer.toBuffer(chunk));
            }
        });
        add("HTTP_DONE", "httpDone", function HTTP_DONE(resp) {
            // convert buffers array into single buffer
            if (resp.httpResponse.buffers && resp.httpResponse.buffers.length > 0) {
                var body = $dbC7k.util.buffer.concat(resp.httpResponse.buffers);
                resp.httpResponse.body = body;
            }
            delete resp.httpResponse.numBytes;
            delete resp.httpResponse.buffers;
        });
        add("FINALIZE_ERROR", "retry", function FINALIZE_ERROR(resp) {
            if (resp.httpResponse.statusCode) {
                resp.error.statusCode = resp.httpResponse.statusCode;
                if (resp.error.retryable === undefined) resp.error.retryable = this.service.retryableError(resp.error, this);
            }
        });
        add("INVALIDATE_CREDENTIALS", "retry", function INVALIDATE_CREDENTIALS(resp) {
            if (!resp.error) return;
            switch(resp.error.code){
                case "RequestExpired":
                case "ExpiredTokenException":
                case "ExpiredToken":
                    resp.error.retryable = true;
                    resp.request.service.config.credentials.expired = true;
            }
        });
        add("EXPIRED_SIGNATURE", "retry", function EXPIRED_SIGNATURE(resp) {
            var err = resp.error;
            if (!err) return;
            if (typeof err.code === "string" && typeof err.message === "string") {
                if (err.code.match(/Signature/) && err.message.match(/expired/)) resp.error.retryable = true;
            }
        });
        add("CLOCK_SKEWED", "retry", function CLOCK_SKEWED(resp) {
            if (!resp.error) return;
            if (this.service.clockSkewError(resp.error) && this.service.config.correctClockSkew) resp.error.retryable = true;
        });
        add("REDIRECT", "retry", function REDIRECT(resp) {
            if (resp.error && resp.error.statusCode >= 300 && resp.error.statusCode < 400 && resp.httpResponse.headers["location"]) {
                this.httpRequest.endpoint = new $dbC7k.Endpoint(resp.httpResponse.headers["location"]);
                this.httpRequest.headers["Host"] = this.httpRequest.endpoint.host;
                resp.error.redirect = true;
                resp.error.retryable = true;
            }
        });
        add("RETRY_CHECK", "retry", function RETRY_CHECK(resp) {
            if (resp.error) {
                if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) resp.error.retryDelay = 0;
                else if (resp.retryCount < resp.maxRetries) resp.error.retryDelay = this.service.retryDelays(resp.retryCount) || 0;
            }
        });
        addAsync("RESET_RETRY_STATE", "afterRetry", function RESET_RETRY_STATE(resp, done) {
            var delay, willRetry = false;
            if (resp.error) {
                delay = resp.error.retryDelay || 0;
                if (resp.error.retryable && resp.retryCount < resp.maxRetries) {
                    resp.retryCount++;
                    willRetry = true;
                } else if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
                    resp.redirectCount++;
                    willRetry = true;
                }
            }
            if (willRetry) {
                resp.error = null;
                setTimeout(done, delay);
            } else done();
        });
    }),
    CorePost: new $gOH6p().addNamedListeners(function(add) {
        add("EXTRACT_REQUEST_ID", "extractData", $dbC7k.util.extractRequestId);
        add("EXTRACT_REQUEST_ID", "extractError", $dbC7k.util.extractRequestId);
        add("ENOTFOUND_ERROR", "httpError", function ENOTFOUND_ERROR(err) {
            if (err.code === "NetworkingError" && err.errno === "ENOTFOUND") {
                var message = "Inaccessible host: `" + err.hostname + "'. This service may not be available in the `" + err.region + "' region.";
                this.response.error = $dbC7k.util.error(new Error(message), {
                    code: "UnknownEndpoint",
                    region: err.region,
                    hostname: err.hostname,
                    retryable: true,
                    originalError: err
                });
            }
        });
    }),
    Logger: new $gOH6p().addNamedListeners(function(add) {
        add("LOG_REQUEST", "complete", function LOG_REQUEST(resp) {
            var req = resp.request;
            var logger = req.service.config.logger;
            if (!logger) return;
            function filterSensitiveLog(inputShape, shape) {
                if (!shape) return shape;
                switch(inputShape.type){
                    case "structure":
                        var struct = {};
                        $dbC7k.util.each(shape, function(subShapeName, subShape) {
                            if (Object.prototype.hasOwnProperty.call(inputShape.members, subShapeName)) struct[subShapeName] = filterSensitiveLog(inputShape.members[subShapeName], subShape);
                            else struct[subShapeName] = subShape;
                        });
                        return struct;
                    case "list":
                        var list = [];
                        $dbC7k.util.arrayEach(shape, function(subShape, index) {
                            list.push(filterSensitiveLog(inputShape.member, subShape));
                        });
                        return list;
                    case "map":
                        var map = {};
                        $dbC7k.util.each(shape, function(key, value) {
                            map[key] = filterSensitiveLog(inputShape.value, value);
                        });
                        return map;
                    default:
                        if (inputShape.isSensitive) return "***SensitiveInformation***";
                        else return shape;
                }
            }
            function buildMessage() {
                var time = resp.request.service.getSkewCorrectedDate().getTime();
                var delta = (time - req.startTime.getTime()) / 1000;
                var ansi = logger.isTTY ? true : false;
                var status = resp.httpResponse.statusCode;
                var censoredParams = req.params;
                if (req.service.api.operations && req.service.api.operations[req.operation] && req.service.api.operations[req.operation].input) {
                    var inputShape = req.service.api.operations[req.operation].input;
                    censoredParams = filterSensitiveLog(inputShape, req.params);
                }
                var params = (parcelRequire("bDD92")).inspect(censoredParams, true, null);
                var message = "";
                if (ansi) message += "\x1b[33m";
                message += "[AWS " + req.service.serviceIdentifier + " " + status;
                message += " " + delta.toString() + "s " + resp.retryCount + " retries]";
                if (ansi) message += "\x1b[0;1m";
                message += " " + $dbC7k.util.string.lowerFirst(req.operation);
                message += "(" + params + ")";
                if (ansi) message += "\x1b[0m";
                return message;
            }
            var line = buildMessage();
            if (typeof logger.log === "function") logger.log(line);
            else if (typeof logger.write === "function") logger.write(line + "\n");
        });
    }),
    Json: new $gOH6p().addNamedListeners(function(add) {
        var svc = (parcelRequire("5cMk6"));
        add("BUILD", "build", svc.buildRequest);
        add("EXTRACT_DATA", "extractData", svc.extractData);
        add("EXTRACT_ERROR", "extractError", svc.extractError);
    }),
    Rest: new $gOH6p().addNamedListeners(function(add) {
        var svc = (parcelRequire("8x3DS"));
        add("BUILD", "build", svc.buildRequest);
        add("EXTRACT_DATA", "extractData", svc.extractData);
        add("EXTRACT_ERROR", "extractError", svc.extractError);
    }),
    RestJson: new $gOH6p().addNamedListeners(function(add) {
        var svc = (parcelRequire("9KxRK"));
        add("BUILD", "build", svc.buildRequest);
        add("EXTRACT_DATA", "extractData", svc.extractData);
        add("EXTRACT_ERROR", "extractError", svc.extractError);
    }),
    RestXml: new $gOH6p().addNamedListeners(function(add) {
        var svc = (parcelRequire("73Rhe"));
        add("BUILD", "build", svc.buildRequest);
        add("EXTRACT_DATA", "extractData", svc.extractData);
        add("EXTRACT_ERROR", "extractError", svc.extractError);
    }),
    Query: new $gOH6p().addNamedListeners(function(add) {
        var svc = (parcelRequire("gIynQ"));
        add("BUILD", "build", svc.buildRequest);
        add("EXTRACT_DATA", "extractData", svc.extractData);
        add("EXTRACT_ERROR", "extractError", svc.extractError);
    })
};

});
parcelRequire.register("43w6M", function(module, exports) {

var $e67mm = parcelRequire("e67mm");

var $dbC7k = parcelRequire("dbC7k");

var $5DMlf = parcelRequire("5DMlf");
var $2f40594881dae785$var$endpointDiscoveryEnabledEnvs = [
    "AWS_ENABLE_ENDPOINT_DISCOVERY",
    "AWS_ENDPOINT_DISCOVERY_ENABLED"
];
/**
 * Generate key (except resources and operation part) to index the endpoints in the cache
 * If input shape has endpointdiscoveryid trait then use
 *   accessKey + operation + resources + region + service as cache key
 * If input shape doesn't have endpointdiscoveryid trait then use
 *   accessKey + region + service as cache key
 * @return [map<String,String>] object with keys to index endpoints.
 * @api private
 */ function $2f40594881dae785$var$getCacheKey(request) {
    var service = request.service;
    var api = service.api || {};
    var operations = api.operations;
    var identifiers = {};
    if (service.config.region) identifiers.region = service.config.region;
    if (api.serviceId) identifiers.serviceId = api.serviceId;
    if (service.config.credentials.accessKeyId) identifiers.accessKeyId = service.config.credentials.accessKeyId;
    return identifiers;
}
/**
 * Recursive helper for marshallCustomIdentifiers().
 * Looks for required string input members that have 'endpointdiscoveryid' trait.
 * @api private
 */ function $2f40594881dae785$var$marshallCustomIdentifiersHelper(result, params, shape) {
    if (!shape || params === undefined || params === null) return;
    if (shape.type === "structure" && shape.required && shape.required.length > 0) $5DMlf.arrayEach(shape.required, function(name) {
        var memberShape = shape.members[name];
        if (memberShape.endpointDiscoveryId === true) {
            var locationName = memberShape.isLocationName ? memberShape.name : name;
            result[locationName] = String(params[name]);
        } else $2f40594881dae785$var$marshallCustomIdentifiersHelper(result, params[name], memberShape);
    });
}
/**
 * Get custom identifiers for cache key.
 * Identifies custom identifiers by checking each shape's `endpointDiscoveryId` trait.
 * @param [object] request object
 * @param [object] input shape of the given operation's api
 * @api private
 */ function $2f40594881dae785$var$marshallCustomIdentifiers(request, shape) {
    var identifiers = {};
    $2f40594881dae785$var$marshallCustomIdentifiersHelper(identifiers, request.params, shape);
    return identifiers;
}
/**
 * Call endpoint discovery operation when it's optional.
 * When endpoint is available in cache then use the cached endpoints. If endpoints
 * are unavailable then use regional endpoints and call endpoint discovery operation
 * asynchronously. This is turned off by default.
 * @param [object] request object
 * @api private
 */ function $2f40594881dae785$var$optionalDiscoverEndpoint(request) {
    var service = request.service;
    var api = service.api;
    var operationModel = api.operations ? api.operations[request.operation] : undefined;
    var inputShape = operationModel ? operationModel.input : undefined;
    var identifiers = $2f40594881dae785$var$marshallCustomIdentifiers(request, inputShape);
    var cacheKey = $2f40594881dae785$var$getCacheKey(request);
    if (Object.keys(identifiers).length > 0) {
        cacheKey = $5DMlf.update(cacheKey, identifiers);
        if (operationModel) cacheKey.operation = operationModel.name;
    }
    var endpoints = $dbC7k.endpointCache.get(cacheKey);
    if (endpoints && endpoints.length === 1 && endpoints[0].Address === "") //endpoint operation is being made but response not yet received
    //or endpoint operation just failed in 1 minute
    return;
    else if (endpoints && endpoints.length > 0) //found endpoint record from cache
    request.httpRequest.updateEndpoint(endpoints[0].Address);
    else {
        //endpoint record not in cache or outdated. make discovery operation
        var endpointRequest = service.makeRequest(api.endpointOperation, {
            Operation: operationModel.name,
            Identifiers: identifiers
        });
        $2f40594881dae785$var$addApiVersionHeader(endpointRequest);
        endpointRequest.removeListener("validate", $dbC7k.EventListeners.Core.VALIDATE_PARAMETERS);
        endpointRequest.removeListener("retry", $dbC7k.EventListeners.Core.RETRY_CHECK);
        //put in a placeholder for endpoints already requested, prevent
        //too much in-flight calls
        $dbC7k.endpointCache.put(cacheKey, [
            {
                Address: "",
                CachePeriodInMinutes: 1
            }
        ]);
        endpointRequest.send(function(err, data) {
            if (data && data.Endpoints) $dbC7k.endpointCache.put(cacheKey, data.Endpoints);
            else if (err) $dbC7k.endpointCache.put(cacheKey, [
                {
                    Address: "",
                    CachePeriodInMinutes: 1 //not to make more endpoint operation in next 1 minute
                }
            ]);
        });
    }
}
var $2f40594881dae785$var$requestQueue = {};
/**
 * Call endpoint discovery operation when it's required.
 * When endpoint is available in cache then use cached ones. If endpoints are
 * unavailable then SDK should call endpoint operation then use returned new
 * endpoint for the api call. SDK will automatically attempt to do endpoint
 * discovery. This is turned off by default
 * @param [object] request object
 * @api private
 */ function $2f40594881dae785$var$requiredDiscoverEndpoint(request, done) {
    var service = request.service;
    var api = service.api;
    var operationModel = api.operations ? api.operations[request.operation] : undefined;
    var inputShape = operationModel ? operationModel.input : undefined;
    var identifiers = $2f40594881dae785$var$marshallCustomIdentifiers(request, inputShape);
    var cacheKey = $2f40594881dae785$var$getCacheKey(request);
    if (Object.keys(identifiers).length > 0) {
        cacheKey = $5DMlf.update(cacheKey, identifiers);
        if (operationModel) cacheKey.operation = operationModel.name;
    }
    var cacheKeyStr = $dbC7k.EndpointCache.getKeyString(cacheKey);
    var endpoints = $dbC7k.endpointCache.get(cacheKeyStr); //endpoint cache also accepts string keys
    if (endpoints && endpoints.length === 1 && endpoints[0].Address === "") {
        //endpoint operation is being made but response not yet received
        //push request object to a pending queue
        if (!$2f40594881dae785$var$requestQueue[cacheKeyStr]) $2f40594881dae785$var$requestQueue[cacheKeyStr] = [];
        $2f40594881dae785$var$requestQueue[cacheKeyStr].push({
            request: request,
            callback: done
        });
        return;
    } else if (endpoints && endpoints.length > 0) {
        request.httpRequest.updateEndpoint(endpoints[0].Address);
        done();
    } else {
        var endpointRequest = service.makeRequest(api.endpointOperation, {
            Operation: operationModel.name,
            Identifiers: identifiers
        });
        endpointRequest.removeListener("validate", $dbC7k.EventListeners.Core.VALIDATE_PARAMETERS);
        $2f40594881dae785$var$addApiVersionHeader(endpointRequest);
        //put in a placeholder for endpoints already requested, prevent
        //too much in-flight calls
        $dbC7k.endpointCache.put(cacheKeyStr, [
            {
                Address: "",
                CachePeriodInMinutes: 60 //long-live cache
            }
        ]);
        endpointRequest.send(function(err, data) {
            if (err) {
                var errorParams = {
                    code: "EndpointDiscoveryException",
                    message: "Request cannot be fulfilled without specifying an endpoint",
                    retryable: false
                };
                request.response.error = $5DMlf.error(err, errorParams);
                $dbC7k.endpointCache.remove(cacheKey);
                //fail all the pending requests in batch
                if ($2f40594881dae785$var$requestQueue[cacheKeyStr]) {
                    var pendingRequests = $2f40594881dae785$var$requestQueue[cacheKeyStr];
                    $5DMlf.arrayEach(pendingRequests, function(requestContext) {
                        requestContext.request.response.error = $5DMlf.error(err, errorParams);
                        requestContext.callback();
                    });
                    delete $2f40594881dae785$var$requestQueue[cacheKeyStr];
                }
            } else if (data) {
                $dbC7k.endpointCache.put(cacheKeyStr, data.Endpoints);
                request.httpRequest.updateEndpoint(data.Endpoints[0].Address);
                //update the endpoint for all the pending requests in batch
                if ($2f40594881dae785$var$requestQueue[cacheKeyStr]) {
                    var pendingRequests = $2f40594881dae785$var$requestQueue[cacheKeyStr];
                    $5DMlf.arrayEach(pendingRequests, function(requestContext) {
                        requestContext.request.httpRequest.updateEndpoint(data.Endpoints[0].Address);
                        requestContext.callback();
                    });
                    delete $2f40594881dae785$var$requestQueue[cacheKeyStr];
                }
            }
            done();
        });
    }
}
/**
 * add api version header to endpoint operation
 * @api private
 */ function $2f40594881dae785$var$addApiVersionHeader(endpointRequest) {
    var api = endpointRequest.service.api;
    var apiVersion = api.apiVersion;
    if (apiVersion && !endpointRequest.httpRequest.headers["x-amz-api-version"]) endpointRequest.httpRequest.headers["x-amz-api-version"] = apiVersion;
}
/**
 * If api call gets invalid endpoint exception, SDK should attempt to remove the invalid
 * endpoint from cache.
 * @api private
 */ function $2f40594881dae785$var$invalidateCachedEndpoints(response) {
    var error = response.error;
    var httpResponse = response.httpResponse;
    if (error && (error.code === "InvalidEndpointException" || httpResponse.statusCode === 421)) {
        var request = response.request;
        var operations = request.service.api.operations || {};
        var inputShape = operations[request.operation] ? operations[request.operation].input : undefined;
        var identifiers = $2f40594881dae785$var$marshallCustomIdentifiers(request, inputShape);
        var cacheKey = $2f40594881dae785$var$getCacheKey(request);
        if (Object.keys(identifiers).length > 0) {
            cacheKey = $5DMlf.update(cacheKey, identifiers);
            if (operations[request.operation]) cacheKey.operation = operations[request.operation].name;
        }
        $dbC7k.endpointCache.remove(cacheKey);
    }
}
/**
 * If endpoint is explicitly configured, SDK should not do endpoint discovery in anytime.
 * @param [object] client Service client object.
 * @api private
 */ function $2f40594881dae785$var$hasCustomEndpoint(client) {
    //if set endpoint is set for specific client, enable endpoint discovery will raise an error.
    if (client._originalConfig && client._originalConfig.endpoint && client._originalConfig.endpointDiscoveryEnabled === true) throw $5DMlf.error(new Error(), {
        code: "ConfigurationException",
        message: "Custom endpoint is supplied; endpointDiscoveryEnabled must not be true."
    });
    var svcConfig = $dbC7k.config[client.serviceIdentifier] || {};
    return Boolean($dbC7k.config.endpoint || svcConfig.endpoint || client._originalConfig && client._originalConfig.endpoint);
}
/**
 * @api private
 */ function $2f40594881dae785$var$isFalsy(value) {
    return [
        "false",
        "0"
    ].indexOf(value) >= 0;
}
/**
 * If endpoint discovery should perform for this request when endpoint discovery is optional.
 * SDK performs config resolution in order like below:
 * 1. If turned on client configuration(default to off) then turn on endpoint discovery.
 * 2. If turned on in env AWS_ENABLE_ENDPOINT_DISCOVERY then turn on endpoint discovery.
 * 3. If turned on in shared ini config file with key 'endpoint_discovery_enabled', then
 *   turn on endpoint discovery.
 * @param [object] request request object.
 * @api private
 */ function $2f40594881dae785$var$isEndpointDiscoveryApplicable(request) {
    var service = request.service || {};
    if (service.config.endpointDiscoveryEnabled === true) return true;
    //shared ini file is only available in Node
    //not to check env in browser
    if ($5DMlf.isBrowser()) return false;
    for(var i = 0; i < $2f40594881dae785$var$endpointDiscoveryEnabledEnvs.length; i++){
        var env = $2f40594881dae785$var$endpointDiscoveryEnabledEnvs[i];
        if (Object.prototype.hasOwnProperty.call($e67mm.env, env)) {
            if ($e67mm.env[env] === "" || $e67mm.env[env] === undefined) throw $5DMlf.error(new Error(), {
                code: "ConfigurationException",
                message: "environmental variable " + env + " cannot be set to nothing"
            });
            if (!$2f40594881dae785$var$isFalsy($e67mm.env[env])) return true;
        }
    }
    var configFile = {};
    try {
        configFile = $dbC7k.util.iniLoader ? $dbC7k.util.iniLoader.loadFrom({
            isConfig: true,
            filename: $e67mm.env[$dbC7k.util.sharedConfigFileEnv]
        }) : {};
    } catch (e) {}
    var sharedFileConfig = configFile[0, $dbC7k.util.defaultProfile] || {};
    if (Object.prototype.hasOwnProperty.call(sharedFileConfig, "endpoint_discovery_enabled")) {
        if (sharedFileConfig.endpoint_discovery_enabled === undefined) throw $5DMlf.error(new Error(), {
            code: "ConfigurationException",
            message: "config file entry 'endpoint_discovery_enabled' cannot be set to nothing"
        });
        if (!$2f40594881dae785$var$isFalsy(sharedFileConfig.endpoint_discovery_enabled)) return true;
    }
    return false;
}
/**
 * attach endpoint discovery logic to request object
 * @param [object] request
 * @api private
 */ function $2f40594881dae785$var$discoverEndpoint(request, done) {
    var service = request.service || {};
    if ($2f40594881dae785$var$hasCustomEndpoint(service) || request.isPresigned()) return done();
    if (!$2f40594881dae785$var$isEndpointDiscoveryApplicable(request)) return done();
    request.httpRequest.appendToUserAgent("endpoint-discovery");
    var operations = service.api.operations || {};
    var operationModel = operations[request.operation];
    var isEndpointDiscoveryRequired = operationModel ? operationModel.endpointDiscoveryRequired : "NULL";
    switch(isEndpointDiscoveryRequired){
        case "OPTIONAL":
            $2f40594881dae785$var$optionalDiscoverEndpoint(request);
            request.addNamedListener("INVALIDATE_CACHED_ENDPOINTS", "extractError", $2f40594881dae785$var$invalidateCachedEndpoints);
            done();
            break;
        case "REQUIRED":
            request.addNamedListener("INVALIDATE_CACHED_ENDPOINTS", "extractError", $2f40594881dae785$var$invalidateCachedEndpoints);
            $2f40594881dae785$var$requiredDiscoverEndpoint(request, done);
            break;
        case "NULL":
        default:
            done();
            break;
    }
}
module.exports = {
    discoverEndpoint: $2f40594881dae785$var$discoverEndpoint,
    requiredDiscoverEndpoint: $2f40594881dae785$var$requiredDiscoverEndpoint,
    optionalDiscoverEndpoint: $2f40594881dae785$var$optionalDiscoverEndpoint,
    marshallCustomIdentifiers: $2f40594881dae785$var$marshallCustomIdentifiers,
    getCacheKey: $2f40594881dae785$var$getCacheKey,
    invalidateCachedEndpoint: $2f40594881dae785$var$invalidateCachedEndpoints
};

});

parcelRequire.register("bDD92", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $e67mm = parcelRequire("e67mm");
var $8791b39247018c0a$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $8791b39247018c0a$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$8791b39247018c0a$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($8791b39247018c0a$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($8791b39247018c0a$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($8791b39247018c0a$var$isNull(x) || !$8791b39247018c0a$var$isObject(x)) str += " " + x;
    else str += " " + $8791b39247018c0a$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $e67mm !== "undefined" && $e67mm.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $e67mm === "undefined") return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($e67mm.throwDeprecation) throw new Error(msg);
            else if ($e67mm.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $8791b39247018c0a$var$debugs = {};
var $8791b39247018c0a$var$debugEnvRegex = /^$/;
var $8791b39247018c0a$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$8791b39247018c0a$var$debugs[set]) {
        if ($8791b39247018c0a$var$debugEnvRegex.test(set)) {
            var pid = $e67mm.pid;
            $8791b39247018c0a$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $8791b39247018c0a$var$debugs[set] = function() {};
    }
    return $8791b39247018c0a$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $8791b39247018c0a$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $8791b39247018c0a$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($8791b39247018c0a$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($8791b39247018c0a$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($8791b39247018c0a$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($8791b39247018c0a$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($8791b39247018c0a$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $8791b39247018c0a$var$stylizeWithColor;
    return $8791b39247018c0a$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $8791b39247018c0a$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$8791b39247018c0a$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$8791b39247018c0a$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $8791b39247018c0a$var$stylizeWithColor(str, styleType) {
    var style = $8791b39247018c0a$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $8791b39247018c0a$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $8791b39247018c0a$var$inspect.colors[style][1] + "m";
    else return str;
}
function $8791b39247018c0a$var$stylizeNoColor(str, styleType) {
    return str;
}
function $8791b39247018c0a$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $8791b39247018c0a$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $8791b39247018c0a$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$8791b39247018c0a$var$isString(ret)) ret = $8791b39247018c0a$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $8791b39247018c0a$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $8791b39247018c0a$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($8791b39247018c0a$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $8791b39247018c0a$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($8791b39247018c0a$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($8791b39247018c0a$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($8791b39247018c0a$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($8791b39247018c0a$var$isError(value)) return $8791b39247018c0a$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($8791b39247018c0a$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($8791b39247018c0a$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($8791b39247018c0a$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($8791b39247018c0a$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($8791b39247018c0a$var$isError(value)) base = " " + $8791b39247018c0a$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($8791b39247018c0a$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $8791b39247018c0a$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $8791b39247018c0a$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $8791b39247018c0a$var$reduceToSingleString(output, base, braces);
}
function $8791b39247018c0a$var$formatPrimitive(ctx, value) {
    if ($8791b39247018c0a$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($8791b39247018c0a$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($8791b39247018c0a$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($8791b39247018c0a$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($8791b39247018c0a$var$isNull(value)) return ctx.stylize("null", "null");
}
function $8791b39247018c0a$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $8791b39247018c0a$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($8791b39247018c0a$var$hasOwnProperty(value, String(i))) output.push($8791b39247018c0a$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($8791b39247018c0a$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $8791b39247018c0a$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$8791b39247018c0a$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($8791b39247018c0a$var$isNull(recurseTimes)) str = $8791b39247018c0a$var$formatValue(ctx, desc.value, null);
            else str = $8791b39247018c0a$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($8791b39247018c0a$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $8791b39247018c0a$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("1OuGe"));
function $8791b39247018c0a$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $8791b39247018c0a$var$isArray;
function $8791b39247018c0a$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
module.exports.isBoolean = $8791b39247018c0a$var$isBoolean;
function $8791b39247018c0a$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $8791b39247018c0a$var$isNull;
function $8791b39247018c0a$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $8791b39247018c0a$var$isNullOrUndefined;
function $8791b39247018c0a$var$isNumber(arg) {
    return typeof arg === "number";
}
module.exports.isNumber = $8791b39247018c0a$var$isNumber;
function $8791b39247018c0a$var$isString(arg) {
    return typeof arg === "string";
}
module.exports.isString = $8791b39247018c0a$var$isString;
function $8791b39247018c0a$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
module.exports.isSymbol = $8791b39247018c0a$var$isSymbol;
function $8791b39247018c0a$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $8791b39247018c0a$var$isUndefined;
function $8791b39247018c0a$var$isRegExp(re) {
    return $8791b39247018c0a$var$isObject(re) && $8791b39247018c0a$var$objectToString(re) === "[object RegExp]";
}
module.exports.isRegExp = $8791b39247018c0a$var$isRegExp;
module.exports.types.isRegExp = $8791b39247018c0a$var$isRegExp;
function $8791b39247018c0a$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
module.exports.isObject = $8791b39247018c0a$var$isObject;
function $8791b39247018c0a$var$isDate(d) {
    return $8791b39247018c0a$var$isObject(d) && $8791b39247018c0a$var$objectToString(d) === "[object Date]";
}
module.exports.isDate = $8791b39247018c0a$var$isDate;
module.exports.types.isDate = $8791b39247018c0a$var$isDate;
function $8791b39247018c0a$var$isError(e) {
    return $8791b39247018c0a$var$isObject(e) && ($8791b39247018c0a$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
module.exports.isError = $8791b39247018c0a$var$isError;
module.exports.types.isNativeError = $8791b39247018c0a$var$isError;
function $8791b39247018c0a$var$isFunction(arg) {
    return typeof arg === "function";
}
module.exports.isFunction = $8791b39247018c0a$var$isFunction;
function $8791b39247018c0a$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
module.exports.isPrimitive = $8791b39247018c0a$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("9XS2N"));
function $8791b39247018c0a$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $8791b39247018c0a$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $8791b39247018c0a$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $8791b39247018c0a$var$timestamp() {
    var d = new Date();
    var time = [
        $8791b39247018c0a$var$pad(d.getHours()),
        $8791b39247018c0a$var$pad(d.getMinutes()),
        $8791b39247018c0a$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $8791b39247018c0a$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log("%s - %s", $8791b39247018c0a$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("8VpWl"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$8791b39247018c0a$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $8791b39247018c0a$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $8791b39247018c0a$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($8791b39247018c0a$var$kCustomPromisifiedSymbol && original[$8791b39247018c0a$var$kCustomPromisifiedSymbol]) {
        var fn = original[$8791b39247018c0a$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $8791b39247018c0a$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($8791b39247018c0a$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $8791b39247018c0a$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $8791b39247018c0a$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $8791b39247018c0a$var$kCustomPromisifiedSymbol;
function $8791b39247018c0a$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $8791b39247018c0a$var$callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $e67mm.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $e67mm.nextTick($8791b39247018c0a$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $8791b39247018c0a$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $8791b39247018c0a$var$callbackify;

});
parcelRequire.register("1OuGe", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $1gbcx = parcelRequire("1gbcx");

var $gl7IX = parcelRequire("gl7IX");

var $jCBKx = parcelRequire("jCBKx");

var $aSsgt = parcelRequire("aSsgt");
function $15224262cb721c43$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $15224262cb721c43$var$BigIntSupported = typeof BigInt !== "undefined";
var $15224262cb721c43$var$SymbolSupported = typeof Symbol !== "undefined";
var $15224262cb721c43$var$ObjectToString = $15224262cb721c43$var$uncurryThis(Object.prototype.toString);
var $15224262cb721c43$var$numberValue = $15224262cb721c43$var$uncurryThis(Number.prototype.valueOf);
var $15224262cb721c43$var$stringValue = $15224262cb721c43$var$uncurryThis(String.prototype.valueOf);
var $15224262cb721c43$var$booleanValue = $15224262cb721c43$var$uncurryThis(Boolean.prototype.valueOf);
if ($15224262cb721c43$var$BigIntSupported) var $15224262cb721c43$var$bigIntValue = $15224262cb721c43$var$uncurryThis(BigInt.prototype.valueOf);
if ($15224262cb721c43$var$SymbolSupported) var $15224262cb721c43$var$symbolValue = $15224262cb721c43$var$uncurryThis(Symbol.prototype.valueOf);
function $15224262cb721c43$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $1gbcx;
module.exports.isGeneratorFunction = $gl7IX;
module.exports.isTypedArray = $aSsgt;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $15224262cb721c43$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $15224262cb721c43$var$isPromise;
function $15224262cb721c43$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $aSsgt(value) || $15224262cb721c43$var$isDataView(value);
}
module.exports.isArrayBufferView = $15224262cb721c43$var$isArrayBufferView;
function $15224262cb721c43$var$isUint8Array(value) {
    return $jCBKx(value) === "Uint8Array";
}
module.exports.isUint8Array = $15224262cb721c43$var$isUint8Array;
function $15224262cb721c43$var$isUint8ClampedArray(value) {
    return $jCBKx(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $15224262cb721c43$var$isUint8ClampedArray;
function $15224262cb721c43$var$isUint16Array(value) {
    return $jCBKx(value) === "Uint16Array";
}
module.exports.isUint16Array = $15224262cb721c43$var$isUint16Array;
function $15224262cb721c43$var$isUint32Array(value) {
    return $jCBKx(value) === "Uint32Array";
}
module.exports.isUint32Array = $15224262cb721c43$var$isUint32Array;
function $15224262cb721c43$var$isInt8Array(value) {
    return $jCBKx(value) === "Int8Array";
}
module.exports.isInt8Array = $15224262cb721c43$var$isInt8Array;
function $15224262cb721c43$var$isInt16Array(value) {
    return $jCBKx(value) === "Int16Array";
}
module.exports.isInt16Array = $15224262cb721c43$var$isInt16Array;
function $15224262cb721c43$var$isInt32Array(value) {
    return $jCBKx(value) === "Int32Array";
}
module.exports.isInt32Array = $15224262cb721c43$var$isInt32Array;
function $15224262cb721c43$var$isFloat32Array(value) {
    return $jCBKx(value) === "Float32Array";
}
module.exports.isFloat32Array = $15224262cb721c43$var$isFloat32Array;
function $15224262cb721c43$var$isFloat64Array(value) {
    return $jCBKx(value) === "Float64Array";
}
module.exports.isFloat64Array = $15224262cb721c43$var$isFloat64Array;
function $15224262cb721c43$var$isBigInt64Array(value) {
    return $jCBKx(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $15224262cb721c43$var$isBigInt64Array;
function $15224262cb721c43$var$isBigUint64Array(value) {
    return $jCBKx(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $15224262cb721c43$var$isBigUint64Array;
function $15224262cb721c43$var$isMapToString(value) {
    return $15224262cb721c43$var$ObjectToString(value) === "[object Map]";
}
$15224262cb721c43$var$isMapToString.working = typeof Map !== "undefined" && $15224262cb721c43$var$isMapToString(new Map());
function $15224262cb721c43$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $15224262cb721c43$var$isMapToString.working ? $15224262cb721c43$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $15224262cb721c43$var$isMap;
function $15224262cb721c43$var$isSetToString(value) {
    return $15224262cb721c43$var$ObjectToString(value) === "[object Set]";
}
$15224262cb721c43$var$isSetToString.working = typeof Set !== "undefined" && $15224262cb721c43$var$isSetToString(new Set());
function $15224262cb721c43$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $15224262cb721c43$var$isSetToString.working ? $15224262cb721c43$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $15224262cb721c43$var$isSet;
function $15224262cb721c43$var$isWeakMapToString(value) {
    return $15224262cb721c43$var$ObjectToString(value) === "[object WeakMap]";
}
$15224262cb721c43$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $15224262cb721c43$var$isWeakMapToString(new WeakMap());
function $15224262cb721c43$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $15224262cb721c43$var$isWeakMapToString.working ? $15224262cb721c43$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $15224262cb721c43$var$isWeakMap;
function $15224262cb721c43$var$isWeakSetToString(value) {
    return $15224262cb721c43$var$ObjectToString(value) === "[object WeakSet]";
}
$15224262cb721c43$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $15224262cb721c43$var$isWeakSetToString(new WeakSet());
function $15224262cb721c43$var$isWeakSet(value) {
    return $15224262cb721c43$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $15224262cb721c43$var$isWeakSet;
function $15224262cb721c43$var$isArrayBufferToString(value) {
    return $15224262cb721c43$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$15224262cb721c43$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $15224262cb721c43$var$isArrayBufferToString(new ArrayBuffer());
function $15224262cb721c43$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $15224262cb721c43$var$isArrayBufferToString.working ? $15224262cb721c43$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $15224262cb721c43$var$isArrayBuffer;
function $15224262cb721c43$var$isDataViewToString(value) {
    return $15224262cb721c43$var$ObjectToString(value) === "[object DataView]";
}
$15224262cb721c43$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $15224262cb721c43$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $15224262cb721c43$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $15224262cb721c43$var$isDataViewToString.working ? $15224262cb721c43$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $15224262cb721c43$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $15224262cb721c43$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $15224262cb721c43$var$isSharedArrayBufferToString(value) {
    return $15224262cb721c43$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $15224262cb721c43$var$isSharedArrayBuffer(value) {
    if (typeof $15224262cb721c43$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $15224262cb721c43$var$isSharedArrayBufferToString.working === "undefined") $15224262cb721c43$var$isSharedArrayBufferToString.working = $15224262cb721c43$var$isSharedArrayBufferToString(new $15224262cb721c43$var$SharedArrayBufferCopy());
    return $15224262cb721c43$var$isSharedArrayBufferToString.working ? $15224262cb721c43$var$isSharedArrayBufferToString(value) : value instanceof $15224262cb721c43$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $15224262cb721c43$var$isSharedArrayBuffer;
function $15224262cb721c43$var$isAsyncFunction(value) {
    return $15224262cb721c43$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $15224262cb721c43$var$isAsyncFunction;
function $15224262cb721c43$var$isMapIterator(value) {
    return $15224262cb721c43$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $15224262cb721c43$var$isMapIterator;
function $15224262cb721c43$var$isSetIterator(value) {
    return $15224262cb721c43$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $15224262cb721c43$var$isSetIterator;
function $15224262cb721c43$var$isGeneratorObject(value) {
    return $15224262cb721c43$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $15224262cb721c43$var$isGeneratorObject;
function $15224262cb721c43$var$isWebAssemblyCompiledModule(value) {
    return $15224262cb721c43$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $15224262cb721c43$var$isWebAssemblyCompiledModule;
function $15224262cb721c43$var$isNumberObject(value) {
    return $15224262cb721c43$var$checkBoxedPrimitive(value, $15224262cb721c43$var$numberValue);
}
module.exports.isNumberObject = $15224262cb721c43$var$isNumberObject;
function $15224262cb721c43$var$isStringObject(value) {
    return $15224262cb721c43$var$checkBoxedPrimitive(value, $15224262cb721c43$var$stringValue);
}
module.exports.isStringObject = $15224262cb721c43$var$isStringObject;
function $15224262cb721c43$var$isBooleanObject(value) {
    return $15224262cb721c43$var$checkBoxedPrimitive(value, $15224262cb721c43$var$booleanValue);
}
module.exports.isBooleanObject = $15224262cb721c43$var$isBooleanObject;
function $15224262cb721c43$var$isBigIntObject(value) {
    return $15224262cb721c43$var$BigIntSupported && $15224262cb721c43$var$checkBoxedPrimitive(value, $15224262cb721c43$var$bigIntValue);
}
module.exports.isBigIntObject = $15224262cb721c43$var$isBigIntObject;
function $15224262cb721c43$var$isSymbolObject(value) {
    return $15224262cb721c43$var$SymbolSupported && $15224262cb721c43$var$checkBoxedPrimitive(value, $15224262cb721c43$var$symbolValue);
}
module.exports.isSymbolObject = $15224262cb721c43$var$isSymbolObject;
function $15224262cb721c43$var$isBoxedPrimitive(value) {
    return $15224262cb721c43$var$isNumberObject(value) || $15224262cb721c43$var$isStringObject(value) || $15224262cb721c43$var$isBooleanObject(value) || $15224262cb721c43$var$isBigIntObject(value) || $15224262cb721c43$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $15224262cb721c43$var$isBoxedPrimitive;
function $15224262cb721c43$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($15224262cb721c43$var$isArrayBuffer(value) || $15224262cb721c43$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $15224262cb721c43$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});
parcelRequire.register("1gbcx", function(module, exports) {
"use strict";

var $0eaff96aede76a5d$var$hasToStringTag = (parcelRequire("gB3VP"))();

var $iE4KL = parcelRequire("iE4KL");
var $0eaff96aede76a5d$var$$toString = $iE4KL("Object.prototype.toString");
var $0eaff96aede76a5d$var$isStandardArguments = function isArguments(value) {
    if ($0eaff96aede76a5d$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $0eaff96aede76a5d$var$$toString(value) === "[object Arguments]";
};
var $0eaff96aede76a5d$var$isLegacyArguments = function isArguments(value) {
    if ($0eaff96aede76a5d$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $0eaff96aede76a5d$var$$toString(value) !== "[object Array]" && $0eaff96aede76a5d$var$$toString(value.callee) === "[object Function]";
};
var $0eaff96aede76a5d$var$supportsStandardArguments = function() {
    return $0eaff96aede76a5d$var$isStandardArguments(arguments);
}();
$0eaff96aede76a5d$var$isStandardArguments.isLegacyArguments = $0eaff96aede76a5d$var$isLegacyArguments; // for tests
module.exports = $0eaff96aede76a5d$var$supportsStandardArguments ? $0eaff96aede76a5d$var$isStandardArguments : $0eaff96aede76a5d$var$isLegacyArguments;

});
parcelRequire.register("gB3VP", function(module, exports) {
"use strict";

var $hMv3j = parcelRequire("hMv3j");
module.exports = function hasToStringTagShams() {
    return $hMv3j() && !!Symbol.toStringTag;
};

});
parcelRequire.register("hMv3j", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRequire.register("iE4KL", function(module, exports) {
"use strict";

var $iHaJW = parcelRequire("iHaJW");

var $8GslT = parcelRequire("8GslT");
var $d92fa656e243475f$var$$indexOf = $8GslT($iHaJW("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $iHaJW(name, !!allowMissing);
    if (typeof intrinsic === "function" && $d92fa656e243475f$var$$indexOf(name, ".prototype.") > -1) return $8GslT(intrinsic);
    return intrinsic;
};

});
parcelRequire.register("iHaJW", function(module, exports) {
"use strict";
var $d9c492e31a76840c$var$undefined;
var $d9c492e31a76840c$var$$SyntaxError = SyntaxError;
var $d9c492e31a76840c$var$$Function = Function;
var $d9c492e31a76840c$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $d9c492e31a76840c$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $d9c492e31a76840c$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $d9c492e31a76840c$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($d9c492e31a76840c$var$$gOPD) try {
    $d9c492e31a76840c$var$$gOPD({}, "");
} catch (e) {
    $d9c492e31a76840c$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $d9c492e31a76840c$var$throwTypeError = function() {
    throw new $d9c492e31a76840c$var$$TypeError();
};
var $d9c492e31a76840c$var$ThrowTypeError = $d9c492e31a76840c$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $d9c492e31a76840c$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $d9c492e31a76840c$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $d9c492e31a76840c$var$throwTypeError;
        }
    }
}() : $d9c492e31a76840c$var$throwTypeError;

var $d9c492e31a76840c$var$hasSymbols = (parcelRequire("64GS8"))();

var $d9c492e31a76840c$var$hasProto = (parcelRequire("4UlHv"))();
var $d9c492e31a76840c$var$getProto = Object.getPrototypeOf || ($d9c492e31a76840c$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $d9c492e31a76840c$var$needsEval = {};
var $d9c492e31a76840c$var$TypedArray = typeof Uint8Array === "undefined" || !$d9c492e31a76840c$var$getProto ? $d9c492e31a76840c$var$undefined : $d9c492e31a76840c$var$getProto(Uint8Array);
var $d9c492e31a76840c$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? $d9c492e31a76840c$var$undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? $d9c492e31a76840c$var$undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $d9c492e31a76840c$var$hasSymbols && $d9c492e31a76840c$var$getProto ? $d9c492e31a76840c$var$getProto([][Symbol.iterator]()) : $d9c492e31a76840c$var$undefined,
    "%AsyncFromSyncIteratorPrototype%": $d9c492e31a76840c$var$undefined,
    "%AsyncFunction%": $d9c492e31a76840c$var$needsEval,
    "%AsyncGenerator%": $d9c492e31a76840c$var$needsEval,
    "%AsyncGeneratorFunction%": $d9c492e31a76840c$var$needsEval,
    "%AsyncIteratorPrototype%": $d9c492e31a76840c$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? $d9c492e31a76840c$var$undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? $d9c492e31a76840c$var$undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? $d9c492e31a76840c$var$undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? $d9c492e31a76840c$var$undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? $d9c492e31a76840c$var$undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? $d9c492e31a76840c$var$undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? $d9c492e31a76840c$var$undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? $d9c492e31a76840c$var$undefined : FinalizationRegistry,
    "%Function%": $d9c492e31a76840c$var$$Function,
    "%GeneratorFunction%": $d9c492e31a76840c$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? $d9c492e31a76840c$var$undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? $d9c492e31a76840c$var$undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? $d9c492e31a76840c$var$undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $d9c492e31a76840c$var$hasSymbols && $d9c492e31a76840c$var$getProto ? $d9c492e31a76840c$var$getProto($d9c492e31a76840c$var$getProto([][Symbol.iterator]())) : $d9c492e31a76840c$var$undefined,
    "%JSON%": typeof JSON === "object" ? JSON : $d9c492e31a76840c$var$undefined,
    "%Map%": typeof Map === "undefined" ? $d9c492e31a76840c$var$undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$d9c492e31a76840c$var$hasSymbols || !$d9c492e31a76840c$var$getProto ? $d9c492e31a76840c$var$undefined : $d9c492e31a76840c$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? $d9c492e31a76840c$var$undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? $d9c492e31a76840c$var$undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? $d9c492e31a76840c$var$undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? $d9c492e31a76840c$var$undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$d9c492e31a76840c$var$hasSymbols || !$d9c492e31a76840c$var$getProto ? $d9c492e31a76840c$var$undefined : $d9c492e31a76840c$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? $d9c492e31a76840c$var$undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $d9c492e31a76840c$var$hasSymbols && $d9c492e31a76840c$var$getProto ? $d9c492e31a76840c$var$getProto(""[Symbol.iterator]()) : $d9c492e31a76840c$var$undefined,
    "%Symbol%": $d9c492e31a76840c$var$hasSymbols ? Symbol : $d9c492e31a76840c$var$undefined,
    "%SyntaxError%": $d9c492e31a76840c$var$$SyntaxError,
    "%ThrowTypeError%": $d9c492e31a76840c$var$ThrowTypeError,
    "%TypedArray%": $d9c492e31a76840c$var$TypedArray,
    "%TypeError%": $d9c492e31a76840c$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? $d9c492e31a76840c$var$undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? $d9c492e31a76840c$var$undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? $d9c492e31a76840c$var$undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? $d9c492e31a76840c$var$undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? $d9c492e31a76840c$var$undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? $d9c492e31a76840c$var$undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? $d9c492e31a76840c$var$undefined : WeakSet
};
if ($d9c492e31a76840c$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $d9c492e31a76840c$var$errorProto = $d9c492e31a76840c$var$getProto($d9c492e31a76840c$var$getProto(e));
    $d9c492e31a76840c$var$INTRINSICS["%Error.prototype%"] = $d9c492e31a76840c$var$errorProto;
}
var $d9c492e31a76840c$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $d9c492e31a76840c$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $d9c492e31a76840c$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $d9c492e31a76840c$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $d9c492e31a76840c$var$getProto) value = $d9c492e31a76840c$var$getProto(gen.prototype);
    }
    $d9c492e31a76840c$var$INTRINSICS[name] = value;
    return value;
};
var $d9c492e31a76840c$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $8T3k8 = parcelRequire("8T3k8");

var $eUvJy = parcelRequire("eUvJy");
var $d9c492e31a76840c$var$$concat = $8T3k8.call(Function.call, Array.prototype.concat);
var $d9c492e31a76840c$var$$spliceApply = $8T3k8.call(Function.apply, Array.prototype.splice);
var $d9c492e31a76840c$var$$replace = $8T3k8.call(Function.call, String.prototype.replace);
var $d9c492e31a76840c$var$$strSlice = $8T3k8.call(Function.call, String.prototype.slice);
var $d9c492e31a76840c$var$$exec = $8T3k8.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $d9c492e31a76840c$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $d9c492e31a76840c$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $d9c492e31a76840c$var$stringToPath = function stringToPath(string) {
    var first = $d9c492e31a76840c$var$$strSlice(string, 0, 1);
    var last = $d9c492e31a76840c$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $d9c492e31a76840c$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $d9c492e31a76840c$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $d9c492e31a76840c$var$$replace(string, $d9c492e31a76840c$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $d9c492e31a76840c$var$$replace(subString, $d9c492e31a76840c$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $d9c492e31a76840c$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($eUvJy($d9c492e31a76840c$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $d9c492e31a76840c$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($eUvJy($d9c492e31a76840c$var$INTRINSICS, intrinsicName)) {
        var value = $d9c492e31a76840c$var$INTRINSICS[intrinsicName];
        if (value === $d9c492e31a76840c$var$needsEval) value = $d9c492e31a76840c$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $d9c492e31a76840c$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $d9c492e31a76840c$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $d9c492e31a76840c$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $d9c492e31a76840c$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($d9c492e31a76840c$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $d9c492e31a76840c$var$$SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $d9c492e31a76840c$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $d9c492e31a76840c$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $d9c492e31a76840c$var$$spliceApply(parts, $d9c492e31a76840c$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $d9c492e31a76840c$var$$strSlice(part, 0, 1);
        var last = $d9c492e31a76840c$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $d9c492e31a76840c$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($eUvJy($d9c492e31a76840c$var$INTRINSICS, intrinsicRealName)) value = $d9c492e31a76840c$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $d9c492e31a76840c$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($d9c492e31a76840c$var$$gOPD && i + 1 >= parts.length) {
                var desc = $d9c492e31a76840c$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $eUvJy(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $d9c492e31a76840c$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRequire.register("64GS8", function(module, exports) {
"use strict";
var $46c45f51a70c5a8a$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $hMv3j = parcelRequire("hMv3j");
module.exports = function hasNativeSymbols() {
    if (typeof $46c45f51a70c5a8a$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $46c45f51a70c5a8a$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $hMv3j();
};

});

parcelRequire.register("4UlHv", function(module, exports) {
"use strict";
var $392d39b2327c4fce$var$test = {
    foo: {}
};
var $392d39b2327c4fce$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $392d39b2327c4fce$var$test
    }).foo === $392d39b2327c4fce$var$test.foo && !(({
        __proto__: null
    }) instanceof $392d39b2327c4fce$var$$Object);
};

});

parcelRequire.register("8T3k8", function(module, exports) {
"use strict";

var $5P3xk = parcelRequire("5P3xk");
module.exports = Function.prototype.bind || $5P3xk;

});
parcelRequire.register("5P3xk", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $43d4757498b04b55$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $43d4757498b04b55$var$slice = Array.prototype.slice;
var $43d4757498b04b55$var$toStr = Object.prototype.toString;
var $43d4757498b04b55$var$funcType = "[object Function]";
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $43d4757498b04b55$var$toStr.call(target) !== $43d4757498b04b55$var$funcType) throw new TypeError($43d4757498b04b55$var$ERROR_MESSAGE + target);
    var args = $43d4757498b04b55$var$slice.call(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($43d4757498b04b55$var$slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat($43d4757498b04b55$var$slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRequire.register("eUvJy", function(module, exports) {
"use strict";

var $8T3k8 = parcelRequire("8T3k8");
module.exports = $8T3k8.call(Function.call, Object.prototype.hasOwnProperty);

});


parcelRequire.register("8GslT", function(module, exports) {
"use strict";

var $8T3k8 = parcelRequire("8T3k8");

var $iHaJW = parcelRequire("iHaJW");
var $65283d16dbc5c808$var$$apply = $iHaJW("%Function.prototype.apply%");
var $65283d16dbc5c808$var$$call = $iHaJW("%Function.prototype.call%");
var $65283d16dbc5c808$var$$reflectApply = $iHaJW("%Reflect.apply%", true) || $8T3k8.call($65283d16dbc5c808$var$$call, $65283d16dbc5c808$var$$apply);
var $65283d16dbc5c808$var$$gOPD = $iHaJW("%Object.getOwnPropertyDescriptor%", true);
var $65283d16dbc5c808$var$$defineProperty = $iHaJW("%Object.defineProperty%", true);
var $65283d16dbc5c808$var$$max = $iHaJW("%Math.max%");
if ($65283d16dbc5c808$var$$defineProperty) try {
    $65283d16dbc5c808$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $65283d16dbc5c808$var$$defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    var func = $65283d16dbc5c808$var$$reflectApply($8T3k8, $65283d16dbc5c808$var$$call, arguments);
    if ($65283d16dbc5c808$var$$gOPD && $65283d16dbc5c808$var$$defineProperty) {
        var desc = $65283d16dbc5c808$var$$gOPD(func, "length");
        if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
        $65283d16dbc5c808$var$$defineProperty(func, "length", {
            value: 1 + $65283d16dbc5c808$var$$max(0, originalFunction.length - (arguments.length - 1))
        });
    }
    return func;
};
var $65283d16dbc5c808$var$applyBind = function applyBind() {
    return $65283d16dbc5c808$var$$reflectApply($8T3k8, $65283d16dbc5c808$var$$apply, arguments);
};
if ($65283d16dbc5c808$var$$defineProperty) $65283d16dbc5c808$var$$defineProperty(module.exports, "apply", {
    value: $65283d16dbc5c808$var$applyBind
});
else module.exports.apply = $65283d16dbc5c808$var$applyBind;

});



parcelRequire.register("gl7IX", function(module, exports) {
"use strict";
var $be5499610deb4117$var$toStr = Object.prototype.toString;
var $be5499610deb4117$var$fnToStr = Function.prototype.toString;
var $be5499610deb4117$var$isFnRegex = /^\s*(?:function)?\*/;

var $be5499610deb4117$var$hasToStringTag = (parcelRequire("gB3VP"))();
var $be5499610deb4117$var$getProto = Object.getPrototypeOf;
var $be5499610deb4117$var$getGeneratorFunc = function() {
    if (!$be5499610deb4117$var$hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var $be5499610deb4117$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if ($be5499610deb4117$var$isFnRegex.test($be5499610deb4117$var$fnToStr.call(fn))) return true;
    if (!$be5499610deb4117$var$hasToStringTag) {
        var str = $be5499610deb4117$var$toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!$be5499610deb4117$var$getProto) return false;
    if (typeof $be5499610deb4117$var$GeneratorFunction === "undefined") {
        var generatorFunc = $be5499610deb4117$var$getGeneratorFunc();
        $be5499610deb4117$var$GeneratorFunction = generatorFunc ? $be5499610deb4117$var$getProto(generatorFunc) : false;
    }
    return $be5499610deb4117$var$getProto(fn) === $be5499610deb4117$var$GeneratorFunction;
};

});

parcelRequire.register("jCBKx", function(module, exports) {
"use strict";

var $49URV = parcelRequire("49URV");

var $7szV7 = parcelRequire("7szV7");

var $iE4KL = parcelRequire("iE4KL");

var $kReto = parcelRequire("kReto");
var $e48ed935626e93b2$var$$toString = $iE4KL("Object.prototype.toString");

var $e48ed935626e93b2$var$hasToStringTag = (parcelRequire("gB3VP"))();
var $e48ed935626e93b2$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $e48ed935626e93b2$var$typedArrays = $7szV7();
var $e48ed935626e93b2$var$$slice = $iE4KL("String.prototype.slice");
var $e48ed935626e93b2$var$toStrTags = {};
var $e48ed935626e93b2$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($e48ed935626e93b2$var$hasToStringTag && $kReto && $e48ed935626e93b2$var$getPrototypeOf) $49URV($e48ed935626e93b2$var$typedArrays, function(typedArray) {
    if (typeof $e48ed935626e93b2$var$g[typedArray] === "function") {
        var arr = new $e48ed935626e93b2$var$g[typedArray]();
        if (Symbol.toStringTag in arr) {
            var proto = $e48ed935626e93b2$var$getPrototypeOf(arr);
            var descriptor = $kReto(proto, Symbol.toStringTag);
            if (!descriptor) {
                var superProto = $e48ed935626e93b2$var$getPrototypeOf(proto);
                descriptor = $kReto(superProto, Symbol.toStringTag);
            }
            $e48ed935626e93b2$var$toStrTags[typedArray] = descriptor.get;
        }
    }
});
var $e48ed935626e93b2$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var foundName = false;
    $49URV($e48ed935626e93b2$var$toStrTags, function(getter, typedArray) {
        if (!foundName) try {
            var name = getter.call(value);
            if (name === typedArray) foundName = name;
        } catch (e) {}
    });
    return foundName;
};

var $aSsgt = parcelRequire("aSsgt");
module.exports = function whichTypedArray(value) {
    if (!$aSsgt(value)) return false;
    if (!$e48ed935626e93b2$var$hasToStringTag || !(Symbol.toStringTag in value)) return $e48ed935626e93b2$var$$slice($e48ed935626e93b2$var$$toString(value), 8, -1);
    return $e48ed935626e93b2$var$tryTypedArrays(value);
};

});
parcelRequire.register("49URV", function(module, exports) {
"use strict";

var $84cZC = parcelRequire("84cZC");
var $30741da83d008c9d$var$toStr = Object.prototype.toString;
var $30741da83d008c9d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $30741da83d008c9d$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($30741da83d008c9d$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $30741da83d008c9d$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $30741da83d008c9d$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($30741da83d008c9d$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $30741da83d008c9d$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$84cZC(iterator)) throw new TypeError("iterator must be a function");
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($30741da83d008c9d$var$toStr.call(list) === "[object Array]") $30741da83d008c9d$var$forEachArray(list, iterator, receiver);
    else if (typeof list === "string") $30741da83d008c9d$var$forEachString(list, iterator, receiver);
    else $30741da83d008c9d$var$forEachObject(list, iterator, receiver);
};
module.exports = $30741da83d008c9d$var$forEach;

});
parcelRequire.register("84cZC", function(module, exports) {
"use strict";
var $5df8c690668b961c$var$fnToStr = Function.prototype.toString;
var $5df8c690668b961c$var$reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var $5df8c690668b961c$var$badArrayLike;
var $5df8c690668b961c$var$isCallableMarker;
if (typeof $5df8c690668b961c$var$reflectApply === "function" && typeof Object.defineProperty === "function") try {
    $5df8c690668b961c$var$badArrayLike = Object.defineProperty({}, "length", {
        get: function() {
            throw $5df8c690668b961c$var$isCallableMarker;
        }
    });
    $5df8c690668b961c$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $5df8c690668b961c$var$reflectApply(function() {
        throw 42;
    }, null, $5df8c690668b961c$var$badArrayLike);
} catch (_) {
    if (_ !== $5df8c690668b961c$var$isCallableMarker) $5df8c690668b961c$var$reflectApply = null;
}
else $5df8c690668b961c$var$reflectApply = null;
var $5df8c690668b961c$var$constructorRegex = /^\s*class\b/;
var $5df8c690668b961c$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $5df8c690668b961c$var$fnToStr.call(value);
        return $5df8c690668b961c$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $5df8c690668b961c$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($5df8c690668b961c$var$isES6ClassFn(value)) return false;
        $5df8c690668b961c$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $5df8c690668b961c$var$toStr = Object.prototype.toString;
var $5df8c690668b961c$var$objectClass = "[object Object]";
var $5df8c690668b961c$var$fnClass = "[object Function]";
var $5df8c690668b961c$var$genClass = "[object GeneratorFunction]";
var $5df8c690668b961c$var$ddaClass = "[object HTMLAllCollection]"; // IE 11
var $5df8c690668b961c$var$ddaClass2 = "[object HTML document.all class]";
var $5df8c690668b961c$var$ddaClass3 = "[object HTMLCollection]"; // IE 9-10
var $5df8c690668b961c$var$hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $5df8c690668b961c$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $5df8c690668b961c$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === "object") {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $5df8c690668b961c$var$all = document.all;
    if ($5df8c690668b961c$var$toStr.call($5df8c690668b961c$var$all) === $5df8c690668b961c$var$toStr.call(document.all)) $5df8c690668b961c$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($5df8c690668b961c$var$isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
            var str = $5df8c690668b961c$var$toStr.call(value);
            return (str === $5df8c690668b961c$var$ddaClass || str === $5df8c690668b961c$var$ddaClass2 || str === $5df8c690668b961c$var$ddaClass3 // opera 12.16
             || str === $5df8c690668b961c$var$objectClass // IE 6-8
            ) && value("") == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $5df8c690668b961c$var$reflectApply ? function isCallable(value) {
    if ($5df8c690668b961c$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    try {
        $5df8c690668b961c$var$reflectApply(value, null, $5df8c690668b961c$var$badArrayLike);
    } catch (e) {
        if (e !== $5df8c690668b961c$var$isCallableMarker) return false;
    }
    return !$5df8c690668b961c$var$isES6ClassFn(value) && $5df8c690668b961c$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($5df8c690668b961c$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    if ($5df8c690668b961c$var$hasToStringTag) return $5df8c690668b961c$var$tryFunctionObject(value);
    if ($5df8c690668b961c$var$isES6ClassFn(value)) return false;
    var strClass = $5df8c690668b961c$var$toStr.call(value);
    if (strClass !== $5df8c690668b961c$var$fnClass && strClass !== $5df8c690668b961c$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $5df8c690668b961c$var$tryFunctionObject(value);
};

});


parcelRequire.register("7szV7", function(module, exports) {
"use strict";
var $56e702f1abe4a908$var$possibleNames = [
    "BigInt64Array",
    "BigUint64Array",
    "Float32Array",
    "Float64Array",
    "Int16Array",
    "Int32Array",
    "Int8Array",
    "Uint16Array",
    "Uint32Array",
    "Uint8Array",
    "Uint8ClampedArray"
];
var $56e702f1abe4a908$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
module.exports = function availableTypedArrays() {
    var out = [];
    for(var i = 0; i < $56e702f1abe4a908$var$possibleNames.length; i++)if (typeof $56e702f1abe4a908$var$g[$56e702f1abe4a908$var$possibleNames[i]] === "function") out[out.length] = $56e702f1abe4a908$var$possibleNames[i];
    return out;
};

});

parcelRequire.register("kReto", function(module, exports) {
"use strict";

var $iHaJW = parcelRequire("iHaJW");
var $f2f3fbf56b3eef84$var$$gOPD = $iHaJW("%Object.getOwnPropertyDescriptor%", true);
if ($f2f3fbf56b3eef84$var$$gOPD) try {
    $f2f3fbf56b3eef84$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $f2f3fbf56b3eef84$var$$gOPD = null;
}
module.exports = $f2f3fbf56b3eef84$var$$gOPD;

});

parcelRequire.register("aSsgt", function(module, exports) {
"use strict";

var $49URV = parcelRequire("49URV");

var $7szV7 = parcelRequire("7szV7");

var $iE4KL = parcelRequire("iE4KL");
var $7eb4df55e0a36691$var$$toString = $iE4KL("Object.prototype.toString");

var $7eb4df55e0a36691$var$hasToStringTag = (parcelRequire("gB3VP"))();

var $kReto = parcelRequire("kReto");
var $7eb4df55e0a36691$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $7eb4df55e0a36691$var$typedArrays = $7szV7();
var $7eb4df55e0a36691$var$$indexOf = $iE4KL("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
var $7eb4df55e0a36691$var$$slice = $iE4KL("String.prototype.slice");
var $7eb4df55e0a36691$var$toStrTags = {};
var $7eb4df55e0a36691$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($7eb4df55e0a36691$var$hasToStringTag && $kReto && $7eb4df55e0a36691$var$getPrototypeOf) $49URV($7eb4df55e0a36691$var$typedArrays, function(typedArray) {
    var arr = new $7eb4df55e0a36691$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $7eb4df55e0a36691$var$getPrototypeOf(arr);
        var descriptor = $kReto(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $7eb4df55e0a36691$var$getPrototypeOf(proto);
            descriptor = $kReto(superProto, Symbol.toStringTag);
        }
        $7eb4df55e0a36691$var$toStrTags[typedArray] = descriptor.get;
    }
});
var $7eb4df55e0a36691$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var anyTrue = false;
    $49URV($7eb4df55e0a36691$var$toStrTags, function(getter, typedArray) {
        if (!anyTrue) try {
            anyTrue = getter.call(value) === typedArray;
        } catch (e) {}
    });
    return anyTrue;
};
module.exports = function isTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$7eb4df55e0a36691$var$hasToStringTag || !(Symbol.toStringTag in value)) {
        var tag = $7eb4df55e0a36691$var$$slice($7eb4df55e0a36691$var$$toString(value), 8, -1);
        return $7eb4df55e0a36691$var$$indexOf($7eb4df55e0a36691$var$typedArrays, tag) > -1;
    }
    if (!$kReto) return false;
    return $7eb4df55e0a36691$var$tryTypedArrays(value);
};

});



parcelRequire.register("9XS2N", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});

parcelRequire.register("8VpWl", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});



parcelRequire.register("hVwZR", function(module, exports) {

var $e67mm = parcelRequire("e67mm");

var $dbC7k = parcelRequire("dbC7k");

var $hsHxV = parcelRequire("hsHxV");
var $d0d15afe58d55795$var$inherit = $dbC7k.util.inherit;
var $d0d15afe58d55795$var$domain = $dbC7k.util.domain;

var $lxybn = parcelRequire("lxybn");
/**
 * @api private
 */ var $d0d15afe58d55795$var$hardErrorStates = {
    success: 1,
    error: 1,
    complete: 1
};
function $d0d15afe58d55795$var$isTerminalState(machine) {
    return Object.prototype.hasOwnProperty.call($d0d15afe58d55795$var$hardErrorStates, machine._asm.currentState);
}
var $d0d15afe58d55795$var$fsm = new $hsHxV();
$d0d15afe58d55795$var$fsm.setupStates = function() {
    var transition = function(_, done) {
        var self = this;
        self._haltHandlersOnError = false;
        self.emit(self._asm.currentState, function(err) {
            if (err) {
                if ($d0d15afe58d55795$var$isTerminalState(self)) {
                    if ($d0d15afe58d55795$var$domain && self.domain instanceof $d0d15afe58d55795$var$domain.Domain) {
                        err.domainEmitter = self;
                        err.domain = self.domain;
                        err.domainThrown = false;
                        self.domain.emit("error", err);
                    } else throw err;
                } else {
                    self.response.error = err;
                    done(err);
                }
            } else done(self.response.error);
        });
    };
    this.addState("validate", "build", "error", transition);
    this.addState("build", "afterBuild", "restart", transition);
    this.addState("afterBuild", "sign", "restart", transition);
    this.addState("sign", "send", "retry", transition);
    this.addState("retry", "afterRetry", "afterRetry", transition);
    this.addState("afterRetry", "sign", "error", transition);
    this.addState("send", "validateResponse", "retry", transition);
    this.addState("validateResponse", "extractData", "extractError", transition);
    this.addState("extractError", "extractData", "retry", transition);
    this.addState("extractData", "success", "retry", transition);
    this.addState("restart", "build", "error", transition);
    this.addState("success", "complete", "complete", transition);
    this.addState("error", "complete", "complete", transition);
    this.addState("complete", null, null, transition);
};
$d0d15afe58d55795$var$fsm.setupStates();
/**
 * ## Asynchronous Requests
 *
 * All requests made through the SDK are asynchronous and use a
 * callback interface. Each service method that kicks off a request
 * returns an `AWS.Request` object that you can use to register
 * callbacks.
 *
 * For example, the following service method returns the request
 * object as "request", which can be used to register callbacks:
 *
 * ```javascript
 * // request is an AWS.Request object
 * var request = ec2.describeInstances();
 *
 * // register callbacks on request to retrieve response data
 * request.on('success', function(response) {
 *   console.log(response.data);
 * });
 * ```
 *
 * When a request is ready to be sent, the {send} method should
 * be called:
 *
 * ```javascript
 * request.send();
 * ```
 *
 * Since registered callbacks may or may not be idempotent, requests should only
 * be sent once. To perform the same operation multiple times, you will need to
 * create multiple request objects, each with its own registered callbacks.
 *
 * ## Removing Default Listeners for Events
 *
 * Request objects are built with default listeners for the various events,
 * depending on the service type. In some cases, you may want to remove
 * some built-in listeners to customize behaviour. Doing this requires
 * access to the built-in listener functions, which are exposed through
 * the {AWS.EventListeners.Core} namespace. For instance, you may
 * want to customize the HTTP handler used when sending a request. In this
 * case, you can remove the built-in listener associated with the 'send'
 * event, the {AWS.EventListeners.Core.SEND} listener and add your own.
 *
 * ## Multiple Callbacks and Chaining
 *
 * You can register multiple callbacks on any request object. The
 * callbacks can be registered for different events, or all for the
 * same event. In addition, you can chain callback registration, for
 * example:
 *
 * ```javascript
 * request.
 *   on('success', function(response) {
 *     console.log("Success!");
 *   }).
 *   on('error', function(error, response) {
 *     console.log("Error!");
 *   }).
 *   on('complete', function(response) {
 *     console.log("Always!");
 *   }).
 *   send();
 * ```
 *
 * The above example will print either "Success! Always!", or "Error! Always!",
 * depending on whether the request succeeded or not.
 *
 * @!attribute httpRequest
 *   @readonly
 *   @!group HTTP Properties
 *   @return [AWS.HttpRequest] the raw HTTP request object
 *     containing request headers and body information
 *     sent by the service.
 *
 * @!attribute startTime
 *   @readonly
 *   @!group Operation Properties
 *   @return [Date] the time that the request started
 *
 * @!group Request Building Events
 *
 * @!event validate(request)
 *   Triggered when a request is being validated. Listeners
 *   should throw an error if the request should not be sent.
 *   @param request [Request] the request object being sent
 *   @see AWS.EventListeners.Core.VALIDATE_CREDENTIALS
 *   @see AWS.EventListeners.Core.VALIDATE_REGION
 *   @example Ensuring that a certain parameter is set before sending a request
 *     var req = s3.putObject(params);
 *     req.on('validate', function() {
 *       if (!req.params.Body.match(/^Hello\s/)) {
 *         throw new Error('Body must start with "Hello "');
 *       }
 *     });
 *     req.send(function(err, data) { ... });
 *
 * @!event build(request)
 *   Triggered when the request payload is being built. Listeners
 *   should fill the necessary information to send the request
 *   over HTTP.
 *   @param (see AWS.Request~validate)
 *   @example Add a custom HTTP header to a request
 *     var req = s3.putObject(params);
 *     req.on('build', function() {
 *       req.httpRequest.headers['Custom-Header'] = 'value';
 *     });
 *     req.send(function(err, data) { ... });
 *
 * @!event sign(request)
 *   Triggered when the request is being signed. Listeners should
 *   add the correct authentication headers and/or adjust the body,
 *   depending on the authentication mechanism being used.
 *   @param (see AWS.Request~validate)
 *
 * @!group Request Sending Events
 *
 * @!event send(response)
 *   Triggered when the request is ready to be sent. Listeners
 *   should call the underlying transport layer to initiate
 *   the sending of the request.
 *   @param response [Response] the response object
 *   @context [Request] the request object that was sent
 *   @see AWS.EventListeners.Core.SEND
 *
 * @!event retry(response)
 *   Triggered when a request failed and might need to be retried or redirected.
 *   If the response is retryable, the listener should set the
 *   `response.error.retryable` property to `true`, and optionally set
 *   `response.error.retryDelay` to the millisecond delay for the next attempt.
 *   In the case of a redirect, `response.error.redirect` should be set to
 *   `true` with `retryDelay` set to an optional delay on the next request.
 *
 *   If a listener decides that a request should not be retried,
 *   it should set both `retryable` and `redirect` to false.
 *
 *   Note that a retryable error will be retried at most
 *   {AWS.Config.maxRetries} times (based on the service object's config).
 *   Similarly, a request that is redirected will only redirect at most
 *   {AWS.Config.maxRedirects} times.
 *
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @example Adding a custom retry for a 404 response
 *     request.on('retry', function(response) {
 *       // this resource is not yet available, wait 10 seconds to get it again
 *       if (response.httpResponse.statusCode === 404 && response.error) {
 *         response.error.retryable = true;   // retry this error
 *         response.error.retryDelay = 10000; // wait 10 seconds
 *       }
 *     });
 *
 * @!group Data Parsing Events
 *
 * @!event extractError(response)
 *   Triggered on all non-2xx requests so that listeners can extract
 *   error details from the response body. Listeners to this event
 *   should set the `response.error` property.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event extractData(response)
 *   Triggered in successful requests to allow listeners to
 *   de-serialize the response body into `response.data`.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!group Completion Events
 *
 * @!event success(response)
 *   Triggered when the request completed successfully.
 *   `response.data` will contain the response data and
 *   `response.error` will be null.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event error(error, response)
 *   Triggered when an error occurs at any point during the
 *   request. `response.error` will contain details about the error
 *   that occurred. `response.data` will be null.
 *   @param error [Error] the error object containing details about
 *     the error that occurred.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event complete(response)
 *   Triggered whenever a request cycle completes. `response.error`
 *   should be checked, since the request may have failed.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!group HTTP Events
 *
 * @!event httpHeaders(statusCode, headers, response, statusMessage)
 *   Triggered when headers are sent by the remote server
 *   @param statusCode [Integer] the HTTP response code
 *   @param headers [map<String,String>] the response headers
 *   @param (see AWS.Request~send)
 *   @param statusMessage [String] A status message corresponding to the HTTP
 *                                 response code
 *   @context (see AWS.Request~send)
 *
 * @!event httpData(chunk, response)
 *   Triggered when data is sent by the remote server
 *   @param chunk [Buffer] the buffer data containing the next data chunk
 *     from the server
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @see AWS.EventListeners.Core.HTTP_DATA
 *
 * @!event httpUploadProgress(progress, response)
 *   Triggered when the HTTP request has uploaded more data
 *   @param progress [map] An object containing the `loaded` and `total` bytes
 *     of the request.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @note This event will not be emitted in Node.js 0.8.x.
 *
 * @!event httpDownloadProgress(progress, response)
 *   Triggered when the HTTP request has downloaded more data
 *   @param progress [map] An object containing the `loaded` and `total` bytes
 *     of the request.
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *   @note This event will not be emitted in Node.js 0.8.x.
 *
 * @!event httpError(error, response)
 *   Triggered when the HTTP request failed
 *   @param error [Error] the error object that was thrown
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @!event httpDone(response)
 *   Triggered when the server is finished sending data
 *   @param (see AWS.Request~send)
 *   @context (see AWS.Request~send)
 *
 * @see AWS.Response
 */ $dbC7k.Request = $d0d15afe58d55795$var$inherit({
    /**
   * Creates a request for an operation on a given service with
   * a set of input parameters.
   *
   * @param service [AWS.Service] the service to perform the operation on
   * @param operation [String] the operation to perform on the service
   * @param params [Object] parameters to send to the operation.
   *   See the operation's documentation for the format of the
   *   parameters.
   */ constructor: function Request(service, operation, params) {
        var endpoint = service.endpoint;
        var region = service.config.region;
        var customUserAgent = service.config.customUserAgent;
        // global endpoints sign as us-east-1
        if (service.isGlobalEndpoint) region = "us-east-1";
        this.domain = $d0d15afe58d55795$var$domain && $d0d15afe58d55795$var$domain.active;
        this.service = service;
        this.operation = operation;
        this.params = params || {};
        this.httpRequest = new $dbC7k.HttpRequest(endpoint, region);
        this.httpRequest.appendToUserAgent(customUserAgent);
        this.startTime = service.getSkewCorrectedDate();
        this.response = new $dbC7k.Response(this);
        this._asm = new $hsHxV($d0d15afe58d55795$var$fsm.states, "validate");
        this._haltHandlersOnError = false;
        $dbC7k.SequentialExecutor.call(this);
        this.emit = this.emitEvent;
    },
    /**
   * @!group Sending a Request
   */ /**
   * @overload send(callback = null)
   *   Sends the request object.
   *
   *   @callback callback function(err, data)
   *     If a callback is supplied, it is called when a response is returned
   *     from the service.
   *     @context [AWS.Request] the request object being sent.
   *     @param err [Error] the error object returned from the request.
   *       Set to `null` if the request is successful.
   *     @param data [Object] the de-serialized data returned from
   *       the request. Set to `null` if a request error occurs.
   *   @example Sending a request with a callback
   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
   *     request.send(function(err, data) { console.log(err, data); });
   *   @example Sending a request with no callback (using event handlers)
   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
   *     request.on('complete', function(response) { ... }); // register a callback
   *     request.send();
   */ send: function send(callback) {
        if (callback) {
            // append to user agent
            this.httpRequest.appendToUserAgent("callback");
            this.on("complete", function(resp) {
                callback.call(resp, resp.error, resp.data);
            });
        }
        this.runTo();
        return this.response;
    },
    /**
   * @!method  promise()
   *   Sends the request and returns a 'thenable' promise.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function(data)
   *     Called if the promise is fulfilled.
   *     @param data [Object] the de-serialized data returned from the request.
   *   @callback rejectedCallback function(error)
   *     Called if the promise is rejected.
   *     @param error [Error] the error object returned from the request.
   *   @return [Promise] A promise that represents the state of the request.
   *   @example Sending a request using promises.
   *     var request = s3.putObject({Bucket: 'bucket', Key: 'key'});
   *     var result = request.promise();
   *     result.then(function(data) { ... }, function(error) { ... });
   */ /**
   * @api private
   */ build: function build(callback) {
        return this.runTo("send", callback);
    },
    /**
   * @api private
   */ runTo: function runTo(state, done) {
        this._asm.runTo(state, done, this);
        return this;
    },
    /**
   * Aborts a request, emitting the error and complete events.
   *
   * @!macro nobrowser
   * @example Aborting a request after sending
   *   var params = {
   *     Bucket: 'bucket', Key: 'key',
   *     Body: Buffer.alloc(1024 * 1024 * 5) // 5MB payload
   *   };
   *   var request = s3.putObject(params);
   *   request.send(function (err, data) {
   *     if (err) console.log("Error:", err.code, err.message);
   *     else console.log(data);
   *   });
   *
   *   // abort request in 1 second
   *   setTimeout(request.abort.bind(request), 1000);
   *
   *   // prints "Error: RequestAbortedError Request aborted by user"
   * @return [AWS.Request] the same request object, for chaining.
   * @since v1.4.0
   */ abort: function abort() {
        this.removeAllListeners("validateResponse");
        this.removeAllListeners("extractError");
        this.on("validateResponse", function addAbortedError(resp) {
            resp.error = $dbC7k.util.error(new Error("Request aborted by user"), {
                code: "RequestAbortedError",
                retryable: false
            });
        });
        if (this.httpRequest.stream && !this.httpRequest.stream.didCallback) {
            this.httpRequest.stream.abort();
            if (this.httpRequest._abortCallback) this.httpRequest._abortCallback();
            else this.removeAllListeners("send"); // haven't sent yet, so let's not
        }
        return this;
    },
    /**
   * Iterates over each page of results given a pageable request, calling
   * the provided callback with each page of data. After all pages have been
   * retrieved, the callback is called with `null` data.
   *
   * @note This operation can generate multiple requests to a service.
   * @example Iterating over multiple pages of objects in an S3 bucket
   *   var pages = 1;
   *   s3.listObjects().eachPage(function(err, data) {
   *     if (err) return;
   *     console.log("Page", pages++);
   *     console.log(data);
   *   });
   * @example Iterating over multiple pages with an asynchronous callback
   *   s3.listObjects(params).eachPage(function(err, data, done) {
   *     doSomethingAsyncAndOrExpensive(function() {
   *       // The next page of results isn't fetched until done is called
   *       done();
   *     });
   *   });
   * @callback callback function(err, data, [doneCallback])
   *   Called with each page of resulting data from the request. If the
   *   optional `doneCallback` is provided in the function, it must be called
   *   when the callback is complete.
   *
   *   @param err [Error] an error object, if an error occurred.
   *   @param data [Object] a single page of response data. If there is no
   *     more data, this object will be `null`.
   *   @param doneCallback [Function] an optional done callback. If this
   *     argument is defined in the function declaration, it should be called
   *     when the next page is ready to be retrieved. This is useful for
   *     controlling serial pagination across asynchronous operations.
   *   @return [Boolean] if the callback returns `false`, pagination will
   *     stop.
   *
   * @see AWS.Request.eachItem
   * @see AWS.Response.nextPage
   * @since v1.4.0
   */ eachPage: function eachPage(callback) {
        // Make all callbacks async-ish
        callback = $dbC7k.util.fn.makeAsync(callback, 3);
        function wrappedCallback(response) {
            callback.call(response, response.error, response.data, function(result) {
                if (result === false) return;
                if (response.hasNextPage()) response.nextPage().on("complete", wrappedCallback).send();
                else callback.call(response, null, null, $dbC7k.util.fn.noop);
            });
        }
        this.on("complete", wrappedCallback).send();
    },
    /**
   * Enumerates over individual items of a request, paging the responses if
   * necessary.
   *
   * @api experimental
   * @since v1.4.0
   */ eachItem: function eachItem(callback) {
        var self = this;
        function wrappedCallback(err, data) {
            if (err) return callback(err, null);
            if (data === null) return callback(null, null);
            var config = self.service.paginationConfig(self.operation);
            var resultKey = config.resultKey;
            if (Array.isArray(resultKey)) resultKey = resultKey[0];
            var items = $lxybn.search(data, resultKey);
            var continueIteration = true;
            $dbC7k.util.arrayEach(items, function(item) {
                continueIteration = callback(null, item);
                if (continueIteration === false) return $dbC7k.util.abort;
            });
            return continueIteration;
        }
        this.eachPage(wrappedCallback);
    },
    /**
   * @return [Boolean] whether the operation can return multiple pages of
   *   response data.
   * @see AWS.Response.eachPage
   * @since v1.4.0
   */ isPageable: function isPageable() {
        return this.service.paginationConfig(this.operation) ? true : false;
    },
    /**
   * Sends the request and converts the request object into a readable stream
   * that can be read from or piped into a writable stream.
   *
   * @note The data read from a readable stream contains only
   *   the raw HTTP body contents.
   * @example Manually reading from a stream
   *   request.createReadStream().on('data', function(data) {
   *     console.log("Got data:", data.toString());
   *   });
   * @example Piping a request body into a file
   *   var out = fs.createWriteStream('/path/to/outfile.jpg');
   *   s3.service.getObject(params).createReadStream().pipe(out);
   * @return [Stream] the readable stream object that can be piped
   *   or read from (by registering 'data' event listeners).
   * @!macro nobrowser
   */ createReadStream: function createReadStream() {
        var streams = $dbC7k.util.stream;
        var req = this;
        var stream = null;
        if ($dbC7k.HttpClient.streamsApiVersion === 2) {
            stream = new streams.PassThrough();
            $e67mm.nextTick(function() {
                req.send();
            });
        } else {
            stream = new streams.Stream();
            stream.readable = true;
            stream.sent = false;
            stream.on("newListener", function(event) {
                if (!stream.sent && event === "data") {
                    stream.sent = true;
                    $e67mm.nextTick(function() {
                        req.send();
                    });
                }
            });
        }
        this.on("error", function(err) {
            stream.emit("error", err);
        });
        this.on("httpHeaders", function streamHeaders(statusCode, headers, resp) {
            if (statusCode < 300) {
                req.removeListener("httpData", $dbC7k.EventListeners.Core.HTTP_DATA);
                req.removeListener("httpError", $dbC7k.EventListeners.Core.HTTP_ERROR);
                req.on("httpError", function streamHttpError(error) {
                    resp.error = error;
                    resp.error.retryable = false;
                });
                var shouldCheckContentLength = false;
                var expectedLen;
                if (req.httpRequest.method !== "HEAD") expectedLen = parseInt(headers["content-length"], 10);
                if (expectedLen !== undefined && !isNaN(expectedLen) && expectedLen >= 0) {
                    shouldCheckContentLength = true;
                    var receivedLen = 0;
                }
                var checkContentLengthAndEmit = function checkContentLengthAndEmit() {
                    if (shouldCheckContentLength && receivedLen !== expectedLen) stream.emit("error", $dbC7k.util.error(new Error("Stream content length mismatch. Received " + receivedLen + " of " + expectedLen + " bytes."), {
                        code: "StreamContentLengthMismatch"
                    }));
                    else if ($dbC7k.HttpClient.streamsApiVersion === 2) stream.end();
                    else stream.emit("end");
                };
                var httpStream = resp.httpResponse.createUnbufferedStream();
                if ($dbC7k.HttpClient.streamsApiVersion === 2) {
                    if (shouldCheckContentLength) {
                        var lengthAccumulator = new streams.PassThrough();
                        lengthAccumulator._write = function(chunk) {
                            if (chunk && chunk.length) receivedLen += chunk.length;
                            return streams.PassThrough.prototype._write.apply(this, arguments);
                        };
                        lengthAccumulator.on("end", checkContentLengthAndEmit);
                        stream.on("error", function(err) {
                            shouldCheckContentLength = false;
                            httpStream.unpipe(lengthAccumulator);
                            lengthAccumulator.emit("end");
                            lengthAccumulator.end();
                        });
                        httpStream.pipe(lengthAccumulator).pipe(stream, {
                            end: false
                        });
                    } else httpStream.pipe(stream);
                } else {
                    if (shouldCheckContentLength) httpStream.on("data", function(arg) {
                        if (arg && arg.length) receivedLen += arg.length;
                    });
                    httpStream.on("data", function(arg) {
                        stream.emit("data", arg);
                    });
                    httpStream.on("end", checkContentLengthAndEmit);
                }
                httpStream.on("error", function(err) {
                    shouldCheckContentLength = false;
                    stream.emit("error", err);
                });
            }
        });
        return stream;
    },
    /**
   * @param [Array,Response] args This should be the response object,
   *   or an array of args to send to the event.
   * @api private
   */ emitEvent: function emit(eventName, args, done) {
        if (typeof args === "function") {
            done = args;
            args = null;
        }
        if (!done) done = function() {};
        if (!args) args = this.eventParameters(eventName, this.response);
        var origEmit = $dbC7k.SequentialExecutor.prototype.emit;
        origEmit.call(this, eventName, args, function(err) {
            if (err) this.response.error = err;
            done.call(this, err);
        });
    },
    /**
   * @api private
   */ eventParameters: function eventParameters(eventName) {
        switch(eventName){
            case "restart":
            case "validate":
            case "sign":
            case "build":
            case "afterValidate":
            case "afterBuild":
                return [
                    this
                ];
            case "error":
                return [
                    this.response.error,
                    this.response
                ];
            default:
                return [
                    this.response
                ];
        }
    },
    /**
   * @api private
   */ presign: function presign(expires, callback) {
        if (!callback && typeof expires === "function") {
            callback = expires;
            expires = null;
        }
        return new $dbC7k.Signers.Presign().sign(this.toGet(), expires, callback);
    },
    /**
   * @api private
   */ isPresigned: function isPresigned() {
        return Object.prototype.hasOwnProperty.call(this.httpRequest.headers, "presigned-expires");
    },
    /**
   * @api private
   */ toUnauthenticated: function toUnauthenticated() {
        this._unAuthenticated = true;
        this.removeListener("validate", $dbC7k.EventListeners.Core.VALIDATE_CREDENTIALS);
        this.removeListener("sign", $dbC7k.EventListeners.Core.SIGN);
        return this;
    },
    /**
   * @api private
   */ toGet: function toGet() {
        if (this.service.api.protocol === "query" || this.service.api.protocol === "ec2") {
            this.removeListener("build", this.buildAsGet);
            this.addListener("build", this.buildAsGet);
        }
        return this;
    },
    /**
   * @api private
   */ buildAsGet: function buildAsGet(request) {
        request.httpRequest.method = "GET";
        request.httpRequest.path = request.service.endpoint.path + "?" + request.httpRequest.body;
        request.httpRequest.body = "";
        // don't need these headers on a GET request
        delete request.httpRequest.headers["Content-Length"];
        delete request.httpRequest.headers["Content-Type"];
    },
    /**
   * @api private
   */ haltHandlersOnError: function haltHandlersOnError() {
        this._haltHandlersOnError = true;
    }
});
/**
 * @api private
 */ $dbC7k.Request.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
    this.prototype.promise = function promise() {
        var self = this;
        // append to user agent
        this.httpRequest.appendToUserAgent("promise");
        return new PromiseDependency(function(resolve, reject) {
            self.on("complete", function(resp) {
                if (resp.error) reject(resp.error);
                else // define $response property so that it is not enumberable
                // this prevents circular reference errors when stringifying the JSON object
                resolve(Object.defineProperty(resp.data || {}, "$response", {
                    value: resp
                }));
            });
            self.runTo();
        });
    };
};
/**
 * @api private
 */ $dbC7k.Request.deletePromisesFromClass = function deletePromisesFromClass() {
    delete this.prototype.promise;
};
$dbC7k.util.addPromises($dbC7k.Request);
$dbC7k.util.mixin($dbC7k.Request, $dbC7k.SequentialExecutor);

});
parcelRequire.register("hsHxV", function(module, exports) {
function $cb66d49462fb2fc1$var$AcceptorStateMachine(states, state) {
    this.currentState = state || null;
    this.states = states || {};
}
$cb66d49462fb2fc1$var$AcceptorStateMachine.prototype.runTo = function runTo(finalState, done, bindObject, inputError) {
    if (typeof finalState === "function") {
        inputError = bindObject;
        bindObject = done;
        done = finalState;
        finalState = null;
    }
    var self = this;
    var state = self.states[self.currentState];
    state.fn.call(bindObject || self, inputError, function(err) {
        if (err) {
            if (state.fail) self.currentState = state.fail;
            else return done ? done.call(bindObject, err) : null;
        } else {
            if (state.accept) self.currentState = state.accept;
            else return done ? done.call(bindObject) : null;
        }
        if (self.currentState === finalState) return done ? done.call(bindObject, err) : null;
        self.runTo(finalState, done, bindObject, err);
    });
};
$cb66d49462fb2fc1$var$AcceptorStateMachine.prototype.addState = function addState(name, acceptState, failState, fn) {
    if (typeof acceptState === "function") {
        fn = acceptState;
        acceptState = null;
        failState = null;
    } else if (typeof failState === "function") {
        fn = failState;
        failState = null;
    }
    if (!this.currentState) this.currentState = name;
    this.states[name] = {
        accept: acceptState,
        fail: failState,
        fn: fn
    };
    return this;
};
/**
 * @api private
 */ module.exports = $cb66d49462fb2fc1$var$AcceptorStateMachine;

});

parcelRequire.register("lxybn", function(module, exports) {
(function(exports1) {
    "use strict";
    function isArray(obj) {
        if (obj !== null) return Object.prototype.toString.call(obj) === "[object Array]";
        else return false;
    }
    function isObject(obj) {
        if (obj !== null) return Object.prototype.toString.call(obj) === "[object Object]";
        else return false;
    }
    function strictDeepEqual(first, second) {
        // Check the scalar case first.
        if (first === second) return true;
        // Check if they are the same type.
        var firstType = Object.prototype.toString.call(first);
        if (firstType !== Object.prototype.toString.call(second)) return false;
        // We know that first and second have the same type so we can just check the
        // first type from now on.
        if (isArray(first) === true) {
            // Short circuit if they're not the same length;
            if (first.length !== second.length) return false;
            for(var i = 0; i < first.length; i++){
                if (strictDeepEqual(first[i], second[i]) === false) return false;
            }
            return true;
        }
        if (isObject(first) === true) {
            // An object is equal if it has the same key/value pairs.
            var keysSeen = {};
            for(var key in first)if (hasOwnProperty.call(first, key)) {
                if (strictDeepEqual(first[key], second[key]) === false) return false;
                keysSeen[key] = true;
            }
            // Now check that there aren't any keys in second that weren't
            // in first.
            for(var key2 in second)if (hasOwnProperty.call(second, key2)) {
                if (keysSeen[key2] !== true) return false;
            }
            return true;
        }
        return false;
    }
    function isFalse(obj) {
        // From the spec:
        // A false value corresponds to the following values:
        // Empty list
        // Empty object
        // Empty string
        // False boolean
        // null value
        // First check the scalar values.
        if (obj === "" || obj === false || obj === null) return true;
        else if (isArray(obj) && obj.length === 0) // Check for an empty array.
        return true;
        else if (isObject(obj)) {
            // Check for an empty object.
            for(var key in obj){
                // If there are any keys, then
                // the object is not empty so the object
                // is not false.
                if (obj.hasOwnProperty(key)) return false;
            }
            return true;
        } else return false;
    }
    function objValues(obj) {
        var keys = Object.keys(obj);
        var values = [];
        for(var i = 0; i < keys.length; i++)values.push(obj[keys[i]]);
        return values;
    }
    function merge(a, b) {
        var merged = {};
        for(var key in a)merged[key] = a[key];
        for(var key2 in b)merged[key2] = b[key2];
        return merged;
    }
    var trimLeft;
    if (typeof String.prototype.trimLeft === "function") trimLeft = function(str) {
        return str.trimLeft();
    };
    else trimLeft = function(str) {
        return str.match(/^\s*(.*)/)[1];
    };
    // Type constants used to define functions.
    var TYPE_NUMBER = 0;
    var TYPE_ANY = 1;
    var TYPE_STRING = 2;
    var TYPE_ARRAY = 3;
    var TYPE_OBJECT = 4;
    var TYPE_BOOLEAN = 5;
    var TYPE_EXPREF = 6;
    var TYPE_NULL = 7;
    var TYPE_ARRAY_NUMBER = 8;
    var TYPE_ARRAY_STRING = 9;
    var TOK_EOF = "EOF";
    var TOK_UNQUOTEDIDENTIFIER = "UnquotedIdentifier";
    var TOK_QUOTEDIDENTIFIER = "QuotedIdentifier";
    var TOK_RBRACKET = "Rbracket";
    var TOK_RPAREN = "Rparen";
    var TOK_COMMA = "Comma";
    var TOK_COLON = "Colon";
    var TOK_RBRACE = "Rbrace";
    var TOK_NUMBER = "Number";
    var TOK_CURRENT = "Current";
    var TOK_EXPREF = "Expref";
    var TOK_PIPE = "Pipe";
    var TOK_OR = "Or";
    var TOK_AND = "And";
    var TOK_EQ = "EQ";
    var TOK_GT = "GT";
    var TOK_LT = "LT";
    var TOK_GTE = "GTE";
    var TOK_LTE = "LTE";
    var TOK_NE = "NE";
    var TOK_FLATTEN = "Flatten";
    var TOK_STAR = "Star";
    var TOK_FILTER = "Filter";
    var TOK_DOT = "Dot";
    var TOK_NOT = "Not";
    var TOK_LBRACE = "Lbrace";
    var TOK_LBRACKET = "Lbracket";
    var TOK_LPAREN = "Lparen";
    var TOK_LITERAL = "Literal";
    // The "&", "[", "<", ">" tokens
    // are not in basicToken because
    // there are two token variants
    // ("&&", "[?", "<=", ">=").  This is specially handled
    // below.
    var basicTokens = {
        ".": TOK_DOT,
        "*": TOK_STAR,
        ",": TOK_COMMA,
        ":": TOK_COLON,
        "{": TOK_LBRACE,
        "}": TOK_RBRACE,
        "]": TOK_RBRACKET,
        "(": TOK_LPAREN,
        ")": TOK_RPAREN,
        "@": TOK_CURRENT
    };
    var operatorStartToken = {
        "<": true,
        ">": true,
        "=": true,
        "!": true
    };
    var skipChars = {
        " ": true,
        "	": true,
        "\n": true
    };
    function isAlpha(ch) {
        return ch >= "a" && ch <= "z" || ch >= "A" && ch <= "Z" || ch === "_";
    }
    function isNum(ch) {
        return ch >= "0" && ch <= "9" || ch === "-";
    }
    function isAlphaNum(ch) {
        return ch >= "a" && ch <= "z" || ch >= "A" && ch <= "Z" || ch >= "0" && ch <= "9" || ch === "_";
    }
    function Lexer() {}
    Lexer.prototype = {
        tokenize: function(stream) {
            var tokens = [];
            this._current = 0;
            var start;
            var identifier;
            var token;
            while(this._current < stream.length){
                if (isAlpha(stream[this._current])) {
                    start = this._current;
                    identifier = this._consumeUnquotedIdentifier(stream);
                    tokens.push({
                        type: TOK_UNQUOTEDIDENTIFIER,
                        value: identifier,
                        start: start
                    });
                } else if (basicTokens[stream[this._current]] !== undefined) {
                    tokens.push({
                        type: basicTokens[stream[this._current]],
                        value: stream[this._current],
                        start: this._current
                    });
                    this._current++;
                } else if (isNum(stream[this._current])) {
                    token = this._consumeNumber(stream);
                    tokens.push(token);
                } else if (stream[this._current] === "[") {
                    // No need to increment this._current.  This happens
                    // in _consumeLBracket
                    token = this._consumeLBracket(stream);
                    tokens.push(token);
                } else if (stream[this._current] === '"') {
                    start = this._current;
                    identifier = this._consumeQuotedIdentifier(stream);
                    tokens.push({
                        type: TOK_QUOTEDIDENTIFIER,
                        value: identifier,
                        start: start
                    });
                } else if (stream[this._current] === "'") {
                    start = this._current;
                    identifier = this._consumeRawStringLiteral(stream);
                    tokens.push({
                        type: TOK_LITERAL,
                        value: identifier,
                        start: start
                    });
                } else if (stream[this._current] === "`") {
                    start = this._current;
                    var literal = this._consumeLiteral(stream);
                    tokens.push({
                        type: TOK_LITERAL,
                        value: literal,
                        start: start
                    });
                } else if (operatorStartToken[stream[this._current]] !== undefined) tokens.push(this._consumeOperator(stream));
                else if (skipChars[stream[this._current]] !== undefined) // Ignore whitespace.
                this._current++;
                else if (stream[this._current] === "&") {
                    start = this._current;
                    this._current++;
                    if (stream[this._current] === "&") {
                        this._current++;
                        tokens.push({
                            type: TOK_AND,
                            value: "&&",
                            start: start
                        });
                    } else tokens.push({
                        type: TOK_EXPREF,
                        value: "&",
                        start: start
                    });
                } else if (stream[this._current] === "|") {
                    start = this._current;
                    this._current++;
                    if (stream[this._current] === "|") {
                        this._current++;
                        tokens.push({
                            type: TOK_OR,
                            value: "||",
                            start: start
                        });
                    } else tokens.push({
                        type: TOK_PIPE,
                        value: "|",
                        start: start
                    });
                } else {
                    var error = new Error("Unknown character:" + stream[this._current]);
                    error.name = "LexerError";
                    throw error;
                }
            }
            return tokens;
        },
        _consumeUnquotedIdentifier: function(stream) {
            var start = this._current;
            this._current++;
            while(this._current < stream.length && isAlphaNum(stream[this._current]))this._current++;
            return stream.slice(start, this._current);
        },
        _consumeQuotedIdentifier: function(stream) {
            var start = this._current;
            this._current++;
            var maxLength = stream.length;
            while(stream[this._current] !== '"' && this._current < maxLength){
                // You can escape a double quote and you can escape an escape.
                var current = this._current;
                if (stream[current] === "\\" && (stream[current + 1] === "\\" || stream[current + 1] === '"')) current += 2;
                else current++;
                this._current = current;
            }
            this._current++;
            return JSON.parse(stream.slice(start, this._current));
        },
        _consumeRawStringLiteral: function(stream) {
            var start = this._current;
            this._current++;
            var maxLength = stream.length;
            while(stream[this._current] !== "'" && this._current < maxLength){
                // You can escape a single quote and you can escape an escape.
                var current = this._current;
                if (stream[current] === "\\" && (stream[current + 1] === "\\" || stream[current + 1] === "'")) current += 2;
                else current++;
                this._current = current;
            }
            this._current++;
            var literal = stream.slice(start + 1, this._current - 1);
            return literal.replace("\\'", "'");
        },
        _consumeNumber: function(stream) {
            var start = this._current;
            this._current++;
            var maxLength = stream.length;
            while(isNum(stream[this._current]) && this._current < maxLength)this._current++;
            var value = parseInt(stream.slice(start, this._current));
            return {
                type: TOK_NUMBER,
                value: value,
                start: start
            };
        },
        _consumeLBracket: function(stream) {
            var start = this._current;
            this._current++;
            if (stream[this._current] === "?") {
                this._current++;
                return {
                    type: TOK_FILTER,
                    value: "[?",
                    start: start
                };
            } else if (stream[this._current] === "]") {
                this._current++;
                return {
                    type: TOK_FLATTEN,
                    value: "[]",
                    start: start
                };
            } else return {
                type: TOK_LBRACKET,
                value: "[",
                start: start
            };
        },
        _consumeOperator: function(stream) {
            var start = this._current;
            var startingChar = stream[start];
            this._current++;
            if (startingChar === "!") {
                if (stream[this._current] === "=") {
                    this._current++;
                    return {
                        type: TOK_NE,
                        value: "!=",
                        start: start
                    };
                } else return {
                    type: TOK_NOT,
                    value: "!",
                    start: start
                };
            } else if (startingChar === "<") {
                if (stream[this._current] === "=") {
                    this._current++;
                    return {
                        type: TOK_LTE,
                        value: "<=",
                        start: start
                    };
                } else return {
                    type: TOK_LT,
                    value: "<",
                    start: start
                };
            } else if (startingChar === ">") {
                if (stream[this._current] === "=") {
                    this._current++;
                    return {
                        type: TOK_GTE,
                        value: ">=",
                        start: start
                    };
                } else return {
                    type: TOK_GT,
                    value: ">",
                    start: start
                };
            } else if (startingChar === "=") {
                if (stream[this._current] === "=") {
                    this._current++;
                    return {
                        type: TOK_EQ,
                        value: "==",
                        start: start
                    };
                }
            }
        },
        _consumeLiteral: function(stream) {
            this._current++;
            var start = this._current;
            var maxLength = stream.length;
            var literal;
            while(stream[this._current] !== "`" && this._current < maxLength){
                // You can escape a literal char or you can escape the escape.
                var current = this._current;
                if (stream[current] === "\\" && (stream[current + 1] === "\\" || stream[current + 1] === "`")) current += 2;
                else current++;
                this._current = current;
            }
            var literalString = trimLeft(stream.slice(start, this._current));
            literalString = literalString.replace("\\`", "`");
            if (this._looksLikeJSON(literalString)) literal = JSON.parse(literalString);
            else // Try to JSON parse it as "<literal>"
            literal = JSON.parse('"' + literalString + '"');
            // +1 gets us to the ending "`", +1 to move on to the next char.
            this._current++;
            return literal;
        },
        _looksLikeJSON: function(literalString) {
            var startingChars = '[{"';
            var jsonLiterals = [
                "true",
                "false",
                "null"
            ];
            var numberLooking = "-0123456789";
            if (literalString === "") return false;
            else if (startingChars.indexOf(literalString[0]) >= 0) return true;
            else if (jsonLiterals.indexOf(literalString) >= 0) return true;
            else if (numberLooking.indexOf(literalString[0]) >= 0) try {
                JSON.parse(literalString);
                return true;
            } catch (ex) {
                return false;
            }
            else return false;
        }
    };
    var bindingPower = {};
    bindingPower[TOK_EOF] = 0;
    bindingPower[TOK_UNQUOTEDIDENTIFIER] = 0;
    bindingPower[TOK_QUOTEDIDENTIFIER] = 0;
    bindingPower[TOK_RBRACKET] = 0;
    bindingPower[TOK_RPAREN] = 0;
    bindingPower[TOK_COMMA] = 0;
    bindingPower[TOK_RBRACE] = 0;
    bindingPower[TOK_NUMBER] = 0;
    bindingPower[TOK_CURRENT] = 0;
    bindingPower[TOK_EXPREF] = 0;
    bindingPower[TOK_PIPE] = 1;
    bindingPower[TOK_OR] = 2;
    bindingPower[TOK_AND] = 3;
    bindingPower[TOK_EQ] = 5;
    bindingPower[TOK_GT] = 5;
    bindingPower[TOK_LT] = 5;
    bindingPower[TOK_GTE] = 5;
    bindingPower[TOK_LTE] = 5;
    bindingPower[TOK_NE] = 5;
    bindingPower[TOK_FLATTEN] = 9;
    bindingPower[TOK_STAR] = 20;
    bindingPower[TOK_FILTER] = 21;
    bindingPower[TOK_DOT] = 40;
    bindingPower[TOK_NOT] = 45;
    bindingPower[TOK_LBRACE] = 50;
    bindingPower[TOK_LBRACKET] = 55;
    bindingPower[TOK_LPAREN] = 60;
    function Parser() {}
    Parser.prototype = {
        parse: function(expression) {
            this._loadTokens(expression);
            this.index = 0;
            var ast = this.expression(0);
            if (this._lookahead(0) !== TOK_EOF) {
                var t = this._lookaheadToken(0);
                var error = new Error("Unexpected token type: " + t.type + ", value: " + t.value);
                error.name = "ParserError";
                throw error;
            }
            return ast;
        },
        _loadTokens: function(expression) {
            var lexer = new Lexer();
            var tokens = lexer.tokenize(expression);
            tokens.push({
                type: TOK_EOF,
                value: "",
                start: expression.length
            });
            this.tokens = tokens;
        },
        expression: function(rbp) {
            var leftToken = this._lookaheadToken(0);
            this._advance();
            var left = this.nud(leftToken);
            var currentToken = this._lookahead(0);
            while(rbp < bindingPower[currentToken]){
                this._advance();
                left = this.led(currentToken, left);
                currentToken = this._lookahead(0);
            }
            return left;
        },
        _lookahead: function(number) {
            return this.tokens[this.index + number].type;
        },
        _lookaheadToken: function(number) {
            return this.tokens[this.index + number];
        },
        _advance: function() {
            this.index++;
        },
        nud: function(token) {
            var left;
            var right;
            var expression;
            switch(token.type){
                case TOK_LITERAL:
                    return {
                        type: "Literal",
                        value: token.value
                    };
                case TOK_UNQUOTEDIDENTIFIER:
                    return {
                        type: "Field",
                        name: token.value
                    };
                case TOK_QUOTEDIDENTIFIER:
                    var node = {
                        type: "Field",
                        name: token.value
                    };
                    if (this._lookahead(0) === TOK_LPAREN) throw new Error("Quoted identifier not allowed for function names.");
                    else return node;
                    break;
                case TOK_NOT:
                    right = this.expression(bindingPower.Not);
                    return {
                        type: "NotExpression",
                        children: [
                            right
                        ]
                    };
                case TOK_STAR:
                    left = {
                        type: "Identity"
                    };
                    right = null;
                    if (this._lookahead(0) === TOK_RBRACKET) // This can happen in a multiselect,
                    // [a, b, *]
                    right = {
                        type: "Identity"
                    };
                    else right = this._parseProjectionRHS(bindingPower.Star);
                    return {
                        type: "ValueProjection",
                        children: [
                            left,
                            right
                        ]
                    };
                case TOK_FILTER:
                    return this.led(token.type, {
                        type: "Identity"
                    });
                case TOK_LBRACE:
                    return this._parseMultiselectHash();
                case TOK_FLATTEN:
                    left = {
                        type: TOK_FLATTEN,
                        children: [
                            {
                                type: "Identity"
                            }
                        ]
                    };
                    right = this._parseProjectionRHS(bindingPower.Flatten);
                    return {
                        type: "Projection",
                        children: [
                            left,
                            right
                        ]
                    };
                case TOK_LBRACKET:
                    if (this._lookahead(0) === TOK_NUMBER || this._lookahead(0) === TOK_COLON) {
                        right = this._parseIndexExpression();
                        return this._projectIfSlice({
                            type: "Identity"
                        }, right);
                    } else if (this._lookahead(0) === TOK_STAR && this._lookahead(1) === TOK_RBRACKET) {
                        this._advance();
                        this._advance();
                        right = this._parseProjectionRHS(bindingPower.Star);
                        return {
                            type: "Projection",
                            children: [
                                {
                                    type: "Identity"
                                },
                                right
                            ]
                        };
                    } else return this._parseMultiselectList();
                    break;
                case TOK_CURRENT:
                    return {
                        type: TOK_CURRENT
                    };
                case TOK_EXPREF:
                    expression = this.expression(bindingPower.Expref);
                    return {
                        type: "ExpressionReference",
                        children: [
                            expression
                        ]
                    };
                case TOK_LPAREN:
                    var args = [];
                    while(this._lookahead(0) !== TOK_RPAREN){
                        if (this._lookahead(0) === TOK_CURRENT) {
                            expression = {
                                type: TOK_CURRENT
                            };
                            this._advance();
                        } else expression = this.expression(0);
                        args.push(expression);
                    }
                    this._match(TOK_RPAREN);
                    return args[0];
                default:
                    this._errorToken(token);
            }
        },
        led: function(tokenName, left) {
            var right;
            switch(tokenName){
                case TOK_DOT:
                    var rbp = bindingPower.Dot;
                    if (this._lookahead(0) !== TOK_STAR) {
                        right = this._parseDotRHS(rbp);
                        return {
                            type: "Subexpression",
                            children: [
                                left,
                                right
                            ]
                        };
                    } else {
                        // Creating a projection.
                        this._advance();
                        right = this._parseProjectionRHS(rbp);
                        return {
                            type: "ValueProjection",
                            children: [
                                left,
                                right
                            ]
                        };
                    }
                    break;
                case TOK_PIPE:
                    right = this.expression(bindingPower.Pipe);
                    return {
                        type: TOK_PIPE,
                        children: [
                            left,
                            right
                        ]
                    };
                case TOK_OR:
                    right = this.expression(bindingPower.Or);
                    return {
                        type: "OrExpression",
                        children: [
                            left,
                            right
                        ]
                    };
                case TOK_AND:
                    right = this.expression(bindingPower.And);
                    return {
                        type: "AndExpression",
                        children: [
                            left,
                            right
                        ]
                    };
                case TOK_LPAREN:
                    var name = left.name;
                    var args = [];
                    var expression, node;
                    while(this._lookahead(0) !== TOK_RPAREN){
                        if (this._lookahead(0) === TOK_CURRENT) {
                            expression = {
                                type: TOK_CURRENT
                            };
                            this._advance();
                        } else expression = this.expression(0);
                        if (this._lookahead(0) === TOK_COMMA) this._match(TOK_COMMA);
                        args.push(expression);
                    }
                    this._match(TOK_RPAREN);
                    node = {
                        type: "Function",
                        name: name,
                        children: args
                    };
                    return node;
                case TOK_FILTER:
                    var condition = this.expression(0);
                    this._match(TOK_RBRACKET);
                    if (this._lookahead(0) === TOK_FLATTEN) right = {
                        type: "Identity"
                    };
                    else right = this._parseProjectionRHS(bindingPower.Filter);
                    return {
                        type: "FilterProjection",
                        children: [
                            left,
                            right,
                            condition
                        ]
                    };
                case TOK_FLATTEN:
                    var leftNode = {
                        type: TOK_FLATTEN,
                        children: [
                            left
                        ]
                    };
                    var rightNode = this._parseProjectionRHS(bindingPower.Flatten);
                    return {
                        type: "Projection",
                        children: [
                            leftNode,
                            rightNode
                        ]
                    };
                case TOK_EQ:
                case TOK_NE:
                case TOK_GT:
                case TOK_GTE:
                case TOK_LT:
                case TOK_LTE:
                    return this._parseComparator(left, tokenName);
                case TOK_LBRACKET:
                    var token = this._lookaheadToken(0);
                    if (token.type === TOK_NUMBER || token.type === TOK_COLON) {
                        right = this._parseIndexExpression();
                        return this._projectIfSlice(left, right);
                    } else {
                        this._match(TOK_STAR);
                        this._match(TOK_RBRACKET);
                        right = this._parseProjectionRHS(bindingPower.Star);
                        return {
                            type: "Projection",
                            children: [
                                left,
                                right
                            ]
                        };
                    }
                    break;
                default:
                    this._errorToken(this._lookaheadToken(0));
            }
        },
        _match: function(tokenType) {
            if (this._lookahead(0) === tokenType) this._advance();
            else {
                var t = this._lookaheadToken(0);
                var error = new Error("Expected " + tokenType + ", got: " + t.type);
                error.name = "ParserError";
                throw error;
            }
        },
        _errorToken: function(token) {
            var error = new Error("Invalid token (" + token.type + '): "' + token.value + '"');
            error.name = "ParserError";
            throw error;
        },
        _parseIndexExpression: function() {
            if (this._lookahead(0) === TOK_COLON || this._lookahead(1) === TOK_COLON) return this._parseSliceExpression();
            else {
                var node = {
                    type: "Index",
                    value: this._lookaheadToken(0).value
                };
                this._advance();
                this._match(TOK_RBRACKET);
                return node;
            }
        },
        _projectIfSlice: function(left, right) {
            var indexExpr = {
                type: "IndexExpression",
                children: [
                    left,
                    right
                ]
            };
            if (right.type === "Slice") return {
                type: "Projection",
                children: [
                    indexExpr,
                    this._parseProjectionRHS(bindingPower.Star)
                ]
            };
            else return indexExpr;
        },
        _parseSliceExpression: function() {
            // [start:end:step] where each part is optional, as well as the last
            // colon.
            var parts = [
                null,
                null,
                null
            ];
            var index = 0;
            var currentToken = this._lookahead(0);
            while(currentToken !== TOK_RBRACKET && index < 3){
                if (currentToken === TOK_COLON) {
                    index++;
                    this._advance();
                } else if (currentToken === TOK_NUMBER) {
                    parts[index] = this._lookaheadToken(0).value;
                    this._advance();
                } else {
                    var t = this._lookahead(0);
                    var error = new Error("Syntax error, unexpected token: " + t.value + "(" + t.type + ")");
                    error.name = "Parsererror";
                    throw error;
                }
                currentToken = this._lookahead(0);
            }
            this._match(TOK_RBRACKET);
            return {
                type: "Slice",
                children: parts
            };
        },
        _parseComparator: function(left, comparator) {
            var right = this.expression(bindingPower[comparator]);
            return {
                type: "Comparator",
                name: comparator,
                children: [
                    left,
                    right
                ]
            };
        },
        _parseDotRHS: function(rbp) {
            var lookahead = this._lookahead(0);
            var exprTokens = [
                TOK_UNQUOTEDIDENTIFIER,
                TOK_QUOTEDIDENTIFIER,
                TOK_STAR
            ];
            if (exprTokens.indexOf(lookahead) >= 0) return this.expression(rbp);
            else if (lookahead === TOK_LBRACKET) {
                this._match(TOK_LBRACKET);
                return this._parseMultiselectList();
            } else if (lookahead === TOK_LBRACE) {
                this._match(TOK_LBRACE);
                return this._parseMultiselectHash();
            }
        },
        _parseProjectionRHS: function(rbp) {
            var right;
            if (bindingPower[this._lookahead(0)] < 10) right = {
                type: "Identity"
            };
            else if (this._lookahead(0) === TOK_LBRACKET) right = this.expression(rbp);
            else if (this._lookahead(0) === TOK_FILTER) right = this.expression(rbp);
            else if (this._lookahead(0) === TOK_DOT) {
                this._match(TOK_DOT);
                right = this._parseDotRHS(rbp);
            } else {
                var t = this._lookaheadToken(0);
                var error = new Error("Sytanx error, unexpected token: " + t.value + "(" + t.type + ")");
                error.name = "ParserError";
                throw error;
            }
            return right;
        },
        _parseMultiselectList: function() {
            var expressions = [];
            while(this._lookahead(0) !== TOK_RBRACKET){
                var expression = this.expression(0);
                expressions.push(expression);
                if (this._lookahead(0) === TOK_COMMA) {
                    this._match(TOK_COMMA);
                    if (this._lookahead(0) === TOK_RBRACKET) throw new Error("Unexpected token Rbracket");
                }
            }
            this._match(TOK_RBRACKET);
            return {
                type: "MultiSelectList",
                children: expressions
            };
        },
        _parseMultiselectHash: function() {
            var pairs = [];
            var identifierTypes = [
                TOK_UNQUOTEDIDENTIFIER,
                TOK_QUOTEDIDENTIFIER
            ];
            var keyToken, keyName, value, node;
            for(;;){
                keyToken = this._lookaheadToken(0);
                if (identifierTypes.indexOf(keyToken.type) < 0) throw new Error("Expecting an identifier token, got: " + keyToken.type);
                keyName = keyToken.value;
                this._advance();
                this._match(TOK_COLON);
                value = this.expression(0);
                node = {
                    type: "KeyValuePair",
                    name: keyName,
                    value: value
                };
                pairs.push(node);
                if (this._lookahead(0) === TOK_COMMA) this._match(TOK_COMMA);
                else if (this._lookahead(0) === TOK_RBRACE) {
                    this._match(TOK_RBRACE);
                    break;
                }
            }
            return {
                type: "MultiSelectHash",
                children: pairs
            };
        }
    };
    function TreeInterpreter(runtime) {
        this.runtime = runtime;
    }
    TreeInterpreter.prototype = {
        search: function(node, value) {
            return this.visit(node, value);
        },
        visit: function(node, value) {
            var matched, current, result, first, second, field, left, right, collected, i;
            switch(node.type){
                case "Field":
                    if (value === null) return null;
                    else if (isObject(value)) {
                        field = value[node.name];
                        if (field === undefined) return null;
                        else return field;
                    } else return null;
                    break;
                case "Subexpression":
                    result = this.visit(node.children[0], value);
                    for(i = 1; i < node.children.length; i++){
                        result = this.visit(node.children[1], result);
                        if (result === null) return null;
                    }
                    return result;
                case "IndexExpression":
                    left = this.visit(node.children[0], value);
                    right = this.visit(node.children[1], left);
                    return right;
                case "Index":
                    if (!isArray(value)) return null;
                    var index = node.value;
                    if (index < 0) index = value.length + index;
                    result = value[index];
                    if (result === undefined) result = null;
                    return result;
                case "Slice":
                    if (!isArray(value)) return null;
                    var sliceParams = node.children.slice(0);
                    var computed = this.computeSliceParams(value.length, sliceParams);
                    var start = computed[0];
                    var stop = computed[1];
                    var step = computed[2];
                    result = [];
                    if (step > 0) for(i = start; i < stop; i += step)result.push(value[i]);
                    else for(i = start; i > stop; i += step)result.push(value[i]);
                    return result;
                case "Projection":
                    // Evaluate left child.
                    var base = this.visit(node.children[0], value);
                    if (!isArray(base)) return null;
                    collected = [];
                    for(i = 0; i < base.length; i++){
                        current = this.visit(node.children[1], base[i]);
                        if (current !== null) collected.push(current);
                    }
                    return collected;
                case "ValueProjection":
                    // Evaluate left child.
                    base = this.visit(node.children[0], value);
                    if (!isObject(base)) return null;
                    collected = [];
                    var values = objValues(base);
                    for(i = 0; i < values.length; i++){
                        current = this.visit(node.children[1], values[i]);
                        if (current !== null) collected.push(current);
                    }
                    return collected;
                case "FilterProjection":
                    base = this.visit(node.children[0], value);
                    if (!isArray(base)) return null;
                    var filtered = [];
                    var finalResults = [];
                    for(i = 0; i < base.length; i++){
                        matched = this.visit(node.children[2], base[i]);
                        if (!isFalse(matched)) filtered.push(base[i]);
                    }
                    for(var j = 0; j < filtered.length; j++){
                        current = this.visit(node.children[1], filtered[j]);
                        if (current !== null) finalResults.push(current);
                    }
                    return finalResults;
                case "Comparator":
                    first = this.visit(node.children[0], value);
                    second = this.visit(node.children[1], value);
                    switch(node.name){
                        case TOK_EQ:
                            result = strictDeepEqual(first, second);
                            break;
                        case TOK_NE:
                            result = !strictDeepEqual(first, second);
                            break;
                        case TOK_GT:
                            result = first > second;
                            break;
                        case TOK_GTE:
                            result = first >= second;
                            break;
                        case TOK_LT:
                            result = first < second;
                            break;
                        case TOK_LTE:
                            result = first <= second;
                            break;
                        default:
                            throw new Error("Unknown comparator: " + node.name);
                    }
                    return result;
                case TOK_FLATTEN:
                    var original = this.visit(node.children[0], value);
                    if (!isArray(original)) return null;
                    var merged = [];
                    for(i = 0; i < original.length; i++){
                        current = original[i];
                        if (isArray(current)) merged.push.apply(merged, current);
                        else merged.push(current);
                    }
                    return merged;
                case "Identity":
                    return value;
                case "MultiSelectList":
                    if (value === null) return null;
                    collected = [];
                    for(i = 0; i < node.children.length; i++)collected.push(this.visit(node.children[i], value));
                    return collected;
                case "MultiSelectHash":
                    if (value === null) return null;
                    collected = {};
                    var child;
                    for(i = 0; i < node.children.length; i++){
                        child = node.children[i];
                        collected[child.name] = this.visit(child.value, value);
                    }
                    return collected;
                case "OrExpression":
                    matched = this.visit(node.children[0], value);
                    if (isFalse(matched)) matched = this.visit(node.children[1], value);
                    return matched;
                case "AndExpression":
                    first = this.visit(node.children[0], value);
                    if (isFalse(first) === true) return first;
                    return this.visit(node.children[1], value);
                case "NotExpression":
                    first = this.visit(node.children[0], value);
                    return isFalse(first);
                case "Literal":
                    return node.value;
                case TOK_PIPE:
                    left = this.visit(node.children[0], value);
                    return this.visit(node.children[1], left);
                case TOK_CURRENT:
                    return value;
                case "Function":
                    var resolvedArgs = [];
                    for(i = 0; i < node.children.length; i++)resolvedArgs.push(this.visit(node.children[i], value));
                    return this.runtime.callFunction(node.name, resolvedArgs);
                case "ExpressionReference":
                    var refNode = node.children[0];
                    // Tag the node with a specific attribute so the type
                    // checker verify the type.
                    refNode.jmespathType = TOK_EXPREF;
                    return refNode;
                default:
                    throw new Error("Unknown node type: " + node.type);
            }
        },
        computeSliceParams: function(arrayLength, sliceParams) {
            var start = sliceParams[0];
            var stop = sliceParams[1];
            var step = sliceParams[2];
            var computed = [
                null,
                null,
                null
            ];
            if (step === null) step = 1;
            else if (step === 0) {
                var error = new Error("Invalid slice, step cannot be 0");
                error.name = "RuntimeError";
                throw error;
            }
            var stepValueNegative = step < 0 ? true : false;
            if (start === null) start = stepValueNegative ? arrayLength - 1 : 0;
            else start = this.capSliceRange(arrayLength, start, step);
            if (stop === null) stop = stepValueNegative ? -1 : arrayLength;
            else stop = this.capSliceRange(arrayLength, stop, step);
            computed[0] = start;
            computed[1] = stop;
            computed[2] = step;
            return computed;
        },
        capSliceRange: function(arrayLength, actualValue, step) {
            if (actualValue < 0) {
                actualValue += arrayLength;
                if (actualValue < 0) actualValue = step < 0 ? -1 : 0;
            } else if (actualValue >= arrayLength) actualValue = step < 0 ? arrayLength - 1 : arrayLength;
            return actualValue;
        }
    };
    function Runtime(interpreter) {
        this._interpreter = interpreter;
        this.functionTable = {
            // name: [function, <signature>]
            // The <signature> can be:
            //
            // {
            //   args: [[type1, type2], [type1, type2]],
            //   variadic: true|false
            // }
            //
            // Each arg in the arg list is a list of valid types
            // (if the function is overloaded and supports multiple
            // types.  If the type is "any" then no type checking
            // occurs on the argument.  Variadic is optional
            // and if not provided is assumed to be false.
            abs: {
                _func: this._functionAbs,
                _signature: [
                    {
                        types: [
                            TYPE_NUMBER
                        ]
                    }
                ]
            },
            avg: {
                _func: this._functionAvg,
                _signature: [
                    {
                        types: [
                            TYPE_ARRAY_NUMBER
                        ]
                    }
                ]
            },
            ceil: {
                _func: this._functionCeil,
                _signature: [
                    {
                        types: [
                            TYPE_NUMBER
                        ]
                    }
                ]
            },
            contains: {
                _func: this._functionContains,
                _signature: [
                    {
                        types: [
                            TYPE_STRING,
                            TYPE_ARRAY
                        ]
                    },
                    {
                        types: [
                            TYPE_ANY
                        ]
                    }
                ]
            },
            "ends_with": {
                _func: this._functionEndsWith,
                _signature: [
                    {
                        types: [
                            TYPE_STRING
                        ]
                    },
                    {
                        types: [
                            TYPE_STRING
                        ]
                    }
                ]
            },
            floor: {
                _func: this._functionFloor,
                _signature: [
                    {
                        types: [
                            TYPE_NUMBER
                        ]
                    }
                ]
            },
            length: {
                _func: this._functionLength,
                _signature: [
                    {
                        types: [
                            TYPE_STRING,
                            TYPE_ARRAY,
                            TYPE_OBJECT
                        ]
                    }
                ]
            },
            map: {
                _func: this._functionMap,
                _signature: [
                    {
                        types: [
                            TYPE_EXPREF
                        ]
                    },
                    {
                        types: [
                            TYPE_ARRAY
                        ]
                    }
                ]
            },
            max: {
                _func: this._functionMax,
                _signature: [
                    {
                        types: [
                            TYPE_ARRAY_NUMBER,
                            TYPE_ARRAY_STRING
                        ]
                    }
                ]
            },
            "merge": {
                _func: this._functionMerge,
                _signature: [
                    {
                        types: [
                            TYPE_OBJECT
                        ],
                        variadic: true
                    }
                ]
            },
            "max_by": {
                _func: this._functionMaxBy,
                _signature: [
                    {
                        types: [
                            TYPE_ARRAY
                        ]
                    },
                    {
                        types: [
                            TYPE_EXPREF
                        ]
                    }
                ]
            },
            sum: {
                _func: this._functionSum,
                _signature: [
                    {
                        types: [
                            TYPE_ARRAY_NUMBER
                        ]
                    }
                ]
            },
            "starts_with": {
                _func: this._functionStartsWith,
                _signature: [
                    {
                        types: [
                            TYPE_STRING
                        ]
                    },
                    {
                        types: [
                            TYPE_STRING
                        ]
                    }
                ]
            },
            min: {
                _func: this._functionMin,
                _signature: [
                    {
                        types: [
                            TYPE_ARRAY_NUMBER,
                            TYPE_ARRAY_STRING
                        ]
                    }
                ]
            },
            "min_by": {
                _func: this._functionMinBy,
                _signature: [
                    {
                        types: [
                            TYPE_ARRAY
                        ]
                    },
                    {
                        types: [
                            TYPE_EXPREF
                        ]
                    }
                ]
            },
            type: {
                _func: this._functionType,
                _signature: [
                    {
                        types: [
                            TYPE_ANY
                        ]
                    }
                ]
            },
            keys: {
                _func: this._functionKeys,
                _signature: [
                    {
                        types: [
                            TYPE_OBJECT
                        ]
                    }
                ]
            },
            values: {
                _func: this._functionValues,
                _signature: [
                    {
                        types: [
                            TYPE_OBJECT
                        ]
                    }
                ]
            },
            sort: {
                _func: this._functionSort,
                _signature: [
                    {
                        types: [
                            TYPE_ARRAY_STRING,
                            TYPE_ARRAY_NUMBER
                        ]
                    }
                ]
            },
            "sort_by": {
                _func: this._functionSortBy,
                _signature: [
                    {
                        types: [
                            TYPE_ARRAY
                        ]
                    },
                    {
                        types: [
                            TYPE_EXPREF
                        ]
                    }
                ]
            },
            join: {
                _func: this._functionJoin,
                _signature: [
                    {
                        types: [
                            TYPE_STRING
                        ]
                    },
                    {
                        types: [
                            TYPE_ARRAY_STRING
                        ]
                    }
                ]
            },
            reverse: {
                _func: this._functionReverse,
                _signature: [
                    {
                        types: [
                            TYPE_STRING,
                            TYPE_ARRAY
                        ]
                    }
                ]
            },
            "to_array": {
                _func: this._functionToArray,
                _signature: [
                    {
                        types: [
                            TYPE_ANY
                        ]
                    }
                ]
            },
            "to_string": {
                _func: this._functionToString,
                _signature: [
                    {
                        types: [
                            TYPE_ANY
                        ]
                    }
                ]
            },
            "to_number": {
                _func: this._functionToNumber,
                _signature: [
                    {
                        types: [
                            TYPE_ANY
                        ]
                    }
                ]
            },
            "not_null": {
                _func: this._functionNotNull,
                _signature: [
                    {
                        types: [
                            TYPE_ANY
                        ],
                        variadic: true
                    }
                ]
            }
        };
    }
    Runtime.prototype = {
        callFunction: function(name, resolvedArgs) {
            var functionEntry = this.functionTable[name];
            if (functionEntry === undefined) throw new Error("Unknown function: " + name + "()");
            this._validateArgs(name, resolvedArgs, functionEntry._signature);
            return functionEntry._func.call(this, resolvedArgs);
        },
        _validateArgs: function(name, args, signature) {
            // Validating the args requires validating
            // the correct arity and the correct type of each arg.
            // If the last argument is declared as variadic, then we need
            // a minimum number of args to be required.  Otherwise it has to
            // be an exact amount.
            var pluralized;
            if (signature[signature.length - 1].variadic) {
                if (args.length < signature.length) {
                    pluralized = signature.length === 1 ? " argument" : " arguments";
                    throw new Error("ArgumentError: " + name + "() " + "takes at least" + signature.length + pluralized + " but received " + args.length);
                }
            } else if (args.length !== signature.length) {
                pluralized = signature.length === 1 ? " argument" : " arguments";
                throw new Error("ArgumentError: " + name + "() " + "takes " + signature.length + pluralized + " but received " + args.length);
            }
            var currentSpec;
            var actualType;
            var typeMatched;
            for(var i = 0; i < signature.length; i++){
                typeMatched = false;
                currentSpec = signature[i].types;
                actualType = this._getTypeName(args[i]);
                for(var j = 0; j < currentSpec.length; j++)if (this._typeMatches(actualType, currentSpec[j], args[i])) {
                    typeMatched = true;
                    break;
                }
                if (!typeMatched) throw new Error("TypeError: " + name + "() " + "expected argument " + (i + 1) + " to be type " + currentSpec + " but received type " + actualType + " instead.");
            }
        },
        _typeMatches: function(actual, expected, argValue) {
            if (expected === TYPE_ANY) return true;
            if (expected === TYPE_ARRAY_STRING || expected === TYPE_ARRAY_NUMBER || expected === TYPE_ARRAY) {
                // The expected type can either just be array,
                // or it can require a specific subtype (array of numbers).
                //
                // The simplest case is if "array" with no subtype is specified.
                if (expected === TYPE_ARRAY) return actual === TYPE_ARRAY;
                else if (actual === TYPE_ARRAY) {
                    // Otherwise we need to check subtypes.
                    // I think this has potential to be improved.
                    var subtype;
                    if (expected === TYPE_ARRAY_NUMBER) subtype = TYPE_NUMBER;
                    else if (expected === TYPE_ARRAY_STRING) subtype = TYPE_STRING;
                    for(var i = 0; i < argValue.length; i++){
                        if (!this._typeMatches(this._getTypeName(argValue[i]), subtype, argValue[i])) return false;
                    }
                    return true;
                }
            } else return actual === expected;
        },
        _getTypeName: function(obj) {
            switch(Object.prototype.toString.call(obj)){
                case "[object String]":
                    return TYPE_STRING;
                case "[object Number]":
                    return TYPE_NUMBER;
                case "[object Array]":
                    return TYPE_ARRAY;
                case "[object Boolean]":
                    return TYPE_BOOLEAN;
                case "[object Null]":
                    return TYPE_NULL;
                case "[object Object]":
                    // Check if it's an expref.  If it has, it's been
                    // tagged with a jmespathType attr of 'Expref';
                    if (obj.jmespathType === TOK_EXPREF) return TYPE_EXPREF;
                    else return TYPE_OBJECT;
            }
        },
        _functionStartsWith: function(resolvedArgs) {
            return resolvedArgs[0].lastIndexOf(resolvedArgs[1]) === 0;
        },
        _functionEndsWith: function(resolvedArgs) {
            var searchStr = resolvedArgs[0];
            var suffix = resolvedArgs[1];
            return searchStr.indexOf(suffix, searchStr.length - suffix.length) !== -1;
        },
        _functionReverse: function(resolvedArgs) {
            var typeName = this._getTypeName(resolvedArgs[0]);
            if (typeName === TYPE_STRING) {
                var originalStr = resolvedArgs[0];
                var reversedStr = "";
                for(var i = originalStr.length - 1; i >= 0; i--)reversedStr += originalStr[i];
                return reversedStr;
            } else {
                var reversedArray = resolvedArgs[0].slice(0);
                reversedArray.reverse();
                return reversedArray;
            }
        },
        _functionAbs: function(resolvedArgs) {
            return Math.abs(resolvedArgs[0]);
        },
        _functionCeil: function(resolvedArgs) {
            return Math.ceil(resolvedArgs[0]);
        },
        _functionAvg: function(resolvedArgs) {
            var sum = 0;
            var inputArray = resolvedArgs[0];
            for(var i = 0; i < inputArray.length; i++)sum += inputArray[i];
            return sum / inputArray.length;
        },
        _functionContains: function(resolvedArgs) {
            return resolvedArgs[0].indexOf(resolvedArgs[1]) >= 0;
        },
        _functionFloor: function(resolvedArgs) {
            return Math.floor(resolvedArgs[0]);
        },
        _functionLength: function(resolvedArgs) {
            if (!isObject(resolvedArgs[0])) return resolvedArgs[0].length;
            else // As far as I can tell, there's no way to get the length
            // of an object without O(n) iteration through the object.
            return Object.keys(resolvedArgs[0]).length;
        },
        _functionMap: function(resolvedArgs) {
            var mapped = [];
            var interpreter = this._interpreter;
            var exprefNode = resolvedArgs[0];
            var elements = resolvedArgs[1];
            for(var i = 0; i < elements.length; i++)mapped.push(interpreter.visit(exprefNode, elements[i]));
            return mapped;
        },
        _functionMerge: function(resolvedArgs) {
            var merged = {};
            for(var i = 0; i < resolvedArgs.length; i++){
                var current = resolvedArgs[i];
                for(var key in current)merged[key] = current[key];
            }
            return merged;
        },
        _functionMax: function(resolvedArgs) {
            if (resolvedArgs[0].length > 0) {
                var typeName = this._getTypeName(resolvedArgs[0][0]);
                if (typeName === TYPE_NUMBER) return Math.max.apply(Math, resolvedArgs[0]);
                else {
                    var elements = resolvedArgs[0];
                    var maxElement = elements[0];
                    for(var i = 1; i < elements.length; i++)if (maxElement.localeCompare(elements[i]) < 0) maxElement = elements[i];
                    return maxElement;
                }
            } else return null;
        },
        _functionMin: function(resolvedArgs) {
            if (resolvedArgs[0].length > 0) {
                var typeName = this._getTypeName(resolvedArgs[0][0]);
                if (typeName === TYPE_NUMBER) return Math.min.apply(Math, resolvedArgs[0]);
                else {
                    var elements = resolvedArgs[0];
                    var minElement = elements[0];
                    for(var i = 1; i < elements.length; i++)if (elements[i].localeCompare(minElement) < 0) minElement = elements[i];
                    return minElement;
                }
            } else return null;
        },
        _functionSum: function(resolvedArgs) {
            var sum = 0;
            var listToSum = resolvedArgs[0];
            for(var i = 0; i < listToSum.length; i++)sum += listToSum[i];
            return sum;
        },
        _functionType: function(resolvedArgs) {
            switch(this._getTypeName(resolvedArgs[0])){
                case TYPE_NUMBER:
                    return "number";
                case TYPE_STRING:
                    return "string";
                case TYPE_ARRAY:
                    return "array";
                case TYPE_OBJECT:
                    return "object";
                case TYPE_BOOLEAN:
                    return "boolean";
                case TYPE_EXPREF:
                    return "expref";
                case TYPE_NULL:
                    return "null";
            }
        },
        _functionKeys: function(resolvedArgs) {
            return Object.keys(resolvedArgs[0]);
        },
        _functionValues: function(resolvedArgs) {
            var obj = resolvedArgs[0];
            var keys = Object.keys(obj);
            var values = [];
            for(var i = 0; i < keys.length; i++)values.push(obj[keys[i]]);
            return values;
        },
        _functionJoin: function(resolvedArgs) {
            var joinChar = resolvedArgs[0];
            var listJoin = resolvedArgs[1];
            return listJoin.join(joinChar);
        },
        _functionToArray: function(resolvedArgs) {
            if (this._getTypeName(resolvedArgs[0]) === TYPE_ARRAY) return resolvedArgs[0];
            else return [
                resolvedArgs[0]
            ];
        },
        _functionToString: function(resolvedArgs) {
            if (this._getTypeName(resolvedArgs[0]) === TYPE_STRING) return resolvedArgs[0];
            else return JSON.stringify(resolvedArgs[0]);
        },
        _functionToNumber: function(resolvedArgs) {
            var typeName = this._getTypeName(resolvedArgs[0]);
            var convertedValue;
            if (typeName === TYPE_NUMBER) return resolvedArgs[0];
            else if (typeName === TYPE_STRING) {
                convertedValue = +resolvedArgs[0];
                if (!isNaN(convertedValue)) return convertedValue;
            }
            return null;
        },
        _functionNotNull: function(resolvedArgs) {
            for(var i = 0; i < resolvedArgs.length; i++){
                if (this._getTypeName(resolvedArgs[i]) !== TYPE_NULL) return resolvedArgs[i];
            }
            return null;
        },
        _functionSort: function(resolvedArgs) {
            var sortedArray = resolvedArgs[0].slice(0);
            sortedArray.sort();
            return sortedArray;
        },
        _functionSortBy: function(resolvedArgs) {
            var sortedArray = resolvedArgs[0].slice(0);
            if (sortedArray.length === 0) return sortedArray;
            var interpreter = this._interpreter;
            var exprefNode = resolvedArgs[1];
            var requiredType = this._getTypeName(interpreter.visit(exprefNode, sortedArray[0]));
            if ([
                TYPE_NUMBER,
                TYPE_STRING
            ].indexOf(requiredType) < 0) throw new Error("TypeError");
            var that = this;
            // In order to get a stable sort out of an unstable
            // sort algorithm, we decorate/sort/undecorate (DSU)
            // by creating a new list of [index, element] pairs.
            // In the cmp function, if the evaluated elements are
            // equal, then the index will be used as the tiebreaker.
            // After the decorated list has been sorted, it will be
            // undecorated to extract the original elements.
            var decorated = [];
            for(var i = 0; i < sortedArray.length; i++)decorated.push([
                i,
                sortedArray[i]
            ]);
            decorated.sort(function(a, b) {
                var exprA = interpreter.visit(exprefNode, a[1]);
                var exprB = interpreter.visit(exprefNode, b[1]);
                if (that._getTypeName(exprA) !== requiredType) throw new Error("TypeError: expected " + requiredType + ", received " + that._getTypeName(exprA));
                else if (that._getTypeName(exprB) !== requiredType) throw new Error("TypeError: expected " + requiredType + ", received " + that._getTypeName(exprB));
                if (exprA > exprB) return 1;
                else if (exprA < exprB) return -1;
                else // If they're equal compare the items by their
                // order to maintain relative order of equal keys
                // (i.e. to get a stable sort).
                return a[0] - b[0];
            });
            // Undecorate: extract out the original list elements.
            for(var j = 0; j < decorated.length; j++)sortedArray[j] = decorated[j][1];
            return sortedArray;
        },
        _functionMaxBy: function(resolvedArgs) {
            var exprefNode = resolvedArgs[1];
            var resolvedArray = resolvedArgs[0];
            var keyFunction = this.createKeyFunction(exprefNode, [
                TYPE_NUMBER,
                TYPE_STRING
            ]);
            var maxNumber = -Infinity;
            var maxRecord;
            var current;
            for(var i = 0; i < resolvedArray.length; i++){
                current = keyFunction(resolvedArray[i]);
                if (current > maxNumber) {
                    maxNumber = current;
                    maxRecord = resolvedArray[i];
                }
            }
            return maxRecord;
        },
        _functionMinBy: function(resolvedArgs) {
            var exprefNode = resolvedArgs[1];
            var resolvedArray = resolvedArgs[0];
            var keyFunction = this.createKeyFunction(exprefNode, [
                TYPE_NUMBER,
                TYPE_STRING
            ]);
            var minNumber = Infinity;
            var minRecord;
            var current;
            for(var i = 0; i < resolvedArray.length; i++){
                current = keyFunction(resolvedArray[i]);
                if (current < minNumber) {
                    minNumber = current;
                    minRecord = resolvedArray[i];
                }
            }
            return minRecord;
        },
        createKeyFunction: function(exprefNode, allowedTypes) {
            var that = this;
            var interpreter = this._interpreter;
            var keyFunc = function(x) {
                var current = interpreter.visit(exprefNode, x);
                if (allowedTypes.indexOf(that._getTypeName(current)) < 0) {
                    var msg = "TypeError: expected one of " + allowedTypes + ", received " + that._getTypeName(current);
                    throw new Error(msg);
                }
                return current;
            };
            return keyFunc;
        }
    };
    function compile(stream) {
        var parser = new Parser();
        var ast = parser.parse(stream);
        return ast;
    }
    function tokenize(stream) {
        var lexer = new Lexer();
        return lexer.tokenize(stream);
    }
    function search(data, expression) {
        var parser = new Parser();
        // This needs to be improved.  Both the interpreter and runtime depend on
        // each other.  The runtime needs the interpreter to support exprefs.
        // There's likely a clean way to avoid the cyclic dependency.
        var runtime = new Runtime();
        var interpreter = new TreeInterpreter(runtime);
        runtime._interpreter = interpreter;
        var node = parser.parse(expression);
        return interpreter.search(node, data);
    }
    exports1.tokenize = tokenize;
    exports1.compile = compile;
    exports1.search = search;
    exports1.strictDeepEqual = strictDeepEqual;
})(module.exports);

});


parcelRequire.register("lw5In", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
var $faa104f341997c9b$var$inherit = $dbC7k.util.inherit;

var $lxybn = parcelRequire("lxybn");
/**
 * This class encapsulates the response information
 * from a service request operation sent through {AWS.Request}.
 * The response object has two main properties for getting information
 * back from a request:
 *
 * ## The `data` property
 *
 * The `response.data` property contains the serialized object data
 * retrieved from the service request. For instance, for an
 * Amazon DynamoDB `listTables` method call, the response data might
 * look like:
 *
 * ```
 * > resp.data
 * { TableNames:
 *    [ 'table1', 'table2', ... ] }
 * ```
 *
 * The `data` property can be null if an error occurs (see below).
 *
 * ## The `error` property
 *
 * In the event of a service error (or transfer error), the
 * `response.error` property will be filled with the given
 * error data in the form:
 *
 * ```
 * { code: 'SHORT_UNIQUE_ERROR_CODE',
 *   message: 'Some human readable error message' }
 * ```
 *
 * In the case of an error, the `data` property will be `null`.
 * Note that if you handle events that can be in a failure state,
 * you should always check whether `response.error` is set
 * before attempting to access the `response.data` property.
 *
 * @!attribute data
 *   @readonly
 *   @!group Data Properties
 *   @note Inside of a {AWS.Request~httpData} event, this
 *     property contains a single raw packet instead of the
 *     full de-serialized service response.
 *   @return [Object] the de-serialized response data
 *     from the service.
 *
 * @!attribute error
 *   An structure containing information about a service
 *   or networking error.
 *   @readonly
 *   @!group Data Properties
 *   @note This attribute is only filled if a service or
 *     networking error occurs.
 *   @return [Error]
 *     * code [String] a unique short code representing the
 *       error that was emitted.
 *     * message [String] a longer human readable error message
 *     * retryable [Boolean] whether the error message is
 *       retryable.
 *     * statusCode [Numeric] in the case of a request that reached the service,
 *       this value contains the response status code.
 *     * time [Date] the date time object when the error occurred.
 *     * hostname [String] set when a networking error occurs to easily
 *       identify the endpoint of the request.
 *     * region [String] set when a networking error occurs to easily
 *       identify the region of the request.
 *
 * @!attribute requestId
 *   @readonly
 *   @!group Data Properties
 *   @return [String] the unique request ID associated with the response.
 *     Log this value when debugging requests for AWS support.
 *
 * @!attribute retryCount
 *   @readonly
 *   @!group Operation Properties
 *   @return [Integer] the number of retries that were
 *     attempted before the request was completed.
 *
 * @!attribute redirectCount
 *   @readonly
 *   @!group Operation Properties
 *   @return [Integer] the number of redirects that were
 *     followed before the request was completed.
 *
 * @!attribute httpResponse
 *   @readonly
 *   @!group HTTP Properties
 *   @return [AWS.HttpResponse] the raw HTTP response object
 *     containing the response headers and body information
 *     from the server.
 *
 * @see AWS.Request
 */ $dbC7k.Response = $faa104f341997c9b$var$inherit({
    /**
   * @api private
   */ constructor: function Response(request) {
        this.request = request;
        this.data = null;
        this.error = null;
        this.retryCount = 0;
        this.redirectCount = 0;
        this.httpResponse = new $dbC7k.HttpResponse();
        if (request) {
            this.maxRetries = request.service.numRetries();
            this.maxRedirects = request.service.config.maxRedirects;
        }
    },
    /**
   * Creates a new request for the next page of response data, calling the
   * callback with the page data if a callback is provided.
   *
   * @callback callback function(err, data)
   *   Called when a page of data is returned from the next request.
   *
   *   @param err [Error] an error object, if an error occurred in the request
   *   @param data [Object] the next page of data, or null, if there are no
   *     more pages left.
   * @return [AWS.Request] the request object for the next page of data
   * @return [null] if no callback is provided and there are no pages left
   *   to retrieve.
   * @since v1.4.0
   */ nextPage: function nextPage(callback) {
        var config;
        var service = this.request.service;
        var operation = this.request.operation;
        try {
            config = service.paginationConfig(operation, true);
        } catch (e) {
            this.error = e;
        }
        if (!this.hasNextPage()) {
            if (callback) callback(this.error, null);
            else if (this.error) throw this.error;
            return null;
        }
        var params = $dbC7k.util.copy(this.request.params);
        if (!this.nextPageTokens) return callback ? callback(null, null) : null;
        else {
            var inputTokens = config.inputToken;
            if (typeof inputTokens === "string") inputTokens = [
                inputTokens
            ];
            for(var i = 0; i < inputTokens.length; i++)params[inputTokens[i]] = this.nextPageTokens[i];
            return service.makeRequest(this.request.operation, params, callback);
        }
    },
    /**
   * @return [Boolean] whether more pages of data can be returned by further
   *   requests
   * @since v1.4.0
   */ hasNextPage: function hasNextPage() {
        this.cacheNextPageTokens();
        if (this.nextPageTokens) return true;
        if (this.nextPageTokens === undefined) return undefined;
        else return false;
    },
    /**
   * @api private
   */ cacheNextPageTokens: function cacheNextPageTokens() {
        if (Object.prototype.hasOwnProperty.call(this, "nextPageTokens")) return this.nextPageTokens;
        this.nextPageTokens = undefined;
        var config = this.request.service.paginationConfig(this.request.operation);
        if (!config) return this.nextPageTokens;
        this.nextPageTokens = null;
        if (config.moreResults) {
            if (!$lxybn.search(this.data, config.moreResults)) return this.nextPageTokens;
        }
        var exprs = config.outputToken;
        if (typeof exprs === "string") exprs = [
            exprs
        ];
        $dbC7k.util.arrayEach.call(this, exprs, function(expr) {
            var output = $lxybn.search(this.data, expr);
            if (output) {
                this.nextPageTokens = this.nextPageTokens || [];
                this.nextPageTokens.push(output);
            }
        });
        return this.nextPageTokens;
    }
});

});

parcelRequire.register("dygj6", function(module, exports) {
/**
 * Copyright 2012-2013 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You
 * may not use this file except in compliance with the License. A copy of
 * the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific
 * language governing permissions and limitations under the License.
 */ 
var $dbC7k = parcelRequire("dbC7k");
var $9ddb1998a075f130$var$inherit = $dbC7k.util.inherit;

var $lxybn = parcelRequire("lxybn");
/**
 * @api private
 */ function $9ddb1998a075f130$var$CHECK_ACCEPTORS(resp) {
    var waiter = resp.request._waiter;
    var acceptors = waiter.config.acceptors;
    var acceptorMatched = false;
    var state = "retry";
    acceptors.forEach(function(acceptor) {
        if (!acceptorMatched) {
            var matcher = waiter.matchers[acceptor.matcher];
            if (matcher && matcher(resp, acceptor.expected, acceptor.argument)) {
                acceptorMatched = true;
                state = acceptor.state;
            }
        }
    });
    if (!acceptorMatched && resp.error) state = "failure";
    if (state === "success") waiter.setSuccess(resp);
    else waiter.setError(resp, state === "retry");
}
/**
 * @api private
 */ $dbC7k.ResourceWaiter = $9ddb1998a075f130$var$inherit({
    /**
   * Waits for a given state on a service object
   * @param service [Service] the service object to wait on
   * @param state [String] the state (defined in waiter configuration) to wait
   *   for.
   * @example Create a waiter for running EC2 instances
   *   var ec2 = new AWS.EC2;
   *   var waiter = new AWS.ResourceWaiter(ec2, 'instanceRunning');
   */ constructor: function constructor(service, state) {
        this.service = service;
        this.state = state;
        this.loadWaiterConfig(this.state);
    },
    service: null,
    state: null,
    config: null,
    matchers: {
        path: function(resp, expected, argument) {
            try {
                var result = $lxybn.search(resp.data, argument);
            } catch (err) {
                return false;
            }
            return $lxybn.strictDeepEqual(result, expected);
        },
        pathAll: function(resp, expected, argument) {
            try {
                var results = $lxybn.search(resp.data, argument);
            } catch (err) {
                return false;
            }
            if (!Array.isArray(results)) results = [
                results
            ];
            var numResults = results.length;
            if (!numResults) return false;
            for(var ind = 0; ind < numResults; ind++){
                if (!$lxybn.strictDeepEqual(results[ind], expected)) return false;
            }
            return true;
        },
        pathAny: function(resp, expected, argument) {
            try {
                var results = $lxybn.search(resp.data, argument);
            } catch (err) {
                return false;
            }
            if (!Array.isArray(results)) results = [
                results
            ];
            var numResults = results.length;
            for(var ind = 0; ind < numResults; ind++){
                if ($lxybn.strictDeepEqual(results[ind], expected)) return true;
            }
            return false;
        },
        status: function(resp, expected) {
            var statusCode = resp.httpResponse.statusCode;
            return typeof statusCode === "number" && statusCode === expected;
        },
        error: function(resp, expected) {
            if (typeof expected === "string" && resp.error) return expected === resp.error.code;
            // if expected is not string, can be boolean indicating presence of error
            return expected === !!resp.error;
        }
    },
    listeners: new $dbC7k.SequentialExecutor().addNamedListeners(function(add) {
        add("RETRY_CHECK", "retry", function(resp) {
            var waiter = resp.request._waiter;
            if (resp.error && resp.error.code === "ResourceNotReady") resp.error.retryDelay = (waiter.config.delay || 0) * 1000;
        });
        add("CHECK_OUTPUT", "extractData", $9ddb1998a075f130$var$CHECK_ACCEPTORS);
        add("CHECK_ERROR", "extractError", $9ddb1998a075f130$var$CHECK_ACCEPTORS);
    }),
    /**
   * @return [AWS.Request]
   */ wait: function wait(params, callback) {
        if (typeof params === "function") {
            callback = params;
            params = undefined;
        }
        if (params && params.$waiter) {
            params = $dbC7k.util.copy(params);
            if (typeof params.$waiter.delay === "number") this.config.delay = params.$waiter.delay;
            if (typeof params.$waiter.maxAttempts === "number") this.config.maxAttempts = params.$waiter.maxAttempts;
            delete params.$waiter;
        }
        var request = this.service.makeRequest(this.config.operation, params);
        request._waiter = this;
        request.response.maxRetries = this.config.maxAttempts;
        request.addListeners(this.listeners);
        if (callback) request.send(callback);
        return request;
    },
    setSuccess: function setSuccess(resp) {
        resp.error = null;
        resp.data = resp.data || {};
        resp.request.removeAllListeners("extractData");
    },
    setError: function setError(resp, retryable) {
        resp.data = null;
        resp.error = $dbC7k.util.error(resp.error || new Error(), {
            code: "ResourceNotReady",
            message: "Resource is not in the state " + this.state,
            retryable: retryable
        });
    },
    /**
   * Loads waiter configuration from API configuration
   *
   * @api private
   */ loadWaiterConfig: function loadWaiterConfig(state) {
        if (!this.service.api.waiters[state]) throw new $dbC7k.util.error(new Error(), {
            code: "StateNotFoundError",
            message: "State " + state + " not found."
        });
        this.config = $dbC7k.util.copy(this.service.api.waiters[state]);
    }
});

});

parcelRequire.register("cqL7q", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
var $90cc768b09196fe9$var$inherit = $dbC7k.util.inherit;
/**
 * @api private
 */ $dbC7k.Signers.RequestSigner = $90cc768b09196fe9$var$inherit({
    constructor: function RequestSigner(request) {
        this.request = request;
    },
    setServiceClientId: function setServiceClientId(id) {
        this.serviceClientId = id;
    },
    getServiceClientId: function getServiceClientId() {
        return this.serviceClientId;
    }
});
$dbC7k.Signers.RequestSigner.getVersion = function getVersion(version) {
    switch(version){
        case "v2":
            return $dbC7k.Signers.V2;
        case "v3":
            return $dbC7k.Signers.V3;
        case "s3v4":
            return $dbC7k.Signers.V4;
        case "v4":
            return $dbC7k.Signers.V4;
        case "s3":
            return $dbC7k.Signers.S3;
        case "v3https":
            return $dbC7k.Signers.V3Https;
    }
    throw new Error("Unknown signing version " + version);
};
parcelRequire("tLrQd");
parcelRequire("VO4WM");
parcelRequire("33FyC");
parcelRequire("eodu2");
parcelRequire("kvsL2");
parcelRequire("hREYg");

});
parcelRequire.register("tLrQd", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
var $059783be12a4af0d$var$inherit = $dbC7k.util.inherit;
/**
 * @api private
 */ $dbC7k.Signers.V2 = $059783be12a4af0d$var$inherit($dbC7k.Signers.RequestSigner, {
    addAuthorization: function addAuthorization(credentials, date) {
        if (!date) date = $dbC7k.util.date.getDate();
        var r = this.request;
        r.params.Timestamp = $dbC7k.util.date.iso8601(date);
        r.params.SignatureVersion = "2";
        r.params.SignatureMethod = "HmacSHA256";
        r.params.AWSAccessKeyId = credentials.accessKeyId;
        if (credentials.sessionToken) r.params.SecurityToken = credentials.sessionToken;
        delete r.params.Signature; // delete old Signature for re-signing
        r.params.Signature = this.signature(credentials);
        r.body = $dbC7k.util.queryParamsToString(r.params);
        r.headers["Content-Length"] = r.body.length;
    },
    signature: function signature(credentials) {
        return $dbC7k.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), "base64");
    },
    stringToSign: function stringToSign() {
        var parts = [];
        parts.push(this.request.method);
        parts.push(this.request.endpoint.host.toLowerCase());
        parts.push(this.request.pathname());
        parts.push($dbC7k.util.queryParamsToString(this.request.params));
        return parts.join("\n");
    }
});
/**
 * @api private
 */ module.exports = $dbC7k.Signers.V2;

});

parcelRequire.register("VO4WM", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
var $0adc2b972c08f5f8$var$inherit = $dbC7k.util.inherit;
/**
 * @api private
 */ $dbC7k.Signers.V3 = $0adc2b972c08f5f8$var$inherit($dbC7k.Signers.RequestSigner, {
    addAuthorization: function addAuthorization(credentials, date) {
        var datetime = $dbC7k.util.date.rfc822(date);
        this.request.headers["X-Amz-Date"] = datetime;
        if (credentials.sessionToken) this.request.headers["x-amz-security-token"] = credentials.sessionToken;
        this.request.headers["X-Amzn-Authorization"] = this.authorization(credentials, datetime);
    },
    authorization: function authorization(credentials) {
        return "AWS3 AWSAccessKeyId=" + credentials.accessKeyId + "," + "Algorithm=HmacSHA256," + "SignedHeaders=" + this.signedHeaders() + "," + "Signature=" + this.signature(credentials);
    },
    signedHeaders: function signedHeaders() {
        var headers = [];
        $dbC7k.util.arrayEach(this.headersToSign(), function iterator(h) {
            headers.push(h.toLowerCase());
        });
        return headers.sort().join(";");
    },
    canonicalHeaders: function canonicalHeaders() {
        var headers = this.request.headers;
        var parts = [];
        $dbC7k.util.arrayEach(this.headersToSign(), function iterator(h) {
            parts.push(h.toLowerCase().trim() + ":" + String(headers[h]).trim());
        });
        return parts.sort().join("\n") + "\n";
    },
    headersToSign: function headersToSign() {
        var headers = [];
        $dbC7k.util.each(this.request.headers, function iterator(k) {
            if (k === "Host" || k === "Content-Encoding" || k.match(/^X-Amz/i)) headers.push(k);
        });
        return headers;
    },
    signature: function signature(credentials) {
        return $dbC7k.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), "base64");
    },
    stringToSign: function stringToSign() {
        var parts = [];
        parts.push(this.request.method);
        parts.push("/");
        parts.push("");
        parts.push(this.canonicalHeaders());
        parts.push(this.request.body);
        return $dbC7k.util.crypto.sha256(parts.join("\n"));
    }
});
/**
 * @api private
 */ module.exports = $dbC7k.Signers.V3;

});

parcelRequire.register("33FyC", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
var $23a1e35ac239f011$var$inherit = $dbC7k.util.inherit;
parcelRequire("VO4WM");
/**
 * @api private
 */ $dbC7k.Signers.V3Https = $23a1e35ac239f011$var$inherit($dbC7k.Signers.V3, {
    authorization: function authorization(credentials) {
        return "AWS3-HTTPS AWSAccessKeyId=" + credentials.accessKeyId + "," + "Algorithm=HmacSHA256," + "Signature=" + this.signature(credentials);
    },
    stringToSign: function stringToSign() {
        return this.request.headers["X-Amz-Date"];
    }
});
/**
 * @api private
 */ module.exports = $dbC7k.Signers.V3Https;

});

parcelRequire.register("eodu2", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");

var $3SbtQ = parcelRequire("3SbtQ");
var $a79dc4214aa0eda2$var$inherit = $dbC7k.util.inherit;
/**
 * @api private
 */ var $a79dc4214aa0eda2$var$expiresHeader = "presigned-expires";
/**
 * @api private
 */ $dbC7k.Signers.V4 = $a79dc4214aa0eda2$var$inherit($dbC7k.Signers.RequestSigner, {
    constructor: function V4(request, serviceName, options) {
        $dbC7k.Signers.RequestSigner.call(this, request);
        this.serviceName = serviceName;
        options = options || {};
        this.signatureCache = typeof options.signatureCache === "boolean" ? options.signatureCache : true;
        this.operation = options.operation;
        this.signatureVersion = options.signatureVersion;
    },
    algorithm: "AWS4-HMAC-SHA256",
    addAuthorization: function addAuthorization(credentials, date) {
        var datetime = $dbC7k.util.date.iso8601(date).replace(/[:\-]|\.\d{3}/g, "");
        if (this.isPresigned()) this.updateForPresigned(credentials, datetime);
        else this.addHeaders(credentials, datetime);
        this.request.headers["Authorization"] = this.authorization(credentials, datetime);
    },
    addHeaders: function addHeaders(credentials, datetime) {
        this.request.headers["X-Amz-Date"] = datetime;
        if (credentials.sessionToken) this.request.headers["x-amz-security-token"] = credentials.sessionToken;
    },
    updateForPresigned: function updateForPresigned(credentials, datetime) {
        var credString = this.credentialString(datetime);
        var qs = {
            "X-Amz-Date": datetime,
            "X-Amz-Algorithm": this.algorithm,
            "X-Amz-Credential": credentials.accessKeyId + "/" + credString,
            "X-Amz-Expires": this.request.headers[$a79dc4214aa0eda2$var$expiresHeader],
            "X-Amz-SignedHeaders": this.signedHeaders()
        };
        if (credentials.sessionToken) qs["X-Amz-Security-Token"] = credentials.sessionToken;
        if (this.request.headers["Content-Type"]) qs["Content-Type"] = this.request.headers["Content-Type"];
        if (this.request.headers["Content-MD5"]) qs["Content-MD5"] = this.request.headers["Content-MD5"];
        if (this.request.headers["Cache-Control"]) qs["Cache-Control"] = this.request.headers["Cache-Control"];
        // need to pull in any other X-Amz-* headers
        $dbC7k.util.each.call(this, this.request.headers, function(key, value) {
            if (key === $a79dc4214aa0eda2$var$expiresHeader) return;
            if (this.isSignableHeader(key)) {
                var lowerKey = key.toLowerCase();
                // Metadata should be normalized
                if (lowerKey.indexOf("x-amz-meta-") === 0) qs[lowerKey] = value;
                else if (lowerKey.indexOf("x-amz-") === 0) qs[key] = value;
            }
        });
        var sep = this.request.path.indexOf("?") >= 0 ? "&" : "?";
        this.request.path += sep + $dbC7k.util.queryParamsToString(qs);
    },
    authorization: function authorization(credentials, datetime) {
        var parts = [];
        var credString = this.credentialString(datetime);
        parts.push(this.algorithm + " Credential=" + credentials.accessKeyId + "/" + credString);
        parts.push("SignedHeaders=" + this.signedHeaders());
        parts.push("Signature=" + this.signature(credentials, datetime));
        return parts.join(", ");
    },
    signature: function signature(credentials, datetime) {
        var signingKey = $3SbtQ.getSigningKey(credentials, datetime.substr(0, 8), this.request.region, this.serviceName, this.signatureCache);
        return $dbC7k.util.crypto.hmac(signingKey, this.stringToSign(datetime), "hex");
    },
    stringToSign: function stringToSign(datetime) {
        var parts = [];
        parts.push("AWS4-HMAC-SHA256");
        parts.push(datetime);
        parts.push(this.credentialString(datetime));
        parts.push(this.hexEncodedHash(this.canonicalString()));
        return parts.join("\n");
    },
    canonicalString: function canonicalString() {
        var parts = [], pathname = this.request.pathname();
        if (this.serviceName !== "s3" && this.signatureVersion !== "s3v4") pathname = $dbC7k.util.uriEscapePath(pathname);
        parts.push(this.request.method);
        parts.push(pathname);
        parts.push(this.request.search());
        parts.push(this.canonicalHeaders() + "\n");
        parts.push(this.signedHeaders());
        parts.push(this.hexEncodedBodyHash());
        return parts.join("\n");
    },
    canonicalHeaders: function canonicalHeaders() {
        var headers = [];
        $dbC7k.util.each.call(this, this.request.headers, function(key, item) {
            headers.push([
                key,
                item
            ]);
        });
        headers.sort(function(a, b) {
            return a[0].toLowerCase() < b[0].toLowerCase() ? -1 : 1;
        });
        var parts = [];
        $dbC7k.util.arrayEach.call(this, headers, function(item) {
            var key = item[0].toLowerCase();
            if (this.isSignableHeader(key)) {
                var value = item[1];
                if (typeof value === "undefined" || value === null || typeof value.toString !== "function") throw $dbC7k.util.error(new Error("Header " + key + " contains invalid value"), {
                    code: "InvalidHeader"
                });
                parts.push(key + ":" + this.canonicalHeaderValues(value.toString()));
            }
        });
        return parts.join("\n");
    },
    canonicalHeaderValues: function canonicalHeaderValues(values) {
        return values.replace(/\s+/g, " ").replace(/^\s+|\s+$/g, "");
    },
    signedHeaders: function signedHeaders() {
        var keys = [];
        $dbC7k.util.each.call(this, this.request.headers, function(key) {
            key = key.toLowerCase();
            if (this.isSignableHeader(key)) keys.push(key);
        });
        return keys.sort().join(";");
    },
    credentialString: function credentialString(datetime) {
        return $3SbtQ.createScope(datetime.substr(0, 8), this.request.region, this.serviceName);
    },
    hexEncodedHash: function hash(string) {
        return $dbC7k.util.crypto.sha256(string, "hex");
    },
    hexEncodedBodyHash: function hexEncodedBodyHash() {
        var request = this.request;
        if (this.isPresigned() && this.serviceName === "s3" && !request.body) return "UNSIGNED-PAYLOAD";
        else if (request.headers["X-Amz-Content-Sha256"]) return request.headers["X-Amz-Content-Sha256"];
        else return this.hexEncodedHash(this.request.body || "");
    },
    unsignableHeaders: [
        "authorization",
        "content-type",
        "content-length",
        "user-agent",
        $a79dc4214aa0eda2$var$expiresHeader,
        "expect",
        "x-amzn-trace-id"
    ],
    isSignableHeader: function isSignableHeader(key) {
        if (key.toLowerCase().indexOf("x-amz-") === 0) return true;
        return this.unsignableHeaders.indexOf(key) < 0;
    },
    isPresigned: function isPresigned() {
        return this.request.headers[$a79dc4214aa0eda2$var$expiresHeader] ? true : false;
    }
});
/**
 * @api private
 */ module.exports = $dbC7k.Signers.V4;

});
parcelRequire.register("3SbtQ", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
/**
 * @api private
 */ var $2d1f5207cf830d57$var$cachedSecret = {};
/**
 * @api private
 */ var $2d1f5207cf830d57$var$cacheQueue = [];
/**
 * @api private
 */ var $2d1f5207cf830d57$var$maxCacheEntries = 50;
/**
 * @api private
 */ var $2d1f5207cf830d57$var$v4Identifier = "aws4_request";
/**
 * @api private
 */ module.exports = {
    /**
   * @api private
   *
   * @param date [String]
   * @param region [String]
   * @param serviceName [String]
   * @return [String]
   */ createScope: function createScope(date, region, serviceName) {
        return [
            date.substr(0, 8),
            region,
            serviceName,
            $2d1f5207cf830d57$var$v4Identifier
        ].join("/");
    },
    /**
   * @api private
   *
   * @param credentials [Credentials]
   * @param date [String]
   * @param region [String]
   * @param service [String]
   * @param shouldCache [Boolean]
   * @return [String]
   */ getSigningKey: function getSigningKey(credentials, date, region, service, shouldCache) {
        var credsIdentifier = $dbC7k.util.crypto.hmac(credentials.secretAccessKey, credentials.accessKeyId, "base64");
        var cacheKey = [
            credsIdentifier,
            date,
            region,
            service
        ].join("_");
        shouldCache = shouldCache !== false;
        if (shouldCache && cacheKey in $2d1f5207cf830d57$var$cachedSecret) return $2d1f5207cf830d57$var$cachedSecret[cacheKey];
        var kDate = $dbC7k.util.crypto.hmac("AWS4" + credentials.secretAccessKey, date, "buffer");
        var kRegion = $dbC7k.util.crypto.hmac(kDate, region, "buffer");
        var kService = $dbC7k.util.crypto.hmac(kRegion, service, "buffer");
        var signingKey = $dbC7k.util.crypto.hmac(kService, $2d1f5207cf830d57$var$v4Identifier, "buffer");
        if (shouldCache) {
            $2d1f5207cf830d57$var$cachedSecret[cacheKey] = signingKey;
            $2d1f5207cf830d57$var$cacheQueue.push(cacheKey);
            if ($2d1f5207cf830d57$var$cacheQueue.length > $2d1f5207cf830d57$var$maxCacheEntries) // remove the oldest entry (not the least recently used)
            delete $2d1f5207cf830d57$var$cachedSecret[$2d1f5207cf830d57$var$cacheQueue.shift()];
        }
        return signingKey;
    },
    /**
   * @api private
   *
   * Empties the derived signing key cache. Made available for testing purposes
   * only.
   */ emptyCache: function emptyCache() {
        $2d1f5207cf830d57$var$cachedSecret = {};
        $2d1f5207cf830d57$var$cacheQueue = [];
    }
};

});


parcelRequire.register("kvsL2", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
var $eedd02945cdb3b9c$var$inherit = $dbC7k.util.inherit;
/**
 * @api private
 */ $dbC7k.Signers.S3 = $eedd02945cdb3b9c$var$inherit($dbC7k.Signers.RequestSigner, {
    /**
   * When building the stringToSign, these sub resource params should be
   * part of the canonical resource string with their NON-decoded values
   */ subResources: {
        "acl": 1,
        "accelerate": 1,
        "analytics": 1,
        "cors": 1,
        "lifecycle": 1,
        "delete": 1,
        "inventory": 1,
        "location": 1,
        "logging": 1,
        "metrics": 1,
        "notification": 1,
        "partNumber": 1,
        "policy": 1,
        "requestPayment": 1,
        "replication": 1,
        "restore": 1,
        "tagging": 1,
        "torrent": 1,
        "uploadId": 1,
        "uploads": 1,
        "versionId": 1,
        "versioning": 1,
        "versions": 1,
        "website": 1
    },
    // when building the stringToSign, these querystring params should be
    // part of the canonical resource string with their NON-encoded values
    responseHeaders: {
        "response-content-type": 1,
        "response-content-language": 1,
        "response-expires": 1,
        "response-cache-control": 1,
        "response-content-disposition": 1,
        "response-content-encoding": 1
    },
    addAuthorization: function addAuthorization(credentials, date) {
        if (!this.request.headers["presigned-expires"]) this.request.headers["X-Amz-Date"] = $dbC7k.util.date.rfc822(date);
        if (credentials.sessionToken) // presigned URLs require this header to be lowercased
        this.request.headers["x-amz-security-token"] = credentials.sessionToken;
        var signature = this.sign(credentials.secretAccessKey, this.stringToSign());
        var auth = "AWS " + credentials.accessKeyId + ":" + signature;
        this.request.headers["Authorization"] = auth;
    },
    stringToSign: function stringToSign() {
        var r = this.request;
        var parts = [];
        parts.push(r.method);
        parts.push(r.headers["Content-MD5"] || "");
        parts.push(r.headers["Content-Type"] || "");
        // This is the "Date" header, but we use X-Amz-Date.
        // The S3 signing mechanism requires us to pass an empty
        // string for this Date header regardless.
        parts.push(r.headers["presigned-expires"] || "");
        var headers = this.canonicalizedAmzHeaders();
        if (headers) parts.push(headers);
        parts.push(this.canonicalizedResource());
        return parts.join("\n");
    },
    canonicalizedAmzHeaders: function canonicalizedAmzHeaders() {
        var amzHeaders = [];
        $dbC7k.util.each(this.request.headers, function(name) {
            if (name.match(/^x-amz-/i)) amzHeaders.push(name);
        });
        amzHeaders.sort(function(a, b) {
            return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
        });
        var parts = [];
        $dbC7k.util.arrayEach.call(this, amzHeaders, function(name) {
            parts.push(name.toLowerCase() + ":" + String(this.request.headers[name]));
        });
        return parts.join("\n");
    },
    canonicalizedResource: function canonicalizedResource() {
        var r = this.request;
        var parts = r.path.split("?");
        var path = parts[0];
        var querystring = parts[1];
        var resource = "";
        if (r.virtualHostedBucket) resource += "/" + r.virtualHostedBucket;
        resource += path;
        if (querystring) {
            // collect a list of sub resources and query params that need to be signed
            var resources = [];
            $dbC7k.util.arrayEach.call(this, querystring.split("&"), function(param) {
                var name = param.split("=")[0];
                var value = param.split("=")[1];
                if (this.subResources[name] || this.responseHeaders[name]) {
                    var subresource = {
                        name: name
                    };
                    if (value !== undefined) {
                        if (this.subResources[name]) subresource.value = value;
                        else subresource.value = decodeURIComponent(value);
                    }
                    resources.push(subresource);
                }
            });
            resources.sort(function(a, b) {
                return a.name < b.name ? -1 : 1;
            });
            if (resources.length) {
                querystring = [];
                $dbC7k.util.arrayEach(resources, function(res) {
                    if (res.value === undefined) querystring.push(res.name);
                    else querystring.push(res.name + "=" + res.value);
                });
                resource += "?" + querystring.join("&");
            }
        }
        return resource;
    },
    sign: function sign(secret, string) {
        return $dbC7k.util.crypto.hmac(secret, string, "base64", "sha1");
    }
});
/**
 * @api private
 */ module.exports = $dbC7k.Signers.S3;

});

parcelRequire.register("hREYg", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
var $d0172ae414852b8d$var$inherit = $dbC7k.util.inherit;
/**
 * @api private
 */ var $d0172ae414852b8d$var$expiresHeader = "presigned-expires";
/**
 * @api private
 */ function $d0172ae414852b8d$var$signedUrlBuilder(request) {
    var expires = request.httpRequest.headers[$d0172ae414852b8d$var$expiresHeader];
    var signerClass = request.service.getSignerClass(request);
    delete request.httpRequest.headers["User-Agent"];
    delete request.httpRequest.headers["X-Amz-User-Agent"];
    if (signerClass === $dbC7k.Signers.V4) {
        if (expires > 604800) {
            var message = "Presigning does not support expiry time greater than a week with SigV4 signing.";
            throw $dbC7k.util.error(new Error(), {
                code: "InvalidExpiryTime",
                message: message,
                retryable: false
            });
        }
        request.httpRequest.headers[$d0172ae414852b8d$var$expiresHeader] = expires;
    } else if (signerClass === $dbC7k.Signers.S3) {
        var now = request.service ? request.service.getSkewCorrectedDate() : $dbC7k.util.date.getDate();
        request.httpRequest.headers[$d0172ae414852b8d$var$expiresHeader] = parseInt($dbC7k.util.date.unixTimestamp(now) + expires, 10).toString();
    } else throw $dbC7k.util.error(new Error(), {
        message: "Presigning only supports S3 or SigV4 signing.",
        code: "UnsupportedSigner",
        retryable: false
    });
}
/**
 * @api private
 */ function $d0172ae414852b8d$var$signedUrlSigner(request) {
    var endpoint = request.httpRequest.endpoint;
    var parsedUrl = $dbC7k.util.urlParse(request.httpRequest.path);
    var queryParams = {};
    if (parsedUrl.search) queryParams = $dbC7k.util.queryStringParse(parsedUrl.search.substr(1));
    var auth = request.httpRequest.headers["Authorization"].split(" ");
    if (auth[0] === "AWS") {
        auth = auth[1].split(":");
        queryParams["AWSAccessKeyId"] = auth[0];
        queryParams["Signature"] = auth[1];
        $dbC7k.util.each(request.httpRequest.headers, function(key, value) {
            if (key === $d0172ae414852b8d$var$expiresHeader) key = "Expires";
            if (key.indexOf("x-amz-meta-") === 0) {
                // Delete existing, potentially not normalized key
                delete queryParams[key];
                key = key.toLowerCase();
            }
            queryParams[key] = value;
        });
        delete request.httpRequest.headers[$d0172ae414852b8d$var$expiresHeader];
        delete queryParams["Authorization"];
        delete queryParams["Host"];
    } else if (auth[0] === "AWS4-HMAC-SHA256") {
        auth.shift();
        var rest = auth.join(" ");
        var signature = rest.match(/Signature=(.*?)(?:,|\s|\r?\n|$)/)[1];
        queryParams["X-Amz-Signature"] = signature;
        delete queryParams["Expires"];
    }
    // build URL
    endpoint.pathname = parsedUrl.pathname;
    endpoint.search = $dbC7k.util.queryParamsToString(queryParams);
}
/**
 * @api private
 */ $dbC7k.Signers.Presign = $d0172ae414852b8d$var$inherit({
    /**
   * @api private
   */ sign: function sign(request, expireTime, callback) {
        request.httpRequest.headers[$d0172ae414852b8d$var$expiresHeader] = expireTime || 3600;
        request.on("build", $d0172ae414852b8d$var$signedUrlBuilder);
        request.on("sign", $d0172ae414852b8d$var$signedUrlSigner);
        request.removeListener("afterBuild", $dbC7k.EventListeners.Core.SET_CONTENT_LENGTH);
        request.removeListener("afterBuild", $dbC7k.EventListeners.Core.COMPUTE_SHA256);
        request.emit("beforePresign", [
            request
        ]);
        if (callback) request.build(function() {
            if (this.response.error) callback(this.response.error);
            else callback(null, $dbC7k.util.urlFormat(request.httpRequest.endpoint));
        });
        else {
            request.build();
            if (request.response.error) throw request.response.error;
            return $dbC7k.util.urlFormat(request.httpRequest.endpoint);
        }
    }
});
/**
 * @api private
 */ module.exports = $dbC7k.Signers.Presign;

});


parcelRequire.register("idU0U", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
/**
 * @api private
 */ $dbC7k.ParamValidator = $dbC7k.util.inherit({
    /**
   * Create a new validator object.
   *
   * @param validation [Boolean|map] whether input parameters should be
   *     validated against the operation description before sending the
   *     request. Pass a map to enable any of the following specific
   *     validation features:
   *
   *     * **min** [Boolean] &mdash; Validates that a value meets the min
   *       constraint. This is enabled by default when paramValidation is set
   *       to `true`.
   *     * **max** [Boolean] &mdash; Validates that a value meets the max
   *       constraint.
   *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
   *       regular expression.
   *     * **enum** [Boolean] &mdash; Validates that a string value matches one
   *       of the allowable enum values.
   */ constructor: function ParamValidator(validation) {
        if (validation === true || validation === undefined) validation = {
            "min": true
        };
        this.validation = validation;
    },
    validate: function validate(shape, params, context) {
        this.errors = [];
        this.validateMember(shape, params || {}, context || "params");
        if (this.errors.length > 1) {
            var msg = this.errors.join("\n* ");
            msg = "There were " + this.errors.length + " validation errors:\n* " + msg;
            throw $dbC7k.util.error(new Error(msg), {
                code: "MultipleValidationErrors",
                errors: this.errors
            });
        } else if (this.errors.length === 1) throw this.errors[0];
        else return true;
    },
    fail: function fail(code, message) {
        this.errors.push($dbC7k.util.error(new Error(message), {
            code: code
        }));
    },
    validateStructure: function validateStructure(shape, params, context) {
        this.validateType(params, context, [
            "object"
        ], "structure");
        var paramName;
        for(var i = 0; shape.required && i < shape.required.length; i++){
            paramName = shape.required[i];
            var value = params[paramName];
            if (value === undefined || value === null) this.fail("MissingRequiredParameter", "Missing required key '" + paramName + "' in " + context);
        }
        // validate hash members
        for(paramName in params){
            if (!Object.prototype.hasOwnProperty.call(params, paramName)) continue;
            var paramValue = params[paramName], memberShape = shape.members[paramName];
            if (memberShape !== undefined) {
                var memberContext = [
                    context,
                    paramName
                ].join(".");
                this.validateMember(memberShape, paramValue, memberContext);
            } else this.fail("UnexpectedParameter", "Unexpected key '" + paramName + "' found in " + context);
        }
        return true;
    },
    validateMember: function validateMember(shape, param, context) {
        switch(shape.type){
            case "structure":
                return this.validateStructure(shape, param, context);
            case "list":
                return this.validateList(shape, param, context);
            case "map":
                return this.validateMap(shape, param, context);
            default:
                return this.validateScalar(shape, param, context);
        }
    },
    validateList: function validateList(shape, params, context) {
        if (this.validateType(params, context, [
            Array
        ])) {
            this.validateRange(shape, params.length, context, "list member count");
            // validate array members
            for(var i = 0; i < params.length; i++)this.validateMember(shape.member, params[i], context + "[" + i + "]");
        }
    },
    validateMap: function validateMap(shape, params, context) {
        if (this.validateType(params, context, [
            "object"
        ], "map")) {
            // Build up a count of map members to validate range traits.
            var mapCount = 0;
            for(var param in params){
                if (!Object.prototype.hasOwnProperty.call(params, param)) continue;
                // Validate any map key trait constraints
                this.validateMember(shape.key, param, context + "[key='" + param + "']");
                this.validateMember(shape.value, params[param], context + "['" + param + "']");
                mapCount++;
            }
            this.validateRange(shape, mapCount, context, "map member count");
        }
    },
    validateScalar: function validateScalar(shape, value, context) {
        switch(shape.type){
            case null:
            case undefined:
            case "string":
                return this.validateString(shape, value, context);
            case "base64":
            case "binary":
                return this.validatePayload(value, context);
            case "integer":
            case "float":
                return this.validateNumber(shape, value, context);
            case "boolean":
                return this.validateType(value, context, [
                    "boolean"
                ]);
            case "timestamp":
                return this.validateType(value, context, [
                    Date,
                    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/,
                    "number"
                ], "Date object, ISO-8601 string, or a UNIX timestamp");
            default:
                return this.fail("UnkownType", "Unhandled type " + shape.type + " for " + context);
        }
    },
    validateString: function validateString(shape, value, context) {
        var validTypes = [
            "string"
        ];
        if (shape.isJsonValue) validTypes = validTypes.concat([
            "number",
            "object",
            "boolean"
        ]);
        if (value !== null && this.validateType(value, context, validTypes)) {
            this.validateEnum(shape, value, context);
            this.validateRange(shape, value.length, context, "string length");
            this.validatePattern(shape, value, context);
            this.validateUri(shape, value, context);
        }
    },
    validateUri: function validateUri(shape, value, context) {
        if (shape["location"] === "uri") {
            if (value.length === 0) this.fail("UriParameterError", 'Expected uri parameter to have length >= 1, but found "' + value + '" for ' + context);
        }
    },
    validatePattern: function validatePattern(shape, value, context) {
        if (this.validation["pattern"] && shape["pattern"] !== undefined) {
            if (!new RegExp(shape["pattern"]).test(value)) this.fail("PatternMatchError", 'Provided value "' + value + '" ' + "does not match regex pattern /" + shape["pattern"] + "/ for " + context);
        }
    },
    validateRange: function validateRange(shape, value, context, descriptor) {
        if (this.validation["min"]) {
            if (shape["min"] !== undefined && value < shape["min"]) this.fail("MinRangeError", "Expected " + descriptor + " >= " + shape["min"] + ", but found " + value + " for " + context);
        }
        if (this.validation["max"]) {
            if (shape["max"] !== undefined && value > shape["max"]) this.fail("MaxRangeError", "Expected " + descriptor + " <= " + shape["max"] + ", but found " + value + " for " + context);
        }
    },
    validateEnum: function validateRange(shape, value, context) {
        if (this.validation["enum"] && shape["enum"] !== undefined) // Fail if the string value is not present in the enum list
        {
            if (shape["enum"].indexOf(value) === -1) this.fail("EnumError", "Found string value of " + value + ", but " + "expected " + shape["enum"].join("|") + " for " + context);
        }
    },
    validateType: function validateType(value, context, acceptedTypes, type) {
        // We will not log an error for null or undefined, but we will return
        // false so that callers know that the expected type was not strictly met.
        if (value === null || value === undefined) return false;
        var foundInvalidType = false;
        for(var i = 0; i < acceptedTypes.length; i++){
            if (typeof acceptedTypes[i] === "string") {
                if (typeof value === acceptedTypes[i]) return true;
            } else if (acceptedTypes[i] instanceof RegExp) {
                if ((value || "").toString().match(acceptedTypes[i])) return true;
            } else {
                if (value instanceof acceptedTypes[i]) return true;
                if ($dbC7k.util.isType(value, acceptedTypes[i])) return true;
                if (!type && !foundInvalidType) acceptedTypes = acceptedTypes.slice();
                acceptedTypes[i] = $dbC7k.util.typeName(acceptedTypes[i]);
            }
            foundInvalidType = true;
        }
        var acceptedType = type;
        if (!acceptedType) acceptedType = acceptedTypes.join(", ").replace(/,([^,]+)$/, ", or$1");
        var vowel = acceptedType.match(/^[aeiou]/i) ? "n" : "";
        this.fail("InvalidParameterType", "Expected " + context + " to be a" + vowel + " " + acceptedType);
        return false;
    },
    validateNumber: function validateNumber(shape, value, context) {
        if (value === null || value === undefined) return;
        if (typeof value === "string") {
            var castedValue = parseFloat(value);
            if (castedValue.toString() === value) value = castedValue;
        }
        if (this.validateType(value, context, [
            "number"
        ])) this.validateRange(shape, value, context, "numeric value");
    },
    validatePayload: function validatePayload(value, context) {
        if (value === null || value === undefined) return;
        if (typeof value === "string") return;
        if (value && typeof value.byteLength === "number") return; // typed arrays
        if ($dbC7k.util.isNode()) {
            var Stream = $dbC7k.util.stream.Stream;
            if ($dbC7k.util.Buffer.isBuffer(value) || value instanceof Stream) return;
        } else {
            if (Blob, value instanceof Blob) return;
        }
        var types = [
            "Buffer",
            "Stream",
            "File",
            "Blob",
            "ArrayBuffer",
            "DataView"
        ];
        if (value) for(var i = 0; i < types.length; i++){
            if ($dbC7k.util.isType(value, types[i])) return;
            if ($dbC7k.util.typeName(value.constructor) === types[i]) return;
        }
        this.fail("InvalidParameterType", "Expected " + context + " to be a " + "string, Buffer, Stream, Blob, or typed array object");
    }
});

});


parcelRequire.register("6BE6r", function(module, exports) {
"use strict";

});

parcelRequire.register("1R1lB", function(module, exports) {
module.exports = JSON.parse('{"acm":{"name":"ACM","cors":true},"apigateway":{"name":"APIGateway","cors":true},"applicationautoscaling":{"prefix":"application-autoscaling","name":"ApplicationAutoScaling","cors":true},"appstream":{"name":"AppStream"},"autoscaling":{"name":"AutoScaling","cors":true},"batch":{"name":"Batch"},"budgets":{"name":"Budgets"},"clouddirectory":{"name":"CloudDirectory","versions":["2016-05-10*"]},"cloudformation":{"name":"CloudFormation","cors":true},"cloudfront":{"name":"CloudFront","versions":["2013-05-12*","2013-11-11*","2014-05-31*","2014-10-21*","2014-11-06*","2015-04-17*","2015-07-27*","2015-09-17*","2016-01-13*","2016-01-28*","2016-08-01*","2016-08-20*","2016-09-07*","2016-09-29*","2016-11-25*","2017-03-25*","2017-10-30*","2018-06-18*","2018-11-05*"],"cors":true},"cloudhsm":{"name":"CloudHSM","cors":true},"cloudsearch":{"name":"CloudSearch"},"cloudsearchdomain":{"name":"CloudSearchDomain"},"cloudtrail":{"name":"CloudTrail","cors":true},"cloudwatch":{"prefix":"monitoring","name":"CloudWatch","cors":true},"cloudwatchevents":{"prefix":"events","name":"CloudWatchEvents","versions":["2014-02-03*"],"cors":true},"cloudwatchlogs":{"prefix":"logs","name":"CloudWatchLogs","cors":true},"codebuild":{"name":"CodeBuild","cors":true},"codecommit":{"name":"CodeCommit","cors":true},"codedeploy":{"name":"CodeDeploy","cors":true},"codepipeline":{"name":"CodePipeline","cors":true},"cognitoidentity":{"prefix":"cognito-identity","name":"CognitoIdentity","cors":true},"cognitoidentityserviceprovider":{"prefix":"cognito-idp","name":"CognitoIdentityServiceProvider","cors":true},"cognitosync":{"prefix":"cognito-sync","name":"CognitoSync","cors":true},"configservice":{"prefix":"config","name":"ConfigService","cors":true},"cur":{"name":"CUR","cors":true},"datapipeline":{"name":"DataPipeline"},"devicefarm":{"name":"DeviceFarm","cors":true},"directconnect":{"name":"DirectConnect","cors":true},"directoryservice":{"prefix":"ds","name":"DirectoryService"},"discovery":{"name":"Discovery"},"dms":{"name":"DMS"},"dynamodb":{"name":"DynamoDB","cors":true},"dynamodbstreams":{"prefix":"streams.dynamodb","name":"DynamoDBStreams","cors":true},"ec2":{"name":"EC2","versions":["2013-06-15*","2013-10-15*","2014-02-01*","2014-05-01*","2014-06-15*","2014-09-01*","2014-10-01*","2015-03-01*","2015-04-15*","2015-10-01*","2016-04-01*","2016-09-15*"],"cors":true},"ecr":{"name":"ECR","cors":true},"ecs":{"name":"ECS","cors":true},"efs":{"prefix":"elasticfilesystem","name":"EFS","cors":true},"elasticache":{"name":"ElastiCache","versions":["2012-11-15*","2014-03-24*","2014-07-15*","2014-09-30*"],"cors":true},"elasticbeanstalk":{"name":"ElasticBeanstalk","cors":true},"elb":{"prefix":"elasticloadbalancing","name":"ELB","cors":true},"elbv2":{"prefix":"elasticloadbalancingv2","name":"ELBv2","cors":true},"emr":{"prefix":"elasticmapreduce","name":"EMR","cors":true},"es":{"name":"ES"},"elastictranscoder":{"name":"ElasticTranscoder","cors":true},"firehose":{"name":"Firehose","cors":true},"gamelift":{"name":"GameLift","cors":true},"glacier":{"name":"Glacier"},"health":{"name":"Health"},"iam":{"name":"IAM","cors":true},"importexport":{"name":"ImportExport"},"inspector":{"name":"Inspector","versions":["2015-08-18*"],"cors":true},"iot":{"name":"Iot","cors":true},"iotdata":{"prefix":"iot-data","name":"IotData","cors":true},"kinesis":{"name":"Kinesis","cors":true},"kinesisanalytics":{"name":"KinesisAnalytics"},"kms":{"name":"KMS","cors":true},"lambda":{"name":"Lambda","cors":true},"lexruntime":{"prefix":"runtime.lex","name":"LexRuntime","cors":true},"lightsail":{"name":"Lightsail"},"machinelearning":{"name":"MachineLearning","cors":true},"marketplacecommerceanalytics":{"name":"MarketplaceCommerceAnalytics","cors":true},"marketplacemetering":{"prefix":"meteringmarketplace","name":"MarketplaceMetering"},"mturk":{"prefix":"mturk-requester","name":"MTurk","cors":true},"mobileanalytics":{"name":"MobileAnalytics","cors":true},"opsworks":{"name":"OpsWorks","cors":true},"opsworkscm":{"name":"OpsWorksCM"},"organizations":{"name":"Organizations"},"pinpoint":{"name":"Pinpoint"},"polly":{"name":"Polly","cors":true},"rds":{"name":"RDS","versions":["2014-09-01*"],"cors":true},"redshift":{"name":"Redshift","cors":true},"rekognition":{"name":"Rekognition","cors":true},"resourcegroupstaggingapi":{"name":"ResourceGroupsTaggingAPI"},"route53":{"name":"Route53","cors":true},"route53domains":{"name":"Route53Domains","cors":true},"s3":{"name":"S3","dualstackAvailable":true,"cors":true},"s3control":{"name":"S3Control","dualstackAvailable":true},"servicecatalog":{"name":"ServiceCatalog","cors":true},"ses":{"prefix":"email","name":"SES","cors":true},"shield":{"name":"Shield"},"simpledb":{"prefix":"sdb","name":"SimpleDB"},"sms":{"name":"SMS"},"snowball":{"name":"Snowball"},"sns":{"name":"SNS","cors":true},"sqs":{"name":"SQS","cors":true},"ssm":{"name":"SSM","cors":true},"storagegateway":{"name":"StorageGateway","cors":true},"stepfunctions":{"prefix":"states","name":"StepFunctions"},"sts":{"name":"STS","cors":true},"support":{"name":"Support"},"swf":{"name":"SWF"},"xray":{"name":"XRay"},"waf":{"name":"WAF","cors":true},"wafregional":{"prefix":"waf-regional","name":"WAFRegional"},"workdocs":{"name":"WorkDocs","cors":true},"workspaces":{"name":"WorkSpaces"},"codestar":{"name":"CodeStar"},"lexmodelbuildingservice":{"prefix":"lex-models","name":"LexModelBuildingService","cors":true},"marketplaceentitlementservice":{"prefix":"entitlement.marketplace","name":"MarketplaceEntitlementService"},"athena":{"name":"Athena"},"greengrass":{"name":"Greengrass"},"dax":{"name":"DAX"},"migrationhub":{"prefix":"AWSMigrationHub","name":"MigrationHub"},"cloudhsmv2":{"name":"CloudHSMV2"},"glue":{"name":"Glue"},"mobile":{"name":"Mobile"},"pricing":{"name":"Pricing","cors":true},"costexplorer":{"prefix":"ce","name":"CostExplorer","cors":true},"mediaconvert":{"name":"MediaConvert"},"medialive":{"name":"MediaLive"},"mediapackage":{"name":"MediaPackage"},"mediastore":{"name":"MediaStore"},"mediastoredata":{"prefix":"mediastore-data","name":"MediaStoreData","cors":true},"appsync":{"name":"AppSync"},"guardduty":{"name":"GuardDuty"},"mq":{"name":"MQ"},"comprehend":{"name":"Comprehend","cors":true},"iotjobsdataplane":{"prefix":"iot-jobs-data","name":"IoTJobsDataPlane"},"kinesisvideoarchivedmedia":{"prefix":"kinesis-video-archived-media","name":"KinesisVideoArchivedMedia","cors":true},"kinesisvideomedia":{"prefix":"kinesis-video-media","name":"KinesisVideoMedia","cors":true},"kinesisvideo":{"name":"KinesisVideo","cors":true},"sagemakerruntime":{"prefix":"runtime.sagemaker","name":"SageMakerRuntime"},"sagemaker":{"name":"SageMaker"},"translate":{"name":"Translate","cors":true},"resourcegroups":{"prefix":"resource-groups","name":"ResourceGroups","cors":true},"alexaforbusiness":{"name":"AlexaForBusiness"},"cloud9":{"name":"Cloud9"},"serverlessapplicationrepository":{"prefix":"serverlessrepo","name":"ServerlessApplicationRepository"},"servicediscovery":{"name":"ServiceDiscovery"},"workmail":{"name":"WorkMail"},"autoscalingplans":{"prefix":"autoscaling-plans","name":"AutoScalingPlans"},"transcribeservice":{"prefix":"transcribe","name":"TranscribeService"},"connect":{"name":"Connect"},"acmpca":{"prefix":"acm-pca","name":"ACMPCA"},"fms":{"name":"FMS"},"secretsmanager":{"name":"SecretsManager","cors":true},"iotanalytics":{"name":"IoTAnalytics"},"iot1clickdevicesservice":{"prefix":"iot1click-devices","name":"IoT1ClickDevicesService"},"iot1clickprojects":{"prefix":"iot1click-projects","name":"IoT1ClickProjects"},"pi":{"name":"PI"},"neptune":{"name":"Neptune"},"mediatailor":{"name":"MediaTailor"},"eks":{"name":"EKS"},"macie":{"name":"Macie"},"dlm":{"name":"DLM"},"signer":{"name":"Signer"},"chime":{"name":"Chime"},"pinpointemail":{"prefix":"pinpoint-email","name":"PinpointEmail"},"ram":{"name":"RAM"},"route53resolver":{"name":"Route53Resolver"},"pinpointsmsvoice":{"prefix":"sms-voice","name":"PinpointSMSVoice"},"quicksight":{"name":"QuickSight"},"rdsdataservice":{"prefix":"rds-data","name":"RDSDataService"},"amplify":{"name":"Amplify"},"datasync":{"name":"DataSync"},"robomaker":{"name":"RoboMaker"},"transfer":{"name":"Transfer"},"globalaccelerator":{"name":"GlobalAccelerator"},"comprehendmedical":{"name":"ComprehendMedical","cors":true},"kinesisanalyticsv2":{"name":"KinesisAnalyticsV2"},"mediaconnect":{"name":"MediaConnect"},"fsx":{"name":"FSx"},"securityhub":{"name":"SecurityHub"},"appmesh":{"name":"AppMesh","versions":["2018-10-01*"]},"licensemanager":{"prefix":"license-manager","name":"LicenseManager"},"kafka":{"name":"Kafka"},"apigatewaymanagementapi":{"name":"ApiGatewayManagementApi"},"apigatewayv2":{"name":"ApiGatewayV2"},"docdb":{"name":"DocDB"},"backup":{"name":"Backup"},"worklink":{"name":"WorkLink"},"textract":{"name":"Textract"},"managedblockchain":{"name":"ManagedBlockchain"},"mediapackagevod":{"prefix":"mediapackage-vod","name":"MediaPackageVod"},"groundstation":{"name":"GroundStation"},"iotthingsgraph":{"name":"IoTThingsGraph"},"iotevents":{"name":"IoTEvents"},"ioteventsdata":{"prefix":"iotevents-data","name":"IoTEventsData"},"personalize":{"name":"Personalize","cors":true},"personalizeevents":{"prefix":"personalize-events","name":"PersonalizeEvents","cors":true},"personalizeruntime":{"prefix":"personalize-runtime","name":"PersonalizeRuntime","cors":true},"applicationinsights":{"prefix":"application-insights","name":"ApplicationInsights"},"servicequotas":{"prefix":"service-quotas","name":"ServiceQuotas"},"ec2instanceconnect":{"prefix":"ec2-instance-connect","name":"EC2InstanceConnect"},"eventbridge":{"name":"EventBridge"},"lakeformation":{"name":"LakeFormation"},"forecastservice":{"prefix":"forecast","name":"ForecastService"},"forecastqueryservice":{"prefix":"forecastquery","name":"ForecastQueryService"}}');

});

parcelRequire.register("9rAOB", function(module, exports) {

var $f3LOF = parcelRequire("f3LOF");

var $fje1W = parcelRequire("fje1W");
var $6e03316c35f160a6$var$uuid = $fje1W;
$6e03316c35f160a6$var$uuid.v1 = $f3LOF;
$6e03316c35f160a6$var$uuid.v4 = $fje1W;
module.exports = $6e03316c35f160a6$var$uuid;

});
parcelRequire.register("f3LOF", function(module, exports) {

var $Bcray = parcelRequire("Bcray");

var $izOXr = parcelRequire("izOXr");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $af6c3a2849f5f527$var$_nodeId;
var $af6c3a2849f5f527$var$_clockseq;
// Previous uuid creation time
var $af6c3a2849f5f527$var$_lastMSecs = 0;
var $af6c3a2849f5f527$var$_lastNSecs = 0;
// See https://github.com/broofa/node-uuid for API details
function $af6c3a2849f5f527$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $af6c3a2849f5f527$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $af6c3a2849f5f527$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $Bcray();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $af6c3a2849f5f527$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $af6c3a2849f5f527$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $af6c3a2849f5f527$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $af6c3a2849f5f527$var$_lastMSecs + (nsecs - $af6c3a2849f5f527$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $af6c3a2849f5f527$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $af6c3a2849f5f527$var$_lastMSecs = msecs;
    $af6c3a2849f5f527$var$_lastNSecs = nsecs;
    $af6c3a2849f5f527$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $izOXr(b);
}
module.exports = $af6c3a2849f5f527$var$v1;

});
parcelRequire.register("Bcray", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $06fd1a9659fcba9c$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($06fd1a9659fcba9c$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $06fd1a9659fcba9c$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $06fd1a9659fcba9c$var$getRandomValues($06fd1a9659fcba9c$var$rnds8);
        return $06fd1a9659fcba9c$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $06fd1a9659fcba9c$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $06fd1a9659fcba9c$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $06fd1a9659fcba9c$var$rnds;
    };
}

});

parcelRequire.register("izOXr", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $d8630600a9b764e4$var$byteToHex = [];
for(var $d8630600a9b764e4$var$i = 0; $d8630600a9b764e4$var$i < 256; ++$d8630600a9b764e4$var$i)$d8630600a9b764e4$var$byteToHex[$d8630600a9b764e4$var$i] = ($d8630600a9b764e4$var$i + 0x100).toString(16).substr(1);
function $d8630600a9b764e4$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $d8630600a9b764e4$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $d8630600a9b764e4$var$bytesToUuid;

});


parcelRequire.register("fje1W", function(module, exports) {

var $Bcray = parcelRequire("Bcray");

var $izOXr = parcelRequire("izOXr");
function $b253837ccb4b6968$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $Bcray)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $izOXr(rnds);
}
module.exports = $b253837ccb4b6968$var$v4;

});



parcelRequire.register("iJyoZ", function(module, exports) {

var $h0RRl = parcelRequire("h0RRl");

var $943Tu = parcelRequire("943Tu");

var $er33i = parcelRequire("er33i");

var $cE2Xz = parcelRequire("cE2Xz");
/**
 * @api private
 */ module.exports = exports = {
    createHash: function createHash(alg) {
        alg = alg.toLowerCase();
        if (alg === "md5") return new $943Tu();
        else if (alg === "sha256") return new $cE2Xz();
        else if (alg === "sha1") return new $er33i();
        throw new Error("Hash algorithm " + alg + " is not supported in the browser SDK");
    },
    createHmac: function createHmac(alg, key) {
        alg = alg.toLowerCase();
        if (alg === "md5") return new $h0RRl($943Tu, key);
        else if (alg === "sha256") return new $h0RRl($cE2Xz, key);
        else if (alg === "sha1") return new $h0RRl($er33i, key);
        throw new Error("HMAC algorithm " + alg + " is not supported in the browser SDK");
    },
    createSign: function() {
        throw new Error("createSign is not implemented in the browser");
    }
};

});
parcelRequire.register("h0RRl", function(module, exports) {

var $eNCgD = parcelRequire("eNCgD");
/**
 * @api private
 */ function Hmac(hashCtor, secret) {
    this.hash = new hashCtor();
    this.outer = new hashCtor();
    var inner = bufferFromSecret(hashCtor, secret);
    var outer = new Uint8Array(hashCtor.BLOCK_SIZE);
    outer.set(inner);
    for(var i = 0; i < hashCtor.BLOCK_SIZE; i++){
        inner[i] ^= 0x36;
        outer[i] ^= 0x5c;
    }
    this.hash.update(inner);
    this.outer.update(outer);
    // Zero out the copied key buffer.
    for(var i = 0; i < inner.byteLength; i++)inner[i] = 0;
}
/**
 * @api private
 */ module.exports = exports = Hmac;
Hmac.prototype.update = function(toHash) {
    if ($eNCgD.isEmptyData(toHash) || this.error) return this;
    try {
        this.hash.update($eNCgD.convertToBuffer(toHash));
    } catch (e) {
        this.error = e;
    }
    return this;
};
Hmac.prototype.digest = function(encoding) {
    if (!this.outer.finished) this.outer.update(this.hash.digest());
    return this.outer.digest(encoding);
};
function bufferFromSecret(hashCtor, secret) {
    var input = $eNCgD.convertToBuffer(secret);
    if (input.byteLength > hashCtor.BLOCK_SIZE) {
        var bufferHash = new hashCtor;
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(hashCtor.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}

});
parcelRequire.register("eNCgD", function(module, exports) {

var $2xBj3 = parcelRequire("2xBj3");
var $ac63535b20ca9f85$require$Buffer = $2xBj3.Buffer;
/**
 * This is a polyfill for the static method `isView` of `ArrayBuffer`, which is
 * e.g. missing in IE 10.
 *
 * @api private
 */ if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "undefined") ArrayBuffer.isView = function(arg) {
    return viewStrings.indexOf(Object.prototype.toString.call(arg)) > -1;
};
/**
 * @api private
 */ var viewStrings = [
    "[object Int8Array]",
    "[object Uint8Array]",
    "[object Uint8ClampedArray]",
    "[object Int16Array]",
    "[object Uint16Array]",
    "[object Int32Array]",
    "[object Uint32Array]",
    "[object Float32Array]",
    "[object Float64Array]",
    "[object DataView]"
];
/**
 * @api private
 */ function isEmptyData(data) {
    if (typeof data === "string") return data.length === 0;
    return data.byteLength === 0;
}
/**
 * @api private
 */ function convertToBuffer(data) {
    if (typeof data === "string") data = new $ac63535b20ca9f85$require$Buffer(data, "utf8");
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    return new Uint8Array(data);
}
/**
 * @api private
 */ module.exports = exports = {
    isEmptyData: isEmptyData,
    convertToBuffer: convertToBuffer
};

});
parcelRequire.register("2xBj3", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $1d9b9a1b3fb5c750$export$a143d493d941bafc; }, function (v) { return $1d9b9a1b3fb5c750$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $1d9b9a1b3fb5c750$export$f99ded8fe4b79145; }, function (v) { return $1d9b9a1b3fb5c750$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $1d9b9a1b3fb5c750$export$a143d493d941bafc;
var $1d9b9a1b3fb5c750$export$e4cf37d7f6fb9e0a;
var $1d9b9a1b3fb5c750$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $1d9b9a1b3fb5c750$export$599f31c3813fae4d;
"use strict";

var $RyRJ6 = parcelRequire("RyRJ6");

var $eYtri = parcelRequire("eYtri");

var $jp5KE = parcelRequire("jp5KE");
$1d9b9a1b3fb5c750$export$a143d493d941bafc = $1d9b9a1b3fb5c750$var$Buffer;
$1d9b9a1b3fb5c750$export$e4cf37d7f6fb9e0a = $1d9b9a1b3fb5c750$var$SlowBuffer;
$1d9b9a1b3fb5c750$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $1d9b9a1b3fb5c750$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $1d9b9a1b3fb5c750$var$typedArraySupport();
$1d9b9a1b3fb5c750$export$599f31c3813fae4d = $1d9b9a1b3fb5c750$var$kMaxLength();
function $1d9b9a1b3fb5c750$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $1d9b9a1b3fb5c750$var$kMaxLength() {
    return $1d9b9a1b3fb5c750$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $1d9b9a1b3fb5c750$var$createBuffer(that, length) {
    if ($1d9b9a1b3fb5c750$var$kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if ($1d9b9a1b3fb5c750$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $1d9b9a1b3fb5c750$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $1d9b9a1b3fb5c750$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $1d9b9a1b3fb5c750$var$Buffer(arg, encodingOrOffset, length) {
    if (!$1d9b9a1b3fb5c750$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $1d9b9a1b3fb5c750$var$Buffer)) return new $1d9b9a1b3fb5c750$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return $1d9b9a1b3fb5c750$var$allocUnsafe(this, arg);
    }
    return $1d9b9a1b3fb5c750$var$from(this, arg, encodingOrOffset, length);
}
$1d9b9a1b3fb5c750$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$1d9b9a1b3fb5c750$var$Buffer._augment = function(arr) {
    arr.__proto__ = $1d9b9a1b3fb5c750$var$Buffer.prototype;
    return arr;
};
function $1d9b9a1b3fb5c750$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return $1d9b9a1b3fb5c750$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return $1d9b9a1b3fb5c750$var$fromString(that, value, encodingOrOffset);
    return $1d9b9a1b3fb5c750$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $1d9b9a1b3fb5c750$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $1d9b9a1b3fb5c750$var$from(null, value, encodingOrOffset, length);
};
if ($1d9b9a1b3fb5c750$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $1d9b9a1b3fb5c750$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $1d9b9a1b3fb5c750$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && $1d9b9a1b3fb5c750$var$Buffer[Symbol.species] === $1d9b9a1b3fb5c750$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($1d9b9a1b3fb5c750$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $1d9b9a1b3fb5c750$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $1d9b9a1b3fb5c750$var$alloc(that, size, fill, encoding) {
    $1d9b9a1b3fb5c750$var$assertSize(size);
    if (size <= 0) return $1d9b9a1b3fb5c750$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? $1d9b9a1b3fb5c750$var$createBuffer(that, size).fill(fill, encoding) : $1d9b9a1b3fb5c750$var$createBuffer(that, size).fill(fill);
    return $1d9b9a1b3fb5c750$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $1d9b9a1b3fb5c750$var$Buffer.alloc = function(size, fill, encoding) {
    return $1d9b9a1b3fb5c750$var$alloc(null, size, fill, encoding);
};
function $1d9b9a1b3fb5c750$var$allocUnsafe(that, size) {
    $1d9b9a1b3fb5c750$var$assertSize(size);
    that = $1d9b9a1b3fb5c750$var$createBuffer(that, size < 0 ? 0 : $1d9b9a1b3fb5c750$var$checked(size) | 0);
    if (!$1d9b9a1b3fb5c750$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $1d9b9a1b3fb5c750$var$Buffer.allocUnsafe = function(size) {
    return $1d9b9a1b3fb5c750$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $1d9b9a1b3fb5c750$var$Buffer.allocUnsafeSlow = function(size) {
    return $1d9b9a1b3fb5c750$var$allocUnsafe(null, size);
};
function $1d9b9a1b3fb5c750$var$fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$1d9b9a1b3fb5c750$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $1d9b9a1b3fb5c750$var$byteLength(string, encoding) | 0;
    that = $1d9b9a1b3fb5c750$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $1d9b9a1b3fb5c750$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $1d9b9a1b3fb5c750$var$checked(array.length) | 0;
    that = $1d9b9a1b3fb5c750$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $1d9b9a1b3fb5c750$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($1d9b9a1b3fb5c750$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $1d9b9a1b3fb5c750$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $1d9b9a1b3fb5c750$var$fromArrayLike(that, array);
    return that;
}
function $1d9b9a1b3fb5c750$var$fromObject(that, obj) {
    if ($1d9b9a1b3fb5c750$var$Buffer.isBuffer(obj)) {
        var len = $1d9b9a1b3fb5c750$var$checked(obj.length) | 0;
        that = $1d9b9a1b3fb5c750$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || $1d9b9a1b3fb5c750$var$isnan(obj.length)) return $1d9b9a1b3fb5c750$var$createBuffer(that, 0);
            return $1d9b9a1b3fb5c750$var$fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && $jp5KE(obj.data)) return $1d9b9a1b3fb5c750$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function $1d9b9a1b3fb5c750$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $1d9b9a1b3fb5c750$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $1d9b9a1b3fb5c750$var$kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function $1d9b9a1b3fb5c750$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $1d9b9a1b3fb5c750$var$Buffer.alloc(+length);
}
$1d9b9a1b3fb5c750$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$1d9b9a1b3fb5c750$var$Buffer.compare = function compare(a, b) {
    if (!$1d9b9a1b3fb5c750$var$Buffer.isBuffer(a) || !$1d9b9a1b3fb5c750$var$Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$1d9b9a1b3fb5c750$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$1d9b9a1b3fb5c750$var$Buffer.concat = function concat(list, length) {
    if (!$jp5KE(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $1d9b9a1b3fb5c750$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $1d9b9a1b3fb5c750$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$1d9b9a1b3fb5c750$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $1d9b9a1b3fb5c750$var$byteLength(string, encoding) {
    if ($1d9b9a1b3fb5c750$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return $1d9b9a1b3fb5c750$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $1d9b9a1b3fb5c750$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $1d9b9a1b3fb5c750$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$1d9b9a1b3fb5c750$var$Buffer.byteLength = $1d9b9a1b3fb5c750$var$byteLength;
function $1d9b9a1b3fb5c750$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $1d9b9a1b3fb5c750$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $1d9b9a1b3fb5c750$var$utf8Slice(this, start, end);
        case "ascii":
            return $1d9b9a1b3fb5c750$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $1d9b9a1b3fb5c750$var$latin1Slice(this, start, end);
        case "base64":
            return $1d9b9a1b3fb5c750$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $1d9b9a1b3fb5c750$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$1d9b9a1b3fb5c750$var$Buffer.prototype._isBuffer = true;
function $1d9b9a1b3fb5c750$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$1d9b9a1b3fb5c750$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$1d9b9a1b3fb5c750$var$swap(this, i, i + 1);
    return this;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $1d9b9a1b3fb5c750$var$swap(this, i, i + 3);
        $1d9b9a1b3fb5c750$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $1d9b9a1b3fb5c750$var$swap(this, i, i + 7);
        $1d9b9a1b3fb5c750$var$swap(this, i + 1, i + 6);
        $1d9b9a1b3fb5c750$var$swap(this, i + 2, i + 5);
        $1d9b9a1b3fb5c750$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return $1d9b9a1b3fb5c750$var$utf8Slice(this, 0, length);
    return $1d9b9a1b3fb5c750$var$slowToString.apply(this, arguments);
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.equals = function equals(b) {
    if (!$1d9b9a1b3fb5c750$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $1d9b9a1b3fb5c750$var$Buffer.compare(this, b) === 0;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $1d9b9a1b3fb5c750$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$1d9b9a1b3fb5c750$var$Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $1d9b9a1b3fb5c750$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $1d9b9a1b3fb5c750$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($1d9b9a1b3fb5c750$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $1d9b9a1b3fb5c750$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($1d9b9a1b3fb5c750$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $1d9b9a1b3fb5c750$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $1d9b9a1b3fb5c750$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$1d9b9a1b3fb5c750$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $1d9b9a1b3fb5c750$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $1d9b9a1b3fb5c750$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $1d9b9a1b3fb5c750$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $1d9b9a1b3fb5c750$var$utf8Write(buf, string, offset, length) {
    return $1d9b9a1b3fb5c750$var$blitBuffer($1d9b9a1b3fb5c750$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $1d9b9a1b3fb5c750$var$asciiWrite(buf, string, offset, length) {
    return $1d9b9a1b3fb5c750$var$blitBuffer($1d9b9a1b3fb5c750$var$asciiToBytes(string), buf, offset, length);
}
function $1d9b9a1b3fb5c750$var$latin1Write(buf, string, offset, length) {
    return $1d9b9a1b3fb5c750$var$asciiWrite(buf, string, offset, length);
}
function $1d9b9a1b3fb5c750$var$base64Write(buf, string, offset, length) {
    return $1d9b9a1b3fb5c750$var$blitBuffer($1d9b9a1b3fb5c750$var$base64ToBytes(string), buf, offset, length);
}
function $1d9b9a1b3fb5c750$var$ucs2Write(buf, string, offset, length) {
    return $1d9b9a1b3fb5c750$var$blitBuffer($1d9b9a1b3fb5c750$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$1d9b9a1b3fb5c750$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $1d9b9a1b3fb5c750$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $1d9b9a1b3fb5c750$var$utf8Write(this, string, offset, length);
        case "ascii":
            return $1d9b9a1b3fb5c750$var$asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return $1d9b9a1b3fb5c750$var$latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $1d9b9a1b3fb5c750$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $1d9b9a1b3fb5c750$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $1d9b9a1b3fb5c750$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $RyRJ6.fromByteArray(buf);
    else return $RyRJ6.fromByteArray(buf.slice(start, end));
}
function $1d9b9a1b3fb5c750$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $1d9b9a1b3fb5c750$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $1d9b9a1b3fb5c750$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $1d9b9a1b3fb5c750$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $1d9b9a1b3fb5c750$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $1d9b9a1b3fb5c750$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $1d9b9a1b3fb5c750$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $1d9b9a1b3fb5c750$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $1d9b9a1b3fb5c750$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $1d9b9a1b3fb5c750$var$toHex(buf[i]);
    return out;
}
function $1d9b9a1b3fb5c750$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$1d9b9a1b3fb5c750$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($1d9b9a1b3fb5c750$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $1d9b9a1b3fb5c750$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $1d9b9a1b3fb5c750$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $1d9b9a1b3fb5c750$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$1d9b9a1b3fb5c750$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkOffset(offset, 4, this.length);
    return $eYtri.read(this, offset, true, 23, 4);
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkOffset(offset, 4, this.length);
    return $eYtri.read(this, offset, false, 23, 4);
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkOffset(offset, 8, this.length);
    return $eYtri.read(this, offset, true, 52, 8);
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkOffset(offset, 8, this.length);
    return $eYtri.read(this, offset, false, 52, 8);
};
function $1d9b9a1b3fb5c750$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$1d9b9a1b3fb5c750$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$1d9b9a1b3fb5c750$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $1d9b9a1b3fb5c750$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $1d9b9a1b3fb5c750$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$1d9b9a1b3fb5c750$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $1d9b9a1b3fb5c750$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$1d9b9a1b3fb5c750$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($1d9b9a1b3fb5c750$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $1d9b9a1b3fb5c750$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($1d9b9a1b3fb5c750$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $1d9b9a1b3fb5c750$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $1d9b9a1b3fb5c750$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$1d9b9a1b3fb5c750$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($1d9b9a1b3fb5c750$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $1d9b9a1b3fb5c750$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($1d9b9a1b3fb5c750$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $1d9b9a1b3fb5c750$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $1d9b9a1b3fb5c750$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $1d9b9a1b3fb5c750$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$1d9b9a1b3fb5c750$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($1d9b9a1b3fb5c750$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $1d9b9a1b3fb5c750$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($1d9b9a1b3fb5c750$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $1d9b9a1b3fb5c750$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($1d9b9a1b3fb5c750$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $1d9b9a1b3fb5c750$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($1d9b9a1b3fb5c750$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $1d9b9a1b3fb5c750$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $1d9b9a1b3fb5c750$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $1d9b9a1b3fb5c750$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $eYtri.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$1d9b9a1b3fb5c750$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $1d9b9a1b3fb5c750$var$writeFloat(this, value, offset, true, noAssert);
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $1d9b9a1b3fb5c750$var$writeFloat(this, value, offset, false, noAssert);
};
function $1d9b9a1b3fb5c750$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $1d9b9a1b3fb5c750$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $eYtri.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$1d9b9a1b3fb5c750$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $1d9b9a1b3fb5c750$var$writeDouble(this, value, offset, true, noAssert);
};
$1d9b9a1b3fb5c750$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $1d9b9a1b3fb5c750$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$1d9b9a1b3fb5c750$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$1d9b9a1b3fb5c750$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$1d9b9a1b3fb5c750$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$1d9b9a1b3fb5c750$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $1d9b9a1b3fb5c750$var$Buffer.isBuffer(val) ? val : $1d9b9a1b3fb5c750$var$utf8ToBytes(new $1d9b9a1b3fb5c750$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $1d9b9a1b3fb5c750$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $1d9b9a1b3fb5c750$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $1d9b9a1b3fb5c750$var$stringtrim(str).replace($1d9b9a1b3fb5c750$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $1d9b9a1b3fb5c750$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function $1d9b9a1b3fb5c750$var$toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function $1d9b9a1b3fb5c750$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $1d9b9a1b3fb5c750$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $1d9b9a1b3fb5c750$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $1d9b9a1b3fb5c750$var$base64ToBytes(str) {
    return $RyRJ6.toByteArray($1d9b9a1b3fb5c750$var$base64clean(str));
}
function $1d9b9a1b3fb5c750$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $1d9b9a1b3fb5c750$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}

});
parcelRequire.register("eYtri", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $ae6d81501249bb10$export$aafa59e2e03f2942; }, function (v) { return $ae6d81501249bb10$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $ae6d81501249bb10$export$68d8715fc104d294; }, function (v) { return $ae6d81501249bb10$export$68d8715fc104d294 = v; });
var $ae6d81501249bb10$export$aafa59e2e03f2942;
var $ae6d81501249bb10$export$68d8715fc104d294;
$ae6d81501249bb10$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$ae6d81501249bb10$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});

parcelRequire.register("jp5KE", function(module, exports) {
var $e204d03a5bccc936$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $e204d03a5bccc936$var$toString.call(arr) == "[object Array]";
};

});




parcelRequire.register("943Tu", function(module, exports) {

var $eNCgD = parcelRequire("eNCgD");

var $2xBj3 = parcelRequire("2xBj3");
var $6997820a85c19be6$require$Buffer = $2xBj3.Buffer;
var BLOCK_SIZE = 64;
var DIGEST_LENGTH = 16;
var INIT = [
    0x67452301,
    0xefcdab89,
    0x98badcfe,
    0x10325476
];
/**
 * @api private
 */ function Md5() {
    this.state = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476
    ];
    this.buffer = new DataView(new ArrayBuffer(BLOCK_SIZE));
    this.bufferLength = 0;
    this.bytesHashed = 0;
    this.finished = false;
}
/**
 * @api private
 */ module.exports = exports = Md5;
Md5.BLOCK_SIZE = BLOCK_SIZE;
Md5.prototype.update = function(sourceData) {
    if ($eNCgD.isEmptyData(sourceData)) return this;
    else if (this.finished) throw new Error("Attempted to update an already finished hash.");
    var data = $eNCgD.convertToBuffer(sourceData);
    var position = 0;
    var byteLength = data.byteLength;
    this.bytesHashed += byteLength;
    while(byteLength > 0){
        this.buffer.setUint8(this.bufferLength++, data[position++]);
        byteLength--;
        if (this.bufferLength === BLOCK_SIZE) {
            this.hashBuffer();
            this.bufferLength = 0;
        }
    }
    return this;
};
Md5.prototype.digest = function(encoding) {
    if (!this.finished) {
        var _a = this, buffer = _a.buffer, undecoratedLength = _a.bufferLength, bytesHashed = _a.bytesHashed;
        var bitsHashed = bytesHashed * 8;
        buffer.setUint8(this.bufferLength++, 128);
        // Ensure the final block has enough room for the hashed length
        if (undecoratedLength % BLOCK_SIZE >= BLOCK_SIZE - 8) {
            for(var i = this.bufferLength; i < BLOCK_SIZE; i++)buffer.setUint8(i, 0);
            this.hashBuffer();
            this.bufferLength = 0;
        }
        for(var i = this.bufferLength; i < BLOCK_SIZE - 8; i++)buffer.setUint8(i, 0);
        buffer.setUint32(BLOCK_SIZE - 8, bitsHashed >>> 0, true);
        buffer.setUint32(BLOCK_SIZE - 4, Math.floor(bitsHashed / 0x100000000), true);
        this.hashBuffer();
        this.finished = true;
    }
    var out = new DataView(new ArrayBuffer(DIGEST_LENGTH));
    for(var i = 0; i < 4; i++)out.setUint32(i * 4, this.state[i], true);
    var buff = new $6997820a85c19be6$require$Buffer(out.buffer, out.byteOffset, out.byteLength);
    return encoding ? buff.toString(encoding) : buff;
};
Md5.prototype.hashBuffer = function() {
    var _a = this, buffer = _a.buffer, state = _a.state;
    var a = state[0], b = state[1], c = state[2], d = state[3];
    a = ff(a, b, c, d, buffer.getUint32(0, true), 7, 0xd76aa478);
    d = ff(d, a, b, c, buffer.getUint32(4, true), 12, 0xe8c7b756);
    c = ff(c, d, a, b, buffer.getUint32(8, true), 17, 0x242070db);
    b = ff(b, c, d, a, buffer.getUint32(12, true), 22, 0xc1bdceee);
    a = ff(a, b, c, d, buffer.getUint32(16, true), 7, 0xf57c0faf);
    d = ff(d, a, b, c, buffer.getUint32(20, true), 12, 0x4787c62a);
    c = ff(c, d, a, b, buffer.getUint32(24, true), 17, 0xa8304613);
    b = ff(b, c, d, a, buffer.getUint32(28, true), 22, 0xfd469501);
    a = ff(a, b, c, d, buffer.getUint32(32, true), 7, 0x698098d8);
    d = ff(d, a, b, c, buffer.getUint32(36, true), 12, 0x8b44f7af);
    c = ff(c, d, a, b, buffer.getUint32(40, true), 17, 0xffff5bb1);
    b = ff(b, c, d, a, buffer.getUint32(44, true), 22, 0x895cd7be);
    a = ff(a, b, c, d, buffer.getUint32(48, true), 7, 0x6b901122);
    d = ff(d, a, b, c, buffer.getUint32(52, true), 12, 0xfd987193);
    c = ff(c, d, a, b, buffer.getUint32(56, true), 17, 0xa679438e);
    b = ff(b, c, d, a, buffer.getUint32(60, true), 22, 0x49b40821);
    a = gg(a, b, c, d, buffer.getUint32(4, true), 5, 0xf61e2562);
    d = gg(d, a, b, c, buffer.getUint32(24, true), 9, 0xc040b340);
    c = gg(c, d, a, b, buffer.getUint32(44, true), 14, 0x265e5a51);
    b = gg(b, c, d, a, buffer.getUint32(0, true), 20, 0xe9b6c7aa);
    a = gg(a, b, c, d, buffer.getUint32(20, true), 5, 0xd62f105d);
    d = gg(d, a, b, c, buffer.getUint32(40, true), 9, 0x02441453);
    c = gg(c, d, a, b, buffer.getUint32(60, true), 14, 0xd8a1e681);
    b = gg(b, c, d, a, buffer.getUint32(16, true), 20, 0xe7d3fbc8);
    a = gg(a, b, c, d, buffer.getUint32(36, true), 5, 0x21e1cde6);
    d = gg(d, a, b, c, buffer.getUint32(56, true), 9, 0xc33707d6);
    c = gg(c, d, a, b, buffer.getUint32(12, true), 14, 0xf4d50d87);
    b = gg(b, c, d, a, buffer.getUint32(32, true), 20, 0x455a14ed);
    a = gg(a, b, c, d, buffer.getUint32(52, true), 5, 0xa9e3e905);
    d = gg(d, a, b, c, buffer.getUint32(8, true), 9, 0xfcefa3f8);
    c = gg(c, d, a, b, buffer.getUint32(28, true), 14, 0x676f02d9);
    b = gg(b, c, d, a, buffer.getUint32(48, true), 20, 0x8d2a4c8a);
    a = hh(a, b, c, d, buffer.getUint32(20, true), 4, 0xfffa3942);
    d = hh(d, a, b, c, buffer.getUint32(32, true), 11, 0x8771f681);
    c = hh(c, d, a, b, buffer.getUint32(44, true), 16, 0x6d9d6122);
    b = hh(b, c, d, a, buffer.getUint32(56, true), 23, 0xfde5380c);
    a = hh(a, b, c, d, buffer.getUint32(4, true), 4, 0xa4beea44);
    d = hh(d, a, b, c, buffer.getUint32(16, true), 11, 0x4bdecfa9);
    c = hh(c, d, a, b, buffer.getUint32(28, true), 16, 0xf6bb4b60);
    b = hh(b, c, d, a, buffer.getUint32(40, true), 23, 0xbebfbc70);
    a = hh(a, b, c, d, buffer.getUint32(52, true), 4, 0x289b7ec6);
    d = hh(d, a, b, c, buffer.getUint32(0, true), 11, 0xeaa127fa);
    c = hh(c, d, a, b, buffer.getUint32(12, true), 16, 0xd4ef3085);
    b = hh(b, c, d, a, buffer.getUint32(24, true), 23, 0x04881d05);
    a = hh(a, b, c, d, buffer.getUint32(36, true), 4, 0xd9d4d039);
    d = hh(d, a, b, c, buffer.getUint32(48, true), 11, 0xe6db99e5);
    c = hh(c, d, a, b, buffer.getUint32(60, true), 16, 0x1fa27cf8);
    b = hh(b, c, d, a, buffer.getUint32(8, true), 23, 0xc4ac5665);
    a = ii(a, b, c, d, buffer.getUint32(0, true), 6, 0xf4292244);
    d = ii(d, a, b, c, buffer.getUint32(28, true), 10, 0x432aff97);
    c = ii(c, d, a, b, buffer.getUint32(56, true), 15, 0xab9423a7);
    b = ii(b, c, d, a, buffer.getUint32(20, true), 21, 0xfc93a039);
    a = ii(a, b, c, d, buffer.getUint32(48, true), 6, 0x655b59c3);
    d = ii(d, a, b, c, buffer.getUint32(12, true), 10, 0x8f0ccc92);
    c = ii(c, d, a, b, buffer.getUint32(40, true), 15, 0xffeff47d);
    b = ii(b, c, d, a, buffer.getUint32(4, true), 21, 0x85845dd1);
    a = ii(a, b, c, d, buffer.getUint32(32, true), 6, 0x6fa87e4f);
    d = ii(d, a, b, c, buffer.getUint32(60, true), 10, 0xfe2ce6e0);
    c = ii(c, d, a, b, buffer.getUint32(24, true), 15, 0xa3014314);
    b = ii(b, c, d, a, buffer.getUint32(52, true), 21, 0x4e0811a1);
    a = ii(a, b, c, d, buffer.getUint32(16, true), 6, 0xf7537e82);
    d = ii(d, a, b, c, buffer.getUint32(44, true), 10, 0xbd3af235);
    c = ii(c, d, a, b, buffer.getUint32(8, true), 15, 0x2ad7d2bb);
    b = ii(b, c, d, a, buffer.getUint32(36, true), 21, 0xeb86d391);
    state[0] = a + state[0] & 0xFFFFFFFF;
    state[1] = b + state[1] & 0xFFFFFFFF;
    state[2] = c + state[2] & 0xFFFFFFFF;
    state[3] = d + state[3] & 0xFFFFFFFF;
};
function cmn(q, a, b, x, s, t) {
    a = (a + q & 0xFFFFFFFF) + (x + t & 0xFFFFFFFF) & 0xFFFFFFFF;
    return (a << s | a >>> 32 - s) + b & 0xFFFFFFFF;
}
function ff(a, b, c, d, x, s, t) {
    return cmn(b & c | ~b & d, a, b, x, s, t);
}
function gg(a, b, c, d, x, s, t) {
    return cmn(b & d | c & ~d, a, b, x, s, t);
}
function hh(a, b, c, d, x, s, t) {
    return cmn(b ^ c ^ d, a, b, x, s, t);
}
function ii(a, b, c, d, x, s, t) {
    return cmn(c ^ (b | ~d), a, b, x, s, t);
}

});

parcelRequire.register("er33i", function(module, exports) {

var $2xBj3 = parcelRequire("2xBj3");
var $a825f463c1f4866f$require$Buffer = $2xBj3.Buffer;

var $eNCgD = parcelRequire("eNCgD");
var BLOCK_SIZE = 64;
var DIGEST_LENGTH = 20;
var KEY = new Uint32Array([
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
]);
var INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
var MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
/**
 * @api private
 */ function Sha1() {
    this.h0 = 0x67452301;
    this.h1 = 0xEFCDAB89;
    this.h2 = 0x98BADCFE;
    this.h3 = 0x10325476;
    this.h4 = 0xC3D2E1F0;
    // The first 64 bytes (16 words) is the data chunk
    this.block = new Uint32Array(80);
    this.offset = 0;
    this.shift = 24;
    this.totalLength = 0;
}
/**
 * @api private
 */ module.exports = exports = Sha1;
Sha1.BLOCK_SIZE = BLOCK_SIZE;
Sha1.prototype.update = function(data) {
    if (this.finished) throw new Error("Attempted to update an already finished hash.");
    if ($eNCgD.isEmptyData(data)) return this;
    data = $eNCgD.convertToBuffer(data);
    var length = data.length;
    this.totalLength += length * 8;
    for(var i = 0; i < length; i++)this.write(data[i]);
    return this;
};
Sha1.prototype.write = function write(byte) {
    this.block[this.offset] |= (byte & 0xff) << this.shift;
    if (this.shift) this.shift -= 8;
    else {
        this.offset++;
        this.shift = 24;
    }
    if (this.offset === 16) this.processBlock();
};
Sha1.prototype.digest = function(encoding) {
    // Pad
    this.write(0x80);
    if (this.offset > 14 || this.offset === 14 && this.shift < 24) this.processBlock();
    this.offset = 14;
    this.shift = 24;
    // 64-bit length big-endian
    this.write(0x00); // numbers this big aren't accurate in javascript anyway
    this.write(0x00); // ..So just hard-code to zero.
    this.write(this.totalLength > 0xffffffffff ? this.totalLength / 0x10000000000 : 0x00);
    this.write(this.totalLength > 0xffffffff ? this.totalLength / 0x100000000 : 0x00);
    for(var s = 24; s >= 0; s -= 8)this.write(this.totalLength >> s);
    // The value in state is little-endian rather than big-endian, so flip
    // each word into a new Uint8Array
    var out = new $a825f463c1f4866f$require$Buffer(DIGEST_LENGTH);
    var outView = new DataView(out.buffer);
    outView.setUint32(0, this.h0, false);
    outView.setUint32(4, this.h1, false);
    outView.setUint32(8, this.h2, false);
    outView.setUint32(12, this.h3, false);
    outView.setUint32(16, this.h4, false);
    return encoding ? out.toString(encoding) : out;
};
Sha1.prototype.processBlock = function processBlock() {
    // Extend the sixteen 32-bit words into eighty 32-bit words:
    for(var i = 16; i < 80; i++){
        var w = this.block[i - 3] ^ this.block[i - 8] ^ this.block[i - 14] ^ this.block[i - 16];
        this.block[i] = w << 1 | w >>> 31;
    }
    // Initialize hash value for this chunk:
    var a = this.h0;
    var b = this.h1;
    var c = this.h2;
    var d = this.h3;
    var e = this.h4;
    var f, k;
    // Main loop:
    for(i = 0; i < 80; i++){
        if (i < 20) {
            f = d ^ b & (c ^ d);
            k = 0x5A827999;
        } else if (i < 40) {
            f = b ^ c ^ d;
            k = 0x6ED9EBA1;
        } else if (i < 60) {
            f = b & c | d & (b | c);
            k = 0x8F1BBCDC;
        } else {
            f = b ^ c ^ d;
            k = 0xCA62C1D6;
        }
        var temp = (a << 5 | a >>> 27) + f + e + k + (this.block[i] | 0);
        e = d;
        d = c;
        c = b << 30 | b >>> 2;
        b = a;
        a = temp;
    }
    // Add this chunk's hash to result so far:
    this.h0 = this.h0 + a | 0;
    this.h1 = this.h1 + b | 0;
    this.h2 = this.h2 + c | 0;
    this.h3 = this.h3 + d | 0;
    this.h4 = this.h4 + e | 0;
    // The block is now reusable.
    this.offset = 0;
    for(i = 0; i < 16; i++)this.block[i] = 0;
};

});

parcelRequire.register("cE2Xz", function(module, exports) {

var $2xBj3 = parcelRequire("2xBj3");
var $02602f8d57291dd7$require$Buffer = $2xBj3.Buffer;

var $eNCgD = parcelRequire("eNCgD");
var BLOCK_SIZE = 64;
var DIGEST_LENGTH = 32;
var KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
var INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
var MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
/**
 * @private
 */ function Sha256() {
    this.state = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.temp = new Int32Array(64);
    this.buffer = new Uint8Array(64);
    this.bufferLength = 0;
    this.bytesHashed = 0;
    /**
     * @private
     */ this.finished = false;
}
/**
 * @api private
 */ module.exports = exports = Sha256;
Sha256.BLOCK_SIZE = BLOCK_SIZE;
Sha256.prototype.update = function(data) {
    if (this.finished) throw new Error("Attempted to update an already finished hash.");
    if ($eNCgD.isEmptyData(data)) return this;
    data = $eNCgD.convertToBuffer(data);
    var position = 0;
    var byteLength = data.byteLength;
    this.bytesHashed += byteLength;
    if (this.bytesHashed * 8 > MAX_HASHABLE_LENGTH) throw new Error("Cannot hash more than 2^53 - 1 bits");
    while(byteLength > 0){
        this.buffer[this.bufferLength++] = data[position++];
        byteLength--;
        if (this.bufferLength === BLOCK_SIZE) {
            this.hashBuffer();
            this.bufferLength = 0;
        }
    }
    return this;
};
Sha256.prototype.digest = function(encoding) {
    if (!this.finished) {
        var bitsHashed = this.bytesHashed * 8;
        var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
        var undecoratedLength = this.bufferLength;
        bufferView.setUint8(this.bufferLength++, 0x80);
        // Ensure the final block has enough room for the hashed length
        if (undecoratedLength % BLOCK_SIZE >= BLOCK_SIZE - 8) {
            for(var i = this.bufferLength; i < BLOCK_SIZE; i++)bufferView.setUint8(i, 0);
            this.hashBuffer();
            this.bufferLength = 0;
        }
        for(var i = this.bufferLength; i < BLOCK_SIZE - 8; i++)bufferView.setUint8(i, 0);
        bufferView.setUint32(BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
        bufferView.setUint32(BLOCK_SIZE - 4, bitsHashed);
        this.hashBuffer();
        this.finished = true;
    }
    // The value in state is little-endian rather than big-endian, so flip
    // each word into a new Uint8Array
    var out = new $02602f8d57291dd7$require$Buffer(DIGEST_LENGTH);
    for(var i = 0; i < 8; i++){
        out[i * 4] = this.state[i] >>> 24 & 0xff;
        out[i * 4 + 1] = this.state[i] >>> 16 & 0xff;
        out[i * 4 + 2] = this.state[i] >>> 8 & 0xff;
        out[i * 4 + 3] = this.state[i] >>> 0 & 0xff;
    }
    return encoding ? out.toString(encoding) : out;
};
Sha256.prototype.hashBuffer = function() {
    var _a = this, buffer = _a.buffer, state = _a.state;
    var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
    for(var i = 0; i < BLOCK_SIZE; i++){
        if (i < 16) this.temp[i] = (buffer[i * 4] & 0xff) << 24 | (buffer[i * 4 + 1] & 0xff) << 16 | (buffer[i * 4 + 2] & 0xff) << 8 | buffer[i * 4 + 3] & 0xff;
        else {
            var u = this.temp[i - 2];
            var t1_1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
            u = this.temp[i - 15];
            var t2_1 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
            this.temp[i] = (t1_1 + this.temp[i - 7] | 0) + (t2_1 + this.temp[i - 16] | 0);
        }
        var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (KEY[i] + this.temp[i] | 0) | 0) | 0;
        var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
        state7 = state6;
        state6 = state5;
        state5 = state4;
        state4 = state3 + t1 | 0;
        state3 = state2;
        state2 = state1;
        state1 = state0;
        state0 = t1 + t2 | 0;
    }
    state[0] += state0;
    state[1] += state1;
    state[2] += state2;
    state[3] += state3;
    state[4] += state4;
    state[5] += state5;
    state[6] += state6;
    state[7] += state7;
};

});


parcelRequire.register("g1P72", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $bab46334a9e58315$export$98e6a39c04603d36; }, function (v) { return $bab46334a9e58315$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "resolve", function () { return $bab46334a9e58315$export$f7ad0328861e2f03; }, function (v) { return $bab46334a9e58315$export$f7ad0328861e2f03 = v; });
$parcel$export(module.exports, "resolveObject", function () { return $bab46334a9e58315$export$7daf1a5d2f4dd018; }, function (v) { return $bab46334a9e58315$export$7daf1a5d2f4dd018 = v; });
$parcel$export(module.exports, "format", function () { return $bab46334a9e58315$export$d9468344d3651243; }, function (v) { return $bab46334a9e58315$export$d9468344d3651243 = v; });
$parcel$export(module.exports, "Url", function () { return $bab46334a9e58315$export$59d795186a5d3f58; }, function (v) { return $bab46334a9e58315$export$59d795186a5d3f58 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $bab46334a9e58315$export$98e6a39c04603d36;
var $bab46334a9e58315$export$f7ad0328861e2f03;
var $bab46334a9e58315$export$7daf1a5d2f4dd018;
var $bab46334a9e58315$export$d9468344d3651243;
var $bab46334a9e58315$export$59d795186a5d3f58;

var $8nQOF = parcelRequire("8nQOF");
$bab46334a9e58315$export$98e6a39c04603d36 = $bab46334a9e58315$var$urlParse;
$bab46334a9e58315$export$f7ad0328861e2f03 = $bab46334a9e58315$var$urlResolve;
$bab46334a9e58315$export$7daf1a5d2f4dd018 = $bab46334a9e58315$var$urlResolveObject;
$bab46334a9e58315$export$d9468344d3651243 = $bab46334a9e58315$var$urlFormat;
$bab46334a9e58315$export$59d795186a5d3f58 = $bab46334a9e58315$var$Url;
function $bab46334a9e58315$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $bab46334a9e58315$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $bab46334a9e58315$var$portPattern = /:[0-9]*$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$bab46334a9e58315$var$delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
$bab46334a9e58315$var$unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat($bab46334a9e58315$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$bab46334a9e58315$var$autoEscape = [
    "'"
].concat($bab46334a9e58315$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$bab46334a9e58315$var$nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat($bab46334a9e58315$var$autoEscape), $bab46334a9e58315$var$hostEndingChars = [
    "/",
    "?",
    "#"
], $bab46334a9e58315$var$hostnameMaxLen = 255, $bab46334a9e58315$var$hostnamePartPattern = /^[a-z0-9A-Z_-]{0,63}$/, $bab46334a9e58315$var$hostnamePartStart = /^([a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
$bab46334a9e58315$var$unsafeProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that never have a hostname.
$bab46334a9e58315$var$hostlessProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that always contain a // bit.
$bab46334a9e58315$var$slashedProtocol = {
    "http": true,
    "https": true,
    "ftp": true,
    "gopher": true,
    "file": true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};

var $4zfGi = parcelRequire("4zfGi");
function $bab46334a9e58315$var$urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && $bab46334a9e58315$var$isObject(url) && url instanceof $bab46334a9e58315$var$Url) return url;
    var u = new $bab46334a9e58315$var$Url;
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
$bab46334a9e58315$var$Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (!$bab46334a9e58315$var$isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    var rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    var proto = $bab46334a9e58315$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && $bab46334a9e58315$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$bab46334a9e58315$var$hostlessProtocol[proto] && (slashes || proto && !$bab46334a9e58315$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < $bab46334a9e58315$var$hostEndingChars.length; i++){
            var hec = rest.indexOf($bab46334a9e58315$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf("@", hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < $bab46334a9e58315$var$nonHostChars.length; i++){
            var hec = rest.indexOf($bab46334a9e58315$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || "";
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($bab46334a9e58315$var$hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($bab46334a9e58315$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($bab46334a9e58315$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $bab46334a9e58315$var$hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) {
            // IDNA Support: Returns a puny coded representation of "domain".
            // It only converts the part of the domain name that
            // has non ASCII characters. I.e. it dosent matter if
            // you call it with a domain that already is in ASCII.
            var domainArray = this.hostname.split(".");
            var newOut = [];
            for(var i = 0; i < domainArray.length; ++i){
                var s = domainArray[i];
                newOut.push(s.match(/[^A-Za-z0-9_-]/) ? "xn--" + $8nQOF.encode(s) : s);
            }
            this.hostname = newOut.join(".");
        }
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    // now rest is set to the post-host stuff.
    // chop off any delim chars.
    if (!$bab46334a9e58315$var$unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for(var i = 0, l = $bab46334a9e58315$var$autoEscape.length; i < l; i++){
        var ae = $bab46334a9e58315$var$autoEscape[i];
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $4zfGi.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if ($bab46334a9e58315$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    //to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function $bab46334a9e58315$var$urlFormat(obj) {
    // ensure it's an object, and not a string url.
    // If it's an obj, this is a no-op.
    // this way, you can call url_format() on strings
    // to clean up potentially wonky urls.
    if ($bab46334a9e58315$var$isString(obj)) obj = $bab46334a9e58315$var$urlParse(obj);
    if (!(obj instanceof $bab46334a9e58315$var$Url)) return $bab46334a9e58315$var$Url.prototype.format.call(obj);
    return obj.format();
}
$bab46334a9e58315$var$Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && $bab46334a9e58315$var$isObject(this.query) && Object.keys(this.query).length) query = $4zfGi.stringify(this.query);
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
    // unless they had them to begin with.
    if (this.slashes || (!protocol || $bab46334a9e58315$var$slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function $bab46334a9e58315$var$urlResolve(source, relative) {
    return $bab46334a9e58315$var$urlParse(source, false, true).resolve(relative);
}
$bab46334a9e58315$var$Url.prototype.resolve = function(relative) {
    return this.resolveObject($bab46334a9e58315$var$urlParse(relative, false, true)).format();
};
function $bab46334a9e58315$var$urlResolveObject(source, relative) {
    if (!source) return relative;
    return $bab46334a9e58315$var$urlParse(source, false, true).resolveObject(relative);
}
$bab46334a9e58315$var$Url.prototype.resolveObject = function(relative) {
    if ($bab46334a9e58315$var$isString(relative)) {
        var rel = new $bab46334a9e58315$var$Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new $bab46334a9e58315$var$Url();
    Object.keys(this).forEach(function(k) {
        result[k] = this[k];
    }, this);
    // hash is always overridden, no matter what.
    // even href="" will remove it.
    result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        Object.keys(relative).forEach(function(k) {
            if (k !== "protocol") result[k] = relative[k];
        });
        //urlParse appends trailing / to urls like http://www.example.com
        if ($bab46334a9e58315$var$slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = "/";
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        // if it's a known url protocol, then changing
        // the protocol does weird things
        // first, if it's not file:, then we MUST have a host,
        // and if there was a path
        // to begin with, then we MUST have a path.
        // if it is file:, then the host is dropped,
        // because that's known to be hostless.
        // anything else is assumed to be absolute.
        if (!$bab46334a9e58315$var$slashedProtocol[relative.protocol]) {
            Object.keys(relative).forEach(function(k) {
                result[k] = relative[k];
            });
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !$bab46334a9e58315$var$hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !$bab46334a9e58315$var$slashedProtocol[result.protocol];
    // if the url is a non-slashed url, then relative
    // links like ../.. should be able
    // to crawl up to the hostname, as well.  This is strange.
    // result.protocol has already been set by now.
    // Later on, put the first path part into the host field.
    if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        // it's relative
        // throw away the existing file, and take the new path instead.
        if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (!$bab46334a9e58315$var$isNullOrUndefined(relative.search)) {
        // just pull out the search.
        // like href='?foo'.
        // Put this after the other two cases because it simplifies the booleans
        if (psychotic) {
            result.hostname = result.host = srcPath.shift();
            //occationaly the auth can get stuck only in host
            //this especialy happens in cases like
            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
            var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.host = result.hostname = authInHost.shift();
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        //to support http.request
        if (!$bab46334a9e58315$var$isNull(result.pathname) || !$bab46334a9e58315$var$isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        // no path at all.  easy.
        // we've already handled the other stuff above.
        result.pathname = null;
        //to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    // if a url ENDs in . or .., then it must get a trailing slash.
    // however, if it ends in anything else non-slashy,
    // then it must NOT get a trailing slash.
    var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host) && (last === "." || last === "..") || last === "";
    // strip single dots, resolve double dots to parent dir
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last == ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = result.host = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        //occationaly the auth can get stuck only in host
        //this especialy happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
        var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
    } else result.pathname = srcPath.join("/");
    //to support request.http
    if (!$bab46334a9e58315$var$isNull(result.pathname) || !$bab46334a9e58315$var$isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
$bab46334a9e58315$var$Url.prototype.parseHost = function() {
    var host = this.host;
    var port = $bab46334a9e58315$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
function $bab46334a9e58315$var$isString(arg) {
    return typeof arg === "string";
}
function $bab46334a9e58315$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
function $bab46334a9e58315$var$isNull(arg) {
    return arg === null;
}
function $bab46334a9e58315$var$isNullOrUndefined(arg) {
    return arg == null;
}

});
parcelRequire.register("8nQOF", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.3.2",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) freeModule.exports = punycode;
        else for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else root.punycode = punycode;
})(this);

});


parcelRequire.register("kCuzU", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $f02f136bf9d712e9$export$2f872c0f2117be69; }, function (v) { return $f02f136bf9d712e9$export$2f872c0f2117be69 = v; });
$parcel$export(module.exports, "parse", function () { return $f02f136bf9d712e9$export$98e6a39c04603d36; }, function (v) { return $f02f136bf9d712e9$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "encode", function () { return $f02f136bf9d712e9$export$c564cdbbe6da493; }, function (v) { return $f02f136bf9d712e9$export$c564cdbbe6da493 = v; });
$parcel$export(module.exports, "stringify", function () { return $f02f136bf9d712e9$export$fac44ee5b035f737; }, function (v) { return $f02f136bf9d712e9$export$fac44ee5b035f737 = v; });
var $f02f136bf9d712e9$export$2f872c0f2117be69;
var $f02f136bf9d712e9$export$98e6a39c04603d36;
var $f02f136bf9d712e9$export$c564cdbbe6da493;
var $f02f136bf9d712e9$export$fac44ee5b035f737;
"use strict";

$f02f136bf9d712e9$export$2f872c0f2117be69 = $f02f136bf9d712e9$export$98e6a39c04603d36 = (parcelRequire("eUOpG"));

$f02f136bf9d712e9$export$c564cdbbe6da493 = $f02f136bf9d712e9$export$fac44ee5b035f737 = (parcelRequire("2y33c"));

});
parcelRequire.register("eUOpG", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $adbd66a699acb136$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || "&";
    eq = eq || "=";
    var obj = {};
    if (typeof qs !== "string" || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === "number") maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, "%20"), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = "";
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$adbd66a699acb136$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if (Array.isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};

});

parcelRequire.register("2y33c", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $1db11f888650efb0$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case "string":
            return v;
        case "boolean":
            return v ? "true" : "false";
        case "number":
            return isFinite(v) ? v : "";
        default:
            return "";
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || "&";
    eq = eq || "=";
    if (obj === null) obj = undefined;
    if (typeof obj === "object") return Object.keys(obj).map(function(k) {
        var ks = encodeURIComponent($1db11f888650efb0$var$stringifyPrimitive(k)) + eq;
        if (Array.isArray(obj[k])) return obj[k].map(function(v) {
            return ks + encodeURIComponent($1db11f888650efb0$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($1db11f888650efb0$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return "";
    return encodeURIComponent($1db11f888650efb0$var$stringifyPrimitive(name)) + eq + encodeURIComponent($1db11f888650efb0$var$stringifyPrimitive(obj));
};

});


parcelRequire.register("48XNY", function(module, exports) {
module.exports = {
    //provide realtime clock for performance measurement
    now: function now() {
        if (typeof performance !== "undefined" && typeof performance.now === "function") return performance.now();
        return Date.now();
    }
};

});

parcelRequire.register("bjVXf", function(module, exports) {

var $4uCzt = parcelRequire("4uCzt");
var $02207d9fa224bc6e$require$eventMessageChunker = $4uCzt.eventMessageChunker;

var $bktu7 = parcelRequire("bktu7");
var $02207d9fa224bc6e$require$parseEvent = $bktu7.parseEvent;
function $02207d9fa224bc6e$var$createEventStream(body, parser, model) {
    var eventMessages = $02207d9fa224bc6e$require$eventMessageChunker(body);
    var events = [];
    for(var i = 0; i < eventMessages.length; i++)events.push($02207d9fa224bc6e$require$parseEvent(parser, eventMessages[i], model));
    return events;
}
/**
 * @api private
 */ module.exports = {
    createEventStream: $02207d9fa224bc6e$var$createEventStream
};

});
parcelRequire.register("4uCzt", function(module, exports) {
/**
 * Takes in a buffer of event messages and splits them into individual messages.
 * @param {Buffer} buffer
 * @api private
 */ function $3457e231005ff10c$var$eventMessageChunker(buffer) {
    /** @type Buffer[] */ var messages = [];
    var offset = 0;
    while(offset < buffer.length){
        var totalLength = buffer.readInt32BE(offset);
        // create new buffer for individual message (shares memory with original)
        var message = buffer.slice(offset, totalLength + offset);
        // increment offset to it starts at the next message
        offset += totalLength;
        messages.push(message);
    }
    return messages;
}
/**
 * @api private
 */ module.exports = {
    eventMessageChunker: $3457e231005ff10c$var$eventMessageChunker
};

});

parcelRequire.register("bktu7", function(module, exports) {

var $bpJAo = parcelRequire("bpJAo");
var $83f86f0a112d86ee$require$parseMessage = $bpJAo.parseMessage;
/**
 *
 * @param {*} parser
 * @param {Buffer} message
 * @param {*} shape
 * @api private
 */ function $83f86f0a112d86ee$var$parseEvent(parser, message, shape) {
    var parsedMessage = $83f86f0a112d86ee$require$parseMessage(message);
    // check if message is an event or error
    var messageType = parsedMessage.headers[":message-type"];
    if (messageType) {
        if (messageType.value === "error") throw $83f86f0a112d86ee$var$parseError(parsedMessage);
        else if (messageType.value !== "event") // not sure how to parse non-events/non-errors, ignore for now
        return;
    }
    // determine event type
    var eventType = parsedMessage.headers[":event-type"];
    // check that the event type is modeled
    var eventModel = shape.members[eventType.value];
    if (!eventModel) return;
    var result = {};
    // check if an event payload exists
    var eventPayloadMemberName = eventModel.eventPayloadMemberName;
    if (eventPayloadMemberName) {
        var payloadShape = eventModel.members[eventPayloadMemberName];
        // if the shape is binary, return the byte array
        if (payloadShape.type === "binary") result[eventPayloadMemberName] = parsedMessage.body;
        else result[eventPayloadMemberName] = parser.parse(parsedMessage.body.toString(), payloadShape);
    }
    // read event headers
    var eventHeaderNames = eventModel.eventHeaderMemberNames;
    for(var i = 0; i < eventHeaderNames.length; i++){
        var name = eventHeaderNames[i];
        if (parsedMessage.headers[name]) // parse the header!
        result[name] = eventModel.members[name].toType(parsedMessage.headers[name].value);
    }
    var output = {};
    output[eventType.value] = result;
    return output;
}
function $83f86f0a112d86ee$var$parseError(message) {
    var errorCode = message.headers[":error-code"];
    var errorMessage = message.headers[":error-message"];
    var error = new Error(errorMessage.value || errorMessage);
    error.code = error.name = errorCode.value || errorCode;
    return error;
}
/**
 * @api private
 */ module.exports = {
    parseEvent: $83f86f0a112d86ee$var$parseEvent
};

});
parcelRequire.register("bpJAo", function(module, exports) {

var $heGUe = parcelRequire("heGUe");
var $0224fd7bb5e4feec$require$Int64 = $heGUe.Int64;

var $cfxKp = parcelRequire("cfxKp");
var $0224fd7bb5e4feec$require$splitMessage = $cfxKp.splitMessage;
var $0224fd7bb5e4feec$var$BOOLEAN_TAG = "boolean";
var $0224fd7bb5e4feec$var$BYTE_TAG = "byte";
var $0224fd7bb5e4feec$var$SHORT_TAG = "short";
var $0224fd7bb5e4feec$var$INT_TAG = "integer";
var $0224fd7bb5e4feec$var$LONG_TAG = "long";
var $0224fd7bb5e4feec$var$BINARY_TAG = "binary";
var $0224fd7bb5e4feec$var$STRING_TAG = "string";
var $0224fd7bb5e4feec$var$TIMESTAMP_TAG = "timestamp";
var $0224fd7bb5e4feec$var$UUID_TAG = "uuid";
/**
 * @api private
 *
 * @param {Buffer} headers
 */ function $0224fd7bb5e4feec$var$parseHeaders(headers) {
    var out = {};
    var position = 0;
    while(position < headers.length){
        var nameLength = headers.readUInt8(position++);
        var name = headers.slice(position, position + nameLength).toString();
        position += nameLength;
        switch(headers.readUInt8(position++)){
            case 0 /* boolTrue */ :
                out[name] = {
                    type: $0224fd7bb5e4feec$var$BOOLEAN_TAG,
                    value: true
                };
                break;
            case 1 /* boolFalse */ :
                out[name] = {
                    type: $0224fd7bb5e4feec$var$BOOLEAN_TAG,
                    value: false
                };
                break;
            case 2 /* byte */ :
                out[name] = {
                    type: $0224fd7bb5e4feec$var$BYTE_TAG,
                    value: headers.readInt8(position++)
                };
                break;
            case 3 /* short */ :
                out[name] = {
                    type: $0224fd7bb5e4feec$var$SHORT_TAG,
                    value: headers.readInt16BE(position)
                };
                position += 2;
                break;
            case 4 /* integer */ :
                out[name] = {
                    type: $0224fd7bb5e4feec$var$INT_TAG,
                    value: headers.readInt32BE(position)
                };
                position += 4;
                break;
            case 5 /* long */ :
                out[name] = {
                    type: $0224fd7bb5e4feec$var$LONG_TAG,
                    value: new $0224fd7bb5e4feec$require$Int64(headers.slice(position, position + 8))
                };
                position += 8;
                break;
            case 6 /* byteArray */ :
                var binaryLength = headers.readUInt16BE(position);
                position += 2;
                out[name] = {
                    type: $0224fd7bb5e4feec$var$BINARY_TAG,
                    value: headers.slice(position, position + binaryLength)
                };
                position += binaryLength;
                break;
            case 7 /* string */ :
                var stringLength = headers.readUInt16BE(position);
                position += 2;
                out[name] = {
                    type: $0224fd7bb5e4feec$var$STRING_TAG,
                    value: headers.slice(position, position + stringLength).toString()
                };
                position += stringLength;
                break;
            case 8 /* timestamp */ :
                out[name] = {
                    type: $0224fd7bb5e4feec$var$TIMESTAMP_TAG,
                    value: new Date(new $0224fd7bb5e4feec$require$Int64(headers.slice(position, position + 8)).valueOf())
                };
                position += 8;
                break;
            case 9 /* uuid */ :
                var uuidChars = headers.slice(position, position + 16).toString("hex");
                position += 16;
                out[name] = {
                    type: $0224fd7bb5e4feec$var$UUID_TAG,
                    value: uuidChars.substr(0, 8) + "-" + uuidChars.substr(8, 4) + "-" + uuidChars.substr(12, 4) + "-" + uuidChars.substr(16, 4) + "-" + uuidChars.substr(20)
                };
                break;
            default:
                throw new Error("Unrecognized header type tag");
        }
    }
    return out;
}
function $0224fd7bb5e4feec$var$parseMessage(message) {
    var parsed = $0224fd7bb5e4feec$require$splitMessage(message);
    return {
        headers: $0224fd7bb5e4feec$var$parseHeaders(parsed.headers),
        body: parsed.body
    };
}
/**
 * @api private
 */ module.exports = {
    parseMessage: $0224fd7bb5e4feec$var$parseMessage
};

});
parcelRequire.register("heGUe", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
var $c8c506b60da08d30$require$util = $dbC7k.util;
var $c8c506b60da08d30$var$toBuffer = $c8c506b60da08d30$require$util.buffer.toBuffer;
/**
 * A lossless representation of a signed, 64-bit integer. Instances of this
 * class may be used in arithmetic expressions as if they were numeric
 * primitives, but the binary representation will be preserved unchanged as the
 * `bytes` property of the object. The bytes should be encoded as big-endian,
 * two's complement integers.
 * @param {Buffer} bytes
 *
 * @api private
 */ function $c8c506b60da08d30$var$Int64(bytes) {
    if (bytes.length !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    if (!$c8c506b60da08d30$require$util.Buffer.isBuffer(bytes)) bytes = $c8c506b60da08d30$var$toBuffer(bytes);
    this.bytes = bytes;
}
/**
 * @param {number} number
 * @returns {Int64}
 *
 * @api private
 */ $c8c506b60da08d30$var$Int64.fromNumber = function(number) {
    if (number > 9223372036854775807 || number < -9223372036854776000) throw new Error(number + " is too large (or, if negative, too small) to represent as an Int64");
    var bytes = new Uint8Array(8);
    for(var i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
    if (number < 0) $c8c506b60da08d30$var$negate(bytes);
    return new $c8c506b60da08d30$var$Int64(bytes);
};
/**
 * @returns {number}
 *
 * @api private
 */ $c8c506b60da08d30$var$Int64.prototype.valueOf = function() {
    var bytes = this.bytes.slice(0);
    var negative = bytes[0] & 128;
    if (negative) $c8c506b60da08d30$var$negate(bytes);
    return parseInt(bytes.toString("hex"), 16) * (negative ? -1 : 1);
};
$c8c506b60da08d30$var$Int64.prototype.toString = function() {
    return String(this.valueOf());
};
/**
 * @param {Buffer} bytes
 *
 * @api private
 */ function $c8c506b60da08d30$var$negate(bytes) {
    for(var i = 0; i < 8; i++)bytes[i] ^= 0xFF;
    for(var i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}
/**
 * @api private
 */ module.exports = {
    Int64: $c8c506b60da08d30$var$Int64
};

});

parcelRequire.register("cfxKp", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
var $8eb1104ec0c9111a$require$util = $dbC7k.util;
var $8eb1104ec0c9111a$var$toBuffer = $8eb1104ec0c9111a$require$util.buffer.toBuffer;
// All prelude components are unsigned, 32-bit integers
var $8eb1104ec0c9111a$var$PRELUDE_MEMBER_LENGTH = 4;
// The prelude consists of two components
var $8eb1104ec0c9111a$var$PRELUDE_LENGTH = $8eb1104ec0c9111a$var$PRELUDE_MEMBER_LENGTH * 2;
// Checksums are always CRC32 hashes.
var $8eb1104ec0c9111a$var$CHECKSUM_LENGTH = 4;
// Messages must include a full prelude, a prelude checksum, and a message checksum
var $8eb1104ec0c9111a$var$MINIMUM_MESSAGE_LENGTH = $8eb1104ec0c9111a$var$PRELUDE_LENGTH + $8eb1104ec0c9111a$var$CHECKSUM_LENGTH * 2;
/**
 * @api private
 *
 * @param {Buffer} message
 */ function $8eb1104ec0c9111a$var$splitMessage(message) {
    if (!$8eb1104ec0c9111a$require$util.Buffer.isBuffer(message)) message = $8eb1104ec0c9111a$var$toBuffer(message);
    if (message.length < $8eb1104ec0c9111a$var$MINIMUM_MESSAGE_LENGTH) throw new Error("Provided message too short to accommodate event stream message overhead");
    if (message.length !== message.readUInt32BE(0)) throw new Error("Reported message length does not match received message length");
    var expectedPreludeChecksum = message.readUInt32BE($8eb1104ec0c9111a$var$PRELUDE_LENGTH);
    if (expectedPreludeChecksum !== $8eb1104ec0c9111a$require$util.crypto.crc32(message.slice(0, $8eb1104ec0c9111a$var$PRELUDE_LENGTH))) throw new Error("The prelude checksum specified in the message (" + expectedPreludeChecksum + ") does not match the calculated CRC32 checksum.");
    var expectedMessageChecksum = message.readUInt32BE(message.length - $8eb1104ec0c9111a$var$CHECKSUM_LENGTH);
    if (expectedMessageChecksum !== $8eb1104ec0c9111a$require$util.crypto.crc32(message.slice(0, message.length - $8eb1104ec0c9111a$var$CHECKSUM_LENGTH))) throw new Error("The message checksum did not match the expected value of " + expectedMessageChecksum);
    var headersStart = $8eb1104ec0c9111a$var$PRELUDE_LENGTH + $8eb1104ec0c9111a$var$CHECKSUM_LENGTH;
    var headersEnd = headersStart + message.readUInt32BE($8eb1104ec0c9111a$var$PRELUDE_MEMBER_LENGTH);
    return {
        headers: message.slice(headersStart, headersEnd),
        body: message.slice(headersEnd, message.length - $8eb1104ec0c9111a$var$CHECKSUM_LENGTH)
    };
}
/**
 * @api private
 */ module.exports = {
    splitMessage: $8eb1104ec0c9111a$var$splitMessage
};

});




parcelRequire.register("80SUB", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");

var $2XC9S = parcelRequire("2XC9S");
/**
 * Represents temporary credentials retrieved from {AWS.STS}. Without any
 * extra parameters, credentials will be fetched from the
 * {AWS.STS.getSessionToken} operation. If an IAM role is provided, the
 * {AWS.STS.assumeRole} operation will be used to fetch credentials for the
 * role instead.
 *
 * @note AWS.TemporaryCredentials is deprecated, but remains available for
 *   backwards compatibility. {AWS.ChainableTemporaryCredentials} is the
 *   preferred class for temporary credentials.
 *
 * To setup temporary credentials, configure a set of master credentials
 * using the standard credentials providers (environment, EC2 instance metadata,
 * or from the filesystem), then set the global credentials to a new
 * temporary credentials object:
 *
 * ```javascript
 * // Note that environment credentials are loaded by default,
 * // the following line is shown for clarity:
 * AWS.config.credentials = new AWS.EnvironmentCredentials('AWS');
 *
 * // Now set temporary credentials seeded from the master credentials
 * AWS.config.credentials = new AWS.TemporaryCredentials();
 *
 * // subsequent requests will now use temporary credentials from AWS STS.
 * new AWS.S3().listBucket(function(err, data) { ... });
 * ```
 *
 * @!attribute masterCredentials
 *   @return [AWS.Credentials] the master (non-temporary) credentials used to
 *     get and refresh temporary credentials from AWS STS.
 * @note (see constructor)
 */ $dbC7k.TemporaryCredentials = $dbC7k.util.inherit($dbC7k.Credentials, {
    /**
   * Creates a new temporary credentials object.
   *
   * @note In order to create temporary credentials, you first need to have
   *   "master" credentials configured in {AWS.Config.credentials}. These
   *   master credentials are necessary to retrieve the temporary credentials,
   *   as well as refresh the credentials when they expire.
   * @param params [map] a map of options that are passed to the
   *   {AWS.STS.assumeRole} or {AWS.STS.getSessionToken} operations.
   *   If a `RoleArn` parameter is passed in, credentials will be based on the
   *   IAM role.
   * @param masterCredentials [AWS.Credentials] the master (non-temporary) credentials
   *  used to get and refresh temporary credentials from AWS STS.
   * @example Creating a new credentials object for generic temporary credentials
   *   AWS.config.credentials = new AWS.TemporaryCredentials();
   * @example Creating a new credentials object for an IAM role
   *   AWS.config.credentials = new AWS.TemporaryCredentials({
   *     RoleArn: 'arn:aws:iam::1234567890:role/TemporaryCredentials',
   *   });
   * @see AWS.STS.assumeRole
   * @see AWS.STS.getSessionToken
   */ constructor: function TemporaryCredentials(params, masterCredentials) {
        $dbC7k.Credentials.call(this);
        this.loadMasterCredentials(masterCredentials);
        this.expired = true;
        this.params = params || {};
        if (this.params.RoleArn) this.params.RoleSessionName = this.params.RoleSessionName || "temporary-credentials";
    },
    /**
   * Refreshes credentials using {AWS.STS.assumeRole} or
   * {AWS.STS.getSessionToken}, depending on whether an IAM role ARN was passed
   * to the credentials {constructor}.
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see get
   */ refresh: function refresh(callback) {
        this.coalesceRefresh(callback || $dbC7k.util.fn.callback);
    },
    /**
   * @api private
   */ load: function load(callback) {
        var self = this;
        self.createClients();
        self.masterCredentials.get(function() {
            self.service.config.credentials = self.masterCredentials;
            var operation = self.params.RoleArn ? self.service.assumeRole : self.service.getSessionToken;
            operation.call(self.service, function(err, data) {
                if (!err) self.service.credentialsFrom(data, self);
                callback(err);
            });
        });
    },
    /**
   * @api private
   */ loadMasterCredentials: function loadMasterCredentials(masterCredentials) {
        this.masterCredentials = masterCredentials || $dbC7k.config.credentials;
        while(this.masterCredentials.masterCredentials)this.masterCredentials = this.masterCredentials.masterCredentials;
        if (typeof this.masterCredentials.get !== "function") this.masterCredentials = new $dbC7k.Credentials(this.masterCredentials);
    },
    /**
   * @api private
   */ createClients: function() {
        this.service = this.service || new $2XC9S({
            params: this.params
        });
    }
});

});
parcelRequire.register("2XC9S", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $227eb0ed0d03d007$var$Service = $dbC7k.Service;
var $227eb0ed0d03d007$var$apiLoader = $dbC7k.apiLoader;
$227eb0ed0d03d007$var$apiLoader.services["sts"] = {};
$dbC7k.STS = $227eb0ed0d03d007$var$Service.defineService("sts", [
    "2011-06-15"
]);
parcelRequire("cMC1Y");


Object.defineProperty($227eb0ed0d03d007$var$apiLoader.services["sts"], "2011-06-15", {
    get: function get() {
        var model = (parcelRequire("eQ7XC"));
        model.paginators = (parcelRequire("2rqoD")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.STS;

});
parcelRequire.register("cMC1Y", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
$dbC7k.util.update($dbC7k.STS.prototype, {
    /**
   * @overload credentialsFrom(data, credentials = null)
   *   Creates a credentials object from STS response data containing
   *   credentials information. Useful for quickly setting AWS credentials.
   *
   *   @note This is a low-level utility function. If you want to load temporary
   *     credentials into your process for subsequent requests to AWS resources,
   *     you should use {AWS.TemporaryCredentials} instead.
   *   @param data [map] data retrieved from a call to {getFederatedToken},
   *     {getSessionToken}, {assumeRole}, or {assumeRoleWithWebIdentity}.
   *   @param credentials [AWS.Credentials] an optional credentials object to
   *     fill instead of creating a new object. Useful when modifying an
   *     existing credentials object from a refresh call.
   *   @return [AWS.TemporaryCredentials] the set of temporary credentials
   *     loaded from a raw STS operation response.
   *   @example Using credentialsFrom to load global AWS credentials
   *     var sts = new AWS.STS();
   *     sts.getSessionToken(function (err, data) {
   *       if (err) console.log("Error getting credentials");
   *       else {
   *         AWS.config.credentials = sts.credentialsFrom(data);
   *       }
   *     });
   *   @see AWS.TemporaryCredentials
   */ credentialsFrom: function credentialsFrom(data, credentials) {
        if (!data) return null;
        if (!credentials) credentials = new $dbC7k.TemporaryCredentials();
        credentials.expired = false;
        credentials.accessKeyId = data.Credentials.AccessKeyId;
        credentials.secretAccessKey = data.Credentials.SecretAccessKey;
        credentials.sessionToken = data.Credentials.SessionToken;
        credentials.expireTime = data.Credentials.Expiration;
        return credentials;
    },
    assumeRoleWithWebIdentity: function assumeRoleWithWebIdentity(params, callback) {
        return this.makeUnauthenticatedRequest("assumeRoleWithWebIdentity", params, callback);
    },
    assumeRoleWithSAML: function assumeRoleWithSAML(params, callback) {
        return this.makeUnauthenticatedRequest("assumeRoleWithSAML", params, callback);
    }
});

});

parcelRequire.register("eQ7XC", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2011-06-15","endpointPrefix":"sts","globalEndpoint":"sts.amazonaws.com","protocol":"query","serviceAbbreviation":"AWS STS","serviceFullName":"AWS Security Token Service","serviceId":"STS","signatureVersion":"v4","uid":"sts-2011-06-15","xmlNamespace":"https://sts.amazonaws.com/doc/2011-06-15/"},"operations":{"AssumeRole":{"input":{"type":"structure","required":["RoleArn","RoleSessionName"],"members":{"RoleArn":{},"RoleSessionName":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"},"ExternalId":{},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"AssumeRoleResult","type":"structure","members":{"Credentials":{"shape":"Sc"},"AssumedRoleUser":{"shape":"Sh"},"PackedPolicySize":{"type":"integer"}}}},"AssumeRoleWithSAML":{"input":{"type":"structure","required":["RoleArn","PrincipalArn","SAMLAssertion"],"members":{"RoleArn":{},"PrincipalArn":{},"SAMLAssertion":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithSAMLResult","type":"structure","members":{"Credentials":{"shape":"Sc"},"AssumedRoleUser":{"shape":"Sh"},"PackedPolicySize":{"type":"integer"},"Subject":{},"SubjectType":{},"Issuer":{},"Audience":{},"NameQualifier":{}}}},"AssumeRoleWithWebIdentity":{"input":{"type":"structure","required":["RoleArn","RoleSessionName","WebIdentityToken"],"members":{"RoleArn":{},"RoleSessionName":{},"WebIdentityToken":{},"ProviderId":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithWebIdentityResult","type":"structure","members":{"Credentials":{"shape":"Sc"},"SubjectFromWebIdentityToken":{},"AssumedRoleUser":{"shape":"Sh"},"PackedPolicySize":{"type":"integer"},"Provider":{},"Audience":{}}}},"DecodeAuthorizationMessage":{"input":{"type":"structure","required":["EncodedMessage"],"members":{"EncodedMessage":{}}},"output":{"resultWrapper":"DecodeAuthorizationMessageResult","type":"structure","members":{"DecodedMessage":{}}}},"GetAccessKeyInfo":{"input":{"type":"structure","required":["AccessKeyId"],"members":{"AccessKeyId":{}}},"output":{"resultWrapper":"GetAccessKeyInfoResult","type":"structure","members":{"Account":{}}}},"GetCallerIdentity":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"GetCallerIdentityResult","type":"structure","members":{"UserId":{},"Account":{},"Arn":{}}}},"GetFederationToken":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Policy":{},"PolicyArns":{"shape":"S4"},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"GetFederationTokenResult","type":"structure","members":{"Credentials":{"shape":"Sc"},"FederatedUser":{"type":"structure","required":["FederatedUserId","Arn"],"members":{"FederatedUserId":{},"Arn":{}}},"PackedPolicySize":{"type":"integer"}}}},"GetSessionToken":{"input":{"type":"structure","members":{"DurationSeconds":{"type":"integer"},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"GetSessionTokenResult","type":"structure","members":{"Credentials":{"shape":"Sc"}}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","members":{"arn":{}}}},"Sc":{"type":"structure","required":["AccessKeyId","SecretAccessKey","SessionToken","Expiration"],"members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}},"Sh":{"type":"structure","required":["AssumedRoleId","Arn"],"members":{"AssumedRoleId":{},"Arn":{}}}}}');

});

parcelRequire.register("2rqoD", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});



parcelRequire.register("lO2Eh", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");

var $2XC9S = parcelRequire("2XC9S");
/**
 * Represents temporary credentials retrieved from {AWS.STS}. Without any
 * extra parameters, credentials will be fetched from the
 * {AWS.STS.getSessionToken} operation. If an IAM role is provided, the
 * {AWS.STS.assumeRole} operation will be used to fetch credentials for the
 * role instead.
 *
 * AWS.ChainableTemporaryCredentials differs from AWS.TemporaryCredentials in
 * the way masterCredentials and refreshes are handled.
 * AWS.ChainableTemporaryCredentials refreshes expired credentials using the
 * masterCredentials passed by the user to support chaining of STS credentials.
 * However, AWS.TemporaryCredentials recursively collapses the masterCredentials
 * during instantiation, precluding the ability to refresh credentials which
 * require intermediate, temporary credentials.
 *
 * For example, if the application should use RoleA, which must be assumed from
 * RoleB, and the environment provides credentials which can assume RoleB, then
 * AWS.ChainableTemporaryCredentials must be used to support refreshing the
 * temporary credentials for RoleA:
 *
 * ```javascript
 * var roleACreds = new AWS.ChainableTemporaryCredentials({
 *   params: {RoleArn: 'RoleA'},
 *   masterCredentials: new AWS.ChainableTemporaryCredentials({
 *     params: {RoleArn: 'RoleB'},
 *     masterCredentials: new AWS.EnvironmentCredentials('AWS')
 *   })
 * });
 * ```
 *
 * If AWS.TemporaryCredentials had been used in the previous example,
 * `roleACreds` would fail to refresh because `roleACreds` would
 * use the environment credentials for the AssumeRole request.
 *
 * Another difference is that AWS.ChainableTemporaryCredentials creates the STS
 * service instance during instantiation while AWS.TemporaryCredentials creates
 * the STS service instance during the first refresh. Creating the service
 * instance during instantiation effectively captures the master credentials
 * from the global config, so that subsequent changes to the global config do
 * not affect the master credentials used to refresh the temporary credentials.
 *
 * This allows an instance of AWS.ChainableTemporaryCredentials to be assigned
 * to AWS.config.credentials:
 *
 * ```javascript
 * var envCreds = new AWS.EnvironmentCredentials('AWS');
 * AWS.config.credentials = envCreds;
 * // masterCredentials will be envCreds
 * AWS.config.credentials = new AWS.ChainableTemporaryCredentials({
 *   params: {RoleArn: '...'}
 * });
 * ```
 *
 * Similarly, to use the CredentialProviderChain's default providers as the
 * master credentials, simply create a new instance of
 * AWS.ChainableTemporaryCredentials:
 *
 * ```javascript
 * AWS.config.credentials = new ChainableTemporaryCredentials({
 *   params: {RoleArn: '...'}
 * });
 * ```
 *
 * @!attribute service
 *   @return [AWS.STS] the STS service instance used to
 *     get and refresh temporary credentials from AWS STS.
 * @note (see constructor)
 */ $dbC7k.ChainableTemporaryCredentials = $dbC7k.util.inherit($dbC7k.Credentials, {
    /**
   * Creates a new temporary credentials object.
   *
   * @param options [map] a set of options
   * @option options params [map] ({}) a map of options that are passed to the
   *   {AWS.STS.assumeRole} or {AWS.STS.getSessionToken} operations.
   *   If a `RoleArn` parameter is passed in, credentials will be based on the
   *   IAM role. If a `SerialNumber` parameter is passed in, {tokenCodeFn} must
   *   also be passed in or an error will be thrown.
   * @option options masterCredentials [AWS.Credentials] the master credentials
   *   used to get and refresh temporary credentials from AWS STS. By default,
   *   AWS.config.credentials or AWS.config.credentialProvider will be used.
   * @option options tokenCodeFn [Function] (null) Function to provide
   *   `TokenCode`, if `SerialNumber` is provided for profile in {params}. Function
   *   is called with value of `SerialNumber` and `callback`, and should provide
   *   the `TokenCode` or an error to the callback in the format
   *   `callback(err, token)`.
   * @example Creating a new credentials object for generic temporary credentials
   *   AWS.config.credentials = new AWS.ChainableTemporaryCredentials();
   * @example Creating a new credentials object for an IAM role
   *   AWS.config.credentials = new AWS.ChainableTemporaryCredentials({
   *     params: {
   *       RoleArn: 'arn:aws:iam::1234567890:role/TemporaryCredentials'
   *     }
   *   });
   * @see AWS.STS.assumeRole
   * @see AWS.STS.getSessionToken
   */ constructor: function ChainableTemporaryCredentials(options) {
        $dbC7k.Credentials.call(this);
        options = options || {};
        this.errorCode = "ChainableTemporaryCredentialsProviderFailure";
        this.expired = true;
        this.tokenCodeFn = null;
        var params = $dbC7k.util.copy(options.params) || {};
        if (params.RoleArn) params.RoleSessionName = params.RoleSessionName || "temporary-credentials";
        if (params.SerialNumber) {
            if (!options.tokenCodeFn || typeof options.tokenCodeFn !== "function") throw new $dbC7k.util.error(new Error("tokenCodeFn must be a function when params.SerialNumber is given"), {
                code: this.errorCode
            });
            else this.tokenCodeFn = options.tokenCodeFn;
        }
        config = $dbC7k.util.merge({
            params: params,
            credentials: options.masterCredentials || $dbC7k.config.credentials
        }, options.stsConfig || {});
        this.service = new $2XC9S(config);
    },
    /**
   * Refreshes credentials using {AWS.STS.assumeRole} or
   * {AWS.STS.getSessionToken}, depending on whether an IAM role ARN was passed
   * to the credentials {constructor}.
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see AWS.Credentials.get
   */ refresh: function refresh(callback) {
        this.coalesceRefresh(callback || $dbC7k.util.fn.callback);
    },
    /**
   * @api private
   * @param callback
   */ load: function load(callback) {
        var self = this;
        var operation = self.service.config.params.RoleArn ? "assumeRole" : "getSessionToken";
        this.getTokenCode(function(err, tokenCode) {
            var params = {};
            if (err) {
                callback(err);
                return;
            }
            if (tokenCode) params.TokenCode = tokenCode;
            self.service[operation](params, function(err, data) {
                if (!err) self.service.credentialsFrom(data, self);
                callback(err);
            });
        });
    },
    /**
   * @api private
   */ getTokenCode: function getTokenCode(callback) {
        var self = this;
        if (this.tokenCodeFn) this.tokenCodeFn(this.service.config.params.SerialNumber, function(err, token) {
            if (err) {
                var message = err;
                if (err instanceof Error) message = err.message;
                callback($dbC7k.util.error(new Error("Error fetching MFA token: " + message), {
                    code: self.errorCode
                }));
                return;
            }
            callback(null, token);
        });
        else callback(null);
    }
});

});

parcelRequire.register("7O5d0", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");

var $2XC9S = parcelRequire("2XC9S");
/**
 * Represents credentials retrieved from STS Web Identity Federation support.
 *
 * By default this provider gets credentials using the
 * {AWS.STS.assumeRoleWithWebIdentity} service operation. This operation
 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
 * application for which credentials will be given. In addition, the
 * `WebIdentityToken` must be set to the token provided by the identity
 * provider. See {constructor} for an example on creating a credentials
 * object with proper `RoleArn` and `WebIdentityToken` values.
 *
 * ## Refreshing Credentials from Identity Service
 *
 * In addition to AWS credentials expiring after a given amount of time, the
 * login token from the identity provider will also expire. Once this token
 * expires, it will not be usable to refresh AWS credentials, and another
 * token will be needed. The SDK does not manage refreshing of the token value,
 * but this can be done through a "refresh token" supported by most identity
 * providers. Consult the documentation for the identity provider for refreshing
 * tokens. Once the refreshed token is acquired, you should make sure to update
 * this new token in the credentials object's {params} property. The following
 * code will update the WebIdentityToken, assuming you have retrieved an updated
 * token from the identity provider:
 *
 * ```javascript
 * AWS.config.credentials.params.WebIdentityToken = updatedToken;
 * ```
 *
 * Future calls to `credentials.refresh()` will now use the new token.
 *
 * @!attribute params
 *   @return [map] the map of params passed to
 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
 *     `params.WebIdentityToken` property.
 * @!attribute data
 *   @return [map] the raw data response from the call to
 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
 *     access to other properties from the response.
 */ $dbC7k.WebIdentityCredentials = $dbC7k.util.inherit($dbC7k.Credentials, {
    /**
   * Creates a new credentials object.
   * @param (see AWS.STS.assumeRoleWithWebIdentity)
   * @example Creating a new credentials object
   *   AWS.config.credentials = new AWS.WebIdentityCredentials({
   *     RoleArn: 'arn:aws:iam::1234567890:role/WebIdentity',
   *     WebIdentityToken: 'ABCDEFGHIJKLMNOP', // token from identity service
   *     RoleSessionName: 'web' // optional name, defaults to web-identity
   *   }, {
   *     // optionally provide configuration to apply to the underlying AWS.STS service client
   *     // if configuration is not provided, then configuration will be pulled from AWS.config
   *
   *     // specify timeout options
   *     httpOptions: {
   *       timeout: 100
   *     }
   *   });
   * @see AWS.STS.assumeRoleWithWebIdentity
   * @see AWS.Config
   */ constructor: function WebIdentityCredentials(params, clientConfig) {
        $dbC7k.Credentials.call(this);
        this.expired = true;
        this.params = params;
        this.params.RoleSessionName = this.params.RoleSessionName || "web-identity";
        this.data = null;
        this._clientConfig = $dbC7k.util.copy(clientConfig || {});
    },
    /**
   * Refreshes credentials using {AWS.STS.assumeRoleWithWebIdentity}
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see get
   */ refresh: function refresh(callback) {
        this.coalesceRefresh(callback || $dbC7k.util.fn.callback);
    },
    /**
   * @api private
   */ load: function load(callback) {
        var self = this;
        self.createClients();
        self.service.assumeRoleWithWebIdentity(function(err, data) {
            self.data = null;
            if (!err) {
                self.data = data;
                self.service.credentialsFrom(data, self);
            }
            callback(err);
        });
    },
    /**
   * @api private
   */ createClients: function() {
        if (!this.service) {
            var stsConfig = $dbC7k.util.merge({}, this._clientConfig);
            stsConfig.params = this.params;
            this.service = new $2XC9S(stsConfig);
        }
    }
});

});

parcelRequire.register("4LDe2", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");

var $emVYJ = parcelRequire("emVYJ");

var $2XC9S = parcelRequire("2XC9S");
/**
 * Represents credentials retrieved from STS Web Identity Federation using
 * the Amazon Cognito Identity service.
 *
 * By default this provider gets credentials using the
 * {AWS.CognitoIdentity.getCredentialsForIdentity} service operation, which
 * requires either an `IdentityId` or an `IdentityPoolId` (Amazon Cognito
 * Identity Pool ID), which is used to call {AWS.CognitoIdentity.getId} to
 * obtain an `IdentityId`. If the identity or identity pool is not configured in
 * the Amazon Cognito Console to use IAM roles with the appropriate permissions,
 * then additionally a `RoleArn` is required containing the ARN of the IAM trust
 * policy for the Amazon Cognito role that the user will log into. If a `RoleArn`
 * is provided, then this provider gets credentials using the
 * {AWS.STS.assumeRoleWithWebIdentity} service operation, after first getting an
 * Open ID token from {AWS.CognitoIdentity.getOpenIdToken}.
 *
 * In addition, if this credential provider is used to provide authenticated
 * login, the `Logins` map may be set to the tokens provided by the respective
 * identity providers. See {constructor} for an example on creating a credentials
 * object with proper property values.
 *
 * ## Refreshing Credentials from Identity Service
 *
 * In addition to AWS credentials expiring after a given amount of time, the
 * login token from the identity provider will also expire. Once this token
 * expires, it will not be usable to refresh AWS credentials, and another
 * token will be needed. The SDK does not manage refreshing of the token value,
 * but this can be done through a "refresh token" supported by most identity
 * providers. Consult the documentation for the identity provider for refreshing
 * tokens. Once the refreshed token is acquired, you should make sure to update
 * this new token in the credentials object's {params} property. The following
 * code will update the WebIdentityToken, assuming you have retrieved an updated
 * token from the identity provider:
 *
 * ```javascript
 * AWS.config.credentials.params.Logins['graph.facebook.com'] = updatedToken;
 * ```
 *
 * Future calls to `credentials.refresh()` will now use the new token.
 *
 * @!attribute params
 *   @return [map] the map of params passed to
 *     {AWS.CognitoIdentity.getId},
 *     {AWS.CognitoIdentity.getOpenIdToken}, and
 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
 *     `params.WebIdentityToken` property.
 * @!attribute data
 *   @return [map] the raw data response from the call to
 *     {AWS.CognitoIdentity.getCredentialsForIdentity}, or
 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
 *     access to other properties from the response.
 * @!attribute identityId
 *   @return [String] the Cognito ID returned by the last call to
 *     {AWS.CognitoIdentity.getOpenIdToken}. This ID represents the actual
 *     final resolved identity ID from Amazon Cognito.
 */ $dbC7k.CognitoIdentityCredentials = $dbC7k.util.inherit($dbC7k.Credentials, {
    /**
   * @api private
   */ localStorageKey: {
        id: "aws.cognito.identity-id.",
        providers: "aws.cognito.identity-providers."
    },
    /**
   * Creates a new credentials object.
   * @example Creating a new credentials object
   *   AWS.config.credentials = new AWS.CognitoIdentityCredentials({
   *
   *     // either IdentityPoolId or IdentityId is required
   *     // See the IdentityPoolId param for AWS.CognitoIdentity.getID (linked below)
   *     // See the IdentityId param for AWS.CognitoIdentity.getCredentialsForIdentity
   *     // or AWS.CognitoIdentity.getOpenIdToken (linked below)
   *     IdentityPoolId: 'us-east-1:1699ebc0-7900-4099-b910-2df94f52a030',
   *     IdentityId: 'us-east-1:128d0a74-c82f-4553-916d-90053e4a8b0f'
   *
   *     // optional, only necessary when the identity pool is not configured
   *     // to use IAM roles in the Amazon Cognito Console
   *     // See the RoleArn param for AWS.STS.assumeRoleWithWebIdentity (linked below)
   *     RoleArn: 'arn:aws:iam::1234567890:role/MYAPP-CognitoIdentity',
   *
   *     // optional tokens, used for authenticated login
   *     // See the Logins param for AWS.CognitoIdentity.getID (linked below)
   *     Logins: {
   *       'graph.facebook.com': 'FBTOKEN',
   *       'www.amazon.com': 'AMAZONTOKEN',
   *       'accounts.google.com': 'GOOGLETOKEN',
   *       'api.twitter.com': 'TWITTERTOKEN',
   *       'www.digits.com': 'DIGITSTOKEN'
   *     },
   *
   *     // optional name, defaults to web-identity
   *     // See the RoleSessionName param for AWS.STS.assumeRoleWithWebIdentity (linked below)
   *     RoleSessionName: 'web',
   *
   *     // optional, only necessary when application runs in a browser
   *     // and multiple users are signed in at once, used for caching
   *     LoginId: 'example@gmail.com'
   *
   *   }, {
   *      // optionally provide configuration to apply to the underlying service clients
   *      // if configuration is not provided, then configuration will be pulled from AWS.config
   *
   *      // region should match the region your identity pool is located in
   *      region: 'us-east-1',
   *
   *      // specify timeout options
   *      httpOptions: {
   *        timeout: 100
   *      }
   *   });
   * @see AWS.CognitoIdentity.getId
   * @see AWS.CognitoIdentity.getCredentialsForIdentity
   * @see AWS.STS.assumeRoleWithWebIdentity
   * @see AWS.CognitoIdentity.getOpenIdToken
   * @see AWS.Config
   * @note If a region is not provided in the global AWS.config, or
   *   specified in the `clientConfig` to the CognitoIdentityCredentials
   *   constructor, you may encounter a 'Missing credentials in config' error
   *   when calling making a service call.
   */ constructor: function CognitoIdentityCredentials(params, clientConfig) {
        $dbC7k.Credentials.call(this);
        this.expired = true;
        this.params = params;
        this.data = null;
        this._identityId = null;
        this._clientConfig = $dbC7k.util.copy(clientConfig || {});
        this.loadCachedId();
        var self = this;
        Object.defineProperty(this, "identityId", {
            get: function() {
                self.loadCachedId();
                return self._identityId || self.params.IdentityId;
            },
            set: function(identityId) {
                self._identityId = identityId;
            }
        });
    },
    /**
   * Refreshes credentials using {AWS.CognitoIdentity.getCredentialsForIdentity},
   * or {AWS.STS.assumeRoleWithWebIdentity}.
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see AWS.Credentials.get
   */ refresh: function refresh(callback) {
        this.coalesceRefresh(callback || $dbC7k.util.fn.callback);
    },
    /**
   * @api private
   * @param callback
   */ load: function load(callback) {
        var self = this;
        self.createClients();
        self.data = null;
        self._identityId = null;
        self.getId(function(err) {
            if (!err) {
                if (!self.params.RoleArn) self.getCredentialsForIdentity(callback);
                else self.getCredentialsFromSTS(callback);
            } else {
                self.clearIdOnNotAuthorized(err);
                callback(err);
            }
        });
    },
    /**
   * Clears the cached Cognito ID associated with the currently configured
   * identity pool ID. Use this to manually invalidate your cache if
   * the identity pool ID was deleted.
   */ clearCachedId: function clearCache() {
        this._identityId = null;
        delete this.params.IdentityId;
        var poolId = this.params.IdentityPoolId;
        var loginId = this.params.LoginId || "";
        delete this.storage[this.localStorageKey.id + poolId + loginId];
        delete this.storage[this.localStorageKey.providers + poolId + loginId];
    },
    /**
   * @api private
   */ clearIdOnNotAuthorized: function clearIdOnNotAuthorized(err) {
        var self = this;
        if (err.code == "NotAuthorizedException") self.clearCachedId();
    },
    /**
   * Retrieves a Cognito ID, loading from cache if it was already retrieved
   * on this device.
   *
   * @callback callback function(err, identityId)
   *   @param err [Error, null] an error object if the call failed or null if
   *     it succeeded.
   *   @param identityId [String, null] if successful, the callback will return
   *     the Cognito ID.
   * @note If not loaded explicitly, the Cognito ID is loaded and stored in
   *   localStorage in the browser environment of a device.
   * @api private
   */ getId: function getId(callback) {
        var self = this;
        if (typeof self.params.IdentityId === "string") return callback(null, self.params.IdentityId);
        self.cognito.getId(function(err, data) {
            if (!err && data.IdentityId) {
                self.params.IdentityId = data.IdentityId;
                callback(null, data.IdentityId);
            } else callback(err);
        });
    },
    /**
   * @api private
   */ loadCredentials: function loadCredentials(data, credentials) {
        if (!data || !credentials) return;
        credentials.expired = false;
        credentials.accessKeyId = data.Credentials.AccessKeyId;
        credentials.secretAccessKey = data.Credentials.SecretKey;
        credentials.sessionToken = data.Credentials.SessionToken;
        credentials.expireTime = data.Credentials.Expiration;
    },
    /**
   * @api private
   */ getCredentialsForIdentity: function getCredentialsForIdentity(callback) {
        var self = this;
        self.cognito.getCredentialsForIdentity(function(err, data) {
            if (!err) {
                self.cacheId(data);
                self.data = data;
                self.loadCredentials(self.data, self);
            } else self.clearIdOnNotAuthorized(err);
            callback(err);
        });
    },
    /**
   * @api private
   */ getCredentialsFromSTS: function getCredentialsFromSTS(callback) {
        var self = this;
        self.cognito.getOpenIdToken(function(err, data) {
            if (!err) {
                self.cacheId(data);
                self.params.WebIdentityToken = data.Token;
                self.webIdentityCredentials.refresh(function(webErr) {
                    if (!webErr) {
                        self.data = self.webIdentityCredentials.data;
                        self.sts.credentialsFrom(self.data, self);
                    }
                    callback(webErr);
                });
            } else {
                self.clearIdOnNotAuthorized(err);
                callback(err);
            }
        });
    },
    /**
   * @api private
   */ loadCachedId: function loadCachedId() {
        var self = this;
        // in the browser we source default IdentityId from localStorage
        if ($dbC7k.util.isBrowser() && !self.params.IdentityId) {
            var id = self.getStorage("id");
            if (id && self.params.Logins) {
                var actualProviders = Object.keys(self.params.Logins);
                var cachedProviders = (self.getStorage("providers") || "").split(",");
                // only load ID if at least one provider used this ID before
                var intersect = cachedProviders.filter(function(n) {
                    return actualProviders.indexOf(n) !== -1;
                });
                if (intersect.length !== 0) self.params.IdentityId = id;
            } else if (id) self.params.IdentityId = id;
        }
    },
    /**
   * @api private
   */ createClients: function() {
        var clientConfig = this._clientConfig;
        this.webIdentityCredentials = this.webIdentityCredentials || new $dbC7k.WebIdentityCredentials(this.params, clientConfig);
        if (!this.cognito) {
            var cognitoConfig = $dbC7k.util.merge({}, clientConfig);
            cognitoConfig.params = this.params;
            this.cognito = new $emVYJ(cognitoConfig);
        }
        this.sts = this.sts || new $2XC9S(clientConfig);
    },
    /**
   * @api private
   */ cacheId: function cacheId(data) {
        this._identityId = data.IdentityId;
        this.params.IdentityId = this._identityId;
        // cache this IdentityId in browser localStorage if possible
        if ($dbC7k.util.isBrowser()) {
            this.setStorage("id", data.IdentityId);
            if (this.params.Logins) this.setStorage("providers", Object.keys(this.params.Logins).join(","));
        }
    },
    /**
   * @api private
   */ getStorage: function getStorage(key) {
        return this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || "")];
    },
    /**
   * @api private
   */ setStorage: function setStorage(key, val) {
        try {
            this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || "")] = val;
        } catch (_) {}
    },
    /**
   * @api private
   */ storage: function() {
        try {
            var storage = $dbC7k.util.isBrowser() && window.localStorage !== null && typeof window.localStorage === "object" ? window.localStorage : {};
            // Test set/remove which would throw an error in Safari's private browsing
            storage["aws.test-storage"] = "foobar";
            delete storage["aws.test-storage"];
            return storage;
        } catch (_) {
            return {};
        }
    }()
});

});
parcelRequire.register("emVYJ", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $a760181996af5976$var$Service = $dbC7k.Service;
var $a760181996af5976$var$apiLoader = $dbC7k.apiLoader;
$a760181996af5976$var$apiLoader.services["cognitoidentity"] = {};
$dbC7k.CognitoIdentity = $a760181996af5976$var$Service.defineService("cognitoidentity", [
    "2014-06-30"
]);
parcelRequire("fTZ3a");


Object.defineProperty($a760181996af5976$var$apiLoader.services["cognitoidentity"], "2014-06-30", {
    get: function get() {
        var model = (parcelRequire("C6nkU"));
        model.paginators = (parcelRequire("7kzTz")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.CognitoIdentity;

});
parcelRequire.register("fTZ3a", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
$dbC7k.util.update($dbC7k.CognitoIdentity.prototype, {
    getOpenIdToken: function getOpenIdToken(params, callback) {
        return this.makeUnauthenticatedRequest("getOpenIdToken", params, callback);
    },
    getId: function getId(params, callback) {
        return this.makeUnauthenticatedRequest("getId", params, callback);
    },
    getCredentialsForIdentity: function getCredentialsForIdentity(params, callback) {
        return this.makeUnauthenticatedRequest("getCredentialsForIdentity", params, callback);
    }
});

});

parcelRequire.register("C6nkU", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2014-06-30","endpointPrefix":"cognito-identity","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity","serviceId":"Cognito Identity","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityService","uid":"cognito-identity-2014-06-30"},"operations":{"CreateIdentityPool":{"input":{"type":"structure","required":["IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S4"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S8"},"CognitoIdentityProviders":{"shape":"Sa"},"SamlProviderARNs":{"shape":"Sf"},"IdentityPoolTags":{"shape":"Sg"}}},"output":{"shape":"Sj"}},"DeleteIdentities":{"input":{"type":"structure","required":["IdentityIdsToDelete"],"members":{"IdentityIdsToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"UnprocessedIdentityIds":{"type":"list","member":{"type":"structure","members":{"IdentityId":{},"ErrorCode":{}}}}}}},"DeleteIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}}},"DescribeIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{}}},"output":{"shape":"Su"}},"DescribeIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"shape":"Sj"}},"GetCredentialsForIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"Sz"},"CustomRoleArn":{}}},"output":{"type":"structure","members":{"IdentityId":{},"Credentials":{"type":"structure","members":{"AccessKeyId":{},"SecretKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}}}}},"GetId":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"AccountId":{},"IdentityPoolId":{},"Logins":{"shape":"Sz"}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"GetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Roles":{"shape":"S1b"},"RoleMappings":{"shape":"S1d"}}}},"GetOpenIdToken":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"Sz"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"GetOpenIdTokenForDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId","Logins"],"members":{"IdentityPoolId":{},"IdentityId":{},"Logins":{"shape":"Sz"},"TokenDuration":{"type":"long"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"ListIdentities":{"input":{"type":"structure","required":["IdentityPoolId","MaxResults"],"members":{"IdentityPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{},"HideDisabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Identities":{"type":"list","member":{"shape":"Su"}},"NextToken":{}}}},"ListIdentityPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityPools":{"type":"list","member":{"type":"structure","members":{"IdentityPoolId":{},"IdentityPoolName":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sg"}}}},"LookupDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{},"IdentityId":{},"DeveloperUserIdentifier":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityId":{},"DeveloperUserIdentifierList":{"type":"list","member":{}},"NextToken":{}}}},"MergeDeveloperIdentities":{"input":{"type":"structure","required":["SourceUserIdentifier","DestinationUserIdentifier","DeveloperProviderName","IdentityPoolId"],"members":{"SourceUserIdentifier":{},"DestinationUserIdentifier":{},"DeveloperProviderName":{},"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"SetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId","Roles"],"members":{"IdentityPoolId":{},"Roles":{"shape":"S1b"},"RoleMappings":{"shape":"S1d"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"Tags":{"shape":"Sg"}}},"output":{"type":"structure","members":{}}},"UnlinkDeveloperIdentity":{"input":{"type":"structure","required":["IdentityId","IdentityPoolId","DeveloperProviderName","DeveloperUserIdentifier"],"members":{"IdentityId":{},"IdentityPoolId":{},"DeveloperProviderName":{},"DeveloperUserIdentifier":{}}}},"UnlinkIdentity":{"input":{"type":"structure","required":["IdentityId","Logins","LoginsToRemove"],"members":{"IdentityId":{},"Logins":{"shape":"Sz"},"LoginsToRemove":{"shape":"Sv"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateIdentityPool":{"input":{"shape":"Sj"},"output":{"shape":"Sj"}}},"shapes":{"S4":{"type":"map","key":{},"value":{}},"S8":{"type":"list","member":{}},"Sa":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ClientId":{},"ServerSideTokenCheck":{"type":"boolean"}}}},"Sf":{"type":"list","member":{}},"Sg":{"type":"map","key":{},"value":{}},"Sj":{"type":"structure","required":["IdentityPoolId","IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolId":{},"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S4"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S8"},"CognitoIdentityProviders":{"shape":"Sa"},"SamlProviderARNs":{"shape":"Sf"},"IdentityPoolTags":{"shape":"Sg"}}},"Su":{"type":"structure","members":{"IdentityId":{},"Logins":{"shape":"Sv"},"CreationDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"}}},"Sv":{"type":"list","member":{}},"Sz":{"type":"map","key":{},"value":{}},"S1b":{"type":"map","key":{},"value":{}},"S1d":{"type":"map","key":{},"value":{"type":"structure","required":["Type"],"members":{"Type":{},"AmbiguousRoleResolution":{},"RulesConfiguration":{"type":"structure","required":["Rules"],"members":{"Rules":{"type":"list","member":{"type":"structure","required":["Claim","MatchType","Value","RoleARN"],"members":{"Claim":{},"MatchType":{},"Value":{},"RoleARN":{}}}}}}}}}}}');

});

parcelRequire.register("7kzTz", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});



parcelRequire.register("5JwBe", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");

var $2XC9S = parcelRequire("2XC9S");
/**
 * Represents credentials retrieved from STS SAML support.
 *
 * By default this provider gets credentials using the
 * {AWS.STS.assumeRoleWithSAML} service operation. This operation
 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
 * application for which credentials will be given, as well as a `PrincipalArn`
 * representing the ARN for the SAML identity provider. In addition, the
 * `SAMLAssertion` must be set to the token provided by the identity
 * provider. See {constructor} for an example on creating a credentials
 * object with proper `RoleArn`, `PrincipalArn`, and `SAMLAssertion` values.
 *
 * ## Refreshing Credentials from Identity Service
 *
 * In addition to AWS credentials expiring after a given amount of time, the
 * login token from the identity provider will also expire. Once this token
 * expires, it will not be usable to refresh AWS credentials, and another
 * token will be needed. The SDK does not manage refreshing of the token value,
 * but this can be done through a "refresh token" supported by most identity
 * providers. Consult the documentation for the identity provider for refreshing
 * tokens. Once the refreshed token is acquired, you should make sure to update
 * this new token in the credentials object's {params} property. The following
 * code will update the SAMLAssertion, assuming you have retrieved an updated
 * token from the identity provider:
 *
 * ```javascript
 * AWS.config.credentials.params.SAMLAssertion = updatedToken;
 * ```
 *
 * Future calls to `credentials.refresh()` will now use the new token.
 *
 * @!attribute params
 *   @return [map] the map of params passed to
 *     {AWS.STS.assumeRoleWithSAML}. To update the token, set the
 *     `params.SAMLAssertion` property.
 */ $dbC7k.SAMLCredentials = $dbC7k.util.inherit($dbC7k.Credentials, {
    /**
   * Creates a new credentials object.
   * @param (see AWS.STS.assumeRoleWithSAML)
   * @example Creating a new credentials object
   *   AWS.config.credentials = new AWS.SAMLCredentials({
   *     RoleArn: 'arn:aws:iam::1234567890:role/SAMLRole',
   *     PrincipalArn: 'arn:aws:iam::1234567890:role/SAMLPrincipal',
   *     SAMLAssertion: 'base64-token', // base64-encoded token from IdP
   *   });
   * @see AWS.STS.assumeRoleWithSAML
   */ constructor: function SAMLCredentials(params) {
        $dbC7k.Credentials.call(this);
        this.expired = true;
        this.params = params;
    },
    /**
   * Refreshes credentials using {AWS.STS.assumeRoleWithSAML}
   *
   * @callback callback function(err)
   *   Called when the STS service responds (or fails). When
   *   this callback is called with no error, it means that the credentials
   *   information has been loaded into the object (as the `accessKeyId`,
   *   `secretAccessKey`, and `sessionToken` properties).
   *   @param err [Error] if an error occurred, this value will be filled
   * @see get
   */ refresh: function refresh(callback) {
        this.coalesceRefresh(callback || $dbC7k.util.fn.callback);
    },
    /**
   * @api private
   */ load: function load(callback) {
        var self = this;
        self.createClients();
        self.service.assumeRoleWithSAML(function(err, data) {
            if (!err) self.service.credentialsFrom(data, self);
            callback(err);
        });
    },
    /**
   * @api private
   */ createClients: function() {
        this.service = this.service || new $2XC9S({
            params: this.params
        });
    }
});

});

parcelRequire.register("dys5Z", function(module, exports) {

var $5DMlf = parcelRequire("5DMlf");

var $DT6jw = parcelRequire("DT6jw");
function $9de43e8a1cfed7a8$var$DomXmlParser() {}
$9de43e8a1cfed7a8$var$DomXmlParser.prototype.parse = function(xml, shape) {
    if (xml.replace(/^\s+/, "") === "") return {};
    var result, error;
    try {
        if (window.DOMParser) {
            try {
                var parser = new DOMParser();
                result = parser.parseFromString(xml, "text/xml");
            } catch (syntaxError) {
                throw $5DMlf.error(new Error("Parse error in document"), {
                    originalError: syntaxError,
                    code: "XMLParserError",
                    retryable: true
                });
            }
            if (result.documentElement === null) throw $5DMlf.error(new Error("Cannot parse empty document."), {
                code: "XMLParserError",
                retryable: true
            });
            var isError = result.getElementsByTagName("parsererror")[0];
            if (isError && (isError.parentNode === result || isError.parentNode.nodeName === "body" || isError.parentNode.parentNode === result || isError.parentNode.parentNode.nodeName === "body")) {
                var errorElement = isError.getElementsByTagName("div")[0] || isError;
                throw $5DMlf.error(new Error(errorElement.textContent || "Parser error in document"), {
                    code: "XMLParserError",
                    retryable: true
                });
            }
        } else if (window.ActiveXObject) {
            result = new window.ActiveXObject("Microsoft.XMLDOM");
            result.async = false;
            if (!result.loadXML(xml)) throw $5DMlf.error(new Error("Parse error in document"), {
                code: "XMLParserError",
                retryable: true
            });
        } else throw new Error("Cannot load XML parser");
    } catch (e) {
        error = e;
    }
    if (result && result.documentElement && !error) {
        var data = $9de43e8a1cfed7a8$var$parseXml(result.documentElement, shape);
        var metadata = $9de43e8a1cfed7a8$var$getElementByTagName(result.documentElement, "ResponseMetadata");
        if (metadata) data.ResponseMetadata = $9de43e8a1cfed7a8$var$parseXml(metadata, {});
        return data;
    } else if (error) throw $5DMlf.error(error || new Error(), {
        code: "XMLParserError",
        retryable: true
    });
    else return {};
};
function $9de43e8a1cfed7a8$var$getElementByTagName(xml, tag) {
    var elements = xml.getElementsByTagName(tag);
    for(var i = 0, iLen = elements.length; i < iLen; i++){
        if (elements[i].parentNode === xml) return elements[i];
    }
}
function $9de43e8a1cfed7a8$var$parseXml(xml, shape) {
    if (!shape) shape = {};
    switch(shape.type){
        case "structure":
            return $9de43e8a1cfed7a8$var$parseStructure(xml, shape);
        case "map":
            return $9de43e8a1cfed7a8$var$parseMap(xml, shape);
        case "list":
            return $9de43e8a1cfed7a8$var$parseList(xml, shape);
        case undefined:
        case null:
            return $9de43e8a1cfed7a8$var$parseUnknown(xml);
        default:
            return $9de43e8a1cfed7a8$var$parseScalar(xml, shape);
    }
}
function $9de43e8a1cfed7a8$var$parseStructure(xml, shape) {
    var data = {};
    if (xml === null) return data;
    $5DMlf.each(shape.members, function(memberName, memberShape) {
        if (memberShape.isXmlAttribute) {
            if (Object.prototype.hasOwnProperty.call(xml.attributes, memberShape.name)) {
                var value = xml.attributes[memberShape.name].value;
                data[memberName] = $9de43e8a1cfed7a8$var$parseXml({
                    textContent: value
                }, memberShape);
            }
        } else {
            var xmlChild = memberShape.flattened ? xml : $9de43e8a1cfed7a8$var$getElementByTagName(xml, memberShape.name);
            if (xmlChild) data[memberName] = $9de43e8a1cfed7a8$var$parseXml(xmlChild, memberShape);
            else if (!memberShape.flattened && memberShape.type === "list") data[memberName] = memberShape.defaultValue;
        }
    });
    return data;
}
function $9de43e8a1cfed7a8$var$parseMap(xml, shape) {
    var data = {};
    var xmlKey = shape.key.name || "key";
    var xmlValue = shape.value.name || "value";
    var tagName = shape.flattened ? shape.name : "entry";
    var child = xml.firstElementChild;
    while(child){
        if (child.nodeName === tagName) {
            var key = $9de43e8a1cfed7a8$var$getElementByTagName(child, xmlKey).textContent;
            var value = $9de43e8a1cfed7a8$var$getElementByTagName(child, xmlValue);
            data[key] = $9de43e8a1cfed7a8$var$parseXml(value, shape.value);
        }
        child = child.nextElementSibling;
    }
    return data;
}
function $9de43e8a1cfed7a8$var$parseList(xml, shape) {
    var data = [];
    var tagName = shape.flattened ? shape.name : shape.member.name || "member";
    var child = xml.firstElementChild;
    while(child){
        if (child.nodeName === tagName) data.push($9de43e8a1cfed7a8$var$parseXml(child, shape.member));
        child = child.nextElementSibling;
    }
    return data;
}
function $9de43e8a1cfed7a8$var$parseScalar(xml, shape) {
    if (xml.getAttribute) {
        var encoding = xml.getAttribute("encoding");
        if (encoding === "base64") shape = new $DT6jw.create({
            type: encoding
        });
    }
    var text = xml.textContent;
    if (text === "") text = null;
    if (typeof shape.toType === "function") return shape.toType(text);
    else return text;
}
function $9de43e8a1cfed7a8$var$parseUnknown(xml) {
    if (xml === undefined || xml === null) return "";
    // empty object
    if (!xml.firstElementChild) {
        if (xml.parentNode.parentNode === null) return {};
        if (xml.childNodes.length === 0) return "";
        else return xml.textContent;
    }
    // object, parse as structure
    var shape = {
        type: "structure",
        members: {}
    };
    var child = xml.firstElementChild;
    while(child){
        var tag = child.nodeName;
        if (Object.prototype.hasOwnProperty.call(shape.members, tag)) // multiple tags of the same name makes it a list
        shape.members[tag].type = "list";
        else shape.members[tag] = {
            name: tag
        };
        child = child.nextElementSibling;
    }
    return $9de43e8a1cfed7a8$var$parseStructure(xml, shape);
}
/**
 * @api private
 */ module.exports = $9de43e8a1cfed7a8$var$DomXmlParser;

});

parcelRequire.register("9d3sY", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");

var $73mPy = parcelRequire("73mPy");
var $6b4804460d4d8645$require$EventEmitter = $73mPy.EventEmitter;
parcelRequire("huvQa");
/**
 * @api private
 */ $dbC7k.XHRClient = $dbC7k.util.inherit({
    handleRequest: function handleRequest(httpRequest, httpOptions, callback, errCallback) {
        var self = this;
        var endpoint = httpRequest.endpoint;
        var emitter = new $6b4804460d4d8645$require$EventEmitter();
        var href = endpoint.protocol + "//" + endpoint.hostname;
        if (endpoint.port !== 80 && endpoint.port !== 443) href += ":" + endpoint.port;
        href += httpRequest.path;
        var xhr = new XMLHttpRequest(), headersEmitted = false;
        httpRequest.stream = xhr;
        xhr.addEventListener("readystatechange", function() {
            try {
                if (xhr.status === 0) return; // 0 code is invalid
            } catch (e) {
                return;
            }
            if (this.readyState >= this.HEADERS_RECEIVED && !headersEmitted) {
                emitter.statusCode = xhr.status;
                emitter.headers = self.parseHeaders(xhr.getAllResponseHeaders());
                emitter.emit("headers", emitter.statusCode, emitter.headers, xhr.statusText);
                headersEmitted = true;
            }
            if (this.readyState === this.DONE) self.finishRequest(xhr, emitter);
        }, false);
        xhr.upload.addEventListener("progress", function(evt) {
            emitter.emit("sendProgress", evt);
        });
        xhr.addEventListener("progress", function(evt) {
            emitter.emit("receiveProgress", evt);
        }, false);
        xhr.addEventListener("timeout", function() {
            errCallback($dbC7k.util.error(new Error("Timeout"), {
                code: "TimeoutError"
            }));
        }, false);
        xhr.addEventListener("error", function() {
            errCallback($dbC7k.util.error(new Error("Network Failure"), {
                code: "NetworkingError"
            }));
        }, false);
        xhr.addEventListener("abort", function() {
            errCallback($dbC7k.util.error(new Error("Request aborted"), {
                code: "RequestAbortedError"
            }));
        }, false);
        callback(emitter);
        xhr.open(httpRequest.method, href, httpOptions.xhrAsync !== false);
        $dbC7k.util.each(httpRequest.headers, function(key, value) {
            if (key !== "Content-Length" && key !== "User-Agent" && key !== "Host") xhr.setRequestHeader(key, value);
        });
        if (httpOptions.timeout && httpOptions.xhrAsync !== false) xhr.timeout = httpOptions.timeout;
        if (httpOptions.xhrWithCredentials) xhr.withCredentials = true;
        try {
            xhr.responseType = "arraybuffer";
        } catch (e) {}
        try {
            if (httpRequest.body) xhr.send(httpRequest.body);
            else xhr.send();
        } catch (err) {
            if (httpRequest.body && typeof httpRequest.body.buffer === "object") xhr.send(httpRequest.body.buffer); // send ArrayBuffer directly
            else throw err;
        }
        return emitter;
    },
    parseHeaders: function parseHeaders(rawHeaders) {
        var headers = {};
        $dbC7k.util.arrayEach(rawHeaders.split(/\r?\n/), function(line) {
            var key = line.split(":", 1)[0];
            var value = line.substring(key.length + 2);
            if (key.length > 0) headers[key.toLowerCase()] = value;
        });
        return headers;
    },
    finishRequest: function finishRequest(xhr, emitter) {
        var buffer;
        if (xhr.responseType === "arraybuffer" && xhr.response) {
            var ab = xhr.response;
            buffer = new $dbC7k.util.Buffer(ab.byteLength);
            var view = new Uint8Array(ab);
            for(var i = 0; i < buffer.length; ++i)buffer[i] = view[i];
        }
        try {
            if (!buffer && typeof xhr.responseText === "string") buffer = new $dbC7k.util.Buffer(xhr.responseText);
        } catch (e) {}
        if (buffer) emitter.emit("data", buffer);
        emitter.emit("end");
    }
});
/**
 * @api private
 */ $dbC7k.HttpClient.prototype = $dbC7k.XHRClient.prototype;
/**
 * @api private
 */ $dbC7k.HttpClient.streamsApiVersion = 1;

});
parcelRequire.register("73mPy", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
function $522a85db57c73b03$var$EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
}
module.exports = $522a85db57c73b03$var$EventEmitter;
// Backwards-compat with node 0.10.x
$522a85db57c73b03$var$EventEmitter.EventEmitter = $522a85db57c73b03$var$EventEmitter;
$522a85db57c73b03$var$EventEmitter.prototype._events = undefined;
$522a85db57c73b03$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$522a85db57c73b03$var$EventEmitter.defaultMaxListeners = 10;
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$522a85db57c73b03$var$EventEmitter.prototype.setMaxListeners = function(n) {
    if (!$522a85db57c73b03$var$isNumber(n) || n < 0 || isNaN(n)) throw TypeError("n must be a positive number");
    this._maxListeners = n;
    return this;
};
$522a85db57c73b03$var$EventEmitter.prototype.emit = function(type) {
    var er, handler, len, args, i, listeners;
    if (!this._events) this._events = {};
    // If there is no 'error' event listener then throw.
    if (type === "error") {
        if (!this._events.error || $522a85db57c73b03$var$isObject(this._events.error) && !this._events.error.length) {
            er = arguments[1];
            if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ")");
                err.context = er;
                throw err;
            }
        }
    }
    handler = this._events[type];
    if ($522a85db57c73b03$var$isUndefined(handler)) return false;
    if ($522a85db57c73b03$var$isFunction(handler)) switch(arguments.length){
        // fast cases
        case 1:
            handler.call(this);
            break;
        case 2:
            handler.call(this, arguments[1]);
            break;
        case 3:
            handler.call(this, arguments[1], arguments[2]);
            break;
        // slower
        default:
            args = Array.prototype.slice.call(arguments, 1);
            handler.apply(this, args);
    }
    else if ($522a85db57c73b03$var$isObject(handler)) {
        args = Array.prototype.slice.call(arguments, 1);
        listeners = handler.slice();
        len = listeners.length;
        for(i = 0; i < len; i++)listeners[i].apply(this, args);
    }
    return true;
};
$522a85db57c73b03$var$EventEmitter.prototype.addListener = function(type, listener) {
    var m;
    if (!$522a85db57c73b03$var$isFunction(listener)) throw TypeError("listener must be a function");
    if (!this._events) this._events = {};
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (this._events.newListener) this.emit("newListener", type, $522a85db57c73b03$var$isFunction(listener.listener) ? listener.listener : listener);
    if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
    else if ($522a85db57c73b03$var$isObject(this._events[type])) // If we've already got an array, just append.
    this._events[type].push(listener);
    else // Adding the second element, need to change to array.
    this._events[type] = [
        this._events[type],
        listener
    ];
    // Check for listener leak
    if ($522a85db57c73b03$var$isObject(this._events[type]) && !this._events[type].warned) {
        if (!$522a85db57c73b03$var$isUndefined(this._maxListeners)) m = this._maxListeners;
        else m = $522a85db57c73b03$var$EventEmitter.defaultMaxListeners;
        if (m && m > 0 && this._events[type].length > m) {
            this._events[type].warned = true;
            console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
            if (typeof console.trace === "function") // not supported in IE 10
            console.trace();
        }
    }
    return this;
};
$522a85db57c73b03$var$EventEmitter.prototype.on = $522a85db57c73b03$var$EventEmitter.prototype.addListener;
$522a85db57c73b03$var$EventEmitter.prototype.once = function(type, listener) {
    if (!$522a85db57c73b03$var$isFunction(listener)) throw TypeError("listener must be a function");
    var fired = false;
    function g() {
        this.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(this, arguments);
        }
    }
    g.listener = listener;
    this.on(type, g);
    return this;
};
// emits a 'removeListener' event iff the listener was removed
$522a85db57c73b03$var$EventEmitter.prototype.removeListener = function(type, listener) {
    var list, position, length, i;
    if (!$522a85db57c73b03$var$isFunction(listener)) throw TypeError("listener must be a function");
    if (!this._events || !this._events[type]) return this;
    list = this._events[type];
    length = list.length;
    position = -1;
    if (list === listener || $522a85db57c73b03$var$isFunction(list.listener) && list.listener === listener) {
        delete this._events[type];
        if (this._events.removeListener) this.emit("removeListener", type, listener);
    } else if ($522a85db57c73b03$var$isObject(list)) {
        for(i = length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list.length = 0;
            delete this._events[type];
        } else list.splice(position, 1);
        if (this._events.removeListener) this.emit("removeListener", type, listener);
    }
    return this;
};
$522a85db57c73b03$var$EventEmitter.prototype.removeAllListeners = function(type) {
    var key, listeners;
    if (!this._events) return this;
    // not listening for removeListener, no need to emit
    if (!this._events.removeListener) {
        if (arguments.length === 0) this._events = {};
        else if (this._events[type]) delete this._events[type];
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        for(key in this._events){
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = {};
        return this;
    }
    listeners = this._events[type];
    if ($522a85db57c73b03$var$isFunction(listeners)) this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    while(listeners.length)this.removeListener(type, listeners[listeners.length - 1]);
    delete this._events[type];
    return this;
};
$522a85db57c73b03$var$EventEmitter.prototype.listeners = function(type) {
    var ret;
    if (!this._events || !this._events[type]) ret = [];
    else if ($522a85db57c73b03$var$isFunction(this._events[type])) ret = [
        this._events[type]
    ];
    else ret = this._events[type].slice();
    return ret;
};
$522a85db57c73b03$var$EventEmitter.prototype.listenerCount = function(type) {
    if (this._events) {
        var evlistener = this._events[type];
        if ($522a85db57c73b03$var$isFunction(evlistener)) return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
};
$522a85db57c73b03$var$EventEmitter.listenerCount = function(emitter, type) {
    return emitter.listenerCount(type);
};
function $522a85db57c73b03$var$isFunction(arg) {
    return typeof arg === "function";
}
function $522a85db57c73b03$var$isNumber(arg) {
    return typeof arg === "number";
}
function $522a85db57c73b03$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
function $522a85db57c73b03$var$isUndefined(arg) {
    return arg === void 0;
}

});





parcelRequire.register("gkIJB", function(module, exports) {
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $gBqCF = parcelRequire("gBqCF");
$parcel$exportWildcard(module.exports, $gBqCF);

});
parcelRequire.register("gBqCF", function(module, exports) {

$parcel$export(module.exports, "ConsoleLogger", function () { return $c164c0bd47f3871d$export$ba6a9c7ac8291f7f; });
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $c164c0bd47f3871d$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $c164c0bd47f3871d$var$LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5
};
/**
 * Write logs
 * @class Logger
 */ var $c164c0bd47f3871d$export$ba6a9c7ac8291f7f = /** @class */ function() {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */ function ConsoleLogger(name, level) {
        if (level === void 0) level = "WARN";
        this.name = name;
        this.level = level;
    }
    ConsoleLogger.prototype._padding = function(n) {
        return n < 10 ? "0" + n : "" + n;
    };
    ConsoleLogger.prototype._ts = function() {
        var dt = new Date();
        return [
            this._padding(dt.getMinutes()),
            this._padding(dt.getSeconds())
        ].join(":") + "." + dt.getMilliseconds();
    };
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype._log = function(type) {
        var msg = [];
        for(var _i = 1; _i < arguments.length; _i++)msg[_i - 1] = arguments[_i];
        var logger_level_name = this.level;
        if (ConsoleLogger.LOG_LEVEL) logger_level_name = ConsoleLogger.LOG_LEVEL;
        if (typeof window !== "undefined" && window.LOG_LEVEL) logger_level_name = window.LOG_LEVEL;
        var logger_level = $c164c0bd47f3871d$var$LOG_LEVELS[logger_level_name];
        var type_level = $c164c0bd47f3871d$var$LOG_LEVELS[type];
        if (!(type_level >= logger_level)) // Do nothing if type is not greater than or equal to logger level (handle undefined)
        return;
        var log = console.log.bind(console);
        if (type === "ERROR" && console.error) log = console.error.bind(console);
        if (type === "WARN" && console.warn) log = console.warn.bind(console);
        var prefix = "[" + type + "] " + this._ts() + " " + this.name;
        if (msg.length === 1 && typeof msg[0] === "string") log(prefix + " - " + msg[0]);
        else if (msg.length === 1) log(prefix, msg[0]);
        else if (typeof msg[0] === "string") {
            var obj = msg.slice(1);
            if (obj.length === 1) obj = obj[0];
            log(prefix + " - " + msg[0], obj);
        } else log(prefix, msg);
    };
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.log = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $c164c0bd47f3871d$var$__spreadArrays([
            "INFO"
        ], msg));
    };
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.info = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $c164c0bd47f3871d$var$__spreadArrays([
            "INFO"
        ], msg));
    };
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.warn = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $c164c0bd47f3871d$var$__spreadArrays([
            "WARN"
        ], msg));
    };
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.error = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $c164c0bd47f3871d$var$__spreadArrays([
            "ERROR"
        ], msg));
    };
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.debug = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $c164c0bd47f3871d$var$__spreadArrays([
            "DEBUG"
        ], msg));
    };
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */ ConsoleLogger.prototype.verbose = function() {
        var msg = [];
        for(var _i = 0; _i < arguments.length; _i++)msg[_i] = arguments[_i];
        this._log.apply(this, $c164c0bd47f3871d$var$__spreadArrays([
            "VERBOSE"
        ], msg));
    };
    ConsoleLogger.LOG_LEVEL = null;
    return ConsoleLogger;
}();

});


parcelRequire.register("8Xt9v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $685a7273771cb104$export$2e2bcd8739ae039; });
parcelRequire("gkIJB");
var $gBqCF = parcelRequire("gBqCF");
var $685a7273771cb104$var$logger = new (0, $gBqCF.ConsoleLogger)("Amplify");
var $685a7273771cb104$var$Amplify = /** @class */ function() {
    function Amplify() {}
    Amplify.register = function(comp) {
        $685a7273771cb104$var$logger.debug("component registered in amplify", comp);
        this._components.push(comp);
        if (typeof comp.getModuleName === "function") Amplify[comp.getModuleName()] = comp;
        else $685a7273771cb104$var$logger.debug("no getModuleName method for component", comp);
    };
    Amplify.configure = function(config) {
        var _this = this;
        if (!config) return this._config;
        this._config = Object.assign(this._config, config);
        $685a7273771cb104$var$logger.debug("amplify config", this._config);
        this._components.map(function(comp) {
            comp.configure(_this._config);
        });
        return this._config;
    };
    Amplify.addPluggable = function(pluggable) {
        if (pluggable && pluggable["getCategory"] && typeof pluggable["getCategory"] === "function") this._components.map(function(comp) {
            if (comp["addPluggable"] && typeof comp["addPluggable"] === "function") comp.addPluggable(pluggable);
        });
    };
    Amplify._components = [];
    Amplify._config = {};
    // for backward compatibility to avoid breaking change
    // if someone is using like Amplify.Auth
    Amplify.Auth = null;
    Amplify.Analytics = null;
    Amplify.API = null;
    Amplify.Storage = null;
    Amplify.I18n = null;
    Amplify.Cache = null;
    Amplify.PubSub = null;
    Amplify.Interactions = null;
    Amplify.Pushnotification = null;
    Amplify.UI = null;
    Amplify.XR = null;
    Amplify.Predictions = null;
    Amplify.DataStore = null;
    Amplify.Logger = (0, $gBqCF.ConsoleLogger);
    Amplify.ServiceWorker = null;
    return Amplify;
}();
var $685a7273771cb104$export$2e2bcd8739ae039 = $685a7273771cb104$var$Amplify;

});

parcelRequire.register("egl3L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a622e5526e9d7f78$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $8qtcj = parcelRequire("8qtcj");
var $a622e5526e9d7f78$var$ClientDevice = /** @class */ function() {
    function ClientDevice() {}
    ClientDevice.clientInfo = function() {
        return $8qtcj.clientInfo();
    };
    ClientDevice.dimension = function() {
        return $8qtcj.dimension();
    };
    return ClientDevice;
}();
var $a622e5526e9d7f78$export$2e2bcd8739ae039 = $a622e5526e9d7f78$var$ClientDevice;

});
parcelRequire.register("8qtcj", function(module, exports) {

$parcel$export(module.exports, "clientInfo", function () { return $6227667aeb112aba$export$a2e6d3a753e91268; });
$parcel$export(module.exports, "dimension", function () { return $6227667aeb112aba$export$edcd89beb969619a; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("gkIJB");
var $gBqCF = parcelRequire("gBqCF");
var $6227667aeb112aba$var$logger = new (0, $gBqCF.ConsoleLogger)("ClientDevice_Browser");
function $6227667aeb112aba$export$a2e6d3a753e91268() {
    if (typeof window === "undefined") return {};
    return $6227667aeb112aba$var$browserClientInfo();
}
function $6227667aeb112aba$var$browserClientInfo() {
    if (typeof window === "undefined") {
        $6227667aeb112aba$var$logger.warn("No window object available to get browser client info");
        return {};
    }
    var nav = window.navigator;
    if (!nav) {
        $6227667aeb112aba$var$logger.warn("No navigator object available to get browser client info");
        return {};
    }
    var platform = nav.platform, product = nav.product, vendor = nav.vendor, userAgent = nav.userAgent, language = nav.language;
    var type = $6227667aeb112aba$var$browserType(userAgent);
    var timezone = $6227667aeb112aba$var$browserTimezone();
    return {
        platform: platform,
        make: product || vendor,
        model: type.type,
        version: type.version,
        appVersion: [
            type.type,
            type.version
        ].join("/"),
        language: language,
        timezone: timezone
    };
}
function $6227667aeb112aba$export$edcd89beb969619a() {
    if (typeof window === "undefined") {
        $6227667aeb112aba$var$logger.warn("No window object available to get browser client info");
        return {
            width: 320,
            height: 320
        };
    }
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}
function $6227667aeb112aba$var$browserTimezone() {
    var tzMatch = /\(([A-Za-z\s].*)\)/.exec(new Date().toString());
    return tzMatch ? tzMatch[1] || "" : "";
}
function $6227667aeb112aba$var$browserType(userAgent) {
    var operaMatch = /.+(Opera[\s[A-Z]*|OPR[\sA-Z]*)\/([0-9\.]+).*/i.exec(userAgent);
    if (operaMatch) return {
        type: operaMatch[1],
        version: operaMatch[2]
    };
    var ieMatch = /.+(Trident|Edge)\/([0-9\.]+).*/i.exec(userAgent);
    if (ieMatch) return {
        type: ieMatch[1],
        version: ieMatch[2]
    };
    var cfMatch = /.+(Chrome|Firefox|FxiOS)\/([0-9\.]+).*/i.exec(userAgent);
    if (cfMatch) return {
        type: cfMatch[1],
        version: cfMatch[2]
    };
    var sMatch = /.+(Safari)\/([0-9\.]+).*/i.exec(userAgent);
    if (sMatch) return {
        type: sMatch[1],
        version: sMatch[2]
    };
    var awkMatch = /.+(AppleWebKit)\/([0-9\.]+).*/i.exec(userAgent);
    if (awkMatch) return {
        type: awkMatch[1],
        version: awkMatch[2]
    };
    var anyMatch = /.*([A-Z]+)\/([0-9\.]+).*/i.exec(userAgent);
    if (anyMatch) return {
        type: anyMatch[1],
        version: anyMatch[2]
    };
    return {
        type: "",
        version: ""
    };
}

});


parcelRequire.register("cZG7C", function(module, exports) {
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ function $975bdb0f4a2f7aa8$export$b0a304098b703512(name) {
    return new Error("Missing config value of " + name);
}
function $975bdb0f4a2f7aa8$export$4765636db8d9fa0d(name) {
    return new Error("Invalid parameter value of " + name);
}

});

parcelRequire.register("iZUWK", function(module, exports) {

$parcel$export(module.exports, "HubClass", function () { return $dd4a18e462e0cdd1$export$6b38ef2be9abbbb9; });
$parcel$export(module.exports, "default", function () { return $dd4a18e462e0cdd1$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("gkIJB");
var $gBqCF = parcelRequire("gBqCF");
var $dd4a18e462e0cdd1$var$__assign = undefined && undefined.__assign || function() {
    $dd4a18e462e0cdd1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dd4a18e462e0cdd1$var$__assign.apply(this, arguments);
};
var $dd4a18e462e0cdd1$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $dd4a18e462e0cdd1$var$logger = new (0, $gBqCF.ConsoleLogger)("Hub");
var $dd4a18e462e0cdd1$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
function $dd4a18e462e0cdd1$var$isLegacyCallback(callback) {
    return callback.onHubCapsule !== undefined;
}
var $dd4a18e462e0cdd1$export$6b38ef2be9abbbb9 = /** @class */ function() {
    function HubClass(name) {
        this.listeners = [];
        this.patterns = [];
        this.protectedChannels = [
            "core",
            "auth",
            "api",
            "analytics",
            "interactions",
            "pubsub",
            "storage",
            "xr"
        ];
        this.name = name;
    }
    // Note - Need to pass channel as a reference for removal to work and not anonymous function
    HubClass.prototype.remove = function(channel, listener) {
        if (channel instanceof RegExp) {
            var pattern_1 = this.patterns.find(function(_a) {
                var pattern = _a.pattern;
                return pattern.source === channel.source;
            });
            if (!pattern_1) {
                $dd4a18e462e0cdd1$var$logger.warn("No listeners for " + channel);
                return;
            }
            this.patterns = $dd4a18e462e0cdd1$var$__spreadArrays(this.patterns.filter(function(x) {
                return x !== pattern_1;
            }));
        } else {
            var holder = this.listeners[channel];
            if (!holder) {
                $dd4a18e462e0cdd1$var$logger.warn("No listeners for " + channel);
                return;
            }
            this.listeners[channel] = $dd4a18e462e0cdd1$var$__spreadArrays(holder.filter(function(_a) {
                var callback = _a.callback;
                return callback !== listener;
            }));
        }
    };
    HubClass.prototype.dispatch = function(channel, payload, source, ampSymbol) {
        if (source === void 0) source = "";
        if (this.protectedChannels.indexOf(channel) > -1) {
            var hasAccess = ampSymbol === $dd4a18e462e0cdd1$var$AMPLIFY_SYMBOL;
            if (!hasAccess) $dd4a18e462e0cdd1$var$logger.warn("WARNING: " + channel + " is protected and dispatching on it can have unintended consequences");
        }
        var capsule = {
            channel: channel,
            payload: $dd4a18e462e0cdd1$var$__assign({}, payload),
            source: source,
            patternInfo: []
        };
        try {
            this._toListeners(capsule);
        } catch (e) {
            $dd4a18e462e0cdd1$var$logger.error(e);
        }
    };
    HubClass.prototype.listen = function(channel, callback, listenerName) {
        if (listenerName === void 0) listenerName = "noname";
        var cb;
        // Check for legacy onHubCapsule callback for backwards compatability
        if ($dd4a18e462e0cdd1$var$isLegacyCallback(callback)) {
            $dd4a18e462e0cdd1$var$logger.warn("WARNING onHubCapsule is Deprecated. Please pass in a callback.");
            cb = callback.onHubCapsule.bind(callback);
        } else if (typeof callback !== "function") throw new Error("No callback supplied to Hub");
        else cb = callback;
        if (channel instanceof RegExp) this.patterns.push({
            pattern: channel,
            callback: cb
        });
        else {
            var holder = this.listeners[channel];
            if (!holder) {
                holder = [];
                this.listeners[channel] = holder;
            }
            holder.push({
                name: listenerName,
                callback: cb
            });
        }
    };
    HubClass.prototype._toListeners = function(capsule) {
        var channel = capsule.channel, payload = capsule.payload;
        var holder = this.listeners[channel];
        if (holder) holder.forEach(function(listener) {
            $dd4a18e462e0cdd1$var$logger.debug("Dispatching to " + channel + " with ", payload);
            try {
                listener.callback(capsule);
            } catch (e) {
                $dd4a18e462e0cdd1$var$logger.error(e);
            }
        });
        if (this.patterns.length > 0) {
            if (!payload.message) {
                $dd4a18e462e0cdd1$var$logger.warn("Cannot perform pattern matching without a message key");
                return;
            }
            var payloadStr_1 = payload.message;
            this.patterns.forEach(function(pattern) {
                var match = payloadStr_1.match(pattern.pattern);
                if (match) {
                    var groups = match.slice(1);
                    var dispatchingCapsule = $dd4a18e462e0cdd1$var$__assign($dd4a18e462e0cdd1$var$__assign({}, capsule), {
                        patternInfo: groups
                    });
                    try {
                        pattern.callback(dispatchingCapsule);
                    } catch (e) {
                        $dd4a18e462e0cdd1$var$logger.error(e);
                    }
                }
            });
        }
    };
    return HubClass;
}();
/*We export a __default__ instance of HubClass to use it as a
psuedo Singleton for the main messaging bus, however you can still create
your own instance of HubClass() for a separate "private bus" of events.*/ var $dd4a18e462e0cdd1$var$Hub = new $dd4a18e462e0cdd1$export$6b38ef2be9abbbb9("__default__");
var $dd4a18e462e0cdd1$export$2e2bcd8739ae039 = $dd4a18e462e0cdd1$var$Hub;

});

parcelRequire.register("f70Ze", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b008465e9f70cba0$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $6zsEB = parcelRequire("6zsEB");
parcelRequire("gkIJB");
var $gBqCF = parcelRequire("gBqCF");

var $8Xt9v = parcelRequire("8Xt9v");
var $b008465e9f70cba0$var$logger = new (0, $gBqCF.ConsoleLogger)("I18n");
var $b008465e9f70cba0$var$_config = null;
var $b008465e9f70cba0$var$_i18n = null;
/**
 * Export I18n APIs
 */ var $b008465e9f70cba0$var$I18n = /** @class */ function() {
    function I18n() {}
    /**
     * @static
     * @method
     * Configure I18n part
     * @param {Object} config - Configuration of the I18n
     */ I18n.configure = function(config) {
        $b008465e9f70cba0$var$logger.debug("configure I18n");
        if (!config) return $b008465e9f70cba0$var$_config;
        $b008465e9f70cba0$var$_config = Object.assign({}, $b008465e9f70cba0$var$_config, config.I18n || config);
        I18n.createInstance();
        return $b008465e9f70cba0$var$_config;
    };
    I18n.getModuleName = function() {
        return "I18n";
    };
    /**
     * @static
     * @method
     * Create an instance of I18n for the library
     */ I18n.createInstance = function() {
        $b008465e9f70cba0$var$logger.debug("create I18n instance");
        if ($b008465e9f70cba0$var$_i18n) return;
        $b008465e9f70cba0$var$_i18n = new (0, $6zsEB.I18n)($b008465e9f70cba0$var$_config);
    };
    /**
     * @static @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.setLanguage = function(lang) {
        I18n.checkConfig();
        return $b008465e9f70cba0$var$_i18n.setLanguage(lang);
    };
    /**
     * @static @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.get = function(key, defVal) {
        if (!I18n.checkConfig()) return typeof defVal === "undefined" ? key : defVal;
        return $b008465e9f70cba0$var$_i18n.get(key, defVal);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {String} langurage - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.putVocabulariesForLanguage = function(language, vocabularies) {
        I18n.checkConfig();
        return $b008465e9f70cba0$var$_i18n.putVocabulariesForLanguage(language, vocabularies);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.putVocabularies = function(vocabularies) {
        I18n.checkConfig();
        return $b008465e9f70cba0$var$_i18n.putVocabularies(vocabularies);
    };
    I18n.checkConfig = function() {
        if (!$b008465e9f70cba0$var$_i18n) $b008465e9f70cba0$var$_i18n = new (0, $6zsEB.I18n)($b008465e9f70cba0$var$_config);
        return true;
    };
    return I18n;
}();
(0, $8Xt9v.default).register($b008465e9f70cba0$var$I18n);
var $b008465e9f70cba0$export$2e2bcd8739ae039 = $b008465e9f70cba0$var$I18n;

});
parcelRequire.register("6zsEB", function(module, exports) {

$parcel$export(module.exports, "I18n", function () { return $4c8c3d092129ed81$export$dbe3113d60765c1a; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("gkIJB");
var $gBqCF = parcelRequire("gBqCF");
var $4c8c3d092129ed81$var$logger = new (0, $gBqCF.ConsoleLogger)("I18n");
/**
 * Language transition class
 */ var $4c8c3d092129ed81$export$dbe3113d60765c1a = /** @class */ function() {
    /**
     * @constructor
     * Initialize with configurations
     * @param {Object} options
     */ function I18n(options) {
        /**
         * @private
         */ this._options = null;
        /**
         * @private
         */ this._lang = null;
        /**
         * @private
         */ this._dict = {};
        this._options = Object.assign({}, options);
        this._lang = this._options.language;
        if (!this._lang && typeof window !== "undefined" && window && window.navigator) this._lang = window.navigator.language;
        $4c8c3d092129ed81$var$logger.debug(this._lang);
    }
    /**
     * @method
     * Explicitly setting language
     * @param {String} lang
     */ I18n.prototype.setLanguage = function(lang) {
        this._lang = lang;
    };
    /**
     * @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */ I18n.prototype.get = function(key, defVal) {
        if (defVal === void 0) defVal = undefined;
        if (!this._lang) return typeof defVal !== "undefined" ? defVal : key;
        var lang = this._lang;
        var val = this.getByLanguage(key, lang);
        if (val) return val;
        if (lang.indexOf("-") > 0) val = this.getByLanguage(key, lang.split("-")[0]);
        if (val) return val;
        return typeof defVal !== "undefined" ? defVal : key;
    };
    /**
     * @method
     * Get value according to specified language
     * @param {String} key
     * @param {String} language - Specified langurage to be used
     * @param {String} defVal - Default value
     */ I18n.prototype.getByLanguage = function(key, language, defVal) {
        if (defVal === void 0) defVal = null;
        if (!language) return defVal;
        var lang_dict = this._dict[language];
        if (!lang_dict) return defVal;
        return lang_dict[key];
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {String} langurage - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */ I18n.prototype.putVocabulariesForLanguage = function(language, vocabularies) {
        var lang_dict = this._dict[language];
        if (!lang_dict) lang_dict = this._dict[language] = {};
        Object.assign(lang_dict, vocabularies);
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */ I18n.prototype.putVocabularies = function(vocabularies) {
        var _this = this;
        Object.keys(vocabularies).map(function(key) {
            _this.putVocabulariesForLanguage(key, vocabularies[key]);
        });
    };
    return I18n;
}();

});


parcelRequire.register("gssgp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfb52f74a5913258$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $e67mm = parcelRequire("e67mm");
var $bfb52f74a5913258$var$MIME_MAP = [
    {
        type: "text/plain",
        ext: "txt"
    },
    {
        type: "text/html",
        ext: "html"
    },
    {
        type: "text/javascript",
        ext: "js"
    },
    {
        type: "text/css",
        ext: "css"
    },
    {
        type: "text/csv",
        ext: "csv"
    },
    {
        type: "text/yaml",
        ext: "yml"
    },
    {
        type: "text/yaml",
        ext: "yaml"
    },
    {
        type: "text/calendar",
        ext: "ics"
    },
    {
        type: "text/calendar",
        ext: "ical"
    },
    {
        type: "image/png",
        ext: "png"
    },
    {
        type: "image/gif",
        ext: "gif"
    },
    {
        type: "image/jpeg",
        ext: "jpg"
    },
    {
        type: "image/jpeg",
        ext: "jpeg"
    },
    {
        type: "image/bmp",
        ext: "bmp"
    },
    {
        type: "image/x-icon",
        ext: "ico"
    },
    {
        type: "image/tiff",
        ext: "tif"
    },
    {
        type: "image/tiff",
        ext: "tiff"
    },
    {
        type: "image/svg+xml",
        ext: "svg"
    },
    {
        type: "application/json",
        ext: "json"
    },
    {
        type: "application/xml",
        ext: "xml"
    },
    {
        type: "application/x-sh",
        ext: "sh"
    },
    {
        type: "application/zip",
        ext: "zip"
    },
    {
        type: "application/x-rar-compressed",
        ext: "rar"
    },
    {
        type: "application/x-tar",
        ext: "tar"
    },
    {
        type: "application/x-bzip",
        ext: "bz"
    },
    {
        type: "application/x-bzip2",
        ext: "bz2"
    },
    {
        type: "application/pdf",
        ext: "pdf"
    },
    {
        type: "application/java-archive",
        ext: "jar"
    },
    {
        type: "application/msword",
        ext: "doc"
    },
    {
        type: "application/vnd.ms-excel",
        ext: "xls"
    },
    {
        type: "application/vnd.ms-excel",
        ext: "xlsx"
    },
    {
        type: "message/rfc822",
        ext: "eml"
    }
];
var $bfb52f74a5913258$var$JS = /** @class */ function() {
    function JS() {}
    JS.isEmpty = function(obj) {
        return Object.keys(obj).length === 0;
    };
    JS.sortByField = function(list, field, dir) {
        if (!list || !list.sort) return false;
        var dirX = dir && dir === "desc" ? -1 : 1;
        list.sort(function(a, b) {
            var a_val = a[field];
            var b_val = b[field];
            if (typeof b_val === "undefined") return typeof a_val === "undefined" ? 0 : 1 * dirX;
            if (typeof a_val === "undefined") return -1 * dirX;
            if (a_val < b_val) return -1 * dirX;
            if (a_val > b_val) return 1 * dirX;
            return 0;
        });
        return true;
    };
    JS.objectLessAttributes = function(obj, less) {
        var ret = Object.assign({}, obj);
        if (less) {
            if (typeof less === "string") delete ret[less];
            else less.forEach(function(attr) {
                delete ret[attr];
            });
        }
        return ret;
    };
    JS.filenameToContentType = function(filename, defVal) {
        if (defVal === void 0) defVal = "application/octet-stream";
        var name = filename.toLowerCase();
        var filtered = $bfb52f74a5913258$var$MIME_MAP.filter(function(mime) {
            return name.endsWith("." + mime.ext);
        });
        return filtered.length > 0 ? filtered[0].type : defVal;
    };
    JS.isTextFile = function(contentType) {
        var type = contentType.toLowerCase();
        if (type.startsWith("text/")) return true;
        return "application/json" === type || "application/xml" === type || "application/sh" === type;
    };
    /**
     * generate random string
     */ JS.generateRandomString = function() {
        var result = "";
        var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        for(var i = 32; i > 0; i -= 1)result += chars[Math.floor(Math.random() * chars.length)];
        return result;
    };
    JS.makeQuerablePromise = function(promise) {
        if (promise.isResolved) return promise;
        var isPending = true;
        var isRejected = false;
        var isFullfilled = false;
        var result = promise.then(function(data) {
            isFullfilled = true;
            isPending = false;
            return data;
        }, function(e) {
            isRejected = true;
            isPending = false;
            throw e;
        });
        result.isFullfilled = function() {
            return isFullfilled;
        };
        result.isPending = function() {
            return isPending;
        };
        result.isRejected = function() {
            return isRejected;
        };
        return result;
    };
    JS.browserOrNode = function() {
        var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";
        var isNode = typeof $e67mm !== "undefined" && $e67mm.versions != null && $e67mm.versions.node != null;
        return {
            isBrowser: isBrowser,
            isNode: isNode
        };
    };
    /**
     * transfer the first letter of the keys to lowercase
     * @param {Object} obj - the object need to be transferred
     * @param {Array} whiteListForItself - whitelist itself from being transferred
     * @param {Array} whiteListForChildren - whitelist its children keys from being transferred
     */ JS.transferKeyToLowerCase = function(obj, whiteListForItself, whiteListForChildren) {
        if (whiteListForItself === void 0) whiteListForItself = [];
        if (whiteListForChildren === void 0) whiteListForChildren = [];
        if (!JS.isStrictObject(obj)) return obj;
        var ret = {};
        for(var key in obj)if (obj.hasOwnProperty(key)) {
            var transferedKey = whiteListForItself.includes(key) ? key : key[0].toLowerCase() + key.slice(1);
            ret[transferedKey] = whiteListForChildren.includes(key) ? obj[key] : JS.transferKeyToLowerCase(obj[key], whiteListForItself, whiteListForChildren);
        }
        return ret;
    };
    /**
     * transfer the first letter of the keys to lowercase
     * @param {Object} obj - the object need to be transferred
     * @param {Array} whiteListForItself - whitelist itself from being transferred
     * @param {Array} whiteListForChildren - whitelist its children keys from being transferred
     */ JS.transferKeyToUpperCase = function(obj, whiteListForItself, whiteListForChildren) {
        if (whiteListForItself === void 0) whiteListForItself = [];
        if (whiteListForChildren === void 0) whiteListForChildren = [];
        if (!JS.isStrictObject(obj)) return obj;
        var ret = {};
        for(var key in obj)if (obj.hasOwnProperty(key)) {
            var transferedKey = whiteListForItself.includes(key) ? key : key[0].toUpperCase() + key.slice(1);
            ret[transferedKey] = whiteListForChildren.includes(key) ? obj[key] : JS.transferKeyToUpperCase(obj[key], whiteListForItself, whiteListForChildren);
        }
        return ret;
    };
    /**
     * Return true if the object is a strict object
     * which means it's not Array, Function, Number, String, Boolean or Null
     * @param obj the Object
     */ JS.isStrictObject = function(obj) {
        return obj instanceof Object && !(obj instanceof Array) && !(obj instanceof Function) && !(obj instanceof Number) && !(obj instanceof String) && !(obj instanceof Boolean);
    };
    return JS;
}();
var $bfb52f74a5913258$export$2e2bcd8739ae039 = $bfb52f74a5913258$var$JS;

});

parcelRequire.register("kP2rz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f28a7758fb251273$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("gkIJB");
var $gBqCF = parcelRequire("gBqCF");
parcelRequire("eHBkL");
var $j8YuG = parcelRequire("j8YuG");
parcelRequire("iBT7b");
var $blxMe = parcelRequire("blxMe");
var $f28a7758fb251273$var$__assign = undefined && undefined.__assign || function() {
    $f28a7758fb251273$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f28a7758fb251273$var$__assign.apply(this, arguments);
};
var $f28a7758fb251273$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f28a7758fb251273$var$logger = new (0, $gBqCF.ConsoleLogger)("Signer");

var $i3eDV = parcelRequire("i3eDV");
var $f28a7758fb251273$var$crypto = (0, $blxMe)["util"].crypto;
var $f28a7758fb251273$var$DEFAULT_ALGORITHM = "AWS4-HMAC-SHA256";
var $f28a7758fb251273$var$IOT_SERVICE_NAME = "iotdevicegateway";
var $f28a7758fb251273$var$encrypt = function(key, src, encoding) {
    return $f28a7758fb251273$var$crypto.lib.createHmac("sha256", key).update(src, "utf8").digest(encoding);
};
var $f28a7758fb251273$var$hash = function(src) {
    var arg = src || "";
    return $f28a7758fb251273$var$crypto.createHash("sha256").update(arg, "utf8").digest("hex");
};
/**
 * @private
 * RFC 3986 compliant version of encodeURIComponent
 */ var $f28a7758fb251273$var$escape_RFC3986 = function(component) {
    return component.replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
};
/**
 * @private
 * Create canonical query string
 *
 */ var $f28a7758fb251273$var$canonical_query = function(query) {
    if (!query || query.length === 0) return "";
    return query.split("&").map(function(e) {
        var key_val = e.split("=");
        if (key_val.length === 1) return e;
        else {
            var reencoded_val = $f28a7758fb251273$var$escape_RFC3986(key_val[1]);
            return key_val[0] + "=" + reencoded_val;
        }
    }).sort(function(a, b) {
        var key_a = a.split("=")[0];
        var key_b = b.split("=")[0];
        if (key_a === key_b) return a < b ? -1 : 1;
        else return key_a < key_b ? -1 : 1;
    }).join("&");
};
/**
* @private
* Create canonical headers
*
<pre>
CanonicalHeaders =
    CanonicalHeadersEntry0 + CanonicalHeadersEntry1 + ... + CanonicalHeadersEntryN
CanonicalHeadersEntry =
    Lowercase(HeaderName) + ':' + Trimall(HeaderValue) + '\n'
</pre>
*/ var $f28a7758fb251273$var$canonical_headers = function(headers) {
    if (!headers || Object.keys(headers).length === 0) return "";
    return Object.keys(headers).map(function(key) {
        return {
            key: key.toLowerCase(),
            value: headers[key] ? headers[key].trim().replace(/\s+/g, " ") : ""
        };
    }).sort(function(a, b) {
        return a.key < b.key ? -1 : 1;
    }).map(function(item) {
        return item.key + ":" + item.value;
    }).join("\n") + "\n";
};
/**
 * List of header keys included in the canonical headers.
 * @access private
 */ var $f28a7758fb251273$var$signed_headers = function(headers) {
    return Object.keys(headers).map(function(key) {
        return key.toLowerCase();
    }).sort().join(";");
};
/**
* @private
* Create canonical request
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-canonical-request.html|Create a Canonical Request}
*
<pre>
CanonicalRequest =
    HTTPRequestMethod + '\n' +
    CanonicalURI + '\n' +
    CanonicalQueryString + '\n' +
    CanonicalHeaders + '\n' +
    SignedHeaders + '\n' +
    HexEncode(Hash(RequestPayload))
</pre>
*/ var $f28a7758fb251273$var$canonical_request = function(request) {
    var url_info = $i3eDV.parse(request.url);
    return [
        request.method || "/",
        encodeURIComponent(url_info.pathname).replace(/%2F/gi, "/"),
        $f28a7758fb251273$var$canonical_query(url_info.query),
        $f28a7758fb251273$var$canonical_headers(request.headers),
        $f28a7758fb251273$var$signed_headers(request.headers),
        $f28a7758fb251273$var$hash(request.data)
    ].join("\n");
};
var $f28a7758fb251273$var$parse_service_info = function(request) {
    var url_info = $i3eDV.parse(request.url), host = url_info.host;
    var matched = host.match(/([^\.]+)\.(?:([^\.]*)\.)?amazonaws\.com$/);
    var parsed = (matched || []).slice(1, 3);
    if (parsed[1] === "es") // Elastic Search
    parsed = parsed.reverse();
    return {
        service: request.service || parsed[0],
        region: request.region || parsed[1]
    };
};
var $f28a7758fb251273$var$credential_scope = function(d_str, region, service) {
    return [
        d_str,
        region,
        service,
        "aws4_request"
    ].join("/");
};
/**
* @private
* Create a string to sign
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-string-to-sign.html|Create String to Sign}
*
<pre>
StringToSign =
    Algorithm + \n +
    RequestDateTime + \n +
    CredentialScope + \n +
    HashedCanonicalRequest
</pre>
*/ var $f28a7758fb251273$var$string_to_sign = function(algorithm, canonical_request, dt_str, scope) {
    return [
        algorithm,
        dt_str,
        scope,
        $f28a7758fb251273$var$hash(canonical_request)
    ].join("\n");
};
/**
* @private
* Create signing key
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-calculate-signature.html|Calculate Signature}
*
<pre>
kSecret = your secret access key
kDate = HMAC("AWS4" + kSecret, Date)
kRegion = HMAC(kDate, Region)
kService = HMAC(kRegion, Service)
kSigning = HMAC(kService, "aws4_request")
</pre>
*/ var $f28a7758fb251273$var$get_signing_key = function(secret_key, d_str, service_info) {
    $f28a7758fb251273$var$logger.debug(service_info);
    var k = "AWS4" + secret_key, k_date = $f28a7758fb251273$var$encrypt(k, d_str), k_region = $f28a7758fb251273$var$encrypt(k_date, service_info.region), k_service = $f28a7758fb251273$var$encrypt(k_region, service_info.service), k_signing = $f28a7758fb251273$var$encrypt(k_service, "aws4_request");
    return k_signing;
};
var $f28a7758fb251273$var$get_signature = function(signing_key, str_to_sign) {
    return $f28a7758fb251273$var$encrypt(signing_key, str_to_sign, "hex");
};
/**
 * @private
 * Create authorization header
 * Refer to
 * {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html|Add the Signing Information}
 */ var $f28a7758fb251273$var$get_authorization_header = function(algorithm, access_key, scope, signed_headers, signature) {
    return [
        algorithm + " " + "Credential=" + access_key + "/" + scope,
        "SignedHeaders=" + signed_headers,
        "Signature=" + signature
    ].join(", ");
};
/**
 * AWS request signer.
 * Refer to {@link http://docs.aws.amazon.com/general/latest/gr/sigv4_signing.html|Signature Version 4}
 *
 * @class Signer
 */ var $f28a7758fb251273$var$Signer = /** @class */ function() {
    function Signer() {}
    /**
    * Sign a HTTP request, add 'Authorization' header to request param
    * @method sign
    * @memberof Signer
    * @static
    *
    * @param {object} request - HTTP request object
    <pre>
    request: {
        method: GET | POST | PUT ...
        url: ...,
        headers: {
            header1: ...
        },
        data: data
    }
    </pre>
    * @param {object} access_info - AWS access credential info
    <pre>
    access_info: {
        access_key: ...,
        secret_key: ...,
        session_token: ...
    }
    </pre>
    * @param {object} [service_info] - AWS service type and region, optional,
    *                                  if not provided then parse out from url
    <pre>
    service_info: {
        service: ...,
        region: ...
    }
    </pre>
    *
    * @returns {object} Signed HTTP request
    */ Signer.sign = function(request, access_info, service_info) {
        if (service_info === void 0) service_info = null;
        request.headers = request.headers || {};
        // datetime string and date string
        var dt = (0, $j8YuG.DateUtils).getDateWithClockOffset(), dt_str = dt.toISOString().replace(/[:\-]|\.\d{3}/g, ""), d_str = dt_str.substr(0, 8);
        var url_info = $i3eDV.parse(request.url);
        request.headers["host"] = url_info.host;
        request.headers["x-amz-date"] = dt_str;
        if (access_info.session_token) request.headers["X-Amz-Security-Token"] = access_info.session_token;
        // Task 1: Create a Canonical Request
        var request_str = $f28a7758fb251273$var$canonical_request(request);
        $f28a7758fb251273$var$logger.debug(request_str);
        // Task 2: Create a String to Sign
        var serviceInfo = service_info || $f28a7758fb251273$var$parse_service_info(request), scope = $f28a7758fb251273$var$credential_scope(d_str, serviceInfo.region, serviceInfo.service), str_to_sign = $f28a7758fb251273$var$string_to_sign($f28a7758fb251273$var$DEFAULT_ALGORITHM, request_str, dt_str, scope);
        // Task 3: Calculate the Signature
        var signing_key = $f28a7758fb251273$var$get_signing_key(access_info.secret_key, d_str, serviceInfo), signature = $f28a7758fb251273$var$get_signature(signing_key, str_to_sign);
        // Task 4: Adding the Signing information to the Request
        var authorization_header = $f28a7758fb251273$var$get_authorization_header($f28a7758fb251273$var$DEFAULT_ALGORITHM, access_info.access_key, scope, $f28a7758fb251273$var$signed_headers(request.headers), signature);
        request.headers["Authorization"] = authorization_header;
        return request;
    };
    Signer.signUrl = function(urlOrRequest, accessInfo, serviceInfo, expiration) {
        var urlToSign = typeof urlOrRequest === "object" ? urlOrRequest.url : urlOrRequest;
        var method = typeof urlOrRequest === "object" ? urlOrRequest.method : "GET";
        var body = typeof urlOrRequest === "object" ? urlOrRequest.body : undefined;
        var now = (0, $j8YuG.DateUtils).getDateWithClockOffset().toISOString().replace(/[:\-]|\.\d{3}/g, "");
        var today = now.substr(0, 8);
        // Intentionally discarding search
        var _a = $i3eDV.parse(urlToSign, true, true), search = _a.search, parsedUrl = $f28a7758fb251273$var$__rest(_a, [
            "search"
        ]);
        var host = parsedUrl.host;
        var signedHeaders = {
            host: host
        };
        var _b = serviceInfo || $f28a7758fb251273$var$parse_service_info({
            url: $i3eDV.format(parsedUrl)
        }), region = _b.region, service = _b.service;
        var credentialScope = $f28a7758fb251273$var$credential_scope(today, region, service);
        // IoT service does not allow the session token in the canonical request
        // https://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html
        var sessionTokenRequired = accessInfo.session_token && service !== $f28a7758fb251273$var$IOT_SERVICE_NAME;
        var queryParams = $f28a7758fb251273$var$__assign($f28a7758fb251273$var$__assign($f28a7758fb251273$var$__assign({
            "X-Amz-Algorithm": $f28a7758fb251273$var$DEFAULT_ALGORITHM,
            "X-Amz-Credential": [
                accessInfo.access_key,
                credentialScope
            ].join("/"),
            "X-Amz-Date": now.substr(0, 16)
        }, sessionTokenRequired ? {
            "X-Amz-Security-Token": "" + accessInfo.session_token
        } : {}), expiration ? {
            "X-Amz-Expires": "" + expiration
        } : {}), {
            "X-Amz-SignedHeaders": Object.keys(signedHeaders).join(",")
        });
        var canonicalRequest = $f28a7758fb251273$var$canonical_request({
            method: method,
            url: $i3eDV.format($f28a7758fb251273$var$__assign($f28a7758fb251273$var$__assign({}, parsedUrl), {
                query: $f28a7758fb251273$var$__assign($f28a7758fb251273$var$__assign({}, parsedUrl.query), queryParams)
            })),
            headers: signedHeaders,
            data: body
        });
        var stringToSign = $f28a7758fb251273$var$string_to_sign($f28a7758fb251273$var$DEFAULT_ALGORITHM, canonicalRequest, now, credentialScope);
        var signing_key = $f28a7758fb251273$var$get_signing_key(accessInfo.secret_key, today, {
            region: region,
            service: service
        });
        var signature = $f28a7758fb251273$var$get_signature(signing_key, stringToSign);
        var additionalQueryParams = $f28a7758fb251273$var$__assign({
            "X-Amz-Signature": signature
        }, accessInfo.session_token && {
            "X-Amz-Security-Token": accessInfo.session_token
        });
        var result = $i3eDV.format({
            protocol: parsedUrl.protocol,
            slashes: true,
            hostname: parsedUrl.hostname,
            port: parsedUrl.port,
            pathname: parsedUrl.pathname,
            query: $f28a7758fb251273$var$__assign($f28a7758fb251273$var$__assign($f28a7758fb251273$var$__assign({}, parsedUrl.query), queryParams), additionalQueryParams)
        });
        return result;
    };
    return Signer;
}();
var $f28a7758fb251273$export$2e2bcd8739ae039 = $f28a7758fb251273$var$Signer;

});
parcelRequire.register("eHBkL", function(module, exports) {
$parcel$export(module.exports, "DateUtils", function () { return (parcelRequire("j8YuG")).DateUtils; });

$parcel$export(module.exports, "Mutex", function () { return (parcelRequire("bU8Gd")).default; });
$parcel$export(module.exports, "Reachability", function () { return (parcelRequire("1hyL4")).default; });

var $9opJY = parcelRequire("9opJY");

var $bU8Gd = parcelRequire("bU8Gd");

var $1hyL4 = parcelRequire("1hyL4");
parcelRequire("j8YuG");
$parcel$exportWildcard(module.exports, $9opJY);

});
parcelRequire.register("9opJY", function(module, exports) {

$parcel$export(module.exports, "NonRetryableError", function () { return $6d6a5275358dc678$export$1e38badc838ad384; });
$parcel$export(module.exports, "jitteredExponentialRetry", function () { return $6d6a5275358dc678$export$a24aa7705df9cf44; });

var $gBqCF = parcelRequire("gBqCF");
var $6d6a5275358dc678$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6d6a5275358dc678$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6d6a5275358dc678$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $6d6a5275358dc678$var$logger = new (0, $gBqCF.ConsoleLogger)("Util");
var $6d6a5275358dc678$export$1e38badc838ad384 = /** @class */ function(_super) {
    $6d6a5275358dc678$var$__extends(NonRetryableError, _super);
    function NonRetryableError(message) {
        var _this = _super.call(this, message) || this;
        _this.nonRetryable = true;
        return _this;
    }
    return NonRetryableError;
}(Error);
var $6d6a5275358dc678$var$isNonRetryableError = function(obj) {
    var key = "nonRetryable";
    return obj && obj[key];
};
function $6d6a5275358dc678$export$9369b12211e1fce4(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) attempt = 1;
    return $6d6a5275358dc678$var$__awaiter(this, void 0, void 0, function() {
        var err_1, retryIn_1;
        return $6d6a5275358dc678$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (typeof functionToRetry !== "function") throw Error("functionToRetry must be a function");
                    $6d6a5275358dc678$var$logger.debug(functionToRetry.name + " attempt #" + attempt + " with this vars: " + JSON.stringify(args));
                    _a.label = 1;
                case 1:
                    _a.trys.push([
                        1,
                        3,
                        ,
                        8
                    ]);
                    return [
                        4 /*yield*/ ,
                        functionToRetry.apply(void 0, args)
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
                case 3:
                    err_1 = _a.sent();
                    $6d6a5275358dc678$var$logger.debug("error on " + functionToRetry.name + ": " + err_1 + " ");
                    if ($6d6a5275358dc678$var$isNonRetryableError(err_1)) {
                        $6d6a5275358dc678$var$logger.debug(functionToRetry.name + " non retryable error " + err_1);
                        throw err_1;
                    }
                    retryIn_1 = delayFn(attempt, args, err_1);
                    $6d6a5275358dc678$var$logger.debug(functionToRetry.name + " retrying in " + retryIn_1 + " ms");
                    if (!(retryIn_1 !== false)) return [
                        3 /*break*/ ,
                        6
                    ];
                    return [
                        4 /*yield*/ ,
                        new Promise(function(res) {
                            return setTimeout(res, retryIn_1);
                        })
                    ];
                case 4:
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        $6d6a5275358dc678$export$9369b12211e1fce4(functionToRetry, args, delayFn, attempt + 1)
                    ];
                case 5:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
                case 6:
                    throw err_1;
                case 7:
                    return [
                        3 /*break*/ ,
                        8
                    ];
                case 8:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
var $6d6a5275358dc678$var$MAX_DELAY_MS = 300000;
function $6d6a5275358dc678$var$jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function(attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
var $6d6a5275358dc678$export$a24aa7705df9cf44 = function(functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) maxDelayMs = $6d6a5275358dc678$var$MAX_DELAY_MS;
    return $6d6a5275358dc678$export$9369b12211e1fce4(functionToRetry, args, $6d6a5275358dc678$var$jitteredBackoff(maxDelayMs));
};

});

parcelRequire.register("bU8Gd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8aaba8552c5b1e60$export$2e2bcd8739ae039; });
/*!
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Christian Speckner <cnspeckn@googlemail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $8aaba8552c5b1e60$var$Mutex = /** @class */ function() {
    function Mutex() {
        this._queue = [];
        this._pending = false;
    }
    Mutex.prototype.isLocked = function() {
        return this._pending;
    };
    Mutex.prototype.acquire = function() {
        var _this = this;
        var ticket = new Promise(function(resolve) {
            return _this._queue.push(resolve);
        });
        if (!this._pending) this._dispatchNext();
        return ticket;
    };
    Mutex.prototype.runExclusive = function(callback) {
        return this.acquire().then(function(release) {
            var result;
            try {
                result = callback();
            } catch (e) {
                release();
                throw e;
            }
            return Promise.resolve(result).then(function(x) {
                return release(), x;
            }, function(e) {
                release();
                throw e;
            });
        });
    };
    Mutex.prototype._dispatchNext = function() {
        if (this._queue.length > 0) {
            this._pending = true;
            this._queue.shift()(this._dispatchNext.bind(this));
        } else this._pending = false;
    };
    return Mutex;
}();
var $8aaba8552c5b1e60$export$2e2bcd8739ae039 = $8aaba8552c5b1e60$var$Mutex;

});

parcelRequire.register("1hyL4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ef2573bee029f17$export$2e2bcd8739ae039; });

var $gbejU = parcelRequire("gbejU");
var $0ef2573bee029f17$var$ReachabilityNavigator = /** @class */ function() {
    function ReachabilityNavigator() {}
    ReachabilityNavigator.prototype.networkMonitor = function() {
        return new $gbejU(function(observer) {
            observer.next({
                online: window.navigator.onLine
            });
            var notifyOnline = function() {
                return observer.next({
                    online: true
                });
            };
            var notifyOffline = function() {
                return observer.next({
                    online: false
                });
            };
            window.addEventListener("online", notifyOnline);
            window.addEventListener("offline", notifyOffline);
            return function() {
                window.removeEventListener("online", notifyOnline);
                window.removeEventListener("offline", notifyOffline);
            };
        });
    };
    return ReachabilityNavigator;
}();
var $0ef2573bee029f17$export$2e2bcd8739ae039 = $0ef2573bee029f17$var$ReachabilityNavigator;

});
parcelRequire.register("gbejU", function(module, exports) {

module.exports = (parcelRequire("bVA6v")).Observable;

});
parcelRequire.register("bVA6v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $8af1060d72495e3c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8af1060d72495e3c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8af1060d72495e3c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8af1060d72495e3c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8af1060d72495e3c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $8af1060d72495e3c$var$hasSymbols = function() {
    return typeof Symbol === "function";
};
var $8af1060d72495e3c$var$hasSymbol = function(name) {
    return $8af1060d72495e3c$var$hasSymbols() && Boolean(Symbol[name]);
};
var $8af1060d72495e3c$var$getSymbol = function(name) {
    return $8af1060d72495e3c$var$hasSymbol(name) ? Symbol[name] : "@@" + name;
};
if ($8af1060d72495e3c$var$hasSymbols() && !$8af1060d72495e3c$var$hasSymbol("observable")) Symbol.observable = Symbol("observable");
var $8af1060d72495e3c$var$SymbolIterator = $8af1060d72495e3c$var$getSymbol("iterator");
var $8af1060d72495e3c$var$SymbolObservable = $8af1060d72495e3c$var$getSymbol("observable");
var $8af1060d72495e3c$var$SymbolSpecies = $8af1060d72495e3c$var$getSymbol("species"); // === Abstract Operations ===
function $8af1060d72495e3c$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== "function") throw new TypeError(value + " is not a function");
    return value;
}
function $8af1060d72495e3c$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$8af1060d72495e3c$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $8af1060d72495e3c$var$Observable;
}
function $8af1060d72495e3c$var$isObservable(x) {
    return x instanceof $8af1060d72495e3c$var$Observable; // SPEC: Brand check
}
function $8af1060d72495e3c$var$hostReportError(e) {
    if ($8af1060d72495e3c$var$hostReportError.log) $8af1060d72495e3c$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $8af1060d72495e3c$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $8af1060d72495e3c$var$hostReportError(e);
        }
    });
}
function $8af1060d72495e3c$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === "function") cleanup();
        else {
            var unsubscribe = $8af1060d72495e3c$var$getMethod(cleanup, "unsubscribe");
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $8af1060d72495e3c$var$hostReportError(e);
    }
}
function $8af1060d72495e3c$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = "closed";
}
function $8af1060d72495e3c$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = "ready";
    for(var i = 0; i < queue.length; ++i){
        $8af1060d72495e3c$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === "closed") break;
    }
}
function $8af1060d72495e3c$var$notifySubscription(subscription, type, value) {
    subscription._state = "running";
    var observer = subscription._observer;
    try {
        var m = $8af1060d72495e3c$var$getMethod(observer, type);
        switch(type){
            case "next":
                if (m) m.call(observer, value);
                break;
            case "error":
                $8af1060d72495e3c$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case "complete":
                $8af1060d72495e3c$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $8af1060d72495e3c$var$hostReportError(e);
    }
    if (subscription._state === "closed") $8af1060d72495e3c$var$cleanupSubscription(subscription);
    else if (subscription._state === "running") subscription._state = "ready";
}
function $8af1060d72495e3c$var$onNotify(subscription, type, value) {
    if (subscription._state === "closed") return;
    if (subscription._state === "buffering") {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== "ready") {
        subscription._state = "buffering";
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $8af1060d72495e3c$var$enqueue(function() {
            return $8af1060d72495e3c$var$flushSubscription(subscription);
        });
        return;
    }
    $8af1060d72495e3c$var$notifySubscription(subscription, type, value);
}
var $8af1060d72495e3c$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $8af1060d72495e3c$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = "initializing";
        var subscriptionObserver = new $8af1060d72495e3c$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === "initializing") this._state = "ready";
    }
    $8af1060d72495e3c$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== "closed") {
                    $8af1060d72495e3c$var$closeSubscription(this);
                    $8af1060d72495e3c$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === "closed";
            }
        }
    ]);
    return Subscription;
}();
var $8af1060d72495e3c$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $8af1060d72495e3c$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $8af1060d72495e3c$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $8af1060d72495e3c$var$onNotify(this._subscription, "next", value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $8af1060d72495e3c$var$onNotify(this._subscription, "error", value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $8af1060d72495e3c$var$onNotify(this._subscription, "complete");
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === "closed";
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $8af1060d72495e3c$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $8af1060d72495e3c$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError("Observable cannot be called as a function");
        if (typeof subscriber !== "function") throw new TypeError("Observable initializer must be a function");
        this._subscriber = subscriber;
    }
    $8af1060d72495e3c$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $8af1060d72495e3c$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== "function") {
                        reject(new TypeError(fn + " is not a function"));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = $8af1060d72495e3c$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = $8af1060d72495e3c$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = $8af1060d72495e3c$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError("Cannot reduce an empty sequence"));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $8af1060d72495e3c$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = $8af1060d72495e3c$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $8af1060d72495e3c$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === "function" ? this : Observable;
                if (x == null) throw new TypeError(x + " is not an object");
                var method = $8af1060d72495e3c$var$getMethod(x, $8af1060d72495e3c$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + " is not an object");
                    if ($8af1060d72495e3c$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($8af1060d72495e3c$var$hasSymbol("iterator")) {
                    method = $8af1060d72495e3c$var$getMethod(x, $8af1060d72495e3c$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $8af1060d72495e3c$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $8af1060d72495e3c$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + " is not observable");
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === "function" ? this : Observable;
                return new C(function(observer) {
                    $8af1060d72495e3c$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $8af1060d72495e3c$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $8af1060d72495e3c$var$Observable;
if ($8af1060d72495e3c$var$hasSymbols()) Object.defineProperty($8af1060d72495e3c$var$Observable, Symbol("extensions"), {
    value: {
        symbol: $8af1060d72495e3c$var$SymbolObservable,
        hostReportError: $8af1060d72495e3c$var$hostReportError
    },
    configurable: true
});

});



parcelRequire.register("j8YuG", function(module, exports) {

$parcel$export(module.exports, "DateUtils", function () { return $defdb07a469cdf62$export$3e048df13f4eb60b; });
/**
 * Date & time utility functions to abstract the `aws-sdk` away from users.
 * (v2 => v3 modularization is a breaking change)
 *
 * @see https://github.com/aws/aws-sdk-js/blob/6edf586dcc1de7fe8fbfbbd9a0d2b1847921e6e1/lib/util.js#L262
 */ var $defdb07a469cdf62$export$3e048df13f4eb60b = {
    /**
     * Milliseconds to offset the date to compensate for clock skew between device & services
     */ clockOffset: 0,
    getDateWithClockOffset: function() {
        if ($defdb07a469cdf62$export$3e048df13f4eb60b.clockOffset) return new Date(new Date().getTime() + $defdb07a469cdf62$export$3e048df13f4eb60b.clockOffset);
        else return new Date();
    },
    /**
     * @returns {number} Clock offset in milliseconds
     */ getClockOffset: function() {
        return $defdb07a469cdf62$export$3e048df13f4eb60b.clockOffset;
    },
    /**
     * @param {number} offset Clock offset in milliseconds
     */ setClockOffset: function(offset) {
        $defdb07a469cdf62$export$3e048df13f4eb60b.clockOffset = offset;
    }
};

});



parcelRequire.register("hlQms", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca1d03b223127804$export$2e2bcd8739ae039; });
parcelRequire("gkIJB");
var $gBqCF = parcelRequire("gBqCF");
var $ca1d03b223127804$var$logger = new (0, $gBqCF.ConsoleLogger)("Parser");
var $ca1d03b223127804$var$Parser = /** @class */ function() {
    function Parser() {}
    Parser.parseMobilehubConfig = function(config) {
        var amplifyConfig = {};
        // Analytics
        if (config["aws_mobile_analytics_app_id"]) {
            var Analytics = {
                AWSPinpoint: {
                    appId: config["aws_mobile_analytics_app_id"],
                    region: config["aws_mobile_analytics_app_region"]
                }
            };
            amplifyConfig.Analytics = Analytics;
        }
        // Auth
        if (config["aws_cognito_identity_pool_id"] || config["aws_user_pools_id"]) {
            var Auth = {
                userPoolId: config["aws_user_pools_id"],
                userPoolWebClientId: config["aws_user_pools_web_client_id"],
                region: config["aws_cognito_region"],
                identityPoolId: config["aws_cognito_identity_pool_id"],
                identityPoolRegion: config["aws_cognito_region"],
                mandatorySignIn: config["aws_mandatory_sign_in"] === "enable" ? true : false
            };
            amplifyConfig.Auth = Auth;
        }
        // Storage
        var storageConfig;
        if (config["aws_user_files_s3_bucket"]) storageConfig = {
            AWSS3: {
                bucket: config["aws_user_files_s3_bucket"],
                region: config["aws_user_files_s3_bucket_region"],
                dangerouslyConnectToHttpEndpointForTesting: config["aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing"]
            }
        };
        else storageConfig = config ? config.Storage || config : {};
        amplifyConfig.Analytics = Object.assign({}, amplifyConfig.Analytics, config.Analytics);
        amplifyConfig.Auth = Object.assign({}, amplifyConfig.Auth, config.Auth);
        amplifyConfig.Storage = Object.assign({}, storageConfig);
        $ca1d03b223127804$var$logger.debug("parse config", config, "to amplifyconfig", amplifyConfig);
        return amplifyConfig;
    };
    return Parser;
}();
var $ca1d03b223127804$export$2e2bcd8739ae039 = $ca1d03b223127804$var$Parser;

});

parcelRequire.register("i22q0", function(module, exports) {

$parcel$export(module.exports, "GoogleOAuth", function () { return $d20a4a2676279039$export$75ace714083c1340; });
$parcel$export(module.exports, "FacebookOAuth", function () { return $d20a4a2676279039$export$1b6b8b5328e38349; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $aSpmN = parcelRequire("aSpmN");

var $alElx = parcelRequire("alElx");
var $d20a4a2676279039$export$75ace714083c1340 = new (0, $aSpmN.default)();
var $d20a4a2676279039$export$1b6b8b5328e38349 = new (0, $alElx.default)();

});
parcelRequire.register("aSpmN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7eb29fcefb75cefb$export$2e2bcd8739ae039; });
parcelRequire("gkIJB");
var $gBqCF = parcelRequire("gBqCF");

var $gssgp = parcelRequire("gssgp");
var $7eb29fcefb75cefb$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7eb29fcefb75cefb$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $7eb29fcefb75cefb$var$logger = new (0, $gBqCF.ConsoleLogger)("CognitoCredentials");
var $7eb29fcefb75cefb$var$waitForInit = new Promise(function(res, rej) {
    if (!(0, $gssgp.default).browserOrNode().isBrowser) {
        $7eb29fcefb75cefb$var$logger.debug("not in the browser, directly resolved");
        return res();
    }
    var ga = window["gapi"] && window["gapi"].auth2 ? window["gapi"].auth2 : null;
    if (ga) {
        $7eb29fcefb75cefb$var$logger.debug("google api already loaded");
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var $7eb29fcefb75cefb$var$GoogleOAuth = /** @class */ function() {
    function GoogleOAuth() {
        this.initialized = false;
        this.refreshGoogleToken = this.refreshGoogleToken.bind(this);
        this._refreshGoogleTokenImpl = this._refreshGoogleTokenImpl.bind(this);
    }
    GoogleOAuth.prototype.refreshGoogleToken = function() {
        return $7eb29fcefb75cefb$var$__awaiter(this, void 0, void 0, function() {
            return $7eb29fcefb75cefb$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        $7eb29fcefb75cefb$var$logger.debug("need to wait for the Google SDK loaded");
                        return [
                            4 /*yield*/ ,
                            $7eb29fcefb75cefb$var$waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        $7eb29fcefb75cefb$var$logger.debug("finish waiting");
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshGoogleTokenImpl()
                        ];
                }
            });
        });
    };
    GoogleOAuth.prototype._refreshGoogleTokenImpl = function() {
        var ga = null;
        if ((0, $gssgp.default).browserOrNode().isBrowser) ga = window["gapi"] && window["gapi"].auth2 ? window["gapi"].auth2 : null;
        if (!ga) {
            $7eb29fcefb75cefb$var$logger.debug("no gapi auth2 available");
            return Promise.reject("no gapi auth2 available");
        }
        return new Promise(function(res, rej) {
            ga.getAuthInstance().then(function(googleAuth) {
                if (!googleAuth) {
                    console.log("google Auth undefiend");
                    rej("google Auth undefiend");
                }
                var googleUser = googleAuth.currentUser.get();
                // refresh the token
                if (googleUser.isSignedIn()) {
                    $7eb29fcefb75cefb$var$logger.debug("refreshing the google access token");
                    googleUser.reloadAuthResponse().then(function(authResponse) {
                        var id_token = authResponse.id_token, expires_at = authResponse.expires_at;
                        var profile = googleUser.getBasicProfile();
                        var user = {
                            email: profile.getEmail(),
                            name: profile.getName()
                        };
                        res({
                            token: id_token,
                            expires_at: expires_at
                        });
                    });
                } else rej("User is not signed in with Google");
            }).catch(function(err) {
                $7eb29fcefb75cefb$var$logger.debug("Failed to refresh google token", err);
                rej("Failed to refresh google token");
            });
        });
    };
    return GoogleOAuth;
}();
var $7eb29fcefb75cefb$export$2e2bcd8739ae039 = $7eb29fcefb75cefb$var$GoogleOAuth;

});

parcelRequire.register("alElx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $788b297f3ab96284$export$2e2bcd8739ae039; });
parcelRequire("gkIJB");
var $gBqCF = parcelRequire("gBqCF");

var $gssgp = parcelRequire("gssgp");
var $788b297f3ab96284$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $788b297f3ab96284$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $788b297f3ab96284$var$logger = new (0, $gBqCF.ConsoleLogger)("CognitoCredentials");
var $788b297f3ab96284$var$waitForInit = new Promise(function(res, rej) {
    if (!(0, $gssgp.default).browserOrNode().isBrowser) {
        $788b297f3ab96284$var$logger.debug("not in the browser, directly resolved");
        return res();
    }
    var fb = window["FB"];
    if (fb) {
        $788b297f3ab96284$var$logger.debug("FB SDK already loaded");
        return res();
    } else setTimeout(function() {
        return res();
    }, 2000);
});
var $788b297f3ab96284$var$FacebookOAuth = /** @class */ function() {
    function FacebookOAuth() {
        this.initialized = false;
        this.refreshFacebookToken = this.refreshFacebookToken.bind(this);
        this._refreshFacebookTokenImpl = this._refreshFacebookTokenImpl.bind(this);
    }
    FacebookOAuth.prototype.refreshFacebookToken = function() {
        return $788b297f3ab96284$var$__awaiter(this, void 0, void 0, function() {
            return $788b297f3ab96284$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.initialized) return [
                            3 /*break*/ ,
                            2
                        ];
                        $788b297f3ab96284$var$logger.debug("need to wait for the Facebook SDK loaded");
                        return [
                            4 /*yield*/ ,
                            $788b297f3ab96284$var$waitForInit
                        ];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        $788b297f3ab96284$var$logger.debug("finish waiting");
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            this._refreshFacebookTokenImpl()
                        ];
                }
            });
        });
    };
    FacebookOAuth.prototype._refreshFacebookTokenImpl = function() {
        var fb = null;
        if ((0, $gssgp.default).browserOrNode().isBrowser) fb = window["FB"];
        if (!fb) {
            $788b297f3ab96284$var$logger.debug("no fb sdk available");
            return Promise.reject("no fb sdk available");
        }
        return new Promise(function(res, rej) {
            fb.getLoginStatus(function(fbResponse) {
                if (!fbResponse || !fbResponse.authResponse) {
                    $788b297f3ab96284$var$logger.debug("no response from facebook when refreshing the jwt token");
                    rej("no response from facebook when refreshing the jwt token");
                }
                var response = fbResponse.authResponse;
                var accessToken = response.accessToken, expiresIn = response.expiresIn;
                var date = new Date();
                var expires_at = expiresIn * 1000 + date.getTime();
                if (!accessToken) {
                    $788b297f3ab96284$var$logger.debug("the jwtToken is undefined");
                    rej("the jwtToken is undefined");
                }
                res({
                    token: accessToken,
                    expires_at: expires_at
                });
            }, {
                scope: "public_profile,email"
            });
        });
    };
    return FacebookOAuth;
}();
var $788b297f3ab96284$export$2e2bcd8739ae039 = $788b297f3ab96284$var$FacebookOAuth;

});


parcelRequire.register("j8co1", function(module, exports) {
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $gssgp = parcelRequire("gssgp");

var $33IrZ = parcelRequire("33IrZ");
var $ded85f5dd8494689$export$e096e0343c3f397d = {};
var $ded85f5dd8494689$export$a0e153c73743701a = {
    addEventListener: function(action, handler) {
        return;
    }
};
// if not in react native, just use local storage
var $ded85f5dd8494689$export$91c2016c393016c7 = (0, $gssgp.default).browserOrNode().isBrowser ? new (0, $33IrZ.default)().getStorage() : undefined;

});
parcelRequire.register("33IrZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23a421d1adc8a543$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $23a421d1adc8a543$var$dataMemory = {};
/** @class */ var $23a421d1adc8a543$export$d7392285c701ecf5 = /** @class */ function() {
    function MemoryStorage() {}
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */ MemoryStorage.setItem = function(key, value) {
        $23a421d1adc8a543$var$dataMemory[key] = value;
        return $23a421d1adc8a543$var$dataMemory[key];
    };
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */ MemoryStorage.getItem = function(key) {
        return Object.prototype.hasOwnProperty.call($23a421d1adc8a543$var$dataMemory, key) ? $23a421d1adc8a543$var$dataMemory[key] : undefined;
    };
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */ MemoryStorage.removeItem = function(key) {
        return delete $23a421d1adc8a543$var$dataMemory[key];
    };
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */ MemoryStorage.clear = function() {
        $23a421d1adc8a543$var$dataMemory = {};
        return $23a421d1adc8a543$var$dataMemory;
    };
    return MemoryStorage;
}();
var $23a421d1adc8a543$var$StorageHelper = /** @class */ function() {
    /**
     * This is used to get a storage object
     * @returns {object} the storage
     */ function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem("aws.amplify.test-ls", 1);
            this.storageWindow.removeItem("aws.amplify.test-ls");
        } catch (exception) {
            this.storageWindow = $23a421d1adc8a543$export$d7392285c701ecf5;
        }
    }
    /**
     * This is used to return the storage
     * @returns {object} the storage
     */ StorageHelper.prototype.getStorage = function() {
        return this.storageWindow;
    };
    return StorageHelper;
}();
var $23a421d1adc8a543$export$2e2bcd8739ae039 = $23a421d1adc8a543$var$StorageHelper;

});


parcelRequire.register("aCVDw", function(module, exports) {

$parcel$export(module.exports, "Credentials", function () { return $7bca295fd2ab0fe2$export$a9627919734faa48; });
$parcel$export(module.exports, "default", function () { return $7bca295fd2ab0fe2$export$2e2bcd8739ae039; });
parcelRequire("gkIJB");
var $gBqCF = parcelRequire("gBqCF");

var $33IrZ = parcelRequire("33IrZ");
parcelRequire("iBT7b");
var $blxMe = parcelRequire("blxMe");

var $gssgp = parcelRequire("gssgp");

var $i22q0 = parcelRequire("i22q0");

var $8Xt9v = parcelRequire("8Xt9v");
var $7bca295fd2ab0fe2$var$__assign = undefined && undefined.__assign || function() {
    $7bca295fd2ab0fe2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7bca295fd2ab0fe2$var$__assign.apply(this, arguments);
};
var $7bca295fd2ab0fe2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7bca295fd2ab0fe2$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $7bca295fd2ab0fe2$var$logger = new (0, $gBqCF.ConsoleLogger)("Credentials");
var $7bca295fd2ab0fe2$var$CREDENTIALS_TTL = 3000000; // 50 min, can be modified on config if required in the future
var $7bca295fd2ab0fe2$export$a9627919734faa48 = /** @class */ function() {
    function Credentials(config) {
        this._gettingCredPromise = null;
        this._refreshHandlers = {};
        this.configure(config);
        this._refreshHandlers["google"] = (0, $i22q0.GoogleOAuth).refreshGoogleToken;
        this._refreshHandlers["facebook"] = (0, $i22q0.FacebookOAuth).refreshFacebookToken;
    }
    Credentials.prototype.getCredSource = function() {
        return this._credentials_source;
    };
    Credentials.prototype.configure = function(config) {
        if (!config) return this._config || {};
        this._config = Object.assign({}, this._config, config);
        var refreshHandlers = this._config.refreshHandlers;
        // If the developer has provided an object of refresh handlers,
        // then we can merge the provided handlers with the current handlers.
        if (refreshHandlers) this._refreshHandlers = $7bca295fd2ab0fe2$var$__assign($7bca295fd2ab0fe2$var$__assign({}, this._refreshHandlers), refreshHandlers);
        this._storage = this._config.storage;
        if (!this._storage) this._storage = new (0, $33IrZ.default)().getStorage();
        this._storageSync = Promise.resolve();
        if (typeof this._storage["sync"] === "function") this._storageSync = this._storage["sync"]();
        return this._config;
    };
    Credentials.prototype.get = function() {
        $7bca295fd2ab0fe2$var$logger.debug("getting credentials");
        return this._pickupCredentials();
    };
    Credentials.prototype._pickupCredentials = function() {
        $7bca295fd2ab0fe2$var$logger.debug("picking up credentials");
        if (!this._gettingCredPromise || !this._gettingCredPromise.isPending()) {
            $7bca295fd2ab0fe2$var$logger.debug("getting new cred promise");
            if ((0, $blxMe).config && (0, $blxMe).config.credentials && (0, $blxMe).config.credentials instanceof (0, $blxMe).Credentials) this._gettingCredPromise = (0, $gssgp.default).makeQuerablePromise(this._setCredentialsFromAWS());
            else this._gettingCredPromise = (0, $gssgp.default).makeQuerablePromise(this._keepAlive());
        } else $7bca295fd2ab0fe2$var$logger.debug("getting old cred promise");
        return this._gettingCredPromise;
    };
    Credentials.prototype._keepAlive = function() {
        $7bca295fd2ab0fe2$var$logger.debug("checking if credentials exists and not expired");
        var cred = this._credentials;
        if (cred && !this._isExpired(cred)) {
            $7bca295fd2ab0fe2$var$logger.debug("credentials not changed and not expired, directly return");
            return Promise.resolve(cred);
        }
        $7bca295fd2ab0fe2$var$logger.debug("need to get a new credential or refresh the existing one");
        if ((0, $8Xt9v.default).Auth && typeof (0, $8Xt9v.default).Auth.currentUserCredentials === "function") return (0, $8Xt9v.default).Auth.currentUserCredentials();
        else return Promise.reject("No Auth module registered in Amplify");
    };
    Credentials.prototype.refreshFederatedToken = function(federatedInfo) {
        var _this = this;
        $7bca295fd2ab0fe2$var$logger.debug("Getting federated credentials");
        var provider = federatedInfo.provider, user = federatedInfo.user;
        var token = federatedInfo.token, expires_at = federatedInfo.expires_at, identity_id = federatedInfo.identity_id;
        var that = this;
        $7bca295fd2ab0fe2$var$logger.debug("checking if federated jwt token expired");
        if (expires_at > new Date().getTime()) {
            // if not expired
            $7bca295fd2ab0fe2$var$logger.debug("token not expired");
            return this._setCredentialsFromFederation({
                provider: provider,
                token: token,
                user: user,
                identity_id: identity_id,
                expires_at: expires_at
            });
        } else // if refresh handler exists
        if (that._refreshHandlers[provider] && typeof that._refreshHandlers[provider] === "function") {
            $7bca295fd2ab0fe2$var$logger.debug("getting refreshed jwt token from federation provider");
            return that._refreshHandlers[provider]().then(function(data) {
                $7bca295fd2ab0fe2$var$logger.debug("refresh federated token sucessfully", data);
                token = data.token;
                identity_id = data.identity_id;
                expires_at = data.expires_at;
                return that._setCredentialsFromFederation({
                    provider: provider,
                    token: token,
                    user: user,
                    identity_id: identity_id,
                    expires_at: expires_at
                });
            }).catch(function(e) {
                $7bca295fd2ab0fe2$var$logger.debug("refresh federated token failed", e);
                _this.clear();
                return Promise.reject("refreshing federation token failed: " + e);
            });
        } else {
            $7bca295fd2ab0fe2$var$logger.debug("no refresh handler for provider:", provider);
            this.clear();
            return Promise.reject("no refresh handler for provider");
        }
    };
    Credentials.prototype._isExpired = function(credentials) {
        if (!credentials) {
            $7bca295fd2ab0fe2$var$logger.debug("no credentials for expiration check");
            return true;
        }
        $7bca295fd2ab0fe2$var$logger.debug("is this credentials expired?", credentials);
        var ts = new Date().getTime();
        var delta = 600000; // 10 minutes
        var expired = credentials.expired, expireTime = credentials.expireTime;
        if (!expired && expireTime > ts + delta && ts < this._nextCredentialsRefresh) return false;
        return true;
    };
    Credentials.prototype._setCredentialsForGuest = function() {
        return $7bca295fd2ab0fe2$var$__awaiter(this, void 0, void 0, function() {
            var attempted, _a, identityPoolId, region, mandatorySignIn, identityId, e_1, credentials, that;
            var _this = this;
            return $7bca295fd2ab0fe2$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        attempted = false;
                        $7bca295fd2ab0fe2$var$logger.debug("setting credentials for guest");
                        _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region, mandatorySignIn = _a.mandatorySignIn;
                        if (mandatorySignIn) return [
                            2 /*return*/ ,
                            Promise.reject("cannot get guest credentials when mandatory signin enabled")
                        ];
                        if (!identityPoolId) {
                            $7bca295fd2ab0fe2$var$logger.debug("No Cognito Federated Identity pool provided");
                            return [
                                2 /*return*/ ,
                                Promise.reject("No Cognito Federated Identity pool provided")
                            ];
                        }
                        identityId = undefined;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _b.sent();
                        identityId = this._storage.getItem("CognitoIdentityId-" + identityPoolId);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _b.sent();
                        $7bca295fd2ab0fe2$var$logger.debug("Failed to get the cached identityId", e_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        credentials = new (0, $blxMe).CognitoIdentityCredentials({
                            IdentityPoolId: identityPoolId,
                            IdentityId: identityId ? identityId : undefined
                        }, {
                            region: region
                        });
                        that = this;
                        return [
                            2 /*return*/ ,
                            this._loadCredentials(credentials, "guest", false, null).then(function(res) {
                                return res;
                            }).catch(function(e) {
                                return $7bca295fd2ab0fe2$var$__awaiter(_this, void 0, void 0, function() {
                                    var newCredentials;
                                    return $7bca295fd2ab0fe2$var$__generator(this, function(_a) {
                                        // If identity id is deleted in the console, we make one attempt to recreate it
                                        // and remove existing id from cache.
                                        if (e.code === "ResourceNotFoundException" && e.message === "Identity '" + identityId + "' not found." && !attempted) {
                                            attempted = true;
                                            $7bca295fd2ab0fe2$var$logger.debug("Failed to load guest credentials");
                                            this._storage.removeItem("CognitoIdentityId-" + identityPoolId);
                                            credentials.clearCachedId();
                                            newCredentials = new (0, $blxMe).CognitoIdentityCredentials({
                                                IdentityPoolId: identityPoolId,
                                                IdentityId: undefined
                                            }, {
                                                region: region
                                            });
                                            return [
                                                2 /*return*/ ,
                                                this._loadCredentials(newCredentials, "guest", false, null)
                                            ];
                                        } else return [
                                            2 /*return*/ ,
                                            e
                                        ];
                                        return [
                                            2 /*return*/ 
                                        ];
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    Credentials.prototype._setCredentialsFromAWS = function() {
        var credentials = (0, $blxMe).config.credentials;
        $7bca295fd2ab0fe2$var$logger.debug("setting credentials from aws");
        var that = this;
        if (credentials instanceof (0, $blxMe).Credentials) return Promise.resolve(credentials);
        else {
            $7bca295fd2ab0fe2$var$logger.debug("AWS.config.credentials is not an instance of AWS Credentials");
            return Promise.reject("AWS.config.credentials is not an instance of AWS Credentials");
        }
    };
    Credentials.prototype._setCredentialsFromFederation = function(params) {
        var provider = params.provider, token = params.token, identity_id = params.identity_id, user = params.user, expires_at = params.expires_at;
        var domains = {
            google: "accounts.google.com",
            facebook: "graph.facebook.com",
            amazon: "www.amazon.com",
            developer: "cognito-identity.amazonaws.com"
        };
        // Use custom provider url instead of the predefined ones
        var domain = domains[provider] || provider;
        if (!domain) return Promise.reject("You must specify a federated provider");
        var logins = {};
        logins[domain] = token;
        var _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region;
        if (!identityPoolId) {
            $7bca295fd2ab0fe2$var$logger.debug("No Cognito Federated Identity pool provided");
            return Promise.reject("No Cognito Federated Identity pool provided");
        }
        var credentials = new (0, $blxMe).CognitoIdentityCredentials({
            IdentityPoolId: identityPoolId,
            IdentityId: identity_id,
            Logins: logins
        }, {
            region: region
        });
        return this._loadCredentials(credentials, "federated", true, params);
    };
    Credentials.prototype._setCredentialsFromSession = function(session) {
        $7bca295fd2ab0fe2$var$logger.debug("set credentials from session");
        var idToken = session.getIdToken().getJwtToken();
        var _a = this._config, region = _a.region, userPoolId = _a.userPoolId, identityPoolId = _a.identityPoolId;
        if (!identityPoolId) {
            $7bca295fd2ab0fe2$var$logger.debug("No Cognito Federated Identity pool provided");
            return Promise.reject("No Cognito Federated Identity pool provided");
        }
        var key = "cognito-idp." + region + ".amazonaws.com/" + userPoolId;
        var logins = {};
        logins[key] = idToken;
        var credentials = new (0, $blxMe).CognitoIdentityCredentials({
            IdentityPoolId: identityPoolId,
            Logins: logins
        }, {
            region: region
        });
        return this._loadCredentials(credentials, "userPool", true, null);
    };
    Credentials.prototype._loadCredentials = function(credentials, source, authenticated, info) {
        var _this = this;
        var that = this;
        var identityPoolId = this._config.identityPoolId;
        return new Promise(function(res, rej) {
            credentials.get(function(err) {
                return $7bca295fd2ab0fe2$var$__awaiter(_this, void 0, void 0, function() {
                    var user, provider, token, expires_at, identity_id, e_2;
                    return $7bca295fd2ab0fe2$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (err) {
                                    $7bca295fd2ab0fe2$var$logger.debug("Failed to load credentials", credentials);
                                    rej(err);
                                    return [
                                        2 /*return*/ 
                                    ];
                                }
                                $7bca295fd2ab0fe2$var$logger.debug("Load credentials successfully", credentials);
                                that._credentials = credentials;
                                that._credentials.authenticated = authenticated;
                                that._credentials_source = source;
                                that._nextCredentialsRefresh = new Date().getTime() + $7bca295fd2ab0fe2$var$CREDENTIALS_TTL;
                                if (!(source === "federated")) return [
                                    3 /*break*/ ,
                                    3
                                ];
                                user = Object.assign({
                                    id: this._credentials.identityId
                                }, info.user);
                                provider = info.provider, token = info.token, expires_at = info.expires_at, identity_id = info.identity_id;
                                try {
                                    this._storage.setItem("aws-amplify-federatedInfo", JSON.stringify({
                                        provider: provider,
                                        token: token,
                                        user: user,
                                        expires_at: expires_at,
                                        identity_id: identity_id
                                    }));
                                } catch (e) {
                                    $7bca295fd2ab0fe2$var$logger.debug("Failed to put federated info into auth storage", e);
                                }
                                if (!((0, $8Xt9v.default).Cache && typeof (0, $8Xt9v.default).Cache.setItem === "function")) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    (0, $8Xt9v.default).Cache.setItem("federatedInfo", {
                                        provider: provider,
                                        token: token,
                                        user: user,
                                        expires_at: expires_at,
                                        identity_id: identity_id
                                    }, {
                                        priority: 1
                                    })
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                $7bca295fd2ab0fe2$var$logger.debug("No Cache module registered in Amplify");
                                _a.label = 3;
                            case 3:
                                if (!(source === "guest")) return [
                                    3 /*break*/ ,
                                    7
                                ];
                                _a.label = 4;
                            case 4:
                                _a.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this._storageSync
                                ];
                            case 5:
                                _a.sent();
                                this._storage.setItem("CognitoIdentityId-" + identityPoolId, credentials.identityId);
                                return [
                                    3 /*break*/ ,
                                    7
                                ];
                            case 6:
                                e_2 = _a.sent();
                                $7bca295fd2ab0fe2$var$logger.debug("Failed to cache identityId", e_2);
                                return [
                                    3 /*break*/ ,
                                    7
                                ];
                            case 7:
                                res(that._credentials);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            });
        });
    };
    Credentials.prototype.set = function(params, source) {
        if (source === "session") return this._setCredentialsFromSession(params);
        else if (source === "federation") return this._setCredentialsFromFederation(params);
        else if (source === "guest") return this._setCredentialsForGuest();
        else {
            $7bca295fd2ab0fe2$var$logger.debug("no source specified for setting credentials");
            return Promise.reject("invalid source");
        }
    };
    Credentials.prototype.clear = function() {
        return $7bca295fd2ab0fe2$var$__awaiter(this, void 0, void 0, function() {
            var _a, identityPoolId, region, credentials;
            return $7bca295fd2ab0fe2$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region;
                        if (identityPoolId) {
                            credentials = new (0, $blxMe).CognitoIdentityCredentials({
                                IdentityPoolId: identityPoolId
                            }, {
                                region: region
                            });
                            credentials.clearCachedId();
                        }
                        this._credentials = null;
                        this._credentials_source = null;
                        this._storage.removeItem("aws-amplify-federatedInfo");
                        if (!((0, $8Xt9v.default).Cache && typeof (0, $8Xt9v.default).Cache.setItem === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $8Xt9v.default).Cache.removeItem("federatedInfo")
                        ];
                    case 1:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        $7bca295fd2ab0fe2$var$logger.debug("No Cache module registered in Amplify");
                        _b.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ Credentials.prototype.shear = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    return Credentials;
}();
var $7bca295fd2ab0fe2$var$instance = new $7bca295fd2ab0fe2$export$a9627919734faa48(null);
var $7bca295fd2ab0fe2$export$2e2bcd8739ae039 = $7bca295fd2ab0fe2$var$instance;

});

parcelRequire.register("3gtMd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("hk5A5")).default; });
/**
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $hk5A5 = parcelRequire("hk5A5");

});
parcelRequire.register("hk5A5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9c8a23961ad3963$export$2e2bcd8739ae039; });
/**
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("gkIJB");
var $gBqCF = parcelRequire("gBqCF");

var $gssgp = parcelRequire("gssgp");

var $8Xt9v = parcelRequire("8Xt9v");
/**
 * Provides a means to registering a service worker in the browser
 * and communicating with it via postMessage events.
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API/
 *
 * postMessage events are currently not supported in all browsers. See:
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API
 *
 * At the minmum this class will register the service worker and listen
 * and attempt to dispatch messages on state change and record analytics
 * events based on the service worker lifecycle.
 */ var $c9c8a23961ad3963$var$ServiceWorkerClass = /** @class */ function() {
    function ServiceWorkerClass() {
        // The AWS Amplify logger
        this._logger = new (0, $gBqCF.ConsoleLogger)("ServiceWorker");
    }
    Object.defineProperty(ServiceWorkerClass.prototype, "serviceWorker", {
        /**
         * Get the currently active service worker
         */ get: function() {
            return this._serviceWorker;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Register the service-worker.js file in the browser
     * Make sure the service-worker.js is part of the build
     * for example with Angular, modify the angular-cli.json file
     * and add to "assets" array "service-worker.js"
     * @param {string} - (optional) Service worker file. Defaults to "/service-worker.js"
     * @param {string} - (optional) The service worker scope. Defaults to "/"
     *  - API Doc: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register
     * @returns {Promise}
     *	- resolve(ServiceWorkerRegistration)
     *	- reject(Error)
     **/ ServiceWorkerClass.prototype.register = function(filePath, scope) {
        var _this = this;
        if (filePath === void 0) filePath = "/service-worker.js";
        if (scope === void 0) scope = "/";
        this._logger.debug("registering " + filePath);
        this._logger.debug("registering service worker with scope " + scope);
        return new Promise(function(resolve, reject) {
            if (navigator && "serviceWorker" in navigator) navigator.serviceWorker.register(filePath, {
                scope: scope
            }).then(function(registration) {
                if (registration.installing) _this._serviceWorker = registration.installing;
                else if (registration.waiting) _this._serviceWorker = registration.waiting;
                else if (registration.active) _this._serviceWorker = registration.active;
                _this._registration = registration;
                _this._setupListeners();
                _this._logger.debug("Service Worker Registration Success: " + registration);
                return resolve(registration);
            }).catch(function(error) {
                _this._logger.debug("Service Worker Registration Failed " + error);
                return reject(error);
            });
            else return reject(new Error("Service Worker not available"));
        });
    };
    /**
     * Enable web push notifications. If not subscribed, a new subscription will
     * be created and registered.
     * 	Test Push Server: https://web-push-codelab.glitch.me/
     * 	Push Server Libraries: https://github.com/web-push-libs/
     * 	API Doc: https://developers.google.com/web/fundamentals/codelabs/push-notifications/
     * @param publicKey
     * @returns {Promise}
     * 	- resolve(PushSubscription)
     *  - reject(Error)
     */ ServiceWorkerClass.prototype.enablePush = function(publicKey) {
        var _this = this;
        if (!this._registration) throw new Error("Service Worker not registered");
        this._publicKey = publicKey;
        return new Promise(function(resolve, reject) {
            if ((0, $gssgp.default).browserOrNode().isBrowser) _this._registration.pushManager.getSubscription().then(function(subscription) {
                if (subscription) {
                    _this._subscription = subscription;
                    _this._logger.debug("User is subscribed to push: " + JSON.stringify(subscription));
                    resolve(subscription);
                } else {
                    _this._logger.debug("User is NOT subscribed to push");
                    return _this._registration.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: _this._urlB64ToUint8Array(publicKey)
                    }).then(function(subscription) {
                        _this._subscription = subscription;
                        _this._logger.debug("User subscribed: " + JSON.stringify(subscription));
                        resolve(subscription);
                    }).catch(function(error) {
                        _this._logger.error(error);
                    });
                }
            });
            else return reject(new Error("Service Worker not available"));
        });
    };
    /**
     * Convert a base64 encoded string to a Uint8 array for the push server key
     * @param base64String
     */ ServiceWorkerClass.prototype._urlB64ToUint8Array = function(base64String) {
        var padding = "=".repeat((4 - base64String.length % 4) % 4);
        var base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
        var rawData = window.atob(base64);
        var outputArray = new Uint8Array(rawData.length);
        for(var i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
        return outputArray;
    };
    /**
     * Send a message to the service worker. The service worker needs
     * to implement `self.addEventListener('message') to handle the
     * message. This ***currently*** does not work in Safari or IE.
     * @param {object | string} - An arbitrary JSON object or string message to send to the service worker
     *	- see: https://developer.mozilla.org/en-US/docs/Web/API/Transferable
     * @returns {Promise}
     **/ ServiceWorkerClass.prototype.send = function(message) {
        if (this._serviceWorker) this._serviceWorker.postMessage(typeof message === "object" ? JSON.stringify(message) : message);
    };
    /**
     * Listen for service worker state change and message events
     * https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorker/state
     **/ ServiceWorkerClass.prototype._setupListeners = function() {
        var _this = this;
        this._serviceWorker.addEventListener("statechange", function(event) {
            var currentState = _this._serviceWorker.state;
            _this._logger.debug("ServiceWorker statechange: " + currentState);
            if ((0, $8Xt9v.default).Analytics && typeof (0, $8Xt9v.default).Analytics.record === "function") (0, $8Xt9v.default).Analytics.record({
                name: "ServiceWorker",
                attributes: {
                    state: currentState
                }
            });
        });
        this._serviceWorker.addEventListener("message", function(event) {
            _this._logger.debug("ServiceWorker message event: " + event);
        });
    };
    return ServiceWorkerClass;
}();
var $c9c8a23961ad3963$export$2e2bcd8739ae039 = $c9c8a23961ad3963$var$ServiceWorkerClass;

});


parcelRequire.register("imZy6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5fa0671a281e6f5$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $hGfmJ = parcelRequire("hGfmJ");
var $d5fa0671a281e6f5$var$Platform = {
    userAgent: "aws-amplify/" + $hGfmJ.version + " js",
    product: "",
    navigator: null,
    isReactNative: false
};
if (typeof navigator !== "undefined" && navigator.product) {
    $d5fa0671a281e6f5$var$Platform.product = navigator.product || "";
    $d5fa0671a281e6f5$var$Platform.navigator = navigator || null;
    switch(navigator.product){
        case "ReactNative":
            $d5fa0671a281e6f5$var$Platform.userAgent = "aws-amplify/" + $hGfmJ.version + " react-native";
            $d5fa0671a281e6f5$var$Platform.isReactNative = true;
            break;
        default:
            $d5fa0671a281e6f5$var$Platform.userAgent = "aws-amplify/" + $hGfmJ.version + " js";
            $d5fa0671a281e6f5$var$Platform.isReactNative = false;
            break;
    }
}
var $d5fa0671a281e6f5$export$2e2bcd8739ae039 = $d5fa0671a281e6f5$var$Platform;

});
parcelRequire.register("hGfmJ", function(module, exports) {
module.exports = JSON.parse('{"name":"@aws-amplify/core","version":"2.3.0","description":"Core category of aws-amplify","main":"./lib/index.js","module":"./lib-esm/index.js","typings":"./lib-esm/index.d.ts","publishConfig":{"access":"public"},"scripts":{"test":"tslint \'src/**/*.ts\' && jest -w 1 --coverage","build-with-test":"npm test && npm run build","build:cjs":"node ./build es5 && webpack && webpack --config ./webpack.config.dev.js","build:esm":"node ./build es6","build:cjs:watch":"node ./build es5 --watch","build:esm:watch":"node ./build es6 --watch","build":"npm run clean && npm run build:esm && npm run build:cjs","clean":"rimraf lib-esm lib dist","format":"echo \\"Not implemented\\"","lint":"tslint \'src/**/*.ts\'"},"react-native":{"./index":"./lib/index.js","./lib/ClientDevice":"./lib/ClientDevice/reactnative.js","./lib/RNComponents":"./lib/RNComponents/reactnative.js","./lib/StorageHelper":"./lib/StorageHelper/reactnative.js"},"repository":{"type":"git","url":"https://github.com/aws-amplify/amplify-js.git"},"author":"Amazon Web Services","license":"Apache-2.0","bugs":{"url":"https://github.com/aws/aws-amplify/issues"},"homepage":"https://aws-amplify.github.io/","devDependencies":{"@react-native-community/netinfo":"4.7.0","find":"^0.2.7","prepend-file":"^1.3.1","react-native":"0.59.0"},"dependencies":{"aws-sdk":"2.518.0","url":"^0.11.0","zen-observable":"^0.8.6"},"peerDependencies":{"@react-native-community/netinfo":"^5.5.0"},"jest":{"globals":{"ts-jest":{"diagnostics":false,"tsConfig":{"lib":["es5","es2015","dom","esnext.asynciterable","es2017.object"],"allowJs":true}}},"transform":{"^.+\\\\.(js|jsx|ts|tsx)$":"ts-jest"},"testRegex":"(/__tests__/.*|\\\\.(test|spec))\\\\.(tsx?|jsx?)$","moduleFileExtensions":["ts","tsx","js","json","jsx"],"testEnvironment":"jsdom","coverageThreshold":{"global":{"branches":0,"functions":0,"lines":0,"statements":0}},"testURL":"http://localhost/","coveragePathIgnorePatterns":["/node_modules/"]},"gitHead":"a105664b4028e06246c6d9f6ceebb8730187d50c"}');

});


parcelRequire.register("2SWCi", function(module, exports) {

$parcel$export(module.exports, "INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER", function () { return $219e17fa12cffb5b$export$36df2663cc7faf97; });
$parcel$export(module.exports, "INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER", function () { return $219e17fa12cffb5b$export$ea26e09ecef8d08d; });
$parcel$export(module.exports, "USER_AGENT_HEADER", function () { return $219e17fa12cffb5b$export$16032fc466434892; });
/*
 * Copyright 2018-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ /**
 * This Symbol is used to reference an internal-only PubSub provider that
 * is used for AppSync/GraphQL subscriptions in the API category.
 */ var $219e17fa12cffb5b$var$hasSymbol = typeof Symbol !== "undefined" && typeof Symbol.for === "function";
var $219e17fa12cffb5b$export$36df2663cc7faf97 = $219e17fa12cffb5b$var$hasSymbol ? Symbol.for("INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER") : "@@INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER";
var $219e17fa12cffb5b$export$ea26e09ecef8d08d = $219e17fa12cffb5b$var$hasSymbol ? Symbol.for("INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER") : "@@INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER";
var $219e17fa12cffb5b$export$16032fc466434892 = "x-amz-user-agent";

});


parcelRequire.register("7r2po", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $569cec49c4b0b835$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("2hWDt");
var $iZUWK = parcelRequire("iZUWK");
var $gBqCF = parcelRequire("gBqCF");
var $egl3L = parcelRequire("egl3L");
var $kP2rz = parcelRequire("kP2rz");
var $gssgp = parcelRequire("gssgp");
var $imZy6 = parcelRequire("imZy6");
var $aCVDw = parcelRequire("aCVDw");

var $2tX1t = parcelRequire("2tX1t");

var $9x214 = parcelRequire("9x214");

var $32hwF = parcelRequire("32hwF");

var $d7nsV = parcelRequire("d7nsV");
var $569cec49c4b0b835$var$__assign = undefined && undefined.__assign || function() {
    $569cec49c4b0b835$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $569cec49c4b0b835$var$__assign.apply(this, arguments);
};
var $569cec49c4b0b835$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $569cec49c4b0b835$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $569cec49c4b0b835$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $569cec49c4b0b835$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var $569cec49c4b0b835$var$dispatchAnalyticsEvent = function(event, data) {
    (0, $iZUWK.default).dispatch("analytics", {
        event: event,
        data: data
    }, "Analytics", $569cec49c4b0b835$var$AMPLIFY_SYMBOL);
};
var $569cec49c4b0b835$var$logger = new (0, $gBqCF.ConsoleLogger)("AWSPinpointProvider");
var $569cec49c4b0b835$var$RETRYABLE_CODES = [
    429,
    500
];
var $569cec49c4b0b835$var$ACCEPTED_CODES = [
    202
];
var $569cec49c4b0b835$var$FORBIDDEN_CODE = 403;
var $569cec49c4b0b835$var$BAD_REQUEST_CODE = 400;
var $569cec49c4b0b835$var$MOBILE_SERVICE_NAME = "mobiletargeting";
var $569cec49c4b0b835$var$EXPIRED_TOKEN_CODE = "ExpiredTokenException";
var $569cec49c4b0b835$var$UPDATE_ENDPOINT = "_update_endpoint";
var $569cec49c4b0b835$var$SESSION_START = "_session.start";
var $569cec49c4b0b835$var$SESSION_STOP = "_session.stop";
var $569cec49c4b0b835$var$BEACON_SUPPORTED = typeof navigator !== "undefined" && navigator && typeof navigator.sendBeacon === "function";
// events buffer
var $569cec49c4b0b835$var$BUFFER_SIZE = 1000;
var $569cec49c4b0b835$var$FLUSH_SIZE = 100;
var $569cec49c4b0b835$var$FLUSH_INTERVAL = 5000; // 5s
var $569cec49c4b0b835$var$RESEND_LIMIT = 5;
// params: { event: {name: , .... }, timeStamp, config, resendLimit }
var $569cec49c4b0b835$var$AWSPinpointProvider = /** @class */ function() {
    function AWSPinpointProvider(config) {
        this._endpointGenerating = true;
        this._endpointUpdateInProgress = false;
        this._buffer = null;
        this._endpointBuffer = [];
        this._config = config ? config : {};
        this._config.bufferSize = this._config.bufferSize || $569cec49c4b0b835$var$BUFFER_SIZE;
        this._config.flushSize = this._config.flushSize || $569cec49c4b0b835$var$FLUSH_SIZE;
        this._config.flushInterval = this._config.flushInterval || $569cec49c4b0b835$var$FLUSH_INTERVAL;
        this._config.resendLimit = this._config.resendLimit || $569cec49c4b0b835$var$RESEND_LIMIT;
        this._clientInfo = (0, $egl3L.default).clientInfo();
    }
    /**
     * get the category of the plugin
     */ AWSPinpointProvider.prototype.getCategory = function() {
        return AWSPinpointProvider.category;
    };
    /**
     * get provider name of the plugin
     */ AWSPinpointProvider.prototype.getProviderName = function() {
        return AWSPinpointProvider.providerName;
    };
    /**
     * configure the plugin
     * @param {Object} config - configuration
     */ AWSPinpointProvider.prototype.configure = function(config) {
        var _this = this;
        $569cec49c4b0b835$var$logger.debug("configure Analytics", config);
        var conf = config || {};
        this._config = Object.assign({}, this._config, conf);
        if (this._config.appId && !this._config.disabled) {
            if (!this._config.endpointId) {
                var cacheKey = this.getProviderName() + "_" + this._config.appId;
                this._getEndpointId(cacheKey).then(function(endpointId) {
                    $569cec49c4b0b835$var$logger.debug("setting endpoint id from the cache", endpointId);
                    _this._config.endpointId = endpointId;
                    $569cec49c4b0b835$var$dispatchAnalyticsEvent("pinpointProvider_configured", null);
                }).catch(function(err) {
                    $569cec49c4b0b835$var$logger.debug("Failed to generate endpointId", err);
                });
            } else $569cec49c4b0b835$var$dispatchAnalyticsEvent("pinpointProvider_configured", null);
        } else this._flushBuffer();
        return this._config;
    };
    /**
     * record an event
     * @param {Object} params - the params of an event
     */ AWSPinpointProvider.prototype.record = function(params, handlers) {
        return $569cec49c4b0b835$var$__awaiter(this, void 0, void 0, function() {
            var credentials, timestamp;
            return $569cec49c4b0b835$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $569cec49c4b0b835$var$logger.debug("_public record", params);
                        return [
                            4 /*yield*/ ,
                            this._getCredentials()
                        ];
                    case 1:
                        credentials = _a.sent();
                        if (!credentials || !this._config.appId || !this._config.region) {
                            $569cec49c4b0b835$var$logger.debug("cannot send events without credentials, applicationId or region");
                            return [
                                2 /*return*/ ,
                                handlers.reject(new Error("No credentials, applicationId or region"))
                            ];
                        }
                        this._initClients(credentials);
                        timestamp = new Date().getTime();
                        // attach the session and eventId
                        this._generateSession(params);
                        params.event.eventId = (0, $32hwF.v1)();
                        Object.assign(params, {
                            timestamp: timestamp,
                            config: this._config
                        });
                        if (params.event.immediate) return [
                            2 /*return*/ ,
                            this._send(params, handlers)
                        ];
                        else this._putToBuffer(params, handlers);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSPinpointProvider.prototype._sendEndpointUpdate = function(endpointObject) {
        return $569cec49c4b0b835$var$__awaiter(this, void 0, void 0, function() {
            var next;
            return $569cec49c4b0b835$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this._endpointUpdateInProgress) {
                            this._endpointBuffer.push(endpointObject);
                            return [
                                2 /*return*/ 
                            ];
                        }
                        this._endpointUpdateInProgress = true;
                        return [
                            4 /*yield*/ ,
                            this._updateEndpoint(endpointObject)
                        ];
                    case 1:
                        _a.sent();
                        next = this._endpointBuffer.shift();
                        this._endpointUpdateInProgress = false;
                        next && this._sendEndpointUpdate(next);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * @private
     * @param params - params for event recording
     * Put events into buffer
     */ AWSPinpointProvider.prototype._putToBuffer = function(params, handlers) {
        if (params.event.name === $569cec49c4b0b835$var$UPDATE_ENDPOINT) {
            this._sendEndpointUpdate({
                params: params,
                handlers: handlers
            });
            return;
        }
        this._buffer && this._buffer.push({
            params: params,
            handlers: handlers
        });
    };
    AWSPinpointProvider.prototype._generateSession = function(params) {
        this._sessionId = this._sessionId || (0, $32hwF.v1)();
        var event = params.event;
        switch(event.name){
            case $569cec49c4b0b835$var$SESSION_START:
                // refresh the session id and session start time
                this._sessionStartTimestamp = new Date().getTime();
                this._sessionId = (0, $32hwF.v1)();
                event.session = {
                    Id: this._sessionId,
                    StartTimestamp: new Date(this._sessionStartTimestamp).toISOString()
                };
                break;
            case $569cec49c4b0b835$var$SESSION_STOP:
                var stopTimestamp = new Date().getTime();
                this._sessionStartTimestamp = this._sessionStartTimestamp || new Date().getTime();
                this._sessionId = this._sessionId || (0, $32hwF.v1)();
                event.session = {
                    Id: this._sessionId,
                    Duration: stopTimestamp - this._sessionStartTimestamp,
                    StartTimestamp: new Date(this._sessionStartTimestamp).toISOString(),
                    StopTimestamp: new Date(stopTimestamp).toISOString()
                };
                this._sessionId = undefined;
                this._sessionStartTimestamp = undefined;
                break;
            default:
                this._sessionStartTimestamp = this._sessionStartTimestamp || new Date().getTime();
                this._sessionId = this._sessionId || (0, $32hwF.v1)();
                event.session = {
                    Id: this._sessionId,
                    StartTimestamp: new Date(this._sessionStartTimestamp).toISOString()
                };
        }
    };
    AWSPinpointProvider.prototype._send = function(params, handlers) {
        return $569cec49c4b0b835$var$__awaiter(this, void 0, void 0, function() {
            var event;
            return $569cec49c4b0b835$var$__generator(this, function(_a) {
                event = params.event;
                switch(event.name){
                    case $569cec49c4b0b835$var$UPDATE_ENDPOINT:
                        return [
                            2 /*return*/ ,
                            this._updateEndpoint({
                                params: params,
                                handlers: handlers
                            })
                        ];
                    case $569cec49c4b0b835$var$SESSION_STOP:
                        return [
                            2 /*return*/ ,
                            this._pinpointSendStopSession(params, handlers)
                        ];
                    default:
                        return [
                            2 /*return*/ ,
                            this._pinpointPutEvents(params, handlers)
                        ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSPinpointProvider.prototype._generateBatchItemContext = function(params) {
        var _a;
        var event = params.event, timestamp = params.timestamp, config = params.config;
        var name = event.name, attributes = event.attributes, metrics = event.metrics, eventId = event.eventId, session = event.session;
        var appId = config.appId, endpointId = config.endpointId;
        var endpointContext = {};
        var eventParams = {
            ApplicationId: appId,
            EventsRequest: {
                BatchItem: {}
            }
        };
        eventParams.EventsRequest.BatchItem[endpointId] = {};
        var endpointObj = eventParams.EventsRequest.BatchItem[endpointId];
        endpointObj.Endpoint = endpointContext;
        endpointObj.Events = (_a = {}, _a[eventId] = {
            EventType: name,
            Timestamp: new Date(timestamp).toISOString(),
            Attributes: attributes,
            Metrics: metrics,
            Session: session
        }, _a);
        return eventParams;
    };
    AWSPinpointProvider.prototype._pinpointPutEvents = function(params, handlers) {
        return $569cec49c4b0b835$var$__awaiter(this, void 0, void 0, function() {
            var eventId, endpointId, eventParams, data, _a, _b, _c, StatusCode, Message, err_1;
            return $569cec49c4b0b835$var$__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        eventId = params.event.eventId, endpointId = params.config.endpointId;
                        eventParams = this._generateBatchItemContext(params);
                        _d.label = 1;
                    case 1:
                        _d.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.pinpointClient.putEvents(eventParams).promise()
                        ];
                    case 2:
                        data = _d.sent();
                        _a = endpointId, _b = eventId, _c = data.EventsResponse.Results[_a].EventsItemResponse[_b], StatusCode = _c.StatusCode, Message = _c.Message;
                        if ($569cec49c4b0b835$var$ACCEPTED_CODES.includes(StatusCode)) {
                            $569cec49c4b0b835$var$logger.debug("record event success. ", data);
                            return [
                                2 /*return*/ ,
                                handlers.resolve(data)
                            ];
                        } else if ($569cec49c4b0b835$var$RETRYABLE_CODES.includes(StatusCode)) this._retry(params, handlers);
                        else {
                            $569cec49c4b0b835$var$logger.error("Event " + eventId + " is not accepted, the error is " + Message);
                            return [
                                2 /*return*/ ,
                                handlers.reject(data)
                            ];
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_1 = _d.sent();
                        this._eventError(err_1);
                        return [
                            2 /*return*/ ,
                            handlers.reject(err_1)
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSPinpointProvider.prototype._pinpointSendStopSession = function(params, handlers) {
        if (!$569cec49c4b0b835$var$BEACON_SUPPORTED) {
            this._pinpointPutEvents(params, handlers);
            return;
        }
        var eventParams = this._generateBatchItemContext(params);
        var region = this._config.region;
        var ApplicationId = eventParams.ApplicationId, EventsRequest = eventParams.EventsRequest;
        var accessInfo = {
            secret_key: this._config.credentials.secretAccessKey,
            access_key: this._config.credentials.accessKeyId,
            session_token: this._config.credentials.sessionToken
        };
        var url = "https://pinpoint." + region + ".amazonaws.com/v1/apps/" + ApplicationId + "/events/legacy";
        var body = JSON.stringify(EventsRequest);
        var method = "POST";
        var request = {
            url: url,
            body: body,
            method: method
        };
        var serviceInfo = {
            region: region,
            service: $569cec49c4b0b835$var$MOBILE_SERVICE_NAME
        };
        var requestUrl = (0, $kP2rz.default).signUrl(request, accessInfo, serviceInfo, null);
        var success = navigator.sendBeacon(requestUrl, body);
        if (success) return handlers.resolve("sendBeacon success");
        return handlers.reject("sendBeacon failure");
    };
    AWSPinpointProvider.prototype._retry = function(params, handlers) {
        var resendLimit = params.config.resendLimit;
        // For backward compatibility
        params.resendLimit = typeof params.resendLimit === "number" ? params.resendLimit : resendLimit;
        if (params.resendLimit-- > 0) {
            $569cec49c4b0b835$var$logger.debug("resending event " + params.eventName + " with " + params.resendLimit + " retry times left");
            this._pinpointPutEvents(params, handlers);
        } else $569cec49c4b0b835$var$logger.debug("retry times used up for event " + params.eventName);
    };
    AWSPinpointProvider.prototype._updateEndpoint = function(endpointObject) {
        return $569cec49c4b0b835$var$__awaiter(this, void 0, void 0, function() {
            var params, handlers, config, event, appId, endpointId, request, update_params, data, err_2, failureData;
            return $569cec49c4b0b835$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        params = endpointObject.params, handlers = endpointObject.handlers;
                        config = params.config, event = params.event;
                        appId = config.appId, endpointId = config.endpointId;
                        request = this._endpointRequest(config, (0, $gssgp.default).transferKeyToLowerCase(event, [], [
                            "attributes",
                            "userAttributes",
                            "Attributes",
                            "UserAttributes"
                        ]));
                        update_params = {
                            ApplicationId: appId,
                            EndpointId: endpointId,
                            EndpointRequest: request
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.pinpointClient.updateEndpoint(update_params).promise()
                        ];
                    case 2:
                        data = _a.sent();
                        $569cec49c4b0b835$var$logger.debug("updateEndpoint success", data);
                        this._endpointGenerating = false;
                        this._resumeBuffer();
                        handlers.resolve(data);
                        return [
                            2 /*return*/ 
                        ];
                    case 3:
                        err_2 = _a.sent();
                        failureData = {
                            err: err_2,
                            update_params: update_params,
                            endpointObject: endpointObject
                        };
                        return [
                            2 /*return*/ ,
                            this._handleEndpointUpdateFailure(failureData)
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSPinpointProvider.prototype._handleEndpointUpdateFailure = function(failureData) {
        return $569cec49c4b0b835$var$__awaiter(this, void 0, void 0, function() {
            var err, endpointObject, statusCode, exponential;
            return $569cec49c4b0b835$var$__generator(this, function(_a) {
                err = failureData.err, endpointObject = failureData.endpointObject;
                statusCode = err.statusCode;
                $569cec49c4b0b835$var$logger.debug("updateEndpoint failed", err);
                switch(statusCode){
                    case $569cec49c4b0b835$var$BAD_REQUEST_CODE:
                        return [
                            2 /*return*/ ,
                            this._handleEndpointUpdateBadRequest(failureData)
                        ];
                    case $569cec49c4b0b835$var$FORBIDDEN_CODE:
                        return [
                            2 /*return*/ ,
                            this._handleEndpointUpdateForbidden(failureData)
                        ];
                    default:
                        if ($569cec49c4b0b835$var$RETRYABLE_CODES.includes(statusCode)) {
                            exponential = true;
                            return [
                                2 /*return*/ ,
                                this._retryEndpointUpdate(endpointObject, exponential)
                            ];
                        }
                        endpointObject.handlers.reject(err);
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSPinpointProvider.prototype._handleEndpointUpdateBadRequest = function(failureData) {
        return $569cec49c4b0b835$var$__awaiter(this, void 0, void 0, function() {
            var err, update_params, endpointObject, message, ApplicationId, EndpointRequest, err_3;
            return $569cec49c4b0b835$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        err = failureData.err, update_params = failureData.update_params, endpointObject = failureData.endpointObject;
                        message = err.message;
                        ApplicationId = update_params.ApplicationId, EndpointRequest = update_params.EndpointRequest;
                        if (!String(message).startsWith("Exceeded maximum endpoint per user count")) return [
                            2 /*return*/ ,
                            endpointObject.handlers.reject(err)
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._removeUnusedEndpoints(ApplicationId, EndpointRequest.User.UserId)
                        ];
                    case 2:
                        _a.sent();
                        $569cec49c4b0b835$var$logger.debug("Removed unused endpoints successfully");
                        this._retryEndpointUpdate(endpointObject);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_3 = _a.sent();
                        $569cec49c4b0b835$var$logger.warn("Failed to remove unused endpoints with error: " + err_3);
                        $569cec49c4b0b835$var$logger.warn('Please ensure you have updated your Pinpoint IAM Policy with the Action: "mobiletargeting:GetUserEndpoints" in order to get endpoints info of the user');
                        return [
                            2 /*return*/ ,
                            endpointObject.handlers.reject(err_3)
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSPinpointProvider.prototype._handleEndpointUpdateForbidden = function(failureData) {
        var err = failureData.err, endpointObject = failureData.endpointObject;
        var code = err.code, retryable = err.retryable;
        if (code !== $569cec49c4b0b835$var$EXPIRED_TOKEN_CODE && !retryable) return endpointObject.handlers.reject(err);
        this._retryEndpointUpdate(endpointObject);
    };
    AWSPinpointProvider.prototype._retryEndpointUpdate = function(endpointObject, exponential) {
        if (exponential === void 0) exponential = false;
        $569cec49c4b0b835$var$logger.debug("_retryEndpointUpdate", endpointObject);
        var params = endpointObject.params;
        // TODO: implement retry with exp back off once exp function is available
        var resendLimit = params.config.resendLimit;
        params.resendLimit = typeof params.resendLimit === "number" ? params.resendLimit : resendLimit;
        if (params.resendLimit-- > 0) {
            $569cec49c4b0b835$var$logger.debug("resending endpoint update " + params.event.eventId + " with " + params.resendLimit + " retry attempts remaining");
            // insert at the front of endpointBuffer
            this._endpointBuffer.length ? this._endpointBuffer.unshift(endpointObject) : this._updateEndpoint(endpointObject);
            return;
        }
        $569cec49c4b0b835$var$logger.warn("resending endpoint update " + params.event.eventId + " failed after " + params.config.resendLimit + " attempts");
        if (this._endpointGenerating) $569cec49c4b0b835$var$logger.error("Initial endpoint update failed. ");
    };
    AWSPinpointProvider.prototype._removeUnusedEndpoints = function(appId, userId) {
        return $569cec49c4b0b835$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $569cec49c4b0b835$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(res, rej) {
                        // TODO: re-write with Promise (during refactor pt. 2)
                        _this.pinpointClient.getUserEndpoints({
                            ApplicationId: appId,
                            UserId: userId
                        }, function(err, data) {
                            if (err) {
                                $569cec49c4b0b835$var$logger.debug("Failed to get endpoints associated with the userId: " + userId + " with error", err);
                                return rej(err);
                            }
                            var endpoints = data.EndpointsResponse.Item;
                            $569cec49c4b0b835$var$logger.debug("get endpoints associated with the userId: " + userId + " with data", endpoints);
                            var endpointToBeDeleted = endpoints[0];
                            for(var i = 1; i < endpoints.length; i++){
                                var timeStamp1 = Date.parse(endpointToBeDeleted["EffectiveDate"]);
                                var timeStamp2 = Date.parse(endpoints[i]["EffectiveDate"]);
                                // delete the one with invalid effective date
                                if (isNaN(timeStamp1)) break;
                                if (isNaN(timeStamp2)) {
                                    endpointToBeDeleted = endpoints[i];
                                    break;
                                }
                                if (timeStamp2 < timeStamp1) endpointToBeDeleted = endpoints[i];
                            }
                            // update the endpoint's user id with an empty string
                            var update_params = {
                                ApplicationId: appId,
                                EndpointId: endpointToBeDeleted["Id"],
                                EndpointRequest: {
                                    User: {
                                        UserId: ""
                                    }
                                }
                            };
                            _this.pinpointClient.updateEndpoint(update_params, function(err, data) {
                                if (err) {
                                    $569cec49c4b0b835$var$logger.debug("Failed to update the endpoint", err);
                                    return rej(err);
                                }
                                $569cec49c4b0b835$var$logger.debug("The old endpoint is updated with an empty string for user id");
                                return res(data);
                            });
                        });
                    })
                ];
            });
        });
    };
    /**
     * @private
     * @param config
     * Init the clients
     */ AWSPinpointProvider.prototype._initClients = function(credentials) {
        return $569cec49c4b0b835$var$__awaiter(this, void 0, void 0, function() {
            var identityId, region;
            return $569cec49c4b0b835$var$__generator(this, function(_a) {
                $569cec49c4b0b835$var$logger.debug("init clients");
                if (this.pinpointClient && this._config.credentials && this._config.credentials.sessionToken === credentials.sessionToken && this._config.credentials.identityId === credentials.identityId) {
                    $569cec49c4b0b835$var$logger.debug("no change for aws credentials, directly return from init");
                    return [
                        2 /*return*/ 
                    ];
                }
                identityId = this._config.credentials ? this._config.credentials.identityId : null;
                this._config.credentials = credentials;
                region = this._config.region;
                $569cec49c4b0b835$var$logger.debug("init clients with credentials", credentials);
                this.pinpointClient = new $2tX1t({
                    region: region,
                    credentials: credentials
                });
                if (this._bufferExists() && identityId === credentials.identityId) // if the identity has remained the same, pass the updated client to the buffer
                this._updateBufferClient();
                else // otherwise flush the buffer and instantiate a new one
                // this will cause the old buffer to send any remaining events
                // with the old credentials and then stop looping and shortly thereafter get picked up by GC
                this._initBuffer();
                this._customizePinpointClientReq();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSPinpointProvider.prototype._bufferExists = function() {
        return this._buffer && this._buffer instanceof (0, $d7nsV.default);
    };
    AWSPinpointProvider.prototype._initBuffer = function() {
        if (this._bufferExists()) this._flushBuffer();
        this._buffer = new (0, $d7nsV.default)(this.pinpointClient, this._config);
        // if the first endpoint update hasn't yet resolved pause the buffer to
        // prevent race conditions. It will be resumed as soon as that request succeeds
        if (this._endpointGenerating) this._buffer.pause();
    };
    AWSPinpointProvider.prototype._updateBufferClient = function() {
        if (this._bufferExists()) this._buffer.updateClient(this.pinpointClient);
    };
    AWSPinpointProvider.prototype._flushBuffer = function() {
        if (this._bufferExists()) {
            this._buffer.flush();
            this._buffer = null;
        }
    };
    AWSPinpointProvider.prototype._resumeBuffer = function() {
        if (this._bufferExists()) this._buffer.resume();
    };
    AWSPinpointProvider.prototype._customizePinpointClientReq = function() {
        this.pinpointClient.customizeRequests(function(request) {
            request.on("build", function(req) {
                if ((0, $imZy6.default).isReactNative) req.httpRequest.headers["user-agent"] = (0, $imZy6.default).userAgent;
                // TODO: remove this after we switch to using the current API (non-legacy)
                if (req.httpRequest.path.includes("/events")) req.httpRequest.path += "/legacy";
            });
        });
    };
    AWSPinpointProvider.prototype._getEndpointId = function(cacheKey) {
        return $569cec49c4b0b835$var$__awaiter(this, void 0, void 0, function() {
            var endpointId;
            return $569cec49c4b0b835$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $9x214.default).getItem(cacheKey)
                        ];
                    case 1:
                        endpointId = _a.sent();
                        $569cec49c4b0b835$var$logger.debug("endpointId from cache", endpointId, "type", typeof endpointId);
                        if (!endpointId) {
                            endpointId = (0, $32hwF.v1)();
                            (0, $9x214.default).setItem(cacheKey, endpointId);
                        }
                        return [
                            2 /*return*/ ,
                            endpointId
                        ];
                }
            });
        });
    };
    /**
     * EndPoint request
     * @return {Object} - The request of updating endpoint
     */ AWSPinpointProvider.prototype._endpointRequest = function(config, event) {
        var credentials = config.credentials;
        var clientInfo = this._clientInfo || {};
        var clientContext = config.clientContext || {};
        // for now we have three different ways for default endpoint configurations
        // clientInfo
        // clientContext (deprecated)
        // config.endpoint
        var defaultEndpointConfig = config.endpoint || {};
        var demographicByClientInfo = {
            appVersion: clientInfo.appVersion,
            make: clientInfo.make,
            model: clientInfo.model,
            modelVersion: clientInfo.version,
            platform: clientInfo.platform
        };
        // for backward compatibility
        var clientId = clientContext.clientId, appTitle = clientContext.appTitle, appVersionName = clientContext.appVersionName, appVersionCode = clientContext.appVersionCode, appPackageName = clientContext.appPackageName, demographicByClientContext = $569cec49c4b0b835$var$__rest(clientContext, [
            "clientId",
            "appTitle",
            "appVersionName",
            "appVersionCode",
            "appPackageName"
        ]);
        var channelType = event.address ? clientInfo.platform === "android" ? "GCM" : "APNS" : undefined;
        var tmp = $569cec49c4b0b835$var$__assign($569cec49c4b0b835$var$__assign($569cec49c4b0b835$var$__assign({
            channelType: channelType,
            requestId: (0, $32hwF.v1)(),
            effectiveDate: new Date().toISOString()
        }, defaultEndpointConfig), event), {
            attributes: $569cec49c4b0b835$var$__assign($569cec49c4b0b835$var$__assign({}, defaultEndpointConfig.attributes), event.attributes),
            demographic: $569cec49c4b0b835$var$__assign($569cec49c4b0b835$var$__assign($569cec49c4b0b835$var$__assign($569cec49c4b0b835$var$__assign({}, demographicByClientInfo), demographicByClientContext), defaultEndpointConfig.demographic), event.demographic),
            location: $569cec49c4b0b835$var$__assign($569cec49c4b0b835$var$__assign({}, defaultEndpointConfig.location), event.location),
            metrics: $569cec49c4b0b835$var$__assign($569cec49c4b0b835$var$__assign({}, defaultEndpointConfig.metrics), event.metrics),
            user: {
                userId: event.userId || defaultEndpointConfig.userId || credentials.identityId,
                userAttributes: $569cec49c4b0b835$var$__assign($569cec49c4b0b835$var$__assign({}, defaultEndpointConfig.userAttributes), event.userAttributes)
            }
        });
        // eliminate unnecessary params
        var userId = tmp.userId, userAttributes = tmp.userAttributes, name = tmp.name, session = tmp.session, eventId = tmp.eventId, immediate = tmp.immediate, ret = $569cec49c4b0b835$var$__rest(tmp, [
            "userId",
            "userAttributes",
            "name",
            "session",
            "eventId",
            "immediate"
        ]);
        return (0, $gssgp.default).transferKeyToUpperCase(ret, [], [
            "metrics",
            "userAttributes",
            "attributes"
        ]);
    };
    AWSPinpointProvider.prototype._eventError = function(err) {
        $569cec49c4b0b835$var$logger.error("record event failed.", err);
        $569cec49c4b0b835$var$logger.warn('Please ensure you have updated your Pinpoint IAM Policy with the Action: "mobiletargeting:PutEvents" in order to record events');
    };
    AWSPinpointProvider.prototype._getCredentials = function() {
        return $569cec49c4b0b835$var$__awaiter(this, void 0, void 0, function() {
            var credentials, err_4;
            return $569cec49c4b0b835$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, $aCVDw.default).get()
                        ];
                    case 1:
                        credentials = _a.sent();
                        if (!credentials) return [
                            2 /*return*/ ,
                            null
                        ];
                        $569cec49c4b0b835$var$logger.debug("set credentials for analytics", credentials);
                        return [
                            2 /*return*/ ,
                            (0, $aCVDw.default).shear(credentials)
                        ];
                    case 2:
                        err_4 = _a.sent();
                        $569cec49c4b0b835$var$logger.debug("ensure credentials error", err_4);
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSPinpointProvider.category = "Analytics";
    AWSPinpointProvider.providerName = "AWSPinpoint";
    return AWSPinpointProvider;
}();
var $569cec49c4b0b835$export$2e2bcd8739ae039 = $569cec49c4b0b835$var$AWSPinpointProvider;

});
parcelRequire.register("2tX1t", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $1cec12e270a29c09$var$Service = $dbC7k.Service;
var $1cec12e270a29c09$var$apiLoader = $dbC7k.apiLoader;
$1cec12e270a29c09$var$apiLoader.services["pinpoint"] = {};
$dbC7k.Pinpoint = $1cec12e270a29c09$var$Service.defineService("pinpoint", [
    "2016-12-01"
]);

Object.defineProperty($1cec12e270a29c09$var$apiLoader.services["pinpoint"], "2016-12-01", {
    get: function get() {
        var model = (parcelRequire("dVldg"));
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Pinpoint;

});
parcelRequire.register("dVldg", function(module, exports) {
module.exports = JSON.parse('{"metadata":{"apiVersion":"2016-12-01","endpointPrefix":"pinpoint","signingName":"mobiletargeting","serviceFullName":"Amazon Pinpoint","serviceId":"Pinpoint","protocol":"rest-json","jsonVersion":"1.1","uid":"pinpoint-2016-12-01","signatureVersion":"v4"},"operations":{"CreateApp":{"http":{"requestUri":"/v1/apps","responseCode":201},"input":{"type":"structure","members":{"CreateApplicationRequest":{"type":"structure","members":{"Name":{},"tags":{"shape":"S4","locationName":"tags"}},"required":["Name"]}},"required":["CreateApplicationRequest"],"payload":"CreateApplicationRequest"},"output":{"type":"structure","members":{"ApplicationResponse":{"shape":"S6"}},"required":["ApplicationResponse"],"payload":"ApplicationResponse"}},"CreateCampaign":{"http":{"requestUri":"/v1/apps/{application-id}/campaigns","responseCode":201},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"WriteCampaignRequest":{"shape":"S8"}},"required":["ApplicationId","WriteCampaignRequest"],"payload":"WriteCampaignRequest"},"output":{"type":"structure","members":{"CampaignResponse":{"shape":"S12"}},"required":["CampaignResponse"],"payload":"CampaignResponse"}},"CreateExportJob":{"http":{"requestUri":"/v1/apps/{application-id}/jobs/export","responseCode":202},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"ExportJobRequest":{"type":"structure","members":{"RoleArn":{},"S3UrlPrefix":{},"SegmentId":{},"SegmentVersion":{"type":"integer"}},"required":["S3UrlPrefix","RoleArn"]}},"required":["ApplicationId","ExportJobRequest"],"payload":"ExportJobRequest"},"output":{"type":"structure","members":{"ExportJobResponse":{"shape":"S1a"}},"required":["ExportJobResponse"],"payload":"ExportJobResponse"}},"CreateImportJob":{"http":{"requestUri":"/v1/apps/{application-id}/jobs/import","responseCode":201},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"ImportJobRequest":{"type":"structure","members":{"DefineSegment":{"type":"boolean"},"ExternalId":{},"Format":{},"RegisterEndpoints":{"type":"boolean"},"RoleArn":{},"S3Url":{},"SegmentId":{},"SegmentName":{}},"required":["Format","S3Url","RoleArn"]}},"required":["ApplicationId","ImportJobRequest"],"payload":"ImportJobRequest"},"output":{"type":"structure","members":{"ImportJobResponse":{"shape":"S1h"}},"required":["ImportJobResponse"],"payload":"ImportJobResponse"}},"CreateSegment":{"http":{"requestUri":"/v1/apps/{application-id}/segments","responseCode":201},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"WriteSegmentRequest":{"shape":"S1k"}},"required":["ApplicationId","WriteSegmentRequest"],"payload":"WriteSegmentRequest"},"output":{"type":"structure","members":{"SegmentResponse":{"shape":"S24"}},"required":["SegmentResponse"],"payload":"SegmentResponse"}},"DeleteAdmChannel":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/channels/adm","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ADMChannelResponse":{"shape":"S2a"}},"required":["ADMChannelResponse"],"payload":"ADMChannelResponse"}},"DeleteApnsChannel":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/channels/apns","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"APNSChannelResponse":{"shape":"S2d"}},"required":["APNSChannelResponse"],"payload":"APNSChannelResponse"}},"DeleteApnsSandboxChannel":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/channels/apns_sandbox","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"APNSSandboxChannelResponse":{"shape":"S2g"}},"required":["APNSSandboxChannelResponse"],"payload":"APNSSandboxChannelResponse"}},"DeleteApnsVoipChannel":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/channels/apns_voip","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"APNSVoipChannelResponse":{"shape":"S2j"}},"required":["APNSVoipChannelResponse"],"payload":"APNSVoipChannelResponse"}},"DeleteApnsVoipSandboxChannel":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/channels/apns_voip_sandbox","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"APNSVoipSandboxChannelResponse":{"shape":"S2m"}},"required":["APNSVoipSandboxChannelResponse"],"payload":"APNSVoipSandboxChannelResponse"}},"DeleteApp":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ApplicationResponse":{"shape":"S6"}},"required":["ApplicationResponse"],"payload":"ApplicationResponse"}},"DeleteBaiduChannel":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/channels/baidu","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"BaiduChannelResponse":{"shape":"S2r"}},"required":["BaiduChannelResponse"],"payload":"BaiduChannelResponse"}},"DeleteCampaign":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/campaigns/{campaign-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"CampaignId":{"location":"uri","locationName":"campaign-id"}},"required":["CampaignId","ApplicationId"]},"output":{"type":"structure","members":{"CampaignResponse":{"shape":"S12"}},"required":["CampaignResponse"],"payload":"CampaignResponse"}},"DeleteEmailChannel":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/channels/email","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"EmailChannelResponse":{"shape":"S2w"}},"required":["EmailChannelResponse"],"payload":"EmailChannelResponse"}},"DeleteEndpoint":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/endpoints/{endpoint-id}","responseCode":202},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"EndpointId":{"location":"uri","locationName":"endpoint-id"}},"required":["ApplicationId","EndpointId"]},"output":{"type":"structure","members":{"EndpointResponse":{"shape":"S2z"}},"required":["EndpointResponse"],"payload":"EndpointResponse"}},"DeleteEventStream":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/eventstream","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"EventStream":{"shape":"S38"}},"required":["EventStream"],"payload":"EventStream"}},"DeleteGcmChannel":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/channels/gcm","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"GCMChannelResponse":{"shape":"S3b"}},"required":["GCMChannelResponse"],"payload":"GCMChannelResponse"}},"DeleteSegment":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/segments/{segment-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"SegmentId":{"location":"uri","locationName":"segment-id"}},"required":["SegmentId","ApplicationId"]},"output":{"type":"structure","members":{"SegmentResponse":{"shape":"S24"}},"required":["SegmentResponse"],"payload":"SegmentResponse"}},"DeleteSmsChannel":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/channels/sms","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"SMSChannelResponse":{"shape":"S3g"}},"required":["SMSChannelResponse"],"payload":"SMSChannelResponse"}},"DeleteUserEndpoints":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/users/{user-id}","responseCode":202},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"UserId":{"location":"uri","locationName":"user-id"}},"required":["ApplicationId","UserId"]},"output":{"type":"structure","members":{"EndpointsResponse":{"shape":"S3j"}},"required":["EndpointsResponse"],"payload":"EndpointsResponse"}},"DeleteVoiceChannel":{"http":{"method":"DELETE","requestUri":"/v1/apps/{application-id}/channels/voice","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"VoiceChannelResponse":{"shape":"S3n"}},"required":["VoiceChannelResponse"],"payload":"VoiceChannelResponse"}},"GetAdmChannel":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels/adm","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ADMChannelResponse":{"shape":"S2a"}},"required":["ADMChannelResponse"],"payload":"ADMChannelResponse"}},"GetApnsChannel":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels/apns","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"APNSChannelResponse":{"shape":"S2d"}},"required":["APNSChannelResponse"],"payload":"APNSChannelResponse"}},"GetApnsSandboxChannel":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels/apns_sandbox","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"APNSSandboxChannelResponse":{"shape":"S2g"}},"required":["APNSSandboxChannelResponse"],"payload":"APNSSandboxChannelResponse"}},"GetApnsVoipChannel":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels/apns_voip","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"APNSVoipChannelResponse":{"shape":"S2j"}},"required":["APNSVoipChannelResponse"],"payload":"APNSVoipChannelResponse"}},"GetApnsVoipSandboxChannel":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels/apns_voip_sandbox","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"APNSVoipSandboxChannelResponse":{"shape":"S2m"}},"required":["APNSVoipSandboxChannelResponse"],"payload":"APNSVoipSandboxChannelResponse"}},"GetApp":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ApplicationResponse":{"shape":"S6"}},"required":["ApplicationResponse"],"payload":"ApplicationResponse"}},"GetApplicationDateRangeKpi":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/kpis/daterange/{kpi-name}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"EndTime":{"shape":"S41","location":"querystring","locationName":"end-time"},"KpiName":{"location":"uri","locationName":"kpi-name"},"NextToken":{"location":"querystring","locationName":"next-token"},"PageSize":{"location":"querystring","locationName":"page-size"},"StartTime":{"shape":"S41","location":"querystring","locationName":"start-time"}},"required":["ApplicationId","KpiName"]},"output":{"type":"structure","members":{"ApplicationDateRangeKpiResponse":{"type":"structure","members":{"ApplicationId":{},"EndTime":{"shape":"S41"},"KpiName":{},"KpiResult":{"shape":"S44"},"NextToken":{},"StartTime":{"shape":"S41"}},"required":["KpiResult","KpiName","EndTime","StartTime","ApplicationId"]}},"required":["ApplicationDateRangeKpiResponse"],"payload":"ApplicationDateRangeKpiResponse"}},"GetApplicationSettings":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/settings","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ApplicationSettingsResource":{"shape":"S4b"}},"required":["ApplicationSettingsResource"],"payload":"ApplicationSettingsResource"}},"GetApps":{"http":{"method":"GET","requestUri":"/v1/apps","responseCode":200},"input":{"type":"structure","members":{"PageSize":{"location":"querystring","locationName":"page-size"},"Token":{"location":"querystring","locationName":"token"}}},"output":{"type":"structure","members":{"ApplicationsResponse":{"type":"structure","members":{"Item":{"type":"list","member":{"shape":"S6"}},"NextToken":{}}}},"required":["ApplicationsResponse"],"payload":"ApplicationsResponse"}},"GetBaiduChannel":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels/baidu","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"BaiduChannelResponse":{"shape":"S2r"}},"required":["BaiduChannelResponse"],"payload":"BaiduChannelResponse"}},"GetCampaign":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/campaigns/{campaign-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"CampaignId":{"location":"uri","locationName":"campaign-id"}},"required":["CampaignId","ApplicationId"]},"output":{"type":"structure","members":{"CampaignResponse":{"shape":"S12"}},"required":["CampaignResponse"],"payload":"CampaignResponse"}},"GetCampaignActivities":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/campaigns/{campaign-id}/activities","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"CampaignId":{"location":"uri","locationName":"campaign-id"},"PageSize":{"location":"querystring","locationName":"page-size"},"Token":{"location":"querystring","locationName":"token"}},"required":["ApplicationId","CampaignId"]},"output":{"type":"structure","members":{"ActivitiesResponse":{"type":"structure","members":{"Item":{"type":"list","member":{"type":"structure","members":{"ApplicationId":{},"CampaignId":{},"End":{},"Id":{},"Result":{},"ScheduledStart":{},"Start":{},"State":{},"SuccessfulEndpointCount":{"type":"integer"},"TimezonesCompletedCount":{"type":"integer"},"TimezonesTotalCount":{"type":"integer"},"TotalEndpointCount":{"type":"integer"},"TreatmentId":{}},"required":["CampaignId","Id","ApplicationId"]}},"NextToken":{}},"required":["Item"]}},"required":["ActivitiesResponse"],"payload":"ActivitiesResponse"}},"GetCampaignDateRangeKpi":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/campaigns/{campaign-id}/kpis/daterange/{kpi-name}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"CampaignId":{"location":"uri","locationName":"campaign-id"},"EndTime":{"shape":"S41","location":"querystring","locationName":"end-time"},"KpiName":{"location":"uri","locationName":"kpi-name"},"NextToken":{"location":"querystring","locationName":"next-token"},"PageSize":{"location":"querystring","locationName":"page-size"},"StartTime":{"shape":"S41","location":"querystring","locationName":"start-time"}},"required":["ApplicationId","KpiName","CampaignId"]},"output":{"type":"structure","members":{"CampaignDateRangeKpiResponse":{"type":"structure","members":{"ApplicationId":{},"CampaignId":{},"EndTime":{"shape":"S41"},"KpiName":{},"KpiResult":{"shape":"S44"},"NextToken":{},"StartTime":{"shape":"S41"}},"required":["KpiResult","KpiName","EndTime","CampaignId","StartTime","ApplicationId"]}},"required":["CampaignDateRangeKpiResponse"],"payload":"CampaignDateRangeKpiResponse"}},"GetCampaignVersion":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/campaigns/{campaign-id}/versions/{version}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"CampaignId":{"location":"uri","locationName":"campaign-id"},"Version":{"location":"uri","locationName":"version"}},"required":["Version","ApplicationId","CampaignId"]},"output":{"type":"structure","members":{"CampaignResponse":{"shape":"S12"}},"required":["CampaignResponse"],"payload":"CampaignResponse"}},"GetCampaignVersions":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/campaigns/{campaign-id}/versions","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"CampaignId":{"location":"uri","locationName":"campaign-id"},"PageSize":{"location":"querystring","locationName":"page-size"},"Token":{"location":"querystring","locationName":"token"}},"required":["ApplicationId","CampaignId"]},"output":{"type":"structure","members":{"CampaignsResponse":{"shape":"S4w"}},"required":["CampaignsResponse"],"payload":"CampaignsResponse"}},"GetCampaigns":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/campaigns","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"PageSize":{"location":"querystring","locationName":"page-size"},"Token":{"location":"querystring","locationName":"token"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"CampaignsResponse":{"shape":"S4w"}},"required":["CampaignsResponse"],"payload":"CampaignsResponse"}},"GetChannels":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ChannelsResponse":{"type":"structure","members":{"Channels":{"type":"map","key":{},"value":{"type":"structure","members":{"ApplicationId":{},"CreationDate":{},"Enabled":{"type":"boolean"},"HasCredential":{"type":"boolean"},"Id":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"Version":{"type":"integer"}}}}},"required":["Channels"]}},"required":["ChannelsResponse"],"payload":"ChannelsResponse"}},"GetEmailChannel":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels/email","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"EmailChannelResponse":{"shape":"S2w"}},"required":["EmailChannelResponse"],"payload":"EmailChannelResponse"}},"GetEndpoint":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/endpoints/{endpoint-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"EndpointId":{"location":"uri","locationName":"endpoint-id"}},"required":["ApplicationId","EndpointId"]},"output":{"type":"structure","members":{"EndpointResponse":{"shape":"S2z"}},"required":["EndpointResponse"],"payload":"EndpointResponse"}},"GetEventStream":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/eventstream","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"EventStream":{"shape":"S38"}},"required":["EventStream"],"payload":"EventStream"}},"GetExportJob":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/jobs/export/{job-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"JobId":{"location":"uri","locationName":"job-id"}},"required":["ApplicationId","JobId"]},"output":{"type":"structure","members":{"ExportJobResponse":{"shape":"S1a"}},"required":["ExportJobResponse"],"payload":"ExportJobResponse"}},"GetExportJobs":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/jobs/export","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"PageSize":{"location":"querystring","locationName":"page-size"},"Token":{"location":"querystring","locationName":"token"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ExportJobsResponse":{"shape":"S5f"}},"required":["ExportJobsResponse"],"payload":"ExportJobsResponse"}},"GetGcmChannel":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels/gcm","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"GCMChannelResponse":{"shape":"S3b"}},"required":["GCMChannelResponse"],"payload":"GCMChannelResponse"}},"GetImportJob":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/jobs/import/{job-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"JobId":{"location":"uri","locationName":"job-id"}},"required":["ApplicationId","JobId"]},"output":{"type":"structure","members":{"ImportJobResponse":{"shape":"S1h"}},"required":["ImportJobResponse"],"payload":"ImportJobResponse"}},"GetImportJobs":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/jobs/import","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"PageSize":{"location":"querystring","locationName":"page-size"},"Token":{"location":"querystring","locationName":"token"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ImportJobsResponse":{"shape":"S5n"}},"required":["ImportJobsResponse"],"payload":"ImportJobsResponse"}},"GetSegment":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/segments/{segment-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"SegmentId":{"location":"uri","locationName":"segment-id"}},"required":["SegmentId","ApplicationId"]},"output":{"type":"structure","members":{"SegmentResponse":{"shape":"S24"}},"required":["SegmentResponse"],"payload":"SegmentResponse"}},"GetSegmentExportJobs":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/segments/{segment-id}/jobs/export","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"PageSize":{"location":"querystring","locationName":"page-size"},"SegmentId":{"location":"uri","locationName":"segment-id"},"Token":{"location":"querystring","locationName":"token"}},"required":["SegmentId","ApplicationId"]},"output":{"type":"structure","members":{"ExportJobsResponse":{"shape":"S5f"}},"required":["ExportJobsResponse"],"payload":"ExportJobsResponse"}},"GetSegmentImportJobs":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/segments/{segment-id}/jobs/import","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"PageSize":{"location":"querystring","locationName":"page-size"},"SegmentId":{"location":"uri","locationName":"segment-id"},"Token":{"location":"querystring","locationName":"token"}},"required":["SegmentId","ApplicationId"]},"output":{"type":"structure","members":{"ImportJobsResponse":{"shape":"S5n"}},"required":["ImportJobsResponse"],"payload":"ImportJobsResponse"}},"GetSegmentVersion":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/segments/{segment-id}/versions/{version}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"SegmentId":{"location":"uri","locationName":"segment-id"},"Version":{"location":"uri","locationName":"version"}},"required":["SegmentId","Version","ApplicationId"]},"output":{"type":"structure","members":{"SegmentResponse":{"shape":"S24"}},"required":["SegmentResponse"],"payload":"SegmentResponse"}},"GetSegmentVersions":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/segments/{segment-id}/versions","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"PageSize":{"location":"querystring","locationName":"page-size"},"SegmentId":{"location":"uri","locationName":"segment-id"},"Token":{"location":"querystring","locationName":"token"}},"required":["SegmentId","ApplicationId"]},"output":{"type":"structure","members":{"SegmentsResponse":{"shape":"S5z"}},"required":["SegmentsResponse"],"payload":"SegmentsResponse"}},"GetSegments":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/segments","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"PageSize":{"location":"querystring","locationName":"page-size"},"Token":{"location":"querystring","locationName":"token"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"SegmentsResponse":{"shape":"S5z"}},"required":["SegmentsResponse"],"payload":"SegmentsResponse"}},"GetSmsChannel":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels/sms","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"SMSChannelResponse":{"shape":"S3g"}},"required":["SMSChannelResponse"],"payload":"SMSChannelResponse"}},"GetUserEndpoints":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/users/{user-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"UserId":{"location":"uri","locationName":"user-id"}},"required":["ApplicationId","UserId"]},"output":{"type":"structure","members":{"EndpointsResponse":{"shape":"S3j"}},"required":["EndpointsResponse"],"payload":"EndpointsResponse"}},"GetVoiceChannel":{"http":{"method":"GET","requestUri":"/v1/apps/{application-id}/channels/voice","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"VoiceChannelResponse":{"shape":"S3n"}},"required":["VoiceChannelResponse"],"payload":"VoiceChannelResponse"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/v1/tags/{resource-arn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{"TagsModel":{"shape":"S6b"}},"required":["TagsModel"],"payload":"TagsModel"}},"PhoneNumberValidate":{"http":{"requestUri":"/v1/phone/number/validate","responseCode":200},"input":{"type":"structure","members":{"NumberValidateRequest":{"type":"structure","members":{"IsoCountryCode":{},"PhoneNumber":{}}}},"required":["NumberValidateRequest"],"payload":"NumberValidateRequest"},"output":{"type":"structure","members":{"NumberValidateResponse":{"type":"structure","members":{"Carrier":{},"City":{},"CleansedPhoneNumberE164":{},"CleansedPhoneNumberNational":{},"Country":{},"CountryCodeIso2":{},"CountryCodeNumeric":{},"County":{},"OriginalCountryCodeIso2":{},"OriginalPhoneNumber":{},"PhoneType":{},"PhoneTypeCode":{"type":"integer"},"Timezone":{},"ZipCode":{}}}},"required":["NumberValidateResponse"],"payload":"NumberValidateResponse"}},"PutEventStream":{"http":{"requestUri":"/v1/apps/{application-id}/eventstream","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"WriteEventStream":{"type":"structure","members":{"DestinationStreamArn":{},"RoleArn":{}},"required":["RoleArn","DestinationStreamArn"]}},"required":["ApplicationId","WriteEventStream"],"payload":"WriteEventStream"},"output":{"type":"structure","members":{"EventStream":{"shape":"S38"}},"required":["EventStream"],"payload":"EventStream"}},"PutEvents":{"http":{"requestUri":"/v1/apps/{application-id}/events","responseCode":202},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"EventsRequest":{"type":"structure","members":{"BatchItem":{"type":"map","key":{},"value":{"type":"structure","members":{"Endpoint":{"type":"structure","members":{"Address":{},"Attributes":{"shape":"S30"},"ChannelType":{},"Demographic":{"shape":"S32"},"EffectiveDate":{},"EndpointStatus":{},"Location":{"shape":"S33"},"Metrics":{"shape":"S34"},"OptOut":{},"RequestId":{},"User":{"shape":"S35"}}},"Events":{"type":"map","key":{},"value":{"type":"structure","members":{"AppPackageName":{},"AppTitle":{},"AppVersionCode":{},"Attributes":{"shape":"S4"},"ClientSdkVersion":{},"EventType":{},"Metrics":{"shape":"S34"},"SdkName":{},"Session":{"type":"structure","members":{"Duration":{"type":"integer"},"Id":{},"StartTimestamp":{},"StopTimestamp":{}},"required":["StartTimestamp","Id"]},"Timestamp":{}},"required":["EventType","Timestamp"]}}},"required":["Endpoint","Events"]}}},"required":["BatchItem"]}},"required":["ApplicationId","EventsRequest"],"payload":"EventsRequest"},"output":{"type":"structure","members":{"EventsResponse":{"type":"structure","members":{"Results":{"type":"map","key":{},"value":{"type":"structure","members":{"EndpointItemResponse":{"type":"structure","members":{"Message":{},"StatusCode":{"type":"integer"}}},"EventsItemResponse":{"type":"map","key":{},"value":{"type":"structure","members":{"Message":{},"StatusCode":{"type":"integer"}}}}}}}}}},"required":["EventsResponse"],"payload":"EventsResponse"}},"RemoveAttributes":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/attributes/{attribute-type}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"AttributeType":{"location":"uri","locationName":"attribute-type"},"UpdateAttributesRequest":{"type":"structure","members":{"Blacklist":{"shape":"Sp"}}}},"required":["AttributeType","ApplicationId","UpdateAttributesRequest"],"payload":"UpdateAttributesRequest"},"output":{"type":"structure","members":{"AttributesResource":{"type":"structure","members":{"ApplicationId":{},"AttributeType":{},"Attributes":{"shape":"Sp"}},"required":["AttributeType","ApplicationId"]}},"required":["AttributesResource"],"payload":"AttributesResource"}},"SendMessages":{"http":{"requestUri":"/v1/apps/{application-id}/messages","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"MessageRequest":{"type":"structure","members":{"Addresses":{"type":"map","key":{},"value":{"type":"structure","members":{"BodyOverride":{},"ChannelType":{},"Context":{"shape":"S4"},"RawContent":{},"Substitutions":{"shape":"S30"},"TitleOverride":{}}}},"Context":{"shape":"S4"},"Endpoints":{"shape":"S76"},"MessageConfiguration":{"shape":"S78"},"TraceId":{}},"required":["MessageConfiguration"]}},"required":["ApplicationId","MessageRequest"],"payload":"MessageRequest"},"output":{"type":"structure","members":{"MessageResponse":{"type":"structure","members":{"ApplicationId":{},"EndpointResult":{"shape":"S7o"},"RequestId":{},"Result":{"type":"map","key":{},"value":{"type":"structure","members":{"DeliveryStatus":{},"MessageId":{},"StatusCode":{"type":"integer"},"StatusMessage":{},"UpdatedToken":{}},"required":["DeliveryStatus","StatusCode"]}}},"required":["ApplicationId"]}},"required":["MessageResponse"],"payload":"MessageResponse"}},"SendUsersMessages":{"http":{"requestUri":"/v1/apps/{application-id}/users-messages","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"SendUsersMessageRequest":{"type":"structure","members":{"Context":{"shape":"S4"},"MessageConfiguration":{"shape":"S78"},"TraceId":{},"Users":{"shape":"S76"}},"required":["MessageConfiguration","Users"]}},"required":["ApplicationId","SendUsersMessageRequest"],"payload":"SendUsersMessageRequest"},"output":{"type":"structure","members":{"SendUsersMessageResponse":{"type":"structure","members":{"ApplicationId":{},"RequestId":{},"Result":{"type":"map","key":{},"value":{"shape":"S7o"}}},"required":["ApplicationId"]}},"required":["SendUsersMessageResponse"],"payload":"SendUsersMessageResponse"}},"TagResource":{"http":{"requestUri":"/v1/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"TagsModel":{"shape":"S6b"}},"required":["ResourceArn","TagsModel"],"payload":"TagsModel"}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/v1/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"TagKeys":{"shape":"Sp","location":"querystring","locationName":"tagKeys"}},"required":["TagKeys","ResourceArn"]}},"UpdateAdmChannel":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/channels/adm","responseCode":200},"input":{"type":"structure","members":{"ADMChannelRequest":{"type":"structure","members":{"ClientId":{},"ClientSecret":{},"Enabled":{"type":"boolean"}},"required":["ClientSecret","ClientId"]},"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId","ADMChannelRequest"],"payload":"ADMChannelRequest"},"output":{"type":"structure","members":{"ADMChannelResponse":{"shape":"S2a"}},"required":["ADMChannelResponse"],"payload":"ADMChannelResponse"}},"UpdateApnsChannel":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/channels/apns","responseCode":200},"input":{"type":"structure","members":{"APNSChannelRequest":{"type":"structure","members":{"BundleId":{},"Certificate":{},"DefaultAuthenticationMethod":{},"Enabled":{"type":"boolean"},"PrivateKey":{},"TeamId":{},"TokenKey":{},"TokenKeyId":{}}},"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId","APNSChannelRequest"],"payload":"APNSChannelRequest"},"output":{"type":"structure","members":{"APNSChannelResponse":{"shape":"S2d"}},"required":["APNSChannelResponse"],"payload":"APNSChannelResponse"}},"UpdateApnsSandboxChannel":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/channels/apns_sandbox","responseCode":200},"input":{"type":"structure","members":{"APNSSandboxChannelRequest":{"type":"structure","members":{"BundleId":{},"Certificate":{},"DefaultAuthenticationMethod":{},"Enabled":{"type":"boolean"},"PrivateKey":{},"TeamId":{},"TokenKey":{},"TokenKeyId":{}}},"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId","APNSSandboxChannelRequest"],"payload":"APNSSandboxChannelRequest"},"output":{"type":"structure","members":{"APNSSandboxChannelResponse":{"shape":"S2g"}},"required":["APNSSandboxChannelResponse"],"payload":"APNSSandboxChannelResponse"}},"UpdateApnsVoipChannel":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/channels/apns_voip","responseCode":200},"input":{"type":"structure","members":{"APNSVoipChannelRequest":{"type":"structure","members":{"BundleId":{},"Certificate":{},"DefaultAuthenticationMethod":{},"Enabled":{"type":"boolean"},"PrivateKey":{},"TeamId":{},"TokenKey":{},"TokenKeyId":{}}},"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId","APNSVoipChannelRequest"],"payload":"APNSVoipChannelRequest"},"output":{"type":"structure","members":{"APNSVoipChannelResponse":{"shape":"S2j"}},"required":["APNSVoipChannelResponse"],"payload":"APNSVoipChannelResponse"}},"UpdateApnsVoipSandboxChannel":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/channels/apns_voip_sandbox","responseCode":200},"input":{"type":"structure","members":{"APNSVoipSandboxChannelRequest":{"type":"structure","members":{"BundleId":{},"Certificate":{},"DefaultAuthenticationMethod":{},"Enabled":{"type":"boolean"},"PrivateKey":{},"TeamId":{},"TokenKey":{},"TokenKeyId":{}}},"ApplicationId":{"location":"uri","locationName":"application-id"}},"required":["ApplicationId","APNSVoipSandboxChannelRequest"],"payload":"APNSVoipSandboxChannelRequest"},"output":{"type":"structure","members":{"APNSVoipSandboxChannelResponse":{"shape":"S2m"}},"required":["APNSVoipSandboxChannelResponse"],"payload":"APNSVoipSandboxChannelResponse"}},"UpdateApplicationSettings":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/settings","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"WriteApplicationSettingsRequest":{"type":"structure","members":{"CampaignHook":{"shape":"Sy"},"CloudWatchMetricsEnabled":{"type":"boolean"},"Limits":{"shape":"S10"},"QuietTime":{"shape":"Sx"}}}},"required":["ApplicationId","WriteApplicationSettingsRequest"],"payload":"WriteApplicationSettingsRequest"},"output":{"type":"structure","members":{"ApplicationSettingsResource":{"shape":"S4b"}},"required":["ApplicationSettingsResource"],"payload":"ApplicationSettingsResource"}},"UpdateBaiduChannel":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/channels/baidu","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"BaiduChannelRequest":{"type":"structure","members":{"ApiKey":{},"Enabled":{"type":"boolean"},"SecretKey":{}},"required":["SecretKey","ApiKey"]}},"required":["ApplicationId","BaiduChannelRequest"],"payload":"BaiduChannelRequest"},"output":{"type":"structure","members":{"BaiduChannelResponse":{"shape":"S2r"}},"required":["BaiduChannelResponse"],"payload":"BaiduChannelResponse"}},"UpdateCampaign":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/campaigns/{campaign-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"CampaignId":{"location":"uri","locationName":"campaign-id"},"WriteCampaignRequest":{"shape":"S8"}},"required":["CampaignId","ApplicationId","WriteCampaignRequest"],"payload":"WriteCampaignRequest"},"output":{"type":"structure","members":{"CampaignResponse":{"shape":"S12"}},"required":["CampaignResponse"],"payload":"CampaignResponse"}},"UpdateEmailChannel":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/channels/email","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"EmailChannelRequest":{"type":"structure","members":{"ConfigurationSet":{},"Enabled":{"type":"boolean"},"FromAddress":{},"Identity":{},"RoleArn":{}},"required":["FromAddress","Identity"]}},"required":["ApplicationId","EmailChannelRequest"],"payload":"EmailChannelRequest"},"output":{"type":"structure","members":{"EmailChannelResponse":{"shape":"S2w"}},"required":["EmailChannelResponse"],"payload":"EmailChannelResponse"}},"UpdateEndpoint":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/endpoints/{endpoint-id}","responseCode":202},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"EndpointId":{"location":"uri","locationName":"endpoint-id"},"EndpointRequest":{"type":"structure","members":{"Address":{},"Attributes":{"shape":"S30"},"ChannelType":{},"Demographic":{"shape":"S32"},"EffectiveDate":{},"EndpointStatus":{},"Location":{"shape":"S33"},"Metrics":{"shape":"S34"},"OptOut":{},"RequestId":{},"User":{"shape":"S35"}}}},"required":["ApplicationId","EndpointId","EndpointRequest"],"payload":"EndpointRequest"},"output":{"type":"structure","members":{"MessageBody":{"shape":"S8t"}},"required":["MessageBody"],"payload":"MessageBody"}},"UpdateEndpointsBatch":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/endpoints","responseCode":202},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"EndpointBatchRequest":{"type":"structure","members":{"Item":{"type":"list","member":{"type":"structure","members":{"Address":{},"Attributes":{"shape":"S30"},"ChannelType":{},"Demographic":{"shape":"S32"},"EffectiveDate":{},"EndpointStatus":{},"Id":{},"Location":{"shape":"S33"},"Metrics":{"shape":"S34"},"OptOut":{},"RequestId":{},"User":{"shape":"S35"}}}}},"required":["Item"]}},"required":["ApplicationId","EndpointBatchRequest"],"payload":"EndpointBatchRequest"},"output":{"type":"structure","members":{"MessageBody":{"shape":"S8t"}},"required":["MessageBody"],"payload":"MessageBody"}},"UpdateGcmChannel":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/channels/gcm","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"GCMChannelRequest":{"type":"structure","members":{"ApiKey":{},"Enabled":{"type":"boolean"}},"required":["ApiKey"]}},"required":["ApplicationId","GCMChannelRequest"],"payload":"GCMChannelRequest"},"output":{"type":"structure","members":{"GCMChannelResponse":{"shape":"S3b"}},"required":["GCMChannelResponse"],"payload":"GCMChannelResponse"}},"UpdateSegment":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/segments/{segment-id}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"SegmentId":{"location":"uri","locationName":"segment-id"},"WriteSegmentRequest":{"shape":"S1k"}},"required":["SegmentId","ApplicationId","WriteSegmentRequest"],"payload":"WriteSegmentRequest"},"output":{"type":"structure","members":{"SegmentResponse":{"shape":"S24"}},"required":["SegmentResponse"],"payload":"SegmentResponse"}},"UpdateSmsChannel":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/channels/sms","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"SMSChannelRequest":{"type":"structure","members":{"Enabled":{"type":"boolean"},"SenderId":{},"ShortCode":{}}}},"required":["ApplicationId","SMSChannelRequest"],"payload":"SMSChannelRequest"},"output":{"type":"structure","members":{"SMSChannelResponse":{"shape":"S3g"}},"required":["SMSChannelResponse"],"payload":"SMSChannelResponse"}},"UpdateVoiceChannel":{"http":{"method":"PUT","requestUri":"/v1/apps/{application-id}/channels/voice","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"application-id"},"VoiceChannelRequest":{"type":"structure","members":{"Enabled":{"type":"boolean"}}}},"required":["ApplicationId","VoiceChannelRequest"],"payload":"VoiceChannelRequest"},"output":{"type":"structure","members":{"VoiceChannelResponse":{"shape":"S3n"}},"required":["VoiceChannelResponse"],"payload":"VoiceChannelResponse"}}},"shapes":{"S4":{"type":"map","key":{},"value":{}},"S6":{"type":"structure","members":{"Arn":{},"Id":{},"Name":{},"tags":{"shape":"S4","locationName":"tags"}},"required":["Id","Arn","Name"]},"S8":{"type":"structure","members":{"AdditionalTreatments":{"type":"list","member":{"type":"structure","members":{"MessageConfiguration":{"shape":"Sb"},"Schedule":{"shape":"Sj"},"SizePercent":{"type":"integer"},"TreatmentDescription":{},"TreatmentName":{}},"required":["SizePercent"]}},"Description":{},"HoldoutPercent":{"type":"integer"},"Hook":{"shape":"Sy"},"IsPaused":{"type":"boolean"},"Limits":{"shape":"S10"},"MessageConfiguration":{"shape":"Sb"},"Name":{},"Schedule":{"shape":"Sj"},"SegmentId":{},"SegmentVersion":{"type":"integer"},"tags":{"shape":"S4","locationName":"tags"},"TreatmentDescription":{},"TreatmentName":{}}},"Sb":{"type":"structure","members":{"ADMMessage":{"shape":"Sc"},"APNSMessage":{"shape":"Sc"},"BaiduMessage":{"shape":"Sc"},"DefaultMessage":{"shape":"Sc"},"EmailMessage":{"type":"structure","members":{"Body":{},"FromAddress":{},"HtmlBody":{},"Title":{}},"required":["Title"]},"GCMMessage":{"shape":"Sc"},"SMSMessage":{"type":"structure","members":{"Body":{},"MessageType":{},"SenderId":{}}}}},"Sc":{"type":"structure","members":{"Action":{},"Body":{},"ImageIconUrl":{},"ImageSmallIconUrl":{},"ImageUrl":{},"JsonBody":{},"MediaUrl":{},"RawContent":{},"SilentPush":{"type":"boolean"},"TimeToLive":{"type":"integer"},"Title":{},"Url":{}}},"Sj":{"type":"structure","members":{"EndTime":{},"EventFilter":{"type":"structure","members":{"Dimensions":{"type":"structure","members":{"Attributes":{"shape":"Sm"},"EventType":{"shape":"Sq"},"Metrics":{"shape":"Ss"}}},"FilterType":{}},"required":["FilterType","Dimensions"]},"Frequency":{},"IsLocalTime":{"type":"boolean"},"QuietTime":{"shape":"Sx"},"StartTime":{},"Timezone":{}},"required":["StartTime"]},"Sm":{"type":"map","key":{},"value":{"type":"structure","members":{"AttributeType":{},"Values":{"shape":"Sp"}},"required":["Values"]}},"Sp":{"type":"list","member":{}},"Sq":{"type":"structure","members":{"DimensionType":{},"Values":{"shape":"Sp"}},"required":["Values"]},"Ss":{"type":"map","key":{},"value":{"type":"structure","members":{"ComparisonOperator":{},"Value":{"type":"double"}},"required":["ComparisonOperator","Value"]}},"Sx":{"type":"structure","members":{"End":{},"Start":{}}},"Sy":{"type":"structure","members":{"LambdaFunctionName":{},"Mode":{},"WebUrl":{}}},"S10":{"type":"structure","members":{"Daily":{"type":"integer"},"MaximumDuration":{"type":"integer"},"MessagesPerSecond":{"type":"integer"},"Total":{"type":"integer"}}},"S12":{"type":"structure","members":{"AdditionalTreatments":{"type":"list","member":{"type":"structure","members":{"Id":{},"MessageConfiguration":{"shape":"Sb"},"Schedule":{"shape":"Sj"},"SizePercent":{"type":"integer"},"State":{"shape":"S15"},"TreatmentDescription":{},"TreatmentName":{}},"required":["Id","SizePercent"]}},"ApplicationId":{},"Arn":{},"CreationDate":{},"DefaultState":{"shape":"S15"},"Description":{},"HoldoutPercent":{"type":"integer"},"Hook":{"shape":"Sy"},"Id":{},"IsPaused":{"type":"boolean"},"LastModifiedDate":{},"Limits":{"shape":"S10"},"MessageConfiguration":{"shape":"Sb"},"Name":{},"Schedule":{"shape":"Sj"},"SegmentId":{},"SegmentVersion":{"type":"integer"},"State":{"shape":"S15"},"tags":{"shape":"S4","locationName":"tags"},"TreatmentDescription":{},"TreatmentName":{},"Version":{"type":"integer"}},"required":["LastModifiedDate","CreationDate","SegmentId","SegmentVersion","Id","Arn","ApplicationId"]},"S15":{"type":"structure","members":{"CampaignStatus":{}}},"S1a":{"type":"structure","members":{"ApplicationId":{},"CompletedPieces":{"type":"integer"},"CompletionDate":{},"CreationDate":{},"Definition":{"type":"structure","members":{"RoleArn":{},"S3UrlPrefix":{},"SegmentId":{},"SegmentVersion":{"type":"integer"}},"required":["S3UrlPrefix","RoleArn"]},"FailedPieces":{"type":"integer"},"Failures":{"shape":"Sp"},"Id":{},"JobStatus":{},"TotalFailures":{"type":"integer"},"TotalPieces":{"type":"integer"},"TotalProcessed":{"type":"integer"},"Type":{}},"required":["JobStatus","CreationDate","Type","Definition","Id","ApplicationId"]},"S1h":{"type":"structure","members":{"ApplicationId":{},"CompletedPieces":{"type":"integer"},"CompletionDate":{},"CreationDate":{},"Definition":{"type":"structure","members":{"DefineSegment":{"type":"boolean"},"ExternalId":{},"Format":{},"RegisterEndpoints":{"type":"boolean"},"RoleArn":{},"S3Url":{},"SegmentId":{},"SegmentName":{}},"required":["Format","S3Url","RoleArn"]},"FailedPieces":{"type":"integer"},"Failures":{"shape":"Sp"},"Id":{},"JobStatus":{},"TotalFailures":{"type":"integer"},"TotalPieces":{"type":"integer"},"TotalProcessed":{"type":"integer"},"Type":{}},"required":["JobStatus","CreationDate","Type","Definition","Id","ApplicationId"]},"S1k":{"type":"structure","members":{"Dimensions":{"shape":"S1l"},"Name":{},"SegmentGroups":{"shape":"S1u"},"tags":{"shape":"S4","locationName":"tags"}}},"S1l":{"type":"structure","members":{"Attributes":{"shape":"Sm"},"Behavior":{"type":"structure","members":{"Recency":{"type":"structure","members":{"Duration":{},"RecencyType":{}},"required":["Duration","RecencyType"]}}},"Demographic":{"type":"structure","members":{"AppVersion":{"shape":"Sq"},"Channel":{"shape":"Sq"},"DeviceType":{"shape":"Sq"},"Make":{"shape":"Sq"},"Model":{"shape":"Sq"},"Platform":{"shape":"Sq"}}},"Location":{"type":"structure","members":{"Country":{"shape":"Sq"},"GPSPoint":{"type":"structure","members":{"Coordinates":{"type":"structure","members":{"Latitude":{"type":"double"},"Longitude":{"type":"double"}},"required":["Latitude","Longitude"]},"RangeInKilometers":{"type":"double"}},"required":["Coordinates"]}}},"Metrics":{"shape":"Ss"},"UserAttributes":{"shape":"Sm"}}},"S1u":{"type":"structure","members":{"Groups":{"type":"list","member":{"type":"structure","members":{"Dimensions":{"type":"list","member":{"shape":"S1l"}},"SourceSegments":{"type":"list","member":{"type":"structure","members":{"Id":{},"Version":{"type":"integer"}},"required":["Id"]}},"SourceType":{},"Type":{}}}},"Include":{}}},"S24":{"type":"structure","members":{"ApplicationId":{},"Arn":{},"CreationDate":{},"Dimensions":{"shape":"S1l"},"Id":{},"ImportDefinition":{"type":"structure","members":{"ChannelCounts":{"type":"map","key":{},"value":{"type":"integer"}},"ExternalId":{},"Format":{},"RoleArn":{},"S3Url":{},"Size":{"type":"integer"}},"required":["Format","S3Url","Size","ExternalId","RoleArn"]},"LastModifiedDate":{},"Name":{},"SegmentGroups":{"shape":"S1u"},"SegmentType":{},"tags":{"shape":"S4","locationName":"tags"},"Version":{"type":"integer"}},"required":["SegmentType","CreationDate","Id","Arn","ApplicationId"]},"S2a":{"type":"structure","members":{"ApplicationId":{},"CreationDate":{},"Enabled":{"type":"boolean"},"HasCredential":{"type":"boolean"},"Id":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"Platform":{},"Version":{"type":"integer"}},"required":["Platform"]},"S2d":{"type":"structure","members":{"ApplicationId":{},"CreationDate":{},"DefaultAuthenticationMethod":{},"Enabled":{"type":"boolean"},"HasCredential":{"type":"boolean"},"HasTokenKey":{"type":"boolean"},"Id":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"Platform":{},"Version":{"type":"integer"}},"required":["Platform"]},"S2g":{"type":"structure","members":{"ApplicationId":{},"CreationDate":{},"DefaultAuthenticationMethod":{},"Enabled":{"type":"boolean"},"HasCredential":{"type":"boolean"},"HasTokenKey":{"type":"boolean"},"Id":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"Platform":{},"Version":{"type":"integer"}},"required":["Platform"]},"S2j":{"type":"structure","members":{"ApplicationId":{},"CreationDate":{},"DefaultAuthenticationMethod":{},"Enabled":{"type":"boolean"},"HasCredential":{"type":"boolean"},"HasTokenKey":{"type":"boolean"},"Id":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"Platform":{},"Version":{"type":"integer"}},"required":["Platform"]},"S2m":{"type":"structure","members":{"ApplicationId":{},"CreationDate":{},"DefaultAuthenticationMethod":{},"Enabled":{"type":"boolean"},"HasCredential":{"type":"boolean"},"HasTokenKey":{"type":"boolean"},"Id":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"Platform":{},"Version":{"type":"integer"}},"required":["Platform"]},"S2r":{"type":"structure","members":{"ApplicationId":{},"CreationDate":{},"Credential":{},"Enabled":{"type":"boolean"},"HasCredential":{"type":"boolean"},"Id":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"Platform":{},"Version":{"type":"integer"}},"required":["Credential","Platform"]},"S2w":{"type":"structure","members":{"ApplicationId":{},"ConfigurationSet":{},"CreationDate":{},"Enabled":{"type":"boolean"},"FromAddress":{},"HasCredential":{"type":"boolean"},"Id":{},"Identity":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"MessagesPerSecond":{"type":"integer"},"Platform":{},"RoleArn":{},"Version":{"type":"integer"}},"required":["Platform"]},"S2z":{"type":"structure","members":{"Address":{},"ApplicationId":{},"Attributes":{"shape":"S30"},"ChannelType":{},"CohortId":{},"CreationDate":{},"Demographic":{"shape":"S32"},"EffectiveDate":{},"EndpointStatus":{},"Id":{},"Location":{"shape":"S33"},"Metrics":{"shape":"S34"},"OptOut":{},"RequestId":{},"User":{"shape":"S35"}}},"S30":{"type":"map","key":{},"value":{"shape":"Sp"}},"S32":{"type":"structure","members":{"AppVersion":{},"Locale":{},"Make":{},"Model":{},"ModelVersion":{},"Platform":{},"PlatformVersion":{},"Timezone":{}}},"S33":{"type":"structure","members":{"City":{},"Country":{},"Latitude":{"type":"double"},"Longitude":{"type":"double"},"PostalCode":{},"Region":{}}},"S34":{"type":"map","key":{},"value":{"type":"double"}},"S35":{"type":"structure","members":{"UserAttributes":{"shape":"S30"},"UserId":{}}},"S38":{"type":"structure","members":{"ApplicationId":{},"DestinationStreamArn":{},"ExternalId":{},"LastModifiedDate":{},"LastUpdatedBy":{},"RoleArn":{}},"required":["ApplicationId","RoleArn","DestinationStreamArn"]},"S3b":{"type":"structure","members":{"ApplicationId":{},"CreationDate":{},"Credential":{},"Enabled":{"type":"boolean"},"HasCredential":{"type":"boolean"},"Id":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"Platform":{},"Version":{"type":"integer"}},"required":["Credential","Platform"]},"S3g":{"type":"structure","members":{"ApplicationId":{},"CreationDate":{},"Enabled":{"type":"boolean"},"HasCredential":{"type":"boolean"},"Id":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"Platform":{},"PromotionalMessagesPerSecond":{"type":"integer"},"SenderId":{},"ShortCode":{},"TransactionalMessagesPerSecond":{"type":"integer"},"Version":{"type":"integer"}},"required":["Platform"]},"S3j":{"type":"structure","members":{"Item":{"type":"list","member":{"shape":"S2z"}}},"required":["Item"]},"S3n":{"type":"structure","members":{"ApplicationId":{},"CreationDate":{},"Enabled":{"type":"boolean"},"HasCredential":{"type":"boolean"},"Id":{},"IsArchived":{"type":"boolean"},"LastModifiedBy":{},"LastModifiedDate":{},"Platform":{},"Version":{"type":"integer"}},"required":["Platform"]},"S41":{"type":"timestamp","timestampFormat":"iso8601"},"S44":{"type":"structure","members":{"Rows":{"type":"list","member":{"type":"structure","members":{"GroupedBys":{"shape":"S47"},"Values":{"shape":"S47"}},"required":["GroupedBys","Values"]}}},"required":["Rows"]},"S47":{"type":"list","member":{"type":"structure","members":{"Key":{},"Type":{},"Value":{}},"required":["Type","Value","Key"]}},"S4b":{"type":"structure","members":{"ApplicationId":{},"CampaignHook":{"shape":"Sy"},"LastModifiedDate":{},"Limits":{"shape":"S10"},"QuietTime":{"shape":"Sx"}},"required":["ApplicationId"]},"S4w":{"type":"structure","members":{"Item":{"type":"list","member":{"shape":"S12"}},"NextToken":{}},"required":["Item"]},"S5f":{"type":"structure","members":{"Item":{"type":"list","member":{"shape":"S1a"}},"NextToken":{}},"required":["Item"]},"S5n":{"type":"structure","members":{"Item":{"type":"list","member":{"shape":"S1h"}},"NextToken":{}},"required":["Item"]},"S5z":{"type":"structure","members":{"Item":{"type":"list","member":{"shape":"S24"}},"NextToken":{}},"required":["Item"]},"S6b":{"type":"structure","members":{"tags":{"shape":"S4","locationName":"tags"}},"required":["tags"]},"S76":{"type":"map","key":{},"value":{"type":"structure","members":{"BodyOverride":{},"Context":{"shape":"S4"},"RawContent":{},"Substitutions":{"shape":"S30"},"TitleOverride":{}}}},"S78":{"type":"structure","members":{"ADMMessage":{"type":"structure","members":{"Action":{},"Body":{},"ConsolidationKey":{},"Data":{"shape":"S4"},"ExpiresAfter":{},"IconReference":{},"ImageIconUrl":{},"ImageUrl":{},"MD5":{},"RawContent":{},"SilentPush":{"type":"boolean"},"SmallImageIconUrl":{},"Sound":{},"Substitutions":{"shape":"S30"},"Title":{},"Url":{}}},"APNSMessage":{"type":"structure","members":{"Action":{},"Badge":{"type":"integer"},"Body":{},"Category":{},"CollapseId":{},"Data":{"shape":"S4"},"MediaUrl":{},"PreferredAuthenticationMethod":{},"Priority":{},"RawContent":{},"SilentPush":{"type":"boolean"},"Sound":{},"Substitutions":{"shape":"S30"},"ThreadId":{},"TimeToLive":{"type":"integer"},"Title":{},"Url":{}}},"BaiduMessage":{"type":"structure","members":{"Action":{},"Body":{},"Data":{"shape":"S4"},"IconReference":{},"ImageIconUrl":{},"ImageUrl":{},"RawContent":{},"SilentPush":{"type":"boolean"},"SmallImageIconUrl":{},"Sound":{},"Substitutions":{"shape":"S30"},"TimeToLive":{"type":"integer"},"Title":{},"Url":{}}},"DefaultMessage":{"type":"structure","members":{"Body":{},"Substitutions":{"shape":"S30"}}},"DefaultPushNotificationMessage":{"type":"structure","members":{"Action":{},"Body":{},"Data":{"shape":"S4"},"SilentPush":{"type":"boolean"},"Substitutions":{"shape":"S30"},"Title":{},"Url":{}}},"EmailMessage":{"type":"structure","members":{"Body":{},"FeedbackForwardingAddress":{},"FromAddress":{},"RawEmail":{"type":"structure","members":{"Data":{"type":"blob"}}},"ReplyToAddresses":{"shape":"Sp"},"SimpleEmail":{"type":"structure","members":{"HtmlPart":{"shape":"S7i"},"Subject":{"shape":"S7i"},"TextPart":{"shape":"S7i"}}},"Substitutions":{"shape":"S30"}}},"GCMMessage":{"type":"structure","members":{"Action":{},"Body":{},"CollapseKey":{},"Data":{"shape":"S4"},"IconReference":{},"ImageIconUrl":{},"ImageUrl":{},"Priority":{},"RawContent":{},"RestrictedPackageName":{},"SilentPush":{"type":"boolean"},"SmallImageIconUrl":{},"Sound":{},"Substitutions":{"shape":"S30"},"TimeToLive":{"type":"integer"},"Title":{},"Url":{}}},"SMSMessage":{"type":"structure","members":{"Body":{},"Keyword":{},"MessageType":{},"OriginationNumber":{},"SenderId":{},"Substitutions":{"shape":"S30"}}},"VoiceMessage":{"type":"structure","members":{"Body":{},"LanguageCode":{},"OriginationNumber":{},"Substitutions":{"shape":"S30"},"VoiceId":{}}}}},"S7i":{"type":"structure","members":{"Charset":{},"Data":{}}},"S7o":{"type":"map","key":{},"value":{"type":"structure","members":{"Address":{},"DeliveryStatus":{},"MessageId":{},"StatusCode":{"type":"integer"},"StatusMessage":{},"UpdatedToken":{}},"required":["DeliveryStatus","StatusCode"]}},"S8t":{"type":"structure","members":{"Message":{},"RequestID":{}}}}}');

});


parcelRequire.register("9x214", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f08c28168fcf4d6$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $2hWDt = parcelRequire("2hWDt");

var $5Nfd1 = parcelRequire("5Nfd1");

var $kMkaR = parcelRequire("kMkaR");
var $6f08c28168fcf4d6$export$2e2bcd8739ae039 = (0, $5Nfd1.default);
(0, $2hWDt.default).register((0, $5Nfd1.default));

});
parcelRequire.register("5Nfd1", function(module, exports) {

$parcel$export(module.exports, "BrowserStorageCache", function () { return $437d538d1f3a2112$export$2a9787695d97e2c4; });
$parcel$export(module.exports, "default", function () { return $437d538d1f3a2112$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("4IJD3");
var $f2Vmk = parcelRequire("f2Vmk");

var $lGOOD = parcelRequire("lGOOD");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $437d538d1f3a2112$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $437d538d1f3a2112$var$logger = new (0, $gBqCF.ConsoleLogger)("Cache");
/**
 * Customized storage based on the SessionStorage or LocalStorage with LRU implemented
 */ var $437d538d1f3a2112$export$2a9787695d97e2c4 = /** @class */ function(_super) {
    $437d538d1f3a2112$var$__extends(BrowserStorageCache, _super);
    /**
     * initialize the cache
     * @param config - the configuration of the cache
     */ function BrowserStorageCache(config) {
        var _this = this;
        var cacheConfig = config ? Object.assign({}, (0, $f2Vmk.defaultConfig), config) : (0, $f2Vmk.defaultConfig);
        _this = _super.call(this, cacheConfig) || this;
        _this.config.storage = cacheConfig.storage;
        _this.getItem = _this.getItem.bind(_this);
        _this.setItem = _this.setItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        return _this;
    }
    /**
     * decrease current size of the cache
     *
     * @private
     * @param amount - the amount of the cache size which needs to be decreased
     */ BrowserStorageCache.prototype._decreaseCurSizeInBytes = function(amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize - amount).toString());
    };
    /**
     * increase current size of the cache
     *
     * @private
     * @param amount - the amount of the cache szie which need to be increased
     */ BrowserStorageCache.prototype._increaseCurSizeInBytes = function(amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize + amount).toString());
    };
    /**
     * update the visited time if item has been visited
     *
     * @private
     * @param item - the item which need to be refreshed
     * @param prefixedKey - the key of the item
     *
     * @return the refreshed item
     */ BrowserStorageCache.prototype._refreshItem = function(item, prefixedKey) {
        item.visitedTime = (0, $f2Vmk.getCurrTime)();
        this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        return item;
    };
    /**
     * check wether item is expired
     *
     * @private
     * @param key - the key of the item
     *
     * @return true if the item is expired.
     */ BrowserStorageCache.prototype._isExpired = function(key) {
        var text = this.config.storage.getItem(key);
        var item = JSON.parse(text);
        if ((0, $f2Vmk.getCurrTime)() >= item.expires) return true;
        return false;
    };
    /**
     * delete item from cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param size - optional, the byte size of the item
     */ BrowserStorageCache.prototype._removeItem = function(prefixedKey, size) {
        var itemSize = size ? size : JSON.parse(this.config.storage.getItem(prefixedKey)).byteSize;
        this._decreaseCurSizeInBytes(itemSize);
        // remove the cache item
        this.config.storage.removeItem(prefixedKey);
    };
    /**
     * put item into cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param itemData - the value of the item
     * @param itemSizeInBytes - the byte size of the item
     */ BrowserStorageCache.prototype._setItem = function(prefixedKey, item) {
        // update the cache size
        this._increaseCurSizeInBytes(item.byteSize);
        try {
            this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        } catch (setItemErr) {
            // if failed, we need to rollback the cache size
            this._decreaseCurSizeInBytes(item.byteSize);
            $437d538d1f3a2112$var$logger.error("Failed to set item " + setItemErr);
        }
    };
    /**
     * total space needed when poping out items
     *
     * @private
     * @param itemSize
     *
     * @return total space needed
     */ BrowserStorageCache.prototype._sizeToPop = function(itemSize) {
        var spaceItemNeed = this.getCacheCurSize() + itemSize - this.config.capacityInBytes;
        var cacheThresholdSpace = (1 - this.config.warningThreshold) * this.config.capacityInBytes;
        return spaceItemNeed > cacheThresholdSpace ? spaceItemNeed : cacheThresholdSpace;
    };
    /**
     * see whether cache is full
     *
     * @private
     * @param itemSize
     *
     * @return true if cache is full
     */ BrowserStorageCache.prototype._isCacheFull = function(itemSize) {
        return itemSize + this.getCacheCurSize() > this.config.capacityInBytes;
    };
    /**
     * scan the storage and find out all the keys owned by this cache
     * also clean the expired keys while scanning
     *
     * @private
     *
     * @return array of keys
     */ BrowserStorageCache.prototype._findValidKeys = function() {
        var keys = [];
        var keyInCache = [];
        // get all keys in Storage
        for(var i = 0; i < this.config.storage.length; i += 1)keyInCache.push(this.config.storage.key(i));
        // find those items which belong to our cache and also clean those expired items
        for(var i = 0; i < keyInCache.length; i += 1){
            var key = keyInCache[i];
            if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) {
                if (this._isExpired(key)) this._removeItem(key);
                else keys.push(key);
            }
        }
        return keys;
    };
    /**
     * get all the items we have, sort them by their priority,
     * if priority is same, sort them by their last visited time
     * pop out items from the low priority (5 is the lowest)
     *
     * @private
     * @param keys - all the keys in this cache
     * @param sizeToPop - the total size of the items which needed to be poped out
     */ BrowserStorageCache.prototype._popOutItems = function(keys, sizeToPop) {
        var items = [];
        var remainedSize = sizeToPop;
        // get the items from Storage
        for(var i = 0; i < keys.length; i += 1){
            var val = this.config.storage.getItem(keys[i]);
            if (val != null) {
                var item = JSON.parse(val);
                items.push(item);
            }
        }
        // first compare priority
        // then compare visited time
        items.sort(function(a, b) {
            if (a.priority > b.priority) return -1;
            else if (a.priority < b.priority) return 1;
            else {
                if (a.visitedTime < b.visitedTime) return -1;
                else return 1;
            }
        });
        for(var i = 0; i < items.length; i += 1){
            // pop out items until we have enough room for new item
            this._removeItem(items[i].key, items[i].byteSize);
            remainedSize -= items[i].byteSize;
            if (remainedSize <= 0) return;
        }
    };
    /**
     * Set item into cache. You can put number, string, boolean or object.
     * The cache will first check whether has the same key.
     * If it has, it will delete the old item and then put the new item in
     * The cache will pop out items if it is full
     * You can specify the cache item options. The cache will abort and output a warning:
     * If the key is invalid
     * If the size of the item exceeds itemMaxSize.
     * If the value is undefined
     * If incorrect cache item configuration
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param value - the value of the item
     * @param {Object} [options] - optional, the specified meta-data
     */ BrowserStorageCache.prototype.setItem = function(key, value, options) {
        $437d538d1f3a2112$var$logger.log("Set item: key is " + key + ", value is " + value + " with options: " + options);
        var prefixedKey = this.config.keyPrefix + key;
        // invalid keys
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            $437d538d1f3a2112$var$logger.warn("Invalid key: should not be empty or 'CurSize'");
            return;
        }
        if (typeof value === "undefined") {
            $437d538d1f3a2112$var$logger.warn("The value of item should not be undefined!");
            return;
        }
        var cacheItemOptions = {
            priority: options && options.priority !== undefined ? options.priority : this.config.defaultPriority,
            expires: options && options.expires !== undefined ? options.expires : this.config.defaultTTL + (0, $f2Vmk.getCurrTime)()
        };
        if (cacheItemOptions.priority < 1 || cacheItemOptions.priority > 5) {
            $437d538d1f3a2112$var$logger.warn("Invalid parameter: priority due to out or range. It should be within 1 and 5.");
            return;
        }
        var item = this.fillCacheItem(prefixedKey, value, cacheItemOptions);
        // check wether this item is too big;
        if (item.byteSize > this.config.itemMaxSize) {
            $437d538d1f3a2112$var$logger.warn("Item with key: " + key + " you are trying to put into is too big!");
            return;
        }
        try {
            // first look into the storage, if it exists, delete it.
            var val = this.config.storage.getItem(prefixedKey);
            if (val) this._removeItem(prefixedKey, JSON.parse(val).byteSize);
            // check whether the cache is full
            if (this._isCacheFull(item.byteSize)) {
                var validKeys = this._findValidKeys();
                // check again and then pop out items
                if (this._isCacheFull(item.byteSize)) {
                    var sizeToPop = this._sizeToPop(item.byteSize);
                    this._popOutItems(validKeys, sizeToPop);
                }
            }
            // put item in the cache
            // may failed due to storage full
            this._setItem(prefixedKey, item);
        } catch (e) {
            $437d538d1f3a2112$var$logger.warn("setItem failed! " + e);
        }
    };
    /**
     * Get item from cache. It will return null if item doesn’t exist or it has been expired.
     * If you specified callback function in the options,
     * then the function will be executed if no such item in the cache
     * and finally put the return value into cache.
     * Please make sure the callback function will return the value you want to put into the cache.
     * The cache will abort output a warning:
     * If the key is invalid
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param {Object} [options] - the options of callback function
     *
     * @return - return the value of the item
     */ BrowserStorageCache.prototype.getItem = function(key, options) {
        $437d538d1f3a2112$var$logger.log("Get item: key is " + key + " with options " + options);
        var ret = null;
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            $437d538d1f3a2112$var$logger.warn("Invalid key: should not be empty or 'CurSize'");
            return null;
        }
        try {
            ret = this.config.storage.getItem(prefixedKey);
            if (ret != null) {
                if (this._isExpired(prefixedKey)) {
                    // if expired, remove that item and return null
                    this._removeItem(prefixedKey, JSON.parse(ret).byteSize);
                    ret = null;
                } else {
                    // if not expired, great, return the value and refresh it
                    var item = JSON.parse(ret);
                    item = this._refreshItem(item, prefixedKey);
                    return item.data;
                }
            }
            if (options && options.callback !== undefined) {
                var val = options.callback();
                if (val !== null) this.setItem(key, val, options);
                return val;
            }
            return null;
        } catch (e) {
            $437d538d1f3a2112$var$logger.warn("getItem failed! " + e);
            return null;
        }
    };
    /**
     * remove item from the cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     * @param key - the key of the item
     */ BrowserStorageCache.prototype.removeItem = function(key) {
        $437d538d1f3a2112$var$logger.log("Remove item: key is " + key);
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) return;
        try {
            var val = this.config.storage.getItem(prefixedKey);
            if (val) this._removeItem(prefixedKey, JSON.parse(val).byteSize);
        } catch (e) {
            $437d538d1f3a2112$var$logger.warn("removeItem failed! " + e);
        }
    };
    /**
     * clear the entire cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     */ BrowserStorageCache.prototype.clear = function() {
        $437d538d1f3a2112$var$logger.log("Clear Cache");
        var keysToRemove = [];
        for(var i = 0; i < this.config.storage.length; i += 1){
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0) keysToRemove.push(key);
        }
        try {
            for(var i = 0; i < keysToRemove.length; i += 1)this.config.storage.removeItem(keysToRemove[i]);
        } catch (e) {
            $437d538d1f3a2112$var$logger.warn("clear failed! " + e);
        }
    };
    /**
     * Return all the keys in the cache.
     *
     * @return - all keys in the cache
     */ BrowserStorageCache.prototype.getAllKeys = function() {
        var keys = [];
        for(var i = 0; i < this.config.storage.length; i += 1){
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0 && key !== this.cacheCurSizeKey) keys.push(key.substring(this.config.keyPrefix.length));
        }
        return keys;
    };
    /**
     * return the current size of the cache
     *
     * @return - current size of the cache
     */ BrowserStorageCache.prototype.getCacheCurSize = function() {
        var ret = this.config.storage.getItem(this.cacheCurSizeKey);
        if (!ret) {
            this.config.storage.setItem(this.cacheCurSizeKey, "0");
            ret = "0";
        }
        return Number(ret);
    };
    /**
     * Return a new instance of cache with customized configuration.
     * @param config - the customized configuration
     *
     * @return - new instance of Cache
     */ BrowserStorageCache.prototype.createInstance = function(config) {
        if (!config.keyPrefix || config.keyPrefix === (0, $f2Vmk.defaultConfig).keyPrefix) {
            $437d538d1f3a2112$var$logger.error("invalid keyPrefix, setting keyPrefix with timeStamp");
            config.keyPrefix = (0, $f2Vmk.getCurrTime).toString();
        }
        return new BrowserStorageCache(config);
    };
    return BrowserStorageCache;
}((0, $lGOOD.default));
var $437d538d1f3a2112$var$instance = new $437d538d1f3a2112$export$2a9787695d97e2c4();
var $437d538d1f3a2112$export$2e2bcd8739ae039 = $437d538d1f3a2112$var$instance;

});
parcelRequire.register("4IJD3", function(module, exports) {
$parcel$export(module.exports, "CacheObject", function () { return (parcelRequire("f2Vmk")).CacheObject; });
$parcel$export(module.exports, "defaultConfig", function () { return (parcelRequire("f2Vmk")).defaultConfig; });
$parcel$export(module.exports, "getByteLength", function () { return (parcelRequire("f2Vmk")).getByteLength; });
$parcel$export(module.exports, "getCurrTime", function () { return (parcelRequire("f2Vmk")).getCurrTime; });
$parcel$export(module.exports, "isInteger", function () { return (parcelRequire("f2Vmk")).isInteger; });

$parcel$export(module.exports, "CacheList", function () { return (parcelRequire("bjsWh")).default; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("f2Vmk");

var $bjsWh = parcelRequire("bjsWh");

});
parcelRequire.register("f2Vmk", function(module, exports) {

$parcel$export(module.exports, "defaultConfig", function () { return $af43893fce96bebc$export$f84bd70098573c5c; });
$parcel$export(module.exports, "getByteLength", function () { return $af43893fce96bebc$export$cc8c3b705bb8e6e2; });
$parcel$export(module.exports, "getCurrTime", function () { return $af43893fce96bebc$export$dd144842d7b22d3a; });
$parcel$export(module.exports, "isInteger", function () { return $af43893fce96bebc$export$a287f47fed4544b8; });
$parcel$export(module.exports, "CacheObject", function () { return $af43893fce96bebc$export$2dd5b9e5ba192a1a; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("2hWDt");
var $33IrZ = parcelRequire("33IrZ");
var $af43893fce96bebc$export$f84bd70098573c5c = {
    keyPrefix: "aws-amplify-cache",
    capacityInBytes: 1048576,
    itemMaxSize: 210000,
    defaultTTL: 259200000,
    defaultPriority: 5,
    warningThreshold: 0.8,
    // the storage helper will check if localStorage exists,
    // if not, will use a in-memory object instead
    storage: new (0, $33IrZ.default)().getStorage()
};
function $af43893fce96bebc$export$cc8c3b705bb8e6e2(str) {
    var ret = 0;
    ret = str.length;
    for(var i = str.length; i >= 0; i -= 1){
        var charCode = str.charCodeAt(i);
        if (charCode > 0x7f && charCode <= 0x7ff) ret += 1;
        else if (charCode > 0x7ff && charCode <= 0xffff) ret += 2;
        // trail surrogate
        if (charCode >= 0xdc00 && charCode <= 0xdfff) i -= 1;
    }
    return ret;
}
function $af43893fce96bebc$export$dd144842d7b22d3a() {
    var currTime = new Date();
    return currTime.getTime();
}
function $af43893fce96bebc$export$a287f47fed4544b8(value) {
    if (Number.isInteger) return Number.isInteger(value);
    return $af43893fce96bebc$var$_isInteger(value);
}
function $af43893fce96bebc$var$_isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
}
/**
 * provide an object as the in-memory cache
 */ var $af43893fce96bebc$var$store = {};
var $af43893fce96bebc$export$2dd5b9e5ba192a1a = /** @class */ function() {
    function CacheObject() {}
    CacheObject.clear = function() {
        $af43893fce96bebc$var$store = {};
    };
    CacheObject.getItem = function(key) {
        return $af43893fce96bebc$var$store[key] || null;
    };
    CacheObject.setItem = function(key, value) {
        $af43893fce96bebc$var$store[key] = value;
    };
    CacheObject.removeItem = function(key) {
        delete $af43893fce96bebc$var$store[key];
    };
    return CacheObject;
}();

});

parcelRequire.register("bjsWh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83c7eabe452c455c$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $83c7eabe452c455c$var$DoubleLinkedNode = /** @class */ function() {
    function DoubleLinkedNode(keyVal) {
        this.key = keyVal ? keyVal : "";
        this.prevNode = null;
        this.nextNode = null;
    }
    return DoubleLinkedNode;
}();
/**
 * double linked list plus a hash table inside
 * each key in the cache stored as a node in the list
 * recently visited node will be rotated to the head
 * so the Last Recently Visited node will be at the tail
 *
 * @member head - dummy head of the linked list
 * @member tail - dummy tail of the linked list
 * @member hashtable - the hashtable which maps cache key to list node
 * @member length - length of the list
 */ var $83c7eabe452c455c$var$CacheList = /** @class */ function() {
    /**
     * initialization
     */ function CacheList() {
        this.head = new $83c7eabe452c455c$var$DoubleLinkedNode();
        this.tail = new $83c7eabe452c455c$var$DoubleLinkedNode();
        this.hashtable = {};
        this.length = 0;
        this.head.nextNode = this.tail;
        this.tail.prevNode = this.head;
    }
    /**
     * insert node to the head of the list
     *
     * @param node
     */ CacheList.prototype.insertNodeToHead = function(node) {
        var tmp = this.head.nextNode;
        this.head.nextNode = node;
        node.nextNode = tmp;
        node.prevNode = this.head;
        tmp.prevNode = node;
        this.length = this.length + 1;
    };
    /**
     * remove node
     *
     * @param node
     */ CacheList.prototype.removeNode = function(node) {
        node.prevNode.nextNode = node.nextNode;
        node.nextNode.prevNode = node.prevNode;
        node.prevNode = null;
        node.nextNode = null;
        this.length = this.length - 1;
    };
    /**
     * @return true if list is empty
     */ CacheList.prototype.isEmpty = function() {
        return this.length === 0;
    };
    /**
     * refresh node so it is rotated to the head
     *
     * @param key - key of the node
     */ CacheList.prototype.refresh = function(key) {
        var node = this.hashtable[key];
        this.removeNode(node);
        this.insertNodeToHead(node);
    };
    /**
     * insert new node to the head and add it in the hashtable
     *
     * @param key - the key of the node
     */ CacheList.prototype.insertItem = function(key) {
        var node = new $83c7eabe452c455c$var$DoubleLinkedNode(key);
        this.hashtable[key] = node;
        this.insertNodeToHead(node);
    };
    /**
     * @return the LAST Recently Visited key
     */ CacheList.prototype.getLastItem = function() {
        return this.tail.prevNode.key;
    };
    /**
     * remove the cache key from the list and hashtable
     * @param key - the key of the node
     */ CacheList.prototype.removeItem = function(key) {
        var removedItem = this.hashtable[key];
        this.removeNode(removedItem);
        delete this.hashtable[key];
    };
    /**
     * @return length of the list
     */ CacheList.prototype.getSize = function() {
        return this.length;
    };
    /**
     * @return true if the key is in the hashtable
     * @param key
     */ CacheList.prototype.containsKey = function(key) {
        return key in this.hashtable;
    };
    /**
     * clean up the list and hashtable
     */ CacheList.prototype.clearList = function() {
        for(var _i = 0, _a = Object.keys(this.hashtable); _i < _a.length; _i++){
            var key = _a[_i];
            if (this.hashtable.hasOwnProperty(key)) delete this.hashtable[key];
        }
        this.head.nextNode = this.tail;
        this.tail.prevNode = this.head;
        this.length = 0;
    };
    /**
     * @return all keys in the hashtable
     */ CacheList.prototype.getKeys = function() {
        return Object.keys(this.hashtable);
    };
    /**
     * mainly for test
     *
     * @param key
     * @return true if key is the head node
     */ CacheList.prototype.isHeadNode = function(key) {
        var node = this.hashtable[key];
        return node.prevNode === this.head;
    };
    /**
     * mainly for test
     *
     * @param key
     * @return true if key is the tail node
     */ CacheList.prototype.isTailNode = function(key) {
        var node = this.hashtable[key];
        return node.nextNode === this.tail;
    };
    return CacheList;
}();
var $83c7eabe452c455c$export$2e2bcd8739ae039 = $83c7eabe452c455c$var$CacheList;

});


parcelRequire.register("lGOOD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fca4f02587ec9f6a$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("4IJD3");
var $f2Vmk = parcelRequire("f2Vmk");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $fca4f02587ec9f6a$var$logger = new (0, $gBqCF.ConsoleLogger)("StorageCache");
/**
 * Initialization of the cache
 *
 */ var $fca4f02587ec9f6a$var$StorageCache = /** @class */ function() {
    /**
     * Initialize the cache
     * @param config - the configuration of the cache
     */ function StorageCache(config) {
        this.config = Object.assign({}, config);
        this.cacheCurSizeKey = this.config.keyPrefix + "CurSize";
        this.checkConfig();
    }
    StorageCache.prototype.getModuleName = function() {
        return "Cache";
    };
    StorageCache.prototype.checkConfig = function() {
        // check configuration
        if (!(0, $f2Vmk.isInteger)(this.config.capacityInBytes)) {
            $fca4f02587ec9f6a$var$logger.error("Invalid parameter: capacityInBytes. It should be an Integer. Setting back to default.");
            this.config.capacityInBytes = (0, $f2Vmk.defaultConfig).capacityInBytes;
        }
        if (!(0, $f2Vmk.isInteger)(this.config.itemMaxSize)) {
            $fca4f02587ec9f6a$var$logger.error("Invalid parameter: itemMaxSize. It should be an Integer. Setting back to default.");
            this.config.itemMaxSize = (0, $f2Vmk.defaultConfig).itemMaxSize;
        }
        if (!(0, $f2Vmk.isInteger)(this.config.defaultTTL)) {
            $fca4f02587ec9f6a$var$logger.error("Invalid parameter: defaultTTL. It should be an Integer. Setting back to default.");
            this.config.defaultTTL = (0, $f2Vmk.defaultConfig).defaultTTL;
        }
        if (!(0, $f2Vmk.isInteger)(this.config.defaultPriority)) {
            $fca4f02587ec9f6a$var$logger.error("Invalid parameter: defaultPriority. It should be an Integer. Setting back to default.");
            this.config.defaultPriority = (0, $f2Vmk.defaultConfig).defaultPriority;
        }
        if (this.config.itemMaxSize > this.config.capacityInBytes) {
            $fca4f02587ec9f6a$var$logger.error("Invalid parameter: itemMaxSize. It should be smaller than capacityInBytes. Setting back to default.");
            this.config.itemMaxSize = (0, $f2Vmk.defaultConfig).itemMaxSize;
        }
        if (this.config.defaultPriority > 5 || this.config.defaultPriority < 1) {
            $fca4f02587ec9f6a$var$logger.error("Invalid parameter: defaultPriority. It should be between 1 and 5. Setting back to default.");
            this.config.defaultPriority = (0, $f2Vmk.defaultConfig).defaultPriority;
        }
        if (Number(this.config.warningThreshold) > 1 || Number(this.config.warningThreshold) < 0) {
            $fca4f02587ec9f6a$var$logger.error("Invalid parameter: warningThreshold. It should be between 0 and 1. Setting back to default.");
            this.config.warningThreshold = (0, $f2Vmk.defaultConfig).warningThreshold;
        }
        // set 5MB limit
        var cacheLimit = 5242880;
        if (this.config.capacityInBytes > cacheLimit) {
            $fca4f02587ec9f6a$var$logger.error("Cache Capacity should be less than 5MB. Setting back to default. Setting back to default.");
            this.config.capacityInBytes = (0, $f2Vmk.defaultConfig).capacityInBytes;
        }
    };
    /**
     * produce a JSON object with meta-data and data value
     * @param value - the value of the item
     * @param options - optional, the specified meta-data
     *
     * @return - the item which has the meta-data and the value
     */ StorageCache.prototype.fillCacheItem = function(key, value, options) {
        var ret = {
            key: key,
            data: value,
            timestamp: (0, $f2Vmk.getCurrTime)(),
            visitedTime: (0, $f2Vmk.getCurrTime)(),
            priority: options.priority,
            expires: options.expires,
            type: typeof value,
            byteSize: 0
        };
        ret.byteSize = (0, $f2Vmk.getByteLength)(JSON.stringify(ret));
        // for accurate size
        ret.byteSize = (0, $f2Vmk.getByteLength)(JSON.stringify(ret));
        return ret;
    };
    /**
     * set cache with customized configuration
     * @param config - customized configuration
     *
     * @return - the current configuration
     */ StorageCache.prototype.configure = function(config) {
        if (!config) return this.config;
        if (config.keyPrefix) $fca4f02587ec9f6a$var$logger.warn("Don't try to configure keyPrefix!");
        this.config = Object.assign({}, this.config, config, config.Cache);
        this.checkConfig();
        return this.config;
    };
    return StorageCache;
}();
var $fca4f02587ec9f6a$export$2e2bcd8739ae039 = $fca4f02587ec9f6a$var$StorageCache;

});


parcelRequire.register("kMkaR", function(module, exports) {
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("4IJD3");
var $f2Vmk = parcelRequire("f2Vmk");
var $bjsWh = parcelRequire("bjsWh");

var $lGOOD = parcelRequire("lGOOD");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $f207f088f9180d9b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f207f088f9180d9b$var$logger = new (0, $gBqCF.ConsoleLogger)("InMemoryCache");
/**
 * Customized in-memory cache with LRU implemented
 * @member cacheObj - object which store items
 * @member cacheList - list of keys in the cache with LRU
 * @member curSizeInBytes - current size of the cache
 * @member maxPriority - max of the priority
 * @member cacheSizeLimit - the limit of cache size
 */ var $f207f088f9180d9b$export$467265324939f47f = /** @class */ function(_super) {
    $f207f088f9180d9b$var$__extends(InMemoryCache, _super);
    /**
     * initialize the cache
     *
     * @param config - the configuration of the cache
     */ function InMemoryCache(config) {
        var _this = this;
        var cacheConfig = config ? Object.assign({}, (0, $f2Vmk.defaultConfig), config) : (0, $f2Vmk.defaultConfig);
        _this = _super.call(this, cacheConfig) || this;
        $f207f088f9180d9b$var$logger.debug("now we start!");
        _this.cacheList = [];
        _this.curSizeInBytes = 0;
        _this.maxPriority = 5;
        _this.getItem = _this.getItem.bind(_this);
        _this.setItem = _this.setItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        // initialize list for every priority
        for(var i = 0; i < _this.maxPriority; i += 1)_this.cacheList[i] = new (0, $bjsWh.default)();
        return _this;
    }
    /**
     * decrease current size of the cache
     *
     * @param amount - the amount of the cache size which needs to be decreased
     */ InMemoryCache.prototype._decreaseCurSizeInBytes = function(amount) {
        this.curSizeInBytes -= amount;
    };
    /**
     * increase current size of the cache
     *
     * @param amount - the amount of the cache szie which need to be increased
     */ InMemoryCache.prototype._increaseCurSizeInBytes = function(amount) {
        this.curSizeInBytes += amount;
    };
    /**
     * check whether item is expired
     *
     * @param key - the key of the item
     *
     * @return true if the item is expired.
     */ InMemoryCache.prototype._isExpired = function(key) {
        var text = (0, $f2Vmk.CacheObject).getItem(key);
        var item = JSON.parse(text);
        if ((0, $f2Vmk.getCurrTime)() >= item.expires) return true;
        return false;
    };
    /**
     * delete item from cache
     *
     * @param prefixedKey - the key of the item
     * @param listIdx - indicates which cache list the key belongs to
     */ InMemoryCache.prototype._removeItem = function(prefixedKey, listIdx) {
        // delete the key from the list
        this.cacheList[listIdx].removeItem(prefixedKey);
        // decrease the current size of the cache
        this._decreaseCurSizeInBytes(JSON.parse((0, $f2Vmk.CacheObject).getItem(prefixedKey)).byteSize);
        // finally remove the item from memory
        (0, $f2Vmk.CacheObject).removeItem(prefixedKey);
    };
    /**
     * put item into cache
     *
     * @param prefixedKey - the key of the item
     * @param itemData - the value of the item
     * @param itemSizeInBytes - the byte size of the item
     * @param listIdx - indicates which cache list the key belongs to
     */ InMemoryCache.prototype._setItem = function(prefixedKey, item, listIdx) {
        // insert the key into the list
        this.cacheList[listIdx].insertItem(prefixedKey);
        // increase the current size of the cache
        this._increaseCurSizeInBytes(item.byteSize);
        // finally add the item into memory
        (0, $f2Vmk.CacheObject).setItem(prefixedKey, JSON.stringify(item));
    };
    /**
     * see whether cache is full
     *
     * @param itemSize
     *
     * @return true if cache is full
     */ InMemoryCache.prototype._isCacheFull = function(itemSize) {
        return this.curSizeInBytes + itemSize > this.config.capacityInBytes;
    };
    /**
     * check whether the cache contains the key
     *
     * @param key
     */ InMemoryCache.prototype.containsKey = function(key) {
        var prefixedKey = this.config.keyPrefix + key;
        for(var i = 0; i < this.maxPriority; i += 1){
            if (this.cacheList[i].containsKey(prefixedKey)) return i + 1;
        }
        return -1;
    };
    /**
     * * Set item into cache. You can put number, string, boolean or object.
     * The cache will first check whether has the same key.
     * If it has, it will delete the old item and then put the new item in
     * The cache will pop out items if it is full
     * You can specify the cache item options. The cache will abort and output a warning:
     * If the key is invalid
     * If the size of the item exceeds itemMaxSize.
     * If the value is undefined
     * If incorrect cache item configuration
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param value - the value of the item
     * @param options - optional, the specified meta-data
     *
     * @throws if the item is too big which exceeds the limit of single item size
     * @throws if the key is invalid
     */ InMemoryCache.prototype.setItem = function(key, value, options) {
        var prefixedKey = this.config.keyPrefix + key;
        // invalid keys
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            $f207f088f9180d9b$var$logger.warn("Invalid key: should not be empty or 'CurSize'");
            return;
        }
        if (typeof value === "undefined") {
            $f207f088f9180d9b$var$logger.warn("The value of item should not be undefined!");
            return;
        }
        var cacheItemOptions = {
            priority: options && options.priority !== undefined ? options.priority : this.config.defaultPriority,
            expires: options && options.expires !== undefined ? options.expires : this.config.defaultTTL + (0, $f2Vmk.getCurrTime)()
        };
        if (cacheItemOptions.priority < 1 || cacheItemOptions.priority > 5) {
            $f207f088f9180d9b$var$logger.warn("Invalid parameter: priority due to out or range. It should be within 1 and 5.");
            return;
        }
        var item = this.fillCacheItem(prefixedKey, value, cacheItemOptions);
        // check wether this item is too big;
        if (item.byteSize > this.config.itemMaxSize) {
            $f207f088f9180d9b$var$logger.warn("Item with key: " + key + " you are trying to put into is too big!");
            return;
        }
        // if key already in the cache, then delete it.
        var presentKeyPrio = this.containsKey(key);
        if (presentKeyPrio !== -1) this._removeItem(prefixedKey, presentKeyPrio - 1);
        // pop out items in the cache when cache is full based on LRU
        // first start from lowest priority cache list
        var cacheListIdx = this.maxPriority - 1;
        while(this._isCacheFull(item.byteSize) && cacheListIdx >= 0)if (!this.cacheList[cacheListIdx].isEmpty()) {
            var popedItemKey = this.cacheList[cacheListIdx].getLastItem();
            this._removeItem(popedItemKey, cacheListIdx);
        } else cacheListIdx -= 1;
        this._setItem(prefixedKey, item, Number(item.priority) - 1);
    };
    /**
     * Get item from cache. It will return null if item doesn’t exist or it has been expired.
     * If you specified callback function in the options,
     * then the function will be executed if no such item in the cache
     * and finally put the return value into cache.
     * Please make sure the callback function will return the value you want to put into the cache.
     * The cache will abort output a warning:
     * If the key is invalid
     *
     * @param key - the key of the item
     * @param options - the options of callback function
     */ InMemoryCache.prototype.getItem = function(key, options) {
        var ret = null;
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix || prefixedKey === this.cacheCurSizeKey) {
            $f207f088f9180d9b$var$logger.warn("Invalid key: should not be empty or 'CurSize'");
            return null;
        }
        // check whether it's in the cachelist
        var presentKeyPrio = this.containsKey(key);
        if (presentKeyPrio !== -1) {
            if (this._isExpired(prefixedKey)) // if expired, remove that item and return null
            this._removeItem(prefixedKey, presentKeyPrio - 1);
            else {
                // if not expired, great, return the value and refresh it
                ret = (0, $f2Vmk.CacheObject).getItem(prefixedKey);
                var item = JSON.parse(ret);
                this.cacheList[item.priority - 1].refresh(prefixedKey);
                return item.data;
            }
        }
        if (options && options.callback !== undefined) {
            var val = options.callback();
            if (val !== null) this.setItem(key, val, options);
            return val;
        }
        return null;
    };
    /**
     * remove item from the cache
     *
     * @param key - the key of the item
     */ InMemoryCache.prototype.removeItem = function(key) {
        var prefixedKey = this.config.keyPrefix + key;
        // check if the key is in the cache
        var presentKeyPrio = this.containsKey(key);
        if (presentKeyPrio !== -1) this._removeItem(prefixedKey, presentKeyPrio - 1);
    };
    /**
     * clear the entire cache
     */ InMemoryCache.prototype.clear = function() {
        for(var i = 0; i < this.maxPriority; i += 1)for(var _i = 0, _a = this.cacheList[i].getKeys(); _i < _a.length; _i++){
            var key = _a[_i];
            this._removeItem(key, i);
        }
    };
    /**
     * Return all the keys in the cache.
     */ InMemoryCache.prototype.getAllKeys = function() {
        var keys = [];
        for(var i = 0; i < this.maxPriority; i += 1)for(var _i = 0, _a = this.cacheList[i].getKeys(); _i < _a.length; _i++){
            var key = _a[_i];
            keys.push(key.substring(this.config.keyPrefix.length));
        }
        return keys;
    };
    /**
     * return the current size of the cache
     *
     * @return the current size of the cache
     */ InMemoryCache.prototype.getCacheCurSize = function() {
        return this.curSizeInBytes;
    };
    /**
     * Return a new instance of cache with customized configuration.
     * @param config - the customized configuration
     */ InMemoryCache.prototype.createInstance = function(config) {
        return new InMemoryCache(config);
    };
    return InMemoryCache;
}((0, $lGOOD.default));
var $f207f088f9180d9b$var$instance = new $f207f088f9180d9b$export$467265324939f47f();
var $f207f088f9180d9b$export$2e2bcd8739ae039 = $f207f088f9180d9b$var$instance;

});


parcelRequire.register("32hwF", function(module, exports) {

var $1eMZI = parcelRequire("1eMZI");

var $aMUyp = parcelRequire("aMUyp");
var $235f274398e0a43b$var$uuid = $aMUyp;
$235f274398e0a43b$var$uuid.v1 = $1eMZI;
$235f274398e0a43b$var$uuid.v4 = $aMUyp;
module.exports = $235f274398e0a43b$var$uuid;

});
parcelRequire.register("1eMZI", function(module, exports) {

var $bjqhW = parcelRequire("bjqhW");

var $5mtiB = parcelRequire("5mtiB");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $0e6d1a84eab8c868$var$_nodeId;
var $0e6d1a84eab8c868$var$_clockseq;
// Previous uuid creation time
var $0e6d1a84eab8c868$var$_lastMSecs = 0;
var $0e6d1a84eab8c868$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $0e6d1a84eab8c868$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $0e6d1a84eab8c868$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $0e6d1a84eab8c868$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $bjqhW();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $0e6d1a84eab8c868$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $0e6d1a84eab8c868$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $0e6d1a84eab8c868$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $0e6d1a84eab8c868$var$_lastMSecs + (nsecs - $0e6d1a84eab8c868$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $0e6d1a84eab8c868$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $0e6d1a84eab8c868$var$_lastMSecs = msecs;
    $0e6d1a84eab8c868$var$_lastNSecs = nsecs;
    $0e6d1a84eab8c868$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $5mtiB(b);
}
module.exports = $0e6d1a84eab8c868$var$v1;

});
parcelRequire.register("bjqhW", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $83c5dc65e6998f1d$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($83c5dc65e6998f1d$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $83c5dc65e6998f1d$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $83c5dc65e6998f1d$var$getRandomValues($83c5dc65e6998f1d$var$rnds8);
        return $83c5dc65e6998f1d$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $83c5dc65e6998f1d$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $83c5dc65e6998f1d$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $83c5dc65e6998f1d$var$rnds;
    };
}

});

parcelRequire.register("5mtiB", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $3e75bc070e0ac111$var$byteToHex = [];
for(var $3e75bc070e0ac111$var$i = 0; $3e75bc070e0ac111$var$i < 256; ++$3e75bc070e0ac111$var$i)$3e75bc070e0ac111$var$byteToHex[$3e75bc070e0ac111$var$i] = ($3e75bc070e0ac111$var$i + 0x100).toString(16).substr(1);
function $3e75bc070e0ac111$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $3e75bc070e0ac111$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $3e75bc070e0ac111$var$bytesToUuid;

});


parcelRequire.register("aMUyp", function(module, exports) {

var $bjqhW = parcelRequire("bjqhW");

var $5mtiB = parcelRequire("5mtiB");
function $7daa4187008c5684$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $bjqhW)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $5mtiB(rnds);
}
module.exports = $7daa4187008c5684$var$v4;

});


parcelRequire.register("d7nsV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98ce21997b904f8d$export$2e2bcd8739ae039; });
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $98ce21997b904f8d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $98ce21997b904f8d$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $98ce21997b904f8d$var$logger = new (0, $gBqCF.ConsoleLogger)("EventsBuffer");
var $98ce21997b904f8d$var$RETRYABLE_CODES = [
    429,
    500
];
var $98ce21997b904f8d$var$ACCEPTED_CODES = [
    202
];
var $98ce21997b904f8d$var$EventsBuffer = /** @class */ function() {
    function EventsBuffer(client, config) {
        this._pause = false;
        this._flush = false;
        $98ce21997b904f8d$var$logger.debug("Instantiating buffer with config:", config);
        this._buffer = [];
        this._client = client;
        this._config = config;
        this._sendBatch = this._sendBatch.bind(this);
        this._startLoop();
    }
    EventsBuffer.prototype.push = function(event) {
        var _a;
        if (this._buffer > this._config.bufferSize) {
            $98ce21997b904f8d$var$logger.debug("Exceeded analytics events buffer size");
            return event.handlers.reject(new Error("Exceeded the size of analytics events buffer"));
        }
        var eventId = event.params.event.eventId;
        var bufferElement = (_a = {}, _a[eventId] = event, _a);
        this._buffer.push(bufferElement);
    };
    EventsBuffer.prototype.pause = function() {
        this._pause = true;
    };
    EventsBuffer.prototype.resume = function() {
        this._pause = false;
    };
    EventsBuffer.prototype.updateClient = function(client) {
        this._client = client;
    };
    EventsBuffer.prototype.flush = function() {
        this._flush = true;
    };
    EventsBuffer.prototype._startLoop = function() {
        if (this._interval) clearInterval(this._interval);
        var flushInterval = this._config.flushInterval;
        this._interval = setInterval(this._sendBatch, flushInterval);
    };
    EventsBuffer.prototype._sendBatch = function() {
        var bufferLength = this._buffer.length;
        if (this._flush && !bufferLength) clearInterval(this._interval);
        if (this._pause || !bufferLength) return;
        var flushSize = this._config.flushSize;
        var batchSize = Math.min(flushSize, bufferLength);
        var bufferSubset = this._buffer.splice(0, batchSize);
        this._putEvents(bufferSubset);
    };
    EventsBuffer.prototype._putEvents = function(buffer) {
        return $98ce21997b904f8d$var$__awaiter(this, void 0, void 0, function() {
            var eventMap, batchEventParams, data, err_1;
            return $98ce21997b904f8d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        eventMap = this._bufferToMap(buffer);
                        batchEventParams = this._generateBatchEventParams(eventMap);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._client.putEvents(batchEventParams).promise()
                        ];
                    case 2:
                        data = _a.sent();
                        this._processPutEventsSuccessResponse(data, eventMap);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            this._handlePutEventsFailure(err_1, eventMap)
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    EventsBuffer.prototype._generateBatchEventParams = function(eventMap) {
        var batchEventParams = {
            ApplicationId: "",
            EventsRequest: {
                BatchItem: {}
            }
        };
        Object.values(eventMap).forEach(function(item) {
            var params = item.params;
            var event = params.event, timestamp = params.timestamp, config = params.config;
            var name = event.name, attributes = event.attributes, metrics = event.metrics, eventId = event.eventId, session = event.session;
            var appId = config.appId, endpointId = config.endpointId;
            var batchItem = batchEventParams.EventsRequest.BatchItem;
            batchEventParams.ApplicationId = batchEventParams.ApplicationId || appId;
            if (!batchItem[endpointId]) batchItem[endpointId] = {
                Endpoint: {},
                Events: {}
            };
            batchItem[endpointId].Events[eventId] = {
                EventType: name,
                Timestamp: new Date(timestamp).toISOString(),
                Attributes: attributes,
                Metrics: metrics,
                Session: session
            };
        });
        return batchEventParams;
    };
    EventsBuffer.prototype._handlePutEventsFailure = function(err, eventMap) {
        $98ce21997b904f8d$var$logger.debug("_putEvents Failed:", err);
        var statusCode = err.statusCode;
        if ($98ce21997b904f8d$var$RETRYABLE_CODES.includes(statusCode)) {
            var retryableEvents = Object.values(eventMap);
            this._retry(retryableEvents);
            return;
        }
    };
    EventsBuffer.prototype._processPutEventsSuccessResponse = function(data, eventMap) {
        var Results = data.EventsResponse.Results;
        var retryableEvents = [];
        Object.entries(Results).forEach(function(_a) {
            var endpointId = _a[0], endpointValues = _a[1];
            var responses = endpointValues.EventsItemResponse;
            Object.entries(responses).forEach(function(_a) {
                var _b, _c;
                var eventId = _a[0], _d = _a[1], StatusCode = _d.StatusCode, Message = _d.Message;
                var eventObject = eventMap[eventId];
                // manually crafting handlers response to keep API consistant
                var response = {
                    EventsResponse: {
                        Results: (_b = {}, _b[endpointId] = {
                            EventsItemResponse: (_c = {}, _c[eventId] = {
                                StatusCode: StatusCode,
                                Message: Message
                            }, _c)
                        }, _b)
                    }
                };
                if ($98ce21997b904f8d$var$ACCEPTED_CODES.includes(StatusCode)) {
                    eventObject.handlers.resolve(response);
                    return;
                }
                if ($98ce21997b904f8d$var$RETRYABLE_CODES.includes(StatusCode)) {
                    retryableEvents.push(eventObject);
                    return;
                }
                var name = eventObject.params.event.name;
                $98ce21997b904f8d$var$logger.error("event " + eventId + " : " + name + " failed with error: " + Message);
                return eventObject.handlers.reject(response);
            });
        });
        if (retryableEvents.length) this._retry(retryableEvents);
    };
    EventsBuffer.prototype._retry = function(retryableEvents) {
        var _a;
        // retryable events that haven't reached the resendLimit
        var eligibleEvents = [];
        retryableEvents.forEach(function(event) {
            var _a;
            var params = event.params;
            var _b = params.event, eventId = _b.eventId, name = _b.name;
            if (params.resendLimit-- > 0) {
                $98ce21997b904f8d$var$logger.debug("resending event " + eventId + " : " + name + " with " + params.resendLimit + " retry attempts remaining");
                eligibleEvents.push((_a = {}, _a[eventId] = event, _a));
                return;
            }
            $98ce21997b904f8d$var$logger.debug("no retry attempts remaining for event " + eventId + " : " + name);
        });
        // add the events to the front of the buffer
        (_a = this._buffer).unshift.apply(_a, eligibleEvents);
    };
    // convert buffer to map, i.e. { eventId1: { params, handler }, eventId2: { params, handlers } }
    // this allows us to easily access the handlers after receiving a batch response
    EventsBuffer.prototype._bufferToMap = function(buffer) {
        return buffer.reduce(function(acc, curVal) {
            var _a = Object.entries(curVal)[0], key = _a[0], value = _a[1];
            acc[key] = value;
            return acc;
        }, {});
    };
    return EventsBuffer;
}();
var $98ce21997b904f8d$export$2e2bcd8739ae039 = $98ce21997b904f8d$var$EventsBuffer;

});


parcelRequire.register("5g5jW", function(module, exports) {

$parcel$export(module.exports, "PageViewTracker", function () { return (parcelRequire("7q5hq")).default; });
$parcel$export(module.exports, "EventTracker", function () { return (parcelRequire("e73gb")).default; });
$parcel$export(module.exports, "SessionTracker", function () { return (parcelRequire("7gn03")).default; });

var $7q5hq = parcelRequire("7q5hq");

var $e73gb = parcelRequire("e73gb");

var $7gn03 = parcelRequire("7gn03");

});
parcelRequire.register("7q5hq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $566f0e9dc93a98b4$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $9CeVW = parcelRequire("9CeVW");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $gssgp = parcelRequire("gssgp");
var $566f0e9dc93a98b4$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $566f0e9dc93a98b4$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $566f0e9dc93a98b4$var$logger = new (0, $gBqCF.ConsoleLogger)("PageViewTracker");
var $566f0e9dc93a98b4$var$PREV_URL_KEY = "aws-amplify-analytics-prevUrl";
var $566f0e9dc93a98b4$var$getUrl = function() {
    if (!(0, $gssgp.default).browserOrNode().isBrowser) return "";
    else return window.location.origin + window.location.pathname;
};
var $566f0e9dc93a98b4$var$defaultOpts = {
    enable: false,
    provider: "AWSPinpoint",
    getUrl: $566f0e9dc93a98b4$var$getUrl
};
var $566f0e9dc93a98b4$var$PageViewTracker = /** @class */ function() {
    function PageViewTracker(tracker, opts) {
        $566f0e9dc93a98b4$var$logger.debug("initialize pageview tracker with opts", opts);
        this._config = Object.assign({}, $566f0e9dc93a98b4$var$defaultOpts, opts);
        this._tracker = tracker;
        this._hasEnabled = false;
        this._trackFunc = this._trackFunc.bind(this);
        if (this._config.type === "SPA") this._pageViewTrackSPA();
        else this._pageViewTrackDefault();
    }
    PageViewTracker.prototype.configure = function(opts) {
        Object.assign(this._config, opts);
        // if spa, need to remove those listeners if disabled
        if (this._config.type === "SPA") this._pageViewTrackSPA();
        return this._config;
    };
    PageViewTracker.prototype._isSameUrl = function() {
        var prevUrl = sessionStorage.getItem($566f0e9dc93a98b4$var$PREV_URL_KEY);
        var curUrl = this._config.getUrl();
        if (prevUrl === curUrl) {
            $566f0e9dc93a98b4$var$logger.debug("the url is same");
            return true;
        } else return false;
    };
    PageViewTracker.prototype._pageViewTrackDefault = function() {
        return $566f0e9dc93a98b4$var$__awaiter(this, void 0, void 0, function() {
            var url, customAttrs, _a, attributes;
            return $566f0e9dc93a98b4$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(0, $gssgp.default).browserOrNode().isBrowser || !window.addEventListener || !window.sessionStorage) {
                            $566f0e9dc93a98b4$var$logger.debug("not in the supported web enviroment");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        url = this._config.getUrl();
                        if (!(typeof this._config.attributes === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._config.attributes()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = this._config.attributes;
                        _b.label = 3;
                    case 3:
                        customAttrs = _a;
                        attributes = Object.assign({
                            url: url
                        }, customAttrs);
                        if (this._config.enable && !this._isSameUrl()) {
                            this._tracker({
                                name: this._config.eventName || "pageView",
                                attributes: attributes
                            }, this._config.provider).catch(function(e) {
                                $566f0e9dc93a98b4$var$logger.debug("Failed to record the page view event", e);
                            });
                            sessionStorage.setItem($566f0e9dc93a98b4$var$PREV_URL_KEY, url);
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PageViewTracker.prototype._trackFunc = function() {
        return $566f0e9dc93a98b4$var$__awaiter(this, void 0, void 0, function() {
            var url, customAttrs, _a, attributes;
            return $566f0e9dc93a98b4$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(0, $gssgp.default).browserOrNode().isBrowser || !window.addEventListener || !history.pushState || !window.sessionStorage) {
                            $566f0e9dc93a98b4$var$logger.debug("not in the supported web enviroment");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        url = this._config.getUrl();
                        if (!(typeof this._config.attributes === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._config.attributes()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = this._config.attributes;
                        _b.label = 3;
                    case 3:
                        customAttrs = _a;
                        attributes = Object.assign({
                            url: url
                        }, customAttrs);
                        if (!this._isSameUrl()) {
                            this._tracker({
                                name: this._config.eventName || "pageView",
                                attributes: attributes
                            }, this._config.provider).catch(function(e) {
                                $566f0e9dc93a98b4$var$logger.debug("Failed to record the page view event", e);
                            });
                            sessionStorage.setItem($566f0e9dc93a98b4$var$PREV_URL_KEY, url);
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PageViewTracker.prototype._pageViewTrackSPA = function() {
        if (!(0, $gssgp.default).browserOrNode().isBrowser || !window.addEventListener || !history.pushState) {
            $566f0e9dc93a98b4$var$logger.debug("not in the supported web enviroment");
            return;
        }
        if (this._config.enable && !this._hasEnabled) {
            (0, $9CeVW.default).add(history, "pushState", this._trackFunc);
            (0, $9CeVW.default).add(history, "replaceState", this._trackFunc);
            window.addEventListener("popstate", this._trackFunc);
            this._trackFunc();
            this._hasEnabled = true;
        } else {
            (0, $9CeVW.default).remove(history, "pushState");
            (0, $9CeVW.default).remove(history, "replaceState");
            window.removeEventListener("popstate", this._trackFunc);
            this._hasEnabled = false;
        }
    };
    return PageViewTracker;
}();
var $566f0e9dc93a98b4$export$2e2bcd8739ae039 = $566f0e9dc93a98b4$var$PageViewTracker;

});
parcelRequire.register("9CeVW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70033f21f22f0545$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $70033f21f22f0545$var$lists = [];
var $70033f21f22f0545$var$MethodEmbed = /** @class */ function() {
    function MethodEmbed(context, methodName) {
        this.context = context;
        this.methodName = methodName;
        this._originalMethod = context[methodName].bind(context);
    }
    MethodEmbed.add = function(context, methodName, methodOverride) {
        $70033f21f22f0545$var$getInstance(context, methodName).set(methodOverride);
    };
    MethodEmbed.remove = function(context, methodName) {
        $70033f21f22f0545$var$getInstance(context, methodName).remove();
    };
    MethodEmbed.prototype.set = function(methodOverride) {
        var _this = this;
        this.context[this.methodName] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return methodOverride(_this._originalMethod.apply(_this, args));
        };
    };
    MethodEmbed.prototype.remove = function() {
        this.context[this.methodName] = this._originalMethod;
    };
    return MethodEmbed;
}();
var $70033f21f22f0545$export$2e2bcd8739ae039 = $70033f21f22f0545$var$MethodEmbed;
function $70033f21f22f0545$var$getInstance(context, methodName) {
    var instance = $70033f21f22f0545$var$lists.filter(function(h) {
        return h.context === context && h.methodName === methodName;
    })[0];
    if (!instance) {
        instance = new $70033f21f22f0545$var$MethodEmbed(context, methodName);
        $70033f21f22f0545$var$lists.push(instance);
    }
    return instance;
}

});


parcelRequire.register("e73gb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4643f8270da3895$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("fBYhj");
var $5ljbU = parcelRequire("5ljbU");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $gssgp = parcelRequire("gssgp");
var $a4643f8270da3895$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a4643f8270da3895$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $a4643f8270da3895$var$logger = new (0, $gBqCF.ConsoleLogger)("EventTracker");
var $a4643f8270da3895$var$defaultOpts = {
    enable: false,
    events: [
        "click"
    ],
    selectorPrefix: "data-amplify-analytics-",
    provider: "AWSPinpoint"
};
var $a4643f8270da3895$var$EventTracker = /** @class */ function() {
    function EventTracker(tracker, opts) {
        if (!(0, $gssgp.default).browserOrNode().isBrowser || !window.addEventListener) {
            $a4643f8270da3895$var$logger.debug("not in the supported web environment");
            return;
        }
        this._config = Object.assign({}, $a4643f8270da3895$var$defaultOpts, opts);
        this._tracker = tracker;
        this._delegates = {};
        this._trackFunc = this._trackFunc.bind(this);
        $a4643f8270da3895$var$logger.debug("initialize pageview tracker with opts", this._config);
        this.configure(this._config);
    }
    EventTracker.prototype.configure = function(opts) {
        var _this = this;
        Object.assign(this._config, opts);
        if (!this._config.enable) {
            Object.keys(this._delegates).forEach(function(key) {
                if (typeof _this._delegates[key].destroy === "function") _this._delegates[key].destroy();
            });
            this._delegates = {};
        } else if (this._config.enable && Object.keys(this._delegates).length === 0) {
            var selector_1 = "[" + this._config.selectorPrefix + "on]";
            this._config.events.forEach(function(evt) {
                _this._delegates[evt] = (0, $5ljbU.default)(document, evt, selector_1, _this._trackFunc, {
                    composed: true,
                    useCapture: true
                });
            });
        }
        return this._config;
    };
    EventTracker.prototype._trackFunc = function(event, element) {
        return $a4643f8270da3895$var$__awaiter(this, void 0, void 0, function() {
            var customAttrs, events, eventName, attrs, defaultAttrs, _a, attributes;
            return $a4643f8270da3895$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        customAttrs = {};
                        events = element.getAttribute(this._config.selectorPrefix + "on").split(/\s*,\s*/);
                        eventName = element.getAttribute(this._config.selectorPrefix + "name");
                        attrs = element.getAttribute(this._config.selectorPrefix + "attrs");
                        if (attrs) attrs.split(/\s*,\s*/).forEach(function(attr) {
                            var tmp = attr.trim().split(/\s*:\s*/);
                            customAttrs[tmp[0]] = tmp[1];
                        });
                        if (!(typeof this._config.attributes === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._config.attributes()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = this._config.attributes;
                        _b.label = 3;
                    case 3:
                        defaultAttrs = _a;
                        attributes = Object.assign({
                            type: event.type,
                            target: event.target.localName + " with id " + event.target.id
                        }, defaultAttrs, customAttrs);
                        $a4643f8270da3895$var$logger.debug("events needed to be recorded", events);
                        $a4643f8270da3895$var$logger.debug("attributes needed to be attached", customAttrs);
                        if (events.indexOf(event.type) < 0) {
                            $a4643f8270da3895$var$logger.debug("event " + event.type + " is not selected to be recorded");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        this._tracker({
                            name: eventName || "event",
                            attributes: attributes
                        }, this._config.provider).catch(function(e) {
                            $a4643f8270da3895$var$logger.debug("Failed to record the " + event.type + " event', " + e);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return EventTracker;
}();
var $a4643f8270da3895$export$2e2bcd8739ae039 = $a4643f8270da3895$var$EventTracker;

});
parcelRequire.register("fBYhj", function(module, exports) {

$parcel$export(module.exports, "delegate", function () { return (parcelRequire("5ljbU")).default; });

var $86MA2 = parcelRequire("86MA2");

var $5ljbU = parcelRequire("5ljbU");

var $f6ZRS = parcelRequire("f6ZRS");

var $7GG34 = parcelRequire("7GG34");

var $ffVmn = parcelRequire("ffVmn");

var $gSmlj = parcelRequire("gSmlj");

var $29cTL = parcelRequire("29cTL");

});
parcelRequire.register("86MA2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e749150868b5f43$export$2e2bcd8739ae039; });
/**
 * Copyright (c) 2017, Philip Walton <philip@philipwalton.com>
 */ 
var $ffVmn = parcelRequire("ffVmn");

var $gSmlj = parcelRequire("gSmlj");
function $5e749150868b5f43$export$2e2bcd8739ae039(element, selector, shouldCheckSelf) {
    if (shouldCheckSelf === void 0) shouldCheckSelf = false;
    if (!(element && element.nodeType === 1 && selector)) return;
    var parentElements = (shouldCheckSelf ? [
        element
    ] : []).concat((0, $gSmlj.default)(element));
    for(var i = 0, parent_1; parent_1 = parentElements[i]; i++){
        if ((0, $ffVmn.default)(parent_1, selector)) return parent_1;
    }
}

});
parcelRequire.register("ffVmn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1b4c03cb8c00868$export$2e2bcd8739ae039; });
/**
 * Copyright (c) 2017, Philip Walton <philip@philipwalton.com>
 */ parcelRequire("2hWDt");
var $gssgp = parcelRequire("gssgp");
var $b1b4c03cb8c00868$var$proto = (0, $gssgp.default).browserOrNode().isBrowser && window["Element"] ? window["Element"].prototype : null;
var $b1b4c03cb8c00868$var$nativeMatches = $b1b4c03cb8c00868$var$proto ? $b1b4c03cb8c00868$var$proto.matches || // @ts-ignore
$b1b4c03cb8c00868$var$proto.matchesSelector || // @ts-ignore
$b1b4c03cb8c00868$var$proto.webkitMatchesSelector || // @ts-ignore
$b1b4c03cb8c00868$var$proto.mozMatchesSelector || // @ts-ignore
$b1b4c03cb8c00868$var$proto.msMatchesSelector || // @ts-ignore
$b1b4c03cb8c00868$var$proto.oMatchesSelector : null;
function $b1b4c03cb8c00868$export$2e2bcd8739ae039(element, test) {
    // Validate input.
    if (element && element.nodeType === 1 && test) {
        // if test is a string or DOM element test it.
        if (typeof test === "string" || test.nodeType === 1) return element === test || $b1b4c03cb8c00868$var$matchesSelector(element, /** @type {string} */ test);
        else if ("length" in test) // if it has a length property iterate over the items
        // and return true if any match.
        for(var i = 0, item = void 0; item = test[i]; i++){
            if (element === item || $b1b4c03cb8c00868$var$matchesSelector(element, item)) return true;
        }
    }
    // Still here? Return false
    return false;
}
/**
 * Tests whether a DOM element matches a selector. This polyfills the native
 * Element.prototype.matches method across browsers.
 * @param {!Element} element The DOM element to test.
 * @param {string} selector The CSS selector to test element against.
 * @return {boolean} True if the selector matches.
 */ function $b1b4c03cb8c00868$var$matchesSelector(element, selector) {
    if (typeof selector !== "string") return false;
    if ($b1b4c03cb8c00868$var$nativeMatches) return $b1b4c03cb8c00868$var$nativeMatches.call(element, selector);
    var nodes = element.parentNode.querySelectorAll(selector);
    for(var i = 0, node = void 0; node = nodes[i]; i++){
        if (node === element) return true;
    }
    return false;
}

});

parcelRequire.register("gSmlj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c493054d50224991$export$2e2bcd8739ae039; });
/**
 * Copyright (c) 2017, Philip Walton <philip@philipwalton.com>
 */ /**
 * Returns an array of a DOM element's parent elements.
 * @param {!Element} element The DOM element whose parents to get.
 * @return {!Array} An array of all parent elemets, or an empty array if no
 *     parent elements are found.
 */ function $c493054d50224991$export$2e2bcd8739ae039(ele) {
    var list = [];
    var element = ele;
    while(element && element.parentNode && element.parentNode.nodeType === 1){
        element = /** @type {!Element} */ element.parentNode;
        list.push(element);
    }
    return list;
}

});


parcelRequire.register("5ljbU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e3dccdfab3c01bd$export$2e2bcd8739ae039; });
/**
 * Copyright (c) 2017, Philip Walton <philip@philipwalton.com>
 */ 
var $86MA2 = parcelRequire("86MA2");

var $ffVmn = parcelRequire("ffVmn");
function $3e3dccdfab3c01bd$export$2e2bcd8739ae039(ancestor, eventType, selector, callback, opts) {
    if (opts === void 0) opts = {};
    // Defines the event listener.
    var listener = function(event) {
        var delegateTarget;
        // If opts.composed is true and the event originated from inside a Shadow
        // tree, check the composed path nodes.
        if (opts["composed"] && typeof event["composedPath"] === "function") {
            var composedPath = event.composedPath();
            for(var i = 0, node = void 0; node = composedPath[i]; i++)if (node.nodeType === 1 && (0, $ffVmn.default)(node, selector)) delegateTarget = node;
        } else // Otherwise check the parents.
        delegateTarget = (0, $86MA2.default)(event.target, selector, true);
        if (delegateTarget) callback.call(delegateTarget, event, delegateTarget);
    };
    ancestor.addEventListener(eventType, listener, opts["useCapture"]);
    return {
        destroy: function() {
            ancestor.removeEventListener(eventType, listener, opts["useCapture"]);
        }
    };
}

});

parcelRequire.register("f6ZRS", function(module, exports) {
/**
 * Copyright (c) 2017, Philip Walton <philip@philipwalton.com>
 */ /**
 * Dispatches an event on the passed element.
 * @param {!Element} element The DOM element to dispatch the event on.
 * @param {string} eventType The type of event to dispatch.
 * @param {Object|string=} eventName A string name of the event constructor
 *     to use. Defaults to 'Event' if nothing is passed or 'CustomEvent' if
 *     a value is set on `initDict.detail`. If eventName is given an object
 *     it is assumed to be initDict and thus reassigned.
 * @param {Object=} initDict The initialization attributes for the
 *     event. A `detail` property can be used here to pass custom data.
 * @return {boolean} The return value of `element.dispatchEvent`, which will
 *     be false if any of the event listeners called `preventDefault`.
 */ function $b00768421aa05904$export$2e2bcd8739ae039(element, eventType, evtName, init_dict) {
    if (evtName === void 0) evtName = "Event";
    if (init_dict === void 0) init_dict = {};
    var event;
    var isCustom;
    var initDict = init_dict;
    var eventName = evtName;
    // eventName is optional
    if (typeof eventName === "object") {
        initDict = eventName;
        eventName = "Event";
    }
    initDict["bubbles"] = initDict["bubbles"] || false;
    initDict["cancelable"] = initDict["cancelable"] || false;
    initDict["composed"] = initDict["composed"] || false;
    // If a detail property is passed, this is a custom event.
    if ("detail" in initDict) isCustom = true;
    eventName = isCustom ? "CustomEvent" : eventName;
    // Tries to create the event using constructors, if that doesn't work,
    // fallback to `document.createEvent()`.
    try {
        event = new window[eventName](eventType, initDict);
    } catch (err) {
        event = document.createEvent(eventName);
        var initMethod = "init" + (isCustom ? "Custom" : "") + "Event";
        event[initMethod](eventType, initDict["bubbles"], initDict["cancelable"], initDict["detail"]);
    }
    return element.dispatchEvent(event);
}

});

parcelRequire.register("7GG34", function(module, exports) {
/**
 * Copyright (c) 2017, Philip Walton <philip@philipwalton.com>
 */ /**
 * Gets all attributes of an element as a plain JavaScriot object.
 * @param {Element} element The element whose attributes to get.
 * @return {!Object} An object whose keys are the attribute keys and whose
 *     values are the attribute values. If no attributes exist, an empty
 *     object is returned.
 */ function $598d129b9e9e9bc5$export$2e2bcd8739ae039(element) {
    var attrs = {};
    // Validate input.
    if (!(element && element.nodeType === 1)) return attrs;
    // Return an empty object if there are no attributes.
    var map = element.attributes;
    if (map.length === 0) return {};
    for(var i = 0, attr = void 0; attr = map[i]; i++)attrs[attr.name] = attr.value;
    return attrs;
}

});

parcelRequire.register("29cTL", function(module, exports) {
/**
 * Copyright (c) 2017, Philip Walton <philip@philipwalton.com>
 */ parcelRequire("2hWDt");
var $gssgp = parcelRequire("gssgp");
var $19066d6063d0ed98$var$HTTP_PORT = "80";
var $19066d6063d0ed98$var$HTTPS_PORT = "443";
var $19066d6063d0ed98$var$DEFAULT_PORT = RegExp(":(" + $19066d6063d0ed98$var$HTTP_PORT + "|" + $19066d6063d0ed98$var$HTTPS_PORT + ")$");
var $19066d6063d0ed98$var$a = (0, $gssgp.default).browserOrNode().isBrowser ? document.createElement("a") : null;
var $19066d6063d0ed98$var$cache = {};
function $19066d6063d0ed98$export$2e2bcd8739ae039(u) {
    var url = u;
    // All falsy values (as well as ".") should map to the current URL.
    url = !url || url === "." ? location.href : url;
    if ($19066d6063d0ed98$var$cache[url]) return $19066d6063d0ed98$var$cache[url];
    $19066d6063d0ed98$var$a.href = url;
    // When parsing file relative paths (e.g. `../index.html`), IE will correctly
    // resolve the `href` property but will keep the `..` in the `path` property.
    // It will also not include the `host` or `hostname` properties. Furthermore,
    // IE will sometimes return no protocol or just a colon, especially for things
    // like relative protocol URLs (e.g. "//google.com").
    // To workaround all of these issues, we reparse with the full URL from the
    // `href` property.
    if (url.charAt(0) === "." || url.charAt(0) === "/") return $19066d6063d0ed98$export$2e2bcd8739ae039($19066d6063d0ed98$var$a.href);
    // Don't include default ports.
    var port = $19066d6063d0ed98$var$a.port === $19066d6063d0ed98$var$HTTP_PORT || $19066d6063d0ed98$var$a.port === $19066d6063d0ed98$var$HTTPS_PORT ? "" : $19066d6063d0ed98$var$a.port;
    // PhantomJS sets the port to "0" when using the file: protocol.
    port = port === "0" ? "" : port;
    // Sometimes IE incorrectly includes a port for default ports
    // (e.g. `:80` or `:443`) even when no port is specified in the URL.
    // http://bit.ly/1rQNoMg
    var host = $19066d6063d0ed98$var$a.host.replace($19066d6063d0ed98$var$DEFAULT_PORT, "");
    // Not all browser support `origin` so we have to build it.
    var origin = $19066d6063d0ed98$var$a["origin"] ? $19066d6063d0ed98$var$a["origin"] : $19066d6063d0ed98$var$a.protocol + "//" + host;
    // Sometimes IE doesn't include the leading slash for pathname.
    // http://bit.ly/1rQNoMg
    var pathname = $19066d6063d0ed98$var$a.pathname.charAt(0) === "/" ? $19066d6063d0ed98$var$a.pathname : "/" + $19066d6063d0ed98$var$a.pathname;
    return $19066d6063d0ed98$var$cache[url] = {
        hash: $19066d6063d0ed98$var$a.hash,
        host: host,
        hostname: $19066d6063d0ed98$var$a.hostname,
        href: $19066d6063d0ed98$var$a.href,
        origin: origin,
        pathname: pathname,
        port: port,
        protocol: $19066d6063d0ed98$var$a.protocol,
        search: $19066d6063d0ed98$var$a.search
    };
}

});



parcelRequire.register("7gn03", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $549bde52ba2b9ff6$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $gssgp = parcelRequire("gssgp");
var $549bde52ba2b9ff6$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $549bde52ba2b9ff6$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $549bde52ba2b9ff6$var$logger = new (0, $gBqCF.ConsoleLogger)("SessionTracker");
var $549bde52ba2b9ff6$var$defaultOpts = {
    enable: false,
    provider: "AWSPinpoint"
};
var $549bde52ba2b9ff6$var$initialEventSent = false;
var $549bde52ba2b9ff6$var$SessionTracker = /** @class */ function() {
    function SessionTracker(tracker, opts) {
        this._config = Object.assign({}, $549bde52ba2b9ff6$var$defaultOpts, opts);
        this._tracker = tracker;
        this._hasEnabled = false;
        this._trackFunc = this._trackFunc.bind(this);
        this._trackBeforeUnload = this._trackBeforeUnload.bind(this);
        this.configure(this._config);
    }
    SessionTracker.prototype._envCheck = function() {
        if (!(0, $gssgp.default).browserOrNode().isBrowser) return false;
        if (!document || !document.addEventListener) {
            $549bde52ba2b9ff6$var$logger.debug("not in the supported web environment");
            return false;
        }
        if (typeof document.hidden !== "undefined") {
            this._hidden = "hidden";
            this._visibilityChange = "visibilitychange";
        } else if (typeof document["msHidden"] !== "undefined") {
            this._hidden = "msHidden";
            this._visibilityChange = "msvisibilitychange";
        } else if (typeof document["webkitHidden"] !== "undefined") {
            this._hidden = "webkitHidden";
            this._visibilityChange = "webkitvisibilitychange";
        } else {
            $549bde52ba2b9ff6$var$logger.debug("not in the supported web environment");
            return false;
        }
        return true;
    };
    SessionTracker.prototype._trackFunc = function() {
        return $549bde52ba2b9ff6$var$__awaiter(this, void 0, void 0, function() {
            var customAttrs, _a, attributes;
            return $549bde52ba2b9ff6$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(typeof this._config.attributes === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._config.attributes()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = this._config.attributes;
                        _b.label = 3;
                    case 3:
                        customAttrs = _a;
                        attributes = Object.assign({}, customAttrs);
                        if (document.visibilityState === this._hidden) this._tracker({
                            name: "_session.stop",
                            attributes: attributes
                        }, this._config.provider).catch(function(e) {
                            $549bde52ba2b9ff6$var$logger.debug("record session stop event failed.", e);
                        });
                        else this._tracker({
                            name: "_session.start",
                            attributes: attributes
                        }, this._config.provider).catch(function(e) {
                            $549bde52ba2b9ff6$var$logger.debug("record session start event failed.", e);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SessionTracker.prototype._trackBeforeUnload = function(event) {
        // before unload callback cannot be async => https://github.com/aws-amplify/amplify-js/issues/2088
        var _this = this;
        var customAttrs = typeof this._config.attributes === "function" ? Promise.resolve(this._config.attributes()) : Promise.resolve(this._config.attributes);
        customAttrs.then(function(custom) {
            var attributes = Object.assign({}, custom);
            _this._tracker({
                name: "_session.stop",
                attributes: attributes,
                immediate: true
            }, _this._config.provider).catch(function(e) {
                $549bde52ba2b9ff6$var$logger.debug("record session stop event failed.", e);
            });
        });
    };
    // to keep configure a synchronized function
    SessionTracker.prototype._sendInitialEvent = function() {
        return $549bde52ba2b9ff6$var$__awaiter(this, void 0, void 0, function() {
            var customAttrs, _a, attributes;
            return $549bde52ba2b9ff6$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if ($549bde52ba2b9ff6$var$initialEventSent) {
                            $549bde52ba2b9ff6$var$logger.debug("the start session has been sent when the page is loaded");
                            return [
                                2 /*return*/ 
                            ];
                        } else $549bde52ba2b9ff6$var$initialEventSent = true;
                        if (!(typeof this._config.attributes === "function")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._config.attributes()
                        ];
                    case 1:
                        _a = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = this._config.attributes;
                        _b.label = 3;
                    case 3:
                        customAttrs = _a;
                        attributes = Object.assign({}, customAttrs);
                        this._tracker({
                            name: "_session.start",
                            attributes: attributes
                        }, this._config.provider).catch(function(e) {
                            $549bde52ba2b9ff6$var$logger.debug("record session start event failed.", e);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SessionTracker.prototype.configure = function(opts) {
        if (!this._envCheck()) return this._config;
        Object.assign(this._config, opts);
        if (this._config.enable && !this._hasEnabled) {
            // send a start session as soon as it's enabled
            this._sendInitialEvent();
            // listen on events
            document.addEventListener(this._visibilityChange, this._trackFunc, false);
            window.addEventListener("beforeunload", this._trackBeforeUnload, false);
            this._hasEnabled = true;
        } else if (!this._config.enable && this._hasEnabled) {
            document.removeEventListener(this._visibilityChange, this._trackFunc, false);
            window.removeEventListener("beforeunload", this._trackBeforeUnload, false);
            this._hasEnabled = false;
        }
        return this._config;
    };
    return SessionTracker;
}();
var $549bde52ba2b9ff6$export$2e2bcd8739ae039 = $549bde52ba2b9ff6$var$SessionTracker;

});



parcelRequire.register("1M8si", function(module, exports) {

$parcel$export(module.exports, "AWSKinesisProvider", function () { return (parcelRequire("bOqq5")).default; });

var $7r2po = parcelRequire("7r2po");

var $bOqq5 = parcelRequire("bOqq5");

var $eKe2w = parcelRequire("eKe2w");

var $b3RkR = parcelRequire("b3RkR");

});
parcelRequire.register("bOqq5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8998db9ed1f6c9d4$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $aCVDw = parcelRequire("aCVDw");

var $gnl8D = parcelRequire("gnl8D");
var $8998db9ed1f6c9d4$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8998db9ed1f6c9d4$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $8998db9ed1f6c9d4$var$logger = new (0, $gBqCF.ConsoleLogger)("AWSKineisProvider");
// events buffer
var $8998db9ed1f6c9d4$var$BUFFER_SIZE = 1000;
var $8998db9ed1f6c9d4$var$FLUSH_SIZE = 100;
var $8998db9ed1f6c9d4$var$FLUSH_INTERVAL = 5000; // 5s
var $8998db9ed1f6c9d4$var$RESEND_LIMIT = 5;
var $8998db9ed1f6c9d4$var$AWSKinesisProvider = /** @class */ function() {
    function AWSKinesisProvider(config) {
        this._buffer = [];
        this._config = config || {};
        this._config.bufferSize = this._config.bufferSize || $8998db9ed1f6c9d4$var$BUFFER_SIZE;
        this._config.flushSize = this._config.flushSize || $8998db9ed1f6c9d4$var$FLUSH_SIZE;
        this._config.flushInterval = this._config.flushInterval || $8998db9ed1f6c9d4$var$FLUSH_INTERVAL;
        this._config.resendLimit = this._config.resendLimit || $8998db9ed1f6c9d4$var$RESEND_LIMIT;
        this._setupTimer();
    }
    AWSKinesisProvider.prototype._setupTimer = function() {
        var _this = this;
        if (this._timer) clearInterval(this._timer);
        var _a = this._config, flushSize = _a.flushSize, flushInterval = _a.flushInterval;
        this._timer = setInterval(function() {
            var size = _this._buffer.length < flushSize ? _this._buffer.length : flushSize;
            var events = [];
            for(var i = 0; i < size; i += 1){
                var params = _this._buffer.shift();
                events.push(params);
            }
            _this._sendFromBuffer(events);
        }, flushInterval);
    };
    /**
     * get the category of the plugin
     */ AWSKinesisProvider.prototype.getCategory = function() {
        return "Analytics";
    };
    /**
     * get provider name of the plugin
     */ AWSKinesisProvider.prototype.getProviderName = function() {
        return "AWSKinesis";
    };
    /**
     * configure the plugin
     * @param {Object} config - configuration
     */ AWSKinesisProvider.prototype.configure = function(config) {
        $8998db9ed1f6c9d4$var$logger.debug("configure Analytics", config);
        var conf = config || {};
        this._config = Object.assign({}, this._config, conf);
        this._setupTimer();
        return this._config;
    };
    /**
     * record an event
     * @param {Object} params - the params of an event
     */ AWSKinesisProvider.prototype.record = function(params) {
        return $8998db9ed1f6c9d4$var$__awaiter(this, void 0, void 0, function() {
            var credentials;
            return $8998db9ed1f6c9d4$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._getCredentials()
                        ];
                    case 1:
                        credentials = _a.sent();
                        if (!credentials) return [
                            2 /*return*/ ,
                            Promise.resolve(false)
                        ];
                        Object.assign(params, {
                            config: this._config,
                            credentials: credentials
                        });
                        return [
                            2 /*return*/ ,
                            this._putToBuffer(params)
                        ];
                }
            });
        });
    };
    AWSKinesisProvider.prototype.updateEndpoint = function(params) {
        $8998db9ed1f6c9d4$var$logger.debug("updateEndpoint is not implemented in Kinesis provider");
        return Promise.resolve(true);
    };
    /**
     * @private
     * @param params - params for the event recording
     * Put events into buffer
     */ AWSKinesisProvider.prototype._putToBuffer = function(params) {
        if (this._buffer.length < $8998db9ed1f6c9d4$var$BUFFER_SIZE) {
            this._buffer.push(params);
            return Promise.resolve(true);
        } else {
            $8998db9ed1f6c9d4$var$logger.debug("exceed analytics events buffer size");
            return Promise.reject(false);
        }
    };
    AWSKinesisProvider.prototype._sendFromBuffer = function(events) {
        var _this = this;
        // collapse events by credentials
        // events = [ {params} ]
        var eventsGroups = [];
        var preCred = null;
        var group = [];
        for(var i = 0; i < events.length; i += 1){
            var cred = events[i].credentials;
            if (i === 0) {
                group.push(events[i]);
                preCred = cred;
            } else if (cred.sessionToken === preCred.sessionToken && cred.identityId === preCred.identityId) {
                $8998db9ed1f6c9d4$var$logger.debug("no change for cred, put event in the same group");
                group.push(events[i]);
            } else {
                eventsGroups.push(group);
                group = [];
                group.push(events[i]);
                preCred = cred;
            }
        }
        eventsGroups.push(group);
        eventsGroups.map(function(evts) {
            _this._sendEvents(evts);
        });
    };
    AWSKinesisProvider.prototype._sendEvents = function(group) {
        var _this = this;
        if (group.length === 0) return;
        var _a = group[0], config = _a.config, credentials = _a.credentials;
        var initClients = this._init(config, credentials);
        if (!initClients) return false;
        var records = {};
        group.map(function(params) {
            // spit by streamName
            var evt = params.event;
            var streamName = evt.streamName;
            if (records[streamName] === undefined) records[streamName] = [];
            var Data = JSON.stringify(evt.data);
            var PartitionKey = evt.partitionKey || "partition-" + credentials.identityId;
            var record = {
                Data: Data,
                PartitionKey: PartitionKey
            };
            records[streamName].push(record);
        });
        Object.keys(records).map(function(streamName) {
            $8998db9ed1f6c9d4$var$logger.debug("putting records to kinesis with records", records[streamName]);
            _this._kinesis.putRecords({
                Records: records[streamName],
                StreamName: streamName
            }, function(err, data) {
                if (err) $8998db9ed1f6c9d4$var$logger.debug("Failed to upload records to Kinesis", err);
                else $8998db9ed1f6c9d4$var$logger.debug("Upload records to stream", streamName);
            });
        });
    };
    AWSKinesisProvider.prototype._init = function(config, credentials) {
        $8998db9ed1f6c9d4$var$logger.debug("init clients");
        if (this._kinesis && this._config.credentials && this._config.credentials.sessionToken === credentials.sessionToken && this._config.credentials.identityId === credentials.identityId) {
            $8998db9ed1f6c9d4$var$logger.debug("no change for analytics config, directly return from init");
            return true;
        }
        this._config.credentials = credentials;
        var region = config.region;
        return this._initKinesis(region, credentials);
    };
    AWSKinesisProvider.prototype._initKinesis = function(region, credentials) {
        $8998db9ed1f6c9d4$var$logger.debug("initialize kinesis with credentials", credentials);
        this._kinesis = new $gnl8D({
            apiVersion: "2013-12-02",
            region: region,
            credentials: credentials
        });
        return true;
    };
    /**
     * @private
     * check if current credentials exists
     */ AWSKinesisProvider.prototype._getCredentials = function() {
        var _this = this;
        return (0, $aCVDw.default).get().then(function(credentials) {
            if (!credentials) return null;
            $8998db9ed1f6c9d4$var$logger.debug("set credentials for analytics", _this._config.credentials);
            return (0, $aCVDw.default).shear(credentials);
        }).catch(function(err) {
            $8998db9ed1f6c9d4$var$logger.debug("ensure credentials error", err);
            return null;
        });
    };
    return AWSKinesisProvider;
}();
var $8998db9ed1f6c9d4$export$2e2bcd8739ae039 = $8998db9ed1f6c9d4$var$AWSKinesisProvider;

});
parcelRequire.register("gnl8D", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $bebf30f56a0a64de$var$Service = $dbC7k.Service;
var $bebf30f56a0a64de$var$apiLoader = $dbC7k.apiLoader;
$bebf30f56a0a64de$var$apiLoader.services["kinesis"] = {};
$dbC7k.Kinesis = $bebf30f56a0a64de$var$Service.defineService("kinesis", [
    "2013-12-02"
]);



Object.defineProperty($bebf30f56a0a64de$var$apiLoader.services["kinesis"], "2013-12-02", {
    get: function get() {
        var model = (parcelRequire("jRaC5"));
        model.paginators = (parcelRequire("blELq")).pagination;
        model.waiters = (parcelRequire("6QZrc")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Kinesis;

});
parcelRequire.register("jRaC5", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2013-12-02","endpointPrefix":"kinesis","jsonVersion":"1.1","protocol":"json","protocolSettings":{"h2":"eventstream"},"serviceAbbreviation":"Kinesis","serviceFullName":"Amazon Kinesis","serviceId":"Kinesis","signatureVersion":"v4","targetPrefix":"Kinesis_20131202","uid":"kinesis-2013-12-02"},"operations":{"AddTagsToStream":{"input":{"type":"structure","required":["StreamName","Tags"],"members":{"StreamName":{},"Tags":{"type":"map","key":{},"value":{}}}}},"CreateStream":{"input":{"type":"structure","required":["StreamName","ShardCount"],"members":{"StreamName":{},"ShardCount":{"type":"integer"}}}},"DecreaseStreamRetentionPeriod":{"input":{"type":"structure","required":["StreamName","RetentionPeriodHours"],"members":{"StreamName":{},"RetentionPeriodHours":{"type":"integer"}}}},"DeleteStream":{"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{},"EnforceConsumerDeletion":{"type":"boolean"}}}},"DeregisterStreamConsumer":{"input":{"type":"structure","members":{"StreamARN":{},"ConsumerName":{},"ConsumerARN":{}}}},"DescribeLimits":{"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["ShardLimit","OpenShardCount"],"members":{"ShardLimit":{"type":"integer"},"OpenShardCount":{"type":"integer"}}}},"DescribeStream":{"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{},"Limit":{"type":"integer"},"ExclusiveStartShardId":{}}},"output":{"type":"structure","required":["StreamDescription"],"members":{"StreamDescription":{"type":"structure","required":["StreamName","StreamARN","StreamStatus","Shards","HasMoreShards","RetentionPeriodHours","StreamCreationTimestamp","EnhancedMonitoring"],"members":{"StreamName":{},"StreamARN":{},"StreamStatus":{},"Shards":{"shape":"Sp"},"HasMoreShards":{"type":"boolean"},"RetentionPeriodHours":{"type":"integer"},"StreamCreationTimestamp":{"type":"timestamp"},"EnhancedMonitoring":{"shape":"Sw"},"EncryptionType":{},"KeyId":{}}}}}},"DescribeStreamConsumer":{"input":{"type":"structure","members":{"StreamARN":{},"ConsumerName":{},"ConsumerARN":{}}},"output":{"type":"structure","required":["ConsumerDescription"],"members":{"ConsumerDescription":{"type":"structure","required":["ConsumerName","ConsumerARN","ConsumerStatus","ConsumerCreationTimestamp","StreamARN"],"members":{"ConsumerName":{},"ConsumerARN":{},"ConsumerStatus":{},"ConsumerCreationTimestamp":{"type":"timestamp"},"StreamARN":{}}}}}},"DescribeStreamSummary":{"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{}}},"output":{"type":"structure","required":["StreamDescriptionSummary"],"members":{"StreamDescriptionSummary":{"type":"structure","required":["StreamName","StreamARN","StreamStatus","RetentionPeriodHours","StreamCreationTimestamp","EnhancedMonitoring","OpenShardCount"],"members":{"StreamName":{},"StreamARN":{},"StreamStatus":{},"RetentionPeriodHours":{"type":"integer"},"StreamCreationTimestamp":{"type":"timestamp"},"EnhancedMonitoring":{"shape":"Sw"},"EncryptionType":{},"KeyId":{},"OpenShardCount":{"type":"integer"},"ConsumerCount":{"type":"integer"}}}}}},"DisableEnhancedMonitoring":{"input":{"type":"structure","required":["StreamName","ShardLevelMetrics"],"members":{"StreamName":{},"ShardLevelMetrics":{"shape":"Sy"}}},"output":{"shape":"S1b"}},"EnableEnhancedMonitoring":{"input":{"type":"structure","required":["StreamName","ShardLevelMetrics"],"members":{"StreamName":{},"ShardLevelMetrics":{"shape":"Sy"}}},"output":{"shape":"S1b"}},"GetRecords":{"input":{"type":"structure","required":["ShardIterator"],"members":{"ShardIterator":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","required":["Records"],"members":{"Records":{"type":"list","member":{"type":"structure","required":["SequenceNumber","Data","PartitionKey"],"members":{"SequenceNumber":{},"ApproximateArrivalTimestamp":{"type":"timestamp"},"Data":{"type":"blob"},"PartitionKey":{},"EncryptionType":{}}}},"NextShardIterator":{},"MillisBehindLatest":{"type":"long"}}}},"GetShardIterator":{"input":{"type":"structure","required":["StreamName","ShardId","ShardIteratorType"],"members":{"StreamName":{},"ShardId":{},"ShardIteratorType":{},"StartingSequenceNumber":{},"Timestamp":{"type":"timestamp"}}},"output":{"type":"structure","members":{"ShardIterator":{}}}},"IncreaseStreamRetentionPeriod":{"input":{"type":"structure","required":["StreamName","RetentionPeriodHours"],"members":{"StreamName":{},"RetentionPeriodHours":{"type":"integer"}}}},"ListShards":{"input":{"type":"structure","members":{"StreamName":{},"NextToken":{},"ExclusiveStartShardId":{},"MaxResults":{"type":"integer"},"StreamCreationTimestamp":{"type":"timestamp"}}},"output":{"type":"structure","members":{"Shards":{"shape":"Sp"},"NextToken":{}}}},"ListStreamConsumers":{"input":{"type":"structure","required":["StreamARN"],"members":{"StreamARN":{},"NextToken":{},"MaxResults":{"type":"integer"},"StreamCreationTimestamp":{"type":"timestamp"}}},"output":{"type":"structure","members":{"Consumers":{"type":"list","member":{"shape":"S1y"}},"NextToken":{}}}},"ListStreams":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"ExclusiveStartStreamName":{}}},"output":{"type":"structure","required":["StreamNames","HasMoreStreams"],"members":{"StreamNames":{"type":"list","member":{}},"HasMoreStreams":{"type":"boolean"}}}},"ListTagsForStream":{"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{},"ExclusiveStartTagKey":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","required":["Tags","HasMoreTags"],"members":{"Tags":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"HasMoreTags":{"type":"boolean"}}}},"MergeShards":{"input":{"type":"structure","required":["StreamName","ShardToMerge","AdjacentShardToMerge"],"members":{"StreamName":{},"ShardToMerge":{},"AdjacentShardToMerge":{}}}},"PutRecord":{"input":{"type":"structure","required":["StreamName","Data","PartitionKey"],"members":{"StreamName":{},"Data":{"type":"blob"},"PartitionKey":{},"ExplicitHashKey":{},"SequenceNumberForOrdering":{}}},"output":{"type":"structure","required":["ShardId","SequenceNumber"],"members":{"ShardId":{},"SequenceNumber":{},"EncryptionType":{}}}},"PutRecords":{"input":{"type":"structure","required":["Records","StreamName"],"members":{"Records":{"type":"list","member":{"type":"structure","required":["Data","PartitionKey"],"members":{"Data":{"type":"blob"},"ExplicitHashKey":{},"PartitionKey":{}}}},"StreamName":{}}},"output":{"type":"structure","required":["Records"],"members":{"FailedRecordCount":{"type":"integer"},"Records":{"type":"list","member":{"type":"structure","members":{"SequenceNumber":{},"ShardId":{},"ErrorCode":{},"ErrorMessage":{}}}},"EncryptionType":{}}}},"RegisterStreamConsumer":{"input":{"type":"structure","required":["StreamARN","ConsumerName"],"members":{"StreamARN":{},"ConsumerName":{}}},"output":{"type":"structure","required":["Consumer"],"members":{"Consumer":{"shape":"S1y"}}}},"RemoveTagsFromStream":{"input":{"type":"structure","required":["StreamName","TagKeys"],"members":{"StreamName":{},"TagKeys":{"type":"list","member":{}}}}},"SplitShard":{"input":{"type":"structure","required":["StreamName","ShardToSplit","NewStartingHashKey"],"members":{"StreamName":{},"ShardToSplit":{},"NewStartingHashKey":{}}}},"StartStreamEncryption":{"input":{"type":"structure","required":["StreamName","EncryptionType","KeyId"],"members":{"StreamName":{},"EncryptionType":{},"KeyId":{}}}},"StopStreamEncryption":{"input":{"type":"structure","required":["StreamName","EncryptionType","KeyId"],"members":{"StreamName":{},"EncryptionType":{},"KeyId":{}}}},"UpdateShardCount":{"input":{"type":"structure","required":["StreamName","TargetShardCount","ScalingType"],"members":{"StreamName":{},"TargetShardCount":{"type":"integer"},"ScalingType":{}}},"output":{"type":"structure","members":{"StreamName":{},"CurrentShardCount":{"type":"integer"},"TargetShardCount":{"type":"integer"}}}}},"shapes":{"Sp":{"type":"list","member":{"type":"structure","required":["ShardId","HashKeyRange","SequenceNumberRange"],"members":{"ShardId":{},"ParentShardId":{},"AdjacentParentShardId":{},"HashKeyRange":{"type":"structure","required":["StartingHashKey","EndingHashKey"],"members":{"StartingHashKey":{},"EndingHashKey":{}}},"SequenceNumberRange":{"type":"structure","required":["StartingSequenceNumber"],"members":{"StartingSequenceNumber":{},"EndingSequenceNumber":{}}}}}},"Sw":{"type":"list","member":{"type":"structure","members":{"ShardLevelMetrics":{"shape":"Sy"}}}},"Sy":{"type":"list","member":{}},"S1b":{"type":"structure","members":{"StreamName":{},"CurrentShardLevelMetrics":{"shape":"Sy"},"DesiredShardLevelMetrics":{"shape":"Sy"}}},"S1y":{"type":"structure","required":["ConsumerName","ConsumerARN","ConsumerStatus","ConsumerCreationTimestamp"],"members":{"ConsumerName":{},"ConsumerARN":{},"ConsumerStatus":{},"ConsumerCreationTimestamp":{"type":"timestamp"}}}}}');

});

parcelRequire.register("blELq", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeStream":{"input_token":"ExclusiveStartShardId","limit_key":"Limit","more_results":"StreamDescription.HasMoreShards","output_token":"StreamDescription.Shards[-1].ShardId","result_key":"StreamDescription.Shards"},"ListStreamConsumers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListStreams":{"input_token":"ExclusiveStartStreamName","limit_key":"Limit","more_results":"HasMoreStreams","output_token":"StreamNames[-1]","result_key":"StreamNames"}}}');

});

parcelRequire.register("6QZrc", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"StreamExists":{"delay":10,"operation":"DescribeStream","maxAttempts":18,"acceptors":[{"expected":"ACTIVE","matcher":"path","state":"success","argument":"StreamDescription.StreamStatus"}]},"StreamNotExists":{"delay":10,"operation":"DescribeStream","maxAttempts":18,"acceptors":[{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]}}}');

});



parcelRequire.register("eKe2w", function(module, exports) {
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
parcelRequire("1M8si");
var $bOqq5 = parcelRequire("bOqq5");

var $kPiwT = parcelRequire("kPiwT");
var $abc040921b672607$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $abc040921b672607$var$logger = new (0, $gBqCF.ConsoleLogger)("AWSKineisFirehoseProvider");
var $abc040921b672607$var$AWSKinesisFirehoseProvider = /** @class */ function(_super) {
    $abc040921b672607$var$__extends(AWSKinesisFirehoseProvider, _super);
    function AWSKinesisFirehoseProvider(config) {
        return _super.call(this, config) || this;
    }
    /**
     * get provider name of the plugin
     */ AWSKinesisFirehoseProvider.prototype.getProviderName = function() {
        return "AWSKinesisFirehose";
    };
    AWSKinesisFirehoseProvider.prototype._sendEvents = function(group) {
        var _this = this;
        if (group.length === 0) return;
        var _a = group[0], config = _a.config, credentials = _a.credentials;
        var initClients = this._init(config, credentials);
        if (!initClients) return false;
        var records = {};
        group.map(function(params) {
            // spit by streamName
            var evt = params.event;
            var streamName = evt.streamName;
            if (records[streamName] === undefined) records[streamName] = [];
            var PartitionKey = evt.partitionKey || "partition-" + credentials.identityId;
            Object.assign(evt.data, {
                PartitionKey: PartitionKey
            });
            var Data = JSON.stringify(evt.data);
            var record = {
                Data: Data
            };
            records[streamName].push(record);
        });
        Object.keys(records).map(function(streamName) {
            $abc040921b672607$var$logger.debug("putting records to kinesis", streamName, "with records", records[streamName]);
            _this._kinesisFirehose.putRecordBatch({
                Records: records[streamName],
                DeliveryStreamName: streamName
            }, function(err) {
                if (err) $abc040921b672607$var$logger.debug("Failed to upload records to Kinesis", err);
                else $abc040921b672607$var$logger.debug("Upload records to stream", streamName);
            });
        });
    };
    AWSKinesisFirehoseProvider.prototype._init = function(config, credentials) {
        $abc040921b672607$var$logger.debug("init clients");
        if (this._kinesisFirehose && this._config.credentials && this._config.credentials.sessionToken === credentials.sessionToken && this._config.credentials.identityId === credentials.identityId) {
            $abc040921b672607$var$logger.debug("no change for analytics config, directly return from init");
            return true;
        }
        this._config.credentials = credentials;
        var region = config.region;
        return this._initFirehose(region, credentials);
    };
    AWSKinesisFirehoseProvider.prototype._initFirehose = function(region, credentials) {
        $abc040921b672607$var$logger.debug("initialize kinesis firehose with credentials", credentials);
        this._kinesisFirehose = new $kPiwT({
            apiVersion: "2015-08-04",
            region: region,
            credentials: credentials
        });
        return true;
    };
    return AWSKinesisFirehoseProvider;
}((0, $bOqq5.default));
var $abc040921b672607$export$2e2bcd8739ae039 = $abc040921b672607$var$AWSKinesisFirehoseProvider;

});
parcelRequire.register("kPiwT", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $f296f1a69d2822bb$var$Service = $dbC7k.Service;
var $f296f1a69d2822bb$var$apiLoader = $dbC7k.apiLoader;
$f296f1a69d2822bb$var$apiLoader.services["firehose"] = {};
$dbC7k.Firehose = $f296f1a69d2822bb$var$Service.defineService("firehose", [
    "2015-08-04"
]);


Object.defineProperty($f296f1a69d2822bb$var$apiLoader.services["firehose"], "2015-08-04", {
    get: function get() {
        var model = (parcelRequire("4mCfY"));
        model.paginators = (parcelRequire("fIStW")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Firehose;

});
parcelRequire.register("4mCfY", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-08-04","endpointPrefix":"firehose","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Firehose","serviceFullName":"Amazon Kinesis Firehose","serviceId":"Firehose","signatureVersion":"v4","targetPrefix":"Firehose_20150804","uid":"firehose-2015-08-04"},"operations":{"CreateDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"DeliveryStreamType":{},"KinesisStreamSourceConfiguration":{"type":"structure","required":["KinesisStreamARN","RoleARN"],"members":{"KinesisStreamARN":{},"RoleARN":{}}},"S3DestinationConfiguration":{"shape":"S7","deprecated":true},"ExtendedS3DestinationConfiguration":{"type":"structure","required":["RoleARN","BucketARN"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Sb"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Sf"},"CloudWatchLoggingOptions":{"shape":"Sj"},"ProcessingConfiguration":{"shape":"So"},"S3BackupMode":{},"S3BackupConfiguration":{"shape":"S7"},"DataFormatConversionConfiguration":{"shape":"Sx"}}},"RedshiftDestinationConfiguration":{"type":"structure","required":["RoleARN","ClusterJDBCURL","CopyCommand","Username","Password","S3Configuration"],"members":{"RoleARN":{},"ClusterJDBCURL":{},"CopyCommand":{"shape":"S1o"},"Username":{"shape":"S1s"},"Password":{"shape":"S1t"},"RetryOptions":{"shape":"S1u"},"S3Configuration":{"shape":"S7"},"ProcessingConfiguration":{"shape":"So"},"S3BackupMode":{},"S3BackupConfiguration":{"shape":"S7"},"CloudWatchLoggingOptions":{"shape":"Sj"}}},"ElasticsearchDestinationConfiguration":{"type":"structure","required":["RoleARN","DomainARN","IndexName","TypeName","S3Configuration"],"members":{"RoleARN":{},"DomainARN":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S22"},"RetryOptions":{"shape":"S25"},"S3BackupMode":{},"S3Configuration":{"shape":"S7"},"ProcessingConfiguration":{"shape":"So"},"CloudWatchLoggingOptions":{"shape":"Sj"}}},"SplunkDestinationConfiguration":{"type":"structure","required":["HECEndpoint","HECEndpointType","HECToken","S3Configuration"],"members":{"HECEndpoint":{},"HECEndpointType":{},"HECToken":{},"HECAcknowledgmentTimeoutInSeconds":{"type":"integer"},"RetryOptions":{"shape":"S2d"},"S3BackupMode":{},"S3Configuration":{"shape":"S7"},"ProcessingConfiguration":{"shape":"So"},"CloudWatchLoggingOptions":{"shape":"Sj"}}},"Tags":{"shape":"S2g"}}},"output":{"type":"structure","members":{"DeliveryStreamARN":{}}}},"DeleteDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{}}},"output":{"type":"structure","members":{}}},"DescribeDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"Limit":{"type":"integer"},"ExclusiveStartDestinationId":{}}},"output":{"type":"structure","required":["DeliveryStreamDescription"],"members":{"DeliveryStreamDescription":{"type":"structure","required":["DeliveryStreamName","DeliveryStreamARN","DeliveryStreamStatus","DeliveryStreamType","VersionId","Destinations","HasMoreDestinations"],"members":{"DeliveryStreamName":{},"DeliveryStreamARN":{},"DeliveryStreamStatus":{},"DeliveryStreamEncryptionConfiguration":{"type":"structure","members":{"Status":{}}},"DeliveryStreamType":{},"VersionId":{},"CreateTimestamp":{"type":"timestamp"},"LastUpdateTimestamp":{"type":"timestamp"},"Source":{"type":"structure","members":{"KinesisStreamSourceDescription":{"type":"structure","members":{"KinesisStreamARN":{},"RoleARN":{},"DeliveryStartTimestamp":{"type":"timestamp"}}}}},"Destinations":{"type":"list","member":{"type":"structure","required":["DestinationId"],"members":{"DestinationId":{},"S3DestinationDescription":{"shape":"S33"},"ExtendedS3DestinationDescription":{"type":"structure","required":["RoleARN","BucketARN","BufferingHints","CompressionFormat","EncryptionConfiguration"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Sb"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Sf"},"CloudWatchLoggingOptions":{"shape":"Sj"},"ProcessingConfiguration":{"shape":"So"},"S3BackupMode":{},"S3BackupDescription":{"shape":"S33"},"DataFormatConversionConfiguration":{"shape":"Sx"}}},"RedshiftDestinationDescription":{"type":"structure","required":["RoleARN","ClusterJDBCURL","CopyCommand","Username","S3DestinationDescription"],"members":{"RoleARN":{},"ClusterJDBCURL":{},"CopyCommand":{"shape":"S1o"},"Username":{"shape":"S1s"},"RetryOptions":{"shape":"S1u"},"S3DestinationDescription":{"shape":"S33"},"ProcessingConfiguration":{"shape":"So"},"S3BackupMode":{},"S3BackupDescription":{"shape":"S33"},"CloudWatchLoggingOptions":{"shape":"Sj"}}},"ElasticsearchDestinationDescription":{"type":"structure","members":{"RoleARN":{},"DomainARN":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S22"},"RetryOptions":{"shape":"S25"},"S3BackupMode":{},"S3DestinationDescription":{"shape":"S33"},"ProcessingConfiguration":{"shape":"So"},"CloudWatchLoggingOptions":{"shape":"Sj"}}},"SplunkDestinationDescription":{"type":"structure","members":{"HECEndpoint":{},"HECEndpointType":{},"HECToken":{},"HECAcknowledgmentTimeoutInSeconds":{"type":"integer"},"RetryOptions":{"shape":"S2d"},"S3BackupMode":{},"S3DestinationDescription":{"shape":"S33"},"ProcessingConfiguration":{"shape":"So"},"CloudWatchLoggingOptions":{"shape":"Sj"}}}}}},"HasMoreDestinations":{"type":"boolean"}}}}}},"ListDeliveryStreams":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"DeliveryStreamType":{},"ExclusiveStartDeliveryStreamName":{}}},"output":{"type":"structure","required":["DeliveryStreamNames","HasMoreDeliveryStreams"],"members":{"DeliveryStreamNames":{"type":"list","member":{}},"HasMoreDeliveryStreams":{"type":"boolean"}}}},"ListTagsForDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"ExclusiveStartTagKey":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","required":["Tags","HasMoreTags"],"members":{"Tags":{"type":"list","member":{"shape":"S2h"}},"HasMoreTags":{"type":"boolean"}}}},"PutRecord":{"input":{"type":"structure","required":["DeliveryStreamName","Record"],"members":{"DeliveryStreamName":{},"Record":{"shape":"S3h"}}},"output":{"type":"structure","required":["RecordId"],"members":{"RecordId":{},"Encrypted":{"type":"boolean"}}}},"PutRecordBatch":{"input":{"type":"structure","required":["DeliveryStreamName","Records"],"members":{"DeliveryStreamName":{},"Records":{"type":"list","member":{"shape":"S3h"}}}},"output":{"type":"structure","required":["FailedPutCount","RequestResponses"],"members":{"FailedPutCount":{"type":"integer"},"Encrypted":{"type":"boolean"},"RequestResponses":{"type":"list","member":{"type":"structure","members":{"RecordId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"StartDeliveryStreamEncryption":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{}}},"output":{"type":"structure","members":{}}},"StopDeliveryStreamEncryption":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{}}},"output":{"type":"structure","members":{}}},"TagDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName","Tags"],"members":{"DeliveryStreamName":{},"Tags":{"shape":"S2g"}}},"output":{"type":"structure","members":{}}},"UntagDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName","TagKeys"],"members":{"DeliveryStreamName":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDestination":{"input":{"type":"structure","required":["DeliveryStreamName","CurrentDeliveryStreamVersionId","DestinationId"],"members":{"DeliveryStreamName":{},"CurrentDeliveryStreamVersionId":{},"DestinationId":{},"S3DestinationUpdate":{"shape":"S42","deprecated":true},"ExtendedS3DestinationUpdate":{"type":"structure","members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Sb"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Sf"},"CloudWatchLoggingOptions":{"shape":"Sj"},"ProcessingConfiguration":{"shape":"So"},"S3BackupMode":{},"S3BackupUpdate":{"shape":"S42"},"DataFormatConversionConfiguration":{"shape":"Sx"}}},"RedshiftDestinationUpdate":{"type":"structure","members":{"RoleARN":{},"ClusterJDBCURL":{},"CopyCommand":{"shape":"S1o"},"Username":{"shape":"S1s"},"Password":{"shape":"S1t"},"RetryOptions":{"shape":"S1u"},"S3Update":{"shape":"S42"},"ProcessingConfiguration":{"shape":"So"},"S3BackupMode":{},"S3BackupUpdate":{"shape":"S42"},"CloudWatchLoggingOptions":{"shape":"Sj"}}},"ElasticsearchDestinationUpdate":{"type":"structure","members":{"RoleARN":{},"DomainARN":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S22"},"RetryOptions":{"shape":"S25"},"S3Update":{"shape":"S42"},"ProcessingConfiguration":{"shape":"So"},"CloudWatchLoggingOptions":{"shape":"Sj"}}},"SplunkDestinationUpdate":{"type":"structure","members":{"HECEndpoint":{},"HECEndpointType":{},"HECToken":{},"HECAcknowledgmentTimeoutInSeconds":{"type":"integer"},"RetryOptions":{"shape":"S2d"},"S3BackupMode":{},"S3Update":{"shape":"S42"},"ProcessingConfiguration":{"shape":"So"},"CloudWatchLoggingOptions":{"shape":"Sj"}}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S7":{"type":"structure","required":["RoleARN","BucketARN"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Sb"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Sf"},"CloudWatchLoggingOptions":{"shape":"Sj"}}},"Sb":{"type":"structure","members":{"SizeInMBs":{"type":"integer"},"IntervalInSeconds":{"type":"integer"}}},"Sf":{"type":"structure","members":{"NoEncryptionConfig":{},"KMSEncryptionConfig":{"type":"structure","required":["AWSKMSKeyARN"],"members":{"AWSKMSKeyARN":{}}}}},"Sj":{"type":"structure","members":{"Enabled":{"type":"boolean"},"LogGroupName":{},"LogStreamName":{}}},"So":{"type":"structure","members":{"Enabled":{"type":"boolean"},"Processors":{"type":"list","member":{"type":"structure","required":["Type"],"members":{"Type":{},"Parameters":{"type":"list","member":{"type":"structure","required":["ParameterName","ParameterValue"],"members":{"ParameterName":{},"ParameterValue":{}}}}}}}}},"Sx":{"type":"structure","members":{"SchemaConfiguration":{"type":"structure","members":{"RoleARN":{},"CatalogId":{},"DatabaseName":{},"TableName":{},"Region":{},"VersionId":{}}},"InputFormatConfiguration":{"type":"structure","members":{"Deserializer":{"type":"structure","members":{"OpenXJsonSerDe":{"type":"structure","members":{"ConvertDotsInJsonKeysToUnderscores":{"type":"boolean"},"CaseInsensitive":{"type":"boolean"},"ColumnToJsonKeyMappings":{"type":"map","key":{},"value":{}}}},"HiveJsonSerDe":{"type":"structure","members":{"TimestampFormats":{"type":"list","member":{}}}}}}}},"OutputFormatConfiguration":{"type":"structure","members":{"Serializer":{"type":"structure","members":{"ParquetSerDe":{"type":"structure","members":{"BlockSizeBytes":{"type":"integer"},"PageSizeBytes":{"type":"integer"},"Compression":{},"EnableDictionaryCompression":{"type":"boolean"},"MaxPaddingBytes":{"type":"integer"},"WriterVersion":{}}},"OrcSerDe":{"type":"structure","members":{"StripeSizeBytes":{"type":"integer"},"BlockSizeBytes":{"type":"integer"},"RowIndexStride":{"type":"integer"},"EnablePadding":{"type":"boolean"},"PaddingTolerance":{"type":"double"},"Compression":{},"BloomFilterColumns":{"type":"list","member":{}},"BloomFilterFalsePositiveProbability":{"type":"double"},"DictionaryKeyThreshold":{"type":"double"},"FormatVersion":{}}}}}}},"Enabled":{"type":"boolean"}}},"S1o":{"type":"structure","required":["DataTableName"],"members":{"DataTableName":{},"DataTableColumns":{},"CopyOptions":{}}},"S1s":{"type":"string","sensitive":true},"S1t":{"type":"string","sensitive":true},"S1u":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S22":{"type":"structure","members":{"IntervalInSeconds":{"type":"integer"},"SizeInMBs":{"type":"integer"}}},"S25":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S2d":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S2g":{"type":"list","member":{"shape":"S2h"}},"S2h":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}},"S33":{"type":"structure","required":["RoleARN","BucketARN","BufferingHints","CompressionFormat","EncryptionConfiguration"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Sb"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Sf"},"CloudWatchLoggingOptions":{"shape":"Sj"}}},"S3h":{"type":"structure","required":["Data"],"members":{"Data":{"type":"blob"}}},"S42":{"type":"structure","members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Sb"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Sf"},"CloudWatchLoggingOptions":{"shape":"Sj"}}}}}');

});

parcelRequire.register("fIStW", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});



parcelRequire.register("b3RkR", function(module, exports) {
/*
 * Copyright 2019-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $gssgp = parcelRequire("gssgp");
var $aCVDw = parcelRequire("aCVDw");

var $jXOED = parcelRequire("jXOED");
parcelRequire("fCLmI");
var $1caGC = parcelRequire("1caGC");
var $aKdJu = parcelRequire("aKdJu");

var $j7XhJ = parcelRequire("j7XhJ");
var $80d958dbb9faf80e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $80d958dbb9faf80e$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $80d958dbb9faf80e$var$logger = new (0, $gBqCF.ConsoleLogger)("AmazonPersonalizeProvider");
// events buffer
var $80d958dbb9faf80e$var$FLUSH_SIZE = 5;
var $80d958dbb9faf80e$var$FLUSH_SIZE_THRESHHOLD = 10;
var $80d958dbb9faf80e$var$FLUSH_INTERVAL = 5000; // 5s
var $80d958dbb9faf80e$var$IDENTIFY_EVENT = "Identify";
var $80d958dbb9faf80e$var$AmazonPersonalizeProvider = /** @class */ function() {
    function AmazonPersonalizeProvider(config) {
        this._buffer = [];
        this._config = config ? config : {};
        this._config.flushSize = this._config.flushSize > 0 && this._config.flushSize <= $80d958dbb9faf80e$var$FLUSH_SIZE_THRESHHOLD ? this._config.flushSize : $80d958dbb9faf80e$var$FLUSH_SIZE;
        this._config.flushInterval = this._config.flushInterval || $80d958dbb9faf80e$var$FLUSH_INTERVAL;
        this._sessionManager = new (0, $1caGC.SessionInfoManager)();
        if (!(0, $j7XhJ.isEmpty)(this._config.trackingId)) this._sessionInfo = this._sessionManager.retrieveSessionInfo(this._config.trackingId);
        this._isBrowser = (0, $gssgp.default).browserOrNode().isBrowser;
        // flush event buffer
        this._setupTimer();
    }
    AmazonPersonalizeProvider.prototype._setupTimer = function() {
        if (this._timer) clearInterval(this._timer);
        var _a = this._config, flushSize = _a.flushSize, flushInterval = _a.flushInterval;
        var that = this;
        this._timer = setInterval(function() {
            that._sendFromBuffer();
        }, flushInterval);
    };
    /**
     * Record event
     * @param eventType      - type of the event action. e.g. "Click"
     * @param properties     - properties of the event
     * @return Promise
     */ AmazonPersonalizeProvider.prototype.record = function(params) {
        return $80d958dbb9faf80e$var$__awaiter(this, void 0, void 0, function() {
            var credentials, _a, eventType, properties, requestParams, isLoaded;
            return $80d958dbb9faf80e$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._getCredentials()
                        ];
                    case 1:
                        credentials = _b.sent();
                        if (!credentials) return [
                            2 /*return*/ ,
                            Promise.resolve(false)
                        ];
                        Object.assign(params, {
                            config: this._config,
                            credentials: credentials,
                            sentAt: new Date().getTime() / 1000
                        });
                        _a = params.event, eventType = _a.eventType, properties = _a.properties;
                        if (eventType === $80d958dbb9faf80e$var$IDENTIFY_EVENT) {
                            this._sessionManager.updateSessionInfo(properties && properties.userId ? properties.userId : "", this._sessionInfo);
                            return [
                                2 /*return*/ 
                            ];
                        } else if (!(0, $j7XhJ.isEmpty)(params.event.userId)) this._sessionManager.updateSessionInfo(params.event.userId, this._sessionInfo);
                        requestParams = this.generateRequestParams(params, this._sessionInfo);
                        if (!(eventType === "MediaAutoTrack")) return [
                            3 /*break*/ ,
                            7
                        ];
                        if (!this._isBrowser) return [
                            3 /*break*/ ,
                            5
                        ];
                        if (!!(0, $j7XhJ.isEmpty)((0, $j7XhJ.get)(requestParams, "eventData.properties.domElementId", null))) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.isElementFullyLoaded(this.loadElement, requestParams.eventData.properties["domElementId"], 500, 5)
                        ];
                    case 2:
                        isLoaded = _b.sent();
                        if (isLoaded) new (0, $aKdJu.MediaAutoTrack)(requestParams, this);
                        else $80d958dbb9faf80e$var$logger.debug("Cannot find the media element.");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        $80d958dbb9faf80e$var$logger.debug("Missing domElementId field in 'properties' for MediaAutoTrack event type.");
                        _b.label = 4;
                    case 4:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        $80d958dbb9faf80e$var$logger.debug("MediaAutoTrack only for browser");
                        _b.label = 6;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                    case 7:
                        return [
                            2 /*return*/ ,
                            this.putToBuffer(requestParams)
                        ];
                }
            });
        });
    };
    AmazonPersonalizeProvider.prototype.loadElement = function(domId) {
        return new Promise(function(resolve, reject) {
            if (document.getElementById(domId) && document.getElementById(domId).clientHeight) return resolve(true);
            else return reject(true);
        });
    };
    AmazonPersonalizeProvider.prototype.isElementFullyLoaded = function(operation, params, delay, times) {
        var _this = this;
        var wait = function(ms) {
            return new Promise(function(r) {
                return setTimeout(r, ms);
            });
        };
        return new Promise(function(resolve, reject) {
            return operation(params).then(resolve).catch(function(reason) {
                if (times - 1 > 0) return wait(delay).then(_this.isElementFullyLoaded.bind(null, operation, params, delay, times - 1)).then(resolve).catch(reject);
                return reject(reason);
            });
        });
    };
    /**
     * get the category of the plugin
     */ AmazonPersonalizeProvider.prototype.getCategory = function() {
        return "Analytics";
    };
    /**
     * get provider name of the plugin
     */ AmazonPersonalizeProvider.prototype.getProviderName = function() {
        return "AmazonPersonalize";
    };
    /**
     * configure the plugin
     * @param {Object} config - configuration
     */ AmazonPersonalizeProvider.prototype.configure = function(config) {
        $80d958dbb9faf80e$var$logger.debug("configure Analytics", config);
        var conf = config ? config : {};
        this._config = Object.assign({}, this._config, conf);
        if (!(0, $j7XhJ.isEmpty)(this._config.trackingId)) this._sessionInfo = this._sessionManager.retrieveSessionInfo(this._config.trackingId);
        this._setupTimer();
        return this._config;
    };
    /**
     * Generate the requestParams from customer input params and sessionInfo
     * @private
     * @param eventData      - customer input for event data
     * @param api            - api name
     * @return RequestParams - wrapper object with all information required for make request
     */ AmazonPersonalizeProvider.prototype.generateRequestParams = function(params, sessionInfo) {
        var requestParams = {};
        var _a = params.event, eventType = _a.eventType, properties = _a.properties;
        requestParams.eventData = {
            eventType: eventType,
            properties: properties
        };
        requestParams.sessionInfo = sessionInfo;
        requestParams.sentAt = params.sentAt;
        requestParams.credentials = params.credentials;
        requestParams.config = params.config;
        return requestParams;
    };
    /**
     * record an event
     * @param {Object} params - the params of an event
     */ AmazonPersonalizeProvider.prototype._sendEvents = function(group) {
        var groupLen = group.length;
        if (groupLen === 0) {
            $80d958dbb9faf80e$var$logger.debug("events array is empty, directly return");
            return;
        }
        var _a = group[0], config = _a.config, credentials = _a.credentials, sessionInfo = _a.sessionInfo;
        var initClients = this._init(config, credentials);
        if (!initClients) return false;
        if (groupLen > 0) {
            var events = [];
            for(var i = 0; i < groupLen; i += 1){
                var params = group.shift();
                var eventPayload = this._generateSingleRecordPayload(params, sessionInfo);
                events.push(eventPayload);
            }
            var payload = {};
            payload.trackingId = sessionInfo.trackingId;
            payload.sessionId = sessionInfo.sessionId;
            payload.userId = sessionInfo.userId;
            payload.eventList = events;
            this._personalize.putEvents(payload, function(err, data) {
                if (err) $80d958dbb9faf80e$var$logger.debug("Failed to call putEvents in Personalize", err);
                else $80d958dbb9faf80e$var$logger.debug("Put events");
            });
        }
    };
    /**
     * Put event into buffer
     * @private
     * @param params - params for the event recording
     */ AmazonPersonalizeProvider.prototype.putToBuffer = function(params) {
        if (this._buffer.length < this._config.flushSize) this._buffer.push(params);
        else {
            this._buffer.push(params);
            this._sendFromBuffer();
        }
        return Promise.resolve(true);
    };
    /**
     * flush the buffer and batch sending the request
     * @private
     * @param eventsParams - the buffer for cache the payload
     */ AmazonPersonalizeProvider.prototype._sendFromBuffer = function() {
        var _this = this;
        var size = this._buffer.length;
        if (size <= 0) return;
        var eventsGroups = [];
        var preCred = null;
        var group = [];
        for(var i = 0; i < size; i += 1){
            var currRequestParams = this._buffer.shift();
            var cred = currRequestParams.credentials;
            var sessionInfo = currRequestParams.sessionInfo;
            if (i === 0) {
                group.push(currRequestParams);
                preCred = cred;
            } else if ((0, $j7XhJ.isEqual)(sessionInfo, this._sessionInfo) && cred.sessionToken === preCred.sessionToken && cred.identityId === preCred.identityId) {
                $80d958dbb9faf80e$var$logger.debug("no change for cred, put event in the same group");
                group.push(currRequestParams);
            } else {
                eventsGroups.push(group);
                group = [];
                group.push(currRequestParams);
                preCred = cred;
                this._sessionInfo = sessionInfo;
            }
        }
        eventsGroups.push(group);
        eventsGroups.map(function(group) {
            _this._sendEvents(group);
        });
    };
    /**
     * Generate the record payload for single event
     * @private
     * @param params - RequestParams
     */ AmazonPersonalizeProvider.prototype._generateSingleRecordPayload = function(params, sessionInfo) {
        var eventData = params.eventData, sentAt = params.sentAt;
        var trackPayload = {};
        trackPayload.sentAt = sentAt;
        trackPayload.properties = eventData.properties;
        trackPayload.eventId = this._sessionManager.getTimerKey() + sessionInfo.sessionId;
        trackPayload.eventType = eventData.eventType;
        return trackPayload;
    };
    /**
     * Initialize the personalize client
     * @private
     * @param params - RequestParams
     */ AmazonPersonalizeProvider.prototype._init = function(config, credentials) {
        $80d958dbb9faf80e$var$logger.debug("init clients");
        if (this._personalize && this._config.credentials && this._config.credentials.sessionToken === credentials.sessionToken && this._config.credentials.identityId === credentials.identityId) {
            $80d958dbb9faf80e$var$logger.debug("no change for analytics config, directly return from init");
            return true;
        }
        this._config.credentials = credentials;
        var region = config.region;
        $80d958dbb9faf80e$var$logger.debug("initialize personalize with credentials", credentials);
        this._personalize = new $jXOED({
            apiVersion: "2018-03-22",
            region: region,
            credentials: credentials
        });
        return true;
    };
    /**
     * check if current credentials exists
     * @private
     */ AmazonPersonalizeProvider.prototype._getCredentials = function() {
        var that = this;
        return (0, $aCVDw.default).get().then(function(credentials) {
            if (!credentials) return null;
            $80d958dbb9faf80e$var$logger.debug("set credentials for analytics", that._config.credentials);
            return (0, $aCVDw.default).shear(credentials);
        }).catch(function(err) {
            $80d958dbb9faf80e$var$logger.debug("ensure credentials error", err);
            return null;
        });
    };
    return AmazonPersonalizeProvider;
}();
var $80d958dbb9faf80e$export$2e2bcd8739ae039 = $80d958dbb9faf80e$var$AmazonPersonalizeProvider;

});
parcelRequire.register("jXOED", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $e88ad1e7b2f06825$var$Service = $dbC7k.Service;
var $e88ad1e7b2f06825$var$apiLoader = $dbC7k.apiLoader;
$e88ad1e7b2f06825$var$apiLoader.services["personalizeevents"] = {};
$dbC7k.PersonalizeEvents = $e88ad1e7b2f06825$var$Service.defineService("personalizeevents", [
    "2018-03-22"
]);


Object.defineProperty($e88ad1e7b2f06825$var$apiLoader.services["personalizeevents"], "2018-03-22", {
    get: function get() {
        var model = (parcelRequire("a2YDB"));
        model.paginators = (parcelRequire("f0fm6")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.PersonalizeEvents;

});
parcelRequire.register("a2YDB", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-03-22","endpointPrefix":"personalize-events","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Personalize Events","serviceId":"Personalize Events","signatureVersion":"v4","signingName":"personalize","uid":"personalize-events-2018-03-22"},"operations":{"PutEvents":{"http":{"requestUri":"/events"},"input":{"type":"structure","required":["trackingId","sessionId","eventList"],"members":{"trackingId":{},"userId":{},"sessionId":{},"eventList":{"type":"list","member":{"type":"structure","required":["eventType","properties","sentAt"],"members":{"eventId":{},"eventType":{},"properties":{"jsonvalue":true},"sentAt":{"type":"timestamp"}}}}}}}},"shapes":{}}');

});

parcelRequire.register("f0fm6", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("fCLmI", function(module, exports) {
$parcel$export(module.exports, "SessionInfoManager", function () { return (parcelRequire("1caGC")).SessionInfoManager; });
$parcel$export(module.exports, "MediaAutoTrack", function () { return (parcelRequire("aKdJu")).MediaAutoTrack; });
parcelRequire("1caGC");
parcelRequire("aKdJu");

});
parcelRequire.register("1caGC", function(module, exports) {

$parcel$export(module.exports, "SessionInfoManager", function () { return $0def33857247b900$export$f91cf1cc94c50061; });

var $j7XhJ = parcelRequire("j7XhJ");

var $32hwF = parcelRequire("32hwF");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $gssgp = parcelRequire("gssgp");

var $9x214 = parcelRequire("9x214");
var $0def33857247b900$var$PERSONALIZE_CACHE = "_awsct";
var $0def33857247b900$var$PERSONALIZE_CACHE_USERID = "_awsct_uid";
var $0def33857247b900$var$PERSONALIZE_CACHE_SESSIONID = "_awsct_sid";
var $0def33857247b900$var$DEFAULT_CACHE_PREFIX = "peronslize";
var $0def33857247b900$var$TIMER_INTERVAL = 30000;
var $0def33857247b900$var$DELIMITER = ".";
var $0def33857247b900$var$CACHE_EXPIRY_IN_DAYS = 7;
var $0def33857247b900$var$logger = new (0, $gBqCF.ConsoleLogger)("AmazonPersonalizeProvider");
var $0def33857247b900$export$f91cf1cc94c50061 = /** @class */ function() {
    function SessionInfoManager(prefixKey) {
        if (prefixKey === void 0) prefixKey = "";
        this._isBrowser = (0, $gssgp.default).browserOrNode().isBrowser;
        this._timerKey = (0, $32hwF.v1)().substr(0, 15);
        this._refreshTimer();
    }
    SessionInfoManager.prototype._refreshTimer = function() {
        if (this._timer) clearInterval(this._timer);
        var that = this;
        this._timer = setInterval(function() {
            that._timerKey = (0, $32hwF.v1)().substr(0, 15);
        }, $0def33857247b900$var$TIMER_INTERVAL);
    };
    SessionInfoManager.prototype.storeValue = function(key, value) {
        var today = new Date();
        var expire = new Date();
        expire.setTime(today.getTime() + 86400000 * $0def33857247b900$var$CACHE_EXPIRY_IN_DAYS);
        (0, $9x214.default).setItem(this._getCachePrefix(key), value, {
            expires: expire.getTime()
        });
    };
    SessionInfoManager.prototype.retrieveValue = function(key) {
        return (0, $9x214.default).getItem(this._getCachePrefix(key));
    };
    SessionInfoManager.prototype._getCachePrefix = function(key) {
        if (this._isBrowser) return key + $0def33857247b900$var$DELIMITER + window.location.host;
        return $0def33857247b900$var$DEFAULT_CACHE_PREFIX;
    };
    SessionInfoManager.prototype.getTimerKey = function() {
        return this._timerKey;
    };
    SessionInfoManager.prototype.updateSessionInfo = function(userId, sessionInfo) {
        var existUserId = sessionInfo.userId;
        var existSessionId = sessionInfo.sessionId;
        if (this._isRequireNewSession(userId, existUserId, existSessionId)) {
            var newSessionId = (0, $32hwF.v1)();
            this.storeValue($0def33857247b900$var$PERSONALIZE_CACHE_USERID, userId);
            this.storeValue($0def33857247b900$var$PERSONALIZE_CACHE_SESSIONID, newSessionId);
            sessionInfo.sessionId = newSessionId;
        } else if (this._isRequireUpdateSessionInfo(userId, existUserId, existSessionId)) this.storeValue($0def33857247b900$var$PERSONALIZE_CACHE_USERID, userId);
        sessionInfo.userId = userId;
    };
    SessionInfoManager.prototype._isRequireUpdateSessionInfo = function(userId, cachedSessionUserId, cachedSessionSessionId) {
        // anonymouse => sign in : hasSession && s_userId == null && curr_userId !=null
        var isNoCachedSession = (0, $j7XhJ.isEmpty)(cachedSessionSessionId);
        return !isNoCachedSession && (0, $j7XhJ.isEmpty)(cachedSessionUserId) && !(0, $j7XhJ.isEmpty)(userId);
    };
    SessionInfoManager.prototype.retrieveSessionInfo = function(trackingId) {
        var sessionInfo = {};
        sessionInfo.trackingId = trackingId;
        sessionInfo.sessionId = this.retrieveValue($0def33857247b900$var$PERSONALIZE_CACHE_SESSIONID);
        sessionInfo.userId = this.retrieveValue($0def33857247b900$var$PERSONALIZE_CACHE_USERID);
        if ((0, $j7XhJ.isEmpty)(sessionInfo.sessionId)) {
            sessionInfo.sessionId = (0, $32hwF.v1)();
            this.storeValue($0def33857247b900$var$PERSONALIZE_CACHE_SESSIONID, sessionInfo.sessionId);
        }
        this.storeValue($0def33857247b900$var$PERSONALIZE_CACHE, trackingId);
        return sessionInfo;
    };
    SessionInfoManager.prototype._isRequireNewSession = function(userId, cachedSessionUserId, cachedSessionSessionId) {
        // new session => 1. no cached session info 2. signOut: s_userId !=null && curr_userId ==null
        // 3. switch account: s_userId !=null && curr_userId !=null && s_userId != curr_userId
        var isNoCachedSession = (0, $j7XhJ.isEmpty)(cachedSessionSessionId);
        var isSignoutCase = (0, $j7XhJ.isEmpty)(userId) && !(0, $j7XhJ.isEmpty)(cachedSessionUserId);
        var isSwitchUserCase = !(0, $j7XhJ.isEmpty)(userId) && !(0, $j7XhJ.isEmpty)(cachedSessionUserId) && !(0, $j7XhJ.isEqual)(userId, cachedSessionUserId);
        return isNoCachedSession || isSignoutCase || isSwitchUserCase;
    };
    return SessionInfoManager;
}();

});
parcelRequire.register("j7XhJ", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});


parcelRequire.register("aKdJu", function(module, exports) {

$parcel$export(module.exports, "MediaAutoTrack", function () { return $7d28da49331f0150$export$103596046efc704a; });
var $7d28da49331f0150$var$HTML5_MEDIA_EVENT;
(function(HTML5_MEDIA_EVENT) {
    HTML5_MEDIA_EVENT["PLAY"] = "play";
    HTML5_MEDIA_EVENT["PAUSE"] = "pause";
    HTML5_MEDIA_EVENT["ENDED"] = "Ended";
})($7d28da49331f0150$var$HTML5_MEDIA_EVENT || ($7d28da49331f0150$var$HTML5_MEDIA_EVENT = {}));
var $7d28da49331f0150$var$MEDIA_TYPE;
(function(MEDIA_TYPE) {
    MEDIA_TYPE["IFRAME"] = "IFRAME";
    MEDIA_TYPE["VIDEO"] = "VIDEO";
    MEDIA_TYPE["AUDIO"] = "AUDIO";
})($7d28da49331f0150$var$MEDIA_TYPE || ($7d28da49331f0150$var$MEDIA_TYPE = {}));
var $7d28da49331f0150$var$EVENT_TYPE;
(function(EVENT_TYPE) {
    EVENT_TYPE["PLAY"] = "Play";
    EVENT_TYPE["ENDED"] = "Ended";
    EVENT_TYPE["PAUSE"] = "Pause";
    EVENT_TYPE["TIME_WATCHED"] = "TimeWatched";
})($7d28da49331f0150$var$EVENT_TYPE || ($7d28da49331f0150$var$EVENT_TYPE = {}));
var $7d28da49331f0150$export$103596046efc704a = /** @class */ function() {
    function MediaAutoTrack(params, provider) {
        var _a;
        this.eventActionMapping = (_a = {}, _a[$7d28da49331f0150$var$EVENT_TYPE.ENDED] = this.endedEventAction.bind(this), _a[$7d28da49331f0150$var$EVENT_TYPE.PLAY] = this.playEventAction.bind(this), _a[$7d28da49331f0150$var$EVENT_TYPE.PAUSE] = this.pauseEventAction.bind(this), _a);
        var eventData = params.eventData;
        this._params = params;
        this._mediaElement = document.getElementById(eventData.properties["domElementId"]);
        this._started = false;
        this._provider = provider;
        var mediaTrackFunMapping = {
            IFRAME: this._iframeMediaTracker,
            VIDEO: this._html5MediaTracker,
            AUDIO: this._html5MediaTracker
        };
        mediaTrackFunMapping[this._mediaElement.tagName].bind(this)();
        this._initYoutubeFrame();
    }
    MediaAutoTrack.prototype._initYoutubeFrame = function() {
        this._youTubeIframeLoader = {
            src: "https://www.youtube.com/iframe_api",
            loading: false,
            loaded: false,
            listeners: [],
            load: function(callback) {
                var _this = this;
                this.listeners.push(callback);
                if (this.loaded) {
                    setTimeout(function() {
                        _this.done();
                    });
                    return;
                }
                if (this.loading) return;
                this.loading = true;
                window["onYouTubeIframeAPIReady"] = function() {
                    _this.loaded = true;
                    _this.done();
                };
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src = this.src;
                document.body.appendChild(script);
            },
            done: function() {
                delete window["onYouTubeIframeAPIReady"];
                while(this.listeners.length)this.listeners.pop()(window["YT"]);
            }
        };
    };
    MediaAutoTrack.prototype._iframeMediaTracker = function() {
        var that = this;
        setInterval(function() {
            if (that._started) that.recordEvent($7d28da49331f0150$var$MEDIA_TYPE.IFRAME, $7d28da49331f0150$var$EVENT_TYPE.TIME_WATCHED);
        }, 3000);
        this._youTubeIframeLoader.load(function(YT) {
            that._iframePlayer = new YT.Player(that._mediaElement.id, {
                events: {
                    onStateChange: that._onPlayerStateChange.bind(that)
                }
            });
        });
    };
    MediaAutoTrack.prototype._onPlayerStateChange = function(event) {
        var iframeEventMapping = {
            0: $7d28da49331f0150$var$EVENT_TYPE.ENDED,
            1: $7d28da49331f0150$var$EVENT_TYPE.PLAY,
            2: $7d28da49331f0150$var$EVENT_TYPE.PAUSE
        };
        var eventType = iframeEventMapping[event.data];
        if (eventType) this.eventActionMapping[eventType]($7d28da49331f0150$var$MEDIA_TYPE.IFRAME);
    };
    MediaAutoTrack.prototype._html5MediaTracker = function() {
        var that = this;
        setInterval(function() {
            if (that._started) that.recordEvent($7d28da49331f0150$var$MEDIA_TYPE.VIDEO, $7d28da49331f0150$var$EVENT_TYPE.TIME_WATCHED);
        }, 3000);
        this._mediaElement.addEventListener($7d28da49331f0150$var$HTML5_MEDIA_EVENT.PLAY, function() {
            that.eventActionMapping[$7d28da49331f0150$var$EVENT_TYPE.PLAY]($7d28da49331f0150$var$MEDIA_TYPE.VIDEO);
        }, false);
        this._mediaElement.addEventListener($7d28da49331f0150$var$HTML5_MEDIA_EVENT.PAUSE, function() {
            that.eventActionMapping[$7d28da49331f0150$var$EVENT_TYPE.PAUSE]($7d28da49331f0150$var$MEDIA_TYPE.VIDEO);
        }, false);
        this._mediaElement.addEventListener($7d28da49331f0150$var$HTML5_MEDIA_EVENT.ENDED, function() {
            that.eventActionMapping[$7d28da49331f0150$var$EVENT_TYPE.ENDED]($7d28da49331f0150$var$MEDIA_TYPE.VIDEO);
        }, false);
    };
    MediaAutoTrack.prototype.playEventAction = function(mediaType) {
        this._started = true;
        this.recordEvent(mediaType, $7d28da49331f0150$var$EVENT_TYPE.PLAY);
    };
    MediaAutoTrack.prototype.pauseEventAction = function(mediaType) {
        this._started = false;
        this.recordEvent(mediaType, $7d28da49331f0150$var$EVENT_TYPE.PAUSE);
    };
    MediaAutoTrack.prototype.endedEventAction = function(mediaType) {
        this._started = false;
        this.recordEvent(mediaType, $7d28da49331f0150$var$EVENT_TYPE.ENDED);
    };
    MediaAutoTrack.prototype.recordEvent = function(mediaType, eventType) {
        var newParams = Object.assign({}, this._params);
        var eventData = newParams.eventData;
        eventData.eventType = eventType;
        if (mediaType === $7d28da49331f0150$var$MEDIA_TYPE.VIDEO) {
            eventData.properties.timestamp = this._mediaElement.currentTime;
            eventData.properties.duration = this._mediaElement.duration;
        } else {
            eventData.properties.timestamp = this._financial(this._iframePlayer.getCurrentTime());
            eventData.properties.duration = this._financial(this._iframePlayer.getDuration());
        }
        var percentage = parseFloat(eventData.properties.timestamp) / parseFloat(eventData.properties.duration);
        eventData.properties.eventValue = Number(percentage.toFixed(4));
        delete eventData.properties.domElementId;
        this._provider.putToBuffer(newParams);
    };
    MediaAutoTrack.prototype._financial = function(x) {
        return Number.parseFloat(x).toFixed(4);
    };
    return MediaAutoTrack;
}();

});





parcelRequire.register("hbz3E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c82ea885648acf21$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $5OX7i = parcelRequire("5OX7i");
parcelRequire("3xxnP");
var $4myfH = parcelRequire("4myfH");
var $2YUd1 = parcelRequire("2YUd1");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $2hWDt = parcelRequire("2hWDt");
var $c82ea885648acf21$var$logger = new (0, $gBqCF.ConsoleLogger)("Auth");
var $c82ea885648acf21$var$_instance = null;
if (!$c82ea885648acf21$var$_instance) {
    $c82ea885648acf21$var$logger.debug("Create Auth Instance");
    $c82ea885648acf21$var$_instance = new (0, $5OX7i.default)(null);
}
var $c82ea885648acf21$var$Auth = $c82ea885648acf21$var$_instance;
(0, $2hWDt.default).register($c82ea885648acf21$var$Auth);
var $c82ea885648acf21$export$2e2bcd8739ae039 = $c82ea885648acf21$var$Auth;

});
parcelRequire.register("5OX7i", function(module, exports) {

$parcel$export(module.exports, "CognitoHostedUIIdentityProvider", function () { return $43cf7a9c36e82c0e$export$eeb013770cb92342; });
$parcel$export(module.exports, "default", function () { return $43cf7a9c36e82c0e$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("lV7tM");
var $6ZRLT = parcelRequire("6ZRLT");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $iZUWK = parcelRequire("iZUWK");
var $blxMe = parcelRequire("blxMe");
var $2hWDt = parcelRequire("2hWDt");
var $hlQms = parcelRequire("hlQms");
var $33IrZ = parcelRequire("33IrZ");
var $aCVDw = parcelRequire("aCVDw");
var $gssgp = parcelRequire("gssgp");
parcelRequire("3xxnP");
var $2YUd1 = parcelRequire("2YUd1");
var $lihsy = parcelRequire("lihsy");
var $gYRRU = parcelRequire("gYRRU");
var $kdPCY = parcelRequire("kdPCY");
var $dTtsJ = parcelRequire("dTtsJ");
var $VNeTv = parcelRequire("VNeTv");
var $M7FPA = parcelRequire("M7FPA");
var $3kONY = parcelRequire("3kONY");
var $4myfH = parcelRequire("4myfH");

var $i3eDV = parcelRequire("i3eDV");

var $7p6WT = parcelRequire("7p6WT");

var $hkawN = parcelRequire("hkawN");

var $8e3hn = parcelRequire("8e3hn");

var $6ZRLT = parcelRequire("6ZRLT");
var $43cf7a9c36e82c0e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $43cf7a9c36e82c0e$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $43cf7a9c36e82c0e$var$logger = new (0, $gBqCF.ConsoleLogger)("AuthClass");
var $43cf7a9c36e82c0e$var$USER_ADMIN_SCOPE = "aws.cognito.signin.user.admin";
var $43cf7a9c36e82c0e$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var $43cf7a9c36e82c0e$var$dispatchAuthEvent = function(event, data, message) {
    (0, $iZUWK.default).dispatch("auth", {
        event: event,
        data: data,
        message: message
    }, "Auth", $43cf7a9c36e82c0e$var$AMPLIFY_SYMBOL);
};
var $43cf7a9c36e82c0e$export$eeb013770cb92342;
(function(CognitoHostedUIIdentityProvider) {
    CognitoHostedUIIdentityProvider["Cognito"] = "COGNITO";
    CognitoHostedUIIdentityProvider["Google"] = "Google";
    CognitoHostedUIIdentityProvider["Facebook"] = "Facebook";
    CognitoHostedUIIdentityProvider["Amazon"] = "LoginWithAmazon";
})($43cf7a9c36e82c0e$export$eeb013770cb92342 || ($43cf7a9c36e82c0e$export$eeb013770cb92342 = {}));
/**
 * Provide authentication steps
 */ var $43cf7a9c36e82c0e$var$AuthClass = /** @class */ function() {
    /**
     * Initialize Auth with AWS configurations
     * @param {Object} config - Configuration of the Auth
     */ function AuthClass(config) {
        var _this = this;
        this.userPool = null;
        this.user = null;
        this.configure(config);
        this.currentUserCredentials = this.currentUserCredentials.bind(this);
        if ((0, $blxMe).config) (0, $blxMe).config.update({
            customUserAgent: (0, $2hWDt.Constants).userAgent
        });
        else $43cf7a9c36e82c0e$var$logger.warn("No AWS.config");
        (0, $iZUWK.default).listen("auth", function(_a) {
            var payload = _a.payload;
            var event = payload.event;
            switch(event){
                case "signIn":
                    _this._storage.setItem("amplify-signin-with-hostedUI", "false");
                    break;
                case "signOut":
                    _this._storage.removeItem("amplify-signin-with-hostedUI");
                    break;
                case "cognitoHostedUI":
                    _this._storage.setItem("amplify-signin-with-hostedUI", "true");
                    break;
            }
        });
    }
    AuthClass.prototype.getModuleName = function() {
        return "Auth";
    };
    AuthClass.prototype.configure = function(config) {
        var _this = this;
        if (!config) return this._config || {};
        $43cf7a9c36e82c0e$var$logger.debug("configure Auth");
        var conf = Object.assign({}, this._config, (0, $hlQms.default).parseMobilehubConfig(config).Auth, config);
        this._config = conf;
        var _a = this._config, userPoolId = _a.userPoolId, userPoolWebClientId = _a.userPoolWebClientId, cookieStorage = _a.cookieStorage, oauth = _a.oauth, region = _a.region, identityPoolId = _a.identityPoolId, mandatorySignIn = _a.mandatorySignIn, refreshHandlers = _a.refreshHandlers, identityPoolRegion = _a.identityPoolRegion, clientMetadata = _a.clientMetadata;
        if (!this._config.storage) {
            // backward compatbility
            if (cookieStorage) this._storage = new (0, $2YUd1.default)(cookieStorage);
            else this._storage = new (0, $33IrZ.default)().getStorage();
        } else {
            if (!this._isValidAuthStorage(this._config.storage)) {
                $43cf7a9c36e82c0e$var$logger.error("The storage in the Auth config is not valid!");
                throw new Error("Empty storage object");
            }
            this._storage = this._config.storage;
        }
        this._storageSync = Promise.resolve();
        if (typeof this._storage["sync"] === "function") this._storageSync = this._storage["sync"]();
        if (userPoolId) {
            var userPoolData = {
                UserPoolId: userPoolId,
                ClientId: userPoolWebClientId
            };
            userPoolData.Storage = this._storage;
            this.userPool = new (0, $lihsy.default)(userPoolData);
        }
        (0, $aCVDw.default).configure({
            mandatorySignIn: mandatorySignIn,
            region: identityPoolRegion || region,
            userPoolId: userPoolId,
            identityPoolId: identityPoolId,
            refreshHandlers: refreshHandlers,
            storage: this._storage
        });
        // initiailize cognitoauth client if hosted ui options provided
        // to keep backward compatibility:
        var cognitoHostedUIConfig = oauth ? (0, $6ZRLT.isCognitoHostedOpts)(this._config.oauth) ? oauth : oauth.awsCognito : undefined;
        if (cognitoHostedUIConfig) {
            var cognitoAuthParams = Object.assign({
                cognitoClientId: userPoolWebClientId,
                UserPoolId: userPoolId,
                domain: cognitoHostedUIConfig["domain"],
                scopes: cognitoHostedUIConfig["scope"],
                redirectSignIn: cognitoHostedUIConfig["redirectSignIn"],
                redirectSignOut: cognitoHostedUIConfig["redirectSignOut"],
                responseType: cognitoHostedUIConfig["responseType"],
                Storage: this._storage,
                urlOpener: cognitoHostedUIConfig["urlOpener"],
                clientMetadata: clientMetadata
            }, cognitoHostedUIConfig["options"]);
            this._oAuthHandler = new (0, $7p6WT.default)({
                scopes: cognitoAuthParams.scopes,
                config: cognitoAuthParams,
                cognitoClientId: cognitoAuthParams.cognitoClientId
            });
            // **NOTE** - Remove this in a future major release as it is a breaking change
            // Prevents _handleAuthResponse from being called multiple times in Expo
            // See https://github.com/aws-amplify/amplify-js/issues/4388
            var usedResponseUrls_1 = {};
            (0, $hkawN.default)(function(_a) {
                var url = _a.url;
                if (usedResponseUrls_1[url]) return;
                usedResponseUrls_1[url] = true;
                _this._handleAuthResponse(url);
            });
        }
        $43cf7a9c36e82c0e$var$dispatchAuthEvent("configured", null, "The Auth category has been configured successfully");
        return this._config;
    };
    /**
     * Sign up with username, password and other attributes like phone, email
     * @param {String | object} params - The user attributes used for signin
     * @param {String[]} restOfAttrs - for the backward compatability
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.signUp = function(params) {
        var _this = this;
        var restOfAttrs = [];
        for(var _i = 1; _i < arguments.length; _i++)restOfAttrs[_i - 1] = arguments[_i];
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var attributes = [];
        var validationData = null;
        var clientMetadata;
        if (params && typeof params === "string") {
            username = params;
            password = restOfAttrs ? restOfAttrs[0] : null;
            var email = restOfAttrs ? restOfAttrs[1] : null;
            var phone_number = restOfAttrs ? restOfAttrs[2] : null;
            if (email) attributes.push({
                Name: "email",
                Value: email
            });
            if (phone_number) attributes.push({
                Name: "phone_number",
                Value: phone_number
            });
        } else if (params && typeof params === "object") {
            username = params["username"];
            password = params["password"];
            if (params && params.clientMetadata) clientMetadata = params.clientMetadata;
            else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
            var attrs_1 = params["attributes"];
            if (attrs_1) Object.keys(attrs_1).map(function(key) {
                var ele = {
                    Name: key,
                    Value: attrs_1[key]
                };
                attributes.push(ele);
            });
            validationData = params["validationData"] || null;
        } else return this.rejectAuthError((0, $6ZRLT.AuthErrorTypes).SignUpError);
        if (!username) return this.rejectAuthError((0, $6ZRLT.AuthErrorTypes).EmptyUsername);
        if (!password) return this.rejectAuthError((0, $6ZRLT.AuthErrorTypes).EmptyPassword);
        $43cf7a9c36e82c0e$var$logger.debug("signUp attrs:", attributes);
        $43cf7a9c36e82c0e$var$logger.debug("signUp validation data:", validationData);
        return new Promise(function(resolve, reject) {
            _this.userPool.signUp(username, password, attributes, validationData, function(err, data) {
                if (err) {
                    $43cf7a9c36e82c0e$var$dispatchAuthEvent("signUp_failure", err, username + " failed to signup");
                    reject(err);
                } else {
                    $43cf7a9c36e82c0e$var$dispatchAuthEvent("signUp", data, username + " has signed up successfully");
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    /**
     * Send the verfication code to confirm sign up
     * @param {String} username - The username to be confirmed
     * @param {String} code - The verification code
     * @param {ConfirmSignUpOptions} options - other options for confirm signup
     * @return - A promise resolves callback data if success
     */ AuthClass.prototype.confirmSignUp = function(username, code, options) {
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $6ZRLT.AuthErrorTypes).EmptyUsername);
        if (!code) return this.rejectAuthError((0, $6ZRLT.AuthErrorTypes).EmptyCode);
        var user = this.createCognitoUser(username);
        var forceAliasCreation = options && typeof options.forceAliasCreation === "boolean" ? options.forceAliasCreation : true;
        var clientMetadata;
        if (options && options.clientMetadata) clientMetadata = options.clientMetadata;
        else if (this._config.clientMetadata) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.confirmRegistration(code, forceAliasCreation, function(err, data) {
                if (err) reject(err);
                else resolve(data);
            }, clientMetadata);
        });
    };
    /**
     * Resend the verification code
     * @param {String} username - The username to be confirmed
     * @param {ClientMetadata} clientMetadata - Metadata to be passed to Cognito Lambda triggers
     * @return - A promise resolves data if success
     */ AuthClass.prototype.resendSignUp = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $6ZRLT.AuthErrorTypes).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.resendConfirmationCode(function(err, data) {
                if (err) reject(err);
                else resolve(data);
            }, clientMetadata);
        });
    };
    /**
     * Sign in
     * @param {String | SignInOpts} usernameOrSignInOpts - The username to be signed in or the sign in options
     * @param {String} password - The password of the username
     * @return - A promise resolves the CognitoUser
     */ AuthClass.prototype.signIn = function(usernameOrSignInOpts, pw, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        var username = null;
        var password = null;
        var validationData = {};
        // for backward compatibility
        if (typeof usernameOrSignInOpts === "string") {
            username = usernameOrSignInOpts;
            password = pw;
        } else if ((0, $6ZRLT.isUsernamePasswordOpts)(usernameOrSignInOpts)) {
            if (typeof pw !== "undefined") $43cf7a9c36e82c0e$var$logger.warn("The password should be defined under the first parameter object!");
            username = usernameOrSignInOpts.username;
            password = usernameOrSignInOpts.password;
            validationData = usernameOrSignInOpts.validationData;
        } else return this.rejectAuthError((0, $6ZRLT.AuthErrorTypes).InvalidUsername);
        if (!username) return this.rejectAuthError((0, $6ZRLT.AuthErrorTypes).EmptyUsername);
        var authDetails = new (0, $gYRRU.default)({
            Username: username,
            Password: password,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        });
        if (password) return this.signInWithPassword(authDetails);
        else return this.signInWithoutPassword(authDetails);
    };
    /**
     * Return an object with the authentication callbacks
     * @param {CognitoUser} user - the cognito user object
     * @param {} resolve - function called when resolving the current step
     * @param {} reject - function called when rejecting the current step
     * @return - an object with the callback methods for user authentication
     */ AuthClass.prototype.authCallbacks = function(user, resolve, reject) {
        var _this = this;
        var that = this;
        return {
            onSuccess: function(session) {
                return $43cf7a9c36e82c0e$var$__awaiter(_this, void 0, void 0, function() {
                    var cred, e_1, currentUser, e_2;
                    return $43cf7a9c36e82c0e$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                $43cf7a9c36e82c0e$var$logger.debug(session);
                                delete user["challengeName"];
                                delete user["challengeParam"];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    4,
                                    5,
                                    9
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    (0, $aCVDw.default).clear()
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    (0, $aCVDw.default).set(session, "session")
                                ];
                            case 3:
                                cred = _a.sent();
                                $43cf7a9c36e82c0e$var$logger.debug("succeed to get cognito credentials", cred);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 4:
                                e_1 = _a.sent();
                                $43cf7a9c36e82c0e$var$logger.debug("cannot get cognito credentials", e_1);
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 5:
                                _a.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.currentUserPoolUser()
                                ];
                            case 6:
                                currentUser = _a.sent();
                                that.user = currentUser;
                                $43cf7a9c36e82c0e$var$dispatchAuthEvent("signIn", currentUser, "A user " + user.getUsername() + " has been signed in");
                                resolve(currentUser);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 7:
                                e_2 = _a.sent();
                                $43cf7a9c36e82c0e$var$logger.error("Failed to get the signed in user", e_2);
                                reject(e_2);
                                return [
                                    3 /*break*/ ,
                                    8
                                ];
                            case 8:
                                return [
                                    7 /*endfinally*/ 
                                ];
                            case 9:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            },
            onFailure: function(err) {
                $43cf7a9c36e82c0e$var$logger.debug("signIn failure", err);
                $43cf7a9c36e82c0e$var$dispatchAuthEvent("signIn_failure", err, user.getUsername() + " failed to signin");
                reject(err);
            },
            customChallenge: function(challengeParam) {
                $43cf7a9c36e82c0e$var$logger.debug("signIn custom challenge answer required");
                user["challengeName"] = "CUSTOM_CHALLENGE";
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            mfaRequired: function(challengeName, challengeParam) {
                $43cf7a9c36e82c0e$var$logger.debug("signIn MFA required");
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            mfaSetup: function(challengeName, challengeParam) {
                $43cf7a9c36e82c0e$var$logger.debug("signIn mfa setup", challengeName);
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            newPasswordRequired: function(userAttributes, requiredAttributes) {
                $43cf7a9c36e82c0e$var$logger.debug("signIn new password");
                user["challengeName"] = "NEW_PASSWORD_REQUIRED";
                user["challengeParam"] = {
                    userAttributes: userAttributes,
                    requiredAttributes: requiredAttributes
                };
                resolve(user);
            },
            totpRequired: function(challengeName, challengeParam) {
                $43cf7a9c36e82c0e$var$logger.debug("signIn totpRequired");
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            },
            selectMFAType: function(challengeName, challengeParam) {
                $43cf7a9c36e82c0e$var$logger.debug("signIn selectMFAType", challengeName);
                user["challengeName"] = challengeName;
                user["challengeParam"] = challengeParam;
                resolve(user);
            }
        };
    };
    /**
     * Sign in with a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithPassword = function(authDetails) {
        var _this = this;
        var user = this.createCognitoUser(authDetails.getUsername());
        return new Promise(function(resolve, reject) {
            user.authenticateUser(authDetails, _this.authCallbacks(user, resolve, reject));
        });
    };
    /**
     * Sign in without a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */ AuthClass.prototype.signInWithoutPassword = function(authDetails) {
        var _this = this;
        var user = this.createCognitoUser(authDetails.getUsername());
        user.setAuthenticationFlowType("CUSTOM_AUTH");
        return new Promise(function(resolve, reject) {
            user.initiateAuth(authDetails, _this.authCallbacks(user, resolve, reject));
        });
    };
    /**
     * get user current preferred mfa option
     * this method doesn't work with totp, we need to deprecate it.
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves the current preferred mfa option if success
     */ AuthClass.prototype.getMFAOptions = function(user) {
        return new Promise(function(res, rej) {
            user.getMFAOptions(function(err, mfaOptions) {
                if (err) {
                    $43cf7a9c36e82c0e$var$logger.debug("get MFA Options failed", err);
                    rej(err);
                    return;
                }
                $43cf7a9c36e82c0e$var$logger.debug("get MFA options success", mfaOptions);
                res(mfaOptions);
                return;
            });
        });
    };
    /**
     * get preferred mfa method
     * @param {CognitoUser} user - the current cognito user
     * @param {GetPreferredMFAOpts} params - options for getting the current user preferred MFA
     */ AuthClass.prototype.getPreferredMFA = function(user, params) {
        var that = this;
        return new Promise(function(res, rej) {
            var bypassCache = params ? params.bypassCache : false;
            user.getUserData(function(err, data) {
                if (err) {
                    $43cf7a9c36e82c0e$var$logger.debug("getting preferred mfa failed", err);
                    rej(err);
                    return;
                }
                var mfaType = that._getMfaTypeFromUserData(data);
                if (!mfaType) {
                    rej("invalid MFA Type");
                    return;
                } else {
                    res(mfaType);
                    return;
                }
            }, {
                bypassCache: bypassCache
            });
        });
    };
    AuthClass.prototype._getMfaTypeFromUserData = function(data) {
        var ret = null;
        var preferredMFA = data.PreferredMfaSetting;
        // if the user has used Auth.setPreferredMFA() to setup the mfa type
        // then the "PreferredMfaSetting" would exist in the response
        if (preferredMFA) ret = preferredMFA;
        else {
            // if mfaList exists but empty, then its noMFA
            var mfaList = data.UserMFASettingList;
            if (!mfaList) {
                // if SMS was enabled by using Auth.enableSMS(),
                // the response would contain MFAOptions
                // as for now Cognito only supports for SMS, so we will say it is 'SMS_MFA'
                // if it does not exist, then it should be NOMFA
                var MFAOptions = data.MFAOptions;
                if (MFAOptions) ret = "SMS_MFA";
                else ret = "NOMFA";
            } else if (mfaList.length === 0) ret = "NOMFA";
            else $43cf7a9c36e82c0e$var$logger.debug("invalid case for getPreferredMFA", data);
        }
        return ret;
    };
    AuthClass.prototype._getUserData = function(user, params) {
        return new Promise(function(res, rej) {
            user.getUserData(function(err, data) {
                if (err) {
                    $43cf7a9c36e82c0e$var$logger.debug("getting user data failed", err);
                    rej(err);
                    return;
                } else {
                    res(data);
                    return;
                }
            }, params);
        });
    };
    /**
     * set preferred MFA method
     * @param {CognitoUser} user - the current Cognito user
     * @param {string} mfaMethod - preferred mfa method
     * @return - A promise resolve if success
     */ AuthClass.prototype.setPreferredMFA = function(user, mfaMethod) {
        return $43cf7a9c36e82c0e$var$__awaiter(this, void 0, void 0, function() {
            var userData, smsMfaSettings, totpMfaSettings, _a, mfaList, currentMFAType, that;
            return $43cf7a9c36e82c0e$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._getUserData(user, {
                                bypassCache: true
                            })
                        ];
                    case 1:
                        userData = _b.sent();
                        smsMfaSettings = null;
                        totpMfaSettings = null;
                        _a = mfaMethod;
                        switch(_a){
                            case "TOTP":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case "SMS":
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case "NOMFA":
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 2:
                        totpMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 3:
                        smsMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true
                        };
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 4:
                        mfaList = userData["UserMFASettingList"];
                        return [
                            4 /*yield*/ ,
                            this._getMfaTypeFromUserData(userData)
                        ];
                    case 5:
                        currentMFAType = _b.sent();
                        if (currentMFAType === "NOMFA") return [
                            2 /*return*/ ,
                            Promise.resolve("No change for mfa type")
                        ];
                        else if (currentMFAType === "SMS_MFA") smsMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else if (currentMFAType === "SOFTWARE_TOKEN_MFA") totpMfaSettings = {
                            PreferredMfa: false,
                            Enabled: false
                        };
                        else return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, $6ZRLT.AuthErrorTypes).InvalidMFA)
                        ];
                        // if there is a UserMFASettingList in the response
                        // we need to disable every mfa type in that list
                        if (mfaList && mfaList.length !== 0) // to disable SMS or TOTP if exists in that list
                        mfaList.forEach(function(mfaType) {
                            if (mfaType === "SMS_MFA") smsMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                            else if (mfaType === "SOFTWARE_TOKEN_MFA") totpMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false
                            };
                        });
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        $43cf7a9c36e82c0e$var$logger.debug("no validmfa method provided");
                        return [
                            2 /*return*/ ,
                            this.rejectAuthError((0, $6ZRLT.AuthErrorTypes).NoMFA)
                        ];
                    case 7:
                        that = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                user.setUserMfaPreference(smsMfaSettings, totpMfaSettings, function(err, result) {
                                    if (err) {
                                        $43cf7a9c36e82c0e$var$logger.debug("Set user mfa preference error", err);
                                        return rej(err);
                                    }
                                    $43cf7a9c36e82c0e$var$logger.debug("Set user mfa success", result);
                                    $43cf7a9c36e82c0e$var$logger.debug("Caching the latest user data into local");
                                    // cache the latest result into user data
                                    user.getUserData(function(err, data) {
                                        if (err) {
                                            $43cf7a9c36e82c0e$var$logger.debug("getting user data failed", err);
                                            return rej(err);
                                        } else return res(result);
                                    }, {
                                        bypassCache: true
                                    });
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * diable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.disableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.disableMFA(function(err, data) {
                if (err) {
                    $43cf7a9c36e82c0e$var$logger.debug("disable mfa failed", err);
                    rej(err);
                    return;
                }
                $43cf7a9c36e82c0e$var$logger.debug("disable mfa succeed", data);
                res(data);
                return;
            });
        });
    };
    /**
     * enable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */ AuthClass.prototype.enableSMS = function(user) {
        return new Promise(function(res, rej) {
            user.enableMFA(function(err, data) {
                if (err) {
                    $43cf7a9c36e82c0e$var$logger.debug("enable mfa failed", err);
                    rej(err);
                    return;
                }
                $43cf7a9c36e82c0e$var$logger.debug("enable mfa succeed", data);
                res(data);
                return;
            });
        });
    };
    /**
     * Setup TOTP
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves with the secret code if success
     */ AuthClass.prototype.setupTOTP = function(user) {
        return new Promise(function(res, rej) {
            user.associateSoftwareToken({
                onFailure: function(err) {
                    $43cf7a9c36e82c0e$var$logger.debug("associateSoftwareToken failed", err);
                    rej(err);
                    return;
                },
                associateSecretCode: function(secretCode) {
                    $43cf7a9c36e82c0e$var$logger.debug("associateSoftwareToken sucess", secretCode);
                    res(secretCode);
                    return;
                }
            });
        });
    };
    /**
     * verify TOTP setup
     * @param {CognitoUser} user - the current user
     * @param {string} challengeAnswer - challenge answer
     * @return - A promise resolves is success
     */ AuthClass.prototype.verifyTotpToken = function(user, challengeAnswer) {
        $43cf7a9c36e82c0e$var$logger.debug("verfication totp token", user, challengeAnswer);
        return new Promise(function(res, rej) {
            user.verifySoftwareToken(challengeAnswer, "My TOTP device", {
                onFailure: function(err) {
                    $43cf7a9c36e82c0e$var$logger.debug("verifyTotpToken failed", err);
                    rej(err);
                    return;
                },
                onSuccess: function(data) {
                    $43cf7a9c36e82c0e$var$logger.debug("verifyTotpToken success", data);
                    res(data);
                    return;
                }
            });
        });
    };
    /**
     * Send MFA code to confirm sign in
     * @param {Object} user - The CognitoUser object
     * @param {String} code - The confirmation code
     */ AuthClass.prototype.confirmSignIn = function(user, code, mfaType, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!code) return this.rejectAuthError((0, $6ZRLT.AuthErrorTypes).EmptyCode);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendMFACode(code, {
                onSuccess: function(session) {
                    return $43cf7a9c36e82c0e$var$__awaiter(_this, void 0, void 0, function() {
                        var cred, e_3;
                        return $43cf7a9c36e82c0e$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    $43cf7a9c36e82c0e$var$logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        6
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        (0, $aCVDw.default).clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        (0, $aCVDw.default).set(session, "session")
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    $43cf7a9c36e82c0e$var$logger.debug("succeed to get cognito credentials", cred);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 4:
                                    e_3 = _a.sent();
                                    $43cf7a9c36e82c0e$var$logger.debug("cannot get cognito credentials", e_3);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 5:
                                    that.user = user;
                                    $43cf7a9c36e82c0e$var$dispatchAuthEvent("signIn", user, user + " has signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 6:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    $43cf7a9c36e82c0e$var$logger.debug("confirm signIn failure", err);
                    reject(err);
                }
            }, mfaType, clientMetadata);
        });
    };
    AuthClass.prototype.completeNewPassword = function(user, password, requiredAttributes, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!password) return this.rejectAuthError((0, $6ZRLT.AuthErrorTypes).EmptyPassword);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.completeNewPasswordChallenge(password, requiredAttributes, {
                onSuccess: function(session) {
                    return $43cf7a9c36e82c0e$var$__awaiter(_this, void 0, void 0, function() {
                        var cred, e_4;
                        return $43cf7a9c36e82c0e$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    $43cf7a9c36e82c0e$var$logger.debug(session);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([
                                        1,
                                        4,
                                        5,
                                        6
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        (0, $aCVDw.default).clear()
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        (0, $aCVDw.default).set(session, "session")
                                    ];
                                case 3:
                                    cred = _a.sent();
                                    $43cf7a9c36e82c0e$var$logger.debug("succeed to get cognito credentials", cred);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 4:
                                    e_4 = _a.sent();
                                    $43cf7a9c36e82c0e$var$logger.debug("cannot get cognito credentials", e_4);
                                    return [
                                        3 /*break*/ ,
                                        6
                                    ];
                                case 5:
                                    that.user = user;
                                    $43cf7a9c36e82c0e$var$dispatchAuthEvent("signIn", user, user + " has signed in");
                                    resolve(user);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 6:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                onFailure: function(err) {
                    $43cf7a9c36e82c0e$var$logger.debug("completeNewPassword failure", err);
                    $43cf7a9c36e82c0e$var$dispatchAuthEvent("completeNewPassword_failure", err, _this.user + " failed to complete the new password flow");
                    reject(err);
                },
                mfaRequired: function(challengeName, challengeParam) {
                    $43cf7a9c36e82c0e$var$logger.debug("signIn MFA required");
                    user["challengeName"] = challengeName;
                    user["challengeParam"] = challengeParam;
                    resolve(user);
                },
                mfaSetup: function(challengeName, challengeParam) {
                    $43cf7a9c36e82c0e$var$logger.debug("signIn mfa setup", challengeName);
                    user["challengeName"] = challengeName;
                    user["challengeParam"] = challengeParam;
                    resolve(user);
                }
            }, clientMetadata);
        });
    };
    /**
     * Send the answer to a custom challenge
     * @param {CognitoUser} user - The CognitoUser object
     * @param {String} challengeResponses - The confirmation code
     */ AuthClass.prototype.sendCustomChallengeAnswer = function(user, challengeResponses, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!challengeResponses) return this.rejectAuthError((0, $6ZRLT.AuthErrorTypes).EmptyChallengeResponse);
        var that = this;
        return new Promise(function(resolve, reject) {
            user.sendCustomChallengeAnswer(challengeResponses, _this.authCallbacks(user, resolve, reject), clientMetadata);
        });
    };
    /**
     * Update an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/ AuthClass.prototype.updateUserAttributes = function(user, attributes, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        var attributeList = [];
        var that = this;
        return new Promise(function(resolve, reject) {
            that.userSession(user).then(function(session) {
                for(var key in attributes)if (key !== "sub" && key.indexOf("_verified") < 0) {
                    var attr = {
                        Name: key,
                        Value: attributes[key]
                    };
                    attributeList.push(attr);
                }
                user.updateAttributes(attributeList, function(err, result) {
                    if (err) return reject(err);
                    else return resolve(result);
                }, clientMetadata);
            });
        });
    };
    /**
     * Return user attributes
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to user attributes if success
     */ AuthClass.prototype.userAttributes = function(user) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.getUserAttributes(function(err, attributes) {
                    if (err) reject(err);
                    else resolve(attributes);
                });
            });
        });
    };
    AuthClass.prototype.verifiedContact = function(user) {
        var that = this;
        return this.userAttributes(user).then(function(attributes) {
            var attrs = that.attributesToObject(attributes);
            var unverified = {};
            var verified = {};
            if (attrs["email"]) {
                if (attrs["email_verified"]) verified["email"] = attrs["email"];
                else unverified["email"] = attrs["email"];
            }
            if (attrs["phone_number"]) {
                if (attrs["phone_number_verified"]) verified["phone_number"] = attrs["phone_number"];
                else unverified["phone_number"] = attrs["phone_number"];
            }
            return {
                verified: verified,
                unverified: unverified
            };
        });
    };
    /**
     * Get current authenticated user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentUserPoolUser = function(params) {
        var _this = this;
        if (!this.userPool) return this.rejectNoUserPool();
        var that = this;
        return new Promise(function(res, rej) {
            _this._storageSync.then(function() {
                var user = that.userPool.getCurrentUser();
                if (!user) {
                    $43cf7a9c36e82c0e$var$logger.debug("Failed to get user from user pool");
                    rej("No current user");
                    return;
                }
                // refresh the session if the session expired.
                user.getSession(function(err, session) {
                    if (err) {
                        $43cf7a9c36e82c0e$var$logger.debug("Failed to get the user session", err);
                        rej(err);
                        return;
                    }
                    // get user data from Cognito
                    var bypassCache = params ? params.bypassCache : false;
                    // validate the token's scope fisrt before calling this function
                    var _a = session.getAccessToken().decodePayload().scope, scope = _a === void 0 ? "" : _a;
                    if (scope.split(" ").includes($43cf7a9c36e82c0e$var$USER_ADMIN_SCOPE)) user.getUserData(function(err, data) {
                        if (err) {
                            $43cf7a9c36e82c0e$var$logger.debug("getting user data failed", err);
                            // Make sure the user is still valid
                            if (err.message === "User is disabled." || err.message === "User does not exist." || err.message === "Access Token has been revoked" // Session revoked by another app
                            ) rej(err);
                            else // the error may also be thrown when lack of permissions to get user info etc
                            // in that case we just bypass the error
                            res(user);
                            return;
                        }
                        var preferredMFA = data.PreferredMfaSetting || "NOMFA";
                        var attributeList = [];
                        for(var i = 0; i < data.UserAttributes.length; i++){
                            var attribute = {
                                Name: data.UserAttributes[i].Name,
                                Value: data.UserAttributes[i].Value
                            };
                            var userAttribute = new (0, $kdPCY.default)(attribute);
                            attributeList.push(userAttribute);
                        }
                        var attributes = that.attributesToObject(attributeList);
                        Object.assign(user, {
                            attributes: attributes,
                            preferredMFA: preferredMFA
                        });
                        return res(user);
                    }, {
                        bypassCache: bypassCache
                    });
                    else {
                        $43cf7a9c36e82c0e$var$logger.debug("Unable to get the user data because the " + $43cf7a9c36e82c0e$var$USER_ADMIN_SCOPE + " " + "is not in the scopes of the access token");
                        return res(user);
                    }
                });
            }).catch(function(e) {
                $43cf7a9c36e82c0e$var$logger.debug("Failed to sync cache info into memory", e);
                return rej(e);
            });
        });
    };
    /**
     * Get current authenticated user
     * @param {CurrentUserOpts} - options for getting the current user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */ AuthClass.prototype.currentAuthenticatedUser = function(params) {
        return $43cf7a9c36e82c0e$var$__awaiter(this, void 0, void 0, function() {
            var federatedUser, e_5, user, e_6;
            return $43cf7a9c36e82c0e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        $43cf7a9c36e82c0e$var$logger.debug("getting current authenticated user");
                        federatedUser = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_5 = _a.sent();
                        $43cf7a9c36e82c0e$var$logger.debug("Failed to sync cache info into memory", e_5);
                        throw e_5;
                    case 4:
                        try {
                            federatedUser = JSON.parse(this._storage.getItem("aws-amplify-federatedInfo")).user;
                        } catch (e) {
                            $43cf7a9c36e82c0e$var$logger.debug("cannot load federated user from auth storage");
                        }
                        if (!federatedUser) return [
                            3 /*break*/ ,
                            5
                        ];
                        this.user = federatedUser;
                        $43cf7a9c36e82c0e$var$logger.debug("get current authenticated federated user", this.user);
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                    case 5:
                        $43cf7a9c36e82c0e$var$logger.debug("get current authenticated userpool user");
                        user = null;
                        _a.label = 6;
                    case 6:
                        _a.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser(params)
                        ];
                    case 7:
                        user = _a.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        e_6 = _a.sent();
                        if (e_6 === "No userPool") $43cf7a9c36e82c0e$var$logger.error("Cannot get the current user because the user pool is missing. Please make sure the Auth module is configured with a valid Cognito User Pool ID");
                        $43cf7a9c36e82c0e$var$logger.debug("The user is not authenticated by the error", e_6);
                        throw "not authenticated";
                    case 9:
                        this.user = user;
                        return [
                            2 /*return*/ ,
                            this.user
                        ];
                }
            });
        });
    };
    /**
     * Get current user's session
     * @return - A promise resolves to session object if success
     */ AuthClass.prototype.currentSession = function() {
        var that = this;
        $43cf7a9c36e82c0e$var$logger.debug("Getting current session");
        // Purposely not calling the reject method here because we don't need a console error
        if (!this.userPool) return Promise.reject();
        return new Promise(function(res, rej) {
            that.currentUserPoolUser().then(function(user) {
                that.userSession(user).then(function(session) {
                    res(session);
                    return;
                }).catch(function(e) {
                    $43cf7a9c36e82c0e$var$logger.debug("Failed to get the current session", e);
                    rej(e);
                    return;
                });
            }).catch(function(e) {
                $43cf7a9c36e82c0e$var$logger.debug("Failed to get the current user", e);
                rej(e);
                return;
            });
        });
    };
    /**
     * Get the corresponding user session
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to the session
     */ AuthClass.prototype.userSession = function(user) {
        if (!user) {
            $43cf7a9c36e82c0e$var$logger.debug("the user is null");
            return this.rejectAuthError((0, $6ZRLT.AuthErrorTypes).NoUserSession);
        }
        return new Promise(function(resolve, reject) {
            $43cf7a9c36e82c0e$var$logger.debug("Getting the session from this user:", user);
            user.getSession(function(err, session) {
                if (err) {
                    $43cf7a9c36e82c0e$var$logger.debug("Failed to get the session from user", user);
                    reject(err);
                    return;
                } else {
                    $43cf7a9c36e82c0e$var$logger.debug("Succeed to get the user session", session);
                    resolve(session);
                    return;
                }
            });
        });
    };
    /**
     * Get  authenticated credentials of current user.
     * @return - A promise resolves to be current user's credentials
     */ AuthClass.prototype.currentUserCredentials = function() {
        return $43cf7a9c36e82c0e$var$__awaiter(this, void 0, void 0, function() {
            var that, e_7, federatedInfo;
            return $43cf7a9c36e82c0e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        that = this;
                        $43cf7a9c36e82c0e$var$logger.debug("Getting current user credentials");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_7 = _a.sent();
                        $43cf7a9c36e82c0e$var$logger.debug("Failed to sync cache info into memory", e_7);
                        throw e_7;
                    case 4:
                        federatedInfo = null;
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem("aws-amplify-federatedInfo"));
                        } catch (e) {
                            $43cf7a9c36e82c0e$var$logger.debug("failed to get or parse item aws-amplify-federatedInfo", e);
                        }
                        if (federatedInfo) // refresh the jwt token here if necessary
                        return [
                            2 /*return*/ ,
                            (0, $aCVDw.default).refreshFederatedToken(federatedInfo)
                        ];
                        else return [
                            2 /*return*/ ,
                            this.currentSession().then(function(session) {
                                $43cf7a9c36e82c0e$var$logger.debug("getting session success", session);
                                return (0, $aCVDw.default).set(session, "session");
                            }).catch(function(error) {
                                $43cf7a9c36e82c0e$var$logger.debug("getting session failed", error);
                                return (0, $aCVDw.default).set(null, "guest");
                            })
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.currentCredentials = function() {
        $43cf7a9c36e82c0e$var$logger.debug("getting current credntials");
        return (0, $aCVDw.default).get();
    };
    /**
     * Initiate an attribute confirmation request
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attributes to be verified
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttribute = function(user, attr, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            user.getAttributeVerificationCode(attr, {
                onSuccess: function() {
                    return resolve();
                },
                onFailure: function(err) {
                    return reject(err);
                },
                clientMetadata: clientMetadata
            });
        });
    };
    /**
     * Confirm an attribute using a confirmation code
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyUserAttributeSubmit = function(user, attr, code) {
        if (!code) return this.rejectAuthError((0, $6ZRLT.AuthErrorTypes).EmptyCode);
        return new Promise(function(resolve, reject) {
            user.verifyAttribute(attr, code, {
                onSuccess: function(data) {
                    resolve(data);
                    return;
                },
                onFailure: function(err) {
                    reject(err);
                    return;
                }
            });
        });
    };
    AuthClass.prototype.verifyCurrentUserAttribute = function(attr) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttribute(user, attr);
        });
    };
    /**
     * Confirm current user's attribute using a confirmation code
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */ AuthClass.prototype.verifyCurrentUserAttributeSubmit = function(attr, code) {
        var that = this;
        return that.currentUserPoolUser().then(function(user) {
            return that.verifyUserAttributeSubmit(user, attr, code);
        });
    };
    AuthClass.prototype.cognitoIdentitySignOut = function(opts, user) {
        return $43cf7a9c36e82c0e$var$__awaiter(this, void 0, void 0, function() {
            var e_8, isSignedInHostedUI;
            var _this = this;
            return $43cf7a9c36e82c0e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._storageSync
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_8 = _a.sent();
                        $43cf7a9c36e82c0e$var$logger.debug("Failed to sync cache info into memory", e_8);
                        throw e_8;
                    case 3:
                        isSignedInHostedUI = this._oAuthHandler && this._storage.getItem("amplify-signin-with-hostedUI") === "true";
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                if (opts && opts.global) {
                                    $43cf7a9c36e82c0e$var$logger.debug("user global sign out", user);
                                    // in order to use global signout
                                    // we must validate the user as an authenticated user by using getSession
                                    user.getSession(function(err, result) {
                                        if (err) {
                                            $43cf7a9c36e82c0e$var$logger.debug("failed to get the user session", err);
                                            return rej(err);
                                        }
                                        user.globalSignOut({
                                            onSuccess: function(data) {
                                                $43cf7a9c36e82c0e$var$logger.debug("global sign out success");
                                                if (isSignedInHostedUI) return res(_this._oAuthHandler.signOut());
                                                else return res();
                                            },
                                            onFailure: function(err) {
                                                $43cf7a9c36e82c0e$var$logger.debug("global sign out failed", err);
                                                return rej(err);
                                            }
                                        });
                                    });
                                } else {
                                    $43cf7a9c36e82c0e$var$logger.debug("user sign out", user);
                                    user.signOut();
                                    if (isSignedInHostedUI) return res(_this._oAuthHandler.signOut());
                                    else return res();
                                }
                            })
                        ];
                }
            });
        });
    };
    /**
     * Sign out method
     * @
     * @return - A promise resolved if success
     */ AuthClass.prototype.signOut = function(opts) {
        return $43cf7a9c36e82c0e$var$__awaiter(this, void 0, void 0, function() {
            var e_9, user;
            return $43cf7a9c36e82c0e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cleanCachedItems()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_9 = _a.sent();
                        $43cf7a9c36e82c0e$var$logger.debug("failed to clear cached items");
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        if (!this.userPool) return [
                            3 /*break*/ ,
                            7
                        ];
                        user = this.userPool.getCurrentUser();
                        if (!user) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.cognitoIdentitySignOut(opts, user)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        $43cf7a9c36e82c0e$var$logger.debug("no current Cognito user");
                        _a.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        $43cf7a9c36e82c0e$var$logger.debug("no Congito User pool");
                        _a.label = 8;
                    case 8:
                        /**
                         * Note for future refactor - no reliable way to get username with
                         * Cognito User Pools vs Identity when federating with Social Providers
                         * This is why we need a well structured session object that can be inspected
                         * and information passed back in the message below for Hub dispatch
                         */ $43cf7a9c36e82c0e$var$dispatchAuthEvent("signOut", this.user, "A user has been signed out");
                        this.user = null;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.cleanCachedItems = function() {
        return $43cf7a9c36e82c0e$var$__awaiter(this, void 0, void 0, function() {
            return $43cf7a9c36e82c0e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // clear cognito cached item
                        return [
                            4 /*yield*/ ,
                            (0, $aCVDw.default).clear()
                        ];
                    case 1:
                        // clear cognito cached item
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Change a password for an authenticated user
     * @param {Object} user - The CognitoUser object
     * @param {String} oldPassword - the current password
     * @param {String} newPassword - the requested new password
     * @return - A promise resolves if success
     */ AuthClass.prototype.changePassword = function(user, oldPassword, newPassword, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        return new Promise(function(resolve, reject) {
            _this.userSession(user).then(function(session) {
                user.changePassword(oldPassword, newPassword, function(err, data) {
                    if (err) {
                        $43cf7a9c36e82c0e$var$logger.debug("change password failure", err);
                        return reject(err);
                    } else return resolve(data);
                }, clientMetadata);
            });
        });
    };
    /**
     * Initiate a forgot password request
     * @param {String} username - the username to change password
     * @return - A promise resolves if success
     */ AuthClass.prototype.forgotPassword = function(username, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $6ZRLT.AuthErrorTypes).EmptyUsername);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.forgotPassword({
                onSuccess: function() {
                    resolve();
                    return;
                },
                onFailure: function(err) {
                    $43cf7a9c36e82c0e$var$logger.debug("forgot password failure", err);
                    $43cf7a9c36e82c0e$var$dispatchAuthEvent("forgotPassword_failure", err, username + " forgotPassword failed");
                    reject(err);
                    return;
                },
                inputVerificationCode: function(data) {
                    $43cf7a9c36e82c0e$var$dispatchAuthEvent("forgotPassword", user, username + " has initiated forgot password flow");
                    resolve(data);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Confirm a new password using a confirmation Code
     * @param {String} username - The username
     * @param {String} code - The confirmation code
     * @param {String} password - The new password
     * @return - A promise that resolves if success
     */ AuthClass.prototype.forgotPasswordSubmit = function(username, code, password, clientMetadata) {
        if (clientMetadata === void 0) clientMetadata = this._config.clientMetadata;
        if (!this.userPool) return this.rejectNoUserPool();
        if (!username) return this.rejectAuthError((0, $6ZRLT.AuthErrorTypes).EmptyUsername);
        if (!code) return this.rejectAuthError((0, $6ZRLT.AuthErrorTypes).EmptyCode);
        if (!password) return this.rejectAuthError((0, $6ZRLT.AuthErrorTypes).EmptyPassword);
        var user = this.createCognitoUser(username);
        return new Promise(function(resolve, reject) {
            user.confirmPassword(code, password, {
                onSuccess: function() {
                    $43cf7a9c36e82c0e$var$dispatchAuthEvent("forgotPasswordSubmit", user, username + " forgotPasswordSubmit successful");
                    resolve();
                    return;
                },
                onFailure: function(err) {
                    $43cf7a9c36e82c0e$var$dispatchAuthEvent("forgotPasswordSubmit_failure", err, username + " forgotPasswordSubmit failed");
                    reject(err);
                    return;
                }
            }, clientMetadata);
        });
    };
    /**
     * Get user information
     * @async
     * @return {Object }- current User's information
     */ AuthClass.prototype.currentUserInfo = function() {
        return $43cf7a9c36e82c0e$var$__awaiter(this, void 0, void 0, function() {
            var source, user, attributes, userAttrs, credentials, e_10, info, err_1, user;
            return $43cf7a9c36e82c0e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        source = (0, $aCVDw.default).getCredSource();
                        if (!(!source || source === "aws" || source === "userPool")) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            this.currentUserPoolUser().catch(function(err) {
                                return $43cf7a9c36e82c0e$var$logger.debug(err);
                            })
                        ];
                    case 1:
                        user = _a.sent();
                        if (!user) return [
                            2 /*return*/ ,
                            null
                        ];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.userAttributes(user)
                        ];
                    case 3:
                        attributes = _a.sent();
                        userAttrs = this.attributesToObject(attributes);
                        credentials = null;
                        _a.label = 4;
                    case 4:
                        _a.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.currentCredentials()
                        ];
                    case 5:
                        credentials = _a.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        e_10 = _a.sent();
                        $43cf7a9c36e82c0e$var$logger.debug("Failed to retrieve credentials while getting current user info", e_10);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        info = {
                            id: credentials ? credentials.identityId : undefined,
                            username: user.getUsername(),
                            attributes: userAttrs
                        };
                        return [
                            2 /*return*/ ,
                            info
                        ];
                    case 8:
                        err_1 = _a.sent();
                        $43cf7a9c36e82c0e$var$logger.debug("currentUserInfo error", err_1);
                        return [
                            2 /*return*/ ,
                            {}
                        ];
                    case 9:
                        if (source === "federated") {
                            user = this.user;
                            return [
                                2 /*return*/ ,
                                user ? user : {}
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AuthClass.prototype.federatedSignIn = function(providerOrOptions, response, user) {
        return $43cf7a9c36e82c0e$var$__awaiter(this, void 0, void 0, function() {
            var options, provider, customState, client_id, redirect_uri, provider, loggedInUser, token, identity_id, expires_at, credentials, currentUser;
            return $43cf7a9c36e82c0e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation requires either a User Pool or Identity Pool in config");
                        // Ensure backwards compatability
                        if (typeof providerOrOptions === "undefined") {
                            if (this._config.identityPoolId && !this._config.userPoolId) throw new Error("Federation with Identity Pools requires tokens passed as arguments");
                        }
                        if (!((0, $6ZRLT.isFederatedSignInOptions)(providerOrOptions) || (0, $6ZRLT.isFederatedSignInOptionsCustom)(providerOrOptions) || typeof providerOrOptions === "undefined")) return [
                            3 /*break*/ ,
                            1
                        ];
                        options = providerOrOptions || {
                            provider: $43cf7a9c36e82c0e$export$eeb013770cb92342.Cognito
                        };
                        provider = (0, $6ZRLT.isFederatedSignInOptions)(options) ? options.provider : options.customProvider;
                        customState = (0, $6ZRLT.isFederatedSignInOptions)(options) ? options.customState : options.customState;
                        if (this._config.userPoolId) {
                            client_id = (0, $6ZRLT.isCognitoHostedOpts)(this._config.oauth) ? this._config.userPoolWebClientId : this._config.oauth.clientID;
                            redirect_uri = (0, $6ZRLT.isCognitoHostedOpts)(this._config.oauth) ? this._config.oauth.redirectSignIn : this._config.oauth.redirectUri;
                            this._oAuthHandler.oauthSignIn(this._config.oauth.responseType, this._config.oauth.domain, redirect_uri, client_id, provider, customState);
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 1:
                        provider = providerOrOptions;
                        // To check if the user is already logged in
                        try {
                            loggedInUser = JSON.stringify(JSON.parse(this._storage.getItem("aws-amplify-federatedInfo")).user);
                            if (loggedInUser) $43cf7a9c36e82c0e$var$logger.warn("There is already a signed in user: " + loggedInUser + " in your app.\n																	You should not call Auth.federatedSignIn method again as it may cause unexpected behavior.");
                        } catch (e) {}
                        token = response.token, identity_id = response.identity_id, expires_at = response.expires_at;
                        return [
                            4 /*yield*/ ,
                            (0, $aCVDw.default).set({
                                provider: provider,
                                token: token,
                                identity_id: identity_id,
                                user: user,
                                expires_at: expires_at
                            }, "federation")
                        ];
                    case 2:
                        credentials = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.currentAuthenticatedUser()
                        ];
                    case 3:
                        currentUser = _a.sent();
                        $43cf7a9c36e82c0e$var$dispatchAuthEvent("signIn", currentUser, "A user " + currentUser.username + " has been signed in");
                        $43cf7a9c36e82c0e$var$logger.debug("federated sign in credentials", credentials);
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Used to complete the OAuth flow with or without the Cognito Hosted UI
     * @param {String} URL - optional parameter for customers to pass in the response URL
     */ AuthClass.prototype._handleAuthResponse = function(URL) {
        return $43cf7a9c36e82c0e$var$__awaiter(this, void 0, void 0, function() {
            var currentUrl, hasCodeOrError, hasTokenOrError, _a, accessToken, idToken, refreshToken, state, session, credentials, isCustomStateIncluded, currentUser, customState, err_2;
            return $43cf7a9c36e82c0e$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this._config.userPoolId) throw new Error("OAuth responses require a User Pool defined in config");
                        $43cf7a9c36e82c0e$var$dispatchAuthEvent("parsingCallbackUrl", {
                            url: URL
                        }, "The callback url is being parsed");
                        currentUrl = URL || ((0, $gssgp.default).browserOrNode().isBrowser ? window.location.href : "");
                        hasCodeOrError = !!((0, $i3eDV.parse)(currentUrl).query || "").split("&").map(function(entry) {
                            return entry.split("=");
                        }).find(function(_a) {
                            var k = _a[0];
                            return k === "code" || k === "error";
                        });
                        hasTokenOrError = !!((0, $i3eDV.parse)(currentUrl).hash || "#").substr(1).split("&").map(function(entry) {
                            return entry.split("=");
                        }).find(function(_a) {
                            var k = _a[0];
                            return k === "access_token" || k === "error";
                        });
                        if (!(hasCodeOrError || hasTokenOrError)) return [
                            3 /*break*/ ,
                            6
                        ];
                        this._storage.setItem("amplify-redirected-from-hosted-ui", "true");
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._oAuthHandler.handleAuthResponse(currentUrl)
                        ];
                    case 2:
                        _a = _b.sent(), accessToken = _a.accessToken, idToken = _a.idToken, refreshToken = _a.refreshToken, state = _a.state;
                        session = new (0, $dTtsJ.default)({
                            IdToken: new (0, $VNeTv.default)({
                                IdToken: idToken
                            }),
                            RefreshToken: new (0, $M7FPA.default)({
                                RefreshToken: refreshToken
                            }),
                            AccessToken: new (0, $3kONY.default)({
                                AccessToken: accessToken
                            })
                        });
                        credentials = void 0;
                        if (!this._config.identityPoolId) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $aCVDw.default).set(session, "session")
                        ];
                    case 3:
                        credentials = _b.sent();
                        $43cf7a9c36e82c0e$var$logger.debug("AWS credentials", credentials);
                        _b.label = 4;
                    case 4:
                        isCustomStateIncluded = /-/.test(state);
                        currentUser = this.createCognitoUser(session.getIdToken().decodePayload()["cognito:username"]);
                        $43cf7a9c36e82c0e$var$dispatchAuthEvent("signIn", currentUser, "A user " + currentUser.getUsername() + " has been signed in");
                        $43cf7a9c36e82c0e$var$dispatchAuthEvent("cognitoHostedUI", currentUser, "A user " + currentUser.getUsername() + " has been signed in via Cognito Hosted UI");
                        if (isCustomStateIncluded) {
                            customState = state.split("-").splice(1).join("-");
                            $43cf7a9c36e82c0e$var$dispatchAuthEvent("customOAuthState", customState, "State for user " + currentUser.getUsername());
                        }
                        // This calls cacheTokens() in Cognito SDK
                        currentUser.setSignInUserSession(session);
                        //#endregion
                        if (window && typeof window.history !== "undefined") window.history.replaceState({}, null, this._config.oauth.redirectSignIn);
                        return [
                            2 /*return*/ ,
                            credentials
                        ];
                    case 5:
                        err_2 = _b.sent();
                        $43cf7a9c36e82c0e$var$logger.debug("Error in cognito hosted auth response", err_2);
                        $43cf7a9c36e82c0e$var$dispatchAuthEvent("signIn_failure", err_2, "The OAuth response flow failed");
                        $43cf7a9c36e82c0e$var$dispatchAuthEvent("cognitoHostedUI_failure", err_2, "A failure occurred when returning to the Cognito Hosted UI");
                        $43cf7a9c36e82c0e$var$dispatchAuthEvent("customState_failure", err_2, "A failure occurred when returning state");
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */ AuthClass.prototype.essentialCredentials = function(credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated
        };
    };
    AuthClass.prototype.attributesToObject = function(attributes) {
        var obj = {};
        if (attributes) attributes.map(function(attribute) {
            if (attribute.Value === "true") obj[attribute.Name] = true;
            else if (attribute.Value === "false") obj[attribute.Name] = false;
            else obj[attribute.Name] = attribute.Value;
        });
        return obj;
    };
    AuthClass.prototype.createCognitoUser = function(username) {
        var userData = {
            Username: username,
            Pool: this.userPool
        };
        userData.Storage = this._storage;
        var authenticationFlowType = this._config.authenticationFlowType;
        var user = new (0, $4myfH.default)(userData);
        if (authenticationFlowType) user.setAuthenticationFlowType(authenticationFlowType);
        return user;
    };
    AuthClass.prototype._isValidAuthStorage = function(obj) {
        // We need to check if the obj has the functions of Storage
        return !!obj && typeof obj.getItem === "function" && typeof obj.setItem === "function" && typeof obj.removeItem === "function" && typeof obj.clear === "function";
    };
    AuthClass.prototype.noUserPoolErrorHandler = function(config) {
        if (config) {
            if (!config.userPoolId || !config.identityPoolId) return (0, $6ZRLT.AuthErrorTypes).MissingAuthConfig;
        }
        return (0, $6ZRLT.AuthErrorTypes).NoConfig;
    };
    AuthClass.prototype.rejectAuthError = function(type) {
        return Promise.reject(new (0, $8e3hn.AuthError)(type));
    };
    AuthClass.prototype.rejectNoUserPool = function() {
        var type = this.noUserPoolErrorHandler(this._config);
        return Promise.reject(new (0, $8e3hn.NoUserPoolError)(type));
    };
    return AuthClass;
}();
var $43cf7a9c36e82c0e$export$2e2bcd8739ae039 = $43cf7a9c36e82c0e$var$AuthClass;

});
parcelRequire.register("lV7tM", function(module, exports) {
$parcel$export(module.exports, "isCognitoHostedOpts", function () { return (parcelRequire("6ZRLT")).isCognitoHostedOpts; });
$parcel$export(module.exports, "isFederatedSignInOptions", function () { return (parcelRequire("6ZRLT")).isFederatedSignInOptions; });
$parcel$export(module.exports, "isFederatedSignInOptionsCustom", function () { return (parcelRequire("6ZRLT")).isFederatedSignInOptionsCustom; });
$parcel$export(module.exports, "isUsernamePasswordOpts", function () { return (parcelRequire("6ZRLT")).isUsernamePasswordOpts; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("6ZRLT");

});
parcelRequire.register("6ZRLT", function(module, exports) {

$parcel$export(module.exports, "CognitoHostedUIIdentityProvider", function () { return $5182267a4a0166ba$export$eeb013770cb92342; });
$parcel$export(module.exports, "isFederatedSignInOptions", function () { return $5182267a4a0166ba$export$9b905d6895bdc426; });
$parcel$export(module.exports, "isFederatedSignInOptionsCustom", function () { return $5182267a4a0166ba$export$828f8efbdf71714b; });
$parcel$export(module.exports, "isCognitoHostedOpts", function () { return $5182267a4a0166ba$export$b380f8ec78ef17c8; });
$parcel$export(module.exports, "AuthErrorTypes", function () { return $5182267a4a0166ba$export$edb367c0a140d3db; });
$parcel$export(module.exports, "isUsernamePasswordOpts", function () { return $5182267a4a0166ba$export$ad34f09783c4cb16; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $5182267a4a0166ba$export$eeb013770cb92342;
(function(CognitoHostedUIIdentityProvider) {
    CognitoHostedUIIdentityProvider["Cognito"] = "COGNITO";
    CognitoHostedUIIdentityProvider["Google"] = "Google";
    CognitoHostedUIIdentityProvider["Facebook"] = "Facebook";
    CognitoHostedUIIdentityProvider["Amazon"] = "LoginWithAmazon";
})($5182267a4a0166ba$export$eeb013770cb92342 || ($5182267a4a0166ba$export$eeb013770cb92342 = {}));
function $5182267a4a0166ba$export$9b905d6895bdc426(obj) {
    var keys = [
        "provider",
        "customState"
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $5182267a4a0166ba$export$828f8efbdf71714b(obj) {
    var keys = [
        "customProvider",
        "customState"
    ];
    return obj && !!keys.find(function(k) {
        return obj.hasOwnProperty(k);
    });
}
function $5182267a4a0166ba$export$b380f8ec78ef17c8(oauth) {
    return oauth.redirectSignIn !== undefined;
}
var $5182267a4a0166ba$export$edb367c0a140d3db;
(function(AuthErrorTypes) {
    AuthErrorTypes["NoConfig"] = "noConfig";
    AuthErrorTypes["MissingAuthConfig"] = "missingAuthConfig";
    AuthErrorTypes["EmptyUsername"] = "emptyUsername";
    AuthErrorTypes["InvalidUsername"] = "invalidUsername";
    AuthErrorTypes["EmptyPassword"] = "emptyPassword";
    AuthErrorTypes["EmptyCode"] = "emptyCode";
    AuthErrorTypes["SignUpError"] = "signUpError";
    AuthErrorTypes["NoMFA"] = "noMFA";
    AuthErrorTypes["InvalidMFA"] = "invalidMFA";
    AuthErrorTypes["EmptyChallengeResponse"] = "emptyChallengeResponse";
    AuthErrorTypes["NoUserSession"] = "noUserSession";
    AuthErrorTypes["Default"] = "default";
})($5182267a4a0166ba$export$edb367c0a140d3db || ($5182267a4a0166ba$export$edb367c0a140d3db = {}));
function $5182267a4a0166ba$export$ad34f09783c4cb16(obj) {
    return !!obj.username;
}

});


parcelRequire.register("3xxnP", function(module, exports) {

$parcel$export(module.exports, "AuthenticationDetails", function () { return (parcelRequire("gYRRU")).default; });
$parcel$export(module.exports, "CognitoAccessToken", function () { return (parcelRequire("3kONY")).default; });
$parcel$export(module.exports, "CognitoIdToken", function () { return (parcelRequire("VNeTv")).default; });
$parcel$export(module.exports, "CognitoRefreshToken", function () { return (parcelRequire("M7FPA")).default; });
$parcel$export(module.exports, "CognitoUser", function () { return (parcelRequire("4myfH")).default; });
$parcel$export(module.exports, "CognitoUserAttribute", function () { return (parcelRequire("kdPCY")).default; });
$parcel$export(module.exports, "CognitoUserPool", function () { return (parcelRequire("lihsy")).default; });
$parcel$export(module.exports, "CognitoUserSession", function () { return (parcelRequire("dTtsJ")).default; });
$parcel$export(module.exports, "CookieStorage", function () { return (parcelRequire("2YUd1")).default; });
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gYRRU = parcelRequire("gYRRU");

var $eGFMf = parcelRequire("eGFMf");

var $3kONY = parcelRequire("3kONY");

var $VNeTv = parcelRequire("VNeTv");

var $M7FPA = parcelRequire("M7FPA");

var $4myfH = parcelRequire("4myfH");

var $kdPCY = parcelRequire("kdPCY");

var $lihsy = parcelRequire("lihsy");

var $dTtsJ = parcelRequire("dTtsJ");

var $2YUd1 = parcelRequire("2YUd1");

var $2R4Jl = parcelRequire("2R4Jl");

});
parcelRequire.register("gYRRU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5cc0915c7f5734d$export$2e2bcd8739ae039; });
function $c5cc0915c7f5734d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ /** @class */ var $c5cc0915c7f5734d$var$AuthenticationDetails = function() {
    /**
  * Constructs a new AuthenticationDetails object
  * @param {object=} data Creation options.
  * @param {string} data.Username User being authenticated.
  * @param {string} data.Password Plain-text password to authenticate with.
  * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
  * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
  */ function AuthenticationDetails(data) {
        $c5cc0915c7f5734d$var$_classCallCheck(this, AuthenticationDetails);
        var _ref = data || {}, ValidationData = _ref.ValidationData, Username = _ref.Username, Password = _ref.Password, AuthParameters = _ref.AuthParameters, ClientMetadata = _ref.ClientMetadata;
        this.validationData = ValidationData || {};
        this.authParameters = AuthParameters || {};
        this.clientMetadata = ClientMetadata || {};
        this.username = Username;
        this.password = Password;
    }
    /**
  * @returns {string} the record's username
  */ AuthenticationDetails.prototype.getUsername = function getUsername() {
        return this.username;
    };
    /**
  * @returns {string} the record's password
  */ AuthenticationDetails.prototype.getPassword = function getPassword() {
        return this.password;
    };
    /**
  * @returns {Array} the record's validationData
  */ AuthenticationDetails.prototype.getValidationData = function getValidationData() {
        return this.validationData;
    };
    /**
  * @returns {Array} the record's authParameters
  */ AuthenticationDetails.prototype.getAuthParameters = function getAuthParameters() {
        return this.authParameters;
    };
    /**
  * @returns {ClientMetadata} the clientMetadata for a Lambda trigger
  */ AuthenticationDetails.prototype.getClientMetadata = function getClientMetadata() {
        return this.clientMetadata;
    };
    return AuthenticationDetails;
}();
var $c5cc0915c7f5734d$export$2e2bcd8739ae039 = $c5cc0915c7f5734d$var$AuthenticationDetails;

});

parcelRequire.register("eGFMf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab156508c76da24e$export$2e2bcd8739ae039; });

var $aE4oM = parcelRequire("aE4oM");

var $7IQXV = parcelRequire("7IQXV");
parcelRequire("lr3QI");

var $fbuuf = parcelRequire("fbuuf");

var $m6xY6 = parcelRequire("m6xY6");

var $4OMoi = parcelRequire("4OMoi");
function $ab156508c76da24e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $ab156508c76da24e$var$randomBytes = function randomBytes(nBytes) {
    return (0, $aE4oM.Buffer).from((0, (/*@__PURE__*/$parcel$interopDefault($7IQXV))).lib.WordArray.random(nBytes).toString(), "hex");
};
var $ab156508c76da24e$var$initN = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF";
var $ab156508c76da24e$var$newPasswordRequiredChallengeUserAttributePrefix = "userAttributes.";
/** @class */ var $ab156508c76da24e$var$AuthenticationHelper = function() {
    /**
  * Constructs a new AuthenticationHelper object
  * @param {string} PoolName Cognito user pool name.
  */ function AuthenticationHelper(PoolName) {
        $ab156508c76da24e$var$_classCallCheck(this, AuthenticationHelper);
        this.N = new (0, $4OMoi.default)($ab156508c76da24e$var$initN, 16);
        this.g = new (0, $4OMoi.default)("2", 16);
        this.k = new (0, $4OMoi.default)(this.hexHash("00" + this.N.toString(16) + "0" + this.g.toString(16)), 16);
        this.smallAValue = this.generateRandomSmallA();
        this.getLargeAValue(function() {});
        this.infoBits = (0, $aE4oM.Buffer).from("Caldera Derived Key", "utf8");
        this.poolName = PoolName;
    }
    /**
  * @returns {BigInteger} small A, a random number
  */ AuthenticationHelper.prototype.getSmallAValue = function getSmallAValue() {
        return this.smallAValue;
    };
    /**
  * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
  * @returns {void}
  */ AuthenticationHelper.prototype.getLargeAValue = function getLargeAValue(callback) {
        var _this = this;
        if (this.largeAValue) callback(null, this.largeAValue);
        else this.calculateA(this.smallAValue, function(err, largeAValue) {
            if (err) callback(err, null);
            _this.largeAValue = largeAValue;
            callback(null, _this.largeAValue);
        });
    };
    /**
  * helper function to generate a random big integer
  * @returns {BigInteger} a random value.
  * @private
  */ AuthenticationHelper.prototype.generateRandomSmallA = function generateRandomSmallA() {
        var hexRandom = $ab156508c76da24e$var$randomBytes(128).toString("hex");
        var randomBigInt = new (0, $4OMoi.default)(hexRandom, 16);
        var smallABigInt = randomBigInt.mod(this.N);
        return smallABigInt;
    };
    /**
  * helper function to generate a random string
  * @returns {string} a random value.
  * @private
  */ AuthenticationHelper.prototype.generateRandomString = function generateRandomString() {
        return $ab156508c76da24e$var$randomBytes(40).toString("base64");
    };
    /**
  * @returns {string} Generated random value included in password hash.
  */ AuthenticationHelper.prototype.getRandomPassword = function getRandomPassword() {
        return this.randomPassword;
    };
    /**
  * @returns {string} Generated random value included in devices hash.
  */ AuthenticationHelper.prototype.getSaltDevices = function getSaltDevices() {
        return this.SaltToHashDevices;
    };
    /**
  * @returns {string} Value used to verify devices.
  */ AuthenticationHelper.prototype.getVerifierDevices = function getVerifierDevices() {
        return this.verifierDevices;
    };
    /**
  * Generate salts and compute verifier.
  * @param {string} deviceGroupKey Devices to generate verifier for.
  * @param {string} username User to generate verifier for.
  * @param {nodeCallback<null>} callback Called with (err, null)
  * @returns {void}
  */ AuthenticationHelper.prototype.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
        var _this2 = this;
        this.randomPassword = this.generateRandomString();
        var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
        var hashedString = this.hash(combinedString);
        var hexRandom = $ab156508c76da24e$var$randomBytes(16).toString("hex");
        this.SaltToHashDevices = this.padHex(new (0, $4OMoi.default)(hexRandom, 16));
        this.g.modPow(new (0, $4OMoi.default)(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function(err, verifierDevicesNotPadded) {
            if (err) callback(err, null);
            _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
            callback(null, null);
        });
    };
    /**
  * Calculate the client's public value A = g^a%N
  * with the generated random number a
  * @param {BigInteger} a Randomly generated small A.
  * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
  * @returns {void}
  * @private
  */ AuthenticationHelper.prototype.calculateA = function calculateA(a, callback) {
        var _this3 = this;
        this.g.modPow(a, this.N, function(err, A) {
            if (err) callback(err, null);
            if (A.mod(_this3.N).equals((0, $4OMoi.default).ZERO)) callback(new Error("Illegal paramater. A mod N cannot be 0."), null);
            callback(null, A);
        });
    };
    /**
  * Calculate the client's value U which is the hash of A and B
  * @param {BigInteger} A Large A value.
  * @param {BigInteger} B Server B value.
  * @returns {BigInteger} Computed U value.
  * @private
  */ AuthenticationHelper.prototype.calculateU = function calculateU(A, B) {
        this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
        var finalU = new (0, $4OMoi.default)(this.UHexHash, 16);
        return finalU;
    };
    /**
  * Calculate a hash from a bitArray
  * @param {Buffer} buf Value to hash.
  * @returns {String} Hex-encoded hash.
  * @private
  */ AuthenticationHelper.prototype.hash = function hash(buf) {
        var str = buf instanceof (0, $aE4oM.Buffer) ? (0, (/*@__PURE__*/$parcel$interopDefault($7IQXV))).lib.WordArray.create(buf) : buf;
        var hashHex = (0, (/*@__PURE__*/$parcel$interopDefault($fbuuf)))(str).toString();
        return new Array(64 - hashHex.length).join("0") + hashHex;
    };
    /**
  * Calculate a hash from a hex string
  * @param {String} hexStr Value to hash.
  * @returns {String} Hex-encoded hash.
  * @private
  */ AuthenticationHelper.prototype.hexHash = function hexHash(hexStr) {
        return this.hash((0, $aE4oM.Buffer).from(hexStr, "hex"));
    };
    /**
  * Standard hkdf algorithm
  * @param {Buffer} ikm Input key material.
  * @param {Buffer} salt Salt value.
  * @returns {Buffer} Strong key material.
  * @private
  */ AuthenticationHelper.prototype.computehkdf = function computehkdf(ikm, salt) {
        var infoBitsWordArray = (0, (/*@__PURE__*/$parcel$interopDefault($7IQXV))).lib.WordArray.create((0, $aE4oM.Buffer).concat([
            this.infoBits,
            (0, $aE4oM.Buffer).from(String.fromCharCode(1), "utf8")
        ]));
        var ikmWordArray = ikm instanceof (0, $aE4oM.Buffer) ? (0, (/*@__PURE__*/$parcel$interopDefault($7IQXV))).lib.WordArray.create(ikm) : ikm;
        var saltWordArray = salt instanceof (0, $aE4oM.Buffer) ? (0, (/*@__PURE__*/$parcel$interopDefault($7IQXV))).lib.WordArray.create(salt) : salt;
        var prk = (0, (/*@__PURE__*/$parcel$interopDefault($m6xY6)))(ikmWordArray, saltWordArray);
        var hmac = (0, (/*@__PURE__*/$parcel$interopDefault($m6xY6)))(infoBitsWordArray, prk);
        return (0, $aE4oM.Buffer).from(hmac.toString(), "hex").slice(0, 16);
    };
    /**
  * Calculates the final hkdf based on computed S value, and computed U value and the key
  * @param {String} username Username.
  * @param {String} password Password.
  * @param {BigInteger} serverBValue Server B value.
  * @param {BigInteger} salt Generated salt.
  * @param {nodeCallback<Buffer>} callback Called with (err, hkdfValue)
  * @returns {void}
  */ AuthenticationHelper.prototype.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
        var _this4 = this;
        if (serverBValue.mod(this.N).equals((0, $4OMoi.default).ZERO)) throw new Error("B cannot be zero.");
        this.UValue = this.calculateU(this.largeAValue, serverBValue);
        if (this.UValue.equals((0, $4OMoi.default).ZERO)) throw new Error("U cannot be zero.");
        var usernamePassword = "" + this.poolName + username + ":" + password;
        var usernamePasswordHash = this.hash(usernamePassword);
        var xValue = new (0, $4OMoi.default)(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
        this.calculateS(xValue, serverBValue, function(err, sValue) {
            if (err) callback(err, null);
            var hkdf = _this4.computehkdf((0, $aE4oM.Buffer).from(_this4.padHex(sValue), "hex"), (0, $aE4oM.Buffer).from(_this4.padHex(_this4.UValue.toString(16)), "hex"));
            callback(null, hkdf);
        });
    };
    /**
  * Calculates the S value used in getPasswordAuthenticationKey
  * @param {BigInteger} xValue Salted password hash value.
  * @param {BigInteger} serverBValue Server B value.
  * @param {nodeCallback<string>} callback Called on success or error.
  * @returns {void}
  */ AuthenticationHelper.prototype.calculateS = function calculateS(xValue, serverBValue, callback) {
        var _this5 = this;
        this.g.modPow(xValue, this.N, function(err, gModPowXN) {
            if (err) callback(err, null);
            var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
            intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function(err2, result) {
                if (err2) callback(err2, null);
                callback(null, result.mod(_this5.N));
            });
        });
    };
    /**
  * Return constant newPasswordRequiredChallengeUserAttributePrefix
  * @return {newPasswordRequiredChallengeUserAttributePrefix} constant prefix value
  */ AuthenticationHelper.prototype.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
        return $ab156508c76da24e$var$newPasswordRequiredChallengeUserAttributePrefix;
    };
    /**
  * Converts a BigInteger (or hex string) to hex format padded with zeroes for hashing
  * @param {BigInteger|String} bigInt Number or string to pad.
  * @returns {String} Padded hex string.
  */ AuthenticationHelper.prototype.padHex = function padHex(bigInt) {
        var hashStr = bigInt.toString(16);
        if (hashStr.length % 2 === 1) hashStr = "0" + hashStr;
        else if ("89ABCDEFabcdef".indexOf(hashStr[0]) !== -1) hashStr = "00" + hashStr;
        return hashStr;
    };
    return AuthenticationHelper;
}();
var $ab156508c76da24e$export$2e2bcd8739ae039 = $ab156508c76da24e$var$AuthenticationHelper;

});
parcelRequire.register("aE4oM", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $7c010d4b4bcea9b4$export$a143d493d941bafc; }, function (v) { return $7c010d4b4bcea9b4$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $7c010d4b4bcea9b4$export$f99ded8fe4b79145; }, function (v) { return $7c010d4b4bcea9b4$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $7c010d4b4bcea9b4$export$a143d493d941bafc;
var $7c010d4b4bcea9b4$export$e4cf37d7f6fb9e0a;
var $7c010d4b4bcea9b4$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $7c010d4b4bcea9b4$export$599f31c3813fae4d;
"use strict";

var $RyRJ6 = parcelRequire("RyRJ6");

var $kjGnt = parcelRequire("kjGnt");

var $jp5KE = parcelRequire("jp5KE");
$7c010d4b4bcea9b4$export$a143d493d941bafc = $7c010d4b4bcea9b4$var$Buffer;
$7c010d4b4bcea9b4$export$e4cf37d7f6fb9e0a = $7c010d4b4bcea9b4$var$SlowBuffer;
$7c010d4b4bcea9b4$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $7c010d4b4bcea9b4$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $7c010d4b4bcea9b4$var$typedArraySupport();
$7c010d4b4bcea9b4$export$599f31c3813fae4d = $7c010d4b4bcea9b4$var$kMaxLength();
function $7c010d4b4bcea9b4$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $7c010d4b4bcea9b4$var$kMaxLength() {
    return $7c010d4b4bcea9b4$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $7c010d4b4bcea9b4$var$createBuffer(that, length) {
    if ($7c010d4b4bcea9b4$var$kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if ($7c010d4b4bcea9b4$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $7c010d4b4bcea9b4$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $7c010d4b4bcea9b4$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $7c010d4b4bcea9b4$var$Buffer(arg, encodingOrOffset, length) {
    if (!$7c010d4b4bcea9b4$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $7c010d4b4bcea9b4$var$Buffer)) return new $7c010d4b4bcea9b4$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return $7c010d4b4bcea9b4$var$allocUnsafe(this, arg);
    }
    return $7c010d4b4bcea9b4$var$from(this, arg, encodingOrOffset, length);
}
$7c010d4b4bcea9b4$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$7c010d4b4bcea9b4$var$Buffer._augment = function(arr) {
    arr.__proto__ = $7c010d4b4bcea9b4$var$Buffer.prototype;
    return arr;
};
function $7c010d4b4bcea9b4$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return $7c010d4b4bcea9b4$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return $7c010d4b4bcea9b4$var$fromString(that, value, encodingOrOffset);
    return $7c010d4b4bcea9b4$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $7c010d4b4bcea9b4$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $7c010d4b4bcea9b4$var$from(null, value, encodingOrOffset, length);
};
if ($7c010d4b4bcea9b4$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $7c010d4b4bcea9b4$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $7c010d4b4bcea9b4$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && $7c010d4b4bcea9b4$var$Buffer[Symbol.species] === $7c010d4b4bcea9b4$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($7c010d4b4bcea9b4$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $7c010d4b4bcea9b4$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $7c010d4b4bcea9b4$var$alloc(that, size, fill, encoding) {
    $7c010d4b4bcea9b4$var$assertSize(size);
    if (size <= 0) return $7c010d4b4bcea9b4$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? $7c010d4b4bcea9b4$var$createBuffer(that, size).fill(fill, encoding) : $7c010d4b4bcea9b4$var$createBuffer(that, size).fill(fill);
    return $7c010d4b4bcea9b4$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $7c010d4b4bcea9b4$var$Buffer.alloc = function(size, fill, encoding) {
    return $7c010d4b4bcea9b4$var$alloc(null, size, fill, encoding);
};
function $7c010d4b4bcea9b4$var$allocUnsafe(that, size) {
    $7c010d4b4bcea9b4$var$assertSize(size);
    that = $7c010d4b4bcea9b4$var$createBuffer(that, size < 0 ? 0 : $7c010d4b4bcea9b4$var$checked(size) | 0);
    if (!$7c010d4b4bcea9b4$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $7c010d4b4bcea9b4$var$Buffer.allocUnsafe = function(size) {
    return $7c010d4b4bcea9b4$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $7c010d4b4bcea9b4$var$Buffer.allocUnsafeSlow = function(size) {
    return $7c010d4b4bcea9b4$var$allocUnsafe(null, size);
};
function $7c010d4b4bcea9b4$var$fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$7c010d4b4bcea9b4$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $7c010d4b4bcea9b4$var$byteLength(string, encoding) | 0;
    that = $7c010d4b4bcea9b4$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $7c010d4b4bcea9b4$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $7c010d4b4bcea9b4$var$checked(array.length) | 0;
    that = $7c010d4b4bcea9b4$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $7c010d4b4bcea9b4$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($7c010d4b4bcea9b4$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $7c010d4b4bcea9b4$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $7c010d4b4bcea9b4$var$fromArrayLike(that, array);
    return that;
}
function $7c010d4b4bcea9b4$var$fromObject(that, obj) {
    if ($7c010d4b4bcea9b4$var$Buffer.isBuffer(obj)) {
        var len = $7c010d4b4bcea9b4$var$checked(obj.length) | 0;
        that = $7c010d4b4bcea9b4$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || $7c010d4b4bcea9b4$var$isnan(obj.length)) return $7c010d4b4bcea9b4$var$createBuffer(that, 0);
            return $7c010d4b4bcea9b4$var$fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && $jp5KE(obj.data)) return $7c010d4b4bcea9b4$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function $7c010d4b4bcea9b4$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $7c010d4b4bcea9b4$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $7c010d4b4bcea9b4$var$kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function $7c010d4b4bcea9b4$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $7c010d4b4bcea9b4$var$Buffer.alloc(+length);
}
$7c010d4b4bcea9b4$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$7c010d4b4bcea9b4$var$Buffer.compare = function compare(a, b) {
    if (!$7c010d4b4bcea9b4$var$Buffer.isBuffer(a) || !$7c010d4b4bcea9b4$var$Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$7c010d4b4bcea9b4$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$7c010d4b4bcea9b4$var$Buffer.concat = function concat(list, length) {
    if (!$jp5KE(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $7c010d4b4bcea9b4$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $7c010d4b4bcea9b4$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$7c010d4b4bcea9b4$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $7c010d4b4bcea9b4$var$byteLength(string, encoding) {
    if ($7c010d4b4bcea9b4$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return $7c010d4b4bcea9b4$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $7c010d4b4bcea9b4$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $7c010d4b4bcea9b4$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$7c010d4b4bcea9b4$var$Buffer.byteLength = $7c010d4b4bcea9b4$var$byteLength;
function $7c010d4b4bcea9b4$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $7c010d4b4bcea9b4$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $7c010d4b4bcea9b4$var$utf8Slice(this, start, end);
        case "ascii":
            return $7c010d4b4bcea9b4$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $7c010d4b4bcea9b4$var$latin1Slice(this, start, end);
        case "base64":
            return $7c010d4b4bcea9b4$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $7c010d4b4bcea9b4$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$7c010d4b4bcea9b4$var$Buffer.prototype._isBuffer = true;
function $7c010d4b4bcea9b4$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$7c010d4b4bcea9b4$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$7c010d4b4bcea9b4$var$swap(this, i, i + 1);
    return this;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $7c010d4b4bcea9b4$var$swap(this, i, i + 3);
        $7c010d4b4bcea9b4$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $7c010d4b4bcea9b4$var$swap(this, i, i + 7);
        $7c010d4b4bcea9b4$var$swap(this, i + 1, i + 6);
        $7c010d4b4bcea9b4$var$swap(this, i + 2, i + 5);
        $7c010d4b4bcea9b4$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return $7c010d4b4bcea9b4$var$utf8Slice(this, 0, length);
    return $7c010d4b4bcea9b4$var$slowToString.apply(this, arguments);
};
$7c010d4b4bcea9b4$var$Buffer.prototype.equals = function equals(b) {
    if (!$7c010d4b4bcea9b4$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $7c010d4b4bcea9b4$var$Buffer.compare(this, b) === 0;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $7c010d4b4bcea9b4$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
$7c010d4b4bcea9b4$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$7c010d4b4bcea9b4$var$Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $7c010d4b4bcea9b4$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $7c010d4b4bcea9b4$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($7c010d4b4bcea9b4$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $7c010d4b4bcea9b4$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($7c010d4b4bcea9b4$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $7c010d4b4bcea9b4$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $7c010d4b4bcea9b4$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$7c010d4b4bcea9b4$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $7c010d4b4bcea9b4$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$7c010d4b4bcea9b4$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $7c010d4b4bcea9b4$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $7c010d4b4bcea9b4$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $7c010d4b4bcea9b4$var$utf8Write(buf, string, offset, length) {
    return $7c010d4b4bcea9b4$var$blitBuffer($7c010d4b4bcea9b4$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $7c010d4b4bcea9b4$var$asciiWrite(buf, string, offset, length) {
    return $7c010d4b4bcea9b4$var$blitBuffer($7c010d4b4bcea9b4$var$asciiToBytes(string), buf, offset, length);
}
function $7c010d4b4bcea9b4$var$latin1Write(buf, string, offset, length) {
    return $7c010d4b4bcea9b4$var$asciiWrite(buf, string, offset, length);
}
function $7c010d4b4bcea9b4$var$base64Write(buf, string, offset, length) {
    return $7c010d4b4bcea9b4$var$blitBuffer($7c010d4b4bcea9b4$var$base64ToBytes(string), buf, offset, length);
}
function $7c010d4b4bcea9b4$var$ucs2Write(buf, string, offset, length) {
    return $7c010d4b4bcea9b4$var$blitBuffer($7c010d4b4bcea9b4$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$7c010d4b4bcea9b4$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $7c010d4b4bcea9b4$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $7c010d4b4bcea9b4$var$utf8Write(this, string, offset, length);
        case "ascii":
            return $7c010d4b4bcea9b4$var$asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return $7c010d4b4bcea9b4$var$latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $7c010d4b4bcea9b4$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $7c010d4b4bcea9b4$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$7c010d4b4bcea9b4$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $7c010d4b4bcea9b4$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $RyRJ6.fromByteArray(buf);
    else return $RyRJ6.fromByteArray(buf.slice(start, end));
}
function $7c010d4b4bcea9b4$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $7c010d4b4bcea9b4$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $7c010d4b4bcea9b4$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $7c010d4b4bcea9b4$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $7c010d4b4bcea9b4$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $7c010d4b4bcea9b4$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $7c010d4b4bcea9b4$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $7c010d4b4bcea9b4$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $7c010d4b4bcea9b4$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $7c010d4b4bcea9b4$var$toHex(buf[i]);
    return out;
}
function $7c010d4b4bcea9b4$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$7c010d4b4bcea9b4$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($7c010d4b4bcea9b4$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $7c010d4b4bcea9b4$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $7c010d4b4bcea9b4$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $7c010d4b4bcea9b4$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$7c010d4b4bcea9b4$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7c010d4b4bcea9b4$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7c010d4b4bcea9b4$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $7c010d4b4bcea9b4$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$7c010d4b4bcea9b4$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $7c010d4b4bcea9b4$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $7c010d4b4bcea9b4$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$7c010d4b4bcea9b4$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $7c010d4b4bcea9b4$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $7c010d4b4bcea9b4$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$7c010d4b4bcea9b4$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7c010d4b4bcea9b4$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $7c010d4b4bcea9b4$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $7c010d4b4bcea9b4$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $7c010d4b4bcea9b4$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $7c010d4b4bcea9b4$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $7c010d4b4bcea9b4$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $7c010d4b4bcea9b4$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$7c010d4b4bcea9b4$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $7c010d4b4bcea9b4$var$checkOffset(offset, 4, this.length);
    return $kjGnt.read(this, offset, true, 23, 4);
};
$7c010d4b4bcea9b4$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $7c010d4b4bcea9b4$var$checkOffset(offset, 4, this.length);
    return $kjGnt.read(this, offset, false, 23, 4);
};
$7c010d4b4bcea9b4$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $7c010d4b4bcea9b4$var$checkOffset(offset, 8, this.length);
    return $kjGnt.read(this, offset, true, 52, 8);
};
$7c010d4b4bcea9b4$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $7c010d4b4bcea9b4$var$checkOffset(offset, 8, this.length);
    return $kjGnt.read(this, offset, false, 52, 8);
};
function $7c010d4b4bcea9b4$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$7c010d4b4bcea9b4$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$7c010d4b4bcea9b4$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $7c010d4b4bcea9b4$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $7c010d4b4bcea9b4$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7c010d4b4bcea9b4$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$7c010d4b4bcea9b4$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $7c010d4b4bcea9b4$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$7c010d4b4bcea9b4$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7c010d4b4bcea9b4$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($7c010d4b4bcea9b4$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $7c010d4b4bcea9b4$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7c010d4b4bcea9b4$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($7c010d4b4bcea9b4$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $7c010d4b4bcea9b4$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $7c010d4b4bcea9b4$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$7c010d4b4bcea9b4$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7c010d4b4bcea9b4$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($7c010d4b4bcea9b4$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $7c010d4b4bcea9b4$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7c010d4b4bcea9b4$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($7c010d4b4bcea9b4$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $7c010d4b4bcea9b4$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $7c010d4b4bcea9b4$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $7c010d4b4bcea9b4$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7c010d4b4bcea9b4$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$7c010d4b4bcea9b4$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7c010d4b4bcea9b4$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($7c010d4b4bcea9b4$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $7c010d4b4bcea9b4$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7c010d4b4bcea9b4$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($7c010d4b4bcea9b4$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $7c010d4b4bcea9b4$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7c010d4b4bcea9b4$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($7c010d4b4bcea9b4$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $7c010d4b4bcea9b4$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$7c010d4b4bcea9b4$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $7c010d4b4bcea9b4$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($7c010d4b4bcea9b4$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $7c010d4b4bcea9b4$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $7c010d4b4bcea9b4$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $7c010d4b4bcea9b4$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $7c010d4b4bcea9b4$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $kjGnt.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$7c010d4b4bcea9b4$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $7c010d4b4bcea9b4$var$writeFloat(this, value, offset, true, noAssert);
};
$7c010d4b4bcea9b4$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $7c010d4b4bcea9b4$var$writeFloat(this, value, offset, false, noAssert);
};
function $7c010d4b4bcea9b4$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $7c010d4b4bcea9b4$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $kjGnt.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$7c010d4b4bcea9b4$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $7c010d4b4bcea9b4$var$writeDouble(this, value, offset, true, noAssert);
};
$7c010d4b4bcea9b4$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $7c010d4b4bcea9b4$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$7c010d4b4bcea9b4$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$7c010d4b4bcea9b4$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$7c010d4b4bcea9b4$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$7c010d4b4bcea9b4$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $7c010d4b4bcea9b4$var$Buffer.isBuffer(val) ? val : $7c010d4b4bcea9b4$var$utf8ToBytes(new $7c010d4b4bcea9b4$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $7c010d4b4bcea9b4$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $7c010d4b4bcea9b4$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $7c010d4b4bcea9b4$var$stringtrim(str).replace($7c010d4b4bcea9b4$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $7c010d4b4bcea9b4$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function $7c010d4b4bcea9b4$var$toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function $7c010d4b4bcea9b4$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $7c010d4b4bcea9b4$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $7c010d4b4bcea9b4$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $7c010d4b4bcea9b4$var$base64ToBytes(str) {
    return $RyRJ6.toByteArray($7c010d4b4bcea9b4$var$base64clean(str));
}
function $7c010d4b4bcea9b4$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $7c010d4b4bcea9b4$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}

});

parcelRequire.register("7IQXV", function(module, exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        /*
	     * Local polyfil of Object.create
	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var i = 0; i < thatSigBytes; i += 4)thisWords[thisSigBytes + i >>> 2] = thatWords[i >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                var r = function(m_w) {
                    var m_w = m_w;
                    var m_z = 0x3ade68b1;
                    var mask = 0xffffffff;
                    return function() {
                        m_z = 0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10) & mask;
                        m_w = 0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10) & mask;
                        var result = (m_z << 0x10) + m_w & mask;
                        result /= 0x100000000;
                        result += 0.5;
                        return result * (Math1.random() > .5 ? 1 : -1);
                    };
                };
                for(var i = 0, rcache; i < nBytes; i += 4){
                    var _r = r((rcache || Math1.random()) * 0x100000000);
                    rcache = _r() * 0x3ade67b7;
                    words.push(_r() * 0x100000000 | 0);
                }
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    var processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});

parcelRequire.register("lr3QI", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("7IQXV")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != "function") return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRequire.register("fbuuf", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("7IQXV")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRequire.register("m6xY6", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("7IQXV")), (parcelRequire("fbuuf")), (parcelRequire("bzqHu")));
})(this, function(CryptoJS) {
    return CryptoJS.HmacSHA256;
});

});
parcelRequire.register("bzqHu", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("7IQXV")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == "string") key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});


parcelRequire.register("4OMoi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38215e5d521645a0$export$2e2bcd8739ae039; });
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
var $38215e5d521645a0$export$2e2bcd8739ae039 = $38215e5d521645a0$var$BigInteger;
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */ // (public) Constructor
function $38215e5d521645a0$var$BigInteger(a, b) {
    if (a != null) this.fromString(a, b);
}
// return new, unset BigInteger
function $38215e5d521645a0$var$nbi() {
    return new $38215e5d521645a0$var$BigInteger(null);
}
// Bits per digit
var $38215e5d521645a0$var$dbits;
// JavaScript engine analysis
var $38215e5d521645a0$var$canary = 0xdeadbeefcafe;
var $38215e5d521645a0$var$j_lm = ($38215e5d521645a0$var$canary & 0xffffff) == 0xefcafe;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $38215e5d521645a0$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $38215e5d521645a0$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $38215e5d521645a0$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
var $38215e5d521645a0$var$inBrowser = typeof navigator !== "undefined";
if ($38215e5d521645a0$var$inBrowser && $38215e5d521645a0$var$j_lm && navigator.appName == "Microsoft Internet Explorer") {
    $38215e5d521645a0$var$BigInteger.prototype.am = $38215e5d521645a0$var$am2;
    $38215e5d521645a0$var$dbits = 30;
} else if ($38215e5d521645a0$var$inBrowser && $38215e5d521645a0$var$j_lm && navigator.appName != "Netscape") {
    $38215e5d521645a0$var$BigInteger.prototype.am = $38215e5d521645a0$var$am1;
    $38215e5d521645a0$var$dbits = 26;
} else {
    // Mozilla/Netscape seems to prefer am3
    $38215e5d521645a0$var$BigInteger.prototype.am = $38215e5d521645a0$var$am3;
    $38215e5d521645a0$var$dbits = 28;
}
$38215e5d521645a0$var$BigInteger.prototype.DB = $38215e5d521645a0$var$dbits;
$38215e5d521645a0$var$BigInteger.prototype.DM = (1 << $38215e5d521645a0$var$dbits) - 1;
$38215e5d521645a0$var$BigInteger.prototype.DV = 1 << $38215e5d521645a0$var$dbits;
var $38215e5d521645a0$var$BI_FP = 52;
$38215e5d521645a0$var$BigInteger.prototype.FV = Math.pow(2, $38215e5d521645a0$var$BI_FP);
$38215e5d521645a0$var$BigInteger.prototype.F1 = $38215e5d521645a0$var$BI_FP - $38215e5d521645a0$var$dbits;
$38215e5d521645a0$var$BigInteger.prototype.F2 = 2 * $38215e5d521645a0$var$dbits - $38215e5d521645a0$var$BI_FP;
// Digit conversions
var $38215e5d521645a0$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var $38215e5d521645a0$var$BI_RC = new Array();
var $38215e5d521645a0$var$rr, $38215e5d521645a0$var$vv;
$38215e5d521645a0$var$rr = "0".charCodeAt(0);
for($38215e5d521645a0$var$vv = 0; $38215e5d521645a0$var$vv <= 9; ++$38215e5d521645a0$var$vv)$38215e5d521645a0$var$BI_RC[$38215e5d521645a0$var$rr++] = $38215e5d521645a0$var$vv;
$38215e5d521645a0$var$rr = "a".charCodeAt(0);
for($38215e5d521645a0$var$vv = 10; $38215e5d521645a0$var$vv < 36; ++$38215e5d521645a0$var$vv)$38215e5d521645a0$var$BI_RC[$38215e5d521645a0$var$rr++] = $38215e5d521645a0$var$vv;
$38215e5d521645a0$var$rr = "A".charCodeAt(0);
for($38215e5d521645a0$var$vv = 10; $38215e5d521645a0$var$vv < 36; ++$38215e5d521645a0$var$vv)$38215e5d521645a0$var$BI_RC[$38215e5d521645a0$var$rr++] = $38215e5d521645a0$var$vv;
function $38215e5d521645a0$var$int2char(n) {
    return $38215e5d521645a0$var$BI_RM.charAt(n);
}
function $38215e5d521645a0$var$intAt(s, i) {
    var c = $38215e5d521645a0$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $38215e5d521645a0$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $38215e5d521645a0$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + this.DV;
    else this.t = 0;
}
// return bigint initialized to value
function $38215e5d521645a0$var$nbv(i) {
    var r = $38215e5d521645a0$var$nbi();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $38215e5d521645a0$var$bnpFromString(s, b) {
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    this.t = 0;
    this.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = $38215e5d521645a0$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) this[this.t++] = x;
        else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
            this[this.t++] = x >> this.DB - sh;
        } else this[this.t - 1] |= x << sh;
        sh += k;
        if (sh >= this.DB) sh -= this.DB;
    }
    this.clamp();
    if (mi) $38215e5d521645a0$var$BigInteger.ZERO.subTo(this, this);
}
// (protected) clamp off excess high words
function $38215e5d521645a0$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $38215e5d521645a0$var$bnToString(b) {
    if (this.s < 0) return "-" + this.negate().toString();
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
    var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
        if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = $38215e5d521645a0$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (this[i] & (1 << p) - 1) << k - p;
                d |= this[--i] >> (p += this.DB - k);
            } else {
                d = this[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += this.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $38215e5d521645a0$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $38215e5d521645a0$var$bnNegate() {
    var r = $38215e5d521645a0$var$nbi();
    $38215e5d521645a0$var$BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $38215e5d521645a0$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $38215e5d521645a0$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0){
        if ((r = this[i] - a[i]) != 0) return r;
    }
    return 0;
}
// returns bit length of the integer x
function $38215e5d521645a0$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $38215e5d521645a0$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $38215e5d521645a0$var$nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (protected) r = this << n*DB
function $38215e5d521645a0$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $38215e5d521645a0$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $38215e5d521645a0$var$bnpLShiftTo(n, r) {
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
    for(i = this.t - 1; i >= 0; --i){
        r[i + ds + 1] = this[i] >> cbs | c;
        c = (this[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
}
// (protected) r = this >> n
function $38215e5d521645a0$var$bnpRShiftTo(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
        r.t = 0;
        return;
    }
    var bs = n % this.DB;
    var cbs = this.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = this[ds] >> bs;
    for(var i = ds + 1; i < this.t; ++i){
        r[i - ds - 1] |= (this[i] & bm) << cbs;
        r[i - ds] = this[i] >> bs;
    }
    if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
    r.t = this.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $38215e5d521645a0$var$bnpSubTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] - a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c -= a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = this.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $38215e5d521645a0$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $38215e5d521645a0$var$BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $38215e5d521645a0$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $38215e5d521645a0$var$bnpDivRemTo(m, q, r) {
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = this.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) this.copyTo(r);
        return;
    }
    if (r == null) r = $38215e5d521645a0$var$nbi();
    var y = $38215e5d521645a0$var$nbi(), ts = this.s, ms = m.s;
    var nsh = this.DB - $38215e5d521645a0$var$nbits(pm[pm.t - 1]);
    // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
    var i = r.t, j = i - ys, t = q == null ? $38215e5d521645a0$var$nbi() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $38215e5d521645a0$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y);
    // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $38215e5d521645a0$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r);
    // Denormalize remainder
    if (ts < 0) $38215e5d521645a0$var$BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function $38215e5d521645a0$var$bnMod(a) {
    var r = $38215e5d521645a0$var$nbi();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($38215e5d521645a0$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $38215e5d521645a0$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3;
    // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf;
    // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff;
    // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
    // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly;
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV;
    // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
function $38215e5d521645a0$var$bnEquals(a) {
    return this.compareTo(a) == 0;
}
// (protected) r = this + a
function $38215e5d521645a0$var$bnpAddTo(a, r) {
    var i = 0, c = 0, m = Math.min(a.t, this.t);
    while(i < m){
        c += this[i] + a[i];
        r[i++] = c & this.DM;
        c >>= this.DB;
    }
    if (a.t < this.t) {
        c += a.s;
        while(i < this.t){
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += this.s;
    } else {
        c += this.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = this.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function $38215e5d521645a0$var$bnAdd(a) {
    var r = $38215e5d521645a0$var$nbi();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function $38215e5d521645a0$var$bnSubtract(a) {
    var r = $38215e5d521645a0$var$nbi();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function $38215e5d521645a0$var$bnMultiply(a) {
    var r = $38215e5d521645a0$var$nbi();
    this.multiplyTo(a, r);
    return r;
}
// (public) this / a
function $38215e5d521645a0$var$bnDivide(a) {
    var r = $38215e5d521645a0$var$nbi();
    this.divRemTo(a, r, null);
    return r;
}
// Montgomery reduction
function $38215e5d521645a0$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $38215e5d521645a0$var$montConvert(x) {
    var r = $38215e5d521645a0$var$nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($38215e5d521645a0$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $38215e5d521645a0$var$montRevert(x) {
    var r = $38215e5d521645a0$var$nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $38215e5d521645a0$var$montReduce(x) {
    while(x.t <= this.mt2)// pad x so am has enough room later
    x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $38215e5d521645a0$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $38215e5d521645a0$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$38215e5d521645a0$var$Montgomery.prototype.convert = $38215e5d521645a0$var$montConvert;
$38215e5d521645a0$var$Montgomery.prototype.revert = $38215e5d521645a0$var$montRevert;
$38215e5d521645a0$var$Montgomery.prototype.reduce = $38215e5d521645a0$var$montReduce;
$38215e5d521645a0$var$Montgomery.prototype.mulTo = $38215e5d521645a0$var$montMulTo;
$38215e5d521645a0$var$Montgomery.prototype.sqrTo = $38215e5d521645a0$var$montSqrTo;
// (public) this^e % m (HAC 14.85)
function $38215e5d521645a0$var$bnModPow(e, m, callback) {
    var i = e.bitLength(), k, r = $38215e5d521645a0$var$nbv(1), z = new $38215e5d521645a0$var$Montgomery(m);
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = $38215e5d521645a0$var$nbi();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = $38215e5d521645a0$var$nbi();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = $38215e5d521645a0$var$nbi(), t;
    i = $38215e5d521645a0$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    var result = z.revert(r);
    callback(null, result);
    return result;
}
// protected
$38215e5d521645a0$var$BigInteger.prototype.copyTo = $38215e5d521645a0$var$bnpCopyTo;
$38215e5d521645a0$var$BigInteger.prototype.fromInt = $38215e5d521645a0$var$bnpFromInt;
$38215e5d521645a0$var$BigInteger.prototype.fromString = $38215e5d521645a0$var$bnpFromString;
$38215e5d521645a0$var$BigInteger.prototype.clamp = $38215e5d521645a0$var$bnpClamp;
$38215e5d521645a0$var$BigInteger.prototype.dlShiftTo = $38215e5d521645a0$var$bnpDLShiftTo;
$38215e5d521645a0$var$BigInteger.prototype.drShiftTo = $38215e5d521645a0$var$bnpDRShiftTo;
$38215e5d521645a0$var$BigInteger.prototype.lShiftTo = $38215e5d521645a0$var$bnpLShiftTo;
$38215e5d521645a0$var$BigInteger.prototype.rShiftTo = $38215e5d521645a0$var$bnpRShiftTo;
$38215e5d521645a0$var$BigInteger.prototype.subTo = $38215e5d521645a0$var$bnpSubTo;
$38215e5d521645a0$var$BigInteger.prototype.multiplyTo = $38215e5d521645a0$var$bnpMultiplyTo;
$38215e5d521645a0$var$BigInteger.prototype.squareTo = $38215e5d521645a0$var$bnpSquareTo;
$38215e5d521645a0$var$BigInteger.prototype.divRemTo = $38215e5d521645a0$var$bnpDivRemTo;
$38215e5d521645a0$var$BigInteger.prototype.invDigit = $38215e5d521645a0$var$bnpInvDigit;
$38215e5d521645a0$var$BigInteger.prototype.addTo = $38215e5d521645a0$var$bnpAddTo;
// public
$38215e5d521645a0$var$BigInteger.prototype.toString = $38215e5d521645a0$var$bnToString;
$38215e5d521645a0$var$BigInteger.prototype.negate = $38215e5d521645a0$var$bnNegate;
$38215e5d521645a0$var$BigInteger.prototype.abs = $38215e5d521645a0$var$bnAbs;
$38215e5d521645a0$var$BigInteger.prototype.compareTo = $38215e5d521645a0$var$bnCompareTo;
$38215e5d521645a0$var$BigInteger.prototype.bitLength = $38215e5d521645a0$var$bnBitLength;
$38215e5d521645a0$var$BigInteger.prototype.mod = $38215e5d521645a0$var$bnMod;
$38215e5d521645a0$var$BigInteger.prototype.equals = $38215e5d521645a0$var$bnEquals;
$38215e5d521645a0$var$BigInteger.prototype.add = $38215e5d521645a0$var$bnAdd;
$38215e5d521645a0$var$BigInteger.prototype.subtract = $38215e5d521645a0$var$bnSubtract;
$38215e5d521645a0$var$BigInteger.prototype.multiply = $38215e5d521645a0$var$bnMultiply;
$38215e5d521645a0$var$BigInteger.prototype.divide = $38215e5d521645a0$var$bnDivide;
$38215e5d521645a0$var$BigInteger.prototype.modPow = $38215e5d521645a0$var$bnModPow;
// "constants"
$38215e5d521645a0$var$BigInteger.ZERO = $38215e5d521645a0$var$nbv(0);
$38215e5d521645a0$var$BigInteger.ONE = $38215e5d521645a0$var$nbv(1);

});


parcelRequire.register("3kONY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26daa62bd6c369b9$export$2e2bcd8739ae039; });

var $geV7x = parcelRequire("geV7x");
function $26daa62bd6c369b9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $26daa62bd6c369b9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $26daa62bd6c369b9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/** @class */ var $26daa62bd6c369b9$var$CognitoAccessToken = function(_CognitoJwtToken) {
    $26daa62bd6c369b9$var$_inherits(CognitoAccessToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */ function CognitoAccessToken() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, AccessToken = _ref.AccessToken;
        $26daa62bd6c369b9$var$_classCallCheck(this, CognitoAccessToken);
        return $26daa62bd6c369b9$var$_possibleConstructorReturn(this, _CognitoJwtToken.call(this, AccessToken || ""));
    }
    return CognitoAccessToken;
}((0, $geV7x.default));
var $26daa62bd6c369b9$export$2e2bcd8739ae039 = $26daa62bd6c369b9$var$CognitoAccessToken;

});
parcelRequire.register("geV7x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd2a4314916ba08c$export$2e2bcd8739ae039; });

var $aE4oM = parcelRequire("aE4oM");
function $bd2a4314916ba08c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/** @class */ var $bd2a4314916ba08c$var$CognitoJwtToken = function() {
    /**
  * Constructs a new CognitoJwtToken object
  * @param {string=} token The JWT token.
  */ function CognitoJwtToken(token) {
        $bd2a4314916ba08c$var$_classCallCheck(this, CognitoJwtToken);
        // Assign object
        this.jwtToken = token || "";
        this.payload = this.decodePayload();
    }
    /**
  * @returns {string} the record's token.
  */ CognitoJwtToken.prototype.getJwtToken = function getJwtToken() {
        return this.jwtToken;
    };
    /**
  * @returns {int} the token's expiration (exp member).
  */ CognitoJwtToken.prototype.getExpiration = function getExpiration() {
        return this.payload.exp;
    };
    /**
  * @returns {int} the token's "issued at" (iat member).
  */ CognitoJwtToken.prototype.getIssuedAt = function getIssuedAt() {
        return this.payload.iat;
    };
    /**
  * @returns {object} the token's payload.
  */ CognitoJwtToken.prototype.decodePayload = function decodePayload() {
        var payload = this.jwtToken.split(".")[1];
        try {
            return JSON.parse((0, $aE4oM.Buffer).from(payload, "base64").toString("utf8"));
        } catch (err) {
            return {};
        }
    };
    return CognitoJwtToken;
}();
var $bd2a4314916ba08c$export$2e2bcd8739ae039 = $bd2a4314916ba08c$var$CognitoJwtToken;

});


parcelRequire.register("VNeTv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0adb84df135e7c36$export$2e2bcd8739ae039; });

var $geV7x = parcelRequire("geV7x");
function $0adb84df135e7c36$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0adb84df135e7c36$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $0adb84df135e7c36$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/** @class */ var $0adb84df135e7c36$var$CognitoIdToken = function(_CognitoJwtToken) {
    $0adb84df135e7c36$var$_inherits(CognitoIdToken, _CognitoJwtToken);
    /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */ function CognitoIdToken() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, IdToken = _ref.IdToken;
        $0adb84df135e7c36$var$_classCallCheck(this, CognitoIdToken);
        return $0adb84df135e7c36$var$_possibleConstructorReturn(this, _CognitoJwtToken.call(this, IdToken || ""));
    }
    return CognitoIdToken;
}((0, $geV7x.default));
var $0adb84df135e7c36$export$2e2bcd8739ae039 = $0adb84df135e7c36$var$CognitoIdToken;

});

parcelRequire.register("M7FPA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $090a6fa52d6032a9$export$2e2bcd8739ae039; });
function $090a6fa52d6032a9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ /** @class */ var $090a6fa52d6032a9$var$CognitoRefreshToken = function() {
    /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */ function CognitoRefreshToken() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, RefreshToken = _ref.RefreshToken;
        $090a6fa52d6032a9$var$_classCallCheck(this, CognitoRefreshToken);
        // Assign object
        this.token = RefreshToken || "";
    }
    /**
   * @returns {string} the record's token.
   */ CognitoRefreshToken.prototype.getToken = function getToken() {
        return this.token;
    };
    return CognitoRefreshToken;
}();
var $090a6fa52d6032a9$export$2e2bcd8739ae039 = $090a6fa52d6032a9$var$CognitoRefreshToken;

});

parcelRequire.register("4myfH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32d3c94368f73470$export$2e2bcd8739ae039; });

var $aE4oM = parcelRequire("aE4oM");

var $7IQXV = parcelRequire("7IQXV");
parcelRequire("lr3QI");

var $kqURS = parcelRequire("kqURS");

var $m6xY6 = parcelRequire("m6xY6");

var $4OMoi = parcelRequire("4OMoi");

var $eGFMf = parcelRequire("eGFMf");

var $3kONY = parcelRequire("3kONY");

var $VNeTv = parcelRequire("VNeTv");

var $M7FPA = parcelRequire("M7FPA");

var $dTtsJ = parcelRequire("dTtsJ");

var $2R4Jl = parcelRequire("2R4Jl");

var $kdPCY = parcelRequire("kdPCY");

var $23Zzy = parcelRequire("23Zzy");
function $32d3c94368f73470$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */ /**
 * @callback onFailure
 * @param {*} err Failure reason.
 */ /**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */ /**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */ /**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */ /**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */ /**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */ /** @class */ var $32d3c94368f73470$var$CognitoUser = function() {
    /**
  * Constructs a new CognitoUser object
  * @param {object} data Creation options
  * @param {string} data.Username The user's username.
  * @param {CognitoUserPool} data.Pool Pool containing the user.
  * @param {object} data.Storage Optional storage object.
  */ function CognitoUser(data) {
        $32d3c94368f73470$var$_classCallCheck(this, CognitoUser);
        if (data == null || data.Username == null || data.Pool == null) throw new Error("Username and pool information are required.");
        this.username = data.Username || "";
        this.pool = data.Pool;
        this.Session = null;
        this.client = data.Pool.client;
        this.signInUserSession = null;
        this.authenticationFlowType = "USER_SRP_AUTH";
        this.storage = data.Storage || new (0, $23Zzy.default)().getStorage();
        this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
    }
    /**
  * Sets the session for this user
  * @param {CognitoUserSession} signInUserSession the session
  * @returns {void}
  */ CognitoUser.prototype.setSignInUserSession = function setSignInUserSession(signInUserSession) {
        this.clearCachedUserData();
        this.signInUserSession = signInUserSession;
        this.cacheTokens();
    };
    /**
  * @returns {CognitoUserSession} the current session for this user
  */ CognitoUser.prototype.getSignInUserSession = function getSignInUserSession() {
        return this.signInUserSession;
    };
    /**
  * @returns {string} the user's username
  */ CognitoUser.prototype.getUsername = function getUsername() {
        return this.username;
    };
    /**
  * @returns {String} the authentication flow type
  */ CognitoUser.prototype.getAuthenticationFlowType = function getAuthenticationFlowType() {
        return this.authenticationFlowType;
    };
    /**
  * sets authentication flow type
  * @param {string} authenticationFlowType New value.
  * @returns {void}
  */ CognitoUser.prototype.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
        this.authenticationFlowType = authenticationFlowType;
    };
    /**
  * This is used for authenticating the user through the custom authentication flow.
  * @param {AuthenticationDetails} authDetails Contains the authentication data
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {customChallenge} callback.customChallenge Custom challenge
  *        response required to continue.
  * @param {authSuccess} callback.onSuccess Called on success with the new session.
  * @returns {void}
  */ CognitoUser.prototype.initiateAuth = function initiateAuth(authDetails, callback) {
        var _this = this;
        var authParameters = authDetails.getAuthParameters();
        authParameters.USERNAME = this.username;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "CUSTOM_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            var challengeName = data.ChallengeName;
            var challengeParameters = data.ChallengeParameters;
            if (challengeName === "CUSTOM_CHALLENGE") {
                _this.Session = data.Session;
                return callback.customChallenge(challengeParameters);
            }
            _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
            _this.cacheTokens();
            return callback.onSuccess(_this.signInUserSession);
        });
    };
    /**
  * This is used for authenticating the user.
  * stuff
  * @param {AuthenticationDetails} authDetails Contains the authentication data
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {newPasswordRequired} callback.newPasswordRequired new
  *        password and any required attributes are required to continue
  * @param {mfaRequired} callback.mfaRequired MFA code
  *        required to continue.
  * @param {customChallenge} callback.customChallenge Custom challenge
  *        response required to continue.
  * @param {authSuccess} callback.onSuccess Called on success with the new session.
  * @returns {void}
  */ CognitoUser.prototype.authenticateUser = function authenticateUser(authDetails, callback) {
        if (this.authenticationFlowType === "USER_PASSWORD_AUTH") return this.authenticateUserPlainUsernamePassword(authDetails, callback);
        else if (this.authenticationFlowType === "USER_SRP_AUTH" || this.authenticationFlowType === "CUSTOM_AUTH") return this.authenticateUserDefaultAuth(authDetails, callback);
        return callback.onFailure(new Error("Authentication flow type is invalid."));
    };
    /**
  * PRIVATE ONLY: This is an internal only method and should not
  * be directly called by the consumers.
  * It calls the AuthenticationHelper for SRP related
  * stuff
  * @param {AuthenticationDetails} authDetails Contains the authentication data
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {newPasswordRequired} callback.newPasswordRequired new
  *        password and any required attributes are required to continue
  * @param {mfaRequired} callback.mfaRequired MFA code
  *        required to continue.
  * @param {customChallenge} callback.customChallenge Custom challenge
  *        response required to continue.
  * @param {authSuccess} callback.onSuccess Called on success with the new session.
  * @returns {void}
  */ CognitoUser.prototype.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
        var _this2 = this;
        var authenticationHelper = new (0, $eGFMf.default)(this.pool.getUserPoolId().split("_")[1]);
        var dateHelper = new (0, $2R4Jl.default)();
        var serverBValue = void 0;
        var salt = void 0;
        var authParameters = {};
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        authParameters.USERNAME = this.username;
        authenticationHelper.getLargeAValue(function(errOnAValue, aValue) {
            // getLargeAValue callback start
            if (errOnAValue) callback.onFailure(errOnAValue);
            authParameters.SRP_A = aValue.toString(16);
            if (_this2.authenticationFlowType === "CUSTOM_AUTH") authParameters.CHALLENGE_NAME = "SRP_A";
            var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
            var jsonReq = {
                AuthFlow: _this2.authenticationFlowType,
                ClientId: _this2.pool.getClientId(),
                AuthParameters: authParameters,
                ClientMetadata: clientMetaData
            };
            if (_this2.getUserContextData(_this2.username)) jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
            _this2.client.request("InitiateAuth", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                _this2.username = challengeParameters.USER_ID_FOR_SRP;
                serverBValue = new (0, $4OMoi.default)(challengeParameters.SRP_B, 16);
                salt = new (0, $4OMoi.default)(challengeParameters.SALT, 16);
                _this2.getCachedDeviceKeyAndPassword();
                authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function(errOnHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errOnHkdf) callback.onFailure(errOnHkdf);
                    var dateNow = dateHelper.getNowString();
                    var message = (0, (/*@__PURE__*/$parcel$interopDefault($7IQXV))).lib.WordArray.create((0, $aE4oM.Buffer).concat([
                        (0, $aE4oM.Buffer).from(_this2.pool.getUserPoolId().split("_")[1], "utf8"),
                        (0, $aE4oM.Buffer).from(_this2.username, "utf8"),
                        (0, $aE4oM.Buffer).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $aE4oM.Buffer).from(dateNow, "utf8")
                    ]));
                    var key = (0, (/*@__PURE__*/$parcel$interopDefault($7IQXV))).lib.WordArray.create(hkdf);
                    var signatureString = (0, (/*@__PURE__*/$parcel$interopDefault($kqURS))).stringify((0, (/*@__PURE__*/$parcel$interopDefault($m6xY6)))(message, key));
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this2.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    if (_this2.deviceKey != null) challengeResponses.DEVICE_KEY = _this2.deviceKey;
                    var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
                        return _this2.client.request("RespondToAuthChallenge", challenge, function(errChallenge, dataChallenge) {
                            if (errChallenge && errChallenge.code === "ResourceNotFoundException" && errChallenge.message.toLowerCase().indexOf("device") !== -1) {
                                challengeResponses.DEVICE_KEY = null;
                                _this2.deviceKey = null;
                                _this2.randomPassword = null;
                                _this2.deviceGroupKey = null;
                                _this2.clearCachedDeviceKeyAndPassword();
                                return respondToAuthChallenge(challenge, challengeCallback);
                            }
                            return challengeCallback(errChallenge, dataChallenge);
                        });
                    };
                    var jsonReqResp = {
                        ChallengeName: "PASSWORD_VERIFIER",
                        ClientId: _this2.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session,
                        ClientMetadata: clientMetaData
                    };
                    if (_this2.getUserContextData()) jsonReqResp.UserContextData = _this2.getUserContextData();
                    respondToAuthChallenge(jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    };
    /**
  * PRIVATE ONLY: This is an internal only method and should not
  * be directly called by the consumers.
  * @param {AuthenticationDetails} authDetails Contains the authentication data.
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {mfaRequired} callback.mfaRequired MFA code
  *        required to continue.
  * @param {authSuccess} callback.onSuccess Called on success with the new session.
  * @returns {void}
  */ CognitoUser.prototype.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
        var _this3 = this;
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.PASSWORD = authDetails.getPassword();
        if (!authParameters.PASSWORD) {
            callback.onFailure(new Error("PASSWORD parameter is required"));
            return;
        }
        var authenticationHelper = new (0, $eGFMf.default)(this.pool.getUserPoolId().split("_")[1]);
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) authParameters.DEVICE_KEY = this.deviceKey;
        var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
        var jsonReq = {
            AuthFlow: "USER_PASSWORD_AUTH",
            ClientId: this.pool.getClientId(),
            AuthParameters: authParameters,
            ClientMetadata: clientMetaData
        };
        if (this.getUserContextData(this.username)) jsonReq.UserContextData = this.getUserContextData(this.username);
        // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
        // Cognito UserPools verifies password and returns tokens.
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) return callback.onFailure(err);
            return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
        });
    };
    /**
  * PRIVATE ONLY: This is an internal only method and should not
  * be directly called by the consumers.
  * @param {object} dataAuthenticate authentication data
  * @param {object} authenticationHelper helper created
  * @param {callback} callback passed on from caller
  * @returns {void}
  */ CognitoUser.prototype.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
        var _this4 = this;
        var challengeName = dataAuthenticate.ChallengeName;
        var challengeParameters = dataAuthenticate.ChallengeParameters;
        if (challengeName === "SMS_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaRequired(challengeName, challengeParameters);
        }
        if (challengeName === "SELECT_MFA_TYPE") {
            this.Session = dataAuthenticate.Session;
            return callback.selectMFAType(challengeName, challengeParameters);
        }
        if (challengeName === "MFA_SETUP") {
            this.Session = dataAuthenticate.Session;
            return callback.mfaSetup(challengeName, challengeParameters);
        }
        if (challengeName === "SOFTWARE_TOKEN_MFA") {
            this.Session = dataAuthenticate.Session;
            return callback.totpRequired(challengeName, challengeParameters);
        }
        if (challengeName === "CUSTOM_CHALLENGE") {
            this.Session = dataAuthenticate.Session;
            return callback.customChallenge(challengeParameters);
        }
        if (challengeName === "NEW_PASSWORD_REQUIRED") {
            this.Session = dataAuthenticate.Session;
            var userAttributes = null;
            var rawRequiredAttributes = null;
            var requiredAttributes = [];
            var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
            if (challengeParameters) {
                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
            }
            if (rawRequiredAttributes) for(var i = 0; i < rawRequiredAttributes.length; i++)requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
            return callback.newPasswordRequired(userAttributes, requiredAttributes);
        }
        if (challengeName === "DEVICE_SRP_AUTH") {
            this.getDeviceResponse(callback);
            return undefined;
        }
        this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
        this.challengeName = challengeName;
        this.cacheTokens();
        var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
        if (newDeviceMetadata == null) return callback.onSuccess(this.signInUserSession);
        authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
            if (errGenHash) return callback.onFailure(errGenHash);
            var deviceSecretVerifierConfig = {
                Salt: (0, $aE4oM.Buffer).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                PasswordVerifier: (0, $aE4oM.Buffer).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
            };
            _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
            _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
            _this4.randomPassword = authenticationHelper.getRandomPassword();
            _this4.client.request("ConfirmDevice", {
                DeviceKey: newDeviceMetadata.DeviceKey,
                AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
                DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                DeviceName: navigator.userAgent
            }, function(errConfirm, dataConfirm) {
                if (errConfirm) return callback.onFailure(errConfirm);
                _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                _this4.cacheDeviceKeyAndPassword();
                if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
                return callback.onSuccess(_this4.signInUserSession);
            });
            return undefined;
        });
        return undefined;
    };
    /**
  * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
  * Pass the new password with any new user attributes to be updated.
  * User attribute keys must be of format userAttributes.<attribute_name>.
  * @param {string} newPassword new password for this user
  * @param {object} requiredAttributeData map with values for all required attributes
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
  * @param {customChallenge} callback.customChallenge Custom challenge
  *         response required to continue.
  * @param {authSuccess} callback.onSuccess Called on success with the new session.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */ CognitoUser.prototype.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
        var _this5 = this;
        if (!newPassword) return callback.onFailure(new Error("New password is required."));
        var authenticationHelper = new (0, $eGFMf.default)(this.pool.getUserPoolId().split("_")[1]);
        var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
        var finalUserAttributes = {};
        if (requiredAttributeData) Object.keys(requiredAttributeData).forEach(function(key) {
            finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
        });
        finalUserAttributes.NEW_PASSWORD = newPassword;
        finalUserAttributes.USERNAME = this.username;
        var jsonReq = {
            ChallengeName: "NEW_PASSWORD_REQUIRED",
            ClientId: this.pool.getClientId(),
            ChallengeResponses: finalUserAttributes,
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) return callback.onFailure(errAuthenticate);
            return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
        });
        return undefined;
    };
    /**
  * This is used to get a session using device authentication. It is called at the end of user
  * authentication
  *
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {authSuccess} callback.onSuccess Called on success with the new session.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  * @private
  */ CognitoUser.prototype.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
        var _this6 = this;
        var authenticationHelper = new (0, $eGFMf.default)(this.deviceGroupKey);
        var dateHelper = new (0, $2R4Jl.default)();
        var authParameters = {};
        authParameters.USERNAME = this.username;
        authParameters.DEVICE_KEY = this.deviceKey;
        authenticationHelper.getLargeAValue(function(errAValue, aValue) {
            // getLargeAValue callback start
            if (errAValue) callback.onFailure(errAValue);
            authParameters.SRP_A = aValue.toString(16);
            var jsonReq = {
                ChallengeName: "DEVICE_SRP_AUTH",
                ClientId: _this6.pool.getClientId(),
                ChallengeResponses: authParameters,
                ClientMetadata: clientMetadata
            };
            if (_this6.getUserContextData()) jsonReq.UserContextData = _this6.getUserContextData();
            _this6.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
                if (err) return callback.onFailure(err);
                var challengeParameters = data.ChallengeParameters;
                var serverBValue = new (0, $4OMoi.default)(challengeParameters.SRP_B, 16);
                var salt = new (0, $4OMoi.default)(challengeParameters.SALT, 16);
                authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function(errHkdf, hkdf) {
                    // getPasswordAuthenticationKey callback start
                    if (errHkdf) return callback.onFailure(errHkdf);
                    var dateNow = dateHelper.getNowString();
                    var message = (0, (/*@__PURE__*/$parcel$interopDefault($7IQXV))).lib.WordArray.create((0, $aE4oM.Buffer).concat([
                        (0, $aE4oM.Buffer).from(_this6.deviceGroupKey, "utf8"),
                        (0, $aE4oM.Buffer).from(_this6.deviceKey, "utf8"),
                        (0, $aE4oM.Buffer).from(challengeParameters.SECRET_BLOCK, "base64"),
                        (0, $aE4oM.Buffer).from(dateNow, "utf8")
                    ]));
                    var key = (0, (/*@__PURE__*/$parcel$interopDefault($7IQXV))).lib.WordArray.create(hkdf);
                    var signatureString = (0, (/*@__PURE__*/$parcel$interopDefault($kqURS))).stringify((0, (/*@__PURE__*/$parcel$interopDefault($m6xY6)))(message, key));
                    var challengeResponses = {};
                    challengeResponses.USERNAME = _this6.username;
                    challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
                    challengeResponses.TIMESTAMP = dateNow;
                    challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
                    challengeResponses.DEVICE_KEY = _this6.deviceKey;
                    var jsonReqResp = {
                        ChallengeName: "DEVICE_PASSWORD_VERIFIER",
                        ClientId: _this6.pool.getClientId(),
                        ChallengeResponses: challengeResponses,
                        Session: data.Session
                    };
                    if (_this6.getUserContextData()) jsonReqResp.UserContextData = _this6.getUserContextData();
                    _this6.client.request("RespondToAuthChallenge", jsonReqResp, function(errAuthenticate, dataAuthenticate) {
                        if (errAuthenticate) return callback.onFailure(errAuthenticate);
                        _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
                        _this6.cacheTokens();
                        return callback.onSuccess(_this6.signInUserSession);
                    });
                    return undefined;
                // getPasswordAuthenticationKey callback end
                });
                return undefined;
            });
        // getLargeAValue callback end
        });
    };
    /**
  * This is used for a certain user to confirm the registration by using a confirmation code
  * @param {string} confirmationCode Code entered by user.
  * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
  * @param {nodeCallback<string>} callback Called on success or error.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */ CognitoUser.prototype.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            ConfirmationCode: confirmationCode,
            Username: this.username,
            ForceAliasCreation: forceAliasCreation,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmSignUp", jsonReq, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
    };
    /**
  * This is used by the user once he has the responses to a custom challenge
  * @param {string} answerChallenge The custom challenge answer.
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {customChallenge} callback.customChallenge
  *    Custom challenge response required to continue.
  * @param {authSuccess} callback.onSuccess Called on success with the new session.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */ CognitoUser.prototype.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
        var _this7 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var authenticationHelper = new (0, $eGFMf.default)(this.pool.getUserPoolId().split("_")[1]);
        this.getCachedDeviceKeyAndPassword();
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: "CUSTOM_CHALLENGE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            return _this7.authenticateUserInternal(data, authenticationHelper, callback);
        });
    };
    /**
  * This is used by the user once he has an MFA code
  * @param {string} confirmationCode The MFA code entered by the user.
  * @param {object} callback Result callback map.
  * @param {string} mfaType The mfa we are replying to.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {authSuccess} callback.onSuccess Called on success with the new session.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */ CognitoUser.prototype.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
        var _this8 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.SMS_MFA_CODE = confirmationCode;
        var mfaTypeSelection = mfaType || "SMS_MFA";
        if (mfaTypeSelection === "SOFTWARE_TOKEN_MFA") challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
        if (this.deviceKey != null) challengeResponses.DEVICE_KEY = this.deviceKey;
        var jsonReq = {
            ChallengeName: mfaTypeSelection,
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, dataAuthenticate) {
            if (err) return callback.onFailure(err);
            var challengeName = dataAuthenticate.ChallengeName;
            if (challengeName === "DEVICE_SRP_AUTH") {
                _this8.getDeviceResponse(callback);
                return undefined;
            }
            _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
            _this8.cacheTokens();
            if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) return callback.onSuccess(_this8.signInUserSession);
            var authenticationHelper = new (0, $eGFMf.default)(_this8.pool.getUserPoolId().split("_")[1]);
            authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(errGenHash) {
                if (errGenHash) return callback.onFailure(errGenHash);
                var deviceSecretVerifierConfig = {
                    Salt: (0, $aE4oM.Buffer).from(authenticationHelper.getSaltDevices(), "hex").toString("base64"),
                    PasswordVerifier: (0, $aE4oM.Buffer).from(authenticationHelper.getVerifierDevices(), "hex").toString("base64")
                };
                _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
                _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
                _this8.randomPassword = authenticationHelper.getRandomPassword();
                _this8.client.request("ConfirmDevice", {
                    DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
                    AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
                    DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
                    DeviceName: navigator.userAgent
                }, function(errConfirm, dataConfirm) {
                    if (errConfirm) return callback.onFailure(errConfirm);
                    _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
                    _this8.cacheDeviceKeyAndPassword();
                    if (dataConfirm.UserConfirmationNecessary === true) return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
                    return callback.onSuccess(_this8.signInUserSession);
                });
                return undefined;
            });
            return undefined;
        });
    };
    /**
  * This is used by an authenticated user to change the current password
  * @param {string} oldUserPassword The current password.
  * @param {string} newUserPassword The requested new password.
  * @param {nodeCallback<string>} callback Called on success or error.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */ CognitoUser.prototype.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("ChangePassword", {
            PreviousPassword: oldUserPassword,
            ProposedPassword: newUserPassword,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    };
    /**
  * This is used by an authenticated user to enable MFA for itself
  * @deprecated
  * @param {nodeCallback<string>} callback Called on success or error.
  * @returns {void}
  */ CognitoUser.prototype.enableMFA = function enableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        var mfaEnabled = {
            DeliveryMedium: "SMS",
            AttributeName: "phone_number"
        };
        mfaOptions.push(mfaEnabled);
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    };
    /**
  * This is used by an authenticated user to enable MFA for itself
  * @param {IMfaSettings} smsMfaSettings the sms mfa settings
  * @param {IMFASettings} softwareTokenMfaSettings the software token mfa settings
  * @param {nodeCallback<string>} callback Called on success or error.
  * @returns {void}
  */ CognitoUser.prototype.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("SetUserMFAPreference", {
            SMSMfaSettings: smsMfaSettings,
            SoftwareTokenMfaSettings: softwareTokenMfaSettings,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    };
    /**
  * This is used by an authenticated user to disable MFA for itself
  * @deprecated
  * @param {nodeCallback<string>} callback Called on success or error.
  * @returns {void}
  */ CognitoUser.prototype.disableMFA = function disableMFA(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        var mfaOptions = [];
        this.client.request("SetUserSettings", {
            MFAOptions: mfaOptions,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    };
    /**
  * This is used by an authenticated user to delete itself
  * @param {nodeCallback<string>} callback Called on success or error.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */ CognitoUser.prototype.deleteUser = function deleteUser(callback, clientMetadata) {
        var _this9 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            _this9.clearCachedUser();
            return callback(null, "SUCCESS");
        });
        return undefined;
    };
    /**
  * @typedef {CognitoUserAttribute | { Name:string, Value:string }} AttributeArg
  */ /**
  * This is used by an authenticated user to change a list of attributes
  * @param {AttributeArg[]} attributes A list of the new user attributes.
  * @param {nodeCallback<string>} callback Called on success or error.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */ CognitoUser.prototype.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback(new Error("User is not authenticated"), null);
        this.client.request("UpdateUserAttributes", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserAttributes: attributes,
            ClientMetadata: clientMetadata
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    };
    /**
  * This is used by an authenticated user to get a list of attributes
  * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
  * @returns {void}
  */ CognitoUser.prototype.getUserAttributes = function getUserAttributes(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            var attributeList = [];
            for(var i = 0; i < userData.UserAttributes.length; i++){
                var attribute = {
                    Name: userData.UserAttributes[i].Name,
                    Value: userData.UserAttributes[i].Value
                };
                var userAttribute = new (0, $kdPCY.default)(attribute);
                attributeList.push(userAttribute);
            }
            return callback(null, attributeList);
        });
        return undefined;
    };
    /**
  * This is used by an authenticated user to get the MFAOptions
  * @param {nodeCallback<MFAOptions>} callback Called on success or error.
  * @returns {void}
  */ CognitoUser.prototype.getMFAOptions = function getMFAOptions(callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, userData) {
            if (err) return callback(err, null);
            return callback(null, userData.MFAOptions);
        });
        return undefined;
    };
    /**
  * This is used by an authenticated users to get the userData
  * @param {nodeCallback<UserData>} callback Called on success or error.
  * @returns {void}
  */ CognitoUser.prototype.getUserData = function getUserData(callback, params) {
        var _this10 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
            this.clearCachedUserData();
            return callback(new Error("User is not authenticated"), null);
        }
        var bypassCache = params ? params.bypassCache : false;
        var userData = this.storage.getItem(this.userDataKey);
        // get the cached user data
        if (!userData || bypassCache) this.client.request("GetUser", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, latestUserData) {
            if (err) return callback(err, null);
            _this10.cacheUserData(latestUserData);
            var refresh = _this10.signInUserSession.getRefreshToken();
            if (refresh && refresh.getToken()) _this10.refreshSession(refresh, function(refreshError, data) {
                if (refreshError) return callback(refreshError, null);
                return callback(null, latestUserData);
            });
            else return callback(null, latestUserData);
        });
        else try {
            return callback(null, JSON.parse(userData));
        } catch (err) {
            this.clearCachedUserData();
            return callback(err, null);
        }
        return undefined;
    };
    /**
  * This is used by an authenticated user to delete a list of attributes
  * @param {string[]} attributeList Names of the attributes to delete.
  * @param {nodeCallback<string>} callback Called on success or error.
  * @returns {void}
  */ CognitoUser.prototype.deleteAttributes = function deleteAttributes(attributeList, callback) {
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) return callback(new Error("User is not authenticated"), null);
        this.client.request("DeleteUserAttributes", {
            UserAttributeNames: attributeList,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback(err, null);
            return callback(null, "SUCCESS");
        });
        return undefined;
    };
    /**
  * This is used by a user to resend a confirmation code
  * @param {nodeCallback<string>} callback Called on success or error.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */ CognitoUser.prototype.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        this.client.request("ResendConfirmationCode", jsonReq, function(err, result) {
            if (err) return callback(err, null);
            return callback(null, result);
        });
    };
    /**
  * This is used to get a session, either from the session object
  * or from  the local storage, or by using a refresh token
  *
  * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
  * @returns {void}
  */ CognitoUser.prototype.getSession = function getSession(callback) {
        if (this.username == null) return callback(new Error("Username is null. Cannot retrieve a new session"), null);
        if (this.signInUserSession != null && this.signInUserSession.isValid()) return callback(null, this.signInUserSession);
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var idTokenKey = keyPrefix + ".idToken";
        var accessTokenKey = keyPrefix + ".accessToken";
        var refreshTokenKey = keyPrefix + ".refreshToken";
        var clockDriftKey = keyPrefix + ".clockDrift";
        if (this.storage.getItem(idTokenKey)) {
            var idToken = new (0, $VNeTv.default)({
                IdToken: this.storage.getItem(idTokenKey)
            });
            var accessToken = new (0, $3kONY.default)({
                AccessToken: this.storage.getItem(accessTokenKey)
            });
            var refreshToken = new (0, $M7FPA.default)({
                RefreshToken: this.storage.getItem(refreshTokenKey)
            });
            var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
            var sessionData = {
                IdToken: idToken,
                AccessToken: accessToken,
                RefreshToken: refreshToken,
                ClockDrift: clockDrift
            };
            var cachedSession = new (0, $dTtsJ.default)(sessionData);
            if (cachedSession.isValid()) {
                this.signInUserSession = cachedSession;
                return callback(null, this.signInUserSession);
            }
            if (!refreshToken.getToken()) return callback(new Error("Cannot retrieve a new session. Please authenticate."), null);
            this.refreshSession(refreshToken, callback);
        } else callback(new Error("Local storage is missing an ID Token, Please authenticate"), null);
        return undefined;
    };
    /**
  * This uses the refreshToken to retrieve a new session
  * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
  * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */ CognitoUser.prototype.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
        var _this11 = this;
        var authParameters = {};
        authParameters.REFRESH_TOKEN = refreshToken.getToken();
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var lastUserKey = keyPrefix + ".LastAuthUser";
        if (this.storage.getItem(lastUserKey)) {
            this.username = this.storage.getItem(lastUserKey);
            var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            authParameters.DEVICE_KEY = this.deviceKey;
        }
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            AuthFlow: "REFRESH_TOKEN_AUTH",
            AuthParameters: authParameters,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("InitiateAuth", jsonReq, function(err, authResult) {
            if (err) {
                if (err.code === "NotAuthorizedException") _this11.clearCachedUser();
                return callback(err, null);
            }
            if (authResult) {
                var authenticationResult = authResult.AuthenticationResult;
                if (!Object.prototype.hasOwnProperty.call(authenticationResult, "RefreshToken")) authenticationResult.RefreshToken = refreshToken.getToken();
                _this11.signInUserSession = _this11.getCognitoUserSession(authenticationResult);
                _this11.cacheTokens();
                return callback(null, _this11.signInUserSession);
            }
            return undefined;
        });
    };
    /**
  * This is used to save the session tokens to local storage
  * @returns {void}
  */ CognitoUser.prototype.cacheTokens = function cacheTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
        this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
        this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
        this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
        this.storage.setItem(lastUserKey, this.username);
    };
    /**
  * This is to cache user data
  */ CognitoUser.prototype.cacheUserData = function cacheUserData(userData) {
        this.storage.setItem(this.userDataKey, JSON.stringify(userData));
    };
    /**
  * This is to remove cached user data
  */ CognitoUser.prototype.clearCachedUserData = function clearCachedUserData() {
        this.storage.removeItem(this.userDataKey);
    };
    CognitoUser.prototype.clearCachedUser = function clearCachedUser() {
        this.clearCachedTokens();
        this.clearCachedUserData();
    };
    /**
  * This is used to cache the device key and device group and device password
  * @returns {void}
  */ CognitoUser.prototype.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.setItem(deviceKeyKey, this.deviceKey);
        this.storage.setItem(randomPasswordKey, this.randomPassword);
        this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
    };
    /**
  * This is used to get current device key and device group and device password
  * @returns {void}
  */ CognitoUser.prototype.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        if (this.storage.getItem(deviceKeyKey)) {
            this.deviceKey = this.storage.getItem(deviceKeyKey);
            this.randomPassword = this.storage.getItem(randomPasswordKey);
            this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
        }
    };
    /**
  * This is used to clear the device key info from local storage
  * @returns {void}
  */ CognitoUser.prototype.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
        var deviceKeyKey = keyPrefix + ".deviceKey";
        var randomPasswordKey = keyPrefix + ".randomPasswordKey";
        var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
        this.storage.removeItem(deviceKeyKey);
        this.storage.removeItem(randomPasswordKey);
        this.storage.removeItem(deviceGroupKeyKey);
    };
    /**
  * This is used to clear the session tokens from local storage
  * @returns {void}
  */ CognitoUser.prototype.clearCachedTokens = function clearCachedTokens() {
        var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
        var idTokenKey = keyPrefix + "." + this.username + ".idToken";
        var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
        var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
        var lastUserKey = keyPrefix + ".LastAuthUser";
        var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
        this.storage.removeItem(idTokenKey);
        this.storage.removeItem(accessTokenKey);
        this.storage.removeItem(refreshTokenKey);
        this.storage.removeItem(lastUserKey);
        this.storage.removeItem(clockDriftKey);
    };
    /**
  * This is used to build a user session from tokens retrieved in the authentication result
  * @param {object} authResult Successful auth response from server.
  * @returns {CognitoUserSession} The new user session.
  * @private
  */ CognitoUser.prototype.getCognitoUserSession = function getCognitoUserSession(authResult) {
        var idToken = new (0, $VNeTv.default)(authResult);
        var accessToken = new (0, $3kONY.default)(authResult);
        var refreshToken = new (0, $M7FPA.default)(authResult);
        var sessionData = {
            IdToken: idToken,
            AccessToken: accessToken,
            RefreshToken: refreshToken
        };
        return new (0, $dTtsJ.default)(sessionData);
    };
    /**
  * This is used to initiate a forgot password request
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {inputVerificationCode?} callback.inputVerificationCode
  *    Optional callback raised instead of onSuccess with response data.
  * @param {onSuccess} callback.onSuccess Called on success.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */ CognitoUser.prototype.forgotPassword = function forgotPassword(callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ForgotPassword", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess(data);
        });
    };
    /**
  * This is used to confirm a new password using a confirmationCode
  * @param {string} confirmationCode Code entered by user.
  * @param {string} newPassword Confirm new password.
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {onSuccess<void>} callback.onSuccess Called on success.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */ CognitoUser.prototype.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
        var jsonReq = {
            ClientId: this.pool.getClientId(),
            Username: this.username,
            ConfirmationCode: confirmationCode,
            Password: newPassword,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("ConfirmForgotPassword", jsonReq, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess();
        });
    };
    /**
  * This is used to initiate an attribute confirmation request
  * @param {string} attributeName User attribute that needs confirmation.
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
  * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
  * @returns {void}
  */ CognitoUser.prototype.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetUserAttributeVerificationCode", {
            AttributeName: attributeName,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            ClientMetadata: clientMetadata
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            if (typeof callback.inputVerificationCode === "function") return callback.inputVerificationCode(data);
            return callback.onSuccess();
        });
        return undefined;
    };
    /**
  * This is used to confirm an attribute using a confirmation code
  * @param {string} attributeName Attribute being confirmed.
  * @param {string} confirmationCode Code entered by user.
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {onSuccess<string>} callback.onSuccess Called on success.
  * @returns {void}
  */ CognitoUser.prototype.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("VerifyUserAttribute", {
            AttributeName: attributeName,
            Code: confirmationCode,
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    };
    /**
  * This is used to get the device information using the current device key
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
  * @returns {void}
  */ CognitoUser.prototype.getDevice = function getDevice(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    };
    /**
  * This is used to forget a specific device
  * @param {string} deviceKey Device key.
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {onSuccess<string>} callback.onSuccess Called on success.
  * @returns {void}
  */ CognitoUser.prototype.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("ForgetDevice", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: deviceKey
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    };
    /**
  * This is used to forget the current device
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {onSuccess<string>} callback.onSuccess Called on success.
  * @returns {void}
  */ CognitoUser.prototype.forgetDevice = function forgetDevice(callback) {
        var _this12 = this;
        this.forgetSpecificDevice(this.deviceKey, {
            onFailure: callback.onFailure,
            onSuccess: function onSuccess(result) {
                _this12.deviceKey = null;
                _this12.deviceGroupKey = null;
                _this12.randomPassword = null;
                _this12.clearCachedDeviceKeyAndPassword();
                return callback.onSuccess(result);
            }
        });
    };
    /**
  * This is used to set the device status as remembered
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {onSuccess<string>} callback.onSuccess Called on success.
  * @returns {void}
  */ CognitoUser.prototype.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    };
    /**
  * This is used to set the device status as not remembered
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {onSuccess<string>} callback.onSuccess Called on success.
  * @returns {void}
  */ CognitoUser.prototype.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("UpdateDeviceStatus", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            DeviceKey: this.deviceKey,
            DeviceRememberedStatus: "not_remembered"
        }, function(err) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    };
    /**
  * This is used to list all devices for a user
  *
  * @param {int} limit the number of devices returned in a call
  * @param {string} paginationToken the pagination token in case any was returned before
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
  * @returns {void}
  */ CognitoUser.prototype.listDevices = function listDevices(limit, paginationToken, callback) {
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("ListDevices", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            Limit: limit,
            PaginationToken: paginationToken
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
        return undefined;
    };
    /**
  * This is used to globally revoke all tokens issued to a user
  * @param {object} callback Result callback map.
  * @param {onFailure} callback.onFailure Called on any error.
  * @param {onSuccess<string>} callback.onSuccess Called on success.
  * @returns {void}
  */ CognitoUser.prototype.globalSignOut = function globalSignOut(callback) {
        var _this13 = this;
        if (this.signInUserSession == null || !this.signInUserSession.isValid()) return callback.onFailure(new Error("User is not authenticated"));
        this.client.request("GlobalSignOut", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err) {
            if (err) return callback.onFailure(err);
            _this13.clearCachedUser();
            return callback.onSuccess("SUCCESS");
        });
        return undefined;
    };
    /**
  * This is used for the user to signOut of the application and clear the cached tokens.
  * @returns {void}
  */ CognitoUser.prototype.signOut = function signOut() {
        this.signInUserSession = null;
        this.clearCachedUser();
    };
    /**
  * This is used by a user trying to select a given MFA
  * @param {string} answerChallenge the mfa the user wants
  * @param {nodeCallback<string>} callback Called on success or error.
  * @returns {void}
  */ CognitoUser.prototype.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
        var _this14 = this;
        var challengeResponses = {};
        challengeResponses.USERNAME = this.username;
        challengeResponses.ANSWER = answerChallenge;
        var jsonReq = {
            ChallengeName: "SELECT_MFA_TYPE",
            ChallengeResponses: challengeResponses,
            ClientId: this.pool.getClientId(),
            Session: this.Session
        };
        if (this.getUserContextData()) jsonReq.UserContextData = this.getUserContextData();
        this.client.request("RespondToAuthChallenge", jsonReq, function(err, data) {
            if (err) return callback.onFailure(err);
            _this14.Session = data.Session;
            if (answerChallenge === "SMS_MFA") return callback.mfaRequired(data.challengeName, data.challengeParameters);
            if (answerChallenge === "SOFTWARE_TOKEN_MFA") return callback.totpRequired(data.challengeName, data.challengeParameters);
            return undefined;
        });
    };
    /**
  * This returns the user context data for advanced security feature.
  * @returns {void}
  */ CognitoUser.prototype.getUserContextData = function getUserContextData() {
        var pool = this.pool;
        return pool.getUserContextData(this.username);
    };
    /**
  * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
  * @param {nodeCallback<string>} callback Called on success or error.
  * @returns {void}
  */ CognitoUser.prototype.associateSoftwareToken = function associateSoftwareToken(callback) {
        var _this15 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("AssociateSoftwareToken", {
            Session: this.Session
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this15.Session = data.Session;
            return callback.associateSecretCode(data.SecretCode);
        });
        else this.client.request("AssociateSoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.associateSecretCode(data.SecretCode);
        });
    };
    /**
  * This is used by an authenticated or a user trying to authenticate to verify a TOTP MFA
  * @param {string} totpCode The MFA code entered by the user.
  * @param {string} friendlyDeviceName The device name we are assigning to the device.
  * @param {nodeCallback<string>} callback Called on success or error.
  * @returns {void}
  */ CognitoUser.prototype.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
        var _this16 = this;
        if (!(this.signInUserSession != null && this.signInUserSession.isValid())) this.client.request("VerifySoftwareToken", {
            Session: this.Session,
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            _this16.Session = data.Session;
            var challengeResponses = {};
            challengeResponses.USERNAME = _this16.username;
            var jsonReq = {
                ChallengeName: "MFA_SETUP",
                ClientId: _this16.pool.getClientId(),
                ChallengeResponses: challengeResponses,
                Session: _this16.Session
            };
            if (_this16.getUserContextData()) jsonReq.UserContextData = _this16.getUserContextData();
            _this16.client.request("RespondToAuthChallenge", jsonReq, function(errRespond, dataRespond) {
                if (errRespond) return callback.onFailure(errRespond);
                _this16.signInUserSession = _this16.getCognitoUserSession(dataRespond.AuthenticationResult);
                _this16.cacheTokens();
                return callback.onSuccess(_this16.signInUserSession);
            });
            return undefined;
        });
        else this.client.request("VerifySoftwareToken", {
            AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
            UserCode: totpCode,
            FriendlyDeviceName: friendlyDeviceName
        }, function(err, data) {
            if (err) return callback.onFailure(err);
            return callback.onSuccess(data);
        });
    };
    return CognitoUser;
}();
var $32d3c94368f73470$export$2e2bcd8739ae039 = $32d3c94368f73470$var$CognitoUser;

});
parcelRequire.register("kqURS", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("7IQXV")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                words[nBytes >>> 2] |= (bits1 | bits2) << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRequire.register("dTtsJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1d74403670f6346$export$2e2bcd8739ae039; });
function $a1d74403670f6346$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ /** @class */ var $a1d74403670f6346$var$CognitoUserSession = function() {
    /**
  * Constructs a new CognitoUserSession object
  * @param {CognitoIdToken} IdToken The session's Id token.
  * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
  * @param {CognitoAccessToken} AccessToken The session's access token.
  * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
  */ function CognitoUserSession() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, IdToken = _ref.IdToken, RefreshToken = _ref.RefreshToken, AccessToken = _ref.AccessToken, ClockDrift = _ref.ClockDrift;
        $a1d74403670f6346$var$_classCallCheck(this, CognitoUserSession);
        if (AccessToken == null || IdToken == null) throw new Error("Id token and Access Token must be present.");
        this.idToken = IdToken;
        this.refreshToken = RefreshToken;
        this.accessToken = AccessToken;
        this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
    }
    /**
  * @returns {CognitoIdToken} the session's Id token
  */ CognitoUserSession.prototype.getIdToken = function getIdToken() {
        return this.idToken;
    };
    /**
  * @returns {CognitoRefreshToken} the session's refresh token
  */ CognitoUserSession.prototype.getRefreshToken = function getRefreshToken() {
        return this.refreshToken;
    };
    /**
  * @returns {CognitoAccessToken} the session's access token
  */ CognitoUserSession.prototype.getAccessToken = function getAccessToken() {
        return this.accessToken;
    };
    /**
  * @returns {int} the session's clock drift
  */ CognitoUserSession.prototype.getClockDrift = function getClockDrift() {
        return this.clockDrift;
    };
    /**
  * @returns {int} the computer's clock drift
  */ CognitoUserSession.prototype.calculateClockDrift = function calculateClockDrift() {
        var now = Math.floor(new Date() / 1000);
        var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
        return now - iat;
    };
    /**
  * Checks to see if the session is still valid based on session expiry information found
  * in tokens and the current time (adjusted with clock drift)
  * @returns {boolean} if the session is still valid
  */ CognitoUserSession.prototype.isValid = function isValid() {
        var now = Math.floor(new Date() / 1000);
        var adjusted = now - this.clockDrift;
        return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
    };
    return CognitoUserSession;
}();
var $a1d74403670f6346$export$2e2bcd8739ae039 = $a1d74403670f6346$var$CognitoUserSession;

});

parcelRequire.register("2R4Jl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21443360ade42c50$export$2e2bcd8739ae039; });
function $21443360ade42c50$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ var $21443360ade42c50$var$monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $21443360ade42c50$var$weekNames = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
/** @class */ var $21443360ade42c50$var$DateHelper = function() {
    function DateHelper() {
        $21443360ade42c50$var$_classCallCheck(this, DateHelper);
    }
    /**
  * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
  */ DateHelper.prototype.getNowString = function getNowString() {
        var now = new Date();
        var weekDay = $21443360ade42c50$var$weekNames[now.getUTCDay()];
        var month = $21443360ade42c50$var$monthNames[now.getUTCMonth()];
        var day = now.getUTCDate();
        var hours = now.getUTCHours();
        if (hours < 10) hours = "0" + hours;
        var minutes = now.getUTCMinutes();
        if (minutes < 10) minutes = "0" + minutes;
        var seconds = now.getUTCSeconds();
        if (seconds < 10) seconds = "0" + seconds;
        var year = now.getUTCFullYear();
        // ddd MMM D HH:mm:ss UTC YYYY
        var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
        return dateNow;
    };
    return DateHelper;
}();
var $21443360ade42c50$export$2e2bcd8739ae039 = $21443360ade42c50$var$DateHelper;

});

parcelRequire.register("kdPCY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb8d11b4a247fd97$export$2e2bcd8739ae039; });
function $eb8d11b4a247fd97$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ /** @class */ var $eb8d11b4a247fd97$var$CognitoUserAttribute = function() {
    /**
  * Constructs a new CognitoUserAttribute object
  * @param {string=} Name The record's name
  * @param {string=} Value The record's value
  */ function CognitoUserAttribute() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, Name = _ref.Name, Value = _ref.Value;
        $eb8d11b4a247fd97$var$_classCallCheck(this, CognitoUserAttribute);
        this.Name = Name || "";
        this.Value = Value || "";
    }
    /**
  * @returns {string} the record's value.
  */ CognitoUserAttribute.prototype.getValue = function getValue() {
        return this.Value;
    };
    /**
  * Sets the record's value.
  * @param {string} value The new value.
  * @returns {CognitoUserAttribute} The record for method chaining.
  */ CognitoUserAttribute.prototype.setValue = function setValue(value) {
        this.Value = value;
        return this;
    };
    /**
  * @returns {string} the record's name.
  */ CognitoUserAttribute.prototype.getName = function getName() {
        return this.Name;
    };
    /**
  * Sets the record's name
  * @param {string} name The new name.
  * @returns {CognitoUserAttribute} The record for method chaining.
  */ CognitoUserAttribute.prototype.setName = function setName(name) {
        this.Name = name;
        return this;
    };
    /**
  * @returns {string} a string representation of the record.
  */ CognitoUserAttribute.prototype.toString = function toString() {
        return JSON.stringify(this);
    };
    /**
  * @returns {object} a flat object representing the record.
  */ CognitoUserAttribute.prototype.toJSON = function toJSON() {
        return {
            Name: this.Name,
            Value: this.Value
        };
    };
    return CognitoUserAttribute;
}();
var $eb8d11b4a247fd97$export$2e2bcd8739ae039 = $eb8d11b4a247fd97$var$CognitoUserAttribute;

});

parcelRequire.register("23Zzy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $180b9f935deabd47$export$2e2bcd8739ae039; });
function $180b9f935deabd47$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */ var $180b9f935deabd47$var$dataMemory = {};
/** @class */ var $180b9f935deabd47$var$MemoryStorage = function() {
    function MemoryStorage() {
        $180b9f935deabd47$var$_classCallCheck(this, MemoryStorage);
    }
    /**
  * This is used to set a specific item in storage
  * @param {string} key - the key for the item
  * @param {object} value - the value
  * @returns {string} value that was set
  */ MemoryStorage.setItem = function setItem(key, value) {
        $180b9f935deabd47$var$dataMemory[key] = value;
        return $180b9f935deabd47$var$dataMemory[key];
    };
    /**
  * This is used to get a specific key from storage
  * @param {string} key - the key for the item
  * This is used to clear the storage
  * @returns {string} the data item
  */ MemoryStorage.getItem = function getItem(key) {
        return Object.prototype.hasOwnProperty.call($180b9f935deabd47$var$dataMemory, key) ? $180b9f935deabd47$var$dataMemory[key] : undefined;
    };
    /**
  * This is used to remove an item from storage
  * @param {string} key - the key being set
  * @returns {string} value - value that was deleted
  */ MemoryStorage.removeItem = function removeItem(key) {
        return delete $180b9f935deabd47$var$dataMemory[key];
    };
    /**
  * This is used to clear the storage
  * @returns {string} nothing
  */ MemoryStorage.clear = function clear() {
        $180b9f935deabd47$var$dataMemory = {};
        return $180b9f935deabd47$var$dataMemory;
    };
    return MemoryStorage;
}();
/** @class */ var $180b9f935deabd47$var$StorageHelper = function() {
    /**
  * This is used to get a storage object
  * @returns {object} the storage
  */ function StorageHelper() {
        $180b9f935deabd47$var$_classCallCheck(this, StorageHelper);
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem("aws.cognito.test-ls", 1);
            this.storageWindow.removeItem("aws.cognito.test-ls");
        } catch (exception) {
            this.storageWindow = $180b9f935deabd47$var$MemoryStorage;
        }
    }
    /**
  * This is used to return the storage
  * @returns {object} the storage
  */ StorageHelper.prototype.getStorage = function getStorage() {
        return this.storageWindow;
    };
    return StorageHelper;
}();
var $180b9f935deabd47$export$2e2bcd8739ae039 = $180b9f935deabd47$var$StorageHelper;

});


parcelRequire.register("lihsy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f808d28649139036$export$2e2bcd8739ae039; });

var $8JhYh = parcelRequire("8JhYh");

var $4myfH = parcelRequire("4myfH");

var $23Zzy = parcelRequire("23Zzy");
function $f808d28649139036$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/** @class */ var $f808d28649139036$var$CognitoUserPool = function() {
    /**
  * Constructs a new CognitoUserPool object
  * @param {object} data Creation options.
  * @param {string} data.UserPoolId Cognito user pool id.
  * @param {string} data.ClientId User pool application client id.
  * @param {object} data.Storage Optional storage object.
  * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
  *        boolean flag indicating if the data collection is enabled
  *        to support cognito advanced security features. By default, this
  *        flag is set to true.
  */ function CognitoUserPool(data) {
        $f808d28649139036$var$_classCallCheck(this, CognitoUserPool);
        var _ref = data || {}, UserPoolId = _ref.UserPoolId, ClientId = _ref.ClientId, endpoint = _ref.endpoint, AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
        if (!UserPoolId || !ClientId) throw new Error("Both UserPoolId and ClientId are required.");
        if (!/^[\w-]+_.+$/.test(UserPoolId)) throw new Error("Invalid UserPoolId format.");
        var region = UserPoolId.split("_")[0];
        this.userPoolId = UserPoolId;
        this.clientId = ClientId;
        this.client = new (0, $8JhYh.default)(region, endpoint);
        /**
   * By default, AdvancedSecurityDataCollectionFlag is set to true,
   * if no input value is provided.
   */ this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
        this.storage = data.Storage || new (0, $23Zzy.default)().getStorage();
    }
    /**
  * @returns {string} the user pool id
  */ CognitoUserPool.prototype.getUserPoolId = function getUserPoolId() {
        return this.userPoolId;
    };
    /**
  * @returns {string} the client id
  */ CognitoUserPool.prototype.getClientId = function getClientId() {
        return this.clientId;
    };
    /**
  * @typedef {object} SignUpResult
  * @property {CognitoUser} user New user.
  * @property {bool} userConfirmed If the user is already confirmed.
  */ /**
  * method for signing up a user
  * @param {string} username User's username.
  * @param {string} password Plain-text initial password entered by user.
  * @param {(AttributeArg[])=} userAttributes New user attributes.
  * @param {(AttributeArg[])=} validationData Application metadata.
  * @param {(AttributeArg[])=} clientMetadata Client metadata.
  * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
  * @returns {void}
  */ CognitoUserPool.prototype.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
        var _this = this;
        var jsonReq = {
            ClientId: this.clientId,
            Username: username,
            Password: password,
            UserAttributes: userAttributes,
            ValidationData: validationData,
            ClientMetadata: clientMetadata
        };
        if (this.getUserContextData(username)) jsonReq.UserContextData = this.getUserContextData(username);
        this.client.request("SignUp", jsonReq, function(err, data) {
            if (err) return callback(err, null);
            var cognitoUser = {
                Username: username,
                Pool: _this,
                Storage: _this.storage
            };
            var returnData = {
                user: new (0, $4myfH.default)(cognitoUser),
                userConfirmed: data.UserConfirmed,
                userSub: data.UserSub,
                codeDeliveryDetails: data.CodeDeliveryDetails
            };
            return callback(null, returnData);
        });
    };
    /**
  * method for getting the current user of the application from the local storage
  *
  * @returns {CognitoUser} the user retrieved from storage
  */ CognitoUserPool.prototype.getCurrentUser = function getCurrentUser() {
        var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
        var lastAuthUser = this.storage.getItem(lastUserKey);
        if (lastAuthUser) {
            var cognitoUser = {
                Username: lastAuthUser,
                Pool: this,
                Storage: this.storage
            };
            return new (0, $4myfH.default)(cognitoUser);
        }
        return null;
    };
    /**
  * This method returns the encoded data string used for cognito advanced security feature.
  * This would be generated only when developer has included the JS used for collecting the
  * data on their client. Please refer to documentation to know more about using AdvancedSecurity
  * features
  * @param {string} username the username for the context data
  * @returns {string} the user context data
  **/ CognitoUserPool.prototype.getUserContextData = function getUserContextData(username) {
        if (typeof AmazonCognitoAdvancedSecurityData === "undefined") return undefined;
        /* eslint-disable */ var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
        /* eslint-enable */ if (this.advancedSecurityDataCollectionFlag) {
            var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
            if (advancedSecurityData) {
                var userContextData = {
                    EncodedData: advancedSecurityData
                };
                return userContextData;
            }
        }
        return {};
    };
    return CognitoUserPool;
}();
var $f808d28649139036$export$2e2bcd8739ae039 = $f808d28649139036$var$CognitoUserPool;

});
parcelRequire.register("8JhYh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65b07768ec7e2525$export$2e2bcd8739ae039; });

var $9zFim = parcelRequire("9zFim");
function $65b07768ec7e2525$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/** @class */ var $65b07768ec7e2525$var$Client = function() {
    /**
  * Constructs a new AWS Cognito Identity Provider client object
  * @param {string} region AWS region
  * @param {string} endpoint endpoint
  */ function Client(region, endpoint) {
        $65b07768ec7e2525$var$_classCallCheck(this, Client);
        this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";
        this.userAgent = (0, $9zFim.default).prototype.userAgent || "aws-amplify/0.1.x js";
    }
    /**
  * Makes an unauthenticated request on AWS Cognito Identity Provider API
  * using fetch
  * @param {string} operation API operation
  * @param {object} params Input parameters
  * @param {function} callback Callback called when a response is returned
  * @returns {void}
  */ Client.prototype.request = function request(operation, params, callback) {
        var headers = {
            "Content-Type": "application/x-amz-json-1.1",
            "X-Amz-Target": "AWSCognitoIdentityProviderService." + operation,
            "X-Amz-User-Agent": this.userAgent
        };
        var options = {
            headers: headers,
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            body: JSON.stringify(params)
        };
        var response = void 0;
        var responseJsonData = void 0;
        fetch(this.endpoint, options).then(function(resp) {
            response = resp;
            return resp;
        }, function(err) {
            // If error happens here, the request failed
            // if it is TypeError throw network error
            if (err instanceof TypeError) throw new Error("Network error");
            throw err;
        }).then(function(resp) {
            return resp.json().catch(function() {
                return {};
            });
        }).then(function(data) {
            // return parsed body stream
            if (response.ok) return callback(null, data);
            responseJsonData = data;
            // Taken from aws-sdk-js/lib/protocol/json.js
            // eslint-disable-next-line no-underscore-dangle
            var code = (data.__type || data.code).split("#").pop();
            var error = {
                code: code,
                name: code,
                message: data.message || data.Message || null
            };
            return callback(error);
        }).catch(function(err) {
            // first check if we have a service error
            if (response && response.headers && response.headers.get("x-amzn-errortype")) try {
                var code = response.headers.get("x-amzn-errortype").split(":")[0];
                var error = {
                    code: code,
                    name: code,
                    statusCode: response.status,
                    message: response.status ? response.status.toString() : null
                };
                return callback(error);
            } catch (ex) {
                return callback(err);
            }
            else if (err instanceof Error && err.message === "Network error") {
                var _error = {
                    code: "NetworkError",
                    name: err.name,
                    message: err.message
                };
                return callback(_error);
            } else return callback(err);
        });
    };
    return Client;
}();
var $65b07768ec7e2525$export$2e2bcd8739ae039 = $65b07768ec7e2525$var$Client;

});
parcelRequire.register("9zFim", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f876a4d79b6c6a5$export$2e2bcd8739ae039; });
// class for defining the amzn user-agent
var $6f876a4d79b6c6a5$export$2e2bcd8739ae039 = $6f876a4d79b6c6a5$var$UserAgent;
// constructor
function $6f876a4d79b6c6a5$var$UserAgent() {}
// public
$6f876a4d79b6c6a5$var$UserAgent.prototype.userAgent = "aws-amplify/0.1.x js";

});



parcelRequire.register("2YUd1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22bcc954109e5cad$export$2e2bcd8739ae039; });

var $aFNvk = parcelRequire("aFNvk");
function $22bcc954109e5cad$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/** @class */ var $22bcc954109e5cad$var$CookieStorage = function() {
    /**
  * Constructs a new CookieStorage object
  * @param {object} data Creation options.
  * @param {string} data.domain Cookies domain (mandatory).
  * @param {string} data.path Cookies path (default: '/')
  * @param {integer} data.expires Cookie expiration (in days, default: 365)
  * @param {boolean} data.secure Cookie secure flag (default: true)
  */ function CookieStorage(data) {
        $22bcc954109e5cad$var$_classCallCheck(this, CookieStorage);
        if (data.domain) this.domain = data.domain;
        else throw new Error("The domain of cookieStorage can not be undefined.");
        if (data.path) this.path = data.path;
        else this.path = "/";
        if (Object.prototype.hasOwnProperty.call(data, "expires")) this.expires = data.expires;
        else this.expires = 365;
        if (Object.prototype.hasOwnProperty.call(data, "secure")) this.secure = data.secure;
        else this.secure = true;
    }
    /**
  * This is used to set a specific item in storage
  * @param {string} key - the key for the item
  * @param {object} value - the value
  * @returns {string} value that was set
  */ CookieStorage.prototype.setItem = function setItem(key, value) {
        $aFNvk.set(key, value, {
            path: this.path,
            expires: this.expires,
            domain: this.domain,
            secure: this.secure
        });
        return $aFNvk.get(key);
    };
    /**
  * This is used to get a specific key from storage
  * @param {string} key - the key for the item
  * This is used to clear the storage
  * @returns {string} the data item
  */ CookieStorage.prototype.getItem = function getItem(key) {
        return $aFNvk.get(key);
    };
    /**
  * This is used to remove an item from storage
  * @param {string} key - the key being set
  * @returns {string} value - value that was deleted
  */ CookieStorage.prototype.removeItem = function removeItem(key) {
        return $aFNvk.remove(key, {
            path: this.path,
            domain: this.domain,
            secure: this.secure
        });
    };
    /**
  * This is used to clear the storage
  * @returns {string} nothing
  */ CookieStorage.prototype.clear = function clear() {
        var cookies = $aFNvk.get();
        var index = void 0;
        for(index = 0; index < cookies.length; ++index)$aFNvk.remove(cookies[index]);
        return {};
    };
    return CookieStorage;
}();
var $22bcc954109e5cad$export$2e2bcd8739ae039 = $22bcc954109e5cad$var$CookieStorage;

});
parcelRequire.register("aFNvk", function(module, exports) {
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});



parcelRequire.register("7p6WT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5640421a14091588$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $i3eDV = parcelRequire("i3eDV");

var $gjNOP = parcelRequire("gjNOP");

var $5jtCg = parcelRequire("5jtCg");

var $6ZRLT = parcelRequire("6ZRLT");
parcelRequire("2hWDt");
var $iZUWK = parcelRequire("iZUWK");
var $gBqCF = parcelRequire("gBqCF");
var $5640421a14091588$var$__assign = undefined && undefined.__assign || function() {
    $5640421a14091588$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5640421a14091588$var$__assign.apply(this, arguments);
};
var $5640421a14091588$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5640421a14091588$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

var $fbuuf = parcelRequire("fbuuf");

var $kqURS = parcelRequire("kqURS");
var $5640421a14091588$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var $5640421a14091588$var$dispatchAuthEvent = function(event, data, message) {
    (0, $iZUWK.default).dispatch("auth", {
        event: event,
        data: data,
        message: message
    }, "Auth", $5640421a14091588$var$AMPLIFY_SYMBOL);
};
var $5640421a14091588$var$logger = new (0, $gBqCF.ConsoleLogger)("OAuth");
var $5640421a14091588$var$OAuth = /** @class */ function() {
    function OAuth(_a) {
        var config = _a.config, cognitoClientId = _a.cognitoClientId, _b = _a.scopes, scopes = _b === void 0 ? [] : _b;
        this._urlOpener = config.urlOpener || (0, $gjNOP.launchUri);
        this._config = config;
        this._cognitoClientId = cognitoClientId;
        this._scopes = scopes;
    }
    OAuth.prototype.oauthSignIn = function(responseType, domain, redirectSignIn, clientId, provider, customState) {
        if (responseType === void 0) responseType = "code";
        if (provider === void 0) provider = (0, $6ZRLT.CognitoHostedUIIdentityProvider).Cognito;
        var generatedState = this._generateState(32);
        var state = customState ? generatedState + "-" + customState : generatedState;
        $5jtCg.setState(encodeURIComponent(state));
        var pkce_key = this._generateRandom(128);
        $5jtCg.setPKCE(pkce_key);
        var code_challenge = this._generateChallenge(pkce_key);
        var code_challenge_method = "S256";
        var queryString = Object.entries($5640421a14091588$var$__assign($5640421a14091588$var$__assign({
            redirect_uri: redirectSignIn,
            response_type: responseType,
            client_id: clientId,
            identity_provider: provider,
            scopes: this._scopes,
            state: state
        }, responseType === "code" ? {
            code_challenge: code_challenge
        } : {}), responseType === "code" ? {
            code_challenge_method: code_challenge_method
        } : {})).map(function(_a) {
            var k = _a[0], v = _a[1];
            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
        }).join("&");
        var URL = "https://" + domain + "/oauth2/authorize?" + queryString;
        $5640421a14091588$var$logger.debug("Redirecting to " + URL);
        this._urlOpener(URL, redirectSignIn);
    };
    OAuth.prototype._handleCodeFlow = function(currentUrl) {
        return $5640421a14091588$var$__awaiter(this, void 0, void 0, function() {
            var code, oAuthTokenEndpoint, client_id, redirect_uri, code_verifier, oAuthTokenBody, body, _a, access_token, refresh_token, id_token, error;
            return $5640421a14091588$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        code = ((0, $i3eDV.parse)(currentUrl).query || "").split("&").map(function(pairings) {
                            return pairings.split("=");
                        }).reduce(function(accum, _a) {
                            var _b;
                            var k = _a[0], v = _a[1];
                            return $5640421a14091588$var$__assign($5640421a14091588$var$__assign({}, accum), (_b = {}, _b[k] = v, _b));
                        }, {
                            code: undefined
                        }).code;
                        if (!code) return [
                            2 /*return*/ 
                        ];
                        oAuthTokenEndpoint = "https://" + this._config.domain + "/oauth2/token";
                        $5640421a14091588$var$dispatchAuthEvent("codeFlow", {}, "Retrieving tokens from " + oAuthTokenEndpoint);
                        client_id = (0, $6ZRLT.isCognitoHostedOpts)(this._config) ? this._cognitoClientId : this._config.clientID;
                        redirect_uri = (0, $6ZRLT.isCognitoHostedOpts)(this._config) ? this._config.redirectSignIn : this._config.redirectUri;
                        code_verifier = $5jtCg.getPKCE();
                        oAuthTokenBody = $5640421a14091588$var$__assign({
                            grant_type: "authorization_code",
                            code: code,
                            client_id: client_id,
                            redirect_uri: redirect_uri
                        }, code_verifier ? {
                            code_verifier: code_verifier
                        } : {});
                        $5640421a14091588$var$logger.debug("Calling token endpoint: " + oAuthTokenEndpoint + " with", oAuthTokenBody);
                        body = Object.entries(oAuthTokenBody).map(function(_a) {
                            var k = _a[0], v = _a[1];
                            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
                        }).join("&");
                        return [
                            4 /*yield*/ ,
                            fetch(oAuthTokenEndpoint, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/x-www-form-urlencoded"
                                },
                                body: body
                            })
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            _b.sent().json()
                        ];
                    case 2:
                        _a = _b.sent(), access_token = _a.access_token, refresh_token = _a.refresh_token, id_token = _a.id_token, error = _a.error;
                        if (error) throw new Error(error);
                        return [
                            2 /*return*/ ,
                            {
                                accessToken: access_token,
                                refreshToken: refresh_token,
                                idToken: id_token
                            }
                        ];
                }
            });
        });
    };
    OAuth.prototype._handleImplicitFlow = function(currentUrl) {
        return $5640421a14091588$var$__awaiter(this, void 0, void 0, function() {
            var _a, id_token, access_token;
            return $5640421a14091588$var$__generator(this, function(_b) {
                _a = (0, $i3eDV.parse)(currentUrl).hash.substr(1) // Remove # from returned code
                .split("&").map(function(pairings) {
                    return pairings.split("=");
                }).reduce(function(accum, _a) {
                    var _b;
                    var k = _a[0], v = _a[1];
                    return $5640421a14091588$var$__assign($5640421a14091588$var$__assign({}, accum), (_b = {}, _b[k] = v, _b));
                }, {
                    id_token: undefined,
                    access_token: undefined
                }), id_token = _a.id_token, access_token = _a.access_token;
                $5640421a14091588$var$dispatchAuthEvent("implicitFlow", {}, "Got tokens from " + currentUrl);
                $5640421a14091588$var$logger.debug("Retrieving implicit tokens from " + currentUrl + " with");
                return [
                    2 /*return*/ ,
                    {
                        accessToken: access_token,
                        idToken: id_token,
                        refreshToken: null
                    }
                ];
            });
        });
    };
    OAuth.prototype.handleAuthResponse = function(currentUrl) {
        return $5640421a14091588$var$__awaiter(this, void 0, void 0, function() {
            var urlParams, error, error_description, state, _a, _b, e_1;
            return $5640421a14091588$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        urlParams = currentUrl ? $5640421a14091588$var$__assign($5640421a14091588$var$__assign({}, ((0, $i3eDV.parse)(currentUrl).hash || "#").substr(1).split("&").map(function(entry) {
                            return entry.split("=");
                        }).reduce(function(acc, _a) {
                            var k = _a[0], v = _a[1];
                            return acc[k] = v, acc;
                        }, {})), ((0, $i3eDV.parse)(currentUrl).query || "").split("&").map(function(entry) {
                            return entry.split("=");
                        }).reduce(function(acc, _a) {
                            var k = _a[0], v = _a[1];
                            return acc[k] = v, acc;
                        }, {})) : {};
                        error = urlParams.error, error_description = urlParams.error_description;
                        if (error) throw new Error(error_description);
                        state = this._validateState(urlParams);
                        $5640421a14091588$var$logger.debug("Starting " + this._config.responseType + " flow with " + currentUrl);
                        if (!(this._config.responseType === "code")) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleCodeFlow(currentUrl)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            $5640421a14091588$var$__assign.apply(void 0, [
                                $5640421a14091588$var$__assign.apply(void 0, _a.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 2:
                        _b = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._handleImplicitFlow(currentUrl)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            $5640421a14091588$var$__assign.apply(void 0, [
                                $5640421a14091588$var$__assign.apply(void 0, _b.concat([
                                    _c.sent()
                                ])),
                                {
                                    state: state
                                }
                            ])
                        ];
                    case 4:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        e_1 = _c.sent();
                        $5640421a14091588$var$logger.error("Error handling auth response.", e_1);
                        throw e_1;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    OAuth.prototype._validateState = function(urlParams) {
        if (!urlParams) return;
        var savedState = $5jtCg.getState();
        var returnedState = urlParams.state;
        // This is because savedState only exists if the flow was initiated by Amplify
        if (savedState && savedState !== returnedState) throw new Error("Invalid state in OAuth flow");
        return returnedState;
    };
    OAuth.prototype.signOut = function() {
        return $5640421a14091588$var$__awaiter(this, void 0, void 0, function() {
            var oAuthLogoutEndpoint, client_id, signout_uri;
            return $5640421a14091588$var$__generator(this, function(_a) {
                oAuthLogoutEndpoint = "https://" + this._config.domain + "/logout?";
                client_id = (0, $6ZRLT.isCognitoHostedOpts)(this._config) ? this._cognitoClientId : this._config.oauth.clientID;
                signout_uri = (0, $6ZRLT.isCognitoHostedOpts)(this._config) ? this._config.redirectSignOut : this._config.returnTo;
                oAuthLogoutEndpoint += Object.entries({
                    client_id: client_id,
                    logout_uri: encodeURIComponent(signout_uri)
                }).map(function(_a) {
                    var k = _a[0], v = _a[1];
                    return k + "=" + v;
                }).join("&");
                $5640421a14091588$var$dispatchAuthEvent("oAuthSignOut", {
                    oAuth: "signOut"
                }, "Signing out from " + oAuthLogoutEndpoint);
                $5640421a14091588$var$logger.debug("Signing out from " + oAuthLogoutEndpoint);
                return [
                    2 /*return*/ ,
                    this._urlOpener(oAuthLogoutEndpoint)
                ];
            });
        });
    };
    OAuth.prototype._generateState = function(length) {
        var result = "";
        var i = length;
        var chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        for(; i > 0; --i)result += chars[Math.round(Math.random() * (chars.length - 1))];
        return result;
    };
    OAuth.prototype._generateChallenge = function(code) {
        return this._base64URL($fbuuf(code));
    };
    OAuth.prototype._base64URL = function(string) {
        return string.toString($kqURS).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    };
    OAuth.prototype._generateRandom = function(size) {
        var CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
        var buffer = new Uint8Array(size);
        if (typeof window !== "undefined" && !!window.crypto) window.crypto.getRandomValues(buffer);
        else for(var i = 0; i < size; i += 1)buffer[i] = Math.random() * CHARSET.length | 0;
        return this._bufferToString(buffer);
    };
    OAuth.prototype._bufferToString = function(buffer) {
        var CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var state = [];
        for(var i = 0; i < buffer.byteLength; i += 1){
            var index = buffer[i] % CHARSET.length;
            state.push(CHARSET[index]);
        }
        return state.join("");
    };
    return OAuth;
}();
var $5640421a14091588$export$2e2bcd8739ae039 = $5640421a14091588$var$OAuth;

});
parcelRequire.register("gjNOP", function(module, exports) {

$parcel$export(module.exports, "launchUri", function () { return $be1510ac6d90eff4$export$9b38228bd9928080; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $be1510ac6d90eff4$var$SELF = "_self";
var $be1510ac6d90eff4$export$9b38228bd9928080 = function(url) {
    var windowProxy = window.open(url, $be1510ac6d90eff4$var$SELF);
    if (windowProxy) return Promise.resolve(windowProxy);
    else return Promise.reject();
};

});

parcelRequire.register("5jtCg", function(module, exports) {

$parcel$export(module.exports, "setState", function () { return $3de5b34468a67c5b$export$42fffed799c298bb; });
$parcel$export(module.exports, "getState", function () { return $3de5b34468a67c5b$export$50fdfeece43146fd; });
$parcel$export(module.exports, "setPKCE", function () { return $3de5b34468a67c5b$export$14934cb45d589fa1; });
$parcel$export(module.exports, "getPKCE", function () { return $3de5b34468a67c5b$export$742ac7ded61fbfce; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $3de5b34468a67c5b$export$42fffed799c298bb = function(state) {
    window.sessionStorage.setItem("oauth_state", state);
};
var $3de5b34468a67c5b$export$50fdfeece43146fd = function() {
    var oauth_state = window.sessionStorage.getItem("oauth_state");
    window.sessionStorage.removeItem("oauth_state");
    return oauth_state;
};
var $3de5b34468a67c5b$export$14934cb45d589fa1 = function(private_key) {
    window.sessionStorage.setItem("ouath_pkce_key", private_key);
};
var $3de5b34468a67c5b$export$742ac7ded61fbfce = function() {
    var ouath_pkce_key = window.sessionStorage.getItem("ouath_pkce_key");
    window.sessionStorage.removeItem("ouath_pkce_key");
    return ouath_pkce_key;
};
var $3de5b34468a67c5b$export$1042faa6df30c26 = function() {
    window.sessionStorage.removeItem("ouath_pkce_key");
    window.sessionStorage.removeItem("oauth_state");
};

});


parcelRequire.register("hkawN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9cc78937a56d27d$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("2hWDt");
var $gssgp = parcelRequire("gssgp");
var $c9cc78937a56d27d$export$2e2bcd8739ae039 = function(callback) {
    if ((0, $gssgp.default).browserOrNode().isBrowser && window.location) {
        var url = window.location.href;
        callback({
            url: url
        });
    } else if ((0, $gssgp.default).browserOrNode().isNode) ;
    else throw new Error("Not supported");
};

});

parcelRequire.register("8e3hn", function(module, exports) {

$parcel$export(module.exports, "AuthError", function () { return $5fd22cb7a805d1d1$export$145273558d58e0ac; });
$parcel$export(module.exports, "NoUserPoolError", function () { return $5fd22cb7a805d1d1$export$71192787e041818c; });
/*
 * Copyright 2019-2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $5fd22cb7a805d1d1$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5fd22cb7a805d1d1$var$logger = new (0, $gBqCF.ConsoleLogger)("AuthError");
var $5fd22cb7a805d1d1$var$DEFAULT_MSG = "Authentication Error";
var $5fd22cb7a805d1d1$export$145273558d58e0ac = /** @class */ function(_super) {
    $5fd22cb7a805d1d1$var$__extends(AuthError, _super);
    function AuthError(type) {
        var _this = this;
        var _a = $5fd22cb7a805d1d1$export$d8113b8d790509a4[type], message = _a.message, log = _a.log;
        _this = _super.call(this, message) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = AuthError;
        Object.setPrototypeOf(_this, AuthError.prototype);
        _this.name = "AuthError";
        _this.log = log || message;
        $5fd22cb7a805d1d1$var$logger.error(_this.log);
        return _this;
    }
    return AuthError;
}(Error);
var $5fd22cb7a805d1d1$export$71192787e041818c = /** @class */ function(_super) {
    $5fd22cb7a805d1d1$var$__extends(NoUserPoolError, _super);
    function NoUserPoolError(type) {
        var _this = _super.call(this, type) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = NoUserPoolError;
        Object.setPrototypeOf(_this, NoUserPoolError.prototype);
        _this.name = "NoUserPoolError";
        return _this;
    }
    return NoUserPoolError;
}($5fd22cb7a805d1d1$export$145273558d58e0ac);
var $5fd22cb7a805d1d1$export$d8113b8d790509a4 = {
    noConfig: {
        message: $5fd22cb7a805d1d1$var$DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly.\n            This error is typically caused by one of the following scenarios:\n\n            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point\n                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information\n            \n            2. There might be multiple conflicting versions of aws-amplify or amplify packages in your node_modules.\n                Try deleting your node_modules folder and reinstalling the dependencies with `yarn install`\n        "
    },
    missingAuthConfig: {
        message: $5fd22cb7a805d1d1$var$DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly. \n            The configuration object is missing required auth properties. \n            Did you run `amplify push` after adding auth via `amplify add auth`?\n            See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information\n        "
    },
    emptyUsername: {
        message: "Username cannot be empty"
    },
    // TODO: should include a list of valid sign-in types
    invalidUsername: {
        message: "The username should either be a string or one of the sign in types"
    },
    emptyPassword: {
        message: "Password cannot be empty"
    },
    emptyCode: {
        message: "Confirmation code cannot be empty"
    },
    signUpError: {
        message: "Error creating account",
        log: "The first parameter should either be non-null string or object"
    },
    noMFA: {
        message: "No valid MFA method provided"
    },
    invalidMFA: {
        message: "Invalid MFA type"
    },
    emptyChallengeResponse: {
        message: "Challenge response cannot be empty"
    },
    noUserSession: {
        message: "Failed to get the session because the user is empty"
    },
    default: {
        message: $5fd22cb7a805d1d1$var$DEFAULT_MSG
    }
};

});



parcelRequire.register("axy8Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ac77849747b0a17$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "StorageClass", function () { return (parcelRequire("3wefN")).default; }, function (v) { return (parcelRequire("3wefN")).default = v; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $3wefN = parcelRequire("3wefN");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $2hWDt = parcelRequire("2hWDt");
parcelRequire("5ZwjQ");
var $7ac77849747b0a17$var$__assign = undefined && undefined.__assign || function() {
    $7ac77849747b0a17$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7ac77849747b0a17$var$__assign.apply(this, arguments);
};
var $7ac77849747b0a17$var$logger = new (0, $gBqCF.ConsoleLogger)("Storage");
var $7ac77849747b0a17$var$_instance = null;
if (!$7ac77849747b0a17$var$_instance) {
    $7ac77849747b0a17$var$logger.debug("Create Storage Instance");
    $7ac77849747b0a17$var$_instance = new (0, $3wefN.default)();
    $7ac77849747b0a17$var$_instance.vault = new (0, $3wefN.default)();
    var $7ac77849747b0a17$var$old_configure_1 = $7ac77849747b0a17$var$_instance.configure;
    $7ac77849747b0a17$var$_instance.configure = function(options) {
        $7ac77849747b0a17$var$logger.debug("storage configure called");
        var vaultConfig = $7ac77849747b0a17$var$__assign({}, $7ac77849747b0a17$var$old_configure_1.call($7ac77849747b0a17$var$_instance, options));
        // set level private for each provider for the vault
        Object.keys(vaultConfig).forEach(function(providerName) {
            if (typeof vaultConfig[providerName] !== "string") vaultConfig[providerName] = $7ac77849747b0a17$var$__assign($7ac77849747b0a17$var$__assign({}, vaultConfig[providerName]), {
                level: "private"
            });
        });
        $7ac77849747b0a17$var$logger.debug("storage vault configure called");
        $7ac77849747b0a17$var$_instance.vault.configure(vaultConfig);
    };
}
var $7ac77849747b0a17$var$Storage = $7ac77849747b0a17$var$_instance;
(0, $2hWDt.default).register($7ac77849747b0a17$var$Storage);
var $7ac77849747b0a17$export$2e2bcd8739ae039 = $7ac77849747b0a17$var$Storage;

});
parcelRequire.register("3wefN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28ff6ac66546aa10$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $hlQms = parcelRequire("hlQms");

var $eG0WE = parcelRequire("eG0WE");
var $28ff6ac66546aa10$var$__assign = undefined && undefined.__assign || function() {
    $28ff6ac66546aa10$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $28ff6ac66546aa10$var$__assign.apply(this, arguments);
};
var $28ff6ac66546aa10$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $28ff6ac66546aa10$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $28ff6ac66546aa10$var$logger = new (0, $gBqCF.ConsoleLogger)("StorageClass");
var $28ff6ac66546aa10$var$DEFAULT_PROVIDER = "AWSS3";
/**
 * Provide storage methods to use AWS S3
 */ var $28ff6ac66546aa10$var$StorageClass = /** @class */ function() {
    /**
     * Initialize Storage
     * @param {Object} config - Configuration object for storage
     */ function StorageClass() {
        this._config = {};
        this._pluggables = [];
        $28ff6ac66546aa10$var$logger.debug("Storage Options", this._config);
        this.get = this.get.bind(this);
        this.put = this.put.bind(this);
        this.remove = this.remove.bind(this);
        this.list = this.list.bind(this);
    }
    StorageClass.prototype.getModuleName = function() {
        return "Storage";
    };
    /**
     * add plugin into Storage category
     * @param {Object} pluggable - an instance of the plugin
     */ StorageClass.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategory() === "Storage") {
            this._pluggables.push(pluggable);
            var config = {};
            config = pluggable.configure(this._config[pluggable.getProviderName()]);
            return config;
        }
    };
    /**
     * Get the plugin object
     * @param providerName - the name of the plugin
     */ StorageClass.prototype.getPluggable = function(providerName) {
        var pluggable = this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
        if (pluggable === undefined) {
            $28ff6ac66546aa10$var$logger.debug("No plugin found with providerName", providerName);
            return null;
        } else return pluggable;
    };
    /**
     * Remove the plugin object
     * @param providerName - the name of the plugin
     */ StorageClass.prototype.removePluggable = function(providerName) {
        this._pluggables = this._pluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        return;
    };
    /**
     * Configure Storage
     * @param {Object} config - Configuration object for storage
     * @return {Object} - Current configuration
     */ StorageClass.prototype.configure = function(config) {
        var _this = this;
        $28ff6ac66546aa10$var$logger.debug("configure Storage");
        if (!config) return this._config;
        var amplifyConfig = (0, $hlQms.default).parseMobilehubConfig(config);
        var storageKeysFromConfig = Object.keys(amplifyConfig.Storage);
        var storageArrayKeys = [
            "bucket",
            "region",
            "level",
            "track",
            "customPrefix",
            "serverSideEncryption",
            "SSECustomerAlgorithm",
            "SSECustomerKey",
            "SSECustomerKeyMD5",
            "SSEKMSKeyId"
        ];
        var isInStorageArrayKeys = function(k) {
            return storageArrayKeys.some(function(x) {
                return x === k;
            });
        };
        var checkConfigKeysFromArray = function(k) {
            return k.find(function(k) {
                return isInStorageArrayKeys(k);
            });
        };
        if (storageKeysFromConfig && checkConfigKeysFromArray(storageKeysFromConfig) && !amplifyConfig.Storage[$28ff6ac66546aa10$var$DEFAULT_PROVIDER]) amplifyConfig.Storage[$28ff6ac66546aa10$var$DEFAULT_PROVIDER] = {};
        Object.entries(amplifyConfig.Storage).map(function(_a) {
            var key = _a[0], value = _a[1];
            if (key && isInStorageArrayKeys(key) && value !== undefined) {
                amplifyConfig.Storage[$28ff6ac66546aa10$var$DEFAULT_PROVIDER][key] = value;
                delete amplifyConfig.Storage[key];
            }
        });
        // only update new values for each provider
        Object.keys(amplifyConfig.Storage).forEach(function(providerName) {
            if (typeof amplifyConfig.Storage[providerName] !== "string") _this._config[providerName] = $28ff6ac66546aa10$var$__assign($28ff6ac66546aa10$var$__assign({}, _this._config[providerName]), amplifyConfig.Storage[providerName]);
        });
        this._pluggables.forEach(function(pluggable) {
            pluggable.configure(_this._config[pluggable.getProviderName()]);
        });
        if (this._pluggables.length === 0) this.addPluggable(new (0, $eG0WE.default)());
        return this._config;
    };
    /**
     * Get a presigned URL of the file or the object data when download:true
     *
     * @param {String} key - key of the object
     * @param {Object} [config] - { level : private|protected|public, download: true|false }
     * @return - A promise resolves to either a presigned url or the object
     */ StorageClass.prototype.get = function(key, config) {
        return $28ff6ac66546aa10$var$__awaiter(this, void 0, void 0, function() {
            var _a, provider, prov;
            return $28ff6ac66546aa10$var$__generator(this, function(_b) {
                _a = (config || {}).provider, provider = _a === void 0 ? $28ff6ac66546aa10$var$DEFAULT_PROVIDER : _a;
                prov = this._pluggables.find(function(pluggable) {
                    return pluggable.getProviderName() === provider;
                });
                if (prov === undefined) {
                    $28ff6ac66546aa10$var$logger.debug("No plugin found with providerName", provider);
                    Promise.reject("No plugin found in Storage for the provider");
                }
                return [
                    2 /*return*/ ,
                    prov.get(key, config)
                ];
            });
        });
    };
    /**
     * Put a file in storage bucket specified to configure method
     * @param {String} key - key of the object
     * @param {Object} object - File to be put in bucket
     * @param {Object} [config] - { level : private|protected|public, contentType: MIME Types,
     *  progressCallback: function }
     * @return - promise resolves to object on success
     */ StorageClass.prototype.put = function(key, object, config) {
        return $28ff6ac66546aa10$var$__awaiter(this, void 0, void 0, function() {
            var _a, provider, prov;
            return $28ff6ac66546aa10$var$__generator(this, function(_b) {
                _a = (config || {}).provider, provider = _a === void 0 ? $28ff6ac66546aa10$var$DEFAULT_PROVIDER : _a;
                prov = this._pluggables.find(function(pluggable) {
                    return pluggable.getProviderName() === provider;
                });
                if (prov === undefined) {
                    $28ff6ac66546aa10$var$logger.debug("No plugin found with providerName", provider);
                    Promise.reject("No plugin found in Storage for the provider");
                }
                return [
                    2 /*return*/ ,
                    prov.put(key, object, config)
                ];
            });
        });
    };
    /**
     * Remove the object for specified key
     * @param {String} key - key of the object
     * @param {Object} [config] - { level : private|protected|public }
     * @return - Promise resolves upon successful removal of the object
     */ StorageClass.prototype.remove = function(key, config) {
        return $28ff6ac66546aa10$var$__awaiter(this, void 0, void 0, function() {
            var _a, provider, prov;
            return $28ff6ac66546aa10$var$__generator(this, function(_b) {
                _a = (config || {}).provider, provider = _a === void 0 ? $28ff6ac66546aa10$var$DEFAULT_PROVIDER : _a;
                prov = this._pluggables.find(function(pluggable) {
                    return pluggable.getProviderName() === provider;
                });
                if (prov === undefined) {
                    $28ff6ac66546aa10$var$logger.debug("No plugin found with providerName", provider);
                    Promise.reject("No plugin found in Storage for the provider");
                }
                return [
                    2 /*return*/ ,
                    prov.remove(key, config)
                ];
            });
        });
    };
    /**
     * List bucket objects relative to the level and prefix specified
     * @param {String} path - the path that contains objects
     * @param {Object} [config] - { level : private|protected|public, maxKeys: NUMBER }
     * @return - Promise resolves to list of keys for all objects in path
     */ StorageClass.prototype.list = function(path, config) {
        return $28ff6ac66546aa10$var$__awaiter(this, void 0, void 0, function() {
            var _a, provider, prov;
            return $28ff6ac66546aa10$var$__generator(this, function(_b) {
                _a = (config || {}).provider, provider = _a === void 0 ? $28ff6ac66546aa10$var$DEFAULT_PROVIDER : _a;
                prov = this._pluggables.find(function(pluggable) {
                    return pluggable.getProviderName() === provider;
                });
                if (prov === undefined) {
                    $28ff6ac66546aa10$var$logger.debug("No plugin found with providerName", provider);
                    Promise.reject("No plugin found in Storage for the provider");
                }
                return [
                    2 /*return*/ ,
                    prov.list(path, config)
                ];
            });
        });
    };
    return StorageClass;
}();
var $28ff6ac66546aa10$export$2e2bcd8739ae039 = $28ff6ac66546aa10$var$StorageClass;

});
parcelRequire.register("eG0WE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aaf5b892bb06c45c$export$2e2bcd8739ae039; });
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $iZUWK = parcelRequire("iZUWK");
var $hlQms = parcelRequire("hlQms");
var $aCVDw = parcelRequire("aCVDw");

var $fMxnS = parcelRequire("fMxnS");
var $aaf5b892bb06c45c$var$__assign = undefined && undefined.__assign || function() {
    $aaf5b892bb06c45c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $aaf5b892bb06c45c$var$__assign.apply(this, arguments);
};
var $aaf5b892bb06c45c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $aaf5b892bb06c45c$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $aaf5b892bb06c45c$var$logger = new (0, $gBqCF.ConsoleLogger)("AWSS3Provider");
var $aaf5b892bb06c45c$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var $aaf5b892bb06c45c$var$dispatchStorageEvent = function(track, event, attrs, metrics, message) {
    if (track) (0, $iZUWK.default).dispatch("storage", {
        event: event,
        data: {
            attrs: attrs,
            metrics: metrics
        },
        message: message
    }, "Storage", $aaf5b892bb06c45c$var$AMPLIFY_SYMBOL);
};
var $aaf5b892bb06c45c$var$localTestingStorageEndpoint = "http://localhost:20005";
/**
 * Provide storage methods to use AWS S3
 */ var $aaf5b892bb06c45c$var$AWSS3Provider = /** @class */ function() {
    /**
     * Initialize Storage with AWS configurations
     * @param {Object} config - Configuration object for storage
     */ function AWSS3Provider(config) {
        this._config = config ? config : {};
        $aaf5b892bb06c45c$var$logger.debug("Storage Options", this._config);
    }
    /**
     * get the category of the plugin
     */ AWSS3Provider.prototype.getCategory = function() {
        return AWSS3Provider.CATEGORY;
    };
    /**
     * get provider name of the plugin
     */ AWSS3Provider.prototype.getProviderName = function() {
        return AWSS3Provider.PROVIDER_NAME;
    };
    /**
     * Configure Storage part with aws configuration
     * @param {Object} config - Configuration of the Storage
     * @return {Object} - Current configuration
     */ AWSS3Provider.prototype.configure = function(config) {
        $aaf5b892bb06c45c$var$logger.debug("configure Storage", config);
        if (!config) return this._config;
        var amplifyConfig = (0, $hlQms.default).parseMobilehubConfig(config);
        this._config = Object.assign({}, this._config, amplifyConfig.Storage);
        if (!this._config.bucket) $aaf5b892bb06c45c$var$logger.debug("Do not have bucket yet");
        return this._config;
    };
    /**
     * Get a presigned URL of the file or the object data when download:true
     *
     * @param {String} key - key of the object
     * @param {Object} [config] - { level : private|protected|public, download: true|false }
     * @return - A promise resolves to Amazon S3 presigned URL on success
     */ AWSS3Provider.prototype.get = function(key, config) {
        return $aaf5b892bb06c45c$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, download, cacheControl, contentDisposition, contentEncoding, contentLanguage, contentType, expires, track, prefix, final_key, s3, params;
            return $aaf5b892bb06c45c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) return [
                            2 /*return*/ ,
                            Promise.reject("No credentials")
                        ];
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, download = opt.download, cacheControl = opt.cacheControl, contentDisposition = opt.contentDisposition, contentEncoding = opt.contentEncoding, contentLanguage = opt.contentLanguage, contentType = opt.contentType, expires = opt.expires, track = opt.track;
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        s3 = this._createS3(opt);
                        $aaf5b892bb06c45c$var$logger.debug("get " + key + " from " + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        // See: https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/S3.html#getObject-property
                        if (cacheControl) params.ResponseCacheControl = cacheControl;
                        if (contentDisposition) params.ResponseContentDisposition = contentDisposition;
                        if (contentEncoding) params.ResponseContentEncoding = contentEncoding;
                        if (contentLanguage) params.ResponseContentLanguage = contentLanguage;
                        if (contentType) params.ResponseContentType = contentType;
                        if (download === true) return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                s3.getObject(params, function(err, data) {
                                    if (err) {
                                        $aaf5b892bb06c45c$var$dispatchStorageEvent(track, "download", {
                                            method: "get",
                                            result: "failed"
                                        }, null, "Download failed with " + err.message);
                                        rej(err);
                                    } else {
                                        $aaf5b892bb06c45c$var$dispatchStorageEvent(track, "download", {
                                            method: "get",
                                            result: "success"
                                        }, {
                                            fileSize: Number(data.Body["length"])
                                        }, "Download success for " + key);
                                        res(data);
                                    }
                                });
                            })
                        ];
                        if (expires) params.Expires = expires;
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                try {
                                    var url = s3.getSignedUrl("getObject", params);
                                    $aaf5b892bb06c45c$var$dispatchStorageEvent(track, "getSignedUrl", {
                                        method: "get",
                                        result: "success"
                                    }, null, "Signed URL: " + url);
                                    res(url);
                                } catch (e) {
                                    $aaf5b892bb06c45c$var$logger.warn("get signed url error", e);
                                    $aaf5b892bb06c45c$var$dispatchStorageEvent(track, "getSignedUrl", {
                                        method: "get",
                                        result: "failed"
                                    }, null, "Could not get a signed URL for " + key);
                                    rej(e);
                                }
                            })
                        ];
                }
            });
        });
    };
    /**
     * Put a file in S3 bucket specified to configure method
     * @param {String} key - key of the object
     * @param {Object} object - File to be put in Amazon S3 bucket
     * @param {Object} [config] - { level : private|protected|public, contentType: MIME Types,
     *  progressCallback: function }
     * @return - promise resolves to object on success
     */ AWSS3Provider.prototype.put = function(key, object, config) {
        return $aaf5b892bb06c45c$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, progressCallback, contentType, contentDisposition, cacheControl, expires, metadata, tagging, serverSideEncryption, SSECustomerAlgorithm, SSECustomerKey, SSECustomerKeyMD5, SSEKMSKeyId, type, prefix, final_key, s3, params, upload, data, e_1;
            return $aaf5b892bb06c45c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) return [
                            2 /*return*/ ,
                            Promise.reject("No credentials")
                        ];
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track, progressCallback = opt.progressCallback;
                        contentType = opt.contentType, contentDisposition = opt.contentDisposition, cacheControl = opt.cacheControl, expires = opt.expires, metadata = opt.metadata, tagging = opt.tagging;
                        serverSideEncryption = opt.serverSideEncryption, SSECustomerAlgorithm = opt.SSECustomerAlgorithm, SSECustomerKey = opt.SSECustomerKey, SSECustomerKeyMD5 = opt.SSECustomerKeyMD5, SSEKMSKeyId = opt.SSEKMSKeyId;
                        type = contentType ? contentType : "binary/octet-stream";
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        s3 = this._createS3(opt);
                        $aaf5b892bb06c45c$var$logger.debug("put " + key + " to " + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key,
                            Body: object,
                            ContentType: type
                        };
                        if (cacheControl) params.CacheControl = cacheControl;
                        if (contentDisposition) params.ContentDisposition = contentDisposition;
                        if (expires) params.Expires = expires;
                        if (metadata) params.Metadata = metadata;
                        if (tagging) params.Tagging = tagging;
                        if (serverSideEncryption) {
                            params.ServerSideEncryption = serverSideEncryption;
                            if (SSECustomerAlgorithm) params.SSECustomerAlgorithm = SSECustomerAlgorithm;
                            if (SSECustomerKey) params.SSECustomerKey = SSECustomerKey;
                            if (SSECustomerKeyMD5) params.SSECustomerKeyMD5 = SSECustomerKeyMD5;
                            if (SSEKMSKeyId) params.SSEKMSKeyId = SSEKMSKeyId;
                        }
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        upload = s3.upload(params).on("httpUploadProgress", function(progress) {
                            if (progressCallback) {
                                if (typeof progressCallback === "function") progressCallback(progress);
                                else $aaf5b892bb06c45c$var$logger.warn("progressCallback should be a function, not a " + typeof progressCallback);
                            }
                        });
                        return [
                            4 /*yield*/ ,
                            upload.promise()
                        ];
                    case 3:
                        data = _a.sent();
                        $aaf5b892bb06c45c$var$logger.debug("upload result", data);
                        $aaf5b892bb06c45c$var$dispatchStorageEvent(track, "upload", {
                            method: "put",
                            result: "success"
                        }, null, "Upload success for " + key);
                        return [
                            2 /*return*/ ,
                            {
                                key: data.Key.substr(prefix.length)
                            }
                        ];
                    case 4:
                        e_1 = _a.sent();
                        $aaf5b892bb06c45c$var$logger.warn("error uploading", e_1);
                        $aaf5b892bb06c45c$var$dispatchStorageEvent(track, "upload", {
                            method: "put",
                            result: "failed"
                        }, null, "Error uploading " + key);
                        throw e_1;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Remove the object for specified key
     * @param {String} key - key of the object
     * @param {Object} [config] - { level : private|protected|public }
     * @return - Promise resolves upon successful removal of the object
     */ AWSS3Provider.prototype.remove = function(key, config) {
        return $aaf5b892bb06c45c$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, prefix, final_key, s3, params;
            return $aaf5b892bb06c45c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) return [
                            2 /*return*/ ,
                            Promise.reject("No credentials")
                        ];
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track;
                        prefix = this._prefix(opt);
                        final_key = prefix + key;
                        s3 = this._createS3(opt);
                        $aaf5b892bb06c45c$var$logger.debug("remove " + key + " from " + final_key);
                        params = {
                            Bucket: bucket,
                            Key: final_key
                        };
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                s3.deleteObject(params, function(err, data) {
                                    if (err) {
                                        $aaf5b892bb06c45c$var$dispatchStorageEvent(track, "delete", {
                                            method: "remove",
                                            result: "failed"
                                        }, null, "Deletion of " + key + " failed with " + err);
                                        rej(err);
                                    } else {
                                        $aaf5b892bb06c45c$var$dispatchStorageEvent(track, "delete", {
                                            method: "remove",
                                            result: "success"
                                        }, null, "Deleted " + key + " successfully");
                                        res(data);
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * List bucket objects relative to the level and prefix specified
     * @param {String} path - the path that contains objects
     * @param {Object} [config] - { level : private|protected|public }
     * @return - Promise resolves to list of keys for all objects in path
     */ AWSS3Provider.prototype.list = function(path, config) {
        return $aaf5b892bb06c45c$var$__awaiter(this, void 0, void 0, function() {
            var credentialsOK, opt, bucket, track, maxKeys, prefix, final_path, s3, params;
            return $aaf5b892bb06c45c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) return [
                            2 /*return*/ ,
                            Promise.reject("No credentials")
                        ];
                        opt = Object.assign({}, this._config, config);
                        bucket = opt.bucket, track = opt.track, maxKeys = opt.maxKeys;
                        prefix = this._prefix(opt);
                        final_path = prefix + path;
                        s3 = this._createS3(opt);
                        $aaf5b892bb06c45c$var$logger.debug("list " + path + " from " + final_path);
                        params = {
                            Bucket: bucket,
                            Prefix: final_path,
                            MaxKeys: maxKeys
                        };
                        return [
                            2 /*return*/ ,
                            new Promise(function(res, rej) {
                                s3.listObjects(params, function(err, data) {
                                    if (err) {
                                        $aaf5b892bb06c45c$var$logger.warn("list error", err);
                                        $aaf5b892bb06c45c$var$dispatchStorageEvent(track, "list", {
                                            method: "list",
                                            result: "failed"
                                        }, null, "Listing items failed: " + err.message);
                                        rej(err);
                                    } else {
                                        var list = data.Contents.map(function(item) {
                                            return {
                                                key: item.Key.substr(prefix.length),
                                                eTag: item.ETag,
                                                lastModified: item.LastModified,
                                                size: item.Size
                                            };
                                        });
                                        $aaf5b892bb06c45c$var$dispatchStorageEvent(track, "list", {
                                            method: "list",
                                            result: "success"
                                        }, null, list.length + " items returned from list operation");
                                        $aaf5b892bb06c45c$var$logger.debug("list", list);
                                        res(list);
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * @private
     */ AWSS3Provider.prototype._ensureCredentials = function() {
        var _this = this;
        return (0, $aCVDw.default).get().then(function(credentials) {
            if (!credentials) return false;
            var cred = (0, $aCVDw.default).shear(credentials);
            $aaf5b892bb06c45c$var$logger.debug("set credentials for storage", cred);
            _this._config.credentials = cred;
            return true;
        }).catch(function(err) {
            $aaf5b892bb06c45c$var$logger.warn("ensure credentials error", err);
            return false;
        });
    };
    /**
     * @private
     */ AWSS3Provider.prototype._prefix = function(config) {
        var credentials = config.credentials, level = config.level;
        var customPrefix = config.customPrefix || {};
        var identityId = config.identityId || credentials.identityId;
        var privatePath = (customPrefix.private !== undefined ? customPrefix.private : "private/") + identityId + "/";
        var protectedPath = (customPrefix.protected !== undefined ? customPrefix.protected : "protected/") + identityId + "/";
        var publicPath = customPrefix.public !== undefined ? customPrefix.public : "public/";
        switch(level){
            case "private":
                return privatePath;
            case "protected":
                return protectedPath;
            default:
                return publicPath;
        }
    };
    /**
     * @private
     */ AWSS3Provider.prototype._createS3 = function(config) {
        var bucket = config.bucket, region = config.region, credentials = config.credentials, dangerouslyConnectToHttpEndpointForTesting = config.dangerouslyConnectToHttpEndpointForTesting;
        var localTestingConfig = {};
        if (dangerouslyConnectToHttpEndpointForTesting) localTestingConfig = {
            endpoint: $aaf5b892bb06c45c$var$localTestingStorageEndpoint,
            s3BucketEndpoint: true,
            s3ForcePathStyle: true
        };
        return new $fMxnS($aaf5b892bb06c45c$var$__assign({
            apiVersion: "2006-03-01",
            params: {
                Bucket: bucket
            },
            signatureVersion: "v4",
            region: region,
            credentials: credentials
        }, localTestingConfig));
    };
    AWSS3Provider.CATEGORY = "Storage";
    AWSS3Provider.PROVIDER_NAME = "AWSS3";
    return AWSS3Provider;
}();
var $aaf5b892bb06c45c$export$2e2bcd8739ae039 = $aaf5b892bb06c45c$var$AWSS3Provider;

});
parcelRequire.register("fMxnS", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $b7d53c15d7d30100$var$Service = $dbC7k.Service;
var $b7d53c15d7d30100$var$apiLoader = $dbC7k.apiLoader;
$b7d53c15d7d30100$var$apiLoader.services["s3"] = {};
$dbC7k.S3 = $b7d53c15d7d30100$var$Service.defineService("s3", [
    "2006-03-01"
]);
parcelRequire("eLjKd");



Object.defineProperty($b7d53c15d7d30100$var$apiLoader.services["s3"], "2006-03-01", {
    get: function get() {
        var model = (parcelRequire("25nQG"));
        model.paginators = (parcelRequire("5udx1")).pagination;
        model.waiters = (parcelRequire("8i7wF")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.S3;

});
parcelRequire.register("eLjKd", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");

var $3SbtQ = parcelRequire("3SbtQ");
parcelRequire("iOS2j");
/**
 * @api private
 */ var $abf4c5502cb287d6$var$operationsWith200StatusCodeError = {
    "completeMultipartUpload": true,
    "copyObject": true,
    "uploadPartCopy": true
};
/**
 * @api private
 */ var $abf4c5502cb287d6$var$regionRedirectErrorCodes = [
    "AuthorizationHeaderMalformed",
    "BadRequest",
    "PermanentRedirect",
    301 // head operations on path-style or regional endpoints
];
$dbC7k.util.update($dbC7k.S3.prototype, {
    /**
   * @api private
   */ getSignatureVersion: function getSignatureVersion(request) {
        var defaultApiVersion = this.api.signatureVersion;
        var userDefinedVersion = this._originalConfig ? this._originalConfig.signatureVersion : null;
        var regionDefinedVersion = this.config.signatureVersion;
        var isPresigned = request ? request.isPresigned() : false;
        /*
      1) User defined version specified:
        a) always return user defined version
      2) No user defined version specified:
        a) default to lowest version the region supports
        b) If using presigned urls, default to lowest version the region supports
    */ if (userDefinedVersion) {
            userDefinedVersion = userDefinedVersion === "v2" ? "s3" : userDefinedVersion;
            return userDefinedVersion;
        }
        if (isPresigned !== true) defaultApiVersion = "v4";
        else if (regionDefinedVersion) defaultApiVersion = regionDefinedVersion;
        return defaultApiVersion;
    },
    /**
   * @api private
   */ getSignerClass: function getSignerClass(request) {
        var signatureVersion = this.getSignatureVersion(request);
        return $dbC7k.Signers.RequestSigner.getVersion(signatureVersion);
    },
    /**
   * @api private
   */ validateService: function validateService() {
        var msg;
        var messages = [];
        // default to us-east-1 when no region is provided
        if (!this.config.region) this.config.region = "us-east-1";
        if (!this.config.endpoint && this.config.s3BucketEndpoint) messages.push("An endpoint must be provided when configuring `s3BucketEndpoint` to true.");
        if (messages.length === 1) msg = messages[0];
        else if (messages.length > 1) msg = "Multiple configuration errors:\n" + messages.join("\n");
        if (msg) throw $dbC7k.util.error(new Error(), {
            name: "InvalidEndpoint",
            message: msg
        });
    },
    /**
   * @api private
   */ shouldDisableBodySigning: function shouldDisableBodySigning(request) {
        var signerClass = this.getSignerClass();
        if (this.config.s3DisableBodySigning === true && signerClass === $dbC7k.Signers.V4 && request.httpRequest.endpoint.protocol === "https:") return true;
        return false;
    },
    /**
   * @api private
   */ setupRequestListeners: function setupRequestListeners(request) {
        var prependListener = true;
        request.addListener("validate", this.validateScheme);
        request.addListener("validate", this.validateBucketEndpoint);
        request.addListener("validate", this.correctBucketRegionFromCache);
        request.addListener("validate", this.validateBucketName, prependListener);
        request.addListener("build", this.addContentType);
        request.addListener("build", this.populateURI);
        request.addListener("build", this.computeContentMd5);
        request.addListener("build", this.computeSseCustomerKeyMd5);
        request.addListener("afterBuild", this.addExpect100Continue);
        request.removeListener("validate", $dbC7k.EventListeners.Core.VALIDATE_REGION);
        request.addListener("extractError", this.extractError);
        request.onAsync("extractError", this.requestBucketRegion);
        request.addListener("extractData", this.extractData);
        request.addListener("extractData", $dbC7k.util.hoistPayloadMember);
        request.addListener("beforePresign", this.prepareSignedUrl);
        if ($dbC7k.util.isBrowser()) request.onAsync("retry", this.reqRegionForNetworkingError);
        if (this.shouldDisableBodySigning(request)) {
            request.removeListener("afterBuild", $dbC7k.EventListeners.Core.COMPUTE_SHA256);
            request.addListener("afterBuild", this.disableBodySigning);
        }
    },
    /**
   * @api private
   */ validateScheme: function(req) {
        var params = req.params, scheme = req.httpRequest.endpoint.protocol, sensitive = params.SSECustomerKey || params.CopySourceSSECustomerKey;
        if (sensitive && scheme !== "https:") {
            var msg = "Cannot send SSE keys over HTTP. Set 'sslEnabled'to 'true' in your configuration";
            throw $dbC7k.util.error(new Error(), {
                code: "ConfigError",
                message: msg
            });
        }
    },
    /**
   * @api private
   */ validateBucketEndpoint: function(req) {
        if (!req.params.Bucket && req.service.config.s3BucketEndpoint) {
            var msg = "Cannot send requests to root API with `s3BucketEndpoint` set.";
            throw $dbC7k.util.error(new Error(), {
                code: "ConfigError",
                message: msg
            });
        }
    },
    /**
   * @api private
   */ validateBucketName: function validateBucketName(req) {
        var service = req.service;
        var signatureVersion = service.getSignatureVersion(req);
        var bucket = req.params && req.params.Bucket;
        var key = req.params && req.params.Key;
        var slashIndex = bucket && bucket.indexOf("/");
        if (bucket && slashIndex >= 0) {
            if (typeof key === "string" && slashIndex > 0) {
                req.params = $dbC7k.util.copy(req.params);
                // Need to include trailing slash to match sigv2 behavior
                var prefix = bucket.substr(slashIndex + 1) || "";
                req.params.Key = prefix + "/" + key;
                req.params.Bucket = bucket.substr(0, slashIndex);
            } else if (signatureVersion === "v4") {
                var msg = "Bucket names cannot contain forward slashes. Bucket: " + bucket;
                throw $dbC7k.util.error(new Error(), {
                    code: "InvalidBucket",
                    message: msg
                });
            }
        }
    },
    /**
   * @api private
   */ isValidAccelerateOperation: function isValidAccelerateOperation(operation) {
        var invalidOperations = [
            "createBucket",
            "deleteBucket",
            "listBuckets"
        ];
        return invalidOperations.indexOf(operation) === -1;
    },
    /**
   * S3 prefers dns-compatible bucket names to be moved from the uri path
   * to the hostname as a sub-domain.  This is not possible, even for dns-compat
   * buckets when using SSL and the bucket name contains a dot ('.').  The
   * ssl wildcard certificate is only 1-level deep.
   *
   * @api private
   */ populateURI: function populateURI(req) {
        var httpRequest = req.httpRequest;
        var b = req.params.Bucket;
        var service = req.service;
        var endpoint = httpRequest.endpoint;
        if (b) {
            if (!service.pathStyleBucketName(b)) {
                if (service.config.useAccelerateEndpoint && service.isValidAccelerateOperation(req.operation)) {
                    if (service.config.useDualstack) endpoint.hostname = b + ".s3-accelerate.dualstack.amazonaws.com";
                    else endpoint.hostname = b + ".s3-accelerate.amazonaws.com";
                } else if (!service.config.s3BucketEndpoint) endpoint.hostname = b + "." + endpoint.hostname;
                var port = endpoint.port;
                if (port !== 80 && port !== 443) endpoint.host = endpoint.hostname + ":" + endpoint.port;
                else endpoint.host = endpoint.hostname;
                httpRequest.virtualHostedBucket = b; // needed for signing the request
                service.removeVirtualHostedBucketFromPath(req);
            }
        }
    },
    /**
   * Takes the bucket name out of the path if bucket is virtual-hosted
   *
   * @api private
   */ removeVirtualHostedBucketFromPath: function removeVirtualHostedBucketFromPath(req) {
        var httpRequest = req.httpRequest;
        var bucket = httpRequest.virtualHostedBucket;
        if (bucket && httpRequest.path) {
            if (req.params && req.params.Key) {
                var encodedS3Key = "/" + $dbC7k.util.uriEscapePath(req.params.Key);
                if (httpRequest.path.indexOf(encodedS3Key) === 0 && (httpRequest.path.length === encodedS3Key.length || httpRequest.path[encodedS3Key.length] === "?")) //path only contains key or path contains only key and querystring
                return;
            }
            httpRequest.path = httpRequest.path.replace(new RegExp("/" + bucket), "");
            if (httpRequest.path[0] !== "/") httpRequest.path = "/" + httpRequest.path;
        }
    },
    /**
   * Adds Expect: 100-continue header if payload is greater-or-equal 1MB
   * @api private
   */ addExpect100Continue: function addExpect100Continue(req) {
        var len = req.httpRequest.headers["Content-Length"];
        if ($dbC7k.util.isNode() && (len >= 1048576 || req.params.Body instanceof $dbC7k.util.stream.Stream)) req.httpRequest.headers["Expect"] = "100-continue";
    },
    /**
   * Adds a default content type if none is supplied.
   *
   * @api private
   */ addContentType: function addContentType(req) {
        var httpRequest = req.httpRequest;
        if (httpRequest.method === "GET" || httpRequest.method === "HEAD") {
            // Content-Type is not set in GET/HEAD requests
            delete httpRequest.headers["Content-Type"];
            return;
        }
        if (!httpRequest.headers["Content-Type"]) httpRequest.headers["Content-Type"] = "application/octet-stream";
        var contentType = httpRequest.headers["Content-Type"];
        if ($dbC7k.util.isBrowser()) {
            if (typeof httpRequest.body === "string" && !contentType.match(/;\s*charset=/)) {
                var charset = "; charset=UTF-8";
                httpRequest.headers["Content-Type"] += charset;
            } else {
                var replaceFn = function(_, prefix, charsetName) {
                    return prefix + charsetName.toUpperCase();
                };
                httpRequest.headers["Content-Type"] = contentType.replace(/(;\s*charset=)(.+)$/, replaceFn);
            }
        }
    },
    /**
   * @api private
   */ computableChecksumOperations: {
        putBucketCors: true,
        putBucketLifecycle: true,
        putBucketLifecycleConfiguration: true,
        putBucketTagging: true,
        deleteObjects: true,
        putBucketReplication: true,
        putObjectLegalHold: true,
        putObjectRetention: true,
        putObjectLockConfiguration: true
    },
    /**
   * Checks whether checksums should be computed for the request.
   * If the request requires checksums to be computed, this will always
   * return true, otherwise it depends on whether {AWS.Config.computeChecksums}
   * is set.
   *
   * @param req [AWS.Request] the request to check against
   * @return [Boolean] whether to compute checksums for a request.
   * @api private
   */ willComputeChecksums: function willComputeChecksums(req) {
        if (this.computableChecksumOperations[req.operation]) return true;
        if (!this.config.computeChecksums) return false;
        // TODO: compute checksums for Stream objects
        if (!$dbC7k.util.Buffer.isBuffer(req.httpRequest.body) && typeof req.httpRequest.body !== "string") return false;
        var rules = req.service.api.operations[req.operation].input.members;
        // Sha256 signing disabled, and not a presigned url
        if (req.service.shouldDisableBodySigning(req) && !Object.prototype.hasOwnProperty.call(req.httpRequest.headers, "presigned-expires")) {
            if (rules.ContentMD5 && !req.params.ContentMD5) return true;
        }
        // V4 signer uses SHA256 signatures so only compute MD5 if it is required
        if (req.service.getSignerClass(req) === $dbC7k.Signers.V4) {
            if (rules.ContentMD5 && !rules.ContentMD5.required) return false;
        }
        if (rules.ContentMD5 && !req.params.ContentMD5) return true;
    },
    /**
   * A listener that computes the Content-MD5 and sets it in the header.
   * @see AWS.S3.willComputeChecksums
   * @api private
   */ computeContentMd5: function computeContentMd5(req) {
        if (req.service.willComputeChecksums(req)) {
            var md5 = $dbC7k.util.crypto.md5(req.httpRequest.body, "base64");
            req.httpRequest.headers["Content-MD5"] = md5;
        }
    },
    /**
   * @api private
   */ computeSseCustomerKeyMd5: function computeSseCustomerKeyMd5(req) {
        var keys = {
            SSECustomerKey: "x-amz-server-side-encryption-customer-key-MD5",
            CopySourceSSECustomerKey: "x-amz-copy-source-server-side-encryption-customer-key-MD5"
        };
        $dbC7k.util.each(keys, function(key, header) {
            if (req.params[key]) {
                var value = $dbC7k.util.crypto.md5(req.params[key], "base64");
                req.httpRequest.headers[header] = value;
            }
        });
    },
    /**
   * Returns true if the bucket name should be left in the URI path for
   * a request to S3.  This function takes into account the current
   * endpoint protocol (e.g. http or https).
   *
   * @api private
   */ pathStyleBucketName: function pathStyleBucketName(bucketName) {
        // user can force path style requests via the configuration
        if (this.config.s3ForcePathStyle) return true;
        if (this.config.s3BucketEndpoint) return false;
        if (this.dnsCompatibleBucketName(bucketName)) return this.config.sslEnabled && bucketName.match(/\./) ? true : false;
        else return true; // not dns compatible names must always use path style
    },
    /**
   * Returns true if the bucket name is DNS compatible.  Buckets created
   * outside of the classic region MUST be DNS compatible.
   *
   * @api private
   */ dnsCompatibleBucketName: function dnsCompatibleBucketName(bucketName) {
        var b = bucketName;
        var domain = new RegExp(/^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/);
        var ipAddress = new RegExp(/(\d+\.){3}\d+/);
        var dots = new RegExp(/\.\./);
        return b.match(domain) && !b.match(ipAddress) && !b.match(dots) ? true : false;
    },
    /**
   * @return [Boolean] whether response contains an error
   * @api private
   */ successfulResponse: function successfulResponse(resp) {
        var req = resp.request;
        var httpResponse = resp.httpResponse;
        if ($abf4c5502cb287d6$var$operationsWith200StatusCodeError[req.operation] && httpResponse.body.toString().match("<Error>")) return false;
        else return httpResponse.statusCode < 300;
    },
    /**
   * @return [Boolean] whether the error can be retried
   * @api private
   */ retryableError: function retryableError(error, request) {
        if ($abf4c5502cb287d6$var$operationsWith200StatusCodeError[request.operation] && error.statusCode === 200) return true;
        else if (request._requestRegionForBucket && request.service.bucketRegionCache[request._requestRegionForBucket]) return false;
        else if (error && error.code === "RequestTimeout") return true;
        else if (error && $abf4c5502cb287d6$var$regionRedirectErrorCodes.indexOf(error.code) != -1 && error.region && error.region != request.httpRequest.region) {
            request.httpRequest.region = error.region;
            if (error.statusCode === 301) request.service.updateReqBucketRegion(request);
            return true;
        } else {
            var _super = $dbC7k.Service.prototype.retryableError;
            return _super.call(this, error, request);
        }
    },
    /**
   * Updates httpRequest with region. If region is not provided, then
   * the httpRequest will be updated based on httpRequest.region
   *
   * @api private
   */ updateReqBucketRegion: function updateReqBucketRegion(request, region) {
        var httpRequest = request.httpRequest;
        if (typeof region === "string" && region.length) httpRequest.region = region;
        if (!httpRequest.endpoint.host.match(/s3(?!-accelerate).*\.amazonaws\.com$/)) return;
        var service = request.service;
        var s3Config = service.config;
        var s3BucketEndpoint = s3Config.s3BucketEndpoint;
        if (s3BucketEndpoint) delete s3Config.s3BucketEndpoint;
        var newConfig = $dbC7k.util.copy(s3Config);
        delete newConfig.endpoint;
        newConfig.region = httpRequest.region;
        httpRequest.endpoint = new $dbC7k.S3(newConfig).endpoint;
        service.populateURI(request);
        s3Config.s3BucketEndpoint = s3BucketEndpoint;
        httpRequest.headers.Host = httpRequest.endpoint.host;
        if (request._asm.currentState === "validate") {
            request.removeListener("build", service.populateURI);
            request.addListener("build", service.removeVirtualHostedBucketFromPath);
        }
    },
    /**
   * Provides a specialized parser for getBucketLocation -- all other
   * operations are parsed by the super class.
   *
   * @api private
   */ extractData: function extractData(resp) {
        var req = resp.request;
        if (req.operation === "getBucketLocation") {
            var match = resp.httpResponse.body.toString().match(/>(.+)<\/Location/);
            delete resp.data["_"];
            if (match) resp.data.LocationConstraint = match[1];
            else resp.data.LocationConstraint = "";
        }
        var bucket = req.params.Bucket || null;
        if (req.operation === "deleteBucket" && typeof bucket === "string" && !resp.error) req.service.clearBucketRegionCache(bucket);
        else {
            var headers = resp.httpResponse.headers || {};
            var region = headers["x-amz-bucket-region"] || null;
            if (!region && req.operation === "createBucket" && !resp.error) {
                var createBucketConfiguration = req.params.CreateBucketConfiguration;
                if (!createBucketConfiguration) region = "us-east-1";
                else if (createBucketConfiguration.LocationConstraint === "EU") region = "eu-west-1";
                else region = createBucketConfiguration.LocationConstraint;
            }
            if (region) {
                if (bucket && region !== req.service.bucketRegionCache[bucket]) req.service.bucketRegionCache[bucket] = region;
            }
        }
        req.service.extractRequestIds(resp);
    },
    /**
   * Extracts an error object from the http response.
   *
   * @api private
   */ extractError: function extractError(resp) {
        var codes = {
            304: "NotModified",
            403: "Forbidden",
            400: "BadRequest",
            404: "NotFound"
        };
        var req = resp.request;
        var code = resp.httpResponse.statusCode;
        var body = resp.httpResponse.body || "";
        var headers = resp.httpResponse.headers || {};
        var region = headers["x-amz-bucket-region"] || null;
        var bucket = req.params.Bucket || null;
        var bucketRegionCache = req.service.bucketRegionCache;
        if (region && bucket && region !== bucketRegionCache[bucket]) bucketRegionCache[bucket] = region;
        var cachedRegion;
        if (codes[code] && body.length === 0) {
            if (bucket && !region) {
                cachedRegion = bucketRegionCache[bucket] || null;
                if (cachedRegion !== req.httpRequest.region) region = cachedRegion;
            }
            resp.error = $dbC7k.util.error(new Error(), {
                code: codes[code],
                message: null,
                region: region
            });
        } else {
            var data = new $dbC7k.XML.Parser().parse(body.toString());
            if (data.Region && !region) {
                region = data.Region;
                if (bucket && region !== bucketRegionCache[bucket]) bucketRegionCache[bucket] = region;
            } else if (bucket && !region && !data.Region) {
                cachedRegion = bucketRegionCache[bucket] || null;
                if (cachedRegion !== req.httpRequest.region) region = cachedRegion;
            }
            resp.error = $dbC7k.util.error(new Error(), {
                code: data.Code || code,
                message: data.Message || null,
                region: region
            });
        }
        req.service.extractRequestIds(resp);
    },
    /**
   * If region was not obtained synchronously, then send async request
   * to get bucket region for errors resulting from wrong region.
   *
   * @api private
   */ requestBucketRegion: function requestBucketRegion(resp, done) {
        var error = resp.error;
        var req = resp.request;
        var bucket = req.params.Bucket || null;
        if (!error || !bucket || error.region || req.operation === "listObjects" || $dbC7k.util.isNode() && req.operation === "headBucket" || error.statusCode === 400 && req.operation !== "headObject" || $abf4c5502cb287d6$var$regionRedirectErrorCodes.indexOf(error.code) === -1) return done();
        var reqOperation = $dbC7k.util.isNode() ? "headBucket" : "listObjects";
        var reqParams = {
            Bucket: bucket
        };
        if (reqOperation === "listObjects") reqParams.MaxKeys = 0;
        var regionReq = req.service[reqOperation](reqParams);
        regionReq._requestRegionForBucket = bucket;
        regionReq.send(function() {
            var region = req.service.bucketRegionCache[bucket] || null;
            error.region = region;
            done();
        });
    },
    /**
   * For browser only. If NetworkingError received, will attempt to obtain
   * the bucket region.
   *
   * @api private
   */ reqRegionForNetworkingError: function reqRegionForNetworkingError(resp, done) {
        if (!$dbC7k.util.isBrowser()) return done();
        var error = resp.error;
        var request = resp.request;
        var bucket = request.params.Bucket;
        if (!error || error.code !== "NetworkingError" || !bucket || request.httpRequest.region === "us-east-1") return done();
        var service = request.service;
        var bucketRegionCache = service.bucketRegionCache;
        var cachedRegion = bucketRegionCache[bucket] || null;
        if (cachedRegion && cachedRegion !== request.httpRequest.region) {
            service.updateReqBucketRegion(request, cachedRegion);
            done();
        } else if (!service.dnsCompatibleBucketName(bucket)) {
            service.updateReqBucketRegion(request, "us-east-1");
            if (bucketRegionCache[bucket] !== "us-east-1") bucketRegionCache[bucket] = "us-east-1";
            done();
        } else if (request.httpRequest.virtualHostedBucket) {
            var getRegionReq = service.listObjects({
                Bucket: bucket,
                MaxKeys: 0
            });
            service.updateReqBucketRegion(getRegionReq, "us-east-1");
            getRegionReq._requestRegionForBucket = bucket;
            getRegionReq.send(function() {
                var region = service.bucketRegionCache[bucket] || null;
                if (region && region !== request.httpRequest.region) service.updateReqBucketRegion(request, region);
                done();
            });
        } else // DNS-compatible path-style
        // (s3ForcePathStyle or bucket name with dot over https)
        // Cannot obtain region information for this case
        done();
    },
    /**
   * Cache for bucket region.
   *
   * @api private
   */ bucketRegionCache: {},
    /**
   * Clears bucket region cache.
   *
   * @api private
   */ clearBucketRegionCache: function(buckets) {
        var bucketRegionCache = this.bucketRegionCache;
        if (!buckets) buckets = Object.keys(bucketRegionCache);
        else if (typeof buckets === "string") buckets = [
            buckets
        ];
        for(var i = 0; i < buckets.length; i++)delete bucketRegionCache[buckets[i]];
        return bucketRegionCache;
    },
    /**
    * Corrects request region if bucket's cached region is different
    *
    * @api private
    */ correctBucketRegionFromCache: function correctBucketRegionFromCache(req) {
        var bucket = req.params.Bucket || null;
        if (bucket) {
            var service = req.service;
            var requestRegion = req.httpRequest.region;
            var cachedRegion = service.bucketRegionCache[bucket];
            if (cachedRegion && cachedRegion !== requestRegion) service.updateReqBucketRegion(req, cachedRegion);
        }
    },
    /**
   * Extracts S3 specific request ids from the http response.
   *
   * @api private
   */ extractRequestIds: function extractRequestIds(resp) {
        var extendedRequestId = resp.httpResponse.headers ? resp.httpResponse.headers["x-amz-id-2"] : null;
        var cfId = resp.httpResponse.headers ? resp.httpResponse.headers["x-amz-cf-id"] : null;
        resp.extendedRequestId = extendedRequestId;
        resp.cfId = cfId;
        if (resp.error) {
            resp.error.requestId = resp.requestId || null;
            resp.error.extendedRequestId = extendedRequestId;
            resp.error.cfId = cfId;
        }
    },
    /**
   * Get a pre-signed URL for a given operation name.
   *
   * @note You must ensure that you have static or previously resolved
   *   credentials if you call this method synchronously (with no callback),
   *   otherwise it may not properly sign the request. If you cannot guarantee
   *   this (you are using an asynchronous credential provider, i.e., EC2
   *   IAM roles), you should always call this method with an asynchronous
   *   callback.
   * @note Not all operation parameters are supported when using pre-signed
   *   URLs. Certain parameters, such as `SSECustomerKey`, `ACL`, `Expires`,
   *   `ContentLength`, or `Tagging` must be provided as headers when sending a
   *   request. If you are using pre-signed URLs to upload from a browser and
   *   need to use these fields, see {createPresignedPost}.
   * @note The default signer allows altering the request by adding corresponding
   *   headers to set some parameters (e.g. Range) and these added parameters
   *   won't be signed. You must use signatureVersion v4 to to include these
   *   parameters in the signed portion of the URL and enforce exact matching
   *   between headers and signed params in the URL.
   * @note This operation cannot be used with a promise. See note above regarding
   *   asynchronous credentials and use with a callback.
   * @param operation [String] the name of the operation to call
   * @param params [map] parameters to pass to the operation. See the given
   *   operation for the expected operation parameters. In addition, you can
   *   also pass the "Expires" parameter to inform S3 how long the URL should
   *   work for.
   * @option params Expires [Integer] (900) the number of seconds to expire
   *   the pre-signed URL operation in. Defaults to 15 minutes.
   * @param callback [Function] if a callback is provided, this function will
   *   pass the URL as the second parameter (after the error parameter) to
   *   the callback function.
   * @return [String] if called synchronously (with no callback), returns the
   *   signed URL.
   * @return [null] nothing is returned if a callback is provided.
   * @example Pre-signing a getObject operation (synchronously)
   *   var params = {Bucket: 'bucket', Key: 'key'};
   *   var url = s3.getSignedUrl('getObject', params);
   *   console.log('The URL is', url);
   * @example Pre-signing a putObject (asynchronously)
   *   var params = {Bucket: 'bucket', Key: 'key'};
   *   s3.getSignedUrl('putObject', params, function (err, url) {
   *     console.log('The URL is', url);
   *   });
   * @example Pre-signing a putObject operation with a specific payload
   *   var params = {Bucket: 'bucket', Key: 'key', Body: 'body'};
   *   var url = s3.getSignedUrl('putObject', params);
   *   console.log('The URL is', url);
   * @example Passing in a 1-minute expiry time for a pre-signed URL
   *   var params = {Bucket: 'bucket', Key: 'key', Expires: 60};
   *   var url = s3.getSignedUrl('getObject', params);
   *   console.log('The URL is', url); // expires in 60 seconds
   */ getSignedUrl: function getSignedUrl(operation, params, callback) {
        params = $dbC7k.util.copy(params || {});
        var expires = params.Expires || 900;
        if (typeof expires !== "number") throw $dbC7k.util.error(new Error(), {
            code: "InvalidParameterException",
            message: "The expiration must be a number, received " + typeof expires
        });
        delete params.Expires; // we can't validate this
        var request = this.makeRequest(operation, params);
        if (callback) $dbC7k.util.defer(function() {
            request.presign(expires, callback);
        });
        else return request.presign(expires, callback);
    },
    /**
   * Get a pre-signed POST policy to support uploading to S3 directly from an
   * HTML form.
   *
   * @param params [map]
   * @option params Bucket [String]     The bucket to which the post should be
   *                                    uploaded
   * @option params Expires [Integer]   (3600) The number of seconds for which
   *                                    the presigned policy should be valid.
   * @option params Conditions [Array]  An array of conditions that must be met
   *                                    for the presigned policy to allow the
   *                                    upload. This can include required tags,
   *                                    the accepted range for content lengths,
   *                                    etc.
   * @see http://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-HTTPPOSTConstructPolicy.html
   * @option params Fields [map]        Fields to include in the form. All
   *                                    values passed in as fields will be
   *                                    signed as exact match conditions.
   * @param callback [Function]
   *
   * @note All fields passed in when creating presigned post data will be signed
   *   as exact match conditions. Any fields that will be interpolated by S3
   *   must be added to the fields hash after signing, and an appropriate
   *   condition for such fields must be explicitly added to the Conditions
   *   array passed to this function before signing.
   *
   * @example Presiging post data with a known key
   *   var params = {
   *     Bucket: 'bucket',
   *     Fields: {
   *       key: 'key'
   *     }
   *   };
   *   s3.createPresignedPost(params, function(err, data) {
   *     if (err) {
   *       console.error('Presigning post data encountered an error', err);
   *     } else {
   *       console.log('The post data is', data);
   *     }
   *   });
   *
   * @example Presigning post data with an interpolated key
   *   var params = {
   *     Bucket: 'bucket',
   *     Conditions: [
   *       ['starts-with', '$key', 'path/to/uploads/']
   *     ]
   *   };
   *   s3.createPresignedPost(params, function(err, data) {
   *     if (err) {
   *       console.error('Presigning post data encountered an error', err);
   *     } else {
   *       data.Fields.key = 'path/to/uploads/${filename}';
   *       console.log('The post data is', data);
   *     }
   *   });
   *
   * @note You must ensure that you have static or previously resolved
   *   credentials if you call this method synchronously (with no callback),
   *   otherwise it may not properly sign the request. If you cannot guarantee
   *   this (you are using an asynchronous credential provider, i.e., EC2
   *   IAM roles), you should always call this method with an asynchronous
   *   callback.
   *
   * @return [map]  If called synchronously (with no callback), returns a hash
   *                with the url to set as the form action and a hash of fields
   *                to include in the form.
   * @return [null] Nothing is returned if a callback is provided.
   *
   * @callback callback function (err, data)
   *  @param err [Error] the error object returned from the policy signer
   *  @param data [map] The data necessary to construct an HTML form
   *  @param data.url [String] The URL to use as the action of the form
   *  @param data.fields [map] A hash of fields that must be included in the
   *                           form for the upload to succeed. This hash will
   *                           include the signed POST policy, your access key
   *                           ID and security token (if present), etc. These
   *                           may be safely included as input elements of type
   *                           'hidden.'
   */ createPresignedPost: function createPresignedPost(params, callback) {
        if (typeof params === "function" && callback === undefined) {
            callback = params;
            params = null;
        }
        params = $dbC7k.util.copy(params || {});
        var boundParams = this.config.params || {};
        var bucket = params.Bucket || boundParams.Bucket, self = this, config = this.config, endpoint = $dbC7k.util.copy(this.endpoint);
        if (!config.s3BucketEndpoint) endpoint.pathname = "/" + bucket;
        function finalizePost() {
            return {
                url: $dbC7k.util.urlFormat(endpoint),
                fields: self.preparePostFields(config.credentials, config.region, bucket, params.Fields, params.Conditions, params.Expires)
            };
        }
        if (callback) config.getCredentials(function(err) {
            if (err) callback(err);
            callback(null, finalizePost());
        });
        else return finalizePost();
    },
    /**
   * @api private
   */ preparePostFields: function preparePostFields(credentials, region, bucket, fields, conditions, expiresInSeconds) {
        var now = this.getSkewCorrectedDate();
        if (!credentials || !region || !bucket) throw new Error("Unable to create a POST object policy without a bucket, region, and credentials");
        fields = $dbC7k.util.copy(fields || {});
        conditions = (conditions || []).slice(0);
        expiresInSeconds = expiresInSeconds || 3600;
        var signingDate = $dbC7k.util.date.iso8601(now).replace(/[:\-]|\.\d{3}/g, "");
        var shortDate = signingDate.substr(0, 8);
        var scope = $3SbtQ.createScope(shortDate, region, "s3");
        var credential = credentials.accessKeyId + "/" + scope;
        fields["bucket"] = bucket;
        fields["X-Amz-Algorithm"] = "AWS4-HMAC-SHA256";
        fields["X-Amz-Credential"] = credential;
        fields["X-Amz-Date"] = signingDate;
        if (credentials.sessionToken) fields["X-Amz-Security-Token"] = credentials.sessionToken;
        for(var field in fields)if (fields.hasOwnProperty(field)) {
            var condition = {};
            condition[field] = fields[field];
            conditions.push(condition);
        }
        fields.Policy = this.preparePostPolicy(new Date(now.valueOf() + expiresInSeconds * 1000), conditions);
        fields["X-Amz-Signature"] = $dbC7k.util.crypto.hmac($3SbtQ.getSigningKey(credentials, shortDate, region, "s3", true), fields.Policy, "hex");
        return fields;
    },
    /**
   * @api private
   */ preparePostPolicy: function preparePostPolicy(expiration, conditions) {
        return $dbC7k.util.base64.encode(JSON.stringify({
            expiration: $dbC7k.util.date.iso8601(expiration),
            conditions: conditions
        }));
    },
    /**
   * @api private
   */ prepareSignedUrl: function prepareSignedUrl(request) {
        request.addListener("validate", request.service.noPresignedContentLength);
        request.removeListener("build", request.service.addContentType);
        if (!request.params.Body) // no Content-MD5/SHA-256 if body is not provided
        request.removeListener("build", request.service.computeContentMd5);
        else request.addListener("afterBuild", $dbC7k.EventListeners.Core.COMPUTE_SHA256);
    },
    /**
   * @api private
   * @param request
   */ disableBodySigning: function disableBodySigning(request) {
        var headers = request.httpRequest.headers;
        // Add the header to anything that isn't a presigned url, unless that presigned url had a body defined
        if (!Object.prototype.hasOwnProperty.call(headers, "presigned-expires")) headers["X-Amz-Content-Sha256"] = "UNSIGNED-PAYLOAD";
    },
    /**
   * @api private
   */ noPresignedContentLength: function noPresignedContentLength(request) {
        if (request.params.ContentLength !== undefined) throw $dbC7k.util.error(new Error(), {
            code: "UnexpectedParameter",
            message: "ContentLength is not supported in pre-signed URLs."
        });
    },
    createBucket: function createBucket(params, callback) {
        // When creating a bucket *outside* the classic region, the location
        // constraint must be set for the bucket and it must match the endpoint.
        // This chunk of code will set the location constraint param based
        // on the region (when possible), but it will not override a passed-in
        // location constraint.
        if (typeof params === "function" || !params) {
            callback = callback || params;
            params = {};
        }
        var hostname = this.endpoint.hostname;
        if (hostname !== this.api.globalEndpoint && !params.CreateBucketConfiguration) params.CreateBucketConfiguration = {
            LocationConstraint: this.config.region
        };
        return this.makeRequest("createBucket", params, callback);
    },
    /**
   * @see AWS.S3.ManagedUpload
   * @overload upload(params = {}, [options], [callback])
   *   Uploads an arbitrarily sized buffer, blob, or stream, using intelligent
   *   concurrent handling of parts if the payload is large enough. You can
   *   configure the concurrent queue size by setting `options`. Note that this
   *   is the only operation for which the SDK can retry requests with stream
   *   bodies.
   *
   *   @param (see AWS.S3.putObject)
   *   @option (see AWS.S3.ManagedUpload.constructor)
   *   @return [AWS.S3.ManagedUpload] the managed upload object that can call
   *     `send()` or track progress.
   *   @example Uploading a stream object
   *     var params = {Bucket: 'bucket', Key: 'key', Body: stream};
   *     s3.upload(params, function(err, data) {
   *       console.log(err, data);
   *     });
   *   @example Uploading a stream with concurrency of 1 and partSize of 10mb
   *     var params = {Bucket: 'bucket', Key: 'key', Body: stream};
   *     var options = {partSize: 10 * 1024 * 1024, queueSize: 1};
   *     s3.upload(params, options, function(err, data) {
   *       console.log(err, data);
   *     });
   * @callback callback function(err, data)
   *   @param err [Error] an error or null if no error occurred.
   *   @param data [map] The response data from the successful upload:
   *   @param data.Location [String] the URL of the uploaded object
   *   @param data.ETag [String] the ETag of the uploaded object
   *   @param data.Bucket [String]  the bucket to which the object was uploaded
   *   @param data.Key [String] the key to which the object was uploaded
   */ upload: function upload(params, options, callback) {
        if (typeof options === "function" && callback === undefined) {
            callback = options;
            options = null;
        }
        options = options || {};
        options = $dbC7k.util.merge(options || {}, {
            service: this,
            params: params
        });
        var uploader = new $dbC7k.S3.ManagedUpload(options);
        if (typeof callback === "function") uploader.send(callback);
        return uploader;
    }
});

});
parcelRequire.register("iOS2j", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
var $db36cffe51cc5655$var$byteLength = $dbC7k.util.string.byteLength;
var $db36cffe51cc5655$var$Buffer = $dbC7k.util.Buffer;
/**
 * The managed uploader allows for easy and efficient uploading of buffers,
 * blobs, or streams, using a configurable amount of concurrency to perform
 * multipart uploads where possible. This abstraction also enables uploading
 * streams of unknown size due to the use of multipart uploads.
 *
 * To construct a managed upload object, see the {constructor} function.
 *
 * ## Tracking upload progress
 *
 * The managed upload object can also track progress by attaching an
 * 'httpUploadProgress' listener to the upload manager. This event is similar
 * to {AWS.Request~httpUploadProgress} but groups all concurrent upload progress
 * into a single event. See {AWS.S3.ManagedUpload~httpUploadProgress} for more
 * information.
 *
 * ## Handling Multipart Cleanup
 *
 * By default, this class will automatically clean up any multipart uploads
 * when an individual part upload fails. This behavior can be disabled in order
 * to manually handle failures by setting the `leavePartsOnError` configuration
 * option to `true` when initializing the upload object.
 *
 * @!event httpUploadProgress(progress)
 *   Triggered when the uploader has uploaded more data.
 *   @note The `total` property may not be set if the stream being uploaded has
 *     not yet finished chunking. In this case the `total` will be undefined
 *     until the total stream size is known.
 *   @note This event will not be emitted in Node.js 0.8.x.
 *   @param progress [map] An object containing the `loaded` and `total` bytes
 *     of the request and the `key` of the S3 object. Note that `total` may be undefined until the payload
 *     size is known.
 *   @context (see AWS.Request~send)
 */ $dbC7k.S3.ManagedUpload = $dbC7k.util.inherit({
    /**
   * Creates a managed upload object with a set of configuration options.
   *
   * @note A "Body" parameter is required to be set prior to calling {send}.
   * @note In Node.js, sending "Body" as {https://nodejs.org/dist/latest/docs/api/stream.html#stream_object_mode object-mode stream}
   *   may result in upload hangs. Using buffer stream is preferable.
   * @option options params [map] a map of parameters to pass to the upload
   *   requests. The "Body" parameter is required to be specified either on
   *   the service or in the params option.
   * @note ContentMD5 should not be provided when using the managed upload object.
   *   Instead, setting "computeChecksums" to true will enable automatic ContentMD5 generation
   *   by the managed upload object.
   * @option options queueSize [Number] (4) the size of the concurrent queue
   *   manager to upload parts in parallel. Set to 1 for synchronous uploading
   *   of parts. Note that the uploader will buffer at most queueSize * partSize
   *   bytes into memory at any given time.
   * @option options partSize [Number] (5mb) the size in bytes for each
   *   individual part to be uploaded. Adjust the part size to ensure the number
   *   of parts does not exceed {maxTotalParts}. See {minPartSize} for the
   *   minimum allowed part size.
   * @option options leavePartsOnError [Boolean] (false) whether to abort the
   *   multipart upload if an error occurs. Set to true if you want to handle
   *   failures manually.
   * @option options service [AWS.S3] an optional S3 service object to use for
   *   requests. This object might have bound parameters used by the uploader.
   * @option options tags [Array<map>] The tags to apply to the uploaded object.
   *   Each tag should have a `Key` and `Value` keys.
   * @example Creating a default uploader for a stream object
   *   var upload = new AWS.S3.ManagedUpload({
   *     params: {Bucket: 'bucket', Key: 'key', Body: stream}
   *   });
   * @example Creating an uploader with concurrency of 1 and partSize of 10mb
   *   var upload = new AWS.S3.ManagedUpload({
   *     partSize: 10 * 1024 * 1024, queueSize: 1,
   *     params: {Bucket: 'bucket', Key: 'key', Body: stream}
   *   });
   * @example Creating an uploader with tags
   *   var upload = new AWS.S3.ManagedUpload({
   *     params: {Bucket: 'bucket', Key: 'key', Body: stream},
   *     tags: [{Key: 'tag1', Value: 'value1'}, {Key: 'tag2', Value: 'value2'}]
   *   });
   * @see send
   */ constructor: function ManagedUpload(options) {
        var self = this;
        $dbC7k.SequentialExecutor.call(self);
        self.body = null;
        self.sliceFn = null;
        self.callback = null;
        self.parts = {};
        self.completeInfo = [];
        self.fillQueue = function() {
            self.callback(new Error("Unsupported body payload " + typeof self.body));
        };
        self.configure(options);
    },
    /**
   * @api private
   */ configure: function configure(options) {
        options = options || {};
        this.partSize = this.minPartSize;
        if (options.queueSize) this.queueSize = options.queueSize;
        if (options.partSize) this.partSize = options.partSize;
        if (options.leavePartsOnError) this.leavePartsOnError = true;
        if (options.tags) {
            if (!Array.isArray(options.tags)) throw new Error("Tags must be specified as an array; " + typeof options.tags + " provided.");
            this.tags = options.tags;
        }
        if (this.partSize < this.minPartSize) throw new Error("partSize must be greater than " + this.minPartSize);
        this.service = options.service;
        this.bindServiceObject(options.params);
        this.validateBody();
        this.adjustTotalBytes();
    },
    /**
   * @api private
   */ leavePartsOnError: false,
    /**
   * @api private
   */ queueSize: 4,
    /**
   * @api private
   */ partSize: null,
    /**
   * @readonly
   * @return [Number] the minimum number of bytes for an individual part
   *   upload.
   */ minPartSize: 5242880,
    /**
   * @readonly
   * @return [Number] the maximum allowed number of parts in a multipart upload.
   */ maxTotalParts: 10000,
    /**
   * Initiates the managed upload for the payload.
   *
   * @callback callback function(err, data)
   *   @param err [Error] an error or null if no error occurred.
   *   @param data [map] The response data from the successful upload:
   *     * `Location` (String) the URL of the uploaded object
   *     * `ETag` (String) the ETag of the uploaded object
   *     * `Bucket` (String) the bucket to which the object was uploaded
   *     * `Key` (String) the key to which the object was uploaded
   * @example Sending a managed upload object
   *   var params = {Bucket: 'bucket', Key: 'key', Body: stream};
   *   var upload = new AWS.S3.ManagedUpload({params: params});
   *   upload.send(function(err, data) {
   *     console.log(err, data);
   *   });
   */ send: function(callback) {
        var self = this;
        self.failed = false;
        self.callback = callback || function(err) {
            if (err) throw err;
        };
        var runFill = true;
        if (self.sliceFn) self.fillQueue = self.fillBuffer;
        else if ($dbC7k.util.isNode()) {
            var Stream = $dbC7k.util.stream.Stream;
            if (self.body instanceof Stream) {
                runFill = false;
                self.fillQueue = self.fillStream;
                self.partBuffers = [];
                self.body.on("error", function(err) {
                    self.cleanup(err);
                }).on("readable", function() {
                    self.fillQueue();
                }).on("end", function() {
                    self.isDoneChunking = true;
                    self.numParts = self.totalPartNumbers;
                    self.fillQueue.call(self);
                    if (self.isDoneChunking && self.totalPartNumbers >= 1 && self.doneParts === self.numParts) self.finishMultiPart();
                });
            }
        }
        if (runFill) self.fillQueue.call(self);
    },
    /**
   * @!method  promise()
   *   Returns a 'thenable' promise.
   *
   *   Two callbacks can be provided to the `then` method on the returned promise.
   *   The first callback will be called if the promise is fulfilled, and the second
   *   callback will be called if the promise is rejected.
   *   @callback fulfilledCallback function(data)
   *     Called if the promise is fulfilled.
   *     @param data [map] The response data from the successful upload:
   *       `Location` (String) the URL of the uploaded object
   *       `ETag` (String) the ETag of the uploaded object
   *       `Bucket` (String) the bucket to which the object was uploaded
   *       `Key` (String) the key to which the object was uploaded
   *   @callback rejectedCallback function(err)
   *     Called if the promise is rejected.
   *     @param err [Error] an error or null if no error occurred.
   *   @return [Promise] A promise that represents the state of the upload request.
   *   @example Sending an upload request using promises.
   *     var upload = s3.upload({Bucket: 'bucket', Key: 'key', Body: stream});
   *     var promise = upload.promise();
   *     promise.then(function(data) { ... }, function(err) { ... });
   */ /**
   * Aborts a managed upload, including all concurrent upload requests.
   * @note By default, calling this function will cleanup a multipart upload
   *   if one was created. To leave the multipart upload around after aborting
   *   a request, configure `leavePartsOnError` to `true` in the {constructor}.
   * @note Calling {abort} in the browser environment will not abort any requests
   *   that are already in flight. If a multipart upload was created, any parts
   *   not yet uploaded will not be sent, and the multipart upload will be cleaned up.
   * @example Aborting an upload
   *   var params = {
   *     Bucket: 'bucket', Key: 'key',
   *     Body: Buffer.alloc(1024 * 1024 * 25) // 25MB payload
   *   };
   *   var upload = s3.upload(params);
   *   upload.send(function (err, data) {
   *     if (err) console.log("Error:", err.code, err.message);
   *     else console.log(data);
   *   });
   *
   *   // abort request in 1 second
   *   setTimeout(upload.abort.bind(upload), 1000);
   */ abort: function() {
        var self = this;
        //abort putObject request
        if (self.isDoneChunking === true && self.totalPartNumbers === 1 && self.singlePart) self.singlePart.abort();
        else self.cleanup($dbC7k.util.error(new Error("Request aborted by user"), {
            code: "RequestAbortedError",
            retryable: false
        }));
    },
    /**
   * @api private
   */ validateBody: function validateBody() {
        var self = this;
        self.body = self.service.config.params.Body;
        if (typeof self.body === "string") self.body = $dbC7k.util.buffer.toBuffer(self.body);
        else if (!self.body) throw new Error("params.Body is required");
        self.sliceFn = $dbC7k.util.arraySliceFn(self.body);
    },
    /**
   * @api private
   */ bindServiceObject: function bindServiceObject(params) {
        params = params || {};
        var self = this;
        // bind parameters to new service object
        if (!self.service) self.service = new $dbC7k.S3({
            params: params
        });
        else {
            var service = self.service;
            var config = $dbC7k.util.copy(service.config);
            config.signatureVersion = service.getSignatureVersion();
            self.service = new service.constructor.__super__(config);
            self.service.config.params = $dbC7k.util.merge(self.service.config.params || {}, params);
        }
    },
    /**
   * @api private
   */ adjustTotalBytes: function adjustTotalBytes() {
        var self = this;
        try {
            self.totalBytes = $db36cffe51cc5655$var$byteLength(self.body);
        } catch (e) {}
        // try to adjust partSize if we know payload length
        if (self.totalBytes) {
            var newPartSize = Math.ceil(self.totalBytes / self.maxTotalParts);
            if (newPartSize > self.partSize) self.partSize = newPartSize;
        } else self.totalBytes = undefined;
    },
    /**
   * @api private
   */ isDoneChunking: false,
    /**
   * @api private
   */ partPos: 0,
    /**
   * @api private
   */ totalChunkedBytes: 0,
    /**
   * @api private
   */ totalUploadedBytes: 0,
    /**
   * @api private
   */ totalBytes: undefined,
    /**
   * @api private
   */ numParts: 0,
    /**
   * @api private
   */ totalPartNumbers: 0,
    /**
   * @api private
   */ activeParts: 0,
    /**
   * @api private
   */ doneParts: 0,
    /**
   * @api private
   */ parts: null,
    /**
   * @api private
   */ completeInfo: null,
    /**
   * @api private
   */ failed: false,
    /**
   * @api private
   */ multipartReq: null,
    /**
   * @api private
   */ partBuffers: null,
    /**
   * @api private
   */ partBufferLength: 0,
    /**
   * @api private
   */ fillBuffer: function fillBuffer() {
        var self = this;
        var bodyLen = $db36cffe51cc5655$var$byteLength(self.body);
        if (bodyLen === 0) {
            self.isDoneChunking = true;
            self.numParts = 1;
            self.nextChunk(self.body);
            return;
        }
        while(self.activeParts < self.queueSize && self.partPos < bodyLen){
            var endPos = Math.min(self.partPos + self.partSize, bodyLen);
            var buf = self.sliceFn.call(self.body, self.partPos, endPos);
            self.partPos += self.partSize;
            if ($db36cffe51cc5655$var$byteLength(buf) < self.partSize || self.partPos === bodyLen) {
                self.isDoneChunking = true;
                self.numParts = self.totalPartNumbers + 1;
            }
            self.nextChunk(buf);
        }
    },
    /**
   * @api private
   */ fillStream: function fillStream() {
        var self = this;
        if (self.activeParts >= self.queueSize) return;
        var buf = self.body.read(self.partSize - self.partBufferLength) || self.body.read();
        if (buf) {
            self.partBuffers.push(buf);
            self.partBufferLength += buf.length;
            self.totalChunkedBytes += buf.length;
        }
        if (self.partBufferLength >= self.partSize) {
            // if we have single buffer we avoid copyfull concat
            var pbuf = self.partBuffers.length === 1 ? self.partBuffers[0] : $db36cffe51cc5655$var$Buffer.concat(self.partBuffers);
            self.partBuffers = [];
            self.partBufferLength = 0;
            // if we have more than partSize, push the rest back on the queue
            if (pbuf.length > self.partSize) {
                var rest = pbuf.slice(self.partSize);
                self.partBuffers.push(rest);
                self.partBufferLength += rest.length;
                pbuf = pbuf.slice(0, self.partSize);
            }
            self.nextChunk(pbuf);
        }
        if (self.isDoneChunking && !self.isDoneSending) {
            // if we have single buffer we avoid copyfull concat
            pbuf = self.partBuffers.length === 1 ? self.partBuffers[0] : $db36cffe51cc5655$var$Buffer.concat(self.partBuffers);
            self.partBuffers = [];
            self.partBufferLength = 0;
            self.totalBytes = self.totalChunkedBytes;
            self.isDoneSending = true;
            if (self.numParts === 0 || pbuf.length > 0) {
                self.numParts++;
                self.nextChunk(pbuf);
            }
        }
        self.body.read(0);
    },
    /**
   * @api private
   */ nextChunk: function nextChunk(chunk) {
        var self = this;
        if (self.failed) return null;
        var partNumber = ++self.totalPartNumbers;
        if (self.isDoneChunking && partNumber === 1) {
            var params = {
                Body: chunk
            };
            if (this.tags) params.Tagging = this.getTaggingHeader();
            var req = self.service.putObject(params);
            req._managedUpload = self;
            req.on("httpUploadProgress", self.progress).send(self.finishSinglePart);
            self.singlePart = req; //save the single part request
            return null;
        } else if (self.service.config.params.ContentMD5) {
            var err = $dbC7k.util.error(new Error("The Content-MD5 you specified is invalid for multi-part uploads."), {
                code: "InvalidDigest",
                retryable: false
            });
            self.cleanup(err);
            return null;
        }
        if (self.completeInfo[partNumber] && self.completeInfo[partNumber].ETag !== null) return null; // Already uploaded this part.
        self.activeParts++;
        if (!self.service.config.params.UploadId) {
            if (!self.multipartReq) {
                self.multipartReq = self.service.createMultipartUpload();
                self.multipartReq.on("success", function(resp) {
                    self.service.config.params.UploadId = resp.data.UploadId;
                    self.multipartReq = null;
                });
                self.queueChunks(chunk, partNumber);
                self.multipartReq.on("error", function(err) {
                    self.cleanup(err);
                });
                self.multipartReq.send();
            } else self.queueChunks(chunk, partNumber);
        } else self.uploadPart(chunk, partNumber);
    },
    /**
   * @api private
   */ getTaggingHeader: function getTaggingHeader() {
        var kvPairStrings = [];
        for(var i = 0; i < this.tags.length; i++)kvPairStrings.push($dbC7k.util.uriEscape(this.tags[i].Key) + "=" + $dbC7k.util.uriEscape(this.tags[i].Value));
        return kvPairStrings.join("&");
    },
    /**
   * @api private
   */ uploadPart: function uploadPart(chunk, partNumber) {
        var self = this;
        var partParams = {
            Body: chunk,
            ContentLength: $dbC7k.util.string.byteLength(chunk),
            PartNumber: partNumber
        };
        var partInfo = {
            ETag: null,
            PartNumber: partNumber
        };
        self.completeInfo[partNumber] = partInfo;
        var req = self.service.uploadPart(partParams);
        self.parts[partNumber] = req;
        req._lastUploadedBytes = 0;
        req._managedUpload = self;
        req.on("httpUploadProgress", self.progress);
        req.send(function(err, data) {
            delete self.parts[partParams.PartNumber];
            self.activeParts--;
            if (!err && (!data || !data.ETag)) {
                var message = "No access to ETag property on response.";
                if ($dbC7k.util.isBrowser()) message += " Check CORS configuration to expose ETag header.";
                err = $dbC7k.util.error(new Error(message), {
                    code: "ETagMissing",
                    retryable: false
                });
            }
            if (err) return self.cleanup(err);
            //prevent sending part being returned twice (https://github.com/aws/aws-sdk-js/issues/2304)
            if (self.completeInfo[partNumber] && self.completeInfo[partNumber].ETag !== null) return null;
            partInfo.ETag = data.ETag;
            self.doneParts++;
            if (self.isDoneChunking && self.doneParts === self.numParts) self.finishMultiPart();
            else self.fillQueue.call(self);
        });
    },
    /**
   * @api private
   */ queueChunks: function queueChunks(chunk, partNumber) {
        var self = this;
        self.multipartReq.on("success", function() {
            self.uploadPart(chunk, partNumber);
        });
    },
    /**
   * @api private
   */ cleanup: function cleanup(err) {
        var self = this;
        if (self.failed) return;
        // clean up stream
        if (typeof self.body.removeAllListeners === "function" && typeof self.body.resume === "function") {
            self.body.removeAllListeners("readable");
            self.body.removeAllListeners("end");
            self.body.resume();
        }
        // cleanup multipartReq listeners
        if (self.multipartReq) {
            self.multipartReq.removeAllListeners("success");
            self.multipartReq.removeAllListeners("error");
            self.multipartReq.removeAllListeners("complete");
            delete self.multipartReq;
        }
        if (self.service.config.params.UploadId && !self.leavePartsOnError) self.service.abortMultipartUpload().send();
        else if (self.leavePartsOnError) self.isDoneChunking = false;
        $dbC7k.util.each(self.parts, function(partNumber, part) {
            part.removeAllListeners("complete");
            part.abort();
        });
        self.activeParts = 0;
        self.partPos = 0;
        self.numParts = 0;
        self.totalPartNumbers = 0;
        self.parts = {};
        self.failed = true;
        self.callback(err);
    },
    /**
   * @api private
   */ finishMultiPart: function finishMultiPart() {
        var self = this;
        var completeParams = {
            MultipartUpload: {
                Parts: self.completeInfo.slice(1)
            }
        };
        self.service.completeMultipartUpload(completeParams, function(err, data) {
            if (err) return self.cleanup(err);
            if (data && typeof data.Location === "string") data.Location = data.Location.replace(/%2F/g, "/");
            if (Array.isArray(self.tags)) {
                for(var i = 0; i < self.tags.length; i++)self.tags[i].Value = String(self.tags[i].Value);
                self.service.putObjectTagging({
                    Tagging: {
                        TagSet: self.tags
                    }
                }, function(e, d) {
                    if (e) self.callback(e);
                    else self.callback(e, data);
                });
            } else self.callback(err, data);
        });
    },
    /**
   * @api private
   */ finishSinglePart: function finishSinglePart(err, data) {
        var upload = this.request._managedUpload;
        var httpReq = this.request.httpRequest;
        var endpoint = httpReq.endpoint;
        if (err) return upload.callback(err);
        data.Location = [
            endpoint.protocol,
            "//",
            endpoint.host,
            httpReq.path
        ].join("");
        data.key = this.request.params.Key; // will stay undocumented
        data.Key = this.request.params.Key;
        data.Bucket = this.request.params.Bucket;
        upload.callback(err, data);
    },
    /**
   * @api private
   */ progress: function progress(info) {
        var upload = this._managedUpload;
        if (this.operation === "putObject") {
            info.part = 1;
            info.key = this.params.Key;
        } else {
            upload.totalUploadedBytes += info.loaded - this._lastUploadedBytes;
            this._lastUploadedBytes = info.loaded;
            info = {
                loaded: upload.totalUploadedBytes,
                total: upload.totalBytes,
                part: this.params.PartNumber,
                key: this.params.Key
            };
        }
        upload.emit("httpUploadProgress", [
            info
        ]);
    }
});
$dbC7k.util.mixin($dbC7k.S3.ManagedUpload, $dbC7k.SequentialExecutor);
/**
 * @api private
 */ $dbC7k.S3.ManagedUpload.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
    this.prototype.promise = $dbC7k.util.promisifyMethod("send", PromiseDependency);
};
/**
 * @api private
 */ $dbC7k.S3.ManagedUpload.deletePromisesFromClass = function deletePromisesFromClass() {
    delete this.prototype.promise;
};
$dbC7k.util.addPromises($dbC7k.S3.ManagedUpload);
/**
 * @api private
 */ module.exports = $dbC7k.S3.ManagedUpload;

});


parcelRequire.register("25nQG", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2006-03-01","checksumFormat":"md5","endpointPrefix":"s3","globalEndpoint":"s3.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"Amazon S3","serviceFullName":"Amazon Simple Storage Service","serviceId":"S3","signatureVersion":"s3","uid":"s3-2006-03-01"},"operations":{"AbortMultipartUpload":{"http":{"method":"DELETE","requestUri":"/{Bucket}/{Key+}","responseCode":204},"input":{"type":"structure","required":["Bucket","Key","UploadId"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"UploadId":{"location":"querystring","locationName":"uploadId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"CompleteMultipartUpload":{"http":{"requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key","UploadId"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"MultipartUpload":{"locationName":"CompleteMultipartUpload","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"Parts":{"locationName":"Part","type":"list","member":{"type":"structure","members":{"ETag":{},"PartNumber":{"type":"integer"}}},"flattened":true}}},"UploadId":{"location":"querystring","locationName":"uploadId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}},"payload":"MultipartUpload"},"output":{"type":"structure","members":{"Location":{},"Bucket":{},"Key":{},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"ETag":{},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"CopyObject":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","CopySource","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Bucket":{"location":"uri","locationName":"Bucket"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentType":{"location":"header","locationName":"Content-Type"},"CopySource":{"location":"header","locationName":"x-amz-copy-source"},"CopySourceIfMatch":{"location":"header","locationName":"x-amz-copy-source-if-match"},"CopySourceIfModifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-modified-since","type":"timestamp"},"CopySourceIfNoneMatch":{"location":"header","locationName":"x-amz-copy-source-if-none-match"},"CopySourceIfUnmodifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-unmodified-since","type":"timestamp"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"location":"uri","locationName":"Key"},"Metadata":{"shape":"S11","location":"headers","locationName":"x-amz-meta-"},"MetadataDirective":{"location":"header","locationName":"x-amz-metadata-directive"},"TaggingDirective":{"location":"header","locationName":"x-amz-tagging-directive"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1b","location":"header","locationName":"x-amz-server-side-encryption-context"},"CopySourceSSECustomerAlgorithm":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-algorithm"},"CopySourceSSECustomerKey":{"shape":"S1d","location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key"},"CopySourceSSECustomerKeyMD5":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Tagging":{"location":"header","locationName":"x-amz-tagging"},"ObjectLockMode":{"location":"header","locationName":"x-amz-object-lock-mode"},"ObjectLockRetainUntilDate":{"shape":"S1h","location":"header","locationName":"x-amz-object-lock-retain-until-date"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-object-lock-legal-hold"}}},"output":{"type":"structure","members":{"CopyObjectResult":{"type":"structure","members":{"ETag":{},"LastModified":{"type":"timestamp"}}},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"CopySourceVersionId":{"location":"header","locationName":"x-amz-copy-source-version-id"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1b","location":"header","locationName":"x-amz-server-side-encryption-context"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}},"payload":"CopyObjectResult"},"alias":"PutObjectCopy"},"CreateBucket":{"http":{"method":"PUT","requestUri":"/{Bucket}"},"input":{"type":"structure","required":["Bucket"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Bucket":{"location":"uri","locationName":"Bucket"},"CreateBucketConfiguration":{"locationName":"CreateBucketConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"LocationConstraint":{}}},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWrite":{"location":"header","locationName":"x-amz-grant-write"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"ObjectLockEnabledForBucket":{"location":"header","locationName":"x-amz-bucket-object-lock-enabled","type":"boolean"}},"payload":"CreateBucketConfiguration"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"}}},"alias":"PutBucket"},"CreateMultipartUpload":{"http":{"requestUri":"/{Bucket}/{Key+}?uploads"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Bucket":{"location":"uri","locationName":"Bucket"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"location":"uri","locationName":"Key"},"Metadata":{"shape":"S11","location":"headers","locationName":"x-amz-meta-"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1b","location":"header","locationName":"x-amz-server-side-encryption-context"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Tagging":{"location":"header","locationName":"x-amz-tagging"},"ObjectLockMode":{"location":"header","locationName":"x-amz-object-lock-mode"},"ObjectLockRetainUntilDate":{"shape":"S1h","location":"header","locationName":"x-amz-object-lock-retain-until-date"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-object-lock-legal-hold"}}},"output":{"type":"structure","members":{"AbortDate":{"location":"header","locationName":"x-amz-abort-date","type":"timestamp"},"AbortRuleId":{"location":"header","locationName":"x-amz-abort-rule-id"},"Bucket":{"locationName":"Bucket"},"Key":{},"UploadId":{},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1b","location":"header","locationName":"x-amz-server-side-encryption-context"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"alias":"InitiateMultipartUpload"},"DeleteBucket":{"http":{"method":"DELETE","requestUri":"/{Bucket}","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketAnalyticsConfiguration":{"http":{"method":"DELETE","requestUri":"/{Bucket}?analytics","responseCode":204},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}}},"DeleteBucketCors":{"http":{"method":"DELETE","requestUri":"/{Bucket}?cors","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketEncryption":{"http":{"method":"DELETE","requestUri":"/{Bucket}?encryption","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketInventoryConfiguration":{"http":{"method":"DELETE","requestUri":"/{Bucket}?inventory","responseCode":204},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}}},"DeleteBucketLifecycle":{"http":{"method":"DELETE","requestUri":"/{Bucket}?lifecycle","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketMetricsConfiguration":{"http":{"method":"DELETE","requestUri":"/{Bucket}?metrics","responseCode":204},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}}},"DeleteBucketPolicy":{"http":{"method":"DELETE","requestUri":"/{Bucket}?policy","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketReplication":{"http":{"method":"DELETE","requestUri":"/{Bucket}?replication","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketTagging":{"http":{"method":"DELETE","requestUri":"/{Bucket}?tagging","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteBucketWebsite":{"http":{"method":"DELETE","requestUri":"/{Bucket}?website","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"DeleteObject":{"http":{"method":"DELETE","requestUri":"/{Bucket}/{Key+}","responseCode":204},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"MFA":{"location":"header","locationName":"x-amz-mfa"},"VersionId":{"location":"querystring","locationName":"versionId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"BypassGovernanceRetention":{"location":"header","locationName":"x-amz-bypass-governance-retention","type":"boolean"}}},"output":{"type":"structure","members":{"DeleteMarker":{"location":"header","locationName":"x-amz-delete-marker","type":"boolean"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"DeleteObjectTagging":{"http":{"method":"DELETE","requestUri":"/{Bucket}/{Key+}?tagging","responseCode":204},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"}}},"output":{"type":"structure","members":{"VersionId":{"location":"header","locationName":"x-amz-version-id"}}}},"DeleteObjects":{"http":{"requestUri":"/{Bucket}?delete"},"input":{"type":"structure","required":["Bucket","Delete"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delete":{"locationName":"Delete","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Objects"],"members":{"Objects":{"locationName":"Object","type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"VersionId":{}}},"flattened":true},"Quiet":{"type":"boolean"}}},"MFA":{"location":"header","locationName":"x-amz-mfa"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"BypassGovernanceRetention":{"location":"header","locationName":"x-amz-bypass-governance-retention","type":"boolean"}},"payload":"Delete"},"output":{"type":"structure","members":{"Deleted":{"type":"list","member":{"type":"structure","members":{"Key":{},"VersionId":{},"DeleteMarker":{"type":"boolean"},"DeleteMarkerVersionId":{}}},"flattened":true},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"Errors":{"locationName":"Error","type":"list","member":{"type":"structure","members":{"Key":{},"VersionId":{},"Code":{},"Message":{}}},"flattened":true}}},"alias":"DeleteMultipleObjects"},"DeletePublicAccessBlock":{"http":{"method":"DELETE","requestUri":"/{Bucket}?publicAccessBlock","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"GetBucketAccelerateConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?accelerate"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Status":{}}}},"GetBucketAcl":{"http":{"method":"GET","requestUri":"/{Bucket}?acl"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Owner":{"shape":"S32"},"Grants":{"shape":"S35","locationName":"AccessControlList"}}}},"GetBucketAnalyticsConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?analytics"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}},"output":{"type":"structure","members":{"AnalyticsConfiguration":{"shape":"S3e"}},"payload":"AnalyticsConfiguration"}},"GetBucketCors":{"http":{"method":"GET","requestUri":"/{Bucket}?cors"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"CORSRules":{"shape":"S3u","locationName":"CORSRule"}}}},"GetBucketEncryption":{"http":{"method":"GET","requestUri":"/{Bucket}?encryption"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"ServerSideEncryptionConfiguration":{"shape":"S47"}},"payload":"ServerSideEncryptionConfiguration"}},"GetBucketInventoryConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?inventory"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}},"output":{"type":"structure","members":{"InventoryConfiguration":{"shape":"S4d"}},"payload":"InventoryConfiguration"}},"GetBucketLifecycle":{"http":{"method":"GET","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Rules":{"shape":"S4t","locationName":"Rule"}}},"deprecated":true},"GetBucketLifecycleConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Rules":{"shape":"S58","locationName":"Rule"}}}},"GetBucketLocation":{"http":{"method":"GET","requestUri":"/{Bucket}?location"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"LocationConstraint":{}}}},"GetBucketLogging":{"http":{"method":"GET","requestUri":"/{Bucket}?logging"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"LoggingEnabled":{"shape":"S5i"}}}},"GetBucketMetricsConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?metrics"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}},"output":{"type":"structure","members":{"MetricsConfiguration":{"shape":"S5q"}},"payload":"MetricsConfiguration"}},"GetBucketNotification":{"http":{"method":"GET","requestUri":"/{Bucket}?notification"},"input":{"shape":"S5t"},"output":{"shape":"S5u"},"deprecated":true},"GetBucketNotificationConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?notification"},"input":{"shape":"S5t"},"output":{"shape":"S65"}},"GetBucketPolicy":{"http":{"method":"GET","requestUri":"/{Bucket}?policy"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Policy":{}},"payload":"Policy"}},"GetBucketPolicyStatus":{"http":{"method":"GET","requestUri":"/{Bucket}?policyStatus"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"PolicyStatus":{"type":"structure","members":{"IsPublic":{"locationName":"IsPublic","type":"boolean"}}}},"payload":"PolicyStatus"}},"GetBucketReplication":{"http":{"method":"GET","requestUri":"/{Bucket}?replication"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"ReplicationConfiguration":{"shape":"S6s"}},"payload":"ReplicationConfiguration"}},"GetBucketRequestPayment":{"http":{"method":"GET","requestUri":"/{Bucket}?requestPayment"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Payer":{}}}},"GetBucketTagging":{"http":{"method":"GET","requestUri":"/{Bucket}?tagging"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","required":["TagSet"],"members":{"TagSet":{"shape":"S3k"}}}},"GetBucketVersioning":{"http":{"method":"GET","requestUri":"/{Bucket}?versioning"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"Status":{},"MFADelete":{"locationName":"MfaDelete"}}}},"GetBucketWebsite":{"http":{"method":"GET","requestUri":"/{Bucket}?website"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"RedirectAllRequestsTo":{"shape":"S7l"},"IndexDocument":{"shape":"S7o"},"ErrorDocument":{"shape":"S7q"},"RoutingRules":{"shape":"S7r"}}}},"GetObject":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"IfMatch":{"location":"header","locationName":"If-Match"},"IfModifiedSince":{"location":"header","locationName":"If-Modified-Since","type":"timestamp"},"IfNoneMatch":{"location":"header","locationName":"If-None-Match"},"IfUnmodifiedSince":{"location":"header","locationName":"If-Unmodified-Since","type":"timestamp"},"Key":{"location":"uri","locationName":"Key"},"Range":{"location":"header","locationName":"Range"},"ResponseCacheControl":{"location":"querystring","locationName":"response-cache-control"},"ResponseContentDisposition":{"location":"querystring","locationName":"response-content-disposition"},"ResponseContentEncoding":{"location":"querystring","locationName":"response-content-encoding"},"ResponseContentLanguage":{"location":"querystring","locationName":"response-content-language"},"ResponseContentType":{"location":"querystring","locationName":"response-content-type"},"ResponseExpires":{"location":"querystring","locationName":"response-expires","type":"timestamp"},"VersionId":{"location":"querystring","locationName":"versionId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"}}},"output":{"type":"structure","members":{"Body":{"streaming":true,"type":"blob"},"DeleteMarker":{"location":"header","locationName":"x-amz-delete-marker","type":"boolean"},"AcceptRanges":{"location":"header","locationName":"accept-ranges"},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"Restore":{"location":"header","locationName":"x-amz-restore"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ETag":{"location":"header","locationName":"ETag"},"MissingMeta":{"location":"header","locationName":"x-amz-missing-meta","type":"integer"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentRange":{"location":"header","locationName":"Content-Range"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"Metadata":{"shape":"S11","location":"headers","locationName":"x-amz-meta-"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"ReplicationStatus":{"location":"header","locationName":"x-amz-replication-status"},"PartsCount":{"location":"header","locationName":"x-amz-mp-parts-count","type":"integer"},"TagCount":{"location":"header","locationName":"x-amz-tagging-count","type":"integer"},"ObjectLockMode":{"location":"header","locationName":"x-amz-object-lock-mode"},"ObjectLockRetainUntilDate":{"shape":"S1h","location":"header","locationName":"x-amz-object-lock-retain-until-date"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-object-lock-legal-hold"}},"payload":"Body"}},"GetObjectAcl":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?acl"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"Owner":{"shape":"S32"},"Grants":{"shape":"S35","locationName":"AccessControlList"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"GetObjectLegalHold":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?legal-hold"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"LegalHold":{"shape":"S8q"}},"payload":"LegalHold"}},"GetObjectLockConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?object-lock"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"ObjectLockConfiguration":{"shape":"S8t"}},"payload":"ObjectLockConfiguration"}},"GetObjectRetention":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?retention"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"Retention":{"shape":"S91"}},"payload":"Retention"}},"GetObjectTagging":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?tagging"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"}}},"output":{"type":"structure","required":["TagSet"],"members":{"VersionId":{"location":"header","locationName":"x-amz-version-id"},"TagSet":{"shape":"S3k"}}}},"GetObjectTorrent":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?torrent"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"Body":{"streaming":true,"type":"blob"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}},"payload":"Body"}},"GetPublicAccessBlock":{"http":{"method":"GET","requestUri":"/{Bucket}?publicAccessBlock"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","members":{"PublicAccessBlockConfiguration":{"shape":"S98"}},"payload":"PublicAccessBlockConfiguration"}},"HeadBucket":{"http":{"method":"HEAD","requestUri":"/{Bucket}"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}}},"HeadObject":{"http":{"method":"HEAD","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"IfMatch":{"location":"header","locationName":"If-Match"},"IfModifiedSince":{"location":"header","locationName":"If-Modified-Since","type":"timestamp"},"IfNoneMatch":{"location":"header","locationName":"If-None-Match"},"IfUnmodifiedSince":{"location":"header","locationName":"If-Unmodified-Since","type":"timestamp"},"Key":{"location":"uri","locationName":"Key"},"Range":{"location":"header","locationName":"Range"},"VersionId":{"location":"querystring","locationName":"versionId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"}}},"output":{"type":"structure","members":{"DeleteMarker":{"location":"header","locationName":"x-amz-delete-marker","type":"boolean"},"AcceptRanges":{"location":"header","locationName":"accept-ranges"},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"Restore":{"location":"header","locationName":"x-amz-restore"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ETag":{"location":"header","locationName":"ETag"},"MissingMeta":{"location":"header","locationName":"x-amz-missing-meta","type":"integer"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"Metadata":{"shape":"S11","location":"headers","locationName":"x-amz-meta-"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"ReplicationStatus":{"location":"header","locationName":"x-amz-replication-status"},"PartsCount":{"location":"header","locationName":"x-amz-mp-parts-count","type":"integer"},"ObjectLockMode":{"location":"header","locationName":"x-amz-object-lock-mode"},"ObjectLockRetainUntilDate":{"shape":"S1h","location":"header","locationName":"x-amz-object-lock-retain-until-date"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-object-lock-legal-hold"}}}},"ListBucketAnalyticsConfigurations":{"http":{"method":"GET","requestUri":"/{Bucket}?analytics"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"ContinuationToken":{},"NextContinuationToken":{},"AnalyticsConfigurationList":{"locationName":"AnalyticsConfiguration","type":"list","member":{"shape":"S3e"},"flattened":true}}}},"ListBucketInventoryConfigurations":{"http":{"method":"GET","requestUri":"/{Bucket}?inventory"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"}}},"output":{"type":"structure","members":{"ContinuationToken":{},"InventoryConfigurationList":{"locationName":"InventoryConfiguration","type":"list","member":{"shape":"S4d"},"flattened":true},"IsTruncated":{"type":"boolean"},"NextContinuationToken":{}}}},"ListBucketMetricsConfigurations":{"http":{"method":"GET","requestUri":"/{Bucket}?metrics"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"ContinuationToken":{},"NextContinuationToken":{},"MetricsConfigurationList":{"locationName":"MetricsConfiguration","type":"list","member":{"shape":"S5q"},"flattened":true}}}},"ListBuckets":{"http":{"method":"GET"},"output":{"type":"structure","members":{"Buckets":{"type":"list","member":{"locationName":"Bucket","type":"structure","members":{"Name":{},"CreationDate":{"type":"timestamp"}}}},"Owner":{"shape":"S32"}}},"alias":"GetService"},"ListMultipartUploads":{"http":{"method":"GET","requestUri":"/{Bucket}?uploads"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"KeyMarker":{"location":"querystring","locationName":"key-marker"},"MaxUploads":{"location":"querystring","locationName":"max-uploads","type":"integer"},"Prefix":{"location":"querystring","locationName":"prefix"},"UploadIdMarker":{"location":"querystring","locationName":"upload-id-marker"}}},"output":{"type":"structure","members":{"Bucket":{},"KeyMarker":{},"UploadIdMarker":{},"NextKeyMarker":{},"Prefix":{},"Delimiter":{},"NextUploadIdMarker":{},"MaxUploads":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Uploads":{"locationName":"Upload","type":"list","member":{"type":"structure","members":{"UploadId":{},"Key":{},"Initiated":{"type":"timestamp"},"StorageClass":{},"Owner":{"shape":"S32"},"Initiator":{"shape":"Sa5"}}},"flattened":true},"CommonPrefixes":{"shape":"Sa6"},"EncodingType":{}}}},"ListObjectVersions":{"http":{"method":"GET","requestUri":"/{Bucket}?versions"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"KeyMarker":{"location":"querystring","locationName":"key-marker"},"MaxKeys":{"location":"querystring","locationName":"max-keys","type":"integer"},"Prefix":{"location":"querystring","locationName":"prefix"},"VersionIdMarker":{"location":"querystring","locationName":"version-id-marker"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"KeyMarker":{},"VersionIdMarker":{},"NextKeyMarker":{},"NextVersionIdMarker":{},"Versions":{"locationName":"Version","type":"list","member":{"type":"structure","members":{"ETag":{},"Size":{"type":"integer"},"StorageClass":{},"Key":{},"VersionId":{},"IsLatest":{"type":"boolean"},"LastModified":{"type":"timestamp"},"Owner":{"shape":"S32"}}},"flattened":true},"DeleteMarkers":{"locationName":"DeleteMarker","type":"list","member":{"type":"structure","members":{"Owner":{"shape":"S32"},"Key":{},"VersionId":{},"IsLatest":{"type":"boolean"},"LastModified":{"type":"timestamp"}}},"flattened":true},"Name":{},"Prefix":{},"Delimiter":{},"MaxKeys":{"type":"integer"},"CommonPrefixes":{"shape":"Sa6"},"EncodingType":{}}},"alias":"GetBucketObjectVersions"},"ListObjects":{"http":{"method":"GET","requestUri":"/{Bucket}"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"Marker":{"location":"querystring","locationName":"marker"},"MaxKeys":{"location":"querystring","locationName":"max-keys","type":"integer"},"Prefix":{"location":"querystring","locationName":"prefix"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"Marker":{},"NextMarker":{},"Contents":{"shape":"Sao"},"Name":{},"Prefix":{},"Delimiter":{},"MaxKeys":{"type":"integer"},"CommonPrefixes":{"shape":"Sa6"},"EncodingType":{}}},"alias":"GetBucket"},"ListObjectsV2":{"http":{"method":"GET","requestUri":"/{Bucket}?list-type=2"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"MaxKeys":{"location":"querystring","locationName":"max-keys","type":"integer"},"Prefix":{"location":"querystring","locationName":"prefix"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"},"FetchOwner":{"location":"querystring","locationName":"fetch-owner","type":"boolean"},"StartAfter":{"location":"querystring","locationName":"start-after"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"Contents":{"shape":"Sao"},"Name":{},"Prefix":{},"Delimiter":{},"MaxKeys":{"type":"integer"},"CommonPrefixes":{"shape":"Sa6"},"EncodingType":{},"KeyCount":{"type":"integer"},"ContinuationToken":{},"NextContinuationToken":{},"StartAfter":{}}}},"ListParts":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key","UploadId"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"MaxParts":{"location":"querystring","locationName":"max-parts","type":"integer"},"PartNumberMarker":{"location":"querystring","locationName":"part-number-marker","type":"integer"},"UploadId":{"location":"querystring","locationName":"uploadId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"AbortDate":{"location":"header","locationName":"x-amz-abort-date","type":"timestamp"},"AbortRuleId":{"location":"header","locationName":"x-amz-abort-rule-id"},"Bucket":{},"Key":{},"UploadId":{},"PartNumberMarker":{"type":"integer"},"NextPartNumberMarker":{"type":"integer"},"MaxParts":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Parts":{"locationName":"Part","type":"list","member":{"type":"structure","members":{"PartNumber":{"type":"integer"},"LastModified":{"type":"timestamp"},"ETag":{},"Size":{"type":"integer"}}},"flattened":true},"Initiator":{"shape":"Sa5"},"Owner":{"shape":"S32"},"StorageClass":{},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"PutBucketAccelerateConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?accelerate"},"input":{"type":"structure","required":["Bucket","AccelerateConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"AccelerateConfiguration":{"locationName":"AccelerateConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"Status":{}}}},"payload":"AccelerateConfiguration"}},"PutBucketAcl":{"http":{"method":"PUT","requestUri":"/{Bucket}?acl"},"input":{"type":"structure","required":["Bucket"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"AccessControlPolicy":{"shape":"Sb6","locationName":"AccessControlPolicy","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWrite":{"location":"header","locationName":"x-amz-grant-write"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"}},"payload":"AccessControlPolicy"}},"PutBucketAnalyticsConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?analytics"},"input":{"type":"structure","required":["Bucket","Id","AnalyticsConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"AnalyticsConfiguration":{"shape":"S3e","locationName":"AnalyticsConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"AnalyticsConfiguration"}},"PutBucketCors":{"http":{"method":"PUT","requestUri":"/{Bucket}?cors"},"input":{"type":"structure","required":["Bucket","CORSConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"CORSConfiguration":{"locationName":"CORSConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["CORSRules"],"members":{"CORSRules":{"shape":"S3u","locationName":"CORSRule"}}},"ContentMD5":{"location":"header","locationName":"Content-MD5"}},"payload":"CORSConfiguration"}},"PutBucketEncryption":{"http":{"method":"PUT","requestUri":"/{Bucket}?encryption"},"input":{"type":"structure","required":["Bucket","ServerSideEncryptionConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ServerSideEncryptionConfiguration":{"shape":"S47","locationName":"ServerSideEncryptionConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"ServerSideEncryptionConfiguration"}},"PutBucketInventoryConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?inventory"},"input":{"type":"structure","required":["Bucket","Id","InventoryConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"InventoryConfiguration":{"shape":"S4d","locationName":"InventoryConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"InventoryConfiguration"}},"PutBucketLifecycle":{"http":{"method":"PUT","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"LifecycleConfiguration":{"locationName":"LifecycleConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Rules"],"members":{"Rules":{"shape":"S4t","locationName":"Rule"}}}},"payload":"LifecycleConfiguration"},"deprecated":true},"PutBucketLifecycleConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"LifecycleConfiguration":{"locationName":"LifecycleConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Rules"],"members":{"Rules":{"shape":"S58","locationName":"Rule"}}}},"payload":"LifecycleConfiguration"}},"PutBucketLogging":{"http":{"method":"PUT","requestUri":"/{Bucket}?logging"},"input":{"type":"structure","required":["Bucket","BucketLoggingStatus"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"BucketLoggingStatus":{"locationName":"BucketLoggingStatus","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"LoggingEnabled":{"shape":"S5i"}}},"ContentMD5":{"location":"header","locationName":"Content-MD5"}},"payload":"BucketLoggingStatus"}},"PutBucketMetricsConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?metrics"},"input":{"type":"structure","required":["Bucket","Id","MetricsConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"MetricsConfiguration":{"shape":"S5q","locationName":"MetricsConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"MetricsConfiguration"}},"PutBucketNotification":{"http":{"method":"PUT","requestUri":"/{Bucket}?notification"},"input":{"type":"structure","required":["Bucket","NotificationConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"NotificationConfiguration":{"shape":"S5u","locationName":"NotificationConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"NotificationConfiguration"},"deprecated":true},"PutBucketNotificationConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?notification"},"input":{"type":"structure","required":["Bucket","NotificationConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"NotificationConfiguration":{"shape":"S65","locationName":"NotificationConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"NotificationConfiguration"}},"PutBucketPolicy":{"http":{"method":"PUT","requestUri":"/{Bucket}?policy"},"input":{"type":"structure","required":["Bucket","Policy"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ConfirmRemoveSelfBucketAccess":{"location":"header","locationName":"x-amz-confirm-remove-self-bucket-access","type":"boolean"},"Policy":{}},"payload":"Policy"}},"PutBucketReplication":{"http":{"method":"PUT","requestUri":"/{Bucket}?replication"},"input":{"type":"structure","required":["Bucket","ReplicationConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ReplicationConfiguration":{"shape":"S6s","locationName":"ReplicationConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"Token":{"location":"header","locationName":"x-amz-bucket-object-lock-token"}},"payload":"ReplicationConfiguration"}},"PutBucketRequestPayment":{"http":{"method":"PUT","requestUri":"/{Bucket}?requestPayment"},"input":{"type":"structure","required":["Bucket","RequestPaymentConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"RequestPaymentConfiguration":{"locationName":"RequestPaymentConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Payer"],"members":{"Payer":{}}}},"payload":"RequestPaymentConfiguration"}},"PutBucketTagging":{"http":{"method":"PUT","requestUri":"/{Bucket}?tagging"},"input":{"type":"structure","required":["Bucket","Tagging"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"Tagging":{"shape":"Sbt","locationName":"Tagging","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"Tagging"}},"PutBucketVersioning":{"http":{"method":"PUT","requestUri":"/{Bucket}?versioning"},"input":{"type":"structure","required":["Bucket","VersioningConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"MFA":{"location":"header","locationName":"x-amz-mfa"},"VersioningConfiguration":{"locationName":"VersioningConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"MFADelete":{"locationName":"MfaDelete"},"Status":{}}}},"payload":"VersioningConfiguration"}},"PutBucketWebsite":{"http":{"method":"PUT","requestUri":"/{Bucket}?website"},"input":{"type":"structure","required":["Bucket","WebsiteConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"WebsiteConfiguration":{"locationName":"WebsiteConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"ErrorDocument":{"shape":"S7q"},"IndexDocument":{"shape":"S7o"},"RedirectAllRequestsTo":{"shape":"S7l"},"RoutingRules":{"shape":"S7r"}}}},"payload":"WebsiteConfiguration"}},"PutObject":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Body":{"streaming":true,"type":"blob"},"Bucket":{"location":"uri","locationName":"Bucket"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"location":"uri","locationName":"Key"},"Metadata":{"shape":"S11","location":"headers","locationName":"x-amz-meta-"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1b","location":"header","locationName":"x-amz-server-side-encryption-context"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Tagging":{"location":"header","locationName":"x-amz-tagging"},"ObjectLockMode":{"location":"header","locationName":"x-amz-object-lock-mode"},"ObjectLockRetainUntilDate":{"shape":"S1h","location":"header","locationName":"x-amz-object-lock-retain-until-date"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-object-lock-legal-hold"}},"payload":"Body"},"output":{"type":"structure","members":{"Expiration":{"location":"header","locationName":"x-amz-expiration"},"ETag":{"location":"header","locationName":"ETag"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1b","location":"header","locationName":"x-amz-server-side-encryption-context"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"PutObjectAcl":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}?acl"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"AccessControlPolicy":{"shape":"Sb6","locationName":"AccessControlPolicy","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWrite":{"location":"header","locationName":"x-amz-grant-write"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"location":"uri","locationName":"Key"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"VersionId":{"location":"querystring","locationName":"versionId"}},"payload":"AccessControlPolicy"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"PutObjectLegalHold":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}?legal-hold"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"LegalHold":{"shape":"S8q","locationName":"LegalHold","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"VersionId":{"location":"querystring","locationName":"versionId"},"ContentMD5":{"location":"header","locationName":"Content-MD5"}},"payload":"LegalHold"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"PutObjectLockConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?object-lock"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ObjectLockConfiguration":{"shape":"S8t","locationName":"ObjectLockConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Token":{"location":"header","locationName":"x-amz-bucket-object-lock-token"},"ContentMD5":{"location":"header","locationName":"Content-MD5"}},"payload":"ObjectLockConfiguration"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"PutObjectRetention":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}?retention"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"Retention":{"shape":"S91","locationName":"Retention","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"VersionId":{"location":"querystring","locationName":"versionId"},"BypassGovernanceRetention":{"location":"header","locationName":"x-amz-bypass-governance-retention","type":"boolean"},"ContentMD5":{"location":"header","locationName":"Content-MD5"}},"payload":"Retention"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"PutObjectTagging":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}?tagging"},"input":{"type":"structure","required":["Bucket","Key","Tagging"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"Tagging":{"shape":"Sbt","locationName":"Tagging","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"Tagging"},"output":{"type":"structure","members":{"VersionId":{"location":"header","locationName":"x-amz-version-id"}}}},"PutPublicAccessBlock":{"http":{"method":"PUT","requestUri":"/{Bucket}?publicAccessBlock"},"input":{"type":"structure","required":["Bucket","PublicAccessBlockConfiguration"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"PublicAccessBlockConfiguration":{"shape":"S98","locationName":"PublicAccessBlockConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"PublicAccessBlockConfiguration"}},"RestoreObject":{"http":{"requestUri":"/{Bucket}/{Key+}?restore"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"RestoreRequest":{"locationName":"RestoreRequest","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"Days":{"type":"integer"},"GlacierJobParameters":{"type":"structure","required":["Tier"],"members":{"Tier":{}}},"Type":{},"Tier":{},"Description":{},"SelectParameters":{"type":"structure","required":["InputSerialization","ExpressionType","Expression","OutputSerialization"],"members":{"InputSerialization":{"shape":"Scj"},"ExpressionType":{},"Expression":{},"OutputSerialization":{"shape":"Scy"}}},"OutputLocation":{"type":"structure","members":{"S3":{"type":"structure","required":["BucketName","Prefix"],"members":{"BucketName":{},"Prefix":{},"Encryption":{"type":"structure","required":["EncryptionType"],"members":{"EncryptionType":{},"KMSKeyId":{"shape":"Sj"},"KMSContext":{}}},"CannedACL":{},"AccessControlList":{"shape":"S35"},"Tagging":{"shape":"Sbt"},"UserMetadata":{"type":"list","member":{"locationName":"MetadataEntry","type":"structure","members":{"Name":{},"Value":{}}}},"StorageClass":{}}}}}}},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}},"payload":"RestoreRequest"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"RestoreOutputPath":{"location":"header","locationName":"x-amz-restore-output-path"}}},"alias":"PostObjectRestore"},"SelectObjectContent":{"http":{"requestUri":"/{Bucket}/{Key+}?select&select-type=2"},"input":{"locationName":"SelectObjectContentRequest","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Bucket","Key","Expression","ExpressionType","InputSerialization","OutputSerialization"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"Expression":{},"ExpressionType":{},"RequestProgress":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"InputSerialization":{"shape":"Scj"},"OutputSerialization":{"shape":"Scy"}}},"output":{"type":"structure","members":{"Payload":{"type":"structure","members":{"Records":{"type":"structure","members":{"Payload":{"eventpayload":true,"type":"blob"}},"event":true},"Stats":{"type":"structure","members":{"Details":{"eventpayload":true,"type":"structure","members":{"BytesScanned":{"type":"long"},"BytesProcessed":{"type":"long"},"BytesReturned":{"type":"long"}}}},"event":true},"Progress":{"type":"structure","members":{"Details":{"eventpayload":true,"type":"structure","members":{"BytesScanned":{"type":"long"},"BytesProcessed":{"type":"long"},"BytesReturned":{"type":"long"}}}},"event":true},"Cont":{"type":"structure","members":{},"event":true},"End":{"type":"structure","members":{},"event":true}},"eventstream":true}},"payload":"Payload"}},"UploadPart":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key","PartNumber","UploadId"],"members":{"Body":{"streaming":true,"type":"blob"},"Bucket":{"location":"uri","locationName":"Bucket"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"Key":{"location":"uri","locationName":"Key"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"},"UploadId":{"location":"querystring","locationName":"uploadId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}},"payload":"Body"},"output":{"type":"structure","members":{"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"ETag":{"location":"header","locationName":"ETag"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"UploadPartCopy":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","CopySource","Key","PartNumber","UploadId"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"},"CopySource":{"location":"header","locationName":"x-amz-copy-source"},"CopySourceIfMatch":{"location":"header","locationName":"x-amz-copy-source-if-match"},"CopySourceIfModifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-modified-since","type":"timestamp"},"CopySourceIfNoneMatch":{"location":"header","locationName":"x-amz-copy-source-if-none-match"},"CopySourceIfUnmodifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-unmodified-since","type":"timestamp"},"CopySourceRange":{"location":"header","locationName":"x-amz-copy-source-range"},"Key":{"location":"uri","locationName":"Key"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"},"UploadId":{"location":"querystring","locationName":"uploadId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"S19","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"CopySourceSSECustomerAlgorithm":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-algorithm"},"CopySourceSSECustomerKey":{"shape":"S1d","location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key"},"CopySourceSSECustomerKeyMD5":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"CopySourceVersionId":{"location":"header","locationName":"x-amz-copy-source-version-id"},"CopyPartResult":{"type":"structure","members":{"ETag":{},"LastModified":{"type":"timestamp"}}},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sj","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}},"payload":"CopyPartResult"}}},"shapes":{"Sj":{"type":"string","sensitive":true},"S11":{"type":"map","key":{},"value":{}},"S19":{"type":"blob","sensitive":true},"S1b":{"type":"string","sensitive":true},"S1d":{"type":"blob","sensitive":true},"S1h":{"type":"timestamp","timestampFormat":"iso8601"},"S32":{"type":"structure","members":{"DisplayName":{},"ID":{}}},"S35":{"type":"list","member":{"locationName":"Grant","type":"structure","members":{"Grantee":{"shape":"S37"},"Permission":{}}}},"S37":{"type":"structure","required":["Type"],"members":{"DisplayName":{},"EmailAddress":{},"ID":{},"Type":{"locationName":"xsi:type","xmlAttribute":true},"URI":{}},"xmlNamespace":{"prefix":"xsi","uri":"http://www.w3.org/2001/XMLSchema-instance"}},"S3e":{"type":"structure","required":["Id","StorageClassAnalysis"],"members":{"Id":{},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S3h"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S3k","flattened":true,"locationName":"Tag"}}}}},"StorageClassAnalysis":{"type":"structure","members":{"DataExport":{"type":"structure","required":["OutputSchemaVersion","Destination"],"members":{"OutputSchemaVersion":{},"Destination":{"type":"structure","required":["S3BucketDestination"],"members":{"S3BucketDestination":{"type":"structure","required":["Format","Bucket"],"members":{"Format":{},"BucketAccountId":{},"Bucket":{},"Prefix":{}}}}}}}}}}},"S3h":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"S3k":{"type":"list","member":{"shape":"S3h","locationName":"Tag"}},"S3u":{"type":"list","member":{"type":"structure","required":["AllowedMethods","AllowedOrigins"],"members":{"AllowedHeaders":{"locationName":"AllowedHeader","type":"list","member":{},"flattened":true},"AllowedMethods":{"locationName":"AllowedMethod","type":"list","member":{},"flattened":true},"AllowedOrigins":{"locationName":"AllowedOrigin","type":"list","member":{},"flattened":true},"ExposeHeaders":{"locationName":"ExposeHeader","type":"list","member":{},"flattened":true},"MaxAgeSeconds":{"type":"integer"}}},"flattened":true},"S47":{"type":"structure","required":["Rules"],"members":{"Rules":{"locationName":"Rule","type":"list","member":{"type":"structure","members":{"ApplyServerSideEncryptionByDefault":{"type":"structure","required":["SSEAlgorithm"],"members":{"SSEAlgorithm":{},"KMSMasterKeyID":{"shape":"Sj"}}}}},"flattened":true}}},"S4d":{"type":"structure","required":["Destination","IsEnabled","Id","IncludedObjectVersions","Schedule"],"members":{"Destination":{"type":"structure","required":["S3BucketDestination"],"members":{"S3BucketDestination":{"type":"structure","required":["Bucket","Format"],"members":{"AccountId":{},"Bucket":{},"Format":{},"Prefix":{},"Encryption":{"type":"structure","members":{"SSES3":{"locationName":"SSE-S3","type":"structure","members":{}},"SSEKMS":{"locationName":"SSE-KMS","type":"structure","required":["KeyId"],"members":{"KeyId":{"shape":"Sj"}}}}}}}}},"IsEnabled":{"type":"boolean"},"Filter":{"type":"structure","required":["Prefix"],"members":{"Prefix":{}}},"Id":{},"IncludedObjectVersions":{},"OptionalFields":{"type":"list","member":{"locationName":"Field"}},"Schedule":{"type":"structure","required":["Frequency"],"members":{"Frequency":{}}}}},"S4t":{"type":"list","member":{"type":"structure","required":["Prefix","Status"],"members":{"Expiration":{"shape":"S4v"},"ID":{},"Prefix":{},"Status":{},"Transition":{"shape":"S50"},"NoncurrentVersionTransition":{"shape":"S52"},"NoncurrentVersionExpiration":{"shape":"S53"},"AbortIncompleteMultipartUpload":{"shape":"S54"}}},"flattened":true},"S4v":{"type":"structure","members":{"Date":{"shape":"S4w"},"Days":{"type":"integer"},"ExpiredObjectDeleteMarker":{"type":"boolean"}}},"S4w":{"type":"timestamp","timestampFormat":"iso8601"},"S50":{"type":"structure","members":{"Date":{"shape":"S4w"},"Days":{"type":"integer"},"StorageClass":{}}},"S52":{"type":"structure","members":{"NoncurrentDays":{"type":"integer"},"StorageClass":{}}},"S53":{"type":"structure","members":{"NoncurrentDays":{"type":"integer"}}},"S54":{"type":"structure","members":{"DaysAfterInitiation":{"type":"integer"}}},"S58":{"type":"list","member":{"type":"structure","required":["Status"],"members":{"Expiration":{"shape":"S4v"},"ID":{},"Prefix":{"deprecated":true},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S3h"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S3k","flattened":true,"locationName":"Tag"}}}}},"Status":{},"Transitions":{"locationName":"Transition","type":"list","member":{"shape":"S50"},"flattened":true},"NoncurrentVersionTransitions":{"locationName":"NoncurrentVersionTransition","type":"list","member":{"shape":"S52"},"flattened":true},"NoncurrentVersionExpiration":{"shape":"S53"},"AbortIncompleteMultipartUpload":{"shape":"S54"}}},"flattened":true},"S5i":{"type":"structure","required":["TargetBucket","TargetPrefix"],"members":{"TargetBucket":{},"TargetGrants":{"type":"list","member":{"locationName":"Grant","type":"structure","members":{"Grantee":{"shape":"S37"},"Permission":{}}}},"TargetPrefix":{}}},"S5q":{"type":"structure","required":["Id"],"members":{"Id":{},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S3h"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S3k","flattened":true,"locationName":"Tag"}}}}}}},"S5t":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"location":"uri","locationName":"Bucket"}}},"S5u":{"type":"structure","members":{"TopicConfiguration":{"type":"structure","members":{"Id":{},"Events":{"shape":"S5x","locationName":"Event"},"Event":{"deprecated":true},"Topic":{}}},"QueueConfiguration":{"type":"structure","members":{"Id":{},"Event":{"deprecated":true},"Events":{"shape":"S5x","locationName":"Event"},"Queue":{}}},"CloudFunctionConfiguration":{"type":"structure","members":{"Id":{},"Event":{"deprecated":true},"Events":{"shape":"S5x","locationName":"Event"},"CloudFunction":{},"InvocationRole":{}}}}},"S5x":{"type":"list","member":{},"flattened":true},"S65":{"type":"structure","members":{"TopicConfigurations":{"locationName":"TopicConfiguration","type":"list","member":{"type":"structure","required":["TopicArn","Events"],"members":{"Id":{},"TopicArn":{"locationName":"Topic"},"Events":{"shape":"S5x","locationName":"Event"},"Filter":{"shape":"S68"}}},"flattened":true},"QueueConfigurations":{"locationName":"QueueConfiguration","type":"list","member":{"type":"structure","required":["QueueArn","Events"],"members":{"Id":{},"QueueArn":{"locationName":"Queue"},"Events":{"shape":"S5x","locationName":"Event"},"Filter":{"shape":"S68"}}},"flattened":true},"LambdaFunctionConfigurations":{"locationName":"CloudFunctionConfiguration","type":"list","member":{"type":"structure","required":["LambdaFunctionArn","Events"],"members":{"Id":{},"LambdaFunctionArn":{"locationName":"CloudFunction"},"Events":{"shape":"S5x","locationName":"Event"},"Filter":{"shape":"S68"}}},"flattened":true}}},"S68":{"type":"structure","members":{"Key":{"locationName":"S3Key","type":"structure","members":{"FilterRules":{"locationName":"FilterRule","type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}},"flattened":true}}}}},"S6s":{"type":"structure","required":["Role","Rules"],"members":{"Role":{},"Rules":{"locationName":"Rule","type":"list","member":{"type":"structure","required":["Status","Destination"],"members":{"ID":{},"Priority":{"type":"integer"},"Prefix":{"deprecated":true},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S3h"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S3k","flattened":true,"locationName":"Tag"}}}}},"Status":{},"SourceSelectionCriteria":{"type":"structure","members":{"SseKmsEncryptedObjects":{"type":"structure","required":["Status"],"members":{"Status":{}}}}},"Destination":{"type":"structure","required":["Bucket"],"members":{"Bucket":{},"Account":{},"StorageClass":{},"AccessControlTranslation":{"type":"structure","required":["Owner"],"members":{"Owner":{}}},"EncryptionConfiguration":{"type":"structure","members":{"ReplicaKmsKeyID":{}}}}},"DeleteMarkerReplication":{"type":"structure","members":{"Status":{}}}}},"flattened":true}}},"S7l":{"type":"structure","required":["HostName"],"members":{"HostName":{},"Protocol":{}}},"S7o":{"type":"structure","required":["Suffix"],"members":{"Suffix":{}}},"S7q":{"type":"structure","required":["Key"],"members":{"Key":{}}},"S7r":{"type":"list","member":{"locationName":"RoutingRule","type":"structure","required":["Redirect"],"members":{"Condition":{"type":"structure","members":{"HttpErrorCodeReturnedEquals":{},"KeyPrefixEquals":{}}},"Redirect":{"type":"structure","members":{"HostName":{},"HttpRedirectCode":{},"Protocol":{},"ReplaceKeyPrefixWith":{},"ReplaceKeyWith":{}}}}}},"S8q":{"type":"structure","members":{"Status":{}}},"S8t":{"type":"structure","members":{"ObjectLockEnabled":{},"Rule":{"type":"structure","members":{"DefaultRetention":{"type":"structure","members":{"Mode":{},"Days":{"type":"integer"},"Years":{"type":"integer"}}}}}}},"S91":{"type":"structure","members":{"Mode":{},"RetainUntilDate":{"shape":"S4w"}}},"S98":{"type":"structure","members":{"BlockPublicAcls":{"locationName":"BlockPublicAcls","type":"boolean"},"IgnorePublicAcls":{"locationName":"IgnorePublicAcls","type":"boolean"},"BlockPublicPolicy":{"locationName":"BlockPublicPolicy","type":"boolean"},"RestrictPublicBuckets":{"locationName":"RestrictPublicBuckets","type":"boolean"}}},"Sa5":{"type":"structure","members":{"ID":{},"DisplayName":{}}},"Sa6":{"type":"list","member":{"type":"structure","members":{"Prefix":{}}},"flattened":true},"Sao":{"type":"list","member":{"type":"structure","members":{"Key":{},"LastModified":{"type":"timestamp"},"ETag":{},"Size":{"type":"integer"},"StorageClass":{},"Owner":{"shape":"S32"}}},"flattened":true},"Sb6":{"type":"structure","members":{"Grants":{"shape":"S35","locationName":"AccessControlList"},"Owner":{"shape":"S32"}}},"Sbt":{"type":"structure","required":["TagSet"],"members":{"TagSet":{"shape":"S3k"}}},"Scj":{"type":"structure","members":{"CSV":{"type":"structure","members":{"FileHeaderInfo":{},"Comments":{},"QuoteEscapeCharacter":{},"RecordDelimiter":{},"FieldDelimiter":{},"QuoteCharacter":{},"AllowQuotedRecordDelimiter":{"type":"boolean"}}},"CompressionType":{},"JSON":{"type":"structure","members":{"Type":{}}},"Parquet":{"type":"structure","members":{}}}},"Scy":{"type":"structure","members":{"CSV":{"type":"structure","members":{"QuoteFields":{},"QuoteEscapeCharacter":{},"RecordDelimiter":{},"FieldDelimiter":{},"QuoteCharacter":{}}},"JSON":{"type":"structure","members":{"RecordDelimiter":{}}}}}}}');

});

parcelRequire.register("5udx1", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListBuckets":{"result_key":"Buckets"},"ListMultipartUploads":{"input_token":["KeyMarker","UploadIdMarker"],"limit_key":"MaxUploads","more_results":"IsTruncated","output_token":["NextKeyMarker","NextUploadIdMarker"],"result_key":["Uploads","CommonPrefixes"]},"ListObjectVersions":{"input_token":["KeyMarker","VersionIdMarker"],"limit_key":"MaxKeys","more_results":"IsTruncated","output_token":["NextKeyMarker","NextVersionIdMarker"],"result_key":["Versions","DeleteMarkers","CommonPrefixes"]},"ListObjects":{"input_token":"Marker","limit_key":"MaxKeys","more_results":"IsTruncated","output_token":"NextMarker || Contents[-1].Key","result_key":["Contents","CommonPrefixes"]},"ListObjectsV2":{"input_token":"ContinuationToken","limit_key":"MaxKeys","output_token":"NextContinuationToken","result_key":["Contents","CommonPrefixes"]},"ListParts":{"input_token":"PartNumberMarker","limit_key":"MaxParts","more_results":"IsTruncated","output_token":"NextPartNumberMarker","result_key":"Parts"}}}');

});

parcelRequire.register("8i7wF", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"BucketExists":{"delay":5,"operation":"HeadBucket","maxAttempts":20,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"expected":301,"matcher":"status","state":"success"},{"expected":403,"matcher":"status","state":"success"},{"expected":404,"matcher":"status","state":"retry"}]},"BucketNotExists":{"delay":5,"operation":"HeadBucket","maxAttempts":20,"acceptors":[{"expected":404,"matcher":"status","state":"success"}]},"ObjectExists":{"delay":5,"operation":"HeadObject","maxAttempts":20,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"expected":404,"matcher":"status","state":"retry"}]},"ObjectNotExists":{"delay":5,"operation":"HeadObject","maxAttempts":20,"acceptors":[{"expected":404,"matcher":"status","state":"success"}]}}}');

});




parcelRequire.register("5ZwjQ", function(module, exports) {

var $eG0WE = parcelRequire("eG0WE");

});


parcelRequire.register("5Q7Dg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4407bab511f2987d$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "GRAPHQL_AUTH_MODE", function () { return (parcelRequire("IRLYq")).GRAPHQL_AUTH_MODE; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $duItG = parcelRequire("duItG");

var $IRLYq = parcelRequire("IRLYq");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $2hWDt = parcelRequire("2hWDt");
var $4407bab511f2987d$var$logger = new (0, $gBqCF.ConsoleLogger)("API");
var $4407bab511f2987d$var$_instance = null;
if (!$4407bab511f2987d$var$_instance) {
    $4407bab511f2987d$var$logger.debug("Create API Instance");
    $4407bab511f2987d$var$_instance = new (0, $duItG.default)(null);
}
var $4407bab511f2987d$var$API = $4407bab511f2987d$var$_instance;
(0, $2hWDt.default).register($4407bab511f2987d$var$API);
var $4407bab511f2987d$export$2e2bcd8739ae039 = $4407bab511f2987d$var$API;

});
parcelRequire.register("duItG", function(module, exports) {

$parcel$export(module.exports, "graphqlOperation", function () { return $9d30941591f50863$export$78930a3b816845f9; });
$parcel$export(module.exports, "default", function () { return $9d30941591f50863$export$2e2bcd8739ae039; });

var $hr48k = parcelRequire("hr48k");

var $3oaEu = parcelRequire("3oaEu");

var $VZOGu = parcelRequire("VZOGu");

var $5rRUY = parcelRequire("5rRUY");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $2hWDt = parcelRequire("2hWDt");
var $2SWCi = parcelRequire("2SWCi");
var $aCVDw = parcelRequire("aCVDw");

var $hbz3E = parcelRequire("hbz3E");

var $9x214 = parcelRequire("9x214");
var $9d30941591f50863$var$__assign = undefined && undefined.__assign || function() {
    $9d30941591f50863$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9d30941591f50863$var$__assign.apply(this, arguments);
};
var $9d30941591f50863$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9d30941591f50863$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $9d30941591f50863$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9d30941591f50863$var$USER_AGENT_HEADER = "x-amz-user-agent";
var $9d30941591f50863$var$logger = new (0, $gBqCF.ConsoleLogger)("API");
var $9d30941591f50863$export$78930a3b816845f9 = function(query, variables) {
    if (variables === void 0) variables = {};
    return {
        query: query,
        variables: variables
    };
};
/**
 * Export Cloud Logic APIs
 */ var $9d30941591f50863$var$APIClass = /** @class */ function() {
    /**
     * Initialize Storage with AWS configuration
     * @param {Object} options - Configuration object for storage
     */ function APIClass(options) {
        this._api = null;
        this._options = options;
        $9d30941591f50863$var$logger.debug("API Options", this._options);
    }
    APIClass.prototype.getModuleName = function() {
        return "API";
    };
    /**
     * Configure API part with aws configurations
     * @param {Object} config - Configuration of the API
     * @return {Object} - The current configuration
     */ APIClass.prototype.configure = function(options) {
        var _a = options || {}, _b = _a.API, API = _b === void 0 ? {} : _b, otherOptions = $9d30941591f50863$var$__rest(_a, [
            "API"
        ]);
        var opt = $9d30941591f50863$var$__assign($9d30941591f50863$var$__assign({}, otherOptions), API);
        $9d30941591f50863$var$logger.debug("configure API", {
            opt: opt
        });
        if (opt["aws_project_region"]) {
            if (opt["aws_cloud_logic_custom"]) {
                var custom = opt["aws_cloud_logic_custom"];
                opt.endpoints = typeof custom === "string" ? JSON.parse(custom) : custom;
            }
            opt = Object.assign({}, opt, {
                region: opt["aws_project_region"],
                header: {}
            });
        }
        if (!Array.isArray(opt.endpoints)) opt.endpoints = [];
        // Check if endpoints has custom_headers and validate if is a function
        opt.endpoints.forEach(function(endpoint) {
            if (typeof endpoint.custom_header !== "undefined" && typeof endpoint.custom_header !== "function") {
                $9d30941591f50863$var$logger.warn("API " + endpoint.name + ", custom_header should be a function");
                endpoint.custom_header = undefined;
            }
        });
        if (typeof opt.graphql_headers !== "undefined" && typeof opt.graphql_headers !== "function") {
            $9d30941591f50863$var$logger.warn("graphql_headers should be a function");
            opt.graphql_headers = undefined;
        }
        this._options = Object.assign({}, this._options, opt);
        this.createInstance();
        return this._options;
    };
    /**
     * Create an instance of API for the library
     * @return - A promise of true if Success
     */ APIClass.prototype.createInstance = function() {
        $9d30941591f50863$var$logger.debug("create API instance");
        if (this._options) {
            this._api = new (0, $5rRUY.RestClient)(this._options);
            return true;
        } else return Promise.reject("API not configured");
    };
    /**
     * Make a GET request
     * @param {string} apiName  - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ APIClass.prototype.get = function(apiName, path, init) {
        return $9d30941591f50863$var$__awaiter(this, void 0, void 0, function() {
            var error_1, endpoint;
            return $9d30941591f50863$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this._api) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.createInstance()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.reject(error_1)
                        ];
                    case 4:
                        endpoint = this._api.endpoint(apiName);
                        if (endpoint.length === 0) return [
                            2 /*return*/ ,
                            Promise.reject("API " + apiName + " does not exist")
                        ];
                        return [
                            2 /*return*/ ,
                            this._api.get(endpoint + path, init)
                        ];
                }
            });
        });
    };
    /**
     * Make a POST request
     * @param {string} apiName  - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ APIClass.prototype.post = function(apiName, path, init) {
        return $9d30941591f50863$var$__awaiter(this, void 0, void 0, function() {
            var error_2, endpoint;
            return $9d30941591f50863$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this._api) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.createInstance()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_2 = _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.reject(error_2)
                        ];
                    case 4:
                        endpoint = this._api.endpoint(apiName);
                        if (endpoint.length === 0) return [
                            2 /*return*/ ,
                            Promise.reject("API " + apiName + " does not exist")
                        ];
                        return [
                            2 /*return*/ ,
                            this._api.post(endpoint + path, init)
                        ];
                }
            });
        });
    };
    /**
     * Make a PUT request
     * @param {string} apiName  - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ APIClass.prototype.put = function(apiName, path, init) {
        return $9d30941591f50863$var$__awaiter(this, void 0, void 0, function() {
            var error_3, endpoint;
            return $9d30941591f50863$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this._api) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.createInstance()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_3 = _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.reject(error_3)
                        ];
                    case 4:
                        endpoint = this._api.endpoint(apiName);
                        if (endpoint.length === 0) return [
                            2 /*return*/ ,
                            Promise.reject("API " + apiName + " does not exist")
                        ];
                        return [
                            2 /*return*/ ,
                            this._api.put(endpoint + path, init)
                        ];
                }
            });
        });
    };
    /**
     * Make a PATCH request
     * @param {string} apiName  - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ APIClass.prototype.patch = function(apiName, path, init) {
        return $9d30941591f50863$var$__awaiter(this, void 0, void 0, function() {
            var error_4, endpoint;
            return $9d30941591f50863$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this._api) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.createInstance()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_4 = _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.reject(error_4)
                        ];
                    case 4:
                        endpoint = this._api.endpoint(apiName);
                        if (endpoint.length === 0) return [
                            2 /*return*/ ,
                            Promise.reject("API " + apiName + " does not exist")
                        ];
                        return [
                            2 /*return*/ ,
                            this._api.patch(endpoint + path, init)
                        ];
                }
            });
        });
    };
    /**
     * Make a DEL request
     * @param {string} apiName  - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ APIClass.prototype.del = function(apiName, path, init) {
        return $9d30941591f50863$var$__awaiter(this, void 0, void 0, function() {
            var error_5, endpoint;
            return $9d30941591f50863$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this._api) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.createInstance()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_5 = _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.reject(error_5)
                        ];
                    case 4:
                        endpoint = this._api.endpoint(apiName);
                        if (endpoint.length === 0) return [
                            2 /*return*/ ,
                            Promise.reject("API " + apiName + " does not exist")
                        ];
                        return [
                            2 /*return*/ ,
                            this._api.del(endpoint + path, init)
                        ];
                }
            });
        });
    };
    /**
     * Make a HEAD request
     * @param {string} apiName  - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ APIClass.prototype.head = function(apiName, path, init) {
        return $9d30941591f50863$var$__awaiter(this, void 0, void 0, function() {
            var error_6, endpoint;
            return $9d30941591f50863$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this._api) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.createInstance()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_6 = _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.reject(error_6)
                        ];
                    case 4:
                        endpoint = this._api.endpoint(apiName);
                        if (endpoint.length === 0) return [
                            2 /*return*/ ,
                            Promise.reject("API " + apiName + " does not exist")
                        ];
                        return [
                            2 /*return*/ ,
                            this._api.head(endpoint + path, init)
                        ];
                }
            });
        });
    };
    /**
     * Getting endpoint for API
     * @param {string} apiName - The name of the api
     * @return {string} - The endpoint of the api
     */ APIClass.prototype.endpoint = function(apiName) {
        return $9d30941591f50863$var$__awaiter(this, void 0, void 0, function() {
            var error_7;
            return $9d30941591f50863$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this._api) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.createInstance()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_7 = _a.sent();
                        return [
                            2 /*return*/ ,
                            Promise.reject(error_7)
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            this._api.endpoint(apiName)
                        ];
                }
            });
        });
    };
    APIClass.prototype._headerBasedAuth = function(defaultAuthenticationType) {
        return $9d30941591f50863$var$__awaiter(this, void 0, void 0, function() {
            var _a, aws_appsync_authenticationType, apiKey, authenticationType, headers, _b, credentialsOK, federatedInfo, session;
            return $9d30941591f50863$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = this._options, aws_appsync_authenticationType = _a.aws_appsync_authenticationType, apiKey = _a.aws_appsync_apiKey;
                        authenticationType = defaultAuthenticationType || aws_appsync_authenticationType || "AWS_IAM";
                        headers = {};
                        _b = authenticationType;
                        switch(_b){
                            case "API_KEY":
                                return [
                                    3 /*break*/ ,
                                    1
                                ];
                            case "AWS_IAM":
                                return [
                                    3 /*break*/ ,
                                    2
                                ];
                            case "OPENID_CONNECT":
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case "AMAZON_COGNITO_USER_POOLS":
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 1:
                        if (!apiKey) throw new Error("No api-key configured");
                        headers = {
                            Authorization: null,
                            "X-Api-Key": apiKey
                        };
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 3:
                        credentialsOK = _c.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            (0, $9x214.default).getItem("federatedInfo")
                        ];
                    case 5:
                        federatedInfo = _c.sent();
                        if (!federatedInfo || !federatedInfo.token) throw new Error("No federated jwt");
                        headers = {
                            Authorization: federatedInfo.token
                        };
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            (0, $hbz3E.default).currentSession()
                        ];
                    case 7:
                        session = _c.sent();
                        headers = {
                            Authorization: session.getAccessToken().getJwtToken()
                        };
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        headers = {
                            Authorization: null
                        };
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 9:
                        return [
                            2 /*return*/ ,
                            headers
                        ];
                }
            });
        });
    };
    /**
     * to get the operation type
     * @param operation
     */ APIClass.prototype.getGraphqlOperationType = function(operation) {
        var doc = (0, $VZOGu.parse)(operation);
        var operationType = doc.definitions[0].operation;
        return operationType;
    };
    /**
     * Executes a GraphQL operation
     *
     * @param {GraphQLOptions} GraphQL Options
     * @param {object} additionalHeaders headers to merge in after any `graphql_headers` set in the config
     * @returns {Promise<GraphQLResult> | Observable<object>}
     */ APIClass.prototype.graphql = function(_a, additionalHeaders) {
        var paramQuery = _a.query, _b = _a.variables, variables = _b === void 0 ? {} : _b, authMode = _a.authMode;
        var query = typeof paramQuery === "string" ? (0, $VZOGu.parse)(paramQuery) : (0, $VZOGu.parse)((0, $3oaEu.print)(paramQuery));
        var _c = query.definitions.filter(function(def) {
            return def.kind === "OperationDefinition";
        })[0], operationDef = _c === void 0 ? {} : _c;
        var operationType = operationDef.operation;
        switch(operationType){
            case "query":
            case "mutation":
                return this._graphql({
                    query: query,
                    variables: variables,
                    authMode: authMode
                }, additionalHeaders);
            case "subscription":
                return this._graphqlSubscribe({
                    query: query,
                    variables: variables,
                    authMode: authMode
                });
        }
        throw new Error("invalid operation type: " + operationType);
    };
    APIClass.prototype._graphql = function(_a, additionalHeaders) {
        var query = _a.query, variables = _a.variables, authMode = _a.authMode;
        if (additionalHeaders === void 0) additionalHeaders = {};
        return $9d30941591f50863$var$__awaiter(this, void 0, void 0, function() {
            var _b, region, appSyncGraphqlEndpoint, _c, graphql_headers, customGraphqlEndpoint, customEndpointRegion, headers, _d, _e, _f, _g, _h, _j, body, init, endpoint, error, response, err_1, errors;
            var _k;
            return $9d30941591f50863$var$__generator(this, function(_l) {
                switch(_l.label){
                    case 0:
                        if (!!this._api) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.createInstance()
                        ];
                    case 1:
                        _l.sent();
                        _l.label = 2;
                    case 2:
                        _b = this._options, region = _b.aws_appsync_region, appSyncGraphqlEndpoint = _b.aws_appsync_graphqlEndpoint, _c = _b.graphql_headers, graphql_headers = _c === void 0 ? function() {
                            return {};
                        } : _c, customGraphqlEndpoint = _b.graphql_endpoint, customEndpointRegion = _b.graphql_endpoint_iam_region;
                        _d = [
                            {}
                        ];
                        _e = !customGraphqlEndpoint;
                        if (!_e) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this._headerBasedAuth(authMode)
                        ];
                    case 3:
                        _e = _l.sent();
                        _l.label = 4;
                    case 4:
                        _f = [
                            $9d30941591f50863$var$__assign.apply(void 0, _d.concat([
                                _e
                            ]))
                        ];
                        _g = customGraphqlEndpoint;
                        if (!_g) return [
                            3 /*break*/ ,
                            8
                        ];
                        if (!customEndpointRegion) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            this._headerBasedAuth(authMode)
                        ];
                    case 5:
                        _h = _l.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        _h = {
                            Authorization: null
                        };
                        _l.label = 7;
                    case 7:
                        _g = _h;
                        _l.label = 8;
                    case 8:
                        _j = [
                            $9d30941591f50863$var$__assign.apply(void 0, _f.concat([
                                _g
                            ]))
                        ];
                        return [
                            4 /*yield*/ ,
                            graphql_headers({
                                query: query,
                                variables: variables
                            })
                        ];
                    case 9:
                        headers = $9d30941591f50863$var$__assign.apply(void 0, [
                            $9d30941591f50863$var$__assign.apply(void 0, [
                                $9d30941591f50863$var$__assign.apply(void 0, _j.concat([
                                    _l.sent()
                                ])),
                                additionalHeaders
                            ]),
                            !customGraphqlEndpoint && (_k = {}, _k[$9d30941591f50863$var$USER_AGENT_HEADER] = (0, $2hWDt.Constants).userAgent, _k)
                        ]);
                        body = {
                            query: (0, $3oaEu.print)(query),
                            variables: variables
                        };
                        init = {
                            headers: headers,
                            body: body,
                            signerServiceInfo: {
                                service: !customGraphqlEndpoint ? "appsync" : "execute-api",
                                region: !customGraphqlEndpoint ? region : customEndpointRegion
                            }
                        };
                        endpoint = customGraphqlEndpoint || appSyncGraphqlEndpoint;
                        if (!endpoint) {
                            error = new (0, $hr48k.GraphQLError)("No graphql endpoint provided.");
                            throw {
                                data: {},
                                errors: [
                                    error
                                ]
                            };
                        }
                        _l.label = 10;
                    case 10:
                        _l.trys.push([
                            10,
                            12,
                            ,
                            13
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._api.post(endpoint, init)
                        ];
                    case 11:
                        response = _l.sent();
                        return [
                            3 /*break*/ ,
                            13
                        ];
                    case 12:
                        err_1 = _l.sent();
                        response = {
                            data: {},
                            errors: [
                                new (0, $hr48k.GraphQLError)(err_1.message)
                            ]
                        };
                        return [
                            3 /*break*/ ,
                            13
                        ];
                    case 13:
                        errors = response.errors;
                        if (errors && errors.length) throw response;
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
    APIClass.prototype._graphqlSubscribe = function(_a) {
        var query = _a.query, variables = _a.variables, defaultAuthenticationType = _a.authMode;
        var _b = this._options, region = _b.aws_appsync_region, appSyncGraphqlEndpoint = _b.aws_appsync_graphqlEndpoint, aws_appsync_authenticationType = _b.aws_appsync_authenticationType, apiKey = _b.aws_appsync_apiKey, _c = _b.graphql_headers, graphql_headers = _c === void 0 ? function() {
            return {};
        } : _c;
        var authenticationType = defaultAuthenticationType || aws_appsync_authenticationType || "AWS_IAM";
        if ((0, $2hWDt.default).PubSub && typeof (0, $2hWDt.default).PubSub.subscribe === "function") return (0, $2hWDt.default).PubSub.subscribe("", {
            provider: (0, $2SWCi.INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER),
            appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
            authenticationType: authenticationType,
            apiKey: apiKey,
            query: (0, $3oaEu.print)(query),
            region: region,
            variables: variables,
            graphql_headers: graphql_headers
        });
        else {
            $9d30941591f50863$var$logger.debug("No pubsub module applied for subscription");
            throw new Error("No pubsub module applied for subscription");
        }
    };
    /**
     * @private
     */ APIClass.prototype._ensureCredentials = function() {
        return (0, $aCVDw.default).get().then(function(credentials) {
            if (!credentials) return false;
            var cred = (0, $aCVDw.default).shear(credentials);
            $9d30941591f50863$var$logger.debug("set credentials for api", cred);
            return true;
        }).catch(function(err) {
            $9d30941591f50863$var$logger.warn("ensure credentials error", err);
            return false;
        });
    };
    return APIClass;
}();
var $9d30941591f50863$export$2e2bcd8739ae039 = $9d30941591f50863$var$APIClass;

});
parcelRequire.register("hr48k", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", function () { return $d9f4eb8e2d56e3b6$export$92d6ed0888e7cb7f; });
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ 
var $bT6uI = parcelRequire("bT6uI");

var $03iLt = parcelRequire("03iLt");
function $d9f4eb8e2d56e3b6$export$92d6ed0888e7cb7f(message, nodes, source, positions, path, originalError, extensions) {
    // Compute list of blame nodes.
    var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [
        nodes
    ] : undefined; // Compute locations in the source for the given nodes/positions.
    var _source = source;
    if (!_source && _nodes) {
        var node = _nodes[0];
        _source = node && node.loc && node.loc.source;
    }
    var _positions = positions;
    if (!_positions && _nodes) _positions = _nodes.reduce(function(list, node) {
        if (node.loc) list.push(node.loc.start);
        return list;
    }, []);
    if (_positions && _positions.length === 0) _positions = undefined;
    var _locations;
    if (positions && source) _locations = positions.map(function(pos) {
        return (0, $03iLt.getLocation)(source, pos);
    });
    else if (_nodes) _locations = _nodes.reduce(function(list, node) {
        if (node.loc) list.push((0, $03iLt.getLocation)(node.loc.source, node.loc.start));
        return list;
    }, []);
    var _extensions = extensions || originalError && originalError.extensions;
    Object.defineProperties(this, {
        message: {
            value: message,
            // By being enumerable, JSON.stringify will include `message` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: true,
            writable: true
        },
        locations: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _locations || undefined,
            // By being enumerable, JSON.stringify will include `locations` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(_locations)
        },
        path: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: path || undefined,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(path)
        },
        nodes: {
            value: _nodes || undefined
        },
        source: {
            value: _source || undefined
        },
        positions: {
            value: _positions || undefined
        },
        originalError: {
            value: originalError
        },
        extensions: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _extensions || undefined,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(_extensions)
        }
    }); // Include (non-enumerable) stack trace.
    if (originalError && originalError.stack) Object.defineProperty(this, "stack", {
        value: originalError.stack,
        writable: true,
        configurable: true
    });
    else if (Error.captureStackTrace) Error.captureStackTrace(this, $d9f4eb8e2d56e3b6$export$92d6ed0888e7cb7f);
    else Object.defineProperty(this, "stack", {
        value: Error().stack,
        writable: true,
        configurable: true
    });
}
$d9f4eb8e2d56e3b6$export$92d6ed0888e7cb7f.prototype = Object.create(Error.prototype, {
    constructor: {
        value: $d9f4eb8e2d56e3b6$export$92d6ed0888e7cb7f
    },
    name: {
        value: "GraphQLError"
    },
    toString: {
        value: function toString() {
            return (0, $bT6uI.printError)(this);
        }
    }
});

});
parcelRequire.register("bT6uI", function(module, exports) {

$parcel$export(module.exports, "printError", function () { return $ea277d3930e23371$export$55ee1551a3f962e6; });
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ 
var $03iLt = parcelRequire("03iLt");
function $ea277d3930e23371$export$55ee1551a3f962e6(error) {
    var printedLocations = [];
    if (error.nodes) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = error.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var node = _step.value;
                if (node.loc) printedLocations.push($ea277d3930e23371$var$highlightSourceAtLocation(node.loc.source, (0, $03iLt.getLocation)(node.loc.source, node.loc.start)));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
    } else if (error.source && error.locations) {
        var source = error.source;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;
        try {
            for(var _iterator2 = error.locations[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var location = _step2.value;
                printedLocations.push($ea277d3930e23371$var$highlightSourceAtLocation(source, location));
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) _iterator2.return();
            } finally{
                if (_didIteratorError2) throw _iteratorError2;
            }
        }
    }
    return printedLocations.length === 0 ? error.message : [
        error.message
    ].concat(printedLocations).join("\n\n") + "\n";
}
/**
 * Render a helpful description of the location of the error in the GraphQL
 * Source document.
 */ function $ea277d3930e23371$var$highlightSourceAtLocation(source, location) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $ea277d3930e23371$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = location.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = location.line + lineOffset;
    var columnOffset = location.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = location.column + columnOffset;
    var lines = body.split(/\r\n|[\n\r]/g);
    return "".concat(source.name, " (").concat(lineNum, ":").concat(columnNum, ")\n") + $ea277d3930e23371$var$printPrefixedLines([
        [
            "".concat(lineNum - 1, ": "),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum, ": "),
            lines[lineIndex]
        ],
        [
            "",
            $ea277d3930e23371$var$whitespace(columnNum - 1) + "^"
        ],
        [
            "".concat(lineNum + 1, ": "),
            lines[lineIndex + 1]
        ]
    ]);
}
function $ea277d3930e23371$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = 0;
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;
    try {
        for(var _iterator3 = existingLines[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
            var _ref4 = _step3.value;
            var prefix = _ref4[0];
            padLen = Math.max(padLen, prefix.length);
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) _iterator3.return();
        } finally{
            if (_didIteratorError3) throw _iteratorError3;
        }
    }
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $ea277d3930e23371$var$lpad(padLen, prefix) + line;
    }).join("\n");
}
function $ea277d3930e23371$var$whitespace(len) {
    return Array(len + 1).join(" ");
}
function $ea277d3930e23371$var$lpad(len, str) {
    return $ea277d3930e23371$var$whitespace(len - str.length) + str;
}

});
parcelRequire.register("03iLt", function(module, exports) {

$parcel$export(module.exports, "getLocation", function () { return $08e68333d9dba2e2$export$e7fd20fad3cf4b5f; });
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $08e68333d9dba2e2$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});



parcelRequire.register("3oaEu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.print = $277be03deeae9e90$var$print;

var $7IZQC = parcelRequire("7IZQC");
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */ function $277be03deeae9e90$var$print(ast) {
    return (0, $7IZQC.visit)(ast, {
        leave: $277be03deeae9e90$var$printDocASTReducer
    });
}
var $277be03deeae9e90$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return "$" + node.name;
    },
    // Document
    Document: function Document(node) {
        return $277be03deeae9e90$var$join(node.definitions, "\n\n") + "\n";
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $277be03deeae9e90$var$wrap("(", $277be03deeae9e90$var$join(node.variableDefinitions, ", "), ")");
        var directives = $277be03deeae9e90$var$join(node.directives, " ");
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === "query" ? selectionSet : $277be03deeae9e90$var$join([
            op,
            $277be03deeae9e90$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], " ");
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ": " + type + $277be03deeae9e90$var$wrap(" = ", defaultValue) + $277be03deeae9e90$var$wrap(" ", $277be03deeae9e90$var$join(directives, " "));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $277be03deeae9e90$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        return $277be03deeae9e90$var$join([
            $277be03deeae9e90$var$wrap("", alias, ": ") + name + $277be03deeae9e90$var$wrap("(", $277be03deeae9e90$var$join(args, ", "), ")"),
            $277be03deeae9e90$var$join(directives, " "),
            selectionSet
        ], " ");
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ": " + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return "..." + name + $277be03deeae9e90$var$wrap(" ", $277be03deeae9e90$var$join(directives, " "));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $277be03deeae9e90$var$join([
            "...",
            $277be03deeae9e90$var$wrap("on ", typeCondition),
            $277be03deeae9e90$var$join(directives, " "),
            selectionSet
        ], " ");
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($277be03deeae9e90$var$wrap("(", $277be03deeae9e90$var$join(variableDefinitions, ", "), ")"), " ") + "on ".concat(typeCondition, " ").concat($277be03deeae9e90$var$wrap("", $277be03deeae9e90$var$join(directives, " "), " ")) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? $277be03deeae9e90$var$printBlockString(value, key === "description") : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? "true" : "false";
    },
    NullValue: function NullValue() {
        return "null";
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return "[" + $277be03deeae9e90$var$join(values, ", ") + "]";
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return "{" + $277be03deeae9e90$var$join(fields, ", ") + "}";
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ": " + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return "@" + name + $277be03deeae9e90$var$wrap("(", $277be03deeae9e90$var$join(args, ", "), ")");
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return "[" + type + "]";
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + "!";
    },
    // Type System Definitions
    SchemaDefinition: function SchemaDefinition(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $277be03deeae9e90$var$join([
            "schema",
            $277be03deeae9e90$var$join(directives, " "),
            $277be03deeae9e90$var$block(operationTypes)
        ], " ");
    },
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ": " + type;
    },
    ScalarTypeDefinition: $277be03deeae9e90$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $277be03deeae9e90$var$join([
            "scalar",
            name,
            $277be03deeae9e90$var$join(directives, " ")
        ], " ");
    }),
    ObjectTypeDefinition: $277be03deeae9e90$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $277be03deeae9e90$var$join([
            "type",
            name,
            $277be03deeae9e90$var$wrap("implements ", $277be03deeae9e90$var$join(interfaces, " & ")),
            $277be03deeae9e90$var$join(directives, " "),
            $277be03deeae9e90$var$block(fields)
        ], " ");
    }),
    FieldDefinition: $277be03deeae9e90$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + (args.every(function(arg) {
            return arg.indexOf("\n") === -1;
        }) ? $277be03deeae9e90$var$wrap("(", $277be03deeae9e90$var$join(args, ", "), ")") : $277be03deeae9e90$var$wrap("(\n", $277be03deeae9e90$var$indent($277be03deeae9e90$var$join(args, "\n")), "\n)")) + ": " + type + $277be03deeae9e90$var$wrap(" ", $277be03deeae9e90$var$join(directives, " "));
    }),
    InputValueDefinition: $277be03deeae9e90$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $277be03deeae9e90$var$join([
            name + ": " + type,
            $277be03deeae9e90$var$wrap("= ", defaultValue),
            $277be03deeae9e90$var$join(directives, " ")
        ], " ");
    }),
    InterfaceTypeDefinition: $277be03deeae9e90$var$addDescription(function(_ref26) {
        var name = _ref26.name, directives = _ref26.directives, fields = _ref26.fields;
        return $277be03deeae9e90$var$join([
            "interface",
            name,
            $277be03deeae9e90$var$join(directives, " "),
            $277be03deeae9e90$var$block(fields)
        ], " ");
    }),
    UnionTypeDefinition: $277be03deeae9e90$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $277be03deeae9e90$var$join([
            "union",
            name,
            $277be03deeae9e90$var$join(directives, " "),
            types && types.length !== 0 ? "= " + $277be03deeae9e90$var$join(types, " | ") : ""
        ], " ");
    }),
    EnumTypeDefinition: $277be03deeae9e90$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $277be03deeae9e90$var$join([
            "enum",
            name,
            $277be03deeae9e90$var$join(directives, " "),
            $277be03deeae9e90$var$block(values)
        ], " ");
    }),
    EnumValueDefinition: $277be03deeae9e90$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $277be03deeae9e90$var$join([
            name,
            $277be03deeae9e90$var$join(directives, " ")
        ], " ");
    }),
    InputObjectTypeDefinition: $277be03deeae9e90$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $277be03deeae9e90$var$join([
            "input",
            name,
            $277be03deeae9e90$var$join(directives, " "),
            $277be03deeae9e90$var$block(fields)
        ], " ");
    }),
    DirectiveDefinition: $277be03deeae9e90$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, locations = _ref31.locations;
        return "directive @" + name + (args.every(function(arg) {
            return arg.indexOf("\n") === -1;
        }) ? $277be03deeae9e90$var$wrap("(", $277be03deeae9e90$var$join(args, ", "), ")") : $277be03deeae9e90$var$wrap("(\n", $277be03deeae9e90$var$indent($277be03deeae9e90$var$join(args, "\n")), "\n)")) + " on " + $277be03deeae9e90$var$join(locations, " | ");
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $277be03deeae9e90$var$join([
            "extend schema",
            $277be03deeae9e90$var$join(directives, " "),
            $277be03deeae9e90$var$block(operationTypes)
        ], " ");
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $277be03deeae9e90$var$join([
            "extend scalar",
            name,
            $277be03deeae9e90$var$join(directives, " ")
        ], " ");
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $277be03deeae9e90$var$join([
            "extend type",
            name,
            $277be03deeae9e90$var$wrap("implements ", $277be03deeae9e90$var$join(interfaces, " & ")),
            $277be03deeae9e90$var$join(directives, " "),
            $277be03deeae9e90$var$block(fields)
        ], " ");
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, directives = _ref35.directives, fields = _ref35.fields;
        return $277be03deeae9e90$var$join([
            "extend interface",
            name,
            $277be03deeae9e90$var$join(directives, " "),
            $277be03deeae9e90$var$block(fields)
        ], " ");
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $277be03deeae9e90$var$join([
            "extend union",
            name,
            $277be03deeae9e90$var$join(directives, " "),
            types && types.length !== 0 ? "= " + $277be03deeae9e90$var$join(types, " | ") : ""
        ], " ");
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $277be03deeae9e90$var$join([
            "extend enum",
            name,
            $277be03deeae9e90$var$join(directives, " "),
            $277be03deeae9e90$var$block(values)
        ], " ");
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $277be03deeae9e90$var$join([
            "extend input",
            name,
            $277be03deeae9e90$var$join(directives, " "),
            $277be03deeae9e90$var$block(fields)
        ], " ");
    }
};
function $277be03deeae9e90$var$addDescription(cb) {
    return function(node) {
        return $277be03deeae9e90$var$join([
            node.description,
            cb(node)
        ], "\n");
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $277be03deeae9e90$var$join(maybeArray, separator) {
    return maybeArray ? maybeArray.filter(function(x) {
        return x;
    }).join(separator || "") : "";
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $277be03deeae9e90$var$block(array) {
    return array && array.length !== 0 ? "{\n" + $277be03deeae9e90$var$indent($277be03deeae9e90$var$join(array, "\n")) + "\n}" : "";
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise
 * print an empty string.
 */ function $277be03deeae9e90$var$wrap(start, maybeString, end) {
    return maybeString ? start + maybeString + (end || "") : "";
}
function $277be03deeae9e90$var$indent(maybeString) {
    return maybeString && "  " + maybeString.replace(/\n/g, "\n  ");
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 */ function $277be03deeae9e90$var$printBlockString(value, isDescription) {
    var escaped = value.replace(/"""/g, '\\"""');
    return (value[0] === " " || value[0] === "	") && value.indexOf("\n") === -1 ? '"""'.concat(escaped.replace(/"$/, '"\n'), '"""') : '"""\n'.concat(isDescription ? escaped : $277be03deeae9e90$var$indent(escaped), '\n"""');
}

});
parcelRequire.register("7IZQC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.visit = $59fc9e1acf2a5145$var$visit;
module.exports.visitInParallel = $59fc9e1acf2a5145$var$visitInParallel;
module.exports.visitWithTypeInfo = $59fc9e1acf2a5145$var$visitWithTypeInfo;
module.exports.getVisitFn = $59fc9e1acf2a5145$var$getVisitFn;
module.exports.BREAK = module.exports.QueryDocumentKeys = void 0;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */ /**
 * A visitor is comprised of visit functions, which are called on each node
 * during the visitor's traversal.
 */ /**
 * A KeyMap describes each the traversable properties of each kind of node.
 */ var $59fc9e1acf2a5145$var$QueryDocumentKeys = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        // or removed in the future.
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
module.exports.QueryDocumentKeys = $59fc9e1acf2a5145$var$QueryDocumentKeys;
var $59fc9e1acf2a5145$var$BREAK = {};
/**
 * visit() will walk through an AST using a depth first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */ module.exports.BREAK = $59fc9e1acf2a5145$var$BREAK;
function $59fc9e1acf2a5145$var$visit(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $59fc9e1acf2a5145$var$QueryDocumentKeys;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var k in node)if (node.hasOwnProperty(k)) clone[k] = node[k];
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!$59fc9e1acf2a5145$var$isNode(node)) throw new Error("Invalid AST Node: " + JSON.stringify(node));
            var visitFn = $59fc9e1acf2a5145$var$getVisitFn(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $59fc9e1acf2a5145$var$BREAK) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ($59fc9e1acf2a5145$var$isNode(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : visitorKeys[node.kind] || [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $59fc9e1acf2a5145$var$isNode(maybeNode) {
    return Boolean(maybeNode && typeof maybeNode.kind === "string");
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */ function $59fc9e1acf2a5145$var$visitInParallel(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (!skipping[i]) {
                var fn = $59fc9e1acf2a5145$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $59fc9e1acf2a5145$var$BREAK) skipping[i] = $59fc9e1acf2a5145$var$BREAK;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (!skipping[i]) {
                    var fn = $59fc9e1acf2a5145$var$getVisitFn(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $59fc9e1acf2a5145$var$BREAK) skipping[i] = $59fc9e1acf2a5145$var$BREAK;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
/**
 * Creates a new visitor instance which maintains a provided TypeInfo instance
 * along with visiting visitor.
 */ function $59fc9e1acf2a5145$var$visitWithTypeInfo(typeInfo, visitor) {
    return {
        enter: function enter(node) {
            typeInfo.enter(node);
            var fn = $59fc9e1acf2a5145$var$getVisitFn(visitor, node.kind, /* isLeaving */ false);
            if (fn) {
                var result = fn.apply(visitor, arguments);
                if (result !== undefined) {
                    typeInfo.leave(node);
                    if ($59fc9e1acf2a5145$var$isNode(result)) typeInfo.enter(result);
                }
                return result;
            }
        },
        leave: function leave(node) {
            var fn = $59fc9e1acf2a5145$var$getVisitFn(visitor, node.kind, /* isLeaving */ true);
            var result;
            if (fn) result = fn.apply(visitor, arguments);
            typeInfo.leave(node);
            return result;
        }
    };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */ function $59fc9e1acf2a5145$var$getVisitFn(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === "function") // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === "function") // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === "function") // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === "function") // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});


parcelRequire.register("VZOGu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $0ae54673f4de9042$var$parse;
module.exports.parseValue = $0ae54673f4de9042$var$parseValue;
module.exports.parseType = $0ae54673f4de9042$var$parseType;
module.exports.parseConstValue = $0ae54673f4de9042$var$parseConstValue;
module.exports.parseTypeReference = $0ae54673f4de9042$var$parseTypeReference;
module.exports.parseNamedType = $0ae54673f4de9042$var$parseNamedType;

var $0ae54673f4de9042$var$_inspect = $0ae54673f4de9042$var$_interopRequireDefault((parcelRequire("1vcsZ")));

var $RBQuR = parcelRequire("RBQuR");

var $4Ic4S = parcelRequire("4Ic4S");

var $5G1OP = parcelRequire("5G1OP");

var $cU2Ah = parcelRequire("cU2Ah");

var $doQi7 = parcelRequire("doQi7");
function $0ae54673f4de9042$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */ function $0ae54673f4de9042$var$parse(source, options) {
    var sourceObj = typeof source === "string" ? new $RBQuR.Source(source) : source;
    if (!(sourceObj instanceof $RBQuR.Source)) throw new TypeError("Must provide Source. Received: ".concat((0, $0ae54673f4de9042$var$_inspect.default)(sourceObj)));
    var lexer = (0, $5G1OP.createLexer)(sourceObj, options || {});
    return $0ae54673f4de9042$var$parseDocument(lexer);
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */ function $0ae54673f4de9042$var$parseValue(source, options) {
    var sourceObj = typeof source === "string" ? new $RBQuR.Source(source) : source;
    var lexer = (0, $5G1OP.createLexer)(sourceObj, options || {});
    $0ae54673f4de9042$var$expect(lexer, $5G1OP.TokenKind.SOF);
    var value = $0ae54673f4de9042$var$parseValueLiteral(lexer, false);
    $0ae54673f4de9042$var$expect(lexer, $5G1OP.TokenKind.EOF);
    return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */ function $0ae54673f4de9042$var$parseType(source, options) {
    var sourceObj = typeof source === "string" ? new $RBQuR.Source(source) : source;
    var lexer = (0, $5G1OP.createLexer)(sourceObj, options || {});
    $0ae54673f4de9042$var$expect(lexer, $5G1OP.TokenKind.SOF);
    var type = $0ae54673f4de9042$var$parseTypeReference(lexer);
    $0ae54673f4de9042$var$expect(lexer, $5G1OP.TokenKind.EOF);
    return type;
}
/**
 * Converts a name lex token into a name parse node.
 */ function $0ae54673f4de9042$var$parseName(lexer) {
    var token = $0ae54673f4de9042$var$expect(lexer, $5G1OP.TokenKind.NAME);
    return {
        kind: $cU2Ah.Kind.NAME,
        value: token.value,
        loc: $0ae54673f4de9042$var$loc(lexer, token)
    };
} // Implements the parsing rules in the Document section.
/**
 * Document : Definition+
 */ function $0ae54673f4de9042$var$parseDocument(lexer) {
    var start = lexer.token;
    return {
        kind: $cU2Ah.Kind.DOCUMENT,
        definitions: $0ae54673f4de9042$var$many(lexer, $5G1OP.TokenKind.SOF, $0ae54673f4de9042$var$parseDefinition, $5G1OP.TokenKind.EOF),
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * Definition :
 *   - ExecutableDefinition
 *   - TypeSystemDefinition
 *   - TypeSystemExtension
 */ function $0ae54673f4de9042$var$parseDefinition(lexer) {
    if ($0ae54673f4de9042$var$peek(lexer, $5G1OP.TokenKind.NAME)) switch(lexer.token.value){
        case "query":
        case "mutation":
        case "subscription":
        case "fragment":
            return $0ae54673f4de9042$var$parseExecutableDefinition(lexer);
        case "schema":
        case "scalar":
        case "type":
        case "interface":
        case "union":
        case "enum":
        case "input":
        case "directive":
            return $0ae54673f4de9042$var$parseTypeSystemDefinition(lexer);
        case "extend":
            return $0ae54673f4de9042$var$parseTypeSystemExtension(lexer);
    }
    else if ($0ae54673f4de9042$var$peek(lexer, $5G1OP.TokenKind.BRACE_L)) return $0ae54673f4de9042$var$parseExecutableDefinition(lexer);
    else if ($0ae54673f4de9042$var$peekDescription(lexer)) return $0ae54673f4de9042$var$parseTypeSystemDefinition(lexer);
    throw $0ae54673f4de9042$var$unexpected(lexer);
}
/**
 * ExecutableDefinition :
 *   - OperationDefinition
 *   - FragmentDefinition
 */ function $0ae54673f4de9042$var$parseExecutableDefinition(lexer) {
    if ($0ae54673f4de9042$var$peek(lexer, $5G1OP.TokenKind.NAME)) switch(lexer.token.value){
        case "query":
        case "mutation":
        case "subscription":
            return $0ae54673f4de9042$var$parseOperationDefinition(lexer);
        case "fragment":
            return $0ae54673f4de9042$var$parseFragmentDefinition(lexer);
    }
    else if ($0ae54673f4de9042$var$peek(lexer, $5G1OP.TokenKind.BRACE_L)) return $0ae54673f4de9042$var$parseOperationDefinition(lexer);
    throw $0ae54673f4de9042$var$unexpected(lexer);
} // Implements the parsing rules in the Operations section.
/**
 * OperationDefinition :
 *  - SelectionSet
 *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
 */ function $0ae54673f4de9042$var$parseOperationDefinition(lexer) {
    var start = lexer.token;
    if ($0ae54673f4de9042$var$peek(lexer, $5G1OP.TokenKind.BRACE_L)) return {
        kind: $cU2Ah.Kind.OPERATION_DEFINITION,
        operation: "query",
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: $0ae54673f4de9042$var$parseSelectionSet(lexer),
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
    var operation = $0ae54673f4de9042$var$parseOperationType(lexer);
    var name;
    if ($0ae54673f4de9042$var$peek(lexer, $5G1OP.TokenKind.NAME)) name = $0ae54673f4de9042$var$parseName(lexer);
    return {
        kind: $cU2Ah.Kind.OPERATION_DEFINITION,
        operation: operation,
        name: name,
        variableDefinitions: $0ae54673f4de9042$var$parseVariableDefinitions(lexer),
        directives: $0ae54673f4de9042$var$parseDirectives(lexer, false),
        selectionSet: $0ae54673f4de9042$var$parseSelectionSet(lexer),
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * OperationType : one of query mutation subscription
 */ function $0ae54673f4de9042$var$parseOperationType(lexer) {
    var operationToken = $0ae54673f4de9042$var$expect(lexer, $5G1OP.TokenKind.NAME);
    switch(operationToken.value){
        case "query":
            return "query";
        case "mutation":
            return "mutation";
        case "subscription":
            return "subscription";
    }
    throw $0ae54673f4de9042$var$unexpected(lexer, operationToken);
}
/**
 * VariableDefinitions : ( VariableDefinition+ )
 */ function $0ae54673f4de9042$var$parseVariableDefinitions(lexer) {
    return $0ae54673f4de9042$var$peek(lexer, $5G1OP.TokenKind.PAREN_L) ? $0ae54673f4de9042$var$many(lexer, $5G1OP.TokenKind.PAREN_L, $0ae54673f4de9042$var$parseVariableDefinition, $5G1OP.TokenKind.PAREN_R) : [];
}
/**
 * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
 */ function $0ae54673f4de9042$var$parseVariableDefinition(lexer) {
    var start = lexer.token;
    if (lexer.options.experimentalVariableDefinitionDirectives) return {
        kind: $cU2Ah.Kind.VARIABLE_DEFINITION,
        variable: $0ae54673f4de9042$var$parseVariable(lexer),
        type: ($0ae54673f4de9042$var$expect(lexer, $5G1OP.TokenKind.COLON), $0ae54673f4de9042$var$parseTypeReference(lexer)),
        defaultValue: $0ae54673f4de9042$var$skip(lexer, $5G1OP.TokenKind.EQUALS) ? $0ae54673f4de9042$var$parseValueLiteral(lexer, true) : undefined,
        directives: $0ae54673f4de9042$var$parseDirectives(lexer, true),
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
    return {
        kind: $cU2Ah.Kind.VARIABLE_DEFINITION,
        variable: $0ae54673f4de9042$var$parseVariable(lexer),
        type: ($0ae54673f4de9042$var$expect(lexer, $5G1OP.TokenKind.COLON), $0ae54673f4de9042$var$parseTypeReference(lexer)),
        defaultValue: $0ae54673f4de9042$var$skip(lexer, $5G1OP.TokenKind.EQUALS) ? $0ae54673f4de9042$var$parseValueLiteral(lexer, true) : undefined,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * Variable : $ Name
 */ function $0ae54673f4de9042$var$parseVariable(lexer) {
    var start = lexer.token;
    $0ae54673f4de9042$var$expect(lexer, $5G1OP.TokenKind.DOLLAR);
    return {
        kind: $cU2Ah.Kind.VARIABLE,
        name: $0ae54673f4de9042$var$parseName(lexer),
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * SelectionSet : { Selection+ }
 */ function $0ae54673f4de9042$var$parseSelectionSet(lexer) {
    var start = lexer.token;
    return {
        kind: $cU2Ah.Kind.SELECTION_SET,
        selections: $0ae54673f4de9042$var$many(lexer, $5G1OP.TokenKind.BRACE_L, $0ae54673f4de9042$var$parseSelection, $5G1OP.TokenKind.BRACE_R),
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * Selection :
 *   - Field
 *   - FragmentSpread
 *   - InlineFragment
 */ function $0ae54673f4de9042$var$parseSelection(lexer) {
    return $0ae54673f4de9042$var$peek(lexer, $5G1OP.TokenKind.SPREAD) ? $0ae54673f4de9042$var$parseFragment(lexer) : $0ae54673f4de9042$var$parseField(lexer);
}
/**
 * Field : Alias? Name Arguments? Directives? SelectionSet?
 *
 * Alias : Name :
 */ function $0ae54673f4de9042$var$parseField(lexer) {
    var start = lexer.token;
    var nameOrAlias = $0ae54673f4de9042$var$parseName(lexer);
    var alias;
    var name;
    if ($0ae54673f4de9042$var$skip(lexer, $5G1OP.TokenKind.COLON)) {
        alias = nameOrAlias;
        name = $0ae54673f4de9042$var$parseName(lexer);
    } else name = nameOrAlias;
    return {
        kind: $cU2Ah.Kind.FIELD,
        alias: alias,
        name: name,
        arguments: $0ae54673f4de9042$var$parseArguments(lexer, false),
        directives: $0ae54673f4de9042$var$parseDirectives(lexer, false),
        selectionSet: $0ae54673f4de9042$var$peek(lexer, $5G1OP.TokenKind.BRACE_L) ? $0ae54673f4de9042$var$parseSelectionSet(lexer) : undefined,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * Arguments[Const] : ( Argument[?Const]+ )
 */ function $0ae54673f4de9042$var$parseArguments(lexer, isConst) {
    var item = isConst ? $0ae54673f4de9042$var$parseConstArgument : $0ae54673f4de9042$var$parseArgument;
    return $0ae54673f4de9042$var$peek(lexer, $5G1OP.TokenKind.PAREN_L) ? $0ae54673f4de9042$var$many(lexer, $5G1OP.TokenKind.PAREN_L, item, $5G1OP.TokenKind.PAREN_R) : [];
}
/**
 * Argument[Const] : Name : Value[?Const]
 */ function $0ae54673f4de9042$var$parseArgument(lexer) {
    var start = lexer.token;
    return {
        kind: $cU2Ah.Kind.ARGUMENT,
        name: $0ae54673f4de9042$var$parseName(lexer),
        value: ($0ae54673f4de9042$var$expect(lexer, $5G1OP.TokenKind.COLON), $0ae54673f4de9042$var$parseValueLiteral(lexer, false)),
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
function $0ae54673f4de9042$var$parseConstArgument(lexer) {
    var start = lexer.token;
    return {
        kind: $cU2Ah.Kind.ARGUMENT,
        name: $0ae54673f4de9042$var$parseName(lexer),
        value: ($0ae54673f4de9042$var$expect(lexer, $5G1OP.TokenKind.COLON), $0ae54673f4de9042$var$parseConstValue(lexer)),
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
} // Implements the parsing rules in the Fragments section.
/**
 * Corresponds to both FragmentSpread and InlineFragment in the spec.
 *
 * FragmentSpread : ... FragmentName Directives?
 *
 * InlineFragment : ... TypeCondition? Directives? SelectionSet
 */ function $0ae54673f4de9042$var$parseFragment(lexer) {
    var start = lexer.token;
    $0ae54673f4de9042$var$expect(lexer, $5G1OP.TokenKind.SPREAD);
    if ($0ae54673f4de9042$var$peek(lexer, $5G1OP.TokenKind.NAME) && lexer.token.value !== "on") return {
        kind: $cU2Ah.Kind.FRAGMENT_SPREAD,
        name: $0ae54673f4de9042$var$parseFragmentName(lexer),
        directives: $0ae54673f4de9042$var$parseDirectives(lexer, false),
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
    var typeCondition;
    if (lexer.token.value === "on") {
        lexer.advance();
        typeCondition = $0ae54673f4de9042$var$parseNamedType(lexer);
    }
    return {
        kind: $cU2Ah.Kind.INLINE_FRAGMENT,
        typeCondition: typeCondition,
        directives: $0ae54673f4de9042$var$parseDirectives(lexer, false),
        selectionSet: $0ae54673f4de9042$var$parseSelectionSet(lexer),
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * FragmentDefinition :
 *   - fragment FragmentName on TypeCondition Directives? SelectionSet
 *
 * TypeCondition : NamedType
 */ function $0ae54673f4de9042$var$parseFragmentDefinition(lexer) {
    var start = lexer.token;
    $0ae54673f4de9042$var$expectKeyword(lexer, "fragment"); // Experimental support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
    if (lexer.options.experimentalFragmentVariables) return {
        kind: $cU2Ah.Kind.FRAGMENT_DEFINITION,
        name: $0ae54673f4de9042$var$parseFragmentName(lexer),
        variableDefinitions: $0ae54673f4de9042$var$parseVariableDefinitions(lexer),
        typeCondition: ($0ae54673f4de9042$var$expectKeyword(lexer, "on"), $0ae54673f4de9042$var$parseNamedType(lexer)),
        directives: $0ae54673f4de9042$var$parseDirectives(lexer, false),
        selectionSet: $0ae54673f4de9042$var$parseSelectionSet(lexer),
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
    return {
        kind: $cU2Ah.Kind.FRAGMENT_DEFINITION,
        name: $0ae54673f4de9042$var$parseFragmentName(lexer),
        typeCondition: ($0ae54673f4de9042$var$expectKeyword(lexer, "on"), $0ae54673f4de9042$var$parseNamedType(lexer)),
        directives: $0ae54673f4de9042$var$parseDirectives(lexer, false),
        selectionSet: $0ae54673f4de9042$var$parseSelectionSet(lexer),
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * FragmentName : Name but not `on`
 */ function $0ae54673f4de9042$var$parseFragmentName(lexer) {
    if (lexer.token.value === "on") throw $0ae54673f4de9042$var$unexpected(lexer);
    return $0ae54673f4de9042$var$parseName(lexer);
} // Implements the parsing rules in the Values section.
/**
 * Value[Const] :
 *   - [~Const] Variable
 *   - IntValue
 *   - FloatValue
 *   - StringValue
 *   - BooleanValue
 *   - NullValue
 *   - EnumValue
 *   - ListValue[?Const]
 *   - ObjectValue[?Const]
 *
 * BooleanValue : one of `true` `false`
 *
 * NullValue : `null`
 *
 * EnumValue : Name but not `true`, `false` or `null`
 */ function $0ae54673f4de9042$var$parseValueLiteral(lexer, isConst) {
    var token = lexer.token;
    switch(token.kind){
        case $5G1OP.TokenKind.BRACKET_L:
            return $0ae54673f4de9042$var$parseList(lexer, isConst);
        case $5G1OP.TokenKind.BRACE_L:
            return $0ae54673f4de9042$var$parseObject(lexer, isConst);
        case $5G1OP.TokenKind.INT:
            lexer.advance();
            return {
                kind: $cU2Ah.Kind.INT,
                value: token.value,
                loc: $0ae54673f4de9042$var$loc(lexer, token)
            };
        case $5G1OP.TokenKind.FLOAT:
            lexer.advance();
            return {
                kind: $cU2Ah.Kind.FLOAT,
                value: token.value,
                loc: $0ae54673f4de9042$var$loc(lexer, token)
            };
        case $5G1OP.TokenKind.STRING:
        case $5G1OP.TokenKind.BLOCK_STRING:
            return $0ae54673f4de9042$var$parseStringLiteral(lexer);
        case $5G1OP.TokenKind.NAME:
            if (token.value === "true" || token.value === "false") {
                lexer.advance();
                return {
                    kind: $cU2Ah.Kind.BOOLEAN,
                    value: token.value === "true",
                    loc: $0ae54673f4de9042$var$loc(lexer, token)
                };
            } else if (token.value === "null") {
                lexer.advance();
                return {
                    kind: $cU2Ah.Kind.NULL,
                    loc: $0ae54673f4de9042$var$loc(lexer, token)
                };
            }
            lexer.advance();
            return {
                kind: $cU2Ah.Kind.ENUM,
                value: token.value,
                loc: $0ae54673f4de9042$var$loc(lexer, token)
            };
        case $5G1OP.TokenKind.DOLLAR:
            if (!isConst) return $0ae54673f4de9042$var$parseVariable(lexer);
            break;
    }
    throw $0ae54673f4de9042$var$unexpected(lexer);
}
function $0ae54673f4de9042$var$parseStringLiteral(lexer) {
    var token = lexer.token;
    lexer.advance();
    return {
        kind: $cU2Ah.Kind.STRING,
        value: token.value,
        block: token.kind === $5G1OP.TokenKind.BLOCK_STRING,
        loc: $0ae54673f4de9042$var$loc(lexer, token)
    };
}
function $0ae54673f4de9042$var$parseConstValue(lexer) {
    return $0ae54673f4de9042$var$parseValueLiteral(lexer, true);
}
function $0ae54673f4de9042$var$parseValueValue(lexer) {
    return $0ae54673f4de9042$var$parseValueLiteral(lexer, false);
}
/**
 * ListValue[Const] :
 *   - [ ]
 *   - [ Value[?Const]+ ]
 */ function $0ae54673f4de9042$var$parseList(lexer, isConst) {
    var start = lexer.token;
    var item = isConst ? $0ae54673f4de9042$var$parseConstValue : $0ae54673f4de9042$var$parseValueValue;
    return {
        kind: $cU2Ah.Kind.LIST,
        values: $0ae54673f4de9042$var$any(lexer, $5G1OP.TokenKind.BRACKET_L, item, $5G1OP.TokenKind.BRACKET_R),
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * ObjectValue[Const] :
 *   - { }
 *   - { ObjectField[?Const]+ }
 */ function $0ae54673f4de9042$var$parseObject(lexer, isConst) {
    var start = lexer.token;
    $0ae54673f4de9042$var$expect(lexer, $5G1OP.TokenKind.BRACE_L);
    var fields = [];
    while(!$0ae54673f4de9042$var$skip(lexer, $5G1OP.TokenKind.BRACE_R))fields.push($0ae54673f4de9042$var$parseObjectField(lexer, isConst));
    return {
        kind: $cU2Ah.Kind.OBJECT,
        fields: fields,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * ObjectField[Const] : Name : Value[?Const]
 */ function $0ae54673f4de9042$var$parseObjectField(lexer, isConst) {
    var start = lexer.token;
    return {
        kind: $cU2Ah.Kind.OBJECT_FIELD,
        name: $0ae54673f4de9042$var$parseName(lexer),
        value: ($0ae54673f4de9042$var$expect(lexer, $5G1OP.TokenKind.COLON), $0ae54673f4de9042$var$parseValueLiteral(lexer, isConst)),
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
} // Implements the parsing rules in the Directives section.
/**
 * Directives[Const] : Directive[?Const]+
 */ function $0ae54673f4de9042$var$parseDirectives(lexer, isConst) {
    var directives = [];
    while($0ae54673f4de9042$var$peek(lexer, $5G1OP.TokenKind.AT))directives.push($0ae54673f4de9042$var$parseDirective(lexer, isConst));
    return directives;
}
/**
 * Directive[Const] : @ Name Arguments[?Const]?
 */ function $0ae54673f4de9042$var$parseDirective(lexer, isConst) {
    var start = lexer.token;
    $0ae54673f4de9042$var$expect(lexer, $5G1OP.TokenKind.AT);
    return {
        kind: $cU2Ah.Kind.DIRECTIVE,
        name: $0ae54673f4de9042$var$parseName(lexer),
        arguments: $0ae54673f4de9042$var$parseArguments(lexer, isConst),
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
} // Implements the parsing rules in the Types section.
/**
 * Type :
 *   - NamedType
 *   - ListType
 *   - NonNullType
 */ function $0ae54673f4de9042$var$parseTypeReference(lexer) {
    var start = lexer.token;
    var type;
    if ($0ae54673f4de9042$var$skip(lexer, $5G1OP.TokenKind.BRACKET_L)) {
        type = $0ae54673f4de9042$var$parseTypeReference(lexer);
        $0ae54673f4de9042$var$expect(lexer, $5G1OP.TokenKind.BRACKET_R);
        type = {
            kind: $cU2Ah.Kind.LIST_TYPE,
            type: type,
            loc: $0ae54673f4de9042$var$loc(lexer, start)
        };
    } else type = $0ae54673f4de9042$var$parseNamedType(lexer);
    if ($0ae54673f4de9042$var$skip(lexer, $5G1OP.TokenKind.BANG)) return {
        kind: $cU2Ah.Kind.NON_NULL_TYPE,
        type: type,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
    return type;
}
/**
 * NamedType : Name
 */ function $0ae54673f4de9042$var$parseNamedType(lexer) {
    var start = lexer.token;
    return {
        kind: $cU2Ah.Kind.NAMED_TYPE,
        name: $0ae54673f4de9042$var$parseName(lexer),
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
} // Implements the parsing rules in the Type Definition section.
/**
 * TypeSystemDefinition :
 *   - SchemaDefinition
 *   - TypeDefinition
 *   - DirectiveDefinition
 *
 * TypeDefinition :
 *   - ScalarTypeDefinition
 *   - ObjectTypeDefinition
 *   - InterfaceTypeDefinition
 *   - UnionTypeDefinition
 *   - EnumTypeDefinition
 *   - InputObjectTypeDefinition
 */ function $0ae54673f4de9042$var$parseTypeSystemDefinition(lexer) {
    // Many definitions begin with a description and require a lookahead.
    var keywordToken = $0ae54673f4de9042$var$peekDescription(lexer) ? lexer.lookahead() : lexer.token;
    if (keywordToken.kind === $5G1OP.TokenKind.NAME) switch(keywordToken.value){
        case "schema":
            return $0ae54673f4de9042$var$parseSchemaDefinition(lexer);
        case "scalar":
            return $0ae54673f4de9042$var$parseScalarTypeDefinition(lexer);
        case "type":
            return $0ae54673f4de9042$var$parseObjectTypeDefinition(lexer);
        case "interface":
            return $0ae54673f4de9042$var$parseInterfaceTypeDefinition(lexer);
        case "union":
            return $0ae54673f4de9042$var$parseUnionTypeDefinition(lexer);
        case "enum":
            return $0ae54673f4de9042$var$parseEnumTypeDefinition(lexer);
        case "input":
            return $0ae54673f4de9042$var$parseInputObjectTypeDefinition(lexer);
        case "directive":
            return $0ae54673f4de9042$var$parseDirectiveDefinition(lexer);
    }
    throw $0ae54673f4de9042$var$unexpected(lexer, keywordToken);
}
function $0ae54673f4de9042$var$peekDescription(lexer) {
    return $0ae54673f4de9042$var$peek(lexer, $5G1OP.TokenKind.STRING) || $0ae54673f4de9042$var$peek(lexer, $5G1OP.TokenKind.BLOCK_STRING);
}
/**
 * Description : StringValue
 */ function $0ae54673f4de9042$var$parseDescription(lexer) {
    if ($0ae54673f4de9042$var$peekDescription(lexer)) return $0ae54673f4de9042$var$parseStringLiteral(lexer);
}
/**
 * SchemaDefinition : schema Directives[Const]? { OperationTypeDefinition+ }
 */ function $0ae54673f4de9042$var$parseSchemaDefinition(lexer) {
    var start = lexer.token;
    $0ae54673f4de9042$var$expectKeyword(lexer, "schema");
    var directives = $0ae54673f4de9042$var$parseDirectives(lexer, true);
    var operationTypes = $0ae54673f4de9042$var$many(lexer, $5G1OP.TokenKind.BRACE_L, $0ae54673f4de9042$var$parseOperationTypeDefinition, $5G1OP.TokenKind.BRACE_R);
    return {
        kind: $cU2Ah.Kind.SCHEMA_DEFINITION,
        directives: directives,
        operationTypes: operationTypes,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * OperationTypeDefinition : OperationType : NamedType
 */ function $0ae54673f4de9042$var$parseOperationTypeDefinition(lexer) {
    var start = lexer.token;
    var operation = $0ae54673f4de9042$var$parseOperationType(lexer);
    $0ae54673f4de9042$var$expect(lexer, $5G1OP.TokenKind.COLON);
    var type = $0ae54673f4de9042$var$parseNamedType(lexer);
    return {
        kind: $cU2Ah.Kind.OPERATION_TYPE_DEFINITION,
        operation: operation,
        type: type,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
 */ function $0ae54673f4de9042$var$parseScalarTypeDefinition(lexer) {
    var start = lexer.token;
    var description = $0ae54673f4de9042$var$parseDescription(lexer);
    $0ae54673f4de9042$var$expectKeyword(lexer, "scalar");
    var name = $0ae54673f4de9042$var$parseName(lexer);
    var directives = $0ae54673f4de9042$var$parseDirectives(lexer, true);
    return {
        kind: $cU2Ah.Kind.SCALAR_TYPE_DEFINITION,
        description: description,
        name: name,
        directives: directives,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * ObjectTypeDefinition :
 *   Description?
 *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
 */ function $0ae54673f4de9042$var$parseObjectTypeDefinition(lexer) {
    var start = lexer.token;
    var description = $0ae54673f4de9042$var$parseDescription(lexer);
    $0ae54673f4de9042$var$expectKeyword(lexer, "type");
    var name = $0ae54673f4de9042$var$parseName(lexer);
    var interfaces = $0ae54673f4de9042$var$parseImplementsInterfaces(lexer);
    var directives = $0ae54673f4de9042$var$parseDirectives(lexer, true);
    var fields = $0ae54673f4de9042$var$parseFieldsDefinition(lexer);
    return {
        kind: $cU2Ah.Kind.OBJECT_TYPE_DEFINITION,
        description: description,
        name: name,
        interfaces: interfaces,
        directives: directives,
        fields: fields,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * ImplementsInterfaces :
 *   - implements `&`? NamedType
 *   - ImplementsInterfaces & NamedType
 */ function $0ae54673f4de9042$var$parseImplementsInterfaces(lexer) {
    var types = [];
    if (lexer.token.value === "implements") {
        lexer.advance(); // Optional leading ampersand
        $0ae54673f4de9042$var$skip(lexer, $5G1OP.TokenKind.AMP);
        do types.push($0ae54673f4de9042$var$parseNamedType(lexer));
        while ($0ae54673f4de9042$var$skip(lexer, $5G1OP.TokenKind.AMP) || // Legacy support for the SDL?
        lexer.options.allowLegacySDLImplementsInterfaces && $0ae54673f4de9042$var$peek(lexer, $5G1OP.TokenKind.NAME));
    }
    return types;
}
/**
 * FieldsDefinition : { FieldDefinition+ }
 */ function $0ae54673f4de9042$var$parseFieldsDefinition(lexer) {
    // Legacy support for the SDL?
    if (lexer.options.allowLegacySDLEmptyFields && $0ae54673f4de9042$var$peek(lexer, $5G1OP.TokenKind.BRACE_L) && lexer.lookahead().kind === $5G1OP.TokenKind.BRACE_R) {
        lexer.advance();
        lexer.advance();
        return [];
    }
    return $0ae54673f4de9042$var$peek(lexer, $5G1OP.TokenKind.BRACE_L) ? $0ae54673f4de9042$var$many(lexer, $5G1OP.TokenKind.BRACE_L, $0ae54673f4de9042$var$parseFieldDefinition, $5G1OP.TokenKind.BRACE_R) : [];
}
/**
 * FieldDefinition :
 *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
 */ function $0ae54673f4de9042$var$parseFieldDefinition(lexer) {
    var start = lexer.token;
    var description = $0ae54673f4de9042$var$parseDescription(lexer);
    var name = $0ae54673f4de9042$var$parseName(lexer);
    var args = $0ae54673f4de9042$var$parseArgumentDefs(lexer);
    $0ae54673f4de9042$var$expect(lexer, $5G1OP.TokenKind.COLON);
    var type = $0ae54673f4de9042$var$parseTypeReference(lexer);
    var directives = $0ae54673f4de9042$var$parseDirectives(lexer, true);
    return {
        kind: $cU2Ah.Kind.FIELD_DEFINITION,
        description: description,
        name: name,
        arguments: args,
        type: type,
        directives: directives,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * ArgumentsDefinition : ( InputValueDefinition+ )
 */ function $0ae54673f4de9042$var$parseArgumentDefs(lexer) {
    if (!$0ae54673f4de9042$var$peek(lexer, $5G1OP.TokenKind.PAREN_L)) return [];
    return $0ae54673f4de9042$var$many(lexer, $5G1OP.TokenKind.PAREN_L, $0ae54673f4de9042$var$parseInputValueDef, $5G1OP.TokenKind.PAREN_R);
}
/**
 * InputValueDefinition :
 *   - Description? Name : Type DefaultValue? Directives[Const]?
 */ function $0ae54673f4de9042$var$parseInputValueDef(lexer) {
    var start = lexer.token;
    var description = $0ae54673f4de9042$var$parseDescription(lexer);
    var name = $0ae54673f4de9042$var$parseName(lexer);
    $0ae54673f4de9042$var$expect(lexer, $5G1OP.TokenKind.COLON);
    var type = $0ae54673f4de9042$var$parseTypeReference(lexer);
    var defaultValue;
    if ($0ae54673f4de9042$var$skip(lexer, $5G1OP.TokenKind.EQUALS)) defaultValue = $0ae54673f4de9042$var$parseConstValue(lexer);
    var directives = $0ae54673f4de9042$var$parseDirectives(lexer, true);
    return {
        kind: $cU2Ah.Kind.INPUT_VALUE_DEFINITION,
        description: description,
        name: name,
        type: type,
        defaultValue: defaultValue,
        directives: directives,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * InterfaceTypeDefinition :
 *   - Description? interface Name Directives[Const]? FieldsDefinition?
 */ function $0ae54673f4de9042$var$parseInterfaceTypeDefinition(lexer) {
    var start = lexer.token;
    var description = $0ae54673f4de9042$var$parseDescription(lexer);
    $0ae54673f4de9042$var$expectKeyword(lexer, "interface");
    var name = $0ae54673f4de9042$var$parseName(lexer);
    var directives = $0ae54673f4de9042$var$parseDirectives(lexer, true);
    var fields = $0ae54673f4de9042$var$parseFieldsDefinition(lexer);
    return {
        kind: $cU2Ah.Kind.INTERFACE_TYPE_DEFINITION,
        description: description,
        name: name,
        directives: directives,
        fields: fields,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * UnionTypeDefinition :
 *   - Description? union Name Directives[Const]? UnionMemberTypes?
 */ function $0ae54673f4de9042$var$parseUnionTypeDefinition(lexer) {
    var start = lexer.token;
    var description = $0ae54673f4de9042$var$parseDescription(lexer);
    $0ae54673f4de9042$var$expectKeyword(lexer, "union");
    var name = $0ae54673f4de9042$var$parseName(lexer);
    var directives = $0ae54673f4de9042$var$parseDirectives(lexer, true);
    var types = $0ae54673f4de9042$var$parseUnionMemberTypes(lexer);
    return {
        kind: $cU2Ah.Kind.UNION_TYPE_DEFINITION,
        description: description,
        name: name,
        directives: directives,
        types: types,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * UnionMemberTypes :
 *   - = `|`? NamedType
 *   - UnionMemberTypes | NamedType
 */ function $0ae54673f4de9042$var$parseUnionMemberTypes(lexer) {
    var types = [];
    if ($0ae54673f4de9042$var$skip(lexer, $5G1OP.TokenKind.EQUALS)) {
        // Optional leading pipe
        $0ae54673f4de9042$var$skip(lexer, $5G1OP.TokenKind.PIPE);
        do types.push($0ae54673f4de9042$var$parseNamedType(lexer));
        while ($0ae54673f4de9042$var$skip(lexer, $5G1OP.TokenKind.PIPE));
    }
    return types;
}
/**
 * EnumTypeDefinition :
 *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
 */ function $0ae54673f4de9042$var$parseEnumTypeDefinition(lexer) {
    var start = lexer.token;
    var description = $0ae54673f4de9042$var$parseDescription(lexer);
    $0ae54673f4de9042$var$expectKeyword(lexer, "enum");
    var name = $0ae54673f4de9042$var$parseName(lexer);
    var directives = $0ae54673f4de9042$var$parseDirectives(lexer, true);
    var values = $0ae54673f4de9042$var$parseEnumValuesDefinition(lexer);
    return {
        kind: $cU2Ah.Kind.ENUM_TYPE_DEFINITION,
        description: description,
        name: name,
        directives: directives,
        values: values,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * EnumValuesDefinition : { EnumValueDefinition+ }
 */ function $0ae54673f4de9042$var$parseEnumValuesDefinition(lexer) {
    return $0ae54673f4de9042$var$peek(lexer, $5G1OP.TokenKind.BRACE_L) ? $0ae54673f4de9042$var$many(lexer, $5G1OP.TokenKind.BRACE_L, $0ae54673f4de9042$var$parseEnumValueDefinition, $5G1OP.TokenKind.BRACE_R) : [];
}
/**
 * EnumValueDefinition : Description? EnumValue Directives[Const]?
 *
 * EnumValue : Name
 */ function $0ae54673f4de9042$var$parseEnumValueDefinition(lexer) {
    var start = lexer.token;
    var description = $0ae54673f4de9042$var$parseDescription(lexer);
    var name = $0ae54673f4de9042$var$parseName(lexer);
    var directives = $0ae54673f4de9042$var$parseDirectives(lexer, true);
    return {
        kind: $cU2Ah.Kind.ENUM_VALUE_DEFINITION,
        description: description,
        name: name,
        directives: directives,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * InputObjectTypeDefinition :
 *   - Description? input Name Directives[Const]? InputFieldsDefinition?
 */ function $0ae54673f4de9042$var$parseInputObjectTypeDefinition(lexer) {
    var start = lexer.token;
    var description = $0ae54673f4de9042$var$parseDescription(lexer);
    $0ae54673f4de9042$var$expectKeyword(lexer, "input");
    var name = $0ae54673f4de9042$var$parseName(lexer);
    var directives = $0ae54673f4de9042$var$parseDirectives(lexer, true);
    var fields = $0ae54673f4de9042$var$parseInputFieldsDefinition(lexer);
    return {
        kind: $cU2Ah.Kind.INPUT_OBJECT_TYPE_DEFINITION,
        description: description,
        name: name,
        directives: directives,
        fields: fields,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * InputFieldsDefinition : { InputValueDefinition+ }
 */ function $0ae54673f4de9042$var$parseInputFieldsDefinition(lexer) {
    return $0ae54673f4de9042$var$peek(lexer, $5G1OP.TokenKind.BRACE_L) ? $0ae54673f4de9042$var$many(lexer, $5G1OP.TokenKind.BRACE_L, $0ae54673f4de9042$var$parseInputValueDef, $5G1OP.TokenKind.BRACE_R) : [];
}
/**
 * TypeSystemExtension :
 *   - SchemaExtension
 *   - TypeExtension
 *
 * TypeExtension :
 *   - ScalarTypeExtension
 *   - ObjectTypeExtension
 *   - InterfaceTypeExtension
 *   - UnionTypeExtension
 *   - EnumTypeExtension
 *   - InputObjectTypeDefinition
 */ function $0ae54673f4de9042$var$parseTypeSystemExtension(lexer) {
    var keywordToken = lexer.lookahead();
    if (keywordToken.kind === $5G1OP.TokenKind.NAME) switch(keywordToken.value){
        case "schema":
            return $0ae54673f4de9042$var$parseSchemaExtension(lexer);
        case "scalar":
            return $0ae54673f4de9042$var$parseScalarTypeExtension(lexer);
        case "type":
            return $0ae54673f4de9042$var$parseObjectTypeExtension(lexer);
        case "interface":
            return $0ae54673f4de9042$var$parseInterfaceTypeExtension(lexer);
        case "union":
            return $0ae54673f4de9042$var$parseUnionTypeExtension(lexer);
        case "enum":
            return $0ae54673f4de9042$var$parseEnumTypeExtension(lexer);
        case "input":
            return $0ae54673f4de9042$var$parseInputObjectTypeExtension(lexer);
    }
    throw $0ae54673f4de9042$var$unexpected(lexer, keywordToken);
}
/**
 * SchemaExtension :
 *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
 *  - extend schema Directives[Const]
 */ function $0ae54673f4de9042$var$parseSchemaExtension(lexer) {
    var start = lexer.token;
    $0ae54673f4de9042$var$expectKeyword(lexer, "extend");
    $0ae54673f4de9042$var$expectKeyword(lexer, "schema");
    var directives = $0ae54673f4de9042$var$parseDirectives(lexer, true);
    var operationTypes = $0ae54673f4de9042$var$peek(lexer, $5G1OP.TokenKind.BRACE_L) ? $0ae54673f4de9042$var$many(lexer, $5G1OP.TokenKind.BRACE_L, $0ae54673f4de9042$var$parseOperationTypeDefinition, $5G1OP.TokenKind.BRACE_R) : [];
    if (directives.length === 0 && operationTypes.length === 0) throw $0ae54673f4de9042$var$unexpected(lexer);
    return {
        kind: $cU2Ah.Kind.SCHEMA_EXTENSION,
        directives: directives,
        operationTypes: operationTypes,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * ScalarTypeExtension :
 *   - extend scalar Name Directives[Const]
 */ function $0ae54673f4de9042$var$parseScalarTypeExtension(lexer) {
    var start = lexer.token;
    $0ae54673f4de9042$var$expectKeyword(lexer, "extend");
    $0ae54673f4de9042$var$expectKeyword(lexer, "scalar");
    var name = $0ae54673f4de9042$var$parseName(lexer);
    var directives = $0ae54673f4de9042$var$parseDirectives(lexer, true);
    if (directives.length === 0) throw $0ae54673f4de9042$var$unexpected(lexer);
    return {
        kind: $cU2Ah.Kind.SCALAR_TYPE_EXTENSION,
        name: name,
        directives: directives,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * ObjectTypeExtension :
 *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
 *  - extend type Name ImplementsInterfaces? Directives[Const]
 *  - extend type Name ImplementsInterfaces
 */ function $0ae54673f4de9042$var$parseObjectTypeExtension(lexer) {
    var start = lexer.token;
    $0ae54673f4de9042$var$expectKeyword(lexer, "extend");
    $0ae54673f4de9042$var$expectKeyword(lexer, "type");
    var name = $0ae54673f4de9042$var$parseName(lexer);
    var interfaces = $0ae54673f4de9042$var$parseImplementsInterfaces(lexer);
    var directives = $0ae54673f4de9042$var$parseDirectives(lexer, true);
    var fields = $0ae54673f4de9042$var$parseFieldsDefinition(lexer);
    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw $0ae54673f4de9042$var$unexpected(lexer);
    return {
        kind: $cU2Ah.Kind.OBJECT_TYPE_EXTENSION,
        name: name,
        interfaces: interfaces,
        directives: directives,
        fields: fields,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * InterfaceTypeExtension :
 *   - extend interface Name Directives[Const]? FieldsDefinition
 *   - extend interface Name Directives[Const]
 */ function $0ae54673f4de9042$var$parseInterfaceTypeExtension(lexer) {
    var start = lexer.token;
    $0ae54673f4de9042$var$expectKeyword(lexer, "extend");
    $0ae54673f4de9042$var$expectKeyword(lexer, "interface");
    var name = $0ae54673f4de9042$var$parseName(lexer);
    var directives = $0ae54673f4de9042$var$parseDirectives(lexer, true);
    var fields = $0ae54673f4de9042$var$parseFieldsDefinition(lexer);
    if (directives.length === 0 && fields.length === 0) throw $0ae54673f4de9042$var$unexpected(lexer);
    return {
        kind: $cU2Ah.Kind.INTERFACE_TYPE_EXTENSION,
        name: name,
        directives: directives,
        fields: fields,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * UnionTypeExtension :
 *   - extend union Name Directives[Const]? UnionMemberTypes
 *   - extend union Name Directives[Const]
 */ function $0ae54673f4de9042$var$parseUnionTypeExtension(lexer) {
    var start = lexer.token;
    $0ae54673f4de9042$var$expectKeyword(lexer, "extend");
    $0ae54673f4de9042$var$expectKeyword(lexer, "union");
    var name = $0ae54673f4de9042$var$parseName(lexer);
    var directives = $0ae54673f4de9042$var$parseDirectives(lexer, true);
    var types = $0ae54673f4de9042$var$parseUnionMemberTypes(lexer);
    if (directives.length === 0 && types.length === 0) throw $0ae54673f4de9042$var$unexpected(lexer);
    return {
        kind: $cU2Ah.Kind.UNION_TYPE_EXTENSION,
        name: name,
        directives: directives,
        types: types,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * EnumTypeExtension :
 *   - extend enum Name Directives[Const]? EnumValuesDefinition
 *   - extend enum Name Directives[Const]
 */ function $0ae54673f4de9042$var$parseEnumTypeExtension(lexer) {
    var start = lexer.token;
    $0ae54673f4de9042$var$expectKeyword(lexer, "extend");
    $0ae54673f4de9042$var$expectKeyword(lexer, "enum");
    var name = $0ae54673f4de9042$var$parseName(lexer);
    var directives = $0ae54673f4de9042$var$parseDirectives(lexer, true);
    var values = $0ae54673f4de9042$var$parseEnumValuesDefinition(lexer);
    if (directives.length === 0 && values.length === 0) throw $0ae54673f4de9042$var$unexpected(lexer);
    return {
        kind: $cU2Ah.Kind.ENUM_TYPE_EXTENSION,
        name: name,
        directives: directives,
        values: values,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * InputObjectTypeExtension :
 *   - extend input Name Directives[Const]? InputFieldsDefinition
 *   - extend input Name Directives[Const]
 */ function $0ae54673f4de9042$var$parseInputObjectTypeExtension(lexer) {
    var start = lexer.token;
    $0ae54673f4de9042$var$expectKeyword(lexer, "extend");
    $0ae54673f4de9042$var$expectKeyword(lexer, "input");
    var name = $0ae54673f4de9042$var$parseName(lexer);
    var directives = $0ae54673f4de9042$var$parseDirectives(lexer, true);
    var fields = $0ae54673f4de9042$var$parseInputFieldsDefinition(lexer);
    if (directives.length === 0 && fields.length === 0) throw $0ae54673f4de9042$var$unexpected(lexer);
    return {
        kind: $cU2Ah.Kind.INPUT_OBJECT_TYPE_EXTENSION,
        name: name,
        directives: directives,
        fields: fields,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * DirectiveDefinition :
 *   - Description? directive @ Name ArgumentsDefinition? on DirectiveLocations
 */ function $0ae54673f4de9042$var$parseDirectiveDefinition(lexer) {
    var start = lexer.token;
    var description = $0ae54673f4de9042$var$parseDescription(lexer);
    $0ae54673f4de9042$var$expectKeyword(lexer, "directive");
    $0ae54673f4de9042$var$expect(lexer, $5G1OP.TokenKind.AT);
    var name = $0ae54673f4de9042$var$parseName(lexer);
    var args = $0ae54673f4de9042$var$parseArgumentDefs(lexer);
    $0ae54673f4de9042$var$expectKeyword(lexer, "on");
    var locations = $0ae54673f4de9042$var$parseDirectiveLocations(lexer);
    return {
        kind: $cU2Ah.Kind.DIRECTIVE_DEFINITION,
        description: description,
        name: name,
        arguments: args,
        locations: locations,
        loc: $0ae54673f4de9042$var$loc(lexer, start)
    };
}
/**
 * DirectiveLocations :
 *   - `|`? DirectiveLocation
 *   - DirectiveLocations | DirectiveLocation
 */ function $0ae54673f4de9042$var$parseDirectiveLocations(lexer) {
    // Optional leading pipe
    $0ae54673f4de9042$var$skip(lexer, $5G1OP.TokenKind.PIPE);
    var locations = [];
    do locations.push($0ae54673f4de9042$var$parseDirectiveLocation(lexer));
    while ($0ae54673f4de9042$var$skip(lexer, $5G1OP.TokenKind.PIPE));
    return locations;
}
/*
 * DirectiveLocation :
 *   - ExecutableDirectiveLocation
 *   - TypeSystemDirectiveLocation
 *
 * ExecutableDirectiveLocation : one of
 *   `QUERY`
 *   `MUTATION`
 *   `SUBSCRIPTION`
 *   `FIELD`
 *   `FRAGMENT_DEFINITION`
 *   `FRAGMENT_SPREAD`
 *   `INLINE_FRAGMENT`
 *
 * TypeSystemDirectiveLocation : one of
 *   `SCHEMA`
 *   `SCALAR`
 *   `OBJECT`
 *   `FIELD_DEFINITION`
 *   `ARGUMENT_DEFINITION`
 *   `INTERFACE`
 *   `UNION`
 *   `ENUM`
 *   `ENUM_VALUE`
 *   `INPUT_OBJECT`
 *   `INPUT_FIELD_DEFINITION`
 */ function $0ae54673f4de9042$var$parseDirectiveLocation(lexer) {
    var start = lexer.token;
    var name = $0ae54673f4de9042$var$parseName(lexer);
    if ($doQi7.DirectiveLocation.hasOwnProperty(name.value)) return name;
    throw $0ae54673f4de9042$var$unexpected(lexer, start);
} // Core parsing utility functions
/**
 * Returns a location object, used to identify the place in
 * the source that created a given parsed object.
 */ function $0ae54673f4de9042$var$loc(lexer, startToken) {
    if (!lexer.options.noLocation) return new $0ae54673f4de9042$var$Loc(startToken, lexer.lastToken, lexer.source);
}
function $0ae54673f4de9042$var$Loc(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
} // Print a simplified form when appearing in JSON/util.inspect.
$0ae54673f4de9042$var$Loc.prototype.toJSON = $0ae54673f4de9042$var$Loc.prototype.inspect = function toJSON() {
    return {
        start: this.start,
        end: this.end
    };
};
/**
 * Determines if the next token is of a given kind
 */ function $0ae54673f4de9042$var$peek(lexer, kind) {
    return lexer.token.kind === kind;
}
/**
 * If the next token is of the given kind, return true after advancing
 * the lexer. Otherwise, do not change the parser state and return false.
 */ function $0ae54673f4de9042$var$skip(lexer, kind) {
    var match = lexer.token.kind === kind;
    if (match) lexer.advance();
    return match;
}
/**
 * If the next token is of the given kind, return that token after advancing
 * the lexer. Otherwise, do not change the parser state and throw an error.
 */ function $0ae54673f4de9042$var$expect(lexer, kind) {
    var token = lexer.token;
    if (token.kind === kind) {
        lexer.advance();
        return token;
    }
    throw (0, $4Ic4S.syntaxError)(lexer.source, token.start, "Expected ".concat(kind, ", found ").concat((0, $5G1OP.getTokenDesc)(token)));
}
/**
 * If the next token is a keyword with the given value, return that token after
 * advancing the lexer. Otherwise, do not change the parser state and return
 * false.
 */ function $0ae54673f4de9042$var$expectKeyword(lexer, value) {
    var token = lexer.token;
    if (token.kind === $5G1OP.TokenKind.NAME && token.value === value) {
        lexer.advance();
        return token;
    }
    throw (0, $4Ic4S.syntaxError)(lexer.source, token.start, 'Expected "'.concat(value, '", found ').concat((0, $5G1OP.getTokenDesc)(token)));
}
/**
 * Helper function for creating an error when an unexpected lexed token
 * is encountered.
 */ function $0ae54673f4de9042$var$unexpected(lexer, atToken) {
    var token = atToken || lexer.token;
    return (0, $4Ic4S.syntaxError)(lexer.source, token.start, "Unexpected ".concat((0, $5G1OP.getTokenDesc)(token)));
}
/**
 * Returns a possibly empty list of parse nodes, determined by
 * the parseFn. This list begins with a lex token of openKind
 * and ends with a lex token of closeKind. Advances the parser
 * to the next lex token after the closing token.
 */ function $0ae54673f4de9042$var$any(lexer, openKind, parseFn, closeKind) {
    $0ae54673f4de9042$var$expect(lexer, openKind);
    var nodes = [];
    while(!$0ae54673f4de9042$var$skip(lexer, closeKind))nodes.push(parseFn(lexer));
    return nodes;
}
/**
 * Returns a non-empty list of parse nodes, determined by
 * the parseFn. This list begins with a lex token of openKind
 * and ends with a lex token of closeKind. Advances the parser
 * to the next lex token after the closing token.
 */ function $0ae54673f4de9042$var$many(lexer, openKind, parseFn, closeKind) {
    $0ae54673f4de9042$var$expect(lexer, openKind);
    var nodes = [
        parseFn(lexer)
    ];
    while(!$0ae54673f4de9042$var$skip(lexer, closeKind))nodes.push(parseFn(lexer));
    return nodes;
}

});
parcelRequire.register("1vcsZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $11825b4e601ed482$var$inspect;
function $11825b4e601ed482$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $11825b4e601ed482$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $11825b4e601ed482$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $11825b4e601ed482$var$_typeof(obj);
}
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Used to print values in error messages.
 */ function $11825b4e601ed482$var$inspect(value) {
    return value && $11825b4e601ed482$var$_typeof(value) === "object" ? typeof value.inspect === "function" ? value.inspect() : Array.isArray(value) ? "[" + value.map($11825b4e601ed482$var$inspect).join(", ") + "]" : "{" + Object.keys(value).map(function(k) {
        return "".concat(k, ": ").concat($11825b4e601ed482$var$inspect(value[k]));
    }).join(", ") + "}" : typeof value === "string" ? '"' + value + '"' : typeof value === "function" ? "[function ".concat(value.name, "]") : String(value);
}

});

parcelRequire.register("RBQuR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Source = void 0;

var $0a124eb94deab373$var$_invariant = $0a124eb94deab373$var$_interopRequireDefault((parcelRequire("dMz3I")));

var $0a124eb94deab373$var$_defineToStringTag = $0a124eb94deab373$var$_interopRequireDefault((parcelRequire("bh8Zl")));
function $0a124eb94deab373$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0a124eb94deab373$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * A representation of source input to GraphQL.
 * `name` and `locationOffset` are optional. They are useful for clients who
 * store GraphQL documents in source files; for example, if the GraphQL input
 * starts at line 40 in a file named Foo.graphql, it might be useful for name to
 * be "Foo.graphql" and location to be `{ line: 40, column: 0 }`.
 * line and column in locationOffset are 1-indexed
 */ var $0a124eb94deab373$var$Source = function Source(body, name, locationOffset) {
    $0a124eb94deab373$var$_defineProperty(this, "body", void 0);
    $0a124eb94deab373$var$_defineProperty(this, "name", void 0);
    $0a124eb94deab373$var$_defineProperty(this, "locationOffset", void 0);
    this.body = body;
    this.name = name || "GraphQL request";
    this.locationOffset = locationOffset || {
        line: 1,
        column: 1
    };
    !(this.locationOffset.line > 0) && (0, $0a124eb94deab373$var$_invariant.default)(0, "line in locationOffset is 1-indexed and must be positive");
    !(this.locationOffset.column > 0) && (0, $0a124eb94deab373$var$_invariant.default)(0, "column in locationOffset is 1-indexed and must be positive");
}; // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported
module.exports.Source = $0a124eb94deab373$var$Source;
(0, $0a124eb94deab373$var$_defineToStringTag.default)($0a124eb94deab373$var$Source);

});
parcelRequire.register("dMz3I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a08af40a871e2afa$var$invariant;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ function $a08af40a871e2afa$var$invariant(condition, message) {
    /* istanbul ignore else */ if (!condition) throw new Error(message);
}

});

parcelRequire.register("bh8Zl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8358412bc6a61d8e$var$applyToStringTag;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * The `applyToStringTag()` function checks first to see if the runtime
 * supports the `Symbol` class and then if the `Symbol.toStringTag` constant
 * is defined as a `Symbol` instance. If both conditions are met, the
 * Symbol.toStringTag property is defined as a getter that returns the
 * supplied class constructor's name.
 *
 * @method applyToStringTag
 *
 * @param {Class<any>} classObject a class such as Object, String, Number but
 * typically one of your own creation through the class keyword; `class A {}`,
 * for example.
 */ function $8358412bc6a61d8e$var$applyToStringTag(classObject) {
    if (typeof Symbol === "function" && Symbol.toStringTag) Object.defineProperty(classObject.prototype, Symbol.toStringTag, {
        get: function get() {
            return this.constructor.name;
        }
    });
}

});


parcelRequire.register("4Ic4S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "GraphQLError", {
    enumerable: true,
    get: function get() {
        return $76DNy.GraphQLError;
    }
});
Object.defineProperty(module.exports, "syntaxError", {
    enumerable: true,
    get: function get() {
        return $7KiYl.syntaxError;
    }
});
Object.defineProperty(module.exports, "locatedError", {
    enumerable: true,
    get: function get() {
        return $cslD3.locatedError;
    }
});
Object.defineProperty(module.exports, "printError", {
    enumerable: true,
    get: function get() {
        return $9hrSa.printError;
    }
});
Object.defineProperty(module.exports, "formatError", {
    enumerable: true,
    get: function get() {
        return $2idrZ.formatError;
    }
});

var $76DNy = parcelRequire("76DNy");

var $7KiYl = parcelRequire("7KiYl");

var $cslD3 = parcelRequire("cslD3");

var $9hrSa = parcelRequire("9hrSa");

var $2idrZ = parcelRequire("2idrZ");

});
parcelRequire.register("76DNy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GraphQLError = $52c7f70b34e305a7$var$GraphQLError;

var $9hrSa = parcelRequire("9hrSa");

var $aZdVo = parcelRequire("aZdVo");
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ function $52c7f70b34e305a7$var$GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
    // Compute list of blame nodes.
    var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [
        nodes
    ] : undefined; // Compute locations in the source for the given nodes/positions.
    var _source = source;
    if (!_source && _nodes) {
        var node = _nodes[0];
        _source = node && node.loc && node.loc.source;
    }
    var _positions = positions;
    if (!_positions && _nodes) _positions = _nodes.reduce(function(list, node) {
        if (node.loc) list.push(node.loc.start);
        return list;
    }, []);
    if (_positions && _positions.length === 0) _positions = undefined;
    var _locations;
    if (positions && source) _locations = positions.map(function(pos) {
        return (0, $aZdVo.getLocation)(source, pos);
    });
    else if (_nodes) _locations = _nodes.reduce(function(list, node) {
        if (node.loc) list.push((0, $aZdVo.getLocation)(node.loc.source, node.loc.start));
        return list;
    }, []);
    var _extensions = extensions || originalError && originalError.extensions;
    Object.defineProperties(this, {
        message: {
            value: message,
            // By being enumerable, JSON.stringify will include `message` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: true,
            writable: true
        },
        locations: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _locations || undefined,
            // By being enumerable, JSON.stringify will include `locations` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(_locations)
        },
        path: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: path || undefined,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(path)
        },
        nodes: {
            value: _nodes || undefined
        },
        source: {
            value: _source || undefined
        },
        positions: {
            value: _positions || undefined
        },
        originalError: {
            value: originalError
        },
        extensions: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _extensions || undefined,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(_extensions)
        }
    }); // Include (non-enumerable) stack trace.
    if (originalError && originalError.stack) Object.defineProperty(this, "stack", {
        value: originalError.stack,
        writable: true,
        configurable: true
    });
    else if (Error.captureStackTrace) Error.captureStackTrace(this, $52c7f70b34e305a7$var$GraphQLError);
    else Object.defineProperty(this, "stack", {
        value: Error().stack,
        writable: true,
        configurable: true
    });
}
$52c7f70b34e305a7$var$GraphQLError.prototype = Object.create(Error.prototype, {
    constructor: {
        value: $52c7f70b34e305a7$var$GraphQLError
    },
    name: {
        value: "GraphQLError"
    },
    toString: {
        value: function toString() {
            return (0, $9hrSa.printError)(this);
        }
    }
});

});
parcelRequire.register("9hrSa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.printError = $6c1b527febc31f22$var$printError;

var $aZdVo = parcelRequire("aZdVo");
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */ function $6c1b527febc31f22$var$printError(error) {
    var printedLocations = [];
    if (error.nodes) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = error.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var node = _step.value;
                if (node.loc) printedLocations.push($6c1b527febc31f22$var$highlightSourceAtLocation(node.loc.source, (0, $aZdVo.getLocation)(node.loc.source, node.loc.start)));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
    } else if (error.source && error.locations) {
        var source = error.source;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;
        try {
            for(var _iterator2 = error.locations[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var location = _step2.value;
                printedLocations.push($6c1b527febc31f22$var$highlightSourceAtLocation(source, location));
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) _iterator2.return();
            } finally{
                if (_didIteratorError2) throw _iteratorError2;
            }
        }
    }
    return printedLocations.length === 0 ? error.message : [
        error.message
    ].concat(printedLocations).join("\n\n") + "\n";
}
/**
 * Render a helpful description of the location of the error in the GraphQL
 * Source document.
 */ function $6c1b527febc31f22$var$highlightSourceAtLocation(source, location) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $6c1b527febc31f22$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = location.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = location.line + lineOffset;
    var columnOffset = location.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = location.column + columnOffset;
    var lines = body.split(/\r\n|[\n\r]/g);
    return "".concat(source.name, " (").concat(lineNum, ":").concat(columnNum, ")\n") + $6c1b527febc31f22$var$printPrefixedLines([
        [
            "".concat(lineNum - 1, ": "),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum, ": "),
            lines[lineIndex]
        ],
        [
            "",
            $6c1b527febc31f22$var$whitespace(columnNum - 1) + "^"
        ],
        [
            "".concat(lineNum + 1, ": "),
            lines[lineIndex + 1]
        ]
    ]);
}
function $6c1b527febc31f22$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = 0;
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;
    try {
        for(var _iterator3 = existingLines[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
            var _ref4 = _step3.value;
            var prefix = _ref4[0];
            padLen = Math.max(padLen, prefix.length);
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) _iterator3.return();
        } finally{
            if (_didIteratorError3) throw _iteratorError3;
        }
    }
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $6c1b527febc31f22$var$lpad(padLen, prefix) + line;
    }).join("\n");
}
function $6c1b527febc31f22$var$whitespace(len) {
    return Array(len + 1).join(" ");
}
function $6c1b527febc31f22$var$lpad(len, str) {
    return $6c1b527febc31f22$var$whitespace(len - str.length) + str;
}

});
parcelRequire.register("aZdVo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLocation = $7ffa670a74fc3f66$var$getLocation;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $7ffa670a74fc3f66$var$getLocation(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});



parcelRequire.register("7KiYl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.syntaxError = $5a3b8bcae30dc42e$var$syntaxError;

var $76DNy = parcelRequire("76DNy");
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */ function $5a3b8bcae30dc42e$var$syntaxError(source, position, description) {
    return new $76DNy.GraphQLError("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});

parcelRequire.register("cslD3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.locatedError = $9118e09ec71ca2e7$var$locatedError;

var $76DNy = parcelRequire("76DNy");
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Given an arbitrary Error, presumably thrown while attempting to execute a
 * GraphQL operation, produce a new GraphQLError aware of the location in the
 * document responsible for the original Error.
 */ function $9118e09ec71ca2e7$var$locatedError(originalError, nodes, path) {
    // Note: this uses a brand-check to support GraphQL errors originating from
    // other contexts.
    if (originalError && Array.isArray(originalError.path)) return originalError;
    return new $76DNy.GraphQLError(originalError && originalError.message, originalError && originalError.nodes || nodes, originalError && originalError.source, originalError && originalError.positions, path, originalError);
}

});

parcelRequire.register("2idrZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatError = $1ab7b22fcc11849b$var$formatError;

var $1ab7b22fcc11849b$var$_invariant = $1ab7b22fcc11849b$var$_interopRequireDefault((parcelRequire("dMz3I")));
function $1ab7b22fcc11849b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 */ function $1ab7b22fcc11849b$var$formatError(error) {
    !error && (0, $1ab7b22fcc11849b$var$_invariant.default)(0, "Received null or undefined error.");
    var message = error.message || "An unknown error occurred.";
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
}

});


parcelRequire.register("5G1OP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createLexer = $422249281799c89d$var$createLexer;
module.exports.getTokenDesc = $422249281799c89d$var$getTokenDesc;
module.exports.TokenKind = void 0;

var $4Ic4S = parcelRequire("4Ic4S");

var $422249281799c89d$var$_blockStringValue = $422249281799c89d$var$_interopRequireDefault((parcelRequire("bo8Xw")));
function $422249281799c89d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Given a Source object, this returns a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */ function $422249281799c89d$var$createLexer(source, options) {
    var startOfFileToken = new $422249281799c89d$var$Tok($422249281799c89d$var$TokenKind.SOF, 0, 0, 0, 0, null);
    var lexer = {
        source: source,
        options: options,
        lastToken: startOfFileToken,
        token: startOfFileToken,
        line: 1,
        lineStart: 0,
        advance: $422249281799c89d$var$advanceLexer,
        lookahead: $422249281799c89d$var$lookahead
    };
    return lexer;
}
function $422249281799c89d$var$advanceLexer() {
    this.lastToken = this.token;
    var token = this.token = this.lookahead();
    return token;
}
function $422249281799c89d$var$lookahead() {
    var token = this.token;
    if (token.kind !== $422249281799c89d$var$TokenKind.EOF) do // Note: next is only mutable during parsing, so we cast to allow this.
    token = token.next || (token.next = $422249281799c89d$var$readToken(this, token));
    while (token.kind === $422249281799c89d$var$TokenKind.COMMENT);
    return token;
}
/**
 * The return type of createLexer.
 */ /**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $422249281799c89d$var$TokenKind = Object.freeze({
    SOF: "<SOF>",
    EOF: "<EOF>",
    BANG: "!",
    DOLLAR: "$",
    AMP: "&",
    PAREN_L: "(",
    PAREN_R: ")",
    SPREAD: "...",
    COLON: ":",
    EQUALS: "=",
    AT: "@",
    BRACKET_L: "[",
    BRACKET_R: "]",
    BRACE_L: "{",
    PIPE: "|",
    BRACE_R: "}",
    NAME: "Name",
    INT: "Int",
    FLOAT: "Float",
    STRING: "String",
    BLOCK_STRING: "BlockString",
    COMMENT: "Comment"
});
/**
 * The enum type representing the token kinds values.
 */ module.exports.TokenKind = $422249281799c89d$var$TokenKind;
/**
 * A helper function to describe a token as a string for debugging
 */ function $422249281799c89d$var$getTokenDesc(token) {
    var value = token.value;
    return value ? "".concat(token.kind, ' "').concat(value, '"') : token.kind;
}
var $422249281799c89d$var$charCodeAt = String.prototype.charCodeAt;
var $422249281799c89d$var$slice = String.prototype.slice;
/**
 * Helper function for constructing the Token object.
 */ function $422249281799c89d$var$Tok(kind, start, end, line, column, prev, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column;
    this.value = value;
    this.prev = prev;
    this.next = null;
} // Print a simplified form when appearing in JSON/util.inspect.
$422249281799c89d$var$Tok.prototype.toJSON = $422249281799c89d$var$Tok.prototype.inspect = function toJSON() {
    return {
        kind: this.kind,
        value: this.value,
        line: this.line,
        column: this.column
    };
};
function $422249281799c89d$var$printCharCode(code) {
    return isNaN(code) ? $422249281799c89d$var$TokenKind.EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : '"\\u'.concat(("00" + code.toString(16).toUpperCase()).slice(-4), '"');
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace and comments until it finds the next lexable
 * token, then lexes punctuators immediately or calls the appropriate helper
 * function for more complicated tokens.
 */ function $422249281799c89d$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = $422249281799c89d$var$positionAfterWhitespace(body, prev.end, lexer);
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    if (pos >= bodyLength) return new $422249281799c89d$var$Tok($422249281799c89d$var$TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
    var code = $422249281799c89d$var$charCodeAt.call(body, pos); // SourceCharacter
    switch(code){
        // !
        case 33:
            return new $422249281799c89d$var$Tok($422249281799c89d$var$TokenKind.BANG, pos, pos + 1, line, col, prev);
        // #
        case 35:
            return $422249281799c89d$var$readComment(source, pos, line, col, prev);
        // $
        case 36:
            return new $422249281799c89d$var$Tok($422249281799c89d$var$TokenKind.DOLLAR, pos, pos + 1, line, col, prev);
        // &
        case 38:
            return new $422249281799c89d$var$Tok($422249281799c89d$var$TokenKind.AMP, pos, pos + 1, line, col, prev);
        // (
        case 40:
            return new $422249281799c89d$var$Tok($422249281799c89d$var$TokenKind.PAREN_L, pos, pos + 1, line, col, prev);
        // )
        case 41:
            return new $422249281799c89d$var$Tok($422249281799c89d$var$TokenKind.PAREN_R, pos, pos + 1, line, col, prev);
        // .
        case 46:
            if ($422249281799c89d$var$charCodeAt.call(body, pos + 1) === 46 && $422249281799c89d$var$charCodeAt.call(body, pos + 2) === 46) return new $422249281799c89d$var$Tok($422249281799c89d$var$TokenKind.SPREAD, pos, pos + 3, line, col, prev);
            break;
        // :
        case 58:
            return new $422249281799c89d$var$Tok($422249281799c89d$var$TokenKind.COLON, pos, pos + 1, line, col, prev);
        // =
        case 61:
            return new $422249281799c89d$var$Tok($422249281799c89d$var$TokenKind.EQUALS, pos, pos + 1, line, col, prev);
        // @
        case 64:
            return new $422249281799c89d$var$Tok($422249281799c89d$var$TokenKind.AT, pos, pos + 1, line, col, prev);
        // [
        case 91:
            return new $422249281799c89d$var$Tok($422249281799c89d$var$TokenKind.BRACKET_L, pos, pos + 1, line, col, prev);
        // ]
        case 93:
            return new $422249281799c89d$var$Tok($422249281799c89d$var$TokenKind.BRACKET_R, pos, pos + 1, line, col, prev);
        // {
        case 123:
            return new $422249281799c89d$var$Tok($422249281799c89d$var$TokenKind.BRACE_L, pos, pos + 1, line, col, prev);
        // |
        case 124:
            return new $422249281799c89d$var$Tok($422249281799c89d$var$TokenKind.PIPE, pos, pos + 1, line, col, prev);
        // }
        case 125:
            return new $422249281799c89d$var$Tok($422249281799c89d$var$TokenKind.BRACE_R, pos, pos + 1, line, col, prev);
        // A-Z _ a-z
        case 65:
        case 66:
        case 67:
        case 68:
        case 69:
        case 70:
        case 71:
        case 72:
        case 73:
        case 74:
        case 75:
        case 76:
        case 77:
        case 78:
        case 79:
        case 80:
        case 81:
        case 82:
        case 83:
        case 84:
        case 85:
        case 86:
        case 87:
        case 88:
        case 89:
        case 90:
        case 95:
        case 97:
        case 98:
        case 99:
        case 100:
        case 101:
        case 102:
        case 103:
        case 104:
        case 105:
        case 106:
        case 107:
        case 108:
        case 109:
        case 110:
        case 111:
        case 112:
        case 113:
        case 114:
        case 115:
        case 116:
        case 117:
        case 118:
        case 119:
        case 120:
        case 121:
        case 122:
            return $422249281799c89d$var$readName(source, pos, line, col, prev);
        // - 0-9
        case 45:
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
            return $422249281799c89d$var$readNumber(source, pos, code, line, col, prev);
        // "
        case 34:
            if ($422249281799c89d$var$charCodeAt.call(body, pos + 1) === 34 && $422249281799c89d$var$charCodeAt.call(body, pos + 2) === 34) return $422249281799c89d$var$readBlockString(source, pos, line, col, prev);
            return $422249281799c89d$var$readString(source, pos, line, col, prev);
    }
    throw (0, $4Ic4S.syntaxError)(source, pos, $422249281799c89d$var$unexpectedCharacterMessage(code));
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $422249281799c89d$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($422249281799c89d$var$printCharCode(code), ".");
    if (code === 39) // '
    return "Unexpected single quote character ('), did you mean to use a double quote (\")?";
    return "Cannot parse the unexpected character ".concat($422249281799c89d$var$printCharCode(code), ".");
}
/**
 * Reads from body starting at startPosition until it finds a non-whitespace
 * or commented character, then returns the position of that character for
 * lexing.
 */ function $422249281799c89d$var$positionAfterWhitespace(body, startPosition, lexer) {
    var bodyLength = body.length;
    var position = startPosition;
    while(position < bodyLength){
        var code = $422249281799c89d$var$charCodeAt.call(body, position); // tab | space | comma | BOM
        if (code === 9 || code === 32 || code === 44 || code === 0xfeff) ++position;
        else if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if ($422249281799c89d$var$charCodeAt.call(body, position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else break;
    }
    return position;
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $422249281799c89d$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = $422249281799c89d$var$charCodeAt.call(body, ++position);
    while (code !== null && (code > 0x001f || code === 0x0009));
    return new $422249281799c89d$var$Tok($422249281799c89d$var$TokenKind.COMMENT, start, position, line, col, prev, $422249281799c89d$var$slice.call(body, start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $422249281799c89d$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = $422249281799c89d$var$charCodeAt.call(body, ++position);
    if (code === 48) {
        // 0
        code = $422249281799c89d$var$charCodeAt.call(body, ++position);
        if (code >= 48 && code <= 57) throw (0, $4Ic4S.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($422249281799c89d$var$printCharCode(code), "."));
    } else {
        position = $422249281799c89d$var$readDigits(source, position, code);
        code = $422249281799c89d$var$charCodeAt.call(body, position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = $422249281799c89d$var$charCodeAt.call(body, ++position);
        position = $422249281799c89d$var$readDigits(source, position, code);
        code = $422249281799c89d$var$charCodeAt.call(body, position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = $422249281799c89d$var$charCodeAt.call(body, ++position);
        if (code === 43 || code === 45) // + -
        code = $422249281799c89d$var$charCodeAt.call(body, ++position);
        position = $422249281799c89d$var$readDigits(source, position, code);
    }
    return new $422249281799c89d$var$Tok(isFloat ? $422249281799c89d$var$TokenKind.FLOAT : $422249281799c89d$var$TokenKind.INT, start, position, line, col, prev, $422249281799c89d$var$slice.call(body, start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $422249281799c89d$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = $422249281799c89d$var$charCodeAt.call(body, ++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $4Ic4S.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($422249281799c89d$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $422249281799c89d$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = "";
    while(position < body.length && (code = $422249281799c89d$var$charCodeAt.call(body, position)) !== null && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += $422249281799c89d$var$slice.call(body, chunkStart, position);
            return new $422249281799c89d$var$Tok($422249281799c89d$var$TokenKind.STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $4Ic4S.syntaxError)(source, position, "Invalid character within String: ".concat($422249281799c89d$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += $422249281799c89d$var$slice.call(body, chunkStart, position - 1);
            code = $422249281799c89d$var$charCodeAt.call(body, position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += "/";
                    break;
                case 92:
                    value += "\\";
                    break;
                case 98:
                    value += "\b";
                    break;
                case 102:
                    value += "\f";
                    break;
                case 110:
                    value += "\n";
                    break;
                case 114:
                    value += "\r";
                    break;
                case 116:
                    value += "	";
                    break;
                case 117:
                    // u
                    var charCode = $422249281799c89d$var$uniCharCode($422249281799c89d$var$charCodeAt.call(body, position + 1), $422249281799c89d$var$charCodeAt.call(body, position + 2), $422249281799c89d$var$charCodeAt.call(body, position + 3), $422249281799c89d$var$charCodeAt.call(body, position + 4));
                    if (charCode < 0) throw (0, $4Ic4S.syntaxError)(source, position, "Invalid character escape sequence: " + "\\u".concat(body.slice(position + 1, position + 5), "."));
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $4Ic4S.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $4Ic4S.syntaxError)(source, position, "Unterminated string.");
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $422249281799c89d$var$readBlockString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = "";
    while(position < body.length && (code = $422249281799c89d$var$charCodeAt.call(body, position)) !== null){
        // Closing Triple-Quote (""")
        if (code === 34 && $422249281799c89d$var$charCodeAt.call(body, position + 1) === 34 && $422249281799c89d$var$charCodeAt.call(body, position + 2) === 34) {
            rawValue += $422249281799c89d$var$slice.call(body, chunkStart, position);
            return new $422249281799c89d$var$Tok($422249281799c89d$var$TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0, $422249281799c89d$var$_blockStringValue.default)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $4Ic4S.syntaxError)(source, position, "Invalid character within String: ".concat($422249281799c89d$var$printCharCode(code), "."));
         // Escape Triple-Quote (\""")
        if (code === 92 && $422249281799c89d$var$charCodeAt.call(body, position + 1) === 34 && $422249281799c89d$var$charCodeAt.call(body, position + 2) === 34 && $422249281799c89d$var$charCodeAt.call(body, position + 3) === 34) {
            rawValue += $422249281799c89d$var$slice.call(body, chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $4Ic4S.syntaxError)(source, position, "Unterminated string.");
}
/**
 * Converts four hexidecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $422249281799c89d$var$uniCharCode(a, b, c, d) {
    return $422249281799c89d$var$char2hex(a) << 12 | $422249281799c89d$var$char2hex(b) << 8 | $422249281799c89d$var$char2hex(c) << 4 | $422249281799c89d$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $422249281799c89d$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $422249281799c89d$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && (code = $422249281799c89d$var$charCodeAt.call(body, position)) !== null && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new $422249281799c89d$var$Tok($422249281799c89d$var$TokenKind.NAME, start, position, line, col, prev, $422249281799c89d$var$slice.call(body, start, position));
}

});
parcelRequire.register("bo8Xw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $84a8e2a88ffad5f1$var$blockStringValue;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Produces the value of a block string from its parsed raw value, similar to
 * Coffeescript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 */ function $84a8e2a88ffad5f1$var$blockStringValue(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = null;
    for(var i = 1; i < lines.length; i++){
        var line = lines[i];
        var indent = $84a8e2a88ffad5f1$var$leadingWhitespace(line);
        if (indent < line.length && (commonIndent === null || indent < commonIndent)) {
            commonIndent = indent;
            if (commonIndent === 0) break;
        }
    }
    if (commonIndent) for(var _i = 1; _i < lines.length; _i++)lines[_i] = lines[_i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    while(lines.length > 0 && $84a8e2a88ffad5f1$var$isBlank(lines[0]))lines.shift();
    while(lines.length > 0 && $84a8e2a88ffad5f1$var$isBlank(lines[lines.length - 1]))lines.pop();
     // Return a string of the lines joined with U+000A.
    return lines.join("\n");
}
function $84a8e2a88ffad5f1$var$leadingWhitespace(str) {
    var i = 0;
    while(i < str.length && (str[i] === " " || str[i] === "	"))i++;
    return i;
}
function $84a8e2a88ffad5f1$var$isBlank(str) {
    return $84a8e2a88ffad5f1$var$leadingWhitespace(str) === str.length;
}

});


parcelRequire.register("cU2Ah", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Kind = void 0;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * The set of allowed kind values for AST nodes.
 */ var $964cb822ab2b8f0d$var$Kind = Object.freeze({
    // Name
    NAME: "Name",
    // Document
    DOCUMENT: "Document",
    OPERATION_DEFINITION: "OperationDefinition",
    VARIABLE_DEFINITION: "VariableDefinition",
    SELECTION_SET: "SelectionSet",
    FIELD: "Field",
    ARGUMENT: "Argument",
    // Fragments
    FRAGMENT_SPREAD: "FragmentSpread",
    INLINE_FRAGMENT: "InlineFragment",
    FRAGMENT_DEFINITION: "FragmentDefinition",
    // Values
    VARIABLE: "Variable",
    INT: "IntValue",
    FLOAT: "FloatValue",
    STRING: "StringValue",
    BOOLEAN: "BooleanValue",
    NULL: "NullValue",
    ENUM: "EnumValue",
    LIST: "ListValue",
    OBJECT: "ObjectValue",
    OBJECT_FIELD: "ObjectField",
    // Directives
    DIRECTIVE: "Directive",
    // Types
    NAMED_TYPE: "NamedType",
    LIST_TYPE: "ListType",
    NON_NULL_TYPE: "NonNullType",
    // Type System Definitions
    SCHEMA_DEFINITION: "SchemaDefinition",
    OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
    // Type Definitions
    SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
    OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
    FIELD_DEFINITION: "FieldDefinition",
    INPUT_VALUE_DEFINITION: "InputValueDefinition",
    INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
    UNION_TYPE_DEFINITION: "UnionTypeDefinition",
    ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
    ENUM_VALUE_DEFINITION: "EnumValueDefinition",
    INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
    // Directive Definitions
    DIRECTIVE_DEFINITION: "DirectiveDefinition",
    // Type System Extensions
    SCHEMA_EXTENSION: "SchemaExtension",
    // Type Extensions
    SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
    OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
    INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
    UNION_TYPE_EXTENSION: "UnionTypeExtension",
    ENUM_TYPE_EXTENSION: "EnumTypeExtension",
    INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */ module.exports.Kind = $964cb822ab2b8f0d$var$Kind;

});

parcelRequire.register("doQi7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectiveLocation = void 0;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * The set of allowed directive location values.
 */ var $9c16143380f75006$var$DirectiveLocation = Object.freeze({
    // Request Definitions
    QUERY: "QUERY",
    MUTATION: "MUTATION",
    SUBSCRIPTION: "SUBSCRIPTION",
    FIELD: "FIELD",
    FRAGMENT_DEFINITION: "FRAGMENT_DEFINITION",
    FRAGMENT_SPREAD: "FRAGMENT_SPREAD",
    INLINE_FRAGMENT: "INLINE_FRAGMENT",
    VARIABLE_DEFINITION: "VARIABLE_DEFINITION",
    // Type System Definitions
    SCHEMA: "SCHEMA",
    SCALAR: "SCALAR",
    OBJECT: "OBJECT",
    FIELD_DEFINITION: "FIELD_DEFINITION",
    ARGUMENT_DEFINITION: "ARGUMENT_DEFINITION",
    INTERFACE: "INTERFACE",
    UNION: "UNION",
    ENUM: "ENUM",
    ENUM_VALUE: "ENUM_VALUE",
    INPUT_OBJECT: "INPUT_OBJECT",
    INPUT_FIELD_DEFINITION: "INPUT_FIELD_DEFINITION"
});
/**
 * The enum type representing the directive location values.
 */ module.exports.DirectiveLocation = $9c16143380f75006$var$DirectiveLocation;

});


parcelRequire.register("5rRUY", function(module, exports) {

$parcel$export(module.exports, "RestClient", function () { return $3f794c5ebc1d0452$export$ea8b5b3aea9558ce; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $imZy6 = parcelRequire("imZy6");
var $aCVDw = parcelRequire("aCVDw");
var $kP2rz = parcelRequire("kP2rz");

var $8q52X = parcelRequire("8q52X");
var $3f794c5ebc1d0452$var$__assign = undefined && undefined.__assign || function() {
    $3f794c5ebc1d0452$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3f794c5ebc1d0452$var$__assign.apply(this, arguments);
};
var $3f794c5ebc1d0452$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3f794c5ebc1d0452$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $3f794c5ebc1d0452$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3f794c5ebc1d0452$var$logger = new (0, $gBqCF.ConsoleLogger)("RestClient");

var $i3eDV = parcelRequire("i3eDV");
/**
* HTTP Client for REST requests. Send and receive JSON data.
* Sign request with AWS credentials if available
* Usage:
<pre>
const restClient = new RestClient();
restClient.get('...')
    .then(function(data) {
        console.log(data);
    })
    .catch(err => console.log(err));
</pre>
*/ var $3f794c5ebc1d0452$export$ea8b5b3aea9558ce = /** @class */ function() {
    /**
     * @param {RestClientOptions} [options] - Instance options
     */ function RestClient(options) {
        this._region = "us-east-1"; // this will be updated by endpoint function
        this._service = "execute-api"; // this can be updated by endpoint function
        this._custom_header = undefined; // this can be updated by endpoint function
        var endpoints = options.endpoints;
        this._options = options;
        $3f794c5ebc1d0452$var$logger.debug("API Options", this._options);
    }
    /**
    * Update AWS credentials
    * @param {AWSCredentials} credentials - AWS credentials
    *
    updateCredentials(credentials: AWSCredentials) {
        this.options.credentials = credentials;
    }
*/ /**
     * Basic HTTP request. Customizable
     * @param {string} url - Full request URL
     * @param {string} method - Request HTTP method
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.ajax = function(url, method, init) {
        return $3f794c5ebc1d0452$var$__awaiter(this, void 0, void 0, function() {
            var parsed_url, params, libraryHeaders, userAgent, initParams, isAllResponse, custom_header, _a, _b, search, parsedUrl;
            var _this = this;
            return $3f794c5ebc1d0452$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $3f794c5ebc1d0452$var$logger.debug(method + " " + url);
                        parsed_url = this._parseUrl(url);
                        params = {
                            method: method,
                            url: url,
                            host: parsed_url.host,
                            path: parsed_url.path,
                            headers: {},
                            data: null,
                            responseType: "json",
                            timeout: 0
                        };
                        libraryHeaders = {};
                        if ((0, $imZy6.default).isReactNative) {
                            userAgent = (0, $imZy6.default).userAgent || "aws-amplify/0.1.x";
                            libraryHeaders = {
                                "User-Agent": userAgent
                            };
                        }
                        initParams = Object.assign({}, init);
                        isAllResponse = initParams.response;
                        if (initParams.body) {
                            libraryHeaders["Content-Type"] = "application/json; charset=UTF-8";
                            params.data = JSON.stringify(initParams.body);
                        }
                        if (initParams.responseType) params.responseType = initParams.responseType;
                        if (initParams.withCredentials) params["withCredentials"] = initParams.withCredentials;
                        if (initParams.timeout) params.timeout = initParams.timeout;
                        params["signerServiceInfo"] = initParams.signerServiceInfo;
                        if (!this._custom_header) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._custom_header()
                        ];
                    case 1:
                        _a = _c.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        _a = undefined;
                        _c.label = 3;
                    case 3:
                        custom_header = _a;
                        params.headers = $3f794c5ebc1d0452$var$__assign($3f794c5ebc1d0452$var$__assign($3f794c5ebc1d0452$var$__assign({}, libraryHeaders), custom_header), initParams.headers);
                        _b = $i3eDV.parse(url, true, true), search = _b.search, parsedUrl = $3f794c5ebc1d0452$var$__rest(_b, [
                            "search"
                        ]);
                        params.url = $i3eDV.format($3f794c5ebc1d0452$var$__assign($3f794c5ebc1d0452$var$__assign({}, parsedUrl), {
                            query: $3f794c5ebc1d0452$var$__assign($3f794c5ebc1d0452$var$__assign({}, parsedUrl.query), initParams.queryStringParameters || {})
                        }));
                        // Do not sign the request if client has added 'Authorization' header,
                        // which means custom authorizer.
                        if (typeof params.headers["Authorization"] !== "undefined") {
                            params.headers = Object.keys(params.headers).reduce(function(acc, k) {
                                if (params.headers[k]) acc[k] = params.headers[k];
                                return acc;
                            // tslint:disable-next-line:align
                            }, {});
                            return [
                                2 /*return*/ ,
                                this._request(params, isAllResponse)
                            ];
                        }
                        // Signing the request in case there credentials are available
                        return [
                            2 /*return*/ ,
                            (0, $aCVDw.default).get().then(function(credentials) {
                                return _this._signed($3f794c5ebc1d0452$var$__assign({}, params), credentials, isAllResponse);
                            }, function(err) {
                                $3f794c5ebc1d0452$var$logger.debug("No credentials available, the request will be unsigned");
                                return _this._request(params, isAllResponse);
                            })
                        ];
                }
            });
        });
    };
    /**
     * GET HTTP request
     * @param {string} url - Full request URL
     * @param {JSON} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.get = function(url, init) {
        return this.ajax(url, "GET", init);
    };
    /**
     * PUT HTTP request
     * @param {string} url - Full request URL
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.put = function(url, init) {
        return this.ajax(url, "PUT", init);
    };
    /**
     * PATCH HTTP request
     * @param {string} url - Full request URL
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.patch = function(url, init) {
        return this.ajax(url, "PATCH", init);
    };
    /**
     * POST HTTP request
     * @param {string} url - Full request URL
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.post = function(url, init) {
        return this.ajax(url, "POST", init);
    };
    /**
     * DELETE HTTP request
     * @param {string} url - Full request URL
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.del = function(url, init) {
        return this.ajax(url, "DELETE", init);
    };
    /**
     * HEAD HTTP request
     * @param {string} url - Full request URL
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */ RestClient.prototype.head = function(url, init) {
        return this.ajax(url, "HEAD", init);
    };
    /**
     * Getting endpoint for API
     * @param {string} apiName - The name of the api
     * @return {string} - The endpoint of the api
     */ RestClient.prototype.endpoint = function(apiName) {
        var _this = this;
        var cloud_logic_array = this._options.endpoints;
        var response = "";
        if (!Array.isArray(cloud_logic_array)) return response;
        cloud_logic_array.forEach(function(v) {
            if (v.name === apiName) {
                response = v.endpoint;
                if (typeof v.region === "string") _this._region = v.region;
                else if (typeof _this._options.region === "string") _this._region = _this._options.region;
                if (typeof v.service === "string") _this._service = v.service || "execute-api";
                else _this._service = "execute-api";
                if (typeof v.custom_header === "function") _this._custom_header = v.custom_header;
                else _this._custom_header = undefined;
            }
        });
        return response;
    };
    /** private methods **/ RestClient.prototype._signed = function(params, credentials, isAllResponse) {
        var signerServiceInfoParams = params.signerServiceInfo, otherParams = $3f794c5ebc1d0452$var$__rest(params, [
            "signerServiceInfo"
        ]);
        var endpoint_region = this._region || this._options.region;
        var endpoint_service = this._service || this._options.service;
        var creds = {
            secret_key: credentials.secretAccessKey,
            access_key: credentials.accessKeyId,
            session_token: credentials.sessionToken
        };
        var endpointInfo = {
            region: endpoint_region,
            service: endpoint_service
        };
        var signerServiceInfo = Object.assign(endpointInfo, signerServiceInfoParams);
        var signed_params = (0, $kP2rz.default).sign(otherParams, creds, signerServiceInfo);
        if (signed_params.data) signed_params.body = signed_params.data;
        $3f794c5ebc1d0452$var$logger.debug("Signed Request: ", signed_params);
        delete signed_params.headers["host"];
        return (0, (/*@__PURE__*/$parcel$interopDefault($8q52X)))(signed_params).then(function(response) {
            return isAllResponse ? response : response.data;
        }).catch(function(error) {
            $3f794c5ebc1d0452$var$logger.debug(error);
            throw error;
        });
    };
    RestClient.prototype._request = function(params, isAllResponse) {
        if (isAllResponse === void 0) isAllResponse = false;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8q52X)))(params).then(function(response) {
            return isAllResponse ? response : response.data;
        }).catch(function(error) {
            $3f794c5ebc1d0452$var$logger.debug(error);
            throw error;
        });
    };
    RestClient.prototype._parseUrl = function(url) {
        var parts = url.split("/");
        return {
            host: parts[2],
            path: "/" + parts.slice(3).join("/")
        };
    };
    return RestClient;
}();

});
parcelRequire.register("8q52X", function(module, exports) {

module.exports = (parcelRequire("2HHXb"));

});
parcelRequire.register("2HHXb", function(module, exports) {
"use strict";

var $iEgly = parcelRequire("iEgly");

var $e3jNO = parcelRequire("e3jNO");

var $kfdng = parcelRequire("kfdng");

var $3F2Tk = parcelRequire("3F2Tk");

var $cdjbk = parcelRequire("cdjbk");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $1f81b12a8c8351e4$var$createInstance(defaultConfig) {
    var context = new $kfdng(defaultConfig);
    var instance = $e3jNO($kfdng.prototype.request, context);
    // Copy axios.prototype to instance
    $iEgly.extend(instance, $kfdng.prototype, context);
    // Copy context to instance
    $iEgly.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $1f81b12a8c8351e4$var$axios = $1f81b12a8c8351e4$var$createInstance($cdjbk);
// Expose Axios class to allow class inheritance
$1f81b12a8c8351e4$var$axios.Axios = $kfdng;
// Factory for creating new instances
$1f81b12a8c8351e4$var$axios.create = function create(instanceConfig) {
    return $1f81b12a8c8351e4$var$createInstance($3F2Tk($1f81b12a8c8351e4$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$1f81b12a8c8351e4$var$axios.Cancel = (parcelRequire("agyIU"));

$1f81b12a8c8351e4$var$axios.CancelToken = (parcelRequire("aulkG"));

$1f81b12a8c8351e4$var$axios.isCancel = (parcelRequire("dkSym"));
// Expose all/spread
$1f81b12a8c8351e4$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$1f81b12a8c8351e4$var$axios.spread = (parcelRequire("9AoMl"));
module.exports = $1f81b12a8c8351e4$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $1f81b12a8c8351e4$var$axios;

});
parcelRequire.register("iEgly", function(module, exports) {
"use strict";

var $e3jNO = parcelRequire("e3jNO");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $d938a48b35003b4a$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $d938a48b35003b4a$var$isArray(val) {
    return $d938a48b35003b4a$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $d938a48b35003b4a$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $d938a48b35003b4a$var$isBuffer(val) {
    return val !== null && !$d938a48b35003b4a$var$isUndefined(val) && val.constructor !== null && !$d938a48b35003b4a$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $d938a48b35003b4a$var$isArrayBuffer(val) {
    return $d938a48b35003b4a$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $d938a48b35003b4a$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $d938a48b35003b4a$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $d938a48b35003b4a$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $d938a48b35003b4a$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $d938a48b35003b4a$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $d938a48b35003b4a$var$isDate(val) {
    return $d938a48b35003b4a$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $d938a48b35003b4a$var$isFile(val) {
    return $d938a48b35003b4a$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $d938a48b35003b4a$var$isBlob(val) {
    return $d938a48b35003b4a$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $d938a48b35003b4a$var$isFunction(val) {
    return $d938a48b35003b4a$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $d938a48b35003b4a$var$isStream(val) {
    return $d938a48b35003b4a$var$isObject(val) && $d938a48b35003b4a$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $d938a48b35003b4a$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $d938a48b35003b4a$var$trim(str) {
    return str.replace(/^\s*/, "").replace(/\s*$/, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $d938a48b35003b4a$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $d938a48b35003b4a$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($d938a48b35003b4a$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $d938a48b35003b4a$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === "object" && typeof val === "object") result[key] = $d938a48b35003b4a$var$merge(result[key], val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$d938a48b35003b4a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $d938a48b35003b4a$var$deepMerge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === "object" && typeof val === "object") result[key] = $d938a48b35003b4a$var$deepMerge(result[key], val);
        else if (typeof val === "object") result[key] = $d938a48b35003b4a$var$deepMerge({}, val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$d938a48b35003b4a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $d938a48b35003b4a$var$extend(a, b, thisArg) {
    $d938a48b35003b4a$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $e3jNO(val, thisArg);
        else a[key] = val;
    });
    return a;
}
module.exports = {
    isArray: $d938a48b35003b4a$var$isArray,
    isArrayBuffer: $d938a48b35003b4a$var$isArrayBuffer,
    isBuffer: $d938a48b35003b4a$var$isBuffer,
    isFormData: $d938a48b35003b4a$var$isFormData,
    isArrayBufferView: $d938a48b35003b4a$var$isArrayBufferView,
    isString: $d938a48b35003b4a$var$isString,
    isNumber: $d938a48b35003b4a$var$isNumber,
    isObject: $d938a48b35003b4a$var$isObject,
    isUndefined: $d938a48b35003b4a$var$isUndefined,
    isDate: $d938a48b35003b4a$var$isDate,
    isFile: $d938a48b35003b4a$var$isFile,
    isBlob: $d938a48b35003b4a$var$isBlob,
    isFunction: $d938a48b35003b4a$var$isFunction,
    isStream: $d938a48b35003b4a$var$isStream,
    isURLSearchParams: $d938a48b35003b4a$var$isURLSearchParams,
    isStandardBrowserEnv: $d938a48b35003b4a$var$isStandardBrowserEnv,
    forEach: $d938a48b35003b4a$var$forEach,
    merge: $d938a48b35003b4a$var$merge,
    deepMerge: $d938a48b35003b4a$var$deepMerge,
    extend: $d938a48b35003b4a$var$extend,
    trim: $d938a48b35003b4a$var$trim
};

});
parcelRequire.register("e3jNO", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRequire.register("kfdng", function(module, exports) {
"use strict";

var $iEgly = parcelRequire("iEgly");

var $8ws27 = parcelRequire("8ws27");

var $jNg1d = parcelRequire("jNg1d");

var $bzYKD = parcelRequire("bzYKD");

var $3F2Tk = parcelRequire("3F2Tk");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $ebcf9535ef87eab0$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $jNg1d(),
        response: new $jNg1d()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $ebcf9535ef87eab0$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $3F2Tk(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    // Hook up interceptors middleware
    var chain = [
        $bzYKD,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
$ebcf9535ef87eab0$var$Axios.prototype.getUri = function getUri(config) {
    config = $3F2Tk(this.defaults, config);
    return $8ws27(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$iEgly.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $ebcf9535ef87eab0$var$Axios.prototype[method] = function(url, config) {
        return this.request($iEgly.merge(config || {}, {
            method: method,
            url: url
        }));
    };
});
$iEgly.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $ebcf9535ef87eab0$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($iEgly.merge(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $ebcf9535ef87eab0$var$Axios;

});
parcelRequire.register("8ws27", function(module, exports) {
"use strict";

var $iEgly = parcelRequire("iEgly");
function $63470eb2055c9eff$var$encode(val) {
    return encodeURIComponent(val).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($iEgly.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $iEgly.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($iEgly.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $iEgly.forEach(val, function parseValue(v) {
                if ($iEgly.isDate(v)) v = v.toISOString();
                else if ($iEgly.isObject(v)) v = JSON.stringify(v);
                parts.push($63470eb2055c9eff$var$encode(key) + "=" + $63470eb2055c9eff$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRequire.register("jNg1d", function(module, exports) {
"use strict";

var $iEgly = parcelRequire("iEgly");
function $e68f04e80a1bb55f$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $e68f04e80a1bb55f$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $e68f04e80a1bb55f$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $e68f04e80a1bb55f$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $iEgly.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $e68f04e80a1bb55f$var$InterceptorManager;

});

parcelRequire.register("bzYKD", function(module, exports) {
"use strict";

var $iEgly = parcelRequire("iEgly");

var $jDc1C = parcelRequire("jDc1C");

var $dkSym = parcelRequire("dkSym");

var $cdjbk = parcelRequire("cdjbk");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $86e2167cf5799592$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $86e2167cf5799592$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $jDc1C(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $iEgly.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $iEgly.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $cdjbk.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $86e2167cf5799592$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $jDc1C(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$dkSym(reason)) {
            $86e2167cf5799592$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $jDc1C(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRequire.register("jDc1C", function(module, exports) {
"use strict";

var $iEgly = parcelRequire("iEgly");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $iEgly.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRequire.register("dkSym", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRequire.register("cdjbk", function(module, exports) {

var $e67mm = parcelRequire("e67mm");
"use strict";

var $iEgly = parcelRequire("iEgly");

var $k5zaQ = parcelRequire("k5zaQ");
var $8e459407c6c53523$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $8e459407c6c53523$var$setContentTypeIfUnset(headers, value) {
    if (!$iEgly.isUndefined(headers) && $iEgly.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $8e459407c6c53523$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("aMjHY"));
    else if (typeof $e67mm !== "undefined" && Object.prototype.toString.call($e67mm) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("aMjHY"));
    return adapter;
}
var $8e459407c6c53523$var$defaults = {
    adapter: $8e459407c6c53523$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $k5zaQ(headers, "Accept");
            $k5zaQ(headers, "Content-Type");
            if ($iEgly.isFormData(data) || $iEgly.isArrayBuffer(data) || $iEgly.isBuffer(data) || $iEgly.isStream(data) || $iEgly.isFile(data) || $iEgly.isBlob(data)) return data;
            if ($iEgly.isArrayBufferView(data)) return data.buffer;
            if ($iEgly.isURLSearchParams(data)) {
                $8e459407c6c53523$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($iEgly.isObject(data)) {
                $8e459407c6c53523$var$setContentTypeIfUnset(headers, "application/json;charset=utf-8");
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === "string") try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$8e459407c6c53523$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$iEgly.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $8e459407c6c53523$var$defaults.headers[method] = {};
});
$iEgly.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $8e459407c6c53523$var$defaults.headers[method] = $iEgly.merge($8e459407c6c53523$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $8e459407c6c53523$var$defaults;

});
parcelRequire.register("k5zaQ", function(module, exports) {
"use strict";

var $iEgly = parcelRequire("iEgly");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $iEgly.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRequire.register("aMjHY", function(module, exports) {
"use strict";

var $iEgly = parcelRequire("iEgly");

var $6XN1X = parcelRequire("6XN1X");

var $8ws27 = parcelRequire("8ws27");

var $1d2yu = parcelRequire("1d2yu");

var $cJrCQ = parcelRequire("cJrCQ");

var $kTs6D = parcelRequire("kTs6D");

var $2bFFA = parcelRequire("2bFFA");

module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($iEgly.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password || "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $1d2yu(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $8ws27(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $cJrCQ(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === "text" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $6XN1X(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($2bFFA("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($2bFFA("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($2bFFA(timeoutErrorMessage, config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($iEgly.isStandardBrowserEnv()) {
            var cookies = (parcelRequire("7UPan"));
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $kTs6D(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $iEgly.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$iEgly.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== "json") throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (requestData === undefined) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRequire.register("6XN1X", function(module, exports) {
"use strict";

var $2bFFA = parcelRequire("2bFFA");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!validateStatus || validateStatus(response.status)) resolve(response);
    else reject($2bFFA("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRequire.register("2bFFA", function(module, exports) {
"use strict";

var $3UBz9 = parcelRequire("3UBz9");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $3UBz9(error, config, code, request, response);
};

});
parcelRequire.register("3UBz9", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});



parcelRequire.register("1d2yu", function(module, exports) {
"use strict";

var $hIM4p = parcelRequire("hIM4p");

var $pzqJH = parcelRequire("pzqJH");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$hIM4p(requestedURL)) return $pzqJH(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRequire.register("hIM4p", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRequire.register("pzqJH", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRequire.register("cJrCQ", function(module, exports) {
"use strict";

var $iEgly = parcelRequire("iEgly");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $944f1de0a24af19a$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $iEgly.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $iEgly.trim(line.substr(0, i)).toLowerCase();
        val = $iEgly.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $944f1de0a24af19a$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRequire.register("kTs6D", function(module, exports) {
"use strict";

var $iEgly = parcelRequire("iEgly");
module.exports = $iEgly.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $iEgly.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRequire.register("7UPan", function(module, exports) {
"use strict";

var $iEgly = parcelRequire("iEgly");
module.exports = $iEgly.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($iEgly.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($iEgly.isString(path)) cookie.push("path=" + path);
            if ($iEgly.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});




parcelRequire.register("3F2Tk", function(module, exports) {
"use strict";

var $iEgly = parcelRequire("iEgly");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "params",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "url",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "maxContentLength",
        "validateStatus",
        "maxRedirects",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath"
    ];
    $iEgly.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
    });
    $iEgly.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
        if ($iEgly.isObject(config2[prop])) config[prop] = $iEgly.deepMerge(config1[prop], config2[prop]);
        else if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
        else if ($iEgly.isObject(config1[prop])) config[prop] = $iEgly.deepMerge(config1[prop]);
        else if (typeof config1[prop] !== "undefined") config[prop] = config1[prop];
    });
    $iEgly.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
        else if (typeof config1[prop] !== "undefined") config[prop] = config1[prop];
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys);
    var otherKeys = Object.keys(config2).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $iEgly.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
        if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
        else if (typeof config1[prop] !== "undefined") config[prop] = config1[prop];
    });
    return config;
};

});


parcelRequire.register("agyIU", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $77965558133a7662$var$Cancel(message) {
    this.message = message;
}
$77965558133a7662$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$77965558133a7662$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $77965558133a7662$var$Cancel;

});

parcelRequire.register("aulkG", function(module, exports) {
"use strict";

var $agyIU = parcelRequire("agyIU");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $7a2d40edb7eef8ea$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $agyIU(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $7a2d40edb7eef8ea$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $7a2d40edb7eef8ea$var$CancelToken.source = function source() {
    var cancel;
    var token = new $7a2d40edb7eef8ea$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $7a2d40edb7eef8ea$var$CancelToken;

});

parcelRequire.register("9AoMl", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});





parcelRequire.register("IRLYq", function(module, exports) {

$parcel$export(module.exports, "GRAPHQL_AUTH_MODE", function () { return $086dd253a1c54788$export$cfce9c15015bef96; });
/**
 * RestClient instance options
 */ var $086dd253a1c54788$export$d2df57b277b2ae51 = /** @class */ function() {
    function RestClientOptions() {
        this.credentials_key = "awsCredentials";
        this.headers = {};
    }
    return RestClientOptions;
}();
/**
 * AWS credentials needed for RestClient
 */ var $086dd253a1c54788$export$816277b69db2db8d = /** @class */ function() {
    function AWSCredentials() {}
    return AWSCredentials;
}();
var $086dd253a1c54788$export$cfce9c15015bef96;
(function(GRAPHQL_AUTH_MODE) {
    GRAPHQL_AUTH_MODE["API_KEY"] = "API_KEY";
    GRAPHQL_AUTH_MODE["AWS_IAM"] = "AWS_IAM";
    GRAPHQL_AUTH_MODE["OPENID_CONNECT"] = "OPENID_CONNECT";
    GRAPHQL_AUTH_MODE["AMAZON_COGNITO_USER_POOLS"] = "AMAZON_COGNITO_USER_POOLS";
})($086dd253a1c54788$export$cfce9c15015bef96 || ($086dd253a1c54788$export$cfce9c15015bef96 = {}));

});


parcelRequire.register("72iLF", function(module, exports) {

$parcel$export(module.exports, "CONTROL_MSG", function () { return $51f74737273740e0$export$f96baa4bc836aea4; });
$parcel$export(module.exports, "default", function () { return $51f74737273740e0$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $eTAvL = parcelRequire("eTAvL");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $2hWDt = parcelRequire("2hWDt");

var $eIYqJ = parcelRequire("eIYqJ");
var $51f74737273740e0$var$logger = new (0, $gBqCF.ConsoleLogger)("PubSub");
var $51f74737273740e0$export$f96baa4bc836aea4;
(function(CONTROL_MSG) {
    CONTROL_MSG["CONNECTION_CLOSED"] = "Connection closed";
    CONTROL_MSG["TIMEOUT_DISCONNECT"] = "Timeout disconnect";
})($51f74737273740e0$export$f96baa4bc836aea4 || ($51f74737273740e0$export$f96baa4bc836aea4 = {}));
var $51f74737273740e0$var$_instance = null;
if (!$51f74737273740e0$var$_instance) {
    $51f74737273740e0$var$logger.debug("Create PubSub Instance");
    $51f74737273740e0$var$_instance = new (0, $eTAvL.default)(null);
}
var $51f74737273740e0$var$PubSub = $51f74737273740e0$var$_instance;
(0, $2hWDt.default).register($51f74737273740e0$var$PubSub);
var $51f74737273740e0$export$2e2bcd8739ae039 = $51f74737273740e0$var$PubSub;
$parcel$exportWildcard(module.exports, $eIYqJ);

});
parcelRequire.register("eTAvL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad8286260a34fe83$export$2e2bcd8739ae039; });

var $gbejU = parcelRequire("gbejU");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $2SWCi = parcelRequire("2SWCi");
parcelRequire("5kqic");
var $lFQSa = parcelRequire("lFQSa");
var $8CzEt = parcelRequire("8CzEt");
var $ad8286260a34fe83$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ad8286260a34fe83$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $ad8286260a34fe83$var$logger = new (0, $gBqCF.ConsoleLogger)("PubSub");
var $ad8286260a34fe83$var$PubSub = /** @class */ function() {
    /**
     * Initialize PubSub with AWS configurations
     *
     * @param {PubSubOptions} options - Configuration object for PubSub
     */ function PubSub(options) {
        this._options = options;
        $ad8286260a34fe83$var$logger.debug("PubSub Options", this._options);
        this._pluggables = [];
        this.subscribe = this.subscribe.bind(this);
    }
    Object.defineProperty(PubSub.prototype, "awsAppSyncProvider", {
        /**
         * Lazy instantiate AWSAppSyncProvider when it is required by the API category
         */ get: function() {
            if (!this._awsAppSyncProvider) this._awsAppSyncProvider = new (0, $lFQSa.AWSAppSyncProvider)(this._options);
            return this._awsAppSyncProvider;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PubSub.prototype, "awsAppSyncRealTimeProvider", {
        /**
         * Lazy instantiate AWSAppSyncRealTimeProvider when it is required by the API category
         */ get: function() {
            if (!this._awsAppSyncRealTimeProvider) this._awsAppSyncRealTimeProvider = new (0, $8CzEt.AWSAppSyncRealTimeProvider)(this._options);
            return this._awsAppSyncRealTimeProvider;
        },
        enumerable: true,
        configurable: true
    });
    PubSub.prototype.getModuleName = function() {
        return "PubSub";
    };
    /**
     * Configure PubSub part with configurations
     *
     * @param {PubSubOptions} config - Configuration for PubSub
     * @return {Object} - The current configuration
     */ PubSub.prototype.configure = function(options) {
        var _this = this;
        var opt = options ? options.PubSub || options : {};
        $ad8286260a34fe83$var$logger.debug("configure PubSub", {
            opt: opt
        });
        this._options = Object.assign({}, this._options, opt);
        this._pluggables.map(function(pluggable) {
            return pluggable.configure(_this._options);
        });
        return this._options;
    };
    /**
     * add plugin into Analytics category
     * @param {Object} pluggable - an instance of the plugin
     */ PubSub.prototype.addPluggable = function(pluggable) {
        return $ad8286260a34fe83$var$__awaiter(this, void 0, void 0, function() {
            var config;
            return $ad8286260a34fe83$var$__generator(this, function(_a) {
                if (pluggable && pluggable.getCategory() === "PubSub") {
                    this._pluggables.push(pluggable);
                    config = pluggable.configure(this._options);
                    return [
                        2 /*return*/ ,
                        config
                    ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    PubSub.prototype.getProviderByName = function(providerName) {
        if (providerName === (0, $2SWCi.INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER)) return this.awsAppSyncProvider;
        if (providerName === (0, $2SWCi.INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER)) return this.awsAppSyncRealTimeProvider;
        return this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
    };
    PubSub.prototype.getProviders = function(options) {
        if (options === void 0) options = {};
        var providerName = options.provider;
        if (!providerName) return this._pluggables;
        var provider = this.getProviderByName(providerName);
        if (!provider) throw new Error("Could not find provider named " + providerName);
        return [
            provider
        ];
    };
    PubSub.prototype.publish = function(topics, msg, options) {
        return $ad8286260a34fe83$var$__awaiter(this, void 0, void 0, function() {
            return $ad8286260a34fe83$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    Promise.all(this.getProviders(options).map(function(provider) {
                        return provider.publish(topics, msg, options);
                    }))
                ];
            });
        });
    };
    PubSub.prototype.subscribe = function(topics, options) {
        $ad8286260a34fe83$var$logger.debug("subscribe options", options);
        var providers = this.getProviders(options);
        return new $gbejU(function(observer) {
            var observables = providers.map(function(provider) {
                return {
                    provider: provider,
                    observable: provider.subscribe(topics, options)
                };
            });
            var subscriptions = observables.map(function(_a) {
                var provider = _a.provider, observable = _a.observable;
                return observable.subscribe({
                    start: console.error,
                    next: function(value) {
                        return observer.next({
                            provider: provider,
                            value: value
                        });
                    },
                    error: function(error) {
                        return observer.error({
                            provider: provider,
                            error: error
                        });
                    }
                });
            });
            return function() {
                return subscriptions.forEach(function(subscription) {
                    return subscription.unsubscribe();
                });
            };
        });
    };
    return PubSub;
}();
var $ad8286260a34fe83$export$2e2bcd8739ae039 = $ad8286260a34fe83$var$PubSub;

});
parcelRequire.register("5kqic", function(module, exports) {
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $aXKIu = parcelRequire("aXKIu");

var $lFQSa = parcelRequire("lFQSa");

var $8CzEt = parcelRequire("8CzEt");

var $eIYqJ = parcelRequire("eIYqJ");

var $iPlxP = parcelRequire("iPlxP");
$parcel$exportWildcard(module.exports, $aXKIu);
$parcel$exportWildcard(module.exports, $lFQSa);
$parcel$exportWildcard(module.exports, $8CzEt);
$parcel$exportWildcard(module.exports, $eIYqJ);
$parcel$exportWildcard(module.exports, $iPlxP);

});
parcelRequire.register("aXKIu", function(module, exports) {

$parcel$export(module.exports, "AbstractPubSubProvider", function () { return $7fb3a70224cc1339$export$38596aa9173af3e4; });
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $7fb3a70224cc1339$var$__assign = undefined && undefined.__assign || function() {
    $7fb3a70224cc1339$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7fb3a70224cc1339$var$__assign.apply(this, arguments);
};
var $7fb3a70224cc1339$var$logger = new (0, $gBqCF.ConsoleLogger)("AbstractPubSubProvider");
var $7fb3a70224cc1339$export$38596aa9173af3e4 = /** @class */ function() {
    function AbstractPubSubProvider(options) {
        if (options === void 0) options = {};
        this._config = options;
    }
    AbstractPubSubProvider.prototype.configure = function(config) {
        if (config === void 0) config = {};
        this._config = $7fb3a70224cc1339$var$__assign($7fb3a70224cc1339$var$__assign({}, config), this._config);
        $7fb3a70224cc1339$var$logger.debug("configure " + this.getProviderName(), this._config);
        return this.options;
    };
    AbstractPubSubProvider.prototype.getCategory = function() {
        return "PubSub";
    };
    Object.defineProperty(AbstractPubSubProvider.prototype, "options", {
        get: function() {
            return $7fb3a70224cc1339$var$__assign({}, this._config);
        },
        enumerable: true,
        configurable: true
    });
    return AbstractPubSubProvider;
}();

});

parcelRequire.register("lFQSa", function(module, exports) {

$parcel$export(module.exports, "AWSAppSyncProvider", function () { return $fc7670b75c869210$export$937fc88a753c4320; });

var $gbejU = parcelRequire("gbejU");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");

var $iPlxP = parcelRequire("iPlxP");
var $fc7670b75c869210$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $fc7670b75c869210$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fc7670b75c869210$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $fc7670b75c869210$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fc7670b75c869210$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $fc7670b75c869210$var$logger = new (0, $gBqCF.ConsoleLogger)("AWSAppSyncProvider");
var $fc7670b75c869210$export$937fc88a753c4320 = /** @class */ function(_super) {
    $fc7670b75c869210$var$__extends(AWSAppSyncProvider, _super);
    function AWSAppSyncProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._topicClient = new Map();
        _this._topicAlias = new Map();
        return _this;
    }
    Object.defineProperty(AWSAppSyncProvider.prototype, "endpoint", {
        get: function() {
            throw new Error("Not supported");
        },
        enumerable: true,
        configurable: true
    });
    AWSAppSyncProvider.prototype.getProviderName = function() {
        return "AWSAppSyncProvider";
    };
    AWSAppSyncProvider.prototype.publish = function(topics, msg, options) {
        return $fc7670b75c869210$var$__awaiter(this, void 0, void 0, function() {
            return $fc7670b75c869210$var$__generator(this, function(_a) {
                throw new Error("Operation not supported");
            });
        });
    };
    AWSAppSyncProvider.prototype._cleanUp = function(clientId) {
        var _this = this;
        var topicsForClient = Array.from(this._topicClient.entries()).filter(function(_a) {
            var c = _a[1];
            return c.clientId === clientId;
        }).map(function(_a) {
            var t = _a[0];
            return t;
        });
        topicsForClient.forEach(function(t) {
            return _this._cleanUpForTopic(t);
        });
    };
    AWSAppSyncProvider.prototype._cleanUpForTopic = function(topic) {
        this._topicClient.delete(topic);
        this._topicAlias.delete(topic);
    };
    AWSAppSyncProvider.prototype.onDisconnect = function(_a) {
        var _this = this;
        var clientId = _a.clientId, errorCode = _a.errorCode, args = $fc7670b75c869210$var$__rest(_a, [
            "clientId",
            "errorCode"
        ]);
        if (errorCode !== 0) {
            var topicsForClient = Array.from(this._topicClient.entries()).filter(function(_a) {
                var c = _a[1];
                return c.clientId === clientId;
            }).map(function(_a) {
                var t = _a[0];
                return t;
            });
            topicsForClient.forEach(function(topic) {
                if (_this._topicObservers.has(topic)) {
                    _this._topicObservers.get(topic).forEach(function(obs) {
                        if (!obs.closed) obs.error(args);
                    });
                    _this._topicObservers.delete(topic);
                }
            });
            this._cleanUp(clientId);
        }
    };
    AWSAppSyncProvider.prototype.disconnect = function(clientId) {
        return $fc7670b75c869210$var$__awaiter(this, void 0, void 0, function() {
            var client;
            return $fc7670b75c869210$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.clientsQueue.get(clientId, function() {
                                return null;
                            })
                        ];
                    case 1:
                        client = _a.sent();
                        return [
                            4 /*yield*/ ,
                            _super.prototype.disconnect.call(this, clientId)
                        ];
                    case 2:
                        _a.sent();
                        this._cleanUp(clientId);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSAppSyncProvider.prototype.subscribe = function(topics, options) {
        var _this = this;
        if (options === void 0) options = {};
        var result = new $gbejU(function(observer) {
            var targetTopics = [].concat(topics);
            $fc7670b75c869210$var$logger.debug("Subscribing to topic(s)", targetTopics.join(","));
            (function() {
                return $fc7670b75c869210$var$__awaiter(_this, void 0, void 0, function() {
                    var _a, mqttConnections, newSubscriptions, newAliases, map;
                    var _this = this;
                    return $fc7670b75c869210$var$__generator(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                // Add these topics to map
                                targetTopics.forEach(function(t) {
                                    if (!_this._topicObservers.has(t)) _this._topicObservers.set(t, new Set());
                                    _this._topicObservers.get(t).add(observer);
                                });
                                _a = options.mqttConnections, mqttConnections = _a === void 0 ? [] : _a, newSubscriptions = options.newSubscriptions;
                                newAliases = Object.entries(newSubscriptions).map(function(_a) {
                                    var alias = _a[0], v = _a[1];
                                    return [
                                        v.topic,
                                        alias
                                    ];
                                });
                                // Merge new aliases with old ones
                                this._topicAlias = new Map($fc7670b75c869210$var$__spreadArrays(Array.from(this._topicAlias.entries()), newAliases));
                                map = Object.entries(targetTopics.reduce(function(acc, elem) {
                                    var connectionInfoForTopic = mqttConnections.find(function(c) {
                                        return c.topics.indexOf(elem) > -1;
                                    });
                                    if (connectionInfoForTopic) {
                                        var clientId = connectionInfoForTopic.client, url = connectionInfoForTopic.url;
                                        if (!acc[clientId]) acc[clientId] = {
                                            url: url,
                                            topics: new Set()
                                        };
                                        acc[clientId].topics.add(elem);
                                    }
                                    return acc;
                                }, {}));
                                // reconnect everything we have in the map
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(map.map(function(_a) {
                                        var clientId = _a[0], _b = _a[1], url = _b.url, topics = _b.topics;
                                        return $fc7670b75c869210$var$__awaiter(_this, void 0, void 0, function() {
                                            var client, err_1;
                                            var _this = this;
                                            return $fc7670b75c869210$var$__generator(this, function(_c) {
                                                switch(_c.label){
                                                    case 0:
                                                        client = null;
                                                        _c.label = 1;
                                                    case 1:
                                                        _c.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.connect(clientId, {
                                                                clientId: clientId,
                                                                url: url
                                                            })
                                                        ];
                                                    case 2:
                                                        client = _c.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                    case 3:
                                                        err_1 = _c.sent();
                                                        observer.error({
                                                            message: "Failed to connect",
                                                            error: err_1
                                                        });
                                                        observer.complete();
                                                        return [
                                                            2 /*return*/ ,
                                                            undefined
                                                        ];
                                                    case 4:
                                                        // subscribe to all topics for this client
                                                        // store topic-client mapping
                                                        topics.forEach(function(topic) {
                                                            if (client.isConnected()) {
                                                                client.subscribe(topic);
                                                                _this._topicClient.set(topic, client);
                                                            }
                                                        });
                                                        return [
                                                            2 /*return*/ ,
                                                            client
                                                        ];
                                                }
                                            });
                                        });
                                    }))
                                ];
                            case 1:
                                // reconnect everything we have in the map
                                _b.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            })();
            return function() {
                $fc7670b75c869210$var$logger.debug("Unsubscribing from topic(s)", targetTopics.join(","));
                targetTopics.forEach(function(t) {
                    var client = _this._topicClient.get(t);
                    if (client && client.isConnected()) {
                        client.unsubscribe(t);
                        _this._topicClient.delete(t);
                        if (!Array.from(_this._topicClient.values()).some(function(c) {
                            return c === client;
                        })) _this.disconnect(client.clientId);
                    }
                    _this._topicObservers.delete(t);
                });
            };
        });
        return $gbejU.from(result).map(function(value) {
            var topic = _this.getTopicForValue(value);
            var alias = _this._topicAlias.get(topic);
            value.data = Object.entries(value.data).reduce(function(obj, _a) {
                var origKey = _a[0], val = _a[1];
                return obj[alias || origKey] = val, obj;
            }, {});
            return value;
        });
    };
    return AWSAppSyncProvider;
}((0, $iPlxP.MqttOverWSProvider));

});
parcelRequire.register("iPlxP", function(module, exports) {

$parcel$export(module.exports, "MqttOverWSProvider", function () { return $db4db3bd25849829$export$4e8eac6aa347b425; });

var $anDWk = parcelRequire("anDWk");

var $32hwF = parcelRequire("32hwF");

var $gbejU = parcelRequire("gbejU");

var $aXKIu = parcelRequire("aXKIu");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $db4db3bd25849829$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $db4db3bd25849829$var$__assign = undefined && undefined.__assign || function() {
    $db4db3bd25849829$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $db4db3bd25849829$var$__assign.apply(this, arguments);
};
var $db4db3bd25849829$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $db4db3bd25849829$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $db4db3bd25849829$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $db4db3bd25849829$var$logger = new (0, $gBqCF.ConsoleLogger)("MqttOverWSProvider");
function $db4db3bd25849829$export$4848305770dbede7(filter, topic) {
    var filterArray = filter.split("/");
    var length = filterArray.length;
    var topicArray = topic.split("/");
    for(var i = 0; i < length; ++i){
        var left = filterArray[i];
        var right = topicArray[i];
        if (left === "#") return topicArray.length >= length;
        if (left !== "+" && left !== right) return false;
    }
    return length === topicArray.length;
}
var $db4db3bd25849829$var$ClientsQueue = /** @class */ function() {
    function ClientsQueue() {
        this.promises = new Map();
    }
    ClientsQueue.prototype.get = function(clientId, clientFactory) {
        return $db4db3bd25849829$var$__awaiter(this, void 0, void 0, function() {
            var promise;
            return $db4db3bd25849829$var$__generator(this, function(_a) {
                promise = this.promises.get(clientId);
                if (promise) return [
                    2 /*return*/ ,
                    promise
                ];
                promise = clientFactory(clientId);
                this.promises.set(clientId, promise);
                return [
                    2 /*return*/ ,
                    promise
                ];
            });
        });
    };
    Object.defineProperty(ClientsQueue.prototype, "allClients", {
        get: function() {
            return Array.from(this.promises.keys());
        },
        enumerable: true,
        configurable: true
    });
    ClientsQueue.prototype.remove = function(clientId) {
        this.promises.delete(clientId);
    };
    return ClientsQueue;
}();
var $db4db3bd25849829$var$topicSymbol = typeof Symbol !== "undefined" ? Symbol("topic") : "@@topic";
var $db4db3bd25849829$export$4e8eac6aa347b425 = /** @class */ function(_super) {
    $db4db3bd25849829$var$__extends(MqttOverWSProvider, _super);
    function MqttOverWSProvider(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, $db4db3bd25849829$var$__assign($db4db3bd25849829$var$__assign({}, options), {
            clientId: options.clientId || (0, $32hwF.v4)()
        })) || this;
        _this._clientsQueue = new $db4db3bd25849829$var$ClientsQueue();
        _this._topicObservers = new Map();
        _this._clientIdObservers = new Map();
        return _this;
    }
    Object.defineProperty(MqttOverWSProvider.prototype, "clientId", {
        get: function() {
            return this.options.clientId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MqttOverWSProvider.prototype, "endpoint", {
        get: function() {
            return this.options.aws_pubsub_endpoint;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MqttOverWSProvider.prototype, "clientsQueue", {
        get: function() {
            return this._clientsQueue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MqttOverWSProvider.prototype, "isSSLEnabled", {
        get: function() {
            return !this.options.aws_appsync_dangerously_connect_to_http_endpoint_for_testing;
        },
        enumerable: true,
        configurable: true
    });
    MqttOverWSProvider.prototype.getTopicForValue = function(value) {
        return typeof value === "object" && value[$db4db3bd25849829$var$topicSymbol];
    };
    MqttOverWSProvider.prototype.getProviderName = function() {
        return "MqttOverWSProvider";
    };
    MqttOverWSProvider.prototype.onDisconnect = function(_a) {
        var _this = this;
        var clientId = _a.clientId, errorCode = _a.errorCode, args = $db4db3bd25849829$var$__rest(_a, [
            "clientId",
            "errorCode"
        ]);
        if (errorCode !== 0) {
            $db4db3bd25849829$var$logger.warn(clientId, JSON.stringify($db4db3bd25849829$var$__assign({
                errorCode: errorCode
            }, args), null, 2));
            var topicsToDelete_1 = [];
            var clientIdObservers = this._clientIdObservers.get(clientId);
            if (!clientIdObservers) return;
            clientIdObservers.forEach(function(observer) {
                observer.error("Disconnected, error code: " + errorCode);
                // removing observers for disconnected clientId
                _this._topicObservers.forEach(function(observerForTopic, observerTopic) {
                    observerForTopic.delete(observer);
                    if (observerForTopic.size === 0) topicsToDelete_1.push(observerTopic);
                });
            });
            // forgiving any trace of clientId
            this._clientIdObservers.delete(clientId);
            // Removing topics that are not listen by an observer
            topicsToDelete_1.forEach(function(topic) {
                _this._topicObservers.delete(topic);
            });
        }
    };
    MqttOverWSProvider.prototype.newClient = function(_a) {
        var url = _a.url, clientId = _a.clientId;
        return $db4db3bd25849829$var$__awaiter(this, void 0, void 0, function() {
            var client;
            var _this = this;
            return $db4db3bd25849829$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $db4db3bd25849829$var$logger.debug("Creating new MQTT client", clientId);
                        client = new $anDWk.Client(url, clientId);
                        // client.trace = (args) => logger.debug(clientId, JSON.stringify(args, null, 2));
                        client.onMessageArrived = function(_a) {
                            var topic = _a.destinationName, msg = _a.payloadString;
                            _this._onMessage(topic, msg);
                        };
                        client.onConnectionLost = function(_a) {
                            var errorCode = _a.errorCode, args = $db4db3bd25849829$var$__rest(_a, [
                                "errorCode"
                            ]);
                            _this.onDisconnect($db4db3bd25849829$var$__assign({
                                clientId: clientId,
                                errorCode: errorCode
                            }, args));
                        };
                        return [
                            4 /*yield*/ ,
                            new Promise(function(resolve, reject) {
                                client.connect({
                                    useSSL: _this.isSSLEnabled,
                                    mqttVersion: 3,
                                    onSuccess: function() {
                                        return resolve(client);
                                    },
                                    onFailure: reject
                                });
                            })
                        ];
                    case 1:
                        _b.sent();
                        return [
                            2 /*return*/ ,
                            client
                        ];
                }
            });
        });
    };
    MqttOverWSProvider.prototype.connect = function(clientId, options) {
        if (options === void 0) options = {};
        return $db4db3bd25849829$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $db4db3bd25849829$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.clientsQueue.get(clientId, function(clientId) {
                                return _this.newClient($db4db3bd25849829$var$__assign($db4db3bd25849829$var$__assign({}, options), {
                                    clientId: clientId
                                }));
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    MqttOverWSProvider.prototype.disconnect = function(clientId) {
        return $db4db3bd25849829$var$__awaiter(this, void 0, void 0, function() {
            var client;
            return $db4db3bd25849829$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.clientsQueue.get(clientId, function() {
                                return null;
                            })
                        ];
                    case 1:
                        client = _a.sent();
                        if (client && client.isConnected()) client.disconnect();
                        this.clientsQueue.remove(clientId);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MqttOverWSProvider.prototype.publish = function(topics, msg) {
        return $db4db3bd25849829$var$__awaiter(this, void 0, void 0, function() {
            var targetTopics, message, url, client;
            return $db4db3bd25849829$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        targetTopics = [].concat(topics);
                        message = JSON.stringify(msg);
                        return [
                            4 /*yield*/ ,
                            this.endpoint
                        ];
                    case 1:
                        url = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.connect(this.clientId, {
                                url: url
                            })
                        ];
                    case 2:
                        client = _a.sent();
                        $db4db3bd25849829$var$logger.debug("Publishing to topic(s)", targetTopics.join(","), message);
                        targetTopics.forEach(function(topic) {
                            return client.send(topic, message);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MqttOverWSProvider.prototype._onMessage = function(topic, msg) {
        try {
            var matchedTopicObservers_1 = [];
            this._topicObservers.forEach(function(observerForTopic, observerTopic) {
                if ($db4db3bd25849829$export$4848305770dbede7(observerTopic, topic)) matchedTopicObservers_1.push(observerForTopic);
            });
            var parsedMessage_1 = JSON.parse(msg);
            if (typeof parsedMessage_1 === "object") parsedMessage_1[$db4db3bd25849829$var$topicSymbol] = topic;
            matchedTopicObservers_1.forEach(function(observersForTopic) {
                observersForTopic.forEach(function(observer) {
                    return observer.next(parsedMessage_1);
                });
            });
        } catch (error) {
            $db4db3bd25849829$var$logger.warn("Error handling message", error, msg);
        }
    };
    MqttOverWSProvider.prototype.subscribe = function(topics, options) {
        var _this = this;
        if (options === void 0) options = {};
        var targetTopics = [].concat(topics);
        $db4db3bd25849829$var$logger.debug("Subscribing to topic(s)", targetTopics.join(","));
        return new $gbejU(function(observer) {
            targetTopics.forEach(function(topic) {
                // this._topicObservers is used to notify the observers according to the topic received on the message
                var observersForTopic = _this._topicObservers.get(topic);
                if (!observersForTopic) {
                    observersForTopic = new Set();
                    _this._topicObservers.set(topic, observersForTopic);
                }
                observersForTopic.add(observer);
            });
            // @ts-ignore
            var client;
            var _a = options.clientId, clientId = _a === void 0 ? _this.clientId : _a;
            // this._clientIdObservers is used to close observers when client gets disconnected
            var observersForClientId = _this._clientIdObservers.get(clientId);
            if (!observersForClientId) observersForClientId = new Set();
            observersForClientId.add(observer);
            _this._clientIdObservers.set(clientId, observersForClientId);
            (function() {
                return $db4db3bd25849829$var$__awaiter(_this, void 0, void 0, function() {
                    var _a, url, _b, e_1;
                    return $db4db3bd25849829$var$__generator(this, function(_c) {
                        switch(_c.label){
                            case 0:
                                _a = options.url;
                                if (!(_a === void 0)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this.endpoint
                                ];
                            case 1:
                                _b = _c.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                _b = _a;
                                _c.label = 3;
                            case 3:
                                url = _b;
                                _c.label = 4;
                            case 4:
                                _c.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.connect(clientId, {
                                        url: url
                                    })
                                ];
                            case 5:
                                client = _c.sent();
                                targetTopics.forEach(function(topic) {
                                    client.subscribe(topic);
                                });
                                return [
                                    3 /*break*/ ,
                                    7
                                ];
                            case 6:
                                e_1 = _c.sent();
                                observer.error(e_1);
                                return [
                                    3 /*break*/ ,
                                    7
                                ];
                            case 7:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            })();
            return function() {
                $db4db3bd25849829$var$logger.debug("Unsubscribing from topic(s)", targetTopics.join(","));
                if (client) {
                    _this._clientIdObservers.get(clientId).delete(observer);
                    // No more observers per client => client not needed anymore
                    if (_this._clientIdObservers.get(clientId).size === 0) {
                        _this.disconnect(clientId);
                        _this._clientIdObservers.delete(clientId);
                    }
                    targetTopics.forEach(function(topic) {
                        var observersForTopic = _this._topicObservers.get(topic) || new Set();
                        observersForTopic.delete(observer);
                        // if no observers exists for the topic, topic should be removed
                        if (observersForTopic.size === 0) {
                            _this._topicObservers.delete(topic);
                            if (client.isConnected()) client.unsubscribe(topic);
                        }
                    });
                }
                return null;
            };
        });
    };
    return MqttOverWSProvider;
}((0, $aXKIu.AbstractPubSubProvider));

});
parcelRequire.register("anDWk", function(module, exports) {
/*******************************************************************************
 * Copyright (c) 2013 IBM Corp.
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License v1.0
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *    http://www.eclipse.org/legal/epl-v10.html
 * and the Eclipse Distribution License is available at
 *   http://www.eclipse.org/org/documents/edl-v10.php.
 *
 * Contributors:
 *    Andrew Banks - initial API and implementation and initial documentation
 *******************************************************************************/ // Only expose a single object name in the global namespace.
// Everything must go through this module. Global Paho module
// only has a single public function, client, which returns
// a Paho client object given connection details.
/**
 * Send and receive messages using web browsers.
 * <p>
 * This programming interface lets a JavaScript client application use the MQTT V3.1 or
 * V3.1.1 protocol to connect to an MQTT-supporting messaging server.
 *
 * The function supported includes:
 * <ol>
 * <li>Connecting to and disconnecting from a server. The server is identified by its host name and port number.
 * <li>Specifying options that relate to the communications link with the server,
 * for example the frequency of keep-alive heartbeats, and whether SSL/TLS is required.
 * <li>Subscribing to and receiving messages from MQTT Topics.
 * <li>Publishing messages to MQTT Topics.
 * </ol>
 * <p>
 * The API consists of two main objects:
 * <dl>
 * <dt><b>{@link Paho.Client}</b></dt>
 * <dd>This contains methods that provide the functionality of the API,
 * including provision of callbacks that notify the application when a message
 * arrives from or is delivered to the messaging server,
 * or when the status of its connection to the messaging server changes.</dd>
 * <dt><b>{@link Paho.Message}</b></dt>
 * <dd>This encapsulates the payload of the message along with various attributes
 * associated with its delivery, in particular the destination to which it has
 * been (or is about to be) sent.</dd>
 * </dl>
 * <p>
 * The programming interface validates parameters passed to it, and will throw
 * an Error containing an error message intended for developer use, if it detects
 * an error with any parameter.
 * <p>
 * Example:
 *
 * <code><pre>
var client = new Paho.MQTT.Client(location.hostname, Number(location.port), "clientId");
client.onConnectionLost = onConnectionLost;
client.onMessageArrived = onMessageArrived;
client.connect({onSuccess:onConnect});

function onConnect() {
  // Once a connection has been made, make a subscription and send a message.
  console.log("onConnect");
  client.subscribe("/World");
  var message = new Paho.MQTT.Message("Hello");
  message.destinationName = "/World";
  client.send(message);
};
function onConnectionLost(responseObject) {
  if (responseObject.errorCode !== 0)
	console.log("onConnectionLost:"+responseObject.errorMessage);
};
function onMessageArrived(message) {
  console.log("onMessageArrived:"+message.payloadString);
  client.disconnect();
};
 * </pre></code>
 * @namespace Paho
 */ /* jshint shadow:true */ (function ExportLibrary(root, factory) {
    module.exports = factory();
})(module.exports, function LibraryFactory() {
    var PahoMQTT = function(global1) {
        // Private variables below, these are only visible inside the function closure
        // which is used to define the module.
        var version = "@VERSION@-@BUILDLEVEL@";
        /**
	 * @private
	 */ var localStorage = global1.localStorage || function() {
            var data = {};
            return {
                setItem: function(key, item) {
                    data[key] = item;
                },
                getItem: function(key) {
                    return data[key];
                },
                removeItem: function(key) {
                    delete data[key];
                }
            };
        }();
        /**
	 * Unique message type identifiers, with associated
	 * associated integer values.
	 * @private
	 */ var MESSAGE_TYPE = {
            CONNECT: 1,
            CONNACK: 2,
            PUBLISH: 3,
            PUBACK: 4,
            PUBREC: 5,
            PUBREL: 6,
            PUBCOMP: 7,
            SUBSCRIBE: 8,
            SUBACK: 9,
            UNSUBSCRIBE: 10,
            UNSUBACK: 11,
            PINGREQ: 12,
            PINGRESP: 13,
            DISCONNECT: 14
        };
        // Collection of utility methods used to simplify module code
        // and promote the DRY pattern.
        /**
	 * Validate an object's parameter names to ensure they
	 * match a list of expected variables name for this option
	 * type. Used to ensure option object passed into the API don't
	 * contain erroneous parameters.
	 * @param {Object} obj - User options object
	 * @param {Object} keys - valid keys and types that may exist in obj.
	 * @throws {Error} Invalid option parameter found.
	 * @private
	 */ var validate = function(obj, keys) {
            for(var key in obj)if (obj.hasOwnProperty(key)) {
                if (keys.hasOwnProperty(key)) {
                    if (typeof obj[key] !== keys[key]) throw new Error(format(ERROR.INVALID_TYPE, [
                        typeof obj[key],
                        key
                    ]));
                } else {
                    var errorStr = "Unknown property, " + key + ". Valid properties are:";
                    for(var validKey in keys)if (keys.hasOwnProperty(validKey)) errorStr = errorStr + " " + validKey;
                    throw new Error(errorStr);
                }
            }
        };
        /**
	 * Return a new function which runs the user function bound
	 * to a fixed scope.
	 * @param {function} User function
	 * @param {object} Function scope
	 * @return {function} User function bound to another scope
	 * @private
	 */ var scope = function(f, scope) {
            return function() {
                return f.apply(scope, arguments);
            };
        };
        /**
	 * Unique message type identifiers, with associated
	 * associated integer values.
	 * @private
	 */ var ERROR = {
            OK: {
                code: 0,
                text: "AMQJSC0000I OK."
            },
            CONNECT_TIMEOUT: {
                code: 1,
                text: "AMQJSC0001E Connect timed out."
            },
            SUBSCRIBE_TIMEOUT: {
                code: 2,
                text: "AMQJS0002E Subscribe timed out."
            },
            UNSUBSCRIBE_TIMEOUT: {
                code: 3,
                text: "AMQJS0003E Unsubscribe timed out."
            },
            PING_TIMEOUT: {
                code: 4,
                text: "AMQJS0004E Ping timed out."
            },
            INTERNAL_ERROR: {
                code: 5,
                text: "AMQJS0005E Internal error. Error Message: {0}, Stack trace: {1}"
            },
            CONNACK_RETURNCODE: {
                code: 6,
                text: "AMQJS0006E Bad Connack return code:{0} {1}."
            },
            SOCKET_ERROR: {
                code: 7,
                text: "AMQJS0007E Socket error:{0}."
            },
            SOCKET_CLOSE: {
                code: 8,
                text: "AMQJS0008I Socket closed."
            },
            MALFORMED_UTF: {
                code: 9,
                text: "AMQJS0009E Malformed UTF data:{0} {1} {2}."
            },
            UNSUPPORTED: {
                code: 10,
                text: "AMQJS0010E {0} is not supported by this browser."
            },
            INVALID_STATE: {
                code: 11,
                text: "AMQJS0011E Invalid state {0}."
            },
            INVALID_TYPE: {
                code: 12,
                text: "AMQJS0012E Invalid type {0} for {1}."
            },
            INVALID_ARGUMENT: {
                code: 13,
                text: "AMQJS0013E Invalid argument {0} for {1}."
            },
            UNSUPPORTED_OPERATION: {
                code: 14,
                text: "AMQJS0014E Unsupported operation."
            },
            INVALID_STORED_DATA: {
                code: 15,
                text: "AMQJS0015E Invalid data in local storage key={0} value={1}."
            },
            INVALID_MQTT_MESSAGE_TYPE: {
                code: 16,
                text: "AMQJS0016E Invalid MQTT message type {0}."
            },
            MALFORMED_UNICODE: {
                code: 17,
                text: "AMQJS0017E Malformed Unicode string:{0} {1}."
            },
            BUFFER_FULL: {
                code: 18,
                text: "AMQJS0018E Message buffer is full, maximum buffer size: {0}."
            }
        };
        /** CONNACK RC Meaning. */ var CONNACK_RC = {
            0: "Connection Accepted",
            1: "Connection Refused: unacceptable protocol version",
            2: "Connection Refused: identifier rejected",
            3: "Connection Refused: server unavailable",
            4: "Connection Refused: bad user name or password",
            5: "Connection Refused: not authorized"
        };
        /**
	 * Format an error message text.
	 * @private
	 * @param {error} ERROR value above.
	 * @param {substitutions} [array] substituted into the text.
	 * @return the text with the substitutions made.
	 */ var format = function(error, substitutions) {
            var text = error.text;
            if (substitutions) {
                var field, start;
                for(var i = 0; i < substitutions.length; i++){
                    field = "{" + i + "}";
                    start = text.indexOf(field);
                    if (start > 0) {
                        var part1 = text.substring(0, start);
                        var part2 = text.substring(start + field.length);
                        text = part1 + substitutions[i] + part2;
                    }
                }
            }
            return text;
        };
        //MQTT protocol and version          6    M    Q    I    s    d    p    3
        var MqttProtoIdentifierv3 = [
            0x00,
            0x06,
            0x4d,
            0x51,
            0x49,
            0x73,
            0x64,
            0x70,
            0x03
        ];
        //MQTT proto/version for 311         4    M    Q    T    T    4
        var MqttProtoIdentifierv4 = [
            0x00,
            0x04,
            0x4d,
            0x51,
            0x54,
            0x54,
            0x04
        ];
        /**
	 * Construct an MQTT wire protocol message.
	 * @param type MQTT packet type.
	 * @param options optional wire message attributes.
	 *
	 * Optional properties
	 *
	 * messageIdentifier: message ID in the range [0..65535]
	 * payloadMessage:	Application Message - PUBLISH only
	 * connectStrings:	array of 0 or more Strings to be put into the CONNECT payload
	 * topics:			array of strings (SUBSCRIBE, UNSUBSCRIBE)
	 * requestQoS:		array of QoS values [0..2]
	 *
	 * "Flag" properties
	 * cleanSession:	true if present / false if absent (CONNECT)
	 * willMessage:  	true if present / false if absent (CONNECT)
	 * isRetained:		true if present / false if absent (CONNECT)
	 * userName:		true if present / false if absent (CONNECT)
	 * password:		true if present / false if absent (CONNECT)
	 * keepAliveInterval:	integer [0..65535]  (CONNECT)
	 *
	 * @private
	 * @ignore
	 */ var WireMessage = function(type, options) {
            this.type = type;
            for(var name in options)if (options.hasOwnProperty(name)) this[name] = options[name];
        };
        WireMessage.prototype.encode = function() {
            // Compute the first byte of the fixed header
            var first = (this.type & 0x0f) << 4;
            /*
		 * Now calculate the length of the variable header + payload by adding up the lengths
		 * of all the component parts
		 */ var remLength = 0;
            var topicStrLength = [];
            var destinationNameLength = 0;
            var willMessagePayloadBytes;
            // if the message contains a messageIdentifier then we need two bytes for that
            if (this.messageIdentifier !== undefined) remLength += 2;
            switch(this.type){
                // If this a Connect then we need to include 12 bytes for its header
                case MESSAGE_TYPE.CONNECT:
                    switch(this.mqttVersion){
                        case 3:
                            remLength += MqttProtoIdentifierv3.length + 3;
                            break;
                        case 4:
                            remLength += MqttProtoIdentifierv4.length + 3;
                            break;
                    }
                    remLength += UTF8Length(this.clientId) + 2;
                    if (this.willMessage !== undefined) {
                        remLength += UTF8Length(this.willMessage.destinationName) + 2;
                        // Will message is always a string, sent as UTF-8 characters with a preceding length.
                        willMessagePayloadBytes = this.willMessage.payloadBytes;
                        if (!(willMessagePayloadBytes instanceof Uint8Array)) willMessagePayloadBytes = new Uint8Array(payloadBytes);
                        remLength += willMessagePayloadBytes.byteLength + 2;
                    }
                    if (this.userName !== undefined) remLength += UTF8Length(this.userName) + 2;
                    if (this.password !== undefined) remLength += UTF8Length(this.password) + 2;
                    break;
                // Subscribe, Unsubscribe can both contain topic strings
                case MESSAGE_TYPE.SUBSCRIBE:
                    first |= 0x02; // Qos = 1;
                    for(var i = 0; i < this.topics.length; i++){
                        topicStrLength[i] = UTF8Length(this.topics[i]);
                        remLength += topicStrLength[i] + 2;
                    }
                    remLength += this.requestedQos.length; // 1 byte for each topic's Qos
                    break;
                case MESSAGE_TYPE.UNSUBSCRIBE:
                    first |= 0x02; // Qos = 1;
                    for(var i = 0; i < this.topics.length; i++){
                        topicStrLength[i] = UTF8Length(this.topics[i]);
                        remLength += topicStrLength[i] + 2;
                    }
                    break;
                case MESSAGE_TYPE.PUBREL:
                    first |= 0x02; // Qos = 1;
                    break;
                case MESSAGE_TYPE.PUBLISH:
                    if (this.payloadMessage.duplicate) first |= 0x08;
                    first = first |= this.payloadMessage.qos << 1;
                    if (this.payloadMessage.retained) first |= 0x01;
                    destinationNameLength = UTF8Length(this.payloadMessage.destinationName);
                    remLength += destinationNameLength + 2;
                    var payloadBytes = this.payloadMessage.payloadBytes;
                    remLength += payloadBytes.byteLength;
                    if (payloadBytes instanceof ArrayBuffer) payloadBytes = new Uint8Array(payloadBytes);
                    else if (!(payloadBytes instanceof Uint8Array)) payloadBytes = new Uint8Array(payloadBytes.buffer);
                    break;
                case MESSAGE_TYPE.DISCONNECT:
                    break;
                default:
                    break;
            }
            // Now we can allocate a buffer for the message
            var mbi = encodeMBI(remLength); // Convert the length to MQTT MBI format
            var pos = mbi.length + 1; // Offset of start of variable header
            var buffer = new ArrayBuffer(remLength + pos);
            var byteStream = new Uint8Array(buffer); // view it as a sequence of bytes
            //Write the fixed header into the buffer
            byteStream[0] = first;
            byteStream.set(mbi, 1);
            // If this is a PUBLISH then the variable header starts with a topic
            if (this.type == MESSAGE_TYPE.PUBLISH) pos = writeString(this.payloadMessage.destinationName, destinationNameLength, byteStream, pos);
            else if (this.type == MESSAGE_TYPE.CONNECT) {
                switch(this.mqttVersion){
                    case 3:
                        byteStream.set(MqttProtoIdentifierv3, pos);
                        pos += MqttProtoIdentifierv3.length;
                        break;
                    case 4:
                        byteStream.set(MqttProtoIdentifierv4, pos);
                        pos += MqttProtoIdentifierv4.length;
                        break;
                }
                var connectFlags = 0;
                if (this.cleanSession) connectFlags = 0x02;
                if (this.willMessage !== undefined) {
                    connectFlags |= 0x04;
                    connectFlags |= this.willMessage.qos << 3;
                    if (this.willMessage.retained) connectFlags |= 0x20;
                }
                if (this.userName !== undefined) connectFlags |= 0x80;
                if (this.password !== undefined) connectFlags |= 0x40;
                byteStream[pos++] = connectFlags;
                pos = writeUint16(this.keepAliveInterval, byteStream, pos);
            }
            // Output the messageIdentifier - if there is one
            if (this.messageIdentifier !== undefined) pos = writeUint16(this.messageIdentifier, byteStream, pos);
            switch(this.type){
                case MESSAGE_TYPE.CONNECT:
                    pos = writeString(this.clientId, UTF8Length(this.clientId), byteStream, pos);
                    if (this.willMessage !== undefined) {
                        pos = writeString(this.willMessage.destinationName, UTF8Length(this.willMessage.destinationName), byteStream, pos);
                        pos = writeUint16(willMessagePayloadBytes.byteLength, byteStream, pos);
                        byteStream.set(willMessagePayloadBytes, pos);
                        pos += willMessagePayloadBytes.byteLength;
                    }
                    if (this.userName !== undefined) pos = writeString(this.userName, UTF8Length(this.userName), byteStream, pos);
                    if (this.password !== undefined) pos = writeString(this.password, UTF8Length(this.password), byteStream, pos);
                    break;
                case MESSAGE_TYPE.PUBLISH:
                    // PUBLISH has a text or binary payload, if text do not add a 2 byte length field, just the UTF characters.
                    byteStream.set(payloadBytes, pos);
                    break;
                //    	    case MESSAGE_TYPE.PUBREC:
                //    	    case MESSAGE_TYPE.PUBREL:
                //    	    case MESSAGE_TYPE.PUBCOMP:
                //    	    	break;
                case MESSAGE_TYPE.SUBSCRIBE:
                    // SUBSCRIBE has a list of topic strings and request QoS
                    for(var i = 0; i < this.topics.length; i++){
                        pos = writeString(this.topics[i], topicStrLength[i], byteStream, pos);
                        byteStream[pos++] = this.requestedQos[i];
                    }
                    break;
                case MESSAGE_TYPE.UNSUBSCRIBE:
                    // UNSUBSCRIBE has a list of topic strings
                    for(var i = 0; i < this.topics.length; i++)pos = writeString(this.topics[i], topicStrLength[i], byteStream, pos);
                    break;
                default:
            }
            return buffer;
        };
        function decodeMessage(input, pos) {
            var startingPos = pos;
            var first = input[pos];
            var type = first >> 4;
            var messageInfo = first &= 0x0f;
            pos += 1;
            // Decode the remaining length (MBI format)
            var digit;
            var remLength = 0;
            var multiplier = 1;
            do {
                if (pos == input.length) return [
                    null,
                    startingPos
                ];
                digit = input[pos++];
                remLength += (digit & 0x7F) * multiplier;
                multiplier *= 128;
            }while ((digit & 0x80) !== 0);
            var endPos = pos + remLength;
            if (endPos > input.length) return [
                null,
                startingPos
            ];
            var wireMessage = new WireMessage(type);
            switch(type){
                case MESSAGE_TYPE.CONNACK:
                    var connectAcknowledgeFlags = input[pos++];
                    if (connectAcknowledgeFlags & 0x01) wireMessage.sessionPresent = true;
                    wireMessage.returnCode = input[pos++];
                    break;
                case MESSAGE_TYPE.PUBLISH:
                    var qos = messageInfo >> 1 & 0x03;
                    var len = readUint16(input, pos);
                    pos += 2;
                    var topicName = parseUTF8(input, pos, len);
                    pos += len;
                    // If QoS 1 or 2 there will be a messageIdentifier
                    if (qos > 0) {
                        wireMessage.messageIdentifier = readUint16(input, pos);
                        pos += 2;
                    }
                    var message = new Message(input.subarray(pos, endPos));
                    if ((messageInfo & 0x01) == 0x01) message.retained = true;
                    if ((messageInfo & 0x08) == 0x08) message.duplicate = true;
                    message.qos = qos;
                    message.destinationName = topicName;
                    wireMessage.payloadMessage = message;
                    break;
                case MESSAGE_TYPE.PUBACK:
                case MESSAGE_TYPE.PUBREC:
                case MESSAGE_TYPE.PUBREL:
                case MESSAGE_TYPE.PUBCOMP:
                case MESSAGE_TYPE.UNSUBACK:
                    wireMessage.messageIdentifier = readUint16(input, pos);
                    break;
                case MESSAGE_TYPE.SUBACK:
                    wireMessage.messageIdentifier = readUint16(input, pos);
                    pos += 2;
                    wireMessage.returnCode = input.subarray(pos, endPos);
                    break;
                default:
                    break;
            }
            return [
                wireMessage,
                endPos
            ];
        }
        function writeUint16(input, buffer, offset) {
            buffer[offset++] = input >> 8; //MSB
            buffer[offset++] = input % 256; //LSB
            return offset;
        }
        function writeString(input, utf8Length, buffer, offset) {
            offset = writeUint16(utf8Length, buffer, offset);
            stringToUTF8(input, buffer, offset);
            return offset + utf8Length;
        }
        function readUint16(buffer, offset) {
            return 256 * buffer[offset] + buffer[offset + 1];
        }
        /**
	 * Encodes an MQTT Multi-Byte Integer
	 * @private
	 */ function encodeMBI(number) {
            var output = new Array(1);
            var numBytes = 0;
            do {
                var digit = number % 128;
                number = number >> 7;
                if (number > 0) digit |= 0x80;
                output[numBytes++] = digit;
            }while (number > 0 && numBytes < 4);
            return output;
        }
        /**
	 * Takes a String and calculates its length in bytes when encoded in UTF8.
	 * @private
	 */ function UTF8Length(input) {
            var output = 0;
            for(var i = 0; i < input.length; i++){
                var charCode = input.charCodeAt(i);
                if (charCode > 0x7FF) {
                    // Surrogate pair means its a 4 byte character
                    if (0xD800 <= charCode && charCode <= 0xDBFF) {
                        i++;
                        output++;
                    }
                    output += 3;
                } else if (charCode > 0x7F) output += 2;
                else output++;
            }
            return output;
        }
        /**
	 * Takes a String and writes it into an array as UTF8 encoded bytes.
	 * @private
	 */ function stringToUTF8(input, output, start) {
            var pos = start;
            for(var i = 0; i < input.length; i++){
                var charCode = input.charCodeAt(i);
                // Check for a surrogate pair.
                if (0xD800 <= charCode && charCode <= 0xDBFF) {
                    var lowCharCode = input.charCodeAt(++i);
                    if (isNaN(lowCharCode)) throw new Error(format(ERROR.MALFORMED_UNICODE, [
                        charCode,
                        lowCharCode
                    ]));
                    charCode = (charCode - 0xD800 << 10) + (lowCharCode - 0xDC00) + 0x10000;
                }
                if (charCode <= 0x7F) output[pos++] = charCode;
                else if (charCode <= 0x7FF) {
                    output[pos++] = charCode >> 6 & 0x1F | 0xC0;
                    output[pos++] = charCode & 0x3F | 0x80;
                } else if (charCode <= 0xFFFF) {
                    output[pos++] = charCode >> 12 & 0x0F | 0xE0;
                    output[pos++] = charCode >> 6 & 0x3F | 0x80;
                    output[pos++] = charCode & 0x3F | 0x80;
                } else {
                    output[pos++] = charCode >> 18 & 0x07 | 0xF0;
                    output[pos++] = charCode >> 12 & 0x3F | 0x80;
                    output[pos++] = charCode >> 6 & 0x3F | 0x80;
                    output[pos++] = charCode & 0x3F | 0x80;
                }
            }
            return output;
        }
        function parseUTF8(input, offset, length) {
            var output = "";
            var utf16;
            var pos = offset;
            while(pos < offset + length){
                var byte1 = input[pos++];
                if (byte1 < 128) utf16 = byte1;
                else {
                    var byte2 = input[pos++] - 128;
                    if (byte2 < 0) throw new Error(format(ERROR.MALFORMED_UTF, [
                        byte1.toString(16),
                        byte2.toString(16),
                        ""
                    ]));
                    if (byte1 < 0xE0) utf16 = 64 * (byte1 - 0xC0) + byte2;
                    else {
                        var byte3 = input[pos++] - 128;
                        if (byte3 < 0) throw new Error(format(ERROR.MALFORMED_UTF, [
                            byte1.toString(16),
                            byte2.toString(16),
                            byte3.toString(16)
                        ]));
                        if (byte1 < 0xF0) utf16 = 4096 * (byte1 - 0xE0) + 64 * byte2 + byte3;
                        else {
                            var byte4 = input[pos++] - 128;
                            if (byte4 < 0) throw new Error(format(ERROR.MALFORMED_UTF, [
                                byte1.toString(16),
                                byte2.toString(16),
                                byte3.toString(16),
                                byte4.toString(16)
                            ]));
                            if (byte1 < 0xF8) utf16 = 262144 * (byte1 - 0xF0) + 4096 * byte2 + 64 * byte3 + byte4;
                            else throw new Error(format(ERROR.MALFORMED_UTF, [
                                byte1.toString(16),
                                byte2.toString(16),
                                byte3.toString(16),
                                byte4.toString(16)
                            ]));
                        }
                    }
                }
                if (utf16 > 0xFFFF) {
                    utf16 -= 0x10000;
                    output += String.fromCharCode(0xD800 + (utf16 >> 10)); // lead character
                    utf16 = 0xDC00 + (utf16 & 0x3FF); // trail character
                }
                output += String.fromCharCode(utf16);
            }
            return output;
        }
        /**
	 * Repeat keepalive requests, monitor responses.
	 * @ignore
	 */ var Pinger = function(client, keepAliveInterval) {
            this._client = client;
            this._keepAliveInterval = keepAliveInterval * 1000;
            this.isReset = false;
            var pingReq = new WireMessage(MESSAGE_TYPE.PINGREQ).encode();
            var doTimeout = function(pinger) {
                return function() {
                    return doPing.apply(pinger);
                };
            };
            /** @ignore */ var doPing = function() {
                if (!this.isReset) {
                    this._client._trace("Pinger.doPing", "Timed out");
                    this._client._disconnected(ERROR.PING_TIMEOUT.code, format(ERROR.PING_TIMEOUT));
                } else {
                    this.isReset = false;
                    this._client._trace("Pinger.doPing", "send PINGREQ");
                    this._client.socket.send(pingReq);
                    this.timeout = setTimeout(doTimeout(this), this._keepAliveInterval);
                }
            };
            this.reset = function() {
                this.isReset = true;
                clearTimeout(this.timeout);
                if (this._keepAliveInterval > 0) this.timeout = setTimeout(doTimeout(this), this._keepAliveInterval);
            };
            this.cancel = function() {
                clearTimeout(this.timeout);
            };
        };
        /**
	 * Monitor request completion.
	 * @ignore
	 */ var Timeout = function(client, timeoutSeconds, action, args) {
            if (!timeoutSeconds) timeoutSeconds = 30;
            var doTimeout = function(action, client, args) {
                return function() {
                    return action.apply(client, args);
                };
            };
            this.timeout = setTimeout(doTimeout(action, client, args), timeoutSeconds * 1000);
            this.cancel = function() {
                clearTimeout(this.timeout);
            };
        };
        /**
	 * Internal implementation of the Websockets MQTT V3.1 client.
	 *
	 * @name Paho.ClientImpl @constructor
	 * @param {String} host the DNS nameof the webSocket host.
	 * @param {Number} port the port number for that host.
	 * @param {String} clientId the MQ client identifier.
	 */ var ClientImpl = function(uri, host, port, path, clientId) {
            // Check dependencies are satisfied in this browser.
            if (!("WebSocket" in global1 && global1.WebSocket !== null)) throw new Error(format(ERROR.UNSUPPORTED, [
                "WebSocket"
            ]));
            if (!("ArrayBuffer" in global1 && global1.ArrayBuffer !== null)) throw new Error(format(ERROR.UNSUPPORTED, [
                "ArrayBuffer"
            ]));
            this._trace("Paho.Client", uri, host, port, path, clientId);
            this.host = host;
            this.port = port;
            this.path = path;
            this.uri = uri;
            this.clientId = clientId;
            this._wsuri = null;
            // Local storagekeys are qualified with the following string.
            // The conditional inclusion of path in the key is for backward
            // compatibility to when the path was not configurable and assumed to
            // be /mqtt
            this._localKey = host + ":" + port + (path != "/mqtt" ? ":" + path : "") + ":" + clientId + ":";
            // Create private instance-only message queue
            // Internal queue of messages to be sent, in sending order.
            this._msg_queue = [];
            this._buffered_msg_queue = [];
            // Messages we have sent and are expecting a response for, indexed by their respective message ids.
            this._sentMessages = {};
            // Messages we have received and acknowleged and are expecting a confirm message for
            // indexed by their respective message ids.
            this._receivedMessages = {};
            // Internal list of callbacks to be executed when messages
            // have been successfully sent over web socket, e.g. disconnect
            // when it doesn't have to wait for ACK, just message is dispatched.
            this._notify_msg_sent = {};
            // Unique identifier for SEND messages, incrementing
            // counter as messages are sent.
            this._message_identifier = 1;
            // Used to determine the transmission sequence of stored sent messages.
            this._sequence = 0;
            // Load the local state, if any, from the saved version, only restore state relevant to this client.
            for(var key in localStorage)if (key.indexOf("Sent:" + this._localKey) === 0 || key.indexOf("Received:" + this._localKey) === 0) this.restore(key);
        };
        // Messaging Client public instance members.
        ClientImpl.prototype.host = null;
        ClientImpl.prototype.port = null;
        ClientImpl.prototype.path = null;
        ClientImpl.prototype.uri = null;
        ClientImpl.prototype.clientId = null;
        // Messaging Client private instance members.
        ClientImpl.prototype.socket = null;
        /* true once we have received an acknowledgement to a CONNECT packet. */ ClientImpl.prototype.connected = false;
        /* The largest message identifier allowed, may not be larger than 2**16 but
		 * if set smaller reduces the maximum number of outbound messages allowed.
		 */ ClientImpl.prototype.maxMessageIdentifier = 65536;
        ClientImpl.prototype.connectOptions = null;
        ClientImpl.prototype.hostIndex = null;
        ClientImpl.prototype.onConnected = null;
        ClientImpl.prototype.onConnectionLost = null;
        ClientImpl.prototype.onMessageDelivered = null;
        ClientImpl.prototype.onMessageArrived = null;
        ClientImpl.prototype.traceFunction = null;
        ClientImpl.prototype._msg_queue = null;
        ClientImpl.prototype._buffered_msg_queue = null;
        ClientImpl.prototype._connectTimeout = null;
        /* The sendPinger monitors how long we allow before we send data to prove to the server that we are alive. */ ClientImpl.prototype.sendPinger = null;
        /* The receivePinger monitors how long we allow before we require evidence that the server is alive. */ ClientImpl.prototype.receivePinger = null;
        ClientImpl.prototype._reconnectInterval = 1; // Reconnect Delay, starts at 1 second
        ClientImpl.prototype._reconnecting = false;
        ClientImpl.prototype._reconnectTimeout = null;
        ClientImpl.prototype.disconnectedPublishing = false;
        ClientImpl.prototype.disconnectedBufferSize = 5000;
        ClientImpl.prototype.receiveBuffer = null;
        ClientImpl.prototype._traceBuffer = null;
        ClientImpl.prototype._MAX_TRACE_ENTRIES = 100;
        ClientImpl.prototype.connect = function(connectOptions) {
            var connectOptionsMasked = this._traceMask(connectOptions, "password");
            this._trace("Client.connect", connectOptionsMasked, this.socket, this.connected);
            if (this.connected) throw new Error(format(ERROR.INVALID_STATE, [
                "already connected"
            ]));
            if (this.socket) throw new Error(format(ERROR.INVALID_STATE, [
                "already connected"
            ]));
            if (this._reconnecting) {
                // connect() function is called while reconnect is in progress.
                // Terminate the auto reconnect process to use new connect options.
                this._reconnectTimeout.cancel();
                this._reconnectTimeout = null;
                this._reconnecting = false;
            }
            this.connectOptions = connectOptions;
            this._reconnectInterval = 1;
            this._reconnecting = false;
            if (connectOptions.uris) {
                this.hostIndex = 0;
                this._doConnect(connectOptions.uris[0]);
            } else this._doConnect(this.uri);
        };
        ClientImpl.prototype.subscribe = function(filter, subscribeOptions) {
            this._trace("Client.subscribe", filter, subscribeOptions);
            if (!this.connected) throw new Error(format(ERROR.INVALID_STATE, [
                "not connected"
            ]));
            var wireMessage = new WireMessage(MESSAGE_TYPE.SUBSCRIBE);
            wireMessage.topics = filter.constructor === Array ? filter : [
                filter
            ];
            if (subscribeOptions.qos === undefined) subscribeOptions.qos = 0;
            wireMessage.requestedQos = [];
            for(var i = 0; i < wireMessage.topics.length; i++)wireMessage.requestedQos[i] = subscribeOptions.qos;
            if (subscribeOptions.onSuccess) wireMessage.onSuccess = function(grantedQos) {
                subscribeOptions.onSuccess({
                    invocationContext: subscribeOptions.invocationContext,
                    grantedQos: grantedQos
                });
            };
            if (subscribeOptions.onFailure) wireMessage.onFailure = function(errorCode) {
                subscribeOptions.onFailure({
                    invocationContext: subscribeOptions.invocationContext,
                    errorCode: errorCode,
                    errorMessage: format(errorCode)
                });
            };
            if (subscribeOptions.timeout) wireMessage.timeOut = new Timeout(this, subscribeOptions.timeout, subscribeOptions.onFailure, [
                {
                    invocationContext: subscribeOptions.invocationContext,
                    errorCode: ERROR.SUBSCRIBE_TIMEOUT.code,
                    errorMessage: format(ERROR.SUBSCRIBE_TIMEOUT)
                }
            ]);
            // All subscriptions return a SUBACK.
            this._requires_ack(wireMessage);
            this._schedule_message(wireMessage);
        };
        /** @ignore */ ClientImpl.prototype.unsubscribe = function(filter, unsubscribeOptions) {
            this._trace("Client.unsubscribe", filter, unsubscribeOptions);
            if (!this.connected) throw new Error(format(ERROR.INVALID_STATE, [
                "not connected"
            ]));
            var wireMessage = new WireMessage(MESSAGE_TYPE.UNSUBSCRIBE);
            wireMessage.topics = filter.constructor === Array ? filter : [
                filter
            ];
            if (unsubscribeOptions.onSuccess) wireMessage.callback = function() {
                unsubscribeOptions.onSuccess({
                    invocationContext: unsubscribeOptions.invocationContext
                });
            };
            if (unsubscribeOptions.timeout) wireMessage.timeOut = new Timeout(this, unsubscribeOptions.timeout, unsubscribeOptions.onFailure, [
                {
                    invocationContext: unsubscribeOptions.invocationContext,
                    errorCode: ERROR.UNSUBSCRIBE_TIMEOUT.code,
                    errorMessage: format(ERROR.UNSUBSCRIBE_TIMEOUT)
                }
            ]);
            // All unsubscribes return a SUBACK.
            this._requires_ack(wireMessage);
            this._schedule_message(wireMessage);
        };
        ClientImpl.prototype.send = function(message) {
            this._trace("Client.send", message);
            var wireMessage = new WireMessage(MESSAGE_TYPE.PUBLISH);
            wireMessage.payloadMessage = message;
            if (this.connected) {
                // Mark qos 1 & 2 message as "ACK required"
                // For qos 0 message, invoke onMessageDelivered callback if there is one.
                // Then schedule the message.
                if (message.qos > 0) this._requires_ack(wireMessage);
                else if (this.onMessageDelivered) this._notify_msg_sent[wireMessage] = this.onMessageDelivered(wireMessage.payloadMessage);
                this._schedule_message(wireMessage);
            } else {
                // Currently disconnected, will not schedule this message
                // Check if reconnecting is in progress and disconnected publish is enabled.
                if (this._reconnecting && this.disconnectedPublishing) {
                    // Check the limit which include the "required ACK" messages
                    var messageCount = Object.keys(this._sentMessages).length + this._buffered_msg_queue.length;
                    if (messageCount > this.disconnectedBufferSize) throw new Error(format(ERROR.BUFFER_FULL, [
                        this.disconnectedBufferSize
                    ]));
                    else if (message.qos > 0) // Mark this message as "ACK required"
                    this._requires_ack(wireMessage);
                    else {
                        wireMessage.sequence = ++this._sequence;
                        // Add messages in fifo order to array, by adding to start
                        this._buffered_msg_queue.unshift(wireMessage);
                    }
                } else throw new Error(format(ERROR.INVALID_STATE, [
                    "not connected"
                ]));
            }
        };
        ClientImpl.prototype.disconnect = function() {
            this._trace("Client.disconnect");
            if (this._reconnecting) {
                // disconnect() function is called while reconnect is in progress.
                // Terminate the auto reconnect process.
                this._reconnectTimeout.cancel();
                this._reconnectTimeout = null;
                this._reconnecting = false;
            }
            if (!this.socket) throw new Error(format(ERROR.INVALID_STATE, [
                "not connecting or connected"
            ]));
            var wireMessage = new WireMessage(MESSAGE_TYPE.DISCONNECT);
            // Run the disconnected call back as soon as the message has been sent,
            // in case of a failure later on in the disconnect processing.
            // as a consequence, the _disconected call back may be run several times.
            this._notify_msg_sent[wireMessage] = scope(this._disconnected, this);
            this._schedule_message(wireMessage);
        };
        ClientImpl.prototype.getTraceLog = function() {
            if (this._traceBuffer !== null) {
                this._trace("Client.getTraceLog", new Date());
                this._trace("Client.getTraceLog in flight messages", this._sentMessages.length);
                for(var key in this._sentMessages)this._trace("_sentMessages ", key, this._sentMessages[key]);
                for(var key in this._receivedMessages)this._trace("_receivedMessages ", key, this._receivedMessages[key]);
                return this._traceBuffer;
            }
        };
        ClientImpl.prototype.startTrace = function() {
            if (this._traceBuffer === null) this._traceBuffer = [];
            this._trace("Client.startTrace", new Date(), version);
        };
        ClientImpl.prototype.stopTrace = function() {
            delete this._traceBuffer;
        };
        ClientImpl.prototype._doConnect = function(wsurl) {
            // When the socket is open, this client will send the CONNECT WireMessage using the saved parameters.
            if (this.connectOptions.useSSL) {
                var uriParts = wsurl.split(":");
                uriParts[0] = "wss";
                wsurl = uriParts.join(":");
            }
            this._wsuri = wsurl;
            this.connected = false;
            if (this.connectOptions.mqttVersion < 4) this.socket = new WebSocket(wsurl, [
                "mqttv3.1"
            ]);
            else this.socket = new WebSocket(wsurl, [
                "mqtt"
            ]);
            this.socket.binaryType = "arraybuffer";
            this.socket.onopen = scope(this._on_socket_open, this);
            this.socket.onmessage = scope(this._on_socket_message, this);
            this.socket.onerror = scope(this._on_socket_error, this);
            this.socket.onclose = scope(this._on_socket_close, this);
            this.sendPinger = new Pinger(this, this.connectOptions.keepAliveInterval);
            this.receivePinger = new Pinger(this, this.connectOptions.keepAliveInterval);
            if (this._connectTimeout) {
                this._connectTimeout.cancel();
                this._connectTimeout = null;
            }
            this._connectTimeout = new Timeout(this, this.connectOptions.timeout, this._disconnected, [
                ERROR.CONNECT_TIMEOUT.code,
                format(ERROR.CONNECT_TIMEOUT)
            ]);
        };
        // Schedule a new message to be sent over the WebSockets
        // connection. CONNECT messages cause WebSocket connection
        // to be started. All other messages are queued internally
        // until this has happened. When WS connection starts, process
        // all outstanding messages.
        ClientImpl.prototype._schedule_message = function(message) {
            // Add messages in fifo order to array, by adding to start
            this._msg_queue.unshift(message);
            // Process outstanding messages in the queue if we have an  open socket, and have received CONNACK.
            if (this.connected) this._process_queue();
        };
        ClientImpl.prototype.store = function(prefix, wireMessage) {
            var storedMessage = {
                type: wireMessage.type,
                messageIdentifier: wireMessage.messageIdentifier,
                version: 1
            };
            switch(wireMessage.type){
                case MESSAGE_TYPE.PUBLISH:
                    if (wireMessage.pubRecReceived) storedMessage.pubRecReceived = true;
                    // Convert the payload to a hex string.
                    storedMessage.payloadMessage = {};
                    var hex = "";
                    var messageBytes = wireMessage.payloadMessage.payloadBytes;
                    for(var i = 0; i < messageBytes.length; i++)if (messageBytes[i] <= 0xF) hex = hex + "0" + messageBytes[i].toString(16);
                    else hex = hex + messageBytes[i].toString(16);
                    storedMessage.payloadMessage.payloadHex = hex;
                    storedMessage.payloadMessage.qos = wireMessage.payloadMessage.qos;
                    storedMessage.payloadMessage.destinationName = wireMessage.payloadMessage.destinationName;
                    if (wireMessage.payloadMessage.duplicate) storedMessage.payloadMessage.duplicate = true;
                    if (wireMessage.payloadMessage.retained) storedMessage.payloadMessage.retained = true;
                    // Add a sequence number to sent messages.
                    if (prefix.indexOf("Sent:") === 0) {
                        if (wireMessage.sequence === undefined) wireMessage.sequence = ++this._sequence;
                        storedMessage.sequence = wireMessage.sequence;
                    }
                    break;
                default:
                    throw Error(format(ERROR.INVALID_STORED_DATA, [
                        prefix + this._localKey + wireMessage.messageIdentifier,
                        storedMessage
                    ]));
            }
            localStorage.setItem(prefix + this._localKey + wireMessage.messageIdentifier, JSON.stringify(storedMessage));
        };
        ClientImpl.prototype.restore = function(key) {
            var value = localStorage.getItem(key);
            var storedMessage = JSON.parse(value);
            var wireMessage = new WireMessage(storedMessage.type, storedMessage);
            switch(storedMessage.type){
                case MESSAGE_TYPE.PUBLISH:
                    // Replace the payload message with a Message object.
                    var hex = storedMessage.payloadMessage.payloadHex;
                    var buffer = new ArrayBuffer(hex.length / 2);
                    var byteStream = new Uint8Array(buffer);
                    var i = 0;
                    while(hex.length >= 2){
                        var x = parseInt(hex.substring(0, 2), 16);
                        hex = hex.substring(2, hex.length);
                        byteStream[i++] = x;
                    }
                    var payloadMessage = new Message(byteStream);
                    payloadMessage.qos = storedMessage.payloadMessage.qos;
                    payloadMessage.destinationName = storedMessage.payloadMessage.destinationName;
                    if (storedMessage.payloadMessage.duplicate) payloadMessage.duplicate = true;
                    if (storedMessage.payloadMessage.retained) payloadMessage.retained = true;
                    wireMessage.payloadMessage = payloadMessage;
                    break;
                default:
                    throw Error(format(ERROR.INVALID_STORED_DATA, [
                        key,
                        value
                    ]));
            }
            if (key.indexOf("Sent:" + this._localKey) === 0) {
                wireMessage.payloadMessage.duplicate = true;
                this._sentMessages[wireMessage.messageIdentifier] = wireMessage;
            } else if (key.indexOf("Received:" + this._localKey) === 0) this._receivedMessages[wireMessage.messageIdentifier] = wireMessage;
        };
        ClientImpl.prototype._process_queue = function() {
            var message = null;
            // Send all queued messages down socket connection
            while(message = this._msg_queue.pop()){
                this._socket_send(message);
                // Notify listeners that message was successfully sent
                if (this._notify_msg_sent[message]) {
                    this._notify_msg_sent[message]();
                    delete this._notify_msg_sent[message];
                }
            }
        };
        /**
	 * Expect an ACK response for this message. Add message to the set of in progress
	 * messages and set an unused identifier in this message.
	 * @ignore
	 */ ClientImpl.prototype._requires_ack = function(wireMessage) {
            var messageCount = Object.keys(this._sentMessages).length;
            if (messageCount > this.maxMessageIdentifier) throw Error("Too many messages:" + messageCount);
            while(this._sentMessages[this._message_identifier] !== undefined)this._message_identifier++;
            wireMessage.messageIdentifier = this._message_identifier;
            this._sentMessages[wireMessage.messageIdentifier] = wireMessage;
            if (wireMessage.type === MESSAGE_TYPE.PUBLISH) this.store("Sent:", wireMessage);
            if (this._message_identifier === this.maxMessageIdentifier) this._message_identifier = 1;
        };
        /**
	 * Called when the underlying websocket has been opened.
	 * @ignore
	 */ ClientImpl.prototype._on_socket_open = function() {
            // Create the CONNECT message object.
            var wireMessage = new WireMessage(MESSAGE_TYPE.CONNECT, this.connectOptions);
            wireMessage.clientId = this.clientId;
            this._socket_send(wireMessage);
        };
        /**
	 * Called when the underlying websocket has received a complete packet.
	 * @ignore
	 */ ClientImpl.prototype._on_socket_message = function(event) {
            this._trace("Client._on_socket_message", event.data);
            var messages = this._deframeMessages(event.data);
            for(var i = 0; i < messages.length; i += 1)this._handleMessage(messages[i]);
        };
        ClientImpl.prototype._deframeMessages = function(data) {
            var byteArray = new Uint8Array(data);
            var messages = [];
            if (this.receiveBuffer) {
                var newData = new Uint8Array(this.receiveBuffer.length + byteArray.length);
                newData.set(this.receiveBuffer);
                newData.set(byteArray, this.receiveBuffer.length);
                byteArray = newData;
                delete this.receiveBuffer;
            }
            try {
                var offset = 0;
                while(offset < byteArray.length){
                    var result = decodeMessage(byteArray, offset);
                    var wireMessage = result[0];
                    offset = result[1];
                    if (wireMessage !== null) messages.push(wireMessage);
                    else break;
                }
                if (offset < byteArray.length) this.receiveBuffer = byteArray.subarray(offset);
            } catch (error) {
                var errorStack = error.hasOwnProperty("stack") == "undefined" ? error.stack.toString() : "No Error Stack Available";
                this._disconnected(ERROR.INTERNAL_ERROR.code, format(ERROR.INTERNAL_ERROR, [
                    error.message,
                    errorStack
                ]));
                return;
            }
            return messages;
        };
        ClientImpl.prototype._handleMessage = function(wireMessage) {
            this._trace("Client._handleMessage", wireMessage);
            try {
                switch(wireMessage.type){
                    case MESSAGE_TYPE.CONNACK:
                        this._connectTimeout.cancel();
                        if (this._reconnectTimeout) this._reconnectTimeout.cancel();
                        // If we have started using clean session then clear up the local state.
                        if (this.connectOptions.cleanSession) {
                            for(var key in this._sentMessages){
                                var sentMessage = this._sentMessages[key];
                                localStorage.removeItem("Sent:" + this._localKey + sentMessage.messageIdentifier);
                            }
                            this._sentMessages = {};
                            for(var key in this._receivedMessages){
                                var receivedMessage = this._receivedMessages[key];
                                localStorage.removeItem("Received:" + this._localKey + receivedMessage.messageIdentifier);
                            }
                            this._receivedMessages = {};
                        }
                        // Client connected and ready for business.
                        if (wireMessage.returnCode === 0) {
                            this.connected = true;
                            // Jump to the end of the list of uris and stop looking for a good host.
                            if (this.connectOptions.uris) this.hostIndex = this.connectOptions.uris.length;
                        } else {
                            this._disconnected(ERROR.CONNACK_RETURNCODE.code, format(ERROR.CONNACK_RETURNCODE, [
                                wireMessage.returnCode,
                                CONNACK_RC[wireMessage.returnCode]
                            ]));
                            break;
                        }
                        // Resend messages.
                        var sequencedMessages = [];
                        for(var msgId in this._sentMessages)if (this._sentMessages.hasOwnProperty(msgId)) sequencedMessages.push(this._sentMessages[msgId]);
                        // Also schedule qos 0 buffered messages if any
                        if (this._buffered_msg_queue.length > 0) {
                            var msg = null;
                            while(msg = this._buffered_msg_queue.pop()){
                                sequencedMessages.push(msg);
                                if (this.onMessageDelivered) this._notify_msg_sent[msg] = this.onMessageDelivered(msg.payloadMessage);
                            }
                        }
                        // Sort sentMessages into the original sent order.
                        var sequencedMessages = sequencedMessages.sort(function(a, b) {
                            return a.sequence - b.sequence;
                        });
                        for(var i = 0, len = sequencedMessages.length; i < len; i++){
                            var sentMessage = sequencedMessages[i];
                            if (sentMessage.type == MESSAGE_TYPE.PUBLISH && sentMessage.pubRecReceived) {
                                var pubRelMessage = new WireMessage(MESSAGE_TYPE.PUBREL, {
                                    messageIdentifier: sentMessage.messageIdentifier
                                });
                                this._schedule_message(pubRelMessage);
                            } else this._schedule_message(sentMessage);
                        }
                        // Execute the connectOptions.onSuccess callback if there is one.
                        // Will also now return if this connection was the result of an automatic
                        // reconnect and which URI was successfully connected to.
                        if (this.connectOptions.onSuccess) this.connectOptions.onSuccess({
                            invocationContext: this.connectOptions.invocationContext
                        });
                        var reconnected = false;
                        if (this._reconnecting) {
                            reconnected = true;
                            this._reconnectInterval = 1;
                            this._reconnecting = false;
                        }
                        // Execute the onConnected callback if there is one.
                        this._connected(reconnected, this._wsuri);
                        // Process all queued messages now that the connection is established.
                        this._process_queue();
                        break;
                    case MESSAGE_TYPE.PUBLISH:
                        this._receivePublish(wireMessage);
                        break;
                    case MESSAGE_TYPE.PUBACK:
                        var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
                        // If this is a re flow of a PUBACK after we have restarted receivedMessage will not exist.
                        if (sentMessage) {
                            delete this._sentMessages[wireMessage.messageIdentifier];
                            localStorage.removeItem("Sent:" + this._localKey + wireMessage.messageIdentifier);
                            if (this.onMessageDelivered) this.onMessageDelivered(sentMessage.payloadMessage);
                        }
                        break;
                    case MESSAGE_TYPE.PUBREC:
                        var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
                        // If this is a re flow of a PUBREC after we have restarted receivedMessage will not exist.
                        if (sentMessage) {
                            sentMessage.pubRecReceived = true;
                            var pubRelMessage = new WireMessage(MESSAGE_TYPE.PUBREL, {
                                messageIdentifier: wireMessage.messageIdentifier
                            });
                            this.store("Sent:", sentMessage);
                            this._schedule_message(pubRelMessage);
                        }
                        break;
                    case MESSAGE_TYPE.PUBREL:
                        var receivedMessage = this._receivedMessages[wireMessage.messageIdentifier];
                        localStorage.removeItem("Received:" + this._localKey + wireMessage.messageIdentifier);
                        // If this is a re flow of a PUBREL after we have restarted receivedMessage will not exist.
                        if (receivedMessage) {
                            this._receiveMessage(receivedMessage);
                            delete this._receivedMessages[wireMessage.messageIdentifier];
                        }
                        // Always flow PubComp, we may have previously flowed PubComp but the server lost it and restarted.
                        var pubCompMessage = new WireMessage(MESSAGE_TYPE.PUBCOMP, {
                            messageIdentifier: wireMessage.messageIdentifier
                        });
                        this._schedule_message(pubCompMessage);
                        break;
                    case MESSAGE_TYPE.PUBCOMP:
                        var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
                        delete this._sentMessages[wireMessage.messageIdentifier];
                        localStorage.removeItem("Sent:" + this._localKey + wireMessage.messageIdentifier);
                        if (this.onMessageDelivered) this.onMessageDelivered(sentMessage.payloadMessage);
                        break;
                    case MESSAGE_TYPE.SUBACK:
                        var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
                        if (sentMessage) {
                            if (sentMessage.timeOut) sentMessage.timeOut.cancel();
                            // This will need to be fixed when we add multiple topic support
                            if (wireMessage.returnCode[0] === 0x80) {
                                if (sentMessage.onFailure) sentMessage.onFailure(wireMessage.returnCode);
                            } else if (sentMessage.onSuccess) sentMessage.onSuccess(wireMessage.returnCode);
                            delete this._sentMessages[wireMessage.messageIdentifier];
                        }
                        break;
                    case MESSAGE_TYPE.UNSUBACK:
                        var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
                        if (sentMessage) {
                            if (sentMessage.timeOut) sentMessage.timeOut.cancel();
                            if (sentMessage.callback) sentMessage.callback();
                            delete this._sentMessages[wireMessage.messageIdentifier];
                        }
                        break;
                    case MESSAGE_TYPE.PINGRESP:
                        /* The sendPinger or receivePinger may have sent a ping, the receivePinger has already been reset. */ this.sendPinger.reset();
                        break;
                    case MESSAGE_TYPE.DISCONNECT:
                        // Clients do not expect to receive disconnect packets.
                        this._disconnected(ERROR.INVALID_MQTT_MESSAGE_TYPE.code, format(ERROR.INVALID_MQTT_MESSAGE_TYPE, [
                            wireMessage.type
                        ]));
                        break;
                    default:
                        this._disconnected(ERROR.INVALID_MQTT_MESSAGE_TYPE.code, format(ERROR.INVALID_MQTT_MESSAGE_TYPE, [
                            wireMessage.type
                        ]));
                }
            } catch (error) {
                var errorStack = error.hasOwnProperty("stack") == "undefined" ? error.stack.toString() : "No Error Stack Available";
                this._disconnected(ERROR.INTERNAL_ERROR.code, format(ERROR.INTERNAL_ERROR, [
                    error.message,
                    errorStack
                ]));
                return;
            }
        };
        /** @ignore */ ClientImpl.prototype._on_socket_error = function(error) {
            if (!this._reconnecting) this._disconnected(ERROR.SOCKET_ERROR.code, format(ERROR.SOCKET_ERROR, [
                error.data
            ]));
        };
        /** @ignore */ ClientImpl.prototype._on_socket_close = function() {
            if (!this._reconnecting) this._disconnected(ERROR.SOCKET_CLOSE.code, format(ERROR.SOCKET_CLOSE));
        };
        /** @ignore */ ClientImpl.prototype._socket_send = function(wireMessage) {
            if (wireMessage.type == 1) {
                var wireMessageMasked = this._traceMask(wireMessage, "password");
                this._trace("Client._socket_send", wireMessageMasked);
            } else this._trace("Client._socket_send", wireMessage);
            this.socket.send(wireMessage.encode());
            /* We have proved to the server we are alive. */ this.sendPinger.reset();
        };
        /** @ignore */ ClientImpl.prototype._receivePublish = function(wireMessage) {
            switch(wireMessage.payloadMessage.qos){
                case "undefined":
                case 0:
                    this._receiveMessage(wireMessage);
                    break;
                case 1:
                    var pubAckMessage = new WireMessage(MESSAGE_TYPE.PUBACK, {
                        messageIdentifier: wireMessage.messageIdentifier
                    });
                    this._schedule_message(pubAckMessage);
                    this._receiveMessage(wireMessage);
                    break;
                case 2:
                    this._receivedMessages[wireMessage.messageIdentifier] = wireMessage;
                    this.store("Received:", wireMessage);
                    var pubRecMessage = new WireMessage(MESSAGE_TYPE.PUBREC, {
                        messageIdentifier: wireMessage.messageIdentifier
                    });
                    this._schedule_message(pubRecMessage);
                    break;
                default:
                    throw Error("Invaild qos=" + wireMessage.payloadMessage.qos);
            }
        };
        /** @ignore */ ClientImpl.prototype._receiveMessage = function(wireMessage) {
            if (this.onMessageArrived) this.onMessageArrived(wireMessage.payloadMessage);
        };
        /**
	 * Client has connected.
	 * @param {reconnect} [boolean] indicate if this was a result of reconnect operation.
	 * @param {uri} [string] fully qualified WebSocket URI of the server.
	 */ ClientImpl.prototype._connected = function(reconnect, uri) {
            // Execute the onConnected callback if there is one.
            if (this.onConnected) this.onConnected(reconnect, uri);
        };
        /**
	 * Attempts to reconnect the client to the server.
   * For each reconnect attempt, will double the reconnect interval
   * up to 128 seconds.
	 */ ClientImpl.prototype._reconnect = function() {
            this._trace("Client._reconnect");
            if (!this.connected) {
                this._reconnecting = true;
                this.sendPinger.cancel();
                this.receivePinger.cancel();
                if (this._reconnectInterval < 128) this._reconnectInterval = this._reconnectInterval * 2;
                if (this.connectOptions.uris) {
                    this.hostIndex = 0;
                    this._doConnect(this.connectOptions.uris[0]);
                } else this._doConnect(this.uri);
            }
        };
        /**
	 * Client has disconnected either at its own request or because the server
	 * or network disconnected it. Remove all non-durable state.
	 * @param {errorCode} [number] the error number.
	 * @param {errorText} [string] the error text.
	 * @ignore
	 */ ClientImpl.prototype._disconnected = function(errorCode, errorText) {
            this._trace("Client._disconnected", errorCode, errorText);
            if (errorCode !== undefined && this._reconnecting) {
                //Continue automatic reconnect process
                this._reconnectTimeout = new Timeout(this, this._reconnectInterval, this._reconnect);
                return;
            }
            this.sendPinger.cancel();
            this.receivePinger.cancel();
            if (this._connectTimeout) {
                this._connectTimeout.cancel();
                this._connectTimeout = null;
            }
            // Clear message buffers.
            this._msg_queue = [];
            this._buffered_msg_queue = [];
            this._notify_msg_sent = {};
            if (this.socket) {
                // Cancel all socket callbacks so that they cannot be driven again by this socket.
                this.socket.onopen = null;
                this.socket.onmessage = null;
                this.socket.onerror = null;
                this.socket.onclose = null;
                if (this.socket.readyState === 1) this.socket.close();
                delete this.socket;
            }
            if (this.connectOptions.uris && this.hostIndex < this.connectOptions.uris.length - 1) {
                // Try the next host.
                this.hostIndex++;
                this._doConnect(this.connectOptions.uris[this.hostIndex]);
            } else {
                if (errorCode === undefined) {
                    errorCode = ERROR.OK.code;
                    errorText = format(ERROR.OK);
                }
                // Run any application callbacks last as they may attempt to reconnect and hence create a new socket.
                if (this.connected) {
                    this.connected = false;
                    // Execute the connectionLostCallback if there is one, and we were connected.
                    if (this.onConnectionLost) this.onConnectionLost({
                        errorCode: errorCode,
                        errorMessage: errorText,
                        reconnect: this.connectOptions.reconnect,
                        uri: this._wsuri
                    });
                    if (errorCode !== ERROR.OK.code && this.connectOptions.reconnect) {
                        // Start automatic reconnect process for the very first time since last successful connect.
                        this._reconnectInterval = 1;
                        this._reconnect();
                        return;
                    }
                } else {
                    // Otherwise we never had a connection, so indicate that the connect has failed.
                    if (this.connectOptions.mqttVersion === 4 && this.connectOptions.mqttVersionExplicit === false) {
                        this._trace("Failed to connect V4, dropping back to V3");
                        this.connectOptions.mqttVersion = 3;
                        if (this.connectOptions.uris) {
                            this.hostIndex = 0;
                            this._doConnect(this.connectOptions.uris[0]);
                        } else this._doConnect(this.uri);
                    } else if (this.connectOptions.onFailure) this.connectOptions.onFailure({
                        invocationContext: this.connectOptions.invocationContext,
                        errorCode: errorCode,
                        errorMessage: errorText
                    });
                }
            }
        };
        /** @ignore */ ClientImpl.prototype._trace = function() {
            // Pass trace message back to client's callback function
            if (this.traceFunction) {
                var args = Array.prototype.slice.call(arguments);
                for(var i in args)if (typeof args[i] !== "undefined") args.splice(i, 1, JSON.stringify(args[i]));
                var record = args.join("");
                this.traceFunction({
                    severity: "Debug",
                    message: record
                });
            }
            //buffer style trace
            if (this._traceBuffer !== null) for(var i = 0, max = arguments.length; i < max; i++){
                if (this._traceBuffer.length == this._MAX_TRACE_ENTRIES) this._traceBuffer.shift();
                if (i === 0) this._traceBuffer.push(arguments[i]);
                else if (typeof arguments[i] === "undefined") this._traceBuffer.push(arguments[i]);
                else this._traceBuffer.push("  " + JSON.stringify(arguments[i]));
            }
        };
        /** @ignore */ ClientImpl.prototype._traceMask = function(traceObject, masked) {
            var traceObjectMasked = {};
            for(var attr in traceObject)if (traceObject.hasOwnProperty(attr)) {
                if (attr == masked) traceObjectMasked[attr] = "******";
                else traceObjectMasked[attr] = traceObject[attr];
            }
            return traceObjectMasked;
        };
        // ------------------------------------------------------------------------
        // Public Programming interface.
        // ------------------------------------------------------------------------
        /**
	 * The JavaScript application communicates to the server using a {@link Paho.Client} object.
	 * <p>
	 * Most applications will create just one Client object and then call its connect() method,
	 * however applications can create more than one Client object if they wish.
	 * In this case the combination of host, port and clientId attributes must be different for each Client object.
	 * <p>
	 * The send, subscribe and unsubscribe methods are implemented as asynchronous JavaScript methods
	 * (even though the underlying protocol exchange might be synchronous in nature).
	 * This means they signal their completion by calling back to the application,
	 * via Success or Failure callback functions provided by the application on the method in question.
	 * Such callbacks are called at most once per method invocation and do not persist beyond the lifetime
	 * of the script that made the invocation.
	 * <p>
	 * In contrast there are some callback functions, most notably <i>onMessageArrived</i>,
	 * that are defined on the {@link Paho.Client} object.
	 * These may get called multiple times, and aren't directly related to specific method invocations made by the client.
	 *
	 * @name Paho.Client
	 *
	 * @constructor
	 *
	 * @param {string} host - the address of the messaging server, as a fully qualified WebSocket URI, as a DNS name or dotted decimal IP address.
	 * @param {number} port - the port number to connect to - only required if host is not a URI
	 * @param {string} path - the path on the host to connect to - only used if host is not a URI. Default: '/mqtt'.
	 * @param {string} clientId - the Messaging client identifier, between 1 and 23 characters in length.
	 *
	 * @property {string} host - <i>read only</i> the server's DNS hostname or dotted decimal IP address.
	 * @property {number} port - <i>read only</i> the server's port.
	 * @property {string} path - <i>read only</i> the server's path.
	 * @property {string} clientId - <i>read only</i> used when connecting to the server.
	 * @property {function} onConnectionLost - called when a connection has been lost.
	 *                            after a connect() method has succeeded.
	 *                            Establish the call back used when a connection has been lost. The connection may be
	 *                            lost because the client initiates a disconnect or because the server or network
	 *                            cause the client to be disconnected. The disconnect call back may be called without
	 *                            the connectionComplete call back being invoked if, for example the client fails to
	 *                            connect.
	 *                            A single response object parameter is passed to the onConnectionLost callback containing the following fields:
	 *                            <ol>
	 *                            <li>errorCode
	 *                            <li>errorMessage
	 *                            </ol>
	 * @property {function} onMessageDelivered - called when a message has been delivered.
	 *                            All processing that this Client will ever do has been completed. So, for example,
	 *                            in the case of a Qos=2 message sent by this client, the PubComp flow has been received from the server
	 *                            and the message has been removed from persistent storage before this callback is invoked.
	 *                            Parameters passed to the onMessageDelivered callback are:
	 *                            <ol>
	 *                            <li>{@link Paho.Message} that was delivered.
	 *                            </ol>
	 * @property {function} onMessageArrived - called when a message has arrived in this Paho.client.
	 *                            Parameters passed to the onMessageArrived callback are:
	 *                            <ol>
	 *                            <li>{@link Paho.Message} that has arrived.
	 *                            </ol>
	 * @property {function} onConnected - called when a connection is successfully made to the server.
	 *                                  after a connect() method.
	 *                                  Parameters passed to the onConnected callback are:
	 *                                  <ol>
	 *                                  <li>reconnect (boolean) - If true, the connection was the result of a reconnect.</li>
	 *                                  <li>URI (string) - The URI used to connect to the server.</li>
	 *                                  </ol>
	 * @property {boolean} disconnectedPublishing - if set, will enable disconnected publishing in
	 *                                            in the event that the connection to the server is lost.
	 * @property {number} disconnectedBufferSize - Used to set the maximum number of messages that the disconnected
	 *                                             buffer will hold before rejecting new messages. Default size: 5000 messages
	 * @property {function} trace - called whenever trace is called. TODO
	 */ var Client = function(host, port, path, clientId) {
            var uri;
            if (typeof host !== "string") throw new Error(format(ERROR.INVALID_TYPE, [
                typeof host,
                "host"
            ]));
            if (arguments.length == 2) {
                // host: must be full ws:// uri
                // port: clientId
                clientId = port;
                uri = host;
                var match = uri.match(/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/);
                if (match) {
                    host = match[4] || match[2];
                    port = parseInt(match[7]);
                    path = match[8];
                } else throw new Error(format(ERROR.INVALID_ARGUMENT, [
                    host,
                    "host"
                ]));
            } else {
                if (arguments.length == 3) {
                    clientId = path;
                    path = "/mqtt";
                }
                if (typeof port !== "number" || port < 0) throw new Error(format(ERROR.INVALID_TYPE, [
                    typeof port,
                    "port"
                ]));
                if (typeof path !== "string") throw new Error(format(ERROR.INVALID_TYPE, [
                    typeof path,
                    "path"
                ]));
                var ipv6AddSBracket = host.indexOf(":") !== -1 && host.slice(0, 1) !== "[" && host.slice(-1) !== "]";
                uri = "ws://" + (ipv6AddSBracket ? "[" + host + "]" : host) + ":" + port + path;
            }
            var clientIdLength = 0;
            for(var i = 0; i < clientId.length; i++){
                var charCode = clientId.charCodeAt(i);
                if (0xD800 <= charCode && charCode <= 0xDBFF) i++; // Surrogate pair.
                clientIdLength++;
            }
            if (typeof clientId !== "string" || clientIdLength > 65535) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                clientId,
                "clientId"
            ]));
            var client = new ClientImpl(uri, host, port, path, clientId);
            //Public Properties
            Object.defineProperties(this, {
                "host": {
                    get: function() {
                        return host;
                    },
                    set: function() {
                        throw new Error(format(ERROR.UNSUPPORTED_OPERATION));
                    }
                },
                "port": {
                    get: function() {
                        return port;
                    },
                    set: function() {
                        throw new Error(format(ERROR.UNSUPPORTED_OPERATION));
                    }
                },
                "path": {
                    get: function() {
                        return path;
                    },
                    set: function() {
                        throw new Error(format(ERROR.UNSUPPORTED_OPERATION));
                    }
                },
                "uri": {
                    get: function() {
                        return uri;
                    },
                    set: function() {
                        throw new Error(format(ERROR.UNSUPPORTED_OPERATION));
                    }
                },
                "clientId": {
                    get: function() {
                        return client.clientId;
                    },
                    set: function() {
                        throw new Error(format(ERROR.UNSUPPORTED_OPERATION));
                    }
                },
                "onConnected": {
                    get: function() {
                        return client.onConnected;
                    },
                    set: function(newOnConnected) {
                        if (typeof newOnConnected === "function") client.onConnected = newOnConnected;
                        else throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof newOnConnected,
                            "onConnected"
                        ]));
                    }
                },
                "disconnectedPublishing": {
                    get: function() {
                        return client.disconnectedPublishing;
                    },
                    set: function(newDisconnectedPublishing) {
                        client.disconnectedPublishing = newDisconnectedPublishing;
                    }
                },
                "disconnectedBufferSize": {
                    get: function() {
                        return client.disconnectedBufferSize;
                    },
                    set: function(newDisconnectedBufferSize) {
                        client.disconnectedBufferSize = newDisconnectedBufferSize;
                    }
                },
                "onConnectionLost": {
                    get: function() {
                        return client.onConnectionLost;
                    },
                    set: function(newOnConnectionLost) {
                        if (typeof newOnConnectionLost === "function") client.onConnectionLost = newOnConnectionLost;
                        else throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof newOnConnectionLost,
                            "onConnectionLost"
                        ]));
                    }
                },
                "onMessageDelivered": {
                    get: function() {
                        return client.onMessageDelivered;
                    },
                    set: function(newOnMessageDelivered) {
                        if (typeof newOnMessageDelivered === "function") client.onMessageDelivered = newOnMessageDelivered;
                        else throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof newOnMessageDelivered,
                            "onMessageDelivered"
                        ]));
                    }
                },
                "onMessageArrived": {
                    get: function() {
                        return client.onMessageArrived;
                    },
                    set: function(newOnMessageArrived) {
                        if (typeof newOnMessageArrived === "function") client.onMessageArrived = newOnMessageArrived;
                        else throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof newOnMessageArrived,
                            "onMessageArrived"
                        ]));
                    }
                },
                "trace": {
                    get: function() {
                        return client.traceFunction;
                    },
                    set: function(trace) {
                        if (typeof trace === "function") client.traceFunction = trace;
                        else throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof trace,
                            "onTrace"
                        ]));
                    }
                }
            });
            /**
		 * Connect this Messaging client to its server.
		 *
		 * @name Paho.Client#connect
		 * @function
		 * @param {object} connectOptions - Attributes used with the connection.
		 * @param {number} connectOptions.timeout - If the connect has not succeeded within this
		 *                    number of seconds, it is deemed to have failed.
		 *                    The default is 30 seconds.
		 * @param {string} connectOptions.userName - Authentication username for this connection.
		 * @param {string} connectOptions.password - Authentication password for this connection.
		 * @param {Paho.Message} connectOptions.willMessage - sent by the server when the client
		 *                    disconnects abnormally.
		 * @param {number} connectOptions.keepAliveInterval - the server disconnects this client if
		 *                    there is no activity for this number of seconds.
		 *                    The default value of 60 seconds is assumed if not set.
		 * @param {boolean} connectOptions.cleanSession - if true(default) the client and server
		 *                    persistent state is deleted on successful connect.
		 * @param {boolean} connectOptions.useSSL - if present and true, use an SSL Websocket connection.
		 * @param {object} connectOptions.invocationContext - passed to the onSuccess callback or onFailure callback.
		 * @param {function} connectOptions.onSuccess - called when the connect acknowledgement
		 *                    has been received from the server.
		 * A single response object parameter is passed to the onSuccess callback containing the following fields:
		 * <ol>
		 * <li>invocationContext as passed in to the onSuccess method in the connectOptions.
		 * </ol>
	 * @param {function} connectOptions.onFailure - called when the connect request has failed or timed out.
		 * A single response object parameter is passed to the onFailure callback containing the following fields:
		 * <ol>
		 * <li>invocationContext as passed in to the onFailure method in the connectOptions.
		 * <li>errorCode a number indicating the nature of the error.
		 * <li>errorMessage text describing the error.
		 * </ol>
	 * @param {array} connectOptions.hosts - If present this contains either a set of hostnames or fully qualified
		 * WebSocket URIs (ws://iot.eclipse.org:80/ws), that are tried in order in place
		 * of the host and port paramater on the construtor. The hosts are tried one at at time in order until
		 * one of then succeeds.
	 * @param {array} connectOptions.ports - If present the set of ports matching the hosts. If hosts contains URIs, this property
		 * is not used.
	 * @param {boolean} connectOptions.reconnect - Sets whether the client will automatically attempt to reconnect
	 * to the server if the connection is lost.
	 *<ul>
	 *<li>If set to false, the client will not attempt to automatically reconnect to the server in the event that the
	 * connection is lost.</li>
	 *<li>If set to true, in the event that the connection is lost, the client will attempt to reconnect to the server.
	 * It will initially wait 1 second before it attempts to reconnect, for every failed reconnect attempt, the delay
	 * will double until it is at 2 minutes at which point the delay will stay at 2 minutes.</li>
	 *</ul>
	 * @param {number} connectOptions.mqttVersion - The version of MQTT to use to connect to the MQTT Broker.
	 *<ul>
	 *<li>3 - MQTT V3.1</li>
	 *<li>4 - MQTT V3.1.1</li>
	 *</ul>
	 * @param {boolean} connectOptions.mqttVersionExplicit - If set to true, will force the connection to use the
	 * selected MQTT Version or will fail to connect.
	 * @param {array} connectOptions.uris - If present, should contain a list of fully qualified WebSocket uris
	 * (e.g. ws://iot.eclipse.org:80/ws), that are tried in order in place of the host and port parameter of the construtor.
	 * The uris are tried one at a time in order until one of them succeeds. Do not use this in conjunction with hosts as
	 * the hosts array will be converted to uris and will overwrite this property.
		 * @throws {InvalidState} If the client is not in disconnected state. The client must have received connectionLost
		 * or disconnected before calling connect for a second or subsequent time.
		 */ this.connect = function(connectOptions) {
                connectOptions = connectOptions || {};
                validate(connectOptions, {
                    timeout: "number",
                    userName: "string",
                    password: "string",
                    willMessage: "object",
                    keepAliveInterval: "number",
                    cleanSession: "boolean",
                    useSSL: "boolean",
                    invocationContext: "object",
                    onSuccess: "function",
                    onFailure: "function",
                    hosts: "object",
                    ports: "object",
                    reconnect: "boolean",
                    mqttVersion: "number",
                    mqttVersionExplicit: "boolean",
                    uris: "object"
                });
                // If no keep alive interval is set, assume 60 seconds.
                if (connectOptions.keepAliveInterval === undefined) connectOptions.keepAliveInterval = 60;
                if (connectOptions.mqttVersion > 4 || connectOptions.mqttVersion < 3) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                    connectOptions.mqttVersion,
                    "connectOptions.mqttVersion"
                ]));
                if (connectOptions.mqttVersion === undefined) {
                    connectOptions.mqttVersionExplicit = false;
                    connectOptions.mqttVersion = 4;
                } else connectOptions.mqttVersionExplicit = true;
                //Check that if password is set, so is username
                if (connectOptions.password !== undefined && connectOptions.userName === undefined) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                    connectOptions.password,
                    "connectOptions.password"
                ]));
                if (connectOptions.willMessage) {
                    if (!(connectOptions.willMessage instanceof Message)) throw new Error(format(ERROR.INVALID_TYPE, [
                        connectOptions.willMessage,
                        "connectOptions.willMessage"
                    ]));
                    // The will message must have a payload that can be represented as a string.
                    // Cause the willMessage to throw an exception if this is not the case.
                    connectOptions.willMessage.stringPayload = null;
                    if (typeof connectOptions.willMessage.destinationName === "undefined") throw new Error(format(ERROR.INVALID_TYPE, [
                        typeof connectOptions.willMessage.destinationName,
                        "connectOptions.willMessage.destinationName"
                    ]));
                }
                if (typeof connectOptions.cleanSession === "undefined") connectOptions.cleanSession = true;
                if (connectOptions.hosts) {
                    if (!(connectOptions.hosts instanceof Array)) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                        connectOptions.hosts,
                        "connectOptions.hosts"
                    ]));
                    if (connectOptions.hosts.length < 1) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                        connectOptions.hosts,
                        "connectOptions.hosts"
                    ]));
                    var usingURIs = false;
                    for(var i = 0; i < connectOptions.hosts.length; i++){
                        if (typeof connectOptions.hosts[i] !== "string") throw new Error(format(ERROR.INVALID_TYPE, [
                            typeof connectOptions.hosts[i],
                            "connectOptions.hosts[" + i + "]"
                        ]));
                        if (/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/.test(connectOptions.hosts[i])) {
                            if (i === 0) usingURIs = true;
                            else if (!usingURIs) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                                connectOptions.hosts[i],
                                "connectOptions.hosts[" + i + "]"
                            ]));
                        } else if (usingURIs) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            connectOptions.hosts[i],
                            "connectOptions.hosts[" + i + "]"
                        ]));
                    }
                    if (!usingURIs) {
                        if (!connectOptions.ports) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            connectOptions.ports,
                            "connectOptions.ports"
                        ]));
                        if (!(connectOptions.ports instanceof Array)) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            connectOptions.ports,
                            "connectOptions.ports"
                        ]));
                        if (connectOptions.hosts.length !== connectOptions.ports.length) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            connectOptions.ports,
                            "connectOptions.ports"
                        ]));
                        connectOptions.uris = [];
                        for(var i = 0; i < connectOptions.hosts.length; i++){
                            if (typeof connectOptions.ports[i] !== "number" || connectOptions.ports[i] < 0) throw new Error(format(ERROR.INVALID_TYPE, [
                                typeof connectOptions.ports[i],
                                "connectOptions.ports[" + i + "]"
                            ]));
                            var host = connectOptions.hosts[i];
                            var port = connectOptions.ports[i];
                            var ipv6 = host.indexOf(":") !== -1;
                            uri = "ws://" + (ipv6 ? "[" + host + "]" : host) + ":" + port + path;
                            connectOptions.uris.push(uri);
                        }
                    } else connectOptions.uris = connectOptions.hosts;
                }
                client.connect(connectOptions);
            };
            /**
		 * Subscribe for messages, request receipt of a copy of messages sent to the destinations described by the filter.
		 *
		 * @name Paho.Client#subscribe
		 * @function
		 * @param {string} filter describing the destinations to receive messages from.
		 * <br>
		 * @param {object} subscribeOptions - used to control the subscription
		 *
		 * @param {number} subscribeOptions.qos - the maximum qos of any publications sent
		 *                                  as a result of making this subscription.
		 * @param {object} subscribeOptions.invocationContext - passed to the onSuccess callback
		 *                                  or onFailure callback.
		 * @param {function} subscribeOptions.onSuccess - called when the subscribe acknowledgement
		 *                                  has been received from the server.
		 *                                  A single response object parameter is passed to the onSuccess callback containing the following fields:
		 *                                  <ol>
		 *                                  <li>invocationContext if set in the subscribeOptions.
		 *                                  </ol>
		 * @param {function} subscribeOptions.onFailure - called when the subscribe request has failed or timed out.
		 *                                  A single response object parameter is passed to the onFailure callback containing the following fields:
		 *                                  <ol>
		 *                                  <li>invocationContext - if set in the subscribeOptions.
		 *                                  <li>errorCode - a number indicating the nature of the error.
		 *                                  <li>errorMessage - text describing the error.
		 *                                  </ol>
		 * @param {number} subscribeOptions.timeout - which, if present, determines the number of
		 *                                  seconds after which the onFailure calback is called.
		 *                                  The presence of a timeout does not prevent the onSuccess
		 *                                  callback from being called when the subscribe completes.
		 * @throws {InvalidState} if the client is not in connected state.
		 */ this.subscribe = function(filter, subscribeOptions) {
                if (typeof filter !== "string" && filter.constructor !== Array) throw new Error("Invalid argument:" + filter);
                subscribeOptions = subscribeOptions || {};
                validate(subscribeOptions, {
                    qos: "number",
                    invocationContext: "object",
                    onSuccess: "function",
                    onFailure: "function",
                    timeout: "number"
                });
                if (subscribeOptions.timeout && !subscribeOptions.onFailure) throw new Error("subscribeOptions.timeout specified with no onFailure callback.");
                if (typeof subscribeOptions.qos !== "undefined" && !(subscribeOptions.qos === 0 || subscribeOptions.qos === 1 || subscribeOptions.qos === 2)) throw new Error(format(ERROR.INVALID_ARGUMENT, [
                    subscribeOptions.qos,
                    "subscribeOptions.qos"
                ]));
                client.subscribe(filter, subscribeOptions);
            };
            /**
		 * Unsubscribe for messages, stop receiving messages sent to destinations described by the filter.
		 *
		 * @name Paho.Client#unsubscribe
		 * @function
		 * @param {string} filter - describing the destinations to receive messages from.
		 * @param {object} unsubscribeOptions - used to control the subscription
		 * @param {object} unsubscribeOptions.invocationContext - passed to the onSuccess callback
											  or onFailure callback.
		 * @param {function} unsubscribeOptions.onSuccess - called when the unsubscribe acknowledgement has been received from the server.
		 *                                    A single response object parameter is passed to the
		 *                                    onSuccess callback containing the following fields:
		 *                                    <ol>
		 *                                    <li>invocationContext - if set in the unsubscribeOptions.
		 *                                    </ol>
		 * @param {function} unsubscribeOptions.onFailure called when the unsubscribe request has failed or timed out.
		 *                                    A single response object parameter is passed to the onFailure callback containing the following fields:
		 *                                    <ol>
		 *                                    <li>invocationContext - if set in the unsubscribeOptions.
		 *                                    <li>errorCode - a number indicating the nature of the error.
		 *                                    <li>errorMessage - text describing the error.
		 *                                    </ol>
		 * @param {number} unsubscribeOptions.timeout - which, if present, determines the number of seconds
		 *                                    after which the onFailure callback is called. The presence of
		 *                                    a timeout does not prevent the onSuccess callback from being
		 *                                    called when the unsubscribe completes
		 * @throws {InvalidState} if the client is not in connected state.
		 */ this.unsubscribe = function(filter, unsubscribeOptions) {
                if (typeof filter !== "string" && filter.constructor !== Array) throw new Error("Invalid argument:" + filter);
                unsubscribeOptions = unsubscribeOptions || {};
                validate(unsubscribeOptions, {
                    invocationContext: "object",
                    onSuccess: "function",
                    onFailure: "function",
                    timeout: "number"
                });
                if (unsubscribeOptions.timeout && !unsubscribeOptions.onFailure) throw new Error("unsubscribeOptions.timeout specified with no onFailure callback.");
                client.unsubscribe(filter, unsubscribeOptions);
            };
            /**
		 * Send a message to the consumers of the destination in the Message.
		 *
		 * @name Paho.Client#send
		 * @function
		 * @param {string|Paho.Message} topic - <b>mandatory</b> The name of the destination to which the message is to be sent.
		 * 					   - If it is the only parameter, used as Paho.Message object.
		 * @param {String|ArrayBuffer} payload - The message data to be sent.
		 * @param {number} qos The Quality of Service used to deliver the message.
		 * 		<dl>
		 * 			<dt>0 Best effort (default).
		 *     			<dt>1 At least once.
		 *     			<dt>2 Exactly once.
		 * 		</dl>
		 * @param {Boolean} retained If true, the message is to be retained by the server and delivered
		 *                     to both current and future subscriptions.
		 *                     If false the server only delivers the message to current subscribers, this is the default for new Messages.
		 *                     A received message has the retained boolean set to true if the message was published
		 *                     with the retained boolean set to true
		 *                     and the subscrption was made after the message has been published.
		 * @throws {InvalidState} if the client is not connected.
		 */ this.send = function(topic, payload, qos, retained) {
                var message;
                if (arguments.length === 0) throw new Error("Invalid argument.length");
                else if (arguments.length == 1) {
                    if (!(topic instanceof Message) && typeof topic !== "string") throw new Error("Invalid argument:" + typeof topic);
                    message = topic;
                    if (typeof message.destinationName === "undefined") throw new Error(format(ERROR.INVALID_ARGUMENT, [
                        message.destinationName,
                        "Message.destinationName"
                    ]));
                    client.send(message);
                } else {
                    //parameter checking in Message object
                    message = new Message(payload);
                    message.destinationName = topic;
                    if (arguments.length >= 3) message.qos = qos;
                    if (arguments.length >= 4) message.retained = retained;
                    client.send(message);
                }
            };
            /**
		 * Publish a message to the consumers of the destination in the Message.
		 * Synonym for Paho.Mqtt.Client#send
		 *
		 * @name Paho.Client#publish
		 * @function
		 * @param {string|Paho.Message} topic - <b>mandatory</b> The name of the topic to which the message is to be published.
		 * 					   - If it is the only parameter, used as Paho.Message object.
		 * @param {String|ArrayBuffer} payload - The message data to be published.
		 * @param {number} qos The Quality of Service used to deliver the message.
		 * 		<dl>
		 * 			<dt>0 Best effort (default).
		 *     			<dt>1 At least once.
		 *     			<dt>2 Exactly once.
		 * 		</dl>
		 * @param {Boolean} retained If true, the message is to be retained by the server and delivered
		 *                     to both current and future subscriptions.
		 *                     If false the server only delivers the message to current subscribers, this is the default for new Messages.
		 *                     A received message has the retained boolean set to true if the message was published
		 *                     with the retained boolean set to true
		 *                     and the subscrption was made after the message has been published.
		 * @throws {InvalidState} if the client is not connected.
		 */ this.publish = function(topic, payload, qos, retained) {
                var message;
                if (arguments.length === 0) throw new Error("Invalid argument.length");
                else if (arguments.length == 1) {
                    if (!(topic instanceof Message) && typeof topic !== "string") throw new Error("Invalid argument:" + typeof topic);
                    message = topic;
                    if (typeof message.destinationName === "undefined") throw new Error(format(ERROR.INVALID_ARGUMENT, [
                        message.destinationName,
                        "Message.destinationName"
                    ]));
                    client.send(message);
                } else {
                    //parameter checking in Message object
                    message = new Message(payload);
                    message.destinationName = topic;
                    if (arguments.length >= 3) message.qos = qos;
                    if (arguments.length >= 4) message.retained = retained;
                    client.send(message);
                }
            };
            /**
		 * Normal disconnect of this Messaging client from its server.
		 *
		 * @name Paho.Client#disconnect
		 * @function
		 * @throws {InvalidState} if the client is already disconnected.
		 */ this.disconnect = function() {
                client.disconnect();
            };
            /**
		 * Get the contents of the trace log.
		 *
		 * @name Paho.Client#getTraceLog
		 * @function
		 * @return {Object[]} tracebuffer containing the time ordered trace records.
		 */ this.getTraceLog = function() {
                return client.getTraceLog();
            };
            /**
		 * Start tracing.
		 *
		 * @name Paho.Client#startTrace
		 * @function
		 */ this.startTrace = function() {
                client.startTrace();
            };
            /**
		 * Stop tracing.
		 *
		 * @name Paho.Client#stopTrace
		 * @function
		 */ this.stopTrace = function() {
                client.stopTrace();
            };
            this.isConnected = function() {
                return client.connected;
            };
        };
        /**
	 * An application message, sent or received.
	 * <p>
	 * All attributes may be null, which implies the default values.
	 *
	 * @name Paho.Message
	 * @constructor
	 * @param {String|ArrayBuffer} payload The message data to be sent.
	 * <p>
	 * @property {string} payloadString <i>read only</i> The payload as a string if the payload consists of valid UTF-8 characters.
	 * @property {ArrayBuffer} payloadBytes <i>read only</i> The payload as an ArrayBuffer.
	 * <p>
	 * @property {string} destinationName <b>mandatory</b> The name of the destination to which the message is to be sent
	 *                    (for messages about to be sent) or the name of the destination from which the message has been received.
	 *                    (for messages received by the onMessage function).
	 * <p>
	 * @property {number} qos The Quality of Service used to deliver the message.
	 * <dl>
	 *     <dt>0 Best effort (default).
	 *     <dt>1 At least once.
	 *     <dt>2 Exactly once.
	 * </dl>
	 * <p>
	 * @property {Boolean} retained If true, the message is to be retained by the server and delivered
	 *                     to both current and future subscriptions.
	 *                     If false the server only delivers the message to current subscribers, this is the default for new Messages.
	 *                     A received message has the retained boolean set to true if the message was published
	 *                     with the retained boolean set to true
	 *                     and the subscrption was made after the message has been published.
	 * <p>
	 * @property {Boolean} duplicate <i>read only</i> If true, this message might be a duplicate of one which has already been received.
	 *                     This is only set on messages received from the server.
	 *
	 */ var Message = function(newPayload) {
            var payload;
            if (typeof newPayload === "string" || newPayload instanceof ArrayBuffer || ArrayBuffer.isView(newPayload) && !(newPayload instanceof DataView)) payload = newPayload;
            else throw format(ERROR.INVALID_ARGUMENT, [
                newPayload,
                "newPayload"
            ]);
            var destinationName;
            var qos = 0;
            var retained = false;
            var duplicate = false;
            Object.defineProperties(this, {
                "payloadString": {
                    enumerable: true,
                    get: function() {
                        if (typeof payload === "string") return payload;
                        else return parseUTF8(payload, 0, payload.length);
                    }
                },
                "payloadBytes": {
                    enumerable: true,
                    get: function() {
                        if (typeof payload === "string") {
                            var buffer = new ArrayBuffer(UTF8Length(payload));
                            var byteStream = new Uint8Array(buffer);
                            stringToUTF8(payload, byteStream, 0);
                            return byteStream;
                        } else return payload;
                    }
                },
                "destinationName": {
                    enumerable: true,
                    get: function() {
                        return destinationName;
                    },
                    set: function(newDestinationName) {
                        if (typeof newDestinationName === "string") destinationName = newDestinationName;
                        else throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            newDestinationName,
                            "newDestinationName"
                        ]));
                    }
                },
                "qos": {
                    enumerable: true,
                    get: function() {
                        return qos;
                    },
                    set: function(newQos) {
                        if (newQos === 0 || newQos === 1 || newQos === 2) qos = newQos;
                        else throw new Error("Invalid argument:" + newQos);
                    }
                },
                "retained": {
                    enumerable: true,
                    get: function() {
                        return retained;
                    },
                    set: function(newRetained) {
                        if (typeof newRetained === "boolean") retained = newRetained;
                        else throw new Error(format(ERROR.INVALID_ARGUMENT, [
                            newRetained,
                            "newRetained"
                        ]));
                    }
                },
                "topic": {
                    enumerable: true,
                    get: function() {
                        return destinationName;
                    },
                    set: function(newTopic) {
                        destinationName = newTopic;
                    }
                },
                "duplicate": {
                    enumerable: true,
                    get: function() {
                        return duplicate;
                    },
                    set: function(newDuplicate) {
                        duplicate = newDuplicate;
                    }
                }
            });
        };
        // Module contents.
        return {
            Client: Client,
            Message: Message
        };
    // eslint-disable-next-line no-nested-ternary
    }(typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
    return PahoMQTT;
});

});



parcelRequire.register("8CzEt", function(module, exports) {

$parcel$export(module.exports, "AWSAppSyncRealTimeProvider", function () { return $646d870c7f39b777$export$b7b5e6371992068d; });

var $gbejU = parcelRequire("gbejU");

var $31fsw = parcelRequire("31fsw");

var $i3eDV = parcelRequire("i3eDV");

var $32hwF = parcelRequire("32hwF");

var $5oOz5 = parcelRequire("5oOz5");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $iZUWK = parcelRequire("iZUWK");
var $2SWCi = parcelRequire("2SWCi");
var $2hWDt = parcelRequire("2hWDt");
var $9opJY = parcelRequire("9opJY");
var $aCVDw = parcelRequire("aCVDw");
var $kP2rz = parcelRequire("kP2rz");

var $9x214 = parcelRequire("9x214");

var $hbz3E = parcelRequire("hbz3E");

var $aXKIu = parcelRequire("aXKIu");

var $72iLF = parcelRequire("72iLF");
var $646d870c7f39b777$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $646d870c7f39b777$var$__assign = undefined && undefined.__assign || function() {
    $646d870c7f39b777$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $646d870c7f39b777$var$__assign.apply(this, arguments);
};
var $646d870c7f39b777$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $646d870c7f39b777$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $646d870c7f39b777$var$logger = new (0, $gBqCF.ConsoleLogger)("AWSAppSyncRealTimeProvider");
var $646d870c7f39b777$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var $646d870c7f39b777$var$dispatchApiEvent = function(event, data, message) {
    (0, $iZUWK.default).dispatch("api", {
        event: event,
        data: data,
        message: message
    }, "PubSub", $646d870c7f39b777$var$AMPLIFY_SYMBOL);
};
var $646d870c7f39b777$var$MAX_DELAY_MS = 5000;
var $646d870c7f39b777$var$NON_RETRYABLE_CODES = [
    400,
    401,
    403
];
var $646d870c7f39b777$var$MESSAGE_TYPES;
(function(MESSAGE_TYPES) {
    /**
     * Client -> Server message.
     * This message type is the first message after handshake and this will initialize AWS AppSync RealTime communication
     */ MESSAGE_TYPES["GQL_CONNECTION_INIT"] = "connection_init";
    /**
     * Server -> Client message
     * This message type is in case there is an issue with AWS AppSync RealTime when establishing connection
     */ MESSAGE_TYPES["GQL_CONNECTION_ERROR"] = "connection_error";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_CONNECTION_INIT message
     */ MESSAGE_TYPES["GQL_CONNECTION_ACK"] = "connection_ack";
    /**
     * Client -> Server message.
     * This message type is for register subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_START"] = "start";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_START message
     */ MESSAGE_TYPES["GQL_START_ACK"] = "start_ack";
    /**
     * Server -> Client message.
     * This message type is for subscription message from AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_DATA"] = "data";
    /**
     * Server -> Client message.
     * This message type helps the client to know is still receiving messages from AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_CONNECTION_KEEP_ALIVE"] = "ka";
    /**
     * Client -> Server message.
     * This message type is for unregister subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_STOP"] = "stop";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_STOP message
     */ MESSAGE_TYPES["GQL_COMPLETE"] = "complete";
    /**
     * Server -> Client message.
     * This message type is for sending error messages from AWS AppSync RealTime to the client
     */ MESSAGE_TYPES["GQL_ERROR"] = "error";
})($646d870c7f39b777$var$MESSAGE_TYPES || ($646d870c7f39b777$var$MESSAGE_TYPES = {}));
var $646d870c7f39b777$var$SUBSCRIPTION_STATUS;
(function(SUBSCRIPTION_STATUS) {
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["PENDING"] = 0] = "PENDING";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["CONNECTED"] = 1] = "CONNECTED";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["FAILED"] = 2] = "FAILED";
})($646d870c7f39b777$var$SUBSCRIPTION_STATUS || ($646d870c7f39b777$var$SUBSCRIPTION_STATUS = {}));
var $646d870c7f39b777$var$SOCKET_STATUS;
(function(SOCKET_STATUS) {
    SOCKET_STATUS[SOCKET_STATUS["CLOSED"] = 0] = "CLOSED";
    SOCKET_STATUS[SOCKET_STATUS["READY"] = 1] = "READY";
    SOCKET_STATUS[SOCKET_STATUS["CONNECTING"] = 2] = "CONNECTING";
})($646d870c7f39b777$var$SOCKET_STATUS || ($646d870c7f39b777$var$SOCKET_STATUS = {}));
var $646d870c7f39b777$var$AWS_APPSYNC_REALTIME_HEADERS = {
    accept: "application/json, text/javascript",
    "content-encoding": "amz-1.0",
    "content-type": "application/json; charset=UTF-8"
};
/**
 * Time in milleseconds to wait for GQL_CONNECTION_INIT message
 */ var $646d870c7f39b777$var$CONNECTION_INIT_TIMEOUT = 15000;
/**
 * Time in milleseconds to wait for GQL_START_ACK message
 */ var $646d870c7f39b777$var$START_ACK_TIMEOUT = 15000;
/**
 * Default Time in milleseconds to wait for GQL_CONNECTION_KEEP_ALIVE message
 */ var $646d870c7f39b777$var$DEFAULT_KEEP_ALIVE_TIMEOUT = 300000;
var $646d870c7f39b777$export$b7b5e6371992068d = /** @class */ function(_super) {
    $646d870c7f39b777$var$__extends(AWSAppSyncRealTimeProvider, _super);
    function AWSAppSyncRealTimeProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.socketStatus = $646d870c7f39b777$var$SOCKET_STATUS.CLOSED;
        _this.keepAliveTimeout = $646d870c7f39b777$var$DEFAULT_KEEP_ALIVE_TIMEOUT;
        _this.subscriptionObserverMap = new Map();
        _this.promiseArray = [];
        return _this;
    }
    AWSAppSyncRealTimeProvider.prototype.getProviderName = function() {
        return "AWSAppSyncRealTimeProvider";
    };
    AWSAppSyncRealTimeProvider.prototype.newClient = function() {
        throw new Error("Not used here");
    };
    AWSAppSyncRealTimeProvider.prototype.publish = function(_topics, _msg, _options) {
        return $646d870c7f39b777$var$__awaiter(this, void 0, void 0, function() {
            return $646d870c7f39b777$var$__generator(this, function(_a) {
                throw new Error("Operation not supported");
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype.subscribe = function(_topics, options) {
        var _this = this;
        var appSyncGraphqlEndpoint = options.appSyncGraphqlEndpoint;
        return new $gbejU(function(observer) {
            if (!appSyncGraphqlEndpoint) {
                observer.error({
                    errors: [
                        $646d870c7f39b777$var$__assign({}, new (0, $31fsw.GraphQLError)("Subscribe only available for AWS AppSync endpoint"))
                    ]
                });
                observer.complete();
            } else {
                var subscriptionId_1 = (0, $32hwF.v4)();
                _this._startSubscriptionWithAWSAppSyncRealTime({
                    options: options,
                    observer: observer,
                    subscriptionId: subscriptionId_1
                });
                return function() {
                    return $646d870c7f39b777$var$__awaiter(_this, void 0, void 0, function() {
                        var subscriptionState, err_1;
                        return $646d870c7f39b777$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    _a.trys.push([
                                        0,
                                        2,
                                        3,
                                        4
                                    ]);
                                    // Waiting that subscription has been connected before trying to unsubscribe
                                    return [
                                        4 /*yield*/ ,
                                        this._waitForSubscriptionToBeConnected(subscriptionId_1)
                                    ];
                                case 1:
                                    // Waiting that subscription has been connected before trying to unsubscribe
                                    _a.sent();
                                    subscriptionState = (this.subscriptionObserverMap.get(subscriptionId_1) || {}).subscriptionState;
                                    if (!subscriptionState) // subscription already unsubscribed
                                    return [
                                        2 /*return*/ 
                                    ];
                                    if (subscriptionState === $646d870c7f39b777$var$SUBSCRIPTION_STATUS.CONNECTED) this._sendUnsubscriptionMessage(subscriptionId_1);
                                    else throw new Error("Subscription never connected");
                                    return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                case 2:
                                    err_1 = _a.sent();
                                    $646d870c7f39b777$var$logger.debug("Error while unsubscribing " + err_1);
                                    return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                case 3:
                                    this._removeSubscriptionObserver(subscriptionId_1);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 4:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
            }
        });
    };
    AWSAppSyncRealTimeProvider.prototype._startSubscriptionWithAWSAppSyncRealTime = function(_a) {
        var options = _a.options, observer = _a.observer, subscriptionId = _a.subscriptionId;
        return $646d870c7f39b777$var$__awaiter(this, void 0, void 0, function() {
            var appSyncGraphqlEndpoint, authenticationType, query, variables, apiKey, region, _b, graphql_headers, subscriptionState, data, dataString, headerObj, _c, _d, subscriptionMessage, stringToAWSRealTime, err_2, _e, message, subscriptionFailedCallback_1, _f, subscriptionFailedCallback, subscriptionReadyCallback;
            var _g;
            var _this = this;
            return $646d870c7f39b777$var$__generator(this, function(_h) {
                switch(_h.label){
                    case 0:
                        appSyncGraphqlEndpoint = options.appSyncGraphqlEndpoint, authenticationType = options.authenticationType, query = options.query, variables = options.variables, apiKey = options.apiKey, region = options.region, _b = options.graphql_headers, graphql_headers = _b === void 0 ? function() {
                            return {};
                        } : _b;
                        subscriptionState = $646d870c7f39b777$var$SUBSCRIPTION_STATUS.PENDING;
                        data = {
                            query: query,
                            variables: variables
                        };
                        // Having a subscription id map will make it simple to forward messages received
                        this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            query: query,
                            variables: variables,
                            subscriptionState: subscriptionState,
                            startAckTimeoutId: null
                        });
                        dataString = JSON.stringify(data);
                        _c = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._awsRealTimeHeaderBasedAuth({
                                apiKey: apiKey,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                authenticationType: authenticationType,
                                payload: dataString,
                                canonicalUri: "",
                                region: region
                            })
                        ];
                    case 1:
                        _d = [
                            $646d870c7f39b777$var$__assign.apply(void 0, _c.concat([
                                _h.sent()
                            ]))
                        ];
                        return [
                            4 /*yield*/ ,
                            graphql_headers()
                        ];
                    case 2:
                        headerObj = $646d870c7f39b777$var$__assign.apply(void 0, [
                            $646d870c7f39b777$var$__assign.apply(void 0, _d.concat([
                                _h.sent()
                            ])),
                            (_g = {}, _g[0, $2SWCi.USER_AGENT_HEADER] = (0, $2hWDt.Constants).userAgent, _g)
                        ]);
                        subscriptionMessage = {
                            id: subscriptionId,
                            payload: {
                                data: dataString,
                                extensions: {
                                    authorization: $646d870c7f39b777$var$__assign({}, headerObj)
                                }
                            },
                            type: $646d870c7f39b777$var$MESSAGE_TYPES.GQL_START
                        };
                        stringToAWSRealTime = JSON.stringify(subscriptionMessage);
                        _h.label = 3;
                    case 3:
                        _h.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._initializeWebSocketConnection({
                                apiKey: apiKey,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                authenticationType: authenticationType,
                                region: region
                            })
                        ];
                    case 4:
                        _h.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        err_2 = _h.sent();
                        $646d870c7f39b777$var$logger.debug({
                            err: err_2
                        });
                        _e = err_2.message, message = _e === void 0 ? "" : _e;
                        observer.error({
                            errors: [
                                $646d870c7f39b777$var$__assign({}, new (0, $31fsw.GraphQLError)("Connection failed: " + message))
                            ]
                        });
                        observer.complete();
                        subscriptionFailedCallback_1 = (this.subscriptionObserverMap.get(subscriptionId) || {}).subscriptionFailedCallback;
                        // Notify concurrent unsubscription
                        if (typeof subscriptionFailedCallback_1 === "function") subscriptionFailedCallback_1();
                        return [
                            2 /*return*/ 
                        ];
                    case 6:
                        _f = this.subscriptionObserverMap.get(subscriptionId), subscriptionFailedCallback = _f.subscriptionFailedCallback, subscriptionReadyCallback = _f.subscriptionReadyCallback;
                        // This must be done before sending the message in order to be listening immediately
                        this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            subscriptionState: subscriptionState,
                            variables: variables,
                            query: query,
                            subscriptionReadyCallback: subscriptionReadyCallback,
                            subscriptionFailedCallback: subscriptionFailedCallback,
                            startAckTimeoutId: setTimeout(function() {
                                _this._timeoutStartSubscriptionAck.call(_this, subscriptionId);
                            }, $646d870c7f39b777$var$START_ACK_TIMEOUT)
                        });
                        this.awsRealTimeSocket.send(stringToAWSRealTime);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Waiting that subscription has been connected before trying to unsubscribe
    AWSAppSyncRealTimeProvider.prototype._waitForSubscriptionToBeConnected = function(subscriptionId) {
        return $646d870c7f39b777$var$__awaiter(this, void 0, void 0, function() {
            var subscriptionState;
            var _this = this;
            return $646d870c7f39b777$var$__generator(this, function(_a) {
                subscriptionState = this.subscriptionObserverMap.get(subscriptionId).subscriptionState;
                // This in case unsubscribe is invoked before sending start subscription message
                if (subscriptionState === $646d870c7f39b777$var$SUBSCRIPTION_STATUS.PENDING) return [
                    2 /*return*/ ,
                    new Promise(function(res, rej) {
                        var _a = _this.subscriptionObserverMap.get(subscriptionId), observer = _a.observer, subscriptionState = _a.subscriptionState, variables = _a.variables, query = _a.query;
                        _this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            subscriptionState: subscriptionState,
                            variables: variables,
                            query: query,
                            subscriptionReadyCallback: res,
                            subscriptionFailedCallback: rej
                        });
                    })
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._sendUnsubscriptionMessage = function(subscriptionId) {
        try {
            if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN && this.socketStatus === $646d870c7f39b777$var$SOCKET_STATUS.READY) {
                // Preparing unsubscribe message to stop receiving messages for that subscription
                var unsubscribeMessage = {
                    id: subscriptionId,
                    type: $646d870c7f39b777$var$MESSAGE_TYPES.GQL_STOP
                };
                var stringToAWSRealTime = JSON.stringify(unsubscribeMessage);
                this.awsRealTimeSocket.send(stringToAWSRealTime);
            }
        } catch (err) {
            // If GQL_STOP is not sent because of disconnection issue, then there is nothing the client can do
            $646d870c7f39b777$var$logger.debug({
                err: err
            });
        }
    };
    AWSAppSyncRealTimeProvider.prototype._removeSubscriptionObserver = function(subscriptionId) {
        this.subscriptionObserverMap.delete(subscriptionId);
        // Verifying 1000ms after removing subscription in case there are new subscription unmount/mount
        setTimeout(this._closeSocketIfRequired.bind(this), 1000);
    };
    AWSAppSyncRealTimeProvider.prototype._closeSocketIfRequired = function() {
        if (this.subscriptionObserverMap.size > 0) // Active subscriptions on the WebSocket
        return;
        if (!this.awsRealTimeSocket) {
            this.socketStatus = $646d870c7f39b777$var$SOCKET_STATUS.CLOSED;
            return;
        }
        if (this.awsRealTimeSocket.bufferedAmount > 0) // Still data on the WebSocket
        setTimeout(this._closeSocketIfRequired.bind(this), 1000);
        else {
            $646d870c7f39b777$var$logger.debug("closing WebSocket...");
            clearTimeout(this.keepAliveTimeoutId);
            var tempSocket = this.awsRealTimeSocket;
            // Cleaning callbacks to avoid race condition, socket still exists
            tempSocket.onclose = undefined;
            tempSocket.onerror = undefined;
            tempSocket.close(1000);
            this.awsRealTimeSocket = null;
            this.socketStatus = $646d870c7f39b777$var$SOCKET_STATUS.CLOSED;
        }
    };
    AWSAppSyncRealTimeProvider.prototype._handleIncomingSubscriptionMessage = function(message) {
        $646d870c7f39b777$var$logger.debug("subscription message from AWS AppSync RealTime: " + message.data);
        var _a = JSON.parse(message.data), _b = _a.id, id = _b === void 0 ? "" : _b, payload = _a.payload, type = _a.type;
        var _c = this.subscriptionObserverMap.get(id) || {}, _d = _c.observer, observer = _d === void 0 ? null : _d, _e = _c.query, query = _e === void 0 ? "" : _e, _f = _c.variables, variables = _f === void 0 ? {} : _f, startAckTimeoutId = _c.startAckTimeoutId, subscriptionReadyCallback = _c.subscriptionReadyCallback, subscriptionFailedCallback = _c.subscriptionFailedCallback;
        $646d870c7f39b777$var$logger.debug({
            id: id,
            observer: observer,
            query: query,
            variables: variables
        });
        if (type === $646d870c7f39b777$var$MESSAGE_TYPES.GQL_DATA && payload && payload.data) {
            if (observer) observer.next(payload);
            else $646d870c7f39b777$var$logger.debug("observer not found for id: " + id);
            return;
        }
        if (type === $646d870c7f39b777$var$MESSAGE_TYPES.GQL_START_ACK) {
            $646d870c7f39b777$var$logger.debug("subscription ready for " + JSON.stringify({
                query: query,
                variables: variables
            }));
            if (typeof subscriptionReadyCallback === "function") subscriptionReadyCallback();
            clearTimeout(startAckTimeoutId);
            $646d870c7f39b777$var$dispatchApiEvent("connected", {
                query: query,
                variables: variables
            }, "Connection established for subscription");
            var subscriptionState = $646d870c7f39b777$var$SUBSCRIPTION_STATUS.CONNECTED;
            this.subscriptionObserverMap.set(id, {
                observer: observer,
                query: query,
                variables: variables,
                startAckTimeoutId: null,
                subscriptionState: subscriptionState,
                subscriptionReadyCallback: subscriptionReadyCallback,
                subscriptionFailedCallback: subscriptionFailedCallback
            });
            // TODO: emit event on hub but it requires to store the id first
            return;
        }
        if (type === $646d870c7f39b777$var$MESSAGE_TYPES.GQL_CONNECTION_KEEP_ALIVE) {
            clearTimeout(this.keepAliveTimeoutId);
            this.keepAliveTimeoutId = setTimeout(this._errorDisconnect.bind(this, (0, $72iLF.CONTROL_MSG).TIMEOUT_DISCONNECT), this.keepAliveTimeout);
            return;
        }
        if (type === $646d870c7f39b777$var$MESSAGE_TYPES.GQL_ERROR) {
            var subscriptionState = $646d870c7f39b777$var$SUBSCRIPTION_STATUS.FAILED;
            this.subscriptionObserverMap.set(id, {
                observer: observer,
                query: query,
                variables: variables,
                startAckTimeoutId: startAckTimeoutId,
                subscriptionReadyCallback: subscriptionReadyCallback,
                subscriptionFailedCallback: subscriptionFailedCallback,
                subscriptionState: subscriptionState
            });
            observer.error({
                errors: [
                    $646d870c7f39b777$var$__assign({}, new (0, $31fsw.GraphQLError)("Connection failed: " + JSON.stringify(payload)))
                ]
            });
            clearTimeout(startAckTimeoutId);
            observer.complete();
            if (typeof subscriptionFailedCallback === "function") subscriptionFailedCallback();
        }
    };
    AWSAppSyncRealTimeProvider.prototype._errorDisconnect = function(msg) {
        $646d870c7f39b777$var$logger.debug("Disconnect error: " + msg);
        this.subscriptionObserverMap.forEach(function(_a) {
            var observer = _a.observer;
            if (!observer.closed) observer.error({
                errors: [
                    $646d870c7f39b777$var$__assign({}, new (0, $31fsw.GraphQLError)(msg))
                ]
            });
        });
        this.subscriptionObserverMap.clear();
        if (this.awsRealTimeSocket) this.awsRealTimeSocket.close();
        this.socketStatus = $646d870c7f39b777$var$SOCKET_STATUS.CLOSED;
    };
    AWSAppSyncRealTimeProvider.prototype._timeoutStartSubscriptionAck = function(subscriptionId) {
        var _a = this.subscriptionObserverMap.get(subscriptionId) || {}, observer = _a.observer, query = _a.query, variables = _a.variables;
        if (!observer) return;
        this.subscriptionObserverMap.set(subscriptionId, {
            observer: observer,
            query: query,
            variables: variables,
            subscriptionState: $646d870c7f39b777$var$SUBSCRIPTION_STATUS.FAILED
        });
        if (observer && !observer.closed) {
            observer.error({
                errors: [
                    $646d870c7f39b777$var$__assign({}, new (0, $31fsw.GraphQLError)("Subscription timeout " + JSON.stringify({
                        query: query,
                        variables: variables
                    })))
                ]
            });
            // Cleanup will be automatically executed
            observer.complete();
        }
        $646d870c7f39b777$var$logger.debug("timeoutStartSubscription", JSON.stringify({
            query: query,
            variables: variables
        }));
    };
    AWSAppSyncRealTimeProvider.prototype._initializeWebSocketConnection = function(_a) {
        var _this = this;
        var appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, authenticationType = _a.authenticationType, apiKey = _a.apiKey, region = _a.region;
        if (this.socketStatus === $646d870c7f39b777$var$SOCKET_STATUS.READY) return;
        return new Promise(function(res, rej) {
            return $646d870c7f39b777$var$__awaiter(_this, void 0, void 0, function() {
                var discoverableEndpoint, payloadString, headerString, _a, _b, headerQs, payloadQs, awsRealTimeUrl, err_3;
                return $646d870c7f39b777$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.promiseArray.push({
                                res: res,
                                rej: rej
                            });
                            if (!(this.socketStatus === $646d870c7f39b777$var$SOCKET_STATUS.CLOSED)) return [
                                3 /*break*/ ,
                                5
                            ];
                            _c.label = 1;
                        case 1:
                            _c.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            this.socketStatus = $646d870c7f39b777$var$SOCKET_STATUS.CONNECTING;
                            discoverableEndpoint = appSyncGraphqlEndpoint.replace("https://", "wss://").replace("appsync-api", "appsync-realtime-api").replace("gogi-beta", "grt-beta");
                            payloadString = "{}";
                            _b = (_a = JSON).stringify;
                            return [
                                4 /*yield*/ ,
                                this._awsRealTimeHeaderBasedAuth({
                                    authenticationType: authenticationType,
                                    payload: payloadString,
                                    canonicalUri: "/connect",
                                    apiKey: apiKey,
                                    appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                    region: region
                                })
                            ];
                        case 2:
                            headerString = _b.apply(_a, [
                                _c.sent()
                            ]);
                            headerQs = (0, $5oOz5.Buffer).from(headerString).toString("base64");
                            payloadQs = (0, $5oOz5.Buffer).from(payloadString).toString("base64");
                            awsRealTimeUrl = discoverableEndpoint + "?header=" + headerQs + "&payload=" + payloadQs;
                            return [
                                4 /*yield*/ ,
                                this._initializeRetryableHandshake({
                                    awsRealTimeUrl: awsRealTimeUrl
                                })
                            ];
                        case 3:
                            _c.sent();
                            this.promiseArray.forEach(function(_a) {
                                var res = _a.res;
                                $646d870c7f39b777$var$logger.debug("Notifying connection successful");
                                res();
                            });
                            this.socketStatus = $646d870c7f39b777$var$SOCKET_STATUS.READY;
                            this.promiseArray = [];
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_3 = _c.sent();
                            this.promiseArray.forEach(function(_a) {
                                var rej = _a.rej;
                                return rej(err_3);
                            });
                            this.promiseArray = [];
                            if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN) this.awsRealTimeSocket.close(3001);
                            this.awsRealTimeSocket = null;
                            this.socketStatus = $646d870c7f39b777$var$SOCKET_STATUS.CLOSED;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._initializeRetryableHandshake = function(_a) {
        var awsRealTimeUrl = _a.awsRealTimeUrl;
        return $646d870c7f39b777$var$__awaiter(this, void 0, void 0, function() {
            return $646d870c7f39b777$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $646d870c7f39b777$var$logger.debug("Initializaling retryable Handshake");
                        return [
                            4 /*yield*/ ,
                            (0, $9opJY.jitteredExponentialRetry)(this._initializeHandshake.bind(this), [
                                {
                                    awsRealTimeUrl: awsRealTimeUrl
                                }
                            ], $646d870c7f39b777$var$MAX_DELAY_MS)
                        ];
                    case 1:
                        _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._initializeHandshake = function(_a) {
        var awsRealTimeUrl = _a.awsRealTimeUrl;
        return $646d870c7f39b777$var$__awaiter(this, void 0, void 0, function() {
            var err_4, errorType, errorCode;
            var _this = this;
            return $646d870c7f39b777$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $646d870c7f39b777$var$logger.debug("Initializing handshake " + awsRealTimeUrl);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            function() {
                                return new Promise(function(res, rej) {
                                    var newSocket = new WebSocket(awsRealTimeUrl, "graphql-ws");
                                    newSocket.onerror = function() {
                                        $646d870c7f39b777$var$logger.debug("WebSocket connection error");
                                    };
                                    newSocket.onclose = function() {
                                        rej(new Error("Connection handshake error"));
                                    };
                                    newSocket.onopen = function() {
                                        _this.awsRealTimeSocket = newSocket;
                                        return res();
                                    };
                                });
                            }()
                        ];
                    case 2:
                        _b.sent();
                        // Step 2: wait for ack from AWS AppSyncReaTime after sending init
                        return [
                            4 /*yield*/ ,
                            function() {
                                return new Promise(function(res, rej) {
                                    var ackOk = false;
                                    _this.awsRealTimeSocket.onerror = function(error) {
                                        $646d870c7f39b777$var$logger.debug("WebSocket error " + JSON.stringify(error));
                                    };
                                    _this.awsRealTimeSocket.onclose = function(event) {
                                        $646d870c7f39b777$var$logger.debug("WebSocket closed " + event.reason);
                                        rej(new Error(JSON.stringify(event)));
                                    };
                                    _this.awsRealTimeSocket.onmessage = function(message) {
                                        $646d870c7f39b777$var$logger.debug("subscription message from AWS AppSyncRealTime: " + message.data + " ");
                                        var data = JSON.parse(message.data);
                                        var type = data.type, _a = data.payload, _b = (_a === void 0 ? {} : _a).connectionTimeoutMs, connectionTimeoutMs = _b === void 0 ? $646d870c7f39b777$var$DEFAULT_KEEP_ALIVE_TIMEOUT : _b;
                                        if (type === $646d870c7f39b777$var$MESSAGE_TYPES.GQL_CONNECTION_ACK) {
                                            ackOk = true;
                                            _this.keepAliveTimeout = connectionTimeoutMs;
                                            _this.awsRealTimeSocket.onmessage = _this._handleIncomingSubscriptionMessage.bind(_this);
                                            _this.awsRealTimeSocket.onerror = function(err) {
                                                $646d870c7f39b777$var$logger.debug(err);
                                                _this._errorDisconnect((0, $72iLF.CONTROL_MSG).CONNECTION_CLOSED);
                                            };
                                            res("Cool, connected to AWS AppSyncRealTime");
                                            return;
                                        }
                                        if (type === $646d870c7f39b777$var$MESSAGE_TYPES.GQL_CONNECTION_ERROR) {
                                            var _c = data.payload, _d = (_c === void 0 ? {} : _c).errors, _e = (_d === void 0 ? [] : _d)[0], _f = _e === void 0 ? {} : _e, _g = _f.errorType, errorType = _g === void 0 ? "" : _g, _h = _f.errorCode, errorCode = _h === void 0 ? 0 : _h;
                                            rej({
                                                errorType: errorType,
                                                errorCode: errorCode
                                            });
                                        }
                                    };
                                    var gqlInit = {
                                        type: $646d870c7f39b777$var$MESSAGE_TYPES.GQL_CONNECTION_INIT
                                    };
                                    _this.awsRealTimeSocket.send(JSON.stringify(gqlInit));
                                    function checkAckOk() {
                                        if (!ackOk) rej(new Error("Connection timeout: ack from AWSRealTime was not received on " + $646d870c7f39b777$var$CONNECTION_INIT_TIMEOUT + " ms"));
                                    }
                                    setTimeout(checkAckOk.bind(_this), $646d870c7f39b777$var$CONNECTION_INIT_TIMEOUT);
                                });
                            }()
                        ];
                    case 3:
                        // Step 2: wait for ack from AWS AppSyncReaTime after sending init
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        err_4 = _b.sent();
                        errorType = err_4.errorType, errorCode = err_4.errorCode;
                        if ($646d870c7f39b777$var$NON_RETRYABLE_CODES.includes(errorCode)) throw new (0, $9opJY.NonRetryableError)(errorType);
                        else if (errorType) throw new Error(errorType);
                        else throw err_4;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeHeaderBasedAuth = function(_a) {
        var authenticationType = _a.authenticationType, payload = _a.payload, canonicalUri = _a.canonicalUri, appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, apiKey = _a.apiKey, region = _a.region;
        return $646d870c7f39b777$var$__awaiter(this, void 0, void 0, function() {
            var headerHandler, handler, host, result;
            return $646d870c7f39b777$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        headerHandler = {
                            API_KEY: this._awsRealTimeApiKeyHeader.bind(this),
                            AWS_IAM: this._awsRealTimeIAMHeader.bind(this),
                            OPENID_CONNECT: this._awsRealTimeOPENIDHeader.bind(this),
                            AMAZON_COGNITO_USER_POOLS: this._awsRealTimeCUPHeader.bind(this)
                        };
                        handler = headerHandler[authenticationType];
                        if (typeof handler !== "function") {
                            $646d870c7f39b777$var$logger.debug("Authentication type " + authenticationType + " not supported");
                            return [
                                2 /*return*/ ,
                                ""
                            ];
                        }
                        host = $i3eDV.parse(appSyncGraphqlEndpoint).host;
                        return [
                            4 /*yield*/ ,
                            handler({
                                payload: payload,
                                canonicalUri: canonicalUri,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                apiKey: apiKey,
                                region: region,
                                host: host
                            })
                        ];
                    case 1:
                        result = _b.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeCUPHeader = function(_a) {
        var host = _a.host;
        return $646d870c7f39b777$var$__awaiter(this, void 0, void 0, function() {
            var session;
            return $646d870c7f39b777$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $hbz3E.default).currentSession()
                        ];
                    case 1:
                        session = _b.sent();
                        return [
                            2 /*return*/ ,
                            {
                                Authorization: session.getAccessToken().getJwtToken(),
                                host: host
                            }
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeOPENIDHeader = function(_a) {
        var host = _a.host;
        return $646d870c7f39b777$var$__awaiter(this, void 0, void 0, function() {
            var federatedInfo;
            return $646d870c7f39b777$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $9x214.default).getItem("federatedInfo")
                        ];
                    case 1:
                        federatedInfo = _b.sent();
                        if (!federatedInfo || !federatedInfo.token) throw new Error("No federated jwt");
                        return [
                            2 /*return*/ ,
                            {
                                Authorization: federatedInfo.token,
                                host: host
                            }
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeApiKeyHeader = function(_a) {
        var apiKey = _a.apiKey, host = _a.host;
        return $646d870c7f39b777$var$__awaiter(this, void 0, void 0, function() {
            var dt, dtStr;
            return $646d870c7f39b777$var$__generator(this, function(_b) {
                dt = new Date();
                dtStr = dt.toISOString().replace(/[:\-]|\.\d{3}/g, "");
                return [
                    2 /*return*/ ,
                    {
                        host: host,
                        "x-amz-date": dtStr,
                        "x-api-key": apiKey
                    }
                ];
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeIAMHeader = function(_a) {
        var payload = _a.payload, canonicalUri = _a.canonicalUri, appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, region = _a.region;
        return $646d870c7f39b777$var$__awaiter(this, void 0, void 0, function() {
            var endpointInfo, credentialsOK, creds, request, signed_params;
            return $646d870c7f39b777$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        endpointInfo = {
                            region: region,
                            service: "appsync"
                        };
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _b.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        return [
                            4 /*yield*/ ,
                            (0, $aCVDw.default).get().then(function(credentials) {
                                return {
                                    secret_key: credentials.secretAccessKey,
                                    access_key: credentials.accessKeyId,
                                    session_token: credentials.sessionToken
                                };
                            })
                        ];
                    case 2:
                        creds = _b.sent();
                        request = {
                            url: "" + appSyncGraphqlEndpoint + canonicalUri,
                            data: payload,
                            method: "POST",
                            headers: $646d870c7f39b777$var$__assign({}, $646d870c7f39b777$var$AWS_APPSYNC_REALTIME_HEADERS)
                        };
                        signed_params = (0, $kP2rz.default).sign(request, creds, endpointInfo);
                        return [
                            2 /*return*/ ,
                            signed_params.headers
                        ];
                }
            });
        });
    };
    /**
     * @private
     */ AWSAppSyncRealTimeProvider.prototype._ensureCredentials = function() {
        return (0, $aCVDw.default).get().then(function(credentials) {
            if (!credentials) return false;
            var cred = (0, $aCVDw.default).shear(credentials);
            $646d870c7f39b777$var$logger.debug("set credentials for AWSAppSyncRealTimeProvider", cred);
            return true;
        }).catch(function(err) {
            $646d870c7f39b777$var$logger.warn("ensure credentials error", err);
            return false;
        });
    };
    return AWSAppSyncRealTimeProvider;
}((0, $aXKIu.AbstractPubSubProvider));

});
parcelRequire.register("31fsw", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", function () { return $d027588e1676ebac$export$92d6ed0888e7cb7f; });
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ 
var $f97OH = parcelRequire("f97OH");

var $dQsJP = parcelRequire("dQsJP");
function $d027588e1676ebac$export$92d6ed0888e7cb7f(message, nodes, source, positions, path, originalError, extensions) {
    // Compute list of blame nodes.
    var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [
        nodes
    ] : undefined; // Compute locations in the source for the given nodes/positions.
    var _source = source;
    if (!_source && _nodes) {
        var node = _nodes[0];
        _source = node && node.loc && node.loc.source;
    }
    var _positions = positions;
    if (!_positions && _nodes) _positions = _nodes.reduce(function(list, node) {
        if (node.loc) list.push(node.loc.start);
        return list;
    }, []);
    if (_positions && _positions.length === 0) _positions = undefined;
    var _locations;
    if (positions && source) _locations = positions.map(function(pos) {
        return (0, $dQsJP.getLocation)(source, pos);
    });
    else if (_nodes) _locations = _nodes.reduce(function(list, node) {
        if (node.loc) list.push((0, $dQsJP.getLocation)(node.loc.source, node.loc.start));
        return list;
    }, []);
    var _extensions = extensions || originalError && originalError.extensions;
    Object.defineProperties(this, {
        message: {
            value: message,
            // By being enumerable, JSON.stringify will include `message` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: true,
            writable: true
        },
        locations: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _locations || undefined,
            // By being enumerable, JSON.stringify will include `locations` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(_locations)
        },
        path: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: path || undefined,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(path)
        },
        nodes: {
            value: _nodes || undefined
        },
        source: {
            value: _source || undefined
        },
        positions: {
            value: _positions || undefined
        },
        originalError: {
            value: originalError
        },
        extensions: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _extensions || undefined,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(_extensions)
        }
    }); // Include (non-enumerable) stack trace.
    if (originalError && originalError.stack) Object.defineProperty(this, "stack", {
        value: originalError.stack,
        writable: true,
        configurable: true
    });
    else if (Error.captureStackTrace) Error.captureStackTrace(this, $d027588e1676ebac$export$92d6ed0888e7cb7f);
    else Object.defineProperty(this, "stack", {
        value: Error().stack,
        writable: true,
        configurable: true
    });
}
$d027588e1676ebac$export$92d6ed0888e7cb7f.prototype = Object.create(Error.prototype, {
    constructor: {
        value: $d027588e1676ebac$export$92d6ed0888e7cb7f
    },
    name: {
        value: "GraphQLError"
    },
    toString: {
        value: function toString() {
            return (0, $f97OH.printError)(this);
        }
    }
});

});
parcelRequire.register("f97OH", function(module, exports) {

$parcel$export(module.exports, "printError", function () { return $8acdc861897c17e3$export$55ee1551a3f962e6; });
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ 
var $dQsJP = parcelRequire("dQsJP");
function $8acdc861897c17e3$export$55ee1551a3f962e6(error) {
    var printedLocations = [];
    if (error.nodes) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = error.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var node = _step.value;
                if (node.loc) printedLocations.push($8acdc861897c17e3$var$highlightSourceAtLocation(node.loc.source, (0, $dQsJP.getLocation)(node.loc.source, node.loc.start)));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
    } else if (error.source && error.locations) {
        var source = error.source;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;
        try {
            for(var _iterator2 = error.locations[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var location = _step2.value;
                printedLocations.push($8acdc861897c17e3$var$highlightSourceAtLocation(source, location));
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) _iterator2.return();
            } finally{
                if (_didIteratorError2) throw _iteratorError2;
            }
        }
    }
    return printedLocations.length === 0 ? error.message : [
        error.message
    ].concat(printedLocations).join("\n\n") + "\n";
}
/**
 * Render a helpful description of the location of the error in the GraphQL
 * Source document.
 */ function $8acdc861897c17e3$var$highlightSourceAtLocation(source, location) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $8acdc861897c17e3$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = location.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = location.line + lineOffset;
    var columnOffset = location.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = location.column + columnOffset;
    var lines = body.split(/\r\n|[\n\r]/g);
    return "".concat(source.name, " (").concat(lineNum, ":").concat(columnNum, ")\n") + $8acdc861897c17e3$var$printPrefixedLines([
        [
            "".concat(lineNum - 1, ": "),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum, ": "),
            lines[lineIndex]
        ],
        [
            "",
            $8acdc861897c17e3$var$whitespace(columnNum - 1) + "^"
        ],
        [
            "".concat(lineNum + 1, ": "),
            lines[lineIndex + 1]
        ]
    ]);
}
function $8acdc861897c17e3$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = 0;
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;
    try {
        for(var _iterator3 = existingLines[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
            var _ref4 = _step3.value;
            var prefix = _ref4[0];
            padLen = Math.max(padLen, prefix.length);
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) _iterator3.return();
        } finally{
            if (_didIteratorError3) throw _iteratorError3;
        }
    }
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $8acdc861897c17e3$var$lpad(padLen, prefix) + line;
    }).join("\n");
}
function $8acdc861897c17e3$var$whitespace(len) {
    return Array(len + 1).join(" ");
}
function $8acdc861897c17e3$var$lpad(len, str) {
    return $8acdc861897c17e3$var$whitespace(len - str.length) + str;
}

});
parcelRequire.register("dQsJP", function(module, exports) {

$parcel$export(module.exports, "getLocation", function () { return $5192740ab591f6f7$export$e7fd20fad3cf4b5f; });
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $5192740ab591f6f7$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});




parcelRequire.register("eIYqJ", function(module, exports) {

var $iPlxP = parcelRequire("iPlxP");
parcelRequire("2hWDt");
var $aCVDw = parcelRequire("aCVDw");
var $kP2rz = parcelRequire("kP2rz");
var $ab840cea24f09799$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ab840cea24f09799$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ab840cea24f09799$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $ab840cea24f09799$var$SERVICE_NAME = "iotdevicegateway";
var $ab840cea24f09799$export$5c9ec3d843e2180d = /** @class */ function(_super) {
    $ab840cea24f09799$var$__extends(AWSIoTProvider, _super);
    function AWSIoTProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AWSIoTProvider.prototype, "region", {
        get: function() {
            return this.options.aws_pubsub_region;
        },
        enumerable: true,
        configurable: true
    });
    AWSIoTProvider.prototype.getProviderName = function() {
        return "AWSIoTProvider";
    };
    Object.defineProperty(AWSIoTProvider.prototype, "endpoint", {
        get: function() {
            var _this = this;
            return function() {
                return $ab840cea24f09799$var$__awaiter(_this, void 0, void 0, function() {
                    var endpoint, serviceInfo, _a, access_key, secret_key, session_token, result;
                    return $ab840cea24f09799$var$__generator(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                endpoint = this.options.aws_pubsub_endpoint;
                                serviceInfo = {
                                    service: $ab840cea24f09799$var$SERVICE_NAME,
                                    region: this.region
                                };
                                return [
                                    4 /*yield*/ ,
                                    (0, $aCVDw.default).get()
                                ];
                            case 1:
                                _a = _b.sent(), access_key = _a.accessKeyId, secret_key = _a.secretAccessKey, session_token = _a.sessionToken;
                                result = (0, $kP2rz.default).signUrl(endpoint, {
                                    access_key: access_key,
                                    secret_key: secret_key,
                                    session_token: session_token
                                }, serviceInfo);
                                return [
                                    2 /*return*/ ,
                                    result
                                ];
                        }
                    });
                });
            }();
        },
        enumerable: true,
        configurable: true
    });
    return AWSIoTProvider;
}((0, $iPlxP.MqttOverWSProvider));

});




parcelRequire.register("6i0dT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $494498d65442d5c9$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $5y8GF = parcelRequire("5y8GF");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $2hWDt = parcelRequire("2hWDt");

var $fDIVI = parcelRequire("fDIVI");
var $494498d65442d5c9$var$logger = new (0, $gBqCF.ConsoleLogger)("Interactions");
var $494498d65442d5c9$var$_instance = null;
if (!$494498d65442d5c9$var$_instance) {
    $494498d65442d5c9$var$logger.debug("Create Interactions Instance");
    $494498d65442d5c9$var$_instance = new (0, $5y8GF.default)(null);
}
var $494498d65442d5c9$var$Interactions = $494498d65442d5c9$var$_instance;
(0, $2hWDt.default).register($494498d65442d5c9$var$Interactions);
var $494498d65442d5c9$export$2e2bcd8739ae039 = $494498d65442d5c9$var$Interactions;
$parcel$exportWildcard(module.exports, $fDIVI);

});
parcelRequire.register("5y8GF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40a6ddd6dfe55e1c$export$2e2bcd8739ae039; });
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
parcelRequire("fkntX");
var $fDIVI = parcelRequire("fDIVI");
var $40a6ddd6dfe55e1c$var$__assign = undefined && undefined.__assign || function() {
    $40a6ddd6dfe55e1c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $40a6ddd6dfe55e1c$var$__assign.apply(this, arguments);
};
var $40a6ddd6dfe55e1c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $40a6ddd6dfe55e1c$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $40a6ddd6dfe55e1c$var$logger = new (0, $gBqCF.ConsoleLogger)("Interactions");
var $40a6ddd6dfe55e1c$var$Interactions = /** @class */ function() {
    /**
     * Initialize PubSub with AWS configurations
     *
     * @param {InteractionsOptions} options - Configuration object for Interactions
     */ function Interactions(options) {
        this._options = options;
        $40a6ddd6dfe55e1c$var$logger.debug("Interactions Options", this._options);
        this._pluggables = {};
    }
    Interactions.prototype.getModuleName = function() {
        return "Interactions";
    };
    /**
     *
     * @param {InteractionsOptions} options - Configuration object for Interactions
     * @return {Object} - The current configuration
     */ Interactions.prototype.configure = function(options) {
        var _this = this;
        var opt = options ? options.Interactions || options : {};
        $40a6ddd6dfe55e1c$var$logger.debug("configure Interactions", {
            opt: opt
        });
        this._options = $40a6ddd6dfe55e1c$var$__assign($40a6ddd6dfe55e1c$var$__assign({
            bots: {}
        }, opt), opt.Interactions);
        var aws_bots_config = this._options.aws_bots_config;
        var bots_config = this._options.bots;
        if (!Object.keys(bots_config).length && aws_bots_config) // Convert aws_bots_config to bots object
        {
            if (Array.isArray(aws_bots_config)) aws_bots_config.forEach(function(bot) {
                _this._options.bots[bot.name] = bot;
            });
        }
        // Check if AWSLex provider is already on pluggables
        if (!this._pluggables.AWSLexProvider && bots_config && Object.keys(bots_config).map(function(key) {
            return bots_config[key];
        }).find(function(bot) {
            return !bot.providerName || bot.providerName === "AWSLexProvider";
        })) this._pluggables.AWSLexProvider = new (0, $fDIVI.AWSLexProvider)();
        Object.keys(this._pluggables).map(function(key) {
            _this._pluggables[key].configure(_this._options.bots);
        });
        return this._options;
    };
    Interactions.prototype.addPluggable = function(pluggable) {
        if (pluggable && pluggable.getCategory() === "Interactions") {
            if (!this._pluggables[pluggable.getProviderName()]) {
                pluggable.configure(this._options.bots);
                this._pluggables[pluggable.getProviderName()] = pluggable;
                return;
            } else throw new Error("Bot " + pluggable.getProviderName() + " already plugged");
        }
    };
    Interactions.prototype.send = function(botname, message) {
        return $40a6ddd6dfe55e1c$var$__awaiter(this, void 0, void 0, function() {
            var botProvider;
            return $40a6ddd6dfe55e1c$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this._options.bots || !this._options.bots[botname]) throw new Error("Bot " + botname + " does not exist");
                        botProvider = this._options.bots[botname].providerName || "AWSLexProvider";
                        if (!this._pluggables[botProvider]) throw new Error("Bot " + botProvider + " does not have valid pluggin did you try addPluggable first?");
                        return [
                            4 /*yield*/ ,
                            this._pluggables[botProvider].sendMessage(botname, message)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    Interactions.prototype.onComplete = function(botname, callback) {
        if (!this._options.bots || !this._options.bots[botname]) throw new Error("Bot " + botname + " does not exist");
        var botProvider = this._options.bots[botname].providerName || "AWSLexProvider";
        if (!this._pluggables[botProvider]) throw new Error("Bot " + botProvider + " does not have valid pluggin did you try addPluggable first?");
        this._pluggables[botProvider].onComplete(botname, callback);
    };
    return Interactions;
}();
var $40a6ddd6dfe55e1c$export$2e2bcd8739ae039 = $40a6ddd6dfe55e1c$var$Interactions;

});
parcelRequire.register("fkntX", function(module, exports) {
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $fDIVI = parcelRequire("fDIVI");

var $eULkp = parcelRequire("eULkp");
$parcel$exportWildcard(module.exports, $fDIVI);
$parcel$exportWildcard(module.exports, $eULkp);

});
parcelRequire.register("fDIVI", function(module, exports) {

$parcel$export(module.exports, "AWSLexProvider", function () { return $b62d59b2adf35549$export$49497e7fe044387b; });
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $eULkp = parcelRequire("eULkp");

var $lkBWy = parcelRequire("lkBWy");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $aCVDw = parcelRequire("aCVDw");
var $blxMe = parcelRequire("blxMe");
var $b62d59b2adf35549$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b62d59b2adf35549$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b62d59b2adf35549$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $b62d59b2adf35549$var$logger = new (0, $gBqCF.ConsoleLogger)("AWSLexProvider");
var $b62d59b2adf35549$export$49497e7fe044387b = /** @class */ function(_super) {
    $b62d59b2adf35549$var$__extends(AWSLexProvider, _super);
    function AWSLexProvider(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, options) || this;
        _this.aws_lex = new $lkBWy({
            region: _this._config.region
        });
        _this._botsCompleteCallback = {};
        return _this;
    }
    AWSLexProvider.prototype.getProviderName = function() {
        return "AWSLexProvider";
    };
    AWSLexProvider.prototype.responseCallback = function(err, data, res, rej, botname) {
        var _this = this;
        if (err) {
            rej(err);
            return;
        } else {
            // Check if state is fulfilled to resolve onFullfilment promise
            $b62d59b2adf35549$var$logger.debug("postContent state", data.dialogState);
            if (data.dialogState === "ReadyForFulfillment" || data.dialogState === "Fulfilled") {
                if (typeof this._botsCompleteCallback[botname] === "function") setTimeout(function() {
                    return _this._botsCompleteCallback[botname](null, {
                        slots: data.slots
                    });
                }, 0);
                if (this._config && typeof this._config[botname].onComplete === "function") setTimeout(function() {
                    return _this._config[botname].onComplete(null, {
                        slots: data.slots
                    });
                }, 0);
            }
            res(data);
            if (data.dialogState === "Failed") {
                if (typeof this._botsCompleteCallback[botname] === "function") setTimeout(function() {
                    return _this._botsCompleteCallback[botname]("Bot conversation failed");
                }, 0);
                if (this._config && typeof this._config[botname].onComplete === "function") setTimeout(function() {
                    return _this._config[botname].onComplete("Bot conversation failed");
                }, 0);
            }
        }
    };
    AWSLexProvider.prototype.sendMessage = function(botname, message) {
        var _this = this;
        return new Promise(function(res, rej) {
            return $b62d59b2adf35549$var$__awaiter(_this, void 0, void 0, function() {
                var credentials, params;
                var _this = this;
                return $b62d59b2adf35549$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!this._config[botname]) return [
                                2 /*return*/ ,
                                rej("Bot " + botname + " does not exist")
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, $aCVDw.default).get()
                            ];
                        case 1:
                            credentials = _a.sent();
                            if (!credentials) return [
                                2 /*return*/ ,
                                rej("No credentials")
                            ];
                            (0, $blxMe).config.update({
                                credentials: credentials
                            });
                            this.aws_lex = new $lkBWy({
                                region: this._config[botname].region,
                                credentials: credentials
                            });
                            if (typeof message === "string") {
                                params = {
                                    botAlias: this._config[botname].alias,
                                    botName: botname,
                                    inputText: message,
                                    userId: credentials.identityId
                                };
                                $b62d59b2adf35549$var$logger.debug("postText to lex", message);
                                this.aws_lex.postText(params, function(err, data) {
                                    _this.responseCallback(err, data, res, rej, botname);
                                });
                            } else {
                                if (message.options["messageType"] === "voice") params = {
                                    botAlias: this._config[botname].alias,
                                    botName: botname,
                                    contentType: "audio/x-l16; sample-rate=16000",
                                    inputStream: message.content,
                                    userId: credentials.identityId,
                                    accept: "audio/mpeg"
                                };
                                else params = {
                                    botAlias: this._config[botname].alias,
                                    botName: botname,
                                    contentType: "text/plain; charset=utf-8",
                                    inputStream: message.content,
                                    userId: credentials.identityId,
                                    accept: "audio/mpeg"
                                };
                                $b62d59b2adf35549$var$logger.debug("postContent to lex", message);
                                this.aws_lex.postContent(params, function(err, data) {
                                    _this.responseCallback(err, data, res, rej, botname);
                                });
                            }
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    AWSLexProvider.prototype.onComplete = function(botname, callback) {
        if (!this._config[botname]) throw new ErrorEvent("Bot " + botname + " does not exist");
        this._botsCompleteCallback[botname] = callback;
    };
    return AWSLexProvider;
}((0, $eULkp.AbstractInteractionsProvider));

});
parcelRequire.register("eULkp", function(module, exports) {

$parcel$export(module.exports, "AbstractInteractionsProvider", function () { return $adbb02092668a71f$export$a3e4dd03c769f695; });
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $adbb02092668a71f$var$__assign = undefined && undefined.__assign || function() {
    $adbb02092668a71f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $adbb02092668a71f$var$__assign.apply(this, arguments);
};
var $adbb02092668a71f$var$logger = new (0, $gBqCF.ConsoleLogger)("AbstractInteractionsProvider");
var $adbb02092668a71f$export$a3e4dd03c769f695 = /** @class */ function() {
    function AbstractInteractionsProvider(options) {
        if (options === void 0) options = {};
        this._config = options;
    }
    AbstractInteractionsProvider.prototype.configure = function(config) {
        if (config === void 0) config = {};
        this._config = $adbb02092668a71f$var$__assign($adbb02092668a71f$var$__assign({}, this._config), config);
        $adbb02092668a71f$var$logger.debug("configure " + this.getProviderName(), this._config);
        return this.options;
    };
    AbstractInteractionsProvider.prototype.getCategory = function() {
        return "Interactions";
    };
    Object.defineProperty(AbstractInteractionsProvider.prototype, "options", {
        get: function() {
            return $adbb02092668a71f$var$__assign({}, this._config);
        },
        enumerable: true,
        configurable: true
    });
    return AbstractInteractionsProvider;
}();

});

parcelRequire.register("lkBWy", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $f878e5fec2404dae$var$Service = $dbC7k.Service;
var $f878e5fec2404dae$var$apiLoader = $dbC7k.apiLoader;
$f878e5fec2404dae$var$apiLoader.services["lexruntime"] = {};
$dbC7k.LexRuntime = $f878e5fec2404dae$var$Service.defineService("lexruntime", [
    "2016-11-28"
]);


Object.defineProperty($f878e5fec2404dae$var$apiLoader.services["lexruntime"], "2016-11-28", {
    get: function get() {
        var model = (parcelRequire("kMiW6"));
        model.paginators = (parcelRequire("kdsSS")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.LexRuntime;

});
parcelRequire.register("kMiW6", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-11-28","endpointPrefix":"runtime.lex","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Lex Runtime Service","serviceId":"Lex Runtime Service","signatureVersion":"v4","signingName":"lex","uid":"runtime.lex-2016-11-28"},"operations":{"DeleteSession":{"http":{"method":"DELETE","requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/session"},"input":{"type":"structure","required":["botName","botAlias","userId"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"}}},"output":{"type":"structure","members":{"botName":{},"botAlias":{},"userId":{},"sessionId":{}}}},"GetSession":{"http":{"method":"GET","requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/session"},"input":{"type":"structure","required":["botName","botAlias","userId"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"}}},"output":{"type":"structure","members":{"recentIntentSummaryView":{"type":"list","member":{"type":"structure","required":["dialogActionType"],"members":{"intentName":{},"slots":{"shape":"Sc"},"confirmationStatus":{},"dialogActionType":{},"fulfillmentState":{},"slotToElicit":{}}}},"sessionAttributes":{"shape":"Sc"},"sessionId":{},"dialogAction":{"shape":"Sg"}}}},"PostContent":{"http":{"requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/content"},"input":{"type":"structure","required":["botName","botAlias","userId","contentType","inputStream"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"},"sessionAttributes":{"shape":"Sk","jsonvalue":true,"location":"header","locationName":"x-amz-lex-session-attributes"},"requestAttributes":{"shape":"Sk","jsonvalue":true,"location":"header","locationName":"x-amz-lex-request-attributes"},"contentType":{"location":"header","locationName":"Content-Type"},"accept":{"location":"header","locationName":"Accept"},"inputStream":{"shape":"Sn"}},"payload":"inputStream"},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"intentName":{"location":"header","locationName":"x-amz-lex-intent-name"},"slots":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-slots"},"sessionAttributes":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-session-attributes"},"message":{"shape":"Sh","location":"header","locationName":"x-amz-lex-message"},"messageFormat":{"location":"header","locationName":"x-amz-lex-message-format"},"dialogState":{"location":"header","locationName":"x-amz-lex-dialog-state"},"slotToElicit":{"location":"header","locationName":"x-amz-lex-slot-to-elicit"},"inputTranscript":{"location":"header","locationName":"x-amz-lex-input-transcript"},"audioStream":{"shape":"Sn"}},"payload":"audioStream"},"authtype":"v4-unsigned-body"},"PostText":{"http":{"requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/text"},"input":{"type":"structure","required":["botName","botAlias","userId","inputText"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"},"sessionAttributes":{"shape":"Sc"},"requestAttributes":{"shape":"Sc"},"inputText":{"shape":"Sh"}}},"output":{"type":"structure","members":{"intentName":{},"slots":{"shape":"Sc"},"sessionAttributes":{"shape":"Sc"},"message":{"shape":"Sh"},"messageFormat":{},"dialogState":{},"slotToElicit":{},"responseCard":{"type":"structure","members":{"version":{},"contentType":{},"genericAttachments":{"type":"list","member":{"type":"structure","members":{"title":{},"subTitle":{},"attachmentLinkUrl":{},"imageUrl":{},"buttons":{"type":"list","member":{"type":"structure","required":["text","value"],"members":{"text":{},"value":{}}}}}}}}}}}},"PutSession":{"http":{"requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/session"},"input":{"type":"structure","required":["botName","botAlias","userId"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"},"sessionAttributes":{"shape":"Sc"},"dialogAction":{"shape":"Sg"},"accept":{"location":"header","locationName":"Accept"}}},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"intentName":{"location":"header","locationName":"x-amz-lex-intent-name"},"slots":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-slots"},"sessionAttributes":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-session-attributes"},"message":{"shape":"Sh","location":"header","locationName":"x-amz-lex-message"},"messageFormat":{"location":"header","locationName":"x-amz-lex-message-format"},"dialogState":{"location":"header","locationName":"x-amz-lex-dialog-state"},"slotToElicit":{"location":"header","locationName":"x-amz-lex-slot-to-elicit"},"audioStream":{"shape":"Sn"},"sessionId":{"location":"header","locationName":"x-amz-lex-session-id"}},"payload":"audioStream"}}},"shapes":{"Sc":{"type":"map","key":{},"value":{},"sensitive":true},"Sg":{"type":"structure","required":["type"],"members":{"type":{},"intentName":{},"slots":{"shape":"Sc"},"slotToElicit":{},"fulfillmentState":{},"message":{"shape":"Sh"},"messageFormat":{}}},"Sh":{"type":"string","sensitive":true},"Sk":{"type":"string","sensitive":true},"Sn":{"type":"blob","streaming":true}}}');

});

parcelRequire.register("kdsSS", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});






parcelRequire.register("kLzjU", function(module, exports) {
!function(t, _) {
    module.exports = _();
}(module.exports, function() {
    return function(t) {
        var _ = {};
        function n(o) {
            if (_[o]) return _[o].exports;
            var e = _[o] = {
                i: o,
                l: !1,
                exports: {}
            };
            return t[o].call(e.exports, e, e.exports, n), e.l = !0, e.exports;
        }
        return n.m = t, n.c = _, n.d = function(t, _, o) {
            n.o(t, _) || Object.defineProperty(t, _, {
                enumerable: !0,
                get: o
            });
        }, n.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, n.t = function(t, _) {
            if (1 & _ && (t = n(t)), 8 & _) return t;
            if (4 & _ && "object" == typeof t && t && t.__esModule) return t;
            var o = Object.create(null);
            if (n.r(o), Object.defineProperty(o, "default", {
                enumerable: !0,
                value: t
            }), 2 & _ && "string" != typeof t) for(var e in t)n.d(o, e, (function(_) {
                return t[_];
            }).bind(null, e));
            return o;
        }, n.n = function(t) {
            var _ = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return n.d(_, "a", _), _;
        }, n.o = function(t, _) {
            return Object.prototype.hasOwnProperty.call(t, _);
        }, n.p = "", n(n.s = 0);
    }([
        function(t, _, n) {
            "use strict";
            function o(t) {
                for(var n in t)_.hasOwnProperty(n) || (_[n] = t[n]);
            }
            Object.defineProperty(_, "__esModule", {
                value: !0
            }), o(n(1)), o(n(2)), o(n(3)), o(n(4)), o(n(5)), o(n(6)), o(n(7)), o(n(8)), o(n(9)), o(n(10)), o(n(11)), o(n(12)), o(n(13));
        },
        function(t, _, n) {
            t.exports = {
                a: "Anchor__a___1_Iz8"
            };
        },
        function(t, _, n) {
            t.exports = {
                button: "Button__button___vS7Mv",
                signInButton: "Button__signInButton___3bUH-",
                googleSignInButton: "Button__googleSignInButton___1YiCu",
                signInButtonIcon: "Button__signInButtonIcon___ihN75",
                auth0SignInButton: "Button__auth0SignInButton___znnCj",
                facebookSignInButton: "Button__facebookSignInButton___34Txh",
                amazonSignInButton: "Button__amazonSignInButton___2EMtl",
                oAuthSignInButton: "Button__oAuthSignInButton___3UGOl",
                signInButtonContent: "Button__signInButtonContent___xqTXJ"
            };
        },
        function(t, _, n) {
            t.exports = {
                formContainer: "Form__formContainer___1GA3x",
                formSection: "Form__formSection___1PPvW",
                formField: "Form__formField___38Ikl",
                formRow: "Form__formRow___2mwRs"
            };
        },
        function(t, _, n) {
            t.exports = {
                hint: "Hint__hint___2XngB"
            };
        },
        function(t, _, n) {
            t.exports = {
                input: "Input__input___3e_bf",
                inputLabel: "Input__inputLabel___3VF0S",
                label: "Input__label___23sO8",
                radio: "Input__radio___2hllK"
            };
        },
        function(t, _, n) {
            t.exports = {
                navBar: "Nav__navBar___xtCFA",
                navRight: "Nav__navRight___1QG2J",
                nav: "Nav__nav___2Dx2Y",
                navItem: "Nav__navItem___1LtFQ"
            };
        },
        function(t, _, n) {
            t.exports = {
                photoPickerButton: "PhotoPicker__photoPickerButton___2XdVn",
                photoPlaceholder: "PhotoPicker__photoPlaceholder___2JXO4",
                photoPlaceholderIcon: "PhotoPicker__photoPlaceholderIcon___3Et71"
            };
        },
        function(t, _, n) {
            t.exports = {
                container: "Section__container___3YYTG",
                actionRow: "Section__actionRow___2LWSU",
                sectionHeader: "Section__sectionHeader___2djyg",
                sectionHeaderHint: "Section__sectionHeaderHint___3Wxdc",
                sectionBody: "Section__sectionBody___ihqqd",
                sectionHeaderContent: "Section__sectionHeaderContent___1UCqa",
                sectionFooter: "Section__sectionFooter___1T54C",
                sectionFooterPrimaryContent: "Section__sectionFooterPrimaryContent___2r9ZX",
                sectionFooterSecondaryContent: "Section__sectionFooterSecondaryContent___Nj41Q"
            };
        },
        function(t, _, n) {
            t.exports = {
                selectInput: "SelectInput__selectInput___3efO4"
            };
        },
        function(t, _, n) {
            t.exports = {
                strike: "Strike__strike___1XV1b",
                strikeContent: "Strike__strikeContent___10gLb"
            };
        },
        function(t, _, n) {
            t.exports = {
                toast: "Toast__toast___XXr3v",
                toastClose: "Toast__toastClose___18lU4"
            };
        },
        function(t, _, n) {
            t.exports = {
                totpQrcode: "Totp__totpQrcode___1crLx"
            };
        },
        function(t, _, n) {
            t.exports = {
                sumerianSceneContainer: "XR__sumerianSceneContainer___3nVMt",
                sumerianScene: "XR__sumerianScene___2Tt7-",
                loadingOverlay: "XR__loadingOverlay___IbqcI",
                loadingContainer: "XR__loadingContainer___2Itxb",
                loadingLogo: "XR__loadingLogo___Ub7xQ",
                loadingSceneName: "XR__loadingSceneName___3__ne",
                loadingBar: "XR__loadingBar___2vcke",
                loadingBarFill: "XR__loadingBarFill___3M-D9",
                sceneErrorText: "XR__sceneErrorText___2y0tp",
                sceneBar: "XR__sceneBar___2ShrP",
                sceneName: "XR__sceneName___1ApHr",
                sceneActions: "XR__sceneActions___7plGs",
                actionButton: "XR__actionButton___2poIM",
                tooltip: "XR__tooltip___UYyhn",
                actionIcon: "XR__actionIcon___2qnd2",
                autoShowTooltip: "XR__autoShowTooltip___V1QH7"
            };
        }
    ]);
});

});

parcelRequire.register("7aWDl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5396f2fc59821f26$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $6Fcm0 = parcelRequire("6Fcm0");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $2hWDt = parcelRequire("2hWDt");

var $linLx = parcelRequire("linLx");

var $lpd5k = parcelRequire("lpd5k");
var $5396f2fc59821f26$var$logger = new (0, $gBqCF.ConsoleLogger)("XR");
var $5396f2fc59821f26$var$_instance = null;
if (!$5396f2fc59821f26$var$_instance) {
    $5396f2fc59821f26$var$logger.debug("Create XR Instance");
    $5396f2fc59821f26$var$_instance = new (0, $6Fcm0.default)(null);
}
var $5396f2fc59821f26$var$XR = $5396f2fc59821f26$var$_instance;
(0, $2hWDt.default).register($5396f2fc59821f26$var$XR);
var $5396f2fc59821f26$export$2e2bcd8739ae039 = $5396f2fc59821f26$var$XR;
$parcel$exportWildcard(module.exports, $linLx);
$parcel$exportWildcard(module.exports, $lpd5k);

});
parcelRequire.register("6Fcm0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4da027aadac64aa0$export$2e2bcd8739ae039; });
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");

var $linLx = parcelRequire("linLx");

var $lpd5k = parcelRequire("lpd5k");
var $4da027aadac64aa0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4da027aadac64aa0$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $4da027aadac64aa0$var$logger = new (0, $gBqCF.ConsoleLogger)("XR");
var $4da027aadac64aa0$var$DEFAULT_PROVIDER_NAME = "SumerianProvider";
var $4da027aadac64aa0$var$XR = /** @class */ function() {
    /**
     * Initialize XR with AWS configurations
     *
     * @param {XROptions} options - Configuration object for XR
     */ function XR(options) {
        this._options = options;
        $4da027aadac64aa0$var$logger.debug("XR Options", this._options);
        this._defaultProvider = $4da027aadac64aa0$var$DEFAULT_PROVIDER_NAME;
        this._pluggables = {};
        // Add default provider
        this.addPluggable(new (0, $linLx.SumerianProvider)());
    }
    /**
     * Configure XR part with configurations
     *
     * @param {XROptions} config - Configuration for XR
     * @return {Object} - The current configuration
     */ XR.prototype.configure = function(options) {
        var _this = this;
        var opt = options ? options.XR || options : {};
        $4da027aadac64aa0$var$logger.debug("configure XR", {
            opt: opt
        });
        this._options = Object.assign({}, this._options, opt);
        Object.entries(this._pluggables).map(function(_a) {
            var name = _a[0], provider = _a[1];
            if (name === _this._defaultProvider && !opt[_this._defaultProvider]) provider.configure(_this._options);
            else provider.configure(_this._options[name]);
        });
        return this._options;
    };
    /**
     * add plugin into XR category
     * @param {Object} pluggable - an instance of the plugin
     */ XR.prototype.addPluggable = function(pluggable) {
        return $4da027aadac64aa0$var$__awaiter(this, void 0, void 0, function() {
            var config;
            return $4da027aadac64aa0$var$__generator(this, function(_a) {
                if (pluggable && pluggable.getCategory() === "XR") {
                    this._pluggables[pluggable.getProviderName()] = pluggable;
                    config = pluggable.configure(this._options);
                    return [
                        2 /*return*/ ,
                        config
                    ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    XR.prototype.loadScene = function(sceneName, domElementId, sceneOptions, provider) {
        if (sceneOptions === void 0) sceneOptions = {};
        if (provider === void 0) provider = this._defaultProvider;
        return $4da027aadac64aa0$var$__awaiter(this, void 0, void 0, function() {
            return $4da027aadac64aa0$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this._pluggables[provider]) throw new (0, $lpd5k.XRProviderNotConfigured)("Provider '" + provider + "' not configured");
                        return [
                            4 /*yield*/ ,
                            this._pluggables[provider].loadScene(sceneName, domElementId, sceneOptions)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    XR.prototype.isSceneLoaded = function(sceneName, provider) {
        if (provider === void 0) provider = this._defaultProvider;
        if (!this._pluggables[provider]) throw new (0, $lpd5k.XRProviderNotConfigured)("Provider '" + provider + "' not configured");
        return this._pluggables[provider].isSceneLoaded(sceneName);
    };
    XR.prototype.getSceneController = function(sceneName, provider) {
        if (provider === void 0) provider = this._defaultProvider;
        if (!this._pluggables[provider]) throw new (0, $lpd5k.XRProviderNotConfigured)("Provider '" + provider + "' not configured");
        return this._pluggables[provider].getSceneController(sceneName);
    };
    XR.prototype.isVRCapable = function(sceneName, provider) {
        if (provider === void 0) provider = this._defaultProvider;
        if (!this._pluggables[provider]) throw new (0, $lpd5k.XRProviderNotConfigured)("Provider '" + provider + "' not configured");
        return this._pluggables[provider].isVRCapable(sceneName);
    };
    XR.prototype.isVRPresentationActive = function(sceneName, provider) {
        if (provider === void 0) provider = this._defaultProvider;
        if (!this._pluggables[provider]) throw new (0, $lpd5k.XRProviderNotConfigured)("Provider '" + provider + "' not configured");
        return this._pluggables[provider].isVRPresentationActive(sceneName);
    };
    XR.prototype.start = function(sceneName, provider) {
        if (provider === void 0) provider = this._defaultProvider;
        if (!this._pluggables[provider]) throw new (0, $lpd5k.XRProviderNotConfigured)("Provider '" + provider + "' not configured");
        return this._pluggables[provider].start(sceneName);
    };
    XR.prototype.enterVR = function(sceneName, provider) {
        if (provider === void 0) provider = this._defaultProvider;
        if (!this._pluggables[provider]) throw new (0, $lpd5k.XRProviderNotConfigured)("Provider '" + provider + "' not configured");
        return this._pluggables[provider].enterVR(sceneName);
    };
    XR.prototype.exitVR = function(sceneName, provider) {
        if (provider === void 0) provider = this._defaultProvider;
        if (!this._pluggables[provider]) throw new (0, $lpd5k.XRProviderNotConfigured)("Provider '" + provider + "' not configured");
        return this._pluggables[provider].exitVR(sceneName);
    };
    XR.prototype.isMuted = function(sceneName, provider) {
        if (provider === void 0) provider = this._defaultProvider;
        if (!this._pluggables[provider]) throw new (0, $lpd5k.XRProviderNotConfigured)("Provider '" + provider + "' not configured");
        return this._pluggables[provider].isMuted(sceneName);
    };
    XR.prototype.setMuted = function(sceneName, muted, provider) {
        if (provider === void 0) provider = this._defaultProvider;
        if (!this._pluggables[provider]) throw new (0, $lpd5k.XRProviderNotConfigured)("Provider '" + provider + "' not configured");
        return this._pluggables[provider].setMuted(sceneName, muted);
    };
    XR.prototype.onSceneEvent = function(sceneName, eventName, eventHandler, provider) {
        if (provider === void 0) provider = this._defaultProvider;
        if (!this._pluggables[provider]) throw new (0, $lpd5k.XRProviderNotConfigured)("Provider '" + provider + "' not configured");
        return this._pluggables[provider].onSceneEvent(sceneName, eventName, eventHandler);
    };
    XR.prototype.enableAudio = function(sceneName, provider) {
        if (provider === void 0) provider = this._defaultProvider;
        if (!this._pluggables[provider]) throw new (0, $lpd5k.XRProviderNotConfigured)("Provider '" + provider + "' not configured");
        return this._pluggables[provider].enableAudio(sceneName);
    };
    return XR;
}();
var $4da027aadac64aa0$export$2e2bcd8739ae039 = $4da027aadac64aa0$var$XR;

});
parcelRequire.register("linLx", function(module, exports) {

$parcel$export(module.exports, "SumerianProvider", function () { return $f80db6d23b6620d8$export$ad595c968a9b2726; });
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $2hWDt = parcelRequire("2hWDt");
var $aCVDw = parcelRequire("aCVDw");
var $kP2rz = parcelRequire("kP2rz");

var $jy3cR = parcelRequire("jy3cR");

var $lpd5k = parcelRequire("lpd5k");
var $f80db6d23b6620d8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f80db6d23b6620d8$var$__assign = undefined && undefined.__assign || function() {
    $f80db6d23b6620d8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f80db6d23b6620d8$var$__assign.apply(this, arguments);
};
var $f80db6d23b6620d8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f80db6d23b6620d8$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f80db6d23b6620d8$var$SUMERIAN_SERVICE_NAME = "sumerian";
var $f80db6d23b6620d8$var$logger = new (0, $gBqCF.ConsoleLogger)("SumerianProvider");
var $f80db6d23b6620d8$export$ad595c968a9b2726 = /** @class */ function(_super) {
    $f80db6d23b6620d8$var$__extends(SumerianProvider, _super);
    function SumerianProvider(options) {
        if (options === void 0) options = {};
        return _super.call(this, options) || this;
    }
    SumerianProvider.prototype.getProviderName = function() {
        return "SumerianProvider";
    };
    SumerianProvider.prototype.loadScript = function(url) {
        return $f80db6d23b6620d8$var$__awaiter(this, void 0, void 0, function() {
            return $f80db6d23b6620d8$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var scriptElement = document.createElement("script");
                        scriptElement.src = url;
                        scriptElement.addEventListener("load", function(event) {
                            resolve();
                        });
                        scriptElement.addEventListener("error", function(event) {
                            reject(new Error("Failed to load script: " + url));
                        });
                        document.head.appendChild(scriptElement);
                    })
                ];
            });
        });
    };
    SumerianProvider.prototype.loadScene = function(sceneName, domElementId, sceneOptions) {
        return $f80db6d23b6620d8$var$__awaiter(this, void 0, void 0, function() {
            var errorMsg, errorMsg, element, errorMsg, scene, errorMsg, sceneUrl, sceneId, sceneRegion, errorMsg, awsSDKConfigOverride, fetchOptions, url, credentials, accessInfo, serviceInfo, request, e_1, apiResponse, apiResponseJson, sceneBundleData, sceneBundle, sceneBundleJson, error_1, progressCallback, publishParamOverrides, sceneLoadParams, sceneController, _i, _a, warning;
            return $f80db6d23b6620d8$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!sceneName) {
                            errorMsg = "No scene name passed into loadScene";
                            $f80db6d23b6620d8$var$logger.error(errorMsg);
                            throw new (0, $lpd5k.XRSceneLoadFailure)(errorMsg);
                        }
                        if (!domElementId) {
                            errorMsg = "No dom element id passed into loadScene";
                            $f80db6d23b6620d8$var$logger.error(errorMsg);
                            throw new (0, $lpd5k.XRNoDomElement)(errorMsg);
                        }
                        element = document.getElementById(domElementId);
                        if (!element) {
                            errorMsg = "DOM element id, " + domElementId + " not found";
                            $f80db6d23b6620d8$var$logger.error(errorMsg);
                            throw new (0, $lpd5k.XRNoDomElement)(errorMsg);
                        }
                        scene = this.getScene(sceneName);
                        if (!scene.sceneConfig) {
                            errorMsg = "No scene config configured for scene: " + sceneName;
                            $f80db6d23b6620d8$var$logger.error(errorMsg);
                            throw new (0, $lpd5k.XRSceneLoadFailure)(errorMsg);
                        }
                        sceneUrl = scene.sceneConfig.url;
                        sceneId = scene.sceneConfig.sceneId;
                        if (scene.sceneConfig.hasOwnProperty("region")) // Use the scene region on the Sumerian scene configuration
                        sceneRegion = scene.sceneConfig.region;
                        else if (this.options.hasOwnProperty("region")) // Use the scene region on the XR category configuration
                        sceneRegion = this.options.region;
                        else {
                            errorMsg = "No region configured for scene: " + sceneName;
                            $f80db6d23b6620d8$var$logger.error(errorMsg);
                            throw new (0, $lpd5k.XRSceneLoadFailure)(errorMsg);
                        }
                        awsSDKConfigOverride = {
                            region: sceneRegion,
                            // This is passed to the AWS clients created in
                            // Sumerian's AwsSystem
                            // This helps other services(like Lex and Polly) to track
                            // traffic coming from Sumerian scenes embedded with Amplify
                            customUserAgent: (0, $2hWDt.Constants).userAgent + "-SumerianScene"
                        };
                        fetchOptions = {
                            headers: {
                                // This sets the AWS user agent string
                                // So the Sumerian service knows this request is
                                // from Amplify
                                "X-Amz-User-Agent": (0, $2hWDt.Constants).userAgent
                            }
                        };
                        url = sceneUrl;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, $aCVDw.default).get()
                        ];
                    case 2:
                        credentials = _b.sent();
                        awsSDKConfigOverride["credentials"] = credentials;
                        accessInfo = {
                            secret_key: credentials.secretAccessKey,
                            access_key: credentials.accessKeyId,
                            session_token: credentials.sessionToken
                        };
                        serviceInfo = {
                            region: sceneRegion,
                            service: $f80db6d23b6620d8$var$SUMERIAN_SERVICE_NAME
                        };
                        request = (0, $kP2rz.default).sign({
                            method: "GET",
                            url: sceneUrl
                        }, accessInfo, serviceInfo);
                        fetchOptions.headers = $f80db6d23b6620d8$var$__assign($f80db6d23b6620d8$var$__assign({}, fetchOptions.headers), request.headers);
                        url = request.url;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _b.sent();
                        $f80db6d23b6620d8$var$logger.debug("No credentials available, the request will be unsigned");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            fetch(url, fetchOptions)
                        ];
                    case 5:
                        apiResponse = _b.sent();
                        return [
                            4 /*yield*/ ,
                            apiResponse.json()
                        ];
                    case 6:
                        apiResponseJson = _b.sent();
                        if (apiResponse.status === 403) {
                            if (apiResponseJson.message) {
                                $f80db6d23b6620d8$var$logger.error("Failure to authenticate user: " + apiResponseJson.message);
                                throw new (0, $lpd5k.XRSceneLoadFailure)("Failure to authenticate user: " + apiResponseJson.message);
                            } else {
                                $f80db6d23b6620d8$var$logger.error("Failure to authenticate user");
                                throw new (0, $lpd5k.XRSceneLoadFailure)("Failure to authenticate user");
                            }
                        }
                        sceneBundleData = apiResponseJson.bundleData[sceneId];
                        return [
                            4 /*yield*/ ,
                            fetch(sceneBundleData.url, {
                                headers: sceneBundleData.headers
                            })
                        ];
                    case 7:
                        sceneBundle = _b.sent();
                        return [
                            4 /*yield*/ ,
                            sceneBundle.json()
                        ];
                    case 8:
                        sceneBundleJson = _b.sent();
                        _b.label = 9;
                    case 9:
                        _b.trys.push([
                            9,
                            11,
                            ,
                            12
                        ]);
                        // Load the Sumerian bootstrapper script into the DOM
                        return [
                            4 /*yield*/ ,
                            this.loadScript(sceneBundleJson[sceneId].bootstrapperUrl)
                        ];
                    case 10:
                        // Load the Sumerian bootstrapper script into the DOM
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 11:
                        error_1 = _b.sent();
                        $f80db6d23b6620d8$var$logger.error(error_1);
                        throw new (0, $lpd5k.XRSceneLoadFailure)(error_1);
                    case 12:
                        progressCallback = sceneOptions.progressCallback ? sceneOptions.progressCallback : undefined;
                        publishParamOverrides = scene.publishParamOverrides ? scene.publishParamOverrides : undefined;
                        sceneLoadParams = {
                            element: element,
                            sceneId: sceneId,
                            sceneBundle: sceneBundleJson,
                            apiResponse: apiResponseJson,
                            progressCallback: progressCallback,
                            publishParamOverrides: publishParamOverrides,
                            awsSDKConfigOverride: awsSDKConfigOverride
                        };
                        return [
                            4 /*yield*/ ,
                            window.SumerianBootstrapper.loadScene(sceneLoadParams)
                        ];
                    case 13:
                        sceneController = _b.sent();
                        scene.sceneController = sceneController;
                        scene.isLoaded = true;
                        // Log scene warnings
                        for(_i = 0, _a = sceneController.sceneLoadWarnings; _i < _a.length; _i++){
                            warning = _a[_i];
                            $f80db6d23b6620d8$var$logger.warn("loadScene warning: " + warning);
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SumerianProvider.prototype.isSceneLoaded = function(sceneName) {
        var scene = this.getScene(sceneName);
        return scene.isLoaded || false;
    };
    SumerianProvider.prototype.getScene = function(sceneName) {
        if (!this.options.scenes) {
            var errorMsg = "No scenes were defined in the configuration";
            $f80db6d23b6620d8$var$logger.error(errorMsg);
            throw new (0, $lpd5k.XRNoSceneConfiguredError)(errorMsg);
        }
        if (!sceneName) {
            var errorMsg = "No scene name was passed";
            $f80db6d23b6620d8$var$logger.error(errorMsg);
            throw new (0, $lpd5k.XRSceneNotFoundError)(errorMsg);
        }
        if (!this.options.scenes[sceneName]) {
            var errorMsg = "Scene '" + sceneName + "' is not configured";
            $f80db6d23b6620d8$var$logger.error(errorMsg);
            throw new (0, $lpd5k.XRSceneNotFoundError)(errorMsg);
        }
        return this.options.scenes[sceneName];
    };
    SumerianProvider.prototype.getSceneController = function(sceneName) {
        if (!this.options.scenes) {
            var errorMsg = "No scenes were defined in the configuration";
            $f80db6d23b6620d8$var$logger.error(errorMsg);
            throw new (0, $lpd5k.XRNoSceneConfiguredError)(errorMsg);
        }
        var scene = this.options.scenes[sceneName];
        if (!scene) {
            var errorMsg = "Scene '" + sceneName + "' is not configured";
            $f80db6d23b6620d8$var$logger.error(errorMsg);
            throw new (0, $lpd5k.XRSceneNotFoundError)(errorMsg);
        }
        var sceneController = scene.sceneController;
        if (!sceneController) {
            var errorMsg = "Scene controller for '" + sceneName + "' has not been loaded";
            $f80db6d23b6620d8$var$logger.error(errorMsg);
            throw new (0, $lpd5k.XRSceneNotLoadedError)(errorMsg);
        }
        return sceneController;
    };
    SumerianProvider.prototype.isVRCapable = function(sceneName) {
        var sceneController = this.getSceneController(sceneName);
        return sceneController.vrCapable;
    };
    SumerianProvider.prototype.isVRPresentationActive = function(sceneName) {
        var sceneController = this.getSceneController(sceneName);
        return sceneController.vrPresentationActive;
    };
    SumerianProvider.prototype.start = function(sceneName) {
        var sceneController = this.getSceneController(sceneName);
        sceneController.start();
    };
    SumerianProvider.prototype.enterVR = function(sceneName) {
        var sceneController = this.getSceneController(sceneName);
        sceneController.enterVR();
    };
    SumerianProvider.prototype.exitVR = function(sceneName) {
        var sceneController = this.getSceneController(sceneName);
        sceneController.exitVR();
    };
    SumerianProvider.prototype.isMuted = function(sceneName) {
        var sceneController = this.getSceneController(sceneName);
        return sceneController.muted;
    };
    SumerianProvider.prototype.setMuted = function(sceneName, muted) {
        var sceneController = this.getSceneController(sceneName);
        sceneController.muted = muted;
    };
    SumerianProvider.prototype.onSceneEvent = function(sceneName, eventName, eventHandler) {
        var sceneController = this.getSceneController(sceneName);
        sceneController.on(eventName, eventHandler);
    };
    SumerianProvider.prototype.enableAudio = function(sceneName) {
        var sceneController = this.getSceneController(sceneName);
        sceneController.enableAudio();
    };
    return SumerianProvider;
}((0, $jy3cR.AbstractXRProvider));

});
parcelRequire.register("jy3cR", function(module, exports) {

$parcel$export(module.exports, "AbstractXRProvider", function () { return $e3b3ae0843085552$export$63eea04f2bb4dcb5; });
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $e3b3ae0843085552$var$__assign = undefined && undefined.__assign || function() {
    $e3b3ae0843085552$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e3b3ae0843085552$var$__assign.apply(this, arguments);
};
var $e3b3ae0843085552$var$logger = new (0, $gBqCF.ConsoleLogger)("AbstractXRProvider");
var $e3b3ae0843085552$export$63eea04f2bb4dcb5 = /** @class */ function() {
    function AbstractXRProvider(options) {
        if (options === void 0) options = {};
        this._config = options;
    }
    AbstractXRProvider.prototype.configure = function(config) {
        if (config === void 0) config = {};
        this._config = $e3b3ae0843085552$var$__assign($e3b3ae0843085552$var$__assign({}, config), this._config);
        $e3b3ae0843085552$var$logger.debug("configure " + this.getProviderName(), this._config);
        return this.options;
    };
    AbstractXRProvider.prototype.getCategory = function() {
        return "XR";
    };
    Object.defineProperty(AbstractXRProvider.prototype, "options", {
        get: function() {
            return $e3b3ae0843085552$var$__assign({}, this._config);
        },
        enumerable: true,
        configurable: true
    });
    return AbstractXRProvider;
}();

});

parcelRequire.register("lpd5k", function(module, exports) {

$parcel$export(module.exports, "XRNoSceneConfiguredError", function () { return $f956152be0cce436$export$56c9e5cb2781199d; });
$parcel$export(module.exports, "XRSceneNotFoundError", function () { return $f956152be0cce436$export$b34215dd7467e24a; });
$parcel$export(module.exports, "XRSceneNotLoadedError", function () { return $f956152be0cce436$export$be86ffebb22398a5; });
$parcel$export(module.exports, "XRNoDomElement", function () { return $f956152be0cce436$export$65210296a10f3c4e; });
$parcel$export(module.exports, "XRSceneLoadFailure", function () { return $f956152be0cce436$export$2196ec94a0c4134e; });
$parcel$export(module.exports, "XRProviderNotConfigured", function () { return $f956152be0cce436$export$ce63e13e575d0540; });
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ var $f956152be0cce436$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f956152be0cce436$export$c4cd08a6720f5357 = /** @class */ function(_super) {
    $f956152be0cce436$var$__extends(XRError, _super);
    function XRError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return XRError;
}(Error);
var $f956152be0cce436$export$56c9e5cb2781199d = /** @class */ function(_super) {
    $f956152be0cce436$var$__extends(XRNoSceneConfiguredError, _super);
    function XRNoSceneConfiguredError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return XRNoSceneConfiguredError;
}($f956152be0cce436$export$c4cd08a6720f5357);
var $f956152be0cce436$export$b34215dd7467e24a = /** @class */ function(_super) {
    $f956152be0cce436$var$__extends(XRSceneNotFoundError, _super);
    function XRSceneNotFoundError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return XRSceneNotFoundError;
}($f956152be0cce436$export$c4cd08a6720f5357);
var $f956152be0cce436$export$be86ffebb22398a5 = /** @class */ function(_super) {
    $f956152be0cce436$var$__extends(XRSceneNotLoadedError, _super);
    function XRSceneNotLoadedError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return XRSceneNotLoadedError;
}($f956152be0cce436$export$c4cd08a6720f5357);
var $f956152be0cce436$export$65210296a10f3c4e = /** @class */ function(_super) {
    $f956152be0cce436$var$__extends(XRNoDomElement, _super);
    function XRNoDomElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return XRNoDomElement;
}($f956152be0cce436$export$c4cd08a6720f5357);
var $f956152be0cce436$export$2196ec94a0c4134e = /** @class */ function(_super) {
    $f956152be0cce436$var$__extends(XRSceneLoadFailure, _super);
    function XRSceneLoadFailure() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return XRSceneLoadFailure;
}($f956152be0cce436$export$c4cd08a6720f5357);
var $f956152be0cce436$export$ce63e13e575d0540 = /** @class */ function(_super) {
    $f956152be0cce436$var$__extends(XRProviderNotConfigured, _super);
    function XRProviderNotConfigured() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return XRProviderNotConfigured;
}($f956152be0cce436$export$c4cd08a6720f5357);

});




parcelRequire.register("519yT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a74767f8a21573b$export$2e2bcd8739ae039; });
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $bI736 = parcelRequire("bI736");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $2hWDt = parcelRequire("2hWDt");
parcelRequire("lnK4H");
var $1B2FB = parcelRequire("1B2FB");
var $g0yeX = parcelRequire("g0yeX");
var $3K689 = parcelRequire("3K689");
var $eHzYr = parcelRequire("eHzYr");
parcelRequire("j3ga8");
var $9dl3A = parcelRequire("9dl3A");
var $3a74767f8a21573b$var$logger = new (0, $gBqCF.ConsoleLogger)("Predictions");
var $3a74767f8a21573b$var$_instance = null;
if (!$3a74767f8a21573b$var$_instance) {
    $3a74767f8a21573b$var$logger.debug("Create Predictions Instance");
    $3a74767f8a21573b$var$_instance = new (0, $bI736.default)({});
}
var $3a74767f8a21573b$var$Predictions = $3a74767f8a21573b$var$_instance;
(0, $2hWDt.default).register($3a74767f8a21573b$var$Predictions);
var $3a74767f8a21573b$export$2e2bcd8739ae039 = $3a74767f8a21573b$var$Predictions;

});
parcelRequire.register("bI736", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8869459524508d08$export$2e2bcd8739ae039; });
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $8869459524508d08$var$__assign = undefined && undefined.__assign || function() {
    $8869459524508d08$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8869459524508d08$var$__assign.apply(this, arguments);
};
var $8869459524508d08$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $8869459524508d08$var$logger = new (0, $gBqCF.ConsoleLogger)("Predictions");
var $8869459524508d08$var$Predictions = /** @class */ function() {
    /**
     * Initialize Predictions with AWS configurations
     * @param {PredictionsOptions} options - Configuration object for Predictions
     */ function Predictions(options) {
        this._options = options;
        this._convertPluggables = [];
        this._identifyPluggables = [];
        this._interpretPluggables = [];
    }
    Predictions.prototype.getModuleName = function() {
        return "Predictions";
    };
    /**
     * add plugin/pluggable into Predictions category
     * @param {Object} pluggable - an instance of the plugin/pluggable
     **/ Predictions.prototype.addPluggable = function(pluggable) {
        if (this.getPluggable(pluggable.getProviderName())) throw new Error("Pluggable with name " + pluggable.getProviderName() + " has already been added.");
        var pluggableAdded = false;
        if (this.implementsConvertPluggable(pluggable)) {
            this._convertPluggables.push(pluggable);
            pluggableAdded = true;
        }
        if (this.implementsIdentifyPluggable(pluggable)) {
            this._identifyPluggables.push(pluggable);
            pluggableAdded = true;
        }
        if (this.implementsInterpretPluggable(pluggable)) {
            this._interpretPluggables.push(pluggable);
            pluggableAdded = true;
        }
        if (pluggableAdded) this.configurePluggable(pluggable);
    };
    /**
     * Get the plugin object
     * @param providerName - the name of the plugin
     */ Predictions.prototype.getPluggable = function(providerName) {
        var pluggable = this.getAllProviders().find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
        if (pluggable === undefined) {
            $8869459524508d08$var$logger.debug("No plugin found with providerName=>", providerName);
            return null;
        } else return pluggable;
    };
    /**
     * Remove the plugin object
     * @param providerName - the name of the plugin
     */ Predictions.prototype.removePluggable = function(providerName) {
        this._convertPluggables = this._convertPluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        this._identifyPluggables = this._identifyPluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        this._interpretPluggables = this._interpretPluggables.filter(function(pluggable) {
            return pluggable.getProviderName() !== providerName;
        });
        return;
    };
    /**
     * To make both top level providers and category level providers work with same interface and configuration
     * this method duplicates Predictions config into parent level config (for top level provider) and
     * category level config (such as convert, identify etc) and pass both to each provider.
     */ Predictions.prototype.configure = function(options) {
        var _this = this;
        var predictionsConfig = options ? options.predictions || options : {};
        predictionsConfig = $8869459524508d08$var$__assign($8869459524508d08$var$__assign({}, predictionsConfig), options);
        this._options = Object.assign({}, this._options, predictionsConfig);
        $8869459524508d08$var$logger.debug("configure Predictions", this._options);
        this.getAllProviders().forEach(function(pluggable) {
            return _this.configurePluggable(pluggable);
        });
    };
    Predictions.prototype.interpret = function(input, options) {
        var pluggableToExecute = this.getPluggableToExecute(this._interpretPluggables, options);
        return pluggableToExecute.interpret(input);
    };
    Predictions.prototype.convert = function(input, options) {
        var pluggableToExecute = this.getPluggableToExecute(this._convertPluggables, options);
        return pluggableToExecute.convert(input);
    };
    Predictions.prototype.identify = function(input, options) {
        var pluggableToExecute = this.getPluggableToExecute(this._identifyPluggables, options);
        return pluggableToExecute.identify(input);
    };
    // tslint:disable-next-line: max-line-length
    Predictions.prototype.getPluggableToExecute = function(pluggables, providerOptions) {
        // Give preference to provider name first since it is more specific to this call, even if
        // there is only one provider configured to error out if the name provided is not the one matched.
        if (providerOptions && providerOptions.providerName) return $8869459524508d08$var$__spreadArrays(pluggables).find(function(pluggable) {
            return pluggable.getProviderName() === providerOptions.providerName;
        });
        else {
            if (pluggables.length === 1) return pluggables[0];
            else throw new Error("More than one or no providers are configured, Either specify a provider name or configure exactly one provider");
        }
    };
    Predictions.prototype.getAllProviders = function() {
        return $8869459524508d08$var$__spreadArrays(this._convertPluggables, this._identifyPluggables, this._interpretPluggables);
    };
    Predictions.prototype.configurePluggable = function(pluggable) {
        var categoryConfig = Object.assign({}, this._options["predictions"], this._options[pluggable.getCategory().toLowerCase()] // Actual category level config
        );
        pluggable.configure(categoryConfig);
    };
    Predictions.prototype.implementsConvertPluggable = function(obj) {
        return obj && typeof obj.convert === "function";
    };
    Predictions.prototype.implementsIdentifyPluggable = function(obj) {
        return obj && typeof obj.identify === "function";
    };
    Predictions.prototype.implementsInterpretPluggable = function(obj) {
        return obj && typeof obj.interpret === "function";
    };
    return Predictions;
}();
var $8869459524508d08$export$2e2bcd8739ae039 = $8869459524508d08$var$Predictions;

});

parcelRequire.register("lnK4H", function(module, exports) {

$parcel$export(module.exports, "AmazonAIConvertPredictionsProvider", function () { return (parcelRequire("g0yeX")).default; });
$parcel$export(module.exports, "AmazonAIIdentifyPredictionsProvider", function () { return (parcelRequire("1B2FB")).default; });
$parcel$export(module.exports, "AmazonAIInterpretPredictionsProvider", function () { return (parcelRequire("eHzYr")).default; });

var $g0yeX = parcelRequire("g0yeX");

var $1B2FB = parcelRequire("1B2FB");

var $eHzYr = parcelRequire("eHzYr");

var $3K689 = parcelRequire("3K689");

});
parcelRequire.register("g0yeX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba7734d27d5a5ab3$export$2e2bcd8739ae039; });

var $8yp7t = parcelRequire("8yp7t");

var $gLVBK = parcelRequire("gLVBK");

var $4xsDJ = parcelRequire("4xsDJ");
parcelRequire("j3ga8");
var $9dl3A = parcelRequire("9dl3A");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $aCVDw = parcelRequire("aCVDw");
var $kP2rz = parcelRequire("kP2rz");

var $hAJO1 = parcelRequire("hAJO1");

var $706Xw = parcelRequire("706Xw");

var $5oOz5 = parcelRequire("5oOz5");
var $ba7734d27d5a5ab3$require$Buffer = $5oOz5.Buffer;
var $ba7734d27d5a5ab3$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ba7734d27d5a5ab3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ba7734d27d5a5ab3$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $ba7734d27d5a5ab3$var$logger = new (0, $gBqCF.ConsoleLogger)("AmazonAIConvertPredictionsProvider");
var $ba7734d27d5a5ab3$var$eventBuilder = new (0, $hAJO1.EventStreamMarshaller)((0, $706Xw.toUtf8), (0, $706Xw.fromUtf8));
var $ba7734d27d5a5ab3$var$AmazonAIConvertPredictionsProvider = /** @class */ function(_super) {
    $ba7734d27d5a5ab3$var$__extends(AmazonAIConvertPredictionsProvider, _super);
    function AmazonAIConvertPredictionsProvider() {
        var _this = _super.call(this) || this;
        _this.inputSampleRate = 44100;
        _this.outputSampleRate = 16000;
        return _this;
    }
    AmazonAIConvertPredictionsProvider.prototype.getProviderName = function() {
        return "AmazonAIConvertPredictionsProvider";
    };
    AmazonAIConvertPredictionsProvider.prototype.translateText = function(input) {
        var _this = this;
        $ba7734d27d5a5ab3$var$logger.debug("Starting translation");
        return new Promise(function(res, rej) {
            return $ba7734d27d5a5ab3$var$__awaiter(_this, void 0, void 0, function() {
                var _a, _b, _c, _d, _e, sourceLanguage, _f, targetLanguage, _g, region, credentials, sourceLanguageCode, targetLanguageCode;
                return $ba7734d27d5a5ab3$var$__generator(this, function(_h) {
                    switch(_h.label){
                        case 0:
                            _a = this._config.translateText, _b = _a === void 0 ? {} : _a, _c = _b.defaults, _d = _c === void 0 ? {} : _c, _e = _d.sourceLanguage, sourceLanguage = _e === void 0 ? "" : _e, _f = _d.targetLanguage, targetLanguage = _f === void 0 ? "" : _f, _g = _b.region, region = _g === void 0 ? "" : _g;
                            if (!region) return [
                                2 /*return*/ ,
                                rej("region not configured for transcription")
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, $aCVDw.default).get()
                            ];
                        case 1:
                            credentials = _h.sent();
                            if (!credentials) return [
                                2 /*return*/ ,
                                rej("No credentials")
                            ];
                            sourceLanguageCode = input.translateText.source.language || sourceLanguage;
                            targetLanguageCode = input.translateText.targetLanguage || targetLanguage;
                            if (!sourceLanguageCode || !targetLanguageCode) return [
                                2 /*return*/ ,
                                rej("Please provide both source and target language")
                            ];
                            this.translate = new $gLVBK({
                                region: region,
                                credentials: credentials
                            });
                            this.translate.translateText({
                                SourceLanguageCode: sourceLanguageCode,
                                TargetLanguageCode: targetLanguageCode,
                                Text: input.translateText.source.text
                            }, function(err, data) {
                                $ba7734d27d5a5ab3$var$logger.debug({
                                    err: err,
                                    data: data
                                });
                                if (err) return rej(err);
                                else return res({
                                    text: data.TranslatedText,
                                    language: data.TargetLanguageCode
                                });
                            });
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    AmazonAIConvertPredictionsProvider.prototype.convertTextToSpeech = function(input) {
        var _this = this;
        return new Promise(function(res, rej) {
            return $ba7734d27d5a5ab3$var$__awaiter(_this, void 0, void 0, function() {
                var credentials, _a, _b, _c, _d, VoiceId, _e, region, voiceId;
                return $ba7734d27d5a5ab3$var$__generator(this, function(_f) {
                    switch(_f.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                (0, $aCVDw.default).get()
                            ];
                        case 1:
                            credentials = _f.sent();
                            if (!credentials) return [
                                2 /*return*/ ,
                                rej("No credentials")
                            ];
                            _a = this._config.speechGenerator, _b = _a === void 0 ? {} : _a, _c = _b.defaults, _d = (_c === void 0 ? {} : _c).VoiceId, VoiceId = _d === void 0 ? "" : _d, _e = _b.region, region = _e === void 0 ? "" : _e;
                            if (!input.textToSpeech.source) return [
                                2 /*return*/ ,
                                rej("Source needs to be provided in the input")
                            ];
                            voiceId = input.textToSpeech.voiceId || VoiceId;
                            if (!region) return [
                                2 /*return*/ ,
                                rej("Region was undefined. Did you enable speech generator using amplify CLI?")
                            ];
                            if (!voiceId) return [
                                2 /*return*/ ,
                                rej("VoiceId was undefined.")
                            ];
                            this.textToSpeech = new $4xsDJ({
                                region: region,
                                credentials: credentials
                            });
                            this.textToSpeech.synthesizeSpeech({
                                OutputFormat: "mp3",
                                Text: input.textToSpeech.source.text,
                                VoiceId: voiceId,
                                TextType: "text",
                                SampleRate: "24000"
                            }, function(err, data) {
                                if (err) rej(err);
                                else {
                                    var blob = new Blob([
                                        data.AudioStream
                                    ], {
                                        type: data.ContentType
                                    });
                                    var url = URL.createObjectURL(blob);
                                    res({
                                        speech: {
                                            url: url
                                        },
                                        audioStream: data.AudioStream.buffer,
                                        text: input.textToSpeech.source.text
                                    });
                                }
                            });
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    AmazonAIConvertPredictionsProvider.prototype.convertSpeechToText = function(input) {
        var _this = this;
        return new Promise(function(res, rej) {
            return $ba7734d27d5a5ab3$var$__awaiter(_this, void 0, void 0, function() {
                var credentials, _a, _b, _c, _d, languageCode, _e, region, _f, source, _g, language, connection, fullText, err_1, err_2;
                return $ba7734d27d5a5ab3$var$__generator(this, function(_h) {
                    switch(_h.label){
                        case 0:
                            _h.trys.push([
                                0,
                                7,
                                ,
                                8
                            ]);
                            $ba7734d27d5a5ab3$var$logger.debug("starting transcription..");
                            return [
                                4 /*yield*/ ,
                                (0, $aCVDw.default).get()
                            ];
                        case 1:
                            credentials = _h.sent();
                            if (!credentials) return [
                                2 /*return*/ ,
                                rej("No credentials")
                            ];
                            _a = this._config.transcription, _b = _a === void 0 ? {} : _a, _c = _b.defaults, _d = (_c === void 0 ? {} : _c).language, languageCode = _d === void 0 ? "" : _d, _e = _b.region, region = _e === void 0 ? "" : _e;
                            if (!region) return [
                                2 /*return*/ ,
                                rej("region not configured for transcription")
                            ];
                            if (!languageCode) return [
                                2 /*return*/ ,
                                rej("languageCode not configured or provided for transcription")
                            ];
                            _f = input.transcription, source = _f.source, _g = _f.language, language = _g === void 0 ? languageCode : _g;
                            if (!(0, $9dl3A.isBytesSource)(source)) return [
                                3 /*break*/ ,
                                6
                            ];
                            return [
                                4 /*yield*/ ,
                                this.openConnectionWithTranscribe({
                                    credentials: credentials,
                                    region: region,
                                    languageCode: language
                                })
                            ];
                        case 2:
                            connection = _h.sent();
                            _h.label = 3;
                        case 3:
                            _h.trys.push([
                                3,
                                5,
                                ,
                                6
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.sendDataToTranscribe({
                                    connection: connection,
                                    raw: source.bytes
                                })
                            ];
                        case 4:
                            fullText = _h.sent();
                            return [
                                2 /*return*/ ,
                                res({
                                    transcription: {
                                        fullText: fullText
                                    }
                                })
                            ];
                        case 5:
                            err_1 = _h.sent();
                            rej(err_1);
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 6:
                            return [
                                2 /*return*/ ,
                                rej("Source types other than byte source are not supported.")
                            ];
                        case 7:
                            err_2 = _h.sent();
                            return [
                                2 /*return*/ ,
                                rej(err_2.name + ": " + err_2.message)
                            ];
                        case 8:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    AmazonAIConvertPredictionsProvider.serializeDataFromTranscribe = function(message) {
        var decodedMessage = "";
        var transcribeMessage = $ba7734d27d5a5ab3$var$eventBuilder.unmarshall($ba7734d27d5a5ab3$require$Buffer.from(message.data));
        var transcribeMessageJson = JSON.parse(String.fromCharCode.apply(String, transcribeMessage.body));
        if (transcribeMessage.headers[":message-type"].value === "exception") {
            $ba7734d27d5a5ab3$var$logger.debug("exception", JSON.stringify(transcribeMessageJson.Message, null, 2));
            throw new Error(transcribeMessageJson.Message);
        } else if (transcribeMessage.headers[":message-type"].value === "event") {
            if (transcribeMessageJson.Transcript.Results.length > 0) {
                if (transcribeMessageJson.Transcript.Results[0].Alternatives.length > 0) {
                    if (transcribeMessageJson.Transcript.Results[0].Alternatives[0].Transcript.length > 0) {
                        if (transcribeMessageJson.Transcript.Results[0].IsPartial === false) {
                            decodedMessage = transcribeMessageJson.Transcript.Results[0].Alternatives[0].Transcript + "\n";
                            $ba7734d27d5a5ab3$var$logger.debug({
                                decodedMessage: decodedMessage
                            });
                        } else $ba7734d27d5a5ab3$var$logger.debug({
                            transcript: transcribeMessageJson.Transcript.Results[0].Alternatives[0]
                        });
                    }
                }
            }
        }
        return decodedMessage;
    };
    AmazonAIConvertPredictionsProvider.prototype.sendDataToTranscribe = function(_a) {
        var _this = this;
        var connection = _a.connection, raw = _a.raw;
        return new Promise(function(res, rej) {
            var fullText = "";
            connection.onmessage = function(message) {
                try {
                    var decodedMessage = AmazonAIConvertPredictionsProvider.serializeDataFromTranscribe(message);
                    if (decodedMessage) fullText += decodedMessage + " ";
                } catch (err) {
                    $ba7734d27d5a5ab3$var$logger.debug(err);
                    rej(err.message);
                }
            };
            connection.onerror = function(errorEvent) {
                $ba7734d27d5a5ab3$var$logger.debug({
                    errorEvent: errorEvent
                });
                rej("failed to transcribe, network error");
            };
            connection.onclose = function(closeEvent) {
                $ba7734d27d5a5ab3$var$logger.debug({
                    closeEvent: closeEvent
                });
                return res(fullText.trim());
            };
            $ba7734d27d5a5ab3$var$logger.debug({
                raw: raw
            });
            if (Array.isArray(raw)) for(var i = 0; i < raw.length - 1023; i += 1024){
                var data = raw.slice(i, i + 1024);
                _this.sendEncodedDataToTranscribe(connection, data);
            }
            // sending end frame
            var endFrameEventMessage = _this.getAudioEventMessage($ba7734d27d5a5ab3$require$Buffer.from([]));
            var endFrameBinary = $ba7734d27d5a5ab3$var$eventBuilder.marshall(endFrameEventMessage);
            connection.send(endFrameBinary);
        });
    };
    AmazonAIConvertPredictionsProvider.prototype.sendEncodedDataToTranscribe = function(connection, data) {
        var downsampledBuffer = this.downsampleBuffer({
            buffer: data
        });
        var pcmEncodedBuffer = this.pcmEncode(downsampledBuffer);
        var audioEventMessage = this.getAudioEventMessage($ba7734d27d5a5ab3$require$Buffer.from(pcmEncodedBuffer));
        var binary = $ba7734d27d5a5ab3$var$eventBuilder.marshall(audioEventMessage);
        connection.send(binary);
    };
    AmazonAIConvertPredictionsProvider.prototype.getAudioEventMessage = function(buffer) {
        var audioEventMessage = {
            body: buffer,
            headers: {
                ":message-type": {
                    type: "string",
                    value: "event"
                },
                ":event-type": {
                    type: "string",
                    value: "AudioEvent"
                }
            }
        };
        return audioEventMessage;
    };
    AmazonAIConvertPredictionsProvider.prototype.pcmEncode = function(input) {
        var offset = 0;
        var buffer = new ArrayBuffer(input.length * 2);
        var view = new DataView(buffer);
        for(var i = 0; i < input.length; i++, offset += 2){
            var s = Math.max(-1, Math.min(1, input[i]));
            view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
        }
        return buffer;
    };
    AmazonAIConvertPredictionsProvider.prototype.downsampleBuffer = function(_a) {
        var buffer = _a.buffer;
        if (this.outputSampleRate === this.inputSampleRate) return buffer;
        var sampleRateRatio = this.inputSampleRate / this.outputSampleRate;
        var newLength = Math.round(buffer.length / sampleRateRatio);
        var result = new Float32Array(newLength);
        var offsetResult = 0;
        var offsetBuffer = 0;
        while(offsetResult < result.length){
            var nextOffsetBuffer = Math.round((offsetResult + 1) * sampleRateRatio);
            var accum = 0, count = 0;
            for(var i = offsetBuffer; i < nextOffsetBuffer && i < buffer.length; i++){
                accum += buffer[i];
                count++;
            }
            result[offsetResult] = accum / count;
            offsetResult++;
            offsetBuffer = nextOffsetBuffer;
        }
        return result;
    };
    AmazonAIConvertPredictionsProvider.prototype.openConnectionWithTranscribe = function(_a) {
        var _this = this;
        var userCredentials = _a.credentials, region = _a.region, languageCode = _a.languageCode;
        return new Promise(function(res, rej) {
            return $ba7734d27d5a5ab3$var$__awaiter(_this, void 0, void 0, function() {
                var access_key, secret_key, session_token, credentials, signedUrl, connection;
                return $ba7734d27d5a5ab3$var$__generator(this, function(_a) {
                    access_key = userCredentials.accessKeyId, secret_key = userCredentials.secretAccessKey, session_token = userCredentials.sessionToken;
                    credentials = {
                        access_key: access_key,
                        secret_key: secret_key,
                        session_token: session_token
                    };
                    signedUrl = this.generateTranscribeUrl({
                        credentials: credentials,
                        region: region,
                        languageCode: languageCode
                    });
                    $ba7734d27d5a5ab3$var$logger.debug("connecting...");
                    connection = new WebSocket(signedUrl);
                    connection.binaryType = "arraybuffer";
                    connection.onopen = function() {
                        $ba7734d27d5a5ab3$var$logger.debug("connected");
                        res(connection);
                    };
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        });
    };
    AmazonAIConvertPredictionsProvider.prototype.generateTranscribeUrl = function(_a) {
        var credentials = _a.credentials, region = _a.region, languageCode = _a.languageCode;
        var url = [
            "wss://transcribestreaming." + region + ".amazonaws.com:8443",
            "/stream-transcription-websocket?",
            "media-encoding=pcm&",
            "sample-rate=16000&",
            "language-code=" + languageCode
        ].join("");
        var signedUrl = (0, $kP2rz.default).signUrl(url, credentials, {
            region: region,
            service: "transcribe"
        }, 300);
        return signedUrl;
    };
    return AmazonAIConvertPredictionsProvider;
}((0, $8yp7t.AbstractConvertPredictionsProvider));
var $ba7734d27d5a5ab3$export$2e2bcd8739ae039 = $ba7734d27d5a5ab3$var$AmazonAIConvertPredictionsProvider;

});
parcelRequire.register("8yp7t", function(module, exports) {

$parcel$export(module.exports, "AbstractConvertPredictionsProvider", function () { return $63a4fbe733f675fb$export$50413df91974829f; });

var $9dl3A = parcelRequire("9dl3A");
parcelRequire("eOV94");
var $rynSq = parcelRequire("rynSq");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $63a4fbe733f675fb$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $63a4fbe733f675fb$var$logger = new (0, $gBqCF.ConsoleLogger)("AbstractConvertPredictionsProvider");
var $63a4fbe733f675fb$export$50413df91974829f = /** @class */ function(_super) {
    $63a4fbe733f675fb$var$__extends(AbstractConvertPredictionsProvider, _super);
    function AbstractConvertPredictionsProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AbstractConvertPredictionsProvider.prototype.getCategory = function() {
        return "Convert";
    };
    AbstractConvertPredictionsProvider.prototype.convert = function(input) {
        if ((0, $9dl3A.isTranslateTextInput)(input)) {
            $63a4fbe733f675fb$var$logger.debug("translateText");
            return this.translateText(input);
        } else if ((0, $9dl3A.isTextToSpeechInput)(input)) {
            $63a4fbe733f675fb$var$logger.debug("textToSpeech");
            return this.convertTextToSpeech(input);
        } else if ((0, $9dl3A.isSpeechToTextInput)(input)) {
            $63a4fbe733f675fb$var$logger.debug("textToSpeech");
            return this.convertSpeechToText(input);
        }
    };
    AbstractConvertPredictionsProvider.prototype.translateText = function(translateTextInput) {
        throw new Error("convertText is not implemented by this provider");
    };
    AbstractConvertPredictionsProvider.prototype.convertTextToSpeech = function(textToSpeechInput) {
        throw new Error("convertTextToSpeech is not implemented by this provider");
    };
    AbstractConvertPredictionsProvider.prototype.convertSpeechToText = function(speechToTextInput) {
        throw new Error("convertSpeechToText is not implemented by this provider");
    };
    return AbstractConvertPredictionsProvider;
}((0, $rynSq.AbstractPredictionsProvider));

});
parcelRequire.register("9dl3A", function(module, exports) {

$parcel$export(module.exports, "InterpretTextCategories", function () { return $6b55a969e29593d9$export$38c1a43510654976; });
$parcel$export(module.exports, "isIdentifyFromCollection", function () { return $6b55a969e29593d9$export$fd90c6886b0e1f05; });
$parcel$export(module.exports, "isIdentifyCelebrities", function () { return $6b55a969e29593d9$export$2ae38404cc92d84c; });
$parcel$export(module.exports, "isTranslateTextInput", function () { return $6b55a969e29593d9$export$c8f41cfb5dcddca0; });
$parcel$export(module.exports, "isTextToSpeechInput", function () { return $6b55a969e29593d9$export$de525fdbb299954b; });
$parcel$export(module.exports, "isSpeechToTextInput", function () { return $6b55a969e29593d9$export$98e7f8da55e33c57; });
$parcel$export(module.exports, "isStorageSource", function () { return $6b55a969e29593d9$export$81f6c0d0154ea9b9; });
$parcel$export(module.exports, "isFileSource", function () { return $6b55a969e29593d9$export$3073f488d08e5f44; });
$parcel$export(module.exports, "isBytesSource", function () { return $6b55a969e29593d9$export$a6b66e283bd6737; });
$parcel$export(module.exports, "isIdentifyTextInput", function () { return $6b55a969e29593d9$export$7afcf55dfd05ab70; });
$parcel$export(module.exports, "isIdentifyLabelsInput", function () { return $6b55a969e29593d9$export$abade8c44e846210; });
$parcel$export(module.exports, "isIdentifyEntitiesInput", function () { return $6b55a969e29593d9$export$ae6e1e6fc3db4d20; });
$parcel$export(module.exports, "isInterpretTextInput", function () { return $6b55a969e29593d9$export$64c9e57a20e9da9d; });
/**
 * Convert types
 */ var $6b55a969e29593d9$export$38c1a43510654976;
(function(InterpretTextCategories) {
    InterpretTextCategories["ALL"] = "ALL";
    InterpretTextCategories["LANGUAGE"] = "LANGUAGE";
    InterpretTextCategories["ENTITIES"] = "ENTITIES";
    InterpretTextCategories["SENTIMENT"] = "SENTIMENT";
    InterpretTextCategories["SYNTAX"] = "SYNTAX";
    InterpretTextCategories["KEY_PHRASES"] = "KEY_PHRASES";
})($6b55a969e29593d9$export$38c1a43510654976 || ($6b55a969e29593d9$export$38c1a43510654976 = {}));
function $6b55a969e29593d9$export$fd90c6886b0e1f05(obj) {
    var key = "collection";
    var keyId = "collectionId";
    return obj && (obj.hasOwnProperty(key) || obj.hasOwnProperty(keyId));
}
function $6b55a969e29593d9$export$2ae38404cc92d84c(obj) {
    var key = "celebrityDetection";
    return obj && obj.hasOwnProperty(key);
}
function $6b55a969e29593d9$export$c8f41cfb5dcddca0(obj) {
    var key = "translateText";
    return obj && obj.hasOwnProperty(key);
}
function $6b55a969e29593d9$export$de525fdbb299954b(obj) {
    var key = "textToSpeech";
    return obj && obj.hasOwnProperty(key);
}
function $6b55a969e29593d9$export$98e7f8da55e33c57(obj) {
    var key = "transcription";
    return obj && obj.hasOwnProperty(key);
}
function $6b55a969e29593d9$export$81f6c0d0154ea9b9(obj) {
    var key = "key";
    return obj && obj.hasOwnProperty(key);
}
function $6b55a969e29593d9$export$3073f488d08e5f44(obj) {
    var key = "file";
    return obj && obj.hasOwnProperty(key);
}
function $6b55a969e29593d9$export$a6b66e283bd6737(obj) {
    var key = "bytes";
    return obj && obj.hasOwnProperty(key);
}
function $6b55a969e29593d9$export$7afcf55dfd05ab70(obj) {
    var key = "text";
    return obj && obj.hasOwnProperty(key);
}
function $6b55a969e29593d9$export$abade8c44e846210(obj) {
    var key = "labels";
    return obj && obj.hasOwnProperty(key);
}
function $6b55a969e29593d9$export$ae6e1e6fc3db4d20(obj) {
    var key = "entities";
    return obj && obj.hasOwnProperty(key);
}
function $6b55a969e29593d9$export$64c9e57a20e9da9d(obj) {
    var key = "text";
    return obj && obj.hasOwnProperty(key);
}

});

parcelRequire.register("eOV94", function(module, exports) {
$parcel$export(module.exports, "AbstractPredictionsProvider", function () { return (parcelRequire("rynSq")).AbstractPredictionsProvider; });
parcelRequire("rynSq");

var $8yp7t = parcelRequire("8yp7t");

var $c9o1I = parcelRequire("c9o1I");

var $12F2R = parcelRequire("12F2R");
$parcel$exportWildcard(module.exports, $8yp7t);
$parcel$exportWildcard(module.exports, $c9o1I);
$parcel$exportWildcard(module.exports, $12F2R);

});
parcelRequire.register("rynSq", function(module, exports) {

$parcel$export(module.exports, "AbstractPredictionsProvider", function () { return $052d31b2fbd60d13$export$3d778fb8d81de72d; });
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $052d31b2fbd60d13$var$logger = new (0, $gBqCF.ConsoleLogger)("Amplify");
var $052d31b2fbd60d13$export$3d778fb8d81de72d = /** @class */ function() {
    function AbstractPredictionsProvider() {}
    AbstractPredictionsProvider.prototype.configure = function(config) {
        $052d31b2fbd60d13$var$logger.debug("configure AbstractPredictionsProvider", {
            config: config
        });
        this._config = config;
        return config;
    };
    return AbstractPredictionsProvider;
}();

});

parcelRequire.register("c9o1I", function(module, exports) {

$parcel$export(module.exports, "AbstractIdentifyPredictionsProvider", function () { return $8d88f682549fd1fb$export$35dfa1f05ef0f082; });
parcelRequire("eOV94");
var $rynSq = parcelRequire("rynSq");

var $9dl3A = parcelRequire("9dl3A");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $8d88f682549fd1fb$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8d88f682549fd1fb$var$logger = new (0, $gBqCF.ConsoleLogger)("AbstractIdentifyPredictionsProvider");
var $8d88f682549fd1fb$export$35dfa1f05ef0f082 = /** @class */ function(_super) {
    $8d88f682549fd1fb$var$__extends(AbstractIdentifyPredictionsProvider, _super);
    function AbstractIdentifyPredictionsProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AbstractIdentifyPredictionsProvider.prototype.getCategory = function() {
        return "Identify";
    };
    AbstractIdentifyPredictionsProvider.prototype.identify = function(input) {
        if ((0, $9dl3A.isIdentifyTextInput)(input)) {
            $8d88f682549fd1fb$var$logger.debug("identifyText");
            return this.identifyText(input);
        } else if ((0, $9dl3A.isIdentifyLabelsInput)(input)) {
            $8d88f682549fd1fb$var$logger.debug("identifyLabels");
            return this.identifyLabels(input);
        } else if ((0, $9dl3A.isIdentifyEntitiesInput)(input)) {
            $8d88f682549fd1fb$var$logger.debug("identifyEntities");
            return this.identifyEntities(input);
        }
    };
    AbstractIdentifyPredictionsProvider.prototype.identifyText = function(input) {
        throw new Error("identifyText is not implemented by this provider.");
    };
    AbstractIdentifyPredictionsProvider.prototype.identifyLabels = function(input) {
        throw new Error("identifyLabels is not implemented by this provider");
    };
    AbstractIdentifyPredictionsProvider.prototype.identifyEntities = function(input) {
        throw new Error("identifyEntities is not implemented by this provider");
    };
    return AbstractIdentifyPredictionsProvider;
}((0, $rynSq.AbstractPredictionsProvider));

});

parcelRequire.register("12F2R", function(module, exports) {

$parcel$export(module.exports, "AbstractInterpretPredictionsProvider", function () { return $0c25d10a78bce943$export$15b471c09b280e9; });
parcelRequire("eOV94");
var $rynSq = parcelRequire("rynSq");

var $9dl3A = parcelRequire("9dl3A");
var $0c25d10a78bce943$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0c25d10a78bce943$export$15b471c09b280e9 = /** @class */ function(_super) {
    $0c25d10a78bce943$var$__extends(AbstractInterpretPredictionsProvider, _super);
    function AbstractInterpretPredictionsProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AbstractInterpretPredictionsProvider.prototype.getCategory = function() {
        return "Interpret";
    };
    AbstractInterpretPredictionsProvider.prototype.interpret = function(input) {
        if ((0, $9dl3A.isInterpretTextInput)(input)) return this.interpretText(input);
    };
    AbstractInterpretPredictionsProvider.prototype.interpretText = function(input) {
        throw new Error("interpretText is not implement by this provider");
    };
    return AbstractInterpretPredictionsProvider;
}((0, $rynSq.AbstractPredictionsProvider));

});



parcelRequire.register("gLVBK", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $c35db8daf53f51f2$var$Service = $dbC7k.Service;
var $c35db8daf53f51f2$var$apiLoader = $dbC7k.apiLoader;
$c35db8daf53f51f2$var$apiLoader.services["translate"] = {};
$dbC7k.Translate = $c35db8daf53f51f2$var$Service.defineService("translate", [
    "2017-07-01"
]);


Object.defineProperty($c35db8daf53f51f2$var$apiLoader.services["translate"], "2017-07-01", {
    get: function get() {
        var model = (parcelRequire("5pkjO"));
        model.paginators = (parcelRequire("eI23J")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Translate;

});
parcelRequire.register("5pkjO", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-07-01","endpointPrefix":"translate","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Translate","serviceId":"Translate","signatureVersion":"v4","signingName":"translate","targetPrefix":"AWSShineFrontendService_20170701","uid":"translate-2017-07-01"},"operations":{"DeleteTerminology":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"GetTerminology":{"input":{"type":"structure","required":["Name","TerminologyDataFormat"],"members":{"Name":{},"TerminologyDataFormat":{}}},"output":{"type":"structure","members":{"TerminologyProperties":{"shape":"S6"},"TerminologyDataLocation":{"type":"structure","required":["RepositoryType","Location"],"members":{"RepositoryType":{},"Location":{}}}}}},"ImportTerminology":{"input":{"type":"structure","required":["Name","MergeStrategy","TerminologyData"],"members":{"Name":{},"MergeStrategy":{},"Description":{},"TerminologyData":{"type":"structure","required":["File","Format"],"members":{"File":{"type":"blob","sensitive":true},"Format":{}}},"EncryptionKey":{"shape":"Sb"}}},"output":{"type":"structure","members":{"TerminologyProperties":{"shape":"S6"}}}},"ListTerminologies":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TerminologyPropertiesList":{"type":"list","member":{"shape":"S6"}},"NextToken":{}}}},"TranslateText":{"input":{"type":"structure","required":["Text","SourceLanguageCode","TargetLanguageCode"],"members":{"Text":{},"TerminologyNames":{"type":"list","member":{}},"SourceLanguageCode":{},"TargetLanguageCode":{}}},"output":{"type":"structure","required":["TranslatedText","SourceLanguageCode","TargetLanguageCode"],"members":{"TranslatedText":{},"SourceLanguageCode":{},"TargetLanguageCode":{},"AppliedTerminologies":{"type":"list","member":{"type":"structure","members":{"Name":{},"Terms":{"type":"list","member":{"type":"structure","members":{"SourceText":{},"TargetText":{}}}}}}}}}}},"shapes":{"S6":{"type":"structure","members":{"Name":{},"Description":{},"Arn":{},"SourceLanguageCode":{},"TargetLanguageCodes":{"type":"list","member":{}},"EncryptionKey":{"shape":"Sb"},"SizeBytes":{"type":"integer"},"TermCount":{"type":"integer"},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"}}},"Sb":{"type":"structure","required":["Type","Id"],"members":{"Type":{},"Id":{}}}}}');

});

parcelRequire.register("eI23J", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("4xsDJ", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $34e075beff47b0a5$var$Service = $dbC7k.Service;
var $34e075beff47b0a5$var$apiLoader = $dbC7k.apiLoader;
$34e075beff47b0a5$var$apiLoader.services["polly"] = {};
$dbC7k.Polly = $34e075beff47b0a5$var$Service.defineService("polly", [
    "2016-06-10"
]);
parcelRequire("jDXGD");


Object.defineProperty($34e075beff47b0a5$var$apiLoader.services["polly"], "2016-06-10", {
    get: function get() {
        var model = (parcelRequire("az40D"));
        model.paginators = (parcelRequire("1JER2")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Polly;

});
parcelRequire.register("jDXGD", function(module, exports) {
parcelRequire("fcoTw");

});
parcelRequire.register("fcoTw", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
var $b10b4986b51983b8$var$rest = $dbC7k.Protocol.Rest;
/**
 * A presigner object can be used to generate presigned urls for the Polly service.
 */ $dbC7k.Polly.Presigner = $dbC7k.util.inherit({
    /**
     * Creates a presigner object with a set of configuration options.
     *
     * @option options params [map] An optional map of parameters to bind to every
     *   request sent by this service object.
     * @option options service [AWS.Polly] An optional pre-configured instance
     *  of the AWS.Polly service object to use for requests. The object may
     *  bound parameters used by the presigner.
     * @see AWS.Polly.constructor
     */ constructor: function Signer(options) {
        options = options || {};
        this.options = options;
        this.service = options.service;
        this.bindServiceObject(options);
        this._operations = {};
    },
    /**
     * @api private
     */ bindServiceObject: function bindServiceObject(options) {
        options = options || {};
        if (!this.service) this.service = new $dbC7k.Polly(options);
        else {
            var config = $dbC7k.util.copy(this.service.config);
            this.service = new this.service.constructor.__super__(config);
            this.service.config.params = $dbC7k.util.merge(this.service.config.params || {}, options.params);
        }
    },
    /**
     * @api private
     */ modifyInputMembers: function modifyInputMembers(input) {
        // make copies of the input so we don't overwrite the api
        // need to be careful to copy anything we access/modify
        var modifiedInput = $dbC7k.util.copy(input);
        modifiedInput.members = $dbC7k.util.copy(input.members);
        $dbC7k.util.each(input.members, function(name, member) {
            modifiedInput.members[name] = $dbC7k.util.copy(member);
            // update location and locationName
            if (!member.location || member.location === "body") {
                modifiedInput.members[name].location = "querystring";
                modifiedInput.members[name].locationName = name;
            }
        });
        return modifiedInput;
    },
    /**
     * @api private
     */ convertPostToGet: function convertPostToGet(req) {
        // convert method
        req.httpRequest.method = "GET";
        var operation = req.service.api.operations[req.operation];
        // get cached operation input first
        var input = this._operations[req.operation];
        if (!input) // modify the original input
        this._operations[req.operation] = input = this.modifyInputMembers(operation.input);
        var uri = $b10b4986b51983b8$var$rest.generateURI(req.httpRequest.endpoint.path, operation.httpPath, input, req.params);
        req.httpRequest.path = uri;
        req.httpRequest.body = "";
        // don't need these headers on a GET request
        delete req.httpRequest.headers["Content-Length"];
        delete req.httpRequest.headers["Content-Type"];
    },
    /**
     * @overload getSynthesizeSpeechUrl(params = {}, [expires = 3600], [callback])
     *   Generate a presigned url for {AWS.Polly.synthesizeSpeech}.
     *   @note You must ensure that you have static or previously resolved
     *     credentials if you call this method synchronously (with no callback),
     *     otherwise it may not properly sign the request. If you cannot guarantee
     *     this (you are using an asynchronous credential provider, i.e., EC2
     *     IAM roles), you should always call this method with an asynchronous
     *     callback.
     *   @param params [map] parameters to pass to the operation. See the {AWS.Polly.synthesizeSpeech}
     *     operation for the expected operation parameters.
     *   @param expires [Integer] (3600) the number of seconds to expire the pre-signed URL operation in.
     *     Defaults to 1 hour.
     *   @return [string] if called synchronously (with no callback), returns the signed URL.
     *   @return [null] nothing is returned if a callback is provided.
     *   @callback callback function (err, url)
     *     If a callback is supplied, it is called when a signed URL has been generated.
     *     @param err [Error] the error object returned from the presigner.
     *     @param url [String] the signed URL.
     *   @see AWS.Polly.synthesizeSpeech
     */ getSynthesizeSpeechUrl: function getSynthesizeSpeechUrl(params, expires, callback) {
        var self = this;
        var request = this.service.makeRequest("synthesizeSpeech", params);
        // remove existing build listeners
        request.removeAllListeners("build");
        request.on("build", function(req) {
            self.convertPostToGet(req);
        });
        return request.presign(expires, callback);
    }
});

});


parcelRequire.register("az40D", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-06-10","endpointPrefix":"polly","protocol":"rest-json","serviceFullName":"Amazon Polly","serviceId":"Polly","signatureVersion":"v4","uid":"polly-2016-06-10"},"operations":{"DeleteLexicon":{"http":{"method":"DELETE","requestUri":"/v1/lexicons/{LexiconName}","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{"shape":"S2","location":"uri","locationName":"LexiconName"}}},"output":{"type":"structure","members":{}}},"DescribeVoices":{"http":{"method":"GET","requestUri":"/v1/voices","responseCode":200},"input":{"type":"structure","members":{"Engine":{"location":"querystring","locationName":"Engine"},"LanguageCode":{"location":"querystring","locationName":"LanguageCode"},"IncludeAdditionalLanguageCodes":{"location":"querystring","locationName":"IncludeAdditionalLanguageCodes","type":"boolean"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Voices":{"type":"list","member":{"type":"structure","members":{"Gender":{},"Id":{},"LanguageCode":{},"LanguageName":{},"Name":{},"AdditionalLanguageCodes":{"type":"list","member":{}},"SupportedEngines":{"type":"list","member":{}}}}},"NextToken":{}}}},"GetLexicon":{"http":{"method":"GET","requestUri":"/v1/lexicons/{LexiconName}","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{"shape":"S2","location":"uri","locationName":"LexiconName"}}},"output":{"type":"structure","members":{"Lexicon":{"type":"structure","members":{"Content":{},"Name":{"shape":"S2"}}},"LexiconAttributes":{"shape":"Sm"}}}},"GetSpeechSynthesisTask":{"http":{"method":"GET","requestUri":"/v1/synthesisTasks/{TaskId}","responseCode":200},"input":{"type":"structure","required":["TaskId"],"members":{"TaskId":{"location":"uri","locationName":"TaskId"}}},"output":{"type":"structure","members":{"SynthesisTask":{"shape":"Sv"}}}},"ListLexicons":{"http":{"method":"GET","requestUri":"/v1/lexicons","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Lexicons":{"type":"list","member":{"type":"structure","members":{"Name":{"shape":"S2"},"Attributes":{"shape":"Sm"}}}},"NextToken":{}}}},"ListSpeechSynthesisTasks":{"http":{"method":"GET","requestUri":"/v1/synthesisTasks","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"},"Status":{"location":"querystring","locationName":"Status"}}},"output":{"type":"structure","members":{"NextToken":{},"SynthesisTasks":{"type":"list","member":{"shape":"Sv"}}}}},"PutLexicon":{"http":{"method":"PUT","requestUri":"/v1/lexicons/{LexiconName}","responseCode":200},"input":{"type":"structure","required":["Name","Content"],"members":{"Name":{"shape":"S2","location":"uri","locationName":"LexiconName"},"Content":{}}},"output":{"type":"structure","members":{}}},"StartSpeechSynthesisTask":{"http":{"requestUri":"/v1/synthesisTasks","responseCode":200},"input":{"type":"structure","required":["OutputFormat","OutputS3BucketName","Text","VoiceId"],"members":{"Engine":{},"LanguageCode":{},"LexiconNames":{"shape":"S12"},"OutputFormat":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"SampleRate":{},"SnsTopicArn":{},"SpeechMarkTypes":{"shape":"S15"},"Text":{},"TextType":{},"VoiceId":{}}},"output":{"type":"structure","members":{"SynthesisTask":{"shape":"Sv"}}}},"SynthesizeSpeech":{"http":{"requestUri":"/v1/speech","responseCode":200},"input":{"type":"structure","required":["OutputFormat","Text","VoiceId"],"members":{"Engine":{},"LanguageCode":{},"LexiconNames":{"shape":"S12"},"OutputFormat":{},"SampleRate":{},"SpeechMarkTypes":{"shape":"S15"},"Text":{},"TextType":{},"VoiceId":{}}},"output":{"type":"structure","members":{"AudioStream":{"type":"blob","streaming":true},"ContentType":{"location":"header","locationName":"Content-Type"},"RequestCharacters":{"location":"header","locationName":"x-amzn-RequestCharacters","type":"integer"}},"payload":"AudioStream"}}},"shapes":{"S2":{"type":"string","sensitive":true},"Sm":{"type":"structure","members":{"Alphabet":{},"LanguageCode":{},"LastModified":{"type":"timestamp"},"LexiconArn":{},"LexemesCount":{"type":"integer"},"Size":{"type":"integer"}}},"Sv":{"type":"structure","members":{"Engine":{},"TaskId":{},"TaskStatus":{},"TaskStatusReason":{},"OutputUri":{},"CreationTime":{"type":"timestamp"},"RequestCharacters":{"type":"integer"},"SnsTopicArn":{},"LexiconNames":{"shape":"S12"},"OutputFormat":{},"SampleRate":{},"SpeechMarkTypes":{"shape":"S15"},"TextType":{},"VoiceId":{},"LanguageCode":{}}},"S12":{"type":"list","member":{"shape":"S2"}},"S15":{"type":"list","member":{}}}}');

});

parcelRequire.register("1JER2", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListSpeechSynthesisTasks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("j3ga8", function(module, exports) {
$parcel$export(module.exports, "InterpretTextCategories", function () { return (parcelRequire("9dl3A")).InterpretTextCategories; });
$parcel$export(module.exports, "isBytesSource", function () { return (parcelRequire("9dl3A")).isBytesSource; });
$parcel$export(module.exports, "isFileSource", function () { return (parcelRequire("9dl3A")).isFileSource; });
$parcel$export(module.exports, "isIdentifyCelebrities", function () { return (parcelRequire("9dl3A")).isIdentifyCelebrities; });
$parcel$export(module.exports, "isIdentifyFromCollection", function () { return (parcelRequire("9dl3A")).isIdentifyFromCollection; });
$parcel$export(module.exports, "isStorageSource", function () { return (parcelRequire("9dl3A")).isStorageSource; });
parcelRequire("9dl3A");

});

parcelRequire.register("hAJO1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5uGCL = parcelRequire("5uGCL");

$5uGCL.__exportStar((parcelRequire("cDYQI")), module.exports);

$5uGCL.__exportStar((parcelRequire("b7FSL")), module.exports);

});
parcelRequire.register("5uGCL", function(module, exports) {

$parcel$export(module.exports, "__exportStar", function () { return $4000d15f98cbd7ec$export$f33643c0debef087; });
$parcel$export(module.exports, "__values", function () { return $4000d15f98cbd7ec$export$19a8beecd37a4c45; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $4000d15f98cbd7ec$var$extendStatics = function(d, b) {
    $4000d15f98cbd7ec$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $4000d15f98cbd7ec$var$extendStatics(d, b);
};
function $4000d15f98cbd7ec$export$a8ba968b8961cb8a(d, b) {
    $4000d15f98cbd7ec$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $4000d15f98cbd7ec$export$18ce0697a983be9b = function() {
    $4000d15f98cbd7ec$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4000d15f98cbd7ec$export$18ce0697a983be9b.apply(this, arguments);
};
function $4000d15f98cbd7ec$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4000d15f98cbd7ec$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $4000d15f98cbd7ec$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $4000d15f98cbd7ec$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $4000d15f98cbd7ec$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $4000d15f98cbd7ec$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $4000d15f98cbd7ec$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $4000d15f98cbd7ec$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $4000d15f98cbd7ec$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $4000d15f98cbd7ec$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $4000d15f98cbd7ec$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($4000d15f98cbd7ec$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $4000d15f98cbd7ec$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $4000d15f98cbd7ec$export$10c90e4f7922046c(v) {
    return this instanceof $4000d15f98cbd7ec$export$10c90e4f7922046c ? (this.v = v, this) : new $4000d15f98cbd7ec$export$10c90e4f7922046c(v);
}
function $4000d15f98cbd7ec$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $4000d15f98cbd7ec$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $4000d15f98cbd7ec$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $4000d15f98cbd7ec$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $4000d15f98cbd7ec$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $4000d15f98cbd7ec$export$19a8beecd37a4c45 === "function" ? $4000d15f98cbd7ec$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $4000d15f98cbd7ec$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $4000d15f98cbd7ec$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $4000d15f98cbd7ec$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $4000d15f98cbd7ec$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $4000d15f98cbd7ec$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRequire.register("cDYQI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iCkXp = parcelRequire("iCkXp");

var $dgbyf = parcelRequire("dgbyf");

var $lNn7Z = parcelRequire("lNn7Z");
/**
 * A marshaller that can convert binary-packed event stream messages into
 * JavaScript objects and back again into their binary format.
 */ var $934853f228cae570$var$EventStreamMarshaller = /** @class */ function() {
    function EventStreamMarshaller(toUtf8, fromUtf8) {
        this.headerMarshaller = new $iCkXp.HeaderMarshaller(toUtf8, fromUtf8);
    }
    /**
     * Convert a structured JavaScript object with tagged headers into a binary
     * event stream message.
     */ EventStreamMarshaller.prototype.marshall = function(_a) {
        var rawHeaders = _a.headers, body = _a.body;
        var headers = this.headerMarshaller.format(rawHeaders);
        var length = headers.byteLength + body.byteLength + 16;
        var out = new Uint8Array(length);
        var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
        var checksum = new $lNn7Z.Crc32;
        // Format message
        view.setUint32(0, length, false);
        view.setUint32(4, headers.byteLength, false);
        view.setUint32(8, checksum.update(out.subarray(0, 8)).digest(), false);
        out.set(headers, 12);
        out.set(body, headers.byteLength + 12);
        // Write trailing message checksum
        view.setUint32(length - 4, checksum.update(out.subarray(8, length - 4)).digest(), false);
        return out;
    };
    /**
     * Convert a binary event stream message into a JavaScript object with an
     * opaque, binary body and tagged, parsed headers.
     */ EventStreamMarshaller.prototype.unmarshall = function(message) {
        var _a = $dgbyf.splitMessage(message), headers = _a.headers, body = _a.body;
        return {
            headers: this.headerMarshaller.parse(headers),
            body: body
        };
    };
    return EventStreamMarshaller;
}();
module.exports.EventStreamMarshaller = $934853f228cae570$var$EventStreamMarshaller;

});
parcelRequire.register("iCkXp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5uGCL = parcelRequire("5uGCL");

var $kLYmm = parcelRequire("kLYmm");

var $b7FSL = parcelRequire("b7FSL");
/**
 * @internal
 */ var $d8dc08400ab3a4e8$var$HeaderMarshaller = /** @class */ function() {
    function HeaderMarshaller(toUtf8, fromUtf8) {
        this.toUtf8 = toUtf8;
        this.fromUtf8 = fromUtf8;
    }
    HeaderMarshaller.prototype.format = function(headers) {
        var e_1, _a, e_2, _b;
        var chunks = [];
        try {
            for(var _c = $5uGCL.__values(Object.keys(headers)), _d = _c.next(); !_d.done; _d = _c.next()){
                var headerName = _d.value;
                var bytes = this.fromUtf8(headerName);
                chunks.push(Uint8Array.from([
                    bytes.byteLength
                ]), bytes, this.formatHeaderValue(headers[headerName]));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var out = new Uint8Array(chunks.reduce(function(carry, bytes) {
            return carry + bytes.byteLength;
        }, 0));
        var position = 0;
        try {
            for(var chunks_1 = $5uGCL.__values(chunks), chunks_1_1 = chunks_1.next(); !chunks_1_1.done; chunks_1_1 = chunks_1.next()){
                var chunk = chunks_1_1.value;
                out.set(chunk, position);
                position += chunk.byteLength;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (chunks_1_1 && !chunks_1_1.done && (_b = chunks_1.return)) _b.call(chunks_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return out;
    };
    HeaderMarshaller.prototype.formatHeaderValue = function(header) {
        switch(header.type){
            case "boolean":
                return Uint8Array.from([
                    header.value ? 0 /* boolTrue */  : 1 /* boolFalse */ 
                ]);
            case "byte":
                return Uint8Array.from([
                    2 /* byte */ ,
                    header.value
                ]);
            case "short":
                var shortView = new DataView(new ArrayBuffer(3));
                shortView.setUint8(0, 3 /* short */ );
                shortView.setInt16(1, header.value, false);
                return new Uint8Array(shortView.buffer);
            case "integer":
                var intView = new DataView(new ArrayBuffer(5));
                intView.setUint8(0, 4 /* integer */ );
                intView.setInt32(1, header.value, false);
                return new Uint8Array(intView.buffer);
            case "long":
                var longBytes = new Uint8Array(9);
                longBytes[0] = 5 /* long */ ;
                longBytes.set(header.value.bytes, 1);
                return longBytes;
            case "binary":
                var binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
                binView.setUint8(0, 6 /* byteArray */ );
                binView.setUint16(1, header.value.byteLength, false);
                var binBytes = new Uint8Array(binView.buffer);
                binBytes.set(header.value, 3);
                return binBytes;
            case "string":
                var utf8Bytes = this.fromUtf8(header.value);
                var strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
                strView.setUint8(0, 7 /* string */ );
                strView.setUint16(1, utf8Bytes.byteLength, false);
                var strBytes = new Uint8Array(strView.buffer);
                strBytes.set(utf8Bytes, 3);
                return strBytes;
            case "timestamp":
                var tsBytes = new Uint8Array(9);
                tsBytes[0] = 8 /* timestamp */ ;
                tsBytes.set($b7FSL.Int64.fromNumber(header.value.valueOf()).bytes, 1);
                return tsBytes;
            case "uuid":
                if (!$d8dc08400ab3a4e8$var$UUID_PATTERN.test(header.value)) throw new Error("Invalid UUID received: " + header.value);
                var uuidBytes = new Uint8Array(17);
                uuidBytes[0] = 9 /* uuid */ ;
                uuidBytes.set($kLYmm.fromHex(header.value.replace(/\-/g, "")), 1);
                return uuidBytes;
        }
    };
    HeaderMarshaller.prototype.parse = function(headers) {
        var out = {};
        var position = 0;
        while(position < headers.byteLength){
            var nameLength = headers.getUint8(position++);
            var name = this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, nameLength));
            position += nameLength;
            switch(headers.getUint8(position++)){
                case 0 /* boolTrue */ :
                    out[name] = {
                        type: $d8dc08400ab3a4e8$var$BOOLEAN_TAG,
                        value: true
                    };
                    break;
                case 1 /* boolFalse */ :
                    out[name] = {
                        type: $d8dc08400ab3a4e8$var$BOOLEAN_TAG,
                        value: false
                    };
                    break;
                case 2 /* byte */ :
                    out[name] = {
                        type: $d8dc08400ab3a4e8$var$BYTE_TAG,
                        value: headers.getInt8(position++)
                    };
                    break;
                case 3 /* short */ :
                    out[name] = {
                        type: $d8dc08400ab3a4e8$var$SHORT_TAG,
                        value: headers.getInt16(position, false)
                    };
                    position += 2;
                    break;
                case 4 /* integer */ :
                    out[name] = {
                        type: $d8dc08400ab3a4e8$var$INT_TAG,
                        value: headers.getInt32(position, false)
                    };
                    position += 4;
                    break;
                case 5 /* long */ :
                    out[name] = {
                        type: $d8dc08400ab3a4e8$var$LONG_TAG,
                        value: new $b7FSL.Int64(new Uint8Array(headers.buffer, headers.byteOffset + position, 8))
                    };
                    position += 8;
                    break;
                case 6 /* byteArray */ :
                    var binaryLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $d8dc08400ab3a4e8$var$BINARY_TAG,
                        value: new Uint8Array(headers.buffer, headers.byteOffset + position, binaryLength)
                    };
                    position += binaryLength;
                    break;
                case 7 /* string */ :
                    var stringLength = headers.getUint16(position, false);
                    position += 2;
                    out[name] = {
                        type: $d8dc08400ab3a4e8$var$STRING_TAG,
                        value: this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, stringLength))
                    };
                    position += stringLength;
                    break;
                case 8 /* timestamp */ :
                    out[name] = {
                        type: $d8dc08400ab3a4e8$var$TIMESTAMP_TAG,
                        value: new Date(new $b7FSL.Int64(new Uint8Array(headers.buffer, headers.byteOffset + position, 8)).valueOf())
                    };
                    position += 8;
                    break;
                case 9 /* uuid */ :
                    var uuidBytes = new Uint8Array(headers.buffer, headers.byteOffset + position, 16);
                    position += 16;
                    out[name] = {
                        type: $d8dc08400ab3a4e8$var$UUID_TAG,
                        value: $kLYmm.toHex(uuidBytes.subarray(0, 4)) + "-" + $kLYmm.toHex(uuidBytes.subarray(4, 6)) + "-" + $kLYmm.toHex(uuidBytes.subarray(6, 8)) + "-" + $kLYmm.toHex(uuidBytes.subarray(8, 10)) + "-" + $kLYmm.toHex(uuidBytes.subarray(10))
                    };
                    break;
                default:
                    throw new Error("Unrecognized header type tag");
            }
        }
        return out;
    };
    return HeaderMarshaller;
}();
module.exports.HeaderMarshaller = $d8dc08400ab3a4e8$var$HeaderMarshaller;
var $d8dc08400ab3a4e8$var$BOOLEAN_TAG = "boolean";
var $d8dc08400ab3a4e8$var$BYTE_TAG = "byte";
var $d8dc08400ab3a4e8$var$SHORT_TAG = "short";
var $d8dc08400ab3a4e8$var$INT_TAG = "integer";
var $d8dc08400ab3a4e8$var$LONG_TAG = "long";
var $d8dc08400ab3a4e8$var$BINARY_TAG = "binary";
var $d8dc08400ab3a4e8$var$STRING_TAG = "string";
var $d8dc08400ab3a4e8$var$TIMESTAMP_TAG = "timestamp";
var $d8dc08400ab3a4e8$var$UUID_TAG = "uuid";
var $d8dc08400ab3a4e8$var$UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;

});
parcelRequire.register("kLYmm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f1f7049dc71ff801$var$SHORT_TO_HEX = {};
var $f1f7049dc71ff801$var$HEX_TO_SHORT = {};
for(var $f1f7049dc71ff801$var$i = 0; $f1f7049dc71ff801$var$i < 256; $f1f7049dc71ff801$var$i++){
    var $f1f7049dc71ff801$var$encodedByte = $f1f7049dc71ff801$var$i.toString(16).toLowerCase();
    if ($f1f7049dc71ff801$var$encodedByte.length === 1) $f1f7049dc71ff801$var$encodedByte = "0" + $f1f7049dc71ff801$var$encodedByte;
    $f1f7049dc71ff801$var$SHORT_TO_HEX[$f1f7049dc71ff801$var$i] = $f1f7049dc71ff801$var$encodedByte;
    $f1f7049dc71ff801$var$HEX_TO_SHORT[$f1f7049dc71ff801$var$encodedByte] = $f1f7049dc71ff801$var$i;
}
/**
 * Converts a hexadecimal encoded string to a Uint8Array of bytes.
 *
 * @param encoded The hexadecimal encoded string
 */ function $f1f7049dc71ff801$var$fromHex(encoded) {
    if (encoded.length % 2 !== 0) throw new Error("Hex encoded strings must have an even number length");
    var out = new Uint8Array(encoded.length / 2);
    for(var i = 0; i < encoded.length; i += 2){
        var encodedByte = encoded.substr(i, 2).toLowerCase();
        if (encodedByte in $f1f7049dc71ff801$var$HEX_TO_SHORT) out[i / 2] = $f1f7049dc71ff801$var$HEX_TO_SHORT[encodedByte];
        else throw new Error("Cannot decode unrecognized sequence " + encodedByte + " as hexadecimal");
    }
    return out;
}
module.exports.fromHex = $f1f7049dc71ff801$var$fromHex;
/**
 * Converts a Uint8Array of binary data to a hexadecimal encoded string.
 *
 * @param bytes The binary data to encode
 */ function $f1f7049dc71ff801$var$toHex(bytes) {
    var out = "";
    for(var i = 0; i < bytes.byteLength; i++)out += $f1f7049dc71ff801$var$SHORT_TO_HEX[bytes[i]];
    return out;
}
module.exports.toHex = $f1f7049dc71ff801$var$toHex;

});

parcelRequire.register("b7FSL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kLYmm = parcelRequire("kLYmm");
/**
 * A lossless representation of a signed, 64-bit integer. Instances of this
 * class may be used in arithmetic expressions as if they were numeric
 * primitives, but the binary representation will be preserved unchanged as the
 * `bytes` property of the object. The bytes should be encoded as big-endian,
 * two's complement integers.
 */ var $8190d616b817f0e3$var$Int64 = /** @class */ function() {
    function Int64(bytes) {
        this.bytes = bytes;
        if (bytes.byteLength !== 8) throw new Error("Int64 buffers must be exactly 8 bytes");
    }
    Int64.fromNumber = function(number) {
        if (number > 9223372036854775807 || number < -9223372036854776000) throw new Error(number + " is too large (or, if negative, too small) to represent as an Int64");
        var bytes = new Uint8Array(8);
        for(var i = 7, remaining = Math.abs(Math.round(number)); i > -1 && remaining > 0; i--, remaining /= 256)bytes[i] = remaining;
        if (number < 0) $8190d616b817f0e3$var$negate(bytes);
        return new Int64(bytes);
    };
    /**
     * Called implicitly by infix arithmetic operators.
     */ Int64.prototype.valueOf = function() {
        var bytes = this.bytes.slice(0);
        var negative = bytes[0] & 128;
        if (negative) $8190d616b817f0e3$var$negate(bytes);
        return parseInt($kLYmm.toHex(bytes), 16) * (negative ? -1 : 1);
    };
    Int64.prototype.toString = function() {
        return String(this.valueOf());
    };
    return Int64;
}();
module.exports.Int64 = $8190d616b817f0e3$var$Int64;
function $8190d616b817f0e3$var$negate(bytes) {
    for(var i = 0; i < 8; i++)bytes[i] ^= 0xFF;
    for(var i = 7; i > -1; i--){
        bytes[i]++;
        if (bytes[i] !== 0) break;
    }
}

});


parcelRequire.register("dgbyf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lNn7Z = parcelRequire("lNn7Z");
// All prelude components are unsigned, 32-bit integers
var $9a75baddd430f916$var$PRELUDE_MEMBER_LENGTH = 4;
// The prelude consists of two components
var $9a75baddd430f916$var$PRELUDE_LENGTH = $9a75baddd430f916$var$PRELUDE_MEMBER_LENGTH * 2;
// Checksums are always CRC32 hashes.
var $9a75baddd430f916$var$CHECKSUM_LENGTH = 4;
// Messages must include a full prelude, a prelude checksum, and a message checksum
var $9a75baddd430f916$var$MINIMUM_MESSAGE_LENGTH = $9a75baddd430f916$var$PRELUDE_LENGTH + $9a75baddd430f916$var$CHECKSUM_LENGTH * 2;
/**
 * @internal
 */ function $9a75baddd430f916$var$splitMessage(_a) {
    var byteLength = _a.byteLength, byteOffset = _a.byteOffset, buffer = _a.buffer;
    if (byteLength < $9a75baddd430f916$var$MINIMUM_MESSAGE_LENGTH) throw new Error("Provided message too short to accommodate event stream message overhead");
    var view = new DataView(buffer, byteOffset, byteLength);
    var messageLength = view.getUint32(0, false);
    if (byteLength !== messageLength) throw new Error("Reported message length does not match received message length");
    var headerLength = view.getUint32($9a75baddd430f916$var$PRELUDE_MEMBER_LENGTH, false);
    var expectedPreludeChecksum = view.getUint32($9a75baddd430f916$var$PRELUDE_LENGTH, false);
    var expectedMessageChecksum = view.getUint32(byteLength - $9a75baddd430f916$var$CHECKSUM_LENGTH, false);
    var checksummer = (new $lNn7Z.Crc32).update(new Uint8Array(buffer, byteOffset, $9a75baddd430f916$var$PRELUDE_LENGTH));
    if (expectedPreludeChecksum !== checksummer.digest()) throw new Error("The prelude checksum specified in the message (" + expectedPreludeChecksum + ") does not match the calculated CRC32 checksum (" + checksummer.digest() + ")");
    checksummer.update(new Uint8Array(buffer, byteOffset + $9a75baddd430f916$var$PRELUDE_LENGTH, byteLength - ($9a75baddd430f916$var$PRELUDE_LENGTH + $9a75baddd430f916$var$CHECKSUM_LENGTH)));
    if (expectedMessageChecksum !== checksummer.digest()) throw new Error("The message checksum (" + checksummer.digest() + ") did not match the expected value of " + expectedMessageChecksum);
    return {
        headers: new DataView(buffer, byteOffset + $9a75baddd430f916$var$PRELUDE_LENGTH + $9a75baddd430f916$var$CHECKSUM_LENGTH, headerLength),
        body: new Uint8Array(buffer, byteOffset + $9a75baddd430f916$var$PRELUDE_LENGTH + $9a75baddd430f916$var$CHECKSUM_LENGTH + headerLength, messageLength - headerLength - ($9a75baddd430f916$var$PRELUDE_LENGTH + $9a75baddd430f916$var$CHECKSUM_LENGTH + $9a75baddd430f916$var$CHECKSUM_LENGTH))
    };
}
module.exports.splitMessage = $9a75baddd430f916$var$splitMessage;

});
parcelRequire.register("lNn7Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8Wr76 = parcelRequire("8Wr76");
function $fde01d4979a08f93$var$crc32(data) {
    return (new $fde01d4979a08f93$var$Crc32).update(data).digest();
}
module.exports.crc32 = $fde01d4979a08f93$var$crc32;
var $fde01d4979a08f93$var$Crc32 = /** @class */ function() {
    function Crc32() {
        this.checksum = 0xffffffff;
    }
    Crc32.prototype.update = function(data) {
        var e_1, _a;
        try {
            for(var data_1 = $8Wr76.__values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()){
                var byte = data_1_1.value;
                this.checksum = this.checksum >>> 8 ^ $fde01d4979a08f93$var$lookupTable[(this.checksum ^ byte) & 0xff];
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    Crc32.prototype.digest = function() {
        return (this.checksum ^ 0xffffffff) >>> 0;
    };
    return Crc32;
}();
module.exports.Crc32 = $fde01d4979a08f93$var$Crc32;
var $fde01d4979a08f93$var$lookupTable = Uint32Array.from([
    0x00000000,
    0x77073096,
    0xEE0E612C,
    0x990951BA,
    0x076DC419,
    0x706AF48F,
    0xE963A535,
    0x9E6495A3,
    0x0EDB8832,
    0x79DCB8A4,
    0xE0D5E91E,
    0x97D2D988,
    0x09B64C2B,
    0x7EB17CBD,
    0xE7B82D07,
    0x90BF1D91,
    0x1DB71064,
    0x6AB020F2,
    0xF3B97148,
    0x84BE41DE,
    0x1ADAD47D,
    0x6DDDE4EB,
    0xF4D4B551,
    0x83D385C7,
    0x136C9856,
    0x646BA8C0,
    0xFD62F97A,
    0x8A65C9EC,
    0x14015C4F,
    0x63066CD9,
    0xFA0F3D63,
    0x8D080DF5,
    0x3B6E20C8,
    0x4C69105E,
    0xD56041E4,
    0xA2677172,
    0x3C03E4D1,
    0x4B04D447,
    0xD20D85FD,
    0xA50AB56B,
    0x35B5A8FA,
    0x42B2986C,
    0xDBBBC9D6,
    0xACBCF940,
    0x32D86CE3,
    0x45DF5C75,
    0xDCD60DCF,
    0xABD13D59,
    0x26D930AC,
    0x51DE003A,
    0xC8D75180,
    0xBFD06116,
    0x21B4F4B5,
    0x56B3C423,
    0xCFBA9599,
    0xB8BDA50F,
    0x2802B89E,
    0x5F058808,
    0xC60CD9B2,
    0xB10BE924,
    0x2F6F7C87,
    0x58684C11,
    0xC1611DAB,
    0xB6662D3D,
    0x76DC4190,
    0x01DB7106,
    0x98D220BC,
    0xEFD5102A,
    0x71B18589,
    0x06B6B51F,
    0x9FBFE4A5,
    0xE8B8D433,
    0x7807C9A2,
    0x0F00F934,
    0x9609A88E,
    0xE10E9818,
    0x7F6A0DBB,
    0x086D3D2D,
    0x91646C97,
    0xE6635C01,
    0x6B6B51F4,
    0x1C6C6162,
    0x856530D8,
    0xF262004E,
    0x6C0695ED,
    0x1B01A57B,
    0x8208F4C1,
    0xF50FC457,
    0x65B0D9C6,
    0x12B7E950,
    0x8BBEB8EA,
    0xFCB9887C,
    0x62DD1DDF,
    0x15DA2D49,
    0x8CD37CF3,
    0xFBD44C65,
    0x4DB26158,
    0x3AB551CE,
    0xA3BC0074,
    0xD4BB30E2,
    0x4ADFA541,
    0x3DD895D7,
    0xA4D1C46D,
    0xD3D6F4FB,
    0x4369E96A,
    0x346ED9FC,
    0xAD678846,
    0xDA60B8D0,
    0x44042D73,
    0x33031DE5,
    0xAA0A4C5F,
    0xDD0D7CC9,
    0x5005713C,
    0x270241AA,
    0xBE0B1010,
    0xC90C2086,
    0x5768B525,
    0x206F85B3,
    0xB966D409,
    0xCE61E49F,
    0x5EDEF90E,
    0x29D9C998,
    0xB0D09822,
    0xC7D7A8B4,
    0x59B33D17,
    0x2EB40D81,
    0xB7BD5C3B,
    0xC0BA6CAD,
    0xEDB88320,
    0x9ABFB3B6,
    0x03B6E20C,
    0x74B1D29A,
    0xEAD54739,
    0x9DD277AF,
    0x04DB2615,
    0x73DC1683,
    0xE3630B12,
    0x94643B84,
    0x0D6D6A3E,
    0x7A6A5AA8,
    0xE40ECF0B,
    0x9309FF9D,
    0x0A00AE27,
    0x7D079EB1,
    0xF00F9344,
    0x8708A3D2,
    0x1E01F268,
    0x6906C2FE,
    0xF762575D,
    0x806567CB,
    0x196C3671,
    0x6E6B06E7,
    0xFED41B76,
    0x89D32BE0,
    0x10DA7A5A,
    0x67DD4ACC,
    0xF9B9DF6F,
    0x8EBEEFF9,
    0x17B7BE43,
    0x60B08ED5,
    0xD6D6A3E8,
    0xA1D1937E,
    0x38D8C2C4,
    0x4FDFF252,
    0xD1BB67F1,
    0xA6BC5767,
    0x3FB506DD,
    0x48B2364B,
    0xD80D2BDA,
    0xAF0A1B4C,
    0x36034AF6,
    0x41047A60,
    0xDF60EFC3,
    0xA867DF55,
    0x316E8EEF,
    0x4669BE79,
    0xCB61B38C,
    0xBC66831A,
    0x256FD2A0,
    0x5268E236,
    0xCC0C7795,
    0xBB0B4703,
    0x220216B9,
    0x5505262F,
    0xC5BA3BBE,
    0xB2BD0B28,
    0x2BB45A92,
    0x5CB36A04,
    0xC2D7FFA7,
    0xB5D0CF31,
    0x2CD99E8B,
    0x5BDEAE1D,
    0x9B64C2B0,
    0xEC63F226,
    0x756AA39C,
    0x026D930A,
    0x9C0906A9,
    0xEB0E363F,
    0x72076785,
    0x05005713,
    0x95BF4A82,
    0xE2B87A14,
    0x7BB12BAE,
    0x0CB61B38,
    0x92D28E9B,
    0xE5D5BE0D,
    0x7CDCEFB7,
    0x0BDBDF21,
    0x86D3D2D4,
    0xF1D4E242,
    0x68DDB3F8,
    0x1FDA836E,
    0x81BE16CD,
    0xF6B9265B,
    0x6FB077E1,
    0x18B74777,
    0x88085AE6,
    0xFF0F6A70,
    0x66063BCA,
    0x11010B5C,
    0x8F659EFF,
    0xF862AE69,
    0x616BFFD3,
    0x166CCF45,
    0xA00AE278,
    0xD70DD2EE,
    0x4E048354,
    0x3903B3C2,
    0xA7672661,
    0xD06016F7,
    0x4969474D,
    0x3E6E77DB,
    0xAED16A4A,
    0xD9D65ADC,
    0x40DF0B66,
    0x37D83BF0,
    0xA9BCAE53,
    0xDEBB9EC5,
    0x47B2CF7F,
    0x30B5FFE9,
    0xBDBDF21C,
    0xCABAC28A,
    0x53B39330,
    0x24B4A3A6,
    0xBAD03605,
    0xCDD70693,
    0x54DE5729,
    0x23D967BF,
    0xB3667A2E,
    0xC4614AB8,
    0x5D681B02,
    0x2A6F2B94,
    0xB40BBE37,
    0xC30C8EA1,
    0x5A05DF1B,
    0x2D02EF8D
]);

});
parcelRequire.register("8Wr76", function(module, exports) {

$parcel$export(module.exports, "__values", function () { return $6828c5b52ba3c7e0$export$19a8beecd37a4c45; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $6828c5b52ba3c7e0$var$extendStatics = function(d, b) {
    $6828c5b52ba3c7e0$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $6828c5b52ba3c7e0$var$extendStatics(d, b);
};
function $6828c5b52ba3c7e0$export$a8ba968b8961cb8a(d, b) {
    $6828c5b52ba3c7e0$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $6828c5b52ba3c7e0$export$18ce0697a983be9b = function() {
    $6828c5b52ba3c7e0$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6828c5b52ba3c7e0$export$18ce0697a983be9b.apply(this, arguments);
};
function $6828c5b52ba3c7e0$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6828c5b52ba3c7e0$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $6828c5b52ba3c7e0$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $6828c5b52ba3c7e0$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $6828c5b52ba3c7e0$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $6828c5b52ba3c7e0$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $6828c5b52ba3c7e0$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $6828c5b52ba3c7e0$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $6828c5b52ba3c7e0$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $6828c5b52ba3c7e0$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $6828c5b52ba3c7e0$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($6828c5b52ba3c7e0$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $6828c5b52ba3c7e0$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $6828c5b52ba3c7e0$export$10c90e4f7922046c(v) {
    return this instanceof $6828c5b52ba3c7e0$export$10c90e4f7922046c ? (this.v = v, this) : new $6828c5b52ba3c7e0$export$10c90e4f7922046c(v);
}
function $6828c5b52ba3c7e0$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $6828c5b52ba3c7e0$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $6828c5b52ba3c7e0$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $6828c5b52ba3c7e0$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $6828c5b52ba3c7e0$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $6828c5b52ba3c7e0$export$19a8beecd37a4c45 === "function" ? $6828c5b52ba3c7e0$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $6828c5b52ba3c7e0$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $6828c5b52ba3c7e0$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $6828c5b52ba3c7e0$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $6828c5b52ba3c7e0$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $6828c5b52ba3c7e0$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});





parcelRequire.register("706Xw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aJuUX = parcelRequire("aJuUX");
function $518dee69dc05a2b7$var$fromUtf8(input) {
    var buf = $aJuUX.fromString(input, "utf8");
    return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength / Uint8Array.BYTES_PER_ELEMENT);
}
module.exports.fromUtf8 = $518dee69dc05a2b7$var$fromUtf8;
function $518dee69dc05a2b7$var$toUtf8(input) {
    return $aJuUX.fromArrayBuffer(input.buffer, input.byteOffset, input.byteLength).toString("utf8");
}
module.exports.toUtf8 = $518dee69dc05a2b7$var$toUtf8;

});
parcelRequire.register("aJuUX", function(module, exports) {

var $e67mm = parcelRequire("e67mm");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5oOz5 = parcelRequire("5oOz5");

var $51ZBv = parcelRequire("51ZBv");
function $7d0616f04387cc05$var$fromArrayBuffer(input, offset, length) {
    if (offset === void 0) offset = 0;
    if (length === void 0) length = input.byteLength - offset;
    if (!$51ZBv.isArrayBuffer(input)) throw new Error("argument passed to fromArrayBuffer was not an ArrayBuffer");
    if (typeof $5oOz5.Buffer.from === "function" && $5oOz5.Buffer.from !== Uint8Array.from) return $5oOz5.Buffer.from(input, offset, length);
    // Any version of node that supports the optional offset and length
    // parameters, which were added in Node 6.0.0, will support Buffer.from and
    // have already returned. Throw if offset is not 0 or if length differs from
    // the underlying buffer's length.
    if (offset !== 0 || length !== input.byteLength) throw new Error("Unable to convert TypedArray to Buffer in Node " + $e67mm.version);
    return new $5oOz5.Buffer(input);
}
module.exports.fromArrayBuffer = $7d0616f04387cc05$var$fromArrayBuffer;
function $7d0616f04387cc05$var$fromString(input, encoding) {
    if (typeof input !== "string") throw new Error("argument passed to fromString was not a string");
    if (typeof $5oOz5.Buffer.from === "function" && $5oOz5.Buffer.from !== Uint8Array.from) return $5oOz5.Buffer.from(input, encoding);
    return new $5oOz5.Buffer(input, encoding);
}
module.exports.fromString = $7d0616f04387cc05$var$fromString;

});
parcelRequire.register("51ZBv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $3a9cd504cadf1e6f$var$isArrayBuffer(arg) {
    return typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
}
module.exports.isArrayBuffer = $3a9cd504cadf1e6f$var$isArrayBuffer;

});




parcelRequire.register("1B2FB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $129b516158905bcd$export$2e2bcd8739ae039; });
parcelRequire("2hWDt");
var $aCVDw = parcelRequire("aCVDw");

var $axy8Q = parcelRequire("axy8Q");
parcelRequire("eOV94");
var $c9o1I = parcelRequire("c9o1I");

var $1Z7n0 = parcelRequire("1Z7n0");
parcelRequire("j3ga8");
var $9dl3A = parcelRequire("9dl3A");

var $54Djg = parcelRequire("54Djg");

var $8Clxz = parcelRequire("8Clxz");

var $51H3M = parcelRequire("51H3M");
var $129b516158905bcd$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $129b516158905bcd$var$__assign = undefined && undefined.__assign || function() {
    $129b516158905bcd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $129b516158905bcd$var$__assign.apply(this, arguments);
};
var $129b516158905bcd$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $129b516158905bcd$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $129b516158905bcd$var$AmazonAIIdentifyPredictionsProvider = /** @class */ function(_super) {
    $129b516158905bcd$var$__extends(AmazonAIIdentifyPredictionsProvider, _super);
    function AmazonAIIdentifyPredictionsProvider() {
        return _super.call(this) || this;
    }
    AmazonAIIdentifyPredictionsProvider.prototype.getProviderName = function() {
        return "AmazonAIIdentifyPredictionsProvider";
    };
    /**
     * Verify user input source and converts it into source object readable by Rekognition and Textract.
     * Note that Rekognition and Textract use the same source interface, so we need not worry about types.
     * @param {IdentifySource} source - User input source that directs to the object user wants
     * to identify (storage, file, or bytes).
     * @return {Promise<Rekognition.Image>} - Promise resolving to the converted source object.
     */ AmazonAIIdentifyPredictionsProvider.prototype.configureSource = function(source) {
        return new Promise(function(res, rej) {
            if ((0, $9dl3A.isStorageSource)(source)) {
                var storageConfig = {
                    level: source.level,
                    identityId: source.identityId
                };
                (0, $axy8Q.default).get(source.key, storageConfig).then(function(url) {
                    var parser = /https:\/\/([a-zA-Z0-9%-_.]+)\.s3\.[A-Za-z0-9%-._~]+\/([a-zA-Z0-9%-._~/]+)\?/;
                    var parsedURL = url.match(parser);
                    if (parsedURL.length < 3) rej("Invalid S3 key was given.");
                    res({
                        S3Object: {
                            Bucket: parsedURL[1],
                            Name: parsedURL[2]
                        }
                    });
                }).catch(function(err) {
                    return rej(err);
                });
            } else if ((0, $9dl3A.isFileSource)(source)) (0, $8Clxz.blobToArrayBuffer)(source.file).then(function(buffer) {
                res({
                    Bytes: buffer
                });
            }).catch(function(err) {
                return rej(err);
            });
            else if ((0, $9dl3A.isBytesSource)(source)) {
                var bytes = source.bytes;
                if (bytes instanceof Blob) (0, $8Clxz.blobToArrayBuffer)(bytes).then(function(buffer) {
                    res({
                        Bytes: buffer
                    });
                }).catch(function(err) {
                    return rej(err);
                });
                // everything else can be directly passed to Rekognition / Textract.
                res({
                    Bytes: bytes
                });
            } else rej("Input source is not configured correctly.");
        });
    };
    /**
     * Recognize text from real-world images and documents (plain text, forms and tables). Detects text in the input
     * image and converts it into machine-readable text.
     * @param {IdentifySource} source - Object containing the source image and feature types to analyze.
     * @return {Promise<IdentifyTextOutput>} - Promise resolving to object containing identified texts.
     */ AmazonAIIdentifyPredictionsProvider.prototype.identifyText = function(input) {
        var _this = this;
        return new Promise(function(res, rej) {
            return $129b516158905bcd$var$__awaiter(_this, void 0, void 0, function() {
                var credentials, _a, _b, _c, region, _d, _e, configFormat, inputDocument, format, featureTypes, textractParam_1, rekognitionParam, param;
                var _this = this;
                return $129b516158905bcd$var$__generator(this, function(_f) {
                    switch(_f.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                (0, $aCVDw.default).get()
                            ];
                        case 1:
                            credentials = _f.sent();
                            if (!credentials) return [
                                2 /*return*/ ,
                                rej("No credentials")
                            ];
                            _a = this._config.identifyText, _b = _a === void 0 ? {} : _a, _c = _b.region, region = _c === void 0 ? "" : _c, _d = _b.defaults, _e = (_d === void 0 ? {} : _d).format, configFormat = _e === void 0 ? "PLAIN" : _e;
                            this.rekognition = new $1Z7n0({
                                region: region,
                                credentials: credentials
                            });
                            this.textract = new $54Djg({
                                region: region,
                                credentials: credentials
                            });
                            return [
                                4 /*yield*/ ,
                                this.configureSource(input.text.source).then(function(data) {
                                    return inputDocument = data;
                                }).catch(function(err) {
                                    rej(err);
                                })
                            ];
                        case 2:
                            _f.sent();
                            format = input.text.format || configFormat;
                            featureTypes = [];
                            if (format === "FORM" || format === "ALL") featureTypes.push("FORMS");
                            if (format === "TABLE" || format === "ALL") featureTypes.push("TABLES");
                            if (featureTypes.length === 0) {
                                textractParam_1 = {
                                    Document: inputDocument
                                };
                                rekognitionParam = {
                                    Image: inputDocument
                                };
                                this.rekognition.detectText(rekognitionParam, function(rekognitionErr, rekognitionData) {
                                    if (rekognitionErr) return rej(rekognitionErr);
                                    var rekognitionResponse = (0, $51H3M.categorizeRekognitionBlocks)(rekognitionData.TextDetections);
                                    if (rekognitionResponse.text.words.length < 50) // did not hit the word limit, return the data
                                    return res(rekognitionResponse);
                                    _this.textract.detectDocumentText(textractParam_1, function(textractErr, textractData) {
                                        if (textractErr) return rej(textractErr);
                                        // use the service that identified more texts.
                                        if (rekognitionData.TextDetections.length > textractData.Blocks.length) return res(rekognitionResponse);
                                        else return res((0, $51H3M.categorizeTextractBlocks)(textractData.Blocks));
                                    });
                                });
                            } else {
                                param = {
                                    Document: inputDocument,
                                    FeatureTypes: featureTypes
                                };
                                this.textract.analyzeDocument(param, function(err, data) {
                                    if (err) return rej(err);
                                    var blocks = data.Blocks;
                                    res((0, $51H3M.categorizeTextractBlocks)(blocks));
                                });
                            }
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    /**
     * Identify instances of real world entities from an image and if it contains unsafe content.
     * @param {IdentifyLabelsInput} input - Object containing the source image and entity type to identify.
     * @return {Promise<IdentifyLabelsOutput>} - Promise resolving to an array of identified entities.
     */ AmazonAIIdentifyPredictionsProvider.prototype.identifyLabels = function(input) {
        var _this = this;
        return new Promise(function(res, rej) {
            return $129b516158905bcd$var$__awaiter(_this, void 0, void 0, function() {
                var credentials, _a, _b, _c, region, _d, _e, type, inputImage, param, servicePromises, entityType;
                return $129b516158905bcd$var$__generator(this, function(_f) {
                    switch(_f.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                (0, $aCVDw.default).get()
                            ];
                        case 1:
                            credentials = _f.sent();
                            if (!credentials) return [
                                2 /*return*/ ,
                                rej("No credentials")
                            ];
                            _a = this._config.identifyLabels, _b = _a === void 0 ? {} : _a, _c = _b.region, region = _c === void 0 ? "" : _c, _d = _b.defaults, _e = (_d === void 0 ? {} : _d).type, type = _e === void 0 ? "LABELS" : _e;
                            this.rekognition = new $1Z7n0({
                                region: region,
                                credentials: credentials
                            });
                            return [
                                4 /*yield*/ ,
                                this.configureSource(input.labels.source).then(function(data) {
                                    inputImage = data;
                                }).catch(function(err) {
                                    return rej(err);
                                })
                            ];
                        case 2:
                            _f.sent();
                            param = {
                                Image: inputImage
                            };
                            servicePromises = [];
                            entityType = input.labels.type || type;
                            if (entityType === "LABELS" || entityType === "ALL") servicePromises.push(this.detectLabels(param));
                            if (entityType === "UNSAFE" || entityType === "ALL") servicePromises.push(this.detectModerationLabels(param));
                            // if (servicePromises.length === 0) {
                            //     rej('You must specify entity type: LABELS | UNSAFE | ALL');
                            // }
                            Promise.all(servicePromises).then(function(data) {
                                var identifyResult = {};
                                // concatenate resolved promises to a single object
                                data.forEach(function(val) {
                                    identifyResult = $129b516158905bcd$var$__assign($129b516158905bcd$var$__assign({}, identifyResult), val);
                                });
                                res(identifyResult);
                            }).catch(function(err) {
                                return rej(err);
                            });
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    /**
     * Calls Rekognition.detectLabels and organizes the returned data.
     * @param {Rekognition.DetectLabelsRequest} param - parameter to be passed onto Rekognition
     * @return {Promise<IdentifyLabelsOutput>} - Promise resolving to organized detectLabels response.
     */ AmazonAIIdentifyPredictionsProvider.prototype.detectLabels = function(param) {
        var _this = this;
        return new Promise(function(res, rej) {
            _this.rekognition.detectLabels(param, function(err, data) {
                if (err) return rej(err);
                if (!data.Labels) return res({
                    labels: null
                }); // no image was detected
                var detectLabelData = data.Labels.map(function(val) {
                    var boxes = val.Instances ? val.Instances.map(function(val) {
                        return (0, $8Clxz.makeCamelCase)(val.BoundingBox);
                    }) : undefined;
                    return {
                        name: val.Name,
                        boundingBoxes: boxes,
                        metadata: {
                            confidence: val.Confidence,
                            parents: (0, $8Clxz.makeCamelCaseArray)(val.Parents)
                        }
                    };
                });
                return res({
                    labels: detectLabelData
                });
            });
        });
    };
    /**
     * Calls Rekognition.detectModerationLabels and organizes the returned data.
     * @param {Rekognition.DetectLabelsRequest} param - Parameter to be passed onto Rekognition
     * @return {Promise<IdentifyLabelsOutput>} - Promise resolving to organized detectModerationLabels response.
     */ AmazonAIIdentifyPredictionsProvider.prototype.detectModerationLabels = function(param) {
        var _this = this;
        return new Promise(function(res, rej) {
            _this.rekognition.detectModerationLabels(param, function(err, data) {
                if (err) return rej(err);
                if (data.ModerationLabels.length !== 0) return res({
                    unsafe: "YES"
                });
                else return res({
                    unsafe: "NO"
                });
            });
        });
    };
    /**
     * Identify faces within an image that is provided as input, and match faces from a collection
     * or identify celebrities.
     * @param {IdentifyEntityInput} input - object containing the source image and face match options.
     * @return {Promise<IdentifyEntityOutput>} Promise resolving to identify results.
     */ AmazonAIIdentifyPredictionsProvider.prototype.identifyEntities = function(input) {
        var _this = this;
        return new Promise(function(res, rej) {
            return $129b516158905bcd$var$__awaiter(_this, void 0, void 0, function() {
                var credentials, _a, _b, _c, region, _d, celebrityDetectionEnabled, _e, _f, _g, collectionIdConfig, _h, maxFacesConfig, inputImage, param, _j, _k, collectionId, _l, maxFaces, updatedParam;
                var _this = this;
                return $129b516158905bcd$var$__generator(this, function(_m) {
                    switch(_m.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                (0, $aCVDw.default).get()
                            ];
                        case 1:
                            credentials = _m.sent();
                            if (!credentials) return [
                                2 /*return*/ ,
                                rej("No credentials")
                            ];
                            _a = this._config.identifyEntities, _b = _a === void 0 ? {} : _a, _c = _b.region, region = _c === void 0 ? "" : _c, _d = _b.celebrityDetectionEnabled, celebrityDetectionEnabled = _d === void 0 ? false : _d, _e = _b.defaults, _f = _e === void 0 ? {} : _e, _g = _f.collectionId, collectionIdConfig = _g === void 0 ? "" : _g, _h = _f.maxEntities, maxFacesConfig = _h === void 0 ? 50 : _h;
                            // default arguments
                            this.rekognition = new $1Z7n0({
                                region: region,
                                credentials: credentials
                            });
                            return [
                                4 /*yield*/ ,
                                this.configureSource(input.entities.source).then(function(data) {
                                    return inputImage = data;
                                }).catch(function(err) {
                                    return rej(err);
                                })
                            ];
                        case 2:
                            _m.sent();
                            param = {
                                Image: inputImage
                            };
                            if ((0, $9dl3A.isIdentifyCelebrities)(input.entities) && input.entities.celebrityDetection) {
                                if (!celebrityDetectionEnabled) return [
                                    2 /*return*/ ,
                                    rej("Error: You have to enable celebrity detection first")
                                ];
                                this.rekognition.recognizeCelebrities(param, function(err, data) {
                                    if (err) return rej(err);
                                    var faces = data.CelebrityFaces.map(function(celebrity) {
                                        return {
                                            boundingBox: (0, $8Clxz.makeCamelCase)(celebrity.Face.BoundingBox),
                                            landmarks: (0, $8Clxz.makeCamelCaseArray)(celebrity.Face.Landmarks),
                                            metadata: $129b516158905bcd$var$__assign($129b516158905bcd$var$__assign({}, (0, $8Clxz.makeCamelCase)(celebrity, [
                                                "Id",
                                                "Name",
                                                "Urls"
                                            ])), {
                                                pose: (0, $8Clxz.makeCamelCase)(celebrity.Face.Pose)
                                            })
                                        };
                                    });
                                    res({
                                        entities: faces
                                    });
                                });
                            } else if ((0, $9dl3A.isIdentifyFromCollection)(input.entities) && input.entities.collection) {
                                _j = input.entities, _k = _j.collectionId, collectionId = _k === void 0 ? collectionIdConfig : _k, _l = _j.maxEntities, maxFaces = _l === void 0 ? maxFacesConfig : _l;
                                updatedParam = $129b516158905bcd$var$__assign($129b516158905bcd$var$__assign({}, param), {
                                    CollectionId: collectionId,
                                    MaxFaces: maxFaces
                                });
                                this.rekognition.searchFacesByImage(updatedParam, function(err, data) {
                                    if (err) return rej(err);
                                    var faces = data.FaceMatches.map(function(val) {
                                        return {
                                            boundingBox: (0, $8Clxz.makeCamelCase)(val.Face.BoundingBox),
                                            metadata: {
                                                externalImageId: _this.decodeExternalImageId(val.Face.ExternalImageId),
                                                similarity: val.Similarity
                                            }
                                        };
                                    });
                                    res({
                                        entities: faces
                                    });
                                });
                            } else this.rekognition.detectFaces(param, function(err, data) {
                                if (err) return rej(err);
                                var faces = data.FaceDetails.map(function(detail) {
                                    // face attributes keys we want to extract from Rekognition's response
                                    var attributeKeys = [
                                        "Smile",
                                        "Eyeglasses",
                                        "Sunglasses",
                                        "Gender",
                                        "Beard",
                                        "Mustache",
                                        "EyesOpen",
                                        "MouthOpen"
                                    ];
                                    var faceAttributes = (0, $8Clxz.makeCamelCase)(detail, attributeKeys);
                                    if (detail.Emotions) faceAttributes["emotions"] = detail.Emotions.map(function(emotion) {
                                        return emotion.Type;
                                    });
                                    return {
                                        boundingBox: (0, $8Clxz.makeCamelCase)(detail.BoundingBox),
                                        landmarks: (0, $8Clxz.makeCamelCaseArray)(detail.Landmarks),
                                        ageRange: (0, $8Clxz.makeCamelCase)(detail.AgeRange),
                                        attributes: (0, $8Clxz.makeCamelCase)(detail, attributeKeys),
                                        metadata: {
                                            confidence: detail.Confidence,
                                            pose: (0, $8Clxz.makeCamelCase)(detail.Pose)
                                        }
                                    };
                                });
                                res({
                                    entities: faces
                                });
                            });
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    AmazonAIIdentifyPredictionsProvider.prototype.decodeExternalImageId = function(externalImageId) {
        return ("" + externalImageId).replace(/::/g, "/");
    };
    return AmazonAIIdentifyPredictionsProvider;
}((0, $c9o1I.AbstractIdentifyPredictionsProvider));
var $129b516158905bcd$export$2e2bcd8739ae039 = $129b516158905bcd$var$AmazonAIIdentifyPredictionsProvider;

});
parcelRequire.register("1Z7n0", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $1721347af7a50c17$var$Service = $dbC7k.Service;
var $1721347af7a50c17$var$apiLoader = $dbC7k.apiLoader;
$1721347af7a50c17$var$apiLoader.services["rekognition"] = {};
$dbC7k.Rekognition = $1721347af7a50c17$var$Service.defineService("rekognition", [
    "2016-06-27"
]);


Object.defineProperty($1721347af7a50c17$var$apiLoader.services["rekognition"], "2016-06-27", {
    get: function get() {
        var model = (parcelRequire("e0Iba"));
        model.paginators = (parcelRequire("dFl7v")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Rekognition;

});
parcelRequire.register("e0Iba", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-06-27","endpointPrefix":"rekognition","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Rekognition","serviceId":"Rekognition","signatureVersion":"v4","targetPrefix":"RekognitionService","uid":"rekognition-2016-06-27"},"operations":{"CompareFaces":{"input":{"type":"structure","required":["SourceImage","TargetImage"],"members":{"SourceImage":{"shape":"S2"},"TargetImage":{"shape":"S2"},"SimilarityThreshold":{"type":"float"}}},"output":{"type":"structure","members":{"SourceImageFace":{"type":"structure","members":{"BoundingBox":{"shape":"Sb"},"Confidence":{"type":"float"}}},"FaceMatches":{"type":"list","member":{"type":"structure","members":{"Similarity":{"type":"float"},"Face":{"shape":"Sf"}}}},"UnmatchedFaces":{"type":"list","member":{"shape":"Sf"}},"SourceImageOrientationCorrection":{},"TargetImageOrientationCorrection":{}}}},"CreateCollection":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{}}},"output":{"type":"structure","members":{"StatusCode":{"type":"integer"},"CollectionArn":{},"FaceModelVersion":{}}}},"CreateStreamProcessor":{"input":{"type":"structure","required":["Input","Output","Name","Settings","RoleArn"],"members":{"Input":{"shape":"Su"},"Output":{"shape":"Sx"},"Name":{},"Settings":{"shape":"S11"},"RoleArn":{}}},"output":{"type":"structure","members":{"StreamProcessorArn":{}}}},"DeleteCollection":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{}}},"output":{"type":"structure","members":{"StatusCode":{"type":"integer"}}}},"DeleteFaces":{"input":{"type":"structure","required":["CollectionId","FaceIds"],"members":{"CollectionId":{},"FaceIds":{"shape":"S19"}}},"output":{"type":"structure","members":{"DeletedFaces":{"shape":"S19"}}}},"DeleteStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DescribeCollection":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{}}},"output":{"type":"structure","members":{"FaceCount":{"type":"long"},"FaceModelVersion":{},"CollectionARN":{},"CreationTimestamp":{"type":"timestamp"}}}},"DescribeStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"StreamProcessorArn":{},"Status":{},"StatusMessage":{},"CreationTimestamp":{"type":"timestamp"},"LastUpdateTimestamp":{"type":"timestamp"},"Input":{"shape":"Su"},"Output":{"shape":"Sx"},"RoleArn":{},"Settings":{"shape":"S11"}}}},"DetectFaces":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"},"Attributes":{"shape":"S1m"}}},"output":{"type":"structure","members":{"FaceDetails":{"type":"list","member":{"shape":"S1q"}},"OrientationCorrection":{}}}},"DetectLabels":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"},"MaxLabels":{"type":"integer"},"MinConfidence":{"type":"float"}}},"output":{"type":"structure","members":{"Labels":{"type":"list","member":{"shape":"S28"}},"OrientationCorrection":{},"LabelModelVersion":{}}}},"DetectModerationLabels":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"},"MinConfidence":{"type":"float"}}},"output":{"type":"structure","members":{"ModerationLabels":{"type":"list","member":{"shape":"S2g"}},"ModerationModelVersion":{}}}},"DetectText":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"}}},"output":{"type":"structure","members":{"TextDetections":{"type":"list","member":{"type":"structure","members":{"DetectedText":{},"Type":{},"Id":{"type":"integer"},"ParentId":{"type":"integer"},"Confidence":{"type":"float"},"Geometry":{"type":"structure","members":{"BoundingBox":{"shape":"Sb"},"Polygon":{"type":"list","member":{"type":"structure","members":{"X":{"type":"float"},"Y":{"type":"float"}}}}}}}}}}}},"GetCelebrityInfo":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{"Urls":{"shape":"S2s"},"Name":{}}}},"GetCelebrityRecognition":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S32"},"NextToken":{},"Celebrities":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Celebrity":{"type":"structure","members":{"Urls":{"shape":"S2s"},"Name":{},"Id":{},"Confidence":{"type":"float"},"BoundingBox":{"shape":"Sb"},"Face":{"shape":"S1q"}}}}}}}}},"GetContentModeration":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S32"},"ModerationLabels":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"ModerationLabel":{"shape":"S2g"}}}},"NextToken":{},"ModerationModelVersion":{}}}},"GetFaceDetection":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S32"},"NextToken":{},"Faces":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Face":{"shape":"S1q"}}}}}}},"GetFaceSearch":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"NextToken":{},"VideoMetadata":{"shape":"S32"},"Persons":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Person":{"shape":"S3l"},"FaceMatches":{"shape":"S3n"}}}}}}},"GetLabelDetection":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S32"},"NextToken":{},"Labels":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Label":{"shape":"S28"}}}},"LabelModelVersion":{}}}},"GetPersonTracking":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S32"},"NextToken":{},"Persons":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Person":{"shape":"S3l"}}}}}}},"IndexFaces":{"input":{"type":"structure","required":["CollectionId","Image"],"members":{"CollectionId":{},"Image":{"shape":"S2"},"ExternalImageId":{},"DetectionAttributes":{"shape":"S1m"},"MaxFaces":{"type":"integer"},"QualityFilter":{}}},"output":{"type":"structure","members":{"FaceRecords":{"type":"list","member":{"type":"structure","members":{"Face":{"shape":"S3p"},"FaceDetail":{"shape":"S1q"}}}},"OrientationCorrection":{},"FaceModelVersion":{},"UnindexedFaces":{"type":"list","member":{"type":"structure","members":{"Reasons":{"type":"list","member":{}},"FaceDetail":{"shape":"S1q"}}}}}}},"ListCollections":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"CollectionIds":{"type":"list","member":{}},"NextToken":{},"FaceModelVersions":{"type":"list","member":{}}}}},"ListFaces":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Faces":{"type":"list","member":{"shape":"S3p"}},"NextToken":{},"FaceModelVersion":{}}}},"ListStreamProcessors":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"StreamProcessors":{"type":"list","member":{"type":"structure","members":{"Name":{},"Status":{}}}}}}},"RecognizeCelebrities":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"S2"}}},"output":{"type":"structure","members":{"CelebrityFaces":{"type":"list","member":{"type":"structure","members":{"Urls":{"shape":"S2s"},"Name":{},"Id":{},"Face":{"shape":"Sf"},"MatchConfidence":{"type":"float"}}}},"UnrecognizedFaces":{"type":"list","member":{"shape":"Sf"}},"OrientationCorrection":{}}}},"SearchFaces":{"input":{"type":"structure","required":["CollectionId","FaceId"],"members":{"CollectionId":{},"FaceId":{},"MaxFaces":{"type":"integer"},"FaceMatchThreshold":{"type":"float"}}},"output":{"type":"structure","members":{"SearchedFaceId":{},"FaceMatches":{"shape":"S3n"},"FaceModelVersion":{}}}},"SearchFacesByImage":{"input":{"type":"structure","required":["CollectionId","Image"],"members":{"CollectionId":{},"Image":{"shape":"S2"},"MaxFaces":{"type":"integer"},"FaceMatchThreshold":{"type":"float"}}},"output":{"type":"structure","members":{"SearchedFaceBoundingBox":{"shape":"Sb"},"SearchedFaceConfidence":{"type":"float"},"FaceMatches":{"shape":"S3n"},"FaceModelVersion":{}}}},"StartCelebrityRecognition":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S4z"},"ClientRequestToken":{},"NotificationChannel":{"shape":"S51"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartContentModeration":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S4z"},"MinConfidence":{"type":"float"},"ClientRequestToken":{},"NotificationChannel":{"shape":"S51"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartFaceDetection":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S4z"},"ClientRequestToken":{},"NotificationChannel":{"shape":"S51"},"FaceAttributes":{},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartFaceSearch":{"input":{"type":"structure","required":["Video","CollectionId"],"members":{"Video":{"shape":"S4z"},"ClientRequestToken":{},"FaceMatchThreshold":{"type":"float"},"CollectionId":{},"NotificationChannel":{"shape":"S51"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartLabelDetection":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S4z"},"ClientRequestToken":{},"MinConfidence":{"type":"float"},"NotificationChannel":{"shape":"S51"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartPersonTracking":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S4z"},"ClientRequestToken":{},"NotificationChannel":{"shape":"S51"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"StopStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S2":{"type":"structure","members":{"Bytes":{"type":"blob"},"S3Object":{"shape":"S4"}}},"S4":{"type":"structure","members":{"Bucket":{},"Name":{},"Version":{}}},"Sb":{"type":"structure","members":{"Width":{"type":"float"},"Height":{"type":"float"},"Left":{"type":"float"},"Top":{"type":"float"}}},"Sf":{"type":"structure","members":{"BoundingBox":{"shape":"Sb"},"Confidence":{"type":"float"},"Landmarks":{"shape":"Sg"},"Pose":{"shape":"Sj"},"Quality":{"shape":"Sl"}}},"Sg":{"type":"list","member":{"type":"structure","members":{"Type":{},"X":{"type":"float"},"Y":{"type":"float"}}}},"Sj":{"type":"structure","members":{"Roll":{"type":"float"},"Yaw":{"type":"float"},"Pitch":{"type":"float"}}},"Sl":{"type":"structure","members":{"Brightness":{"type":"float"},"Sharpness":{"type":"float"}}},"Su":{"type":"structure","members":{"KinesisVideoStream":{"type":"structure","members":{"Arn":{}}}}},"Sx":{"type":"structure","members":{"KinesisDataStream":{"type":"structure","members":{"Arn":{}}}}},"S11":{"type":"structure","members":{"FaceSearch":{"type":"structure","members":{"CollectionId":{},"FaceMatchThreshold":{"type":"float"}}}}},"S19":{"type":"list","member":{}},"S1m":{"type":"list","member":{}},"S1q":{"type":"structure","members":{"BoundingBox":{"shape":"Sb"},"AgeRange":{"type":"structure","members":{"Low":{"type":"integer"},"High":{"type":"integer"}}},"Smile":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Eyeglasses":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Sunglasses":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Gender":{"type":"structure","members":{"Value":{},"Confidence":{"type":"float"}}},"Beard":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Mustache":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"EyesOpen":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"MouthOpen":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Emotions":{"type":"list","member":{"type":"structure","members":{"Type":{},"Confidence":{"type":"float"}}}},"Landmarks":{"shape":"Sg"},"Pose":{"shape":"Sj"},"Quality":{"shape":"Sl"},"Confidence":{"type":"float"}}},"S28":{"type":"structure","members":{"Name":{},"Confidence":{"type":"float"},"Instances":{"type":"list","member":{"type":"structure","members":{"BoundingBox":{"shape":"Sb"},"Confidence":{"type":"float"}}}},"Parents":{"type":"list","member":{"type":"structure","members":{"Name":{}}}}}},"S2g":{"type":"structure","members":{"Confidence":{"type":"float"},"Name":{},"ParentName":{}}},"S2s":{"type":"list","member":{}},"S32":{"type":"structure","members":{"Codec":{},"DurationMillis":{"type":"long"},"Format":{},"FrameRate":{"type":"float"},"FrameHeight":{"type":"long"},"FrameWidth":{"type":"long"}}},"S3l":{"type":"structure","members":{"Index":{"type":"long"},"BoundingBox":{"shape":"Sb"},"Face":{"shape":"S1q"}}},"S3n":{"type":"list","member":{"type":"structure","members":{"Similarity":{"type":"float"},"Face":{"shape":"S3p"}}}},"S3p":{"type":"structure","members":{"FaceId":{},"BoundingBox":{"shape":"Sb"},"ImageId":{},"ExternalImageId":{},"Confidence":{"type":"float"}}},"S4z":{"type":"structure","members":{"S3Object":{"shape":"S4"}}},"S51":{"type":"structure","required":["SNSTopicArn","RoleArn"],"members":{"SNSTopicArn":{},"RoleArn":{}}}}}');

});

parcelRequire.register("dFl7v", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"GetCelebrityRecognition":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetContentModeration":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetFaceDetection":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetFaceSearch":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetLabelDetection":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetPersonTracking":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListCollections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CollectionIds"},"ListFaces":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Faces"},"ListStreamProcessors":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"}}}');

});


parcelRequire.register("54Djg", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $3b1bd1927bba8478$var$Service = $dbC7k.Service;
var $3b1bd1927bba8478$var$apiLoader = $dbC7k.apiLoader;
$3b1bd1927bba8478$var$apiLoader.services["textract"] = {};
$dbC7k.Textract = $3b1bd1927bba8478$var$Service.defineService("textract", [
    "2018-06-27"
]);


Object.defineProperty($3b1bd1927bba8478$var$apiLoader.services["textract"], "2018-06-27", {
    get: function get() {
        var model = (parcelRequire("kzuPe"));
        model.paginators = (parcelRequire("lWrsk")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Textract;

});
parcelRequire.register("kzuPe", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-06-27","endpointPrefix":"textract","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Textract","serviceId":"Textract","signatureVersion":"v4","targetPrefix":"Textract","uid":"textract-2018-06-27"},"operations":{"AnalyzeDocument":{"input":{"type":"structure","required":["Document","FeatureTypes"],"members":{"Document":{"shape":"S2"},"FeatureTypes":{"shape":"S8"}}},"output":{"type":"structure","members":{"DocumentMetadata":{"shape":"Sb"},"Blocks":{"shape":"Sd"}}}},"DetectDocumentText":{"input":{"type":"structure","required":["Document"],"members":{"Document":{"shape":"S2"}}},"output":{"type":"structure","members":{"DocumentMetadata":{"shape":"Sb"},"Blocks":{"shape":"Sd"}}}},"GetDocumentAnalysis":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DocumentMetadata":{"shape":"Sb"},"JobStatus":{},"NextToken":{},"Blocks":{"shape":"Sd"},"Warnings":{"shape":"S13"},"StatusMessage":{}}}},"GetDocumentTextDetection":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DocumentMetadata":{"shape":"Sb"},"JobStatus":{},"NextToken":{},"Blocks":{"shape":"Sd"},"Warnings":{"shape":"S13"},"StatusMessage":{}}}},"StartDocumentAnalysis":{"input":{"type":"structure","required":["DocumentLocation","FeatureTypes"],"members":{"DocumentLocation":{"shape":"S1b"},"FeatureTypes":{"shape":"S8"},"ClientRequestToken":{},"JobTag":{},"NotificationChannel":{"shape":"S1e"}}},"output":{"type":"structure","members":{"JobId":{}}}},"StartDocumentTextDetection":{"input":{"type":"structure","required":["DocumentLocation"],"members":{"DocumentLocation":{"shape":"S1b"},"ClientRequestToken":{},"JobTag":{},"NotificationChannel":{"shape":"S1e"}}},"output":{"type":"structure","members":{"JobId":{}}}}},"shapes":{"S2":{"type":"structure","members":{"Bytes":{"type":"blob"},"S3Object":{"shape":"S4"}}},"S4":{"type":"structure","members":{"Bucket":{},"Name":{},"Version":{}}},"S8":{"type":"list","member":{}},"Sb":{"type":"structure","members":{"Pages":{"type":"integer"}}},"Sd":{"type":"list","member":{"type":"structure","members":{"BlockType":{},"Confidence":{"type":"float"},"Text":{},"RowIndex":{"type":"integer"},"ColumnIndex":{"type":"integer"},"RowSpan":{"type":"integer"},"ColumnSpan":{"type":"integer"},"Geometry":{"type":"structure","members":{"BoundingBox":{"type":"structure","members":{"Width":{"type":"float"},"Height":{"type":"float"},"Left":{"type":"float"},"Top":{"type":"float"}}},"Polygon":{"type":"list","member":{"type":"structure","members":{"X":{"type":"float"},"Y":{"type":"float"}}}}}},"Id":{},"Relationships":{"type":"list","member":{"type":"structure","members":{"Type":{},"Ids":{"type":"list","member":{}}}}},"EntityTypes":{"type":"list","member":{}},"SelectionStatus":{},"Page":{"type":"integer"}}}},"S13":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"Pages":{"type":"list","member":{"type":"integer"}}}}},"S1b":{"type":"structure","members":{"S3Object":{"shape":"S4"}}},"S1e":{"type":"structure","required":["SNSTopicArn","RoleArn"],"members":{"SNSTopicArn":{},"RoleArn":{}}}}}');

});

parcelRequire.register("lWrsk", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("8Clxz", function(module, exports) {

$parcel$export(module.exports, "makeCamelCase", function () { return $646294d03b5afbb0$export$44e7716ae1289d49; });
$parcel$export(module.exports, "makeCamelCaseArray", function () { return $646294d03b5afbb0$export$f9a9a96d2b1b1632; });
$parcel$export(module.exports, "blobToArrayBuffer", function () { return $646294d03b5afbb0$export$41f28d0d76de7163; });
/**
 * Changes object keys to camel case. If optional parameter `keys` is given, then we extract only the
 * keys specified in `keys`.
 */ function $646294d03b5afbb0$export$44e7716ae1289d49(obj, keys) {
    if (!obj) return undefined;
    var newObj = {};
    var keysToRename = keys ? keys : Object.keys(obj);
    keysToRename.forEach(function(key) {
        var _a;
        if (obj.hasOwnProperty(key)) {
            // change the key to camelcase.
            var camelCaseKey = key.charAt(0).toLowerCase() + key.substr(1);
            Object.assign(newObj, (_a = {}, _a[camelCaseKey] = obj[key], _a));
        }
    });
    return newObj;
}
function $646294d03b5afbb0$export$f9a9a96d2b1b1632(objArr, keys) {
    if (!objArr) return undefined;
    return objArr.map(function(obj) {
        return $646294d03b5afbb0$export$44e7716ae1289d49(obj, keys);
    });
}
function $646294d03b5afbb0$export$41f28d0d76de7163(blob) {
    return new Promise(function(res, rej) {
        var reader = new FileReader();
        reader.onload = function(_event) {
            res(reader.result);
        };
        reader.onerror = function(err) {
            rej(err);
        };
        try {
            reader.readAsArrayBuffer(blob);
        } catch (err) {
            rej(err); // in case user gives invalid type
        }
    });
}

});

parcelRequire.register("51H3M", function(module, exports) {

$parcel$export(module.exports, "categorizeRekognitionBlocks", function () { return $3a8e728f552b6bf4$export$81666bdb324d12c; });
$parcel$export(module.exports, "categorizeTextractBlocks", function () { return $3a8e728f552b6bf4$export$f1438e6a8d69be41; });

var $8Clxz = parcelRequire("8Clxz");
function $3a8e728f552b6bf4$var$getBoundingBox(geometry) {
    if (!geometry) return undefined;
    return (0, $8Clxz.makeCamelCase)(geometry.BoundingBox);
}
function $3a8e728f552b6bf4$var$getPolygon(geometry) {
    if (!geometry) return undefined;
    return (0, $8Clxz.makeCamelCaseArray)(geometry.Polygon);
}
function $3a8e728f552b6bf4$export$81666bdb324d12c(blocks) {
    // Skeleton IdentifyText API response. We will populate it as we iterate through blocks.
    var response = {
        text: {
            fullText: "",
            words: [],
            lines: [],
            linesDetailed: []
        }
    };
    // We categorize each block by running a forEach loop through them.
    blocks.forEach(function(block) {
        switch(block.Type){
            case "LINE":
                response.text.lines.push(block.DetectedText);
                response.text.linesDetailed.push({
                    text: block.DetectedText,
                    polygon: $3a8e728f552b6bf4$var$getPolygon(block.Geometry),
                    boundingBox: $3a8e728f552b6bf4$var$getBoundingBox(block.Geometry),
                    page: null
                });
                break;
            case "WORD":
                response.text.fullText += block.DetectedText + " ";
                response.text.words.push({
                    text: block.DetectedText,
                    polygon: $3a8e728f552b6bf4$var$getPolygon(block.Geometry),
                    boundingBox: $3a8e728f552b6bf4$var$getBoundingBox(block.Geometry)
                });
                break;
        }
    });
    // remove trailing space of fullText
    response.text.fullText = response.text.fullText.substr(0, response.text.fullText.length - 1);
    return response;
}
function $3a8e728f552b6bf4$export$f1438e6a8d69be41(blocks) {
    // Skeleton IdentifyText API response. We will populate it as we iterate through blocks.
    var response = {
        text: {
            fullText: "",
            words: [],
            lines: [],
            linesDetailed: []
        }
    };
    // if blocks is an empty array, ie. textract did not detect anything, return empty response.
    if (blocks.length === 0) return response;
    /**
     * We categorize each of the blocks by running a forEach loop through them.
     *
     * For complex structures such as Tables and KeyValue, we need to trasverse through their children. To do so,
     * we will post-process them after the for each loop. We do this by storing table and keyvalues in arrays and
     * mapping other blocks in `blockMap` (id to block) so we can reference them easily later.
     *
     * Note that we do not map `WORD` and `TABLE` in `blockMap` because they will not be referenced by any other
     * block except the Page block.
     */ var tableBlocks = Array();
    var keyValueBlocks = Array();
    var blockMap = {};
    blocks.forEach(function(block) {
        switch(block.BlockType){
            case "LINE":
                response.text.lines.push(block.Text);
                response.text.linesDetailed.push({
                    text: block.Text,
                    polygon: $3a8e728f552b6bf4$var$getPolygon(block.Geometry),
                    boundingBox: $3a8e728f552b6bf4$var$getBoundingBox(block.Geometry),
                    page: block.Page
                });
                break;
            case "WORD":
                response.text.fullText += block.Text + " ";
                response.text.words.push({
                    text: block.Text,
                    polygon: $3a8e728f552b6bf4$var$getPolygon(block.Geometry),
                    boundingBox: $3a8e728f552b6bf4$var$getBoundingBox(block.Geometry)
                });
                blockMap[block.Id] = block;
                break;
            case "SELECTION_ELEMENT":
                var selectionStatus = block.SelectionStatus === "SELECTED" ? true : false;
                if (!response.text.selections) response.text.selections = [];
                response.text.selections.push({
                    selected: selectionStatus,
                    polygon: $3a8e728f552b6bf4$var$getPolygon(block.Geometry),
                    boundingBox: $3a8e728f552b6bf4$var$getBoundingBox(block.Geometry)
                });
                blockMap[block.Id] = block;
                break;
            case "TABLE":
                tableBlocks.push(block);
                break;
            case "KEY_VALUE_SET":
                keyValueBlocks.push(block);
                blockMap[block.Id] = block;
                break;
            default:
                blockMap[block.Id] = block;
        }
    });
    // remove trailing space in fullText
    response.text.fullText = response.text.fullText.substr(0, response.text.fullText.length - 1);
    // Post-process complex structures if they exist.
    if (tableBlocks.length !== 0) {
        var tableResponse_1 = Array();
        tableBlocks.forEach(function(table) {
            tableResponse_1.push($3a8e728f552b6bf4$export$99624ed580f203ab(table, blockMap));
        });
        response.text.tables = tableResponse_1;
    }
    if (keyValueBlocks.length !== 0) {
        var keyValueResponse_1 = Array();
        keyValueBlocks.forEach(function(keyValue) {
            // We need the KeyValue blocks of EntityType = `KEY`, which has both key and value references.
            if (keyValue.EntityTypes.indexOf("KEY") !== -1) keyValueResponse_1.push($3a8e728f552b6bf4$export$c41cd4b65b9d8612(keyValue, blockMap));
        });
        response.text.keyValues = keyValueResponse_1;
    }
    return response;
}
function $3a8e728f552b6bf4$export$99624ed580f203ab(table, blockMap) {
    var tableMatrix;
    tableMatrix = [];
    // visit each of the cell associated with the table's relationship.
    table.Relationships.forEach(function(tableRelation) {
        tableRelation.Ids.forEach(function(cellId) {
            var cellBlock = blockMap[cellId];
            var row = cellBlock.RowIndex - 1; // textract starts indexing at 1, so subtract it by 1.
            var col = cellBlock.ColumnIndex - 1; // textract starts indexing at 1, so subtract it by 1.
            // extract data contained inside the cell.
            var content = $3a8e728f552b6bf4$export$cf38fe8135ab134a(cellBlock, blockMap);
            var cell = {
                text: content.text,
                boundingBox: $3a8e728f552b6bf4$var$getBoundingBox(cellBlock.Geometry),
                polygon: $3a8e728f552b6bf4$var$getPolygon(cellBlock.Geometry),
                selected: content.selected,
                rowSpan: cellBlock.RowSpan,
                columnSpan: cellBlock.ColumnSpan
            };
            if (!tableMatrix[row]) tableMatrix[row] = [];
            tableMatrix[row][col] = cell;
        });
    });
    var rowSize = tableMatrix.length;
    var columnSize = tableMatrix[0].length;
    // Note that we leave spanned cells undefined for distinction
    return {
        size: {
            rows: rowSize,
            columns: columnSize
        },
        table: tableMatrix,
        boundingBox: $3a8e728f552b6bf4$var$getBoundingBox(table.Geometry),
        polygon: $3a8e728f552b6bf4$var$getPolygon(table.Geometry)
    };
}
function $3a8e728f552b6bf4$export$c41cd4b65b9d8612(keyBlock, blockMap) {
    var keyText = "";
    var valueText = "";
    var valueSelected;
    keyBlock.Relationships.forEach(function(keyValueRelation) {
        if (keyValueRelation.Type === "CHILD") {
            // relation refers to key
            var contents = $3a8e728f552b6bf4$export$cf38fe8135ab134a(keyBlock, blockMap);
            keyText = contents.text;
        } else if (keyValueRelation.Type === "VALUE") // relation refers to value
        keyValueRelation.Ids.forEach(function(valueId) {
            var valueBlock = blockMap[valueId];
            var contents = $3a8e728f552b6bf4$export$cf38fe8135ab134a(valueBlock, blockMap);
            valueText = contents.text;
            if (contents.selected != null) valueSelected = contents.selected;
        });
    });
    return {
        key: keyText,
        value: {
            text: valueText,
            selected: valueSelected
        },
        polygon: $3a8e728f552b6bf4$var$getPolygon(keyBlock.Geometry),
        boundingBox: $3a8e728f552b6bf4$var$getBoundingBox(keyBlock.Geometry)
    };
}
function $3a8e728f552b6bf4$export$cf38fe8135ab134a(block, blockMap) {
    var words = "";
    var isSelected;
    if (!block.Relationships) // some block might have no content
    return {
        text: "",
        selected: undefined
    };
    block.Relationships.forEach(function(relation) {
        relation.Ids.forEach(function(contentId) {
            var contentBlock = blockMap[contentId];
            if (contentBlock.BlockType === "WORD") words += contentBlock.Text + " ";
            else if (contentBlock.BlockType === "SELECTION_ELEMENT") isSelected = contentBlock.SelectionStatus === "SELECTED" ? true : false;
        });
    });
    words = words.substr(0, words.length - 1); // remove trailing space.
    return {
        text: words,
        selected: isSelected
    };
}

});


parcelRequire.register("eHzYr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab40fc8407467b64$export$2e2bcd8739ae039; });
parcelRequire("2hWDt");
var $aCVDw = parcelRequire("aCVDw");
parcelRequire("eOV94");
var $12F2R = parcelRequire("12F2R");
parcelRequire("j3ga8");
var $9dl3A = parcelRequire("9dl3A");

var $9XbUy = parcelRequire("9XbUy");
var $ab40fc8407467b64$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ab40fc8407467b64$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ab40fc8407467b64$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $ab40fc8407467b64$var$AmazonAIInterpretPredictionsProvider = /** @class */ function(_super) {
    $ab40fc8407467b64$var$__extends(AmazonAIInterpretPredictionsProvider, _super);
    function AmazonAIInterpretPredictionsProvider() {
        return _super.call(this) || this;
    }
    AmazonAIInterpretPredictionsProvider.prototype.getProviderName = function() {
        return "AmazonAIInterpretPredictionsProvider";
    };
    AmazonAIInterpretPredictionsProvider.prototype.interpretText = function(input) {
        var _this = this;
        return new Promise(function(res, rej) {
            return $ab40fc8407467b64$var$__awaiter(_this, void 0, void 0, function() {
                var credentials, _a, _b, _c, region, _d, _e, interpretTypeConfig, _f, _g, _h, _j, text, _k, interpretType, _l, _m, _o, language, comprehend, doAll, languagePromise, languageDetectionParams, entitiesPromise, LanguageCode, _p, entitiesDetectionParams, sentimentPromise, LanguageCode, _q, sentimentParams, syntaxPromise, LanguageCode, _r, syntaxParams, keyPhrasesPromise, LanguageCode, _s, keyPhrasesParams, results, err_1;
                return $ab40fc8407467b64$var$__generator(this, function(_t) {
                    switch(_t.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                (0, $aCVDw.default).get()
                            ];
                        case 1:
                            credentials = _t.sent();
                            if (!credentials) return [
                                2 /*return*/ ,
                                rej("No credentials")
                            ];
                            _a = this._config.interpretText, _b = _a === void 0 ? {} : _a, _c = _b.region, region = _c === void 0 ? "" : _c, _d = _b.defaults, _e = (_d === void 0 ? {} : _d).type, interpretTypeConfig = _e === void 0 ? "" : _e;
                            _f = input.text, _g = _f === void 0 ? {} : _f, _h = _g.source, _j = (_h === void 0 ? {} : _h).text, text = _j === void 0 ? "" : _j, _k = _g.type, interpretType = _k === void 0 ? interpretTypeConfig : _k;
                            _l = input.text, _m = (_l === void 0 ? {} : _l).source, _o = (_m === void 0 ? {} : _m).language, language = _o === void 0 ? undefined : _o;
                            comprehend = new (0, $9XbUy.Comprehend)({
                                credentials: credentials,
                                region: region
                            });
                            doAll = interpretType === (0, $9dl3A.InterpretTextCategories).ALL;
                            if (doAll || interpretType === (0, $9dl3A.InterpretTextCategories).LANGUAGE) {
                                languageDetectionParams = {
                                    Text: text
                                };
                                languagePromise = this.detectLanguage(languageDetectionParams, comprehend);
                            }
                            if (!(doAll || interpretType === (0, $9dl3A.InterpretTextCategories).ENTITIES)) return [
                                3 /*break*/ ,
                                4
                            ];
                            _p = language;
                            if (_p) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                languagePromise
                            ];
                        case 2:
                            _p = _t.sent();
                            _t.label = 3;
                        case 3:
                            LanguageCode = _p;
                            if (!LanguageCode) return [
                                2 /*return*/ ,
                                rej("language code is required on source for this selection")
                            ];
                            entitiesDetectionParams = {
                                Text: text,
                                LanguageCode: LanguageCode
                            };
                            entitiesPromise = this.detectEntities(entitiesDetectionParams, comprehend);
                            _t.label = 4;
                        case 4:
                            if (!(doAll || interpretType === (0, $9dl3A.InterpretTextCategories).SENTIMENT)) return [
                                3 /*break*/ ,
                                7
                            ];
                            _q = language;
                            if (_q) return [
                                3 /*break*/ ,
                                6
                            ];
                            return [
                                4 /*yield*/ ,
                                languagePromise
                            ];
                        case 5:
                            _q = _t.sent();
                            _t.label = 6;
                        case 6:
                            LanguageCode = _q;
                            if (!LanguageCode) return [
                                2 /*return*/ ,
                                rej("language code is required on source for this selection")
                            ];
                            sentimentParams = {
                                Text: text,
                                LanguageCode: LanguageCode
                            };
                            sentimentPromise = this.detectSentiment(sentimentParams, comprehend);
                            _t.label = 7;
                        case 7:
                            if (!(doAll || interpretType === (0, $9dl3A.InterpretTextCategories).SYNTAX)) return [
                                3 /*break*/ ,
                                10
                            ];
                            _r = language;
                            if (_r) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                languagePromise
                            ];
                        case 8:
                            _r = _t.sent();
                            _t.label = 9;
                        case 9:
                            LanguageCode = _r;
                            if (!LanguageCode) return [
                                2 /*return*/ ,
                                rej("language code is required on source for this selection")
                            ];
                            syntaxParams = {
                                Text: text,
                                LanguageCode: LanguageCode
                            };
                            syntaxPromise = this.detectSyntax(syntaxParams, comprehend);
                            _t.label = 10;
                        case 10:
                            if (!(doAll || interpretType === (0, $9dl3A.InterpretTextCategories).KEY_PHRASES)) return [
                                3 /*break*/ ,
                                13
                            ];
                            _s = language;
                            if (_s) return [
                                3 /*break*/ ,
                                12
                            ];
                            return [
                                4 /*yield*/ ,
                                languagePromise
                            ];
                        case 11:
                            _s = _t.sent();
                            _t.label = 12;
                        case 12:
                            LanguageCode = _s;
                            if (!LanguageCode) return [
                                2 /*return*/ ,
                                rej("language code is required on source for this selection")
                            ];
                            keyPhrasesParams = {
                                Text: text,
                                LanguageCode: LanguageCode
                            };
                            keyPhrasesPromise = this.detectKeyPhrases(keyPhrasesParams, comprehend);
                            _t.label = 13;
                        case 13:
                            _t.trys.push([
                                13,
                                15,
                                ,
                                16
                            ]);
                            return [
                                4 /*yield*/ ,
                                Promise.all([
                                    languagePromise,
                                    entitiesPromise,
                                    sentimentPromise,
                                    syntaxPromise,
                                    keyPhrasesPromise
                                ])
                            ];
                        case 14:
                            results = _t.sent();
                            res({
                                textInterpretation: {
                                    keyPhrases: results[4] || [],
                                    language: results[0] || "",
                                    sentiment: results[2],
                                    syntax: results[3] || [],
                                    textEntities: results[1] || []
                                }
                            });
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case 15:
                            err_1 = _t.sent();
                            rej(err_1);
                            return [
                                3 /*break*/ ,
                                16
                            ];
                        case 16:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    AmazonAIInterpretPredictionsProvider.prototype.detectKeyPhrases = function(params, comprehend) {
        return new Promise(function(res, rej) {
            comprehend.detectKeyPhrases(params, function(err, data) {
                var _a = (data || {}).KeyPhrases, KeyPhrases = _a === void 0 ? [] : _a;
                if (err) {
                    if (err.code === "AccessDeniedException") rej("Not authorized, did you enable Interpret Text on predictions category Amplify CLI? try: amplify predictions add");
                    else rej(err.message);
                } else res(KeyPhrases.map(function(_a) {
                    var text = _a.Text;
                    return {
                        text: text
                    };
                }));
            });
        });
    };
    AmazonAIInterpretPredictionsProvider.prototype.detectSyntax = function(params, comprehend) {
        var _this = this;
        return new Promise(function(res, rej) {
            comprehend.detectSyntax(params, function(err, data) {
                var _a = (data || {}).SyntaxTokens, SyntaxTokens = _a === void 0 ? [] : _a;
                if (err) {
                    if (err.code === "AccessDeniedException") rej("Not authorized, did you enable Interpret Text on predictions category Amplify CLI? try: amplify predictions add");
                    else rej(err.message);
                } else res(_this.serializeSyntaxFromComprehend(SyntaxTokens));
            });
        });
    };
    AmazonAIInterpretPredictionsProvider.prototype.serializeSyntaxFromComprehend = function(tokens) {
        var response = [];
        if (tokens && Array.isArray(tokens)) response = tokens.map(function(_a) {
            var _b = _a.Text, text = _b === void 0 ? "" : _b, _c = _a.PartOfSpeech, _d = (_c === void 0 ? {} : _c).Tag, syntax = _d === void 0 ? "" : _d;
            return {
                text: text,
                syntax: syntax
            };
        });
        return response;
    };
    AmazonAIInterpretPredictionsProvider.prototype.detectSentiment = function(params, comprehend) {
        return new Promise(function(res, rej) {
            comprehend.detectSentiment(params, function(err, data) {
                if (err) {
                    if (err.code === "AccessDeniedException") rej("Not authorized, did you enable Interpret Text on predictions category Amplify CLI? try: amplify predictions add");
                    else rej(err.message);
                } else {
                    var _a = data, _b = _a.Sentiment, predominant = _b === void 0 ? "" : _b, _c = _a.SentimentScore, _d = _c === void 0 ? {} : _c, _e = _d.Positive, positive = _e === void 0 ? 0 : _e, _f = _d.Negative, negative = _f === void 0 ? 0 : _f, _g = _d.Neutral, neutral = _g === void 0 ? 0 : _g, _h = _d.Mixed, mixed = _h === void 0 ? 0 : _h;
                    res({
                        predominant: predominant,
                        positive: positive,
                        negative: negative,
                        neutral: neutral,
                        mixed: mixed
                    });
                }
            });
        });
    };
    AmazonAIInterpretPredictionsProvider.prototype.detectEntities = function(params, comprehend) {
        var _this = this;
        return new Promise(function(res, rej) {
            comprehend.detectEntities(params, function(err, data) {
                var _a = (data || {}).Entities, Entities = _a === void 0 ? [] : _a;
                if (err) {
                    if (err.code === "AccessDeniedException") rej("Not authorized, did you enable Interpret Text on predictions category Amplify CLI? try: amplify predictions add");
                    else rej(err.message);
                } else res(_this.serializeEntitiesFromComprehend(Entities));
            });
        });
    };
    AmazonAIInterpretPredictionsProvider.prototype.serializeEntitiesFromComprehend = function(data) {
        var response = [];
        if (data && Array.isArray(data)) response = data.map(function(_a) {
            var type = _a.Type, text = _a.Text;
            return {
                type: type,
                text: text
            };
        });
        return response;
    };
    AmazonAIInterpretPredictionsProvider.prototype.detectLanguage = function(params, comprehend) {
        return new Promise(function(res, rej) {
            comprehend.detectDominantLanguage(params, function(err, data) {
                if (err) {
                    if (err.code === "AccessDeniedException") rej("Not authorized, did you enable Interpret Text on predictions category Amplify CLI? try: amplify predictions add");
                    else rej(err.message);
                } else {
                    var _a = (data || {}).Languages, LanguageCode = (_a === void 0 ? [
                        ""
                    ] : _a)[0].LanguageCode;
                    if (!LanguageCode) rej("Language not detected");
                    res(data.Languages[0].LanguageCode);
                }
            });
        });
    };
    return AmazonAIInterpretPredictionsProvider;
}((0, $12F2R.AbstractInterpretPredictionsProvider));
var $ab40fc8407467b64$export$2e2bcd8739ae039 = $ab40fc8407467b64$var$AmazonAIInterpretPredictionsProvider;

});
parcelRequire.register("9XbUy", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
parcelRequire("bTKxK");
/**
 * @api private
 */ module.exports = $dbC7k;

});
parcelRequire.register("bTKxK", function(module, exports) {
parcelRequire("hDDYX");





























































































































































































module.exports = {
    ACM: (parcelRequire("llFHp")),
    APIGateway: (parcelRequire("ietQp")),
    ApplicationAutoScaling: (parcelRequire("lxtho")),
    AppStream: (parcelRequire("3kN3i")),
    AutoScaling: (parcelRequire("jnGV7")),
    Batch: (parcelRequire("l8bhr")),
    Budgets: (parcelRequire("d3c74")),
    CloudDirectory: (parcelRequire("fbrMh")),
    CloudFormation: (parcelRequire("cYyu7")),
    CloudFront: (parcelRequire("32Tpm")),
    CloudHSM: (parcelRequire("bSVV9")),
    CloudSearch: (parcelRequire("9uo2Y")),
    CloudSearchDomain: (parcelRequire("bdTvN")),
    CloudTrail: (parcelRequire("3FoB4")),
    CloudWatch: (parcelRequire("6kPtS")),
    CloudWatchEvents: (parcelRequire("7aeIK")),
    CloudWatchLogs: (parcelRequire("ebUqC")),
    CodeBuild: (parcelRequire("5ZkTE")),
    CodeCommit: (parcelRequire("hs4DB")),
    CodeDeploy: (parcelRequire("j6UGC")),
    CodePipeline: (parcelRequire("gfN2I")),
    CognitoIdentity: (parcelRequire("emVYJ")),
    CognitoIdentityServiceProvider: (parcelRequire("gpRa9")),
    CognitoSync: (parcelRequire("545lv")),
    ConfigService: (parcelRequire("lQUxu")),
    CUR: (parcelRequire("6XcsC")),
    DataPipeline: (parcelRequire("hVPLg")),
    DeviceFarm: (parcelRequire("jg5tU")),
    DirectConnect: (parcelRequire("cLQcf")),
    DirectoryService: (parcelRequire("gG6yG")),
    Discovery: (parcelRequire("9M49d")),
    DMS: (parcelRequire("dfRu7")),
    DynamoDB: (parcelRequire("aVn70")),
    DynamoDBStreams: (parcelRequire("6qVcH")),
    EC2: (parcelRequire("hnS9G")),
    ECR: (parcelRequire("kvMHl")),
    ECS: (parcelRequire("luy43")),
    EFS: (parcelRequire("gQxbQ")),
    ElastiCache: (parcelRequire("FMpEp")),
    ElasticBeanstalk: (parcelRequire("88ZlK")),
    ELB: (parcelRequire("2d0vs")),
    ELBv2: (parcelRequire("dBnqk")),
    EMR: (parcelRequire("ftiKd")),
    ES: (parcelRequire("833Tl")),
    ElasticTranscoder: (parcelRequire("3j4mZ")),
    Firehose: (parcelRequire("kPiwT")),
    GameLift: (parcelRequire("8Fuaj")),
    Glacier: (parcelRequire("35GBw")),
    Health: (parcelRequire("63Qtg")),
    IAM: (parcelRequire("eExGZ")),
    ImportExport: (parcelRequire("lRSVL")),
    Inspector: (parcelRequire("3c0tt")),
    Iot: (parcelRequire("hTzNZ")),
    IotData: (parcelRequire("jLtQS")),
    Kinesis: (parcelRequire("gnl8D")),
    KinesisAnalytics: (parcelRequire("a1IK6")),
    KMS: (parcelRequire("hhHeB")),
    Lambda: (parcelRequire("gNGsW")),
    LexRuntime: (parcelRequire("lkBWy")),
    Lightsail: (parcelRequire("iEYIw")),
    MachineLearning: (parcelRequire("jdatw")),
    MarketplaceCommerceAnalytics: (parcelRequire("3W3Ob")),
    MarketplaceMetering: (parcelRequire("9IaLI")),
    MTurk: (parcelRequire("anz2K")),
    MobileAnalytics: (parcelRequire("kR1k5")),
    OpsWorks: (parcelRequire("6vlmU")),
    OpsWorksCM: (parcelRequire("ik8DS")),
    Organizations: (parcelRequire("l57XG")),
    Pinpoint: (parcelRequire("2tX1t")),
    Polly: (parcelRequire("4xsDJ")),
    RDS: (parcelRequire("2D5Mw")),
    Redshift: (parcelRequire("1gXlb")),
    Rekognition: (parcelRequire("1Z7n0")),
    ResourceGroupsTaggingAPI: (parcelRequire("u577v")),
    Route53: (parcelRequire("au73S")),
    Route53Domains: (parcelRequire("3nF3q")),
    S3: (parcelRequire("fMxnS")),
    S3Control: (parcelRequire("iokjV")),
    ServiceCatalog: (parcelRequire("g3uvH")),
    SES: (parcelRequire("bMrsx")),
    Shield: (parcelRequire("4B6Rs")),
    SimpleDB: (parcelRequire("4CxJH")),
    SMS: (parcelRequire("4gio4")),
    Snowball: (parcelRequire("1cN2L")),
    SNS: (parcelRequire("jrMpy")),
    SQS: (parcelRequire("lIiMN")),
    SSM: (parcelRequire("1deU5")),
    StorageGateway: (parcelRequire("9l6N3")),
    StepFunctions: (parcelRequire("kWbYB")),
    STS: (parcelRequire("2XC9S")),
    Support: (parcelRequire("9FKrv")),
    SWF: (parcelRequire("hQukQ")),
    XRay: (parcelRequire("zowlZ")),
    WAF: (parcelRequire("atSlF")),
    WAFRegional: (parcelRequire("dhNjG")),
    WorkDocs: (parcelRequire("7BMZN")),
    WorkSpaces: (parcelRequire("cDZ1P")),
    CodeStar: (parcelRequire("3wIkS")),
    LexModelBuildingService: (parcelRequire("c6WOe")),
    MarketplaceEntitlementService: (parcelRequire("cIgpK")),
    Athena: (parcelRequire("8qyF3")),
    Greengrass: (parcelRequire("5wQjN")),
    DAX: (parcelRequire("fi1HW")),
    MigrationHub: (parcelRequire("dbKPa")),
    CloudHSMV2: (parcelRequire("1ZwQB")),
    Glue: (parcelRequire("hrZED")),
    Mobile: (parcelRequire("59O1g")),
    Pricing: (parcelRequire("ahwWJ")),
    CostExplorer: (parcelRequire("61k9P")),
    MediaConvert: (parcelRequire("62HZl")),
    MediaLive: (parcelRequire("iwTb8")),
    MediaPackage: (parcelRequire("5ya3x")),
    MediaStore: (parcelRequire("azr8B")),
    MediaStoreData: (parcelRequire("1MQ84")),
    AppSync: (parcelRequire("b1wwb")),
    GuardDuty: (parcelRequire("bhpjB")),
    MQ: (parcelRequire("ktBtX")),
    Comprehend: (parcelRequire("gCZWu")),
    IoTJobsDataPlane: (parcelRequire("1ctS0")),
    KinesisVideoArchivedMedia: (parcelRequire("9qanA")),
    KinesisVideoMedia: (parcelRequire("9bbp1")),
    KinesisVideo: (parcelRequire("9fffT")),
    SageMakerRuntime: (parcelRequire("5EOKc")),
    SageMaker: (parcelRequire("k3VkF")),
    Translate: (parcelRequire("gLVBK")),
    ResourceGroups: (parcelRequire("aA9R8")),
    AlexaForBusiness: (parcelRequire("1McK4")),
    Cloud9: (parcelRequire("j9Dj4")),
    ServerlessApplicationRepository: (parcelRequire("3zsbm")),
    ServiceDiscovery: (parcelRequire("x3czj")),
    WorkMail: (parcelRequire("86pyA")),
    AutoScalingPlans: (parcelRequire("l4KIK")),
    TranscribeService: (parcelRequire("dwg5e")),
    Connect: (parcelRequire("bkZtL")),
    ACMPCA: (parcelRequire("92RjP")),
    FMS: (parcelRequire("e9PgI")),
    SecretsManager: (parcelRequire("afQhB")),
    IoTAnalytics: (parcelRequire("c4Auk")),
    IoT1ClickDevicesService: (parcelRequire("j4h8u")),
    IoT1ClickProjects: (parcelRequire("XW1VW")),
    PI: (parcelRequire("6TmrW")),
    Neptune: (parcelRequire("dxfDP")),
    MediaTailor: (parcelRequire("iUX15")),
    EKS: (parcelRequire("kSCoZ")),
    Macie: (parcelRequire("9HUEc")),
    DLM: (parcelRequire("8Isi7")),
    Signer: (parcelRequire("1dwEY")),
    Chime: (parcelRequire("7NETQ")),
    PinpointEmail: (parcelRequire("cLTJx")),
    RAM: (parcelRequire("dOzzt")),
    Route53Resolver: (parcelRequire("5ufha")),
    PinpointSMSVoice: (parcelRequire("3yBwy")),
    QuickSight: (parcelRequire("il6YC")),
    RDSDataService: (parcelRequire("3FYNA")),
    Amplify: (parcelRequire("dlJxB")),
    DataSync: (parcelRequire("4IPZ5")),
    RoboMaker: (parcelRequire("jSc6B")),
    Transfer: (parcelRequire("35PO7")),
    GlobalAccelerator: (parcelRequire("iXtd0")),
    ComprehendMedical: (parcelRequire("eBfVx")),
    KinesisAnalyticsV2: (parcelRequire("cpzJU")),
    MediaConnect: (parcelRequire("cYUp8")),
    FSx: (parcelRequire("8FG7D")),
    SecurityHub: (parcelRequire("gRQWf")),
    AppMesh: (parcelRequire("e9g2s")),
    LicenseManager: (parcelRequire("6SiC5")),
    Kafka: (parcelRequire("2L4Zo")),
    ApiGatewayManagementApi: (parcelRequire("3h5GF")),
    ApiGatewayV2: (parcelRequire("kJOLS")),
    DocDB: (parcelRequire("iNer6")),
    Backup: (parcelRequire("ap3cB")),
    WorkLink: (parcelRequire("aKTDz")),
    Textract: (parcelRequire("54Djg")),
    ManagedBlockchain: (parcelRequire("bdvfx")),
    MediaPackageVod: (parcelRequire("5HK0a")),
    GroundStation: (parcelRequire("2Z6oX")),
    IoTThingsGraph: (parcelRequire("7vbsP")),
    IoTEvents: (parcelRequire("bZ5ph")),
    IoTEventsData: (parcelRequire("7EhQV")),
    Personalize: (parcelRequire("gM8i6")),
    PersonalizeEvents: (parcelRequire("jXOED")),
    PersonalizeRuntime: (parcelRequire("dw836")),
    ApplicationInsights: (parcelRequire("fxe10")),
    ServiceQuotas: (parcelRequire("aJDKj")),
    EC2InstanceConnect: (parcelRequire("bCxOy")),
    EventBridge: (parcelRequire("74y33")),
    LakeFormation: (parcelRequire("c90QS")),
    ForecastService: (parcelRequire("cvExU")),
    ForecastQueryService: (parcelRequire("cfIZP"))
};

});
parcelRequire.register("llFHp", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $f8abe7b9059d1087$var$Service = $dbC7k.Service;
var $f8abe7b9059d1087$var$apiLoader = $dbC7k.apiLoader;
$f8abe7b9059d1087$var$apiLoader.services["acm"] = {};
$dbC7k.ACM = $f8abe7b9059d1087$var$Service.defineService("acm", [
    "2015-12-08"
]);



Object.defineProperty($f8abe7b9059d1087$var$apiLoader.services["acm"], "2015-12-08", {
    get: function get() {
        var model = (parcelRequire("81CYo"));
        model.paginators = (parcelRequire("6igGI")).pagination;
        model.waiters = (parcelRequire("2a5xB")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ACM;

});
parcelRequire.register("81CYo", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-12-08","endpointPrefix":"acm","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"ACM","serviceFullName":"AWS Certificate Manager","serviceId":"ACM","signatureVersion":"v4","targetPrefix":"CertificateManager","uid":"acm-2015-12-08"},"operations":{"AddTagsToCertificate":{"input":{"type":"structure","required":["CertificateArn","Tags"],"members":{"CertificateArn":{},"Tags":{"shape":"S3"}}}},"DeleteCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}}},"DescribeCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"output":{"type":"structure","members":{"Certificate":{"type":"structure","members":{"CertificateArn":{},"DomainName":{},"SubjectAlternativeNames":{"shape":"Sc"},"DomainValidationOptions":{"shape":"Sd"},"Serial":{},"Subject":{},"Issuer":{},"CreatedAt":{"type":"timestamp"},"IssuedAt":{"type":"timestamp"},"ImportedAt":{"type":"timestamp"},"Status":{},"RevokedAt":{"type":"timestamp"},"RevocationReason":{},"NotBefore":{"type":"timestamp"},"NotAfter":{"type":"timestamp"},"KeyAlgorithm":{},"SignatureAlgorithm":{},"InUseBy":{"type":"list","member":{}},"FailureReason":{},"Type":{},"RenewalSummary":{"type":"structure","required":["RenewalStatus","DomainValidationOptions","UpdatedAt"],"members":{"RenewalStatus":{},"DomainValidationOptions":{"shape":"Sd"},"RenewalStatusReason":{},"UpdatedAt":{"type":"timestamp"}}},"KeyUsages":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"ExtendedKeyUsages":{"type":"list","member":{"type":"structure","members":{"Name":{},"OID":{}}}},"CertificateAuthorityArn":{},"RenewalEligibility":{},"Options":{"shape":"S11"}}}}}},"ExportCertificate":{"input":{"type":"structure","required":["CertificateArn","Passphrase"],"members":{"CertificateArn":{},"Passphrase":{"type":"blob","sensitive":true}}},"output":{"type":"structure","members":{"Certificate":{},"CertificateChain":{},"PrivateKey":{"type":"string","sensitive":true}}}},"GetCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"output":{"type":"structure","members":{"Certificate":{},"CertificateChain":{}}}},"ImportCertificate":{"input":{"type":"structure","required":["Certificate","PrivateKey"],"members":{"CertificateArn":{},"Certificate":{"type":"blob"},"PrivateKey":{"type":"blob","sensitive":true},"CertificateChain":{"type":"blob"}}},"output":{"type":"structure","members":{"CertificateArn":{}}}},"ListCertificates":{"input":{"type":"structure","members":{"CertificateStatuses":{"type":"list","member":{}},"Includes":{"type":"structure","members":{"extendedKeyUsage":{"type":"list","member":{}},"keyUsage":{"type":"list","member":{}},"keyTypes":{"type":"list","member":{}}}},"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"CertificateSummaryList":{"type":"list","member":{"type":"structure","members":{"CertificateArn":{},"DomainName":{}}}}}}},"ListTagsForCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S3"}}}},"RemoveTagsFromCertificate":{"input":{"type":"structure","required":["CertificateArn","Tags"],"members":{"CertificateArn":{},"Tags":{"shape":"S3"}}}},"RenewCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}}},"RequestCertificate":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"ValidationMethod":{},"SubjectAlternativeNames":{"shape":"Sc"},"IdempotencyToken":{},"DomainValidationOptions":{"type":"list","member":{"type":"structure","required":["DomainName","ValidationDomain"],"members":{"DomainName":{},"ValidationDomain":{}}}},"Options":{"shape":"S11"},"CertificateAuthorityArn":{}}},"output":{"type":"structure","members":{"CertificateArn":{}}}},"ResendValidationEmail":{"input":{"type":"structure","required":["CertificateArn","Domain","ValidationDomain"],"members":{"CertificateArn":{},"Domain":{},"ValidationDomain":{}}}},"UpdateCertificateOptions":{"input":{"type":"structure","required":["CertificateArn","Options"],"members":{"CertificateArn":{},"Options":{"shape":"S11"}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sc":{"type":"list","member":{}},"Sd":{"type":"list","member":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"ValidationEmails":{"type":"list","member":{}},"ValidationDomain":{},"ValidationStatus":{},"ResourceRecord":{"type":"structure","required":["Name","Type","Value"],"members":{"Name":{},"Type":{},"Value":{}}},"ValidationMethod":{}}}},"S11":{"type":"structure","members":{"CertificateTransparencyLoggingPreference":{}}}}}');

});

parcelRequire.register("6igGI", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListCertificates":{"input_token":"NextToken","limit_key":"MaxItems","output_token":"NextToken","result_key":"CertificateSummaryList"}}}');

});

parcelRequire.register("2a5xB", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"CertificateValidated":{"delay":60,"maxAttempts":40,"operation":"DescribeCertificate","acceptors":[{"matcher":"pathAll","expected":"SUCCESS","argument":"Certificate.DomainValidationOptions[].ValidationStatus","state":"success"},{"matcher":"pathAny","expected":"PENDING_VALIDATION","argument":"Certificate.DomainValidationOptions[].ValidationStatus","state":"retry"},{"matcher":"path","expected":"FAILED","argument":"Certificate.Status","state":"failure"},{"matcher":"error","expected":"ResourceNotFoundException","state":"failure"}]}}}');

});


parcelRequire.register("ietQp", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $d460af489c4f313d$var$Service = $dbC7k.Service;
var $d460af489c4f313d$var$apiLoader = $dbC7k.apiLoader;
$d460af489c4f313d$var$apiLoader.services["apigateway"] = {};
$dbC7k.APIGateway = $d460af489c4f313d$var$Service.defineService("apigateway", [
    "2015-07-09"
]);
parcelRequire("kddgx");


Object.defineProperty($d460af489c4f313d$var$apiLoader.services["apigateway"], "2015-07-09", {
    get: function get() {
        var model = (parcelRequire("bYs97"));
        model.paginators = (parcelRequire("cZWLf")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.APIGateway;

});
parcelRequire.register("kddgx", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
$dbC7k.util.update($dbC7k.APIGateway.prototype, {
    /**
 * Sets the Accept header to application/json.
 *
 * @api private
 */ setAcceptHeader: function setAcceptHeader(req) {
        var httpRequest = req.httpRequest;
        if (!httpRequest.headers.Accept) httpRequest.headers["Accept"] = "application/json";
    },
    /**
   * @api private
   */ setupRequestListeners: function setupRequestListeners(request) {
        request.addListener("build", this.setAcceptHeader);
        if (request.operation === "getExport") {
            var params = request.params || {};
            if (params.exportType === "swagger") request.addListener("extractData", $dbC7k.util.convertPayloadToString);
        }
    }
});

});

parcelRequire.register("bYs97", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-07-09","endpointPrefix":"apigateway","protocol":"rest-json","serviceFullName":"Amazon API Gateway","serviceId":"API Gateway","signatureVersion":"v4","uid":"apigateway-2015-07-09"},"operations":{"CreateApiKey":{"http":{"requestUri":"/apikeys","responseCode":201},"input":{"type":"structure","members":{"name":{},"description":{},"enabled":{"type":"boolean"},"generateDistinctId":{"type":"boolean"},"value":{},"stageKeys":{"type":"list","member":{"type":"structure","members":{"restApiId":{},"stageName":{}}}},"customerId":{},"tags":{"shape":"S6"}}},"output":{"shape":"S7"}},"CreateAuthorizer":{"http":{"requestUri":"/restapis/{restapi_id}/authorizers","responseCode":201},"input":{"type":"structure","required":["restApiId","name","type"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"name":{},"type":{},"providerARNs":{"shape":"Sc"},"authType":{},"authorizerUri":{},"authorizerCredentials":{},"identitySource":{},"identityValidationExpression":{},"authorizerResultTtlInSeconds":{"type":"integer"}}},"output":{"shape":"Sf"}},"CreateBasePathMapping":{"http":{"requestUri":"/domainnames/{domain_name}/basepathmappings","responseCode":201},"input":{"type":"structure","required":["domainName","restApiId"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{},"restApiId":{},"stage":{}}},"output":{"shape":"Sh"}},"CreateDeployment":{"http":{"requestUri":"/restapis/{restapi_id}/deployments","responseCode":201},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{},"stageDescription":{},"description":{},"cacheClusterEnabled":{"type":"boolean"},"cacheClusterSize":{},"variables":{"shape":"S6"},"canarySettings":{"type":"structure","members":{"percentTraffic":{"type":"double"},"stageVariableOverrides":{"shape":"S6"},"useStageCache":{"type":"boolean"}}},"tracingEnabled":{"type":"boolean"}}},"output":{"shape":"Sn"}},"CreateDocumentationPart":{"http":{"requestUri":"/restapis/{restapi_id}/documentation/parts","responseCode":201},"input":{"type":"structure","required":["restApiId","location","properties"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"location":{"shape":"Ss"},"properties":{}}},"output":{"shape":"Sv"}},"CreateDocumentationVersion":{"http":{"requestUri":"/restapis/{restapi_id}/documentation/versions","responseCode":201},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{},"stageName":{},"description":{}}},"output":{"shape":"Sx"}},"CreateDomainName":{"http":{"requestUri":"/domainnames","responseCode":201},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{},"certificateName":{},"certificateBody":{},"certificatePrivateKey":{},"certificateChain":{},"certificateArn":{},"regionalCertificateName":{},"regionalCertificateArn":{},"endpointConfiguration":{"shape":"Sz"},"tags":{"shape":"S6"},"securityPolicy":{}}},"output":{"shape":"S13"}},"CreateModel":{"http":{"requestUri":"/restapis/{restapi_id}/models","responseCode":201},"input":{"type":"structure","required":["restApiId","name","contentType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"name":{},"description":{},"schema":{},"contentType":{}}},"output":{"shape":"S16"}},"CreateRequestValidator":{"http":{"requestUri":"/restapis/{restapi_id}/requestvalidators","responseCode":201},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"name":{},"validateRequestBody":{"type":"boolean"},"validateRequestParameters":{"type":"boolean"}}},"output":{"shape":"S18"}},"CreateResource":{"http":{"requestUri":"/restapis/{restapi_id}/resources/{parent_id}","responseCode":201},"input":{"type":"structure","required":["restApiId","parentId","pathPart"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"parentId":{"location":"uri","locationName":"parent_id"},"pathPart":{}}},"output":{"shape":"S1a"}},"CreateRestApi":{"http":{"requestUri":"/restapis","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"version":{},"cloneFrom":{},"binaryMediaTypes":{"shape":"S9"},"minimumCompressionSize":{"type":"integer"},"apiKeySource":{},"endpointConfiguration":{"shape":"Sz"},"policy":{},"tags":{"shape":"S6"}}},"output":{"shape":"S1q"}},"CreateStage":{"http":{"requestUri":"/restapis/{restapi_id}/stages","responseCode":201},"input":{"type":"structure","required":["restApiId","stageName","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{},"deploymentId":{},"description":{},"cacheClusterEnabled":{"type":"boolean"},"cacheClusterSize":{},"variables":{"shape":"S6"},"documentationVersion":{},"canarySettings":{"shape":"S1s"},"tracingEnabled":{"type":"boolean"},"tags":{"shape":"S6"}}},"output":{"shape":"S1t"}},"CreateUsagePlan":{"http":{"requestUri":"/usageplans","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"apiStages":{"shape":"S20"},"throttle":{"shape":"S23"},"quota":{"shape":"S24"},"tags":{"shape":"S6"}}},"output":{"shape":"S26"}},"CreateUsagePlanKey":{"http":{"requestUri":"/usageplans/{usageplanId}/keys","responseCode":201},"input":{"type":"structure","required":["usagePlanId","keyId","keyType"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{},"keyType":{}}},"output":{"shape":"S28"}},"CreateVpcLink":{"http":{"requestUri":"/vpclinks","responseCode":202},"input":{"type":"structure","required":["name","targetArns"],"members":{"name":{},"description":{},"targetArns":{"shape":"S9"},"tags":{"shape":"S6"}}},"output":{"shape":"S2a"}},"DeleteApiKey":{"http":{"method":"DELETE","requestUri":"/apikeys/{api_Key}","responseCode":202},"input":{"type":"structure","required":["apiKey"],"members":{"apiKey":{"location":"uri","locationName":"api_Key"}}}},"DeleteAuthorizer":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"}}}},"DeleteBasePathMapping":{"http":{"method":"DELETE","requestUri":"/domainnames/{domain_name}/basepathmappings/{base_path}","responseCode":202},"input":{"type":"structure","required":["domainName","basePath"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{"location":"uri","locationName":"base_path"}}}},"DeleteClientCertificate":{"http":{"method":"DELETE","requestUri":"/clientcertificates/{clientcertificate_id}","responseCode":202},"input":{"type":"structure","required":["clientCertificateId"],"members":{"clientCertificateId":{"location":"uri","locationName":"clientcertificate_id"}}}},"DeleteDeployment":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/deployments/{deployment_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"uri","locationName":"deployment_id"}}}},"DeleteDocumentationPart":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/documentation/parts/{part_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","documentationPartId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationPartId":{"location":"uri","locationName":"part_id"}}}},"DeleteDocumentationVersion":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/documentation/versions/{doc_version}","responseCode":202},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{"location":"uri","locationName":"doc_version"}}}},"DeleteDomainName":{"http":{"method":"DELETE","requestUri":"/domainnames/{domain_name}","responseCode":202},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"}}}},"DeleteGatewayResponse":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}","responseCode":202},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"}}}},"DeleteIntegration":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}}},"DeleteIntegrationResponse":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}}},"DeleteMethod":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}}},"DeleteMethodResponse":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}}},"DeleteModel":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/models/{model_name}","responseCode":202},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"}}}},"DeleteRequestValidator":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","requestValidatorId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"requestValidatorId":{"location":"uri","locationName":"requestvalidator_id"}}}},"DeleteResource":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","resourceId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"}}}},"DeleteRestApi":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}","responseCode":202},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"}}}},"DeleteStage":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/stages/{stage_name}","responseCode":202},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}}},"DeleteUsagePlan":{"http":{"method":"DELETE","requestUri":"/usageplans/{usageplanId}","responseCode":202},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"}}}},"DeleteUsagePlanKey":{"http":{"method":"DELETE","requestUri":"/usageplans/{usageplanId}/keys/{keyId}","responseCode":202},"input":{"type":"structure","required":["usagePlanId","keyId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"uri","locationName":"keyId"}}}},"DeleteVpcLink":{"http":{"method":"DELETE","requestUri":"/vpclinks/{vpclink_id}","responseCode":202},"input":{"type":"structure","required":["vpcLinkId"],"members":{"vpcLinkId":{"location":"uri","locationName":"vpclink_id"}}}},"FlushStageAuthorizersCache":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/cache/authorizers","responseCode":202},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}}},"FlushStageCache":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/cache/data","responseCode":202},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}}},"GenerateClientCertificate":{"http":{"requestUri":"/clientcertificates","responseCode":201},"input":{"type":"structure","members":{"description":{},"tags":{"shape":"S6"}}},"output":{"shape":"S31"}},"GetAccount":{"http":{"method":"GET","requestUri":"/account"},"input":{"type":"structure","members":{}},"output":{"shape":"S33"}},"GetApiKey":{"http":{"method":"GET","requestUri":"/apikeys/{api_Key}"},"input":{"type":"structure","required":["apiKey"],"members":{"apiKey":{"location":"uri","locationName":"api_Key"},"includeValue":{"location":"querystring","locationName":"includeValue","type":"boolean"}}},"output":{"shape":"S7"}},"GetApiKeys":{"http":{"method":"GET","requestUri":"/apikeys"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"nameQuery":{"location":"querystring","locationName":"name"},"customerId":{"location":"querystring","locationName":"customerId"},"includeValues":{"location":"querystring","locationName":"includeValues","type":"boolean"}}},"output":{"type":"structure","members":{"warnings":{"shape":"S9"},"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S7"}}}}},"GetAuthorizer":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}"},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"}}},"output":{"shape":"Sf"}},"GetAuthorizers":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/authorizers"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sf"}}}}},"GetBasePathMapping":{"http":{"method":"GET","requestUri":"/domainnames/{domain_name}/basepathmappings/{base_path}"},"input":{"type":"structure","required":["domainName","basePath"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{"location":"uri","locationName":"base_path"}}},"output":{"shape":"Sh"}},"GetBasePathMappings":{"http":{"method":"GET","requestUri":"/domainnames/{domain_name}/basepathmappings"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sh"}}}}},"GetClientCertificate":{"http":{"method":"GET","requestUri":"/clientcertificates/{clientcertificate_id}"},"input":{"type":"structure","required":["clientCertificateId"],"members":{"clientCertificateId":{"location":"uri","locationName":"clientcertificate_id"}}},"output":{"shape":"S31"}},"GetClientCertificates":{"http":{"method":"GET","requestUri":"/clientcertificates"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S31"}}}}},"GetDeployment":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/deployments/{deployment_id}"},"input":{"type":"structure","required":["restApiId","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"uri","locationName":"deployment_id"},"embed":{"shape":"S9","location":"querystring","locationName":"embed"}}},"output":{"shape":"Sn"}},"GetDeployments":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/deployments"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sn"}}}}},"GetDocumentationPart":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/parts/{part_id}"},"input":{"type":"structure","required":["restApiId","documentationPartId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationPartId":{"location":"uri","locationName":"part_id"}}},"output":{"shape":"Sv"}},"GetDocumentationParts":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/parts"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"type":{"location":"querystring","locationName":"type"},"nameQuery":{"location":"querystring","locationName":"name"},"path":{"location":"querystring","locationName":"path"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"locationStatus":{"location":"querystring","locationName":"locationStatus"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sv"}}}}},"GetDocumentationVersion":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/versions/{doc_version}"},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{"location":"uri","locationName":"doc_version"}}},"output":{"shape":"Sx"}},"GetDocumentationVersions":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/versions"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sx"}}}}},"GetDomainName":{"http":{"method":"GET","requestUri":"/domainnames/{domain_name}"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"}}},"output":{"shape":"S13"}},"GetDomainNames":{"http":{"method":"GET","requestUri":"/domainnames"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S13"}}}}},"GetExport":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/exports/{export_type}","responseCode":200},"input":{"type":"structure","required":["restApiId","stageName","exportType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"},"exportType":{"location":"uri","locationName":"export_type"},"parameters":{"shape":"S6","location":"querystring"},"accepts":{"location":"header","locationName":"Accept"}}},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"contentDisposition":{"location":"header","locationName":"Content-Disposition"},"body":{"type":"blob"}},"payload":"body"}},"GetGatewayResponse":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}"},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"}}},"output":{"shape":"S45"}},"GetGatewayResponses":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/gatewayresponses"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S45"}}}}},"GetIntegration":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}},"output":{"shape":"S1h"}},"GetIntegrationResponse":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}},"output":{"shape":"S1n"}},"GetMethod":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}},"output":{"shape":"S1c"}},"GetMethodResponse":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}},"output":{"shape":"S1f"}},"GetModel":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/models/{model_name}"},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"},"flatten":{"location":"querystring","locationName":"flatten","type":"boolean"}}},"output":{"shape":"S16"}},"GetModelTemplate":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/models/{model_name}/default_template"},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"}}},"output":{"type":"structure","members":{"value":{}}}},"GetModels":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/models"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S16"}}}}},"GetRequestValidator":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}"},"input":{"type":"structure","required":["restApiId","requestValidatorId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"requestValidatorId":{"location":"uri","locationName":"requestvalidator_id"}}},"output":{"shape":"S18"}},"GetRequestValidators":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/requestvalidators"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S18"}}}}},"GetResource":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}"},"input":{"type":"structure","required":["restApiId","resourceId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"embed":{"shape":"S9","location":"querystring","locationName":"embed"}}},"output":{"shape":"S1a"}},"GetResources":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"embed":{"shape":"S9","location":"querystring","locationName":"embed"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S1a"}}}}},"GetRestApi":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"}}},"output":{"shape":"S1q"}},"GetRestApis":{"http":{"method":"GET","requestUri":"/restapis"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S1q"}}}}},"GetSdk":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/sdks/{sdk_type}","responseCode":200},"input":{"type":"structure","required":["restApiId","stageName","sdkType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"},"sdkType":{"location":"uri","locationName":"sdk_type"},"parameters":{"shape":"S6","location":"querystring"}}},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"contentDisposition":{"location":"header","locationName":"Content-Disposition"},"body":{"type":"blob"}},"payload":"body"}},"GetSdkType":{"http":{"method":"GET","requestUri":"/sdktypes/{sdktype_id}"},"input":{"type":"structure","required":["id"],"members":{"id":{"location":"uri","locationName":"sdktype_id"}}},"output":{"shape":"S4y"}},"GetSdkTypes":{"http":{"method":"GET","requestUri":"/sdktypes"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S4y"}}}}},"GetStage":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages/{stage_name}"},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}},"output":{"shape":"S1t"}},"GetStages":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"querystring","locationName":"deploymentId"}}},"output":{"type":"structure","members":{"item":{"type":"list","member":{"shape":"S1t"}}}}},"GetTags":{"http":{"method":"GET","requestUri":"/tags/{resource_arn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resource_arn"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"tags":{"shape":"S6"}}}},"GetUsage":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}/usage"},"input":{"type":"structure","required":["usagePlanId","startDate","endDate"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"querystring","locationName":"keyId"},"startDate":{"location":"querystring","locationName":"startDate"},"endDate":{"location":"querystring","locationName":"endDate"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"shape":"S5b"}},"GetUsagePlan":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}"},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"}}},"output":{"shape":"S26"}},"GetUsagePlanKey":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}/keys/{keyId}","responseCode":200},"input":{"type":"structure","required":["usagePlanId","keyId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"uri","locationName":"keyId"}}},"output":{"shape":"S28"}},"GetUsagePlanKeys":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}/keys"},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"nameQuery":{"location":"querystring","locationName":"name"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S28"}}}}},"GetUsagePlans":{"http":{"method":"GET","requestUri":"/usageplans"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"keyId":{"location":"querystring","locationName":"keyId"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S26"}}}}},"GetVpcLink":{"http":{"method":"GET","requestUri":"/vpclinks/{vpclink_id}"},"input":{"type":"structure","required":["vpcLinkId"],"members":{"vpcLinkId":{"location":"uri","locationName":"vpclink_id"}}},"output":{"shape":"S2a"}},"GetVpcLinks":{"http":{"method":"GET","requestUri":"/vpclinks"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S2a"}}}}},"ImportApiKeys":{"http":{"requestUri":"/apikeys?mode=import","responseCode":201},"input":{"type":"structure","required":["body","format"],"members":{"body":{"type":"blob"},"format":{"location":"querystring","locationName":"format"},"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"}},"payload":"body"},"output":{"type":"structure","members":{"ids":{"shape":"S9"},"warnings":{"shape":"S9"}}}},"ImportDocumentationParts":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/documentation/parts"},"input":{"type":"structure","required":["restApiId","body"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"mode":{"location":"querystring","locationName":"mode"},"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"},"body":{"type":"blob"}},"payload":"body"},"output":{"type":"structure","members":{"ids":{"shape":"S9"},"warnings":{"shape":"S9"}}}},"ImportRestApi":{"http":{"requestUri":"/restapis?mode=import","responseCode":201},"input":{"type":"structure","required":["body"],"members":{"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"},"parameters":{"shape":"S6","location":"querystring"},"body":{"type":"blob"}},"payload":"body"},"output":{"shape":"S1q"}},"PutGatewayResponse":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}","responseCode":201},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"},"statusCode":{},"responseParameters":{"shape":"S6"},"responseTemplates":{"shape":"S6"}}},"output":{"shape":"S45"}},"PutIntegration":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","type"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"type":{},"integrationHttpMethod":{"locationName":"httpMethod"},"uri":{},"connectionType":{},"connectionId":{},"credentials":{},"requestParameters":{"shape":"S6"},"requestTemplates":{"shape":"S6"},"passthroughBehavior":{},"cacheNamespace":{},"cacheKeyParameters":{"shape":"S9"},"contentHandling":{},"timeoutInMillis":{"type":"integer"}}},"output":{"shape":"S1h"}},"PutIntegrationResponse":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"selectionPattern":{},"responseParameters":{"shape":"S6"},"responseTemplates":{"shape":"S6"},"contentHandling":{}}},"output":{"shape":"S1n"}},"PutMethod":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","authorizationType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"authorizationType":{},"authorizerId":{},"apiKeyRequired":{"type":"boolean"},"operationName":{},"requestParameters":{"shape":"S1d"},"requestModels":{"shape":"S6"},"requestValidatorId":{},"authorizationScopes":{"shape":"S9"}}},"output":{"shape":"S1c"}},"PutMethodResponse":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"responseParameters":{"shape":"S1d"},"responseModels":{"shape":"S6"}}},"output":{"shape":"S1f"}},"PutRestApi":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}"},"input":{"type":"structure","required":["restApiId","body"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"mode":{"location":"querystring","locationName":"mode"},"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"},"parameters":{"shape":"S6","location":"querystring"},"body":{"type":"blob"}},"payload":"body"},"output":{"shape":"S1q"}},"TagResource":{"http":{"method":"PUT","requestUri":"/tags/{resource_arn}","responseCode":204},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resource_arn"},"tags":{"shape":"S6"}}}},"TestInvokeAuthorizer":{"http":{"requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}"},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"},"headers":{"shape":"S6"},"multiValueHeaders":{"shape":"S67"},"pathWithQueryString":{},"body":{},"stageVariables":{"shape":"S6"},"additionalContext":{"shape":"S6"}}},"output":{"type":"structure","members":{"clientStatus":{"type":"integer"},"log":{},"latency":{"type":"long"},"principalId":{},"policy":{},"authorization":{"shape":"S67"},"claims":{"shape":"S6"}}}},"TestInvokeMethod":{"http":{"requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"pathWithQueryString":{},"body":{},"headers":{"shape":"S6"},"multiValueHeaders":{"shape":"S67"},"clientCertificateId":{},"stageVariables":{"shape":"S6"}}},"output":{"type":"structure","members":{"status":{"type":"integer"},"body":{},"headers":{"shape":"S6"},"multiValueHeaders":{"shape":"S67"},"log":{},"latency":{"type":"long"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resource_arn}","responseCode":204},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resource_arn"},"tagKeys":{"shape":"S9","location":"querystring","locationName":"tagKeys"}}}},"UpdateAccount":{"http":{"method":"PATCH","requestUri":"/account"},"input":{"type":"structure","members":{"patchOperations":{"shape":"S6d"}}},"output":{"shape":"S33"}},"UpdateApiKey":{"http":{"method":"PATCH","requestUri":"/apikeys/{api_Key}"},"input":{"type":"structure","required":["apiKey"],"members":{"apiKey":{"location":"uri","locationName":"api_Key"},"patchOperations":{"shape":"S6d"}}},"output":{"shape":"S7"}},"UpdateAuthorizer":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}"},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"},"patchOperations":{"shape":"S6d"}}},"output":{"shape":"Sf"}},"UpdateBasePathMapping":{"http":{"method":"PATCH","requestUri":"/domainnames/{domain_name}/basepathmappings/{base_path}"},"input":{"type":"structure","required":["domainName","basePath"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{"location":"uri","locationName":"base_path"},"patchOperations":{"shape":"S6d"}}},"output":{"shape":"Sh"}},"UpdateClientCertificate":{"http":{"method":"PATCH","requestUri":"/clientcertificates/{clientcertificate_id}"},"input":{"type":"structure","required":["clientCertificateId"],"members":{"clientCertificateId":{"location":"uri","locationName":"clientcertificate_id"},"patchOperations":{"shape":"S6d"}}},"output":{"shape":"S31"}},"UpdateDeployment":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/deployments/{deployment_id}"},"input":{"type":"structure","required":["restApiId","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"uri","locationName":"deployment_id"},"patchOperations":{"shape":"S6d"}}},"output":{"shape":"Sn"}},"UpdateDocumentationPart":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/documentation/parts/{part_id}"},"input":{"type":"structure","required":["restApiId","documentationPartId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationPartId":{"location":"uri","locationName":"part_id"},"patchOperations":{"shape":"S6d"}}},"output":{"shape":"Sv"}},"UpdateDocumentationVersion":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/documentation/versions/{doc_version}"},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{"location":"uri","locationName":"doc_version"},"patchOperations":{"shape":"S6d"}}},"output":{"shape":"Sx"}},"UpdateDomainName":{"http":{"method":"PATCH","requestUri":"/domainnames/{domain_name}"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"patchOperations":{"shape":"S6d"}}},"output":{"shape":"S13"}},"UpdateGatewayResponse":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}"},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"},"patchOperations":{"shape":"S6d"}}},"output":{"shape":"S45"}},"UpdateIntegration":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"patchOperations":{"shape":"S6d"}}},"output":{"shape":"S1h"}},"UpdateIntegrationResponse":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"patchOperations":{"shape":"S6d"}}},"output":{"shape":"S1n"}},"UpdateMethod":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"patchOperations":{"shape":"S6d"}}},"output":{"shape":"S1c"}},"UpdateMethodResponse":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"patchOperations":{"shape":"S6d"}}},"output":{"shape":"S1f"}},"UpdateModel":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/models/{model_name}"},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"},"patchOperations":{"shape":"S6d"}}},"output":{"shape":"S16"}},"UpdateRequestValidator":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}"},"input":{"type":"structure","required":["restApiId","requestValidatorId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"requestValidatorId":{"location":"uri","locationName":"requestvalidator_id"},"patchOperations":{"shape":"S6d"}}},"output":{"shape":"S18"}},"UpdateResource":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}"},"input":{"type":"structure","required":["restApiId","resourceId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"patchOperations":{"shape":"S6d"}}},"output":{"shape":"S1a"}},"UpdateRestApi":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"patchOperations":{"shape":"S6d"}}},"output":{"shape":"S1q"}},"UpdateStage":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/stages/{stage_name}"},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"},"patchOperations":{"shape":"S6d"}}},"output":{"shape":"S1t"}},"UpdateUsage":{"http":{"method":"PATCH","requestUri":"/usageplans/{usageplanId}/keys/{keyId}/usage"},"input":{"type":"structure","required":["usagePlanId","keyId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"uri","locationName":"keyId"},"patchOperations":{"shape":"S6d"}}},"output":{"shape":"S5b"}},"UpdateUsagePlan":{"http":{"method":"PATCH","requestUri":"/usageplans/{usageplanId}"},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"patchOperations":{"shape":"S6d"}}},"output":{"shape":"S26"}},"UpdateVpcLink":{"http":{"method":"PATCH","requestUri":"/vpclinks/{vpclink_id}"},"input":{"type":"structure","required":["vpcLinkId"],"members":{"vpcLinkId":{"location":"uri","locationName":"vpclink_id"},"patchOperations":{"shape":"S6d"}}},"output":{"shape":"S2a"}}},"shapes":{"S6":{"type":"map","key":{},"value":{}},"S7":{"type":"structure","members":{"id":{},"value":{},"name":{},"customerId":{},"description":{},"enabled":{"type":"boolean"},"createdDate":{"type":"timestamp"},"lastUpdatedDate":{"type":"timestamp"},"stageKeys":{"shape":"S9"},"tags":{"shape":"S6"}}},"S9":{"type":"list","member":{}},"Sc":{"type":"list","member":{}},"Sf":{"type":"structure","members":{"id":{},"name":{},"type":{},"providerARNs":{"shape":"Sc"},"authType":{},"authorizerUri":{},"authorizerCredentials":{},"identitySource":{},"identityValidationExpression":{},"authorizerResultTtlInSeconds":{"type":"integer"}}},"Sh":{"type":"structure","members":{"basePath":{},"restApiId":{},"stage":{}}},"Sn":{"type":"structure","members":{"id":{},"description":{},"createdDate":{"type":"timestamp"},"apiSummary":{"type":"map","key":{},"value":{"type":"map","key":{},"value":{"type":"structure","members":{"authorizationType":{},"apiKeyRequired":{"type":"boolean"}}}}}}},"Ss":{"type":"structure","required":["type"],"members":{"type":{},"path":{},"method":{},"statusCode":{},"name":{}}},"Sv":{"type":"structure","members":{"id":{},"location":{"shape":"Ss"},"properties":{}}},"Sx":{"type":"structure","members":{"version":{},"createdDate":{"type":"timestamp"},"description":{}}},"Sz":{"type":"structure","members":{"types":{"type":"list","member":{}}}},"S13":{"type":"structure","members":{"domainName":{},"certificateName":{},"certificateArn":{},"certificateUploadDate":{"type":"timestamp"},"regionalDomainName":{},"regionalHostedZoneId":{},"regionalCertificateName":{},"regionalCertificateArn":{},"distributionDomainName":{},"distributionHostedZoneId":{},"endpointConfiguration":{"shape":"Sz"},"domainNameStatus":{},"domainNameStatusMessage":{},"securityPolicy":{},"tags":{"shape":"S6"}}},"S16":{"type":"structure","members":{"id":{},"name":{},"description":{},"schema":{},"contentType":{}}},"S18":{"type":"structure","members":{"id":{},"name":{},"validateRequestBody":{"type":"boolean"},"validateRequestParameters":{"type":"boolean"}}},"S1a":{"type":"structure","members":{"id":{},"parentId":{},"pathPart":{},"path":{},"resourceMethods":{"type":"map","key":{},"value":{"shape":"S1c"}}}},"S1c":{"type":"structure","members":{"httpMethod":{},"authorizationType":{},"authorizerId":{},"apiKeyRequired":{"type":"boolean"},"requestValidatorId":{},"operationName":{},"requestParameters":{"shape":"S1d"},"requestModels":{"shape":"S6"},"methodResponses":{"type":"map","key":{},"value":{"shape":"S1f"}},"methodIntegration":{"shape":"S1h"},"authorizationScopes":{"shape":"S9"}}},"S1d":{"type":"map","key":{},"value":{"type":"boolean"}},"S1f":{"type":"structure","members":{"statusCode":{},"responseParameters":{"shape":"S1d"},"responseModels":{"shape":"S6"}}},"S1h":{"type":"structure","members":{"type":{},"httpMethod":{},"uri":{},"connectionType":{},"connectionId":{},"credentials":{},"requestParameters":{"shape":"S6"},"requestTemplates":{"shape":"S6"},"passthroughBehavior":{},"contentHandling":{},"timeoutInMillis":{"type":"integer"},"cacheNamespace":{},"cacheKeyParameters":{"shape":"S9"},"integrationResponses":{"type":"map","key":{},"value":{"shape":"S1n"}}}},"S1n":{"type":"structure","members":{"statusCode":{},"selectionPattern":{},"responseParameters":{"shape":"S6"},"responseTemplates":{"shape":"S6"},"contentHandling":{}}},"S1q":{"type":"structure","members":{"id":{},"name":{},"description":{},"createdDate":{"type":"timestamp"},"version":{},"warnings":{"shape":"S9"},"binaryMediaTypes":{"shape":"S9"},"minimumCompressionSize":{"type":"integer"},"apiKeySource":{},"endpointConfiguration":{"shape":"Sz"},"policy":{},"tags":{"shape":"S6"}}},"S1s":{"type":"structure","members":{"percentTraffic":{"type":"double"},"deploymentId":{},"stageVariableOverrides":{"shape":"S6"},"useStageCache":{"type":"boolean"}}},"S1t":{"type":"structure","members":{"deploymentId":{},"clientCertificateId":{},"stageName":{},"description":{},"cacheClusterEnabled":{"type":"boolean"},"cacheClusterSize":{},"cacheClusterStatus":{},"methodSettings":{"type":"map","key":{},"value":{"type":"structure","members":{"metricsEnabled":{"type":"boolean"},"loggingLevel":{},"dataTraceEnabled":{"type":"boolean"},"throttlingBurstLimit":{"type":"integer"},"throttlingRateLimit":{"type":"double"},"cachingEnabled":{"type":"boolean"},"cacheTtlInSeconds":{"type":"integer"},"cacheDataEncrypted":{"type":"boolean"},"requireAuthorizationForCacheControl":{"type":"boolean"},"unauthorizedCacheControlHeaderStrategy":{}}}},"variables":{"shape":"S6"},"documentationVersion":{},"accessLogSettings":{"type":"structure","members":{"format":{},"destinationArn":{}}},"canarySettings":{"shape":"S1s"},"tracingEnabled":{"type":"boolean"},"webAclArn":{},"tags":{"shape":"S6"},"createdDate":{"type":"timestamp"},"lastUpdatedDate":{"type":"timestamp"}}},"S20":{"type":"list","member":{"type":"structure","members":{"apiId":{},"stage":{},"throttle":{"type":"map","key":{},"value":{"shape":"S23"}}}}},"S23":{"type":"structure","members":{"burstLimit":{"type":"integer"},"rateLimit":{"type":"double"}}},"S24":{"type":"structure","members":{"limit":{"type":"integer"},"offset":{"type":"integer"},"period":{}}},"S26":{"type":"structure","members":{"id":{},"name":{},"description":{},"apiStages":{"shape":"S20"},"throttle":{"shape":"S23"},"quota":{"shape":"S24"},"productCode":{},"tags":{"shape":"S6"}}},"S28":{"type":"structure","members":{"id":{},"type":{},"value":{},"name":{}}},"S2a":{"type":"structure","members":{"id":{},"name":{},"description":{},"targetArns":{"shape":"S9"},"status":{},"statusMessage":{},"tags":{"shape":"S6"}}},"S31":{"type":"structure","members":{"clientCertificateId":{},"description":{},"pemEncodedCertificate":{},"createdDate":{"type":"timestamp"},"expirationDate":{"type":"timestamp"},"tags":{"shape":"S6"}}},"S33":{"type":"structure","members":{"cloudwatchRoleArn":{},"throttleSettings":{"shape":"S23"},"features":{"shape":"S9"},"apiKeyVersion":{}}},"S45":{"type":"structure","members":{"responseType":{},"statusCode":{},"responseParameters":{"shape":"S6"},"responseTemplates":{"shape":"S6"},"defaultResponse":{"type":"boolean"}}},"S4y":{"type":"structure","members":{"id":{},"friendlyName":{},"description":{},"configurationProperties":{"type":"list","member":{"type":"structure","members":{"name":{},"friendlyName":{},"description":{},"required":{"type":"boolean"},"defaultValue":{}}}}}},"S5b":{"type":"structure","members":{"usagePlanId":{},"startDate":{},"endDate":{},"position":{},"items":{"locationName":"values","type":"map","key":{},"value":{"type":"list","member":{"type":"list","member":{"type":"long"}}}}}},"S67":{"type":"map","key":{},"value":{"shape":"S9"}},"S6d":{"type":"list","member":{"type":"structure","members":{"op":{},"path":{},"value":{},"from":{}}}}}}');

});

parcelRequire.register("cZWLf", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"GetApiKeys":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetBasePathMappings":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetClientCertificates":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetDeployments":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetDomainNames":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetModels":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetResources":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetRestApis":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetUsage":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetUsagePlanKeys":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetUsagePlans":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetVpcLinks":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"}}}');

});


parcelRequire.register("lxtho", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $fae364538a9d1c04$var$Service = $dbC7k.Service;
var $fae364538a9d1c04$var$apiLoader = $dbC7k.apiLoader;
$fae364538a9d1c04$var$apiLoader.services["applicationautoscaling"] = {};
$dbC7k.ApplicationAutoScaling = $fae364538a9d1c04$var$Service.defineService("applicationautoscaling", [
    "2016-02-06"
]);


Object.defineProperty($fae364538a9d1c04$var$apiLoader.services["applicationautoscaling"], "2016-02-06", {
    get: function get() {
        var model = (parcelRequire("veR93"));
        model.paginators = (parcelRequire("2qgFN")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ApplicationAutoScaling;

});
parcelRequire.register("veR93", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-02-06","endpointPrefix":"autoscaling","jsonVersion":"1.1","protocol":"json","serviceFullName":"Application Auto Scaling","serviceId":"Application Auto Scaling","signatureVersion":"v4","signingName":"application-autoscaling","targetPrefix":"AnyScaleFrontendService","uid":"application-autoscaling-2016-02-06"},"operations":{"DeleteScalingPolicy":{"input":{"type":"structure","required":["PolicyName","ServiceNamespace","ResourceId","ScalableDimension"],"members":{"PolicyName":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{}}},"output":{"type":"structure","members":{}}},"DeleteScheduledAction":{"input":{"type":"structure","required":["ServiceNamespace","ScheduledActionName","ResourceId","ScalableDimension"],"members":{"ServiceNamespace":{},"ScheduledActionName":{},"ResourceId":{},"ScalableDimension":{}}},"output":{"type":"structure","members":{}}},"DeregisterScalableTarget":{"input":{"type":"structure","required":["ServiceNamespace","ResourceId","ScalableDimension"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{}}},"output":{"type":"structure","members":{}}},"DescribeScalableTargets":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"ServiceNamespace":{},"ResourceIds":{"shape":"Sb"},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalableTargets":{"type":"list","member":{"type":"structure","required":["ServiceNamespace","ResourceId","ScalableDimension","MinCapacity","MaxCapacity","RoleARN","CreationTime"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"RoleARN":{},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeScalingActivities":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalingActivities":{"type":"list","member":{"type":"structure","required":["ActivityId","ServiceNamespace","ResourceId","ScalableDimension","Description","Cause","StartTime","StatusCode"],"members":{"ActivityId":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"Description":{},"Cause":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"StatusCode":{},"StatusMessage":{},"Details":{}}}},"NextToken":{}}}},"DescribeScalingPolicies":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"PolicyNames":{"shape":"Sb"},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalingPolicies":{"type":"list","member":{"type":"structure","required":["PolicyARN","PolicyName","ServiceNamespace","ResourceId","ScalableDimension","PolicyType","CreationTime"],"members":{"PolicyARN":{},"PolicyName":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"PolicyType":{},"StepScalingPolicyConfiguration":{"shape":"Sv"},"TargetTrackingScalingPolicyConfiguration":{"shape":"S14"},"Alarms":{"shape":"S1i"},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeScheduledActions":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"ScheduledActionNames":{"shape":"Sb"},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScheduledActions":{"type":"list","member":{"type":"structure","required":["ScheduledActionName","ScheduledActionARN","ServiceNamespace","Schedule","ResourceId","CreationTime"],"members":{"ScheduledActionName":{},"ScheduledActionARN":{},"ServiceNamespace":{},"Schedule":{},"ResourceId":{},"ScalableDimension":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"ScalableTargetAction":{"shape":"S1p"},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"PutScalingPolicy":{"input":{"type":"structure","required":["PolicyName","ServiceNamespace","ResourceId","ScalableDimension"],"members":{"PolicyName":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"PolicyType":{},"StepScalingPolicyConfiguration":{"shape":"Sv"},"TargetTrackingScalingPolicyConfiguration":{"shape":"S14"}}},"output":{"type":"structure","required":["PolicyARN"],"members":{"PolicyARN":{},"Alarms":{"shape":"S1i"}}}},"PutScheduledAction":{"input":{"type":"structure","required":["ServiceNamespace","ScheduledActionName","ResourceId","ScalableDimension"],"members":{"ServiceNamespace":{},"Schedule":{},"ScheduledActionName":{},"ResourceId":{},"ScalableDimension":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"ScalableTargetAction":{"shape":"S1p"}}},"output":{"type":"structure","members":{}}},"RegisterScalableTarget":{"input":{"type":"structure","required":["ServiceNamespace","ResourceId","ScalableDimension"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"RoleARN":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sb":{"type":"list","member":{}},"Sv":{"type":"structure","members":{"AdjustmentType":{},"StepAdjustments":{"type":"list","member":{"type":"structure","required":["ScalingAdjustment"],"members":{"MetricIntervalLowerBound":{"type":"double"},"MetricIntervalUpperBound":{"type":"double"},"ScalingAdjustment":{"type":"integer"}}}},"MinAdjustmentMagnitude":{"type":"integer"},"Cooldown":{"type":"integer"},"MetricAggregationType":{}}},"S14":{"type":"structure","required":["TargetValue"],"members":{"TargetValue":{"type":"double"},"PredefinedMetricSpecification":{"type":"structure","required":["PredefinedMetricType"],"members":{"PredefinedMetricType":{},"ResourceLabel":{}}},"CustomizedMetricSpecification":{"type":"structure","required":["MetricName","Namespace","Statistic"],"members":{"MetricName":{},"Namespace":{},"Dimensions":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"Statistic":{},"Unit":{}}},"ScaleOutCooldown":{"type":"integer"},"ScaleInCooldown":{"type":"integer"},"DisableScaleIn":{"type":"boolean"}}},"S1i":{"type":"list","member":{"type":"structure","required":["AlarmName","AlarmARN"],"members":{"AlarmName":{},"AlarmARN":{}}}},"S1p":{"type":"structure","members":{"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"}}}}}');

});

parcelRequire.register("2qgFN", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeScalableTargets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScalableTargets"},"DescribeScalingActivities":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScalingActivities"},"DescribeScalingPolicies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScalingPolicies"}}}');

});


parcelRequire.register("3kN3i", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $26d94a19c57afd41$var$Service = $dbC7k.Service;
var $26d94a19c57afd41$var$apiLoader = $dbC7k.apiLoader;
$26d94a19c57afd41$var$apiLoader.services["appstream"] = {};
$dbC7k.AppStream = $26d94a19c57afd41$var$Service.defineService("appstream", [
    "2016-12-01"
]);



Object.defineProperty($26d94a19c57afd41$var$apiLoader.services["appstream"], "2016-12-01", {
    get: function get() {
        var model = (parcelRequire("jvtez"));
        model.paginators = (parcelRequire("oCkQR")).pagination;
        model.waiters = (parcelRequire("4telJ")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.AppStream;

});
parcelRequire.register("jvtez", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-12-01","endpointPrefix":"appstream2","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon AppStream","serviceId":"AppStream","signatureVersion":"v4","signingName":"appstream","targetPrefix":"PhotonAdminProxyService","uid":"appstream-2016-12-01"},"operations":{"AssociateFleet":{"input":{"type":"structure","required":["FleetName","StackName"],"members":{"FleetName":{},"StackName":{}}},"output":{"type":"structure","members":{}}},"BatchAssociateUserStack":{"input":{"type":"structure","required":["UserStackAssociations"],"members":{"UserStackAssociations":{"shape":"S5"}}},"output":{"type":"structure","members":{"errors":{"shape":"Sb"}}}},"BatchDisassociateUserStack":{"input":{"type":"structure","required":["UserStackAssociations"],"members":{"UserStackAssociations":{"shape":"S5"}}},"output":{"type":"structure","members":{"errors":{"shape":"Sb"}}}},"CopyImage":{"input":{"type":"structure","required":["SourceImageName","DestinationImageName","DestinationRegion"],"members":{"SourceImageName":{},"DestinationImageName":{},"DestinationRegion":{},"DestinationImageDescription":{}}},"output":{"type":"structure","members":{"DestinationImageName":{}}}},"CreateDirectoryConfig":{"input":{"type":"structure","required":["DirectoryName","OrganizationalUnitDistinguishedNames","ServiceAccountCredentials"],"members":{"DirectoryName":{},"OrganizationalUnitDistinguishedNames":{"shape":"Sn"},"ServiceAccountCredentials":{"shape":"Sp"}}},"output":{"type":"structure","members":{"DirectoryConfig":{"shape":"St"}}}},"CreateFleet":{"input":{"type":"structure","required":["Name","InstanceType","ComputeCapacity"],"members":{"Name":{},"ImageName":{},"ImageArn":{},"InstanceType":{},"FleetType":{},"ComputeCapacity":{"shape":"Sy"},"VpcConfig":{"shape":"S10"},"MaxUserDurationInSeconds":{"type":"integer"},"DisconnectTimeoutInSeconds":{"type":"integer"},"Description":{},"DisplayName":{},"EnableDefaultInternetAccess":{"type":"boolean"},"DomainJoinInfo":{"shape":"S15"},"Tags":{"shape":"S16"},"IdleDisconnectTimeoutInSeconds":{"type":"integer"}}},"output":{"type":"structure","members":{"Fleet":{"shape":"S1a"}}}},"CreateImageBuilder":{"input":{"type":"structure","required":["Name","InstanceType"],"members":{"Name":{},"ImageName":{},"ImageArn":{},"InstanceType":{},"Description":{},"DisplayName":{},"VpcConfig":{"shape":"S10"},"EnableDefaultInternetAccess":{"type":"boolean"},"DomainJoinInfo":{"shape":"S15"},"AppstreamAgentVersion":{},"Tags":{"shape":"S16"},"AccessEndpoints":{"shape":"S1i"}}},"output":{"type":"structure","members":{"ImageBuilder":{"shape":"S1m"}}}},"CreateImageBuilderStreamingURL":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Validity":{"type":"long"}}},"output":{"type":"structure","members":{"StreamingURL":{},"Expires":{"type":"timestamp"}}}},"CreateStack":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"DisplayName":{},"StorageConnectors":{"shape":"S1y"},"RedirectURL":{},"FeedbackURL":{},"UserSettings":{"shape":"S26"},"ApplicationSettings":{"shape":"S2a"},"Tags":{"shape":"S16"},"AccessEndpoints":{"shape":"S1i"}}},"output":{"type":"structure","members":{"Stack":{"shape":"S2d"}}}},"CreateStreamingURL":{"input":{"type":"structure","required":["StackName","FleetName","UserId"],"members":{"StackName":{},"FleetName":{},"UserId":{},"ApplicationId":{},"Validity":{"type":"long"},"SessionContext":{}}},"output":{"type":"structure","members":{"StreamingURL":{},"Expires":{"type":"timestamp"}}}},"CreateUsageReportSubscription":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"S3BucketName":{},"Schedule":{}}}},"CreateUser":{"input":{"type":"structure","required":["UserName","AuthenticationType"],"members":{"UserName":{"shape":"S7"},"MessageAction":{},"FirstName":{"shape":"S2q"},"LastName":{"shape":"S2q"},"AuthenticationType":{}}},"output":{"type":"structure","members":{}}},"DeleteDirectoryConfig":{"input":{"type":"structure","required":["DirectoryName"],"members":{"DirectoryName":{}}},"output":{"type":"structure","members":{}}},"DeleteFleet":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteImage":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Image":{"shape":"S2y"}}}},"DeleteImageBuilder":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"ImageBuilder":{"shape":"S1m"}}}},"DeleteImagePermissions":{"input":{"type":"structure","required":["Name","SharedAccountId"],"members":{"Name":{},"SharedAccountId":{}}},"output":{"type":"structure","members":{}}},"DeleteStack":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteUsageReportSubscription":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DeleteUser":{"input":{"type":"structure","required":["UserName","AuthenticationType"],"members":{"UserName":{"shape":"S7"},"AuthenticationType":{}}},"output":{"type":"structure","members":{}}},"DescribeDirectoryConfigs":{"input":{"type":"structure","members":{"DirectoryNames":{"type":"list","member":{}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DirectoryConfigs":{"type":"list","member":{"shape":"St"}},"NextToken":{}}}},"DescribeFleets":{"input":{"type":"structure","members":{"Names":{"shape":"S3n"},"NextToken":{}}},"output":{"type":"structure","members":{"Fleets":{"type":"list","member":{"shape":"S1a"}},"NextToken":{}}}},"DescribeImageBuilders":{"input":{"type":"structure","members":{"Names":{"shape":"S3n"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ImageBuilders":{"type":"list","member":{"shape":"S1m"}},"NextToken":{}}}},"DescribeImagePermissions":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"MaxResults":{"type":"integer"},"SharedAwsAccountIds":{"type":"list","member":{}},"NextToken":{}}},"output":{"type":"structure","members":{"Name":{},"SharedImagePermissionsList":{"type":"list","member":{"type":"structure","required":["sharedAccountId","imagePermissions"],"members":{"sharedAccountId":{},"imagePermissions":{"shape":"S36"}}}},"NextToken":{}}}},"DescribeImages":{"input":{"type":"structure","members":{"Names":{"shape":"S3n"},"Arns":{"type":"list","member":{}},"Type":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Images":{"type":"list","member":{"shape":"S2y"}},"NextToken":{}}}},"DescribeSessions":{"input":{"type":"structure","required":["StackName","FleetName"],"members":{"StackName":{},"FleetName":{},"UserId":{},"NextToken":{},"Limit":{"type":"integer"},"AuthenticationType":{}}},"output":{"type":"structure","members":{"Sessions":{"type":"list","member":{"type":"structure","required":["Id","UserId","StackName","FleetName","State"],"members":{"Id":{},"UserId":{},"StackName":{},"FleetName":{},"State":{},"ConnectionState":{},"StartTime":{"type":"timestamp"},"MaxExpirationTime":{"type":"timestamp"},"AuthenticationType":{},"NetworkAccessConfiguration":{"shape":"S1r"}}}},"NextToken":{}}}},"DescribeStacks":{"input":{"type":"structure","members":{"Names":{"shape":"S3n"},"NextToken":{}}},"output":{"type":"structure","members":{"Stacks":{"type":"list","member":{"shape":"S2d"}},"NextToken":{}}}},"DescribeUsageReportSubscriptions":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"UsageReportSubscriptions":{"type":"list","member":{"type":"structure","members":{"S3BucketName":{},"Schedule":{},"LastGeneratedReportDate":{"type":"timestamp"},"SubscriptionErrors":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{}}}}}}},"NextToken":{}}}},"DescribeUserStackAssociations":{"input":{"type":"structure","members":{"StackName":{},"UserName":{"shape":"S7"},"AuthenticationType":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"UserStackAssociations":{"shape":"S5"},"NextToken":{}}}},"DescribeUsers":{"input":{"type":"structure","required":["AuthenticationType"],"members":{"AuthenticationType":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Users":{"type":"list","member":{"type":"structure","required":["AuthenticationType"],"members":{"Arn":{},"UserName":{"shape":"S7"},"Enabled":{"type":"boolean"},"Status":{},"FirstName":{"shape":"S2q"},"LastName":{"shape":"S2q"},"CreatedTime":{"type":"timestamp"},"AuthenticationType":{}}}},"NextToken":{}}}},"DisableUser":{"input":{"type":"structure","required":["UserName","AuthenticationType"],"members":{"UserName":{"shape":"S7"},"AuthenticationType":{}}},"output":{"type":"structure","members":{}}},"DisassociateFleet":{"input":{"type":"structure","required":["FleetName","StackName"],"members":{"FleetName":{},"StackName":{}}},"output":{"type":"structure","members":{}}},"EnableUser":{"input":{"type":"structure","required":["UserName","AuthenticationType"],"members":{"UserName":{"shape":"S7"},"AuthenticationType":{}}},"output":{"type":"structure","members":{}}},"ExpireSession":{"input":{"type":"structure","required":["SessionId"],"members":{"SessionId":{}}},"output":{"type":"structure","members":{}}},"ListAssociatedFleets":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"NextToken":{}}},"output":{"type":"structure","members":{"Names":{"shape":"S3n"},"NextToken":{}}}},"ListAssociatedStacks":{"input":{"type":"structure","required":["FleetName"],"members":{"FleetName":{},"NextToken":{}}},"output":{"type":"structure","members":{"Names":{"shape":"S3n"},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S16"}}}},"StartFleet":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"StartImageBuilder":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"AppstreamAgentVersion":{}}},"output":{"type":"structure","members":{"ImageBuilder":{"shape":"S1m"}}}},"StopFleet":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"StopImageBuilder":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"ImageBuilder":{"shape":"S1m"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S16"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDirectoryConfig":{"input":{"type":"structure","required":["DirectoryName"],"members":{"DirectoryName":{},"OrganizationalUnitDistinguishedNames":{"shape":"Sn"},"ServiceAccountCredentials":{"shape":"Sp"}}},"output":{"type":"structure","members":{"DirectoryConfig":{"shape":"St"}}}},"UpdateFleet":{"input":{"type":"structure","members":{"ImageName":{},"ImageArn":{},"Name":{},"InstanceType":{},"ComputeCapacity":{"shape":"Sy"},"VpcConfig":{"shape":"S10"},"MaxUserDurationInSeconds":{"type":"integer"},"DisconnectTimeoutInSeconds":{"type":"integer"},"DeleteVpcConfig":{"deprecated":true,"type":"boolean"},"Description":{},"DisplayName":{},"EnableDefaultInternetAccess":{"type":"boolean"},"DomainJoinInfo":{"shape":"S15"},"IdleDisconnectTimeoutInSeconds":{"type":"integer"},"AttributesToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"Fleet":{"shape":"S1a"}}}},"UpdateImagePermissions":{"input":{"type":"structure","required":["Name","SharedAccountId","ImagePermissions"],"members":{"Name":{},"SharedAccountId":{},"ImagePermissions":{"shape":"S36"}}},"output":{"type":"structure","members":{}}},"UpdateStack":{"input":{"type":"structure","required":["Name"],"members":{"DisplayName":{},"Description":{},"Name":{},"StorageConnectors":{"shape":"S1y"},"DeleteStorageConnectors":{"deprecated":true,"type":"boolean"},"RedirectURL":{},"FeedbackURL":{},"AttributesToDelete":{"type":"list","member":{}},"UserSettings":{"shape":"S26"},"ApplicationSettings":{"shape":"S2a"},"AccessEndpoints":{"shape":"S1i"}}},"output":{"type":"structure","members":{"Stack":{"shape":"S2d"}}}}},"shapes":{"S5":{"type":"list","member":{"shape":"S6"}},"S6":{"type":"structure","required":["StackName","UserName","AuthenticationType"],"members":{"StackName":{},"UserName":{"shape":"S7"},"AuthenticationType":{},"SendEmailNotification":{"type":"boolean"}}},"S7":{"type":"string","sensitive":true},"Sb":{"type":"list","member":{"type":"structure","members":{"UserStackAssociation":{"shape":"S6"},"ErrorCode":{},"ErrorMessage":{}}}},"Sn":{"type":"list","member":{}},"Sp":{"type":"structure","required":["AccountName","AccountPassword"],"members":{"AccountName":{"type":"string","sensitive":true},"AccountPassword":{"type":"string","sensitive":true}}},"St":{"type":"structure","required":["DirectoryName"],"members":{"DirectoryName":{},"OrganizationalUnitDistinguishedNames":{"shape":"Sn"},"ServiceAccountCredentials":{"shape":"Sp"},"CreatedTime":{"type":"timestamp"}}},"Sy":{"type":"structure","required":["DesiredInstances"],"members":{"DesiredInstances":{"type":"integer"}}},"S10":{"type":"structure","members":{"SubnetIds":{"type":"list","member":{}},"SecurityGroupIds":{"type":"list","member":{}}}},"S15":{"type":"structure","members":{"DirectoryName":{},"OrganizationalUnitDistinguishedName":{}}},"S16":{"type":"map","key":{},"value":{}},"S1a":{"type":"structure","required":["Arn","Name","InstanceType","ComputeCapacityStatus","State"],"members":{"Arn":{},"Name":{},"DisplayName":{},"Description":{},"ImageName":{},"ImageArn":{},"InstanceType":{},"FleetType":{},"ComputeCapacityStatus":{"type":"structure","required":["Desired"],"members":{"Desired":{"type":"integer"},"Running":{"type":"integer"},"InUse":{"type":"integer"},"Available":{"type":"integer"}}},"MaxUserDurationInSeconds":{"type":"integer"},"DisconnectTimeoutInSeconds":{"type":"integer"},"State":{},"VpcConfig":{"shape":"S10"},"CreatedTime":{"type":"timestamp"},"FleetErrors":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{}}}},"EnableDefaultInternetAccess":{"type":"boolean"},"DomainJoinInfo":{"shape":"S15"},"IdleDisconnectTimeoutInSeconds":{"type":"integer"}}},"S1i":{"type":"list","member":{"type":"structure","required":["EndpointType"],"members":{"EndpointType":{},"VpceId":{}}}},"S1m":{"type":"structure","required":["Name"],"members":{"Name":{},"Arn":{},"ImageArn":{},"Description":{},"DisplayName":{},"VpcConfig":{"shape":"S10"},"InstanceType":{},"Platform":{},"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"CreatedTime":{"type":"timestamp"},"EnableDefaultInternetAccess":{"type":"boolean"},"DomainJoinInfo":{"shape":"S15"},"NetworkAccessConfiguration":{"shape":"S1r"},"ImageBuilderErrors":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{},"ErrorTimestamp":{"type":"timestamp"}}}},"AppstreamAgentVersion":{},"AccessEndpoints":{"shape":"S1i"}}},"S1r":{"type":"structure","members":{"EniPrivateIpAddress":{},"EniId":{}}},"S1y":{"type":"list","member":{"type":"structure","required":["ConnectorType"],"members":{"ConnectorType":{},"ResourceIdentifier":{},"Domains":{"type":"list","member":{}}}}},"S26":{"type":"list","member":{"type":"structure","required":["Action","Permission"],"members":{"Action":{},"Permission":{}}}},"S2a":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"SettingsGroup":{}}},"S2d":{"type":"structure","required":["Name"],"members":{"Arn":{},"Name":{},"Description":{},"DisplayName":{},"CreatedTime":{"type":"timestamp"},"StorageConnectors":{"shape":"S1y"},"RedirectURL":{},"FeedbackURL":{},"StackErrors":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{}}}},"UserSettings":{"shape":"S26"},"ApplicationSettings":{"type":"structure","members":{"Enabled":{"type":"boolean"},"SettingsGroup":{},"S3BucketName":{}}},"AccessEndpoints":{"shape":"S1i"}}},"S2q":{"type":"string","sensitive":true},"S2y":{"type":"structure","required":["Name"],"members":{"Name":{},"Arn":{},"BaseImageArn":{},"DisplayName":{},"State":{},"Visibility":{},"ImageBuilderSupported":{"type":"boolean"},"ImageBuilderName":{},"Platform":{},"Description":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Applications":{"type":"list","member":{"type":"structure","members":{"Name":{},"DisplayName":{},"IconURL":{},"LaunchPath":{},"LaunchParameters":{},"Enabled":{"type":"boolean"},"Metadata":{"type":"map","key":{},"value":{}}}}},"CreatedTime":{"type":"timestamp"},"PublicBaseImageReleasedDate":{"type":"timestamp"},"AppstreamAgentVersion":{},"ImagePermissions":{"shape":"S36"}}},"S36":{"type":"structure","members":{"allowFleet":{"type":"boolean"},"allowImageBuilder":{"type":"boolean"}}},"S3n":{"type":"list","member":{}}}}');

});

parcelRequire.register("oCkQR", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeImagePermissions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeImages":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});

parcelRequire.register("4telJ", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"FleetStarted":{"delay":30,"maxAttempts":40,"operation":"DescribeFleets","acceptors":[{"state":"success","matcher":"pathAll","argument":"Fleets[].State","expected":"ACTIVE"},{"state":"failure","matcher":"pathAny","argument":"Fleets[].State","expected":"PENDING_DEACTIVATE"},{"state":"failure","matcher":"pathAny","argument":"Fleets[].State","expected":"INACTIVE"}]},"FleetStopped":{"delay":30,"maxAttempts":40,"operation":"DescribeFleets","acceptors":[{"state":"success","matcher":"pathAll","argument":"Fleets[].State","expected":"INACTIVE"},{"state":"failure","matcher":"pathAny","argument":"Fleets[].State","expected":"PENDING_ACTIVATE"},{"state":"failure","matcher":"pathAny","argument":"Fleets[].State","expected":"ACTIVE"}]}}}');

});


parcelRequire.register("jnGV7", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $e1c1755d8c531d82$var$Service = $dbC7k.Service;
var $e1c1755d8c531d82$var$apiLoader = $dbC7k.apiLoader;
$e1c1755d8c531d82$var$apiLoader.services["autoscaling"] = {};
$dbC7k.AutoScaling = $e1c1755d8c531d82$var$Service.defineService("autoscaling", [
    "2011-01-01"
]);


Object.defineProperty($e1c1755d8c531d82$var$apiLoader.services["autoscaling"], "2011-01-01", {
    get: function get() {
        var model = (parcelRequire("2wERw"));
        model.paginators = (parcelRequire("l0vDy")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.AutoScaling;

});
parcelRequire.register("2wERw", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2011-01-01","endpointPrefix":"autoscaling","protocol":"query","serviceFullName":"Auto Scaling","serviceId":"Auto Scaling","signatureVersion":"v4","uid":"autoscaling-2011-01-01","xmlNamespace":"http://autoscaling.amazonaws.com/doc/2011-01-01/"},"operations":{"AttachInstances":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{}}}},"AttachLoadBalancerTargetGroups":{"input":{"type":"structure","required":["AutoScalingGroupName","TargetGroupARNs"],"members":{"AutoScalingGroupName":{},"TargetGroupARNs":{"shape":"S6"}}},"output":{"resultWrapper":"AttachLoadBalancerTargetGroupsResult","type":"structure","members":{}}},"AttachLoadBalancers":{"input":{"type":"structure","required":["AutoScalingGroupName","LoadBalancerNames"],"members":{"AutoScalingGroupName":{},"LoadBalancerNames":{"shape":"Sa"}}},"output":{"resultWrapper":"AttachLoadBalancersResult","type":"structure","members":{}}},"BatchDeleteScheduledAction":{"input":{"type":"structure","required":["AutoScalingGroupName","ScheduledActionNames"],"members":{"AutoScalingGroupName":{},"ScheduledActionNames":{"shape":"Se"}}},"output":{"resultWrapper":"BatchDeleteScheduledActionResult","type":"structure","members":{"FailedScheduledActions":{"shape":"Sg"}}}},"BatchPutScheduledUpdateGroupAction":{"input":{"type":"structure","required":["AutoScalingGroupName","ScheduledUpdateGroupActions"],"members":{"AutoScalingGroupName":{},"ScheduledUpdateGroupActions":{"type":"list","member":{"type":"structure","required":["ScheduledActionName"],"members":{"ScheduledActionName":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Recurrence":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"}}}}}},"output":{"resultWrapper":"BatchPutScheduledUpdateGroupActionResult","type":"structure","members":{"FailedScheduledUpdateGroupActions":{"shape":"Sg"}}}},"CompleteLifecycleAction":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName","LifecycleActionResult"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleActionToken":{},"LifecycleActionResult":{},"InstanceId":{}}},"output":{"resultWrapper":"CompleteLifecycleActionResult","type":"structure","members":{}}},"CreateAutoScalingGroup":{"input":{"type":"structure","required":["AutoScalingGroupName","MinSize","MaxSize"],"members":{"AutoScalingGroupName":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"Sy"},"MixedInstancesPolicy":{"shape":"S10"},"InstanceId":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"DefaultCooldown":{"type":"integer"},"AvailabilityZones":{"shape":"S1a"},"LoadBalancerNames":{"shape":"Sa"},"TargetGroupARNs":{"shape":"S6"},"HealthCheckType":{},"HealthCheckGracePeriod":{"type":"integer"},"PlacementGroup":{},"VPCZoneIdentifier":{},"TerminationPolicies":{"shape":"S1e"},"NewInstancesProtectedFromScaleIn":{"type":"boolean"},"LifecycleHookSpecificationList":{"type":"list","member":{"type":"structure","required":["LifecycleHookName","LifecycleTransition"],"members":{"LifecycleHookName":{},"LifecycleTransition":{},"NotificationMetadata":{},"HeartbeatTimeout":{"type":"integer"},"DefaultResult":{},"NotificationTargetARN":{},"RoleARN":{}}}},"Tags":{"shape":"S1n"},"ServiceLinkedRoleARN":{}}}},"CreateLaunchConfiguration":{"input":{"type":"structure","required":["LaunchConfigurationName"],"members":{"LaunchConfigurationName":{},"ImageId":{},"KeyName":{},"SecurityGroups":{"shape":"S1t"},"ClassicLinkVPCId":{},"ClassicLinkVPCSecurityGroups":{"shape":"S1u"},"UserData":{},"InstanceId":{},"InstanceType":{},"KernelId":{},"RamdiskId":{},"BlockDeviceMappings":{"shape":"S1w"},"InstanceMonitoring":{"shape":"S25"},"SpotPrice":{},"IamInstanceProfile":{},"EbsOptimized":{"type":"boolean"},"AssociatePublicIpAddress":{"type":"boolean"},"PlacementTenancy":{}}}},"CreateOrUpdateTags":{"input":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S1n"}}}},"DeleteAutoScalingGroup":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"ForceDelete":{"type":"boolean"}}}},"DeleteLaunchConfiguration":{"input":{"type":"structure","required":["LaunchConfigurationName"],"members":{"LaunchConfigurationName":{}}}},"DeleteLifecycleHook":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{}}},"output":{"resultWrapper":"DeleteLifecycleHookResult","type":"structure","members":{}}},"DeleteNotificationConfiguration":{"input":{"type":"structure","required":["AutoScalingGroupName","TopicARN"],"members":{"AutoScalingGroupName":{},"TopicARN":{}}}},"DeletePolicy":{"input":{"type":"structure","required":["PolicyName"],"members":{"AutoScalingGroupName":{},"PolicyName":{}}}},"DeleteScheduledAction":{"input":{"type":"structure","required":["AutoScalingGroupName","ScheduledActionName"],"members":{"AutoScalingGroupName":{},"ScheduledActionName":{}}}},"DeleteTags":{"input":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S1n"}}}},"DescribeAccountLimits":{"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"MaxNumberOfAutoScalingGroups":{"type":"integer"},"MaxNumberOfLaunchConfigurations":{"type":"integer"},"NumberOfAutoScalingGroups":{"type":"integer"},"NumberOfLaunchConfigurations":{"type":"integer"}}}},"DescribeAdjustmentTypes":{"output":{"resultWrapper":"DescribeAdjustmentTypesResult","type":"structure","members":{"AdjustmentTypes":{"type":"list","member":{"type":"structure","members":{"AdjustmentType":{}}}}}}},"DescribeAutoScalingGroups":{"input":{"type":"structure","members":{"AutoScalingGroupNames":{"shape":"S2t"},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeAutoScalingGroupsResult","type":"structure","required":["AutoScalingGroups"],"members":{"AutoScalingGroups":{"type":"list","member":{"type":"structure","required":["AutoScalingGroupName","MinSize","MaxSize","DesiredCapacity","DefaultCooldown","AvailabilityZones","HealthCheckType","CreatedTime"],"members":{"AutoScalingGroupName":{},"AutoScalingGroupARN":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"Sy"},"MixedInstancesPolicy":{"shape":"S10"},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"DefaultCooldown":{"type":"integer"},"AvailabilityZones":{"shape":"S1a"},"LoadBalancerNames":{"shape":"Sa"},"TargetGroupARNs":{"shape":"S6"},"HealthCheckType":{},"HealthCheckGracePeriod":{"type":"integer"},"Instances":{"type":"list","member":{"type":"structure","required":["InstanceId","AvailabilityZone","LifecycleState","HealthStatus","ProtectedFromScaleIn"],"members":{"InstanceId":{},"AvailabilityZone":{},"LifecycleState":{},"HealthStatus":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"Sy"},"ProtectedFromScaleIn":{"type":"boolean"}}}},"CreatedTime":{"type":"timestamp"},"SuspendedProcesses":{"type":"list","member":{"type":"structure","members":{"ProcessName":{},"SuspensionReason":{}}}},"PlacementGroup":{},"VPCZoneIdentifier":{},"EnabledMetrics":{"type":"list","member":{"type":"structure","members":{"Metric":{},"Granularity":{}}}},"Status":{},"Tags":{"shape":"S35"},"TerminationPolicies":{"shape":"S1e"},"NewInstancesProtectedFromScaleIn":{"type":"boolean"},"ServiceLinkedRoleARN":{}}}},"NextToken":{}}}},"DescribeAutoScalingInstances":{"input":{"type":"structure","members":{"InstanceIds":{"shape":"S2"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeAutoScalingInstancesResult","type":"structure","members":{"AutoScalingInstances":{"type":"list","member":{"type":"structure","required":["InstanceId","AutoScalingGroupName","AvailabilityZone","LifecycleState","HealthStatus","ProtectedFromScaleIn"],"members":{"InstanceId":{},"AutoScalingGroupName":{},"AvailabilityZone":{},"LifecycleState":{},"HealthStatus":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"Sy"},"ProtectedFromScaleIn":{"type":"boolean"}}}},"NextToken":{}}}},"DescribeAutoScalingNotificationTypes":{"output":{"resultWrapper":"DescribeAutoScalingNotificationTypesResult","type":"structure","members":{"AutoScalingNotificationTypes":{"shape":"S3c"}}}},"DescribeLaunchConfigurations":{"input":{"type":"structure","members":{"LaunchConfigurationNames":{"type":"list","member":{}},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLaunchConfigurationsResult","type":"structure","required":["LaunchConfigurations"],"members":{"LaunchConfigurations":{"type":"list","member":{"type":"structure","required":["LaunchConfigurationName","ImageId","InstanceType","CreatedTime"],"members":{"LaunchConfigurationName":{},"LaunchConfigurationARN":{},"ImageId":{},"KeyName":{},"SecurityGroups":{"shape":"S1t"},"ClassicLinkVPCId":{},"ClassicLinkVPCSecurityGroups":{"shape":"S1u"},"UserData":{},"InstanceType":{},"KernelId":{},"RamdiskId":{},"BlockDeviceMappings":{"shape":"S1w"},"InstanceMonitoring":{"shape":"S25"},"SpotPrice":{},"IamInstanceProfile":{},"CreatedTime":{"type":"timestamp"},"EbsOptimized":{"type":"boolean"},"AssociatePublicIpAddress":{"type":"boolean"},"PlacementTenancy":{}}}},"NextToken":{}}}},"DescribeLifecycleHookTypes":{"output":{"resultWrapper":"DescribeLifecycleHookTypesResult","type":"structure","members":{"LifecycleHookTypes":{"shape":"S3c"}}}},"DescribeLifecycleHooks":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"LifecycleHookNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeLifecycleHooksResult","type":"structure","members":{"LifecycleHooks":{"type":"list","member":{"type":"structure","members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleTransition":{},"NotificationTargetARN":{},"RoleARN":{},"NotificationMetadata":{},"HeartbeatTimeout":{"type":"integer"},"GlobalTimeout":{"type":"integer"},"DefaultResult":{}}}}}}},"DescribeLoadBalancerTargetGroups":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancerTargetGroupsResult","type":"structure","members":{"LoadBalancerTargetGroups":{"type":"list","member":{"type":"structure","members":{"LoadBalancerTargetGroupARN":{},"State":{}}}},"NextToken":{}}}},"DescribeLoadBalancers":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancersResult","type":"structure","members":{"LoadBalancers":{"type":"list","member":{"type":"structure","members":{"LoadBalancerName":{},"State":{}}}},"NextToken":{}}}},"DescribeMetricCollectionTypes":{"output":{"resultWrapper":"DescribeMetricCollectionTypesResult","type":"structure","members":{"Metrics":{"type":"list","member":{"type":"structure","members":{"Metric":{}}}},"Granularities":{"type":"list","member":{"type":"structure","members":{"Granularity":{}}}}}}},"DescribeNotificationConfigurations":{"input":{"type":"structure","members":{"AutoScalingGroupNames":{"shape":"S2t"},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeNotificationConfigurationsResult","type":"structure","required":["NotificationConfigurations"],"members":{"NotificationConfigurations":{"type":"list","member":{"type":"structure","members":{"AutoScalingGroupName":{},"TopicARN":{},"NotificationType":{}}}},"NextToken":{}}}},"DescribePolicies":{"input":{"type":"structure","members":{"AutoScalingGroupName":{},"PolicyNames":{"type":"list","member":{}},"PolicyTypes":{"type":"list","member":{}},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribePoliciesResult","type":"structure","members":{"ScalingPolicies":{"type":"list","member":{"type":"structure","members":{"AutoScalingGroupName":{},"PolicyName":{},"PolicyARN":{},"PolicyType":{},"AdjustmentType":{},"MinAdjustmentStep":{"shape":"S4c"},"MinAdjustmentMagnitude":{"type":"integer"},"ScalingAdjustment":{"type":"integer"},"Cooldown":{"type":"integer"},"StepAdjustments":{"shape":"S4f"},"MetricAggregationType":{},"EstimatedInstanceWarmup":{"type":"integer"},"Alarms":{"shape":"S4j"},"TargetTrackingConfiguration":{"shape":"S4l"}}}},"NextToken":{}}}},"DescribeScalingActivities":{"input":{"type":"structure","members":{"ActivityIds":{"type":"list","member":{}},"AutoScalingGroupName":{},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeScalingActivitiesResult","type":"structure","required":["Activities"],"members":{"Activities":{"shape":"S51"},"NextToken":{}}}},"DescribeScalingProcessTypes":{"output":{"resultWrapper":"DescribeScalingProcessTypesResult","type":"structure","members":{"Processes":{"type":"list","member":{"type":"structure","required":["ProcessName"],"members":{"ProcessName":{}}}}}}},"DescribeScheduledActions":{"input":{"type":"structure","members":{"AutoScalingGroupName":{},"ScheduledActionNames":{"shape":"Se"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeScheduledActionsResult","type":"structure","members":{"ScheduledUpdateGroupActions":{"type":"list","member":{"type":"structure","members":{"AutoScalingGroupName":{},"ScheduledActionName":{},"ScheduledActionARN":{},"Time":{"type":"timestamp"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Recurrence":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"}}}},"NextToken":{}}}},"DescribeTags":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Values":{"type":"list","member":{}}}}},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"Tags":{"shape":"S35"},"NextToken":{}}}},"DescribeTerminationPolicyTypes":{"output":{"resultWrapper":"DescribeTerminationPolicyTypesResult","type":"structure","members":{"TerminationPolicyTypes":{"shape":"S1e"}}}},"DetachInstances":{"input":{"type":"structure","required":["AutoScalingGroupName","ShouldDecrementDesiredCapacity"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{},"ShouldDecrementDesiredCapacity":{"type":"boolean"}}},"output":{"resultWrapper":"DetachInstancesResult","type":"structure","members":{"Activities":{"shape":"S51"}}}},"DetachLoadBalancerTargetGroups":{"input":{"type":"structure","required":["AutoScalingGroupName","TargetGroupARNs"],"members":{"AutoScalingGroupName":{},"TargetGroupARNs":{"shape":"S6"}}},"output":{"resultWrapper":"DetachLoadBalancerTargetGroupsResult","type":"structure","members":{}}},"DetachLoadBalancers":{"input":{"type":"structure","required":["AutoScalingGroupName","LoadBalancerNames"],"members":{"AutoScalingGroupName":{},"LoadBalancerNames":{"shape":"Sa"}}},"output":{"resultWrapper":"DetachLoadBalancersResult","type":"structure","members":{}}},"DisableMetricsCollection":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"Metrics":{"shape":"S5q"}}}},"EnableMetricsCollection":{"input":{"type":"structure","required":["AutoScalingGroupName","Granularity"],"members":{"AutoScalingGroupName":{},"Metrics":{"shape":"S5q"},"Granularity":{}}}},"EnterStandby":{"input":{"type":"structure","required":["AutoScalingGroupName","ShouldDecrementDesiredCapacity"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{},"ShouldDecrementDesiredCapacity":{"type":"boolean"}}},"output":{"resultWrapper":"EnterStandbyResult","type":"structure","members":{"Activities":{"shape":"S51"}}}},"ExecutePolicy":{"input":{"type":"structure","required":["PolicyName"],"members":{"AutoScalingGroupName":{},"PolicyName":{},"HonorCooldown":{"type":"boolean"},"MetricValue":{"type":"double"},"BreachThreshold":{"type":"double"}}}},"ExitStandby":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{}}},"output":{"resultWrapper":"ExitStandbyResult","type":"structure","members":{"Activities":{"shape":"S51"}}}},"PutLifecycleHook":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleTransition":{},"RoleARN":{},"NotificationTargetARN":{},"NotificationMetadata":{},"HeartbeatTimeout":{"type":"integer"},"DefaultResult":{}}},"output":{"resultWrapper":"PutLifecycleHookResult","type":"structure","members":{}}},"PutNotificationConfiguration":{"input":{"type":"structure","required":["AutoScalingGroupName","TopicARN","NotificationTypes"],"members":{"AutoScalingGroupName":{},"TopicARN":{},"NotificationTypes":{"shape":"S3c"}}}},"PutScalingPolicy":{"input":{"type":"structure","required":["AutoScalingGroupName","PolicyName"],"members":{"AutoScalingGroupName":{},"PolicyName":{},"PolicyType":{},"AdjustmentType":{},"MinAdjustmentStep":{"shape":"S4c"},"MinAdjustmentMagnitude":{"type":"integer"},"ScalingAdjustment":{"type":"integer"},"Cooldown":{"type":"integer"},"MetricAggregationType":{},"StepAdjustments":{"shape":"S4f"},"EstimatedInstanceWarmup":{"type":"integer"},"TargetTrackingConfiguration":{"shape":"S4l"}}},"output":{"resultWrapper":"PutScalingPolicyResult","type":"structure","members":{"PolicyARN":{},"Alarms":{"shape":"S4j"}}}},"PutScheduledUpdateGroupAction":{"input":{"type":"structure","required":["AutoScalingGroupName","ScheduledActionName"],"members":{"AutoScalingGroupName":{},"ScheduledActionName":{},"Time":{"type":"timestamp"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Recurrence":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"}}}},"RecordLifecycleActionHeartbeat":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleActionToken":{},"InstanceId":{}}},"output":{"resultWrapper":"RecordLifecycleActionHeartbeatResult","type":"structure","members":{}}},"ResumeProcesses":{"input":{"shape":"S66"}},"SetDesiredCapacity":{"input":{"type":"structure","required":["AutoScalingGroupName","DesiredCapacity"],"members":{"AutoScalingGroupName":{},"DesiredCapacity":{"type":"integer"},"HonorCooldown":{"type":"boolean"}}}},"SetInstanceHealth":{"input":{"type":"structure","required":["InstanceId","HealthStatus"],"members":{"InstanceId":{},"HealthStatus":{},"ShouldRespectGracePeriod":{"type":"boolean"}}}},"SetInstanceProtection":{"input":{"type":"structure","required":["InstanceIds","AutoScalingGroupName","ProtectedFromScaleIn"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{},"ProtectedFromScaleIn":{"type":"boolean"}}},"output":{"resultWrapper":"SetInstanceProtectionResult","type":"structure","members":{}}},"SuspendProcesses":{"input":{"shape":"S66"}},"TerminateInstanceInAutoScalingGroup":{"input":{"type":"structure","required":["InstanceId","ShouldDecrementDesiredCapacity"],"members":{"InstanceId":{},"ShouldDecrementDesiredCapacity":{"type":"boolean"}}},"output":{"resultWrapper":"TerminateInstanceInAutoScalingGroupResult","type":"structure","members":{"Activity":{"shape":"S52"}}}},"UpdateAutoScalingGroup":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"Sy"},"MixedInstancesPolicy":{"shape":"S10"},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"DefaultCooldown":{"type":"integer"},"AvailabilityZones":{"shape":"S1a"},"HealthCheckType":{},"HealthCheckGracePeriod":{"type":"integer"},"PlacementGroup":{},"VPCZoneIdentifier":{},"TerminationPolicies":{"shape":"S1e"},"NewInstancesProtectedFromScaleIn":{"type":"boolean"},"ServiceLinkedRoleARN":{}}}}},"shapes":{"S2":{"type":"list","member":{}},"S6":{"type":"list","member":{}},"Sa":{"type":"list","member":{}},"Se":{"type":"list","member":{}},"Sg":{"type":"list","member":{"type":"structure","required":["ScheduledActionName"],"members":{"ScheduledActionName":{},"ErrorCode":{},"ErrorMessage":{}}}},"Sy":{"type":"structure","members":{"LaunchTemplateId":{},"LaunchTemplateName":{},"Version":{}}},"S10":{"type":"structure","members":{"LaunchTemplate":{"type":"structure","members":{"LaunchTemplateSpecification":{"shape":"Sy"},"Overrides":{"type":"list","member":{"type":"structure","members":{"InstanceType":{}}}}}},"InstancesDistribution":{"type":"structure","members":{"OnDemandAllocationStrategy":{},"OnDemandBaseCapacity":{"type":"integer"},"OnDemandPercentageAboveBaseCapacity":{"type":"integer"},"SpotAllocationStrategy":{},"SpotInstancePools":{"type":"integer"},"SpotMaxPrice":{}}}}},"S1a":{"type":"list","member":{}},"S1e":{"type":"list","member":{}},"S1n":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"ResourceId":{},"ResourceType":{},"Key":{},"Value":{},"PropagateAtLaunch":{"type":"boolean"}}}},"S1t":{"type":"list","member":{}},"S1u":{"type":"list","member":{}},"S1w":{"type":"list","member":{"type":"structure","required":["DeviceName"],"members":{"VirtualName":{},"DeviceName":{},"Ebs":{"type":"structure","members":{"SnapshotId":{},"VolumeSize":{"type":"integer"},"VolumeType":{},"DeleteOnTermination":{"type":"boolean"},"Iops":{"type":"integer"},"Encrypted":{"type":"boolean"}}},"NoDevice":{"type":"boolean"}}}},"S25":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"S2t":{"type":"list","member":{}},"S35":{"type":"list","member":{"type":"structure","members":{"ResourceId":{},"ResourceType":{},"Key":{},"Value":{},"PropagateAtLaunch":{"type":"boolean"}}}},"S3c":{"type":"list","member":{}},"S4c":{"type":"integer","deprecated":true},"S4f":{"type":"list","member":{"type":"structure","required":["ScalingAdjustment"],"members":{"MetricIntervalLowerBound":{"type":"double"},"MetricIntervalUpperBound":{"type":"double"},"ScalingAdjustment":{"type":"integer"}}}},"S4j":{"type":"list","member":{"type":"structure","members":{"AlarmName":{},"AlarmARN":{}}}},"S4l":{"type":"structure","required":["TargetValue"],"members":{"PredefinedMetricSpecification":{"type":"structure","required":["PredefinedMetricType"],"members":{"PredefinedMetricType":{},"ResourceLabel":{}}},"CustomizedMetricSpecification":{"type":"structure","required":["MetricName","Namespace","Statistic"],"members":{"MetricName":{},"Namespace":{},"Dimensions":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"Statistic":{},"Unit":{}}},"TargetValue":{"type":"double"},"DisableScaleIn":{"type":"boolean"}}},"S51":{"type":"list","member":{"shape":"S52"}},"S52":{"type":"structure","required":["ActivityId","AutoScalingGroupName","Cause","StartTime","StatusCode"],"members":{"ActivityId":{},"AutoScalingGroupName":{},"Description":{},"Cause":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"StatusCode":{},"StatusMessage":{},"Progress":{"type":"integer"},"Details":{}}},"S5q":{"type":"list","member":{}},"S66":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"ScalingProcesses":{"type":"list","member":{}}}}}}');

});

parcelRequire.register("l0vDy", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeAutoScalingGroups":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"AutoScalingGroups"},"DescribeAutoScalingInstances":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"AutoScalingInstances"},"DescribeLaunchConfigurations":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"LaunchConfigurations"},"DescribeNotificationConfigurations":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"NotificationConfigurations"},"DescribePolicies":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"ScalingPolicies"},"DescribeScalingActivities":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"Activities"},"DescribeScheduledActions":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"ScheduledUpdateGroupActions"},"DescribeTags":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"Tags"}}}');

});


parcelRequire.register("l8bhr", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $f6231858a9ec6fd2$var$Service = $dbC7k.Service;
var $f6231858a9ec6fd2$var$apiLoader = $dbC7k.apiLoader;
$f6231858a9ec6fd2$var$apiLoader.services["batch"] = {};
$dbC7k.Batch = $f6231858a9ec6fd2$var$Service.defineService("batch", [
    "2016-08-10"
]);


Object.defineProperty($f6231858a9ec6fd2$var$apiLoader.services["batch"], "2016-08-10", {
    get: function get() {
        var model = (parcelRequire("lNbGW"));
        model.paginators = (parcelRequire("dLscA")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Batch;

});
parcelRequire.register("lNbGW", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-08-10","endpointPrefix":"batch","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"AWS Batch","serviceFullName":"AWS Batch","serviceId":"Batch","signatureVersion":"v4","uid":"batch-2016-08-10"},"operations":{"CancelJob":{"http":{"requestUri":"/v1/canceljob"},"input":{"type":"structure","required":["jobId","reason"],"members":{"jobId":{},"reason":{}}},"output":{"type":"structure","members":{}}},"CreateComputeEnvironment":{"http":{"requestUri":"/v1/createcomputeenvironment"},"input":{"type":"structure","required":["computeEnvironmentName","type","serviceRole"],"members":{"computeEnvironmentName":{},"type":{},"state":{},"computeResources":{"shape":"S7"},"serviceRole":{}}},"output":{"type":"structure","members":{"computeEnvironmentName":{},"computeEnvironmentArn":{}}}},"CreateJobQueue":{"http":{"requestUri":"/v1/createjobqueue"},"input":{"type":"structure","required":["jobQueueName","priority","computeEnvironmentOrder"],"members":{"jobQueueName":{},"state":{},"priority":{"type":"integer"},"computeEnvironmentOrder":{"shape":"Sg"}}},"output":{"type":"structure","required":["jobQueueName","jobQueueArn"],"members":{"jobQueueName":{},"jobQueueArn":{}}}},"DeleteComputeEnvironment":{"http":{"requestUri":"/v1/deletecomputeenvironment"},"input":{"type":"structure","required":["computeEnvironment"],"members":{"computeEnvironment":{}}},"output":{"type":"structure","members":{}}},"DeleteJobQueue":{"http":{"requestUri":"/v1/deletejobqueue"},"input":{"type":"structure","required":["jobQueue"],"members":{"jobQueue":{}}},"output":{"type":"structure","members":{}}},"DeregisterJobDefinition":{"http":{"requestUri":"/v1/deregisterjobdefinition"},"input":{"type":"structure","required":["jobDefinition"],"members":{"jobDefinition":{}}},"output":{"type":"structure","members":{}}},"DescribeComputeEnvironments":{"http":{"requestUri":"/v1/describecomputeenvironments"},"input":{"type":"structure","members":{"computeEnvironments":{"shape":"Sa"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"computeEnvironments":{"type":"list","member":{"type":"structure","required":["computeEnvironmentName","computeEnvironmentArn","ecsClusterArn"],"members":{"computeEnvironmentName":{},"computeEnvironmentArn":{},"ecsClusterArn":{},"type":{},"state":{},"status":{},"statusReason":{},"computeResources":{"shape":"S7"},"serviceRole":{}}}},"nextToken":{}}}},"DescribeJobDefinitions":{"http":{"requestUri":"/v1/describejobdefinitions"},"input":{"type":"structure","members":{"jobDefinitions":{"shape":"Sa"},"maxResults":{"type":"integer"},"jobDefinitionName":{},"status":{},"nextToken":{}}},"output":{"type":"structure","members":{"jobDefinitions":{"type":"list","member":{"type":"structure","required":["jobDefinitionName","jobDefinitionArn","revision","type"],"members":{"jobDefinitionName":{},"jobDefinitionArn":{},"revision":{"type":"integer"},"status":{},"type":{},"parameters":{"shape":"Sy"},"retryStrategy":{"shape":"Sz"},"containerProperties":{"shape":"S10"},"timeout":{"shape":"S1j"},"nodeProperties":{"shape":"S1k"}}}},"nextToken":{}}}},"DescribeJobQueues":{"http":{"requestUri":"/v1/describejobqueues"},"input":{"type":"structure","members":{"jobQueues":{"shape":"Sa"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"jobQueues":{"type":"list","member":{"type":"structure","required":["jobQueueName","jobQueueArn","state","priority","computeEnvironmentOrder"],"members":{"jobQueueName":{},"jobQueueArn":{},"state":{},"status":{},"statusReason":{},"priority":{"type":"integer"},"computeEnvironmentOrder":{"shape":"Sg"}}}},"nextToken":{}}}},"DescribeJobs":{"http":{"requestUri":"/v1/describejobs"},"input":{"type":"structure","required":["jobs"],"members":{"jobs":{"shape":"Sa"}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","required":["jobName","jobId","jobQueue","status","startedAt","jobDefinition"],"members":{"jobName":{},"jobId":{},"jobQueue":{},"status":{},"attempts":{"type":"list","member":{"type":"structure","members":{"container":{"type":"structure","members":{"containerInstanceArn":{},"taskArn":{},"exitCode":{"type":"integer"},"reason":{},"logStreamName":{},"networkInterfaces":{"shape":"S20"}}},"startedAt":{"type":"long"},"stoppedAt":{"type":"long"},"statusReason":{}}}},"statusReason":{},"createdAt":{"type":"long"},"retryStrategy":{"shape":"Sz"},"startedAt":{"type":"long"},"stoppedAt":{"type":"long"},"dependsOn":{"shape":"S23"},"jobDefinition":{},"parameters":{"shape":"Sy"},"container":{"type":"structure","members":{"image":{},"vcpus":{"type":"integer"},"memory":{"type":"integer"},"command":{"shape":"Sa"},"jobRoleArn":{},"volumes":{"shape":"S11"},"environment":{"shape":"S14"},"mountPoints":{"shape":"S16"},"readonlyRootFilesystem":{"type":"boolean"},"ulimits":{"shape":"S19"},"privileged":{"type":"boolean"},"user":{},"exitCode":{"type":"integer"},"reason":{},"containerInstanceArn":{},"taskArn":{},"logStreamName":{},"instanceType":{},"networkInterfaces":{"shape":"S20"},"resourceRequirements":{"shape":"S1b"},"linuxParameters":{"shape":"S1e"}}},"nodeDetails":{"type":"structure","members":{"nodeIndex":{"type":"integer"},"isMainNode":{"type":"boolean"}}},"nodeProperties":{"shape":"S1k"},"arrayProperties":{"type":"structure","members":{"statusSummary":{"type":"map","key":{},"value":{"type":"integer"}},"size":{"type":"integer"},"index":{"type":"integer"}}},"timeout":{"shape":"S1j"}}}}}}},"ListJobs":{"http":{"requestUri":"/v1/listjobs"},"input":{"type":"structure","members":{"jobQueue":{},"arrayJobId":{},"multiNodeJobId":{},"jobStatus":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["jobSummaryList"],"members":{"jobSummaryList":{"type":"list","member":{"type":"structure","required":["jobId","jobName"],"members":{"jobId":{},"jobName":{},"createdAt":{"type":"long"},"status":{},"statusReason":{},"startedAt":{"type":"long"},"stoppedAt":{"type":"long"},"container":{"type":"structure","members":{"exitCode":{"type":"integer"},"reason":{}}},"arrayProperties":{"type":"structure","members":{"size":{"type":"integer"},"index":{"type":"integer"}}},"nodeProperties":{"type":"structure","members":{"isMainNode":{"type":"boolean"},"numNodes":{"type":"integer"},"nodeIndex":{"type":"integer"}}}}}},"nextToken":{}}}},"RegisterJobDefinition":{"http":{"requestUri":"/v1/registerjobdefinition"},"input":{"type":"structure","required":["jobDefinitionName","type"],"members":{"jobDefinitionName":{},"type":{},"parameters":{"shape":"Sy"},"containerProperties":{"shape":"S10"},"nodeProperties":{"shape":"S1k"},"retryStrategy":{"shape":"Sz"},"timeout":{"shape":"S1j"}}},"output":{"type":"structure","required":["jobDefinitionName","jobDefinitionArn","revision"],"members":{"jobDefinitionName":{},"jobDefinitionArn":{},"revision":{"type":"integer"}}}},"SubmitJob":{"http":{"requestUri":"/v1/submitjob"},"input":{"type":"structure","required":["jobName","jobQueue","jobDefinition"],"members":{"jobName":{},"jobQueue":{},"arrayProperties":{"type":"structure","members":{"size":{"type":"integer"}}},"dependsOn":{"shape":"S23"},"jobDefinition":{},"parameters":{"shape":"Sy"},"containerOverrides":{"shape":"S2m"},"nodeOverrides":{"type":"structure","members":{"numNodes":{"type":"integer"},"nodePropertyOverrides":{"type":"list","member":{"type":"structure","required":["targetNodes"],"members":{"targetNodes":{},"containerOverrides":{"shape":"S2m"}}}}}},"retryStrategy":{"shape":"Sz"},"timeout":{"shape":"S1j"}}},"output":{"type":"structure","required":["jobName","jobId"],"members":{"jobName":{},"jobId":{}}}},"TerminateJob":{"http":{"requestUri":"/v1/terminatejob"},"input":{"type":"structure","required":["jobId","reason"],"members":{"jobId":{},"reason":{}}},"output":{"type":"structure","members":{}}},"UpdateComputeEnvironment":{"http":{"requestUri":"/v1/updatecomputeenvironment"},"input":{"type":"structure","required":["computeEnvironment"],"members":{"computeEnvironment":{},"state":{},"computeResources":{"type":"structure","members":{"minvCpus":{"type":"integer"},"maxvCpus":{"type":"integer"},"desiredvCpus":{"type":"integer"}}},"serviceRole":{}}},"output":{"type":"structure","members":{"computeEnvironmentName":{},"computeEnvironmentArn":{}}}},"UpdateJobQueue":{"http":{"requestUri":"/v1/updatejobqueue"},"input":{"type":"structure","required":["jobQueue"],"members":{"jobQueue":{},"state":{},"priority":{"type":"integer"},"computeEnvironmentOrder":{"shape":"Sg"}}},"output":{"type":"structure","members":{"jobQueueName":{},"jobQueueArn":{}}}}},"shapes":{"S7":{"type":"structure","required":["type","minvCpus","maxvCpus","instanceTypes","subnets","instanceRole"],"members":{"type":{},"minvCpus":{"type":"integer"},"maxvCpus":{"type":"integer"},"desiredvCpus":{"type":"integer"},"instanceTypes":{"shape":"Sa"},"imageId":{},"subnets":{"shape":"Sa"},"securityGroupIds":{"shape":"Sa"},"ec2KeyPair":{},"instanceRole":{},"tags":{"type":"map","key":{},"value":{}},"placementGroup":{},"bidPercentage":{"type":"integer"},"spotIamFleetRole":{},"launchTemplate":{"type":"structure","members":{"launchTemplateId":{},"launchTemplateName":{},"version":{}}}}},"Sa":{"type":"list","member":{}},"Sg":{"type":"list","member":{"type":"structure","required":["order","computeEnvironment"],"members":{"order":{"type":"integer"},"computeEnvironment":{}}}},"Sy":{"type":"map","key":{},"value":{}},"Sz":{"type":"structure","members":{"attempts":{"type":"integer"}}},"S10":{"type":"structure","members":{"image":{},"vcpus":{"type":"integer"},"memory":{"type":"integer"},"command":{"shape":"Sa"},"jobRoleArn":{},"volumes":{"shape":"S11"},"environment":{"shape":"S14"},"mountPoints":{"shape":"S16"},"readonlyRootFilesystem":{"type":"boolean"},"privileged":{"type":"boolean"},"ulimits":{"shape":"S19"},"user":{},"instanceType":{},"resourceRequirements":{"shape":"S1b"},"linuxParameters":{"shape":"S1e"}}},"S11":{"type":"list","member":{"type":"structure","members":{"host":{"type":"structure","members":{"sourcePath":{}}},"name":{}}}},"S14":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{}}}},"S16":{"type":"list","member":{"type":"structure","members":{"containerPath":{},"readOnly":{"type":"boolean"},"sourceVolume":{}}}},"S19":{"type":"list","member":{"type":"structure","required":["hardLimit","name","softLimit"],"members":{"hardLimit":{"type":"integer"},"name":{},"softLimit":{"type":"integer"}}}},"S1b":{"type":"list","member":{"type":"structure","required":["value","type"],"members":{"value":{},"type":{}}}},"S1e":{"type":"structure","members":{"devices":{"type":"list","member":{"type":"structure","required":["hostPath"],"members":{"hostPath":{},"containerPath":{},"permissions":{"type":"list","member":{}}}}}}},"S1j":{"type":"structure","members":{"attemptDurationSeconds":{"type":"integer"}}},"S1k":{"type":"structure","required":["numNodes","mainNode","nodeRangeProperties"],"members":{"numNodes":{"type":"integer"},"mainNode":{"type":"integer"},"nodeRangeProperties":{"type":"list","member":{"type":"structure","required":["targetNodes"],"members":{"targetNodes":{},"container":{"shape":"S10"}}}}}},"S20":{"type":"list","member":{"type":"structure","members":{"attachmentId":{},"ipv6Address":{},"privateIpv4Address":{}}}},"S23":{"type":"list","member":{"type":"structure","members":{"jobId":{},"type":{}}}},"S2m":{"type":"structure","members":{"vcpus":{"type":"integer"},"memory":{"type":"integer"},"command":{"shape":"Sa"},"instanceType":{},"environment":{"shape":"S14"},"resourceRequirements":{"shape":"S1b"}}}}}');

});

parcelRequire.register("dLscA", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeComputeEnvironments":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"computeEnvironments"},"DescribeJobDefinitions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"jobDefinitions"},"DescribeJobQueues":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"jobQueues"},"ListJobs":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"jobSummaryList"}}}');

});


parcelRequire.register("d3c74", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $9804f38ee7a739ff$var$Service = $dbC7k.Service;
var $9804f38ee7a739ff$var$apiLoader = $dbC7k.apiLoader;
$9804f38ee7a739ff$var$apiLoader.services["budgets"] = {};
$dbC7k.Budgets = $9804f38ee7a739ff$var$Service.defineService("budgets", [
    "2016-10-20"
]);


Object.defineProperty($9804f38ee7a739ff$var$apiLoader.services["budgets"], "2016-10-20", {
    get: function get() {
        var model = (parcelRequire("2MVr8"));
        model.paginators = (parcelRequire("8cDx4")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Budgets;

});
parcelRequire.register("2MVr8", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-10-20","endpointPrefix":"budgets","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"AWSBudgets","serviceFullName":"AWS Budgets","serviceId":"Budgets","signatureVersion":"v4","targetPrefix":"AWSBudgetServiceGateway","uid":"budgets-2016-10-20"},"operations":{"CreateBudget":{"input":{"type":"structure","required":["AccountId","Budget"],"members":{"AccountId":{},"Budget":{"shape":"S3"},"NotificationsWithSubscribers":{"type":"list","member":{"type":"structure","required":["Notification","Subscribers"],"members":{"Notification":{"shape":"Sl"},"Subscribers":{"shape":"Sr"}}}}}},"output":{"type":"structure","members":{}}},"CreateNotification":{"input":{"type":"structure","required":["AccountId","BudgetName","Notification","Subscribers"],"members":{"AccountId":{},"BudgetName":{},"Notification":{"shape":"Sl"},"Subscribers":{"shape":"Sr"}}},"output":{"type":"structure","members":{}}},"CreateSubscriber":{"input":{"type":"structure","required":["AccountId","BudgetName","Notification","Subscriber"],"members":{"AccountId":{},"BudgetName":{},"Notification":{"shape":"Sl"},"Subscriber":{"shape":"Ss"}}},"output":{"type":"structure","members":{}}},"DeleteBudget":{"input":{"type":"structure","required":["AccountId","BudgetName"],"members":{"AccountId":{},"BudgetName":{}}},"output":{"type":"structure","members":{}}},"DeleteNotification":{"input":{"type":"structure","required":["AccountId","BudgetName","Notification"],"members":{"AccountId":{},"BudgetName":{},"Notification":{"shape":"Sl"}}},"output":{"type":"structure","members":{}}},"DeleteSubscriber":{"input":{"type":"structure","required":["AccountId","BudgetName","Notification","Subscriber"],"members":{"AccountId":{},"BudgetName":{},"Notification":{"shape":"Sl"},"Subscriber":{"shape":"Ss"}}},"output":{"type":"structure","members":{}}},"DescribeBudget":{"input":{"type":"structure","required":["AccountId","BudgetName"],"members":{"AccountId":{},"BudgetName":{}}},"output":{"type":"structure","members":{"Budget":{"shape":"S3"}}}},"DescribeBudgetPerformanceHistory":{"input":{"type":"structure","required":["AccountId","BudgetName"],"members":{"AccountId":{},"BudgetName":{},"TimePeriod":{"shape":"Sf"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"BudgetPerformanceHistory":{"type":"structure","members":{"BudgetName":{},"BudgetType":{},"CostFilters":{"shape":"Sa"},"CostTypes":{"shape":"Sc"},"TimeUnit":{},"BudgetedAndActualAmountsList":{"type":"list","member":{"type":"structure","members":{"BudgetedAmount":{"shape":"S5"},"ActualAmount":{"shape":"S5"},"TimePeriod":{"shape":"Sf"}}}}}},"NextToken":{}}}},"DescribeBudgets":{"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Budgets":{"type":"list","member":{"shape":"S3"}},"NextToken":{}}}},"DescribeNotificationsForBudget":{"input":{"type":"structure","required":["AccountId","BudgetName"],"members":{"AccountId":{},"BudgetName":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Notifications":{"type":"list","member":{"shape":"Sl"}},"NextToken":{}}}},"DescribeSubscribersForNotification":{"input":{"type":"structure","required":["AccountId","BudgetName","Notification"],"members":{"AccountId":{},"BudgetName":{},"Notification":{"shape":"Sl"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Subscribers":{"shape":"Sr"},"NextToken":{}}}},"UpdateBudget":{"input":{"type":"structure","required":["AccountId","NewBudget"],"members":{"AccountId":{},"NewBudget":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"UpdateNotification":{"input":{"type":"structure","required":["AccountId","BudgetName","OldNotification","NewNotification"],"members":{"AccountId":{},"BudgetName":{},"OldNotification":{"shape":"Sl"},"NewNotification":{"shape":"Sl"}}},"output":{"type":"structure","members":{}}},"UpdateSubscriber":{"input":{"type":"structure","required":["AccountId","BudgetName","Notification","OldSubscriber","NewSubscriber"],"members":{"AccountId":{},"BudgetName":{},"Notification":{"shape":"Sl"},"OldSubscriber":{"shape":"Ss"},"NewSubscriber":{"shape":"Ss"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S3":{"type":"structure","required":["BudgetName","TimeUnit","BudgetType"],"members":{"BudgetName":{},"BudgetLimit":{"shape":"S5"},"PlannedBudgetLimits":{"type":"map","key":{},"value":{"shape":"S5"}},"CostFilters":{"shape":"Sa"},"CostTypes":{"shape":"Sc"},"TimeUnit":{},"TimePeriod":{"shape":"Sf"},"CalculatedSpend":{"type":"structure","required":["ActualSpend"],"members":{"ActualSpend":{"shape":"S5"},"ForecastedSpend":{"shape":"S5"}}},"BudgetType":{},"LastUpdatedTime":{"type":"timestamp"}}},"S5":{"type":"structure","required":["Amount","Unit"],"members":{"Amount":{},"Unit":{}}},"Sa":{"type":"map","key":{},"value":{"type":"list","member":{}}},"Sc":{"type":"structure","members":{"IncludeTax":{"type":"boolean"},"IncludeSubscription":{"type":"boolean"},"UseBlended":{"type":"boolean"},"IncludeRefund":{"type":"boolean"},"IncludeCredit":{"type":"boolean"},"IncludeUpfront":{"type":"boolean"},"IncludeRecurring":{"type":"boolean"},"IncludeOtherSubscription":{"type":"boolean"},"IncludeSupport":{"type":"boolean"},"IncludeDiscount":{"type":"boolean"},"UseAmortized":{"type":"boolean"}}},"Sf":{"type":"structure","members":{"Start":{"type":"timestamp"},"End":{"type":"timestamp"}}},"Sl":{"type":"structure","required":["NotificationType","ComparisonOperator","Threshold"],"members":{"NotificationType":{},"ComparisonOperator":{},"Threshold":{"type":"double"},"ThresholdType":{},"NotificationState":{}}},"Sr":{"type":"list","member":{"shape":"Ss"}},"Ss":{"type":"structure","required":["SubscriptionType","Address"],"members":{"SubscriptionType":{},"Address":{"type":"string","sensitive":true}}}}}');

});

parcelRequire.register("8cDx4", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("fbrMh", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $b0dd6e254c7c5d46$var$Service = $dbC7k.Service;
var $b0dd6e254c7c5d46$var$apiLoader = $dbC7k.apiLoader;
$b0dd6e254c7c5d46$var$apiLoader.services["clouddirectory"] = {};
$dbC7k.CloudDirectory = $b0dd6e254c7c5d46$var$Service.defineService("clouddirectory", [
    "2016-05-10",
    "2016-05-10*",
    "2017-01-11"
]);


Object.defineProperty($b0dd6e254c7c5d46$var$apiLoader.services["clouddirectory"], "2016-05-10", {
    get: function get() {
        var model = (parcelRequire("9TzRJ"));
        model.paginators = (parcelRequire("hDCTG")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});


Object.defineProperty($b0dd6e254c7c5d46$var$apiLoader.services["clouddirectory"], "2017-01-11", {
    get: function get() {
        var model = (parcelRequire("bLmX5"));
        model.paginators = (parcelRequire("jOuen")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.CloudDirectory;

});
parcelRequire.register("9TzRJ", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-05-10","endpointPrefix":"clouddirectory","protocol":"rest-json","serviceFullName":"Amazon CloudDirectory","serviceId":"CloudDirectory","signatureVersion":"v4","signingName":"clouddirectory","uid":"clouddirectory-2016-05-10"},"operations":{"AddFacetToObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/facets","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","SchemaFacet","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"SchemaFacet":{"shape":"S3"},"ObjectAttributeList":{"shape":"S5"},"ObjectReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"ApplySchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/apply","responseCode":200},"input":{"type":"structure","required":["PublishedSchemaArn","DirectoryArn"],"members":{"PublishedSchemaArn":{},"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","members":{"AppliedSchemaArn":{},"DirectoryArn":{}}}},"AttachObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/attach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ParentReference","ChildReference","LinkName"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ParentReference":{"shape":"Sf"},"ChildReference":{"shape":"Sf"},"LinkName":{}}},"output":{"type":"structure","members":{"AttachedObjectIdentifier":{}}}},"AttachPolicy":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/policy/attach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","PolicyReference","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"PolicyReference":{"shape":"Sf"},"ObjectReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"AttachToIndex":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/index/attach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","IndexReference","TargetReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"IndexReference":{"shape":"Sf"},"TargetReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{"AttachedObjectIdentifier":{}}}},"AttachTypedLink":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/typedlink/attach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","SourceObjectReference","TargetObjectReference","TypedLinkFacet","Attributes"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"SourceObjectReference":{"shape":"Sf"},"TargetObjectReference":{"shape":"Sf"},"TypedLinkFacet":{"shape":"St"},"Attributes":{"shape":"Sv"}}},"output":{"type":"structure","members":{"TypedLinkSpecifier":{"shape":"Sy"}}}},"BatchRead":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/batchread","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","Operations"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"Operations":{"type":"list","member":{"type":"structure","members":{"ListObjectAttributes":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"FacetFilter":{"shape":"S3"}}},"ListObjectChildren":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListAttachedIndices":{"type":"structure","required":["TargetReference"],"members":{"TargetReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListObjectParentPaths":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"GetObjectInformation":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"}}},"GetObjectAttributes":{"type":"structure","required":["ObjectReference","SchemaFacet","AttributeNames"],"members":{"ObjectReference":{"shape":"Sf"},"SchemaFacet":{"shape":"S3"},"AttributeNames":{"shape":"S1a"}}},"ListObjectPolicies":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListPolicyAttachments":{"type":"structure","required":["PolicyReference"],"members":{"PolicyReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"LookupPolicy":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListIndex":{"type":"structure","required":["IndexReference"],"members":{"RangesOnIndexedValues":{"shape":"S1f"},"IndexReference":{"shape":"Sf"},"MaxResults":{"type":"integer"},"NextToken":{}}},"ListOutgoingTypedLinks":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"FilterAttributeRanges":{"shape":"S1k"},"FilterTypedLink":{"shape":"St"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListIncomingTypedLinks":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"FilterAttributeRanges":{"shape":"S1k"},"FilterTypedLink":{"shape":"St"},"NextToken":{},"MaxResults":{"type":"integer"}}},"GetLinkAttributes":{"type":"structure","required":["TypedLinkSpecifier","AttributeNames"],"members":{"TypedLinkSpecifier":{"shape":"Sy"},"AttributeNames":{"shape":"S1a"}}}}}},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"Responses":{"type":"list","member":{"type":"structure","members":{"SuccessfulResponse":{"type":"structure","members":{"ListObjectAttributes":{"type":"structure","members":{"Attributes":{"shape":"S5"},"NextToken":{}}},"ListObjectChildren":{"type":"structure","members":{"Children":{"shape":"S1v"},"NextToken":{}}},"GetObjectInformation":{"type":"structure","members":{"SchemaFacets":{"shape":"S1x"},"ObjectIdentifier":{}}},"GetObjectAttributes":{"type":"structure","members":{"Attributes":{"shape":"S5"}}},"ListAttachedIndices":{"type":"structure","members":{"IndexAttachments":{"shape":"S20"},"NextToken":{}}},"ListObjectParentPaths":{"type":"structure","members":{"PathToObjectIdentifiersList":{"shape":"S23"},"NextToken":{}}},"ListObjectPolicies":{"type":"structure","members":{"AttachedPolicyIds":{"shape":"S26"},"NextToken":{}}},"ListPolicyAttachments":{"type":"structure","members":{"ObjectIdentifiers":{"shape":"S26"},"NextToken":{}}},"LookupPolicy":{"type":"structure","members":{"PolicyToPathList":{"shape":"S2a"},"NextToken":{}}},"ListIndex":{"type":"structure","members":{"IndexAttachments":{"shape":"S20"},"NextToken":{}}},"ListOutgoingTypedLinks":{"type":"structure","members":{"TypedLinkSpecifiers":{"shape":"S2h"},"NextToken":{}}},"ListIncomingTypedLinks":{"type":"structure","members":{"LinkSpecifiers":{"shape":"S2h"},"NextToken":{}}},"GetLinkAttributes":{"type":"structure","members":{"Attributes":{"shape":"S5"}}}}},"ExceptionResponse":{"type":"structure","members":{"Type":{},"Message":{}}}}}}}}},"BatchWrite":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/batchwrite","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","Operations"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"Operations":{"type":"list","member":{"type":"structure","members":{"CreateObject":{"type":"structure","required":["SchemaFacet","ObjectAttributeList"],"members":{"SchemaFacet":{"shape":"S1x"},"ObjectAttributeList":{"shape":"S5"},"ParentReference":{"shape":"Sf"},"LinkName":{},"BatchReferenceName":{}}},"AttachObject":{"type":"structure","required":["ParentReference","ChildReference","LinkName"],"members":{"ParentReference":{"shape":"Sf"},"ChildReference":{"shape":"Sf"},"LinkName":{}}},"DetachObject":{"type":"structure","required":["ParentReference","LinkName"],"members":{"ParentReference":{"shape":"Sf"},"LinkName":{},"BatchReferenceName":{}}},"UpdateObjectAttributes":{"type":"structure","required":["ObjectReference","AttributeUpdates"],"members":{"ObjectReference":{"shape":"Sf"},"AttributeUpdates":{"shape":"S2v"}}},"DeleteObject":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"}}},"AddFacetToObject":{"type":"structure","required":["SchemaFacet","ObjectAttributeList","ObjectReference"],"members":{"SchemaFacet":{"shape":"S3"},"ObjectAttributeList":{"shape":"S5"},"ObjectReference":{"shape":"Sf"}}},"RemoveFacetFromObject":{"type":"structure","required":["SchemaFacet","ObjectReference"],"members":{"SchemaFacet":{"shape":"S3"},"ObjectReference":{"shape":"Sf"}}},"AttachPolicy":{"type":"structure","required":["PolicyReference","ObjectReference"],"members":{"PolicyReference":{"shape":"Sf"},"ObjectReference":{"shape":"Sf"}}},"DetachPolicy":{"type":"structure","required":["PolicyReference","ObjectReference"],"members":{"PolicyReference":{"shape":"Sf"},"ObjectReference":{"shape":"Sf"}}},"CreateIndex":{"type":"structure","required":["OrderedIndexedAttributeList","IsUnique"],"members":{"OrderedIndexedAttributeList":{"shape":"S35"},"IsUnique":{"type":"boolean"},"ParentReference":{"shape":"Sf"},"LinkName":{},"BatchReferenceName":{}}},"AttachToIndex":{"type":"structure","required":["IndexReference","TargetReference"],"members":{"IndexReference":{"shape":"Sf"},"TargetReference":{"shape":"Sf"}}},"DetachFromIndex":{"type":"structure","required":["IndexReference","TargetReference"],"members":{"IndexReference":{"shape":"Sf"},"TargetReference":{"shape":"Sf"}}},"AttachTypedLink":{"type":"structure","required":["SourceObjectReference","TargetObjectReference","TypedLinkFacet","Attributes"],"members":{"SourceObjectReference":{"shape":"Sf"},"TargetObjectReference":{"shape":"Sf"},"TypedLinkFacet":{"shape":"St"},"Attributes":{"shape":"Sv"}}},"DetachTypedLink":{"type":"structure","required":["TypedLinkSpecifier"],"members":{"TypedLinkSpecifier":{"shape":"Sy"}}},"UpdateLinkAttributes":{"type":"structure","required":["TypedLinkSpecifier","AttributeUpdates"],"members":{"TypedLinkSpecifier":{"shape":"Sy"},"AttributeUpdates":{"shape":"S3c"}}}}}}}},"output":{"type":"structure","members":{"Responses":{"type":"list","member":{"type":"structure","members":{"CreateObject":{"type":"structure","members":{"ObjectIdentifier":{}}},"AttachObject":{"type":"structure","members":{"attachedObjectIdentifier":{}}},"DetachObject":{"type":"structure","members":{"detachedObjectIdentifier":{}}},"UpdateObjectAttributes":{"type":"structure","members":{"ObjectIdentifier":{}}},"DeleteObject":{"type":"structure","members":{}},"AddFacetToObject":{"type":"structure","members":{}},"RemoveFacetFromObject":{"type":"structure","members":{}},"AttachPolicy":{"type":"structure","members":{}},"DetachPolicy":{"type":"structure","members":{}},"CreateIndex":{"type":"structure","members":{"ObjectIdentifier":{}}},"AttachToIndex":{"type":"structure","members":{"AttachedObjectIdentifier":{}}},"DetachFromIndex":{"type":"structure","members":{"DetachedObjectIdentifier":{}}},"AttachTypedLink":{"type":"structure","members":{"TypedLinkSpecifier":{"shape":"Sy"}}},"DetachTypedLink":{"type":"structure","members":{}},"UpdateLinkAttributes":{"type":"structure","members":{}}}}}}}},"CreateDirectory":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/directory/create","responseCode":200},"input":{"type":"structure","required":["Name","SchemaArn"],"members":{"Name":{},"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","required":["DirectoryArn","Name","ObjectIdentifier","AppliedSchemaArn"],"members":{"DirectoryArn":{},"Name":{},"ObjectIdentifier":{},"AppliedSchemaArn":{}}}},"CreateFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/facet/create","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name","ObjectType"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{},"Attributes":{"shape":"S42"},"ObjectType":{}}},"output":{"type":"structure","members":{}}},"CreateIndex":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/index","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","OrderedIndexedAttributeList","IsUnique"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"OrderedIndexedAttributeList":{"shape":"S35"},"IsUnique":{"type":"boolean"},"ParentReference":{"shape":"Sf"},"LinkName":{}}},"output":{"type":"structure","members":{"ObjectIdentifier":{}}}},"CreateObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","SchemaFacets"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"SchemaFacets":{"shape":"S1x"},"ObjectAttributeList":{"shape":"S5"},"ParentReference":{"shape":"Sf"},"LinkName":{}}},"output":{"type":"structure","members":{"ObjectIdentifier":{}}}},"CreateSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/create","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"SchemaArn":{}}}},"CreateTypedLinkFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet/create","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Facet"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Facet":{"type":"structure","required":["Name","Attributes","IdentityAttributeOrder"],"members":{"Name":{},"Attributes":{"shape":"S4q"},"IdentityAttributeOrder":{"shape":"S1a"}}}}},"output":{"type":"structure","members":{}}},"DeleteDirectory":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/directory","responseCode":200},"input":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{}}}},"DeleteFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/facet/delete","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/delete","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"DeleteSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema","responseCode":200},"input":{"type":"structure","required":["SchemaArn"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","members":{"SchemaArn":{}}}},"DeleteTypedLinkFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet/delete","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{}}},"output":{"type":"structure","members":{}}},"DetachFromIndex":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/index/detach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","IndexReference","TargetReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"IndexReference":{"shape":"Sf"},"TargetReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{"DetachedObjectIdentifier":{}}}},"DetachObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/detach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ParentReference","LinkName"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ParentReference":{"shape":"Sf"},"LinkName":{}}},"output":{"type":"structure","members":{"DetachedObjectIdentifier":{}}}},"DetachPolicy":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/policy/detach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","PolicyReference","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"PolicyReference":{"shape":"Sf"},"ObjectReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"DetachTypedLink":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/typedlink/detach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","TypedLinkSpecifier"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"TypedLinkSpecifier":{"shape":"Sy"}}}},"DisableDirectory":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/directory/disable","responseCode":200},"input":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{}}}},"EnableDirectory":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/directory/enable","responseCode":200},"input":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{}}}},"GetAppliedSchemaVersion":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/getappliedschema","responseCode":200},"input":{"type":"structure","required":["SchemaArn"],"members":{"SchemaArn":{}}},"output":{"type":"structure","members":{"AppliedSchemaArn":{}}}},"GetDirectory":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/directory/get","responseCode":200},"input":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","required":["Directory"],"members":{"Directory":{"shape":"S5i"}}}},"GetFacet":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/facet","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{}}},"output":{"type":"structure","members":{"Facet":{"type":"structure","members":{"Name":{},"ObjectType":{}}}}}},"GetLinkAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/attributes/get","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","TypedLinkSpecifier","AttributeNames"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"TypedLinkSpecifier":{"shape":"Sy"},"AttributeNames":{"shape":"S1a"},"ConsistencyLevel":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S5"}}}},"GetObjectAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/attributes/get","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference","SchemaFacet","AttributeNames"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"},"SchemaFacet":{"shape":"S3"},"AttributeNames":{"shape":"S1a"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S5"}}}},"GetObjectInformation":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/information","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"SchemaFacets":{"shape":"S1x"},"ObjectIdentifier":{}}}},"GetSchemaAsJson":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/json","responseCode":200},"input":{"type":"structure","required":["SchemaArn"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","members":{"Name":{},"Document":{}}}},"GetTypedLinkFacetInformation":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet/get","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{}}},"output":{"type":"structure","members":{"IdentityAttributeOrder":{"shape":"S1a"}}}},"ListAppliedSchemaArns":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/applied","responseCode":200},"input":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{},"SchemaArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SchemaArns":{"shape":"S61"},"NextToken":{}}}},"ListAttachedIndices":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/indices","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","TargetReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"TargetReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"IndexAttachments":{"shape":"S20"},"NextToken":{}}}},"ListDevelopmentSchemaArns":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/development","responseCode":200},"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SchemaArns":{"shape":"S61"},"NextToken":{}}}},"ListDirectories":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/directory/list","responseCode":200},"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"state":{}}},"output":{"type":"structure","required":["Directories"],"members":{"Directories":{"type":"list","member":{"shape":"S5i"}},"NextToken":{}}}},"ListFacetAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/facet/attributes","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S42"},"NextToken":{}}}},"ListFacetNames":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/facet/list","responseCode":200},"input":{"type":"structure","required":["SchemaArn"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FacetNames":{"type":"list","member":{}},"NextToken":{}}}},"ListIncomingTypedLinks":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/incoming","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"FilterAttributeRanges":{"shape":"S1k"},"FilterTypedLink":{"shape":"St"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{}}},"output":{"type":"structure","members":{"LinkSpecifiers":{"shape":"S2h"},"NextToken":{}}}},"ListIndex":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/index/targets","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","IndexReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"RangesOnIndexedValues":{"shape":"S1f"},"IndexReference":{"shape":"Sf"},"MaxResults":{"type":"integer"},"NextToken":{},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"IndexAttachments":{"shape":"S20"},"NextToken":{}}}},"ListObjectAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/attributes","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"},"FacetFilter":{"shape":"S3"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S5"},"NextToken":{}}}},"ListObjectChildren":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/children","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"Children":{"shape":"S1v"},"NextToken":{}}}},"ListObjectParentPaths":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/parentpaths","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PathToObjectIdentifiersList":{"shape":"S23"},"NextToken":{}}}},"ListObjectParents":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/parent","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"Parents":{"type":"map","key":{},"value":{}},"NextToken":{}}}},"ListObjectPolicies":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/policy","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"AttachedPolicyIds":{"shape":"S26"},"NextToken":{}}}},"ListOutgoingTypedLinks":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/outgoing","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"FilterAttributeRanges":{"shape":"S1k"},"FilterTypedLink":{"shape":"St"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{}}},"output":{"type":"structure","members":{"TypedLinkSpecifiers":{"shape":"S2h"},"NextToken":{}}}},"ListPolicyAttachments":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/policy/attachment","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","PolicyReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"PolicyReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"ObjectIdentifiers":{"shape":"S26"},"NextToken":{}}}},"ListPublishedSchemaArns":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/published","responseCode":200},"input":{"type":"structure","members":{"SchemaArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SchemaArns":{"shape":"S61"},"NextToken":{}}}},"ListTagsForResource":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/tags","responseCode":200},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S72"},"NextToken":{}}}},"ListTypedLinkFacetAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet/attributes","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S4q"},"NextToken":{}}}},"ListTypedLinkFacetNames":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet/list","responseCode":200},"input":{"type":"structure","required":["SchemaArn"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FacetNames":{"type":"list","member":{}},"NextToken":{}}}},"LookupPolicy":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/policy/lookup","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PolicyToPathList":{"shape":"S2a"},"NextToken":{}}}},"PublishSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/publish","responseCode":200},"input":{"type":"structure","required":["DevelopmentSchemaArn","Version"],"members":{"DevelopmentSchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Version":{},"MinorVersion":{},"Name":{}}},"output":{"type":"structure","members":{"PublishedSchemaArn":{}}}},"PutSchemaFromJson":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/json","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Document"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Document":{}}},"output":{"type":"structure","members":{"Arn":{}}}},"RemoveFacetFromObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/facets/delete","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","SchemaFacet","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"SchemaFacet":{"shape":"S3"},"ObjectReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/tags/add","responseCode":200},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S72"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/tags/remove","responseCode":200},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/facet","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{},"AttributeUpdates":{"type":"list","member":{"type":"structure","members":{"Attribute":{"shape":"S43"},"Action":{}}}},"ObjectType":{}}},"output":{"type":"structure","members":{}}},"UpdateLinkAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/attributes/update","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","TypedLinkSpecifier","AttributeUpdates"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"TypedLinkSpecifier":{"shape":"Sy"},"AttributeUpdates":{"shape":"S3c"}}},"output":{"type":"structure","members":{}}},"UpdateObjectAttributes":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/update","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference","AttributeUpdates"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"AttributeUpdates":{"shape":"S2v"}}},"output":{"type":"structure","members":{"ObjectIdentifier":{}}}},"UpdateSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/update","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{}}},"output":{"type":"structure","members":{"SchemaArn":{}}}},"UpdateTypedLinkFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name","AttributeUpdates","IdentityAttributeOrder"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{},"AttributeUpdates":{"type":"list","member":{"type":"structure","required":["Attribute","Action"],"members":{"Attribute":{"shape":"S4r"},"Action":{}}}},"IdentityAttributeOrder":{"shape":"S1a"}}},"output":{"type":"structure","members":{}}},"UpgradeAppliedSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/upgradeapplied","responseCode":200},"input":{"type":"structure","required":["PublishedSchemaArn","DirectoryArn"],"members":{"PublishedSchemaArn":{},"DirectoryArn":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"UpgradedSchemaArn":{},"DirectoryArn":{}}}},"UpgradePublishedSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/upgradepublished","responseCode":200},"input":{"type":"structure","required":["DevelopmentSchemaArn","PublishedSchemaArn","MinorVersion"],"members":{"DevelopmentSchemaArn":{},"PublishedSchemaArn":{},"MinorVersion":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"UpgradedSchemaArn":{}}}}},"shapes":{"S3":{"type":"structure","members":{"SchemaArn":{},"FacetName":{}}},"S5":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{"shape":"S7"},"Value":{"shape":"S9"}}}},"S7":{"type":"structure","required":["SchemaArn","FacetName","Name"],"members":{"SchemaArn":{},"FacetName":{},"Name":{}}},"S9":{"type":"structure","members":{"StringValue":{},"BinaryValue":{"type":"blob"},"BooleanValue":{"type":"boolean"},"NumberValue":{},"DatetimeValue":{"type":"timestamp"}}},"Sf":{"type":"structure","members":{"Selector":{}}},"St":{"type":"structure","required":["SchemaArn","TypedLinkName"],"members":{"SchemaArn":{},"TypedLinkName":{}}},"Sv":{"type":"list","member":{"type":"structure","required":["AttributeName","Value"],"members":{"AttributeName":{},"Value":{"shape":"S9"}}}},"Sy":{"type":"structure","required":["TypedLinkFacet","SourceObjectReference","TargetObjectReference","IdentityAttributeValues"],"members":{"TypedLinkFacet":{"shape":"St"},"SourceObjectReference":{"shape":"Sf"},"TargetObjectReference":{"shape":"Sf"},"IdentityAttributeValues":{"shape":"Sv"}}},"S1a":{"type":"list","member":{}},"S1f":{"type":"list","member":{"type":"structure","members":{"AttributeKey":{"shape":"S7"},"Range":{"shape":"S1h"}}}},"S1h":{"type":"structure","required":["StartMode","EndMode"],"members":{"StartMode":{},"StartValue":{"shape":"S9"},"EndMode":{},"EndValue":{"shape":"S9"}}},"S1k":{"type":"list","member":{"type":"structure","required":["Range"],"members":{"AttributeName":{},"Range":{"shape":"S1h"}}}},"S1v":{"type":"map","key":{},"value":{}},"S1x":{"type":"list","member":{"shape":"S3"}},"S20":{"type":"list","member":{"type":"structure","members":{"IndexedAttributes":{"shape":"S5"},"ObjectIdentifier":{}}}},"S23":{"type":"list","member":{"type":"structure","members":{"Path":{},"ObjectIdentifiers":{"shape":"S26"}}}},"S26":{"type":"list","member":{}},"S2a":{"type":"list","member":{"type":"structure","members":{"Path":{},"Policies":{"type":"list","member":{"type":"structure","members":{"PolicyId":{},"ObjectIdentifier":{},"PolicyType":{}}}}}}},"S2h":{"type":"list","member":{"shape":"Sy"}},"S2v":{"type":"list","member":{"type":"structure","members":{"ObjectAttributeKey":{"shape":"S7"},"ObjectAttributeAction":{"type":"structure","members":{"ObjectAttributeActionType":{},"ObjectAttributeUpdateValue":{"shape":"S9"}}}}}},"S35":{"type":"list","member":{"shape":"S7"}},"S3c":{"type":"list","member":{"type":"structure","members":{"AttributeKey":{"shape":"S7"},"AttributeAction":{"type":"structure","members":{"AttributeActionType":{},"AttributeUpdateValue":{"shape":"S9"}}}}}},"S42":{"type":"list","member":{"shape":"S43"}},"S43":{"type":"structure","required":["Name"],"members":{"Name":{},"AttributeDefinition":{"type":"structure","required":["Type"],"members":{"Type":{},"DefaultValue":{"shape":"S9"},"IsImmutable":{"type":"boolean"},"Rules":{"shape":"S46"}}},"AttributeReference":{"type":"structure","required":["TargetFacetName","TargetAttributeName"],"members":{"TargetFacetName":{},"TargetAttributeName":{}}},"RequiredBehavior":{}}},"S46":{"type":"map","key":{},"value":{"type":"structure","members":{"Type":{},"Parameters":{"type":"map","key":{},"value":{}}}}},"S4q":{"type":"list","member":{"shape":"S4r"}},"S4r":{"type":"structure","required":["Name","Type","RequiredBehavior"],"members":{"Name":{},"Type":{},"DefaultValue":{"shape":"S9"},"IsImmutable":{"type":"boolean"},"Rules":{"shape":"S46"},"RequiredBehavior":{}}},"S5i":{"type":"structure","members":{"Name":{},"DirectoryArn":{},"State":{},"CreationDateTime":{"type":"timestamp"}}},"S61":{"type":"list","member":{}},"S72":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}');

});

parcelRequire.register("hDCTG", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListAppliedSchemaArns":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListAttachedIndices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDevelopmentSchemaArns":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDirectories":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListFacetAttributes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListFacetNames":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListIndex":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListObjectAttributes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListObjectChildren":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListObjectParentPaths":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListObjectParents":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListObjectPolicies":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListPolicyAttachments":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListPublishedSchemaArns":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTagsForResource":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTypedLinkFacetAttributes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTypedLinkFacetNames":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"LookupPolicy":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});

parcelRequire.register("bLmX5", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-01-11","endpointPrefix":"clouddirectory","protocol":"rest-json","serviceFullName":"Amazon CloudDirectory","serviceId":"CloudDirectory","signatureVersion":"v4","signingName":"clouddirectory","uid":"clouddirectory-2017-01-11"},"operations":{"AddFacetToObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/facets","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","SchemaFacet","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"SchemaFacet":{"shape":"S3"},"ObjectAttributeList":{"shape":"S5"},"ObjectReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"ApplySchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/apply","responseCode":200},"input":{"type":"structure","required":["PublishedSchemaArn","DirectoryArn"],"members":{"PublishedSchemaArn":{},"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","members":{"AppliedSchemaArn":{},"DirectoryArn":{}}}},"AttachObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/attach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ParentReference","ChildReference","LinkName"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ParentReference":{"shape":"Sf"},"ChildReference":{"shape":"Sf"},"LinkName":{}}},"output":{"type":"structure","members":{"AttachedObjectIdentifier":{}}}},"AttachPolicy":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/policy/attach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","PolicyReference","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"PolicyReference":{"shape":"Sf"},"ObjectReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"AttachToIndex":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/index/attach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","IndexReference","TargetReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"IndexReference":{"shape":"Sf"},"TargetReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{"AttachedObjectIdentifier":{}}}},"AttachTypedLink":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/typedlink/attach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","SourceObjectReference","TargetObjectReference","TypedLinkFacet","Attributes"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"SourceObjectReference":{"shape":"Sf"},"TargetObjectReference":{"shape":"Sf"},"TypedLinkFacet":{"shape":"St"},"Attributes":{"shape":"Sv"}}},"output":{"type":"structure","members":{"TypedLinkSpecifier":{"shape":"Sy"}}}},"BatchRead":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/batchread","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","Operations"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"Operations":{"type":"list","member":{"type":"structure","members":{"ListObjectAttributes":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"FacetFilter":{"shape":"S3"}}},"ListObjectChildren":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListAttachedIndices":{"type":"structure","required":["TargetReference"],"members":{"TargetReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListObjectParentPaths":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"GetObjectInformation":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"}}},"GetObjectAttributes":{"type":"structure","required":["ObjectReference","SchemaFacet","AttributeNames"],"members":{"ObjectReference":{"shape":"Sf"},"SchemaFacet":{"shape":"S3"},"AttributeNames":{"shape":"S1a"}}},"ListObjectParents":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListObjectPolicies":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListPolicyAttachments":{"type":"structure","required":["PolicyReference"],"members":{"PolicyReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"LookupPolicy":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListIndex":{"type":"structure","required":["IndexReference"],"members":{"RangesOnIndexedValues":{"shape":"S1g"},"IndexReference":{"shape":"Sf"},"MaxResults":{"type":"integer"},"NextToken":{}}},"ListOutgoingTypedLinks":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"FilterAttributeRanges":{"shape":"S1l"},"FilterTypedLink":{"shape":"St"},"NextToken":{},"MaxResults":{"type":"integer"}}},"ListIncomingTypedLinks":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"},"FilterAttributeRanges":{"shape":"S1l"},"FilterTypedLink":{"shape":"St"},"NextToken":{},"MaxResults":{"type":"integer"}}},"GetLinkAttributes":{"type":"structure","required":["TypedLinkSpecifier","AttributeNames"],"members":{"TypedLinkSpecifier":{"shape":"Sy"},"AttributeNames":{"shape":"S1a"}}}}}},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"Responses":{"type":"list","member":{"type":"structure","members":{"SuccessfulResponse":{"type":"structure","members":{"ListObjectAttributes":{"type":"structure","members":{"Attributes":{"shape":"S5"},"NextToken":{}}},"ListObjectChildren":{"type":"structure","members":{"Children":{"shape":"S1w"},"NextToken":{}}},"GetObjectInformation":{"type":"structure","members":{"SchemaFacets":{"shape":"S1y"},"ObjectIdentifier":{}}},"GetObjectAttributes":{"type":"structure","members":{"Attributes":{"shape":"S5"}}},"ListAttachedIndices":{"type":"structure","members":{"IndexAttachments":{"shape":"S21"},"NextToken":{}}},"ListObjectParentPaths":{"type":"structure","members":{"PathToObjectIdentifiersList":{"shape":"S24"},"NextToken":{}}},"ListObjectPolicies":{"type":"structure","members":{"AttachedPolicyIds":{"shape":"S27"},"NextToken":{}}},"ListPolicyAttachments":{"type":"structure","members":{"ObjectIdentifiers":{"shape":"S27"},"NextToken":{}}},"LookupPolicy":{"type":"structure","members":{"PolicyToPathList":{"shape":"S2b"},"NextToken":{}}},"ListIndex":{"type":"structure","members":{"IndexAttachments":{"shape":"S21"},"NextToken":{}}},"ListOutgoingTypedLinks":{"type":"structure","members":{"TypedLinkSpecifiers":{"shape":"S2i"},"NextToken":{}}},"ListIncomingTypedLinks":{"type":"structure","members":{"LinkSpecifiers":{"shape":"S2i"},"NextToken":{}}},"GetLinkAttributes":{"type":"structure","members":{"Attributes":{"shape":"S5"}}},"ListObjectParents":{"type":"structure","members":{"ParentLinks":{"shape":"S2m"},"NextToken":{}}}}},"ExceptionResponse":{"type":"structure","members":{"Type":{},"Message":{}}}}}}}}},"BatchWrite":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/batchwrite","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","Operations"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"Operations":{"type":"list","member":{"type":"structure","members":{"CreateObject":{"type":"structure","required":["SchemaFacet","ObjectAttributeList"],"members":{"SchemaFacet":{"shape":"S1y"},"ObjectAttributeList":{"shape":"S5"},"ParentReference":{"shape":"Sf"},"LinkName":{},"BatchReferenceName":{}}},"AttachObject":{"type":"structure","required":["ParentReference","ChildReference","LinkName"],"members":{"ParentReference":{"shape":"Sf"},"ChildReference":{"shape":"Sf"},"LinkName":{}}},"DetachObject":{"type":"structure","required":["ParentReference","LinkName"],"members":{"ParentReference":{"shape":"Sf"},"LinkName":{},"BatchReferenceName":{}}},"UpdateObjectAttributes":{"type":"structure","required":["ObjectReference","AttributeUpdates"],"members":{"ObjectReference":{"shape":"Sf"},"AttributeUpdates":{"shape":"S2z"}}},"DeleteObject":{"type":"structure","required":["ObjectReference"],"members":{"ObjectReference":{"shape":"Sf"}}},"AddFacetToObject":{"type":"structure","required":["SchemaFacet","ObjectAttributeList","ObjectReference"],"members":{"SchemaFacet":{"shape":"S3"},"ObjectAttributeList":{"shape":"S5"},"ObjectReference":{"shape":"Sf"}}},"RemoveFacetFromObject":{"type":"structure","required":["SchemaFacet","ObjectReference"],"members":{"SchemaFacet":{"shape":"S3"},"ObjectReference":{"shape":"Sf"}}},"AttachPolicy":{"type":"structure","required":["PolicyReference","ObjectReference"],"members":{"PolicyReference":{"shape":"Sf"},"ObjectReference":{"shape":"Sf"}}},"DetachPolicy":{"type":"structure","required":["PolicyReference","ObjectReference"],"members":{"PolicyReference":{"shape":"Sf"},"ObjectReference":{"shape":"Sf"}}},"CreateIndex":{"type":"structure","required":["OrderedIndexedAttributeList","IsUnique"],"members":{"OrderedIndexedAttributeList":{"shape":"S39"},"IsUnique":{"type":"boolean"},"ParentReference":{"shape":"Sf"},"LinkName":{},"BatchReferenceName":{}}},"AttachToIndex":{"type":"structure","required":["IndexReference","TargetReference"],"members":{"IndexReference":{"shape":"Sf"},"TargetReference":{"shape":"Sf"}}},"DetachFromIndex":{"type":"structure","required":["IndexReference","TargetReference"],"members":{"IndexReference":{"shape":"Sf"},"TargetReference":{"shape":"Sf"}}},"AttachTypedLink":{"type":"structure","required":["SourceObjectReference","TargetObjectReference","TypedLinkFacet","Attributes"],"members":{"SourceObjectReference":{"shape":"Sf"},"TargetObjectReference":{"shape":"Sf"},"TypedLinkFacet":{"shape":"St"},"Attributes":{"shape":"Sv"}}},"DetachTypedLink":{"type":"structure","required":["TypedLinkSpecifier"],"members":{"TypedLinkSpecifier":{"shape":"Sy"}}},"UpdateLinkAttributes":{"type":"structure","required":["TypedLinkSpecifier","AttributeUpdates"],"members":{"TypedLinkSpecifier":{"shape":"Sy"},"AttributeUpdates":{"shape":"S3g"}}}}}}}},"output":{"type":"structure","members":{"Responses":{"type":"list","member":{"type":"structure","members":{"CreateObject":{"type":"structure","members":{"ObjectIdentifier":{}}},"AttachObject":{"type":"structure","members":{"attachedObjectIdentifier":{}}},"DetachObject":{"type":"structure","members":{"detachedObjectIdentifier":{}}},"UpdateObjectAttributes":{"type":"structure","members":{"ObjectIdentifier":{}}},"DeleteObject":{"type":"structure","members":{}},"AddFacetToObject":{"type":"structure","members":{}},"RemoveFacetFromObject":{"type":"structure","members":{}},"AttachPolicy":{"type":"structure","members":{}},"DetachPolicy":{"type":"structure","members":{}},"CreateIndex":{"type":"structure","members":{"ObjectIdentifier":{}}},"AttachToIndex":{"type":"structure","members":{"AttachedObjectIdentifier":{}}},"DetachFromIndex":{"type":"structure","members":{"DetachedObjectIdentifier":{}}},"AttachTypedLink":{"type":"structure","members":{"TypedLinkSpecifier":{"shape":"Sy"}}},"DetachTypedLink":{"type":"structure","members":{}},"UpdateLinkAttributes":{"type":"structure","members":{}}}}}}}},"CreateDirectory":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/directory/create","responseCode":200},"input":{"type":"structure","required":["Name","SchemaArn"],"members":{"Name":{},"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","required":["DirectoryArn","Name","ObjectIdentifier","AppliedSchemaArn"],"members":{"DirectoryArn":{},"Name":{},"ObjectIdentifier":{},"AppliedSchemaArn":{}}}},"CreateFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/facet/create","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{},"Attributes":{"shape":"S46"},"ObjectType":{},"FacetStyle":{}}},"output":{"type":"structure","members":{}}},"CreateIndex":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/index","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","OrderedIndexedAttributeList","IsUnique"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"OrderedIndexedAttributeList":{"shape":"S39"},"IsUnique":{"type":"boolean"},"ParentReference":{"shape":"Sf"},"LinkName":{}}},"output":{"type":"structure","members":{"ObjectIdentifier":{}}}},"CreateObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","SchemaFacets"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"SchemaFacets":{"shape":"S1y"},"ObjectAttributeList":{"shape":"S5"},"ParentReference":{"shape":"Sf"},"LinkName":{}}},"output":{"type":"structure","members":{"ObjectIdentifier":{}}}},"CreateSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/create","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"SchemaArn":{}}}},"CreateTypedLinkFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet/create","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Facet"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Facet":{"type":"structure","required":["Name","Attributes","IdentityAttributeOrder"],"members":{"Name":{},"Attributes":{"shape":"S4v"},"IdentityAttributeOrder":{"shape":"S1a"}}}}},"output":{"type":"structure","members":{}}},"DeleteDirectory":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/directory","responseCode":200},"input":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{}}}},"DeleteFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/facet/delete","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/delete","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"DeleteSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema","responseCode":200},"input":{"type":"structure","required":["SchemaArn"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","members":{"SchemaArn":{}}}},"DeleteTypedLinkFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet/delete","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{}}},"output":{"type":"structure","members":{}}},"DetachFromIndex":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/index/detach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","IndexReference","TargetReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"IndexReference":{"shape":"Sf"},"TargetReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{"DetachedObjectIdentifier":{}}}},"DetachObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/detach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ParentReference","LinkName"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ParentReference":{"shape":"Sf"},"LinkName":{}}},"output":{"type":"structure","members":{"DetachedObjectIdentifier":{}}}},"DetachPolicy":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/policy/detach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","PolicyReference","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"PolicyReference":{"shape":"Sf"},"ObjectReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"DetachTypedLink":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/typedlink/detach","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","TypedLinkSpecifier"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"TypedLinkSpecifier":{"shape":"Sy"}}}},"DisableDirectory":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/directory/disable","responseCode":200},"input":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{}}}},"EnableDirectory":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/directory/enable","responseCode":200},"input":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{}}}},"GetAppliedSchemaVersion":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/getappliedschema","responseCode":200},"input":{"type":"structure","required":["SchemaArn"],"members":{"SchemaArn":{}}},"output":{"type":"structure","members":{"AppliedSchemaArn":{}}}},"GetDirectory":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/directory/get","responseCode":200},"input":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","required":["Directory"],"members":{"Directory":{"shape":"S5n"}}}},"GetFacet":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/facet","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{}}},"output":{"type":"structure","members":{"Facet":{"type":"structure","members":{"Name":{},"ObjectType":{},"FacetStyle":{}}}}}},"GetLinkAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/attributes/get","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","TypedLinkSpecifier","AttributeNames"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"TypedLinkSpecifier":{"shape":"Sy"},"AttributeNames":{"shape":"S1a"},"ConsistencyLevel":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S5"}}}},"GetObjectAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/attributes/get","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference","SchemaFacet","AttributeNames"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"},"SchemaFacet":{"shape":"S3"},"AttributeNames":{"shape":"S1a"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S5"}}}},"GetObjectInformation":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/information","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"SchemaFacets":{"shape":"S1y"},"ObjectIdentifier":{}}}},"GetSchemaAsJson":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/json","responseCode":200},"input":{"type":"structure","required":["SchemaArn"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"}}},"output":{"type":"structure","members":{"Name":{},"Document":{}}}},"GetTypedLinkFacetInformation":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet/get","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{}}},"output":{"type":"structure","members":{"IdentityAttributeOrder":{"shape":"S1a"}}}},"ListAppliedSchemaArns":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/applied","responseCode":200},"input":{"type":"structure","required":["DirectoryArn"],"members":{"DirectoryArn":{},"SchemaArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SchemaArns":{"shape":"S66"},"NextToken":{}}}},"ListAttachedIndices":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/indices","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","TargetReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"TargetReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"IndexAttachments":{"shape":"S21"},"NextToken":{}}}},"ListDevelopmentSchemaArns":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/development","responseCode":200},"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SchemaArns":{"shape":"S66"},"NextToken":{}}}},"ListDirectories":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/directory/list","responseCode":200},"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"state":{}}},"output":{"type":"structure","required":["Directories"],"members":{"Directories":{"type":"list","member":{"shape":"S5n"}},"NextToken":{}}}},"ListFacetAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/facet/attributes","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S46"},"NextToken":{}}}},"ListFacetNames":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/facet/list","responseCode":200},"input":{"type":"structure","required":["SchemaArn"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FacetNames":{"type":"list","member":{}},"NextToken":{}}}},"ListIncomingTypedLinks":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/incoming","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"FilterAttributeRanges":{"shape":"S1l"},"FilterTypedLink":{"shape":"St"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{}}},"output":{"type":"structure","members":{"LinkSpecifiers":{"shape":"S2i"},"NextToken":{}}}},"ListIndex":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/index/targets","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","IndexReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"RangesOnIndexedValues":{"shape":"S1g"},"IndexReference":{"shape":"Sf"},"MaxResults":{"type":"integer"},"NextToken":{},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"IndexAttachments":{"shape":"S21"},"NextToken":{}}}},"ListManagedSchemaArns":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/managed","responseCode":200},"input":{"type":"structure","members":{"SchemaArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SchemaArns":{"shape":"S66"},"NextToken":{}}}},"ListObjectAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/attributes","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"},"FacetFilter":{"shape":"S3"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S5"},"NextToken":{}}}},"ListObjectChildren":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/children","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"Children":{"shape":"S1w"},"NextToken":{}}}},"ListObjectParentPaths":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/parentpaths","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PathToObjectIdentifiersList":{"shape":"S24"},"NextToken":{}}}},"ListObjectParents":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/parent","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"},"IncludeAllLinksToEachParent":{"type":"boolean"}}},"output":{"type":"structure","members":{"Parents":{"type":"map","key":{},"value":{}},"NextToken":{},"ParentLinks":{"shape":"S2m"}}}},"ListObjectPolicies":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/object/policy","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"AttachedPolicyIds":{"shape":"S27"},"NextToken":{}}}},"ListOutgoingTypedLinks":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/outgoing","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"FilterAttributeRanges":{"shape":"S1l"},"FilterTypedLink":{"shape":"St"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{}}},"output":{"type":"structure","members":{"TypedLinkSpecifiers":{"shape":"S2i"},"NextToken":{}}}},"ListPolicyAttachments":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/policy/attachment","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","PolicyReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"PolicyReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"},"ConsistencyLevel":{"location":"header","locationName":"x-amz-consistency-level"}}},"output":{"type":"structure","members":{"ObjectIdentifiers":{"shape":"S27"},"NextToken":{}}}},"ListPublishedSchemaArns":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/schema/published","responseCode":200},"input":{"type":"structure","members":{"SchemaArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SchemaArns":{"shape":"S66"},"NextToken":{}}}},"ListTagsForResource":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/tags","responseCode":200},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S79"},"NextToken":{}}}},"ListTypedLinkFacetAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet/attributes","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S4v"},"NextToken":{}}}},"ListTypedLinkFacetNames":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet/list","responseCode":200},"input":{"type":"structure","required":["SchemaArn"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FacetNames":{"type":"list","member":{}},"NextToken":{}}}},"LookupPolicy":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/policy/lookup","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PolicyToPathList":{"shape":"S2b"},"NextToken":{}}}},"PublishSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/publish","responseCode":200},"input":{"type":"structure","required":["DevelopmentSchemaArn","Version"],"members":{"DevelopmentSchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Version":{},"MinorVersion":{},"Name":{}}},"output":{"type":"structure","members":{"PublishedSchemaArn":{}}}},"PutSchemaFromJson":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/json","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Document"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Document":{}}},"output":{"type":"structure","members":{"Arn":{}}}},"RemoveFacetFromObject":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/facets/delete","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","SchemaFacet","ObjectReference"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"SchemaFacet":{"shape":"S3"},"ObjectReference":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/tags/add","responseCode":200},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S79"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/tags/remove","responseCode":200},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/facet","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{},"AttributeUpdates":{"type":"list","member":{"type":"structure","members":{"Attribute":{"shape":"S47"},"Action":{}}}},"ObjectType":{}}},"output":{"type":"structure","members":{}}},"UpdateLinkAttributes":{"http":{"requestUri":"/amazonclouddirectory/2017-01-11/typedlink/attributes/update","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","TypedLinkSpecifier","AttributeUpdates"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"TypedLinkSpecifier":{"shape":"Sy"},"AttributeUpdates":{"shape":"S3g"}}},"output":{"type":"structure","members":{}}},"UpdateObjectAttributes":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/object/update","responseCode":200},"input":{"type":"structure","required":["DirectoryArn","ObjectReference","AttributeUpdates"],"members":{"DirectoryArn":{"location":"header","locationName":"x-amz-data-partition"},"ObjectReference":{"shape":"Sf"},"AttributeUpdates":{"shape":"S2z"}}},"output":{"type":"structure","members":{"ObjectIdentifier":{}}}},"UpdateSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/update","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{}}},"output":{"type":"structure","members":{"SchemaArn":{}}}},"UpdateTypedLinkFacet":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/typedlink/facet","responseCode":200},"input":{"type":"structure","required":["SchemaArn","Name","AttributeUpdates","IdentityAttributeOrder"],"members":{"SchemaArn":{"location":"header","locationName":"x-amz-data-partition"},"Name":{},"AttributeUpdates":{"type":"list","member":{"type":"structure","required":["Attribute","Action"],"members":{"Attribute":{"shape":"S4w"},"Action":{}}}},"IdentityAttributeOrder":{"shape":"S1a"}}},"output":{"type":"structure","members":{}}},"UpgradeAppliedSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/upgradeapplied","responseCode":200},"input":{"type":"structure","required":["PublishedSchemaArn","DirectoryArn"],"members":{"PublishedSchemaArn":{},"DirectoryArn":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"UpgradedSchemaArn":{},"DirectoryArn":{}}}},"UpgradePublishedSchema":{"http":{"method":"PUT","requestUri":"/amazonclouddirectory/2017-01-11/schema/upgradepublished","responseCode":200},"input":{"type":"structure","required":["DevelopmentSchemaArn","PublishedSchemaArn","MinorVersion"],"members":{"DevelopmentSchemaArn":{},"PublishedSchemaArn":{},"MinorVersion":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"UpgradedSchemaArn":{}}}}},"shapes":{"S3":{"type":"structure","members":{"SchemaArn":{},"FacetName":{}}},"S5":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{"shape":"S7"},"Value":{"shape":"S9"}}}},"S7":{"type":"structure","required":["SchemaArn","FacetName","Name"],"members":{"SchemaArn":{},"FacetName":{},"Name":{}}},"S9":{"type":"structure","members":{"StringValue":{},"BinaryValue":{"type":"blob"},"BooleanValue":{"type":"boolean"},"NumberValue":{},"DatetimeValue":{"type":"timestamp"}}},"Sf":{"type":"structure","members":{"Selector":{}}},"St":{"type":"structure","required":["SchemaArn","TypedLinkName"],"members":{"SchemaArn":{},"TypedLinkName":{}}},"Sv":{"type":"list","member":{"type":"structure","required":["AttributeName","Value"],"members":{"AttributeName":{},"Value":{"shape":"S9"}}}},"Sy":{"type":"structure","required":["TypedLinkFacet","SourceObjectReference","TargetObjectReference","IdentityAttributeValues"],"members":{"TypedLinkFacet":{"shape":"St"},"SourceObjectReference":{"shape":"Sf"},"TargetObjectReference":{"shape":"Sf"},"IdentityAttributeValues":{"shape":"Sv"}}},"S1a":{"type":"list","member":{}},"S1g":{"type":"list","member":{"type":"structure","members":{"AttributeKey":{"shape":"S7"},"Range":{"shape":"S1i"}}}},"S1i":{"type":"structure","required":["StartMode","EndMode"],"members":{"StartMode":{},"StartValue":{"shape":"S9"},"EndMode":{},"EndValue":{"shape":"S9"}}},"S1l":{"type":"list","member":{"type":"structure","required":["Range"],"members":{"AttributeName":{},"Range":{"shape":"S1i"}}}},"S1w":{"type":"map","key":{},"value":{}},"S1y":{"type":"list","member":{"shape":"S3"}},"S21":{"type":"list","member":{"type":"structure","members":{"IndexedAttributes":{"shape":"S5"},"ObjectIdentifier":{}}}},"S24":{"type":"list","member":{"type":"structure","members":{"Path":{},"ObjectIdentifiers":{"shape":"S27"}}}},"S27":{"type":"list","member":{}},"S2b":{"type":"list","member":{"type":"structure","members":{"Path":{},"Policies":{"type":"list","member":{"type":"structure","members":{"PolicyId":{},"ObjectIdentifier":{},"PolicyType":{}}}}}}},"S2i":{"type":"list","member":{"shape":"Sy"}},"S2m":{"type":"list","member":{"type":"structure","members":{"ObjectIdentifier":{},"LinkName":{}}}},"S2z":{"type":"list","member":{"type":"structure","members":{"ObjectAttributeKey":{"shape":"S7"},"ObjectAttributeAction":{"type":"structure","members":{"ObjectAttributeActionType":{},"ObjectAttributeUpdateValue":{"shape":"S9"}}}}}},"S39":{"type":"list","member":{"shape":"S7"}},"S3g":{"type":"list","member":{"type":"structure","members":{"AttributeKey":{"shape":"S7"},"AttributeAction":{"type":"structure","members":{"AttributeActionType":{},"AttributeUpdateValue":{"shape":"S9"}}}}}},"S46":{"type":"list","member":{"shape":"S47"}},"S47":{"type":"structure","required":["Name"],"members":{"Name":{},"AttributeDefinition":{"type":"structure","required":["Type"],"members":{"Type":{},"DefaultValue":{"shape":"S9"},"IsImmutable":{"type":"boolean"},"Rules":{"shape":"S4a"}}},"AttributeReference":{"type":"structure","required":["TargetFacetName","TargetAttributeName"],"members":{"TargetFacetName":{},"TargetAttributeName":{}}},"RequiredBehavior":{}}},"S4a":{"type":"map","key":{},"value":{"type":"structure","members":{"Type":{},"Parameters":{"type":"map","key":{},"value":{}}}}},"S4v":{"type":"list","member":{"shape":"S4w"}},"S4w":{"type":"structure","required":["Name","Type","RequiredBehavior"],"members":{"Name":{},"Type":{},"DefaultValue":{"shape":"S9"},"IsImmutable":{"type":"boolean"},"Rules":{"shape":"S4a"},"RequiredBehavior":{}}},"S5n":{"type":"structure","members":{"Name":{},"DirectoryArn":{},"State":{},"CreationDateTime":{"type":"timestamp"}}},"S66":{"type":"list","member":{}},"S79":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}');

});

parcelRequire.register("jOuen", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListAppliedSchemaArns":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListAttachedIndices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDevelopmentSchemaArns":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDirectories":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListFacetAttributes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListFacetNames":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListIndex":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListManagedSchemaArns":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListObjectAttributes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListObjectChildren":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListObjectParentPaths":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListObjectParents":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListObjectPolicies":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListPolicyAttachments":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListPublishedSchemaArns":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTagsForResource":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTypedLinkFacetAttributes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTypedLinkFacetNames":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"LookupPolicy":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("cYyu7", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $9725d691aaf27e18$var$Service = $dbC7k.Service;
var $9725d691aaf27e18$var$apiLoader = $dbC7k.apiLoader;
$9725d691aaf27e18$var$apiLoader.services["cloudformation"] = {};
$dbC7k.CloudFormation = $9725d691aaf27e18$var$Service.defineService("cloudformation", [
    "2010-05-15"
]);



Object.defineProperty($9725d691aaf27e18$var$apiLoader.services["cloudformation"], "2010-05-15", {
    get: function get() {
        var model = (parcelRequire("ccEeU"));
        model.paginators = (parcelRequire("h5zCp")).pagination;
        model.waiters = (parcelRequire("7nG3T")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.CloudFormation;

});
parcelRequire.register("ccEeU", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2010-05-15","endpointPrefix":"cloudformation","protocol":"query","serviceFullName":"AWS CloudFormation","serviceId":"CloudFormation","signatureVersion":"v4","uid":"cloudformation-2010-05-15","xmlNamespace":"http://cloudformation.amazonaws.com/doc/2010-05-15/"},"operations":{"CancelUpdateStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"ClientRequestToken":{}}}},"ContinueUpdateRollback":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"RoleARN":{},"ResourcesToSkip":{"type":"list","member":{}},"ClientRequestToken":{}}},"output":{"resultWrapper":"ContinueUpdateRollbackResult","type":"structure","members":{}}},"CreateChangeSet":{"input":{"type":"structure","required":["StackName","ChangeSetName"],"members":{"StackName":{},"TemplateBody":{},"TemplateURL":{},"UsePreviousTemplate":{"type":"boolean"},"Parameters":{"shape":"Se"},"Capabilities":{"shape":"Sj"},"ResourceTypes":{"shape":"Sl"},"RoleARN":{},"RollbackConfiguration":{"shape":"Sn"},"NotificationARNs":{"shape":"St"},"Tags":{"shape":"Sv"},"ChangeSetName":{},"ClientToken":{},"Description":{},"ChangeSetType":{}}},"output":{"resultWrapper":"CreateChangeSetResult","type":"structure","members":{"Id":{},"StackId":{}}}},"CreateStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"TemplateBody":{},"TemplateURL":{},"Parameters":{"shape":"Se"},"DisableRollback":{"type":"boolean"},"RollbackConfiguration":{"shape":"Sn"},"TimeoutInMinutes":{"type":"integer"},"NotificationARNs":{"shape":"St"},"Capabilities":{"shape":"Sj"},"ResourceTypes":{"shape":"Sl"},"RoleARN":{},"OnFailure":{},"StackPolicyBody":{},"StackPolicyURL":{},"Tags":{"shape":"Sv"},"ClientRequestToken":{},"EnableTerminationProtection":{"type":"boolean"}}},"output":{"resultWrapper":"CreateStackResult","type":"structure","members":{"StackId":{}}}},"CreateStackInstances":{"input":{"type":"structure","required":["StackSetName","Accounts","Regions"],"members":{"StackSetName":{},"Accounts":{"shape":"S1g"},"Regions":{"shape":"S1i"},"ParameterOverrides":{"shape":"Se"},"OperationPreferences":{"shape":"S1k"},"OperationId":{"idempotencyToken":true}}},"output":{"resultWrapper":"CreateStackInstancesResult","type":"structure","members":{"OperationId":{}}}},"CreateStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"Description":{},"TemplateBody":{},"TemplateURL":{},"Parameters":{"shape":"Se"},"Capabilities":{"shape":"Sj"},"Tags":{"shape":"Sv"},"AdministrationRoleARN":{},"ExecutionRoleName":{},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"resultWrapper":"CreateStackSetResult","type":"structure","members":{"StackSetId":{}}}},"DeleteChangeSet":{"input":{"type":"structure","required":["ChangeSetName"],"members":{"ChangeSetName":{},"StackName":{}}},"output":{"resultWrapper":"DeleteChangeSetResult","type":"structure","members":{}}},"DeleteStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"RetainResources":{"type":"list","member":{}},"RoleARN":{},"ClientRequestToken":{}}}},"DeleteStackInstances":{"input":{"type":"structure","required":["StackSetName","Accounts","Regions","RetainStacks"],"members":{"StackSetName":{},"Accounts":{"shape":"S1g"},"Regions":{"shape":"S1i"},"OperationPreferences":{"shape":"S1k"},"RetainStacks":{"type":"boolean"},"OperationId":{"idempotencyToken":true}}},"output":{"resultWrapper":"DeleteStackInstancesResult","type":"structure","members":{"OperationId":{}}}},"DeleteStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{}}},"output":{"resultWrapper":"DeleteStackSetResult","type":"structure","members":{}}},"DescribeAccountLimits":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"AccountLimits":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{"type":"integer"}}}},"NextToken":{}}}},"DescribeChangeSet":{"input":{"type":"structure","required":["ChangeSetName"],"members":{"ChangeSetName":{},"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"DescribeChangeSetResult","type":"structure","members":{"ChangeSetName":{},"ChangeSetId":{},"StackId":{},"StackName":{},"Description":{},"Parameters":{"shape":"Se"},"CreationTime":{"type":"timestamp"},"ExecutionStatus":{},"Status":{},"StatusReason":{},"NotificationARNs":{"shape":"St"},"RollbackConfiguration":{"shape":"Sn"},"Capabilities":{"shape":"Sj"},"Tags":{"shape":"Sv"},"Changes":{"type":"list","member":{"type":"structure","members":{"Type":{},"ResourceChange":{"type":"structure","members":{"Action":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Replacement":{},"Scope":{"type":"list","member":{}},"Details":{"type":"list","member":{"type":"structure","members":{"Target":{"type":"structure","members":{"Attribute":{},"Name":{},"RequiresRecreation":{}}},"Evaluation":{},"ChangeSource":{},"CausingEntity":{}}}}}}}}},"NextToken":{}}}},"DescribeStackDriftDetectionStatus":{"input":{"type":"structure","required":["StackDriftDetectionId"],"members":{"StackDriftDetectionId":{}}},"output":{"resultWrapper":"DescribeStackDriftDetectionStatusResult","type":"structure","required":["StackId","StackDriftDetectionId","DetectionStatus","Timestamp"],"members":{"StackId":{},"StackDriftDetectionId":{},"StackDriftStatus":{},"DetectionStatus":{},"DetectionStatusReason":{},"DriftedStackResourceCount":{"type":"integer"},"Timestamp":{"type":"timestamp"}}}},"DescribeStackEvents":{"input":{"type":"structure","members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"DescribeStackEventsResult","type":"structure","members":{"StackEvents":{"type":"list","member":{"type":"structure","required":["StackId","EventId","StackName","Timestamp"],"members":{"StackId":{},"EventId":{},"StackName":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Timestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"ResourceProperties":{},"ClientRequestToken":{}}}},"NextToken":{}}}},"DescribeStackInstance":{"input":{"type":"structure","required":["StackSetName","StackInstanceAccount","StackInstanceRegion"],"members":{"StackSetName":{},"StackInstanceAccount":{},"StackInstanceRegion":{}}},"output":{"resultWrapper":"DescribeStackInstanceResult","type":"structure","members":{"StackInstance":{"type":"structure","members":{"StackSetId":{},"Region":{},"Account":{},"StackId":{},"ParameterOverrides":{"shape":"Se"},"Status":{},"StatusReason":{}}}}}},"DescribeStackResource":{"input":{"type":"structure","required":["StackName","LogicalResourceId"],"members":{"StackName":{},"LogicalResourceId":{}}},"output":{"resultWrapper":"DescribeStackResourceResult","type":"structure","members":{"StackResourceDetail":{"type":"structure","required":["LogicalResourceId","ResourceType","LastUpdatedTimestamp","ResourceStatus"],"members":{"StackName":{},"StackId":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"LastUpdatedTimestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"Description":{},"Metadata":{},"DriftInformation":{"shape":"S3o"}}}}}},"DescribeStackResourceDrifts":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"StackResourceDriftStatusFilters":{"type":"list","member":{}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"DescribeStackResourceDriftsResult","type":"structure","required":["StackResourceDrifts"],"members":{"StackResourceDrifts":{"type":"list","member":{"shape":"S3v"}},"NextToken":{}}}},"DescribeStackResources":{"input":{"type":"structure","members":{"StackName":{},"LogicalResourceId":{},"PhysicalResourceId":{}}},"output":{"resultWrapper":"DescribeStackResourcesResult","type":"structure","members":{"StackResources":{"type":"list","member":{"type":"structure","required":["LogicalResourceId","ResourceType","Timestamp","ResourceStatus"],"members":{"StackName":{},"StackId":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Timestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"Description":{},"DriftInformation":{"shape":"S3o"}}}}}}},"DescribeStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{}}},"output":{"resultWrapper":"DescribeStackSetResult","type":"structure","members":{"StackSet":{"type":"structure","members":{"StackSetName":{},"StackSetId":{},"Description":{},"Status":{},"TemplateBody":{},"Parameters":{"shape":"Se"},"Capabilities":{"shape":"Sj"},"Tags":{"shape":"Sv"},"StackSetARN":{},"AdministrationRoleARN":{},"ExecutionRoleName":{}}}}}},"DescribeStackSetOperation":{"input":{"type":"structure","required":["StackSetName","OperationId"],"members":{"StackSetName":{},"OperationId":{}}},"output":{"resultWrapper":"DescribeStackSetOperationResult","type":"structure","members":{"StackSetOperation":{"type":"structure","members":{"OperationId":{},"StackSetId":{},"Action":{},"Status":{},"OperationPreferences":{"shape":"S1k"},"RetainStacks":{"type":"boolean"},"AdministrationRoleARN":{},"ExecutionRoleName":{},"CreationTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}}}},"DescribeStacks":{"input":{"type":"structure","members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"DescribeStacksResult","type":"structure","members":{"Stacks":{"type":"list","member":{"type":"structure","required":["StackName","CreationTime","StackStatus"],"members":{"StackId":{},"StackName":{},"ChangeSetId":{},"Description":{},"Parameters":{"shape":"Se"},"CreationTime":{"type":"timestamp"},"DeletionTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"RollbackConfiguration":{"shape":"Sn"},"StackStatus":{},"StackStatusReason":{},"DisableRollback":{"type":"boolean"},"NotificationARNs":{"shape":"St"},"TimeoutInMinutes":{"type":"integer"},"Capabilities":{"shape":"Sj"},"Outputs":{"type":"list","member":{"type":"structure","members":{"OutputKey":{},"OutputValue":{},"Description":{},"ExportName":{}}}},"RoleARN":{},"Tags":{"shape":"Sv"},"EnableTerminationProtection":{"type":"boolean"},"ParentId":{},"RootId":{},"DriftInformation":{"type":"structure","required":["StackDriftStatus"],"members":{"StackDriftStatus":{},"LastCheckTimestamp":{"type":"timestamp"}}}}}},"NextToken":{}}}},"DetectStackDrift":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"LogicalResourceIds":{"type":"list","member":{}}}},"output":{"resultWrapper":"DetectStackDriftResult","type":"structure","required":["StackDriftDetectionId"],"members":{"StackDriftDetectionId":{}}}},"DetectStackResourceDrift":{"input":{"type":"structure","required":["StackName","LogicalResourceId"],"members":{"StackName":{},"LogicalResourceId":{}}},"output":{"resultWrapper":"DetectStackResourceDriftResult","type":"structure","required":["StackResourceDrift"],"members":{"StackResourceDrift":{"shape":"S3v"}}}},"EstimateTemplateCost":{"input":{"type":"structure","members":{"TemplateBody":{},"TemplateURL":{},"Parameters":{"shape":"Se"}}},"output":{"resultWrapper":"EstimateTemplateCostResult","type":"structure","members":{"Url":{}}}},"ExecuteChangeSet":{"input":{"type":"structure","required":["ChangeSetName"],"members":{"ChangeSetName":{},"StackName":{},"ClientRequestToken":{}}},"output":{"resultWrapper":"ExecuteChangeSetResult","type":"structure","members":{}}},"GetStackPolicy":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{}}},"output":{"resultWrapper":"GetStackPolicyResult","type":"structure","members":{"StackPolicyBody":{}}}},"GetTemplate":{"input":{"type":"structure","members":{"StackName":{},"ChangeSetName":{},"TemplateStage":{}}},"output":{"resultWrapper":"GetTemplateResult","type":"structure","members":{"TemplateBody":{},"StagesAvailable":{"type":"list","member":{}}}}},"GetTemplateSummary":{"input":{"type":"structure","members":{"TemplateBody":{},"TemplateURL":{},"StackName":{},"StackSetName":{}}},"output":{"resultWrapper":"GetTemplateSummaryResult","type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"DefaultValue":{},"ParameterType":{},"NoEcho":{"type":"boolean"},"Description":{},"ParameterConstraints":{"type":"structure","members":{"AllowedValues":{"type":"list","member":{}}}}}}},"Description":{},"Capabilities":{"shape":"Sj"},"CapabilitiesReason":{},"ResourceTypes":{"shape":"Sl"},"Version":{},"Metadata":{},"DeclaredTransforms":{"shape":"S5r"}}}},"ListChangeSets":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"ListChangeSetsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"StackId":{},"StackName":{},"ChangeSetId":{},"ChangeSetName":{},"ExecutionStatus":{},"Status":{},"StatusReason":{},"CreationTime":{"type":"timestamp"},"Description":{}}}},"NextToken":{}}}},"ListExports":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListExportsResult","type":"structure","members":{"Exports":{"type":"list","member":{"type":"structure","members":{"ExportingStackId":{},"Name":{},"Value":{}}}},"NextToken":{}}}},"ListImports":{"input":{"type":"structure","required":["ExportName"],"members":{"ExportName":{},"NextToken":{}}},"output":{"resultWrapper":"ListImportsResult","type":"structure","members":{"Imports":{"type":"list","member":{}},"NextToken":{}}}},"ListStackInstances":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"NextToken":{},"MaxResults":{"type":"integer"},"StackInstanceAccount":{},"StackInstanceRegion":{}}},"output":{"resultWrapper":"ListStackInstancesResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"StackSetId":{},"Region":{},"Account":{},"StackId":{},"Status":{},"StatusReason":{}}}},"NextToken":{}}}},"ListStackResources":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"ListStackResourcesResult","type":"structure","members":{"StackResourceSummaries":{"type":"list","member":{"type":"structure","required":["LogicalResourceId","ResourceType","LastUpdatedTimestamp","ResourceStatus"],"members":{"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"LastUpdatedTimestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"DriftInformation":{"type":"structure","required":["StackResourceDriftStatus"],"members":{"StackResourceDriftStatus":{},"LastCheckTimestamp":{"type":"timestamp"}}}}}},"NextToken":{}}}},"ListStackSetOperationResults":{"input":{"type":"structure","required":["StackSetName","OperationId"],"members":{"StackSetName":{},"OperationId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListStackSetOperationResultsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"Account":{},"Region":{},"Status":{},"StatusReason":{},"AccountGateResult":{"type":"structure","members":{"Status":{},"StatusReason":{}}}}}},"NextToken":{}}}},"ListStackSetOperations":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListStackSetOperationsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"OperationId":{},"Action":{},"Status":{},"CreationTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListStackSets":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Status":{}}},"output":{"resultWrapper":"ListStackSetsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"StackSetName":{},"StackSetId":{},"Description":{},"Status":{}}}},"NextToken":{}}}},"ListStacks":{"input":{"type":"structure","members":{"NextToken":{},"StackStatusFilter":{"type":"list","member":{}}}},"output":{"resultWrapper":"ListStacksResult","type":"structure","members":{"StackSummaries":{"type":"list","member":{"type":"structure","required":["StackName","CreationTime","StackStatus"],"members":{"StackId":{},"StackName":{},"TemplateDescription":{},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"DeletionTime":{"type":"timestamp"},"StackStatus":{},"StackStatusReason":{},"ParentId":{},"RootId":{},"DriftInformation":{"type":"structure","required":["StackDriftStatus"],"members":{"StackDriftStatus":{},"LastCheckTimestamp":{"type":"timestamp"}}}}}},"NextToken":{}}}},"SetStackPolicy":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"StackPolicyBody":{},"StackPolicyURL":{}}}},"SignalResource":{"input":{"type":"structure","required":["StackName","LogicalResourceId","UniqueId","Status"],"members":{"StackName":{},"LogicalResourceId":{},"UniqueId":{},"Status":{}}}},"StopStackSetOperation":{"input":{"type":"structure","required":["StackSetName","OperationId"],"members":{"StackSetName":{},"OperationId":{}}},"output":{"resultWrapper":"StopStackSetOperationResult","type":"structure","members":{}}},"UpdateStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"TemplateBody":{},"TemplateURL":{},"UsePreviousTemplate":{"type":"boolean"},"StackPolicyDuringUpdateBody":{},"StackPolicyDuringUpdateURL":{},"Parameters":{"shape":"Se"},"Capabilities":{"shape":"Sj"},"ResourceTypes":{"shape":"Sl"},"RoleARN":{},"RollbackConfiguration":{"shape":"Sn"},"StackPolicyBody":{},"StackPolicyURL":{},"NotificationARNs":{"shape":"St"},"Tags":{"shape":"Sv"},"ClientRequestToken":{}}},"output":{"resultWrapper":"UpdateStackResult","type":"structure","members":{"StackId":{}}}},"UpdateStackInstances":{"input":{"type":"structure","required":["StackSetName","Accounts","Regions"],"members":{"StackSetName":{},"Accounts":{"shape":"S1g"},"Regions":{"shape":"S1i"},"ParameterOverrides":{"shape":"Se"},"OperationPreferences":{"shape":"S1k"},"OperationId":{"idempotencyToken":true}}},"output":{"resultWrapper":"UpdateStackInstancesResult","type":"structure","members":{"OperationId":{}}}},"UpdateStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"Description":{},"TemplateBody":{},"TemplateURL":{},"UsePreviousTemplate":{"type":"boolean"},"Parameters":{"shape":"Se"},"Capabilities":{"shape":"Sj"},"Tags":{"shape":"Sv"},"OperationPreferences":{"shape":"S1k"},"AdministrationRoleARN":{},"ExecutionRoleName":{},"OperationId":{"idempotencyToken":true},"Accounts":{"shape":"S1g"},"Regions":{"shape":"S1i"}}},"output":{"resultWrapper":"UpdateStackSetResult","type":"structure","members":{"OperationId":{}}}},"UpdateTerminationProtection":{"input":{"type":"structure","required":["EnableTerminationProtection","StackName"],"members":{"EnableTerminationProtection":{"type":"boolean"},"StackName":{}}},"output":{"resultWrapper":"UpdateTerminationProtectionResult","type":"structure","members":{"StackId":{}}}},"ValidateTemplate":{"input":{"type":"structure","members":{"TemplateBody":{},"TemplateURL":{}}},"output":{"resultWrapper":"ValidateTemplateResult","type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"DefaultValue":{},"NoEcho":{"type":"boolean"},"Description":{}}}},"Description":{},"Capabilities":{"shape":"Sj"},"CapabilitiesReason":{},"DeclaredTransforms":{"shape":"S5r"}}}}},"shapes":{"Se":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"ParameterValue":{},"UsePreviousValue":{"type":"boolean"},"ResolvedValue":{}}}},"Sj":{"type":"list","member":{}},"Sl":{"type":"list","member":{}},"Sn":{"type":"structure","members":{"RollbackTriggers":{"type":"list","member":{"type":"structure","required":["Arn","Type"],"members":{"Arn":{},"Type":{}}}},"MonitoringTimeInMinutes":{"type":"integer"}}},"St":{"type":"list","member":{}},"Sv":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S1g":{"type":"list","member":{}},"S1i":{"type":"list","member":{}},"S1k":{"type":"structure","members":{"RegionOrder":{"shape":"S1i"},"FailureToleranceCount":{"type":"integer"},"FailureTolerancePercentage":{"type":"integer"},"MaxConcurrentCount":{"type":"integer"},"MaxConcurrentPercentage":{"type":"integer"}}},"S3o":{"type":"structure","required":["StackResourceDriftStatus"],"members":{"StackResourceDriftStatus":{},"LastCheckTimestamp":{"type":"timestamp"}}},"S3v":{"type":"structure","required":["StackId","LogicalResourceId","ResourceType","StackResourceDriftStatus","Timestamp"],"members":{"StackId":{},"LogicalResourceId":{},"PhysicalResourceId":{},"PhysicalResourceIdContext":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"ResourceType":{},"ExpectedProperties":{},"ActualProperties":{},"PropertyDifferences":{"type":"list","member":{"type":"structure","required":["PropertyPath","ExpectedValue","ActualValue","DifferenceType"],"members":{"PropertyPath":{},"ExpectedValue":{},"ActualValue":{},"DifferenceType":{}}}},"StackResourceDriftStatus":{},"Timestamp":{"type":"timestamp"}}},"S5r":{"type":"list","member":{}}}}');

});

parcelRequire.register("h5zCp", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeStackEvents":{"input_token":"NextToken","output_token":"NextToken","result_key":"StackEvents"},"DescribeStackResourceDrifts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"DescribeStackResources":{"result_key":"StackResources"},"DescribeStacks":{"input_token":"NextToken","output_token":"NextToken","result_key":"Stacks"},"ListExports":{"input_token":"NextToken","output_token":"NextToken","result_key":"Exports"},"ListImports":{"input_token":"NextToken","output_token":"NextToken","result_key":"Imports"},"ListStackResources":{"input_token":"NextToken","output_token":"NextToken","result_key":"StackResourceSummaries"},"ListStacks":{"input_token":"NextToken","output_token":"NextToken","result_key":"StackSummaries"}}}');

});

parcelRequire.register("7nG3T", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"StackExists":{"delay":5,"operation":"DescribeStacks","maxAttempts":20,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"ValidationError","state":"retry"}]},"StackCreateComplete":{"delay":30,"operation":"DescribeStacks","maxAttempts":120,"description":"Wait until stack status is CREATE_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"CREATE_COMPLETE","matcher":"pathAll","state":"success"},{"argument":"Stacks[].StackStatus","expected":"CREATE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"DELETE_COMPLETE","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"DELETE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"ROLLBACK_COMPLETE","matcher":"pathAny","state":"failure"},{"expected":"ValidationError","matcher":"error","state":"failure"}]},"StackDeleteComplete":{"delay":30,"operation":"DescribeStacks","maxAttempts":120,"description":"Wait until stack status is DELETE_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"DELETE_COMPLETE","matcher":"pathAll","state":"success"},{"expected":"ValidationError","matcher":"error","state":"success"},{"argument":"Stacks[].StackStatus","expected":"DELETE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"CREATE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_IN_PROGRESS","matcher":"pathAny","state":"failure"}]},"StackUpdateComplete":{"delay":30,"maxAttempts":120,"operation":"DescribeStacks","description":"Wait until stack status is UPDATE_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"UPDATE_COMPLETE","matcher":"pathAll","state":"success"},{"expected":"UPDATE_FAILED","matcher":"pathAny","state":"failure","argument":"Stacks[].StackStatus"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"expected":"UPDATE_ROLLBACK_COMPLETE","matcher":"pathAny","state":"failure","argument":"Stacks[].StackStatus"},{"expected":"ValidationError","matcher":"error","state":"failure"}]},"ChangeSetCreateComplete":{"delay":30,"operation":"DescribeChangeSet","maxAttempts":120,"description":"Wait until change set status is CREATE_COMPLETE.","acceptors":[{"argument":"Status","expected":"CREATE_COMPLETE","matcher":"path","state":"success"},{"argument":"Status","expected":"FAILED","matcher":"path","state":"failure"},{"expected":"ValidationError","matcher":"error","state":"failure"}]}}}');

});


parcelRequire.register("32Tpm", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $237c89e27069055e$var$Service = $dbC7k.Service;
var $237c89e27069055e$var$apiLoader = $dbC7k.apiLoader;
$237c89e27069055e$var$apiLoader.services["cloudfront"] = {};
$dbC7k.CloudFront = $237c89e27069055e$var$Service.defineService("cloudfront", [
    "2013-05-12*",
    "2013-11-11*",
    "2014-05-31*",
    "2014-10-21*",
    "2014-11-06*",
    "2015-04-17*",
    "2015-07-27*",
    "2015-09-17*",
    "2016-01-13*",
    "2016-01-28*",
    "2016-08-01*",
    "2016-08-20*",
    "2016-09-07*",
    "2016-09-29*",
    "2016-11-25",
    "2016-11-25*",
    "2017-03-25",
    "2017-03-25*",
    "2017-10-30",
    "2017-10-30*",
    "2018-06-18",
    "2018-06-18*",
    "2018-11-05",
    "2018-11-05*",
    "2019-03-26"
]);
parcelRequire("ehSSA");



Object.defineProperty($237c89e27069055e$var$apiLoader.services["cloudfront"], "2016-11-25", {
    get: function get() {
        var model = (parcelRequire("6MpYZ"));
        model.paginators = (parcelRequire("67X5Y")).pagination;
        model.waiters = (parcelRequire("4wf6x")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});



Object.defineProperty($237c89e27069055e$var$apiLoader.services["cloudfront"], "2017-03-25", {
    get: function get() {
        var model = (parcelRequire("6hxPK"));
        model.paginators = (parcelRequire("h9euz")).pagination;
        model.waiters = (parcelRequire("nkx9Q")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});



Object.defineProperty($237c89e27069055e$var$apiLoader.services["cloudfront"], "2017-10-30", {
    get: function get() {
        var model = (parcelRequire("e7WoQ"));
        model.paginators = (parcelRequire("fFlB7")).pagination;
        model.waiters = (parcelRequire("29ntq")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});



Object.defineProperty($237c89e27069055e$var$apiLoader.services["cloudfront"], "2018-06-18", {
    get: function get() {
        var model = (parcelRequire("aPlhg"));
        model.paginators = (parcelRequire("c8EKW")).pagination;
        model.waiters = (parcelRequire("Gnq1p")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});



Object.defineProperty($237c89e27069055e$var$apiLoader.services["cloudfront"], "2018-11-05", {
    get: function get() {
        var model = (parcelRequire("isduD"));
        model.paginators = (parcelRequire("6LLDI")).pagination;
        model.waiters = (parcelRequire("fuhKk")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});



Object.defineProperty($237c89e27069055e$var$apiLoader.services["cloudfront"], "2019-03-26", {
    get: function get() {
        var model = (parcelRequire("3DMfx"));
        model.paginators = (parcelRequire("Lnsf9")).pagination;
        model.waiters = (parcelRequire("fDqym")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.CloudFront;

});
parcelRequire.register("ehSSA", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
parcelRequire("5lM2y");
$dbC7k.util.update($dbC7k.CloudFront.prototype, {
    setupRequestListeners: function setupRequestListeners(request) {
        request.addListener("extractData", $dbC7k.util.hoistPayloadMember);
    }
});

});
parcelRequire.register("5lM2y", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
var $3e542dafe043ab2e$var$url = $dbC7k.util.url, $3e542dafe043ab2e$var$crypto = $dbC7k.util.crypto.lib, $3e542dafe043ab2e$var$base64Encode = $dbC7k.util.base64.encode, $3e542dafe043ab2e$var$inherit = $dbC7k.util.inherit;
var $3e542dafe043ab2e$var$queryEncode = function(string) {
    var replacements = {
        "+": "-",
        "=": "_",
        "/": "~"
    };
    return string.replace(/[\+=\/]/g, function(match) {
        return replacements[match];
    });
};
var $3e542dafe043ab2e$var$signPolicy = function(policy, privateKey) {
    var sign = $3e542dafe043ab2e$var$crypto.createSign("RSA-SHA1");
    sign.write(policy);
    return $3e542dafe043ab2e$var$queryEncode(sign.sign(privateKey, "base64"));
};
var $3e542dafe043ab2e$var$signWithCannedPolicy = function(url, expires, keyPairId, privateKey) {
    var policy = JSON.stringify({
        Statement: [
            {
                Resource: url,
                Condition: {
                    DateLessThan: {
                        "AWS:EpochTime": expires
                    }
                }
            }
        ]
    });
    return {
        Expires: expires,
        "Key-Pair-Id": keyPairId,
        Signature: $3e542dafe043ab2e$var$signPolicy(policy.toString(), privateKey)
    };
};
var $3e542dafe043ab2e$var$signWithCustomPolicy = function(policy, keyPairId, privateKey) {
    policy = policy.replace(/\s/mg, "");
    return {
        Policy: $3e542dafe043ab2e$var$queryEncode($3e542dafe043ab2e$var$base64Encode(policy)),
        "Key-Pair-Id": keyPairId,
        Signature: $3e542dafe043ab2e$var$signPolicy(policy, privateKey)
    };
};
var $3e542dafe043ab2e$var$determineScheme = function(url) {
    var parts = url.split("://");
    if (parts.length < 2) throw new Error("Invalid URL.");
    return parts[0].replace("*", "");
};
var $3e542dafe043ab2e$var$getRtmpUrl = function(rtmpUrl) {
    var parsed = $3e542dafe043ab2e$var$url.parse(rtmpUrl);
    return parsed.path.replace(/^\//, "") + (parsed.hash || "");
};
var $3e542dafe043ab2e$var$getResource = function(url) {
    switch($3e542dafe043ab2e$var$determineScheme(url)){
        case "http":
        case "https":
            return url;
        case "rtmp":
            return $3e542dafe043ab2e$var$getRtmpUrl(url);
        default:
            throw new Error("Invalid URI scheme. Scheme must be one of http, https, or rtmp");
    }
};
var $3e542dafe043ab2e$var$handleError = function(err, callback) {
    if (!callback || typeof callback !== "function") throw err;
    callback(err);
};
var $3e542dafe043ab2e$var$handleSuccess = function(result, callback) {
    if (!callback || typeof callback !== "function") return result;
    callback(null, result);
};
$dbC7k.CloudFront.Signer = $3e542dafe043ab2e$var$inherit({
    /**
     * A signer object can be used to generate signed URLs and cookies for granting
     * access to content on restricted CloudFront distributions.
     *
     * @see http://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/PrivateContent.html
     *
     * @param keyPairId [String]    (Required) The ID of the CloudFront key pair
     *                              being used.
     * @param privateKey [String]   (Required) A private key in RSA format.
     */ constructor: function Signer(keyPairId, privateKey) {
        if (keyPairId === void 0 || privateKey === void 0) throw new Error("A key pair ID and private key are required");
        this.keyPairId = keyPairId;
        this.privateKey = privateKey;
    },
    /**
     * Create a signed Amazon CloudFront Cookie.
     *
     * @param options [Object]            The options to create a signed cookie.
     * @option options url [String]     The URL to which the signature will grant
     *                                  access. Required unless you pass in a full
     *                                  policy.
     * @option options expires [Number] A Unix UTC timestamp indicating when the
     *                                  signature should expire. Required unless you
     *                                  pass in a full policy.
     * @option options policy [String]  A CloudFront JSON policy. Required unless
     *                                  you pass in a url and an expiry time.
     *
     * @param cb [Function] if a callback is provided, this function will
     *   pass the hash as the second parameter (after the error parameter) to
     *   the callback function.
     *
     * @return [Object] if called synchronously (with no callback), returns the
     *   signed cookie parameters.
     * @return [null] nothing is returned if a callback is provided.
     */ getSignedCookie: function(options, cb) {
        var signatureHash = "policy" in options ? $3e542dafe043ab2e$var$signWithCustomPolicy(options.policy, this.keyPairId, this.privateKey) : $3e542dafe043ab2e$var$signWithCannedPolicy(options.url, options.expires, this.keyPairId, this.privateKey);
        var cookieHash = {};
        for(var key in signatureHash)if (Object.prototype.hasOwnProperty.call(signatureHash, key)) cookieHash["CloudFront-" + key] = signatureHash[key];
        return $3e542dafe043ab2e$var$handleSuccess(cookieHash, cb);
    },
    /**
     * Create a signed Amazon CloudFront URL.
     *
     * Keep in mind that URLs meant for use in media/flash players may have
     * different requirements for URL formats (e.g. some require that the
     * extension be removed, some require the file name to be prefixed
     * - mp4:<path>, some require you to add "/cfx/st" into your URL).
     *
     * @param options [Object]          The options to create a signed URL.
     * @option options url [String]     The URL to which the signature will grant
     *                                  access. Any query params included with
     *                                  the URL should be encoded. Required.
     * @option options expires [Number] A Unix UTC timestamp indicating when the
     *                                  signature should expire. Required unless you
     *                                  pass in a full policy.
     * @option options policy [String]  A CloudFront JSON policy. Required unless
     *                                  you pass in a url and an expiry time.
     *
     * @param cb [Function] if a callback is provided, this function will
     *   pass the URL as the second parameter (after the error parameter) to
     *   the callback function.
     *
     * @return [String] if called synchronously (with no callback), returns the
     *   signed URL.
     * @return [null] nothing is returned if a callback is provided.
     */ getSignedUrl: function(options, cb) {
        try {
            var resource = $3e542dafe043ab2e$var$getResource(options.url);
        } catch (err) {
            return $3e542dafe043ab2e$var$handleError(err, cb);
        }
        var parsedUrl = $3e542dafe043ab2e$var$url.parse(options.url, true), signatureHash = Object.prototype.hasOwnProperty.call(options, "policy") ? $3e542dafe043ab2e$var$signWithCustomPolicy(options.policy, this.keyPairId, this.privateKey) : $3e542dafe043ab2e$var$signWithCannedPolicy(resource, options.expires, this.keyPairId, this.privateKey);
        parsedUrl.search = null;
        for(var key in signatureHash)if (Object.prototype.hasOwnProperty.call(signatureHash, key)) parsedUrl.query[key] = signatureHash[key];
        try {
            var signedUrl = $3e542dafe043ab2e$var$determineScheme(options.url) === "rtmp" ? $3e542dafe043ab2e$var$getRtmpUrl($3e542dafe043ab2e$var$url.format(parsedUrl)) : $3e542dafe043ab2e$var$url.format(parsedUrl);
        } catch (err) {
            return $3e542dafe043ab2e$var$handleError(err, cb);
        }
        return $3e542dafe043ab2e$var$handleSuccess(signedUrl, cb);
    }
});
/**
 * @api private
 */ module.exports = $dbC7k.CloudFront.Signer;

});


parcelRequire.register("6MpYZ", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-11-25","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2016-11-25"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2016-11-25/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2016-11-25/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2016-11-25/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S21"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateInvalidation":{"http":{"requestUri":"/2016-11-25/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S28","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2016-11-25/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2016-11-25/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S2e"},"Tags":{"shape":"S21"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2016-11-25/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2016-11-25/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2016-11-25/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2016-11-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S2e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2016-11-25/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3a"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2016-11-25/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3a"}},"payload":"DistributionList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2016-11-25/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"Sy"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2016-11-25/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S21"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2016-11-25/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S21","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2016-11-25/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2016-11-25/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2016-11-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}}}}}}}}},"Sn":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}},"So":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Sy":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S12":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"}}}}},"S13":{"type":"list","member":{"locationName":"Method"}},"S16":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","members":{"LambdaFunctionARN":{},"EventType":{}}}}}},"S1a":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}}}}},"S1d":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1i":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1m":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S1s":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"DistributionConfig":{"shape":"S7"}}},"S1u":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S21":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S28":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S2c":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S28"}}},"S2e":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"Sy"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S2f":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S2i":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"StreamingDistributionConfig":{"shape":"S2e"}}},"S3a":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}');

});

parcelRequire.register("67X5Y", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","output_token":"DistributionList.NextMarker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","output_token":"InvalidationList.NextMarker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","output_token":"StreamingDistributionList.NextMarker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","result_key":"StreamingDistributionList.Items"}}}');

});

parcelRequire.register("4wf6x", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}');

});

parcelRequire.register("6hxPK", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-03-25","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2017-03-25"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2017-03-25/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2017-03-25/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2017-03-25/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S21"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateInvalidation":{"http":{"requestUri":"/2017-03-25/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S28","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2017-03-25/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2017-03-25/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S2e"},"Tags":{"shape":"S21"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2017-03-25/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteServiceLinkedRole":{"http":{"method":"DELETE","requestUri":"/2017-03-25/service-linked-role/{RoleName}","responseCode":204},"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{"location":"uri","locationName":"RoleName"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2017-03-25/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2017-03-25/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2017-03-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S2e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2017-03-25/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3b"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2017-03-25/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3b"}},"payload":"DistributionList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2017-03-25/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"Sy"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2017-03-25/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S21"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2017-03-25/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S21","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2017-03-25/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2017-03-25/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2017-03-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}}}}}}},"Sn":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}},"So":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Sy":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S12":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"}}}}},"S13":{"type":"list","member":{"locationName":"Method"}},"S16":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","members":{"LambdaFunctionARN":{},"EventType":{}}}}}},"S1a":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}}}}},"S1d":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1i":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1m":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S1s":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"DistributionConfig":{"shape":"S7"}}},"S1u":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S21":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S28":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S2c":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S28"}}},"S2e":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"Sy"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S2f":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S2i":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"StreamingDistributionConfig":{"shape":"S2e"}}},"S3b":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}');

});

parcelRequire.register("h9euz", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}');

});

parcelRequire.register("nkx9Q", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}');

});

parcelRequire.register("e7WoQ", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-10-30","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2017-10-30"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2017-10-30/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2017-10-30/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2017-10-30/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S22"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateFieldLevelEncryptionConfig":{"http":{"requestUri":"/2017-10-30/field-level-encryption","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionConfig"],"members":{"FieldLevelEncryptionConfig":{"shape":"S29","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"CreateFieldLevelEncryptionProfile":{"http":{"requestUri":"/2017-10-30/field-level-encryption-profile","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"CreateInvalidation":{"http":{"requestUri":"/2017-10-30/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S2v","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S2z"}},"payload":"Invalidation"}},"CreatePublicKey":{"http":{"requestUri":"/2017-10-30/public-key","responseCode":201},"input":{"type":"structure","required":["PublicKeyConfig"],"members":{"PublicKeyConfig":{"shape":"S31","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2017-10-30/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S35","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2017-10-30/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S35"},"Tags":{"shape":"S22"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2017-10-30/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2017-10-30/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionConfig":{"http":{"method":"DELETE","requestUri":"/2017-10-30/field-level-encryption/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionProfile":{"http":{"method":"DELETE","requestUri":"/2017-10-30/field-level-encryption-profile/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeletePublicKey":{"http":{"method":"DELETE","requestUri":"/2017-10-30/public-key/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2017-10-30/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2017-10-30/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2017-10-30/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetFieldLevelEncryption":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"GetFieldLevelEncryptionConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionConfig":{"shape":"S29"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionConfig"}},"GetFieldLevelEncryptionProfile":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption-profile/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"GetFieldLevelEncryptionProfileConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfileConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2017-10-30/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S2z"}},"payload":"Invalidation"}},"GetPublicKey":{"http":{"method":"GET","requestUri":"/2017-10-30/public-key/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"GetPublicKeyConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/public-key/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKeyConfig":{"shape":"S31"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKeyConfig"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2017-10-30/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S35"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2017-10-30/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2017-10-30/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4g"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2017-10-30/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4g"}},"payload":"DistributionList"}},"ListFieldLevelEncryptionConfigs":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionSummary","type":"structure","required":["Id","LastModifiedTime"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Comment":{},"QueryArgProfileConfig":{"shape":"S2a"},"ContentTypeProfileConfig":{"shape":"S2e"}}}}}}},"payload":"FieldLevelEncryptionList"}},"ListFieldLevelEncryptionProfiles":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption-profile"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionProfileSummary","type":"structure","required":["Id","LastModifiedTime","Name","EncryptionEntities"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Name":{},"EncryptionEntities":{"shape":"S2n"},"Comment":{}}}}}}},"payload":"FieldLevelEncryptionProfileList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2017-10-30/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListPublicKeys":{"http":{"method":"GET","requestUri":"/2017-10-30/public-key"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"PublicKeySummary","type":"structure","required":["Id","Name","CreatedTime","EncodedKey"],"members":{"Id":{},"Name":{},"CreatedTime":{"type":"timestamp"},"EncodedKey":{},"Comment":{}}}}}}},"payload":"PublicKeyList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2017-10-30/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S36"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"Sy"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2017-10-30/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S22"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2017-10-30/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S22","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2017-10-30/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2017-10-30/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2017-10-30/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateFieldLevelEncryptionConfig":{"http":{"method":"PUT","requestUri":"/2017-10-30/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionConfig","Id"],"members":{"FieldLevelEncryptionConfig":{"shape":"S29","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"UpdateFieldLevelEncryptionProfile":{"http":{"method":"PUT","requestUri":"/2017-10-30/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig","Id"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"UpdatePublicKey":{"http":{"method":"PUT","requestUri":"/2017-10-30/public-key/{Id}/config"},"input":{"type":"structure","required":["PublicKeyConfig","Id"],"members":{"PublicKeyConfig":{"shape":"S31","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2017-10-30/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S35","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1b"},"CustomErrorResponses":{"shape":"S1e"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1j"},"Restrictions":{"shape":"S1n"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}}}}}}},"Sn":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"},"FieldLevelEncryptionId":{}}},"So":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Sy":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S12":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"}}}}},"S13":{"type":"list","member":{"locationName":"Method"}},"S16":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","required":["LambdaFunctionARN","EventType"],"members":{"LambdaFunctionARN":{},"EventType":{}}}}}},"S1b":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"},"FieldLevelEncryptionId":{}}}}}},"S1e":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1j":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1n":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S1t":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1v"},"DistributionConfig":{"shape":"S7"}}},"S1v":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S22":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S29":{"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"Comment":{},"QueryArgProfileConfig":{"shape":"S2a"},"ContentTypeProfileConfig":{"shape":"S2e"}}},"S2a":{"type":"structure","required":["ForwardWhenQueryArgProfileIsUnknown"],"members":{"ForwardWhenQueryArgProfileIsUnknown":{"type":"boolean"},"QueryArgProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"QueryArgProfile","type":"structure","required":["QueryArg","ProfileId"],"members":{"QueryArg":{},"ProfileId":{}}}}}}}},"S2e":{"type":"structure","required":["ForwardWhenContentTypeIsUnknown"],"members":{"ForwardWhenContentTypeIsUnknown":{"type":"boolean"},"ContentTypeProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ContentTypeProfile","type":"structure","required":["Format","ContentType"],"members":{"Format":{},"ProfileId":{},"ContentType":{}}}}}}}},"S2k":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionConfig":{"shape":"S29"}}},"S2m":{"type":"structure","required":["Name","CallerReference","EncryptionEntities"],"members":{"Name":{},"CallerReference":{},"Comment":{},"EncryptionEntities":{"shape":"S2n"}}},"S2n":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"EncryptionEntity","type":"structure","required":["PublicKeyId","ProviderId","FieldPatterns"],"members":{"PublicKeyId":{},"ProviderId":{},"FieldPatterns":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldPattern"}}}}}}}}},"S2t":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionProfileConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionProfileConfig":{"shape":"S2m"}}},"S2v":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S2z":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S2v"}}},"S31":{"type":"structure","required":["CallerReference","Name","EncodedKey"],"members":{"CallerReference":{},"Name":{},"EncodedKey":{},"Comment":{}}},"S33":{"type":"structure","required":["Id","CreatedTime","PublicKeyConfig"],"members":{"Id":{},"CreatedTime":{"type":"timestamp"},"PublicKeyConfig":{"shape":"S31"}}},"S35":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S36"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"Sy"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S36":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S39":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1v"},"StreamingDistributionConfig":{"shape":"S35"}}},"S4g":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1b"},"CustomErrorResponses":{"shape":"S1e"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1j"},"Restrictions":{"shape":"S1n"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}');

});

parcelRequire.register("fFlB7", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}');

});

parcelRequire.register("29ntq", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}');

});

parcelRequire.register("aPlhg", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-06-18","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2018-06-18"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2018-06-18/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2018-06-18/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2018-06-18/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S22"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateFieldLevelEncryptionConfig":{"http":{"requestUri":"/2018-06-18/field-level-encryption","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionConfig"],"members":{"FieldLevelEncryptionConfig":{"shape":"S29","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"CreateFieldLevelEncryptionProfile":{"http":{"requestUri":"/2018-06-18/field-level-encryption-profile","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"CreateInvalidation":{"http":{"requestUri":"/2018-06-18/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S2v","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S2z"}},"payload":"Invalidation"}},"CreatePublicKey":{"http":{"requestUri":"/2018-06-18/public-key","responseCode":201},"input":{"type":"structure","required":["PublicKeyConfig"],"members":{"PublicKeyConfig":{"shape":"S31","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2018-06-18/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S35","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2018-06-18/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S35"},"Tags":{"shape":"S22"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2018-06-18/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2018-06-18/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionConfig":{"http":{"method":"DELETE","requestUri":"/2018-06-18/field-level-encryption/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionProfile":{"http":{"method":"DELETE","requestUri":"/2018-06-18/field-level-encryption-profile/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeletePublicKey":{"http":{"method":"DELETE","requestUri":"/2018-06-18/public-key/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2018-06-18/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2018-06-18/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2018-06-18/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetFieldLevelEncryption":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"GetFieldLevelEncryptionConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionConfig":{"shape":"S29"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionConfig"}},"GetFieldLevelEncryptionProfile":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption-profile/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"GetFieldLevelEncryptionProfileConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfileConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2018-06-18/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S2z"}},"payload":"Invalidation"}},"GetPublicKey":{"http":{"method":"GET","requestUri":"/2018-06-18/public-key/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"GetPublicKeyConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/public-key/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKeyConfig":{"shape":"S31"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKeyConfig"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2018-06-18/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S35"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2018-06-18/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2018-06-18/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4g"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2018-06-18/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4g"}},"payload":"DistributionList"}},"ListFieldLevelEncryptionConfigs":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionSummary","type":"structure","required":["Id","LastModifiedTime"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Comment":{},"QueryArgProfileConfig":{"shape":"S2a"},"ContentTypeProfileConfig":{"shape":"S2e"}}}}}}},"payload":"FieldLevelEncryptionList"}},"ListFieldLevelEncryptionProfiles":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption-profile"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionProfileSummary","type":"structure","required":["Id","LastModifiedTime","Name","EncryptionEntities"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Name":{},"EncryptionEntities":{"shape":"S2n"},"Comment":{}}}}}}},"payload":"FieldLevelEncryptionProfileList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2018-06-18/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListPublicKeys":{"http":{"method":"GET","requestUri":"/2018-06-18/public-key"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"PublicKeySummary","type":"structure","required":["Id","Name","CreatedTime","EncodedKey"],"members":{"Id":{},"Name":{},"CreatedTime":{"type":"timestamp"},"EncodedKey":{},"Comment":{}}}}}}},"payload":"PublicKeyList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2018-06-18/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S36"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"Sy"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2018-06-18/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S22"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2018-06-18/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S22","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2018-06-18/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2018-06-18/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2018-06-18/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateFieldLevelEncryptionConfig":{"http":{"method":"PUT","requestUri":"/2018-06-18/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionConfig","Id"],"members":{"FieldLevelEncryptionConfig":{"shape":"S29","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"UpdateFieldLevelEncryptionProfile":{"http":{"method":"PUT","requestUri":"/2018-06-18/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig","Id"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"UpdatePublicKey":{"http":{"method":"PUT","requestUri":"/2018-06-18/public-key/{Id}/config"},"input":{"type":"structure","required":["PublicKeyConfig","Id"],"members":{"PublicKeyConfig":{"shape":"S31","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2018-06-18/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S35","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1b"},"CustomErrorResponses":{"shape":"S1e"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1j"},"Restrictions":{"shape":"S1n"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}}}}}}},"Sn":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"},"FieldLevelEncryptionId":{}}},"So":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Sy":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S12":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"}}}}},"S13":{"type":"list","member":{"locationName":"Method"}},"S16":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","required":["LambdaFunctionARN","EventType"],"members":{"LambdaFunctionARN":{},"EventType":{},"IncludeBody":{"type":"boolean"}}}}}},"S1b":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"},"FieldLevelEncryptionId":{}}}}}},"S1e":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1j":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1n":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S1t":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1v"},"DistributionConfig":{"shape":"S7"}}},"S1v":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S22":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S29":{"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"Comment":{},"QueryArgProfileConfig":{"shape":"S2a"},"ContentTypeProfileConfig":{"shape":"S2e"}}},"S2a":{"type":"structure","required":["ForwardWhenQueryArgProfileIsUnknown"],"members":{"ForwardWhenQueryArgProfileIsUnknown":{"type":"boolean"},"QueryArgProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"QueryArgProfile","type":"structure","required":["QueryArg","ProfileId"],"members":{"QueryArg":{},"ProfileId":{}}}}}}}},"S2e":{"type":"structure","required":["ForwardWhenContentTypeIsUnknown"],"members":{"ForwardWhenContentTypeIsUnknown":{"type":"boolean"},"ContentTypeProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ContentTypeProfile","type":"structure","required":["Format","ContentType"],"members":{"Format":{},"ProfileId":{},"ContentType":{}}}}}}}},"S2k":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionConfig":{"shape":"S29"}}},"S2m":{"type":"structure","required":["Name","CallerReference","EncryptionEntities"],"members":{"Name":{},"CallerReference":{},"Comment":{},"EncryptionEntities":{"shape":"S2n"}}},"S2n":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"EncryptionEntity","type":"structure","required":["PublicKeyId","ProviderId","FieldPatterns"],"members":{"PublicKeyId":{},"ProviderId":{},"FieldPatterns":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldPattern"}}}}}}}}},"S2t":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionProfileConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionProfileConfig":{"shape":"S2m"}}},"S2v":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S2z":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S2v"}}},"S31":{"type":"structure","required":["CallerReference","Name","EncodedKey"],"members":{"CallerReference":{},"Name":{},"EncodedKey":{},"Comment":{}}},"S33":{"type":"structure","required":["Id","CreatedTime","PublicKeyConfig"],"members":{"Id":{},"CreatedTime":{"type":"timestamp"},"PublicKeyConfig":{"shape":"S31"}}},"S35":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S36"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"Sy"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S36":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S39":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1v"},"StreamingDistributionConfig":{"shape":"S35"}}},"S4g":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1b"},"CustomErrorResponses":{"shape":"S1e"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1j"},"Restrictions":{"shape":"S1n"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}');

});

parcelRequire.register("c8EKW", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}');

});

parcelRequire.register("Gnq1p", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}');

});

parcelRequire.register("isduD", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-11-05","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2018-11-05"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2018-11-05/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2018-11-05/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S22"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2018-11-05/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S2b"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S22"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateFieldLevelEncryptionConfig":{"http":{"requestUri":"/2018-11-05/field-level-encryption","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionConfig"],"members":{"FieldLevelEncryptionConfig":{"shape":"S2i","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"CreateFieldLevelEncryptionProfile":{"http":{"requestUri":"/2018-11-05/field-level-encryption-profile","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2v","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S32"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"CreateInvalidation":{"http":{"requestUri":"/2018-11-05/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S34","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S38"}},"payload":"Invalidation"}},"CreatePublicKey":{"http":{"requestUri":"/2018-11-05/public-key","responseCode":201},"input":{"type":"structure","required":["PublicKeyConfig"],"members":{"PublicKeyConfig":{"shape":"S3a","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3c"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2018-11-05/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S3e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2018-11-05/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S3e"},"Tags":{"shape":"S2b"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2018-11-05/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2018-11-05/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionConfig":{"http":{"method":"DELETE","requestUri":"/2018-11-05/field-level-encryption/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionProfile":{"http":{"method":"DELETE","requestUri":"/2018-11-05/field-level-encryption-profile/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeletePublicKey":{"http":{"method":"DELETE","requestUri":"/2018-11-05/public-key/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2018-11-05/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2018-11-05/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2018-11-05/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S22"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetFieldLevelEncryption":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"GetFieldLevelEncryptionConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionConfig":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionConfig"}},"GetFieldLevelEncryptionProfile":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption-profile/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S32"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"GetFieldLevelEncryptionProfileConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2v"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfileConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2018-11-05/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S38"}},"payload":"Invalidation"}},"GetPublicKey":{"http":{"method":"GET","requestUri":"/2018-11-05/public-key/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3c"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"GetPublicKeyConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/public-key/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKeyConfig":{"shape":"S3a"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKeyConfig"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2018-11-05/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S3e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2018-11-05/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2018-11-05/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4p"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2018-11-05/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4p"}},"payload":"DistributionList"}},"ListFieldLevelEncryptionConfigs":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionSummary","type":"structure","required":["Id","LastModifiedTime"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Comment":{},"QueryArgProfileConfig":{"shape":"S2j"},"ContentTypeProfileConfig":{"shape":"S2n"}}}}}}},"payload":"FieldLevelEncryptionList"}},"ListFieldLevelEncryptionProfiles":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption-profile"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionProfileSummary","type":"structure","required":["Id","LastModifiedTime","Name","EncryptionEntities"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Name":{},"EncryptionEntities":{"shape":"S2w"},"Comment":{}}}}}}},"payload":"FieldLevelEncryptionProfileList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2018-11-05/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListPublicKeys":{"http":{"method":"GET","requestUri":"/2018-11-05/public-key"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"PublicKeySummary","type":"structure","required":["Id","Name","CreatedTime","EncodedKey"],"members":{"Id":{},"Name":{},"CreatedTime":{"type":"timestamp"},"EncodedKey":{},"Comment":{}}}}}}},"payload":"PublicKeyList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2018-11-05/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S3f"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"S17"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2018-11-05/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S2b"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2018-11-05/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S2b","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2018-11-05/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2018-11-05/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2018-11-05/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S22"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateFieldLevelEncryptionConfig":{"http":{"method":"PUT","requestUri":"/2018-11-05/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionConfig","Id"],"members":{"FieldLevelEncryptionConfig":{"shape":"S2i","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"UpdateFieldLevelEncryptionProfile":{"http":{"method":"PUT","requestUri":"/2018-11-05/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig","Id"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2v","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S32"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"UpdatePublicKey":{"http":{"method":"PUT","requestUri":"/2018-11-05/public-key/{Id}/config"},"input":{"type":"structure","required":["PublicKeyConfig","Id"],"members":{"PublicKeyConfig":{"shape":"S3a","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3c"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2018-11-05/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S3e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"OriginGroups":{"shape":"Sn"},"DefaultCacheBehavior":{"shape":"Sw"},"CacheBehaviors":{"shape":"S1k"},"CustomErrorResponses":{"shape":"S1n"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1s"},"Restrictions":{"shape":"S1w"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}}}}}}},"Sn":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginGroup","type":"structure","required":["Id","FailoverCriteria","Members"],"members":{"Id":{},"FailoverCriteria":{"type":"structure","required":["StatusCodes"],"members":{"StatusCodes":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StatusCode","type":"integer"}}}}}},"Members":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginGroupMember","type":"structure","required":["OriginId"],"members":{"OriginId":{}}}}}}}}}}},"Sw":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"Sx"},"TrustedSigners":{"shape":"S17"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S1b"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S1f"},"FieldLevelEncryptionId":{}}},"Sx":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"S17":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S1b":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S1c"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S1c"}}}}},"S1c":{"type":"list","member":{"locationName":"Method"}},"S1f":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","required":["LambdaFunctionARN","EventType"],"members":{"LambdaFunctionARN":{},"EventType":{},"IncludeBody":{"type":"boolean"}}}}}},"S1k":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"Sx"},"TrustedSigners":{"shape":"S17"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S1b"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S1f"},"FieldLevelEncryptionId":{}}}}}},"S1n":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1s":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1w":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S22":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S24"},"DistributionConfig":{"shape":"S7"}}},"S24":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S2b":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S2i":{"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"Comment":{},"QueryArgProfileConfig":{"shape":"S2j"},"ContentTypeProfileConfig":{"shape":"S2n"}}},"S2j":{"type":"structure","required":["ForwardWhenQueryArgProfileIsUnknown"],"members":{"ForwardWhenQueryArgProfileIsUnknown":{"type":"boolean"},"QueryArgProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"QueryArgProfile","type":"structure","required":["QueryArg","ProfileId"],"members":{"QueryArg":{},"ProfileId":{}}}}}}}},"S2n":{"type":"structure","required":["ForwardWhenContentTypeIsUnknown"],"members":{"ForwardWhenContentTypeIsUnknown":{"type":"boolean"},"ContentTypeProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ContentTypeProfile","type":"structure","required":["Format","ContentType"],"members":{"Format":{},"ProfileId":{},"ContentType":{}}}}}}}},"S2t":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionConfig":{"shape":"S2i"}}},"S2v":{"type":"structure","required":["Name","CallerReference","EncryptionEntities"],"members":{"Name":{},"CallerReference":{},"Comment":{},"EncryptionEntities":{"shape":"S2w"}}},"S2w":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"EncryptionEntity","type":"structure","required":["PublicKeyId","ProviderId","FieldPatterns"],"members":{"PublicKeyId":{},"ProviderId":{},"FieldPatterns":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldPattern"}}}}}}}}},"S32":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionProfileConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionProfileConfig":{"shape":"S2v"}}},"S34":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S38":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S34"}}},"S3a":{"type":"structure","required":["CallerReference","Name","EncodedKey"],"members":{"CallerReference":{},"Name":{},"EncodedKey":{},"Comment":{}}},"S3c":{"type":"structure","required":["Id","CreatedTime","PublicKeyConfig"],"members":{"Id":{},"CreatedTime":{"type":"timestamp"},"PublicKeyConfig":{"shape":"S3a"}}},"S3e":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S3f"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"S17"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S3f":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S3i":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S24"},"StreamingDistributionConfig":{"shape":"S3e"}}},"S4p":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"OriginGroups":{"shape":"Sn"},"DefaultCacheBehavior":{"shape":"Sw"},"CacheBehaviors":{"shape":"S1k"},"CustomErrorResponses":{"shape":"S1n"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1s"},"Restrictions":{"shape":"S1w"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}');

});

parcelRequire.register("6LLDI", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}');

});

parcelRequire.register("fuhKk", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}');

});

parcelRequire.register("3DMfx", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2019-03-26","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2019-03-26"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2019-03-26/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2019-03-26/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S23"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2019-03-26/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S2f"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S23"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateFieldLevelEncryptionConfig":{"http":{"requestUri":"/2019-03-26/field-level-encryption","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionConfig"],"members":{"FieldLevelEncryptionConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2x"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"CreateFieldLevelEncryptionProfile":{"http":{"requestUri":"/2019-03-26/field-level-encryption-profile","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2z","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S36"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"CreateInvalidation":{"http":{"requestUri":"/2019-03-26/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S38","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S3c"}},"payload":"Invalidation"}},"CreatePublicKey":{"http":{"requestUri":"/2019-03-26/public-key","responseCode":201},"input":{"type":"structure","required":["PublicKeyConfig"],"members":{"PublicKeyConfig":{"shape":"S3e","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3g"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2019-03-26/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S3i","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3m"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2019-03-26/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S3i"},"Tags":{"shape":"S2f"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3m"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2019-03-26/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2019-03-26/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionConfig":{"http":{"method":"DELETE","requestUri":"/2019-03-26/field-level-encryption/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionProfile":{"http":{"method":"DELETE","requestUri":"/2019-03-26/field-level-encryption-profile/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeletePublicKey":{"http":{"method":"DELETE","requestUri":"/2019-03-26/public-key/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2019-03-26/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2019-03-26/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2019-03-26/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S23"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetFieldLevelEncryption":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2x"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"GetFieldLevelEncryptionConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionConfig":{"shape":"S2m"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionConfig"}},"GetFieldLevelEncryptionProfile":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption-profile/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S36"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"GetFieldLevelEncryptionProfileConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2z"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfileConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2019-03-26/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S3c"}},"payload":"Invalidation"}},"GetPublicKey":{"http":{"method":"GET","requestUri":"/2019-03-26/public-key/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3g"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"GetPublicKeyConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/public-key/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKeyConfig":{"shape":"S3e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKeyConfig"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2019-03-26/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3m"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S3i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2019-03-26/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2019-03-26/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4t"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2019-03-26/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4t"}},"payload":"DistributionList"}},"ListFieldLevelEncryptionConfigs":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionSummary","type":"structure","required":["Id","LastModifiedTime"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Comment":{},"QueryArgProfileConfig":{"shape":"S2n"},"ContentTypeProfileConfig":{"shape":"S2r"}}}}}}},"payload":"FieldLevelEncryptionList"}},"ListFieldLevelEncryptionProfiles":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption-profile"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionProfileSummary","type":"structure","required":["Id","LastModifiedTime","Name","EncryptionEntities"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Name":{},"EncryptionEntities":{"shape":"S30"},"Comment":{}}}}}}},"payload":"FieldLevelEncryptionProfileList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2019-03-26/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListPublicKeys":{"http":{"method":"GET","requestUri":"/2019-03-26/public-key"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"PublicKeySummary","type":"structure","required":["Id","Name","CreatedTime","EncodedKey"],"members":{"Id":{},"Name":{},"CreatedTime":{"type":"timestamp"},"EncodedKey":{},"Comment":{}}}}}}},"payload":"PublicKeyList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2019-03-26/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S3j"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"S17"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2019-03-26/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S2f"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2019-03-26/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S2f","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2019-03-26/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2019-03-26/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2019-03-26/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S23"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateFieldLevelEncryptionConfig":{"http":{"method":"PUT","requestUri":"/2019-03-26/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionConfig","Id"],"members":{"FieldLevelEncryptionConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2x"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"UpdateFieldLevelEncryptionProfile":{"http":{"method":"PUT","requestUri":"/2019-03-26/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig","Id"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2z","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S36"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"UpdatePublicKey":{"http":{"method":"PUT","requestUri":"/2019-03-26/public-key/{Id}/config"},"input":{"type":"structure","required":["PublicKeyConfig","Id"],"members":{"PublicKeyConfig":{"shape":"S3e","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3g"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2019-03-26/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S3i","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3m"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"OriginGroups":{"shape":"Sn"},"DefaultCacheBehavior":{"shape":"Sw"},"CacheBehaviors":{"shape":"S1k"},"CustomErrorResponses":{"shape":"S1n"},"Comment":{"type":"string","sensitive":true},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1t"},"Restrictions":{"shape":"S1x"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}}}}}}},"Sn":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginGroup","type":"structure","required":["Id","FailoverCriteria","Members"],"members":{"Id":{},"FailoverCriteria":{"type":"structure","required":["StatusCodes"],"members":{"StatusCodes":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StatusCode","type":"integer"}}}}}},"Members":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginGroupMember","type":"structure","required":["OriginId"],"members":{"OriginId":{}}}}}}}}}}},"Sw":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"Sx"},"TrustedSigners":{"shape":"S17"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S1b"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S1f"},"FieldLevelEncryptionId":{}}},"Sx":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"S17":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S1b":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S1c"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S1c"}}}}},"S1c":{"type":"list","member":{"locationName":"Method"}},"S1f":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","required":["LambdaFunctionARN","EventType"],"members":{"LambdaFunctionARN":{},"EventType":{},"IncludeBody":{"type":"boolean"}}}}}},"S1k":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"Sx"},"TrustedSigners":{"shape":"S17"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S1b"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S1f"},"FieldLevelEncryptionId":{}}}}}},"S1n":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1t":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1x":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S23":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S25"},"DistributionConfig":{"shape":"S7"},"AliasICPRecordals":{"shape":"S2a"}}},"S25":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S2a":{"type":"list","member":{"locationName":"AliasICPRecordal","type":"structure","members":{"CNAME":{},"ICPRecordalStatus":{}}}},"S2f":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S2m":{"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"Comment":{},"QueryArgProfileConfig":{"shape":"S2n"},"ContentTypeProfileConfig":{"shape":"S2r"}}},"S2n":{"type":"structure","required":["ForwardWhenQueryArgProfileIsUnknown"],"members":{"ForwardWhenQueryArgProfileIsUnknown":{"type":"boolean"},"QueryArgProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"QueryArgProfile","type":"structure","required":["QueryArg","ProfileId"],"members":{"QueryArg":{},"ProfileId":{}}}}}}}},"S2r":{"type":"structure","required":["ForwardWhenContentTypeIsUnknown"],"members":{"ForwardWhenContentTypeIsUnknown":{"type":"boolean"},"ContentTypeProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ContentTypeProfile","type":"structure","required":["Format","ContentType"],"members":{"Format":{},"ProfileId":{},"ContentType":{}}}}}}}},"S2x":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionConfig":{"shape":"S2m"}}},"S2z":{"type":"structure","required":["Name","CallerReference","EncryptionEntities"],"members":{"Name":{},"CallerReference":{},"Comment":{},"EncryptionEntities":{"shape":"S30"}}},"S30":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"EncryptionEntity","type":"structure","required":["PublicKeyId","ProviderId","FieldPatterns"],"members":{"PublicKeyId":{},"ProviderId":{},"FieldPatterns":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldPattern"}}}}}}}}},"S36":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionProfileConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionProfileConfig":{"shape":"S2z"}}},"S38":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S3c":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S38"}}},"S3e":{"type":"structure","required":["CallerReference","Name","EncodedKey"],"members":{"CallerReference":{},"Name":{},"EncodedKey":{},"Comment":{}}},"S3g":{"type":"structure","required":["Id","CreatedTime","PublicKeyConfig"],"members":{"Id":{},"CreatedTime":{"type":"timestamp"},"PublicKeyConfig":{"shape":"S3e"}}},"S3i":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S3j"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"S17"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S3j":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S3m":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S25"},"StreamingDistributionConfig":{"shape":"S3i"}}},"S4t":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"OriginGroups":{"shape":"Sn"},"DefaultCacheBehavior":{"shape":"Sw"},"CacheBehaviors":{"shape":"S1k"},"CustomErrorResponses":{"shape":"S1n"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1t"},"Restrictions":{"shape":"S1x"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"},"AliasICPRecordals":{"shape":"S2a"}}}}}}}}');

});

parcelRequire.register("Lnsf9", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}');

});

parcelRequire.register("fDqym", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":35,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}');

});


parcelRequire.register("bSVV9", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $8a71aaba18f02329$var$Service = $dbC7k.Service;
var $8a71aaba18f02329$var$apiLoader = $dbC7k.apiLoader;
$8a71aaba18f02329$var$apiLoader.services["cloudhsm"] = {};
$dbC7k.CloudHSM = $8a71aaba18f02329$var$Service.defineService("cloudhsm", [
    "2014-05-30"
]);


Object.defineProperty($8a71aaba18f02329$var$apiLoader.services["cloudhsm"], "2014-05-30", {
    get: function get() {
        var model = (parcelRequire("bHYch"));
        model.paginators = (parcelRequire("lyUKf")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.CloudHSM;

});
parcelRequire.register("bHYch", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2014-05-30","endpointPrefix":"cloudhsm","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CloudHSM","serviceFullName":"Amazon CloudHSM","serviceId":"CloudHSM","signatureVersion":"v4","targetPrefix":"CloudHsmFrontendService","uid":"cloudhsm-2014-05-30"},"operations":{"AddTagsToResource":{"input":{"type":"structure","required":["ResourceArn","TagList"],"members":{"ResourceArn":{},"TagList":{"shape":"S3"}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}},"CreateHapg":{"input":{"type":"structure","required":["Label"],"members":{"Label":{}}},"output":{"type":"structure","members":{"HapgArn":{}}}},"CreateHsm":{"input":{"type":"structure","required":["SubnetId","SshKey","IamRoleArn","SubscriptionType"],"members":{"SubnetId":{"locationName":"SubnetId"},"SshKey":{"locationName":"SshKey"},"EniIp":{"locationName":"EniIp"},"IamRoleArn":{"locationName":"IamRoleArn"},"ExternalId":{"locationName":"ExternalId"},"SubscriptionType":{"locationName":"SubscriptionType"},"ClientToken":{"locationName":"ClientToken"},"SyslogIp":{"locationName":"SyslogIp"}},"locationName":"CreateHsmRequest"},"output":{"type":"structure","members":{"HsmArn":{}}}},"CreateLunaClient":{"input":{"type":"structure","required":["Certificate"],"members":{"Label":{},"Certificate":{}}},"output":{"type":"structure","members":{"ClientArn":{}}}},"DeleteHapg":{"input":{"type":"structure","required":["HapgArn"],"members":{"HapgArn":{}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}},"DeleteHsm":{"input":{"type":"structure","required":["HsmArn"],"members":{"HsmArn":{"locationName":"HsmArn"}},"locationName":"DeleteHsmRequest"},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}},"DeleteLunaClient":{"input":{"type":"structure","required":["ClientArn"],"members":{"ClientArn":{}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}},"DescribeHapg":{"input":{"type":"structure","required":["HapgArn"],"members":{"HapgArn":{}}},"output":{"type":"structure","members":{"HapgArn":{},"HapgSerial":{},"HsmsLastActionFailed":{"shape":"Sz"},"HsmsPendingDeletion":{"shape":"Sz"},"HsmsPendingRegistration":{"shape":"Sz"},"Label":{},"LastModifiedTimestamp":{},"PartitionSerialList":{"shape":"S11"},"State":{}}}},"DescribeHsm":{"input":{"type":"structure","members":{"HsmArn":{},"HsmSerialNumber":{}}},"output":{"type":"structure","members":{"HsmArn":{},"Status":{},"StatusDetails":{},"AvailabilityZone":{},"EniId":{},"EniIp":{},"SubscriptionType":{},"SubscriptionStartDate":{},"SubscriptionEndDate":{},"VpcId":{},"SubnetId":{},"IamRoleArn":{},"SerialNumber":{},"VendorName":{},"HsmType":{},"SoftwareVersion":{},"SshPublicKey":{},"SshKeyLastUpdated":{},"ServerCertUri":{},"ServerCertLastUpdated":{},"Partitions":{"type":"list","member":{}}}}},"DescribeLunaClient":{"input":{"type":"structure","members":{"ClientArn":{},"CertificateFingerprint":{}}},"output":{"type":"structure","members":{"ClientArn":{},"Certificate":{},"CertificateFingerprint":{},"LastModifiedTimestamp":{},"Label":{}}}},"GetConfig":{"input":{"type":"structure","required":["ClientArn","ClientVersion","HapgList"],"members":{"ClientArn":{},"ClientVersion":{},"HapgList":{"shape":"S1i"}}},"output":{"type":"structure","members":{"ConfigType":{},"ConfigFile":{},"ConfigCred":{}}}},"ListAvailableZones":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AZList":{"type":"list","member":{}}}}},"ListHapgs":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","required":["HapgList"],"members":{"HapgList":{"shape":"S1i"},"NextToken":{}}}},"ListHsms":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"HsmList":{"shape":"Sz"},"NextToken":{}}}},"ListLunaClients":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","required":["ClientList"],"members":{"ClientList":{"type":"list","member":{}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","required":["TagList"],"members":{"TagList":{"shape":"S3"}}}},"ModifyHapg":{"input":{"type":"structure","required":["HapgArn"],"members":{"HapgArn":{},"Label":{},"PartitionSerialList":{"shape":"S11"}}},"output":{"type":"structure","members":{"HapgArn":{}}}},"ModifyHsm":{"input":{"type":"structure","required":["HsmArn"],"members":{"HsmArn":{"locationName":"HsmArn"},"SubnetId":{"locationName":"SubnetId"},"EniIp":{"locationName":"EniIp"},"IamRoleArn":{"locationName":"IamRoleArn"},"ExternalId":{"locationName":"ExternalId"},"SyslogIp":{"locationName":"SyslogIp"}},"locationName":"ModifyHsmRequest"},"output":{"type":"structure","members":{"HsmArn":{}}}},"ModifyLunaClient":{"input":{"type":"structure","required":["ClientArn","Certificate"],"members":{"ClientArn":{},"Certificate":{}}},"output":{"type":"structure","members":{"ClientArn":{}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceArn","TagKeyList"],"members":{"ResourceArn":{},"TagKeyList":{"type":"list","member":{}}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sz":{"type":"list","member":{}},"S11":{"type":"list","member":{}},"S1i":{"type":"list","member":{}}}}');

});

parcelRequire.register("lyUKf", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("9uo2Y", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $6e8991a42af283f2$var$Service = $dbC7k.Service;
var $6e8991a42af283f2$var$apiLoader = $dbC7k.apiLoader;
$6e8991a42af283f2$var$apiLoader.services["cloudsearch"] = {};
$dbC7k.CloudSearch = $6e8991a42af283f2$var$Service.defineService("cloudsearch", [
    "2011-02-01",
    "2013-01-01"
]);


Object.defineProperty($6e8991a42af283f2$var$apiLoader.services["cloudsearch"], "2011-02-01", {
    get: function get() {
        var model = (parcelRequire("hIV4q"));
        model.paginators = (parcelRequire("2fKRa")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});


Object.defineProperty($6e8991a42af283f2$var$apiLoader.services["cloudsearch"], "2013-01-01", {
    get: function get() {
        var model = (parcelRequire("jkH81"));
        model.paginators = (parcelRequire("476Iv")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.CloudSearch;

});
parcelRequire.register("hIV4q", function(module, exports) {
module.exports = JSON.parse('{"metadata":{"apiVersion":"2011-02-01","endpointPrefix":"cloudsearch","serviceFullName":"Amazon CloudSearch","serviceId":"CloudSearch","signatureVersion":"v4","xmlNamespace":"http://cloudsearch.amazonaws.com/doc/2011-02-01/","protocol":"query"},"operations":{"CreateDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"CreateDomainResult","type":"structure","members":{"DomainStatus":{"shape":"S4"}}}},"DefineIndexField":{"input":{"type":"structure","required":["DomainName","IndexField"],"members":{"DomainName":{},"IndexField":{"shape":"Sf"}}},"output":{"resultWrapper":"DefineIndexFieldResult","type":"structure","required":["IndexField"],"members":{"IndexField":{"shape":"Sx"}}}},"DefineRankExpression":{"input":{"type":"structure","required":["DomainName","RankExpression"],"members":{"DomainName":{},"RankExpression":{"shape":"S12"}}},"output":{"resultWrapper":"DefineRankExpressionResult","type":"structure","required":["RankExpression"],"members":{"RankExpression":{"shape":"S15"}}}},"DeleteDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"DeleteDomainResult","type":"structure","members":{"DomainStatus":{"shape":"S4"}}}},"DeleteIndexField":{"input":{"type":"structure","required":["DomainName","IndexFieldName"],"members":{"DomainName":{},"IndexFieldName":{}}},"output":{"resultWrapper":"DeleteIndexFieldResult","type":"structure","required":["IndexField"],"members":{"IndexField":{"shape":"Sx"}}}},"DeleteRankExpression":{"input":{"type":"structure","required":["DomainName","RankName"],"members":{"DomainName":{},"RankName":{}}},"output":{"resultWrapper":"DeleteRankExpressionResult","type":"structure","required":["RankExpression"],"members":{"RankExpression":{"shape":"S15"}}}},"DescribeAvailabilityOptions":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"DescribeAvailabilityOptionsResult","type":"structure","members":{"AvailabilityOptions":{"shape":"S1e"}}}},"DescribeDefaultSearchField":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"DescribeDefaultSearchFieldResult","type":"structure","required":["DefaultSearchField"],"members":{"DefaultSearchField":{"shape":"S1i"}}}},"DescribeDomains":{"input":{"type":"structure","members":{"DomainNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeDomainsResult","type":"structure","required":["DomainStatusList"],"members":{"DomainStatusList":{"type":"list","member":{"shape":"S4"}}}}},"DescribeIndexFields":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"FieldNames":{"shape":"S1o"}}},"output":{"resultWrapper":"DescribeIndexFieldsResult","type":"structure","required":["IndexFields"],"members":{"IndexFields":{"type":"list","member":{"shape":"Sx"}}}}},"DescribeRankExpressions":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"RankNames":{"shape":"S1o"}}},"output":{"resultWrapper":"DescribeRankExpressionsResult","type":"structure","required":["RankExpressions"],"members":{"RankExpressions":{"type":"list","member":{"shape":"S15"}}}}},"DescribeServiceAccessPolicies":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"DescribeServiceAccessPoliciesResult","type":"structure","required":["AccessPolicies"],"members":{"AccessPolicies":{"shape":"S1w"}}}},"DescribeStemmingOptions":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"DescribeStemmingOptionsResult","type":"structure","required":["Stems"],"members":{"Stems":{"shape":"S20"}}}},"DescribeStopwordOptions":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"DescribeStopwordOptionsResult","type":"structure","required":["Stopwords"],"members":{"Stopwords":{"shape":"S24"}}}},"DescribeSynonymOptions":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"DescribeSynonymOptionsResult","type":"structure","required":["Synonyms"],"members":{"Synonyms":{"shape":"S28"}}}},"IndexDocuments":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"IndexDocumentsResult","type":"structure","members":{"FieldNames":{"shape":"S1o"}}}},"UpdateAvailabilityOptions":{"input":{"type":"structure","required":["DomainName","MultiAZ"],"members":{"DomainName":{},"MultiAZ":{"type":"boolean"}}},"output":{"resultWrapper":"UpdateAvailabilityOptionsResult","type":"structure","members":{"AvailabilityOptions":{"shape":"S1e"}}}},"UpdateDefaultSearchField":{"input":{"type":"structure","required":["DomainName","DefaultSearchField"],"members":{"DomainName":{},"DefaultSearchField":{}}},"output":{"resultWrapper":"UpdateDefaultSearchFieldResult","type":"structure","required":["DefaultSearchField"],"members":{"DefaultSearchField":{"shape":"S1i"}}}},"UpdateServiceAccessPolicies":{"input":{"type":"structure","required":["DomainName","AccessPolicies"],"members":{"DomainName":{},"AccessPolicies":{}}},"output":{"resultWrapper":"UpdateServiceAccessPoliciesResult","type":"structure","required":["AccessPolicies"],"members":{"AccessPolicies":{"shape":"S1w"}}}},"UpdateStemmingOptions":{"input":{"type":"structure","required":["DomainName","Stems"],"members":{"DomainName":{},"Stems":{}}},"output":{"resultWrapper":"UpdateStemmingOptionsResult","type":"structure","required":["Stems"],"members":{"Stems":{"shape":"S20"}}}},"UpdateStopwordOptions":{"input":{"type":"structure","required":["DomainName","Stopwords"],"members":{"DomainName":{},"Stopwords":{}}},"output":{"resultWrapper":"UpdateStopwordOptionsResult","type":"structure","required":["Stopwords"],"members":{"Stopwords":{"shape":"S24"}}}},"UpdateSynonymOptions":{"input":{"type":"structure","required":["DomainName","Synonyms"],"members":{"DomainName":{},"Synonyms":{}}},"output":{"resultWrapper":"UpdateSynonymOptionsResult","type":"structure","required":["Synonyms"],"members":{"Synonyms":{"shape":"S28"}}}}},"shapes":{"S4":{"type":"structure","required":["DomainId","DomainName","RequiresIndexDocuments"],"members":{"DomainId":{},"DomainName":{},"Created":{"type":"boolean"},"Deleted":{"type":"boolean"},"NumSearchableDocs":{"type":"long"},"DocService":{"shape":"S8"},"SearchService":{"shape":"S8"},"RequiresIndexDocuments":{"type":"boolean"},"Processing":{"type":"boolean"},"SearchInstanceType":{},"SearchPartitionCount":{"type":"integer"},"SearchInstanceCount":{"type":"integer"}}},"S8":{"type":"structure","members":{"Arn":{},"Endpoint":{}}},"Sf":{"type":"structure","required":["IndexFieldName","IndexFieldType"],"members":{"IndexFieldName":{},"IndexFieldType":{},"UIntOptions":{"type":"structure","members":{"DefaultValue":{"type":"integer"}}},"LiteralOptions":{"type":"structure","members":{"DefaultValue":{},"SearchEnabled":{"type":"boolean"},"FacetEnabled":{"type":"boolean"},"ResultEnabled":{"type":"boolean"}}},"TextOptions":{"type":"structure","members":{"DefaultValue":{},"FacetEnabled":{"type":"boolean"},"ResultEnabled":{"type":"boolean"},"TextProcessor":{}}},"SourceAttributes":{"type":"list","member":{"type":"structure","required":["SourceDataFunction"],"members":{"SourceDataFunction":{},"SourceDataCopy":{"type":"structure","required":["SourceName"],"members":{"SourceName":{},"DefaultValue":{}}},"SourceDataTrimTitle":{"type":"structure","required":["SourceName"],"members":{"SourceName":{},"DefaultValue":{},"Separator":{},"Language":{}}},"SourceDataMap":{"type":"structure","required":["SourceName"],"members":{"SourceName":{},"DefaultValue":{},"Cases":{"type":"map","key":{},"value":{}}}}}}}}},"Sx":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"Sf"},"Status":{"shape":"Sy"}}},"Sy":{"type":"structure","required":["CreationDate","UpdateDate","State"],"members":{"CreationDate":{"type":"timestamp"},"UpdateDate":{"type":"timestamp"},"UpdateVersion":{"type":"integer"},"State":{},"PendingDeletion":{"type":"boolean"}}},"S12":{"type":"structure","required":["RankName","RankExpression"],"members":{"RankName":{},"RankExpression":{}}},"S15":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S12"},"Status":{"shape":"Sy"}}},"S1e":{"type":"structure","required":["Options","Status"],"members":{"Options":{"type":"boolean"},"Status":{"shape":"Sy"}}},"S1i":{"type":"structure","required":["Options","Status"],"members":{"Options":{},"Status":{"shape":"Sy"}}},"S1o":{"type":"list","member":{}},"S1w":{"type":"structure","required":["Options","Status"],"members":{"Options":{},"Status":{"shape":"Sy"}}},"S20":{"type":"structure","required":["Options","Status"],"members":{"Options":{},"Status":{"shape":"Sy"}}},"S24":{"type":"structure","required":["Options","Status"],"members":{"Options":{},"Status":{"shape":"Sy"}}},"S28":{"type":"structure","required":["Options","Status"],"members":{"Options":{},"Status":{"shape":"Sy"}}}}}');

});

parcelRequire.register("2fKRa", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeDomains":{"result_key":"DomainStatusList"},"DescribeIndexFields":{"result_key":"IndexFields"},"DescribeRankExpressions":{"result_key":"RankExpressions"}}}');

});

parcelRequire.register("jkH81", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2013-01-01","endpointPrefix":"cloudsearch","serviceFullName":"Amazon CloudSearch","serviceId":"CloudSearch","signatureVersion":"v4","xmlNamespace":"http://cloudsearch.amazonaws.com/doc/2013-01-01/","protocol":"query","uid":"cloudsearch-2013-01-01"},"operations":{"BuildSuggesters":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"BuildSuggestersResult","type":"structure","members":{"FieldNames":{"shape":"S4"}}}},"CreateDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"CreateDomainResult","type":"structure","members":{"DomainStatus":{"shape":"S8"}}}},"DefineAnalysisScheme":{"input":{"type":"structure","required":["DomainName","AnalysisScheme"],"members":{"DomainName":{},"AnalysisScheme":{"shape":"Sl"}}},"output":{"resultWrapper":"DefineAnalysisSchemeResult","type":"structure","required":["AnalysisScheme"],"members":{"AnalysisScheme":{"shape":"Ss"}}}},"DefineExpression":{"input":{"type":"structure","required":["DomainName","Expression"],"members":{"DomainName":{},"Expression":{"shape":"Sy"}}},"output":{"resultWrapper":"DefineExpressionResult","type":"structure","required":["Expression"],"members":{"Expression":{"shape":"S11"}}}},"DefineIndexField":{"input":{"type":"structure","required":["DomainName","IndexField"],"members":{"DomainName":{},"IndexField":{"shape":"S13"}}},"output":{"resultWrapper":"DefineIndexFieldResult","type":"structure","required":["IndexField"],"members":{"IndexField":{"shape":"S1n"}}}},"DefineSuggester":{"input":{"type":"structure","required":["DomainName","Suggester"],"members":{"DomainName":{},"Suggester":{"shape":"S1p"}}},"output":{"resultWrapper":"DefineSuggesterResult","type":"structure","required":["Suggester"],"members":{"Suggester":{"shape":"S1t"}}}},"DeleteAnalysisScheme":{"input":{"type":"structure","required":["DomainName","AnalysisSchemeName"],"members":{"DomainName":{},"AnalysisSchemeName":{}}},"output":{"resultWrapper":"DeleteAnalysisSchemeResult","type":"structure","required":["AnalysisScheme"],"members":{"AnalysisScheme":{"shape":"Ss"}}}},"DeleteDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"DeleteDomainResult","type":"structure","members":{"DomainStatus":{"shape":"S8"}}}},"DeleteExpression":{"input":{"type":"structure","required":["DomainName","ExpressionName"],"members":{"DomainName":{},"ExpressionName":{}}},"output":{"resultWrapper":"DeleteExpressionResult","type":"structure","required":["Expression"],"members":{"Expression":{"shape":"S11"}}}},"DeleteIndexField":{"input":{"type":"structure","required":["DomainName","IndexFieldName"],"members":{"DomainName":{},"IndexFieldName":{}}},"output":{"resultWrapper":"DeleteIndexFieldResult","type":"structure","required":["IndexField"],"members":{"IndexField":{"shape":"S1n"}}}},"DeleteSuggester":{"input":{"type":"structure","required":["DomainName","SuggesterName"],"members":{"DomainName":{},"SuggesterName":{}}},"output":{"resultWrapper":"DeleteSuggesterResult","type":"structure","required":["Suggester"],"members":{"Suggester":{"shape":"S1t"}}}},"DescribeAnalysisSchemes":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AnalysisSchemeNames":{"shape":"S25"},"Deployed":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeAnalysisSchemesResult","type":"structure","required":["AnalysisSchemes"],"members":{"AnalysisSchemes":{"type":"list","member":{"shape":"Ss"}}}}},"DescribeAvailabilityOptions":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"Deployed":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeAvailabilityOptionsResult","type":"structure","members":{"AvailabilityOptions":{"shape":"S2a"}}}},"DescribeDomains":{"input":{"type":"structure","members":{"DomainNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeDomainsResult","type":"structure","required":["DomainStatusList"],"members":{"DomainStatusList":{"type":"list","member":{"shape":"S8"}}}}},"DescribeExpressions":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"ExpressionNames":{"shape":"S25"},"Deployed":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeExpressionsResult","type":"structure","required":["Expressions"],"members":{"Expressions":{"type":"list","member":{"shape":"S11"}}}}},"DescribeIndexFields":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"FieldNames":{"type":"list","member":{}},"Deployed":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeIndexFieldsResult","type":"structure","required":["IndexFields"],"members":{"IndexFields":{"type":"list","member":{"shape":"S1n"}}}}},"DescribeScalingParameters":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"DescribeScalingParametersResult","type":"structure","required":["ScalingParameters"],"members":{"ScalingParameters":{"shape":"S2p"}}}},"DescribeServiceAccessPolicies":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"Deployed":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeServiceAccessPoliciesResult","type":"structure","required":["AccessPolicies"],"members":{"AccessPolicies":{"shape":"S2u"}}}},"DescribeSuggesters":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"SuggesterNames":{"shape":"S25"},"Deployed":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeSuggestersResult","type":"structure","required":["Suggesters"],"members":{"Suggesters":{"type":"list","member":{"shape":"S1t"}}}}},"IndexDocuments":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"IndexDocumentsResult","type":"structure","members":{"FieldNames":{"shape":"S4"}}}},"ListDomainNames":{"output":{"resultWrapper":"ListDomainNamesResult","type":"structure","members":{"DomainNames":{"type":"map","key":{},"value":{}}}}},"UpdateAvailabilityOptions":{"input":{"type":"structure","required":["DomainName","MultiAZ"],"members":{"DomainName":{},"MultiAZ":{"type":"boolean"}}},"output":{"resultWrapper":"UpdateAvailabilityOptionsResult","type":"structure","members":{"AvailabilityOptions":{"shape":"S2a"}}}},"UpdateScalingParameters":{"input":{"type":"structure","required":["DomainName","ScalingParameters"],"members":{"DomainName":{},"ScalingParameters":{"shape":"S2q"}}},"output":{"resultWrapper":"UpdateScalingParametersResult","type":"structure","required":["ScalingParameters"],"members":{"ScalingParameters":{"shape":"S2p"}}}},"UpdateServiceAccessPolicies":{"input":{"type":"structure","required":["DomainName","AccessPolicies"],"members":{"DomainName":{},"AccessPolicies":{}}},"output":{"resultWrapper":"UpdateServiceAccessPoliciesResult","type":"structure","required":["AccessPolicies"],"members":{"AccessPolicies":{"shape":"S2u"}}}}},"shapes":{"S4":{"type":"list","member":{}},"S8":{"type":"structure","required":["DomainId","DomainName","RequiresIndexDocuments"],"members":{"DomainId":{},"DomainName":{},"ARN":{},"Created":{"type":"boolean"},"Deleted":{"type":"boolean"},"DocService":{"shape":"Sc"},"SearchService":{"shape":"Sc"},"RequiresIndexDocuments":{"type":"boolean"},"Processing":{"type":"boolean"},"SearchInstanceType":{},"SearchPartitionCount":{"type":"integer"},"SearchInstanceCount":{"type":"integer"},"Limits":{"type":"structure","required":["MaximumReplicationCount","MaximumPartitionCount"],"members":{"MaximumReplicationCount":{"type":"integer"},"MaximumPartitionCount":{"type":"integer"}}}}},"Sc":{"type":"structure","members":{"Endpoint":{}}},"Sl":{"type":"structure","required":["AnalysisSchemeName","AnalysisSchemeLanguage"],"members":{"AnalysisSchemeName":{},"AnalysisSchemeLanguage":{},"AnalysisOptions":{"type":"structure","members":{"Synonyms":{},"Stopwords":{},"StemmingDictionary":{},"JapaneseTokenizationDictionary":{},"AlgorithmicStemming":{}}}}},"Ss":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"Sl"},"Status":{"shape":"St"}}},"St":{"type":"structure","required":["CreationDate","UpdateDate","State"],"members":{"CreationDate":{"type":"timestamp"},"UpdateDate":{"type":"timestamp"},"UpdateVersion":{"type":"integer"},"State":{},"PendingDeletion":{"type":"boolean"}}},"Sy":{"type":"structure","required":["ExpressionName","ExpressionValue"],"members":{"ExpressionName":{},"ExpressionValue":{}}},"S11":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"Sy"},"Status":{"shape":"St"}}},"S13":{"type":"structure","required":["IndexFieldName","IndexFieldType"],"members":{"IndexFieldName":{},"IndexFieldType":{},"IntOptions":{"type":"structure","members":{"DefaultValue":{"type":"long"},"SourceField":{},"FacetEnabled":{"type":"boolean"},"SearchEnabled":{"type":"boolean"},"ReturnEnabled":{"type":"boolean"},"SortEnabled":{"type":"boolean"}}},"DoubleOptions":{"type":"structure","members":{"DefaultValue":{"type":"double"},"SourceField":{},"FacetEnabled":{"type":"boolean"},"SearchEnabled":{"type":"boolean"},"ReturnEnabled":{"type":"boolean"},"SortEnabled":{"type":"boolean"}}},"LiteralOptions":{"type":"structure","members":{"DefaultValue":{},"SourceField":{},"FacetEnabled":{"type":"boolean"},"SearchEnabled":{"type":"boolean"},"ReturnEnabled":{"type":"boolean"},"SortEnabled":{"type":"boolean"}}},"TextOptions":{"type":"structure","members":{"DefaultValue":{},"SourceField":{},"ReturnEnabled":{"type":"boolean"},"SortEnabled":{"type":"boolean"},"HighlightEnabled":{"type":"boolean"},"AnalysisScheme":{}}},"DateOptions":{"type":"structure","members":{"DefaultValue":{},"SourceField":{},"FacetEnabled":{"type":"boolean"},"SearchEnabled":{"type":"boolean"},"ReturnEnabled":{"type":"boolean"},"SortEnabled":{"type":"boolean"}}},"LatLonOptions":{"type":"structure","members":{"DefaultValue":{},"SourceField":{},"FacetEnabled":{"type":"boolean"},"SearchEnabled":{"type":"boolean"},"ReturnEnabled":{"type":"boolean"},"SortEnabled":{"type":"boolean"}}},"IntArrayOptions":{"type":"structure","members":{"DefaultValue":{"type":"long"},"SourceFields":{},"FacetEnabled":{"type":"boolean"},"SearchEnabled":{"type":"boolean"},"ReturnEnabled":{"type":"boolean"}}},"DoubleArrayOptions":{"type":"structure","members":{"DefaultValue":{"type":"double"},"SourceFields":{},"FacetEnabled":{"type":"boolean"},"SearchEnabled":{"type":"boolean"},"ReturnEnabled":{"type":"boolean"}}},"LiteralArrayOptions":{"type":"structure","members":{"DefaultValue":{},"SourceFields":{},"FacetEnabled":{"type":"boolean"},"SearchEnabled":{"type":"boolean"},"ReturnEnabled":{"type":"boolean"}}},"TextArrayOptions":{"type":"structure","members":{"DefaultValue":{},"SourceFields":{},"ReturnEnabled":{"type":"boolean"},"HighlightEnabled":{"type":"boolean"},"AnalysisScheme":{}}},"DateArrayOptions":{"type":"structure","members":{"DefaultValue":{},"SourceFields":{},"FacetEnabled":{"type":"boolean"},"SearchEnabled":{"type":"boolean"},"ReturnEnabled":{"type":"boolean"}}}}},"S1n":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S13"},"Status":{"shape":"St"}}},"S1p":{"type":"structure","required":["SuggesterName","DocumentSuggesterOptions"],"members":{"SuggesterName":{},"DocumentSuggesterOptions":{"type":"structure","required":["SourceField"],"members":{"SourceField":{},"FuzzyMatching":{},"SortExpression":{}}}}},"S1t":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S1p"},"Status":{"shape":"St"}}},"S25":{"type":"list","member":{}},"S2a":{"type":"structure","required":["Options","Status"],"members":{"Options":{"type":"boolean"},"Status":{"shape":"St"}}},"S2p":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S2q"},"Status":{"shape":"St"}}},"S2q":{"type":"structure","members":{"DesiredInstanceType":{},"DesiredReplicationCount":{"type":"integer"},"DesiredPartitionCount":{"type":"integer"}}},"S2u":{"type":"structure","required":["Options","Status"],"members":{"Options":{},"Status":{"shape":"St"}}}}}');

});

parcelRequire.register("476Iv", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeAnalysisSchemes":{"result_key":"AnalysisSchemes"},"DescribeDomains":{"result_key":"DomainStatusList"},"DescribeExpressions":{"result_key":"Expressions"},"DescribeIndexFields":{"result_key":"IndexFields"},"DescribeSuggesters":{"result_key":"Suggesters"}}}');

});


parcelRequire.register("bdTvN", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $82bbf81c20e73445$var$Service = $dbC7k.Service;
var $82bbf81c20e73445$var$apiLoader = $dbC7k.apiLoader;
$82bbf81c20e73445$var$apiLoader.services["cloudsearchdomain"] = {};
$dbC7k.CloudSearchDomain = $82bbf81c20e73445$var$Service.defineService("cloudsearchdomain", [
    "2013-01-01"
]);
parcelRequire("2W1pF");

Object.defineProperty($82bbf81c20e73445$var$apiLoader.services["cloudsearchdomain"], "2013-01-01", {
    get: function get() {
        var model = (parcelRequire("ggysG"));
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.CloudSearchDomain;

});
parcelRequire.register("2W1pF", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
/**
 * Constructs a service interface object. Each API operation is exposed as a
 * function on service.
 *
 * ### Sending a Request Using CloudSearchDomain
 *
 * ```javascript
 * var csd = new AWS.CloudSearchDomain({endpoint: 'my.host.tld'});
 * csd.search(params, function (err, data) {
 *   if (err) console.log(err, err.stack); // an error occurred
 *   else     console.log(data);           // successful response
 * });
 * ```
 *
 * ### Locking the API Version
 *
 * In order to ensure that the CloudSearchDomain object uses this specific API,
 * you can construct the object by passing the `apiVersion` option to the
 * constructor:
 *
 * ```javascript
 * var csd = new AWS.CloudSearchDomain({
 *   endpoint: 'my.host.tld',
 *   apiVersion: '2013-01-01'
 * });
 * ```
 *
 * You can also set the API version globally in `AWS.config.apiVersions` using
 * the **cloudsearchdomain** service identifier:
 *
 * ```javascript
 * AWS.config.apiVersions = {
 *   cloudsearchdomain: '2013-01-01',
 *   // other service API versions
 * };
 *
 * var csd = new AWS.CloudSearchDomain({endpoint: 'my.host.tld'});
 * ```
 *
 * @note You *must* provide an `endpoint` configuration parameter when
 *   constructing this service. See {constructor} for more information.
 *
 * @!method constructor(options = {})
 *   Constructs a service object. This object has one method for each
 *   API operation.
 *
 *   @example Constructing a CloudSearchDomain object
 *     var csd = new AWS.CloudSearchDomain({endpoint: 'my.host.tld'});
 *   @note You *must* provide an `endpoint` when constructing this service.
 *   @option (see AWS.Config.constructor)
 *
 * @service cloudsearchdomain
 * @version 2013-01-01
 */ $dbC7k.util.update($dbC7k.CloudSearchDomain.prototype, {
    /**
   * @api private
   */ validateService: function validateService() {
        if (!this.config.endpoint || this.config.endpoint.indexOf("{") >= 0) {
            var msg = "AWS.CloudSearchDomain requires an explicit `endpoint' configuration option.";
            throw $dbC7k.util.error(new Error(), {
                name: "InvalidEndpoint",
                message: msg
            });
        }
    },
    /**
   * @api private
   */ setupRequestListeners: function setupRequestListeners(request) {
        request.removeListener("validate", $dbC7k.EventListeners.Core.VALIDATE_CREDENTIALS);
        request.onAsync("validate", this.validateCredentials);
        request.addListener("validate", this.updateRegion);
        if (request.operation === "search") request.addListener("build", this.convertGetToPost);
    },
    /**
   * @api private
   */ validateCredentials: function(req, done) {
        if (!req.service.api.signatureVersion) return done(); // none
        req.service.config.getCredentials(function(err) {
            if (err) req.removeListener("sign", $dbC7k.EventListeners.Core.SIGN);
            done();
        });
    },
    /**
   * @api private
   */ convertGetToPost: function(request) {
        var httpRequest = request.httpRequest;
        // convert queries to POST to avoid length restrictions
        var path = httpRequest.path.split("?");
        httpRequest.method = "POST";
        httpRequest.path = path[0];
        httpRequest.body = path[1];
        httpRequest.headers["Content-Length"] = httpRequest.body.length;
        httpRequest.headers["Content-Type"] = "application/x-www-form-urlencoded";
    },
    /**
   * @api private
   */ updateRegion: function updateRegion(request) {
        var endpoint = request.httpRequest.endpoint.hostname;
        var zones = endpoint.split(".");
        request.httpRequest.region = zones[1] || request.httpRequest.region;
    }
});

});

parcelRequire.register("ggysG", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2013-01-01","endpointPrefix":"cloudsearchdomain","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon CloudSearch Domain","serviceId":"CloudSearch Domain","signatureVersion":"v4","signingName":"cloudsearch","uid":"cloudsearchdomain-2013-01-01"},"operations":{"Search":{"http":{"method":"GET","requestUri":"/2013-01-01/search?format=sdk&pretty=true"},"input":{"type":"structure","required":["query"],"members":{"cursor":{"location":"querystring","locationName":"cursor"},"expr":{"location":"querystring","locationName":"expr"},"facet":{"location":"querystring","locationName":"facet"},"filterQuery":{"location":"querystring","locationName":"fq"},"highlight":{"location":"querystring","locationName":"highlight"},"partial":{"location":"querystring","locationName":"partial","type":"boolean"},"query":{"location":"querystring","locationName":"q"},"queryOptions":{"location":"querystring","locationName":"q.options"},"queryParser":{"location":"querystring","locationName":"q.parser"},"return":{"location":"querystring","locationName":"return"},"size":{"location":"querystring","locationName":"size","type":"long"},"sort":{"location":"querystring","locationName":"sort"},"start":{"location":"querystring","locationName":"start","type":"long"},"stats":{"location":"querystring","locationName":"stats"}}},"output":{"type":"structure","members":{"status":{"type":"structure","members":{"timems":{"type":"long"},"rid":{}}},"hits":{"type":"structure","members":{"found":{"type":"long"},"start":{"type":"long"},"cursor":{},"hit":{"type":"list","member":{"type":"structure","members":{"id":{},"fields":{"type":"map","key":{},"value":{"type":"list","member":{}}},"exprs":{"type":"map","key":{},"value":{}},"highlights":{"type":"map","key":{},"value":{}}}}}}},"facets":{"type":"map","key":{},"value":{"type":"structure","members":{"buckets":{"type":"list","member":{"type":"structure","members":{"value":{},"count":{"type":"long"}}}}}}},"stats":{"type":"map","key":{},"value":{"type":"structure","members":{"min":{},"max":{},"count":{"type":"long"},"missing":{"type":"long"},"sum":{"type":"double"},"sumOfSquares":{"type":"double"},"mean":{},"stddev":{"type":"double"}}}}}}},"Suggest":{"http":{"method":"GET","requestUri":"/2013-01-01/suggest?format=sdk&pretty=true"},"input":{"type":"structure","required":["query","suggester"],"members":{"query":{"location":"querystring","locationName":"q"},"suggester":{"location":"querystring","locationName":"suggester"},"size":{"location":"querystring","locationName":"size","type":"long"}}},"output":{"type":"structure","members":{"status":{"type":"structure","members":{"timems":{"type":"long"},"rid":{}}},"suggest":{"type":"structure","members":{"query":{},"found":{"type":"long"},"suggestions":{"type":"list","member":{"type":"structure","members":{"suggestion":{},"score":{"type":"long"},"id":{}}}}}}}}},"UploadDocuments":{"http":{"requestUri":"/2013-01-01/documents/batch?format=sdk"},"input":{"type":"structure","required":["documents","contentType"],"members":{"documents":{"type":"blob","streaming":true},"contentType":{"location":"header","locationName":"Content-Type"}},"payload":"documents"},"output":{"type":"structure","members":{"status":{},"adds":{"type":"long"},"deletes":{"type":"long"},"warnings":{"type":"list","member":{"type":"structure","members":{"message":{}}}}}}}},"shapes":{}}');

});


parcelRequire.register("3FoB4", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $2ab847e47e628a0f$var$Service = $dbC7k.Service;
var $2ab847e47e628a0f$var$apiLoader = $dbC7k.apiLoader;
$2ab847e47e628a0f$var$apiLoader.services["cloudtrail"] = {};
$dbC7k.CloudTrail = $2ab847e47e628a0f$var$Service.defineService("cloudtrail", [
    "2013-11-01"
]);


Object.defineProperty($2ab847e47e628a0f$var$apiLoader.services["cloudtrail"], "2013-11-01", {
    get: function get() {
        var model = (parcelRequire("kKLyg"));
        model.paginators = (parcelRequire("bE7lL")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.CloudTrail;

});
parcelRequire.register("kKLyg", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2013-11-01","endpointPrefix":"cloudtrail","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CloudTrail","serviceFullName":"AWS CloudTrail","serviceId":"CloudTrail","signatureVersion":"v4","targetPrefix":"com.amazonaws.cloudtrail.v20131101.CloudTrail_20131101","uid":"cloudtrail-2013-11-01"},"operations":{"AddTags":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{},"TagsList":{"shape":"S3"}}},"output":{"type":"structure","members":{}},"idempotent":true},"CreateTrail":{"input":{"type":"structure","required":["Name","S3BucketName"],"members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"EnableLogFileValidation":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"IsOrganizationTrail":{"type":"boolean"}}},"output":{"type":"structure","members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{"deprecated":true},"SnsTopicARN":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"TrailARN":{},"LogFileValidationEnabled":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"IsOrganizationTrail":{"type":"boolean"}}},"idempotent":true},"DeleteTrail":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DescribeTrails":{"input":{"type":"structure","members":{"trailNameList":{"type":"list","member":{}},"includeShadowTrails":{"type":"boolean"}}},"output":{"type":"structure","members":{"trailList":{"type":"list","member":{"type":"structure","members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{"deprecated":true},"SnsTopicARN":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"HomeRegion":{},"TrailARN":{},"LogFileValidationEnabled":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"HasCustomEventSelectors":{"type":"boolean"},"IsOrganizationTrail":{"type":"boolean"}}}}}},"idempotent":true},"GetEventSelectors":{"input":{"type":"structure","required":["TrailName"],"members":{"TrailName":{}}},"output":{"type":"structure","members":{"TrailARN":{},"EventSelectors":{"shape":"Si"}}},"idempotent":true},"GetTrailStatus":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"IsLogging":{"type":"boolean"},"LatestDeliveryError":{},"LatestNotificationError":{},"LatestDeliveryTime":{"type":"timestamp"},"LatestNotificationTime":{"type":"timestamp"},"StartLoggingTime":{"type":"timestamp"},"StopLoggingTime":{"type":"timestamp"},"LatestCloudWatchLogsDeliveryError":{},"LatestCloudWatchLogsDeliveryTime":{"type":"timestamp"},"LatestDigestDeliveryTime":{"type":"timestamp"},"LatestDigestDeliveryError":{},"LatestDeliveryAttemptTime":{},"LatestNotificationAttemptTime":{},"LatestNotificationAttemptSucceeded":{},"LatestDeliveryAttemptSucceeded":{},"TimeLoggingStarted":{},"TimeLoggingStopped":{}}},"idempotent":true},"ListPublicKeys":{"input":{"type":"structure","members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"NextToken":{}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"list","member":{"type":"structure","members":{"Value":{"type":"blob"},"ValidityStartTime":{"type":"timestamp"},"ValidityEndTime":{"type":"timestamp"},"Fingerprint":{}}}},"NextToken":{}}},"idempotent":true},"ListTags":{"input":{"type":"structure","required":["ResourceIdList"],"members":{"ResourceIdList":{"type":"list","member":{}},"NextToken":{}}},"output":{"type":"structure","members":{"ResourceTagList":{"type":"list","member":{"type":"structure","members":{"ResourceId":{},"TagsList":{"shape":"S3"}}}},"NextToken":{}}},"idempotent":true},"LookupEvents":{"input":{"type":"structure","members":{"LookupAttributes":{"type":"list","member":{"type":"structure","required":["AttributeKey","AttributeValue"],"members":{"AttributeKey":{},"AttributeValue":{}}}},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Events":{"type":"list","member":{"type":"structure","members":{"EventId":{},"EventName":{},"ReadOnly":{},"AccessKeyId":{},"EventTime":{"type":"timestamp"},"EventSource":{},"Username":{},"Resources":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ResourceName":{}}}},"CloudTrailEvent":{}}}},"NextToken":{}}},"idempotent":true},"PutEventSelectors":{"input":{"type":"structure","required":["TrailName","EventSelectors"],"members":{"TrailName":{},"EventSelectors":{"shape":"Si"}}},"output":{"type":"structure","members":{"TrailARN":{},"EventSelectors":{"shape":"Si"}}},"idempotent":true},"RemoveTags":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{},"TagsList":{"shape":"S3"}}},"output":{"type":"structure","members":{}},"idempotent":true},"StartLogging":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"StopLogging":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateTrail":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"EnableLogFileValidation":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"IsOrganizationTrail":{"type":"boolean"}}},"output":{"type":"structure","members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{"deprecated":true},"SnsTopicARN":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"TrailARN":{},"LogFileValidationEnabled":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"IsOrganizationTrail":{"type":"boolean"}}},"idempotent":true}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Si":{"type":"list","member":{"type":"structure","members":{"ReadWriteType":{},"IncludeManagementEvents":{"type":"boolean"},"DataResources":{"type":"list","member":{"type":"structure","members":{"Type":{},"Values":{"type":"list","member":{}}}}}}}}}}');

});

parcelRequire.register("bE7lL", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeTrails":{"result_key":"trailList"},"LookupEvents":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Events"}}}');

});


parcelRequire.register("6kPtS", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $49cc8b6258047ff9$var$Service = $dbC7k.Service;
var $49cc8b6258047ff9$var$apiLoader = $dbC7k.apiLoader;
$49cc8b6258047ff9$var$apiLoader.services["cloudwatch"] = {};
$dbC7k.CloudWatch = $49cc8b6258047ff9$var$Service.defineService("cloudwatch", [
    "2010-08-01"
]);



Object.defineProperty($49cc8b6258047ff9$var$apiLoader.services["cloudwatch"], "2010-08-01", {
    get: function get() {
        var model = (parcelRequire("5hW1c"));
        model.paginators = (parcelRequire("5xF6I")).pagination;
        model.waiters = (parcelRequire("hdtVy")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.CloudWatch;

});
parcelRequire.register("5hW1c", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2010-08-01","endpointPrefix":"monitoring","protocol":"query","serviceAbbreviation":"CloudWatch","serviceFullName":"Amazon CloudWatch","serviceId":"CloudWatch","signatureVersion":"v4","uid":"monitoring-2010-08-01","xmlNamespace":"http://monitoring.amazonaws.com/doc/2010-08-01/"},"operations":{"DeleteAlarms":{"input":{"type":"structure","required":["AlarmNames"],"members":{"AlarmNames":{"shape":"S2"}}}},"DeleteAnomalyDetector":{"input":{"type":"structure","required":["Namespace","MetricName","Stat"],"members":{"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S7"},"Stat":{}}},"output":{"resultWrapper":"DeleteAnomalyDetectorResult","type":"structure","members":{}}},"DeleteDashboards":{"input":{"type":"structure","required":["DashboardNames"],"members":{"DashboardNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DeleteDashboardsResult","type":"structure","members":{}}},"DescribeAlarmHistory":{"input":{"type":"structure","members":{"AlarmName":{},"HistoryItemType":{},"StartDate":{"type":"timestamp"},"EndDate":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeAlarmHistoryResult","type":"structure","members":{"AlarmHistoryItems":{"type":"list","member":{"type":"structure","members":{"AlarmName":{},"Timestamp":{"type":"timestamp"},"HistoryItemType":{},"HistorySummary":{},"HistoryData":{}}}},"NextToken":{}}}},"DescribeAlarms":{"input":{"type":"structure","members":{"AlarmNames":{"shape":"S2"},"AlarmNamePrefix":{},"StateValue":{},"ActionPrefix":{},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeAlarmsResult","type":"structure","members":{"MetricAlarms":{"shape":"Sw"},"NextToken":{}}}},"DescribeAlarmsForMetric":{"input":{"type":"structure","required":["MetricName","Namespace"],"members":{"MetricName":{},"Namespace":{},"Statistic":{},"ExtendedStatistic":{},"Dimensions":{"shape":"S7"},"Period":{"type":"integer"},"Unit":{}}},"output":{"resultWrapper":"DescribeAlarmsForMetricResult","type":"structure","members":{"MetricAlarms":{"shape":"Sw"}}}},"DescribeAnomalyDetectors":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S7"}}},"output":{"resultWrapper":"DescribeAnomalyDetectorsResult","type":"structure","members":{"AnomalyDetectors":{"type":"list","member":{"type":"structure","members":{"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S7"},"Stat":{},"Configuration":{"shape":"S1u"}}}},"NextToken":{}}}},"DisableAlarmActions":{"input":{"type":"structure","required":["AlarmNames"],"members":{"AlarmNames":{"shape":"S2"}}}},"EnableAlarmActions":{"input":{"type":"structure","required":["AlarmNames"],"members":{"AlarmNames":{"shape":"S2"}}}},"GetDashboard":{"input":{"type":"structure","required":["DashboardName"],"members":{"DashboardName":{}}},"output":{"resultWrapper":"GetDashboardResult","type":"structure","members":{"DashboardArn":{},"DashboardBody":{},"DashboardName":{}}}},"GetMetricData":{"input":{"type":"structure","required":["MetricDataQueries","StartTime","EndTime"],"members":{"MetricDataQueries":{"shape":"S1f"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"NextToken":{},"ScanBy":{},"MaxDatapoints":{"type":"integer"}}},"output":{"resultWrapper":"GetMetricDataResult","type":"structure","members":{"MetricDataResults":{"type":"list","member":{"type":"structure","members":{"Id":{},"Label":{},"Timestamps":{"type":"list","member":{"type":"timestamp"}},"Values":{"type":"list","member":{"type":"double"}},"StatusCode":{},"Messages":{"shape":"S2e"}}}},"NextToken":{},"Messages":{"shape":"S2e"}}}},"GetMetricStatistics":{"input":{"type":"structure","required":["Namespace","MetricName","StartTime","EndTime","Period"],"members":{"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S7"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Period":{"type":"integer"},"Statistics":{"type":"list","member":{}},"ExtendedStatistics":{"type":"list","member":{}},"Unit":{}}},"output":{"resultWrapper":"GetMetricStatisticsResult","type":"structure","members":{"Label":{},"Datapoints":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"timestamp"},"SampleCount":{"type":"double"},"Average":{"type":"double"},"Sum":{"type":"double"},"Minimum":{"type":"double"},"Maximum":{"type":"double"},"Unit":{},"ExtendedStatistics":{"type":"map","key":{},"value":{"type":"double"}}},"xmlOrder":["Timestamp","SampleCount","Average","Sum","Minimum","Maximum","Unit","ExtendedStatistics"]}}}}},"GetMetricWidgetImage":{"input":{"type":"structure","required":["MetricWidget"],"members":{"MetricWidget":{},"OutputFormat":{}}},"output":{"resultWrapper":"GetMetricWidgetImageResult","type":"structure","members":{"MetricWidgetImage":{"type":"blob"}}}},"ListDashboards":{"input":{"type":"structure","members":{"DashboardNamePrefix":{},"NextToken":{}}},"output":{"resultWrapper":"ListDashboardsResult","type":"structure","members":{"DashboardEntries":{"type":"list","member":{"type":"structure","members":{"DashboardName":{},"DashboardArn":{},"LastModified":{"type":"timestamp"},"Size":{"type":"long"}}}},"NextToken":{}}}},"ListMetrics":{"input":{"type":"structure","members":{"Namespace":{},"MetricName":{},"Dimensions":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Value":{}}}},"NextToken":{}}},"output":{"resultWrapper":"ListMetricsResult","type":"structure","members":{"Metrics":{"type":"list","member":{"shape":"S1j"}},"NextToken":{}},"xmlOrder":["Metrics","NextToken"]}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"Tags":{"shape":"S39"}}}},"PutAnomalyDetector":{"input":{"type":"structure","required":["Namespace","MetricName","Stat"],"members":{"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S7"},"Stat":{},"Configuration":{"shape":"S1u"}}},"output":{"resultWrapper":"PutAnomalyDetectorResult","type":"structure","members":{}}},"PutDashboard":{"input":{"type":"structure","required":["DashboardName","DashboardBody"],"members":{"DashboardName":{},"DashboardBody":{}}},"output":{"resultWrapper":"PutDashboardResult","type":"structure","members":{"DashboardValidationMessages":{"type":"list","member":{"type":"structure","members":{"DataPath":{},"Message":{}}}}}}},"PutMetricAlarm":{"input":{"type":"structure","required":["AlarmName","EvaluationPeriods","ComparisonOperator"],"members":{"AlarmName":{},"AlarmDescription":{},"ActionsEnabled":{"type":"boolean"},"OKActions":{"shape":"S11"},"AlarmActions":{"shape":"S11"},"InsufficientDataActions":{"shape":"S11"},"MetricName":{},"Namespace":{},"Statistic":{},"ExtendedStatistic":{},"Dimensions":{"shape":"S7"},"Period":{"type":"integer"},"Unit":{},"EvaluationPeriods":{"type":"integer"},"DatapointsToAlarm":{"type":"integer"},"Threshold":{"type":"double"},"ComparisonOperator":{},"TreatMissingData":{},"EvaluateLowSampleCountPercentile":{},"Metrics":{"shape":"S1f"},"Tags":{"shape":"S39"},"ThresholdMetricId":{}}}},"PutMetricData":{"input":{"type":"structure","required":["Namespace","MetricData"],"members":{"Namespace":{},"MetricData":{"type":"list","member":{"type":"structure","required":["MetricName"],"members":{"MetricName":{},"Dimensions":{"shape":"S7"},"Timestamp":{"type":"timestamp"},"Value":{"type":"double"},"StatisticValues":{"type":"structure","required":["SampleCount","Sum","Minimum","Maximum"],"members":{"SampleCount":{"type":"double"},"Sum":{"type":"double"},"Minimum":{"type":"double"},"Maximum":{"type":"double"}}},"Values":{"type":"list","member":{"type":"double"}},"Counts":{"type":"list","member":{"type":"double"}},"Unit":{},"StorageResolution":{"type":"integer"}}}}}}},"SetAlarmState":{"input":{"type":"structure","required":["AlarmName","StateValue","StateReason"],"members":{"AlarmName":{},"StateValue":{},"StateReason":{},"StateReasonData":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S39"}}},"output":{"resultWrapper":"TagResourceResult","type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"resultWrapper":"UntagResourceResult","type":"structure","members":{}}}},"shapes":{"S2":{"type":"list","member":{}},"S7":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}},"xmlOrder":["Name","Value"]}},"Sw":{"type":"list","member":{"type":"structure","members":{"AlarmName":{},"AlarmArn":{},"AlarmDescription":{},"AlarmConfigurationUpdatedTimestamp":{"type":"timestamp"},"ActionsEnabled":{"type":"boolean"},"OKActions":{"shape":"S11"},"AlarmActions":{"shape":"S11"},"InsufficientDataActions":{"shape":"S11"},"StateValue":{},"StateReason":{},"StateReasonData":{},"StateUpdatedTimestamp":{"type":"timestamp"},"MetricName":{},"Namespace":{},"Statistic":{},"ExtendedStatistic":{},"Dimensions":{"shape":"S7"},"Period":{"type":"integer"},"Unit":{},"EvaluationPeriods":{"type":"integer"},"DatapointsToAlarm":{"type":"integer"},"Threshold":{"type":"double"},"ComparisonOperator":{},"TreatMissingData":{},"EvaluateLowSampleCountPercentile":{},"Metrics":{"shape":"S1f"},"ThresholdMetricId":{}},"xmlOrder":["AlarmName","AlarmArn","AlarmDescription","AlarmConfigurationUpdatedTimestamp","ActionsEnabled","OKActions","AlarmActions","InsufficientDataActions","StateValue","StateReason","StateReasonData","StateUpdatedTimestamp","MetricName","Namespace","Statistic","Dimensions","Period","Unit","EvaluationPeriods","Threshold","ComparisonOperator","ExtendedStatistic","TreatMissingData","EvaluateLowSampleCountPercentile","DatapointsToAlarm","Metrics","ThresholdMetricId"]}},"S11":{"type":"list","member":{}},"S1f":{"type":"list","member":{"type":"structure","required":["Id"],"members":{"Id":{},"MetricStat":{"type":"structure","required":["Metric","Period","Stat"],"members":{"Metric":{"shape":"S1j"},"Period":{"type":"integer"},"Stat":{},"Unit":{}}},"Expression":{},"Label":{},"ReturnData":{"type":"boolean"}}}},"S1j":{"type":"structure","members":{"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S7"}},"xmlOrder":["Namespace","MetricName","Dimensions"]},"S1u":{"type":"structure","members":{"ExcludedTimeRanges":{"type":"list","member":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}},"xmlOrder":["StartTime","EndTime"]}},"MetricTimezone":{}}},"S2e":{"type":"list","member":{"type":"structure","members":{"Code":{},"Value":{}}}},"S39":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}}}}');

});

parcelRequire.register("5xF6I", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeAlarmHistory":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"AlarmHistoryItems"},"DescribeAlarms":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"MetricAlarms"},"DescribeAlarmsForMetric":{"result_key":"MetricAlarms"},"GetMetricData":{"input_token":"NextToken","limit_key":"MaxDatapoints","output_token":"NextToken","result_key":["MetricDataResults","Messages"]},"ListDashboards":{"input_token":"NextToken","output_token":"NextToken","result_key":"DashboardEntries"},"ListMetrics":{"input_token":"NextToken","output_token":"NextToken","result_key":"Metrics"}}}');

});

parcelRequire.register("hdtVy", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"AlarmExists":{"delay":5,"maxAttempts":40,"operation":"DescribeAlarms","acceptors":[{"matcher":"path","expected":true,"argument":"length(MetricAlarms[]) > `0`","state":"success"}]}}}');

});


parcelRequire.register("7aeIK", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $5374e2c9fa0ab59b$var$Service = $dbC7k.Service;
var $5374e2c9fa0ab59b$var$apiLoader = $dbC7k.apiLoader;
$5374e2c9fa0ab59b$var$apiLoader.services["cloudwatchevents"] = {};
$dbC7k.CloudWatchEvents = $5374e2c9fa0ab59b$var$Service.defineService("cloudwatchevents", [
    "2014-02-03*",
    "2015-10-07"
]);


Object.defineProperty($5374e2c9fa0ab59b$var$apiLoader.services["cloudwatchevents"], "2015-10-07", {
    get: function get() {
        var model = (parcelRequire("1ER29"));
        model.paginators = (parcelRequire("jHTr8")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.CloudWatchEvents;

});
parcelRequire.register("1ER29", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-10-07","endpointPrefix":"events","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon CloudWatch Events","serviceId":"CloudWatch Events","signatureVersion":"v4","targetPrefix":"AWSEvents","uid":"events-2015-10-07"},"operations":{"ActivateEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"CreateEventBus":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventSourceName":{}}},"output":{"type":"structure","members":{"EventBusArn":{}}}},"CreatePartnerEventSource":{"input":{"type":"structure","required":["Name","Account"],"members":{"Name":{},"Account":{}}},"output":{"type":"structure","members":{"EventSourceArn":{}}}},"DeactivateEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DeleteEventBus":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DeletePartnerEventSource":{"input":{"type":"structure","required":["Name","Account"],"members":{"Name":{},"Account":{}}}},"DeleteRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{},"Force":{"type":"boolean"}}}},"DescribeEventBus":{"input":{"type":"structure","members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"Policy":{}}}},"DescribeEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Arn":{},"CreatedBy":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"Name":{},"State":{}}}},"DescribePartnerEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Arn":{},"Name":{}}}},"DescribeRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"EventPattern":{},"ScheduleExpression":{},"State":{},"Description":{},"RoleArn":{},"ManagedBy":{},"EventBusName":{}}}},"DisableRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{}}}},"EnableRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{}}}},"ListEventBuses":{"input":{"type":"structure","members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"EventBuses":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{},"Policy":{}}}},"NextToken":{}}}},"ListEventSources":{"input":{"type":"structure","members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"EventSources":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreatedBy":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"Name":{},"State":{}}}},"NextToken":{}}}},"ListPartnerEventSourceAccounts":{"input":{"type":"structure","required":["EventSourceName"],"members":{"EventSourceName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"PartnerEventSourceAccounts":{"type":"list","member":{"type":"structure","members":{"Account":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"State":{}}}},"NextToken":{}}}},"ListPartnerEventSources":{"input":{"type":"structure","required":["NamePrefix"],"members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"PartnerEventSources":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Name":{}}}},"NextToken":{}}}},"ListRuleNamesByTarget":{"input":{"type":"structure","required":["TargetArn"],"members":{"TargetArn":{},"EventBusName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"RuleNames":{"type":"list","member":{}},"NextToken":{}}}},"ListRules":{"input":{"type":"structure","members":{"NamePrefix":{},"EventBusName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Rules":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{},"EventPattern":{},"State":{},"Description":{},"ScheduleExpression":{},"RoleArn":{},"ManagedBy":{},"EventBusName":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S1u"}}}},"ListTargetsByRule":{"input":{"type":"structure","required":["Rule"],"members":{"Rule":{},"EventBusName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Targets":{"shape":"S20"},"NextToken":{}}}},"PutEvents":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","members":{"Time":{"type":"timestamp"},"Source":{},"Resources":{"shape":"S2y"},"DetailType":{},"Detail":{},"EventBusName":{}}}}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"Entries":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"PutPartnerEvents":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","members":{"Time":{"type":"timestamp"},"Source":{},"Resources":{"shape":"S2y"},"DetailType":{},"Detail":{}}}}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"Entries":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"PutPermission":{"input":{"type":"structure","required":["Action","Principal","StatementId"],"members":{"EventBusName":{},"Action":{},"Principal":{},"StatementId":{},"Condition":{"type":"structure","required":["Type","Key","Value"],"members":{"Type":{},"Key":{},"Value":{}}}}}},"PutRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"ScheduleExpression":{},"EventPattern":{},"State":{},"Description":{},"RoleArn":{},"Tags":{"shape":"S1u"},"EventBusName":{}}},"output":{"type":"structure","members":{"RuleArn":{}}}},"PutTargets":{"input":{"type":"structure","required":["Rule","Targets"],"members":{"Rule":{},"EventBusName":{},"Targets":{"shape":"S20"}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"FailedEntries":{"type":"list","member":{"type":"structure","members":{"TargetId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"RemovePermission":{"input":{"type":"structure","required":["StatementId"],"members":{"StatementId":{},"EventBusName":{}}}},"RemoveTargets":{"input":{"type":"structure","required":["Rule","Ids"],"members":{"Rule":{},"EventBusName":{},"Ids":{"type":"list","member":{}},"Force":{"type":"boolean"}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"FailedEntries":{"type":"list","member":{"type":"structure","members":{"TargetId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S1u"}}},"output":{"type":"structure","members":{}}},"TestEventPattern":{"input":{"type":"structure","required":["EventPattern","Event"],"members":{"EventPattern":{},"Event":{}}},"output":{"type":"structure","members":{"Result":{"type":"boolean"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S1u":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S20":{"type":"list","member":{"type":"structure","required":["Id","Arn"],"members":{"Id":{},"Arn":{},"RoleArn":{},"Input":{},"InputPath":{},"InputTransformer":{"type":"structure","required":["InputTemplate"],"members":{"InputPathsMap":{"type":"map","key":{},"value":{}},"InputTemplate":{}}},"KinesisParameters":{"type":"structure","required":["PartitionKeyPath"],"members":{"PartitionKeyPath":{}}},"RunCommandParameters":{"type":"structure","required":["RunCommandTargets"],"members":{"RunCommandTargets":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}}}},"EcsParameters":{"type":"structure","required":["TaskDefinitionArn"],"members":{"TaskDefinitionArn":{},"TaskCount":{"type":"integer"},"LaunchType":{},"NetworkConfiguration":{"type":"structure","members":{"awsvpcConfiguration":{"type":"structure","required":["Subnets"],"members":{"Subnets":{"shape":"S2m"},"SecurityGroups":{"shape":"S2m"},"AssignPublicIp":{}}}}},"PlatformVersion":{},"Group":{}}},"BatchParameters":{"type":"structure","required":["JobDefinition","JobName"],"members":{"JobDefinition":{},"JobName":{},"ArrayProperties":{"type":"structure","members":{"Size":{"type":"integer"}}},"RetryStrategy":{"type":"structure","members":{"Attempts":{"type":"integer"}}}}},"SqsParameters":{"type":"structure","members":{"MessageGroupId":{}}}}}},"S2m":{"type":"list","member":{}},"S2y":{"type":"list","member":{}}}}');

});

parcelRequire.register("jHTr8", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("ebUqC", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $a54ddd40dc8c31e7$var$Service = $dbC7k.Service;
var $a54ddd40dc8c31e7$var$apiLoader = $dbC7k.apiLoader;
$a54ddd40dc8c31e7$var$apiLoader.services["cloudwatchlogs"] = {};
$dbC7k.CloudWatchLogs = $a54ddd40dc8c31e7$var$Service.defineService("cloudwatchlogs", [
    "2014-03-28"
]);


Object.defineProperty($a54ddd40dc8c31e7$var$apiLoader.services["cloudwatchlogs"], "2014-03-28", {
    get: function get() {
        var model = (parcelRequire("eABq5"));
        model.paginators = (parcelRequire("9whac")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.CloudWatchLogs;

});
parcelRequire.register("eABq5", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2014-03-28","endpointPrefix":"logs","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon CloudWatch Logs","serviceId":"CloudWatch Logs","signatureVersion":"v4","targetPrefix":"Logs_20140328","uid":"logs-2014-03-28"},"operations":{"AssociateKmsKey":{"input":{"type":"structure","required":["logGroupName","kmsKeyId"],"members":{"logGroupName":{},"kmsKeyId":{}}}},"CancelExportTask":{"input":{"type":"structure","required":["taskId"],"members":{"taskId":{}}}},"CreateExportTask":{"input":{"type":"structure","required":["logGroupName","from","to","destination"],"members":{"taskName":{},"logGroupName":{},"logStreamNamePrefix":{},"from":{"type":"long"},"to":{"type":"long"},"destination":{},"destinationPrefix":{}}},"output":{"type":"structure","members":{"taskId":{}}}},"CreateLogGroup":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"kmsKeyId":{},"tags":{"shape":"Se"}}}},"CreateLogStream":{"input":{"type":"structure","required":["logGroupName","logStreamName"],"members":{"logGroupName":{},"logStreamName":{}}}},"DeleteDestination":{"input":{"type":"structure","required":["destinationName"],"members":{"destinationName":{}}}},"DeleteLogGroup":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}}},"DeleteLogStream":{"input":{"type":"structure","required":["logGroupName","logStreamName"],"members":{"logGroupName":{},"logStreamName":{}}}},"DeleteMetricFilter":{"input":{"type":"structure","required":["logGroupName","filterName"],"members":{"logGroupName":{},"filterName":{}}}},"DeleteResourcePolicy":{"input":{"type":"structure","members":{"policyName":{}}}},"DeleteRetentionPolicy":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}}},"DeleteSubscriptionFilter":{"input":{"type":"structure","required":["logGroupName","filterName"],"members":{"logGroupName":{},"filterName":{}}}},"DescribeDestinations":{"input":{"type":"structure","members":{"DestinationNamePrefix":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"destinations":{"type":"list","member":{"shape":"Sx"}},"nextToken":{}}}},"DescribeExportTasks":{"input":{"type":"structure","members":{"taskId":{},"statusCode":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"exportTasks":{"type":"list","member":{"type":"structure","members":{"taskId":{},"taskName":{},"logGroupName":{},"from":{"type":"long"},"to":{"type":"long"},"destination":{},"destinationPrefix":{},"status":{"type":"structure","members":{"code":{},"message":{}}},"executionInfo":{"type":"structure","members":{"creationTime":{"type":"long"},"completionTime":{"type":"long"}}}}}},"nextToken":{}}}},"DescribeLogGroups":{"input":{"type":"structure","members":{"logGroupNamePrefix":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"logGroups":{"type":"list","member":{"type":"structure","members":{"logGroupName":{},"creationTime":{"type":"long"},"retentionInDays":{"type":"integer"},"metricFilterCount":{"type":"integer"},"arn":{},"storedBytes":{"type":"long"},"kmsKeyId":{}}}},"nextToken":{}}}},"DescribeLogStreams":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"logStreamNamePrefix":{},"orderBy":{},"descending":{"type":"boolean"},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"logStreams":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"creationTime":{"type":"long"},"firstEventTimestamp":{"type":"long"},"lastEventTimestamp":{"type":"long"},"lastIngestionTime":{"type":"long"},"uploadSequenceToken":{},"arn":{},"storedBytes":{"deprecated":true,"deprecatedMessage":"Starting on June 17, 2019, this parameter will be deprecated for log streams, and will be reported as zero. This change applies only to log streams. The storedBytes parameter for log groups is not affected.","type":"long"}}}},"nextToken":{}}}},"DescribeMetricFilters":{"input":{"type":"structure","members":{"logGroupName":{},"filterNamePrefix":{},"nextToken":{},"limit":{"type":"integer"},"metricName":{},"metricNamespace":{}}},"output":{"type":"structure","members":{"metricFilters":{"type":"list","member":{"type":"structure","members":{"filterName":{},"filterPattern":{},"metricTransformations":{"shape":"S1v"},"creationTime":{"type":"long"},"logGroupName":{}}}},"nextToken":{}}}},"DescribeQueries":{"input":{"type":"structure","members":{"logGroupName":{},"status":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"queries":{"type":"list","member":{"type":"structure","members":{"queryId":{},"queryString":{},"status":{},"createTime":{"type":"long"},"logGroupName":{}}}},"nextToken":{}}}},"DescribeResourcePolicies":{"input":{"type":"structure","members":{"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"resourcePolicies":{"type":"list","member":{"shape":"S2a"}},"nextToken":{}}}},"DescribeSubscriptionFilters":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"filterNamePrefix":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"subscriptionFilters":{"type":"list","member":{"type":"structure","members":{"filterName":{},"logGroupName":{},"filterPattern":{},"destinationArn":{},"roleArn":{},"distribution":{},"creationTime":{"type":"long"}}}},"nextToken":{}}}},"DisassociateKmsKey":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}}},"FilterLogEvents":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"logStreamNames":{"type":"list","member":{}},"logStreamNamePrefix":{},"startTime":{"type":"long"},"endTime":{"type":"long"},"filterPattern":{},"nextToken":{},"limit":{"type":"integer"},"interleaved":{"deprecated":true,"deprecatedMessage":"Starting on June 17, 2019, this parameter will be ignored and the value will be assumed to be true. The response from this operation will always interleave events from multiple log streams within a log group.","type":"boolean"}}},"output":{"type":"structure","members":{"events":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"timestamp":{"type":"long"},"message":{},"ingestionTime":{"type":"long"},"eventId":{}}}},"searchedLogStreams":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"searchedCompletely":{"type":"boolean"}}}},"nextToken":{}}}},"GetLogEvents":{"input":{"type":"structure","required":["logGroupName","logStreamName"],"members":{"logGroupName":{},"logStreamName":{},"startTime":{"type":"long"},"endTime":{"type":"long"},"nextToken":{},"limit":{"type":"integer"},"startFromHead":{"type":"boolean"}}},"output":{"type":"structure","members":{"events":{"type":"list","member":{"type":"structure","members":{"timestamp":{"type":"long"},"message":{},"ingestionTime":{"type":"long"}}}},"nextForwardToken":{},"nextBackwardToken":{}}}},"GetLogGroupFields":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"time":{"type":"long"}}},"output":{"type":"structure","members":{"logGroupFields":{"type":"list","member":{"type":"structure","members":{"name":{},"percent":{"type":"integer"}}}}}}},"GetLogRecord":{"input":{"type":"structure","required":["logRecordPointer"],"members":{"logRecordPointer":{}}},"output":{"type":"structure","members":{"logRecord":{"type":"map","key":{},"value":{}}}}},"GetQueryResults":{"input":{"type":"structure","required":["queryId"],"members":{"queryId":{}}},"output":{"type":"structure","members":{"results":{"type":"list","member":{"type":"list","member":{"type":"structure","members":{"field":{},"value":{}}}}},"statistics":{"type":"structure","members":{"recordsMatched":{"type":"double"},"recordsScanned":{"type":"double"},"bytesScanned":{"type":"double"}}},"status":{}}}},"ListTagsLogGroup":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}},"output":{"type":"structure","members":{"tags":{"shape":"Se"}}}},"PutDestination":{"input":{"type":"structure","required":["destinationName","targetArn","roleArn"],"members":{"destinationName":{},"targetArn":{},"roleArn":{}}},"output":{"type":"structure","members":{"destination":{"shape":"Sx"}}}},"PutDestinationPolicy":{"input":{"type":"structure","required":["destinationName","accessPolicy"],"members":{"destinationName":{},"accessPolicy":{}}}},"PutLogEvents":{"input":{"type":"structure","required":["logGroupName","logStreamName","logEvents"],"members":{"logGroupName":{},"logStreamName":{},"logEvents":{"type":"list","member":{"type":"structure","required":["timestamp","message"],"members":{"timestamp":{"type":"long"},"message":{}}}},"sequenceToken":{}}},"output":{"type":"structure","members":{"nextSequenceToken":{},"rejectedLogEventsInfo":{"type":"structure","members":{"tooNewLogEventStartIndex":{"type":"integer"},"tooOldLogEventEndIndex":{"type":"integer"},"expiredLogEventEndIndex":{"type":"integer"}}}}}},"PutMetricFilter":{"input":{"type":"structure","required":["logGroupName","filterName","filterPattern","metricTransformations"],"members":{"logGroupName":{},"filterName":{},"filterPattern":{},"metricTransformations":{"shape":"S1v"}}}},"PutResourcePolicy":{"input":{"type":"structure","members":{"policyName":{},"policyDocument":{}}},"output":{"type":"structure","members":{"resourcePolicy":{"shape":"S2a"}}}},"PutRetentionPolicy":{"input":{"type":"structure","required":["logGroupName","retentionInDays"],"members":{"logGroupName":{},"retentionInDays":{"type":"integer"}}}},"PutSubscriptionFilter":{"input":{"type":"structure","required":["logGroupName","filterName","filterPattern","destinationArn"],"members":{"logGroupName":{},"filterName":{},"filterPattern":{},"destinationArn":{},"roleArn":{},"distribution":{}}}},"StartQuery":{"input":{"type":"structure","required":["startTime","endTime","queryString"],"members":{"logGroupName":{},"logGroupNames":{"type":"list","member":{}},"startTime":{"type":"long"},"endTime":{"type":"long"},"queryString":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"queryId":{}}}},"StopQuery":{"input":{"type":"structure","required":["queryId"],"members":{"queryId":{}}},"output":{"type":"structure","members":{"success":{"type":"boolean"}}}},"TagLogGroup":{"input":{"type":"structure","required":["logGroupName","tags"],"members":{"logGroupName":{},"tags":{"shape":"Se"}}}},"TestMetricFilter":{"input":{"type":"structure","required":["filterPattern","logEventMessages"],"members":{"filterPattern":{},"logEventMessages":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"matches":{"type":"list","member":{"type":"structure","members":{"eventNumber":{"type":"long"},"eventMessage":{},"extractedValues":{"type":"map","key":{},"value":{}}}}}}}},"UntagLogGroup":{"input":{"type":"structure","required":["logGroupName","tags"],"members":{"logGroupName":{},"tags":{"type":"list","member":{}}}}}},"shapes":{"Se":{"type":"map","key":{},"value":{}},"Sx":{"type":"structure","members":{"destinationName":{},"targetArn":{},"roleArn":{},"accessPolicy":{},"arn":{},"creationTime":{"type":"long"}}},"S1v":{"type":"list","member":{"type":"structure","required":["metricName","metricNamespace","metricValue"],"members":{"metricName":{},"metricNamespace":{},"metricValue":{},"defaultValue":{"type":"double"}}}},"S2a":{"type":"structure","members":{"policyName":{},"policyDocument":{},"lastUpdatedTime":{"type":"long"}}}}}');

});

parcelRequire.register("9whac", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeDestinations":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"destinations"},"DescribeLogGroups":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"logGroups"},"DescribeLogStreams":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"logStreams"},"DescribeMetricFilters":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"metricFilters"},"DescribeSubscriptionFilters":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"subscriptionFilters"},"FilterLogEvents":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":["events","searchedLogStreams"]},"GetLogEvents":{"input_token":"nextToken","limit_key":"limit","output_token":"nextForwardToken","result_key":"events"}}}');

});


parcelRequire.register("5ZkTE", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $45c2dbe676dae51d$var$Service = $dbC7k.Service;
var $45c2dbe676dae51d$var$apiLoader = $dbC7k.apiLoader;
$45c2dbe676dae51d$var$apiLoader.services["codebuild"] = {};
$dbC7k.CodeBuild = $45c2dbe676dae51d$var$Service.defineService("codebuild", [
    "2016-10-06"
]);


Object.defineProperty($45c2dbe676dae51d$var$apiLoader.services["codebuild"], "2016-10-06", {
    get: function get() {
        var model = (parcelRequire("362bt"));
        model.paginators = (parcelRequire("lAGxg")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.CodeBuild;

});
parcelRequire.register("362bt", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-10-06","endpointPrefix":"codebuild","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS CodeBuild","serviceId":"CodeBuild","signatureVersion":"v4","targetPrefix":"CodeBuild_20161006","uid":"codebuild-2016-10-06"},"operations":{"BatchDeleteBuilds":{"input":{"type":"structure","required":["ids"],"members":{"ids":{"shape":"S2"}}},"output":{"type":"structure","members":{"buildsDeleted":{"shape":"S2"},"buildsNotDeleted":{"type":"list","member":{"type":"structure","members":{"id":{},"statusCode":{}}}}}}},"BatchGetBuilds":{"input":{"type":"structure","required":["ids"],"members":{"ids":{"shape":"S2"}}},"output":{"type":"structure","members":{"builds":{"type":"list","member":{"shape":"Sb"}},"buildsNotFound":{"shape":"S2"}}}},"BatchGetProjects":{"input":{"type":"structure","required":["names"],"members":{"names":{"shape":"S1k"}}},"output":{"type":"structure","members":{"projects":{"type":"list","member":{"shape":"S1n"}},"projectsNotFound":{"shape":"S1k"}}}},"CreateProject":{"input":{"type":"structure","required":["name","source","artifacts","environment","serviceRole"],"members":{"name":{},"description":{},"source":{"shape":"Sk"},"secondarySources":{"shape":"Sr"},"sourceVersion":{},"secondarySourceVersions":{"shape":"Ss"},"artifacts":{"shape":"S1q"},"secondaryArtifacts":{"shape":"S1u"},"cache":{"shape":"Sw"},"environment":{"shape":"S10"},"serviceRole":{},"timeoutInMinutes":{"type":"integer"},"queuedTimeoutInMinutes":{"type":"integer"},"encryptionKey":{},"tags":{"shape":"S1w"},"vpcConfig":{"shape":"S1f"},"badgeEnabled":{"type":"boolean"},"logsConfig":{"shape":"S26"}}},"output":{"type":"structure","members":{"project":{"shape":"S1n"}}}},"CreateWebhook":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{},"branchFilter":{},"filterGroups":{"shape":"S21"}}},"output":{"type":"structure","members":{"webhook":{"shape":"S20"}}}},"DeleteProject":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{}}},"DeleteSourceCredentials":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"arn":{}}}},"DeleteWebhook":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{}}},"output":{"type":"structure","members":{}}},"ImportSourceCredentials":{"input":{"type":"structure","required":["token","serverType","authType"],"members":{"username":{},"token":{"type":"string","sensitive":true},"serverType":{},"authType":{},"shouldOverwrite":{"type":"boolean"}}},"output":{"type":"structure","members":{"arn":{}}}},"InvalidateProjectCache":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{}}},"output":{"type":"structure","members":{}}},"ListBuilds":{"input":{"type":"structure","members":{"sortOrder":{},"nextToken":{}}},"output":{"type":"structure","members":{"ids":{"shape":"S2"},"nextToken":{}}}},"ListBuildsForProject":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{},"sortOrder":{},"nextToken":{}}},"output":{"type":"structure","members":{"ids":{"shape":"S2"},"nextToken":{}}}},"ListCuratedEnvironmentImages":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"platforms":{"type":"list","member":{"type":"structure","members":{"platform":{},"languages":{"type":"list","member":{"type":"structure","members":{"language":{},"images":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"versions":{"type":"list","member":{}}}}}}}}}}}}}},"ListProjects":{"input":{"type":"structure","members":{"sortBy":{},"sortOrder":{},"nextToken":{}}},"output":{"type":"structure","members":{"nextToken":{},"projects":{"shape":"S1k"}}}},"ListSourceCredentials":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"sourceCredentialsInfos":{"type":"list","member":{"type":"structure","members":{"arn":{},"serverType":{},"authType":{}}}}}}},"StartBuild":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{},"secondarySourcesOverride":{"shape":"Sr"},"secondarySourcesVersionOverride":{"shape":"Ss"},"sourceVersion":{},"artifactsOverride":{"shape":"S1q"},"secondaryArtifactsOverride":{"shape":"S1u"},"environmentVariablesOverride":{"shape":"S13"},"sourceTypeOverride":{},"sourceLocationOverride":{},"sourceAuthOverride":{"shape":"Sp"},"gitCloneDepthOverride":{"type":"integer"},"gitSubmodulesConfigOverride":{"shape":"Sn"},"buildspecOverride":{},"insecureSslOverride":{"type":"boolean"},"reportBuildStatusOverride":{"type":"boolean"},"environmentTypeOverride":{},"imageOverride":{},"computeTypeOverride":{},"certificateOverride":{},"cacheOverride":{"shape":"Sw"},"serviceRoleOverride":{},"privilegedModeOverride":{"type":"boolean"},"timeoutInMinutesOverride":{"type":"integer"},"queuedTimeoutInMinutesOverride":{"type":"integer"},"idempotencyToken":{},"logsConfigOverride":{"shape":"S26"},"registryCredentialOverride":{"shape":"S16"},"imagePullCredentialsTypeOverride":{}}},"output":{"type":"structure","members":{"build":{"shape":"Sb"}}}},"StopBuild":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{"build":{"shape":"Sb"}}}},"UpdateProject":{"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"source":{"shape":"Sk"},"secondarySources":{"shape":"Sr"},"sourceVersion":{},"secondarySourceVersions":{"shape":"Ss"},"artifacts":{"shape":"S1q"},"secondaryArtifacts":{"shape":"S1u"},"cache":{"shape":"Sw"},"environment":{"shape":"S10"},"serviceRole":{},"timeoutInMinutes":{"type":"integer"},"queuedTimeoutInMinutes":{"type":"integer"},"encryptionKey":{},"tags":{"shape":"S1w"},"vpcConfig":{"shape":"S1f"},"badgeEnabled":{"type":"boolean"},"logsConfig":{"shape":"S26"}}},"output":{"type":"structure","members":{"project":{"shape":"S1n"}}}},"UpdateWebhook":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{},"branchFilter":{},"rotateSecret":{"type":"boolean"},"filterGroups":{"shape":"S21"}}},"output":{"type":"structure","members":{"webhook":{"shape":"S20"}}}}},"shapes":{"S2":{"type":"list","member":{}},"Sb":{"type":"structure","members":{"id":{},"arn":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"currentPhase":{},"buildStatus":{},"sourceVersion":{},"resolvedSourceVersion":{},"projectName":{},"phases":{"type":"list","member":{"type":"structure","members":{"phaseType":{},"phaseStatus":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"durationInSeconds":{"type":"long"},"contexts":{"type":"list","member":{"type":"structure","members":{"statusCode":{},"message":{}}}}}}},"source":{"shape":"Sk"},"secondarySources":{"shape":"Sr"},"secondarySourceVersions":{"shape":"Ss"},"artifacts":{"shape":"Su"},"secondaryArtifacts":{"type":"list","member":{"shape":"Su"}},"cache":{"shape":"Sw"},"environment":{"shape":"S10"},"serviceRole":{},"logs":{"type":"structure","members":{"groupName":{},"streamName":{},"deepLink":{},"s3DeepLink":{},"cloudWatchLogs":{"shape":"S1a"},"s3Logs":{"shape":"S1c"}}},"timeoutInMinutes":{"type":"integer"},"queuedTimeoutInMinutes":{"type":"integer"},"buildComplete":{"type":"boolean"},"initiator":{},"vpcConfig":{"shape":"S1f"},"networkInterface":{"type":"structure","members":{"subnetId":{},"networkInterfaceId":{}}},"encryptionKey":{}}},"Sk":{"type":"structure","required":["type"],"members":{"type":{},"location":{},"gitCloneDepth":{"type":"integer"},"gitSubmodulesConfig":{"shape":"Sn"},"buildspec":{},"auth":{"shape":"Sp"},"reportBuildStatus":{"type":"boolean"},"insecureSsl":{"type":"boolean"},"sourceIdentifier":{}}},"Sn":{"type":"structure","required":["fetchSubmodules"],"members":{"fetchSubmodules":{"type":"boolean"}}},"Sp":{"type":"structure","required":["type"],"members":{"type":{},"resource":{}}},"Sr":{"type":"list","member":{"shape":"Sk"}},"Ss":{"type":"list","member":{"type":"structure","required":["sourceIdentifier","sourceVersion"],"members":{"sourceIdentifier":{},"sourceVersion":{}}}},"Su":{"type":"structure","members":{"location":{},"sha256sum":{},"md5sum":{},"overrideArtifactName":{"type":"boolean"},"encryptionDisabled":{"type":"boolean"},"artifactIdentifier":{}}},"Sw":{"type":"structure","required":["type"],"members":{"type":{},"location":{},"modes":{"type":"list","member":{}}}},"S10":{"type":"structure","required":["type","image","computeType"],"members":{"type":{},"image":{},"computeType":{},"environmentVariables":{"shape":"S13"},"privilegedMode":{"type":"boolean"},"certificate":{},"registryCredential":{"shape":"S16"},"imagePullCredentialsType":{}}},"S13":{"type":"list","member":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{},"type":{}}}},"S16":{"type":"structure","required":["credential","credentialProvider"],"members":{"credential":{},"credentialProvider":{}}},"S1a":{"type":"structure","required":["status"],"members":{"status":{},"groupName":{},"streamName":{}}},"S1c":{"type":"structure","required":["status"],"members":{"status":{},"location":{},"encryptionDisabled":{"type":"boolean"}}},"S1f":{"type":"structure","members":{"vpcId":{},"subnets":{"type":"list","member":{}},"securityGroupIds":{"type":"list","member":{}}}},"S1k":{"type":"list","member":{}},"S1n":{"type":"structure","members":{"name":{},"arn":{},"description":{},"source":{"shape":"Sk"},"secondarySources":{"shape":"Sr"},"sourceVersion":{},"secondarySourceVersions":{"shape":"Ss"},"artifacts":{"shape":"S1q"},"secondaryArtifacts":{"shape":"S1u"},"cache":{"shape":"Sw"},"environment":{"shape":"S10"},"serviceRole":{},"timeoutInMinutes":{"type":"integer"},"queuedTimeoutInMinutes":{"type":"integer"},"encryptionKey":{},"tags":{"shape":"S1w"},"created":{"type":"timestamp"},"lastModified":{"type":"timestamp"},"webhook":{"shape":"S20"},"vpcConfig":{"shape":"S1f"},"badge":{"type":"structure","members":{"badgeEnabled":{"type":"boolean"},"badgeRequestUrl":{}}},"logsConfig":{"shape":"S26"}}},"S1q":{"type":"structure","required":["type"],"members":{"type":{},"location":{},"path":{},"namespaceType":{},"name":{},"packaging":{},"overrideArtifactName":{"type":"boolean"},"encryptionDisabled":{"type":"boolean"},"artifactIdentifier":{}}},"S1u":{"type":"list","member":{"shape":"S1q"}},"S1w":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}}},"S20":{"type":"structure","members":{"url":{},"payloadUrl":{},"secret":{},"branchFilter":{},"filterGroups":{"shape":"S21"},"lastModifiedSecret":{"type":"timestamp"}}},"S21":{"type":"list","member":{"type":"list","member":{"type":"structure","required":["type","pattern"],"members":{"type":{},"pattern":{},"excludeMatchedPattern":{"type":"boolean"}}}}},"S26":{"type":"structure","members":{"cloudWatchLogs":{"shape":"S1a"},"s3Logs":{"shape":"S1c"}}}}}');

});

parcelRequire.register("lAGxg", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("hs4DB", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $cb48a6280c87771a$var$Service = $dbC7k.Service;
var $cb48a6280c87771a$var$apiLoader = $dbC7k.apiLoader;
$cb48a6280c87771a$var$apiLoader.services["codecommit"] = {};
$dbC7k.CodeCommit = $cb48a6280c87771a$var$Service.defineService("codecommit", [
    "2015-04-13"
]);


Object.defineProperty($cb48a6280c87771a$var$apiLoader.services["codecommit"], "2015-04-13", {
    get: function get() {
        var model = (parcelRequire("62sq7"));
        model.paginators = (parcelRequire("7SolJ")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.CodeCommit;

});
parcelRequire.register("62sq7", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-04-13","endpointPrefix":"codecommit","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CodeCommit","serviceFullName":"AWS CodeCommit","serviceId":"CodeCommit","signatureVersion":"v4","targetPrefix":"CodeCommit_20150413","uid":"codecommit-2015-04-13"},"operations":{"BatchDescribeMergeConflicts":{"input":{"type":"structure","required":["repositoryName","destinationCommitSpecifier","sourceCommitSpecifier","mergeOption"],"members":{"repositoryName":{},"destinationCommitSpecifier":{},"sourceCommitSpecifier":{},"mergeOption":{},"maxMergeHunks":{"type":"integer"},"maxConflictFiles":{"type":"integer"},"filePaths":{"type":"list","member":{}},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"nextToken":{}}},"output":{"type":"structure","required":["conflicts","destinationCommitId","sourceCommitId"],"members":{"conflicts":{"type":"list","member":{"type":"structure","members":{"conflictMetadata":{"shape":"Se"},"mergeHunks":{"shape":"St"}}}},"nextToken":{},"errors":{"type":"list","member":{"type":"structure","required":["filePath","exceptionName","message"],"members":{"filePath":{},"exceptionName":{},"message":{}}}},"destinationCommitId":{},"sourceCommitId":{},"baseCommitId":{}}}},"BatchGetCommits":{"input":{"type":"structure","required":["commitIds","repositoryName"],"members":{"commitIds":{"type":"list","member":{}},"repositoryName":{}}},"output":{"type":"structure","members":{"commits":{"type":"list","member":{"shape":"S18"}},"errors":{"type":"list","member":{"type":"structure","members":{"commitId":{},"errorCode":{},"errorMessage":{}}}}}}},"BatchGetRepositories":{"input":{"type":"structure","required":["repositoryNames"],"members":{"repositoryNames":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"repositories":{"type":"list","member":{"shape":"S1n"}},"repositoriesNotFound":{"type":"list","member":{}}}}},"CreateBranch":{"input":{"type":"structure","required":["repositoryName","branchName","commitId"],"members":{"repositoryName":{},"branchName":{},"commitId":{}}}},"CreateCommit":{"input":{"type":"structure","required":["repositoryName","branchName"],"members":{"repositoryName":{},"branchName":{},"parentCommitId":{},"authorName":{},"email":{},"commitMessage":{},"keepEmptyFolders":{"type":"boolean"},"putFiles":{"type":"list","member":{"type":"structure","required":["filePath"],"members":{"filePath":{},"fileMode":{},"fileContent":{"type":"blob"},"sourceFile":{"type":"structure","required":["filePath"],"members":{"filePath":{},"isMove":{"type":"boolean"}}}}}},"deleteFiles":{"shape":"S27"},"setFileModes":{"shape":"S29"}}},"output":{"type":"structure","members":{"commitId":{},"treeId":{},"filesAdded":{"shape":"S2c"},"filesUpdated":{"shape":"S2c"},"filesDeleted":{"shape":"S2c"}}}},"CreatePullRequest":{"input":{"type":"structure","required":["title","targets"],"members":{"title":{},"description":{},"targets":{"type":"list","member":{"type":"structure","required":["repositoryName","sourceReference"],"members":{"repositoryName":{},"sourceReference":{},"destinationReference":{}}}},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"S2m"}}}},"CreateRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"repositoryDescription":{},"tags":{"shape":"S2u"}}},"output":{"type":"structure","members":{"repositoryMetadata":{"shape":"S1n"}}}},"CreateUnreferencedMergeCommit":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier","mergeOption"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"mergeOption":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"authorName":{},"email":{},"commitMessage":{},"keepEmptyFolders":{"type":"boolean"},"conflictResolution":{"shape":"S2z"}}},"output":{"type":"structure","members":{"commitId":{},"treeId":{}}}},"DeleteBranch":{"input":{"type":"structure","required":["repositoryName","branchName"],"members":{"repositoryName":{},"branchName":{}}},"output":{"type":"structure","members":{"deletedBranch":{"shape":"S36"}}}},"DeleteCommentContent":{"input":{"type":"structure","required":["commentId"],"members":{"commentId":{}}},"output":{"type":"structure","members":{"comment":{"shape":"S3a"}}}},"DeleteFile":{"input":{"type":"structure","required":["repositoryName","branchName","filePath","parentCommitId"],"members":{"repositoryName":{},"branchName":{},"filePath":{},"parentCommitId":{},"keepEmptyFolders":{"type":"boolean"},"commitMessage":{},"name":{},"email":{}}},"output":{"type":"structure","required":["commitId","blobId","treeId","filePath"],"members":{"commitId":{},"blobId":{},"treeId":{},"filePath":{}}}},"DeleteRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{}}},"output":{"type":"structure","members":{"repositoryId":{}}}},"DescribeMergeConflicts":{"input":{"type":"structure","required":["repositoryName","destinationCommitSpecifier","sourceCommitSpecifier","mergeOption","filePath"],"members":{"repositoryName":{},"destinationCommitSpecifier":{},"sourceCommitSpecifier":{},"mergeOption":{},"maxMergeHunks":{"type":"integer"},"filePath":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"nextToken":{}}},"output":{"type":"structure","required":["conflictMetadata","mergeHunks","destinationCommitId","sourceCommitId"],"members":{"conflictMetadata":{"shape":"Se"},"mergeHunks":{"shape":"St"},"nextToken":{},"destinationCommitId":{},"sourceCommitId":{},"baseCommitId":{}}}},"DescribePullRequestEvents":{"input":{"type":"structure","required":["pullRequestId"],"members":{"pullRequestId":{},"pullRequestEventType":{},"actorArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["pullRequestEvents"],"members":{"pullRequestEvents":{"type":"list","member":{"type":"structure","members":{"pullRequestId":{},"eventDate":{"type":"timestamp"},"pullRequestEventType":{},"actorArn":{},"pullRequestCreatedEventMetadata":{"type":"structure","members":{"repositoryName":{},"sourceCommitId":{},"destinationCommitId":{},"mergeBase":{}}},"pullRequestStatusChangedEventMetadata":{"type":"structure","members":{"pullRequestStatus":{}}},"pullRequestSourceReferenceUpdatedEventMetadata":{"type":"structure","members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"mergeBase":{}}},"pullRequestMergedStateChangedEventMetadata":{"type":"structure","members":{"repositoryName":{},"destinationReference":{},"mergeMetadata":{"shape":"S2r"}}}}}},"nextToken":{}}}},"GetBlob":{"input":{"type":"structure","required":["repositoryName","blobId"],"members":{"repositoryName":{},"blobId":{}}},"output":{"type":"structure","required":["content"],"members":{"content":{"type":"blob"}}}},"GetBranch":{"input":{"type":"structure","members":{"repositoryName":{},"branchName":{}}},"output":{"type":"structure","members":{"branch":{"shape":"S36"}}}},"GetComment":{"input":{"type":"structure","required":["commentId"],"members":{"commentId":{}}},"output":{"type":"structure","members":{"comment":{"shape":"S3a"}}}},"GetCommentsForComparedCommit":{"input":{"type":"structure","required":["repositoryName","afterCommitId"],"members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"commentsForComparedCommitData":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"beforeBlobId":{},"afterBlobId":{},"location":{"shape":"S44"},"comments":{"shape":"S47"}}}},"nextToken":{}}}},"GetCommentsForPullRequest":{"input":{"type":"structure","required":["pullRequestId"],"members":{"pullRequestId":{},"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"commentsForPullRequestData":{"type":"list","member":{"type":"structure","members":{"pullRequestId":{},"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"beforeBlobId":{},"afterBlobId":{},"location":{"shape":"S44"},"comments":{"shape":"S47"}}}},"nextToken":{}}}},"GetCommit":{"input":{"type":"structure","required":["repositoryName","commitId"],"members":{"repositoryName":{},"commitId":{}}},"output":{"type":"structure","required":["commit"],"members":{"commit":{"shape":"S18"}}}},"GetDifferences":{"input":{"type":"structure","required":["repositoryName","afterCommitSpecifier"],"members":{"repositoryName":{},"beforeCommitSpecifier":{},"afterCommitSpecifier":{},"beforePath":{},"afterPath":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"differences":{"type":"list","member":{"type":"structure","members":{"beforeBlob":{"shape":"S4j"},"afterBlob":{"shape":"S4j"},"changeType":{}}}},"NextToken":{}}}},"GetFile":{"input":{"type":"structure","required":["repositoryName","filePath"],"members":{"repositoryName":{},"commitSpecifier":{},"filePath":{}}},"output":{"type":"structure","required":["commitId","blobId","filePath","fileMode","fileSize","fileContent"],"members":{"commitId":{},"blobId":{},"filePath":{},"fileMode":{},"fileSize":{"type":"long"},"fileContent":{"type":"blob"}}}},"GetFolder":{"input":{"type":"structure","required":["repositoryName","folderPath"],"members":{"repositoryName":{},"commitSpecifier":{},"folderPath":{}}},"output":{"type":"structure","required":["commitId","folderPath"],"members":{"commitId":{},"folderPath":{},"treeId":{},"subFolders":{"type":"list","member":{"type":"structure","members":{"treeId":{},"absolutePath":{},"relativePath":{}}}},"files":{"type":"list","member":{"type":"structure","members":{"blobId":{},"absolutePath":{},"relativePath":{},"fileMode":{}}}},"symbolicLinks":{"type":"list","member":{"type":"structure","members":{"blobId":{},"absolutePath":{},"relativePath":{},"fileMode":{}}}},"subModules":{"type":"list","member":{"type":"structure","members":{"commitId":{},"absolutePath":{},"relativePath":{}}}}}}},"GetMergeCommit":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{}}},"output":{"type":"structure","members":{"sourceCommitId":{},"destinationCommitId":{},"baseCommitId":{},"mergedCommitId":{}}}},"GetMergeConflicts":{"input":{"type":"structure","required":["repositoryName","destinationCommitSpecifier","sourceCommitSpecifier","mergeOption"],"members":{"repositoryName":{},"destinationCommitSpecifier":{},"sourceCommitSpecifier":{},"mergeOption":{},"conflictDetailLevel":{},"maxConflictFiles":{"type":"integer"},"conflictResolutionStrategy":{},"nextToken":{}}},"output":{"type":"structure","required":["mergeable","destinationCommitId","sourceCommitId","conflictMetadataList"],"members":{"mergeable":{"type":"boolean"},"destinationCommitId":{},"sourceCommitId":{},"baseCommitId":{},"conflictMetadataList":{"type":"list","member":{"shape":"Se"}},"nextToken":{}}}},"GetMergeOptions":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{}}},"output":{"type":"structure","required":["mergeOptions","sourceCommitId","destinationCommitId","baseCommitId"],"members":{"mergeOptions":{"type":"list","member":{}},"sourceCommitId":{},"destinationCommitId":{},"baseCommitId":{}}}},"GetPullRequest":{"input":{"type":"structure","required":["pullRequestId"],"members":{"pullRequestId":{}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"S2m"}}}},"GetRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{}}},"output":{"type":"structure","members":{"repositoryMetadata":{"shape":"S1n"}}}},"GetRepositoryTriggers":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{}}},"output":{"type":"structure","members":{"configurationId":{},"triggers":{"shape":"S5e"}}}},"ListBranches":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"nextToken":{}}},"output":{"type":"structure","members":{"branches":{"shape":"S5i"},"nextToken":{}}}},"ListPullRequests":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"authorArn":{},"pullRequestStatus":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["pullRequestIds"],"members":{"pullRequestIds":{"type":"list","member":{}},"nextToken":{}}}},"ListRepositories":{"input":{"type":"structure","members":{"nextToken":{},"sortBy":{},"order":{}}},"output":{"type":"structure","members":{"repositories":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"repositoryId":{}}}},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{},"nextToken":{}}},"output":{"type":"structure","members":{"tags":{"shape":"S2u"},"nextToken":{}}}},"MergeBranchesByFastForward":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"targetBranch":{}}},"output":{"type":"structure","members":{"commitId":{},"treeId":{}}}},"MergeBranchesBySquash":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"targetBranch":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"authorName":{},"email":{},"commitMessage":{},"keepEmptyFolders":{"type":"boolean"},"conflictResolution":{"shape":"S2z"}}},"output":{"type":"structure","members":{"commitId":{},"treeId":{}}}},"MergeBranchesByThreeWay":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"targetBranch":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"authorName":{},"email":{},"commitMessage":{},"keepEmptyFolders":{"type":"boolean"},"conflictResolution":{"shape":"S2z"}}},"output":{"type":"structure","members":{"commitId":{},"treeId":{}}}},"MergePullRequestByFastForward":{"input":{"type":"structure","required":["pullRequestId","repositoryName"],"members":{"pullRequestId":{},"repositoryName":{},"sourceCommitId":{}}},"output":{"type":"structure","members":{"pullRequest":{"shape":"S2m"}}}},"MergePullRequestBySquash":{"input":{"type":"structure","required":["pullRequestId","repositoryName"],"members":{"pullRequestId":{},"repositoryName":{},"sourceCommitId":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"commitMessage":{},"authorName":{},"email":{},"keepEmptyFolders":{"type":"boolean"},"conflictResolution":{"shape":"S2z"}}},"output":{"type":"structure","members":{"pullRequest":{"shape":"S2m"}}}},"MergePullRequestByThreeWay":{"input":{"type":"structure","required":["pullRequestId","repositoryName"],"members":{"pullRequestId":{},"repositoryName":{},"sourceCommitId":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"commitMessage":{},"authorName":{},"email":{},"keepEmptyFolders":{"type":"boolean"},"conflictResolution":{"shape":"S2z"}}},"output":{"type":"structure","members":{"pullRequest":{"shape":"S2m"}}}},"PostCommentForComparedCommit":{"input":{"type":"structure","required":["repositoryName","afterCommitId","content"],"members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"location":{"shape":"S44"},"content":{},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"beforeBlobId":{},"afterBlobId":{},"location":{"shape":"S44"},"comment":{"shape":"S3a"}}},"idempotent":true},"PostCommentForPullRequest":{"input":{"type":"structure","required":["pullRequestId","repositoryName","beforeCommitId","afterCommitId","content"],"members":{"pullRequestId":{},"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"location":{"shape":"S44"},"content":{},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"repositoryName":{},"pullRequestId":{},"beforeCommitId":{},"afterCommitId":{},"beforeBlobId":{},"afterBlobId":{},"location":{"shape":"S44"},"comment":{"shape":"S3a"}}},"idempotent":true},"PostCommentReply":{"input":{"type":"structure","required":["inReplyTo","content"],"members":{"inReplyTo":{},"clientRequestToken":{"idempotencyToken":true},"content":{}}},"output":{"type":"structure","members":{"comment":{"shape":"S3a"}}},"idempotent":true},"PutFile":{"input":{"type":"structure","required":["repositoryName","branchName","fileContent","filePath"],"members":{"repositoryName":{},"branchName":{},"fileContent":{"type":"blob"},"filePath":{},"fileMode":{},"parentCommitId":{},"commitMessage":{},"name":{},"email":{}}},"output":{"type":"structure","required":["commitId","blobId","treeId"],"members":{"commitId":{},"blobId":{},"treeId":{}}}},"PutRepositoryTriggers":{"input":{"type":"structure","required":["repositoryName","triggers"],"members":{"repositoryName":{},"triggers":{"shape":"S5e"}}},"output":{"type":"structure","members":{"configurationId":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S2u"}}}},"TestRepositoryTriggers":{"input":{"type":"structure","required":["repositoryName","triggers"],"members":{"repositoryName":{},"triggers":{"shape":"S5e"}}},"output":{"type":"structure","members":{"successfulExecutions":{"type":"list","member":{}},"failedExecutions":{"type":"list","member":{"type":"structure","members":{"trigger":{},"failureMessage":{}}}}}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}}},"UpdateComment":{"input":{"type":"structure","required":["commentId","content"],"members":{"commentId":{},"content":{}}},"output":{"type":"structure","members":{"comment":{"shape":"S3a"}}}},"UpdateDefaultBranch":{"input":{"type":"structure","required":["repositoryName","defaultBranchName"],"members":{"repositoryName":{},"defaultBranchName":{}}}},"UpdatePullRequestDescription":{"input":{"type":"structure","required":["pullRequestId","description"],"members":{"pullRequestId":{},"description":{}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"S2m"}}}},"UpdatePullRequestStatus":{"input":{"type":"structure","required":["pullRequestId","pullRequestStatus"],"members":{"pullRequestId":{},"pullRequestStatus":{}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"S2m"}}}},"UpdatePullRequestTitle":{"input":{"type":"structure","required":["pullRequestId","title"],"members":{"pullRequestId":{},"title":{}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"S2m"}}}},"UpdateRepositoryDescription":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"repositoryDescription":{}}}},"UpdateRepositoryName":{"input":{"type":"structure","required":["oldName","newName"],"members":{"oldName":{},"newName":{}}}}},"shapes":{"Se":{"type":"structure","members":{"filePath":{},"fileSizes":{"type":"structure","members":{"source":{"type":"long"},"destination":{"type":"long"},"base":{"type":"long"}}},"fileModes":{"type":"structure","members":{"source":{},"destination":{},"base":{}}},"objectTypes":{"type":"structure","members":{"source":{},"destination":{},"base":{}}},"numberOfConflicts":{"type":"integer"},"isBinaryFile":{"type":"structure","members":{"source":{"type":"boolean"},"destination":{"type":"boolean"},"base":{"type":"boolean"}}},"contentConflict":{"type":"boolean"},"fileModeConflict":{"type":"boolean"},"objectTypeConflict":{"type":"boolean"},"mergeOperations":{"type":"structure","members":{"source":{},"destination":{}}}}},"St":{"type":"list","member":{"type":"structure","members":{"isConflict":{"type":"boolean"},"source":{"shape":"Sw"},"destination":{"shape":"Sw"},"base":{"shape":"Sw"}}}},"Sw":{"type":"structure","members":{"startLine":{"type":"integer"},"endLine":{"type":"integer"},"hunkContent":{}}},"S18":{"type":"structure","members":{"commitId":{},"treeId":{},"parents":{"type":"list","member":{}},"message":{},"author":{"shape":"S1a"},"committer":{"shape":"S1a"},"additionalData":{}}},"S1a":{"type":"structure","members":{"name":{},"email":{},"date":{}}},"S1n":{"type":"structure","members":{"accountId":{},"repositoryId":{},"repositoryName":{},"repositoryDescription":{},"defaultBranch":{},"lastModifiedDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"},"cloneUrlHttp":{},"cloneUrlSsh":{},"Arn":{}}},"S27":{"type":"list","member":{"type":"structure","required":["filePath"],"members":{"filePath":{}}}},"S29":{"type":"list","member":{"type":"structure","required":["filePath","fileMode"],"members":{"filePath":{},"fileMode":{}}}},"S2c":{"type":"list","member":{"type":"structure","members":{"absolutePath":{},"blobId":{},"fileMode":{}}}},"S2m":{"type":"structure","members":{"pullRequestId":{},"title":{},"description":{},"lastActivityDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"},"pullRequestStatus":{},"authorArn":{},"pullRequestTargets":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"sourceReference":{},"destinationReference":{},"destinationCommit":{},"sourceCommit":{},"mergeBase":{},"mergeMetadata":{"shape":"S2r"}}}},"clientRequestToken":{}}},"S2r":{"type":"structure","members":{"isMerged":{"type":"boolean"},"mergedBy":{},"mergeCommitId":{},"mergeOption":{}}},"S2u":{"type":"map","key":{},"value":{}},"S2z":{"type":"structure","members":{"replaceContents":{"type":"list","member":{"type":"structure","required":["filePath","replacementType"],"members":{"filePath":{},"replacementType":{},"content":{"type":"blob"},"fileMode":{}}}},"deleteFiles":{"shape":"S27"},"setFileModes":{"shape":"S29"}}},"S36":{"type":"structure","members":{"branchName":{},"commitId":{}}},"S3a":{"type":"structure","members":{"commentId":{},"content":{},"inReplyTo":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"authorArn":{},"deleted":{"type":"boolean"},"clientRequestToken":{}}},"S44":{"type":"structure","members":{"filePath":{},"filePosition":{"type":"long"},"relativeFileVersion":{}}},"S47":{"type":"list","member":{"shape":"S3a"}},"S4j":{"type":"structure","members":{"blobId":{},"path":{},"mode":{}}},"S5e":{"type":"list","member":{"type":"structure","required":["name","destinationArn","events"],"members":{"name":{},"destinationArn":{},"customData":{},"branches":{"shape":"S5i"},"events":{"type":"list","member":{}}}}},"S5i":{"type":"list","member":{}}}}');

});

parcelRequire.register("7SolJ", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeMergeConflicts":{"input_token":"nextToken","limit_key":"maxMergeHunks","output_token":"nextToken"},"DescribePullRequestEvents":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"GetCommentsForComparedCommit":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"GetCommentsForPullRequest":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"GetDifferences":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetMergeConflicts":{"input_token":"nextToken","limit_key":"maxConflictFiles","output_token":"nextToken"},"ListBranches":{"input_token":"nextToken","output_token":"nextToken","result_key":"branches"},"ListPullRequests":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"ListRepositories":{"input_token":"nextToken","output_token":"nextToken","result_key":"repositories"}}}');

});


parcelRequire.register("j6UGC", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $de9a8c9ea43bb508$var$Service = $dbC7k.Service;
var $de9a8c9ea43bb508$var$apiLoader = $dbC7k.apiLoader;
$de9a8c9ea43bb508$var$apiLoader.services["codedeploy"] = {};
$dbC7k.CodeDeploy = $de9a8c9ea43bb508$var$Service.defineService("codedeploy", [
    "2014-10-06"
]);



Object.defineProperty($de9a8c9ea43bb508$var$apiLoader.services["codedeploy"], "2014-10-06", {
    get: function get() {
        var model = (parcelRequire("4O8tn"));
        model.paginators = (parcelRequire("ljweG")).pagination;
        model.waiters = (parcelRequire("3I6WL")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.CodeDeploy;

});
parcelRequire.register("4O8tn", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2014-10-06","endpointPrefix":"codedeploy","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CodeDeploy","serviceFullName":"AWS CodeDeploy","serviceId":"CodeDeploy","signatureVersion":"v4","targetPrefix":"CodeDeploy_20141006","uid":"codedeploy-2014-10-06"},"operations":{"AddTagsToOnPremisesInstances":{"input":{"type":"structure","required":["tags","instanceNames"],"members":{"tags":{"shape":"S2"},"instanceNames":{"shape":"S6"}}}},"BatchGetApplicationRevisions":{"input":{"type":"structure","required":["applicationName","revisions"],"members":{"applicationName":{},"revisions":{"shape":"Sa"}}},"output":{"type":"structure","members":{"applicationName":{},"errorMessage":{},"revisions":{"type":"list","member":{"type":"structure","members":{"revisionLocation":{"shape":"Sb"},"genericRevisionInfo":{"shape":"Su"}}}}}}},"BatchGetApplications":{"input":{"type":"structure","required":["applicationNames"],"members":{"applicationNames":{"shape":"S10"}}},"output":{"type":"structure","members":{"applicationsInfo":{"type":"list","member":{"shape":"S13"}}}}},"BatchGetDeploymentGroups":{"input":{"type":"structure","required":["applicationName","deploymentGroupNames"],"members":{"applicationName":{},"deploymentGroupNames":{"shape":"Sw"}}},"output":{"type":"structure","members":{"deploymentGroupsInfo":{"type":"list","member":{"shape":"S1b"}},"errorMessage":{}}}},"BatchGetDeploymentInstances":{"input":{"type":"structure","required":["deploymentId","instanceIds"],"members":{"deploymentId":{},"instanceIds":{"shape":"S31"}}},"output":{"type":"structure","members":{"instancesSummary":{"type":"list","member":{"shape":"S35"}},"errorMessage":{}}},"deprecated":true,"deprecatedMessage":"This operation is deprecated, use BatchGetDeploymentTargets instead."},"BatchGetDeploymentTargets":{"input":{"type":"structure","members":{"deploymentId":{},"targetIds":{"shape":"S3i"}}},"output":{"type":"structure","members":{"deploymentTargets":{"type":"list","member":{"shape":"S3m"}}}}},"BatchGetDeployments":{"input":{"type":"structure","required":["deploymentIds"],"members":{"deploymentIds":{"shape":"S46"}}},"output":{"type":"structure","members":{"deploymentsInfo":{"type":"list","member":{"shape":"S49"}}}}},"BatchGetOnPremisesInstances":{"input":{"type":"structure","required":["instanceNames"],"members":{"instanceNames":{"shape":"S6"}}},"output":{"type":"structure","members":{"instanceInfos":{"type":"list","member":{"shape":"S4o"}}}}},"ContinueDeployment":{"input":{"type":"structure","members":{"deploymentId":{},"deploymentWaitType":{}}}},"CreateApplication":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"computePlatform":{},"tags":{"shape":"S2"}}},"output":{"type":"structure","members":{"applicationId":{}}}},"CreateDeployment":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"deploymentGroupName":{},"revision":{"shape":"Sb"},"deploymentConfigName":{},"description":{},"ignoreApplicationStopFailures":{"type":"boolean"},"targetInstances":{"shape":"S4g"},"autoRollbackConfiguration":{"shape":"S1z"},"updateOutdatedInstancesOnly":{"type":"boolean"},"fileExistsBehavior":{}}},"output":{"type":"structure","members":{"deploymentId":{}}}},"CreateDeploymentConfig":{"input":{"type":"structure","required":["deploymentConfigName"],"members":{"deploymentConfigName":{},"minimumHealthyHosts":{"shape":"S4z"},"trafficRoutingConfig":{"shape":"S52"},"computePlatform":{}}},"output":{"type":"structure","members":{"deploymentConfigId":{}}}},"CreateDeploymentGroup":{"input":{"type":"structure","required":["applicationName","deploymentGroupName","serviceRoleArn"],"members":{"applicationName":{},"deploymentGroupName":{},"deploymentConfigName":{},"ec2TagFilters":{"shape":"S1e"},"onPremisesInstanceTagFilters":{"shape":"S1h"},"autoScalingGroups":{"shape":"S4h"},"serviceRoleArn":{},"triggerConfigurations":{"shape":"S1p"},"alarmConfiguration":{"shape":"S1v"},"autoRollbackConfiguration":{"shape":"S1z"},"deploymentStyle":{"shape":"S22"},"blueGreenDeploymentConfiguration":{"shape":"S25"},"loadBalancerInfo":{"shape":"S2d"},"ec2TagSet":{"shape":"S2s"},"ecsServices":{"shape":"S2w"},"onPremisesTagSet":{"shape":"S2u"},"tags":{"shape":"S2"}}},"output":{"type":"structure","members":{"deploymentGroupId":{}}}},"DeleteApplication":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{}}}},"DeleteDeploymentConfig":{"input":{"type":"structure","required":["deploymentConfigName"],"members":{"deploymentConfigName":{}}}},"DeleteDeploymentGroup":{"input":{"type":"structure","required":["applicationName","deploymentGroupName"],"members":{"applicationName":{},"deploymentGroupName":{}}},"output":{"type":"structure","members":{"hooksNotCleanedUp":{"shape":"S1k"}}}},"DeleteGitHubAccountToken":{"input":{"type":"structure","members":{"tokenName":{}}},"output":{"type":"structure","members":{"tokenName":{}}}},"DeregisterOnPremisesInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}}},"GetApplication":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{}}},"output":{"type":"structure","members":{"application":{"shape":"S13"}}}},"GetApplicationRevision":{"input":{"type":"structure","required":["applicationName","revision"],"members":{"applicationName":{},"revision":{"shape":"Sb"}}},"output":{"type":"structure","members":{"applicationName":{},"revision":{"shape":"Sb"},"revisionInfo":{"shape":"Su"}}}},"GetDeployment":{"input":{"type":"structure","required":["deploymentId"],"members":{"deploymentId":{}}},"output":{"type":"structure","members":{"deploymentInfo":{"shape":"S49"}}}},"GetDeploymentConfig":{"input":{"type":"structure","required":["deploymentConfigName"],"members":{"deploymentConfigName":{}}},"output":{"type":"structure","members":{"deploymentConfigInfo":{"type":"structure","members":{"deploymentConfigId":{},"deploymentConfigName":{},"minimumHealthyHosts":{"shape":"S4z"},"createTime":{"type":"timestamp"},"computePlatform":{},"trafficRoutingConfig":{"shape":"S52"}}}}}},"GetDeploymentGroup":{"input":{"type":"structure","required":["applicationName","deploymentGroupName"],"members":{"applicationName":{},"deploymentGroupName":{}}},"output":{"type":"structure","members":{"deploymentGroupInfo":{"shape":"S1b"}}}},"GetDeploymentInstance":{"input":{"type":"structure","required":["deploymentId","instanceId"],"members":{"deploymentId":{},"instanceId":{}}},"output":{"type":"structure","members":{"instanceSummary":{"shape":"S35"}}},"deprecated":true,"deprecatedMessage":"This operation is deprecated, use GetDeploymentTarget instead."},"GetDeploymentTarget":{"input":{"type":"structure","members":{"deploymentId":{},"targetId":{}}},"output":{"type":"structure","members":{"deploymentTarget":{"shape":"S3m"}}}},"GetOnPremisesInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}},"output":{"type":"structure","members":{"instanceInfo":{"shape":"S4o"}}}},"ListApplicationRevisions":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"sortBy":{},"sortOrder":{},"s3Bucket":{},"s3KeyPrefix":{},"deployed":{},"nextToken":{}}},"output":{"type":"structure","members":{"revisions":{"shape":"Sa"},"nextToken":{}}}},"ListApplications":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"applications":{"shape":"S10"},"nextToken":{}}}},"ListDeploymentConfigs":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"deploymentConfigsList":{"type":"list","member":{}},"nextToken":{}}}},"ListDeploymentGroups":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"nextToken":{}}},"output":{"type":"structure","members":{"applicationName":{},"deploymentGroups":{"shape":"Sw"},"nextToken":{}}}},"ListDeploymentInstances":{"input":{"type":"structure","required":["deploymentId"],"members":{"deploymentId":{},"nextToken":{},"instanceStatusFilter":{"type":"list","member":{"shape":"S36"}},"instanceTypeFilter":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"instancesList":{"shape":"S31"},"nextToken":{}}},"deprecated":true,"deprecatedMessage":"This operation is deprecated, use ListDeploymentTargets instead."},"ListDeploymentTargets":{"input":{"type":"structure","members":{"deploymentId":{},"nextToken":{},"targetFilters":{"type":"map","key":{},"value":{"type":"list","member":{}}}}},"output":{"type":"structure","members":{"targetIds":{"shape":"S3i"},"nextToken":{}}}},"ListDeployments":{"input":{"type":"structure","members":{"applicationName":{},"deploymentGroupName":{},"includeOnlyStatuses":{"type":"list","member":{}},"createTimeRange":{"type":"structure","members":{"start":{"type":"timestamp"},"end":{"type":"timestamp"}}},"nextToken":{}}},"output":{"type":"structure","members":{"deployments":{"shape":"S46"},"nextToken":{}}}},"ListGitHubAccountTokenNames":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"tokenNameList":{"type":"list","member":{}},"nextToken":{}}}},"ListOnPremisesInstances":{"input":{"type":"structure","members":{"registrationStatus":{},"tagFilters":{"shape":"S1h"},"nextToken":{}}},"output":{"type":"structure","members":{"instanceNames":{"shape":"S6"},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S2"},"NextToken":{}}}},"PutLifecycleEventHookExecutionStatus":{"input":{"type":"structure","members":{"deploymentId":{},"lifecycleEventHookExecutionId":{},"status":{}}},"output":{"type":"structure","members":{"lifecycleEventHookExecutionId":{}}}},"RegisterApplicationRevision":{"input":{"type":"structure","required":["applicationName","revision"],"members":{"applicationName":{},"description":{},"revision":{"shape":"Sb"}}}},"RegisterOnPremisesInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{},"iamSessionArn":{},"iamUserArn":{}}}},"RemoveTagsFromOnPremisesInstances":{"input":{"type":"structure","required":["tags","instanceNames"],"members":{"tags":{"shape":"S2"},"instanceNames":{"shape":"S6"}}}},"SkipWaitTimeForInstanceTermination":{"input":{"type":"structure","members":{"deploymentId":{}}},"deprecated":true,"deprecatedMessage":"This operation is deprecated, use ContinueDeployment with DeploymentWaitType instead."},"StopDeployment":{"input":{"type":"structure","required":["deploymentId"],"members":{"deploymentId":{},"autoRollbackEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"status":{},"statusMessage":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S2"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateApplication":{"input":{"type":"structure","members":{"applicationName":{},"newApplicationName":{}}}},"UpdateDeploymentGroup":{"input":{"type":"structure","required":["applicationName","currentDeploymentGroupName"],"members":{"applicationName":{},"currentDeploymentGroupName":{},"newDeploymentGroupName":{},"deploymentConfigName":{},"ec2TagFilters":{"shape":"S1e"},"onPremisesInstanceTagFilters":{"shape":"S1h"},"autoScalingGroups":{"shape":"S4h"},"serviceRoleArn":{},"triggerConfigurations":{"shape":"S1p"},"alarmConfiguration":{"shape":"S1v"},"autoRollbackConfiguration":{"shape":"S1z"},"deploymentStyle":{"shape":"S22"},"blueGreenDeploymentConfiguration":{"shape":"S25"},"loadBalancerInfo":{"shape":"S2d"},"ec2TagSet":{"shape":"S2s"},"ecsServices":{"shape":"S2w"},"onPremisesTagSet":{"shape":"S2u"}}},"output":{"type":"structure","members":{"hooksNotCleanedUp":{"shape":"S1k"}}}}},"shapes":{"S2":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S6":{"type":"list","member":{}},"Sa":{"type":"list","member":{"shape":"Sb"}},"Sb":{"type":"structure","members":{"revisionType":{},"s3Location":{"type":"structure","members":{"bucket":{},"key":{},"bundleType":{},"version":{},"eTag":{}}},"gitHubLocation":{"type":"structure","members":{"repository":{},"commitId":{}}},"string":{"type":"structure","members":{"content":{},"sha256":{}},"deprecated":true,"deprecatedMessage":"RawString and String revision type are deprecated, use AppSpecContent type instead."},"appSpecContent":{"type":"structure","members":{"content":{},"sha256":{}}}}},"Su":{"type":"structure","members":{"description":{},"deploymentGroups":{"shape":"Sw"},"firstUsedTime":{"type":"timestamp"},"lastUsedTime":{"type":"timestamp"},"registerTime":{"type":"timestamp"}}},"Sw":{"type":"list","member":{}},"S10":{"type":"list","member":{}},"S13":{"type":"structure","members":{"applicationId":{},"applicationName":{},"createTime":{"type":"timestamp"},"linkedToGitHub":{"type":"boolean"},"gitHubAccountName":{},"computePlatform":{}}},"S1b":{"type":"structure","members":{"applicationName":{},"deploymentGroupId":{},"deploymentGroupName":{},"deploymentConfigName":{},"ec2TagFilters":{"shape":"S1e"},"onPremisesInstanceTagFilters":{"shape":"S1h"},"autoScalingGroups":{"shape":"S1k"},"serviceRoleArn":{},"targetRevision":{"shape":"Sb"},"triggerConfigurations":{"shape":"S1p"},"alarmConfiguration":{"shape":"S1v"},"autoRollbackConfiguration":{"shape":"S1z"},"deploymentStyle":{"shape":"S22"},"blueGreenDeploymentConfiguration":{"shape":"S25"},"loadBalancerInfo":{"shape":"S2d"},"lastSuccessfulDeployment":{"shape":"S2p"},"lastAttemptedDeployment":{"shape":"S2p"},"ec2TagSet":{"shape":"S2s"},"onPremisesTagSet":{"shape":"S2u"},"computePlatform":{},"ecsServices":{"shape":"S2w"}}},"S1e":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"Type":{}}}},"S1h":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"Type":{}}}},"S1k":{"type":"list","member":{"type":"structure","members":{"name":{},"hook":{}}}},"S1p":{"type":"list","member":{"type":"structure","members":{"triggerName":{},"triggerTargetArn":{},"triggerEvents":{"type":"list","member":{}}}}},"S1v":{"type":"structure","members":{"enabled":{"type":"boolean"},"ignorePollAlarmFailure":{"type":"boolean"},"alarms":{"type":"list","member":{"type":"structure","members":{"name":{}}}}}},"S1z":{"type":"structure","members":{"enabled":{"type":"boolean"},"events":{"type":"list","member":{}}}},"S22":{"type":"structure","members":{"deploymentType":{},"deploymentOption":{}}},"S25":{"type":"structure","members":{"terminateBlueInstancesOnDeploymentSuccess":{"type":"structure","members":{"action":{},"terminationWaitTimeInMinutes":{"type":"integer"}}},"deploymentReadyOption":{"type":"structure","members":{"actionOnTimeout":{},"waitTimeInMinutes":{"type":"integer"}}},"greenFleetProvisioningOption":{"type":"structure","members":{"action":{}}}}},"S2d":{"type":"structure","members":{"elbInfoList":{"type":"list","member":{"type":"structure","members":{"name":{}}}},"targetGroupInfoList":{"shape":"S2h"},"targetGroupPairInfoList":{"type":"list","member":{"type":"structure","members":{"targetGroups":{"shape":"S2h"},"prodTrafficRoute":{"shape":"S2m"},"testTrafficRoute":{"shape":"S2m"}}}}}},"S2h":{"type":"list","member":{"shape":"S2i"}},"S2i":{"type":"structure","members":{"name":{}}},"S2m":{"type":"structure","members":{"listenerArns":{"type":"list","member":{}}}},"S2p":{"type":"structure","members":{"deploymentId":{},"status":{},"endTime":{"type":"timestamp"},"createTime":{"type":"timestamp"}}},"S2s":{"type":"structure","members":{"ec2TagSetList":{"type":"list","member":{"shape":"S1e"}}}},"S2u":{"type":"structure","members":{"onPremisesTagSetList":{"type":"list","member":{"shape":"S1h"}}}},"S2w":{"type":"list","member":{"type":"structure","members":{"serviceName":{},"clusterName":{}}}},"S31":{"type":"list","member":{}},"S35":{"type":"structure","members":{"deploymentId":{},"instanceId":{},"status":{"shape":"S36"},"lastUpdatedAt":{"type":"timestamp"},"lifecycleEvents":{"shape":"S37"},"instanceType":{}},"deprecated":true,"deprecatedMessage":"InstanceSummary is deprecated, use DeploymentTarget instead."},"S36":{"type":"string","deprecated":true,"deprecatedMessage":"InstanceStatus is deprecated, use TargetStatus instead."},"S37":{"type":"list","member":{"type":"structure","members":{"lifecycleEventName":{},"diagnostics":{"type":"structure","members":{"errorCode":{},"scriptName":{},"message":{},"logTail":{}}},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"status":{}}}},"S3i":{"type":"list","member":{}},"S3m":{"type":"structure","members":{"deploymentTargetType":{},"instanceTarget":{"type":"structure","members":{"deploymentId":{},"targetId":{},"targetArn":{},"status":{},"lastUpdatedAt":{"type":"timestamp"},"lifecycleEvents":{"shape":"S37"},"instanceLabel":{}}},"lambdaTarget":{"type":"structure","members":{"deploymentId":{},"targetId":{},"targetArn":{},"status":{},"lastUpdatedAt":{"type":"timestamp"},"lifecycleEvents":{"shape":"S37"},"lambdaFunctionInfo":{"type":"structure","members":{"functionName":{},"functionAlias":{},"currentVersion":{},"targetVersion":{},"targetVersionWeight":{"type":"double"}}}}},"ecsTarget":{"type":"structure","members":{"deploymentId":{},"targetId":{},"targetArn":{},"lastUpdatedAt":{"type":"timestamp"},"lifecycleEvents":{"shape":"S37"},"status":{},"taskSetsInfo":{"type":"list","member":{"type":"structure","members":{"identifer":{},"desiredCount":{"type":"long"},"pendingCount":{"type":"long"},"runningCount":{"type":"long"},"status":{},"trafficWeight":{"type":"double"},"targetGroup":{"shape":"S2i"},"taskSetLabel":{}}}}}}}},"S46":{"type":"list","member":{}},"S49":{"type":"structure","members":{"applicationName":{},"deploymentGroupName":{},"deploymentConfigName":{},"deploymentId":{},"previousRevision":{"shape":"Sb"},"revision":{"shape":"Sb"},"status":{},"errorInformation":{"type":"structure","members":{"code":{},"message":{}}},"createTime":{"type":"timestamp"},"startTime":{"type":"timestamp"},"completeTime":{"type":"timestamp"},"deploymentOverview":{"type":"structure","members":{"Pending":{"type":"long"},"InProgress":{"type":"long"},"Succeeded":{"type":"long"},"Failed":{"type":"long"},"Skipped":{"type":"long"},"Ready":{"type":"long"}}},"description":{},"creator":{},"ignoreApplicationStopFailures":{"type":"boolean"},"autoRollbackConfiguration":{"shape":"S1z"},"updateOutdatedInstancesOnly":{"type":"boolean"},"rollbackInfo":{"type":"structure","members":{"rollbackDeploymentId":{},"rollbackTriggeringDeploymentId":{},"rollbackMessage":{}}},"deploymentStyle":{"shape":"S22"},"targetInstances":{"shape":"S4g"},"instanceTerminationWaitTimeStarted":{"type":"boolean"},"blueGreenDeploymentConfiguration":{"shape":"S25"},"loadBalancerInfo":{"shape":"S2d"},"additionalDeploymentStatusInfo":{"type":"string","deprecated":true,"deprecatedMessage":"AdditionalDeploymentStatusInfo is deprecated, use DeploymentStatusMessageList instead."},"fileExistsBehavior":{},"deploymentStatusMessages":{"type":"list","member":{}},"computePlatform":{}}},"S4g":{"type":"structure","members":{"tagFilters":{"shape":"S1e"},"autoScalingGroups":{"shape":"S4h"},"ec2TagSet":{"shape":"S2s"}}},"S4h":{"type":"list","member":{}},"S4o":{"type":"structure","members":{"instanceName":{},"iamSessionArn":{},"iamUserArn":{},"instanceArn":{},"registerTime":{"type":"timestamp"},"deregisterTime":{"type":"timestamp"},"tags":{"shape":"S2"}}},"S4z":{"type":"structure","members":{"value":{"type":"integer"},"type":{}}},"S52":{"type":"structure","members":{"type":{},"timeBasedCanary":{"type":"structure","members":{"canaryPercentage":{"type":"integer"},"canaryInterval":{"type":"integer"}}},"timeBasedLinear":{"type":"structure","members":{"linearPercentage":{"type":"integer"},"linearInterval":{"type":"integer"}}}}}}}');

});

parcelRequire.register("ljweG", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListApplicationRevisions":{"input_token":"nextToken","output_token":"nextToken","result_key":"revisions"},"ListApplications":{"input_token":"nextToken","output_token":"nextToken","result_key":"applications"},"ListDeploymentConfigs":{"input_token":"nextToken","output_token":"nextToken","result_key":"deploymentConfigsList"},"ListDeploymentGroups":{"input_token":"nextToken","output_token":"nextToken","result_key":"deploymentGroups"},"ListDeploymentInstances":{"input_token":"nextToken","output_token":"nextToken","result_key":"instancesList"},"ListDeployments":{"input_token":"nextToken","output_token":"nextToken","result_key":"deployments"}}}');

});

parcelRequire.register("3I6WL", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"DeploymentSuccessful":{"delay":15,"operation":"GetDeployment","maxAttempts":120,"acceptors":[{"expected":"Succeeded","matcher":"path","state":"success","argument":"deploymentInfo.status"},{"expected":"Failed","matcher":"path","state":"failure","argument":"deploymentInfo.status"},{"expected":"Stopped","matcher":"path","state":"failure","argument":"deploymentInfo.status"}]}}}');

});


parcelRequire.register("gfN2I", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $bd5416ebc789a870$var$Service = $dbC7k.Service;
var $bd5416ebc789a870$var$apiLoader = $dbC7k.apiLoader;
$bd5416ebc789a870$var$apiLoader.services["codepipeline"] = {};
$dbC7k.CodePipeline = $bd5416ebc789a870$var$Service.defineService("codepipeline", [
    "2015-07-09"
]);


Object.defineProperty($bd5416ebc789a870$var$apiLoader.services["codepipeline"], "2015-07-09", {
    get: function get() {
        var model = (parcelRequire("5dqQ5"));
        model.paginators = (parcelRequire("bi1Vo")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.CodePipeline;

});
parcelRequire.register("5dqQ5", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-07-09","endpointPrefix":"codepipeline","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CodePipeline","serviceFullName":"AWS CodePipeline","serviceId":"CodePipeline","signatureVersion":"v4","targetPrefix":"CodePipeline_20150709","uid":"codepipeline-2015-07-09"},"operations":{"AcknowledgeJob":{"input":{"type":"structure","required":["jobId","nonce"],"members":{"jobId":{},"nonce":{}}},"output":{"type":"structure","members":{"status":{}}}},"AcknowledgeThirdPartyJob":{"input":{"type":"structure","required":["jobId","nonce","clientToken"],"members":{"jobId":{},"nonce":{},"clientToken":{}}},"output":{"type":"structure","members":{"status":{}}}},"CreateCustomActionType":{"input":{"type":"structure","required":["category","provider","version","inputArtifactDetails","outputArtifactDetails"],"members":{"category":{},"provider":{},"version":{},"settings":{"shape":"Se"},"configurationProperties":{"shape":"Sh"},"inputArtifactDetails":{"shape":"Sn"},"outputArtifactDetails":{"shape":"Sn"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","required":["actionType"],"members":{"actionType":{"shape":"Sv"},"tags":{"shape":"Sq"}}}},"CreatePipeline":{"input":{"type":"structure","required":["pipeline"],"members":{"pipeline":{"shape":"Sz"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"pipeline":{"shape":"Sz"},"tags":{"shape":"Sq"}}}},"DeleteCustomActionType":{"input":{"type":"structure","required":["category","provider","version"],"members":{"category":{},"provider":{},"version":{}}}},"DeletePipeline":{"input":{"type":"structure","required":["name"],"members":{"name":{}}}},"DeleteWebhook":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{}}},"DeregisterWebhookWithThirdParty":{"input":{"type":"structure","members":{"webhookName":{}}},"output":{"type":"structure","members":{}}},"DisableStageTransition":{"input":{"type":"structure","required":["pipelineName","stageName","transitionType","reason"],"members":{"pipelineName":{},"stageName":{},"transitionType":{},"reason":{}}}},"EnableStageTransition":{"input":{"type":"structure","required":["pipelineName","stageName","transitionType"],"members":{"pipelineName":{},"stageName":{},"transitionType":{}}}},"GetJobDetails":{"input":{"type":"structure","required":["jobId"],"members":{"jobId":{}}},"output":{"type":"structure","members":{"jobDetails":{"type":"structure","members":{"id":{},"data":{"shape":"S28"},"accountId":{}}}}}},"GetPipeline":{"input":{"type":"structure","required":["name"],"members":{"name":{},"version":{"type":"integer"}}},"output":{"type":"structure","members":{"pipeline":{"shape":"Sz"},"metadata":{"type":"structure","members":{"pipelineArn":{},"created":{"type":"timestamp"},"updated":{"type":"timestamp"}}}}}},"GetPipelineExecution":{"input":{"type":"structure","required":["pipelineName","pipelineExecutionId"],"members":{"pipelineName":{},"pipelineExecutionId":{}}},"output":{"type":"structure","members":{"pipelineExecution":{"type":"structure","members":{"pipelineName":{},"pipelineVersion":{"type":"integer"},"pipelineExecutionId":{},"status":{},"artifactRevisions":{"type":"list","member":{"type":"structure","members":{"name":{},"revisionId":{},"revisionChangeIdentifier":{},"revisionSummary":{},"created":{"type":"timestamp"},"revisionUrl":{}}}}}}}}},"GetPipelineState":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{"pipelineName":{},"pipelineVersion":{"type":"integer"},"stageStates":{"type":"list","member":{"type":"structure","members":{"stageName":{},"inboundTransitionState":{"type":"structure","members":{"enabled":{"type":"boolean"},"lastChangedBy":{},"lastChangedAt":{"type":"timestamp"},"disabledReason":{}}},"actionStates":{"type":"list","member":{"type":"structure","members":{"actionName":{},"currentRevision":{"shape":"S3g"},"latestExecution":{"type":"structure","members":{"status":{},"summary":{},"lastStatusChange":{"type":"timestamp"},"token":{},"lastUpdatedBy":{},"externalExecutionId":{},"externalExecutionUrl":{},"percentComplete":{"type":"integer"},"errorDetails":{"type":"structure","members":{"code":{},"message":{}}}}},"entityUrl":{},"revisionUrl":{}}}},"latestExecution":{"type":"structure","required":["pipelineExecutionId","status"],"members":{"pipelineExecutionId":{},"status":{}}}}}},"created":{"type":"timestamp"},"updated":{"type":"timestamp"}}}},"GetThirdPartyJobDetails":{"input":{"type":"structure","required":["jobId","clientToken"],"members":{"jobId":{},"clientToken":{}}},"output":{"type":"structure","members":{"jobDetails":{"type":"structure","members":{"id":{},"data":{"type":"structure","members":{"actionTypeId":{"shape":"Sw"},"actionConfiguration":{"shape":"S29"},"pipelineContext":{"shape":"S2a"},"inputArtifacts":{"shape":"S2g"},"outputArtifacts":{"shape":"S2g"},"artifactCredentials":{"shape":"S2o"},"continuationToken":{},"encryptionKey":{"shape":"S15"}}},"nonce":{}}}}}},"ListActionExecutions":{"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{},"filter":{"type":"structure","members":{"pipelineExecutionId":{}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"actionExecutionDetails":{"type":"list","member":{"type":"structure","members":{"pipelineExecutionId":{},"actionExecutionId":{},"pipelineVersion":{"type":"integer"},"stageName":{},"actionName":{},"startTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"status":{},"input":{"type":"structure","members":{"actionTypeId":{"shape":"Sw"},"configuration":{"shape":"S1l"},"roleArn":{},"region":{},"inputArtifacts":{"shape":"S45"}}},"output":{"type":"structure","members":{"outputArtifacts":{"shape":"S45"},"executionResult":{"type":"structure","members":{"externalExecutionId":{},"externalExecutionSummary":{},"externalExecutionUrl":{}}}}}}}},"nextToken":{}}}},"ListActionTypes":{"input":{"type":"structure","members":{"actionOwnerFilter":{},"nextToken":{}}},"output":{"type":"structure","required":["actionTypes"],"members":{"actionTypes":{"type":"list","member":{"shape":"Sv"}},"nextToken":{}}}},"ListPipelineExecutions":{"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"pipelineExecutionSummaries":{"type":"list","member":{"type":"structure","members":{"pipelineExecutionId":{},"status":{},"startTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"sourceRevisions":{"type":"list","member":{"type":"structure","required":["actionName"],"members":{"actionName":{},"revisionId":{},"revisionSummary":{},"revisionUrl":{}}}}}}},"nextToken":{}}}},"ListPipelines":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"pipelines":{"type":"list","member":{"type":"structure","members":{"name":{},"version":{"type":"integer"},"created":{"type":"timestamp"},"updated":{"type":"timestamp"}}}},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sq"},"nextToken":{}}}},"ListWebhooks":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"webhooks":{"type":"list","member":{"shape":"S4x"}},"NextToken":{}}}},"PollForJobs":{"input":{"type":"structure","required":["actionTypeId"],"members":{"actionTypeId":{"shape":"Sw"},"maxBatchSize":{"type":"integer"},"queryParam":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","members":{"id":{},"data":{"shape":"S28"},"nonce":{},"accountId":{}}}}}}},"PollForThirdPartyJobs":{"input":{"type":"structure","required":["actionTypeId"],"members":{"actionTypeId":{"shape":"Sw"},"maxBatchSize":{"type":"integer"}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","members":{"clientId":{},"jobId":{}}}}}}},"PutActionRevision":{"input":{"type":"structure","required":["pipelineName","stageName","actionName","actionRevision"],"members":{"pipelineName":{},"stageName":{},"actionName":{},"actionRevision":{"shape":"S3g"}}},"output":{"type":"structure","members":{"newRevision":{"type":"boolean"},"pipelineExecutionId":{}}}},"PutApprovalResult":{"input":{"type":"structure","required":["pipelineName","stageName","actionName","result","token"],"members":{"pipelineName":{},"stageName":{},"actionName":{},"result":{"type":"structure","required":["summary","status"],"members":{"summary":{},"status":{}}},"token":{}}},"output":{"type":"structure","members":{"approvedAt":{"type":"timestamp"}}}},"PutJobFailureResult":{"input":{"type":"structure","required":["jobId","failureDetails"],"members":{"jobId":{},"failureDetails":{"shape":"S5x"}}}},"PutJobSuccessResult":{"input":{"type":"structure","required":["jobId"],"members":{"jobId":{},"currentRevision":{"shape":"S60"},"continuationToken":{},"executionDetails":{"shape":"S62"}}}},"PutThirdPartyJobFailureResult":{"input":{"type":"structure","required":["jobId","clientToken","failureDetails"],"members":{"jobId":{},"clientToken":{},"failureDetails":{"shape":"S5x"}}}},"PutThirdPartyJobSuccessResult":{"input":{"type":"structure","required":["jobId","clientToken"],"members":{"jobId":{},"clientToken":{},"currentRevision":{"shape":"S60"},"continuationToken":{},"executionDetails":{"shape":"S62"}}}},"PutWebhook":{"input":{"type":"structure","required":["webhook"],"members":{"webhook":{"shape":"S4y"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"webhook":{"shape":"S4x"}}}},"RegisterWebhookWithThirdParty":{"input":{"type":"structure","members":{"webhookName":{}}},"output":{"type":"structure","members":{}}},"RetryStageExecution":{"input":{"type":"structure","required":["pipelineName","stageName","pipelineExecutionId","retryMode"],"members":{"pipelineName":{},"stageName":{},"pipelineExecutionId":{},"retryMode":{}}},"output":{"type":"structure","members":{"pipelineExecutionId":{}}}},"StartPipelineExecution":{"input":{"type":"structure","required":["name"],"members":{"name":{},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"pipelineExecutionId":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdatePipeline":{"input":{"type":"structure","required":["pipeline"],"members":{"pipeline":{"shape":"Sz"}}},"output":{"type":"structure","members":{"pipeline":{"shape":"Sz"}}}}},"shapes":{"Se":{"type":"structure","members":{"thirdPartyConfigurationUrl":{},"entityUrlTemplate":{},"executionUrlTemplate":{},"revisionUrlTemplate":{}}},"Sh":{"type":"list","member":{"type":"structure","required":["name","required","key","secret"],"members":{"name":{},"required":{"type":"boolean"},"key":{"type":"boolean"},"secret":{"type":"boolean"},"queryable":{"type":"boolean"},"description":{},"type":{}}}},"Sn":{"type":"structure","required":["minimumCount","maximumCount"],"members":{"minimumCount":{"type":"integer"},"maximumCount":{"type":"integer"}}},"Sq":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Sv":{"type":"structure","required":["id","inputArtifactDetails","outputArtifactDetails"],"members":{"id":{"shape":"Sw"},"settings":{"shape":"Se"},"actionConfigurationProperties":{"shape":"Sh"},"inputArtifactDetails":{"shape":"Sn"},"outputArtifactDetails":{"shape":"Sn"}}},"Sw":{"type":"structure","required":["category","owner","provider","version"],"members":{"category":{},"owner":{},"provider":{},"version":{}}},"Sz":{"type":"structure","required":["name","roleArn","stages"],"members":{"name":{},"roleArn":{},"artifactStore":{"shape":"S12"},"artifactStores":{"type":"map","key":{},"value":{"shape":"S12"}},"stages":{"type":"list","member":{"type":"structure","required":["name","actions"],"members":{"name":{},"blockers":{"type":"list","member":{"type":"structure","required":["name","type"],"members":{"name":{},"type":{}}}},"actions":{"type":"list","member":{"type":"structure","required":["name","actionTypeId"],"members":{"name":{},"actionTypeId":{"shape":"Sw"},"runOrder":{"type":"integer"},"configuration":{"shape":"S1l"},"outputArtifacts":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{}}}},"inputArtifacts":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{}}}},"roleArn":{},"region":{}}}}}}},"version":{"type":"integer"}}},"S12":{"type":"structure","required":["type","location"],"members":{"type":{},"location":{},"encryptionKey":{"shape":"S15"}}},"S15":{"type":"structure","required":["id","type"],"members":{"id":{},"type":{}}},"S1l":{"type":"map","key":{},"value":{}},"S28":{"type":"structure","members":{"actionTypeId":{"shape":"Sw"},"actionConfiguration":{"shape":"S29"},"pipelineContext":{"shape":"S2a"},"inputArtifacts":{"shape":"S2g"},"outputArtifacts":{"shape":"S2g"},"artifactCredentials":{"shape":"S2o"},"continuationToken":{},"encryptionKey":{"shape":"S15"}}},"S29":{"type":"structure","members":{"configuration":{"shape":"S1l"}}},"S2a":{"type":"structure","members":{"pipelineName":{},"stage":{"type":"structure","members":{"name":{}}},"action":{"type":"structure","members":{"name":{},"actionExecutionId":{}}},"pipelineArn":{},"pipelineExecutionId":{}}},"S2g":{"type":"list","member":{"type":"structure","members":{"name":{},"revision":{},"location":{"type":"structure","members":{"type":{},"s3Location":{"type":"structure","required":["bucketName","objectKey"],"members":{"bucketName":{},"objectKey":{}}}}}}}},"S2o":{"type":"structure","required":["accessKeyId","secretAccessKey","sessionToken"],"members":{"accessKeyId":{},"secretAccessKey":{},"sessionToken":{}},"sensitive":true},"S3g":{"type":"structure","required":["revisionId","revisionChangeId","created"],"members":{"revisionId":{},"revisionChangeId":{},"created":{"type":"timestamp"}}},"S45":{"type":"list","member":{"type":"structure","members":{"name":{},"s3location":{"type":"structure","members":{"bucket":{},"key":{}}}}}},"S4x":{"type":"structure","required":["definition","url"],"members":{"definition":{"shape":"S4y"},"url":{},"errorMessage":{},"errorCode":{},"lastTriggered":{"type":"timestamp"},"arn":{},"tags":{"shape":"Sq"}}},"S4y":{"type":"structure","required":["name","targetPipeline","targetAction","filters","authentication","authenticationConfiguration"],"members":{"name":{},"targetPipeline":{},"targetAction":{},"filters":{"type":"list","member":{"type":"structure","required":["jsonPath"],"members":{"jsonPath":{},"matchEquals":{}}}},"authentication":{},"authenticationConfiguration":{"type":"structure","members":{"AllowedIPRange":{},"SecretToken":{}}}}},"S5x":{"type":"structure","required":["type","message"],"members":{"type":{},"message":{},"externalExecutionId":{}}},"S60":{"type":"structure","required":["revision","changeIdentifier"],"members":{"revision":{},"changeIdentifier":{},"created":{"type":"timestamp"},"revisionSummary":{}}},"S62":{"type":"structure","members":{"summary":{},"externalExecutionId":{},"percentComplete":{"type":"integer"}}}}}');

});

parcelRequire.register("bi1Vo", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListActionExecutions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"actionExecutionDetails"},"ListActionTypes":{"input_token":"nextToken","output_token":"nextToken","result_key":"actionTypes"},"ListPipelineExecutions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"pipelineExecutionSummaries"},"ListPipelines":{"input_token":"nextToken","output_token":"nextToken","result_key":"pipelines"},"ListTagsForResource":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"tags"},"ListWebhooks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"webhooks"}}}');

});


parcelRequire.register("gpRa9", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $bf383822cfaa7fad$var$Service = $dbC7k.Service;
var $bf383822cfaa7fad$var$apiLoader = $dbC7k.apiLoader;
$bf383822cfaa7fad$var$apiLoader.services["cognitoidentityserviceprovider"] = {};
$dbC7k.CognitoIdentityServiceProvider = $bf383822cfaa7fad$var$Service.defineService("cognitoidentityserviceprovider", [
    "2016-04-18"
]);


Object.defineProperty($bf383822cfaa7fad$var$apiLoader.services["cognitoidentityserviceprovider"], "2016-04-18", {
    get: function get() {
        var model = (parcelRequire("9f1Xi"));
        model.paginators = (parcelRequire("1agKe")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.CognitoIdentityServiceProvider;

});
parcelRequire.register("9f1Xi", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-04-18","endpointPrefix":"cognito-idp","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity Provider","serviceId":"Cognito Identity Provider","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityProviderService","uid":"cognito-idp-2016-04-18"},"operations":{"AddCustomAttributes":{"input":{"type":"structure","required":["UserPoolId","CustomAttributes"],"members":{"UserPoolId":{},"CustomAttributes":{"type":"list","member":{"shape":"S4"}}}},"output":{"type":"structure","members":{}}},"AdminAddUserToGroup":{"input":{"type":"structure","required":["UserPoolId","Username","GroupName"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"GroupName":{}}}},"AdminConfirmSignUp":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminCreateUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"},"ValidationData":{"shape":"Si"},"TemporaryPassword":{"shape":"Sm"},"ForceAliasCreation":{"type":"boolean"},"MessageAction":{},"DesiredDeliveryMediums":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"User":{"shape":"Ss"}}}},"AdminDeleteUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}}},"AdminDeleteUserAttributes":{"input":{"type":"structure","required":["UserPoolId","Username","UserAttributeNames"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributeNames":{"shape":"Sz"}}},"output":{"type":"structure","members":{}}},"AdminDisableProviderForUser":{"input":{"type":"structure","required":["UserPoolId","User"],"members":{"UserPoolId":{},"User":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"AdminDisableUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminEnableUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminForgetDevice":{"input":{"type":"structure","required":["UserPoolId","Username","DeviceKey"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"DeviceKey":{}}}},"AdminGetDevice":{"input":{"type":"structure","required":["DeviceKey","UserPoolId","Username"],"members":{"DeviceKey":{},"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","required":["Device"],"members":{"Device":{"shape":"S1d"}}}},"AdminGetUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","required":["Username"],"members":{"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"},"UserCreateDate":{"type":"timestamp"},"UserLastModifiedDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"UserStatus":{},"MFAOptions":{"shape":"Sv"},"PreferredMfaSetting":{},"UserMFASettingList":{"shape":"S1g"}}}},"AdminInitiateAuth":{"input":{"type":"structure","required":["UserPoolId","ClientId","AuthFlow"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"AuthFlow":{},"AuthParameters":{"shape":"S1k"},"ClientMetadata":{"shape":"S1l"},"AnalyticsMetadata":{"shape":"S1m"},"ContextData":{"shape":"S1n"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"AdminLinkProviderForUser":{"input":{"type":"structure","required":["UserPoolId","DestinationUser","SourceUser"],"members":{"UserPoolId":{},"DestinationUser":{"shape":"S12"},"SourceUser":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"AdminListDevices":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"Limit":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"Devices":{"shape":"S24"},"PaginationToken":{}}}},"AdminListGroupsForUser":{"input":{"type":"structure","required":["Username","UserPoolId"],"members":{"Username":{"shape":"Sd"},"UserPoolId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"shape":"S28"},"NextToken":{}}}},"AdminListUserAuthEvents":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AuthEvents":{"type":"list","member":{"type":"structure","members":{"EventId":{},"EventType":{},"CreationDate":{"type":"timestamp"},"EventResponse":{},"EventRisk":{"type":"structure","members":{"RiskDecision":{},"RiskLevel":{}}},"ChallengeResponses":{"type":"list","member":{"type":"structure","members":{"ChallengeName":{},"ChallengeResponse":{}}}},"EventContextData":{"type":"structure","members":{"IpAddress":{},"DeviceName":{},"Timezone":{},"City":{},"Country":{}}},"EventFeedback":{"type":"structure","required":["FeedbackValue","Provider"],"members":{"FeedbackValue":{},"Provider":{},"FeedbackDate":{"type":"timestamp"}}}}}},"NextToken":{}}}},"AdminRemoveUserFromGroup":{"input":{"type":"structure","required":["UserPoolId","Username","GroupName"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"GroupName":{}}}},"AdminResetUserPassword":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminRespondToAuthChallenge":{"input":{"type":"structure","required":["UserPoolId","ClientId","ChallengeName"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"ChallengeName":{},"ChallengeResponses":{"shape":"S2x"},"Session":{},"AnalyticsMetadata":{"shape":"S1m"},"ContextData":{"shape":"S1n"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"AdminSetUserMFAPreference":{"input":{"type":"structure","required":["Username","UserPoolId"],"members":{"SMSMfaSettings":{"shape":"S30"},"SoftwareTokenMfaSettings":{"shape":"S31"},"Username":{"shape":"Sd"},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"AdminSetUserPassword":{"input":{"type":"structure","required":["UserPoolId","Username","Password"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"Password":{"shape":"Sm"},"Permanent":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"AdminSetUserSettings":{"input":{"type":"structure","required":["UserPoolId","Username","MFAOptions"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"MFAOptions":{"shape":"Sv"}}},"output":{"type":"structure","members":{}}},"AdminUpdateAuthEventFeedback":{"input":{"type":"structure","required":["UserPoolId","Username","EventId","FeedbackValue"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"EventId":{},"FeedbackValue":{}}},"output":{"type":"structure","members":{}}},"AdminUpdateDeviceStatus":{"input":{"type":"structure","required":["UserPoolId","Username","DeviceKey"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"DeviceKey":{},"DeviceRememberedStatus":{}}},"output":{"type":"structure","members":{}}},"AdminUpdateUserAttributes":{"input":{"type":"structure","required":["UserPoolId","Username","UserAttributes"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"}}},"output":{"type":"structure","members":{}}},"AdminUserGlobalSignOut":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AssociateSoftwareToken":{"input":{"type":"structure","members":{"AccessToken":{"shape":"S1v"},"Session":{}}},"output":{"type":"structure","members":{"SecretCode":{"type":"string","sensitive":true},"Session":{}}}},"ChangePassword":{"input":{"type":"structure","required":["PreviousPassword","ProposedPassword","AccessToken"],"members":{"PreviousPassword":{"shape":"Sm"},"ProposedPassword":{"shape":"Sm"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"ConfirmDevice":{"input":{"type":"structure","required":["AccessToken","DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{},"DeviceSecretVerifierConfig":{"type":"structure","members":{"PasswordVerifier":{},"Salt":{}}},"DeviceName":{}}},"output":{"type":"structure","members":{"UserConfirmationNecessary":{"type":"boolean"}}}},"ConfirmForgotPassword":{"input":{"type":"structure","required":["ClientId","Username","ConfirmationCode","Password"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3r"},"Username":{"shape":"Sd"},"ConfirmationCode":{},"Password":{"shape":"Sm"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3t"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"ConfirmSignUp":{"input":{"type":"structure","required":["ClientId","Username","ConfirmationCode"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3r"},"Username":{"shape":"Sd"},"ConfirmationCode":{},"ForceAliasCreation":{"type":"boolean"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3t"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"CreateGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"CreateIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName","ProviderType","ProviderDetails"],"members":{"UserPoolId":{},"ProviderName":{},"ProviderType":{},"ProviderDetails":{"shape":"S42"},"AttributeMapping":{"shape":"S43"},"IdpIdentifiers":{"shape":"S45"}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S48"}}}},"CreateResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier","Name"],"members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4c"}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4h"}}}},"CreateUserImportJob":{"input":{"type":"structure","required":["JobName","UserPoolId","CloudWatchLogsRoleArn"],"members":{"JobName":{},"UserPoolId":{},"CloudWatchLogsRoleArn":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4l"}}}},"CreateUserPool":{"input":{"type":"structure","required":["PoolName"],"members":{"PoolName":{},"Policies":{"shape":"S4t"},"LambdaConfig":{"shape":"S4x"},"AutoVerifiedAttributes":{"shape":"S4y"},"AliasAttributes":{"shape":"S50"},"UsernameAttributes":{"shape":"S52"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S57"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S5c"},"EmailConfiguration":{"shape":"S5d"},"SmsConfiguration":{"shape":"S5g"},"UserPoolTags":{"shape":"S5h"},"AdminCreateUserConfig":{"shape":"S5k"},"Schema":{"shape":"S5n"},"UserPoolAddOns":{"shape":"S5o"}}},"output":{"type":"structure","members":{"UserPool":{"shape":"S5r"}}}},"CreateUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientName"],"members":{"UserPoolId":{},"ClientName":{},"GenerateSecret":{"type":"boolean"},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S5y"},"WriteAttributes":{"shape":"S5y"},"ExplicitAuthFlows":{"shape":"S60"},"SupportedIdentityProviders":{"shape":"S62"},"CallbackURLs":{"shape":"S63"},"LogoutURLs":{"shape":"S65"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S66"},"AllowedOAuthScopes":{"shape":"S68"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S6a"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S6d"}}}},"CreateUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId"],"members":{"Domain":{},"UserPoolId":{},"CustomDomainConfig":{"shape":"S6g"}}},"output":{"type":"structure","members":{"CloudFrontDomain":{}}}},"DeleteGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{}}}},"DeleteIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{}}}},"DeleteResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier"],"members":{"UserPoolId":{},"Identifier":{}}}},"DeleteUser":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"authtype":"none"},"DeleteUserAttributes":{"input":{"type":"structure","required":["UserAttributeNames","AccessToken"],"members":{"UserAttributeNames":{"shape":"Sz"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"DeleteUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}}},"DeleteUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}}},"DeleteUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId"],"members":{"Domain":{},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"DescribeIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S48"}}}},"DescribeResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier"],"members":{"UserPoolId":{},"Identifier":{}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4h"}}}},"DescribeRiskConfiguration":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}},"output":{"type":"structure","required":["RiskConfiguration"],"members":{"RiskConfiguration":{"shape":"S6y"}}}},"DescribeUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4l"}}}},"DescribeUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"UserPool":{"shape":"S5r"}}}},"DescribeUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S6d"}}}},"DescribeUserPoolDomain":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"type":"structure","members":{"DomainDescription":{"type":"structure","members":{"UserPoolId":{},"AWSAccountId":{},"Domain":{},"S3Bucket":{},"CloudFrontDistribution":{},"Version":{},"Status":{},"CustomDomainConfig":{"shape":"S6g"}}}}}},"ForgetDevice":{"input":{"type":"structure","required":["DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{}}}},"ForgotPassword":{"input":{"type":"structure","required":["ClientId","Username"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3r"},"UserContextData":{"shape":"S3t"},"Username":{"shape":"Sd"},"AnalyticsMetadata":{"shape":"S1m"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S7w"}}},"authtype":"none"},"GetCSVHeader":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"UserPoolId":{},"CSVHeader":{"type":"list","member":{}}}}},"GetDevice":{"input":{"type":"structure","required":["DeviceKey"],"members":{"DeviceKey":{},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","required":["Device"],"members":{"Device":{"shape":"S1d"}}}},"GetGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"GetIdentityProviderByIdentifier":{"input":{"type":"structure","required":["UserPoolId","IdpIdentifier"],"members":{"UserPoolId":{},"IdpIdentifier":{}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S48"}}}},"GetSigningCertificate":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"Certificate":{}}}},"GetUICustomization":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"}}},"output":{"type":"structure","required":["UICustomization"],"members":{"UICustomization":{"shape":"S8a"}}}},"GetUser":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","required":["Username","UserAttributes"],"members":{"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Si"},"MFAOptions":{"shape":"Sv"},"PreferredMfaSetting":{},"UserMFASettingList":{"shape":"S1g"}}},"authtype":"none"},"GetUserAttributeVerificationCode":{"input":{"type":"structure","required":["AccessToken","AttributeName"],"members":{"AccessToken":{"shape":"S1v"},"AttributeName":{}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S7w"}}},"authtype":"none"},"GetUserPoolMfaConfig":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"SmsMfaConfiguration":{"shape":"S8k"},"SoftwareTokenMfaConfiguration":{"shape":"S8l"},"MfaConfiguration":{}}}},"GlobalSignOut":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}}},"InitiateAuth":{"input":{"type":"structure","required":["AuthFlow","ClientId"],"members":{"AuthFlow":{},"AuthParameters":{"shape":"S1k"},"ClientMetadata":{"shape":"S1l"},"ClientId":{"shape":"S1i"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3t"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"ListDevices":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"},"Limit":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"Devices":{"shape":"S24"},"PaginationToken":{}}}},"ListGroups":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"shape":"S28"},"NextToken":{}}}},"ListIdentityProviders":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Providers"],"members":{"Providers":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ProviderType":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListResourceServers":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ResourceServers"],"members":{"ResourceServers":{"type":"list","member":{"shape":"S4h"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S5h"}}}},"ListUserImportJobs":{"input":{"type":"structure","required":["UserPoolId","MaxResults"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"UserImportJobs":{"type":"list","member":{"shape":"S4l"}},"PaginationToken":{}}}},"ListUserPoolClients":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"UserPoolClients":{"type":"list","member":{"type":"structure","members":{"ClientId":{"shape":"S1i"},"UserPoolId":{},"ClientName":{}}}},"NextToken":{}}}},"ListUserPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"UserPools":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"LambdaConfig":{"shape":"S4x"},"Status":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListUsers":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"AttributesToGet":{"type":"list","member":{}},"Limit":{"type":"integer"},"PaginationToken":{},"Filter":{}}},"output":{"type":"structure","members":{"Users":{"shape":"S9n"},"PaginationToken":{}}}},"ListUsersInGroup":{"input":{"type":"structure","required":["UserPoolId","GroupName"],"members":{"UserPoolId":{},"GroupName":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Users":{"shape":"S9n"},"NextToken":{}}}},"ResendConfirmationCode":{"input":{"type":"structure","required":["ClientId","Username"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3r"},"UserContextData":{"shape":"S3t"},"Username":{"shape":"Sd"},"AnalyticsMetadata":{"shape":"S1m"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S7w"}}},"authtype":"none"},"RespondToAuthChallenge":{"input":{"type":"structure","required":["ClientId","ChallengeName"],"members":{"ClientId":{"shape":"S1i"},"ChallengeName":{},"Session":{},"ChallengeResponses":{"shape":"S2x"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3t"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"SetRiskConfiguration":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"CompromisedCredentialsRiskConfiguration":{"shape":"S6z"},"AccountTakeoverRiskConfiguration":{"shape":"S74"},"RiskExceptionConfiguration":{"shape":"S7d"}}},"output":{"type":"structure","required":["RiskConfiguration"],"members":{"RiskConfiguration":{"shape":"S6y"}}}},"SetUICustomization":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"CSS":{},"ImageFile":{"type":"blob"}}},"output":{"type":"structure","required":["UICustomization"],"members":{"UICustomization":{"shape":"S8a"}}}},"SetUserMFAPreference":{"input":{"type":"structure","required":["AccessToken"],"members":{"SMSMfaSettings":{"shape":"S30"},"SoftwareTokenMfaSettings":{"shape":"S31"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}}},"SetUserPoolMfaConfig":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"SmsMfaConfiguration":{"shape":"S8k"},"SoftwareTokenMfaConfiguration":{"shape":"S8l"},"MfaConfiguration":{}}},"output":{"type":"structure","members":{"SmsMfaConfiguration":{"shape":"S8k"},"SoftwareTokenMfaConfiguration":{"shape":"S8l"},"MfaConfiguration":{}}}},"SetUserSettings":{"input":{"type":"structure","required":["AccessToken","MFAOptions"],"members":{"AccessToken":{"shape":"S1v"},"MFAOptions":{"shape":"Sv"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"SignUp":{"input":{"type":"structure","required":["ClientId","Username","Password"],"members":{"ClientId":{"shape":"S1i"},"SecretHash":{"shape":"S3r"},"Username":{"shape":"Sd"},"Password":{"shape":"Sm"},"UserAttributes":{"shape":"Si"},"ValidationData":{"shape":"Si"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3t"}}},"output":{"type":"structure","required":["UserConfirmed","UserSub"],"members":{"UserConfirmed":{"type":"boolean"},"CodeDeliveryDetails":{"shape":"S7w"},"UserSub":{}}},"authtype":"none"},"StartUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4l"}}}},"StopUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4l"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"Tags":{"shape":"S5h"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAuthEventFeedback":{"input":{"type":"structure","required":["UserPoolId","Username","EventId","FeedbackToken","FeedbackValue"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"EventId":{},"FeedbackToken":{"shape":"S1v"},"FeedbackValue":{}}},"output":{"type":"structure","members":{}}},"UpdateDeviceStatus":{"input":{"type":"structure","required":["AccessToken","DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{},"DeviceRememberedStatus":{}}},"output":{"type":"structure","members":{}}},"UpdateGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"UpdateIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{},"ProviderDetails":{"shape":"S42"},"AttributeMapping":{"shape":"S43"},"IdpIdentifiers":{"shape":"S45"}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S48"}}}},"UpdateResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier","Name"],"members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4c"}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4h"}}}},"UpdateUserAttributes":{"input":{"type":"structure","required":["UserAttributes","AccessToken"],"members":{"UserAttributes":{"shape":"Si"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{"CodeDeliveryDetailsList":{"type":"list","member":{"shape":"S7w"}}}},"authtype":"none"},"UpdateUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"Policies":{"shape":"S4t"},"LambdaConfig":{"shape":"S4x"},"AutoVerifiedAttributes":{"shape":"S4y"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S57"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S5c"},"EmailConfiguration":{"shape":"S5d"},"SmsConfiguration":{"shape":"S5g"},"UserPoolTags":{"shape":"S5h"},"AdminCreateUserConfig":{"shape":"S5k"},"UserPoolAddOns":{"shape":"S5o"}}},"output":{"type":"structure","members":{}}},"UpdateUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"ClientName":{},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S5y"},"WriteAttributes":{"shape":"S5y"},"ExplicitAuthFlows":{"shape":"S60"},"SupportedIdentityProviders":{"shape":"S62"},"CallbackURLs":{"shape":"S63"},"LogoutURLs":{"shape":"S65"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S66"},"AllowedOAuthScopes":{"shape":"S68"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S6a"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S6d"}}}},"UpdateUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId","CustomDomainConfig"],"members":{"Domain":{},"UserPoolId":{},"CustomDomainConfig":{"shape":"S6g"}}},"output":{"type":"structure","members":{"CloudFrontDomain":{}}}},"VerifySoftwareToken":{"input":{"type":"structure","required":["UserCode"],"members":{"AccessToken":{"shape":"S1v"},"Session":{},"UserCode":{},"FriendlyDeviceName":{}}},"output":{"type":"structure","members":{"Status":{},"Session":{}}}},"VerifyUserAttribute":{"input":{"type":"structure","required":["AccessToken","AttributeName","Code"],"members":{"AccessToken":{"shape":"S1v"},"AttributeName":{},"Code":{}}},"output":{"type":"structure","members":{}},"authtype":"none"}},"shapes":{"S4":{"type":"structure","members":{"Name":{},"AttributeDataType":{},"DeveloperOnlyAttribute":{"type":"boolean"},"Mutable":{"type":"boolean"},"Required":{"type":"boolean"},"NumberAttributeConstraints":{"type":"structure","members":{"MinValue":{},"MaxValue":{}}},"StringAttributeConstraints":{"type":"structure","members":{"MinLength":{},"MaxLength":{}}}}},"Sd":{"type":"string","sensitive":true},"Si":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Value":{"type":"string","sensitive":true}}}},"Sm":{"type":"string","sensitive":true},"Ss":{"type":"structure","members":{"Username":{"shape":"Sd"},"Attributes":{"shape":"Si"},"UserCreateDate":{"type":"timestamp"},"UserLastModifiedDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"UserStatus":{},"MFAOptions":{"shape":"Sv"}}},"Sv":{"type":"list","member":{"type":"structure","members":{"DeliveryMedium":{},"AttributeName":{}}}},"Sz":{"type":"list","member":{}},"S12":{"type":"structure","members":{"ProviderName":{},"ProviderAttributeName":{},"ProviderAttributeValue":{}}},"S1d":{"type":"structure","members":{"DeviceKey":{},"DeviceAttributes":{"shape":"Si"},"DeviceCreateDate":{"type":"timestamp"},"DeviceLastModifiedDate":{"type":"timestamp"},"DeviceLastAuthenticatedDate":{"type":"timestamp"}}},"S1g":{"type":"list","member":{}},"S1i":{"type":"string","sensitive":true},"S1k":{"type":"map","key":{},"value":{}},"S1l":{"type":"map","key":{},"value":{}},"S1m":{"type":"structure","members":{"AnalyticsEndpointId":{}}},"S1n":{"type":"structure","required":["IpAddress","ServerName","ServerPath","HttpHeaders"],"members":{"IpAddress":{},"ServerName":{},"ServerPath":{},"HttpHeaders":{"type":"list","member":{"type":"structure","members":{"headerName":{},"headerValue":{}}}},"EncodedData":{}}},"S1t":{"type":"map","key":{},"value":{}},"S1u":{"type":"structure","members":{"AccessToken":{"shape":"S1v"},"ExpiresIn":{"type":"integer"},"TokenType":{},"RefreshToken":{"shape":"S1v"},"IdToken":{"shape":"S1v"},"NewDeviceMetadata":{"type":"structure","members":{"DeviceKey":{},"DeviceGroupKey":{}}}}},"S1v":{"type":"string","sensitive":true},"S24":{"type":"list","member":{"shape":"S1d"}},"S28":{"type":"list","member":{"shape":"S29"}},"S29":{"type":"structure","members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S2x":{"type":"map","key":{},"value":{}},"S30":{"type":"structure","members":{"Enabled":{"type":"boolean"},"PreferredMfa":{"type":"boolean"}}},"S31":{"type":"structure","members":{"Enabled":{"type":"boolean"},"PreferredMfa":{"type":"boolean"}}},"S3r":{"type":"string","sensitive":true},"S3t":{"type":"structure","members":{"EncodedData":{}}},"S42":{"type":"map","key":{},"value":{}},"S43":{"type":"map","key":{},"value":{}},"S45":{"type":"list","member":{}},"S48":{"type":"structure","members":{"UserPoolId":{},"ProviderName":{},"ProviderType":{},"ProviderDetails":{"shape":"S42"},"AttributeMapping":{"shape":"S43"},"IdpIdentifiers":{"shape":"S45"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S4c":{"type":"list","member":{"type":"structure","required":["ScopeName","ScopeDescription"],"members":{"ScopeName":{},"ScopeDescription":{}}}},"S4h":{"type":"structure","members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4c"}}},"S4l":{"type":"structure","members":{"JobName":{},"JobId":{},"UserPoolId":{},"PreSignedUrl":{},"CreationDate":{"type":"timestamp"},"StartDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"Status":{},"CloudWatchLogsRoleArn":{},"ImportedUsers":{"type":"long"},"SkippedUsers":{"type":"long"},"FailedUsers":{"type":"long"},"CompletionMessage":{}}},"S4t":{"type":"structure","members":{"PasswordPolicy":{"type":"structure","members":{"MinimumLength":{"type":"integer"},"RequireUppercase":{"type":"boolean"},"RequireLowercase":{"type":"boolean"},"RequireNumbers":{"type":"boolean"},"RequireSymbols":{"type":"boolean"},"TemporaryPasswordValidityDays":{"type":"integer"}}}}},"S4x":{"type":"structure","members":{"PreSignUp":{},"CustomMessage":{},"PostConfirmation":{},"PreAuthentication":{},"PostAuthentication":{},"DefineAuthChallenge":{},"CreateAuthChallenge":{},"VerifyAuthChallengeResponse":{},"PreTokenGeneration":{},"UserMigration":{}}},"S4y":{"type":"list","member":{}},"S50":{"type":"list","member":{}},"S52":{"type":"list","member":{}},"S57":{"type":"structure","members":{"SmsMessage":{},"EmailMessage":{},"EmailSubject":{},"EmailMessageByLink":{},"EmailSubjectByLink":{},"DefaultEmailOption":{}}},"S5c":{"type":"structure","members":{"ChallengeRequiredOnNewDevice":{"type":"boolean"},"DeviceOnlyRememberedOnUserPrompt":{"type":"boolean"}}},"S5d":{"type":"structure","members":{"SourceArn":{},"ReplyToEmailAddress":{},"EmailSendingAccount":{}}},"S5g":{"type":"structure","required":["SnsCallerArn"],"members":{"SnsCallerArn":{},"ExternalId":{}}},"S5h":{"type":"map","key":{},"value":{}},"S5k":{"type":"structure","members":{"AllowAdminCreateUserOnly":{"type":"boolean"},"UnusedAccountValidityDays":{"type":"integer"},"InviteMessageTemplate":{"type":"structure","members":{"SMSMessage":{},"EmailMessage":{},"EmailSubject":{}}}}},"S5n":{"type":"list","member":{"shape":"S4"}},"S5o":{"type":"structure","required":["AdvancedSecurityMode"],"members":{"AdvancedSecurityMode":{}}},"S5r":{"type":"structure","members":{"Id":{},"Name":{},"Policies":{"shape":"S4t"},"LambdaConfig":{"shape":"S4x"},"Status":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"},"SchemaAttributes":{"shape":"S5n"},"AutoVerifiedAttributes":{"shape":"S4y"},"AliasAttributes":{"shape":"S50"},"UsernameAttributes":{"shape":"S52"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S57"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S5c"},"EstimatedNumberOfUsers":{"type":"integer"},"EmailConfiguration":{"shape":"S5d"},"SmsConfiguration":{"shape":"S5g"},"UserPoolTags":{"shape":"S5h"},"SmsConfigurationFailure":{},"EmailConfigurationFailure":{},"Domain":{},"CustomDomain":{},"AdminCreateUserConfig":{"shape":"S5k"},"UserPoolAddOns":{"shape":"S5o"},"Arn":{}}},"S5y":{"type":"list","member":{}},"S60":{"type":"list","member":{}},"S62":{"type":"list","member":{}},"S63":{"type":"list","member":{}},"S65":{"type":"list","member":{}},"S66":{"type":"list","member":{}},"S68":{"type":"list","member":{}},"S6a":{"type":"structure","required":["ApplicationId","RoleArn","ExternalId"],"members":{"ApplicationId":{},"RoleArn":{},"ExternalId":{},"UserDataShared":{"type":"boolean"}}},"S6d":{"type":"structure","members":{"UserPoolId":{},"ClientName":{},"ClientId":{"shape":"S1i"},"ClientSecret":{"type":"string","sensitive":true},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"},"RefreshTokenValidity":{"type":"integer"},"ReadAttributes":{"shape":"S5y"},"WriteAttributes":{"shape":"S5y"},"ExplicitAuthFlows":{"shape":"S60"},"SupportedIdentityProviders":{"shape":"S62"},"CallbackURLs":{"shape":"S63"},"LogoutURLs":{"shape":"S65"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S66"},"AllowedOAuthScopes":{"shape":"S68"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S6a"}}},"S6g":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"S6y":{"type":"structure","members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"CompromisedCredentialsRiskConfiguration":{"shape":"S6z"},"AccountTakeoverRiskConfiguration":{"shape":"S74"},"RiskExceptionConfiguration":{"shape":"S7d"},"LastModifiedDate":{"type":"timestamp"}}},"S6z":{"type":"structure","required":["Actions"],"members":{"EventFilter":{"type":"list","member":{}},"Actions":{"type":"structure","required":["EventAction"],"members":{"EventAction":{}}}}},"S74":{"type":"structure","required":["Actions"],"members":{"NotifyConfiguration":{"type":"structure","required":["SourceArn"],"members":{"From":{},"ReplyTo":{},"SourceArn":{},"BlockEmail":{"shape":"S76"},"NoActionEmail":{"shape":"S76"},"MfaEmail":{"shape":"S76"}}},"Actions":{"type":"structure","members":{"LowAction":{"shape":"S7a"},"MediumAction":{"shape":"S7a"},"HighAction":{"shape":"S7a"}}}}},"S76":{"type":"structure","required":["Subject"],"members":{"Subject":{},"HtmlBody":{},"TextBody":{}}},"S7a":{"type":"structure","required":["Notify","EventAction"],"members":{"Notify":{"type":"boolean"},"EventAction":{}}},"S7d":{"type":"structure","members":{"BlockedIPRangeList":{"type":"list","member":{}},"SkippedIPRangeList":{"type":"list","member":{}}}},"S7w":{"type":"structure","members":{"Destination":{},"DeliveryMedium":{},"AttributeName":{}}},"S8a":{"type":"structure","members":{"UserPoolId":{},"ClientId":{"shape":"S1i"},"ImageUrl":{},"CSS":{},"CSSVersion":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S8k":{"type":"structure","members":{"SmsAuthenticationMessage":{},"SmsConfiguration":{"shape":"S5g"}}},"S8l":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"S9n":{"type":"list","member":{"shape":"Ss"}}}}');

});

parcelRequire.register("1agKe", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"AdminListGroupsForUser":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Groups"},"AdminListUserAuthEvents":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AuthEvents"},"ListGroups":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Groups"},"ListIdentityProviders":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Providers"},"ListResourceServers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ResourceServers"},"ListUserPoolClients":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"UserPoolClients"},"ListUserPools":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"UserPools"},"ListUsersInGroup":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Users"}}}');

});


parcelRequire.register("545lv", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $3b01790f810ab38d$var$Service = $dbC7k.Service;
var $3b01790f810ab38d$var$apiLoader = $dbC7k.apiLoader;
$3b01790f810ab38d$var$apiLoader.services["cognitosync"] = {};
$dbC7k.CognitoSync = $3b01790f810ab38d$var$Service.defineService("cognitosync", [
    "2014-06-30"
]);

Object.defineProperty($3b01790f810ab38d$var$apiLoader.services["cognitosync"], "2014-06-30", {
    get: function get() {
        var model = (parcelRequire("hsTCE"));
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.CognitoSync;

});
parcelRequire.register("hsTCE", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2014-06-30","endpointPrefix":"cognito-sync","jsonVersion":"1.1","serviceFullName":"Amazon Cognito Sync","serviceId":"Cognito Sync","signatureVersion":"v4","protocol":"rest-json","uid":"cognito-sync-2014-06-30"},"operations":{"BulkPublish":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/bulkpublish","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolId":{}}}},"DeleteDataset":{"http":{"method":"DELETE","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"}}},"output":{"type":"structure","members":{"Dataset":{"shape":"S8"}}}},"DescribeDataset":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"}}},"output":{"type":"structure","members":{"Dataset":{"shape":"S8"}}}},"DescribeIdentityPoolUsage":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolUsage":{"shape":"Sg"}}}},"DescribeIdentityUsage":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"}}},"output":{"type":"structure","members":{"IdentityUsage":{"type":"structure","members":{"IdentityId":{},"IdentityPoolId":{},"LastModifiedDate":{"type":"timestamp"},"DatasetCount":{"type":"integer"},"DataStorage":{"type":"long"}}}}}},"GetBulkPublishDetails":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/getBulkPublishDetails","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"BulkPublishStartTime":{"type":"timestamp"},"BulkPublishCompleteTime":{"type":"timestamp"},"BulkPublishStatus":{},"FailureMessage":{}}}},"GetCognitoEvents":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/events","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"Events":{"shape":"Sq"}}}},"GetIdentityPoolConfiguration":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/configuration","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"PushSync":{"shape":"Sv"},"CognitoStreams":{"shape":"Sz"}}}},"ListDatasets":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets","responseCode":200},"input":{"type":"structure","required":["IdentityId","IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"Datasets":{"type":"list","member":{"shape":"S8"}},"Count":{"type":"integer"},"NextToken":{}}}},"ListIdentityPoolUsage":{"http":{"method":"GET","requestUri":"/identitypools","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"IdentityPoolUsages":{"type":"list","member":{"shape":"Sg"}},"MaxResults":{"type":"integer"},"Count":{"type":"integer"},"NextToken":{}}}},"ListRecords":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/records","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"LastSyncCount":{"location":"querystring","locationName":"lastSyncCount","type":"long"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"SyncSessionToken":{"location":"querystring","locationName":"syncSessionToken"}}},"output":{"type":"structure","members":{"Records":{"shape":"S1c"},"NextToken":{},"Count":{"type":"integer"},"DatasetSyncCount":{"type":"long"},"LastModifiedBy":{},"MergedDatasetNames":{"type":"list","member":{}},"DatasetExists":{"type":"boolean"},"DatasetDeletedAfterRequestedSyncCount":{"type":"boolean"},"SyncSessionToken":{}}}},"RegisterDevice":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/identity/{IdentityId}/device","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","Platform","Token"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"Platform":{},"Token":{}}},"output":{"type":"structure","members":{"DeviceId":{}}}},"SetCognitoEvents":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/events","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","Events"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"Events":{"shape":"Sq"}}}},"SetIdentityPoolConfiguration":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/configuration","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"PushSync":{"shape":"Sv"},"CognitoStreams":{"shape":"Sz"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"PushSync":{"shape":"Sv"},"CognitoStreams":{"shape":"Sz"}}}},"SubscribeToDataset":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/subscriptions/{DeviceId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName","DeviceId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"DeviceId":{"location":"uri","locationName":"DeviceId"}}},"output":{"type":"structure","members":{}}},"UnsubscribeFromDataset":{"http":{"method":"DELETE","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/subscriptions/{DeviceId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName","DeviceId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"DeviceId":{"location":"uri","locationName":"DeviceId"}}},"output":{"type":"structure","members":{}}},"UpdateRecords":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName","SyncSessionToken"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"DeviceId":{},"RecordPatches":{"type":"list","member":{"type":"structure","required":["Op","Key","SyncCount"],"members":{"Op":{},"Key":{},"Value":{},"SyncCount":{"type":"long"},"DeviceLastModifiedDate":{"type":"timestamp"}}}},"SyncSessionToken":{},"ClientContext":{"location":"header","locationName":"x-amz-Client-Context"}}},"output":{"type":"structure","members":{"Records":{"shape":"S1c"}}}}},"shapes":{"S8":{"type":"structure","members":{"IdentityId":{},"DatasetName":{},"CreationDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"},"LastModifiedBy":{},"DataStorage":{"type":"long"},"NumRecords":{"type":"long"}}},"Sg":{"type":"structure","members":{"IdentityPoolId":{},"SyncSessionsCount":{"type":"long"},"DataStorage":{"type":"long"},"LastModifiedDate":{"type":"timestamp"}}},"Sq":{"type":"map","key":{},"value":{}},"Sv":{"type":"structure","members":{"ApplicationArns":{"type":"list","member":{}},"RoleArn":{}}},"Sz":{"type":"structure","members":{"StreamName":{},"RoleArn":{},"StreamingStatus":{}}},"S1c":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"SyncCount":{"type":"long"},"LastModifiedDate":{"type":"timestamp"},"LastModifiedBy":{},"DeviceLastModifiedDate":{"type":"timestamp"}}}}},"examples":{}}');

});


parcelRequire.register("lQUxu", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $fe8a4fce7dd2e645$var$Service = $dbC7k.Service;
var $fe8a4fce7dd2e645$var$apiLoader = $dbC7k.apiLoader;
$fe8a4fce7dd2e645$var$apiLoader.services["configservice"] = {};
$dbC7k.ConfigService = $fe8a4fce7dd2e645$var$Service.defineService("configservice", [
    "2014-11-12"
]);


Object.defineProperty($fe8a4fce7dd2e645$var$apiLoader.services["configservice"], "2014-11-12", {
    get: function get() {
        var model = (parcelRequire("jDwvx"));
        model.paginators = (parcelRequire("evOSh")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ConfigService;

});
parcelRequire.register("jDwvx", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2014-11-12","endpointPrefix":"config","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Config Service","serviceFullName":"AWS Config","serviceId":"Config Service","signatureVersion":"v4","targetPrefix":"StarlingDoveService","uid":"config-2014-11-12"},"operations":{"BatchGetAggregateResourceConfig":{"input":{"type":"structure","required":["ConfigurationAggregatorName","ResourceIdentifiers"],"members":{"ConfigurationAggregatorName":{},"ResourceIdentifiers":{"type":"list","member":{"shape":"S4"}}}},"output":{"type":"structure","members":{"BaseConfigurationItems":{"shape":"Sb"},"UnprocessedResourceIdentifiers":{"type":"list","member":{"shape":"S4"}}}}},"BatchGetResourceConfig":{"input":{"type":"structure","required":["resourceKeys"],"members":{"resourceKeys":{"shape":"Sq"}}},"output":{"type":"structure","members":{"baseConfigurationItems":{"shape":"Sb"},"unprocessedResourceKeys":{"shape":"Sq"}}}},"DeleteAggregationAuthorization":{"input":{"type":"structure","required":["AuthorizedAccountId","AuthorizedAwsRegion"],"members":{"AuthorizedAccountId":{},"AuthorizedAwsRegion":{}}}},"DeleteConfigRule":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{}}}},"DeleteConfigurationAggregator":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{}}}},"DeleteConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorderName"],"members":{"ConfigurationRecorderName":{}}}},"DeleteDeliveryChannel":{"input":{"type":"structure","required":["DeliveryChannelName"],"members":{"DeliveryChannelName":{}}}},"DeleteEvaluationResults":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{}}},"output":{"type":"structure","members":{}}},"DeleteOrganizationConfigRule":{"input":{"type":"structure","required":["OrganizationConfigRuleName"],"members":{"OrganizationConfigRuleName":{}}}},"DeletePendingAggregationRequest":{"input":{"type":"structure","required":["RequesterAccountId","RequesterAwsRegion"],"members":{"RequesterAccountId":{},"RequesterAwsRegion":{}}}},"DeleteRemediationConfiguration":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{},"ResourceType":{}}},"output":{"type":"structure","members":{}}},"DeleteRetentionConfiguration":{"input":{"type":"structure","required":["RetentionConfigurationName"],"members":{"RetentionConfigurationName":{}}}},"DeliverConfigSnapshot":{"input":{"type":"structure","required":["deliveryChannelName"],"members":{"deliveryChannelName":{}}},"output":{"type":"structure","members":{"configSnapshotId":{}}}},"DescribeAggregateComplianceByConfigRules":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"Filters":{"type":"structure","members":{"ConfigRuleName":{},"ComplianceType":{},"AccountId":{},"AwsRegion":{}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AggregateComplianceByConfigRules":{"type":"list","member":{"type":"structure","members":{"ConfigRuleName":{},"Compliance":{"shape":"S1l"},"AccountId":{},"AwsRegion":{}}}},"NextToken":{}}}},"DescribeAggregationAuthorizations":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AggregationAuthorizations":{"type":"list","member":{"shape":"S1t"}},"NextToken":{}}}},"DescribeComplianceByConfigRule":{"input":{"type":"structure","members":{"ConfigRuleNames":{"shape":"S1w"},"ComplianceTypes":{"shape":"S1x"},"NextToken":{}}},"output":{"type":"structure","members":{"ComplianceByConfigRules":{"type":"list","member":{"type":"structure","members":{"ConfigRuleName":{},"Compliance":{"shape":"S1l"}}}},"NextToken":{}}}},"DescribeComplianceByResource":{"input":{"type":"structure","members":{"ResourceType":{},"ResourceId":{},"ComplianceTypes":{"shape":"S1x"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ComplianceByResources":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ResourceId":{},"Compliance":{"shape":"S1l"}}}},"NextToken":{}}}},"DescribeConfigRuleEvaluationStatus":{"input":{"type":"structure","members":{"ConfigRuleNames":{"shape":"S1w"},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ConfigRulesEvaluationStatus":{"type":"list","member":{"type":"structure","members":{"ConfigRuleName":{},"ConfigRuleArn":{},"ConfigRuleId":{},"LastSuccessfulInvocationTime":{"type":"timestamp"},"LastFailedInvocationTime":{"type":"timestamp"},"LastSuccessfulEvaluationTime":{"type":"timestamp"},"LastFailedEvaluationTime":{"type":"timestamp"},"FirstActivatedTime":{"type":"timestamp"},"LastErrorCode":{},"LastErrorMessage":{},"FirstEvaluationStarted":{"type":"boolean"}}}},"NextToken":{}}}},"DescribeConfigRules":{"input":{"type":"structure","members":{"ConfigRuleNames":{"shape":"S1w"},"NextToken":{}}},"output":{"type":"structure","members":{"ConfigRules":{"type":"list","member":{"shape":"S2f"}},"NextToken":{}}}},"DescribeConfigurationAggregatorSourcesStatus":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"UpdateStatus":{"type":"list","member":{}},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"AggregatedSourceStatusList":{"type":"list","member":{"type":"structure","members":{"SourceId":{},"SourceType":{},"AwsRegion":{},"LastUpdateStatus":{},"LastUpdateTime":{"type":"timestamp"},"LastErrorCode":{},"LastErrorMessage":{}}}},"NextToken":{}}}},"DescribeConfigurationAggregators":{"input":{"type":"structure","members":{"ConfigurationAggregatorNames":{"type":"list","member":{}},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ConfigurationAggregators":{"type":"list","member":{"shape":"S34"}},"NextToken":{}}}},"DescribeConfigurationRecorderStatus":{"input":{"type":"structure","members":{"ConfigurationRecorderNames":{"shape":"S3c"}}},"output":{"type":"structure","members":{"ConfigurationRecordersStatus":{"type":"list","member":{"type":"structure","members":{"name":{},"lastStartTime":{"type":"timestamp"},"lastStopTime":{"type":"timestamp"},"recording":{"type":"boolean"},"lastStatus":{},"lastErrorCode":{},"lastErrorMessage":{},"lastStatusChangeTime":{"type":"timestamp"}}}}}}},"DescribeConfigurationRecorders":{"input":{"type":"structure","members":{"ConfigurationRecorderNames":{"shape":"S3c"}}},"output":{"type":"structure","members":{"ConfigurationRecorders":{"type":"list","member":{"shape":"S3k"}}}}},"DescribeDeliveryChannelStatus":{"input":{"type":"structure","members":{"DeliveryChannelNames":{"shape":"S3q"}}},"output":{"type":"structure","members":{"DeliveryChannelsStatus":{"type":"list","member":{"type":"structure","members":{"name":{},"configSnapshotDeliveryInfo":{"shape":"S3u"},"configHistoryDeliveryInfo":{"shape":"S3u"},"configStreamDeliveryInfo":{"type":"structure","members":{"lastStatus":{},"lastErrorCode":{},"lastErrorMessage":{},"lastStatusChangeTime":{"type":"timestamp"}}}}}}}}},"DescribeDeliveryChannels":{"input":{"type":"structure","members":{"DeliveryChannelNames":{"shape":"S3q"}}},"output":{"type":"structure","members":{"DeliveryChannels":{"type":"list","member":{"shape":"S40"}}}}},"DescribeOrganizationConfigRuleStatuses":{"input":{"type":"structure","members":{"OrganizationConfigRuleNames":{"shape":"S43"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OrganizationConfigRuleStatuses":{"type":"list","member":{"type":"structure","required":["OrganizationConfigRuleName","OrganizationRuleStatus"],"members":{"OrganizationConfigRuleName":{},"OrganizationRuleStatus":{},"ErrorCode":{},"ErrorMessage":{},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeOrganizationConfigRules":{"input":{"type":"structure","members":{"OrganizationConfigRuleNames":{"shape":"S43"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OrganizationConfigRules":{"type":"list","member":{"type":"structure","required":["OrganizationConfigRuleName","OrganizationConfigRuleArn"],"members":{"OrganizationConfigRuleName":{},"OrganizationConfigRuleArn":{},"OrganizationManagedRuleMetadata":{"shape":"S4d"},"OrganizationCustomRuleMetadata":{"shape":"S4i"},"ExcludedAccounts":{"shape":"S4l"},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribePendingAggregationRequests":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"PendingAggregationRequests":{"type":"list","member":{"type":"structure","members":{"RequesterAccountId":{},"RequesterAwsRegion":{}}}},"NextToken":{}}}},"DescribeRemediationConfigurations":{"input":{"type":"structure","required":["ConfigRuleNames"],"members":{"ConfigRuleNames":{"shape":"S1w"}}},"output":{"type":"structure","members":{"RemediationConfigurations":{"shape":"S4t"}}}},"DescribeRemediationExecutionStatus":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{},"ResourceKeys":{"shape":"Sq"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"RemediationExecutionStatuses":{"type":"list","member":{"type":"structure","members":{"ResourceKey":{"shape":"Sr"},"State":{},"StepDetails":{"type":"list","member":{"type":"structure","members":{"Name":{},"State":{},"ErrorMessage":{},"StartTime":{"type":"timestamp"},"StopTime":{"type":"timestamp"}}}},"InvocationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeRetentionConfigurations":{"input":{"type":"structure","members":{"RetentionConfigurationNames":{"type":"list","member":{}},"NextToken":{}}},"output":{"type":"structure","members":{"RetentionConfigurations":{"type":"list","member":{"shape":"S5e"}},"NextToken":{}}}},"GetAggregateComplianceDetailsByConfigRule":{"input":{"type":"structure","required":["ConfigurationAggregatorName","ConfigRuleName","AccountId","AwsRegion"],"members":{"ConfigurationAggregatorName":{},"ConfigRuleName":{},"AccountId":{},"AwsRegion":{},"ComplianceType":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AggregateEvaluationResults":{"type":"list","member":{"type":"structure","members":{"EvaluationResultIdentifier":{"shape":"S5k"},"ComplianceType":{},"ResultRecordedTime":{"type":"timestamp"},"ConfigRuleInvokedTime":{"type":"timestamp"},"Annotation":{},"AccountId":{},"AwsRegion":{}}}},"NextToken":{}}}},"GetAggregateConfigRuleComplianceSummary":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"Filters":{"type":"structure","members":{"AccountId":{},"AwsRegion":{}}},"GroupByKey":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GroupByKey":{},"AggregateComplianceCounts":{"type":"list","member":{"type":"structure","members":{"GroupName":{},"ComplianceSummary":{"shape":"S5s"}}}},"NextToken":{}}}},"GetAggregateDiscoveredResourceCounts":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"Filters":{"type":"structure","members":{"ResourceType":{},"AccountId":{},"Region":{}}},"GroupByKey":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["TotalDiscoveredResources"],"members":{"TotalDiscoveredResources":{"type":"long"},"GroupByKey":{},"GroupedResourceCounts":{"type":"list","member":{"type":"structure","required":["GroupName","ResourceCount"],"members":{"GroupName":{},"ResourceCount":{"type":"long"}}}},"NextToken":{}}}},"GetAggregateResourceConfig":{"input":{"type":"structure","required":["ConfigurationAggregatorName","ResourceIdentifier"],"members":{"ConfigurationAggregatorName":{},"ResourceIdentifier":{"shape":"S4"}}},"output":{"type":"structure","members":{"ConfigurationItem":{"shape":"S62"}}}},"GetComplianceDetailsByConfigRule":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{},"ComplianceTypes":{"shape":"S1x"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"EvaluationResults":{"shape":"S6e"},"NextToken":{}}}},"GetComplianceDetailsByResource":{"input":{"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{},"ResourceId":{},"ComplianceTypes":{"shape":"S1x"},"NextToken":{}}},"output":{"type":"structure","members":{"EvaluationResults":{"shape":"S6e"},"NextToken":{}}}},"GetComplianceSummaryByConfigRule":{"output":{"type":"structure","members":{"ComplianceSummary":{"shape":"S5s"}}}},"GetComplianceSummaryByResourceType":{"input":{"type":"structure","members":{"ResourceTypes":{"shape":"S6k"}}},"output":{"type":"structure","members":{"ComplianceSummariesByResourceType":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ComplianceSummary":{"shape":"S5s"}}}}}}},"GetDiscoveredResourceCounts":{"input":{"type":"structure","members":{"resourceTypes":{"shape":"S6k"},"limit":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"totalDiscoveredResources":{"type":"long"},"resourceCounts":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"count":{"type":"long"}}}},"nextToken":{}}}},"GetOrganizationConfigRuleDetailedStatus":{"input":{"type":"structure","required":["OrganizationConfigRuleName"],"members":{"OrganizationConfigRuleName":{},"Filters":{"type":"structure","members":{"AccountId":{},"MemberAccountRuleStatus":{}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OrganizationConfigRuleDetailedStatus":{"type":"list","member":{"type":"structure","required":["AccountId","ConfigRuleName","MemberAccountRuleStatus"],"members":{"AccountId":{},"ConfigRuleName":{},"MemberAccountRuleStatus":{},"ErrorCode":{},"ErrorMessage":{},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"GetResourceConfigHistory":{"input":{"type":"structure","required":["resourceType","resourceId"],"members":{"resourceType":{},"resourceId":{},"laterTime":{"type":"timestamp"},"earlierTime":{"type":"timestamp"},"chronologicalOrder":{},"limit":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"configurationItems":{"type":"list","member":{"shape":"S62"}},"nextToken":{}}}},"ListAggregateDiscoveredResources":{"input":{"type":"structure","required":["ConfigurationAggregatorName","ResourceType"],"members":{"ConfigurationAggregatorName":{},"ResourceType":{},"Filters":{"type":"structure","members":{"AccountId":{},"ResourceId":{},"ResourceName":{},"Region":{}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ResourceIdentifiers":{"type":"list","member":{"shape":"S4"}},"NextToken":{}}}},"ListDiscoveredResources":{"input":{"type":"structure","required":["resourceType"],"members":{"resourceType":{},"resourceIds":{"type":"list","member":{}},"resourceName":{},"limit":{"type":"integer"},"includeDeletedResources":{"type":"boolean"},"nextToken":{}}},"output":{"type":"structure","members":{"resourceIdentifiers":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"resourceId":{},"resourceName":{},"resourceDeletionTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S7h"},"NextToken":{}}}},"PutAggregationAuthorization":{"input":{"type":"structure","required":["AuthorizedAccountId","AuthorizedAwsRegion"],"members":{"AuthorizedAccountId":{},"AuthorizedAwsRegion":{},"Tags":{"shape":"S7m"}}},"output":{"type":"structure","members":{"AggregationAuthorization":{"shape":"S1t"}}}},"PutConfigRule":{"input":{"type":"structure","required":["ConfigRule"],"members":{"ConfigRule":{"shape":"S2f"},"Tags":{"shape":"S7m"}}}},"PutConfigurationAggregator":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"AccountAggregationSources":{"shape":"S36"},"OrganizationAggregationSource":{"shape":"S3a"},"Tags":{"shape":"S7m"}}},"output":{"type":"structure","members":{"ConfigurationAggregator":{"shape":"S34"}}}},"PutConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorder"],"members":{"ConfigurationRecorder":{"shape":"S3k"}}}},"PutDeliveryChannel":{"input":{"type":"structure","required":["DeliveryChannel"],"members":{"DeliveryChannel":{"shape":"S40"}}}},"PutEvaluations":{"input":{"type":"structure","required":["ResultToken"],"members":{"Evaluations":{"shape":"S7u"},"ResultToken":{},"TestMode":{"type":"boolean"}}},"output":{"type":"structure","members":{"FailedEvaluations":{"shape":"S7u"}}}},"PutOrganizationConfigRule":{"input":{"type":"structure","required":["OrganizationConfigRuleName"],"members":{"OrganizationConfigRuleName":{},"OrganizationManagedRuleMetadata":{"shape":"S4d"},"OrganizationCustomRuleMetadata":{"shape":"S4i"},"ExcludedAccounts":{"shape":"S4l"}}},"output":{"type":"structure","members":{"OrganizationConfigRuleArn":{}}}},"PutRemediationConfigurations":{"input":{"type":"structure","required":["RemediationConfigurations"],"members":{"RemediationConfigurations":{"shape":"S4t"}}},"output":{"type":"structure","members":{"FailedBatches":{"type":"list","member":{"type":"structure","members":{"FailureMessage":{},"FailedItems":{"shape":"S4t"}}}}}}},"PutRetentionConfiguration":{"input":{"type":"structure","required":["RetentionPeriodInDays"],"members":{"RetentionPeriodInDays":{"type":"integer"}}},"output":{"type":"structure","members":{"RetentionConfiguration":{"shape":"S5e"}}}},"SelectResourceConfig":{"input":{"type":"structure","required":["Expression"],"members":{"Expression":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{}},"QueryInfo":{"type":"structure","members":{"SelectFields":{"type":"list","member":{"type":"structure","members":{"Name":{}}}}}},"NextToken":{}}}},"StartConfigRulesEvaluation":{"input":{"type":"structure","members":{"ConfigRuleNames":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"StartConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorderName"],"members":{"ConfigurationRecorderName":{}}}},"StartRemediationExecution":{"input":{"type":"structure","required":["ConfigRuleName","ResourceKeys"],"members":{"ConfigRuleName":{},"ResourceKeys":{"shape":"Sq"}}},"output":{"type":"structure","members":{"FailureMessage":{},"FailedItems":{"shape":"Sq"}}}},"StopConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorderName"],"members":{"ConfigurationRecorderName":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S7h"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}}}},"shapes":{"S4":{"type":"structure","required":["SourceAccountId","SourceRegion","ResourceId","ResourceType"],"members":{"SourceAccountId":{},"SourceRegion":{},"ResourceId":{},"ResourceType":{},"ResourceName":{}}},"Sb":{"type":"list","member":{"type":"structure","members":{"version":{},"accountId":{},"configurationItemCaptureTime":{"type":"timestamp"},"configurationItemStatus":{},"configurationStateId":{},"arn":{},"resourceType":{},"resourceId":{},"resourceName":{},"awsRegion":{},"availabilityZone":{},"resourceCreationTime":{"type":"timestamp"},"configuration":{},"supplementaryConfiguration":{"shape":"Sl"}}}},"Sl":{"type":"map","key":{},"value":{}},"Sq":{"type":"list","member":{"shape":"Sr"}},"Sr":{"type":"structure","required":["resourceType","resourceId"],"members":{"resourceType":{},"resourceId":{}}},"S1l":{"type":"structure","members":{"ComplianceType":{},"ComplianceContributorCount":{"shape":"S1m"}}},"S1m":{"type":"structure","members":{"CappedCount":{"type":"integer"},"CapExceeded":{"type":"boolean"}}},"S1t":{"type":"structure","members":{"AggregationAuthorizationArn":{},"AuthorizedAccountId":{},"AuthorizedAwsRegion":{},"CreationTime":{"type":"timestamp"}}},"S1w":{"type":"list","member":{}},"S1x":{"type":"list","member":{}},"S2f":{"type":"structure","required":["Source"],"members":{"ConfigRuleName":{},"ConfigRuleArn":{},"ConfigRuleId":{},"Description":{},"Scope":{"type":"structure","members":{"ComplianceResourceTypes":{"type":"list","member":{}},"TagKey":{},"TagValue":{},"ComplianceResourceId":{}}},"Source":{"type":"structure","required":["Owner","SourceIdentifier"],"members":{"Owner":{},"SourceIdentifier":{},"SourceDetails":{"type":"list","member":{"type":"structure","members":{"EventSource":{},"MessageType":{},"MaximumExecutionFrequency":{}}}}}},"InputParameters":{},"MaximumExecutionFrequency":{},"ConfigRuleState":{},"CreatedBy":{}}},"S34":{"type":"structure","members":{"ConfigurationAggregatorName":{},"ConfigurationAggregatorArn":{},"AccountAggregationSources":{"shape":"S36"},"OrganizationAggregationSource":{"shape":"S3a"},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}},"S36":{"type":"list","member":{"type":"structure","required":["AccountIds"],"members":{"AccountIds":{"type":"list","member":{}},"AllAwsRegions":{"type":"boolean"},"AwsRegions":{"shape":"S39"}}}},"S39":{"type":"list","member":{}},"S3a":{"type":"structure","required":["RoleArn"],"members":{"RoleArn":{},"AwsRegions":{"shape":"S39"},"AllAwsRegions":{"type":"boolean"}}},"S3c":{"type":"list","member":{}},"S3k":{"type":"structure","members":{"name":{},"roleARN":{},"recordingGroup":{"type":"structure","members":{"allSupported":{"type":"boolean"},"includeGlobalResourceTypes":{"type":"boolean"},"resourceTypes":{"type":"list","member":{}}}}}},"S3q":{"type":"list","member":{}},"S3u":{"type":"structure","members":{"lastStatus":{},"lastErrorCode":{},"lastErrorMessage":{},"lastAttemptTime":{"type":"timestamp"},"lastSuccessfulTime":{"type":"timestamp"},"nextDeliveryTime":{"type":"timestamp"}}},"S40":{"type":"structure","members":{"name":{},"s3BucketName":{},"s3KeyPrefix":{},"snsTopicARN":{},"configSnapshotDeliveryProperties":{"type":"structure","members":{"deliveryFrequency":{}}}}},"S43":{"type":"list","member":{}},"S4d":{"type":"structure","required":["RuleIdentifier"],"members":{"Description":{},"RuleIdentifier":{},"InputParameters":{},"MaximumExecutionFrequency":{},"ResourceTypesScope":{"shape":"S4g"},"ResourceIdScope":{},"TagKeyScope":{},"TagValueScope":{}}},"S4g":{"type":"list","member":{}},"S4i":{"type":"structure","required":["LambdaFunctionArn","OrganizationConfigRuleTriggerTypes"],"members":{"Description":{},"LambdaFunctionArn":{},"OrganizationConfigRuleTriggerTypes":{"type":"list","member":{}},"InputParameters":{},"MaximumExecutionFrequency":{},"ResourceTypesScope":{"shape":"S4g"},"ResourceIdScope":{},"TagKeyScope":{},"TagValueScope":{}}},"S4l":{"type":"list","member":{}},"S4t":{"type":"list","member":{"type":"structure","required":["ConfigRuleName","TargetType","TargetId"],"members":{"ConfigRuleName":{},"TargetType":{},"TargetId":{},"TargetVersion":{},"Parameters":{"type":"map","key":{},"value":{"type":"structure","members":{"ResourceValue":{"type":"structure","members":{"Value":{}}},"StaticValue":{"type":"structure","members":{"Values":{"type":"list","member":{}}}}}}},"ResourceType":{}}}},"S5e":{"type":"structure","required":["Name","RetentionPeriodInDays"],"members":{"Name":{},"RetentionPeriodInDays":{"type":"integer"}}},"S5k":{"type":"structure","members":{"EvaluationResultQualifier":{"type":"structure","members":{"ConfigRuleName":{},"ResourceType":{},"ResourceId":{}}},"OrderingTimestamp":{"type":"timestamp"}}},"S5s":{"type":"structure","members":{"CompliantResourceCount":{"shape":"S1m"},"NonCompliantResourceCount":{"shape":"S1m"},"ComplianceSummaryTimestamp":{"type":"timestamp"}}},"S62":{"type":"structure","members":{"version":{},"accountId":{},"configurationItemCaptureTime":{"type":"timestamp"},"configurationItemStatus":{},"configurationStateId":{},"configurationItemMD5Hash":{},"arn":{},"resourceType":{},"resourceId":{},"resourceName":{},"awsRegion":{},"availabilityZone":{},"resourceCreationTime":{"type":"timestamp"},"tags":{"type":"map","key":{},"value":{}},"relatedEvents":{"type":"list","member":{}},"relationships":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"resourceId":{},"resourceName":{},"relationshipName":{}}}},"configuration":{},"supplementaryConfiguration":{"shape":"Sl"}}},"S6e":{"type":"list","member":{"type":"structure","members":{"EvaluationResultIdentifier":{"shape":"S5k"},"ComplianceType":{},"ResultRecordedTime":{"type":"timestamp"},"ConfigRuleInvokedTime":{"type":"timestamp"},"Annotation":{},"ResultToken":{}}}},"S6k":{"type":"list","member":{}},"S7h":{"type":"list","member":{"shape":"S7i"}},"S7i":{"type":"structure","members":{"Key":{},"Value":{}}},"S7m":{"type":"list","member":{"shape":"S7i"}},"S7u":{"type":"list","member":{"type":"structure","required":["ComplianceResourceType","ComplianceResourceId","ComplianceType","OrderingTimestamp"],"members":{"ComplianceResourceType":{},"ComplianceResourceId":{},"ComplianceType":{},"Annotation":{},"OrderingTimestamp":{"type":"timestamp"}}}}}}');

});

parcelRequire.register("evOSh", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeRemediationExecutionStatus":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"RemediationExecutionStatuses"},"GetResourceConfigHistory":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"configurationItems"}}}');

});


parcelRequire.register("6XcsC", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $5101eb2c118011a6$var$Service = $dbC7k.Service;
var $5101eb2c118011a6$var$apiLoader = $dbC7k.apiLoader;
$5101eb2c118011a6$var$apiLoader.services["cur"] = {};
$dbC7k.CUR = $5101eb2c118011a6$var$Service.defineService("cur", [
    "2017-01-06"
]);


Object.defineProperty($5101eb2c118011a6$var$apiLoader.services["cur"], "2017-01-06", {
    get: function get() {
        var model = (parcelRequire("a4vKZ"));
        model.paginators = (parcelRequire("aXqCd")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.CUR;

});
parcelRequire.register("a4vKZ", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-01-06","endpointPrefix":"cur","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Cost and Usage Report Service","serviceId":"Cost and Usage Report Service","signatureVersion":"v4","signingName":"cur","targetPrefix":"AWSOrigamiServiceGatewayService","uid":"cur-2017-01-06"},"operations":{"DeleteReportDefinition":{"input":{"type":"structure","members":{"ReportName":{}}},"output":{"type":"structure","members":{"ResponseMessage":{}}}},"DescribeReportDefinitions":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ReportDefinitions":{"type":"list","member":{"shape":"Sa"}},"NextToken":{}}}},"ModifyReportDefinition":{"input":{"type":"structure","required":["ReportName","ReportDefinition"],"members":{"ReportName":{},"ReportDefinition":{"shape":"Sa"}}},"output":{"type":"structure","members":{}}},"PutReportDefinition":{"input":{"type":"structure","required":["ReportDefinition"],"members":{"ReportDefinition":{"shape":"Sa"}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sa":{"type":"structure","required":["ReportName","TimeUnit","Format","Compression","AdditionalSchemaElements","S3Bucket","S3Prefix","S3Region"],"members":{"ReportName":{},"TimeUnit":{},"Format":{},"Compression":{},"AdditionalSchemaElements":{"type":"list","member":{}},"S3Bucket":{},"S3Prefix":{},"S3Region":{},"AdditionalArtifacts":{"type":"list","member":{}},"RefreshClosedReports":{"type":"boolean"},"ReportVersioning":{}}}}}');

});

parcelRequire.register("aXqCd", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeReportDefinitions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("hVPLg", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $d0dfe9488be24195$var$Service = $dbC7k.Service;
var $d0dfe9488be24195$var$apiLoader = $dbC7k.apiLoader;
$d0dfe9488be24195$var$apiLoader.services["datapipeline"] = {};
$dbC7k.DataPipeline = $d0dfe9488be24195$var$Service.defineService("datapipeline", [
    "2012-10-29"
]);


Object.defineProperty($d0dfe9488be24195$var$apiLoader.services["datapipeline"], "2012-10-29", {
    get: function get() {
        var model = (parcelRequire("fYHYD"));
        model.paginators = (parcelRequire("3y2ce")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.DataPipeline;

});
parcelRequire.register("fYHYD", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2012-10-29","endpointPrefix":"datapipeline","jsonVersion":"1.1","serviceFullName":"AWS Data Pipeline","serviceId":"Data Pipeline","signatureVersion":"v4","targetPrefix":"DataPipeline","protocol":"json","uid":"datapipeline-2012-10-29"},"operations":{"ActivatePipeline":{"input":{"type":"structure","required":["pipelineId"],"members":{"pipelineId":{},"parameterValues":{"shape":"S3"},"startTimestamp":{"type":"timestamp"}}},"output":{"type":"structure","members":{}}},"AddTags":{"input":{"type":"structure","required":["pipelineId","tags"],"members":{"pipelineId":{},"tags":{"shape":"Sa"}}},"output":{"type":"structure","members":{}}},"CreatePipeline":{"input":{"type":"structure","required":["name","uniqueId"],"members":{"name":{},"uniqueId":{},"description":{},"tags":{"shape":"Sa"}}},"output":{"type":"structure","required":["pipelineId"],"members":{"pipelineId":{}}}},"DeactivatePipeline":{"input":{"type":"structure","required":["pipelineId"],"members":{"pipelineId":{},"cancelActive":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeletePipeline":{"input":{"type":"structure","required":["pipelineId"],"members":{"pipelineId":{}}}},"DescribeObjects":{"input":{"type":"structure","required":["pipelineId","objectIds"],"members":{"pipelineId":{},"objectIds":{"shape":"Sn"},"evaluateExpressions":{"type":"boolean"},"marker":{}}},"output":{"type":"structure","required":["pipelineObjects"],"members":{"pipelineObjects":{"shape":"Sq"},"marker":{},"hasMoreResults":{"type":"boolean"}}}},"DescribePipelines":{"input":{"type":"structure","required":["pipelineIds"],"members":{"pipelineIds":{"shape":"Sn"}}},"output":{"type":"structure","required":["pipelineDescriptionList"],"members":{"pipelineDescriptionList":{"type":"list","member":{"type":"structure","required":["pipelineId","name","fields"],"members":{"pipelineId":{},"name":{},"fields":{"shape":"Ss"},"description":{},"tags":{"shape":"Sa"}}}}}}},"EvaluateExpression":{"input":{"type":"structure","required":["pipelineId","objectId","expression"],"members":{"pipelineId":{},"objectId":{},"expression":{}}},"output":{"type":"structure","required":["evaluatedExpression"],"members":{"evaluatedExpression":{}}}},"GetPipelineDefinition":{"input":{"type":"structure","required":["pipelineId"],"members":{"pipelineId":{},"version":{}}},"output":{"type":"structure","members":{"pipelineObjects":{"shape":"Sq"},"parameterObjects":{"shape":"S13"},"parameterValues":{"shape":"S3"}}}},"ListPipelines":{"input":{"type":"structure","members":{"marker":{}}},"output":{"type":"structure","required":["pipelineIdList"],"members":{"pipelineIdList":{"type":"list","member":{"type":"structure","members":{"id":{},"name":{}}}},"marker":{},"hasMoreResults":{"type":"boolean"}}}},"PollForTask":{"input":{"type":"structure","required":["workerGroup"],"members":{"workerGroup":{},"hostname":{},"instanceIdentity":{"type":"structure","members":{"document":{},"signature":{}}}}},"output":{"type":"structure","members":{"taskObject":{"type":"structure","members":{"taskId":{},"pipelineId":{},"attemptId":{},"objects":{"type":"map","key":{},"value":{"shape":"Sr"}}}}}}},"PutPipelineDefinition":{"input":{"type":"structure","required":["pipelineId","pipelineObjects"],"members":{"pipelineId":{},"pipelineObjects":{"shape":"Sq"},"parameterObjects":{"shape":"S13"},"parameterValues":{"shape":"S3"}}},"output":{"type":"structure","required":["errored"],"members":{"validationErrors":{"shape":"S1l"},"validationWarnings":{"shape":"S1p"},"errored":{"type":"boolean"}}}},"QueryObjects":{"input":{"type":"structure","required":["pipelineId","sphere"],"members":{"pipelineId":{},"query":{"type":"structure","members":{"selectors":{"type":"list","member":{"type":"structure","members":{"fieldName":{},"operator":{"type":"structure","members":{"type":{},"values":{"shape":"S1x"}}}}}}}},"sphere":{},"marker":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ids":{"shape":"Sn"},"marker":{},"hasMoreResults":{"type":"boolean"}}}},"RemoveTags":{"input":{"type":"structure","required":["pipelineId","tagKeys"],"members":{"pipelineId":{},"tagKeys":{"shape":"S1x"}}},"output":{"type":"structure","members":{}}},"ReportTaskProgress":{"input":{"type":"structure","required":["taskId"],"members":{"taskId":{},"fields":{"shape":"Ss"}}},"output":{"type":"structure","required":["canceled"],"members":{"canceled":{"type":"boolean"}}}},"ReportTaskRunnerHeartbeat":{"input":{"type":"structure","required":["taskrunnerId"],"members":{"taskrunnerId":{},"workerGroup":{},"hostname":{}}},"output":{"type":"structure","required":["terminate"],"members":{"terminate":{"type":"boolean"}}}},"SetStatus":{"input":{"type":"structure","required":["pipelineId","objectIds","status"],"members":{"pipelineId":{},"objectIds":{"shape":"Sn"},"status":{}}}},"SetTaskStatus":{"input":{"type":"structure","required":["taskId","taskStatus"],"members":{"taskId":{},"taskStatus":{},"errorId":{},"errorMessage":{},"errorStackTrace":{}}},"output":{"type":"structure","members":{}}},"ValidatePipelineDefinition":{"input":{"type":"structure","required":["pipelineId","pipelineObjects"],"members":{"pipelineId":{},"pipelineObjects":{"shape":"Sq"},"parameterObjects":{"shape":"S13"},"parameterValues":{"shape":"S3"}}},"output":{"type":"structure","required":["errored"],"members":{"validationErrors":{"shape":"S1l"},"validationWarnings":{"shape":"S1p"},"errored":{"type":"boolean"}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["id","stringValue"],"members":{"id":{},"stringValue":{}}}},"Sa":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Sn":{"type":"list","member":{}},"Sq":{"type":"list","member":{"shape":"Sr"}},"Sr":{"type":"structure","required":["id","name","fields"],"members":{"id":{},"name":{},"fields":{"shape":"Ss"}}},"Ss":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"stringValue":{},"refValue":{}}}},"S13":{"type":"list","member":{"type":"structure","required":["id","attributes"],"members":{"id":{},"attributes":{"type":"list","member":{"type":"structure","required":["key","stringValue"],"members":{"key":{},"stringValue":{}}}}}}},"S1l":{"type":"list","member":{"type":"structure","members":{"id":{},"errors":{"shape":"S1n"}}}},"S1n":{"type":"list","member":{}},"S1p":{"type":"list","member":{"type":"structure","members":{"id":{},"warnings":{"shape":"S1n"}}}},"S1x":{"type":"list","member":{}}}}');

});

parcelRequire.register("3y2ce", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListPipelines":{"input_token":"marker","output_token":"marker","more_results":"hasMoreResults","result_key":"pipelineIdList"},"DescribeObjects":{"input_token":"marker","output_token":"marker","more_results":"hasMoreResults","result_key":"pipelineObjects"},"DescribePipelines":{"result_key":"pipelineDescriptionList"},"QueryObjects":{"input_token":"marker","output_token":"marker","more_results":"hasMoreResults","limit_key":"limit","result_key":"ids"}}}');

});


parcelRequire.register("jg5tU", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $e053c372b7542541$var$Service = $dbC7k.Service;
var $e053c372b7542541$var$apiLoader = $dbC7k.apiLoader;
$e053c372b7542541$var$apiLoader.services["devicefarm"] = {};
$dbC7k.DeviceFarm = $e053c372b7542541$var$Service.defineService("devicefarm", [
    "2015-06-23"
]);


Object.defineProperty($e053c372b7542541$var$apiLoader.services["devicefarm"], "2015-06-23", {
    get: function get() {
        var model = (parcelRequire("68bKt"));
        model.paginators = (parcelRequire("h87NX")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.DeviceFarm;

});
parcelRequire.register("68bKt", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-06-23","endpointPrefix":"devicefarm","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Device Farm","serviceId":"Device Farm","signatureVersion":"v4","targetPrefix":"DeviceFarm_20150623","uid":"devicefarm-2015-06-23"},"operations":{"CreateDevicePool":{"input":{"type":"structure","required":["projectArn","name","rules"],"members":{"projectArn":{},"name":{},"description":{},"rules":{"shape":"S5"},"maxDevices":{"type":"integer"}}},"output":{"type":"structure","members":{"devicePool":{"shape":"Sc"}}}},"CreateInstanceProfile":{"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"packageCleanup":{"type":"boolean"},"excludeAppPackagesFromCleanup":{"shape":"Sg"},"rebootAfterUse":{"type":"boolean"}}},"output":{"type":"structure","members":{"instanceProfile":{"shape":"Si"}}}},"CreateNetworkProfile":{"input":{"type":"structure","required":["projectArn","name"],"members":{"projectArn":{},"name":{},"description":{},"type":{},"uplinkBandwidthBits":{"type":"long"},"downlinkBandwidthBits":{"type":"long"},"uplinkDelayMs":{"type":"long"},"downlinkDelayMs":{"type":"long"},"uplinkJitterMs":{"type":"long"},"downlinkJitterMs":{"type":"long"},"uplinkLossPercent":{"type":"integer"},"downlinkLossPercent":{"type":"integer"}}},"output":{"type":"structure","members":{"networkProfile":{"shape":"So"}}}},"CreateProject":{"input":{"type":"structure","required":["name"],"members":{"name":{},"defaultJobTimeoutMinutes":{"type":"integer"}}},"output":{"type":"structure","members":{"project":{"shape":"Ss"}}}},"CreateRemoteAccessSession":{"input":{"type":"structure","required":["projectArn","deviceArn"],"members":{"projectArn":{},"deviceArn":{},"instanceArn":{},"sshPublicKey":{},"remoteDebugEnabled":{"type":"boolean"},"remoteRecordEnabled":{"type":"boolean"},"remoteRecordAppArn":{},"name":{},"clientId":{},"configuration":{"type":"structure","members":{"billingMethod":{},"vpceConfigurationArns":{"shape":"Sz"}}},"interactionMode":{},"skipAppResign":{"type":"boolean"}}},"output":{"type":"structure","members":{"remoteAccessSession":{"shape":"S12"}}}},"CreateUpload":{"input":{"type":"structure","required":["projectArn","name","type"],"members":{"projectArn":{},"name":{},"type":{},"contentType":{}}},"output":{"type":"structure","members":{"upload":{"shape":"S1n"}}}},"CreateVPCEConfiguration":{"input":{"type":"structure","required":["vpceConfigurationName","vpceServiceName","serviceDnsName"],"members":{"vpceConfigurationName":{},"vpceServiceName":{},"serviceDnsName":{},"vpceConfigurationDescription":{}}},"output":{"type":"structure","members":{"vpceConfiguration":{"shape":"S1y"}}}},"DeleteDevicePool":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteInstanceProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteNetworkProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteProject":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteRemoteAccessSession":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteRun":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteUpload":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteVPCEConfiguration":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"GetAccountSettings":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"accountSettings":{"type":"structure","members":{"awsAccountNumber":{},"unmeteredDevices":{"shape":"S2j"},"unmeteredRemoteAccessDevices":{"shape":"S2j"},"maxJobTimeoutMinutes":{"type":"integer"},"trialMinutes":{"type":"structure","members":{"total":{"type":"double"},"remaining":{"type":"double"}}},"maxSlots":{"type":"map","key":{},"value":{"type":"integer"}},"defaultJobTimeoutMinutes":{"type":"integer"},"skipAppResign":{"type":"boolean"}}}}}},"GetDevice":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"device":{"shape":"S15"}}}},"GetDeviceInstance":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"deviceInstance":{"shape":"S1c"}}}},"GetDevicePool":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"devicePool":{"shape":"Sc"}}}},"GetDevicePoolCompatibility":{"input":{"type":"structure","required":["devicePoolArn"],"members":{"devicePoolArn":{},"appArn":{},"testType":{},"test":{"shape":"S2u"},"configuration":{"shape":"S2x"}}},"output":{"type":"structure","members":{"compatibleDevices":{"shape":"S35"},"incompatibleDevices":{"shape":"S35"}}}},"GetInstanceProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"instanceProfile":{"shape":"Si"}}}},"GetJob":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"job":{"shape":"S3d"}}}},"GetNetworkProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"networkProfile":{"shape":"So"}}}},"GetOfferingStatus":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"current":{"shape":"S3l"},"nextPeriod":{"shape":"S3l"},"nextToken":{}}}},"GetProject":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"project":{"shape":"Ss"}}}},"GetRemoteAccessSession":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"remoteAccessSession":{"shape":"S12"}}}},"GetRun":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"run":{"shape":"S42"}}}},"GetSuite":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"suite":{"shape":"S4b"}}}},"GetTest":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"test":{"shape":"S4e"}}}},"GetUpload":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"upload":{"shape":"S1n"}}}},"GetVPCEConfiguration":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"vpceConfiguration":{"shape":"S1y"}}}},"InstallToRemoteAccessSession":{"input":{"type":"structure","required":["remoteAccessSessionArn","appArn"],"members":{"remoteAccessSessionArn":{},"appArn":{}}},"output":{"type":"structure","members":{"appUpload":{"shape":"S1n"}}}},"ListArtifacts":{"input":{"type":"structure","required":["arn","type"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"artifacts":{"type":"list","member":{"type":"structure","members":{"arn":{},"name":{},"type":{},"extension":{},"url":{}}}},"nextToken":{}}}},"ListDeviceInstances":{"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"deviceInstances":{"shape":"S1b"},"nextToken":{}}}},"ListDevicePools":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"devicePools":{"type":"list","member":{"shape":"Sc"}},"nextToken":{}}}},"ListDevices":{"input":{"type":"structure","members":{"arn":{},"nextToken":{},"filters":{"shape":"S45"}}},"output":{"type":"structure","members":{"devices":{"type":"list","member":{"shape":"S15"}},"nextToken":{}}}},"ListInstanceProfiles":{"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"instanceProfiles":{"type":"list","member":{"shape":"Si"}},"nextToken":{}}}},"ListJobs":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"shape":"S3d"}},"nextToken":{}}}},"ListNetworkProfiles":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"networkProfiles":{"type":"list","member":{"shape":"So"}},"nextToken":{}}}},"ListOfferingPromotions":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"offeringPromotions":{"type":"list","member":{"type":"structure","members":{"id":{},"description":{}}}},"nextToken":{}}}},"ListOfferingTransactions":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"offeringTransactions":{"type":"list","member":{"shape":"S5g"}},"nextToken":{}}}},"ListOfferings":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"offerings":{"type":"list","member":{"shape":"S3p"}},"nextToken":{}}}},"ListProjects":{"input":{"type":"structure","members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"projects":{"type":"list","member":{"shape":"Ss"}},"nextToken":{}}}},"ListRemoteAccessSessions":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"remoteAccessSessions":{"type":"list","member":{"shape":"S12"}},"nextToken":{}}}},"ListRuns":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"runs":{"type":"list","member":{"shape":"S42"}},"nextToken":{}}}},"ListSamples":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"samples":{"type":"list","member":{"type":"structure","members":{"arn":{},"type":{},"url":{}}}},"nextToken":{}}}},"ListSuites":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"suites":{"type":"list","member":{"shape":"S4b"}},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S64"}}}},"ListTests":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"tests":{"type":"list","member":{"shape":"S4e"}},"nextToken":{}}}},"ListUniqueProblems":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"uniqueProblems":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"message":{},"problems":{"type":"list","member":{"type":"structure","members":{"run":{"shape":"S6i"},"job":{"shape":"S6i"},"suite":{"shape":"S6i"},"test":{"shape":"S6i"},"device":{"shape":"S15"},"result":{},"message":{}}}}}}}},"nextToken":{}}}},"ListUploads":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"uploads":{"type":"list","member":{"shape":"S1n"}},"nextToken":{}}}},"ListVPCEConfigurations":{"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"vpceConfigurations":{"type":"list","member":{"shape":"S1y"}},"nextToken":{}}}},"PurchaseOffering":{"input":{"type":"structure","members":{"offeringId":{},"quantity":{"type":"integer"},"offeringPromotionId":{}}},"output":{"type":"structure","members":{"offeringTransaction":{"shape":"S5g"}}}},"RenewOffering":{"input":{"type":"structure","members":{"offeringId":{},"quantity":{"type":"integer"}}},"output":{"type":"structure","members":{"offeringTransaction":{"shape":"S5g"}}}},"ScheduleRun":{"input":{"type":"structure","required":["projectArn","test"],"members":{"projectArn":{},"appArn":{},"devicePoolArn":{},"deviceSelectionConfiguration":{"type":"structure","required":["filters","maxDevices"],"members":{"filters":{"shape":"S45"},"maxDevices":{"type":"integer"}}},"name":{},"test":{"shape":"S2u"},"configuration":{"shape":"S2x"},"executionConfiguration":{"type":"structure","members":{"jobTimeoutMinutes":{"type":"integer"},"accountsCleanup":{"type":"boolean"},"appPackagesCleanup":{"type":"boolean"},"videoCapture":{"type":"boolean"},"skipAppResign":{"type":"boolean"}}}}},"output":{"type":"structure","members":{"run":{"shape":"S42"}}}},"StopJob":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"job":{"shape":"S3d"}}}},"StopRemoteAccessSession":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"remoteAccessSession":{"shape":"S12"}}}},"StopRun":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"run":{"shape":"S42"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S64"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDeviceInstance":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"profileArn":{},"labels":{"shape":"S1d"}}},"output":{"type":"structure","members":{"deviceInstance":{"shape":"S1c"}}}},"UpdateDevicePool":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"description":{},"rules":{"shape":"S5"},"maxDevices":{"type":"integer"},"clearMaxDevices":{"type":"boolean"}}},"output":{"type":"structure","members":{"devicePool":{"shape":"Sc"}}}},"UpdateInstanceProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"description":{},"packageCleanup":{"type":"boolean"},"excludeAppPackagesFromCleanup":{"shape":"Sg"},"rebootAfterUse":{"type":"boolean"}}},"output":{"type":"structure","members":{"instanceProfile":{"shape":"Si"}}}},"UpdateNetworkProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"description":{},"type":{},"uplinkBandwidthBits":{"type":"long"},"downlinkBandwidthBits":{"type":"long"},"uplinkDelayMs":{"type":"long"},"downlinkDelayMs":{"type":"long"},"uplinkJitterMs":{"type":"long"},"downlinkJitterMs":{"type":"long"},"uplinkLossPercent":{"type":"integer"},"downlinkLossPercent":{"type":"integer"}}},"output":{"type":"structure","members":{"networkProfile":{"shape":"So"}}}},"UpdateProject":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"defaultJobTimeoutMinutes":{"type":"integer"}}},"output":{"type":"structure","members":{"project":{"shape":"Ss"}}}},"UpdateUpload":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"contentType":{},"editContent":{"type":"boolean"}}},"output":{"type":"structure","members":{"upload":{"shape":"S1n"}}}},"UpdateVPCEConfiguration":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"vpceConfigurationName":{},"vpceServiceName":{},"serviceDnsName":{},"vpceConfigurationDescription":{}}},"output":{"type":"structure","members":{"vpceConfiguration":{"shape":"S1y"}}}}},"shapes":{"S5":{"type":"list","member":{"type":"structure","members":{"attribute":{},"operator":{},"value":{}}}},"Sc":{"type":"structure","members":{"arn":{},"name":{},"description":{},"type":{},"rules":{"shape":"S5"},"maxDevices":{"type":"integer"}}},"Sg":{"type":"list","member":{}},"Si":{"type":"structure","members":{"arn":{},"packageCleanup":{"type":"boolean"},"excludeAppPackagesFromCleanup":{"shape":"Sg"},"rebootAfterUse":{"type":"boolean"},"name":{},"description":{}}},"So":{"type":"structure","members":{"arn":{},"name":{},"description":{},"type":{},"uplinkBandwidthBits":{"type":"long"},"downlinkBandwidthBits":{"type":"long"},"uplinkDelayMs":{"type":"long"},"downlinkDelayMs":{"type":"long"},"uplinkJitterMs":{"type":"long"},"downlinkJitterMs":{"type":"long"},"uplinkLossPercent":{"type":"integer"},"downlinkLossPercent":{"type":"integer"}}},"Ss":{"type":"structure","members":{"arn":{},"name":{},"defaultJobTimeoutMinutes":{"type":"integer"},"created":{"type":"timestamp"}}},"Sz":{"type":"list","member":{}},"S12":{"type":"structure","members":{"arn":{},"name":{},"created":{"type":"timestamp"},"status":{},"result":{},"message":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"device":{"shape":"S15"},"instanceArn":{},"remoteDebugEnabled":{"type":"boolean"},"remoteRecordEnabled":{"type":"boolean"},"remoteRecordAppArn":{},"hostAddress":{},"clientId":{},"billingMethod":{},"deviceMinutes":{"shape":"S1h"},"endpoint":{},"deviceUdid":{},"interactionMode":{},"skipAppResign":{"type":"boolean"}}},"S15":{"type":"structure","members":{"arn":{},"name":{},"manufacturer":{},"model":{},"modelId":{},"formFactor":{},"platform":{},"os":{},"cpu":{"type":"structure","members":{"frequency":{},"architecture":{},"clock":{"type":"double"}}},"resolution":{"type":"structure","members":{"width":{"type":"integer"},"height":{"type":"integer"}}},"heapSize":{"type":"long"},"memory":{"type":"long"},"image":{},"carrier":{},"radio":{},"remoteAccessEnabled":{"type":"boolean"},"remoteDebugEnabled":{"type":"boolean"},"fleetType":{},"fleetName":{},"instances":{"shape":"S1b"},"availability":{}}},"S1b":{"type":"list","member":{"shape":"S1c"}},"S1c":{"type":"structure","members":{"arn":{},"deviceArn":{},"labels":{"shape":"S1d"},"status":{},"udid":{},"instanceProfile":{"shape":"Si"}}},"S1d":{"type":"list","member":{}},"S1h":{"type":"structure","members":{"total":{"type":"double"},"metered":{"type":"double"},"unmetered":{"type":"double"}}},"S1n":{"type":"structure","members":{"arn":{},"name":{},"created":{"type":"timestamp"},"type":{},"status":{},"url":{},"metadata":{},"contentType":{},"message":{},"category":{}}},"S1y":{"type":"structure","members":{"arn":{},"vpceConfigurationName":{},"vpceServiceName":{},"serviceDnsName":{},"vpceConfigurationDescription":{}}},"S2j":{"type":"map","key":{},"value":{"type":"integer"}},"S2u":{"type":"structure","required":["type"],"members":{"type":{},"testPackageArn":{},"testSpecArn":{},"filter":{},"parameters":{"type":"map","key":{},"value":{}}}},"S2x":{"type":"structure","members":{"extraDataPackageArn":{},"networkProfileArn":{},"locale":{},"location":{"shape":"S2y"},"vpceConfigurationArns":{"shape":"Sz"},"customerArtifactPaths":{"shape":"S2z"},"radios":{"shape":"S33"},"auxiliaryApps":{"shape":"Sz"},"billingMethod":{}}},"S2y":{"type":"structure","required":["latitude","longitude"],"members":{"latitude":{"type":"double"},"longitude":{"type":"double"}}},"S2z":{"type":"structure","members":{"iosPaths":{"type":"list","member":{}},"androidPaths":{"type":"list","member":{}},"deviceHostPaths":{"type":"list","member":{}}}},"S33":{"type":"structure","members":{"wifi":{"type":"boolean"},"bluetooth":{"type":"boolean"},"nfc":{"type":"boolean"},"gps":{"type":"boolean"}}},"S35":{"type":"list","member":{"type":"structure","members":{"device":{"shape":"S15"},"compatible":{"type":"boolean"},"incompatibilityMessages":{"type":"list","member":{"type":"structure","members":{"message":{},"type":{}}}}}}},"S3d":{"type":"structure","members":{"arn":{},"name":{},"type":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S3e"},"message":{},"device":{"shape":"S15"},"instanceArn":{},"deviceMinutes":{"shape":"S1h"},"videoEndpoint":{},"videoCapture":{"type":"boolean"}}},"S3e":{"type":"structure","members":{"total":{"type":"integer"},"passed":{"type":"integer"},"failed":{"type":"integer"},"warned":{"type":"integer"},"errored":{"type":"integer"},"stopped":{"type":"integer"},"skipped":{"type":"integer"}}},"S3l":{"type":"map","key":{},"value":{"shape":"S3n"}},"S3n":{"type":"structure","members":{"type":{},"offering":{"shape":"S3p"},"quantity":{"type":"integer"},"effectiveOn":{"type":"timestamp"}}},"S3p":{"type":"structure","members":{"id":{},"description":{},"type":{},"platform":{},"recurringCharges":{"type":"list","member":{"type":"structure","members":{"cost":{"shape":"S3t"},"frequency":{}}}}}},"S3t":{"type":"structure","members":{"amount":{"type":"double"},"currencyCode":{}}},"S42":{"type":"structure","members":{"arn":{},"name":{},"type":{},"platform":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S3e"},"message":{},"totalJobs":{"type":"integer"},"completedJobs":{"type":"integer"},"billingMethod":{},"deviceMinutes":{"shape":"S1h"},"networkProfile":{"shape":"So"},"parsingResultUrl":{},"resultCode":{},"seed":{"type":"integer"},"appUpload":{},"eventCount":{"type":"integer"},"jobTimeoutMinutes":{"type":"integer"},"devicePoolArn":{},"locale":{},"radios":{"shape":"S33"},"location":{"shape":"S2y"},"customerArtifactPaths":{"shape":"S2z"},"webUrl":{},"skipAppResign":{"type":"boolean"},"testSpecArn":{},"deviceSelectionResult":{"type":"structure","members":{"filters":{"shape":"S45"},"matchedDevicesCount":{"type":"integer"},"maxDevices":{"type":"integer"}}}}},"S45":{"type":"list","member":{"type":"structure","members":{"attribute":{},"operator":{},"values":{"type":"list","member":{}}}}},"S4b":{"type":"structure","members":{"arn":{},"name":{},"type":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S3e"},"message":{},"deviceMinutes":{"shape":"S1h"}}},"S4e":{"type":"structure","members":{"arn":{},"name":{},"type":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S3e"},"message":{},"deviceMinutes":{"shape":"S1h"}}},"S5g":{"type":"structure","members":{"offeringStatus":{"shape":"S3n"},"transactionId":{},"offeringPromotionId":{},"createdOn":{"type":"timestamp"},"cost":{"shape":"S3t"}}},"S64":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S6i":{"type":"structure","members":{"arn":{},"name":{}}}}}');

});

parcelRequire.register("h87NX", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"GetOfferingStatus":{"input_token":"nextToken","output_token":"nextToken","result_key":["current","nextPeriod"]},"ListArtifacts":{"input_token":"nextToken","output_token":"nextToken","result_key":"artifacts"},"ListDevicePools":{"input_token":"nextToken","output_token":"nextToken","result_key":"devicePools"},"ListDevices":{"input_token":"nextToken","output_token":"nextToken","result_key":"devices"},"ListJobs":{"input_token":"nextToken","output_token":"nextToken","result_key":"jobs"},"ListOfferingTransactions":{"input_token":"nextToken","output_token":"nextToken","result_key":"offeringTransactions"},"ListOfferings":{"input_token":"nextToken","output_token":"nextToken","result_key":"offerings"},"ListProjects":{"input_token":"nextToken","output_token":"nextToken","result_key":"projects"},"ListRuns":{"input_token":"nextToken","output_token":"nextToken","result_key":"runs"},"ListSamples":{"input_token":"nextToken","output_token":"nextToken","result_key":"samples"},"ListSuites":{"input_token":"nextToken","output_token":"nextToken","result_key":"suites"},"ListTests":{"input_token":"nextToken","output_token":"nextToken","result_key":"tests"},"ListUniqueProblems":{"input_token":"nextToken","output_token":"nextToken","result_key":"uniqueProblems"},"ListUploads":{"input_token":"nextToken","output_token":"nextToken","result_key":"uploads"}}}');

});


parcelRequire.register("cLQcf", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $94c25cf7d71f9605$var$Service = $dbC7k.Service;
var $94c25cf7d71f9605$var$apiLoader = $dbC7k.apiLoader;
$94c25cf7d71f9605$var$apiLoader.services["directconnect"] = {};
$dbC7k.DirectConnect = $94c25cf7d71f9605$var$Service.defineService("directconnect", [
    "2012-10-25"
]);


Object.defineProperty($94c25cf7d71f9605$var$apiLoader.services["directconnect"], "2012-10-25", {
    get: function get() {
        var model = (parcelRequire("cR39v"));
        model.paginators = (parcelRequire("a8lDx")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.DirectConnect;

});
parcelRequire.register("cR39v", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2012-10-25","endpointPrefix":"directconnect","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Direct Connect","serviceId":"Direct Connect","signatureVersion":"v4","targetPrefix":"OvertureService","uid":"directconnect-2012-10-25"},"operations":{"AcceptDirectConnectGatewayAssociationProposal":{"input":{"type":"structure","required":["directConnectGatewayId","proposalId","associatedGatewayOwnerAccount"],"members":{"directConnectGatewayId":{},"proposalId":{},"associatedGatewayOwnerAccount":{},"overrideAllowedPrefixesToDirectConnectGateway":{"shape":"S5"}}},"output":{"type":"structure","members":{"directConnectGatewayAssociation":{"shape":"S9"}}}},"AllocateConnectionOnInterconnect":{"input":{"type":"structure","required":["bandwidth","connectionName","ownerAccount","interconnectId","vlan"],"members":{"bandwidth":{},"connectionName":{},"ownerAccount":{},"interconnectId":{},"vlan":{"type":"integer"}}},"output":{"shape":"So"},"deprecated":true},"AllocateHostedConnection":{"input":{"type":"structure","required":["connectionId","ownerAccount","bandwidth","connectionName","vlan"],"members":{"connectionId":{},"ownerAccount":{},"bandwidth":{},"connectionName":{},"vlan":{"type":"integer"},"tags":{"shape":"Sz"}}},"output":{"shape":"So"}},"AllocatePrivateVirtualInterface":{"input":{"type":"structure","required":["connectionId","ownerAccount","newPrivateVirtualInterfaceAllocation"],"members":{"connectionId":{},"ownerAccount":{},"newPrivateVirtualInterfaceAllocation":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"mtu":{"type":"integer"},"authKey":{},"amazonAddress":{},"addressFamily":{},"customerAddress":{},"tags":{"shape":"Sz"}}}}},"output":{"shape":"S1d"}},"AllocatePublicVirtualInterface":{"input":{"type":"structure","required":["connectionId","ownerAccount","newPublicVirtualInterfaceAllocation"],"members":{"connectionId":{},"ownerAccount":{},"newPublicVirtualInterfaceAllocation":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"routeFilterPrefixes":{"shape":"S5"},"tags":{"shape":"Sz"}}}}},"output":{"shape":"S1d"}},"AllocateTransitVirtualInterface":{"input":{"type":"structure","required":["connectionId","ownerAccount","newTransitVirtualInterfaceAllocation"],"members":{"connectionId":{},"ownerAccount":{},"newTransitVirtualInterfaceAllocation":{"type":"structure","members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"mtu":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"tags":{"shape":"Sz"}}}}},"output":{"type":"structure","members":{"virtualInterface":{"shape":"S1d"}}}},"AssociateConnectionWithLag":{"input":{"type":"structure","required":["connectionId","lagId"],"members":{"connectionId":{},"lagId":{}}},"output":{"shape":"So"}},"AssociateHostedConnection":{"input":{"type":"structure","required":["connectionId","parentConnectionId"],"members":{"connectionId":{},"parentConnectionId":{}}},"output":{"shape":"So"}},"AssociateVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId","connectionId"],"members":{"virtualInterfaceId":{},"connectionId":{}}},"output":{"shape":"S1d"}},"ConfirmConnection":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{}}},"output":{"type":"structure","members":{"connectionState":{}}}},"ConfirmPrivateVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{},"virtualGatewayId":{"shape":"Sh"},"directConnectGatewayId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"ConfirmPublicVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"ConfirmTransitVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId","directConnectGatewayId"],"members":{"virtualInterfaceId":{},"directConnectGatewayId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"CreateBGPPeer":{"input":{"type":"structure","members":{"virtualInterfaceId":{},"newBGPPeer":{"type":"structure","members":{"asn":{"type":"integer"},"authKey":{},"addressFamily":{},"amazonAddress":{},"customerAddress":{}}}}},"output":{"type":"structure","members":{"virtualInterface":{"shape":"S1d"}}}},"CreateConnection":{"input":{"type":"structure","required":["location","bandwidth","connectionName"],"members":{"location":{},"bandwidth":{},"connectionName":{},"lagId":{},"tags":{"shape":"Sz"}}},"output":{"shape":"So"}},"CreateDirectConnectGateway":{"input":{"type":"structure","required":["directConnectGatewayName"],"members":{"directConnectGatewayName":{},"amazonSideAsn":{"type":"long"}}},"output":{"type":"structure","members":{"directConnectGateway":{"shape":"S2b"}}}},"CreateDirectConnectGatewayAssociation":{"input":{"type":"structure","required":["directConnectGatewayId"],"members":{"directConnectGatewayId":{},"gatewayId":{},"addAllowedPrefixesToDirectConnectGateway":{"shape":"S5"},"virtualGatewayId":{"shape":"Sh"}}},"output":{"type":"structure","members":{"directConnectGatewayAssociation":{"shape":"S9"}}}},"CreateDirectConnectGatewayAssociationProposal":{"input":{"type":"structure","required":["directConnectGatewayId","directConnectGatewayOwnerAccount","gatewayId"],"members":{"directConnectGatewayId":{},"directConnectGatewayOwnerAccount":{},"gatewayId":{},"addAllowedPrefixesToDirectConnectGateway":{"shape":"S5"},"removeAllowedPrefixesToDirectConnectGateway":{"shape":"S5"}}},"output":{"type":"structure","members":{"directConnectGatewayAssociationProposal":{"shape":"S2i"}}}},"CreateInterconnect":{"input":{"type":"structure","required":["interconnectName","bandwidth","location"],"members":{"interconnectName":{},"bandwidth":{},"location":{},"lagId":{},"tags":{"shape":"Sz"}}},"output":{"shape":"S2m"}},"CreateLag":{"input":{"type":"structure","required":["numberOfConnections","location","connectionsBandwidth","lagName"],"members":{"numberOfConnections":{"type":"integer"},"location":{},"connectionsBandwidth":{},"lagName":{},"connectionId":{},"tags":{"shape":"Sz"},"childConnectionTags":{"shape":"Sz"}}},"output":{"shape":"S2r"}},"CreatePrivateVirtualInterface":{"input":{"type":"structure","required":["connectionId","newPrivateVirtualInterface"],"members":{"connectionId":{},"newPrivateVirtualInterface":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"mtu":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"virtualGatewayId":{"shape":"Sh"},"directConnectGatewayId":{},"tags":{"shape":"Sz"}}}}},"output":{"shape":"S1d"}},"CreatePublicVirtualInterface":{"input":{"type":"structure","required":["connectionId","newPublicVirtualInterface"],"members":{"connectionId":{},"newPublicVirtualInterface":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"routeFilterPrefixes":{"shape":"S5"},"tags":{"shape":"Sz"}}}}},"output":{"shape":"S1d"}},"CreateTransitVirtualInterface":{"input":{"type":"structure","required":["connectionId","newTransitVirtualInterface"],"members":{"connectionId":{},"newTransitVirtualInterface":{"type":"structure","members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"mtu":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"directConnectGatewayId":{},"tags":{"shape":"Sz"}}}}},"output":{"type":"structure","members":{"virtualInterface":{"shape":"S1d"}}}},"DeleteBGPPeer":{"input":{"type":"structure","members":{"virtualInterfaceId":{},"asn":{"type":"integer"},"customerAddress":{},"bgpPeerId":{}}},"output":{"type":"structure","members":{"virtualInterface":{"shape":"S1d"}}}},"DeleteConnection":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{}}},"output":{"shape":"So"}},"DeleteDirectConnectGateway":{"input":{"type":"structure","required":["directConnectGatewayId"],"members":{"directConnectGatewayId":{}}},"output":{"type":"structure","members":{"directConnectGateway":{"shape":"S2b"}}}},"DeleteDirectConnectGatewayAssociation":{"input":{"type":"structure","members":{"associationId":{},"directConnectGatewayId":{},"virtualGatewayId":{"shape":"Sh"}}},"output":{"type":"structure","members":{"directConnectGatewayAssociation":{"shape":"S9"}}}},"DeleteDirectConnectGatewayAssociationProposal":{"input":{"type":"structure","required":["proposalId"],"members":{"proposalId":{}}},"output":{"type":"structure","members":{"directConnectGatewayAssociationProposal":{"shape":"S2i"}}}},"DeleteInterconnect":{"input":{"type":"structure","required":["interconnectId"],"members":{"interconnectId":{}}},"output":{"type":"structure","members":{"interconnectState":{}}}},"DeleteLag":{"input":{"type":"structure","required":["lagId"],"members":{"lagId":{}}},"output":{"shape":"S2r"}},"DeleteVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"DescribeConnectionLoa":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{},"providerName":{},"loaContentType":{}}},"output":{"type":"structure","members":{"loa":{"shape":"S3k"}}},"deprecated":true},"DescribeConnections":{"input":{"type":"structure","members":{"connectionId":{}}},"output":{"shape":"S3n"}},"DescribeConnectionsOnInterconnect":{"input":{"type":"structure","required":["interconnectId"],"members":{"interconnectId":{}}},"output":{"shape":"S3n"},"deprecated":true},"DescribeDirectConnectGatewayAssociationProposals":{"input":{"type":"structure","members":{"directConnectGatewayId":{},"proposalId":{},"associatedGatewayId":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"directConnectGatewayAssociationProposals":{"type":"list","member":{"shape":"S2i"}},"nextToken":{}}}},"DescribeDirectConnectGatewayAssociations":{"input":{"type":"structure","members":{"associationId":{},"associatedGatewayId":{},"directConnectGatewayId":{},"maxResults":{"type":"integer"},"nextToken":{},"virtualGatewayId":{"shape":"Sh"}}},"output":{"type":"structure","members":{"directConnectGatewayAssociations":{"type":"list","member":{"shape":"S9"}},"nextToken":{}}}},"DescribeDirectConnectGatewayAttachments":{"input":{"type":"structure","members":{"directConnectGatewayId":{},"virtualInterfaceId":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"directConnectGatewayAttachments":{"type":"list","member":{"type":"structure","members":{"directConnectGatewayId":{},"virtualInterfaceId":{},"virtualInterfaceRegion":{},"virtualInterfaceOwnerAccount":{},"attachmentState":{},"attachmentType":{},"stateChangeError":{}}}},"nextToken":{}}}},"DescribeDirectConnectGateways":{"input":{"type":"structure","members":{"directConnectGatewayId":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"directConnectGateways":{"type":"list","member":{"shape":"S2b"}},"nextToken":{}}}},"DescribeHostedConnections":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{}}},"output":{"shape":"S3n"}},"DescribeInterconnectLoa":{"input":{"type":"structure","required":["interconnectId"],"members":{"interconnectId":{},"providerName":{},"loaContentType":{}}},"output":{"type":"structure","members":{"loa":{"shape":"S3k"}}},"deprecated":true},"DescribeInterconnects":{"input":{"type":"structure","members":{"interconnectId":{}}},"output":{"type":"structure","members":{"interconnects":{"type":"list","member":{"shape":"S2m"}}}}},"DescribeLags":{"input":{"type":"structure","members":{"lagId":{}}},"output":{"type":"structure","members":{"lags":{"type":"list","member":{"shape":"S2r"}}}}},"DescribeLoa":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{},"providerName":{},"loaContentType":{}}},"output":{"shape":"S3k"}},"DescribeLocations":{"output":{"type":"structure","members":{"locations":{"type":"list","member":{"type":"structure","members":{"locationCode":{},"locationName":{},"region":{},"availablePortSpeeds":{"type":"list","member":{}}}}}}}},"DescribeTags":{"input":{"type":"structure","required":["resourceArns"],"members":{"resourceArns":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"resourceTags":{"type":"list","member":{"type":"structure","members":{"resourceArn":{},"tags":{"shape":"Sz"}}}}}}},"DescribeVirtualGateways":{"output":{"type":"structure","members":{"virtualGateways":{"type":"list","member":{"type":"structure","members":{"virtualGatewayId":{"shape":"Sh"},"virtualGatewayState":{}}}}}}},"DescribeVirtualInterfaces":{"input":{"type":"structure","members":{"connectionId":{},"virtualInterfaceId":{}}},"output":{"type":"structure","members":{"virtualInterfaces":{"type":"list","member":{"shape":"S1d"}}}}},"DisassociateConnectionFromLag":{"input":{"type":"structure","required":["connectionId","lagId"],"members":{"connectionId":{},"lagId":{}}},"output":{"shape":"So"}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"Sz"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDirectConnectGatewayAssociation":{"input":{"type":"structure","members":{"associationId":{},"addAllowedPrefixesToDirectConnectGateway":{"shape":"S5"},"removeAllowedPrefixesToDirectConnectGateway":{"shape":"S5"}}},"output":{"type":"structure","members":{"directConnectGatewayAssociation":{"shape":"S9"}}}},"UpdateLag":{"input":{"type":"structure","required":["lagId"],"members":{"lagId":{},"lagName":{},"minimumLinks":{"type":"integer"}}},"output":{"shape":"S2r"}},"UpdateVirtualInterfaceAttributes":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{},"mtu":{"type":"integer"}}},"output":{"shape":"S1d"}}},"shapes":{"S5":{"type":"list","member":{"type":"structure","members":{"cidr":{}}}},"S9":{"type":"structure","members":{"directConnectGatewayId":{},"directConnectGatewayOwnerAccount":{},"associationState":{},"stateChangeError":{},"associatedGateway":{"shape":"Sc"},"associationId":{},"allowedPrefixesToDirectConnectGateway":{"shape":"S5"},"virtualGatewayId":{"shape":"Sh"},"virtualGatewayRegion":{"type":"string","deprecated":true},"virtualGatewayOwnerAccount":{}}},"Sc":{"type":"structure","members":{"id":{},"type":{},"ownerAccount":{},"region":{}}},"Sh":{"type":"string","deprecated":true},"So":{"type":"structure","members":{"ownerAccount":{},"connectionId":{},"connectionName":{},"connectionState":{},"region":{},"location":{},"bandwidth":{},"vlan":{"type":"integer"},"partnerName":{},"loaIssueTime":{"type":"timestamp"},"lagId":{},"awsDevice":{"shape":"Sv"},"jumboFrameCapable":{"type":"boolean"},"awsDeviceV2":{},"hasLogicalRedundancy":{},"tags":{"shape":"Sz"}}},"Sv":{"type":"string","deprecated":true},"Sz":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}}},"S1d":{"type":"structure","members":{"ownerAccount":{},"virtualInterfaceId":{},"location":{},"connectionId":{},"virtualInterfaceType":{},"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"amazonSideAsn":{"type":"long"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"virtualInterfaceState":{},"customerRouterConfig":{},"mtu":{"type":"integer"},"jumboFrameCapable":{"type":"boolean"},"virtualGatewayId":{"shape":"Sh"},"directConnectGatewayId":{},"routeFilterPrefixes":{"shape":"S5"},"bgpPeers":{"type":"list","member":{"type":"structure","members":{"bgpPeerId":{},"asn":{"type":"integer"},"authKey":{},"addressFamily":{},"amazonAddress":{},"customerAddress":{},"bgpPeerState":{},"bgpStatus":{},"awsDeviceV2":{}}}},"region":{},"awsDeviceV2":{},"tags":{"shape":"Sz"}}},"S2b":{"type":"structure","members":{"directConnectGatewayId":{},"directConnectGatewayName":{},"amazonSideAsn":{"type":"long"},"ownerAccount":{},"directConnectGatewayState":{},"stateChangeError":{}}},"S2i":{"type":"structure","members":{"proposalId":{},"directConnectGatewayId":{},"directConnectGatewayOwnerAccount":{},"proposalState":{},"associatedGateway":{"shape":"Sc"},"existingAllowedPrefixesToDirectConnectGateway":{"shape":"S5"},"requestedAllowedPrefixesToDirectConnectGateway":{"shape":"S5"}}},"S2m":{"type":"structure","members":{"interconnectId":{},"interconnectName":{},"interconnectState":{},"region":{},"location":{},"bandwidth":{},"loaIssueTime":{"type":"timestamp"},"lagId":{},"awsDevice":{"shape":"Sv"},"jumboFrameCapable":{"type":"boolean"},"awsDeviceV2":{},"hasLogicalRedundancy":{},"tags":{"shape":"Sz"}}},"S2r":{"type":"structure","members":{"connectionsBandwidth":{},"numberOfConnections":{"type":"integer"},"lagId":{},"ownerAccount":{},"lagName":{},"lagState":{},"location":{},"region":{},"minimumLinks":{"type":"integer"},"awsDevice":{"shape":"Sv"},"awsDeviceV2":{},"connections":{"shape":"S2t"},"allowsHostedConnections":{"type":"boolean"},"jumboFrameCapable":{"type":"boolean"},"hasLogicalRedundancy":{},"tags":{"shape":"Sz"}}},"S2t":{"type":"list","member":{"shape":"So"}},"S3k":{"type":"structure","members":{"loaContent":{"type":"blob"},"loaContentType":{}}},"S3n":{"type":"structure","members":{"connections":{"shape":"S2t"}}}}}');

});

parcelRequire.register("a8lDx", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeConnections":{"result_key":"connections"},"DescribeConnectionsOnInterconnect":{"result_key":"connections"},"DescribeInterconnects":{"result_key":"interconnects"},"DescribeLocations":{"result_key":"locations"},"DescribeVirtualGateways":{"result_key":"virtualGateways"},"DescribeVirtualInterfaces":{"result_key":"virtualInterfaces"}}}');

});


parcelRequire.register("gG6yG", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $c245a7f4af55b21c$var$Service = $dbC7k.Service;
var $c245a7f4af55b21c$var$apiLoader = $dbC7k.apiLoader;
$c245a7f4af55b21c$var$apiLoader.services["directoryservice"] = {};
$dbC7k.DirectoryService = $c245a7f4af55b21c$var$Service.defineService("directoryservice", [
    "2015-04-16"
]);


Object.defineProperty($c245a7f4af55b21c$var$apiLoader.services["directoryservice"], "2015-04-16", {
    get: function get() {
        var model = (parcelRequire("9AxNN"));
        model.paginators = (parcelRequire("6iOgV")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.DirectoryService;

});
parcelRequire.register("9AxNN", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-04-16","endpointPrefix":"ds","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Directory Service","serviceFullName":"AWS Directory Service","serviceId":"Directory Service","signatureVersion":"v4","targetPrefix":"DirectoryService_20150416","uid":"ds-2015-04-16"},"operations":{"AcceptSharedDirectory":{"input":{"type":"structure","required":["SharedDirectoryId"],"members":{"SharedDirectoryId":{}}},"output":{"type":"structure","members":{"SharedDirectory":{"shape":"S4"}}}},"AddIpRoutes":{"input":{"type":"structure","required":["DirectoryId","IpRoutes"],"members":{"DirectoryId":{},"IpRoutes":{"type":"list","member":{"type":"structure","members":{"CidrIp":{},"Description":{}}}},"UpdateSecurityGroupForDirectoryControllers":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceId","Tags"],"members":{"ResourceId":{},"Tags":{"shape":"Sk"}}},"output":{"type":"structure","members":{}}},"CancelSchemaExtension":{"input":{"type":"structure","required":["DirectoryId","SchemaExtensionId"],"members":{"DirectoryId":{},"SchemaExtensionId":{}}},"output":{"type":"structure","members":{}}},"ConnectDirectory":{"input":{"type":"structure","required":["Name","Password","Size","ConnectSettings"],"members":{"Name":{},"ShortName":{},"Password":{"shape":"Sv"},"Description":{},"Size":{},"ConnectSettings":{"type":"structure","required":["VpcId","SubnetIds","CustomerDnsIps","CustomerUserName"],"members":{"VpcId":{},"SubnetIds":{"shape":"Sz"},"CustomerDnsIps":{"shape":"S11"},"CustomerUserName":{}}},"Tags":{"shape":"Sk"}}},"output":{"type":"structure","members":{"DirectoryId":{}}}},"CreateAlias":{"input":{"type":"structure","required":["DirectoryId","Alias"],"members":{"DirectoryId":{},"Alias":{}}},"output":{"type":"structure","members":{"DirectoryId":{},"Alias":{}}}},"CreateComputer":{"input":{"type":"structure","required":["DirectoryId","ComputerName","Password"],"members":{"DirectoryId":{},"ComputerName":{},"Password":{"type":"string","sensitive":true},"OrganizationalUnitDistinguishedName":{},"ComputerAttributes":{"shape":"S1c"}}},"output":{"type":"structure","members":{"Computer":{"type":"structure","members":{"ComputerId":{},"ComputerName":{},"ComputerAttributes":{"shape":"S1c"}}}}}},"CreateConditionalForwarder":{"input":{"type":"structure","required":["DirectoryId","RemoteDomainName","DnsIpAddrs"],"members":{"DirectoryId":{},"RemoteDomainName":{},"DnsIpAddrs":{"shape":"S11"}}},"output":{"type":"structure","members":{}}},"CreateDirectory":{"input":{"type":"structure","required":["Name","Password","Size"],"members":{"Name":{},"ShortName":{},"Password":{"shape":"S1n"},"Description":{},"Size":{},"VpcSettings":{"shape":"S1o"},"Tags":{"shape":"Sk"}}},"output":{"type":"structure","members":{"DirectoryId":{}}}},"CreateLogSubscription":{"input":{"type":"structure","required":["DirectoryId","LogGroupName"],"members":{"DirectoryId":{},"LogGroupName":{}}},"output":{"type":"structure","members":{}}},"CreateMicrosoftAD":{"input":{"type":"structure","required":["Name","Password","VpcSettings"],"members":{"Name":{},"ShortName":{},"Password":{"shape":"S1n"},"Description":{},"VpcSettings":{"shape":"S1o"},"Edition":{},"Tags":{"shape":"Sk"}}},"output":{"type":"structure","members":{"DirectoryId":{}}}},"CreateSnapshot":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{},"Name":{}}},"output":{"type":"structure","members":{"SnapshotId":{}}}},"CreateTrust":{"input":{"type":"structure","required":["DirectoryId","RemoteDomainName","TrustPassword","TrustDirection"],"members":{"DirectoryId":{},"RemoteDomainName":{},"TrustPassword":{"type":"string","sensitive":true},"TrustDirection":{},"TrustType":{},"ConditionalForwarderIpAddrs":{"shape":"S11"},"SelectiveAuth":{}}},"output":{"type":"structure","members":{"TrustId":{}}}},"DeleteConditionalForwarder":{"input":{"type":"structure","required":["DirectoryId","RemoteDomainName"],"members":{"DirectoryId":{},"RemoteDomainName":{}}},"output":{"type":"structure","members":{}}},"DeleteDirectory":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{}}},"output":{"type":"structure","members":{"DirectoryId":{}}}},"DeleteLogSubscription":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{}}},"output":{"type":"structure","members":{}}},"DeleteSnapshot":{"input":{"type":"structure","required":["SnapshotId"],"members":{"SnapshotId":{}}},"output":{"type":"structure","members":{"SnapshotId":{}}}},"DeleteTrust":{"input":{"type":"structure","required":["TrustId"],"members":{"TrustId":{},"DeleteAssociatedConditionalForwarder":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrustId":{}}}},"DeregisterEventTopic":{"input":{"type":"structure","required":["DirectoryId","TopicName"],"members":{"DirectoryId":{},"TopicName":{}}},"output":{"type":"structure","members":{}}},"DescribeConditionalForwarders":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{},"RemoteDomainNames":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ConditionalForwarders":{"type":"list","member":{"type":"structure","members":{"RemoteDomainName":{},"DnsIpAddrs":{"shape":"S11"},"ReplicationScope":{}}}}}}},"DescribeDirectories":{"input":{"type":"structure","members":{"DirectoryIds":{"shape":"S2s"},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"DirectoryDescriptions":{"type":"list","member":{"type":"structure","members":{"DirectoryId":{},"Name":{},"ShortName":{},"Size":{},"Edition":{},"Alias":{},"AccessUrl":{},"Description":{},"DnsIpAddrs":{"shape":"S11"},"Stage":{},"ShareStatus":{},"ShareMethod":{},"ShareNotes":{"shape":"S8"},"LaunchTime":{"type":"timestamp"},"StageLastUpdatedDateTime":{"type":"timestamp"},"Type":{},"VpcSettings":{"shape":"S32"},"ConnectSettings":{"type":"structure","members":{"VpcId":{},"SubnetIds":{"shape":"Sz"},"CustomerUserName":{},"SecurityGroupId":{},"AvailabilityZones":{"shape":"S34"},"ConnectIps":{"type":"list","member":{}}}},"RadiusSettings":{"shape":"S38"},"RadiusStatus":{},"StageReason":{},"SsoEnabled":{"type":"boolean"},"DesiredNumberOfDomainControllers":{"type":"integer"},"OwnerDirectoryDescription":{"type":"structure","members":{"DirectoryId":{},"AccountId":{},"DnsIpAddrs":{"shape":"S11"},"VpcSettings":{"shape":"S32"},"RadiusSettings":{"shape":"S38"},"RadiusStatus":{}}}}}},"NextToken":{}}}},"DescribeDomainControllers":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{},"DomainControllerIds":{"type":"list","member":{}},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"DomainControllers":{"type":"list","member":{"type":"structure","members":{"DirectoryId":{},"DomainControllerId":{},"DnsIpAddr":{},"VpcId":{},"SubnetId":{},"AvailabilityZone":{},"Status":{},"StatusReason":{},"LaunchTime":{"type":"timestamp"},"StatusLastUpdatedDateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeEventTopics":{"input":{"type":"structure","members":{"DirectoryId":{},"TopicNames":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"EventTopics":{"type":"list","member":{"type":"structure","members":{"DirectoryId":{},"TopicName":{},"TopicArn":{},"CreatedDateTime":{"type":"timestamp"},"Status":{}}}}}}},"DescribeSharedDirectories":{"input":{"type":"structure","required":["OwnerDirectoryId"],"members":{"OwnerDirectoryId":{},"SharedDirectoryIds":{"shape":"S2s"},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"SharedDirectories":{"type":"list","member":{"shape":"S4"}},"NextToken":{}}}},"DescribeSnapshots":{"input":{"type":"structure","members":{"DirectoryId":{},"SnapshotIds":{"type":"list","member":{}},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Snapshots":{"type":"list","member":{"type":"structure","members":{"DirectoryId":{},"SnapshotId":{},"Type":{},"Name":{},"Status":{},"StartTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeTrusts":{"input":{"type":"structure","members":{"DirectoryId":{},"TrustIds":{"type":"list","member":{}},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Trusts":{"type":"list","member":{"type":"structure","members":{"DirectoryId":{},"TrustId":{},"RemoteDomainName":{},"TrustType":{},"TrustDirection":{},"TrustState":{},"CreatedDateTime":{"type":"timestamp"},"LastUpdatedDateTime":{"type":"timestamp"},"StateLastUpdatedDateTime":{"type":"timestamp"},"TrustStateReason":{},"SelectiveAuth":{}}}},"NextToken":{}}}},"DisableRadius":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{}}},"output":{"type":"structure","members":{}}},"DisableSso":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{},"UserName":{},"Password":{"shape":"Sv"}}},"output":{"type":"structure","members":{}}},"EnableRadius":{"input":{"type":"structure","required":["DirectoryId","RadiusSettings"],"members":{"DirectoryId":{},"RadiusSettings":{"shape":"S38"}}},"output":{"type":"structure","members":{}}},"EnableSso":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{},"UserName":{},"Password":{"shape":"Sv"}}},"output":{"type":"structure","members":{}}},"GetDirectoryLimits":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"DirectoryLimits":{"type":"structure","members":{"CloudOnlyDirectoriesLimit":{"type":"integer"},"CloudOnlyDirectoriesCurrentCount":{"type":"integer"},"CloudOnlyDirectoriesLimitReached":{"type":"boolean"},"CloudOnlyMicrosoftADLimit":{"type":"integer"},"CloudOnlyMicrosoftADCurrentCount":{"type":"integer"},"CloudOnlyMicrosoftADLimitReached":{"type":"boolean"},"ConnectedDirectoriesLimit":{"type":"integer"},"ConnectedDirectoriesCurrentCount":{"type":"integer"},"ConnectedDirectoriesLimitReached":{"type":"boolean"}}}}}},"GetSnapshotLimits":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{}}},"output":{"type":"structure","members":{"SnapshotLimits":{"type":"structure","members":{"ManualSnapshotsLimit":{"type":"integer"},"ManualSnapshotsCurrentCount":{"type":"integer"},"ManualSnapshotsLimitReached":{"type":"boolean"}}}}}},"ListIpRoutes":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"IpRoutesInfo":{"type":"list","member":{"type":"structure","members":{"DirectoryId":{},"CidrIp":{},"IpRouteStatusMsg":{},"AddedDateTime":{"type":"timestamp"},"IpRouteStatusReason":{},"Description":{}}}},"NextToken":{}}}},"ListLogSubscriptions":{"input":{"type":"structure","members":{"DirectoryId":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"LogSubscriptions":{"type":"list","member":{"type":"structure","members":{"DirectoryId":{},"LogGroupName":{},"SubscriptionCreatedDateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListSchemaExtensions":{"input":{"type":"structure","required":["DirectoryId"],"members":{"DirectoryId":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"SchemaExtensionsInfo":{"type":"list","member":{"type":"structure","members":{"DirectoryId":{},"SchemaExtensionId":{},"Description":{},"SchemaExtensionStatus":{},"SchemaExtensionStatusReason":{},"StartDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sk"},"NextToken":{}}}},"RegisterEventTopic":{"input":{"type":"structure","required":["DirectoryId","TopicName"],"members":{"DirectoryId":{},"TopicName":{}}},"output":{"type":"structure","members":{}}},"RejectSharedDirectory":{"input":{"type":"structure","required":["SharedDirectoryId"],"members":{"SharedDirectoryId":{}}},"output":{"type":"structure","members":{"SharedDirectoryId":{}}}},"RemoveIpRoutes":{"input":{"type":"structure","required":["DirectoryId","CidrIps"],"members":{"DirectoryId":{},"CidrIps":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceId","TagKeys"],"members":{"ResourceId":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"ResetUserPassword":{"input":{"type":"structure","required":["DirectoryId","UserName","NewPassword"],"members":{"DirectoryId":{},"UserName":{},"NewPassword":{"type":"string","sensitive":true}}},"output":{"type":"structure","members":{}}},"RestoreFromSnapshot":{"input":{"type":"structure","required":["SnapshotId"],"members":{"SnapshotId":{}}},"output":{"type":"structure","members":{}}},"ShareDirectory":{"input":{"type":"structure","required":["DirectoryId","ShareTarget","ShareMethod"],"members":{"DirectoryId":{},"ShareNotes":{"shape":"S8"},"ShareTarget":{"type":"structure","required":["Id","Type"],"members":{"Id":{},"Type":{}}},"ShareMethod":{}}},"output":{"type":"structure","members":{"SharedDirectoryId":{}}}},"StartSchemaExtension":{"input":{"type":"structure","required":["DirectoryId","CreateSnapshotBeforeSchemaExtension","LdifContent","Description"],"members":{"DirectoryId":{},"CreateSnapshotBeforeSchemaExtension":{"type":"boolean"},"LdifContent":{},"Description":{}}},"output":{"type":"structure","members":{"SchemaExtensionId":{}}}},"UnshareDirectory":{"input":{"type":"structure","required":["DirectoryId","UnshareTarget"],"members":{"DirectoryId":{},"UnshareTarget":{"type":"structure","required":["Id","Type"],"members":{"Id":{},"Type":{}}}}},"output":{"type":"structure","members":{"SharedDirectoryId":{}}}},"UpdateConditionalForwarder":{"input":{"type":"structure","required":["DirectoryId","RemoteDomainName","DnsIpAddrs"],"members":{"DirectoryId":{},"RemoteDomainName":{},"DnsIpAddrs":{"shape":"S11"}}},"output":{"type":"structure","members":{}}},"UpdateNumberOfDomainControllers":{"input":{"type":"structure","required":["DirectoryId","DesiredNumber"],"members":{"DirectoryId":{},"DesiredNumber":{"type":"integer"}}},"output":{"type":"structure","members":{}}},"UpdateRadius":{"input":{"type":"structure","required":["DirectoryId","RadiusSettings"],"members":{"DirectoryId":{},"RadiusSettings":{"shape":"S38"}}},"output":{"type":"structure","members":{}}},"UpdateTrust":{"input":{"type":"structure","required":["TrustId"],"members":{"TrustId":{},"SelectiveAuth":{}}},"output":{"type":"structure","members":{"RequestId":{},"TrustId":{}}}},"VerifyTrust":{"input":{"type":"structure","required":["TrustId"],"members":{"TrustId":{}}},"output":{"type":"structure","members":{"TrustId":{}}}}},"shapes":{"S4":{"type":"structure","members":{"OwnerAccountId":{},"OwnerDirectoryId":{},"ShareMethod":{},"SharedAccountId":{},"SharedDirectoryId":{},"ShareStatus":{},"ShareNotes":{"shape":"S8"},"CreatedDateTime":{"type":"timestamp"},"LastUpdatedDateTime":{"type":"timestamp"}}},"S8":{"type":"string","sensitive":true},"Sk":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sv":{"type":"string","sensitive":true},"Sz":{"type":"list","member":{}},"S11":{"type":"list","member":{}},"S1c":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}}},"S1n":{"type":"string","sensitive":true},"S1o":{"type":"structure","required":["VpcId","SubnetIds"],"members":{"VpcId":{},"SubnetIds":{"shape":"Sz"}}},"S2s":{"type":"list","member":{}},"S32":{"type":"structure","members":{"VpcId":{},"SubnetIds":{"shape":"Sz"},"SecurityGroupId":{},"AvailabilityZones":{"shape":"S34"}}},"S34":{"type":"list","member":{}},"S38":{"type":"structure","members":{"RadiusServers":{"type":"list","member":{}},"RadiusPort":{"type":"integer"},"RadiusTimeout":{"type":"integer"},"RadiusRetries":{"type":"integer"},"SharedSecret":{"type":"string","sensitive":true},"AuthenticationProtocol":{},"DisplayLabel":{},"UseSameUsername":{"type":"boolean"}}}}}');

});

parcelRequire.register("6iOgV", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeDomainControllers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit"}}}');

});


parcelRequire.register("9M49d", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $71dbd0645ddf585b$var$Service = $dbC7k.Service;
var $71dbd0645ddf585b$var$apiLoader = $dbC7k.apiLoader;
$71dbd0645ddf585b$var$apiLoader.services["discovery"] = {};
$dbC7k.Discovery = $71dbd0645ddf585b$var$Service.defineService("discovery", [
    "2015-11-01"
]);


Object.defineProperty($71dbd0645ddf585b$var$apiLoader.services["discovery"], "2015-11-01", {
    get: function get() {
        var model = (parcelRequire("62Zzc"));
        model.paginators = (parcelRequire("6XIJI")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Discovery;

});
parcelRequire.register("62Zzc", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-11-01","endpointPrefix":"discovery","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Application Discovery Service","serviceId":"Application Discovery Service","signatureVersion":"v4","targetPrefix":"AWSPoseidonService_V2015_11_01","uid":"discovery-2015-11-01"},"operations":{"AssociateConfigurationItemsToApplication":{"input":{"type":"structure","required":["applicationConfigurationId","configurationIds"],"members":{"applicationConfigurationId":{},"configurationIds":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"BatchDeleteImportData":{"input":{"type":"structure","required":["importTaskIds"],"members":{"importTaskIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"errors":{"type":"list","member":{"type":"structure","members":{"importTaskId":{},"errorCode":{},"errorDescription":{}}}}}}},"CreateApplication":{"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{}}},"output":{"type":"structure","members":{"configurationId":{}}}},"CreateTags":{"input":{"type":"structure","required":["configurationIds","tags"],"members":{"configurationIds":{"shape":"S3"},"tags":{"shape":"Si"}}},"output":{"type":"structure","members":{}}},"DeleteApplications":{"input":{"type":"structure","required":["configurationIds"],"members":{"configurationIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"DeleteTags":{"input":{"type":"structure","required":["configurationIds"],"members":{"configurationIds":{"shape":"S3"},"tags":{"shape":"Si"}}},"output":{"type":"structure","members":{}}},"DescribeAgents":{"input":{"type":"structure","members":{"agentIds":{"shape":"St"},"filters":{"shape":"Sv"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"agentsInfo":{"type":"list","member":{"type":"structure","members":{"agentId":{},"hostName":{},"agentNetworkInfoList":{"type":"list","member":{"type":"structure","members":{"ipAddress":{},"macAddress":{}}}},"connectorId":{},"version":{},"health":{},"lastHealthPingTime":{},"collectionStatus":{},"agentType":{},"registeredTime":{}}}},"nextToken":{}}}},"DescribeConfigurations":{"input":{"type":"structure","required":["configurationIds"],"members":{"configurationIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"configurations":{"type":"list","member":{"type":"map","key":{},"value":{}}}}}},"DescribeContinuousExports":{"input":{"type":"structure","members":{"exportIds":{"type":"list","member":{}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"descriptions":{"type":"list","member":{"type":"structure","members":{"exportId":{},"status":{},"statusDetail":{},"s3Bucket":{},"startTime":{"type":"timestamp"},"stopTime":{"type":"timestamp"},"dataSource":{},"schemaStorageConfig":{"shape":"S1o"}}}},"nextToken":{}}}},"DescribeExportConfigurations":{"input":{"type":"structure","members":{"exportIds":{"shape":"S1r"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"exportsInfo":{"shape":"S1t"},"nextToken":{}}},"deprecated":true},"DescribeExportTasks":{"input":{"type":"structure","members":{"exportIds":{"shape":"S1r"},"filters":{"shape":"S21"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"exportsInfo":{"shape":"S1t"},"nextToken":{}}}},"DescribeImportTasks":{"input":{"type":"structure","members":{"filters":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"type":"list","member":{}}}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"nextToken":{},"tasks":{"type":"list","member":{"shape":"S2e"}}}}},"DescribeTags":{"input":{"type":"structure","members":{"filters":{"type":"list","member":{"type":"structure","required":["name","values"],"members":{"name":{},"values":{"shape":"Sx"}}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"tags":{"type":"list","member":{"type":"structure","members":{"configurationType":{},"configurationId":{},"key":{},"value":{},"timeOfCreation":{"type":"timestamp"}}}},"nextToken":{}}}},"DisassociateConfigurationItemsFromApplication":{"input":{"type":"structure","required":["applicationConfigurationId","configurationIds"],"members":{"applicationConfigurationId":{},"configurationIds":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"ExportConfigurations":{"output":{"type":"structure","members":{"exportId":{}}},"deprecated":true},"GetDiscoverySummary":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"servers":{"type":"long"},"applications":{"type":"long"},"serversMappedToApplications":{"type":"long"},"serversMappedtoTags":{"type":"long"},"agentSummary":{"type":"structure","required":["activeAgents","healthyAgents","blackListedAgents","shutdownAgents","unhealthyAgents","totalAgents","unknownAgents"],"members":{"activeAgents":{"type":"integer"},"healthyAgents":{"type":"integer"},"blackListedAgents":{"type":"integer"},"shutdownAgents":{"type":"integer"},"unhealthyAgents":{"type":"integer"},"totalAgents":{"type":"integer"},"unknownAgents":{"type":"integer"}}},"connectorSummary":{"type":"structure","required":["activeConnectors","healthyConnectors","blackListedConnectors","shutdownConnectors","unhealthyConnectors","totalConnectors","unknownConnectors"],"members":{"activeConnectors":{"type":"integer"},"healthyConnectors":{"type":"integer"},"blackListedConnectors":{"type":"integer"},"shutdownConnectors":{"type":"integer"},"unhealthyConnectors":{"type":"integer"},"totalConnectors":{"type":"integer"},"unknownConnectors":{"type":"integer"}}}}}},"ListConfigurations":{"input":{"type":"structure","required":["configurationType"],"members":{"configurationType":{},"filters":{"shape":"Sv"},"maxResults":{"type":"integer"},"nextToken":{},"orderBy":{"type":"list","member":{"type":"structure","required":["fieldName"],"members":{"fieldName":{},"sortOrder":{}}}}}},"output":{"type":"structure","members":{"configurations":{"type":"list","member":{"type":"map","key":{},"value":{}}},"nextToken":{}}}},"ListServerNeighbors":{"input":{"type":"structure","required":["configurationId"],"members":{"configurationId":{},"portInformationNeeded":{"type":"boolean"},"neighborConfigurationIds":{"shape":"S3"},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["neighbors"],"members":{"neighbors":{"type":"list","member":{"type":"structure","required":["sourceServerId","destinationServerId","connectionsCount"],"members":{"sourceServerId":{},"destinationServerId":{},"destinationPort":{"type":"integer"},"transportProtocol":{},"connectionsCount":{"type":"long"}}}},"nextToken":{},"knownDependencyCount":{"type":"long"}}}},"StartContinuousExport":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"exportId":{},"s3Bucket":{},"startTime":{"type":"timestamp"},"dataSource":{},"schemaStorageConfig":{"shape":"S1o"}}}},"StartDataCollectionByAgentIds":{"input":{"type":"structure","required":["agentIds"],"members":{"agentIds":{"shape":"St"}}},"output":{"type":"structure","members":{"agentsConfigurationStatus":{"shape":"S3f"}}}},"StartExportTask":{"input":{"type":"structure","members":{"exportDataFormat":{"type":"list","member":{}},"filters":{"shape":"S21"},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"exportId":{}}}},"StartImportTask":{"input":{"type":"structure","required":["name","importUrl"],"members":{"clientRequestToken":{"idempotencyToken":true},"name":{},"importUrl":{}}},"output":{"type":"structure","members":{"task":{"shape":"S2e"}}}},"StopContinuousExport":{"input":{"type":"structure","required":["exportId"],"members":{"exportId":{}}},"output":{"type":"structure","members":{"startTime":{"type":"timestamp"},"stopTime":{"type":"timestamp"}}}},"StopDataCollectionByAgentIds":{"input":{"type":"structure","required":["agentIds"],"members":{"agentIds":{"shape":"St"}}},"output":{"type":"structure","members":{"agentsConfigurationStatus":{"shape":"S3f"}}}},"UpdateApplication":{"input":{"type":"structure","required":["configurationId"],"members":{"configurationId":{},"name":{},"description":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S3":{"type":"list","member":{}},"Si":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"St":{"type":"list","member":{}},"Sv":{"type":"list","member":{"type":"structure","required":["name","values","condition"],"members":{"name":{},"values":{"shape":"Sx"},"condition":{}}}},"Sx":{"type":"list","member":{}},"S1o":{"type":"map","key":{},"value":{}},"S1r":{"type":"list","member":{}},"S1t":{"type":"list","member":{"type":"structure","required":["exportId","exportStatus","statusMessage","exportRequestTime"],"members":{"exportId":{},"exportStatus":{},"statusMessage":{},"configurationsDownloadUrl":{},"exportRequestTime":{"type":"timestamp"},"isTruncated":{"type":"boolean"},"requestedStartTime":{"type":"timestamp"},"requestedEndTime":{"type":"timestamp"}}}},"S21":{"type":"list","member":{"type":"structure","required":["name","values","condition"],"members":{"name":{},"values":{"shape":"Sx"},"condition":{}}}},"S2e":{"type":"structure","members":{"importTaskId":{},"clientRequestToken":{},"name":{},"importUrl":{},"status":{},"importRequestTime":{"type":"timestamp"},"importCompletionTime":{"type":"timestamp"},"importDeletedTime":{"type":"timestamp"},"serverImportSuccess":{"type":"integer"},"serverImportFailure":{"type":"integer"},"applicationImportSuccess":{"type":"integer"},"applicationImportFailure":{"type":"integer"},"errorsAndFailedEntriesZip":{}}},"S3f":{"type":"list","member":{"type":"structure","members":{"agentId":{},"operationSucceeded":{"type":"boolean"},"description":{}}}}}}');

});

parcelRequire.register("6XIJI", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeContinuousExports":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"DescribeImportTasks":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}');

});


parcelRequire.register("dfRu7", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $9a662a0c69283f09$var$Service = $dbC7k.Service;
var $9a662a0c69283f09$var$apiLoader = $dbC7k.apiLoader;
$9a662a0c69283f09$var$apiLoader.services["dms"] = {};
$dbC7k.DMS = $9a662a0c69283f09$var$Service.defineService("dms", [
    "2016-01-01"
]);



Object.defineProperty($9a662a0c69283f09$var$apiLoader.services["dms"], "2016-01-01", {
    get: function get() {
        var model = (parcelRequire("gQ2Xo"));
        model.paginators = (parcelRequire("d4YQx")).pagination;
        model.waiters = (parcelRequire("k5DZL")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.DMS;

});
parcelRequire.register("gQ2Xo", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-01-01","endpointPrefix":"dms","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Database Migration Service","serviceId":"Database Migration Service","signatureVersion":"v4","targetPrefix":"AmazonDMSv20160101","uid":"dms-2016-01-01"},"operations":{"AddTagsToResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"ApplyPendingMaintenanceAction":{"input":{"type":"structure","required":["ReplicationInstanceArn","ApplyAction","OptInType"],"members":{"ReplicationInstanceArn":{},"ApplyAction":{},"OptInType":{}}},"output":{"type":"structure","members":{"ResourcePendingMaintenanceActions":{"shape":"S8"}}}},"CreateEndpoint":{"input":{"type":"structure","required":["EndpointIdentifier","EndpointType","EngineName"],"members":{"EndpointIdentifier":{},"EndpointType":{},"EngineName":{},"Username":{},"Password":{"shape":"Se"},"ServerName":{},"Port":{"type":"integer"},"DatabaseName":{},"ExtraConnectionAttributes":{},"KmsKeyId":{},"Tags":{"shape":"S3"},"CertificateArn":{},"SslMode":{},"ServiceAccessRoleArn":{},"ExternalTableDefinition":{},"DynamoDbSettings":{"shape":"Sh"},"S3Settings":{"shape":"Si"},"DmsTransferSettings":{"shape":"Sp"},"MongoDbSettings":{"shape":"Sq"},"KinesisSettings":{"shape":"Su"},"ElasticsearchSettings":{"shape":"Sw"},"RedshiftSettings":{"shape":"Sx"}}},"output":{"type":"structure","members":{"Endpoint":{"shape":"Sz"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S11"},"SourceIds":{"shape":"S12"},"Enabled":{"type":"boolean"},"Tags":{"shape":"S3"}}},"output":{"type":"structure","members":{"EventSubscription":{"shape":"S14"}}}},"CreateReplicationInstance":{"input":{"type":"structure","required":["ReplicationInstanceIdentifier","ReplicationInstanceClass"],"members":{"ReplicationInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"ReplicationInstanceClass":{},"VpcSecurityGroupIds":{"shape":"S17"},"AvailabilityZone":{},"ReplicationSubnetGroupIdentifier":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"Tags":{"shape":"S3"},"KmsKeyId":{},"PubliclyAccessible":{"type":"boolean"},"DnsNameServers":{}}},"output":{"type":"structure","members":{"ReplicationInstance":{"shape":"S19"}}}},"CreateReplicationSubnetGroup":{"input":{"type":"structure","required":["ReplicationSubnetGroupIdentifier","ReplicationSubnetGroupDescription","SubnetIds"],"members":{"ReplicationSubnetGroupIdentifier":{},"ReplicationSubnetGroupDescription":{},"SubnetIds":{"shape":"S1l"},"Tags":{"shape":"S3"}}},"output":{"type":"structure","members":{"ReplicationSubnetGroup":{"shape":"S1d"}}}},"CreateReplicationTask":{"input":{"type":"structure","required":["ReplicationTaskIdentifier","SourceEndpointArn","TargetEndpointArn","ReplicationInstanceArn","MigrationType","TableMappings"],"members":{"ReplicationTaskIdentifier":{},"SourceEndpointArn":{},"TargetEndpointArn":{},"ReplicationInstanceArn":{},"MigrationType":{},"TableMappings":{},"ReplicationTaskSettings":{},"CdcStartTime":{"type":"timestamp"},"CdcStartPosition":{},"CdcStopPosition":{},"Tags":{"shape":"S3"}}},"output":{"type":"structure","members":{"ReplicationTask":{"shape":"S1q"}}}},"DeleteCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"output":{"type":"structure","members":{"Certificate":{"shape":"S1v"}}}},"DeleteEndpoint":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}},"output":{"type":"structure","members":{"Endpoint":{"shape":"Sz"}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"type":"structure","members":{"EventSubscription":{"shape":"S14"}}}},"DeleteReplicationInstance":{"input":{"type":"structure","required":["ReplicationInstanceArn"],"members":{"ReplicationInstanceArn":{}}},"output":{"type":"structure","members":{"ReplicationInstance":{"shape":"S19"}}}},"DeleteReplicationSubnetGroup":{"input":{"type":"structure","required":["ReplicationSubnetGroupIdentifier"],"members":{"ReplicationSubnetGroupIdentifier":{}}},"output":{"type":"structure","members":{}}},"DeleteReplicationTask":{"input":{"type":"structure","required":["ReplicationTaskArn"],"members":{"ReplicationTaskArn":{}}},"output":{"type":"structure","members":{"ReplicationTask":{"shape":"S1q"}}}},"DescribeAccountAttributes":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AccountQuotas":{"type":"list","member":{"type":"structure","members":{"AccountQuotaName":{},"Used":{"type":"long"},"Max":{"type":"long"}}}},"UniqueAccountIdentifier":{}}}},"DescribeCertificates":{"input":{"type":"structure","members":{"Filters":{"shape":"S2c"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"Certificates":{"type":"list","member":{"shape":"S1v"}}}}},"DescribeConnections":{"input":{"type":"structure","members":{"Filters":{"shape":"S2c"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"Connections":{"type":"list","member":{"shape":"S2k"}}}}},"DescribeEndpointTypes":{"input":{"type":"structure","members":{"Filters":{"shape":"S2c"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"SupportedEndpointTypes":{"type":"list","member":{"type":"structure","members":{"EngineName":{},"SupportsCDC":{"type":"boolean"},"EndpointType":{},"EngineDisplayName":{}}}}}}},"DescribeEndpoints":{"input":{"type":"structure","members":{"Filters":{"shape":"S2c"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"Endpoints":{"type":"list","member":{"shape":"Sz"}}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S2c"}}},"output":{"type":"structure","members":{"EventCategoryGroupList":{"type":"list","member":{"type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S11"}}}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S2c"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S14"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S11"},"Filters":{"shape":"S2c"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S11"},"Date":{"type":"timestamp"}}}}}}},"DescribeOrderableReplicationInstances":{"input":{"type":"structure","members":{"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"OrderableReplicationInstances":{"type":"list","member":{"type":"structure","members":{"EngineVersion":{},"ReplicationInstanceClass":{},"StorageType":{},"MinAllocatedStorage":{"type":"integer"},"MaxAllocatedStorage":{"type":"integer"},"DefaultAllocatedStorage":{"type":"integer"},"IncludedAllocatedStorage":{"type":"integer"},"AvailabilityZones":{"type":"list","member":{}},"ReleaseStatus":{}}}},"Marker":{}}}},"DescribePendingMaintenanceActions":{"input":{"type":"structure","members":{"ReplicationInstanceArn":{},"Filters":{"shape":"S2c"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"type":"structure","members":{"PendingMaintenanceActions":{"type":"list","member":{"shape":"S8"}},"Marker":{}}}},"DescribeRefreshSchemasStatus":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}},"output":{"type":"structure","members":{"RefreshSchemasStatus":{"shape":"S3f"}}}},"DescribeReplicationInstanceTaskLogs":{"input":{"type":"structure","required":["ReplicationInstanceArn"],"members":{"ReplicationInstanceArn":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"ReplicationInstanceArn":{},"ReplicationInstanceTaskLogs":{"type":"list","member":{"type":"structure","members":{"ReplicationTaskName":{},"ReplicationTaskArn":{},"ReplicationInstanceTaskLogSize":{"type":"long"}}}},"Marker":{}}}},"DescribeReplicationInstances":{"input":{"type":"structure","members":{"Filters":{"shape":"S2c"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"ReplicationInstances":{"type":"list","member":{"shape":"S19"}}}}},"DescribeReplicationSubnetGroups":{"input":{"type":"structure","members":{"Filters":{"shape":"S2c"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"ReplicationSubnetGroups":{"type":"list","member":{"shape":"S1d"}}}}},"DescribeReplicationTaskAssessmentResults":{"input":{"type":"structure","members":{"ReplicationTaskArn":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"BucketName":{},"ReplicationTaskAssessmentResults":{"type":"list","member":{"type":"structure","members":{"ReplicationTaskIdentifier":{},"ReplicationTaskArn":{},"ReplicationTaskLastAssessmentDate":{"type":"timestamp"},"AssessmentStatus":{},"AssessmentResultsFile":{},"AssessmentResults":{},"S3ObjectUrl":{}}}}}}},"DescribeReplicationTasks":{"input":{"type":"structure","members":{"Filters":{"shape":"S2c"},"MaxRecords":{"type":"integer"},"Marker":{},"WithoutSettings":{"type":"boolean"}}},"output":{"type":"structure","members":{"Marker":{},"ReplicationTasks":{"type":"list","member":{"shape":"S1q"}}}}},"DescribeSchemas":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"Schemas":{"type":"list","member":{}}}}},"DescribeTableStatistics":{"input":{"type":"structure","required":["ReplicationTaskArn"],"members":{"ReplicationTaskArn":{},"MaxRecords":{"type":"integer"},"Marker":{},"Filters":{"shape":"S2c"}}},"output":{"type":"structure","members":{"ReplicationTaskArn":{},"TableStatistics":{"type":"list","member":{"type":"structure","members":{"SchemaName":{},"TableName":{},"Inserts":{"type":"long"},"Deletes":{"type":"long"},"Updates":{"type":"long"},"Ddls":{"type":"long"},"FullLoadRows":{"type":"long"},"FullLoadCondtnlChkFailedRows":{"type":"long"},"FullLoadErrorRows":{"type":"long"},"LastUpdateTime":{"type":"timestamp"},"TableState":{},"ValidationPendingRecords":{"type":"long"},"ValidationFailedRecords":{"type":"long"},"ValidationSuspendedRecords":{"type":"long"},"ValidationState":{},"ValidationStateDetails":{}}}},"Marker":{}}}},"ImportCertificate":{"input":{"type":"structure","required":["CertificateIdentifier"],"members":{"CertificateIdentifier":{},"CertificatePem":{},"CertificateWallet":{"type":"blob"},"Tags":{"shape":"S3"}}},"output":{"type":"structure","members":{"Certificate":{"shape":"S1v"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"TagList":{"shape":"S3"}}}},"ModifyEndpoint":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{},"EndpointIdentifier":{},"EndpointType":{},"EngineName":{},"Username":{},"Password":{"shape":"Se"},"ServerName":{},"Port":{"type":"integer"},"DatabaseName":{},"ExtraConnectionAttributes":{},"CertificateArn":{},"SslMode":{},"ServiceAccessRoleArn":{},"ExternalTableDefinition":{},"DynamoDbSettings":{"shape":"Sh"},"S3Settings":{"shape":"Si"},"DmsTransferSettings":{"shape":"Sp"},"MongoDbSettings":{"shape":"Sq"},"KinesisSettings":{"shape":"Su"},"ElasticsearchSettings":{"shape":"Sw"},"RedshiftSettings":{"shape":"Sx"}}},"output":{"type":"structure","members":{"Endpoint":{"shape":"Sz"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S11"},"Enabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"EventSubscription":{"shape":"S14"}}}},"ModifyReplicationInstance":{"input":{"type":"structure","required":["ReplicationInstanceArn"],"members":{"ReplicationInstanceArn":{},"AllocatedStorage":{"type":"integer"},"ApplyImmediately":{"type":"boolean"},"ReplicationInstanceClass":{},"VpcSecurityGroupIds":{"shape":"S17"},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReplicationInstanceIdentifier":{}}},"output":{"type":"structure","members":{"ReplicationInstance":{"shape":"S19"}}}},"ModifyReplicationSubnetGroup":{"input":{"type":"structure","required":["ReplicationSubnetGroupIdentifier","SubnetIds"],"members":{"ReplicationSubnetGroupIdentifier":{},"ReplicationSubnetGroupDescription":{},"SubnetIds":{"shape":"S1l"}}},"output":{"type":"structure","members":{"ReplicationSubnetGroup":{"shape":"S1d"}}}},"ModifyReplicationTask":{"input":{"type":"structure","required":["ReplicationTaskArn"],"members":{"ReplicationTaskArn":{},"ReplicationTaskIdentifier":{},"MigrationType":{},"TableMappings":{},"ReplicationTaskSettings":{},"CdcStartTime":{"type":"timestamp"},"CdcStartPosition":{},"CdcStopPosition":{}}},"output":{"type":"structure","members":{"ReplicationTask":{"shape":"S1q"}}}},"RebootReplicationInstance":{"input":{"type":"structure","required":["ReplicationInstanceArn"],"members":{"ReplicationInstanceArn":{},"ForceFailover":{"type":"boolean"}}},"output":{"type":"structure","members":{"ReplicationInstance":{"shape":"S19"}}}},"RefreshSchemas":{"input":{"type":"structure","required":["EndpointArn","ReplicationInstanceArn"],"members":{"EndpointArn":{},"ReplicationInstanceArn":{}}},"output":{"type":"structure","members":{"RefreshSchemasStatus":{"shape":"S3f"}}}},"ReloadTables":{"input":{"type":"structure","required":["ReplicationTaskArn","TablesToReload"],"members":{"ReplicationTaskArn":{},"TablesToReload":{"type":"list","member":{"type":"structure","members":{"SchemaName":{},"TableName":{}}}},"ReloadOption":{}}},"output":{"type":"structure","members":{"ReplicationTaskArn":{}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"StartReplicationTask":{"input":{"type":"structure","required":["ReplicationTaskArn","StartReplicationTaskType"],"members":{"ReplicationTaskArn":{},"StartReplicationTaskType":{},"CdcStartTime":{"type":"timestamp"},"CdcStartPosition":{},"CdcStopPosition":{}}},"output":{"type":"structure","members":{"ReplicationTask":{"shape":"S1q"}}}},"StartReplicationTaskAssessment":{"input":{"type":"structure","required":["ReplicationTaskArn"],"members":{"ReplicationTaskArn":{}}},"output":{"type":"structure","members":{"ReplicationTask":{"shape":"S1q"}}}},"StopReplicationTask":{"input":{"type":"structure","required":["ReplicationTaskArn"],"members":{"ReplicationTaskArn":{}}},"output":{"type":"structure","members":{"ReplicationTask":{"shape":"S1q"}}}},"TestConnection":{"input":{"type":"structure","required":["ReplicationInstanceArn","EndpointArn"],"members":{"ReplicationInstanceArn":{},"EndpointArn":{}}},"output":{"type":"structure","members":{"Connection":{"shape":"S2k"}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S8":{"type":"structure","members":{"ResourceIdentifier":{},"PendingMaintenanceActionDetails":{"type":"list","member":{"type":"structure","members":{"Action":{},"AutoAppliedAfterDate":{"type":"timestamp"},"ForcedApplyDate":{"type":"timestamp"},"OptInStatus":{},"CurrentApplyDate":{"type":"timestamp"},"Description":{}}}}}},"Se":{"type":"string","sensitive":true},"Sh":{"type":"structure","required":["ServiceAccessRoleArn"],"members":{"ServiceAccessRoleArn":{}}},"Si":{"type":"structure","members":{"ServiceAccessRoleArn":{},"ExternalTableDefinition":{},"CsvRowDelimiter":{},"CsvDelimiter":{},"BucketFolder":{},"BucketName":{},"CompressionType":{},"EncryptionMode":{},"ServerSideEncryptionKmsKeyId":{},"DataFormat":{},"EncodingType":{},"DictPageSizeLimit":{"type":"integer"},"RowGroupLength":{"type":"integer"},"DataPageSize":{"type":"integer"},"ParquetVersion":{},"EnableStatistics":{"type":"boolean"},"IncludeOpForFullLoad":{"type":"boolean"},"CdcInsertsOnly":{"type":"boolean"},"TimestampColumnName":{}}},"Sp":{"type":"structure","members":{"ServiceAccessRoleArn":{},"BucketName":{}}},"Sq":{"type":"structure","members":{"Username":{},"Password":{"shape":"Se"},"ServerName":{},"Port":{"type":"integer"},"DatabaseName":{},"AuthType":{},"AuthMechanism":{},"NestingLevel":{},"ExtractDocId":{},"DocsToInvestigate":{},"AuthSource":{},"KmsKeyId":{}}},"Su":{"type":"structure","members":{"StreamArn":{},"MessageFormat":{},"ServiceAccessRoleArn":{}}},"Sw":{"type":"structure","required":["ServiceAccessRoleArn","EndpointUri"],"members":{"ServiceAccessRoleArn":{},"EndpointUri":{},"FullLoadErrorPercentage":{"type":"integer"},"ErrorRetryDuration":{"type":"integer"}}},"Sx":{"type":"structure","members":{"AcceptAnyDate":{"type":"boolean"},"AfterConnectScript":{},"BucketFolder":{},"BucketName":{},"ConnectionTimeout":{"type":"integer"},"DatabaseName":{},"DateFormat":{},"EmptyAsNull":{"type":"boolean"},"EncryptionMode":{},"FileTransferUploadStreams":{"type":"integer"},"LoadTimeout":{"type":"integer"},"MaxFileSize":{"type":"integer"},"Password":{"shape":"Se"},"Port":{"type":"integer"},"RemoveQuotes":{"type":"boolean"},"ReplaceInvalidChars":{},"ReplaceChars":{},"ServerName":{},"ServiceAccessRoleArn":{},"ServerSideEncryptionKmsKeyId":{},"TimeFormat":{},"TrimBlanks":{"type":"boolean"},"TruncateColumns":{"type":"boolean"},"Username":{},"WriteBufferSize":{"type":"integer"}}},"Sz":{"type":"structure","members":{"EndpointIdentifier":{},"EndpointType":{},"EngineName":{},"EngineDisplayName":{},"Username":{},"ServerName":{},"Port":{"type":"integer"},"DatabaseName":{},"ExtraConnectionAttributes":{},"Status":{},"KmsKeyId":{},"EndpointArn":{},"CertificateArn":{},"SslMode":{},"ServiceAccessRoleArn":{},"ExternalTableDefinition":{},"ExternalId":{},"DynamoDbSettings":{"shape":"Sh"},"S3Settings":{"shape":"Si"},"DmsTransferSettings":{"shape":"Sp"},"MongoDbSettings":{"shape":"Sq"},"KinesisSettings":{"shape":"Su"},"ElasticsearchSettings":{"shape":"Sw"},"RedshiftSettings":{"shape":"Sx"}}},"S11":{"type":"list","member":{}},"S12":{"type":"list","member":{}},"S14":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S12"},"EventCategoriesList":{"shape":"S11"},"Enabled":{"type":"boolean"}}},"S17":{"type":"list","member":{}},"S19":{"type":"structure","members":{"ReplicationInstanceIdentifier":{},"ReplicationInstanceClass":{},"ReplicationInstanceStatus":{},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"VpcSecurityGroups":{"type":"list","member":{"type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"AvailabilityZone":{},"ReplicationSubnetGroup":{"shape":"S1d"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"ReplicationInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{}}},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"KmsKeyId":{},"ReplicationInstanceArn":{},"ReplicationInstancePublicIpAddress":{"deprecated":true},"ReplicationInstancePrivateIpAddress":{"deprecated":true},"ReplicationInstancePublicIpAddresses":{"type":"list","member":{}},"ReplicationInstancePrivateIpAddresses":{"type":"list","member":{}},"PubliclyAccessible":{"type":"boolean"},"SecondaryAvailabilityZone":{},"FreeUntil":{"type":"timestamp"},"DnsNameServers":{}}},"S1d":{"type":"structure","members":{"ReplicationSubnetGroupIdentifier":{},"ReplicationSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"type":"structure","members":{"Name":{}}},"SubnetStatus":{}}}}}},"S1l":{"type":"list","member":{}},"S1q":{"type":"structure","members":{"ReplicationTaskIdentifier":{},"SourceEndpointArn":{},"TargetEndpointArn":{},"ReplicationInstanceArn":{},"MigrationType":{},"TableMappings":{},"ReplicationTaskSettings":{},"Status":{},"LastFailureMessage":{},"StopReason":{},"ReplicationTaskCreationDate":{"type":"timestamp"},"ReplicationTaskStartDate":{"type":"timestamp"},"CdcStartPosition":{},"CdcStopPosition":{},"RecoveryCheckpoint":{},"ReplicationTaskArn":{},"ReplicationTaskStats":{"type":"structure","members":{"FullLoadProgressPercent":{"type":"integer"},"ElapsedTimeMillis":{"type":"long"},"TablesLoaded":{"type":"integer"},"TablesLoading":{"type":"integer"},"TablesQueued":{"type":"integer"},"TablesErrored":{"type":"integer"}}}}},"S1v":{"type":"structure","members":{"CertificateIdentifier":{},"CertificateCreationDate":{"type":"timestamp"},"CertificatePem":{},"CertificateWallet":{"type":"blob"},"CertificateArn":{},"CertificateOwner":{},"ValidFromDate":{"type":"timestamp"},"ValidToDate":{"type":"timestamp"},"SigningAlgorithm":{},"KeyLength":{"type":"integer"}}},"S2c":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{}}}}},"S2k":{"type":"structure","members":{"ReplicationInstanceArn":{},"EndpointArn":{},"Status":{},"LastFailureMessage":{},"EndpointIdentifier":{},"ReplicationInstanceIdentifier":{}}},"S3f":{"type":"structure","members":{"EndpointArn":{},"ReplicationInstanceArn":{},"Status":{},"LastRefreshDate":{"type":"timestamp"},"LastFailureMessage":{}}}}}');

});

parcelRequire.register("d4YQx", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeCertificates":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeConnections":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeEndpointTypes":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeEndpoints":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeEventSubscriptions":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeEvents":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeOrderableReplicationInstances":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribePendingMaintenanceActions":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeReplicationInstanceTaskLogs":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeReplicationInstances":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeReplicationSubnetGroups":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeReplicationTaskAssessmentResults":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeReplicationTasks":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeSchemas":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"},"DescribeTableStatistics":{"input_token":"Marker","output_token":"Marker","limit_key":"MaxRecords"}}}');

});

parcelRequire.register("k5DZL", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"TestConnectionSucceeds":{"acceptors":[{"argument":"Connections[].Status","expected":"successful","matcher":"pathAll","state":"success"},{"argument":"Connections[].Status","expected":"failed","matcher":"pathAny","state":"failure"}],"delay":5,"description":"Wait until testing connection succeeds.","maxAttempts":60,"operation":"DescribeConnections"},"EndpointDeleted":{"acceptors":[{"expected":"ResourceNotFoundFault","matcher":"error","state":"success"},{"argument":"Endpoints[].Status","expected":"active","matcher":"pathAny","state":"failure"},{"argument":"Endpoints[].Status","expected":"creating","matcher":"pathAny","state":"failure"}],"delay":5,"description":"Wait until testing endpoint is deleted.","maxAttempts":60,"operation":"DescribeEndpoints"},"ReplicationInstanceAvailable":{"acceptors":[{"argument":"ReplicationInstances[].ReplicationInstanceStatus","expected":"available","matcher":"pathAll","state":"success"},{"argument":"ReplicationInstances[].ReplicationInstanceStatus","expected":"deleting","matcher":"pathAny","state":"failure"},{"argument":"ReplicationInstances[].ReplicationInstanceStatus","expected":"incompatible-credentials","matcher":"pathAny","state":"failure"},{"argument":"ReplicationInstances[].ReplicationInstanceStatus","expected":"incompatible-network","matcher":"pathAny","state":"failure"},{"argument":"ReplicationInstances[].ReplicationInstanceStatus","expected":"inaccessible-encryption-credentials","matcher":"pathAny","state":"failure"}],"delay":60,"description":"Wait until DMS replication instance is available.","maxAttempts":60,"operation":"DescribeReplicationInstances"},"ReplicationInstanceDeleted":{"acceptors":[{"argument":"ReplicationInstances[].ReplicationInstanceStatus","expected":"available","matcher":"pathAny","state":"failure"},{"expected":"ResourceNotFoundFault","matcher":"error","state":"success"}],"delay":15,"description":"Wait until DMS replication instance is deleted.","maxAttempts":60,"operation":"DescribeReplicationInstances"},"ReplicationTaskReady":{"acceptors":[{"argument":"ReplicationTasks[].Status","expected":"ready","matcher":"pathAll","state":"success"},{"argument":"ReplicationTasks[].Status","expected":"starting","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"running","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"stopping","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"stopped","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"failed","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"modifying","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"testing","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"deleting","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until DMS replication task is ready.","maxAttempts":60,"operation":"DescribeReplicationTasks"},"ReplicationTaskStopped":{"acceptors":[{"argument":"ReplicationTasks[].Status","expected":"stopped","matcher":"pathAll","state":"success"},{"argument":"ReplicationTasks[].Status","expected":"ready","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"creating","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"starting","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"running","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"failed","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"modifying","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"testing","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"deleting","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until DMS replication task is stopped.","maxAttempts":60,"operation":"DescribeReplicationTasks"},"ReplicationTaskRunning":{"acceptors":[{"argument":"ReplicationTasks[].Status","expected":"running","matcher":"pathAll","state":"success"},{"argument":"ReplicationTasks[].Status","expected":"ready","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"creating","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"stopping","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"stopped","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"failed","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"modifying","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"testing","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"deleting","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until DMS replication task is running.","maxAttempts":60,"operation":"DescribeReplicationTasks"},"ReplicationTaskDeleted":{"acceptors":[{"argument":"ReplicationTasks[].Status","expected":"ready","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"creating","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"stopped","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"running","matcher":"pathAny","state":"failure"},{"argument":"ReplicationTasks[].Status","expected":"failed","matcher":"pathAny","state":"failure"},{"expected":"ResourceNotFoundFault","matcher":"error","state":"success"}],"delay":15,"description":"Wait until DMS replication task is deleted.","maxAttempts":60,"operation":"DescribeReplicationTasks"}}}');

});


parcelRequire.register("aVn70", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $7f4127cf0206c519$var$Service = $dbC7k.Service;
var $7f4127cf0206c519$var$apiLoader = $dbC7k.apiLoader;
$7f4127cf0206c519$var$apiLoader.services["dynamodb"] = {};
$dbC7k.DynamoDB = $7f4127cf0206c519$var$Service.defineService("dynamodb", [
    "2011-12-05",
    "2012-08-10"
]);
parcelRequire("2HQH8");



Object.defineProperty($7f4127cf0206c519$var$apiLoader.services["dynamodb"], "2011-12-05", {
    get: function get() {
        var model = (parcelRequire("6JxaH"));
        model.paginators = (parcelRequire("h7nJR")).pagination;
        model.waiters = (parcelRequire("4xmEi")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});



Object.defineProperty($7f4127cf0206c519$var$apiLoader.services["dynamodb"], "2012-08-10", {
    get: function get() {
        var model = (parcelRequire("14kpV"));
        model.paginators = (parcelRequire("hYR6Y")).pagination;
        model.waiters = (parcelRequire("jNZq2")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.DynamoDB;

});
parcelRequire.register("2HQH8", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
parcelRequire("2uSAI");
$dbC7k.util.update($dbC7k.DynamoDB.prototype, {
    /**
   * @api private
   */ setupRequestListeners: function setupRequestListeners(request) {
        if (request.service.config.dynamoDbCrc32) {
            request.removeListener("extractData", $dbC7k.EventListeners.Json.EXTRACT_DATA);
            request.addListener("extractData", this.checkCrc32);
            request.addListener("extractData", $dbC7k.EventListeners.Json.EXTRACT_DATA);
        }
    },
    /**
   * @api private
   */ checkCrc32: function checkCrc32(resp) {
        if (!resp.httpResponse.streaming && !resp.request.service.crc32IsValid(resp)) {
            resp.data = null;
            resp.error = $dbC7k.util.error(new Error(), {
                code: "CRC32CheckFailed",
                message: "CRC32 integrity check failed",
                retryable: true
            });
            resp.request.haltHandlersOnError();
            throw resp.error;
        }
    },
    /**
   * @api private
   */ crc32IsValid: function crc32IsValid(resp) {
        var crc = resp.httpResponse.headers["x-amz-crc32"];
        if (!crc) return true; // no (valid) CRC32 header
        return parseInt(crc, 10) === $dbC7k.util.crypto.crc32(resp.httpResponse.body);
    },
    /**
   * @api private
   */ defaultRetryCount: 10,
    /**
   * @api private
   */ retryDelays: function retryDelays(retryCount) {
        var retryDelayOptions = $dbC7k.util.copy(this.config.retryDelayOptions);
        if (typeof retryDelayOptions.base !== "number") retryDelayOptions.base = 50; // default for dynamodb
        var delay = $dbC7k.util.calculateRetryDelay(retryCount, retryDelayOptions);
        return delay;
    }
});

});
parcelRequire.register("2uSAI", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");

var $1Jk6r = parcelRequire("1Jk6r");

var $ggt9L = parcelRequire("ggt9L");
/**
 * The document client simplifies working with items in Amazon DynamoDB
 * by abstracting away the notion of attribute values. This abstraction
 * annotates native JavaScript types supplied as input parameters, as well
 * as converts annotated response data to native JavaScript types.
 *
 * ## Marshalling Input and Unmarshalling Response Data
 *
 * The document client affords developers the use of native JavaScript types
 * instead of `AttributeValue`s to simplify the JavaScript development
 * experience with Amazon DynamoDB. JavaScript objects passed in as parameters
 * are marshalled into `AttributeValue` shapes required by Amazon DynamoDB.
 * Responses from DynamoDB are unmarshalled into plain JavaScript objects
 * by the `DocumentClient`. The `DocumentClient`, does not accept
 * `AttributeValue`s in favor of native JavaScript types.
 *
 * |                             JavaScript Type                            | DynamoDB AttributeValue |
 * |:----------------------------------------------------------------------:|-------------------------|
 * | String                                                                 | S                       |
 * | Number                                                                 | N                       |
 * | Boolean                                                                | BOOL                    |
 * | null                                                                   | NULL                    |
 * | Array                                                                  | L                       |
 * | Object                                                                 | M                       |
 * | Buffer, File, Blob, ArrayBuffer, DataView, and JavaScript typed arrays | B                       |
 *
 * ## Support for Sets
 *
 * The `DocumentClient` offers a convenient way to create sets from
 * JavaScript Arrays. The type of set is inferred from the first element
 * in the array. DynamoDB supports string, number, and binary sets. To
 * learn more about supported types see the
 * [Amazon DynamoDB Data Model Documentation](http://docs.aws.amazon.com/amazondynamodb/latest/developerguide/DataModel.html)
 * For more information see {AWS.DynamoDB.DocumentClient.createSet}
 *
 */ $dbC7k.DynamoDB.DocumentClient = $dbC7k.util.inherit({
    /**
   * Creates a DynamoDB document client with a set of configuration options.
   *
   * @option options params [map] An optional map of parameters to bind to every
   *   request sent by this service object.
   * @option options service [AWS.DynamoDB] An optional pre-configured instance
   *  of the AWS.DynamoDB service object to use for requests. The object may
   *  bound parameters used by the document client.
   * @option options convertEmptyValues [Boolean] set to true if you would like
   *  the document client to convert empty values (0-length strings, binary
   *  buffers, and sets) to be converted to NULL types when persisting to
   *  DynamoDB.
   * @see AWS.DynamoDB.constructor
   *
   */ constructor: function DocumentClient(options) {
        var self = this;
        self.options = options || {};
        self.configure(self.options);
    },
    /**
   * @api private
   */ configure: function configure(options) {
        var self = this;
        self.service = options.service;
        self.bindServiceObject(options);
        self.attrValue = options.attrValue = self.service.api.operations.putItem.input.members.Item.value.shape;
    },
    /**
   * @api private
   */ bindServiceObject: function bindServiceObject(options) {
        var self = this;
        options = options || {};
        if (!self.service) self.service = new $dbC7k.DynamoDB(options);
        else {
            var config = $dbC7k.util.copy(self.service.config);
            self.service = new self.service.constructor.__super__(config);
            self.service.config.params = $dbC7k.util.merge(self.service.config.params || {}, options.params);
        }
    },
    /**
   * @api private
   */ makeServiceRequest: function(operation, params, callback) {
        var self = this;
        var request = self.service[operation](params);
        self.setupRequest(request);
        self.setupResponse(request);
        if (typeof callback === "function") request.send(callback);
        return request;
    },
    /**
   * @api private
   */ serviceClientOperationsMap: {
        batchGet: "batchGetItem",
        batchWrite: "batchWriteItem",
        delete: "deleteItem",
        get: "getItem",
        put: "putItem",
        query: "query",
        scan: "scan",
        update: "updateItem",
        transactGet: "transactGetItems",
        transactWrite: "transactWriteItems"
    },
    /**
   * Returns the attributes of one or more items from one or more tables
   * by delegating to `AWS.DynamoDB.batchGetItem()`.
   *
   * Supply the same parameters as {AWS.DynamoDB.batchGetItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.batchGetItem
   * @example Get items from multiple tables
   *  var params = {
   *    RequestItems: {
   *      'Table-1': {
   *        Keys: [
   *          {
   *             HashKey: 'haskey',
   *             NumberRangeKey: 1
   *          }
   *        ]
   *      },
   *      'Table-2': {
   *        Keys: [
   *          { foo: 'bar' },
   *        ]
   *      }
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.batchGet(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */ batchGet: function(params, callback) {
        var operation = this.serviceClientOperationsMap["batchGet"];
        return this.makeServiceRequest(operation, params, callback);
    },
    /**
   * Puts or deletes multiple items in one or more tables by delegating
   * to `AWS.DynamoDB.batchWriteItem()`.
   *
   * Supply the same parameters as {AWS.DynamoDB.batchWriteItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.batchWriteItem
   * @example Write to and delete from a table
   *  var params = {
   *    RequestItems: {
   *      'Table-1': [
   *        {
   *          DeleteRequest: {
   *            Key: { HashKey: 'someKey' }
   *          }
   *        },
   *        {
   *          PutRequest: {
   *            Item: {
   *              HashKey: 'anotherKey',
   *              NumAttribute: 1,
   *              BoolAttribute: true,
   *              ListAttribute: [1, 'two', false],
   *              MapAttribute: { foo: 'bar' }
   *            }
   *          }
   *        }
   *      ]
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.batchWrite(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */ batchWrite: function(params, callback) {
        var operation = this.serviceClientOperationsMap["batchWrite"];
        return this.makeServiceRequest(operation, params, callback);
    },
    /**
   * Deletes a single item in a table by primary key by delegating to
   * `AWS.DynamoDB.deleteItem()`
   *
   * Supply the same parameters as {AWS.DynamoDB.deleteItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.deleteItem
   * @example Delete an item from a table
   *  var params = {
   *    TableName : 'Table',
   *    Key: {
   *      HashKey: 'hashkey',
   *      NumberRangeKey: 1
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.delete(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */ delete: function(params, callback) {
        var operation = this.serviceClientOperationsMap["delete"];
        return this.makeServiceRequest(operation, params, callback);
    },
    /**
   * Returns a set of attributes for the item with the given primary key
   * by delegating to `AWS.DynamoDB.getItem()`.
   *
   * Supply the same parameters as {AWS.DynamoDB.getItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.getItem
   * @example Get an item from a table
   *  var params = {
   *    TableName : 'Table',
   *    Key: {
   *      HashKey: 'hashkey'
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.get(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */ get: function(params, callback) {
        var operation = this.serviceClientOperationsMap["get"];
        return this.makeServiceRequest(operation, params, callback);
    },
    /**
   * Creates a new item, or replaces an old item with a new item by
   * delegating to `AWS.DynamoDB.putItem()`.
   *
   * Supply the same parameters as {AWS.DynamoDB.putItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.putItem
   * @example Create a new item in a table
   *  var params = {
   *    TableName : 'Table',
   *    Item: {
   *       HashKey: 'haskey',
   *       NumAttribute: 1,
   *       BoolAttribute: true,
   *       ListAttribute: [1, 'two', false],
   *       MapAttribute: { foo: 'bar'},
   *       NullAttribute: null
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.put(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */ put: function(params, callback) {
        var operation = this.serviceClientOperationsMap["put"];
        return this.makeServiceRequest(operation, params, callback);
    },
    /**
   * Edits an existing item's attributes, or adds a new item to the table if
   * it does not already exist by delegating to `AWS.DynamoDB.updateItem()`.
   *
   * Supply the same parameters as {AWS.DynamoDB.updateItem} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.updateItem
   * @example Update an item with expressions
   *  var params = {
   *    TableName: 'Table',
   *    Key: { HashKey : 'hashkey' },
   *    UpdateExpression: 'set #a = :x + :y',
   *    ConditionExpression: '#a < :MAX',
   *    ExpressionAttributeNames: {'#a' : 'Sum'},
   *    ExpressionAttributeValues: {
   *      ':x' : 20,
   *      ':y' : 45,
   *      ':MAX' : 100,
   *    }
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.update(params, function(err, data) {
   *     if (err) console.log(err);
   *     else console.log(data);
   *  });
   *
   */ update: function(params, callback) {
        var operation = this.serviceClientOperationsMap["update"];
        return this.makeServiceRequest(operation, params, callback);
    },
    /**
   * Returns one or more items and item attributes by accessing every item
   * in a table or a secondary index.
   *
   * Supply the same parameters as {AWS.DynamoDB.scan} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.scan
   * @example Scan the table with a filter expression
   *  var params = {
   *    TableName : 'Table',
   *    FilterExpression : 'Year = :this_year',
   *    ExpressionAttributeValues : {':this_year' : 2015}
   *  };
   *
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  documentClient.scan(params, function(err, data) {
   *     if (err) console.log(err);
   *     else console.log(data);
   *  });
   *
   */ scan: function(params, callback) {
        var operation = this.serviceClientOperationsMap["scan"];
        return this.makeServiceRequest(operation, params, callback);
    },
    /**
    * Directly access items from a table by primary key or a secondary index.
    *
    * Supply the same parameters as {AWS.DynamoDB.query} with
    * `AttributeValue`s substituted by native JavaScript types.
    *
    * @see AWS.DynamoDB.query
    * @example Query an index
    *  var params = {
    *    TableName: 'Table',
    *    IndexName: 'Index',
    *    KeyConditionExpression: 'HashKey = :hkey and RangeKey > :rkey',
    *    ExpressionAttributeValues: {
    *      ':hkey': 'key',
    *      ':rkey': 2015
    *    }
    *  };
    *
    *  var documentClient = new AWS.DynamoDB.DocumentClient();
    *
    *  documentClient.query(params, function(err, data) {
    *     if (err) console.log(err);
    *     else console.log(data);
    *  });
    *
    */ query: function(params, callback) {
        var operation = this.serviceClientOperationsMap["query"];
        return this.makeServiceRequest(operation, params, callback);
    },
    /**
   * Synchronous write operation that groups up to 10 action requests
   *
   * Supply the same parameters as {AWS.DynamoDB.transactWriteItems} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.transactWriteItems
   * @example Get items from multiple tables
   *  var params = {
   *    TransactItems: [{
   *      Put: {
   *        TableName : 'Table0',
   *        Item: {
   *          HashKey: 'haskey',
   *          NumAttribute: 1,
   *          BoolAttribute: true,
   *          ListAttribute: [1, 'two', false],
   *          MapAttribute: { foo: 'bar'},
   *          NullAttribute: null
   *        }
   *      }
   *    }, {
   *      Update: {
   *        TableName: 'Table1',
   *        Key: { HashKey : 'hashkey' },
   *        UpdateExpression: 'set #a = :x + :y',
   *        ConditionExpression: '#a < :MAX',
   *        ExpressionAttributeNames: {'#a' : 'Sum'},
   *        ExpressionAttributeValues: {
   *          ':x' : 20,
   *          ':y' : 45,
   *          ':MAX' : 100,
   *        }
   *      }
   *    }]
   *  };
   *
   *  documentClient.transactWrite(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   */ transactWrite: function(params, callback) {
        var operation = this.serviceClientOperationsMap["transactWrite"];
        return this.makeServiceRequest(operation, params, callback);
    },
    /**
   * Atomically retrieves multiple items from one or more tables (but not from indexes)
   * in a single account and region.
   *
   * Supply the same parameters as {AWS.DynamoDB.transactGetItems} with
   * `AttributeValue`s substituted by native JavaScript types.
   *
   * @see AWS.DynamoDB.transactGetItems
   * @example Get items from multiple tables
   *  var params = {
   *    TransactItems: [{
   *      Get: {
   *        TableName : 'Table0',
   *        Key: {
   *          HashKey: 'hashkey0'
   *        }
   *      }
   *    }, {
   *      Get: {
   *        TableName : 'Table1',
   *        Key: {
   *          HashKey: 'hashkey1'
   *        }
   *      }
   *    }]
   *  };
   *
   *  documentClient.transactGet(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   */ transactGet: function(params, callback) {
        var operation = this.serviceClientOperationsMap["transactGet"];
        return this.makeServiceRequest(operation, params, callback);
    },
    /**
   * Creates a set of elements inferring the type of set from
   * the type of the first element. Amazon DynamoDB currently supports
   * the number sets, string sets, and binary sets. For more information
   * about DynamoDB data types see the documentation on the
   * [Amazon DynamoDB Data Model](http://docs.aws.amazon.com/amazondynamodb/latest/developerguide/DataModel.html#DataModel.DataTypes).
   *
   * @param list [Array] Collection to represent your DynamoDB Set
   * @param options [map]
   *  * **validate** [Boolean] set to true if you want to validate the type
   *    of each element in the set. Defaults to `false`.
   * @example Creating a number set
   *  var documentClient = new AWS.DynamoDB.DocumentClient();
   *
   *  var params = {
   *    Item: {
   *      hashkey: 'hashkey'
   *      numbers: documentClient.createSet([1, 2, 3]);
   *    }
   *  };
   *
   *  documentClient.put(params, function(err, data) {
   *    if (err) console.log(err);
   *    else console.log(data);
   *  });
   *
   */ createSet: function(list, options) {
        options = options || {};
        return new $ggt9L(list, options);
    },
    /**
   * @api private
   */ getTranslator: function() {
        return new $1Jk6r(this.options);
    },
    /**
   * @api private
   */ setupRequest: function setupRequest(request) {
        var self = this;
        var translator = self.getTranslator();
        var operation = request.operation;
        var inputShape = request.service.api.operations[operation].input;
        request._events.validate.unshift(function(req) {
            req.rawParams = $dbC7k.util.copy(req.params);
            req.params = translator.translateInput(req.rawParams, inputShape);
        });
    },
    /**
   * @api private
   */ setupResponse: function setupResponse(request) {
        var self = this;
        var translator = self.getTranslator();
        var outputShape = self.service.api.operations[request.operation].output;
        request.on("extractData", function(response) {
            response.data = translator.translateOutput(response.data, outputShape);
        });
        var response = request.response;
        response.nextPage = function(cb) {
            var resp = this;
            var req = resp.request;
            var config;
            var service = req.service;
            var operation = req.operation;
            try {
                config = service.paginationConfig(operation, true);
            } catch (e) {
                resp.error = e;
            }
            if (!resp.hasNextPage()) {
                if (cb) cb(resp.error, null);
                else if (resp.error) throw resp.error;
                return null;
            }
            var params = $dbC7k.util.copy(req.rawParams);
            if (!resp.nextPageTokens) return cb ? cb(null, null) : null;
            else {
                var inputTokens = config.inputToken;
                if (typeof inputTokens === "string") inputTokens = [
                    inputTokens
                ];
                for(var i = 0; i < inputTokens.length; i++)params[inputTokens[i]] = resp.nextPageTokens[i];
                return self[operation](params, cb);
            }
        };
    }
});
/**
 * @api private
 */ module.exports = $dbC7k.DynamoDB.DocumentClient;

});
parcelRequire.register("1Jk6r", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
var $1429966957a50201$require$util = $dbC7k.util;

var $dEOdk = parcelRequire("dEOdk");
var $1429966957a50201$var$Translator = function(options) {
    options = options || {};
    this.attrValue = options.attrValue;
    this.convertEmptyValues = Boolean(options.convertEmptyValues);
    this.wrapNumbers = Boolean(options.wrapNumbers);
};
$1429966957a50201$var$Translator.prototype.translateInput = function(value, shape) {
    this.mode = "input";
    return this.translate(value, shape);
};
$1429966957a50201$var$Translator.prototype.translateOutput = function(value, shape) {
    this.mode = "output";
    return this.translate(value, shape);
};
$1429966957a50201$var$Translator.prototype.translate = function(value, shape) {
    var self = this;
    if (!shape || value === undefined) return undefined;
    if (shape.shape === self.attrValue) return $dEOdk[self.mode](value, {
        convertEmptyValues: self.convertEmptyValues,
        wrapNumbers: self.wrapNumbers
    });
    switch(shape.type){
        case "structure":
            return self.translateStructure(value, shape);
        case "map":
            return self.translateMap(value, shape);
        case "list":
            return self.translateList(value, shape);
        default:
            return self.translateScalar(value, shape);
    }
};
$1429966957a50201$var$Translator.prototype.translateStructure = function(structure, shape) {
    var self = this;
    if (structure == null) return undefined;
    var struct = {};
    $1429966957a50201$require$util.each(structure, function(name, value) {
        var memberShape = shape.members[name];
        if (memberShape) {
            var result = self.translate(value, memberShape);
            if (result !== undefined) struct[name] = result;
        }
    });
    return struct;
};
$1429966957a50201$var$Translator.prototype.translateList = function(list, shape) {
    var self = this;
    if (list == null) return undefined;
    var out = [];
    $1429966957a50201$require$util.arrayEach(list, function(value) {
        var result = self.translate(value, shape.member);
        if (result === undefined) out.push(null);
        else out.push(result);
    });
    return out;
};
$1429966957a50201$var$Translator.prototype.translateMap = function(map, shape) {
    var self = this;
    if (map == null) return undefined;
    var out = {};
    $1429966957a50201$require$util.each(map, function(key, value) {
        var result = self.translate(value, shape.value);
        if (result === undefined) out[key] = null;
        else out[key] = result;
    });
    return out;
};
$1429966957a50201$var$Translator.prototype.translateScalar = function(value, shape) {
    return shape.toType(value);
};
/**
 * @api private
 */ module.exports = $1429966957a50201$var$Translator;

});
parcelRequire.register("dEOdk", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
var $9f15f6439871bdce$var$util = $dbC7k.util;

var $bp0ht = parcelRequire("bp0ht");
var $9f15f6439871bdce$require$typeOf = $bp0ht.typeOf;

var $ggt9L = parcelRequire("ggt9L");

var $fb5Nh = parcelRequire("fb5Nh");
$dbC7k.DynamoDB.Converter = {
    /**
   * Convert a JavaScript value to its equivalent DynamoDB AttributeValue type
   *
   * @param data [any] The data to convert to a DynamoDB AttributeValue
   * @param options [map]
   * @option options convertEmptyValues [Boolean] Whether to automatically
   *                                              convert empty strings, blobs,
   *                                              and sets to `null`
   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
   *                                        NumberValue object instead of
   *                                        converting them to native JavaScript
   *                                        numbers. This allows for the safe
   *                                        round-trip transport of numbers of
   *                                        arbitrary size.
   * @return [map] An object in the Amazon DynamoDB AttributeValue format
   *
   * @see AWS.DynamoDB.Converter.marshall AWS.DynamoDB.Converter.marshall to
   *    convert entire records (rather than individual attributes)
   */ input: function convertInput(data, options) {
        options = options || {};
        var type = $9f15f6439871bdce$require$typeOf(data);
        if (type === "Object") return $9f15f6439871bdce$var$formatMap(data, options);
        else if (type === "Array") return $9f15f6439871bdce$var$formatList(data, options);
        else if (type === "Set") return $9f15f6439871bdce$var$formatSet(data, options);
        else if (type === "String") {
            if (data.length === 0 && options.convertEmptyValues) return convertInput(null);
            return {
                S: data
            };
        } else if (type === "Number" || type === "NumberValue") return {
            N: data.toString()
        };
        else if (type === "Binary") {
            if (data.length === 0 && options.convertEmptyValues) return convertInput(null);
            return {
                B: data
            };
        } else if (type === "Boolean") return {
            BOOL: data
        };
        else if (type === "null") return {
            NULL: true
        };
        else if (type !== "undefined" && type !== "Function") // this value has a custom constructor
        return $9f15f6439871bdce$var$formatMap(data, options);
    },
    /**
   * Convert a JavaScript object into a DynamoDB record.
   *
   * @param data [any] The data to convert to a DynamoDB record
   * @param options [map]
   * @option options convertEmptyValues [Boolean] Whether to automatically
   *                                              convert empty strings, blobs,
   *                                              and sets to `null`
   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
   *                                        NumberValue object instead of
   *                                        converting them to native JavaScript
   *                                        numbers. This allows for the safe
   *                                        round-trip transport of numbers of
   *                                        arbitrary size.
   *
   * @return [map] An object in the DynamoDB record format.
   *
   * @example Convert a JavaScript object into a DynamoDB record
   *  var marshalled = AWS.DynamoDB.Converter.marshall({
   *    string: 'foo',
   *    list: ['fizz', 'buzz', 'pop'],
   *    map: {
   *      nestedMap: {
   *        key: 'value',
   *      }
   *    },
   *    number: 123,
   *    nullValue: null,
   *    boolValue: true,
   *    stringSet: new DynamoDBSet(['foo', 'bar', 'baz'])
   *  });
   */ marshall: function marshallItem(data, options) {
        return $dbC7k.DynamoDB.Converter.input(data, options).M;
    },
    /**
   * Convert a DynamoDB AttributeValue object to its equivalent JavaScript type.
   *
   * @param data [map] An object in the Amazon DynamoDB AttributeValue format
   * @param options [map]
   * @option options convertEmptyValues [Boolean] Whether to automatically
   *                                              convert empty strings, blobs,
   *                                              and sets to `null`
   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
   *                                        NumberValue object instead of
   *                                        converting them to native JavaScript
   *                                        numbers. This allows for the safe
   *                                        round-trip transport of numbers of
   *                                        arbitrary size.
   *
   * @return [Object|Array|String|Number|Boolean|null]
   *
   * @see AWS.DynamoDB.Converter.unmarshall AWS.DynamoDB.Converter.unmarshall to
   *    convert entire records (rather than individual attributes)
   */ output: function convertOutput(data, options) {
        options = options || {};
        var list, map, i;
        for(var type in data){
            var values = data[type];
            if (type === "M") {
                map = {};
                for(var key in values)map[key] = convertOutput(values[key], options);
                return map;
            } else if (type === "L") {
                list = [];
                for(i = 0; i < values.length; i++)list.push(convertOutput(values[i], options));
                return list;
            } else if (type === "SS") {
                list = [];
                for(i = 0; i < values.length; i++)list.push(values[i] + "");
                return new $ggt9L(list);
            } else if (type === "NS") {
                list = [];
                for(i = 0; i < values.length; i++)list.push($9f15f6439871bdce$var$convertNumber(values[i], options.wrapNumbers));
                return new $ggt9L(list);
            } else if (type === "BS") {
                list = [];
                for(i = 0; i < values.length; i++)list.push($dbC7k.util.buffer.toBuffer(values[i]));
                return new $ggt9L(list);
            } else if (type === "S") return values + "";
            else if (type === "N") return $9f15f6439871bdce$var$convertNumber(values, options.wrapNumbers);
            else if (type === "B") return $9f15f6439871bdce$var$util.buffer.toBuffer(values);
            else if (type === "BOOL") return values === "true" || values === "TRUE" || values === true;
            else if (type === "NULL") return null;
        }
    },
    /**
   * Convert a DynamoDB record into a JavaScript object.
   *
   * @param data [any] The DynamoDB record
   * @param options [map]
   * @option options convertEmptyValues [Boolean] Whether to automatically
   *                                              convert empty strings, blobs,
   *                                              and sets to `null`
   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
   *                                        NumberValue object instead of
   *                                        converting them to native JavaScript
   *                                        numbers. This allows for the safe
   *                                        round-trip transport of numbers of
   *                                        arbitrary size.
   *
   * @return [map] An object whose properties have been converted from
   *    DynamoDB's AttributeValue format into their corresponding native
   *    JavaScript types.
   *
   * @example Convert a record received from a DynamoDB stream
   *  var unmarshalled = AWS.DynamoDB.Converter.unmarshall({
   *    string: {S: 'foo'},
   *    list: {L: [{S: 'fizz'}, {S: 'buzz'}, {S: 'pop'}]},
   *    map: {
   *      M: {
   *        nestedMap: {
   *          M: {
   *            key: {S: 'value'}
   *          }
   *        }
   *      }
   *    },
   *    number: {N: '123'},
   *    nullValue: {NULL: true},
   *    boolValue: {BOOL: true}
   *  });
   */ unmarshall: function unmarshall(data, options) {
        return $dbC7k.DynamoDB.Converter.output({
            M: data
        }, options);
    }
};
/**
 * @api private
 * @param data [Array]
 * @param options [map]
 */ function $9f15f6439871bdce$var$formatList(data, options) {
    var list = {
        L: []
    };
    for(var i = 0; i < data.length; i++)list["L"].push($dbC7k.DynamoDB.Converter.input(data[i], options));
    return list;
}
/**
 * @api private
 * @param value [String]
 * @param wrapNumbers [Boolean]
 */ function $9f15f6439871bdce$var$convertNumber(value, wrapNumbers) {
    return wrapNumbers ? new $fb5Nh(value) : Number(value);
}
/**
 * @api private
 * @param data [map]
 * @param options [map]
 */ function $9f15f6439871bdce$var$formatMap(data, options) {
    var map = {
        M: {}
    };
    for(var key in data){
        var formatted = $dbC7k.DynamoDB.Converter.input(data[key], options);
        if (formatted !== void 0) map["M"][key] = formatted;
    }
    return map;
}
/**
 * @api private
 */ function $9f15f6439871bdce$var$formatSet(data, options) {
    options = options || {};
    var values = data.values;
    if (options.convertEmptyValues) {
        values = $9f15f6439871bdce$var$filterEmptySetValues(data);
        if (values.length === 0) return $dbC7k.DynamoDB.Converter.input(null);
    }
    var map = {};
    switch(data.type){
        case "String":
            map["SS"] = values;
            break;
        case "Binary":
            map["BS"] = values;
            break;
        case "Number":
            map["NS"] = values.map(function(value) {
                return value.toString();
            });
    }
    return map;
}
/**
 * @api private
 */ function $9f15f6439871bdce$var$filterEmptySetValues(set) {
    var nonEmptyValues = [];
    var potentiallyEmptyTypes = {
        String: true,
        Binary: true,
        Number: false
    };
    if (potentiallyEmptyTypes[set.type]) {
        for(var i = 0; i < set.values.length; i++){
            if (set.values[i].length === 0) continue;
            nonEmptyValues.push(set.values[i]);
        }
        return nonEmptyValues;
    }
    return set.values;
}
/**
 * @api private
 */ module.exports = $dbC7k.DynamoDB.Converter;

});
parcelRequire.register("bp0ht", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
var $84d23f4b0b580d39$require$util = $dbC7k.util;
function $84d23f4b0b580d39$var$typeOf(data) {
    if (data === null && typeof data === "object") return "null";
    else if (data !== undefined && $84d23f4b0b580d39$var$isBinary(data)) return "Binary";
    else if (data !== undefined && data.constructor) return data.wrapperName || $84d23f4b0b580d39$require$util.typeName(data.constructor);
    else if (data !== undefined && typeof data === "object") // this object is the result of Object.create(null), hence the absence of a
    // defined constructor
    return "Object";
    else return "undefined";
}
function $84d23f4b0b580d39$var$isBinary(data) {
    var types = [
        "Buffer",
        "File",
        "Blob",
        "ArrayBuffer",
        "DataView",
        "Int8Array",
        "Uint8Array",
        "Uint8ClampedArray",
        "Int16Array",
        "Uint16Array",
        "Int32Array",
        "Uint32Array",
        "Float32Array",
        "Float64Array"
    ];
    if ($84d23f4b0b580d39$require$util.isNode()) {
        var Stream = $84d23f4b0b580d39$require$util.stream.Stream;
        if ($84d23f4b0b580d39$require$util.Buffer.isBuffer(data) || data instanceof Stream) return true;
    }
    for(var i = 0; i < types.length; i++)if (data !== undefined && data.constructor) {
        if ($84d23f4b0b580d39$require$util.isType(data, types[i])) return true;
        if ($84d23f4b0b580d39$require$util.typeName(data.constructor) === types[i]) return true;
    }
    return false;
}
/**
 * @api private
 */ module.exports = {
    typeOf: $84d23f4b0b580d39$var$typeOf,
    isBinary: $84d23f4b0b580d39$var$isBinary
};

});

parcelRequire.register("ggt9L", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
var $bd74c1cf47544341$require$util = $dbC7k.util;

var $bp0ht = parcelRequire("bp0ht");
var $bd74c1cf47544341$require$typeOf = $bp0ht.typeOf;
/**
 * @api private
 */ var $bd74c1cf47544341$var$memberTypeToSetType = {
    "String": "String",
    "Number": "Number",
    "NumberValue": "Number",
    "Binary": "Binary"
};
/**
 * @api private
 */ var $bd74c1cf47544341$var$DynamoDBSet = $bd74c1cf47544341$require$util.inherit({
    constructor: function Set(list, options) {
        options = options || {};
        this.wrapperName = "Set";
        this.initialize(list, options.validate);
    },
    initialize: function(list, validate) {
        var self = this;
        self.values = [].concat(list);
        self.detectType();
        if (validate) self.validate();
    },
    detectType: function() {
        this.type = $bd74c1cf47544341$var$memberTypeToSetType[$bd74c1cf47544341$require$typeOf(this.values[0])];
        if (!this.type) throw $bd74c1cf47544341$require$util.error(new Error(), {
            code: "InvalidSetType",
            message: "Sets can contain string, number, or binary values"
        });
    },
    validate: function() {
        var self = this;
        var length = self.values.length;
        var values = self.values;
        for(var i = 0; i < length; i++){
            if ($bd74c1cf47544341$var$memberTypeToSetType[$bd74c1cf47544341$require$typeOf(values[i])] !== self.type) throw $bd74c1cf47544341$require$util.error(new Error(), {
                code: "InvalidType",
                message: self.type + " Set contains " + $bd74c1cf47544341$require$typeOf(values[i]) + " value"
            });
        }
    },
    /**
   * Render the underlying values only when converting to JSON.
   */ toJSON: function() {
        var self = this;
        return self.values;
    }
});
/**
 * @api private
 */ module.exports = $bd74c1cf47544341$var$DynamoDBSet;

});

parcelRequire.register("fb5Nh", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
var $02da018f150c362b$require$util = $dbC7k.util;
/**
 * An object recognizable as a numeric value that stores the underlying number
 * as a string.
 *
 * Intended to be a deserialization target for the DynamoDB Document Client when
 * the `wrapNumbers` flag is set. This allows for numeric values that lose
 * precision when converted to JavaScript's `number` type.
 */ var $02da018f150c362b$var$DynamoDBNumberValue = $02da018f150c362b$require$util.inherit({
    constructor: function NumberValue(value) {
        this.wrapperName = "NumberValue";
        this.value = value.toString();
    },
    /**
   * Render the underlying value as a number when converting to JSON.
   */ toJSON: function() {
        return this.toNumber();
    },
    /**
   * Convert the underlying value to a JavaScript number.
   */ toNumber: function() {
        return Number(this.value);
    },
    /**
   * Return a string representing the unaltered value provided to the
   * constructor.
   */ toString: function() {
        return this.value;
    }
});
/**
 * @api private
 */ module.exports = $02da018f150c362b$var$DynamoDBNumberValue;

});





parcelRequire.register("6JxaH", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2011-12-05","endpointPrefix":"dynamodb","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"DynamoDB","serviceFullName":"Amazon DynamoDB","serviceId":"DynamoDB","signatureVersion":"v4","targetPrefix":"DynamoDB_20111205","uid":"dynamodb-2011-12-05"},"operations":{"BatchGetItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"S2"}}},"output":{"type":"structure","members":{"Responses":{"type":"map","key":{},"value":{"type":"structure","members":{"Items":{"shape":"Sk"},"ConsumedCapacityUnits":{"type":"double"}}}},"UnprocessedKeys":{"shape":"S2"}}}},"BatchWriteItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"So"}}},"output":{"type":"structure","members":{"Responses":{"type":"map","key":{},"value":{"type":"structure","members":{"ConsumedCapacityUnits":{"type":"double"}}}},"UnprocessedItems":{"shape":"So"}}}},"CreateTable":{"input":{"type":"structure","required":["TableName","KeySchema","ProvisionedThroughput"],"members":{"TableName":{},"KeySchema":{"shape":"Sy"},"ProvisionedThroughput":{"shape":"S12"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S15"}}}},"DeleteItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"Expected":{"shape":"S1b"},"ReturnValues":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"DeleteTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S15"}}}},"DescribeTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"Table":{"shape":"S15"}}}},"GetItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"AttributesToGet":{"shape":"Se"},"ConsistentRead":{"type":"boolean"}}},"output":{"type":"structure","members":{"Item":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"ListTables":{"input":{"type":"structure","members":{"ExclusiveStartTableName":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TableNames":{"type":"list","member":{}},"LastEvaluatedTableName":{}}}},"PutItem":{"input":{"type":"structure","required":["TableName","Item"],"members":{"TableName":{},"Item":{"shape":"Ss"},"Expected":{"shape":"S1b"},"ReturnValues":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"Query":{"input":{"type":"structure","required":["TableName","HashKeyValue"],"members":{"TableName":{},"AttributesToGet":{"shape":"Se"},"Limit":{"type":"integer"},"ConsistentRead":{"type":"boolean"},"Count":{"type":"boolean"},"HashKeyValue":{"shape":"S7"},"RangeKeyCondition":{"shape":"S1u"},"ScanIndexForward":{"type":"boolean"},"ExclusiveStartKey":{"shape":"S6"}}},"output":{"type":"structure","members":{"Items":{"shape":"Sk"},"Count":{"type":"integer"},"LastEvaluatedKey":{"shape":"S6"},"ConsumedCapacityUnits":{"type":"double"}}}},"Scan":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{},"AttributesToGet":{"shape":"Se"},"Limit":{"type":"integer"},"Count":{"type":"boolean"},"ScanFilter":{"type":"map","key":{},"value":{"shape":"S1u"}},"ExclusiveStartKey":{"shape":"S6"}}},"output":{"type":"structure","members":{"Items":{"shape":"Sk"},"Count":{"type":"integer"},"ScannedCount":{"type":"integer"},"LastEvaluatedKey":{"shape":"S6"},"ConsumedCapacityUnits":{"type":"double"}}}},"UpdateItem":{"input":{"type":"structure","required":["TableName","Key","AttributeUpdates"],"members":{"TableName":{},"Key":{"shape":"S6"},"AttributeUpdates":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S7"},"Action":{}}}},"Expected":{"shape":"S1b"},"ReturnValues":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"UpdateTable":{"input":{"type":"structure","required":["TableName","ProvisionedThroughput"],"members":{"TableName":{},"ProvisionedThroughput":{"shape":"S12"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S15"}}}}},"shapes":{"S2":{"type":"map","key":{},"value":{"type":"structure","required":["Keys"],"members":{"Keys":{"type":"list","member":{"shape":"S6"}},"AttributesToGet":{"shape":"Se"},"ConsistentRead":{"type":"boolean"}}}},"S6":{"type":"structure","required":["HashKeyElement"],"members":{"HashKeyElement":{"shape":"S7"},"RangeKeyElement":{"shape":"S7"}}},"S7":{"type":"structure","members":{"S":{},"N":{},"B":{"type":"blob"},"SS":{"type":"list","member":{}},"NS":{"type":"list","member":{}},"BS":{"type":"list","member":{"type":"blob"}}}},"Se":{"type":"list","member":{}},"Sk":{"type":"list","member":{"shape":"Sl"}},"Sl":{"type":"map","key":{},"value":{"shape":"S7"}},"So":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"PutRequest":{"type":"structure","required":["Item"],"members":{"Item":{"shape":"Ss"}}},"DeleteRequest":{"type":"structure","required":["Key"],"members":{"Key":{"shape":"S6"}}}}}}},"Ss":{"type":"map","key":{},"value":{"shape":"S7"}},"Sy":{"type":"structure","required":["HashKeyElement"],"members":{"HashKeyElement":{"shape":"Sz"},"RangeKeyElement":{"shape":"Sz"}}},"Sz":{"type":"structure","required":["AttributeName","AttributeType"],"members":{"AttributeName":{},"AttributeType":{}}},"S12":{"type":"structure","required":["ReadCapacityUnits","WriteCapacityUnits"],"members":{"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"S15":{"type":"structure","members":{"TableName":{},"KeySchema":{"shape":"Sy"},"TableStatus":{},"CreationDateTime":{"type":"timestamp"},"ProvisionedThroughput":{"type":"structure","members":{"LastIncreaseDateTime":{"type":"timestamp"},"LastDecreaseDateTime":{"type":"timestamp"},"NumberOfDecreasesToday":{"type":"long"},"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"TableSizeBytes":{"type":"long"},"ItemCount":{"type":"long"}}},"S1b":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S7"},"Exists":{"type":"boolean"}}}},"S1u":{"type":"structure","required":["ComparisonOperator"],"members":{"AttributeValueList":{"type":"list","member":{"shape":"S7"}},"ComparisonOperator":{}}}}}');

});

parcelRequire.register("h7nJR", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"BatchGetItem":{"input_token":"RequestItems","output_token":"UnprocessedKeys"},"ListTables":{"input_token":"ExclusiveStartTableName","limit_key":"Limit","output_token":"LastEvaluatedTableName","result_key":"TableNames"},"Query":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"},"Scan":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"}}}');

});

parcelRequire.register("4xmEi", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"TableExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ACTIVE","matcher":"path","state":"success","argument":"Table.TableStatus"},{"expected":"ResourceNotFoundException","matcher":"error","state":"retry"}]},"TableNotExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]}}}');

});

parcelRequire.register("14kpV", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2012-08-10","endpointPrefix":"dynamodb","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"DynamoDB","serviceFullName":"Amazon DynamoDB","serviceId":"DynamoDB","signatureVersion":"v4","targetPrefix":"DynamoDB_20120810","uid":"dynamodb-2012-08-10"},"operations":{"BatchGetItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"S2"},"ReturnConsumedCapacity":{}}},"output":{"type":"structure","members":{"Responses":{"type":"map","key":{},"value":{"shape":"Sr"}},"UnprocessedKeys":{"shape":"S2"},"ConsumedCapacity":{"shape":"St"}}},"endpointdiscovery":{}},"BatchWriteItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"S10"},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{}}},"output":{"type":"structure","members":{"UnprocessedItems":{"shape":"S10"},"ItemCollectionMetrics":{"shape":"S18"},"ConsumedCapacity":{"shape":"St"}}},"endpointdiscovery":{}},"CreateBackup":{"input":{"type":"structure","required":["TableName","BackupName"],"members":{"TableName":{},"BackupName":{}}},"output":{"type":"structure","members":{"BackupDetails":{"shape":"S1h"}}},"endpointdiscovery":{}},"CreateGlobalTable":{"input":{"type":"structure","required":["GlobalTableName","ReplicationGroup"],"members":{"GlobalTableName":{},"ReplicationGroup":{"shape":"S1p"}}},"output":{"type":"structure","members":{"GlobalTableDescription":{"shape":"S1t"}}},"endpointdiscovery":{}},"CreateTable":{"input":{"type":"structure","required":["AttributeDefinitions","TableName","KeySchema"],"members":{"AttributeDefinitions":{"shape":"S1z"},"TableName":{},"KeySchema":{"shape":"S23"},"LocalSecondaryIndexes":{"type":"list","member":{"type":"structure","required":["IndexName","KeySchema","Projection"],"members":{"IndexName":{},"KeySchema":{"shape":"S23"},"Projection":{"shape":"S28"}}}},"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","required":["IndexName","KeySchema","Projection"],"members":{"IndexName":{},"KeySchema":{"shape":"S23"},"Projection":{"shape":"S28"},"ProvisionedThroughput":{"shape":"S2e"}}}},"BillingMode":{},"ProvisionedThroughput":{"shape":"S2e"},"StreamSpecification":{"shape":"S2h"},"SSESpecification":{"shape":"S2k"},"Tags":{"shape":"S2o"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S2t"}}},"endpointdiscovery":{}},"DeleteBackup":{"input":{"type":"structure","required":["BackupArn"],"members":{"BackupArn":{}}},"output":{"type":"structure","members":{"BackupDescription":{"shape":"S3g"}}},"endpointdiscovery":{}},"DeleteItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"Expected":{"shape":"S3t"},"ConditionalOperator":{},"ReturnValues":{},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S41"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Ss"},"ConsumedCapacity":{"shape":"Su"},"ItemCollectionMetrics":{"shape":"S1a"}}},"endpointdiscovery":{}},"DeleteTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S2t"}}},"endpointdiscovery":{}},"DescribeBackup":{"input":{"type":"structure","required":["BackupArn"],"members":{"BackupArn":{}}},"output":{"type":"structure","members":{"BackupDescription":{"shape":"S3g"}}},"endpointdiscovery":{}},"DescribeContinuousBackups":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"ContinuousBackupsDescription":{"shape":"S4a"}}},"endpointdiscovery":{}},"DescribeEndpoints":{"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["Endpoints"],"members":{"Endpoints":{"type":"list","member":{"type":"structure","required":["Address","CachePeriodInMinutes"],"members":{"Address":{},"CachePeriodInMinutes":{"type":"long"}}}}}},"endpointoperation":true},"DescribeGlobalTable":{"input":{"type":"structure","required":["GlobalTableName"],"members":{"GlobalTableName":{}}},"output":{"type":"structure","members":{"GlobalTableDescription":{"shape":"S1t"}}},"endpointdiscovery":{}},"DescribeGlobalTableSettings":{"input":{"type":"structure","required":["GlobalTableName"],"members":{"GlobalTableName":{}}},"output":{"type":"structure","members":{"GlobalTableName":{},"ReplicaSettings":{"shape":"S4m"}}},"endpointdiscovery":{}},"DescribeLimits":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AccountMaxReadCapacityUnits":{"type":"long"},"AccountMaxWriteCapacityUnits":{"type":"long"},"TableMaxReadCapacityUnits":{"type":"long"},"TableMaxWriteCapacityUnits":{"type":"long"}}},"endpointdiscovery":{}},"DescribeTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"Table":{"shape":"S2t"}}},"endpointdiscovery":{}},"DescribeTimeToLive":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TimeToLiveDescription":{"shape":"S3p"}}},"endpointdiscovery":{}},"GetItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"AttributesToGet":{"shape":"Sj"},"ConsistentRead":{"type":"boolean"},"ReturnConsumedCapacity":{},"ProjectionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"}}},"output":{"type":"structure","members":{"Item":{"shape":"Ss"},"ConsumedCapacity":{"shape":"Su"}}},"endpointdiscovery":{}},"ListBackups":{"input":{"type":"structure","members":{"TableName":{},"Limit":{"type":"integer"},"TimeRangeLowerBound":{"type":"timestamp"},"TimeRangeUpperBound":{"type":"timestamp"},"ExclusiveStartBackupArn":{},"BackupType":{}}},"output":{"type":"structure","members":{"BackupSummaries":{"type":"list","member":{"type":"structure","members":{"TableName":{},"TableId":{},"TableArn":{},"BackupArn":{},"BackupName":{},"BackupCreationDateTime":{"type":"timestamp"},"BackupExpiryDateTime":{"type":"timestamp"},"BackupStatus":{},"BackupType":{},"BackupSizeBytes":{"type":"long"}}}},"LastEvaluatedBackupArn":{}}},"endpointdiscovery":{}},"ListGlobalTables":{"input":{"type":"structure","members":{"ExclusiveStartGlobalTableName":{},"Limit":{"type":"integer"},"RegionName":{}}},"output":{"type":"structure","members":{"GlobalTables":{"type":"list","member":{"type":"structure","members":{"GlobalTableName":{},"ReplicationGroup":{"shape":"S1p"}}}},"LastEvaluatedGlobalTableName":{}}},"endpointdiscovery":{}},"ListTables":{"input":{"type":"structure","members":{"ExclusiveStartTableName":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TableNames":{"type":"list","member":{}},"LastEvaluatedTableName":{}}},"endpointdiscovery":{}},"ListTagsOfResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S2o"},"NextToken":{}}},"endpointdiscovery":{}},"PutItem":{"input":{"type":"structure","required":["TableName","Item"],"members":{"TableName":{},"Item":{"shape":"S14"},"Expected":{"shape":"S3t"},"ReturnValues":{},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"ConditionalOperator":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S41"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Ss"},"ConsumedCapacity":{"shape":"Su"},"ItemCollectionMetrics":{"shape":"S1a"}}},"endpointdiscovery":{}},"Query":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{},"IndexName":{},"Select":{},"AttributesToGet":{"shape":"Sj"},"Limit":{"type":"integer"},"ConsistentRead":{"type":"boolean"},"KeyConditions":{"type":"map","key":{},"value":{"shape":"S5w"}},"QueryFilter":{"shape":"S5x"},"ConditionalOperator":{},"ScanIndexForward":{"type":"boolean"},"ExclusiveStartKey":{"shape":"S6"},"ReturnConsumedCapacity":{},"ProjectionExpression":{},"FilterExpression":{},"KeyConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S41"}}},"output":{"type":"structure","members":{"Items":{"shape":"Sr"},"Count":{"type":"integer"},"ScannedCount":{"type":"integer"},"LastEvaluatedKey":{"shape":"S6"},"ConsumedCapacity":{"shape":"Su"}}},"endpointdiscovery":{}},"RestoreTableFromBackup":{"input":{"type":"structure","required":["TargetTableName","BackupArn"],"members":{"TargetTableName":{},"BackupArn":{}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S2t"}}},"endpointdiscovery":{}},"RestoreTableToPointInTime":{"input":{"type":"structure","required":["SourceTableName","TargetTableName"],"members":{"SourceTableName":{},"TargetTableName":{},"UseLatestRestorableTime":{"type":"boolean"},"RestoreDateTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S2t"}}},"endpointdiscovery":{}},"Scan":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{},"IndexName":{},"AttributesToGet":{"shape":"Sj"},"Limit":{"type":"integer"},"Select":{},"ScanFilter":{"shape":"S5x"},"ConditionalOperator":{},"ExclusiveStartKey":{"shape":"S6"},"ReturnConsumedCapacity":{},"TotalSegments":{"type":"integer"},"Segment":{"type":"integer"},"ProjectionExpression":{},"FilterExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S41"},"ConsistentRead":{"type":"boolean"}}},"output":{"type":"structure","members":{"Items":{"shape":"Sr"},"Count":{"type":"integer"},"ScannedCount":{"type":"integer"},"LastEvaluatedKey":{"shape":"S6"},"ConsumedCapacity":{"shape":"Su"}}},"endpointdiscovery":{}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S2o"}}},"endpointdiscovery":{}},"TransactGetItems":{"input":{"type":"structure","required":["TransactItems"],"members":{"TransactItems":{"type":"list","member":{"type":"structure","required":["Get"],"members":{"Get":{"type":"structure","required":["Key","TableName"],"members":{"Key":{"shape":"S6"},"TableName":{},"ProjectionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"}}}}}},"ReturnConsumedCapacity":{}}},"output":{"type":"structure","members":{"ConsumedCapacity":{"shape":"St"},"Responses":{"type":"list","member":{"type":"structure","members":{"Item":{"shape":"Ss"}}}}}},"endpointdiscovery":{}},"TransactWriteItems":{"input":{"type":"structure","required":["TransactItems"],"members":{"TransactItems":{"type":"list","member":{"type":"structure","members":{"ConditionCheck":{"type":"structure","required":["Key","TableName","ConditionExpression"],"members":{"Key":{"shape":"S6"},"TableName":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S41"},"ReturnValuesOnConditionCheckFailure":{}}},"Put":{"type":"structure","required":["Item","TableName"],"members":{"Item":{"shape":"S14"},"TableName":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S41"},"ReturnValuesOnConditionCheckFailure":{}}},"Delete":{"type":"structure","required":["Key","TableName"],"members":{"Key":{"shape":"S6"},"TableName":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S41"},"ReturnValuesOnConditionCheckFailure":{}}},"Update":{"type":"structure","required":["Key","UpdateExpression","TableName"],"members":{"Key":{"shape":"S6"},"UpdateExpression":{},"TableName":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S41"},"ReturnValuesOnConditionCheckFailure":{}}}}}},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ConsumedCapacity":{"shape":"St"},"ItemCollectionMetrics":{"shape":"S18"}}},"endpointdiscovery":{}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"endpointdiscovery":{}},"UpdateContinuousBackups":{"input":{"type":"structure","required":["TableName","PointInTimeRecoverySpecification"],"members":{"TableName":{},"PointInTimeRecoverySpecification":{"type":"structure","required":["PointInTimeRecoveryEnabled"],"members":{"PointInTimeRecoveryEnabled":{"type":"boolean"}}}}},"output":{"type":"structure","members":{"ContinuousBackupsDescription":{"shape":"S4a"}}},"endpointdiscovery":{}},"UpdateGlobalTable":{"input":{"type":"structure","required":["GlobalTableName","ReplicaUpdates"],"members":{"GlobalTableName":{},"ReplicaUpdates":{"type":"list","member":{"type":"structure","members":{"Create":{"type":"structure","required":["RegionName"],"members":{"RegionName":{}}},"Delete":{"type":"structure","required":["RegionName"],"members":{"RegionName":{}}}}}}}},"output":{"type":"structure","members":{"GlobalTableDescription":{"shape":"S1t"}}},"endpointdiscovery":{}},"UpdateGlobalTableSettings":{"input":{"type":"structure","required":["GlobalTableName"],"members":{"GlobalTableName":{},"GlobalTableBillingMode":{},"GlobalTableProvisionedWriteCapacityUnits":{"type":"long"},"GlobalTableProvisionedWriteCapacityAutoScalingSettingsUpdate":{"shape":"S74"},"GlobalTableGlobalSecondaryIndexSettingsUpdate":{"type":"list","member":{"type":"structure","required":["IndexName"],"members":{"IndexName":{},"ProvisionedWriteCapacityUnits":{"type":"long"},"ProvisionedWriteCapacityAutoScalingSettingsUpdate":{"shape":"S74"}}}},"ReplicaSettingsUpdate":{"type":"list","member":{"type":"structure","required":["RegionName"],"members":{"RegionName":{},"ReplicaProvisionedReadCapacityUnits":{"type":"long"},"ReplicaProvisionedReadCapacityAutoScalingSettingsUpdate":{"shape":"S74"},"ReplicaGlobalSecondaryIndexSettingsUpdate":{"type":"list","member":{"type":"structure","required":["IndexName"],"members":{"IndexName":{},"ProvisionedReadCapacityUnits":{"type":"long"},"ProvisionedReadCapacityAutoScalingSettingsUpdate":{"shape":"S74"}}}}}}}}},"output":{"type":"structure","members":{"GlobalTableName":{},"ReplicaSettings":{"shape":"S4m"}}},"endpointdiscovery":{}},"UpdateItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"AttributeUpdates":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S8"},"Action":{}}}},"Expected":{"shape":"S3t"},"ConditionalOperator":{},"ReturnValues":{},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"UpdateExpression":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"},"ExpressionAttributeValues":{"shape":"S41"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Ss"},"ConsumedCapacity":{"shape":"Su"},"ItemCollectionMetrics":{"shape":"S1a"}}},"endpointdiscovery":{}},"UpdateTable":{"input":{"type":"structure","required":["TableName"],"members":{"AttributeDefinitions":{"shape":"S1z"},"TableName":{},"BillingMode":{},"ProvisionedThroughput":{"shape":"S2e"},"GlobalSecondaryIndexUpdates":{"type":"list","member":{"type":"structure","members":{"Update":{"type":"structure","required":["IndexName","ProvisionedThroughput"],"members":{"IndexName":{},"ProvisionedThroughput":{"shape":"S2e"}}},"Create":{"type":"structure","required":["IndexName","KeySchema","Projection"],"members":{"IndexName":{},"KeySchema":{"shape":"S23"},"Projection":{"shape":"S28"},"ProvisionedThroughput":{"shape":"S2e"}}},"Delete":{"type":"structure","required":["IndexName"],"members":{"IndexName":{}}}}}},"StreamSpecification":{"shape":"S2h"},"SSESpecification":{"shape":"S2k"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S2t"}}},"endpointdiscovery":{}},"UpdateTimeToLive":{"input":{"type":"structure","required":["TableName","TimeToLiveSpecification"],"members":{"TableName":{},"TimeToLiveSpecification":{"shape":"S7s"}}},"output":{"type":"structure","members":{"TimeToLiveSpecification":{"shape":"S7s"}}},"endpointdiscovery":{}}},"shapes":{"S2":{"type":"map","key":{},"value":{"type":"structure","required":["Keys"],"members":{"Keys":{"type":"list","member":{"shape":"S6"}},"AttributesToGet":{"shape":"Sj"},"ConsistentRead":{"type":"boolean"},"ProjectionExpression":{},"ExpressionAttributeNames":{"shape":"Sm"}}}},"S6":{"type":"map","key":{},"value":{"shape":"S8"}},"S8":{"type":"structure","members":{"S":{},"N":{},"B":{"type":"blob"},"SS":{"type":"list","member":{}},"NS":{"type":"list","member":{}},"BS":{"type":"list","member":{"type":"blob"}},"M":{"type":"map","key":{},"value":{"shape":"S8"}},"L":{"type":"list","member":{"shape":"S8"}},"NULL":{"type":"boolean"},"BOOL":{"type":"boolean"}}},"Sj":{"type":"list","member":{}},"Sm":{"type":"map","key":{},"value":{}},"Sr":{"type":"list","member":{"shape":"Ss"}},"Ss":{"type":"map","key":{},"value":{"shape":"S8"}},"St":{"type":"list","member":{"shape":"Su"}},"Su":{"type":"structure","members":{"TableName":{},"CapacityUnits":{"type":"double"},"ReadCapacityUnits":{"type":"double"},"WriteCapacityUnits":{"type":"double"},"Table":{"shape":"Sw"},"LocalSecondaryIndexes":{"shape":"Sx"},"GlobalSecondaryIndexes":{"shape":"Sx"}}},"Sw":{"type":"structure","members":{"ReadCapacityUnits":{"type":"double"},"WriteCapacityUnits":{"type":"double"},"CapacityUnits":{"type":"double"}}},"Sx":{"type":"map","key":{},"value":{"shape":"Sw"}},"S10":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"PutRequest":{"type":"structure","required":["Item"],"members":{"Item":{"shape":"S14"}}},"DeleteRequest":{"type":"structure","required":["Key"],"members":{"Key":{"shape":"S6"}}}}}}},"S14":{"type":"map","key":{},"value":{"shape":"S8"}},"S18":{"type":"map","key":{},"value":{"type":"list","member":{"shape":"S1a"}}},"S1a":{"type":"structure","members":{"ItemCollectionKey":{"type":"map","key":{},"value":{"shape":"S8"}},"SizeEstimateRangeGB":{"type":"list","member":{"type":"double"}}}},"S1h":{"type":"structure","required":["BackupArn","BackupName","BackupStatus","BackupType","BackupCreationDateTime"],"members":{"BackupArn":{},"BackupName":{},"BackupSizeBytes":{"type":"long"},"BackupStatus":{},"BackupType":{},"BackupCreationDateTime":{"type":"timestamp"},"BackupExpiryDateTime":{"type":"timestamp"}}},"S1p":{"type":"list","member":{"type":"structure","members":{"RegionName":{}}}},"S1t":{"type":"structure","members":{"ReplicationGroup":{"type":"list","member":{"type":"structure","members":{"RegionName":{}}}},"GlobalTableArn":{},"CreationDateTime":{"type":"timestamp"},"GlobalTableStatus":{},"GlobalTableName":{}}},"S1z":{"type":"list","member":{"type":"structure","required":["AttributeName","AttributeType"],"members":{"AttributeName":{},"AttributeType":{}}}},"S23":{"type":"list","member":{"type":"structure","required":["AttributeName","KeyType"],"members":{"AttributeName":{},"KeyType":{}}}},"S28":{"type":"structure","members":{"ProjectionType":{},"NonKeyAttributes":{"type":"list","member":{}}}},"S2e":{"type":"structure","required":["ReadCapacityUnits","WriteCapacityUnits"],"members":{"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"S2h":{"type":"structure","members":{"StreamEnabled":{"type":"boolean"},"StreamViewType":{}}},"S2k":{"type":"structure","members":{"Enabled":{"type":"boolean"},"SSEType":{},"KMSMasterKeyId":{}}},"S2o":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S2t":{"type":"structure","members":{"AttributeDefinitions":{"shape":"S1z"},"TableName":{},"KeySchema":{"shape":"S23"},"TableStatus":{},"CreationDateTime":{"type":"timestamp"},"ProvisionedThroughput":{"shape":"S2v"},"TableSizeBytes":{"type":"long"},"ItemCount":{"type":"long"},"TableArn":{},"TableId":{},"BillingModeSummary":{"shape":"S30"},"LocalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S23"},"Projection":{"shape":"S28"},"IndexSizeBytes":{"type":"long"},"ItemCount":{"type":"long"},"IndexArn":{}}}},"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S23"},"Projection":{"shape":"S28"},"IndexStatus":{},"Backfilling":{"type":"boolean"},"ProvisionedThroughput":{"shape":"S2v"},"IndexSizeBytes":{"type":"long"},"ItemCount":{"type":"long"},"IndexArn":{}}}},"StreamSpecification":{"shape":"S2h"},"LatestStreamLabel":{},"LatestStreamArn":{},"RestoreSummary":{"type":"structure","required":["RestoreDateTime","RestoreInProgress"],"members":{"SourceBackupArn":{},"SourceTableArn":{},"RestoreDateTime":{"type":"timestamp"},"RestoreInProgress":{"type":"boolean"}}},"SSEDescription":{"shape":"S3b"}}},"S2v":{"type":"structure","members":{"LastIncreaseDateTime":{"type":"timestamp"},"LastDecreaseDateTime":{"type":"timestamp"},"NumberOfDecreasesToday":{"type":"long"},"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"S30":{"type":"structure","members":{"BillingMode":{},"LastUpdateToPayPerRequestDateTime":{"type":"timestamp"}}},"S3b":{"type":"structure","members":{"Status":{},"SSEType":{},"KMSMasterKeyArn":{}}},"S3g":{"type":"structure","members":{"BackupDetails":{"shape":"S1h"},"SourceTableDetails":{"type":"structure","required":["TableName","TableId","KeySchema","TableCreationDateTime","ProvisionedThroughput"],"members":{"TableName":{},"TableId":{},"TableArn":{},"TableSizeBytes":{"type":"long"},"KeySchema":{"shape":"S23"},"TableCreationDateTime":{"type":"timestamp"},"ProvisionedThroughput":{"shape":"S2e"},"ItemCount":{"type":"long"},"BillingMode":{}}},"SourceTableFeatureDetails":{"type":"structure","members":{"LocalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S23"},"Projection":{"shape":"S28"}}}},"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S23"},"Projection":{"shape":"S28"},"ProvisionedThroughput":{"shape":"S2e"}}}},"StreamDescription":{"shape":"S2h"},"TimeToLiveDescription":{"shape":"S3p"},"SSEDescription":{"shape":"S3b"}}}}},"S3p":{"type":"structure","members":{"TimeToLiveStatus":{},"AttributeName":{}}},"S3t":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S8"},"Exists":{"type":"boolean"},"ComparisonOperator":{},"AttributeValueList":{"shape":"S3x"}}}},"S3x":{"type":"list","member":{"shape":"S8"}},"S41":{"type":"map","key":{},"value":{"shape":"S8"}},"S4a":{"type":"structure","required":["ContinuousBackupsStatus"],"members":{"ContinuousBackupsStatus":{},"PointInTimeRecoveryDescription":{"type":"structure","members":{"PointInTimeRecoveryStatus":{},"EarliestRestorableDateTime":{"type":"timestamp"},"LatestRestorableDateTime":{"type":"timestamp"}}}}},"S4m":{"type":"list","member":{"type":"structure","required":["RegionName"],"members":{"RegionName":{},"ReplicaStatus":{},"ReplicaBillingModeSummary":{"shape":"S30"},"ReplicaProvisionedReadCapacityUnits":{"type":"long"},"ReplicaProvisionedReadCapacityAutoScalingSettings":{"shape":"S4p"},"ReplicaProvisionedWriteCapacityUnits":{"type":"long"},"ReplicaProvisionedWriteCapacityAutoScalingSettings":{"shape":"S4p"},"ReplicaGlobalSecondaryIndexSettings":{"type":"list","member":{"type":"structure","required":["IndexName"],"members":{"IndexName":{},"IndexStatus":{},"ProvisionedReadCapacityUnits":{"type":"long"},"ProvisionedReadCapacityAutoScalingSettings":{"shape":"S4p"},"ProvisionedWriteCapacityUnits":{"type":"long"},"ProvisionedWriteCapacityAutoScalingSettings":{"shape":"S4p"}}}}}}},"S4p":{"type":"structure","members":{"MinimumUnits":{"type":"long"},"MaximumUnits":{"type":"long"},"AutoScalingDisabled":{"type":"boolean"},"AutoScalingRoleArn":{},"ScalingPolicies":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"TargetTrackingScalingPolicyConfiguration":{"type":"structure","required":["TargetValue"],"members":{"DisableScaleIn":{"type":"boolean"},"ScaleInCooldown":{"type":"integer"},"ScaleOutCooldown":{"type":"integer"},"TargetValue":{"type":"double"}}}}}}}},"S5w":{"type":"structure","required":["ComparisonOperator"],"members":{"AttributeValueList":{"shape":"S3x"},"ComparisonOperator":{}}},"S5x":{"type":"map","key":{},"value":{"shape":"S5w"}},"S74":{"type":"structure","members":{"MinimumUnits":{"type":"long"},"MaximumUnits":{"type":"long"},"AutoScalingDisabled":{"type":"boolean"},"AutoScalingRoleArn":{},"ScalingPolicyUpdate":{"type":"structure","required":["TargetTrackingScalingPolicyConfiguration"],"members":{"PolicyName":{},"TargetTrackingScalingPolicyConfiguration":{"type":"structure","required":["TargetValue"],"members":{"DisableScaleIn":{"type":"boolean"},"ScaleInCooldown":{"type":"integer"},"ScaleOutCooldown":{"type":"integer"},"TargetValue":{"type":"double"}}}}}}},"S7s":{"type":"structure","required":["Enabled","AttributeName"],"members":{"Enabled":{"type":"boolean"},"AttributeName":{}}}}}');

});

parcelRequire.register("hYR6Y", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"BatchGetItem":{"input_token":"RequestItems","output_token":"UnprocessedKeys"},"ListTables":{"input_token":"ExclusiveStartTableName","limit_key":"Limit","output_token":"LastEvaluatedTableName","result_key":"TableNames"},"Query":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"},"Scan":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"}}}');

});

parcelRequire.register("jNZq2", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"TableExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ACTIVE","matcher":"path","state":"success","argument":"Table.TableStatus"},{"expected":"ResourceNotFoundException","matcher":"error","state":"retry"}]},"TableNotExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]}}}');

});


parcelRequire.register("6qVcH", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $4af18b41cfbb1ffb$var$Service = $dbC7k.Service;
var $4af18b41cfbb1ffb$var$apiLoader = $dbC7k.apiLoader;
$4af18b41cfbb1ffb$var$apiLoader.services["dynamodbstreams"] = {};
$dbC7k.DynamoDBStreams = $4af18b41cfbb1ffb$var$Service.defineService("dynamodbstreams", [
    "2012-08-10"
]);


Object.defineProperty($4af18b41cfbb1ffb$var$apiLoader.services["dynamodbstreams"], "2012-08-10", {
    get: function get() {
        var model = (parcelRequire("8WMMp"));
        model.paginators = (parcelRequire("1uWmI")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.DynamoDBStreams;

});
parcelRequire.register("8WMMp", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2012-08-10","endpointPrefix":"streams.dynamodb","jsonVersion":"1.0","protocol":"json","serviceFullName":"Amazon DynamoDB Streams","serviceId":"DynamoDB Streams","signatureVersion":"v4","signingName":"dynamodb","targetPrefix":"DynamoDBStreams_20120810","uid":"streams-dynamodb-2012-08-10"},"operations":{"DescribeStream":{"input":{"type":"structure","required":["StreamArn"],"members":{"StreamArn":{},"Limit":{"type":"integer"},"ExclusiveStartShardId":{}}},"output":{"type":"structure","members":{"StreamDescription":{"type":"structure","members":{"StreamArn":{},"StreamLabel":{},"StreamStatus":{},"StreamViewType":{},"CreationRequestDateTime":{"type":"timestamp"},"TableName":{},"KeySchema":{"type":"list","member":{"type":"structure","required":["AttributeName","KeyType"],"members":{"AttributeName":{},"KeyType":{}}}},"Shards":{"type":"list","member":{"type":"structure","members":{"ShardId":{},"SequenceNumberRange":{"type":"structure","members":{"StartingSequenceNumber":{},"EndingSequenceNumber":{}}},"ParentShardId":{}}}},"LastEvaluatedShardId":{}}}}}},"GetRecords":{"input":{"type":"structure","required":["ShardIterator"],"members":{"ShardIterator":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Records":{"type":"list","member":{"type":"structure","members":{"eventID":{},"eventName":{},"eventVersion":{},"eventSource":{},"awsRegion":{},"dynamodb":{"type":"structure","members":{"ApproximateCreationDateTime":{"type":"timestamp"},"Keys":{"shape":"Sr"},"NewImage":{"shape":"Sr"},"OldImage":{"shape":"Sr"},"SequenceNumber":{},"SizeBytes":{"type":"long"},"StreamViewType":{}}},"userIdentity":{"type":"structure","members":{"PrincipalId":{},"Type":{}}}}}},"NextShardIterator":{}}}},"GetShardIterator":{"input":{"type":"structure","required":["StreamArn","ShardId","ShardIteratorType"],"members":{"StreamArn":{},"ShardId":{},"ShardIteratorType":{},"SequenceNumber":{}}},"output":{"type":"structure","members":{"ShardIterator":{}}}},"ListStreams":{"input":{"type":"structure","members":{"TableName":{},"Limit":{"type":"integer"},"ExclusiveStartStreamArn":{}}},"output":{"type":"structure","members":{"Streams":{"type":"list","member":{"type":"structure","members":{"StreamArn":{},"TableName":{},"StreamLabel":{}}}},"LastEvaluatedStreamArn":{}}}}},"shapes":{"Sr":{"type":"map","key":{},"value":{"shape":"St"}},"St":{"type":"structure","members":{"S":{},"N":{},"B":{"type":"blob"},"SS":{"type":"list","member":{}},"NS":{"type":"list","member":{}},"BS":{"type":"list","member":{"type":"blob"}},"M":{"type":"map","key":{},"value":{"shape":"St"}},"L":{"type":"list","member":{"shape":"St"}},"NULL":{"type":"boolean"},"BOOL":{"type":"boolean"}}}}}');

});

parcelRequire.register("1uWmI", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("hnS9G", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $ca7e97b9299c63e7$var$Service = $dbC7k.Service;
var $ca7e97b9299c63e7$var$apiLoader = $dbC7k.apiLoader;
$ca7e97b9299c63e7$var$apiLoader.services["ec2"] = {};
$dbC7k.EC2 = $ca7e97b9299c63e7$var$Service.defineService("ec2", [
    "2013-06-15*",
    "2013-10-15*",
    "2014-02-01*",
    "2014-05-01*",
    "2014-06-15*",
    "2014-09-01*",
    "2014-10-01*",
    "2015-03-01*",
    "2015-04-15*",
    "2015-10-01*",
    "2016-04-01*",
    "2016-09-15*",
    "2016-11-15"
]);
parcelRequire("b4uyL");



Object.defineProperty($ca7e97b9299c63e7$var$apiLoader.services["ec2"], "2016-11-15", {
    get: function get() {
        var model = (parcelRequire("2foFs"));
        model.paginators = (parcelRequire("aOF5Y")).pagination;
        model.waiters = (parcelRequire("aZeEd")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.EC2;

});
parcelRequire.register("b4uyL", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
$dbC7k.util.update($dbC7k.EC2.prototype, {
    /**
   * @api private
   */ setupRequestListeners: function setupRequestListeners(request) {
        request.removeListener("extractError", $dbC7k.EventListeners.Query.EXTRACT_ERROR);
        request.addListener("extractError", this.extractError);
        if (request.operation === "copySnapshot") request.onAsync("validate", this.buildCopySnapshotPresignedUrl);
    },
    /**
   * @api private
   */ buildCopySnapshotPresignedUrl: function buildCopySnapshotPresignedUrl(req, done) {
        if (req.params.PresignedUrl || req._subRequest) return done();
        req.params = $dbC7k.util.copy(req.params);
        req.params.DestinationRegion = req.service.config.region;
        var config = $dbC7k.util.copy(req.service.config);
        delete config.endpoint;
        config.region = req.params.SourceRegion;
        var svc = new req.service.constructor(config);
        var newReq = svc[req.operation](req.params);
        newReq._subRequest = true;
        newReq.presign(function(err, url) {
            if (err) done(err);
            else {
                req.params.PresignedUrl = url;
                done();
            }
        });
    },
    /**
   * @api private
   */ extractError: function extractError(resp) {
        // EC2 nests the error code and message deeper than other AWS Query services.
        var httpResponse = resp.httpResponse;
        var data = new $dbC7k.XML.Parser().parse(httpResponse.body.toString() || "");
        if (data.Errors) resp.error = $dbC7k.util.error(new Error(), {
            code: data.Errors.Error.Code,
            message: data.Errors.Error.Message
        });
        else resp.error = $dbC7k.util.error(new Error(), {
            code: httpResponse.statusCode,
            message: null
        });
        resp.error.requestId = data.RequestID || null;
    }
});

});

parcelRequire.register("2foFs", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-11-15","endpointPrefix":"ec2","protocol":"ec2","serviceAbbreviation":"Amazon EC2","serviceFullName":"Amazon Elastic Compute Cloud","serviceId":"EC2","signatureVersion":"v4","uid":"ec2-2016-11-15","xmlNamespace":"http://ec2.amazonaws.com/doc/2016-11-15"},"operations":{"AcceptReservedInstancesExchangeQuote":{"input":{"type":"structure","required":["ReservedInstanceIds"],"members":{"DryRun":{"type":"boolean"},"ReservedInstanceIds":{"shape":"S3","locationName":"ReservedInstanceId"},"TargetConfigurations":{"shape":"S5","locationName":"TargetConfiguration"}}},"output":{"type":"structure","members":{"ExchangeId":{"locationName":"exchangeId"}}}},"AcceptTransitGatewayVpcAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachment":{"shape":"Sb","locationName":"transitGatewayVpcAttachment"}}}},"AcceptVpcEndpointConnections":{"input":{"type":"structure","required":["ServiceId","VpcEndpointIds"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"VpcEndpointIds":{"shape":"Sd","locationName":"VpcEndpointId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"Sm","locationName":"unsuccessful"}}}},"AcceptVpcPeeringConnection":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"VpcPeeringConnection":{"shape":"Sr","locationName":"vpcPeeringConnection"}}}},"AdvertiseByoipCidr":{"input":{"type":"structure","required":["Cidr"],"members":{"Cidr":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"S12","locationName":"byoipCidr"}}}},"AllocateAddress":{"input":{"type":"structure","members":{"Domain":{},"Address":{},"PublicIpv4Pool":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"PublicIp":{"locationName":"publicIp"},"AllocationId":{"locationName":"allocationId"},"PublicIpv4Pool":{"locationName":"publicIpv4Pool"},"Domain":{"locationName":"domain"}}}},"AllocateHosts":{"input":{"type":"structure","required":["AvailabilityZone","InstanceType","Quantity"],"members":{"AutoPlacement":{"locationName":"autoPlacement"},"AvailabilityZone":{"locationName":"availabilityZone"},"ClientToken":{"locationName":"clientToken"},"InstanceType":{"locationName":"instanceType"},"Quantity":{"locationName":"quantity","type":"integer"},"TagSpecifications":{"shape":"S19","locationName":"TagSpecification"},"HostRecovery":{}}},"output":{"type":"structure","members":{"HostIds":{"shape":"S1e","locationName":"hostIdSet"}}}},"ApplySecurityGroupsToClientVpnTargetNetwork":{"input":{"type":"structure","required":["ClientVpnEndpointId","VpcId","SecurityGroupIds"],"members":{"ClientVpnEndpointId":{},"VpcId":{},"SecurityGroupIds":{"shape":"S1g","locationName":"SecurityGroupId"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"SecurityGroupIds":{"shape":"S1g","locationName":"securityGroupIds"}}}},"AssignIpv6Addresses":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"S1j","locationName":"ipv6Addresses"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"AssignedIpv6Addresses":{"shape":"S1j","locationName":"assignedIpv6Addresses"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}}},"AssignPrivateIpAddresses":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"AllowReassignment":{"locationName":"allowReassignment","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddresses":{"shape":"S1m","locationName":"privateIpAddress"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"}}},"output":{"type":"structure","members":{"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"AssignedPrivateIpAddresses":{"locationName":"assignedPrivateIpAddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"PrivateIpAddress":{"locationName":"privateIpAddress"}}}}}}},"AssociateAddress":{"input":{"type":"structure","members":{"AllocationId":{},"InstanceId":{},"PublicIp":{},"AllowReassociation":{"locationName":"allowReassociation","type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}},"output":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"}}}},"AssociateClientVpnTargetNetwork":{"input":{"type":"structure","required":["ClientVpnEndpointId","SubnetId"],"members":{"ClientVpnEndpointId":{},"SubnetId":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"Status":{"shape":"S1u","locationName":"status"}}}},"AssociateDhcpOptions":{"input":{"type":"structure","required":["DhcpOptionsId","VpcId"],"members":{"DhcpOptionsId":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"AssociateIamInstanceProfile":{"input":{"type":"structure","required":["IamInstanceProfile","InstanceId"],"members":{"IamInstanceProfile":{"shape":"S1y"},"InstanceId":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociation":{"shape":"S20","locationName":"iamInstanceProfileAssociation"}}}},"AssociateRouteTable":{"input":{"type":"structure","required":["RouteTableId","SubnetId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"},"SubnetId":{"locationName":"subnetId"}}},"output":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"}}}},"AssociateSubnetCidrBlock":{"input":{"type":"structure","required":["Ipv6CidrBlock","SubnetId"],"members":{"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"SubnetId":{"locationName":"subnetId"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S27","locationName":"ipv6CidrBlockAssociation"},"SubnetId":{"locationName":"subnetId"}}}},"AssociateTransitGatewayRouteTable":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","TransitGatewayAttachmentId"],"members":{"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Association":{"shape":"S2c","locationName":"association"}}}},"AssociateVpcCidrBlock":{"input":{"type":"structure","required":["VpcId"],"members":{"AmazonProvidedIpv6CidrBlock":{"locationName":"amazonProvidedIpv6CidrBlock","type":"boolean"},"CidrBlock":{},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S2h","locationName":"ipv6CidrBlockAssociation"},"CidrBlockAssociation":{"shape":"S2k","locationName":"cidrBlockAssociation"},"VpcId":{"locationName":"vpcId"}}}},"AttachClassicLinkVpc":{"input":{"type":"structure","required":["Groups","InstanceId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Groups":{"shape":"S2m","locationName":"SecurityGroupId"},"InstanceId":{"locationName":"instanceId"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"AttachInternetGateway":{"input":{"type":"structure","required":["InternetGatewayId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayId":{"locationName":"internetGatewayId"},"VpcId":{"locationName":"vpcId"}}}},"AttachNetworkInterface":{"input":{"type":"structure","required":["DeviceIndex","InstanceId","NetworkInterfaceId"],"members":{"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"AttachmentId":{"locationName":"attachmentId"}}}},"AttachVolume":{"input":{"type":"structure","required":["Device","InstanceId","VolumeId"],"members":{"Device":{},"InstanceId":{},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"shape":"S2s"}},"AttachVpnGateway":{"input":{"type":"structure","required":["VpcId","VpnGatewayId"],"members":{"VpcId":{},"VpnGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpcAttachment":{"shape":"S2w","locationName":"attachment"}}}},"AuthorizeClientVpnIngress":{"input":{"type":"structure","required":["ClientVpnEndpointId","TargetNetworkCidr"],"members":{"ClientVpnEndpointId":{},"TargetNetworkCidr":{},"AccessGroupId":{},"AuthorizeAllGroups":{"type":"boolean"},"Description":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Status":{"shape":"S30","locationName":"status"}}}},"AuthorizeSecurityGroupEgress":{"input":{"type":"structure","required":["GroupId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupId":{"locationName":"groupId"},"IpPermissions":{"shape":"S33","locationName":"ipPermissions"},"CidrIp":{"locationName":"cidrIp"},"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"ToPort":{"locationName":"toPort","type":"integer"},"SourceSecurityGroupName":{"locationName":"sourceSecurityGroupName"},"SourceSecurityGroupOwnerId":{"locationName":"sourceSecurityGroupOwnerId"}}}},"AuthorizeSecurityGroupIngress":{"input":{"type":"structure","members":{"CidrIp":{},"FromPort":{"type":"integer"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S33"},"IpProtocol":{},"SourceSecurityGroupName":{},"SourceSecurityGroupOwnerId":{},"ToPort":{"type":"integer"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"BundleInstance":{"input":{"type":"structure","required":["InstanceId","Storage"],"members":{"InstanceId":{},"Storage":{"shape":"S3f"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BundleTask":{"shape":"S3j","locationName":"bundleInstanceTask"}}}},"CancelBundleTask":{"input":{"type":"structure","required":["BundleId"],"members":{"BundleId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BundleTask":{"shape":"S3j","locationName":"bundleInstanceTask"}}}},"CancelCapacityReservation":{"input":{"type":"structure","required":["CapacityReservationId"],"members":{"CapacityReservationId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"CancelConversionTask":{"input":{"type":"structure","required":["ConversionTaskId"],"members":{"ConversionTaskId":{"locationName":"conversionTaskId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"ReasonMessage":{"locationName":"reasonMessage"}}}},"CancelExportTask":{"input":{"type":"structure","required":["ExportTaskId"],"members":{"ExportTaskId":{"locationName":"exportTaskId"}}}},"CancelImportTask":{"input":{"type":"structure","members":{"CancelReason":{},"DryRun":{"type":"boolean"},"ImportTaskId":{}}},"output":{"type":"structure","members":{"ImportTaskId":{"locationName":"importTaskId"},"PreviousState":{"locationName":"previousState"},"State":{"locationName":"state"}}}},"CancelReservedInstancesListing":{"input":{"type":"structure","required":["ReservedInstancesListingId"],"members":{"ReservedInstancesListingId":{"locationName":"reservedInstancesListingId"}}},"output":{"type":"structure","members":{"ReservedInstancesListings":{"shape":"S3w","locationName":"reservedInstancesListingsSet"}}}},"CancelSpotFleetRequests":{"input":{"type":"structure","required":["SpotFleetRequestIds","TerminateInstances"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotFleetRequestIds":{"shape":"Sd","locationName":"spotFleetRequestId"},"TerminateInstances":{"locationName":"terminateInstances","type":"boolean"}}},"output":{"type":"structure","members":{"SuccessfulFleetRequests":{"locationName":"successfulFleetRequestSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrentSpotFleetRequestState":{"locationName":"currentSpotFleetRequestState"},"PreviousSpotFleetRequestState":{"locationName":"previousSpotFleetRequestState"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}},"UnsuccessfulFleetRequests":{"locationName":"unsuccessfulFleetRequestSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}}}}},"CancelSpotInstanceRequests":{"input":{"type":"structure","required":["SpotInstanceRequestIds"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotInstanceRequestIds":{"shape":"S4h","locationName":"SpotInstanceRequestId"}}},"output":{"type":"structure","members":{"CancelledSpotInstanceRequests":{"locationName":"spotInstanceRequestSet","type":"list","member":{"locationName":"item","type":"structure","members":{"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"State":{"locationName":"state"}}}}}}},"ConfirmProductInstance":{"input":{"type":"structure","required":["InstanceId","ProductCode"],"members":{"InstanceId":{},"ProductCode":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"OwnerId":{"locationName":"ownerId"},"Return":{"locationName":"return","type":"boolean"}}}},"CopyFpgaImage":{"input":{"type":"structure","required":["SourceFpgaImageId","SourceRegion"],"members":{"DryRun":{"type":"boolean"},"SourceFpgaImageId":{},"Description":{},"Name":{},"SourceRegion":{},"ClientToken":{}}},"output":{"type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"}}}},"CopyImage":{"input":{"type":"structure","required":["Name","SourceImageId","SourceRegion"],"members":{"ClientToken":{},"Description":{},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"Name":{},"SourceImageId":{},"SourceRegion":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"}}}},"CopySnapshot":{"input":{"type":"structure","required":["SourceRegion","SourceSnapshotId"],"members":{"Description":{},"DestinationRegion":{"locationName":"destinationRegion"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"PresignedUrl":{"locationName":"presignedUrl"},"SourceRegion":{},"SourceSnapshotId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"}}}},"CreateCapacityReservation":{"input":{"type":"structure","required":["InstanceType","InstancePlatform","InstanceCount"],"members":{"ClientToken":{},"InstanceType":{},"InstancePlatform":{},"AvailabilityZone":{},"AvailabilityZoneId":{},"Tenancy":{},"InstanceCount":{"type":"integer"},"EbsOptimized":{"type":"boolean"},"EphemeralStorage":{"type":"boolean"},"EndDate":{"type":"timestamp"},"EndDateType":{},"InstanceMatchCriteria":{},"TagSpecifications":{"shape":"S19"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CapacityReservation":{"shape":"S50","locationName":"capacityReservation"}}}},"CreateClientVpnEndpoint":{"input":{"type":"structure","required":["ClientCidrBlock","ServerCertificateArn","AuthenticationOptions","ConnectionLogOptions"],"members":{"ClientCidrBlock":{},"ServerCertificateArn":{},"AuthenticationOptions":{"locationName":"Authentication","type":"list","member":{"type":"structure","members":{"Type":{},"ActiveDirectory":{"type":"structure","members":{"DirectoryId":{}}},"MutualAuthentication":{"type":"structure","members":{"ClientRootCertificateChainArn":{}}}}}},"ConnectionLogOptions":{"shape":"S58"},"DnsServers":{"shape":"Sd"},"TransportProtocol":{},"Description":{},"SplitTunnel":{"type":"boolean"},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true},"TagSpecifications":{"shape":"S19","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Status":{"shape":"S5b","locationName":"status"},"DnsName":{"locationName":"dnsName"}}}},"CreateClientVpnRoute":{"input":{"type":"structure","required":["ClientVpnEndpointId","DestinationCidrBlock","TargetVpcSubnetId"],"members":{"ClientVpnEndpointId":{},"DestinationCidrBlock":{},"TargetVpcSubnetId":{},"Description":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Status":{"shape":"S5f","locationName":"status"}}}},"CreateCustomerGateway":{"input":{"type":"structure","required":["BgpAsn","Type"],"members":{"BgpAsn":{"type":"integer"},"PublicIp":{"locationName":"IpAddress"},"CertificateArn":{},"Type":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"CustomerGateway":{"shape":"S5k","locationName":"customerGateway"}}}},"CreateDefaultSubnet":{"input":{"type":"structure","required":["AvailabilityZone"],"members":{"AvailabilityZone":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Subnet":{"shape":"S5n","locationName":"subnet"}}}},"CreateDefaultVpc":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Vpc":{"shape":"S5s","locationName":"vpc"}}}},"CreateDhcpOptions":{"input":{"type":"structure","required":["DhcpConfigurations"],"members":{"DhcpConfigurations":{"locationName":"dhcpConfiguration","type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"Values":{"shape":"Sd","locationName":"Value"}}}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"DhcpOptions":{"shape":"S61","locationName":"dhcpOptions"}}}},"CreateEgressOnlyInternetGateway":{"input":{"type":"structure","required":["VpcId"],"members":{"ClientToken":{},"DryRun":{"type":"boolean"},"VpcId":{}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"EgressOnlyInternetGateway":{"shape":"S68","locationName":"egressOnlyInternetGateway"}}}},"CreateFleet":{"input":{"type":"structure","required":["LaunchTemplateConfigs","TargetCapacitySpecification"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"SpotOptions":{"type":"structure","members":{"AllocationStrategy":{},"InstanceInterruptionBehavior":{},"InstancePoolsToUseCount":{"type":"integer"},"SingleInstanceType":{"type":"boolean"},"SingleAvailabilityZone":{"type":"boolean"},"MinTargetCapacity":{"type":"integer"},"MaxTotalPrice":{}}},"OnDemandOptions":{"type":"structure","members":{"AllocationStrategy":{},"SingleInstanceType":{"type":"boolean"},"SingleAvailabilityZone":{"type":"boolean"},"MinTargetCapacity":{"type":"integer"},"MaxTotalPrice":{}}},"ExcessCapacityTerminationPolicy":{},"LaunchTemplateConfigs":{"type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateSpecification":{"type":"structure","members":{"LaunchTemplateId":{},"LaunchTemplateName":{},"Version":{}}},"Overrides":{"type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceType":{},"MaxPrice":{},"SubnetId":{},"AvailabilityZone":{},"WeightedCapacity":{"type":"double"},"Priority":{"type":"double"},"Placement":{"shape":"S6q"}}}}}}},"TargetCapacitySpecification":{"shape":"S6r"},"TerminateInstancesWithExpiration":{"type":"boolean"},"Type":{},"ValidFrom":{"type":"timestamp"},"ValidUntil":{"type":"timestamp"},"ReplaceUnhealthyInstances":{"type":"boolean"},"TagSpecifications":{"shape":"S19","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"FleetId":{"locationName":"fleetId"},"Errors":{"locationName":"errorSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateAndOverrides":{"shape":"S6y","locationName":"launchTemplateAndOverrides"},"Lifecycle":{"locationName":"lifecycle"},"ErrorCode":{"locationName":"errorCode"},"ErrorMessage":{"locationName":"errorMessage"}}}},"Instances":{"locationName":"fleetInstanceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateAndOverrides":{"shape":"S6y","locationName":"launchTemplateAndOverrides"},"Lifecycle":{"locationName":"lifecycle"},"InstanceIds":{"shape":"S75","locationName":"instanceIds"},"InstanceType":{"locationName":"instanceType"},"Platform":{"locationName":"platform"}}}}}}},"CreateFlowLogs":{"input":{"type":"structure","required":["ResourceIds","ResourceType","TrafficType"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"DeliverLogsPermissionArn":{},"LogGroupName":{},"ResourceIds":{"shape":"Sd","locationName":"ResourceId"},"ResourceType":{},"TrafficType":{},"LogDestinationType":{},"LogDestination":{}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"FlowLogIds":{"shape":"Sd","locationName":"flowLogIdSet"},"Unsuccessful":{"shape":"Sm","locationName":"unsuccessful"}}}},"CreateFpgaImage":{"input":{"type":"structure","required":["InputStorageLocation"],"members":{"DryRun":{"type":"boolean"},"InputStorageLocation":{"shape":"S7e"},"LogsStorageLocation":{"shape":"S7e"},"Description":{},"Name":{},"ClientToken":{}}},"output":{"type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"},"FpgaImageGlobalId":{"locationName":"fpgaImageGlobalId"}}}},"CreateImage":{"input":{"type":"structure","required":["InstanceId","Name"],"members":{"BlockDeviceMappings":{"shape":"S7h","locationName":"blockDeviceMapping"},"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"},"Name":{"locationName":"name"},"NoReboot":{"locationName":"noReboot","type":"boolean"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"}}}},"CreateInstanceExportTask":{"input":{"type":"structure","required":["InstanceId"],"members":{"Description":{"locationName":"description"},"ExportToS3Task":{"locationName":"exportToS3","type":"structure","members":{"ContainerFormat":{"locationName":"containerFormat"},"DiskImageFormat":{"locationName":"diskImageFormat"},"S3Bucket":{"locationName":"s3Bucket"},"S3Prefix":{"locationName":"s3Prefix"}}},"InstanceId":{"locationName":"instanceId"},"TargetEnvironment":{"locationName":"targetEnvironment"}}},"output":{"type":"structure","members":{"ExportTask":{"shape":"S7s","locationName":"exportTask"}}}},"CreateInternetGateway":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InternetGateway":{"shape":"S7y","locationName":"internetGateway"}}}},"CreateKeyPair":{"input":{"type":"structure","required":["KeyName"],"members":{"KeyName":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"KeyFingerprint":{"locationName":"keyFingerprint"},"KeyMaterial":{"locationName":"keyMaterial"},"KeyName":{"locationName":"keyName"}}}},"CreateLaunchTemplate":{"input":{"type":"structure","required":["LaunchTemplateName","LaunchTemplateData"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"LaunchTemplateName":{},"VersionDescription":{},"LaunchTemplateData":{"shape":"S83"},"TagSpecifications":{"shape":"S19","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"LaunchTemplate":{"shape":"S93","locationName":"launchTemplate"}}}},"CreateLaunchTemplateVersion":{"input":{"type":"structure","required":["LaunchTemplateData"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"LaunchTemplateId":{},"LaunchTemplateName":{},"SourceVersion":{},"VersionDescription":{},"LaunchTemplateData":{"shape":"S83"}}},"output":{"type":"structure","members":{"LaunchTemplateVersion":{"shape":"S96","locationName":"launchTemplateVersion"}}}},"CreateNatGateway":{"input":{"type":"structure","required":["AllocationId","SubnetId"],"members":{"AllocationId":{},"ClientToken":{},"SubnetId":{}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"NatGateway":{"shape":"S9z","locationName":"natGateway"}}}},"CreateNetworkAcl":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"NetworkAcl":{"shape":"Sa6","locationName":"networkAcl"}}}},"CreateNetworkAclEntry":{"input":{"type":"structure","required":["Egress","NetworkAclId","Protocol","RuleAction","RuleNumber"],"members":{"CidrBlock":{"locationName":"cidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Egress":{"locationName":"egress","type":"boolean"},"IcmpTypeCode":{"shape":"Sab","locationName":"Icmp"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"NetworkAclId":{"locationName":"networkAclId"},"PortRange":{"shape":"Sac","locationName":"portRange"},"Protocol":{"locationName":"protocol"},"RuleAction":{"locationName":"ruleAction"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"CreateNetworkInterface":{"input":{"type":"structure","required":["SubnetId"],"members":{"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Groups":{"shape":"S8a","locationName":"SecurityGroupId"},"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"S9e","locationName":"ipv6Addresses"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"shape":"S8d","locationName":"privateIpAddresses"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"},"InterfaceType":{},"SubnetId":{"locationName":"subnetId"}}},"output":{"type":"structure","members":{"NetworkInterface":{"shape":"Sai","locationName":"networkInterface"}}}},"CreateNetworkInterfacePermission":{"input":{"type":"structure","required":["NetworkInterfaceId","Permission"],"members":{"NetworkInterfaceId":{},"AwsAccountId":{},"AwsService":{},"Permission":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"InterfacePermission":{"shape":"Saw","locationName":"interfacePermission"}}}},"CreatePlacementGroup":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupName":{"locationName":"groupName"},"Strategy":{"locationName":"strategy"},"PartitionCount":{"type":"integer"}}}},"CreateReservedInstancesListing":{"input":{"type":"structure","required":["ClientToken","InstanceCount","PriceSchedules","ReservedInstancesId"],"members":{"ClientToken":{"locationName":"clientToken"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"PriceSchedules":{"locationName":"priceSchedules","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Price":{"locationName":"price","type":"double"},"Term":{"locationName":"term","type":"long"}}}},"ReservedInstancesId":{"locationName":"reservedInstancesId"}}},"output":{"type":"structure","members":{"ReservedInstancesListings":{"shape":"S3w","locationName":"reservedInstancesListingsSet"}}}},"CreateRoute":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"GatewayId":{"locationName":"gatewayId"},"InstanceId":{"locationName":"instanceId"},"NatGatewayId":{"locationName":"natGatewayId"},"TransitGatewayId":{},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"RouteTableId":{"locationName":"routeTableId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"CreateRouteTable":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"RouteTable":{"shape":"Sb9","locationName":"routeTable"}}}},"CreateSecurityGroup":{"input":{"type":"structure","required":["Description","GroupName"],"members":{"Description":{"locationName":"GroupDescription"},"GroupName":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"GroupId":{"locationName":"groupId"}}}},"CreateSnapshot":{"input":{"type":"structure","required":["VolumeId"],"members":{"Description":{},"VolumeId":{},"TagSpecifications":{"shape":"S19","locationName":"TagSpecification"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"shape":"Sbl"}},"CreateSnapshots":{"input":{"type":"structure","required":["InstanceSpecification"],"members":{"Description":{},"InstanceSpecification":{"type":"structure","members":{"InstanceId":{},"ExcludeBootVolume":{"type":"boolean"}}},"TagSpecifications":{"shape":"S19","locationName":"TagSpecification"},"DryRun":{"type":"boolean"},"CopyTagsFromSource":{}}},"output":{"type":"structure","members":{"Snapshots":{"locationName":"snapshotSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"Tags":{"shape":"Si","locationName":"tagSet"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"VolumeId":{"locationName":"volumeId"},"State":{"locationName":"state"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"StartTime":{"locationName":"startTime","type":"timestamp"},"Progress":{"locationName":"progress"},"OwnerId":{"locationName":"ownerId"},"SnapshotId":{"locationName":"snapshotId"}}}}}}},"CreateSpotDatafeedSubscription":{"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"locationName":"bucket"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Prefix":{"locationName":"prefix"}}},"output":{"type":"structure","members":{"SpotDatafeedSubscription":{"shape":"Sbw","locationName":"spotDatafeedSubscription"}}}},"CreateSubnet":{"input":{"type":"structure","required":["CidrBlock","VpcId"],"members":{"AvailabilityZone":{},"AvailabilityZoneId":{},"CidrBlock":{},"Ipv6CidrBlock":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Subnet":{"shape":"S5n","locationName":"subnet"}}}},"CreateTags":{"input":{"type":"structure","required":["Resources","Tags"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Resources":{"shape":"Sc2","locationName":"ResourceId"},"Tags":{"shape":"Si","locationName":"Tag"}}}},"CreateTrafficMirrorFilter":{"input":{"type":"structure","members":{"Description":{},"TagSpecifications":{"shape":"S19","locationName":"TagSpecification"},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"TrafficMirrorFilter":{"shape":"Sc5","locationName":"trafficMirrorFilter"},"ClientToken":{"locationName":"clientToken"}}}},"CreateTrafficMirrorFilterRule":{"input":{"type":"structure","required":["TrafficMirrorFilterId","TrafficDirection","RuleNumber","RuleAction","DestinationCidrBlock","SourceCidrBlock"],"members":{"TrafficMirrorFilterId":{},"TrafficDirection":{},"RuleNumber":{"type":"integer"},"RuleAction":{},"DestinationPortRange":{"shape":"Sce"},"SourcePortRange":{"shape":"Sce"},"Protocol":{"type":"integer"},"DestinationCidrBlock":{},"SourceCidrBlock":{},"Description":{},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"TrafficMirrorFilterRule":{"shape":"Sc7","locationName":"trafficMirrorFilterRule"},"ClientToken":{"locationName":"clientToken"}}}},"CreateTrafficMirrorSession":{"input":{"type":"structure","required":["NetworkInterfaceId","TrafficMirrorTargetId","TrafficMirrorFilterId","SessionNumber"],"members":{"NetworkInterfaceId":{},"TrafficMirrorTargetId":{},"TrafficMirrorFilterId":{},"PacketLength":{"type":"integer"},"SessionNumber":{"type":"integer"},"VirtualNetworkId":{"type":"integer"},"Description":{},"TagSpecifications":{"shape":"S19","locationName":"TagSpecification"},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"TrafficMirrorSession":{"shape":"Sci","locationName":"trafficMirrorSession"},"ClientToken":{"locationName":"clientToken"}}}},"CreateTrafficMirrorTarget":{"input":{"type":"structure","members":{"NetworkInterfaceId":{},"NetworkLoadBalancerArn":{},"Description":{},"TagSpecifications":{"shape":"S19","locationName":"TagSpecification"},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"TrafficMirrorTarget":{"shape":"Scl","locationName":"trafficMirrorTarget"},"ClientToken":{"locationName":"clientToken"}}}},"CreateTransitGateway":{"input":{"type":"structure","members":{"Description":{},"Options":{"type":"structure","members":{"AmazonSideAsn":{"type":"long"},"AutoAcceptSharedAttachments":{},"DefaultRouteTableAssociation":{},"DefaultRouteTablePropagation":{},"VpnEcmpSupport":{},"DnsSupport":{}}},"TagSpecifications":{"shape":"S19","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGateway":{"shape":"Scu","locationName":"transitGateway"}}}},"CreateTransitGatewayRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","TransitGatewayRouteTableId"],"members":{"DestinationCidrBlock":{},"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"Blackhole":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Route":{"shape":"Scz","locationName":"route"}}}},"CreateTransitGatewayRouteTable":{"input":{"type":"structure","required":["TransitGatewayId"],"members":{"TransitGatewayId":{},"TagSpecifications":{"shape":"S19"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayRouteTable":{"shape":"Sd6","locationName":"transitGatewayRouteTable"}}}},"CreateTransitGatewayVpcAttachment":{"input":{"type":"structure","required":["TransitGatewayId","VpcId","SubnetIds"],"members":{"TransitGatewayId":{},"VpcId":{},"SubnetIds":{"shape":"Sd"},"Options":{"type":"structure","members":{"DnsSupport":{},"Ipv6Support":{}}},"TagSpecifications":{"shape":"S19"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachment":{"shape":"Sb","locationName":"transitGatewayVpcAttachment"}}}},"CreateVolume":{"input":{"type":"structure","required":["AvailabilityZone"],"members":{"AvailabilityZone":{},"Encrypted":{"locationName":"encrypted","type":"boolean"},"Iops":{"type":"integer"},"KmsKeyId":{},"Size":{"type":"integer"},"SnapshotId":{},"VolumeType":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"TagSpecifications":{"shape":"S19","locationName":"TagSpecification"}}},"output":{"shape":"Sdc"}},"CreateVpc":{"input":{"type":"structure","required":["CidrBlock"],"members":{"CidrBlock":{},"AmazonProvidedIpv6CidrBlock":{"locationName":"amazonProvidedIpv6CidrBlock","type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceTenancy":{"locationName":"instanceTenancy"}}},"output":{"type":"structure","members":{"Vpc":{"shape":"S5s","locationName":"vpc"}}}},"CreateVpcEndpoint":{"input":{"type":"structure","required":["VpcId","ServiceName"],"members":{"DryRun":{"type":"boolean"},"VpcEndpointType":{},"VpcId":{},"ServiceName":{},"PolicyDocument":{},"RouteTableIds":{"shape":"Sd","locationName":"RouteTableId"},"SubnetIds":{"shape":"Sd","locationName":"SubnetId"},"SecurityGroupIds":{"shape":"Sd","locationName":"SecurityGroupId"},"ClientToken":{},"PrivateDnsEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"VpcEndpoint":{"shape":"Sdk","locationName":"vpcEndpoint"},"ClientToken":{"locationName":"clientToken"}}}},"CreateVpcEndpointConnectionNotification":{"input":{"type":"structure","required":["ConnectionNotificationArn","ConnectionEvents"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"VpcEndpointId":{},"ConnectionNotificationArn":{},"ConnectionEvents":{"shape":"Sd"},"ClientToken":{}}},"output":{"type":"structure","members":{"ConnectionNotification":{"shape":"Sds","locationName":"connectionNotification"},"ClientToken":{"locationName":"clientToken"}}}},"CreateVpcEndpointServiceConfiguration":{"input":{"type":"structure","required":["NetworkLoadBalancerArns"],"members":{"DryRun":{"type":"boolean"},"AcceptanceRequired":{"type":"boolean"},"NetworkLoadBalancerArns":{"shape":"Sd","locationName":"NetworkLoadBalancerArn"},"ClientToken":{}}},"output":{"type":"structure","members":{"ServiceConfiguration":{"shape":"Sdx","locationName":"serviceConfiguration"},"ClientToken":{"locationName":"clientToken"}}}},"CreateVpcPeeringConnection":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"PeerOwnerId":{"locationName":"peerOwnerId"},"PeerVpcId":{"locationName":"peerVpcId"},"VpcId":{"locationName":"vpcId"},"PeerRegion":{}}},"output":{"type":"structure","members":{"VpcPeeringConnection":{"shape":"Sr","locationName":"vpcPeeringConnection"}}}},"CreateVpnConnection":{"input":{"type":"structure","required":["CustomerGatewayId","Type"],"members":{"CustomerGatewayId":{},"Type":{},"VpnGatewayId":{},"TransitGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"Options":{"locationName":"options","type":"structure","members":{"StaticRoutesOnly":{"locationName":"staticRoutesOnly","type":"boolean"},"TunnelOptions":{"type":"list","member":{"locationName":"item","type":"structure","members":{"TunnelInsideCidr":{},"PreSharedKey":{}}}}}}}},"output":{"type":"structure","members":{"VpnConnection":{"shape":"Se9","locationName":"vpnConnection"}}}},"CreateVpnConnectionRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","VpnConnectionId"],"members":{"DestinationCidrBlock":{},"VpnConnectionId":{}}}},"CreateVpnGateway":{"input":{"type":"structure","required":["Type"],"members":{"AvailabilityZone":{},"Type":{},"AmazonSideAsn":{"type":"long"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpnGateway":{"shape":"Sel","locationName":"vpnGateway"}}}},"DeleteClientVpnEndpoint":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Status":{"shape":"S5b","locationName":"status"}}}},"DeleteClientVpnRoute":{"input":{"type":"structure","required":["ClientVpnEndpointId","DestinationCidrBlock"],"members":{"ClientVpnEndpointId":{},"TargetVpcSubnetId":{},"DestinationCidrBlock":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Status":{"shape":"S5f","locationName":"status"}}}},"DeleteCustomerGateway":{"input":{"type":"structure","required":["CustomerGatewayId"],"members":{"CustomerGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteDhcpOptions":{"input":{"type":"structure","required":["DhcpOptionsId"],"members":{"DhcpOptionsId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteEgressOnlyInternetGateway":{"input":{"type":"structure","required":["EgressOnlyInternetGatewayId"],"members":{"DryRun":{"type":"boolean"},"EgressOnlyInternetGatewayId":{}}},"output":{"type":"structure","members":{"ReturnCode":{"locationName":"returnCode","type":"boolean"}}}},"DeleteFleets":{"input":{"type":"structure","required":["FleetIds","TerminateInstances"],"members":{"DryRun":{"type":"boolean"},"FleetIds":{"shape":"Sew","locationName":"FleetId"},"TerminateInstances":{"type":"boolean"}}},"output":{"type":"structure","members":{"SuccessfulFleetDeletions":{"locationName":"successfulFleetDeletionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrentFleetState":{"locationName":"currentFleetState"},"PreviousFleetState":{"locationName":"previousFleetState"},"FleetId":{"locationName":"fleetId"}}}},"UnsuccessfulFleetDeletions":{"locationName":"unsuccessfulFleetDeletionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"FleetId":{"locationName":"fleetId"}}}}}}},"DeleteFlowLogs":{"input":{"type":"structure","required":["FlowLogIds"],"members":{"DryRun":{"type":"boolean"},"FlowLogIds":{"shape":"Sd","locationName":"FlowLogId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"Sm","locationName":"unsuccessful"}}}},"DeleteFpgaImage":{"input":{"type":"structure","required":["FpgaImageId"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DeleteInternetGateway":{"input":{"type":"structure","required":["InternetGatewayId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayId":{"locationName":"internetGatewayId"}}}},"DeleteKeyPair":{"input":{"type":"structure","required":["KeyName"],"members":{"KeyName":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteLaunchTemplate":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"LaunchTemplateId":{},"LaunchTemplateName":{}}},"output":{"type":"structure","members":{"LaunchTemplate":{"shape":"S93","locationName":"launchTemplate"}}}},"DeleteLaunchTemplateVersions":{"input":{"type":"structure","required":["Versions"],"members":{"DryRun":{"type":"boolean"},"LaunchTemplateId":{},"LaunchTemplateName":{},"Versions":{"shape":"Sfe","locationName":"LaunchTemplateVersion"}}},"output":{"type":"structure","members":{"SuccessfullyDeletedLaunchTemplateVersions":{"locationName":"successfullyDeletedLaunchTemplateVersionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"VersionNumber":{"locationName":"versionNumber","type":"long"}}}},"UnsuccessfullyDeletedLaunchTemplateVersions":{"locationName":"unsuccessfullyDeletedLaunchTemplateVersionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"VersionNumber":{"locationName":"versionNumber","type":"long"},"ResponseError":{"locationName":"responseError","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}}}}},"DeleteNatGateway":{"input":{"type":"structure","required":["NatGatewayId"],"members":{"NatGatewayId":{}}},"output":{"type":"structure","members":{"NatGatewayId":{"locationName":"natGatewayId"}}}},"DeleteNetworkAcl":{"input":{"type":"structure","required":["NetworkAclId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"}}}},"DeleteNetworkAclEntry":{"input":{"type":"structure","required":["Egress","NetworkAclId","RuleNumber"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Egress":{"locationName":"egress","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"DeleteNetworkInterface":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}}},"DeleteNetworkInterfacePermission":{"input":{"type":"structure","required":["NetworkInterfacePermissionId"],"members":{"NetworkInterfacePermissionId":{},"Force":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DeletePlacementGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupName":{"locationName":"groupName"}}}},"DeleteRoute":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"}}}},"DeleteRouteTable":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"}}}},"DeleteSecurityGroup":{"input":{"type":"structure","members":{"GroupId":{},"GroupName":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteSnapshot":{"input":{"type":"structure","required":["SnapshotId"],"members":{"SnapshotId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteSpotDatafeedSubscription":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteSubnet":{"input":{"type":"structure","required":["SubnetId"],"members":{"SubnetId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteTags":{"input":{"type":"structure","required":["Resources"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Resources":{"shape":"Sc2","locationName":"resourceId"},"Tags":{"shape":"Si","locationName":"tag"}}}},"DeleteTrafficMirrorFilter":{"input":{"type":"structure","required":["TrafficMirrorFilterId"],"members":{"TrafficMirrorFilterId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorFilterId":{"locationName":"trafficMirrorFilterId"}}}},"DeleteTrafficMirrorFilterRule":{"input":{"type":"structure","required":["TrafficMirrorFilterRuleId"],"members":{"TrafficMirrorFilterRuleId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorFilterRuleId":{"locationName":"trafficMirrorFilterRuleId"}}}},"DeleteTrafficMirrorSession":{"input":{"type":"structure","required":["TrafficMirrorSessionId"],"members":{"TrafficMirrorSessionId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorSessionId":{"locationName":"trafficMirrorSessionId"}}}},"DeleteTrafficMirrorTarget":{"input":{"type":"structure","required":["TrafficMirrorTargetId"],"members":{"TrafficMirrorTargetId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorTargetId":{"locationName":"trafficMirrorTargetId"}}}},"DeleteTransitGateway":{"input":{"type":"structure","required":["TransitGatewayId"],"members":{"TransitGatewayId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGateway":{"shape":"Scu","locationName":"transitGateway"}}}},"DeleteTransitGatewayRoute":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","DestinationCidrBlock"],"members":{"TransitGatewayRouteTableId":{},"DestinationCidrBlock":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Route":{"shape":"Scz","locationName":"route"}}}},"DeleteTransitGatewayRouteTable":{"input":{"type":"structure","required":["TransitGatewayRouteTableId"],"members":{"TransitGatewayRouteTableId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayRouteTable":{"shape":"Sd6","locationName":"transitGatewayRouteTable"}}}},"DeleteTransitGatewayVpcAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachment":{"shape":"Sb","locationName":"transitGatewayVpcAttachment"}}}},"DeleteVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteVpc":{"input":{"type":"structure","required":["VpcId"],"members":{"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteVpcEndpointConnectionNotifications":{"input":{"type":"structure","required":["ConnectionNotificationIds"],"members":{"DryRun":{"type":"boolean"},"ConnectionNotificationIds":{"shape":"Sd","locationName":"ConnectionNotificationId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"Sm","locationName":"unsuccessful"}}}},"DeleteVpcEndpointServiceConfigurations":{"input":{"type":"structure","required":["ServiceIds"],"members":{"DryRun":{"type":"boolean"},"ServiceIds":{"shape":"Sd","locationName":"ServiceId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"Sm","locationName":"unsuccessful"}}}},"DeleteVpcEndpoints":{"input":{"type":"structure","required":["VpcEndpointIds"],"members":{"DryRun":{"type":"boolean"},"VpcEndpointIds":{"shape":"Sd","locationName":"VpcEndpointId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"Sm","locationName":"unsuccessful"}}}},"DeleteVpcPeeringConnection":{"input":{"type":"structure","required":["VpcPeeringConnectionId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DeleteVpnConnection":{"input":{"type":"structure","required":["VpnConnectionId"],"members":{"VpnConnectionId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteVpnConnectionRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","VpnConnectionId"],"members":{"DestinationCidrBlock":{},"VpnConnectionId":{}}}},"DeleteVpnGateway":{"input":{"type":"structure","required":["VpnGatewayId"],"members":{"VpnGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeprovisionByoipCidr":{"input":{"type":"structure","required":["Cidr"],"members":{"Cidr":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"S12","locationName":"byoipCidr"}}}},"DeregisterImage":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DescribeAccountAttributes":{"input":{"type":"structure","members":{"AttributeNames":{"locationName":"attributeName","type":"list","member":{"locationName":"attributeName"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"AccountAttributes":{"locationName":"accountAttributeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AttributeName":{"locationName":"attributeName"},"AttributeValues":{"locationName":"attributeValueSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AttributeValue":{"locationName":"attributeValue"}}}}}}}}}},"DescribeAddresses":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"PublicIps":{"locationName":"PublicIp","type":"list","member":{"locationName":"PublicIp"}},"AllocationIds":{"locationName":"AllocationId","type":"list","member":{"locationName":"AllocationId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Addresses":{"locationName":"addressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"PublicIp":{"locationName":"publicIp"},"AllocationId":{"locationName":"allocationId"},"AssociationId":{"locationName":"associationId"},"Domain":{"locationName":"domain"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"NetworkInterfaceOwnerId":{"locationName":"networkInterfaceOwnerId"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"Tags":{"shape":"Si","locationName":"tagSet"},"PublicIpv4Pool":{"locationName":"publicIpv4Pool"}}}}}}},"DescribeAggregateIdFormat":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"UseLongIdsAggregated":{"locationName":"useLongIdsAggregated","type":"boolean"},"Statuses":{"shape":"Shf","locationName":"statusSet"}}}},"DescribeAvailabilityZones":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"ZoneNames":{"locationName":"ZoneName","type":"list","member":{"locationName":"ZoneName"}},"ZoneIds":{"locationName":"ZoneId","type":"list","member":{"locationName":"ZoneId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"AvailabilityZones":{"locationName":"availabilityZoneInfo","type":"list","member":{"locationName":"item","type":"structure","members":{"State":{"locationName":"zoneState"},"Messages":{"locationName":"messageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Message":{"locationName":"message"}}}},"RegionName":{"locationName":"regionName"},"ZoneName":{"locationName":"zoneName"},"ZoneId":{"locationName":"zoneId"}}}}}}},"DescribeBundleTasks":{"input":{"type":"structure","members":{"BundleIds":{"locationName":"BundleId","type":"list","member":{"locationName":"BundleId"}},"Filters":{"shape":"Sh6","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BundleTasks":{"locationName":"bundleInstanceTasksSet","type":"list","member":{"shape":"S3j","locationName":"item"}}}}},"DescribeByoipCidrs":{"input":{"type":"structure","required":["MaxResults"],"members":{"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ByoipCidrs":{"locationName":"byoipCidrSet","type":"list","member":{"shape":"S12","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeCapacityReservations":{"input":{"type":"structure","members":{"CapacityReservationIds":{"locationName":"CapacityReservationId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"Sh6","locationName":"Filter"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"CapacityReservations":{"locationName":"capacityReservationSet","type":"list","member":{"shape":"S50","locationName":"item"}}}}},"DescribeClassicLinkInstances":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceIds":{"shape":"Si5","locationName":"InstanceId"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Instances":{"locationName":"instancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Groups":{"shape":"Sal","locationName":"groupSet"},"InstanceId":{"locationName":"instanceId"},"Tags":{"shape":"Si","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClientVpnAuthorizationRules":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"DryRun":{"type":"boolean"},"NextToken":{},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AuthorizationRules":{"locationName":"authorizationRule","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Description":{"locationName":"description"},"GroupId":{"locationName":"groupId"},"AccessAll":{"locationName":"accessAll","type":"boolean"},"DestinationCidr":{"locationName":"destinationCidr"},"Status":{"shape":"S30","locationName":"status"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClientVpnConnections":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"Filters":{"shape":"Sh6","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Connections":{"locationName":"connections","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Timestamp":{"locationName":"timestamp"},"ConnectionId":{"locationName":"connectionId"},"Username":{"locationName":"username"},"ConnectionEstablishedTime":{"locationName":"connectionEstablishedTime"},"IngressBytes":{"locationName":"ingressBytes"},"EgressBytes":{"locationName":"egressBytes"},"IngressPackets":{"locationName":"ingressPackets"},"EgressPackets":{"locationName":"egressPackets"},"ClientIp":{"locationName":"clientIp"},"CommonName":{"locationName":"commonName"},"Status":{"shape":"Sik","locationName":"status"},"ConnectionEndTime":{"locationName":"connectionEndTime"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClientVpnEndpoints":{"input":{"type":"structure","members":{"ClientVpnEndpointIds":{"shape":"Sd","locationName":"ClientVpnEndpointId"},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Sh6","locationName":"Filter"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ClientVpnEndpoints":{"locationName":"clientVpnEndpoint","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Description":{"locationName":"description"},"Status":{"shape":"S5b","locationName":"status"},"CreationTime":{"locationName":"creationTime"},"DeletionTime":{"locationName":"deletionTime"},"DnsName":{"locationName":"dnsName"},"ClientCidrBlock":{"locationName":"clientCidrBlock"},"DnsServers":{"shape":"Sd","locationName":"dnsServer"},"SplitTunnel":{"locationName":"splitTunnel","type":"boolean"},"VpnProtocol":{"locationName":"vpnProtocol"},"TransportProtocol":{"locationName":"transportProtocol"},"AssociatedTargetNetworks":{"deprecated":true,"deprecatedMessage":"This property is deprecated. To view the target networks associated with a Client VPN endpoint, call DescribeClientVpnTargetNetworks and inspect the clientVpnTargetNetworks response element.","locationName":"associatedTargetNetwork","type":"list","member":{"locationName":"item","type":"structure","members":{"NetworkId":{"locationName":"networkId"},"NetworkType":{"locationName":"networkType"}}}},"ServerCertificateArn":{"locationName":"serverCertificateArn"},"AuthenticationOptions":{"locationName":"authenticationOptions","type":"list","member":{"locationName":"item","type":"structure","members":{"Type":{"locationName":"type"},"ActiveDirectory":{"locationName":"activeDirectory","type":"structure","members":{"DirectoryId":{"locationName":"directoryId"}}},"MutualAuthentication":{"locationName":"mutualAuthentication","type":"structure","members":{"ClientRootCertificateChain":{"locationName":"clientRootCertificateChain"}}}}}},"ConnectionLogOptions":{"locationName":"connectionLogOptions","type":"structure","members":{"Enabled":{"type":"boolean"},"CloudwatchLogGroup":{},"CloudwatchLogStream":{}}},"Tags":{"shape":"Si","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClientVpnRoutes":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Routes":{"locationName":"routes","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"DestinationCidr":{"locationName":"destinationCidr"},"TargetSubnet":{"locationName":"targetSubnet"},"Type":{"locationName":"type"},"Origin":{"locationName":"origin"},"Status":{"shape":"S5f","locationName":"status"},"Description":{"locationName":"description"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClientVpnTargetNetworks":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"AssociationIds":{"shape":"Sd"},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Sh6","locationName":"Filter"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ClientVpnTargetNetworks":{"locationName":"clientVpnTargetNetworks","type":"list","member":{"locationName":"item","type":"structure","members":{"AssociationId":{"locationName":"associationId"},"VpcId":{"locationName":"vpcId"},"TargetNetworkId":{"locationName":"targetNetworkId"},"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Status":{"shape":"S1u","locationName":"status"},"SecurityGroups":{"shape":"Sd","locationName":"securityGroups"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeConversionTasks":{"input":{"type":"structure","members":{"ConversionTaskIds":{"locationName":"conversionTaskId","type":"list","member":{"locationName":"item"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"ConversionTasks":{"locationName":"conversionTasks","type":"list","member":{"shape":"Sje","locationName":"item"}}}}},"DescribeCustomerGateways":{"input":{"type":"structure","members":{"CustomerGatewayIds":{"locationName":"CustomerGatewayId","type":"list","member":{"locationName":"CustomerGatewayId"}},"Filters":{"shape":"Sh6","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"CustomerGateways":{"locationName":"customerGatewaySet","type":"list","member":{"shape":"S5k","locationName":"item"}}}}},"DescribeDhcpOptions":{"input":{"type":"structure","members":{"DhcpOptionsIds":{"locationName":"DhcpOptionsId","type":"list","member":{"locationName":"DhcpOptionsId"}},"Filters":{"shape":"Sh6","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DhcpOptions":{"locationName":"dhcpOptionsSet","type":"list","member":{"shape":"S61","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeEgressOnlyInternetGateways":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"EgressOnlyInternetGatewayIds":{"locationName":"EgressOnlyInternetGatewayId","type":"list","member":{"locationName":"item"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"EgressOnlyInternetGateways":{"locationName":"egressOnlyInternetGatewaySet","type":"list","member":{"shape":"S68","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeElasticGpus":{"input":{"type":"structure","members":{"ElasticGpuIds":{"locationName":"ElasticGpuId","type":"list","member":{"locationName":"item"}},"DryRun":{"type":"boolean"},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ElasticGpuSet":{"locationName":"elasticGpuSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ElasticGpuId":{"locationName":"elasticGpuId"},"AvailabilityZone":{"locationName":"availabilityZone"},"ElasticGpuType":{"locationName":"elasticGpuType"},"ElasticGpuHealth":{"locationName":"elasticGpuHealth","type":"structure","members":{"Status":{"locationName":"status"}}},"ElasticGpuState":{"locationName":"elasticGpuState"},"InstanceId":{"locationName":"instanceId"}}}},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}}},"DescribeExportImageTasks":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sh6","locationName":"Filter"},"ExportImageTaskIds":{"locationName":"ExportImageTaskId","type":"list","member":{"locationName":"ExportImageTaskId"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ExportImageTasks":{"locationName":"exportImageTaskSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"ExportImageTaskId":{"locationName":"exportImageTaskId"},"ImageId":{"locationName":"imageId"},"Progress":{"locationName":"progress"},"S3ExportLocation":{"shape":"Skf","locationName":"s3ExportLocation"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeExportTasks":{"input":{"type":"structure","members":{"ExportTaskIds":{"locationName":"exportTaskId","type":"list","member":{"locationName":"ExportTaskId"}}}},"output":{"type":"structure","members":{"ExportTasks":{"locationName":"exportTaskSet","type":"list","member":{"shape":"S7s","locationName":"item"}}}}},"DescribeFleetHistory":{"input":{"type":"structure","required":["FleetId","StartTime"],"members":{"DryRun":{"type":"boolean"},"EventType":{},"MaxResults":{"type":"integer"},"NextToken":{},"FleetId":{},"StartTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"HistoryRecords":{"locationName":"historyRecordSet","type":"list","member":{"locationName":"item","type":"structure","members":{"EventInformation":{"shape":"Skp","locationName":"eventInformation"},"EventType":{"locationName":"eventType"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"LastEvaluatedTime":{"locationName":"lastEvaluatedTime","type":"timestamp"},"NextToken":{"locationName":"nextToken"},"FleetId":{"locationName":"fleetId"},"StartTime":{"locationName":"startTime","type":"timestamp"}}}},"DescribeFleetInstances":{"input":{"type":"structure","required":["FleetId"],"members":{"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{},"FleetId":{},"Filters":{"shape":"Sh6","locationName":"Filter"}}},"output":{"type":"structure","members":{"ActiveInstances":{"shape":"Sks","locationName":"activeInstanceSet"},"NextToken":{"locationName":"nextToken"},"FleetId":{"locationName":"fleetId"}}}},"DescribeFleets":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{},"FleetIds":{"shape":"Sew","locationName":"FleetId"},"Filters":{"shape":"Sh6","locationName":"Filter"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Fleets":{"locationName":"fleetSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ActivityStatus":{"locationName":"activityStatus"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"FleetId":{"locationName":"fleetId"},"FleetState":{"locationName":"fleetState"},"ClientToken":{"locationName":"clientToken"},"ExcessCapacityTerminationPolicy":{"locationName":"excessCapacityTerminationPolicy"},"FulfilledCapacity":{"locationName":"fulfilledCapacity","type":"double"},"FulfilledOnDemandCapacity":{"locationName":"fulfilledOnDemandCapacity","type":"double"},"LaunchTemplateConfigs":{"locationName":"launchTemplateConfigs","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateSpecification":{"shape":"S6z","locationName":"launchTemplateSpecification"},"Overrides":{"locationName":"overrides","type":"list","member":{"shape":"S70","locationName":"item"}}}}},"TargetCapacitySpecification":{"locationName":"targetCapacitySpecification","type":"structure","members":{"TotalTargetCapacity":{"locationName":"totalTargetCapacity","type":"integer"},"OnDemandTargetCapacity":{"locationName":"onDemandTargetCapacity","type":"integer"},"SpotTargetCapacity":{"locationName":"spotTargetCapacity","type":"integer"},"DefaultTargetCapacityType":{"locationName":"defaultTargetCapacityType"}}},"TerminateInstancesWithExpiration":{"locationName":"terminateInstancesWithExpiration","type":"boolean"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"ReplaceUnhealthyInstances":{"locationName":"replaceUnhealthyInstances","type":"boolean"},"SpotOptions":{"locationName":"spotOptions","type":"structure","members":{"AllocationStrategy":{"locationName":"allocationStrategy"},"InstanceInterruptionBehavior":{"locationName":"instanceInterruptionBehavior"},"InstancePoolsToUseCount":{"locationName":"instancePoolsToUseCount","type":"integer"},"SingleInstanceType":{"locationName":"singleInstanceType","type":"boolean"},"SingleAvailabilityZone":{"locationName":"singleAvailabilityZone","type":"boolean"},"MinTargetCapacity":{"locationName":"minTargetCapacity","type":"integer"},"MaxTotalPrice":{"locationName":"maxTotalPrice"}}},"OnDemandOptions":{"locationName":"onDemandOptions","type":"structure","members":{"AllocationStrategy":{"locationName":"allocationStrategy"},"SingleInstanceType":{"locationName":"singleInstanceType","type":"boolean"},"SingleAvailabilityZone":{"locationName":"singleAvailabilityZone","type":"boolean"},"MinTargetCapacity":{"locationName":"minTargetCapacity","type":"integer"},"MaxTotalPrice":{"locationName":"maxTotalPrice"}}},"Tags":{"shape":"Si","locationName":"tagSet"},"Errors":{"locationName":"errorSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateAndOverrides":{"shape":"S6y","locationName":"launchTemplateAndOverrides"},"Lifecycle":{"locationName":"lifecycle"},"ErrorCode":{"locationName":"errorCode"},"ErrorMessage":{"locationName":"errorMessage"}}}},"Instances":{"locationName":"fleetInstanceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateAndOverrides":{"shape":"S6y","locationName":"launchTemplateAndOverrides"},"Lifecycle":{"locationName":"lifecycle"},"InstanceIds":{"shape":"S75","locationName":"instanceIds"},"InstanceType":{"locationName":"instanceType"},"Platform":{"locationName":"platform"}}}}}}}}}},"DescribeFlowLogs":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filter":{"shape":"Sh6"},"FlowLogIds":{"shape":"Sd","locationName":"FlowLogId"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FlowLogs":{"locationName":"flowLogSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CreationTime":{"locationName":"creationTime","type":"timestamp"},"DeliverLogsErrorMessage":{"locationName":"deliverLogsErrorMessage"},"DeliverLogsPermissionArn":{"locationName":"deliverLogsPermissionArn"},"DeliverLogsStatus":{"locationName":"deliverLogsStatus"},"FlowLogId":{"locationName":"flowLogId"},"FlowLogStatus":{"locationName":"flowLogStatus"},"LogGroupName":{"locationName":"logGroupName"},"ResourceId":{"locationName":"resourceId"},"TrafficType":{"locationName":"trafficType"},"LogDestinationType":{"locationName":"logDestinationType"},"LogDestination":{"locationName":"logDestination"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeFpgaImageAttribute":{"input":{"type":"structure","required":["FpgaImageId","Attribute"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{},"Attribute":{}}},"output":{"type":"structure","members":{"FpgaImageAttribute":{"shape":"Slh","locationName":"fpgaImageAttribute"}}}},"DescribeFpgaImages":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"FpgaImageIds":{"locationName":"FpgaImageId","type":"list","member":{"locationName":"item"}},"Owners":{"shape":"Slq","locationName":"Owner"},"Filters":{"shape":"Sh6","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FpgaImages":{"locationName":"fpgaImageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"},"FpgaImageGlobalId":{"locationName":"fpgaImageGlobalId"},"Name":{"locationName":"name"},"Description":{"locationName":"description"},"ShellVersion":{"locationName":"shellVersion"},"PciId":{"locationName":"pciId","type":"structure","members":{"DeviceId":{},"VendorId":{},"SubsystemId":{},"SubsystemVendorId":{}}},"State":{"locationName":"state","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"CreateTime":{"locationName":"createTime","type":"timestamp"},"UpdateTime":{"locationName":"updateTime","type":"timestamp"},"OwnerId":{"locationName":"ownerId"},"OwnerAlias":{"locationName":"ownerAlias"},"ProductCodes":{"shape":"Sll","locationName":"productCodes"},"Tags":{"shape":"Si","locationName":"tags"},"Public":{"locationName":"public","type":"boolean"},"DataRetentionSupport":{"locationName":"dataRetentionSupport","type":"boolean"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeHostReservationOfferings":{"input":{"type":"structure","members":{"Filter":{"shape":"Sh6"},"MaxDuration":{"type":"integer"},"MaxResults":{"type":"integer"},"MinDuration":{"type":"integer"},"NextToken":{},"OfferingId":{}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"OfferingSet":{"locationName":"offeringSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceFamily":{"locationName":"instanceFamily"},"OfferingId":{"locationName":"offeringId"},"PaymentOption":{"locationName":"paymentOption"},"UpfrontPrice":{"locationName":"upfrontPrice"}}}}}}},"DescribeHostReservations":{"input":{"type":"structure","members":{"Filter":{"shape":"Sh6"},"HostReservationIdSet":{"type":"list","member":{"locationName":"item"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"HostReservationSet":{"locationName":"hostReservationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Count":{"locationName":"count","type":"integer"},"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"End":{"locationName":"end","type":"timestamp"},"HostIdSet":{"shape":"Sm9","locationName":"hostIdSet"},"HostReservationId":{"locationName":"hostReservationId"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceFamily":{"locationName":"instanceFamily"},"OfferingId":{"locationName":"offeringId"},"PaymentOption":{"locationName":"paymentOption"},"Start":{"locationName":"start","type":"timestamp"},"State":{"locationName":"state"},"UpfrontPrice":{"locationName":"upfrontPrice"},"Tags":{"shape":"Si","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeHosts":{"input":{"type":"structure","members":{"Filter":{"shape":"Sh6","locationName":"filter"},"HostIds":{"shape":"Smc","locationName":"hostId"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Hosts":{"locationName":"hostSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AutoPlacement":{"locationName":"autoPlacement"},"AvailabilityZone":{"locationName":"availabilityZone"},"AvailableCapacity":{"locationName":"availableCapacity","type":"structure","members":{"AvailableInstanceCapacity":{"locationName":"availableInstanceCapacity","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailableCapacity":{"locationName":"availableCapacity","type":"integer"},"InstanceType":{"locationName":"instanceType"},"TotalCapacity":{"locationName":"totalCapacity","type":"integer"}}}},"AvailableVCpus":{"locationName":"availableVCpus","type":"integer"}}},"ClientToken":{"locationName":"clientToken"},"HostId":{"locationName":"hostId"},"HostProperties":{"locationName":"hostProperties","type":"structure","members":{"Cores":{"locationName":"cores","type":"integer"},"InstanceType":{"locationName":"instanceType"},"Sockets":{"locationName":"sockets","type":"integer"},"TotalVCpus":{"locationName":"totalVCpus","type":"integer"}}},"HostReservationId":{"locationName":"hostReservationId"},"Instances":{"locationName":"instances","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"InstanceType":{"locationName":"instanceType"}}}},"State":{"locationName":"state"},"AllocationTime":{"locationName":"allocationTime","type":"timestamp"},"ReleaseTime":{"locationName":"releaseTime","type":"timestamp"},"Tags":{"shape":"Si","locationName":"tagSet"},"HostRecovery":{"locationName":"hostRecovery"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeIamInstanceProfileAssociations":{"input":{"type":"structure","members":{"AssociationIds":{"locationName":"AssociationId","type":"list","member":{"locationName":"AssociationId"}},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociations":{"locationName":"iamInstanceProfileAssociationSet","type":"list","member":{"shape":"S20","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeIdFormat":{"input":{"type":"structure","members":{"Resource":{}}},"output":{"type":"structure","members":{"Statuses":{"shape":"Shf","locationName":"statusSet"}}}},"DescribeIdentityIdFormat":{"input":{"type":"structure","required":["PrincipalArn"],"members":{"PrincipalArn":{"locationName":"principalArn"},"Resource":{"locationName":"resource"}}},"output":{"type":"structure","members":{"Statuses":{"shape":"Shf","locationName":"statusSet"}}}},"DescribeImageAttribute":{"input":{"type":"structure","required":["Attribute","ImageId"],"members":{"Attribute":{},"ImageId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BlockDeviceMappings":{"shape":"Smz","locationName":"blockDeviceMapping"},"ImageId":{"locationName":"imageId"},"LaunchPermissions":{"shape":"Sn0","locationName":"launchPermission"},"ProductCodes":{"shape":"Sll","locationName":"productCodes"},"Description":{"shape":"S65","locationName":"description"},"KernelId":{"shape":"S65","locationName":"kernel"},"RamdiskId":{"shape":"S65","locationName":"ramdisk"},"SriovNetSupport":{"shape":"S65","locationName":"sriovNetSupport"}}}},"DescribeImages":{"input":{"type":"structure","members":{"ExecutableUsers":{"locationName":"ExecutableBy","type":"list","member":{"locationName":"ExecutableBy"}},"Filters":{"shape":"Sh6","locationName":"Filter"},"ImageIds":{"locationName":"ImageId","type":"list","member":{"locationName":"ImageId"}},"Owners":{"shape":"Slq","locationName":"Owner"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Images":{"locationName":"imagesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Architecture":{"locationName":"architecture"},"CreationDate":{"locationName":"creationDate"},"ImageId":{"locationName":"imageId"},"ImageLocation":{"locationName":"imageLocation"},"ImageType":{"locationName":"imageType"},"Public":{"locationName":"isPublic","type":"boolean"},"KernelId":{"locationName":"kernelId"},"OwnerId":{"locationName":"imageOwnerId"},"Platform":{"locationName":"platform"},"ProductCodes":{"shape":"Sll","locationName":"productCodes"},"RamdiskId":{"locationName":"ramdiskId"},"State":{"locationName":"imageState"},"BlockDeviceMappings":{"shape":"Smz","locationName":"blockDeviceMapping"},"Description":{"locationName":"description"},"EnaSupport":{"locationName":"enaSupport","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"ImageOwnerAlias":{"locationName":"imageOwnerAlias"},"Name":{"locationName":"name"},"RootDeviceName":{"locationName":"rootDeviceName"},"RootDeviceType":{"locationName":"rootDeviceType"},"SriovNetSupport":{"locationName":"sriovNetSupport"},"StateReason":{"shape":"Snd","locationName":"stateReason"},"Tags":{"shape":"Si","locationName":"tagSet"},"VirtualizationType":{"locationName":"virtualizationType"}}}}}}},"DescribeImportImageTasks":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sh6"},"ImportTaskIds":{"shape":"Sng","locationName":"ImportTaskId"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ImportImageTasks":{"locationName":"importImageTaskSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Architecture":{"locationName":"architecture"},"Description":{"locationName":"description"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"ImageId":{"locationName":"imageId"},"ImportTaskId":{"locationName":"importTaskId"},"KmsKeyId":{"locationName":"kmsKeyId"},"LicenseType":{"locationName":"licenseType"},"Platform":{"locationName":"platform"},"Progress":{"locationName":"progress"},"SnapshotDetails":{"shape":"Snk","locationName":"snapshotDetailSet"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeImportSnapshotTasks":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sh6"},"ImportTaskIds":{"shape":"Sng","locationName":"ImportTaskId"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ImportSnapshotTasks":{"locationName":"importSnapshotTaskSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"ImportTaskId":{"locationName":"importTaskId"},"SnapshotTaskDetail":{"shape":"Snr","locationName":"snapshotTaskDetail"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstanceAttribute":{"input":{"type":"structure","required":["Attribute","InstanceId"],"members":{"Attribute":{"locationName":"attribute"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"}}},"output":{"type":"structure","members":{"Groups":{"shape":"Sal","locationName":"groupSet"},"BlockDeviceMappings":{"shape":"Snv","locationName":"blockDeviceMapping"},"DisableApiTermination":{"shape":"Sny","locationName":"disableApiTermination"},"EnaSupport":{"shape":"Sny","locationName":"enaSupport"},"EbsOptimized":{"shape":"Sny","locationName":"ebsOptimized"},"InstanceId":{"locationName":"instanceId"},"InstanceInitiatedShutdownBehavior":{"shape":"S65","locationName":"instanceInitiatedShutdownBehavior"},"InstanceType":{"shape":"S65","locationName":"instanceType"},"KernelId":{"shape":"S65","locationName":"kernel"},"ProductCodes":{"shape":"Sll","locationName":"productCodes"},"RamdiskId":{"shape":"S65","locationName":"ramdisk"},"RootDeviceName":{"shape":"S65","locationName":"rootDeviceName"},"SourceDestCheck":{"shape":"Sny","locationName":"sourceDestCheck"},"SriovNetSupport":{"shape":"S65","locationName":"sriovNetSupport"},"UserData":{"shape":"S65","locationName":"userData"}}}},"DescribeInstanceCreditSpecifications":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sh6","locationName":"Filter"},"InstanceIds":{"shape":"Si5","locationName":"InstanceId"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceCreditSpecifications":{"locationName":"instanceCreditSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"CpuCredits":{"locationName":"cpuCredits"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstanceStatus":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"InstanceIds":{"shape":"Si5","locationName":"InstanceId"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"IncludeAllInstances":{"locationName":"includeAllInstances","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceStatuses":{"locationName":"instanceStatusSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Events":{"locationName":"eventsSet","type":"list","member":{"shape":"So9","locationName":"item"}},"InstanceId":{"locationName":"instanceId"},"InstanceState":{"shape":"Soc","locationName":"instanceState"},"InstanceStatus":{"shape":"Soe","locationName":"instanceStatus"},"SystemStatus":{"shape":"Soe","locationName":"systemStatus"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstances":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"InstanceIds":{"shape":"Si5","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Reservations":{"locationName":"reservationSet","type":"list","member":{"shape":"Son","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInternetGateways":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayIds":{"shape":"Sd","locationName":"internetGatewayId"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InternetGateways":{"locationName":"internetGatewaySet","type":"list","member":{"shape":"S7y","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeKeyPairs":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"KeyNames":{"locationName":"KeyName","type":"list","member":{"locationName":"KeyName"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"KeyPairs":{"locationName":"keySet","type":"list","member":{"locationName":"item","type":"structure","members":{"KeyFingerprint":{"locationName":"keyFingerprint"},"KeyName":{"locationName":"keyName"}}}}}}},"DescribeLaunchTemplateVersions":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"LaunchTemplateId":{},"LaunchTemplateName":{},"Versions":{"shape":"Sfe","locationName":"LaunchTemplateVersion"},"MinVersion":{},"MaxVersion":{},"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"Sh6","locationName":"Filter"}}},"output":{"type":"structure","members":{"LaunchTemplateVersions":{"locationName":"launchTemplateVersionSet","type":"list","member":{"shape":"S96","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLaunchTemplates":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"LaunchTemplateIds":{"shape":"Sd","locationName":"LaunchTemplateId"},"LaunchTemplateNames":{"locationName":"LaunchTemplateName","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sh6","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"LaunchTemplates":{"locationName":"launchTemplates","type":"list","member":{"shape":"S93","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeMovingAddresses":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"PublicIps":{"shape":"Sd","locationName":"publicIp"}}},"output":{"type":"structure","members":{"MovingAddressStatuses":{"locationName":"movingAddressStatusSet","type":"list","member":{"locationName":"item","type":"structure","members":{"MoveStatus":{"locationName":"moveStatus"},"PublicIp":{"locationName":"publicIp"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNatGateways":{"input":{"type":"structure","members":{"Filter":{"shape":"Sh6"},"MaxResults":{"type":"integer"},"NatGatewayIds":{"shape":"Sd","locationName":"NatGatewayId"},"NextToken":{}}},"output":{"type":"structure","members":{"NatGateways":{"locationName":"natGatewaySet","type":"list","member":{"shape":"S9z","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkAcls":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkAclIds":{"shape":"Sd","locationName":"NetworkAclId"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NetworkAcls":{"locationName":"networkAclSet","type":"list","member":{"shape":"Sa6","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkInterfaceAttribute":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"Attribute":{"locationName":"attribute"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"Attachment":{"shape":"Sak","locationName":"attachment"},"Description":{"shape":"S65","locationName":"description"},"Groups":{"shape":"Sal","locationName":"groupSet"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"SourceDestCheck":{"shape":"Sny","locationName":"sourceDestCheck"}}}},"DescribeNetworkInterfacePermissions":{"input":{"type":"structure","members":{"NetworkInterfacePermissionIds":{"locationName":"NetworkInterfacePermissionId","type":"list","member":{}},"Filters":{"shape":"Sh6","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NetworkInterfacePermissions":{"locationName":"networkInterfacePermissions","type":"list","member":{"shape":"Saw","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkInterfaces":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceIds":{"locationName":"NetworkInterfaceId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NetworkInterfaces":{"locationName":"networkInterfaceSet","type":"list","member":{"shape":"Sai","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribePlacementGroups":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupNames":{"locationName":"groupName","type":"list","member":{}}}},"output":{"type":"structure","members":{"PlacementGroups":{"locationName":"placementGroupSet","type":"list","member":{"locationName":"item","type":"structure","members":{"GroupName":{"locationName":"groupName"},"State":{"locationName":"state"},"Strategy":{"locationName":"strategy"},"PartitionCount":{"locationName":"partitionCount","type":"integer"}}}}}}},"DescribePrefixLists":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"PrefixListIds":{"shape":"Sd","locationName":"PrefixListId"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"PrefixLists":{"locationName":"prefixListSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Cidrs":{"shape":"Sd","locationName":"cidrSet"},"PrefixListId":{"locationName":"prefixListId"},"PrefixListName":{"locationName":"prefixListName"}}}}}}},"DescribePrincipalIdFormat":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Resources":{"locationName":"Resource","type":"list","member":{"locationName":"item"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Principals":{"locationName":"principalSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Arn":{"locationName":"arn"},"Statuses":{"shape":"Shf","locationName":"statusSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribePublicIpv4Pools":{"input":{"type":"structure","members":{"PoolIds":{"shape":"Sd","locationName":"PoolId"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PublicIpv4Pools":{"locationName":"publicIpv4PoolSet","type":"list","member":{"locationName":"item","type":"structure","members":{"PoolId":{"locationName":"poolId"},"Description":{"locationName":"description"},"PoolAddressRanges":{"locationName":"poolAddressRangeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"FirstAddress":{"locationName":"firstAddress"},"LastAddress":{"locationName":"lastAddress"},"AddressCount":{"locationName":"addressCount","type":"integer"},"AvailableAddressCount":{"locationName":"availableAddressCount","type":"integer"}}}},"TotalAddressCount":{"locationName":"totalAddressCount","type":"integer"},"TotalAvailableAddressCount":{"locationName":"totalAvailableAddressCount","type":"integer"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeRegions":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"RegionNames":{"locationName":"RegionName","type":"list","member":{"locationName":"RegionName"}},"DryRun":{"locationName":"dryRun","type":"boolean"},"AllRegions":{"type":"boolean"}}},"output":{"type":"structure","members":{"Regions":{"locationName":"regionInfo","type":"list","member":{"locationName":"item","type":"structure","members":{"Endpoint":{"locationName":"regionEndpoint"},"RegionName":{"locationName":"regionName"},"OptInStatus":{"locationName":"optInStatus"}}}}}}},"DescribeReservedInstances":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"OfferingClass":{},"ReservedInstancesIds":{"shape":"Sra","locationName":"ReservedInstancesId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"OfferingType":{"locationName":"offeringType"}}},"output":{"type":"structure","members":{"ReservedInstances":{"locationName":"reservedInstancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Duration":{"locationName":"duration","type":"long"},"End":{"locationName":"end","type":"timestamp"},"FixedPrice":{"locationName":"fixedPrice","type":"float"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"InstanceType":{"locationName":"instanceType"},"ProductDescription":{"locationName":"productDescription"},"ReservedInstancesId":{"locationName":"reservedInstancesId"},"Start":{"locationName":"start","type":"timestamp"},"State":{"locationName":"state"},"UsagePrice":{"locationName":"usagePrice","type":"float"},"CurrencyCode":{"locationName":"currencyCode"},"InstanceTenancy":{"locationName":"instanceTenancy"},"OfferingClass":{"locationName":"offeringClass"},"OfferingType":{"locationName":"offeringType"},"RecurringCharges":{"shape":"Sri","locationName":"recurringCharges"},"Scope":{"locationName":"scope"},"Tags":{"shape":"Si","locationName":"tagSet"}}}}}}},"DescribeReservedInstancesListings":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"ReservedInstancesId":{"locationName":"reservedInstancesId"},"ReservedInstancesListingId":{"locationName":"reservedInstancesListingId"}}},"output":{"type":"structure","members":{"ReservedInstancesListings":{"shape":"S3w","locationName":"reservedInstancesListingsSet"}}}},"DescribeReservedInstancesModifications":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"ReservedInstancesModificationIds":{"locationName":"ReservedInstancesModificationId","type":"list","member":{"locationName":"ReservedInstancesModificationId"}},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ReservedInstancesModifications":{"locationName":"reservedInstancesModificationsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"EffectiveDate":{"locationName":"effectiveDate","type":"timestamp"},"ModificationResults":{"locationName":"modificationResultSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservedInstancesId":{"locationName":"reservedInstancesId"},"TargetConfiguration":{"shape":"Srv","locationName":"targetConfiguration"}}}},"ReservedInstancesIds":{"locationName":"reservedInstancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservedInstancesId":{"locationName":"reservedInstancesId"}}}},"ReservedInstancesModificationId":{"locationName":"reservedInstancesModificationId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"UpdateDate":{"locationName":"updateDate","type":"timestamp"}}}}}}},"DescribeReservedInstancesOfferings":{"input":{"type":"structure","members":{"AvailabilityZone":{},"Filters":{"shape":"Sh6","locationName":"Filter"},"IncludeMarketplace":{"type":"boolean"},"InstanceType":{},"MaxDuration":{"type":"long"},"MaxInstanceCount":{"type":"integer"},"MinDuration":{"type":"long"},"OfferingClass":{},"ProductDescription":{},"ReservedInstancesOfferingIds":{"locationName":"ReservedInstancesOfferingId","type":"list","member":{}},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceTenancy":{"locationName":"instanceTenancy"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"OfferingType":{"locationName":"offeringType"}}},"output":{"type":"structure","members":{"ReservedInstancesOfferings":{"locationName":"reservedInstancesOfferingsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Duration":{"locationName":"duration","type":"long"},"FixedPrice":{"locationName":"fixedPrice","type":"float"},"InstanceType":{"locationName":"instanceType"},"ProductDescription":{"locationName":"productDescription"},"ReservedInstancesOfferingId":{"locationName":"reservedInstancesOfferingId"},"UsagePrice":{"locationName":"usagePrice","type":"float"},"CurrencyCode":{"locationName":"currencyCode"},"InstanceTenancy":{"locationName":"instanceTenancy"},"Marketplace":{"locationName":"marketplace","type":"boolean"},"OfferingClass":{"locationName":"offeringClass"},"OfferingType":{"locationName":"offeringType"},"PricingDetails":{"locationName":"pricingDetailsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Count":{"locationName":"count","type":"integer"},"Price":{"locationName":"price","type":"double"}}}},"RecurringCharges":{"shape":"Sri","locationName":"recurringCharges"},"Scope":{"locationName":"scope"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeRouteTables":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableIds":{"shape":"Sd","locationName":"RouteTableId"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"RouteTables":{"locationName":"routeTableSet","type":"list","member":{"shape":"Sb9","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeScheduledInstanceAvailability":{"input":{"type":"structure","required":["FirstSlotStartTimeRange","Recurrence"],"members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sh6","locationName":"Filter"},"FirstSlotStartTimeRange":{"type":"structure","required":["EarliestTime","LatestTime"],"members":{"EarliestTime":{"type":"timestamp"},"LatestTime":{"type":"timestamp"}}},"MaxResults":{"type":"integer"},"MaxSlotDurationInHours":{"type":"integer"},"MinSlotDurationInHours":{"type":"integer"},"NextToken":{},"Recurrence":{"type":"structure","members":{"Frequency":{},"Interval":{"type":"integer"},"OccurrenceDays":{"locationName":"OccurrenceDay","type":"list","member":{"locationName":"OccurenceDay","type":"integer"}},"OccurrenceRelativeToEnd":{"type":"boolean"},"OccurrenceUnit":{}}}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ScheduledInstanceAvailabilitySet":{"locationName":"scheduledInstanceAvailabilitySet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"AvailableInstanceCount":{"locationName":"availableInstanceCount","type":"integer"},"FirstSlotStartTime":{"locationName":"firstSlotStartTime","type":"timestamp"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceType":{"locationName":"instanceType"},"MaxTermDurationInDays":{"locationName":"maxTermDurationInDays","type":"integer"},"MinTermDurationInDays":{"locationName":"minTermDurationInDays","type":"integer"},"NetworkPlatform":{"locationName":"networkPlatform"},"Platform":{"locationName":"platform"},"PurchaseToken":{"locationName":"purchaseToken"},"Recurrence":{"shape":"Ssh","locationName":"recurrence"},"SlotDurationInHours":{"locationName":"slotDurationInHours","type":"integer"},"TotalScheduledInstanceHours":{"locationName":"totalScheduledInstanceHours","type":"integer"}}}}}}},"DescribeScheduledInstances":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"ScheduledInstanceIds":{"locationName":"ScheduledInstanceId","type":"list","member":{"locationName":"ScheduledInstanceId"}},"SlotStartTimeRange":{"type":"structure","members":{"EarliestTime":{"type":"timestamp"},"LatestTime":{"type":"timestamp"}}}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ScheduledInstanceSet":{"locationName":"scheduledInstanceSet","type":"list","member":{"shape":"Sso","locationName":"item"}}}}},"DescribeSecurityGroupReferences":{"input":{"type":"structure","required":["GroupId"],"members":{"DryRun":{"type":"boolean"},"GroupId":{"type":"list","member":{"locationName":"item"}}}},"output":{"type":"structure","members":{"SecurityGroupReferenceSet":{"locationName":"securityGroupReferenceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"GroupId":{"locationName":"groupId"},"ReferencingVpcId":{"locationName":"referencingVpcId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}}}}}},"DescribeSecurityGroups":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"GroupIds":{"shape":"S2m","locationName":"GroupId"},"GroupNames":{"shape":"Ssv","locationName":"GroupName"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SecurityGroups":{"locationName":"securityGroupInfo","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"groupDescription"},"GroupName":{"locationName":"groupName"},"IpPermissions":{"shape":"S33","locationName":"ipPermissions"},"OwnerId":{"locationName":"ownerId"},"GroupId":{"locationName":"groupId"},"IpPermissionsEgress":{"shape":"S33","locationName":"ipPermissionsEgress"},"Tags":{"shape":"Si","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeSnapshotAttribute":{"input":{"type":"structure","required":["Attribute","SnapshotId"],"members":{"Attribute":{},"SnapshotId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"CreateVolumePermissions":{"shape":"St3","locationName":"createVolumePermission"},"ProductCodes":{"shape":"Sll","locationName":"productCodes"},"SnapshotId":{"locationName":"snapshotId"}}}},"DescribeSnapshots":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"OwnerIds":{"shape":"Slq","locationName":"Owner"},"RestorableByUserIds":{"locationName":"RestorableBy","type":"list","member":{}},"SnapshotIds":{"locationName":"SnapshotId","type":"list","member":{"locationName":"SnapshotId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Snapshots":{"locationName":"snapshotSet","type":"list","member":{"shape":"Sbl","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeSpotDatafeedSubscription":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"SpotDatafeedSubscription":{"shape":"Sbw","locationName":"spotDatafeedSubscription"}}}},"DescribeSpotFleetInstances":{"input":{"type":"structure","required":["SpotFleetRequestId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}},"output":{"type":"structure","members":{"ActiveInstances":{"shape":"Sks","locationName":"activeInstanceSet"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}},"DescribeSpotFleetRequestHistory":{"input":{"type":"structure","required":["SpotFleetRequestId","StartTime"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"EventType":{"locationName":"eventType"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"StartTime":{"locationName":"startTime","type":"timestamp"}}},"output":{"type":"structure","members":{"HistoryRecords":{"locationName":"historyRecordSet","type":"list","member":{"locationName":"item","type":"structure","members":{"EventInformation":{"shape":"Skp","locationName":"eventInformation"},"EventType":{"locationName":"eventType"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"LastEvaluatedTime":{"locationName":"lastEvaluatedTime","type":"timestamp"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"StartTime":{"locationName":"startTime","type":"timestamp"}}}},"DescribeSpotFleetRequests":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestIds":{"shape":"Sd","locationName":"spotFleetRequestId"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"SpotFleetRequestConfigs":{"locationName":"spotFleetRequestConfigSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ActivityStatus":{"locationName":"activityStatus"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"SpotFleetRequestConfig":{"shape":"Stq","locationName":"spotFleetRequestConfig"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"SpotFleetRequestState":{"locationName":"spotFleetRequestState"}}}}}}},"DescribeSpotInstanceRequests":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotInstanceRequestIds":{"shape":"S4h","locationName":"SpotInstanceRequestId"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SpotInstanceRequests":{"shape":"Suf","locationName":"spotInstanceRequestSet"},"NextToken":{"locationName":"nextToken"}}}},"DescribeSpotPriceHistory":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"AvailabilityZone":{"locationName":"availabilityZone"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EndTime":{"locationName":"endTime","type":"timestamp"},"InstanceTypes":{"locationName":"InstanceType","type":"list","member":{}},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"ProductDescriptions":{"locationName":"ProductDescription","type":"list","member":{}},"StartTime":{"locationName":"startTime","type":"timestamp"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"SpotPriceHistory":{"locationName":"spotPriceHistorySet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"InstanceType":{"locationName":"instanceType"},"ProductDescription":{"locationName":"productDescription"},"SpotPrice":{"locationName":"spotPrice"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}}}}},"DescribeStaleSecurityGroups":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{},"VpcId":{}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"StaleSecurityGroupSet":{"locationName":"staleSecurityGroupSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"GroupId":{"locationName":"groupId"},"GroupName":{"locationName":"groupName"},"StaleIpPermissions":{"shape":"Sux","locationName":"staleIpPermissions"},"StaleIpPermissionsEgress":{"shape":"Sux","locationName":"staleIpPermissionsEgress"},"VpcId":{"locationName":"vpcId"}}}}}}},"DescribeSubnets":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"SubnetIds":{"locationName":"SubnetId","type":"list","member":{"locationName":"SubnetId"}},"DryRun":{"locationName":"dryRun","type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Subnets":{"locationName":"subnetSet","type":"list","member":{"shape":"S5n","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTags":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Tags":{"locationName":"tagSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"Value":{"locationName":"value"}}}}}}},"DescribeTrafficMirrorFilters":{"input":{"type":"structure","members":{"TrafficMirrorFilterIds":{"shape":"Sd","locationName":"TrafficMirrorFilterId"},"DryRun":{"type":"boolean"},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"TrafficMirrorFilters":{"locationName":"trafficMirrorFilterSet","type":"list","member":{"shape":"Sc5","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTrafficMirrorSessions":{"input":{"type":"structure","members":{"TrafficMirrorSessionIds":{"shape":"Sd","locationName":"TrafficMirrorSessionId"},"DryRun":{"type":"boolean"},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"TrafficMirrorSessions":{"locationName":"trafficMirrorSessionSet","type":"list","member":{"shape":"Sci","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTrafficMirrorTargets":{"input":{"type":"structure","members":{"TrafficMirrorTargetIds":{"shape":"Sd","locationName":"TrafficMirrorTargetId"},"DryRun":{"type":"boolean"},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"TrafficMirrorTargets":{"locationName":"trafficMirrorTargetSet","type":"list","member":{"shape":"Scl","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayAttachments":{"input":{"type":"structure","members":{"TransitGatewayAttachmentIds":{"shape":"Svm"},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayAttachments":{"locationName":"transitGatewayAttachments","type":"list","member":{"locationName":"item","type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"TransitGatewayOwnerId":{"locationName":"transitGatewayOwnerId"},"ResourceOwnerId":{"locationName":"resourceOwnerId"},"ResourceType":{"locationName":"resourceType"},"ResourceId":{"locationName":"resourceId"},"State":{"locationName":"state"},"Association":{"locationName":"association","type":"structure","members":{"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"State":{"locationName":"state"}}},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Tags":{"shape":"Si","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayRouteTables":{"input":{"type":"structure","members":{"TransitGatewayRouteTableIds":{"type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayRouteTables":{"locationName":"transitGatewayRouteTables","type":"list","member":{"shape":"Sd6","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayVpcAttachments":{"input":{"type":"structure","members":{"TransitGatewayAttachmentIds":{"shape":"Svm"},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachments":{"locationName":"transitGatewayVpcAttachments","type":"list","member":{"shape":"Sb","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGateways":{"input":{"type":"structure","members":{"TransitGatewayIds":{"type":"list","member":{"locationName":"item"}},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGateways":{"locationName":"transitGatewaySet","type":"list","member":{"shape":"Scu","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVolumeAttribute":{"input":{"type":"structure","required":["Attribute","VolumeId"],"members":{"Attribute":{},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"AutoEnableIO":{"shape":"Sny","locationName":"autoEnableIO"},"ProductCodes":{"shape":"Sll","locationName":"productCodes"},"VolumeId":{"locationName":"volumeId"}}}},"DescribeVolumeStatus":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"VolumeIds":{"shape":"Sw7","locationName":"VolumeId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"VolumeStatuses":{"locationName":"volumeStatusSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Actions":{"locationName":"actionsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Code":{"locationName":"code"},"Description":{"locationName":"description"},"EventId":{"locationName":"eventId"},"EventType":{"locationName":"eventType"}}}},"AvailabilityZone":{"locationName":"availabilityZone"},"Events":{"locationName":"eventsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"EventId":{"locationName":"eventId"},"EventType":{"locationName":"eventType"},"NotAfter":{"locationName":"notAfter","type":"timestamp"},"NotBefore":{"locationName":"notBefore","type":"timestamp"}}}},"VolumeId":{"locationName":"volumeId"},"VolumeStatus":{"locationName":"volumeStatus","type":"structure","members":{"Details":{"locationName":"details","type":"list","member":{"locationName":"item","type":"structure","members":{"Name":{"locationName":"name"},"Status":{"locationName":"status"}}}},"Status":{"locationName":"status"}}}}}}}}},"DescribeVolumes":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"VolumeIds":{"shape":"Sw7","locationName":"VolumeId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Volumes":{"locationName":"volumeSet","type":"list","member":{"shape":"Sdc","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVolumesModifications":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"VolumeIds":{"shape":"Sw7","locationName":"VolumeId"},"Filters":{"shape":"Sh6","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"VolumesModifications":{"locationName":"volumeModificationSet","type":"list","member":{"shape":"Swq","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcAttribute":{"input":{"type":"structure","required":["Attribute","VpcId"],"members":{"Attribute":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpcId":{"locationName":"vpcId"},"EnableDnsHostnames":{"shape":"Sny","locationName":"enableDnsHostnames"},"EnableDnsSupport":{"shape":"Sny","locationName":"enableDnsSupport"}}}},"DescribeVpcClassicLink":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcIds":{"shape":"Sww","locationName":"VpcId"}}},"output":{"type":"structure","members":{"Vpcs":{"locationName":"vpcSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ClassicLinkEnabled":{"locationName":"classicLinkEnabled","type":"boolean"},"Tags":{"shape":"Si","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}}}}}},"DescribeVpcClassicLinkDnsSupport":{"input":{"type":"structure","members":{"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"VpcIds":{"shape":"Sww"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Vpcs":{"locationName":"vpcs","type":"list","member":{"locationName":"item","type":"structure","members":{"ClassicLinkDnsSupported":{"locationName":"classicLinkDnsSupported","type":"boolean"},"VpcId":{"locationName":"vpcId"}}}}}}},"DescribeVpcEndpointConnectionNotifications":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"ConnectionNotificationId":{},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ConnectionNotificationSet":{"locationName":"connectionNotificationSet","type":"list","member":{"shape":"Sds","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpointConnections":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"VpcEndpointConnections":{"locationName":"vpcEndpointConnectionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ServiceId":{"locationName":"serviceId"},"VpcEndpointId":{"locationName":"vpcEndpointId"},"VpcEndpointOwner":{"locationName":"vpcEndpointOwner"},"VpcEndpointState":{"locationName":"vpcEndpointState"},"CreationTimestamp":{"locationName":"creationTimestamp","type":"timestamp"},"DnsEntries":{"shape":"Sdo","locationName":"dnsEntrySet"},"NetworkLoadBalancerArns":{"shape":"Sd","locationName":"networkLoadBalancerArnSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpointServiceConfigurations":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"ServiceIds":{"shape":"Sd","locationName":"ServiceId"},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ServiceConfigurations":{"locationName":"serviceConfigurationSet","type":"list","member":{"shape":"Sdx","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpointServicePermissions":{"input":{"type":"structure","required":["ServiceId"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AllowedPrincipals":{"locationName":"allowedPrincipals","type":"list","member":{"locationName":"item","type":"structure","members":{"PrincipalType":{"locationName":"principalType"},"Principal":{"locationName":"principal"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpointServices":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"ServiceNames":{"shape":"Sd","locationName":"ServiceName"},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ServiceNames":{"shape":"Sd","locationName":"serviceNameSet"},"ServiceDetails":{"locationName":"serviceDetailSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ServiceName":{"locationName":"serviceName"},"ServiceId":{"locationName":"serviceId"},"ServiceType":{"shape":"Sdy","locationName":"serviceType"},"AvailabilityZones":{"shape":"Sd","locationName":"availabilityZoneSet"},"Owner":{"locationName":"owner"},"BaseEndpointDnsNames":{"shape":"Sd","locationName":"baseEndpointDnsNameSet"},"PrivateDnsName":{"locationName":"privateDnsName"},"VpcEndpointPolicySupported":{"locationName":"vpcEndpointPolicySupported","type":"boolean"},"AcceptanceRequired":{"locationName":"acceptanceRequired","type":"boolean"},"ManagesVpcEndpoints":{"locationName":"managesVpcEndpoints","type":"boolean"},"Tags":{"shape":"Si","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpoints":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"VpcEndpointIds":{"shape":"Sd","locationName":"VpcEndpointId"},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"VpcEndpoints":{"locationName":"vpcEndpointSet","type":"list","member":{"shape":"Sdk","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcPeeringConnections":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionIds":{"shape":"Sd","locationName":"VpcPeeringConnectionId"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"VpcPeeringConnections":{"locationName":"vpcPeeringConnectionSet","type":"list","member":{"shape":"Sr","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcs":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"VpcIds":{"locationName":"VpcId","type":"list","member":{"locationName":"VpcId"}},"DryRun":{"locationName":"dryRun","type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Vpcs":{"locationName":"vpcSet","type":"list","member":{"shape":"S5s","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpnConnections":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"VpnConnectionIds":{"locationName":"VpnConnectionId","type":"list","member":{"locationName":"VpnConnectionId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnections":{"locationName":"vpnConnectionSet","type":"list","member":{"shape":"Se9","locationName":"item"}}}}},"DescribeVpnGateways":{"input":{"type":"structure","members":{"Filters":{"shape":"Sh6","locationName":"Filter"},"VpnGatewayIds":{"locationName":"VpnGatewayId","type":"list","member":{"locationName":"VpnGatewayId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpnGateways":{"locationName":"vpnGatewaySet","type":"list","member":{"shape":"Sel","locationName":"item"}}}}},"DetachClassicLinkVpc":{"input":{"type":"structure","required":["InstanceId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DetachInternetGateway":{"input":{"type":"structure","required":["InternetGatewayId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayId":{"locationName":"internetGatewayId"},"VpcId":{"locationName":"vpcId"}}}},"DetachNetworkInterface":{"input":{"type":"structure","required":["AttachmentId"],"members":{"AttachmentId":{"locationName":"attachmentId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Force":{"locationName":"force","type":"boolean"}}}},"DetachVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"Device":{},"Force":{"type":"boolean"},"InstanceId":{},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"shape":"S2s"}},"DetachVpnGateway":{"input":{"type":"structure","required":["VpcId","VpnGatewayId"],"members":{"VpcId":{},"VpnGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DisableEbsEncryptionByDefault":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"EbsEncryptionByDefault":{"locationName":"ebsEncryptionByDefault","type":"boolean"}}}},"DisableTransitGatewayRouteTablePropagation":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","TransitGatewayAttachmentId"],"members":{"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Propagation":{"shape":"Syj","locationName":"propagation"}}}},"DisableVgwRoutePropagation":{"input":{"type":"structure","required":["GatewayId","RouteTableId"],"members":{"GatewayId":{},"RouteTableId":{}}}},"DisableVpcClassicLink":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DisableVpcClassicLinkDnsSupport":{"input":{"type":"structure","members":{"VpcId":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DisassociateAddress":{"input":{"type":"structure","members":{"AssociationId":{},"PublicIp":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DisassociateClientVpnTargetNetwork":{"input":{"type":"structure","required":["ClientVpnEndpointId","AssociationId"],"members":{"ClientVpnEndpointId":{},"AssociationId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"Status":{"shape":"S1u","locationName":"status"}}}},"DisassociateIamInstanceProfile":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociation":{"shape":"S20","locationName":"iamInstanceProfileAssociation"}}}},"DisassociateRouteTable":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{"locationName":"associationId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DisassociateSubnetCidrBlock":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{"locationName":"associationId"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S27","locationName":"ipv6CidrBlockAssociation"},"SubnetId":{"locationName":"subnetId"}}}},"DisassociateTransitGatewayRouteTable":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","TransitGatewayAttachmentId"],"members":{"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Association":{"shape":"S2c","locationName":"association"}}}},"DisassociateVpcCidrBlock":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{"locationName":"associationId"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S2h","locationName":"ipv6CidrBlockAssociation"},"CidrBlockAssociation":{"shape":"S2k","locationName":"cidrBlockAssociation"},"VpcId":{"locationName":"vpcId"}}}},"EnableEbsEncryptionByDefault":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"EbsEncryptionByDefault":{"locationName":"ebsEncryptionByDefault","type":"boolean"}}}},"EnableTransitGatewayRouteTablePropagation":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","TransitGatewayAttachmentId"],"members":{"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Propagation":{"shape":"Syj","locationName":"propagation"}}}},"EnableVgwRoutePropagation":{"input":{"type":"structure","required":["GatewayId","RouteTableId"],"members":{"GatewayId":{},"RouteTableId":{}}}},"EnableVolumeIO":{"input":{"type":"structure","required":["VolumeId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VolumeId":{"locationName":"volumeId"}}}},"EnableVpcClassicLink":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"EnableVpcClassicLinkDnsSupport":{"input":{"type":"structure","members":{"VpcId":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ExportClientVpnClientCertificateRevocationList":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CertificateRevocationList":{"locationName":"certificateRevocationList"},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}},"ExportClientVpnClientConfiguration":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ClientConfiguration":{"locationName":"clientConfiguration"}}}},"ExportImage":{"input":{"type":"structure","required":["DiskImageFormat","ImageId","S3ExportLocation"],"members":{"ClientToken":{"idempotencyToken":true},"Description":{},"DiskImageFormat":{},"DryRun":{"type":"boolean"},"ImageId":{},"S3ExportLocation":{"type":"structure","required":["S3Bucket"],"members":{"S3Bucket":{},"S3Prefix":{}}},"RoleName":{}}},"output":{"type":"structure","members":{"Description":{"locationName":"description"},"DiskImageFormat":{"locationName":"diskImageFormat"},"ExportImageTaskId":{"locationName":"exportImageTaskId"},"ImageId":{"locationName":"imageId"},"RoleName":{"locationName":"roleName"},"Progress":{"locationName":"progress"},"S3ExportLocation":{"shape":"Skf","locationName":"s3ExportLocation"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"}}}},"ExportTransitGatewayRoutes":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","S3Bucket"],"members":{"TransitGatewayRouteTableId":{},"Filters":{"shape":"Sh6","locationName":"Filter"},"S3Bucket":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"S3Location":{"locationName":"s3Location"}}}},"GetCapacityReservationUsage":{"input":{"type":"structure","required":["CapacityReservationId"],"members":{"CapacityReservationId":{},"NextToken":{},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"CapacityReservationId":{"locationName":"capacityReservationId"},"InstanceType":{"locationName":"instanceType"},"TotalInstanceCount":{"locationName":"totalInstanceCount","type":"integer"},"AvailableInstanceCount":{"locationName":"availableInstanceCount","type":"integer"},"State":{"locationName":"state"},"InstanceUsages":{"locationName":"instanceUsageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AccountId":{"locationName":"accountId"},"UsedInstanceCount":{"locationName":"usedInstanceCount","type":"integer"}}}}}}},"GetConsoleOutput":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"Latest":{"type":"boolean"}}},"output":{"type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"Output":{"locationName":"output"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"GetConsoleScreenshot":{"input":{"type":"structure","required":["InstanceId"],"members":{"DryRun":{"type":"boolean"},"InstanceId":{},"WakeUp":{"type":"boolean"}}},"output":{"type":"structure","members":{"ImageData":{"locationName":"imageData"},"InstanceId":{"locationName":"instanceId"}}}},"GetEbsDefaultKmsKeyId":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"KmsKeyId":{"locationName":"kmsKeyId"}}}},"GetEbsEncryptionByDefault":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"EbsEncryptionByDefault":{"locationName":"ebsEncryptionByDefault","type":"boolean"}}}},"GetHostReservationPurchasePreview":{"input":{"type":"structure","required":["HostIdSet","OfferingId"],"members":{"HostIdSet":{"shape":"S101"},"OfferingId":{}}},"output":{"type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Purchase":{"shape":"S103","locationName":"purchase"},"TotalHourlyPrice":{"locationName":"totalHourlyPrice"},"TotalUpfrontPrice":{"locationName":"totalUpfrontPrice"}}}},"GetLaunchTemplateData":{"input":{"type":"structure","required":["InstanceId"],"members":{"DryRun":{"type":"boolean"},"InstanceId":{}}},"output":{"type":"structure","members":{"LaunchTemplateData":{"shape":"S97","locationName":"launchTemplateData"}}}},"GetPasswordData":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"PasswordData":{"locationName":"passwordData"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"GetReservedInstancesExchangeQuote":{"input":{"type":"structure","required":["ReservedInstanceIds"],"members":{"DryRun":{"type":"boolean"},"ReservedInstanceIds":{"shape":"S3","locationName":"ReservedInstanceId"},"TargetConfigurations":{"shape":"S5","locationName":"TargetConfiguration"}}},"output":{"type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"IsValidExchange":{"locationName":"isValidExchange","type":"boolean"},"OutputReservedInstancesWillExpireAt":{"locationName":"outputReservedInstancesWillExpireAt","type":"timestamp"},"PaymentDue":{"locationName":"paymentDue"},"ReservedInstanceValueRollup":{"shape":"S10b","locationName":"reservedInstanceValueRollup"},"ReservedInstanceValueSet":{"locationName":"reservedInstanceValueSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservationValue":{"shape":"S10b","locationName":"reservationValue"},"ReservedInstanceId":{"locationName":"reservedInstanceId"}}}},"TargetConfigurationValueRollup":{"shape":"S10b","locationName":"targetConfigurationValueRollup"},"TargetConfigurationValueSet":{"locationName":"targetConfigurationValueSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservationValue":{"shape":"S10b","locationName":"reservationValue"},"TargetConfiguration":{"locationName":"targetConfiguration","type":"structure","members":{"InstanceCount":{"locationName":"instanceCount","type":"integer"},"OfferingId":{"locationName":"offeringId"}}}}}},"ValidationFailureReason":{"locationName":"validationFailureReason"}}}},"GetTransitGatewayAttachmentPropagations":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayAttachmentPropagations":{"locationName":"transitGatewayAttachmentPropagations","type":"list","member":{"locationName":"item","type":"structure","members":{"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"State":{"locationName":"state"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetTransitGatewayRouteTableAssociations":{"input":{"type":"structure","required":["TransitGatewayRouteTableId"],"members":{"TransitGatewayRouteTableId":{},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Associations":{"locationName":"associations","type":"list","member":{"locationName":"item","type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"State":{"locationName":"state"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetTransitGatewayRouteTablePropagations":{"input":{"type":"structure","required":["TransitGatewayRouteTableId"],"members":{"TransitGatewayRouteTableId":{},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayRouteTablePropagations":{"locationName":"transitGatewayRouteTablePropagations","type":"list","member":{"locationName":"item","type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"State":{"locationName":"state"}}}},"NextToken":{"locationName":"nextToken"}}}},"ImportClientVpnClientCertificateRevocationList":{"input":{"type":"structure","required":["ClientVpnEndpointId","CertificateRevocationList"],"members":{"ClientVpnEndpointId":{},"CertificateRevocationList":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ImportImage":{"input":{"type":"structure","members":{"Architecture":{},"ClientData":{"shape":"S10w"},"ClientToken":{},"Description":{},"DiskContainers":{"locationName":"DiskContainer","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{},"DeviceName":{},"Format":{},"SnapshotId":{},"Url":{},"UserBucket":{"shape":"S10z"}}}},"DryRun":{"type":"boolean"},"Encrypted":{"type":"boolean"},"Hypervisor":{},"KmsKeyId":{},"LicenseType":{},"Platform":{},"RoleName":{}}},"output":{"type":"structure","members":{"Architecture":{"locationName":"architecture"},"Description":{"locationName":"description"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"ImageId":{"locationName":"imageId"},"ImportTaskId":{"locationName":"importTaskId"},"KmsKeyId":{"locationName":"kmsKeyId"},"LicenseType":{"locationName":"licenseType"},"Platform":{"locationName":"platform"},"Progress":{"locationName":"progress"},"SnapshotDetails":{"shape":"Snk","locationName":"snapshotDetailSet"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"}}}},"ImportInstance":{"input":{"type":"structure","required":["Platform"],"members":{"Description":{"locationName":"description"},"DiskImages":{"locationName":"diskImage","type":"list","member":{"type":"structure","members":{"Description":{},"Image":{"shape":"S114"},"Volume":{"shape":"S115"}}}},"DryRun":{"locationName":"dryRun","type":"boolean"},"LaunchSpecification":{"locationName":"launchSpecification","type":"structure","members":{"AdditionalInfo":{"locationName":"additionalInfo"},"Architecture":{"locationName":"architecture"},"GroupIds":{"shape":"S8a","locationName":"GroupId"},"GroupNames":{"shape":"S8o","locationName":"GroupName"},"InstanceInitiatedShutdownBehavior":{"locationName":"instanceInitiatedShutdownBehavior"},"InstanceType":{"locationName":"instanceType"},"Monitoring":{"locationName":"monitoring","type":"boolean"},"Placement":{"shape":"S6q","locationName":"placement"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"SubnetId":{"locationName":"subnetId"},"UserData":{"locationName":"userData","type":"structure","members":{"Data":{"locationName":"data"}}}}},"Platform":{"locationName":"platform"}}},"output":{"type":"structure","members":{"ConversionTask":{"shape":"Sje","locationName":"conversionTask"}}}},"ImportKeyPair":{"input":{"type":"structure","required":["KeyName","PublicKeyMaterial"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"KeyName":{"locationName":"keyName"},"PublicKeyMaterial":{"locationName":"publicKeyMaterial","type":"blob"}}},"output":{"type":"structure","members":{"KeyFingerprint":{"locationName":"keyFingerprint"},"KeyName":{"locationName":"keyName"}}}},"ImportSnapshot":{"input":{"type":"structure","members":{"ClientData":{"shape":"S10w"},"ClientToken":{},"Description":{},"DiskContainer":{"type":"structure","members":{"Description":{},"Format":{},"Url":{},"UserBucket":{"shape":"S10z"}}},"DryRun":{"type":"boolean"},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"RoleName":{}}},"output":{"type":"structure","members":{"Description":{"locationName":"description"},"ImportTaskId":{"locationName":"importTaskId"},"SnapshotTaskDetail":{"shape":"Snr","locationName":"snapshotTaskDetail"}}}},"ImportVolume":{"input":{"type":"structure","required":["AvailabilityZone","Image","Volume"],"members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Image":{"shape":"S114","locationName":"image"},"Volume":{"shape":"S115","locationName":"volume"}}},"output":{"type":"structure","members":{"ConversionTask":{"shape":"Sje","locationName":"conversionTask"}}}},"ModifyCapacityReservation":{"input":{"type":"structure","required":["CapacityReservationId"],"members":{"CapacityReservationId":{},"InstanceCount":{"type":"integer"},"EndDate":{"type":"timestamp"},"EndDateType":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyClientVpnEndpoint":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"ServerCertificateArn":{},"ConnectionLogOptions":{"shape":"S58"},"DnsServers":{"type":"structure","members":{"CustomDnsServers":{"shape":"Sd"},"Enabled":{"type":"boolean"}}},"Description":{},"SplitTunnel":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyEbsDefaultKmsKeyId":{"input":{"type":"structure","required":["KmsKeyId"],"members":{"KmsKeyId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"KmsKeyId":{"locationName":"kmsKeyId"}}}},"ModifyFleet":{"input":{"type":"structure","required":["FleetId","TargetCapacitySpecification"],"members":{"DryRun":{"type":"boolean"},"ExcessCapacityTerminationPolicy":{},"FleetId":{},"TargetCapacitySpecification":{"shape":"S6r"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyFpgaImageAttribute":{"input":{"type":"structure","required":["FpgaImageId"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{},"Attribute":{},"OperationType":{},"UserIds":{"shape":"S11r","locationName":"UserId"},"UserGroups":{"shape":"S11s","locationName":"UserGroup"},"ProductCodes":{"shape":"S11t","locationName":"ProductCode"},"LoadPermission":{"type":"structure","members":{"Add":{"shape":"S11v"},"Remove":{"shape":"S11v"}}},"Description":{},"Name":{}}},"output":{"type":"structure","members":{"FpgaImageAttribute":{"shape":"Slh","locationName":"fpgaImageAttribute"}}}},"ModifyHosts":{"input":{"type":"structure","required":["HostIds"],"members":{"AutoPlacement":{"locationName":"autoPlacement"},"HostIds":{"shape":"Smc","locationName":"hostId"},"HostRecovery":{}}},"output":{"type":"structure","members":{"Successful":{"shape":"S1e","locationName":"successful"},"Unsuccessful":{"shape":"S120","locationName":"unsuccessful"}}}},"ModifyIdFormat":{"input":{"type":"structure","required":["Resource","UseLongIds"],"members":{"Resource":{},"UseLongIds":{"type":"boolean"}}}},"ModifyIdentityIdFormat":{"input":{"type":"structure","required":["PrincipalArn","Resource","UseLongIds"],"members":{"PrincipalArn":{"locationName":"principalArn"},"Resource":{"locationName":"resource"},"UseLongIds":{"locationName":"useLongIds","type":"boolean"}}}},"ModifyImageAttribute":{"input":{"type":"structure","required":["ImageId"],"members":{"Attribute":{},"Description":{"shape":"S65"},"ImageId":{},"LaunchPermission":{"type":"structure","members":{"Add":{"shape":"Sn0"},"Remove":{"shape":"Sn0"}}},"OperationType":{},"ProductCodes":{"shape":"S11t","locationName":"ProductCode"},"UserGroups":{"shape":"S11s","locationName":"UserGroup"},"UserIds":{"shape":"S11r","locationName":"UserId"},"Value":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ModifyInstanceAttribute":{"input":{"type":"structure","required":["InstanceId"],"members":{"SourceDestCheck":{"shape":"Sny"},"Attribute":{"locationName":"attribute"},"BlockDeviceMappings":{"locationName":"blockDeviceMapping","type":"list","member":{"locationName":"item","type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"VolumeId":{"locationName":"volumeId"}}},"NoDevice":{"locationName":"noDevice"},"VirtualName":{"locationName":"virtualName"}}}},"DisableApiTermination":{"shape":"Sny","locationName":"disableApiTermination"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EbsOptimized":{"shape":"Sny","locationName":"ebsOptimized"},"EnaSupport":{"shape":"Sny","locationName":"enaSupport"},"Groups":{"shape":"S2m","locationName":"GroupId"},"InstanceId":{"locationName":"instanceId"},"InstanceInitiatedShutdownBehavior":{"shape":"S65","locationName":"instanceInitiatedShutdownBehavior"},"InstanceType":{"shape":"S65","locationName":"instanceType"},"Kernel":{"shape":"S65","locationName":"kernel"},"Ramdisk":{"shape":"S65","locationName":"ramdisk"},"SriovNetSupport":{"shape":"S65","locationName":"sriovNetSupport"},"UserData":{"locationName":"userData","type":"structure","members":{"Value":{"locationName":"value","type":"blob"}}},"Value":{"locationName":"value"}}}},"ModifyInstanceCapacityReservationAttributes":{"input":{"type":"structure","required":["InstanceId","CapacityReservationSpecification"],"members":{"InstanceId":{},"CapacityReservationSpecification":{"shape":"S12b"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyInstanceCreditSpecification":{"input":{"type":"structure","required":["InstanceCreditSpecifications"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"InstanceCreditSpecifications":{"locationName":"InstanceCreditSpecification","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{},"CpuCredits":{}}}}}},"output":{"type":"structure","members":{"SuccessfulInstanceCreditSpecifications":{"locationName":"successfulInstanceCreditSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"}}}},"UnsuccessfulInstanceCreditSpecifications":{"locationName":"unsuccessfulInstanceCreditSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}}}}},"ModifyInstanceEventStartTime":{"input":{"type":"structure","required":["InstanceId","InstanceEventId","NotBefore"],"members":{"DryRun":{"type":"boolean"},"InstanceId":{},"InstanceEventId":{},"NotBefore":{"type":"timestamp"}}},"output":{"type":"structure","members":{"Event":{"shape":"So9","locationName":"event"}}}},"ModifyInstancePlacement":{"input":{"type":"structure","required":["InstanceId"],"members":{"Affinity":{"locationName":"affinity"},"GroupName":{},"HostId":{"locationName":"hostId"},"InstanceId":{"locationName":"instanceId"},"Tenancy":{"locationName":"tenancy"},"PartitionNumber":{"type":"integer"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyLaunchTemplate":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"ClientToken":{},"LaunchTemplateId":{},"LaunchTemplateName":{},"DefaultVersion":{"locationName":"SetDefaultVersion"}}},"output":{"type":"structure","members":{"LaunchTemplate":{"shape":"S93","locationName":"launchTemplate"}}}},"ModifyNetworkInterfaceAttribute":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"Attachment":{"locationName":"attachment","type":"structure","members":{"AttachmentId":{"locationName":"attachmentId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"}}},"Description":{"shape":"S65","locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Groups":{"shape":"S8a","locationName":"SecurityGroupId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"SourceDestCheck":{"shape":"Sny","locationName":"sourceDestCheck"}}}},"ModifyReservedInstances":{"input":{"type":"structure","required":["ReservedInstancesIds","TargetConfigurations"],"members":{"ReservedInstancesIds":{"shape":"Sra","locationName":"ReservedInstancesId"},"ClientToken":{"locationName":"clientToken"},"TargetConfigurations":{"locationName":"ReservedInstancesConfigurationSetItemType","type":"list","member":{"shape":"Srv","locationName":"item"}}}},"output":{"type":"structure","members":{"ReservedInstancesModificationId":{"locationName":"reservedInstancesModificationId"}}}},"ModifySnapshotAttribute":{"input":{"type":"structure","required":["SnapshotId"],"members":{"Attribute":{},"CreateVolumePermission":{"type":"structure","members":{"Add":{"shape":"St3"},"Remove":{"shape":"St3"}}},"GroupNames":{"shape":"Ssv","locationName":"UserGroup"},"OperationType":{},"SnapshotId":{},"UserIds":{"shape":"S11r","locationName":"UserId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ModifySpotFleetRequest":{"input":{"type":"structure","required":["SpotFleetRequestId"],"members":{"ExcessCapacityTerminationPolicy":{"locationName":"excessCapacityTerminationPolicy"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"TargetCapacity":{"locationName":"targetCapacity","type":"integer"},"OnDemandTargetCapacity":{"type":"integer"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifySubnetAttribute":{"input":{"type":"structure","required":["SubnetId"],"members":{"AssignIpv6AddressOnCreation":{"shape":"Sny"},"MapPublicIpOnLaunch":{"shape":"Sny"},"SubnetId":{"locationName":"subnetId"}}}},"ModifyTrafficMirrorFilterNetworkServices":{"input":{"type":"structure","required":["TrafficMirrorFilterId"],"members":{"TrafficMirrorFilterId":{},"AddNetworkServices":{"shape":"Scb","locationName":"AddNetworkService"},"RemoveNetworkServices":{"shape":"Scb","locationName":"RemoveNetworkService"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorFilter":{"shape":"Sc5","locationName":"trafficMirrorFilter"}}}},"ModifyTrafficMirrorFilterRule":{"input":{"type":"structure","required":["TrafficMirrorFilterRuleId"],"members":{"TrafficMirrorFilterRuleId":{},"TrafficDirection":{},"RuleNumber":{"type":"integer"},"RuleAction":{},"DestinationPortRange":{"shape":"Sce"},"SourcePortRange":{"shape":"Sce"},"Protocol":{"type":"integer"},"DestinationCidrBlock":{},"SourceCidrBlock":{},"Description":{},"RemoveFields":{"locationName":"RemoveField","type":"list","member":{}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorFilterRule":{"shape":"Sc7","locationName":"trafficMirrorFilterRule"}}}},"ModifyTrafficMirrorSession":{"input":{"type":"structure","required":["TrafficMirrorSessionId"],"members":{"TrafficMirrorSessionId":{},"TrafficMirrorTargetId":{},"TrafficMirrorFilterId":{},"PacketLength":{"type":"integer"},"SessionNumber":{"type":"integer"},"VirtualNetworkId":{"type":"integer"},"Description":{},"RemoveFields":{"locationName":"RemoveField","type":"list","member":{}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorSession":{"shape":"Sci","locationName":"trafficMirrorSession"}}}},"ModifyTransitGatewayVpcAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"AddSubnetIds":{"shape":"Sd"},"RemoveSubnetIds":{"shape":"Sd"},"Options":{"type":"structure","members":{"DnsSupport":{},"Ipv6Support":{}}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachment":{"shape":"Sb","locationName":"transitGatewayVpcAttachment"}}}},"ModifyVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"DryRun":{"type":"boolean"},"VolumeId":{},"Size":{"type":"integer"},"VolumeType":{},"Iops":{"type":"integer"}}},"output":{"type":"structure","members":{"VolumeModification":{"shape":"Swq","locationName":"volumeModification"}}}},"ModifyVolumeAttribute":{"input":{"type":"structure","required":["VolumeId"],"members":{"AutoEnableIO":{"shape":"Sny"},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ModifyVpcAttribute":{"input":{"type":"structure","required":["VpcId"],"members":{"EnableDnsHostnames":{"shape":"Sny"},"EnableDnsSupport":{"shape":"Sny"},"VpcId":{"locationName":"vpcId"}}}},"ModifyVpcEndpoint":{"input":{"type":"structure","required":["VpcEndpointId"],"members":{"DryRun":{"type":"boolean"},"VpcEndpointId":{},"ResetPolicy":{"type":"boolean"},"PolicyDocument":{},"AddRouteTableIds":{"shape":"Sd","locationName":"AddRouteTableId"},"RemoveRouteTableIds":{"shape":"Sd","locationName":"RemoveRouteTableId"},"AddSubnetIds":{"shape":"Sd","locationName":"AddSubnetId"},"RemoveSubnetIds":{"shape":"Sd","locationName":"RemoveSubnetId"},"AddSecurityGroupIds":{"shape":"Sd","locationName":"AddSecurityGroupId"},"RemoveSecurityGroupIds":{"shape":"Sd","locationName":"RemoveSecurityGroupId"},"PrivateDnsEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyVpcEndpointConnectionNotification":{"input":{"type":"structure","required":["ConnectionNotificationId"],"members":{"DryRun":{"type":"boolean"},"ConnectionNotificationId":{},"ConnectionNotificationArn":{},"ConnectionEvents":{"shape":"Sd"}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"return","type":"boolean"}}}},"ModifyVpcEndpointServiceConfiguration":{"input":{"type":"structure","required":["ServiceId"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"AcceptanceRequired":{"type":"boolean"},"AddNetworkLoadBalancerArns":{"shape":"Sd","locationName":"AddNetworkLoadBalancerArn"},"RemoveNetworkLoadBalancerArns":{"shape":"Sd","locationName":"RemoveNetworkLoadBalancerArn"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyVpcEndpointServicePermissions":{"input":{"type":"structure","required":["ServiceId"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"AddAllowedPrincipals":{"shape":"Sd"},"RemoveAllowedPrincipals":{"shape":"Sd"}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"return","type":"boolean"}}}},"ModifyVpcPeeringConnectionOptions":{"input":{"type":"structure","required":["VpcPeeringConnectionId"],"members":{"AccepterPeeringConnectionOptions":{"shape":"S13v"},"DryRun":{"type":"boolean"},"RequesterPeeringConnectionOptions":{"shape":"S13v"},"VpcPeeringConnectionId":{}}},"output":{"type":"structure","members":{"AccepterPeeringConnectionOptions":{"shape":"S13x","locationName":"accepterPeeringConnectionOptions"},"RequesterPeeringConnectionOptions":{"shape":"S13x","locationName":"requesterPeeringConnectionOptions"}}}},"ModifyVpcTenancy":{"input":{"type":"structure","required":["VpcId","InstanceTenancy"],"members":{"VpcId":{},"InstanceTenancy":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"return","type":"boolean"}}}},"ModifyVpnConnection":{"input":{"type":"structure","required":["VpnConnectionId"],"members":{"VpnConnectionId":{},"TransitGatewayId":{},"CustomerGatewayId":{},"VpnGatewayId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnection":{"shape":"Se9","locationName":"vpnConnection"}}}},"ModifyVpnTunnelCertificate":{"input":{"type":"structure","required":["VpnConnectionId","VpnTunnelOutsideIpAddress"],"members":{"VpnConnectionId":{},"VpnTunnelOutsideIpAddress":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnection":{"shape":"Se9","locationName":"vpnConnection"}}}},"MonitorInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Si5","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceMonitorings":{"shape":"S147","locationName":"instancesSet"}}}},"MoveAddressToVpc":{"input":{"type":"structure","required":["PublicIp"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"PublicIp":{"locationName":"publicIp"}}},"output":{"type":"structure","members":{"AllocationId":{"locationName":"allocationId"},"Status":{"locationName":"status"}}}},"ProvisionByoipCidr":{"input":{"type":"structure","required":["Cidr"],"members":{"Cidr":{},"CidrAuthorizationContext":{"type":"structure","required":["Message","Signature"],"members":{"Message":{},"Signature":{}}},"Description":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"S12","locationName":"byoipCidr"}}}},"PurchaseHostReservation":{"input":{"type":"structure","required":["HostIdSet","OfferingId"],"members":{"ClientToken":{},"CurrencyCode":{},"HostIdSet":{"shape":"S101"},"LimitPrice":{},"OfferingId":{}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"CurrencyCode":{"locationName":"currencyCode"},"Purchase":{"shape":"S103","locationName":"purchase"},"TotalHourlyPrice":{"locationName":"totalHourlyPrice"},"TotalUpfrontPrice":{"locationName":"totalUpfrontPrice"}}}},"PurchaseReservedInstancesOffering":{"input":{"type":"structure","required":["InstanceCount","ReservedInstancesOfferingId"],"members":{"InstanceCount":{"type":"integer"},"ReservedInstancesOfferingId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"LimitPrice":{"locationName":"limitPrice","type":"structure","members":{"Amount":{"locationName":"amount","type":"double"},"CurrencyCode":{"locationName":"currencyCode"}}}}},"output":{"type":"structure","members":{"ReservedInstancesId":{"locationName":"reservedInstancesId"}}}},"PurchaseScheduledInstances":{"input":{"type":"structure","required":["PurchaseRequests"],"members":{"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"PurchaseRequests":{"locationName":"PurchaseRequest","type":"list","member":{"locationName":"PurchaseRequest","type":"structure","required":["InstanceCount","PurchaseToken"],"members":{"InstanceCount":{"type":"integer"},"PurchaseToken":{}}}}}},"output":{"type":"structure","members":{"ScheduledInstanceSet":{"locationName":"scheduledInstanceSet","type":"list","member":{"shape":"Sso","locationName":"item"}}}}},"RebootInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Si5","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"RegisterImage":{"input":{"type":"structure","required":["Name"],"members":{"ImageLocation":{},"Architecture":{"locationName":"architecture"},"BlockDeviceMappings":{"shape":"S7h","locationName":"BlockDeviceMapping"},"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EnaSupport":{"locationName":"enaSupport","type":"boolean"},"KernelId":{"locationName":"kernelId"},"Name":{"locationName":"name"},"BillingProducts":{"locationName":"BillingProduct","type":"list","member":{"locationName":"item"}},"RamdiskId":{"locationName":"ramdiskId"},"RootDeviceName":{"locationName":"rootDeviceName"},"SriovNetSupport":{"locationName":"sriovNetSupport"},"VirtualizationType":{"locationName":"virtualizationType"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"}}}},"RejectTransitGatewayVpcAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachment":{"shape":"Sb","locationName":"transitGatewayVpcAttachment"}}}},"RejectVpcEndpointConnections":{"input":{"type":"structure","required":["ServiceId","VpcEndpointIds"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"VpcEndpointIds":{"shape":"Sd","locationName":"VpcEndpointId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"Sm","locationName":"unsuccessful"}}}},"RejectVpcPeeringConnection":{"input":{"type":"structure","required":["VpcPeeringConnectionId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ReleaseAddress":{"input":{"type":"structure","members":{"AllocationId":{},"PublicIp":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ReleaseHosts":{"input":{"type":"structure","required":["HostIds"],"members":{"HostIds":{"shape":"Smc","locationName":"hostId"}}},"output":{"type":"structure","members":{"Successful":{"shape":"S1e","locationName":"successful"},"Unsuccessful":{"shape":"S120","locationName":"unsuccessful"}}}},"ReplaceIamInstanceProfileAssociation":{"input":{"type":"structure","required":["IamInstanceProfile","AssociationId"],"members":{"IamInstanceProfile":{"shape":"S1y"},"AssociationId":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociation":{"shape":"S20","locationName":"iamInstanceProfileAssociation"}}}},"ReplaceNetworkAclAssociation":{"input":{"type":"structure","required":["AssociationId","NetworkAclId"],"members":{"AssociationId":{"locationName":"associationId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"}}},"output":{"type":"structure","members":{"NewAssociationId":{"locationName":"newAssociationId"}}}},"ReplaceNetworkAclEntry":{"input":{"type":"structure","required":["Egress","NetworkAclId","Protocol","RuleAction","RuleNumber"],"members":{"CidrBlock":{"locationName":"cidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Egress":{"locationName":"egress","type":"boolean"},"IcmpTypeCode":{"shape":"Sab","locationName":"Icmp"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"NetworkAclId":{"locationName":"networkAclId"},"PortRange":{"shape":"Sac","locationName":"portRange"},"Protocol":{"locationName":"protocol"},"RuleAction":{"locationName":"ruleAction"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"ReplaceRoute":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"GatewayId":{"locationName":"gatewayId"},"InstanceId":{"locationName":"instanceId"},"NatGatewayId":{"locationName":"natGatewayId"},"TransitGatewayId":{},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"RouteTableId":{"locationName":"routeTableId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}}},"ReplaceRouteTableAssociation":{"input":{"type":"structure","required":["AssociationId","RouteTableId"],"members":{"AssociationId":{"locationName":"associationId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"}}},"output":{"type":"structure","members":{"NewAssociationId":{"locationName":"newAssociationId"}}}},"ReplaceTransitGatewayRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","TransitGatewayRouteTableId"],"members":{"DestinationCidrBlock":{},"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"Blackhole":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Route":{"shape":"Scz","locationName":"route"}}}},"ReportInstanceStatus":{"input":{"type":"structure","required":["Instances","ReasonCodes","Status"],"members":{"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EndTime":{"locationName":"endTime","type":"timestamp"},"Instances":{"shape":"Si5","locationName":"instanceId"},"ReasonCodes":{"locationName":"reasonCode","type":"list","member":{"locationName":"item"}},"StartTime":{"locationName":"startTime","type":"timestamp"},"Status":{"locationName":"status"}}}},"RequestSpotFleet":{"input":{"type":"structure","required":["SpotFleetRequestConfig"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotFleetRequestConfig":{"shape":"Stq","locationName":"spotFleetRequestConfig"}}},"output":{"type":"structure","members":{"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}},"RequestSpotInstances":{"input":{"type":"structure","members":{"AvailabilityZoneGroup":{"locationName":"availabilityZoneGroup"},"BlockDurationMinutes":{"locationName":"blockDurationMinutes","type":"integer"},"ClientToken":{"locationName":"clientToken"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"LaunchGroup":{"locationName":"launchGroup"},"LaunchSpecification":{"type":"structure","members":{"SecurityGroupIds":{"shape":"Sd","locationName":"SecurityGroupId"},"SecurityGroups":{"shape":"Sd","locationName":"SecurityGroup"},"AddressingType":{"locationName":"addressingType"},"BlockDeviceMappings":{"shape":"Smz","locationName":"blockDeviceMapping"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S1y","locationName":"iamInstanceProfile"},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"Monitoring":{"shape":"Sui","locationName":"monitoring"},"NetworkInterfaces":{"shape":"Stx","locationName":"NetworkInterface"},"Placement":{"shape":"Stz","locationName":"placement"},"RamdiskId":{"locationName":"ramdiskId"},"SubnetId":{"locationName":"subnetId"},"UserData":{"locationName":"userData"}}},"SpotPrice":{"locationName":"spotPrice"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"InstanceInterruptionBehavior":{}}},"output":{"type":"structure","members":{"SpotInstanceRequests":{"shape":"Suf","locationName":"spotInstanceRequestSet"}}}},"ResetEbsDefaultKmsKeyId":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"KmsKeyId":{"locationName":"kmsKeyId"}}}},"ResetFpgaImageAttribute":{"input":{"type":"structure","required":["FpgaImageId"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{},"Attribute":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ResetImageAttribute":{"input":{"type":"structure","required":["Attribute","ImageId"],"members":{"Attribute":{},"ImageId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ResetInstanceAttribute":{"input":{"type":"structure","required":["Attribute","InstanceId"],"members":{"Attribute":{"locationName":"attribute"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"}}}},"ResetNetworkInterfaceAttribute":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"SourceDestCheck":{"locationName":"sourceDestCheck"}}}},"ResetSnapshotAttribute":{"input":{"type":"structure","required":["Attribute","SnapshotId"],"members":{"Attribute":{},"SnapshotId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"RestoreAddressToClassic":{"input":{"type":"structure","required":["PublicIp"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"PublicIp":{"locationName":"publicIp"}}},"output":{"type":"structure","members":{"PublicIp":{"locationName":"publicIp"},"Status":{"locationName":"status"}}}},"RevokeClientVpnIngress":{"input":{"type":"structure","required":["ClientVpnEndpointId","TargetNetworkCidr"],"members":{"ClientVpnEndpointId":{},"TargetNetworkCidr":{},"AccessGroupId":{},"RevokeAllGroups":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Status":{"shape":"S30","locationName":"status"}}}},"RevokeSecurityGroupEgress":{"input":{"type":"structure","required":["GroupId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupId":{"locationName":"groupId"},"IpPermissions":{"shape":"S33","locationName":"ipPermissions"},"CidrIp":{"locationName":"cidrIp"},"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"ToPort":{"locationName":"toPort","type":"integer"},"SourceSecurityGroupName":{"locationName":"sourceSecurityGroupName"},"SourceSecurityGroupOwnerId":{"locationName":"sourceSecurityGroupOwnerId"}}}},"RevokeSecurityGroupIngress":{"input":{"type":"structure","members":{"CidrIp":{},"FromPort":{"type":"integer"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S33"},"IpProtocol":{},"SourceSecurityGroupName":{},"SourceSecurityGroupOwnerId":{},"ToPort":{"type":"integer"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"RunInstances":{"input":{"type":"structure","required":["MaxCount","MinCount"],"members":{"BlockDeviceMappings":{"shape":"S7h","locationName":"BlockDeviceMapping"},"ImageId":{},"InstanceType":{},"Ipv6AddressCount":{"type":"integer"},"Ipv6Addresses":{"shape":"S9e","locationName":"Ipv6Address"},"KernelId":{},"KeyName":{},"MaxCount":{"type":"integer"},"MinCount":{"type":"integer"},"Monitoring":{"shape":"Sui"},"Placement":{"shape":"S6q"},"RamdiskId":{},"SecurityGroupIds":{"shape":"S8a","locationName":"SecurityGroupId"},"SecurityGroups":{"shape":"S8o","locationName":"SecurityGroup"},"SubnetId":{},"UserData":{},"AdditionalInfo":{"locationName":"additionalInfo"},"ClientToken":{"locationName":"clientToken"},"DisableApiTermination":{"locationName":"disableApiTermination","type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S1y","locationName":"iamInstanceProfile"},"InstanceInitiatedShutdownBehavior":{"locationName":"instanceInitiatedShutdownBehavior"},"NetworkInterfaces":{"shape":"Stx","locationName":"networkInterface"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"ElasticGpuSpecification":{"type":"list","member":{"shape":"S8l","locationName":"item"}},"ElasticInferenceAccelerators":{"locationName":"ElasticInferenceAccelerator","type":"list","member":{"locationName":"item","type":"structure","required":["Type"],"members":{"Type":{}}}},"TagSpecifications":{"shape":"S19","locationName":"TagSpecification"},"LaunchTemplate":{"type":"structure","members":{"LaunchTemplateId":{},"LaunchTemplateName":{},"Version":{}}},"InstanceMarketOptions":{"type":"structure","members":{"MarketType":{},"SpotOptions":{"type":"structure","members":{"MaxPrice":{},"SpotInstanceType":{},"BlockDurationMinutes":{"type":"integer"},"ValidUntil":{"type":"timestamp"},"InstanceInterruptionBehavior":{}}}}},"CreditSpecification":{"shape":"S8u"},"CpuOptions":{"type":"structure","members":{"CoreCount":{"type":"integer"},"ThreadsPerCore":{"type":"integer"}}},"CapacityReservationSpecification":{"shape":"S12b"},"HibernationOptions":{"type":"structure","members":{"Configured":{"type":"boolean"}}},"LicenseSpecifications":{"locationName":"LicenseSpecification","type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{}}}}}},"output":{"shape":"Son"}},"RunScheduledInstances":{"input":{"type":"structure","required":["LaunchSpecification","ScheduledInstanceId"],"members":{"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"InstanceCount":{"type":"integer"},"LaunchSpecification":{"type":"structure","required":["ImageId"],"members":{"BlockDeviceMappings":{"locationName":"BlockDeviceMapping","type":"list","member":{"locationName":"BlockDeviceMapping","type":"structure","members":{"DeviceName":{},"Ebs":{"type":"structure","members":{"DeleteOnTermination":{"type":"boolean"},"Encrypted":{"type":"boolean"},"Iops":{"type":"integer"},"SnapshotId":{},"VolumeSize":{"type":"integer"},"VolumeType":{}}},"NoDevice":{},"VirtualName":{}}}},"EbsOptimized":{"type":"boolean"},"IamInstanceProfile":{"type":"structure","members":{"Arn":{},"Name":{}}},"ImageId":{},"InstanceType":{},"KernelId":{},"KeyName":{},"Monitoring":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"NetworkInterfaces":{"locationName":"NetworkInterface","type":"list","member":{"locationName":"NetworkInterface","type":"structure","members":{"AssociatePublicIpAddress":{"type":"boolean"},"DeleteOnTermination":{"type":"boolean"},"Description":{},"DeviceIndex":{"type":"integer"},"Groups":{"shape":"S16l","locationName":"Group"},"Ipv6AddressCount":{"type":"integer"},"Ipv6Addresses":{"locationName":"Ipv6Address","type":"list","member":{"locationName":"Ipv6Address","type":"structure","members":{"Ipv6Address":{}}}},"NetworkInterfaceId":{},"PrivateIpAddress":{},"PrivateIpAddressConfigs":{"locationName":"PrivateIpAddressConfig","type":"list","member":{"locationName":"PrivateIpAddressConfigSet","type":"structure","members":{"Primary":{"type":"boolean"},"PrivateIpAddress":{}}}},"SecondaryPrivateIpAddressCount":{"type":"integer"},"SubnetId":{}}}},"Placement":{"type":"structure","members":{"AvailabilityZone":{},"GroupName":{}}},"RamdiskId":{},"SecurityGroupIds":{"shape":"S16l","locationName":"SecurityGroupId"},"SubnetId":{},"UserData":{}}},"ScheduledInstanceId":{}}},"output":{"type":"structure","members":{"InstanceIdSet":{"locationName":"instanceIdSet","type":"list","member":{"locationName":"item"}}}}},"SearchTransitGatewayRoutes":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","Filters"],"members":{"TransitGatewayRouteTableId":{},"Filters":{"shape":"Sh6","locationName":"Filter"},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Routes":{"locationName":"routeSet","type":"list","member":{"shape":"Scz","locationName":"item"}},"AdditionalRoutesAvailable":{"locationName":"additionalRoutesAvailable","type":"boolean"}}}},"SendDiagnosticInterrupt":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DryRun":{"type":"boolean"}}}},"StartInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Si5","locationName":"InstanceId"},"AdditionalInfo":{"locationName":"additionalInfo"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"StartingInstances":{"shape":"S170","locationName":"instancesSet"}}}},"StopInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Si5","locationName":"InstanceId"},"Hibernate":{"type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Force":{"locationName":"force","type":"boolean"}}},"output":{"type":"structure","members":{"StoppingInstances":{"shape":"S170","locationName":"instancesSet"}}}},"TerminateClientVpnConnections":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"ConnectionId":{},"Username":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Username":{"locationName":"username"},"ConnectionStatuses":{"locationName":"connectionStatuses","type":"list","member":{"locationName":"item","type":"structure","members":{"ConnectionId":{"locationName":"connectionId"},"PreviousStatus":{"shape":"Sik","locationName":"previousStatus"},"CurrentStatus":{"shape":"Sik","locationName":"currentStatus"}}}}}}},"TerminateInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Si5","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"TerminatingInstances":{"shape":"S170","locationName":"instancesSet"}}}},"UnassignIpv6Addresses":{"input":{"type":"structure","required":["Ipv6Addresses","NetworkInterfaceId"],"members":{"Ipv6Addresses":{"shape":"S1j","locationName":"ipv6Addresses"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"UnassignedIpv6Addresses":{"shape":"S1j","locationName":"unassignedIpv6Addresses"}}}},"UnassignPrivateIpAddresses":{"input":{"type":"structure","required":["NetworkInterfaceId","PrivateIpAddresses"],"members":{"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddresses":{"shape":"S1m","locationName":"privateIpAddress"}}}},"UnmonitorInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Si5","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceMonitorings":{"shape":"S147","locationName":"instancesSet"}}}},"UpdateSecurityGroupRuleDescriptionsEgress":{"input":{"type":"structure","required":["IpPermissions"],"members":{"DryRun":{"type":"boolean"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S33"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"UpdateSecurityGroupRuleDescriptionsIngress":{"input":{"type":"structure","required":["IpPermissions"],"members":{"DryRun":{"type":"boolean"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S33"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"WithdrawByoipCidr":{"input":{"type":"structure","required":["Cidr"],"members":{"Cidr":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"S12","locationName":"byoipCidr"}}}}},"shapes":{"S3":{"type":"list","member":{"locationName":"ReservedInstanceId"}},"S5":{"type":"list","member":{"locationName":"TargetConfigurationRequest","type":"structure","required":["OfferingId"],"members":{"InstanceCount":{"type":"integer"},"OfferingId":{}}}},"Sb":{"type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"VpcId":{"locationName":"vpcId"},"VpcOwnerId":{"locationName":"vpcOwnerId"},"State":{"locationName":"state"},"SubnetIds":{"shape":"Sd","locationName":"subnetIds"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Options":{"locationName":"options","type":"structure","members":{"DnsSupport":{"locationName":"dnsSupport"},"Ipv6Support":{"locationName":"ipv6Support"}}},"Tags":{"shape":"Si","locationName":"tagSet"}}},"Sd":{"type":"list","member":{"locationName":"item"}},"Si":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"Value":{"locationName":"value"}}}},"Sm":{"type":"list","member":{"shape":"Sn","locationName":"item"}},"Sn":{"type":"structure","members":{"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"ResourceId":{"locationName":"resourceId"}}},"Sr":{"type":"structure","members":{"AccepterVpcInfo":{"shape":"Ss","locationName":"accepterVpcInfo"},"ExpirationTime":{"locationName":"expirationTime","type":"timestamp"},"RequesterVpcInfo":{"shape":"Ss","locationName":"requesterVpcInfo"},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"Tags":{"shape":"Si","locationName":"tagSet"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"Ss":{"type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"},"Ipv6CidrBlockSet":{"locationName":"ipv6CidrBlockSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"}}}},"CidrBlockSet":{"locationName":"cidrBlockSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"}}}},"OwnerId":{"locationName":"ownerId"},"PeeringOptions":{"locationName":"peeringOptions","type":"structure","members":{"AllowDnsResolutionFromRemoteVpc":{"locationName":"allowDnsResolutionFromRemoteVpc","type":"boolean"},"AllowEgressFromLocalClassicLinkToRemoteVpc":{"locationName":"allowEgressFromLocalClassicLinkToRemoteVpc","type":"boolean"},"AllowEgressFromLocalVpcToRemoteClassicLink":{"locationName":"allowEgressFromLocalVpcToRemoteClassicLink","type":"boolean"}}},"VpcId":{"locationName":"vpcId"},"Region":{"locationName":"region"}}},"S12":{"type":"structure","members":{"Cidr":{"locationName":"cidr"},"Description":{"locationName":"description"},"StatusMessage":{"locationName":"statusMessage"},"State":{"locationName":"state"}}},"S19":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceType":{"locationName":"resourceType"},"Tags":{"shape":"Si","locationName":"Tag"}}}},"S1e":{"type":"list","member":{"locationName":"item"}},"S1g":{"type":"list","member":{"locationName":"item"}},"S1j":{"type":"list","member":{"locationName":"item"}},"S1m":{"type":"list","member":{"locationName":"PrivateIpAddress"}},"S1u":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"S1y":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Name":{"locationName":"name"}}},"S20":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"InstanceId":{"locationName":"instanceId"},"IamInstanceProfile":{"shape":"S21","locationName":"iamInstanceProfile"},"State":{"locationName":"state"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}},"S21":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Id":{"locationName":"id"}}},"S27":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"Ipv6CidrBlockState":{"locationName":"ipv6CidrBlockState","type":"structure","members":{"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}}}},"S2c":{"type":"structure","members":{"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"State":{"locationName":"state"}}},"S2h":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"Ipv6CidrBlockState":{"shape":"S2i","locationName":"ipv6CidrBlockState"}}},"S2i":{"type":"structure","members":{"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}},"S2k":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"CidrBlock":{"locationName":"cidrBlock"},"CidrBlockState":{"shape":"S2i","locationName":"cidrBlockState"}}},"S2m":{"type":"list","member":{"locationName":"groupId"}},"S2s":{"type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"Device":{"locationName":"device"},"InstanceId":{"locationName":"instanceId"},"State":{"locationName":"status"},"VolumeId":{"locationName":"volumeId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"}}},"S2w":{"type":"structure","members":{"State":{"locationName":"state"},"VpcId":{"locationName":"vpcId"}}},"S30":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"S33":{"type":"list","member":{"locationName":"item","type":"structure","members":{"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"IpRanges":{"locationName":"ipRanges","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrIp":{"locationName":"cidrIp"},"Description":{"locationName":"description"}}}},"Ipv6Ranges":{"locationName":"ipv6Ranges","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrIpv6":{"locationName":"cidrIpv6"},"Description":{"locationName":"description"}}}},"PrefixListIds":{"locationName":"prefixListIds","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"PrefixListId":{"locationName":"prefixListId"}}}},"ToPort":{"locationName":"toPort","type":"integer"},"UserIdGroupPairs":{"locationName":"groups","type":"list","member":{"shape":"S3c","locationName":"item"}}}}},"S3c":{"type":"structure","members":{"Description":{"locationName":"description"},"GroupId":{"locationName":"groupId"},"GroupName":{"locationName":"groupName"},"PeeringStatus":{"locationName":"peeringStatus"},"UserId":{"locationName":"userId"},"VpcId":{"locationName":"vpcId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"S3f":{"type":"structure","members":{"S3":{"type":"structure","members":{"AWSAccessKeyId":{},"Bucket":{"locationName":"bucket"},"Prefix":{"locationName":"prefix"},"UploadPolicy":{"locationName":"uploadPolicy","type":"blob"},"UploadPolicySignature":{"locationName":"uploadPolicySignature"}}}}},"S3j":{"type":"structure","members":{"BundleId":{"locationName":"bundleId"},"BundleTaskError":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"InstanceId":{"locationName":"instanceId"},"Progress":{"locationName":"progress"},"StartTime":{"locationName":"startTime","type":"timestamp"},"State":{"locationName":"state"},"Storage":{"shape":"S3f","locationName":"storage"},"UpdateTime":{"locationName":"updateTime","type":"timestamp"}}},"S3w":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"InstanceCounts":{"locationName":"instanceCounts","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceCount":{"locationName":"instanceCount","type":"integer"},"State":{"locationName":"state"}}}},"PriceSchedules":{"locationName":"priceSchedules","type":"list","member":{"locationName":"item","type":"structure","members":{"Active":{"locationName":"active","type":"boolean"},"CurrencyCode":{"locationName":"currencyCode"},"Price":{"locationName":"price","type":"double"},"Term":{"locationName":"term","type":"long"}}}},"ReservedInstancesId":{"locationName":"reservedInstancesId"},"ReservedInstancesListingId":{"locationName":"reservedInstancesListingId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"Si","locationName":"tagSet"},"UpdateDate":{"locationName":"updateDate","type":"timestamp"}}}},"S4h":{"type":"list","member":{"locationName":"SpotInstanceRequestId"}},"S50":{"type":"structure","members":{"CapacityReservationId":{"locationName":"capacityReservationId"},"OwnerId":{"locationName":"ownerId"},"CapacityReservationArn":{"locationName":"capacityReservationArn"},"AvailabilityZoneId":{"locationName":"availabilityZoneId"},"InstanceType":{"locationName":"instanceType"},"InstancePlatform":{"locationName":"instancePlatform"},"AvailabilityZone":{"locationName":"availabilityZone"},"Tenancy":{"locationName":"tenancy"},"TotalInstanceCount":{"locationName":"totalInstanceCount","type":"integer"},"AvailableInstanceCount":{"locationName":"availableInstanceCount","type":"integer"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"EphemeralStorage":{"locationName":"ephemeralStorage","type":"boolean"},"State":{"locationName":"state"},"EndDate":{"locationName":"endDate","type":"timestamp"},"EndDateType":{"locationName":"endDateType"},"InstanceMatchCriteria":{"locationName":"instanceMatchCriteria"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"Tags":{"shape":"Si","locationName":"tagSet"}}},"S58":{"type":"structure","members":{"Enabled":{"type":"boolean"},"CloudwatchLogGroup":{},"CloudwatchLogStream":{}}},"S5b":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"S5f":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"S5k":{"type":"structure","members":{"BgpAsn":{"locationName":"bgpAsn"},"CustomerGatewayId":{"locationName":"customerGatewayId"},"IpAddress":{"locationName":"ipAddress"},"CertificateArn":{"locationName":"certificateArn"},"State":{"locationName":"state"},"Type":{"locationName":"type"},"Tags":{"shape":"Si","locationName":"tagSet"}}},"S5n":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"AvailabilityZoneId":{"locationName":"availabilityZoneId"},"AvailableIpAddressCount":{"locationName":"availableIpAddressCount","type":"integer"},"CidrBlock":{"locationName":"cidrBlock"},"DefaultForAz":{"locationName":"defaultForAz","type":"boolean"},"MapPublicIpOnLaunch":{"locationName":"mapPublicIpOnLaunch","type":"boolean"},"State":{"locationName":"state"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"OwnerId":{"locationName":"ownerId"},"AssignIpv6AddressOnCreation":{"locationName":"assignIpv6AddressOnCreation","type":"boolean"},"Ipv6CidrBlockAssociationSet":{"locationName":"ipv6CidrBlockAssociationSet","type":"list","member":{"shape":"S27","locationName":"item"}},"Tags":{"shape":"Si","locationName":"tagSet"},"SubnetArn":{"locationName":"subnetArn"}}},"S5s":{"type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"},"DhcpOptionsId":{"locationName":"dhcpOptionsId"},"State":{"locationName":"state"},"VpcId":{"locationName":"vpcId"},"OwnerId":{"locationName":"ownerId"},"InstanceTenancy":{"locationName":"instanceTenancy"},"Ipv6CidrBlockAssociationSet":{"locationName":"ipv6CidrBlockAssociationSet","type":"list","member":{"shape":"S2h","locationName":"item"}},"CidrBlockAssociationSet":{"locationName":"cidrBlockAssociationSet","type":"list","member":{"shape":"S2k","locationName":"item"}},"IsDefault":{"locationName":"isDefault","type":"boolean"},"Tags":{"shape":"Si","locationName":"tagSet"}}},"S61":{"type":"structure","members":{"DhcpConfigurations":{"locationName":"dhcpConfigurationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"Values":{"locationName":"valueSet","type":"list","member":{"shape":"S65","locationName":"item"}}}}},"DhcpOptionsId":{"locationName":"dhcpOptionsId"},"OwnerId":{"locationName":"ownerId"},"Tags":{"shape":"Si","locationName":"tagSet"}}},"S65":{"type":"structure","members":{"Value":{"locationName":"value"}}},"S68":{"type":"structure","members":{"Attachments":{"shape":"S69","locationName":"attachmentSet"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"}}},"S69":{"type":"list","member":{"locationName":"item","type":"structure","members":{"State":{"locationName":"state"},"VpcId":{"locationName":"vpcId"}}}},"S6q":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Affinity":{"locationName":"affinity"},"GroupName":{"locationName":"groupName"},"PartitionNumber":{"locationName":"partitionNumber","type":"integer"},"HostId":{"locationName":"hostId"},"Tenancy":{"locationName":"tenancy"},"SpreadDomain":{"locationName":"spreadDomain"}}},"S6r":{"type":"structure","required":["TotalTargetCapacity"],"members":{"TotalTargetCapacity":{"type":"integer"},"OnDemandTargetCapacity":{"type":"integer"},"SpotTargetCapacity":{"type":"integer"},"DefaultTargetCapacityType":{}}},"S6y":{"type":"structure","members":{"LaunchTemplateSpecification":{"shape":"S6z","locationName":"launchTemplateSpecification"},"Overrides":{"shape":"S70","locationName":"overrides"}}},"S6z":{"type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"Version":{"locationName":"version"}}},"S70":{"type":"structure","members":{"InstanceType":{"locationName":"instanceType"},"MaxPrice":{"locationName":"maxPrice"},"SubnetId":{"locationName":"subnetId"},"AvailabilityZone":{"locationName":"availabilityZone"},"WeightedCapacity":{"locationName":"weightedCapacity","type":"double"},"Priority":{"locationName":"priority","type":"double"},"Placement":{"locationName":"placement","type":"structure","members":{"GroupName":{"locationName":"groupName"}}}}},"S75":{"type":"list","member":{"locationName":"item"}},"S7e":{"type":"structure","members":{"Bucket":{},"Key":{}}},"S7h":{"type":"list","member":{"shape":"S7i","locationName":"BlockDeviceMapping"}},"S7i":{"type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"VirtualName":{"locationName":"virtualName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Iops":{"locationName":"iops","type":"integer"},"SnapshotId":{"locationName":"snapshotId"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"VolumeType":{"locationName":"volumeType"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{}}},"NoDevice":{"locationName":"noDevice"}}},"S7s":{"type":"structure","members":{"Description":{"locationName":"description"},"ExportTaskId":{"locationName":"exportTaskId"},"ExportToS3Task":{"locationName":"exportToS3","type":"structure","members":{"ContainerFormat":{"locationName":"containerFormat"},"DiskImageFormat":{"locationName":"diskImageFormat"},"S3Bucket":{"locationName":"s3Bucket"},"S3Key":{"locationName":"s3Key"}}},"InstanceExportDetails":{"locationName":"instanceExport","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"TargetEnvironment":{"locationName":"targetEnvironment"}}},"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}},"S7y":{"type":"structure","members":{"Attachments":{"shape":"S69","locationName":"attachmentSet"},"InternetGatewayId":{"locationName":"internetGatewayId"},"OwnerId":{"locationName":"ownerId"},"Tags":{"shape":"Si","locationName":"tagSet"}}},"S83":{"type":"structure","members":{"KernelId":{},"EbsOptimized":{"type":"boolean"},"IamInstanceProfile":{"type":"structure","members":{"Arn":{},"Name":{}}},"BlockDeviceMappings":{"locationName":"BlockDeviceMapping","type":"list","member":{"locationName":"BlockDeviceMapping","type":"structure","members":{"DeviceName":{},"VirtualName":{},"Ebs":{"type":"structure","members":{"Encrypted":{"type":"boolean"},"DeleteOnTermination":{"type":"boolean"},"Iops":{"type":"integer"},"KmsKeyId":{},"SnapshotId":{},"VolumeSize":{"type":"integer"},"VolumeType":{}}},"NoDevice":{}}}},"NetworkInterfaces":{"locationName":"NetworkInterface","type":"list","member":{"locationName":"InstanceNetworkInterfaceSpecification","type":"structure","members":{"AssociatePublicIpAddress":{"type":"boolean"},"DeleteOnTermination":{"type":"boolean"},"Description":{},"DeviceIndex":{"type":"integer"},"Groups":{"shape":"S8a","locationName":"SecurityGroupId"},"InterfaceType":{},"Ipv6AddressCount":{"type":"integer"},"Ipv6Addresses":{"type":"list","member":{"locationName":"InstanceIpv6Address","type":"structure","members":{"Ipv6Address":{}}}},"NetworkInterfaceId":{},"PrivateIpAddress":{},"PrivateIpAddresses":{"shape":"S8d"},"SecondaryPrivateIpAddressCount":{"type":"integer"},"SubnetId":{}}}},"ImageId":{},"InstanceType":{},"KeyName":{},"Monitoring":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"Placement":{"type":"structure","members":{"AvailabilityZone":{},"Affinity":{},"GroupName":{},"HostId":{},"Tenancy":{},"SpreadDomain":{}}},"RamDiskId":{},"DisableApiTermination":{"type":"boolean"},"InstanceInitiatedShutdownBehavior":{},"UserData":{},"TagSpecifications":{"locationName":"TagSpecification","type":"list","member":{"locationName":"LaunchTemplateTagSpecificationRequest","type":"structure","members":{"ResourceType":{},"Tags":{"shape":"Si","locationName":"Tag"}}}},"ElasticGpuSpecifications":{"locationName":"ElasticGpuSpecification","type":"list","member":{"shape":"S8l","locationName":"ElasticGpuSpecification"}},"ElasticInferenceAccelerators":{"locationName":"ElasticInferenceAccelerator","type":"list","member":{"locationName":"item","type":"structure","required":["Type"],"members":{"Type":{}}}},"SecurityGroupIds":{"shape":"S8a","locationName":"SecurityGroupId"},"SecurityGroups":{"shape":"S8o","locationName":"SecurityGroup"},"InstanceMarketOptions":{"type":"structure","members":{"MarketType":{},"SpotOptions":{"type":"structure","members":{"MaxPrice":{},"SpotInstanceType":{},"BlockDurationMinutes":{"type":"integer"},"ValidUntil":{"type":"timestamp"},"InstanceInterruptionBehavior":{}}}}},"CreditSpecification":{"shape":"S8u"},"CpuOptions":{"type":"structure","members":{"CoreCount":{"type":"integer"},"ThreadsPerCore":{"type":"integer"}}},"CapacityReservationSpecification":{"type":"structure","members":{"CapacityReservationPreference":{},"CapacityReservationTarget":{"shape":"S8y"}}},"LicenseSpecifications":{"locationName":"LicenseSpecification","type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{}}}},"HibernationOptions":{"type":"structure","members":{"Configured":{"type":"boolean"}}}}},"S8a":{"type":"list","member":{"locationName":"SecurityGroupId"}},"S8d":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Primary":{"locationName":"primary","type":"boolean"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"S8l":{"type":"structure","required":["Type"],"members":{"Type":{}}},"S8o":{"type":"list","member":{"locationName":"SecurityGroup"}},"S8u":{"type":"structure","required":["CpuCredits"],"members":{"CpuCredits":{}}},"S8y":{"type":"structure","members":{"CapacityReservationId":{}}},"S93":{"type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"CreatedBy":{"locationName":"createdBy"},"DefaultVersionNumber":{"locationName":"defaultVersionNumber","type":"long"},"LatestVersionNumber":{"locationName":"latestVersionNumber","type":"long"},"Tags":{"shape":"Si","locationName":"tagSet"}}},"S96":{"type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"VersionNumber":{"locationName":"versionNumber","type":"long"},"VersionDescription":{"locationName":"versionDescription"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"CreatedBy":{"locationName":"createdBy"},"DefaultVersion":{"locationName":"defaultVersion","type":"boolean"},"LaunchTemplateData":{"shape":"S97","locationName":"launchTemplateData"}}},"S97":{"type":"structure","members":{"KernelId":{"locationName":"kernelId"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"locationName":"iamInstanceProfile","type":"structure","members":{"Arn":{"locationName":"arn"},"Name":{"locationName":"name"}}},"BlockDeviceMappings":{"locationName":"blockDeviceMappingSet","type":"list","member":{"locationName":"item","type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"VirtualName":{"locationName":"virtualName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"Encrypted":{"locationName":"encrypted","type":"boolean"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Iops":{"locationName":"iops","type":"integer"},"KmsKeyId":{"locationName":"kmsKeyId"},"SnapshotId":{"locationName":"snapshotId"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"VolumeType":{"locationName":"volumeType"}}},"NoDevice":{"locationName":"noDevice"}}}},"NetworkInterfaces":{"locationName":"networkInterfaceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AssociatePublicIpAddress":{"locationName":"associatePublicIpAddress","type":"boolean"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Description":{"locationName":"description"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"Groups":{"shape":"S2m","locationName":"groupSet"},"InterfaceType":{"locationName":"interfaceType"},"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"S9e","locationName":"ipv6AddressesSet"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"shape":"S8d","locationName":"privateIpAddressesSet"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"},"SubnetId":{"locationName":"subnetId"}}}},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KeyName":{"locationName":"keyName"},"Monitoring":{"locationName":"monitoring","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"Placement":{"locationName":"placement","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Affinity":{"locationName":"affinity"},"GroupName":{"locationName":"groupName"},"HostId":{"locationName":"hostId"},"Tenancy":{"locationName":"tenancy"},"SpreadDomain":{"locationName":"spreadDomain"}}},"RamDiskId":{"locationName":"ramDiskId"},"DisableApiTermination":{"locationName":"disableApiTermination","type":"boolean"},"InstanceInitiatedShutdownBehavior":{"locationName":"instanceInitiatedShutdownBehavior"},"UserData":{"locationName":"userData"},"TagSpecifications":{"locationName":"tagSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceType":{"locationName":"resourceType"},"Tags":{"shape":"Si","locationName":"tagSet"}}}},"ElasticGpuSpecifications":{"locationName":"elasticGpuSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Type":{"locationName":"type"}}}},"ElasticInferenceAccelerators":{"locationName":"elasticInferenceAcceleratorSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Type":{"locationName":"type"}}}},"SecurityGroupIds":{"shape":"Sd","locationName":"securityGroupIdSet"},"SecurityGroups":{"shape":"Sd","locationName":"securityGroupSet"},"InstanceMarketOptions":{"locationName":"instanceMarketOptions","type":"structure","members":{"MarketType":{"locationName":"marketType"},"SpotOptions":{"locationName":"spotOptions","type":"structure","members":{"MaxPrice":{"locationName":"maxPrice"},"SpotInstanceType":{"locationName":"spotInstanceType"},"BlockDurationMinutes":{"locationName":"blockDurationMinutes","type":"integer"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"InstanceInterruptionBehavior":{"locationName":"instanceInterruptionBehavior"}}}}},"CreditSpecification":{"locationName":"creditSpecification","type":"structure","members":{"CpuCredits":{"locationName":"cpuCredits"}}},"CpuOptions":{"locationName":"cpuOptions","type":"structure","members":{"CoreCount":{"locationName":"coreCount","type":"integer"},"ThreadsPerCore":{"locationName":"threadsPerCore","type":"integer"}}},"CapacityReservationSpecification":{"locationName":"capacityReservationSpecification","type":"structure","members":{"CapacityReservationPreference":{"locationName":"capacityReservationPreference"},"CapacityReservationTarget":{"shape":"S9t","locationName":"capacityReservationTarget"}}},"LicenseSpecifications":{"locationName":"licenseSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{"locationName":"licenseConfigurationArn"}}}},"HibernationOptions":{"locationName":"hibernationOptions","type":"structure","members":{"Configured":{"locationName":"configured","type":"boolean"}}}}},"S9e":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Address":{"locationName":"ipv6Address"}}}},"S9t":{"type":"structure","members":{"CapacityReservationId":{"locationName":"capacityReservationId"}}},"S9z":{"type":"structure","members":{"CreateTime":{"locationName":"createTime","type":"timestamp"},"DeleteTime":{"locationName":"deleteTime","type":"timestamp"},"FailureCode":{"locationName":"failureCode"},"FailureMessage":{"locationName":"failureMessage"},"NatGatewayAddresses":{"locationName":"natGatewayAddressSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AllocationId":{"locationName":"allocationId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIp":{"locationName":"privateIp"},"PublicIp":{"locationName":"publicIp"}}}},"NatGatewayId":{"locationName":"natGatewayId"},"ProvisionedBandwidth":{"locationName":"provisionedBandwidth","type":"structure","members":{"ProvisionTime":{"locationName":"provisionTime","type":"timestamp"},"Provisioned":{"locationName":"provisioned"},"RequestTime":{"locationName":"requestTime","type":"timestamp"},"Requested":{"locationName":"requested"},"Status":{"locationName":"status"}}},"State":{"locationName":"state"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"Tags":{"shape":"Si","locationName":"tagSet"}}},"Sa6":{"type":"structure","members":{"Associations":{"locationName":"associationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"NetworkAclAssociationId":{"locationName":"networkAclAssociationId"},"NetworkAclId":{"locationName":"networkAclId"},"SubnetId":{"locationName":"subnetId"}}}},"Entries":{"locationName":"entrySet","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"},"Egress":{"locationName":"egress","type":"boolean"},"IcmpTypeCode":{"shape":"Sab","locationName":"icmpTypeCode"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"PortRange":{"shape":"Sac","locationName":"portRange"},"Protocol":{"locationName":"protocol"},"RuleAction":{"locationName":"ruleAction"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"IsDefault":{"locationName":"default","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"},"Tags":{"shape":"Si","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"},"OwnerId":{"locationName":"ownerId"}}},"Sab":{"type":"structure","members":{"Code":{"locationName":"code","type":"integer"},"Type":{"locationName":"type","type":"integer"}}},"Sac":{"type":"structure","members":{"From":{"locationName":"from","type":"integer"},"To":{"locationName":"to","type":"integer"}}},"Sai":{"type":"structure","members":{"Association":{"shape":"Saj","locationName":"association"},"Attachment":{"shape":"Sak","locationName":"attachment"},"AvailabilityZone":{"locationName":"availabilityZone"},"Description":{"locationName":"description"},"Groups":{"shape":"Sal","locationName":"groupSet"},"InterfaceType":{"locationName":"interfaceType"},"Ipv6Addresses":{"locationName":"ipv6AddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Address":{"locationName":"ipv6Address"}}}},"MacAddress":{"locationName":"macAddress"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"OwnerId":{"locationName":"ownerId"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"locationName":"privateIpAddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Association":{"shape":"Saj","locationName":"association"},"Primary":{"locationName":"primary","type":"boolean"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"RequesterId":{"locationName":"requesterId"},"RequesterManaged":{"locationName":"requesterManaged","type":"boolean"},"SourceDestCheck":{"locationName":"sourceDestCheck","type":"boolean"},"Status":{"locationName":"status"},"SubnetId":{"locationName":"subnetId"},"TagSet":{"shape":"Si","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}},"Saj":{"type":"structure","members":{"AllocationId":{"locationName":"allocationId"},"AssociationId":{"locationName":"associationId"},"IpOwnerId":{"locationName":"ipOwnerId"},"PublicDnsName":{"locationName":"publicDnsName"},"PublicIp":{"locationName":"publicIp"}}},"Sak":{"type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"AttachmentId":{"locationName":"attachmentId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"InstanceId":{"locationName":"instanceId"},"InstanceOwnerId":{"locationName":"instanceOwnerId"},"Status":{"locationName":"status"}}},"Sal":{"type":"list","member":{"locationName":"item","type":"structure","members":{"GroupName":{"locationName":"groupName"},"GroupId":{"locationName":"groupId"}}}},"Saw":{"type":"structure","members":{"NetworkInterfacePermissionId":{"locationName":"networkInterfacePermissionId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"AwsAccountId":{"locationName":"awsAccountId"},"AwsService":{"locationName":"awsService"},"Permission":{"locationName":"permission"},"PermissionState":{"locationName":"permissionState","type":"structure","members":{"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}}}},"Sb9":{"type":"structure","members":{"Associations":{"locationName":"associationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Main":{"locationName":"main","type":"boolean"},"RouteTableAssociationId":{"locationName":"routeTableAssociationId"},"RouteTableId":{"locationName":"routeTableId"},"SubnetId":{"locationName":"subnetId"}}}},"PropagatingVgws":{"locationName":"propagatingVgwSet","type":"list","member":{"locationName":"item","type":"structure","members":{"GatewayId":{"locationName":"gatewayId"}}}},"RouteTableId":{"locationName":"routeTableId"},"Routes":{"locationName":"routeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DestinationPrefixListId":{"locationName":"destinationPrefixListId"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"GatewayId":{"locationName":"gatewayId"},"InstanceId":{"locationName":"instanceId"},"InstanceOwnerId":{"locationName":"instanceOwnerId"},"NatGatewayId":{"locationName":"natGatewayId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"Origin":{"locationName":"origin"},"State":{"locationName":"state"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}}},"Tags":{"shape":"Si","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"},"OwnerId":{"locationName":"ownerId"}}},"Sbl":{"type":"structure","members":{"DataEncryptionKeyId":{"locationName":"dataEncryptionKeyId"},"Description":{"locationName":"description"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"OwnerId":{"locationName":"ownerId"},"Progress":{"locationName":"progress"},"SnapshotId":{"locationName":"snapshotId"},"StartTime":{"locationName":"startTime","type":"timestamp"},"State":{"locationName":"status"},"StateMessage":{"locationName":"statusMessage"},"VolumeId":{"locationName":"volumeId"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"OwnerAlias":{"locationName":"ownerAlias"},"Tags":{"shape":"Si","locationName":"tagSet"}}},"Sbw":{"type":"structure","members":{"Bucket":{"locationName":"bucket"},"Fault":{"shape":"Sbx","locationName":"fault"},"OwnerId":{"locationName":"ownerId"},"Prefix":{"locationName":"prefix"},"State":{"locationName":"state"}}},"Sbx":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"Sc2":{"type":"list","member":{}},"Sc5":{"type":"structure","members":{"TrafficMirrorFilterId":{"locationName":"trafficMirrorFilterId"},"IngressFilterRules":{"shape":"Sc6","locationName":"ingressFilterRuleSet"},"EgressFilterRules":{"shape":"Sc6","locationName":"egressFilterRuleSet"},"NetworkServices":{"shape":"Scb","locationName":"networkServiceSet"},"Description":{"locationName":"description"},"Tags":{"shape":"Si","locationName":"tagSet"}}},"Sc6":{"type":"list","member":{"shape":"Sc7","locationName":"item"}},"Sc7":{"type":"structure","members":{"TrafficMirrorFilterRuleId":{"locationName":"trafficMirrorFilterRuleId"},"TrafficMirrorFilterId":{"locationName":"trafficMirrorFilterId"},"TrafficDirection":{"locationName":"trafficDirection"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"},"RuleAction":{"locationName":"ruleAction"},"Protocol":{"locationName":"protocol","type":"integer"},"DestinationPortRange":{"shape":"Sca","locationName":"destinationPortRange"},"SourcePortRange":{"shape":"Sca","locationName":"sourcePortRange"},"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"SourceCidrBlock":{"locationName":"sourceCidrBlock"},"Description":{"locationName":"description"}}},"Sca":{"type":"structure","members":{"FromPort":{"locationName":"fromPort","type":"integer"},"ToPort":{"locationName":"toPort","type":"integer"}}},"Scb":{"type":"list","member":{"locationName":"item"}},"Sce":{"type":"structure","members":{"FromPort":{"type":"integer"},"ToPort":{"type":"integer"}}},"Sci":{"type":"structure","members":{"TrafficMirrorSessionId":{"locationName":"trafficMirrorSessionId"},"TrafficMirrorTargetId":{"locationName":"trafficMirrorTargetId"},"TrafficMirrorFilterId":{"locationName":"trafficMirrorFilterId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"OwnerId":{"locationName":"ownerId"},"PacketLength":{"locationName":"packetLength","type":"integer"},"SessionNumber":{"locationName":"sessionNumber","type":"integer"},"VirtualNetworkId":{"locationName":"virtualNetworkId","type":"integer"},"Description":{"locationName":"description"},"Tags":{"shape":"Si","locationName":"tagSet"}}},"Scl":{"type":"structure","members":{"TrafficMirrorTargetId":{"locationName":"trafficMirrorTargetId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"NetworkLoadBalancerArn":{"locationName":"networkLoadBalancerArn"},"Type":{"locationName":"type"},"Description":{"locationName":"description"},"OwnerId":{"locationName":"ownerId"},"Tags":{"shape":"Si","locationName":"tagSet"}}},"Scu":{"type":"structure","members":{"TransitGatewayId":{"locationName":"transitGatewayId"},"TransitGatewayArn":{"locationName":"transitGatewayArn"},"State":{"locationName":"state"},"OwnerId":{"locationName":"ownerId"},"Description":{"locationName":"description"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Options":{"locationName":"options","type":"structure","members":{"AmazonSideAsn":{"locationName":"amazonSideAsn","type":"long"},"AutoAcceptSharedAttachments":{"locationName":"autoAcceptSharedAttachments"},"DefaultRouteTableAssociation":{"locationName":"defaultRouteTableAssociation"},"AssociationDefaultRouteTableId":{"locationName":"associationDefaultRouteTableId"},"DefaultRouteTablePropagation":{"locationName":"defaultRouteTablePropagation"},"PropagationDefaultRouteTableId":{"locationName":"propagationDefaultRouteTableId"},"VpnEcmpSupport":{"locationName":"vpnEcmpSupport"},"DnsSupport":{"locationName":"dnsSupport"}}},"Tags":{"shape":"Si","locationName":"tagSet"}}},"Scz":{"type":"structure","members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"TransitGatewayAttachments":{"locationName":"transitGatewayAttachments","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceId":{"locationName":"resourceId"},"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceType":{"locationName":"resourceType"}}}},"Type":{"locationName":"type"},"State":{"locationName":"state"}}},"Sd6":{"type":"structure","members":{"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"State":{"locationName":"state"},"DefaultAssociationRouteTable":{"locationName":"defaultAssociationRouteTable","type":"boolean"},"DefaultPropagationRouteTable":{"locationName":"defaultPropagationRouteTable","type":"boolean"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Tags":{"shape":"Si","locationName":"tagSet"}}},"Sdc":{"type":"structure","members":{"Attachments":{"locationName":"attachmentSet","type":"list","member":{"shape":"S2s","locationName":"item"}},"AvailabilityZone":{"locationName":"availabilityZone"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"Size":{"locationName":"size","type":"integer"},"SnapshotId":{"locationName":"snapshotId"},"State":{"locationName":"status"},"VolumeId":{"locationName":"volumeId"},"Iops":{"locationName":"iops","type":"integer"},"Tags":{"shape":"Si","locationName":"tagSet"},"VolumeType":{"locationName":"volumeType"}}},"Sdk":{"type":"structure","members":{"VpcEndpointId":{"locationName":"vpcEndpointId"},"VpcEndpointType":{"locationName":"vpcEndpointType"},"VpcId":{"locationName":"vpcId"},"ServiceName":{"locationName":"serviceName"},"State":{"locationName":"state"},"PolicyDocument":{"locationName":"policyDocument"},"RouteTableIds":{"shape":"Sd","locationName":"routeTableIdSet"},"SubnetIds":{"shape":"Sd","locationName":"subnetIdSet"},"Groups":{"locationName":"groupSet","type":"list","member":{"locationName":"item","type":"structure","members":{"GroupId":{"locationName":"groupId"},"GroupName":{"locationName":"groupName"}}}},"PrivateDnsEnabled":{"locationName":"privateDnsEnabled","type":"boolean"},"RequesterManaged":{"locationName":"requesterManaged","type":"boolean"},"NetworkInterfaceIds":{"shape":"Sd","locationName":"networkInterfaceIdSet"},"DnsEntries":{"shape":"Sdo","locationName":"dnsEntrySet"},"CreationTimestamp":{"locationName":"creationTimestamp","type":"timestamp"},"Tags":{"shape":"Si","locationName":"tagSet"},"OwnerId":{"locationName":"ownerId"}}},"Sdo":{"type":"list","member":{"locationName":"item","type":"structure","members":{"DnsName":{"locationName":"dnsName"},"HostedZoneId":{"locationName":"hostedZoneId"}}}},"Sds":{"type":"structure","members":{"ConnectionNotificationId":{"locationName":"connectionNotificationId"},"ServiceId":{"locationName":"serviceId"},"VpcEndpointId":{"locationName":"vpcEndpointId"},"ConnectionNotificationType":{"locationName":"connectionNotificationType"},"ConnectionNotificationArn":{"locationName":"connectionNotificationArn"},"ConnectionEvents":{"shape":"Sd","locationName":"connectionEvents"},"ConnectionNotificationState":{"locationName":"connectionNotificationState"}}},"Sdx":{"type":"structure","members":{"ServiceType":{"shape":"Sdy","locationName":"serviceType"},"ServiceId":{"locationName":"serviceId"},"ServiceName":{"locationName":"serviceName"},"ServiceState":{"locationName":"serviceState"},"AvailabilityZones":{"shape":"Sd","locationName":"availabilityZoneSet"},"AcceptanceRequired":{"locationName":"acceptanceRequired","type":"boolean"},"ManagesVpcEndpoints":{"locationName":"managesVpcEndpoints","type":"boolean"},"NetworkLoadBalancerArns":{"shape":"Sd","locationName":"networkLoadBalancerArnSet"},"BaseEndpointDnsNames":{"shape":"Sd","locationName":"baseEndpointDnsNameSet"},"PrivateDnsName":{"locationName":"privateDnsName"},"Tags":{"shape":"Si","locationName":"tagSet"}}},"Sdy":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ServiceType":{"locationName":"serviceType"}}}},"Se9":{"type":"structure","members":{"CustomerGatewayConfiguration":{"locationName":"customerGatewayConfiguration"},"CustomerGatewayId":{"locationName":"customerGatewayId"},"Category":{"locationName":"category"},"State":{"locationName":"state"},"Type":{"locationName":"type"},"VpnConnectionId":{"locationName":"vpnConnectionId"},"VpnGatewayId":{"locationName":"vpnGatewayId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"Options":{"locationName":"options","type":"structure","members":{"StaticRoutesOnly":{"locationName":"staticRoutesOnly","type":"boolean"}}},"Routes":{"locationName":"routes","type":"list","member":{"locationName":"item","type":"structure","members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"Source":{"locationName":"source"},"State":{"locationName":"state"}}}},"Tags":{"shape":"Si","locationName":"tagSet"},"VgwTelemetry":{"locationName":"vgwTelemetry","type":"list","member":{"locationName":"item","type":"structure","members":{"AcceptedRouteCount":{"locationName":"acceptedRouteCount","type":"integer"},"LastStatusChange":{"locationName":"lastStatusChange","type":"timestamp"},"OutsideIpAddress":{"locationName":"outsideIpAddress"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"CertificateArn":{"locationName":"certificateArn"}}}}}},"Sel":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"State":{"locationName":"state"},"Type":{"locationName":"type"},"VpcAttachments":{"locationName":"attachments","type":"list","member":{"shape":"S2w","locationName":"item"}},"VpnGatewayId":{"locationName":"vpnGatewayId"},"AmazonSideAsn":{"locationName":"amazonSideAsn","type":"long"},"Tags":{"shape":"Si","locationName":"tagSet"}}},"Sew":{"type":"list","member":{}},"Sfe":{"type":"list","member":{"locationName":"item"}},"Sh6":{"type":"list","member":{"locationName":"Filter","type":"structure","members":{"Name":{},"Values":{"shape":"Sd","locationName":"Value"}}}},"Shf":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Deadline":{"locationName":"deadline","type":"timestamp"},"Resource":{"locationName":"resource"},"UseLongIds":{"locationName":"useLongIds","type":"boolean"}}}},"Si5":{"type":"list","member":{"locationName":"InstanceId"}},"Sik":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"Sje":{"type":"structure","members":{"ConversionTaskId":{"locationName":"conversionTaskId"},"ExpirationTime":{"locationName":"expirationTime"},"ImportInstance":{"locationName":"importInstance","type":"structure","members":{"Description":{"locationName":"description"},"InstanceId":{"locationName":"instanceId"},"Platform":{"locationName":"platform"},"Volumes":{"locationName":"volumes","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"BytesConverted":{"locationName":"bytesConverted","type":"long"},"Description":{"locationName":"description"},"Image":{"shape":"Sji","locationName":"image"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Volume":{"shape":"Sjj","locationName":"volume"}}}}}},"ImportVolume":{"locationName":"importVolume","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"BytesConverted":{"locationName":"bytesConverted","type":"long"},"Description":{"locationName":"description"},"Image":{"shape":"Sji","locationName":"image"},"Volume":{"shape":"Sjj","locationName":"volume"}}},"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"Si","locationName":"tagSet"}}},"Sji":{"type":"structure","members":{"Checksum":{"locationName":"checksum"},"Format":{"locationName":"format"},"ImportManifestUrl":{"locationName":"importManifestUrl"},"Size":{"locationName":"size","type":"long"}}},"Sjj":{"type":"structure","members":{"Id":{"locationName":"id"},"Size":{"locationName":"size","type":"long"}}},"Skf":{"type":"structure","members":{"S3Bucket":{"locationName":"s3Bucket"},"S3Prefix":{"locationName":"s3Prefix"}}},"Skp":{"type":"structure","members":{"EventDescription":{"locationName":"eventDescription"},"EventSubType":{"locationName":"eventSubType"},"InstanceId":{"locationName":"instanceId"}}},"Sks":{"type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"InstanceType":{"locationName":"instanceType"},"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"InstanceHealth":{"locationName":"instanceHealth"}}}},"Slh":{"type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"},"Name":{"locationName":"name"},"Description":{"locationName":"description"},"LoadPermissions":{"locationName":"loadPermissions","type":"list","member":{"locationName":"item","type":"structure","members":{"UserId":{"locationName":"userId"},"Group":{"locationName":"group"}}}},"ProductCodes":{"shape":"Sll","locationName":"productCodes"}}},"Sll":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ProductCodeId":{"locationName":"productCode"},"ProductCodeType":{"locationName":"type"}}}},"Slq":{"type":"list","member":{"locationName":"Owner"}},"Sm9":{"type":"list","member":{"locationName":"item"}},"Smc":{"type":"list","member":{"locationName":"item"}},"Smz":{"type":"list","member":{"shape":"S7i","locationName":"item"}},"Sn0":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Group":{"locationName":"group"},"UserId":{"locationName":"userId"}}}},"Snd":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"Sng":{"type":"list","member":{"locationName":"ImportTaskId"}},"Snk":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"DeviceName":{"locationName":"deviceName"},"DiskImageSize":{"locationName":"diskImageSize","type":"double"},"Format":{"locationName":"format"},"Progress":{"locationName":"progress"},"SnapshotId":{"locationName":"snapshotId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Url":{"locationName":"url"},"UserBucket":{"shape":"Snm","locationName":"userBucket"}}}},"Snm":{"type":"structure","members":{"S3Bucket":{"locationName":"s3Bucket"},"S3Key":{"locationName":"s3Key"}}},"Snr":{"type":"structure","members":{"Description":{"locationName":"description"},"DiskImageSize":{"locationName":"diskImageSize","type":"double"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"Format":{"locationName":"format"},"KmsKeyId":{"locationName":"kmsKeyId"},"Progress":{"locationName":"progress"},"SnapshotId":{"locationName":"snapshotId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Url":{"locationName":"url"},"UserBucket":{"shape":"Snm","locationName":"userBucket"}}},"Snv":{"type":"list","member":{"locationName":"item","type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Status":{"locationName":"status"},"VolumeId":{"locationName":"volumeId"}}}}}},"Sny":{"type":"structure","members":{"Value":{"locationName":"value","type":"boolean"}}},"So9":{"type":"structure","members":{"InstanceEventId":{"locationName":"instanceEventId"},"Code":{"locationName":"code"},"Description":{"locationName":"description"},"NotAfter":{"locationName":"notAfter","type":"timestamp"},"NotBefore":{"locationName":"notBefore","type":"timestamp"},"NotBeforeDeadline":{"locationName":"notBeforeDeadline","type":"timestamp"}}},"Soc":{"type":"structure","members":{"Code":{"locationName":"code","type":"integer"},"Name":{"locationName":"name"}}},"Soe":{"type":"structure","members":{"Details":{"locationName":"details","type":"list","member":{"locationName":"item","type":"structure","members":{"ImpairedSince":{"locationName":"impairedSince","type":"timestamp"},"Name":{"locationName":"name"},"Status":{"locationName":"status"}}}},"Status":{"locationName":"status"}}},"Son":{"type":"structure","members":{"Groups":{"shape":"Sal","locationName":"groupSet"},"Instances":{"locationName":"instancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AmiLaunchIndex":{"locationName":"amiLaunchIndex","type":"integer"},"ImageId":{"locationName":"imageId"},"InstanceId":{"locationName":"instanceId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"LaunchTime":{"locationName":"launchTime","type":"timestamp"},"Monitoring":{"shape":"Soq","locationName":"monitoring"},"Placement":{"shape":"S6q","locationName":"placement"},"Platform":{"locationName":"platform"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"ProductCodes":{"shape":"Sll","locationName":"productCodes"},"PublicDnsName":{"locationName":"dnsName"},"PublicIpAddress":{"locationName":"ipAddress"},"RamdiskId":{"locationName":"ramdiskId"},"State":{"shape":"Soc","locationName":"instanceState"},"StateTransitionReason":{"locationName":"reason"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"Architecture":{"locationName":"architecture"},"BlockDeviceMappings":{"shape":"Snv","locationName":"blockDeviceMapping"},"ClientToken":{"locationName":"clientToken"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"EnaSupport":{"locationName":"enaSupport","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"IamInstanceProfile":{"shape":"S21","locationName":"iamInstanceProfile"},"InstanceLifecycle":{"locationName":"instanceLifecycle"},"ElasticGpuAssociations":{"locationName":"elasticGpuAssociationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ElasticGpuId":{"locationName":"elasticGpuId"},"ElasticGpuAssociationId":{"locationName":"elasticGpuAssociationId"},"ElasticGpuAssociationState":{"locationName":"elasticGpuAssociationState"},"ElasticGpuAssociationTime":{"locationName":"elasticGpuAssociationTime"}}}},"ElasticInferenceAcceleratorAssociations":{"locationName":"elasticInferenceAcceleratorAssociationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ElasticInferenceAcceleratorArn":{"locationName":"elasticInferenceAcceleratorArn"},"ElasticInferenceAcceleratorAssociationId":{"locationName":"elasticInferenceAcceleratorAssociationId"},"ElasticInferenceAcceleratorAssociationState":{"locationName":"elasticInferenceAcceleratorAssociationState"},"ElasticInferenceAcceleratorAssociationTime":{"locationName":"elasticInferenceAcceleratorAssociationTime","type":"timestamp"}}}},"NetworkInterfaces":{"locationName":"networkInterfaceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Association":{"shape":"Soz","locationName":"association"},"Attachment":{"locationName":"attachment","type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"AttachmentId":{"locationName":"attachmentId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"Status":{"locationName":"status"}}},"Description":{"locationName":"description"},"Groups":{"shape":"Sal","locationName":"groupSet"},"Ipv6Addresses":{"shape":"S9e","locationName":"ipv6AddressesSet"},"MacAddress":{"locationName":"macAddress"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"OwnerId":{"locationName":"ownerId"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"locationName":"privateIpAddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Association":{"shape":"Soz","locationName":"association"},"Primary":{"locationName":"primary","type":"boolean"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"SourceDestCheck":{"locationName":"sourceDestCheck","type":"boolean"},"Status":{"locationName":"status"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"InterfaceType":{"locationName":"interfaceType"}}}},"RootDeviceName":{"locationName":"rootDeviceName"},"RootDeviceType":{"locationName":"rootDeviceType"},"SecurityGroups":{"shape":"Sal","locationName":"groupSet"},"SourceDestCheck":{"locationName":"sourceDestCheck","type":"boolean"},"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"SriovNetSupport":{"locationName":"sriovNetSupport"},"StateReason":{"shape":"Snd","locationName":"stateReason"},"Tags":{"shape":"Si","locationName":"tagSet"},"VirtualizationType":{"locationName":"virtualizationType"},"CpuOptions":{"locationName":"cpuOptions","type":"structure","members":{"CoreCount":{"locationName":"coreCount","type":"integer"},"ThreadsPerCore":{"locationName":"threadsPerCore","type":"integer"}}},"CapacityReservationId":{"locationName":"capacityReservationId"},"CapacityReservationSpecification":{"locationName":"capacityReservationSpecification","type":"structure","members":{"CapacityReservationPreference":{"locationName":"capacityReservationPreference"},"CapacityReservationTarget":{"shape":"S9t","locationName":"capacityReservationTarget"}}},"HibernationOptions":{"locationName":"hibernationOptions","type":"structure","members":{"Configured":{"locationName":"configured","type":"boolean"}}},"Licenses":{"locationName":"licenseSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{"locationName":"licenseConfigurationArn"}}}}}}},"OwnerId":{"locationName":"ownerId"},"RequesterId":{"locationName":"requesterId"},"ReservationId":{"locationName":"reservationId"}}},"Soq":{"type":"structure","members":{"State":{"locationName":"state"}}},"Soz":{"type":"structure","members":{"IpOwnerId":{"locationName":"ipOwnerId"},"PublicDnsName":{"locationName":"publicDnsName"},"PublicIp":{"locationName":"publicIp"}}},"Sra":{"type":"list","member":{"locationName":"ReservedInstancesId"}},"Sri":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Amount":{"locationName":"amount","type":"double"},"Frequency":{"locationName":"frequency"}}}},"Srv":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"InstanceType":{"locationName":"instanceType"},"Platform":{"locationName":"platform"},"Scope":{"locationName":"scope"}}},"Ssh":{"type":"structure","members":{"Frequency":{"locationName":"frequency"},"Interval":{"locationName":"interval","type":"integer"},"OccurrenceDaySet":{"locationName":"occurrenceDaySet","type":"list","member":{"locationName":"item","type":"integer"}},"OccurrenceRelativeToEnd":{"locationName":"occurrenceRelativeToEnd","type":"boolean"},"OccurrenceUnit":{"locationName":"occurrenceUnit"}}},"Sso":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"InstanceType":{"locationName":"instanceType"},"NetworkPlatform":{"locationName":"networkPlatform"},"NextSlotStartTime":{"locationName":"nextSlotStartTime","type":"timestamp"},"Platform":{"locationName":"platform"},"PreviousSlotEndTime":{"locationName":"previousSlotEndTime","type":"timestamp"},"Recurrence":{"shape":"Ssh","locationName":"recurrence"},"ScheduledInstanceId":{"locationName":"scheduledInstanceId"},"SlotDurationInHours":{"locationName":"slotDurationInHours","type":"integer"},"TermEndDate":{"locationName":"termEndDate","type":"timestamp"},"TermStartDate":{"locationName":"termStartDate","type":"timestamp"},"TotalScheduledInstanceHours":{"locationName":"totalScheduledInstanceHours","type":"integer"}}},"Ssv":{"type":"list","member":{"locationName":"GroupName"}},"St3":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Group":{"locationName":"group"},"UserId":{"locationName":"userId"}}}},"Stq":{"type":"structure","required":["IamFleetRole","TargetCapacity"],"members":{"AllocationStrategy":{"locationName":"allocationStrategy"},"OnDemandAllocationStrategy":{"locationName":"onDemandAllocationStrategy"},"ClientToken":{"locationName":"clientToken"},"ExcessCapacityTerminationPolicy":{"locationName":"excessCapacityTerminationPolicy"},"FulfilledCapacity":{"locationName":"fulfilledCapacity","type":"double"},"OnDemandFulfilledCapacity":{"locationName":"onDemandFulfilledCapacity","type":"double"},"IamFleetRole":{"locationName":"iamFleetRole"},"LaunchSpecifications":{"locationName":"launchSpecifications","type":"list","member":{"locationName":"item","type":"structure","members":{"SecurityGroups":{"shape":"Sal","locationName":"groupSet"},"AddressingType":{"locationName":"addressingType"},"BlockDeviceMappings":{"shape":"Smz","locationName":"blockDeviceMapping"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S1y","locationName":"iamInstanceProfile"},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"Monitoring":{"locationName":"monitoring","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"NetworkInterfaces":{"shape":"Stx","locationName":"networkInterfaceSet"},"Placement":{"shape":"Stz","locationName":"placement"},"RamdiskId":{"locationName":"ramdiskId"},"SpotPrice":{"locationName":"spotPrice"},"SubnetId":{"locationName":"subnetId"},"UserData":{"locationName":"userData"},"WeightedCapacity":{"locationName":"weightedCapacity","type":"double"},"TagSpecifications":{"locationName":"tagSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceType":{"locationName":"resourceType"},"Tags":{"shape":"Si","locationName":"tag"}}}}}}},"LaunchTemplateConfigs":{"locationName":"launchTemplateConfigs","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateSpecification":{"shape":"S6z","locationName":"launchTemplateSpecification"},"Overrides":{"locationName":"overrides","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceType":{"locationName":"instanceType"},"SpotPrice":{"locationName":"spotPrice"},"SubnetId":{"locationName":"subnetId"},"AvailabilityZone":{"locationName":"availabilityZone"},"WeightedCapacity":{"locationName":"weightedCapacity","type":"double"},"Priority":{"locationName":"priority","type":"double"}}}}}}},"SpotPrice":{"locationName":"spotPrice"},"TargetCapacity":{"locationName":"targetCapacity","type":"integer"},"OnDemandTargetCapacity":{"locationName":"onDemandTargetCapacity","type":"integer"},"OnDemandMaxTotalPrice":{"locationName":"onDemandMaxTotalPrice"},"SpotMaxTotalPrice":{"locationName":"spotMaxTotalPrice"},"TerminateInstancesWithExpiration":{"locationName":"terminateInstancesWithExpiration","type":"boolean"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"ReplaceUnhealthyInstances":{"locationName":"replaceUnhealthyInstances","type":"boolean"},"InstanceInterruptionBehavior":{"locationName":"instanceInterruptionBehavior"},"LoadBalancersConfig":{"locationName":"loadBalancersConfig","type":"structure","members":{"ClassicLoadBalancersConfig":{"locationName":"classicLoadBalancersConfig","type":"structure","members":{"ClassicLoadBalancers":{"locationName":"classicLoadBalancers","type":"list","member":{"locationName":"item","type":"structure","members":{"Name":{"locationName":"name"}}}}}},"TargetGroupsConfig":{"locationName":"targetGroupsConfig","type":"structure","members":{"TargetGroups":{"locationName":"targetGroups","type":"list","member":{"locationName":"item","type":"structure","members":{"Arn":{"locationName":"arn"}}}}}}}},"InstancePoolsToUseCount":{"locationName":"instancePoolsToUseCount","type":"integer"}}},"Stx":{"type":"list","member":{"locationName":"item","type":"structure","members":{"AssociatePublicIpAddress":{"locationName":"associatePublicIpAddress","type":"boolean"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Description":{"locationName":"description"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"Groups":{"shape":"S8a","locationName":"SecurityGroupId"},"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"S9e","locationName":"ipv6AddressesSet","queryName":"Ipv6Addresses"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"shape":"S8d","locationName":"privateIpAddressesSet","queryName":"PrivateIpAddresses"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"},"SubnetId":{"locationName":"subnetId"},"InterfaceType":{}}}},"Stz":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"GroupName":{"locationName":"groupName"},"Tenancy":{"locationName":"tenancy"}}},"Suf":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ActualBlockHourlyPrice":{"locationName":"actualBlockHourlyPrice"},"AvailabilityZoneGroup":{"locationName":"availabilityZoneGroup"},"BlockDurationMinutes":{"locationName":"blockDurationMinutes","type":"integer"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"Fault":{"shape":"Sbx","locationName":"fault"},"InstanceId":{"locationName":"instanceId"},"LaunchGroup":{"locationName":"launchGroup"},"LaunchSpecification":{"locationName":"launchSpecification","type":"structure","members":{"UserData":{"locationName":"userData"},"SecurityGroups":{"shape":"Sal","locationName":"groupSet"},"AddressingType":{"locationName":"addressingType"},"BlockDeviceMappings":{"shape":"Smz","locationName":"blockDeviceMapping"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S1y","locationName":"iamInstanceProfile"},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"NetworkInterfaces":{"shape":"Stx","locationName":"networkInterfaceSet"},"Placement":{"shape":"Stz","locationName":"placement"},"RamdiskId":{"locationName":"ramdiskId"},"SubnetId":{"locationName":"subnetId"},"Monitoring":{"shape":"Sui","locationName":"monitoring"}}},"LaunchedAvailabilityZone":{"locationName":"launchedAvailabilityZone"},"ProductDescription":{"locationName":"productDescription"},"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"SpotPrice":{"locationName":"spotPrice"},"State":{"locationName":"state"},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"},"UpdateTime":{"locationName":"updateTime","type":"timestamp"}}},"Tags":{"shape":"Si","locationName":"tagSet"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"InstanceInterruptionBehavior":{"locationName":"instanceInterruptionBehavior"}}}},"Sui":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"Sux":{"type":"list","member":{"locationName":"item","type":"structure","members":{"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"IpRanges":{"locationName":"ipRanges","type":"list","member":{"locationName":"item"}},"PrefixListIds":{"locationName":"prefixListIds","type":"list","member":{"locationName":"item"}},"ToPort":{"locationName":"toPort","type":"integer"},"UserIdGroupPairs":{"locationName":"groups","type":"list","member":{"shape":"S3c","locationName":"item"}}}}},"Svm":{"type":"list","member":{}},"Sw7":{"type":"list","member":{"locationName":"VolumeId"}},"Swq":{"type":"structure","members":{"VolumeId":{"locationName":"volumeId"},"ModificationState":{"locationName":"modificationState"},"StatusMessage":{"locationName":"statusMessage"},"TargetSize":{"locationName":"targetSize","type":"integer"},"TargetIops":{"locationName":"targetIops","type":"integer"},"TargetVolumeType":{"locationName":"targetVolumeType"},"OriginalSize":{"locationName":"originalSize","type":"integer"},"OriginalIops":{"locationName":"originalIops","type":"integer"},"OriginalVolumeType":{"locationName":"originalVolumeType"},"Progress":{"locationName":"progress","type":"long"},"StartTime":{"locationName":"startTime","type":"timestamp"},"EndTime":{"locationName":"endTime","type":"timestamp"}}},"Sww":{"type":"list","member":{"locationName":"VpcId"}},"Syj":{"type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"State":{"locationName":"state"}}},"S101":{"type":"list","member":{"locationName":"item"}},"S103":{"type":"list","member":{"locationName":"item","type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"HostIdSet":{"shape":"Sm9","locationName":"hostIdSet"},"HostReservationId":{"locationName":"hostReservationId"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceFamily":{"locationName":"instanceFamily"},"PaymentOption":{"locationName":"paymentOption"},"UpfrontPrice":{"locationName":"upfrontPrice"}}}},"S10b":{"type":"structure","members":{"HourlyPrice":{"locationName":"hourlyPrice"},"RemainingTotalValue":{"locationName":"remainingTotalValue"},"RemainingUpfrontValue":{"locationName":"remainingUpfrontValue"}}},"S10w":{"type":"structure","members":{"Comment":{},"UploadEnd":{"type":"timestamp"},"UploadSize":{"type":"double"},"UploadStart":{"type":"timestamp"}}},"S10z":{"type":"structure","members":{"S3Bucket":{},"S3Key":{}}},"S114":{"type":"structure","required":["Bytes","Format","ImportManifestUrl"],"members":{"Bytes":{"locationName":"bytes","type":"long"},"Format":{"locationName":"format"},"ImportManifestUrl":{"locationName":"importManifestUrl"}}},"S115":{"type":"structure","required":["Size"],"members":{"Size":{"locationName":"size","type":"long"}}},"S11r":{"type":"list","member":{"locationName":"UserId"}},"S11s":{"type":"list","member":{"locationName":"UserGroup"}},"S11t":{"type":"list","member":{"locationName":"ProductCode"}},"S11v":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Group":{},"UserId":{}}}},"S120":{"type":"list","member":{"shape":"Sn","locationName":"item"}},"S12b":{"type":"structure","members":{"CapacityReservationPreference":{},"CapacityReservationTarget":{"shape":"S8y"}}},"S13v":{"type":"structure","members":{"AllowDnsResolutionFromRemoteVpc":{"type":"boolean"},"AllowEgressFromLocalClassicLinkToRemoteVpc":{"type":"boolean"},"AllowEgressFromLocalVpcToRemoteClassicLink":{"type":"boolean"}}},"S13x":{"type":"structure","members":{"AllowDnsResolutionFromRemoteVpc":{"locationName":"allowDnsResolutionFromRemoteVpc","type":"boolean"},"AllowEgressFromLocalClassicLinkToRemoteVpc":{"locationName":"allowEgressFromLocalClassicLinkToRemoteVpc","type":"boolean"},"AllowEgressFromLocalVpcToRemoteClassicLink":{"locationName":"allowEgressFromLocalVpcToRemoteClassicLink","type":"boolean"}}},"S147":{"type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"Monitoring":{"shape":"Soq","locationName":"monitoring"}}}},"S16l":{"type":"list","member":{"locationName":"SecurityGroupId"}},"S170":{"type":"list","member":{"locationName":"item","type":"structure","members":{"CurrentState":{"shape":"Soc","locationName":"currentState"},"InstanceId":{"locationName":"instanceId"},"PreviousState":{"shape":"Soc","locationName":"previousState"}}}}}}');

});

parcelRequire.register("aOF5Y", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeAccountAttributes":{"result_key":"AccountAttributes"},"DescribeAddresses":{"result_key":"Addresses"},"DescribeAvailabilityZones":{"result_key":"AvailabilityZones"},"DescribeBundleTasks":{"result_key":"BundleTasks"},"DescribeByoipCidrs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ByoipCidrs"},"DescribeCapacityReservations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CapacityReservations"},"DescribeClassicLinkInstances":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Instances"},"DescribeClientVpnAuthorizationRules":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AuthorizationRules"},"DescribeClientVpnConnections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Connections"},"DescribeClientVpnEndpoints":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ClientVpnEndpoints"},"DescribeClientVpnRoutes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Routes"},"DescribeClientVpnTargetNetworks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ClientVpnTargetNetworks"},"DescribeConversionTasks":{"result_key":"ConversionTasks"},"DescribeCustomerGateways":{"result_key":"CustomerGateways"},"DescribeDhcpOptions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DhcpOptions"},"DescribeEgressOnlyInternetGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"EgressOnlyInternetGateways"},"DescribeExportTasks":{"result_key":"ExportTasks"},"DescribeFleets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Fleets"},"DescribeFlowLogs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"FlowLogs"},"DescribeFpgaImages":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"FpgaImages"},"DescribeHostReservationOfferings":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"OfferingSet"},"DescribeHostReservations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"HostReservationSet"},"DescribeHosts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Hosts"},"DescribeIamInstanceProfileAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IamInstanceProfileAssociations"},"DescribeImages":{"result_key":"Images"},"DescribeImportImageTasks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ImportImageTasks"},"DescribeImportSnapshotTasks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ImportSnapshotTasks"},"DescribeInstanceCreditSpecifications":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceCreditSpecifications"},"DescribeInstanceStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceStatuses"},"DescribeInstances":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Reservations"},"DescribeInternetGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InternetGateways"},"DescribeKeyPairs":{"result_key":"KeyPairs"},"DescribeLaunchTemplateVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LaunchTemplateVersions"},"DescribeLaunchTemplates":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LaunchTemplates"},"DescribeMovingAddresses":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"MovingAddressStatuses"},"DescribeNatGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NatGateways"},"DescribeNetworkAcls":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NetworkAcls"},"DescribeNetworkInterfacePermissions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NetworkInterfacePermissions"},"DescribeNetworkInterfaces":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NetworkInterfaces"},"DescribePlacementGroups":{"result_key":"PlacementGroups"},"DescribePrefixLists":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PrefixLists"},"DescribePrincipalIdFormat":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Principals"},"DescribePublicIpv4Pools":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PublicIpv4Pools"},"DescribeRegions":{"result_key":"Regions"},"DescribeReservedInstances":{"result_key":"ReservedInstances"},"DescribeReservedInstancesListings":{"result_key":"ReservedInstancesListings"},"DescribeReservedInstancesModifications":{"input_token":"NextToken","output_token":"NextToken","result_key":"ReservedInstancesModifications"},"DescribeReservedInstancesOfferings":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ReservedInstancesOfferings"},"DescribeRouteTables":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"RouteTables"},"DescribeScheduledInstanceAvailability":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScheduledInstanceAvailabilitySet"},"DescribeScheduledInstances":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScheduledInstanceSet"},"DescribeSecurityGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SecurityGroups"},"DescribeSnapshots":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Snapshots"},"DescribeSpotFleetRequests":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SpotFleetRequestConfigs"},"DescribeSpotInstanceRequests":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SpotInstanceRequests"},"DescribeSpotPriceHistory":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SpotPriceHistory"},"DescribeStaleSecurityGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"StaleSecurityGroupSet"},"DescribeSubnets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Subnets"},"DescribeTags":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Tags"},"DescribeTrafficMirrorFilters":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TrafficMirrorFilters"},"DescribeTrafficMirrorSessions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TrafficMirrorSessions"},"DescribeTrafficMirrorTargets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TrafficMirrorTargets"},"DescribeTransitGatewayAttachments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayAttachments"},"DescribeTransitGatewayRouteTables":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayRouteTables"},"DescribeTransitGatewayVpcAttachments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayVpcAttachments"},"DescribeTransitGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGateways"},"DescribeVolumeStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VolumeStatuses"},"DescribeVolumes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Volumes"},"DescribeVolumesModifications":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VolumesModifications"},"DescribeVpcClassicLinkDnsSupport":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Vpcs"},"DescribeVpcEndpointConnectionNotifications":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ConnectionNotificationSet"},"DescribeVpcEndpointConnections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VpcEndpointConnections"},"DescribeVpcEndpointServiceConfigurations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ServiceConfigurations"},"DescribeVpcEndpointServicePermissions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AllowedPrincipals"},"DescribeVpcEndpoints":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VpcEndpoints"},"DescribeVpcPeeringConnections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VpcPeeringConnections"},"DescribeVpcs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Vpcs"},"DescribeVpnConnections":{"result_key":"VpnConnections"},"DescribeVpnGateways":{"result_key":"VpnGateways"},"GetTransitGatewayAttachmentPropagations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayAttachmentPropagations"},"GetTransitGatewayRouteTableAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Associations"},"GetTransitGatewayRouteTablePropagations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayRouteTablePropagations"}}}');

});

parcelRequire.register("aZeEd", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"InstanceExists":{"delay":5,"maxAttempts":40,"operation":"DescribeInstances","acceptors":[{"matcher":"path","expected":true,"argument":"length(Reservations[]) > `0`","state":"success"},{"matcher":"error","expected":"InvalidInstanceID.NotFound","state":"retry"}]},"BundleTaskComplete":{"delay":15,"operation":"DescribeBundleTasks","maxAttempts":40,"acceptors":[{"expected":"complete","matcher":"pathAll","state":"success","argument":"BundleTasks[].State"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"BundleTasks[].State"}]},"ConversionTaskCancelled":{"delay":15,"operation":"DescribeConversionTasks","maxAttempts":40,"acceptors":[{"expected":"cancelled","matcher":"pathAll","state":"success","argument":"ConversionTasks[].State"}]},"ConversionTaskCompleted":{"delay":15,"operation":"DescribeConversionTasks","maxAttempts":40,"acceptors":[{"expected":"completed","matcher":"pathAll","state":"success","argument":"ConversionTasks[].State"},{"expected":"cancelled","matcher":"pathAny","state":"failure","argument":"ConversionTasks[].State"},{"expected":"cancelling","matcher":"pathAny","state":"failure","argument":"ConversionTasks[].State"}]},"ConversionTaskDeleted":{"delay":15,"operation":"DescribeConversionTasks","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"ConversionTasks[].State"}]},"CustomerGatewayAvailable":{"delay":15,"operation":"DescribeCustomerGateways","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"CustomerGateways[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"CustomerGateways[].State"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"CustomerGateways[].State"}]},"ExportTaskCancelled":{"delay":15,"operation":"DescribeExportTasks","maxAttempts":40,"acceptors":[{"expected":"cancelled","matcher":"pathAll","state":"success","argument":"ExportTasks[].State"}]},"ExportTaskCompleted":{"delay":15,"operation":"DescribeExportTasks","maxAttempts":40,"acceptors":[{"expected":"completed","matcher":"pathAll","state":"success","argument":"ExportTasks[].State"}]},"ImageExists":{"operation":"DescribeImages","maxAttempts":40,"delay":15,"acceptors":[{"matcher":"path","expected":true,"argument":"length(Images[]) > `0`","state":"success"},{"matcher":"error","expected":"InvalidAMIID.NotFound","state":"retry"}]},"ImageAvailable":{"operation":"DescribeImages","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"Images[].State","expected":"available"},{"state":"failure","matcher":"pathAny","argument":"Images[].State","expected":"failed"}]},"InstanceRunning":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"acceptors":[{"expected":"running","matcher":"pathAll","state":"success","argument":"Reservations[].Instances[].State.Name"},{"expected":"shutting-down","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"matcher":"error","expected":"InvalidInstanceID.NotFound","state":"retry"}]},"InstanceStatusOk":{"operation":"DescribeInstanceStatus","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"InstanceStatuses[].InstanceStatus.Status","expected":"ok"},{"matcher":"error","expected":"InvalidInstanceID.NotFound","state":"retry"}]},"InstanceStopped":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"acceptors":[{"expected":"stopped","matcher":"pathAll","state":"success","argument":"Reservations[].Instances[].State.Name"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"}]},"InstanceTerminated":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"acceptors":[{"expected":"terminated","matcher":"pathAll","state":"success","argument":"Reservations[].Instances[].State.Name"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"}]},"KeyPairExists":{"operation":"DescribeKeyPairs","delay":5,"maxAttempts":6,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(KeyPairs[].KeyName) > `0`"},{"expected":"InvalidKeyPair.NotFound","matcher":"error","state":"retry"}]},"NatGatewayAvailable":{"operation":"DescribeNatGateways","delay":15,"maxAttempts":40,"acceptors":[{"state":"success","matcher":"pathAll","argument":"NatGateways[].State","expected":"available"},{"state":"failure","matcher":"pathAny","argument":"NatGateways[].State","expected":"failed"},{"state":"failure","matcher":"pathAny","argument":"NatGateways[].State","expected":"deleting"},{"state":"failure","matcher":"pathAny","argument":"NatGateways[].State","expected":"deleted"},{"state":"retry","matcher":"error","expected":"NatGatewayNotFound"}]},"NetworkInterfaceAvailable":{"operation":"DescribeNetworkInterfaces","delay":20,"maxAttempts":10,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"NetworkInterfaces[].Status"},{"expected":"InvalidNetworkInterfaceID.NotFound","matcher":"error","state":"failure"}]},"PasswordDataAvailable":{"operation":"GetPasswordData","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"path","argument":"length(PasswordData) > `0`","expected":true}]},"SnapshotCompleted":{"delay":15,"operation":"DescribeSnapshots","maxAttempts":40,"acceptors":[{"expected":"completed","matcher":"pathAll","state":"success","argument":"Snapshots[].State"}]},"SpotInstanceRequestFulfilled":{"operation":"DescribeSpotInstanceRequests","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"SpotInstanceRequests[].Status.Code","expected":"fulfilled"},{"state":"success","matcher":"pathAll","argument":"SpotInstanceRequests[].Status.Code","expected":"request-canceled-and-instance-running"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"schedule-expired"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"canceled-before-fulfillment"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"bad-parameters"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"system-error"},{"state":"retry","matcher":"error","expected":"InvalidSpotInstanceRequestID.NotFound"}]},"SubnetAvailable":{"delay":15,"operation":"DescribeSubnets","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Subnets[].State"}]},"SystemStatusOk":{"operation":"DescribeInstanceStatus","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"InstanceStatuses[].SystemStatus.Status","expected":"ok"}]},"VolumeAvailable":{"delay":15,"operation":"DescribeVolumes","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Volumes[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"Volumes[].State"}]},"VolumeDeleted":{"delay":15,"operation":"DescribeVolumes","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"Volumes[].State"},{"matcher":"error","expected":"InvalidVolume.NotFound","state":"success"}]},"VolumeInUse":{"delay":15,"operation":"DescribeVolumes","maxAttempts":40,"acceptors":[{"expected":"in-use","matcher":"pathAll","state":"success","argument":"Volumes[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"Volumes[].State"}]},"VpcAvailable":{"delay":15,"operation":"DescribeVpcs","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Vpcs[].State"}]},"VpcExists":{"operation":"DescribeVpcs","delay":1,"maxAttempts":5,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"InvalidVpcID.NotFound","state":"retry"}]},"VpnConnectionAvailable":{"delay":15,"operation":"DescribeVpnConnections","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"VpnConnections[].State"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"VpnConnections[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"VpnConnections[].State"}]},"VpnConnectionDeleted":{"delay":15,"operation":"DescribeVpnConnections","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"VpnConnections[].State"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"VpnConnections[].State"}]},"VpcPeeringConnectionExists":{"delay":15,"operation":"DescribeVpcPeeringConnections","maxAttempts":40,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"InvalidVpcPeeringConnectionID.NotFound","state":"retry"}]},"VpcPeeringConnectionDeleted":{"delay":15,"operation":"DescribeVpcPeeringConnections","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"VpcPeeringConnections[].Status.Code"},{"matcher":"error","expected":"InvalidVpcPeeringConnectionID.NotFound","state":"success"}]}}}');

});


parcelRequire.register("kvMHl", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $eeec7a55ff61e349$var$Service = $dbC7k.Service;
var $eeec7a55ff61e349$var$apiLoader = $dbC7k.apiLoader;
$eeec7a55ff61e349$var$apiLoader.services["ecr"] = {};
$dbC7k.ECR = $eeec7a55ff61e349$var$Service.defineService("ecr", [
    "2015-09-21"
]);


Object.defineProperty($eeec7a55ff61e349$var$apiLoader.services["ecr"], "2015-09-21", {
    get: function get() {
        var model = (parcelRequire("9bu3B"));
        model.paginators = (parcelRequire("8Ry5W")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ECR;

});
parcelRequire.register("9bu3B", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-09-21","endpointPrefix":"api.ecr","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon ECR","serviceFullName":"Amazon EC2 Container Registry","serviceId":"ECR","signatureVersion":"v4","signingName":"ecr","targetPrefix":"AmazonEC2ContainerRegistry_V20150921","uid":"ecr-2015-09-21"},"operations":{"BatchCheckLayerAvailability":{"input":{"type":"structure","required":["repositoryName","layerDigests"],"members":{"registryId":{},"repositoryName":{},"layerDigests":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"layers":{"type":"list","member":{"type":"structure","members":{"layerDigest":{},"layerAvailability":{},"layerSize":{"type":"long"},"mediaType":{}}}},"failures":{"type":"list","member":{"type":"structure","members":{"layerDigest":{},"failureCode":{},"failureReason":{}}}}}}},"BatchDeleteImage":{"input":{"type":"structure","required":["repositoryName","imageIds"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"}}},"output":{"type":"structure","members":{"imageIds":{"shape":"Si"},"failures":{"shape":"Sn"}}}},"BatchGetImage":{"input":{"type":"structure","required":["repositoryName","imageIds"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"},"acceptedMediaTypes":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"images":{"type":"list","member":{"shape":"Sv"}},"failures":{"shape":"Sn"}}}},"CompleteLayerUpload":{"input":{"type":"structure","required":["repositoryName","uploadId","layerDigests"],"members":{"registryId":{},"repositoryName":{},"uploadId":{},"layerDigests":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"uploadId":{},"layerDigest":{}}}},"CreateRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"tags":{"shape":"S12"},"imageTagMutability":{}}},"output":{"type":"structure","members":{"repository":{"shape":"S18"}}}},"DeleteLifecyclePolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"lastEvaluatedAt":{"type":"timestamp"}}}},"DeleteRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"repository":{"shape":"S18"}}}},"DeleteRepositoryPolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"policyText":{}}}},"DescribeImages":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"tagStatus":{}}}}},"output":{"type":"structure","members":{"imageDetails":{"type":"list","member":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageDigest":{},"imageTags":{"shape":"S1u"},"imageSizeInBytes":{"type":"long"},"imagePushedAt":{"type":"timestamp"}}}},"nextToken":{}}}},"DescribeRepositories":{"input":{"type":"structure","members":{"registryId":{},"repositoryNames":{"type":"list","member":{}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"repositories":{"type":"list","member":{"shape":"S18"}},"nextToken":{}}}},"GetAuthorizationToken":{"input":{"type":"structure","members":{"registryIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"authorizationData":{"type":"list","member":{"type":"structure","members":{"authorizationToken":{},"expiresAt":{"type":"timestamp"},"proxyEndpoint":{}}}}}}},"GetDownloadUrlForLayer":{"input":{"type":"structure","required":["repositoryName","layerDigest"],"members":{"registryId":{},"repositoryName":{},"layerDigest":{}}},"output":{"type":"structure","members":{"downloadUrl":{},"layerDigest":{}}}},"GetLifecyclePolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"lastEvaluatedAt":{"type":"timestamp"}}}},"GetLifecyclePolicyPreview":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"tagStatus":{}}}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"status":{},"nextToken":{},"previewResults":{"type":"list","member":{"type":"structure","members":{"imageTags":{"shape":"S1u"},"imageDigest":{},"imagePushedAt":{"type":"timestamp"},"action":{"type":"structure","members":{"type":{}}},"appliedRulePriority":{"type":"integer"}}}},"summary":{"type":"structure","members":{"expiringImageTotalCount":{"type":"integer"}}}}}},"GetRepositoryPolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"policyText":{}}}},"InitiateLayerUpload":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"uploadId":{},"partSize":{"type":"long"}}}},"ListImages":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"tagStatus":{}}}}},"output":{"type":"structure","members":{"imageIds":{"shape":"Si"},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"tags":{"shape":"S12"}}}},"PutImage":{"input":{"type":"structure","required":["repositoryName","imageManifest"],"members":{"registryId":{},"repositoryName":{},"imageManifest":{},"imageTag":{}}},"output":{"type":"structure","members":{"image":{"shape":"Sv"}}}},"PutImageTagMutability":{"input":{"type":"structure","required":["repositoryName","imageTagMutability"],"members":{"registryId":{},"repositoryName":{},"imageTagMutability":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageTagMutability":{}}}},"PutLifecyclePolicy":{"input":{"type":"structure","required":["repositoryName","lifecyclePolicyText"],"members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{}}}},"SetRepositoryPolicy":{"input":{"type":"structure","required":["repositoryName","policyText"],"members":{"registryId":{},"repositoryName":{},"policyText":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"policyText":{}}}},"StartLifecyclePolicyPreview":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"status":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UploadLayerPart":{"input":{"type":"structure","required":["repositoryName","uploadId","partFirstByte","partLastByte","layerPartBlob"],"members":{"registryId":{},"repositoryName":{},"uploadId":{},"partFirstByte":{"type":"long"},"partLastByte":{"type":"long"},"layerPartBlob":{"type":"blob"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"uploadId":{},"lastByteReceived":{"type":"long"}}}}},"shapes":{"Si":{"type":"list","member":{"shape":"Sj"}},"Sj":{"type":"structure","members":{"imageDigest":{},"imageTag":{}}},"Sn":{"type":"list","member":{"type":"structure","members":{"imageId":{"shape":"Sj"},"failureCode":{},"failureReason":{}}}},"Sv":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageId":{"shape":"Sj"},"imageManifest":{}}},"S12":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S18":{"type":"structure","members":{"repositoryArn":{},"registryId":{},"repositoryName":{},"repositoryUri":{},"createdAt":{"type":"timestamp"},"imageTagMutability":{}}},"S1u":{"type":"list","member":{}}}}');

});

parcelRequire.register("8Ry5W", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeImages":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"imageDetails"},"DescribeRepositories":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"repositories"},"ListImages":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"imageIds"}}}');

});


parcelRequire.register("luy43", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $fa56d2c6e623bfcd$var$Service = $dbC7k.Service;
var $fa56d2c6e623bfcd$var$apiLoader = $dbC7k.apiLoader;
$fa56d2c6e623bfcd$var$apiLoader.services["ecs"] = {};
$dbC7k.ECS = $fa56d2c6e623bfcd$var$Service.defineService("ecs", [
    "2014-11-13"
]);



Object.defineProperty($fa56d2c6e623bfcd$var$apiLoader.services["ecs"], "2014-11-13", {
    get: function get() {
        var model = (parcelRequire("ecdSj"));
        model.paginators = (parcelRequire("d5NHg")).pagination;
        model.waiters = (parcelRequire("6cmIy")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ECS;

});
parcelRequire.register("ecdSj", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2014-11-13","endpointPrefix":"ecs","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon ECS","serviceFullName":"Amazon EC2 Container Service","serviceId":"ECS","signatureVersion":"v4","targetPrefix":"AmazonEC2ContainerServiceV20141113","uid":"ecs-2014-11-13"},"operations":{"CreateCluster":{"input":{"type":"structure","members":{"clusterName":{},"tags":{"shape":"S3"},"settings":{"shape":"S7"}}},"output":{"type":"structure","members":{"cluster":{"shape":"Sb"}}}},"CreateService":{"input":{"type":"structure","required":["serviceName"],"members":{"cluster":{},"serviceName":{},"taskDefinition":{},"loadBalancers":{"shape":"Sg"},"serviceRegistries":{"shape":"Sj"},"desiredCount":{"type":"integer"},"clientToken":{},"launchType":{},"platformVersion":{},"role":{},"deploymentConfiguration":{"shape":"Sm"},"placementConstraints":{"shape":"Sn"},"placementStrategy":{"shape":"Sq"},"networkConfiguration":{"shape":"St"},"healthCheckGracePeriodSeconds":{"type":"integer"},"schedulingStrategy":{},"deploymentController":{"shape":"Sy"},"tags":{"shape":"S3"},"enableECSManagedTags":{"type":"boolean"},"propagateTags":{}}},"output":{"type":"structure","members":{"service":{"shape":"S13"}}}},"CreateTaskSet":{"input":{"type":"structure","required":["service","cluster","taskDefinition"],"members":{"service":{},"cluster":{},"externalId":{},"taskDefinition":{},"networkConfiguration":{"shape":"St"},"loadBalancers":{"shape":"Sg"},"serviceRegistries":{"shape":"Sj"},"launchType":{},"platformVersion":{},"scale":{"shape":"S17"},"clientToken":{}}},"output":{"type":"structure","members":{"taskSet":{"shape":"S15"}}}},"DeleteAccountSetting":{"input":{"type":"structure","required":["name"],"members":{"name":{},"principalArn":{}}},"output":{"type":"structure","members":{"setting":{"shape":"S1k"}}}},"DeleteAttributes":{"input":{"type":"structure","required":["attributes"],"members":{"cluster":{},"attributes":{"shape":"S1m"}}},"output":{"type":"structure","members":{"attributes":{"shape":"S1m"}}}},"DeleteCluster":{"input":{"type":"structure","required":["cluster"],"members":{"cluster":{}}},"output":{"type":"structure","members":{"cluster":{"shape":"Sb"}}}},"DeleteService":{"input":{"type":"structure","required":["service"],"members":{"cluster":{},"service":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"service":{"shape":"S13"}}}},"DeleteTaskSet":{"input":{"type":"structure","required":["cluster","service","taskSet"],"members":{"cluster":{},"service":{},"taskSet":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"taskSet":{"shape":"S15"}}}},"DeregisterContainerInstance":{"input":{"type":"structure","required":["containerInstance"],"members":{"cluster":{},"containerInstance":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"containerInstance":{"shape":"S1z"}}}},"DeregisterTaskDefinition":{"input":{"type":"structure","required":["taskDefinition"],"members":{"taskDefinition":{}}},"output":{"type":"structure","members":{"taskDefinition":{"shape":"S2a"}}}},"DescribeClusters":{"input":{"type":"structure","members":{"clusters":{"shape":"Sv"},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"clusters":{"type":"list","member":{"shape":"Sb"}},"failures":{"shape":"S42"}}}},"DescribeContainerInstances":{"input":{"type":"structure","required":["containerInstances"],"members":{"cluster":{},"containerInstances":{"shape":"Sv"},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"containerInstances":{"shape":"S48"},"failures":{"shape":"S42"}}}},"DescribeServices":{"input":{"type":"structure","required":["services"],"members":{"cluster":{},"services":{"shape":"Sv"},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"services":{"type":"list","member":{"shape":"S13"}},"failures":{"shape":"S42"}}}},"DescribeTaskDefinition":{"input":{"type":"structure","required":["taskDefinition"],"members":{"taskDefinition":{},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"taskDefinition":{"shape":"S2a"},"tags":{"shape":"S3"}}}},"DescribeTaskSets":{"input":{"type":"structure","required":["cluster","service"],"members":{"cluster":{},"service":{},"taskSets":{"shape":"Sv"}}},"output":{"type":"structure","members":{"taskSets":{"shape":"S14"},"failures":{"shape":"S42"}}}},"DescribeTasks":{"input":{"type":"structure","required":["tasks"],"members":{"cluster":{},"tasks":{"shape":"Sv"},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"tasks":{"shape":"S4o"},"failures":{"shape":"S42"}}}},"DiscoverPollEndpoint":{"input":{"type":"structure","members":{"containerInstance":{},"cluster":{}}},"output":{"type":"structure","members":{"endpoint":{},"telemetryEndpoint":{}}}},"ListAccountSettings":{"input":{"type":"structure","members":{"name":{},"value":{},"principalArn":{},"effectiveSettings":{"type":"boolean"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"settings":{"type":"list","member":{"shape":"S1k"}},"nextToken":{}}}},"ListAttributes":{"input":{"type":"structure","required":["targetType"],"members":{"cluster":{},"targetType":{},"attributeName":{},"attributeValue":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"attributes":{"shape":"S1m"},"nextToken":{}}}},"ListClusters":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"clusterArns":{"shape":"Sv"},"nextToken":{}}}},"ListContainerInstances":{"input":{"type":"structure","members":{"cluster":{},"filter":{},"nextToken":{},"maxResults":{"type":"integer"},"status":{}}},"output":{"type":"structure","members":{"containerInstanceArns":{"shape":"Sv"},"nextToken":{}}}},"ListServices":{"input":{"type":"structure","members":{"cluster":{},"nextToken":{},"maxResults":{"type":"integer"},"launchType":{},"schedulingStrategy":{}}},"output":{"type":"structure","members":{"serviceArns":{"shape":"Sv"},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"tags":{"shape":"S3"}}}},"ListTaskDefinitionFamilies":{"input":{"type":"structure","members":{"familyPrefix":{},"status":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"families":{"shape":"Sv"},"nextToken":{}}}},"ListTaskDefinitions":{"input":{"type":"structure","members":{"familyPrefix":{},"status":{},"sort":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"taskDefinitionArns":{"shape":"Sv"},"nextToken":{}}}},"ListTasks":{"input":{"type":"structure","members":{"cluster":{},"containerInstance":{},"family":{},"nextToken":{},"maxResults":{"type":"integer"},"startedBy":{},"serviceName":{},"desiredStatus":{},"launchType":{}}},"output":{"type":"structure","members":{"taskArns":{"shape":"Sv"},"nextToken":{}}}},"PutAccountSetting":{"input":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{},"principalArn":{}}},"output":{"type":"structure","members":{"setting":{"shape":"S1k"}}}},"PutAccountSettingDefault":{"input":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{}}},"output":{"type":"structure","members":{"setting":{"shape":"S1k"}}}},"PutAttributes":{"input":{"type":"structure","required":["attributes"],"members":{"cluster":{},"attributes":{"shape":"S1m"}}},"output":{"type":"structure","members":{"attributes":{"shape":"S1m"}}}},"RegisterContainerInstance":{"input":{"type":"structure","members":{"cluster":{},"instanceIdentityDocument":{},"instanceIdentityDocumentSignature":{},"totalResources":{"shape":"S22"},"versionInfo":{"shape":"S21"},"containerInstanceArn":{},"attributes":{"shape":"S1m"},"platformDevices":{"type":"list","member":{"type":"structure","required":["id","type"],"members":{"id":{},"type":{}}}},"tags":{"shape":"S3"}}},"output":{"type":"structure","members":{"containerInstance":{"shape":"S1z"}}}},"RegisterTaskDefinition":{"input":{"type":"structure","required":["family","containerDefinitions"],"members":{"family":{},"taskRoleArn":{},"executionRoleArn":{},"networkMode":{},"containerDefinitions":{"shape":"S2b"},"volumes":{"shape":"S3f"},"placementConstraints":{"shape":"S3n"},"requiresCompatibilities":{"shape":"S3q"},"cpu":{},"memory":{},"tags":{"shape":"S3"},"pidMode":{},"ipcMode":{},"proxyConfiguration":{"shape":"S3u"}}},"output":{"type":"structure","members":{"taskDefinition":{"shape":"S2a"},"tags":{"shape":"S3"}}}},"RunTask":{"input":{"type":"structure","required":["taskDefinition"],"members":{"cluster":{},"taskDefinition":{},"overrides":{"shape":"S4q"},"count":{"type":"integer"},"startedBy":{},"group":{},"placementConstraints":{"shape":"Sn"},"placementStrategy":{"shape":"Sq"},"launchType":{},"platformVersion":{},"networkConfiguration":{"shape":"St"},"tags":{"shape":"S3"},"enableECSManagedTags":{"type":"boolean"},"propagateTags":{}}},"output":{"type":"structure","members":{"tasks":{"shape":"S4o"},"failures":{"shape":"S42"}}}},"StartTask":{"input":{"type":"structure","required":["taskDefinition","containerInstances"],"members":{"cluster":{},"taskDefinition":{},"overrides":{"shape":"S4q"},"containerInstances":{"shape":"Sv"},"startedBy":{},"group":{},"networkConfiguration":{"shape":"St"},"tags":{"shape":"S3"},"enableECSManagedTags":{"type":"boolean"},"propagateTags":{}}},"output":{"type":"structure","members":{"tasks":{"shape":"S4o"},"failures":{"shape":"S42"}}}},"StopTask":{"input":{"type":"structure","required":["task"],"members":{"cluster":{},"task":{},"reason":{}}},"output":{"type":"structure","members":{"task":{"shape":"S4p"}}}},"SubmitAttachmentStateChanges":{"input":{"type":"structure","required":["attachments"],"members":{"cluster":{},"attachments":{"shape":"S6c"}}},"output":{"type":"structure","members":{"acknowledgment":{}}}},"SubmitContainerStateChange":{"input":{"type":"structure","members":{"cluster":{},"task":{},"containerName":{},"status":{},"exitCode":{"type":"integer"},"reason":{},"networkBindings":{"shape":"S4v"}}},"output":{"type":"structure","members":{"acknowledgment":{}}}},"SubmitTaskStateChange":{"input":{"type":"structure","members":{"cluster":{},"task":{},"status":{},"reason":{},"containers":{"type":"list","member":{"type":"structure","members":{"containerName":{},"exitCode":{"type":"integer"},"networkBindings":{"shape":"S4v"},"reason":{},"status":{}}}},"attachments":{"shape":"S6c"},"pullStartedAt":{"type":"timestamp"},"pullStoppedAt":{"type":"timestamp"},"executionStoppedAt":{"type":"timestamp"}}},"output":{"type":"structure","members":{"acknowledgment":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateContainerAgent":{"input":{"type":"structure","required":["containerInstance"],"members":{"cluster":{},"containerInstance":{}}},"output":{"type":"structure","members":{"containerInstance":{"shape":"S1z"}}}},"UpdateContainerInstancesState":{"input":{"type":"structure","required":["containerInstances","status"],"members":{"cluster":{},"containerInstances":{"shape":"Sv"},"status":{}}},"output":{"type":"structure","members":{"containerInstances":{"shape":"S48"},"failures":{"shape":"S42"}}}},"UpdateService":{"input":{"type":"structure","required":["service"],"members":{"cluster":{},"service":{},"desiredCount":{"type":"integer"},"taskDefinition":{},"deploymentConfiguration":{"shape":"Sm"},"networkConfiguration":{"shape":"St"},"platformVersion":{},"forceNewDeployment":{"type":"boolean"},"healthCheckGracePeriodSeconds":{"type":"integer"}}},"output":{"type":"structure","members":{"service":{"shape":"S13"}}}},"UpdateServicePrimaryTaskSet":{"input":{"type":"structure","required":["cluster","service","primaryTaskSet"],"members":{"cluster":{},"service":{},"primaryTaskSet":{}}},"output":{"type":"structure","members":{"taskSet":{"shape":"S15"}}}},"UpdateTaskSet":{"input":{"type":"structure","required":["cluster","service","taskSet","scale"],"members":{"cluster":{},"service":{},"taskSet":{},"scale":{"shape":"S17"}}},"output":{"type":"structure","members":{"taskSet":{"shape":"S15"}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}}},"S7":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{}}}},"Sb":{"type":"structure","members":{"clusterArn":{},"clusterName":{},"status":{},"registeredContainerInstancesCount":{"type":"integer"},"runningTasksCount":{"type":"integer"},"pendingTasksCount":{"type":"integer"},"activeServicesCount":{"type":"integer"},"statistics":{"type":"list","member":{"shape":"Se"}},"tags":{"shape":"S3"},"settings":{"shape":"S7"}}},"Se":{"type":"structure","members":{"name":{},"value":{}}},"Sg":{"type":"list","member":{"type":"structure","members":{"targetGroupArn":{},"loadBalancerName":{},"containerName":{},"containerPort":{"type":"integer"}}}},"Sj":{"type":"list","member":{"type":"structure","members":{"registryArn":{},"port":{"type":"integer"},"containerName":{},"containerPort":{"type":"integer"}}}},"Sm":{"type":"structure","members":{"maximumPercent":{"type":"integer"},"minimumHealthyPercent":{"type":"integer"}}},"Sn":{"type":"list","member":{"type":"structure","members":{"type":{},"expression":{}}}},"Sq":{"type":"list","member":{"type":"structure","members":{"type":{},"field":{}}}},"St":{"type":"structure","members":{"awsvpcConfiguration":{"type":"structure","required":["subnets"],"members":{"subnets":{"shape":"Sv"},"securityGroups":{"shape":"Sv"},"assignPublicIp":{}}}}},"Sv":{"type":"list","member":{}},"Sy":{"type":"structure","required":["type"],"members":{"type":{}}},"S13":{"type":"structure","members":{"serviceArn":{},"serviceName":{},"clusterArn":{},"loadBalancers":{"shape":"Sg"},"serviceRegistries":{"shape":"Sj"},"status":{},"desiredCount":{"type":"integer"},"runningCount":{"type":"integer"},"pendingCount":{"type":"integer"},"launchType":{},"platformVersion":{},"taskDefinition":{},"deploymentConfiguration":{"shape":"Sm"},"taskSets":{"shape":"S14"},"deployments":{"type":"list","member":{"type":"structure","members":{"id":{},"status":{},"taskDefinition":{},"desiredCount":{"type":"integer"},"pendingCount":{"type":"integer"},"runningCount":{"type":"integer"},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"},"launchType":{},"platformVersion":{},"networkConfiguration":{"shape":"St"}}}},"roleArn":{},"events":{"type":"list","member":{"type":"structure","members":{"id":{},"createdAt":{"type":"timestamp"},"message":{}}}},"createdAt":{"type":"timestamp"},"placementConstraints":{"shape":"Sn"},"placementStrategy":{"shape":"Sq"},"networkConfiguration":{"shape":"St"},"healthCheckGracePeriodSeconds":{"type":"integer"},"schedulingStrategy":{},"deploymentController":{"shape":"Sy"},"tags":{"shape":"S3"},"createdBy":{},"enableECSManagedTags":{"type":"boolean"},"propagateTags":{}}},"S14":{"type":"list","member":{"shape":"S15"}},"S15":{"type":"structure","members":{"id":{},"taskSetArn":{},"serviceArn":{},"clusterArn":{},"startedBy":{},"externalId":{},"status":{},"taskDefinition":{},"computedDesiredCount":{"type":"integer"},"pendingCount":{"type":"integer"},"runningCount":{"type":"integer"},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"},"launchType":{},"platformVersion":{},"networkConfiguration":{"shape":"St"},"loadBalancers":{"shape":"Sg"},"serviceRegistries":{"shape":"Sj"},"scale":{"shape":"S17"},"stabilityStatus":{},"stabilityStatusAt":{"type":"timestamp"}}},"S17":{"type":"structure","members":{"value":{"type":"double"},"unit":{}}},"S1k":{"type":"structure","members":{"name":{},"value":{},"principalArn":{}}},"S1m":{"type":"list","member":{"shape":"S1n"}},"S1n":{"type":"structure","required":["name"],"members":{"name":{},"value":{},"targetType":{},"targetId":{}}},"S1z":{"type":"structure","members":{"containerInstanceArn":{},"ec2InstanceId":{},"version":{"type":"long"},"versionInfo":{"shape":"S21"},"remainingResources":{"shape":"S22"},"registeredResources":{"shape":"S22"},"status":{},"statusReason":{},"agentConnected":{"type":"boolean"},"runningTasksCount":{"type":"integer"},"pendingTasksCount":{"type":"integer"},"agentUpdateStatus":{},"attributes":{"shape":"S1m"},"registeredAt":{"type":"timestamp"},"attachments":{"shape":"S25"},"tags":{"shape":"S3"}}},"S21":{"type":"structure","members":{"agentVersion":{},"agentHash":{},"dockerVersion":{}}},"S22":{"type":"list","member":{"type":"structure","members":{"name":{},"type":{},"doubleValue":{"type":"double"},"longValue":{"type":"long"},"integerValue":{"type":"integer"},"stringSetValue":{"shape":"Sv"}}}},"S25":{"type":"list","member":{"type":"structure","members":{"id":{},"type":{},"status":{},"details":{"type":"list","member":{"shape":"Se"}}}}},"S2a":{"type":"structure","members":{"taskDefinitionArn":{},"containerDefinitions":{"shape":"S2b"},"family":{},"taskRoleArn":{},"executionRoleArn":{},"networkMode":{},"revision":{"type":"integer"},"volumes":{"shape":"S3f"},"status":{},"requiresAttributes":{"type":"list","member":{"shape":"S1n"}},"placementConstraints":{"shape":"S3n"},"compatibilities":{"shape":"S3q"},"requiresCompatibilities":{"shape":"S3q"},"cpu":{},"memory":{},"pidMode":{},"ipcMode":{},"proxyConfiguration":{"shape":"S3u"}}},"S2b":{"type":"list","member":{"type":"structure","members":{"name":{},"image":{},"repositoryCredentials":{"type":"structure","required":["credentialsParameter"],"members":{"credentialsParameter":{}}},"cpu":{"type":"integer"},"memory":{"type":"integer"},"memoryReservation":{"type":"integer"},"links":{"shape":"Sv"},"portMappings":{"type":"list","member":{"type":"structure","members":{"containerPort":{"type":"integer"},"hostPort":{"type":"integer"},"protocol":{}}}},"essential":{"type":"boolean"},"entryPoint":{"shape":"Sv"},"command":{"shape":"Sv"},"environment":{"shape":"S2h"},"mountPoints":{"type":"list","member":{"type":"structure","members":{"sourceVolume":{},"containerPath":{},"readOnly":{"type":"boolean"}}}},"volumesFrom":{"type":"list","member":{"type":"structure","members":{"sourceContainer":{},"readOnly":{"type":"boolean"}}}},"linuxParameters":{"type":"structure","members":{"capabilities":{"type":"structure","members":{"add":{"shape":"Sv"},"drop":{"shape":"Sv"}}},"devices":{"type":"list","member":{"type":"structure","required":["hostPath"],"members":{"hostPath":{},"containerPath":{},"permissions":{"type":"list","member":{}}}}},"initProcessEnabled":{"type":"boolean"},"sharedMemorySize":{"type":"integer"},"tmpfs":{"type":"list","member":{"type":"structure","required":["containerPath","size"],"members":{"containerPath":{},"size":{"type":"integer"},"mountOptions":{"shape":"Sv"}}}},"maxSwap":{"type":"integer"},"swappiness":{"type":"integer"}}},"secrets":{"shape":"S2u"},"dependsOn":{"type":"list","member":{"type":"structure","required":["containerName","condition"],"members":{"containerName":{},"condition":{}}}},"startTimeout":{"type":"integer"},"stopTimeout":{"type":"integer"},"hostname":{},"user":{},"workingDirectory":{},"disableNetworking":{"type":"boolean"},"privileged":{"type":"boolean"},"readonlyRootFilesystem":{"type":"boolean"},"dnsServers":{"shape":"Sv"},"dnsSearchDomains":{"shape":"Sv"},"extraHosts":{"type":"list","member":{"type":"structure","required":["hostname","ipAddress"],"members":{"hostname":{},"ipAddress":{}}}},"dockerSecurityOptions":{"shape":"Sv"},"interactive":{"type":"boolean"},"pseudoTerminal":{"type":"boolean"},"dockerLabels":{"type":"map","key":{},"value":{}},"ulimits":{"type":"list","member":{"type":"structure","required":["name","softLimit","hardLimit"],"members":{"name":{},"softLimit":{"type":"integer"},"hardLimit":{"type":"integer"}}}},"logConfiguration":{"type":"structure","required":["logDriver"],"members":{"logDriver":{},"options":{"type":"map","key":{},"value":{}},"secretOptions":{"shape":"S2u"}}},"healthCheck":{"type":"structure","required":["command"],"members":{"command":{"shape":"Sv"},"interval":{"type":"integer"},"timeout":{"type":"integer"},"retries":{"type":"integer"},"startPeriod":{"type":"integer"}}},"systemControls":{"type":"list","member":{"type":"structure","members":{"namespace":{},"value":{}}}},"resourceRequirements":{"shape":"S3b"}}}},"S2h":{"type":"list","member":{"shape":"Se"}},"S2u":{"type":"list","member":{"type":"structure","required":["name","valueFrom"],"members":{"name":{},"valueFrom":{}}}},"S3b":{"type":"list","member":{"type":"structure","required":["value","type"],"members":{"value":{},"type":{}}}},"S3f":{"type":"list","member":{"type":"structure","members":{"name":{},"host":{"type":"structure","members":{"sourcePath":{}}},"dockerVolumeConfiguration":{"type":"structure","members":{"scope":{},"autoprovision":{"type":"boolean"},"driver":{},"driverOpts":{"shape":"S3k"},"labels":{"shape":"S3k"}}}}}},"S3k":{"type":"map","key":{},"value":{}},"S3n":{"type":"list","member":{"type":"structure","members":{"type":{},"expression":{}}}},"S3q":{"type":"list","member":{}},"S3u":{"type":"structure","required":["containerName"],"members":{"type":{},"containerName":{},"properties":{"type":"list","member":{"shape":"Se"}}}},"S42":{"type":"list","member":{"type":"structure","members":{"arn":{},"reason":{}}}},"S48":{"type":"list","member":{"shape":"S1z"}},"S4o":{"type":"list","member":{"shape":"S4p"}},"S4p":{"type":"structure","members":{"taskArn":{},"clusterArn":{},"taskDefinitionArn":{},"containerInstanceArn":{},"overrides":{"shape":"S4q"},"lastStatus":{},"desiredStatus":{},"cpu":{},"memory":{},"containers":{"type":"list","member":{"type":"structure","members":{"containerArn":{},"taskArn":{},"name":{},"lastStatus":{},"exitCode":{"type":"integer"},"reason":{},"networkBindings":{"shape":"S4v"},"networkInterfaces":{"type":"list","member":{"type":"structure","members":{"attachmentId":{},"privateIpv4Address":{},"ipv6Address":{}}}},"healthStatus":{},"cpu":{},"memory":{},"memoryReservation":{},"gpuIds":{"type":"list","member":{}}}}},"startedBy":{},"version":{"type":"long"},"stoppedReason":{},"stopCode":{},"connectivity":{},"connectivityAt":{"type":"timestamp"},"pullStartedAt":{"type":"timestamp"},"pullStoppedAt":{"type":"timestamp"},"executionStoppedAt":{"type":"timestamp"},"createdAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"stoppingAt":{"type":"timestamp"},"stoppedAt":{"type":"timestamp"},"group":{},"launchType":{},"platformVersion":{},"attachments":{"shape":"S25"},"healthStatus":{},"tags":{"shape":"S3"}}},"S4q":{"type":"structure","members":{"containerOverrides":{"type":"list","member":{"type":"structure","members":{"name":{},"command":{"shape":"Sv"},"environment":{"shape":"S2h"},"cpu":{"type":"integer"},"memory":{"type":"integer"},"memoryReservation":{"type":"integer"},"resourceRequirements":{"shape":"S3b"}}}},"taskRoleArn":{},"executionRoleArn":{}}},"S4v":{"type":"list","member":{"type":"structure","members":{"bindIP":{},"containerPort":{"type":"integer"},"hostPort":{"type":"integer"},"protocol":{}}}},"S6c":{"type":"list","member":{"type":"structure","required":["attachmentArn","status"],"members":{"attachmentArn":{},"status":{}}}}}}');

});

parcelRequire.register("d5NHg", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListClusters":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"clusterArns"},"ListContainerInstances":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"containerInstanceArns"},"ListServices":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"serviceArns"},"ListTaskDefinitionFamilies":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"families"},"ListTaskDefinitions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"taskDefinitionArns"},"ListTasks":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"taskArns"}}}');

});

parcelRequire.register("6cmIy", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"TasksRunning":{"delay":6,"operation":"DescribeTasks","maxAttempts":100,"acceptors":[{"expected":"STOPPED","matcher":"pathAny","state":"failure","argument":"tasks[].lastStatus"},{"expected":"MISSING","matcher":"pathAny","state":"failure","argument":"failures[].reason"},{"expected":"RUNNING","matcher":"pathAll","state":"success","argument":"tasks[].lastStatus"}]},"TasksStopped":{"delay":6,"operation":"DescribeTasks","maxAttempts":100,"acceptors":[{"expected":"STOPPED","matcher":"pathAll","state":"success","argument":"tasks[].lastStatus"}]},"ServicesStable":{"delay":15,"operation":"DescribeServices","maxAttempts":40,"acceptors":[{"expected":"MISSING","matcher":"pathAny","state":"failure","argument":"failures[].reason"},{"expected":"DRAINING","matcher":"pathAny","state":"failure","argument":"services[].status"},{"expected":"INACTIVE","matcher":"pathAny","state":"failure","argument":"services[].status"},{"expected":true,"matcher":"path","state":"success","argument":"length(services[?!(length(deployments) == `1` && runningCount == desiredCount)]) == `0`"}]},"ServicesInactive":{"delay":15,"operation":"DescribeServices","maxAttempts":40,"acceptors":[{"expected":"MISSING","matcher":"pathAny","state":"failure","argument":"failures[].reason"},{"expected":"INACTIVE","matcher":"pathAny","state":"success","argument":"services[].status"}]}}}');

});


parcelRequire.register("gQxbQ", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $c43b3f8b34976c7d$var$Service = $dbC7k.Service;
var $c43b3f8b34976c7d$var$apiLoader = $dbC7k.apiLoader;
$c43b3f8b34976c7d$var$apiLoader.services["efs"] = {};
$dbC7k.EFS = $c43b3f8b34976c7d$var$Service.defineService("efs", [
    "2015-02-01"
]);


Object.defineProperty($c43b3f8b34976c7d$var$apiLoader.services["efs"], "2015-02-01", {
    get: function get() {
        var model = (parcelRequire("kMDrg"));
        model.paginators = (parcelRequire("7xpWW")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.EFS;

});
parcelRequire.register("kMDrg", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-02-01","endpointPrefix":"elasticfilesystem","protocol":"rest-json","serviceAbbreviation":"EFS","serviceFullName":"Amazon Elastic File System","serviceId":"EFS","signatureVersion":"v4","uid":"elasticfilesystem-2015-02-01"},"operations":{"CreateFileSystem":{"http":{"requestUri":"/2015-02-01/file-systems","responseCode":201},"input":{"type":"structure","required":["CreationToken"],"members":{"CreationToken":{},"PerformanceMode":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"ThroughputMode":{},"ProvisionedThroughputInMibps":{"type":"double"},"Tags":{"shape":"S8"}}},"output":{"shape":"Sc"}},"CreateMountTarget":{"http":{"requestUri":"/2015-02-01/mount-targets","responseCode":200},"input":{"type":"structure","required":["FileSystemId","SubnetId"],"members":{"FileSystemId":{},"SubnetId":{},"IpAddress":{},"SecurityGroups":{"shape":"So"}}},"output":{"shape":"Sq"}},"CreateTags":{"http":{"requestUri":"/2015-02-01/create-tags/{FileSystemId}","responseCode":204},"input":{"type":"structure","required":["FileSystemId","Tags"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"Tags":{"shape":"S8"}}}},"DeleteFileSystem":{"http":{"method":"DELETE","requestUri":"/2015-02-01/file-systems/{FileSystemId}","responseCode":204},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}}},"DeleteMountTarget":{"http":{"method":"DELETE","requestUri":"/2015-02-01/mount-targets/{MountTargetId}","responseCode":204},"input":{"type":"structure","required":["MountTargetId"],"members":{"MountTargetId":{"location":"uri","locationName":"MountTargetId"}}}},"DeleteTags":{"http":{"requestUri":"/2015-02-01/delete-tags/{FileSystemId}","responseCode":204},"input":{"type":"structure","required":["FileSystemId","TagKeys"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"TagKeys":{"type":"list","member":{}}}}},"DescribeFileSystems":{"http":{"method":"GET","requestUri":"/2015-02-01/file-systems","responseCode":200},"input":{"type":"structure","members":{"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"Marker":{"location":"querystring","locationName":"Marker"},"CreationToken":{"location":"querystring","locationName":"CreationToken"},"FileSystemId":{"location":"querystring","locationName":"FileSystemId"}}},"output":{"type":"structure","members":{"Marker":{},"FileSystems":{"type":"list","member":{"shape":"Sc"}},"NextMarker":{}}}},"DescribeLifecycleConfiguration":{"http":{"method":"GET","requestUri":"/2015-02-01/file-systems/{FileSystemId}/lifecycle-configuration","responseCode":200},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}},"output":{"shape":"S14"}},"DescribeMountTargetSecurityGroups":{"http":{"method":"GET","requestUri":"/2015-02-01/mount-targets/{MountTargetId}/security-groups","responseCode":200},"input":{"type":"structure","required":["MountTargetId"],"members":{"MountTargetId":{"location":"uri","locationName":"MountTargetId"}}},"output":{"type":"structure","required":["SecurityGroups"],"members":{"SecurityGroups":{"shape":"So"}}}},"DescribeMountTargets":{"http":{"method":"GET","requestUri":"/2015-02-01/mount-targets","responseCode":200},"input":{"type":"structure","members":{"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"Marker":{"location":"querystring","locationName":"Marker"},"FileSystemId":{"location":"querystring","locationName":"FileSystemId"},"MountTargetId":{"location":"querystring","locationName":"MountTargetId"}}},"output":{"type":"structure","members":{"Marker":{},"MountTargets":{"type":"list","member":{"shape":"Sq"}},"NextMarker":{}}}},"DescribeTags":{"http":{"method":"GET","requestUri":"/2015-02-01/tags/{FileSystemId}/","responseCode":200},"input":{"type":"structure","required":["FileSystemId"],"members":{"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"Marker":{"location":"querystring","locationName":"Marker"},"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}},"output":{"type":"structure","required":["Tags"],"members":{"Marker":{},"Tags":{"shape":"S8"},"NextMarker":{}}}},"ModifyMountTargetSecurityGroups":{"http":{"method":"PUT","requestUri":"/2015-02-01/mount-targets/{MountTargetId}/security-groups","responseCode":204},"input":{"type":"structure","required":["MountTargetId"],"members":{"MountTargetId":{"location":"uri","locationName":"MountTargetId"},"SecurityGroups":{"shape":"So"}}}},"PutLifecycleConfiguration":{"http":{"method":"PUT","requestUri":"/2015-02-01/file-systems/{FileSystemId}/lifecycle-configuration","responseCode":200},"input":{"type":"structure","required":["FileSystemId","LifecyclePolicies"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"LifecyclePolicies":{"shape":"S15"}}},"output":{"shape":"S14"}},"UpdateFileSystem":{"http":{"method":"PUT","requestUri":"/2015-02-01/file-systems/{FileSystemId}","responseCode":202},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"ThroughputMode":{},"ProvisionedThroughputInMibps":{"type":"double"}}},"output":{"shape":"Sc"}}},"shapes":{"S8":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sc":{"type":"structure","required":["OwnerId","CreationToken","FileSystemId","CreationTime","LifeCycleState","NumberOfMountTargets","SizeInBytes","PerformanceMode","Tags"],"members":{"OwnerId":{},"CreationToken":{},"FileSystemId":{},"CreationTime":{"type":"timestamp"},"LifeCycleState":{},"Name":{},"NumberOfMountTargets":{"type":"integer"},"SizeInBytes":{"type":"structure","required":["Value"],"members":{"Value":{"type":"long"},"Timestamp":{"type":"timestamp"},"ValueInIA":{"type":"long"},"ValueInStandard":{"type":"long"}}},"PerformanceMode":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"ThroughputMode":{},"ProvisionedThroughputInMibps":{"type":"double"},"Tags":{"shape":"S8"}}},"So":{"type":"list","member":{}},"Sq":{"type":"structure","required":["MountTargetId","FileSystemId","SubnetId","LifeCycleState"],"members":{"OwnerId":{},"MountTargetId":{},"FileSystemId":{},"SubnetId":{},"LifeCycleState":{},"IpAddress":{},"NetworkInterfaceId":{}}},"S14":{"type":"structure","members":{"LifecyclePolicies":{"shape":"S15"}}},"S15":{"type":"list","member":{"type":"structure","members":{"TransitionToIA":{}}}}}}');

});

parcelRequire.register("7xpWW", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("FMpEp", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $07d962354e51091b$var$Service = $dbC7k.Service;
var $07d962354e51091b$var$apiLoader = $dbC7k.apiLoader;
$07d962354e51091b$var$apiLoader.services["elasticache"] = {};
$dbC7k.ElastiCache = $07d962354e51091b$var$Service.defineService("elasticache", [
    "2012-11-15*",
    "2014-03-24*",
    "2014-07-15*",
    "2014-09-30*",
    "2015-02-02"
]);



Object.defineProperty($07d962354e51091b$var$apiLoader.services["elasticache"], "2015-02-02", {
    get: function get() {
        var model = (parcelRequire("9tAkb"));
        model.paginators = (parcelRequire("2HXSZ")).pagination;
        model.waiters = (parcelRequire("hmoEa")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ElastiCache;

});
parcelRequire.register("9tAkb", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-02-02","endpointPrefix":"elasticache","protocol":"query","serviceFullName":"Amazon ElastiCache","serviceId":"ElastiCache","signatureVersion":"v4","uid":"elasticache-2015-02-02","xmlNamespace":"http://elasticache.amazonaws.com/doc/2015-02-02/"},"operations":{"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S3"}}},"output":{"shape":"S5","resultWrapper":"AddTagsToResourceResult"}},"AuthorizeCacheSecurityGroupIngress":{"input":{"type":"structure","required":["CacheSecurityGroupName","EC2SecurityGroupName","EC2SecurityGroupOwnerId"],"members":{"CacheSecurityGroupName":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeCacheSecurityGroupIngressResult","type":"structure","members":{"CacheSecurityGroup":{"shape":"S8"}}}},"BatchApplyUpdateAction":{"input":{"type":"structure","required":["ReplicationGroupIds","ServiceUpdateName"],"members":{"ReplicationGroupIds":{"shape":"Sc"},"ServiceUpdateName":{}}},"output":{"shape":"Sd","resultWrapper":"BatchApplyUpdateActionResult"}},"BatchStopUpdateAction":{"input":{"type":"structure","required":["ReplicationGroupIds","ServiceUpdateName"],"members":{"ReplicationGroupIds":{"shape":"Sc"},"ServiceUpdateName":{}}},"output":{"shape":"Sd","resultWrapper":"BatchStopUpdateActionResult"}},"CopySnapshot":{"input":{"type":"structure","required":["SourceSnapshotName","TargetSnapshotName"],"members":{"SourceSnapshotName":{},"TargetSnapshotName":{},"TargetBucket":{}}},"output":{"resultWrapper":"CopySnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sm"}}}},"CreateCacheCluster":{"input":{"type":"structure","required":["CacheClusterId"],"members":{"CacheClusterId":{},"ReplicationGroupId":{},"AZMode":{},"PreferredAvailabilityZone":{},"PreferredAvailabilityZones":{"shape":"Sy"},"NumCacheNodes":{"type":"integer"},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"CacheParameterGroupName":{},"CacheSubnetGroupName":{},"CacheSecurityGroupNames":{"shape":"Sz"},"SecurityGroupIds":{"shape":"S10"},"Tags":{"shape":"S3"},"SnapshotArns":{"shape":"S11"},"SnapshotName":{},"PreferredMaintenanceWindow":{},"Port":{"type":"integer"},"NotificationTopicArn":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"AuthToken":{}}},"output":{"resultWrapper":"CreateCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"S14"}}}},"CreateCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName","CacheParameterGroupFamily","Description"],"members":{"CacheParameterGroupName":{},"CacheParameterGroupFamily":{},"Description":{}}},"output":{"resultWrapper":"CreateCacheParameterGroupResult","type":"structure","members":{"CacheParameterGroup":{"shape":"S1j"}}}},"CreateCacheSecurityGroup":{"input":{"type":"structure","required":["CacheSecurityGroupName","Description"],"members":{"CacheSecurityGroupName":{},"Description":{}}},"output":{"resultWrapper":"CreateCacheSecurityGroupResult","type":"structure","members":{"CacheSecurityGroup":{"shape":"S8"}}}},"CreateCacheSubnetGroup":{"input":{"type":"structure","required":["CacheSubnetGroupName","CacheSubnetGroupDescription","SubnetIds"],"members":{"CacheSubnetGroupName":{},"CacheSubnetGroupDescription":{},"SubnetIds":{"shape":"S1n"}}},"output":{"resultWrapper":"CreateCacheSubnetGroupResult","type":"structure","members":{"CacheSubnetGroup":{"shape":"S1p"}}}},"CreateReplicationGroup":{"input":{"type":"structure","required":["ReplicationGroupId","ReplicationGroupDescription"],"members":{"ReplicationGroupId":{},"ReplicationGroupDescription":{},"PrimaryClusterId":{},"AutomaticFailoverEnabled":{"type":"boolean"},"NumCacheClusters":{"type":"integer"},"PreferredCacheClusterAZs":{"shape":"Sv"},"NumNodeGroups":{"type":"integer"},"ReplicasPerNodeGroup":{"type":"integer"},"NodeGroupConfiguration":{"type":"list","member":{"shape":"St","locationName":"NodeGroupConfiguration"}},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"CacheParameterGroupName":{},"CacheSubnetGroupName":{},"CacheSecurityGroupNames":{"shape":"Sz"},"SecurityGroupIds":{"shape":"S10"},"Tags":{"shape":"S3"},"SnapshotArns":{"shape":"S11"},"SnapshotName":{},"PreferredMaintenanceWindow":{},"Port":{"type":"integer"},"NotificationTopicArn":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"AuthToken":{},"TransitEncryptionEnabled":{"type":"boolean"},"AtRestEncryptionEnabled":{"type":"boolean"}}},"output":{"resultWrapper":"CreateReplicationGroupResult","type":"structure","members":{"ReplicationGroup":{"shape":"S1w"}}}},"CreateSnapshot":{"input":{"type":"structure","required":["SnapshotName"],"members":{"ReplicationGroupId":{},"CacheClusterId":{},"SnapshotName":{}}},"output":{"resultWrapper":"CreateSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sm"}}}},"DecreaseReplicaCount":{"input":{"type":"structure","required":["ReplicationGroupId","ApplyImmediately"],"members":{"ReplicationGroupId":{},"NewReplicaCount":{"type":"integer"},"ReplicaConfiguration":{"shape":"S2a"},"ReplicasToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"DecreaseReplicaCountResult","type":"structure","members":{"ReplicationGroup":{"shape":"S1w"}}}},"DeleteCacheCluster":{"input":{"type":"structure","required":["CacheClusterId"],"members":{"CacheClusterId":{},"FinalSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"S14"}}}},"DeleteCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName"],"members":{"CacheParameterGroupName":{}}}},"DeleteCacheSecurityGroup":{"input":{"type":"structure","required":["CacheSecurityGroupName"],"members":{"CacheSecurityGroupName":{}}}},"DeleteCacheSubnetGroup":{"input":{"type":"structure","required":["CacheSubnetGroupName"],"members":{"CacheSubnetGroupName":{}}}},"DeleteReplicationGroup":{"input":{"type":"structure","required":["ReplicationGroupId"],"members":{"ReplicationGroupId":{},"RetainPrimaryCluster":{"type":"boolean"},"FinalSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteReplicationGroupResult","type":"structure","members":{"ReplicationGroup":{"shape":"S1w"}}}},"DeleteSnapshot":{"input":{"type":"structure","required":["SnapshotName"],"members":{"SnapshotName":{}}},"output":{"resultWrapper":"DeleteSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sm"}}}},"DescribeCacheClusters":{"input":{"type":"structure","members":{"CacheClusterId":{},"MaxRecords":{"type":"integer"},"Marker":{},"ShowCacheNodeInfo":{"type":"boolean"},"ShowCacheClustersNotInReplicationGroups":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeCacheClustersResult","type":"structure","members":{"Marker":{},"CacheClusters":{"type":"list","member":{"shape":"S14","locationName":"CacheCluster"}}}}},"DescribeCacheEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"CacheParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeCacheEngineVersionsResult","type":"structure","members":{"Marker":{},"CacheEngineVersions":{"type":"list","member":{"locationName":"CacheEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"CacheParameterGroupFamily":{},"CacheEngineDescription":{},"CacheEngineVersionDescription":{}}}}}}},"DescribeCacheParameterGroups":{"input":{"type":"structure","members":{"CacheParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheParameterGroupsResult","type":"structure","members":{"Marker":{},"CacheParameterGroups":{"type":"list","member":{"shape":"S1j","locationName":"CacheParameterGroup"}}}}},"DescribeCacheParameters":{"input":{"type":"structure","required":["CacheParameterGroupName"],"members":{"CacheParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheParametersResult","type":"structure","members":{"Marker":{},"Parameters":{"shape":"S2z"},"CacheNodeTypeSpecificParameters":{"shape":"S32"}}}},"DescribeCacheSecurityGroups":{"input":{"type":"structure","members":{"CacheSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheSecurityGroupsResult","type":"structure","members":{"Marker":{},"CacheSecurityGroups":{"type":"list","member":{"shape":"S8","locationName":"CacheSecurityGroup"}}}}},"DescribeCacheSubnetGroups":{"input":{"type":"structure","members":{"CacheSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheSubnetGroupsResult","type":"structure","members":{"Marker":{},"CacheSubnetGroups":{"type":"list","member":{"shape":"S1p","locationName":"CacheSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["CacheParameterGroupFamily"],"members":{"CacheParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"CacheParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2z"},"CacheNodeTypeSpecificParameters":{"shape":"S32"}},"wrapper":true}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"Date":{"type":"timestamp"}}}}}}},"DescribeReplicationGroups":{"input":{"type":"structure","members":{"ReplicationGroupId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReplicationGroupsResult","type":"structure","members":{"Marker":{},"ReplicationGroups":{"type":"list","member":{"shape":"S1w","locationName":"ReplicationGroup"}}}}},"DescribeReservedCacheNodes":{"input":{"type":"structure","members":{"ReservedCacheNodeId":{},"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedCacheNodesResult","type":"structure","members":{"Marker":{},"ReservedCacheNodes":{"type":"list","member":{"shape":"S3q","locationName":"ReservedCacheNode"}}}}},"DescribeReservedCacheNodesOfferings":{"input":{"type":"structure","members":{"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedCacheNodesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedCacheNodesOfferings":{"type":"list","member":{"locationName":"ReservedCacheNodesOffering","type":"structure","members":{"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"ProductDescription":{},"OfferingType":{},"RecurringCharges":{"shape":"S3r"}},"wrapper":true}}}}},"DescribeServiceUpdates":{"input":{"type":"structure","members":{"ServiceUpdateName":{},"ServiceUpdateStatus":{"shape":"S3y"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeServiceUpdatesResult","type":"structure","members":{"Marker":{},"ServiceUpdates":{"type":"list","member":{"locationName":"ServiceUpdate","type":"structure","members":{"ServiceUpdateName":{},"ServiceUpdateReleaseDate":{"type":"timestamp"},"ServiceUpdateEndDate":{"type":"timestamp"},"ServiceUpdateSeverity":{},"ServiceUpdateRecommendedApplyByDate":{"type":"timestamp"},"ServiceUpdateStatus":{},"ServiceUpdateDescription":{},"ServiceUpdateType":{},"Engine":{},"EngineVersion":{},"AutoUpdateAfterRecommendedApplyByDate":{"type":"boolean"},"EstimatedUpdateTime":{}}}}}}},"DescribeSnapshots":{"input":{"type":"structure","members":{"ReplicationGroupId":{},"CacheClusterId":{},"SnapshotName":{},"SnapshotSource":{},"Marker":{},"MaxRecords":{"type":"integer"},"ShowNodeGroupConfig":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeSnapshotsResult","type":"structure","members":{"Marker":{},"Snapshots":{"type":"list","member":{"shape":"Sm","locationName":"Snapshot"}}}}},"DescribeUpdateActions":{"input":{"type":"structure","members":{"ServiceUpdateName":{},"ReplicationGroupIds":{"shape":"Sc"},"ServiceUpdateStatus":{"shape":"S3y"},"ServiceUpdateTimeRange":{"type":"structure","members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"UpdateActionStatus":{"type":"list","member":{}},"ShowNodeLevelUpdateStatus":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeUpdateActionsResult","type":"structure","members":{"Marker":{},"UpdateActions":{"type":"list","member":{"locationName":"UpdateAction","type":"structure","members":{"ReplicationGroupId":{},"ServiceUpdateName":{},"ServiceUpdateReleaseDate":{"type":"timestamp"},"ServiceUpdateSeverity":{},"ServiceUpdateStatus":{},"ServiceUpdateRecommendedApplyByDate":{"type":"timestamp"},"ServiceUpdateType":{},"UpdateActionAvailableDate":{"type":"timestamp"},"UpdateActionStatus":{},"NodesUpdated":{},"UpdateActionStatusModifiedDate":{"type":"timestamp"},"SlaMet":{},"NodeGroupUpdateStatus":{"type":"list","member":{"locationName":"NodeGroupUpdateStatus","type":"structure","members":{"NodeGroupId":{},"NodeGroupMemberUpdateStatus":{"type":"list","member":{"locationName":"NodeGroupMemberUpdateStatus","type":"structure","members":{"CacheClusterId":{},"CacheNodeId":{},"NodeUpdateStatus":{},"NodeDeletionDate":{"type":"timestamp"},"NodeUpdateStartDate":{"type":"timestamp"},"NodeUpdateEndDate":{"type":"timestamp"},"NodeUpdateInitiatedBy":{},"NodeUpdateInitiatedDate":{"type":"timestamp"},"NodeUpdateStatusModifiedDate":{"type":"timestamp"}}}}}}},"EstimatedUpdateTime":{}}}}}}},"IncreaseReplicaCount":{"input":{"type":"structure","required":["ReplicationGroupId","ApplyImmediately"],"members":{"ReplicationGroupId":{},"NewReplicaCount":{"type":"integer"},"ReplicaConfiguration":{"shape":"S2a"},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"IncreaseReplicaCountResult","type":"structure","members":{"ReplicationGroup":{"shape":"S1w"}}}},"ListAllowedNodeTypeModifications":{"input":{"type":"structure","members":{"CacheClusterId":{},"ReplicationGroupId":{}}},"output":{"resultWrapper":"ListAllowedNodeTypeModificationsResult","type":"structure","members":{"ScaleUpModifications":{"shape":"S4p"},"ScaleDownModifications":{"shape":"S4p"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{}}},"output":{"shape":"S5","resultWrapper":"ListTagsForResourceResult"}},"ModifyCacheCluster":{"input":{"type":"structure","required":["CacheClusterId"],"members":{"CacheClusterId":{},"NumCacheNodes":{"type":"integer"},"CacheNodeIdsToRemove":{"shape":"S18"},"AZMode":{},"NewAvailabilityZones":{"shape":"Sy"},"CacheSecurityGroupNames":{"shape":"Sz"},"SecurityGroupIds":{"shape":"S10"},"PreferredMaintenanceWindow":{},"NotificationTopicArn":{},"CacheParameterGroupName":{},"NotificationTopicStatus":{},"ApplyImmediately":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"CacheNodeType":{}}},"output":{"resultWrapper":"ModifyCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"S14"}}}},"ModifyCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName","ParameterNameValues"],"members":{"CacheParameterGroupName":{},"ParameterNameValues":{"shape":"S4u"}}},"output":{"shape":"S4w","resultWrapper":"ModifyCacheParameterGroupResult"}},"ModifyCacheSubnetGroup":{"input":{"type":"structure","required":["CacheSubnetGroupName"],"members":{"CacheSubnetGroupName":{},"CacheSubnetGroupDescription":{},"SubnetIds":{"shape":"S1n"}}},"output":{"resultWrapper":"ModifyCacheSubnetGroupResult","type":"structure","members":{"CacheSubnetGroup":{"shape":"S1p"}}}},"ModifyReplicationGroup":{"input":{"type":"structure","required":["ReplicationGroupId"],"members":{"ReplicationGroupId":{},"ReplicationGroupDescription":{},"PrimaryClusterId":{},"SnapshottingClusterId":{},"AutomaticFailoverEnabled":{"type":"boolean"},"CacheSecurityGroupNames":{"shape":"Sz"},"SecurityGroupIds":{"shape":"S10"},"PreferredMaintenanceWindow":{},"NotificationTopicArn":{},"CacheParameterGroupName":{},"NotificationTopicStatus":{},"ApplyImmediately":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"CacheNodeType":{},"NodeGroupId":{"deprecated":true}}},"output":{"resultWrapper":"ModifyReplicationGroupResult","type":"structure","members":{"ReplicationGroup":{"shape":"S1w"}}}},"ModifyReplicationGroupShardConfiguration":{"input":{"type":"structure","required":["ReplicationGroupId","NodeGroupCount","ApplyImmediately"],"members":{"ReplicationGroupId":{},"NodeGroupCount":{"type":"integer"},"ApplyImmediately":{"type":"boolean"},"ReshardingConfiguration":{"type":"list","member":{"locationName":"ReshardingConfiguration","type":"structure","members":{"NodeGroupId":{},"PreferredAvailabilityZones":{"shape":"Sv"}}}},"NodeGroupsToRemove":{"type":"list","member":{"locationName":"NodeGroupToRemove"}},"NodeGroupsToRetain":{"type":"list","member":{"locationName":"NodeGroupToRetain"}}}},"output":{"resultWrapper":"ModifyReplicationGroupShardConfigurationResult","type":"structure","members":{"ReplicationGroup":{"shape":"S1w"}}}},"PurchaseReservedCacheNodesOffering":{"input":{"type":"structure","required":["ReservedCacheNodesOfferingId"],"members":{"ReservedCacheNodesOfferingId":{},"ReservedCacheNodeId":{},"CacheNodeCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedCacheNodesOfferingResult","type":"structure","members":{"ReservedCacheNode":{"shape":"S3q"}}}},"RebootCacheCluster":{"input":{"type":"structure","required":["CacheClusterId","CacheNodeIdsToReboot"],"members":{"CacheClusterId":{},"CacheNodeIdsToReboot":{"shape":"S18"}}},"output":{"resultWrapper":"RebootCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"S14"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}},"output":{"shape":"S5","resultWrapper":"RemoveTagsFromResourceResult"}},"ResetCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName"],"members":{"CacheParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"ParameterNameValues":{"shape":"S4u"}}},"output":{"shape":"S4w","resultWrapper":"ResetCacheParameterGroupResult"}},"RevokeCacheSecurityGroupIngress":{"input":{"type":"structure","required":["CacheSecurityGroupName","EC2SecurityGroupName","EC2SecurityGroupOwnerId"],"members":{"CacheSecurityGroupName":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeCacheSecurityGroupIngressResult","type":"structure","members":{"CacheSecurityGroup":{"shape":"S8"}}}},"TestFailover":{"input":{"type":"structure","required":["ReplicationGroupId","NodeGroupId"],"members":{"ReplicationGroupId":{},"NodeGroupId":{}}},"output":{"resultWrapper":"TestFailoverResult","type":"structure","members":{"ReplicationGroup":{"shape":"S1w"}}}}},"shapes":{"S3":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"S5":{"type":"structure","members":{"TagList":{"shape":"S3"}}},"S8":{"type":"structure","members":{"OwnerId":{},"CacheSecurityGroupName":{},"Description":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}}}},"wrapper":true},"Sc":{"type":"list","member":{}},"Sd":{"type":"structure","members":{"ProcessedUpdateActions":{"type":"list","member":{"locationName":"ProcessedUpdateAction","type":"structure","members":{"ReplicationGroupId":{},"ServiceUpdateName":{},"UpdateActionStatus":{}}}},"UnprocessedUpdateActions":{"type":"list","member":{"locationName":"UnprocessedUpdateAction","type":"structure","members":{"ReplicationGroupId":{},"ServiceUpdateName":{},"ErrorType":{},"ErrorMessage":{}}}}}},"Sm":{"type":"structure","members":{"SnapshotName":{},"ReplicationGroupId":{},"ReplicationGroupDescription":{},"CacheClusterId":{},"SnapshotStatus":{},"SnapshotSource":{},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"NumCacheNodes":{"type":"integer"},"PreferredAvailabilityZone":{},"CacheClusterCreateTime":{"type":"timestamp"},"PreferredMaintenanceWindow":{},"TopicArn":{},"Port":{"type":"integer"},"CacheParameterGroupName":{},"CacheSubnetGroupName":{},"VpcId":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"NumNodeGroups":{"type":"integer"},"AutomaticFailover":{},"NodeSnapshots":{"type":"list","member":{"locationName":"NodeSnapshot","type":"structure","members":{"CacheClusterId":{},"NodeGroupId":{},"CacheNodeId":{},"NodeGroupConfiguration":{"shape":"St"},"CacheSize":{},"CacheNodeCreateTime":{"type":"timestamp"},"SnapshotCreateTime":{"type":"timestamp"}},"wrapper":true}}},"wrapper":true},"St":{"type":"structure","members":{"NodeGroupId":{},"Slots":{},"ReplicaCount":{"type":"integer"},"PrimaryAvailabilityZone":{},"ReplicaAvailabilityZones":{"shape":"Sv"}}},"Sv":{"type":"list","member":{"locationName":"AvailabilityZone"}},"Sy":{"type":"list","member":{"locationName":"PreferredAvailabilityZone"}},"Sz":{"type":"list","member":{"locationName":"CacheSecurityGroupName"}},"S10":{"type":"list","member":{"locationName":"SecurityGroupId"}},"S11":{"type":"list","member":{"locationName":"SnapshotArn"}},"S14":{"type":"structure","members":{"CacheClusterId":{},"ConfigurationEndpoint":{"shape":"S15"},"ClientDownloadLandingPage":{},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"CacheClusterStatus":{},"NumCacheNodes":{"type":"integer"},"PreferredAvailabilityZone":{},"CacheClusterCreateTime":{"type":"timestamp"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"NumCacheNodes":{"type":"integer"},"CacheNodeIdsToRemove":{"shape":"S18"},"EngineVersion":{},"CacheNodeType":{}}},"NotificationConfiguration":{"type":"structure","members":{"TopicArn":{},"TopicStatus":{}}},"CacheSecurityGroups":{"type":"list","member":{"locationName":"CacheSecurityGroup","type":"structure","members":{"CacheSecurityGroupName":{},"Status":{}}}},"CacheParameterGroup":{"type":"structure","members":{"CacheParameterGroupName":{},"ParameterApplyStatus":{},"CacheNodeIdsToReboot":{"shape":"S18"}}},"CacheSubnetGroupName":{},"CacheNodes":{"type":"list","member":{"locationName":"CacheNode","type":"structure","members":{"CacheNodeId":{},"CacheNodeStatus":{},"CacheNodeCreateTime":{"type":"timestamp"},"Endpoint":{"shape":"S15"},"ParameterGroupStatus":{},"SourceCacheNodeId":{},"CustomerAvailabilityZone":{}}}},"AutoMinorVersionUpgrade":{"type":"boolean"},"SecurityGroups":{"type":"list","member":{"type":"structure","members":{"SecurityGroupId":{},"Status":{}}}},"ReplicationGroupId":{},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"AuthTokenEnabled":{"type":"boolean"},"TransitEncryptionEnabled":{"type":"boolean"},"AtRestEncryptionEnabled":{"type":"boolean"}},"wrapper":true},"S15":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"S18":{"type":"list","member":{"locationName":"CacheNodeId"}},"S1j":{"type":"structure","members":{"CacheParameterGroupName":{},"CacheParameterGroupFamily":{},"Description":{}},"wrapper":true},"S1n":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1p":{"type":"structure","members":{"CacheSubnetGroupName":{},"CacheSubnetGroupDescription":{},"VpcId":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"type":"structure","members":{"Name":{}},"wrapper":true}}}}},"wrapper":true},"S1w":{"type":"structure","members":{"ReplicationGroupId":{},"Description":{},"Status":{},"PendingModifiedValues":{"type":"structure","members":{"PrimaryClusterId":{},"AutomaticFailoverStatus":{},"Resharding":{"type":"structure","members":{"SlotMigration":{"type":"structure","members":{"ProgressPercentage":{"type":"double"}}}}}}},"MemberClusters":{"type":"list","member":{"locationName":"ClusterId"}},"NodeGroups":{"type":"list","member":{"locationName":"NodeGroup","type":"structure","members":{"NodeGroupId":{},"Status":{},"PrimaryEndpoint":{"shape":"S15"},"ReaderEndpoint":{"shape":"S15"},"Slots":{},"NodeGroupMembers":{"type":"list","member":{"locationName":"NodeGroupMember","type":"structure","members":{"CacheClusterId":{},"CacheNodeId":{},"ReadEndpoint":{"shape":"S15"},"PreferredAvailabilityZone":{},"CurrentRole":{}}}}}}},"SnapshottingClusterId":{},"AutomaticFailover":{},"ConfigurationEndpoint":{"shape":"S15"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"ClusterEnabled":{"type":"boolean"},"CacheNodeType":{},"AuthTokenEnabled":{"type":"boolean"},"TransitEncryptionEnabled":{"type":"boolean"},"AtRestEncryptionEnabled":{"type":"boolean"}},"wrapper":true},"S2a":{"type":"list","member":{"locationName":"ConfigureShard","type":"structure","required":["NodeGroupId","NewReplicaCount"],"members":{"NodeGroupId":{},"NewReplicaCount":{"type":"integer"},"PreferredAvailabilityZones":{"shape":"Sy"}}}},"S2z":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ChangeType":{}}}},"S32":{"type":"list","member":{"locationName":"CacheNodeTypeSpecificParameter","type":"structure","members":{"ParameterName":{},"Description":{},"Source":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"CacheNodeTypeSpecificValues":{"type":"list","member":{"locationName":"CacheNodeTypeSpecificValue","type":"structure","members":{"CacheNodeType":{},"Value":{}}}},"ChangeType":{}}}},"S3q":{"type":"structure","members":{"ReservedCacheNodeId":{},"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CacheNodeCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"State":{},"RecurringCharges":{"shape":"S3r"},"ReservationARN":{}},"wrapper":true},"S3r":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S3y":{"type":"list","member":{}},"S4p":{"type":"list","member":{}},"S4u":{"type":"list","member":{"locationName":"ParameterNameValue","type":"structure","members":{"ParameterName":{},"ParameterValue":{}}}},"S4w":{"type":"structure","members":{"CacheParameterGroupName":{}}}}}');

});

parcelRequire.register("2HXSZ", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeCacheClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheClusters"},"DescribeCacheEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheEngineVersions"},"DescribeCacheParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheParameterGroups"},"DescribeCacheParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeCacheSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheSecurityGroups"},"DescribeCacheSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeReplicationGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReplicationGroups"},"DescribeReservedCacheNodes":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedCacheNodes"},"DescribeReservedCacheNodesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedCacheNodesOfferings"},"DescribeServiceUpdates":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ServiceUpdates"},"DescribeSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Snapshots"},"DescribeUpdateActions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"UpdateActions"}}}');

});

parcelRequire.register("hmoEa", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"CacheClusterAvailable":{"acceptors":[{"argument":"CacheClusters[].CacheClusterStatus","expected":"available","matcher":"pathAll","state":"success"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"deleted","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"deleting","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"incompatible-network","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"restore-failed","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until ElastiCache cluster is available.","maxAttempts":40,"operation":"DescribeCacheClusters"},"CacheClusterDeleted":{"acceptors":[{"argument":"CacheClusters[].CacheClusterStatus","expected":"deleted","matcher":"pathAll","state":"success"},{"expected":"CacheClusterNotFound","matcher":"error","state":"success"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"available","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"creating","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"incompatible-network","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"modifying","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"restore-failed","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"snapshotting","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until ElastiCache cluster is deleted.","maxAttempts":40,"operation":"DescribeCacheClusters"},"ReplicationGroupAvailable":{"acceptors":[{"argument":"ReplicationGroups[].Status","expected":"available","matcher":"pathAll","state":"success"},{"argument":"ReplicationGroups[].Status","expected":"deleted","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until ElastiCache replication group is available.","maxAttempts":40,"operation":"DescribeReplicationGroups"},"ReplicationGroupDeleted":{"acceptors":[{"argument":"ReplicationGroups[].Status","expected":"deleted","matcher":"pathAll","state":"success"},{"argument":"ReplicationGroups[].Status","expected":"available","matcher":"pathAny","state":"failure"},{"expected":"ReplicationGroupNotFoundFault","matcher":"error","state":"success"}],"delay":15,"description":"Wait until ElastiCache replication group is deleted.","maxAttempts":40,"operation":"DescribeReplicationGroups"}}}');

});


parcelRequire.register("88ZlK", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $5edea8db31db507f$var$Service = $dbC7k.Service;
var $5edea8db31db507f$var$apiLoader = $dbC7k.apiLoader;
$5edea8db31db507f$var$apiLoader.services["elasticbeanstalk"] = {};
$dbC7k.ElasticBeanstalk = $5edea8db31db507f$var$Service.defineService("elasticbeanstalk", [
    "2010-12-01"
]);


Object.defineProperty($5edea8db31db507f$var$apiLoader.services["elasticbeanstalk"], "2010-12-01", {
    get: function get() {
        var model = (parcelRequire("6laZJ"));
        model.paginators = (parcelRequire("gK3On")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ElasticBeanstalk;

});
parcelRequire.register("6laZJ", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2010-12-01","endpointPrefix":"elasticbeanstalk","protocol":"query","serviceAbbreviation":"Elastic Beanstalk","serviceFullName":"AWS Elastic Beanstalk","serviceId":"Elastic Beanstalk","signatureVersion":"v4","uid":"elasticbeanstalk-2010-12-01","xmlNamespace":"http://elasticbeanstalk.amazonaws.com/docs/2010-12-01/"},"operations":{"AbortEnvironmentUpdate":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}}},"ApplyEnvironmentManagedAction":{"input":{"type":"structure","required":["ActionId"],"members":{"EnvironmentName":{},"EnvironmentId":{},"ActionId":{}}},"output":{"resultWrapper":"ApplyEnvironmentManagedActionResult","type":"structure","members":{"ActionId":{},"ActionDescription":{},"ActionType":{},"Status":{}}}},"CheckDNSAvailability":{"input":{"type":"structure","required":["CNAMEPrefix"],"members":{"CNAMEPrefix":{}}},"output":{"resultWrapper":"CheckDNSAvailabilityResult","type":"structure","members":{"Available":{"type":"boolean"},"FullyQualifiedCNAME":{}}}},"ComposeEnvironments":{"input":{"type":"structure","members":{"ApplicationName":{},"GroupName":{},"VersionLabels":{"type":"list","member":{}}}},"output":{"shape":"Si","resultWrapper":"ComposeEnvironmentsResult"}},"CreateApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"Description":{},"ResourceLifecycleConfig":{"shape":"S17"},"Tags":{"shape":"S1d"}}},"output":{"shape":"S1h","resultWrapper":"CreateApplicationResult"}},"CreateApplicationVersion":{"input":{"type":"structure","required":["ApplicationName","VersionLabel"],"members":{"ApplicationName":{},"VersionLabel":{},"Description":{},"SourceBuildInformation":{"shape":"S1n"},"SourceBundle":{"shape":"S1r"},"BuildConfiguration":{"type":"structure","required":["CodeBuildServiceRole","Image"],"members":{"ArtifactName":{},"CodeBuildServiceRole":{},"ComputeType":{},"Image":{},"TimeoutInMinutes":{"type":"integer"}}},"AutoCreateApplication":{"type":"boolean"},"Process":{"type":"boolean"},"Tags":{"shape":"S1d"}}},"output":{"shape":"S1z","resultWrapper":"CreateApplicationVersionResult"}},"CreateConfigurationTemplate":{"input":{"type":"structure","required":["ApplicationName","TemplateName"],"members":{"ApplicationName":{},"TemplateName":{},"SolutionStackName":{},"PlatformArn":{},"SourceConfiguration":{"type":"structure","members":{"ApplicationName":{},"TemplateName":{}}},"EnvironmentId":{},"Description":{},"OptionSettings":{"shape":"S25"},"Tags":{"shape":"S1d"}}},"output":{"shape":"S2b","resultWrapper":"CreateConfigurationTemplateResult"}},"CreateEnvironment":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"EnvironmentName":{},"GroupName":{},"Description":{},"CNAMEPrefix":{},"Tier":{"shape":"S11"},"Tags":{"shape":"S1d"},"VersionLabel":{},"TemplateName":{},"SolutionStackName":{},"PlatformArn":{},"OptionSettings":{"shape":"S25"},"OptionsToRemove":{"shape":"S2e"}}},"output":{"shape":"Sk","resultWrapper":"CreateEnvironmentResult"}},"CreatePlatformVersion":{"input":{"type":"structure","required":["PlatformName","PlatformVersion","PlatformDefinitionBundle"],"members":{"PlatformName":{},"PlatformVersion":{},"PlatformDefinitionBundle":{"shape":"S1r"},"EnvironmentName":{},"OptionSettings":{"shape":"S25"},"Tags":{"shape":"S1d"}}},"output":{"resultWrapper":"CreatePlatformVersionResult","type":"structure","members":{"PlatformSummary":{"shape":"S2k"},"Builder":{"type":"structure","members":{"ARN":{}}}}}},"CreateStorageLocation":{"output":{"resultWrapper":"CreateStorageLocationResult","type":"structure","members":{"S3Bucket":{}}}},"DeleteApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"TerminateEnvByForce":{"type":"boolean"}}}},"DeleteApplicationVersion":{"input":{"type":"structure","required":["ApplicationName","VersionLabel"],"members":{"ApplicationName":{},"VersionLabel":{},"DeleteSourceBundle":{"type":"boolean"}}}},"DeleteConfigurationTemplate":{"input":{"type":"structure","required":["ApplicationName","TemplateName"],"members":{"ApplicationName":{},"TemplateName":{}}}},"DeleteEnvironmentConfiguration":{"input":{"type":"structure","required":["ApplicationName","EnvironmentName"],"members":{"ApplicationName":{},"EnvironmentName":{}}}},"DeletePlatformVersion":{"input":{"type":"structure","members":{"PlatformArn":{}}},"output":{"resultWrapper":"DeletePlatformVersionResult","type":"structure","members":{"PlatformSummary":{"shape":"S2k"}}}},"DescribeAccountAttributes":{"output":{"resultWrapper":"DescribeAccountAttributesResult","type":"structure","members":{"ResourceQuotas":{"type":"structure","members":{"ApplicationQuota":{"shape":"S37"},"ApplicationVersionQuota":{"shape":"S37"},"EnvironmentQuota":{"shape":"S37"},"ConfigurationTemplateQuota":{"shape":"S37"},"CustomPlatformQuota":{"shape":"S37"}}}}}},"DescribeApplicationVersions":{"input":{"type":"structure","members":{"ApplicationName":{},"VersionLabels":{"shape":"S1k"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeApplicationVersionsResult","type":"structure","members":{"ApplicationVersions":{"type":"list","member":{"shape":"S20"}},"NextToken":{}}}},"DescribeApplications":{"input":{"type":"structure","members":{"ApplicationNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeApplicationsResult","type":"structure","members":{"Applications":{"type":"list","member":{"shape":"S1i"}}}}},"DescribeConfigurationOptions":{"input":{"type":"structure","members":{"ApplicationName":{},"TemplateName":{},"EnvironmentName":{},"SolutionStackName":{},"PlatformArn":{},"Options":{"shape":"S2e"}}},"output":{"resultWrapper":"DescribeConfigurationOptionsResult","type":"structure","members":{"SolutionStackName":{},"PlatformArn":{},"Options":{"type":"list","member":{"type":"structure","members":{"Namespace":{},"Name":{},"DefaultValue":{},"ChangeSeverity":{},"UserDefined":{"type":"boolean"},"ValueType":{},"ValueOptions":{"type":"list","member":{}},"MinValue":{"type":"integer"},"MaxValue":{"type":"integer"},"MaxLength":{"type":"integer"},"Regex":{"type":"structure","members":{"Pattern":{},"Label":{}}}}}}}}},"DescribeConfigurationSettings":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"TemplateName":{},"EnvironmentName":{}}},"output":{"resultWrapper":"DescribeConfigurationSettingsResult","type":"structure","members":{"ConfigurationSettings":{"type":"list","member":{"shape":"S2b"}}}}},"DescribeEnvironmentHealth":{"input":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"AttributeNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeEnvironmentHealthResult","type":"structure","members":{"EnvironmentName":{},"HealthStatus":{},"Status":{},"Color":{},"Causes":{"shape":"S43"},"ApplicationMetrics":{"shape":"S45"},"InstancesHealth":{"type":"structure","members":{"NoData":{"type":"integer"},"Unknown":{"type":"integer"},"Pending":{"type":"integer"},"Ok":{"type":"integer"},"Info":{"type":"integer"},"Warning":{"type":"integer"},"Degraded":{"type":"integer"},"Severe":{"type":"integer"}}},"RefreshedAt":{"type":"timestamp"}}}},"DescribeEnvironmentManagedActionHistory":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{},"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"DescribeEnvironmentManagedActionHistoryResult","type":"structure","members":{"ManagedActionHistoryItems":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"ActionType":{},"ActionDescription":{},"FailureType":{},"Status":{},"FailureDescription":{},"ExecutedTime":{"type":"timestamp"},"FinishedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeEnvironmentManagedActions":{"input":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"Status":{}}},"output":{"resultWrapper":"DescribeEnvironmentManagedActionsResult","type":"structure","members":{"ManagedActions":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"ActionDescription":{},"ActionType":{},"Status":{},"WindowStartTime":{"type":"timestamp"}}}}}}},"DescribeEnvironmentResources":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}},"output":{"resultWrapper":"DescribeEnvironmentResourcesResult","type":"structure","members":{"EnvironmentResources":{"type":"structure","members":{"EnvironmentName":{},"AutoScalingGroups":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Instances":{"type":"list","member":{"type":"structure","members":{"Id":{}}}},"LaunchConfigurations":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"LaunchTemplates":{"type":"list","member":{"type":"structure","members":{"Id":{}}}},"LoadBalancers":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Triggers":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Queues":{"type":"list","member":{"type":"structure","members":{"Name":{},"URL":{}}}}}}}}},"DescribeEnvironments":{"input":{"type":"structure","members":{"ApplicationName":{},"VersionLabel":{},"EnvironmentIds":{"type":"list","member":{}},"EnvironmentNames":{"type":"list","member":{}},"IncludeDeleted":{"type":"boolean"},"IncludedDeletedBackTo":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"shape":"Si","resultWrapper":"DescribeEnvironmentsResult"}},"DescribeEvents":{"input":{"type":"structure","members":{"ApplicationName":{},"VersionLabel":{},"TemplateName":{},"EnvironmentId":{},"EnvironmentName":{},"PlatformArn":{},"RequestId":{},"Severity":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Events":{"type":"list","member":{"type":"structure","members":{"EventDate":{"type":"timestamp"},"Message":{},"ApplicationName":{},"VersionLabel":{},"TemplateName":{},"EnvironmentName":{},"PlatformArn":{},"RequestId":{},"Severity":{}}}},"NextToken":{}}}},"DescribeInstancesHealth":{"input":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"AttributeNames":{"type":"list","member":{}},"NextToken":{}}},"output":{"resultWrapper":"DescribeInstancesHealthResult","type":"structure","members":{"InstanceHealthList":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"HealthStatus":{},"Color":{},"Causes":{"shape":"S43"},"LaunchedAt":{"type":"timestamp"},"ApplicationMetrics":{"shape":"S45"},"System":{"type":"structure","members":{"CPUUtilization":{"type":"structure","members":{"User":{"type":"double"},"Nice":{"type":"double"},"System":{"type":"double"},"Idle":{"type":"double"},"IOWait":{"type":"double"},"IRQ":{"type":"double"},"SoftIRQ":{"type":"double"},"Privileged":{"type":"double"}}},"LoadAverage":{"type":"list","member":{"type":"double"}}}},"Deployment":{"type":"structure","members":{"VersionLabel":{},"DeploymentId":{"type":"long"},"Status":{},"DeploymentTime":{"type":"timestamp"}}},"AvailabilityZone":{},"InstanceType":{}}}},"RefreshedAt":{"type":"timestamp"},"NextToken":{}}}},"DescribePlatformVersion":{"input":{"type":"structure","members":{"PlatformArn":{}}},"output":{"resultWrapper":"DescribePlatformVersionResult","type":"structure","members":{"PlatformDescription":{"type":"structure","members":{"PlatformArn":{},"PlatformOwner":{},"PlatformName":{},"PlatformVersion":{},"SolutionStackName":{},"PlatformStatus":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"PlatformCategory":{},"Description":{},"Maintainer":{},"OperatingSystemName":{},"OperatingSystemVersion":{},"ProgrammingLanguages":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{}}}},"Frameworks":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{}}}},"CustomAmiList":{"type":"list","member":{"type":"structure","members":{"VirtualizationType":{},"ImageId":{}}}},"SupportedTierList":{"shape":"S2q"},"SupportedAddonList":{"shape":"S2s"}}}}}},"ListAvailableSolutionStacks":{"output":{"resultWrapper":"ListAvailableSolutionStacksResult","type":"structure","members":{"SolutionStacks":{"type":"list","member":{}},"SolutionStackDetails":{"type":"list","member":{"type":"structure","members":{"SolutionStackName":{},"PermittedFileTypes":{"type":"list","member":{}}}}}}}},"ListPlatformVersions":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"Type":{},"Operator":{},"Values":{"type":"list","member":{}}}}},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"ListPlatformVersionsResult","type":"structure","members":{"PlatformSummaryList":{"type":"list","member":{"shape":"S2k"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"ResourceArn":{},"ResourceTags":{"shape":"S6x"}}}},"RebuildEnvironment":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}}},"RequestEnvironmentInfo":{"input":{"type":"structure","required":["InfoType"],"members":{"EnvironmentId":{},"EnvironmentName":{},"InfoType":{}}}},"RestartAppServer":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}}},"RetrieveEnvironmentInfo":{"input":{"type":"structure","required":["InfoType"],"members":{"EnvironmentId":{},"EnvironmentName":{},"InfoType":{}}},"output":{"resultWrapper":"RetrieveEnvironmentInfoResult","type":"structure","members":{"EnvironmentInfo":{"type":"list","member":{"type":"structure","members":{"InfoType":{},"Ec2InstanceId":{},"SampleTimestamp":{"type":"timestamp"},"Message":{}}}}}}},"SwapEnvironmentCNAMEs":{"input":{"type":"structure","members":{"SourceEnvironmentId":{},"SourceEnvironmentName":{},"DestinationEnvironmentId":{},"DestinationEnvironmentName":{}}}},"TerminateEnvironment":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{},"TerminateResources":{"type":"boolean"},"ForceTerminate":{"type":"boolean"}}},"output":{"shape":"Sk","resultWrapper":"TerminateEnvironmentResult"}},"UpdateApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"Description":{}}},"output":{"shape":"S1h","resultWrapper":"UpdateApplicationResult"}},"UpdateApplicationResourceLifecycle":{"input":{"type":"structure","required":["ApplicationName","ResourceLifecycleConfig"],"members":{"ApplicationName":{},"ResourceLifecycleConfig":{"shape":"S17"}}},"output":{"resultWrapper":"UpdateApplicationResourceLifecycleResult","type":"structure","members":{"ApplicationName":{},"ResourceLifecycleConfig":{"shape":"S17"}}}},"UpdateApplicationVersion":{"input":{"type":"structure","required":["ApplicationName","VersionLabel"],"members":{"ApplicationName":{},"VersionLabel":{},"Description":{}}},"output":{"shape":"S1z","resultWrapper":"UpdateApplicationVersionResult"}},"UpdateConfigurationTemplate":{"input":{"type":"structure","required":["ApplicationName","TemplateName"],"members":{"ApplicationName":{},"TemplateName":{},"Description":{},"OptionSettings":{"shape":"S25"},"OptionsToRemove":{"shape":"S2e"}}},"output":{"shape":"S2b","resultWrapper":"UpdateConfigurationTemplateResult"}},"UpdateEnvironment":{"input":{"type":"structure","members":{"ApplicationName":{},"EnvironmentId":{},"EnvironmentName":{},"GroupName":{},"Description":{},"Tier":{"shape":"S11"},"VersionLabel":{},"TemplateName":{},"SolutionStackName":{},"PlatformArn":{},"OptionSettings":{"shape":"S25"},"OptionsToRemove":{"shape":"S2e"}}},"output":{"shape":"Sk","resultWrapper":"UpdateEnvironmentResult"}},"UpdateTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"TagsToAdd":{"shape":"S6x"},"TagsToRemove":{"type":"list","member":{}}}}},"ValidateConfigurationSettings":{"input":{"type":"structure","required":["ApplicationName","OptionSettings"],"members":{"ApplicationName":{},"TemplateName":{},"EnvironmentName":{},"OptionSettings":{"shape":"S25"}}},"output":{"resultWrapper":"ValidateConfigurationSettingsResult","type":"structure","members":{"Messages":{"type":"list","member":{"type":"structure","members":{"Message":{},"Severity":{},"Namespace":{},"OptionName":{}}}}}}}},"shapes":{"Si":{"type":"structure","members":{"Environments":{"type":"list","member":{"shape":"Sk"}},"NextToken":{}}},"Sk":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"ApplicationName":{},"VersionLabel":{},"SolutionStackName":{},"PlatformArn":{},"TemplateName":{},"Description":{},"EndpointURL":{},"CNAME":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"Status":{},"AbortableOperationInProgress":{"type":"boolean"},"Health":{},"HealthStatus":{},"Resources":{"type":"structure","members":{"LoadBalancer":{"type":"structure","members":{"LoadBalancerName":{},"Domain":{},"Listeners":{"type":"list","member":{"type":"structure","members":{"Protocol":{},"Port":{"type":"integer"}}}}}}}},"Tier":{"shape":"S11"},"EnvironmentLinks":{"type":"list","member":{"type":"structure","members":{"LinkName":{},"EnvironmentName":{}}}},"EnvironmentArn":{}}},"S11":{"type":"structure","members":{"Name":{},"Type":{},"Version":{}}},"S17":{"type":"structure","members":{"ServiceRole":{},"VersionLifecycleConfig":{"type":"structure","members":{"MaxCountRule":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"MaxCount":{"type":"integer"},"DeleteSourceFromS3":{"type":"boolean"}}},"MaxAgeRule":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"MaxAgeInDays":{"type":"integer"},"DeleteSourceFromS3":{"type":"boolean"}}}}}}},"S1d":{"type":"list","member":{"shape":"S1e"}},"S1e":{"type":"structure","members":{"Key":{},"Value":{}}},"S1h":{"type":"structure","members":{"Application":{"shape":"S1i"}}},"S1i":{"type":"structure","members":{"ApplicationArn":{},"ApplicationName":{},"Description":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"Versions":{"shape":"S1k"},"ConfigurationTemplates":{"type":"list","member":{}},"ResourceLifecycleConfig":{"shape":"S17"}}},"S1k":{"type":"list","member":{}},"S1n":{"type":"structure","required":["SourceType","SourceRepository","SourceLocation"],"members":{"SourceType":{},"SourceRepository":{},"SourceLocation":{}}},"S1r":{"type":"structure","members":{"S3Bucket":{},"S3Key":{}}},"S1z":{"type":"structure","members":{"ApplicationVersion":{"shape":"S20"}}},"S20":{"type":"structure","members":{"ApplicationVersionArn":{},"ApplicationName":{},"Description":{},"VersionLabel":{},"SourceBuildInformation":{"shape":"S1n"},"BuildArn":{},"SourceBundle":{"shape":"S1r"},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"Status":{}}},"S25":{"type":"list","member":{"type":"structure","members":{"ResourceName":{},"Namespace":{},"OptionName":{},"Value":{}}}},"S2b":{"type":"structure","members":{"SolutionStackName":{},"PlatformArn":{},"ApplicationName":{},"TemplateName":{},"Description":{},"EnvironmentName":{},"DeploymentStatus":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"OptionSettings":{"shape":"S25"}}},"S2e":{"type":"list","member":{"type":"structure","members":{"ResourceName":{},"Namespace":{},"OptionName":{}}}},"S2k":{"type":"structure","members":{"PlatformArn":{},"PlatformOwner":{},"PlatformStatus":{},"PlatformCategory":{},"OperatingSystemName":{},"OperatingSystemVersion":{},"SupportedTierList":{"shape":"S2q"},"SupportedAddonList":{"shape":"S2s"}}},"S2q":{"type":"list","member":{}},"S2s":{"type":"list","member":{}},"S37":{"type":"structure","members":{"Maximum":{"type":"integer"}}},"S43":{"type":"list","member":{}},"S45":{"type":"structure","members":{"Duration":{"type":"integer"},"RequestCount":{"type":"integer"},"StatusCodes":{"type":"structure","members":{"Status2xx":{"type":"integer"},"Status3xx":{"type":"integer"},"Status4xx":{"type":"integer"},"Status5xx":{"type":"integer"}}},"Latency":{"type":"structure","members":{"P999":{"type":"double"},"P99":{"type":"double"},"P95":{"type":"double"},"P90":{"type":"double"},"P85":{"type":"double"},"P75":{"type":"double"},"P50":{"type":"double"},"P10":{"type":"double"}}}}},"S6x":{"type":"list","member":{"shape":"S1e"}}}}');

});

parcelRequire.register("gK3On", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeApplicationVersions":{"result_key":"ApplicationVersions"},"DescribeApplications":{"result_key":"Applications"},"DescribeConfigurationOptions":{"result_key":"Options"},"DescribeEnvironments":{"result_key":"Environments"},"DescribeEvents":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"Events"},"ListAvailableSolutionStacks":{"result_key":"SolutionStacks"}}}');

});


parcelRequire.register("2d0vs", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $19bd303940584949$var$Service = $dbC7k.Service;
var $19bd303940584949$var$apiLoader = $dbC7k.apiLoader;
$19bd303940584949$var$apiLoader.services["elb"] = {};
$dbC7k.ELB = $19bd303940584949$var$Service.defineService("elb", [
    "2012-06-01"
]);



Object.defineProperty($19bd303940584949$var$apiLoader.services["elb"], "2012-06-01", {
    get: function get() {
        var model = (parcelRequire("l2luV"));
        model.paginators = (parcelRequire("4Wjyc")).pagination;
        model.waiters = (parcelRequire("7IoW5")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ELB;

});
parcelRequire.register("l2luV", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2012-06-01","endpointPrefix":"elasticloadbalancing","protocol":"query","serviceFullName":"Elastic Load Balancing","serviceId":"Elastic Load Balancing","signatureVersion":"v4","uid":"elasticloadbalancing-2012-06-01","xmlNamespace":"http://elasticloadbalancing.amazonaws.com/doc/2012-06-01/"},"operations":{"AddTags":{"input":{"type":"structure","required":["LoadBalancerNames","Tags"],"members":{"LoadBalancerNames":{"shape":"S2"},"Tags":{"shape":"S4"}}},"output":{"resultWrapper":"AddTagsResult","type":"structure","members":{}}},"ApplySecurityGroupsToLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","SecurityGroups"],"members":{"LoadBalancerName":{},"SecurityGroups":{"shape":"Sa"}}},"output":{"resultWrapper":"ApplySecurityGroupsToLoadBalancerResult","type":"structure","members":{"SecurityGroups":{"shape":"Sa"}}}},"AttachLoadBalancerToSubnets":{"input":{"type":"structure","required":["LoadBalancerName","Subnets"],"members":{"LoadBalancerName":{},"Subnets":{"shape":"Se"}}},"output":{"resultWrapper":"AttachLoadBalancerToSubnetsResult","type":"structure","members":{"Subnets":{"shape":"Se"}}}},"ConfigureHealthCheck":{"input":{"type":"structure","required":["LoadBalancerName","HealthCheck"],"members":{"LoadBalancerName":{},"HealthCheck":{"shape":"Si"}}},"output":{"resultWrapper":"ConfigureHealthCheckResult","type":"structure","members":{"HealthCheck":{"shape":"Si"}}}},"CreateAppCookieStickinessPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName","CookieName"],"members":{"LoadBalancerName":{},"PolicyName":{},"CookieName":{}}},"output":{"resultWrapper":"CreateAppCookieStickinessPolicyResult","type":"structure","members":{}}},"CreateLBCookieStickinessPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName"],"members":{"LoadBalancerName":{},"PolicyName":{},"CookieExpirationPeriod":{"type":"long"}}},"output":{"resultWrapper":"CreateLBCookieStickinessPolicyResult","type":"structure","members":{}}},"CreateLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","Listeners"],"members":{"LoadBalancerName":{},"Listeners":{"shape":"Sx"},"AvailabilityZones":{"shape":"S13"},"Subnets":{"shape":"Se"},"SecurityGroups":{"shape":"Sa"},"Scheme":{},"Tags":{"shape":"S4"}}},"output":{"resultWrapper":"CreateLoadBalancerResult","type":"structure","members":{"DNSName":{}}}},"CreateLoadBalancerListeners":{"input":{"type":"structure","required":["LoadBalancerName","Listeners"],"members":{"LoadBalancerName":{},"Listeners":{"shape":"Sx"}}},"output":{"resultWrapper":"CreateLoadBalancerListenersResult","type":"structure","members":{}}},"CreateLoadBalancerPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName","PolicyTypeName"],"members":{"LoadBalancerName":{},"PolicyName":{},"PolicyTypeName":{},"PolicyAttributes":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeValue":{}}}}}},"output":{"resultWrapper":"CreateLoadBalancerPolicyResult","type":"structure","members":{}}},"DeleteLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName"],"members":{"LoadBalancerName":{}}},"output":{"resultWrapper":"DeleteLoadBalancerResult","type":"structure","members":{}}},"DeleteLoadBalancerListeners":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerPorts"],"members":{"LoadBalancerName":{},"LoadBalancerPorts":{"type":"list","member":{"type":"integer"}}}},"output":{"resultWrapper":"DeleteLoadBalancerListenersResult","type":"structure","members":{}}},"DeleteLoadBalancerPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName"],"members":{"LoadBalancerName":{},"PolicyName":{}}},"output":{"resultWrapper":"DeleteLoadBalancerPolicyResult","type":"structure","members":{}}},"DeregisterInstancesFromLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","Instances"],"members":{"LoadBalancerName":{},"Instances":{"shape":"S1p"}}},"output":{"resultWrapper":"DeregisterInstancesFromLoadBalancerResult","type":"structure","members":{"Instances":{"shape":"S1p"}}}},"DescribeAccountLimits":{"input":{"type":"structure","members":{"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"Limits":{"type":"list","member":{"type":"structure","members":{"Name":{},"Max":{}}}},"NextMarker":{}}}},"DescribeInstanceHealth":{"input":{"type":"structure","required":["LoadBalancerName"],"members":{"LoadBalancerName":{},"Instances":{"shape":"S1p"}}},"output":{"resultWrapper":"DescribeInstanceHealthResult","type":"structure","members":{"InstanceStates":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"State":{},"ReasonCode":{},"Description":{}}}}}}},"DescribeLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerName"],"members":{"LoadBalancerName":{}}},"output":{"resultWrapper":"DescribeLoadBalancerAttributesResult","type":"structure","members":{"LoadBalancerAttributes":{"shape":"S2a"}}}},"DescribeLoadBalancerPolicies":{"input":{"type":"structure","members":{"LoadBalancerName":{},"PolicyNames":{"shape":"S2s"}}},"output":{"resultWrapper":"DescribeLoadBalancerPoliciesResult","type":"structure","members":{"PolicyDescriptions":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"PolicyTypeName":{},"PolicyAttributeDescriptions":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeValue":{}}}}}}}}}},"DescribeLoadBalancerPolicyTypes":{"input":{"type":"structure","members":{"PolicyTypeNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeLoadBalancerPolicyTypesResult","type":"structure","members":{"PolicyTypeDescriptions":{"type":"list","member":{"type":"structure","members":{"PolicyTypeName":{},"Description":{},"PolicyAttributeTypeDescriptions":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeType":{},"Description":{},"DefaultValue":{},"Cardinality":{}}}}}}}}}},"DescribeLoadBalancers":{"input":{"type":"structure","members":{"LoadBalancerNames":{"shape":"S2"},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancersResult","type":"structure","members":{"LoadBalancerDescriptions":{"type":"list","member":{"type":"structure","members":{"LoadBalancerName":{},"DNSName":{},"CanonicalHostedZoneName":{},"CanonicalHostedZoneNameID":{},"ListenerDescriptions":{"type":"list","member":{"type":"structure","members":{"Listener":{"shape":"Sy"},"PolicyNames":{"shape":"S2s"}}}},"Policies":{"type":"structure","members":{"AppCookieStickinessPolicies":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"CookieName":{}}}},"LBCookieStickinessPolicies":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"CookieExpirationPeriod":{"type":"long"}}}},"OtherPolicies":{"shape":"S2s"}}},"BackendServerDescriptions":{"type":"list","member":{"type":"structure","members":{"InstancePort":{"type":"integer"},"PolicyNames":{"shape":"S2s"}}}},"AvailabilityZones":{"shape":"S13"},"Subnets":{"shape":"Se"},"VPCId":{},"Instances":{"shape":"S1p"},"HealthCheck":{"shape":"Si"},"SourceSecurityGroup":{"type":"structure","members":{"OwnerAlias":{},"GroupName":{}}},"SecurityGroups":{"shape":"Sa"},"CreatedTime":{"type":"timestamp"},"Scheme":{}}}},"NextMarker":{}}}},"DescribeTags":{"input":{"type":"structure","required":["LoadBalancerNames"],"members":{"LoadBalancerNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"TagDescriptions":{"type":"list","member":{"type":"structure","members":{"LoadBalancerName":{},"Tags":{"shape":"S4"}}}}}}},"DetachLoadBalancerFromSubnets":{"input":{"type":"structure","required":["LoadBalancerName","Subnets"],"members":{"LoadBalancerName":{},"Subnets":{"shape":"Se"}}},"output":{"resultWrapper":"DetachLoadBalancerFromSubnetsResult","type":"structure","members":{"Subnets":{"shape":"Se"}}}},"DisableAvailabilityZonesForLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","AvailabilityZones"],"members":{"LoadBalancerName":{},"AvailabilityZones":{"shape":"S13"}}},"output":{"resultWrapper":"DisableAvailabilityZonesForLoadBalancerResult","type":"structure","members":{"AvailabilityZones":{"shape":"S13"}}}},"EnableAvailabilityZonesForLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","AvailabilityZones"],"members":{"LoadBalancerName":{},"AvailabilityZones":{"shape":"S13"}}},"output":{"resultWrapper":"EnableAvailabilityZonesForLoadBalancerResult","type":"structure","members":{"AvailabilityZones":{"shape":"S13"}}}},"ModifyLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerAttributes"],"members":{"LoadBalancerName":{},"LoadBalancerAttributes":{"shape":"S2a"}}},"output":{"resultWrapper":"ModifyLoadBalancerAttributesResult","type":"structure","members":{"LoadBalancerName":{},"LoadBalancerAttributes":{"shape":"S2a"}}}},"RegisterInstancesWithLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","Instances"],"members":{"LoadBalancerName":{},"Instances":{"shape":"S1p"}}},"output":{"resultWrapper":"RegisterInstancesWithLoadBalancerResult","type":"structure","members":{"Instances":{"shape":"S1p"}}}},"RemoveTags":{"input":{"type":"structure","required":["LoadBalancerNames","Tags"],"members":{"LoadBalancerNames":{"shape":"S2"},"Tags":{"type":"list","member":{"type":"structure","members":{"Key":{}}}}}},"output":{"resultWrapper":"RemoveTagsResult","type":"structure","members":{}}},"SetLoadBalancerListenerSSLCertificate":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerPort","SSLCertificateId"],"members":{"LoadBalancerName":{},"LoadBalancerPort":{"type":"integer"},"SSLCertificateId":{}}},"output":{"resultWrapper":"SetLoadBalancerListenerSSLCertificateResult","type":"structure","members":{}}},"SetLoadBalancerPoliciesForBackendServer":{"input":{"type":"structure","required":["LoadBalancerName","InstancePort","PolicyNames"],"members":{"LoadBalancerName":{},"InstancePort":{"type":"integer"},"PolicyNames":{"shape":"S2s"}}},"output":{"resultWrapper":"SetLoadBalancerPoliciesForBackendServerResult","type":"structure","members":{}}},"SetLoadBalancerPoliciesOfListener":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerPort","PolicyNames"],"members":{"LoadBalancerName":{},"LoadBalancerPort":{"type":"integer"},"PolicyNames":{"shape":"S2s"}}},"output":{"resultWrapper":"SetLoadBalancerPoliciesOfListenerResult","type":"structure","members":{}}}},"shapes":{"S2":{"type":"list","member":{}},"S4":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sa":{"type":"list","member":{}},"Se":{"type":"list","member":{}},"Si":{"type":"structure","required":["Target","Interval","Timeout","UnhealthyThreshold","HealthyThreshold"],"members":{"Target":{},"Interval":{"type":"integer"},"Timeout":{"type":"integer"},"UnhealthyThreshold":{"type":"integer"},"HealthyThreshold":{"type":"integer"}}},"Sx":{"type":"list","member":{"shape":"Sy"}},"Sy":{"type":"structure","required":["Protocol","LoadBalancerPort","InstancePort"],"members":{"Protocol":{},"LoadBalancerPort":{"type":"integer"},"InstanceProtocol":{},"InstancePort":{"type":"integer"},"SSLCertificateId":{}}},"S13":{"type":"list","member":{}},"S1p":{"type":"list","member":{"type":"structure","members":{"InstanceId":{}}}},"S2a":{"type":"structure","members":{"CrossZoneLoadBalancing":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"}}},"AccessLog":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"S3BucketName":{},"EmitInterval":{"type":"integer"},"S3BucketPrefix":{}}},"ConnectionDraining":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"Timeout":{"type":"integer"}}},"ConnectionSettings":{"type":"structure","required":["IdleTimeout"],"members":{"IdleTimeout":{"type":"integer"}}},"AdditionalAttributes":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}},"S2s":{"type":"list","member":{}}}}');

});

parcelRequire.register("4Wjyc", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeInstanceHealth":{"result_key":"InstanceStates"},"DescribeLoadBalancerPolicies":{"result_key":"PolicyDescriptions"},"DescribeLoadBalancerPolicyTypes":{"result_key":"PolicyTypeDescriptions"},"DescribeLoadBalancers":{"input_token":"Marker","output_token":"NextMarker","result_key":"LoadBalancerDescriptions"}}}');

});

parcelRequire.register("7IoW5", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"InstanceDeregistered":{"delay":15,"operation":"DescribeInstanceHealth","maxAttempts":40,"acceptors":[{"expected":"OutOfService","matcher":"pathAll","state":"success","argument":"InstanceStates[].State"},{"matcher":"error","expected":"InvalidInstance","state":"success"}]},"AnyInstanceInService":{"acceptors":[{"argument":"InstanceStates[].State","expected":"InService","matcher":"pathAny","state":"success"}],"delay":15,"maxAttempts":40,"operation":"DescribeInstanceHealth"},"InstanceInService":{"acceptors":[{"argument":"InstanceStates[].State","expected":"InService","matcher":"pathAll","state":"success"},{"matcher":"error","expected":"InvalidInstance","state":"retry"}],"delay":15,"maxAttempts":40,"operation":"DescribeInstanceHealth"}}}');

});


parcelRequire.register("dBnqk", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $9e70e67e950e5844$var$Service = $dbC7k.Service;
var $9e70e67e950e5844$var$apiLoader = $dbC7k.apiLoader;
$9e70e67e950e5844$var$apiLoader.services["elbv2"] = {};
$dbC7k.ELBv2 = $9e70e67e950e5844$var$Service.defineService("elbv2", [
    "2015-12-01"
]);



Object.defineProperty($9e70e67e950e5844$var$apiLoader.services["elbv2"], "2015-12-01", {
    get: function get() {
        var model = (parcelRequire("jdEue"));
        model.paginators = (parcelRequire("9m4Zk")).pagination;
        model.waiters = (parcelRequire("laGVq")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ELBv2;

});
parcelRequire.register("jdEue", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-12-01","endpointPrefix":"elasticloadbalancing","protocol":"query","serviceAbbreviation":"Elastic Load Balancing v2","serviceFullName":"Elastic Load Balancing","serviceId":"Elastic Load Balancing v2","signatureVersion":"v4","uid":"elasticloadbalancingv2-2015-12-01","xmlNamespace":"http://elasticloadbalancing.amazonaws.com/doc/2015-12-01/"},"operations":{"AddListenerCertificates":{"input":{"type":"structure","required":["ListenerArn","Certificates"],"members":{"ListenerArn":{},"Certificates":{"shape":"S3"}}},"output":{"resultWrapper":"AddListenerCertificatesResult","type":"structure","members":{"Certificates":{"shape":"S3"}}}},"AddTags":{"input":{"type":"structure","required":["ResourceArns","Tags"],"members":{"ResourceArns":{"shape":"S9"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"AddTagsResult","type":"structure","members":{}}},"CreateListener":{"input":{"type":"structure","required":["LoadBalancerArn","Protocol","Port","DefaultActions"],"members":{"LoadBalancerArn":{},"Protocol":{},"Port":{"type":"integer"},"SslPolicy":{},"Certificates":{"shape":"S3"},"DefaultActions":{"shape":"Sl"}}},"output":{"resultWrapper":"CreateListenerResult","type":"structure","members":{"Listeners":{"shape":"S1s"}}}},"CreateLoadBalancer":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Subnets":{"shape":"S1w"},"SubnetMappings":{"shape":"S1y"},"SecurityGroups":{"shape":"S21"},"Scheme":{},"Tags":{"shape":"Sb"},"Type":{},"IpAddressType":{}}},"output":{"resultWrapper":"CreateLoadBalancerResult","type":"structure","members":{"LoadBalancers":{"shape":"S27"}}}},"CreateRule":{"input":{"type":"structure","required":["ListenerArn","Conditions","Priority","Actions"],"members":{"ListenerArn":{},"Conditions":{"shape":"S2n"},"Priority":{"type":"integer"},"Actions":{"shape":"Sl"}}},"output":{"resultWrapper":"CreateRuleResult","type":"structure","members":{"Rules":{"shape":"S33"}}}},"CreateTargetGroup":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Protocol":{},"Port":{"type":"integer"},"VpcId":{},"HealthCheckProtocol":{},"HealthCheckPort":{},"HealthCheckEnabled":{"type":"boolean"},"HealthCheckPath":{},"HealthCheckIntervalSeconds":{"type":"integer"},"HealthCheckTimeoutSeconds":{"type":"integer"},"HealthyThresholdCount":{"type":"integer"},"UnhealthyThresholdCount":{"type":"integer"},"Matcher":{"shape":"S3g"},"TargetType":{}}},"output":{"resultWrapper":"CreateTargetGroupResult","type":"structure","members":{"TargetGroups":{"shape":"S3k"}}}},"DeleteListener":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{}}},"output":{"resultWrapper":"DeleteListenerResult","type":"structure","members":{}}},"DeleteLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerArn"],"members":{"LoadBalancerArn":{}}},"output":{"resultWrapper":"DeleteLoadBalancerResult","type":"structure","members":{}}},"DeleteRule":{"input":{"type":"structure","required":["RuleArn"],"members":{"RuleArn":{}}},"output":{"resultWrapper":"DeleteRuleResult","type":"structure","members":{}}},"DeleteTargetGroup":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{}}},"output":{"resultWrapper":"DeleteTargetGroupResult","type":"structure","members":{}}},"DeregisterTargets":{"input":{"type":"structure","required":["TargetGroupArn","Targets"],"members":{"TargetGroupArn":{},"Targets":{"shape":"S3w"}}},"output":{"resultWrapper":"DeregisterTargetsResult","type":"structure","members":{}}},"DescribeAccountLimits":{"input":{"type":"structure","members":{"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"Limits":{"type":"list","member":{"type":"structure","members":{"Name":{},"Max":{}}}},"NextMarker":{}}}},"DescribeListenerCertificates":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeListenerCertificatesResult","type":"structure","members":{"Certificates":{"shape":"S3"},"NextMarker":{}}}},"DescribeListeners":{"input":{"type":"structure","members":{"LoadBalancerArn":{},"ListenerArns":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeListenersResult","type":"structure","members":{"Listeners":{"shape":"S1s"},"NextMarker":{}}}},"DescribeLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerArn"],"members":{"LoadBalancerArn":{}}},"output":{"resultWrapper":"DescribeLoadBalancerAttributesResult","type":"structure","members":{"Attributes":{"shape":"S4f"}}}},"DescribeLoadBalancers":{"input":{"type":"structure","members":{"LoadBalancerArns":{"shape":"S3m"},"Names":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancersResult","type":"structure","members":{"LoadBalancers":{"shape":"S27"},"NextMarker":{}}}},"DescribeRules":{"input":{"type":"structure","members":{"ListenerArn":{},"RuleArns":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeRulesResult","type":"structure","members":{"Rules":{"shape":"S33"},"NextMarker":{}}}},"DescribeSSLPolicies":{"input":{"type":"structure","members":{"Names":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeSSLPoliciesResult","type":"structure","members":{"SslPolicies":{"type":"list","member":{"type":"structure","members":{"SslProtocols":{"type":"list","member":{}},"Ciphers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Priority":{"type":"integer"}}}},"Name":{}}}},"NextMarker":{}}}},"DescribeTags":{"input":{"type":"structure","required":["ResourceArns"],"members":{"ResourceArns":{"shape":"S9"}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"TagDescriptions":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{},"Tags":{"shape":"Sb"}}}}}}},"DescribeTargetGroupAttributes":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{}}},"output":{"resultWrapper":"DescribeTargetGroupAttributesResult","type":"structure","members":{"Attributes":{"shape":"S56"}}}},"DescribeTargetGroups":{"input":{"type":"structure","members":{"LoadBalancerArn":{},"TargetGroupArns":{"type":"list","member":{}},"Names":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeTargetGroupsResult","type":"structure","members":{"TargetGroups":{"shape":"S3k"},"NextMarker":{}}}},"DescribeTargetHealth":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{},"Targets":{"shape":"S3w"}}},"output":{"resultWrapper":"DescribeTargetHealthResult","type":"structure","members":{"TargetHealthDescriptions":{"type":"list","member":{"type":"structure","members":{"Target":{"shape":"S3x"},"HealthCheckPort":{},"TargetHealth":{"type":"structure","members":{"State":{},"Reason":{},"Description":{}}}}}}}}},"ModifyListener":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{},"Port":{"type":"integer"},"Protocol":{},"SslPolicy":{},"Certificates":{"shape":"S3"},"DefaultActions":{"shape":"Sl"}}},"output":{"resultWrapper":"ModifyListenerResult","type":"structure","members":{"Listeners":{"shape":"S1s"}}}},"ModifyLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerArn","Attributes"],"members":{"LoadBalancerArn":{},"Attributes":{"shape":"S4f"}}},"output":{"resultWrapper":"ModifyLoadBalancerAttributesResult","type":"structure","members":{"Attributes":{"shape":"S4f"}}}},"ModifyRule":{"input":{"type":"structure","required":["RuleArn"],"members":{"RuleArn":{},"Conditions":{"shape":"S2n"},"Actions":{"shape":"Sl"}}},"output":{"resultWrapper":"ModifyRuleResult","type":"structure","members":{"Rules":{"shape":"S33"}}}},"ModifyTargetGroup":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{},"HealthCheckProtocol":{},"HealthCheckPort":{},"HealthCheckPath":{},"HealthCheckEnabled":{"type":"boolean"},"HealthCheckIntervalSeconds":{"type":"integer"},"HealthCheckTimeoutSeconds":{"type":"integer"},"HealthyThresholdCount":{"type":"integer"},"UnhealthyThresholdCount":{"type":"integer"},"Matcher":{"shape":"S3g"}}},"output":{"resultWrapper":"ModifyTargetGroupResult","type":"structure","members":{"TargetGroups":{"shape":"S3k"}}}},"ModifyTargetGroupAttributes":{"input":{"type":"structure","required":["TargetGroupArn","Attributes"],"members":{"TargetGroupArn":{},"Attributes":{"shape":"S56"}}},"output":{"resultWrapper":"ModifyTargetGroupAttributesResult","type":"structure","members":{"Attributes":{"shape":"S56"}}}},"RegisterTargets":{"input":{"type":"structure","required":["TargetGroupArn","Targets"],"members":{"TargetGroupArn":{},"Targets":{"shape":"S3w"}}},"output":{"resultWrapper":"RegisterTargetsResult","type":"structure","members":{}}},"RemoveListenerCertificates":{"input":{"type":"structure","required":["ListenerArn","Certificates"],"members":{"ListenerArn":{},"Certificates":{"shape":"S3"}}},"output":{"resultWrapper":"RemoveListenerCertificatesResult","type":"structure","members":{}}},"RemoveTags":{"input":{"type":"structure","required":["ResourceArns","TagKeys"],"members":{"ResourceArns":{"shape":"S9"},"TagKeys":{"type":"list","member":{}}}},"output":{"resultWrapper":"RemoveTagsResult","type":"structure","members":{}}},"SetIpAddressType":{"input":{"type":"structure","required":["LoadBalancerArn","IpAddressType"],"members":{"LoadBalancerArn":{},"IpAddressType":{}}},"output":{"resultWrapper":"SetIpAddressTypeResult","type":"structure","members":{"IpAddressType":{}}}},"SetRulePriorities":{"input":{"type":"structure","required":["RulePriorities"],"members":{"RulePriorities":{"type":"list","member":{"type":"structure","members":{"RuleArn":{},"Priority":{"type":"integer"}}}}}},"output":{"resultWrapper":"SetRulePrioritiesResult","type":"structure","members":{"Rules":{"shape":"S33"}}}},"SetSecurityGroups":{"input":{"type":"structure","required":["LoadBalancerArn","SecurityGroups"],"members":{"LoadBalancerArn":{},"SecurityGroups":{"shape":"S21"}}},"output":{"resultWrapper":"SetSecurityGroupsResult","type":"structure","members":{"SecurityGroupIds":{"shape":"S21"}}}},"SetSubnets":{"input":{"type":"structure","required":["LoadBalancerArn"],"members":{"LoadBalancerArn":{},"Subnets":{"shape":"S1w"},"SubnetMappings":{"shape":"S1y"}}},"output":{"resultWrapper":"SetSubnetsResult","type":"structure","members":{"AvailabilityZones":{"shape":"S2g"}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","members":{"CertificateArn":{},"IsDefault":{"type":"boolean"}}}},"S9":{"type":"list","member":{}},"Sb":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sl":{"type":"list","member":{"type":"structure","required":["Type"],"members":{"Type":{},"TargetGroupArn":{},"AuthenticateOidcConfig":{"type":"structure","required":["Issuer","AuthorizationEndpoint","TokenEndpoint","UserInfoEndpoint","ClientId"],"members":{"Issuer":{},"AuthorizationEndpoint":{},"TokenEndpoint":{},"UserInfoEndpoint":{},"ClientId":{},"ClientSecret":{},"SessionCookieName":{},"Scope":{},"SessionTimeout":{"type":"long"},"AuthenticationRequestExtraParams":{"type":"map","key":{},"value":{}},"OnUnauthenticatedRequest":{},"UseExistingClientSecret":{"type":"boolean"}}},"AuthenticateCognitoConfig":{"type":"structure","required":["UserPoolArn","UserPoolClientId","UserPoolDomain"],"members":{"UserPoolArn":{},"UserPoolClientId":{},"UserPoolDomain":{},"SessionCookieName":{},"Scope":{},"SessionTimeout":{"type":"long"},"AuthenticationRequestExtraParams":{"type":"map","key":{},"value":{}},"OnUnauthenticatedRequest":{}}},"Order":{"type":"integer"},"RedirectConfig":{"type":"structure","required":["StatusCode"],"members":{"Protocol":{},"Port":{},"Host":{},"Path":{},"Query":{},"StatusCode":{}}},"FixedResponseConfig":{"type":"structure","required":["StatusCode"],"members":{"MessageBody":{},"StatusCode":{},"ContentType":{}}}}}},"S1s":{"type":"list","member":{"type":"structure","members":{"ListenerArn":{},"LoadBalancerArn":{},"Port":{"type":"integer"},"Protocol":{},"Certificates":{"shape":"S3"},"SslPolicy":{},"DefaultActions":{"shape":"Sl"}}}},"S1w":{"type":"list","member":{}},"S1y":{"type":"list","member":{"type":"structure","members":{"SubnetId":{},"AllocationId":{}}}},"S21":{"type":"list","member":{}},"S27":{"type":"list","member":{"type":"structure","members":{"LoadBalancerArn":{},"DNSName":{},"CanonicalHostedZoneId":{},"CreatedTime":{"type":"timestamp"},"LoadBalancerName":{},"Scheme":{},"VpcId":{},"State":{"type":"structure","members":{"Code":{},"Reason":{}}},"Type":{},"AvailabilityZones":{"shape":"S2g"},"SecurityGroups":{"shape":"S21"},"IpAddressType":{}}}},"S2g":{"type":"list","member":{"type":"structure","members":{"ZoneName":{},"SubnetId":{},"LoadBalancerAddresses":{"type":"list","member":{"type":"structure","members":{"IpAddress":{},"AllocationId":{}}}}}}},"S2n":{"type":"list","member":{"type":"structure","members":{"Field":{},"Values":{"shape":"S2q"},"HostHeaderConfig":{"type":"structure","members":{"Values":{"shape":"S2q"}}},"PathPatternConfig":{"type":"structure","members":{"Values":{"shape":"S2q"}}},"HttpHeaderConfig":{"type":"structure","members":{"HttpHeaderName":{},"Values":{"shape":"S2q"}}},"QueryStringConfig":{"type":"structure","members":{"Values":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}},"HttpRequestMethodConfig":{"type":"structure","members":{"Values":{"shape":"S2q"}}},"SourceIpConfig":{"type":"structure","members":{"Values":{"shape":"S2q"}}}}}},"S2q":{"type":"list","member":{}},"S33":{"type":"list","member":{"type":"structure","members":{"RuleArn":{},"Priority":{},"Conditions":{"shape":"S2n"},"Actions":{"shape":"Sl"},"IsDefault":{"type":"boolean"}}}},"S3g":{"type":"structure","required":["HttpCode"],"members":{"HttpCode":{}}},"S3k":{"type":"list","member":{"type":"structure","members":{"TargetGroupArn":{},"TargetGroupName":{},"Protocol":{},"Port":{"type":"integer"},"VpcId":{},"HealthCheckProtocol":{},"HealthCheckPort":{},"HealthCheckEnabled":{"type":"boolean"},"HealthCheckIntervalSeconds":{"type":"integer"},"HealthCheckTimeoutSeconds":{"type":"integer"},"HealthyThresholdCount":{"type":"integer"},"UnhealthyThresholdCount":{"type":"integer"},"HealthCheckPath":{},"Matcher":{"shape":"S3g"},"LoadBalancerArns":{"shape":"S3m"},"TargetType":{}}}},"S3m":{"type":"list","member":{}},"S3w":{"type":"list","member":{"shape":"S3x"}},"S3x":{"type":"structure","required":["Id"],"members":{"Id":{},"Port":{"type":"integer"},"AvailabilityZone":{}}},"S4f":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S56":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}');

});

parcelRequire.register("9m4Zk", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeListeners":{"input_token":"Marker","output_token":"NextMarker","result_key":"Listeners"},"DescribeLoadBalancers":{"input_token":"Marker","output_token":"NextMarker","result_key":"LoadBalancers"},"DescribeTargetGroups":{"input_token":"Marker","output_token":"NextMarker","result_key":"TargetGroups"}}}');

});

parcelRequire.register("laGVq", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"LoadBalancerExists":{"delay":15,"operation":"DescribeLoadBalancers","maxAttempts":40,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"LoadBalancerNotFound","state":"retry"}]},"LoadBalancerAvailable":{"delay":15,"operation":"DescribeLoadBalancers","maxAttempts":40,"acceptors":[{"state":"success","matcher":"pathAll","argument":"LoadBalancers[].State.Code","expected":"active"},{"state":"retry","matcher":"pathAny","argument":"LoadBalancers[].State.Code","expected":"provisioning"},{"state":"retry","matcher":"error","expected":"LoadBalancerNotFound"}]},"LoadBalancersDeleted":{"delay":15,"operation":"DescribeLoadBalancers","maxAttempts":40,"acceptors":[{"state":"retry","matcher":"pathAll","argument":"LoadBalancers[].State.Code","expected":"active"},{"matcher":"error","expected":"LoadBalancerNotFound","state":"success"}]},"TargetInService":{"delay":15,"maxAttempts":40,"operation":"DescribeTargetHealth","acceptors":[{"argument":"TargetHealthDescriptions[].TargetHealth.State","expected":"healthy","matcher":"pathAll","state":"success"},{"matcher":"error","expected":"InvalidInstance","state":"retry"}]},"TargetDeregistered":{"delay":15,"maxAttempts":40,"operation":"DescribeTargetHealth","acceptors":[{"matcher":"error","expected":"InvalidTarget","state":"success"},{"argument":"TargetHealthDescriptions[].TargetHealth.State","expected":"unused","matcher":"pathAll","state":"success"}]}}}');

});


parcelRequire.register("ftiKd", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $b4381aae25b9b5c6$var$Service = $dbC7k.Service;
var $b4381aae25b9b5c6$var$apiLoader = $dbC7k.apiLoader;
$b4381aae25b9b5c6$var$apiLoader.services["emr"] = {};
$dbC7k.EMR = $b4381aae25b9b5c6$var$Service.defineService("emr", [
    "2009-03-31"
]);



Object.defineProperty($b4381aae25b9b5c6$var$apiLoader.services["emr"], "2009-03-31", {
    get: function get() {
        var model = (parcelRequire("e1e2s"));
        model.paginators = (parcelRequire("21P7Q")).pagination;
        model.waiters = (parcelRequire("bt3F3")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.EMR;

});
parcelRequire.register("e1e2s", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2009-03-31","endpointPrefix":"elasticmapreduce","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon EMR","serviceFullName":"Amazon Elastic MapReduce","serviceId":"EMR","signatureVersion":"v4","targetPrefix":"ElasticMapReduce","uid":"elasticmapreduce-2009-03-31"},"operations":{"AddInstanceFleet":{"input":{"type":"structure","required":["ClusterId","InstanceFleet"],"members":{"ClusterId":{},"InstanceFleet":{"shape":"S3"}}},"output":{"type":"structure","members":{"ClusterId":{},"InstanceFleetId":{}}}},"AddInstanceGroups":{"input":{"type":"structure","required":["InstanceGroups","JobFlowId"],"members":{"InstanceGroups":{"shape":"Sq"},"JobFlowId":{}}},"output":{"type":"structure","members":{"JobFlowId":{},"InstanceGroupIds":{"type":"list","member":{}}}}},"AddJobFlowSteps":{"input":{"type":"structure","required":["JobFlowId","Steps"],"members":{"JobFlowId":{},"Steps":{"shape":"S1b"}}},"output":{"type":"structure","members":{"StepIds":{"shape":"S1k"}}}},"AddTags":{"input":{"type":"structure","required":["ResourceId","Tags"],"members":{"ResourceId":{},"Tags":{"shape":"S1n"}}},"output":{"type":"structure","members":{}}},"CancelSteps":{"input":{"type":"structure","members":{"ClusterId":{},"StepIds":{"shape":"S1k"}}},"output":{"type":"structure","members":{"CancelStepsInfoList":{"type":"list","member":{"type":"structure","members":{"StepId":{},"Status":{},"Reason":{}}}}}}},"CreateSecurityConfiguration":{"input":{"type":"structure","required":["Name","SecurityConfiguration"],"members":{"Name":{},"SecurityConfiguration":{}}},"output":{"type":"structure","required":["Name","CreationDateTime"],"members":{"Name":{},"CreationDateTime":{"type":"timestamp"}}}},"DeleteSecurityConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DescribeCluster":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{"Cluster":{"type":"structure","members":{"Id":{},"Name":{},"Status":{"shape":"S25"},"Ec2InstanceAttributes":{"type":"structure","members":{"Ec2KeyName":{},"Ec2SubnetId":{},"RequestedEc2SubnetIds":{"shape":"S2b"},"Ec2AvailabilityZone":{},"RequestedEc2AvailabilityZones":{"shape":"S2b"},"IamInstanceProfile":{},"EmrManagedMasterSecurityGroup":{},"EmrManagedSlaveSecurityGroup":{},"ServiceAccessSecurityGroup":{},"AdditionalMasterSecurityGroups":{"shape":"S2c"},"AdditionalSlaveSecurityGroups":{"shape":"S2c"}}},"InstanceCollectionType":{},"LogUri":{},"RequestedAmiVersion":{},"RunningAmiVersion":{},"ReleaseLabel":{},"AutoTerminate":{"type":"boolean"},"TerminationProtected":{"type":"boolean"},"VisibleToAllUsers":{"type":"boolean"},"Applications":{"shape":"S2f"},"Tags":{"shape":"S1n"},"ServiceRole":{},"NormalizedInstanceHours":{"type":"integer"},"MasterPublicDnsName":{},"Configurations":{"shape":"Sh"},"SecurityConfiguration":{},"AutoScalingRole":{},"ScaleDownBehavior":{},"CustomAmiId":{},"EbsRootVolumeSize":{"type":"integer"},"RepoUpgradeOnBoot":{},"KerberosAttributes":{"shape":"S2j"}}}}}},"DescribeJobFlows":{"input":{"type":"structure","members":{"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"JobFlowIds":{"shape":"S1i"},"JobFlowStates":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"JobFlows":{"type":"list","member":{"type":"structure","required":["JobFlowId","Name","ExecutionStatusDetail","Instances"],"members":{"JobFlowId":{},"Name":{},"LogUri":{},"AmiVersion":{},"ExecutionStatusDetail":{"type":"structure","required":["State","CreationDateTime"],"members":{"State":{},"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"},"LastStateChangeReason":{}}},"Instances":{"type":"structure","required":["MasterInstanceType","SlaveInstanceType","InstanceCount"],"members":{"MasterInstanceType":{},"MasterPublicDnsName":{},"MasterInstanceId":{},"SlaveInstanceType":{},"InstanceCount":{"type":"integer"},"InstanceGroups":{"type":"list","member":{"type":"structure","required":["Market","InstanceRole","InstanceType","InstanceRequestCount","InstanceRunningCount","State","CreationDateTime"],"members":{"InstanceGroupId":{},"Name":{},"Market":{},"InstanceRole":{},"BidPrice":{},"InstanceType":{},"InstanceRequestCount":{"type":"integer"},"InstanceRunningCount":{"type":"integer"},"State":{},"LastStateChangeReason":{},"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}},"NormalizedInstanceHours":{"type":"integer"},"Ec2KeyName":{},"Ec2SubnetId":{},"Placement":{"shape":"S2v"},"KeepJobFlowAliveWhenNoSteps":{"type":"boolean"},"TerminationProtected":{"type":"boolean"},"HadoopVersion":{}}},"Steps":{"type":"list","member":{"type":"structure","required":["StepConfig","ExecutionStatusDetail"],"members":{"StepConfig":{"shape":"S1c"},"ExecutionStatusDetail":{"type":"structure","required":["State","CreationDateTime"],"members":{"State":{},"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"},"LastStateChangeReason":{}}}}}},"BootstrapActions":{"type":"list","member":{"type":"structure","members":{"BootstrapActionConfig":{"shape":"S32"}}}},"SupportedProducts":{"shape":"S34"},"VisibleToAllUsers":{"type":"boolean"},"JobFlowRole":{},"ServiceRole":{},"AutoScalingRole":{},"ScaleDownBehavior":{}}}}}},"deprecated":true},"DescribeSecurityConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"SecurityConfiguration":{},"CreationDateTime":{"type":"timestamp"}}}},"DescribeStep":{"input":{"type":"structure","required":["ClusterId","StepId"],"members":{"ClusterId":{},"StepId":{}}},"output":{"type":"structure","members":{"Step":{"type":"structure","members":{"Id":{},"Name":{},"Config":{"shape":"S3a"},"ActionOnFailure":{},"Status":{"shape":"S3b"}}}}}},"GetBlockPublicAccessConfiguration":{"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["BlockPublicAccessConfiguration","BlockPublicAccessConfigurationMetadata"],"members":{"BlockPublicAccessConfiguration":{"shape":"S3j"},"BlockPublicAccessConfigurationMetadata":{"type":"structure","required":["CreationDateTime","CreatedByArn"],"members":{"CreationDateTime":{"type":"timestamp"},"CreatedByArn":{}}}}}},"ListBootstrapActions":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"Marker":{}}},"output":{"type":"structure","members":{"BootstrapActions":{"type":"list","member":{"type":"structure","members":{"Name":{},"ScriptPath":{},"Args":{"shape":"S2c"}}}},"Marker":{}}}},"ListClusters":{"input":{"type":"structure","members":{"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"ClusterStates":{"type":"list","member":{}},"Marker":{}}},"output":{"type":"structure","members":{"Clusters":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Status":{"shape":"S25"},"NormalizedInstanceHours":{"type":"integer"}}}},"Marker":{}}}},"ListInstanceFleets":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"Marker":{}}},"output":{"type":"structure","members":{"InstanceFleets":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"InstanceFleetType":{},"TargetOnDemandCapacity":{"type":"integer"},"TargetSpotCapacity":{"type":"integer"},"ProvisionedOnDemandCapacity":{"type":"integer"},"ProvisionedSpotCapacity":{"type":"integer"},"InstanceTypeSpecifications":{"type":"list","member":{"type":"structure","members":{"InstanceType":{},"WeightedCapacity":{"type":"integer"},"BidPrice":{},"BidPriceAsPercentageOfOnDemandPrice":{"type":"double"},"Configurations":{"shape":"Sh"},"EbsBlockDevices":{"shape":"S4a"},"EbsOptimized":{"type":"boolean"}}}},"LaunchSpecifications":{"shape":"Sk"}}}},"Marker":{}}}},"ListInstanceGroups":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"Marker":{}}},"output":{"type":"structure","members":{"InstanceGroups":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Market":{},"InstanceGroupType":{},"BidPrice":{},"InstanceType":{},"RequestedInstanceCount":{"type":"integer"},"RunningInstanceCount":{"type":"integer"},"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"Configurations":{"shape":"Sh"},"ConfigurationsVersion":{"type":"long"},"LastSuccessfullyAppliedConfigurations":{"shape":"Sh"},"LastSuccessfullyAppliedConfigurationsVersion":{"type":"long"},"EbsBlockDevices":{"shape":"S4a"},"EbsOptimized":{"type":"boolean"},"ShrinkPolicy":{"shape":"S4n"},"AutoScalingPolicy":{"shape":"S4r"}}}},"Marker":{}}}},"ListInstances":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"InstanceGroupId":{},"InstanceGroupTypes":{"type":"list","member":{}},"InstanceFleetId":{},"InstanceFleetType":{},"InstanceStates":{"type":"list","member":{}},"Marker":{}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"Id":{},"Ec2InstanceId":{},"PublicDnsName":{},"PublicIpAddress":{},"PrivateDnsName":{},"PrivateIpAddress":{},"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"InstanceGroupId":{},"InstanceFleetId":{},"Market":{},"InstanceType":{},"EbsVolumes":{"type":"list","member":{"type":"structure","members":{"Device":{},"VolumeId":{}}}}}}},"Marker":{}}}},"ListSecurityConfigurations":{"input":{"type":"structure","members":{"Marker":{}}},"output":{"type":"structure","members":{"SecurityConfigurations":{"type":"list","member":{"type":"structure","members":{"Name":{},"CreationDateTime":{"type":"timestamp"}}}},"Marker":{}}}},"ListSteps":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"StepStates":{"type":"list","member":{}},"StepIds":{"shape":"S1i"},"Marker":{}}},"output":{"type":"structure","members":{"Steps":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Config":{"shape":"S3a"},"ActionOnFailure":{},"Status":{"shape":"S3b"}}}},"Marker":{}}}},"ModifyInstanceFleet":{"input":{"type":"structure","required":["ClusterId","InstanceFleet"],"members":{"ClusterId":{},"InstanceFleet":{"type":"structure","required":["InstanceFleetId"],"members":{"InstanceFleetId":{},"TargetOnDemandCapacity":{"type":"integer"},"TargetSpotCapacity":{"type":"integer"}}}}}},"ModifyInstanceGroups":{"input":{"type":"structure","members":{"ClusterId":{},"InstanceGroups":{"type":"list","member":{"type":"structure","required":["InstanceGroupId"],"members":{"InstanceGroupId":{},"InstanceCount":{"type":"integer"},"EC2InstanceIdsToTerminate":{"type":"list","member":{}},"ShrinkPolicy":{"shape":"S4n"},"Configurations":{"shape":"Sh"}}}}}}},"PutAutoScalingPolicy":{"input":{"type":"structure","required":["ClusterId","InstanceGroupId","AutoScalingPolicy"],"members":{"ClusterId":{},"InstanceGroupId":{},"AutoScalingPolicy":{"shape":"Su"}}},"output":{"type":"structure","members":{"ClusterId":{},"InstanceGroupId":{},"AutoScalingPolicy":{"shape":"S4r"}}}},"PutBlockPublicAccessConfiguration":{"input":{"type":"structure","required":["BlockPublicAccessConfiguration"],"members":{"BlockPublicAccessConfiguration":{"shape":"S3j"}}},"output":{"type":"structure","members":{}}},"RemoveAutoScalingPolicy":{"input":{"type":"structure","required":["ClusterId","InstanceGroupId"],"members":{"ClusterId":{},"InstanceGroupId":{}}},"output":{"type":"structure","members":{}}},"RemoveTags":{"input":{"type":"structure","required":["ResourceId","TagKeys"],"members":{"ResourceId":{},"TagKeys":{"shape":"S2c"}}},"output":{"type":"structure","members":{}}},"RunJobFlow":{"input":{"type":"structure","required":["Name","Instances"],"members":{"Name":{},"LogUri":{},"AdditionalInfo":{},"AmiVersion":{},"ReleaseLabel":{},"Instances":{"type":"structure","members":{"MasterInstanceType":{},"SlaveInstanceType":{},"InstanceCount":{"type":"integer"},"InstanceGroups":{"shape":"Sq"},"InstanceFleets":{"type":"list","member":{"shape":"S3"}},"Ec2KeyName":{},"Placement":{"shape":"S2v"},"KeepJobFlowAliveWhenNoSteps":{"type":"boolean"},"TerminationProtected":{"type":"boolean"},"HadoopVersion":{},"Ec2SubnetId":{},"Ec2SubnetIds":{"shape":"S2b"},"EmrManagedMasterSecurityGroup":{},"EmrManagedSlaveSecurityGroup":{},"ServiceAccessSecurityGroup":{},"AdditionalMasterSecurityGroups":{"shape":"S5z"},"AdditionalSlaveSecurityGroups":{"shape":"S5z"}}},"Steps":{"shape":"S1b"},"BootstrapActions":{"type":"list","member":{"shape":"S32"}},"SupportedProducts":{"shape":"S34"},"NewSupportedProducts":{"type":"list","member":{"type":"structure","members":{"Name":{},"Args":{"shape":"S1i"}}}},"Applications":{"shape":"S2f"},"Configurations":{"shape":"Sh"},"VisibleToAllUsers":{"type":"boolean"},"JobFlowRole":{},"ServiceRole":{},"Tags":{"shape":"S1n"},"SecurityConfiguration":{},"AutoScalingRole":{},"ScaleDownBehavior":{},"CustomAmiId":{},"EbsRootVolumeSize":{"type":"integer"},"RepoUpgradeOnBoot":{},"KerberosAttributes":{"shape":"S2j"}}},"output":{"type":"structure","members":{"JobFlowId":{}}}},"SetTerminationProtection":{"input":{"type":"structure","required":["JobFlowIds","TerminationProtected"],"members":{"JobFlowIds":{"shape":"S1i"},"TerminationProtected":{"type":"boolean"}}}},"SetVisibleToAllUsers":{"input":{"type":"structure","required":["JobFlowIds","VisibleToAllUsers"],"members":{"JobFlowIds":{"shape":"S1i"},"VisibleToAllUsers":{"type":"boolean"}}}},"TerminateJobFlows":{"input":{"type":"structure","required":["JobFlowIds"],"members":{"JobFlowIds":{"shape":"S1i"}}}}},"shapes":{"S3":{"type":"structure","required":["InstanceFleetType"],"members":{"Name":{},"InstanceFleetType":{},"TargetOnDemandCapacity":{"type":"integer"},"TargetSpotCapacity":{"type":"integer"},"InstanceTypeConfigs":{"type":"list","member":{"type":"structure","required":["InstanceType"],"members":{"InstanceType":{},"WeightedCapacity":{"type":"integer"},"BidPrice":{},"BidPriceAsPercentageOfOnDemandPrice":{"type":"double"},"EbsConfiguration":{"shape":"Sa"},"Configurations":{"shape":"Sh"}}}},"LaunchSpecifications":{"shape":"Sk"}}},"Sa":{"type":"structure","members":{"EbsBlockDeviceConfigs":{"type":"list","member":{"type":"structure","required":["VolumeSpecification"],"members":{"VolumeSpecification":{"shape":"Sd"},"VolumesPerInstance":{"type":"integer"}}}},"EbsOptimized":{"type":"boolean"}}},"Sd":{"type":"structure","required":["VolumeType","SizeInGB"],"members":{"VolumeType":{},"Iops":{"type":"integer"},"SizeInGB":{"type":"integer"}}},"Sh":{"type":"list","member":{"type":"structure","members":{"Classification":{},"Configurations":{"shape":"Sh"},"Properties":{"shape":"Sj"}}}},"Sj":{"type":"map","key":{},"value":{}},"Sk":{"type":"structure","required":["SpotSpecification"],"members":{"SpotSpecification":{"type":"structure","required":["TimeoutDurationMinutes","TimeoutAction"],"members":{"TimeoutDurationMinutes":{"type":"integer"},"TimeoutAction":{},"BlockDurationMinutes":{"type":"integer"}}}}},"Sq":{"type":"list","member":{"type":"structure","required":["InstanceRole","InstanceType","InstanceCount"],"members":{"Name":{},"Market":{},"InstanceRole":{},"BidPrice":{},"InstanceType":{},"InstanceCount":{"type":"integer"},"Configurations":{"shape":"Sh"},"EbsConfiguration":{"shape":"Sa"},"AutoScalingPolicy":{"shape":"Su"}}}},"Su":{"type":"structure","required":["Constraints","Rules"],"members":{"Constraints":{"shape":"Sv"},"Rules":{"shape":"Sw"}}},"Sv":{"type":"structure","required":["MinCapacity","MaxCapacity"],"members":{"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"}}},"Sw":{"type":"list","member":{"type":"structure","required":["Name","Action","Trigger"],"members":{"Name":{},"Description":{},"Action":{"type":"structure","required":["SimpleScalingPolicyConfiguration"],"members":{"Market":{},"SimpleScalingPolicyConfiguration":{"type":"structure","required":["ScalingAdjustment"],"members":{"AdjustmentType":{},"ScalingAdjustment":{"type":"integer"},"CoolDown":{"type":"integer"}}}}},"Trigger":{"type":"structure","required":["CloudWatchAlarmDefinition"],"members":{"CloudWatchAlarmDefinition":{"type":"structure","required":["ComparisonOperator","MetricName","Period","Threshold"],"members":{"ComparisonOperator":{},"EvaluationPeriods":{"type":"integer"},"MetricName":{},"Namespace":{},"Period":{"type":"integer"},"Statistic":{},"Threshold":{"type":"double"},"Unit":{},"Dimensions":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}}}}}},"S1b":{"type":"list","member":{"shape":"S1c"}},"S1c":{"type":"structure","required":["Name","HadoopJarStep"],"members":{"Name":{},"ActionOnFailure":{},"HadoopJarStep":{"type":"structure","required":["Jar"],"members":{"Properties":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Jar":{},"MainClass":{},"Args":{"shape":"S1i"}}}}},"S1i":{"type":"list","member":{}},"S1k":{"type":"list","member":{}},"S1n":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S25":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"S2b":{"type":"list","member":{}},"S2c":{"type":"list","member":{}},"S2f":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{},"Args":{"shape":"S2c"},"AdditionalInfo":{"shape":"Sj"}}}},"S2j":{"type":"structure","required":["Realm","KdcAdminPassword"],"members":{"Realm":{},"KdcAdminPassword":{},"CrossRealmTrustPrincipalPassword":{},"ADDomainJoinUser":{},"ADDomainJoinPassword":{}}},"S2v":{"type":"structure","members":{"AvailabilityZone":{},"AvailabilityZones":{"shape":"S2b"}}},"S32":{"type":"structure","required":["Name","ScriptBootstrapAction"],"members":{"Name":{},"ScriptBootstrapAction":{"type":"structure","required":["Path"],"members":{"Path":{},"Args":{"shape":"S1i"}}}}},"S34":{"type":"list","member":{}},"S3a":{"type":"structure","members":{"Jar":{},"Properties":{"shape":"Sj"},"MainClass":{},"Args":{"shape":"S2c"}}},"S3b":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"FailureDetails":{"type":"structure","members":{"Reason":{},"Message":{},"LogFile":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"S3j":{"type":"structure","required":["BlockPublicSecurityGroupRules"],"members":{"BlockPublicSecurityGroupRules":{"type":"boolean"},"PermittedPublicSecurityGroupRuleRanges":{"type":"list","member":{"type":"structure","required":["MinRange"],"members":{"MinRange":{"type":"integer"},"MaxRange":{"type":"integer"}}}}}},"S4a":{"type":"list","member":{"type":"structure","members":{"VolumeSpecification":{"shape":"Sd"},"Device":{}}}},"S4n":{"type":"structure","members":{"DecommissionTimeout":{"type":"integer"},"InstanceResizePolicy":{"type":"structure","members":{"InstancesToTerminate":{"shape":"S4p"},"InstancesToProtect":{"shape":"S4p"},"InstanceTerminationTimeout":{"type":"integer"}}}}},"S4p":{"type":"list","member":{}},"S4r":{"type":"structure","members":{"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}}}},"Constraints":{"shape":"Sv"},"Rules":{"shape":"Sw"}}},"S5z":{"type":"list","member":{}}}}');

});

parcelRequire.register("21P7Q", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeJobFlows":{"result_key":"JobFlows"},"ListBootstrapActions":{"input_token":"Marker","output_token":"Marker","result_key":"BootstrapActions"},"ListClusters":{"input_token":"Marker","output_token":"Marker","result_key":"Clusters"},"ListInstanceFleets":{"input_token":"Marker","output_token":"Marker","result_key":"InstanceFleets"},"ListInstanceGroups":{"input_token":"Marker","output_token":"Marker","result_key":"InstanceGroups"},"ListInstances":{"input_token":"Marker","output_token":"Marker","result_key":"Instances"},"ListSecurityConfigurations":{"input_token":"Marker","output_token":"Marker","result_key":"SecurityConfigurations"},"ListSteps":{"input_token":"Marker","output_token":"Marker","result_key":"Steps"}}}');

});

parcelRequire.register("bt3F3", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"ClusterRunning":{"delay":30,"operation":"DescribeCluster","maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"Cluster.Status.State","expected":"RUNNING"},{"state":"success","matcher":"path","argument":"Cluster.Status.State","expected":"WAITING"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATING"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED_WITH_ERRORS"}]},"StepComplete":{"delay":30,"operation":"DescribeStep","maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"Step.Status.State","expected":"COMPLETED"},{"state":"failure","matcher":"path","argument":"Step.Status.State","expected":"FAILED"},{"state":"failure","matcher":"path","argument":"Step.Status.State","expected":"CANCELLED"}]},"ClusterTerminated":{"delay":30,"operation":"DescribeCluster","maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED_WITH_ERRORS"}]}}}');

});


parcelRequire.register("833Tl", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $5dc19f54fd065f12$var$Service = $dbC7k.Service;
var $5dc19f54fd065f12$var$apiLoader = $dbC7k.apiLoader;
$5dc19f54fd065f12$var$apiLoader.services["es"] = {};
$dbC7k.ES = $5dc19f54fd065f12$var$Service.defineService("es", [
    "2015-01-01"
]);


Object.defineProperty($5dc19f54fd065f12$var$apiLoader.services["es"], "2015-01-01", {
    get: function get() {
        var model = (parcelRequire("gtltv"));
        model.paginators = (parcelRequire("a9IxJ")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ES;

});
parcelRequire.register("gtltv", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-01-01","endpointPrefix":"es","protocol":"rest-json","serviceFullName":"Amazon Elasticsearch Service","serviceId":"Elasticsearch Service","signatureVersion":"v4","uid":"es-2015-01-01"},"operations":{"AddTags":{"http":{"requestUri":"/2015-01-01/tags"},"input":{"type":"structure","required":["ARN","TagList"],"members":{"ARN":{},"TagList":{"shape":"S3"}}}},"CancelElasticsearchServiceSoftwareUpdate":{"http":{"requestUri":"/2015-01-01/es/serviceSoftwareUpdate/cancel"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{"ServiceSoftwareOptions":{"shape":"Sa"}}}},"CreateElasticsearchDomain":{"http":{"requestUri":"/2015-01-01/es/domain"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"ElasticsearchVersion":{},"ElasticsearchClusterConfig":{"shape":"Sh"},"EBSOptions":{"shape":"Sl"},"AccessPolicies":{},"SnapshotOptions":{"shape":"So"},"VPCOptions":{"shape":"Sp"},"CognitoOptions":{"shape":"Sr"},"EncryptionAtRestOptions":{"shape":"Sv"},"NodeToNodeEncryptionOptions":{"shape":"Sx"},"AdvancedOptions":{"shape":"Sy"},"LogPublishingOptions":{"shape":"Sz"}}},"output":{"type":"structure","members":{"DomainStatus":{"shape":"S14"}}}},"DeleteElasticsearchDomain":{"http":{"method":"DELETE","requestUri":"/2015-01-01/es/domain/{DomainName}"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","members":{"DomainStatus":{"shape":"S14"}}}},"DeleteElasticsearchServiceRole":{"http":{"method":"DELETE","requestUri":"/2015-01-01/es/role"}},"DescribeElasticsearchDomain":{"http":{"method":"GET","requestUri":"/2015-01-01/es/domain/{DomainName}"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","required":["DomainStatus"],"members":{"DomainStatus":{"shape":"S14"}}}},"DescribeElasticsearchDomainConfig":{"http":{"method":"GET","requestUri":"/2015-01-01/es/domain/{DomainName}/config"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","required":["DomainConfig"],"members":{"DomainConfig":{"shape":"S1f"}}}},"DescribeElasticsearchDomains":{"http":{"requestUri":"/2015-01-01/es/domain-info"},"input":{"type":"structure","required":["DomainNames"],"members":{"DomainNames":{"type":"list","member":{}}}},"output":{"type":"structure","required":["DomainStatusList"],"members":{"DomainStatusList":{"type":"list","member":{"shape":"S14"}}}}},"DescribeElasticsearchInstanceTypeLimits":{"http":{"method":"GET","requestUri":"/2015-01-01/es/instanceTypeLimits/{ElasticsearchVersion}/{InstanceType}"},"input":{"type":"structure","required":["InstanceType","ElasticsearchVersion"],"members":{"DomainName":{"location":"querystring","locationName":"domainName"},"InstanceType":{"location":"uri","locationName":"InstanceType"},"ElasticsearchVersion":{"location":"uri","locationName":"ElasticsearchVersion"}}},"output":{"type":"structure","members":{"LimitsByRole":{"type":"map","key":{},"value":{"type":"structure","members":{"StorageTypes":{"type":"list","member":{"type":"structure","members":{"StorageTypeName":{},"StorageSubTypeName":{},"StorageTypeLimits":{"type":"list","member":{"type":"structure","members":{"LimitName":{},"LimitValues":{"shape":"S2b"}}}}}}},"InstanceLimits":{"type":"structure","members":{"InstanceCountLimits":{"type":"structure","members":{"MinimumInstanceCount":{"type":"integer"},"MaximumInstanceCount":{"type":"integer"}}}}},"AdditionalLimits":{"type":"list","member":{"type":"structure","members":{"LimitName":{},"LimitValues":{"shape":"S2b"}}}}}}}}}},"DescribeReservedElasticsearchInstanceOfferings":{"http":{"method":"GET","requestUri":"/2015-01-01/es/reservedInstanceOfferings"},"input":{"type":"structure","members":{"ReservedElasticsearchInstanceOfferingId":{"location":"querystring","locationName":"offeringId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{},"ReservedElasticsearchInstanceOfferings":{"type":"list","member":{"type":"structure","members":{"ReservedElasticsearchInstanceOfferingId":{},"ElasticsearchInstanceType":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"PaymentOption":{},"RecurringCharges":{"shape":"S2t"}}}}}}},"DescribeReservedElasticsearchInstances":{"http":{"method":"GET","requestUri":"/2015-01-01/es/reservedInstances"},"input":{"type":"structure","members":{"ReservedElasticsearchInstanceId":{"location":"querystring","locationName":"reservationId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{},"ReservedElasticsearchInstances":{"type":"list","member":{"type":"structure","members":{"ReservationName":{},"ReservedElasticsearchInstanceId":{},"ReservedElasticsearchInstanceOfferingId":{},"ElasticsearchInstanceType":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ElasticsearchInstanceCount":{"type":"integer"},"State":{},"PaymentOption":{},"RecurringCharges":{"shape":"S2t"}}}}}}},"GetCompatibleElasticsearchVersions":{"http":{"method":"GET","requestUri":"/2015-01-01/es/compatibleVersions"},"input":{"type":"structure","members":{"DomainName":{"location":"querystring","locationName":"domainName"}}},"output":{"type":"structure","members":{"CompatibleElasticsearchVersions":{"type":"list","member":{"type":"structure","members":{"SourceVersion":{},"TargetVersions":{"shape":"S34"}}}}}}},"GetUpgradeHistory":{"http":{"method":"GET","requestUri":"/2015-01-01/es/upgradeDomain/{DomainName}/history"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"UpgradeHistories":{"type":"list","member":{"type":"structure","members":{"UpgradeName":{},"StartTimestamp":{"type":"timestamp"},"UpgradeStatus":{},"StepsList":{"type":"list","member":{"type":"structure","members":{"UpgradeStep":{},"UpgradeStepStatus":{},"Issues":{"type":"list","member":{}},"ProgressPercent":{"type":"double"}}}}}}},"NextToken":{}}}},"GetUpgradeStatus":{"http":{"method":"GET","requestUri":"/2015-01-01/es/upgradeDomain/{DomainName}/status"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"}}},"output":{"type":"structure","members":{"UpgradeStep":{},"StepStatus":{},"UpgradeName":{}}}},"ListDomainNames":{"http":{"method":"GET","requestUri":"/2015-01-01/domain"},"output":{"type":"structure","members":{"DomainNames":{"type":"list","member":{"type":"structure","members":{"DomainName":{}}}}}}},"ListElasticsearchInstanceTypes":{"http":{"method":"GET","requestUri":"/2015-01-01/es/instanceTypes/{ElasticsearchVersion}"},"input":{"type":"structure","required":["ElasticsearchVersion"],"members":{"ElasticsearchVersion":{"location":"uri","locationName":"ElasticsearchVersion"},"DomainName":{"location":"querystring","locationName":"domainName"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"ElasticsearchInstanceTypes":{"type":"list","member":{}},"NextToken":{}}}},"ListElasticsearchVersions":{"http":{"method":"GET","requestUri":"/2015-01-01/es/versions"},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"ElasticsearchVersions":{"shape":"S34"},"NextToken":{}}}},"ListTags":{"http":{"method":"GET","requestUri":"/2015-01-01/tags/"},"input":{"type":"structure","required":["ARN"],"members":{"ARN":{"location":"querystring","locationName":"arn"}}},"output":{"type":"structure","members":{"TagList":{"shape":"S3"}}}},"PurchaseReservedElasticsearchInstanceOffering":{"http":{"requestUri":"/2015-01-01/es/purchaseReservedInstanceOffering"},"input":{"type":"structure","required":["ReservedElasticsearchInstanceOfferingId","ReservationName"],"members":{"ReservedElasticsearchInstanceOfferingId":{},"ReservationName":{},"InstanceCount":{"type":"integer"}}},"output":{"type":"structure","members":{"ReservedElasticsearchInstanceId":{},"ReservationName":{}}}},"RemoveTags":{"http":{"requestUri":"/2015-01-01/tags-removal"},"input":{"type":"structure","required":["ARN","TagKeys"],"members":{"ARN":{},"TagKeys":{"shape":"Sq"}}}},"StartElasticsearchServiceSoftwareUpdate":{"http":{"requestUri":"/2015-01-01/es/serviceSoftwareUpdate/start"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{"ServiceSoftwareOptions":{"shape":"Sa"}}}},"UpdateElasticsearchDomainConfig":{"http":{"requestUri":"/2015-01-01/es/domain/{DomainName}/config"},"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{"location":"uri","locationName":"DomainName"},"ElasticsearchClusterConfig":{"shape":"Sh"},"EBSOptions":{"shape":"Sl"},"SnapshotOptions":{"shape":"So"},"VPCOptions":{"shape":"Sp"},"CognitoOptions":{"shape":"Sr"},"AdvancedOptions":{"shape":"Sy"},"AccessPolicies":{},"LogPublishingOptions":{"shape":"Sz"}}},"output":{"type":"structure","required":["DomainConfig"],"members":{"DomainConfig":{"shape":"S1f"}}}},"UpgradeElasticsearchDomain":{"http":{"requestUri":"/2015-01-01/es/upgradeDomain"},"input":{"type":"structure","required":["DomainName","TargetVersion"],"members":{"DomainName":{},"TargetVersion":{},"PerformCheckOnly":{"type":"boolean"}}},"output":{"type":"structure","members":{"DomainName":{},"TargetVersion":{},"PerformCheckOnly":{"type":"boolean"}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sa":{"type":"structure","members":{"CurrentVersion":{},"NewVersion":{},"UpdateAvailable":{"type":"boolean"},"Cancellable":{"type":"boolean"},"UpdateStatus":{},"Description":{},"AutomatedUpdateDate":{"type":"timestamp"}}},"Sh":{"type":"structure","members":{"InstanceType":{},"InstanceCount":{"type":"integer"},"DedicatedMasterEnabled":{"type":"boolean"},"ZoneAwarenessEnabled":{"type":"boolean"},"ZoneAwarenessConfig":{"type":"structure","members":{"AvailabilityZoneCount":{"type":"integer"}}},"DedicatedMasterType":{},"DedicatedMasterCount":{"type":"integer"}}},"Sl":{"type":"structure","members":{"EBSEnabled":{"type":"boolean"},"VolumeType":{},"VolumeSize":{"type":"integer"},"Iops":{"type":"integer"}}},"So":{"type":"structure","members":{"AutomatedSnapshotStartHour":{"type":"integer"}}},"Sp":{"type":"structure","members":{"SubnetIds":{"shape":"Sq"},"SecurityGroupIds":{"shape":"Sq"}}},"Sq":{"type":"list","member":{}},"Sr":{"type":"structure","members":{"Enabled":{"type":"boolean"},"UserPoolId":{},"IdentityPoolId":{},"RoleArn":{}}},"Sv":{"type":"structure","members":{"Enabled":{"type":"boolean"},"KmsKeyId":{}}},"Sx":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"Sy":{"type":"map","key":{},"value":{}},"Sz":{"type":"map","key":{},"value":{"type":"structure","members":{"CloudWatchLogsLogGroupArn":{},"Enabled":{"type":"boolean"}}}},"S14":{"type":"structure","required":["DomainId","DomainName","ARN","ElasticsearchClusterConfig"],"members":{"DomainId":{},"DomainName":{},"ARN":{},"Created":{"type":"boolean"},"Deleted":{"type":"boolean"},"Endpoint":{},"Endpoints":{"type":"map","key":{},"value":{}},"Processing":{"type":"boolean"},"UpgradeProcessing":{"type":"boolean"},"ElasticsearchVersion":{},"ElasticsearchClusterConfig":{"shape":"Sh"},"EBSOptions":{"shape":"Sl"},"AccessPolicies":{},"SnapshotOptions":{"shape":"So"},"VPCOptions":{"shape":"S18"},"CognitoOptions":{"shape":"Sr"},"EncryptionAtRestOptions":{"shape":"Sv"},"NodeToNodeEncryptionOptions":{"shape":"Sx"},"AdvancedOptions":{"shape":"Sy"},"LogPublishingOptions":{"shape":"Sz"},"ServiceSoftwareOptions":{"shape":"Sa"}}},"S18":{"type":"structure","members":{"VPCId":{},"SubnetIds":{"shape":"Sq"},"AvailabilityZones":{"shape":"Sq"},"SecurityGroupIds":{"shape":"Sq"}}},"S1f":{"type":"structure","members":{"ElasticsearchVersion":{"type":"structure","required":["Options","Status"],"members":{"Options":{},"Status":{"shape":"S1h"}}},"ElasticsearchClusterConfig":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"Sh"},"Status":{"shape":"S1h"}}},"EBSOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"Sl"},"Status":{"shape":"S1h"}}},"AccessPolicies":{"type":"structure","required":["Options","Status"],"members":{"Options":{},"Status":{"shape":"S1h"}}},"SnapshotOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"So"},"Status":{"shape":"S1h"}}},"VPCOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"S18"},"Status":{"shape":"S1h"}}},"CognitoOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"Sr"},"Status":{"shape":"S1h"}}},"EncryptionAtRestOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"Sv"},"Status":{"shape":"S1h"}}},"NodeToNodeEncryptionOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"Sx"},"Status":{"shape":"S1h"}}},"AdvancedOptions":{"type":"structure","required":["Options","Status"],"members":{"Options":{"shape":"Sy"},"Status":{"shape":"S1h"}}},"LogPublishingOptions":{"type":"structure","members":{"Options":{"shape":"Sz"},"Status":{"shape":"S1h"}}}}},"S1h":{"type":"structure","required":["CreationDate","UpdateDate","State"],"members":{"CreationDate":{"type":"timestamp"},"UpdateDate":{"type":"timestamp"},"UpdateVersion":{"type":"integer"},"State":{},"PendingDeletion":{"type":"boolean"}}},"S2b":{"type":"list","member":{}},"S2t":{"type":"list","member":{"type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}}}},"S34":{"type":"list","member":{}}}}');

});

parcelRequire.register("a9IxJ", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeReservedElasticsearchInstanceOfferings":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeReservedElasticsearchInstances":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetUpgradeHistory":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListElasticsearchInstanceTypes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListElasticsearchVersions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("3j4mZ", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $2686892fb5298adf$var$Service = $dbC7k.Service;
var $2686892fb5298adf$var$apiLoader = $dbC7k.apiLoader;
$2686892fb5298adf$var$apiLoader.services["elastictranscoder"] = {};
$dbC7k.ElasticTranscoder = $2686892fb5298adf$var$Service.defineService("elastictranscoder", [
    "2012-09-25"
]);



Object.defineProperty($2686892fb5298adf$var$apiLoader.services["elastictranscoder"], "2012-09-25", {
    get: function get() {
        var model = (parcelRequire("6uzQy"));
        model.paginators = (parcelRequire("d3Hc6")).pagination;
        model.waiters = (parcelRequire("6C3ec")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ElasticTranscoder;

});
parcelRequire.register("6uzQy", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2012-09-25","endpointPrefix":"elastictranscoder","protocol":"rest-json","serviceFullName":"Amazon Elastic Transcoder","serviceId":"Elastic Transcoder","signatureVersion":"v4","uid":"elastictranscoder-2012-09-25"},"operations":{"CancelJob":{"http":{"method":"DELETE","requestUri":"/2012-09-25/jobs/{Id}","responseCode":202},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"CreateJob":{"http":{"requestUri":"/2012-09-25/jobs","responseCode":201},"input":{"type":"structure","required":["PipelineId"],"members":{"PipelineId":{},"Input":{"shape":"S5"},"Inputs":{"shape":"St"},"Output":{"shape":"Su"},"Outputs":{"type":"list","member":{"shape":"Su"}},"OutputKeyPrefix":{},"Playlists":{"type":"list","member":{"type":"structure","members":{"Name":{},"Format":{},"OutputKeys":{"shape":"S1l"},"HlsContentProtection":{"shape":"S1m"},"PlayReadyDrm":{"shape":"S1q"}}}},"UserMetadata":{"shape":"S1v"}}},"output":{"type":"structure","members":{"Job":{"shape":"S1y"}}}},"CreatePipeline":{"http":{"requestUri":"/2012-09-25/pipelines","responseCode":201},"input":{"type":"structure","required":["Name","InputBucket","Role"],"members":{"Name":{},"InputBucket":{},"OutputBucket":{},"Role":{},"AwsKmsKeyArn":{},"Notifications":{"shape":"S2a"},"ContentConfig":{"shape":"S2c"},"ThumbnailConfig":{"shape":"S2c"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"},"Warnings":{"shape":"S2n"}}}},"CreatePreset":{"http":{"requestUri":"/2012-09-25/presets","responseCode":201},"input":{"type":"structure","required":["Name","Container"],"members":{"Name":{},"Description":{},"Container":{},"Video":{"shape":"S2r"},"Audio":{"shape":"S37"},"Thumbnails":{"shape":"S3i"}}},"output":{"type":"structure","members":{"Preset":{"shape":"S3m"},"Warning":{}}}},"DeletePipeline":{"http":{"method":"DELETE","requestUri":"/2012-09-25/pipelines/{Id}","responseCode":202},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeletePreset":{"http":{"method":"DELETE","requestUri":"/2012-09-25/presets/{Id}","responseCode":202},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"ListJobsByPipeline":{"http":{"method":"GET","requestUri":"/2012-09-25/jobsByPipeline/{PipelineId}"},"input":{"type":"structure","required":["PipelineId"],"members":{"PipelineId":{"location":"uri","locationName":"PipelineId"},"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Jobs":{"shape":"S3v"},"NextPageToken":{}}}},"ListJobsByStatus":{"http":{"method":"GET","requestUri":"/2012-09-25/jobsByStatus/{Status}"},"input":{"type":"structure","required":["Status"],"members":{"Status":{"location":"uri","locationName":"Status"},"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Jobs":{"shape":"S3v"},"NextPageToken":{}}}},"ListPipelines":{"http":{"method":"GET","requestUri":"/2012-09-25/pipelines"},"input":{"type":"structure","members":{"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Pipelines":{"type":"list","member":{"shape":"S2l"}},"NextPageToken":{}}}},"ListPresets":{"http":{"method":"GET","requestUri":"/2012-09-25/presets"},"input":{"type":"structure","members":{"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Presets":{"type":"list","member":{"shape":"S3m"}},"NextPageToken":{}}}},"ReadJob":{"http":{"method":"GET","requestUri":"/2012-09-25/jobs/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Job":{"shape":"S1y"}}}},"ReadPipeline":{"http":{"method":"GET","requestUri":"/2012-09-25/pipelines/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"},"Warnings":{"shape":"S2n"}}}},"ReadPreset":{"http":{"method":"GET","requestUri":"/2012-09-25/presets/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Preset":{"shape":"S3m"}}}},"TestRole":{"http":{"requestUri":"/2012-09-25/roleTests","responseCode":200},"input":{"type":"structure","required":["Role","InputBucket","OutputBucket","Topics"],"members":{"Role":{},"InputBucket":{},"OutputBucket":{},"Topics":{"type":"list","member":{}}},"deprecated":true},"output":{"type":"structure","members":{"Success":{},"Messages":{"type":"list","member":{}}},"deprecated":true},"deprecated":true},"UpdatePipeline":{"http":{"method":"PUT","requestUri":"/2012-09-25/pipelines/{Id}","responseCode":200},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"Name":{},"InputBucket":{},"Role":{},"AwsKmsKeyArn":{},"Notifications":{"shape":"S2a"},"ContentConfig":{"shape":"S2c"},"ThumbnailConfig":{"shape":"S2c"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"},"Warnings":{"shape":"S2n"}}}},"UpdatePipelineNotifications":{"http":{"requestUri":"/2012-09-25/pipelines/{Id}/notifications"},"input":{"type":"structure","required":["Id","Notifications"],"members":{"Id":{"location":"uri","locationName":"Id"},"Notifications":{"shape":"S2a"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"}}}},"UpdatePipelineStatus":{"http":{"requestUri":"/2012-09-25/pipelines/{Id}/status"},"input":{"type":"structure","required":["Id","Status"],"members":{"Id":{"location":"uri","locationName":"Id"},"Status":{}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"}}}}},"shapes":{"S5":{"type":"structure","members":{"Key":{},"FrameRate":{},"Resolution":{},"AspectRatio":{},"Interlaced":{},"Container":{},"Encryption":{"shape":"Sc"},"TimeSpan":{"shape":"Sg"},"InputCaptions":{"type":"structure","members":{"MergePolicy":{},"CaptionSources":{"shape":"Sk"}}},"DetectedProperties":{"type":"structure","members":{"Width":{"type":"integer"},"Height":{"type":"integer"},"FrameRate":{},"FileSize":{"type":"long"},"DurationMillis":{"type":"long"}}}}},"Sc":{"type":"structure","members":{"Mode":{},"Key":{},"KeyMd5":{},"InitializationVector":{}}},"Sg":{"type":"structure","members":{"StartTime":{},"Duration":{}}},"Sk":{"type":"list","member":{"type":"structure","members":{"Key":{},"Language":{},"TimeOffset":{},"Label":{},"Encryption":{"shape":"Sc"}}}},"St":{"type":"list","member":{"shape":"S5"}},"Su":{"type":"structure","members":{"Key":{},"ThumbnailPattern":{},"ThumbnailEncryption":{"shape":"Sc"},"Rotate":{},"PresetId":{},"SegmentDuration":{},"Watermarks":{"shape":"Sx"},"AlbumArt":{"shape":"S11"},"Composition":{"shape":"S19","deprecated":true},"Captions":{"shape":"S1b"},"Encryption":{"shape":"Sc"}}},"Sx":{"type":"list","member":{"type":"structure","members":{"PresetWatermarkId":{},"InputKey":{},"Encryption":{"shape":"Sc"}}}},"S11":{"type":"structure","members":{"MergePolicy":{},"Artwork":{"type":"list","member":{"type":"structure","members":{"InputKey":{},"MaxWidth":{},"MaxHeight":{},"SizingPolicy":{},"PaddingPolicy":{},"AlbumArtFormat":{},"Encryption":{"shape":"Sc"}}}}}},"S19":{"type":"list","member":{"type":"structure","members":{"TimeSpan":{"shape":"Sg"}},"deprecated":true},"deprecated":true},"S1b":{"type":"structure","members":{"MergePolicy":{"deprecated":true},"CaptionSources":{"shape":"Sk","deprecated":true},"CaptionFormats":{"type":"list","member":{"type":"structure","members":{"Format":{},"Pattern":{},"Encryption":{"shape":"Sc"}}}}}},"S1l":{"type":"list","member":{}},"S1m":{"type":"structure","members":{"Method":{},"Key":{},"KeyMd5":{},"InitializationVector":{},"LicenseAcquisitionUrl":{},"KeyStoragePolicy":{}}},"S1q":{"type":"structure","members":{"Format":{},"Key":{},"KeyMd5":{},"KeyId":{},"InitializationVector":{},"LicenseAcquisitionUrl":{}}},"S1v":{"type":"map","key":{},"value":{}},"S1y":{"type":"structure","members":{"Id":{},"Arn":{},"PipelineId":{},"Input":{"shape":"S5"},"Inputs":{"shape":"St"},"Output":{"shape":"S1z"},"Outputs":{"type":"list","member":{"shape":"S1z"}},"OutputKeyPrefix":{},"Playlists":{"type":"list","member":{"type":"structure","members":{"Name":{},"Format":{},"OutputKeys":{"shape":"S1l"},"HlsContentProtection":{"shape":"S1m"},"PlayReadyDrm":{"shape":"S1q"},"Status":{},"StatusDetail":{}}}},"Status":{},"UserMetadata":{"shape":"S1v"},"Timing":{"type":"structure","members":{"SubmitTimeMillis":{"type":"long"},"StartTimeMillis":{"type":"long"},"FinishTimeMillis":{"type":"long"}}}}},"S1z":{"type":"structure","members":{"Id":{},"Key":{},"ThumbnailPattern":{},"ThumbnailEncryption":{"shape":"Sc"},"Rotate":{},"PresetId":{},"SegmentDuration":{},"Status":{},"StatusDetail":{},"Duration":{"type":"long"},"Width":{"type":"integer"},"Height":{"type":"integer"},"FrameRate":{},"FileSize":{"type":"long"},"DurationMillis":{"type":"long"},"Watermarks":{"shape":"Sx"},"AlbumArt":{"shape":"S11"},"Composition":{"shape":"S19","deprecated":true},"Captions":{"shape":"S1b"},"Encryption":{"shape":"Sc"},"AppliedColorSpaceConversion":{}}},"S2a":{"type":"structure","members":{"Progressing":{},"Completed":{},"Warning":{},"Error":{}}},"S2c":{"type":"structure","members":{"Bucket":{},"StorageClass":{},"Permissions":{"type":"list","member":{"type":"structure","members":{"GranteeType":{},"Grantee":{},"Access":{"type":"list","member":{}}}}}}},"S2l":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Status":{},"InputBucket":{},"OutputBucket":{},"Role":{},"AwsKmsKeyArn":{},"Notifications":{"shape":"S2a"},"ContentConfig":{"shape":"S2c"},"ThumbnailConfig":{"shape":"S2c"}}},"S2n":{"type":"list","member":{"type":"structure","members":{"Code":{},"Message":{}}}},"S2r":{"type":"structure","members":{"Codec":{},"CodecOptions":{"type":"map","key":{},"value":{}},"KeyframesMaxDist":{},"FixedGOP":{},"BitRate":{},"FrameRate":{},"MaxFrameRate":{},"Resolution":{},"AspectRatio":{},"MaxWidth":{},"MaxHeight":{},"DisplayAspectRatio":{},"SizingPolicy":{},"PaddingPolicy":{},"Watermarks":{"type":"list","member":{"type":"structure","members":{"Id":{},"MaxWidth":{},"MaxHeight":{},"SizingPolicy":{},"HorizontalAlign":{},"HorizontalOffset":{},"VerticalAlign":{},"VerticalOffset":{},"Opacity":{},"Target":{}}}}}},"S37":{"type":"structure","members":{"Codec":{},"SampleRate":{},"BitRate":{},"Channels":{},"AudioPackingMode":{},"CodecOptions":{"type":"structure","members":{"Profile":{},"BitDepth":{},"BitOrder":{},"Signed":{}}}}},"S3i":{"type":"structure","members":{"Format":{},"Interval":{},"Resolution":{},"AspectRatio":{},"MaxWidth":{},"MaxHeight":{},"SizingPolicy":{},"PaddingPolicy":{}}},"S3m":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Description":{},"Container":{},"Audio":{"shape":"S37"},"Video":{"shape":"S2r"},"Thumbnails":{"shape":"S3i"},"Type":{}}},"S3v":{"type":"list","member":{"shape":"S1y"}}}}');

});

parcelRequire.register("d3Hc6", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListJobsByPipeline":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Jobs"},"ListJobsByStatus":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Jobs"},"ListPipelines":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Pipelines"},"ListPresets":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Presets"}}}');

});

parcelRequire.register("6C3ec", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"JobComplete":{"delay":30,"operation":"ReadJob","maxAttempts":120,"acceptors":[{"expected":"Complete","matcher":"path","state":"success","argument":"Job.Status"},{"expected":"Canceled","matcher":"path","state":"failure","argument":"Job.Status"},{"expected":"Error","matcher":"path","state":"failure","argument":"Job.Status"}]}}}');

});


parcelRequire.register("8Fuaj", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $64f98d4a8ba64147$var$Service = $dbC7k.Service;
var $64f98d4a8ba64147$var$apiLoader = $dbC7k.apiLoader;
$64f98d4a8ba64147$var$apiLoader.services["gamelift"] = {};
$dbC7k.GameLift = $64f98d4a8ba64147$var$Service.defineService("gamelift", [
    "2015-10-01"
]);


Object.defineProperty($64f98d4a8ba64147$var$apiLoader.services["gamelift"], "2015-10-01", {
    get: function get() {
        var model = (parcelRequire("6vpT9"));
        model.paginators = (parcelRequire("jpmaQ")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.GameLift;

});
parcelRequire.register("6vpT9", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-10-01","endpointPrefix":"gamelift","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon GameLift","serviceId":"GameLift","signatureVersion":"v4","targetPrefix":"GameLift","uid":"gamelift-2015-10-01"},"operations":{"AcceptMatch":{"input":{"type":"structure","required":["TicketId","PlayerIds","AcceptanceType"],"members":{"TicketId":{},"PlayerIds":{"shape":"S3"},"AcceptanceType":{}}},"output":{"type":"structure","members":{}}},"CreateAlias":{"input":{"type":"structure","required":["Name","RoutingStrategy"],"members":{"Name":{},"Description":{},"RoutingStrategy":{"shape":"S9"}}},"output":{"type":"structure","members":{"Alias":{"shape":"Se"}}}},"CreateBuild":{"input":{"type":"structure","members":{"Name":{},"Version":{},"StorageLocation":{"shape":"Sj"},"OperatingSystem":{}}},"output":{"type":"structure","members":{"Build":{"shape":"Sn"},"UploadCredentials":{"shape":"Sr"},"StorageLocation":{"shape":"Sj"}}}},"CreateFleet":{"input":{"type":"structure","required":["Name","EC2InstanceType"],"members":{"Name":{},"Description":{},"BuildId":{},"ScriptId":{},"ServerLaunchPath":{},"ServerLaunchParameters":{},"LogPaths":{"shape":"S3"},"EC2InstanceType":{},"EC2InboundPermissions":{"shape":"Sv"},"NewGameSessionProtectionPolicy":{},"RuntimeConfiguration":{"shape":"S11"},"ResourceCreationLimitPolicy":{"shape":"S17"},"MetricGroups":{"shape":"S19"},"PeerVpcAwsAccountId":{},"PeerVpcId":{},"FleetType":{},"InstanceRoleArn":{}}},"output":{"type":"structure","members":{"FleetAttributes":{"shape":"S1d"}}}},"CreateGameSession":{"input":{"type":"structure","required":["MaximumPlayerSessionCount"],"members":{"FleetId":{},"AliasId":{},"MaximumPlayerSessionCount":{"type":"integer"},"Name":{},"GameProperties":{"shape":"S1i"},"CreatorId":{},"GameSessionId":{},"IdempotencyToken":{},"GameSessionData":{}}},"output":{"type":"structure","members":{"GameSession":{"shape":"S1p"}}}},"CreateGameSessionQueue":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"TimeoutInSeconds":{"type":"integer"},"PlayerLatencyPolicies":{"shape":"S1x"},"Destinations":{"shape":"S1z"}}},"output":{"type":"structure","members":{"GameSessionQueue":{"shape":"S22"}}}},"CreateMatchmakingConfiguration":{"input":{"type":"structure","required":["Name","GameSessionQueueArns","RequestTimeoutSeconds","AcceptanceRequired","RuleSetName"],"members":{"Name":{},"Description":{},"GameSessionQueueArns":{"shape":"S24"},"RequestTimeoutSeconds":{"type":"integer"},"AcceptanceTimeoutSeconds":{"type":"integer"},"AcceptanceRequired":{"type":"boolean"},"RuleSetName":{},"NotificationTarget":{},"AdditionalPlayerCount":{"type":"integer"},"CustomEventData":{},"GameProperties":{"shape":"S1i"},"GameSessionData":{},"BackfillMode":{}}},"output":{"type":"structure","members":{"Configuration":{"shape":"S2c"}}}},"CreateMatchmakingRuleSet":{"input":{"type":"structure","required":["Name","RuleSetBody"],"members":{"Name":{},"RuleSetBody":{}}},"output":{"type":"structure","required":["RuleSet"],"members":{"RuleSet":{"shape":"S2g"}}}},"CreatePlayerSession":{"input":{"type":"structure","required":["GameSessionId","PlayerId"],"members":{"GameSessionId":{},"PlayerId":{},"PlayerData":{}}},"output":{"type":"structure","members":{"PlayerSession":{"shape":"S2k"}}}},"CreatePlayerSessions":{"input":{"type":"structure","required":["GameSessionId","PlayerIds"],"members":{"GameSessionId":{},"PlayerIds":{"type":"list","member":{}},"PlayerDataMap":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","members":{"PlayerSessions":{"shape":"S2r"}}}},"CreateScript":{"input":{"type":"structure","members":{"Name":{},"Version":{},"StorageLocation":{"shape":"Sj"},"ZipFile":{"type":"blob"}}},"output":{"type":"structure","members":{"Script":{"shape":"S2v"}}}},"CreateVpcPeeringAuthorization":{"input":{"type":"structure","required":["GameLiftAwsAccountId","PeerVpcId"],"members":{"GameLiftAwsAccountId":{},"PeerVpcId":{}}},"output":{"type":"structure","members":{"VpcPeeringAuthorization":{"shape":"S2y"}}}},"CreateVpcPeeringConnection":{"input":{"type":"structure","required":["FleetId","PeerVpcAwsAccountId","PeerVpcId"],"members":{"FleetId":{},"PeerVpcAwsAccountId":{},"PeerVpcId":{}}},"output":{"type":"structure","members":{}}},"DeleteAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{}}}},"DeleteBuild":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{}}}},"DeleteFleet":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{}}}},"DeleteGameSessionQueue":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteMatchmakingConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteMatchmakingRuleSet":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteScalingPolicy":{"input":{"type":"structure","required":["Name","FleetId"],"members":{"Name":{},"FleetId":{}}}},"DeleteScript":{"input":{"type":"structure","required":["ScriptId"],"members":{"ScriptId":{}}}},"DeleteVpcPeeringAuthorization":{"input":{"type":"structure","required":["GameLiftAwsAccountId","PeerVpcId"],"members":{"GameLiftAwsAccountId":{},"PeerVpcId":{}}},"output":{"type":"structure","members":{}}},"DeleteVpcPeeringConnection":{"input":{"type":"structure","required":["FleetId","VpcPeeringConnectionId"],"members":{"FleetId":{},"VpcPeeringConnectionId":{}}},"output":{"type":"structure","members":{}}},"DescribeAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{}}},"output":{"type":"structure","members":{"Alias":{"shape":"Se"}}}},"DescribeBuild":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{}}},"output":{"type":"structure","members":{"Build":{"shape":"Sn"}}}},"DescribeEC2InstanceLimits":{"input":{"type":"structure","members":{"EC2InstanceType":{}}},"output":{"type":"structure","members":{"EC2InstanceLimits":{"type":"list","member":{"type":"structure","members":{"EC2InstanceType":{},"CurrentInstances":{"type":"integer"},"InstanceLimit":{"type":"integer"}}}}}}},"DescribeFleetAttributes":{"input":{"type":"structure","members":{"FleetIds":{"shape":"S3p"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetAttributes":{"type":"list","member":{"shape":"S1d"}},"NextToken":{}}}},"DescribeFleetCapacity":{"input":{"type":"structure","members":{"FleetIds":{"shape":"S3p"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetCapacity":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"InstanceType":{},"InstanceCounts":{"type":"structure","members":{"DESIRED":{"type":"integer"},"MINIMUM":{"type":"integer"},"MAXIMUM":{"type":"integer"},"PENDING":{"type":"integer"},"ACTIVE":{"type":"integer"},"IDLE":{"type":"integer"},"TERMINATING":{"type":"integer"}}}}}},"NextToken":{}}}},"DescribeFleetEvents":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Events":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ResourceId":{},"EventCode":{},"Message":{},"EventTime":{"type":"timestamp"},"PreSignedLogUrl":{}}}},"NextToken":{}}}},"DescribeFleetPortSettings":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{}}},"output":{"type":"structure","members":{"InboundPermissions":{"shape":"Sv"}}}},"DescribeFleetUtilization":{"input":{"type":"structure","members":{"FleetIds":{"shape":"S3p"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetUtilization":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"ActiveServerProcessCount":{"type":"integer"},"ActiveGameSessionCount":{"type":"integer"},"CurrentPlayerSessionCount":{"type":"integer"},"MaximumPlayerSessionCount":{"type":"integer"}}}},"NextToken":{}}}},"DescribeGameSessionDetails":{"input":{"type":"structure","members":{"FleetId":{},"GameSessionId":{},"AliasId":{},"StatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessionDetails":{"type":"list","member":{"type":"structure","members":{"GameSession":{"shape":"S1p"},"ProtectionPolicy":{}}}},"NextToken":{}}}},"DescribeGameSessionPlacement":{"input":{"type":"structure","required":["PlacementId"],"members":{"PlacementId":{}}},"output":{"type":"structure","members":{"GameSessionPlacement":{"shape":"S4e"}}}},"DescribeGameSessionQueues":{"input":{"type":"structure","members":{"Names":{"type":"list","member":{}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessionQueues":{"type":"list","member":{"shape":"S22"}},"NextToken":{}}}},"DescribeGameSessions":{"input":{"type":"structure","members":{"FleetId":{},"GameSessionId":{},"AliasId":{},"StatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessions":{"shape":"S4r"},"NextToken":{}}}},"DescribeInstances":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"InstanceId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"InstanceId":{},"IpAddress":{},"OperatingSystem":{},"Type":{},"Status":{},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMatchmaking":{"input":{"type":"structure","required":["TicketIds"],"members":{"TicketIds":{"shape":"S4z"}}},"output":{"type":"structure","members":{"TicketList":{"type":"list","member":{"shape":"S52"}}}}},"DescribeMatchmakingConfigurations":{"input":{"type":"structure","members":{"Names":{"shape":"S4z"},"RuleSetName":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Configurations":{"type":"list","member":{"shape":"S2c"}},"NextToken":{}}}},"DescribeMatchmakingRuleSets":{"input":{"type":"structure","members":{"Names":{"type":"list","member":{}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["RuleSets"],"members":{"RuleSets":{"type":"list","member":{"shape":"S2g"}},"NextToken":{}}}},"DescribePlayerSessions":{"input":{"type":"structure","members":{"GameSessionId":{},"PlayerId":{},"PlayerSessionId":{},"PlayerSessionStatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"PlayerSessions":{"shape":"S2r"},"NextToken":{}}}},"DescribeRuntimeConfiguration":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{}}},"output":{"type":"structure","members":{"RuntimeConfiguration":{"shape":"S11"}}}},"DescribeScalingPolicies":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"StatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalingPolicies":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"Name":{},"Status":{},"ScalingAdjustment":{"type":"integer"},"ScalingAdjustmentType":{},"ComparisonOperator":{},"Threshold":{"type":"double"},"EvaluationPeriods":{"type":"integer"},"MetricName":{},"PolicyType":{},"TargetConfiguration":{"shape":"S62"}}}},"NextToken":{}}}},"DescribeScript":{"input":{"type":"structure","required":["ScriptId"],"members":{"ScriptId":{}}},"output":{"type":"structure","members":{"Script":{"shape":"S2v"}}}},"DescribeVpcPeeringAuthorizations":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"VpcPeeringAuthorizations":{"type":"list","member":{"shape":"S2y"}}}}},"DescribeVpcPeeringConnections":{"input":{"type":"structure","members":{"FleetId":{}}},"output":{"type":"structure","members":{"VpcPeeringConnections":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"IpV4CidrBlock":{},"VpcPeeringConnectionId":{},"Status":{"type":"structure","members":{"Code":{},"Message":{}}},"PeerVpcId":{},"GameLiftVpcId":{}}}}}}},"GetGameSessionLogUrl":{"input":{"type":"structure","required":["GameSessionId"],"members":{"GameSessionId":{}}},"output":{"type":"structure","members":{"PreSignedUrl":{}}}},"GetInstanceAccess":{"input":{"type":"structure","required":["FleetId","InstanceId"],"members":{"FleetId":{},"InstanceId":{}}},"output":{"type":"structure","members":{"InstanceAccess":{"type":"structure","members":{"FleetId":{},"InstanceId":{},"IpAddress":{},"OperatingSystem":{},"Credentials":{"type":"structure","members":{"UserName":{},"Secret":{}},"sensitive":true}}}}}},"ListAliases":{"input":{"type":"structure","members":{"RoutingStrategyType":{},"Name":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Aliases":{"type":"list","member":{"shape":"Se"}},"NextToken":{}}}},"ListBuilds":{"input":{"type":"structure","members":{"Status":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Builds":{"type":"list","member":{"shape":"Sn"}},"NextToken":{}}}},"ListFleets":{"input":{"type":"structure","members":{"BuildId":{},"ScriptId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetIds":{"shape":"S3p"},"NextToken":{}}}},"ListScripts":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Scripts":{"type":"list","member":{"shape":"S2v"}},"NextToken":{}}}},"PutScalingPolicy":{"input":{"type":"structure","required":["Name","FleetId","MetricName"],"members":{"Name":{},"FleetId":{},"ScalingAdjustment":{"type":"integer"},"ScalingAdjustmentType":{},"Threshold":{"type":"double"},"ComparisonOperator":{},"EvaluationPeriods":{"type":"integer"},"MetricName":{},"PolicyType":{},"TargetConfiguration":{"shape":"S62"}}},"output":{"type":"structure","members":{"Name":{}}}},"RequestUploadCredentials":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{}}},"output":{"type":"structure","members":{"UploadCredentials":{"shape":"Sr"},"StorageLocation":{"shape":"Sj"}}}},"ResolveAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{}}},"output":{"type":"structure","members":{"FleetId":{}}}},"SearchGameSessions":{"input":{"type":"structure","members":{"FleetId":{},"AliasId":{},"FilterExpression":{},"SortExpression":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessions":{"shape":"S4r"},"NextToken":{}}}},"StartFleetActions":{"input":{"type":"structure","required":["FleetId","Actions"],"members":{"FleetId":{},"Actions":{"shape":"S1f"}}},"output":{"type":"structure","members":{}}},"StartGameSessionPlacement":{"input":{"type":"structure","required":["PlacementId","GameSessionQueueName","MaximumPlayerSessionCount"],"members":{"PlacementId":{},"GameSessionQueueName":{},"GameProperties":{"shape":"S1i"},"MaximumPlayerSessionCount":{"type":"integer"},"GameSessionName":{},"PlayerLatencies":{"shape":"S4g"},"DesiredPlayerSessions":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"PlayerData":{}}}},"GameSessionData":{}}},"output":{"type":"structure","members":{"GameSessionPlacement":{"shape":"S4e"}}}},"StartMatchBackfill":{"input":{"type":"structure","required":["ConfigurationName","GameSessionArn","Players"],"members":{"TicketId":{},"ConfigurationName":{},"GameSessionArn":{},"Players":{"shape":"S55"}}},"output":{"type":"structure","members":{"MatchmakingTicket":{"shape":"S52"}}}},"StartMatchmaking":{"input":{"type":"structure","required":["ConfigurationName","Players"],"members":{"TicketId":{},"ConfigurationName":{},"Players":{"shape":"S55"}}},"output":{"type":"structure","members":{"MatchmakingTicket":{"shape":"S52"}}}},"StopFleetActions":{"input":{"type":"structure","required":["FleetId","Actions"],"members":{"FleetId":{},"Actions":{"shape":"S1f"}}},"output":{"type":"structure","members":{}}},"StopGameSessionPlacement":{"input":{"type":"structure","required":["PlacementId"],"members":{"PlacementId":{}}},"output":{"type":"structure","members":{"GameSessionPlacement":{"shape":"S4e"}}}},"StopMatchmaking":{"input":{"type":"structure","required":["TicketId"],"members":{"TicketId":{}}},"output":{"type":"structure","members":{}}},"UpdateAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{},"Name":{},"Description":{},"RoutingStrategy":{"shape":"S9"}}},"output":{"type":"structure","members":{"Alias":{"shape":"Se"}}}},"UpdateBuild":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{},"Name":{},"Version":{}}},"output":{"type":"structure","members":{"Build":{"shape":"Sn"}}}},"UpdateFleetAttributes":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"Name":{},"Description":{},"NewGameSessionProtectionPolicy":{},"ResourceCreationLimitPolicy":{"shape":"S17"},"MetricGroups":{"shape":"S19"}}},"output":{"type":"structure","members":{"FleetId":{}}}},"UpdateFleetCapacity":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"DesiredInstances":{"type":"integer"},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"}}},"output":{"type":"structure","members":{"FleetId":{}}}},"UpdateFleetPortSettings":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"InboundPermissionAuthorizations":{"shape":"Sv"},"InboundPermissionRevocations":{"shape":"Sv"}}},"output":{"type":"structure","members":{"FleetId":{}}}},"UpdateGameSession":{"input":{"type":"structure","required":["GameSessionId"],"members":{"GameSessionId":{},"MaximumPlayerSessionCount":{"type":"integer"},"Name":{},"PlayerSessionCreationPolicy":{},"ProtectionPolicy":{}}},"output":{"type":"structure","members":{"GameSession":{"shape":"S1p"}}}},"UpdateGameSessionQueue":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"TimeoutInSeconds":{"type":"integer"},"PlayerLatencyPolicies":{"shape":"S1x"},"Destinations":{"shape":"S1z"}}},"output":{"type":"structure","members":{"GameSessionQueue":{"shape":"S22"}}}},"UpdateMatchmakingConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"GameSessionQueueArns":{"shape":"S24"},"RequestTimeoutSeconds":{"type":"integer"},"AcceptanceTimeoutSeconds":{"type":"integer"},"AcceptanceRequired":{"type":"boolean"},"RuleSetName":{},"NotificationTarget":{},"AdditionalPlayerCount":{"type":"integer"},"CustomEventData":{},"GameProperties":{"shape":"S1i"},"GameSessionData":{},"BackfillMode":{}}},"output":{"type":"structure","members":{"Configuration":{"shape":"S2c"}}}},"UpdateRuntimeConfiguration":{"input":{"type":"structure","required":["FleetId","RuntimeConfiguration"],"members":{"FleetId":{},"RuntimeConfiguration":{"shape":"S11"}}},"output":{"type":"structure","members":{"RuntimeConfiguration":{"shape":"S11"}}}},"UpdateScript":{"input":{"type":"structure","required":["ScriptId"],"members":{"ScriptId":{},"Name":{},"Version":{},"StorageLocation":{"shape":"Sj"},"ZipFile":{"type":"blob"}}},"output":{"type":"structure","members":{"Script":{"shape":"S2v"}}}},"ValidateMatchmakingRuleSet":{"input":{"type":"structure","required":["RuleSetBody"],"members":{"RuleSetBody":{}}},"output":{"type":"structure","members":{"Valid":{"type":"boolean"}}}}},"shapes":{"S3":{"type":"list","member":{}},"S9":{"type":"structure","members":{"Type":{},"FleetId":{},"Message":{}}},"Se":{"type":"structure","members":{"AliasId":{},"Name":{},"AliasArn":{},"Description":{},"RoutingStrategy":{"shape":"S9"},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}},"Sj":{"type":"structure","members":{"Bucket":{},"Key":{},"RoleArn":{},"ObjectVersion":{}}},"Sn":{"type":"structure","members":{"BuildId":{},"Name":{},"Version":{},"Status":{},"SizeOnDisk":{"type":"long"},"OperatingSystem":{},"CreationTime":{"type":"timestamp"}}},"Sr":{"type":"structure","members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{}},"sensitive":true},"Sv":{"type":"list","member":{"type":"structure","required":["FromPort","ToPort","IpRange","Protocol"],"members":{"FromPort":{"type":"integer"},"ToPort":{"type":"integer"},"IpRange":{},"Protocol":{}}}},"S11":{"type":"structure","members":{"ServerProcesses":{"type":"list","member":{"type":"structure","required":["LaunchPath","ConcurrentExecutions"],"members":{"LaunchPath":{},"Parameters":{},"ConcurrentExecutions":{"type":"integer"}}}},"MaxConcurrentGameSessionActivations":{"type":"integer"},"GameSessionActivationTimeoutSeconds":{"type":"integer"}}},"S17":{"type":"structure","members":{"NewGameSessionsPerCreator":{"type":"integer"},"PolicyPeriodInMinutes":{"type":"integer"}}},"S19":{"type":"list","member":{}},"S1d":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"FleetType":{},"InstanceType":{},"Description":{},"Name":{},"CreationTime":{"type":"timestamp"},"TerminationTime":{"type":"timestamp"},"Status":{},"BuildId":{},"ScriptId":{},"ServerLaunchPath":{},"ServerLaunchParameters":{},"LogPaths":{"shape":"S3"},"NewGameSessionProtectionPolicy":{},"OperatingSystem":{},"ResourceCreationLimitPolicy":{"shape":"S17"},"MetricGroups":{"shape":"S19"},"StoppedActions":{"shape":"S1f"},"InstanceRoleArn":{}}},"S1f":{"type":"list","member":{}},"S1i":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S1p":{"type":"structure","members":{"GameSessionId":{},"Name":{},"FleetId":{},"CreationTime":{"type":"timestamp"},"TerminationTime":{"type":"timestamp"},"CurrentPlayerSessionCount":{"type":"integer"},"MaximumPlayerSessionCount":{"type":"integer"},"Status":{},"StatusReason":{},"GameProperties":{"shape":"S1i"},"IpAddress":{},"Port":{"type":"integer"},"PlayerSessionCreationPolicy":{},"CreatorId":{},"GameSessionData":{},"MatchmakerData":{}}},"S1x":{"type":"list","member":{"type":"structure","members":{"MaximumIndividualPlayerLatencyMilliseconds":{"type":"integer"},"PolicyDurationSeconds":{"type":"integer"}}}},"S1z":{"type":"list","member":{"type":"structure","members":{"DestinationArn":{}}}},"S22":{"type":"structure","members":{"Name":{},"GameSessionQueueArn":{},"TimeoutInSeconds":{"type":"integer"},"PlayerLatencyPolicies":{"shape":"S1x"},"Destinations":{"shape":"S1z"}}},"S24":{"type":"list","member":{}},"S2c":{"type":"structure","members":{"Name":{},"Description":{},"GameSessionQueueArns":{"shape":"S24"},"RequestTimeoutSeconds":{"type":"integer"},"AcceptanceTimeoutSeconds":{"type":"integer"},"AcceptanceRequired":{"type":"boolean"},"RuleSetName":{},"NotificationTarget":{},"AdditionalPlayerCount":{"type":"integer"},"CustomEventData":{},"CreationTime":{"type":"timestamp"},"GameProperties":{"shape":"S1i"},"GameSessionData":{},"BackfillMode":{}}},"S2g":{"type":"structure","required":["RuleSetBody"],"members":{"RuleSetName":{},"RuleSetBody":{},"CreationTime":{"type":"timestamp"}}},"S2k":{"type":"structure","members":{"PlayerSessionId":{},"PlayerId":{},"GameSessionId":{},"FleetId":{},"CreationTime":{"type":"timestamp"},"TerminationTime":{"type":"timestamp"},"Status":{},"IpAddress":{},"Port":{"type":"integer"},"PlayerData":{}}},"S2r":{"type":"list","member":{"shape":"S2k"}},"S2v":{"type":"structure","members":{"ScriptId":{},"Name":{},"Version":{},"SizeOnDisk":{"type":"long"},"CreationTime":{"type":"timestamp"},"StorageLocation":{"shape":"Sj"}}},"S2y":{"type":"structure","members":{"GameLiftAwsAccountId":{},"PeerVpcAwsAccountId":{},"PeerVpcId":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"}}},"S3p":{"type":"list","member":{}},"S4e":{"type":"structure","members":{"PlacementId":{},"GameSessionQueueName":{},"Status":{},"GameProperties":{"shape":"S1i"},"MaximumPlayerSessionCount":{"type":"integer"},"GameSessionName":{},"GameSessionId":{},"GameSessionArn":{},"GameSessionRegion":{},"PlayerLatencies":{"shape":"S4g"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"IpAddress":{},"Port":{"type":"integer"},"PlacedPlayerSessions":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"PlayerSessionId":{}}}},"GameSessionData":{},"MatchmakerData":{}}},"S4g":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"RegionIdentifier":{},"LatencyInMilliseconds":{"type":"float"}}}},"S4r":{"type":"list","member":{"shape":"S1p"}},"S4z":{"type":"list","member":{}},"S52":{"type":"structure","members":{"TicketId":{},"ConfigurationName":{},"Status":{},"StatusReason":{},"StatusMessage":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Players":{"shape":"S55"},"GameSessionConnectionInfo":{"type":"structure","members":{"GameSessionArn":{},"IpAddress":{},"Port":{"type":"integer"},"MatchedPlayerSessions":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"PlayerSessionId":{}}}}}},"EstimatedWaitTime":{"type":"integer"}}},"S55":{"type":"list","member":{"type":"structure","members":{"PlayerId":{},"PlayerAttributes":{"type":"map","key":{},"value":{"type":"structure","members":{"S":{},"N":{"type":"double"},"SL":{"shape":"S3"},"SDM":{"type":"map","key":{},"value":{"type":"double"}}}}},"Team":{},"LatencyInMs":{"type":"map","key":{},"value":{"type":"integer"}}}}},"S62":{"type":"structure","required":["TargetValue"],"members":{"TargetValue":{"type":"double"}}}}}');

});

parcelRequire.register("jpmaQ", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("35GBw", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $2402e303cfb40407$var$Service = $dbC7k.Service;
var $2402e303cfb40407$var$apiLoader = $dbC7k.apiLoader;
$2402e303cfb40407$var$apiLoader.services["glacier"] = {};
$dbC7k.Glacier = $2402e303cfb40407$var$Service.defineService("glacier", [
    "2012-06-01"
]);
parcelRequire("8ygdC");



Object.defineProperty($2402e303cfb40407$var$apiLoader.services["glacier"], "2012-06-01", {
    get: function get() {
        var model = (parcelRequire("hMQxF"));
        model.paginators = (parcelRequire("a6BUa")).pagination;
        model.waiters = (parcelRequire("kUcI5")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Glacier;

});
parcelRequire.register("8ygdC", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
$dbC7k.util.update($dbC7k.Glacier.prototype, {
    /**
   * @api private
   */ setupRequestListeners: function setupRequestListeners(request) {
        if (Array.isArray(request._events.validate)) request._events.validate.unshift(this.validateAccountId);
        else request.on("validate", this.validateAccountId);
        request.removeListener("afterBuild", $dbC7k.EventListeners.Core.COMPUTE_SHA256);
        request.on("build", this.addGlacierApiVersion);
        request.on("build", this.addTreeHashHeaders);
    },
    /**
   * @api private
   */ validateAccountId: function validateAccountId(request) {
        if (request.params.accountId !== undefined) return;
        request.params = $dbC7k.util.copy(request.params);
        request.params.accountId = "-";
    },
    /**
   * @api private
   */ addGlacierApiVersion: function addGlacierApiVersion(request) {
        var version = request.service.api.apiVersion;
        request.httpRequest.headers["x-amz-glacier-version"] = version;
    },
    /**
   * @api private
   */ addTreeHashHeaders: function addTreeHashHeaders(request) {
        if (request.params.body === undefined) return;
        var hashes = request.service.computeChecksums(request.params.body);
        request.httpRequest.headers["X-Amz-Content-Sha256"] = hashes.linearHash;
        if (!request.httpRequest.headers["x-amz-sha256-tree-hash"]) request.httpRequest.headers["x-amz-sha256-tree-hash"] = hashes.treeHash;
    },
    /**
   * @!group Computing Checksums
   */ /**
   * Computes the SHA-256 linear and tree hash checksums for a given
   * block of Buffer data. Pass the tree hash of the computed checksums
   * as the checksum input to the {completeMultipartUpload} when performing
   * a multi-part upload.
   *
   * @example Calculate checksum of 5.5MB data chunk
   *   var glacier = new AWS.Glacier();
   *   var data = Buffer.alloc(5.5 * 1024 * 1024);
   *   data.fill('0'); // fill with zeros
   *   var results = glacier.computeChecksums(data);
   *   // Result: { linearHash: '68aff0c5a9...', treeHash: '154e26c78f...' }
   * @param data [Buffer, String] data to calculate the checksum for
   * @return [map<linearHash:String,treeHash:String>] a map containing
   *   the linearHash and treeHash properties representing hex based digests
   *   of the respective checksums.
   * @see completeMultipartUpload
   */ computeChecksums: function computeChecksums(data) {
        if (!$dbC7k.util.Buffer.isBuffer(data)) data = $dbC7k.util.buffer.toBuffer(data);
        var mb = 1048576;
        var hashes = [];
        var hash = $dbC7k.util.crypto.createHash("sha256");
        // build leaf nodes in 1mb chunks
        for(var i = 0; i < data.length; i += mb){
            var chunk = data.slice(i, Math.min(i + mb, data.length));
            hash.update(chunk);
            hashes.push($dbC7k.util.crypto.sha256(chunk));
        }
        return {
            linearHash: hash.digest("hex"),
            treeHash: this.buildHashTree(hashes)
        };
    },
    /**
   * @api private
   */ buildHashTree: function buildHashTree(hashes) {
        // merge leaf nodes
        while(hashes.length > 1){
            var tmpHashes = [];
            for(var i = 0; i < hashes.length; i += 2)if (hashes[i + 1]) {
                var tmpHash = $dbC7k.util.buffer.alloc(64);
                tmpHash.write(hashes[i], 0, 32, "binary");
                tmpHash.write(hashes[i + 1], 32, 32, "binary");
                tmpHashes.push($dbC7k.util.crypto.sha256(tmpHash));
            } else tmpHashes.push(hashes[i]);
            hashes = tmpHashes;
        }
        return $dbC7k.util.crypto.toHex(hashes[0]);
    }
});

});

parcelRequire.register("hMQxF", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2012-06-01","checksumFormat":"sha256","endpointPrefix":"glacier","protocol":"rest-json","serviceFullName":"Amazon Glacier","serviceId":"Glacier","signatureVersion":"v4","uid":"glacier-2012-06-01"},"operations":{"AbortMultipartUpload":{"http":{"method":"DELETE","requestUri":"/{accountId}/vaults/{vaultName}/multipart-uploads/{uploadId}","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName","uploadId"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"uploadId":{"location":"uri","locationName":"uploadId"}}}},"AbortVaultLock":{"http":{"method":"DELETE","requestUri":"/{accountId}/vaults/{vaultName}/lock-policy","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"}}}},"AddTagsToVault":{"http":{"requestUri":"/{accountId}/vaults/{vaultName}/tags?operation=add","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"Tags":{"shape":"S5"}}}},"CompleteMultipartUpload":{"http":{"requestUri":"/{accountId}/vaults/{vaultName}/multipart-uploads/{uploadId}","responseCode":201},"input":{"type":"structure","required":["accountId","vaultName","uploadId"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"uploadId":{"location":"uri","locationName":"uploadId"},"archiveSize":{"location":"header","locationName":"x-amz-archive-size"},"checksum":{"location":"header","locationName":"x-amz-sha256-tree-hash"}}},"output":{"shape":"S9"}},"CompleteVaultLock":{"http":{"requestUri":"/{accountId}/vaults/{vaultName}/lock-policy/{lockId}","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName","lockId"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"lockId":{"location":"uri","locationName":"lockId"}}}},"CreateVault":{"http":{"method":"PUT","requestUri":"/{accountId}/vaults/{vaultName}","responseCode":201},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"}}},"output":{"type":"structure","members":{"location":{"location":"header","locationName":"Location"}}}},"DeleteArchive":{"http":{"method":"DELETE","requestUri":"/{accountId}/vaults/{vaultName}/archives/{archiveId}","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName","archiveId"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"archiveId":{"location":"uri","locationName":"archiveId"}}}},"DeleteVault":{"http":{"method":"DELETE","requestUri":"/{accountId}/vaults/{vaultName}","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"}}}},"DeleteVaultAccessPolicy":{"http":{"method":"DELETE","requestUri":"/{accountId}/vaults/{vaultName}/access-policy","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"}}}},"DeleteVaultNotifications":{"http":{"method":"DELETE","requestUri":"/{accountId}/vaults/{vaultName}/notification-configuration","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"}}}},"DescribeJob":{"http":{"method":"GET","requestUri":"/{accountId}/vaults/{vaultName}/jobs/{jobId}"},"input":{"type":"structure","required":["accountId","vaultName","jobId"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"shape":"Si"}},"DescribeVault":{"http":{"method":"GET","requestUri":"/{accountId}/vaults/{vaultName}"},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"}}},"output":{"shape":"S1a"}},"GetDataRetrievalPolicy":{"http":{"method":"GET","requestUri":"/{accountId}/policies/data-retrieval"},"input":{"type":"structure","required":["accountId"],"members":{"accountId":{"location":"uri","locationName":"accountId"}}},"output":{"type":"structure","members":{"Policy":{"shape":"S1e"}}}},"GetJobOutput":{"http":{"method":"GET","requestUri":"/{accountId}/vaults/{vaultName}/jobs/{jobId}/output"},"input":{"type":"structure","required":["accountId","vaultName","jobId"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"jobId":{"location":"uri","locationName":"jobId"},"range":{"location":"header","locationName":"Range"}}},"output":{"type":"structure","members":{"body":{"shape":"S1k"},"checksum":{"location":"header","locationName":"x-amz-sha256-tree-hash"},"status":{"location":"statusCode","type":"integer"},"contentRange":{"location":"header","locationName":"Content-Range"},"acceptRanges":{"location":"header","locationName":"Accept-Ranges"},"contentType":{"location":"header","locationName":"Content-Type"},"archiveDescription":{"location":"header","locationName":"x-amz-archive-description"}},"payload":"body"}},"GetVaultAccessPolicy":{"http":{"method":"GET","requestUri":"/{accountId}/vaults/{vaultName}/access-policy"},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"}}},"output":{"type":"structure","members":{"policy":{"shape":"S1o"}},"payload":"policy"}},"GetVaultLock":{"http":{"method":"GET","requestUri":"/{accountId}/vaults/{vaultName}/lock-policy"},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"}}},"output":{"type":"structure","members":{"Policy":{},"State":{},"ExpirationDate":{},"CreationDate":{}}}},"GetVaultNotifications":{"http":{"method":"GET","requestUri":"/{accountId}/vaults/{vaultName}/notification-configuration"},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"}}},"output":{"type":"structure","members":{"vaultNotificationConfig":{"shape":"S1t"}},"payload":"vaultNotificationConfig"}},"InitiateJob":{"http":{"requestUri":"/{accountId}/vaults/{vaultName}/jobs","responseCode":202},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"jobParameters":{"type":"structure","members":{"Format":{},"Type":{},"ArchiveId":{},"Description":{},"SNSTopic":{},"RetrievalByteRange":{},"Tier":{},"InventoryRetrievalParameters":{"type":"structure","members":{"StartDate":{},"EndDate":{},"Limit":{},"Marker":{}}},"SelectParameters":{"shape":"Sp"},"OutputLocation":{"shape":"Sx"}}}},"payload":"jobParameters"},"output":{"type":"structure","members":{"location":{"location":"header","locationName":"Location"},"jobId":{"location":"header","locationName":"x-amz-job-id"},"jobOutputPath":{"location":"header","locationName":"x-amz-job-output-path"}}}},"InitiateMultipartUpload":{"http":{"requestUri":"/{accountId}/vaults/{vaultName}/multipart-uploads","responseCode":201},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"archiveDescription":{"location":"header","locationName":"x-amz-archive-description"},"partSize":{"location":"header","locationName":"x-amz-part-size"}}},"output":{"type":"structure","members":{"location":{"location":"header","locationName":"Location"},"uploadId":{"location":"header","locationName":"x-amz-multipart-upload-id"}}}},"InitiateVaultLock":{"http":{"requestUri":"/{accountId}/vaults/{vaultName}/lock-policy","responseCode":201},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"policy":{"type":"structure","members":{"Policy":{}}}},"payload":"policy"},"output":{"type":"structure","members":{"lockId":{"location":"header","locationName":"x-amz-lock-id"}}}},"ListJobs":{"http":{"method":"GET","requestUri":"/{accountId}/vaults/{vaultName}/jobs"},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"limit":{"location":"querystring","locationName":"limit"},"marker":{"location":"querystring","locationName":"marker"},"statuscode":{"location":"querystring","locationName":"statuscode"},"completed":{"location":"querystring","locationName":"completed"}}},"output":{"type":"structure","members":{"JobList":{"type":"list","member":{"shape":"Si"}},"Marker":{}}}},"ListMultipartUploads":{"http":{"method":"GET","requestUri":"/{accountId}/vaults/{vaultName}/multipart-uploads"},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"marker":{"location":"querystring","locationName":"marker"},"limit":{"location":"querystring","locationName":"limit"}}},"output":{"type":"structure","members":{"UploadsList":{"type":"list","member":{"type":"structure","members":{"MultipartUploadId":{},"VaultARN":{},"ArchiveDescription":{},"PartSizeInBytes":{"type":"long"},"CreationDate":{}}}},"Marker":{}}}},"ListParts":{"http":{"method":"GET","requestUri":"/{accountId}/vaults/{vaultName}/multipart-uploads/{uploadId}"},"input":{"type":"structure","required":["accountId","vaultName","uploadId"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"uploadId":{"location":"uri","locationName":"uploadId"},"marker":{"location":"querystring","locationName":"marker"},"limit":{"location":"querystring","locationName":"limit"}}},"output":{"type":"structure","members":{"MultipartUploadId":{},"VaultARN":{},"ArchiveDescription":{},"PartSizeInBytes":{"type":"long"},"CreationDate":{},"Parts":{"type":"list","member":{"type":"structure","members":{"RangeInBytes":{},"SHA256TreeHash":{}}}},"Marker":{}}}},"ListProvisionedCapacity":{"http":{"method":"GET","requestUri":"/{accountId}/provisioned-capacity"},"input":{"type":"structure","required":["accountId"],"members":{"accountId":{"location":"uri","locationName":"accountId"}}},"output":{"type":"structure","members":{"ProvisionedCapacityList":{"type":"list","member":{"type":"structure","members":{"CapacityId":{},"StartDate":{},"ExpirationDate":{}}}}}}},"ListTagsForVault":{"http":{"method":"GET","requestUri":"/{accountId}/vaults/{vaultName}/tags"},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S5"}}}},"ListVaults":{"http":{"method":"GET","requestUri":"/{accountId}/vaults"},"input":{"type":"structure","required":["accountId"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"marker":{"location":"querystring","locationName":"marker"},"limit":{"location":"querystring","locationName":"limit"}}},"output":{"type":"structure","members":{"VaultList":{"type":"list","member":{"shape":"S1a"}},"Marker":{}}}},"PurchaseProvisionedCapacity":{"http":{"requestUri":"/{accountId}/provisioned-capacity","responseCode":201},"input":{"type":"structure","required":["accountId"],"members":{"accountId":{"location":"uri","locationName":"accountId"}}},"output":{"type":"structure","members":{"capacityId":{"location":"header","locationName":"x-amz-capacity-id"}}}},"RemoveTagsFromVault":{"http":{"requestUri":"/{accountId}/vaults/{vaultName}/tags?operation=remove","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"TagKeys":{"type":"list","member":{}}}}},"SetDataRetrievalPolicy":{"http":{"method":"PUT","requestUri":"/{accountId}/policies/data-retrieval","responseCode":204},"input":{"type":"structure","required":["accountId"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"Policy":{"shape":"S1e"}}}},"SetVaultAccessPolicy":{"http":{"method":"PUT","requestUri":"/{accountId}/vaults/{vaultName}/access-policy","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"policy":{"shape":"S1o"}},"payload":"policy"}},"SetVaultNotifications":{"http":{"method":"PUT","requestUri":"/{accountId}/vaults/{vaultName}/notification-configuration","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"vaultNotificationConfig":{"shape":"S1t"}},"payload":"vaultNotificationConfig"}},"UploadArchive":{"http":{"requestUri":"/{accountId}/vaults/{vaultName}/archives","responseCode":201},"input":{"type":"structure","required":["vaultName","accountId"],"members":{"vaultName":{"location":"uri","locationName":"vaultName"},"accountId":{"location":"uri","locationName":"accountId"},"archiveDescription":{"location":"header","locationName":"x-amz-archive-description"},"checksum":{"location":"header","locationName":"x-amz-sha256-tree-hash"},"body":{"shape":"S1k"}},"payload":"body"},"output":{"shape":"S9"}},"UploadMultipartPart":{"http":{"method":"PUT","requestUri":"/{accountId}/vaults/{vaultName}/multipart-uploads/{uploadId}","responseCode":204},"input":{"type":"structure","required":["accountId","vaultName","uploadId"],"members":{"accountId":{"location":"uri","locationName":"accountId"},"vaultName":{"location":"uri","locationName":"vaultName"},"uploadId":{"location":"uri","locationName":"uploadId"},"checksum":{"location":"header","locationName":"x-amz-sha256-tree-hash"},"range":{"location":"header","locationName":"Content-Range"},"body":{"shape":"S1k"}},"payload":"body"},"output":{"type":"structure","members":{"checksum":{"location":"header","locationName":"x-amz-sha256-tree-hash"}}}}},"shapes":{"S5":{"type":"map","key":{},"value":{}},"S9":{"type":"structure","members":{"location":{"location":"header","locationName":"Location"},"checksum":{"location":"header","locationName":"x-amz-sha256-tree-hash"},"archiveId":{"location":"header","locationName":"x-amz-archive-id"}}},"Si":{"type":"structure","members":{"JobId":{},"JobDescription":{},"Action":{},"ArchiveId":{},"VaultARN":{},"CreationDate":{},"Completed":{"type":"boolean"},"StatusCode":{},"StatusMessage":{},"ArchiveSizeInBytes":{"type":"long"},"InventorySizeInBytes":{"type":"long"},"SNSTopic":{},"CompletionDate":{},"SHA256TreeHash":{},"ArchiveSHA256TreeHash":{},"RetrievalByteRange":{},"Tier":{},"InventoryRetrievalParameters":{"type":"structure","members":{"Format":{},"StartDate":{},"EndDate":{},"Limit":{},"Marker":{}}},"JobOutputPath":{},"SelectParameters":{"shape":"Sp"},"OutputLocation":{"shape":"Sx"}}},"Sp":{"type":"structure","members":{"InputSerialization":{"type":"structure","members":{"csv":{"type":"structure","members":{"FileHeaderInfo":{},"Comments":{},"QuoteEscapeCharacter":{},"RecordDelimiter":{},"FieldDelimiter":{},"QuoteCharacter":{}}}}},"ExpressionType":{},"Expression":{},"OutputSerialization":{"type":"structure","members":{"csv":{"type":"structure","members":{"QuoteFields":{},"QuoteEscapeCharacter":{},"RecordDelimiter":{},"FieldDelimiter":{},"QuoteCharacter":{}}}}}}},"Sx":{"type":"structure","members":{"S3":{"type":"structure","members":{"BucketName":{},"Prefix":{},"Encryption":{"type":"structure","members":{"EncryptionType":{},"KMSKeyId":{},"KMSContext":{}}},"CannedACL":{},"AccessControlList":{"type":"list","member":{"type":"structure","members":{"Grantee":{"type":"structure","required":["Type"],"members":{"Type":{},"DisplayName":{},"URI":{},"ID":{},"EmailAddress":{}}},"Permission":{}}}},"Tagging":{"shape":"S17"},"UserMetadata":{"shape":"S17"},"StorageClass":{}}}}},"S17":{"type":"map","key":{},"value":{}},"S1a":{"type":"structure","members":{"VaultARN":{},"VaultName":{},"CreationDate":{},"LastInventoryDate":{},"NumberOfArchives":{"type":"long"},"SizeInBytes":{"type":"long"}}},"S1e":{"type":"structure","members":{"Rules":{"type":"list","member":{"type":"structure","members":{"Strategy":{},"BytesPerHour":{"type":"long"}}}}}},"S1k":{"type":"blob","streaming":true},"S1o":{"type":"structure","members":{"Policy":{}}},"S1t":{"type":"structure","members":{"SNSTopic":{},"Events":{"type":"list","member":{}}}}}}');

});

parcelRequire.register("a6BUa", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListJobs":{"input_token":"marker","limit_key":"limit","output_token":"Marker","result_key":"JobList"},"ListMultipartUploads":{"input_token":"marker","limit_key":"limit","output_token":"Marker","result_key":"UploadsList"},"ListParts":{"input_token":"marker","limit_key":"limit","output_token":"Marker","result_key":"Parts"},"ListVaults":{"input_token":"marker","limit_key":"limit","output_token":"Marker","result_key":"VaultList"}}}');

});

parcelRequire.register("kUcI5", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"VaultExists":{"operation":"DescribeVault","delay":3,"maxAttempts":15,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"ResourceNotFoundException"}]},"VaultNotExists":{"operation":"DescribeVault","delay":3,"maxAttempts":15,"acceptors":[{"state":"retry","matcher":"status","expected":200},{"state":"success","matcher":"error","expected":"ResourceNotFoundException"}]}}}');

});


parcelRequire.register("63Qtg", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $469bb986685617df$var$Service = $dbC7k.Service;
var $469bb986685617df$var$apiLoader = $dbC7k.apiLoader;
$469bb986685617df$var$apiLoader.services["health"] = {};
$dbC7k.Health = $469bb986685617df$var$Service.defineService("health", [
    "2016-08-04"
]);


Object.defineProperty($469bb986685617df$var$apiLoader.services["health"], "2016-08-04", {
    get: function get() {
        var model = (parcelRequire("kHOY5"));
        model.paginators = (parcelRequire("aJn0y")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Health;

});
parcelRequire.register("kHOY5", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-08-04","endpointPrefix":"health","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"AWSHealth","serviceFullName":"AWS Health APIs and Notifications","serviceId":"Health","signatureVersion":"v4","targetPrefix":"AWSHealth_20160804","uid":"health-2016-08-04"},"operations":{"DescribeAffectedEntities":{"input":{"type":"structure","required":["filter"],"members":{"filter":{"type":"structure","required":["eventArns"],"members":{"eventArns":{"shape":"S3"},"entityArns":{"shape":"S5"},"entityValues":{"shape":"S7"},"lastUpdatedTimes":{"shape":"S9"},"tags":{"shape":"Sc"},"statusCodes":{"type":"list","member":{}}}},"locale":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"entities":{"type":"list","member":{"type":"structure","members":{"entityArn":{},"eventArn":{},"entityValue":{},"entityUrl":{},"awsAccountId":{},"lastUpdatedTime":{"type":"timestamp"},"statusCode":{},"tags":{"shape":"Sd"}}}},"nextToken":{}}},"idempotent":true},"DescribeEntityAggregates":{"input":{"type":"structure","members":{"eventArns":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"entityAggregates":{"type":"list","member":{"type":"structure","members":{"eventArn":{},"count":{"type":"integer"}}}}}},"idempotent":true},"DescribeEventAggregates":{"input":{"type":"structure","required":["aggregateField"],"members":{"filter":{"shape":"Sx"},"aggregateField":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"eventAggregates":{"type":"list","member":{"type":"structure","members":{"aggregateValue":{},"count":{"type":"integer"}}}},"nextToken":{}}},"idempotent":true},"DescribeEventDetails":{"input":{"type":"structure","required":["eventArns"],"members":{"eventArns":{"shape":"S3"},"locale":{}}},"output":{"type":"structure","members":{"successfulSet":{"type":"list","member":{"type":"structure","members":{"event":{"shape":"S1j"},"eventDescription":{"type":"structure","members":{"latestDescription":{}}},"eventMetadata":{"type":"map","key":{},"value":{}}}}},"failedSet":{"type":"list","member":{"type":"structure","members":{"eventArn":{},"errorName":{},"errorMessage":{}}}}}},"idempotent":true},"DescribeEventTypes":{"input":{"type":"structure","members":{"filter":{"type":"structure","members":{"eventTypeCodes":{"type":"list","member":{}},"services":{"shape":"S10"},"eventTypeCategories":{"type":"list","member":{}}}},"locale":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"eventTypes":{"type":"list","member":{"type":"structure","members":{"service":{},"code":{},"category":{}}}},"nextToken":{}}},"idempotent":true},"DescribeEvents":{"input":{"type":"structure","members":{"filter":{"shape":"Sx"},"nextToken":{},"maxResults":{"type":"integer"},"locale":{}}},"output":{"type":"structure","members":{"events":{"type":"list","member":{"shape":"S1j"}},"nextToken":{}}},"idempotent":true}},"shapes":{"S3":{"type":"list","member":{}},"S5":{"type":"list","member":{}},"S7":{"type":"list","member":{}},"S9":{"type":"list","member":{"type":"structure","members":{"from":{"type":"timestamp"},"to":{"type":"timestamp"}}}},"Sc":{"type":"list","member":{"shape":"Sd"}},"Sd":{"type":"map","key":{},"value":{}},"Sx":{"type":"structure","members":{"eventArns":{"shape":"S3"},"eventTypeCodes":{"type":"list","member":{}},"services":{"shape":"S10"},"regions":{"type":"list","member":{}},"availabilityZones":{"type":"list","member":{}},"startTimes":{"shape":"S9"},"endTimes":{"shape":"S9"},"lastUpdatedTimes":{"shape":"S9"},"entityArns":{"shape":"S5"},"entityValues":{"shape":"S7"},"eventTypeCategories":{"type":"list","member":{}},"tags":{"shape":"Sc"},"eventStatusCodes":{"type":"list","member":{}}}},"S10":{"type":"list","member":{}},"S1j":{"type":"structure","members":{"arn":{},"service":{},"eventTypeCode":{},"eventTypeCategory":{},"region":{},"availabilityZone":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"lastUpdatedTime":{"type":"timestamp"},"statusCode":{}}}}}');

});

parcelRequire.register("aJn0y", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeAffectedEntities":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"entities"},"DescribeEntityAggregates":{"result_key":"entityAggregates"},"DescribeEventAggregates":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"eventAggregates"},"DescribeEventTypes":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"eventTypes"},"DescribeEvents":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"events"}}}');

});


parcelRequire.register("eExGZ", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $aaaeefb42d6fcaba$var$Service = $dbC7k.Service;
var $aaaeefb42d6fcaba$var$apiLoader = $dbC7k.apiLoader;
$aaaeefb42d6fcaba$var$apiLoader.services["iam"] = {};
$dbC7k.IAM = $aaaeefb42d6fcaba$var$Service.defineService("iam", [
    "2010-05-08"
]);



Object.defineProperty($aaaeefb42d6fcaba$var$apiLoader.services["iam"], "2010-05-08", {
    get: function get() {
        var model = (parcelRequire("6ndIH"));
        model.paginators = (parcelRequire("49ZCE")).pagination;
        model.waiters = (parcelRequire("lyEup")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.IAM;

});
parcelRequire.register("6ndIH", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2010-05-08","endpointPrefix":"iam","globalEndpoint":"iam.amazonaws.com","protocol":"query","serviceAbbreviation":"IAM","serviceFullName":"AWS Identity and Access Management","serviceId":"IAM","signatureVersion":"v4","uid":"iam-2010-05-08","xmlNamespace":"https://iam.amazonaws.com/doc/2010-05-08/"},"operations":{"AddClientIDToOpenIDConnectProvider":{"input":{"type":"structure","required":["OpenIDConnectProviderArn","ClientID"],"members":{"OpenIDConnectProviderArn":{},"ClientID":{}}}},"AddRoleToInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName","RoleName"],"members":{"InstanceProfileName":{},"RoleName":{}}}},"AddUserToGroup":{"input":{"type":"structure","required":["GroupName","UserName"],"members":{"GroupName":{},"UserName":{}}}},"AttachGroupPolicy":{"input":{"type":"structure","required":["GroupName","PolicyArn"],"members":{"GroupName":{},"PolicyArn":{}}}},"AttachRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyArn"],"members":{"RoleName":{},"PolicyArn":{}}}},"AttachUserPolicy":{"input":{"type":"structure","required":["UserName","PolicyArn"],"members":{"UserName":{},"PolicyArn":{}}}},"ChangePassword":{"input":{"type":"structure","required":["OldPassword","NewPassword"],"members":{"OldPassword":{"shape":"Sf"},"NewPassword":{"shape":"Sf"}}}},"CreateAccessKey":{"input":{"type":"structure","members":{"UserName":{}}},"output":{"resultWrapper":"CreateAccessKeyResult","type":"structure","required":["AccessKey"],"members":{"AccessKey":{"type":"structure","required":["UserName","AccessKeyId","Status","SecretAccessKey"],"members":{"UserName":{},"AccessKeyId":{},"Status":{},"SecretAccessKey":{"type":"string","sensitive":true},"CreateDate":{"type":"timestamp"}}}}}},"CreateAccountAlias":{"input":{"type":"structure","required":["AccountAlias"],"members":{"AccountAlias":{}}}},"CreateGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"Path":{},"GroupName":{}}},"output":{"resultWrapper":"CreateGroupResult","type":"structure","required":["Group"],"members":{"Group":{"shape":"Ss"}}}},"CreateInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName"],"members":{"InstanceProfileName":{},"Path":{}}},"output":{"resultWrapper":"CreateInstanceProfileResult","type":"structure","required":["InstanceProfile"],"members":{"InstanceProfile":{"shape":"Sw"}}}},"CreateLoginProfile":{"input":{"type":"structure","required":["UserName","Password"],"members":{"UserName":{},"Password":{"shape":"Sf"},"PasswordResetRequired":{"type":"boolean"}}},"output":{"resultWrapper":"CreateLoginProfileResult","type":"structure","required":["LoginProfile"],"members":{"LoginProfile":{"shape":"S1b"}}}},"CreateOpenIDConnectProvider":{"input":{"type":"structure","required":["Url","ThumbprintList"],"members":{"Url":{},"ClientIDList":{"shape":"S1e"},"ThumbprintList":{"shape":"S1f"}}},"output":{"resultWrapper":"CreateOpenIDConnectProviderResult","type":"structure","members":{"OpenIDConnectProviderArn":{}}}},"CreatePolicy":{"input":{"type":"structure","required":["PolicyName","PolicyDocument"],"members":{"PolicyName":{},"Path":{},"PolicyDocument":{},"Description":{}}},"output":{"resultWrapper":"CreatePolicyResult","type":"structure","members":{"Policy":{"shape":"S1n"}}}},"CreatePolicyVersion":{"input":{"type":"structure","required":["PolicyArn","PolicyDocument"],"members":{"PolicyArn":{},"PolicyDocument":{},"SetAsDefault":{"type":"boolean"}}},"output":{"resultWrapper":"CreatePolicyVersionResult","type":"structure","members":{"PolicyVersion":{"shape":"S1s"}}}},"CreateRole":{"input":{"type":"structure","required":["RoleName","AssumeRolePolicyDocument"],"members":{"Path":{},"RoleName":{},"AssumeRolePolicyDocument":{},"Description":{},"MaxSessionDuration":{"type":"integer"},"PermissionsBoundary":{},"Tags":{"shape":"S14"}}},"output":{"resultWrapper":"CreateRoleResult","type":"structure","required":["Role"],"members":{"Role":{"shape":"Sy"}}}},"CreateSAMLProvider":{"input":{"type":"structure","required":["SAMLMetadataDocument","Name"],"members":{"SAMLMetadataDocument":{},"Name":{}}},"output":{"resultWrapper":"CreateSAMLProviderResult","type":"structure","members":{"SAMLProviderArn":{}}}},"CreateServiceLinkedRole":{"input":{"type":"structure","required":["AWSServiceName"],"members":{"AWSServiceName":{},"Description":{},"CustomSuffix":{}}},"output":{"resultWrapper":"CreateServiceLinkedRoleResult","type":"structure","members":{"Role":{"shape":"Sy"}}}},"CreateServiceSpecificCredential":{"input":{"type":"structure","required":["UserName","ServiceName"],"members":{"UserName":{},"ServiceName":{}}},"output":{"resultWrapper":"CreateServiceSpecificCredentialResult","type":"structure","members":{"ServiceSpecificCredential":{"shape":"S25"}}}},"CreateUser":{"input":{"type":"structure","required":["UserName"],"members":{"Path":{},"UserName":{},"PermissionsBoundary":{},"Tags":{"shape":"S14"}}},"output":{"resultWrapper":"CreateUserResult","type":"structure","members":{"User":{"shape":"S2b"}}}},"CreateVirtualMFADevice":{"input":{"type":"structure","required":["VirtualMFADeviceName"],"members":{"Path":{},"VirtualMFADeviceName":{}}},"output":{"resultWrapper":"CreateVirtualMFADeviceResult","type":"structure","required":["VirtualMFADevice"],"members":{"VirtualMFADevice":{"shape":"S2f"}}}},"DeactivateMFADevice":{"input":{"type":"structure","required":["UserName","SerialNumber"],"members":{"UserName":{},"SerialNumber":{}}}},"DeleteAccessKey":{"input":{"type":"structure","required":["AccessKeyId"],"members":{"UserName":{},"AccessKeyId":{}}}},"DeleteAccountAlias":{"input":{"type":"structure","required":["AccountAlias"],"members":{"AccountAlias":{}}}},"DeleteAccountPasswordPolicy":{},"DeleteGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{}}}},"DeleteGroupPolicy":{"input":{"type":"structure","required":["GroupName","PolicyName"],"members":{"GroupName":{},"PolicyName":{}}}},"DeleteInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName"],"members":{"InstanceProfileName":{}}}},"DeleteLoginProfile":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{}}}},"DeleteOpenIDConnectProvider":{"input":{"type":"structure","required":["OpenIDConnectProviderArn"],"members":{"OpenIDConnectProviderArn":{}}}},"DeletePolicy":{"input":{"type":"structure","required":["PolicyArn"],"members":{"PolicyArn":{}}}},"DeletePolicyVersion":{"input":{"type":"structure","required":["PolicyArn","VersionId"],"members":{"PolicyArn":{},"VersionId":{}}}},"DeleteRole":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{}}}},"DeleteRolePermissionsBoundary":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{}}}},"DeleteRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyName"],"members":{"RoleName":{},"PolicyName":{}}}},"DeleteSAMLProvider":{"input":{"type":"structure","required":["SAMLProviderArn"],"members":{"SAMLProviderArn":{}}}},"DeleteSSHPublicKey":{"input":{"type":"structure","required":["UserName","SSHPublicKeyId"],"members":{"UserName":{},"SSHPublicKeyId":{}}}},"DeleteServerCertificate":{"input":{"type":"structure","required":["ServerCertificateName"],"members":{"ServerCertificateName":{}}}},"DeleteServiceLinkedRole":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{}}},"output":{"resultWrapper":"DeleteServiceLinkedRoleResult","type":"structure","required":["DeletionTaskId"],"members":{"DeletionTaskId":{}}}},"DeleteServiceSpecificCredential":{"input":{"type":"structure","required":["ServiceSpecificCredentialId"],"members":{"UserName":{},"ServiceSpecificCredentialId":{}}}},"DeleteSigningCertificate":{"input":{"type":"structure","required":["CertificateId"],"members":{"UserName":{},"CertificateId":{}}}},"DeleteUser":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{}}}},"DeleteUserPermissionsBoundary":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{}}}},"DeleteUserPolicy":{"input":{"type":"structure","required":["UserName","PolicyName"],"members":{"UserName":{},"PolicyName":{}}}},"DeleteVirtualMFADevice":{"input":{"type":"structure","required":["SerialNumber"],"members":{"SerialNumber":{}}}},"DetachGroupPolicy":{"input":{"type":"structure","required":["GroupName","PolicyArn"],"members":{"GroupName":{},"PolicyArn":{}}}},"DetachRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyArn"],"members":{"RoleName":{},"PolicyArn":{}}}},"DetachUserPolicy":{"input":{"type":"structure","required":["UserName","PolicyArn"],"members":{"UserName":{},"PolicyArn":{}}}},"EnableMFADevice":{"input":{"type":"structure","required":["UserName","SerialNumber","AuthenticationCode1","AuthenticationCode2"],"members":{"UserName":{},"SerialNumber":{},"AuthenticationCode1":{},"AuthenticationCode2":{}}}},"GenerateCredentialReport":{"output":{"resultWrapper":"GenerateCredentialReportResult","type":"structure","members":{"State":{},"Description":{}}}},"GenerateOrganizationsAccessReport":{"input":{"type":"structure","required":["EntityPath"],"members":{"EntityPath":{},"OrganizationsPolicyId":{}}},"output":{"resultWrapper":"GenerateOrganizationsAccessReportResult","type":"structure","members":{"JobId":{}}}},"GenerateServiceLastAccessedDetails":{"input":{"type":"structure","required":["Arn"],"members":{"Arn":{}}},"output":{"resultWrapper":"GenerateServiceLastAccessedDetailsResult","type":"structure","members":{"JobId":{}}}},"GetAccessKeyLastUsed":{"input":{"type":"structure","required":["AccessKeyId"],"members":{"AccessKeyId":{}}},"output":{"resultWrapper":"GetAccessKeyLastUsedResult","type":"structure","members":{"UserName":{},"AccessKeyLastUsed":{"type":"structure","required":["LastUsedDate","ServiceName","Region"],"members":{"LastUsedDate":{"type":"timestamp"},"ServiceName":{},"Region":{}}}}}},"GetAccountAuthorizationDetails":{"input":{"type":"structure","members":{"Filter":{"type":"list","member":{}},"MaxItems":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"GetAccountAuthorizationDetailsResult","type":"structure","members":{"UserDetailList":{"type":"list","member":{"type":"structure","members":{"Path":{},"UserName":{},"UserId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"UserPolicyList":{"shape":"S41"},"GroupList":{"type":"list","member":{}},"AttachedManagedPolicies":{"shape":"S44"},"PermissionsBoundary":{"shape":"S12"},"Tags":{"shape":"S14"}}}},"GroupDetailList":{"type":"list","member":{"type":"structure","members":{"Path":{},"GroupName":{},"GroupId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"GroupPolicyList":{"shape":"S41"},"AttachedManagedPolicies":{"shape":"S44"}}}},"RoleDetailList":{"type":"list","member":{"type":"structure","members":{"Path":{},"RoleName":{},"RoleId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"AssumeRolePolicyDocument":{},"InstanceProfileList":{"shape":"S4a"},"RolePolicyList":{"shape":"S41"},"AttachedManagedPolicies":{"shape":"S44"},"PermissionsBoundary":{"shape":"S12"},"Tags":{"shape":"S14"}}}},"Policies":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"PolicyId":{},"Arn":{},"Path":{},"DefaultVersionId":{},"AttachmentCount":{"type":"integer"},"PermissionsBoundaryUsageCount":{"type":"integer"},"IsAttachable":{"type":"boolean"},"Description":{},"CreateDate":{"type":"timestamp"},"UpdateDate":{"type":"timestamp"},"PolicyVersionList":{"shape":"S4d"}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"GetAccountPasswordPolicy":{"output":{"resultWrapper":"GetAccountPasswordPolicyResult","type":"structure","required":["PasswordPolicy"],"members":{"PasswordPolicy":{"type":"structure","members":{"MinimumPasswordLength":{"type":"integer"},"RequireSymbols":{"type":"boolean"},"RequireNumbers":{"type":"boolean"},"RequireUppercaseCharacters":{"type":"boolean"},"RequireLowercaseCharacters":{"type":"boolean"},"AllowUsersToChangePassword":{"type":"boolean"},"ExpirePasswords":{"type":"boolean"},"MaxPasswordAge":{"type":"integer"},"PasswordReusePrevention":{"type":"integer"},"HardExpiry":{"type":"boolean"}}}}}},"GetAccountSummary":{"output":{"resultWrapper":"GetAccountSummaryResult","type":"structure","members":{"SummaryMap":{"type":"map","key":{},"value":{"type":"integer"}}}}},"GetContextKeysForCustomPolicy":{"input":{"type":"structure","required":["PolicyInputList"],"members":{"PolicyInputList":{"shape":"S4q"}}},"output":{"shape":"S4r","resultWrapper":"GetContextKeysForCustomPolicyResult"}},"GetContextKeysForPrincipalPolicy":{"input":{"type":"structure","required":["PolicySourceArn"],"members":{"PolicySourceArn":{},"PolicyInputList":{"shape":"S4q"}}},"output":{"shape":"S4r","resultWrapper":"GetContextKeysForPrincipalPolicyResult"}},"GetCredentialReport":{"output":{"resultWrapper":"GetCredentialReportResult","type":"structure","members":{"Content":{"type":"blob"},"ReportFormat":{},"GeneratedTime":{"type":"timestamp"}}}},"GetGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"GetGroupResult","type":"structure","required":["Group","Users"],"members":{"Group":{"shape":"Ss"},"Users":{"shape":"S50"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"GetGroupPolicy":{"input":{"type":"structure","required":["GroupName","PolicyName"],"members":{"GroupName":{},"PolicyName":{}}},"output":{"resultWrapper":"GetGroupPolicyResult","type":"structure","required":["GroupName","PolicyName","PolicyDocument"],"members":{"GroupName":{},"PolicyName":{},"PolicyDocument":{}}}},"GetInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName"],"members":{"InstanceProfileName":{}}},"output":{"resultWrapper":"GetInstanceProfileResult","type":"structure","required":["InstanceProfile"],"members":{"InstanceProfile":{"shape":"Sw"}}}},"GetLoginProfile":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{}}},"output":{"resultWrapper":"GetLoginProfileResult","type":"structure","required":["LoginProfile"],"members":{"LoginProfile":{"shape":"S1b"}}}},"GetOpenIDConnectProvider":{"input":{"type":"structure","required":["OpenIDConnectProviderArn"],"members":{"OpenIDConnectProviderArn":{}}},"output":{"resultWrapper":"GetOpenIDConnectProviderResult","type":"structure","members":{"Url":{},"ClientIDList":{"shape":"S1e"},"ThumbprintList":{"shape":"S1f"},"CreateDate":{"type":"timestamp"}}}},"GetOrganizationsAccessReport":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxItems":{"type":"integer"},"Marker":{},"SortKey":{}}},"output":{"resultWrapper":"GetOrganizationsAccessReportResult","type":"structure","required":["JobStatus","JobCreationDate"],"members":{"JobStatus":{},"JobCreationDate":{"type":"timestamp"},"JobCompletionDate":{"type":"timestamp"},"NumberOfServicesAccessible":{"type":"integer"},"NumberOfServicesNotAccessed":{"type":"integer"},"AccessDetails":{"type":"list","member":{"type":"structure","required":["ServiceName","ServiceNamespace"],"members":{"ServiceName":{},"ServiceNamespace":{},"Region":{},"EntityPath":{},"LastAuthenticatedTime":{"type":"timestamp"},"TotalAuthenticatedEntities":{"type":"integer"}}}},"IsTruncated":{"type":"boolean"},"Marker":{},"ErrorDetails":{"shape":"S5i"}}}},"GetPolicy":{"input":{"type":"structure","required":["PolicyArn"],"members":{"PolicyArn":{}}},"output":{"resultWrapper":"GetPolicyResult","type":"structure","members":{"Policy":{"shape":"S1n"}}}},"GetPolicyVersion":{"input":{"type":"structure","required":["PolicyArn","VersionId"],"members":{"PolicyArn":{},"VersionId":{}}},"output":{"resultWrapper":"GetPolicyVersionResult","type":"structure","members":{"PolicyVersion":{"shape":"S1s"}}}},"GetRole":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{}}},"output":{"resultWrapper":"GetRoleResult","type":"structure","required":["Role"],"members":{"Role":{"shape":"Sy"}}}},"GetRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyName"],"members":{"RoleName":{},"PolicyName":{}}},"output":{"resultWrapper":"GetRolePolicyResult","type":"structure","required":["RoleName","PolicyName","PolicyDocument"],"members":{"RoleName":{},"PolicyName":{},"PolicyDocument":{}}}},"GetSAMLProvider":{"input":{"type":"structure","required":["SAMLProviderArn"],"members":{"SAMLProviderArn":{}}},"output":{"resultWrapper":"GetSAMLProviderResult","type":"structure","members":{"SAMLMetadataDocument":{},"CreateDate":{"type":"timestamp"},"ValidUntil":{"type":"timestamp"}}}},"GetSSHPublicKey":{"input":{"type":"structure","required":["UserName","SSHPublicKeyId","Encoding"],"members":{"UserName":{},"SSHPublicKeyId":{},"Encoding":{}}},"output":{"resultWrapper":"GetSSHPublicKeyResult","type":"structure","members":{"SSHPublicKey":{"shape":"S5w"}}}},"GetServerCertificate":{"input":{"type":"structure","required":["ServerCertificateName"],"members":{"ServerCertificateName":{}}},"output":{"resultWrapper":"GetServerCertificateResult","type":"structure","required":["ServerCertificate"],"members":{"ServerCertificate":{"type":"structure","required":["ServerCertificateMetadata","CertificateBody"],"members":{"ServerCertificateMetadata":{"shape":"S62"},"CertificateBody":{},"CertificateChain":{}}}}}},"GetServiceLastAccessedDetails":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxItems":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"GetServiceLastAccessedDetailsResult","type":"structure","required":["JobStatus","JobCreationDate","ServicesLastAccessed","JobCompletionDate"],"members":{"JobStatus":{},"JobCreationDate":{"type":"timestamp"},"ServicesLastAccessed":{"type":"list","member":{"type":"structure","required":["ServiceName","ServiceNamespace"],"members":{"ServiceName":{},"LastAuthenticated":{"type":"timestamp"},"ServiceNamespace":{},"LastAuthenticatedEntity":{},"TotalAuthenticatedEntities":{"type":"integer"}}}},"JobCompletionDate":{"type":"timestamp"},"IsTruncated":{"type":"boolean"},"Marker":{},"Error":{"shape":"S5i"}}}},"GetServiceLastAccessedDetailsWithEntities":{"input":{"type":"structure","required":["JobId","ServiceNamespace"],"members":{"JobId":{},"ServiceNamespace":{},"MaxItems":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"GetServiceLastAccessedDetailsWithEntitiesResult","type":"structure","required":["JobStatus","JobCreationDate","JobCompletionDate","EntityDetailsList"],"members":{"JobStatus":{},"JobCreationDate":{"type":"timestamp"},"JobCompletionDate":{"type":"timestamp"},"EntityDetailsList":{"type":"list","member":{"type":"structure","required":["EntityInfo"],"members":{"EntityInfo":{"type":"structure","required":["Arn","Name","Type","Id"],"members":{"Arn":{},"Name":{},"Type":{},"Id":{},"Path":{}}},"LastAuthenticated":{"type":"timestamp"}}}},"IsTruncated":{"type":"boolean"},"Marker":{},"Error":{"shape":"S5i"}}}},"GetServiceLinkedRoleDeletionStatus":{"input":{"type":"structure","required":["DeletionTaskId"],"members":{"DeletionTaskId":{}}},"output":{"resultWrapper":"GetServiceLinkedRoleDeletionStatusResult","type":"structure","required":["Status"],"members":{"Status":{},"Reason":{"type":"structure","members":{"Reason":{},"RoleUsageList":{"type":"list","member":{"type":"structure","members":{"Region":{},"Resources":{"type":"list","member":{}}}}}}}}}},"GetUser":{"input":{"type":"structure","members":{"UserName":{}}},"output":{"resultWrapper":"GetUserResult","type":"structure","required":["User"],"members":{"User":{"shape":"S2b"}}}},"GetUserPolicy":{"input":{"type":"structure","required":["UserName","PolicyName"],"members":{"UserName":{},"PolicyName":{}}},"output":{"resultWrapper":"GetUserPolicyResult","type":"structure","required":["UserName","PolicyName","PolicyDocument"],"members":{"UserName":{},"PolicyName":{},"PolicyDocument":{}}}},"ListAccessKeys":{"input":{"type":"structure","members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListAccessKeysResult","type":"structure","required":["AccessKeyMetadata"],"members":{"AccessKeyMetadata":{"type":"list","member":{"type":"structure","members":{"UserName":{},"AccessKeyId":{},"Status":{},"CreateDate":{"type":"timestamp"}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListAccountAliases":{"input":{"type":"structure","members":{"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListAccountAliasesResult","type":"structure","required":["AccountAliases"],"members":{"AccountAliases":{"type":"list","member":{}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListAttachedGroupPolicies":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListAttachedGroupPoliciesResult","type":"structure","members":{"AttachedPolicies":{"shape":"S44"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListAttachedRolePolicies":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{},"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListAttachedRolePoliciesResult","type":"structure","members":{"AttachedPolicies":{"shape":"S44"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListAttachedUserPolicies":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListAttachedUserPoliciesResult","type":"structure","members":{"AttachedPolicies":{"shape":"S44"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListEntitiesForPolicy":{"input":{"type":"structure","required":["PolicyArn"],"members":{"PolicyArn":{},"EntityFilter":{},"PathPrefix":{},"PolicyUsageFilter":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListEntitiesForPolicyResult","type":"structure","members":{"PolicyGroups":{"type":"list","member":{"type":"structure","members":{"GroupName":{},"GroupId":{}}}},"PolicyUsers":{"type":"list","member":{"type":"structure","members":{"UserName":{},"UserId":{}}}},"PolicyRoles":{"type":"list","member":{"type":"structure","members":{"RoleName":{},"RoleId":{}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListGroupPolicies":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListGroupPoliciesResult","type":"structure","required":["PolicyNames"],"members":{"PolicyNames":{"shape":"S7g"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListGroups":{"input":{"type":"structure","members":{"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListGroupsResult","type":"structure","required":["Groups"],"members":{"Groups":{"shape":"S7k"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListGroupsForUser":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListGroupsForUserResult","type":"structure","required":["Groups"],"members":{"Groups":{"shape":"S7k"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListInstanceProfiles":{"input":{"type":"structure","members":{"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListInstanceProfilesResult","type":"structure","required":["InstanceProfiles"],"members":{"InstanceProfiles":{"shape":"S4a"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListInstanceProfilesForRole":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListInstanceProfilesForRoleResult","type":"structure","required":["InstanceProfiles"],"members":{"InstanceProfiles":{"shape":"S4a"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListMFADevices":{"input":{"type":"structure","members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListMFADevicesResult","type":"structure","required":["MFADevices"],"members":{"MFADevices":{"type":"list","member":{"type":"structure","required":["UserName","SerialNumber","EnableDate"],"members":{"UserName":{},"SerialNumber":{},"EnableDate":{"type":"timestamp"}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListOpenIDConnectProviders":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"ListOpenIDConnectProvidersResult","type":"structure","members":{"OpenIDConnectProviderList":{"type":"list","member":{"type":"structure","members":{"Arn":{}}}}}}},"ListPolicies":{"input":{"type":"structure","members":{"Scope":{},"OnlyAttached":{"type":"boolean"},"PathPrefix":{},"PolicyUsageFilter":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListPoliciesResult","type":"structure","members":{"Policies":{"type":"list","member":{"shape":"S1n"}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListPoliciesGrantingServiceAccess":{"input":{"type":"structure","required":["Arn","ServiceNamespaces"],"members":{"Marker":{},"Arn":{},"ServiceNamespaces":{"type":"list","member":{}}}},"output":{"resultWrapper":"ListPoliciesGrantingServiceAccessResult","type":"structure","required":["PoliciesGrantingServiceAccess"],"members":{"PoliciesGrantingServiceAccess":{"type":"list","member":{"type":"structure","members":{"ServiceNamespace":{},"Policies":{"type":"list","member":{"type":"structure","required":["PolicyName","PolicyType"],"members":{"PolicyName":{},"PolicyType":{},"PolicyArn":{},"EntityType":{},"EntityName":{}}}}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListPolicyVersions":{"input":{"type":"structure","required":["PolicyArn"],"members":{"PolicyArn":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListPolicyVersionsResult","type":"structure","members":{"Versions":{"shape":"S4d"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListRolePolicies":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListRolePoliciesResult","type":"structure","required":["PolicyNames"],"members":{"PolicyNames":{"shape":"S7g"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListRoleTags":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListRoleTagsResult","type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S14"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListRoles":{"input":{"type":"structure","members":{"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListRolesResult","type":"structure","required":["Roles"],"members":{"Roles":{"shape":"Sx"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListSAMLProviders":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"ListSAMLProvidersResult","type":"structure","members":{"SAMLProviderList":{"type":"list","member":{"type":"structure","members":{"Arn":{},"ValidUntil":{"type":"timestamp"},"CreateDate":{"type":"timestamp"}}}}}}},"ListSSHPublicKeys":{"input":{"type":"structure","members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListSSHPublicKeysResult","type":"structure","members":{"SSHPublicKeys":{"type":"list","member":{"type":"structure","required":["UserName","SSHPublicKeyId","Status","UploadDate"],"members":{"UserName":{},"SSHPublicKeyId":{},"Status":{},"UploadDate":{"type":"timestamp"}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListServerCertificates":{"input":{"type":"structure","members":{"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListServerCertificatesResult","type":"structure","required":["ServerCertificateMetadataList"],"members":{"ServerCertificateMetadataList":{"type":"list","member":{"shape":"S62"}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListServiceSpecificCredentials":{"input":{"type":"structure","members":{"UserName":{},"ServiceName":{}}},"output":{"resultWrapper":"ListServiceSpecificCredentialsResult","type":"structure","members":{"ServiceSpecificCredentials":{"type":"list","member":{"type":"structure","required":["UserName","Status","ServiceUserName","CreateDate","ServiceSpecificCredentialId","ServiceName"],"members":{"UserName":{},"Status":{},"ServiceUserName":{},"CreateDate":{"type":"timestamp"},"ServiceSpecificCredentialId":{},"ServiceName":{}}}}}}},"ListSigningCertificates":{"input":{"type":"structure","members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListSigningCertificatesResult","type":"structure","required":["Certificates"],"members":{"Certificates":{"type":"list","member":{"shape":"S92"}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListUserPolicies":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListUserPoliciesResult","type":"structure","required":["PolicyNames"],"members":{"PolicyNames":{"shape":"S7g"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListUserTags":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListUserTagsResult","type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S14"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListUsers":{"input":{"type":"structure","members":{"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListUsersResult","type":"structure","required":["Users"],"members":{"Users":{"shape":"S50"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListVirtualMFADevices":{"input":{"type":"structure","members":{"AssignmentStatus":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListVirtualMFADevicesResult","type":"structure","required":["VirtualMFADevices"],"members":{"VirtualMFADevices":{"type":"list","member":{"shape":"S2f"}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"PutGroupPolicy":{"input":{"type":"structure","required":["GroupName","PolicyName","PolicyDocument"],"members":{"GroupName":{},"PolicyName":{},"PolicyDocument":{}}}},"PutRolePermissionsBoundary":{"input":{"type":"structure","required":["RoleName","PermissionsBoundary"],"members":{"RoleName":{},"PermissionsBoundary":{}}}},"PutRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyName","PolicyDocument"],"members":{"RoleName":{},"PolicyName":{},"PolicyDocument":{}}}},"PutUserPermissionsBoundary":{"input":{"type":"structure","required":["UserName","PermissionsBoundary"],"members":{"UserName":{},"PermissionsBoundary":{}}}},"PutUserPolicy":{"input":{"type":"structure","required":["UserName","PolicyName","PolicyDocument"],"members":{"UserName":{},"PolicyName":{},"PolicyDocument":{}}}},"RemoveClientIDFromOpenIDConnectProvider":{"input":{"type":"structure","required":["OpenIDConnectProviderArn","ClientID"],"members":{"OpenIDConnectProviderArn":{},"ClientID":{}}}},"RemoveRoleFromInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName","RoleName"],"members":{"InstanceProfileName":{},"RoleName":{}}}},"RemoveUserFromGroup":{"input":{"type":"structure","required":["GroupName","UserName"],"members":{"GroupName":{},"UserName":{}}}},"ResetServiceSpecificCredential":{"input":{"type":"structure","required":["ServiceSpecificCredentialId"],"members":{"UserName":{},"ServiceSpecificCredentialId":{}}},"output":{"resultWrapper":"ResetServiceSpecificCredentialResult","type":"structure","members":{"ServiceSpecificCredential":{"shape":"S25"}}}},"ResyncMFADevice":{"input":{"type":"structure","required":["UserName","SerialNumber","AuthenticationCode1","AuthenticationCode2"],"members":{"UserName":{},"SerialNumber":{},"AuthenticationCode1":{},"AuthenticationCode2":{}}}},"SetDefaultPolicyVersion":{"input":{"type":"structure","required":["PolicyArn","VersionId"],"members":{"PolicyArn":{},"VersionId":{}}}},"SetSecurityTokenServicePreferences":{"input":{"type":"structure","required":["GlobalEndpointTokenVersion"],"members":{"GlobalEndpointTokenVersion":{}}}},"SimulateCustomPolicy":{"input":{"type":"structure","required":["PolicyInputList","ActionNames"],"members":{"PolicyInputList":{"shape":"S4q"},"ActionNames":{"shape":"S9s"},"ResourceArns":{"shape":"S9u"},"ResourcePolicy":{},"ResourceOwner":{},"CallerArn":{},"ContextEntries":{"shape":"S9w"},"ResourceHandlingOption":{},"MaxItems":{"type":"integer"},"Marker":{}}},"output":{"shape":"Sa2","resultWrapper":"SimulateCustomPolicyResult"}},"SimulatePrincipalPolicy":{"input":{"type":"structure","required":["PolicySourceArn","ActionNames"],"members":{"PolicySourceArn":{},"PolicyInputList":{"shape":"S4q"},"ActionNames":{"shape":"S9s"},"ResourceArns":{"shape":"S9u"},"ResourcePolicy":{},"ResourceOwner":{},"CallerArn":{},"ContextEntries":{"shape":"S9w"},"ResourceHandlingOption":{},"MaxItems":{"type":"integer"},"Marker":{}}},"output":{"shape":"Sa2","resultWrapper":"SimulatePrincipalPolicyResult"}},"TagRole":{"input":{"type":"structure","required":["RoleName","Tags"],"members":{"RoleName":{},"Tags":{"shape":"S14"}}}},"TagUser":{"input":{"type":"structure","required":["UserName","Tags"],"members":{"UserName":{},"Tags":{"shape":"S14"}}}},"UntagRole":{"input":{"type":"structure","required":["RoleName","TagKeys"],"members":{"RoleName":{},"TagKeys":{"shape":"Sam"}}}},"UntagUser":{"input":{"type":"structure","required":["UserName","TagKeys"],"members":{"UserName":{},"TagKeys":{"shape":"Sam"}}}},"UpdateAccessKey":{"input":{"type":"structure","required":["AccessKeyId","Status"],"members":{"UserName":{},"AccessKeyId":{},"Status":{}}}},"UpdateAccountPasswordPolicy":{"input":{"type":"structure","members":{"MinimumPasswordLength":{"type":"integer"},"RequireSymbols":{"type":"boolean"},"RequireNumbers":{"type":"boolean"},"RequireUppercaseCharacters":{"type":"boolean"},"RequireLowercaseCharacters":{"type":"boolean"},"AllowUsersToChangePassword":{"type":"boolean"},"MaxPasswordAge":{"type":"integer"},"PasswordReusePrevention":{"type":"integer"},"HardExpiry":{"type":"boolean"}}}},"UpdateAssumeRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyDocument"],"members":{"RoleName":{},"PolicyDocument":{}}}},"UpdateGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"NewPath":{},"NewGroupName":{}}}},"UpdateLoginProfile":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"Password":{"shape":"Sf"},"PasswordResetRequired":{"type":"boolean"}}}},"UpdateOpenIDConnectProviderThumbprint":{"input":{"type":"structure","required":["OpenIDConnectProviderArn","ThumbprintList"],"members":{"OpenIDConnectProviderArn":{},"ThumbprintList":{"shape":"S1f"}}}},"UpdateRole":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{},"Description":{},"MaxSessionDuration":{"type":"integer"}}},"output":{"resultWrapper":"UpdateRoleResult","type":"structure","members":{}}},"UpdateRoleDescription":{"input":{"type":"structure","required":["RoleName","Description"],"members":{"RoleName":{},"Description":{}}},"output":{"resultWrapper":"UpdateRoleDescriptionResult","type":"structure","members":{"Role":{"shape":"Sy"}}}},"UpdateSAMLProvider":{"input":{"type":"structure","required":["SAMLMetadataDocument","SAMLProviderArn"],"members":{"SAMLMetadataDocument":{},"SAMLProviderArn":{}}},"output":{"resultWrapper":"UpdateSAMLProviderResult","type":"structure","members":{"SAMLProviderArn":{}}}},"UpdateSSHPublicKey":{"input":{"type":"structure","required":["UserName","SSHPublicKeyId","Status"],"members":{"UserName":{},"SSHPublicKeyId":{},"Status":{}}}},"UpdateServerCertificate":{"input":{"type":"structure","required":["ServerCertificateName"],"members":{"ServerCertificateName":{},"NewPath":{},"NewServerCertificateName":{}}}},"UpdateServiceSpecificCredential":{"input":{"type":"structure","required":["ServiceSpecificCredentialId","Status"],"members":{"UserName":{},"ServiceSpecificCredentialId":{},"Status":{}}}},"UpdateSigningCertificate":{"input":{"type":"structure","required":["CertificateId","Status"],"members":{"UserName":{},"CertificateId":{},"Status":{}}}},"UpdateUser":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"NewPath":{},"NewUserName":{}}}},"UploadSSHPublicKey":{"input":{"type":"structure","required":["UserName","SSHPublicKeyBody"],"members":{"UserName":{},"SSHPublicKeyBody":{}}},"output":{"resultWrapper":"UploadSSHPublicKeyResult","type":"structure","members":{"SSHPublicKey":{"shape":"S5w"}}}},"UploadServerCertificate":{"input":{"type":"structure","required":["ServerCertificateName","CertificateBody","PrivateKey"],"members":{"Path":{},"ServerCertificateName":{},"CertificateBody":{},"PrivateKey":{"type":"string","sensitive":true},"CertificateChain":{}}},"output":{"resultWrapper":"UploadServerCertificateResult","type":"structure","members":{"ServerCertificateMetadata":{"shape":"S62"}}}},"UploadSigningCertificate":{"input":{"type":"structure","required":["CertificateBody"],"members":{"UserName":{},"CertificateBody":{}}},"output":{"resultWrapper":"UploadSigningCertificateResult","type":"structure","required":["Certificate"],"members":{"Certificate":{"shape":"S92"}}}}},"shapes":{"Sf":{"type":"string","sensitive":true},"Ss":{"type":"structure","required":["Path","GroupName","GroupId","Arn","CreateDate"],"members":{"Path":{},"GroupName":{},"GroupId":{},"Arn":{},"CreateDate":{"type":"timestamp"}}},"Sw":{"type":"structure","required":["Path","InstanceProfileName","InstanceProfileId","Arn","CreateDate","Roles"],"members":{"Path":{},"InstanceProfileName":{},"InstanceProfileId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"Roles":{"shape":"Sx"}}},"Sx":{"type":"list","member":{"shape":"Sy"}},"Sy":{"type":"structure","required":["Path","RoleName","RoleId","Arn","CreateDate"],"members":{"Path":{},"RoleName":{},"RoleId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"AssumeRolePolicyDocument":{},"Description":{},"MaxSessionDuration":{"type":"integer"},"PermissionsBoundary":{"shape":"S12"},"Tags":{"shape":"S14"}}},"S12":{"type":"structure","members":{"PermissionsBoundaryType":{},"PermissionsBoundaryArn":{}}},"S14":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S1b":{"type":"structure","required":["UserName","CreateDate"],"members":{"UserName":{},"CreateDate":{"type":"timestamp"},"PasswordResetRequired":{"type":"boolean"}}},"S1e":{"type":"list","member":{}},"S1f":{"type":"list","member":{}},"S1n":{"type":"structure","members":{"PolicyName":{},"PolicyId":{},"Arn":{},"Path":{},"DefaultVersionId":{},"AttachmentCount":{"type":"integer"},"PermissionsBoundaryUsageCount":{"type":"integer"},"IsAttachable":{"type":"boolean"},"Description":{},"CreateDate":{"type":"timestamp"},"UpdateDate":{"type":"timestamp"}}},"S1s":{"type":"structure","members":{"Document":{},"VersionId":{},"IsDefaultVersion":{"type":"boolean"},"CreateDate":{"type":"timestamp"}}},"S25":{"type":"structure","required":["CreateDate","ServiceName","ServiceUserName","ServicePassword","ServiceSpecificCredentialId","UserName","Status"],"members":{"CreateDate":{"type":"timestamp"},"ServiceName":{},"ServiceUserName":{},"ServicePassword":{"type":"string","sensitive":true},"ServiceSpecificCredentialId":{},"UserName":{},"Status":{}}},"S2b":{"type":"structure","required":["Path","UserName","UserId","Arn","CreateDate"],"members":{"Path":{},"UserName":{},"UserId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"PasswordLastUsed":{"type":"timestamp"},"PermissionsBoundary":{"shape":"S12"},"Tags":{"shape":"S14"}}},"S2f":{"type":"structure","required":["SerialNumber"],"members":{"SerialNumber":{},"Base32StringSeed":{"shape":"S2h"},"QRCodePNG":{"shape":"S2h"},"User":{"shape":"S2b"},"EnableDate":{"type":"timestamp"}}},"S2h":{"type":"blob","sensitive":true},"S41":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"PolicyDocument":{}}}},"S44":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"PolicyArn":{}}}},"S4a":{"type":"list","member":{"shape":"Sw"}},"S4d":{"type":"list","member":{"shape":"S1s"}},"S4q":{"type":"list","member":{}},"S4r":{"type":"structure","members":{"ContextKeyNames":{"shape":"S4s"}}},"S4s":{"type":"list","member":{}},"S50":{"type":"list","member":{"shape":"S2b"}},"S5i":{"type":"structure","required":["Message","Code"],"members":{"Message":{},"Code":{}}},"S5w":{"type":"structure","required":["UserName","SSHPublicKeyId","Fingerprint","SSHPublicKeyBody","Status"],"members":{"UserName":{},"SSHPublicKeyId":{},"Fingerprint":{},"SSHPublicKeyBody":{},"Status":{},"UploadDate":{"type":"timestamp"}}},"S62":{"type":"structure","required":["Path","ServerCertificateName","ServerCertificateId","Arn"],"members":{"Path":{},"ServerCertificateName":{},"ServerCertificateId":{},"Arn":{},"UploadDate":{"type":"timestamp"},"Expiration":{"type":"timestamp"}}},"S7g":{"type":"list","member":{}},"S7k":{"type":"list","member":{"shape":"Ss"}},"S92":{"type":"structure","required":["UserName","CertificateId","CertificateBody","Status"],"members":{"UserName":{},"CertificateId":{},"CertificateBody":{},"Status":{},"UploadDate":{"type":"timestamp"}}},"S9s":{"type":"list","member":{}},"S9u":{"type":"list","member":{}},"S9w":{"type":"list","member":{"type":"structure","members":{"ContextKeyName":{},"ContextKeyValues":{"type":"list","member":{}},"ContextKeyType":{}}}},"Sa2":{"type":"structure","members":{"EvaluationResults":{"type":"list","member":{"type":"structure","required":["EvalActionName","EvalDecision"],"members":{"EvalActionName":{},"EvalResourceName":{},"EvalDecision":{},"MatchedStatements":{"shape":"Sa6"},"MissingContextValues":{"shape":"S4s"},"OrganizationsDecisionDetail":{"type":"structure","members":{"AllowedByOrganizations":{"type":"boolean"}}},"EvalDecisionDetails":{"shape":"Sae"},"ResourceSpecificResults":{"type":"list","member":{"type":"structure","required":["EvalResourceName","EvalResourceDecision"],"members":{"EvalResourceName":{},"EvalResourceDecision":{},"MatchedStatements":{"shape":"Sa6"},"MissingContextValues":{"shape":"S4s"},"EvalDecisionDetails":{"shape":"Sae"}}}}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}},"Sa6":{"type":"list","member":{"type":"structure","members":{"SourcePolicyId":{},"SourcePolicyType":{},"StartPosition":{"shape":"Saa"},"EndPosition":{"shape":"Saa"}}}},"Saa":{"type":"structure","members":{"Line":{"type":"integer"},"Column":{"type":"integer"}}},"Sae":{"type":"map","key":{},"value":{}},"Sam":{"type":"list","member":{}}}}');

});

parcelRequire.register("49ZCE", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"GetAccountAuthorizationDetails":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":["UserDetailList","GroupDetailList","RoleDetailList","Policies"]},"GetGroup":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Users"},"ListAccessKeys":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"AccessKeyMetadata"},"ListAccountAliases":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"AccountAliases"},"ListAttachedGroupPolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"AttachedPolicies"},"ListAttachedRolePolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"AttachedPolicies"},"ListAttachedUserPolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"AttachedPolicies"},"ListEntitiesForPolicy":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":["PolicyGroups","PolicyUsers","PolicyRoles"]},"ListGroupPolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"PolicyNames"},"ListGroups":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Groups"},"ListGroupsForUser":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Groups"},"ListInstanceProfiles":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"InstanceProfiles"},"ListInstanceProfilesForRole":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"InstanceProfiles"},"ListMFADevices":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"MFADevices"},"ListPolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Policies"},"ListPolicyVersions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Versions"},"ListRolePolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"PolicyNames"},"ListRoles":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Roles"},"ListSAMLProviders":{"result_key":"SAMLProviderList"},"ListSSHPublicKeys":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"SSHPublicKeys"},"ListServerCertificates":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"ServerCertificateMetadataList"},"ListSigningCertificates":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Certificates"},"ListUserPolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"PolicyNames"},"ListUsers":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Users"},"ListVirtualMFADevices":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"VirtualMFADevices"},"SimulateCustomPolicy":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"EvaluationResults"},"SimulatePrincipalPolicy":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"EvaluationResults"}}}');

});

parcelRequire.register("lyEup", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"InstanceProfileExists":{"delay":1,"operation":"GetInstanceProfile","maxAttempts":40,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"state":"retry","matcher":"status","expected":404}]},"UserExists":{"delay":1,"operation":"GetUser","maxAttempts":20,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"NoSuchEntity"}]},"RoleExists":{"delay":1,"operation":"GetRole","maxAttempts":20,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"NoSuchEntity"}]},"PolicyExists":{"delay":1,"operation":"GetPolicy","maxAttempts":20,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"NoSuchEntity"}]}}}');

});


parcelRequire.register("lRSVL", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $feb92852dbcc7228$var$Service = $dbC7k.Service;
var $feb92852dbcc7228$var$apiLoader = $dbC7k.apiLoader;
$feb92852dbcc7228$var$apiLoader.services["importexport"] = {};
$dbC7k.ImportExport = $feb92852dbcc7228$var$Service.defineService("importexport", [
    "2010-06-01"
]);


Object.defineProperty($feb92852dbcc7228$var$apiLoader.services["importexport"], "2010-06-01", {
    get: function get() {
        var model = (parcelRequire("7DLqH"));
        model.paginators = (parcelRequire("2Es80")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ImportExport;

});
parcelRequire.register("7DLqH", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"uid":"importexport-2010-06-01","apiVersion":"2010-06-01","endpointPrefix":"importexport","globalEndpoint":"importexport.amazonaws.com","serviceFullName":"AWS Import/Export","serviceId":"ImportExport","signatureVersion":"v2","xmlNamespace":"http://importexport.amazonaws.com/doc/2010-06-01/","protocol":"query"},"operations":{"CancelJob":{"http":{"requestUri":"/?Operation=CancelJob"},"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"APIVersion":{}}},"output":{"resultWrapper":"CancelJobResult","type":"structure","members":{"Success":{"type":"boolean"}}}},"CreateJob":{"http":{"requestUri":"/?Operation=CreateJob"},"input":{"type":"structure","required":["JobType","Manifest","ValidateOnly"],"members":{"JobType":{},"Manifest":{},"ManifestAddendum":{},"ValidateOnly":{"type":"boolean"},"APIVersion":{}}},"output":{"resultWrapper":"CreateJobResult","type":"structure","members":{"JobId":{},"JobType":{},"Signature":{},"SignatureFileContents":{},"WarningMessage":{},"ArtifactList":{"shape":"Sf"}}}},"GetShippingLabel":{"http":{"requestUri":"/?Operation=GetShippingLabel"},"input":{"type":"structure","required":["jobIds"],"members":{"jobIds":{"type":"list","member":{}},"name":{},"company":{},"phoneNumber":{},"country":{},"stateOrProvince":{},"city":{},"postalCode":{},"street1":{},"street2":{},"street3":{},"APIVersion":{}}},"output":{"resultWrapper":"GetShippingLabelResult","type":"structure","members":{"ShippingLabelURL":{},"Warning":{}}}},"GetStatus":{"http":{"requestUri":"/?Operation=GetStatus"},"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"APIVersion":{}}},"output":{"resultWrapper":"GetStatusResult","type":"structure","members":{"JobId":{},"JobType":{},"LocationCode":{},"LocationMessage":{},"ProgressCode":{},"ProgressMessage":{},"Carrier":{},"TrackingNumber":{},"LogBucket":{},"LogKey":{},"ErrorCount":{"type":"integer"},"Signature":{},"SignatureFileContents":{},"CurrentManifest":{},"CreationDate":{"type":"timestamp"},"ArtifactList":{"shape":"Sf"}}}},"ListJobs":{"http":{"requestUri":"/?Operation=ListJobs"},"input":{"type":"structure","members":{"MaxJobs":{"type":"integer"},"Marker":{},"APIVersion":{}}},"output":{"resultWrapper":"ListJobsResult","type":"structure","members":{"Jobs":{"type":"list","member":{"type":"structure","members":{"JobId":{},"CreationDate":{"type":"timestamp"},"IsCanceled":{"type":"boolean"},"JobType":{}}}},"IsTruncated":{"type":"boolean"}}}},"UpdateJob":{"http":{"requestUri":"/?Operation=UpdateJob"},"input":{"type":"structure","required":["JobId","Manifest","JobType","ValidateOnly"],"members":{"JobId":{},"Manifest":{},"JobType":{},"ValidateOnly":{"type":"boolean"},"APIVersion":{}}},"output":{"resultWrapper":"UpdateJobResult","type":"structure","members":{"Success":{"type":"boolean"},"WarningMessage":{},"ArtifactList":{"shape":"Sf"}}}}},"shapes":{"Sf":{"type":"list","member":{"type":"structure","members":{"Description":{},"URL":{}}}}},"examples":{}}');

});

parcelRequire.register("2Es80", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListJobs":{"input_token":"Marker","output_token":"Jobs[-1].JobId","more_results":"IsTruncated","limit_key":"MaxJobs","result_key":"Jobs"}}}');

});


parcelRequire.register("3c0tt", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $2532dc4b1a28a739$var$Service = $dbC7k.Service;
var $2532dc4b1a28a739$var$apiLoader = $dbC7k.apiLoader;
$2532dc4b1a28a739$var$apiLoader.services["inspector"] = {};
$dbC7k.Inspector = $2532dc4b1a28a739$var$Service.defineService("inspector", [
    "2015-08-18*",
    "2016-02-16"
]);


Object.defineProperty($2532dc4b1a28a739$var$apiLoader.services["inspector"], "2016-02-16", {
    get: function get() {
        var model = (parcelRequire("6J97c"));
        model.paginators = (parcelRequire("oC4Qb")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Inspector;

});
parcelRequire.register("6J97c", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-02-16","endpointPrefix":"inspector","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Inspector","serviceId":"Inspector","signatureVersion":"v4","targetPrefix":"InspectorService","uid":"inspector-2016-02-16"},"operations":{"AddAttributesToFindings":{"input":{"type":"structure","required":["findingArns","attributes"],"members":{"findingArns":{"shape":"S2"},"attributes":{"shape":"S4"}}},"output":{"type":"structure","required":["failedItems"],"members":{"failedItems":{"shape":"S9"}}}},"CreateAssessmentTarget":{"input":{"type":"structure","required":["assessmentTargetName"],"members":{"assessmentTargetName":{},"resourceGroupArn":{}}},"output":{"type":"structure","required":["assessmentTargetArn"],"members":{"assessmentTargetArn":{}}}},"CreateAssessmentTemplate":{"input":{"type":"structure","required":["assessmentTargetArn","assessmentTemplateName","durationInSeconds","rulesPackageArns"],"members":{"assessmentTargetArn":{},"assessmentTemplateName":{},"durationInSeconds":{"type":"integer"},"rulesPackageArns":{"shape":"Sj"},"userAttributesForFindings":{"shape":"S4"}}},"output":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{}}}},"CreateExclusionsPreview":{"input":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{}}},"output":{"type":"structure","required":["previewToken"],"members":{"previewToken":{}}}},"CreateResourceGroup":{"input":{"type":"structure","required":["resourceGroupTags"],"members":{"resourceGroupTags":{"shape":"Sp"}}},"output":{"type":"structure","required":["resourceGroupArn"],"members":{"resourceGroupArn":{}}}},"DeleteAssessmentRun":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{}}}},"DeleteAssessmentTarget":{"input":{"type":"structure","required":["assessmentTargetArn"],"members":{"assessmentTargetArn":{}}}},"DeleteAssessmentTemplate":{"input":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{}}}},"DescribeAssessmentRuns":{"input":{"type":"structure","required":["assessmentRunArns"],"members":{"assessmentRunArns":{"shape":"Sy"}}},"output":{"type":"structure","required":["assessmentRuns","failedItems"],"members":{"assessmentRuns":{"type":"list","member":{"type":"structure","required":["arn","name","assessmentTemplateArn","state","durationInSeconds","rulesPackageArns","userAttributesForFindings","createdAt","stateChangedAt","dataCollected","stateChanges","notifications","findingCounts"],"members":{"arn":{},"name":{},"assessmentTemplateArn":{},"state":{},"durationInSeconds":{"type":"integer"},"rulesPackageArns":{"type":"list","member":{}},"userAttributesForFindings":{"shape":"S4"},"createdAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"completedAt":{"type":"timestamp"},"stateChangedAt":{"type":"timestamp"},"dataCollected":{"type":"boolean"},"stateChanges":{"type":"list","member":{"type":"structure","required":["stateChangedAt","state"],"members":{"stateChangedAt":{"type":"timestamp"},"state":{}}}},"notifications":{"type":"list","member":{"type":"structure","required":["date","event","error"],"members":{"date":{"type":"timestamp"},"event":{},"message":{},"error":{"type":"boolean"},"snsTopicArn":{},"snsPublishStatusCode":{}}}},"findingCounts":{"type":"map","key":{},"value":{"type":"integer"}}}}},"failedItems":{"shape":"S9"}}}},"DescribeAssessmentTargets":{"input":{"type":"structure","required":["assessmentTargetArns"],"members":{"assessmentTargetArns":{"shape":"Sy"}}},"output":{"type":"structure","required":["assessmentTargets","failedItems"],"members":{"assessmentTargets":{"type":"list","member":{"type":"structure","required":["arn","name","createdAt","updatedAt"],"members":{"arn":{},"name":{},"resourceGroupArn":{},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeAssessmentTemplates":{"input":{"type":"structure","required":["assessmentTemplateArns"],"members":{"assessmentTemplateArns":{"shape":"Sy"}}},"output":{"type":"structure","required":["assessmentTemplates","failedItems"],"members":{"assessmentTemplates":{"type":"list","member":{"type":"structure","required":["arn","name","assessmentTargetArn","durationInSeconds","rulesPackageArns","userAttributesForFindings","assessmentRunCount","createdAt"],"members":{"arn":{},"name":{},"assessmentTargetArn":{},"durationInSeconds":{"type":"integer"},"rulesPackageArns":{"shape":"Sj"},"userAttributesForFindings":{"shape":"S4"},"lastAssessmentRunArn":{},"assessmentRunCount":{"type":"integer"},"createdAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeCrossAccountAccessRole":{"output":{"type":"structure","required":["roleArn","valid","registeredAt"],"members":{"roleArn":{},"valid":{"type":"boolean"},"registeredAt":{"type":"timestamp"}}}},"DescribeExclusions":{"input":{"type":"structure","required":["exclusionArns"],"members":{"exclusionArns":{"type":"list","member":{}},"locale":{}}},"output":{"type":"structure","required":["exclusions","failedItems"],"members":{"exclusions":{"type":"map","key":{},"value":{"type":"structure","required":["arn","title","description","recommendation","scopes"],"members":{"arn":{},"title":{},"description":{},"recommendation":{},"scopes":{"shape":"S1x"},"attributes":{"shape":"S21"}}}},"failedItems":{"shape":"S9"}}}},"DescribeFindings":{"input":{"type":"structure","required":["findingArns"],"members":{"findingArns":{"shape":"Sy"},"locale":{}}},"output":{"type":"structure","required":["findings","failedItems"],"members":{"findings":{"type":"list","member":{"type":"structure","required":["arn","attributes","userAttributes","createdAt","updatedAt"],"members":{"arn":{},"schemaVersion":{"type":"integer"},"service":{},"serviceAttributes":{"type":"structure","required":["schemaVersion"],"members":{"schemaVersion":{"type":"integer"},"assessmentRunArn":{},"rulesPackageArn":{}}},"assetType":{},"assetAttributes":{"type":"structure","required":["schemaVersion"],"members":{"schemaVersion":{"type":"integer"},"agentId":{},"autoScalingGroup":{},"amiId":{},"hostname":{},"ipv4Addresses":{"type":"list","member":{}},"tags":{"type":"list","member":{"shape":"S2i"}},"networkInterfaces":{"type":"list","member":{"type":"structure","members":{"networkInterfaceId":{},"subnetId":{},"vpcId":{},"privateDnsName":{},"privateIpAddress":{},"privateIpAddresses":{"type":"list","member":{"type":"structure","members":{"privateDnsName":{},"privateIpAddress":{}}}},"publicDnsName":{},"publicIp":{},"ipv6Addresses":{"type":"list","member":{}},"securityGroups":{"type":"list","member":{"type":"structure","members":{"groupName":{},"groupId":{}}}}}}}}},"id":{},"title":{},"description":{},"recommendation":{},"severity":{},"numericSeverity":{"type":"double"},"confidence":{"type":"integer"},"indicatorOfCompromise":{"type":"boolean"},"attributes":{"shape":"S21"},"userAttributes":{"shape":"S4"},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeResourceGroups":{"input":{"type":"structure","required":["resourceGroupArns"],"members":{"resourceGroupArns":{"shape":"Sy"}}},"output":{"type":"structure","required":["resourceGroups","failedItems"],"members":{"resourceGroups":{"type":"list","member":{"type":"structure","required":["arn","tags","createdAt"],"members":{"arn":{},"tags":{"shape":"Sp"},"createdAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeRulesPackages":{"input":{"type":"structure","required":["rulesPackageArns"],"members":{"rulesPackageArns":{"shape":"Sy"},"locale":{}}},"output":{"type":"structure","required":["rulesPackages","failedItems"],"members":{"rulesPackages":{"type":"list","member":{"type":"structure","required":["arn","name","version","provider"],"members":{"arn":{},"name":{},"version":{},"provider":{},"description":{}}}},"failedItems":{"shape":"S9"}}}},"GetAssessmentReport":{"input":{"type":"structure","required":["assessmentRunArn","reportFileFormat","reportType"],"members":{"assessmentRunArn":{},"reportFileFormat":{},"reportType":{}}},"output":{"type":"structure","required":["status"],"members":{"status":{},"url":{}}}},"GetExclusionsPreview":{"input":{"type":"structure","required":["assessmentTemplateArn","previewToken"],"members":{"assessmentTemplateArn":{},"previewToken":{},"nextToken":{},"maxResults":{"type":"integer"},"locale":{}}},"output":{"type":"structure","required":["previewStatus"],"members":{"previewStatus":{},"exclusionPreviews":{"type":"list","member":{"type":"structure","required":["title","description","recommendation","scopes"],"members":{"title":{},"description":{},"recommendation":{},"scopes":{"shape":"S1x"},"attributes":{"shape":"S21"}}}},"nextToken":{}}}},"GetTelemetryMetadata":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{}}},"output":{"type":"structure","required":["telemetryMetadata"],"members":{"telemetryMetadata":{"shape":"S3j"}}}},"ListAssessmentRunAgents":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{},"filter":{"type":"structure","required":["agentHealths","agentHealthCodes"],"members":{"agentHealths":{"type":"list","member":{}},"agentHealthCodes":{"type":"list","member":{}}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentRunAgents"],"members":{"assessmentRunAgents":{"type":"list","member":{"type":"structure","required":["agentId","assessmentRunArn","agentHealth","agentHealthCode","telemetryMetadata"],"members":{"agentId":{},"assessmentRunArn":{},"agentHealth":{},"agentHealthCode":{},"agentHealthDetails":{},"autoScalingGroup":{},"telemetryMetadata":{"shape":"S3j"}}}},"nextToken":{}}}},"ListAssessmentRuns":{"input":{"type":"structure","members":{"assessmentTemplateArns":{"shape":"S3x"},"filter":{"type":"structure","members":{"namePattern":{},"states":{"type":"list","member":{}},"durationRange":{"shape":"S41"},"rulesPackageArns":{"shape":"S42"},"startTimeRange":{"shape":"S43"},"completionTimeRange":{"shape":"S43"},"stateChangeTimeRange":{"shape":"S43"}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentRunArns"],"members":{"assessmentRunArns":{"shape":"S45"},"nextToken":{}}}},"ListAssessmentTargets":{"input":{"type":"structure","members":{"filter":{"type":"structure","members":{"assessmentTargetNamePattern":{}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentTargetArns"],"members":{"assessmentTargetArns":{"shape":"S45"},"nextToken":{}}}},"ListAssessmentTemplates":{"input":{"type":"structure","members":{"assessmentTargetArns":{"shape":"S3x"},"filter":{"type":"structure","members":{"namePattern":{},"durationRange":{"shape":"S41"},"rulesPackageArns":{"shape":"S42"}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentTemplateArns"],"members":{"assessmentTemplateArns":{"shape":"S45"},"nextToken":{}}}},"ListEventSubscriptions":{"input":{"type":"structure","members":{"resourceArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["subscriptions"],"members":{"subscriptions":{"type":"list","member":{"type":"structure","required":["resourceArn","topicArn","eventSubscriptions"],"members":{"resourceArn":{},"topicArn":{},"eventSubscriptions":{"type":"list","member":{"type":"structure","required":["event","subscribedAt"],"members":{"event":{},"subscribedAt":{"type":"timestamp"}}}}}}},"nextToken":{}}}},"ListExclusions":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["exclusionArns"],"members":{"exclusionArns":{"shape":"S45"},"nextToken":{}}}},"ListFindings":{"input":{"type":"structure","members":{"assessmentRunArns":{"shape":"S3x"},"filter":{"type":"structure","members":{"agentIds":{"type":"list","member":{}},"autoScalingGroups":{"type":"list","member":{}},"ruleNames":{"type":"list","member":{}},"severities":{"type":"list","member":{}},"rulesPackageArns":{"shape":"S42"},"attributes":{"shape":"S21"},"userAttributes":{"shape":"S21"},"creationTimeRange":{"shape":"S43"}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["findingArns"],"members":{"findingArns":{"shape":"S45"},"nextToken":{}}}},"ListRulesPackages":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["rulesPackageArns"],"members":{"rulesPackageArns":{"shape":"S45"},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","required":["tags"],"members":{"tags":{"shape":"S4x"}}}},"PreviewAgents":{"input":{"type":"structure","required":["previewAgentsArn"],"members":{"previewAgentsArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["agentPreviews"],"members":{"agentPreviews":{"type":"list","member":{"type":"structure","required":["agentId"],"members":{"hostname":{},"agentId":{},"autoScalingGroup":{},"agentHealth":{},"agentVersion":{},"operatingSystem":{},"kernelVersion":{},"ipv4Address":{}}}},"nextToken":{}}}},"RegisterCrossAccountAccessRole":{"input":{"type":"structure","required":["roleArn"],"members":{"roleArn":{}}}},"RemoveAttributesFromFindings":{"input":{"type":"structure","required":["findingArns","attributeKeys"],"members":{"findingArns":{"shape":"S2"},"attributeKeys":{"type":"list","member":{}}}},"output":{"type":"structure","required":["failedItems"],"members":{"failedItems":{"shape":"S9"}}}},"SetTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{},"tags":{"shape":"S4x"}}}},"StartAssessmentRun":{"input":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{},"assessmentRunName":{}}},"output":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{}}}},"StopAssessmentRun":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{},"stopAction":{}}}},"SubscribeToEvent":{"input":{"type":"structure","required":["resourceArn","event","topicArn"],"members":{"resourceArn":{},"event":{},"topicArn":{}}}},"UnsubscribeFromEvent":{"input":{"type":"structure","required":["resourceArn","event","topicArn"],"members":{"resourceArn":{},"event":{},"topicArn":{}}}},"UpdateAssessmentTarget":{"input":{"type":"structure","required":["assessmentTargetArn","assessmentTargetName"],"members":{"assessmentTargetArn":{},"assessmentTargetName":{},"resourceGroupArn":{}}}}},"shapes":{"S2":{"type":"list","member":{}},"S4":{"type":"list","member":{"shape":"S5"}},"S5":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}},"S9":{"type":"map","key":{},"value":{"type":"structure","required":["failureCode","retryable"],"members":{"failureCode":{},"retryable":{"type":"boolean"}}}},"Sj":{"type":"list","member":{}},"Sp":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}}},"Sy":{"type":"list","member":{}},"S1x":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}}},"S21":{"type":"list","member":{"shape":"S5"}},"S2i":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}},"S3j":{"type":"list","member":{"type":"structure","required":["messageType","count"],"members":{"messageType":{},"count":{"type":"long"},"dataSize":{"type":"long"}}}},"S3x":{"type":"list","member":{}},"S41":{"type":"structure","members":{"minSeconds":{"type":"integer"},"maxSeconds":{"type":"integer"}}},"S42":{"type":"list","member":{}},"S43":{"type":"structure","members":{"beginDate":{"type":"timestamp"},"endDate":{"type":"timestamp"}}},"S45":{"type":"list","member":{}},"S4x":{"type":"list","member":{"shape":"S2i"}}}}');

});

parcelRequire.register("oC4Qb", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"GetExclusionsPreview":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentRunAgents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentRuns":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentTargets":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentTemplates":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListEventSubscriptions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListExclusions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListFindings":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListRulesPackages":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"PreviewAgents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}');

});


parcelRequire.register("hTzNZ", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $d07358e45bd3cc44$var$Service = $dbC7k.Service;
var $d07358e45bd3cc44$var$apiLoader = $dbC7k.apiLoader;
$d07358e45bd3cc44$var$apiLoader.services["iot"] = {};
$dbC7k.Iot = $d07358e45bd3cc44$var$Service.defineService("iot", [
    "2015-05-28"
]);


Object.defineProperty($d07358e45bd3cc44$var$apiLoader.services["iot"], "2015-05-28", {
    get: function get() {
        var model = (parcelRequire("ijptL"));
        model.paginators = (parcelRequire("lgWUV")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Iot;

});
parcelRequire.register("ijptL", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-05-28","endpointPrefix":"iot","protocol":"rest-json","serviceFullName":"AWS IoT","serviceId":"IoT","signatureVersion":"v4","signingName":"execute-api","uid":"iot-2015-05-28"},"operations":{"AcceptCertificateTransfer":{"http":{"method":"PATCH","requestUri":"/accept-certificate-transfer/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"}}}},"AddThingToBillingGroup":{"http":{"method":"PUT","requestUri":"/billing-groups/addThingToBillingGroup"},"input":{"type":"structure","members":{"billingGroupName":{},"billingGroupArn":{},"thingName":{},"thingArn":{}}},"output":{"type":"structure","members":{}}},"AddThingToThingGroup":{"http":{"method":"PUT","requestUri":"/thing-groups/addThingToThingGroup"},"input":{"type":"structure","members":{"thingGroupName":{},"thingGroupArn":{},"thingName":{},"thingArn":{},"overrideDynamicGroups":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"AssociateTargetsWithJob":{"http":{"requestUri":"/jobs/{jobId}/targets"},"input":{"type":"structure","required":["targets","jobId"],"members":{"targets":{"shape":"Sg"},"jobId":{"location":"uri","locationName":"jobId"},"comment":{}}},"output":{"type":"structure","members":{"jobArn":{},"jobId":{},"description":{}}}},"AttachPolicy":{"http":{"method":"PUT","requestUri":"/target-policies/{policyName}"},"input":{"type":"structure","required":["policyName","target"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"target":{}}}},"AttachPrincipalPolicy":{"http":{"method":"PUT","requestUri":"/principal-policies/{policyName}"},"input":{"type":"structure","required":["policyName","principal"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"principal":{"location":"header","locationName":"x-amzn-iot-principal"}}},"deprecated":true},"AttachSecurityProfile":{"http":{"method":"PUT","requestUri":"/security-profiles/{securityProfileName}/targets"},"input":{"type":"structure","required":["securityProfileName","securityProfileTargetArn"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"securityProfileTargetArn":{"location":"querystring","locationName":"securityProfileTargetArn"}}},"output":{"type":"structure","members":{}}},"AttachThingPrincipal":{"http":{"method":"PUT","requestUri":"/things/{thingName}/principals"},"input":{"type":"structure","required":["thingName","principal"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"principal":{"location":"header","locationName":"x-amzn-principal"}}},"output":{"type":"structure","members":{}}},"CancelAuditMitigationActionsTask":{"http":{"method":"PUT","requestUri":"/audit/mitigationactions/tasks/{taskId}/cancel"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{}}},"CancelAuditTask":{"http":{"method":"PUT","requestUri":"/audit/tasks/{taskId}/cancel"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{}}},"CancelCertificateTransfer":{"http":{"method":"PATCH","requestUri":"/cancel-certificate-transfer/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"}}}},"CancelJob":{"http":{"method":"PUT","requestUri":"/jobs/{jobId}/cancel"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"reasonCode":{},"comment":{},"force":{"location":"querystring","locationName":"force","type":"boolean"}}},"output":{"type":"structure","members":{"jobArn":{},"jobId":{},"description":{}}}},"CancelJobExecution":{"http":{"method":"PUT","requestUri":"/things/{thingName}/jobs/{jobId}/cancel"},"input":{"type":"structure","required":["jobId","thingName"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"thingName":{"location":"uri","locationName":"thingName"},"force":{"location":"querystring","locationName":"force","type":"boolean"},"expectedVersion":{"type":"long"},"statusDetails":{"shape":"S1b"}}}},"ClearDefaultAuthorizer":{"http":{"method":"DELETE","requestUri":"/default-authorizer"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"CreateAuthorizer":{"http":{"requestUri":"/authorizer/{authorizerName}"},"input":{"type":"structure","required":["authorizerName","authorizerFunctionArn","tokenKeyName","tokenSigningPublicKeys"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"},"authorizerFunctionArn":{},"tokenKeyName":{},"tokenSigningPublicKeys":{"shape":"S1k"},"status":{}}},"output":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{}}}},"CreateBillingGroup":{"http":{"requestUri":"/billing-groups/{billingGroupName}"},"input":{"type":"structure","required":["billingGroupName"],"members":{"billingGroupName":{"location":"uri","locationName":"billingGroupName"},"billingGroupProperties":{"shape":"S1r"},"tags":{"shape":"S1t"}}},"output":{"type":"structure","members":{"billingGroupName":{},"billingGroupArn":{},"billingGroupId":{}}}},"CreateCertificateFromCsr":{"http":{"requestUri":"/certificates"},"input":{"type":"structure","required":["certificateSigningRequest"],"members":{"certificateSigningRequest":{},"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"certificatePem":{}}}},"CreateDynamicThingGroup":{"http":{"requestUri":"/dynamic-thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName","queryString"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"thingGroupProperties":{"shape":"S25"},"indexName":{},"queryString":{},"queryVersion":{},"tags":{"shape":"S1t"}}},"output":{"type":"structure","members":{"thingGroupName":{},"thingGroupArn":{},"thingGroupId":{},"indexName":{},"queryString":{},"queryVersion":{}}}},"CreateJob":{"http":{"method":"PUT","requestUri":"/jobs/{jobId}"},"input":{"type":"structure","required":["jobId","targets"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"targets":{"shape":"Sg"},"documentSource":{},"document":{},"description":{},"presignedUrlConfig":{"shape":"S2k"},"targetSelection":{},"jobExecutionsRolloutConfig":{"shape":"S2o"},"abortConfig":{"shape":"S2v"},"timeoutConfig":{"shape":"S32"},"tags":{"shape":"S1t"}}},"output":{"type":"structure","members":{"jobArn":{},"jobId":{},"description":{}}}},"CreateKeysAndCertificate":{"http":{"requestUri":"/keys-and-certificate"},"input":{"type":"structure","members":{"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"certificatePem":{},"keyPair":{"type":"structure","members":{"PublicKey":{},"PrivateKey":{"type":"string","sensitive":true}}}}}},"CreateMitigationAction":{"http":{"requestUri":"/mitigationactions/actions/{actionName}"},"input":{"type":"structure","required":["actionName","roleArn","actionParams"],"members":{"actionName":{"location":"uri","locationName":"actionName"},"roleArn":{},"actionParams":{"shape":"S3c"},"tags":{"shape":"S1t"}}},"output":{"type":"structure","members":{"actionArn":{},"actionId":{}}}},"CreateOTAUpdate":{"http":{"requestUri":"/otaUpdates/{otaUpdateId}"},"input":{"type":"structure","required":["otaUpdateId","targets","files","roleArn"],"members":{"otaUpdateId":{"location":"uri","locationName":"otaUpdateId"},"description":{},"targets":{"shape":"S3v"},"targetSelection":{},"awsJobExecutionsRolloutConfig":{"shape":"S3x"},"files":{"shape":"S3z"},"roleArn":{},"additionalParameters":{"shape":"S4w"},"tags":{"shape":"S1t"}}},"output":{"type":"structure","members":{"otaUpdateId":{},"awsIotJobId":{},"otaUpdateArn":{},"awsIotJobArn":{},"otaUpdateStatus":{}}}},"CreatePolicy":{"http":{"requestUri":"/policies/{policyName}"},"input":{"type":"structure","required":["policyName","policyDocument"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyDocument":{}}},"output":{"type":"structure","members":{"policyName":{},"policyArn":{},"policyDocument":{},"policyVersionId":{}}}},"CreatePolicyVersion":{"http":{"requestUri":"/policies/{policyName}/version"},"input":{"type":"structure","required":["policyName","policyDocument"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyDocument":{},"setAsDefault":{"location":"querystring","locationName":"setAsDefault","type":"boolean"}}},"output":{"type":"structure","members":{"policyArn":{},"policyDocument":{},"policyVersionId":{},"isDefaultVersion":{"type":"boolean"}}}},"CreateRoleAlias":{"http":{"requestUri":"/role-aliases/{roleAlias}"},"input":{"type":"structure","required":["roleAlias","roleArn"],"members":{"roleAlias":{"location":"uri","locationName":"roleAlias"},"roleArn":{},"credentialDurationSeconds":{"type":"integer"}}},"output":{"type":"structure","members":{"roleAlias":{},"roleAliasArn":{}}}},"CreateScheduledAudit":{"http":{"requestUri":"/audit/scheduledaudits/{scheduledAuditName}"},"input":{"type":"structure","required":["frequency","targetCheckNames","scheduledAuditName"],"members":{"frequency":{},"dayOfMonth":{},"dayOfWeek":{},"targetCheckNames":{"shape":"S5k"},"scheduledAuditName":{"location":"uri","locationName":"scheduledAuditName"},"tags":{"shape":"S1t"}}},"output":{"type":"structure","members":{"scheduledAuditArn":{}}}},"CreateSecurityProfile":{"http":{"requestUri":"/security-profiles/{securityProfileName}"},"input":{"type":"structure","required":["securityProfileName"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"securityProfileDescription":{},"behaviors":{"shape":"S5r"},"alertTargets":{"shape":"S68"},"additionalMetricsToRetain":{"shape":"S6c"},"tags":{"shape":"S1t"}}},"output":{"type":"structure","members":{"securityProfileName":{},"securityProfileArn":{}}}},"CreateStream":{"http":{"requestUri":"/streams/{streamId}"},"input":{"type":"structure","required":["streamId","files","roleArn"],"members":{"streamId":{"location":"uri","locationName":"streamId"},"description":{},"files":{"shape":"S6h"},"roleArn":{},"tags":{"shape":"S1t"}}},"output":{"type":"structure","members":{"streamId":{},"streamArn":{},"description":{},"streamVersion":{"type":"integer"}}}},"CreateThing":{"http":{"requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"thingTypeName":{},"attributePayload":{"shape":"S27"},"billingGroupName":{}}},"output":{"type":"structure","members":{"thingName":{},"thingArn":{},"thingId":{}}}},"CreateThingGroup":{"http":{"requestUri":"/thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"parentGroupName":{},"thingGroupProperties":{"shape":"S25"},"tags":{"shape":"S1t"}}},"output":{"type":"structure","members":{"thingGroupName":{},"thingGroupArn":{},"thingGroupId":{}}}},"CreateThingType":{"http":{"requestUri":"/thing-types/{thingTypeName}"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"},"thingTypeProperties":{"shape":"S6t"},"tags":{"shape":"S1t"}}},"output":{"type":"structure","members":{"thingTypeName":{},"thingTypeArn":{},"thingTypeId":{}}}},"CreateTopicRule":{"http":{"requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName","topicRulePayload"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"},"topicRulePayload":{"shape":"S71"},"tags":{"location":"header","locationName":"x-amz-tagging"}},"payload":"topicRulePayload"}},"DeleteAccountAuditConfiguration":{"http":{"method":"DELETE","requestUri":"/audit/configuration"},"input":{"type":"structure","members":{"deleteScheduledAudits":{"location":"querystring","locationName":"deleteScheduledAudits","type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteAuthorizer":{"http":{"method":"DELETE","requestUri":"/authorizer/{authorizerName}"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"}}},"output":{"type":"structure","members":{}}},"DeleteBillingGroup":{"http":{"method":"DELETE","requestUri":"/billing-groups/{billingGroupName}"},"input":{"type":"structure","required":["billingGroupName"],"members":{"billingGroupName":{"location":"uri","locationName":"billingGroupName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteCACertificate":{"http":{"method":"DELETE","requestUri":"/cacertificate/{caCertificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"caCertificateId"}}},"output":{"type":"structure","members":{}}},"DeleteCertificate":{"http":{"method":"DELETE","requestUri":"/certificates/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"forceDelete":{"location":"querystring","locationName":"forceDelete","type":"boolean"}}}},"DeleteDynamicThingGroup":{"http":{"method":"DELETE","requestUri":"/dynamic-thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteJob":{"http":{"method":"DELETE","requestUri":"/jobs/{jobId}"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"force":{"location":"querystring","locationName":"force","type":"boolean"}}}},"DeleteJobExecution":{"http":{"method":"DELETE","requestUri":"/things/{thingName}/jobs/{jobId}/executionNumber/{executionNumber}"},"input":{"type":"structure","required":["jobId","thingName","executionNumber"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"thingName":{"location":"uri","locationName":"thingName"},"executionNumber":{"location":"uri","locationName":"executionNumber","type":"long"},"force":{"location":"querystring","locationName":"force","type":"boolean"}}}},"DeleteMitigationAction":{"http":{"method":"DELETE","requestUri":"/mitigationactions/actions/{actionName}"},"input":{"type":"structure","required":["actionName"],"members":{"actionName":{"location":"uri","locationName":"actionName"}}},"output":{"type":"structure","members":{}}},"DeleteOTAUpdate":{"http":{"method":"DELETE","requestUri":"/otaUpdates/{otaUpdateId}"},"input":{"type":"structure","required":["otaUpdateId"],"members":{"otaUpdateId":{"location":"uri","locationName":"otaUpdateId"},"deleteStream":{"location":"querystring","locationName":"deleteStream","type":"boolean"},"forceDeleteAWSJob":{"location":"querystring","locationName":"forceDeleteAWSJob","type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeletePolicy":{"http":{"method":"DELETE","requestUri":"/policies/{policyName}"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"}}}},"DeletePolicyVersion":{"http":{"method":"DELETE","requestUri":"/policies/{policyName}/version/{policyVersionId}"},"input":{"type":"structure","required":["policyName","policyVersionId"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyVersionId":{"location":"uri","locationName":"policyVersionId"}}}},"DeleteRegistrationCode":{"http":{"method":"DELETE","requestUri":"/registrationcode"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DeleteRoleAlias":{"http":{"method":"DELETE","requestUri":"/role-aliases/{roleAlias}"},"input":{"type":"structure","required":["roleAlias"],"members":{"roleAlias":{"location":"uri","locationName":"roleAlias"}}},"output":{"type":"structure","members":{}}},"DeleteScheduledAudit":{"http":{"method":"DELETE","requestUri":"/audit/scheduledaudits/{scheduledAuditName}"},"input":{"type":"structure","required":["scheduledAuditName"],"members":{"scheduledAuditName":{"location":"uri","locationName":"scheduledAuditName"}}},"output":{"type":"structure","members":{}}},"DeleteSecurityProfile":{"http":{"method":"DELETE","requestUri":"/security-profiles/{securityProfileName}"},"input":{"type":"structure","required":["securityProfileName"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteStream":{"http":{"method":"DELETE","requestUri":"/streams/{streamId}"},"input":{"type":"structure","required":["streamId"],"members":{"streamId":{"location":"uri","locationName":"streamId"}}},"output":{"type":"structure","members":{}}},"DeleteThing":{"http":{"method":"DELETE","requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteThingGroup":{"http":{"method":"DELETE","requestUri":"/thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteThingType":{"http":{"method":"DELETE","requestUri":"/thing-types/{thingTypeName}"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{}}},"DeleteTopicRule":{"http":{"method":"DELETE","requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}}},"DeleteV2LoggingLevel":{"http":{"method":"DELETE","requestUri":"/v2LoggingLevel"},"input":{"type":"structure","required":["targetType","targetName"],"members":{"targetType":{"location":"querystring","locationName":"targetType"},"targetName":{"location":"querystring","locationName":"targetName"}}}},"DeprecateThingType":{"http":{"requestUri":"/thing-types/{thingTypeName}/deprecate"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"},"undoDeprecate":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DescribeAccountAuditConfiguration":{"http":{"method":"GET","requestUri":"/audit/configuration"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"roleArn":{},"auditNotificationTargetConfigurations":{"shape":"Sa4"},"auditCheckConfigurations":{"shape":"Sa8"}}}},"DescribeAuditFinding":{"http":{"method":"GET","requestUri":"/audit/findings/{findingId}"},"input":{"type":"structure","required":["findingId"],"members":{"findingId":{"location":"uri","locationName":"findingId"}}},"output":{"type":"structure","members":{"finding":{"shape":"Sad"}}}},"DescribeAuditMitigationActionsTask":{"http":{"method":"GET","requestUri":"/audit/mitigationactions/tasks/{taskId}"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{"taskStatus":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"taskStatistics":{"type":"map","key":{},"value":{"type":"structure","members":{"totalFindingsCount":{"type":"long"},"failedFindingsCount":{"type":"long"},"succeededFindingsCount":{"type":"long"},"skippedFindingsCount":{"type":"long"},"canceledFindingsCount":{"type":"long"}}}},"target":{"shape":"Sb2"},"auditCheckToActionsMapping":{"shape":"Sb6"},"actionsDefinition":{"type":"list","member":{"type":"structure","members":{"name":{},"id":{},"roleArn":{},"actionParams":{"shape":"S3c"}}}}}}},"DescribeAuditTask":{"http":{"method":"GET","requestUri":"/audit/tasks/{taskId}"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{"taskStatus":{},"taskType":{},"taskStartTime":{"type":"timestamp"},"taskStatistics":{"type":"structure","members":{"totalChecks":{"type":"integer"},"inProgressChecks":{"type":"integer"},"waitingForDataCollectionChecks":{"type":"integer"},"compliantChecks":{"type":"integer"},"nonCompliantChecks":{"type":"integer"},"failedChecks":{"type":"integer"},"canceledChecks":{"type":"integer"}}},"scheduledAuditName":{},"auditDetails":{"type":"map","key":{},"value":{"type":"structure","members":{"checkRunStatus":{},"checkCompliant":{"type":"boolean"},"totalResourcesCount":{"type":"long"},"nonCompliantResourcesCount":{"type":"long"},"errorCode":{},"message":{}}}}}}},"DescribeAuthorizer":{"http":{"method":"GET","requestUri":"/authorizer/{authorizerName}"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"}}},"output":{"type":"structure","members":{"authorizerDescription":{"shape":"Sbw"}}}},"DescribeBillingGroup":{"http":{"method":"GET","requestUri":"/billing-groups/{billingGroupName}"},"input":{"type":"structure","required":["billingGroupName"],"members":{"billingGroupName":{"location":"uri","locationName":"billingGroupName"}}},"output":{"type":"structure","members":{"billingGroupName":{},"billingGroupId":{},"billingGroupArn":{},"version":{"type":"long"},"billingGroupProperties":{"shape":"S1r"},"billingGroupMetadata":{"type":"structure","members":{"creationDate":{"type":"timestamp"}}}}}},"DescribeCACertificate":{"http":{"method":"GET","requestUri":"/cacertificate/{caCertificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"caCertificateId"}}},"output":{"type":"structure","members":{"certificateDescription":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"status":{},"certificatePem":{},"ownedBy":{},"creationDate":{"type":"timestamp"},"autoRegistrationStatus":{},"lastModifiedDate":{"type":"timestamp"},"customerVersion":{"type":"integer"},"generationId":{},"validity":{"shape":"Sca"}}},"registrationConfig":{"shape":"Scb"}}}},"DescribeCertificate":{"http":{"method":"GET","requestUri":"/certificates/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"}}},"output":{"type":"structure","members":{"certificateDescription":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"caCertificateId":{},"status":{},"certificatePem":{},"ownedBy":{},"previousOwnedBy":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"customerVersion":{"type":"integer"},"transferData":{"type":"structure","members":{"transferMessage":{},"rejectReason":{},"transferDate":{"type":"timestamp"},"acceptDate":{"type":"timestamp"},"rejectDate":{"type":"timestamp"}}},"generationId":{},"validity":{"shape":"Sca"}}}}}},"DescribeDefaultAuthorizer":{"http":{"method":"GET","requestUri":"/default-authorizer"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"authorizerDescription":{"shape":"Sbw"}}}},"DescribeEndpoint":{"http":{"method":"GET","requestUri":"/endpoint"},"input":{"type":"structure","members":{"endpointType":{"location":"querystring","locationName":"endpointType"}}},"output":{"type":"structure","members":{"endpointAddress":{}}}},"DescribeEventConfigurations":{"http":{"method":"GET","requestUri":"/event-configurations"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"eventConfigurations":{"shape":"Scr"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"DescribeIndex":{"http":{"method":"GET","requestUri":"/indices/{indexName}"},"input":{"type":"structure","required":["indexName"],"members":{"indexName":{"location":"uri","locationName":"indexName"}}},"output":{"type":"structure","members":{"indexName":{},"indexStatus":{},"schema":{}}}},"DescribeJob":{"http":{"method":"GET","requestUri":"/jobs/{jobId}"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"type":"structure","members":{"documentSource":{},"job":{"type":"structure","members":{"jobArn":{},"jobId":{},"targetSelection":{},"status":{},"forceCanceled":{"type":"boolean"},"reasonCode":{},"comment":{},"targets":{"shape":"Sg"},"description":{},"presignedUrlConfig":{"shape":"S2k"},"jobExecutionsRolloutConfig":{"shape":"S2o"},"abortConfig":{"shape":"S2v"},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"completedAt":{"type":"timestamp"},"jobProcessDetails":{"type":"structure","members":{"processingTargets":{"type":"list","member":{}},"numberOfCanceledThings":{"type":"integer"},"numberOfSucceededThings":{"type":"integer"},"numberOfFailedThings":{"type":"integer"},"numberOfRejectedThings":{"type":"integer"},"numberOfQueuedThings":{"type":"integer"},"numberOfInProgressThings":{"type":"integer"},"numberOfRemovedThings":{"type":"integer"},"numberOfTimedOutThings":{"type":"integer"}}},"timeoutConfig":{"shape":"S32"}}}}}},"DescribeJobExecution":{"http":{"method":"GET","requestUri":"/things/{thingName}/jobs/{jobId}"},"input":{"type":"structure","required":["jobId","thingName"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"thingName":{"location":"uri","locationName":"thingName"},"executionNumber":{"location":"querystring","locationName":"executionNumber","type":"long"}}},"output":{"type":"structure","members":{"execution":{"type":"structure","members":{"jobId":{},"status":{},"forceCanceled":{"type":"boolean"},"statusDetails":{"type":"structure","members":{"detailsMap":{"shape":"S1b"}}},"thingArn":{},"queuedAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"executionNumber":{"type":"long"},"versionNumber":{"type":"long"},"approximateSecondsBeforeTimedOut":{"type":"long"}}}}}},"DescribeMitigationAction":{"http":{"method":"GET","requestUri":"/mitigationactions/actions/{actionName}"},"input":{"type":"structure","required":["actionName"],"members":{"actionName":{"location":"uri","locationName":"actionName"}}},"output":{"type":"structure","members":{"actionName":{},"actionType":{},"actionArn":{},"actionId":{},"roleArn":{},"actionParams":{"shape":"S3c"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"DescribeRoleAlias":{"http":{"method":"GET","requestUri":"/role-aliases/{roleAlias}"},"input":{"type":"structure","required":["roleAlias"],"members":{"roleAlias":{"location":"uri","locationName":"roleAlias"}}},"output":{"type":"structure","members":{"roleAliasDescription":{"type":"structure","members":{"roleAlias":{},"roleAliasArn":{},"roleArn":{},"owner":{},"credentialDurationSeconds":{"type":"integer"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}}}},"DescribeScheduledAudit":{"http":{"method":"GET","requestUri":"/audit/scheduledaudits/{scheduledAuditName}"},"input":{"type":"structure","required":["scheduledAuditName"],"members":{"scheduledAuditName":{"location":"uri","locationName":"scheduledAuditName"}}},"output":{"type":"structure","members":{"frequency":{},"dayOfMonth":{},"dayOfWeek":{},"targetCheckNames":{"shape":"S5k"},"scheduledAuditName":{},"scheduledAuditArn":{}}}},"DescribeSecurityProfile":{"http":{"method":"GET","requestUri":"/security-profiles/{securityProfileName}"},"input":{"type":"structure","required":["securityProfileName"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"}}},"output":{"type":"structure","members":{"securityProfileName":{},"securityProfileArn":{},"securityProfileDescription":{},"behaviors":{"shape":"S5r"},"alertTargets":{"shape":"S68"},"additionalMetricsToRetain":{"shape":"S6c"},"version":{"type":"long"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"DescribeStream":{"http":{"method":"GET","requestUri":"/streams/{streamId}"},"input":{"type":"structure","required":["streamId"],"members":{"streamId":{"location":"uri","locationName":"streamId"}}},"output":{"type":"structure","members":{"streamInfo":{"type":"structure","members":{"streamId":{},"streamArn":{},"streamVersion":{"type":"integer"},"description":{},"files":{"shape":"S6h"},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"roleArn":{}}}}}},"DescribeThing":{"http":{"method":"GET","requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"}}},"output":{"type":"structure","members":{"defaultClientId":{},"thingName":{},"thingId":{},"thingArn":{},"thingTypeName":{},"attributes":{"shape":"S28"},"version":{"type":"long"},"billingGroupName":{}}}},"DescribeThingGroup":{"http":{"method":"GET","requestUri":"/thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"}}},"output":{"type":"structure","members":{"thingGroupName":{},"thingGroupId":{},"thingGroupArn":{},"version":{"type":"long"},"thingGroupProperties":{"shape":"S25"},"thingGroupMetadata":{"type":"structure","members":{"parentGroupName":{},"rootToParentThingGroups":{"shape":"Se4"},"creationDate":{"type":"timestamp"}}},"indexName":{},"queryString":{},"queryVersion":{},"status":{}}}},"DescribeThingRegistrationTask":{"http":{"method":"GET","requestUri":"/thing-registration-tasks/{taskId}"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{"taskId":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"templateBody":{},"inputFileBucket":{},"inputFileKey":{},"roleArn":{},"status":{},"message":{},"successCount":{"type":"integer"},"failureCount":{"type":"integer"},"percentageProgress":{"type":"integer"}}}},"DescribeThingType":{"http":{"method":"GET","requestUri":"/thing-types/{thingTypeName}"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{"thingTypeName":{},"thingTypeId":{},"thingTypeArn":{},"thingTypeProperties":{"shape":"S6t"},"thingTypeMetadata":{"shape":"Seh"}}}},"DetachPolicy":{"http":{"requestUri":"/target-policies/{policyName}"},"input":{"type":"structure","required":["policyName","target"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"target":{}}}},"DetachPrincipalPolicy":{"http":{"method":"DELETE","requestUri":"/principal-policies/{policyName}"},"input":{"type":"structure","required":["policyName","principal"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"principal":{"location":"header","locationName":"x-amzn-iot-principal"}}},"deprecated":true},"DetachSecurityProfile":{"http":{"method":"DELETE","requestUri":"/security-profiles/{securityProfileName}/targets"},"input":{"type":"structure","required":["securityProfileName","securityProfileTargetArn"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"securityProfileTargetArn":{"location":"querystring","locationName":"securityProfileTargetArn"}}},"output":{"type":"structure","members":{}}},"DetachThingPrincipal":{"http":{"method":"DELETE","requestUri":"/things/{thingName}/principals"},"input":{"type":"structure","required":["thingName","principal"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"principal":{"location":"header","locationName":"x-amzn-principal"}}},"output":{"type":"structure","members":{}}},"DisableTopicRule":{"http":{"requestUri":"/rules/{ruleName}/disable"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}}},"EnableTopicRule":{"http":{"requestUri":"/rules/{ruleName}/enable"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}}},"GetEffectivePolicies":{"http":{"requestUri":"/effective-policies"},"input":{"type":"structure","members":{"principal":{},"cognitoIdentityPoolId":{},"thingName":{"location":"querystring","locationName":"thingName"}}},"output":{"type":"structure","members":{"effectivePolicies":{"type":"list","member":{"type":"structure","members":{"policyName":{},"policyArn":{},"policyDocument":{}}}}}}},"GetIndexingConfiguration":{"http":{"method":"GET","requestUri":"/indexing/config"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"thingIndexingConfiguration":{"shape":"Sey"},"thingGroupIndexingConfiguration":{"shape":"Sf1"}}}},"GetJobDocument":{"http":{"method":"GET","requestUri":"/jobs/{jobId}/job-document"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"type":"structure","members":{"document":{}}}},"GetLoggingOptions":{"http":{"method":"GET","requestUri":"/loggingOptions"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"roleArn":{},"logLevel":{}}}},"GetOTAUpdate":{"http":{"method":"GET","requestUri":"/otaUpdates/{otaUpdateId}"},"input":{"type":"structure","required":["otaUpdateId"],"members":{"otaUpdateId":{"location":"uri","locationName":"otaUpdateId"}}},"output":{"type":"structure","members":{"otaUpdateInfo":{"type":"structure","members":{"otaUpdateId":{},"otaUpdateArn":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"description":{},"targets":{"shape":"S3v"},"awsJobExecutionsRolloutConfig":{"shape":"S3x"},"targetSelection":{},"otaUpdateFiles":{"shape":"S3z"},"otaUpdateStatus":{},"awsIotJobId":{},"awsIotJobArn":{},"errorInfo":{"type":"structure","members":{"code":{},"message":{}}},"additionalParameters":{"shape":"S4w"}}}}}},"GetPolicy":{"http":{"method":"GET","requestUri":"/policies/{policyName}"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"}}},"output":{"type":"structure","members":{"policyName":{},"policyArn":{},"policyDocument":{},"defaultVersionId":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"generationId":{}}}},"GetPolicyVersion":{"http":{"method":"GET","requestUri":"/policies/{policyName}/version/{policyVersionId}"},"input":{"type":"structure","required":["policyName","policyVersionId"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyVersionId":{"location":"uri","locationName":"policyVersionId"}}},"output":{"type":"structure","members":{"policyArn":{},"policyName":{},"policyDocument":{},"policyVersionId":{},"isDefaultVersion":{"type":"boolean"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"generationId":{}}}},"GetRegistrationCode":{"http":{"method":"GET","requestUri":"/registrationcode"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"registrationCode":{}}}},"GetStatistics":{"http":{"requestUri":"/indices/statistics"},"input":{"type":"structure","required":["queryString"],"members":{"indexName":{},"queryString":{},"aggregationField":{},"queryVersion":{}}},"output":{"type":"structure","members":{"statistics":{"type":"structure","members":{"count":{"type":"integer"}}}}}},"GetTopicRule":{"http":{"method":"GET","requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}},"output":{"type":"structure","members":{"ruleArn":{},"rule":{"type":"structure","members":{"ruleName":{},"sql":{},"description":{},"createdAt":{"type":"timestamp"},"actions":{"shape":"S74"},"ruleDisabled":{"type":"boolean"},"awsIotSqlVersion":{},"errorAction":{"shape":"S75"}}}}}},"GetV2LoggingOptions":{"http":{"method":"GET","requestUri":"/v2LoggingOptions"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"roleArn":{},"defaultLogLevel":{},"disableAllLogs":{"type":"boolean"}}}},"ListActiveViolations":{"http":{"method":"GET","requestUri":"/active-violations"},"input":{"type":"structure","members":{"thingName":{"location":"querystring","locationName":"thingName"},"securityProfileName":{"location":"querystring","locationName":"securityProfileName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"activeViolations":{"type":"list","member":{"type":"structure","members":{"violationId":{},"thingName":{},"securityProfileName":{},"behavior":{"shape":"S5s"},"lastViolationValue":{"shape":"S5x"},"lastViolationTime":{"type":"timestamp"},"violationStartTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListAttachedPolicies":{"http":{"requestUri":"/attached-policies/{target}"},"input":{"type":"structure","required":["target"],"members":{"target":{"location":"uri","locationName":"target"},"recursive":{"location":"querystring","locationName":"recursive","type":"boolean"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"}}},"output":{"type":"structure","members":{"policies":{"shape":"Sg9"},"nextMarker":{}}}},"ListAuditFindings":{"http":{"requestUri":"/audit/findings"},"input":{"type":"structure","members":{"taskId":{},"checkName":{},"resourceIdentifier":{"shape":"Sai"},"maxResults":{"type":"integer"},"nextToken":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"findings":{"type":"list","member":{"shape":"Sad"}},"nextToken":{}}}},"ListAuditMitigationActionsExecutions":{"http":{"method":"GET","requestUri":"/audit/mitigationactions/executions"},"input":{"type":"structure","required":["taskId","findingId"],"members":{"taskId":{"location":"querystring","locationName":"taskId"},"actionStatus":{"location":"querystring","locationName":"actionStatus"},"findingId":{"location":"querystring","locationName":"findingId"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"actionsExecutions":{"type":"list","member":{"type":"structure","members":{"taskId":{},"findingId":{},"actionName":{},"actionId":{},"status":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"errorCode":{},"message":{}}}},"nextToken":{}}}},"ListAuditMitigationActionsTasks":{"http":{"method":"GET","requestUri":"/audit/mitigationactions/tasks"},"input":{"type":"structure","required":["startTime","endTime"],"members":{"auditTaskId":{"location":"querystring","locationName":"auditTaskId"},"findingId":{"location":"querystring","locationName":"findingId"},"taskStatus":{"location":"querystring","locationName":"taskStatus"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"}}},"output":{"type":"structure","members":{"tasks":{"type":"list","member":{"type":"structure","members":{"taskId":{},"startTime":{"type":"timestamp"},"taskStatus":{}}}},"nextToken":{}}}},"ListAuditTasks":{"http":{"method":"GET","requestUri":"/audit/tasks"},"input":{"type":"structure","required":["startTime","endTime"],"members":{"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"},"taskType":{"location":"querystring","locationName":"taskType"},"taskStatus":{"location":"querystring","locationName":"taskStatus"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"tasks":{"type":"list","member":{"type":"structure","members":{"taskId":{},"taskStatus":{},"taskType":{}}}},"nextToken":{}}}},"ListAuthorizers":{"http":{"method":"GET","requestUri":"/authorizers/"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"},"status":{"location":"querystring","locationName":"status"}}},"output":{"type":"structure","members":{"authorizers":{"type":"list","member":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{}}}},"nextMarker":{}}}},"ListBillingGroups":{"http":{"method":"GET","requestUri":"/billing-groups"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"namePrefixFilter":{"location":"querystring","locationName":"namePrefixFilter"}}},"output":{"type":"structure","members":{"billingGroups":{"type":"list","member":{"shape":"Se5"}},"nextToken":{}}}},"ListCACertificates":{"http":{"method":"GET","requestUri":"/cacertificates"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"certificates":{"type":"list","member":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"status":{},"creationDate":{"type":"timestamp"}}}},"nextMarker":{}}}},"ListCertificates":{"http":{"method":"GET","requestUri":"/certificates"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"certificates":{"shape":"Sh6"},"nextMarker":{}}}},"ListCertificatesByCA":{"http":{"method":"GET","requestUri":"/certificates-by-ca/{caCertificateId}"},"input":{"type":"structure","required":["caCertificateId"],"members":{"caCertificateId":{"location":"uri","locationName":"caCertificateId"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"certificates":{"shape":"Sh6"},"nextMarker":{}}}},"ListIndices":{"http":{"method":"GET","requestUri":"/indices"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"indexNames":{"type":"list","member":{}},"nextToken":{}}}},"ListJobExecutionsForJob":{"http":{"method":"GET","requestUri":"/jobs/{jobId}/things"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"status":{"location":"querystring","locationName":"status"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"executionSummaries":{"type":"list","member":{"type":"structure","members":{"thingArn":{},"jobExecutionSummary":{"shape":"Shj"}}}},"nextToken":{}}}},"ListJobExecutionsForThing":{"http":{"method":"GET","requestUri":"/things/{thingName}/jobs"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"status":{"location":"querystring","locationName":"status"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"executionSummaries":{"type":"list","member":{"type":"structure","members":{"jobId":{},"jobExecutionSummary":{"shape":"Shj"}}}},"nextToken":{}}}},"ListJobs":{"http":{"method":"GET","requestUri":"/jobs"},"input":{"type":"structure","members":{"status":{"location":"querystring","locationName":"status"},"targetSelection":{"location":"querystring","locationName":"targetSelection"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"thingGroupName":{"location":"querystring","locationName":"thingGroupName"},"thingGroupId":{"location":"querystring","locationName":"thingGroupId"}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","members":{"jobArn":{},"jobId":{},"thingGroupId":{},"targetSelection":{},"status":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"completedAt":{"type":"timestamp"}}}},"nextToken":{}}}},"ListMitigationActions":{"http":{"method":"GET","requestUri":"/mitigationactions/actions"},"input":{"type":"structure","members":{"actionType":{"location":"querystring","locationName":"actionType"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"actionIdentifiers":{"type":"list","member":{"type":"structure","members":{"actionName":{},"actionArn":{},"creationDate":{"type":"timestamp"}}}},"nextToken":{}}}},"ListOTAUpdates":{"http":{"method":"GET","requestUri":"/otaUpdates"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"otaUpdateStatus":{"location":"querystring","locationName":"otaUpdateStatus"}}},"output":{"type":"structure","members":{"otaUpdates":{"type":"list","member":{"type":"structure","members":{"otaUpdateId":{},"otaUpdateArn":{},"creationDate":{"type":"timestamp"}}}},"nextToken":{}}}},"ListOutgoingCertificates":{"http":{"method":"GET","requestUri":"/certificates-out-going"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"outgoingCertificates":{"type":"list","member":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"transferredTo":{},"transferDate":{"type":"timestamp"},"transferMessage":{},"creationDate":{"type":"timestamp"}}}},"nextMarker":{}}}},"ListPolicies":{"http":{"method":"GET","requestUri":"/policies"},"input":{"type":"structure","members":{"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"policies":{"shape":"Sg9"},"nextMarker":{}}}},"ListPolicyPrincipals":{"http":{"method":"GET","requestUri":"/policy-principals"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"header","locationName":"x-amzn-iot-policy"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"principals":{"shape":"Si8"},"nextMarker":{}}},"deprecated":true},"ListPolicyVersions":{"http":{"method":"GET","requestUri":"/policies/{policyName}/version"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"}}},"output":{"type":"structure","members":{"policyVersions":{"type":"list","member":{"type":"structure","members":{"versionId":{},"isDefaultVersion":{"type":"boolean"},"createDate":{"type":"timestamp"}}}}}}},"ListPrincipalPolicies":{"http":{"method":"GET","requestUri":"/principal-policies"},"input":{"type":"structure","required":["principal"],"members":{"principal":{"location":"header","locationName":"x-amzn-iot-principal"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"policies":{"shape":"Sg9"},"nextMarker":{}}},"deprecated":true},"ListPrincipalThings":{"http":{"method":"GET","requestUri":"/principals/things"},"input":{"type":"structure","required":["principal"],"members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"principal":{"location":"header","locationName":"x-amzn-principal"}}},"output":{"type":"structure","members":{"things":{"shape":"Sii"},"nextToken":{}}}},"ListRoleAliases":{"http":{"method":"GET","requestUri":"/role-aliases"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"roleAliases":{"type":"list","member":{}},"nextMarker":{}}}},"ListScheduledAudits":{"http":{"method":"GET","requestUri":"/audit/scheduledaudits"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"scheduledAudits":{"type":"list","member":{"type":"structure","members":{"scheduledAuditName":{},"scheduledAuditArn":{},"frequency":{},"dayOfMonth":{},"dayOfWeek":{}}}},"nextToken":{}}}},"ListSecurityProfiles":{"http":{"method":"GET","requestUri":"/security-profiles"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"securityProfileIdentifiers":{"type":"list","member":{"shape":"Sit"}},"nextToken":{}}}},"ListSecurityProfilesForTarget":{"http":{"method":"GET","requestUri":"/security-profiles-for-target"},"input":{"type":"structure","required":["securityProfileTargetArn"],"members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"recursive":{"location":"querystring","locationName":"recursive","type":"boolean"},"securityProfileTargetArn":{"location":"querystring","locationName":"securityProfileTargetArn"}}},"output":{"type":"structure","members":{"securityProfileTargetMappings":{"type":"list","member":{"type":"structure","members":{"securityProfileIdentifier":{"shape":"Sit"},"target":{"shape":"Siy"}}}},"nextToken":{}}}},"ListStreams":{"http":{"method":"GET","requestUri":"/streams"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"streams":{"type":"list","member":{"type":"structure","members":{"streamId":{},"streamArn":{},"streamVersion":{"type":"integer"},"description":{}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"tags":{"shape":"S1t"},"nextToken":{}}}},"ListTargetsForPolicy":{"http":{"requestUri":"/policy-targets/{policyName}"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"}}},"output":{"type":"structure","members":{"targets":{"type":"list","member":{}},"nextMarker":{}}}},"ListTargetsForSecurityProfile":{"http":{"method":"GET","requestUri":"/security-profiles/{securityProfileName}/targets"},"input":{"type":"structure","required":["securityProfileName"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"securityProfileTargets":{"type":"list","member":{"shape":"Siy"}},"nextToken":{}}}},"ListThingGroups":{"http":{"method":"GET","requestUri":"/thing-groups"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"parentGroup":{"location":"querystring","locationName":"parentGroup"},"namePrefixFilter":{"location":"querystring","locationName":"namePrefixFilter"},"recursive":{"location":"querystring","locationName":"recursive","type":"boolean"}}},"output":{"type":"structure","members":{"thingGroups":{"shape":"Se4"},"nextToken":{}}}},"ListThingGroupsForThing":{"http":{"method":"GET","requestUri":"/things/{thingName}/thing-groups"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"thingGroups":{"shape":"Se4"},"nextToken":{}}}},"ListThingPrincipals":{"http":{"method":"GET","requestUri":"/things/{thingName}/principals"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"}}},"output":{"type":"structure","members":{"principals":{"shape":"Si8"}}}},"ListThingRegistrationTaskReports":{"http":{"method":"GET","requestUri":"/thing-registration-tasks/{taskId}/reports"},"input":{"type":"structure","required":["taskId","reportType"],"members":{"taskId":{"location":"uri","locationName":"taskId"},"reportType":{"location":"querystring","locationName":"reportType"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"resourceLinks":{"type":"list","member":{}},"reportType":{},"nextToken":{}}}},"ListThingRegistrationTasks":{"http":{"method":"GET","requestUri":"/thing-registration-tasks"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"status":{"location":"querystring","locationName":"status"}}},"output":{"type":"structure","members":{"taskIds":{"type":"list","member":{}},"nextToken":{}}}},"ListThingTypes":{"http":{"method":"GET","requestUri":"/thing-types"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"thingTypeName":{"location":"querystring","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{"thingTypes":{"type":"list","member":{"type":"structure","members":{"thingTypeName":{},"thingTypeArn":{},"thingTypeProperties":{"shape":"S6t"},"thingTypeMetadata":{"shape":"Seh"}}}},"nextToken":{}}}},"ListThings":{"http":{"method":"GET","requestUri":"/things"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"attributeName":{"location":"querystring","locationName":"attributeName"},"attributeValue":{"location":"querystring","locationName":"attributeValue"},"thingTypeName":{"location":"querystring","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{"things":{"type":"list","member":{"type":"structure","members":{"thingName":{},"thingTypeName":{},"thingArn":{},"attributes":{"shape":"S28"},"version":{"type":"long"}}}},"nextToken":{}}}},"ListThingsInBillingGroup":{"http":{"method":"GET","requestUri":"/billing-groups/{billingGroupName}/things"},"input":{"type":"structure","required":["billingGroupName"],"members":{"billingGroupName":{"location":"uri","locationName":"billingGroupName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"things":{"shape":"Sii"},"nextToken":{}}}},"ListThingsInThingGroup":{"http":{"method":"GET","requestUri":"/thing-groups/{thingGroupName}/things"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"recursive":{"location":"querystring","locationName":"recursive","type":"boolean"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"things":{"shape":"Sii"},"nextToken":{}}}},"ListTopicRules":{"http":{"method":"GET","requestUri":"/rules"},"input":{"type":"structure","members":{"topic":{"location":"querystring","locationName":"topic"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"ruleDisabled":{"location":"querystring","locationName":"ruleDisabled","type":"boolean"}}},"output":{"type":"structure","members":{"rules":{"type":"list","member":{"type":"structure","members":{"ruleArn":{},"ruleName":{},"topicPattern":{},"createdAt":{"type":"timestamp"},"ruleDisabled":{"type":"boolean"}}}},"nextToken":{}}}},"ListV2LoggingLevels":{"http":{"method":"GET","requestUri":"/v2LoggingLevel"},"input":{"type":"structure","members":{"targetType":{"location":"querystring","locationName":"targetType"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"logTargetConfigurations":{"type":"list","member":{"type":"structure","members":{"logTarget":{"shape":"Ske"},"logLevel":{}}}},"nextToken":{}}}},"ListViolationEvents":{"http":{"method":"GET","requestUri":"/violation-events"},"input":{"type":"structure","required":["startTime","endTime"],"members":{"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"},"thingName":{"location":"querystring","locationName":"thingName"},"securityProfileName":{"location":"querystring","locationName":"securityProfileName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"violationEvents":{"type":"list","member":{"type":"structure","members":{"violationId":{},"thingName":{},"securityProfileName":{},"behavior":{"shape":"S5s"},"metricValue":{"shape":"S5x"},"violationEventType":{},"violationEventTime":{"type":"timestamp"}}}},"nextToken":{}}}},"RegisterCACertificate":{"http":{"requestUri":"/cacertificate"},"input":{"type":"structure","required":["caCertificate","verificationCertificate"],"members":{"caCertificate":{},"verificationCertificate":{},"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"},"allowAutoRegistration":{"location":"querystring","locationName":"allowAutoRegistration","type":"boolean"},"registrationConfig":{"shape":"Scb"}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{}}}},"RegisterCertificate":{"http":{"requestUri":"/certificate/register"},"input":{"type":"structure","required":["certificatePem"],"members":{"certificatePem":{},"caCertificatePem":{},"setAsActive":{"deprecated":true,"location":"querystring","locationName":"setAsActive","type":"boolean"},"status":{}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{}}}},"RegisterThing":{"http":{"requestUri":"/things"},"input":{"type":"structure","required":["templateBody"],"members":{"templateBody":{},"parameters":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","members":{"certificatePem":{},"resourceArns":{"type":"map","key":{},"value":{}}}}},"RejectCertificateTransfer":{"http":{"method":"PATCH","requestUri":"/reject-certificate-transfer/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"rejectReason":{}}}},"RemoveThingFromBillingGroup":{"http":{"method":"PUT","requestUri":"/billing-groups/removeThingFromBillingGroup"},"input":{"type":"structure","members":{"billingGroupName":{},"billingGroupArn":{},"thingName":{},"thingArn":{}}},"output":{"type":"structure","members":{}}},"RemoveThingFromThingGroup":{"http":{"method":"PUT","requestUri":"/thing-groups/removeThingFromThingGroup"},"input":{"type":"structure","members":{"thingGroupName":{},"thingGroupArn":{},"thingName":{},"thingArn":{}}},"output":{"type":"structure","members":{}}},"ReplaceTopicRule":{"http":{"method":"PATCH","requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName","topicRulePayload"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"},"topicRulePayload":{"shape":"S71"}},"payload":"topicRulePayload"}},"SearchIndex":{"http":{"requestUri":"/indices/search"},"input":{"type":"structure","required":["queryString"],"members":{"indexName":{},"queryString":{},"nextToken":{},"maxResults":{"type":"integer"},"queryVersion":{}}},"output":{"type":"structure","members":{"nextToken":{},"things":{"type":"list","member":{"type":"structure","members":{"thingName":{},"thingId":{},"thingTypeName":{},"thingGroupNames":{"shape":"Sl6"},"attributes":{"shape":"S28"},"shadow":{},"connectivity":{"type":"structure","members":{"connected":{"type":"boolean"},"timestamp":{"type":"long"}}}}}},"thingGroups":{"type":"list","member":{"type":"structure","members":{"thingGroupName":{},"thingGroupId":{},"thingGroupDescription":{},"attributes":{"shape":"S28"},"parentGroupNames":{"shape":"Sl6"}}}}}}},"SetDefaultAuthorizer":{"http":{"requestUri":"/default-authorizer"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{}}},"output":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{}}}},"SetDefaultPolicyVersion":{"http":{"method":"PATCH","requestUri":"/policies/{policyName}/version/{policyVersionId}"},"input":{"type":"structure","required":["policyName","policyVersionId"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyVersionId":{"location":"uri","locationName":"policyVersionId"}}}},"SetLoggingOptions":{"http":{"requestUri":"/loggingOptions"},"input":{"type":"structure","required":["loggingOptionsPayload"],"members":{"loggingOptionsPayload":{"type":"structure","required":["roleArn"],"members":{"roleArn":{},"logLevel":{}}}},"payload":"loggingOptionsPayload"}},"SetV2LoggingLevel":{"http":{"requestUri":"/v2LoggingLevel"},"input":{"type":"structure","required":["logTarget","logLevel"],"members":{"logTarget":{"shape":"Ske"},"logLevel":{}}}},"SetV2LoggingOptions":{"http":{"requestUri":"/v2LoggingOptions"},"input":{"type":"structure","members":{"roleArn":{},"defaultLogLevel":{},"disableAllLogs":{"type":"boolean"}}}},"StartAuditMitigationActionsTask":{"http":{"requestUri":"/audit/mitigationactions/tasks/{taskId}"},"input":{"type":"structure","required":["taskId","target","auditCheckToActionsMapping","clientRequestToken"],"members":{"taskId":{"location":"uri","locationName":"taskId"},"target":{"shape":"Sb2"},"auditCheckToActionsMapping":{"shape":"Sb6"},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"taskId":{}}}},"StartOnDemandAuditTask":{"http":{"requestUri":"/audit/tasks"},"input":{"type":"structure","required":["targetCheckNames"],"members":{"targetCheckNames":{"shape":"S5k"}}},"output":{"type":"structure","members":{"taskId":{}}}},"StartThingRegistrationTask":{"http":{"requestUri":"/thing-registration-tasks"},"input":{"type":"structure","required":["templateBody","inputFileBucket","inputFileKey","roleArn"],"members":{"templateBody":{},"inputFileBucket":{},"inputFileKey":{},"roleArn":{}}},"output":{"type":"structure","members":{"taskId":{}}}},"StopThingRegistrationTask":{"http":{"method":"PUT","requestUri":"/thing-registration-tasks/{taskId}/cancel"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"requestUri":"/tags"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S1t"}}},"output":{"type":"structure","members":{}}},"TestAuthorization":{"http":{"requestUri":"/test-authorization"},"input":{"type":"structure","required":["authInfos"],"members":{"principal":{},"cognitoIdentityPoolId":{},"authInfos":{"type":"list","member":{"shape":"Slw"}},"clientId":{"location":"querystring","locationName":"clientId"},"policyNamesToAdd":{"shape":"Sm0"},"policyNamesToSkip":{"shape":"Sm0"}}},"output":{"type":"structure","members":{"authResults":{"type":"list","member":{"type":"structure","members":{"authInfo":{"shape":"Slw"},"allowed":{"type":"structure","members":{"policies":{"shape":"Sg9"}}},"denied":{"type":"structure","members":{"implicitDeny":{"type":"structure","members":{"policies":{"shape":"Sg9"}}},"explicitDeny":{"type":"structure","members":{"policies":{"shape":"Sg9"}}}}},"authDecision":{},"missingContextValues":{"type":"list","member":{}}}}}}}},"TestInvokeAuthorizer":{"http":{"requestUri":"/authorizer/{authorizerName}/test"},"input":{"type":"structure","required":["authorizerName","token","tokenSignature"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"},"token":{},"tokenSignature":{}}},"output":{"type":"structure","members":{"isAuthenticated":{"type":"boolean"},"principalId":{},"policyDocuments":{"type":"list","member":{}},"refreshAfterInSeconds":{"type":"integer"},"disconnectAfterInSeconds":{"type":"integer"}}}},"TransferCertificate":{"http":{"method":"PATCH","requestUri":"/transfer-certificate/{certificateId}"},"input":{"type":"structure","required":["certificateId","targetAwsAccount"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"targetAwsAccount":{"location":"querystring","locationName":"targetAwsAccount"},"transferMessage":{}}},"output":{"type":"structure","members":{"transferredCertificateArn":{}}}},"UntagResource":{"http":{"requestUri":"/untag"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAccountAuditConfiguration":{"http":{"method":"PATCH","requestUri":"/audit/configuration"},"input":{"type":"structure","members":{"roleArn":{},"auditNotificationTargetConfigurations":{"shape":"Sa4"},"auditCheckConfigurations":{"shape":"Sa8"}}},"output":{"type":"structure","members":{}}},"UpdateAuthorizer":{"http":{"method":"PUT","requestUri":"/authorizer/{authorizerName}"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"},"authorizerFunctionArn":{},"tokenKeyName":{},"tokenSigningPublicKeys":{"shape":"S1k"},"status":{}}},"output":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{}}}},"UpdateBillingGroup":{"http":{"method":"PATCH","requestUri":"/billing-groups/{billingGroupName}"},"input":{"type":"structure","required":["billingGroupName","billingGroupProperties"],"members":{"billingGroupName":{"location":"uri","locationName":"billingGroupName"},"billingGroupProperties":{"shape":"S1r"},"expectedVersion":{"type":"long"}}},"output":{"type":"structure","members":{"version":{"type":"long"}}}},"UpdateCACertificate":{"http":{"method":"PUT","requestUri":"/cacertificate/{caCertificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"caCertificateId"},"newStatus":{"location":"querystring","locationName":"newStatus"},"newAutoRegistrationStatus":{"location":"querystring","locationName":"newAutoRegistrationStatus"},"registrationConfig":{"shape":"Scb"},"removeAutoRegistration":{"type":"boolean"}}}},"UpdateCertificate":{"http":{"method":"PUT","requestUri":"/certificates/{certificateId}"},"input":{"type":"structure","required":["certificateId","newStatus"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"newStatus":{"location":"querystring","locationName":"newStatus"}}}},"UpdateDynamicThingGroup":{"http":{"method":"PATCH","requestUri":"/dynamic-thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName","thingGroupProperties"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"thingGroupProperties":{"shape":"S25"},"expectedVersion":{"type":"long"},"indexName":{},"queryString":{},"queryVersion":{}}},"output":{"type":"structure","members":{"version":{"type":"long"}}}},"UpdateEventConfigurations":{"http":{"method":"PATCH","requestUri":"/event-configurations"},"input":{"type":"structure","members":{"eventConfigurations":{"shape":"Scr"}}},"output":{"type":"structure","members":{}}},"UpdateIndexingConfiguration":{"http":{"requestUri":"/indexing/config"},"input":{"type":"structure","members":{"thingIndexingConfiguration":{"shape":"Sey"},"thingGroupIndexingConfiguration":{"shape":"Sf1"}}},"output":{"type":"structure","members":{}}},"UpdateJob":{"http":{"method":"PATCH","requestUri":"/jobs/{jobId}"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"description":{},"presignedUrlConfig":{"shape":"S2k"},"jobExecutionsRolloutConfig":{"shape":"S2o"},"abortConfig":{"shape":"S2v"},"timeoutConfig":{"shape":"S32"}}}},"UpdateMitigationAction":{"http":{"method":"PATCH","requestUri":"/mitigationactions/actions/{actionName}"},"input":{"type":"structure","required":["actionName"],"members":{"actionName":{"location":"uri","locationName":"actionName"},"roleArn":{},"actionParams":{"shape":"S3c"}}},"output":{"type":"structure","members":{"actionArn":{},"actionId":{}}}},"UpdateRoleAlias":{"http":{"method":"PUT","requestUri":"/role-aliases/{roleAlias}"},"input":{"type":"structure","required":["roleAlias"],"members":{"roleAlias":{"location":"uri","locationName":"roleAlias"},"roleArn":{},"credentialDurationSeconds":{"type":"integer"}}},"output":{"type":"structure","members":{"roleAlias":{},"roleAliasArn":{}}}},"UpdateScheduledAudit":{"http":{"method":"PATCH","requestUri":"/audit/scheduledaudits/{scheduledAuditName}"},"input":{"type":"structure","required":["scheduledAuditName"],"members":{"frequency":{},"dayOfMonth":{},"dayOfWeek":{},"targetCheckNames":{"shape":"S5k"},"scheduledAuditName":{"location":"uri","locationName":"scheduledAuditName"}}},"output":{"type":"structure","members":{"scheduledAuditArn":{}}}},"UpdateSecurityProfile":{"http":{"method":"PATCH","requestUri":"/security-profiles/{securityProfileName}"},"input":{"type":"structure","required":["securityProfileName"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"securityProfileDescription":{},"behaviors":{"shape":"S5r"},"alertTargets":{"shape":"S68"},"additionalMetricsToRetain":{"shape":"S6c"},"deleteBehaviors":{"type":"boolean"},"deleteAlertTargets":{"type":"boolean"},"deleteAdditionalMetricsToRetain":{"type":"boolean"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{"securityProfileName":{},"securityProfileArn":{},"securityProfileDescription":{},"behaviors":{"shape":"S5r"},"alertTargets":{"shape":"S68"},"additionalMetricsToRetain":{"shape":"S6c"},"version":{"type":"long"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"UpdateStream":{"http":{"method":"PUT","requestUri":"/streams/{streamId}"},"input":{"type":"structure","required":["streamId"],"members":{"streamId":{"location":"uri","locationName":"streamId"},"description":{},"files":{"shape":"S6h"},"roleArn":{}}},"output":{"type":"structure","members":{"streamId":{},"streamArn":{},"description":{},"streamVersion":{"type":"integer"}}}},"UpdateThing":{"http":{"method":"PATCH","requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"thingTypeName":{},"attributePayload":{"shape":"S27"},"expectedVersion":{"type":"long"},"removeThingType":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"UpdateThingGroup":{"http":{"method":"PATCH","requestUri":"/thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName","thingGroupProperties"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"thingGroupProperties":{"shape":"S25"},"expectedVersion":{"type":"long"}}},"output":{"type":"structure","members":{"version":{"type":"long"}}}},"UpdateThingGroupsForThing":{"http":{"method":"PUT","requestUri":"/thing-groups/updateThingGroupsForThing"},"input":{"type":"structure","members":{"thingName":{},"thingGroupsToAdd":{"shape":"Snn"},"thingGroupsToRemove":{"shape":"Snn"},"overrideDynamicGroups":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"ValidateSecurityProfileBehaviors":{"http":{"requestUri":"/security-profile-behaviors/validate"},"input":{"type":"structure","required":["behaviors"],"members":{"behaviors":{"shape":"S5r"}}},"output":{"type":"structure","members":{"valid":{"type":"boolean"},"validationErrors":{"type":"list","member":{"type":"structure","members":{"errorMessage":{}}}}}}}},"shapes":{"Sg":{"type":"list","member":{}},"S1b":{"type":"map","key":{},"value":{}},"S1k":{"type":"map","key":{},"value":{}},"S1r":{"type":"structure","members":{"billingGroupDescription":{}}},"S1t":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S25":{"type":"structure","members":{"thingGroupDescription":{},"attributePayload":{"shape":"S27"}}},"S27":{"type":"structure","members":{"attributes":{"shape":"S28"},"merge":{"type":"boolean"}}},"S28":{"type":"map","key":{},"value":{}},"S2k":{"type":"structure","members":{"roleArn":{},"expiresInSec":{"type":"long"}}},"S2o":{"type":"structure","members":{"maximumPerMinute":{"type":"integer"},"exponentialRate":{"type":"structure","required":["baseRatePerMinute","incrementFactor","rateIncreaseCriteria"],"members":{"baseRatePerMinute":{"type":"integer"},"incrementFactor":{"type":"double"},"rateIncreaseCriteria":{"type":"structure","members":{"numberOfNotifiedThings":{"type":"integer"},"numberOfSucceededThings":{"type":"integer"}}}}}}},"S2v":{"type":"structure","required":["criteriaList"],"members":{"criteriaList":{"type":"list","member":{"type":"structure","required":["failureType","action","thresholdPercentage","minNumberOfExecutedThings"],"members":{"failureType":{},"action":{},"thresholdPercentage":{"type":"double"},"minNumberOfExecutedThings":{"type":"integer"}}}}}},"S32":{"type":"structure","members":{"inProgressTimeoutInMinutes":{"type":"long"}}},"S3c":{"type":"structure","members":{"updateDeviceCertificateParams":{"type":"structure","required":["action"],"members":{"action":{}}},"updateCACertificateParams":{"type":"structure","required":["action"],"members":{"action":{}}},"addThingsToThingGroupParams":{"type":"structure","required":["thingGroupNames"],"members":{"thingGroupNames":{"type":"list","member":{}},"overrideDynamicGroups":{"type":"boolean"}}},"replaceDefaultPolicyVersionParams":{"type":"structure","required":["templateName"],"members":{"templateName":{}}},"enableIoTLoggingParams":{"type":"structure","required":["roleArnForLogging","logLevel"],"members":{"roleArnForLogging":{},"logLevel":{}}},"publishFindingToSnsParams":{"type":"structure","required":["topicArn"],"members":{"topicArn":{}}}}},"S3v":{"type":"list","member":{}},"S3x":{"type":"structure","members":{"maximumPerMinute":{"type":"integer"}}},"S3z":{"type":"list","member":{"type":"structure","members":{"fileName":{},"fileVersion":{},"fileLocation":{"type":"structure","members":{"stream":{"type":"structure","members":{"streamId":{},"fileId":{"type":"integer"}}},"s3Location":{"shape":"S47"}}},"codeSigning":{"type":"structure","members":{"awsSignerJobId":{},"startSigningJobParameter":{"type":"structure","members":{"signingProfileParameter":{"type":"structure","members":{"certificateArn":{},"platform":{},"certificatePathOnDevice":{}}},"signingProfileName":{},"destination":{"type":"structure","members":{"s3Destination":{"type":"structure","members":{"bucket":{},"prefix":{}}}}}}},"customCodeSigning":{"type":"structure","members":{"signature":{"type":"structure","members":{"inlineDocument":{"type":"blob"}}},"certificateChain":{"type":"structure","members":{"certificateName":{},"inlineDocument":{}}},"hashAlgorithm":{},"signatureAlgorithm":{}}}}},"attributes":{"type":"map","key":{},"value":{}}}}},"S47":{"type":"structure","members":{"bucket":{},"key":{},"version":{}}},"S4w":{"type":"map","key":{},"value":{}},"S5k":{"type":"list","member":{}},"S5r":{"type":"list","member":{"shape":"S5s"}},"S5s":{"type":"structure","required":["name"],"members":{"name":{},"metric":{},"criteria":{"type":"structure","members":{"comparisonOperator":{},"value":{"shape":"S5x"},"durationSeconds":{"type":"integer"},"consecutiveDatapointsToAlarm":{"type":"integer"},"consecutiveDatapointsToClear":{"type":"integer"},"statisticalThreshold":{"type":"structure","members":{"statistic":{}}}}}}},"S5x":{"type":"structure","members":{"count":{"type":"long"},"cidrs":{"type":"list","member":{}},"ports":{"type":"list","member":{"type":"integer"}}}},"S68":{"type":"map","key":{},"value":{"type":"structure","required":["alertTargetArn","roleArn"],"members":{"alertTargetArn":{},"roleArn":{}}}},"S6c":{"type":"list","member":{}},"S6h":{"type":"list","member":{"type":"structure","members":{"fileId":{"type":"integer"},"s3Location":{"shape":"S47"}}}},"S6t":{"type":"structure","members":{"thingTypeDescription":{},"searchableAttributes":{"type":"list","member":{}}}},"S71":{"type":"structure","required":["sql","actions"],"members":{"sql":{},"description":{},"actions":{"shape":"S74"},"ruleDisabled":{"type":"boolean"},"awsIotSqlVersion":{},"errorAction":{"shape":"S75"}}},"S74":{"type":"list","member":{"shape":"S75"}},"S75":{"type":"structure","members":{"dynamoDB":{"type":"structure","required":["tableName","roleArn","hashKeyField","hashKeyValue"],"members":{"tableName":{},"roleArn":{},"operation":{},"hashKeyField":{},"hashKeyValue":{},"hashKeyType":{},"rangeKeyField":{},"rangeKeyValue":{},"rangeKeyType":{},"payloadField":{}}},"dynamoDBv2":{"type":"structure","required":["roleArn","putItem"],"members":{"roleArn":{},"putItem":{"type":"structure","required":["tableName"],"members":{"tableName":{}}}}},"lambda":{"type":"structure","required":["functionArn"],"members":{"functionArn":{}}},"sns":{"type":"structure","required":["targetArn","roleArn"],"members":{"targetArn":{},"roleArn":{},"messageFormat":{}}},"sqs":{"type":"structure","required":["roleArn","queueUrl"],"members":{"roleArn":{},"queueUrl":{},"useBase64":{"type":"boolean"}}},"kinesis":{"type":"structure","required":["roleArn","streamName"],"members":{"roleArn":{},"streamName":{},"partitionKey":{}}},"republish":{"type":"structure","required":["roleArn","topic"],"members":{"roleArn":{},"topic":{},"qos":{"type":"integer"}}},"s3":{"type":"structure","required":["roleArn","bucketName","key"],"members":{"roleArn":{},"bucketName":{},"key":{},"cannedAcl":{}}},"firehose":{"type":"structure","required":["roleArn","deliveryStreamName"],"members":{"roleArn":{},"deliveryStreamName":{},"separator":{}}},"cloudwatchMetric":{"type":"structure","required":["roleArn","metricNamespace","metricName","metricValue","metricUnit"],"members":{"roleArn":{},"metricNamespace":{},"metricName":{},"metricValue":{},"metricUnit":{},"metricTimestamp":{}}},"cloudwatchAlarm":{"type":"structure","required":["roleArn","alarmName","stateReason","stateValue"],"members":{"roleArn":{},"alarmName":{},"stateReason":{},"stateValue":{}}},"elasticsearch":{"type":"structure","required":["roleArn","endpoint","index","type","id"],"members":{"roleArn":{},"endpoint":{},"index":{},"type":{},"id":{}}},"salesforce":{"type":"structure","required":["token","url"],"members":{"token":{},"url":{}}},"iotAnalytics":{"type":"structure","members":{"channelArn":{},"channelName":{},"roleArn":{}}},"iotEvents":{"type":"structure","required":["inputName","roleArn"],"members":{"inputName":{},"messageId":{},"roleArn":{}}},"stepFunctions":{"type":"structure","required":["stateMachineName","roleArn"],"members":{"executionNamePrefix":{},"stateMachineName":{},"roleArn":{}}}}},"Sa4":{"type":"map","key":{},"value":{"type":"structure","members":{"targetArn":{},"roleArn":{},"enabled":{"type":"boolean"}}}},"Sa8":{"type":"map","key":{},"value":{"type":"structure","members":{"enabled":{"type":"boolean"}}}},"Sad":{"type":"structure","members":{"findingId":{},"taskId":{},"checkName":{},"taskStartTime":{"type":"timestamp"},"findingTime":{"type":"timestamp"},"severity":{},"nonCompliantResource":{"type":"structure","members":{"resourceType":{},"resourceIdentifier":{"shape":"Sai"},"additionalInfo":{"shape":"San"}}},"relatedResources":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"resourceIdentifier":{"shape":"Sai"},"additionalInfo":{"shape":"San"}}}},"reasonForNonCompliance":{},"reasonForNonComplianceCode":{}}},"Sai":{"type":"structure","members":{"deviceCertificateId":{},"caCertificateId":{},"cognitoIdentityPoolId":{},"clientId":{},"policyVersionIdentifier":{"type":"structure","members":{"policyName":{},"policyVersionId":{}}},"account":{}}},"San":{"type":"map","key":{},"value":{}},"Sb2":{"type":"structure","members":{"auditTaskId":{},"findingIds":{"type":"list","member":{}},"auditCheckToReasonCodeFilter":{"type":"map","key":{},"value":{"type":"list","member":{}}}}},"Sb6":{"type":"map","key":{},"value":{"type":"list","member":{}}},"Sbw":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{},"authorizerFunctionArn":{},"tokenKeyName":{},"tokenSigningPublicKeys":{"shape":"S1k"},"status":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}},"Sca":{"type":"structure","members":{"notBefore":{"type":"timestamp"},"notAfter":{"type":"timestamp"}}},"Scb":{"type":"structure","members":{"templateBody":{},"roleArn":{}}},"Scr":{"type":"map","key":{},"value":{"type":"structure","members":{"Enabled":{"type":"boolean"}}}},"Se4":{"type":"list","member":{"shape":"Se5"}},"Se5":{"type":"structure","members":{"groupName":{},"groupArn":{}}},"Seh":{"type":"structure","members":{"deprecated":{"type":"boolean"},"deprecationDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"}}},"Sey":{"type":"structure","required":["thingIndexingMode"],"members":{"thingIndexingMode":{},"thingConnectivityIndexingMode":{}}},"Sf1":{"type":"structure","required":["thingGroupIndexingMode"],"members":{"thingGroupIndexingMode":{}}},"Sg9":{"type":"list","member":{"type":"structure","members":{"policyName":{},"policyArn":{}}}},"Sh6":{"type":"list","member":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"status":{},"creationDate":{"type":"timestamp"}}}},"Shj":{"type":"structure","members":{"status":{},"queuedAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"executionNumber":{"type":"long"}}},"Si8":{"type":"list","member":{}},"Sii":{"type":"list","member":{}},"Sit":{"type":"structure","required":["name","arn"],"members":{"name":{},"arn":{}}},"Siy":{"type":"structure","required":["arn"],"members":{"arn":{}}},"Ske":{"type":"structure","required":["targetType"],"members":{"targetType":{},"targetName":{}}},"Sl6":{"type":"list","member":{}},"Slw":{"type":"structure","members":{"actionType":{},"resources":{"type":"list","member":{}}}},"Sm0":{"type":"list","member":{}},"Snn":{"type":"list","member":{}}}}');

});

parcelRequire.register("lgWUV", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("jLtQS", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $e63990108b55fb1c$var$Service = $dbC7k.Service;
var $e63990108b55fb1c$var$apiLoader = $dbC7k.apiLoader;
$e63990108b55fb1c$var$apiLoader.services["iotdata"] = {};
$dbC7k.IotData = $e63990108b55fb1c$var$Service.defineService("iotdata", [
    "2015-05-28"
]);
parcelRequire("9fCPq");

Object.defineProperty($e63990108b55fb1c$var$apiLoader.services["iotdata"], "2015-05-28", {
    get: function get() {
        var model = (parcelRequire("fzHpl"));
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.IotData;

});
parcelRequire.register("9fCPq", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
/**
 * @api private
 */ var $6bc3a248380870aa$var$blobPayloadOutputOps = [
    "deleteThingShadow",
    "getThingShadow",
    "updateThingShadow"
];
/**
 * Constructs a service interface object. Each API operation is exposed as a
 * function on service.
 *
 * ### Sending a Request Using IotData
 *
 * ```javascript
 * var iotdata = new AWS.IotData({endpoint: 'my.host.tld'});
 * iotdata.getThingShadow(params, function (err, data) {
 *   if (err) console.log(err, err.stack); // an error occurred
 *   else     console.log(data);           // successful response
 * });
 * ```
 *
 * ### Locking the API Version
 *
 * In order to ensure that the IotData object uses this specific API,
 * you can construct the object by passing the `apiVersion` option to the
 * constructor:
 *
 * ```javascript
 * var iotdata = new AWS.IotData({
 *   endpoint: 'my.host.tld',
 *   apiVersion: '2015-05-28'
 * });
 * ```
 *
 * You can also set the API version globally in `AWS.config.apiVersions` using
 * the **iotdata** service identifier:
 *
 * ```javascript
 * AWS.config.apiVersions = {
 *   iotdata: '2015-05-28',
 *   // other service API versions
 * };
 *
 * var iotdata = new AWS.IotData({endpoint: 'my.host.tld'});
 * ```
 *
 * @note You *must* provide an `endpoint` configuration parameter when
 *   constructing this service. See {constructor} for more information.
 *
 * @!method constructor(options = {})
 *   Constructs a service object. This object has one method for each
 *   API operation.
 *
 *   @example Constructing a IotData object
 *     var iotdata = new AWS.IotData({endpoint: 'my.host.tld'});
 *   @note You *must* provide an `endpoint` when constructing this service.
 *   @option (see AWS.Config.constructor)
 *
 * @service iotdata
 * @version 2015-05-28
 */ $dbC7k.util.update($dbC7k.IotData.prototype, {
    /**
     * @api private
     */ validateService: function validateService() {
        if (!this.config.endpoint || this.config.endpoint.indexOf("{") >= 0) {
            var msg = "AWS.IotData requires an explicit `endpoint' configuration option.";
            throw $dbC7k.util.error(new Error(), {
                name: "InvalidEndpoint",
                message: msg
            });
        }
    },
    /**
     * @api private
     */ setupRequestListeners: function setupRequestListeners(request) {
        request.addListener("validateResponse", this.validateResponseBody);
        if ($6bc3a248380870aa$var$blobPayloadOutputOps.indexOf(request.operation) > -1) request.addListener("extractData", $dbC7k.util.convertPayloadToString);
    },
    /**
     * @api private
     */ validateResponseBody: function validateResponseBody(resp) {
        var body = resp.httpResponse.body.toString() || "{}";
        var bodyCheck = body.trim();
        if (!bodyCheck || bodyCheck.charAt(0) !== "{") resp.httpResponse.body = "";
    }
});

});

parcelRequire.register("fzHpl", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"uid":"iot-data-2015-05-28","apiVersion":"2015-05-28","endpointPrefix":"data.iot","protocol":"rest-json","serviceFullName":"AWS IoT Data Plane","serviceId":"IoT Data Plane","signatureVersion":"v4","signingName":"iotdata"},"operations":{"DeleteThingShadow":{"http":{"method":"DELETE","requestUri":"/things/{thingName}/shadow"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"}}},"output":{"type":"structure","required":["payload"],"members":{"payload":{"type":"blob"}},"payload":"payload"}},"GetThingShadow":{"http":{"method":"GET","requestUri":"/things/{thingName}/shadow"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"}}},"output":{"type":"structure","members":{"payload":{"type":"blob"}},"payload":"payload"}},"Publish":{"http":{"requestUri":"/topics/{topic}"},"input":{"type":"structure","required":["topic"],"members":{"topic":{"location":"uri","locationName":"topic"},"qos":{"location":"querystring","locationName":"qos","type":"integer"},"payload":{"type":"blob"}},"payload":"payload"}},"UpdateThingShadow":{"http":{"requestUri":"/things/{thingName}/shadow"},"input":{"type":"structure","required":["thingName","payload"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"payload":{"type":"blob"}},"payload":"payload"},"output":{"type":"structure","members":{"payload":{"type":"blob"}},"payload":"payload"}}},"shapes":{}}');

});


parcelRequire.register("a1IK6", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $74ccb458575b3a0e$var$Service = $dbC7k.Service;
var $74ccb458575b3a0e$var$apiLoader = $dbC7k.apiLoader;
$74ccb458575b3a0e$var$apiLoader.services["kinesisanalytics"] = {};
$dbC7k.KinesisAnalytics = $74ccb458575b3a0e$var$Service.defineService("kinesisanalytics", [
    "2015-08-14"
]);


Object.defineProperty($74ccb458575b3a0e$var$apiLoader.services["kinesisanalytics"], "2015-08-14", {
    get: function get() {
        var model = (parcelRequire("4fxLV"));
        model.paginators = (parcelRequire("95dmW")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.KinesisAnalytics;

});
parcelRequire.register("4fxLV", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-08-14","endpointPrefix":"kinesisanalytics","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Kinesis Analytics","serviceFullName":"Amazon Kinesis Analytics","serviceId":"Kinesis Analytics","signatureVersion":"v4","targetPrefix":"KinesisAnalytics_20150814","uid":"kinesisanalytics-2015-08-14"},"operations":{"AddApplicationCloudWatchLoggingOption":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","CloudWatchLoggingOption"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"CloudWatchLoggingOption":{"shape":"S4"}}},"output":{"type":"structure","members":{}}},"AddApplicationInput":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","Input"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"Input":{"shape":"S9"}}},"output":{"type":"structure","members":{}}},"AddApplicationInputProcessingConfiguration":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","InputId","InputProcessingConfiguration"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"InputId":{},"InputProcessingConfiguration":{"shape":"Sb"}}},"output":{"type":"structure","members":{}}},"AddApplicationOutput":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","Output"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"Output":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"AddApplicationReferenceDataSource":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","ReferenceDataSource"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"ReferenceDataSource":{"type":"structure","required":["TableName","ReferenceSchema"],"members":{"TableName":{},"S3ReferenceDataSource":{"type":"structure","required":["BucketARN","FileKey","ReferenceRoleARN"],"members":{"BucketARN":{},"FileKey":{},"ReferenceRoleARN":{}}},"ReferenceSchema":{"shape":"Si"}}}}},"output":{"type":"structure","members":{}}},"CreateApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"ApplicationDescription":{},"Inputs":{"type":"list","member":{"shape":"S9"}},"Outputs":{"type":"list","member":{"shape":"S12"}},"CloudWatchLoggingOptions":{"type":"list","member":{"shape":"S4"}},"ApplicationCode":{},"Tags":{"shape":"S1l"}}},"output":{"type":"structure","required":["ApplicationSummary"],"members":{"ApplicationSummary":{"shape":"S1q"}}}},"DeleteApplication":{"input":{"type":"structure","required":["ApplicationName","CreateTimestamp"],"members":{"ApplicationName":{},"CreateTimestamp":{"type":"timestamp"}}},"output":{"type":"structure","members":{}}},"DeleteApplicationCloudWatchLoggingOption":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","CloudWatchLoggingOptionId"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"CloudWatchLoggingOptionId":{}}},"output":{"type":"structure","members":{}}},"DeleteApplicationInputProcessingConfiguration":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","InputId"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"InputId":{}}},"output":{"type":"structure","members":{}}},"DeleteApplicationOutput":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","OutputId"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"OutputId":{}}},"output":{"type":"structure","members":{}}},"DeleteApplicationReferenceDataSource":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","ReferenceId"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"ReferenceId":{}}},"output":{"type":"structure","members":{}}},"DescribeApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{}}},"output":{"type":"structure","required":["ApplicationDetail"],"members":{"ApplicationDetail":{"type":"structure","required":["ApplicationName","ApplicationARN","ApplicationStatus","ApplicationVersionId"],"members":{"ApplicationName":{},"ApplicationDescription":{},"ApplicationARN":{},"ApplicationStatus":{},"CreateTimestamp":{"type":"timestamp"},"LastUpdateTimestamp":{"type":"timestamp"},"InputDescriptions":{"type":"list","member":{"type":"structure","members":{"InputId":{},"NamePrefix":{},"InAppStreamNames":{"type":"list","member":{}},"InputProcessingConfigurationDescription":{"type":"structure","members":{"InputLambdaProcessorDescription":{"type":"structure","members":{"ResourceARN":{},"RoleARN":{}}}}},"KinesisStreamsInputDescription":{"type":"structure","members":{"ResourceARN":{},"RoleARN":{}}},"KinesisFirehoseInputDescription":{"type":"structure","members":{"ResourceARN":{},"RoleARN":{}}},"InputSchema":{"shape":"Si"},"InputParallelism":{"shape":"Sg"},"InputStartingPositionConfiguration":{"shape":"S2d"}}}},"OutputDescriptions":{"type":"list","member":{"type":"structure","members":{"OutputId":{},"Name":{},"KinesisStreamsOutputDescription":{"type":"structure","members":{"ResourceARN":{},"RoleARN":{}}},"KinesisFirehoseOutputDescription":{"type":"structure","members":{"ResourceARN":{},"RoleARN":{}}},"LambdaOutputDescription":{"type":"structure","members":{"ResourceARN":{},"RoleARN":{}}},"DestinationSchema":{"shape":"S16"}}}},"ReferenceDataSourceDescriptions":{"type":"list","member":{"type":"structure","required":["ReferenceId","TableName","S3ReferenceDataSourceDescription"],"members":{"ReferenceId":{},"TableName":{},"S3ReferenceDataSourceDescription":{"type":"structure","required":["BucketARN","FileKey","ReferenceRoleARN"],"members":{"BucketARN":{},"FileKey":{},"ReferenceRoleARN":{}}},"ReferenceSchema":{"shape":"Si"}}}},"CloudWatchLoggingOptionDescriptions":{"type":"list","member":{"type":"structure","required":["LogStreamARN","RoleARN"],"members":{"CloudWatchLoggingOptionId":{},"LogStreamARN":{},"RoleARN":{}}}},"ApplicationCode":{},"ApplicationVersionId":{"type":"long"}}}}}},"DiscoverInputSchema":{"input":{"type":"structure","members":{"ResourceARN":{},"RoleARN":{},"InputStartingPositionConfiguration":{"shape":"S2d"},"S3Configuration":{"type":"structure","required":["RoleARN","BucketARN","FileKey"],"members":{"RoleARN":{},"BucketARN":{},"FileKey":{}}},"InputProcessingConfiguration":{"shape":"Sb"}}},"output":{"type":"structure","members":{"InputSchema":{"shape":"Si"},"ParsedInputRecords":{"type":"list","member":{"type":"list","member":{}}},"ProcessedInputRecords":{"type":"list","member":{}},"RawInputRecords":{"type":"list","member":{}}}}},"ListApplications":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"ExclusiveStartApplicationName":{}}},"output":{"type":"structure","required":["ApplicationSummaries","HasMoreApplications"],"members":{"ApplicationSummaries":{"type":"list","member":{"shape":"S1q"}},"HasMoreApplications":{"type":"boolean"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S1l"}}}},"StartApplication":{"input":{"type":"structure","required":["ApplicationName","InputConfigurations"],"members":{"ApplicationName":{},"InputConfigurations":{"type":"list","member":{"type":"structure","required":["Id","InputStartingPositionConfiguration"],"members":{"Id":{},"InputStartingPositionConfiguration":{"shape":"S2d"}}}}}},"output":{"type":"structure","members":{}}},"StopApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S1l"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateApplication":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","ApplicationUpdate"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"ApplicationUpdate":{"type":"structure","members":{"InputUpdates":{"type":"list","member":{"type":"structure","required":["InputId"],"members":{"InputId":{},"NamePrefixUpdate":{},"InputProcessingConfigurationUpdate":{"type":"structure","required":["InputLambdaProcessorUpdate"],"members":{"InputLambdaProcessorUpdate":{"type":"structure","members":{"ResourceARNUpdate":{},"RoleARNUpdate":{}}}}},"KinesisStreamsInputUpdate":{"type":"structure","members":{"ResourceARNUpdate":{},"RoleARNUpdate":{}}},"KinesisFirehoseInputUpdate":{"type":"structure","members":{"ResourceARNUpdate":{},"RoleARNUpdate":{}}},"InputSchemaUpdate":{"type":"structure","members":{"RecordFormatUpdate":{"shape":"Sj"},"RecordEncodingUpdate":{},"RecordColumnUpdates":{"shape":"Ss"}}},"InputParallelismUpdate":{"type":"structure","members":{"CountUpdate":{"type":"integer"}}}}}},"ApplicationCodeUpdate":{},"OutputUpdates":{"type":"list","member":{"type":"structure","required":["OutputId"],"members":{"OutputId":{},"NameUpdate":{},"KinesisStreamsOutputUpdate":{"type":"structure","members":{"ResourceARNUpdate":{},"RoleARNUpdate":{}}},"KinesisFirehoseOutputUpdate":{"type":"structure","members":{"ResourceARNUpdate":{},"RoleARNUpdate":{}}},"LambdaOutputUpdate":{"type":"structure","members":{"ResourceARNUpdate":{},"RoleARNUpdate":{}}},"DestinationSchemaUpdate":{"shape":"S16"}}}},"ReferenceDataSourceUpdates":{"type":"list","member":{"type":"structure","required":["ReferenceId"],"members":{"ReferenceId":{},"TableNameUpdate":{},"S3ReferenceDataSourceUpdate":{"type":"structure","members":{"BucketARNUpdate":{},"FileKeyUpdate":{},"ReferenceRoleARNUpdate":{}}},"ReferenceSchemaUpdate":{"shape":"Si"}}}},"CloudWatchLoggingOptionUpdates":{"type":"list","member":{"type":"structure","required":["CloudWatchLoggingOptionId"],"members":{"CloudWatchLoggingOptionId":{},"LogStreamARNUpdate":{},"RoleARNUpdate":{}}}}}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S4":{"type":"structure","required":["LogStreamARN","RoleARN"],"members":{"LogStreamARN":{},"RoleARN":{}}},"S9":{"type":"structure","required":["NamePrefix","InputSchema"],"members":{"NamePrefix":{},"InputProcessingConfiguration":{"shape":"Sb"},"KinesisStreamsInput":{"type":"structure","required":["ResourceARN","RoleARN"],"members":{"ResourceARN":{},"RoleARN":{}}},"KinesisFirehoseInput":{"type":"structure","required":["ResourceARN","RoleARN"],"members":{"ResourceARN":{},"RoleARN":{}}},"InputParallelism":{"shape":"Sg"},"InputSchema":{"shape":"Si"}}},"Sb":{"type":"structure","required":["InputLambdaProcessor"],"members":{"InputLambdaProcessor":{"type":"structure","required":["ResourceARN","RoleARN"],"members":{"ResourceARN":{},"RoleARN":{}}}}},"Sg":{"type":"structure","members":{"Count":{"type":"integer"}}},"Si":{"type":"structure","required":["RecordFormat","RecordColumns"],"members":{"RecordFormat":{"shape":"Sj"},"RecordEncoding":{},"RecordColumns":{"shape":"Ss"}}},"Sj":{"type":"structure","required":["RecordFormatType"],"members":{"RecordFormatType":{},"MappingParameters":{"type":"structure","members":{"JSONMappingParameters":{"type":"structure","required":["RecordRowPath"],"members":{"RecordRowPath":{}}},"CSVMappingParameters":{"type":"structure","required":["RecordRowDelimiter","RecordColumnDelimiter"],"members":{"RecordRowDelimiter":{},"RecordColumnDelimiter":{}}}}}}},"Ss":{"type":"list","member":{"type":"structure","required":["Name","SqlType"],"members":{"Name":{},"Mapping":{},"SqlType":{}}}},"S12":{"type":"structure","required":["Name","DestinationSchema"],"members":{"Name":{},"KinesisStreamsOutput":{"type":"structure","required":["ResourceARN","RoleARN"],"members":{"ResourceARN":{},"RoleARN":{}}},"KinesisFirehoseOutput":{"type":"structure","required":["ResourceARN","RoleARN"],"members":{"ResourceARN":{},"RoleARN":{}}},"LambdaOutput":{"type":"structure","required":["ResourceARN","RoleARN"],"members":{"ResourceARN":{},"RoleARN":{}}},"DestinationSchema":{"shape":"S16"}}},"S16":{"type":"structure","required":["RecordFormatType"],"members":{"RecordFormatType":{}}},"S1l":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"S1q":{"type":"structure","required":["ApplicationName","ApplicationARN","ApplicationStatus"],"members":{"ApplicationName":{},"ApplicationARN":{},"ApplicationStatus":{}}},"S2d":{"type":"structure","members":{"InputStartingPosition":{}}}}}');

});

parcelRequire.register("95dmW", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("hhHeB", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $c9558fb0e7f07841$var$Service = $dbC7k.Service;
var $c9558fb0e7f07841$var$apiLoader = $dbC7k.apiLoader;
$c9558fb0e7f07841$var$apiLoader.services["kms"] = {};
$dbC7k.KMS = $c9558fb0e7f07841$var$Service.defineService("kms", [
    "2014-11-01"
]);


Object.defineProperty($c9558fb0e7f07841$var$apiLoader.services["kms"], "2014-11-01", {
    get: function get() {
        var model = (parcelRequire("bUIZ1"));
        model.paginators = (parcelRequire("gCTTY")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.KMS;

});
parcelRequire.register("bUIZ1", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2014-11-01","endpointPrefix":"kms","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"KMS","serviceFullName":"AWS Key Management Service","serviceId":"KMS","signatureVersion":"v4","targetPrefix":"TrentService","uid":"kms-2014-11-01"},"operations":{"CancelKeyDeletion":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}},"output":{"type":"structure","members":{"KeyId":{}}}},"ConnectCustomKeyStore":{"input":{"type":"structure","required":["CustomKeyStoreId"],"members":{"CustomKeyStoreId":{}}},"output":{"type":"structure","members":{}}},"CreateAlias":{"input":{"type":"structure","required":["AliasName","TargetKeyId"],"members":{"AliasName":{},"TargetKeyId":{}}}},"CreateCustomKeyStore":{"input":{"type":"structure","required":["CustomKeyStoreName","CloudHsmClusterId","TrustAnchorCertificate","KeyStorePassword"],"members":{"CustomKeyStoreName":{},"CloudHsmClusterId":{},"TrustAnchorCertificate":{},"KeyStorePassword":{"shape":"Sd"}}},"output":{"type":"structure","members":{"CustomKeyStoreId":{}}}},"CreateGrant":{"input":{"type":"structure","required":["KeyId","GranteePrincipal","Operations"],"members":{"KeyId":{},"GranteePrincipal":{},"RetiringPrincipal":{},"Operations":{"shape":"Sh"},"Constraints":{"shape":"Sj"},"GrantTokens":{"shape":"Sn"},"Name":{}}},"output":{"type":"structure","members":{"GrantToken":{},"GrantId":{}}}},"CreateKey":{"input":{"type":"structure","members":{"Policy":{},"Description":{},"KeyUsage":{},"Origin":{},"CustomKeyStoreId":{},"BypassPolicyLockoutSafetyCheck":{"type":"boolean"},"Tags":{"shape":"Sy"}}},"output":{"type":"structure","members":{"KeyMetadata":{"shape":"S13"}}}},"Decrypt":{"input":{"type":"structure","required":["CiphertextBlob"],"members":{"CiphertextBlob":{"type":"blob"},"EncryptionContext":{"shape":"Sk"},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"KeyId":{},"Plaintext":{"shape":"S1d"}}}},"DeleteAlias":{"input":{"type":"structure","required":["AliasName"],"members":{"AliasName":{}}}},"DeleteCustomKeyStore":{"input":{"type":"structure","required":["CustomKeyStoreId"],"members":{"CustomKeyStoreId":{}}},"output":{"type":"structure","members":{}}},"DeleteImportedKeyMaterial":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"DescribeCustomKeyStores":{"input":{"type":"structure","members":{"CustomKeyStoreId":{},"CustomKeyStoreName":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"CustomKeyStores":{"type":"list","member":{"type":"structure","members":{"CustomKeyStoreId":{},"CustomKeyStoreName":{},"CloudHsmClusterId":{},"TrustAnchorCertificate":{},"ConnectionState":{},"ConnectionErrorCode":{},"CreationDate":{"type":"timestamp"}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"DescribeKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"KeyMetadata":{"shape":"S13"}}}},"DisableKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"DisableKeyRotation":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"DisconnectCustomKeyStore":{"input":{"type":"structure","required":["CustomKeyStoreId"],"members":{"CustomKeyStoreId":{}}},"output":{"type":"structure","members":{}}},"EnableKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"EnableKeyRotation":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"Encrypt":{"input":{"type":"structure","required":["KeyId","Plaintext"],"members":{"KeyId":{},"Plaintext":{"shape":"S1d"},"EncryptionContext":{"shape":"Sk"},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"KeyId":{}}}},"GenerateDataKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"EncryptionContext":{"shape":"Sk"},"NumberOfBytes":{"type":"integer"},"KeySpec":{},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"Plaintext":{"shape":"S1d"},"KeyId":{}}}},"GenerateDataKeyWithoutPlaintext":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"EncryptionContext":{"shape":"Sk"},"KeySpec":{},"NumberOfBytes":{"type":"integer"},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"KeyId":{}}}},"GenerateRandom":{"input":{"type":"structure","members":{"NumberOfBytes":{"type":"integer"},"CustomKeyStoreId":{}}},"output":{"type":"structure","members":{"Plaintext":{"shape":"S1d"}}}},"GetKeyPolicy":{"input":{"type":"structure","required":["KeyId","PolicyName"],"members":{"KeyId":{},"PolicyName":{}}},"output":{"type":"structure","members":{"Policy":{}}}},"GetKeyRotationStatus":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}},"output":{"type":"structure","members":{"KeyRotationEnabled":{"type":"boolean"}}}},"GetParametersForImport":{"input":{"type":"structure","required":["KeyId","WrappingAlgorithm","WrappingKeySpec"],"members":{"KeyId":{},"WrappingAlgorithm":{},"WrappingKeySpec":{}}},"output":{"type":"structure","members":{"KeyId":{},"ImportToken":{"type":"blob"},"PublicKey":{"shape":"S1d"},"ParametersValidTo":{"type":"timestamp"}}}},"ImportKeyMaterial":{"input":{"type":"structure","required":["KeyId","ImportToken","EncryptedKeyMaterial"],"members":{"KeyId":{},"ImportToken":{"type":"blob"},"EncryptedKeyMaterial":{"type":"blob"},"ValidTo":{"type":"timestamp"},"ExpirationModel":{}}},"output":{"type":"structure","members":{}}},"ListAliases":{"input":{"type":"structure","members":{"KeyId":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Aliases":{"type":"list","member":{"type":"structure","members":{"AliasName":{},"AliasArn":{},"TargetKeyId":{}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListGrants":{"input":{"type":"structure","required":["KeyId"],"members":{"Limit":{"type":"integer"},"Marker":{},"KeyId":{}}},"output":{"shape":"S2o"}},"ListKeyPolicies":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"PolicyNames":{"type":"list","member":{}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListKeys":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Keys":{"type":"list","member":{"type":"structure","members":{"KeyId":{},"KeyArn":{}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListResourceTags":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sy"},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListRetirableGrants":{"input":{"type":"structure","required":["RetiringPrincipal"],"members":{"Limit":{"type":"integer"},"Marker":{},"RetiringPrincipal":{}}},"output":{"shape":"S2o"}},"PutKeyPolicy":{"input":{"type":"structure","required":["KeyId","PolicyName","Policy"],"members":{"KeyId":{},"PolicyName":{},"Policy":{},"BypassPolicyLockoutSafetyCheck":{"type":"boolean"}}}},"ReEncrypt":{"input":{"type":"structure","required":["CiphertextBlob","DestinationKeyId"],"members":{"CiphertextBlob":{"type":"blob"},"SourceEncryptionContext":{"shape":"Sk"},"DestinationKeyId":{},"DestinationEncryptionContext":{"shape":"Sk"},"GrantTokens":{"shape":"Sn"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"SourceKeyId":{},"KeyId":{}}}},"RetireGrant":{"input":{"type":"structure","members":{"GrantToken":{},"KeyId":{},"GrantId":{}}}},"RevokeGrant":{"input":{"type":"structure","required":["KeyId","GrantId"],"members":{"KeyId":{},"GrantId":{}}}},"ScheduleKeyDeletion":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"PendingWindowInDays":{"type":"integer"}}},"output":{"type":"structure","members":{"KeyId":{},"DeletionDate":{"type":"timestamp"}}}},"TagResource":{"input":{"type":"structure","required":["KeyId","Tags"],"members":{"KeyId":{},"Tags":{"shape":"Sy"}}}},"UntagResource":{"input":{"type":"structure","required":["KeyId","TagKeys"],"members":{"KeyId":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateAlias":{"input":{"type":"structure","required":["AliasName","TargetKeyId"],"members":{"AliasName":{},"TargetKeyId":{}}}},"UpdateCustomKeyStore":{"input":{"type":"structure","required":["CustomKeyStoreId"],"members":{"CustomKeyStoreId":{},"NewCustomKeyStoreName":{},"KeyStorePassword":{"shape":"Sd"},"CloudHsmClusterId":{}}},"output":{"type":"structure","members":{}}},"UpdateKeyDescription":{"input":{"type":"structure","required":["KeyId","Description"],"members":{"KeyId":{},"Description":{}}}}},"shapes":{"Sd":{"type":"string","sensitive":true},"Sh":{"type":"list","member":{}},"Sj":{"type":"structure","members":{"EncryptionContextSubset":{"shape":"Sk"},"EncryptionContextEquals":{"shape":"Sk"}}},"Sk":{"type":"map","key":{},"value":{}},"Sn":{"type":"list","member":{}},"Sy":{"type":"list","member":{"type":"structure","required":["TagKey","TagValue"],"members":{"TagKey":{},"TagValue":{}}}},"S13":{"type":"structure","required":["KeyId"],"members":{"AWSAccountId":{},"KeyId":{},"Arn":{},"CreationDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"Description":{},"KeyUsage":{},"KeyState":{},"DeletionDate":{"type":"timestamp"},"ValidTo":{"type":"timestamp"},"Origin":{},"CustomKeyStoreId":{},"CloudHsmClusterId":{},"ExpirationModel":{},"KeyManager":{}}},"S1d":{"type":"blob","sensitive":true},"S2o":{"type":"structure","members":{"Grants":{"type":"list","member":{"type":"structure","members":{"KeyId":{},"GrantId":{},"Name":{},"CreationDate":{"type":"timestamp"},"GranteePrincipal":{},"RetiringPrincipal":{},"IssuingAccount":{},"Operations":{"shape":"Sh"},"Constraints":{"shape":"Sj"}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}}}');

});

parcelRequire.register("gCTTY", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListAliases":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"Aliases"},"ListGrants":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"Grants"},"ListKeyPolicies":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"PolicyNames"},"ListKeys":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"Keys"}}}');

});


parcelRequire.register("gNGsW", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $c3b229c535ce984a$var$Service = $dbC7k.Service;
var $c3b229c535ce984a$var$apiLoader = $dbC7k.apiLoader;
$c3b229c535ce984a$var$apiLoader.services["lambda"] = {};
$dbC7k.Lambda = $c3b229c535ce984a$var$Service.defineService("lambda", [
    "2014-11-11",
    "2015-03-31"
]);
parcelRequire("imA6x");


Object.defineProperty($c3b229c535ce984a$var$apiLoader.services["lambda"], "2014-11-11", {
    get: function get() {
        var model = (parcelRequire("7cL6E"));
        model.paginators = (parcelRequire("j4n0X")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});



Object.defineProperty($c3b229c535ce984a$var$apiLoader.services["lambda"], "2015-03-31", {
    get: function get() {
        var model = (parcelRequire("dnTqX"));
        model.paginators = (parcelRequire("1wkiu")).pagination;
        model.waiters = (parcelRequire("k8TqW")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Lambda;

});
parcelRequire.register("imA6x", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
$dbC7k.util.update($dbC7k.Lambda.prototype, {
    /**
   * @api private
   */ setupRequestListeners: function setupRequestListeners(request) {
        if (request.operation === "invoke") request.addListener("extractData", $dbC7k.util.convertPayloadToString);
    }
});

});

parcelRequire.register("7cL6E", function(module, exports) {
module.exports = JSON.parse('{"metadata":{"apiVersion":"2014-11-11","endpointPrefix":"lambda","serviceFullName":"AWS Lambda","serviceId":"Lambda","signatureVersion":"v4","protocol":"rest-json"},"operations":{"AddEventSource":{"http":{"requestUri":"/2014-11-13/event-source-mappings/"},"input":{"type":"structure","required":["EventSource","FunctionName","Role"],"members":{"EventSource":{},"FunctionName":{},"Role":{},"BatchSize":{"type":"integer"},"Parameters":{"shape":"S6"}}},"output":{"shape":"S7"}},"DeleteFunction":{"http":{"method":"DELETE","requestUri":"/2014-11-13/functions/{FunctionName}","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}}},"GetEventSource":{"http":{"method":"GET","requestUri":"/2014-11-13/event-source-mappings/{UUID}","responseCode":200},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}},"output":{"shape":"S7"}},"GetFunction":{"http":{"method":"GET","requestUri":"/2014-11-13/functions/{FunctionName}","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}},"output":{"type":"structure","members":{"Configuration":{"shape":"Se"},"Code":{"type":"structure","members":{"RepositoryType":{},"Location":{}}}}}},"GetFunctionConfiguration":{"http":{"method":"GET","requestUri":"/2014-11-13/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}},"output":{"shape":"Se"}},"InvokeAsync":{"http":{"requestUri":"/2014-11-13/functions/{FunctionName}/invoke-async/","responseCode":202},"input":{"type":"structure","required":["FunctionName","InvokeArgs"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"InvokeArgs":{"shape":"Sq"}},"payload":"InvokeArgs"},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"}}}},"ListEventSources":{"http":{"method":"GET","requestUri":"/2014-11-13/event-source-mappings/","responseCode":200},"input":{"type":"structure","members":{"EventSourceArn":{"location":"querystring","locationName":"EventSource"},"FunctionName":{"location":"querystring","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"EventSources":{"type":"list","member":{"shape":"S7"}}}}},"ListFunctions":{"http":{"method":"GET","requestUri":"/2014-11-13/functions/","responseCode":200},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Functions":{"type":"list","member":{"shape":"Se"}}}}},"RemoveEventSource":{"http":{"method":"DELETE","requestUri":"/2014-11-13/event-source-mappings/{UUID}","responseCode":204},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}}},"UpdateFunctionConfiguration":{"http":{"method":"PUT","requestUri":"/2014-11-13/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Role":{"location":"querystring","locationName":"Role"},"Handler":{"location":"querystring","locationName":"Handler"},"Description":{"location":"querystring","locationName":"Description"},"Timeout":{"location":"querystring","locationName":"Timeout","type":"integer"},"MemorySize":{"location":"querystring","locationName":"MemorySize","type":"integer"}}},"output":{"shape":"Se"}},"UploadFunction":{"http":{"method":"PUT","requestUri":"/2014-11-13/functions/{FunctionName}","responseCode":201},"input":{"type":"structure","required":["FunctionName","FunctionZip","Runtime","Role","Handler","Mode"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"FunctionZip":{"shape":"Sq"},"Runtime":{"location":"querystring","locationName":"Runtime"},"Role":{"location":"querystring","locationName":"Role"},"Handler":{"location":"querystring","locationName":"Handler"},"Mode":{"location":"querystring","locationName":"Mode"},"Description":{"location":"querystring","locationName":"Description"},"Timeout":{"location":"querystring","locationName":"Timeout","type":"integer"},"MemorySize":{"location":"querystring","locationName":"MemorySize","type":"integer"}},"payload":"FunctionZip"},"output":{"shape":"Se"}}},"shapes":{"S6":{"type":"map","key":{},"value":{}},"S7":{"type":"structure","members":{"UUID":{},"BatchSize":{"type":"integer"},"EventSource":{},"FunctionName":{},"Parameters":{"shape":"S6"},"Role":{},"LastModified":{"type":"timestamp"},"IsActive":{"type":"boolean"},"Status":{}}},"Se":{"type":"structure","members":{"FunctionName":{},"FunctionARN":{},"ConfigurationId":{},"Runtime":{},"Role":{},"Handler":{},"Mode":{},"CodeSize":{"type":"long"},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"LastModified":{"type":"timestamp"}}},"Sq":{"type":"blob","streaming":true}}}');

});

parcelRequire.register("j4n0X", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListEventSources":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems","result_key":"EventSources"},"ListFunctions":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems","result_key":"Functions"}}}');

});

parcelRequire.register("dnTqX", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-03-31","endpointPrefix":"lambda","protocol":"rest-json","serviceFullName":"AWS Lambda","serviceId":"Lambda","signatureVersion":"v4","uid":"lambda-2015-03-31"},"operations":{"AddLayerVersionPermission":{"http":{"requestUri":"/2018-10-31/layers/{LayerName}/versions/{VersionNumber}/policy","responseCode":201},"input":{"type":"structure","required":["LayerName","VersionNumber","StatementId","Action","Principal"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"long"},"StatementId":{},"Action":{},"Principal":{},"OrganizationId":{},"RevisionId":{"location":"querystring","locationName":"RevisionId"}}},"output":{"type":"structure","members":{"Statement":{},"RevisionId":{}}}},"AddPermission":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/policy","responseCode":201},"input":{"type":"structure","required":["FunctionName","StatementId","Action","Principal"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"StatementId":{},"Action":{},"Principal":{},"SourceArn":{},"SourceAccount":{},"EventSourceToken":{},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"RevisionId":{}}},"output":{"type":"structure","members":{"Statement":{}}}},"CreateAlias":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/aliases","responseCode":201},"input":{"type":"structure","required":["FunctionName","Name","FunctionVersion"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{},"FunctionVersion":{},"Description":{},"RoutingConfig":{"shape":"Sn"}}},"output":{"shape":"Sr"}},"CreateEventSourceMapping":{"http":{"requestUri":"/2015-03-31/event-source-mappings/","responseCode":202},"input":{"type":"structure","required":["EventSourceArn","FunctionName"],"members":{"EventSourceArn":{},"FunctionName":{},"Enabled":{"type":"boolean"},"BatchSize":{"type":"integer"},"StartingPosition":{},"StartingPositionTimestamp":{"type":"timestamp"}}},"output":{"shape":"Sy"}},"CreateFunction":{"http":{"requestUri":"/2015-03-31/functions","responseCode":201},"input":{"type":"structure","required":["FunctionName","Runtime","Role","Handler","Code"],"members":{"FunctionName":{},"Runtime":{},"Role":{},"Handler":{},"Code":{"type":"structure","members":{"ZipFile":{"shape":"S14"},"S3Bucket":{},"S3Key":{},"S3ObjectVersion":{}}},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"Publish":{"type":"boolean"},"VpcConfig":{"shape":"S1b"},"DeadLetterConfig":{"shape":"S1g"},"Environment":{"shape":"S1i"},"KMSKeyArn":{},"TracingConfig":{"shape":"S1n"},"Tags":{"shape":"S1p"},"Layers":{"shape":"S1s"}}},"output":{"shape":"S1u"}},"DeleteAlias":{"http":{"method":"DELETE","requestUri":"/2015-03-31/functions/{FunctionName}/aliases/{Name}","responseCode":204},"input":{"type":"structure","required":["FunctionName","Name"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{"location":"uri","locationName":"Name"}}}},"DeleteEventSourceMapping":{"http":{"method":"DELETE","requestUri":"/2015-03-31/event-source-mappings/{UUID}","responseCode":202},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}},"output":{"shape":"Sy"}},"DeleteFunction":{"http":{"method":"DELETE","requestUri":"/2015-03-31/functions/{FunctionName}","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}}},"DeleteFunctionConcurrency":{"http":{"method":"DELETE","requestUri":"/2017-10-31/functions/{FunctionName}/concurrency","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}}},"DeleteLayerVersion":{"http":{"method":"DELETE","requestUri":"/2018-10-31/layers/{LayerName}/versions/{VersionNumber}","responseCode":204},"input":{"type":"structure","required":["LayerName","VersionNumber"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"long"}}}},"GetAccountSettings":{"http":{"method":"GET","requestUri":"/2016-08-19/account-settings/","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AccountLimit":{"type":"structure","members":{"TotalCodeSize":{"type":"long"},"CodeSizeUnzipped":{"type":"long"},"CodeSizeZipped":{"type":"long"},"ConcurrentExecutions":{"type":"integer"},"UnreservedConcurrentExecutions":{"type":"integer"}}},"AccountUsage":{"type":"structure","members":{"TotalCodeSize":{"type":"long"},"FunctionCount":{"type":"long"}}}}}},"GetAlias":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/aliases/{Name}","responseCode":200},"input":{"type":"structure","required":["FunctionName","Name"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{"location":"uri","locationName":"Name"}}},"output":{"shape":"Sr"}},"GetEventSourceMapping":{"http":{"method":"GET","requestUri":"/2015-03-31/event-source-mappings/{UUID}","responseCode":200},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}},"output":{"shape":"Sy"}},"GetFunction":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"type":"structure","members":{"Configuration":{"shape":"S1u"},"Code":{"type":"structure","members":{"RepositoryType":{},"Location":{}}},"Tags":{"shape":"S1p"},"Concurrency":{"shape":"S2n"}}}},"GetFunctionConfiguration":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"shape":"S1u"}},"GetLayerVersion":{"http":{"method":"GET","requestUri":"/2018-10-31/layers/{LayerName}/versions/{VersionNumber}","responseCode":200},"input":{"type":"structure","required":["LayerName","VersionNumber"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"long"}}},"output":{"shape":"S2r"}},"GetLayerVersionByArn":{"http":{"method":"GET","requestUri":"/2018-10-31/layers?find=LayerVersion","responseCode":200},"input":{"type":"structure","required":["Arn"],"members":{"Arn":{"location":"querystring","locationName":"Arn"}}},"output":{"shape":"S2r"}},"GetLayerVersionPolicy":{"http":{"method":"GET","requestUri":"/2018-10-31/layers/{LayerName}/versions/{VersionNumber}/policy","responseCode":200},"input":{"type":"structure","required":["LayerName","VersionNumber"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"long"}}},"output":{"type":"structure","members":{"Policy":{},"RevisionId":{}}}},"GetPolicy":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/policy","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"type":"structure","members":{"Policy":{},"RevisionId":{}}}},"Invoke":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/invocations"},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"InvocationType":{"location":"header","locationName":"X-Amz-Invocation-Type"},"LogType":{"location":"header","locationName":"X-Amz-Log-Type"},"ClientContext":{"location":"header","locationName":"X-Amz-Client-Context"},"Payload":{"shape":"S14"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}},"payload":"Payload"},"output":{"type":"structure","members":{"StatusCode":{"location":"statusCode","type":"integer"},"FunctionError":{"location":"header","locationName":"X-Amz-Function-Error"},"LogResult":{"location":"header","locationName":"X-Amz-Log-Result"},"Payload":{"shape":"S14"},"ExecutedVersion":{"location":"header","locationName":"X-Amz-Executed-Version"}},"payload":"Payload"}},"InvokeAsync":{"http":{"requestUri":"/2014-11-13/functions/{FunctionName}/invoke-async/","responseCode":202},"input":{"type":"structure","required":["FunctionName","InvokeArgs"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"InvokeArgs":{"type":"blob","streaming":true}},"deprecated":true,"payload":"InvokeArgs"},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"}},"deprecated":true},"deprecated":true},"ListAliases":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/aliases","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"FunctionVersion":{"location":"querystring","locationName":"FunctionVersion"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Aliases":{"type":"list","member":{"shape":"Sr"}}}}},"ListEventSourceMappings":{"http":{"method":"GET","requestUri":"/2015-03-31/event-source-mappings/","responseCode":200},"input":{"type":"structure","members":{"EventSourceArn":{"location":"querystring","locationName":"EventSourceArn"},"FunctionName":{"location":"querystring","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"EventSourceMappings":{"type":"list","member":{"shape":"Sy"}}}}},"ListFunctions":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/","responseCode":200},"input":{"type":"structure","members":{"MasterRegion":{"location":"querystring","locationName":"MasterRegion"},"FunctionVersion":{"location":"querystring","locationName":"FunctionVersion"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Functions":{"shape":"S3k"}}}},"ListLayerVersions":{"http":{"method":"GET","requestUri":"/2018-10-31/layers/{LayerName}/versions","responseCode":200},"input":{"type":"structure","required":["LayerName"],"members":{"CompatibleRuntime":{"location":"querystring","locationName":"CompatibleRuntime"},"LayerName":{"location":"uri","locationName":"LayerName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"LayerVersions":{"type":"list","member":{"shape":"S3p"}}}}},"ListLayers":{"http":{"method":"GET","requestUri":"/2018-10-31/layers","responseCode":200},"input":{"type":"structure","members":{"CompatibleRuntime":{"location":"querystring","locationName":"CompatibleRuntime"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Layers":{"type":"list","member":{"type":"structure","members":{"LayerName":{},"LayerArn":{},"LatestMatchingVersion":{"shape":"S3p"}}}}}}},"ListTags":{"http":{"method":"GET","requestUri":"/2017-03-31/tags/{ARN}"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"uri","locationName":"ARN"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S1p"}}}},"ListVersionsByFunction":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/versions","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Versions":{"shape":"S3k"}}}},"PublishLayerVersion":{"http":{"requestUri":"/2018-10-31/layers/{LayerName}/versions","responseCode":201},"input":{"type":"structure","required":["LayerName","Content"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"Description":{},"Content":{"type":"structure","members":{"S3Bucket":{},"S3Key":{},"S3ObjectVersion":{},"ZipFile":{"shape":"S14"}}},"CompatibleRuntimes":{"shape":"S2u"},"LicenseInfo":{}}},"output":{"type":"structure","members":{"Content":{"shape":"S2s"},"LayerArn":{},"LayerVersionArn":{},"Description":{},"CreatedDate":{},"Version":{"type":"long"},"CompatibleRuntimes":{"shape":"S2u"},"LicenseInfo":{}}}},"PublishVersion":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/versions","responseCode":201},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"CodeSha256":{},"Description":{},"RevisionId":{}}},"output":{"shape":"S1u"}},"PutFunctionConcurrency":{"http":{"method":"PUT","requestUri":"/2017-10-31/functions/{FunctionName}/concurrency","responseCode":200},"input":{"type":"structure","required":["FunctionName","ReservedConcurrentExecutions"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"ReservedConcurrentExecutions":{"type":"integer"}}},"output":{"shape":"S2n"}},"RemoveLayerVersionPermission":{"http":{"method":"DELETE","requestUri":"/2018-10-31/layers/{LayerName}/versions/{VersionNumber}/policy/{StatementId}","responseCode":204},"input":{"type":"structure","required":["LayerName","VersionNumber","StatementId"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"long"},"StatementId":{"location":"uri","locationName":"StatementId"},"RevisionId":{"location":"querystring","locationName":"RevisionId"}}}},"RemovePermission":{"http":{"method":"DELETE","requestUri":"/2015-03-31/functions/{FunctionName}/policy/{StatementId}","responseCode":204},"input":{"type":"structure","required":["FunctionName","StatementId"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"StatementId":{"location":"uri","locationName":"StatementId"},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"RevisionId":{"location":"querystring","locationName":"RevisionId"}}}},"TagResource":{"http":{"requestUri":"/2017-03-31/tags/{ARN}","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"uri","locationName":"ARN"},"Tags":{"shape":"S1p"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/2017-03-31/tags/{ARN}","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"uri","locationName":"ARN"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}}},"UpdateAlias":{"http":{"method":"PUT","requestUri":"/2015-03-31/functions/{FunctionName}/aliases/{Name}","responseCode":200},"input":{"type":"structure","required":["FunctionName","Name"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{"location":"uri","locationName":"Name"},"FunctionVersion":{},"Description":{},"RoutingConfig":{"shape":"Sn"},"RevisionId":{}}},"output":{"shape":"Sr"}},"UpdateEventSourceMapping":{"http":{"method":"PUT","requestUri":"/2015-03-31/event-source-mappings/{UUID}","responseCode":202},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"},"FunctionName":{},"Enabled":{"type":"boolean"},"BatchSize":{"type":"integer"}}},"output":{"shape":"Sy"}},"UpdateFunctionCode":{"http":{"method":"PUT","requestUri":"/2015-03-31/functions/{FunctionName}/code","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"ZipFile":{"shape":"S14"},"S3Bucket":{},"S3Key":{},"S3ObjectVersion":{},"Publish":{"type":"boolean"},"DryRun":{"type":"boolean"},"RevisionId":{}}},"output":{"shape":"S1u"}},"UpdateFunctionConfiguration":{"http":{"method":"PUT","requestUri":"/2015-03-31/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Role":{},"Handler":{},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"VpcConfig":{"shape":"S1b"},"Environment":{"shape":"S1i"},"Runtime":{},"DeadLetterConfig":{"shape":"S1g"},"KMSKeyArn":{},"TracingConfig":{"shape":"S1n"},"RevisionId":{},"Layers":{"shape":"S1s"}}},"output":{"shape":"S1u"}}},"shapes":{"Sn":{"type":"structure","members":{"AdditionalVersionWeights":{"type":"map","key":{},"value":{"type":"double"}}}},"Sr":{"type":"structure","members":{"AliasArn":{},"Name":{},"FunctionVersion":{},"Description":{},"RoutingConfig":{"shape":"Sn"},"RevisionId":{}}},"Sy":{"type":"structure","members":{"UUID":{},"BatchSize":{"type":"integer"},"EventSourceArn":{},"FunctionArn":{},"LastModified":{"type":"timestamp"},"LastProcessingResult":{},"State":{},"StateTransitionReason":{}}},"S14":{"type":"blob","sensitive":true},"S1b":{"type":"structure","members":{"SubnetIds":{"shape":"S1c"},"SecurityGroupIds":{"shape":"S1e"}}},"S1c":{"type":"list","member":{}},"S1e":{"type":"list","member":{}},"S1g":{"type":"structure","members":{"TargetArn":{}}},"S1i":{"type":"structure","members":{"Variables":{"shape":"S1j"}}},"S1j":{"type":"map","key":{"type":"string","sensitive":true},"value":{"type":"string","sensitive":true},"sensitive":true},"S1n":{"type":"structure","members":{"Mode":{}}},"S1p":{"type":"map","key":{},"value":{}},"S1s":{"type":"list","member":{}},"S1u":{"type":"structure","members":{"FunctionName":{},"FunctionArn":{},"Runtime":{},"Role":{},"Handler":{},"CodeSize":{"type":"long"},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"LastModified":{},"CodeSha256":{},"Version":{},"VpcConfig":{"type":"structure","members":{"SubnetIds":{"shape":"S1c"},"SecurityGroupIds":{"shape":"S1e"},"VpcId":{}}},"DeadLetterConfig":{"shape":"S1g"},"Environment":{"type":"structure","members":{"Variables":{"shape":"S1j"},"Error":{"type":"structure","members":{"ErrorCode":{},"Message":{"type":"string","sensitive":true}}}}},"KMSKeyArn":{},"TracingConfig":{"type":"structure","members":{"Mode":{}}},"MasterArn":{},"RevisionId":{},"Layers":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CodeSize":{"type":"long"}}}}}},"S2n":{"type":"structure","members":{"ReservedConcurrentExecutions":{"type":"integer"}}},"S2r":{"type":"structure","members":{"Content":{"shape":"S2s"},"LayerArn":{},"LayerVersionArn":{},"Description":{},"CreatedDate":{},"Version":{"type":"long"},"CompatibleRuntimes":{"shape":"S2u"},"LicenseInfo":{}}},"S2s":{"type":"structure","members":{"Location":{},"CodeSha256":{},"CodeSize":{"type":"long"}}},"S2u":{"type":"list","member":{}},"S3k":{"type":"list","member":{"shape":"S1u"}},"S3p":{"type":"structure","members":{"LayerVersionArn":{},"Version":{"type":"long"},"Description":{},"CreatedDate":{},"CompatibleRuntimes":{"shape":"S2u"},"LicenseInfo":{}}}}}');

});

parcelRequire.register("1wkiu", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListEventSourceMappings":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"EventSourceMappings"},"ListFunctions":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"Functions"}}}');

});

parcelRequire.register("k8TqW", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"FunctionExists":{"delay":1,"operation":"GetFunction","maxAttempts":20,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"ResourceNotFoundException"}]}}}');

});


parcelRequire.register("iEYIw", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $d95b0f9288fe406a$var$Service = $dbC7k.Service;
var $d95b0f9288fe406a$var$apiLoader = $dbC7k.apiLoader;
$d95b0f9288fe406a$var$apiLoader.services["lightsail"] = {};
$dbC7k.Lightsail = $d95b0f9288fe406a$var$Service.defineService("lightsail", [
    "2016-11-28"
]);


Object.defineProperty($d95b0f9288fe406a$var$apiLoader.services["lightsail"], "2016-11-28", {
    get: function get() {
        var model = (parcelRequire("dXPx6"));
        model.paginators = (parcelRequire("btm9w")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Lightsail;

});
parcelRequire.register("dXPx6", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-11-28","endpointPrefix":"lightsail","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Lightsail","serviceId":"Lightsail","signatureVersion":"v4","targetPrefix":"Lightsail_20161128","uid":"lightsail-2016-11-28"},"operations":{"AllocateStaticIp":{"input":{"type":"structure","required":["staticIpName"],"members":{"staticIpName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"AttachDisk":{"input":{"type":"structure","required":["diskName","instanceName","diskPath"],"members":{"diskName":{},"instanceName":{},"diskPath":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"AttachInstancesToLoadBalancer":{"input":{"type":"structure","required":["loadBalancerName","instanceNames"],"members":{"loadBalancerName":{},"instanceNames":{"shape":"Si"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"AttachLoadBalancerTlsCertificate":{"input":{"type":"structure","required":["loadBalancerName","certificateName"],"members":{"loadBalancerName":{},"certificateName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"AttachStaticIp":{"input":{"type":"structure","required":["staticIpName","instanceName"],"members":{"staticIpName":{},"instanceName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CloseInstancePublicPorts":{"input":{"type":"structure","required":["portInfo","instanceName"],"members":{"portInfo":{"shape":"Sp"},"instanceName":{}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"CopySnapshot":{"input":{"type":"structure","required":["sourceSnapshotName","targetSnapshotName","sourceRegion"],"members":{"sourceSnapshotName":{},"targetSnapshotName":{},"sourceRegion":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateCloudFormationStack":{"input":{"type":"structure","required":["instances"],"members":{"instances":{"type":"list","member":{"type":"structure","required":["sourceName","instanceType","portInfoSource","availabilityZone"],"members":{"sourceName":{},"instanceType":{},"portInfoSource":{},"userData":{},"availabilityZone":{}}}}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateDisk":{"input":{"type":"structure","required":["diskName","availabilityZone","sizeInGb"],"members":{"diskName":{},"availabilityZone":{},"sizeInGb":{"type":"integer"},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateDiskFromSnapshot":{"input":{"type":"structure","required":["diskName","diskSnapshotName","availabilityZone","sizeInGb"],"members":{"diskName":{},"diskSnapshotName":{},"availabilityZone":{},"sizeInGb":{"type":"integer"},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateDiskSnapshot":{"input":{"type":"structure","required":["diskSnapshotName"],"members":{"diskName":{},"diskSnapshotName":{},"instanceName":{},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateDomain":{"input":{"type":"structure","required":["domainName"],"members":{"domainName":{},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"CreateDomainEntry":{"input":{"type":"structure","required":["domainName","domainEntry"],"members":{"domainName":{},"domainEntry":{"shape":"S1f"}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"CreateInstanceSnapshot":{"input":{"type":"structure","required":["instanceSnapshotName","instanceName"],"members":{"instanceSnapshotName":{},"instanceName":{},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateInstances":{"input":{"type":"structure","required":["instanceNames","availabilityZone","blueprintId","bundleId"],"members":{"instanceNames":{"shape":"S1n"},"availabilityZone":{},"customImageName":{"deprecated":true},"blueprintId":{},"bundleId":{},"userData":{},"keyPairName":{},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateInstancesFromSnapshot":{"input":{"type":"structure","required":["instanceNames","availabilityZone","instanceSnapshotName","bundleId"],"members":{"instanceNames":{"shape":"S1n"},"attachedDiskMapping":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"originalDiskPath":{},"newDiskName":{}}}}},"availabilityZone":{},"instanceSnapshotName":{},"bundleId":{},"userData":{},"keyPairName":{},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateKeyPair":{"input":{"type":"structure","required":["keyPairName"],"members":{"keyPairName":{},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{"keyPair":{"shape":"S1w"},"publicKeyBase64":{},"privateKeyBase64":{},"operation":{"shape":"S5"}}}},"CreateLoadBalancer":{"input":{"type":"structure","required":["loadBalancerName","instancePort"],"members":{"loadBalancerName":{},"instancePort":{"type":"integer"},"healthCheckPath":{},"certificateName":{},"certificateDomainName":{},"certificateAlternativeNames":{"shape":"S1z"},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateLoadBalancerTlsCertificate":{"input":{"type":"structure","required":["loadBalancerName","certificateName","certificateDomainName"],"members":{"loadBalancerName":{},"certificateName":{},"certificateDomainName":{},"certificateAlternativeNames":{"shape":"S1z"},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateRelationalDatabase":{"input":{"type":"structure","required":["relationalDatabaseName","relationalDatabaseBlueprintId","relationalDatabaseBundleId","masterDatabaseName","masterUsername"],"members":{"relationalDatabaseName":{},"availabilityZone":{},"relationalDatabaseBlueprintId":{},"relationalDatabaseBundleId":{},"masterDatabaseName":{},"masterUsername":{},"masterUserPassword":{"shape":"S24"},"preferredBackupWindow":{},"preferredMaintenanceWindow":{},"publiclyAccessible":{"type":"boolean"},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateRelationalDatabaseFromSnapshot":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{},"availabilityZone":{},"publiclyAccessible":{"type":"boolean"},"relationalDatabaseSnapshotName":{},"relationalDatabaseBundleId":{},"sourceRelationalDatabaseName":{},"restoreTime":{"type":"timestamp"},"useLatestRestorableTime":{"type":"boolean"},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"CreateRelationalDatabaseSnapshot":{"input":{"type":"structure","required":["relationalDatabaseName","relationalDatabaseSnapshotName"],"members":{"relationalDatabaseName":{},"relationalDatabaseSnapshotName":{},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteDisk":{"input":{"type":"structure","required":["diskName"],"members":{"diskName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteDiskSnapshot":{"input":{"type":"structure","required":["diskSnapshotName"],"members":{"diskSnapshotName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteDomain":{"input":{"type":"structure","required":["domainName"],"members":{"domainName":{}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"DeleteDomainEntry":{"input":{"type":"structure","required":["domainName","domainEntry"],"members":{"domainName":{},"domainEntry":{"shape":"S1f"}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"DeleteInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteInstanceSnapshot":{"input":{"type":"structure","required":["instanceSnapshotName"],"members":{"instanceSnapshotName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteKeyPair":{"input":{"type":"structure","required":["keyPairName"],"members":{"keyPairName":{}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"DeleteKnownHostKeys":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteLoadBalancer":{"input":{"type":"structure","required":["loadBalancerName"],"members":{"loadBalancerName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteLoadBalancerTlsCertificate":{"input":{"type":"structure","required":["loadBalancerName","certificateName"],"members":{"loadBalancerName":{},"certificateName":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteRelationalDatabase":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{},"skipFinalSnapshot":{"type":"boolean"},"finalRelationalDatabaseSnapshotName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DeleteRelationalDatabaseSnapshot":{"input":{"type":"structure","required":["relationalDatabaseSnapshotName"],"members":{"relationalDatabaseSnapshotName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DetachDisk":{"input":{"type":"structure","required":["diskName"],"members":{"diskName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DetachInstancesFromLoadBalancer":{"input":{"type":"structure","required":["loadBalancerName","instanceNames"],"members":{"loadBalancerName":{},"instanceNames":{"shape":"Si"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DetachStaticIp":{"input":{"type":"structure","required":["staticIpName"],"members":{"staticIpName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"DownloadDefaultKeyPair":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"publicKeyBase64":{},"privateKeyBase64":{}}}},"ExportSnapshot":{"input":{"type":"structure","required":["sourceSnapshotName"],"members":{"sourceSnapshotName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"GetActiveNames":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"activeNames":{"shape":"S1n"},"nextPageToken":{}}}},"GetBlueprints":{"input":{"type":"structure","members":{"includeInactive":{"type":"boolean"},"pageToken":{}}},"output":{"type":"structure","members":{"blueprints":{"type":"list","member":{"type":"structure","members":{"blueprintId":{},"name":{},"group":{},"type":{},"description":{},"isActive":{"type":"boolean"},"minPower":{"type":"integer"},"version":{},"versionCode":{},"productUrl":{},"licenseUrl":{},"platform":{}}}},"nextPageToken":{}}}},"GetBundles":{"input":{"type":"structure","members":{"includeInactive":{"type":"boolean"},"pageToken":{}}},"output":{"type":"structure","members":{"bundles":{"type":"list","member":{"type":"structure","members":{"price":{"type":"float"},"cpuCount":{"type":"integer"},"diskSizeInGb":{"type":"integer"},"bundleId":{},"instanceType":{},"isActive":{"type":"boolean"},"name":{},"power":{"type":"integer"},"ramSizeInGb":{"type":"float"},"transferPerMonthInGb":{"type":"integer"},"supportedPlatforms":{"type":"list","member":{}}}}},"nextPageToken":{}}}},"GetCloudFormationStackRecords":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"cloudFormationStackRecords":{"type":"list","member":{"type":"structure","members":{"name":{},"arn":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"state":{},"sourceInfo":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"name":{},"arn":{}}}},"destinationInfo":{"shape":"S3u"}}}},"nextPageToken":{}}}},"GetDisk":{"input":{"type":"structure","required":["diskName"],"members":{"diskName":{}}},"output":{"type":"structure","members":{"disk":{"shape":"S3x"}}}},"GetDiskSnapshot":{"input":{"type":"structure","required":["diskSnapshotName"],"members":{"diskSnapshotName":{}}},"output":{"type":"structure","members":{"diskSnapshot":{"shape":"S41"}}}},"GetDiskSnapshots":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"diskSnapshots":{"type":"list","member":{"shape":"S41"}},"nextPageToken":{}}}},"GetDisks":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"disks":{"shape":"S48"},"nextPageToken":{}}}},"GetDomain":{"input":{"type":"structure","required":["domainName"],"members":{"domainName":{}}},"output":{"type":"structure","members":{"domain":{"shape":"S4b"}}}},"GetDomains":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"domains":{"type":"list","member":{"shape":"S4b"}},"nextPageToken":{}}}},"GetExportSnapshotRecords":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"exportSnapshotRecords":{"type":"list","member":{"type":"structure","members":{"name":{},"arn":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"state":{},"sourceInfo":{"type":"structure","members":{"resourceType":{},"createdAt":{"type":"timestamp"},"name":{},"arn":{},"fromResourceName":{},"fromResourceArn":{},"instanceSnapshotInfo":{"type":"structure","members":{"fromBundleId":{},"fromBlueprintId":{},"fromDiskInfo":{"type":"list","member":{"type":"structure","members":{"name":{},"path":{},"sizeInGb":{"type":"integer"},"isSystemDisk":{"type":"boolean"}}}}}},"diskSnapshotInfo":{"type":"structure","members":{"sizeInGb":{"type":"integer"}}}}},"destinationInfo":{"shape":"S3u"}}}},"nextPageToken":{}}}},"GetInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}},"output":{"type":"structure","members":{"instance":{"shape":"S4s"}}}},"GetInstanceAccessDetails":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{},"protocol":{}}},"output":{"type":"structure","members":{"accessDetails":{"type":"structure","members":{"certKey":{},"expiresAt":{"type":"timestamp"},"ipAddress":{},"password":{},"passwordData":{"type":"structure","members":{"ciphertext":{},"keyPairName":{}}},"privateKey":{},"protocol":{},"instanceName":{},"username":{},"hostKeys":{"type":"list","member":{"type":"structure","members":{"algorithm":{},"publicKey":{},"witnessedAt":{"type":"timestamp"},"fingerprintSHA1":{},"fingerprintSHA256":{},"notValidBefore":{"type":"timestamp"},"notValidAfter":{"type":"timestamp"}}}}}}}}},"GetInstanceMetricData":{"input":{"type":"structure","required":["instanceName","metricName","period","startTime","endTime","unit","statistics"],"members":{"instanceName":{},"metricName":{},"period":{"type":"integer"},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"unit":{},"statistics":{"shape":"S5f"}}},"output":{"type":"structure","members":{"metricName":{},"metricData":{"shape":"S5i"}}}},"GetInstancePortStates":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}},"output":{"type":"structure","members":{"portStates":{"type":"list","member":{"type":"structure","members":{"fromPort":{"type":"integer"},"toPort":{"type":"integer"},"protocol":{},"state":{}}}}}}},"GetInstanceSnapshot":{"input":{"type":"structure","required":["instanceSnapshotName"],"members":{"instanceSnapshotName":{}}},"output":{"type":"structure","members":{"instanceSnapshot":{"shape":"S5s"}}}},"GetInstanceSnapshots":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"instanceSnapshots":{"type":"list","member":{"shape":"S5s"}},"nextPageToken":{}}}},"GetInstanceState":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}},"output":{"type":"structure","members":{"state":{"shape":"S52"}}}},"GetInstances":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"instances":{"type":"list","member":{"shape":"S4s"}},"nextPageToken":{}}}},"GetKeyPair":{"input":{"type":"structure","required":["keyPairName"],"members":{"keyPairName":{}}},"output":{"type":"structure","members":{"keyPair":{"shape":"S1w"}}}},"GetKeyPairs":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"keyPairs":{"type":"list","member":{"shape":"S1w"}},"nextPageToken":{}}}},"GetLoadBalancer":{"input":{"type":"structure","required":["loadBalancerName"],"members":{"loadBalancerName":{}}},"output":{"type":"structure","members":{"loadBalancer":{"shape":"S69"}}}},"GetLoadBalancerMetricData":{"input":{"type":"structure","required":["loadBalancerName","metricName","period","startTime","endTime","unit","statistics"],"members":{"loadBalancerName":{},"metricName":{},"period":{"type":"integer"},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"unit":{},"statistics":{"shape":"S5f"}}},"output":{"type":"structure","members":{"metricName":{},"metricData":{"shape":"S5i"}}}},"GetLoadBalancerTlsCertificates":{"input":{"type":"structure","required":["loadBalancerName"],"members":{"loadBalancerName":{}}},"output":{"type":"structure","members":{"tlsCertificates":{"type":"list","member":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"tags":{"shape":"S12"},"loadBalancerName":{},"isAttached":{"type":"boolean"},"status":{},"domainName":{},"domainValidationRecords":{"type":"list","member":{"type":"structure","members":{"name":{},"type":{},"value":{},"validationStatus":{},"domainName":{}}}},"failureReason":{},"issuedAt":{"type":"timestamp"},"issuer":{},"keyAlgorithm":{},"notAfter":{"type":"timestamp"},"notBefore":{"type":"timestamp"},"renewalSummary":{"type":"structure","members":{"renewalStatus":{},"domainValidationOptions":{"type":"list","member":{"type":"structure","members":{"domainName":{},"validationStatus":{}}}}}},"revocationReason":{},"revokedAt":{"type":"timestamp"},"serial":{},"signatureAlgorithm":{},"subject":{},"subjectAlternativeNames":{"shape":"S1n"}}}}}}},"GetLoadBalancers":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"loadBalancers":{"type":"list","member":{"shape":"S69"}},"nextPageToken":{}}}},"GetOperation":{"input":{"type":"structure","required":["operationId"],"members":{"operationId":{}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"GetOperations":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"},"nextPageToken":{}}}},"GetOperationsForResource":{"input":{"type":"structure","required":["resourceName"],"members":{"resourceName":{},"pageToken":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"},"nextPageCount":{"deprecated":true},"nextPageToken":{}}}},"GetRegions":{"input":{"type":"structure","members":{"includeAvailabilityZones":{"type":"boolean"},"includeRelationalDatabaseAvailabilityZones":{"type":"boolean"}}},"output":{"type":"structure","members":{"regions":{"type":"list","member":{"type":"structure","members":{"continentCode":{},"description":{},"displayName":{},"name":{},"availabilityZones":{"shape":"S7f"},"relationalDatabaseAvailabilityZones":{"shape":"S7f"}}}}}}},"GetRelationalDatabase":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{}}},"output":{"type":"structure","members":{"relationalDatabase":{"shape":"S7j"}}}},"GetRelationalDatabaseBlueprints":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"blueprints":{"type":"list","member":{"type":"structure","members":{"blueprintId":{},"engine":{},"engineVersion":{},"engineDescription":{},"engineVersionDescription":{},"isEngineDefault":{"type":"boolean"}}}},"nextPageToken":{}}}},"GetRelationalDatabaseBundles":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"bundles":{"type":"list","member":{"type":"structure","members":{"bundleId":{},"name":{},"price":{"type":"float"},"ramSizeInGb":{"type":"float"},"diskSizeInGb":{"type":"integer"},"transferPerMonthInGb":{"type":"integer"},"cpuCount":{"type":"integer"},"isEncrypted":{"type":"boolean"},"isActive":{"type":"boolean"}}}},"nextPageToken":{}}}},"GetRelationalDatabaseEvents":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{},"durationInMinutes":{"type":"integer"},"pageToken":{}}},"output":{"type":"structure","members":{"relationalDatabaseEvents":{"type":"list","member":{"type":"structure","members":{"resource":{},"createdAt":{"type":"timestamp"},"message":{},"eventCategories":{"shape":"S1n"}}}},"nextPageToken":{}}}},"GetRelationalDatabaseLogEvents":{"input":{"type":"structure","required":["relationalDatabaseName","logStreamName"],"members":{"relationalDatabaseName":{},"logStreamName":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"startFromHead":{"type":"boolean"},"pageToken":{}}},"output":{"type":"structure","members":{"resourceLogEvents":{"type":"list","member":{"type":"structure","members":{"createdAt":{"type":"timestamp"},"message":{}}}},"nextBackwardToken":{},"nextForwardToken":{}}}},"GetRelationalDatabaseLogStreams":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{}}},"output":{"type":"structure","members":{"logStreams":{"shape":"S1n"}}}},"GetRelationalDatabaseMasterUserPassword":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{},"passwordVersion":{}}},"output":{"type":"structure","members":{"masterUserPassword":{"shape":"S24"},"createdAt":{"type":"timestamp"}}}},"GetRelationalDatabaseMetricData":{"input":{"type":"structure","required":["relationalDatabaseName","metricName","period","startTime","endTime","unit","statistics"],"members":{"relationalDatabaseName":{},"metricName":{},"period":{"type":"integer"},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"unit":{},"statistics":{"shape":"S5f"}}},"output":{"type":"structure","members":{"metricName":{},"metricData":{"shape":"S5i"}}}},"GetRelationalDatabaseParameters":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{},"pageToken":{}}},"output":{"type":"structure","members":{"parameters":{"shape":"S8g"},"nextPageToken":{}}}},"GetRelationalDatabaseSnapshot":{"input":{"type":"structure","required":["relationalDatabaseSnapshotName"],"members":{"relationalDatabaseSnapshotName":{}}},"output":{"type":"structure","members":{"relationalDatabaseSnapshot":{"shape":"S8k"}}}},"GetRelationalDatabaseSnapshots":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"relationalDatabaseSnapshots":{"type":"list","member":{"shape":"S8k"}},"nextPageToken":{}}}},"GetRelationalDatabases":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"relationalDatabases":{"type":"list","member":{"shape":"S7j"}},"nextPageToken":{}}}},"GetStaticIp":{"input":{"type":"structure","required":["staticIpName"],"members":{"staticIpName":{}}},"output":{"type":"structure","members":{"staticIp":{"shape":"S8t"}}}},"GetStaticIps":{"input":{"type":"structure","members":{"pageToken":{}}},"output":{"type":"structure","members":{"staticIps":{"type":"list","member":{"shape":"S8t"}},"nextPageToken":{}}}},"ImportKeyPair":{"input":{"type":"structure","required":["keyPairName","publicKeyBase64"],"members":{"keyPairName":{},"publicKeyBase64":{}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"IsVpcPeered":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"isPeered":{"type":"boolean"}}}},"OpenInstancePublicPorts":{"input":{"type":"structure","required":["portInfo","instanceName"],"members":{"portInfo":{"shape":"Sp"},"instanceName":{}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"PeerVpc":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"PutInstancePublicPorts":{"input":{"type":"structure","required":["portInfos","instanceName"],"members":{"portInfos":{"type":"list","member":{"shape":"Sp"}},"instanceName":{}}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"RebootInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"RebootRelationalDatabase":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"ReleaseStaticIp":{"input":{"type":"structure","required":["staticIpName"],"members":{"staticIpName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"StartInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"StartRelationalDatabase":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"StopInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"StopRelationalDatabase":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{},"relationalDatabaseSnapshotName":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"TagResource":{"input":{"type":"structure","required":["resourceName","tags"],"members":{"resourceName":{},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"UnpeerVpc":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"operation":{"shape":"S5"}}}},"UntagResource":{"input":{"type":"structure","required":["resourceName","tagKeys"],"members":{"resourceName":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"UpdateDomainEntry":{"input":{"type":"structure","required":["domainName","domainEntry"],"members":{"domainName":{},"domainEntry":{"shape":"S1f"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"UpdateLoadBalancerAttribute":{"input":{"type":"structure","required":["loadBalancerName","attributeName","attributeValue"],"members":{"loadBalancerName":{},"attributeName":{},"attributeValue":{}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"UpdateRelationalDatabase":{"input":{"type":"structure","required":["relationalDatabaseName"],"members":{"relationalDatabaseName":{},"masterUserPassword":{"shape":"S24"},"rotateMasterUserPassword":{"type":"boolean"},"preferredBackupWindow":{},"preferredMaintenanceWindow":{},"enableBackupRetention":{"type":"boolean"},"disableBackupRetention":{"type":"boolean"},"publiclyAccessible":{"type":"boolean"},"applyImmediately":{"type":"boolean"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}},"UpdateRelationalDatabaseParameters":{"input":{"type":"structure","required":["relationalDatabaseName","parameters"],"members":{"relationalDatabaseName":{},"parameters":{"shape":"S8g"}}},"output":{"type":"structure","members":{"operations":{"shape":"S4"}}}}},"shapes":{"S4":{"type":"list","member":{"shape":"S5"}},"S5":{"type":"structure","members":{"id":{},"resourceName":{},"resourceType":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"isTerminal":{"type":"boolean"},"operationDetails":{},"operationType":{},"status":{},"statusChangedAt":{"type":"timestamp"},"errorCode":{},"errorDetails":{}}},"S9":{"type":"structure","members":{"availabilityZone":{},"regionName":{}}},"Si":{"type":"list","member":{}},"Sp":{"type":"structure","members":{"fromPort":{"type":"integer"},"toPort":{"type":"integer"},"protocol":{}}},"S12":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}}},"S1f":{"type":"structure","members":{"id":{},"name":{},"target":{},"isAlias":{"type":"boolean"},"type":{},"options":{"deprecated":true,"type":"map","key":{},"value":{}}}},"S1n":{"type":"list","member":{}},"S1w":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"tags":{"shape":"S12"},"fingerprint":{}}},"S1z":{"type":"list","member":{}},"S24":{"type":"string","sensitive":true},"S3u":{"type":"structure","members":{"id":{},"service":{}}},"S3x":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"tags":{"shape":"S12"},"sizeInGb":{"type":"integer"},"isSystemDisk":{"type":"boolean"},"iops":{"type":"integer"},"path":{},"state":{},"attachedTo":{},"isAttached":{"type":"boolean"},"attachmentState":{"deprecated":true},"gbInUse":{"deprecated":true,"type":"integer"}}},"S41":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"tags":{"shape":"S12"},"sizeInGb":{"type":"integer"},"state":{},"progress":{},"fromDiskName":{},"fromDiskArn":{},"fromInstanceName":{},"fromInstanceArn":{}}},"S48":{"type":"list","member":{"shape":"S3x"}},"S4b":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"tags":{"shape":"S12"},"domainEntries":{"type":"list","member":{"shape":"S1f"}}}},"S4s":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"tags":{"shape":"S12"},"blueprintId":{},"blueprintName":{},"bundleId":{},"isStaticIp":{"type":"boolean"},"privateIpAddress":{},"publicIpAddress":{},"ipv6Address":{},"hardware":{"type":"structure","members":{"cpuCount":{"type":"integer"},"disks":{"shape":"S48"},"ramSizeInGb":{"type":"float"}}},"networking":{"type":"structure","members":{"monthlyTransfer":{"type":"structure","members":{"gbPerMonthAllocated":{"type":"integer"}}},"ports":{"type":"list","member":{"type":"structure","members":{"fromPort":{"type":"integer"},"toPort":{"type":"integer"},"protocol":{},"accessFrom":{},"accessType":{},"commonName":{},"accessDirection":{}}}}}},"state":{"shape":"S52"},"username":{},"sshKeyName":{}}},"S52":{"type":"structure","members":{"code":{"type":"integer"},"name":{}}},"S5f":{"type":"list","member":{}},"S5i":{"type":"list","member":{"type":"structure","members":{"average":{"type":"double"},"maximum":{"type":"double"},"minimum":{"type":"double"},"sampleCount":{"type":"double"},"sum":{"type":"double"},"timestamp":{"type":"timestamp"},"unit":{}}}},"S5s":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"tags":{"shape":"S12"},"state":{},"progress":{},"fromAttachedDisks":{"shape":"S48"},"fromInstanceName":{},"fromInstanceArn":{},"fromBlueprintId":{},"fromBundleId":{},"sizeInGb":{"type":"integer"}}},"S69":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"tags":{"shape":"S12"},"dnsName":{},"state":{},"protocol":{},"publicPorts":{"type":"list","member":{"type":"integer"}},"healthCheckPath":{},"instancePort":{"type":"integer"},"instanceHealthSummary":{"type":"list","member":{"type":"structure","members":{"instanceName":{},"instanceHealth":{},"instanceHealthReason":{}}}},"tlsCertificateSummaries":{"type":"list","member":{"type":"structure","members":{"name":{},"isAttached":{"type":"boolean"}}}},"configurationOptions":{"type":"map","key":{},"value":{}}}},"S7f":{"type":"list","member":{"type":"structure","members":{"zoneName":{},"state":{}}}},"S7j":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"tags":{"shape":"S12"},"relationalDatabaseBlueprintId":{},"relationalDatabaseBundleId":{},"masterDatabaseName":{},"hardware":{"type":"structure","members":{"cpuCount":{"type":"integer"},"diskSizeInGb":{"type":"integer"},"ramSizeInGb":{"type":"float"}}},"state":{},"secondaryAvailabilityZone":{},"backupRetentionEnabled":{"type":"boolean"},"pendingModifiedValues":{"type":"structure","members":{"masterUserPassword":{},"engineVersion":{},"backupRetentionEnabled":{"type":"boolean"}}},"engine":{},"engineVersion":{},"latestRestorableTime":{"type":"timestamp"},"masterUsername":{},"parameterApplyStatus":{},"preferredBackupWindow":{},"preferredMaintenanceWindow":{},"publiclyAccessible":{"type":"boolean"},"masterEndpoint":{"type":"structure","members":{"port":{"type":"integer"},"address":{}}},"pendingMaintenanceActions":{"type":"list","member":{"type":"structure","members":{"action":{},"description":{},"currentApplyDate":{"type":"timestamp"}}}}}},"S8g":{"type":"list","member":{"type":"structure","members":{"allowedValues":{},"applyMethod":{},"applyType":{},"dataType":{},"description":{},"isModifiable":{"type":"boolean"},"parameterName":{},"parameterValue":{}}}},"S8k":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"tags":{"shape":"S12"},"engine":{},"engineVersion":{},"sizeInGb":{"type":"integer"},"state":{},"fromRelationalDatabaseName":{},"fromRelationalDatabaseArn":{},"fromRelationalDatabaseBundleId":{},"fromRelationalDatabaseBlueprintId":{}}},"S8t":{"type":"structure","members":{"name":{},"arn":{},"supportCode":{},"createdAt":{"type":"timestamp"},"location":{"shape":"S9"},"resourceType":{},"ipAddress":{},"attachedTo":{},"isAttached":{"type":"boolean"}}}}}');

});

parcelRequire.register("btm9w", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("jdatw", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $dfc75b5ad0d71807$var$Service = $dbC7k.Service;
var $dfc75b5ad0d71807$var$apiLoader = $dbC7k.apiLoader;
$dfc75b5ad0d71807$var$apiLoader.services["machinelearning"] = {};
$dbC7k.MachineLearning = $dfc75b5ad0d71807$var$Service.defineService("machinelearning", [
    "2014-12-12"
]);
parcelRequire("j9D9g");



Object.defineProperty($dfc75b5ad0d71807$var$apiLoader.services["machinelearning"], "2014-12-12", {
    get: function get() {
        var model = (parcelRequire("kLVw3"));
        model.paginators = (parcelRequire("k7GIu")).pagination;
        model.waiters = (parcelRequire("dllSk")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.MachineLearning;

});
parcelRequire.register("j9D9g", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
$dbC7k.util.update($dbC7k.MachineLearning.prototype, {
    /**
   * @api private
   */ setupRequestListeners: function setupRequestListeners(request) {
        if (request.operation === "predict") request.addListener("build", this.buildEndpoint);
    },
    /**
   * Updates request endpoint from PredictEndpoint
   * @api private
   */ buildEndpoint: function buildEndpoint(request) {
        var url = request.params.PredictEndpoint;
        if (url) request.httpRequest.endpoint = new $dbC7k.Endpoint(url);
    }
});

});

parcelRequire.register("kLVw3", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"uid":"machinelearning-2014-12-12","apiVersion":"2014-12-12","endpointPrefix":"machinelearning","jsonVersion":"1.1","serviceFullName":"Amazon Machine Learning","serviceId":"Machine Learning","signatureVersion":"v4","targetPrefix":"AmazonML_20141212","protocol":"json"},"operations":{"AddTags":{"input":{"type":"structure","required":["Tags","ResourceId","ResourceType"],"members":{"Tags":{"shape":"S2"},"ResourceId":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ResourceId":{},"ResourceType":{}}}},"CreateBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId","MLModelId","BatchPredictionDataSourceId","OutputUri"],"members":{"BatchPredictionId":{},"BatchPredictionName":{},"MLModelId":{},"BatchPredictionDataSourceId":{},"OutputUri":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{}}}},"CreateDataSourceFromRDS":{"input":{"type":"structure","required":["DataSourceId","RDSData","RoleARN"],"members":{"DataSourceId":{},"DataSourceName":{},"RDSData":{"type":"structure","required":["DatabaseInformation","SelectSqlQuery","DatabaseCredentials","S3StagingLocation","ResourceRole","ServiceRole","SubnetId","SecurityGroupIds"],"members":{"DatabaseInformation":{"shape":"Sf"},"SelectSqlQuery":{},"DatabaseCredentials":{"type":"structure","required":["Username","Password"],"members":{"Username":{},"Password":{}}},"S3StagingLocation":{},"DataRearrangement":{},"DataSchema":{},"DataSchemaUri":{},"ResourceRole":{},"ServiceRole":{},"SubnetId":{},"SecurityGroupIds":{"type":"list","member":{}}}},"RoleARN":{},"ComputeStatistics":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"CreateDataSourceFromRedshift":{"input":{"type":"structure","required":["DataSourceId","DataSpec","RoleARN"],"members":{"DataSourceId":{},"DataSourceName":{},"DataSpec":{"type":"structure","required":["DatabaseInformation","SelectSqlQuery","DatabaseCredentials","S3StagingLocation"],"members":{"DatabaseInformation":{"shape":"Sy"},"SelectSqlQuery":{},"DatabaseCredentials":{"type":"structure","required":["Username","Password"],"members":{"Username":{},"Password":{}}},"S3StagingLocation":{},"DataRearrangement":{},"DataSchema":{},"DataSchemaUri":{}}},"RoleARN":{},"ComputeStatistics":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"CreateDataSourceFromS3":{"input":{"type":"structure","required":["DataSourceId","DataSpec"],"members":{"DataSourceId":{},"DataSourceName":{},"DataSpec":{"type":"structure","required":["DataLocationS3"],"members":{"DataLocationS3":{},"DataRearrangement":{},"DataSchema":{},"DataSchemaLocationS3":{}}},"ComputeStatistics":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"CreateEvaluation":{"input":{"type":"structure","required":["EvaluationId","MLModelId","EvaluationDataSourceId"],"members":{"EvaluationId":{},"EvaluationName":{},"MLModelId":{},"EvaluationDataSourceId":{}}},"output":{"type":"structure","members":{"EvaluationId":{}}}},"CreateMLModel":{"input":{"type":"structure","required":["MLModelId","MLModelType","TrainingDataSourceId"],"members":{"MLModelId":{},"MLModelName":{},"MLModelType":{},"Parameters":{"shape":"S1d"},"TrainingDataSourceId":{},"Recipe":{},"RecipeUri":{}}},"output":{"type":"structure","members":{"MLModelId":{}}}},"CreateRealtimeEndpoint":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{}}},"output":{"type":"structure","members":{"MLModelId":{},"RealtimeEndpointInfo":{"shape":"S1j"}}}},"DeleteBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId"],"members":{"BatchPredictionId":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{}}}},"DeleteDataSource":{"input":{"type":"structure","required":["DataSourceId"],"members":{"DataSourceId":{}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"DeleteEvaluation":{"input":{"type":"structure","required":["EvaluationId"],"members":{"EvaluationId":{}}},"output":{"type":"structure","members":{"EvaluationId":{}}}},"DeleteMLModel":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{}}},"output":{"type":"structure","members":{"MLModelId":{}}}},"DeleteRealtimeEndpoint":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{}}},"output":{"type":"structure","members":{"MLModelId":{},"RealtimeEndpointInfo":{"shape":"S1j"}}}},"DeleteTags":{"input":{"type":"structure","required":["TagKeys","ResourceId","ResourceType"],"members":{"TagKeys":{"type":"list","member":{}},"ResourceId":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ResourceId":{},"ResourceType":{}}}},"DescribeBatchPredictions":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"BatchPredictionId":{},"MLModelId":{},"BatchPredictionDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"OutputUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"TotalRecordCount":{"type":"long"},"InvalidRecordCount":{"type":"long"}}}},"NextToken":{}}}},"DescribeDataSources":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"DataSourceId":{},"DataLocationS3":{},"DataRearrangement":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"DataSizeInBytes":{"type":"long"},"NumberOfFiles":{"type":"long"},"Name":{},"Status":{},"Message":{},"RedshiftMetadata":{"shape":"S2i"},"RDSMetadata":{"shape":"S2j"},"RoleARN":{},"ComputeStatistics":{"type":"boolean"},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeEvaluations":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"EvaluationId":{},"MLModelId":{},"EvaluationDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"PerformanceMetrics":{"shape":"S2q"},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMLModels":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"MLModelId":{},"TrainingDataSourceId":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"SizeInBytes":{"type":"long"},"EndpointInfo":{"shape":"S1j"},"TrainingParameters":{"shape":"S1d"},"InputDataLocationS3":{},"Algorithm":{},"MLModelType":{},"ScoreThreshold":{"type":"float"},"ScoreThresholdLastUpdatedAt":{"type":"timestamp"},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeTags":{"input":{"type":"structure","required":["ResourceId","ResourceType"],"members":{"ResourceId":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ResourceId":{},"ResourceType":{},"Tags":{"shape":"S2"}}}},"GetBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId"],"members":{"BatchPredictionId":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{},"MLModelId":{},"BatchPredictionDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"OutputUri":{},"LogUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"TotalRecordCount":{"type":"long"},"InvalidRecordCount":{"type":"long"}}}},"GetDataSource":{"input":{"type":"structure","required":["DataSourceId"],"members":{"DataSourceId":{},"Verbose":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{},"DataLocationS3":{},"DataRearrangement":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"DataSizeInBytes":{"type":"long"},"NumberOfFiles":{"type":"long"},"Name":{},"Status":{},"LogUri":{},"Message":{},"RedshiftMetadata":{"shape":"S2i"},"RDSMetadata":{"shape":"S2j"},"RoleARN":{},"ComputeStatistics":{"type":"boolean"},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"DataSourceSchema":{}}}},"GetEvaluation":{"input":{"type":"structure","required":["EvaluationId"],"members":{"EvaluationId":{}}},"output":{"type":"structure","members":{"EvaluationId":{},"MLModelId":{},"EvaluationDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"PerformanceMetrics":{"shape":"S2q"},"LogUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"GetMLModel":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{},"Verbose":{"type":"boolean"}}},"output":{"type":"structure","members":{"MLModelId":{},"TrainingDataSourceId":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"SizeInBytes":{"type":"long"},"EndpointInfo":{"shape":"S1j"},"TrainingParameters":{"shape":"S1d"},"InputDataLocationS3":{},"MLModelType":{},"ScoreThreshold":{"type":"float"},"ScoreThresholdLastUpdatedAt":{"type":"timestamp"},"LogUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"Recipe":{},"Schema":{}}}},"Predict":{"input":{"type":"structure","required":["MLModelId","Record","PredictEndpoint"],"members":{"MLModelId":{},"Record":{"type":"map","key":{},"value":{}},"PredictEndpoint":{}}},"output":{"type":"structure","members":{"Prediction":{"type":"structure","members":{"predictedLabel":{},"predictedValue":{"type":"float"},"predictedScores":{"type":"map","key":{},"value":{"type":"float"}},"details":{"type":"map","key":{},"value":{}}}}}}},"UpdateBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId","BatchPredictionName"],"members":{"BatchPredictionId":{},"BatchPredictionName":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{}}}},"UpdateDataSource":{"input":{"type":"structure","required":["DataSourceId","DataSourceName"],"members":{"DataSourceId":{},"DataSourceName":{}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"UpdateEvaluation":{"input":{"type":"structure","required":["EvaluationId","EvaluationName"],"members":{"EvaluationId":{},"EvaluationName":{}}},"output":{"type":"structure","members":{"EvaluationId":{}}}},"UpdateMLModel":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{},"MLModelName":{},"ScoreThreshold":{"type":"float"}}},"output":{"type":"structure","members":{"MLModelId":{}}}}},"shapes":{"S2":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Sf":{"type":"structure","required":["InstanceIdentifier","DatabaseName"],"members":{"InstanceIdentifier":{},"DatabaseName":{}}},"Sy":{"type":"structure","required":["DatabaseName","ClusterIdentifier"],"members":{"DatabaseName":{},"ClusterIdentifier":{}}},"S1d":{"type":"map","key":{},"value":{}},"S1j":{"type":"structure","members":{"PeakRequestsPerSecond":{"type":"integer"},"CreatedAt":{"type":"timestamp"},"EndpointUrl":{},"EndpointStatus":{}}},"S2i":{"type":"structure","members":{"RedshiftDatabase":{"shape":"Sy"},"DatabaseUserName":{},"SelectSqlQuery":{}}},"S2j":{"type":"structure","members":{"Database":{"shape":"Sf"},"DatabaseUserName":{},"SelectSqlQuery":{},"ResourceRole":{},"ServiceRole":{},"DataPipelineId":{}}},"S2q":{"type":"structure","members":{"Properties":{"type":"map","key":{},"value":{}}}}},"examples":{}}');

});

parcelRequire.register("k7GIu", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeBatchPredictions":{"limit_key":"Limit","output_token":"NextToken","input_token":"NextToken","result_key":"Results"},"DescribeDataSources":{"limit_key":"Limit","output_token":"NextToken","input_token":"NextToken","result_key":"Results"},"DescribeEvaluations":{"limit_key":"Limit","output_token":"NextToken","input_token":"NextToken","result_key":"Results"},"DescribeMLModels":{"limit_key":"Limit","output_token":"NextToken","input_token":"NextToken","result_key":"Results"}}}');

});

parcelRequire.register("dllSk", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"DataSourceAvailable":{"delay":30,"operation":"DescribeDataSources","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]},"MLModelAvailable":{"delay":30,"operation":"DescribeMLModels","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]},"EvaluationAvailable":{"delay":30,"operation":"DescribeEvaluations","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]},"BatchPredictionAvailable":{"delay":30,"operation":"DescribeBatchPredictions","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]}}}');

});


parcelRequire.register("3W3Ob", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $2dd9be284bc2aefa$var$Service = $dbC7k.Service;
var $2dd9be284bc2aefa$var$apiLoader = $dbC7k.apiLoader;
$2dd9be284bc2aefa$var$apiLoader.services["marketplacecommerceanalytics"] = {};
$dbC7k.MarketplaceCommerceAnalytics = $2dd9be284bc2aefa$var$Service.defineService("marketplacecommerceanalytics", [
    "2015-07-01"
]);


Object.defineProperty($2dd9be284bc2aefa$var$apiLoader.services["marketplacecommerceanalytics"], "2015-07-01", {
    get: function get() {
        var model = (parcelRequire("aJH0i"));
        model.paginators = (parcelRequire("11cma")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.MarketplaceCommerceAnalytics;

});
parcelRequire.register("aJH0i", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-07-01","endpointPrefix":"marketplacecommerceanalytics","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Marketplace Commerce Analytics","serviceId":"Marketplace Commerce Analytics","signatureVersion":"v4","signingName":"marketplacecommerceanalytics","targetPrefix":"MarketplaceCommerceAnalytics20150701","uid":"marketplacecommerceanalytics-2015-07-01"},"operations":{"GenerateDataSet":{"input":{"type":"structure","required":["dataSetType","dataSetPublicationDate","roleNameArn","destinationS3BucketName","snsTopicArn"],"members":{"dataSetType":{},"dataSetPublicationDate":{"type":"timestamp"},"roleNameArn":{},"destinationS3BucketName":{},"destinationS3Prefix":{},"snsTopicArn":{},"customerDefinedValues":{"shape":"S8"}}},"output":{"type":"structure","members":{"dataSetRequestId":{}}}},"StartSupportDataExport":{"input":{"type":"structure","required":["dataSetType","fromDate","roleNameArn","destinationS3BucketName","snsTopicArn"],"members":{"dataSetType":{},"fromDate":{"type":"timestamp"},"roleNameArn":{},"destinationS3BucketName":{},"destinationS3Prefix":{},"snsTopicArn":{},"customerDefinedValues":{"shape":"S8"}}},"output":{"type":"structure","members":{"dataSetRequestId":{}}}}},"shapes":{"S8":{"type":"map","key":{},"value":{}}}}');

});

parcelRequire.register("11cma", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("9IaLI", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $7120938fd3c3421c$var$Service = $dbC7k.Service;
var $7120938fd3c3421c$var$apiLoader = $dbC7k.apiLoader;
$7120938fd3c3421c$var$apiLoader.services["marketplacemetering"] = {};
$dbC7k.MarketplaceMetering = $7120938fd3c3421c$var$Service.defineService("marketplacemetering", [
    "2016-01-14"
]);


Object.defineProperty($7120938fd3c3421c$var$apiLoader.services["marketplacemetering"], "2016-01-14", {
    get: function get() {
        var model = (parcelRequire("hRms0"));
        model.paginators = (parcelRequire("2zLeT")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.MarketplaceMetering;

});
parcelRequire.register("hRms0", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-01-14","endpointPrefix":"metering.marketplace","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWSMarketplace Metering","serviceId":"Marketplace Metering","signatureVersion":"v4","signingName":"aws-marketplace","targetPrefix":"AWSMPMeteringService","uid":"meteringmarketplace-2016-01-14"},"operations":{"BatchMeterUsage":{"input":{"type":"structure","required":["UsageRecords","ProductCode"],"members":{"UsageRecords":{"shape":"S2"},"ProductCode":{}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"UsageRecord":{"shape":"S3"},"MeteringRecordId":{},"Status":{}}}},"UnprocessedRecords":{"shape":"S2"}}}},"MeterUsage":{"input":{"type":"structure","required":["ProductCode","Timestamp","UsageDimension"],"members":{"ProductCode":{},"Timestamp":{"type":"timestamp"},"UsageDimension":{},"UsageQuantity":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"MeteringRecordId":{}}}},"RegisterUsage":{"input":{"type":"structure","required":["ProductCode","PublicKeyVersion"],"members":{"ProductCode":{},"PublicKeyVersion":{"type":"integer"},"Nonce":{}}},"output":{"type":"structure","members":{"PublicKeyRotationTimestamp":{"type":"timestamp"},"Signature":{}}}},"ResolveCustomer":{"input":{"type":"structure","required":["RegistrationToken"],"members":{"RegistrationToken":{}}},"output":{"type":"structure","members":{"CustomerIdentifier":{},"ProductCode":{}}}}},"shapes":{"S2":{"type":"list","member":{"shape":"S3"}},"S3":{"type":"structure","required":["Timestamp","CustomerIdentifier","Dimension"],"members":{"Timestamp":{"type":"timestamp"},"CustomerIdentifier":{},"Dimension":{},"Quantity":{"type":"integer"}}}}}');

});

parcelRequire.register("2zLeT", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("anz2K", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $78e73c3f2608c21c$var$Service = $dbC7k.Service;
var $78e73c3f2608c21c$var$apiLoader = $dbC7k.apiLoader;
$78e73c3f2608c21c$var$apiLoader.services["mturk"] = {};
$dbC7k.MTurk = $78e73c3f2608c21c$var$Service.defineService("mturk", [
    "2017-01-17"
]);


Object.defineProperty($78e73c3f2608c21c$var$apiLoader.services["mturk"], "2017-01-17", {
    get: function get() {
        var model = (parcelRequire("i1jit"));
        model.paginators = (parcelRequire("8YYl8")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.MTurk;

});
parcelRequire.register("i1jit", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-01-17","endpointPrefix":"mturk-requester","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon MTurk","serviceFullName":"Amazon Mechanical Turk","serviceId":"MTurk","signatureVersion":"v4","targetPrefix":"MTurkRequesterServiceV20170117","uid":"mturk-requester-2017-01-17"},"operations":{"AcceptQualificationRequest":{"input":{"type":"structure","required":["QualificationRequestId"],"members":{"QualificationRequestId":{},"IntegerValue":{"type":"integer"}}},"output":{"type":"structure","members":{}}},"ApproveAssignment":{"input":{"type":"structure","required":["AssignmentId"],"members":{"AssignmentId":{},"RequesterFeedback":{},"OverrideRejection":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"AssociateQualificationWithWorker":{"input":{"type":"structure","required":["QualificationTypeId","WorkerId"],"members":{"QualificationTypeId":{},"WorkerId":{},"IntegerValue":{"type":"integer"},"SendNotification":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"CreateAdditionalAssignmentsForHIT":{"input":{"type":"structure","required":["HITId","NumberOfAdditionalAssignments"],"members":{"HITId":{},"NumberOfAdditionalAssignments":{"type":"integer"},"UniqueRequestToken":{}}},"output":{"type":"structure","members":{}}},"CreateHIT":{"input":{"type":"structure","required":["LifetimeInSeconds","AssignmentDurationInSeconds","Reward","Title","Description"],"members":{"MaxAssignments":{"type":"integer"},"AutoApprovalDelayInSeconds":{"type":"long"},"LifetimeInSeconds":{"type":"long"},"AssignmentDurationInSeconds":{"type":"long"},"Reward":{},"Title":{},"Keywords":{},"Description":{},"Question":{},"RequesterAnnotation":{},"QualificationRequirements":{"shape":"Si"},"UniqueRequestToken":{},"AssignmentReviewPolicy":{"shape":"Sq"},"HITReviewPolicy":{"shape":"Sq"},"HITLayoutId":{},"HITLayoutParameters":{"shape":"Sw"}}},"output":{"type":"structure","members":{"HIT":{"shape":"Sz"}}}},"CreateHITType":{"input":{"type":"structure","required":["AssignmentDurationInSeconds","Reward","Title","Description"],"members":{"AutoApprovalDelayInSeconds":{"type":"long"},"AssignmentDurationInSeconds":{"type":"long"},"Reward":{},"Title":{},"Keywords":{},"Description":{},"QualificationRequirements":{"shape":"Si"}}},"output":{"type":"structure","members":{"HITTypeId":{}}},"idempotent":true},"CreateHITWithHITType":{"input":{"type":"structure","required":["HITTypeId","LifetimeInSeconds"],"members":{"HITTypeId":{},"MaxAssignments":{"type":"integer"},"LifetimeInSeconds":{"type":"long"},"Question":{},"RequesterAnnotation":{},"UniqueRequestToken":{},"AssignmentReviewPolicy":{"shape":"Sq"},"HITReviewPolicy":{"shape":"Sq"},"HITLayoutId":{},"HITLayoutParameters":{"shape":"Sw"}}},"output":{"type":"structure","members":{"HIT":{"shape":"Sz"}}}},"CreateQualificationType":{"input":{"type":"structure","required":["Name","Description","QualificationTypeStatus"],"members":{"Name":{},"Keywords":{},"Description":{},"QualificationTypeStatus":{},"RetryDelayInSeconds":{"type":"long"},"Test":{},"AnswerKey":{},"TestDurationInSeconds":{"type":"long"},"AutoGranted":{"type":"boolean"},"AutoGrantedValue":{"type":"integer"}}},"output":{"type":"structure","members":{"QualificationType":{"shape":"S1a"}}}},"CreateWorkerBlock":{"input":{"type":"structure","required":["WorkerId","Reason"],"members":{"WorkerId":{},"Reason":{}}},"output":{"type":"structure","members":{}}},"DeleteHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteWorkerBlock":{"input":{"type":"structure","required":["WorkerId"],"members":{"WorkerId":{},"Reason":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DisassociateQualificationFromWorker":{"input":{"type":"structure","required":["WorkerId","QualificationTypeId"],"members":{"WorkerId":{},"QualificationTypeId":{},"Reason":{}}},"output":{"type":"structure","members":{}}},"GetAccountBalance":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AvailableBalance":{},"OnHoldBalance":{}}},"idempotent":true},"GetAssignment":{"input":{"type":"structure","required":["AssignmentId"],"members":{"AssignmentId":{}}},"output":{"type":"structure","members":{"Assignment":{"shape":"S1p"},"HIT":{"shape":"Sz"}}},"idempotent":true},"GetFileUploadURL":{"input":{"type":"structure","required":["AssignmentId","QuestionIdentifier"],"members":{"AssignmentId":{},"QuestionIdentifier":{}}},"output":{"type":"structure","members":{"FileUploadURL":{}}},"idempotent":true},"GetHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{}}},"output":{"type":"structure","members":{"HIT":{"shape":"Sz"}}},"idempotent":true},"GetQualificationScore":{"input":{"type":"structure","required":["QualificationTypeId","WorkerId"],"members":{"QualificationTypeId":{},"WorkerId":{}}},"output":{"type":"structure","members":{"Qualification":{"shape":"S1x"}}},"idempotent":true},"GetQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{}}},"output":{"type":"structure","members":{"QualificationType":{"shape":"S1a"}}},"idempotent":true},"ListAssignmentsForHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{},"NextToken":{},"MaxResults":{"type":"integer"},"AssignmentStatuses":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"Assignments":{"type":"list","member":{"shape":"S1p"}}}},"idempotent":true},"ListBonusPayments":{"input":{"type":"structure","members":{"HITId":{},"AssignmentId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NumResults":{"type":"integer"},"NextToken":{},"BonusPayments":{"type":"list","member":{"type":"structure","members":{"WorkerId":{},"BonusAmount":{},"AssignmentId":{},"Reason":{},"GrantTime":{"type":"timestamp"}}}}}},"idempotent":true},"ListHITs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"HITs":{"shape":"S2d"}}},"idempotent":true},"ListHITsForQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"HITs":{"shape":"S2d"}}},"idempotent":true},"ListQualificationRequests":{"input":{"type":"structure","members":{"QualificationTypeId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NumResults":{"type":"integer"},"NextToken":{},"QualificationRequests":{"type":"list","member":{"type":"structure","members":{"QualificationRequestId":{},"QualificationTypeId":{},"WorkerId":{},"Test":{},"Answer":{},"SubmitTime":{"type":"timestamp"}}}}}},"idempotent":true},"ListQualificationTypes":{"input":{"type":"structure","required":["MustBeRequestable"],"members":{"Query":{},"MustBeRequestable":{"type":"boolean"},"MustBeOwnedByCaller":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NumResults":{"type":"integer"},"NextToken":{},"QualificationTypes":{"type":"list","member":{"shape":"S1a"}}}},"idempotent":true},"ListReviewPolicyResultsForHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{},"PolicyLevels":{"type":"list","member":{}},"RetrieveActions":{"type":"boolean"},"RetrieveResults":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"HITId":{},"AssignmentReviewPolicy":{"shape":"Sq"},"HITReviewPolicy":{"shape":"Sq"},"AssignmentReviewReport":{"shape":"S2r"},"HITReviewReport":{"shape":"S2r"},"NextToken":{}}},"idempotent":true},"ListReviewableHITs":{"input":{"type":"structure","members":{"HITTypeId":{},"Status":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"HITs":{"shape":"S2d"}}},"idempotent":true},"ListWorkerBlocks":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"WorkerBlocks":{"type":"list","member":{"type":"structure","members":{"WorkerId":{},"Reason":{}}}}}},"idempotent":true},"ListWorkersWithQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{},"Status":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"Qualifications":{"type":"list","member":{"shape":"S1x"}}}},"idempotent":true},"NotifyWorkers":{"input":{"type":"structure","required":["Subject","MessageText","WorkerIds"],"members":{"Subject":{},"MessageText":{},"WorkerIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"NotifyWorkersFailureStatuses":{"type":"list","member":{"type":"structure","members":{"NotifyWorkersFailureCode":{},"NotifyWorkersFailureMessage":{},"WorkerId":{}}}}}}},"RejectAssignment":{"input":{"type":"structure","required":["AssignmentId","RequesterFeedback"],"members":{"AssignmentId":{},"RequesterFeedback":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"RejectQualificationRequest":{"input":{"type":"structure","required":["QualificationRequestId"],"members":{"QualificationRequestId":{},"Reason":{}}},"output":{"type":"structure","members":{}}},"SendBonus":{"input":{"type":"structure","required":["WorkerId","BonusAmount","AssignmentId","Reason"],"members":{"WorkerId":{},"BonusAmount":{},"AssignmentId":{},"Reason":{},"UniqueRequestToken":{}}},"output":{"type":"structure","members":{}}},"SendTestEventNotification":{"input":{"type":"structure","required":["Notification","TestEventType"],"members":{"Notification":{"shape":"S3k"},"TestEventType":{}}},"output":{"type":"structure","members":{}}},"UpdateExpirationForHIT":{"input":{"type":"structure","required":["HITId","ExpireAt"],"members":{"HITId":{},"ExpireAt":{"type":"timestamp"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateHITReviewStatus":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{},"Revert":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateHITTypeOfHIT":{"input":{"type":"structure","required":["HITId","HITTypeId"],"members":{"HITId":{},"HITTypeId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateNotificationSettings":{"input":{"type":"structure","required":["HITTypeId"],"members":{"HITTypeId":{},"Notification":{"shape":"S3k"},"Active":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{},"Description":{},"QualificationTypeStatus":{},"Test":{},"AnswerKey":{},"TestDurationInSeconds":{"type":"long"},"RetryDelayInSeconds":{"type":"long"},"AutoGranted":{"type":"boolean"},"AutoGrantedValue":{"type":"integer"}}},"output":{"type":"structure","members":{"QualificationType":{"shape":"S1a"}}}}},"shapes":{"Si":{"type":"list","member":{"type":"structure","required":["QualificationTypeId","Comparator"],"members":{"QualificationTypeId":{},"Comparator":{},"IntegerValues":{"type":"list","member":{"type":"integer"}},"LocaleValues":{"type":"list","member":{"shape":"Sn"}},"RequiredToPreview":{"deprecated":true,"type":"boolean"},"ActionsGuarded":{}}}},"Sn":{"type":"structure","required":["Country"],"members":{"Country":{},"Subdivision":{}}},"Sq":{"type":"structure","required":["PolicyName"],"members":{"PolicyName":{},"Parameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"shape":"St"},"MapEntries":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"shape":"St"}}}}}}}}},"St":{"type":"list","member":{}},"Sw":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"Sz":{"type":"structure","members":{"HITId":{},"HITTypeId":{},"HITGroupId":{},"HITLayoutId":{},"CreationTime":{"type":"timestamp"},"Title":{},"Description":{},"Question":{},"Keywords":{},"HITStatus":{},"MaxAssignments":{"type":"integer"},"Reward":{},"AutoApprovalDelayInSeconds":{"type":"long"},"Expiration":{"type":"timestamp"},"AssignmentDurationInSeconds":{"type":"long"},"RequesterAnnotation":{},"QualificationRequirements":{"shape":"Si"},"HITReviewStatus":{},"NumberOfAssignmentsPending":{"type":"integer"},"NumberOfAssignmentsAvailable":{"type":"integer"},"NumberOfAssignmentsCompleted":{"type":"integer"}}},"S1a":{"type":"structure","members":{"QualificationTypeId":{},"CreationTime":{"type":"timestamp"},"Name":{},"Description":{},"Keywords":{},"QualificationTypeStatus":{},"Test":{},"TestDurationInSeconds":{"type":"long"},"AnswerKey":{},"RetryDelayInSeconds":{"type":"long"},"IsRequestable":{"type":"boolean"},"AutoGranted":{"type":"boolean"},"AutoGrantedValue":{"type":"integer"}}},"S1p":{"type":"structure","members":{"AssignmentId":{},"WorkerId":{},"HITId":{},"AssignmentStatus":{},"AutoApprovalTime":{"type":"timestamp"},"AcceptTime":{"type":"timestamp"},"SubmitTime":{"type":"timestamp"},"ApprovalTime":{"type":"timestamp"},"RejectionTime":{"type":"timestamp"},"Deadline":{"type":"timestamp"},"Answer":{},"RequesterFeedback":{}}},"S1x":{"type":"structure","members":{"QualificationTypeId":{},"WorkerId":{},"GrantTime":{"type":"timestamp"},"IntegerValue":{"type":"integer"},"LocaleValue":{"shape":"Sn"},"Status":{}}},"S2d":{"type":"list","member":{"shape":"Sz"}},"S2r":{"type":"structure","members":{"ReviewResults":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"SubjectId":{},"SubjectType":{},"QuestionId":{},"Key":{},"Value":{}}}},"ReviewActions":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"ActionName":{},"TargetId":{},"TargetType":{},"Status":{},"CompleteTime":{"type":"timestamp"},"Result":{},"ErrorCode":{}}}}}},"S3k":{"type":"structure","required":["Destination","Transport","Version","EventTypes"],"members":{"Destination":{},"Transport":{},"Version":{},"EventTypes":{"type":"list","member":{}}}}}}');

});

parcelRequire.register("8YYl8", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListAssignmentsForHIT":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListBonusPayments":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListHITs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListHITsForQualificationType":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListQualificationRequests":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListQualificationTypes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListReviewPolicyResultsForHIT":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListReviewableHITs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWorkerBlocks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWorkersWithQualificationType":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("kR1k5", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $f2e9c89eb3e25d11$var$Service = $dbC7k.Service;
var $f2e9c89eb3e25d11$var$apiLoader = $dbC7k.apiLoader;
$f2e9c89eb3e25d11$var$apiLoader.services["mobileanalytics"] = {};
$dbC7k.MobileAnalytics = $f2e9c89eb3e25d11$var$Service.defineService("mobileanalytics", [
    "2014-06-05"
]);

Object.defineProperty($f2e9c89eb3e25d11$var$apiLoader.services["mobileanalytics"], "2014-06-05", {
    get: function get() {
        var model = (parcelRequire("9z6Xj"));
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.MobileAnalytics;

});
parcelRequire.register("9z6Xj", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2014-06-05","endpointPrefix":"mobileanalytics","serviceFullName":"Amazon Mobile Analytics","serviceId":"Mobile Analytics","signatureVersion":"v4","protocol":"rest-json"},"operations":{"PutEvents":{"http":{"requestUri":"/2014-06-05/events","responseCode":202},"input":{"type":"structure","required":["events","clientContext"],"members":{"events":{"type":"list","member":{"type":"structure","required":["eventType","timestamp"],"members":{"eventType":{},"timestamp":{},"session":{"type":"structure","members":{"id":{},"duration":{"type":"long"},"startTimestamp":{},"stopTimestamp":{}}},"version":{},"attributes":{"type":"map","key":{},"value":{}},"metrics":{"type":"map","key":{},"value":{"type":"double"}}}}},"clientContext":{"location":"header","locationName":"x-amz-Client-Context"},"clientContextEncoding":{"location":"header","locationName":"x-amz-Client-Context-Encoding"}}}}},"shapes":{}}');

});


parcelRequire.register("6vlmU", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $4bc636a8228e9fd8$var$Service = $dbC7k.Service;
var $4bc636a8228e9fd8$var$apiLoader = $dbC7k.apiLoader;
$4bc636a8228e9fd8$var$apiLoader.services["opsworks"] = {};
$dbC7k.OpsWorks = $4bc636a8228e9fd8$var$Service.defineService("opsworks", [
    "2013-02-18"
]);



Object.defineProperty($4bc636a8228e9fd8$var$apiLoader.services["opsworks"], "2013-02-18", {
    get: function get() {
        var model = (parcelRequire("vqlmX"));
        model.paginators = (parcelRequire("bdkvW")).pagination;
        model.waiters = (parcelRequire("8GuXO")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.OpsWorks;

});
parcelRequire.register("vqlmX", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2013-02-18","endpointPrefix":"opsworks","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS OpsWorks","serviceId":"OpsWorks","signatureVersion":"v4","targetPrefix":"OpsWorks_20130218","uid":"opsworks-2013-02-18"},"operations":{"AssignInstance":{"input":{"type":"structure","required":["InstanceId","LayerIds"],"members":{"InstanceId":{},"LayerIds":{"shape":"S3"}}}},"AssignVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{},"InstanceId":{}}}},"AssociateElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{},"InstanceId":{}}}},"AttachElasticLoadBalancer":{"input":{"type":"structure","required":["ElasticLoadBalancerName","LayerId"],"members":{"ElasticLoadBalancerName":{},"LayerId":{}}}},"CloneStack":{"input":{"type":"structure","required":["SourceStackId","ServiceRoleArn"],"members":{"SourceStackId":{},"Name":{},"Region":{},"VpcId":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"UseOpsworksSecurityGroups":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"ClonePermissions":{"type":"boolean"},"CloneAppIds":{"shape":"S3"},"DefaultRootDeviceType":{},"AgentVersion":{}}},"output":{"type":"structure","members":{"StackId":{}}}},"CreateApp":{"input":{"type":"structure","required":["StackId","Name","Type"],"members":{"StackId":{},"Shortname":{},"Name":{},"Description":{},"DataSources":{"shape":"Si"},"Type":{},"AppSource":{"shape":"Sd"},"Domains":{"shape":"S3"},"EnableSsl":{"type":"boolean"},"SslConfiguration":{"shape":"Sl"},"Attributes":{"shape":"Sm"},"Environment":{"shape":"So"}}},"output":{"type":"structure","members":{"AppId":{}}}},"CreateDeployment":{"input":{"type":"structure","required":["StackId","Command"],"members":{"StackId":{},"AppId":{},"InstanceIds":{"shape":"S3"},"LayerIds":{"shape":"S3"},"Command":{"shape":"Ss"},"Comment":{},"CustomJson":{}}},"output":{"type":"structure","members":{"DeploymentId":{}}}},"CreateInstance":{"input":{"type":"structure","required":["StackId","LayerIds","InstanceType"],"members":{"StackId":{},"LayerIds":{"shape":"S3"},"InstanceType":{},"AutoScalingType":{},"Hostname":{},"Os":{},"AmiId":{},"SshKeyName":{},"AvailabilityZone":{},"VirtualizationType":{},"SubnetId":{},"Architecture":{},"RootDeviceType":{},"BlockDeviceMappings":{"shape":"Sz"},"InstallUpdatesOnBoot":{"type":"boolean"},"EbsOptimized":{"type":"boolean"},"AgentVersion":{},"Tenancy":{}}},"output":{"type":"structure","members":{"InstanceId":{}}}},"CreateLayer":{"input":{"type":"structure","required":["StackId","Type","Name","Shortname"],"members":{"StackId":{},"Type":{},"Name":{},"Shortname":{},"Attributes":{"shape":"S17"},"CloudWatchLogsConfiguration":{"shape":"S19"},"CustomInstanceProfileArn":{},"CustomJson":{},"CustomSecurityGroupIds":{"shape":"S3"},"Packages":{"shape":"S3"},"VolumeConfigurations":{"shape":"S1f"},"EnableAutoHealing":{"type":"boolean"},"AutoAssignElasticIps":{"type":"boolean"},"AutoAssignPublicIps":{"type":"boolean"},"CustomRecipes":{"shape":"S1h"},"InstallUpdatesOnBoot":{"type":"boolean"},"UseEbsOptimizedInstances":{"type":"boolean"},"LifecycleEventConfiguration":{"shape":"S1i"}}},"output":{"type":"structure","members":{"LayerId":{}}}},"CreateStack":{"input":{"type":"structure","required":["Name","Region","ServiceRoleArn","DefaultInstanceProfileArn"],"members":{"Name":{},"Region":{},"VpcId":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"UseOpsworksSecurityGroups":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"DefaultRootDeviceType":{},"AgentVersion":{}}},"output":{"type":"structure","members":{"StackId":{}}}},"CreateUserProfile":{"input":{"type":"structure","required":["IamUserArn"],"members":{"IamUserArn":{},"SshUsername":{},"SshPublicKey":{},"AllowSelfManagement":{"type":"boolean"}}},"output":{"type":"structure","members":{"IamUserArn":{}}}},"DeleteApp":{"input":{"type":"structure","required":["AppId"],"members":{"AppId":{}}}},"DeleteInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DeleteElasticIp":{"type":"boolean"},"DeleteVolumes":{"type":"boolean"}}}},"DeleteLayer":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{}}}},"DeleteStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}}},"DeleteUserProfile":{"input":{"type":"structure","required":["IamUserArn"],"members":{"IamUserArn":{}}}},"DeregisterEcsCluster":{"input":{"type":"structure","required":["EcsClusterArn"],"members":{"EcsClusterArn":{}}}},"DeregisterElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{}}}},"DeregisterInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"DeregisterRdsDbInstance":{"input":{"type":"structure","required":["RdsDbInstanceArn"],"members":{"RdsDbInstanceArn":{}}}},"DeregisterVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{}}}},"DescribeAgentVersions":{"input":{"type":"structure","members":{"StackId":{},"ConfigurationManager":{"shape":"Sa"}}},"output":{"type":"structure","members":{"AgentVersions":{"type":"list","member":{"type":"structure","members":{"Version":{},"ConfigurationManager":{"shape":"Sa"}}}}}}},"DescribeApps":{"input":{"type":"structure","members":{"StackId":{},"AppIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Apps":{"type":"list","member":{"type":"structure","members":{"AppId":{},"StackId":{},"Shortname":{},"Name":{},"Description":{},"DataSources":{"shape":"Si"},"Type":{},"AppSource":{"shape":"Sd"},"Domains":{"shape":"S3"},"EnableSsl":{"type":"boolean"},"SslConfiguration":{"shape":"Sl"},"Attributes":{"shape":"Sm"},"CreatedAt":{},"Environment":{"shape":"So"}}}}}}},"DescribeCommands":{"input":{"type":"structure","members":{"DeploymentId":{},"InstanceId":{},"CommandIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Commands":{"type":"list","member":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"DeploymentId":{},"CreatedAt":{},"AcknowledgedAt":{},"CompletedAt":{},"Status":{},"ExitCode":{"type":"integer"},"LogUrl":{},"Type":{}}}}}}},"DescribeDeployments":{"input":{"type":"structure","members":{"StackId":{},"AppId":{},"DeploymentIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Deployments":{"type":"list","member":{"type":"structure","members":{"DeploymentId":{},"StackId":{},"AppId":{},"CreatedAt":{},"CompletedAt":{},"Duration":{"type":"integer"},"IamUserArn":{},"Comment":{},"Command":{"shape":"Ss"},"Status":{},"CustomJson":{},"InstanceIds":{"shape":"S3"}}}}}}},"DescribeEcsClusters":{"input":{"type":"structure","members":{"EcsClusterArns":{"shape":"S3"},"StackId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EcsClusters":{"type":"list","member":{"type":"structure","members":{"EcsClusterArn":{},"EcsClusterName":{},"StackId":{},"RegisteredAt":{}}}},"NextToken":{}}}},"DescribeElasticIps":{"input":{"type":"structure","members":{"InstanceId":{},"StackId":{},"Ips":{"shape":"S3"}}},"output":{"type":"structure","members":{"ElasticIps":{"type":"list","member":{"type":"structure","members":{"Ip":{},"Name":{},"Domain":{},"Region":{},"InstanceId":{}}}}}}},"DescribeElasticLoadBalancers":{"input":{"type":"structure","members":{"StackId":{},"LayerIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"ElasticLoadBalancers":{"type":"list","member":{"type":"structure","members":{"ElasticLoadBalancerName":{},"Region":{},"DnsName":{},"StackId":{},"LayerId":{},"VpcId":{},"AvailabilityZones":{"shape":"S3"},"SubnetIds":{"shape":"S3"},"Ec2InstanceIds":{"shape":"S3"}}}}}}},"DescribeInstances":{"input":{"type":"structure","members":{"StackId":{},"LayerId":{},"InstanceIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"AgentVersion":{},"AmiId":{},"Architecture":{},"Arn":{},"AutoScalingType":{},"AvailabilityZone":{},"BlockDeviceMappings":{"shape":"Sz"},"CreatedAt":{},"EbsOptimized":{"type":"boolean"},"Ec2InstanceId":{},"EcsClusterArn":{},"EcsContainerInstanceArn":{},"ElasticIp":{},"Hostname":{},"InfrastructureClass":{},"InstallUpdatesOnBoot":{"type":"boolean"},"InstanceId":{},"InstanceProfileArn":{},"InstanceType":{},"LastServiceErrorId":{},"LayerIds":{"shape":"S3"},"Os":{},"Platform":{},"PrivateDns":{},"PrivateIp":{},"PublicDns":{},"PublicIp":{},"RegisteredBy":{},"ReportedAgentVersion":{},"ReportedOs":{"type":"structure","members":{"Family":{},"Name":{},"Version":{}}},"RootDeviceType":{},"RootDeviceVolumeId":{},"SecurityGroupIds":{"shape":"S3"},"SshHostDsaKeyFingerprint":{},"SshHostRsaKeyFingerprint":{},"SshKeyName":{},"StackId":{},"Status":{},"SubnetId":{},"Tenancy":{},"VirtualizationType":{}}}}}}},"DescribeLayers":{"input":{"type":"structure","members":{"StackId":{},"LayerIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Layers":{"type":"list","member":{"type":"structure","members":{"Arn":{},"StackId":{},"LayerId":{},"Type":{},"Name":{},"Shortname":{},"Attributes":{"shape":"S17"},"CloudWatchLogsConfiguration":{"shape":"S19"},"CustomInstanceProfileArn":{},"CustomJson":{},"CustomSecurityGroupIds":{"shape":"S3"},"DefaultSecurityGroupNames":{"shape":"S3"},"Packages":{"shape":"S3"},"VolumeConfigurations":{"shape":"S1f"},"EnableAutoHealing":{"type":"boolean"},"AutoAssignElasticIps":{"type":"boolean"},"AutoAssignPublicIps":{"type":"boolean"},"DefaultRecipes":{"shape":"S1h"},"CustomRecipes":{"shape":"S1h"},"CreatedAt":{},"InstallUpdatesOnBoot":{"type":"boolean"},"UseEbsOptimizedInstances":{"type":"boolean"},"LifecycleEventConfiguration":{"shape":"S1i"}}}}}}},"DescribeLoadBasedAutoScaling":{"input":{"type":"structure","required":["LayerIds"],"members":{"LayerIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"LoadBasedAutoScalingConfigurations":{"type":"list","member":{"type":"structure","members":{"LayerId":{},"Enable":{"type":"boolean"},"UpScaling":{"shape":"S36"},"DownScaling":{"shape":"S36"}}}}}}},"DescribeMyUserProfile":{"output":{"type":"structure","members":{"UserProfile":{"type":"structure","members":{"IamUserArn":{},"Name":{},"SshUsername":{},"SshPublicKey":{}}}}}},"DescribeOperatingSystems":{"output":{"type":"structure","members":{"OperatingSystems":{"type":"list","member":{"type":"structure","members":{"Name":{},"Id":{},"Type":{},"ConfigurationManagers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{}}}},"ReportedName":{},"ReportedVersion":{},"Supported":{"type":"boolean"}}}}}}},"DescribePermissions":{"input":{"type":"structure","members":{"IamUserArn":{},"StackId":{}}},"output":{"type":"structure","members":{"Permissions":{"type":"list","member":{"type":"structure","members":{"StackId":{},"IamUserArn":{},"AllowSsh":{"type":"boolean"},"AllowSudo":{"type":"boolean"},"Level":{}}}}}}},"DescribeRaidArrays":{"input":{"type":"structure","members":{"InstanceId":{},"StackId":{},"RaidArrayIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"RaidArrays":{"type":"list","member":{"type":"structure","members":{"RaidArrayId":{},"InstanceId":{},"Name":{},"RaidLevel":{"type":"integer"},"NumberOfDisks":{"type":"integer"},"Size":{"type":"integer"},"Device":{},"MountPoint":{},"AvailabilityZone":{},"CreatedAt":{},"StackId":{},"VolumeType":{},"Iops":{"type":"integer"}}}}}}},"DescribeRdsDbInstances":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{},"RdsDbInstanceArns":{"shape":"S3"}}},"output":{"type":"structure","members":{"RdsDbInstances":{"type":"list","member":{"type":"structure","members":{"RdsDbInstanceArn":{},"DbInstanceIdentifier":{},"DbUser":{},"DbPassword":{},"Region":{},"Address":{},"Engine":{},"StackId":{},"MissingOnRds":{"type":"boolean"}}}}}}},"DescribeServiceErrors":{"input":{"type":"structure","members":{"StackId":{},"InstanceId":{},"ServiceErrorIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"ServiceErrors":{"type":"list","member":{"type":"structure","members":{"ServiceErrorId":{},"StackId":{},"InstanceId":{},"Type":{},"Message":{},"CreatedAt":{}}}}}}},"DescribeStackProvisioningParameters":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}},"output":{"type":"structure","members":{"AgentInstallerUrl":{},"Parameters":{"type":"map","key":{},"value":{}}}}},"DescribeStackSummary":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}},"output":{"type":"structure","members":{"StackSummary":{"type":"structure","members":{"StackId":{},"Name":{},"Arn":{},"LayersCount":{"type":"integer"},"AppsCount":{"type":"integer"},"InstancesCount":{"type":"structure","members":{"Assigning":{"type":"integer"},"Booting":{"type":"integer"},"ConnectionLost":{"type":"integer"},"Deregistering":{"type":"integer"},"Online":{"type":"integer"},"Pending":{"type":"integer"},"Rebooting":{"type":"integer"},"Registered":{"type":"integer"},"Registering":{"type":"integer"},"Requested":{"type":"integer"},"RunningSetup":{"type":"integer"},"SetupFailed":{"type":"integer"},"ShuttingDown":{"type":"integer"},"StartFailed":{"type":"integer"},"StopFailed":{"type":"integer"},"Stopped":{"type":"integer"},"Stopping":{"type":"integer"},"Terminated":{"type":"integer"},"Terminating":{"type":"integer"},"Unassigning":{"type":"integer"}}}}}}}},"DescribeStacks":{"input":{"type":"structure","members":{"StackIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Stacks":{"type":"list","member":{"type":"structure","members":{"StackId":{},"Name":{},"Arn":{},"Region":{},"VpcId":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"UseOpsworksSecurityGroups":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"CreatedAt":{},"DefaultRootDeviceType":{},"AgentVersion":{}}}}}}},"DescribeTimeBasedAutoScaling":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"TimeBasedAutoScalingConfigurations":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"AutoScalingSchedule":{"shape":"S4b"}}}}}}},"DescribeUserProfiles":{"input":{"type":"structure","members":{"IamUserArns":{"shape":"S3"}}},"output":{"type":"structure","members":{"UserProfiles":{"type":"list","member":{"type":"structure","members":{"IamUserArn":{},"Name":{},"SshUsername":{},"SshPublicKey":{},"AllowSelfManagement":{"type":"boolean"}}}}}}},"DescribeVolumes":{"input":{"type":"structure","members":{"InstanceId":{},"StackId":{},"RaidArrayId":{},"VolumeIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Volumes":{"type":"list","member":{"type":"structure","members":{"VolumeId":{},"Ec2VolumeId":{},"Name":{},"RaidArrayId":{},"InstanceId":{},"Status":{},"Size":{"type":"integer"},"Device":{},"MountPoint":{},"Region":{},"AvailabilityZone":{},"VolumeType":{},"Iops":{"type":"integer"},"Encrypted":{"type":"boolean"}}}}}}},"DetachElasticLoadBalancer":{"input":{"type":"structure","required":["ElasticLoadBalancerName","LayerId"],"members":{"ElasticLoadBalancerName":{},"LayerId":{}}}},"DisassociateElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{}}}},"GetHostnameSuggestion":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{}}},"output":{"type":"structure","members":{"LayerId":{},"Hostname":{}}}},"GrantAccess":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"ValidForInMinutes":{"type":"integer"}}},"output":{"type":"structure","members":{"TemporaryCredential":{"type":"structure","members":{"Username":{},"Password":{},"ValidForInMinutes":{"type":"integer"},"InstanceId":{}}}}}},"ListTags":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S50"},"NextToken":{}}}},"RebootInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"RegisterEcsCluster":{"input":{"type":"structure","required":["EcsClusterArn","StackId"],"members":{"EcsClusterArn":{},"StackId":{}}},"output":{"type":"structure","members":{"EcsClusterArn":{}}}},"RegisterElasticIp":{"input":{"type":"structure","required":["ElasticIp","StackId"],"members":{"ElasticIp":{},"StackId":{}}},"output":{"type":"structure","members":{"ElasticIp":{}}}},"RegisterInstance":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{},"Hostname":{},"PublicIp":{},"PrivateIp":{},"RsaPublicKey":{},"RsaPublicKeyFingerprint":{},"InstanceIdentity":{"type":"structure","members":{"Document":{},"Signature":{}}}}},"output":{"type":"structure","members":{"InstanceId":{}}}},"RegisterRdsDbInstance":{"input":{"type":"structure","required":["StackId","RdsDbInstanceArn","DbUser","DbPassword"],"members":{"StackId":{},"RdsDbInstanceArn":{},"DbUser":{},"DbPassword":{}}}},"RegisterVolume":{"input":{"type":"structure","required":["StackId"],"members":{"Ec2VolumeId":{},"StackId":{}}},"output":{"type":"structure","members":{"VolumeId":{}}}},"SetLoadBasedAutoScaling":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{},"Enable":{"type":"boolean"},"UpScaling":{"shape":"S36"},"DownScaling":{"shape":"S36"}}}},"SetPermission":{"input":{"type":"structure","required":["StackId","IamUserArn"],"members":{"StackId":{},"IamUserArn":{},"AllowSsh":{"type":"boolean"},"AllowSudo":{"type":"boolean"},"Level":{}}}},"SetTimeBasedAutoScaling":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"AutoScalingSchedule":{"shape":"S4b"}}}},"StartInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"StartStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}}},"StopInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"Force":{"type":"boolean"}}}},"StopStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S50"}}}},"UnassignInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"UnassignVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateApp":{"input":{"type":"structure","required":["AppId"],"members":{"AppId":{},"Name":{},"Description":{},"DataSources":{"shape":"Si"},"Type":{},"AppSource":{"shape":"Sd"},"Domains":{"shape":"S3"},"EnableSsl":{"type":"boolean"},"SslConfiguration":{"shape":"Sl"},"Attributes":{"shape":"Sm"},"Environment":{"shape":"So"}}}},"UpdateElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{},"Name":{}}}},"UpdateInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"LayerIds":{"shape":"S3"},"InstanceType":{},"AutoScalingType":{},"Hostname":{},"Os":{},"AmiId":{},"SshKeyName":{},"Architecture":{},"InstallUpdatesOnBoot":{"type":"boolean"},"EbsOptimized":{"type":"boolean"},"AgentVersion":{}}}},"UpdateLayer":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{},"Name":{},"Shortname":{},"Attributes":{"shape":"S17"},"CloudWatchLogsConfiguration":{"shape":"S19"},"CustomInstanceProfileArn":{},"CustomJson":{},"CustomSecurityGroupIds":{"shape":"S3"},"Packages":{"shape":"S3"},"VolumeConfigurations":{"shape":"S1f"},"EnableAutoHealing":{"type":"boolean"},"AutoAssignElasticIps":{"type":"boolean"},"AutoAssignPublicIps":{"type":"boolean"},"CustomRecipes":{"shape":"S1h"},"InstallUpdatesOnBoot":{"type":"boolean"},"UseEbsOptimizedInstances":{"type":"boolean"},"LifecycleEventConfiguration":{"shape":"S1i"}}}},"UpdateMyUserProfile":{"input":{"type":"structure","members":{"SshPublicKey":{}}}},"UpdateRdsDbInstance":{"input":{"type":"structure","required":["RdsDbInstanceArn"],"members":{"RdsDbInstanceArn":{},"DbUser":{},"DbPassword":{}}}},"UpdateStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{},"Name":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"DefaultRootDeviceType":{},"UseOpsworksSecurityGroups":{"type":"boolean"},"AgentVersion":{}}}},"UpdateUserProfile":{"input":{"type":"structure","required":["IamUserArn"],"members":{"IamUserArn":{},"SshUsername":{},"SshPublicKey":{},"AllowSelfManagement":{"type":"boolean"}}}},"UpdateVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{},"Name":{},"MountPoint":{}}}}},"shapes":{"S3":{"type":"list","member":{}},"S8":{"type":"map","key":{},"value":{}},"Sa":{"type":"structure","members":{"Name":{},"Version":{}}},"Sb":{"type":"structure","members":{"ManageBerkshelf":{"type":"boolean"},"BerkshelfVersion":{}}},"Sd":{"type":"structure","members":{"Type":{},"Url":{},"Username":{},"Password":{},"SshKey":{},"Revision":{}}},"Si":{"type":"list","member":{"type":"structure","members":{"Type":{},"Arn":{},"DatabaseName":{}}}},"Sl":{"type":"structure","required":["Certificate","PrivateKey"],"members":{"Certificate":{},"PrivateKey":{},"Chain":{}}},"Sm":{"type":"map","key":{},"value":{}},"So":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{},"Secure":{"type":"boolean"}}}},"Ss":{"type":"structure","required":["Name"],"members":{"Name":{},"Args":{"type":"map","key":{},"value":{"shape":"S3"}}}},"Sz":{"type":"list","member":{"type":"structure","members":{"DeviceName":{},"NoDevice":{},"VirtualName":{},"Ebs":{"type":"structure","members":{"SnapshotId":{},"Iops":{"type":"integer"},"VolumeSize":{"type":"integer"},"VolumeType":{},"DeleteOnTermination":{"type":"boolean"}}}}}},"S17":{"type":"map","key":{},"value":{}},"S19":{"type":"structure","members":{"Enabled":{"type":"boolean"},"LogStreams":{"type":"list","member":{"type":"structure","members":{"LogGroupName":{},"DatetimeFormat":{},"TimeZone":{},"File":{},"FileFingerprintLines":{},"MultiLineStartPattern":{},"InitialPosition":{},"Encoding":{},"BufferDuration":{"type":"integer"},"BatchCount":{"type":"integer"},"BatchSize":{"type":"integer"}}}}}},"S1f":{"type":"list","member":{"type":"structure","required":["MountPoint","NumberOfDisks","Size"],"members":{"MountPoint":{},"RaidLevel":{"type":"integer"},"NumberOfDisks":{"type":"integer"},"Size":{"type":"integer"},"VolumeType":{},"Iops":{"type":"integer"},"Encrypted":{"type":"boolean"}}}},"S1h":{"type":"structure","members":{"Setup":{"shape":"S3"},"Configure":{"shape":"S3"},"Deploy":{"shape":"S3"},"Undeploy":{"shape":"S3"},"Shutdown":{"shape":"S3"}}},"S1i":{"type":"structure","members":{"Shutdown":{"type":"structure","members":{"ExecutionTimeout":{"type":"integer"},"DelayUntilElbConnectionsDrained":{"type":"boolean"}}}}},"S36":{"type":"structure","members":{"InstanceCount":{"type":"integer"},"ThresholdsWaitTime":{"type":"integer"},"IgnoreMetricsTime":{"type":"integer"},"CpuThreshold":{"type":"double"},"MemoryThreshold":{"type":"double"},"LoadThreshold":{"type":"double"},"Alarms":{"shape":"S3"}}},"S4b":{"type":"structure","members":{"Monday":{"shape":"S4c"},"Tuesday":{"shape":"S4c"},"Wednesday":{"shape":"S4c"},"Thursday":{"shape":"S4c"},"Friday":{"shape":"S4c"},"Saturday":{"shape":"S4c"},"Sunday":{"shape":"S4c"}}},"S4c":{"type":"map","key":{},"value":{}},"S50":{"type":"map","key":{},"value":{}}}}');

});

parcelRequire.register("bdkvW", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeApps":{"result_key":"Apps"},"DescribeCommands":{"result_key":"Commands"},"DescribeDeployments":{"result_key":"Deployments"},"DescribeEcsClusters":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"EcsClusters"},"DescribeElasticIps":{"result_key":"ElasticIps"},"DescribeElasticLoadBalancers":{"result_key":"ElasticLoadBalancers"},"DescribeInstances":{"result_key":"Instances"},"DescribeLayers":{"result_key":"Layers"},"DescribeLoadBasedAutoScaling":{"result_key":"LoadBasedAutoScalingConfigurations"},"DescribePermissions":{"result_key":"Permissions"},"DescribeRaidArrays":{"result_key":"RaidArrays"},"DescribeServiceErrors":{"result_key":"ServiceErrors"},"DescribeStacks":{"result_key":"Stacks"},"DescribeTimeBasedAutoScaling":{"result_key":"TimeBasedAutoScalingConfigurations"},"DescribeUserProfiles":{"result_key":"UserProfiles"},"DescribeVolumes":{"result_key":"Volumes"}}}');

});

parcelRequire.register("8GuXO", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"AppExists":{"delay":1,"operation":"DescribeApps","maxAttempts":40,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"matcher":"status","expected":400,"state":"failure"}]},"DeploymentSuccessful":{"delay":15,"operation":"DescribeDeployments","maxAttempts":40,"description":"Wait until a deployment has completed successfully.","acceptors":[{"expected":"successful","matcher":"pathAll","state":"success","argument":"Deployments[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"Deployments[].Status"}]},"InstanceOnline":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is online.","acceptors":[{"expected":"online","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"shutting_down","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"start_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopped","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminating","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stop_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]},"InstanceRegistered":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is registered.","acceptors":[{"expected":"registered","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"shutting_down","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopped","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminating","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stop_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]},"InstanceStopped":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is stopped.","acceptors":[{"expected":"stopped","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"booting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"requested","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"running_setup","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"start_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stop_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]},"InstanceTerminated":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is terminated.","acceptors":[{"expected":"terminated","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"ResourceNotFoundException","matcher":"error","state":"success"},{"expected":"booting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"online","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"requested","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"running_setup","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"start_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]}}}');

});


parcelRequire.register("ik8DS", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $d570cc6695616a58$var$Service = $dbC7k.Service;
var $d570cc6695616a58$var$apiLoader = $dbC7k.apiLoader;
$d570cc6695616a58$var$apiLoader.services["opsworkscm"] = {};
$dbC7k.OpsWorksCM = $d570cc6695616a58$var$Service.defineService("opsworkscm", [
    "2016-11-01"
]);



Object.defineProperty($d570cc6695616a58$var$apiLoader.services["opsworkscm"], "2016-11-01", {
    get: function get() {
        var model = (parcelRequire("1Zy6v"));
        model.paginators = (parcelRequire("c1IHX")).pagination;
        model.waiters = (parcelRequire("ecNmx")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.OpsWorksCM;

});
parcelRequire.register("1Zy6v", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-11-01","endpointPrefix":"opsworks-cm","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"OpsWorksCM","serviceFullName":"AWS OpsWorks CM","serviceId":"OpsWorksCM","signatureVersion":"v4","signingName":"opsworks-cm","targetPrefix":"OpsWorksCM_V2016_11_01","uid":"opsworkscm-2016-11-01"},"operations":{"AssociateNode":{"input":{"type":"structure","required":["ServerName","NodeName","EngineAttributes"],"members":{"ServerName":{},"NodeName":{},"EngineAttributes":{"shape":"S4"}}},"output":{"type":"structure","members":{"NodeAssociationStatusToken":{}}}},"CreateBackup":{"input":{"type":"structure","required":["ServerName"],"members":{"ServerName":{},"Description":{}}},"output":{"type":"structure","members":{"Backup":{"shape":"Sd"}}}},"CreateServer":{"input":{"type":"structure","required":["ServerName","InstanceProfileArn","InstanceType","ServiceRoleArn"],"members":{"AssociatePublicIpAddress":{"type":"boolean"},"DisableAutomatedBackup":{"type":"boolean"},"Engine":{},"EngineModel":{},"EngineVersion":{},"EngineAttributes":{"shape":"S4"},"BackupRetentionCount":{"type":"integer"},"ServerName":{},"InstanceProfileArn":{},"InstanceType":{},"KeyPair":{},"PreferredMaintenanceWindow":{},"PreferredBackupWindow":{},"SecurityGroupIds":{"shape":"Sj"},"ServiceRoleArn":{},"SubnetIds":{"shape":"Sj"},"BackupId":{}}},"output":{"type":"structure","members":{"Server":{"shape":"Ss"}}}},"DeleteBackup":{"input":{"type":"structure","required":["BackupId"],"members":{"BackupId":{}}},"output":{"type":"structure","members":{}}},"DeleteServer":{"input":{"type":"structure","required":["ServerName"],"members":{"ServerName":{}}},"output":{"type":"structure","members":{}}},"DescribeAccountAttributes":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"Attributes":{"type":"list","member":{"type":"structure","members":{"Name":{},"Maximum":{"type":"integer"},"Used":{"type":"integer"}}}}}}},"DescribeBackups":{"input":{"type":"structure","members":{"BackupId":{},"ServerName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Backups":{"type":"list","member":{"shape":"Sd"}},"NextToken":{}}}},"DescribeEvents":{"input":{"type":"structure","required":["ServerName"],"members":{"ServerName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ServerEvents":{"type":"list","member":{"type":"structure","members":{"CreatedAt":{"type":"timestamp"},"ServerName":{},"Message":{},"LogUrl":{}}}},"NextToken":{}}}},"DescribeNodeAssociationStatus":{"input":{"type":"structure","required":["NodeAssociationStatusToken","ServerName"],"members":{"NodeAssociationStatusToken":{},"ServerName":{}}},"output":{"type":"structure","members":{"NodeAssociationStatus":{},"EngineAttributes":{"shape":"S4"}}}},"DescribeServers":{"input":{"type":"structure","members":{"ServerName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Servers":{"type":"list","member":{"shape":"Ss"}},"NextToken":{}}}},"DisassociateNode":{"input":{"type":"structure","required":["ServerName","NodeName"],"members":{"ServerName":{},"NodeName":{},"EngineAttributes":{"shape":"S4"}}},"output":{"type":"structure","members":{"NodeAssociationStatusToken":{}}}},"ExportServerEngineAttribute":{"input":{"type":"structure","required":["ExportAttributeName","ServerName"],"members":{"ExportAttributeName":{},"ServerName":{},"InputAttributes":{"shape":"S4"}}},"output":{"type":"structure","members":{"EngineAttribute":{"shape":"S5"},"ServerName":{}}}},"RestoreServer":{"input":{"type":"structure","required":["BackupId","ServerName"],"members":{"BackupId":{},"ServerName":{},"InstanceType":{},"KeyPair":{}}},"output":{"type":"structure","members":{}}},"StartMaintenance":{"input":{"type":"structure","required":["ServerName"],"members":{"ServerName":{},"EngineAttributes":{"shape":"S4"}}},"output":{"type":"structure","members":{"Server":{"shape":"Ss"}}}},"UpdateServer":{"input":{"type":"structure","required":["ServerName"],"members":{"DisableAutomatedBackup":{"type":"boolean"},"BackupRetentionCount":{"type":"integer"},"ServerName":{},"PreferredMaintenanceWindow":{},"PreferredBackupWindow":{}}},"output":{"type":"structure","members":{"Server":{"shape":"Ss"}}}},"UpdateServerEngineAttributes":{"input":{"type":"structure","required":["ServerName","AttributeName"],"members":{"ServerName":{},"AttributeName":{},"AttributeValue":{}}},"output":{"type":"structure","members":{"Server":{"shape":"Ss"}}}}},"shapes":{"S4":{"type":"list","member":{"shape":"S5"}},"S5":{"type":"structure","members":{"Name":{},"Value":{"type":"string","sensitive":true}}},"Sd":{"type":"structure","members":{"BackupArn":{},"BackupId":{},"BackupType":{},"CreatedAt":{"type":"timestamp"},"Description":{},"Engine":{},"EngineModel":{},"EngineVersion":{},"InstanceProfileArn":{},"InstanceType":{},"KeyPair":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"S3DataSize":{"deprecated":true,"type":"integer"},"S3DataUrl":{"deprecated":true},"S3LogUrl":{},"SecurityGroupIds":{"shape":"Sj"},"ServerName":{},"ServiceRoleArn":{},"Status":{},"StatusDescription":{},"SubnetIds":{"shape":"Sj"},"ToolsVersion":{},"UserArn":{}}},"Sj":{"type":"list","member":{}},"Ss":{"type":"structure","members":{"AssociatePublicIpAddress":{"type":"boolean"},"BackupRetentionCount":{"type":"integer"},"ServerName":{},"CreatedAt":{"type":"timestamp"},"CloudFormationStackArn":{},"DisableAutomatedBackup":{"type":"boolean"},"Endpoint":{},"Engine":{},"EngineModel":{},"EngineAttributes":{"shape":"S4"},"EngineVersion":{},"InstanceProfileArn":{},"InstanceType":{},"KeyPair":{},"MaintenanceStatus":{},"PreferredMaintenanceWindow":{},"PreferredBackupWindow":{},"SecurityGroupIds":{"shape":"Sj"},"ServiceRoleArn":{},"Status":{},"StatusReason":{},"SubnetIds":{"shape":"Sj"},"ServerArn":{}}}}}');

});

parcelRequire.register("c1IHX", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});

parcelRequire.register("ecNmx", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"NodeAssociated":{"delay":15,"maxAttempts":15,"operation":"DescribeNodeAssociationStatus","description":"Wait until node is associated or disassociated.","acceptors":[{"expected":"SUCCESS","state":"success","matcher":"path","argument":"NodeAssociationStatus"},{"expected":"FAILED","state":"failure","matcher":"path","argument":"NodeAssociationStatus"}]}}}');

});


parcelRequire.register("l57XG", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $f5903d9ac4fcd5c7$var$Service = $dbC7k.Service;
var $f5903d9ac4fcd5c7$var$apiLoader = $dbC7k.apiLoader;
$f5903d9ac4fcd5c7$var$apiLoader.services["organizations"] = {};
$dbC7k.Organizations = $f5903d9ac4fcd5c7$var$Service.defineService("organizations", [
    "2016-11-28"
]);


Object.defineProperty($f5903d9ac4fcd5c7$var$apiLoader.services["organizations"], "2016-11-28", {
    get: function get() {
        var model = (parcelRequire("xfPtl"));
        model.paginators = (parcelRequire("6d1jN")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Organizations;

});
parcelRequire.register("xfPtl", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-11-28","endpointPrefix":"organizations","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Organizations","serviceFullName":"AWS Organizations","serviceId":"Organizations","signatureVersion":"v4","targetPrefix":"AWSOrganizationsV20161128","uid":"organizations-2016-11-28"},"operations":{"AcceptHandshake":{"input":{"type":"structure","required":["HandshakeId"],"members":{"HandshakeId":{}}},"output":{"type":"structure","members":{"Handshake":{"shape":"S4"}}}},"AttachPolicy":{"input":{"type":"structure","required":["PolicyId","TargetId"],"members":{"PolicyId":{},"TargetId":{}}}},"CancelHandshake":{"input":{"type":"structure","required":["HandshakeId"],"members":{"HandshakeId":{}}},"output":{"type":"structure","members":{"Handshake":{"shape":"S4"}}}},"CreateAccount":{"input":{"type":"structure","required":["Email","AccountName"],"members":{"Email":{"shape":"Sn"},"AccountName":{"shape":"So"},"RoleName":{},"IamUserAccessToBilling":{}}},"output":{"type":"structure","members":{"CreateAccountStatus":{"shape":"Ss"}}}},"CreateGovCloudAccount":{"input":{"type":"structure","required":["Email","AccountName"],"members":{"Email":{"shape":"Sn"},"AccountName":{"shape":"So"},"RoleName":{},"IamUserAccessToBilling":{}}},"output":{"type":"structure","members":{"CreateAccountStatus":{"shape":"Ss"}}}},"CreateOrganization":{"input":{"type":"structure","members":{"FeatureSet":{}}},"output":{"type":"structure","members":{"Organization":{"shape":"S12"}}}},"CreateOrganizationalUnit":{"input":{"type":"structure","required":["ParentId","Name"],"members":{"ParentId":{},"Name":{}}},"output":{"type":"structure","members":{"OrganizationalUnit":{"shape":"S1e"}}}},"CreatePolicy":{"input":{"type":"structure","required":["Content","Description","Name","Type"],"members":{"Content":{},"Description":{},"Name":{},"Type":{}}},"output":{"type":"structure","members":{"Policy":{"shape":"S1m"}}}},"DeclineHandshake":{"input":{"type":"structure","required":["HandshakeId"],"members":{"HandshakeId":{}}},"output":{"type":"structure","members":{"Handshake":{"shape":"S4"}}}},"DeleteOrganization":{},"DeleteOrganizationalUnit":{"input":{"type":"structure","required":["OrganizationalUnitId"],"members":{"OrganizationalUnitId":{}}}},"DeletePolicy":{"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{}}}},"DescribeAccount":{"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{}}},"output":{"type":"structure","members":{"Account":{"shape":"S1w"}}}},"DescribeCreateAccountStatus":{"input":{"type":"structure","required":["CreateAccountRequestId"],"members":{"CreateAccountRequestId":{}}},"output":{"type":"structure","members":{"CreateAccountStatus":{"shape":"Ss"}}}},"DescribeHandshake":{"input":{"type":"structure","required":["HandshakeId"],"members":{"HandshakeId":{}}},"output":{"type":"structure","members":{"Handshake":{"shape":"S4"}}}},"DescribeOrganization":{"output":{"type":"structure","members":{"Organization":{"shape":"S12"}}}},"DescribeOrganizationalUnit":{"input":{"type":"structure","required":["OrganizationalUnitId"],"members":{"OrganizationalUnitId":{}}},"output":{"type":"structure","members":{"OrganizationalUnit":{"shape":"S1e"}}}},"DescribePolicy":{"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{}}},"output":{"type":"structure","members":{"Policy":{"shape":"S1m"}}}},"DetachPolicy":{"input":{"type":"structure","required":["PolicyId","TargetId"],"members":{"PolicyId":{},"TargetId":{}}}},"DisableAWSServiceAccess":{"input":{"type":"structure","required":["ServicePrincipal"],"members":{"ServicePrincipal":{}}}},"DisablePolicyType":{"input":{"type":"structure","required":["RootId","PolicyType"],"members":{"RootId":{},"PolicyType":{}}},"output":{"type":"structure","members":{"Root":{"shape":"S2e"}}}},"EnableAWSServiceAccess":{"input":{"type":"structure","required":["ServicePrincipal"],"members":{"ServicePrincipal":{}}}},"EnableAllFeatures":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"Handshake":{"shape":"S4"}}}},"EnablePolicyType":{"input":{"type":"structure","required":["RootId","PolicyType"],"members":{"RootId":{},"PolicyType":{}}},"output":{"type":"structure","members":{"Root":{"shape":"S2e"}}}},"InviteAccountToOrganization":{"input":{"type":"structure","required":["Target"],"members":{"Target":{"shape":"S7"},"Notes":{"type":"string","sensitive":true}}},"output":{"type":"structure","members":{"Handshake":{"shape":"S4"}}}},"LeaveOrganization":{},"ListAWSServiceAccessForOrganization":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EnabledServicePrincipals":{"type":"list","member":{"type":"structure","members":{"ServicePrincipal":{},"DateEnabled":{"type":"timestamp"}}}},"NextToken":{}}}},"ListAccounts":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Accounts":{"shape":"S2x"},"NextToken":{}}}},"ListAccountsForParent":{"input":{"type":"structure","required":["ParentId"],"members":{"ParentId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Accounts":{"shape":"S2x"},"NextToken":{}}}},"ListChildren":{"input":{"type":"structure","required":["ParentId","ChildType"],"members":{"ParentId":{},"ChildType":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Children":{"type":"list","member":{"type":"structure","members":{"Id":{},"Type":{}}}},"NextToken":{}}}},"ListCreateAccountStatus":{"input":{"type":"structure","members":{"States":{"type":"list","member":{}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"CreateAccountStatuses":{"type":"list","member":{"shape":"Ss"}},"NextToken":{}}}},"ListHandshakesForAccount":{"input":{"type":"structure","members":{"Filter":{"shape":"S3b"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Handshakes":{"shape":"S3d"},"NextToken":{}}}},"ListHandshakesForOrganization":{"input":{"type":"structure","members":{"Filter":{"shape":"S3b"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Handshakes":{"shape":"S3d"},"NextToken":{}}}},"ListOrganizationalUnitsForParent":{"input":{"type":"structure","required":["ParentId"],"members":{"ParentId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"OrganizationalUnits":{"type":"list","member":{"shape":"S1e"}},"NextToken":{}}}},"ListParents":{"input":{"type":"structure","required":["ChildId"],"members":{"ChildId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Parents":{"type":"list","member":{"type":"structure","members":{"Id":{},"Type":{}}}},"NextToken":{}}}},"ListPolicies":{"input":{"type":"structure","required":["Filter"],"members":{"Filter":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Policies":{"shape":"S3q"},"NextToken":{}}}},"ListPoliciesForTarget":{"input":{"type":"structure","required":["TargetId","Filter"],"members":{"TargetId":{},"Filter":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Policies":{"shape":"S3q"},"NextToken":{}}}},"ListRoots":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Roots":{"type":"list","member":{"shape":"S2e"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S3z"},"NextToken":{}}}},"ListTargetsForPolicy":{"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Targets":{"type":"list","member":{"type":"structure","members":{"TargetId":{},"Arn":{},"Name":{},"Type":{}}}},"NextToken":{}}}},"MoveAccount":{"input":{"type":"structure","required":["AccountId","SourceParentId","DestinationParentId"],"members":{"AccountId":{},"SourceParentId":{},"DestinationParentId":{}}}},"RemoveAccountFromOrganization":{"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceId","Tags"],"members":{"ResourceId":{},"Tags":{"shape":"S3z"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceId","TagKeys"],"members":{"ResourceId":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateOrganizationalUnit":{"input":{"type":"structure","required":["OrganizationalUnitId"],"members":{"OrganizationalUnitId":{},"Name":{}}},"output":{"type":"structure","members":{"OrganizationalUnit":{"shape":"S1e"}}}},"UpdatePolicy":{"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{},"Name":{},"Description":{},"Content":{}}},"output":{"type":"structure","members":{"Policy":{"shape":"S1m"}}}}},"shapes":{"S4":{"type":"structure","members":{"Id":{},"Arn":{},"Parties":{"type":"list","member":{"shape":"S7"}},"State":{},"RequestedTimestamp":{"type":"timestamp"},"ExpirationTimestamp":{"type":"timestamp"},"Action":{},"Resources":{"shape":"Sd"}}},"S7":{"type":"structure","required":["Id","Type"],"members":{"Id":{"type":"string","sensitive":true},"Type":{}}},"Sd":{"type":"list","member":{"type":"structure","members":{"Value":{"type":"string","sensitive":true},"Type":{},"Resources":{"shape":"Sd"}}}},"Sn":{"type":"string","sensitive":true},"So":{"type":"string","sensitive":true},"Ss":{"type":"structure","members":{"Id":{},"AccountName":{"shape":"So"},"State":{},"RequestedTimestamp":{"type":"timestamp"},"CompletedTimestamp":{"type":"timestamp"},"AccountId":{},"GovCloudAccountId":{},"FailureReason":{}}},"S12":{"type":"structure","members":{"Id":{},"Arn":{},"FeatureSet":{},"MasterAccountArn":{},"MasterAccountId":{},"MasterAccountEmail":{"shape":"Sn"},"AvailablePolicyTypes":{"shape":"S16"}}},"S16":{"type":"list","member":{"type":"structure","members":{"Type":{},"Status":{}}}},"S1e":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{}}},"S1m":{"type":"structure","members":{"PolicySummary":{"shape":"S1n"},"Content":{}}},"S1n":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Description":{},"Type":{},"AwsManaged":{"type":"boolean"}}},"S1w":{"type":"structure","members":{"Id":{},"Arn":{},"Email":{"shape":"Sn"},"Name":{"shape":"So"},"Status":{},"JoinedMethod":{},"JoinedTimestamp":{"type":"timestamp"}}},"S2e":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"PolicyTypes":{"shape":"S16"}}},"S2x":{"type":"list","member":{"shape":"S1w"}},"S3b":{"type":"structure","members":{"ActionType":{},"ParentHandshakeId":{}}},"S3d":{"type":"list","member":{"shape":"S4"}},"S3q":{"type":"list","member":{"shape":"S1n"}},"S3z":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}}}}');

});

parcelRequire.register("6d1jN", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListAWSServiceAccessForOrganization":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListAccounts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListAccountsForParent":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListChildren":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListCreateAccountStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListHandshakesForAccount":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListHandshakesForOrganization":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListOrganizationalUnitsForParent":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListParents":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListPolicies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListPoliciesForTarget":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListRoots":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTagsForResource":{"input_token":"NextToken","output_token":"NextToken","result_key":"Tags"},"ListTargetsForPolicy":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"}}}');

});


parcelRequire.register("2D5Mw", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $1ea3b56055631142$var$Service = $dbC7k.Service;
var $1ea3b56055631142$var$apiLoader = $dbC7k.apiLoader;
$1ea3b56055631142$var$apiLoader.services["rds"] = {};
$dbC7k.RDS = $1ea3b56055631142$var$Service.defineService("rds", [
    "2013-01-10",
    "2013-02-12",
    "2013-09-09",
    "2014-09-01",
    "2014-09-01*",
    "2014-10-31"
]);
parcelRequire("k9uag");


Object.defineProperty($1ea3b56055631142$var$apiLoader.services["rds"], "2013-01-10", {
    get: function get() {
        var model = (parcelRequire("du4Bn"));
        model.paginators = (parcelRequire("lIcLP")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});


Object.defineProperty($1ea3b56055631142$var$apiLoader.services["rds"], "2013-02-12", {
    get: function get() {
        var model = (parcelRequire("5gb3m"));
        model.paginators = (parcelRequire("lFvdG")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});



Object.defineProperty($1ea3b56055631142$var$apiLoader.services["rds"], "2013-09-09", {
    get: function get() {
        var model = (parcelRequire("lI4Lu"));
        model.paginators = (parcelRequire("7s4BJ")).pagination;
        model.waiters = (parcelRequire("1LcNK")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});


Object.defineProperty($1ea3b56055631142$var$apiLoader.services["rds"], "2014-09-01", {
    get: function get() {
        var model = (parcelRequire("bgyLv"));
        model.paginators = (parcelRequire("6boVc")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});



Object.defineProperty($1ea3b56055631142$var$apiLoader.services["rds"], "2014-10-31", {
    get: function get() {
        var model = (parcelRequire("7PxdU"));
        model.paginators = (parcelRequire("eysue")).pagination;
        model.waiters = (parcelRequire("iLacx")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.RDS;

});
parcelRequire.register("k9uag", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
parcelRequire("5pOJW");
/**
  * @api private
  */ var $eabc0bf3d6b0a08f$var$crossRegionOperations = [
    "copyDBSnapshot",
    "createDBInstanceReadReplica",
    "createDBCluster",
    "copyDBClusterSnapshot"
];
$dbC7k.util.update($dbC7k.RDS.prototype, {
    /**
    * @api private
    */ setupRequestListeners: function setupRequestListeners(request) {
        if ($eabc0bf3d6b0a08f$var$crossRegionOperations.indexOf(request.operation) !== -1 && request.params.SourceRegion) {
            request.params = $dbC7k.util.copy(request.params);
            if (request.params.PreSignedUrl || request.params.SourceRegion === this.config.region) delete request.params.SourceRegion;
            else {
                var doesParamValidation = !!this.config.paramValidation;
                // remove the validate parameters listener so we can re-add it after we build the URL
                if (doesParamValidation) request.removeListener("validate", $dbC7k.EventListeners.Core.VALIDATE_PARAMETERS);
                request.onAsync("validate", this.buildCrossRegionPresignedUrl);
                if (doesParamValidation) request.addListener("validate", $dbC7k.EventListeners.Core.VALIDATE_PARAMETERS);
            }
        }
    },
    /**
    * @api private
    */ buildCrossRegionPresignedUrl: function buildCrossRegionPresignedUrl(req, done) {
        var config = $dbC7k.util.copy(req.service.config);
        config.region = req.params.SourceRegion;
        delete req.params.SourceRegion;
        delete config.endpoint;
        // relevant params for the operation will already be in req.params
        delete config.params;
        config.signatureVersion = "v4";
        var destinationRegion = req.service.config.region;
        var svc = new req.service.constructor(config);
        var newReq = svc[req.operation]($dbC7k.util.copy(req.params));
        newReq.on("build", function addDestinationRegionParam(request) {
            var httpRequest = request.httpRequest;
            httpRequest.params.DestinationRegion = destinationRegion;
            httpRequest.body = $dbC7k.util.queryParamsToString(httpRequest.params);
        });
        newReq.presign(function(err, url) {
            if (err) done(err);
            else {
                req.params.PreSignedUrl = url;
                done();
            }
        });
    }
});

});
parcelRequire.register("5pOJW", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
/**
 * @api private
 */ var $3f16a5720094c7a1$var$service = null;
/**
 * @api private
 */ var $3f16a5720094c7a1$var$api = {
    signatureVersion: "v4",
    signingName: "rds-db"
};
/**
 * @api private
 */ var $3f16a5720094c7a1$var$requiredAuthTokenOptions = {
    region: "string",
    hostname: "string",
    port: "number",
    username: "string"
};
/**
 * A signer object can be used to generate an auth token to a database.
 */ $dbC7k.RDS.Signer = $dbC7k.util.inherit({
    /**
     * Creates a signer object can be used to generate an auth token.
     *
     * @option options credentials [AWS.Credentials] the AWS credentials
     *   to sign requests with. Uses the default credential provider chain
     *   if not specified.
     * @option options hostname [String] the hostname of the database to connect to.
     * @option options port [Number] the port number the database is listening on.
     * @option options region [String] the region the database is located in.
     * @option options username [String] the username to login as.
     * @example Passing in options to constructor
     *   var signer = new AWS.RDS.Signer({
     *     credentials: new AWS.SharedIniFileCredentials({profile: 'default'}),
     *     region: 'us-east-1',
     *     hostname: 'db.us-east-1.rds.amazonaws.com',
     *     port: 8000,
     *     username: 'name'
     *   });
     */ constructor: function Signer(options) {
        this.options = options || {};
    },
    /**
     * @api private
     * Strips the protocol from a url.
     */ convertUrlToAuthToken: function convertUrlToAuthToken(url) {
        // we are always using https as the protocol
        var protocol = "https://";
        if (url.indexOf(protocol) === 0) return url.substring(protocol.length);
    },
    /**
     * @overload getAuthToken(options = {}, [callback])
     *   Generate an auth token to a database.
     *   @note You must ensure that you have static or previously resolved
     *     credentials if you call this method synchronously (with no callback),
     *     otherwise it may not properly sign the request. If you cannot guarantee
     *     this (you are using an asynchronous credential provider, i.e., EC2
     *     IAM roles), you should always call this method with an asynchronous
     *     callback.
     *
     *   @param options [map] The fields to use when generating an auth token.
     *     Any options specified here will be merged on top of any options passed
     *     to AWS.RDS.Signer:
     *
     *     * **credentials** (AWS.Credentials) &mdash; the AWS credentials
     *         to sign requests with. Uses the default credential provider chain
     *         if not specified.
     *     * **hostname** (String) &mdash; the hostname of the database to connect to.
     *     * **port** (Number) &mdash; the port number the database is listening on.
     *     * **region** (String) &mdash; the region the database is located in.
     *     * **username** (String) &mdash; the username to login as.
     *   @return [String] if called synchronously (with no callback), returns the
     *     auth token.
     *   @return [null] nothing is returned if a callback is provided.
     *   @callback callback function (err, token)
     *     If a callback is supplied, it is called when an auth token has been generated.
     *     @param err [Error] the error object returned from the signer.
     *     @param token [String] the auth token.
     *
     *   @example Generating an auth token synchronously
     *     var signer = new AWS.RDS.Signer({
     *       // configure options
     *       region: 'us-east-1',
     *       username: 'default',
     *       hostname: 'db.us-east-1.amazonaws.com',
     *       port: 8000
     *     });
     *     var token = signer.getAuthToken({
     *       // these options are merged with those defined when creating the signer, overriding in the case of a duplicate option
     *       // credentials are not specified here or when creating the signer, so default credential provider will be used
     *       username: 'test' // overriding username
     *     });
     *   @example Generating an auth token asynchronously
     *     var signer = new AWS.RDS.Signer({
     *       // configure options
     *       region: 'us-east-1',
     *       username: 'default',
     *       hostname: 'db.us-east-1.amazonaws.com',
     *       port: 8000
     *     });
     *     signer.getAuthToken({
     *       // these options are merged with those defined when creating the signer, overriding in the case of a duplicate option
     *       // credentials are not specified here or when creating the signer, so default credential provider will be used
     *       username: 'test' // overriding username
     *     }, function(err, token) {
     *       if (err) {
     *         // handle error
     *       } else {
     *         // use token
     *       }
     *     });
     *
     */ getAuthToken: function getAuthToken(options, callback) {
        if (typeof options === "function" && callback === undefined) {
            callback = options;
            options = {};
        }
        var self = this;
        var hasCallback = typeof callback === "function";
        // merge options with existing options
        options = $dbC7k.util.merge(this.options, options);
        // validate options
        var optionsValidation = this.validateAuthTokenOptions(options);
        if (optionsValidation !== true) {
            if (hasCallback) return callback(optionsValidation, null);
            throw optionsValidation;
        }
        // 15 minutes
        var expires = 900;
        // create service to generate a request from
        var serviceOptions = {
            region: options.region,
            endpoint: new $dbC7k.Endpoint(options.hostname + ":" + options.port),
            paramValidation: false,
            signatureVersion: "v4"
        };
        if (options.credentials) serviceOptions.credentials = options.credentials;
        $3f16a5720094c7a1$var$service = new $dbC7k.Service(serviceOptions);
        // ensure the SDK is using sigv4 signing (config is not enough)
        $3f16a5720094c7a1$var$service.api = $3f16a5720094c7a1$var$api;
        var request = $3f16a5720094c7a1$var$service.makeRequest();
        // add listeners to request to properly build auth token
        this.modifyRequestForAuthToken(request, options);
        if (hasCallback) request.presign(expires, function(err, url) {
            if (url) url = self.convertUrlToAuthToken(url);
            callback(err, url);
        });
        else {
            var url = request.presign(expires);
            return this.convertUrlToAuthToken(url);
        }
    },
    /**
     * @api private
     * Modifies a request to allow the presigner to generate an auth token.
     */ modifyRequestForAuthToken: function modifyRequestForAuthToken(request, options) {
        request.on("build", request.buildAsGet);
        var httpRequest = request.httpRequest;
        httpRequest.body = $dbC7k.util.queryParamsToString({
            Action: "connect",
            DBUser: options.username
        });
    },
    /**
     * @api private
     * Validates that the options passed in contain all the keys with values of the correct type that
     *   are needed to generate an auth token.
     */ validateAuthTokenOptions: function validateAuthTokenOptions(options) {
        // iterate over all keys in options
        var message = "";
        options = options || {};
        for(var key in $3f16a5720094c7a1$var$requiredAuthTokenOptions){
            if (!Object.prototype.hasOwnProperty.call($3f16a5720094c7a1$var$requiredAuthTokenOptions, key)) continue;
            if (typeof options[key] !== $3f16a5720094c7a1$var$requiredAuthTokenOptions[key]) message += "option '" + key + "' should have been type '" + $3f16a5720094c7a1$var$requiredAuthTokenOptions[key] + "', was '" + typeof options[key] + "'.\n";
        }
        if (message.length) return $dbC7k.util.error(new Error(), {
            code: "InvalidParameter",
            message: message
        });
        return true;
    }
});

});


parcelRequire.register("du4Bn", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2013-01-10","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2013-01-10","xmlNamespace":"http://rds.amazonaws.com/doc/2013-01-10/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S1c"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1i"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1o"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S25"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S25","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"St","locationName":"DBInstance"}}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S1c","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2f"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sk","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S11","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2f"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1o","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S14","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S3m","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S3o"}},"wrapper":true}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2f"}}},"output":{"shape":"S3z","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1i"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sp"},"VpcSecurityGroupMemberships":{"shape":"Sq"}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1o"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S3m"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2f"}}},"output":{"shape":"S3z","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"Id":{},"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"St":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sv"},"VpcSecurityGroups":{"shape":"Sx"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S11"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMembership":{"type":"structure","members":{"OptionGroupName":{},"Status":{}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"}},"wrapper":true},"Sv":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"Sx":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S11":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S14"},"SubnetStatus":{}}}}},"wrapper":true},"S14":{"type":"structure","members":{"Name":{},"ProvisionedIopsCapable":{"type":"boolean"}},"wrapper":true},"S1c":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"S1i":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1o":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sv"},"VpcSecurityGroupMemberships":{"shape":"Sx"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"S25":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2f":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S3m":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S3o"}},"wrapper":true},"S3o":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S3z":{"type":"structure","members":{"DBParameterGroupName":{}}}}}');

});

parcelRequire.register("lIcLP", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"ListTagsForResource":{"result_key":"TagList"}}}');

});

parcelRequire.register("5gb3m", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2013-02-12","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2013-02-12","xmlNamespace":"http://rds.amazonaws.com/doc/2013-02-12/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S1d"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1j"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1p"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S28"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S28","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"St","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S1d","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2n"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sk","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S11","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2n"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"Persistent":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1p","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S14","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S3w","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S3y"}},"wrapper":true}}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2n"}}},"output":{"shape":"S4b","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1j"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sp"},"VpcSecurityGroupMemberships":{"shape":"Sq"},"OptionSettings":{"type":"list","member":{"shape":"S1t","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1p"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S3w"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2n"}}},"output":{"shape":"S4b","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"St":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sv"},"VpcSecurityGroups":{"shape":"Sx"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S11"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"}},"wrapper":true},"Sv":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"Sx":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S11":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S14"},"SubnetStatus":{}}}}},"wrapper":true},"S14":{"type":"structure","members":{"Name":{},"ProvisionedIopsCapable":{"type":"boolean"}},"wrapper":true},"S1d":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"S1j":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1p":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Port":{"type":"integer"},"OptionSettings":{"type":"list","member":{"shape":"S1t","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"Sv"},"VpcSecurityGroupMemberships":{"shape":"Sx"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"S1t":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"S28":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2n":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S3w":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S3y"}},"wrapper":true},"S3y":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S4b":{"type":"structure","members":{"DBParameterGroupName":{}}}}}');

});

parcelRequire.register("lFvdG", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBLogFiles":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DescribeDBLogFiles"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"DownloadDBLogFilePortion":{"input_token":"Marker","limit_key":"NumberOfLines","more_results":"AdditionalDataPending","output_token":"Marker","result_key":"LogFileData"},"ListTagsForResource":{"result_key":"TagList"}}}');

});

parcelRequire.register("lI4Lu", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2013-09-09","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2013-09-09","xmlNamespace":"http://rds.amazonaws.com/doc/2013-09-09/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"},"DBSubnetGroupName":{}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S1f"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1l"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1r"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S2d"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S2d","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"St","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S1f","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2s"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sk","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S11","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2s"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S27"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Filters":{"shape":"S27"},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1r","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S14","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S41","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S43"}},"wrapper":true}}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S27"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2s"}}},"output":{"shape":"S4g","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1l"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sp"},"VpcSecurityGroupMemberships":{"shape":"Sq"},"OptionSettings":{"type":"list","member":{"shape":"S1v","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1r"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S41"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2s"}}},"output":{"shape":"S4g","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PercentProgress":{"type":"integer"},"SourceRegion":{}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"St":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sv"},"VpcSecurityGroups":{"shape":"Sx"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S11"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}}},"wrapper":true},"Sv":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"Sx":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S11":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S14"},"SubnetStatus":{}}}}},"wrapper":true},"S14":{"type":"structure","members":{"Name":{},"ProvisionedIopsCapable":{"type":"boolean"}},"wrapper":true},"S1f":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"S1l":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1r":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"Port":{"type":"integer"},"OptionSettings":{"type":"list","member":{"shape":"S1v","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"Sv"},"VpcSecurityGroupMemberships":{"shape":"Sx"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"S1v":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"S27":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S2d":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2s":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S41":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S43"}},"wrapper":true},"S43":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S4g":{"type":"structure","members":{"DBParameterGroupName":{}}}}}');

});

parcelRequire.register("7s4BJ", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBLogFiles":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DescribeDBLogFiles"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"DownloadDBLogFilePortion":{"input_token":"Marker","limit_key":"NumberOfLines","more_results":"AdditionalDataPending","output_token":"Marker","result_key":"LogFileData"},"ListTagsForResource":{"result_key":"TagList"}}}');

});

parcelRequire.register("1LcNK", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"DBInstanceAvailable":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBInstanceDeleted":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]}}}');

});

parcelRequire.register("bgyLv", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2014-09-01","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2014-09-01","xmlNamespace":"http://rds.amazonaws.com/doc/2014-09-01/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBParameterGroup":{"input":{"type":"structure","required":["SourceDBParameterGroupIdentifier","TargetDBParameterGroupIdentifier","TargetDBParameterGroupDescription"],"members":{"SourceDBParameterGroupIdentifier":{},"TargetDBParameterGroupIdentifier":{},"TargetDBParameterGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"Sk"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sn"}}}},"CopyOptionGroup":{"input":{"type":"structure","required":["SourceOptionGroupIdentifier","TargetOptionGroupIdentifier","TargetOptionGroupDescription"],"members":{"SourceOptionGroupIdentifier":{},"TargetOptionGroupIdentifier":{},"TargetOptionGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"St"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"S13"},"VpcSecurityGroupIds":{"shape":"S14"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"},"DBSubnetGroupName":{},"StorageType":{}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"Sk"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sn"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1u"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S1b"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"St"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sn"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S2h"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S2h","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"S17","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"Sk","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2w"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sn","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S1b","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2w"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S2b"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Filters":{"shape":"S2b"},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"St","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S1e","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"},"StorageType":{},"SupportsIops":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S45","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S47"}},"wrapper":true}}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S2b"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"S13"},"VpcSecurityGroupIds":{"shape":"S14"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2w"}}},"output":{"shape":"S4k","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1u"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S1b"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"S13"},"VpcSecurityGroupMemberships":{"shape":"S14"},"OptionSettings":{"type":"list","member":{"shape":"Sx","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"St"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S45"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2w"}}},"output":{"shape":"S4k","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"Sn":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PercentProgress":{"type":"integer"},"SourceRegion":{},"StorageType":{},"TdeCredentialArn":{}},"wrapper":true},"St":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"Port":{"type":"integer"},"OptionSettings":{"type":"list","member":{"shape":"Sx","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"Sy"},"VpcSecurityGroupMemberships":{"shape":"S10"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"Sx":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"Sy":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"S10":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S13":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"S14":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"S17":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sy"},"VpcSecurityGroups":{"shape":"S10"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S1b"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{},"StorageType":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}},"StorageType":{},"TdeCredentialArn":{}},"wrapper":true},"S1b":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S1e"},"SubnetStatus":{}}}}},"wrapper":true},"S1e":{"type":"structure","members":{"Name":{}},"wrapper":true},"S1u":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S2b":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S2h":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2w":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S45":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S47"}},"wrapper":true},"S47":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S4k":{"type":"structure","members":{"DBParameterGroupName":{}}}}}');

});

parcelRequire.register("6boVc", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});

parcelRequire.register("7PxdU", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2014-10-31","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2014-10-31","xmlNamespace":"http://rds.amazonaws.com/doc/2014-10-31/"},"operations":{"AddRoleToDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","RoleArn"],"members":{"DBClusterIdentifier":{},"RoleArn":{},"FeatureName":{}}}},"AddRoleToDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","RoleArn","FeatureName"],"members":{"DBInstanceIdentifier":{},"RoleArn":{},"FeatureName":{}}}},"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S6"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"Sb"}}}},"ApplyPendingMaintenanceAction":{"input":{"type":"structure","required":["ResourceIdentifier","ApplyAction","OptInType"],"members":{"ResourceIdentifier":{},"ApplyAction":{},"OptInType":{}}},"output":{"resultWrapper":"ApplyPendingMaintenanceActionResult","type":"structure","members":{"ResourcePendingMaintenanceActions":{"shape":"Sf"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sl"}}}},"BacktrackDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","BacktrackTo"],"members":{"DBClusterIdentifier":{},"BacktrackTo":{"type":"timestamp"},"Force":{"type":"boolean"},"UseEarliestTimeOnPointInTimeUnavailable":{"type":"boolean"}}},"output":{"shape":"Ss","resultWrapper":"BacktrackDBClusterResult"}},"CopyDBClusterParameterGroup":{"input":{"type":"structure","required":["SourceDBClusterParameterGroupIdentifier","TargetDBClusterParameterGroupIdentifier","TargetDBClusterParameterGroupDescription"],"members":{"SourceDBClusterParameterGroupIdentifier":{},"TargetDBClusterParameterGroupIdentifier":{},"TargetDBClusterParameterGroupDescription":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CopyDBClusterParameterGroupResult","type":"structure","members":{"DBClusterParameterGroup":{"shape":"Sv"}}}},"CopyDBClusterSnapshot":{"input":{"type":"structure","required":["SourceDBClusterSnapshotIdentifier","TargetDBClusterSnapshotIdentifier"],"members":{"SourceDBClusterSnapshotIdentifier":{},"TargetDBClusterSnapshotIdentifier":{},"KmsKeyId":{},"PreSignedUrl":{},"CopyTags":{"type":"boolean"},"Tags":{"shape":"Sb"},"SourceRegion":{}}},"output":{"resultWrapper":"CopyDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"Sy"}}}},"CopyDBParameterGroup":{"input":{"type":"structure","required":["SourceDBParameterGroupIdentifier","TargetDBParameterGroupIdentifier","TargetDBParameterGroupDescription"],"members":{"SourceDBParameterGroupIdentifier":{},"TargetDBParameterGroupIdentifier":{},"TargetDBParameterGroupDescription":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CopyDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S13"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{},"KmsKeyId":{},"Tags":{"shape":"Sb"},"CopyTags":{"type":"boolean"},"PreSignedUrl":{},"OptionGroupName":{},"SourceRegion":{}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S16"}}}},"CopyOptionGroup":{"input":{"type":"structure","required":["SourceOptionGroupIdentifier","TargetOptionGroupIdentifier","TargetOptionGroupDescription"],"members":{"SourceOptionGroupIdentifier":{},"TargetOptionGroupIdentifier":{},"TargetOptionGroupDescription":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CopyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1c"}}}},"CreateDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","Engine"],"members":{"AvailabilityZones":{"shape":"Sz"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"S1m"},"DBSubnetGroupName":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"MasterUsername":{},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"ReplicationSourceIdentifier":{},"Tags":{"shape":"Sb"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"PreSignedUrl":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"BacktrackWindow":{"type":"long"},"EnableCloudwatchLogsExports":{"shape":"S1o"},"EngineMode":{},"ScalingConfiguration":{"shape":"S1p"},"DeletionProtection":{"type":"boolean"},"GlobalClusterIdentifier":{},"EnableHttpEndpoint":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"},"SourceRegion":{}}},"output":{"resultWrapper":"CreateDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1r"}}}},"CreateDBClusterEndpoint":{"input":{"type":"structure","required":["DBClusterIdentifier","DBClusterEndpointIdentifier","EndpointType"],"members":{"DBClusterIdentifier":{},"DBClusterEndpointIdentifier":{},"EndpointType":{},"StaticMembers":{"shape":"S1s"},"ExcludedMembers":{"shape":"S1s"}}},"output":{"shape":"S24","resultWrapper":"CreateDBClusterEndpointResult"}},"CreateDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBClusterParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBClusterParameterGroupResult","type":"structure","members":{"DBClusterParameterGroup":{"shape":"Sv"}}}},"CreateDBClusterSnapshot":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier","DBClusterIdentifier"],"members":{"DBClusterSnapshotIdentifier":{},"DBClusterIdentifier":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"Sy"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBInstanceClass","Engine"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"S2a"},"VpcSecurityGroupIds":{"shape":"S1m"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"Sb"},"DBClusterIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"Domain":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"DomainIAMRoleName":{},"PromotionTier":{"type":"integer"},"Timezone":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"EnableCloudwatchLogsExports":{"shape":"S1o"},"ProcessorFeatures":{"shape":"S18"},"DeletionProtection":{"type":"boolean"},"MaxAllocatedStorage":{"type":"integer"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S2c"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"Sb"},"DBSubnetGroupName":{},"VpcSecurityGroupIds":{"shape":"S1m"},"StorageType":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"KmsKeyId":{},"PreSignedUrl":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"EnableCloudwatchLogsExports":{"shape":"S1o"},"ProcessorFeatures":{"shape":"S18"},"UseDefaultProcessorFeatures":{"type":"boolean"},"DeletionProtection":{"type":"boolean"},"SourceRegion":{}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S2c"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S13"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sl"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S16"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S35"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S2g"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S8"},"SourceIds":{"shape":"S7"},"Enabled":{"type":"boolean"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S6"}}}},"CreateGlobalCluster":{"input":{"type":"structure","members":{"GlobalClusterIdentifier":{},"SourceDBClusterIdentifier":{},"Engine":{},"EngineVersion":{},"DeletionProtection":{"type":"boolean"},"DatabaseName":{},"StorageEncrypted":{"type":"boolean"}}},"output":{"resultWrapper":"CreateGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S3b"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1c"}}}},"DeleteDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1r"}}}},"DeleteDBClusterEndpoint":{"input":{"type":"structure","required":["DBClusterEndpointIdentifier"],"members":{"DBClusterEndpointIdentifier":{}}},"output":{"shape":"S24","resultWrapper":"DeleteDBClusterEndpointResult"}},"DeleteDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{}}}},"DeleteDBClusterSnapshot":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier"],"members":{"DBClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"Sy"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{},"DeleteAutomatedBackups":{"type":"boolean"}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S2c"}}}},"DeleteDBInstanceAutomatedBackup":{"input":{"type":"structure","required":["DbiResourceId"],"members":{"DbiResourceId":{}}},"output":{"resultWrapper":"DeleteDBInstanceAutomatedBackupResult","type":"structure","members":{"DBInstanceAutomatedBackup":{"shape":"S3r"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S16"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S6"}}}},"DeleteGlobalCluster":{"input":{"type":"structure","required":["GlobalClusterIdentifier"],"members":{"GlobalClusterIdentifier":{}}},"output":{"resultWrapper":"DeleteGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S3b"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeAccountAttributes":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"DescribeAccountAttributesResult","type":"structure","members":{"AccountQuotas":{"type":"list","member":{"locationName":"AccountQuota","type":"structure","members":{"AccountQuotaName":{},"Used":{"type":"long"},"Max":{"type":"long"}},"wrapper":true}}}}},"DescribeCertificates":{"input":{"type":"structure","members":{"CertificateIdentifier":{},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCertificatesResult","type":"structure","members":{"Certificates":{"type":"list","member":{"locationName":"Certificate","type":"structure","members":{"CertificateIdentifier":{},"CertificateType":{},"Thumbprint":{},"ValidFrom":{"type":"timestamp"},"ValidTill":{"type":"timestamp"},"CertificateArn":{}},"wrapper":true}},"Marker":{}}}},"DescribeDBClusterBacktracks":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"BacktrackIdentifier":{},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterBacktracksResult","type":"structure","members":{"Marker":{},"DBClusterBacktracks":{"type":"list","member":{"shape":"Ss","locationName":"DBClusterBacktrack"}}}}},"DescribeDBClusterEndpoints":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"DBClusterEndpointIdentifier":{},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterEndpointsResult","type":"structure","members":{"Marker":{},"DBClusterEndpoints":{"type":"list","member":{"shape":"S24","locationName":"DBClusterEndpointList"}}}}},"DescribeDBClusterParameterGroups":{"input":{"type":"structure","members":{"DBClusterParameterGroupName":{},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterParameterGroupsResult","type":"structure","members":{"Marker":{},"DBClusterParameterGroups":{"type":"list","member":{"shape":"Sv","locationName":"DBClusterParameterGroup"}}}}},"DescribeDBClusterParameters":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{},"Source":{},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterParametersResult","type":"structure","members":{"Parameters":{"shape":"S4q"},"Marker":{}}}},"DescribeDBClusterSnapshotAttributes":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier"],"members":{"DBClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DescribeDBClusterSnapshotAttributesResult","type":"structure","members":{"DBClusterSnapshotAttributesResult":{"shape":"S4w"}}}},"DescribeDBClusterSnapshots":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"DBClusterSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{},"IncludeShared":{"type":"boolean"},"IncludePublic":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBClusterSnapshotsResult","type":"structure","members":{"Marker":{},"DBClusterSnapshots":{"type":"list","member":{"shape":"Sy","locationName":"DBClusterSnapshot"}}}}},"DescribeDBClusters":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{},"IncludeShared":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBClustersResult","type":"structure","members":{"Marker":{},"DBClusters":{"type":"list","member":{"shape":"S1r","locationName":"DBCluster"}}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"},"ListSupportedTimezones":{"type":"boolean"},"IncludeAll":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S5a"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S5a","locationName":"CharacterSet"}},"ValidUpgradeTarget":{"type":"list","member":{"locationName":"UpgradeTarget","type":"structure","members":{"Engine":{},"EngineVersion":{},"Description":{},"AutoUpgrade":{"type":"boolean"},"IsMajorVersionUpgrade":{"type":"boolean"}}}},"SupportedTimezones":{"type":"list","member":{"locationName":"Timezone","type":"structure","members":{"TimezoneName":{}}}},"ExportableLogTypes":{"shape":"S1o"},"SupportsLogExportsToCloudwatchLogs":{"type":"boolean"},"SupportsReadReplica":{"type":"boolean"},"SupportedEngineModes":{"shape":"S4t"},"SupportedFeatureNames":{"type":"list","member":{}},"Status":{}}}}}}},"DescribeDBInstanceAutomatedBackups":{"input":{"type":"structure","members":{"DbiResourceId":{},"DBInstanceIdentifier":{},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstanceAutomatedBackupsResult","type":"structure","members":{"Marker":{},"DBInstanceAutomatedBackups":{"type":"list","member":{"shape":"S3r","locationName":"DBInstanceAutomatedBackup"}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"S2c","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S13","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S4q"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sl","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshotAttributes":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DescribeDBSnapshotAttributesResult","type":"structure","members":{"DBSnapshotAttributesResult":{"shape":"S61"}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{},"IncludeShared":{"type":"boolean"},"IncludePublic":{"type":"boolean"},"DbiResourceId":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"S16","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S2g","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultClusterParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultClusterParametersResult","type":"structure","members":{"EngineDefaults":{"shape":"S6c"}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"shape":"S6c"}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S49"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S8"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S6","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S8"},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S8"},"Date":{"type":"timestamp"},"SourceArn":{}}}}}}},"DescribeGlobalClusters":{"input":{"type":"structure","members":{"GlobalClusterIdentifier":{},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeGlobalClustersResult","type":"structure","members":{"Marker":{},"GlobalClusters":{"type":"list","member":{"shape":"S3b","locationName":"GlobalClusterMember"}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"OptionsConflictsWith":{"type":"list","member":{"locationName":"OptionConflictName"}},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"RequiresAutoMinorEngineVersionUpgrade":{"type":"boolean"},"VpcOnly":{"type":"boolean"},"SupportsOptionVersionDowngrade":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsRequired":{"type":"boolean"},"MinimumEngineVersionPerAllowedValue":{"type":"list","member":{"locationName":"MinimumEngineVersionPerAllowedValue","type":"structure","members":{"AllowedValue":{},"MinimumEngineVersion":{}}}}}}},"OptionGroupOptionVersions":{"type":"list","member":{"locationName":"OptionVersion","type":"structure","members":{"Version":{},"IsDefault":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Filters":{"shape":"S49"},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1c","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S2j","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"},"SupportsStorageEncryption":{"type":"boolean"},"StorageType":{},"SupportsIops":{"type":"boolean"},"SupportsEnhancedMonitoring":{"type":"boolean"},"SupportsIAMDatabaseAuthentication":{"type":"boolean"},"SupportsPerformanceInsights":{"type":"boolean"},"MinStorageSize":{"type":"integer"},"MaxStorageSize":{"type":"integer"},"MinIopsPerDbInstance":{"type":"integer"},"MaxIopsPerDbInstance":{"type":"integer"},"MinIopsPerGib":{"type":"double"},"MaxIopsPerGib":{"type":"double"},"AvailableProcessorFeatures":{"shape":"S7f"},"SupportedEngineModes":{"shape":"S4t"},"SupportsStorageAutoscaling":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribePendingMaintenanceActions":{"input":{"type":"structure","members":{"ResourceIdentifier":{},"Filters":{"shape":"S49"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribePendingMaintenanceActionsResult","type":"structure","members":{"PendingMaintenanceActions":{"type":"list","member":{"shape":"Sf","locationName":"ResourcePendingMaintenanceActions"}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S7n","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S49"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S7p"}},"wrapper":true}}}}},"DescribeSourceRegions":{"input":{"type":"structure","members":{"RegionName":{},"MaxRecords":{"type":"integer"},"Marker":{},"Filters":{"shape":"S49"}}},"output":{"resultWrapper":"DescribeSourceRegionsResult","type":"structure","members":{"Marker":{},"SourceRegions":{"type":"list","member":{"locationName":"SourceRegion","type":"structure","members":{"RegionName":{},"Endpoint":{},"Status":{}}}}}}},"DescribeValidDBInstanceModifications":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"DescribeValidDBInstanceModificationsResult","type":"structure","members":{"ValidDBInstanceModificationsMessage":{"type":"structure","members":{"Storage":{"type":"list","member":{"locationName":"ValidStorageOptions","type":"structure","members":{"StorageType":{},"StorageSize":{"shape":"S84"},"ProvisionedIops":{"shape":"S84"},"IopsToStorageRatio":{"type":"list","member":{"locationName":"DoubleRange","type":"structure","members":{"From":{"type":"double"},"To":{"type":"double"}}}},"SupportsStorageAutoscaling":{"type":"boolean"}}}},"ValidProcessorFeatures":{"shape":"S7f"}},"wrapper":true}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"FailoverDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"TargetDBInstanceIdentifier":{}}},"output":{"resultWrapper":"FailoverDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1r"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S49"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"Sb"}}}},"ModifyCurrentDBClusterCapacity":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"Capacity":{"type":"integer"},"SecondsBeforeTimeout":{"type":"integer"},"TimeoutAction":{}}},"output":{"resultWrapper":"ModifyCurrentDBClusterCapacityResult","type":"structure","members":{"DBClusterIdentifier":{},"PendingCapacity":{"type":"integer"},"CurrentCapacity":{"type":"integer"},"SecondsBeforeTimeout":{"type":"integer"},"TimeoutAction":{}}}},"ModifyDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"NewDBClusterIdentifier":{},"ApplyImmediately":{"type":"boolean"},"BackupRetentionPeriod":{"type":"integer"},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"S1m"},"Port":{"type":"integer"},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"BacktrackWindow":{"type":"long"},"CloudwatchLogsExportConfiguration":{"shape":"S8h"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"DBInstanceParameterGroupName":{},"ScalingConfiguration":{"shape":"S1p"},"DeletionProtection":{"type":"boolean"},"EnableHttpEndpoint":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1r"}}}},"ModifyDBClusterEndpoint":{"input":{"type":"structure","required":["DBClusterEndpointIdentifier"],"members":{"DBClusterEndpointIdentifier":{},"EndpointType":{},"StaticMembers":{"shape":"S1s"},"ExcludedMembers":{"shape":"S1s"}}},"output":{"shape":"S24","resultWrapper":"ModifyDBClusterEndpointResult"}},"ModifyDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName","Parameters"],"members":{"DBClusterParameterGroupName":{},"Parameters":{"shape":"S4q"}}},"output":{"shape":"S8l","resultWrapper":"ModifyDBClusterParameterGroupResult"}},"ModifyDBClusterSnapshotAttribute":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier","AttributeName"],"members":{"DBClusterSnapshotIdentifier":{},"AttributeName":{},"ValuesToAdd":{"shape":"S4z"},"ValuesToRemove":{"shape":"S4z"}}},"output":{"resultWrapper":"ModifyDBClusterSnapshotAttributeResult","type":"structure","members":{"DBClusterSnapshotAttributesResult":{"shape":"S4w"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSubnetGroupName":{},"DBSecurityGroups":{"shape":"S2a"},"VpcSecurityGroupIds":{"shape":"S1m"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"CACertificateIdentifier":{},"Domain":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"DBPortNumber":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"MonitoringRoleArn":{},"DomainIAMRoleName":{},"PromotionTier":{"type":"integer"},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"CloudwatchLogsExportConfiguration":{"shape":"S8h"},"ProcessorFeatures":{"shape":"S18"},"UseDefaultProcessorFeatures":{"type":"boolean"},"DeletionProtection":{"type":"boolean"},"MaxAllocatedStorage":{"type":"integer"}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S2c"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S4q"}}},"output":{"shape":"S8r","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{},"EngineVersion":{},"OptionGroupName":{}}},"output":{"resultWrapper":"ModifyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S16"}}}},"ModifyDBSnapshotAttribute":{"input":{"type":"structure","required":["DBSnapshotIdentifier","AttributeName"],"members":{"DBSnapshotIdentifier":{},"AttributeName":{},"ValuesToAdd":{"shape":"S4z"},"ValuesToRemove":{"shape":"S4z"}}},"output":{"resultWrapper":"ModifyDBSnapshotAttributeResult","type":"structure","members":{"DBSnapshotAttributesResult":{"shape":"S61"}}}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S35"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S2g"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S8"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S6"}}}},"ModifyGlobalCluster":{"input":{"type":"structure","members":{"GlobalClusterIdentifier":{},"NewGlobalClusterIdentifier":{},"DeletionProtection":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S3b"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"OptionVersion":{},"DBSecurityGroupMemberships":{"shape":"S2a"},"VpcSecurityGroupMemberships":{"shape":"S1m"},"OptionSettings":{"type":"list","member":{"shape":"S1g","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1c"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S2c"}}}},"PromoteReadReplicaDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"PromoteReadReplicaDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1r"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S7n"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S2c"}}}},"RemoveFromGlobalCluster":{"input":{"type":"structure","members":{"GlobalClusterIdentifier":{},"DbClusterIdentifier":{}}},"output":{"resultWrapper":"RemoveFromGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S3b"}}}},"RemoveRoleFromDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","RoleArn"],"members":{"DBClusterIdentifier":{},"RoleArn":{},"FeatureName":{}}}},"RemoveRoleFromDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","RoleArn","FeatureName"],"members":{"DBInstanceIdentifier":{},"RoleArn":{},"FeatureName":{}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S6"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S4q"}}},"output":{"shape":"S8l","resultWrapper":"ResetDBClusterParameterGroupResult"}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S4q"}}},"output":{"shape":"S8r","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBClusterFromS3":{"input":{"type":"structure","required":["DBClusterIdentifier","Engine","MasterUsername","MasterUserPassword","SourceEngine","SourceEngineVersion","S3BucketName","S3IngestionRoleArn"],"members":{"AvailabilityZones":{"shape":"Sz"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"S1m"},"DBSubnetGroupName":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"MasterUsername":{},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"Tags":{"shape":"Sb"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"SourceEngine":{},"SourceEngineVersion":{},"S3BucketName":{},"S3Prefix":{},"S3IngestionRoleArn":{},"BacktrackWindow":{"type":"long"},"EnableCloudwatchLogsExports":{"shape":"S1o"},"DeletionProtection":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreDBClusterFromS3Result","type":"structure","members":{"DBCluster":{"shape":"S1r"}}}},"RestoreDBClusterFromSnapshot":{"input":{"type":"structure","required":["DBClusterIdentifier","SnapshotIdentifier","Engine"],"members":{"AvailabilityZones":{"shape":"Sz"},"DBClusterIdentifier":{},"SnapshotIdentifier":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"DBSubnetGroupName":{},"DatabaseName":{},"OptionGroupName":{},"VpcSecurityGroupIds":{"shape":"S1m"},"Tags":{"shape":"Sb"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"BacktrackWindow":{"type":"long"},"EnableCloudwatchLogsExports":{"shape":"S1o"},"EngineMode":{},"ScalingConfiguration":{"shape":"S1p"},"DBClusterParameterGroupName":{},"DeletionProtection":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreDBClusterFromSnapshotResult","type":"structure","members":{"DBCluster":{"shape":"S1r"}}}},"RestoreDBClusterToPointInTime":{"input":{"type":"structure","required":["DBClusterIdentifier","SourceDBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"RestoreType":{},"SourceDBClusterIdentifier":{},"RestoreToTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"Port":{"type":"integer"},"DBSubnetGroupName":{},"OptionGroupName":{},"VpcSecurityGroupIds":{"shape":"S1m"},"Tags":{"shape":"Sb"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"BacktrackWindow":{"type":"long"},"EnableCloudwatchLogsExports":{"shape":"S1o"},"DBClusterParameterGroupName":{},"DeletionProtection":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreDBClusterToPointInTimeResult","type":"structure","members":{"DBCluster":{"shape":"S1r"}}}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"Sb"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"VpcSecurityGroupIds":{"shape":"S1m"},"Domain":{},"CopyTagsToSnapshot":{"type":"boolean"},"DomainIAMRoleName":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnableCloudwatchLogsExports":{"shape":"S1o"},"ProcessorFeatures":{"shape":"S18"},"UseDefaultProcessorFeatures":{"type":"boolean"},"DBParameterGroupName":{},"DeletionProtection":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"S2c"}}}},"RestoreDBInstanceFromS3":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBInstanceClass","Engine","SourceEngine","SourceEngineVersion","S3BucketName","S3IngestionRoleArn"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"S2a"},"VpcSecurityGroupIds":{"shape":"S1m"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"Sb"},"StorageType":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"SourceEngine":{},"SourceEngineVersion":{},"S3BucketName":{},"S3Prefix":{},"S3IngestionRoleArn":{},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"EnableCloudwatchLogsExports":{"shape":"S1o"},"ProcessorFeatures":{"shape":"S18"},"UseDefaultProcessorFeatures":{"type":"boolean"},"DeletionProtection":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreDBInstanceFromS3Result","type":"structure","members":{"DBInstance":{"shape":"S2c"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CopyTagsToSnapshot":{"type":"boolean"},"Tags":{"shape":"Sb"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"VpcSecurityGroupIds":{"shape":"S1m"},"Domain":{},"DomainIAMRoleName":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnableCloudwatchLogsExports":{"shape":"S1o"},"ProcessorFeatures":{"shape":"S18"},"UseDefaultProcessorFeatures":{"type":"boolean"},"DBParameterGroupName":{},"DeletionProtection":{"type":"boolean"},"SourceDbiResourceId":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"S2c"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sl"}}}},"StartActivityStream":{"input":{"type":"structure","required":["ResourceArn","Mode","KmsKeyId"],"members":{"ResourceArn":{},"Mode":{},"KmsKeyId":{},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"StartActivityStreamResult","type":"structure","members":{"KmsKeyId":{},"KinesisStreamName":{},"Status":{},"Mode":{},"ApplyImmediately":{"type":"boolean"}}}},"StartDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"StartDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1r"}}}},"StartDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"StartDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S2c"}}}},"StopActivityStream":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"StopActivityStreamResult","type":"structure","members":{"KmsKeyId":{},"KinesisStreamName":{},"Status":{}}}},"StopDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"StopDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S1r"}}}},"StopDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"StopDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S2c"}}}}},"shapes":{"S6":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S7"},"EventCategoriesList":{"shape":"S8"},"Enabled":{"type":"boolean"},"EventSubscriptionArn":{}},"wrapper":true},"S7":{"type":"list","member":{"locationName":"SourceId"}},"S8":{"type":"list","member":{"locationName":"EventCategory"}},"Sb":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sf":{"type":"structure","members":{"ResourceIdentifier":{},"PendingMaintenanceActionDetails":{"type":"list","member":{"locationName":"PendingMaintenanceAction","type":"structure","members":{"Action":{},"AutoAppliedAfterDate":{"type":"timestamp"},"ForcedApplyDate":{"type":"timestamp"},"OptInStatus":{},"CurrentApplyDate":{"type":"timestamp"},"Description":{}}}}},"wrapper":true},"Sl":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}},"DBSecurityGroupArn":{}},"wrapper":true},"Ss":{"type":"structure","members":{"DBClusterIdentifier":{},"BacktrackIdentifier":{},"BacktrackTo":{"type":"timestamp"},"BacktrackedFrom":{"type":"timestamp"},"BacktrackRequestCreationTime":{"type":"timestamp"},"Status":{}}},"Sv":{"type":"structure","members":{"DBClusterParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"DBClusterParameterGroupArn":{}},"wrapper":true},"Sy":{"type":"structure","members":{"AvailabilityZones":{"shape":"Sz"},"DBClusterSnapshotIdentifier":{},"DBClusterIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"VpcId":{},"ClusterCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"PercentProgress":{"type":"integer"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DBClusterSnapshotArn":{},"SourceDBClusterSnapshotArn":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"}},"wrapper":true},"Sz":{"type":"list","member":{"locationName":"AvailabilityZone"}},"S13":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"DBParameterGroupArn":{}},"wrapper":true},"S16":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PercentProgress":{"type":"integer"},"SourceRegion":{},"SourceDBSnapshotIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"DBSnapshotArn":{},"Timezone":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"ProcessorFeatures":{"shape":"S18"},"DbiResourceId":{}},"wrapper":true},"S18":{"type":"list","member":{"locationName":"ProcessorFeature","type":"structure","members":{"Name":{},"Value":{}}}},"S1c":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"Port":{"type":"integer"},"OptionVersion":{},"OptionSettings":{"type":"list","member":{"shape":"S1g","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"S1h"},"VpcSecurityGroupMemberships":{"shape":"S1j"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{},"OptionGroupArn":{}},"wrapper":true},"S1g":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"S1h":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"S1j":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S1m":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"S1o":{"type":"list","member":{}},"S1p":{"type":"structure","members":{"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"AutoPause":{"type":"boolean"},"SecondsUntilAutoPause":{"type":"integer"},"TimeoutAction":{}}},"S1r":{"type":"structure","members":{"AllocatedStorage":{"type":"integer"},"AvailabilityZones":{"shape":"Sz"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroup":{},"DBSubnetGroup":{},"Status":{},"PercentProgress":{},"EarliestRestorableTime":{"type":"timestamp"},"Endpoint":{},"ReaderEndpoint":{},"CustomEndpoints":{"shape":"S1s"},"MultiAZ":{"type":"boolean"},"Engine":{},"EngineVersion":{},"LatestRestorableTime":{"type":"timestamp"},"Port":{"type":"integer"},"MasterUsername":{},"DBClusterOptionGroupMemberships":{"type":"list","member":{"locationName":"DBClusterOptionGroup","type":"structure","members":{"DBClusterOptionGroupName":{},"Status":{}}}},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"ReplicationSourceIdentifier":{},"ReadReplicaIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaIdentifier"}},"DBClusterMembers":{"type":"list","member":{"locationName":"DBClusterMember","type":"structure","members":{"DBInstanceIdentifier":{},"IsClusterWriter":{"type":"boolean"},"DBClusterParameterGroupStatus":{},"PromotionTier":{"type":"integer"}},"wrapper":true}},"VpcSecurityGroups":{"shape":"S1j"},"HostedZoneId":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbClusterResourceId":{},"DBClusterArn":{},"AssociatedRoles":{"type":"list","member":{"locationName":"DBClusterRole","type":"structure","members":{"RoleArn":{},"Status":{},"FeatureName":{}}}},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"CloneGroupId":{},"ClusterCreateTime":{"type":"timestamp"},"EarliestBacktrackTime":{"type":"timestamp"},"BacktrackWindow":{"type":"long"},"BacktrackConsumedChangeRecords":{"type":"long"},"EnabledCloudwatchLogsExports":{"shape":"S1o"},"Capacity":{"type":"integer"},"EngineMode":{},"ScalingConfigurationInfo":{"type":"structure","members":{"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"AutoPause":{"type":"boolean"},"SecondsUntilAutoPause":{"type":"integer"},"TimeoutAction":{}}},"DeletionProtection":{"type":"boolean"},"HttpEndpointEnabled":{"type":"boolean"},"ActivityStreamMode":{},"ActivityStreamStatus":{},"ActivityStreamKmsKeyId":{},"ActivityStreamKinesisStreamName":{},"CopyTagsToSnapshot":{"type":"boolean"},"CrossAccountClone":{"type":"boolean"}},"wrapper":true},"S1s":{"type":"list","member":{}},"S24":{"type":"structure","members":{"DBClusterEndpointIdentifier":{},"DBClusterIdentifier":{},"DBClusterEndpointResourceIdentifier":{},"Endpoint":{},"Status":{},"EndpointType":{},"CustomEndpointType":{},"StaticMembers":{"shape":"S1s"},"ExcludedMembers":{"shape":"S1s"},"DBClusterEndpointArn":{}}},"S2a":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"S2c":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"shape":"S2d"},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"S1h"},"VpcSecurityGroups":{"shape":"S1j"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S2g"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"LicenseModel":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{},"StorageType":{},"CACertificateIdentifier":{},"DBSubnetGroupName":{},"PendingCloudwatchLogsExports":{"type":"structure","members":{"LogTypesToEnable":{"shape":"S1o"},"LogTypesToDisable":{"shape":"S1o"}}},"ProcessorFeatures":{"shape":"S18"}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"ReadReplicaDBClusterIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBClusterIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}},"StorageType":{},"TdeCredentialArn":{},"DbInstancePort":{"type":"integer"},"DBClusterIdentifier":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbiResourceId":{},"CACertificateIdentifier":{},"DomainMemberships":{"type":"list","member":{"locationName":"DomainMembership","type":"structure","members":{"Domain":{},"Status":{},"FQDN":{},"IAMRoleName":{}}}},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"EnhancedMonitoringResourceArn":{},"MonitoringRoleArn":{},"PromotionTier":{"type":"integer"},"DBInstanceArn":{},"Timezone":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"PerformanceInsightsEnabled":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"EnabledCloudwatchLogsExports":{"shape":"S1o"},"ProcessorFeatures":{"shape":"S18"},"DeletionProtection":{"type":"boolean"},"AssociatedRoles":{"type":"list","member":{"locationName":"DBInstanceRole","type":"structure","members":{"RoleArn":{},"FeatureName":{},"Status":{}}}},"ListenerEndpoint":{"shape":"S2d"},"MaxAllocatedStorage":{"type":"integer"}},"wrapper":true},"S2d":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"},"HostedZoneId":{}}},"S2g":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S2j"},"SubnetStatus":{}}}},"DBSubnetGroupArn":{}},"wrapper":true},"S2j":{"type":"structure","members":{"Name":{}},"wrapper":true},"S35":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S3b":{"type":"structure","members":{"GlobalClusterIdentifier":{},"GlobalClusterResourceId":{},"GlobalClusterArn":{},"Status":{},"Engine":{},"EngineVersion":{},"DatabaseName":{},"StorageEncrypted":{"type":"boolean"},"DeletionProtection":{"type":"boolean"},"GlobalClusterMembers":{"type":"list","member":{"locationName":"GlobalClusterMember","type":"structure","members":{"DBClusterArn":{},"Readers":{"type":"list","member":{}},"IsWriter":{"type":"boolean"}},"wrapper":true}}},"wrapper":true},"S3r":{"type":"structure","members":{"DBInstanceArn":{},"DbiResourceId":{},"Region":{},"DBInstanceIdentifier":{},"RestoreWindow":{"type":"structure","members":{"EarliestTime":{"type":"timestamp"},"LatestTime":{"type":"timestamp"}}},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"Engine":{},"EngineVersion":{},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"TdeCredentialArn":{},"Encrypted":{"type":"boolean"},"StorageType":{},"KmsKeyId":{},"Timezone":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"}},"wrapper":true},"S49":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S4q":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{},"SupportedEngineModes":{"shape":"S4t"}}}},"S4t":{"type":"list","member":{}},"S4w":{"type":"structure","members":{"DBClusterSnapshotIdentifier":{},"DBClusterSnapshotAttributes":{"type":"list","member":{"locationName":"DBClusterSnapshotAttribute","type":"structure","members":{"AttributeName":{},"AttributeValues":{"shape":"S4z"}}}}},"wrapper":true},"S4z":{"type":"list","member":{"locationName":"AttributeValue"}},"S5a":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S61":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBSnapshotAttributes":{"type":"list","member":{"locationName":"DBSnapshotAttribute","type":"structure","members":{"AttributeName":{},"AttributeValues":{"shape":"S4z"}},"wrapper":true}}},"wrapper":true},"S6c":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S4q"}},"wrapper":true},"S7f":{"type":"list","member":{"locationName":"AvailableProcessorFeature","type":"structure","members":{"Name":{},"DefaultValue":{},"AllowedValues":{}}}},"S7n":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S7p"},"ReservedDBInstanceArn":{}},"wrapper":true},"S7p":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S84":{"type":"list","member":{"locationName":"Range","type":"structure","members":{"From":{"type":"integer"},"To":{"type":"integer"},"Step":{"type":"integer"}}}},"S8h":{"type":"structure","members":{"EnableLogTypes":{"shape":"S1o"},"DisableLogTypes":{"shape":"S1o"}}},"S8l":{"type":"structure","members":{"DBClusterParameterGroupName":{}}},"S8r":{"type":"structure","members":{"DBParameterGroupName":{}}}}}');

});

parcelRequire.register("eysue", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeDBClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusters"},"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstanceAutomatedBackups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstanceAutomatedBackups"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBLogFiles":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DescribeDBLogFiles"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeGlobalClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"GlobalClusters"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"DownloadDBLogFilePortion":{"input_token":"Marker","limit_key":"NumberOfLines","more_results":"AdditionalDataPending","output_token":"Marker","result_key":"LogFileData"},"ListTagsForResource":{"result_key":"TagList"}}}');

});

parcelRequire.register("iLacx", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"DBInstanceAvailable":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBInstanceDeleted":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"DBInstanceNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBSnapshotAvailable":{"delay":30,"operation":"DescribeDBSnapshots","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBSnapshots[].Status"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"}]},"DBSnapshotDeleted":{"delay":30,"operation":"DescribeDBSnapshots","maxAttempts":60,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"DBSnapshots[].Status"},{"expected":"DBSnapshotNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"}]}}}');

});


parcelRequire.register("1gXlb", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $0ed550e1c5c6eff9$var$Service = $dbC7k.Service;
var $0ed550e1c5c6eff9$var$apiLoader = $dbC7k.apiLoader;
$0ed550e1c5c6eff9$var$apiLoader.services["redshift"] = {};
$dbC7k.Redshift = $0ed550e1c5c6eff9$var$Service.defineService("redshift", [
    "2012-12-01"
]);



Object.defineProperty($0ed550e1c5c6eff9$var$apiLoader.services["redshift"], "2012-12-01", {
    get: function get() {
        var model = (parcelRequire("6jk2v"));
        model.paginators = (parcelRequire("hfP0B")).pagination;
        model.waiters = (parcelRequire("hl62w")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Redshift;

});
parcelRequire.register("6jk2v", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2012-12-01","endpointPrefix":"redshift","protocol":"query","serviceFullName":"Amazon Redshift","serviceId":"Redshift","signatureVersion":"v4","uid":"redshift-2012-12-01","xmlNamespace":"http://redshift.amazonaws.com/doc/2012-12-01/"},"operations":{"AcceptReservedNodeExchange":{"input":{"type":"structure","required":["ReservedNodeId","TargetReservedNodeOfferingId"],"members":{"ReservedNodeId":{},"TargetReservedNodeOfferingId":{}}},"output":{"resultWrapper":"AcceptReservedNodeExchangeResult","type":"structure","members":{"ExchangedReservedNode":{"shape":"S4"}}}},"AuthorizeClusterSecurityGroupIngress":{"input":{"type":"structure","required":["ClusterSecurityGroupName"],"members":{"ClusterSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeClusterSecurityGroupIngressResult","type":"structure","members":{"ClusterSecurityGroup":{"shape":"Sd"}}}},"AuthorizeSnapshotAccess":{"input":{"type":"structure","required":["SnapshotIdentifier","AccountWithRestoreAccess"],"members":{"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{},"AccountWithRestoreAccess":{}}},"output":{"resultWrapper":"AuthorizeSnapshotAccessResult","type":"structure","members":{"Snapshot":{"shape":"Sm"}}}},"BatchDeleteClusterSnapshots":{"input":{"type":"structure","required":["Identifiers"],"members":{"Identifiers":{"type":"list","member":{"shape":"Sv","locationName":"DeleteClusterSnapshotMessage"}}}},"output":{"resultWrapper":"BatchDeleteClusterSnapshotsResult","type":"structure","members":{"Resources":{"shape":"Sx"},"Errors":{"type":"list","member":{"shape":"Sz","locationName":"SnapshotErrorMessage"}}}}},"BatchModifyClusterSnapshots":{"input":{"type":"structure","required":["SnapshotIdentifierList"],"members":{"SnapshotIdentifierList":{"shape":"Sx"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"Force":{"type":"boolean"}}},"output":{"resultWrapper":"BatchModifyClusterSnapshotsResult","type":"structure","members":{"Resources":{"shape":"Sx"},"Errors":{"type":"list","member":{"shape":"Sz","locationName":"SnapshotErrorMessage"}}}}},"CancelResize":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"shape":"S14","resultWrapper":"CancelResizeResult"}},"CopyClusterSnapshot":{"input":{"type":"structure","required":["SourceSnapshotIdentifier","TargetSnapshotIdentifier"],"members":{"SourceSnapshotIdentifier":{},"SourceSnapshotClusterIdentifier":{},"TargetSnapshotIdentifier":{},"ManualSnapshotRetentionPeriod":{"type":"integer"}}},"output":{"resultWrapper":"CopyClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sm"}}}},"CreateCluster":{"input":{"type":"structure","required":["ClusterIdentifier","NodeType","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"ClusterIdentifier":{},"ClusterType":{},"NodeType":{},"MasterUsername":{},"MasterUserPassword":{},"ClusterSecurityGroups":{"shape":"S1d"},"VpcSecurityGroupIds":{"shape":"S1e"},"ClusterSubnetGroupName":{},"AvailabilityZone":{},"PreferredMaintenanceWindow":{},"ClusterParameterGroupName":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"Port":{"type":"integer"},"ClusterVersion":{},"AllowVersionUpgrade":{"type":"boolean"},"NumberOfNodes":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"Encrypted":{"type":"boolean"},"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"ElasticIp":{},"Tags":{"shape":"Sg"},"KmsKeyId":{},"EnhancedVpcRouting":{"type":"boolean"},"AdditionalInfo":{},"IamRoles":{"shape":"S1g"},"MaintenanceTrackName":{},"SnapshotScheduleIdentifier":{}}},"output":{"resultWrapper":"CreateClusterResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"CreateClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName","ParameterGroupFamily","Description"],"members":{"ParameterGroupName":{},"ParameterGroupFamily":{},"Description":{},"Tags":{"shape":"Sg"}}},"output":{"resultWrapper":"CreateClusterParameterGroupResult","type":"structure","members":{"ClusterParameterGroup":{"shape":"S29"}}}},"CreateClusterSecurityGroup":{"input":{"type":"structure","required":["ClusterSecurityGroupName","Description"],"members":{"ClusterSecurityGroupName":{},"Description":{},"Tags":{"shape":"Sg"}}},"output":{"resultWrapper":"CreateClusterSecurityGroupResult","type":"structure","members":{"ClusterSecurityGroup":{"shape":"Sd"}}}},"CreateClusterSnapshot":{"input":{"type":"structure","required":["SnapshotIdentifier","ClusterIdentifier"],"members":{"SnapshotIdentifier":{},"ClusterIdentifier":{},"ManualSnapshotRetentionPeriod":{"type":"integer"},"Tags":{"shape":"Sg"}}},"output":{"resultWrapper":"CreateClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sm"}}}},"CreateClusterSubnetGroup":{"input":{"type":"structure","required":["ClusterSubnetGroupName","Description","SubnetIds"],"members":{"ClusterSubnetGroupName":{},"Description":{},"SubnetIds":{"shape":"S2f"},"Tags":{"shape":"Sg"}}},"output":{"resultWrapper":"CreateClusterSubnetGroupResult","type":"structure","members":{"ClusterSubnetGroup":{"shape":"S2h"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"SourceIds":{"shape":"S2o"},"EventCategories":{"shape":"S2p"},"Severity":{},"Enabled":{"type":"boolean"},"Tags":{"shape":"Sg"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S2r"}}}},"CreateHsmClientCertificate":{"input":{"type":"structure","required":["HsmClientCertificateIdentifier"],"members":{"HsmClientCertificateIdentifier":{},"Tags":{"shape":"Sg"}}},"output":{"resultWrapper":"CreateHsmClientCertificateResult","type":"structure","members":{"HsmClientCertificate":{"shape":"S2u"}}}},"CreateHsmConfiguration":{"input":{"type":"structure","required":["HsmConfigurationIdentifier","Description","HsmIpAddress","HsmPartitionName","HsmPartitionPassword","HsmServerPublicCertificate"],"members":{"HsmConfigurationIdentifier":{},"Description":{},"HsmIpAddress":{},"HsmPartitionName":{},"HsmPartitionPassword":{},"HsmServerPublicCertificate":{},"Tags":{"shape":"Sg"}}},"output":{"resultWrapper":"CreateHsmConfigurationResult","type":"structure","members":{"HsmConfiguration":{"shape":"S2x"}}}},"CreateSnapshotCopyGrant":{"input":{"type":"structure","required":["SnapshotCopyGrantName"],"members":{"SnapshotCopyGrantName":{},"KmsKeyId":{},"Tags":{"shape":"Sg"}}},"output":{"resultWrapper":"CreateSnapshotCopyGrantResult","type":"structure","members":{"SnapshotCopyGrant":{"shape":"S30"}}}},"CreateSnapshotSchedule":{"input":{"type":"structure","members":{"ScheduleDefinitions":{"shape":"S32"},"ScheduleIdentifier":{},"ScheduleDescription":{},"Tags":{"shape":"Sg"},"DryRun":{"type":"boolean"},"NextInvocations":{"type":"integer"}}},"output":{"shape":"S33","resultWrapper":"CreateSnapshotScheduleResult"}},"CreateTags":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"Sg"}}}},"DeleteCluster":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"SkipFinalClusterSnapshot":{"type":"boolean"},"FinalClusterSnapshotIdentifier":{},"FinalClusterSnapshotRetentionPeriod":{"type":"integer"}}},"output":{"resultWrapper":"DeleteClusterResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"DeleteClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{}}}},"DeleteClusterSecurityGroup":{"input":{"type":"structure","required":["ClusterSecurityGroupName"],"members":{"ClusterSecurityGroupName":{}}}},"DeleteClusterSnapshot":{"input":{"shape":"Sv"},"output":{"resultWrapper":"DeleteClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sm"}}}},"DeleteClusterSubnetGroup":{"input":{"type":"structure","required":["ClusterSubnetGroupName"],"members":{"ClusterSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}}},"DeleteHsmClientCertificate":{"input":{"type":"structure","required":["HsmClientCertificateIdentifier"],"members":{"HsmClientCertificateIdentifier":{}}}},"DeleteHsmConfiguration":{"input":{"type":"structure","required":["HsmConfigurationIdentifier"],"members":{"HsmConfigurationIdentifier":{}}}},"DeleteSnapshotCopyGrant":{"input":{"type":"structure","required":["SnapshotCopyGrantName"],"members":{"SnapshotCopyGrantName":{}}}},"DeleteSnapshotSchedule":{"input":{"type":"structure","required":["ScheduleIdentifier"],"members":{"ScheduleIdentifier":{}}}},"DeleteTags":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"shape":"S3k"}}}},"DescribeAccountAttributes":{"input":{"type":"structure","members":{"AttributeNames":{"type":"list","member":{"locationName":"AttributeName"}}}},"output":{"resultWrapper":"DescribeAccountAttributesResult","type":"structure","members":{"AccountAttributes":{"type":"list","member":{"locationName":"AccountAttribute","type":"structure","members":{"AttributeName":{},"AttributeValues":{"type":"list","member":{"locationName":"AttributeValueTarget","type":"structure","members":{"AttributeValue":{}}}}}}}}}},"DescribeClusterDbRevisions":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeClusterDbRevisionsResult","type":"structure","members":{"Marker":{},"ClusterDbRevisions":{"type":"list","member":{"locationName":"ClusterDbRevision","type":"structure","members":{"ClusterIdentifier":{},"CurrentDatabaseRevision":{},"DatabaseRevisionReleaseDate":{"type":"timestamp"},"RevisionTargets":{"type":"list","member":{"locationName":"RevisionTarget","type":"structure","members":{"DatabaseRevision":{},"Description":{},"DatabaseRevisionReleaseDate":{"type":"timestamp"}}}}}}}}}},"DescribeClusterParameterGroups":{"input":{"type":"structure","members":{"ParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S3k"},"TagValues":{"shape":"S3z"}}},"output":{"resultWrapper":"DescribeClusterParameterGroupsResult","type":"structure","members":{"Marker":{},"ParameterGroups":{"type":"list","member":{"shape":"S29","locationName":"ClusterParameterGroup"}}}}},"DescribeClusterParameters":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeClusterParametersResult","type":"structure","members":{"Parameters":{"shape":"S44"},"Marker":{}}}},"DescribeClusterSecurityGroups":{"input":{"type":"structure","members":{"ClusterSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S3k"},"TagValues":{"shape":"S3z"}}},"output":{"resultWrapper":"DescribeClusterSecurityGroupsResult","type":"structure","members":{"Marker":{},"ClusterSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"ClusterSecurityGroup"}}}}},"DescribeClusterSnapshots":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"SnapshotIdentifier":{},"SnapshotType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"Marker":{},"OwnerAccount":{},"TagKeys":{"shape":"S3k"},"TagValues":{"shape":"S3z"},"ClusterExists":{"type":"boolean"},"SortingEntities":{"type":"list","member":{"locationName":"SnapshotSortingEntity","type":"structure","required":["Attribute"],"members":{"Attribute":{},"SortOrder":{}}}}}},"output":{"resultWrapper":"DescribeClusterSnapshotsResult","type":"structure","members":{"Marker":{},"Snapshots":{"type":"list","member":{"shape":"Sm","locationName":"Snapshot"}}}}},"DescribeClusterSubnetGroups":{"input":{"type":"structure","members":{"ClusterSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S3k"},"TagValues":{"shape":"S3z"}}},"output":{"resultWrapper":"DescribeClusterSubnetGroupsResult","type":"structure","members":{"Marker":{},"ClusterSubnetGroups":{"type":"list","member":{"shape":"S2h","locationName":"ClusterSubnetGroup"}}}}},"DescribeClusterTracks":{"input":{"type":"structure","members":{"MaintenanceTrackName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeClusterTracksResult","type":"structure","members":{"MaintenanceTracks":{"type":"list","member":{"locationName":"MaintenanceTrack","type":"structure","members":{"MaintenanceTrackName":{},"DatabaseVersion":{},"UpdateTargets":{"type":"list","member":{"locationName":"UpdateTarget","type":"structure","members":{"MaintenanceTrackName":{},"DatabaseVersion":{},"SupportedOperations":{"type":"list","member":{"locationName":"SupportedOperation","type":"structure","members":{"OperationName":{}}}}}}}}}},"Marker":{}}}},"DescribeClusterVersions":{"input":{"type":"structure","members":{"ClusterVersion":{},"ClusterParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeClusterVersionsResult","type":"structure","members":{"Marker":{},"ClusterVersions":{"type":"list","member":{"locationName":"ClusterVersion","type":"structure","members":{"ClusterVersion":{},"ClusterParameterGroupFamily":{},"Description":{}}}}}}},"DescribeClusters":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S3k"},"TagValues":{"shape":"S3z"}}},"output":{"resultWrapper":"DescribeClustersResult","type":"structure","members":{"Marker":{},"Clusters":{"type":"list","member":{"shape":"S1i","locationName":"Cluster"}}}}},"DescribeDefaultClusterParameters":{"input":{"type":"structure","required":["ParameterGroupFamily"],"members":{"ParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDefaultClusterParametersResult","type":"structure","members":{"DefaultClusterParameters":{"type":"structure","members":{"ParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S44"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"Events":{"type":"list","member":{"locationName":"EventInfoMap","type":"structure","members":{"EventId":{},"EventCategories":{"shape":"S2p"},"EventDescription":{},"Severity":{}},"wrapper":true}}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S3k"},"TagValues":{"shape":"S3z"}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S2r","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S2p"},"Severity":{},"Date":{"type":"timestamp"},"EventId":{}}}}}}},"DescribeHsmClientCertificates":{"input":{"type":"structure","members":{"HsmClientCertificateIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S3k"},"TagValues":{"shape":"S3z"}}},"output":{"resultWrapper":"DescribeHsmClientCertificatesResult","type":"structure","members":{"Marker":{},"HsmClientCertificates":{"type":"list","member":{"shape":"S2u","locationName":"HsmClientCertificate"}}}}},"DescribeHsmConfigurations":{"input":{"type":"structure","members":{"HsmConfigurationIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S3k"},"TagValues":{"shape":"S3z"}}},"output":{"resultWrapper":"DescribeHsmConfigurationsResult","type":"structure","members":{"Marker":{},"HsmConfigurations":{"type":"list","member":{"shape":"S2x","locationName":"HsmConfiguration"}}}}},"DescribeLoggingStatus":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"shape":"S5n","resultWrapper":"DescribeLoggingStatusResult"}},"DescribeOrderableClusterOptions":{"input":{"type":"structure","members":{"ClusterVersion":{},"NodeType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableClusterOptionsResult","type":"structure","members":{"OrderableClusterOptions":{"type":"list","member":{"locationName":"OrderableClusterOption","type":"structure","members":{"ClusterVersion":{},"ClusterType":{},"NodeType":{},"AvailabilityZones":{"type":"list","member":{"shape":"S2k","locationName":"AvailabilityZone"}}},"wrapper":true}},"Marker":{}}}},"DescribeReservedNodeOfferings":{"input":{"type":"structure","members":{"ReservedNodeOfferingId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedNodeOfferingsResult","type":"structure","members":{"Marker":{},"ReservedNodeOfferings":{"shape":"S5v"}}}},"DescribeReservedNodes":{"input":{"type":"structure","members":{"ReservedNodeId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedNodesResult","type":"structure","members":{"Marker":{},"ReservedNodes":{"type":"list","member":{"shape":"S4","locationName":"ReservedNode"}}}}},"DescribeResize":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"shape":"S14","resultWrapper":"DescribeResizeResult"}},"DescribeSnapshotCopyGrants":{"input":{"type":"structure","members":{"SnapshotCopyGrantName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S3k"},"TagValues":{"shape":"S3z"}}},"output":{"resultWrapper":"DescribeSnapshotCopyGrantsResult","type":"structure","members":{"Marker":{},"SnapshotCopyGrants":{"type":"list","member":{"shape":"S30","locationName":"SnapshotCopyGrant"}}}}},"DescribeSnapshotSchedules":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"ScheduleIdentifier":{},"TagKeys":{"shape":"S3k"},"TagValues":{"shape":"S3z"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeSnapshotSchedulesResult","type":"structure","members":{"SnapshotSchedules":{"type":"list","member":{"shape":"S33","locationName":"SnapshotSchedule"}},"Marker":{}}}},"DescribeStorage":{"output":{"resultWrapper":"DescribeStorageResult","type":"structure","members":{"TotalBackupSizeInMegaBytes":{"type":"double"},"TotalProvisionedStorageInMegaBytes":{"type":"double"}}}},"DescribeTableRestoreStatus":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"TableRestoreRequestId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeTableRestoreStatusResult","type":"structure","members":{"TableRestoreStatusDetails":{"type":"list","member":{"shape":"S6b","locationName":"TableRestoreStatus"}},"Marker":{}}}},"DescribeTags":{"input":{"type":"structure","members":{"ResourceName":{},"ResourceType":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S3k"},"TagValues":{"shape":"S3z"}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"TaggedResources":{"type":"list","member":{"locationName":"TaggedResource","type":"structure","members":{"Tag":{"shape":"Sh"},"ResourceName":{},"ResourceType":{}}}},"Marker":{}}}},"DisableLogging":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"shape":"S5n","resultWrapper":"DisableLoggingResult"}},"DisableSnapshotCopy":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"resultWrapper":"DisableSnapshotCopyResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"EnableLogging":{"input":{"type":"structure","required":["ClusterIdentifier","BucketName"],"members":{"ClusterIdentifier":{},"BucketName":{},"S3KeyPrefix":{}}},"output":{"shape":"S5n","resultWrapper":"EnableLoggingResult"}},"EnableSnapshotCopy":{"input":{"type":"structure","required":["ClusterIdentifier","DestinationRegion"],"members":{"ClusterIdentifier":{},"DestinationRegion":{},"RetentionPeriod":{"type":"integer"},"SnapshotCopyGrantName":{},"ManualSnapshotRetentionPeriod":{"type":"integer"}}},"output":{"resultWrapper":"EnableSnapshotCopyResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"GetClusterCredentials":{"input":{"type":"structure","required":["DbUser","ClusterIdentifier"],"members":{"DbUser":{},"DbName":{},"ClusterIdentifier":{},"DurationSeconds":{"type":"integer"},"AutoCreate":{"type":"boolean"},"DbGroups":{"type":"list","member":{"locationName":"DbGroup"}}}},"output":{"resultWrapper":"GetClusterCredentialsResult","type":"structure","members":{"DbUser":{},"DbPassword":{"type":"string","sensitive":true},"Expiration":{"type":"timestamp"}}}},"GetReservedNodeExchangeOfferings":{"input":{"type":"structure","required":["ReservedNodeId"],"members":{"ReservedNodeId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"GetReservedNodeExchangeOfferingsResult","type":"structure","members":{"Marker":{},"ReservedNodeOfferings":{"shape":"S5v"}}}},"ModifyCluster":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"ClusterType":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"ClusterSecurityGroups":{"shape":"S1d"},"VpcSecurityGroupIds":{"shape":"S1e"},"MasterUserPassword":{},"ClusterParameterGroupName":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"PreferredMaintenanceWindow":{},"ClusterVersion":{},"AllowVersionUpgrade":{"type":"boolean"},"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"NewClusterIdentifier":{},"PubliclyAccessible":{"type":"boolean"},"ElasticIp":{},"EnhancedVpcRouting":{"type":"boolean"},"MaintenanceTrackName":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{}}},"output":{"resultWrapper":"ModifyClusterResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"ModifyClusterDbRevision":{"input":{"type":"structure","required":["ClusterIdentifier","RevisionTarget"],"members":{"ClusterIdentifier":{},"RevisionTarget":{}}},"output":{"resultWrapper":"ModifyClusterDbRevisionResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"ModifyClusterIamRoles":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"AddIamRoles":{"shape":"S1g"},"RemoveIamRoles":{"shape":"S1g"}}},"output":{"resultWrapper":"ModifyClusterIamRolesResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"ModifyClusterMaintenance":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"DeferMaintenance":{"type":"boolean"},"DeferMaintenanceIdentifier":{},"DeferMaintenanceStartTime":{"type":"timestamp"},"DeferMaintenanceEndTime":{"type":"timestamp"},"DeferMaintenanceDuration":{"type":"integer"}}},"output":{"resultWrapper":"ModifyClusterMaintenanceResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"ModifyClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName","Parameters"],"members":{"ParameterGroupName":{},"Parameters":{"shape":"S44"}}},"output":{"shape":"S72","resultWrapper":"ModifyClusterParameterGroupResult"}},"ModifyClusterSnapshot":{"input":{"type":"structure","required":["SnapshotIdentifier"],"members":{"SnapshotIdentifier":{},"ManualSnapshotRetentionPeriod":{"type":"integer"},"Force":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"Sm"}}}},"ModifyClusterSnapshotSchedule":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"ScheduleIdentifier":{},"DisassociateSchedule":{"type":"boolean"}}}},"ModifyClusterSubnetGroup":{"input":{"type":"structure","required":["ClusterSubnetGroupName","SubnetIds"],"members":{"ClusterSubnetGroupName":{},"Description":{},"SubnetIds":{"shape":"S2f"}}},"output":{"resultWrapper":"ModifyClusterSubnetGroupResult","type":"structure","members":{"ClusterSubnetGroup":{"shape":"S2h"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"SourceIds":{"shape":"S2o"},"EventCategories":{"shape":"S2p"},"Severity":{},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S2r"}}}},"ModifySnapshotCopyRetentionPeriod":{"input":{"type":"structure","required":["ClusterIdentifier","RetentionPeriod"],"members":{"ClusterIdentifier":{},"RetentionPeriod":{"type":"integer"},"Manual":{"type":"boolean"}}},"output":{"resultWrapper":"ModifySnapshotCopyRetentionPeriodResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"ModifySnapshotSchedule":{"input":{"type":"structure","required":["ScheduleIdentifier","ScheduleDefinitions"],"members":{"ScheduleIdentifier":{},"ScheduleDefinitions":{"shape":"S32"}}},"output":{"shape":"S33","resultWrapper":"ModifySnapshotScheduleResult"}},"PurchaseReservedNodeOffering":{"input":{"type":"structure","required":["ReservedNodeOfferingId"],"members":{"ReservedNodeOfferingId":{},"NodeCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedNodeOfferingResult","type":"structure","members":{"ReservedNode":{"shape":"S4"}}}},"RebootCluster":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"resultWrapper":"RebootClusterResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"ResetClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S44"}}},"output":{"shape":"S72","resultWrapper":"ResetClusterParameterGroupResult"}},"ResizeCluster":{"input":{"type":"structure","required":["ClusterIdentifier","NumberOfNodes"],"members":{"ClusterIdentifier":{},"ClusterType":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"Classic":{"type":"boolean"}}},"output":{"resultWrapper":"ResizeClusterResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"RestoreFromClusterSnapshot":{"input":{"type":"structure","required":["ClusterIdentifier","SnapshotIdentifier"],"members":{"ClusterIdentifier":{},"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{},"Port":{"type":"integer"},"AvailabilityZone":{},"AllowVersionUpgrade":{"type":"boolean"},"ClusterSubnetGroupName":{},"PubliclyAccessible":{"type":"boolean"},"OwnerAccount":{},"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"ElasticIp":{},"ClusterParameterGroupName":{},"ClusterSecurityGroups":{"shape":"S1d"},"VpcSecurityGroupIds":{"shape":"S1e"},"PreferredMaintenanceWindow":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"KmsKeyId":{},"NodeType":{},"EnhancedVpcRouting":{"type":"boolean"},"AdditionalInfo":{},"IamRoles":{"shape":"S1g"},"MaintenanceTrackName":{},"SnapshotScheduleIdentifier":{}}},"output":{"resultWrapper":"RestoreFromClusterSnapshotResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}},"RestoreTableFromClusterSnapshot":{"input":{"type":"structure","required":["ClusterIdentifier","SnapshotIdentifier","SourceDatabaseName","SourceTableName","NewTableName"],"members":{"ClusterIdentifier":{},"SnapshotIdentifier":{},"SourceDatabaseName":{},"SourceSchemaName":{},"SourceTableName":{},"TargetDatabaseName":{},"TargetSchemaName":{},"NewTableName":{}}},"output":{"resultWrapper":"RestoreTableFromClusterSnapshotResult","type":"structure","members":{"TableRestoreStatus":{"shape":"S6b"}}}},"RevokeClusterSecurityGroupIngress":{"input":{"type":"structure","required":["ClusterSecurityGroupName"],"members":{"ClusterSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeClusterSecurityGroupIngressResult","type":"structure","members":{"ClusterSecurityGroup":{"shape":"Sd"}}}},"RevokeSnapshotAccess":{"input":{"type":"structure","required":["SnapshotIdentifier","AccountWithRestoreAccess"],"members":{"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{},"AccountWithRestoreAccess":{}}},"output":{"resultWrapper":"RevokeSnapshotAccessResult","type":"structure","members":{"Snapshot":{"shape":"Sm"}}}},"RotateEncryptionKey":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"resultWrapper":"RotateEncryptionKeyResult","type":"structure","members":{"Cluster":{"shape":"S1i"}}}}},"shapes":{"S4":{"type":"structure","members":{"ReservedNodeId":{},"ReservedNodeOfferingId":{},"NodeType":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"NodeCount":{"type":"integer"},"State":{},"OfferingType":{},"RecurringCharges":{"shape":"S8"},"ReservedNodeOfferingType":{}},"wrapper":true},"S8":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"Sd":{"type":"structure","members":{"ClusterSecurityGroupName":{},"Description":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{},"Tags":{"shape":"Sg"}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{},"Tags":{"shape":"Sg"}}}},"Tags":{"shape":"Sg"}},"wrapper":true},"Sg":{"type":"list","member":{"shape":"Sh","locationName":"Tag"}},"Sh":{"type":"structure","members":{"Key":{},"Value":{}}},"Sm":{"type":"structure","members":{"SnapshotIdentifier":{},"ClusterIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"ClusterCreateTime":{"type":"timestamp"},"MasterUsername":{},"ClusterVersion":{},"SnapshotType":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"DBName":{},"VpcId":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"EncryptedWithHSM":{"type":"boolean"},"AccountsWithRestoreAccess":{"type":"list","member":{"locationName":"AccountWithRestoreAccess","type":"structure","members":{"AccountId":{},"AccountAlias":{}}}},"OwnerAccount":{},"TotalBackupSizeInMegaBytes":{"type":"double"},"ActualIncrementalBackupSizeInMegaBytes":{"type":"double"},"BackupProgressInMegaBytes":{"type":"double"},"CurrentBackupRateInMegaBytesPerSecond":{"type":"double"},"EstimatedSecondsToCompletion":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"},"SourceRegion":{},"Tags":{"shape":"Sg"},"RestorableNodeTypes":{"type":"list","member":{"locationName":"NodeType"}},"EnhancedVpcRouting":{"type":"boolean"},"MaintenanceTrackName":{},"ManualSnapshotRetentionPeriod":{"type":"integer"},"ManualSnapshotRemainingDays":{"type":"integer"},"SnapshotRetentionStartTime":{"type":"timestamp"}},"wrapper":true},"Sv":{"type":"structure","required":["SnapshotIdentifier"],"members":{"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{}}},"Sx":{"type":"list","member":{"locationName":"String"}},"Sz":{"type":"structure","members":{"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{},"FailureCode":{},"FailureReason":{}}},"S14":{"type":"structure","members":{"TargetNodeType":{},"TargetNumberOfNodes":{"type":"integer"},"TargetClusterType":{},"Status":{},"ImportTablesCompleted":{"type":"list","member":{}},"ImportTablesInProgress":{"type":"list","member":{}},"ImportTablesNotStarted":{"type":"list","member":{}},"AvgResizeRateInMegaBytesPerSecond":{"type":"double"},"TotalResizeDataInMegaBytes":{"type":"long"},"ProgressInMegaBytes":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"},"EstimatedTimeToCompletionInSeconds":{"type":"long"},"ResizeType":{},"Message":{},"TargetEncryptionType":{},"DataTransferProgressPercent":{"type":"double"}}},"S1d":{"type":"list","member":{"locationName":"ClusterSecurityGroupName"}},"S1e":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"S1g":{"type":"list","member":{"locationName":"IamRoleArn"}},"S1i":{"type":"structure","members":{"ClusterIdentifier":{},"NodeType":{},"ClusterStatus":{},"ClusterAvailabilityStatus":{},"ModifyStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"ClusterCreateTime":{"type":"timestamp"},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"ClusterSecurityGroups":{"type":"list","member":{"locationName":"ClusterSecurityGroup","type":"structure","members":{"ClusterSecurityGroupName":{},"Status":{}}}},"VpcSecurityGroups":{"type":"list","member":{"locationName":"VpcSecurityGroup","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"ClusterParameterGroups":{"type":"list","member":{"locationName":"ClusterParameterGroup","type":"structure","members":{"ParameterGroupName":{},"ParameterApplyStatus":{},"ClusterParameterStatusList":{"type":"list","member":{"type":"structure","members":{"ParameterName":{},"ParameterApplyStatus":{},"ParameterApplyErrorDescription":{}}}}}}},"ClusterSubnetGroupName":{},"VpcId":{},"AvailabilityZone":{},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"MasterUserPassword":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"ClusterType":{},"ClusterVersion":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ClusterIdentifier":{},"PubliclyAccessible":{"type":"boolean"},"EnhancedVpcRouting":{"type":"boolean"},"MaintenanceTrackName":{},"EncryptionType":{}}},"ClusterVersion":{},"AllowVersionUpgrade":{"type":"boolean"},"NumberOfNodes":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"Encrypted":{"type":"boolean"},"RestoreStatus":{"type":"structure","members":{"Status":{},"CurrentRestoreRateInMegaBytesPerSecond":{"type":"double"},"SnapshotSizeInMegaBytes":{"type":"long"},"ProgressInMegaBytes":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"},"EstimatedTimeToCompletionInSeconds":{"type":"long"}}},"DataTransferProgress":{"type":"structure","members":{"Status":{},"CurrentRateInMegaBytesPerSecond":{"type":"double"},"TotalDataInMegaBytes":{"type":"long"},"DataTransferredInMegaBytes":{"type":"long"},"EstimatedTimeToCompletionInSeconds":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"}}},"HsmStatus":{"type":"structure","members":{"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"Status":{}}},"ClusterSnapshotCopyStatus":{"type":"structure","members":{"DestinationRegion":{},"RetentionPeriod":{"type":"long"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"SnapshotCopyGrantName":{}}},"ClusterPublicKey":{},"ClusterNodes":{"type":"list","member":{"type":"structure","members":{"NodeRole":{},"PrivateIPAddress":{},"PublicIPAddress":{}}}},"ElasticIpStatus":{"type":"structure","members":{"ElasticIp":{},"Status":{}}},"ClusterRevisionNumber":{},"Tags":{"shape":"Sg"},"KmsKeyId":{},"EnhancedVpcRouting":{"type":"boolean"},"IamRoles":{"type":"list","member":{"locationName":"ClusterIamRole","type":"structure","members":{"IamRoleArn":{},"ApplyStatus":{}}}},"PendingActions":{"type":"list","member":{}},"MaintenanceTrackName":{},"ElasticResizeNumberOfNodeOptions":{},"DeferredMaintenanceWindows":{"type":"list","member":{"locationName":"DeferredMaintenanceWindow","type":"structure","members":{"DeferMaintenanceIdentifier":{},"DeferMaintenanceStartTime":{"type":"timestamp"},"DeferMaintenanceEndTime":{"type":"timestamp"}}}},"SnapshotScheduleIdentifier":{},"SnapshotScheduleState":{},"ExpectedNextSnapshotScheduleTime":{"type":"timestamp"},"ExpectedNextSnapshotScheduleTimeStatus":{},"ResizeInfo":{"type":"structure","members":{"ResizeType":{},"AllowCancelResize":{"type":"boolean"}}}},"wrapper":true},"S29":{"type":"structure","members":{"ParameterGroupName":{},"ParameterGroupFamily":{},"Description":{},"Tags":{"shape":"Sg"}},"wrapper":true},"S2f":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S2h":{"type":"structure","members":{"ClusterSubnetGroupName":{},"Description":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S2k"},"SubnetStatus":{}}}},"Tags":{"shape":"Sg"}},"wrapper":true},"S2k":{"type":"structure","members":{"Name":{},"SupportedPlatforms":{"type":"list","member":{"locationName":"SupportedPlatform","type":"structure","members":{"Name":{}},"wrapper":true}}},"wrapper":true},"S2o":{"type":"list","member":{"locationName":"SourceId"}},"S2p":{"type":"list","member":{"locationName":"EventCategory"}},"S2r":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{"type":"timestamp"},"SourceType":{},"SourceIdsList":{"shape":"S2o"},"EventCategoriesList":{"shape":"S2p"},"Severity":{},"Enabled":{"type":"boolean"},"Tags":{"shape":"Sg"}},"wrapper":true},"S2u":{"type":"structure","members":{"HsmClientCertificateIdentifier":{},"HsmClientCertificatePublicKey":{},"Tags":{"shape":"Sg"}},"wrapper":true},"S2x":{"type":"structure","members":{"HsmConfigurationIdentifier":{},"Description":{},"HsmIpAddress":{},"HsmPartitionName":{},"Tags":{"shape":"Sg"}},"wrapper":true},"S30":{"type":"structure","members":{"SnapshotCopyGrantName":{},"KmsKeyId":{},"Tags":{"shape":"Sg"}},"wrapper":true},"S32":{"type":"list","member":{"locationName":"ScheduleDefinition"}},"S33":{"type":"structure","members":{"ScheduleDefinitions":{"shape":"S32"},"ScheduleIdentifier":{},"ScheduleDescription":{},"Tags":{"shape":"Sg"},"NextInvocations":{"type":"list","member":{"locationName":"SnapshotTime","type":"timestamp"}},"AssociatedClusterCount":{"type":"integer"},"AssociatedClusters":{"type":"list","member":{"locationName":"ClusterAssociatedToSchedule","type":"structure","members":{"ClusterIdentifier":{},"ScheduleAssociationState":{}}}}}},"S3k":{"type":"list","member":{"locationName":"TagKey"}},"S3z":{"type":"list","member":{"locationName":"TagValue"}},"S44":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"DataType":{},"AllowedValues":{},"ApplyType":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{}}}},"S5n":{"type":"structure","members":{"LoggingEnabled":{"type":"boolean"},"BucketName":{},"S3KeyPrefix":{},"LastSuccessfulDeliveryTime":{"type":"timestamp"},"LastFailureTime":{"type":"timestamp"},"LastFailureMessage":{}}},"S5v":{"type":"list","member":{"locationName":"ReservedNodeOffering","type":"structure","members":{"ReservedNodeOfferingId":{},"NodeType":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"OfferingType":{},"RecurringCharges":{"shape":"S8"},"ReservedNodeOfferingType":{}},"wrapper":true}},"S6b":{"type":"structure","members":{"TableRestoreRequestId":{},"Status":{},"Message":{},"RequestTime":{"type":"timestamp"},"ProgressInMegaBytes":{"type":"long"},"TotalDataInMegaBytes":{"type":"long"},"ClusterIdentifier":{},"SnapshotIdentifier":{},"SourceDatabaseName":{},"SourceSchemaName":{},"SourceTableName":{},"TargetDatabaseName":{},"TargetSchemaName":{},"NewTableName":{}},"wrapper":true},"S72":{"type":"structure","members":{"ParameterGroupName":{},"ParameterGroupStatus":{}}}}}');

});

parcelRequire.register("hfP0B", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeClusterParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ParameterGroups"},"DescribeClusterParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeClusterSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ClusterSecurityGroups"},"DescribeClusterSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Snapshots"},"DescribeClusterSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ClusterSubnetGroups"},"DescribeClusterVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ClusterVersions"},"DescribeClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Clusters"},"DescribeDefaultClusterParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"DefaultClusterParameters.Marker","result_key":"DefaultClusterParameters.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeHsmClientCertificates":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"HsmClientCertificates"},"DescribeHsmConfigurations":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"HsmConfigurations"},"DescribeOrderableClusterOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableClusterOptions"},"DescribeReservedNodeOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedNodeOfferings"},"DescribeReservedNodes":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedNodes"}}}');

});

parcelRequire.register("hl62w", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"ClusterAvailable":{"delay":60,"operation":"DescribeClusters","maxAttempts":30,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Clusters[].ClusterStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"Clusters[].ClusterStatus"},{"expected":"ClusterNotFound","matcher":"error","state":"retry"}]},"ClusterDeleted":{"delay":60,"operation":"DescribeClusters","maxAttempts":30,"acceptors":[{"expected":"ClusterNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"Clusters[].ClusterStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"Clusters[].ClusterStatus"}]},"ClusterRestored":{"operation":"DescribeClusters","maxAttempts":30,"delay":60,"acceptors":[{"state":"success","matcher":"pathAll","argument":"Clusters[].RestoreStatus.Status","expected":"completed"},{"state":"failure","matcher":"pathAny","argument":"Clusters[].ClusterStatus","expected":"deleting"}]},"SnapshotAvailable":{"delay":15,"operation":"DescribeClusterSnapshots","maxAttempts":20,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Snapshots[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"Snapshots[].Status"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"Snapshots[].Status"}]}}}');

});


parcelRequire.register("u577v", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $05a6c4f56ce38426$var$Service = $dbC7k.Service;
var $05a6c4f56ce38426$var$apiLoader = $dbC7k.apiLoader;
$05a6c4f56ce38426$var$apiLoader.services["resourcegroupstaggingapi"] = {};
$dbC7k.ResourceGroupsTaggingAPI = $05a6c4f56ce38426$var$Service.defineService("resourcegroupstaggingapi", [
    "2017-01-26"
]);


Object.defineProperty($05a6c4f56ce38426$var$apiLoader.services["resourcegroupstaggingapi"], "2017-01-26", {
    get: function get() {
        var model = (parcelRequire("bucnX"));
        model.paginators = (parcelRequire("4gYMM")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ResourceGroupsTaggingAPI;

});
parcelRequire.register("bucnX", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-01-26","endpointPrefix":"tagging","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Resource Groups Tagging API","serviceId":"Resource Groups Tagging API","signatureVersion":"v4","targetPrefix":"ResourceGroupsTaggingAPI_20170126","uid":"resourcegroupstaggingapi-2017-01-26"},"operations":{"GetResources":{"input":{"type":"structure","members":{"PaginationToken":{},"TagFilters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"ResourcesPerPage":{"type":"integer"},"TagsPerPage":{"type":"integer"},"ResourceTypeFilters":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"PaginationToken":{},"ResourceTagMappingList":{"type":"list","member":{"type":"structure","members":{"ResourceARN":{},"Tags":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}}}}}}}},"GetTagKeys":{"input":{"type":"structure","members":{"PaginationToken":{}}},"output":{"type":"structure","members":{"PaginationToken":{},"TagKeys":{"type":"list","member":{}}}}},"GetTagValues":{"input":{"type":"structure","required":["Key"],"members":{"PaginationToken":{},"Key":{}}},"output":{"type":"structure","members":{"PaginationToken":{},"TagValues":{"type":"list","member":{}}}}},"TagResources":{"input":{"type":"structure","required":["ResourceARNList","Tags"],"members":{"ResourceARNList":{"shape":"Sp"},"Tags":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","members":{"FailedResourcesMap":{"shape":"Ss"}}}},"UntagResources":{"input":{"type":"structure","required":["ResourceARNList","TagKeys"],"members":{"ResourceARNList":{"shape":"Sp"},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"FailedResourcesMap":{"shape":"Ss"}}}}},"shapes":{"Sp":{"type":"list","member":{}},"Ss":{"type":"map","key":{},"value":{"type":"structure","members":{"StatusCode":{"type":"integer"},"ErrorCode":{},"ErrorMessage":{}}}}}}');

});

parcelRequire.register("4gYMM", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"GetResources":{"input_token":"PaginationToken","limit_key":"ResourcesPerPage","output_token":"PaginationToken","result_key":"ResourceTagMappingList"},"GetTagKeys":{"input_token":"PaginationToken","output_token":"PaginationToken","result_key":"TagKeys"},"GetTagValues":{"input_token":"PaginationToken","output_token":"PaginationToken","result_key":"TagValues"}}}');

});


parcelRequire.register("au73S", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $7a222f0201e13961$var$Service = $dbC7k.Service;
var $7a222f0201e13961$var$apiLoader = $dbC7k.apiLoader;
$7a222f0201e13961$var$apiLoader.services["route53"] = {};
$dbC7k.Route53 = $7a222f0201e13961$var$Service.defineService("route53", [
    "2013-04-01"
]);
parcelRequire("l1zqY");



Object.defineProperty($7a222f0201e13961$var$apiLoader.services["route53"], "2013-04-01", {
    get: function get() {
        var model = (parcelRequire("19rXM"));
        model.paginators = (parcelRequire("fhyLn")).pagination;
        model.waiters = (parcelRequire("fioHJ")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Route53;

});
parcelRequire.register("l1zqY", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
$dbC7k.util.update($dbC7k.Route53.prototype, {
    /**
   * @api private
   */ setupRequestListeners: function setupRequestListeners(request) {
        request.on("build", this.sanitizeUrl);
    },
    /**
   * @api private
   */ sanitizeUrl: function sanitizeUrl(request) {
        var path = request.httpRequest.path;
        request.httpRequest.path = path.replace(/\/%2F\w+%2F/, "/");
    },
    /**
   * @return [Boolean] whether the error can be retried
   * @api private
   */ retryableError: function retryableError(error) {
        if (error.code === "PriorRequestNotComplete" && error.statusCode === 400) return true;
        else {
            var _super = $dbC7k.Service.prototype.retryableError;
            return _super.call(this, error);
        }
    }
});

});

parcelRequire.register("19rXM", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2013-04-01","endpointPrefix":"route53","globalEndpoint":"route53.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"Route 53","serviceFullName":"Amazon Route 53","serviceId":"Route 53","signatureVersion":"v4","uid":"route53-2013-04-01"},"operations":{"AssociateVPCWithHostedZone":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/associatevpc"},"input":{"locationName":"AssociateVPCWithHostedZoneRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"S3"},"Comment":{}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S8"}}}},"ChangeResourceRecordSets":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/rrset/"},"input":{"locationName":"ChangeResourceRecordSetsRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","ChangeBatch"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"ChangeBatch":{"type":"structure","required":["Changes"],"members":{"Comment":{},"Changes":{"type":"list","member":{"locationName":"Change","type":"structure","required":["Action","ResourceRecordSet"],"members":{"Action":{},"ResourceRecordSet":{"shape":"Sh"}}}}}}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S8"}}}},"ChangeTagsForResource":{"http":{"requestUri":"/2013-04-01/tags/{ResourceType}/{ResourceId}"},"input":{"locationName":"ChangeTagsForResourceRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{"location":"uri","locationName":"ResourceType"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"AddTags":{"shape":"S15"},"RemoveTagKeys":{"type":"list","member":{"locationName":"Key"}}}},"output":{"type":"structure","members":{}}},"CreateHealthCheck":{"http":{"requestUri":"/2013-04-01/healthcheck","responseCode":201},"input":{"locationName":"CreateHealthCheckRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["CallerReference","HealthCheckConfig"],"members":{"CallerReference":{},"HealthCheckConfig":{"shape":"S1d"}}},"output":{"type":"structure","required":["HealthCheck","Location"],"members":{"HealthCheck":{"shape":"S1z"},"Location":{"location":"header","locationName":"Location"}}}},"CreateHostedZone":{"http":{"requestUri":"/2013-04-01/hostedzone","responseCode":201},"input":{"locationName":"CreateHostedZoneRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Name","CallerReference"],"members":{"Name":{},"VPC":{"shape":"S3"},"CallerReference":{},"HostedZoneConfig":{"shape":"S2h"},"DelegationSetId":{}}},"output":{"type":"structure","required":["HostedZone","ChangeInfo","DelegationSet","Location"],"members":{"HostedZone":{"shape":"S2k"},"ChangeInfo":{"shape":"S8"},"DelegationSet":{"shape":"S2m"},"VPC":{"shape":"S3"},"Location":{"location":"header","locationName":"Location"}}}},"CreateQueryLoggingConfig":{"http":{"requestUri":"/2013-04-01/queryloggingconfig","responseCode":201},"input":{"locationName":"CreateQueryLoggingConfigRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","CloudWatchLogsLogGroupArn"],"members":{"HostedZoneId":{},"CloudWatchLogsLogGroupArn":{}}},"output":{"type":"structure","required":["QueryLoggingConfig","Location"],"members":{"QueryLoggingConfig":{"shape":"S2r"},"Location":{"location":"header","locationName":"Location"}}}},"CreateReusableDelegationSet":{"http":{"requestUri":"/2013-04-01/delegationset","responseCode":201},"input":{"locationName":"CreateReusableDelegationSetRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"HostedZoneId":{}}},"output":{"type":"structure","required":["DelegationSet","Location"],"members":{"DelegationSet":{"shape":"S2m"},"Location":{"location":"header","locationName":"Location"}}}},"CreateTrafficPolicy":{"http":{"requestUri":"/2013-04-01/trafficpolicy","responseCode":201},"input":{"locationName":"CreateTrafficPolicyRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Name","Document"],"members":{"Name":{},"Document":{},"Comment":{}}},"output":{"type":"structure","required":["TrafficPolicy","Location"],"members":{"TrafficPolicy":{"shape":"S30"},"Location":{"location":"header","locationName":"Location"}}}},"CreateTrafficPolicyInstance":{"http":{"requestUri":"/2013-04-01/trafficpolicyinstance","responseCode":201},"input":{"locationName":"CreateTrafficPolicyInstanceRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","Name","TTL","TrafficPolicyId","TrafficPolicyVersion"],"members":{"HostedZoneId":{},"Name":{},"TTL":{"type":"long"},"TrafficPolicyId":{},"TrafficPolicyVersion":{"type":"integer"}}},"output":{"type":"structure","required":["TrafficPolicyInstance","Location"],"members":{"TrafficPolicyInstance":{"shape":"S35"},"Location":{"location":"header","locationName":"Location"}}}},"CreateTrafficPolicyVersion":{"http":{"requestUri":"/2013-04-01/trafficpolicy/{Id}","responseCode":201},"input":{"locationName":"CreateTrafficPolicyVersionRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id","Document"],"members":{"Id":{"location":"uri","locationName":"Id"},"Document":{},"Comment":{}}},"output":{"type":"structure","required":["TrafficPolicy","Location"],"members":{"TrafficPolicy":{"shape":"S30"},"Location":{"location":"header","locationName":"Location"}}}},"CreateVPCAssociationAuthorization":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/authorizevpcassociation"},"input":{"locationName":"CreateVPCAssociationAuthorizationRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"S3"}}},"output":{"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{},"VPC":{"shape":"S3"}}}},"DeleteHealthCheck":{"http":{"method":"DELETE","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","members":{}}},"DeleteHostedZone":{"http":{"method":"DELETE","requestUri":"/2013-04-01/hostedzone/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S8"}}}},"DeleteQueryLoggingConfig":{"http":{"method":"DELETE","requestUri":"/2013-04-01/queryloggingconfig/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteReusableDelegationSet":{"http":{"method":"DELETE","requestUri":"/2013-04-01/delegationset/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteTrafficPolicy":{"http":{"method":"DELETE","requestUri":"/2013-04-01/trafficpolicy/{Id}/{Version}"},"input":{"type":"structure","required":["Id","Version"],"members":{"Id":{"location":"uri","locationName":"Id"},"Version":{"location":"uri","locationName":"Version","type":"integer"}}},"output":{"type":"structure","members":{}}},"DeleteTrafficPolicyInstance":{"http":{"method":"DELETE","requestUri":"/2013-04-01/trafficpolicyinstance/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteVPCAssociationAuthorization":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/deauthorizevpcassociation"},"input":{"locationName":"DeleteVPCAssociationAuthorizationRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"DisassociateVPCFromHostedZone":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/disassociatevpc"},"input":{"locationName":"DisassociateVPCFromHostedZoneRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"S3"},"Comment":{}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S8"}}}},"GetAccountLimit":{"http":{"method":"GET","requestUri":"/2013-04-01/accountlimit/{Type}"},"input":{"type":"structure","required":["Type"],"members":{"Type":{"location":"uri","locationName":"Type"}}},"output":{"type":"structure","required":["Limit","Count"],"members":{"Limit":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{"type":"long"}}},"Count":{"type":"long"}}}},"GetChange":{"http":{"method":"GET","requestUri":"/2013-04-01/change/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S8"}}}},"GetCheckerIpRanges":{"http":{"method":"GET","requestUri":"/2013-04-01/checkeripranges"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["CheckerIpRanges"],"members":{"CheckerIpRanges":{"type":"list","member":{}}}}},"GetGeoLocation":{"http":{"method":"GET","requestUri":"/2013-04-01/geolocation"},"input":{"type":"structure","members":{"ContinentCode":{"location":"querystring","locationName":"continentcode"},"CountryCode":{"location":"querystring","locationName":"countrycode"},"SubdivisionCode":{"location":"querystring","locationName":"subdivisioncode"}}},"output":{"type":"structure","required":["GeoLocationDetails"],"members":{"GeoLocationDetails":{"shape":"S47"}}}},"GetHealthCheck":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","required":["HealthCheck"],"members":{"HealthCheck":{"shape":"S1z"}}}},"GetHealthCheckCount":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheckcount"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["HealthCheckCount"],"members":{"HealthCheckCount":{"type":"long"}}}},"GetHealthCheckLastFailureReason":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}/lastfailurereason"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","required":["HealthCheckObservations"],"members":{"HealthCheckObservations":{"shape":"S4i"}}}},"GetHealthCheckStatus":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}/status"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","required":["HealthCheckObservations"],"members":{"HealthCheckObservations":{"shape":"S4i"}}}},"GetHostedZone":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["HostedZone"],"members":{"HostedZone":{"shape":"S2k"},"DelegationSet":{"shape":"S2m"},"VPCs":{"shape":"S4q"}}}},"GetHostedZoneCount":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzonecount"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["HostedZoneCount"],"members":{"HostedZoneCount":{"type":"long"}}}},"GetHostedZoneLimit":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzonelimit/{Id}/{Type}"},"input":{"type":"structure","required":["Type","HostedZoneId"],"members":{"Type":{"location":"uri","locationName":"Type"},"HostedZoneId":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["Limit","Count"],"members":{"Limit":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{"type":"long"}}},"Count":{"type":"long"}}}},"GetQueryLoggingConfig":{"http":{"method":"GET","requestUri":"/2013-04-01/queryloggingconfig/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["QueryLoggingConfig"],"members":{"QueryLoggingConfig":{"shape":"S2r"}}}},"GetReusableDelegationSet":{"http":{"method":"GET","requestUri":"/2013-04-01/delegationset/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["DelegationSet"],"members":{"DelegationSet":{"shape":"S2m"}}}},"GetReusableDelegationSetLimit":{"http":{"method":"GET","requestUri":"/2013-04-01/reusabledelegationsetlimit/{Id}/{Type}"},"input":{"type":"structure","required":["Type","DelegationSetId"],"members":{"Type":{"location":"uri","locationName":"Type"},"DelegationSetId":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["Limit","Count"],"members":{"Limit":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{"type":"long"}}},"Count":{"type":"long"}}}},"GetTrafficPolicy":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicy/{Id}/{Version}"},"input":{"type":"structure","required":["Id","Version"],"members":{"Id":{"location":"uri","locationName":"Id"},"Version":{"location":"uri","locationName":"Version","type":"integer"}}},"output":{"type":"structure","required":["TrafficPolicy"],"members":{"TrafficPolicy":{"shape":"S30"}}}},"GetTrafficPolicyInstance":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstance/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["TrafficPolicyInstance"],"members":{"TrafficPolicyInstance":{"shape":"S35"}}}},"GetTrafficPolicyInstanceCount":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstancecount"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["TrafficPolicyInstanceCount"],"members":{"TrafficPolicyInstanceCount":{"type":"integer"}}}},"ListGeoLocations":{"http":{"method":"GET","requestUri":"/2013-04-01/geolocations"},"input":{"type":"structure","members":{"StartContinentCode":{"location":"querystring","locationName":"startcontinentcode"},"StartCountryCode":{"location":"querystring","locationName":"startcountrycode"},"StartSubdivisionCode":{"location":"querystring","locationName":"startsubdivisioncode"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["GeoLocationDetailsList","IsTruncated","MaxItems"],"members":{"GeoLocationDetailsList":{"type":"list","member":{"shape":"S47","locationName":"GeoLocationDetails"}},"IsTruncated":{"type":"boolean"},"NextContinentCode":{},"NextCountryCode":{},"NextSubdivisionCode":{},"MaxItems":{}}}},"ListHealthChecks":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"marker"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["HealthChecks","Marker","IsTruncated","MaxItems"],"members":{"HealthChecks":{"type":"list","member":{"shape":"S1z","locationName":"HealthCheck"}},"Marker":{},"IsTruncated":{"type":"boolean"},"NextMarker":{},"MaxItems":{}}}},"ListHostedZones":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"marker"},"MaxItems":{"location":"querystring","locationName":"maxitems"},"DelegationSetId":{"location":"querystring","locationName":"delegationsetid"}}},"output":{"type":"structure","required":["HostedZones","Marker","IsTruncated","MaxItems"],"members":{"HostedZones":{"shape":"S5o"},"Marker":{},"IsTruncated":{"type":"boolean"},"NextMarker":{},"MaxItems":{}}}},"ListHostedZonesByName":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzonesbyname"},"input":{"type":"structure","members":{"DNSName":{"location":"querystring","locationName":"dnsname"},"HostedZoneId":{"location":"querystring","locationName":"hostedzoneid"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["HostedZones","IsTruncated","MaxItems"],"members":{"HostedZones":{"shape":"S5o"},"DNSName":{},"HostedZoneId":{},"IsTruncated":{"type":"boolean"},"NextDNSName":{},"NextHostedZoneId":{},"MaxItems":{}}}},"ListQueryLoggingConfigs":{"http":{"method":"GET","requestUri":"/2013-04-01/queryloggingconfig"},"input":{"type":"structure","members":{"HostedZoneId":{"location":"querystring","locationName":"hostedzoneid"},"NextToken":{"location":"querystring","locationName":"nexttoken"},"MaxResults":{"location":"querystring","locationName":"maxresults"}}},"output":{"type":"structure","required":["QueryLoggingConfigs"],"members":{"QueryLoggingConfigs":{"type":"list","member":{"shape":"S2r","locationName":"QueryLoggingConfig"}},"NextToken":{}}}},"ListResourceRecordSets":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone/{Id}/rrset"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"StartRecordName":{"location":"querystring","locationName":"name"},"StartRecordType":{"location":"querystring","locationName":"type"},"StartRecordIdentifier":{"location":"querystring","locationName":"identifier"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["ResourceRecordSets","IsTruncated","MaxItems"],"members":{"ResourceRecordSets":{"type":"list","member":{"shape":"Sh","locationName":"ResourceRecordSet"}},"IsTruncated":{"type":"boolean"},"NextRecordName":{},"NextRecordType":{},"NextRecordIdentifier":{},"MaxItems":{}}}},"ListReusableDelegationSets":{"http":{"method":"GET","requestUri":"/2013-04-01/delegationset"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"marker"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["DelegationSets","Marker","IsTruncated","MaxItems"],"members":{"DelegationSets":{"type":"list","member":{"shape":"S2m","locationName":"DelegationSet"}},"Marker":{},"IsTruncated":{"type":"boolean"},"NextMarker":{},"MaxItems":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2013-04-01/tags/{ResourceType}/{ResourceId}"},"input":{"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{"location":"uri","locationName":"ResourceType"},"ResourceId":{"location":"uri","locationName":"ResourceId"}}},"output":{"type":"structure","required":["ResourceTagSet"],"members":{"ResourceTagSet":{"shape":"S64"}}}},"ListTagsForResources":{"http":{"requestUri":"/2013-04-01/tags/{ResourceType}"},"input":{"locationName":"ListTagsForResourcesRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["ResourceType","ResourceIds"],"members":{"ResourceType":{"location":"uri","locationName":"ResourceType"},"ResourceIds":{"type":"list","member":{"locationName":"ResourceId"}}}},"output":{"type":"structure","required":["ResourceTagSets"],"members":{"ResourceTagSets":{"type":"list","member":{"shape":"S64","locationName":"ResourceTagSet"}}}}},"ListTrafficPolicies":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicies"},"input":{"type":"structure","members":{"TrafficPolicyIdMarker":{"location":"querystring","locationName":"trafficpolicyid"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicySummaries","IsTruncated","TrafficPolicyIdMarker","MaxItems"],"members":{"TrafficPolicySummaries":{"type":"list","member":{"locationName":"TrafficPolicySummary","type":"structure","required":["Id","Name","Type","LatestVersion","TrafficPolicyCount"],"members":{"Id":{},"Name":{},"Type":{},"LatestVersion":{"type":"integer"},"TrafficPolicyCount":{"type":"integer"}}}},"IsTruncated":{"type":"boolean"},"TrafficPolicyIdMarker":{},"MaxItems":{}}}},"ListTrafficPolicyInstances":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstances"},"input":{"type":"structure","members":{"HostedZoneIdMarker":{"location":"querystring","locationName":"hostedzoneid"},"TrafficPolicyInstanceNameMarker":{"location":"querystring","locationName":"trafficpolicyinstancename"},"TrafficPolicyInstanceTypeMarker":{"location":"querystring","locationName":"trafficpolicyinstancetype"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicyInstances","IsTruncated","MaxItems"],"members":{"TrafficPolicyInstances":{"shape":"S6f"},"HostedZoneIdMarker":{},"TrafficPolicyInstanceNameMarker":{},"TrafficPolicyInstanceTypeMarker":{},"IsTruncated":{"type":"boolean"},"MaxItems":{}}}},"ListTrafficPolicyInstancesByHostedZone":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstances/hostedzone"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"querystring","locationName":"id"},"TrafficPolicyInstanceNameMarker":{"location":"querystring","locationName":"trafficpolicyinstancename"},"TrafficPolicyInstanceTypeMarker":{"location":"querystring","locationName":"trafficpolicyinstancetype"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicyInstances","IsTruncated","MaxItems"],"members":{"TrafficPolicyInstances":{"shape":"S6f"},"TrafficPolicyInstanceNameMarker":{},"TrafficPolicyInstanceTypeMarker":{},"IsTruncated":{"type":"boolean"},"MaxItems":{}}}},"ListTrafficPolicyInstancesByPolicy":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstances/trafficpolicy"},"input":{"type":"structure","required":["TrafficPolicyId","TrafficPolicyVersion"],"members":{"TrafficPolicyId":{"location":"querystring","locationName":"id"},"TrafficPolicyVersion":{"location":"querystring","locationName":"version","type":"integer"},"HostedZoneIdMarker":{"location":"querystring","locationName":"hostedzoneid"},"TrafficPolicyInstanceNameMarker":{"location":"querystring","locationName":"trafficpolicyinstancename"},"TrafficPolicyInstanceTypeMarker":{"location":"querystring","locationName":"trafficpolicyinstancetype"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicyInstances","IsTruncated","MaxItems"],"members":{"TrafficPolicyInstances":{"shape":"S6f"},"HostedZoneIdMarker":{},"TrafficPolicyInstanceNameMarker":{},"TrafficPolicyInstanceTypeMarker":{},"IsTruncated":{"type":"boolean"},"MaxItems":{}}}},"ListTrafficPolicyVersions":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicies/{Id}/versions"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"TrafficPolicyVersionMarker":{"location":"querystring","locationName":"trafficpolicyversion"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicies","IsTruncated","TrafficPolicyVersionMarker","MaxItems"],"members":{"TrafficPolicies":{"type":"list","member":{"shape":"S30","locationName":"TrafficPolicy"}},"IsTruncated":{"type":"boolean"},"TrafficPolicyVersionMarker":{},"MaxItems":{}}}},"ListVPCAssociationAuthorizations":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone/{Id}/authorizevpcassociation"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"NextToken":{"location":"querystring","locationName":"nexttoken"},"MaxResults":{"location":"querystring","locationName":"maxresults"}}},"output":{"type":"structure","required":["HostedZoneId","VPCs"],"members":{"HostedZoneId":{},"NextToken":{},"VPCs":{"shape":"S4q"}}}},"TestDNSAnswer":{"http":{"method":"GET","requestUri":"/2013-04-01/testdnsanswer"},"input":{"type":"structure","required":["HostedZoneId","RecordName","RecordType"],"members":{"HostedZoneId":{"location":"querystring","locationName":"hostedzoneid"},"RecordName":{"location":"querystring","locationName":"recordname"},"RecordType":{"location":"querystring","locationName":"recordtype"},"ResolverIP":{"location":"querystring","locationName":"resolverip"},"EDNS0ClientSubnetIP":{"location":"querystring","locationName":"edns0clientsubnetip"},"EDNS0ClientSubnetMask":{"location":"querystring","locationName":"edns0clientsubnetmask"}}},"output":{"type":"structure","required":["Nameserver","RecordName","RecordType","RecordData","ResponseCode","Protocol"],"members":{"Nameserver":{},"RecordName":{},"RecordType":{},"RecordData":{"type":"list","member":{"locationName":"RecordDataEntry"}},"ResponseCode":{},"Protocol":{}}}},"UpdateHealthCheck":{"http":{"requestUri":"/2013-04-01/healthcheck/{HealthCheckId}"},"input":{"locationName":"UpdateHealthCheckRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"},"HealthCheckVersion":{"type":"long"},"IPAddress":{},"Port":{"type":"integer"},"ResourcePath":{},"FullyQualifiedDomainName":{},"SearchString":{},"FailureThreshold":{"type":"integer"},"Inverted":{"type":"boolean"},"Disabled":{"type":"boolean"},"HealthThreshold":{"type":"integer"},"ChildHealthChecks":{"shape":"S1q"},"EnableSNI":{"type":"boolean"},"Regions":{"shape":"S1s"},"AlarmIdentifier":{"shape":"S1u"},"InsufficientDataHealthStatus":{},"ResetElements":{"type":"list","member":{"locationName":"ResettableElementName"}}}},"output":{"type":"structure","required":["HealthCheck"],"members":{"HealthCheck":{"shape":"S1z"}}}},"UpdateHostedZoneComment":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}"},"input":{"locationName":"UpdateHostedZoneCommentRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"Comment":{}}},"output":{"type":"structure","required":["HostedZone"],"members":{"HostedZone":{"shape":"S2k"}}}},"UpdateTrafficPolicyComment":{"http":{"requestUri":"/2013-04-01/trafficpolicy/{Id}/{Version}"},"input":{"locationName":"UpdateTrafficPolicyCommentRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id","Version","Comment"],"members":{"Id":{"location":"uri","locationName":"Id"},"Version":{"location":"uri","locationName":"Version","type":"integer"},"Comment":{}}},"output":{"type":"structure","required":["TrafficPolicy"],"members":{"TrafficPolicy":{"shape":"S30"}}}},"UpdateTrafficPolicyInstance":{"http":{"requestUri":"/2013-04-01/trafficpolicyinstance/{Id}"},"input":{"locationName":"UpdateTrafficPolicyInstanceRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id","TTL","TrafficPolicyId","TrafficPolicyVersion"],"members":{"Id":{"location":"uri","locationName":"Id"},"TTL":{"type":"long"},"TrafficPolicyId":{},"TrafficPolicyVersion":{"type":"integer"}}},"output":{"type":"structure","required":["TrafficPolicyInstance"],"members":{"TrafficPolicyInstance":{"shape":"S35"}}}}},"shapes":{"S3":{"type":"structure","members":{"VPCRegion":{},"VPCId":{}}},"S8":{"type":"structure","required":["Id","Status","SubmittedAt"],"members":{"Id":{},"Status":{},"SubmittedAt":{"type":"timestamp"},"Comment":{}}},"Sh":{"type":"structure","required":["Name","Type"],"members":{"Name":{},"Type":{},"SetIdentifier":{},"Weight":{"type":"long"},"Region":{},"GeoLocation":{"type":"structure","members":{"ContinentCode":{},"CountryCode":{},"SubdivisionCode":{}}},"Failover":{},"MultiValueAnswer":{"type":"boolean"},"TTL":{"type":"long"},"ResourceRecords":{"type":"list","member":{"locationName":"ResourceRecord","type":"structure","required":["Value"],"members":{"Value":{}}}},"AliasTarget":{"type":"structure","required":["HostedZoneId","DNSName","EvaluateTargetHealth"],"members":{"HostedZoneId":{},"DNSName":{},"EvaluateTargetHealth":{"type":"boolean"}}},"HealthCheckId":{},"TrafficPolicyInstanceId":{}}},"S15":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"S1d":{"type":"structure","required":["Type"],"members":{"IPAddress":{},"Port":{"type":"integer"},"Type":{},"ResourcePath":{},"FullyQualifiedDomainName":{},"SearchString":{},"RequestInterval":{"type":"integer"},"FailureThreshold":{"type":"integer"},"MeasureLatency":{"type":"boolean"},"Inverted":{"type":"boolean"},"Disabled":{"type":"boolean"},"HealthThreshold":{"type":"integer"},"ChildHealthChecks":{"shape":"S1q"},"EnableSNI":{"type":"boolean"},"Regions":{"shape":"S1s"},"AlarmIdentifier":{"shape":"S1u"},"InsufficientDataHealthStatus":{}}},"S1q":{"type":"list","member":{"locationName":"ChildHealthCheck"}},"S1s":{"type":"list","member":{"locationName":"Region"}},"S1u":{"type":"structure","required":["Region","Name"],"members":{"Region":{},"Name":{}}},"S1z":{"type":"structure","required":["Id","CallerReference","HealthCheckConfig","HealthCheckVersion"],"members":{"Id":{},"CallerReference":{},"LinkedService":{"shape":"S20"},"HealthCheckConfig":{"shape":"S1d"},"HealthCheckVersion":{"type":"long"},"CloudWatchAlarmConfiguration":{"type":"structure","required":["EvaluationPeriods","Threshold","ComparisonOperator","Period","MetricName","Namespace","Statistic"],"members":{"EvaluationPeriods":{"type":"integer"},"Threshold":{"type":"double"},"ComparisonOperator":{},"Period":{"type":"integer"},"MetricName":{},"Namespace":{},"Statistic":{},"Dimensions":{"type":"list","member":{"locationName":"Dimension","type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}}}}}},"S20":{"type":"structure","members":{"ServicePrincipal":{},"Description":{}}},"S2h":{"type":"structure","members":{"Comment":{},"PrivateZone":{"type":"boolean"}}},"S2k":{"type":"structure","required":["Id","Name","CallerReference"],"members":{"Id":{},"Name":{},"CallerReference":{},"Config":{"shape":"S2h"},"ResourceRecordSetCount":{"type":"long"},"LinkedService":{"shape":"S20"}}},"S2m":{"type":"structure","required":["NameServers"],"members":{"Id":{},"CallerReference":{},"NameServers":{"type":"list","member":{"locationName":"NameServer"}}}},"S2r":{"type":"structure","required":["Id","HostedZoneId","CloudWatchLogsLogGroupArn"],"members":{"Id":{},"HostedZoneId":{},"CloudWatchLogsLogGroupArn":{}}},"S30":{"type":"structure","required":["Id","Version","Name","Type","Document"],"members":{"Id":{},"Version":{"type":"integer"},"Name":{},"Type":{},"Document":{},"Comment":{}}},"S35":{"type":"structure","required":["Id","HostedZoneId","Name","TTL","State","Message","TrafficPolicyId","TrafficPolicyVersion","TrafficPolicyType"],"members":{"Id":{},"HostedZoneId":{},"Name":{},"TTL":{"type":"long"},"State":{},"Message":{},"TrafficPolicyId":{},"TrafficPolicyVersion":{"type":"integer"},"TrafficPolicyType":{}}},"S47":{"type":"structure","members":{"ContinentCode":{},"ContinentName":{},"CountryCode":{},"CountryName":{},"SubdivisionCode":{},"SubdivisionName":{}}},"S4i":{"type":"list","member":{"locationName":"HealthCheckObservation","type":"structure","members":{"Region":{},"IPAddress":{},"StatusReport":{"type":"structure","members":{"Status":{},"CheckedTime":{"type":"timestamp"}}}}}},"S4q":{"type":"list","member":{"shape":"S3","locationName":"VPC"}},"S5o":{"type":"list","member":{"shape":"S2k","locationName":"HostedZone"}},"S64":{"type":"structure","members":{"ResourceType":{},"ResourceId":{},"Tags":{"shape":"S15"}}},"S6f":{"type":"list","member":{"shape":"S35","locationName":"TrafficPolicyInstance"}}}}');

});

parcelRequire.register("fhyLn", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListHealthChecks":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"NextMarker","result_key":"HealthChecks"},"ListHostedZones":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"NextMarker","result_key":"HostedZones"},"ListResourceRecordSets":{"input_token":["StartRecordName","StartRecordType","StartRecordIdentifier"],"limit_key":"MaxItems","more_results":"IsTruncated","output_token":["NextRecordName","NextRecordType","NextRecordIdentifier"],"result_key":"ResourceRecordSets"}}}');

});

parcelRequire.register("fioHJ", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"ResourceRecordSetsChanged":{"delay":30,"maxAttempts":60,"operation":"GetChange","acceptors":[{"matcher":"path","expected":"INSYNC","argument":"ChangeInfo.Status","state":"success"}]}}}');

});


parcelRequire.register("3nF3q", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $27635d9b12a75d5a$var$Service = $dbC7k.Service;
var $27635d9b12a75d5a$var$apiLoader = $dbC7k.apiLoader;
$27635d9b12a75d5a$var$apiLoader.services["route53domains"] = {};
$dbC7k.Route53Domains = $27635d9b12a75d5a$var$Service.defineService("route53domains", [
    "2014-05-15"
]);


Object.defineProperty($27635d9b12a75d5a$var$apiLoader.services["route53domains"], "2014-05-15", {
    get: function get() {
        var model = (parcelRequire("deQrs"));
        model.paginators = (parcelRequire("iADBq")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Route53Domains;

});
parcelRequire.register("deQrs", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2014-05-15","endpointPrefix":"route53domains","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Route 53 Domains","serviceId":"Route 53 Domains","signatureVersion":"v4","targetPrefix":"Route53Domains_v20140515","uid":"route53domains-2014-05-15"},"operations":{"CheckDomainAvailability":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"IdnLangCode":{}}},"output":{"type":"structure","required":["Availability"],"members":{"Availability":{}}}},"CheckDomainTransferability":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AuthCode":{"shape":"S7"}}},"output":{"type":"structure","required":["Transferability"],"members":{"Transferability":{"type":"structure","members":{"Transferable":{}}}}}},"DeleteTagsForDomain":{"input":{"type":"structure","required":["DomainName","TagsToDelete"],"members":{"DomainName":{},"TagsToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"DisableDomainAutoRenew":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{}}},"DisableDomainTransferLock":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"EnableDomainAutoRenew":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{}}},"EnableDomainTransferLock":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"GetContactReachabilityStatus":{"input":{"type":"structure","members":{"domainName":{}}},"output":{"type":"structure","members":{"domainName":{},"status":{}}}},"GetDomainDetail":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["DomainName","Nameservers","AdminContact","RegistrantContact","TechContact"],"members":{"DomainName":{},"Nameservers":{"shape":"St"},"AutoRenew":{"type":"boolean"},"AdminContact":{"shape":"Sz"},"RegistrantContact":{"shape":"Sz"},"TechContact":{"shape":"Sz"},"AdminPrivacy":{"type":"boolean"},"RegistrantPrivacy":{"type":"boolean"},"TechPrivacy":{"type":"boolean"},"RegistrarName":{},"WhoIsServer":{},"RegistrarUrl":{},"AbuseContactEmail":{},"AbuseContactPhone":{},"RegistryDomainId":{},"CreationDate":{"type":"timestamp"},"UpdatedDate":{"type":"timestamp"},"ExpirationDate":{"type":"timestamp"},"Reseller":{},"DnsSec":{},"StatusList":{"type":"list","member":{}}}}},"GetDomainSuggestions":{"input":{"type":"structure","required":["DomainName","SuggestionCount","OnlyAvailable"],"members":{"DomainName":{},"SuggestionCount":{"type":"integer"},"OnlyAvailable":{"type":"boolean"}}},"output":{"type":"structure","members":{"SuggestionsList":{"type":"list","member":{"type":"structure","members":{"DomainName":{},"Availability":{}}}}}}},"GetOperationDetail":{"input":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}},"output":{"type":"structure","members":{"OperationId":{},"Status":{},"Message":{},"DomainName":{},"Type":{},"SubmittedDate":{"type":"timestamp"}}}},"ListDomains":{"input":{"type":"structure","members":{"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","required":["Domains"],"members":{"Domains":{"type":"list","member":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AutoRenew":{"type":"boolean"},"TransferLock":{"type":"boolean"},"Expiry":{"type":"timestamp"}}}},"NextPageMarker":{}}}},"ListOperations":{"input":{"type":"structure","members":{"SubmittedSince":{"type":"timestamp"},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","required":["Operations"],"members":{"Operations":{"type":"list","member":{"type":"structure","required":["OperationId","Status","Type","SubmittedDate"],"members":{"OperationId":{},"Status":{},"Type":{},"SubmittedDate":{"type":"timestamp"}}}},"NextPageMarker":{}}}},"ListTagsForDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["TagList"],"members":{"TagList":{"shape":"S29"}}}},"RegisterDomain":{"input":{"type":"structure","required":["DomainName","DurationInYears","AdminContact","RegistrantContact","TechContact"],"members":{"DomainName":{},"IdnLangCode":{},"DurationInYears":{"type":"integer"},"AutoRenew":{"type":"boolean"},"AdminContact":{"shape":"Sz"},"RegistrantContact":{"shape":"Sz"},"TechContact":{"shape":"Sz"},"PrivacyProtectAdminContact":{"type":"boolean"},"PrivacyProtectRegistrantContact":{"type":"boolean"},"PrivacyProtectTechContact":{"type":"boolean"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"RenewDomain":{"input":{"type":"structure","required":["DomainName","CurrentExpiryYear"],"members":{"DomainName":{},"DurationInYears":{"type":"integer"},"CurrentExpiryYear":{"type":"integer"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"ResendContactReachabilityEmail":{"input":{"type":"structure","members":{"domainName":{}}},"output":{"type":"structure","members":{"domainName":{},"emailAddress":{},"isAlreadyVerified":{"type":"boolean"}}}},"RetrieveDomainAuthCode":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","required":["AuthCode"],"members":{"AuthCode":{"shape":"S7"}}}},"TransferDomain":{"input":{"type":"structure","required":["DomainName","DurationInYears","AdminContact","RegistrantContact","TechContact"],"members":{"DomainName":{},"IdnLangCode":{},"DurationInYears":{"type":"integer"},"Nameservers":{"shape":"St"},"AuthCode":{"shape":"S7"},"AutoRenew":{"type":"boolean"},"AdminContact":{"shape":"Sz"},"RegistrantContact":{"shape":"Sz"},"TechContact":{"shape":"Sz"},"PrivacyProtectAdminContact":{"type":"boolean"},"PrivacyProtectRegistrantContact":{"type":"boolean"},"PrivacyProtectTechContact":{"type":"boolean"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"UpdateDomainContact":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AdminContact":{"shape":"Sz"},"RegistrantContact":{"shape":"Sz"},"TechContact":{"shape":"Sz"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"UpdateDomainContactPrivacy":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AdminPrivacy":{"type":"boolean"},"RegistrantPrivacy":{"type":"boolean"},"TechPrivacy":{"type":"boolean"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"UpdateDomainNameservers":{"input":{"type":"structure","required":["DomainName","Nameservers"],"members":{"DomainName":{},"FIAuthKey":{"deprecated":true},"Nameservers":{"shape":"St"}}},"output":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"UpdateTagsForDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"TagsToUpdate":{"shape":"S29"}}},"output":{"type":"structure","members":{}}},"ViewBilling":{"input":{"type":"structure","members":{"Start":{"type":"timestamp"},"End":{"type":"timestamp"},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","members":{"NextPageMarker":{},"BillingRecords":{"type":"list","member":{"type":"structure","members":{"DomainName":{},"Operation":{},"InvoiceId":{},"BillDate":{"type":"timestamp"},"Price":{"type":"double"}}}}}}}},"shapes":{"S7":{"type":"string","sensitive":true},"St":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"GlueIps":{"type":"list","member":{}}}}},"Sz":{"type":"structure","members":{"FirstName":{},"LastName":{},"ContactType":{},"OrganizationName":{},"AddressLine1":{},"AddressLine2":{},"City":{},"State":{},"CountryCode":{},"ZipCode":{},"PhoneNumber":{},"Email":{},"Fax":{},"ExtraParams":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}}},"sensitive":true},"S29":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}');

});

parcelRequire.register("iADBq", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListDomains":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextPageMarker","result_key":"Domains"},"ListOperations":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextPageMarker","result_key":"Operations"}}}');

});


parcelRequire.register("iokjV", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $d63a3b1be49f9f92$var$Service = $dbC7k.Service;
var $d63a3b1be49f9f92$var$apiLoader = $dbC7k.apiLoader;
$d63a3b1be49f9f92$var$apiLoader.services["s3control"] = {};
$dbC7k.S3Control = $d63a3b1be49f9f92$var$Service.defineService("s3control", [
    "2018-08-20"
]);
parcelRequire("l2pv2");


Object.defineProperty($d63a3b1be49f9f92$var$apiLoader.services["s3control"], "2018-08-20", {
    get: function get() {
        var model = (parcelRequire("4ijiM"));
        model.paginators = (parcelRequire("gioZJ")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.S3Control;

});
parcelRequire.register("l2pv2", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
$dbC7k.util.update($dbC7k.S3Control.prototype, {
    /**
   * @api private
   */ setupRequestListeners: function setupRequestListeners(request) {
        request.addListener("afterBuild", this.prependAccountId);
        request.addListener("extractError", this.extractHostId);
        request.addListener("extractData", this.extractHostId);
        request.addListener("validate", this.validateAccountId);
    },
    /**
   * @api private
   */ prependAccountId: function(request) {
        var api = request.service.api;
        var operationModel = api.operations[request.operation];
        var inputModel = operationModel.input;
        var params = request.params;
        if (inputModel.members.AccountId && params.AccountId) {
            //customization needed
            var accountId = params.AccountId;
            var endpoint = request.httpRequest.endpoint;
            var newHostname = String(accountId) + "." + endpoint.hostname;
            endpoint.hostname = newHostname;
            request.httpRequest.headers.Host = newHostname;
            delete request.httpRequest.headers["x-amz-account-id"];
        }
    },
    /**
   * @api private
   */ extractHostId: function(response) {
        var hostId = response.httpResponse.headers ? response.httpResponse.headers["x-amz-id-2"] : null;
        response.extendedRequestId = hostId;
        if (response.error) response.error.extendedRequestId = hostId;
    },
    /**
   * @api private
   */ validateAccountId: function(request) {
        var params = request.params;
        if (!Object.prototype.hasOwnProperty.call(params, "AccountId")) return;
        var accountId = params.AccountId;
        //validate type
        if (typeof accountId !== "string") throw $dbC7k.util.error(new Error(), {
            code: "ValidationError",
            message: "AccountId must be a string."
        });
        //validate length
        if (accountId.length < 1 || accountId.length > 63) throw $dbC7k.util.error(new Error(), {
            code: "ValidationError",
            message: "AccountId length should be between 1 to 63 characters, inclusive."
        });
        //validate pattern
        var hostPattern = /^[a-zA-Z0-9]{1}$|^[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9]$/;
        if (!hostPattern.test(accountId)) throw $dbC7k.util.error(new Error(), {
            code: "ValidationError",
            message: "AccountId should be hostname compatible. AccountId: " + accountId
        });
    }
});

});

parcelRequire.register("4ijiM", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-08-20","endpointPrefix":"s3-control","protocol":"rest-xml","serviceFullName":"AWS S3 Control","serviceId":"S3 Control","signatureVersion":"s3v4","signingName":"s3","uid":"s3control-2018-08-20"},"operations":{"CreateJob":{"http":{"requestUri":"/v20180820/jobs"},"input":{"locationName":"CreateJobRequest","xmlNamespace":{"uri":"http://awss3control.amazonaws.com/doc/2018-08-20/"},"type":"structure","required":["AccountId","Operation","Report","ClientRequestToken","Manifest","Priority","RoleArn"],"members":{"AccountId":{"location":"header","locationName":"x-amz-account-id"},"ConfirmationRequired":{"type":"boolean"},"Operation":{"shape":"S4"},"Report":{"shape":"S12"},"ClientRequestToken":{"idempotencyToken":true},"Manifest":{"shape":"S17"},"Description":{},"Priority":{"type":"integer"},"RoleArn":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"DeletePublicAccessBlock":{"http":{"method":"DELETE","requestUri":"/v20180820/configuration/publicAccessBlock"},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"location":"header","locationName":"x-amz-account-id"}}}},"DescribeJob":{"http":{"method":"GET","requestUri":"/v20180820/jobs/{id}"},"input":{"type":"structure","required":["AccountId","JobId"],"members":{"AccountId":{"location":"header","locationName":"x-amz-account-id"},"JobId":{"location":"uri","locationName":"id"}}},"output":{"type":"structure","members":{"Job":{"type":"structure","members":{"JobId":{},"ConfirmationRequired":{"type":"boolean"},"Description":{},"JobArn":{},"Status":{},"Manifest":{"shape":"S17"},"Operation":{"shape":"S4"},"Priority":{"type":"integer"},"ProgressSummary":{"shape":"S1q"},"StatusUpdateReason":{},"FailureReasons":{"type":"list","member":{"type":"structure","members":{"FailureCode":{},"FailureReason":{}}}},"Report":{"shape":"S12"},"CreationTime":{"type":"timestamp"},"TerminationDate":{"type":"timestamp"},"RoleArn":{},"SuspendedDate":{"type":"timestamp"},"SuspendedCause":{}}}}}},"GetPublicAccessBlock":{"http":{"method":"GET","requestUri":"/v20180820/configuration/publicAccessBlock"},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"location":"header","locationName":"x-amz-account-id"}}},"output":{"type":"structure","members":{"PublicAccessBlockConfiguration":{"shape":"S25"}},"payload":"PublicAccessBlockConfiguration"}},"ListJobs":{"http":{"method":"GET","requestUri":"/v20180820/jobs"},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"location":"header","locationName":"x-amz-account-id"},"JobStatuses":{"location":"querystring","locationName":"jobStatuses","type":"list","member":{}},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"Jobs":{"type":"list","member":{"type":"structure","members":{"JobId":{},"Description":{},"Operation":{},"Priority":{"type":"integer"},"Status":{},"CreationTime":{"type":"timestamp"},"TerminationDate":{"type":"timestamp"},"ProgressSummary":{"shape":"S1q"}}}}}}},"PutPublicAccessBlock":{"http":{"method":"PUT","requestUri":"/v20180820/configuration/publicAccessBlock"},"input":{"type":"structure","required":["PublicAccessBlockConfiguration","AccountId"],"members":{"PublicAccessBlockConfiguration":{"shape":"S25","locationName":"PublicAccessBlockConfiguration","xmlNamespace":{"uri":"http://awss3control.amazonaws.com/doc/2018-08-20/"}},"AccountId":{"location":"header","locationName":"x-amz-account-id"}},"payload":"PublicAccessBlockConfiguration"}},"UpdateJobPriority":{"http":{"requestUri":"/v20180820/jobs/{id}/priority"},"input":{"type":"structure","required":["AccountId","JobId","Priority"],"members":{"AccountId":{"location":"header","locationName":"x-amz-account-id"},"JobId":{"location":"uri","locationName":"id"},"Priority":{"location":"querystring","locationName":"priority","type":"integer"}}},"output":{"type":"structure","required":["JobId","Priority"],"members":{"JobId":{},"Priority":{"type":"integer"}}}},"UpdateJobStatus":{"http":{"requestUri":"/v20180820/jobs/{id}/status"},"input":{"type":"structure","required":["AccountId","JobId","RequestedJobStatus"],"members":{"AccountId":{"location":"header","locationName":"x-amz-account-id"},"JobId":{"location":"uri","locationName":"id"},"RequestedJobStatus":{"location":"querystring","locationName":"requestedJobStatus"},"StatusUpdateReason":{"location":"querystring","locationName":"statusUpdateReason"}}},"output":{"type":"structure","members":{"JobId":{},"Status":{},"StatusUpdateReason":{}}}}},"shapes":{"S4":{"type":"structure","members":{"LambdaInvoke":{"type":"structure","members":{"FunctionArn":{}}},"S3PutObjectCopy":{"type":"structure","members":{"TargetResource":{},"CannedAccessControlList":{},"AccessControlGrants":{"shape":"Sa"},"MetadataDirective":{},"ModifiedSinceConstraint":{"type":"timestamp"},"NewObjectMetadata":{"type":"structure","members":{"CacheControl":{},"ContentDisposition":{},"ContentEncoding":{},"ContentLanguage":{},"UserMetadata":{"type":"map","key":{},"value":{}},"ContentLength":{"type":"long"},"ContentMD5":{},"ContentType":{},"HttpExpiresDate":{"type":"timestamp"},"RequesterCharged":{"type":"boolean"},"SSEAlgorithm":{}}},"NewObjectTagging":{"shape":"Sn"},"RedirectLocation":{},"RequesterPays":{"type":"boolean"},"StorageClass":{},"UnModifiedSinceConstraint":{"type":"timestamp"},"SSEAwsKmsKeyId":{},"TargetKeyPrefix":{},"ObjectLockLegalHoldStatus":{},"ObjectLockMode":{},"ObjectLockRetainUntilDate":{"type":"timestamp"}}},"S3PutObjectAcl":{"type":"structure","members":{"AccessControlPolicy":{"type":"structure","members":{"AccessControlList":{"type":"structure","required":["Owner"],"members":{"Owner":{"type":"structure","members":{"ID":{},"DisplayName":{}}},"Grants":{"shape":"Sa"}}},"CannedAccessControlList":{}}}}},"S3PutObjectTagging":{"type":"structure","members":{"TagSet":{"shape":"Sn"}}},"S3InitiateRestoreObject":{"type":"structure","members":{"ExpirationInDays":{"type":"integer"},"GlacierJobTier":{}}}}},"Sa":{"type":"list","member":{"type":"structure","members":{"Grantee":{"type":"structure","members":{"TypeIdentifier":{},"Identifier":{},"DisplayName":{}}},"Permission":{}}}},"Sn":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S12":{"type":"structure","required":["Enabled"],"members":{"Bucket":{},"Format":{},"Enabled":{"type":"boolean"},"Prefix":{},"ReportScope":{}}},"S17":{"type":"structure","required":["Spec","Location"],"members":{"Spec":{"type":"structure","required":["Format"],"members":{"Format":{},"Fields":{"type":"list","member":{}}}},"Location":{"type":"structure","required":["ObjectArn","ETag"],"members":{"ObjectArn":{},"ObjectVersionId":{},"ETag":{}}}}},"S1q":{"type":"structure","members":{"TotalNumberOfTasks":{"type":"long"},"NumberOfTasksSucceeded":{"type":"long"},"NumberOfTasksFailed":{"type":"long"}}},"S25":{"type":"structure","members":{"BlockPublicAcls":{"locationName":"BlockPublicAcls","type":"boolean"},"IgnorePublicAcls":{"locationName":"IgnorePublicAcls","type":"boolean"},"BlockPublicPolicy":{"locationName":"BlockPublicPolicy","type":"boolean"},"RestrictPublicBuckets":{"locationName":"RestrictPublicBuckets","type":"boolean"}}}}}');

});

parcelRequire.register("gioZJ", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("g3uvH", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $bb0497e22e1c32bb$var$Service = $dbC7k.Service;
var $bb0497e22e1c32bb$var$apiLoader = $dbC7k.apiLoader;
$bb0497e22e1c32bb$var$apiLoader.services["servicecatalog"] = {};
$dbC7k.ServiceCatalog = $bb0497e22e1c32bb$var$Service.defineService("servicecatalog", [
    "2015-12-10"
]);


Object.defineProperty($bb0497e22e1c32bb$var$apiLoader.services["servicecatalog"], "2015-12-10", {
    get: function get() {
        var model = (parcelRequire("7tGA9"));
        model.paginators = (parcelRequire("1hqNH")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ServiceCatalog;

});
parcelRequire.register("7tGA9", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-12-10","endpointPrefix":"servicecatalog","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Service Catalog","serviceId":"Service Catalog","signatureVersion":"v4","targetPrefix":"AWS242ServiceCatalogService","uid":"servicecatalog-2015-12-10"},"operations":{"AcceptPortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PortfolioShareType":{}}},"output":{"type":"structure","members":{}}},"AssociateBudgetWithResource":{"input":{"type":"structure","required":["BudgetName","ResourceId"],"members":{"BudgetName":{},"ResourceId":{}}},"output":{"type":"structure","members":{}}},"AssociatePrincipalWithPortfolio":{"input":{"type":"structure","required":["PortfolioId","PrincipalARN","PrincipalType"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PrincipalARN":{},"PrincipalType":{}}},"output":{"type":"structure","members":{}}},"AssociateProductWithPortfolio":{"input":{"type":"structure","required":["ProductId","PortfolioId"],"members":{"AcceptLanguage":{},"ProductId":{},"PortfolioId":{},"SourcePortfolioId":{}}},"output":{"type":"structure","members":{}}},"AssociateServiceActionWithProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId","ServiceActionId"],"members":{"ProductId":{},"ProvisioningArtifactId":{},"ServiceActionId":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{}}},"AssociateTagOptionWithResource":{"input":{"type":"structure","required":["ResourceId","TagOptionId"],"members":{"ResourceId":{},"TagOptionId":{}}},"output":{"type":"structure","members":{}}},"BatchAssociateServiceActionWithProvisioningArtifact":{"input":{"type":"structure","required":["ServiceActionAssociations"],"members":{"ServiceActionAssociations":{"shape":"Sm"},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"FailedServiceActionAssociations":{"shape":"Sp"}}}},"BatchDisassociateServiceActionFromProvisioningArtifact":{"input":{"type":"structure","required":["ServiceActionAssociations"],"members":{"ServiceActionAssociations":{"shape":"Sm"},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"FailedServiceActionAssociations":{"shape":"Sp"}}}},"CopyProduct":{"input":{"type":"structure","required":["SourceProductArn","IdempotencyToken"],"members":{"AcceptLanguage":{},"SourceProductArn":{},"TargetProductId":{},"TargetProductName":{},"SourceProvisioningArtifactIdentifiers":{"type":"list","member":{"type":"map","key":{},"value":{}}},"CopyOptions":{"type":"list","member":{}},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"CopyProductToken":{}}}},"CreateConstraint":{"input":{"type":"structure","required":["PortfolioId","ProductId","Parameters","Type","IdempotencyToken"],"members":{"AcceptLanguage":{},"PortfolioId":{},"ProductId":{},"Parameters":{},"Type":{},"Description":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ConstraintDetail":{"shape":"S1b"},"ConstraintParameters":{},"Status":{}}}},"CreatePortfolio":{"input":{"type":"structure","required":["DisplayName","ProviderName","IdempotencyToken"],"members":{"AcceptLanguage":{},"DisplayName":{},"Description":{},"ProviderName":{},"Tags":{"shape":"S1i"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"PortfolioDetail":{"shape":"S1n"},"Tags":{"shape":"S1q"}}}},"CreatePortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"AccountId":{},"OrganizationNode":{"shape":"S1s"}}},"output":{"type":"structure","members":{"PortfolioShareToken":{}}}},"CreateProduct":{"input":{"type":"structure","required":["Name","Owner","ProductType","ProvisioningArtifactParameters","IdempotencyToken"],"members":{"AcceptLanguage":{},"Name":{},"Owner":{},"Description":{},"Distributor":{},"SupportDescription":{},"SupportEmail":{},"SupportUrl":{},"ProductType":{},"Tags":{"shape":"S1i"},"ProvisioningArtifactParameters":{"shape":"S23"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ProductViewDetail":{"shape":"S2c"},"ProvisioningArtifactDetail":{"shape":"S2h"},"Tags":{"shape":"S1q"}}}},"CreateProvisionedProductPlan":{"input":{"type":"structure","required":["PlanName","PlanType","ProductId","ProvisionedProductName","ProvisioningArtifactId","IdempotencyToken"],"members":{"AcceptLanguage":{},"PlanName":{},"PlanType":{},"NotificationArns":{"shape":"S2n"},"PathId":{},"ProductId":{},"ProvisionedProductName":{},"ProvisioningArtifactId":{},"ProvisioningParameters":{"shape":"S2q"},"IdempotencyToken":{"idempotencyToken":true},"Tags":{"shape":"S1q"}}},"output":{"type":"structure","members":{"PlanName":{},"PlanId":{},"ProvisionProductId":{},"ProvisionedProductName":{},"ProvisioningArtifactId":{}}}},"CreateProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","Parameters","IdempotencyToken"],"members":{"AcceptLanguage":{},"ProductId":{},"Parameters":{"shape":"S23"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetail":{"shape":"S2h"},"Info":{"shape":"S26"},"Status":{}}}},"CreateServiceAction":{"input":{"type":"structure","required":["Name","DefinitionType","Definition","IdempotencyToken"],"members":{"Name":{},"DefinitionType":{},"Definition":{"shape":"S31"},"Description":{},"AcceptLanguage":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ServiceActionDetail":{"shape":"S36"}}}},"CreateTagOption":{"input":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"output":{"type":"structure","members":{"TagOptionDetail":{"shape":"S3c"}}}},"DeleteConstraint":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{}}},"DeletePortfolio":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{}}},"DeletePortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"AccountId":{},"OrganizationNode":{"shape":"S1s"}}},"output":{"type":"structure","members":{"PortfolioShareToken":{}}}},"DeleteProduct":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{}}},"DeleteProvisionedProductPlan":{"input":{"type":"structure","required":["PlanId"],"members":{"AcceptLanguage":{},"PlanId":{},"IgnoreErrors":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{}}},"output":{"type":"structure","members":{}}},"DeleteServiceAction":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{}}},"DeleteTagOption":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{}}},"DescribeConstraint":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ConstraintDetail":{"shape":"S1b"},"ConstraintParameters":{},"Status":{}}}},"DescribeCopyProductStatus":{"input":{"type":"structure","required":["CopyProductToken"],"members":{"AcceptLanguage":{},"CopyProductToken":{}}},"output":{"type":"structure","members":{"CopyProductStatus":{},"TargetProductId":{},"StatusDetail":{}}}},"DescribePortfolio":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"PortfolioDetail":{"shape":"S1n"},"Tags":{"shape":"S1q"},"TagOptions":{"shape":"S43"},"Budgets":{"shape":"S44"}}}},"DescribePortfolioShareStatus":{"input":{"type":"structure","required":["PortfolioShareToken"],"members":{"PortfolioShareToken":{}}},"output":{"type":"structure","members":{"PortfolioShareToken":{},"PortfolioId":{},"OrganizationNodeValue":{},"Status":{},"ShareDetails":{"type":"structure","members":{"SuccessfulShares":{"type":"list","member":{}},"ShareErrors":{"type":"list","member":{"type":"structure","members":{"Accounts":{"type":"list","member":{}},"Message":{},"Error":{}}}}}}}}},"DescribeProduct":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ProductViewSummary":{"shape":"S2d"},"ProvisioningArtifacts":{"shape":"S4i"},"Budgets":{"shape":"S44"}}}},"DescribeProductAsAdmin":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ProductViewDetail":{"shape":"S2c"},"ProvisioningArtifactSummaries":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"CreatedTime":{"type":"timestamp"},"ProvisioningArtifactMetadata":{"shape":"S26"}}}},"Tags":{"shape":"S1q"},"TagOptions":{"shape":"S43"},"Budgets":{"shape":"S44"}}}},"DescribeProductView":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ProductViewSummary":{"shape":"S2d"},"ProvisioningArtifacts":{"shape":"S4i"}}}},"DescribeProvisionedProduct":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ProvisionedProductDetail":{"shape":"S4t"},"CloudWatchDashboards":{"type":"list","member":{"type":"structure","members":{"Name":{}}}}}}},"DescribeProvisionedProductPlan":{"input":{"type":"structure","required":["PlanId"],"members":{"AcceptLanguage":{},"PlanId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ProvisionedProductPlanDetails":{"type":"structure","members":{"CreatedTime":{"type":"timestamp"},"PathId":{},"ProductId":{},"PlanName":{},"PlanId":{},"ProvisionProductId":{},"ProvisionProductName":{},"PlanType":{},"ProvisioningArtifactId":{},"Status":{},"UpdatedTime":{"type":"timestamp"},"NotificationArns":{"shape":"S2n"},"ProvisioningParameters":{"shape":"S2q"},"Tags":{"shape":"S1q"},"StatusMessage":{}}},"ResourceChanges":{"type":"list","member":{"type":"structure","members":{"Action":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Replacement":{},"Scope":{"type":"list","member":{}},"Details":{"type":"list","member":{"type":"structure","members":{"Target":{"type":"structure","members":{"Attribute":{},"Name":{},"RequiresRecreation":{}}},"Evaluation":{},"CausingEntity":{}}}}}}},"NextPageToken":{}}}},"DescribeProvisioningArtifact":{"input":{"type":"structure","required":["ProvisioningArtifactId","ProductId"],"members":{"AcceptLanguage":{},"ProvisioningArtifactId":{},"ProductId":{},"Verbose":{"type":"boolean"}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetail":{"shape":"S2h"},"Info":{"shape":"S26"},"Status":{}}}},"DescribeProvisioningParameters":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{},"PathId":{}}},"output":{"type":"structure","members":{"ProvisioningArtifactParameters":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"DefaultValue":{},"ParameterType":{},"IsNoEcho":{"type":"boolean"},"Description":{},"ParameterConstraints":{"type":"structure","members":{"AllowedValues":{"type":"list","member":{}}}}}}},"ConstraintSummaries":{"shape":"S65"},"UsageInstructions":{"type":"list","member":{"type":"structure","members":{"Type":{},"Value":{}}}},"TagOptions":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"ProvisioningArtifactPreferences":{"type":"structure","members":{"StackSetAccounts":{"shape":"S6f"},"StackSetRegions":{"shape":"S6g"}}}}}},"DescribeRecord":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S6k"},"RecordOutputs":{"type":"list","member":{"type":"structure","members":{"OutputKey":{},"OutputValue":{},"Description":{}}}},"NextPageToken":{}}}},"DescribeServiceAction":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"ServiceActionDetail":{"shape":"S36"}}}},"DescribeServiceActionExecutionParameters":{"input":{"type":"structure","required":["ProvisionedProductId","ServiceActionId"],"members":{"ProvisionedProductId":{},"ServiceActionId":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"ServiceActionParameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"DefaultValues":{"shape":"S77"}}}}}}},"DescribeTagOption":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{"TagOptionDetail":{"shape":"S3c"}}}},"DisableAWSOrganizationsAccess":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DisassociateBudgetFromResource":{"input":{"type":"structure","required":["BudgetName","ResourceId"],"members":{"BudgetName":{},"ResourceId":{}}},"output":{"type":"structure","members":{}}},"DisassociatePrincipalFromPortfolio":{"input":{"type":"structure","required":["PortfolioId","PrincipalARN"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PrincipalARN":{}}},"output":{"type":"structure","members":{}}},"DisassociateProductFromPortfolio":{"input":{"type":"structure","required":["ProductId","PortfolioId"],"members":{"AcceptLanguage":{},"ProductId":{},"PortfolioId":{}}},"output":{"type":"structure","members":{}}},"DisassociateServiceActionFromProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId","ServiceActionId"],"members":{"ProductId":{},"ProvisioningArtifactId":{},"ServiceActionId":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{}}},"DisassociateTagOptionFromResource":{"input":{"type":"structure","required":["ResourceId","TagOptionId"],"members":{"ResourceId":{},"TagOptionId":{}}},"output":{"type":"structure","members":{}}},"EnableAWSOrganizationsAccess":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"ExecuteProvisionedProductPlan":{"input":{"type":"structure","required":["PlanId","IdempotencyToken"],"members":{"AcceptLanguage":{},"PlanId":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S6k"}}}},"ExecuteProvisionedProductServiceAction":{"input":{"type":"structure","required":["ProvisionedProductId","ServiceActionId","ExecuteToken"],"members":{"ProvisionedProductId":{},"ServiceActionId":{},"ExecuteToken":{"idempotencyToken":true},"AcceptLanguage":{},"Parameters":{"type":"map","key":{},"value":{"shape":"S77"}}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S6k"}}}},"GetAWSOrganizationsAccessStatus":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AccessStatus":{}}}},"ListAcceptedPortfolioShares":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PageToken":{},"PageSize":{"type":"integer"},"PortfolioShareType":{}}},"output":{"type":"structure","members":{"PortfolioDetails":{"shape":"S7z"},"NextPageToken":{}}}},"ListBudgetsForResource":{"input":{"type":"structure","required":["ResourceId"],"members":{"AcceptLanguage":{},"ResourceId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"Budgets":{"shape":"S44"},"NextPageToken":{}}}},"ListConstraintsForPortfolio":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"ProductId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ConstraintDetails":{"type":"list","member":{"shape":"S1b"}},"NextPageToken":{}}}},"ListLaunchPaths":{"input":{"type":"structure","required":["ProductId"],"members":{"AcceptLanguage":{},"ProductId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"LaunchPathSummaries":{"type":"list","member":{"type":"structure","members":{"Id":{},"ConstraintSummaries":{"shape":"S65"},"Tags":{"shape":"S1q"},"Name":{}}}},"NextPageToken":{}}}},"ListOrganizationPortfolioAccess":{"input":{"type":"structure","required":["PortfolioId","OrganizationNodeType"],"members":{"AcceptLanguage":{},"PortfolioId":{},"OrganizationNodeType":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"OrganizationNodes":{"type":"list","member":{"shape":"S1s"}},"NextPageToken":{}}}},"ListPortfolioAccess":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{}}},"output":{"type":"structure","members":{"AccountIds":{"type":"list","member":{}},"NextPageToken":{}}}},"ListPortfolios":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"PortfolioDetails":{"shape":"S7z"},"NextPageToken":{}}}},"ListPortfoliosForProduct":{"input":{"type":"structure","required":["ProductId"],"members":{"AcceptLanguage":{},"ProductId":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"PortfolioDetails":{"shape":"S7z"},"NextPageToken":{}}}},"ListPrincipalsForPortfolio":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"Principals":{"type":"list","member":{"type":"structure","members":{"PrincipalARN":{},"PrincipalType":{}}}},"NextPageToken":{}}}},"ListProvisionedProductPlans":{"input":{"type":"structure","members":{"AcceptLanguage":{},"ProvisionProductId":{},"PageSize":{"type":"integer"},"PageToken":{},"AccessLevelFilter":{"shape":"S8p"}}},"output":{"type":"structure","members":{"ProvisionedProductPlans":{"type":"list","member":{"type":"structure","members":{"PlanName":{},"PlanId":{},"ProvisionProductId":{},"ProvisionProductName":{},"PlanType":{},"ProvisioningArtifactId":{}}}},"NextPageToken":{}}}},"ListProvisioningArtifacts":{"input":{"type":"structure","required":["ProductId"],"members":{"AcceptLanguage":{},"ProductId":{}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetails":{"type":"list","member":{"shape":"S2h"}},"NextPageToken":{}}}},"ListProvisioningArtifactsForServiceAction":{"input":{"type":"structure","required":["ServiceActionId"],"members":{"ServiceActionId":{},"PageSize":{"type":"integer"},"PageToken":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"ProvisioningArtifactViews":{"type":"list","member":{"type":"structure","members":{"ProductViewSummary":{"shape":"S2d"},"ProvisioningArtifact":{"shape":"S4j"}}}},"NextPageToken":{}}}},"ListRecordHistory":{"input":{"type":"structure","members":{"AcceptLanguage":{},"AccessLevelFilter":{"shape":"S8p"},"SearchFilter":{"type":"structure","members":{"Key":{},"Value":{}}},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"RecordDetails":{"type":"list","member":{"shape":"S6k"}},"NextPageToken":{}}}},"ListResourcesForTagOption":{"input":{"type":"structure","required":["TagOptionId"],"members":{"TagOptionId":{},"ResourceType":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ResourceDetails":{"type":"list","member":{"type":"structure","members":{"Id":{},"ARN":{},"Name":{},"Description":{},"CreatedTime":{"type":"timestamp"}}}},"PageToken":{}}}},"ListServiceActions":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ServiceActionSummaries":{"shape":"S9k"},"NextPageToken":{}}}},"ListServiceActionsForProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId"],"members":{"ProductId":{},"ProvisioningArtifactId":{},"PageSize":{"type":"integer"},"PageToken":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"ServiceActionSummaries":{"shape":"S9k"},"NextPageToken":{}}}},"ListStackInstancesForProvisionedProduct":{"input":{"type":"structure","required":["ProvisionedProductId"],"members":{"AcceptLanguage":{},"ProvisionedProductId":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"StackInstances":{"type":"list","member":{"type":"structure","members":{"Account":{},"Region":{},"StackInstanceStatus":{}}}},"NextPageToken":{}}}},"ListTagOptions":{"input":{"type":"structure","members":{"Filters":{"type":"structure","members":{"Key":{},"Value":{},"Active":{"type":"boolean"}}},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"TagOptionDetails":{"shape":"S43"},"PageToken":{}}}},"ProvisionProduct":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId","ProvisionedProductName","ProvisionToken"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{},"PathId":{},"ProvisionedProductName":{},"ProvisioningParameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"ProvisioningPreferences":{"type":"structure","members":{"StackSetAccounts":{"shape":"S6f"},"StackSetRegions":{"shape":"S6g"},"StackSetFailureToleranceCount":{"type":"integer"},"StackSetFailureTolerancePercentage":{"type":"integer"},"StackSetMaxConcurrencyCount":{"type":"integer"},"StackSetMaxConcurrencyPercentage":{"type":"integer"}}},"Tags":{"shape":"S1q"},"NotificationArns":{"shape":"S2n"},"ProvisionToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S6k"}}}},"RejectPortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PortfolioShareType":{}}},"output":{"type":"structure","members":{}}},"ScanProvisionedProducts":{"input":{"type":"structure","members":{"AcceptLanguage":{},"AccessLevelFilter":{"shape":"S8p"},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ProvisionedProducts":{"type":"list","member":{"shape":"S4t"}},"NextPageToken":{}}}},"SearchProducts":{"input":{"type":"structure","members":{"AcceptLanguage":{},"Filters":{"shape":"Saa"},"PageSize":{"type":"integer"},"SortBy":{},"SortOrder":{},"PageToken":{}}},"output":{"type":"structure","members":{"ProductViewSummaries":{"type":"list","member":{"shape":"S2d"}},"ProductViewAggregations":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"Value":{},"ApproximateCount":{"type":"integer"}}}}},"NextPageToken":{}}}},"SearchProductsAsAdmin":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PortfolioId":{},"Filters":{"shape":"Saa"},"SortBy":{},"SortOrder":{},"PageToken":{},"PageSize":{"type":"integer"},"ProductSource":{}}},"output":{"type":"structure","members":{"ProductViewDetails":{"type":"list","member":{"shape":"S2c"}},"NextPageToken":{}}}},"SearchProvisionedProducts":{"input":{"type":"structure","members":{"AcceptLanguage":{},"AccessLevelFilter":{"shape":"S8p"},"Filters":{"type":"map","key":{},"value":{"type":"list","member":{}}},"SortBy":{},"SortOrder":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ProvisionedProducts":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{},"Type":{},"Id":{},"Status":{},"StatusMessage":{},"CreatedTime":{"type":"timestamp"},"IdempotencyToken":{},"LastRecordId":{},"Tags":{"shape":"S1q"},"PhysicalId":{},"ProductId":{},"ProvisioningArtifactId":{},"UserArn":{},"UserArnSession":{}}}},"TotalResultsCount":{"type":"integer"},"NextPageToken":{}}}},"TerminateProvisionedProduct":{"input":{"type":"structure","required":["TerminateToken"],"members":{"ProvisionedProductName":{},"ProvisionedProductId":{},"TerminateToken":{"idempotencyToken":true},"IgnoreErrors":{"type":"boolean"},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S6k"}}}},"UpdateConstraint":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"Description":{},"Parameters":{}}},"output":{"type":"structure","members":{"ConstraintDetail":{"shape":"S1b"},"ConstraintParameters":{},"Status":{}}}},"UpdatePortfolio":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"DisplayName":{},"Description":{},"ProviderName":{},"AddTags":{"shape":"S1i"},"RemoveTags":{"shape":"Sbb"}}},"output":{"type":"structure","members":{"PortfolioDetail":{"shape":"S1n"},"Tags":{"shape":"S1q"}}}},"UpdateProduct":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"Name":{},"Owner":{},"Description":{},"Distributor":{},"SupportDescription":{},"SupportEmail":{},"SupportUrl":{},"AddTags":{"shape":"S1i"},"RemoveTags":{"shape":"Sbb"}}},"output":{"type":"structure","members":{"ProductViewDetail":{"shape":"S2c"},"Tags":{"shape":"S1q"}}}},"UpdateProvisionedProduct":{"input":{"type":"structure","required":["UpdateToken"],"members":{"AcceptLanguage":{},"ProvisionedProductName":{},"ProvisionedProductId":{},"ProductId":{},"ProvisioningArtifactId":{},"PathId":{},"ProvisioningParameters":{"shape":"S2q"},"ProvisioningPreferences":{"type":"structure","members":{"StackSetAccounts":{"shape":"S6f"},"StackSetRegions":{"shape":"S6g"},"StackSetFailureToleranceCount":{"type":"integer"},"StackSetFailureTolerancePercentage":{"type":"integer"},"StackSetMaxConcurrencyCount":{"type":"integer"},"StackSetMaxConcurrencyPercentage":{"type":"integer"},"StackSetOperationType":{}}},"Tags":{"shape":"S1q"},"UpdateToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S6k"}}}},"UpdateProvisionedProductProperties":{"input":{"type":"structure","required":["ProvisionedProductId","ProvisionedProductProperties","IdempotencyToken"],"members":{"AcceptLanguage":{},"ProvisionedProductId":{},"ProvisionedProductProperties":{"shape":"Sbk"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ProvisionedProductId":{},"ProvisionedProductProperties":{"shape":"Sbk"},"RecordId":{},"Status":{}}}},"UpdateProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{},"Name":{},"Description":{},"Active":{"type":"boolean"},"Guidance":{}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetail":{"shape":"S2h"},"Info":{"shape":"S26"},"Status":{}}}},"UpdateServiceAction":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"Name":{},"Definition":{"shape":"S31"},"Description":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"ServiceActionDetail":{"shape":"S36"}}}},"UpdateTagOption":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"Value":{},"Active":{"type":"boolean"}}},"output":{"type":"structure","members":{"TagOptionDetail":{"shape":"S3c"}}}}},"shapes":{"Sm":{"type":"list","member":{"type":"structure","required":["ServiceActionId","ProductId","ProvisioningArtifactId"],"members":{"ServiceActionId":{},"ProductId":{},"ProvisioningArtifactId":{}}}},"Sp":{"type":"list","member":{"type":"structure","members":{"ServiceActionId":{},"ProductId":{},"ProvisioningArtifactId":{},"ErrorCode":{},"ErrorMessage":{}}}},"S1b":{"type":"structure","members":{"ConstraintId":{},"Type":{},"Description":{},"Owner":{}}},"S1i":{"type":"list","member":{"shape":"S1j"}},"S1j":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"S1n":{"type":"structure","members":{"Id":{},"ARN":{},"DisplayName":{},"Description":{},"CreatedTime":{"type":"timestamp"},"ProviderName":{}}},"S1q":{"type":"list","member":{"shape":"S1j"}},"S1s":{"type":"structure","members":{"Type":{},"Value":{}}},"S23":{"type":"structure","required":["Info"],"members":{"Name":{},"Description":{},"Info":{"shape":"S26"},"Type":{},"DisableTemplateValidation":{"type":"boolean"}}},"S26":{"type":"map","key":{},"value":{}},"S2c":{"type":"structure","members":{"ProductViewSummary":{"shape":"S2d"},"Status":{},"ProductARN":{},"CreatedTime":{"type":"timestamp"}}},"S2d":{"type":"structure","members":{"Id":{},"ProductId":{},"Name":{},"Owner":{},"ShortDescription":{},"Type":{},"Distributor":{},"HasDefaultPath":{"type":"boolean"},"SupportEmail":{},"SupportDescription":{},"SupportUrl":{}}},"S2h":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"Type":{},"CreatedTime":{"type":"timestamp"},"Active":{"type":"boolean"},"Guidance":{}}},"S2n":{"type":"list","member":{}},"S2q":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"UsePreviousValue":{"type":"boolean"}}}},"S31":{"type":"map","key":{},"value":{}},"S36":{"type":"structure","members":{"ServiceActionSummary":{"shape":"S37"},"Definition":{"shape":"S31"}}},"S37":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"DefinitionType":{}}},"S3c":{"type":"structure","members":{"Key":{},"Value":{},"Active":{"type":"boolean"},"Id":{}}},"S43":{"type":"list","member":{"shape":"S3c"}},"S44":{"type":"list","member":{"type":"structure","members":{"BudgetName":{}}}},"S4i":{"type":"list","member":{"shape":"S4j"}},"S4j":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"CreatedTime":{"type":"timestamp"},"Guidance":{}}},"S4t":{"type":"structure","members":{"Name":{},"Arn":{},"Type":{},"Id":{},"Status":{},"StatusMessage":{},"CreatedTime":{"type":"timestamp"},"IdempotencyToken":{},"LastRecordId":{},"ProductId":{},"ProvisioningArtifactId":{}}},"S65":{"type":"list","member":{"type":"structure","members":{"Type":{},"Description":{}}}},"S6f":{"type":"list","member":{}},"S6g":{"type":"list","member":{}},"S6k":{"type":"structure","members":{"RecordId":{},"ProvisionedProductName":{},"Status":{},"CreatedTime":{"type":"timestamp"},"UpdatedTime":{"type":"timestamp"},"ProvisionedProductType":{},"RecordType":{},"ProvisionedProductId":{},"ProductId":{},"ProvisioningArtifactId":{},"PathId":{},"RecordErrors":{"type":"list","member":{"type":"structure","members":{"Code":{},"Description":{}}}},"RecordTags":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}},"S77":{"type":"list","member":{}},"S7z":{"type":"list","member":{"shape":"S1n"}},"S8p":{"type":"structure","members":{"Key":{},"Value":{}}},"S9k":{"type":"list","member":{"shape":"S37"}},"Saa":{"type":"map","key":{},"value":{"type":"list","member":{}}},"Sbb":{"type":"list","member":{}},"Sbk":{"type":"map","key":{},"value":{}}}}');

});

parcelRequire.register("1hqNH", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListAcceptedPortfolioShares":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListBudgetsForResource":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListConstraintsForPortfolio":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListLaunchPaths":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListOrganizationPortfolioAccess":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListPortfolios":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListPortfoliosForProduct":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListPrincipalsForPortfolio":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListProvisioningArtifactsForServiceAction":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListResourcesForTagOption":{"input_token":"PageToken","output_token":"PageToken","limit_key":"PageSize"},"ListServiceActions":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListServiceActionsForProvisioningArtifact":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListTagOptions":{"input_token":"PageToken","output_token":"PageToken","limit_key":"PageSize"},"SearchProducts":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"SearchProductsAsAdmin":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"SearchProvisionedProducts":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"}}}');

});


parcelRequire.register("bMrsx", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $89397a3ced39448d$var$Service = $dbC7k.Service;
var $89397a3ced39448d$var$apiLoader = $dbC7k.apiLoader;
$89397a3ced39448d$var$apiLoader.services["ses"] = {};
$dbC7k.SES = $89397a3ced39448d$var$Service.defineService("ses", [
    "2010-12-01"
]);



Object.defineProperty($89397a3ced39448d$var$apiLoader.services["ses"], "2010-12-01", {
    get: function get() {
        var model = (parcelRequire("buZ8i"));
        model.paginators = (parcelRequire("1O7Vk")).pagination;
        model.waiters = (parcelRequire("3y08t")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.SES;

});
parcelRequire.register("buZ8i", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2010-12-01","endpointPrefix":"email","protocol":"query","serviceAbbreviation":"Amazon SES","serviceFullName":"Amazon Simple Email Service","serviceId":"SES","signatureVersion":"v4","signingName":"ses","uid":"email-2010-12-01","xmlNamespace":"http://ses.amazonaws.com/doc/2010-12-01/"},"operations":{"CloneReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName","OriginalRuleSetName"],"members":{"RuleSetName":{},"OriginalRuleSetName":{}}},"output":{"resultWrapper":"CloneReceiptRuleSetResult","type":"structure","members":{}}},"CreateConfigurationSet":{"input":{"type":"structure","required":["ConfigurationSet"],"members":{"ConfigurationSet":{"shape":"S5"}}},"output":{"resultWrapper":"CreateConfigurationSetResult","type":"structure","members":{}}},"CreateConfigurationSetEventDestination":{"input":{"type":"structure","required":["ConfigurationSetName","EventDestination"],"members":{"ConfigurationSetName":{},"EventDestination":{"shape":"S9"}}},"output":{"resultWrapper":"CreateConfigurationSetEventDestinationResult","type":"structure","members":{}}},"CreateConfigurationSetTrackingOptions":{"input":{"type":"structure","required":["ConfigurationSetName","TrackingOptions"],"members":{"ConfigurationSetName":{},"TrackingOptions":{"shape":"Sp"}}},"output":{"resultWrapper":"CreateConfigurationSetTrackingOptionsResult","type":"structure","members":{}}},"CreateCustomVerificationEmailTemplate":{"input":{"type":"structure","required":["TemplateName","FromEmailAddress","TemplateSubject","TemplateContent","SuccessRedirectionURL","FailureRedirectionURL"],"members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"TemplateContent":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"CreateReceiptFilter":{"input":{"type":"structure","required":["Filter"],"members":{"Filter":{"shape":"S10"}}},"output":{"resultWrapper":"CreateReceiptFilterResult","type":"structure","members":{}}},"CreateReceiptRule":{"input":{"type":"structure","required":["RuleSetName","Rule"],"members":{"RuleSetName":{},"After":{},"Rule":{"shape":"S18"}}},"output":{"resultWrapper":"CreateReceiptRuleResult","type":"structure","members":{}}},"CreateReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName"],"members":{"RuleSetName":{}}},"output":{"resultWrapper":"CreateReceiptRuleSetResult","type":"structure","members":{}}},"CreateTemplate":{"input":{"type":"structure","required":["Template"],"members":{"Template":{"shape":"S20"}}},"output":{"resultWrapper":"CreateTemplateResult","type":"structure","members":{}}},"DeleteConfigurationSet":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{}}},"output":{"resultWrapper":"DeleteConfigurationSetResult","type":"structure","members":{}}},"DeleteConfigurationSetEventDestination":{"input":{"type":"structure","required":["ConfigurationSetName","EventDestinationName"],"members":{"ConfigurationSetName":{},"EventDestinationName":{}}},"output":{"resultWrapper":"DeleteConfigurationSetEventDestinationResult","type":"structure","members":{}}},"DeleteConfigurationSetTrackingOptions":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{}}},"output":{"resultWrapper":"DeleteConfigurationSetTrackingOptionsResult","type":"structure","members":{}}},"DeleteCustomVerificationEmailTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}}},"DeleteIdentity":{"input":{"type":"structure","required":["Identity"],"members":{"Identity":{}}},"output":{"resultWrapper":"DeleteIdentityResult","type":"structure","members":{}}},"DeleteIdentityPolicy":{"input":{"type":"structure","required":["Identity","PolicyName"],"members":{"Identity":{},"PolicyName":{}}},"output":{"resultWrapper":"DeleteIdentityPolicyResult","type":"structure","members":{}}},"DeleteReceiptFilter":{"input":{"type":"structure","required":["FilterName"],"members":{"FilterName":{}}},"output":{"resultWrapper":"DeleteReceiptFilterResult","type":"structure","members":{}}},"DeleteReceiptRule":{"input":{"type":"structure","required":["RuleSetName","RuleName"],"members":{"RuleSetName":{},"RuleName":{}}},"output":{"resultWrapper":"DeleteReceiptRuleResult","type":"structure","members":{}}},"DeleteReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName"],"members":{"RuleSetName":{}}},"output":{"resultWrapper":"DeleteReceiptRuleSetResult","type":"structure","members":{}}},"DeleteTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}},"output":{"resultWrapper":"DeleteTemplateResult","type":"structure","members":{}}},"DeleteVerifiedEmailAddress":{"input":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{}}}},"DescribeActiveReceiptRuleSet":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"DescribeActiveReceiptRuleSetResult","type":"structure","members":{"Metadata":{"shape":"S2t"},"Rules":{"shape":"S2v"}}}},"DescribeConfigurationSet":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{},"ConfigurationSetAttributeNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeConfigurationSetResult","type":"structure","members":{"ConfigurationSet":{"shape":"S5"},"EventDestinations":{"type":"list","member":{"shape":"S9"}},"TrackingOptions":{"shape":"Sp"},"DeliveryOptions":{"shape":"S31"},"ReputationOptions":{"type":"structure","members":{"SendingEnabled":{"type":"boolean"},"ReputationMetricsEnabled":{"type":"boolean"},"LastFreshStart":{"type":"timestamp"}}}}}},"DescribeReceiptRule":{"input":{"type":"structure","required":["RuleSetName","RuleName"],"members":{"RuleSetName":{},"RuleName":{}}},"output":{"resultWrapper":"DescribeReceiptRuleResult","type":"structure","members":{"Rule":{"shape":"S18"}}}},"DescribeReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName"],"members":{"RuleSetName":{}}},"output":{"resultWrapper":"DescribeReceiptRuleSetResult","type":"structure","members":{"Metadata":{"shape":"S2t"},"Rules":{"shape":"S2v"}}}},"GetAccountSendingEnabled":{"output":{"resultWrapper":"GetAccountSendingEnabledResult","type":"structure","members":{"Enabled":{"type":"boolean"}}}},"GetCustomVerificationEmailTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}},"output":{"resultWrapper":"GetCustomVerificationEmailTemplateResult","type":"structure","members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"TemplateContent":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"GetIdentityDkimAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3c"}}},"output":{"resultWrapper":"GetIdentityDkimAttributesResult","type":"structure","required":["DkimAttributes"],"members":{"DkimAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["DkimEnabled","DkimVerificationStatus"],"members":{"DkimEnabled":{"type":"boolean"},"DkimVerificationStatus":{},"DkimTokens":{"shape":"S3h"}}}}}}},"GetIdentityMailFromDomainAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3c"}}},"output":{"resultWrapper":"GetIdentityMailFromDomainAttributesResult","type":"structure","required":["MailFromDomainAttributes"],"members":{"MailFromDomainAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["MailFromDomain","MailFromDomainStatus","BehaviorOnMXFailure"],"members":{"MailFromDomain":{},"MailFromDomainStatus":{},"BehaviorOnMXFailure":{}}}}}}},"GetIdentityNotificationAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3c"}}},"output":{"resultWrapper":"GetIdentityNotificationAttributesResult","type":"structure","required":["NotificationAttributes"],"members":{"NotificationAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["BounceTopic","ComplaintTopic","DeliveryTopic","ForwardingEnabled"],"members":{"BounceTopic":{},"ComplaintTopic":{},"DeliveryTopic":{},"ForwardingEnabled":{"type":"boolean"},"HeadersInBounceNotificationsEnabled":{"type":"boolean"},"HeadersInComplaintNotificationsEnabled":{"type":"boolean"},"HeadersInDeliveryNotificationsEnabled":{"type":"boolean"}}}}}}},"GetIdentityPolicies":{"input":{"type":"structure","required":["Identity","PolicyNames"],"members":{"Identity":{},"PolicyNames":{"shape":"S3w"}}},"output":{"resultWrapper":"GetIdentityPoliciesResult","type":"structure","required":["Policies"],"members":{"Policies":{"type":"map","key":{},"value":{}}}}},"GetIdentityVerificationAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3c"}}},"output":{"resultWrapper":"GetIdentityVerificationAttributesResult","type":"structure","required":["VerificationAttributes"],"members":{"VerificationAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["VerificationStatus"],"members":{"VerificationStatus":{},"VerificationToken":{}}}}}}},"GetSendQuota":{"output":{"resultWrapper":"GetSendQuotaResult","type":"structure","members":{"Max24HourSend":{"type":"double"},"MaxSendRate":{"type":"double"},"SentLast24Hours":{"type":"double"}}}},"GetSendStatistics":{"output":{"resultWrapper":"GetSendStatisticsResult","type":"structure","members":{"SendDataPoints":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"timestamp"},"DeliveryAttempts":{"type":"long"},"Bounces":{"type":"long"},"Complaints":{"type":"long"},"Rejects":{"type":"long"}}}}}}},"GetTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}},"output":{"resultWrapper":"GetTemplateResult","type":"structure","members":{"Template":{"shape":"S20"}}}},"ListConfigurationSets":{"input":{"type":"structure","members":{"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListConfigurationSetsResult","type":"structure","members":{"ConfigurationSets":{"type":"list","member":{"shape":"S5"}},"NextToken":{}}}},"ListCustomVerificationEmailTemplates":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListCustomVerificationEmailTemplatesResult","type":"structure","members":{"CustomVerificationEmailTemplates":{"type":"list","member":{"type":"structure","members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"NextToken":{}}}},"ListIdentities":{"input":{"type":"structure","members":{"IdentityType":{},"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListIdentitiesResult","type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3c"},"NextToken":{}}}},"ListIdentityPolicies":{"input":{"type":"structure","required":["Identity"],"members":{"Identity":{}}},"output":{"resultWrapper":"ListIdentityPoliciesResult","type":"structure","required":["PolicyNames"],"members":{"PolicyNames":{"shape":"S3w"}}}},"ListReceiptFilters":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"ListReceiptFiltersResult","type":"structure","members":{"Filters":{"type":"list","member":{"shape":"S10"}}}}},"ListReceiptRuleSets":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListReceiptRuleSetsResult","type":"structure","members":{"RuleSets":{"type":"list","member":{"shape":"S2t"}},"NextToken":{}}}},"ListTemplates":{"input":{"type":"structure","members":{"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListTemplatesResult","type":"structure","members":{"TemplatesMetadata":{"type":"list","member":{"type":"structure","members":{"Name":{},"CreatedTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListVerifiedEmailAddresses":{"output":{"resultWrapper":"ListVerifiedEmailAddressesResult","type":"structure","members":{"VerifiedEmailAddresses":{"shape":"S54"}}}},"PutConfigurationSetDeliveryOptions":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{},"DeliveryOptions":{"shape":"S31"}}},"output":{"resultWrapper":"PutConfigurationSetDeliveryOptionsResult","type":"structure","members":{}}},"PutIdentityPolicy":{"input":{"type":"structure","required":["Identity","PolicyName","Policy"],"members":{"Identity":{},"PolicyName":{},"Policy":{}}},"output":{"resultWrapper":"PutIdentityPolicyResult","type":"structure","members":{}}},"ReorderReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName","RuleNames"],"members":{"RuleSetName":{},"RuleNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"ReorderReceiptRuleSetResult","type":"structure","members":{}}},"SendBounce":{"input":{"type":"structure","required":["OriginalMessageId","BounceSender","BouncedRecipientInfoList"],"members":{"OriginalMessageId":{},"BounceSender":{},"Explanation":{},"MessageDsn":{"type":"structure","required":["ReportingMta"],"members":{"ReportingMta":{},"ArrivalDate":{"type":"timestamp"},"ExtensionFields":{"shape":"S5i"}}},"BouncedRecipientInfoList":{"type":"list","member":{"type":"structure","required":["Recipient"],"members":{"Recipient":{},"RecipientArn":{},"BounceType":{},"RecipientDsnFields":{"type":"structure","required":["Action","Status"],"members":{"FinalRecipient":{},"Action":{},"RemoteMta":{},"Status":{},"DiagnosticCode":{},"LastAttemptDate":{"type":"timestamp"},"ExtensionFields":{"shape":"S5i"}}}}}},"BounceSenderArn":{}}},"output":{"resultWrapper":"SendBounceResult","type":"structure","members":{"MessageId":{}}}},"SendBulkTemplatedEmail":{"input":{"type":"structure","required":["Source","Template","Destinations"],"members":{"Source":{},"SourceArn":{},"ReplyToAddresses":{"shape":"S54"},"ReturnPath":{},"ReturnPathArn":{},"ConfigurationSetName":{},"DefaultTags":{"shape":"S5x"},"Template":{},"TemplateArn":{},"DefaultTemplateData":{},"Destinations":{"type":"list","member":{"type":"structure","required":["Destination"],"members":{"Destination":{"shape":"S64"},"ReplacementTags":{"shape":"S5x"},"ReplacementTemplateData":{}}}}}},"output":{"resultWrapper":"SendBulkTemplatedEmailResult","type":"structure","required":["Status"],"members":{"Status":{"type":"list","member":{"type":"structure","members":{"Status":{},"Error":{},"MessageId":{}}}}}}},"SendCustomVerificationEmail":{"input":{"type":"structure","required":["EmailAddress","TemplateName"],"members":{"EmailAddress":{},"TemplateName":{},"ConfigurationSetName":{}}},"output":{"resultWrapper":"SendCustomVerificationEmailResult","type":"structure","members":{"MessageId":{}}}},"SendEmail":{"input":{"type":"structure","required":["Source","Destination","Message"],"members":{"Source":{},"Destination":{"shape":"S64"},"Message":{"type":"structure","required":["Subject","Body"],"members":{"Subject":{"shape":"S6e"},"Body":{"type":"structure","members":{"Text":{"shape":"S6e"},"Html":{"shape":"S6e"}}}}},"ReplyToAddresses":{"shape":"S54"},"ReturnPath":{},"SourceArn":{},"ReturnPathArn":{},"Tags":{"shape":"S5x"},"ConfigurationSetName":{}}},"output":{"resultWrapper":"SendEmailResult","type":"structure","required":["MessageId"],"members":{"MessageId":{}}}},"SendRawEmail":{"input":{"type":"structure","required":["RawMessage"],"members":{"Source":{},"Destinations":{"shape":"S54"},"RawMessage":{"type":"structure","required":["Data"],"members":{"Data":{"type":"blob"}}},"FromArn":{},"SourceArn":{},"ReturnPathArn":{},"Tags":{"shape":"S5x"},"ConfigurationSetName":{}}},"output":{"resultWrapper":"SendRawEmailResult","type":"structure","required":["MessageId"],"members":{"MessageId":{}}}},"SendTemplatedEmail":{"input":{"type":"structure","required":["Source","Destination","Template","TemplateData"],"members":{"Source":{},"Destination":{"shape":"S64"},"ReplyToAddresses":{"shape":"S54"},"ReturnPath":{},"SourceArn":{},"ReturnPathArn":{},"Tags":{"shape":"S5x"},"ConfigurationSetName":{},"Template":{},"TemplateArn":{},"TemplateData":{}}},"output":{"resultWrapper":"SendTemplatedEmailResult","type":"structure","required":["MessageId"],"members":{"MessageId":{}}}},"SetActiveReceiptRuleSet":{"input":{"type":"structure","members":{"RuleSetName":{}}},"output":{"resultWrapper":"SetActiveReceiptRuleSetResult","type":"structure","members":{}}},"SetIdentityDkimEnabled":{"input":{"type":"structure","required":["Identity","DkimEnabled"],"members":{"Identity":{},"DkimEnabled":{"type":"boolean"}}},"output":{"resultWrapper":"SetIdentityDkimEnabledResult","type":"structure","members":{}}},"SetIdentityFeedbackForwardingEnabled":{"input":{"type":"structure","required":["Identity","ForwardingEnabled"],"members":{"Identity":{},"ForwardingEnabled":{"type":"boolean"}}},"output":{"resultWrapper":"SetIdentityFeedbackForwardingEnabledResult","type":"structure","members":{}}},"SetIdentityHeadersInNotificationsEnabled":{"input":{"type":"structure","required":["Identity","NotificationType","Enabled"],"members":{"Identity":{},"NotificationType":{},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"SetIdentityHeadersInNotificationsEnabledResult","type":"structure","members":{}}},"SetIdentityMailFromDomain":{"input":{"type":"structure","required":["Identity"],"members":{"Identity":{},"MailFromDomain":{},"BehaviorOnMXFailure":{}}},"output":{"resultWrapper":"SetIdentityMailFromDomainResult","type":"structure","members":{}}},"SetIdentityNotificationTopic":{"input":{"type":"structure","required":["Identity","NotificationType"],"members":{"Identity":{},"NotificationType":{},"SnsTopic":{}}},"output":{"resultWrapper":"SetIdentityNotificationTopicResult","type":"structure","members":{}}},"SetReceiptRulePosition":{"input":{"type":"structure","required":["RuleSetName","RuleName"],"members":{"RuleSetName":{},"RuleName":{},"After":{}}},"output":{"resultWrapper":"SetReceiptRulePositionResult","type":"structure","members":{}}},"TestRenderTemplate":{"input":{"type":"structure","required":["TemplateName","TemplateData"],"members":{"TemplateName":{},"TemplateData":{}}},"output":{"resultWrapper":"TestRenderTemplateResult","type":"structure","members":{"RenderedTemplate":{}}}},"UpdateAccountSendingEnabled":{"input":{"type":"structure","members":{"Enabled":{"type":"boolean"}}}},"UpdateConfigurationSetEventDestination":{"input":{"type":"structure","required":["ConfigurationSetName","EventDestination"],"members":{"ConfigurationSetName":{},"EventDestination":{"shape":"S9"}}},"output":{"resultWrapper":"UpdateConfigurationSetEventDestinationResult","type":"structure","members":{}}},"UpdateConfigurationSetReputationMetricsEnabled":{"input":{"type":"structure","required":["ConfigurationSetName","Enabled"],"members":{"ConfigurationSetName":{},"Enabled":{"type":"boolean"}}}},"UpdateConfigurationSetSendingEnabled":{"input":{"type":"structure","required":["ConfigurationSetName","Enabled"],"members":{"ConfigurationSetName":{},"Enabled":{"type":"boolean"}}}},"UpdateConfigurationSetTrackingOptions":{"input":{"type":"structure","required":["ConfigurationSetName","TrackingOptions"],"members":{"ConfigurationSetName":{},"TrackingOptions":{"shape":"Sp"}}},"output":{"resultWrapper":"UpdateConfigurationSetTrackingOptionsResult","type":"structure","members":{}}},"UpdateCustomVerificationEmailTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"TemplateContent":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"UpdateReceiptRule":{"input":{"type":"structure","required":["RuleSetName","Rule"],"members":{"RuleSetName":{},"Rule":{"shape":"S18"}}},"output":{"resultWrapper":"UpdateReceiptRuleResult","type":"structure","members":{}}},"UpdateTemplate":{"input":{"type":"structure","required":["Template"],"members":{"Template":{"shape":"S20"}}},"output":{"resultWrapper":"UpdateTemplateResult","type":"structure","members":{}}},"VerifyDomainDkim":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"resultWrapper":"VerifyDomainDkimResult","type":"structure","required":["DkimTokens"],"members":{"DkimTokens":{"shape":"S3h"}}}},"VerifyDomainIdentity":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"resultWrapper":"VerifyDomainIdentityResult","type":"structure","required":["VerificationToken"],"members":{"VerificationToken":{}}}},"VerifyEmailAddress":{"input":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{}}}},"VerifyEmailIdentity":{"input":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{}}},"output":{"resultWrapper":"VerifyEmailIdentityResult","type":"structure","members":{}}}},"shapes":{"S5":{"type":"structure","required":["Name"],"members":{"Name":{}}},"S9":{"type":"structure","required":["Name","MatchingEventTypes"],"members":{"Name":{},"Enabled":{"type":"boolean"},"MatchingEventTypes":{"type":"list","member":{}},"KinesisFirehoseDestination":{"type":"structure","required":["IAMRoleARN","DeliveryStreamARN"],"members":{"IAMRoleARN":{},"DeliveryStreamARN":{}}},"CloudWatchDestination":{"type":"structure","required":["DimensionConfigurations"],"members":{"DimensionConfigurations":{"type":"list","member":{"type":"structure","required":["DimensionName","DimensionValueSource","DefaultDimensionValue"],"members":{"DimensionName":{},"DimensionValueSource":{},"DefaultDimensionValue":{}}}}}},"SNSDestination":{"type":"structure","required":["TopicARN"],"members":{"TopicARN":{}}}}},"Sp":{"type":"structure","members":{"CustomRedirectDomain":{}}},"S10":{"type":"structure","required":["Name","IpFilter"],"members":{"Name":{},"IpFilter":{"type":"structure","required":["Policy","Cidr"],"members":{"Policy":{},"Cidr":{}}}}},"S18":{"type":"structure","required":["Name"],"members":{"Name":{},"Enabled":{"type":"boolean"},"TlsPolicy":{},"Recipients":{"type":"list","member":{}},"Actions":{"type":"list","member":{"type":"structure","members":{"S3Action":{"type":"structure","required":["BucketName"],"members":{"TopicArn":{},"BucketName":{},"ObjectKeyPrefix":{},"KmsKeyArn":{}}},"BounceAction":{"type":"structure","required":["SmtpReplyCode","Message","Sender"],"members":{"TopicArn":{},"SmtpReplyCode":{},"StatusCode":{},"Message":{},"Sender":{}}},"WorkmailAction":{"type":"structure","required":["OrganizationArn"],"members":{"TopicArn":{},"OrganizationArn":{}}},"LambdaAction":{"type":"structure","required":["FunctionArn"],"members":{"TopicArn":{},"FunctionArn":{},"InvocationType":{}}},"StopAction":{"type":"structure","required":["Scope"],"members":{"Scope":{},"TopicArn":{}}},"AddHeaderAction":{"type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}},"SNSAction":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{},"Encoding":{}}}}}},"ScanEnabled":{"type":"boolean"}}},"S20":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{},"SubjectPart":{},"TextPart":{},"HtmlPart":{}}},"S2t":{"type":"structure","members":{"Name":{},"CreatedTimestamp":{"type":"timestamp"}}},"S2v":{"type":"list","member":{"shape":"S18"}},"S31":{"type":"structure","members":{"TlsPolicy":{}}},"S3c":{"type":"list","member":{}},"S3h":{"type":"list","member":{}},"S3w":{"type":"list","member":{}},"S54":{"type":"list","member":{}},"S5i":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"S5x":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"S64":{"type":"structure","members":{"ToAddresses":{"shape":"S54"},"CcAddresses":{"shape":"S54"},"BccAddresses":{"shape":"S54"}}},"S6e":{"type":"structure","required":["Data"],"members":{"Data":{},"Charset":{}}}}}');

});

parcelRequire.register("1O7Vk", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListCustomVerificationEmailTemplates":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListIdentities":{"input_token":"NextToken","limit_key":"MaxItems","output_token":"NextToken","result_key":"Identities"},"ListVerifiedEmailAddresses":{"result_key":"VerifiedEmailAddresses"}}}');

});

parcelRequire.register("3y08t", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"IdentityExists":{"delay":3,"operation":"GetIdentityVerificationAttributes","maxAttempts":20,"acceptors":[{"expected":"Success","matcher":"pathAll","state":"success","argument":"VerificationAttributes.*.VerificationStatus"}]}}}');

});


parcelRequire.register("4B6Rs", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $358ff098f8f3e2be$var$Service = $dbC7k.Service;
var $358ff098f8f3e2be$var$apiLoader = $dbC7k.apiLoader;
$358ff098f8f3e2be$var$apiLoader.services["shield"] = {};
$dbC7k.Shield = $358ff098f8f3e2be$var$Service.defineService("shield", [
    "2016-06-02"
]);


Object.defineProperty($358ff098f8f3e2be$var$apiLoader.services["shield"], "2016-06-02", {
    get: function get() {
        var model = (parcelRequire("gwreR"));
        model.paginators = (parcelRequire("2fyBM")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Shield;

});
parcelRequire.register("gwreR", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-06-02","endpointPrefix":"shield","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"AWS Shield","serviceFullName":"AWS Shield","serviceId":"Shield","signatureVersion":"v4","targetPrefix":"AWSShield_20160616","uid":"shield-2016-06-02"},"operations":{"AssociateDRTLogBucket":{"input":{"type":"structure","required":["LogBucket"],"members":{"LogBucket":{}}},"output":{"type":"structure","members":{}}},"AssociateDRTRole":{"input":{"type":"structure","required":["RoleArn"],"members":{"RoleArn":{}}},"output":{"type":"structure","members":{}}},"CreateProtection":{"input":{"type":"structure","required":["Name","ResourceArn"],"members":{"Name":{},"ResourceArn":{}}},"output":{"type":"structure","members":{"ProtectionId":{}}}},"CreateSubscription":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DeleteProtection":{"input":{"type":"structure","required":["ProtectionId"],"members":{"ProtectionId":{}}},"output":{"type":"structure","members":{}}},"DeleteSubscription":{"input":{"type":"structure","members":{},"deprecated":true},"output":{"type":"structure","members":{},"deprecated":true},"deprecated":true},"DescribeAttack":{"input":{"type":"structure","required":["AttackId"],"members":{"AttackId":{}}},"output":{"type":"structure","members":{"Attack":{"type":"structure","members":{"AttackId":{},"ResourceArn":{},"SubResources":{"type":"list","member":{"type":"structure","members":{"Type":{},"Id":{},"AttackVectors":{"type":"list","member":{"type":"structure","required":["VectorType"],"members":{"VectorType":{},"VectorCounters":{"shape":"Ss"}}}},"Counters":{"shape":"Ss"}}}},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"AttackCounters":{"shape":"Ss"},"AttackProperties":{"type":"list","member":{"type":"structure","members":{"AttackLayer":{},"AttackPropertyIdentifier":{},"TopContributors":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{"type":"long"}}}},"Unit":{},"Total":{"type":"long"}}}},"Mitigations":{"type":"list","member":{"type":"structure","members":{"MitigationName":{}}}}}}}}},"DescribeDRTAccess":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"RoleArn":{},"LogBucketList":{"type":"list","member":{}}}}},"DescribeEmergencyContactSettings":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"EmergencyContactList":{"shape":"S1c"}}}},"DescribeProtection":{"input":{"type":"structure","members":{"ProtectionId":{},"ResourceArn":{}}},"output":{"type":"structure","members":{"Protection":{"shape":"S1h"}}}},"DescribeSubscription":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"Subscription":{"type":"structure","members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"TimeCommitmentInSeconds":{"type":"long"},"AutoRenew":{},"Limits":{"type":"list","member":{"type":"structure","members":{"Type":{},"Max":{"type":"long"}}}}}}}}},"DisassociateDRTLogBucket":{"input":{"type":"structure","required":["LogBucket"],"members":{"LogBucket":{}}},"output":{"type":"structure","members":{}}},"DisassociateDRTRole":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"GetSubscriptionState":{"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["SubscriptionState"],"members":{"SubscriptionState":{}}}},"ListAttacks":{"input":{"type":"structure","members":{"ResourceArns":{"type":"list","member":{}},"StartTime":{"shape":"S1z"},"EndTime":{"shape":"S1z"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AttackSummaries":{"type":"list","member":{"type":"structure","members":{"AttackId":{},"ResourceArn":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"AttackVectors":{"type":"list","member":{"type":"structure","required":["VectorType"],"members":{"VectorType":{}}}}}}},"NextToken":{}}}},"ListProtections":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Protections":{"type":"list","member":{"shape":"S1h"}},"NextToken":{}}}},"UpdateEmergencyContactSettings":{"input":{"type":"structure","members":{"EmergencyContactList":{"shape":"S1c"}}},"output":{"type":"structure","members":{}}},"UpdateSubscription":{"input":{"type":"structure","members":{"AutoRenew":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"Ss":{"type":"list","member":{"type":"structure","members":{"Name":{},"Max":{"type":"double"},"Average":{"type":"double"},"Sum":{"type":"double"},"N":{"type":"integer"},"Unit":{}}}},"S1c":{"type":"list","member":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{}}}},"S1h":{"type":"structure","members":{"Id":{},"Name":{},"ResourceArn":{}}},"S1z":{"type":"structure","members":{"FromInclusive":{"type":"timestamp"},"ToExclusive":{"type":"timestamp"}}}}}');

});

parcelRequire.register("2fyBM", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("4CxJH", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $35d4e14c696d09e4$var$Service = $dbC7k.Service;
var $35d4e14c696d09e4$var$apiLoader = $dbC7k.apiLoader;
$35d4e14c696d09e4$var$apiLoader.services["simpledb"] = {};
$dbC7k.SimpleDB = $35d4e14c696d09e4$var$Service.defineService("simpledb", [
    "2009-04-15"
]);


Object.defineProperty($35d4e14c696d09e4$var$apiLoader.services["simpledb"], "2009-04-15", {
    get: function get() {
        var model = (parcelRequire("4AcjK"));
        model.paginators = (parcelRequire("dbo1U")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.SimpleDB;

});
parcelRequire.register("4AcjK", function(module, exports) {
module.exports = JSON.parse('{"metadata":{"apiVersion":"2009-04-15","endpointPrefix":"sdb","serviceFullName":"Amazon SimpleDB","serviceId":"SimpleDB","signatureVersion":"v2","xmlNamespace":"http://sdb.amazonaws.com/doc/2009-04-15/","protocol":"query"},"operations":{"BatchDeleteAttributes":{"input":{"type":"structure","required":["DomainName","Items"],"members":{"DomainName":{},"Items":{"type":"list","member":{"locationName":"Item","type":"structure","required":["Name"],"members":{"Name":{"locationName":"ItemName"},"Attributes":{"shape":"S5"}}},"flattened":true}}}},"BatchPutAttributes":{"input":{"type":"structure","required":["DomainName","Items"],"members":{"DomainName":{},"Items":{"type":"list","member":{"locationName":"Item","type":"structure","required":["Name","Attributes"],"members":{"Name":{"locationName":"ItemName"},"Attributes":{"shape":"Sa"}}},"flattened":true}}}},"CreateDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}}},"DeleteAttributes":{"input":{"type":"structure","required":["DomainName","ItemName"],"members":{"DomainName":{},"ItemName":{},"Attributes":{"shape":"S5"},"Expected":{"shape":"Sf"}}}},"DeleteDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}}},"DomainMetadata":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"resultWrapper":"DomainMetadataResult","type":"structure","members":{"ItemCount":{"type":"integer"},"ItemNamesSizeBytes":{"type":"long"},"AttributeNameCount":{"type":"integer"},"AttributeNamesSizeBytes":{"type":"long"},"AttributeValueCount":{"type":"integer"},"AttributeValuesSizeBytes":{"type":"long"},"Timestamp":{"type":"integer"}}}},"GetAttributes":{"input":{"type":"structure","required":["DomainName","ItemName"],"members":{"DomainName":{},"ItemName":{},"AttributeNames":{"type":"list","member":{"locationName":"AttributeName"},"flattened":true},"ConsistentRead":{"type":"boolean"}}},"output":{"resultWrapper":"GetAttributesResult","type":"structure","members":{"Attributes":{"shape":"So"}}}},"ListDomains":{"input":{"type":"structure","members":{"MaxNumberOfDomains":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"ListDomainsResult","type":"structure","members":{"DomainNames":{"type":"list","member":{"locationName":"DomainName"},"flattened":true},"NextToken":{}}}},"PutAttributes":{"input":{"type":"structure","required":["DomainName","ItemName","Attributes"],"members":{"DomainName":{},"ItemName":{},"Attributes":{"shape":"Sa"},"Expected":{"shape":"Sf"}}}},"Select":{"input":{"type":"structure","required":["SelectExpression"],"members":{"SelectExpression":{},"NextToken":{},"ConsistentRead":{"type":"boolean"}}},"output":{"resultWrapper":"SelectResult","type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Item","type":"structure","required":["Name","Attributes"],"members":{"Name":{},"AlternateNameEncoding":{},"Attributes":{"shape":"So"}}},"flattened":true},"NextToken":{}}}}},"shapes":{"S5":{"type":"list","member":{"locationName":"Attribute","type":"structure","required":["Name"],"members":{"Name":{},"Value":{}}},"flattened":true},"Sa":{"type":"list","member":{"locationName":"Attribute","type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{},"Replace":{"type":"boolean"}}},"flattened":true},"Sf":{"type":"structure","members":{"Name":{},"Value":{},"Exists":{"type":"boolean"}}},"So":{"type":"list","member":{"locationName":"Attribute","type":"structure","required":["Name","Value"],"members":{"Name":{},"AlternateNameEncoding":{},"Value":{},"AlternateValueEncoding":{}}},"flattened":true}}}');

});

parcelRequire.register("dbo1U", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListDomains":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxNumberOfDomains","result_key":"DomainNames"},"Select":{"input_token":"NextToken","output_token":"NextToken","result_key":"Items"}}}');

});


parcelRequire.register("4gio4", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $31a6eb618ee77eb8$var$Service = $dbC7k.Service;
var $31a6eb618ee77eb8$var$apiLoader = $dbC7k.apiLoader;
$31a6eb618ee77eb8$var$apiLoader.services["sms"] = {};
$dbC7k.SMS = $31a6eb618ee77eb8$var$Service.defineService("sms", [
    "2016-10-24"
]);


Object.defineProperty($31a6eb618ee77eb8$var$apiLoader.services["sms"], "2016-10-24", {
    get: function get() {
        var model = (parcelRequire("iN92b"));
        model.paginators = (parcelRequire("6vJd7")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.SMS;

});
parcelRequire.register("iN92b", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-10-24","endpointPrefix":"sms","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"SMS","serviceFullName":"AWS Server Migration Service","serviceId":"SMS","signatureVersion":"v4","targetPrefix":"AWSServerMigrationService_V2016_10_24","uid":"sms-2016-10-24"},"operations":{"CreateApp":{"input":{"type":"structure","members":{"name":{},"description":{},"roleName":{},"clientToken":{},"serverGroups":{"shape":"S6"},"tags":{"shape":"So"}}},"output":{"type":"structure","members":{"appSummary":{"shape":"St"},"serverGroups":{"shape":"S6"},"tags":{"shape":"So"}}}},"CreateReplicationJob":{"input":{"type":"structure","required":["serverId","seedReplicationTime"],"members":{"serverId":{},"seedReplicationTime":{"type":"timestamp"},"frequency":{"type":"integer"},"runOnce":{"type":"boolean"},"licenseType":{},"roleName":{},"description":{},"numberOfRecentAmisToKeep":{"type":"integer"},"encrypted":{"type":"boolean"},"kmsKeyId":{}}},"output":{"type":"structure","members":{"replicationJobId":{}}}},"DeleteApp":{"input":{"type":"structure","members":{"appId":{},"forceStopAppReplication":{"type":"boolean"},"forceTerminateApp":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteAppLaunchConfiguration":{"input":{"type":"structure","members":{"appId":{}}},"output":{"type":"structure","members":{}}},"DeleteAppReplicationConfiguration":{"input":{"type":"structure","members":{"appId":{}}},"output":{"type":"structure","members":{}}},"DeleteReplicationJob":{"input":{"type":"structure","required":["replicationJobId"],"members":{"replicationJobId":{}}},"output":{"type":"structure","members":{}}},"DeleteServerCatalog":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DisassociateConnector":{"input":{"type":"structure","required":["connectorId"],"members":{"connectorId":{}}},"output":{"type":"structure","members":{}}},"GenerateChangeSet":{"input":{"type":"structure","members":{"appId":{},"changesetFormat":{}}},"output":{"type":"structure","members":{"s3Location":{"shape":"S1y"}}}},"GenerateTemplate":{"input":{"type":"structure","members":{"appId":{},"templateFormat":{}}},"output":{"type":"structure","members":{"s3Location":{"shape":"S1y"}}}},"GetApp":{"input":{"type":"structure","members":{"appId":{}}},"output":{"type":"structure","members":{"appSummary":{"shape":"St"},"serverGroups":{"shape":"S6"},"tags":{"shape":"So"}}}},"GetAppLaunchConfiguration":{"input":{"type":"structure","members":{"appId":{}}},"output":{"type":"structure","members":{"appId":{},"roleName":{},"serverGroupLaunchConfigurations":{"shape":"S27"}}}},"GetAppReplicationConfiguration":{"input":{"type":"structure","members":{"appId":{}}},"output":{"type":"structure","members":{"serverGroupReplicationConfigurations":{"shape":"S2m"}}}},"GetConnectors":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"connectorList":{"type":"list","member":{"type":"structure","members":{"connectorId":{},"version":{},"status":{},"capabilityList":{"type":"list","member":{}},"vmManagerName":{},"vmManagerType":{},"vmManagerId":{},"ipAddress":{},"macAddress":{},"associatedOn":{"type":"timestamp"}}}},"nextToken":{}}}},"GetReplicationJobs":{"input":{"type":"structure","members":{"replicationJobId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"replicationJobList":{"type":"list","member":{"shape":"S36"}},"nextToken":{}}}},"GetReplicationRuns":{"input":{"type":"structure","required":["replicationJobId"],"members":{"replicationJobId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"replicationJob":{"shape":"S36"},"replicationRunList":{"shape":"S3a"},"nextToken":{}}}},"GetServers":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"},"vmServerAddressList":{"type":"list","member":{"shape":"Sf"}}}},"output":{"type":"structure","members":{"lastModifiedOn":{"type":"timestamp"},"serverCatalogStatus":{},"serverList":{"shape":"Sa"},"nextToken":{}}}},"ImportServerCatalog":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"LaunchApp":{"input":{"type":"structure","members":{"appId":{}}},"output":{"type":"structure","members":{}}},"ListApps":{"input":{"type":"structure","members":{"appIds":{"type":"list","member":{}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"apps":{"type":"list","member":{"shape":"St"}},"nextToken":{}}}},"PutAppLaunchConfiguration":{"input":{"type":"structure","members":{"appId":{},"roleName":{},"serverGroupLaunchConfigurations":{"shape":"S27"}}},"output":{"type":"structure","members":{}}},"PutAppReplicationConfiguration":{"input":{"type":"structure","members":{"appId":{},"serverGroupReplicationConfigurations":{"shape":"S2m"}}},"output":{"type":"structure","members":{}}},"StartAppReplication":{"input":{"type":"structure","members":{"appId":{}}},"output":{"type":"structure","members":{}}},"StartOnDemandReplicationRun":{"input":{"type":"structure","required":["replicationJobId"],"members":{"replicationJobId":{},"description":{}}},"output":{"type":"structure","members":{"replicationRunId":{}}}},"StopAppReplication":{"input":{"type":"structure","members":{"appId":{}}},"output":{"type":"structure","members":{}}},"TerminateApp":{"input":{"type":"structure","members":{"appId":{}}},"output":{"type":"structure","members":{}}},"UpdateApp":{"input":{"type":"structure","members":{"appId":{},"name":{},"description":{},"roleName":{},"serverGroups":{"shape":"S6"},"tags":{"shape":"So"}}},"output":{"type":"structure","members":{"appSummary":{"shape":"St"},"serverGroups":{"shape":"S6"},"tags":{"shape":"So"}}}},"UpdateReplicationJob":{"input":{"type":"structure","required":["replicationJobId"],"members":{"replicationJobId":{},"frequency":{"type":"integer"},"nextReplicationRunStartTime":{"type":"timestamp"},"licenseType":{},"roleName":{},"description":{},"numberOfRecentAmisToKeep":{"type":"integer"},"encrypted":{"type":"boolean"},"kmsKeyId":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S6":{"type":"list","member":{"type":"structure","members":{"serverGroupId":{},"name":{},"serverList":{"shape":"Sa"}}}},"Sa":{"type":"list","member":{"shape":"Sb"}},"Sb":{"type":"structure","members":{"serverId":{},"serverType":{},"vmServer":{"shape":"Se"},"replicationJobId":{},"replicationJobTerminated":{"type":"boolean"}}},"Se":{"type":"structure","members":{"vmServerAddress":{"shape":"Sf"},"vmName":{},"vmManagerName":{},"vmManagerType":{},"vmPath":{}}},"Sf":{"type":"structure","members":{"vmManagerId":{},"vmId":{}}},"So":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}}},"St":{"type":"structure","members":{"appId":{},"name":{},"description":{},"status":{},"statusMessage":{},"replicationStatus":{},"replicationStatusMessage":{},"latestReplicationTime":{"type":"timestamp"},"launchStatus":{},"launchStatusMessage":{},"launchDetails":{"type":"structure","members":{"latestLaunchTime":{"type":"timestamp"},"stackName":{},"stackId":{}}},"creationTime":{"type":"timestamp"},"lastModified":{"type":"timestamp"},"roleName":{},"totalServerGroups":{"type":"integer"},"totalServers":{"type":"integer"}}},"S1y":{"type":"structure","members":{"bucket":{},"key":{}}},"S27":{"type":"list","member":{"type":"structure","members":{"serverGroupId":{},"launchOrder":{"type":"integer"},"serverLaunchConfigurations":{"type":"list","member":{"type":"structure","members":{"server":{"shape":"Sb"},"logicalId":{},"vpc":{},"subnet":{},"securityGroup":{},"ec2KeyName":{},"userData":{"type":"structure","members":{"s3Location":{"shape":"S1y"}}},"instanceType":{},"associatePublicIpAddress":{"type":"boolean"}}}}}}},"S2m":{"type":"list","member":{"type":"structure","members":{"serverGroupId":{},"serverReplicationConfigurations":{"type":"list","member":{"type":"structure","members":{"server":{"shape":"Sb"},"serverReplicationParameters":{"type":"structure","members":{"seedTime":{"type":"timestamp"},"frequency":{"type":"integer"},"runOnce":{"type":"boolean"},"licenseType":{},"numberOfRecentAmisToKeep":{"type":"integer"},"encrypted":{"type":"boolean"},"kmsKeyId":{}}}}}}}}},"S36":{"type":"structure","members":{"replicationJobId":{},"serverId":{},"serverType":{},"vmServer":{"shape":"Se"},"seedReplicationTime":{"type":"timestamp"},"frequency":{"type":"integer"},"runOnce":{"type":"boolean"},"nextReplicationRunStartTime":{"type":"timestamp"},"licenseType":{},"roleName":{},"latestAmiId":{},"state":{},"statusMessage":{},"description":{},"numberOfRecentAmisToKeep":{"type":"integer"},"encrypted":{"type":"boolean"},"kmsKeyId":{},"replicationRunList":{"shape":"S3a"}}},"S3a":{"type":"list","member":{"type":"structure","members":{"replicationRunId":{},"state":{},"type":{},"stageDetails":{"type":"structure","members":{"stage":{},"stageProgress":{}}},"statusMessage":{},"amiId":{},"scheduledStartTime":{"type":"timestamp"},"completedTime":{"type":"timestamp"},"description":{},"encrypted":{"type":"boolean"},"kmsKeyId":{}}}}}}');

});

parcelRequire.register("6vJd7", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"GetConnectors":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"connectorList"},"GetReplicationJobs":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"replicationJobList"},"GetReplicationRuns":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"replicationRunList"},"GetServers":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"serverList"}}}');

});


parcelRequire.register("1cN2L", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $0e0cf47cc0edc4e2$var$Service = $dbC7k.Service;
var $0e0cf47cc0edc4e2$var$apiLoader = $dbC7k.apiLoader;
$0e0cf47cc0edc4e2$var$apiLoader.services["snowball"] = {};
$dbC7k.Snowball = $0e0cf47cc0edc4e2$var$Service.defineService("snowball", [
    "2016-06-30"
]);


Object.defineProperty($0e0cf47cc0edc4e2$var$apiLoader.services["snowball"], "2016-06-30", {
    get: function get() {
        var model = (parcelRequire("3U82G"));
        model.paginators = (parcelRequire("fAT28")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Snowball;

});
parcelRequire.register("3U82G", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-06-30","endpointPrefix":"snowball","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon Snowball","serviceFullName":"Amazon Import/Export Snowball","serviceId":"Snowball","signatureVersion":"v4","targetPrefix":"AWSIESnowballJobManagementService","uid":"snowball-2016-06-30"},"operations":{"CancelCluster":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{}}},"CancelJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{}}},"CreateAddress":{"input":{"type":"structure","required":["Address"],"members":{"Address":{"shape":"S8"}}},"output":{"type":"structure","members":{"AddressId":{}}}},"CreateCluster":{"input":{"type":"structure","required":["JobType","Resources","AddressId","RoleARN","ShippingOption"],"members":{"JobType":{},"Resources":{"shape":"Sf"},"Description":{},"AddressId":{},"KmsKeyARN":{},"RoleARN":{},"SnowballType":{},"ShippingOption":{},"Notification":{"shape":"Sv"},"ForwardingAddressId":{}}},"output":{"type":"structure","members":{"ClusterId":{}}}},"CreateJob":{"input":{"type":"structure","members":{"JobType":{},"Resources":{"shape":"Sf"},"Description":{},"AddressId":{},"KmsKeyARN":{},"RoleARN":{},"SnowballCapacityPreference":{},"ShippingOption":{},"Notification":{"shape":"Sv"},"ClusterId":{},"SnowballType":{},"ForwardingAddressId":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"DescribeAddress":{"input":{"type":"structure","required":["AddressId"],"members":{"AddressId":{}}},"output":{"type":"structure","members":{"Address":{"shape":"S8"}}}},"DescribeAddresses":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Addresses":{"type":"list","member":{"shape":"S8"}},"NextToken":{}}}},"DescribeCluster":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{"ClusterMetadata":{"type":"structure","members":{"ClusterId":{},"Description":{},"KmsKeyARN":{},"RoleARN":{},"ClusterState":{},"JobType":{},"SnowballType":{},"CreationDate":{"type":"timestamp"},"Resources":{"shape":"Sf"},"AddressId":{},"ShippingOption":{},"Notification":{"shape":"Sv"},"ForwardingAddressId":{}}}}}},"DescribeJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobMetadata":{"shape":"S1g"},"SubJobMetadata":{"type":"list","member":{"shape":"S1g"}}}}},"GetJobManifest":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"ManifestURI":{}}}},"GetJobUnlockCode":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"UnlockCode":{}}}},"GetSnowballUsage":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"SnowballLimit":{"type":"integer"},"SnowballsInUse":{"type":"integer"}}}},"ListClusterJobs":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"JobListEntries":{"shape":"S1w"},"NextToken":{}}}},"ListClusters":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ClusterListEntries":{"type":"list","member":{"type":"structure","members":{"ClusterId":{},"ClusterState":{},"CreationDate":{"type":"timestamp"},"Description":{}}}},"NextToken":{}}}},"ListCompatibleImages":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"CompatibleImages":{"type":"list","member":{"type":"structure","members":{"AmiId":{},"Name":{}}}},"NextToken":{}}}},"ListJobs":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"JobListEntries":{"shape":"S1w"},"NextToken":{}}}},"UpdateCluster":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"RoleARN":{},"Description":{},"Resources":{"shape":"Sf"},"AddressId":{},"ShippingOption":{},"Notification":{"shape":"Sv"},"ForwardingAddressId":{}}},"output":{"type":"structure","members":{}}},"UpdateJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"RoleARN":{},"Notification":{"shape":"Sv"},"Resources":{"shape":"Sf"},"AddressId":{},"ShippingOption":{},"Description":{},"SnowballCapacityPreference":{},"ForwardingAddressId":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S8":{"type":"structure","members":{"AddressId":{},"Name":{},"Company":{},"Street1":{},"Street2":{},"Street3":{},"City":{},"StateOrProvince":{},"PrefectureOrDistrict":{},"Landmark":{},"Country":{},"PostalCode":{},"PhoneNumber":{},"IsRestricted":{"type":"boolean"}}},"Sf":{"type":"structure","members":{"S3Resources":{"type":"list","member":{"type":"structure","members":{"BucketArn":{},"KeyRange":{"type":"structure","members":{"BeginMarker":{},"EndMarker":{}}}}}},"LambdaResources":{"type":"list","member":{"type":"structure","members":{"LambdaArn":{},"EventTriggers":{"type":"list","member":{"type":"structure","members":{"EventResourceARN":{}}}}}}},"Ec2AmiResources":{"type":"list","member":{"type":"structure","required":["AmiId"],"members":{"AmiId":{},"SnowballAmiId":{}}}}}},"Sv":{"type":"structure","members":{"SnsTopicARN":{},"JobStatesToNotify":{"type":"list","member":{}},"NotifyAll":{"type":"boolean"}}},"S1g":{"type":"structure","members":{"JobId":{},"JobState":{},"JobType":{},"SnowballType":{},"CreationDate":{"type":"timestamp"},"Resources":{"shape":"Sf"},"Description":{},"KmsKeyARN":{},"RoleARN":{},"AddressId":{},"ShippingDetails":{"type":"structure","members":{"ShippingOption":{},"InboundShipment":{"shape":"S1i"},"OutboundShipment":{"shape":"S1i"}}},"SnowballCapacityPreference":{},"Notification":{"shape":"Sv"},"DataTransferProgress":{"type":"structure","members":{"BytesTransferred":{"type":"long"},"ObjectsTransferred":{"type":"long"},"TotalBytes":{"type":"long"},"TotalObjects":{"type":"long"}}},"JobLogInfo":{"type":"structure","members":{"JobCompletionReportURI":{},"JobSuccessLogURI":{},"JobFailureLogURI":{}}},"ClusterId":{},"ForwardingAddressId":{}}},"S1i":{"type":"structure","members":{"Status":{},"TrackingNumber":{}}},"S1w":{"type":"list","member":{"type":"structure","members":{"JobId":{},"JobState":{},"IsMaster":{"type":"boolean"},"JobType":{},"SnowballType":{},"CreationDate":{"type":"timestamp"},"Description":{}}}}}}');

});

parcelRequire.register("fAT28", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeAddresses":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Addresses"},"ListJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"JobListEntries"}}}');

});


parcelRequire.register("jrMpy", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $e286176989f11f42$var$Service = $dbC7k.Service;
var $e286176989f11f42$var$apiLoader = $dbC7k.apiLoader;
$e286176989f11f42$var$apiLoader.services["sns"] = {};
$dbC7k.SNS = $e286176989f11f42$var$Service.defineService("sns", [
    "2010-03-31"
]);


Object.defineProperty($e286176989f11f42$var$apiLoader.services["sns"], "2010-03-31", {
    get: function get() {
        var model = (parcelRequire("kygKO"));
        model.paginators = (parcelRequire("6eQq2")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.SNS;

});
parcelRequire.register("kygKO", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2010-03-31","endpointPrefix":"sns","protocol":"query","serviceAbbreviation":"Amazon SNS","serviceFullName":"Amazon Simple Notification Service","serviceId":"SNS","signatureVersion":"v4","uid":"sns-2010-03-31","xmlNamespace":"http://sns.amazonaws.com/doc/2010-03-31/"},"operations":{"AddPermission":{"input":{"type":"structure","required":["TopicArn","Label","AWSAccountId","ActionName"],"members":{"TopicArn":{},"Label":{},"AWSAccountId":{"type":"list","member":{}},"ActionName":{"type":"list","member":{}}}}},"CheckIfPhoneNumberIsOptedOut":{"input":{"type":"structure","required":["phoneNumber"],"members":{"phoneNumber":{}}},"output":{"resultWrapper":"CheckIfPhoneNumberIsOptedOutResult","type":"structure","members":{"isOptedOut":{"type":"boolean"}}}},"ConfirmSubscription":{"input":{"type":"structure","required":["TopicArn","Token"],"members":{"TopicArn":{},"Token":{},"AuthenticateOnUnsubscribe":{}}},"output":{"resultWrapper":"ConfirmSubscriptionResult","type":"structure","members":{"SubscriptionArn":{}}}},"CreatePlatformApplication":{"input":{"type":"structure","required":["Name","Platform","Attributes"],"members":{"Name":{},"Platform":{},"Attributes":{"shape":"Sj"}}},"output":{"resultWrapper":"CreatePlatformApplicationResult","type":"structure","members":{"PlatformApplicationArn":{}}}},"CreatePlatformEndpoint":{"input":{"type":"structure","required":["PlatformApplicationArn","Token"],"members":{"PlatformApplicationArn":{},"Token":{},"CustomUserData":{},"Attributes":{"shape":"Sj"}}},"output":{"resultWrapper":"CreatePlatformEndpointResult","type":"structure","members":{"EndpointArn":{}}}},"CreateTopic":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Attributes":{"shape":"Sp"},"Tags":{"shape":"Ss"}}},"output":{"resultWrapper":"CreateTopicResult","type":"structure","members":{"TopicArn":{}}}},"DeleteEndpoint":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}}},"DeletePlatformApplication":{"input":{"type":"structure","required":["PlatformApplicationArn"],"members":{"PlatformApplicationArn":{}}}},"DeleteTopic":{"input":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{}}}},"GetEndpointAttributes":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}},"output":{"resultWrapper":"GetEndpointAttributesResult","type":"structure","members":{"Attributes":{"shape":"Sj"}}}},"GetPlatformApplicationAttributes":{"input":{"type":"structure","required":["PlatformApplicationArn"],"members":{"PlatformApplicationArn":{}}},"output":{"resultWrapper":"GetPlatformApplicationAttributesResult","type":"structure","members":{"Attributes":{"shape":"Sj"}}}},"GetSMSAttributes":{"input":{"type":"structure","members":{"attributes":{"type":"list","member":{}}}},"output":{"resultWrapper":"GetSMSAttributesResult","type":"structure","members":{"attributes":{"shape":"Sj"}}}},"GetSubscriptionAttributes":{"input":{"type":"structure","required":["SubscriptionArn"],"members":{"SubscriptionArn":{}}},"output":{"resultWrapper":"GetSubscriptionAttributesResult","type":"structure","members":{"Attributes":{"shape":"S19"}}}},"GetTopicAttributes":{"input":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{}}},"output":{"resultWrapper":"GetTopicAttributesResult","type":"structure","members":{"Attributes":{"shape":"Sp"}}}},"ListEndpointsByPlatformApplication":{"input":{"type":"structure","required":["PlatformApplicationArn"],"members":{"PlatformApplicationArn":{},"NextToken":{}}},"output":{"resultWrapper":"ListEndpointsByPlatformApplicationResult","type":"structure","members":{"Endpoints":{"type":"list","member":{"type":"structure","members":{"EndpointArn":{},"Attributes":{"shape":"Sj"}}}},"NextToken":{}}}},"ListPhoneNumbersOptedOut":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"resultWrapper":"ListPhoneNumbersOptedOutResult","type":"structure","members":{"phoneNumbers":{"type":"list","member":{}},"nextToken":{}}}},"ListPlatformApplications":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListPlatformApplicationsResult","type":"structure","members":{"PlatformApplications":{"type":"list","member":{"type":"structure","members":{"PlatformApplicationArn":{},"Attributes":{"shape":"Sj"}}}},"NextToken":{}}}},"ListSubscriptions":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListSubscriptionsResult","type":"structure","members":{"Subscriptions":{"shape":"S1r"},"NextToken":{}}}},"ListSubscriptionsByTopic":{"input":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{},"NextToken":{}}},"output":{"resultWrapper":"ListSubscriptionsByTopicResult","type":"structure","members":{"Subscriptions":{"shape":"S1r"},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"Tags":{"shape":"Ss"}}}},"ListTopics":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListTopicsResult","type":"structure","members":{"Topics":{"type":"list","member":{"type":"structure","members":{"TopicArn":{}}}},"NextToken":{}}}},"OptInPhoneNumber":{"input":{"type":"structure","required":["phoneNumber"],"members":{"phoneNumber":{}}},"output":{"resultWrapper":"OptInPhoneNumberResult","type":"structure","members":{}}},"Publish":{"input":{"type":"structure","required":["Message"],"members":{"TopicArn":{},"TargetArn":{},"PhoneNumber":{},"Message":{},"Subject":{},"MessageStructure":{},"MessageAttributes":{"type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value","type":"structure","required":["DataType"],"members":{"DataType":{},"StringValue":{},"BinaryValue":{"type":"blob"}}}}}},"output":{"resultWrapper":"PublishResult","type":"structure","members":{"MessageId":{}}}},"RemovePermission":{"input":{"type":"structure","required":["TopicArn","Label"],"members":{"TopicArn":{},"Label":{}}}},"SetEndpointAttributes":{"input":{"type":"structure","required":["EndpointArn","Attributes"],"members":{"EndpointArn":{},"Attributes":{"shape":"Sj"}}}},"SetPlatformApplicationAttributes":{"input":{"type":"structure","required":["PlatformApplicationArn","Attributes"],"members":{"PlatformApplicationArn":{},"Attributes":{"shape":"Sj"}}}},"SetSMSAttributes":{"input":{"type":"structure","required":["attributes"],"members":{"attributes":{"shape":"Sj"}}},"output":{"resultWrapper":"SetSMSAttributesResult","type":"structure","members":{}}},"SetSubscriptionAttributes":{"input":{"type":"structure","required":["SubscriptionArn","AttributeName"],"members":{"SubscriptionArn":{},"AttributeName":{},"AttributeValue":{}}}},"SetTopicAttributes":{"input":{"type":"structure","required":["TopicArn","AttributeName"],"members":{"TopicArn":{},"AttributeName":{},"AttributeValue":{}}}},"Subscribe":{"input":{"type":"structure","required":["TopicArn","Protocol"],"members":{"TopicArn":{},"Protocol":{},"Endpoint":{},"Attributes":{"shape":"S19"},"ReturnSubscriptionArn":{"type":"boolean"}}},"output":{"resultWrapper":"SubscribeResult","type":"structure","members":{"SubscriptionArn":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Ss"}}},"output":{"resultWrapper":"TagResourceResult","type":"structure","members":{}}},"Unsubscribe":{"input":{"type":"structure","required":["SubscriptionArn"],"members":{"SubscriptionArn":{}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"resultWrapper":"UntagResourceResult","type":"structure","members":{}}}},"shapes":{"Sj":{"type":"map","key":{},"value":{}},"Sp":{"type":"map","key":{},"value":{}},"Ss":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S19":{"type":"map","key":{},"value":{}},"S1r":{"type":"list","member":{"type":"structure","members":{"SubscriptionArn":{},"Owner":{},"Protocol":{},"Endpoint":{},"TopicArn":{}}}}}}');

});

parcelRequire.register("6eQq2", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListEndpointsByPlatformApplication":{"input_token":"NextToken","output_token":"NextToken","result_key":"Endpoints"},"ListPlatformApplications":{"input_token":"NextToken","output_token":"NextToken","result_key":"PlatformApplications"},"ListSubscriptions":{"input_token":"NextToken","output_token":"NextToken","result_key":"Subscriptions"},"ListSubscriptionsByTopic":{"input_token":"NextToken","output_token":"NextToken","result_key":"Subscriptions"},"ListTopics":{"input_token":"NextToken","output_token":"NextToken","result_key":"Topics"}}}');

});


parcelRequire.register("lIiMN", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $fcec4789dd0af24d$var$Service = $dbC7k.Service;
var $fcec4789dd0af24d$var$apiLoader = $dbC7k.apiLoader;
$fcec4789dd0af24d$var$apiLoader.services["sqs"] = {};
$dbC7k.SQS = $fcec4789dd0af24d$var$Service.defineService("sqs", [
    "2012-11-05"
]);
parcelRequire("2FuDt");


Object.defineProperty($fcec4789dd0af24d$var$apiLoader.services["sqs"], "2012-11-05", {
    get: function get() {
        var model = (parcelRequire("bRqgJ"));
        model.paginators = (parcelRequire("1Tf2f")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.SQS;

});
parcelRequire.register("2FuDt", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
$dbC7k.util.update($dbC7k.SQS.prototype, {
    /**
   * @api private
   */ setupRequestListeners: function setupRequestListeners(request) {
        request.addListener("build", this.buildEndpoint);
        if (request.service.config.computeChecksums) {
            if (request.operation === "sendMessage") request.addListener("extractData", this.verifySendMessageChecksum);
            else if (request.operation === "sendMessageBatch") request.addListener("extractData", this.verifySendMessageBatchChecksum);
            else if (request.operation === "receiveMessage") request.addListener("extractData", this.verifyReceiveMessageChecksum);
        }
    },
    /**
   * @api private
   */ verifySendMessageChecksum: function verifySendMessageChecksum(response) {
        if (!response.data) return;
        var md5 = response.data.MD5OfMessageBody;
        var body = this.params.MessageBody;
        var calculatedMd5 = this.service.calculateChecksum(body);
        if (calculatedMd5 !== md5) {
            var msg = 'Got "' + response.data.MD5OfMessageBody + '", expecting "' + calculatedMd5 + '".';
            this.service.throwInvalidChecksumError(response, [
                response.data.MessageId
            ], msg);
        }
    },
    /**
   * @api private
   */ verifySendMessageBatchChecksum: function verifySendMessageBatchChecksum(response) {
        if (!response.data) return;
        var service = this.service;
        var entries = {};
        var errors = [];
        var messageIds = [];
        $dbC7k.util.arrayEach(response.data.Successful, function(entry) {
            entries[entry.Id] = entry;
        });
        $dbC7k.util.arrayEach(this.params.Entries, function(entry) {
            if (entries[entry.Id]) {
                var md5 = entries[entry.Id].MD5OfMessageBody;
                var body = entry.MessageBody;
                if (!service.isChecksumValid(md5, body)) {
                    errors.push(entry.Id);
                    messageIds.push(entries[entry.Id].MessageId);
                }
            }
        });
        if (errors.length > 0) service.throwInvalidChecksumError(response, messageIds, "Invalid messages: " + errors.join(", "));
    },
    /**
   * @api private
   */ verifyReceiveMessageChecksum: function verifyReceiveMessageChecksum(response) {
        if (!response.data) return;
        var service = this.service;
        var messageIds = [];
        $dbC7k.util.arrayEach(response.data.Messages, function(message) {
            var md5 = message.MD5OfBody;
            var body = message.Body;
            if (!service.isChecksumValid(md5, body)) messageIds.push(message.MessageId);
        });
        if (messageIds.length > 0) service.throwInvalidChecksumError(response, messageIds, "Invalid messages: " + messageIds.join(", "));
    },
    /**
   * @api private
   */ throwInvalidChecksumError: function throwInvalidChecksumError(response, ids, message) {
        response.error = $dbC7k.util.error(new Error(), {
            retryable: true,
            code: "InvalidChecksum",
            messageIds: ids,
            message: response.request.operation + " returned an invalid MD5 response. " + message
        });
    },
    /**
   * @api private
   */ isChecksumValid: function isChecksumValid(checksum, data) {
        return this.calculateChecksum(data) === checksum;
    },
    /**
   * @api private
   */ calculateChecksum: function calculateChecksum(data) {
        return $dbC7k.util.crypto.md5(data, "hex");
    },
    /**
   * @api private
   */ buildEndpoint: function buildEndpoint(request) {
        var url = request.httpRequest.params.QueueUrl;
        if (url) {
            request.httpRequest.endpoint = new $dbC7k.Endpoint(url);
            // signature version 4 requires the region name to be set,
            // sqs queue urls contain the region name
            var matches = request.httpRequest.endpoint.host.match(/^sqs\.(.+?)\./);
            if (matches) request.httpRequest.region = matches[1];
        }
    }
});

});

parcelRequire.register("bRqgJ", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2012-11-05","endpointPrefix":"sqs","protocol":"query","serviceAbbreviation":"Amazon SQS","serviceFullName":"Amazon Simple Queue Service","serviceId":"SQS","signatureVersion":"v4","uid":"sqs-2012-11-05","xmlNamespace":"http://queue.amazonaws.com/doc/2012-11-05/"},"operations":{"AddPermission":{"input":{"type":"structure","required":["QueueUrl","Label","AWSAccountIds","Actions"],"members":{"QueueUrl":{},"Label":{},"AWSAccountIds":{"type":"list","member":{"locationName":"AWSAccountId"},"flattened":true},"Actions":{"type":"list","member":{"locationName":"ActionName"},"flattened":true}}}},"ChangeMessageVisibility":{"input":{"type":"structure","required":["QueueUrl","ReceiptHandle","VisibilityTimeout"],"members":{"QueueUrl":{},"ReceiptHandle":{},"VisibilityTimeout":{"type":"integer"}}}},"ChangeMessageVisibilityBatch":{"input":{"type":"structure","required":["QueueUrl","Entries"],"members":{"QueueUrl":{},"Entries":{"type":"list","member":{"locationName":"ChangeMessageVisibilityBatchRequestEntry","type":"structure","required":["Id","ReceiptHandle"],"members":{"Id":{},"ReceiptHandle":{},"VisibilityTimeout":{"type":"integer"}}},"flattened":true}}},"output":{"resultWrapper":"ChangeMessageVisibilityBatchResult","type":"structure","required":["Successful","Failed"],"members":{"Successful":{"type":"list","member":{"locationName":"ChangeMessageVisibilityBatchResultEntry","type":"structure","required":["Id"],"members":{"Id":{}}},"flattened":true},"Failed":{"shape":"Sd"}}}},"CreateQueue":{"input":{"type":"structure","required":["QueueName"],"members":{"QueueName":{},"Attributes":{"shape":"Sh","locationName":"Attribute"},"tags":{"shape":"Sj","locationName":"Tag"}}},"output":{"resultWrapper":"CreateQueueResult","type":"structure","members":{"QueueUrl":{}}}},"DeleteMessage":{"input":{"type":"structure","required":["QueueUrl","ReceiptHandle"],"members":{"QueueUrl":{},"ReceiptHandle":{}}}},"DeleteMessageBatch":{"input":{"type":"structure","required":["QueueUrl","Entries"],"members":{"QueueUrl":{},"Entries":{"type":"list","member":{"locationName":"DeleteMessageBatchRequestEntry","type":"structure","required":["Id","ReceiptHandle"],"members":{"Id":{},"ReceiptHandle":{}}},"flattened":true}}},"output":{"resultWrapper":"DeleteMessageBatchResult","type":"structure","required":["Successful","Failed"],"members":{"Successful":{"type":"list","member":{"locationName":"DeleteMessageBatchResultEntry","type":"structure","required":["Id"],"members":{"Id":{}}},"flattened":true},"Failed":{"shape":"Sd"}}}},"DeleteQueue":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{}}}},"GetQueueAttributes":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{},"AttributeNames":{"shape":"Sw"}}},"output":{"resultWrapper":"GetQueueAttributesResult","type":"structure","members":{"Attributes":{"shape":"Sh","locationName":"Attribute"}}}},"GetQueueUrl":{"input":{"type":"structure","required":["QueueName"],"members":{"QueueName":{},"QueueOwnerAWSAccountId":{}}},"output":{"resultWrapper":"GetQueueUrlResult","type":"structure","members":{"QueueUrl":{}}}},"ListDeadLetterSourceQueues":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{}}},"output":{"resultWrapper":"ListDeadLetterSourceQueuesResult","type":"structure","required":["queueUrls"],"members":{"queueUrls":{"shape":"S12"}}}},"ListQueueTags":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{}}},"output":{"resultWrapper":"ListQueueTagsResult","type":"structure","members":{"Tags":{"shape":"Sj","locationName":"Tag"}}}},"ListQueues":{"input":{"type":"structure","members":{"QueueNamePrefix":{}}},"output":{"resultWrapper":"ListQueuesResult","type":"structure","members":{"QueueUrls":{"shape":"S12"}}}},"PurgeQueue":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{}}}},"ReceiveMessage":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{},"AttributeNames":{"shape":"Sw"},"MessageAttributeNames":{"type":"list","member":{"locationName":"MessageAttributeName"},"flattened":true},"MaxNumberOfMessages":{"type":"integer"},"VisibilityTimeout":{"type":"integer"},"WaitTimeSeconds":{"type":"integer"},"ReceiveRequestAttemptId":{}}},"output":{"resultWrapper":"ReceiveMessageResult","type":"structure","members":{"Messages":{"type":"list","member":{"locationName":"Message","type":"structure","members":{"MessageId":{},"ReceiptHandle":{},"MD5OfBody":{},"Body":{},"Attributes":{"locationName":"Attribute","type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value"},"flattened":true},"MD5OfMessageAttributes":{},"MessageAttributes":{"shape":"S1g","locationName":"MessageAttribute"}}},"flattened":true}}}},"RemovePermission":{"input":{"type":"structure","required":["QueueUrl","Label"],"members":{"QueueUrl":{},"Label":{}}}},"SendMessage":{"input":{"type":"structure","required":["QueueUrl","MessageBody"],"members":{"QueueUrl":{},"MessageBody":{},"DelaySeconds":{"type":"integer"},"MessageAttributes":{"shape":"S1g","locationName":"MessageAttribute"},"MessageDeduplicationId":{},"MessageGroupId":{}}},"output":{"resultWrapper":"SendMessageResult","type":"structure","members":{"MD5OfMessageBody":{},"MD5OfMessageAttributes":{},"MessageId":{},"SequenceNumber":{}}}},"SendMessageBatch":{"input":{"type":"structure","required":["QueueUrl","Entries"],"members":{"QueueUrl":{},"Entries":{"type":"list","member":{"locationName":"SendMessageBatchRequestEntry","type":"structure","required":["Id","MessageBody"],"members":{"Id":{},"MessageBody":{},"DelaySeconds":{"type":"integer"},"MessageAttributes":{"shape":"S1g","locationName":"MessageAttribute"},"MessageDeduplicationId":{},"MessageGroupId":{}}},"flattened":true}}},"output":{"resultWrapper":"SendMessageBatchResult","type":"structure","required":["Successful","Failed"],"members":{"Successful":{"type":"list","member":{"locationName":"SendMessageBatchResultEntry","type":"structure","required":["Id","MessageId","MD5OfMessageBody"],"members":{"Id":{},"MessageId":{},"MD5OfMessageBody":{},"MD5OfMessageAttributes":{},"SequenceNumber":{}}},"flattened":true},"Failed":{"shape":"Sd"}}}},"SetQueueAttributes":{"input":{"type":"structure","required":["QueueUrl","Attributes"],"members":{"QueueUrl":{},"Attributes":{"shape":"Sh","locationName":"Attribute"}}}},"TagQueue":{"input":{"type":"structure","required":["QueueUrl","Tags"],"members":{"QueueUrl":{},"Tags":{"shape":"Sj"}}}},"UntagQueue":{"input":{"type":"structure","required":["QueueUrl","TagKeys"],"members":{"QueueUrl":{},"TagKeys":{"type":"list","member":{"locationName":"TagKey"},"flattened":true}}}}},"shapes":{"Sd":{"type":"list","member":{"locationName":"BatchResultErrorEntry","type":"structure","required":["Id","SenderFault","Code"],"members":{"Id":{},"SenderFault":{"type":"boolean"},"Code":{},"Message":{}}},"flattened":true},"Sh":{"type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value"},"flattened":true,"locationName":"Attribute"},"Sj":{"type":"map","key":{"locationName":"Key"},"value":{"locationName":"Value"},"flattened":true,"locationName":"Tag"},"Sw":{"type":"list","member":{"locationName":"AttributeName"},"flattened":true},"S12":{"type":"list","member":{"locationName":"QueueUrl"},"flattened":true},"S1g":{"type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value","type":"structure","required":["DataType"],"members":{"StringValue":{},"BinaryValue":{"type":"blob"},"StringListValues":{"flattened":true,"locationName":"StringListValue","type":"list","member":{"locationName":"StringListValue"}},"BinaryListValues":{"flattened":true,"locationName":"BinaryListValue","type":"list","member":{"locationName":"BinaryListValue","type":"blob"}},"DataType":{}}},"flattened":true}}}');

});

parcelRequire.register("1Tf2f", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListQueues":{"result_key":"QueueUrls"}}}');

});


parcelRequire.register("1deU5", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $0e2290dfa387ca71$var$Service = $dbC7k.Service;
var $0e2290dfa387ca71$var$apiLoader = $dbC7k.apiLoader;
$0e2290dfa387ca71$var$apiLoader.services["ssm"] = {};
$dbC7k.SSM = $0e2290dfa387ca71$var$Service.defineService("ssm", [
    "2014-11-06"
]);


Object.defineProperty($0e2290dfa387ca71$var$apiLoader.services["ssm"], "2014-11-06", {
    get: function get() {
        var model = (parcelRequire("1OiHi"));
        model.paginators = (parcelRequire("1TuN9")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.SSM;

});
parcelRequire.register("1OiHi", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2014-11-06","endpointPrefix":"ssm","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon SSM","serviceFullName":"Amazon Simple Systems Manager (SSM)","serviceId":"SSM","signatureVersion":"v4","targetPrefix":"AmazonSSM","uid":"ssm-2014-11-06"},"operations":{"AddTagsToResource":{"input":{"type":"structure","required":["ResourceType","ResourceId","Tags"],"members":{"ResourceType":{},"ResourceId":{},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{}}},"CancelCommand":{"input":{"type":"structure","required":["CommandId"],"members":{"CommandId":{},"InstanceIds":{"shape":"Sb"}}},"output":{"type":"structure","members":{}}},"CancelMaintenanceWindowExecution":{"input":{"type":"structure","required":["WindowExecutionId"],"members":{"WindowExecutionId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{}}}},"CreateActivation":{"input":{"type":"structure","required":["IamRole"],"members":{"Description":{},"DefaultInstanceName":{},"IamRole":{},"RegistrationLimit":{"type":"integer"},"ExpirationDate":{"type":"timestamp"},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"ActivationId":{},"ActivationCode":{}}}},"CreateAssociation":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"DocumentVersion":{},"InstanceId":{},"Parameters":{"shape":"St"},"Targets":{"shape":"Sx"},"ScheduleExpression":{},"OutputLocation":{"shape":"S13"},"AssociationName":{},"AutomationTargetParameterName":{},"MaxErrors":{},"MaxConcurrency":{},"ComplianceSeverity":{}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S1e"}}}},"CreateAssociationBatch":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"shape":"S1s"}}}},"output":{"type":"structure","members":{"Successful":{"type":"list","member":{"shape":"S1e"}},"Failed":{"type":"list","member":{"type":"structure","members":{"Entry":{"shape":"S1s"},"Message":{},"Fault":{}}}}}}},"CreateDocument":{"input":{"type":"structure","required":["Content","Name"],"members":{"Content":{},"Attachments":{"shape":"S21"},"Name":{},"VersionName":{},"DocumentType":{},"DocumentFormat":{},"TargetType":{},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"DocumentDescription":{"shape":"S2c"}}}},"CreateMaintenanceWindow":{"input":{"type":"structure","required":["Name","Schedule","Duration","Cutoff","AllowUnassociatedTargets"],"members":{"Name":{},"Description":{"shape":"S2y"},"StartDate":{},"EndDate":{},"Schedule":{},"ScheduleTimezone":{},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"ClientToken":{"idempotencyToken":true},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"WindowId":{}}}},"CreateOpsItem":{"input":{"type":"structure","required":["Description","Source","Title"],"members":{"Description":{},"OperationalData":{"shape":"S3a"},"Notifications":{"shape":"S3f"},"Priority":{"type":"integer"},"RelatedOpsItems":{"shape":"S3j"},"Source":{},"Title":{},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"OpsItemId":{}}}},"CreatePatchBaseline":{"input":{"type":"structure","required":["Name"],"members":{"OperatingSystem":{},"Name":{},"GlobalFilters":{"shape":"S3r"},"ApprovalRules":{"shape":"S3x"},"ApprovedPatches":{"shape":"S43"},"ApprovedPatchesComplianceLevel":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"RejectedPatches":{"shape":"S43"},"RejectedPatchesAction":{},"Description":{},"Sources":{"shape":"S47"},"ClientToken":{"idempotencyToken":true},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"BaselineId":{}}}},"CreateResourceDataSync":{"input":{"type":"structure","required":["SyncName","S3Destination"],"members":{"SyncName":{},"S3Destination":{"shape":"S4h"}}},"output":{"type":"structure","members":{}}},"DeleteActivation":{"input":{"type":"structure","required":["ActivationId"],"members":{"ActivationId":{}}},"output":{"type":"structure","members":{}}},"DeleteAssociation":{"input":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationId":{}}},"output":{"type":"structure","members":{}}},"DeleteDocument":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"DocumentVersion":{},"VersionName":{}}},"output":{"type":"structure","members":{}}},"DeleteInventory":{"input":{"type":"structure","required":["TypeName"],"members":{"TypeName":{},"SchemaDeleteOption":{},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"DeletionId":{},"TypeName":{},"DeletionSummary":{"shape":"S50"}}}},"DeleteMaintenanceWindow":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{}}},"output":{"type":"structure","members":{"WindowId":{}}}},"DeleteParameter":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteParameters":{"input":{"type":"structure","required":["Names"],"members":{"Names":{"shape":"S5d"}}},"output":{"type":"structure","members":{"DeletedParameters":{"shape":"S5d"},"InvalidParameters":{"shape":"S5d"}}}},"DeletePatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{}}},"output":{"type":"structure","members":{"BaselineId":{}}}},"DeleteResourceDataSync":{"input":{"type":"structure","required":["SyncName"],"members":{"SyncName":{}}},"output":{"type":"structure","members":{}}},"DeregisterManagedInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}},"output":{"type":"structure","members":{}}},"DeregisterPatchBaselineForPatchGroup":{"input":{"type":"structure","required":["BaselineId","PatchGroup"],"members":{"BaselineId":{},"PatchGroup":{}}},"output":{"type":"structure","members":{"BaselineId":{},"PatchGroup":{}}}},"DeregisterTargetFromMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","WindowTargetId"],"members":{"WindowId":{},"WindowTargetId":{},"Safe":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTargetId":{}}}},"DeregisterTaskFromMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","WindowTaskId"],"members":{"WindowId":{},"WindowTaskId":{}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{}}}},"DescribeActivations":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"FilterKey":{},"FilterValues":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ActivationList":{"type":"list","member":{"type":"structure","members":{"ActivationId":{},"Description":{},"DefaultInstanceName":{},"IamRole":{},"RegistrationLimit":{"type":"integer"},"RegistrationsCount":{"type":"integer"},"ExpirationDate":{"type":"timestamp"},"Expired":{"type":"boolean"},"CreatedDate":{"type":"timestamp"},"Tags":{"shape":"S4"}}}},"NextToken":{}}}},"DescribeAssociation":{"input":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationId":{},"AssociationVersion":{}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S1e"}}}},"DescribeAssociationExecutionTargets":{"input":{"type":"structure","required":["AssociationId","ExecutionId"],"members":{"AssociationId":{},"ExecutionId":{},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AssociationExecutionTargets":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"AssociationVersion":{},"ExecutionId":{},"ResourceId":{},"ResourceType":{},"Status":{},"DetailedStatus":{},"LastExecutionDate":{"type":"timestamp"},"OutputSource":{"type":"structure","members":{"OutputSourceId":{},"OutputSourceType":{}}}}}},"NextToken":{}}}},"DescribeAssociationExecutions":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Value","Type"],"members":{"Key":{},"Value":{},"Type":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AssociationExecutions":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"AssociationVersion":{},"ExecutionId":{},"Status":{},"DetailedStatus":{},"CreatedTime":{"type":"timestamp"},"LastExecutionDate":{"type":"timestamp"},"ResourceCountByStatus":{}}}},"NextToken":{}}}},"DescribeAutomationExecutions":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AutomationExecutionMetadataList":{"type":"list","member":{"type":"structure","members":{"AutomationExecutionId":{},"DocumentName":{},"DocumentVersion":{},"AutomationExecutionStatus":{},"ExecutionStartTime":{"type":"timestamp"},"ExecutionEndTime":{"type":"timestamp"},"ExecutedBy":{},"LogFile":{},"Outputs":{"shape":"S78"},"Mode":{},"ParentAutomationExecutionId":{},"CurrentStepName":{},"CurrentAction":{},"FailureMessage":{},"TargetParameterName":{},"Targets":{"shape":"Sx"},"TargetMaps":{"shape":"S7d"},"ResolvedTargets":{"shape":"S7i"},"MaxConcurrency":{},"MaxErrors":{},"Target":{},"AutomationType":{}}}},"NextToken":{}}}},"DescribeAutomationStepExecutions":{"input":{"type":"structure","required":["AutomationExecutionId"],"members":{"AutomationExecutionId":{},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}},"NextToken":{},"MaxResults":{"type":"integer"},"ReverseOrder":{"type":"boolean"}}},"output":{"type":"structure","members":{"StepExecutions":{"shape":"S7s"},"NextToken":{}}}},"DescribeAvailablePatches":{"input":{"type":"structure","members":{"Filters":{"shape":"S88"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Patches":{"type":"list","member":{"shape":"S8g"}},"NextToken":{}}}},"DescribeDocument":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"DocumentVersion":{},"VersionName":{}}},"output":{"type":"structure","members":{"Document":{"shape":"S2c"}}}},"DescribeDocumentPermission":{"input":{"type":"structure","required":["Name","PermissionType"],"members":{"Name":{},"PermissionType":{}}},"output":{"type":"structure","members":{"AccountIds":{"shape":"S8x"}}}},"DescribeEffectiveInstanceAssociations":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Associations":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"InstanceId":{},"Content":{},"AssociationVersion":{}}}},"NextToken":{}}}},"DescribeEffectivePatchesForPatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"EffectivePatches":{"type":"list","member":{"type":"structure","members":{"Patch":{"shape":"S8g"},"PatchStatus":{"type":"structure","members":{"DeploymentStatus":{},"ComplianceLevel":{},"ApprovalDate":{"type":"timestamp"}}}}}},"NextToken":{}}}},"DescribeInstanceAssociationsStatus":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceAssociationStatusInfos":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"Name":{},"DocumentVersion":{},"AssociationVersion":{},"InstanceId":{},"ExecutionDate":{"type":"timestamp"},"Status":{},"DetailedStatus":{},"ExecutionSummary":{},"ErrorCode":{},"OutputUrl":{"type":"structure","members":{"S3OutputUrl":{"type":"structure","members":{"OutputUrl":{}}}}},"AssociationName":{}}}},"NextToken":{}}}},"DescribeInstanceInformation":{"input":{"type":"structure","members":{"InstanceInformationFilterList":{"type":"list","member":{"type":"structure","required":["key","valueSet"],"members":{"key":{},"valueSet":{"shape":"S9n"}}}},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"shape":"S9n"}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceInformationList":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"PingStatus":{},"LastPingDateTime":{"type":"timestamp"},"AgentVersion":{},"IsLatestVersion":{"type":"boolean"},"PlatformType":{},"PlatformName":{},"PlatformVersion":{},"ActivationId":{},"IamRole":{},"RegistrationDate":{"type":"timestamp"},"ResourceType":{},"Name":{},"IPAddress":{},"ComputerName":{},"AssociationStatus":{},"LastAssociationExecutionDate":{"type":"timestamp"},"LastSuccessfulAssociationExecutionDate":{"type":"timestamp"},"AssociationOverview":{"type":"structure","members":{"DetailedStatus":{},"InstanceAssociationStatusAggregatedCount":{"type":"map","key":{},"value":{"type":"integer"}}}}}}},"NextToken":{}}}},"DescribeInstancePatchStates":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Sb"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InstancePatchStates":{"type":"list","member":{"shape":"Sa7"}},"NextToken":{}}}},"DescribeInstancePatchStatesForPatchGroup":{"input":{"type":"structure","required":["PatchGroup"],"members":{"PatchGroup":{},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values","Type"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Type":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InstancePatchStates":{"type":"list","member":{"shape":"Sa7"}},"NextToken":{}}}},"DescribeInstancePatches":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"Filters":{"shape":"S88"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Patches":{"type":"list","member":{"type":"structure","required":["Title","KBId","Classification","Severity","State","InstalledTime"],"members":{"Title":{},"KBId":{},"Classification":{},"Severity":{},"State":{},"InstalledTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeInventoryDeletions":{"input":{"type":"structure","members":{"DeletionId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InventoryDeletions":{"type":"list","member":{"type":"structure","members":{"DeletionId":{},"TypeName":{},"DeletionStartTime":{"type":"timestamp"},"LastStatus":{},"LastStatusMessage":{},"DeletionSummary":{"shape":"S50"},"LastStatusUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMaintenanceWindowExecutionTaskInvocations":{"input":{"type":"structure","required":["WindowExecutionId","TaskId"],"members":{"WindowExecutionId":{},"TaskId":{},"Filters":{"shape":"Sb8"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowExecutionTaskInvocationIdentities":{"type":"list","member":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"InvocationId":{},"ExecutionId":{},"TaskType":{},"Parameters":{"shape":"Sbk"},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"OwnerInformation":{"shape":"Saa"},"WindowTargetId":{}}}},"NextToken":{}}}},"DescribeMaintenanceWindowExecutionTasks":{"input":{"type":"structure","required":["WindowExecutionId"],"members":{"WindowExecutionId":{},"Filters":{"shape":"Sb8"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowExecutionTaskIdentities":{"type":"list","member":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"TaskArn":{},"TaskType":{}}}},"NextToken":{}}}},"DescribeMaintenanceWindowExecutions":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Filters":{"shape":"Sb8"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowExecutions":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"WindowExecutionId":{},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMaintenanceWindowSchedule":{"input":{"type":"structure","members":{"WindowId":{},"Targets":{"shape":"Sx"},"ResourceType":{},"Filters":{"shape":"S88"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScheduledWindowExecutions":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"Name":{},"ExecutionTime":{}}}},"NextToken":{}}}},"DescribeMaintenanceWindowTargets":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Filters":{"shape":"Sb8"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Targets":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"WindowTargetId":{},"ResourceType":{},"Targets":{"shape":"Sx"},"OwnerInformation":{"shape":"Saa"},"Name":{},"Description":{"shape":"S2y"}}}},"NextToken":{}}}},"DescribeMaintenanceWindowTasks":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Filters":{"shape":"Sb8"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tasks":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{},"TaskArn":{},"Type":{},"Targets":{"shape":"Sx"},"TaskParameters":{"shape":"Scb"},"Priority":{"type":"integer"},"LoggingInfo":{"shape":"Sch"},"ServiceRoleArn":{},"MaxConcurrency":{},"MaxErrors":{},"Name":{},"Description":{"shape":"S2y"}}}},"NextToken":{}}}},"DescribeMaintenanceWindows":{"input":{"type":"structure","members":{"Filters":{"shape":"Sb8"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowIdentities":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"Name":{},"Description":{"shape":"S2y"},"Enabled":{"type":"boolean"},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"Schedule":{},"ScheduleTimezone":{},"EndDate":{},"StartDate":{},"NextExecutionTime":{}}}},"NextToken":{}}}},"DescribeMaintenanceWindowsForTarget":{"input":{"type":"structure","required":["Targets","ResourceType"],"members":{"Targets":{"shape":"Sx"},"ResourceType":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowIdentities":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"Name":{}}}},"NextToken":{}}}},"DescribeOpsItems":{"input":{"type":"structure","members":{"OpsItemFilters":{"type":"list","member":{"type":"structure","required":["Key","Values","Operator"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Operator":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"OpsItemSummaries":{"type":"list","member":{"type":"structure","members":{"CreatedBy":{},"CreatedTime":{"type":"timestamp"},"LastModifiedBy":{},"LastModifiedTime":{"type":"timestamp"},"Priority":{"type":"integer"},"Source":{},"Status":{},"OpsItemId":{},"Title":{},"OperationalData":{"shape":"S3a"}}}}}}},"DescribeParameters":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}},"ParameterFilters":{"shape":"Sdb"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"KeyId":{},"LastModifiedDate":{"type":"timestamp"},"LastModifiedUser":{},"Description":{},"AllowedPattern":{},"Version":{"type":"long"},"Tier":{},"Policies":{"shape":"Sdq"}}}},"NextToken":{}}}},"DescribePatchBaselines":{"input":{"type":"structure","members":{"Filters":{"shape":"S88"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"BaselineIdentities":{"type":"list","member":{"shape":"Sdv"}},"NextToken":{}}}},"DescribePatchGroupState":{"input":{"type":"structure","required":["PatchGroup"],"members":{"PatchGroup":{}}},"output":{"type":"structure","members":{"Instances":{"type":"integer"},"InstancesWithInstalledPatches":{"type":"integer"},"InstancesWithInstalledOtherPatches":{"type":"integer"},"InstancesWithInstalledRejectedPatches":{"type":"integer"},"InstancesWithMissingPatches":{"type":"integer"},"InstancesWithFailedPatches":{"type":"integer"},"InstancesWithNotApplicablePatches":{"type":"integer"},"InstancesWithUnreportedNotApplicablePatches":{"type":"integer"}}}},"DescribePatchGroups":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"Filters":{"shape":"S88"},"NextToken":{}}},"output":{"type":"structure","members":{"Mappings":{"type":"list","member":{"type":"structure","members":{"PatchGroup":{},"BaselineIdentity":{"shape":"Sdv"}}}},"NextToken":{}}}},"DescribePatchProperties":{"input":{"type":"structure","required":["OperatingSystem","Property"],"members":{"OperatingSystem":{},"Property":{},"PatchSet":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Properties":{"type":"list","member":{"type":"map","key":{},"value":{}}},"NextToken":{}}}},"DescribeSessions":{"input":{"type":"structure","required":["State"],"members":{"State":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}}}},"output":{"type":"structure","members":{"Sessions":{"type":"list","member":{"type":"structure","members":{"SessionId":{},"Target":{},"Status":{},"StartDate":{"type":"timestamp"},"EndDate":{"type":"timestamp"},"DocumentName":{},"Owner":{},"Details":{},"OutputUrl":{"type":"structure","members":{"S3OutputUrl":{},"CloudWatchOutputUrl":{}}}}}},"NextToken":{}}}},"GetAutomationExecution":{"input":{"type":"structure","required":["AutomationExecutionId"],"members":{"AutomationExecutionId":{}}},"output":{"type":"structure","members":{"AutomationExecution":{"type":"structure","members":{"AutomationExecutionId":{},"DocumentName":{},"DocumentVersion":{},"ExecutionStartTime":{"type":"timestamp"},"ExecutionEndTime":{"type":"timestamp"},"AutomationExecutionStatus":{},"StepExecutions":{"shape":"S7s"},"StepExecutionsTruncated":{"type":"boolean"},"Parameters":{"shape":"S78"},"Outputs":{"shape":"S78"},"FailureMessage":{},"Mode":{},"ParentAutomationExecutionId":{},"ExecutedBy":{},"CurrentStepName":{},"CurrentAction":{},"TargetParameterName":{},"Targets":{"shape":"Sx"},"TargetMaps":{"shape":"S7d"},"ResolvedTargets":{"shape":"S7i"},"MaxConcurrency":{},"MaxErrors":{},"Target":{},"TargetLocations":{"shape":"Sex"},"ProgressCounters":{"type":"structure","members":{"TotalSteps":{"type":"integer"},"SuccessSteps":{"type":"integer"},"FailedSteps":{"type":"integer"},"CancelledSteps":{"type":"integer"},"TimedOutSteps":{"type":"integer"}}}}}}}},"GetCommandInvocation":{"input":{"type":"structure","required":["CommandId","InstanceId"],"members":{"CommandId":{},"InstanceId":{},"PluginName":{}}},"output":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"Comment":{},"DocumentName":{},"DocumentVersion":{},"PluginName":{},"ResponseCode":{"type":"integer"},"ExecutionStartDateTime":{},"ExecutionElapsedTime":{},"ExecutionEndDateTime":{},"Status":{},"StatusDetails":{},"StandardOutputContent":{},"StandardOutputUrl":{},"StandardErrorContent":{},"StandardErrorUrl":{},"CloudWatchOutputConfig":{"shape":"Sf9"}}}},"GetConnectionStatus":{"input":{"type":"structure","required":["Target"],"members":{"Target":{}}},"output":{"type":"structure","members":{"Target":{},"Status":{}}}},"GetDefaultPatchBaseline":{"input":{"type":"structure","members":{"OperatingSystem":{}}},"output":{"type":"structure","members":{"BaselineId":{},"OperatingSystem":{}}}},"GetDeployablePatchSnapshotForInstance":{"input":{"type":"structure","required":["InstanceId","SnapshotId"],"members":{"InstanceId":{},"SnapshotId":{}}},"output":{"type":"structure","members":{"InstanceId":{},"SnapshotId":{},"SnapshotDownloadUrl":{},"Product":{}}}},"GetDocument":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"VersionName":{},"DocumentVersion":{},"DocumentFormat":{}}},"output":{"type":"structure","members":{"Name":{},"VersionName":{},"DocumentVersion":{},"Status":{},"StatusInformation":{},"Content":{},"DocumentType":{},"DocumentFormat":{},"AttachmentsContent":{"type":"list","member":{"type":"structure","members":{"Name":{},"Size":{"type":"long"},"Hash":{},"HashType":{},"Url":{}}}}}}},"GetInventory":{"input":{"type":"structure","members":{"Filters":{"shape":"Sfu"},"Aggregators":{"shape":"Sg0"},"ResultAttributes":{"type":"list","member":{"type":"structure","required":["TypeName"],"members":{"TypeName":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Entities":{"type":"list","member":{"type":"structure","members":{"Id":{},"Data":{"type":"map","key":{},"value":{"type":"structure","required":["TypeName","SchemaVersion","Content"],"members":{"TypeName":{},"SchemaVersion":{},"CaptureTime":{},"ContentHash":{},"Content":{"shape":"Sgh"}}}}}}},"NextToken":{}}}},"GetInventorySchema":{"input":{"type":"structure","members":{"TypeName":{},"NextToken":{},"MaxResults":{"type":"integer"},"Aggregator":{"type":"boolean"},"SubType":{"type":"boolean"}}},"output":{"type":"structure","members":{"Schemas":{"type":"list","member":{"type":"structure","required":["TypeName","Attributes"],"members":{"TypeName":{},"Version":{},"Attributes":{"type":"list","member":{"type":"structure","required":["Name","DataType"],"members":{"Name":{},"DataType":{}}}},"DisplayName":{}}}},"NextToken":{}}}},"GetMaintenanceWindow":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{}}},"output":{"type":"structure","members":{"WindowId":{},"Name":{},"Description":{"shape":"S2y"},"StartDate":{},"EndDate":{},"Schedule":{},"ScheduleTimezone":{},"NextExecutionTime":{},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"Enabled":{"type":"boolean"},"CreatedDate":{"type":"timestamp"},"ModifiedDate":{"type":"timestamp"}}}},"GetMaintenanceWindowExecution":{"input":{"type":"structure","required":["WindowExecutionId"],"members":{"WindowExecutionId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{},"TaskIds":{"type":"list","member":{}},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"GetMaintenanceWindowExecutionTask":{"input":{"type":"structure","required":["WindowExecutionId","TaskId"],"members":{"WindowExecutionId":{},"TaskId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"TaskArn":{},"ServiceRole":{},"Type":{},"TaskParameters":{"type":"list","member":{"shape":"Scb"},"sensitive":true},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"GetMaintenanceWindowExecutionTaskInvocation":{"input":{"type":"structure","required":["WindowExecutionId","TaskId","InvocationId"],"members":{"WindowExecutionId":{},"TaskId":{},"InvocationId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"InvocationId":{},"ExecutionId":{},"TaskType":{},"Parameters":{"shape":"Sbk"},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"OwnerInformation":{"shape":"Saa"},"WindowTargetId":{}}}},"GetMaintenanceWindowTask":{"input":{"type":"structure","required":["WindowId","WindowTaskId"],"members":{"WindowId":{},"WindowTaskId":{}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{},"Targets":{"shape":"Sx"},"TaskArn":{},"ServiceRoleArn":{},"TaskType":{},"TaskParameters":{"shape":"Scb"},"TaskInvocationParameters":{"shape":"Sh8"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"Sch"},"Name":{},"Description":{"shape":"S2y"}}}},"GetOpsItem":{"input":{"type":"structure","required":["OpsItemId"],"members":{"OpsItemId":{}}},"output":{"type":"structure","members":{"OpsItem":{"type":"structure","members":{"CreatedBy":{},"CreatedTime":{"type":"timestamp"},"Description":{},"LastModifiedBy":{},"LastModifiedTime":{"type":"timestamp"},"Notifications":{"shape":"S3f"},"Priority":{"type":"integer"},"RelatedOpsItems":{"shape":"S3j"},"Status":{},"OpsItemId":{},"Version":{},"Title":{},"Source":{},"OperationalData":{"shape":"S3a"}}}}}},"GetOpsSummary":{"input":{"type":"structure","required":["Aggregators"],"members":{"Filters":{"shape":"Shs"},"Aggregators":{"shape":"Shy"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Entities":{"type":"list","member":{"type":"structure","members":{"Id":{},"Data":{"type":"map","key":{},"value":{"type":"structure","members":{"Content":{"type":"list","member":{"type":"map","key":{},"value":{}}}}}}}}},"NextToken":{}}}},"GetParameter":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"WithDecryption":{"type":"boolean"}}},"output":{"type":"structure","members":{"Parameter":{"shape":"Sih"}}}},"GetParameterHistory":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"WithDecryption":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"KeyId":{},"LastModifiedDate":{"type":"timestamp"},"LastModifiedUser":{},"Description":{},"Value":{},"AllowedPattern":{},"Version":{"type":"long"},"Labels":{"shape":"Sio"},"Tier":{},"Policies":{"shape":"Sdq"}}}},"NextToken":{}}}},"GetParameters":{"input":{"type":"structure","required":["Names"],"members":{"Names":{"shape":"S5d"},"WithDecryption":{"type":"boolean"}}},"output":{"type":"structure","members":{"Parameters":{"shape":"Sis"},"InvalidParameters":{"shape":"S5d"}}}},"GetParametersByPath":{"input":{"type":"structure","required":["Path"],"members":{"Path":{},"Recursive":{"type":"boolean"},"ParameterFilters":{"shape":"Sdb"},"WithDecryption":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Parameters":{"shape":"Sis"},"NextToken":{}}}},"GetPatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{}}},"output":{"type":"structure","members":{"BaselineId":{},"Name":{},"OperatingSystem":{},"GlobalFilters":{"shape":"S3r"},"ApprovalRules":{"shape":"S3x"},"ApprovedPatches":{"shape":"S43"},"ApprovedPatchesComplianceLevel":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"RejectedPatches":{"shape":"S43"},"RejectedPatchesAction":{},"PatchGroups":{"type":"list","member":{}},"CreatedDate":{"type":"timestamp"},"ModifiedDate":{"type":"timestamp"},"Description":{},"Sources":{"shape":"S47"}}}},"GetPatchBaselineForPatchGroup":{"input":{"type":"structure","required":["PatchGroup"],"members":{"PatchGroup":{},"OperatingSystem":{}}},"output":{"type":"structure","members":{"BaselineId":{},"PatchGroup":{},"OperatingSystem":{}}}},"GetServiceSetting":{"input":{"type":"structure","required":["SettingId"],"members":{"SettingId":{}}},"output":{"type":"structure","members":{"ServiceSetting":{"shape":"Sj4"}}}},"LabelParameterVersion":{"input":{"type":"structure","required":["Name","Labels"],"members":{"Name":{},"ParameterVersion":{"type":"long"},"Labels":{"shape":"Sio"}}},"output":{"type":"structure","members":{"InvalidLabels":{"shape":"Sio"}}}},"ListAssociationVersions":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AssociationVersions":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"AssociationVersion":{},"CreatedDate":{"type":"timestamp"},"Name":{},"DocumentVersion":{},"Parameters":{"shape":"St"},"Targets":{"shape":"Sx"},"ScheduleExpression":{},"OutputLocation":{"shape":"S13"},"AssociationName":{},"MaxErrors":{},"MaxConcurrency":{},"ComplianceSeverity":{}}}},"NextToken":{}}}},"ListAssociations":{"input":{"type":"structure","members":{"AssociationFilterList":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Associations":{"type":"list","member":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationId":{},"AssociationVersion":{},"DocumentVersion":{},"Targets":{"shape":"Sx"},"LastExecutionDate":{"type":"timestamp"},"Overview":{"shape":"S1l"},"ScheduleExpression":{},"AssociationName":{}}}},"NextToken":{}}}},"ListCommandInvocations":{"input":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Sjm"},"Details":{"type":"boolean"}}},"output":{"type":"structure","members":{"CommandInvocations":{"type":"list","member":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"InstanceName":{},"Comment":{},"DocumentName":{},"DocumentVersion":{},"RequestedDateTime":{"type":"timestamp"},"Status":{},"StatusDetails":{},"TraceOutput":{},"StandardOutputUrl":{},"StandardErrorUrl":{},"CommandPlugins":{"type":"list","member":{"type":"structure","members":{"Name":{},"Status":{},"StatusDetails":{},"ResponseCode":{"type":"integer"},"ResponseStartDateTime":{"type":"timestamp"},"ResponseFinishDateTime":{"type":"timestamp"},"Output":{},"StandardOutputUrl":{},"StandardErrorUrl":{},"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{}}}},"ServiceRole":{},"NotificationConfig":{"shape":"Sha"},"CloudWatchOutputConfig":{"shape":"Sf9"}}}},"NextToken":{}}}},"ListCommands":{"input":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Sjm"}}},"output":{"type":"structure","members":{"Commands":{"type":"list","member":{"shape":"Sk2"}},"NextToken":{}}}},"ListComplianceItems":{"input":{"type":"structure","members":{"Filters":{"shape":"Sk9"},"ResourceIds":{"type":"list","member":{}},"ResourceTypes":{"type":"list","member":{}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComplianceItems":{"type":"list","member":{"type":"structure","members":{"ComplianceType":{},"ResourceType":{},"ResourceId":{},"Id":{},"Title":{},"Status":{},"Severity":{},"ExecutionSummary":{"shape":"Skr"},"Details":{"shape":"Sku"}}}},"NextToken":{}}}},"ListComplianceSummaries":{"input":{"type":"structure","members":{"Filters":{"shape":"Sk9"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComplianceSummaryItems":{"type":"list","member":{"type":"structure","members":{"ComplianceType":{},"CompliantSummary":{"shape":"Skz"},"NonCompliantSummary":{"shape":"Sl2"}}}},"NextToken":{}}}},"ListDocumentVersions":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DocumentVersions":{"type":"list","member":{"type":"structure","members":{"Name":{},"DocumentVersion":{},"VersionName":{},"CreatedDate":{"type":"timestamp"},"IsDefaultVersion":{"type":"boolean"},"DocumentFormat":{},"Status":{},"StatusInformation":{}}}},"NextToken":{}}}},"ListDocuments":{"input":{"type":"structure","members":{"DocumentFilterList":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Filters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DocumentIdentifiers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Owner":{},"VersionName":{},"PlatformTypes":{"shape":"S2q"},"DocumentVersion":{},"DocumentType":{},"SchemaVersion":{},"DocumentFormat":{},"TargetType":{},"Tags":{"shape":"S4"}}}},"NextToken":{}}}},"ListInventoryEntries":{"input":{"type":"structure","required":["InstanceId","TypeName"],"members":{"InstanceId":{},"TypeName":{},"Filters":{"shape":"Sfu"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TypeName":{},"InstanceId":{},"SchemaVersion":{},"CaptureTime":{},"Entries":{"shape":"Sgh"},"NextToken":{}}}},"ListResourceComplianceSummaries":{"input":{"type":"structure","members":{"Filters":{"shape":"Sk9"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ResourceComplianceSummaryItems":{"type":"list","member":{"type":"structure","members":{"ComplianceType":{},"ResourceType":{},"ResourceId":{},"Status":{},"OverallSeverity":{},"ExecutionSummary":{"shape":"Skr"},"CompliantSummary":{"shape":"Skz"},"NonCompliantSummary":{"shape":"Sl2"}}}},"NextToken":{}}}},"ListResourceDataSync":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ResourceDataSyncItems":{"type":"list","member":{"type":"structure","members":{"SyncName":{},"S3Destination":{"shape":"S4h"},"LastSyncTime":{"type":"timestamp"},"LastSuccessfulSyncTime":{"type":"timestamp"},"LastStatus":{},"SyncCreatedTime":{"type":"timestamp"},"LastSyncStatusMessage":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{},"ResourceId":{}}},"output":{"type":"structure","members":{"TagList":{"shape":"S4"}}}},"ModifyDocumentPermission":{"input":{"type":"structure","required":["Name","PermissionType"],"members":{"Name":{},"PermissionType":{},"AccountIdsToAdd":{"shape":"S8x"},"AccountIdsToRemove":{"shape":"S8x"}}},"output":{"type":"structure","members":{}}},"PutComplianceItems":{"input":{"type":"structure","required":["ResourceId","ResourceType","ComplianceType","ExecutionSummary","Items"],"members":{"ResourceId":{},"ResourceType":{},"ComplianceType":{},"ExecutionSummary":{"shape":"Skr"},"Items":{"type":"list","member":{"type":"structure","required":["Severity","Status"],"members":{"Id":{},"Title":{},"Severity":{},"Status":{},"Details":{"shape":"Sku"}}}},"ItemContentHash":{}}},"output":{"type":"structure","members":{}}},"PutInventory":{"input":{"type":"structure","required":["InstanceId","Items"],"members":{"InstanceId":{},"Items":{"type":"list","member":{"type":"structure","required":["TypeName","SchemaVersion","CaptureTime"],"members":{"TypeName":{},"SchemaVersion":{},"CaptureTime":{},"ContentHash":{},"Content":{"shape":"Sgh"},"Context":{"type":"map","key":{},"value":{}}}}}}},"output":{"type":"structure","members":{"Message":{}}}},"PutParameter":{"input":{"type":"structure","required":["Name","Value","Type"],"members":{"Name":{},"Description":{},"Value":{},"Type":{},"KeyId":{},"Overwrite":{"type":"boolean"},"AllowedPattern":{},"Tags":{"shape":"S4"},"Tier":{},"Policies":{}}},"output":{"type":"structure","members":{"Version":{"type":"long"}}}},"RegisterDefaultPatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{}}},"output":{"type":"structure","members":{"BaselineId":{}}}},"RegisterPatchBaselineForPatchGroup":{"input":{"type":"structure","required":["BaselineId","PatchGroup"],"members":{"BaselineId":{},"PatchGroup":{}}},"output":{"type":"structure","members":{"BaselineId":{},"PatchGroup":{}}}},"RegisterTargetWithMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","ResourceType","Targets"],"members":{"WindowId":{},"ResourceType":{},"Targets":{"shape":"Sx"},"OwnerInformation":{"shape":"Saa"},"Name":{},"Description":{"shape":"S2y"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"WindowTargetId":{}}}},"RegisterTaskWithMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","Targets","TaskArn","TaskType","MaxConcurrency","MaxErrors"],"members":{"WindowId":{},"Targets":{"shape":"Sx"},"TaskArn":{},"ServiceRoleArn":{},"TaskType":{},"TaskParameters":{"shape":"Scb"},"TaskInvocationParameters":{"shape":"Sh8"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"Sch"},"Name":{},"Description":{"shape":"S2y"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"WindowTaskId":{}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceType","ResourceId","TagKeys"],"members":{"ResourceType":{},"ResourceId":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"ResetServiceSetting":{"input":{"type":"structure","required":["SettingId"],"members":{"SettingId":{}}},"output":{"type":"structure","members":{"ServiceSetting":{"shape":"Sj4"}}}},"ResumeSession":{"input":{"type":"structure","required":["SessionId"],"members":{"SessionId":{}}},"output":{"type":"structure","members":{"SessionId":{},"TokenValue":{},"StreamUrl":{}}}},"SendAutomationSignal":{"input":{"type":"structure","required":["AutomationExecutionId","SignalType"],"members":{"AutomationExecutionId":{},"SignalType":{},"Payload":{"shape":"S78"}}},"output":{"type":"structure","members":{}}},"SendCommand":{"input":{"type":"structure","required":["DocumentName"],"members":{"InstanceIds":{"shape":"Sb"},"Targets":{"shape":"Sx"},"DocumentName":{},"DocumentVersion":{},"DocumentHash":{},"DocumentHashType":{},"TimeoutSeconds":{"type":"integer"},"Comment":{},"Parameters":{"shape":"St"},"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"MaxConcurrency":{},"MaxErrors":{},"ServiceRoleArn":{},"NotificationConfig":{"shape":"Sha"},"CloudWatchOutputConfig":{"shape":"Sf9"}}},"output":{"type":"structure","members":{"Command":{"shape":"Sk2"}}}},"StartAssociationsOnce":{"input":{"type":"structure","required":["AssociationIds"],"members":{"AssociationIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"StartAutomationExecution":{"input":{"type":"structure","required":["DocumentName"],"members":{"DocumentName":{},"DocumentVersion":{},"Parameters":{"shape":"S78"},"ClientToken":{},"Mode":{},"TargetParameterName":{},"Targets":{"shape":"Sx"},"TargetMaps":{"shape":"S7d"},"MaxConcurrency":{},"MaxErrors":{},"TargetLocations":{"shape":"Sex"}}},"output":{"type":"structure","members":{"AutomationExecutionId":{}}}},"StartSession":{"input":{"type":"structure","required":["Target"],"members":{"Target":{},"DocumentName":{},"Parameters":{"type":"map","key":{},"value":{"type":"list","member":{}}}}},"output":{"type":"structure","members":{"SessionId":{},"TokenValue":{},"StreamUrl":{}}}},"StopAutomationExecution":{"input":{"type":"structure","required":["AutomationExecutionId"],"members":{"AutomationExecutionId":{},"Type":{}}},"output":{"type":"structure","members":{}}},"TerminateSession":{"input":{"type":"structure","required":["SessionId"],"members":{"SessionId":{}}},"output":{"type":"structure","members":{"SessionId":{}}}},"UpdateAssociation":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{},"Parameters":{"shape":"St"},"DocumentVersion":{},"ScheduleExpression":{},"OutputLocation":{"shape":"S13"},"Name":{},"Targets":{"shape":"Sx"},"AssociationName":{},"AssociationVersion":{},"AutomationTargetParameterName":{},"MaxErrors":{},"MaxConcurrency":{},"ComplianceSeverity":{}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S1e"}}}},"UpdateAssociationStatus":{"input":{"type":"structure","required":["Name","InstanceId","AssociationStatus"],"members":{"Name":{},"InstanceId":{},"AssociationStatus":{"shape":"S1h"}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S1e"}}}},"UpdateDocument":{"input":{"type":"structure","required":["Content","Name"],"members":{"Content":{},"Attachments":{"shape":"S21"},"Name":{},"VersionName":{},"DocumentVersion":{},"DocumentFormat":{},"TargetType":{}}},"output":{"type":"structure","members":{"DocumentDescription":{"shape":"S2c"}}}},"UpdateDocumentDefaultVersion":{"input":{"type":"structure","required":["Name","DocumentVersion"],"members":{"Name":{},"DocumentVersion":{}}},"output":{"type":"structure","members":{"Description":{"type":"structure","members":{"Name":{},"DefaultVersion":{},"DefaultVersionName":{}}}}}},"UpdateMaintenanceWindow":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Name":{},"Description":{"shape":"S2y"},"StartDate":{},"EndDate":{},"Schedule":{},"ScheduleTimezone":{},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"Enabled":{"type":"boolean"},"Replace":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"Name":{},"Description":{"shape":"S2y"},"StartDate":{},"EndDate":{},"Schedule":{},"ScheduleTimezone":{},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"Enabled":{"type":"boolean"}}}},"UpdateMaintenanceWindowTarget":{"input":{"type":"structure","required":["WindowId","WindowTargetId"],"members":{"WindowId":{},"WindowTargetId":{},"Targets":{"shape":"Sx"},"OwnerInformation":{"shape":"Saa"},"Name":{},"Description":{"shape":"S2y"},"Replace":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTargetId":{},"Targets":{"shape":"Sx"},"OwnerInformation":{"shape":"Saa"},"Name":{},"Description":{"shape":"S2y"}}}},"UpdateMaintenanceWindowTask":{"input":{"type":"structure","required":["WindowId","WindowTaskId"],"members":{"WindowId":{},"WindowTaskId":{},"Targets":{"shape":"Sx"},"TaskArn":{},"ServiceRoleArn":{},"TaskParameters":{"shape":"Scb"},"TaskInvocationParameters":{"shape":"Sh8"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"Sch"},"Name":{},"Description":{"shape":"S2y"},"Replace":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{},"Targets":{"shape":"Sx"},"TaskArn":{},"ServiceRoleArn":{},"TaskParameters":{"shape":"Scb"},"TaskInvocationParameters":{"shape":"Sh8"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"Sch"},"Name":{},"Description":{"shape":"S2y"}}}},"UpdateManagedInstanceRole":{"input":{"type":"structure","required":["InstanceId","IamRole"],"members":{"InstanceId":{},"IamRole":{}}},"output":{"type":"structure","members":{}}},"UpdateOpsItem":{"input":{"type":"structure","required":["OpsItemId"],"members":{"Description":{},"OperationalData":{"shape":"S3a"},"OperationalDataToDelete":{"type":"list","member":{}},"Notifications":{"shape":"S3f"},"Priority":{"type":"integer"},"RelatedOpsItems":{"shape":"S3j"},"Status":{},"OpsItemId":{},"Title":{}}},"output":{"type":"structure","members":{}}},"UpdatePatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{},"Name":{},"GlobalFilters":{"shape":"S3r"},"ApprovalRules":{"shape":"S3x"},"ApprovedPatches":{"shape":"S43"},"ApprovedPatchesComplianceLevel":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"RejectedPatches":{"shape":"S43"},"RejectedPatchesAction":{},"Description":{},"Sources":{"shape":"S47"},"Replace":{"type":"boolean"}}},"output":{"type":"structure","members":{"BaselineId":{},"Name":{},"OperatingSystem":{},"GlobalFilters":{"shape":"S3r"},"ApprovalRules":{"shape":"S3x"},"ApprovedPatches":{"shape":"S43"},"ApprovedPatchesComplianceLevel":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"RejectedPatches":{"shape":"S43"},"RejectedPatchesAction":{},"CreatedDate":{"type":"timestamp"},"ModifiedDate":{"type":"timestamp"},"Description":{},"Sources":{"shape":"S47"}}}},"UpdateServiceSetting":{"input":{"type":"structure","required":["SettingId","SettingValue"],"members":{"SettingId":{},"SettingValue":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sb":{"type":"list","member":{}},"St":{"type":"map","key":{},"value":{"type":"list","member":{}}},"Sx":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"S13":{"type":"structure","members":{"S3Location":{"type":"structure","members":{"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{}}}}},"S1e":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationVersion":{},"Date":{"type":"timestamp"},"LastUpdateAssociationDate":{"type":"timestamp"},"Status":{"shape":"S1h"},"Overview":{"shape":"S1l"},"DocumentVersion":{},"AutomationTargetParameterName":{},"Parameters":{"shape":"St"},"AssociationId":{},"Targets":{"shape":"Sx"},"ScheduleExpression":{},"OutputLocation":{"shape":"S13"},"LastExecutionDate":{"type":"timestamp"},"LastSuccessfulExecutionDate":{"type":"timestamp"},"AssociationName":{},"MaxErrors":{},"MaxConcurrency":{},"ComplianceSeverity":{}}},"S1h":{"type":"structure","required":["Date","Name","Message"],"members":{"Date":{"type":"timestamp"},"Name":{},"Message":{},"AdditionalInfo":{}}},"S1l":{"type":"structure","members":{"Status":{},"DetailedStatus":{},"AssociationStatusAggregatedCount":{"type":"map","key":{},"value":{"type":"integer"}}}},"S1s":{"type":"structure","required":["Name"],"members":{"Name":{},"InstanceId":{},"Parameters":{"shape":"St"},"AutomationTargetParameterName":{},"DocumentVersion":{},"Targets":{"shape":"Sx"},"ScheduleExpression":{},"OutputLocation":{"shape":"S13"},"AssociationName":{},"MaxErrors":{},"MaxConcurrency":{},"ComplianceSeverity":{}}},"S21":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"S2c":{"type":"structure","members":{"Sha1":{},"Hash":{},"HashType":{},"Name":{},"VersionName":{},"Owner":{},"CreatedDate":{"type":"timestamp"},"Status":{},"StatusInformation":{},"DocumentVersion":{},"Description":{},"Parameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"Description":{},"DefaultValue":{}}}},"PlatformTypes":{"shape":"S2q"},"DocumentType":{},"SchemaVersion":{},"LatestVersion":{},"DefaultVersion":{},"DocumentFormat":{},"TargetType":{},"Tags":{"shape":"S4"},"AttachmentsInformation":{"type":"list","member":{"type":"structure","members":{"Name":{}}}}}},"S2q":{"type":"list","member":{}},"S2y":{"type":"string","sensitive":true},"S3a":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{},"Type":{}}}},"S3f":{"type":"list","member":{"type":"structure","members":{"Arn":{}}}},"S3j":{"type":"list","member":{"type":"structure","required":["OpsItemId"],"members":{"OpsItemId":{}}}},"S3r":{"type":"structure","required":["PatchFilters"],"members":{"PatchFilters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}}}},"S3x":{"type":"structure","required":["PatchRules"],"members":{"PatchRules":{"type":"list","member":{"type":"structure","required":["PatchFilterGroup","ApproveAfterDays"],"members":{"PatchFilterGroup":{"shape":"S3r"},"ComplianceLevel":{},"ApproveAfterDays":{"type":"integer"},"EnableNonSecurity":{"type":"boolean"}}}}}},"S43":{"type":"list","member":{}},"S47":{"type":"list","member":{"type":"structure","required":["Name","Products","Configuration"],"members":{"Name":{},"Products":{"type":"list","member":{}},"Configuration":{"type":"string","sensitive":true}}}},"S4h":{"type":"structure","required":["BucketName","SyncFormat","Region"],"members":{"BucketName":{},"Prefix":{},"SyncFormat":{},"Region":{},"AWSKMSKeyARN":{}}},"S50":{"type":"structure","members":{"TotalCount":{"type":"integer"},"RemainingCount":{"type":"integer"},"SummaryItems":{"type":"list","member":{"type":"structure","members":{"Version":{},"Count":{"type":"integer"},"RemainingCount":{"type":"integer"}}}}}},"S5d":{"type":"list","member":{}},"S78":{"type":"map","key":{},"value":{"type":"list","member":{}}},"S7d":{"type":"list","member":{"type":"map","key":{},"value":{"type":"list","member":{}}}},"S7i":{"type":"structure","members":{"ParameterValues":{"type":"list","member":{}},"Truncated":{"type":"boolean"}}},"S7s":{"type":"list","member":{"type":"structure","members":{"StepName":{},"Action":{},"TimeoutSeconds":{"type":"long"},"OnFailure":{},"MaxAttempts":{"type":"integer"},"ExecutionStartTime":{"type":"timestamp"},"ExecutionEndTime":{"type":"timestamp"},"StepStatus":{},"ResponseCode":{},"Inputs":{"type":"map","key":{},"value":{}},"Outputs":{"shape":"S78"},"Response":{},"FailureMessage":{},"FailureDetails":{"type":"structure","members":{"FailureStage":{},"FailureType":{},"Details":{"shape":"S78"}}},"StepExecutionId":{},"OverriddenParameters":{"shape":"S78"},"IsEnd":{"type":"boolean"},"NextStep":{},"IsCritical":{"type":"boolean"},"ValidNextSteps":{"type":"list","member":{}},"Targets":{"shape":"Sx"},"TargetLocation":{"shape":"S81"}}}},"S81":{"type":"structure","members":{"Accounts":{"type":"list","member":{}},"Regions":{"type":"list","member":{}},"TargetLocationMaxConcurrency":{},"TargetLocationMaxErrors":{},"ExecutionRoleName":{}}},"S88":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"S8g":{"type":"structure","members":{"Id":{},"ReleaseDate":{"type":"timestamp"},"Title":{},"Description":{},"ContentUrl":{},"Vendor":{},"ProductFamily":{},"Product":{},"Classification":{},"MsrcSeverity":{},"KbNumber":{},"MsrcNumber":{},"Language":{}}},"S8x":{"type":"list","member":{}},"S9n":{"type":"list","member":{}},"Sa7":{"type":"structure","required":["InstanceId","PatchGroup","BaselineId","OperationStartTime","OperationEndTime","Operation"],"members":{"InstanceId":{},"PatchGroup":{},"BaselineId":{},"SnapshotId":{},"InstallOverrideList":{},"OwnerInformation":{"shape":"Saa"},"InstalledCount":{"type":"integer"},"InstalledOtherCount":{"type":"integer"},"InstalledRejectedCount":{"type":"integer"},"MissingCount":{"type":"integer"},"FailedCount":{"type":"integer"},"UnreportedNotApplicableCount":{"type":"integer"},"NotApplicableCount":{"type":"integer"},"OperationStartTime":{"type":"timestamp"},"OperationEndTime":{"type":"timestamp"},"Operation":{}}},"Saa":{"type":"string","sensitive":true},"Sb8":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"Sbk":{"type":"string","sensitive":true},"Scb":{"type":"map","key":{},"value":{"type":"structure","members":{"Values":{"type":"list","member":{"type":"string","sensitive":true},"sensitive":true}},"sensitive":true},"sensitive":true},"Sch":{"type":"structure","required":["S3BucketName","S3Region"],"members":{"S3BucketName":{},"S3KeyPrefix":{},"S3Region":{}}},"Sdb":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Option":{},"Values":{"type":"list","member":{}}}}},"Sdq":{"type":"list","member":{"type":"structure","members":{"PolicyText":{},"PolicyType":{},"PolicyStatus":{}}}},"Sdv":{"type":"structure","members":{"BaselineId":{},"BaselineName":{},"OperatingSystem":{},"BaselineDescription":{},"DefaultBaseline":{"type":"boolean"}}},"Sex":{"type":"list","member":{"shape":"S81"}},"Sf9":{"type":"structure","members":{"CloudWatchLogGroupName":{},"CloudWatchOutputEnabled":{"type":"boolean"}}},"Sfu":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Type":{}}}},"Sg0":{"type":"list","member":{"type":"structure","members":{"Expression":{},"Aggregators":{"shape":"Sg0"},"Groups":{"type":"list","member":{"type":"structure","required":["Name","Filters"],"members":{"Name":{},"Filters":{"shape":"Sfu"}}}}}}},"Sgh":{"type":"list","member":{"type":"map","key":{},"value":{}}},"Sh8":{"type":"structure","members":{"RunCommand":{"type":"structure","members":{"Comment":{},"DocumentHash":{},"DocumentHashType":{},"NotificationConfig":{"shape":"Sha"},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"Parameters":{"shape":"St"},"ServiceRoleArn":{},"TimeoutSeconds":{"type":"integer"}}},"Automation":{"type":"structure","members":{"DocumentVersion":{},"Parameters":{"shape":"S78"}}},"StepFunctions":{"type":"structure","members":{"Input":{"type":"string","sensitive":true},"Name":{}}},"Lambda":{"type":"structure","members":{"ClientContext":{},"Qualifier":{},"Payload":{"type":"blob","sensitive":true}}}}},"Sha":{"type":"structure","members":{"NotificationArn":{},"NotificationEvents":{"type":"list","member":{}},"NotificationType":{}}},"Shs":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Type":{}}}},"Shy":{"type":"list","member":{"type":"structure","members":{"AggregatorType":{},"TypeName":{},"AttributeName":{},"Values":{"type":"map","key":{},"value":{}},"Filters":{"shape":"Shs"},"Aggregators":{"shape":"Shy"}}}},"Sih":{"type":"structure","members":{"Name":{},"Type":{},"Value":{},"Version":{"type":"long"},"Selector":{},"SourceResult":{},"LastModifiedDate":{"type":"timestamp"},"ARN":{}}},"Sio":{"type":"list","member":{}},"Sis":{"type":"list","member":{"shape":"Sih"}},"Sj4":{"type":"structure","members":{"SettingId":{},"SettingValue":{},"LastModifiedDate":{"type":"timestamp"},"LastModifiedUser":{},"ARN":{},"Status":{}}},"Sjm":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Sk2":{"type":"structure","members":{"CommandId":{},"DocumentName":{},"DocumentVersion":{},"Comment":{},"ExpiresAfter":{"type":"timestamp"},"Parameters":{"shape":"St"},"InstanceIds":{"shape":"Sb"},"Targets":{"shape":"Sx"},"RequestedDateTime":{"type":"timestamp"},"Status":{},"StatusDetails":{},"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"MaxConcurrency":{},"MaxErrors":{},"TargetCount":{"type":"integer"},"CompletedCount":{"type":"integer"},"ErrorCount":{"type":"integer"},"DeliveryTimedOutCount":{"type":"integer"},"ServiceRole":{},"NotificationConfig":{"shape":"Sha"},"CloudWatchOutputConfig":{"shape":"Sf9"}}},"Sk9":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}},"Type":{}}}},"Skr":{"type":"structure","required":["ExecutionTime"],"members":{"ExecutionTime":{"type":"timestamp"},"ExecutionId":{},"ExecutionType":{}}},"Sku":{"type":"map","key":{},"value":{}},"Skz":{"type":"structure","members":{"CompliantCount":{"type":"integer"},"SeveritySummary":{"shape":"Sl1"}}},"Sl1":{"type":"structure","members":{"CriticalCount":{"type":"integer"},"HighCount":{"type":"integer"},"MediumCount":{"type":"integer"},"LowCount":{"type":"integer"},"InformationalCount":{"type":"integer"},"UnspecifiedCount":{"type":"integer"}}},"Sl2":{"type":"structure","members":{"NonCompliantCount":{"type":"integer"},"SeveritySummary":{"shape":"Sl1"}}}}}');

});

parcelRequire.register("1TuN9", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeActivations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ActivationList"},"DescribeInstanceInformation":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceInformationList"},"DescribeParameters":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetParameterHistory":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetParametersByPath":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Associations"},"ListCommandInvocations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CommandInvocations"},"ListCommands":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Commands"},"ListDocuments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DocumentIdentifiers"}}}');

});


parcelRequire.register("9l6N3", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $6ccb57984b9b5af8$var$Service = $dbC7k.Service;
var $6ccb57984b9b5af8$var$apiLoader = $dbC7k.apiLoader;
$6ccb57984b9b5af8$var$apiLoader.services["storagegateway"] = {};
$dbC7k.StorageGateway = $6ccb57984b9b5af8$var$Service.defineService("storagegateway", [
    "2013-06-30"
]);


Object.defineProperty($6ccb57984b9b5af8$var$apiLoader.services["storagegateway"], "2013-06-30", {
    get: function get() {
        var model = (parcelRequire("fD6b2"));
        model.paginators = (parcelRequire("3k2Ge")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.StorageGateway;

});
parcelRequire.register("fD6b2", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2013-06-30","endpointPrefix":"storagegateway","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Storage Gateway","serviceId":"Storage Gateway","signatureVersion":"v4","targetPrefix":"StorageGateway_20130630","uid":"storagegateway-2013-06-30"},"operations":{"ActivateGateway":{"input":{"type":"structure","required":["ActivationKey","GatewayName","GatewayTimezone","GatewayRegion"],"members":{"ActivationKey":{},"GatewayName":{},"GatewayTimezone":{},"GatewayRegion":{},"GatewayType":{},"TapeDriveType":{},"MediumChangerType":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AddCache":{"input":{"type":"structure","required":["GatewayARN","DiskIds"],"members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"ResourceARN":{}}}},"AddUploadBuffer":{"input":{"type":"structure","required":["GatewayARN","DiskIds"],"members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AddWorkingStorage":{"input":{"type":"structure","required":["GatewayARN","DiskIds"],"members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AssignTapePool":{"input":{"type":"structure","required":["TapeARN","PoolId"],"members":{"TapeARN":{},"PoolId":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"AttachVolume":{"input":{"type":"structure","required":["GatewayARN","VolumeARN","NetworkInterfaceId"],"members":{"GatewayARN":{},"TargetName":{},"VolumeARN":{},"NetworkInterfaceId":{},"DiskId":{}}},"output":{"type":"structure","members":{"VolumeARN":{},"TargetARN":{}}}},"CancelArchival":{"input":{"type":"structure","required":["GatewayARN","TapeARN"],"members":{"GatewayARN":{},"TapeARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"CancelRetrieval":{"input":{"type":"structure","required":["GatewayARN","TapeARN"],"members":{"GatewayARN":{},"TapeARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"CreateCachediSCSIVolume":{"input":{"type":"structure","required":["GatewayARN","VolumeSizeInBytes","TargetName","NetworkInterfaceId","ClientToken"],"members":{"GatewayARN":{},"VolumeSizeInBytes":{"type":"long"},"SnapshotId":{},"TargetName":{},"SourceVolumeARN":{},"NetworkInterfaceId":{},"ClientToken":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"VolumeARN":{},"TargetARN":{}}}},"CreateNFSFileShare":{"input":{"type":"structure","required":["ClientToken","GatewayARN","Role","LocationARN"],"members":{"ClientToken":{},"NFSFileShareDefaults":{"shape":"S1c"},"GatewayARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Role":{},"LocationARN":{},"DefaultStorageClass":{},"ObjectACL":{},"ClientList":{"shape":"S1j"},"Squash":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"CreateSMBFileShare":{"input":{"type":"structure","required":["ClientToken","GatewayARN","Role","LocationARN"],"members":{"ClientToken":{},"GatewayARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Role":{},"LocationARN":{},"DefaultStorageClass":{},"ObjectACL":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"SMBACLEnabled":{"type":"boolean"},"AdminUserList":{"shape":"S1p"},"ValidUserList":{"shape":"S1p"},"InvalidUserList":{"shape":"S1p"},"Authentication":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"CreateSnapshot":{"input":{"type":"structure","required":["VolumeARN","SnapshotDescription"],"members":{"VolumeARN":{},"SnapshotDescription":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"VolumeARN":{},"SnapshotId":{}}}},"CreateSnapshotFromVolumeRecoveryPoint":{"input":{"type":"structure","required":["VolumeARN","SnapshotDescription"],"members":{"VolumeARN":{},"SnapshotDescription":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"SnapshotId":{},"VolumeARN":{},"VolumeRecoveryPointTime":{}}}},"CreateStorediSCSIVolume":{"input":{"type":"structure","required":["GatewayARN","DiskId","PreserveExistingData","TargetName","NetworkInterfaceId"],"members":{"GatewayARN":{},"DiskId":{},"SnapshotId":{},"PreserveExistingData":{"type":"boolean"},"TargetName":{},"NetworkInterfaceId":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"VolumeARN":{},"VolumeSizeInBytes":{"type":"long"},"TargetARN":{}}}},"CreateTapeWithBarcode":{"input":{"type":"structure","required":["GatewayARN","TapeSizeInBytes","TapeBarcode"],"members":{"GatewayARN":{},"TapeSizeInBytes":{"type":"long"},"TapeBarcode":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"PoolId":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"CreateTapes":{"input":{"type":"structure","required":["GatewayARN","TapeSizeInBytes","ClientToken","NumTapesToCreate","TapeBarcodePrefix"],"members":{"GatewayARN":{},"TapeSizeInBytes":{"type":"long"},"ClientToken":{},"NumTapesToCreate":{"type":"integer"},"TapeBarcodePrefix":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"PoolId":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"TapeARNs":{"shape":"S2a"}}}},"DeleteBandwidthRateLimit":{"input":{"type":"structure","required":["GatewayARN","BandwidthType"],"members":{"GatewayARN":{},"BandwidthType":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"DeleteChapCredentials":{"input":{"type":"structure","required":["TargetARN","InitiatorName"],"members":{"TargetARN":{},"InitiatorName":{}}},"output":{"type":"structure","members":{"TargetARN":{},"InitiatorName":{}}}},"DeleteFileShare":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{},"ForceDelete":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"DeleteGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"DeleteSnapshotSchedule":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"DeleteTape":{"input":{"type":"structure","required":["GatewayARN","TapeARN"],"members":{"GatewayARN":{},"TapeARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"DeleteTapeArchive":{"input":{"type":"structure","required":["TapeARN"],"members":{"TapeARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"DeleteVolume":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"DescribeBandwidthRateLimit":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"AverageUploadRateLimitInBitsPerSec":{"type":"long"},"AverageDownloadRateLimitInBitsPerSec":{"type":"long"}}}},"DescribeCache":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"},"CacheAllocatedInBytes":{"type":"long"},"CacheUsedPercentage":{"type":"double"},"CacheDirtyPercentage":{"type":"double"},"CacheHitPercentage":{"type":"double"},"CacheMissPercentage":{"type":"double"}}}},"DescribeCachediSCSIVolumes":{"input":{"type":"structure","required":["VolumeARNs"],"members":{"VolumeARNs":{"shape":"S31"}}},"output":{"type":"structure","members":{"CachediSCSIVolumes":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeId":{},"VolumeType":{},"VolumeStatus":{},"VolumeAttachmentStatus":{},"VolumeSizeInBytes":{"type":"long"},"VolumeProgress":{"type":"double"},"SourceSnapshotId":{},"VolumeiSCSIAttributes":{"shape":"S3a"},"CreatedDate":{"type":"timestamp"},"VolumeUsedInBytes":{"type":"long"},"KMSKey":{},"TargetName":{}}}}}}},"DescribeChapCredentials":{"input":{"type":"structure","required":["TargetARN"],"members":{"TargetARN":{}}},"output":{"type":"structure","members":{"ChapCredentials":{"type":"list","member":{"type":"structure","members":{"TargetARN":{},"SecretToAuthenticateInitiator":{"shape":"S3j"},"InitiatorName":{},"SecretToAuthenticateTarget":{"shape":"S3j"}}}}}}},"DescribeGatewayInformation":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"GatewayId":{},"GatewayName":{},"GatewayTimezone":{},"GatewayState":{},"GatewayNetworkInterfaces":{"type":"list","member":{"type":"structure","members":{"Ipv4Address":{},"MacAddress":{},"Ipv6Address":{}}}},"GatewayType":{},"NextUpdateAvailabilityDate":{},"LastSoftwareUpdate":{},"Ec2InstanceId":{},"Ec2InstanceRegion":{},"Tags":{"shape":"S9"},"VPCEndpoint":{}}}},"DescribeMaintenanceStartTime":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"HourOfDay":{"type":"integer"},"MinuteOfHour":{"type":"integer"},"DayOfWeek":{"type":"integer"},"DayOfMonth":{"type":"integer"},"Timezone":{}}}},"DescribeNFSFileShares":{"input":{"type":"structure","required":["FileShareARNList"],"members":{"FileShareARNList":{"shape":"S41"}}},"output":{"type":"structure","members":{"NFSFileShareInfoList":{"type":"list","member":{"type":"structure","members":{"NFSFileShareDefaults":{"shape":"S1c"},"FileShareARN":{},"FileShareId":{},"FileShareStatus":{},"GatewayARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Path":{},"Role":{},"LocationARN":{},"DefaultStorageClass":{},"ObjectACL":{},"ClientList":{"shape":"S1j"},"Squash":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"Tags":{"shape":"S9"}}}}}}},"DescribeSMBFileShares":{"input":{"type":"structure","required":["FileShareARNList"],"members":{"FileShareARNList":{"shape":"S41"}}},"output":{"type":"structure","members":{"SMBFileShareInfoList":{"type":"list","member":{"type":"structure","members":{"FileShareARN":{},"FileShareId":{},"FileShareStatus":{},"GatewayARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Path":{},"Role":{},"LocationARN":{},"DefaultStorageClass":{},"ObjectACL":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"SMBACLEnabled":{"type":"boolean"},"AdminUserList":{"shape":"S1p"},"ValidUserList":{"shape":"S1p"},"InvalidUserList":{"shape":"S1p"},"Authentication":{},"Tags":{"shape":"S9"}}}}}}},"DescribeSMBSettings":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DomainName":{},"SMBGuestPasswordSet":{"type":"boolean"},"SMBSecurityStrategy":{}}}},"DescribeSnapshotSchedule":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"VolumeARN":{},"StartAt":{"type":"integer"},"RecurrenceInHours":{"type":"integer"},"Description":{},"Timezone":{},"Tags":{"shape":"S9"}}}},"DescribeStorediSCSIVolumes":{"input":{"type":"structure","required":["VolumeARNs"],"members":{"VolumeARNs":{"shape":"S31"}}},"output":{"type":"structure","members":{"StorediSCSIVolumes":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeId":{},"VolumeType":{},"VolumeStatus":{},"VolumeAttachmentStatus":{},"VolumeSizeInBytes":{"type":"long"},"VolumeProgress":{"type":"double"},"VolumeDiskId":{},"SourceSnapshotId":{},"PreservedExistingData":{"type":"boolean"},"VolumeiSCSIAttributes":{"shape":"S3a"},"CreatedDate":{"type":"timestamp"},"VolumeUsedInBytes":{"type":"long"},"KMSKey":{},"TargetName":{}}}}}}},"DescribeTapeArchives":{"input":{"type":"structure","members":{"TapeARNs":{"shape":"S2a"},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TapeArchives":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeBarcode":{},"TapeCreatedDate":{"type":"timestamp"},"TapeSizeInBytes":{"type":"long"},"CompletionTime":{"type":"timestamp"},"RetrievedTo":{},"TapeStatus":{},"TapeUsedInBytes":{"type":"long"},"KMSKey":{},"PoolId":{}}}},"Marker":{}}}},"DescribeTapeRecoveryPoints":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{},"TapeRecoveryPointInfos":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeRecoveryPointTime":{"type":"timestamp"},"TapeSizeInBytes":{"type":"long"},"TapeStatus":{}}}},"Marker":{}}}},"DescribeTapes":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"TapeARNs":{"shape":"S2a"},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Tapes":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeBarcode":{},"TapeCreatedDate":{"type":"timestamp"},"TapeSizeInBytes":{"type":"long"},"TapeStatus":{},"VTLDevice":{},"Progress":{"type":"double"},"TapeUsedInBytes":{"type":"long"},"KMSKey":{},"PoolId":{}}}},"Marker":{}}}},"DescribeUploadBuffer":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"},"UploadBufferUsedInBytes":{"type":"long"},"UploadBufferAllocatedInBytes":{"type":"long"}}}},"DescribeVTLDevices":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"VTLDeviceARNs":{"type":"list","member":{}},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{},"VTLDevices":{"type":"list","member":{"type":"structure","members":{"VTLDeviceARN":{},"VTLDeviceType":{},"VTLDeviceVendor":{},"VTLDeviceProductIdentifier":{},"DeviceiSCSIAttributes":{"type":"structure","members":{"TargetARN":{},"NetworkInterfaceId":{},"NetworkInterfacePort":{"type":"integer"},"ChapEnabled":{"type":"boolean"}}}}}},"Marker":{}}}},"DescribeWorkingStorage":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"},"WorkingStorageUsedInBytes":{"type":"long"},"WorkingStorageAllocatedInBytes":{"type":"long"}}}},"DetachVolume":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{},"ForceDetach":{"type":"boolean"}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"DisableGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"JoinDomain":{"input":{"type":"structure","required":["GatewayARN","DomainName","UserName","Password"],"members":{"GatewayARN":{},"DomainName":{},"OrganizationalUnit":{},"DomainControllers":{"type":"list","member":{}},"UserName":{},"Password":{"type":"string","sensitive":true}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"ListFileShares":{"input":{"type":"structure","members":{"GatewayARN":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"NextMarker":{},"FileShareInfoList":{"type":"list","member":{"type":"structure","members":{"FileShareType":{},"FileShareARN":{},"FileShareId":{},"FileShareStatus":{},"GatewayARN":{}}}}}}},"ListGateways":{"input":{"type":"structure","members":{"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Gateways":{"type":"list","member":{"type":"structure","members":{"GatewayId":{},"GatewayARN":{},"GatewayType":{},"GatewayOperationalState":{},"GatewayName":{},"Ec2InstanceId":{},"Ec2InstanceRegion":{}}}},"Marker":{}}}},"ListLocalDisks":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"Disks":{"type":"list","member":{"type":"structure","members":{"DiskId":{},"DiskPath":{},"DiskNode":{},"DiskStatus":{},"DiskSizeInBytes":{"type":"long"},"DiskAllocationType":{},"DiskAllocationResource":{},"DiskAttributeList":{"type":"list","member":{}}}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ResourceARN":{},"Marker":{},"Tags":{"shape":"S9"}}}},"ListTapes":{"input":{"type":"structure","members":{"TapeARNs":{"shape":"S2a"},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TapeInfos":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeBarcode":{},"TapeSizeInBytes":{"type":"long"},"TapeStatus":{},"GatewayARN":{},"PoolId":{}}}},"Marker":{}}}},"ListVolumeInitiators":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"Initiators":{"type":"list","member":{}}}}},"ListVolumeRecoveryPoints":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"VolumeRecoveryPointInfos":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeSizeInBytes":{"type":"long"},"VolumeUsageInBytes":{"type":"long"},"VolumeRecoveryPointTime":{}}}}}}},"ListVolumes":{"input":{"type":"structure","members":{"GatewayARN":{},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{},"Marker":{},"VolumeInfos":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeId":{},"GatewayARN":{},"GatewayId":{},"VolumeType":{},"VolumeSizeInBytes":{"type":"long"},"VolumeAttachmentStatus":{}}}}}}},"NotifyWhenUploaded":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{}}},"output":{"type":"structure","members":{"FileShareARN":{},"NotificationId":{}}}},"RefreshCache":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{},"FolderList":{"type":"list","member":{}},"Recursive":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileShareARN":{},"NotificationId":{}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ResourceARN":{}}}},"ResetCache":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"RetrieveTapeArchive":{"input":{"type":"structure","required":["TapeARN","GatewayARN"],"members":{"TapeARN":{},"GatewayARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"RetrieveTapeRecoveryPoint":{"input":{"type":"structure","required":["TapeARN","GatewayARN"],"members":{"TapeARN":{},"GatewayARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"SetLocalConsolePassword":{"input":{"type":"structure","required":["GatewayARN","LocalConsolePassword"],"members":{"GatewayARN":{},"LocalConsolePassword":{"type":"string","sensitive":true}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"SetSMBGuestPassword":{"input":{"type":"structure","required":["GatewayARN","Password"],"members":{"GatewayARN":{},"Password":{"type":"string","sensitive":true}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"ShutdownGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"StartGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateBandwidthRateLimit":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"AverageUploadRateLimitInBitsPerSec":{"type":"long"},"AverageDownloadRateLimitInBitsPerSec":{"type":"long"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateChapCredentials":{"input":{"type":"structure","required":["TargetARN","SecretToAuthenticateInitiator","InitiatorName"],"members":{"TargetARN":{},"SecretToAuthenticateInitiator":{"shape":"S3j"},"InitiatorName":{},"SecretToAuthenticateTarget":{"shape":"S3j"}}},"output":{"type":"structure","members":{"TargetARN":{},"InitiatorName":{}}}},"UpdateGatewayInformation":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"GatewayName":{},"GatewayTimezone":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"GatewayName":{}}}},"UpdateGatewaySoftwareNow":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateMaintenanceStartTime":{"input":{"type":"structure","required":["GatewayARN","HourOfDay","MinuteOfHour"],"members":{"GatewayARN":{},"HourOfDay":{"type":"integer"},"MinuteOfHour":{"type":"integer"},"DayOfWeek":{"type":"integer"},"DayOfMonth":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateNFSFileShare":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"NFSFileShareDefaults":{"shape":"S1c"},"DefaultStorageClass":{},"ObjectACL":{},"ClientList":{"shape":"S1j"},"Squash":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"UpdateSMBFileShare":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"DefaultStorageClass":{},"ObjectACL":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"SMBACLEnabled":{"type":"boolean"},"AdminUserList":{"shape":"S1p"},"ValidUserList":{"shape":"S1p"},"InvalidUserList":{"shape":"S1p"}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"UpdateSMBSecurityStrategy":{"input":{"type":"structure","required":["GatewayARN","SMBSecurityStrategy"],"members":{"GatewayARN":{},"SMBSecurityStrategy":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateSnapshotSchedule":{"input":{"type":"structure","required":["VolumeARN","StartAt","RecurrenceInHours"],"members":{"VolumeARN":{},"StartAt":{"type":"integer"},"RecurrenceInHours":{"type":"integer"},"Description":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"UpdateVTLDeviceType":{"input":{"type":"structure","required":["VTLDeviceARN","DeviceType"],"members":{"VTLDeviceARN":{},"DeviceType":{}}},"output":{"type":"structure","members":{"VTLDeviceARN":{}}}}},"shapes":{"S9":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sg":{"type":"list","member":{}},"S1c":{"type":"structure","members":{"FileMode":{},"DirectoryMode":{},"GroupId":{"type":"long"},"OwnerId":{"type":"long"}}},"S1j":{"type":"list","member":{}},"S1p":{"type":"list","member":{}},"S2a":{"type":"list","member":{}},"S31":{"type":"list","member":{}},"S3a":{"type":"structure","members":{"TargetARN":{},"NetworkInterfaceId":{},"NetworkInterfacePort":{"type":"integer"},"LunNumber":{"type":"integer"},"ChapEnabled":{"type":"boolean"}}},"S3j":{"type":"string","sensitive":true},"S41":{"type":"list","member":{}}}}');

});

parcelRequire.register("3k2Ge", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeCachediSCSIVolumes":{"result_key":"CachediSCSIVolumes"},"DescribeStorediSCSIVolumes":{"result_key":"StorediSCSIVolumes"},"DescribeTapeArchives":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"TapeArchives"},"DescribeTapeRecoveryPoints":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"TapeRecoveryPointInfos"},"DescribeTapes":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Tapes"},"DescribeVTLDevices":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"VTLDevices"},"ListFileShares":{"input_token":"Marker","limit_key":"Limit","non_aggregate_keys":["Marker"],"output_token":"NextMarker","result_key":"FileShareInfoList"},"ListGateways":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Gateways"},"ListLocalDisks":{"result_key":"Disks"},"ListTagsForResource":{"input_token":"Marker","limit_key":"Limit","non_aggregate_keys":["ResourceARN"],"output_token":"Marker","result_key":"Tags"},"ListTapes":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"TapeInfos"},"ListVolumeRecoveryPoints":{"result_key":"VolumeRecoveryPointInfos"},"ListVolumes":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"VolumeInfos"}}}');

});


parcelRequire.register("kWbYB", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $f3e283afedafbda1$var$Service = $dbC7k.Service;
var $f3e283afedafbda1$var$apiLoader = $dbC7k.apiLoader;
$f3e283afedafbda1$var$apiLoader.services["stepfunctions"] = {};
$dbC7k.StepFunctions = $f3e283afedafbda1$var$Service.defineService("stepfunctions", [
    "2016-11-23"
]);


Object.defineProperty($f3e283afedafbda1$var$apiLoader.services["stepfunctions"], "2016-11-23", {
    get: function get() {
        var model = (parcelRequire("fJQ5P"));
        model.paginators = (parcelRequire("8Y7kU")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.StepFunctions;

});
parcelRequire.register("fJQ5P", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-11-23","endpointPrefix":"states","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"AWS SFN","serviceFullName":"AWS Step Functions","serviceId":"SFN","signatureVersion":"v4","targetPrefix":"AWSStepFunctions","uid":"states-2016-11-23"},"operations":{"CreateActivity":{"input":{"type":"structure","required":["name"],"members":{"name":{},"tags":{"shape":"S3"}}},"output":{"type":"structure","required":["activityArn","creationDate"],"members":{"activityArn":{},"creationDate":{"type":"timestamp"}}},"idempotent":true},"CreateStateMachine":{"input":{"type":"structure","required":["name","definition","roleArn"],"members":{"name":{},"definition":{"shape":"Sb"},"roleArn":{},"tags":{"shape":"S3"}}},"output":{"type":"structure","required":["stateMachineArn","creationDate"],"members":{"stateMachineArn":{},"creationDate":{"type":"timestamp"}}},"idempotent":true},"DeleteActivity":{"input":{"type":"structure","required":["activityArn"],"members":{"activityArn":{}}},"output":{"type":"structure","members":{}}},"DeleteStateMachine":{"input":{"type":"structure","required":["stateMachineArn"],"members":{"stateMachineArn":{}}},"output":{"type":"structure","members":{}}},"DescribeActivity":{"input":{"type":"structure","required":["activityArn"],"members":{"activityArn":{}}},"output":{"type":"structure","required":["activityArn","name","creationDate"],"members":{"activityArn":{},"name":{},"creationDate":{"type":"timestamp"}}}},"DescribeExecution":{"input":{"type":"structure","required":["executionArn"],"members":{"executionArn":{}}},"output":{"type":"structure","required":["executionArn","stateMachineArn","status","startDate","input"],"members":{"executionArn":{},"stateMachineArn":{},"name":{},"status":{},"startDate":{"type":"timestamp"},"stopDate":{"type":"timestamp"},"input":{"shape":"Sm"},"output":{"shape":"Sm"}}}},"DescribeStateMachine":{"input":{"type":"structure","required":["stateMachineArn"],"members":{"stateMachineArn":{}}},"output":{"type":"structure","required":["stateMachineArn","name","definition","roleArn","creationDate"],"members":{"stateMachineArn":{},"name":{},"status":{},"definition":{"shape":"Sb"},"roleArn":{},"creationDate":{"type":"timestamp"}}}},"DescribeStateMachineForExecution":{"input":{"type":"structure","required":["executionArn"],"members":{"executionArn":{}}},"output":{"type":"structure","required":["stateMachineArn","name","definition","roleArn","updateDate"],"members":{"stateMachineArn":{},"name":{},"definition":{"shape":"Sb"},"roleArn":{},"updateDate":{"type":"timestamp"}}}},"GetActivityTask":{"input":{"type":"structure","required":["activityArn"],"members":{"activityArn":{},"workerName":{}}},"output":{"type":"structure","members":{"taskToken":{},"input":{"type":"string","sensitive":true}}}},"GetExecutionHistory":{"input":{"type":"structure","required":["executionArn"],"members":{"executionArn":{},"maxResults":{"type":"integer"},"reverseOrder":{"type":"boolean"},"nextToken":{}}},"output":{"type":"structure","required":["events"],"members":{"events":{"type":"list","member":{"type":"structure","required":["timestamp","type","id"],"members":{"timestamp":{"type":"timestamp"},"type":{},"id":{"type":"long"},"previousEventId":{"type":"long"},"activityFailedEventDetails":{"type":"structure","members":{"error":{"shape":"S16"},"cause":{"shape":"S17"}}},"activityScheduleFailedEventDetails":{"type":"structure","members":{"error":{"shape":"S16"},"cause":{"shape":"S17"}}},"activityScheduledEventDetails":{"type":"structure","required":["resource"],"members":{"resource":{},"input":{"shape":"Sm"},"timeoutInSeconds":{"type":"long"},"heartbeatInSeconds":{"type":"long"}}},"activityStartedEventDetails":{"type":"structure","members":{"workerName":{}}},"activitySucceededEventDetails":{"type":"structure","members":{"output":{"shape":"Sm"}}},"activityTimedOutEventDetails":{"type":"structure","members":{"error":{"shape":"S16"},"cause":{"shape":"S17"}}},"taskFailedEventDetails":{"type":"structure","required":["resourceType","resource"],"members":{"resourceType":{},"resource":{},"error":{"shape":"S16"},"cause":{"shape":"S17"}}},"taskScheduledEventDetails":{"type":"structure","required":["resourceType","resource","region","parameters"],"members":{"resourceType":{},"resource":{},"region":{},"parameters":{"type":"string","sensitive":true},"timeoutInSeconds":{"type":"long"}}},"taskStartFailedEventDetails":{"type":"structure","required":["resourceType","resource"],"members":{"resourceType":{},"resource":{},"error":{"shape":"S16"},"cause":{"shape":"S17"}}},"taskStartedEventDetails":{"type":"structure","required":["resourceType","resource"],"members":{"resourceType":{},"resource":{}}},"taskSubmitFailedEventDetails":{"type":"structure","required":["resourceType","resource"],"members":{"resourceType":{},"resource":{},"error":{"shape":"S16"},"cause":{"shape":"S17"}}},"taskSubmittedEventDetails":{"type":"structure","required":["resourceType","resource"],"members":{"resourceType":{},"resource":{},"output":{"shape":"Sm"}}},"taskSucceededEventDetails":{"type":"structure","required":["resourceType","resource"],"members":{"resourceType":{},"resource":{},"output":{"shape":"Sm"}}},"taskTimedOutEventDetails":{"type":"structure","required":["resourceType","resource"],"members":{"resourceType":{},"resource":{},"error":{"shape":"S16"},"cause":{"shape":"S17"}}},"executionFailedEventDetails":{"type":"structure","members":{"error":{"shape":"S16"},"cause":{"shape":"S17"}}},"executionStartedEventDetails":{"type":"structure","members":{"input":{"shape":"Sm"},"roleArn":{}}},"executionSucceededEventDetails":{"type":"structure","members":{"output":{"shape":"Sm"}}},"executionAbortedEventDetails":{"type":"structure","members":{"error":{"shape":"S16"},"cause":{"shape":"S17"}}},"executionTimedOutEventDetails":{"type":"structure","members":{"error":{"shape":"S16"},"cause":{"shape":"S17"}}},"lambdaFunctionFailedEventDetails":{"type":"structure","members":{"error":{"shape":"S16"},"cause":{"shape":"S17"}}},"lambdaFunctionScheduleFailedEventDetails":{"type":"structure","members":{"error":{"shape":"S16"},"cause":{"shape":"S17"}}},"lambdaFunctionScheduledEventDetails":{"type":"structure","required":["resource"],"members":{"resource":{},"input":{"shape":"Sm"},"timeoutInSeconds":{"type":"long"}}},"lambdaFunctionStartFailedEventDetails":{"type":"structure","members":{"error":{"shape":"S16"},"cause":{"shape":"S17"}}},"lambdaFunctionSucceededEventDetails":{"type":"structure","members":{"output":{"shape":"Sm"}}},"lambdaFunctionTimedOutEventDetails":{"type":"structure","members":{"error":{"shape":"S16"},"cause":{"shape":"S17"}}},"stateEnteredEventDetails":{"type":"structure","required":["name"],"members":{"name":{},"input":{"shape":"Sm"}}},"stateExitedEventDetails":{"type":"structure","required":["name"],"members":{"name":{},"output":{"shape":"Sm"}}}}}},"nextToken":{}}}},"ListActivities":{"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["activities"],"members":{"activities":{"type":"list","member":{"type":"structure","required":["activityArn","name","creationDate"],"members":{"activityArn":{},"name":{},"creationDate":{"type":"timestamp"}}}},"nextToken":{}}}},"ListExecutions":{"input":{"type":"structure","required":["stateMachineArn"],"members":{"stateMachineArn":{},"statusFilter":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["executions"],"members":{"executions":{"type":"list","member":{"type":"structure","required":["executionArn","stateMachineArn","name","status","startDate"],"members":{"executionArn":{},"stateMachineArn":{},"name":{},"status":{},"startDate":{"type":"timestamp"},"stopDate":{"type":"timestamp"}}}},"nextToken":{}}}},"ListStateMachines":{"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["stateMachines"],"members":{"stateMachines":{"type":"list","member":{"type":"structure","required":["stateMachineArn","name","creationDate"],"members":{"stateMachineArn":{},"name":{},"creationDate":{"type":"timestamp"}}}},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"tags":{"shape":"S3"}}}},"SendTaskFailure":{"input":{"type":"structure","required":["taskToken"],"members":{"taskToken":{},"error":{"shape":"S16"},"cause":{"shape":"S17"}}},"output":{"type":"structure","members":{}}},"SendTaskHeartbeat":{"input":{"type":"structure","required":["taskToken"],"members":{"taskToken":{}}},"output":{"type":"structure","members":{}}},"SendTaskSuccess":{"input":{"type":"structure","required":["taskToken","output"],"members":{"taskToken":{},"output":{"shape":"Sm"}}},"output":{"type":"structure","members":{}}},"StartExecution":{"input":{"type":"structure","required":["stateMachineArn"],"members":{"stateMachineArn":{},"name":{},"input":{"shape":"Sm"}}},"output":{"type":"structure","required":["executionArn","startDate"],"members":{"executionArn":{},"startDate":{"type":"timestamp"}}},"idempotent":true},"StopExecution":{"input":{"type":"structure","required":["executionArn"],"members":{"executionArn":{},"error":{"shape":"S16"},"cause":{"shape":"S17"}}},"output":{"type":"structure","required":["stopDate"],"members":{"stopDate":{"type":"timestamp"}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateStateMachine":{"input":{"type":"structure","required":["stateMachineArn"],"members":{"stateMachineArn":{},"definition":{"shape":"Sb"},"roleArn":{}}},"output":{"type":"structure","required":["updateDate"],"members":{"updateDate":{"type":"timestamp"}}},"idempotent":true}},"shapes":{"S3":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}}},"Sb":{"type":"string","sensitive":true},"Sm":{"type":"string","sensitive":true},"S16":{"type":"string","sensitive":true},"S17":{"type":"string","sensitive":true}}}');

});

parcelRequire.register("8Y7kU", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"GetExecutionHistory":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"events"},"ListActivities":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"activities"},"ListExecutions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"executions"},"ListStateMachines":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"stateMachines"}}}');

});


parcelRequire.register("9FKrv", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $70abf7ed9db80512$var$Service = $dbC7k.Service;
var $70abf7ed9db80512$var$apiLoader = $dbC7k.apiLoader;
$70abf7ed9db80512$var$apiLoader.services["support"] = {};
$dbC7k.Support = $70abf7ed9db80512$var$Service.defineService("support", [
    "2013-04-15"
]);


Object.defineProperty($70abf7ed9db80512$var$apiLoader.services["support"], "2013-04-15", {
    get: function get() {
        var model = (parcelRequire("ingom"));
        model.paginators = (parcelRequire("cTVan")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Support;

});
parcelRequire.register("ingom", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"uid":"support-2013-04-15","apiVersion":"2013-04-15","endpointPrefix":"support","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Support","serviceId":"Support","signatureVersion":"v4","targetPrefix":"AWSSupport_20130415"},"operations":{"AddAttachmentsToSet":{"input":{"type":"structure","required":["attachments"],"members":{"attachmentSetId":{},"attachments":{"type":"list","member":{"shape":"S4"}}}},"output":{"type":"structure","members":{"attachmentSetId":{},"expiryTime":{}}}},"AddCommunicationToCase":{"input":{"type":"structure","required":["communicationBody"],"members":{"caseId":{},"communicationBody":{},"ccEmailAddresses":{"shape":"Sc"},"attachmentSetId":{}}},"output":{"type":"structure","members":{"result":{"type":"boolean"}}}},"CreateCase":{"input":{"type":"structure","required":["subject","communicationBody"],"members":{"subject":{},"serviceCode":{},"severityCode":{},"categoryCode":{},"communicationBody":{},"ccEmailAddresses":{"shape":"Sc"},"language":{},"issueType":{},"attachmentSetId":{}}},"output":{"type":"structure","members":{"caseId":{}}}},"DescribeAttachment":{"input":{"type":"structure","required":["attachmentId"],"members":{"attachmentId":{}}},"output":{"type":"structure","members":{"attachment":{"shape":"S4"}}}},"DescribeCases":{"input":{"type":"structure","members":{"caseIdList":{"type":"list","member":{}},"displayId":{},"afterTime":{},"beforeTime":{},"includeResolvedCases":{"type":"boolean"},"nextToken":{},"maxResults":{"type":"integer"},"language":{},"includeCommunications":{"type":"boolean"}}},"output":{"type":"structure","members":{"cases":{"type":"list","member":{"type":"structure","members":{"caseId":{},"displayId":{},"subject":{},"status":{},"serviceCode":{},"categoryCode":{},"severityCode":{},"submittedBy":{},"timeCreated":{},"recentCommunications":{"type":"structure","members":{"communications":{"shape":"S17"},"nextToken":{}}},"ccEmailAddresses":{"shape":"Sc"},"language":{}}}},"nextToken":{}}}},"DescribeCommunications":{"input":{"type":"structure","required":["caseId"],"members":{"caseId":{},"beforeTime":{},"afterTime":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"communications":{"shape":"S17"},"nextToken":{}}}},"DescribeServices":{"input":{"type":"structure","members":{"serviceCodeList":{"type":"list","member":{}},"language":{}}},"output":{"type":"structure","members":{"services":{"type":"list","member":{"type":"structure","members":{"code":{},"name":{},"categories":{"type":"list","member":{"type":"structure","members":{"code":{},"name":{}}}}}}}}}},"DescribeSeverityLevels":{"input":{"type":"structure","members":{"language":{}}},"output":{"type":"structure","members":{"severityLevels":{"type":"list","member":{"type":"structure","members":{"code":{},"name":{}}}}}}},"DescribeTrustedAdvisorCheckRefreshStatuses":{"input":{"type":"structure","required":["checkIds"],"members":{"checkIds":{"shape":"S1t"}}},"output":{"type":"structure","required":["statuses"],"members":{"statuses":{"type":"list","member":{"shape":"S1x"}}}}},"DescribeTrustedAdvisorCheckResult":{"input":{"type":"structure","required":["checkId"],"members":{"checkId":{},"language":{}}},"output":{"type":"structure","members":{"result":{"type":"structure","required":["checkId","timestamp","status","resourcesSummary","categorySpecificSummary","flaggedResources"],"members":{"checkId":{},"timestamp":{},"status":{},"resourcesSummary":{"shape":"S22"},"categorySpecificSummary":{"shape":"S23"},"flaggedResources":{"type":"list","member":{"type":"structure","required":["status","resourceId","metadata"],"members":{"status":{},"region":{},"resourceId":{},"isSuppressed":{"type":"boolean"},"metadata":{"shape":"S1t"}}}}}}}}},"DescribeTrustedAdvisorCheckSummaries":{"input":{"type":"structure","required":["checkIds"],"members":{"checkIds":{"shape":"S1t"}}},"output":{"type":"structure","required":["summaries"],"members":{"summaries":{"type":"list","member":{"type":"structure","required":["checkId","timestamp","status","resourcesSummary","categorySpecificSummary"],"members":{"checkId":{},"timestamp":{},"status":{},"hasFlaggedResources":{"type":"boolean"},"resourcesSummary":{"shape":"S22"},"categorySpecificSummary":{"shape":"S23"}}}}}}},"DescribeTrustedAdvisorChecks":{"input":{"type":"structure","required":["language"],"members":{"language":{}}},"output":{"type":"structure","required":["checks"],"members":{"checks":{"type":"list","member":{"type":"structure","required":["id","name","description","category","metadata"],"members":{"id":{},"name":{},"description":{},"category":{},"metadata":{"shape":"S1t"}}}}}}},"RefreshTrustedAdvisorCheck":{"input":{"type":"structure","required":["checkId"],"members":{"checkId":{}}},"output":{"type":"structure","required":["status"],"members":{"status":{"shape":"S1x"}}}},"ResolveCase":{"input":{"type":"structure","members":{"caseId":{}}},"output":{"type":"structure","members":{"initialCaseStatus":{},"finalCaseStatus":{}}}}},"shapes":{"S4":{"type":"structure","members":{"fileName":{},"data":{"type":"blob"}}},"Sc":{"type":"list","member":{}},"S17":{"type":"list","member":{"type":"structure","members":{"caseId":{},"body":{},"submittedBy":{},"timeCreated":{},"attachmentSet":{"type":"list","member":{"type":"structure","members":{"attachmentId":{},"fileName":{}}}}}}},"S1t":{"type":"list","member":{}},"S1x":{"type":"structure","required":["checkId","status","millisUntilNextRefreshable"],"members":{"checkId":{},"status":{},"millisUntilNextRefreshable":{"type":"long"}}},"S22":{"type":"structure","required":["resourcesProcessed","resourcesFlagged","resourcesIgnored","resourcesSuppressed"],"members":{"resourcesProcessed":{"type":"long"},"resourcesFlagged":{"type":"long"},"resourcesIgnored":{"type":"long"},"resourcesSuppressed":{"type":"long"}}},"S23":{"type":"structure","members":{"costOptimizing":{"type":"structure","required":["estimatedMonthlySavings","estimatedPercentMonthlySavings"],"members":{"estimatedMonthlySavings":{"type":"double"},"estimatedPercentMonthlySavings":{"type":"double"}}}}}}}');

});

parcelRequire.register("cTVan", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeCases":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"cases"},"DescribeCommunications":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"communications"},"DescribeServices":{"result_key":"services"},"DescribeTrustedAdvisorCheckRefreshStatuses":{"result_key":"statuses"},"DescribeTrustedAdvisorCheckSummaries":{"result_key":"summaries"}}}');

});


parcelRequire.register("hQukQ", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $cfded2e9b38352cc$var$Service = $dbC7k.Service;
var $cfded2e9b38352cc$var$apiLoader = $dbC7k.apiLoader;
$cfded2e9b38352cc$var$apiLoader.services["swf"] = {};
$dbC7k.SWF = $cfded2e9b38352cc$var$Service.defineService("swf", [
    "2012-01-25"
]);
parcelRequire("jDGzw");


Object.defineProperty($cfded2e9b38352cc$var$apiLoader.services["swf"], "2012-01-25", {
    get: function get() {
        var model = (parcelRequire("liADg"));
        model.paginators = (parcelRequire("hY9tU")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.SWF;

});
parcelRequire.register("jDGzw", function(module, exports) {

var $dbC7k = parcelRequire("dbC7k");
$dbC7k.util.hideProperties($dbC7k, [
    "SimpleWorkflow"
]);
/**
 * @constant
 * @readonly
 * Backwards compatibility for access to the {AWS.SWF} service class.
 */ $dbC7k.SimpleWorkflow = $dbC7k.SWF;

});

parcelRequire.register("liADg", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2012-01-25","endpointPrefix":"swf","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"Amazon SWF","serviceFullName":"Amazon Simple Workflow Service","serviceId":"SWF","signatureVersion":"v4","targetPrefix":"SimpleWorkflowService","uid":"swf-2012-01-25"},"operations":{"CountClosedWorkflowExecutions":{"input":{"type":"structure","required":["domain"],"members":{"domain":{},"startTimeFilter":{"shape":"S3"},"closeTimeFilter":{"shape":"S3"},"executionFilter":{"shape":"S5"},"typeFilter":{"shape":"S7"},"tagFilter":{"shape":"Sa"},"closeStatusFilter":{"shape":"Sc"}}},"output":{"shape":"Se"}},"CountOpenWorkflowExecutions":{"input":{"type":"structure","required":["domain","startTimeFilter"],"members":{"domain":{},"startTimeFilter":{"shape":"S3"},"typeFilter":{"shape":"S7"},"tagFilter":{"shape":"Sa"},"executionFilter":{"shape":"S5"}}},"output":{"shape":"Se"}},"CountPendingActivityTasks":{"input":{"type":"structure","required":["domain","taskList"],"members":{"domain":{},"taskList":{"shape":"Sj"}}},"output":{"shape":"Sk"}},"CountPendingDecisionTasks":{"input":{"type":"structure","required":["domain","taskList"],"members":{"domain":{},"taskList":{"shape":"Sj"}}},"output":{"shape":"Sk"}},"DeprecateActivityType":{"input":{"type":"structure","required":["domain","activityType"],"members":{"domain":{},"activityType":{"shape":"Sn"}}}},"DeprecateDomain":{"input":{"type":"structure","required":["name"],"members":{"name":{}}}},"DeprecateWorkflowType":{"input":{"type":"structure","required":["domain","workflowType"],"members":{"domain":{},"workflowType":{"shape":"Sr"}}}},"DescribeActivityType":{"input":{"type":"structure","required":["domain","activityType"],"members":{"domain":{},"activityType":{"shape":"Sn"}}},"output":{"type":"structure","required":["typeInfo","configuration"],"members":{"typeInfo":{"shape":"Su"},"configuration":{"type":"structure","members":{"defaultTaskStartToCloseTimeout":{},"defaultTaskHeartbeatTimeout":{},"defaultTaskList":{"shape":"Sj"},"defaultTaskPriority":{},"defaultTaskScheduleToStartTimeout":{},"defaultTaskScheduleToCloseTimeout":{}}}}}},"DescribeDomain":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","required":["domainInfo","configuration"],"members":{"domainInfo":{"shape":"S12"},"configuration":{"type":"structure","required":["workflowExecutionRetentionPeriodInDays"],"members":{"workflowExecutionRetentionPeriodInDays":{}}}}}},"DescribeWorkflowExecution":{"input":{"type":"structure","required":["domain","execution"],"members":{"domain":{},"execution":{"shape":"S17"}}},"output":{"type":"structure","required":["executionInfo","executionConfiguration","openCounts"],"members":{"executionInfo":{"shape":"S1a"},"executionConfiguration":{"type":"structure","required":["taskStartToCloseTimeout","executionStartToCloseTimeout","taskList","childPolicy"],"members":{"taskStartToCloseTimeout":{},"executionStartToCloseTimeout":{},"taskList":{"shape":"Sj"},"taskPriority":{},"childPolicy":{},"lambdaRole":{}}},"openCounts":{"type":"structure","required":["openActivityTasks","openDecisionTasks","openTimers","openChildWorkflowExecutions"],"members":{"openActivityTasks":{"type":"integer"},"openDecisionTasks":{"type":"integer"},"openTimers":{"type":"integer"},"openChildWorkflowExecutions":{"type":"integer"},"openLambdaFunctions":{"type":"integer"}}},"latestActivityTaskTimestamp":{"type":"timestamp"},"latestExecutionContext":{}}}},"DescribeWorkflowType":{"input":{"type":"structure","required":["domain","workflowType"],"members":{"domain":{},"workflowType":{"shape":"Sr"}}},"output":{"type":"structure","required":["typeInfo","configuration"],"members":{"typeInfo":{"shape":"S1m"},"configuration":{"type":"structure","members":{"defaultTaskStartToCloseTimeout":{},"defaultExecutionStartToCloseTimeout":{},"defaultTaskList":{"shape":"Sj"},"defaultTaskPriority":{},"defaultChildPolicy":{},"defaultLambdaRole":{}}}}}},"GetWorkflowExecutionHistory":{"input":{"type":"structure","required":["domain","execution"],"members":{"domain":{},"execution":{"shape":"S17"},"nextPageToken":{},"maximumPageSize":{"type":"integer"},"reverseOrder":{"type":"boolean"}}},"output":{"type":"structure","required":["events"],"members":{"events":{"shape":"S1t"},"nextPageToken":{}}}},"ListActivityTypes":{"input":{"type":"structure","required":["domain","registrationStatus"],"members":{"domain":{},"name":{},"registrationStatus":{},"nextPageToken":{},"maximumPageSize":{"type":"integer"},"reverseOrder":{"type":"boolean"}}},"output":{"type":"structure","required":["typeInfos"],"members":{"typeInfos":{"type":"list","member":{"shape":"Su"}},"nextPageToken":{}}}},"ListClosedWorkflowExecutions":{"input":{"type":"structure","required":["domain"],"members":{"domain":{},"startTimeFilter":{"shape":"S3"},"closeTimeFilter":{"shape":"S3"},"executionFilter":{"shape":"S5"},"closeStatusFilter":{"shape":"Sc"},"typeFilter":{"shape":"S7"},"tagFilter":{"shape":"Sa"},"nextPageToken":{},"maximumPageSize":{"type":"integer"},"reverseOrder":{"type":"boolean"}}},"output":{"shape":"S4g"}},"ListDomains":{"input":{"type":"structure","required":["registrationStatus"],"members":{"nextPageToken":{},"registrationStatus":{},"maximumPageSize":{"type":"integer"},"reverseOrder":{"type":"boolean"}}},"output":{"type":"structure","required":["domainInfos"],"members":{"domainInfos":{"type":"list","member":{"shape":"S12"}},"nextPageToken":{}}}},"ListOpenWorkflowExecutions":{"input":{"type":"structure","required":["domain","startTimeFilter"],"members":{"domain":{},"startTimeFilter":{"shape":"S3"},"typeFilter":{"shape":"S7"},"tagFilter":{"shape":"Sa"},"nextPageToken":{},"maximumPageSize":{"type":"integer"},"reverseOrder":{"type":"boolean"},"executionFilter":{"shape":"S5"}}},"output":{"shape":"S4g"}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"tags":{"shape":"S4o"}}}},"ListWorkflowTypes":{"input":{"type":"structure","required":["domain","registrationStatus"],"members":{"domain":{},"name":{},"registrationStatus":{},"nextPageToken":{},"maximumPageSize":{"type":"integer"},"reverseOrder":{"type":"boolean"}}},"output":{"type":"structure","required":["typeInfos"],"members":{"typeInfos":{"type":"list","member":{"shape":"S1m"}},"nextPageToken":{}}}},"PollForActivityTask":{"input":{"type":"structure","required":["domain","taskList"],"members":{"domain":{},"taskList":{"shape":"Sj"},"identity":{}}},"output":{"type":"structure","required":["taskToken","activityId","startedEventId","workflowExecution","activityType"],"members":{"taskToken":{},"activityId":{},"startedEventId":{"type":"long"},"workflowExecution":{"shape":"S17"},"activityType":{"shape":"Sn"},"input":{}}}},"PollForDecisionTask":{"input":{"type":"structure","required":["domain","taskList"],"members":{"domain":{},"taskList":{"shape":"Sj"},"identity":{},"nextPageToken":{},"maximumPageSize":{"type":"integer"},"reverseOrder":{"type":"boolean"}}},"output":{"type":"structure","required":["taskToken","startedEventId","workflowExecution","workflowType","events"],"members":{"taskToken":{},"startedEventId":{"type":"long"},"workflowExecution":{"shape":"S17"},"workflowType":{"shape":"Sr"},"events":{"shape":"S1t"},"nextPageToken":{},"previousStartedEventId":{"type":"long"}}}},"RecordActivityTaskHeartbeat":{"input":{"type":"structure","required":["taskToken"],"members":{"taskToken":{},"details":{}}},"output":{"type":"structure","required":["cancelRequested"],"members":{"cancelRequested":{"type":"boolean"}}}},"RegisterActivityType":{"input":{"type":"structure","required":["domain","name","version"],"members":{"domain":{},"name":{},"version":{},"description":{},"defaultTaskStartToCloseTimeout":{},"defaultTaskHeartbeatTimeout":{},"defaultTaskList":{"shape":"Sj"},"defaultTaskPriority":{},"defaultTaskScheduleToStartTimeout":{},"defaultTaskScheduleToCloseTimeout":{}}}},"RegisterDomain":{"input":{"type":"structure","required":["name","workflowExecutionRetentionPeriodInDays"],"members":{"name":{},"description":{},"workflowExecutionRetentionPeriodInDays":{},"tags":{"shape":"S4o"}}}},"RegisterWorkflowType":{"input":{"type":"structure","required":["domain","name","version"],"members":{"domain":{},"name":{},"version":{},"description":{},"defaultTaskStartToCloseTimeout":{},"defaultExecutionStartToCloseTimeout":{},"defaultTaskList":{"shape":"Sj"},"defaultTaskPriority":{},"defaultChildPolicy":{},"defaultLambdaRole":{}}}},"RequestCancelWorkflowExecution":{"input":{"type":"structure","required":["domain","workflowId"],"members":{"domain":{},"workflowId":{},"runId":{}}}},"RespondActivityTaskCanceled":{"input":{"type":"structure","required":["taskToken"],"members":{"taskToken":{},"details":{}}}},"RespondActivityTaskCompleted":{"input":{"type":"structure","required":["taskToken"],"members":{"taskToken":{},"result":{}}}},"RespondActivityTaskFailed":{"input":{"type":"structure","required":["taskToken"],"members":{"taskToken":{},"reason":{},"details":{}}}},"RespondDecisionTaskCompleted":{"input":{"type":"structure","required":["taskToken"],"members":{"taskToken":{},"decisions":{"type":"list","member":{"type":"structure","required":["decisionType"],"members":{"decisionType":{},"scheduleActivityTaskDecisionAttributes":{"type":"structure","required":["activityType","activityId"],"members":{"activityType":{"shape":"Sn"},"activityId":{},"control":{},"input":{},"scheduleToCloseTimeout":{},"taskList":{"shape":"Sj"},"taskPriority":{},"scheduleToStartTimeout":{},"startToCloseTimeout":{},"heartbeatTimeout":{}}},"requestCancelActivityTaskDecisionAttributes":{"type":"structure","required":["activityId"],"members":{"activityId":{}}},"completeWorkflowExecutionDecisionAttributes":{"type":"structure","members":{"result":{}}},"failWorkflowExecutionDecisionAttributes":{"type":"structure","members":{"reason":{},"details":{}}},"cancelWorkflowExecutionDecisionAttributes":{"type":"structure","members":{"details":{}}},"continueAsNewWorkflowExecutionDecisionAttributes":{"type":"structure","members":{"input":{},"executionStartToCloseTimeout":{},"taskList":{"shape":"Sj"},"taskPriority":{},"taskStartToCloseTimeout":{},"childPolicy":{},"tagList":{"shape":"S1c"},"workflowTypeVersion":{},"lambdaRole":{}}},"recordMarkerDecisionAttributes":{"type":"structure","required":["markerName"],"members":{"markerName":{},"details":{}}},"startTimerDecisionAttributes":{"type":"structure","required":["timerId","startToFireTimeout"],"members":{"timerId":{},"control":{},"startToFireTimeout":{}}},"cancelTimerDecisionAttributes":{"type":"structure","required":["timerId"],"members":{"timerId":{}}},"signalExternalWorkflowExecutionDecisionAttributes":{"type":"structure","required":["workflowId","signalName"],"members":{"workflowId":{},"runId":{},"signalName":{},"input":{},"control":{}}},"requestCancelExternalWorkflowExecutionDecisionAttributes":{"type":"structure","required":["workflowId"],"members":{"workflowId":{},"runId":{},"control":{}}},"startChildWorkflowExecutionDecisionAttributes":{"type":"structure","required":["workflowType","workflowId"],"members":{"workflowType":{"shape":"Sr"},"workflowId":{},"control":{},"input":{},"executionStartToCloseTimeout":{},"taskList":{"shape":"Sj"},"taskPriority":{},"taskStartToCloseTimeout":{},"childPolicy":{},"tagList":{"shape":"S1c"},"lambdaRole":{}}},"scheduleLambdaFunctionDecisionAttributes":{"type":"structure","required":["id","name"],"members":{"id":{},"name":{},"control":{},"input":{},"startToCloseTimeout":{}}}}}},"executionContext":{}}}},"SignalWorkflowExecution":{"input":{"type":"structure","required":["domain","workflowId","signalName"],"members":{"domain":{},"workflowId":{},"runId":{},"signalName":{},"input":{}}}},"StartWorkflowExecution":{"input":{"type":"structure","required":["domain","workflowId","workflowType"],"members":{"domain":{},"workflowId":{},"workflowType":{"shape":"Sr"},"taskList":{"shape":"Sj"},"taskPriority":{},"input":{},"executionStartToCloseTimeout":{},"tagList":{"shape":"S1c"},"taskStartToCloseTimeout":{},"childPolicy":{},"lambdaRole":{}}},"output":{"type":"structure","members":{"runId":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S4o"}}}},"TerminateWorkflowExecution":{"input":{"type":"structure","required":["domain","workflowId"],"members":{"domain":{},"workflowId":{},"runId":{},"reason":{},"details":{},"childPolicy":{}}}},"UndeprecateActivityType":{"input":{"type":"structure","required":["domain","activityType"],"members":{"domain":{},"activityType":{"shape":"Sn"}}}},"UndeprecateDomain":{"input":{"type":"structure","required":["name"],"members":{"name":{}}}},"UndeprecateWorkflowType":{"input":{"type":"structure","required":["domain","workflowType"],"members":{"domain":{},"workflowType":{"shape":"Sr"}}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}}}},"shapes":{"S3":{"type":"structure","required":["oldestDate"],"members":{"oldestDate":{"type":"timestamp"},"latestDate":{"type":"timestamp"}}},"S5":{"type":"structure","required":["workflowId"],"members":{"workflowId":{}}},"S7":{"type":"structure","required":["name"],"members":{"name":{},"version":{}}},"Sa":{"type":"structure","required":["tag"],"members":{"tag":{}}},"Sc":{"type":"structure","required":["status"],"members":{"status":{}}},"Se":{"type":"structure","required":["count"],"members":{"count":{"type":"integer"},"truncated":{"type":"boolean"}}},"Sj":{"type":"structure","required":["name"],"members":{"name":{}}},"Sk":{"type":"structure","required":["count"],"members":{"count":{"type":"integer"},"truncated":{"type":"boolean"}}},"Sn":{"type":"structure","required":["name","version"],"members":{"name":{},"version":{}}},"Sr":{"type":"structure","required":["name","version"],"members":{"name":{},"version":{}}},"Su":{"type":"structure","required":["activityType","status","creationDate"],"members":{"activityType":{"shape":"Sn"},"status":{},"description":{},"creationDate":{"type":"timestamp"},"deprecationDate":{"type":"timestamp"}}},"S12":{"type":"structure","required":["name","status"],"members":{"name":{},"status":{},"description":{},"arn":{}}},"S17":{"type":"structure","required":["workflowId","runId"],"members":{"workflowId":{},"runId":{}}},"S1a":{"type":"structure","required":["execution","workflowType","startTimestamp","executionStatus"],"members":{"execution":{"shape":"S17"},"workflowType":{"shape":"Sr"},"startTimestamp":{"type":"timestamp"},"closeTimestamp":{"type":"timestamp"},"executionStatus":{},"closeStatus":{},"parent":{"shape":"S17"},"tagList":{"shape":"S1c"},"cancelRequested":{"type":"boolean"}}},"S1c":{"type":"list","member":{}},"S1m":{"type":"structure","required":["workflowType","status","creationDate"],"members":{"workflowType":{"shape":"Sr"},"status":{},"description":{},"creationDate":{"type":"timestamp"},"deprecationDate":{"type":"timestamp"}}},"S1t":{"type":"list","member":{"type":"structure","required":["eventTimestamp","eventType","eventId"],"members":{"eventTimestamp":{"type":"timestamp"},"eventType":{},"eventId":{"type":"long"},"workflowExecutionStartedEventAttributes":{"type":"structure","required":["childPolicy","taskList","workflowType"],"members":{"input":{},"executionStartToCloseTimeout":{},"taskStartToCloseTimeout":{},"childPolicy":{},"taskList":{"shape":"Sj"},"taskPriority":{},"workflowType":{"shape":"Sr"},"tagList":{"shape":"S1c"},"continuedExecutionRunId":{},"parentWorkflowExecution":{"shape":"S17"},"parentInitiatedEventId":{"type":"long"},"lambdaRole":{}}},"workflowExecutionCompletedEventAttributes":{"type":"structure","required":["decisionTaskCompletedEventId"],"members":{"result":{},"decisionTaskCompletedEventId":{"type":"long"}}},"completeWorkflowExecutionFailedEventAttributes":{"type":"structure","required":["cause","decisionTaskCompletedEventId"],"members":{"cause":{},"decisionTaskCompletedEventId":{"type":"long"}}},"workflowExecutionFailedEventAttributes":{"type":"structure","required":["decisionTaskCompletedEventId"],"members":{"reason":{},"details":{},"decisionTaskCompletedEventId":{"type":"long"}}},"failWorkflowExecutionFailedEventAttributes":{"type":"structure","required":["cause","decisionTaskCompletedEventId"],"members":{"cause":{},"decisionTaskCompletedEventId":{"type":"long"}}},"workflowExecutionTimedOutEventAttributes":{"type":"structure","required":["timeoutType","childPolicy"],"members":{"timeoutType":{},"childPolicy":{}}},"workflowExecutionCanceledEventAttributes":{"type":"structure","required":["decisionTaskCompletedEventId"],"members":{"details":{},"decisionTaskCompletedEventId":{"type":"long"}}},"cancelWorkflowExecutionFailedEventAttributes":{"type":"structure","required":["cause","decisionTaskCompletedEventId"],"members":{"cause":{},"decisionTaskCompletedEventId":{"type":"long"}}},"workflowExecutionContinuedAsNewEventAttributes":{"type":"structure","required":["decisionTaskCompletedEventId","newExecutionRunId","taskList","childPolicy","workflowType"],"members":{"input":{},"decisionTaskCompletedEventId":{"type":"long"},"newExecutionRunId":{},"executionStartToCloseTimeout":{},"taskList":{"shape":"Sj"},"taskPriority":{},"taskStartToCloseTimeout":{},"childPolicy":{},"tagList":{"shape":"S1c"},"workflowType":{"shape":"Sr"},"lambdaRole":{}}},"continueAsNewWorkflowExecutionFailedEventAttributes":{"type":"structure","required":["cause","decisionTaskCompletedEventId"],"members":{"cause":{},"decisionTaskCompletedEventId":{"type":"long"}}},"workflowExecutionTerminatedEventAttributes":{"type":"structure","required":["childPolicy"],"members":{"reason":{},"details":{},"childPolicy":{},"cause":{}}},"workflowExecutionCancelRequestedEventAttributes":{"type":"structure","members":{"externalWorkflowExecution":{"shape":"S17"},"externalInitiatedEventId":{"type":"long"},"cause":{}}},"decisionTaskScheduledEventAttributes":{"type":"structure","required":["taskList"],"members":{"taskList":{"shape":"Sj"},"taskPriority":{},"startToCloseTimeout":{}}},"decisionTaskStartedEventAttributes":{"type":"structure","required":["scheduledEventId"],"members":{"identity":{},"scheduledEventId":{"type":"long"}}},"decisionTaskCompletedEventAttributes":{"type":"structure","required":["scheduledEventId","startedEventId"],"members":{"executionContext":{},"scheduledEventId":{"type":"long"},"startedEventId":{"type":"long"}}},"decisionTaskTimedOutEventAttributes":{"type":"structure","required":["timeoutType","scheduledEventId","startedEventId"],"members":{"timeoutType":{},"scheduledEventId":{"type":"long"},"startedEventId":{"type":"long"}}},"activityTaskScheduledEventAttributes":{"type":"structure","required":["activityType","activityId","taskList","decisionTaskCompletedEventId"],"members":{"activityType":{"shape":"Sn"},"activityId":{},"input":{},"control":{},"scheduleToStartTimeout":{},"scheduleToCloseTimeout":{},"startToCloseTimeout":{},"taskList":{"shape":"Sj"},"taskPriority":{},"decisionTaskCompletedEventId":{"type":"long"},"heartbeatTimeout":{}}},"activityTaskStartedEventAttributes":{"type":"structure","required":["scheduledEventId"],"members":{"identity":{},"scheduledEventId":{"type":"long"}}},"activityTaskCompletedEventAttributes":{"type":"structure","required":["scheduledEventId","startedEventId"],"members":{"result":{},"scheduledEventId":{"type":"long"},"startedEventId":{"type":"long"}}},"activityTaskFailedEventAttributes":{"type":"structure","required":["scheduledEventId","startedEventId"],"members":{"reason":{},"details":{},"scheduledEventId":{"type":"long"},"startedEventId":{"type":"long"}}},"activityTaskTimedOutEventAttributes":{"type":"structure","required":["timeoutType","scheduledEventId","startedEventId"],"members":{"timeoutType":{},"scheduledEventId":{"type":"long"},"startedEventId":{"type":"long"},"details":{}}},"activityTaskCanceledEventAttributes":{"type":"structure","required":["scheduledEventId","startedEventId"],"members":{"details":{},"scheduledEventId":{"type":"long"},"startedEventId":{"type":"long"},"latestCancelRequestedEventId":{"type":"long"}}},"activityTaskCancelRequestedEventAttributes":{"type":"structure","required":["decisionTaskCompletedEventId","activityId"],"members":{"decisionTaskCompletedEventId":{"type":"long"},"activityId":{}}},"workflowExecutionSignaledEventAttributes":{"type":"structure","required":["signalName"],"members":{"signalName":{},"input":{},"externalWorkflowExecution":{"shape":"S17"},"externalInitiatedEventId":{"type":"long"}}},"markerRecordedEventAttributes":{"type":"structure","required":["markerName","decisionTaskCompletedEventId"],"members":{"markerName":{},"details":{},"decisionTaskCompletedEventId":{"type":"long"}}},"recordMarkerFailedEventAttributes":{"type":"structure","required":["markerName","cause","decisionTaskCompletedEventId"],"members":{"markerName":{},"cause":{},"decisionTaskCompletedEventId":{"type":"long"}}},"timerStartedEventAttributes":{"type":"structure","required":["timerId","startToFireTimeout","decisionTaskCompletedEventId"],"members":{"timerId":{},"control":{},"startToFireTimeout":{},"decisionTaskCompletedEventId":{"type":"long"}}},"timerFiredEventAttributes":{"type":"structure","required":["timerId","startedEventId"],"members":{"timerId":{},"startedEventId":{"type":"long"}}},"timerCanceledEventAttributes":{"type":"structure","required":["timerId","startedEventId","decisionTaskCompletedEventId"],"members":{"timerId":{},"startedEventId":{"type":"long"},"decisionTaskCompletedEventId":{"type":"long"}}},"startChildWorkflowExecutionInitiatedEventAttributes":{"type":"structure","required":["workflowId","workflowType","taskList","decisionTaskCompletedEventId","childPolicy"],"members":{"workflowId":{},"workflowType":{"shape":"Sr"},"control":{},"input":{},"executionStartToCloseTimeout":{},"taskList":{"shape":"Sj"},"taskPriority":{},"decisionTaskCompletedEventId":{"type":"long"},"childPolicy":{},"taskStartToCloseTimeout":{},"tagList":{"shape":"S1c"},"lambdaRole":{}}},"childWorkflowExecutionStartedEventAttributes":{"type":"structure","required":["workflowExecution","workflowType","initiatedEventId"],"members":{"workflowExecution":{"shape":"S17"},"workflowType":{"shape":"Sr"},"initiatedEventId":{"type":"long"}}},"childWorkflowExecutionCompletedEventAttributes":{"type":"structure","required":["workflowExecution","workflowType","initiatedEventId","startedEventId"],"members":{"workflowExecution":{"shape":"S17"},"workflowType":{"shape":"Sr"},"result":{},"initiatedEventId":{"type":"long"},"startedEventId":{"type":"long"}}},"childWorkflowExecutionFailedEventAttributes":{"type":"structure","required":["workflowExecution","workflowType","initiatedEventId","startedEventId"],"members":{"workflowExecution":{"shape":"S17"},"workflowType":{"shape":"Sr"},"reason":{},"details":{},"initiatedEventId":{"type":"long"},"startedEventId":{"type":"long"}}},"childWorkflowExecutionTimedOutEventAttributes":{"type":"structure","required":["workflowExecution","workflowType","timeoutType","initiatedEventId","startedEventId"],"members":{"workflowExecution":{"shape":"S17"},"workflowType":{"shape":"Sr"},"timeoutType":{},"initiatedEventId":{"type":"long"},"startedEventId":{"type":"long"}}},"childWorkflowExecutionCanceledEventAttributes":{"type":"structure","required":["workflowExecution","workflowType","initiatedEventId","startedEventId"],"members":{"workflowExecution":{"shape":"S17"},"workflowType":{"shape":"Sr"},"details":{},"initiatedEventId":{"type":"long"},"startedEventId":{"type":"long"}}},"childWorkflowExecutionTerminatedEventAttributes":{"type":"structure","required":["workflowExecution","workflowType","initiatedEventId","startedEventId"],"members":{"workflowExecution":{"shape":"S17"},"workflowType":{"shape":"Sr"},"initiatedEventId":{"type":"long"},"startedEventId":{"type":"long"}}},"signalExternalWorkflowExecutionInitiatedEventAttributes":{"type":"structure","required":["workflowId","signalName","decisionTaskCompletedEventId"],"members":{"workflowId":{},"runId":{},"signalName":{},"input":{},"decisionTaskCompletedEventId":{"type":"long"},"control":{}}},"externalWorkflowExecutionSignaledEventAttributes":{"type":"structure","required":["workflowExecution","initiatedEventId"],"members":{"workflowExecution":{"shape":"S17"},"initiatedEventId":{"type":"long"}}},"signalExternalWorkflowExecutionFailedEventAttributes":{"type":"structure","required":["workflowId","cause","initiatedEventId","decisionTaskCompletedEventId"],"members":{"workflowId":{},"runId":{},"cause":{},"initiatedEventId":{"type":"long"},"decisionTaskCompletedEventId":{"type":"long"},"control":{}}},"externalWorkflowExecutionCancelRequestedEventAttributes":{"type":"structure","required":["workflowExecution","initiatedEventId"],"members":{"workflowExecution":{"shape":"S17"},"initiatedEventId":{"type":"long"}}},"requestCancelExternalWorkflowExecutionInitiatedEventAttributes":{"type":"structure","required":["workflowId","decisionTaskCompletedEventId"],"members":{"workflowId":{},"runId":{},"decisionTaskCompletedEventId":{"type":"long"},"control":{}}},"requestCancelExternalWorkflowExecutionFailedEventAttributes":{"type":"structure","required":["workflowId","cause","initiatedEventId","decisionTaskCompletedEventId"],"members":{"workflowId":{},"runId":{},"cause":{},"initiatedEventId":{"type":"long"},"decisionTaskCompletedEventId":{"type":"long"},"control":{}}},"scheduleActivityTaskFailedEventAttributes":{"type":"structure","required":["activityType","activityId","cause","decisionTaskCompletedEventId"],"members":{"activityType":{"shape":"Sn"},"activityId":{},"cause":{},"decisionTaskCompletedEventId":{"type":"long"}}},"requestCancelActivityTaskFailedEventAttributes":{"type":"structure","required":["activityId","cause","decisionTaskCompletedEventId"],"members":{"activityId":{},"cause":{},"decisionTaskCompletedEventId":{"type":"long"}}},"startTimerFailedEventAttributes":{"type":"structure","required":["timerId","cause","decisionTaskCompletedEventId"],"members":{"timerId":{},"cause":{},"decisionTaskCompletedEventId":{"type":"long"}}},"cancelTimerFailedEventAttributes":{"type":"structure","required":["timerId","cause","decisionTaskCompletedEventId"],"members":{"timerId":{},"cause":{},"decisionTaskCompletedEventId":{"type":"long"}}},"startChildWorkflowExecutionFailedEventAttributes":{"type":"structure","required":["workflowType","cause","workflowId","initiatedEventId","decisionTaskCompletedEventId"],"members":{"workflowType":{"shape":"Sr"},"cause":{},"workflowId":{},"initiatedEventId":{"type":"long"},"decisionTaskCompletedEventId":{"type":"long"},"control":{}}},"lambdaFunctionScheduledEventAttributes":{"type":"structure","required":["id","name","decisionTaskCompletedEventId"],"members":{"id":{},"name":{},"control":{},"input":{},"startToCloseTimeout":{},"decisionTaskCompletedEventId":{"type":"long"}}},"lambdaFunctionStartedEventAttributes":{"type":"structure","required":["scheduledEventId"],"members":{"scheduledEventId":{"type":"long"}}},"lambdaFunctionCompletedEventAttributes":{"type":"structure","required":["scheduledEventId","startedEventId"],"members":{"scheduledEventId":{"type":"long"},"startedEventId":{"type":"long"},"result":{}}},"lambdaFunctionFailedEventAttributes":{"type":"structure","required":["scheduledEventId","startedEventId"],"members":{"scheduledEventId":{"type":"long"},"startedEventId":{"type":"long"},"reason":{},"details":{}}},"lambdaFunctionTimedOutEventAttributes":{"type":"structure","required":["scheduledEventId","startedEventId"],"members":{"scheduledEventId":{"type":"long"},"startedEventId":{"type":"long"},"timeoutType":{}}},"scheduleLambdaFunctionFailedEventAttributes":{"type":"structure","required":["id","name","cause","decisionTaskCompletedEventId"],"members":{"id":{},"name":{},"cause":{},"decisionTaskCompletedEventId":{"type":"long"}}},"startLambdaFunctionFailedEventAttributes":{"type":"structure","members":{"scheduledEventId":{"type":"long"},"cause":{},"message":{}}}}}},"S4g":{"type":"structure","required":["executionInfos"],"members":{"executionInfos":{"type":"list","member":{"shape":"S1a"}},"nextPageToken":{}}},"S4o":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}}}}}');

});

parcelRequire.register("hY9tU", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"GetWorkflowExecutionHistory":{"input_token":"nextPageToken","limit_key":"maximumPageSize","output_token":"nextPageToken","result_key":"events"},"ListActivityTypes":{"input_token":"nextPageToken","limit_key":"maximumPageSize","output_token":"nextPageToken","result_key":"typeInfos"},"ListClosedWorkflowExecutions":{"input_token":"nextPageToken","limit_key":"maximumPageSize","output_token":"nextPageToken","result_key":"executionInfos"},"ListDomains":{"input_token":"nextPageToken","limit_key":"maximumPageSize","output_token":"nextPageToken","result_key":"domainInfos"},"ListOpenWorkflowExecutions":{"input_token":"nextPageToken","limit_key":"maximumPageSize","output_token":"nextPageToken","result_key":"executionInfos"},"ListWorkflowTypes":{"input_token":"nextPageToken","limit_key":"maximumPageSize","output_token":"nextPageToken","result_key":"typeInfos"},"PollForDecisionTask":{"input_token":"nextPageToken","limit_key":"maximumPageSize","output_token":"nextPageToken","result_key":"events"}}}');

});


parcelRequire.register("zowlZ", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $06a64a534f608bc2$var$Service = $dbC7k.Service;
var $06a64a534f608bc2$var$apiLoader = $dbC7k.apiLoader;
$06a64a534f608bc2$var$apiLoader.services["xray"] = {};
$dbC7k.XRay = $06a64a534f608bc2$var$Service.defineService("xray", [
    "2016-04-12"
]);


Object.defineProperty($06a64a534f608bc2$var$apiLoader.services["xray"], "2016-04-12", {
    get: function get() {
        var model = (parcelRequire("1pKcs"));
        model.paginators = (parcelRequire("1eakh")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.XRay;

});
parcelRequire.register("1pKcs", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-04-12","endpointPrefix":"xray","protocol":"rest-json","serviceFullName":"AWS X-Ray","serviceId":"XRay","signatureVersion":"v4","uid":"xray-2016-04-12"},"operations":{"BatchGetTraces":{"http":{"requestUri":"/Traces"},"input":{"type":"structure","required":["TraceIds"],"members":{"TraceIds":{"shape":"S2"},"NextToken":{}}},"output":{"type":"structure","members":{"Traces":{"type":"list","member":{"type":"structure","members":{"Id":{},"Duration":{"type":"double"},"Segments":{"type":"list","member":{"type":"structure","members":{"Id":{},"Document":{}}}}}}},"UnprocessedTraceIds":{"type":"list","member":{}},"NextToken":{}}}},"CreateGroup":{"http":{"requestUri":"/CreateGroup"},"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"FilterExpression":{}}},"output":{"type":"structure","members":{"Group":{"shape":"Si"}}}},"CreateSamplingRule":{"http":{"requestUri":"/CreateSamplingRule"},"input":{"type":"structure","required":["SamplingRule"],"members":{"SamplingRule":{"shape":"Sk"}}},"output":{"type":"structure","members":{"SamplingRuleRecord":{"shape":"S10"}}}},"DeleteGroup":{"http":{"requestUri":"/DeleteGroup"},"input":{"type":"structure","members":{"GroupName":{},"GroupARN":{}}},"output":{"type":"structure","members":{}}},"DeleteSamplingRule":{"http":{"requestUri":"/DeleteSamplingRule"},"input":{"type":"structure","members":{"RuleName":{},"RuleARN":{}}},"output":{"type":"structure","members":{"SamplingRuleRecord":{"shape":"S10"}}}},"GetEncryptionConfig":{"http":{"requestUri":"/EncryptionConfig"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"EncryptionConfig":{"shape":"S19"}}}},"GetGroup":{"http":{"requestUri":"/GetGroup"},"input":{"type":"structure","members":{"GroupName":{},"GroupARN":{}}},"output":{"type":"structure","members":{"Group":{"shape":"Si"}}}},"GetGroups":{"http":{"requestUri":"/Groups"},"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"type":"list","member":{"type":"structure","members":{"GroupName":{},"GroupARN":{},"FilterExpression":{}}}},"NextToken":{}}}},"GetSamplingRules":{"http":{"requestUri":"/GetSamplingRules"},"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"SamplingRuleRecords":{"type":"list","member":{"shape":"S10"}},"NextToken":{}}}},"GetSamplingStatisticSummaries":{"http":{"requestUri":"/SamplingStatisticSummaries"},"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"SamplingStatisticSummaries":{"type":"list","member":{"type":"structure","members":{"RuleName":{},"Timestamp":{"type":"timestamp"},"RequestCount":{"type":"integer"},"BorrowCount":{"type":"integer"},"SampledCount":{"type":"integer"}}}},"NextToken":{}}}},"GetSamplingTargets":{"http":{"requestUri":"/SamplingTargets"},"input":{"type":"structure","required":["SamplingStatisticsDocuments"],"members":{"SamplingStatisticsDocuments":{"type":"list","member":{"type":"structure","required":["RuleName","ClientID","Timestamp","RequestCount","SampledCount"],"members":{"RuleName":{},"ClientID":{},"Timestamp":{"type":"timestamp"},"RequestCount":{"type":"integer"},"SampledCount":{"type":"integer"},"BorrowCount":{"type":"integer"}}}}}},"output":{"type":"structure","members":{"SamplingTargetDocuments":{"type":"list","member":{"type":"structure","members":{"RuleName":{},"FixedRate":{"type":"double"},"ReservoirQuota":{"type":"integer"},"ReservoirQuotaTTL":{"type":"timestamp"},"Interval":{"type":"integer"}}}},"LastRuleModification":{"type":"timestamp"},"UnprocessedStatistics":{"type":"list","member":{"type":"structure","members":{"RuleName":{},"ErrorCode":{},"Message":{}}}}}}},"GetServiceGraph":{"http":{"requestUri":"/ServiceGraph"},"input":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"GroupName":{},"GroupARN":{},"NextToken":{}}},"output":{"type":"structure","members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Services":{"shape":"S27"},"ContainsOldGroupVersions":{"type":"boolean"},"NextToken":{}}}},"GetTimeSeriesServiceStatistics":{"http":{"requestUri":"/TimeSeriesServiceStatistics"},"input":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"GroupName":{},"GroupARN":{},"EntitySelectorExpression":{},"Period":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"TimeSeriesServiceStatistics":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"timestamp"},"EdgeSummaryStatistics":{"shape":"S2d"},"ServiceSummaryStatistics":{"shape":"S2m"},"ResponseTimeHistogram":{"shape":"S2h"}}}},"ContainsOldGroupVersions":{"type":"boolean"},"NextToken":{}}}},"GetTraceGraph":{"http":{"requestUri":"/TraceGraph"},"input":{"type":"structure","required":["TraceIds"],"members":{"TraceIds":{"shape":"S2"},"NextToken":{}}},"output":{"type":"structure","members":{"Services":{"shape":"S27"},"NextToken":{}}}},"GetTraceSummaries":{"http":{"requestUri":"/TraceSummaries"},"input":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"TimeRangeType":{},"Sampling":{"type":"boolean"},"SamplingStrategy":{"type":"structure","members":{"Name":{},"Value":{"type":"double"}}},"FilterExpression":{},"NextToken":{}}},"output":{"type":"structure","members":{"TraceSummaries":{"type":"list","member":{"type":"structure","members":{"Id":{},"Duration":{"type":"double"},"ResponseTime":{"type":"double"},"HasFault":{"type":"boolean"},"HasError":{"type":"boolean"},"HasThrottle":{"type":"boolean"},"IsPartial":{"type":"boolean"},"Http":{"type":"structure","members":{"HttpURL":{},"HttpStatus":{"type":"integer"},"HttpMethod":{},"UserAgent":{},"ClientIp":{}}},"Annotations":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"AnnotationValue":{"type":"structure","members":{"NumberValue":{"type":"double"},"BooleanValue":{"type":"boolean"},"StringValue":{}}},"ServiceIds":{"shape":"S38"}}}}},"Users":{"type":"list","member":{"type":"structure","members":{"UserName":{},"ServiceIds":{"shape":"S38"}}}},"ServiceIds":{"shape":"S38"},"ResourceARNs":{"type":"list","member":{"type":"structure","members":{"ARN":{}}}},"InstanceIds":{"type":"list","member":{"type":"structure","members":{"Id":{}}}},"AvailabilityZones":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"EntryPoint":{"shape":"S39"},"FaultRootCauses":{"type":"list","member":{"type":"structure","members":{"Services":{"type":"list","member":{"type":"structure","members":{"Name":{},"Names":{"shape":"S29"},"Type":{},"AccountId":{},"EntityPath":{"type":"list","member":{"type":"structure","members":{"Name":{},"Exceptions":{"shape":"S3o"},"Remote":{"type":"boolean"}}}},"Inferred":{"type":"boolean"}}}}}}},"ErrorRootCauses":{"type":"list","member":{"type":"structure","members":{"Services":{"type":"list","member":{"type":"structure","members":{"Name":{},"Names":{"shape":"S29"},"Type":{},"AccountId":{},"EntityPath":{"type":"list","member":{"type":"structure","members":{"Name":{},"Exceptions":{"shape":"S3o"},"Remote":{"type":"boolean"}}}},"Inferred":{"type":"boolean"}}}}}}},"ResponseTimeRootCauses":{"type":"list","member":{"type":"structure","members":{"Services":{"type":"list","member":{"type":"structure","members":{"Name":{},"Names":{"shape":"S29"},"Type":{},"AccountId":{},"EntityPath":{"type":"list","member":{"type":"structure","members":{"Name":{},"Coverage":{"type":"double"},"Remote":{"type":"boolean"}}}},"Inferred":{"type":"boolean"}}}}}}},"Revision":{"type":"integer"},"MatchedEventTime":{"type":"timestamp"}}}},"ApproximateTime":{"type":"timestamp"},"TracesProcessedCount":{"type":"long"},"NextToken":{}}}},"PutEncryptionConfig":{"http":{"requestUri":"/PutEncryptionConfig"},"input":{"type":"structure","required":["Type"],"members":{"KeyId":{},"Type":{}}},"output":{"type":"structure","members":{"EncryptionConfig":{"shape":"S19"}}}},"PutTelemetryRecords":{"http":{"requestUri":"/TelemetryRecords"},"input":{"type":"structure","required":["TelemetryRecords"],"members":{"TelemetryRecords":{"type":"list","member":{"type":"structure","required":["Timestamp"],"members":{"Timestamp":{"type":"timestamp"},"SegmentsReceivedCount":{"type":"integer"},"SegmentsSentCount":{"type":"integer"},"SegmentsSpilloverCount":{"type":"integer"},"SegmentsRejectedCount":{"type":"integer"},"BackendConnectionErrors":{"type":"structure","members":{"TimeoutCount":{"type":"integer"},"ConnectionRefusedCount":{"type":"integer"},"HTTPCode4XXCount":{"type":"integer"},"HTTPCode5XXCount":{"type":"integer"},"UnknownHostCount":{"type":"integer"},"OtherCount":{"type":"integer"}}}}}},"EC2InstanceId":{},"Hostname":{},"ResourceARN":{}}},"output":{"type":"structure","members":{}}},"PutTraceSegments":{"http":{"requestUri":"/TraceSegments"},"input":{"type":"structure","required":["TraceSegmentDocuments"],"members":{"TraceSegmentDocuments":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"UnprocessedTraceSegments":{"type":"list","member":{"type":"structure","members":{"Id":{},"ErrorCode":{},"Message":{}}}}}}},"UpdateGroup":{"http":{"requestUri":"/UpdateGroup"},"input":{"type":"structure","members":{"GroupName":{},"GroupARN":{},"FilterExpression":{}}},"output":{"type":"structure","members":{"Group":{"shape":"Si"}}}},"UpdateSamplingRule":{"http":{"requestUri":"/UpdateSamplingRule"},"input":{"type":"structure","required":["SamplingRuleUpdate"],"members":{"SamplingRuleUpdate":{"type":"structure","members":{"RuleName":{},"RuleARN":{},"ResourceARN":{},"Priority":{"type":"integer"},"FixedRate":{"type":"double"},"ReservoirSize":{"type":"integer"},"Host":{},"ServiceName":{},"ServiceType":{},"HTTPMethod":{},"URLPath":{},"Attributes":{"shape":"Sw"}}}}},"output":{"type":"structure","members":{"SamplingRuleRecord":{"shape":"S10"}}}}},"shapes":{"S2":{"type":"list","member":{}},"Si":{"type":"structure","members":{"GroupName":{},"GroupARN":{},"FilterExpression":{}}},"Sk":{"type":"structure","required":["ResourceARN","Priority","FixedRate","ReservoirSize","ServiceName","ServiceType","Host","HTTPMethod","URLPath","Version"],"members":{"RuleName":{},"RuleARN":{},"ResourceARN":{},"Priority":{"type":"integer"},"FixedRate":{"type":"double"},"ReservoirSize":{"type":"integer"},"ServiceName":{},"ServiceType":{},"Host":{},"HTTPMethod":{},"URLPath":{},"Version":{"type":"integer"},"Attributes":{"shape":"Sw"}}},"Sw":{"type":"map","key":{},"value":{}},"S10":{"type":"structure","members":{"SamplingRule":{"shape":"Sk"},"CreatedAt":{"type":"timestamp"},"ModifiedAt":{"type":"timestamp"}}},"S19":{"type":"structure","members":{"KeyId":{},"Status":{},"Type":{}}},"S27":{"type":"list","member":{"type":"structure","members":{"ReferenceId":{"type":"integer"},"Name":{},"Names":{"shape":"S29"},"Root":{"type":"boolean"},"AccountId":{},"Type":{},"State":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Edges":{"type":"list","member":{"type":"structure","members":{"ReferenceId":{"type":"integer"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"SummaryStatistics":{"shape":"S2d"},"ResponseTimeHistogram":{"shape":"S2h"},"Aliases":{"type":"list","member":{"type":"structure","members":{"Name":{},"Names":{"type":"list","member":{}},"Type":{}}}}}}},"SummaryStatistics":{"shape":"S2m"},"DurationHistogram":{"shape":"S2h"},"ResponseTimeHistogram":{"shape":"S2h"}}}},"S29":{"type":"list","member":{}},"S2d":{"type":"structure","members":{"OkCount":{"type":"long"},"ErrorStatistics":{"shape":"S2f"},"FaultStatistics":{"shape":"S2g"},"TotalCount":{"type":"long"},"TotalResponseTime":{"type":"double"}}},"S2f":{"type":"structure","members":{"ThrottleCount":{"type":"long"},"OtherCount":{"type":"long"},"TotalCount":{"type":"long"}}},"S2g":{"type":"structure","members":{"OtherCount":{"type":"long"},"TotalCount":{"type":"long"}}},"S2h":{"type":"list","member":{"type":"structure","members":{"Value":{"type":"double"},"Count":{"type":"integer"}}}},"S2m":{"type":"structure","members":{"OkCount":{"type":"long"},"ErrorStatistics":{"shape":"S2f"},"FaultStatistics":{"shape":"S2g"},"TotalCount":{"type":"long"},"TotalResponseTime":{"type":"double"}}},"S38":{"type":"list","member":{"shape":"S39"}},"S39":{"type":"structure","members":{"Name":{},"Names":{"shape":"S29"},"AccountId":{},"Type":{}}},"S3o":{"type":"list","member":{"type":"structure","members":{"Name":{},"Message":{}}}}}}');

});

parcelRequire.register("1eakh", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"BatchGetTraces":{"input_token":"NextToken","non_aggregate_keys":["UnprocessedTraceIds"],"output_token":"NextToken","result_key":"Traces"},"GetGroups":{"input_token":"NextToken","output_token":"NextToken","result_key":"Groups"},"GetSamplingRules":{"input_token":"NextToken","output_token":"NextToken","result_key":"SamplingRuleRecords"},"GetSamplingStatisticSummaries":{"input_token":"NextToken","output_token":"NextToken","result_key":"SamplingStatisticSummaries"},"GetServiceGraph":{"input_token":"NextToken","non_aggregate_keys":["StartTime","EndTime","ContainsOldGroupVersions"],"output_token":"NextToken","result_key":"Services"},"GetTimeSeriesServiceStatistics":{"input_token":"NextToken","non_aggregate_keys":["ContainsOldGroupVersions"],"output_token":"NextToken","result_key":"TimeSeriesServiceStatistics"},"GetTraceGraph":{"input_token":"NextToken","output_token":"NextToken","result_key":"Services"},"GetTraceSummaries":{"input_token":"NextToken","non_aggregate_keys":["TracesProcessedCount","ApproximateTime"],"output_token":"NextToken","result_key":"TraceSummaries"}}}');

});


parcelRequire.register("atSlF", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $7a16c547aba4bc26$var$Service = $dbC7k.Service;
var $7a16c547aba4bc26$var$apiLoader = $dbC7k.apiLoader;
$7a16c547aba4bc26$var$apiLoader.services["waf"] = {};
$dbC7k.WAF = $7a16c547aba4bc26$var$Service.defineService("waf", [
    "2015-08-24"
]);


Object.defineProperty($7a16c547aba4bc26$var$apiLoader.services["waf"], "2015-08-24", {
    get: function get() {
        var model = (parcelRequire("gLxWp"));
        model.paginators = (parcelRequire("8uuFa")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.WAF;

});
parcelRequire.register("gLxWp", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-08-24","endpointPrefix":"waf","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"WAF","serviceFullName":"AWS WAF","serviceId":"WAF","signatureVersion":"v4","targetPrefix":"AWSWAF_20150824","uid":"waf-2015-08-24"},"operations":{"CreateByteMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ByteMatchSet":{"shape":"S5"},"ChangeToken":{}}}},"CreateGeoMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"GeoMatchSet":{"shape":"Sh"},"ChangeToken":{}}}},"CreateIPSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"IPSet":{"shape":"So"},"ChangeToken":{}}}},"CreateRateBasedRule":{"input":{"type":"structure","required":["Name","MetricName","RateKey","RateLimit","ChangeToken"],"members":{"Name":{},"MetricName":{},"RateKey":{},"RateLimit":{"type":"long"},"ChangeToken":{},"Tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{"Rule":{"shape":"S12"},"ChangeToken":{}}}},"CreateRegexMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"RegexMatchSet":{"shape":"S19"},"ChangeToken":{}}}},"CreateRegexPatternSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"RegexPatternSet":{"shape":"S1e"},"ChangeToken":{}}}},"CreateRule":{"input":{"type":"structure","required":["Name","MetricName","ChangeToken"],"members":{"Name":{},"MetricName":{},"ChangeToken":{},"Tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{"Rule":{"shape":"S1j"},"ChangeToken":{}}}},"CreateRuleGroup":{"input":{"type":"structure","required":["Name","MetricName","ChangeToken"],"members":{"Name":{},"MetricName":{},"ChangeToken":{},"Tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{"RuleGroup":{"shape":"S1m"},"ChangeToken":{}}}},"CreateSizeConstraintSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"SizeConstraintSet":{"shape":"S1p"},"ChangeToken":{}}}},"CreateSqlInjectionMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"SqlInjectionMatchSet":{"shape":"S1w"},"ChangeToken":{}}}},"CreateWebACL":{"input":{"type":"structure","required":["Name","MetricName","DefaultAction","ChangeToken"],"members":{"Name":{},"MetricName":{},"DefaultAction":{"shape":"S20"},"ChangeToken":{},"Tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{"WebACL":{"shape":"S23"},"ChangeToken":{}}}},"CreateXssMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"XssMatchSet":{"shape":"S2f"},"ChangeToken":{}}}},"DeleteByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId","ChangeToken"],"members":{"ByteMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId","ChangeToken"],"members":{"GeoMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteIPSet":{"input":{"type":"structure","required":["IPSetId","ChangeToken"],"members":{"IPSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteLoggingConfiguration":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"DeletePermissionPolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"DeleteRateBasedRule":{"input":{"type":"structure","required":["RuleId","ChangeToken"],"members":{"RuleId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId","ChangeToken"],"members":{"RegexMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId","ChangeToken"],"members":{"RegexPatternSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRule":{"input":{"type":"structure","required":["RuleId","ChangeToken"],"members":{"RuleId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRuleGroup":{"input":{"type":"structure","required":["RuleGroupId","ChangeToken"],"members":{"RuleGroupId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId","ChangeToken"],"members":{"SizeConstraintSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId","ChangeToken"],"members":{"SqlInjectionMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteWebACL":{"input":{"type":"structure","required":["WebACLId","ChangeToken"],"members":{"WebACLId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId","ChangeToken"],"members":{"XssMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"GetByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId"],"members":{"ByteMatchSetId":{}}},"output":{"type":"structure","members":{"ByteMatchSet":{"shape":"S5"}}}},"GetChangeToken":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"GetChangeTokenStatus":{"input":{"type":"structure","required":["ChangeToken"],"members":{"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeTokenStatus":{}}}},"GetGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId"],"members":{"GeoMatchSetId":{}}},"output":{"type":"structure","members":{"GeoMatchSet":{"shape":"Sh"}}}},"GetIPSet":{"input":{"type":"structure","required":["IPSetId"],"members":{"IPSetId":{}}},"output":{"type":"structure","members":{"IPSet":{"shape":"So"}}}},"GetLoggingConfiguration":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"LoggingConfiguration":{"shape":"S3n"}}}},"GetPermissionPolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Policy":{}}}},"GetRateBasedRule":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}},"output":{"type":"structure","members":{"Rule":{"shape":"S12"}}}},"GetRateBasedRuleManagedKeys":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{},"NextMarker":{}}},"output":{"type":"structure","members":{"ManagedKeys":{"type":"list","member":{}},"NextMarker":{}}}},"GetRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId"],"members":{"RegexMatchSetId":{}}},"output":{"type":"structure","members":{"RegexMatchSet":{"shape":"S19"}}}},"GetRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId"],"members":{"RegexPatternSetId":{}}},"output":{"type":"structure","members":{"RegexPatternSet":{"shape":"S1e"}}}},"GetRule":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}},"output":{"type":"structure","members":{"Rule":{"shape":"S1j"}}}},"GetRuleGroup":{"input":{"type":"structure","required":["RuleGroupId"],"members":{"RuleGroupId":{}}},"output":{"type":"structure","members":{"RuleGroup":{"shape":"S1m"}}}},"GetSampledRequests":{"input":{"type":"structure","required":["WebAclId","RuleId","TimeWindow","MaxItems"],"members":{"WebAclId":{},"RuleId":{},"TimeWindow":{"shape":"S49"},"MaxItems":{"type":"long"}}},"output":{"type":"structure","members":{"SampledRequests":{"type":"list","member":{"type":"structure","required":["Request","Weight"],"members":{"Request":{"type":"structure","members":{"ClientIP":{},"Country":{},"URI":{},"Method":{},"HTTPVersion":{},"Headers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}}}}},"Weight":{"type":"long"},"Timestamp":{"type":"timestamp"},"Action":{},"RuleWithinRuleGroup":{}}}},"PopulationSize":{"type":"long"},"TimeWindow":{"shape":"S49"}}}},"GetSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId"],"members":{"SizeConstraintSetId":{}}},"output":{"type":"structure","members":{"SizeConstraintSet":{"shape":"S1p"}}}},"GetSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId"],"members":{"SqlInjectionMatchSetId":{}}},"output":{"type":"structure","members":{"SqlInjectionMatchSet":{"shape":"S1w"}}}},"GetWebACL":{"input":{"type":"structure","required":["WebACLId"],"members":{"WebACLId":{}}},"output":{"type":"structure","members":{"WebACL":{"shape":"S23"}}}},"GetXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId"],"members":{"XssMatchSetId":{}}},"output":{"type":"structure","members":{"XssMatchSet":{"shape":"S2f"}}}},"ListActivatedRulesInRuleGroup":{"input":{"type":"structure","members":{"RuleGroupId":{},"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"ActivatedRules":{"shape":"S24"}}}},"ListByteMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"ByteMatchSets":{"type":"list","member":{"type":"structure","required":["ByteMatchSetId","Name"],"members":{"ByteMatchSetId":{},"Name":{}}}}}}},"ListGeoMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"GeoMatchSets":{"type":"list","member":{"type":"structure","required":["GeoMatchSetId","Name"],"members":{"GeoMatchSetId":{},"Name":{}}}}}}},"ListIPSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"IPSets":{"type":"list","member":{"type":"structure","required":["IPSetId","Name"],"members":{"IPSetId":{},"Name":{}}}}}}},"ListLoggingConfigurations":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"LoggingConfigurations":{"type":"list","member":{"shape":"S3n"}},"NextMarker":{}}}},"ListRateBasedRules":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Rules":{"shape":"S5k"}}}},"ListRegexMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RegexMatchSets":{"type":"list","member":{"type":"structure","required":["RegexMatchSetId","Name"],"members":{"RegexMatchSetId":{},"Name":{}}}}}}},"ListRegexPatternSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RegexPatternSets":{"type":"list","member":{"type":"structure","required":["RegexPatternSetId","Name"],"members":{"RegexPatternSetId":{},"Name":{}}}}}}},"ListRuleGroups":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RuleGroups":{"type":"list","member":{"type":"structure","required":["RuleGroupId","Name"],"members":{"RuleGroupId":{},"Name":{}}}}}}},"ListRules":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Rules":{"shape":"S5k"}}}},"ListSizeConstraintSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"SizeConstraintSets":{"type":"list","member":{"type":"structure","required":["SizeConstraintSetId","Name"],"members":{"SizeConstraintSetId":{},"Name":{}}}}}}},"ListSqlInjectionMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"SqlInjectionMatchSets":{"type":"list","member":{"type":"structure","required":["SqlInjectionMatchSetId","Name"],"members":{"SqlInjectionMatchSetId":{},"Name":{}}}}}}},"ListSubscribedRuleGroups":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RuleGroups":{"type":"list","member":{"type":"structure","required":["RuleGroupId","Name","MetricName"],"members":{"RuleGroupId":{},"Name":{},"MetricName":{}}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"NextMarker":{},"Limit":{"type":"integer"},"ResourceARN":{}}},"output":{"type":"structure","members":{"NextMarker":{},"TagInfoForResource":{"type":"structure","members":{"ResourceARN":{},"TagList":{"shape":"Sx"}}}}}},"ListWebACLs":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"WebACLs":{"type":"list","member":{"type":"structure","required":["WebACLId","Name"],"members":{"WebACLId":{},"Name":{}}}}}}},"ListXssMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"XssMatchSets":{"type":"list","member":{"type":"structure","required":["XssMatchSetId","Name"],"members":{"XssMatchSetId":{},"Name":{}}}}}}},"PutLoggingConfiguration":{"input":{"type":"structure","required":["LoggingConfiguration"],"members":{"LoggingConfiguration":{"shape":"S3n"}}},"output":{"type":"structure","members":{"LoggingConfiguration":{"shape":"S3n"}}}},"PutPermissionPolicy":{"input":{"type":"structure","required":["ResourceArn","Policy"],"members":{"ResourceArn":{},"Policy":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId","ChangeToken","Updates"],"members":{"ByteMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ByteMatchTuple"],"members":{"Action":{},"ByteMatchTuple":{"shape":"S8"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId","ChangeToken","Updates"],"members":{"GeoMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","GeoMatchConstraint"],"members":{"Action":{},"GeoMatchConstraint":{"shape":"Sj"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateIPSet":{"input":{"type":"structure","required":["IPSetId","ChangeToken","Updates"],"members":{"IPSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","IPSetDescriptor"],"members":{"Action":{},"IPSetDescriptor":{"shape":"Sq"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRateBasedRule":{"input":{"type":"structure","required":["RuleId","ChangeToken","Updates","RateLimit"],"members":{"RuleId":{},"ChangeToken":{},"Updates":{"shape":"S7a"},"RateLimit":{"type":"long"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId","Updates","ChangeToken"],"members":{"RegexMatchSetId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","RegexMatchTuple"],"members":{"Action":{},"RegexMatchTuple":{"shape":"S1b"}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId","Updates","ChangeToken"],"members":{"RegexPatternSetId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","RegexPatternString"],"members":{"Action":{},"RegexPatternString":{}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRule":{"input":{"type":"structure","required":["RuleId","ChangeToken","Updates"],"members":{"RuleId":{},"ChangeToken":{},"Updates":{"shape":"S7a"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRuleGroup":{"input":{"type":"structure","required":["RuleGroupId","Updates","ChangeToken"],"members":{"RuleGroupId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ActivatedRule"],"members":{"Action":{},"ActivatedRule":{"shape":"S25"}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId","ChangeToken","Updates"],"members":{"SizeConstraintSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","SizeConstraint"],"members":{"Action":{},"SizeConstraint":{"shape":"S1r"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId","ChangeToken","Updates"],"members":{"SqlInjectionMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","SqlInjectionMatchTuple"],"members":{"Action":{},"SqlInjectionMatchTuple":{"shape":"S1y"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateWebACL":{"input":{"type":"structure","required":["WebACLId","ChangeToken"],"members":{"WebACLId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ActivatedRule"],"members":{"Action":{},"ActivatedRule":{"shape":"S25"}}}},"DefaultAction":{"shape":"S20"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId","ChangeToken","Updates"],"members":{"XssMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","XssMatchTuple"],"members":{"Action":{},"XssMatchTuple":{"shape":"S2h"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}}},"shapes":{"S5":{"type":"structure","required":["ByteMatchSetId","ByteMatchTuples"],"members":{"ByteMatchSetId":{},"Name":{},"ByteMatchTuples":{"type":"list","member":{"shape":"S8"}}}},"S8":{"type":"structure","required":["FieldToMatch","TargetString","TextTransformation","PositionalConstraint"],"members":{"FieldToMatch":{"shape":"S9"},"TargetString":{"type":"blob"},"TextTransformation":{},"PositionalConstraint":{}}},"S9":{"type":"structure","required":["Type"],"members":{"Type":{},"Data":{}}},"Sh":{"type":"structure","required":["GeoMatchSetId","GeoMatchConstraints"],"members":{"GeoMatchSetId":{},"Name":{},"GeoMatchConstraints":{"type":"list","member":{"shape":"Sj"}}}},"Sj":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{}}},"So":{"type":"structure","required":["IPSetId","IPSetDescriptors"],"members":{"IPSetId":{},"Name":{},"IPSetDescriptors":{"type":"list","member":{"shape":"Sq"}}}},"Sq":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{}}},"Sx":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S12":{"type":"structure","required":["RuleId","MatchPredicates","RateKey","RateLimit"],"members":{"RuleId":{},"Name":{},"MetricName":{},"MatchPredicates":{"shape":"S13"},"RateKey":{},"RateLimit":{"type":"long"}}},"S13":{"type":"list","member":{"shape":"S14"}},"S14":{"type":"structure","required":["Negated","Type","DataId"],"members":{"Negated":{"type":"boolean"},"Type":{},"DataId":{}}},"S19":{"type":"structure","members":{"RegexMatchSetId":{},"Name":{},"RegexMatchTuples":{"type":"list","member":{"shape":"S1b"}}}},"S1b":{"type":"structure","required":["FieldToMatch","TextTransformation","RegexPatternSetId"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{},"RegexPatternSetId":{}}},"S1e":{"type":"structure","required":["RegexPatternSetId","RegexPatternStrings"],"members":{"RegexPatternSetId":{},"Name":{},"RegexPatternStrings":{"type":"list","member":{}}}},"S1j":{"type":"structure","required":["RuleId","Predicates"],"members":{"RuleId":{},"Name":{},"MetricName":{},"Predicates":{"shape":"S13"}}},"S1m":{"type":"structure","required":["RuleGroupId"],"members":{"RuleGroupId":{},"Name":{},"MetricName":{}}},"S1p":{"type":"structure","required":["SizeConstraintSetId","SizeConstraints"],"members":{"SizeConstraintSetId":{},"Name":{},"SizeConstraints":{"type":"list","member":{"shape":"S1r"}}}},"S1r":{"type":"structure","required":["FieldToMatch","TextTransformation","ComparisonOperator","Size"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{},"ComparisonOperator":{},"Size":{"type":"long"}}},"S1w":{"type":"structure","required":["SqlInjectionMatchSetId","SqlInjectionMatchTuples"],"members":{"SqlInjectionMatchSetId":{},"Name":{},"SqlInjectionMatchTuples":{"type":"list","member":{"shape":"S1y"}}}},"S1y":{"type":"structure","required":["FieldToMatch","TextTransformation"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{}}},"S20":{"type":"structure","required":["Type"],"members":{"Type":{}}},"S23":{"type":"structure","required":["WebACLId","DefaultAction","Rules"],"members":{"WebACLId":{},"Name":{},"MetricName":{},"DefaultAction":{"shape":"S20"},"Rules":{"shape":"S24"},"WebACLArn":{}}},"S24":{"type":"list","member":{"shape":"S25"}},"S25":{"type":"structure","required":["Priority","RuleId"],"members":{"Priority":{"type":"integer"},"RuleId":{},"Action":{"shape":"S20"},"OverrideAction":{"type":"structure","required":["Type"],"members":{"Type":{}}},"Type":{},"ExcludedRules":{"type":"list","member":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}}}}},"S2f":{"type":"structure","required":["XssMatchSetId","XssMatchTuples"],"members":{"XssMatchSetId":{},"Name":{},"XssMatchTuples":{"type":"list","member":{"shape":"S2h"}}}},"S2h":{"type":"structure","required":["FieldToMatch","TextTransformation"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{}}},"S3n":{"type":"structure","required":["ResourceArn","LogDestinationConfigs"],"members":{"ResourceArn":{},"LogDestinationConfigs":{"type":"list","member":{}},"RedactedFields":{"type":"list","member":{"shape":"S9"}}}},"S49":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"S5k":{"type":"list","member":{"type":"structure","required":["RuleId","Name"],"members":{"RuleId":{},"Name":{}}}},"S7a":{"type":"list","member":{"type":"structure","required":["Action","Predicate"],"members":{"Action":{},"Predicate":{"shape":"S14"}}}}}}');

});

parcelRequire.register("8uuFa", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("dhNjG", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $9ac31e22a831b3ed$var$Service = $dbC7k.Service;
var $9ac31e22a831b3ed$var$apiLoader = $dbC7k.apiLoader;
$9ac31e22a831b3ed$var$apiLoader.services["wafregional"] = {};
$dbC7k.WAFRegional = $9ac31e22a831b3ed$var$Service.defineService("wafregional", [
    "2016-11-28"
]);


Object.defineProperty($9ac31e22a831b3ed$var$apiLoader.services["wafregional"], "2016-11-28", {
    get: function get() {
        var model = (parcelRequire("b0bvE"));
        model.paginators = (parcelRequire("aYcBk")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.WAFRegional;

});
parcelRequire.register("b0bvE", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-11-28","endpointPrefix":"waf-regional","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"WAF Regional","serviceFullName":"AWS WAF Regional","serviceId":"WAF Regional","signatureVersion":"v4","targetPrefix":"AWSWAF_Regional_20161128","uid":"waf-regional-2016-11-28"},"operations":{"AssociateWebACL":{"input":{"type":"structure","required":["WebACLId","ResourceArn"],"members":{"WebACLId":{},"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"CreateByteMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ByteMatchSet":{"shape":"S9"},"ChangeToken":{}}}},"CreateGeoMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"GeoMatchSet":{"shape":"Sk"},"ChangeToken":{}}}},"CreateIPSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"IPSet":{"shape":"Sr"},"ChangeToken":{}}}},"CreateRateBasedRule":{"input":{"type":"structure","required":["Name","MetricName","RateKey","RateLimit","ChangeToken"],"members":{"Name":{},"MetricName":{},"RateKey":{},"RateLimit":{"type":"long"},"ChangeToken":{},"Tags":{"shape":"S10"}}},"output":{"type":"structure","members":{"Rule":{"shape":"S15"},"ChangeToken":{}}}},"CreateRegexMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"RegexMatchSet":{"shape":"S1c"},"ChangeToken":{}}}},"CreateRegexPatternSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"RegexPatternSet":{"shape":"S1h"},"ChangeToken":{}}}},"CreateRule":{"input":{"type":"structure","required":["Name","MetricName","ChangeToken"],"members":{"Name":{},"MetricName":{},"ChangeToken":{},"Tags":{"shape":"S10"}}},"output":{"type":"structure","members":{"Rule":{"shape":"S1m"},"ChangeToken":{}}}},"CreateRuleGroup":{"input":{"type":"structure","required":["Name","MetricName","ChangeToken"],"members":{"Name":{},"MetricName":{},"ChangeToken":{},"Tags":{"shape":"S10"}}},"output":{"type":"structure","members":{"RuleGroup":{"shape":"S1p"},"ChangeToken":{}}}},"CreateSizeConstraintSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"SizeConstraintSet":{"shape":"S1s"},"ChangeToken":{}}}},"CreateSqlInjectionMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"SqlInjectionMatchSet":{"shape":"S1z"},"ChangeToken":{}}}},"CreateWebACL":{"input":{"type":"structure","required":["Name","MetricName","DefaultAction","ChangeToken"],"members":{"Name":{},"MetricName":{},"DefaultAction":{"shape":"S23"},"ChangeToken":{},"Tags":{"shape":"S10"}}},"output":{"type":"structure","members":{"WebACL":{"shape":"S26"},"ChangeToken":{}}}},"CreateXssMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"XssMatchSet":{"shape":"S2h"},"ChangeToken":{}}}},"DeleteByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId","ChangeToken"],"members":{"ByteMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId","ChangeToken"],"members":{"GeoMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteIPSet":{"input":{"type":"structure","required":["IPSetId","ChangeToken"],"members":{"IPSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteLoggingConfiguration":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"DeletePermissionPolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"DeleteRateBasedRule":{"input":{"type":"structure","required":["RuleId","ChangeToken"],"members":{"RuleId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId","ChangeToken"],"members":{"RegexMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId","ChangeToken"],"members":{"RegexPatternSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRule":{"input":{"type":"structure","required":["RuleId","ChangeToken"],"members":{"RuleId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRuleGroup":{"input":{"type":"structure","required":["RuleGroupId","ChangeToken"],"members":{"RuleGroupId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId","ChangeToken"],"members":{"SizeConstraintSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId","ChangeToken"],"members":{"SqlInjectionMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteWebACL":{"input":{"type":"structure","required":["WebACLId","ChangeToken"],"members":{"WebACLId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId","ChangeToken"],"members":{"XssMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DisassociateWebACL":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"GetByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId"],"members":{"ByteMatchSetId":{}}},"output":{"type":"structure","members":{"ByteMatchSet":{"shape":"S9"}}}},"GetChangeToken":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"GetChangeTokenStatus":{"input":{"type":"structure","required":["ChangeToken"],"members":{"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeTokenStatus":{}}}},"GetGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId"],"members":{"GeoMatchSetId":{}}},"output":{"type":"structure","members":{"GeoMatchSet":{"shape":"Sk"}}}},"GetIPSet":{"input":{"type":"structure","required":["IPSetId"],"members":{"IPSetId":{}}},"output":{"type":"structure","members":{"IPSet":{"shape":"Sr"}}}},"GetLoggingConfiguration":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"LoggingConfiguration":{"shape":"S3r"}}}},"GetPermissionPolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Policy":{}}}},"GetRateBasedRule":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}},"output":{"type":"structure","members":{"Rule":{"shape":"S15"}}}},"GetRateBasedRuleManagedKeys":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{},"NextMarker":{}}},"output":{"type":"structure","members":{"ManagedKeys":{"type":"list","member":{}},"NextMarker":{}}}},"GetRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId"],"members":{"RegexMatchSetId":{}}},"output":{"type":"structure","members":{"RegexMatchSet":{"shape":"S1c"}}}},"GetRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId"],"members":{"RegexPatternSetId":{}}},"output":{"type":"structure","members":{"RegexPatternSet":{"shape":"S1h"}}}},"GetRule":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}},"output":{"type":"structure","members":{"Rule":{"shape":"S1m"}}}},"GetRuleGroup":{"input":{"type":"structure","required":["RuleGroupId"],"members":{"RuleGroupId":{}}},"output":{"type":"structure","members":{"RuleGroup":{"shape":"S1p"}}}},"GetSampledRequests":{"input":{"type":"structure","required":["WebAclId","RuleId","TimeWindow","MaxItems"],"members":{"WebAclId":{},"RuleId":{},"TimeWindow":{"shape":"S4d"},"MaxItems":{"type":"long"}}},"output":{"type":"structure","members":{"SampledRequests":{"type":"list","member":{"type":"structure","required":["Request","Weight"],"members":{"Request":{"type":"structure","members":{"ClientIP":{},"Country":{},"URI":{},"Method":{},"HTTPVersion":{},"Headers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}}}}},"Weight":{"type":"long"},"Timestamp":{"type":"timestamp"},"Action":{},"RuleWithinRuleGroup":{}}}},"PopulationSize":{"type":"long"},"TimeWindow":{"shape":"S4d"}}}},"GetSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId"],"members":{"SizeConstraintSetId":{}}},"output":{"type":"structure","members":{"SizeConstraintSet":{"shape":"S1s"}}}},"GetSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId"],"members":{"SqlInjectionMatchSetId":{}}},"output":{"type":"structure","members":{"SqlInjectionMatchSet":{"shape":"S1z"}}}},"GetWebACL":{"input":{"type":"structure","required":["WebACLId"],"members":{"WebACLId":{}}},"output":{"type":"structure","members":{"WebACL":{"shape":"S26"}}}},"GetWebACLForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"WebACLSummary":{"shape":"S54"}}}},"GetXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId"],"members":{"XssMatchSetId":{}}},"output":{"type":"structure","members":{"XssMatchSet":{"shape":"S2h"}}}},"ListActivatedRulesInRuleGroup":{"input":{"type":"structure","members":{"RuleGroupId":{},"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"ActivatedRules":{"shape":"S27"}}}},"ListByteMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"ByteMatchSets":{"type":"list","member":{"type":"structure","required":["ByteMatchSetId","Name"],"members":{"ByteMatchSetId":{},"Name":{}}}}}}},"ListGeoMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"GeoMatchSets":{"type":"list","member":{"type":"structure","required":["GeoMatchSetId","Name"],"members":{"GeoMatchSetId":{},"Name":{}}}}}}},"ListIPSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"IPSets":{"type":"list","member":{"type":"structure","required":["IPSetId","Name"],"members":{"IPSetId":{},"Name":{}}}}}}},"ListLoggingConfigurations":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"LoggingConfigurations":{"type":"list","member":{"shape":"S3r"}},"NextMarker":{}}}},"ListRateBasedRules":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Rules":{"shape":"S5r"}}}},"ListRegexMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RegexMatchSets":{"type":"list","member":{"type":"structure","required":["RegexMatchSetId","Name"],"members":{"RegexMatchSetId":{},"Name":{}}}}}}},"ListRegexPatternSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RegexPatternSets":{"type":"list","member":{"type":"structure","required":["RegexPatternSetId","Name"],"members":{"RegexPatternSetId":{},"Name":{}}}}}}},"ListResourcesForWebACL":{"input":{"type":"structure","required":["WebACLId"],"members":{"WebACLId":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ResourceArns":{"type":"list","member":{}}}}},"ListRuleGroups":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RuleGroups":{"type":"list","member":{"type":"structure","required":["RuleGroupId","Name"],"members":{"RuleGroupId":{},"Name":{}}}}}}},"ListRules":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Rules":{"shape":"S5r"}}}},"ListSizeConstraintSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"SizeConstraintSets":{"type":"list","member":{"type":"structure","required":["SizeConstraintSetId","Name"],"members":{"SizeConstraintSetId":{},"Name":{}}}}}}},"ListSqlInjectionMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"SqlInjectionMatchSets":{"type":"list","member":{"type":"structure","required":["SqlInjectionMatchSetId","Name"],"members":{"SqlInjectionMatchSetId":{},"Name":{}}}}}}},"ListSubscribedRuleGroups":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RuleGroups":{"type":"list","member":{"type":"structure","required":["RuleGroupId","Name","MetricName"],"members":{"RuleGroupId":{},"Name":{},"MetricName":{}}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"NextMarker":{},"Limit":{"type":"integer"},"ResourceARN":{}}},"output":{"type":"structure","members":{"NextMarker":{},"TagInfoForResource":{"type":"structure","members":{"ResourceARN":{},"TagList":{"shape":"S10"}}}}}},"ListWebACLs":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"WebACLs":{"type":"list","member":{"shape":"S54"}}}}},"ListXssMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"XssMatchSets":{"type":"list","member":{"type":"structure","required":["XssMatchSetId","Name"],"members":{"XssMatchSetId":{},"Name":{}}}}}}},"PutLoggingConfiguration":{"input":{"type":"structure","required":["LoggingConfiguration"],"members":{"LoggingConfiguration":{"shape":"S3r"}}},"output":{"type":"structure","members":{"LoggingConfiguration":{"shape":"S3r"}}}},"PutPermissionPolicy":{"input":{"type":"structure","required":["ResourceArn","Policy"],"members":{"ResourceArn":{},"Policy":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S10"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId","ChangeToken","Updates"],"members":{"ByteMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ByteMatchTuple"],"members":{"Action":{},"ByteMatchTuple":{"shape":"Sb"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId","ChangeToken","Updates"],"members":{"GeoMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","GeoMatchConstraint"],"members":{"Action":{},"GeoMatchConstraint":{"shape":"Sm"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateIPSet":{"input":{"type":"structure","required":["IPSetId","ChangeToken","Updates"],"members":{"IPSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","IPSetDescriptor"],"members":{"Action":{},"IPSetDescriptor":{"shape":"St"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRateBasedRule":{"input":{"type":"structure","required":["RuleId","ChangeToken","Updates","RateLimit"],"members":{"RuleId":{},"ChangeToken":{},"Updates":{"shape":"S7k"},"RateLimit":{"type":"long"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId","Updates","ChangeToken"],"members":{"RegexMatchSetId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","RegexMatchTuple"],"members":{"Action":{},"RegexMatchTuple":{"shape":"S1e"}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId","Updates","ChangeToken"],"members":{"RegexPatternSetId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","RegexPatternString"],"members":{"Action":{},"RegexPatternString":{}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRule":{"input":{"type":"structure","required":["RuleId","ChangeToken","Updates"],"members":{"RuleId":{},"ChangeToken":{},"Updates":{"shape":"S7k"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRuleGroup":{"input":{"type":"structure","required":["RuleGroupId","Updates","ChangeToken"],"members":{"RuleGroupId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ActivatedRule"],"members":{"Action":{},"ActivatedRule":{"shape":"S28"}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId","ChangeToken","Updates"],"members":{"SizeConstraintSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","SizeConstraint"],"members":{"Action":{},"SizeConstraint":{"shape":"S1u"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId","ChangeToken","Updates"],"members":{"SqlInjectionMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","SqlInjectionMatchTuple"],"members":{"Action":{},"SqlInjectionMatchTuple":{"shape":"S21"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateWebACL":{"input":{"type":"structure","required":["WebACLId","ChangeToken"],"members":{"WebACLId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ActivatedRule"],"members":{"Action":{},"ActivatedRule":{"shape":"S28"}}}},"DefaultAction":{"shape":"S23"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId","ChangeToken","Updates"],"members":{"XssMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","XssMatchTuple"],"members":{"Action":{},"XssMatchTuple":{"shape":"S2j"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}}},"shapes":{"S9":{"type":"structure","required":["ByteMatchSetId","ByteMatchTuples"],"members":{"ByteMatchSetId":{},"Name":{},"ByteMatchTuples":{"type":"list","member":{"shape":"Sb"}}}},"Sb":{"type":"structure","required":["FieldToMatch","TargetString","TextTransformation","PositionalConstraint"],"members":{"FieldToMatch":{"shape":"Sc"},"TargetString":{"type":"blob"},"TextTransformation":{},"PositionalConstraint":{}}},"Sc":{"type":"structure","required":["Type"],"members":{"Type":{},"Data":{}}},"Sk":{"type":"structure","required":["GeoMatchSetId","GeoMatchConstraints"],"members":{"GeoMatchSetId":{},"Name":{},"GeoMatchConstraints":{"type":"list","member":{"shape":"Sm"}}}},"Sm":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{}}},"Sr":{"type":"structure","required":["IPSetId","IPSetDescriptors"],"members":{"IPSetId":{},"Name":{},"IPSetDescriptors":{"type":"list","member":{"shape":"St"}}}},"St":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{}}},"S10":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S15":{"type":"structure","required":["RuleId","MatchPredicates","RateKey","RateLimit"],"members":{"RuleId":{},"Name":{},"MetricName":{},"MatchPredicates":{"shape":"S16"},"RateKey":{},"RateLimit":{"type":"long"}}},"S16":{"type":"list","member":{"shape":"S17"}},"S17":{"type":"structure","required":["Negated","Type","DataId"],"members":{"Negated":{"type":"boolean"},"Type":{},"DataId":{}}},"S1c":{"type":"structure","members":{"RegexMatchSetId":{},"Name":{},"RegexMatchTuples":{"type":"list","member":{"shape":"S1e"}}}},"S1e":{"type":"structure","required":["FieldToMatch","TextTransformation","RegexPatternSetId"],"members":{"FieldToMatch":{"shape":"Sc"},"TextTransformation":{},"RegexPatternSetId":{}}},"S1h":{"type":"structure","required":["RegexPatternSetId","RegexPatternStrings"],"members":{"RegexPatternSetId":{},"Name":{},"RegexPatternStrings":{"type":"list","member":{}}}},"S1m":{"type":"structure","required":["RuleId","Predicates"],"members":{"RuleId":{},"Name":{},"MetricName":{},"Predicates":{"shape":"S16"}}},"S1p":{"type":"structure","required":["RuleGroupId"],"members":{"RuleGroupId":{},"Name":{},"MetricName":{}}},"S1s":{"type":"structure","required":["SizeConstraintSetId","SizeConstraints"],"members":{"SizeConstraintSetId":{},"Name":{},"SizeConstraints":{"type":"list","member":{"shape":"S1u"}}}},"S1u":{"type":"structure","required":["FieldToMatch","TextTransformation","ComparisonOperator","Size"],"members":{"FieldToMatch":{"shape":"Sc"},"TextTransformation":{},"ComparisonOperator":{},"Size":{"type":"long"}}},"S1z":{"type":"structure","required":["SqlInjectionMatchSetId","SqlInjectionMatchTuples"],"members":{"SqlInjectionMatchSetId":{},"Name":{},"SqlInjectionMatchTuples":{"type":"list","member":{"shape":"S21"}}}},"S21":{"type":"structure","required":["FieldToMatch","TextTransformation"],"members":{"FieldToMatch":{"shape":"Sc"},"TextTransformation":{}}},"S23":{"type":"structure","required":["Type"],"members":{"Type":{}}},"S26":{"type":"structure","required":["WebACLId","DefaultAction","Rules"],"members":{"WebACLId":{},"Name":{},"MetricName":{},"DefaultAction":{"shape":"S23"},"Rules":{"shape":"S27"},"WebACLArn":{}}},"S27":{"type":"list","member":{"shape":"S28"}},"S28":{"type":"structure","required":["Priority","RuleId"],"members":{"Priority":{"type":"integer"},"RuleId":{},"Action":{"shape":"S23"},"OverrideAction":{"type":"structure","required":["Type"],"members":{"Type":{}}},"Type":{},"ExcludedRules":{"type":"list","member":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}}}}},"S2h":{"type":"structure","required":["XssMatchSetId","XssMatchTuples"],"members":{"XssMatchSetId":{},"Name":{},"XssMatchTuples":{"type":"list","member":{"shape":"S2j"}}}},"S2j":{"type":"structure","required":["FieldToMatch","TextTransformation"],"members":{"FieldToMatch":{"shape":"Sc"},"TextTransformation":{}}},"S3r":{"type":"structure","required":["ResourceArn","LogDestinationConfigs"],"members":{"ResourceArn":{},"LogDestinationConfigs":{"type":"list","member":{}},"RedactedFields":{"type":"list","member":{"shape":"Sc"}}}},"S4d":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"S54":{"type":"structure","required":["WebACLId","Name"],"members":{"WebACLId":{},"Name":{}}},"S5r":{"type":"list","member":{"type":"structure","required":["RuleId","Name"],"members":{"RuleId":{},"Name":{}}}},"S7k":{"type":"list","member":{"type":"structure","required":["Action","Predicate"],"members":{"Action":{},"Predicate":{"shape":"S17"}}}}}}');

});

parcelRequire.register("aYcBk", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("7BMZN", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $58a1fea4f76b7caf$var$Service = $dbC7k.Service;
var $58a1fea4f76b7caf$var$apiLoader = $dbC7k.apiLoader;
$58a1fea4f76b7caf$var$apiLoader.services["workdocs"] = {};
$dbC7k.WorkDocs = $58a1fea4f76b7caf$var$Service.defineService("workdocs", [
    "2016-05-01"
]);


Object.defineProperty($58a1fea4f76b7caf$var$apiLoader.services["workdocs"], "2016-05-01", {
    get: function get() {
        var model = (parcelRequire("f3cEp"));
        model.paginators = (parcelRequire("amOtf")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.WorkDocs;

});
parcelRequire.register("f3cEp", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2016-05-01","endpointPrefix":"workdocs","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon WorkDocs","serviceId":"WorkDocs","signatureVersion":"v4","uid":"workdocs-2016-05-01"},"operations":{"AbortDocumentVersionUpload":{"http":{"method":"DELETE","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}","responseCode":204},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"}}}},"ActivateUser":{"http":{"requestUri":"/api/v1/users/{UserId}/activation","responseCode":200},"input":{"type":"structure","required":["UserId"],"members":{"UserId":{"location":"uri","locationName":"UserId"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}},"AddResourcePermissions":{"http":{"requestUri":"/api/v1/resources/{ResourceId}/permissions","responseCode":201},"input":{"type":"structure","required":["ResourceId","Principals"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"Principals":{"type":"list","member":{"type":"structure","required":["Id","Type","Role"],"members":{"Id":{},"Type":{},"Role":{}}}},"NotificationOptions":{"type":"structure","members":{"SendEmail":{"type":"boolean"},"EmailMessage":{"shape":"St"}}}}},"output":{"type":"structure","members":{"ShareResults":{"type":"list","member":{"type":"structure","members":{"PrincipalId":{},"InviteePrincipalId":{},"Role":{},"Status":{},"ShareId":{},"StatusMessage":{"shape":"St"}}}}}}},"CreateComment":{"http":{"requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}/comment","responseCode":201},"input":{"type":"structure","required":["DocumentId","VersionId","Text"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"ParentId":{},"ThreadId":{},"Text":{"shape":"S10"},"Visibility":{},"NotifyCollaborators":{"type":"boolean"}}},"output":{"type":"structure","members":{"Comment":{"shape":"S13"}}}},"CreateCustomMetadata":{"http":{"method":"PUT","requestUri":"/api/v1/resources/{ResourceId}/customMetadata","responseCode":200},"input":{"type":"structure","required":["ResourceId","CustomMetadata"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"VersionId":{"location":"querystring","locationName":"versionid"},"CustomMetadata":{"shape":"S16"}}},"output":{"type":"structure","members":{}}},"CreateFolder":{"http":{"requestUri":"/api/v1/folders","responseCode":201},"input":{"type":"structure","required":["ParentFolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Name":{},"ParentFolderId":{}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S1d"}}}},"CreateLabels":{"http":{"method":"PUT","requestUri":"/api/v1/resources/{ResourceId}/labels","responseCode":200},"input":{"type":"structure","required":["ResourceId","Labels"],"members":{"ResourceId":{"location":"uri","locationName":"ResourceId"},"Labels":{"shape":"S1g"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{}}},"CreateNotificationSubscription":{"http":{"requestUri":"/api/v1/organizations/{OrganizationId}/subscriptions","responseCode":200},"input":{"type":"structure","required":["OrganizationId","Endpoint","Protocol","SubscriptionType"],"members":{"OrganizationId":{"location":"uri","locationName":"OrganizationId"},"Endpoint":{},"Protocol":{},"SubscriptionType":{}}},"output":{"type":"structure","members":{"Subscription":{"shape":"S1p"}}}},"CreateUser":{"http":{"requestUri":"/api/v1/users","responseCode":201},"input":{"type":"structure","required":["Username","GivenName","Surname","Password"],"members":{"OrganizationId":{},"Username":{},"EmailAddress":{},"GivenName":{},"Surname":{},"Password":{"type":"string","sensitive":true},"TimeZoneId":{},"StorageRule":{"shape":"Sj"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}},"DeactivateUser":{"http":{"method":"DELETE","requestUri":"/api/v1/users/{UserId}/activation","responseCode":204},"input":{"type":"structure","required":["UserId"],"members":{"UserId":{"location":"uri","locationName":"UserId"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}}},"DeleteComment":{"http":{"method":"DELETE","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}/comment/{CommentId}","responseCode":204},"input":{"type":"structure","required":["DocumentId","VersionId","CommentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"CommentId":{"location":"uri","locationName":"CommentId"}}}},"DeleteCustomMetadata":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/customMetadata","responseCode":200},"input":{"type":"structure","required":["ResourceId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"VersionId":{"location":"querystring","locationName":"versionId"},"Keys":{"location":"querystring","locationName":"keys","type":"list","member":{}},"DeleteAll":{"location":"querystring","locationName":"deleteAll","type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteDocument":{"http":{"method":"DELETE","requestUri":"/api/v1/documents/{DocumentId}","responseCode":204},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"}}}},"DeleteFolder":{"http":{"method":"DELETE","requestUri":"/api/v1/folders/{FolderId}","responseCode":204},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"}}}},"DeleteFolderContents":{"http":{"method":"DELETE","requestUri":"/api/v1/folders/{FolderId}/contents","responseCode":204},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"}}}},"DeleteLabels":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/labels","responseCode":200},"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{"location":"uri","locationName":"ResourceId"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Labels":{"shape":"S1g","location":"querystring","locationName":"labels"},"DeleteAll":{"location":"querystring","locationName":"deleteAll","type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteNotificationSubscription":{"http":{"method":"DELETE","requestUri":"/api/v1/organizations/{OrganizationId}/subscriptions/{SubscriptionId}","responseCode":200},"input":{"type":"structure","required":["SubscriptionId","OrganizationId"],"members":{"SubscriptionId":{"location":"uri","locationName":"SubscriptionId"},"OrganizationId":{"location":"uri","locationName":"OrganizationId"}}}},"DeleteUser":{"http":{"method":"DELETE","requestUri":"/api/v1/users/{UserId}","responseCode":204},"input":{"type":"structure","required":["UserId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"UserId":{"location":"uri","locationName":"UserId"}}}},"DescribeActivities":{"http":{"method":"GET","requestUri":"/api/v1/activities","responseCode":200},"input":{"type":"structure","members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"StartTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"EndTime":{"location":"querystring","locationName":"endTime","type":"timestamp"},"OrganizationId":{"location":"querystring","locationName":"organizationId"},"ActivityTypes":{"location":"querystring","locationName":"activityTypes"},"ResourceId":{"location":"querystring","locationName":"resourceId"},"UserId":{"location":"querystring","locationName":"userId"},"IncludeIndirectActivities":{"location":"querystring","locationName":"includeIndirectActivities","type":"boolean"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"UserActivities":{"type":"list","member":{"type":"structure","members":{"Type":{},"TimeStamp":{"type":"timestamp"},"IsIndirectActivity":{"type":"boolean"},"OrganizationId":{},"Initiator":{"shape":"S2d"},"Participants":{"type":"structure","members":{"Users":{"type":"list","member":{"shape":"S2d"}},"Groups":{"shape":"S2g"}}},"ResourceMetadata":{"shape":"S2j"},"OriginalParent":{"shape":"S2j"},"CommentMetadata":{"type":"structure","members":{"CommentId":{},"Contributor":{"shape":"S8"},"CreatedTimestamp":{"type":"timestamp"},"CommentStatus":{},"RecipientId":{}}}}}},"Marker":{}}}},"DescribeComments":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}/comments","responseCode":200},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Comments":{"type":"list","member":{"shape":"S13"}},"Marker":{}}}},"DescribeDocumentVersions":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/versions","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Include":{"location":"querystring","locationName":"include"},"Fields":{"location":"querystring","locationName":"fields"}}},"output":{"type":"structure","members":{"DocumentVersions":{"type":"list","member":{"shape":"S2u"}},"Marker":{}}}},"DescribeFolderContents":{"http":{"method":"GET","requestUri":"/api/v1/folders/{FolderId}/contents","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"Sort":{"location":"querystring","locationName":"sort"},"Order":{"location":"querystring","locationName":"order"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"},"Type":{"location":"querystring","locationName":"type"},"Include":{"location":"querystring","locationName":"include"}}},"output":{"type":"structure","members":{"Folders":{"shape":"S37"},"Documents":{"shape":"S38"},"Marker":{}}}},"DescribeGroups":{"http":{"method":"GET","requestUri":"/api/v1/groups","responseCode":200},"input":{"type":"structure","required":["SearchQuery"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"SearchQuery":{"shape":"S3b","location":"querystring","locationName":"searchQuery"},"OrganizationId":{"location":"querystring","locationName":"organizationId"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"Groups":{"shape":"S2g"},"Marker":{}}}},"DescribeNotificationSubscriptions":{"http":{"method":"GET","requestUri":"/api/v1/organizations/{OrganizationId}/subscriptions","responseCode":200},"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{"location":"uri","locationName":"OrganizationId"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"Subscriptions":{"type":"list","member":{"shape":"S1p"}},"Marker":{}}}},"DescribeResourcePermissions":{"http":{"method":"GET","requestUri":"/api/v1/resources/{ResourceId}/permissions","responseCode":200},"input":{"type":"structure","required":["ResourceId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"PrincipalId":{"location":"querystring","locationName":"principalId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Principals":{"type":"list","member":{"type":"structure","members":{"Id":{},"Type":{},"Roles":{"type":"list","member":{"type":"structure","members":{"Role":{},"Type":{}}}}}}},"Marker":{}}}},"DescribeRootFolders":{"http":{"method":"GET","requestUri":"/api/v1/me/root","responseCode":200},"input":{"type":"structure","required":["AuthenticationToken"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Folders":{"shape":"S37"},"Marker":{}}}},"DescribeUsers":{"http":{"method":"GET","requestUri":"/api/v1/users","responseCode":200},"input":{"type":"structure","members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"OrganizationId":{"location":"querystring","locationName":"organizationId"},"UserIds":{"location":"querystring","locationName":"userIds"},"Query":{"shape":"S3b","location":"querystring","locationName":"query"},"Include":{"location":"querystring","locationName":"include"},"Order":{"location":"querystring","locationName":"order"},"Sort":{"location":"querystring","locationName":"sort"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Fields":{"location":"querystring","locationName":"fields"}}},"output":{"type":"structure","members":{"Users":{"type":"list","member":{"shape":"S8"}},"TotalNumberOfUsers":{"deprecated":true,"type":"long"},"Marker":{}}}},"GetCurrentUser":{"http":{"method":"GET","requestUri":"/api/v1/me","responseCode":200},"input":{"type":"structure","required":["AuthenticationToken"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}},"GetDocument":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"IncludeCustomMetadata":{"location":"querystring","locationName":"includeCustomMetadata","type":"boolean"}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S39"},"CustomMetadata":{"shape":"S16"}}}},"GetDocumentPath":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/path","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Fields":{"location":"querystring","locationName":"fields"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Path":{"shape":"S42"}}}},"GetDocumentVersion":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}","responseCode":200},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"Fields":{"location":"querystring","locationName":"fields"},"IncludeCustomMetadata":{"location":"querystring","locationName":"includeCustomMetadata","type":"boolean"}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S2u"},"CustomMetadata":{"shape":"S16"}}}},"GetFolder":{"http":{"method":"GET","requestUri":"/api/v1/folders/{FolderId}","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"IncludeCustomMetadata":{"location":"querystring","locationName":"includeCustomMetadata","type":"boolean"}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S1d"},"CustomMetadata":{"shape":"S16"}}}},"GetFolderPath":{"http":{"method":"GET","requestUri":"/api/v1/folders/{FolderId}/path","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Fields":{"location":"querystring","locationName":"fields"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Path":{"shape":"S42"}}}},"GetResources":{"http":{"method":"GET","requestUri":"/api/v1/resources","responseCode":200},"input":{"type":"structure","members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"UserId":{"location":"querystring","locationName":"userId"},"CollectionType":{"location":"querystring","locationName":"collectionType"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Folders":{"shape":"S37"},"Documents":{"shape":"S38"},"Marker":{}}}},"InitiateDocumentVersionUpload":{"http":{"requestUri":"/api/v1/documents","responseCode":201},"input":{"type":"structure","required":["ParentFolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Id":{},"Name":{},"ContentCreatedTimestamp":{"type":"timestamp"},"ContentModifiedTimestamp":{"type":"timestamp"},"ContentType":{},"DocumentSizeInBytes":{"type":"long"},"ParentFolderId":{}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S39"},"UploadMetadata":{"type":"structure","members":{"UploadUrl":{"shape":"S2z"},"SignedHeaders":{"type":"map","key":{},"value":{}}}}}}},"RemoveAllResourcePermissions":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/permissions","responseCode":204},"input":{"type":"structure","required":["ResourceId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"}}}},"RemoveResourcePermission":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/permissions/{PrincipalId}","responseCode":204},"input":{"type":"structure","required":["ResourceId","PrincipalId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"PrincipalId":{"location":"uri","locationName":"PrincipalId"},"PrincipalType":{"location":"querystring","locationName":"type"}}}},"UpdateDocument":{"http":{"method":"PATCH","requestUri":"/api/v1/documents/{DocumentId}","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"Name":{},"ParentFolderId":{},"ResourceState":{}}}},"UpdateDocumentVersion":{"http":{"method":"PATCH","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}","responseCode":200},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"VersionStatus":{}}}},"UpdateFolder":{"http":{"method":"PATCH","requestUri":"/api/v1/folders/{FolderId}","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"Name":{},"ParentFolderId":{},"ResourceState":{}}}},"UpdateUser":{"http":{"method":"PATCH","requestUri":"/api/v1/users/{UserId}","responseCode":200},"input":{"type":"structure","required":["UserId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"UserId":{"location":"uri","locationName":"UserId"},"GivenName":{},"Surname":{},"Type":{},"StorageRule":{"shape":"Sj"},"TimeZoneId":{},"Locale":{},"GrantPoweruserPrivileges":{}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}}},"shapes":{"S2":{"type":"string","sensitive":true},"S8":{"type":"structure","members":{"Id":{},"Username":{},"EmailAddress":{},"GivenName":{},"Surname":{},"OrganizationId":{},"RootFolderId":{},"RecycleBinFolderId":{},"Status":{},"Type":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"TimeZoneId":{},"Locale":{},"Storage":{"type":"structure","members":{"StorageUtilizedInBytes":{"type":"long"},"StorageRule":{"shape":"Sj"}}}}},"Sj":{"type":"structure","members":{"StorageAllocatedInBytes":{"type":"long"},"StorageType":{}}},"St":{"type":"string","sensitive":true},"S10":{"type":"string","sensitive":true},"S13":{"type":"structure","required":["CommentId"],"members":{"CommentId":{},"ParentId":{},"ThreadId":{},"Text":{"shape":"S10"},"Contributor":{"shape":"S8"},"CreatedTimestamp":{"type":"timestamp"},"Status":{},"Visibility":{},"RecipientId":{}}},"S16":{"type":"map","key":{},"value":{}},"S1d":{"type":"structure","members":{"Id":{},"Name":{},"CreatorId":{},"ParentFolderId":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"ResourceState":{},"Signature":{},"Labels":{"shape":"S1g"},"Size":{"type":"long"},"LatestVersionSize":{"type":"long"}}},"S1g":{"type":"list","member":{}},"S1p":{"type":"structure","members":{"SubscriptionId":{},"EndPoint":{},"Protocol":{}}},"S2d":{"type":"structure","members":{"Id":{},"Username":{},"GivenName":{},"Surname":{},"EmailAddress":{}}},"S2g":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{}}}},"S2j":{"type":"structure","members":{"Type":{},"Name":{},"OriginalName":{},"Id":{},"VersionId":{},"Owner":{"shape":"S2d"},"ParentId":{}}},"S2u":{"type":"structure","members":{"Id":{},"Name":{},"ContentType":{},"Size":{"type":"long"},"Signature":{},"Status":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"ContentCreatedTimestamp":{"type":"timestamp"},"ContentModifiedTimestamp":{"type":"timestamp"},"CreatorId":{},"Thumbnail":{"type":"map","key":{},"value":{"shape":"S2z"}},"Source":{"type":"map","key":{},"value":{"shape":"S2z"}}}},"S2z":{"type":"string","sensitive":true},"S37":{"type":"list","member":{"shape":"S1d"}},"S38":{"type":"list","member":{"shape":"S39"}},"S39":{"type":"structure","members":{"Id":{},"CreatorId":{},"ParentFolderId":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"LatestVersionMetadata":{"shape":"S2u"},"ResourceState":{},"Labels":{"shape":"S1g"}}},"S3b":{"type":"string","sensitive":true},"S42":{"type":"structure","members":{"Components":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{}}}}}}}}');

});

parcelRequire.register("amOtf", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeDocumentVersions":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"DocumentVersions"},"DescribeFolderContents":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":["Folders","Documents"]},"DescribeUsers":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Users"}}}');

});


parcelRequire.register("cDZ1P", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $9348778652d5f5e2$var$Service = $dbC7k.Service;
var $9348778652d5f5e2$var$apiLoader = $dbC7k.apiLoader;
$9348778652d5f5e2$var$apiLoader.services["workspaces"] = {};
$dbC7k.WorkSpaces = $9348778652d5f5e2$var$Service.defineService("workspaces", [
    "2015-04-08"
]);


Object.defineProperty($9348778652d5f5e2$var$apiLoader.services["workspaces"], "2015-04-08", {
    get: function get() {
        var model = (parcelRequire("lf7CA"));
        model.paginators = (parcelRequire("hIHC2")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.WorkSpaces;

});
parcelRequire.register("lf7CA", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-04-08","endpointPrefix":"workspaces","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon WorkSpaces","serviceId":"WorkSpaces","signatureVersion":"v4","targetPrefix":"WorkspacesService","uid":"workspaces-2015-04-08"},"operations":{"AssociateIpGroups":{"input":{"type":"structure","required":["DirectoryId","GroupIds"],"members":{"DirectoryId":{},"GroupIds":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"AuthorizeIpRules":{"input":{"type":"structure","required":["GroupId","UserRules"],"members":{"GroupId":{},"UserRules":{"shape":"S7"}}},"output":{"type":"structure","members":{}}},"CopyWorkspaceImage":{"input":{"type":"structure","required":["Name","SourceImageId","SourceRegion"],"members":{"Name":{},"Description":{},"SourceImageId":{},"SourceRegion":{},"Tags":{"shape":"Sh"}}},"output":{"type":"structure","members":{"ImageId":{}}}},"CreateIpGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"GroupDesc":{},"UserRules":{"shape":"S7"},"Tags":{"shape":"Sh"}}},"output":{"type":"structure","members":{"GroupId":{}}}},"CreateTags":{"input":{"type":"structure","required":["ResourceId","Tags"],"members":{"ResourceId":{},"Tags":{"shape":"Sh"}}},"output":{"type":"structure","members":{}}},"CreateWorkspaces":{"input":{"type":"structure","required":["Workspaces"],"members":{"Workspaces":{"type":"list","member":{"shape":"Sv"}}}},"output":{"type":"structure","members":{"FailedRequests":{"type":"list","member":{"type":"structure","members":{"WorkspaceRequest":{"shape":"Sv"},"ErrorCode":{},"ErrorMessage":{}}}},"PendingRequests":{"shape":"S1b"}}}},"DeleteIpGroup":{"input":{"type":"structure","required":["GroupId"],"members":{"GroupId":{}}},"output":{"type":"structure","members":{}}},"DeleteTags":{"input":{"type":"structure","required":["ResourceId","TagKeys"],"members":{"ResourceId":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"DeleteWorkspaceImage":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{}}},"output":{"type":"structure","members":{}}},"DescribeAccount":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"DedicatedTenancySupport":{},"DedicatedTenancyManagementCidrRange":{}}}},"DescribeAccountModifications":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"AccountModifications":{"type":"list","member":{"type":"structure","members":{"ModificationState":{},"DedicatedTenancySupport":{},"DedicatedTenancyManagementCidrRange":{},"StartTime":{"type":"timestamp"},"ErrorCode":{},"ErrorMessage":{}}}},"NextToken":{}}}},"DescribeClientProperties":{"input":{"type":"structure","required":["ResourceIds"],"members":{"ResourceIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ClientPropertiesList":{"type":"list","member":{"type":"structure","members":{"ResourceId":{},"ClientProperties":{"shape":"S2a"}}}}}}},"DescribeIpGroups":{"input":{"type":"structure","members":{"GroupIds":{"shape":"S3"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Result":{"type":"list","member":{"type":"structure","members":{"groupId":{},"groupName":{},"groupDesc":{},"userRules":{"shape":"S7"}}}},"NextToken":{}}}},"DescribeTags":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{}}},"output":{"type":"structure","members":{"TagList":{"shape":"Sh"}}}},"DescribeWorkspaceBundles":{"input":{"type":"structure","members":{"BundleIds":{"type":"list","member":{}},"Owner":{},"NextToken":{}}},"output":{"type":"structure","members":{"Bundles":{"type":"list","member":{"type":"structure","members":{"BundleId":{},"Name":{},"Owner":{},"Description":{},"RootStorage":{"type":"structure","members":{"Capacity":{}}},"UserStorage":{"type":"structure","members":{"Capacity":{}}},"ComputeType":{"type":"structure","members":{"Name":{}}}}}},"NextToken":{}}}},"DescribeWorkspaceDirectories":{"input":{"type":"structure","members":{"DirectoryIds":{"type":"list","member":{}},"NextToken":{}}},"output":{"type":"structure","members":{"Directories":{"type":"list","member":{"type":"structure","members":{"DirectoryId":{},"Alias":{},"DirectoryName":{},"RegistrationCode":{},"SubnetIds":{"type":"list","member":{}},"DnsIpAddresses":{"type":"list","member":{}},"CustomerUserName":{},"IamRoleId":{},"DirectoryType":{},"WorkspaceSecurityGroupId":{},"State":{},"WorkspaceCreationProperties":{"type":"structure","members":{"EnableWorkDocs":{"type":"boolean"},"EnableInternetAccess":{"type":"boolean"},"DefaultOu":{},"CustomSecurityGroupId":{},"UserEnabledAsLocalAdministrator":{"type":"boolean"}}},"ipGroupIds":{"shape":"S3"}}}},"NextToken":{}}}},"DescribeWorkspaceImages":{"input":{"type":"structure","members":{"ImageIds":{"type":"list","member":{}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Images":{"type":"list","member":{"type":"structure","members":{"ImageId":{},"Name":{},"Description":{},"OperatingSystem":{"type":"structure","members":{"Type":{}}},"State":{},"RequiredTenancy":{},"ErrorCode":{},"ErrorMessage":{}}}},"NextToken":{}}}},"DescribeWorkspaces":{"input":{"type":"structure","members":{"WorkspaceIds":{"shape":"S3j"},"DirectoryId":{},"UserName":{},"BundleId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Workspaces":{"shape":"S1b"},"NextToken":{}}}},"DescribeWorkspacesConnectionStatus":{"input":{"type":"structure","members":{"WorkspaceIds":{"shape":"S3j"},"NextToken":{}}},"output":{"type":"structure","members":{"WorkspacesConnectionStatus":{"type":"list","member":{"type":"structure","members":{"WorkspaceId":{},"ConnectionState":{},"ConnectionStateCheckTimestamp":{"type":"timestamp"},"LastKnownUserConnectionTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"DisassociateIpGroups":{"input":{"type":"structure","required":["DirectoryId","GroupIds"],"members":{"DirectoryId":{},"GroupIds":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"ImportWorkspaceImage":{"input":{"type":"structure","required":["Ec2ImageId","IngestionProcess","ImageName","ImageDescription"],"members":{"Ec2ImageId":{},"IngestionProcess":{},"ImageName":{},"ImageDescription":{},"Tags":{"shape":"Sh"}}},"output":{"type":"structure","members":{"ImageId":{}}}},"ListAvailableManagementCidrRanges":{"input":{"type":"structure","required":["ManagementCidrRangeConstraint"],"members":{"ManagementCidrRangeConstraint":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ManagementCidrRanges":{"type":"list","member":{}},"NextToken":{}}}},"ModifyAccount":{"input":{"type":"structure","members":{"DedicatedTenancySupport":{},"DedicatedTenancyManagementCidrRange":{}}},"output":{"type":"structure","members":{}}},"ModifyClientProperties":{"input":{"type":"structure","required":["ResourceId","ClientProperties"],"members":{"ResourceId":{},"ClientProperties":{"shape":"S2a"}}},"output":{"type":"structure","members":{}}},"ModifyWorkspaceProperties":{"input":{"type":"structure","required":["WorkspaceId","WorkspaceProperties"],"members":{"WorkspaceId":{},"WorkspaceProperties":{"shape":"S10"}}},"output":{"type":"structure","members":{}}},"ModifyWorkspaceState":{"input":{"type":"structure","required":["WorkspaceId","WorkspaceState"],"members":{"WorkspaceId":{},"WorkspaceState":{}}},"output":{"type":"structure","members":{}}},"RebootWorkspaces":{"input":{"type":"structure","required":["RebootWorkspaceRequests"],"members":{"RebootWorkspaceRequests":{"type":"list","member":{"type":"structure","required":["WorkspaceId"],"members":{"WorkspaceId":{}}}}}},"output":{"type":"structure","members":{"FailedRequests":{"type":"list","member":{"shape":"S4g"}}}}},"RebuildWorkspaces":{"input":{"type":"structure","required":["RebuildWorkspaceRequests"],"members":{"RebuildWorkspaceRequests":{"type":"list","member":{"type":"structure","required":["WorkspaceId"],"members":{"WorkspaceId":{}}}}}},"output":{"type":"structure","members":{"FailedRequests":{"type":"list","member":{"shape":"S4g"}}}}},"RevokeIpRules":{"input":{"type":"structure","required":["GroupId","UserRules"],"members":{"GroupId":{},"UserRules":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"StartWorkspaces":{"input":{"type":"structure","required":["StartWorkspaceRequests"],"members":{"StartWorkspaceRequests":{"type":"list","member":{"type":"structure","members":{"WorkspaceId":{}}}}}},"output":{"type":"structure","members":{"FailedRequests":{"type":"list","member":{"shape":"S4g"}}}}},"StopWorkspaces":{"input":{"type":"structure","required":["StopWorkspaceRequests"],"members":{"StopWorkspaceRequests":{"type":"list","member":{"type":"structure","members":{"WorkspaceId":{}}}}}},"output":{"type":"structure","members":{"FailedRequests":{"type":"list","member":{"shape":"S4g"}}}}},"TerminateWorkspaces":{"input":{"type":"structure","required":["TerminateWorkspaceRequests"],"members":{"TerminateWorkspaceRequests":{"type":"list","member":{"type":"structure","required":["WorkspaceId"],"members":{"WorkspaceId":{}}}}}},"output":{"type":"structure","members":{"FailedRequests":{"type":"list","member":{"shape":"S4g"}}}}},"UpdateRulesOfIpGroup":{"input":{"type":"structure","required":["GroupId","UserRules"],"members":{"GroupId":{},"UserRules":{"shape":"S7"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S3":{"type":"list","member":{}},"S7":{"type":"list","member":{"type":"structure","members":{"ipRule":{},"ruleDesc":{}}}},"Sh":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sv":{"type":"structure","required":["DirectoryId","UserName","BundleId"],"members":{"DirectoryId":{},"UserName":{},"BundleId":{},"VolumeEncryptionKey":{},"UserVolumeEncryptionEnabled":{"type":"boolean"},"RootVolumeEncryptionEnabled":{"type":"boolean"},"WorkspaceProperties":{"shape":"S10"},"Tags":{"shape":"Sh"}}},"S10":{"type":"structure","members":{"RunningMode":{},"RunningModeAutoStopTimeoutInMinutes":{"type":"integer"},"RootVolumeSizeGib":{"type":"integer"},"UserVolumeSizeGib":{"type":"integer"},"ComputeTypeName":{}}},"S1b":{"type":"list","member":{"type":"structure","members":{"WorkspaceId":{},"DirectoryId":{},"UserName":{},"IpAddress":{},"State":{},"BundleId":{},"SubnetId":{},"ErrorMessage":{},"ErrorCode":{},"ComputerName":{},"VolumeEncryptionKey":{},"UserVolumeEncryptionEnabled":{"type":"boolean"},"RootVolumeEncryptionEnabled":{"type":"boolean"},"WorkspaceProperties":{"shape":"S10"},"ModificationStates":{"type":"list","member":{"type":"structure","members":{"Resource":{},"State":{}}}}}}},"S2a":{"type":"structure","members":{"ReconnectEnabled":{}}},"S3j":{"type":"list","member":{}},"S4g":{"type":"structure","members":{"WorkspaceId":{},"ErrorCode":{},"ErrorMessage":{}}}}}');

});

parcelRequire.register("hIHC2", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeWorkspaceBundles":{"input_token":"NextToken","output_token":"NextToken","result_key":"Bundles"},"DescribeWorkspaceDirectories":{"input_token":"NextToken","output_token":"NextToken","result_key":"Directories"},"DescribeWorkspaces":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Workspaces"}}}');

});


parcelRequire.register("3wIkS", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $2916c06ca67c0ccd$var$Service = $dbC7k.Service;
var $2916c06ca67c0ccd$var$apiLoader = $dbC7k.apiLoader;
$2916c06ca67c0ccd$var$apiLoader.services["codestar"] = {};
$dbC7k.CodeStar = $2916c06ca67c0ccd$var$Service.defineService("codestar", [
    "2017-04-19"
]);


Object.defineProperty($2916c06ca67c0ccd$var$apiLoader.services["codestar"], "2017-04-19", {
    get: function get() {
        var model = (parcelRequire("6sgER"));
        model.paginators = (parcelRequire("xvoXo")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.CodeStar;

});
parcelRequire.register("6sgER", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-04-19","endpointPrefix":"codestar","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CodeStar","serviceFullName":"AWS CodeStar","serviceId":"CodeStar","signatureVersion":"v4","targetPrefix":"CodeStar_20170419","uid":"codestar-2017-04-19"},"operations":{"AssociateTeamMember":{"input":{"type":"structure","required":["projectId","userArn","projectRole"],"members":{"projectId":{},"clientRequestToken":{},"userArn":{},"projectRole":{},"remoteAccessAllowed":{"type":"boolean"}}},"output":{"type":"structure","members":{"clientRequestToken":{}}}},"CreateProject":{"input":{"type":"structure","required":["name","id"],"members":{"name":{"shape":"S9"},"id":{},"description":{"shape":"Sa"},"clientRequestToken":{},"sourceCode":{"type":"list","member":{"type":"structure","required":["source","destination"],"members":{"source":{"type":"structure","required":["s3"],"members":{"s3":{"shape":"Se"}}},"destination":{"type":"structure","members":{"codeCommit":{"type":"structure","required":["name"],"members":{"name":{}}},"gitHub":{"type":"structure","required":["name","type","owner","privateRepository","issuesEnabled","token"],"members":{"name":{},"description":{},"type":{},"owner":{},"privateRepository":{"type":"boolean"},"issuesEnabled":{"type":"boolean"},"token":{"type":"string","sensitive":true}}}}}}}},"toolchain":{"type":"structure","required":["source"],"members":{"source":{"type":"structure","required":["s3"],"members":{"s3":{"shape":"Se"}}},"roleArn":{},"stackParameters":{"type":"map","key":{},"value":{"type":"string","sensitive":true}}}},"tags":{"shape":"Sx"}}},"output":{"type":"structure","required":["id","arn"],"members":{"id":{},"arn":{},"clientRequestToken":{},"projectTemplateId":{}}}},"CreateUserProfile":{"input":{"type":"structure","required":["userArn","displayName","emailAddress"],"members":{"userArn":{},"displayName":{"shape":"S14"},"emailAddress":{"shape":"S15"},"sshPublicKey":{}}},"output":{"type":"structure","required":["userArn"],"members":{"userArn":{},"displayName":{"shape":"S14"},"emailAddress":{"shape":"S15"},"sshPublicKey":{},"createdTimestamp":{"type":"timestamp"},"lastModifiedTimestamp":{"type":"timestamp"}}}},"DeleteProject":{"input":{"type":"structure","required":["id"],"members":{"id":{},"clientRequestToken":{},"deleteStack":{"type":"boolean"}}},"output":{"type":"structure","members":{"stackId":{},"projectArn":{}}}},"DeleteUserProfile":{"input":{"type":"structure","required":["userArn"],"members":{"userArn":{}}},"output":{"type":"structure","required":["userArn"],"members":{"userArn":{}}}},"DescribeProject":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{"name":{"shape":"S9"},"id":{},"arn":{},"description":{"shape":"Sa"},"clientRequestToken":{},"createdTimeStamp":{"type":"timestamp"},"stackId":{},"projectTemplateId":{},"status":{"type":"structure","required":["state"],"members":{"state":{},"reason":{}}}}}},"DescribeUserProfile":{"input":{"type":"structure","required":["userArn"],"members":{"userArn":{}}},"output":{"type":"structure","required":["userArn","createdTimestamp","lastModifiedTimestamp"],"members":{"userArn":{},"displayName":{"shape":"S14"},"emailAddress":{"shape":"S15"},"sshPublicKey":{},"createdTimestamp":{"type":"timestamp"},"lastModifiedTimestamp":{"type":"timestamp"}}}},"DisassociateTeamMember":{"input":{"type":"structure","required":["projectId","userArn"],"members":{"projectId":{},"userArn":{}}},"output":{"type":"structure","members":{}}},"ListProjects":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["projects"],"members":{"projects":{"type":"list","member":{"type":"structure","members":{"projectId":{},"projectArn":{}}}},"nextToken":{}}}},"ListResources":{"input":{"type":"structure","required":["projectId"],"members":{"projectId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"resources":{"type":"list","member":{"type":"structure","required":["id"],"members":{"id":{}}}},"nextToken":{}}}},"ListTagsForProject":{"input":{"type":"structure","required":["id"],"members":{"id":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sx"},"nextToken":{}}}},"ListTeamMembers":{"input":{"type":"structure","required":["projectId"],"members":{"projectId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["teamMembers"],"members":{"teamMembers":{"type":"list","member":{"type":"structure","required":["userArn","projectRole"],"members":{"userArn":{},"projectRole":{},"remoteAccessAllowed":{"type":"boolean"}}}},"nextToken":{}}}},"ListUserProfiles":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["userProfiles"],"members":{"userProfiles":{"type":"list","member":{"type":"structure","members":{"userArn":{},"displayName":{"shape":"S14"},"emailAddress":{"shape":"S15"},"sshPublicKey":{}}}},"nextToken":{}}}},"TagProject":{"input":{"type":"structure","required":["id","tags"],"members":{"id":{},"tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sx"}}}},"UntagProject":{"input":{"type":"structure","required":["id","tags"],"members":{"id":{},"tags":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateProject":{"input":{"type":"structure","required":["id"],"members":{"id":{},"name":{"shape":"S9"},"description":{"shape":"Sa"}}},"output":{"type":"structure","members":{}}},"UpdateTeamMember":{"input":{"type":"structure","required":["projectId","userArn"],"members":{"projectId":{},"userArn":{},"projectRole":{},"remoteAccessAllowed":{"type":"boolean"}}},"output":{"type":"structure","members":{"userArn":{},"projectRole":{},"remoteAccessAllowed":{"type":"boolean"}}}},"UpdateUserProfile":{"input":{"type":"structure","required":["userArn"],"members":{"userArn":{},"displayName":{"shape":"S14"},"emailAddress":{"shape":"S15"},"sshPublicKey":{}}},"output":{"type":"structure","required":["userArn"],"members":{"userArn":{},"displayName":{"shape":"S14"},"emailAddress":{"shape":"S15"},"sshPublicKey":{},"createdTimestamp":{"type":"timestamp"},"lastModifiedTimestamp":{"type":"timestamp"}}}}},"shapes":{"S9":{"type":"string","sensitive":true},"Sa":{"type":"string","sensitive":true},"Se":{"type":"structure","members":{"bucketName":{},"bucketKey":{}}},"Sx":{"type":"map","key":{},"value":{}},"S14":{"type":"string","sensitive":true},"S15":{"type":"string","sensitive":true}}}');

});

parcelRequire.register("xvoXo", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("c6WOe", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $8d13a9d642493892$var$Service = $dbC7k.Service;
var $8d13a9d642493892$var$apiLoader = $dbC7k.apiLoader;
$8d13a9d642493892$var$apiLoader.services["lexmodelbuildingservice"] = {};
$dbC7k.LexModelBuildingService = $8d13a9d642493892$var$Service.defineService("lexmodelbuildingservice", [
    "2017-04-19"
]);


Object.defineProperty($8d13a9d642493892$var$apiLoader.services["lexmodelbuildingservice"], "2017-04-19", {
    get: function get() {
        var model = (parcelRequire("4EQWF"));
        model.paginators = (parcelRequire("dIOu3")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.LexModelBuildingService;

});
parcelRequire.register("4EQWF", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-04-19","endpointPrefix":"models.lex","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Lex Model Building Service","serviceId":"Lex Model Building Service","signatureVersion":"v4","signingName":"lex","uid":"lex-models-2017-04-19"},"operations":{"CreateBotVersion":{"http":{"requestUri":"/bots/{name}/versions","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"intents":{"shape":"S6"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Si"},"status":{},"failureReason":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"version":{},"locale":{},"childDirected":{"type":"boolean"}}}},"CreateIntentVersion":{"http":{"requestUri":"/intents/{name}/versions","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"slots":{"shape":"Sq"},"sampleUtterances":{"shape":"Sy"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"},"followUpPrompt":{"shape":"Sz"},"conclusionStatement":{"shape":"Si"},"dialogCodeHook":{"shape":"S10"},"fulfillmentActivity":{"shape":"S13"},"parentIntentSignature":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{}}}},"CreateSlotTypeVersion":{"http":{"requestUri":"/slottypes/{name}/versions","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"enumerationValues":{"shape":"S19"},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"valueSelectionStrategy":{}}}},"DeleteBot":{"http":{"method":"DELETE","requestUri":"/bots/{name}","responseCode":204},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}}},"DeleteBotAlias":{"http":{"method":"DELETE","requestUri":"/bots/{botName}/aliases/{name}","responseCode":204},"input":{"type":"structure","required":["name","botName"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"}}}},"DeleteBotChannelAssociation":{"http":{"method":"DELETE","requestUri":"/bots/{botName}/aliases/{aliasName}/channels/{name}","responseCode":204},"input":{"type":"structure","required":["name","botName","botAlias"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"aliasName"}}}},"DeleteBotVersion":{"http":{"method":"DELETE","requestUri":"/bots/{name}/versions/{version}","responseCode":204},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}}},"DeleteIntent":{"http":{"method":"DELETE","requestUri":"/intents/{name}","responseCode":204},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}}},"DeleteIntentVersion":{"http":{"method":"DELETE","requestUri":"/intents/{name}/versions/{version}","responseCode":204},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}}},"DeleteSlotType":{"http":{"method":"DELETE","requestUri":"/slottypes/{name}","responseCode":204},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}}},"DeleteSlotTypeVersion":{"http":{"method":"DELETE","requestUri":"/slottypes/{name}/version/{version}","responseCode":204},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}}},"DeleteUtterances":{"http":{"method":"DELETE","requestUri":"/bots/{botName}/utterances/{userId}","responseCode":204},"input":{"type":"structure","required":["botName","userId"],"members":{"botName":{"location":"uri","locationName":"botName"},"userId":{"location":"uri","locationName":"userId"}}}},"GetBot":{"http":{"method":"GET","requestUri":"/bots/{name}/versions/{versionoralias}","responseCode":200},"input":{"type":"structure","required":["name","versionOrAlias"],"members":{"name":{"location":"uri","locationName":"name"},"versionOrAlias":{"location":"uri","locationName":"versionoralias"}}},"output":{"type":"structure","members":{"name":{},"description":{},"intents":{"shape":"S6"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Si"},"status":{},"failureReason":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"version":{},"locale":{},"childDirected":{"type":"boolean"}}}},"GetBotAlias":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/{name}","responseCode":200},"input":{"type":"structure","required":["name","botName"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"}}},"output":{"type":"structure","members":{"name":{},"description":{},"botVersion":{},"botName":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"checksum":{}}}},"GetBotAliases":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/","responseCode":200},"input":{"type":"structure","required":["botName"],"members":{"botName":{"location":"uri","locationName":"botName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"BotAliases":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"botVersion":{},"botName":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"checksum":{}}}},"nextToken":{}}}},"GetBotChannelAssociation":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/{aliasName}/channels/{name}","responseCode":200},"input":{"type":"structure","required":["name","botName","botAlias"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"aliasName"}}},"output":{"type":"structure","members":{"name":{},"description":{},"botAlias":{},"botName":{},"createdDate":{"type":"timestamp"},"type":{},"botConfiguration":{"shape":"S24"},"status":{},"failureReason":{}}}},"GetBotChannelAssociations":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/{aliasName}/channels/","responseCode":200},"input":{"type":"structure","required":["botName","botAlias"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"aliasName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"botChannelAssociations":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"botAlias":{},"botName":{},"createdDate":{"type":"timestamp"},"type":{},"botConfiguration":{"shape":"S24"},"status":{},"failureReason":{}}}},"nextToken":{}}}},"GetBotVersions":{"http":{"method":"GET","requestUri":"/bots/{name}/versions/","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"bots":{"shape":"S2d"},"nextToken":{}}}},"GetBots":{"http":{"method":"GET","requestUri":"/bots/","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"bots":{"shape":"S2d"},"nextToken":{}}}},"GetBuiltinIntent":{"http":{"method":"GET","requestUri":"/builtins/intents/{signature}","responseCode":200},"input":{"type":"structure","required":["signature"],"members":{"signature":{"location":"uri","locationName":"signature"}}},"output":{"type":"structure","members":{"signature":{},"supportedLocales":{"shape":"S2j"},"slots":{"type":"list","member":{"type":"structure","members":{"name":{}}}}}}},"GetBuiltinIntents":{"http":{"method":"GET","requestUri":"/builtins/intents/","responseCode":200},"input":{"type":"structure","members":{"locale":{"location":"querystring","locationName":"locale"},"signatureContains":{"location":"querystring","locationName":"signatureContains"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"intents":{"type":"list","member":{"type":"structure","members":{"signature":{},"supportedLocales":{"shape":"S2j"}}}},"nextToken":{}}}},"GetBuiltinSlotTypes":{"http":{"method":"GET","requestUri":"/builtins/slottypes/","responseCode":200},"input":{"type":"structure","members":{"locale":{"location":"querystring","locationName":"locale"},"signatureContains":{"location":"querystring","locationName":"signatureContains"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"slotTypes":{"type":"list","member":{"type":"structure","members":{"signature":{},"supportedLocales":{"shape":"S2j"}}}},"nextToken":{}}}},"GetExport":{"http":{"method":"GET","requestUri":"/exports/","responseCode":200},"input":{"type":"structure","required":["name","version","resourceType","exportType"],"members":{"name":{"location":"querystring","locationName":"name"},"version":{"location":"querystring","locationName":"version"},"resourceType":{"location":"querystring","locationName":"resourceType"},"exportType":{"location":"querystring","locationName":"exportType"}}},"output":{"type":"structure","members":{"name":{},"version":{},"resourceType":{},"exportType":{},"exportStatus":{},"failureReason":{},"url":{}}}},"GetImport":{"http":{"method":"GET","requestUri":"/imports/{importId}","responseCode":200},"input":{"type":"structure","required":["importId"],"members":{"importId":{"location":"uri","locationName":"importId"}}},"output":{"type":"structure","members":{"name":{},"resourceType":{},"mergeStrategy":{},"importId":{},"importStatus":{},"failureReason":{"type":"list","member":{}},"createdDate":{"type":"timestamp"}}}},"GetIntent":{"http":{"method":"GET","requestUri":"/intents/{name}/versions/{version}","responseCode":200},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}},"output":{"type":"structure","members":{"name":{},"description":{},"slots":{"shape":"Sq"},"sampleUtterances":{"shape":"Sy"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"},"followUpPrompt":{"shape":"Sz"},"conclusionStatement":{"shape":"Si"},"dialogCodeHook":{"shape":"S10"},"fulfillmentActivity":{"shape":"S13"},"parentIntentSignature":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{}}}},"GetIntentVersions":{"http":{"method":"GET","requestUri":"/intents/{name}/versions/","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"intents":{"shape":"S3a"},"nextToken":{}}}},"GetIntents":{"http":{"method":"GET","requestUri":"/intents/","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"intents":{"shape":"S3a"},"nextToken":{}}}},"GetSlotType":{"http":{"method":"GET","requestUri":"/slottypes/{name}/versions/{version}","responseCode":200},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}},"output":{"type":"structure","members":{"name":{},"description":{},"enumerationValues":{"shape":"S19"},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"valueSelectionStrategy":{}}}},"GetSlotTypeVersions":{"http":{"method":"GET","requestUri":"/slottypes/{name}/versions/","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"slotTypes":{"shape":"S3i"},"nextToken":{}}}},"GetSlotTypes":{"http":{"method":"GET","requestUri":"/slottypes/","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"slotTypes":{"shape":"S3i"},"nextToken":{}}}},"GetUtterancesView":{"http":{"method":"GET","requestUri":"/bots/{botname}/utterances?view=aggregation","responseCode":200},"input":{"type":"structure","required":["botName","botVersions","statusType"],"members":{"botName":{"location":"uri","locationName":"botname"},"botVersions":{"location":"querystring","locationName":"bot_versions","type":"list","member":{}},"statusType":{"location":"querystring","locationName":"status_type"}}},"output":{"type":"structure","members":{"botName":{},"utterances":{"type":"list","member":{"type":"structure","members":{"botVersion":{},"utterances":{"type":"list","member":{"type":"structure","members":{"utteranceString":{},"count":{"type":"integer"},"distinctUsers":{"type":"integer"},"firstUtteredDate":{"type":"timestamp"},"lastUtteredDate":{"type":"timestamp"}}}}}}}}}},"PutBot":{"http":{"method":"PUT","requestUri":"/bots/{name}/versions/$LATEST","responseCode":200},"input":{"type":"structure","required":["name","locale","childDirected"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"intents":{"shape":"S6"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Si"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"processBehavior":{},"locale":{},"childDirected":{"type":"boolean"},"createVersion":{"type":"boolean"}}},"output":{"type":"structure","members":{"name":{},"description":{},"intents":{"shape":"S6"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Si"},"status":{},"failureReason":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"version":{},"locale":{},"childDirected":{"type":"boolean"},"createVersion":{"type":"boolean"}}}},"PutBotAlias":{"http":{"method":"PUT","requestUri":"/bots/{botName}/aliases/{name}","responseCode":200},"input":{"type":"structure","required":["name","botVersion","botName"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"botVersion":{},"botName":{"location":"uri","locationName":"botName"},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"botVersion":{},"botName":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"checksum":{}}}},"PutIntent":{"http":{"method":"PUT","requestUri":"/intents/{name}/versions/$LATEST","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"slots":{"shape":"Sq"},"sampleUtterances":{"shape":"Sy"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"},"followUpPrompt":{"shape":"Sz"},"conclusionStatement":{"shape":"Si"},"dialogCodeHook":{"shape":"S10"},"fulfillmentActivity":{"shape":"S13"},"parentIntentSignature":{},"checksum":{},"createVersion":{"type":"boolean"}}},"output":{"type":"structure","members":{"name":{},"description":{},"slots":{"shape":"Sq"},"sampleUtterances":{"shape":"Sy"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"},"followUpPrompt":{"shape":"Sz"},"conclusionStatement":{"shape":"Si"},"dialogCodeHook":{"shape":"S10"},"fulfillmentActivity":{"shape":"S13"},"parentIntentSignature":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"createVersion":{"type":"boolean"}}}},"PutSlotType":{"http":{"method":"PUT","requestUri":"/slottypes/{name}/versions/$LATEST","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"enumerationValues":{"shape":"S19"},"checksum":{},"valueSelectionStrategy":{},"createVersion":{"type":"boolean"}}},"output":{"type":"structure","members":{"name":{},"description":{},"enumerationValues":{"shape":"S19"},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"valueSelectionStrategy":{},"createVersion":{"type":"boolean"}}}},"StartImport":{"http":{"requestUri":"/imports/","responseCode":201},"input":{"type":"structure","required":["payload","resourceType","mergeStrategy"],"members":{"payload":{"type":"blob"},"resourceType":{},"mergeStrategy":{}}},"output":{"type":"structure","members":{"name":{},"resourceType":{},"mergeStrategy":{},"importId":{},"importStatus":{},"createdDate":{"type":"timestamp"}}}}},"shapes":{"S6":{"type":"list","member":{"type":"structure","required":["intentName","intentVersion"],"members":{"intentName":{},"intentVersion":{}}}},"Sa":{"type":"structure","required":["messages","maxAttempts"],"members":{"messages":{"shape":"Sb"},"maxAttempts":{"type":"integer"},"responseCard":{}}},"Sb":{"type":"list","member":{"type":"structure","required":["contentType","content"],"members":{"contentType":{},"content":{},"groupNumber":{"type":"integer"}}}},"Si":{"type":"structure","required":["messages"],"members":{"messages":{"shape":"Sb"},"responseCard":{}}},"Sq":{"type":"list","member":{"type":"structure","required":["name","slotConstraint"],"members":{"name":{},"description":{},"slotConstraint":{},"slotType":{},"slotTypeVersion":{},"valueElicitationPrompt":{"shape":"Sa"},"priority":{"type":"integer"},"sampleUtterances":{"type":"list","member":{}},"responseCard":{}}}},"Sy":{"type":"list","member":{}},"Sz":{"type":"structure","required":["prompt","rejectionStatement"],"members":{"prompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"}}},"S10":{"type":"structure","required":["uri","messageVersion"],"members":{"uri":{},"messageVersion":{}}},"S13":{"type":"structure","required":["type"],"members":{"type":{},"codeHook":{"shape":"S10"}}},"S19":{"type":"list","member":{"type":"structure","required":["value"],"members":{"value":{},"synonyms":{"type":"list","member":{}}}}},"S24":{"type":"map","key":{},"value":{},"sensitive":true},"S2d":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"status":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{}}}},"S2j":{"type":"list","member":{}},"S3a":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{}}}},"S3i":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{}}}}}}');

});

parcelRequire.register("dIOu3", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"GetBotAliases":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBotChannelAssociations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBotVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBots":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBuiltinIntents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBuiltinSlotTypes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetIntentVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetIntents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetSlotTypeVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetSlotTypes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}');

});


parcelRequire.register("cIgpK", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $941653a022a483a9$var$Service = $dbC7k.Service;
var $941653a022a483a9$var$apiLoader = $dbC7k.apiLoader;
$941653a022a483a9$var$apiLoader.services["marketplaceentitlementservice"] = {};
$dbC7k.MarketplaceEntitlementService = $941653a022a483a9$var$Service.defineService("marketplaceentitlementservice", [
    "2017-01-11"
]);


Object.defineProperty($941653a022a483a9$var$apiLoader.services["marketplaceentitlementservice"], "2017-01-11", {
    get: function get() {
        var model = (parcelRequire("ibEVy"));
        model.paginators = (parcelRequire("6lonc")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.MarketplaceEntitlementService;

});
parcelRequire.register("ibEVy", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-01-11","endpointPrefix":"entitlement.marketplace","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Marketplace Entitlement Service","serviceId":"Marketplace Entitlement Service","signatureVersion":"v4","signingName":"aws-marketplace","targetPrefix":"AWSMPEntitlementService","uid":"entitlement.marketplace-2017-01-11"},"operations":{"GetEntitlements":{"input":{"type":"structure","required":["ProductCode"],"members":{"ProductCode":{},"Filter":{"type":"map","key":{},"value":{"type":"list","member":{}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Entitlements":{"type":"list","member":{"type":"structure","members":{"ProductCode":{},"Dimension":{},"CustomerIdentifier":{},"Value":{"type":"structure","members":{"IntegerValue":{"type":"integer"},"DoubleValue":{"type":"double"},"BooleanValue":{"type":"boolean"},"StringValue":{}}},"ExpirationDate":{"type":"timestamp"}}}},"NextToken":{}}}}},"shapes":{}}');

});

parcelRequire.register("6lonc", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("8qyF3", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $622ba36b568fb28f$var$Service = $dbC7k.Service;
var $622ba36b568fb28f$var$apiLoader = $dbC7k.apiLoader;
$622ba36b568fb28f$var$apiLoader.services["athena"] = {};
$dbC7k.Athena = $622ba36b568fb28f$var$Service.defineService("athena", [
    "2017-05-18"
]);


Object.defineProperty($622ba36b568fb28f$var$apiLoader.services["athena"], "2017-05-18", {
    get: function get() {
        var model = (parcelRequire("1cigN"));
        model.paginators = (parcelRequire("lwbmc")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Athena;

});
parcelRequire.register("1cigN", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-05-18","endpointPrefix":"athena","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Athena","serviceId":"Athena","signatureVersion":"v4","targetPrefix":"AmazonAthena","uid":"athena-2017-05-18"},"operations":{"BatchGetNamedQuery":{"input":{"type":"structure","required":["NamedQueryIds"],"members":{"NamedQueryIds":{"shape":"S2"}}},"output":{"type":"structure","members":{"NamedQueries":{"type":"list","member":{"shape":"S6"}},"UnprocessedNamedQueryIds":{"type":"list","member":{"type":"structure","members":{"NamedQueryId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"BatchGetQueryExecution":{"input":{"type":"structure","required":["QueryExecutionIds"],"members":{"QueryExecutionIds":{"shape":"Sh"}}},"output":{"type":"structure","members":{"QueryExecutions":{"type":"list","member":{"shape":"Sl"}},"UnprocessedQueryExecutionIds":{"type":"list","member":{"type":"structure","members":{"QueryExecutionId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"CreateNamedQuery":{"input":{"type":"structure","required":["Name","Database","QueryString"],"members":{"Name":{},"Description":{},"Database":{},"QueryString":{},"ClientRequestToken":{"idempotencyToken":true},"WorkGroup":{}}},"output":{"type":"structure","members":{"NamedQueryId":{}}},"idempotent":true},"CreateWorkGroup":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Configuration":{"shape":"S13"},"Description":{},"Tags":{"shape":"S17"}}},"output":{"type":"structure","members":{}}},"DeleteNamedQuery":{"input":{"type":"structure","required":["NamedQueryId"],"members":{"NamedQueryId":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteWorkGroup":{"input":{"type":"structure","required":["WorkGroup"],"members":{"WorkGroup":{},"RecursiveDeleteOption":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"GetNamedQuery":{"input":{"type":"structure","required":["NamedQueryId"],"members":{"NamedQueryId":{}}},"output":{"type":"structure","members":{"NamedQuery":{"shape":"S6"}}}},"GetQueryExecution":{"input":{"type":"structure","required":["QueryExecutionId"],"members":{"QueryExecutionId":{}}},"output":{"type":"structure","members":{"QueryExecution":{"shape":"Sl"}}}},"GetQueryResults":{"input":{"type":"structure","required":["QueryExecutionId"],"members":{"QueryExecutionId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"UpdateCount":{"type":"long"},"ResultSet":{"type":"structure","members":{"Rows":{"type":"list","member":{"type":"structure","members":{"Data":{"type":"list","member":{"type":"structure","members":{"VarCharValue":{}}}}}}},"ResultSetMetadata":{"type":"structure","members":{"ColumnInfo":{"type":"list","member":{"type":"structure","required":["Name","Type"],"members":{"CatalogName":{},"SchemaName":{},"TableName":{},"Name":{},"Label":{},"Type":{},"Precision":{"type":"integer"},"Scale":{"type":"integer"},"Nullable":{},"CaseSensitive":{"type":"boolean"}}}}}}}},"NextToken":{}}}},"GetWorkGroup":{"input":{"type":"structure","required":["WorkGroup"],"members":{"WorkGroup":{}}},"output":{"type":"structure","members":{"WorkGroup":{"type":"structure","required":["Name"],"members":{"Name":{},"State":{},"Configuration":{"shape":"S13"},"Description":{},"CreationTime":{"type":"timestamp"}}}}}},"ListNamedQueries":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"WorkGroup":{}}},"output":{"type":"structure","members":{"NamedQueryIds":{"shape":"S2"},"NextToken":{}}}},"ListQueryExecutions":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"WorkGroup":{}}},"output":{"type":"structure","members":{"QueryExecutionIds":{"shape":"Sh"},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S17"},"NextToken":{}}}},"ListWorkGroups":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"WorkGroups":{"type":"list","member":{"type":"structure","members":{"Name":{},"State":{},"Description":{},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"StartQueryExecution":{"input":{"type":"structure","required":["QueryString"],"members":{"QueryString":{},"ClientRequestToken":{"idempotencyToken":true},"QueryExecutionContext":{"shape":"Sr"},"ResultConfiguration":{"shape":"Sn"},"WorkGroup":{}}},"output":{"type":"structure","members":{"QueryExecutionId":{}}},"idempotent":true},"StopQueryExecution":{"input":{"type":"structure","required":["QueryExecutionId"],"members":{"QueryExecutionId":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}},"idempotent":true},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S17"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateWorkGroup":{"input":{"type":"structure","required":["WorkGroup"],"members":{"WorkGroup":{},"Description":{},"ConfigurationUpdates":{"type":"structure","members":{"EnforceWorkGroupConfiguration":{"type":"boolean"},"ResultConfigurationUpdates":{"type":"structure","members":{"OutputLocation":{},"RemoveOutputLocation":{"type":"boolean"},"EncryptionConfiguration":{"shape":"Sp"},"RemoveEncryptionConfiguration":{"type":"boolean"}}},"PublishCloudWatchMetricsEnabled":{"type":"boolean"},"BytesScannedCutoffPerQuery":{"type":"long"},"RemoveBytesScannedCutoffPerQuery":{"type":"boolean"},"RequesterPaysEnabled":{"type":"boolean"}}},"State":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S2":{"type":"list","member":{}},"S6":{"type":"structure","required":["Name","Database","QueryString"],"members":{"Name":{},"Description":{},"Database":{},"QueryString":{},"NamedQueryId":{},"WorkGroup":{}}},"Sh":{"type":"list","member":{}},"Sl":{"type":"structure","members":{"QueryExecutionId":{},"Query":{},"StatementType":{},"ResultConfiguration":{"shape":"Sn"},"QueryExecutionContext":{"shape":"Sr"},"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{},"SubmissionDateTime":{"type":"timestamp"},"CompletionDateTime":{"type":"timestamp"}}},"Statistics":{"type":"structure","members":{"EngineExecutionTimeInMillis":{"type":"long"},"DataScannedInBytes":{"type":"long"}}},"WorkGroup":{}}},"Sn":{"type":"structure","members":{"OutputLocation":{},"EncryptionConfiguration":{"shape":"Sp"}}},"Sp":{"type":"structure","required":["EncryptionOption"],"members":{"EncryptionOption":{},"KmsKey":{}}},"Sr":{"type":"structure","members":{"Database":{}}},"S13":{"type":"structure","members":{"ResultConfiguration":{"shape":"Sn"},"EnforceWorkGroupConfiguration":{"type":"boolean"},"PublishCloudWatchMetricsEnabled":{"type":"boolean"},"BytesScannedCutoffPerQuery":{"type":"long"},"RequesterPaysEnabled":{"type":"boolean"}}},"S17":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}');

});

parcelRequire.register("lwbmc", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"GetQueryResults":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListNamedQueries":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListQueryExecutions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWorkGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("5wQjN", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $4068863ff0ea4e7d$var$Service = $dbC7k.Service;
var $4068863ff0ea4e7d$var$apiLoader = $dbC7k.apiLoader;
$4068863ff0ea4e7d$var$apiLoader.services["greengrass"] = {};
$dbC7k.Greengrass = $4068863ff0ea4e7d$var$Service.defineService("greengrass", [
    "2017-06-07"
]);

Object.defineProperty($4068863ff0ea4e7d$var$apiLoader.services["greengrass"], "2017-06-07", {
    get: function get() {
        var model = (parcelRequire("607sQ"));
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Greengrass;

});
parcelRequire.register("607sQ", function(module, exports) {
module.exports = JSON.parse('{"metadata":{"apiVersion":"2017-06-07","endpointPrefix":"greengrass","signingName":"greengrass","serviceFullName":"AWS Greengrass","serviceId":"Greengrass","protocol":"rest-json","jsonVersion":"1.1","uid":"greengrass-2017-06-07","signatureVersion":"v4"},"operations":{"AssociateRoleToGroup":{"http":{"method":"PUT","requestUri":"/greengrass/groups/{GroupId}/role","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"},"RoleArn":{}},"required":["GroupId","RoleArn"]},"output":{"type":"structure","members":{"AssociatedAt":{}}}},"AssociateServiceRoleToAccount":{"http":{"method":"PUT","requestUri":"/greengrass/servicerole","responseCode":200},"input":{"type":"structure","members":{"RoleArn":{}},"required":["RoleArn"]},"output":{"type":"structure","members":{"AssociatedAt":{}}}},"CreateConnectorDefinition":{"http":{"requestUri":"/greengrass/definition/connectors","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"InitialVersion":{"shape":"S7"},"Name":{},"tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{}}}},"CreateConnectorDefinitionVersion":{"http":{"requestUri":"/greengrass/definition/connectors/{ConnectorDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"ConnectorDefinitionId":{"location":"uri","locationName":"ConnectorDefinitionId"},"Connectors":{"shape":"S8"}},"required":["ConnectorDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"Version":{}}}},"CreateCoreDefinition":{"http":{"requestUri":"/greengrass/definition/cores","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"InitialVersion":{"shape":"Sg"},"Name":{},"tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{}}}},"CreateCoreDefinitionVersion":{"http":{"requestUri":"/greengrass/definition/cores/{CoreDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"CoreDefinitionId":{"location":"uri","locationName":"CoreDefinitionId"},"Cores":{"shape":"Sh"}},"required":["CoreDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"Version":{}}}},"CreateDeployment":{"http":{"requestUri":"/greengrass/groups/{GroupId}/deployments","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"DeploymentId":{},"DeploymentType":{},"GroupId":{"location":"uri","locationName":"GroupId"},"GroupVersionId":{}},"required":["GroupId","DeploymentType"]},"output":{"type":"structure","members":{"DeploymentArn":{},"DeploymentId":{}}}},"CreateDeviceDefinition":{"http":{"requestUri":"/greengrass/definition/devices","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"InitialVersion":{"shape":"Sr"},"Name":{},"tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{}}}},"CreateDeviceDefinitionVersion":{"http":{"requestUri":"/greengrass/definition/devices/{DeviceDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"DeviceDefinitionId":{"location":"uri","locationName":"DeviceDefinitionId"},"Devices":{"shape":"Ss"}},"required":["DeviceDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"Version":{}}}},"CreateFunctionDefinition":{"http":{"requestUri":"/greengrass/definition/functions","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"InitialVersion":{"shape":"Sy"},"Name":{},"tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{}}}},"CreateFunctionDefinitionVersion":{"http":{"requestUri":"/greengrass/definition/functions/{FunctionDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"DefaultConfig":{"shape":"Sz"},"FunctionDefinitionId":{"location":"uri","locationName":"FunctionDefinitionId"},"Functions":{"shape":"S14"}},"required":["FunctionDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"Version":{}}}},"CreateGroup":{"http":{"requestUri":"/greengrass/groups","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"InitialVersion":{"shape":"S1h"},"Name":{},"tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{}}}},"CreateGroupCertificateAuthority":{"http":{"requestUri":"/greengrass/groups/{GroupId}/certificateauthorities","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["GroupId"]},"output":{"type":"structure","members":{"GroupCertificateAuthorityArn":{}}}},"CreateGroupVersion":{"http":{"requestUri":"/greengrass/groups/{GroupId}/versions","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"ConnectorDefinitionVersionArn":{},"CoreDefinitionVersionArn":{},"DeviceDefinitionVersionArn":{},"FunctionDefinitionVersionArn":{},"GroupId":{"location":"uri","locationName":"GroupId"},"LoggerDefinitionVersionArn":{},"ResourceDefinitionVersionArn":{},"SubscriptionDefinitionVersionArn":{}},"required":["GroupId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"Version":{}}}},"CreateLoggerDefinition":{"http":{"requestUri":"/greengrass/definition/loggers","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"InitialVersion":{"shape":"S1o"},"Name":{},"tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{}}}},"CreateLoggerDefinitionVersion":{"http":{"requestUri":"/greengrass/definition/loggers/{LoggerDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"LoggerDefinitionId":{"location":"uri","locationName":"LoggerDefinitionId"},"Loggers":{"shape":"S1p"}},"required":["LoggerDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"Version":{}}}},"CreateResourceDefinition":{"http":{"requestUri":"/greengrass/definition/resources","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"InitialVersion":{"shape":"S1y"},"Name":{},"tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{}}}},"CreateResourceDefinitionVersion":{"http":{"requestUri":"/greengrass/definition/resources/{ResourceDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"ResourceDefinitionId":{"location":"uri","locationName":"ResourceDefinitionId"},"Resources":{"shape":"S1z"}},"required":["ResourceDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"Version":{}}}},"CreateSoftwareUpdateJob":{"http":{"requestUri":"/greengrass/updates","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"S3UrlSignerRole":{},"SoftwareToUpdate":{},"UpdateAgentLogLevel":{},"UpdateTargets":{"type":"list","member":{}},"UpdateTargetsArchitecture":{},"UpdateTargetsOperatingSystem":{}},"required":["S3UrlSignerRole","UpdateTargetsArchitecture","SoftwareToUpdate","UpdateTargets","UpdateTargetsOperatingSystem"]},"output":{"type":"structure","members":{"IotJobArn":{},"IotJobId":{}}}},"CreateSubscriptionDefinition":{"http":{"requestUri":"/greengrass/definition/subscriptions","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"InitialVersion":{"shape":"S2l"},"Name":{},"tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{}}}},"CreateSubscriptionDefinitionVersion":{"http":{"requestUri":"/greengrass/definition/subscriptions/{SubscriptionDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"SubscriptionDefinitionId":{"location":"uri","locationName":"SubscriptionDefinitionId"},"Subscriptions":{"shape":"S2m"}},"required":["SubscriptionDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"Version":{}}}},"DeleteConnectorDefinition":{"http":{"method":"DELETE","requestUri":"/greengrass/definition/connectors/{ConnectorDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"ConnectorDefinitionId":{"location":"uri","locationName":"ConnectorDefinitionId"}},"required":["ConnectorDefinitionId"]},"output":{"type":"structure","members":{}}},"DeleteCoreDefinition":{"http":{"method":"DELETE","requestUri":"/greengrass/definition/cores/{CoreDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"CoreDefinitionId":{"location":"uri","locationName":"CoreDefinitionId"}},"required":["CoreDefinitionId"]},"output":{"type":"structure","members":{}}},"DeleteDeviceDefinition":{"http":{"method":"DELETE","requestUri":"/greengrass/definition/devices/{DeviceDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"DeviceDefinitionId":{"location":"uri","locationName":"DeviceDefinitionId"}},"required":["DeviceDefinitionId"]},"output":{"type":"structure","members":{}}},"DeleteFunctionDefinition":{"http":{"method":"DELETE","requestUri":"/greengrass/definition/functions/{FunctionDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"FunctionDefinitionId":{"location":"uri","locationName":"FunctionDefinitionId"}},"required":["FunctionDefinitionId"]},"output":{"type":"structure","members":{}}},"DeleteGroup":{"http":{"method":"DELETE","requestUri":"/greengrass/groups/{GroupId}","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["GroupId"]},"output":{"type":"structure","members":{}}},"DeleteLoggerDefinition":{"http":{"method":"DELETE","requestUri":"/greengrass/definition/loggers/{LoggerDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"LoggerDefinitionId":{"location":"uri","locationName":"LoggerDefinitionId"}},"required":["LoggerDefinitionId"]},"output":{"type":"structure","members":{}}},"DeleteResourceDefinition":{"http":{"method":"DELETE","requestUri":"/greengrass/definition/resources/{ResourceDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"ResourceDefinitionId":{"location":"uri","locationName":"ResourceDefinitionId"}},"required":["ResourceDefinitionId"]},"output":{"type":"structure","members":{}}},"DeleteSubscriptionDefinition":{"http":{"method":"DELETE","requestUri":"/greengrass/definition/subscriptions/{SubscriptionDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"SubscriptionDefinitionId":{"location":"uri","locationName":"SubscriptionDefinitionId"}},"required":["SubscriptionDefinitionId"]},"output":{"type":"structure","members":{}}},"DisassociateRoleFromGroup":{"http":{"method":"DELETE","requestUri":"/greengrass/groups/{GroupId}/role","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["GroupId"]},"output":{"type":"structure","members":{"DisassociatedAt":{}}}},"DisassociateServiceRoleFromAccount":{"http":{"method":"DELETE","requestUri":"/greengrass/servicerole","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"DisassociatedAt":{}}}},"GetAssociatedRole":{"http":{"method":"GET","requestUri":"/greengrass/groups/{GroupId}/role","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["GroupId"]},"output":{"type":"structure","members":{"AssociatedAt":{},"RoleArn":{}}}},"GetBulkDeploymentStatus":{"http":{"method":"GET","requestUri":"/greengrass/bulk/deployments/{BulkDeploymentId}/status","responseCode":200},"input":{"type":"structure","members":{"BulkDeploymentId":{"location":"uri","locationName":"BulkDeploymentId"}},"required":["BulkDeploymentId"]},"output":{"type":"structure","members":{"BulkDeploymentMetrics":{"type":"structure","members":{"InvalidInputRecords":{"type":"integer"},"RecordsProcessed":{"type":"integer"},"RetryAttempts":{"type":"integer"}}},"BulkDeploymentStatus":{},"CreatedAt":{},"ErrorDetails":{"shape":"S3h"},"ErrorMessage":{},"tags":{"shape":"Sb"}}}},"GetConnectivityInfo":{"http":{"method":"GET","requestUri":"/greengrass/things/{ThingName}/connectivityInfo","responseCode":200},"input":{"type":"structure","members":{"ThingName":{"location":"uri","locationName":"ThingName"}},"required":["ThingName"]},"output":{"type":"structure","members":{"ConnectivityInfo":{"shape":"S3l"},"Message":{"locationName":"message"}}}},"GetConnectorDefinition":{"http":{"method":"GET","requestUri":"/greengrass/definition/connectors/{ConnectorDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"ConnectorDefinitionId":{"location":"uri","locationName":"ConnectorDefinitionId"}},"required":["ConnectorDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{},"tags":{"shape":"Sb"}}}},"GetConnectorDefinitionVersion":{"http":{"method":"GET","requestUri":"/greengrass/definition/connectors/{ConnectorDefinitionId}/versions/{ConnectorDefinitionVersionId}","responseCode":200},"input":{"type":"structure","members":{"ConnectorDefinitionId":{"location":"uri","locationName":"ConnectorDefinitionId"},"ConnectorDefinitionVersionId":{"location":"uri","locationName":"ConnectorDefinitionVersionId"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["ConnectorDefinitionId","ConnectorDefinitionVersionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Definition":{"shape":"S7"},"Id":{},"NextToken":{},"Version":{}}}},"GetCoreDefinition":{"http":{"method":"GET","requestUri":"/greengrass/definition/cores/{CoreDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"CoreDefinitionId":{"location":"uri","locationName":"CoreDefinitionId"}},"required":["CoreDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{},"tags":{"shape":"Sb"}}}},"GetCoreDefinitionVersion":{"http":{"method":"GET","requestUri":"/greengrass/definition/cores/{CoreDefinitionId}/versions/{CoreDefinitionVersionId}","responseCode":200},"input":{"type":"structure","members":{"CoreDefinitionId":{"location":"uri","locationName":"CoreDefinitionId"},"CoreDefinitionVersionId":{"location":"uri","locationName":"CoreDefinitionVersionId"}},"required":["CoreDefinitionId","CoreDefinitionVersionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Definition":{"shape":"Sg"},"Id":{},"NextToken":{},"Version":{}}}},"GetDeploymentStatus":{"http":{"method":"GET","requestUri":"/greengrass/groups/{GroupId}/deployments/{DeploymentId}/status","responseCode":200},"input":{"type":"structure","members":{"DeploymentId":{"location":"uri","locationName":"DeploymentId"},"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["GroupId","DeploymentId"]},"output":{"type":"structure","members":{"DeploymentStatus":{},"DeploymentType":{},"ErrorDetails":{"shape":"S3h"},"ErrorMessage":{},"UpdatedAt":{}}}},"GetDeviceDefinition":{"http":{"method":"GET","requestUri":"/greengrass/definition/devices/{DeviceDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"DeviceDefinitionId":{"location":"uri","locationName":"DeviceDefinitionId"}},"required":["DeviceDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{},"tags":{"shape":"Sb"}}}},"GetDeviceDefinitionVersion":{"http":{"method":"GET","requestUri":"/greengrass/definition/devices/{DeviceDefinitionId}/versions/{DeviceDefinitionVersionId}","responseCode":200},"input":{"type":"structure","members":{"DeviceDefinitionId":{"location":"uri","locationName":"DeviceDefinitionId"},"DeviceDefinitionVersionId":{"location":"uri","locationName":"DeviceDefinitionVersionId"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["DeviceDefinitionVersionId","DeviceDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Definition":{"shape":"Sr"},"Id":{},"NextToken":{},"Version":{}}}},"GetFunctionDefinition":{"http":{"method":"GET","requestUri":"/greengrass/definition/functions/{FunctionDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"FunctionDefinitionId":{"location":"uri","locationName":"FunctionDefinitionId"}},"required":["FunctionDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{},"tags":{"shape":"Sb"}}}},"GetFunctionDefinitionVersion":{"http":{"method":"GET","requestUri":"/greengrass/definition/functions/{FunctionDefinitionId}/versions/{FunctionDefinitionVersionId}","responseCode":200},"input":{"type":"structure","members":{"FunctionDefinitionId":{"location":"uri","locationName":"FunctionDefinitionId"},"FunctionDefinitionVersionId":{"location":"uri","locationName":"FunctionDefinitionVersionId"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["FunctionDefinitionId","FunctionDefinitionVersionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Definition":{"shape":"Sy"},"Id":{},"NextToken":{},"Version":{}}}},"GetGroup":{"http":{"method":"GET","requestUri":"/greengrass/groups/{GroupId}","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["GroupId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{},"tags":{"shape":"Sb"}}}},"GetGroupCertificateAuthority":{"http":{"method":"GET","requestUri":"/greengrass/groups/{GroupId}/certificateauthorities/{CertificateAuthorityId}","responseCode":200},"input":{"type":"structure","members":{"CertificateAuthorityId":{"location":"uri","locationName":"CertificateAuthorityId"},"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["CertificateAuthorityId","GroupId"]},"output":{"type":"structure","members":{"GroupCertificateAuthorityArn":{},"GroupCertificateAuthorityId":{},"PemEncodedCertificate":{}}}},"GetGroupCertificateConfiguration":{"http":{"method":"GET","requestUri":"/greengrass/groups/{GroupId}/certificateauthorities/configuration/expiry","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["GroupId"]},"output":{"type":"structure","members":{"CertificateAuthorityExpiryInMilliseconds":{},"CertificateExpiryInMilliseconds":{},"GroupId":{}}}},"GetGroupVersion":{"http":{"method":"GET","requestUri":"/greengrass/groups/{GroupId}/versions/{GroupVersionId}","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"},"GroupVersionId":{"location":"uri","locationName":"GroupVersionId"}},"required":["GroupVersionId","GroupId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Definition":{"shape":"S1h"},"Id":{},"Version":{}}}},"GetLoggerDefinition":{"http":{"method":"GET","requestUri":"/greengrass/definition/loggers/{LoggerDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"LoggerDefinitionId":{"location":"uri","locationName":"LoggerDefinitionId"}},"required":["LoggerDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{},"tags":{"shape":"Sb"}}}},"GetLoggerDefinitionVersion":{"http":{"method":"GET","requestUri":"/greengrass/definition/loggers/{LoggerDefinitionId}/versions/{LoggerDefinitionVersionId}","responseCode":200},"input":{"type":"structure","members":{"LoggerDefinitionId":{"location":"uri","locationName":"LoggerDefinitionId"},"LoggerDefinitionVersionId":{"location":"uri","locationName":"LoggerDefinitionVersionId"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["LoggerDefinitionVersionId","LoggerDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Definition":{"shape":"S1o"},"Id":{},"Version":{}}}},"GetResourceDefinition":{"http":{"method":"GET","requestUri":"/greengrass/definition/resources/{ResourceDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"ResourceDefinitionId":{"location":"uri","locationName":"ResourceDefinitionId"}},"required":["ResourceDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{},"tags":{"shape":"Sb"}}}},"GetResourceDefinitionVersion":{"http":{"method":"GET","requestUri":"/greengrass/definition/resources/{ResourceDefinitionId}/versions/{ResourceDefinitionVersionId}","responseCode":200},"input":{"type":"structure","members":{"ResourceDefinitionId":{"location":"uri","locationName":"ResourceDefinitionId"},"ResourceDefinitionVersionId":{"location":"uri","locationName":"ResourceDefinitionVersionId"}},"required":["ResourceDefinitionVersionId","ResourceDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Definition":{"shape":"S1y"},"Id":{},"Version":{}}}},"GetServiceRoleForAccount":{"http":{"method":"GET","requestUri":"/greengrass/servicerole","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AssociatedAt":{},"RoleArn":{}}}},"GetSubscriptionDefinition":{"http":{"method":"GET","requestUri":"/greengrass/definition/subscriptions/{SubscriptionDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"SubscriptionDefinitionId":{"location":"uri","locationName":"SubscriptionDefinitionId"}},"required":["SubscriptionDefinitionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{},"tags":{"shape":"Sb"}}}},"GetSubscriptionDefinitionVersion":{"http":{"method":"GET","requestUri":"/greengrass/definition/subscriptions/{SubscriptionDefinitionId}/versions/{SubscriptionDefinitionVersionId}","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"SubscriptionDefinitionId":{"location":"uri","locationName":"SubscriptionDefinitionId"},"SubscriptionDefinitionVersionId":{"location":"uri","locationName":"SubscriptionDefinitionVersionId"}},"required":["SubscriptionDefinitionId","SubscriptionDefinitionVersionId"]},"output":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Definition":{"shape":"S2l"},"Id":{},"NextToken":{},"Version":{}}}},"ListBulkDeploymentDetailedReports":{"http":{"method":"GET","requestUri":"/greengrass/bulk/deployments/{BulkDeploymentId}/detailed-reports","responseCode":200},"input":{"type":"structure","members":{"BulkDeploymentId":{"location":"uri","locationName":"BulkDeploymentId"},"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["BulkDeploymentId"]},"output":{"type":"structure","members":{"Deployments":{"type":"list","member":{"type":"structure","members":{"CreatedAt":{},"DeploymentArn":{},"DeploymentId":{},"DeploymentStatus":{},"DeploymentType":{},"ErrorDetails":{"shape":"S3h"},"ErrorMessage":{},"GroupArn":{}}}},"NextToken":{}}}},"ListBulkDeployments":{"http":{"method":"GET","requestUri":"/greengrass/bulk/deployments","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"BulkDeployments":{"type":"list","member":{"type":"structure","members":{"BulkDeploymentArn":{},"BulkDeploymentId":{},"CreatedAt":{}}}},"NextToken":{}}}},"ListConnectorDefinitionVersions":{"http":{"method":"GET","requestUri":"/greengrass/definition/connectors/{ConnectorDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"ConnectorDefinitionId":{"location":"uri","locationName":"ConnectorDefinitionId"},"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["ConnectorDefinitionId"]},"output":{"type":"structure","members":{"NextToken":{},"Versions":{"shape":"S51"}}}},"ListConnectorDefinitions":{"http":{"method":"GET","requestUri":"/greengrass/definition/connectors","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Definitions":{"shape":"S55"},"NextToken":{}}}},"ListCoreDefinitionVersions":{"http":{"method":"GET","requestUri":"/greengrass/definition/cores/{CoreDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"CoreDefinitionId":{"location":"uri","locationName":"CoreDefinitionId"},"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["CoreDefinitionId"]},"output":{"type":"structure","members":{"NextToken":{},"Versions":{"shape":"S51"}}}},"ListCoreDefinitions":{"http":{"method":"GET","requestUri":"/greengrass/definition/cores","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Definitions":{"shape":"S55"},"NextToken":{}}}},"ListDeployments":{"http":{"method":"GET","requestUri":"/greengrass/groups/{GroupId}/deployments","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"},"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["GroupId"]},"output":{"type":"structure","members":{"Deployments":{"type":"list","member":{"type":"structure","members":{"CreatedAt":{},"DeploymentArn":{},"DeploymentId":{},"DeploymentType":{},"GroupArn":{}}}},"NextToken":{}}}},"ListDeviceDefinitionVersions":{"http":{"method":"GET","requestUri":"/greengrass/definition/devices/{DeviceDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"DeviceDefinitionId":{"location":"uri","locationName":"DeviceDefinitionId"},"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["DeviceDefinitionId"]},"output":{"type":"structure","members":{"NextToken":{},"Versions":{"shape":"S51"}}}},"ListDeviceDefinitions":{"http":{"method":"GET","requestUri":"/greengrass/definition/devices","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Definitions":{"shape":"S55"},"NextToken":{}}}},"ListFunctionDefinitionVersions":{"http":{"method":"GET","requestUri":"/greengrass/definition/functions/{FunctionDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"FunctionDefinitionId":{"location":"uri","locationName":"FunctionDefinitionId"},"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["FunctionDefinitionId"]},"output":{"type":"structure","members":{"NextToken":{},"Versions":{"shape":"S51"}}}},"ListFunctionDefinitions":{"http":{"method":"GET","requestUri":"/greengrass/definition/functions","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Definitions":{"shape":"S55"},"NextToken":{}}}},"ListGroupCertificateAuthorities":{"http":{"method":"GET","requestUri":"/greengrass/groups/{GroupId}/certificateauthorities","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["GroupId"]},"output":{"type":"structure","members":{"GroupCertificateAuthorities":{"type":"list","member":{"type":"structure","members":{"GroupCertificateAuthorityArn":{},"GroupCertificateAuthorityId":{}}}}}}},"ListGroupVersions":{"http":{"method":"GET","requestUri":"/greengrass/groups/{GroupId}/versions","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"},"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["GroupId"]},"output":{"type":"structure","members":{"NextToken":{},"Versions":{"shape":"S51"}}}},"ListGroups":{"http":{"method":"GET","requestUri":"/greengrass/groups","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Groups":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{}}}},"NextToken":{}}}},"ListLoggerDefinitionVersions":{"http":{"method":"GET","requestUri":"/greengrass/definition/loggers/{LoggerDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"LoggerDefinitionId":{"location":"uri","locationName":"LoggerDefinitionId"},"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"required":["LoggerDefinitionId"]},"output":{"type":"structure","members":{"NextToken":{},"Versions":{"shape":"S51"}}}},"ListLoggerDefinitions":{"http":{"method":"GET","requestUri":"/greengrass/definition/loggers","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Definitions":{"shape":"S55"},"NextToken":{}}}},"ListResourceDefinitionVersions":{"http":{"method":"GET","requestUri":"/greengrass/definition/resources/{ResourceDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"},"ResourceDefinitionId":{"location":"uri","locationName":"ResourceDefinitionId"}},"required":["ResourceDefinitionId"]},"output":{"type":"structure","members":{"NextToken":{},"Versions":{"shape":"S51"}}}},"ListResourceDefinitions":{"http":{"method":"GET","requestUri":"/greengrass/definition/resources","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Definitions":{"shape":"S55"},"NextToken":{}}}},"ListSubscriptionDefinitionVersions":{"http":{"method":"GET","requestUri":"/greengrass/definition/subscriptions/{SubscriptionDefinitionId}/versions","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"},"SubscriptionDefinitionId":{"location":"uri","locationName":"SubscriptionDefinitionId"}},"required":["SubscriptionDefinitionId"]},"output":{"type":"structure","members":{"NextToken":{},"Versions":{"shape":"S51"}}}},"ListSubscriptionDefinitions":{"http":{"method":"GET","requestUri":"/greengrass/definition/subscriptions","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Definitions":{"shape":"S55"},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resource-arn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{"tags":{"shape":"Sb"}}}},"ResetDeployments":{"http":{"requestUri":"/greengrass/groups/{GroupId}/deployments/$reset","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"Force":{"type":"boolean"},"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["GroupId"]},"output":{"type":"structure","members":{"DeploymentArn":{},"DeploymentId":{}}}},"StartBulkDeployment":{"http":{"requestUri":"/greengrass/bulk/deployments","responseCode":200},"input":{"type":"structure","members":{"AmznClientToken":{"location":"header","locationName":"X-Amzn-Client-Token"},"ExecutionRoleArn":{},"InputFileUri":{},"tags":{"shape":"Sb"}},"required":["ExecutionRoleArn","InputFileUri"]},"output":{"type":"structure","members":{"BulkDeploymentArn":{},"BulkDeploymentId":{}}}},"StopBulkDeployment":{"http":{"method":"PUT","requestUri":"/greengrass/bulk/deployments/{BulkDeploymentId}/$stop","responseCode":200},"input":{"type":"structure","members":{"BulkDeploymentId":{"location":"uri","locationName":"BulkDeploymentId"}},"required":["BulkDeploymentId"]},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"requestUri":"/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"tags":{"shape":"Sb"}},"required":["ResourceArn"]}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"TagKeys":{"shape":"S28","location":"querystring","locationName":"tagKeys"}},"required":["TagKeys","ResourceArn"]}},"UpdateConnectivityInfo":{"http":{"method":"PUT","requestUri":"/greengrass/things/{ThingName}/connectivityInfo","responseCode":200},"input":{"type":"structure","members":{"ConnectivityInfo":{"shape":"S3l"},"ThingName":{"location":"uri","locationName":"ThingName"}},"required":["ThingName"]},"output":{"type":"structure","members":{"Message":{"locationName":"message"},"Version":{}}}},"UpdateConnectorDefinition":{"http":{"method":"PUT","requestUri":"/greengrass/definition/connectors/{ConnectorDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"ConnectorDefinitionId":{"location":"uri","locationName":"ConnectorDefinitionId"},"Name":{}},"required":["ConnectorDefinitionId"]},"output":{"type":"structure","members":{}}},"UpdateCoreDefinition":{"http":{"method":"PUT","requestUri":"/greengrass/definition/cores/{CoreDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"CoreDefinitionId":{"location":"uri","locationName":"CoreDefinitionId"},"Name":{}},"required":["CoreDefinitionId"]},"output":{"type":"structure","members":{}}},"UpdateDeviceDefinition":{"http":{"method":"PUT","requestUri":"/greengrass/definition/devices/{DeviceDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"DeviceDefinitionId":{"location":"uri","locationName":"DeviceDefinitionId"},"Name":{}},"required":["DeviceDefinitionId"]},"output":{"type":"structure","members":{}}},"UpdateFunctionDefinition":{"http":{"method":"PUT","requestUri":"/greengrass/definition/functions/{FunctionDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"FunctionDefinitionId":{"location":"uri","locationName":"FunctionDefinitionId"},"Name":{}},"required":["FunctionDefinitionId"]},"output":{"type":"structure","members":{}}},"UpdateGroup":{"http":{"method":"PUT","requestUri":"/greengrass/groups/{GroupId}","responseCode":200},"input":{"type":"structure","members":{"GroupId":{"location":"uri","locationName":"GroupId"},"Name":{}},"required":["GroupId"]},"output":{"type":"structure","members":{}}},"UpdateGroupCertificateConfiguration":{"http":{"method":"PUT","requestUri":"/greengrass/groups/{GroupId}/certificateauthorities/configuration/expiry","responseCode":200},"input":{"type":"structure","members":{"CertificateExpiryInMilliseconds":{},"GroupId":{"location":"uri","locationName":"GroupId"}},"required":["GroupId"]},"output":{"type":"structure","members":{"CertificateAuthorityExpiryInMilliseconds":{},"CertificateExpiryInMilliseconds":{},"GroupId":{}}}},"UpdateLoggerDefinition":{"http":{"method":"PUT","requestUri":"/greengrass/definition/loggers/{LoggerDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"LoggerDefinitionId":{"location":"uri","locationName":"LoggerDefinitionId"},"Name":{}},"required":["LoggerDefinitionId"]},"output":{"type":"structure","members":{}}},"UpdateResourceDefinition":{"http":{"method":"PUT","requestUri":"/greengrass/definition/resources/{ResourceDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"Name":{},"ResourceDefinitionId":{"location":"uri","locationName":"ResourceDefinitionId"}},"required":["ResourceDefinitionId"]},"output":{"type":"structure","members":{}}},"UpdateSubscriptionDefinition":{"http":{"method":"PUT","requestUri":"/greengrass/definition/subscriptions/{SubscriptionDefinitionId}","responseCode":200},"input":{"type":"structure","members":{"Name":{},"SubscriptionDefinitionId":{"location":"uri","locationName":"SubscriptionDefinitionId"}},"required":["SubscriptionDefinitionId"]},"output":{"type":"structure","members":{}}}},"shapes":{"S7":{"type":"structure","members":{"Connectors":{"shape":"S8"}}},"S8":{"type":"list","member":{"type":"structure","members":{"ConnectorArn":{},"Id":{},"Parameters":{"shape":"Sa"}},"required":["ConnectorArn","Id"]}},"Sa":{"type":"map","key":{},"value":{}},"Sb":{"type":"map","key":{},"value":{}},"Sg":{"type":"structure","members":{"Cores":{"shape":"Sh"}}},"Sh":{"type":"list","member":{"type":"structure","members":{"CertificateArn":{},"Id":{},"SyncShadow":{"type":"boolean"},"ThingArn":{}},"required":["ThingArn","Id","CertificateArn"]}},"Sr":{"type":"structure","members":{"Devices":{"shape":"Ss"}}},"Ss":{"type":"list","member":{"type":"structure","members":{"CertificateArn":{},"Id":{},"SyncShadow":{"type":"boolean"},"ThingArn":{}},"required":["ThingArn","Id","CertificateArn"]}},"Sy":{"type":"structure","members":{"DefaultConfig":{"shape":"Sz"},"Functions":{"shape":"S14"}}},"Sz":{"type":"structure","members":{"Execution":{"type":"structure","members":{"IsolationMode":{},"RunAs":{"shape":"S12"}}}}},"S12":{"type":"structure","members":{"Gid":{"type":"integer"},"Uid":{"type":"integer"}}},"S14":{"type":"list","member":{"type":"structure","members":{"FunctionArn":{},"FunctionConfiguration":{"type":"structure","members":{"EncodingType":{},"Environment":{"type":"structure","members":{"AccessSysfs":{"type":"boolean"},"Execution":{"type":"structure","members":{"IsolationMode":{},"RunAs":{"shape":"S12"}}},"ResourceAccessPolicies":{"type":"list","member":{"type":"structure","members":{"Permission":{},"ResourceId":{}},"required":["ResourceId"]}},"Variables":{"shape":"Sa"}}},"ExecArgs":{},"Executable":{},"MemorySize":{"type":"integer"},"Pinned":{"type":"boolean"},"Timeout":{"type":"integer"}}},"Id":{}},"required":["Id"]}},"S1h":{"type":"structure","members":{"ConnectorDefinitionVersionArn":{},"CoreDefinitionVersionArn":{},"DeviceDefinitionVersionArn":{},"FunctionDefinitionVersionArn":{},"LoggerDefinitionVersionArn":{},"ResourceDefinitionVersionArn":{},"SubscriptionDefinitionVersionArn":{}}},"S1o":{"type":"structure","members":{"Loggers":{"shape":"S1p"}}},"S1p":{"type":"list","member":{"type":"structure","members":{"Component":{},"Id":{},"Level":{},"Space":{"type":"integer"},"Type":{}},"required":["Type","Level","Id","Component"]}},"S1y":{"type":"structure","members":{"Resources":{"shape":"S1z"}}},"S1z":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"ResourceDataContainer":{"type":"structure","members":{"LocalDeviceResourceData":{"type":"structure","members":{"GroupOwnerSetting":{"shape":"S23"},"SourcePath":{}}},"LocalVolumeResourceData":{"type":"structure","members":{"DestinationPath":{},"GroupOwnerSetting":{"shape":"S23"},"SourcePath":{}}},"S3MachineLearningModelResourceData":{"type":"structure","members":{"DestinationPath":{},"S3Uri":{}}},"SageMakerMachineLearningModelResourceData":{"type":"structure","members":{"DestinationPath":{},"SageMakerJobArn":{}}},"SecretsManagerSecretResourceData":{"type":"structure","members":{"ARN":{},"AdditionalStagingLabelsToDownload":{"shape":"S28"}}}}}},"required":["ResourceDataContainer","Id","Name"]}},"S23":{"type":"structure","members":{"AutoAddGroupOwner":{"type":"boolean"},"GroupOwner":{}}},"S28":{"type":"list","member":{}},"S2l":{"type":"structure","members":{"Subscriptions":{"shape":"S2m"}}},"S2m":{"type":"list","member":{"type":"structure","members":{"Id":{},"Source":{},"Subject":{},"Target":{}},"required":["Target","Id","Subject","Source"]}},"S3h":{"type":"list","member":{"type":"structure","members":{"DetailedErrorCode":{},"DetailedErrorMessage":{}}}},"S3l":{"type":"list","member":{"type":"structure","members":{"HostAddress":{},"Id":{},"Metadata":{},"PortNumber":{"type":"integer"}}}},"S51":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"Version":{}}}},"S55":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreationTimestamp":{},"Id":{},"LastUpdatedTimestamp":{},"LatestVersion":{},"LatestVersionArn":{},"Name":{},"Tags":{"shape":"Sb","locationName":"tags"}}}}}}');

});


parcelRequire.register("fi1HW", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $b219dc96af84510b$var$Service = $dbC7k.Service;
var $b219dc96af84510b$var$apiLoader = $dbC7k.apiLoader;
$b219dc96af84510b$var$apiLoader.services["dax"] = {};
$dbC7k.DAX = $b219dc96af84510b$var$Service.defineService("dax", [
    "2017-04-19"
]);


Object.defineProperty($b219dc96af84510b$var$apiLoader.services["dax"], "2017-04-19", {
    get: function get() {
        var model = (parcelRequire("hz65B"));
        model.paginators = (parcelRequire("bSc3g")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.DAX;

});
parcelRequire.register("hz65B", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-04-19","endpointPrefix":"dax","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon DAX","serviceFullName":"Amazon DynamoDB Accelerator (DAX)","serviceId":"DAX","signatureVersion":"v4","targetPrefix":"AmazonDAXV3","uid":"dax-2017-04-19"},"operations":{"CreateCluster":{"input":{"type":"structure","required":["ClusterName","NodeType","ReplicationFactor","IamRoleArn"],"members":{"ClusterName":{},"NodeType":{},"Description":{},"ReplicationFactor":{"type":"integer"},"AvailabilityZones":{"shape":"S4"},"SubnetGroupName":{},"SecurityGroupIds":{"shape":"S5"},"PreferredMaintenanceWindow":{},"NotificationTopicArn":{},"IamRoleArn":{},"ParameterGroupName":{},"Tags":{"shape":"S6"},"SSESpecification":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"}}}}},"output":{"type":"structure","members":{"Cluster":{"shape":"Sb"}}}},"CreateParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{},"Description":{}}},"output":{"type":"structure","members":{"ParameterGroup":{"shape":"Sq"}}}},"CreateSubnetGroup":{"input":{"type":"structure","required":["SubnetGroupName","SubnetIds"],"members":{"SubnetGroupName":{},"Description":{},"SubnetIds":{"shape":"Ss"}}},"output":{"type":"structure","members":{"SubnetGroup":{"shape":"Su"}}}},"DecreaseReplicationFactor":{"input":{"type":"structure","required":["ClusterName","NewReplicationFactor"],"members":{"ClusterName":{},"NewReplicationFactor":{"type":"integer"},"AvailabilityZones":{"shape":"S4"},"NodeIdsToRemove":{"shape":"Se"}}},"output":{"type":"structure","members":{"Cluster":{"shape":"Sb"}}}},"DeleteCluster":{"input":{"type":"structure","required":["ClusterName"],"members":{"ClusterName":{}}},"output":{"type":"structure","members":{"Cluster":{"shape":"Sb"}}}},"DeleteParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{}}},"output":{"type":"structure","members":{"DeletionMessage":{}}}},"DeleteSubnetGroup":{"input":{"type":"structure","required":["SubnetGroupName"],"members":{"SubnetGroupName":{}}},"output":{"type":"structure","members":{"DeletionMessage":{}}}},"DescribeClusters":{"input":{"type":"structure","members":{"ClusterNames":{"type":"list","member":{}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"Clusters":{"type":"list","member":{"shape":"Sb"}}}}},"DescribeDefaultParameters":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"Parameters":{"shape":"S1b"}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceName":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"Events":{"type":"list","member":{"type":"structure","members":{"SourceName":{},"SourceType":{},"Message":{},"Date":{"type":"timestamp"}}}}}}},"DescribeParameterGroups":{"input":{"type":"structure","members":{"ParameterGroupNames":{"type":"list","member":{}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"ParameterGroups":{"type":"list","member":{"shape":"Sq"}}}}},"DescribeParameters":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{},"Source":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"Parameters":{"shape":"S1b"}}}},"DescribeSubnetGroups":{"input":{"type":"structure","members":{"SubnetGroupNames":{"type":"list","member":{}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"SubnetGroups":{"type":"list","member":{"shape":"Su"}}}}},"IncreaseReplicationFactor":{"input":{"type":"structure","required":["ClusterName","NewReplicationFactor"],"members":{"ClusterName":{},"NewReplicationFactor":{"type":"integer"},"AvailabilityZones":{"shape":"S4"}}},"output":{"type":"structure","members":{"Cluster":{"shape":"Sb"}}}},"ListTags":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S6"},"NextToken":{}}}},"RebootNode":{"input":{"type":"structure","required":["ClusterName","NodeId"],"members":{"ClusterName":{},"NodeId":{}}},"output":{"type":"structure","members":{"Cluster":{"shape":"Sb"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S6"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S6"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"Tags":{"shape":"S6"}}}},"UpdateCluster":{"input":{"type":"structure","required":["ClusterName"],"members":{"ClusterName":{},"Description":{},"PreferredMaintenanceWindow":{},"NotificationTopicArn":{},"NotificationTopicStatus":{},"ParameterGroupName":{},"SecurityGroupIds":{"shape":"S5"}}},"output":{"type":"structure","members":{"Cluster":{"shape":"Sb"}}}},"UpdateParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName","ParameterNameValues"],"members":{"ParameterGroupName":{},"ParameterNameValues":{"type":"list","member":{"type":"structure","members":{"ParameterName":{},"ParameterValue":{}}}}}},"output":{"type":"structure","members":{"ParameterGroup":{"shape":"Sq"}}}},"UpdateSubnetGroup":{"input":{"type":"structure","required":["SubnetGroupName"],"members":{"SubnetGroupName":{},"Description":{},"SubnetIds":{"shape":"Ss"}}},"output":{"type":"structure","members":{"SubnetGroup":{"shape":"Su"}}}}},"shapes":{"S4":{"type":"list","member":{}},"S5":{"type":"list","member":{}},"S6":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Sb":{"type":"structure","members":{"ClusterName":{},"Description":{},"ClusterArn":{},"TotalNodes":{"type":"integer"},"ActiveNodes":{"type":"integer"},"NodeType":{},"Status":{},"ClusterDiscoveryEndpoint":{"shape":"Sd"},"NodeIdsToRemove":{"shape":"Se"},"Nodes":{"type":"list","member":{"type":"structure","members":{"NodeId":{},"Endpoint":{"shape":"Sd"},"NodeCreateTime":{"type":"timestamp"},"AvailabilityZone":{},"NodeStatus":{},"ParameterGroupStatus":{}}}},"PreferredMaintenanceWindow":{},"NotificationConfiguration":{"type":"structure","members":{"TopicArn":{},"TopicStatus":{}}},"SubnetGroup":{},"SecurityGroups":{"type":"list","member":{"type":"structure","members":{"SecurityGroupIdentifier":{},"Status":{}}}},"IamRoleArn":{},"ParameterGroup":{"type":"structure","members":{"ParameterGroupName":{},"ParameterApplyStatus":{},"NodeIdsToReboot":{"shape":"Se"}}},"SSEDescription":{"type":"structure","members":{"Status":{}}}}},"Sd":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"Se":{"type":"list","member":{}},"Sq":{"type":"structure","members":{"ParameterGroupName":{},"Description":{}}},"Ss":{"type":"list","member":{}},"Su":{"type":"structure","members":{"SubnetGroupName":{},"Description":{},"VpcId":{},"Subnets":{"type":"list","member":{"type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{}}}}}},"S1b":{"type":"list","member":{"type":"structure","members":{"ParameterName":{},"ParameterType":{},"ParameterValue":{},"NodeTypeSpecificValues":{"type":"list","member":{"type":"structure","members":{"NodeType":{},"Value":{}}}},"Description":{},"Source":{},"DataType":{},"AllowedValues":{},"IsModifiable":{},"ChangeType":{}}}}}}');

});

parcelRequire.register("bSc3g", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("dbKPa", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $99a09fc07cdf0e30$var$Service = $dbC7k.Service;
var $99a09fc07cdf0e30$var$apiLoader = $dbC7k.apiLoader;
$99a09fc07cdf0e30$var$apiLoader.services["migrationhub"] = {};
$dbC7k.MigrationHub = $99a09fc07cdf0e30$var$Service.defineService("migrationhub", [
    "2017-05-31"
]);


Object.defineProperty($99a09fc07cdf0e30$var$apiLoader.services["migrationhub"], "2017-05-31", {
    get: function get() {
        var model = (parcelRequire("3kKkC"));
        model.paginators = (parcelRequire("7DMF4")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.MigrationHub;

});
parcelRequire.register("3kKkC", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-05-31","endpointPrefix":"mgh","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Migration Hub","serviceId":"Migration Hub","signatureVersion":"v4","targetPrefix":"AWSMigrationHub","uid":"AWSMigrationHub-2017-05-31"},"operations":{"AssociateCreatedArtifact":{"input":{"type":"structure","required":["ProgressUpdateStream","MigrationTaskName","CreatedArtifact"],"members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"CreatedArtifact":{"shape":"S4"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"AssociateDiscoveredResource":{"input":{"type":"structure","required":["ProgressUpdateStream","MigrationTaskName","DiscoveredResource"],"members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"DiscoveredResource":{"shape":"Sa"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"CreateProgressUpdateStream":{"input":{"type":"structure","required":["ProgressUpdateStreamName"],"members":{"ProgressUpdateStreamName":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteProgressUpdateStream":{"input":{"type":"structure","required":["ProgressUpdateStreamName"],"members":{"ProgressUpdateStreamName":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DescribeApplicationState":{"input":{"type":"structure","required":["ApplicationId"],"members":{"ApplicationId":{}}},"output":{"type":"structure","members":{"ApplicationStatus":{},"LastUpdatedTime":{"type":"timestamp"}}}},"DescribeMigrationTask":{"input":{"type":"structure","required":["ProgressUpdateStream","MigrationTaskName"],"members":{"ProgressUpdateStream":{},"MigrationTaskName":{}}},"output":{"type":"structure","members":{"MigrationTask":{"type":"structure","members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"Task":{"shape":"Sq"},"UpdateDateTime":{"type":"timestamp"},"ResourceAttributeList":{"type":"list","member":{"shape":"Sv"}}}}}}},"DisassociateCreatedArtifact":{"input":{"type":"structure","required":["ProgressUpdateStream","MigrationTaskName","CreatedArtifactName"],"members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"CreatedArtifactName":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DisassociateDiscoveredResource":{"input":{"type":"structure","required":["ProgressUpdateStream","MigrationTaskName","ConfigurationId"],"members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"ConfigurationId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"ImportMigrationTask":{"input":{"type":"structure","required":["ProgressUpdateStream","MigrationTaskName"],"members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"ListCreatedArtifacts":{"input":{"type":"structure","required":["ProgressUpdateStream","MigrationTaskName"],"members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"CreatedArtifactList":{"type":"list","member":{"shape":"S4"}}}}},"ListDiscoveredResources":{"input":{"type":"structure","required":["ProgressUpdateStream","MigrationTaskName"],"members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"DiscoveredResourceList":{"type":"list","member":{"shape":"Sa"}}}}},"ListMigrationTasks":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"ResourceName":{}}},"output":{"type":"structure","members":{"NextToken":{},"MigrationTaskSummaryList":{"type":"list","member":{"type":"structure","members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"Status":{},"ProgressPercent":{"type":"integer"},"StatusDetail":{},"UpdateDateTime":{"type":"timestamp"}}}}}}},"ListProgressUpdateStreams":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ProgressUpdateStreamSummaryList":{"type":"list","member":{"type":"structure","members":{"ProgressUpdateStreamName":{}}}},"NextToken":{}}}},"NotifyApplicationState":{"input":{"type":"structure","required":["ApplicationId","Status"],"members":{"ApplicationId":{},"Status":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"NotifyMigrationTaskState":{"input":{"type":"structure","required":["ProgressUpdateStream","MigrationTaskName","Task","UpdateDateTime","NextUpdateSeconds"],"members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"Task":{"shape":"Sq"},"UpdateDateTime":{"type":"timestamp"},"NextUpdateSeconds":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"PutResourceAttributes":{"input":{"type":"structure","required":["ProgressUpdateStream","MigrationTaskName","ResourceAttributeList"],"members":{"ProgressUpdateStream":{},"MigrationTaskName":{},"ResourceAttributeList":{"type":"list","member":{"shape":"Sv"}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S4":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{}}},"Sa":{"type":"structure","required":["ConfigurationId"],"members":{"ConfigurationId":{},"Description":{}}},"Sq":{"type":"structure","required":["Status"],"members":{"Status":{},"StatusDetail":{},"ProgressPercent":{"type":"integer"}}},"Sv":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{}}}}}');

});

parcelRequire.register("7DMF4", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("1ZwQB", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $1734f7c9f22ecd4b$var$Service = $dbC7k.Service;
var $1734f7c9f22ecd4b$var$apiLoader = $dbC7k.apiLoader;
$1734f7c9f22ecd4b$var$apiLoader.services["cloudhsmv2"] = {};
$dbC7k.CloudHSMV2 = $1734f7c9f22ecd4b$var$Service.defineService("cloudhsmv2", [
    "2017-04-28"
]);


Object.defineProperty($1734f7c9f22ecd4b$var$apiLoader.services["cloudhsmv2"], "2017-04-28", {
    get: function get() {
        var model = (parcelRequire("glNQJ"));
        model.paginators = (parcelRequire("GiU5G")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.CloudHSMV2;

});
parcelRequire.register("glNQJ", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-04-28","endpointPrefix":"cloudhsmv2","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CloudHSM V2","serviceFullName":"AWS CloudHSM V2","serviceId":"CloudHSM V2","signatureVersion":"v4","signingName":"cloudhsm","targetPrefix":"BaldrApiService","uid":"cloudhsmv2-2017-04-28"},"operations":{"CopyBackupToRegion":{"input":{"type":"structure","required":["DestinationRegion","BackupId"],"members":{"DestinationRegion":{},"BackupId":{}}},"output":{"type":"structure","members":{"DestinationBackup":{"type":"structure","members":{"CreateTimestamp":{"type":"timestamp"},"SourceRegion":{},"SourceBackup":{},"SourceCluster":{}}}}}},"CreateCluster":{"input":{"type":"structure","required":["SubnetIds","HsmType"],"members":{"SubnetIds":{"type":"list","member":{}},"HsmType":{},"SourceBackupId":{}}},"output":{"type":"structure","members":{"Cluster":{"shape":"Sd"}}}},"CreateHsm":{"input":{"type":"structure","required":["ClusterId","AvailabilityZone"],"members":{"ClusterId":{},"AvailabilityZone":{},"IpAddress":{}}},"output":{"type":"structure","members":{"Hsm":{"shape":"Sg"}}}},"DeleteBackup":{"input":{"type":"structure","required":["BackupId"],"members":{"BackupId":{}}},"output":{"type":"structure","members":{"Backup":{"shape":"Sz"}}}},"DeleteCluster":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{"Cluster":{"shape":"Sd"}}}},"DeleteHsm":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"HsmId":{},"EniId":{},"EniIp":{}}},"output":{"type":"structure","members":{"HsmId":{}}}},"DescribeBackups":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S18"},"SortAscending":{"type":"boolean"}}},"output":{"type":"structure","members":{"Backups":{"type":"list","member":{"shape":"Sz"}},"NextToken":{}}}},"DescribeClusters":{"input":{"type":"structure","members":{"Filters":{"shape":"S18"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Clusters":{"type":"list","member":{"shape":"Sd"}},"NextToken":{}}}},"InitializeCluster":{"input":{"type":"structure","required":["ClusterId","SignedCert","TrustAnchor"],"members":{"ClusterId":{},"SignedCert":{},"TrustAnchor":{}}},"output":{"type":"structure","members":{"State":{},"StateMessage":{}}}},"ListTags":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["TagList"],"members":{"TagList":{"shape":"S1l"},"NextToken":{}}}},"RestoreBackup":{"input":{"type":"structure","required":["BackupId"],"members":{"BackupId":{}}},"output":{"type":"structure","members":{"Backup":{"shape":"Sz"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceId","TagList"],"members":{"ResourceId":{},"TagList":{"shape":"S1l"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceId","TagKeyList"],"members":{"ResourceId":{},"TagKeyList":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sd":{"type":"structure","members":{"BackupPolicy":{},"ClusterId":{},"CreateTimestamp":{"type":"timestamp"},"Hsms":{"type":"list","member":{"shape":"Sg"}},"HsmType":{},"PreCoPassword":{},"SecurityGroup":{},"SourceBackupId":{},"State":{},"StateMessage":{},"SubnetMapping":{"type":"map","key":{},"value":{}},"VpcId":{},"Certificates":{"type":"structure","members":{"ClusterCsr":{},"HsmCertificate":{},"AwsHardwareCertificate":{},"ManufacturerHardwareCertificate":{},"ClusterCertificate":{}}}}},"Sg":{"type":"structure","required":["HsmId"],"members":{"AvailabilityZone":{},"ClusterId":{},"SubnetId":{},"EniId":{},"EniIp":{},"HsmId":{},"State":{},"StateMessage":{}}},"Sz":{"type":"structure","required":["BackupId"],"members":{"BackupId":{},"BackupState":{},"ClusterId":{},"CreateTimestamp":{"type":"timestamp"},"CopyTimestamp":{"type":"timestamp"},"SourceRegion":{},"SourceBackup":{},"SourceCluster":{},"DeleteTimestamp":{"type":"timestamp"}}},"S18":{"type":"map","key":{},"value":{"type":"list","member":{}}},"S1l":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}}}}');

});

parcelRequire.register("GiU5G", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeBackups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeClusters":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTags":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("hrZED", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $cb44c88b63e84a17$var$Service = $dbC7k.Service;
var $cb44c88b63e84a17$var$apiLoader = $dbC7k.apiLoader;
$cb44c88b63e84a17$var$apiLoader.services["glue"] = {};
$dbC7k.Glue = $cb44c88b63e84a17$var$Service.defineService("glue", [
    "2017-03-31"
]);


Object.defineProperty($cb44c88b63e84a17$var$apiLoader.services["glue"], "2017-03-31", {
    get: function get() {
        var model = (parcelRequire("fTz2U"));
        model.paginators = (parcelRequire("cu312")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Glue;

});
parcelRequire.register("fTz2U", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-03-31","endpointPrefix":"glue","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Glue","serviceId":"Glue","signatureVersion":"v4","targetPrefix":"AWSGlue","uid":"glue-2017-03-31"},"operations":{"BatchCreatePartition":{"input":{"type":"structure","required":["DatabaseName","TableName","PartitionInputList"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"PartitionInputList":{"type":"list","member":{"shape":"S5"}}}},"output":{"type":"structure","members":{"Errors":{"shape":"Sv"}}}},"BatchDeleteConnection":{"input":{"type":"structure","required":["ConnectionNameList"],"members":{"CatalogId":{},"ConnectionNameList":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"Succeeded":{"shape":"Sm"},"Errors":{"type":"map","key":{},"value":{"shape":"Sx"}}}}},"BatchDeletePartition":{"input":{"type":"structure","required":["DatabaseName","TableName","PartitionsToDelete"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"PartitionsToDelete":{"type":"list","member":{"shape":"S15"}}}},"output":{"type":"structure","members":{"Errors":{"shape":"Sv"}}}},"BatchDeleteTable":{"input":{"type":"structure","required":["DatabaseName","TablesToDelete"],"members":{"CatalogId":{},"DatabaseName":{},"TablesToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"Errors":{"type":"list","member":{"type":"structure","members":{"TableName":{},"ErrorDetail":{"shape":"Sx"}}}}}}},"BatchDeleteTableVersion":{"input":{"type":"structure","required":["DatabaseName","TableName","VersionIds"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"VersionIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"Errors":{"type":"list","member":{"type":"structure","members":{"TableName":{},"VersionId":{},"ErrorDetail":{"shape":"Sx"}}}}}}},"BatchGetCrawlers":{"input":{"type":"structure","required":["CrawlerNames"],"members":{"CrawlerNames":{"shape":"S1j"}}},"output":{"type":"structure","members":{"Crawlers":{"shape":"S1l"},"CrawlersNotFound":{"shape":"S1j"}}}},"BatchGetDevEndpoints":{"input":{"type":"structure","required":["DevEndpointNames"],"members":{"DevEndpointNames":{"shape":"S2l"}}},"output":{"type":"structure","members":{"DevEndpoints":{"shape":"S2o"},"DevEndpointsNotFound":{"shape":"S2l"}}}},"BatchGetJobs":{"input":{"type":"structure","required":["JobNames"],"members":{"JobNames":{"shape":"S2z"}}},"output":{"type":"structure","members":{"Jobs":{"shape":"S31"},"JobsNotFound":{"shape":"S2z"}}}},"BatchGetPartition":{"input":{"type":"structure","required":["DatabaseName","TableName","PartitionsToGet"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"PartitionsToGet":{"shape":"S3k"}}},"output":{"type":"structure","members":{"Partitions":{"shape":"S3m"},"UnprocessedKeys":{"shape":"S3k"}}}},"BatchGetTriggers":{"input":{"type":"structure","required":["TriggerNames"],"members":{"TriggerNames":{"shape":"S3p"}}},"output":{"type":"structure","members":{"Triggers":{"shape":"S3r"},"TriggersNotFound":{"shape":"S3p"}}}},"BatchGetWorkflows":{"input":{"type":"structure","required":["Names"],"members":{"Names":{"shape":"S46"},"IncludeGraph":{"type":"boolean"}}},"output":{"type":"structure","members":{"Workflows":{"type":"list","member":{"shape":"S4a"}},"MissingWorkflows":{"shape":"S46"}}}},"BatchStopJobRun":{"input":{"type":"structure","required":["JobName","JobRunIds"],"members":{"JobName":{},"JobRunIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"SuccessfulSubmissions":{"type":"list","member":{"type":"structure","members":{"JobName":{},"JobRunId":{}}}},"Errors":{"type":"list","member":{"type":"structure","members":{"JobName":{},"JobRunId":{},"ErrorDetail":{"shape":"Sx"}}}}}}},"CancelMLTaskRun":{"input":{"type":"structure","required":["TransformId","TaskRunId"],"members":{"TransformId":{},"TaskRunId":{}}},"output":{"type":"structure","members":{"TransformId":{},"TaskRunId":{},"Status":{}}}},"CreateClassifier":{"input":{"type":"structure","members":{"GrokClassifier":{"type":"structure","required":["Classification","Name","GrokPattern"],"members":{"Classification":{},"Name":{},"GrokPattern":{},"CustomPatterns":{}}},"XMLClassifier":{"type":"structure","required":["Classification","Name"],"members":{"Classification":{},"Name":{},"RowTag":{}}},"JsonClassifier":{"type":"structure","required":["Name","JsonPath"],"members":{"Name":{},"JsonPath":{}}},"CsvClassifier":{"type":"structure","required":["Name"],"members":{"Name":{},"Delimiter":{},"QuoteSymbol":{},"ContainsHeader":{},"Header":{"shape":"S5l"},"DisableValueTrimming":{"type":"boolean"},"AllowSingleColumn":{"type":"boolean"}}}}},"output":{"type":"structure","members":{}}},"CreateConnection":{"input":{"type":"structure","required":["ConnectionInput"],"members":{"CatalogId":{},"ConnectionInput":{"shape":"S5o"}}},"output":{"type":"structure","members":{}}},"CreateCrawler":{"input":{"type":"structure","required":["Name","Role","Targets"],"members":{"Name":{},"Role":{},"DatabaseName":{},"Description":{},"Targets":{"shape":"S1o"},"Schedule":{},"Classifiers":{"shape":"S22"},"TablePrefix":{},"SchemaChangePolicy":{"shape":"S23"},"Configuration":{},"CrawlerSecurityConfiguration":{},"Tags":{"shape":"S5x"}}},"output":{"type":"structure","members":{}}},"CreateDatabase":{"input":{"type":"structure","required":["DatabaseInput"],"members":{"CatalogId":{},"DatabaseInput":{"shape":"S62"}}},"output":{"type":"structure","members":{}}},"CreateDevEndpoint":{"input":{"type":"structure","required":["EndpointName","RoleArn"],"members":{"EndpointName":{},"RoleArn":{},"SecurityGroupIds":{"shape":"S2r"},"SubnetId":{},"PublicKey":{},"PublicKeys":{"shape":"S2w"},"NumberOfNodes":{"type":"integer"},"WorkerType":{},"NumberOfWorkers":{"type":"integer"},"ExtraPythonLibsS3Path":{},"ExtraJarsS3Path":{},"SecurityConfiguration":{},"Tags":{"shape":"S5x"},"Arguments":{"shape":"S2x"}}},"output":{"type":"structure","members":{"EndpointName":{},"Status":{},"SecurityGroupIds":{"shape":"S2r"},"SubnetId":{},"RoleArn":{},"YarnEndpointAddress":{},"ZeppelinRemoteSparkInterpreterPort":{"type":"integer"},"NumberOfNodes":{"type":"integer"},"WorkerType":{},"NumberOfWorkers":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"ExtraPythonLibsS3Path":{},"ExtraJarsS3Path":{},"FailureReason":{},"SecurityConfiguration":{},"CreatedTimestamp":{"type":"timestamp"},"Arguments":{"shape":"S2x"}}}},"CreateJob":{"input":{"type":"structure","required":["Name","Role","Command"],"members":{"Name":{},"Description":{},"LogUri":{},"Role":{},"ExecutionProperty":{"shape":"S35"},"Command":{"shape":"S37"},"DefaultArguments":{"shape":"S3a"},"Connections":{"shape":"S3b"},"MaxRetries":{"type":"integer"},"AllocatedCapacity":{"deprecated":true,"deprecatedMessage":"This property is deprecated, use MaxCapacity instead.","type":"integer"},"Timeout":{"type":"integer"},"MaxCapacity":{"type":"double"},"SecurityConfiguration":{},"Tags":{"shape":"S5x"},"NotificationProperty":{"shape":"S3g"},"GlueVersion":{},"NumberOfWorkers":{"type":"integer"},"WorkerType":{}}},"output":{"type":"structure","members":{"Name":{}}}},"CreateMLTransform":{"input":{"type":"structure","required":["Name","InputRecordTables","Parameters","Role"],"members":{"Name":{},"Description":{},"InputRecordTables":{"shape":"S6g"},"Parameters":{"shape":"S6i"},"Role":{},"MaxCapacity":{"type":"double"},"WorkerType":{},"NumberOfWorkers":{"type":"integer"},"Timeout":{"type":"integer"},"MaxRetries":{"type":"integer"}}},"output":{"type":"structure","members":{"TransformId":{}}}},"CreatePartition":{"input":{"type":"structure","required":["DatabaseName","TableName","PartitionInput"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"PartitionInput":{"shape":"S5"}}},"output":{"type":"structure","members":{}}},"CreateScript":{"input":{"type":"structure","members":{"DagNodes":{"shape":"S6r"},"DagEdges":{"shape":"S6z"},"Language":{}}},"output":{"type":"structure","members":{"PythonScript":{},"ScalaCode":{}}}},"CreateSecurityConfiguration":{"input":{"type":"structure","required":["Name","EncryptionConfiguration"],"members":{"Name":{},"EncryptionConfiguration":{"shape":"S76"}}},"output":{"type":"structure","members":{"Name":{},"CreatedTimestamp":{"type":"timestamp"}}}},"CreateTable":{"input":{"type":"structure","required":["DatabaseName","TableInput"],"members":{"CatalogId":{},"DatabaseName":{},"TableInput":{"shape":"S7h"}}},"output":{"type":"structure","members":{}}},"CreateTrigger":{"input":{"type":"structure","required":["Name","Type","Actions"],"members":{"Name":{},"WorkflowName":{},"Type":{},"Schedule":{},"Predicate":{"shape":"S3y"},"Actions":{"shape":"S3w"},"Description":{},"StartOnCreation":{"type":"boolean"},"Tags":{"shape":"S5x"}}},"output":{"type":"structure","members":{"Name":{}}}},"CreateUserDefinedFunction":{"input":{"type":"structure","required":["DatabaseName","FunctionInput"],"members":{"CatalogId":{},"DatabaseName":{},"FunctionInput":{"shape":"S7q"}}},"output":{"type":"structure","members":{}}},"CreateWorkflow":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"DefaultRunProperties":{"shape":"S4b"},"Tags":{"shape":"S5x"}}},"output":{"type":"structure","members":{"Name":{}}}},"DeleteClassifier":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteConnection":{"input":{"type":"structure","required":["ConnectionName"],"members":{"CatalogId":{},"ConnectionName":{}}},"output":{"type":"structure","members":{}}},"DeleteCrawler":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteDatabase":{"input":{"type":"structure","required":["Name"],"members":{"CatalogId":{},"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteDevEndpoint":{"input":{"type":"structure","required":["EndpointName"],"members":{"EndpointName":{}}},"output":{"type":"structure","members":{}}},"DeleteJob":{"input":{"type":"structure","required":["JobName"],"members":{"JobName":{}}},"output":{"type":"structure","members":{"JobName":{}}}},"DeleteMLTransform":{"input":{"type":"structure","required":["TransformId"],"members":{"TransformId":{}}},"output":{"type":"structure","members":{"TransformId":{}}}},"DeletePartition":{"input":{"type":"structure","required":["DatabaseName","TableName","PartitionValues"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"PartitionValues":{"shape":"S6"}}},"output":{"type":"structure","members":{}}},"DeleteResourcePolicy":{"input":{"type":"structure","members":{"PolicyHashCondition":{}}},"output":{"type":"structure","members":{}}},"DeleteSecurityConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteTable":{"input":{"type":"structure","required":["DatabaseName","Name"],"members":{"CatalogId":{},"DatabaseName":{},"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteTableVersion":{"input":{"type":"structure","required":["DatabaseName","TableName","VersionId"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"VersionId":{}}},"output":{"type":"structure","members":{}}},"DeleteTrigger":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{}}}},"DeleteUserDefinedFunction":{"input":{"type":"structure","required":["DatabaseName","FunctionName"],"members":{"CatalogId":{},"DatabaseName":{},"FunctionName":{}}},"output":{"type":"structure","members":{}}},"DeleteWorkflow":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{}}}},"GetCatalogImportStatus":{"input":{"type":"structure","members":{"CatalogId":{}}},"output":{"type":"structure","members":{"ImportStatus":{"type":"structure","members":{"ImportCompleted":{"type":"boolean"},"ImportTime":{"type":"timestamp"},"ImportedBy":{}}}}}},"GetClassifier":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Classifier":{"shape":"S8x"}}}},"GetClassifiers":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Classifiers":{"type":"list","member":{"shape":"S8x"}},"NextToken":{}}}},"GetConnection":{"input":{"type":"structure","required":["Name"],"members":{"CatalogId":{},"Name":{},"HidePassword":{"type":"boolean"}}},"output":{"type":"structure","members":{"Connection":{"shape":"S99"}}}},"GetConnections":{"input":{"type":"structure","members":{"CatalogId":{},"Filter":{"type":"structure","members":{"MatchCriteria":{"shape":"S5q"},"ConnectionType":{}}},"HidePassword":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ConnectionList":{"type":"list","member":{"shape":"S99"}},"NextToken":{}}}},"GetCrawler":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Crawler":{"shape":"S1m"}}}},"GetCrawlerMetrics":{"input":{"type":"structure","members":{"CrawlerNameList":{"shape":"S1j"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"CrawlerMetricsList":{"type":"list","member":{"type":"structure","members":{"CrawlerName":{},"TimeLeftSeconds":{"type":"double"},"StillEstimating":{"type":"boolean"},"LastRuntimeSeconds":{"type":"double"},"MedianRuntimeSeconds":{"type":"double"},"TablesCreated":{"type":"integer"},"TablesUpdated":{"type":"integer"},"TablesDeleted":{"type":"integer"}}}},"NextToken":{}}}},"GetCrawlers":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Crawlers":{"shape":"S1l"},"NextToken":{}}}},"GetDataCatalogEncryptionSettings":{"input":{"type":"structure","members":{"CatalogId":{}}},"output":{"type":"structure","members":{"DataCatalogEncryptionSettings":{"shape":"S9p"}}}},"GetDatabase":{"input":{"type":"structure","required":["Name"],"members":{"CatalogId":{},"Name":{}}},"output":{"type":"structure","members":{"Database":{"shape":"S9v"}}}},"GetDatabases":{"input":{"type":"structure","members":{"CatalogId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["DatabaseList"],"members":{"DatabaseList":{"type":"list","member":{"shape":"S9v"}},"NextToken":{}}}},"GetDataflowGraph":{"input":{"type":"structure","members":{"PythonScript":{}}},"output":{"type":"structure","members":{"DagNodes":{"shape":"S6r"},"DagEdges":{"shape":"S6z"}}}},"GetDevEndpoint":{"input":{"type":"structure","required":["EndpointName"],"members":{"EndpointName":{}}},"output":{"type":"structure","members":{"DevEndpoint":{"shape":"S2p"}}}},"GetDevEndpoints":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DevEndpoints":{"shape":"S2o"},"NextToken":{}}}},"GetJob":{"input":{"type":"structure","required":["JobName"],"members":{"JobName":{}}},"output":{"type":"structure","members":{"Job":{"shape":"S32"}}}},"GetJobBookmark":{"input":{"type":"structure","required":["JobName"],"members":{"JobName":{},"RunId":{}}},"output":{"type":"structure","members":{"JobBookmarkEntry":{"shape":"Sab"}}}},"GetJobRun":{"input":{"type":"structure","required":["JobName","RunId"],"members":{"JobName":{},"RunId":{},"PredecessorsIncluded":{"type":"boolean"}}},"output":{"type":"structure","members":{"JobRun":{"shape":"S4m"}}}},"GetJobRuns":{"input":{"type":"structure","required":["JobName"],"members":{"JobName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"JobRuns":{"shape":"S4l"},"NextToken":{}}}},"GetJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Jobs":{"shape":"S31"},"NextToken":{}}}},"GetMLTaskRun":{"input":{"type":"structure","required":["TransformId","TaskRunId"],"members":{"TransformId":{},"TaskRunId":{}}},"output":{"type":"structure","members":{"TransformId":{},"TaskRunId":{},"Status":{},"LogGroupName":{},"Properties":{"shape":"Sal"},"ErrorString":{},"StartedOn":{"type":"timestamp"},"LastModifiedOn":{"type":"timestamp"},"CompletedOn":{"type":"timestamp"},"ExecutionTime":{"type":"integer"}}}},"GetMLTaskRuns":{"input":{"type":"structure","required":["TransformId"],"members":{"TransformId":{},"NextToken":{},"MaxResults":{"type":"integer"},"Filter":{"type":"structure","members":{"TaskRunType":{},"Status":{},"StartedBefore":{"type":"timestamp"},"StartedAfter":{"type":"timestamp"}}},"Sort":{"type":"structure","required":["Column","SortDirection"],"members":{"Column":{},"SortDirection":{}}}}},"output":{"type":"structure","members":{"TaskRuns":{"type":"list","member":{"type":"structure","members":{"TransformId":{},"TaskRunId":{},"Status":{},"LogGroupName":{},"Properties":{"shape":"Sal"},"ErrorString":{},"StartedOn":{"type":"timestamp"},"LastModifiedOn":{"type":"timestamp"},"CompletedOn":{"type":"timestamp"},"ExecutionTime":{"type":"integer"}}}},"NextToken":{}}}},"GetMLTransform":{"input":{"type":"structure","required":["TransformId"],"members":{"TransformId":{}}},"output":{"type":"structure","members":{"TransformId":{},"Name":{},"Description":{},"Status":{},"CreatedOn":{"type":"timestamp"},"LastModifiedOn":{"type":"timestamp"},"InputRecordTables":{"shape":"S6g"},"Parameters":{"shape":"S6i"},"EvaluationMetrics":{"shape":"Sb4"},"LabelCount":{"type":"integer"},"Schema":{"shape":"Sb9"},"Role":{},"MaxCapacity":{"type":"double"},"WorkerType":{},"NumberOfWorkers":{"type":"integer"},"Timeout":{"type":"integer"},"MaxRetries":{"type":"integer"}}}},"GetMLTransforms":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filter":{"type":"structure","members":{"Name":{},"TransformType":{},"Status":{},"CreatedBefore":{"type":"timestamp"},"CreatedAfter":{"type":"timestamp"},"LastModifiedBefore":{"type":"timestamp"},"LastModifiedAfter":{"type":"timestamp"},"Schema":{"shape":"Sb9"}}},"Sort":{"type":"structure","required":["Column","SortDirection"],"members":{"Column":{},"SortDirection":{}}}}},"output":{"type":"structure","required":["Transforms"],"members":{"Transforms":{"type":"list","member":{"type":"structure","members":{"TransformId":{},"Name":{},"Description":{},"Status":{},"CreatedOn":{"type":"timestamp"},"LastModifiedOn":{"type":"timestamp"},"InputRecordTables":{"shape":"S6g"},"Parameters":{"shape":"S6i"},"EvaluationMetrics":{"shape":"Sb4"},"LabelCount":{"type":"integer"},"Schema":{"shape":"Sb9"},"Role":{},"MaxCapacity":{"type":"double"},"WorkerType":{},"NumberOfWorkers":{"type":"integer"},"Timeout":{"type":"integer"},"MaxRetries":{"type":"integer"}}}},"NextToken":{}}}},"GetMapping":{"input":{"type":"structure","required":["Source"],"members":{"Source":{"shape":"Sbj"},"Sinks":{"shape":"Sbk"},"Location":{"shape":"Sbl"}}},"output":{"type":"structure","required":["Mapping"],"members":{"Mapping":{"shape":"Sbn"}}}},"GetPartition":{"input":{"type":"structure","required":["DatabaseName","TableName","PartitionValues"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"PartitionValues":{"shape":"S6"}}},"output":{"type":"structure","members":{"Partition":{"shape":"S3n"}}}},"GetPartitions":{"input":{"type":"structure","required":["DatabaseName","TableName"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"Expression":{},"NextToken":{},"Segment":{"type":"structure","required":["SegmentNumber","TotalSegments"],"members":{"SegmentNumber":{"type":"integer"},"TotalSegments":{"type":"integer"}}},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Partitions":{"shape":"S3m"},"NextToken":{}}}},"GetPlan":{"input":{"type":"structure","required":["Mapping","Source"],"members":{"Mapping":{"shape":"Sbn"},"Source":{"shape":"Sbj"},"Sinks":{"shape":"Sbk"},"Location":{"shape":"Sbl"},"Language":{}}},"output":{"type":"structure","members":{"PythonScript":{},"ScalaCode":{}}}},"GetResourcePolicy":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"PolicyInJson":{},"PolicyHash":{},"CreateTime":{"type":"timestamp"},"UpdateTime":{"type":"timestamp"}}}},"GetSecurityConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"SecurityConfiguration":{"shape":"Sc6"}}}},"GetSecurityConfigurations":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"SecurityConfigurations":{"type":"list","member":{"shape":"Sc6"}},"NextToken":{}}}},"GetTable":{"input":{"type":"structure","required":["DatabaseName","Name"],"members":{"CatalogId":{},"DatabaseName":{},"Name":{}}},"output":{"type":"structure","members":{"Table":{"shape":"Scc"}}}},"GetTableVersion":{"input":{"type":"structure","required":["DatabaseName","TableName"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"VersionId":{}}},"output":{"type":"structure","members":{"TableVersion":{"shape":"Scf"}}}},"GetTableVersions":{"input":{"type":"structure","required":["DatabaseName","TableName"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TableVersions":{"type":"list","member":{"shape":"Scf"}},"NextToken":{}}}},"GetTables":{"input":{"type":"structure","required":["DatabaseName"],"members":{"CatalogId":{},"DatabaseName":{},"Expression":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TableList":{"shape":"Scm"},"NextToken":{}}}},"GetTags":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S5x"}}}},"GetTrigger":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Trigger":{"shape":"S3s"}}}},"GetTriggers":{"input":{"type":"structure","members":{"NextToken":{},"DependentJobName":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Triggers":{"shape":"S3r"},"NextToken":{}}}},"GetUserDefinedFunction":{"input":{"type":"structure","required":["DatabaseName","FunctionName"],"members":{"CatalogId":{},"DatabaseName":{},"FunctionName":{}}},"output":{"type":"structure","members":{"UserDefinedFunction":{"shape":"Scw"}}}},"GetUserDefinedFunctions":{"input":{"type":"structure","required":["DatabaseName","Pattern"],"members":{"CatalogId":{},"DatabaseName":{},"Pattern":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"UserDefinedFunctions":{"type":"list","member":{"shape":"Scw"}},"NextToken":{}}}},"GetWorkflow":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"IncludeGraph":{"type":"boolean"}}},"output":{"type":"structure","members":{"Workflow":{"shape":"S4a"}}}},"GetWorkflowRun":{"input":{"type":"structure","required":["Name","RunId"],"members":{"Name":{},"RunId":{},"IncludeGraph":{"type":"boolean"}}},"output":{"type":"structure","members":{"Run":{"shape":"S4c"}}}},"GetWorkflowRunProperties":{"input":{"type":"structure","required":["Name","RunId"],"members":{"Name":{},"RunId":{}}},"output":{"type":"structure","members":{"RunProperties":{"shape":"S4b"}}}},"GetWorkflowRuns":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"IncludeGraph":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Runs":{"type":"list","member":{"shape":"S4c"}},"NextToken":{}}}},"ImportCatalogToGlue":{"input":{"type":"structure","members":{"CatalogId":{}}},"output":{"type":"structure","members":{}}},"ListCrawlers":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"Tags":{"shape":"S5x"}}},"output":{"type":"structure","members":{"CrawlerNames":{"shape":"S1j"},"NextToken":{}}}},"ListDevEndpoints":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Tags":{"shape":"S5x"}}},"output":{"type":"structure","members":{"DevEndpointNames":{"type":"list","member":{}},"NextToken":{}}}},"ListJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Tags":{"shape":"S5x"}}},"output":{"type":"structure","members":{"JobNames":{"shape":"S2z"},"NextToken":{}}}},"ListTriggers":{"input":{"type":"structure","members":{"NextToken":{},"DependentJobName":{},"MaxResults":{"type":"integer"},"Tags":{"shape":"S5x"}}},"output":{"type":"structure","members":{"TriggerNames":{"shape":"S3p"},"NextToken":{}}}},"ListWorkflows":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Workflows":{"shape":"S46"},"NextToken":{}}}},"PutDataCatalogEncryptionSettings":{"input":{"type":"structure","required":["DataCatalogEncryptionSettings"],"members":{"CatalogId":{},"DataCatalogEncryptionSettings":{"shape":"S9p"}}},"output":{"type":"structure","members":{}}},"PutResourcePolicy":{"input":{"type":"structure","required":["PolicyInJson"],"members":{"PolicyInJson":{},"PolicyHashCondition":{},"PolicyExistsCondition":{}}},"output":{"type":"structure","members":{"PolicyHash":{}}}},"PutWorkflowRunProperties":{"input":{"type":"structure","required":["Name","RunId","RunProperties"],"members":{"Name":{},"RunId":{},"RunProperties":{"shape":"S4b"}}},"output":{"type":"structure","members":{}}},"ResetJobBookmark":{"input":{"type":"structure","required":["JobName"],"members":{"JobName":{},"RunId":{}}},"output":{"type":"structure","members":{"JobBookmarkEntry":{"shape":"Sab"}}}},"SearchTables":{"input":{"type":"structure","members":{"CatalogId":{},"NextToken":{},"Filters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"Comparator":{}}}},"SearchText":{},"SortCriteria":{"type":"list","member":{"type":"structure","members":{"FieldName":{},"Sort":{}}}},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"TableList":{"shape":"Scm"}}}},"StartCrawler":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"StartCrawlerSchedule":{"input":{"type":"structure","required":["CrawlerName"],"members":{"CrawlerName":{}}},"output":{"type":"structure","members":{}}},"StartExportLabelsTaskRun":{"input":{"type":"structure","required":["TransformId","OutputS3Path"],"members":{"TransformId":{},"OutputS3Path":{}}},"output":{"type":"structure","members":{"TaskRunId":{}}}},"StartImportLabelsTaskRun":{"input":{"type":"structure","required":["TransformId","InputS3Path"],"members":{"TransformId":{},"InputS3Path":{},"ReplaceAllLabels":{"type":"boolean"}}},"output":{"type":"structure","members":{"TaskRunId":{}}}},"StartJobRun":{"input":{"type":"structure","required":["JobName"],"members":{"JobName":{},"JobRunId":{},"Arguments":{"shape":"S3a"},"AllocatedCapacity":{"deprecated":true,"deprecatedMessage":"This property is deprecated, use MaxCapacity instead.","type":"integer"},"Timeout":{"type":"integer"},"MaxCapacity":{"type":"double"},"SecurityConfiguration":{},"NotificationProperty":{"shape":"S3g"},"WorkerType":{},"NumberOfWorkers":{"type":"integer"}}},"output":{"type":"structure","members":{"JobRunId":{}}}},"StartMLEvaluationTaskRun":{"input":{"type":"structure","required":["TransformId"],"members":{"TransformId":{}}},"output":{"type":"structure","members":{"TaskRunId":{}}}},"StartMLLabelingSetGenerationTaskRun":{"input":{"type":"structure","required":["TransformId","OutputS3Path"],"members":{"TransformId":{},"OutputS3Path":{}}},"output":{"type":"structure","members":{"TaskRunId":{}}}},"StartTrigger":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{}}}},"StartWorkflowRun":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"RunId":{}}}},"StopCrawler":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"StopCrawlerSchedule":{"input":{"type":"structure","required":["CrawlerName"],"members":{"CrawlerName":{}}},"output":{"type":"structure","members":{}}},"StopTrigger":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","TagsToAdd"],"members":{"ResourceArn":{},"TagsToAdd":{"shape":"S5x"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagsToRemove"],"members":{"ResourceArn":{},"TagsToRemove":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateClassifier":{"input":{"type":"structure","members":{"GrokClassifier":{"type":"structure","required":["Name"],"members":{"Name":{},"Classification":{},"GrokPattern":{},"CustomPatterns":{}}},"XMLClassifier":{"type":"structure","required":["Name"],"members":{"Name":{},"Classification":{},"RowTag":{}}},"JsonClassifier":{"type":"structure","required":["Name"],"members":{"Name":{},"JsonPath":{}}},"CsvClassifier":{"type":"structure","required":["Name"],"members":{"Name":{},"Delimiter":{},"QuoteSymbol":{},"ContainsHeader":{},"Header":{"shape":"S5l"},"DisableValueTrimming":{"type":"boolean"},"AllowSingleColumn":{"type":"boolean"}}}}},"output":{"type":"structure","members":{}}},"UpdateConnection":{"input":{"type":"structure","required":["Name","ConnectionInput"],"members":{"CatalogId":{},"Name":{},"ConnectionInput":{"shape":"S5o"}}},"output":{"type":"structure","members":{}}},"UpdateCrawler":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Role":{},"DatabaseName":{},"Description":{},"Targets":{"shape":"S1o"},"Schedule":{},"Classifiers":{"shape":"S22"},"TablePrefix":{},"SchemaChangePolicy":{"shape":"S23"},"Configuration":{},"CrawlerSecurityConfiguration":{}}},"output":{"type":"structure","members":{}}},"UpdateCrawlerSchedule":{"input":{"type":"structure","required":["CrawlerName"],"members":{"CrawlerName":{},"Schedule":{}}},"output":{"type":"structure","members":{}}},"UpdateDatabase":{"input":{"type":"structure","required":["Name","DatabaseInput"],"members":{"CatalogId":{},"Name":{},"DatabaseInput":{"shape":"S62"}}},"output":{"type":"structure","members":{}}},"UpdateDevEndpoint":{"input":{"type":"structure","required":["EndpointName"],"members":{"EndpointName":{},"PublicKey":{},"AddPublicKeys":{"shape":"S2w"},"DeletePublicKeys":{"shape":"S2w"},"CustomLibraries":{"type":"structure","members":{"ExtraPythonLibsS3Path":{},"ExtraJarsS3Path":{}}},"UpdateEtlLibraries":{"type":"boolean"},"DeleteArguments":{"shape":"S2r"},"AddArguments":{"shape":"S2x"}}},"output":{"type":"structure","members":{}}},"UpdateJob":{"input":{"type":"structure","required":["JobName","JobUpdate"],"members":{"JobName":{},"JobUpdate":{"type":"structure","members":{"Description":{},"LogUri":{},"Role":{},"ExecutionProperty":{"shape":"S35"},"Command":{"shape":"S37"},"DefaultArguments":{"shape":"S3a"},"Connections":{"shape":"S3b"},"MaxRetries":{"type":"integer"},"AllocatedCapacity":{"deprecated":true,"deprecatedMessage":"This property is deprecated, use MaxCapacity instead.","type":"integer"},"Timeout":{"type":"integer"},"MaxCapacity":{"type":"double"},"WorkerType":{},"NumberOfWorkers":{"type":"integer"},"SecurityConfiguration":{},"NotificationProperty":{"shape":"S3g"},"GlueVersion":{}}}}},"output":{"type":"structure","members":{"JobName":{}}}},"UpdateMLTransform":{"input":{"type":"structure","required":["TransformId"],"members":{"TransformId":{},"Name":{},"Description":{},"Parameters":{"shape":"S6i"},"Role":{},"MaxCapacity":{"type":"double"},"WorkerType":{},"NumberOfWorkers":{"type":"integer"},"Timeout":{"type":"integer"},"MaxRetries":{"type":"integer"}}},"output":{"type":"structure","members":{"TransformId":{}}}},"UpdatePartition":{"input":{"type":"structure","required":["DatabaseName","TableName","PartitionValueList","PartitionInput"],"members":{"CatalogId":{},"DatabaseName":{},"TableName":{},"PartitionValueList":{"type":"list","member":{}},"PartitionInput":{"shape":"S5"}}},"output":{"type":"structure","members":{}}},"UpdateTable":{"input":{"type":"structure","required":["DatabaseName","TableInput"],"members":{"CatalogId":{},"DatabaseName":{},"TableInput":{"shape":"S7h"},"SkipArchive":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"UpdateTrigger":{"input":{"type":"structure","required":["Name","TriggerUpdate"],"members":{"Name":{},"TriggerUpdate":{"type":"structure","members":{"Name":{},"Description":{},"Schedule":{},"Actions":{"shape":"S3w"},"Predicate":{"shape":"S3y"}}}}},"output":{"type":"structure","members":{"Trigger":{"shape":"S3s"}}}},"UpdateUserDefinedFunction":{"input":{"type":"structure","required":["DatabaseName","FunctionName","FunctionInput"],"members":{"CatalogId":{},"DatabaseName":{},"FunctionName":{},"FunctionInput":{"shape":"S7q"}}},"output":{"type":"structure","members":{}}},"UpdateWorkflow":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"DefaultRunProperties":{"shape":"S4b"}}},"output":{"type":"structure","members":{"Name":{}}}}},"shapes":{"S5":{"type":"structure","members":{"Values":{"shape":"S6"},"LastAccessTime":{"type":"timestamp"},"StorageDescriptor":{"shape":"S9"},"Parameters":{"shape":"Se"},"LastAnalyzedTime":{"type":"timestamp"}}},"S6":{"type":"list","member":{}},"S9":{"type":"structure","members":{"Columns":{"shape":"Sa"},"Location":{},"InputFormat":{},"OutputFormat":{},"Compressed":{"type":"boolean"},"NumberOfBuckets":{"type":"integer"},"SerdeInfo":{"type":"structure","members":{"Name":{},"SerializationLibrary":{},"Parameters":{"shape":"Se"}}},"BucketColumns":{"shape":"Sm"},"SortColumns":{"type":"list","member":{"type":"structure","required":["Column","SortOrder"],"members":{"Column":{},"SortOrder":{"type":"integer"}}}},"Parameters":{"shape":"Se"},"SkewedInfo":{"type":"structure","members":{"SkewedColumnNames":{"shape":"Sm"},"SkewedColumnValues":{"type":"list","member":{}},"SkewedColumnValueLocationMaps":{"type":"map","key":{},"value":{}}}},"StoredAsSubDirectories":{"type":"boolean"}}},"Sa":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Type":{},"Comment":{},"Parameters":{"shape":"Se"}}}},"Se":{"type":"map","key":{},"value":{}},"Sm":{"type":"list","member":{}},"Sv":{"type":"list","member":{"type":"structure","members":{"PartitionValues":{"shape":"S6"},"ErrorDetail":{"shape":"Sx"}}}},"Sx":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{}}},"S15":{"type":"structure","required":["Values"],"members":{"Values":{"shape":"S6"}}},"S1j":{"type":"list","member":{}},"S1l":{"type":"list","member":{"shape":"S1m"}},"S1m":{"type":"structure","members":{"Name":{},"Role":{},"Targets":{"shape":"S1o"},"DatabaseName":{},"Description":{},"Classifiers":{"shape":"S22"},"SchemaChangePolicy":{"shape":"S23"},"State":{},"TablePrefix":{},"Schedule":{"type":"structure","members":{"ScheduleExpression":{},"State":{}}},"CrawlElapsedTime":{"type":"long"},"CreationTime":{"type":"timestamp"},"LastUpdated":{"type":"timestamp"},"LastCrawl":{"type":"structure","members":{"Status":{},"ErrorMessage":{},"LogGroup":{},"LogStream":{},"MessagePrefix":{},"StartTime":{"type":"timestamp"}}},"Version":{"type":"long"},"Configuration":{},"CrawlerSecurityConfiguration":{}}},"S1o":{"type":"structure","members":{"S3Targets":{"type":"list","member":{"type":"structure","members":{"Path":{},"Exclusions":{"shape":"S1s"}}}},"JdbcTargets":{"type":"list","member":{"type":"structure","members":{"ConnectionName":{},"Path":{},"Exclusions":{"shape":"S1s"}}}},"DynamoDBTargets":{"type":"list","member":{"type":"structure","members":{"Path":{}}}},"CatalogTargets":{"type":"list","member":{"type":"structure","required":["DatabaseName","Tables"],"members":{"DatabaseName":{},"Tables":{"type":"list","member":{}}}}}}},"S1s":{"type":"list","member":{}},"S22":{"type":"list","member":{}},"S23":{"type":"structure","members":{"UpdateBehavior":{},"DeleteBehavior":{}}},"S2l":{"type":"list","member":{}},"S2o":{"type":"list","member":{"shape":"S2p"}},"S2p":{"type":"structure","members":{"EndpointName":{},"RoleArn":{},"SecurityGroupIds":{"shape":"S2r"},"SubnetId":{},"YarnEndpointAddress":{},"PrivateAddress":{},"ZeppelinRemoteSparkInterpreterPort":{"type":"integer"},"PublicAddress":{},"Status":{},"WorkerType":{},"NumberOfWorkers":{"type":"integer"},"NumberOfNodes":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"ExtraPythonLibsS3Path":{},"ExtraJarsS3Path":{},"FailureReason":{},"LastUpdateStatus":{},"CreatedTimestamp":{"type":"timestamp"},"LastModifiedTimestamp":{"type":"timestamp"},"PublicKey":{},"PublicKeys":{"shape":"S2w"},"SecurityConfiguration":{},"Arguments":{"shape":"S2x"}}},"S2r":{"type":"list","member":{}},"S2w":{"type":"list","member":{}},"S2x":{"type":"map","key":{},"value":{}},"S2z":{"type":"list","member":{}},"S31":{"type":"list","member":{"shape":"S32"}},"S32":{"type":"structure","members":{"Name":{},"Description":{},"LogUri":{},"Role":{},"CreatedOn":{"type":"timestamp"},"LastModifiedOn":{"type":"timestamp"},"ExecutionProperty":{"shape":"S35"},"Command":{"shape":"S37"},"DefaultArguments":{"shape":"S3a"},"Connections":{"shape":"S3b"},"MaxRetries":{"type":"integer"},"AllocatedCapacity":{"deprecated":true,"deprecatedMessage":"This property is deprecated, use MaxCapacity instead.","type":"integer"},"Timeout":{"type":"integer"},"MaxCapacity":{"type":"double"},"WorkerType":{},"NumberOfWorkers":{"type":"integer"},"SecurityConfiguration":{},"NotificationProperty":{"shape":"S3g"},"GlueVersion":{}}},"S35":{"type":"structure","members":{"MaxConcurrentRuns":{"type":"integer"}}},"S37":{"type":"structure","members":{"Name":{},"ScriptLocation":{},"PythonVersion":{}}},"S3a":{"type":"map","key":{},"value":{}},"S3b":{"type":"structure","members":{"Connections":{"type":"list","member":{}}}},"S3g":{"type":"structure","members":{"NotifyDelayAfter":{"type":"integer"}}},"S3k":{"type":"list","member":{"shape":"S15"}},"S3m":{"type":"list","member":{"shape":"S3n"}},"S3n":{"type":"structure","members":{"Values":{"shape":"S6"},"DatabaseName":{},"TableName":{},"CreationTime":{"type":"timestamp"},"LastAccessTime":{"type":"timestamp"},"StorageDescriptor":{"shape":"S9"},"Parameters":{"shape":"Se"},"LastAnalyzedTime":{"type":"timestamp"}}},"S3p":{"type":"list","member":{}},"S3r":{"type":"list","member":{"shape":"S3s"}},"S3s":{"type":"structure","members":{"Name":{},"WorkflowName":{},"Id":{},"Type":{},"State":{},"Description":{},"Schedule":{},"Actions":{"shape":"S3w"},"Predicate":{"shape":"S3y"}}},"S3w":{"type":"list","member":{"type":"structure","members":{"JobName":{},"Arguments":{"shape":"S3a"},"Timeout":{"type":"integer"},"SecurityConfiguration":{},"NotificationProperty":{"shape":"S3g"},"CrawlerName":{}}}},"S3y":{"type":"structure","members":{"Logical":{},"Conditions":{"type":"list","member":{"type":"structure","members":{"LogicalOperator":{},"JobName":{},"State":{},"CrawlerName":{},"CrawlState":{}}}}}},"S46":{"type":"list","member":{}},"S4a":{"type":"structure","members":{"Name":{},"Description":{},"DefaultRunProperties":{"shape":"S4b"},"CreatedOn":{"type":"timestamp"},"LastModifiedOn":{"type":"timestamp"},"LastRun":{"shape":"S4c"},"Graph":{"shape":"S4f"}}},"S4b":{"type":"map","key":{},"value":{}},"S4c":{"type":"structure","members":{"Name":{},"WorkflowRunId":{},"WorkflowRunProperties":{"shape":"S4b"},"StartedOn":{"type":"timestamp"},"CompletedOn":{"type":"timestamp"},"Status":{},"Statistics":{"type":"structure","members":{"TotalActions":{"type":"integer"},"TimeoutActions":{"type":"integer"},"FailedActions":{"type":"integer"},"StoppedActions":{"type":"integer"},"SucceededActions":{"type":"integer"},"RunningActions":{"type":"integer"}}},"Graph":{"shape":"S4f"}}},"S4f":{"type":"structure","members":{"Nodes":{"type":"list","member":{"type":"structure","members":{"Type":{},"Name":{},"UniqueId":{},"TriggerDetails":{"type":"structure","members":{"Trigger":{"shape":"S3s"}}},"JobDetails":{"type":"structure","members":{"JobRuns":{"shape":"S4l"}}},"CrawlerDetails":{"type":"structure","members":{"Crawls":{"type":"list","member":{"type":"structure","members":{"State":{},"StartedOn":{"type":"timestamp"},"CompletedOn":{"type":"timestamp"},"ErrorMessage":{},"LogGroup":{},"LogStream":{}}}}}}}}},"Edges":{"type":"list","member":{"type":"structure","members":{"SourceId":{},"DestinationId":{}}}}}},"S4l":{"type":"list","member":{"shape":"S4m"}},"S4m":{"type":"structure","members":{"Id":{},"Attempt":{"type":"integer"},"PreviousRunId":{},"TriggerName":{},"JobName":{},"StartedOn":{"type":"timestamp"},"LastModifiedOn":{"type":"timestamp"},"CompletedOn":{"type":"timestamp"},"JobRunState":{},"Arguments":{"shape":"S3a"},"ErrorMessage":{},"PredecessorRuns":{"type":"list","member":{"type":"structure","members":{"JobName":{},"RunId":{}}}},"AllocatedCapacity":{"deprecated":true,"deprecatedMessage":"This property is deprecated, use MaxCapacity instead.","type":"integer"},"ExecutionTime":{"type":"integer"},"Timeout":{"type":"integer"},"MaxCapacity":{"type":"double"},"WorkerType":{},"NumberOfWorkers":{"type":"integer"},"SecurityConfiguration":{},"LogGroupName":{},"NotificationProperty":{"shape":"S3g"},"GlueVersion":{}}},"S5l":{"type":"list","member":{}},"S5o":{"type":"structure","required":["Name","ConnectionType","ConnectionProperties"],"members":{"Name":{},"Description":{},"ConnectionType":{},"MatchCriteria":{"shape":"S5q"},"ConnectionProperties":{"shape":"S5r"},"PhysicalConnectionRequirements":{"shape":"S5t"}}},"S5q":{"type":"list","member":{}},"S5r":{"type":"map","key":{},"value":{}},"S5t":{"type":"structure","members":{"SubnetId":{},"SecurityGroupIdList":{"type":"list","member":{}},"AvailabilityZone":{}}},"S5x":{"type":"map","key":{},"value":{}},"S62":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"LocationUri":{},"Parameters":{"shape":"Se"},"CreateTableDefaultPermissions":{"shape":"S64"}}},"S64":{"type":"list","member":{"type":"structure","members":{"Principal":{"type":"structure","members":{"DataLakePrincipalIdentifier":{}}},"Permissions":{"type":"list","member":{}}}}},"S6g":{"type":"list","member":{"type":"structure","required":["DatabaseName","TableName"],"members":{"DatabaseName":{},"TableName":{},"CatalogId":{},"ConnectionName":{}}}},"S6i":{"type":"structure","required":["TransformType"],"members":{"TransformType":{},"FindMatchesParameters":{"type":"structure","members":{"PrimaryKeyColumnName":{},"PrecisionRecallTradeoff":{"type":"double"},"AccuracyCostTradeoff":{"type":"double"},"EnforceProvidedLabels":{"type":"boolean"}}}}},"S6r":{"type":"list","member":{"type":"structure","required":["Id","NodeType","Args"],"members":{"Id":{},"NodeType":{},"Args":{"shape":"S6v"},"LineNumber":{"type":"integer"}}}},"S6v":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{},"Param":{"type":"boolean"}}}},"S6z":{"type":"list","member":{"type":"structure","required":["Source","Target"],"members":{"Source":{},"Target":{},"TargetParameter":{}}}},"S76":{"type":"structure","members":{"S3Encryption":{"type":"list","member":{"type":"structure","members":{"S3EncryptionMode":{},"KmsKeyArn":{}}}},"CloudWatchEncryption":{"type":"structure","members":{"CloudWatchEncryptionMode":{},"KmsKeyArn":{}}},"JobBookmarksEncryption":{"type":"structure","members":{"JobBookmarksEncryptionMode":{},"KmsKeyArn":{}}}}},"S7h":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"Owner":{},"LastAccessTime":{"type":"timestamp"},"LastAnalyzedTime":{"type":"timestamp"},"Retention":{"type":"integer"},"StorageDescriptor":{"shape":"S9"},"PartitionKeys":{"shape":"Sa"},"ViewOriginalText":{},"ViewExpandedText":{},"TableType":{},"Parameters":{"shape":"Se"}}},"S7q":{"type":"structure","members":{"FunctionName":{},"ClassName":{},"OwnerName":{},"OwnerType":{},"ResourceUris":{"shape":"S7s"}}},"S7s":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"Uri":{}}}},"S8x":{"type":"structure","members":{"GrokClassifier":{"type":"structure","required":["Name","Classification","GrokPattern"],"members":{"Name":{},"Classification":{},"CreationTime":{"type":"timestamp"},"LastUpdated":{"type":"timestamp"},"Version":{"type":"long"},"GrokPattern":{},"CustomPatterns":{}}},"XMLClassifier":{"type":"structure","required":["Name","Classification"],"members":{"Name":{},"Classification":{},"CreationTime":{"type":"timestamp"},"LastUpdated":{"type":"timestamp"},"Version":{"type":"long"},"RowTag":{}}},"JsonClassifier":{"type":"structure","required":["Name","JsonPath"],"members":{"Name":{},"CreationTime":{"type":"timestamp"},"LastUpdated":{"type":"timestamp"},"Version":{"type":"long"},"JsonPath":{}}},"CsvClassifier":{"type":"structure","required":["Name"],"members":{"Name":{},"CreationTime":{"type":"timestamp"},"LastUpdated":{"type":"timestamp"},"Version":{"type":"long"},"Delimiter":{},"QuoteSymbol":{},"ContainsHeader":{},"Header":{"shape":"S5l"},"DisableValueTrimming":{"type":"boolean"},"AllowSingleColumn":{"type":"boolean"}}}}},"S99":{"type":"structure","members":{"Name":{},"Description":{},"ConnectionType":{},"MatchCriteria":{"shape":"S5q"},"ConnectionProperties":{"shape":"S5r"},"PhysicalConnectionRequirements":{"shape":"S5t"},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"LastUpdatedBy":{}}},"S9p":{"type":"structure","members":{"EncryptionAtRest":{"type":"structure","required":["CatalogEncryptionMode"],"members":{"CatalogEncryptionMode":{},"SseAwsKmsKeyId":{}}},"ConnectionPasswordEncryption":{"type":"structure","required":["ReturnConnectionPasswordEncrypted"],"members":{"ReturnConnectionPasswordEncrypted":{"type":"boolean"},"AwsKmsKeyId":{}}}}},"S9v":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"LocationUri":{},"Parameters":{"shape":"Se"},"CreateTime":{"type":"timestamp"},"CreateTableDefaultPermissions":{"shape":"S64"}}},"Sab":{"type":"structure","members":{"JobName":{},"Version":{"type":"integer"},"Run":{"type":"integer"},"Attempt":{"type":"integer"},"PreviousRunId":{},"RunId":{},"JobBookmark":{}}},"Sal":{"type":"structure","members":{"TaskType":{},"ImportLabelsTaskRunProperties":{"type":"structure","members":{"InputS3Path":{},"Replace":{"type":"boolean"}}},"ExportLabelsTaskRunProperties":{"type":"structure","members":{"OutputS3Path":{}}},"LabelingSetGenerationTaskRunProperties":{"type":"structure","members":{"OutputS3Path":{}}},"FindMatchesTaskRunProperties":{"type":"structure","members":{"JobId":{},"JobName":{},"JobRunId":{}}}}},"Sb4":{"type":"structure","required":["TransformType"],"members":{"TransformType":{},"FindMatchesMetrics":{"type":"structure","members":{"AreaUnderPRCurve":{"type":"double"},"Precision":{"type":"double"},"Recall":{"type":"double"},"F1":{"type":"double"},"ConfusionMatrix":{"type":"structure","members":{"NumTruePositives":{"type":"long"},"NumFalsePositives":{"type":"long"},"NumTrueNegatives":{"type":"long"},"NumFalseNegatives":{"type":"long"}}}}}}},"Sb9":{"type":"list","member":{"type":"structure","members":{"Name":{},"DataType":{}}}},"Sbj":{"type":"structure","required":["DatabaseName","TableName"],"members":{"DatabaseName":{},"TableName":{}}},"Sbk":{"type":"list","member":{"shape":"Sbj"}},"Sbl":{"type":"structure","members":{"Jdbc":{"shape":"S6v"},"S3":{"shape":"S6v"},"DynamoDB":{"shape":"S6v"}}},"Sbn":{"type":"list","member":{"type":"structure","members":{"SourceTable":{},"SourcePath":{},"SourceType":{},"TargetTable":{},"TargetPath":{},"TargetType":{}}}},"Sc6":{"type":"structure","members":{"Name":{},"CreatedTimeStamp":{"type":"timestamp"},"EncryptionConfiguration":{"shape":"S76"}}},"Scc":{"type":"structure","required":["Name"],"members":{"Name":{},"DatabaseName":{},"Description":{},"Owner":{},"CreateTime":{"type":"timestamp"},"UpdateTime":{"type":"timestamp"},"LastAccessTime":{"type":"timestamp"},"LastAnalyzedTime":{"type":"timestamp"},"Retention":{"type":"integer"},"StorageDescriptor":{"shape":"S9"},"PartitionKeys":{"shape":"Sa"},"ViewOriginalText":{},"ViewExpandedText":{},"TableType":{},"Parameters":{"shape":"Se"},"CreatedBy":{},"IsRegisteredWithLakeFormation":{"type":"boolean"}}},"Scf":{"type":"structure","members":{"Table":{"shape":"Scc"},"VersionId":{}}},"Scm":{"type":"list","member":{"shape":"Scc"}},"Scw":{"type":"structure","members":{"FunctionName":{},"ClassName":{},"OwnerName":{},"OwnerType":{},"CreateTime":{"type":"timestamp"},"ResourceUris":{"shape":"S7s"}}}}}');

});

parcelRequire.register("cu312", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"GetClassifiers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetConnections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetCrawlerMetrics":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetCrawlers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetDatabases":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetDevEndpoints":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetJobRuns":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetMLTaskRuns":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetMLTransforms":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetPartitions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetSecurityConfigurations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SecurityConfigurations"},"GetTableVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetTables":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetTriggers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetUserDefinedFunctions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetWorkflowRuns":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListCrawlers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListDevEndpoints":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTriggers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListWorkflows":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"SearchTables":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"}}}');

});


parcelRequire.register("59O1g", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $3c1497cc601b2efc$var$Service = $dbC7k.Service;
var $3c1497cc601b2efc$var$apiLoader = $dbC7k.apiLoader;
$3c1497cc601b2efc$var$apiLoader.services["mobile"] = {};
$dbC7k.Mobile = $3c1497cc601b2efc$var$Service.defineService("mobile", [
    "2017-07-01"
]);


Object.defineProperty($3c1497cc601b2efc$var$apiLoader.services["mobile"], "2017-07-01", {
    get: function get() {
        var model = (parcelRequire("hwNhY"));
        model.paginators = (parcelRequire("dOS69")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Mobile;

});
parcelRequire.register("hwNhY", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-07-01","endpointPrefix":"mobile","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS Mobile","serviceId":"Mobile","signatureVersion":"v4","signingName":"AWSMobileHubService","uid":"mobile-2017-07-01"},"operations":{"CreateProject":{"http":{"requestUri":"/projects"},"input":{"type":"structure","members":{"name":{"location":"querystring","locationName":"name"},"region":{"location":"querystring","locationName":"region"},"contents":{"type":"blob"},"snapshotId":{"location":"querystring","locationName":"snapshotId"}},"payload":"contents"},"output":{"type":"structure","members":{"details":{"shape":"S7"}}}},"DeleteProject":{"http":{"method":"DELETE","requestUri":"/projects/{projectId}"},"input":{"type":"structure","required":["projectId"],"members":{"projectId":{"location":"uri","locationName":"projectId"}}},"output":{"type":"structure","members":{"deletedResources":{"shape":"Sc"},"orphanedResources":{"shape":"Sc"}}}},"DescribeBundle":{"http":{"method":"GET","requestUri":"/bundles/{bundleId}"},"input":{"type":"structure","required":["bundleId"],"members":{"bundleId":{"location":"uri","locationName":"bundleId"}}},"output":{"type":"structure","members":{"details":{"shape":"Sq"}}}},"DescribeProject":{"http":{"method":"GET","requestUri":"/project"},"input":{"type":"structure","required":["projectId"],"members":{"projectId":{"location":"querystring","locationName":"projectId"},"syncFromResources":{"location":"querystring","locationName":"syncFromResources","type":"boolean"}}},"output":{"type":"structure","members":{"details":{"shape":"S7"}}}},"ExportBundle":{"http":{"requestUri":"/bundles/{bundleId}"},"input":{"type":"structure","required":["bundleId"],"members":{"bundleId":{"location":"uri","locationName":"bundleId"},"projectId":{"location":"querystring","locationName":"projectId"},"platform":{"location":"querystring","locationName":"platform"}}},"output":{"type":"structure","members":{"downloadUrl":{}}}},"ExportProject":{"http":{"requestUri":"/exports/{projectId}"},"input":{"type":"structure","required":["projectId"],"members":{"projectId":{"location":"uri","locationName":"projectId"}}},"output":{"type":"structure","members":{"downloadUrl":{},"shareUrl":{},"snapshotId":{}}}},"ListBundles":{"http":{"method":"GET","requestUri":"/bundles"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"bundleList":{"type":"list","member":{"shape":"Sq"}},"nextToken":{}}}},"ListProjects":{"http":{"method":"GET","requestUri":"/projects"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"projects":{"type":"list","member":{"type":"structure","members":{"name":{},"projectId":{}}}},"nextToken":{}}}},"UpdateProject":{"http":{"requestUri":"/update"},"input":{"type":"structure","required":["projectId"],"members":{"contents":{"type":"blob"},"projectId":{"location":"querystring","locationName":"projectId"}},"payload":"contents"},"output":{"type":"structure","members":{"details":{"shape":"S7"}}}}},"shapes":{"S7":{"type":"structure","members":{"name":{},"projectId":{},"region":{},"state":{},"createdDate":{"type":"timestamp"},"lastUpdatedDate":{"type":"timestamp"},"consoleUrl":{},"resources":{"shape":"Sc"}}},"Sc":{"type":"list","member":{"type":"structure","members":{"type":{},"name":{},"arn":{},"feature":{},"attributes":{"type":"map","key":{},"value":{}}}}},"Sq":{"type":"structure","members":{"bundleId":{},"title":{},"version":{},"description":{},"iconUrl":{},"availablePlatforms":{"type":"list","member":{}}}}}}');

});

parcelRequire.register("dOS69", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListBundles":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListProjects":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}');

});


parcelRequire.register("ahwWJ", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $77c50c59e845ebce$var$Service = $dbC7k.Service;
var $77c50c59e845ebce$var$apiLoader = $dbC7k.apiLoader;
$77c50c59e845ebce$var$apiLoader.services["pricing"] = {};
$dbC7k.Pricing = $77c50c59e845ebce$var$Service.defineService("pricing", [
    "2017-10-15"
]);


Object.defineProperty($77c50c59e845ebce$var$apiLoader.services["pricing"], "2017-10-15", {
    get: function get() {
        var model = (parcelRequire("8TPU5"));
        model.paginators = (parcelRequire("54J3h")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Pricing;

});
parcelRequire.register("8TPU5", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-10-15","endpointPrefix":"api.pricing","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"AWS Pricing","serviceFullName":"AWS Price List Service","serviceId":"Pricing","signatureVersion":"v4","signingName":"pricing","targetPrefix":"AWSPriceListService","uid":"pricing-2017-10-15"},"operations":{"DescribeServices":{"input":{"type":"structure","members":{"ServiceCode":{},"FormatVersion":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Services":{"type":"list","member":{"type":"structure","members":{"ServiceCode":{},"AttributeNames":{"type":"list","member":{}}}}},"FormatVersion":{},"NextToken":{}}}},"GetAttributeValues":{"input":{"type":"structure","required":["ServiceCode","AttributeName"],"members":{"ServiceCode":{},"AttributeName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AttributeValues":{"type":"list","member":{"type":"structure","members":{"Value":{}}}},"NextToken":{}}}},"GetProducts":{"input":{"type":"structure","members":{"ServiceCode":{},"Filters":{"type":"list","member":{"type":"structure","required":["Type","Field","Value"],"members":{"Type":{},"Field":{},"Value":{}}}},"FormatVersion":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FormatVersion":{},"PriceList":{"type":"list","member":{"jsonvalue":true}},"NextToken":{}}}}},"shapes":{}}');

});

parcelRequire.register("54J3h", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeServices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetAttributeValues":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetProducts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("61k9P", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $462278ed90366262$var$Service = $dbC7k.Service;
var $462278ed90366262$var$apiLoader = $dbC7k.apiLoader;
$462278ed90366262$var$apiLoader.services["costexplorer"] = {};
$dbC7k.CostExplorer = $462278ed90366262$var$Service.defineService("costexplorer", [
    "2017-10-25"
]);


Object.defineProperty($462278ed90366262$var$apiLoader.services["costexplorer"], "2017-10-25", {
    get: function get() {
        var model = (parcelRequire("cOy93"));
        model.paginators = (parcelRequire("avXBN")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.CostExplorer;

});
parcelRequire.register("cOy93", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-10-25","endpointPrefix":"ce","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"AWS Cost Explorer","serviceFullName":"AWS Cost Explorer Service","serviceId":"Cost Explorer","signatureVersion":"v4","signingName":"ce","targetPrefix":"AWSInsightsIndexService","uid":"ce-2017-10-25"},"operations":{"GetCostAndUsage":{"input":{"type":"structure","required":["TimePeriod"],"members":{"TimePeriod":{"shape":"S2"},"Granularity":{},"Filter":{"shape":"S5"},"Metrics":{"shape":"Sd"},"GroupBy":{"shape":"Sf"},"NextPageToken":{}}},"output":{"type":"structure","members":{"NextPageToken":{},"GroupDefinitions":{"shape":"Sf"},"ResultsByTime":{"type":"list","member":{"type":"structure","members":{"TimePeriod":{"shape":"S2"},"Total":{"shape":"Sn"},"Groups":{"type":"list","member":{"type":"structure","members":{"Keys":{"type":"list","member":{}},"Metrics":{"shape":"Sn"}}}},"Estimated":{"type":"boolean"}}}}}}},"GetCostForecast":{"input":{"type":"structure","required":["TimePeriod","Metric","Granularity"],"members":{"TimePeriod":{"shape":"S2"},"Metric":{},"Granularity":{},"Filter":{"shape":"S5"},"PredictionIntervalLevel":{"type":"integer"}}},"output":{"type":"structure","members":{"Total":{"shape":"So"},"ForecastResultsByTime":{"shape":"S10"}}}},"GetDimensionValues":{"input":{"type":"structure","required":["TimePeriod","Dimension"],"members":{"SearchString":{},"TimePeriod":{"shape":"S2"},"Dimension":{},"Context":{},"NextPageToken":{}}},"output":{"type":"structure","required":["DimensionValues","ReturnSize","TotalSize"],"members":{"DimensionValues":{"type":"list","member":{"type":"structure","members":{"Value":{},"Attributes":{"shape":"S19"}}}},"ReturnSize":{"type":"integer"},"TotalSize":{"type":"integer"},"NextPageToken":{}}}},"GetReservationCoverage":{"input":{"type":"structure","required":["TimePeriod"],"members":{"TimePeriod":{"shape":"S2"},"GroupBy":{"shape":"Sf"},"Granularity":{},"Filter":{"shape":"S5"},"Metrics":{"shape":"Sd"},"NextPageToken":{}}},"output":{"type":"structure","required":["CoveragesByTime"],"members":{"CoveragesByTime":{"type":"list","member":{"type":"structure","members":{"TimePeriod":{"shape":"S2"},"Groups":{"type":"list","member":{"type":"structure","members":{"Attributes":{"shape":"S19"},"Coverage":{"shape":"S1j"}}}},"Total":{"shape":"S1j"}}}},"Total":{"shape":"S1j"},"NextPageToken":{}}}},"GetReservationPurchaseRecommendation":{"input":{"type":"structure","required":["Service"],"members":{"AccountId":{},"Service":{},"AccountScope":{},"LookbackPeriodInDays":{},"TermInYears":{},"PaymentOption":{},"ServiceSpecification":{"shape":"S21"},"PageSize":{"type":"integer"},"NextPageToken":{}}},"output":{"type":"structure","members":{"Metadata":{"type":"structure","members":{"RecommendationId":{},"GenerationTimestamp":{}}},"Recommendations":{"type":"list","member":{"type":"structure","members":{"AccountScope":{},"LookbackPeriodInDays":{},"TermInYears":{},"PaymentOption":{},"ServiceSpecification":{"shape":"S21"},"RecommendationDetails":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"InstanceDetails":{"type":"structure","members":{"EC2InstanceDetails":{"type":"structure","members":{"Family":{},"InstanceType":{},"Region":{},"AvailabilityZone":{},"Platform":{},"Tenancy":{},"CurrentGeneration":{"type":"boolean"},"SizeFlexEligible":{"type":"boolean"}}},"RDSInstanceDetails":{"type":"structure","members":{"Family":{},"InstanceType":{},"Region":{},"DatabaseEngine":{},"DatabaseEdition":{},"DeploymentOption":{},"LicenseModel":{},"CurrentGeneration":{"type":"boolean"},"SizeFlexEligible":{"type":"boolean"}}},"RedshiftInstanceDetails":{"type":"structure","members":{"Family":{},"NodeType":{},"Region":{},"CurrentGeneration":{"type":"boolean"},"SizeFlexEligible":{"type":"boolean"}}},"ElastiCacheInstanceDetails":{"type":"structure","members":{"Family":{},"NodeType":{},"Region":{},"ProductDescription":{},"CurrentGeneration":{"type":"boolean"},"SizeFlexEligible":{"type":"boolean"}}},"ESInstanceDetails":{"type":"structure","members":{"InstanceClass":{},"InstanceSize":{},"Region":{},"CurrentGeneration":{"type":"boolean"},"SizeFlexEligible":{"type":"boolean"}}}}},"RecommendedNumberOfInstancesToPurchase":{},"RecommendedNormalizedUnitsToPurchase":{},"MinimumNumberOfInstancesUsedPerHour":{},"MinimumNormalizedUnitsUsedPerHour":{},"MaximumNumberOfInstancesUsedPerHour":{},"MaximumNormalizedUnitsUsedPerHour":{},"AverageNumberOfInstancesUsedPerHour":{},"AverageNormalizedUnitsUsedPerHour":{},"AverageUtilization":{},"EstimatedBreakEvenInMonths":{},"CurrencyCode":{},"EstimatedMonthlySavingsAmount":{},"EstimatedMonthlySavingsPercentage":{},"EstimatedMonthlyOnDemandCost":{},"EstimatedReservationCostForLookbackPeriod":{},"UpfrontCost":{},"RecurringStandardMonthlyCost":{}}}},"RecommendationSummary":{"type":"structure","members":{"TotalEstimatedMonthlySavingsAmount":{},"TotalEstimatedMonthlySavingsPercentage":{},"CurrencyCode":{}}}}}},"NextPageToken":{}}}},"GetReservationUtilization":{"input":{"type":"structure","required":["TimePeriod"],"members":{"TimePeriod":{"shape":"S2"},"GroupBy":{"shape":"Sf"},"Granularity":{},"Filter":{"shape":"S5"},"NextPageToken":{}}},"output":{"type":"structure","required":["UtilizationsByTime"],"members":{"UtilizationsByTime":{"type":"list","member":{"type":"structure","members":{"TimePeriod":{"shape":"S2"},"Groups":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"Attributes":{"shape":"S19"},"Utilization":{"shape":"S2r"}}}},"Total":{"shape":"S2r"}}}},"Total":{"shape":"S2r"},"NextPageToken":{}}}},"GetRightsizingRecommendation":{"input":{"type":"structure","required":["Service"],"members":{"Filter":{"shape":"S5"},"Service":{},"PageSize":{"type":"integer"},"NextPageToken":{}}},"output":{"type":"structure","members":{"Metadata":{"type":"structure","members":{"RecommendationId":{},"GenerationTimestamp":{},"LookbackPeriodInDays":{}}},"Summary":{"type":"structure","members":{"TotalRecommendationCount":{},"EstimatedTotalMonthlySavingsAmount":{},"SavingsCurrencyCode":{},"SavingsPercentage":{}}},"RightsizingRecommendations":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"CurrentInstance":{"type":"structure","members":{"ResourceId":{},"Tags":{"type":"list","member":{"shape":"Sb"}},"ResourceDetails":{"shape":"S3e"},"ResourceUtilization":{"shape":"S3g"},"ReservationCoveredHoursInLookbackPeriod":{},"OnDemandHoursInLookbackPeriod":{},"TotalRunningHoursInLookbackPeriod":{},"MonthlyCost":{},"CurrencyCode":{}}},"RightsizingType":{},"ModifyRecommendationDetail":{"type":"structure","members":{"TargetInstances":{"type":"list","member":{"type":"structure","members":{"EstimatedMonthlyCost":{},"EstimatedMonthlySavings":{},"CurrencyCode":{},"DefaultTargetInstance":{"type":"boolean"},"ResourceDetails":{"shape":"S3e"},"ExpectedResourceUtilization":{"shape":"S3g"}}}}}},"TerminateRecommendationDetail":{"type":"structure","members":{"EstimatedMonthlySavings":{},"CurrencyCode":{}}}}}},"NextPageToken":{}}}},"GetTags":{"input":{"type":"structure","required":["TimePeriod"],"members":{"SearchString":{},"TimePeriod":{"shape":"S2"},"TagKey":{},"NextPageToken":{}}},"output":{"type":"structure","required":["Tags","ReturnSize","TotalSize"],"members":{"NextPageToken":{},"Tags":{"type":"list","member":{}},"ReturnSize":{"type":"integer"},"TotalSize":{"type":"integer"}}}},"GetUsageForecast":{"input":{"type":"structure","required":["TimePeriod","Metric","Granularity"],"members":{"TimePeriod":{"shape":"S2"},"Metric":{},"Granularity":{},"Filter":{"shape":"S5"},"PredictionIntervalLevel":{"type":"integer"}}},"output":{"type":"structure","members":{"Total":{"shape":"So"},"ForecastResultsByTime":{"shape":"S10"}}}}},"shapes":{"S2":{"type":"structure","required":["Start","End"],"members":{"Start":{},"End":{}}},"S5":{"type":"structure","members":{"Or":{"shape":"S6"},"And":{"shape":"S6"},"Not":{"shape":"S5"},"Dimensions":{"type":"structure","members":{"Key":{},"Values":{"shape":"S9"}}},"Tags":{"shape":"Sb"}}},"S6":{"type":"list","member":{"shape":"S5"}},"S9":{"type":"list","member":{}},"Sb":{"type":"structure","members":{"Key":{},"Values":{"shape":"S9"}}},"Sd":{"type":"list","member":{}},"Sf":{"type":"list","member":{"type":"structure","members":{"Type":{},"Key":{}}}},"Sn":{"type":"map","key":{},"value":{"shape":"So"}},"So":{"type":"structure","members":{"Amount":{},"Unit":{}}},"S10":{"type":"list","member":{"type":"structure","members":{"TimePeriod":{"shape":"S2"},"MeanValue":{},"PredictionIntervalLowerBound":{},"PredictionIntervalUpperBound":{}}}},"S19":{"type":"map","key":{},"value":{}},"S1j":{"type":"structure","members":{"CoverageHours":{"type":"structure","members":{"OnDemandHours":{},"ReservedHours":{},"TotalRunningHours":{},"CoverageHoursPercentage":{}}},"CoverageNormalizedUnits":{"type":"structure","members":{"OnDemandNormalizedUnits":{},"ReservedNormalizedUnits":{},"TotalRunningNormalizedUnits":{},"CoverageNormalizedUnitsPercentage":{}}},"CoverageCost":{"type":"structure","members":{"OnDemandCost":{}}}}},"S21":{"type":"structure","members":{"EC2Specification":{"type":"structure","members":{"OfferingClass":{}}}}},"S2r":{"type":"structure","members":{"UtilizationPercentage":{},"UtilizationPercentageInUnits":{},"PurchasedHours":{},"PurchasedUnits":{},"TotalActualHours":{},"TotalActualUnits":{},"UnusedHours":{},"UnusedUnits":{},"OnDemandCostOfRIHoursUsed":{},"NetRISavings":{},"TotalPotentialRISavings":{},"AmortizedUpfrontFee":{},"AmortizedRecurringFee":{},"TotalAmortizedFee":{}}},"S3e":{"type":"structure","members":{"EC2ResourceDetails":{"type":"structure","members":{"HourlyOnDemandRate":{},"InstanceType":{},"Platform":{},"Region":{},"Sku":{},"Memory":{},"NetworkPerformance":{},"Storage":{},"Vcpu":{}}}}},"S3g":{"type":"structure","members":{"EC2ResourceUtilization":{"type":"structure","members":{"MaxCpuUtilizationPercentage":{},"MaxMemoryUtilizationPercentage":{},"MaxStorageUtilizationPercentage":{}}}}}}}');

});

parcelRequire.register("avXBN", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("62HZl", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $0122a9809f3a4efe$var$Service = $dbC7k.Service;
var $0122a9809f3a4efe$var$apiLoader = $dbC7k.apiLoader;
$0122a9809f3a4efe$var$apiLoader.services["mediaconvert"] = {};
$dbC7k.MediaConvert = $0122a9809f3a4efe$var$Service.defineService("mediaconvert", [
    "2017-08-29"
]);


Object.defineProperty($0122a9809f3a4efe$var$apiLoader.services["mediaconvert"], "2017-08-29", {
    get: function get() {
        var model = (parcelRequire("diSKv"));
        model.paginators = (parcelRequire("4EvZl")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.MediaConvert;

});
parcelRequire.register("diSKv", function(module, exports) {
module.exports = JSON.parse('{"metadata":{"apiVersion":"2017-08-29","endpointPrefix":"mediaconvert","signingName":"mediaconvert","serviceFullName":"AWS Elemental MediaConvert","serviceId":"MediaConvert","protocol":"rest-json","jsonVersion":"1.1","uid":"mediaconvert-2017-08-29","signatureVersion":"v4","serviceAbbreviation":"MediaConvert"},"operations":{"AssociateCertificate":{"http":{"requestUri":"/2017-08-29/certificates","responseCode":201},"input":{"type":"structure","members":{"Arn":{"locationName":"arn"}},"required":["Arn"]},"output":{"type":"structure","members":{}}},"CancelJob":{"http":{"method":"DELETE","requestUri":"/2017-08-29/jobs/{id}","responseCode":202},"input":{"type":"structure","members":{"Id":{"locationName":"id","location":"uri"}},"required":["Id"]},"output":{"type":"structure","members":{}}},"CreateJob":{"http":{"requestUri":"/2017-08-29/jobs","responseCode":201},"input":{"type":"structure","members":{"AccelerationSettings":{"shape":"S7","locationName":"accelerationSettings"},"BillingTagsSource":{"locationName":"billingTagsSource"},"ClientRequestToken":{"locationName":"clientRequestToken","idempotencyToken":true},"JobTemplate":{"locationName":"jobTemplate"},"Priority":{"locationName":"priority","type":"integer"},"Queue":{"locationName":"queue"},"Role":{"locationName":"role"},"Settings":{"shape":"Sb","locationName":"settings"},"StatusUpdateInterval":{"locationName":"statusUpdateInterval"},"UserMetadata":{"shape":"Sd5","locationName":"userMetadata"}},"required":["Role","Settings"]},"output":{"type":"structure","members":{"Job":{"shape":"Sd7","locationName":"job"}}}},"CreateJobTemplate":{"http":{"requestUri":"/2017-08-29/jobTemplates","responseCode":201},"input":{"type":"structure","members":{"AccelerationSettings":{"shape":"S7","locationName":"accelerationSettings"},"Category":{"locationName":"category"},"Description":{"locationName":"description"},"Name":{"locationName":"name"},"Priority":{"locationName":"priority","type":"integer"},"Queue":{"locationName":"queue"},"Settings":{"shape":"Sdj","locationName":"settings"},"StatusUpdateInterval":{"locationName":"statusUpdateInterval"},"Tags":{"shape":"Sd5","locationName":"tags"}},"required":["Settings","Name"]},"output":{"type":"structure","members":{"JobTemplate":{"shape":"Sdn","locationName":"jobTemplate"}}}},"CreatePreset":{"http":{"requestUri":"/2017-08-29/presets","responseCode":201},"input":{"type":"structure","members":{"Category":{"locationName":"category"},"Description":{"locationName":"description"},"Name":{"locationName":"name"},"Settings":{"shape":"Sdq","locationName":"settings"},"Tags":{"shape":"Sd5","locationName":"tags"}},"required":["Settings","Name"]},"output":{"type":"structure","members":{"Preset":{"shape":"Sdu","locationName":"preset"}}}},"CreateQueue":{"http":{"requestUri":"/2017-08-29/queues","responseCode":201},"input":{"type":"structure","members":{"Description":{"locationName":"description"},"Name":{"locationName":"name"},"PricingPlan":{"locationName":"pricingPlan"},"ReservationPlanSettings":{"shape":"Sdx","locationName":"reservationPlanSettings"},"Status":{"locationName":"status"},"Tags":{"shape":"Sd5","locationName":"tags"}},"required":["Name"]},"output":{"type":"structure","members":{"Queue":{"shape":"Se2","locationName":"queue"}}}},"DeleteJobTemplate":{"http":{"method":"DELETE","requestUri":"/2017-08-29/jobTemplates/{name}","responseCode":202},"input":{"type":"structure","members":{"Name":{"locationName":"name","location":"uri"}},"required":["Name"]},"output":{"type":"structure","members":{}}},"DeletePreset":{"http":{"method":"DELETE","requestUri":"/2017-08-29/presets/{name}","responseCode":202},"input":{"type":"structure","members":{"Name":{"locationName":"name","location":"uri"}},"required":["Name"]},"output":{"type":"structure","members":{}}},"DeleteQueue":{"http":{"method":"DELETE","requestUri":"/2017-08-29/queues/{name}","responseCode":202},"input":{"type":"structure","members":{"Name":{"locationName":"name","location":"uri"}},"required":["Name"]},"output":{"type":"structure","members":{}}},"DescribeEndpoints":{"http":{"requestUri":"/2017-08-29/endpoints","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"locationName":"maxResults","type":"integer"},"Mode":{"locationName":"mode"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Endpoints":{"locationName":"endpoints","type":"list","member":{"type":"structure","members":{"Url":{"locationName":"url"}}}},"NextToken":{"locationName":"nextToken"}}}},"DisassociateCertificate":{"http":{"method":"DELETE","requestUri":"/2017-08-29/certificates/{arn}","responseCode":202},"input":{"type":"structure","members":{"Arn":{"locationName":"arn","location":"uri"}},"required":["Arn"]},"output":{"type":"structure","members":{}}},"GetJob":{"http":{"method":"GET","requestUri":"/2017-08-29/jobs/{id}","responseCode":200},"input":{"type":"structure","members":{"Id":{"locationName":"id","location":"uri"}},"required":["Id"]},"output":{"type":"structure","members":{"Job":{"shape":"Sd7","locationName":"job"}}}},"GetJobTemplate":{"http":{"method":"GET","requestUri":"/2017-08-29/jobTemplates/{name}","responseCode":200},"input":{"type":"structure","members":{"Name":{"locationName":"name","location":"uri"}},"required":["Name"]},"output":{"type":"structure","members":{"JobTemplate":{"shape":"Sdn","locationName":"jobTemplate"}}}},"GetPreset":{"http":{"method":"GET","requestUri":"/2017-08-29/presets/{name}","responseCode":200},"input":{"type":"structure","members":{"Name":{"locationName":"name","location":"uri"}},"required":["Name"]},"output":{"type":"structure","members":{"Preset":{"shape":"Sdu","locationName":"preset"}}}},"GetQueue":{"http":{"method":"GET","requestUri":"/2017-08-29/queues/{name}","responseCode":200},"input":{"type":"structure","members":{"Name":{"locationName":"name","location":"uri"}},"required":["Name"]},"output":{"type":"structure","members":{"Queue":{"shape":"Se2","locationName":"queue"}}}},"ListJobTemplates":{"http":{"method":"GET","requestUri":"/2017-08-29/jobTemplates","responseCode":200},"input":{"type":"structure","members":{"Category":{"locationName":"category","location":"querystring"},"ListBy":{"locationName":"listBy","location":"querystring"},"MaxResults":{"locationName":"maxResults","location":"querystring","type":"integer"},"NextToken":{"locationName":"nextToken","location":"querystring"},"Order":{"locationName":"order","location":"querystring"}}},"output":{"type":"structure","members":{"JobTemplates":{"locationName":"jobTemplates","type":"list","member":{"shape":"Sdn"}},"NextToken":{"locationName":"nextToken"}}}},"ListJobs":{"http":{"method":"GET","requestUri":"/2017-08-29/jobs","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"locationName":"maxResults","location":"querystring","type":"integer"},"NextToken":{"locationName":"nextToken","location":"querystring"},"Order":{"locationName":"order","location":"querystring"},"Queue":{"locationName":"queue","location":"querystring"},"Status":{"locationName":"status","location":"querystring"}}},"output":{"type":"structure","members":{"Jobs":{"locationName":"jobs","type":"list","member":{"shape":"Sd7"}},"NextToken":{"locationName":"nextToken"}}}},"ListPresets":{"http":{"method":"GET","requestUri":"/2017-08-29/presets","responseCode":200},"input":{"type":"structure","members":{"Category":{"locationName":"category","location":"querystring"},"ListBy":{"locationName":"listBy","location":"querystring"},"MaxResults":{"locationName":"maxResults","location":"querystring","type":"integer"},"NextToken":{"locationName":"nextToken","location":"querystring"},"Order":{"locationName":"order","location":"querystring"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Presets":{"locationName":"presets","type":"list","member":{"shape":"Sdu"}}}}},"ListQueues":{"http":{"method":"GET","requestUri":"/2017-08-29/queues","responseCode":200},"input":{"type":"structure","members":{"ListBy":{"locationName":"listBy","location":"querystring"},"MaxResults":{"locationName":"maxResults","location":"querystring","type":"integer"},"NextToken":{"locationName":"nextToken","location":"querystring"},"Order":{"locationName":"order","location":"querystring"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Queues":{"locationName":"queues","type":"list","member":{"shape":"Se2"}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2017-08-29/tags/{arn}","responseCode":200},"input":{"type":"structure","members":{"Arn":{"locationName":"arn","location":"uri"}},"required":["Arn"]},"output":{"type":"structure","members":{"ResourceTags":{"locationName":"resourceTags","type":"structure","members":{"Arn":{"locationName":"arn"},"Tags":{"shape":"Sd5","locationName":"tags"}}}}}},"TagResource":{"http":{"requestUri":"/2017-08-29/tags","responseCode":200},"input":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Tags":{"shape":"Sd5","locationName":"tags"}},"required":["Arn","Tags"]},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"PUT","requestUri":"/2017-08-29/tags/{arn}","responseCode":200},"input":{"type":"structure","members":{"Arn":{"locationName":"arn","location":"uri"},"TagKeys":{"locationName":"tagKeys","type":"list","member":{}}},"required":["Arn"]},"output":{"type":"structure","members":{}}},"UpdateJobTemplate":{"http":{"method":"PUT","requestUri":"/2017-08-29/jobTemplates/{name}","responseCode":200},"input":{"type":"structure","members":{"AccelerationSettings":{"shape":"S7","locationName":"accelerationSettings"},"Category":{"locationName":"category"},"Description":{"locationName":"description"},"Name":{"locationName":"name","location":"uri"},"Priority":{"locationName":"priority","type":"integer"},"Queue":{"locationName":"queue"},"Settings":{"shape":"Sdj","locationName":"settings"},"StatusUpdateInterval":{"locationName":"statusUpdateInterval"}},"required":["Name"]},"output":{"type":"structure","members":{"JobTemplate":{"shape":"Sdn","locationName":"jobTemplate"}}}},"UpdatePreset":{"http":{"method":"PUT","requestUri":"/2017-08-29/presets/{name}","responseCode":200},"input":{"type":"structure","members":{"Category":{"locationName":"category"},"Description":{"locationName":"description"},"Name":{"locationName":"name","location":"uri"},"Settings":{"shape":"Sdq","locationName":"settings"}},"required":["Name"]},"output":{"type":"structure","members":{"Preset":{"shape":"Sdu","locationName":"preset"}}}},"UpdateQueue":{"http":{"method":"PUT","requestUri":"/2017-08-29/queues/{name}","responseCode":200},"input":{"type":"structure","members":{"Description":{"locationName":"description"},"Name":{"locationName":"name","location":"uri"},"ReservationPlanSettings":{"shape":"Sdx","locationName":"reservationPlanSettings"},"Status":{"locationName":"status"}},"required":["Name"]},"output":{"type":"structure","members":{"Queue":{"shape":"Se2","locationName":"queue"}}}}},"shapes":{"S7":{"type":"structure","members":{"Mode":{"locationName":"mode"}},"required":["Mode"]},"Sb":{"type":"structure","members":{"AdAvailOffset":{"locationName":"adAvailOffset","type":"integer"},"AvailBlanking":{"shape":"Sd","locationName":"availBlanking"},"Esam":{"shape":"Sf","locationName":"esam"},"Inputs":{"locationName":"inputs","type":"list","member":{"type":"structure","members":{"AudioSelectorGroups":{"shape":"Sn","locationName":"audioSelectorGroups"},"AudioSelectors":{"shape":"Sr","locationName":"audioSelectors"},"CaptionSelectors":{"shape":"S1a","locationName":"captionSelectors"},"Crop":{"shape":"S1q","locationName":"crop"},"DeblockFilter":{"locationName":"deblockFilter"},"DecryptionSettings":{"locationName":"decryptionSettings","type":"structure","members":{"DecryptionMode":{"locationName":"decryptionMode"},"EncryptedDecryptionKey":{"locationName":"encryptedDecryptionKey"},"InitializationVector":{"locationName":"initializationVector"},"KmsKeyRegion":{"locationName":"kmsKeyRegion"}}},"DenoiseFilter":{"locationName":"denoiseFilter"},"FileInput":{"locationName":"fileInput"},"FilterEnable":{"locationName":"filterEnable"},"FilterStrength":{"locationName":"filterStrength","type":"integer"},"ImageInserter":{"shape":"S23","locationName":"imageInserter"},"InputClippings":{"shape":"S2a","locationName":"inputClippings"},"Position":{"shape":"S1q","locationName":"position"},"ProgramNumber":{"locationName":"programNumber","type":"integer"},"PsiControl":{"locationName":"psiControl"},"SupplementalImps":{"locationName":"supplementalImps","type":"list","member":{}},"TimecodeSource":{"locationName":"timecodeSource"},"VideoSelector":{"shape":"S2h","locationName":"videoSelector"}}}},"MotionImageInserter":{"shape":"S2o","locationName":"motionImageInserter"},"NielsenConfiguration":{"shape":"S2x","locationName":"nielsenConfiguration"},"OutputGroups":{"shape":"S2z","locationName":"outputGroups"},"TimecodeConfig":{"shape":"Scx","locationName":"timecodeConfig"},"TimedMetadataInsertion":{"shape":"Sd0","locationName":"timedMetadataInsertion"}}},"Sd":{"type":"structure","members":{"AvailBlankingImage":{"locationName":"availBlankingImage"}}},"Sf":{"type":"structure","members":{"ManifestConfirmConditionNotification":{"locationName":"manifestConfirmConditionNotification","type":"structure","members":{"MccXml":{"locationName":"mccXml"}}},"ResponseSignalPreroll":{"locationName":"responseSignalPreroll","type":"integer"},"SignalProcessingNotification":{"locationName":"signalProcessingNotification","type":"structure","members":{"SccXml":{"locationName":"sccXml"}}}}},"Sn":{"type":"map","key":{},"value":{"type":"structure","members":{"AudioSelectorNames":{"locationName":"audioSelectorNames","type":"list","member":{}}}}},"Sr":{"type":"map","key":{},"value":{"type":"structure","members":{"CustomLanguageCode":{"locationName":"customLanguageCode"},"DefaultSelection":{"locationName":"defaultSelection"},"ExternalAudioFileInput":{"locationName":"externalAudioFileInput"},"LanguageCode":{"locationName":"languageCode"},"Offset":{"locationName":"offset","type":"integer"},"Pids":{"shape":"Sy","locationName":"pids"},"ProgramSelection":{"locationName":"programSelection","type":"integer"},"RemixSettings":{"shape":"S11","locationName":"remixSettings"},"SelectorType":{"locationName":"selectorType"},"Tracks":{"shape":"Sy","locationName":"tracks"}}}},"Sy":{"type":"list","member":{"type":"integer"}},"S11":{"type":"structure","members":{"ChannelMapping":{"locationName":"channelMapping","type":"structure","members":{"OutputChannels":{"locationName":"outputChannels","type":"list","member":{"type":"structure","members":{"InputChannels":{"locationName":"inputChannels","type":"list","member":{"type":"integer"}}}}}}},"ChannelsIn":{"locationName":"channelsIn","type":"integer"},"ChannelsOut":{"locationName":"channelsOut","type":"integer"}}},"S1a":{"type":"map","key":{},"value":{"type":"structure","members":{"CustomLanguageCode":{"locationName":"customLanguageCode"},"LanguageCode":{"locationName":"languageCode"},"SourceSettings":{"locationName":"sourceSettings","type":"structure","members":{"AncillarySourceSettings":{"locationName":"ancillarySourceSettings","type":"structure","members":{"SourceAncillaryChannelNumber":{"locationName":"sourceAncillaryChannelNumber","type":"integer"}}},"DvbSubSourceSettings":{"locationName":"dvbSubSourceSettings","type":"structure","members":{"Pid":{"locationName":"pid","type":"integer"}}},"EmbeddedSourceSettings":{"locationName":"embeddedSourceSettings","type":"structure","members":{"Convert608To708":{"locationName":"convert608To708"},"Source608ChannelNumber":{"locationName":"source608ChannelNumber","type":"integer"},"Source608TrackNumber":{"locationName":"source608TrackNumber","type":"integer"}}},"FileSourceSettings":{"locationName":"fileSourceSettings","type":"structure","members":{"Convert608To708":{"locationName":"convert608To708"},"SourceFile":{"locationName":"sourceFile"},"TimeDelta":{"locationName":"timeDelta","type":"integer"}}},"SourceType":{"locationName":"sourceType"},"TeletextSourceSettings":{"locationName":"teletextSourceSettings","type":"structure","members":{"PageNumber":{"locationName":"pageNumber"}}},"TrackSourceSettings":{"locationName":"trackSourceSettings","type":"structure","members":{"TrackNumber":{"locationName":"trackNumber","type":"integer"}}}}}}}},"S1q":{"type":"structure","members":{"Height":{"locationName":"height","type":"integer"},"Width":{"locationName":"width","type":"integer"},"X":{"locationName":"x","type":"integer"},"Y":{"locationName":"y","type":"integer"}}},"S23":{"type":"structure","members":{"InsertableImages":{"locationName":"insertableImages","type":"list","member":{"type":"structure","members":{"Duration":{"locationName":"duration","type":"integer"},"FadeIn":{"locationName":"fadeIn","type":"integer"},"FadeOut":{"locationName":"fadeOut","type":"integer"},"Height":{"locationName":"height","type":"integer"},"ImageInserterInput":{"locationName":"imageInserterInput"},"ImageX":{"locationName":"imageX","type":"integer"},"ImageY":{"locationName":"imageY","type":"integer"},"Layer":{"locationName":"layer","type":"integer"},"Opacity":{"locationName":"opacity","type":"integer"},"StartTime":{"locationName":"startTime"},"Width":{"locationName":"width","type":"integer"}}}}}},"S2a":{"type":"list","member":{"type":"structure","members":{"EndTimecode":{"locationName":"endTimecode"},"StartTimecode":{"locationName":"startTimecode"}}}},"S2h":{"type":"structure","members":{"ColorSpace":{"locationName":"colorSpace"},"ColorSpaceUsage":{"locationName":"colorSpaceUsage"},"Hdr10Metadata":{"shape":"S2k","locationName":"hdr10Metadata"},"Pid":{"locationName":"pid","type":"integer"},"ProgramNumber":{"locationName":"programNumber","type":"integer"},"Rotate":{"locationName":"rotate"}}},"S2k":{"type":"structure","members":{"BluePrimaryX":{"locationName":"bluePrimaryX","type":"integer"},"BluePrimaryY":{"locationName":"bluePrimaryY","type":"integer"},"GreenPrimaryX":{"locationName":"greenPrimaryX","type":"integer"},"GreenPrimaryY":{"locationName":"greenPrimaryY","type":"integer"},"MaxContentLightLevel":{"locationName":"maxContentLightLevel","type":"integer"},"MaxFrameAverageLightLevel":{"locationName":"maxFrameAverageLightLevel","type":"integer"},"MaxLuminance":{"locationName":"maxLuminance","type":"integer"},"MinLuminance":{"locationName":"minLuminance","type":"integer"},"RedPrimaryX":{"locationName":"redPrimaryX","type":"integer"},"RedPrimaryY":{"locationName":"redPrimaryY","type":"integer"},"WhitePointX":{"locationName":"whitePointX","type":"integer"},"WhitePointY":{"locationName":"whitePointY","type":"integer"}}},"S2o":{"type":"structure","members":{"Framerate":{"locationName":"framerate","type":"structure","members":{"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"}}},"Input":{"locationName":"input"},"InsertionMode":{"locationName":"insertionMode"},"Offset":{"locationName":"offset","type":"structure","members":{"ImageX":{"locationName":"imageX","type":"integer"},"ImageY":{"locationName":"imageY","type":"integer"}}},"Playback":{"locationName":"playback"},"StartTime":{"locationName":"startTime"}}},"S2x":{"type":"structure","members":{"BreakoutCode":{"locationName":"breakoutCode","type":"integer"},"DistributorId":{"locationName":"distributorId"}}},"S2z":{"type":"list","member":{"type":"structure","members":{"CustomName":{"locationName":"customName"},"Name":{"locationName":"name"},"OutputGroupSettings":{"locationName":"outputGroupSettings","type":"structure","members":{"CmafGroupSettings":{"locationName":"cmafGroupSettings","type":"structure","members":{"BaseUrl":{"locationName":"baseUrl"},"ClientCache":{"locationName":"clientCache"},"CodecSpecification":{"locationName":"codecSpecification"},"Destination":{"locationName":"destination"},"DestinationSettings":{"shape":"S36","locationName":"destinationSettings"},"Encryption":{"locationName":"encryption","type":"structure","members":{"ConstantInitializationVector":{"locationName":"constantInitializationVector"},"EncryptionMethod":{"locationName":"encryptionMethod"},"InitializationVectorInManifest":{"locationName":"initializationVectorInManifest"},"SpekeKeyProvider":{"locationName":"spekeKeyProvider","type":"structure","members":{"CertificateArn":{"locationName":"certificateArn"},"DashSignaledSystemIds":{"shape":"S3h","locationName":"dashSignaledSystemIds"},"HlsSignaledSystemIds":{"shape":"S3h","locationName":"hlsSignaledSystemIds"},"ResourceId":{"locationName":"resourceId"},"Url":{"locationName":"url"}}},"StaticKeyProvider":{"shape":"S3l","locationName":"staticKeyProvider"},"Type":{"locationName":"type"}}},"FragmentLength":{"locationName":"fragmentLength","type":"integer"},"ManifestCompression":{"locationName":"manifestCompression"},"ManifestDurationFormat":{"locationName":"manifestDurationFormat"},"MinBufferTime":{"locationName":"minBufferTime","type":"integer"},"MinFinalSegmentLength":{"locationName":"minFinalSegmentLength","type":"double"},"SegmentControl":{"locationName":"segmentControl"},"SegmentLength":{"locationName":"segmentLength","type":"integer"},"StreamInfResolution":{"locationName":"streamInfResolution"},"WriteDashManifest":{"locationName":"writeDashManifest"},"WriteHlsManifest":{"locationName":"writeHlsManifest"}}},"DashIsoGroupSettings":{"locationName":"dashIsoGroupSettings","type":"structure","members":{"BaseUrl":{"locationName":"baseUrl"},"Destination":{"locationName":"destination"},"DestinationSettings":{"shape":"S36","locationName":"destinationSettings"},"Encryption":{"locationName":"encryption","type":"structure","members":{"PlaybackDeviceCompatibility":{"locationName":"playbackDeviceCompatibility"},"SpekeKeyProvider":{"shape":"S40","locationName":"spekeKeyProvider"}}},"FragmentLength":{"locationName":"fragmentLength","type":"integer"},"HbbtvCompliance":{"locationName":"hbbtvCompliance"},"MinBufferTime":{"locationName":"minBufferTime","type":"integer"},"SegmentControl":{"locationName":"segmentControl"},"SegmentLength":{"locationName":"segmentLength","type":"integer"},"WriteSegmentTimelineInRepresentation":{"locationName":"writeSegmentTimelineInRepresentation"}}},"FileGroupSettings":{"locationName":"fileGroupSettings","type":"structure","members":{"Destination":{"locationName":"destination"},"DestinationSettings":{"shape":"S36","locationName":"destinationSettings"}}},"HlsGroupSettings":{"locationName":"hlsGroupSettings","type":"structure","members":{"AdMarkers":{"locationName":"adMarkers","type":"list","member":{}},"BaseUrl":{"locationName":"baseUrl"},"CaptionLanguageMappings":{"locationName":"captionLanguageMappings","type":"list","member":{"type":"structure","members":{"CaptionChannel":{"locationName":"captionChannel","type":"integer"},"CustomLanguageCode":{"locationName":"customLanguageCode"},"LanguageCode":{"locationName":"languageCode"},"LanguageDescription":{"locationName":"languageDescription"}}}},"CaptionLanguageSetting":{"locationName":"captionLanguageSetting"},"ClientCache":{"locationName":"clientCache"},"CodecSpecification":{"locationName":"codecSpecification"},"Destination":{"locationName":"destination"},"DestinationSettings":{"shape":"S36","locationName":"destinationSettings"},"DirectoryStructure":{"locationName":"directoryStructure"},"Encryption":{"locationName":"encryption","type":"structure","members":{"ConstantInitializationVector":{"locationName":"constantInitializationVector"},"EncryptionMethod":{"locationName":"encryptionMethod"},"InitializationVectorInManifest":{"locationName":"initializationVectorInManifest"},"OfflineEncrypted":{"locationName":"offlineEncrypted"},"SpekeKeyProvider":{"shape":"S40","locationName":"spekeKeyProvider"},"StaticKeyProvider":{"shape":"S3l","locationName":"staticKeyProvider"},"Type":{"locationName":"type"}}},"ManifestCompression":{"locationName":"manifestCompression"},"ManifestDurationFormat":{"locationName":"manifestDurationFormat"},"MinFinalSegmentLength":{"locationName":"minFinalSegmentLength","type":"double"},"MinSegmentLength":{"locationName":"minSegmentLength","type":"integer"},"OutputSelection":{"locationName":"outputSelection"},"ProgramDateTime":{"locationName":"programDateTime"},"ProgramDateTimePeriod":{"locationName":"programDateTimePeriod","type":"integer"},"SegmentControl":{"locationName":"segmentControl"},"SegmentLength":{"locationName":"segmentLength","type":"integer"},"SegmentsPerSubdirectory":{"locationName":"segmentsPerSubdirectory","type":"integer"},"StreamInfResolution":{"locationName":"streamInfResolution"},"TimedMetadataId3Frame":{"locationName":"timedMetadataId3Frame"},"TimedMetadataId3Period":{"locationName":"timedMetadataId3Period","type":"integer"},"TimestampDeltaMilliseconds":{"locationName":"timestampDeltaMilliseconds","type":"integer"}}},"MsSmoothGroupSettings":{"locationName":"msSmoothGroupSettings","type":"structure","members":{"AudioDeduplication":{"locationName":"audioDeduplication"},"Destination":{"locationName":"destination"},"DestinationSettings":{"shape":"S36","locationName":"destinationSettings"},"Encryption":{"locationName":"encryption","type":"structure","members":{"SpekeKeyProvider":{"shape":"S40","locationName":"spekeKeyProvider"}}},"FragmentLength":{"locationName":"fragmentLength","type":"integer"},"ManifestEncoding":{"locationName":"manifestEncoding"}}},"Type":{"locationName":"type"}}},"Outputs":{"locationName":"outputs","type":"list","member":{"type":"structure","members":{"AudioDescriptions":{"shape":"S50","locationName":"audioDescriptions"},"CaptionDescriptions":{"locationName":"captionDescriptions","type":"list","member":{"type":"structure","members":{"CaptionSelectorName":{"locationName":"captionSelectorName"},"CustomLanguageCode":{"locationName":"customLanguageCode"},"DestinationSettings":{"shape":"S72","locationName":"destinationSettings"},"LanguageCode":{"locationName":"languageCode"},"LanguageDescription":{"locationName":"languageDescription"}}}},"ContainerSettings":{"shape":"S7v","locationName":"containerSettings"},"Extension":{"locationName":"extension"},"NameModifier":{"locationName":"nameModifier"},"OutputSettings":{"locationName":"outputSettings","type":"structure","members":{"HlsSettings":{"locationName":"hlsSettings","type":"structure","members":{"AudioGroupId":{"locationName":"audioGroupId"},"AudioOnlyContainer":{"locationName":"audioOnlyContainer"},"AudioRenditionSets":{"locationName":"audioRenditionSets"},"AudioTrackType":{"locationName":"audioTrackType"},"IFrameOnlyManifest":{"locationName":"iFrameOnlyManifest"},"SegmentModifier":{"locationName":"segmentModifier"}}}}},"Preset":{"locationName":"preset"},"VideoDescription":{"shape":"S9c","locationName":"videoDescription"}}}}}}},"S36":{"type":"structure","members":{"S3Settings":{"locationName":"s3Settings","type":"structure","members":{"Encryption":{"locationName":"encryption","type":"structure","members":{"EncryptionType":{"locationName":"encryptionType"},"KmsKeyArn":{"locationName":"kmsKeyArn"}}}}}}},"S3h":{"type":"list","member":{}},"S3l":{"type":"structure","members":{"KeyFormat":{"locationName":"keyFormat"},"KeyFormatVersions":{"locationName":"keyFormatVersions"},"StaticKeyValue":{"locationName":"staticKeyValue"},"Url":{"locationName":"url"}}},"S40":{"type":"structure","members":{"CertificateArn":{"locationName":"certificateArn"},"ResourceId":{"locationName":"resourceId"},"SystemIds":{"locationName":"systemIds","type":"list","member":{}},"Url":{"locationName":"url"}}},"S50":{"type":"list","member":{"type":"structure","members":{"AudioNormalizationSettings":{"locationName":"audioNormalizationSettings","type":"structure","members":{"Algorithm":{"locationName":"algorithm"},"AlgorithmControl":{"locationName":"algorithmControl"},"CorrectionGateLevel":{"locationName":"correctionGateLevel","type":"integer"},"LoudnessLogging":{"locationName":"loudnessLogging"},"PeakCalculation":{"locationName":"peakCalculation"},"TargetLkfs":{"locationName":"targetLkfs","type":"double"}}},"AudioSourceName":{"locationName":"audioSourceName"},"AudioType":{"locationName":"audioType","type":"integer"},"AudioTypeControl":{"locationName":"audioTypeControl"},"CodecSettings":{"locationName":"codecSettings","type":"structure","members":{"AacSettings":{"locationName":"aacSettings","type":"structure","members":{"AudioDescriptionBroadcasterMix":{"locationName":"audioDescriptionBroadcasterMix"},"Bitrate":{"locationName":"bitrate","type":"integer"},"CodecProfile":{"locationName":"codecProfile"},"CodingMode":{"locationName":"codingMode"},"RateControlMode":{"locationName":"rateControlMode"},"RawFormat":{"locationName":"rawFormat"},"SampleRate":{"locationName":"sampleRate","type":"integer"},"Specification":{"locationName":"specification"},"VbrQuality":{"locationName":"vbrQuality"}}},"Ac3Settings":{"locationName":"ac3Settings","type":"structure","members":{"Bitrate":{"locationName":"bitrate","type":"integer"},"BitstreamMode":{"locationName":"bitstreamMode"},"CodingMode":{"locationName":"codingMode"},"Dialnorm":{"locationName":"dialnorm","type":"integer"},"DynamicRangeCompressionProfile":{"locationName":"dynamicRangeCompressionProfile"},"LfeFilter":{"locationName":"lfeFilter"},"MetadataControl":{"locationName":"metadataControl"},"SampleRate":{"locationName":"sampleRate","type":"integer"}}},"AiffSettings":{"locationName":"aiffSettings","type":"structure","members":{"BitDepth":{"locationName":"bitDepth","type":"integer"},"Channels":{"locationName":"channels","type":"integer"},"SampleRate":{"locationName":"sampleRate","type":"integer"}}},"Codec":{"locationName":"codec"},"Eac3AtmosSettings":{"locationName":"eac3AtmosSettings","type":"structure","members":{"Bitrate":{"locationName":"bitrate","type":"integer"},"BitstreamMode":{"locationName":"bitstreamMode"},"CodingMode":{"locationName":"codingMode"},"DialogueIntelligence":{"locationName":"dialogueIntelligence"},"DynamicRangeCompressionLine":{"locationName":"dynamicRangeCompressionLine"},"DynamicRangeCompressionRf":{"locationName":"dynamicRangeCompressionRf"},"LoRoCenterMixLevel":{"locationName":"loRoCenterMixLevel","type":"double"},"LoRoSurroundMixLevel":{"locationName":"loRoSurroundMixLevel","type":"double"},"LtRtCenterMixLevel":{"locationName":"ltRtCenterMixLevel","type":"double"},"LtRtSurroundMixLevel":{"locationName":"ltRtSurroundMixLevel","type":"double"},"MeteringMode":{"locationName":"meteringMode"},"SampleRate":{"locationName":"sampleRate","type":"integer"},"SpeechThreshold":{"locationName":"speechThreshold","type":"integer"},"StereoDownmix":{"locationName":"stereoDownmix"},"SurroundExMode":{"locationName":"surroundExMode"}}},"Eac3Settings":{"locationName":"eac3Settings","type":"structure","members":{"AttenuationControl":{"locationName":"attenuationControl"},"Bitrate":{"locationName":"bitrate","type":"integer"},"BitstreamMode":{"locationName":"bitstreamMode"},"CodingMode":{"locationName":"codingMode"},"DcFilter":{"locationName":"dcFilter"},"Dialnorm":{"locationName":"dialnorm","type":"integer"},"DynamicRangeCompressionLine":{"locationName":"dynamicRangeCompressionLine"},"DynamicRangeCompressionRf":{"locationName":"dynamicRangeCompressionRf"},"LfeControl":{"locationName":"lfeControl"},"LfeFilter":{"locationName":"lfeFilter"},"LoRoCenterMixLevel":{"locationName":"loRoCenterMixLevel","type":"double"},"LoRoSurroundMixLevel":{"locationName":"loRoSurroundMixLevel","type":"double"},"LtRtCenterMixLevel":{"locationName":"ltRtCenterMixLevel","type":"double"},"LtRtSurroundMixLevel":{"locationName":"ltRtSurroundMixLevel","type":"double"},"MetadataControl":{"locationName":"metadataControl"},"PassthroughControl":{"locationName":"passthroughControl"},"PhaseControl":{"locationName":"phaseControl"},"SampleRate":{"locationName":"sampleRate","type":"integer"},"StereoDownmix":{"locationName":"stereoDownmix"},"SurroundExMode":{"locationName":"surroundExMode"},"SurroundMode":{"locationName":"surroundMode"}}},"Mp2Settings":{"locationName":"mp2Settings","type":"structure","members":{"Bitrate":{"locationName":"bitrate","type":"integer"},"Channels":{"locationName":"channels","type":"integer"},"SampleRate":{"locationName":"sampleRate","type":"integer"}}},"WavSettings":{"locationName":"wavSettings","type":"structure","members":{"BitDepth":{"locationName":"bitDepth","type":"integer"},"Channels":{"locationName":"channels","type":"integer"},"Format":{"locationName":"format"},"SampleRate":{"locationName":"sampleRate","type":"integer"}}}}},"CustomLanguageCode":{"locationName":"customLanguageCode"},"LanguageCode":{"locationName":"languageCode"},"LanguageCodeControl":{"locationName":"languageCodeControl"},"RemixSettings":{"shape":"S11","locationName":"remixSettings"},"StreamName":{"locationName":"streamName"}}}},"S72":{"type":"structure","members":{"BurninDestinationSettings":{"locationName":"burninDestinationSettings","type":"structure","members":{"Alignment":{"locationName":"alignment"},"BackgroundColor":{"locationName":"backgroundColor"},"BackgroundOpacity":{"locationName":"backgroundOpacity","type":"integer"},"FontColor":{"locationName":"fontColor"},"FontOpacity":{"locationName":"fontOpacity","type":"integer"},"FontResolution":{"locationName":"fontResolution","type":"integer"},"FontScript":{"locationName":"fontScript"},"FontSize":{"locationName":"fontSize","type":"integer"},"OutlineColor":{"locationName":"outlineColor"},"OutlineSize":{"locationName":"outlineSize","type":"integer"},"ShadowColor":{"locationName":"shadowColor"},"ShadowOpacity":{"locationName":"shadowOpacity","type":"integer"},"ShadowXOffset":{"locationName":"shadowXOffset","type":"integer"},"ShadowYOffset":{"locationName":"shadowYOffset","type":"integer"},"TeletextSpacing":{"locationName":"teletextSpacing"},"XPosition":{"locationName":"xPosition","type":"integer"},"YPosition":{"locationName":"yPosition","type":"integer"}}},"DestinationType":{"locationName":"destinationType"},"DvbSubDestinationSettings":{"locationName":"dvbSubDestinationSettings","type":"structure","members":{"Alignment":{"locationName":"alignment"},"BackgroundColor":{"locationName":"backgroundColor"},"BackgroundOpacity":{"locationName":"backgroundOpacity","type":"integer"},"FontColor":{"locationName":"fontColor"},"FontOpacity":{"locationName":"fontOpacity","type":"integer"},"FontResolution":{"locationName":"fontResolution","type":"integer"},"FontScript":{"locationName":"fontScript"},"FontSize":{"locationName":"fontSize","type":"integer"},"OutlineColor":{"locationName":"outlineColor"},"OutlineSize":{"locationName":"outlineSize","type":"integer"},"ShadowColor":{"locationName":"shadowColor"},"ShadowOpacity":{"locationName":"shadowOpacity","type":"integer"},"ShadowXOffset":{"locationName":"shadowXOffset","type":"integer"},"ShadowYOffset":{"locationName":"shadowYOffset","type":"integer"},"TeletextSpacing":{"locationName":"teletextSpacing"},"XPosition":{"locationName":"xPosition","type":"integer"},"YPosition":{"locationName":"yPosition","type":"integer"}}},"EmbeddedDestinationSettings":{"locationName":"embeddedDestinationSettings","type":"structure","members":{"Destination608ChannelNumber":{"locationName":"destination608ChannelNumber","type":"integer"},"Destination708ServiceNumber":{"locationName":"destination708ServiceNumber","type":"integer"}}},"SccDestinationSettings":{"locationName":"sccDestinationSettings","type":"structure","members":{"Framerate":{"locationName":"framerate"}}},"TeletextDestinationSettings":{"locationName":"teletextDestinationSettings","type":"structure","members":{"PageNumber":{"locationName":"pageNumber"},"PageTypes":{"locationName":"pageTypes","type":"list","member":{}}}},"TtmlDestinationSettings":{"locationName":"ttmlDestinationSettings","type":"structure","members":{"StylePassthrough":{"locationName":"stylePassthrough"}}}}},"S7v":{"type":"structure","members":{"Container":{"locationName":"container"},"F4vSettings":{"locationName":"f4vSettings","type":"structure","members":{"MoovPlacement":{"locationName":"moovPlacement"}}},"M2tsSettings":{"locationName":"m2tsSettings","type":"structure","members":{"AudioBufferModel":{"locationName":"audioBufferModel"},"AudioFramesPerPes":{"locationName":"audioFramesPerPes","type":"integer"},"AudioPids":{"shape":"S81","locationName":"audioPids"},"Bitrate":{"locationName":"bitrate","type":"integer"},"BufferModel":{"locationName":"bufferModel"},"DvbNitSettings":{"locationName":"dvbNitSettings","type":"structure","members":{"NetworkId":{"locationName":"networkId","type":"integer"},"NetworkName":{"locationName":"networkName"},"NitInterval":{"locationName":"nitInterval","type":"integer"}}},"DvbSdtSettings":{"locationName":"dvbSdtSettings","type":"structure","members":{"OutputSdt":{"locationName":"outputSdt"},"SdtInterval":{"locationName":"sdtInterval","type":"integer"},"ServiceName":{"locationName":"serviceName"},"ServiceProviderName":{"locationName":"serviceProviderName"}}},"DvbSubPids":{"shape":"S81","locationName":"dvbSubPids"},"DvbTdtSettings":{"locationName":"dvbTdtSettings","type":"structure","members":{"TdtInterval":{"locationName":"tdtInterval","type":"integer"}}},"DvbTeletextPid":{"locationName":"dvbTeletextPid","type":"integer"},"EbpAudioInterval":{"locationName":"ebpAudioInterval"},"EbpPlacement":{"locationName":"ebpPlacement"},"EsRateInPes":{"locationName":"esRateInPes"},"ForceTsVideoEbpOrder":{"locationName":"forceTsVideoEbpOrder"},"FragmentTime":{"locationName":"fragmentTime","type":"double"},"MaxPcrInterval":{"locationName":"maxPcrInterval","type":"integer"},"MinEbpInterval":{"locationName":"minEbpInterval","type":"integer"},"NielsenId3":{"locationName":"nielsenId3"},"NullPacketBitrate":{"locationName":"nullPacketBitrate","type":"double"},"PatInterval":{"locationName":"patInterval","type":"integer"},"PcrControl":{"locationName":"pcrControl"},"PcrPid":{"locationName":"pcrPid","type":"integer"},"PmtInterval":{"locationName":"pmtInterval","type":"integer"},"PmtPid":{"locationName":"pmtPid","type":"integer"},"PrivateMetadataPid":{"locationName":"privateMetadataPid","type":"integer"},"ProgramNumber":{"locationName":"programNumber","type":"integer"},"RateMode":{"locationName":"rateMode"},"Scte35Esam":{"locationName":"scte35Esam","type":"structure","members":{"Scte35EsamPid":{"locationName":"scte35EsamPid","type":"integer"}}},"Scte35Pid":{"locationName":"scte35Pid","type":"integer"},"Scte35Source":{"locationName":"scte35Source"},"SegmentationMarkers":{"locationName":"segmentationMarkers"},"SegmentationStyle":{"locationName":"segmentationStyle"},"SegmentationTime":{"locationName":"segmentationTime","type":"double"},"TimedMetadataPid":{"locationName":"timedMetadataPid","type":"integer"},"TransportStreamId":{"locationName":"transportStreamId","type":"integer"},"VideoPid":{"locationName":"videoPid","type":"integer"}}},"M3u8Settings":{"locationName":"m3u8Settings","type":"structure","members":{"AudioFramesPerPes":{"locationName":"audioFramesPerPes","type":"integer"},"AudioPids":{"shape":"S81","locationName":"audioPids"},"NielsenId3":{"locationName":"nielsenId3"},"PatInterval":{"locationName":"patInterval","type":"integer"},"PcrControl":{"locationName":"pcrControl"},"PcrPid":{"locationName":"pcrPid","type":"integer"},"PmtInterval":{"locationName":"pmtInterval","type":"integer"},"PmtPid":{"locationName":"pmtPid","type":"integer"},"PrivateMetadataPid":{"locationName":"privateMetadataPid","type":"integer"},"ProgramNumber":{"locationName":"programNumber","type":"integer"},"Scte35Pid":{"locationName":"scte35Pid","type":"integer"},"Scte35Source":{"locationName":"scte35Source"},"TimedMetadata":{"locationName":"timedMetadata"},"TimedMetadataPid":{"locationName":"timedMetadataPid","type":"integer"},"TransportStreamId":{"locationName":"transportStreamId","type":"integer"},"VideoPid":{"locationName":"videoPid","type":"integer"}}},"MovSettings":{"locationName":"movSettings","type":"structure","members":{"ClapAtom":{"locationName":"clapAtom"},"CslgAtom":{"locationName":"cslgAtom"},"Mpeg2FourCCControl":{"locationName":"mpeg2FourCCControl"},"PaddingControl":{"locationName":"paddingControl"},"Reference":{"locationName":"reference"}}},"Mp4Settings":{"locationName":"mp4Settings","type":"structure","members":{"CslgAtom":{"locationName":"cslgAtom"},"FreeSpaceBox":{"locationName":"freeSpaceBox"},"MoovPlacement":{"locationName":"moovPlacement"},"Mp4MajorBrand":{"locationName":"mp4MajorBrand"}}}}},"S81":{"type":"list","member":{"type":"integer"}},"S9c":{"type":"structure","members":{"AfdSignaling":{"locationName":"afdSignaling"},"AntiAlias":{"locationName":"antiAlias"},"CodecSettings":{"locationName":"codecSettings","type":"structure","members":{"Codec":{"locationName":"codec"},"FrameCaptureSettings":{"locationName":"frameCaptureSettings","type":"structure","members":{"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"},"MaxCaptures":{"locationName":"maxCaptures","type":"integer"},"Quality":{"locationName":"quality","type":"integer"}}},"H264Settings":{"locationName":"h264Settings","type":"structure","members":{"AdaptiveQuantization":{"locationName":"adaptiveQuantization"},"Bitrate":{"locationName":"bitrate","type":"integer"},"CodecLevel":{"locationName":"codecLevel"},"CodecProfile":{"locationName":"codecProfile"},"DynamicSubGop":{"locationName":"dynamicSubGop"},"EntropyEncoding":{"locationName":"entropyEncoding"},"FieldEncoding":{"locationName":"fieldEncoding"},"FlickerAdaptiveQuantization":{"locationName":"flickerAdaptiveQuantization"},"FramerateControl":{"locationName":"framerateControl"},"FramerateConversionAlgorithm":{"locationName":"framerateConversionAlgorithm"},"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"},"GopBReference":{"locationName":"gopBReference"},"GopClosedCadence":{"locationName":"gopClosedCadence","type":"integer"},"GopSize":{"locationName":"gopSize","type":"double"},"GopSizeUnits":{"locationName":"gopSizeUnits"},"HrdBufferInitialFillPercentage":{"locationName":"hrdBufferInitialFillPercentage","type":"integer"},"HrdBufferSize":{"locationName":"hrdBufferSize","type":"integer"},"InterlaceMode":{"locationName":"interlaceMode"},"MaxBitrate":{"locationName":"maxBitrate","type":"integer"},"MinIInterval":{"locationName":"minIInterval","type":"integer"},"NumberBFramesBetweenReferenceFrames":{"locationName":"numberBFramesBetweenReferenceFrames","type":"integer"},"NumberReferenceFrames":{"locationName":"numberReferenceFrames","type":"integer"},"ParControl":{"locationName":"parControl"},"ParDenominator":{"locationName":"parDenominator","type":"integer"},"ParNumerator":{"locationName":"parNumerator","type":"integer"},"QualityTuningLevel":{"locationName":"qualityTuningLevel"},"QvbrSettings":{"locationName":"qvbrSettings","type":"structure","members":{"MaxAverageBitrate":{"locationName":"maxAverageBitrate","type":"integer"},"QvbrQualityLevel":{"locationName":"qvbrQualityLevel","type":"integer"}}},"RateControlMode":{"locationName":"rateControlMode"},"RepeatPps":{"locationName":"repeatPps"},"SceneChangeDetect":{"locationName":"sceneChangeDetect"},"Slices":{"locationName":"slices","type":"integer"},"SlowPal":{"locationName":"slowPal"},"Softness":{"locationName":"softness","type":"integer"},"SpatialAdaptiveQuantization":{"locationName":"spatialAdaptiveQuantization"},"Syntax":{"locationName":"syntax"},"Telecine":{"locationName":"telecine"},"TemporalAdaptiveQuantization":{"locationName":"temporalAdaptiveQuantization"},"UnregisteredSeiTimecode":{"locationName":"unregisteredSeiTimecode"}}},"H265Settings":{"locationName":"h265Settings","type":"structure","members":{"AdaptiveQuantization":{"locationName":"adaptiveQuantization"},"AlternateTransferFunctionSei":{"locationName":"alternateTransferFunctionSei"},"Bitrate":{"locationName":"bitrate","type":"integer"},"CodecLevel":{"locationName":"codecLevel"},"CodecProfile":{"locationName":"codecProfile"},"DynamicSubGop":{"locationName":"dynamicSubGop"},"FlickerAdaptiveQuantization":{"locationName":"flickerAdaptiveQuantization"},"FramerateControl":{"locationName":"framerateControl"},"FramerateConversionAlgorithm":{"locationName":"framerateConversionAlgorithm"},"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"},"GopBReference":{"locationName":"gopBReference"},"GopClosedCadence":{"locationName":"gopClosedCadence","type":"integer"},"GopSize":{"locationName":"gopSize","type":"double"},"GopSizeUnits":{"locationName":"gopSizeUnits"},"HrdBufferInitialFillPercentage":{"locationName":"hrdBufferInitialFillPercentage","type":"integer"},"HrdBufferSize":{"locationName":"hrdBufferSize","type":"integer"},"InterlaceMode":{"locationName":"interlaceMode"},"MaxBitrate":{"locationName":"maxBitrate","type":"integer"},"MinIInterval":{"locationName":"minIInterval","type":"integer"},"NumberBFramesBetweenReferenceFrames":{"locationName":"numberBFramesBetweenReferenceFrames","type":"integer"},"NumberReferenceFrames":{"locationName":"numberReferenceFrames","type":"integer"},"ParControl":{"locationName":"parControl"},"ParDenominator":{"locationName":"parDenominator","type":"integer"},"ParNumerator":{"locationName":"parNumerator","type":"integer"},"QualityTuningLevel":{"locationName":"qualityTuningLevel"},"QvbrSettings":{"locationName":"qvbrSettings","type":"structure","members":{"MaxAverageBitrate":{"locationName":"maxAverageBitrate","type":"integer"},"QvbrQualityLevel":{"locationName":"qvbrQualityLevel","type":"integer"}}},"RateControlMode":{"locationName":"rateControlMode"},"SampleAdaptiveOffsetFilterMode":{"locationName":"sampleAdaptiveOffsetFilterMode"},"SceneChangeDetect":{"locationName":"sceneChangeDetect"},"Slices":{"locationName":"slices","type":"integer"},"SlowPal":{"locationName":"slowPal"},"SpatialAdaptiveQuantization":{"locationName":"spatialAdaptiveQuantization"},"Telecine":{"locationName":"telecine"},"TemporalAdaptiveQuantization":{"locationName":"temporalAdaptiveQuantization"},"TemporalIds":{"locationName":"temporalIds"},"Tiles":{"locationName":"tiles"},"UnregisteredSeiTimecode":{"locationName":"unregisteredSeiTimecode"},"WriteMp4PackagingType":{"locationName":"writeMp4PackagingType"}}},"Mpeg2Settings":{"locationName":"mpeg2Settings","type":"structure","members":{"AdaptiveQuantization":{"locationName":"adaptiveQuantization"},"Bitrate":{"locationName":"bitrate","type":"integer"},"CodecLevel":{"locationName":"codecLevel"},"CodecProfile":{"locationName":"codecProfile"},"DynamicSubGop":{"locationName":"dynamicSubGop"},"FramerateControl":{"locationName":"framerateControl"},"FramerateConversionAlgorithm":{"locationName":"framerateConversionAlgorithm"},"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"},"GopClosedCadence":{"locationName":"gopClosedCadence","type":"integer"},"GopSize":{"locationName":"gopSize","type":"double"},"GopSizeUnits":{"locationName":"gopSizeUnits"},"HrdBufferInitialFillPercentage":{"locationName":"hrdBufferInitialFillPercentage","type":"integer"},"HrdBufferSize":{"locationName":"hrdBufferSize","type":"integer"},"InterlaceMode":{"locationName":"interlaceMode"},"IntraDcPrecision":{"locationName":"intraDcPrecision"},"MaxBitrate":{"locationName":"maxBitrate","type":"integer"},"MinIInterval":{"locationName":"minIInterval","type":"integer"},"NumberBFramesBetweenReferenceFrames":{"locationName":"numberBFramesBetweenReferenceFrames","type":"integer"},"ParControl":{"locationName":"parControl"},"ParDenominator":{"locationName":"parDenominator","type":"integer"},"ParNumerator":{"locationName":"parNumerator","type":"integer"},"QualityTuningLevel":{"locationName":"qualityTuningLevel"},"RateControlMode":{"locationName":"rateControlMode"},"SceneChangeDetect":{"locationName":"sceneChangeDetect"},"SlowPal":{"locationName":"slowPal"},"Softness":{"locationName":"softness","type":"integer"},"SpatialAdaptiveQuantization":{"locationName":"spatialAdaptiveQuantization"},"Syntax":{"locationName":"syntax"},"Telecine":{"locationName":"telecine"},"TemporalAdaptiveQuantization":{"locationName":"temporalAdaptiveQuantization"}}},"ProresSettings":{"locationName":"proresSettings","type":"structure","members":{"CodecProfile":{"locationName":"codecProfile"},"FramerateControl":{"locationName":"framerateControl"},"FramerateConversionAlgorithm":{"locationName":"framerateConversionAlgorithm"},"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"},"InterlaceMode":{"locationName":"interlaceMode"},"ParControl":{"locationName":"parControl"},"ParDenominator":{"locationName":"parDenominator","type":"integer"},"ParNumerator":{"locationName":"parNumerator","type":"integer"},"SlowPal":{"locationName":"slowPal"},"Telecine":{"locationName":"telecine"}}}}},"ColorMetadata":{"locationName":"colorMetadata"},"Crop":{"shape":"S1q","locationName":"crop"},"DropFrameTimecode":{"locationName":"dropFrameTimecode"},"FixedAfd":{"locationName":"fixedAfd","type":"integer"},"Height":{"locationName":"height","type":"integer"},"Position":{"shape":"S1q","locationName":"position"},"RespondToAfd":{"locationName":"respondToAfd"},"ScalingBehavior":{"locationName":"scalingBehavior"},"Sharpness":{"locationName":"sharpness","type":"integer"},"TimecodeInsertion":{"locationName":"timecodeInsertion"},"VideoPreprocessors":{"locationName":"videoPreprocessors","type":"structure","members":{"ColorCorrector":{"locationName":"colorCorrector","type":"structure","members":{"Brightness":{"locationName":"brightness","type":"integer"},"ColorSpaceConversion":{"locationName":"colorSpaceConversion"},"Contrast":{"locationName":"contrast","type":"integer"},"Hdr10Metadata":{"shape":"S2k","locationName":"hdr10Metadata"},"Hue":{"locationName":"hue","type":"integer"},"Saturation":{"locationName":"saturation","type":"integer"}}},"Deinterlacer":{"locationName":"deinterlacer","type":"structure","members":{"Algorithm":{"locationName":"algorithm"},"Control":{"locationName":"control"},"Mode":{"locationName":"mode"}}},"ImageInserter":{"shape":"S23","locationName":"imageInserter"},"NoiseReducer":{"locationName":"noiseReducer","type":"structure","members":{"Filter":{"locationName":"filter"},"FilterSettings":{"locationName":"filterSettings","type":"structure","members":{"Strength":{"locationName":"strength","type":"integer"}}},"SpatialFilterSettings":{"locationName":"spatialFilterSettings","type":"structure","members":{"PostFilterSharpenStrength":{"locationName":"postFilterSharpenStrength","type":"integer"},"Speed":{"locationName":"speed","type":"integer"},"Strength":{"locationName":"strength","type":"integer"}}},"TemporalFilterSettings":{"locationName":"temporalFilterSettings","type":"structure","members":{"AggressiveMode":{"locationName":"aggressiveMode","type":"integer"},"Speed":{"locationName":"speed","type":"integer"},"Strength":{"locationName":"strength","type":"integer"}}}}},"TimecodeBurnin":{"locationName":"timecodeBurnin","type":"structure","members":{"FontSize":{"locationName":"fontSize","type":"integer"},"Position":{"locationName":"position"},"Prefix":{"locationName":"prefix"}}}}},"Width":{"locationName":"width","type":"integer"}}},"Scx":{"type":"structure","members":{"Anchor":{"locationName":"anchor"},"Source":{"locationName":"source"},"Start":{"locationName":"start"},"TimestampOffset":{"locationName":"timestampOffset"}}},"Sd0":{"type":"structure","members":{"Id3Insertions":{"locationName":"id3Insertions","type":"list","member":{"type":"structure","members":{"Id3":{"locationName":"id3"},"Timecode":{"locationName":"timecode"}}}}}},"Sd5":{"type":"map","key":{},"value":{}},"Sd7":{"type":"structure","members":{"AccelerationSettings":{"shape":"S7","locationName":"accelerationSettings"},"Arn":{"locationName":"arn"},"BillingTagsSource":{"locationName":"billingTagsSource"},"CreatedAt":{"shape":"Sd8","locationName":"createdAt"},"CurrentPhase":{"locationName":"currentPhase"},"ErrorCode":{"locationName":"errorCode","type":"integer"},"ErrorMessage":{"locationName":"errorMessage"},"Id":{"locationName":"id"},"JobPercentComplete":{"locationName":"jobPercentComplete","type":"integer"},"JobTemplate":{"locationName":"jobTemplate"},"OutputGroupDetails":{"locationName":"outputGroupDetails","type":"list","member":{"type":"structure","members":{"OutputDetails":{"locationName":"outputDetails","type":"list","member":{"type":"structure","members":{"DurationInMs":{"locationName":"durationInMs","type":"integer"},"VideoDetails":{"locationName":"videoDetails","type":"structure","members":{"HeightInPx":{"locationName":"heightInPx","type":"integer"},"WidthInPx":{"locationName":"widthInPx","type":"integer"}}}}}}}}},"Priority":{"locationName":"priority","type":"integer"},"Queue":{"locationName":"queue"},"RetryCount":{"locationName":"retryCount","type":"integer"},"Role":{"locationName":"role"},"Settings":{"shape":"Sb","locationName":"settings"},"Status":{"locationName":"status"},"StatusUpdateInterval":{"locationName":"statusUpdateInterval"},"Timing":{"locationName":"timing","type":"structure","members":{"FinishTime":{"shape":"Sd8","locationName":"finishTime"},"StartTime":{"shape":"Sd8","locationName":"startTime"},"SubmitTime":{"shape":"Sd8","locationName":"submitTime"}}},"UserMetadata":{"shape":"Sd5","locationName":"userMetadata"}},"required":["Role","Settings"]},"Sd8":{"type":"timestamp","timestampFormat":"unixTimestamp"},"Sdj":{"type":"structure","members":{"AdAvailOffset":{"locationName":"adAvailOffset","type":"integer"},"AvailBlanking":{"shape":"Sd","locationName":"availBlanking"},"Esam":{"shape":"Sf","locationName":"esam"},"Inputs":{"locationName":"inputs","type":"list","member":{"type":"structure","members":{"AudioSelectorGroups":{"shape":"Sn","locationName":"audioSelectorGroups"},"AudioSelectors":{"shape":"Sr","locationName":"audioSelectors"},"CaptionSelectors":{"shape":"S1a","locationName":"captionSelectors"},"Crop":{"shape":"S1q","locationName":"crop"},"DeblockFilter":{"locationName":"deblockFilter"},"DenoiseFilter":{"locationName":"denoiseFilter"},"FilterEnable":{"locationName":"filterEnable"},"FilterStrength":{"locationName":"filterStrength","type":"integer"},"ImageInserter":{"shape":"S23","locationName":"imageInserter"},"InputClippings":{"shape":"S2a","locationName":"inputClippings"},"Position":{"shape":"S1q","locationName":"position"},"ProgramNumber":{"locationName":"programNumber","type":"integer"},"PsiControl":{"locationName":"psiControl"},"TimecodeSource":{"locationName":"timecodeSource"},"VideoSelector":{"shape":"S2h","locationName":"videoSelector"}}}},"MotionImageInserter":{"shape":"S2o","locationName":"motionImageInserter"},"NielsenConfiguration":{"shape":"S2x","locationName":"nielsenConfiguration"},"OutputGroups":{"shape":"S2z","locationName":"outputGroups"},"TimecodeConfig":{"shape":"Scx","locationName":"timecodeConfig"},"TimedMetadataInsertion":{"shape":"Sd0","locationName":"timedMetadataInsertion"}}},"Sdn":{"type":"structure","members":{"AccelerationSettings":{"shape":"S7","locationName":"accelerationSettings"},"Arn":{"locationName":"arn"},"Category":{"locationName":"category"},"CreatedAt":{"shape":"Sd8","locationName":"createdAt"},"Description":{"locationName":"description"},"LastUpdated":{"shape":"Sd8","locationName":"lastUpdated"},"Name":{"locationName":"name"},"Priority":{"locationName":"priority","type":"integer"},"Queue":{"locationName":"queue"},"Settings":{"shape":"Sdj","locationName":"settings"},"StatusUpdateInterval":{"locationName":"statusUpdateInterval"},"Type":{"locationName":"type"}},"required":["Settings","Name"]},"Sdq":{"type":"structure","members":{"AudioDescriptions":{"shape":"S50","locationName":"audioDescriptions"},"CaptionDescriptions":{"locationName":"captionDescriptions","type":"list","member":{"type":"structure","members":{"CustomLanguageCode":{"locationName":"customLanguageCode"},"DestinationSettings":{"shape":"S72","locationName":"destinationSettings"},"LanguageCode":{"locationName":"languageCode"},"LanguageDescription":{"locationName":"languageDescription"}}}},"ContainerSettings":{"shape":"S7v","locationName":"containerSettings"},"VideoDescription":{"shape":"S9c","locationName":"videoDescription"}}},"Sdu":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Category":{"locationName":"category"},"CreatedAt":{"shape":"Sd8","locationName":"createdAt"},"Description":{"locationName":"description"},"LastUpdated":{"shape":"Sd8","locationName":"lastUpdated"},"Name":{"locationName":"name"},"Settings":{"shape":"Sdq","locationName":"settings"},"Type":{"locationName":"type"}},"required":["Settings","Name"]},"Sdx":{"type":"structure","members":{"Commitment":{"locationName":"commitment"},"RenewalType":{"locationName":"renewalType"},"ReservedSlots":{"locationName":"reservedSlots","type":"integer"}},"required":["Commitment","ReservedSlots","RenewalType"]},"Se2":{"type":"structure","members":{"Arn":{"locationName":"arn"},"CreatedAt":{"shape":"Sd8","locationName":"createdAt"},"Description":{"locationName":"description"},"LastUpdated":{"shape":"Sd8","locationName":"lastUpdated"},"Name":{"locationName":"name"},"PricingPlan":{"locationName":"pricingPlan"},"ProgressingJobsCount":{"locationName":"progressingJobsCount","type":"integer"},"ReservationPlan":{"locationName":"reservationPlan","type":"structure","members":{"Commitment":{"locationName":"commitment"},"ExpiresAt":{"shape":"Sd8","locationName":"expiresAt"},"PurchasedAt":{"shape":"Sd8","locationName":"purchasedAt"},"RenewalType":{"locationName":"renewalType"},"ReservedSlots":{"locationName":"reservedSlots","type":"integer"},"Status":{"locationName":"status"}}},"Status":{"locationName":"status"},"SubmittedJobsCount":{"locationName":"submittedJobsCount","type":"integer"},"Type":{"locationName":"type"}},"required":["Name"]}}}');

});

parcelRequire.register("4EvZl", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeEndpoints":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Endpoints"},"ListJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Jobs"},"ListPresets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Presets"},"ListJobTemplates":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"JobTemplates"},"ListQueues":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Queues"}}}');

});


parcelRequire.register("iwTb8", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $d7d6047ca60dcc8b$var$Service = $dbC7k.Service;
var $d7d6047ca60dcc8b$var$apiLoader = $dbC7k.apiLoader;
$d7d6047ca60dcc8b$var$apiLoader.services["medialive"] = {};
$dbC7k.MediaLive = $d7d6047ca60dcc8b$var$Service.defineService("medialive", [
    "2017-10-14"
]);



Object.defineProperty($d7d6047ca60dcc8b$var$apiLoader.services["medialive"], "2017-10-14", {
    get: function get() {
        var model = (parcelRequire("gEU81"));
        model.paginators = (parcelRequire("hHGyn")).pagination;
        model.waiters = (parcelRequire("fO4m2")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.MediaLive;

});
parcelRequire.register("gEU81", function(module, exports) {
module.exports = JSON.parse('{"metadata":{"apiVersion":"2017-10-14","endpointPrefix":"medialive","signingName":"medialive","serviceFullName":"AWS Elemental MediaLive","serviceId":"MediaLive","protocol":"rest-json","jsonVersion":"1.1","uid":"medialive-2017-10-14","signatureVersion":"v4","serviceAbbreviation":"MediaLive"},"operations":{"BatchUpdateSchedule":{"http":{"method":"PUT","requestUri":"/prod/channels/{channelId}/schedule","responseCode":200},"input":{"type":"structure","members":{"ChannelId":{"location":"uri","locationName":"channelId"},"Creates":{"locationName":"creates","type":"structure","members":{"ScheduleActions":{"shape":"S4","locationName":"scheduleActions"}},"required":["ScheduleActions"]},"Deletes":{"locationName":"deletes","type":"structure","members":{"ActionNames":{"shape":"Se","locationName":"actionNames"}},"required":["ActionNames"]}},"required":["ChannelId"]},"output":{"type":"structure","members":{"Creates":{"locationName":"creates","type":"structure","members":{"ScheduleActions":{"shape":"S4","locationName":"scheduleActions"}},"required":["ScheduleActions"]},"Deletes":{"locationName":"deletes","type":"structure","members":{"ScheduleActions":{"shape":"S4","locationName":"scheduleActions"}},"required":["ScheduleActions"]}}}},"CreateChannel":{"http":{"requestUri":"/prod/channels","responseCode":201},"input":{"type":"structure","members":{"ChannelClass":{"locationName":"channelClass"},"Destinations":{"shape":"S1i","locationName":"destinations"},"EncoderSettings":{"shape":"S1p","locationName":"encoderSettings"},"InputAttachments":{"shape":"S9c","locationName":"inputAttachments"},"InputSpecification":{"shape":"Sac","locationName":"inputSpecification"},"LogLevel":{"locationName":"logLevel"},"Name":{"locationName":"name"},"RequestId":{"locationName":"requestId","idempotencyToken":true},"Reserved":{"locationName":"reserved","deprecated":true},"RoleArn":{"locationName":"roleArn"},"Tags":{"shape":"Sah","locationName":"tags"}}},"output":{"type":"structure","members":{"Channel":{"shape":"Saj","locationName":"channel"}}}},"CreateInput":{"http":{"requestUri":"/prod/inputs","responseCode":201},"input":{"type":"structure","members":{"Destinations":{"shape":"Saq","locationName":"destinations"},"InputSecurityGroups":{"shape":"Se","locationName":"inputSecurityGroups"},"MediaConnectFlows":{"shape":"Sas","locationName":"mediaConnectFlows"},"Name":{"locationName":"name"},"RequestId":{"locationName":"requestId","idempotencyToken":true},"RoleArn":{"locationName":"roleArn"},"Sources":{"shape":"Sau","locationName":"sources"},"Tags":{"shape":"Sah","locationName":"tags"},"Type":{"locationName":"type"},"Vpc":{"locationName":"vpc","type":"structure","members":{"SecurityGroupIds":{"shape":"Se","locationName":"securityGroupIds"},"SubnetIds":{"shape":"Se","locationName":"subnetIds"}},"required":["SubnetIds"]}}},"output":{"type":"structure","members":{"Input":{"shape":"Saz","locationName":"input"}}}},"CreateInputSecurityGroup":{"http":{"requestUri":"/prod/inputSecurityGroups","responseCode":200},"input":{"type":"structure","members":{"Tags":{"shape":"Sah","locationName":"tags"},"WhitelistRules":{"shape":"Sbb","locationName":"whitelistRules"}}},"output":{"type":"structure","members":{"SecurityGroup":{"shape":"Sbe","locationName":"securityGroup"}}}},"CreateTags":{"http":{"requestUri":"/prod/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"Tags":{"shape":"Sah","locationName":"tags"}},"required":["ResourceArn"]}},"DeleteChannel":{"http":{"method":"DELETE","requestUri":"/prod/channels/{channelId}","responseCode":200},"input":{"type":"structure","members":{"ChannelId":{"location":"uri","locationName":"channelId"}},"required":["ChannelId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"ChannelClass":{"locationName":"channelClass"},"Destinations":{"shape":"S1i","locationName":"destinations"},"EgressEndpoints":{"shape":"Sak","locationName":"egressEndpoints"},"EncoderSettings":{"shape":"S1p","locationName":"encoderSettings"},"Id":{"locationName":"id"},"InputAttachments":{"shape":"S9c","locationName":"inputAttachments"},"InputSpecification":{"shape":"Sac","locationName":"inputSpecification"},"LogLevel":{"locationName":"logLevel"},"Name":{"locationName":"name"},"PipelineDetails":{"shape":"Sam","locationName":"pipelineDetails"},"PipelinesRunningCount":{"locationName":"pipelinesRunningCount","type":"integer"},"RoleArn":{"locationName":"roleArn"},"State":{"locationName":"state"},"Tags":{"shape":"Sah","locationName":"tags"}}}},"DeleteInput":{"http":{"method":"DELETE","requestUri":"/prod/inputs/{inputId}","responseCode":200},"input":{"type":"structure","members":{"InputId":{"location":"uri","locationName":"inputId"}},"required":["InputId"]},"output":{"type":"structure","members":{}}},"DeleteInputSecurityGroup":{"http":{"method":"DELETE","requestUri":"/prod/inputSecurityGroups/{inputSecurityGroupId}","responseCode":200},"input":{"type":"structure","members":{"InputSecurityGroupId":{"location":"uri","locationName":"inputSecurityGroupId"}},"required":["InputSecurityGroupId"]},"output":{"type":"structure","members":{}}},"DeleteReservation":{"http":{"method":"DELETE","requestUri":"/prod/reservations/{reservationId}","responseCode":200},"input":{"type":"structure","members":{"ReservationId":{"location":"uri","locationName":"reservationId"}},"required":["ReservationId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Count":{"locationName":"count","type":"integer"},"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"DurationUnits":{"locationName":"durationUnits"},"End":{"locationName":"end"},"FixedPrice":{"locationName":"fixedPrice","type":"double"},"Name":{"locationName":"name"},"OfferingDescription":{"locationName":"offeringDescription"},"OfferingId":{"locationName":"offeringId"},"OfferingType":{"locationName":"offeringType"},"Region":{"locationName":"region"},"ReservationId":{"locationName":"reservationId"},"ResourceSpecification":{"shape":"Sbt","locationName":"resourceSpecification"},"Start":{"locationName":"start"},"State":{"locationName":"state"},"Tags":{"shape":"Sah","locationName":"tags"},"UsagePrice":{"locationName":"usagePrice","type":"double"}}}},"DeleteSchedule":{"http":{"method":"DELETE","requestUri":"/prod/channels/{channelId}/schedule","responseCode":200},"input":{"type":"structure","members":{"ChannelId":{"location":"uri","locationName":"channelId"}},"required":["ChannelId"]},"output":{"type":"structure","members":{}}},"DeleteTags":{"http":{"method":"DELETE","requestUri":"/prod/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"TagKeys":{"shape":"Se","location":"querystring","locationName":"tagKeys"}},"required":["TagKeys","ResourceArn"]}},"DescribeChannel":{"http":{"method":"GET","requestUri":"/prod/channels/{channelId}","responseCode":200},"input":{"type":"structure","members":{"ChannelId":{"location":"uri","locationName":"channelId"}},"required":["ChannelId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"ChannelClass":{"locationName":"channelClass"},"Destinations":{"shape":"S1i","locationName":"destinations"},"EgressEndpoints":{"shape":"Sak","locationName":"egressEndpoints"},"EncoderSettings":{"shape":"S1p","locationName":"encoderSettings"},"Id":{"locationName":"id"},"InputAttachments":{"shape":"S9c","locationName":"inputAttachments"},"InputSpecification":{"shape":"Sac","locationName":"inputSpecification"},"LogLevel":{"locationName":"logLevel"},"Name":{"locationName":"name"},"PipelineDetails":{"shape":"Sam","locationName":"pipelineDetails"},"PipelinesRunningCount":{"locationName":"pipelinesRunningCount","type":"integer"},"RoleArn":{"locationName":"roleArn"},"State":{"locationName":"state"},"Tags":{"shape":"Sah","locationName":"tags"}}}},"DescribeInput":{"http":{"method":"GET","requestUri":"/prod/inputs/{inputId}","responseCode":200},"input":{"type":"structure","members":{"InputId":{"location":"uri","locationName":"inputId"}},"required":["InputId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"AttachedChannels":{"shape":"Se","locationName":"attachedChannels"},"Destinations":{"shape":"Sb0","locationName":"destinations"},"Id":{"locationName":"id"},"InputClass":{"locationName":"inputClass"},"InputSourceType":{"locationName":"inputSourceType"},"MediaConnectFlows":{"shape":"Sb5","locationName":"mediaConnectFlows"},"Name":{"locationName":"name"},"RoleArn":{"locationName":"roleArn"},"SecurityGroups":{"shape":"Se","locationName":"securityGroups"},"Sources":{"shape":"Sb7","locationName":"sources"},"State":{"locationName":"state"},"Tags":{"shape":"Sah","locationName":"tags"},"Type":{"locationName":"type"}}}},"DescribeInputSecurityGroup":{"http":{"method":"GET","requestUri":"/prod/inputSecurityGroups/{inputSecurityGroupId}","responseCode":200},"input":{"type":"structure","members":{"InputSecurityGroupId":{"location":"uri","locationName":"inputSecurityGroupId"}},"required":["InputSecurityGroupId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Id":{"locationName":"id"},"Inputs":{"shape":"Se","locationName":"inputs"},"State":{"locationName":"state"},"Tags":{"shape":"Sah","locationName":"tags"},"WhitelistRules":{"shape":"Sbg","locationName":"whitelistRules"}}}},"DescribeOffering":{"http":{"method":"GET","requestUri":"/prod/offerings/{offeringId}","responseCode":200},"input":{"type":"structure","members":{"OfferingId":{"location":"uri","locationName":"offeringId"}},"required":["OfferingId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"DurationUnits":{"locationName":"durationUnits"},"FixedPrice":{"locationName":"fixedPrice","type":"double"},"OfferingDescription":{"locationName":"offeringDescription"},"OfferingId":{"locationName":"offeringId"},"OfferingType":{"locationName":"offeringType"},"Region":{"locationName":"region"},"ResourceSpecification":{"shape":"Sbt","locationName":"resourceSpecification"},"UsagePrice":{"locationName":"usagePrice","type":"double"}}}},"DescribeReservation":{"http":{"method":"GET","requestUri":"/prod/reservations/{reservationId}","responseCode":200},"input":{"type":"structure","members":{"ReservationId":{"location":"uri","locationName":"reservationId"}},"required":["ReservationId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Count":{"locationName":"count","type":"integer"},"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"DurationUnits":{"locationName":"durationUnits"},"End":{"locationName":"end"},"FixedPrice":{"locationName":"fixedPrice","type":"double"},"Name":{"locationName":"name"},"OfferingDescription":{"locationName":"offeringDescription"},"OfferingId":{"locationName":"offeringId"},"OfferingType":{"locationName":"offeringType"},"Region":{"locationName":"region"},"ReservationId":{"locationName":"reservationId"},"ResourceSpecification":{"shape":"Sbt","locationName":"resourceSpecification"},"Start":{"locationName":"start"},"State":{"locationName":"state"},"Tags":{"shape":"Sah","locationName":"tags"},"UsagePrice":{"locationName":"usagePrice","type":"double"}}}},"DescribeSchedule":{"http":{"method":"GET","requestUri":"/prod/channels/{channelId}/schedule","responseCode":200},"input":{"type":"structure","members":{"ChannelId":{"location":"uri","locationName":"channelId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ChannelId"]},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ScheduleActions":{"shape":"S4","locationName":"scheduleActions"}}}},"ListChannels":{"http":{"method":"GET","requestUri":"/prod/channels","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Channels":{"locationName":"channels","type":"list","member":{"type":"structure","members":{"Arn":{"locationName":"arn"},"ChannelClass":{"locationName":"channelClass"},"Destinations":{"shape":"S1i","locationName":"destinations"},"EgressEndpoints":{"shape":"Sak","locationName":"egressEndpoints"},"Id":{"locationName":"id"},"InputAttachments":{"shape":"S9c","locationName":"inputAttachments"},"InputSpecification":{"shape":"Sac","locationName":"inputSpecification"},"LogLevel":{"locationName":"logLevel"},"Name":{"locationName":"name"},"PipelinesRunningCount":{"locationName":"pipelinesRunningCount","type":"integer"},"RoleArn":{"locationName":"roleArn"},"State":{"locationName":"state"},"Tags":{"shape":"Sah","locationName":"tags"}}}},"NextToken":{"locationName":"nextToken"}}}},"ListInputSecurityGroups":{"http":{"method":"GET","requestUri":"/prod/inputSecurityGroups","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"InputSecurityGroups":{"locationName":"inputSecurityGroups","type":"list","member":{"shape":"Sbe"}},"NextToken":{"locationName":"nextToken"}}}},"ListInputs":{"http":{"method":"GET","requestUri":"/prod/inputs","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Inputs":{"locationName":"inputs","type":"list","member":{"shape":"Saz"}},"NextToken":{"locationName":"nextToken"}}}},"ListOfferings":{"http":{"method":"GET","requestUri":"/prod/offerings","responseCode":200},"input":{"type":"structure","members":{"ChannelClass":{"location":"querystring","locationName":"channelClass"},"ChannelConfiguration":{"location":"querystring","locationName":"channelConfiguration"},"Codec":{"location":"querystring","locationName":"codec"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"MaximumBitrate":{"location":"querystring","locationName":"maximumBitrate"},"MaximumFramerate":{"location":"querystring","locationName":"maximumFramerate"},"NextToken":{"location":"querystring","locationName":"nextToken"},"Resolution":{"location":"querystring","locationName":"resolution"},"ResourceType":{"location":"querystring","locationName":"resourceType"},"SpecialFeature":{"location":"querystring","locationName":"specialFeature"},"VideoQuality":{"location":"querystring","locationName":"videoQuality"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Offerings":{"locationName":"offerings","type":"list","member":{"type":"structure","members":{"Arn":{"locationName":"arn"},"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"DurationUnits":{"locationName":"durationUnits"},"FixedPrice":{"locationName":"fixedPrice","type":"double"},"OfferingDescription":{"locationName":"offeringDescription"},"OfferingId":{"locationName":"offeringId"},"OfferingType":{"locationName":"offeringType"},"Region":{"locationName":"region"},"ResourceSpecification":{"shape":"Sbt","locationName":"resourceSpecification"},"UsagePrice":{"locationName":"usagePrice","type":"double"}}}}}}},"ListReservations":{"http":{"method":"GET","requestUri":"/prod/reservations","responseCode":200},"input":{"type":"structure","members":{"ChannelClass":{"location":"querystring","locationName":"channelClass"},"Codec":{"location":"querystring","locationName":"codec"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"MaximumBitrate":{"location":"querystring","locationName":"maximumBitrate"},"MaximumFramerate":{"location":"querystring","locationName":"maximumFramerate"},"NextToken":{"location":"querystring","locationName":"nextToken"},"Resolution":{"location":"querystring","locationName":"resolution"},"ResourceType":{"location":"querystring","locationName":"resourceType"},"SpecialFeature":{"location":"querystring","locationName":"specialFeature"},"VideoQuality":{"location":"querystring","locationName":"videoQuality"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Reservations":{"locationName":"reservations","type":"list","member":{"shape":"Scz"}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/prod/tags/{resource-arn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{"Tags":{"shape":"Sah","locationName":"tags"}}}},"PurchaseOffering":{"http":{"requestUri":"/prod/offerings/{offeringId}/purchase","responseCode":201},"input":{"type":"structure","members":{"Count":{"locationName":"count","type":"integer"},"Name":{"locationName":"name"},"OfferingId":{"location":"uri","locationName":"offeringId"},"RequestId":{"locationName":"requestId","idempotencyToken":true},"Start":{"locationName":"start"},"Tags":{"shape":"Sah","locationName":"tags"}},"required":["OfferingId","Count"]},"output":{"type":"structure","members":{"Reservation":{"shape":"Scz","locationName":"reservation"}}}},"StartChannel":{"http":{"requestUri":"/prod/channels/{channelId}/start","responseCode":200},"input":{"type":"structure","members":{"ChannelId":{"location":"uri","locationName":"channelId"}},"required":["ChannelId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"ChannelClass":{"locationName":"channelClass"},"Destinations":{"shape":"S1i","locationName":"destinations"},"EgressEndpoints":{"shape":"Sak","locationName":"egressEndpoints"},"EncoderSettings":{"shape":"S1p","locationName":"encoderSettings"},"Id":{"locationName":"id"},"InputAttachments":{"shape":"S9c","locationName":"inputAttachments"},"InputSpecification":{"shape":"Sac","locationName":"inputSpecification"},"LogLevel":{"locationName":"logLevel"},"Name":{"locationName":"name"},"PipelineDetails":{"shape":"Sam","locationName":"pipelineDetails"},"PipelinesRunningCount":{"locationName":"pipelinesRunningCount","type":"integer"},"RoleArn":{"locationName":"roleArn"},"State":{"locationName":"state"},"Tags":{"shape":"Sah","locationName":"tags"}}}},"StopChannel":{"http":{"requestUri":"/prod/channels/{channelId}/stop","responseCode":200},"input":{"type":"structure","members":{"ChannelId":{"location":"uri","locationName":"channelId"}},"required":["ChannelId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"ChannelClass":{"locationName":"channelClass"},"Destinations":{"shape":"S1i","locationName":"destinations"},"EgressEndpoints":{"shape":"Sak","locationName":"egressEndpoints"},"EncoderSettings":{"shape":"S1p","locationName":"encoderSettings"},"Id":{"locationName":"id"},"InputAttachments":{"shape":"S9c","locationName":"inputAttachments"},"InputSpecification":{"shape":"Sac","locationName":"inputSpecification"},"LogLevel":{"locationName":"logLevel"},"Name":{"locationName":"name"},"PipelineDetails":{"shape":"Sam","locationName":"pipelineDetails"},"PipelinesRunningCount":{"locationName":"pipelinesRunningCount","type":"integer"},"RoleArn":{"locationName":"roleArn"},"State":{"locationName":"state"},"Tags":{"shape":"Sah","locationName":"tags"}}}},"UpdateChannel":{"http":{"method":"PUT","requestUri":"/prod/channels/{channelId}","responseCode":200},"input":{"type":"structure","members":{"ChannelId":{"location":"uri","locationName":"channelId"},"Destinations":{"shape":"S1i","locationName":"destinations"},"EncoderSettings":{"shape":"S1p","locationName":"encoderSettings"},"InputAttachments":{"shape":"S9c","locationName":"inputAttachments"},"InputSpecification":{"shape":"Sac","locationName":"inputSpecification"},"LogLevel":{"locationName":"logLevel"},"Name":{"locationName":"name"},"RoleArn":{"locationName":"roleArn"}},"required":["ChannelId"]},"output":{"type":"structure","members":{"Channel":{"shape":"Saj","locationName":"channel"}}}},"UpdateChannelClass":{"http":{"method":"PUT","requestUri":"/prod/channels/{channelId}/channelClass","responseCode":200},"input":{"type":"structure","members":{"ChannelClass":{"locationName":"channelClass"},"ChannelId":{"location":"uri","locationName":"channelId"},"Destinations":{"shape":"S1i","locationName":"destinations"}},"required":["ChannelId","ChannelClass"]},"output":{"type":"structure","members":{"Channel":{"shape":"Saj","locationName":"channel"}}}},"UpdateInput":{"http":{"method":"PUT","requestUri":"/prod/inputs/{inputId}","responseCode":200},"input":{"type":"structure","members":{"Destinations":{"shape":"Saq","locationName":"destinations"},"InputId":{"location":"uri","locationName":"inputId"},"InputSecurityGroups":{"shape":"Se","locationName":"inputSecurityGroups"},"MediaConnectFlows":{"shape":"Sas","locationName":"mediaConnectFlows"},"Name":{"locationName":"name"},"RoleArn":{"locationName":"roleArn"},"Sources":{"shape":"Sau","locationName":"sources"}},"required":["InputId"]},"output":{"type":"structure","members":{"Input":{"shape":"Saz","locationName":"input"}}}},"UpdateInputSecurityGroup":{"http":{"method":"PUT","requestUri":"/prod/inputSecurityGroups/{inputSecurityGroupId}","responseCode":200},"input":{"type":"structure","members":{"InputSecurityGroupId":{"location":"uri","locationName":"inputSecurityGroupId"},"Tags":{"shape":"Sah","locationName":"tags"},"WhitelistRules":{"shape":"Sbb","locationName":"whitelistRules"}},"required":["InputSecurityGroupId"]},"output":{"type":"structure","members":{"SecurityGroup":{"shape":"Sbe","locationName":"securityGroup"}}}},"UpdateReservation":{"http":{"method":"PUT","requestUri":"/prod/reservations/{reservationId}","responseCode":200},"input":{"type":"structure","members":{"Name":{"locationName":"name"},"ReservationId":{"location":"uri","locationName":"reservationId"}},"required":["ReservationId"]},"output":{"type":"structure","members":{"Reservation":{"shape":"Scz","locationName":"reservation"}}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","members":{"ActionName":{"locationName":"actionName"},"ScheduleActionSettings":{"locationName":"scheduleActionSettings","type":"structure","members":{"HlsTimedMetadataSettings":{"locationName":"hlsTimedMetadataSettings","type":"structure","members":{"Id3":{"locationName":"id3"}},"required":["Id3"]},"InputSwitchSettings":{"locationName":"inputSwitchSettings","type":"structure","members":{"InputAttachmentNameReference":{"locationName":"inputAttachmentNameReference"},"InputClippingSettings":{"locationName":"inputClippingSettings","type":"structure","members":{"InputTimecodeSource":{"locationName":"inputTimecodeSource"},"StartTimecode":{"locationName":"startTimecode","type":"structure","members":{"Timecode":{"locationName":"timecode"}}},"StopTimecode":{"locationName":"stopTimecode","type":"structure","members":{"LastFrameClippingBehavior":{"locationName":"lastFrameClippingBehavior"},"Timecode":{"locationName":"timecode"}}}},"required":["InputTimecodeSource"]},"UrlPath":{"shape":"Se","locationName":"urlPath"}},"required":["InputAttachmentNameReference"]},"PauseStateSettings":{"locationName":"pauseStateSettings","type":"structure","members":{"Pipelines":{"locationName":"pipelines","type":"list","member":{"type":"structure","members":{"PipelineId":{"locationName":"pipelineId"}},"required":["PipelineId"]}}}},"Scte35ReturnToNetworkSettings":{"locationName":"scte35ReturnToNetworkSettings","type":"structure","members":{"SpliceEventId":{"locationName":"spliceEventId","type":"long"}},"required":["SpliceEventId"]},"Scte35SpliceInsertSettings":{"locationName":"scte35SpliceInsertSettings","type":"structure","members":{"Duration":{"locationName":"duration","type":"long"},"SpliceEventId":{"locationName":"spliceEventId","type":"long"}},"required":["SpliceEventId"]},"Scte35TimeSignalSettings":{"locationName":"scte35TimeSignalSettings","type":"structure","members":{"Scte35Descriptors":{"locationName":"scte35Descriptors","type":"list","member":{"type":"structure","members":{"Scte35DescriptorSettings":{"locationName":"scte35DescriptorSettings","type":"structure","members":{"SegmentationDescriptorScte35DescriptorSettings":{"locationName":"segmentationDescriptorScte35DescriptorSettings","type":"structure","members":{"DeliveryRestrictions":{"locationName":"deliveryRestrictions","type":"structure","members":{"ArchiveAllowedFlag":{"locationName":"archiveAllowedFlag"},"DeviceRestrictions":{"locationName":"deviceRestrictions"},"NoRegionalBlackoutFlag":{"locationName":"noRegionalBlackoutFlag"},"WebDeliveryAllowedFlag":{"locationName":"webDeliveryAllowedFlag"}},"required":["DeviceRestrictions","ArchiveAllowedFlag","WebDeliveryAllowedFlag","NoRegionalBlackoutFlag"]},"SegmentNum":{"locationName":"segmentNum","type":"integer"},"SegmentationCancelIndicator":{"locationName":"segmentationCancelIndicator"},"SegmentationDuration":{"locationName":"segmentationDuration","type":"long"},"SegmentationEventId":{"locationName":"segmentationEventId","type":"long"},"SegmentationTypeId":{"locationName":"segmentationTypeId","type":"integer"},"SegmentationUpid":{"locationName":"segmentationUpid"},"SegmentationUpidType":{"locationName":"segmentationUpidType","type":"integer"},"SegmentsExpected":{"locationName":"segmentsExpected","type":"integer"},"SubSegmentNum":{"locationName":"subSegmentNum","type":"integer"},"SubSegmentsExpected":{"locationName":"subSegmentsExpected","type":"integer"}},"required":["SegmentationEventId","SegmentationCancelIndicator"]}},"required":["SegmentationDescriptorScte35DescriptorSettings"]}},"required":["Scte35DescriptorSettings"]}}},"required":["Scte35Descriptors"]},"StaticImageActivateSettings":{"locationName":"staticImageActivateSettings","type":"structure","members":{"Duration":{"locationName":"duration","type":"integer"},"FadeIn":{"locationName":"fadeIn","type":"integer"},"FadeOut":{"locationName":"fadeOut","type":"integer"},"Height":{"locationName":"height","type":"integer"},"Image":{"shape":"S13","locationName":"image"},"ImageX":{"locationName":"imageX","type":"integer"},"ImageY":{"locationName":"imageY","type":"integer"},"Layer":{"locationName":"layer","type":"integer"},"Opacity":{"locationName":"opacity","type":"integer"},"Width":{"locationName":"width","type":"integer"}},"required":["Image"]},"StaticImageDeactivateSettings":{"locationName":"staticImageDeactivateSettings","type":"structure","members":{"FadeOut":{"locationName":"fadeOut","type":"integer"},"Layer":{"locationName":"layer","type":"integer"}}}}},"ScheduleActionStartSettings":{"locationName":"scheduleActionStartSettings","type":"structure","members":{"FixedModeScheduleActionStartSettings":{"locationName":"fixedModeScheduleActionStartSettings","type":"structure","members":{"Time":{"locationName":"time"}},"required":["Time"]},"FollowModeScheduleActionStartSettings":{"locationName":"followModeScheduleActionStartSettings","type":"structure","members":{"FollowPoint":{"locationName":"followPoint"},"ReferenceActionName":{"locationName":"referenceActionName"}},"required":["ReferenceActionName","FollowPoint"]},"ImmediateModeScheduleActionStartSettings":{"locationName":"immediateModeScheduleActionStartSettings","type":"structure","members":{}}}}},"required":["ActionName","ScheduleActionStartSettings","ScheduleActionSettings"]}},"Se":{"type":"list","member":{}},"S13":{"type":"structure","members":{"PasswordParam":{"locationName":"passwordParam"},"Uri":{"locationName":"uri"},"Username":{"locationName":"username"}},"required":["Uri"]},"S1i":{"type":"list","member":{"type":"structure","members":{"Id":{"locationName":"id"},"MediaPackageSettings":{"locationName":"mediaPackageSettings","type":"list","member":{"type":"structure","members":{"ChannelId":{"locationName":"channelId"}}}},"Settings":{"locationName":"settings","type":"list","member":{"type":"structure","members":{"PasswordParam":{"locationName":"passwordParam"},"StreamName":{"locationName":"streamName"},"Url":{"locationName":"url"},"Username":{"locationName":"username"}}}}}}},"S1p":{"type":"structure","members":{"AudioDescriptions":{"locationName":"audioDescriptions","type":"list","member":{"type":"structure","members":{"AudioNormalizationSettings":{"locationName":"audioNormalizationSettings","type":"structure","members":{"Algorithm":{"locationName":"algorithm"},"AlgorithmControl":{"locationName":"algorithmControl"},"TargetLkfs":{"locationName":"targetLkfs","type":"double"}}},"AudioSelectorName":{"locationName":"audioSelectorName"},"AudioType":{"locationName":"audioType"},"AudioTypeControl":{"locationName":"audioTypeControl"},"CodecSettings":{"locationName":"codecSettings","type":"structure","members":{"AacSettings":{"locationName":"aacSettings","type":"structure","members":{"Bitrate":{"locationName":"bitrate","type":"double"},"CodingMode":{"locationName":"codingMode"},"InputType":{"locationName":"inputType"},"Profile":{"locationName":"profile"},"RateControlMode":{"locationName":"rateControlMode"},"RawFormat":{"locationName":"rawFormat"},"SampleRate":{"locationName":"sampleRate","type":"double"},"Spec":{"locationName":"spec"},"VbrQuality":{"locationName":"vbrQuality"}}},"Ac3Settings":{"locationName":"ac3Settings","type":"structure","members":{"Bitrate":{"locationName":"bitrate","type":"double"},"BitstreamMode":{"locationName":"bitstreamMode"},"CodingMode":{"locationName":"codingMode"},"Dialnorm":{"locationName":"dialnorm","type":"integer"},"DrcProfile":{"locationName":"drcProfile"},"LfeFilter":{"locationName":"lfeFilter"},"MetadataControl":{"locationName":"metadataControl"}}},"Eac3Settings":{"locationName":"eac3Settings","type":"structure","members":{"AttenuationControl":{"locationName":"attenuationControl"},"Bitrate":{"locationName":"bitrate","type":"double"},"BitstreamMode":{"locationName":"bitstreamMode"},"CodingMode":{"locationName":"codingMode"},"DcFilter":{"locationName":"dcFilter"},"Dialnorm":{"locationName":"dialnorm","type":"integer"},"DrcLine":{"locationName":"drcLine"},"DrcRf":{"locationName":"drcRf"},"LfeControl":{"locationName":"lfeControl"},"LfeFilter":{"locationName":"lfeFilter"},"LoRoCenterMixLevel":{"locationName":"loRoCenterMixLevel","type":"double"},"LoRoSurroundMixLevel":{"locationName":"loRoSurroundMixLevel","type":"double"},"LtRtCenterMixLevel":{"locationName":"ltRtCenterMixLevel","type":"double"},"LtRtSurroundMixLevel":{"locationName":"ltRtSurroundMixLevel","type":"double"},"MetadataControl":{"locationName":"metadataControl"},"PassthroughControl":{"locationName":"passthroughControl"},"PhaseControl":{"locationName":"phaseControl"},"StereoDownmix":{"locationName":"stereoDownmix"},"SurroundExMode":{"locationName":"surroundExMode"},"SurroundMode":{"locationName":"surroundMode"}}},"Mp2Settings":{"locationName":"mp2Settings","type":"structure","members":{"Bitrate":{"locationName":"bitrate","type":"double"},"CodingMode":{"locationName":"codingMode"},"SampleRate":{"locationName":"sampleRate","type":"double"}}},"PassThroughSettings":{"locationName":"passThroughSettings","type":"structure","members":{}}}},"LanguageCode":{"locationName":"languageCode"},"LanguageCodeControl":{"locationName":"languageCodeControl"},"Name":{"locationName":"name"},"RemixSettings":{"locationName":"remixSettings","type":"structure","members":{"ChannelMappings":{"locationName":"channelMappings","type":"list","member":{"type":"structure","members":{"InputChannelLevels":{"locationName":"inputChannelLevels","type":"list","member":{"type":"structure","members":{"Gain":{"locationName":"gain","type":"integer"},"InputChannel":{"locationName":"inputChannel","type":"integer"}},"required":["InputChannel","Gain"]}},"OutputChannel":{"locationName":"outputChannel","type":"integer"}},"required":["OutputChannel","InputChannelLevels"]}},"ChannelsIn":{"locationName":"channelsIn","type":"integer"},"ChannelsOut":{"locationName":"channelsOut","type":"integer"}},"required":["ChannelMappings"]},"StreamName":{"locationName":"streamName"}},"required":["AudioSelectorName","Name"]}},"AvailBlanking":{"locationName":"availBlanking","type":"structure","members":{"AvailBlankingImage":{"shape":"S13","locationName":"availBlankingImage"},"State":{"locationName":"state"}}},"AvailConfiguration":{"locationName":"availConfiguration","type":"structure","members":{"AvailSettings":{"locationName":"availSettings","type":"structure","members":{"Scte35SpliceInsert":{"locationName":"scte35SpliceInsert","type":"structure","members":{"AdAvailOffset":{"locationName":"adAvailOffset","type":"integer"},"NoRegionalBlackoutFlag":{"locationName":"noRegionalBlackoutFlag"},"WebDeliveryAllowedFlag":{"locationName":"webDeliveryAllowedFlag"}}},"Scte35TimeSignalApos":{"locationName":"scte35TimeSignalApos","type":"structure","members":{"AdAvailOffset":{"locationName":"adAvailOffset","type":"integer"},"NoRegionalBlackoutFlag":{"locationName":"noRegionalBlackoutFlag"},"WebDeliveryAllowedFlag":{"locationName":"webDeliveryAllowedFlag"}}}}}}},"BlackoutSlate":{"locationName":"blackoutSlate","type":"structure","members":{"BlackoutSlateImage":{"shape":"S13","locationName":"blackoutSlateImage"},"NetworkEndBlackout":{"locationName":"networkEndBlackout"},"NetworkEndBlackoutImage":{"shape":"S13","locationName":"networkEndBlackoutImage"},"NetworkId":{"locationName":"networkId"},"State":{"locationName":"state"}}},"CaptionDescriptions":{"locationName":"captionDescriptions","type":"list","member":{"type":"structure","members":{"CaptionSelectorName":{"locationName":"captionSelectorName"},"DestinationSettings":{"locationName":"destinationSettings","type":"structure","members":{"AribDestinationSettings":{"locationName":"aribDestinationSettings","type":"structure","members":{}},"BurnInDestinationSettings":{"locationName":"burnInDestinationSettings","type":"structure","members":{"Alignment":{"locationName":"alignment"},"BackgroundColor":{"locationName":"backgroundColor"},"BackgroundOpacity":{"locationName":"backgroundOpacity","type":"integer"},"Font":{"shape":"S13","locationName":"font"},"FontColor":{"locationName":"fontColor"},"FontOpacity":{"locationName":"fontOpacity","type":"integer"},"FontResolution":{"locationName":"fontResolution","type":"integer"},"FontSize":{"locationName":"fontSize"},"OutlineColor":{"locationName":"outlineColor"},"OutlineSize":{"locationName":"outlineSize","type":"integer"},"ShadowColor":{"locationName":"shadowColor"},"ShadowOpacity":{"locationName":"shadowOpacity","type":"integer"},"ShadowXOffset":{"locationName":"shadowXOffset","type":"integer"},"ShadowYOffset":{"locationName":"shadowYOffset","type":"integer"},"TeletextGridControl":{"locationName":"teletextGridControl"},"XPosition":{"locationName":"xPosition","type":"integer"},"YPosition":{"locationName":"yPosition","type":"integer"}}},"DvbSubDestinationSettings":{"locationName":"dvbSubDestinationSettings","type":"structure","members":{"Alignment":{"locationName":"alignment"},"BackgroundColor":{"locationName":"backgroundColor"},"BackgroundOpacity":{"locationName":"backgroundOpacity","type":"integer"},"Font":{"shape":"S13","locationName":"font"},"FontColor":{"locationName":"fontColor"},"FontOpacity":{"locationName":"fontOpacity","type":"integer"},"FontResolution":{"locationName":"fontResolution","type":"integer"},"FontSize":{"locationName":"fontSize"},"OutlineColor":{"locationName":"outlineColor"},"OutlineSize":{"locationName":"outlineSize","type":"integer"},"ShadowColor":{"locationName":"shadowColor"},"ShadowOpacity":{"locationName":"shadowOpacity","type":"integer"},"ShadowXOffset":{"locationName":"shadowXOffset","type":"integer"},"ShadowYOffset":{"locationName":"shadowYOffset","type":"integer"},"TeletextGridControl":{"locationName":"teletextGridControl"},"XPosition":{"locationName":"xPosition","type":"integer"},"YPosition":{"locationName":"yPosition","type":"integer"}}},"EmbeddedDestinationSettings":{"locationName":"embeddedDestinationSettings","type":"structure","members":{}},"EmbeddedPlusScte20DestinationSettings":{"locationName":"embeddedPlusScte20DestinationSettings","type":"structure","members":{}},"RtmpCaptionInfoDestinationSettings":{"locationName":"rtmpCaptionInfoDestinationSettings","type":"structure","members":{}},"Scte20PlusEmbeddedDestinationSettings":{"locationName":"scte20PlusEmbeddedDestinationSettings","type":"structure","members":{}},"Scte27DestinationSettings":{"locationName":"scte27DestinationSettings","type":"structure","members":{}},"SmpteTtDestinationSettings":{"locationName":"smpteTtDestinationSettings","type":"structure","members":{}},"TeletextDestinationSettings":{"locationName":"teletextDestinationSettings","type":"structure","members":{}},"TtmlDestinationSettings":{"locationName":"ttmlDestinationSettings","type":"structure","members":{"StyleControl":{"locationName":"styleControl"}}},"WebvttDestinationSettings":{"locationName":"webvttDestinationSettings","type":"structure","members":{}}}},"LanguageCode":{"locationName":"languageCode"},"LanguageDescription":{"locationName":"languageDescription"},"Name":{"locationName":"name"}},"required":["CaptionSelectorName","Name"]}},"GlobalConfiguration":{"locationName":"globalConfiguration","type":"structure","members":{"InitialAudioGain":{"locationName":"initialAudioGain","type":"integer"},"InputEndAction":{"locationName":"inputEndAction"},"InputLossBehavior":{"locationName":"inputLossBehavior","type":"structure","members":{"BlackFrameMsec":{"locationName":"blackFrameMsec","type":"integer"},"InputLossImageColor":{"locationName":"inputLossImageColor"},"InputLossImageSlate":{"shape":"S13","locationName":"inputLossImageSlate"},"InputLossImageType":{"locationName":"inputLossImageType"},"RepeatFrameMsec":{"locationName":"repeatFrameMsec","type":"integer"}}},"OutputLockingMode":{"locationName":"outputLockingMode"},"OutputTimingSource":{"locationName":"outputTimingSource"},"SupportLowFramerateInputs":{"locationName":"supportLowFramerateInputs"}}},"OutputGroups":{"locationName":"outputGroups","type":"list","member":{"type":"structure","members":{"Name":{"locationName":"name"},"OutputGroupSettings":{"locationName":"outputGroupSettings","type":"structure","members":{"ArchiveGroupSettings":{"locationName":"archiveGroupSettings","type":"structure","members":{"Destination":{"shape":"S4x","locationName":"destination"},"RolloverInterval":{"locationName":"rolloverInterval","type":"integer"}},"required":["Destination"]},"FrameCaptureGroupSettings":{"locationName":"frameCaptureGroupSettings","type":"structure","members":{"Destination":{"shape":"S4x","locationName":"destination"}},"required":["Destination"]},"HlsGroupSettings":{"locationName":"hlsGroupSettings","type":"structure","members":{"AdMarkers":{"locationName":"adMarkers","type":"list","member":{}},"BaseUrlContent":{"locationName":"baseUrlContent"},"BaseUrlManifest":{"locationName":"baseUrlManifest"},"CaptionLanguageMappings":{"locationName":"captionLanguageMappings","type":"list","member":{"type":"structure","members":{"CaptionChannel":{"locationName":"captionChannel","type":"integer"},"LanguageCode":{"locationName":"languageCode"},"LanguageDescription":{"locationName":"languageDescription"}},"required":["LanguageCode","LanguageDescription","CaptionChannel"]}},"CaptionLanguageSetting":{"locationName":"captionLanguageSetting"},"ClientCache":{"locationName":"clientCache"},"CodecSpecification":{"locationName":"codecSpecification"},"ConstantIv":{"locationName":"constantIv"},"Destination":{"shape":"S4x","locationName":"destination"},"DirectoryStructure":{"locationName":"directoryStructure"},"EncryptionType":{"locationName":"encryptionType"},"HlsCdnSettings":{"locationName":"hlsCdnSettings","type":"structure","members":{"HlsAkamaiSettings":{"locationName":"hlsAkamaiSettings","type":"structure","members":{"ConnectionRetryInterval":{"locationName":"connectionRetryInterval","type":"integer"},"FilecacheDuration":{"locationName":"filecacheDuration","type":"integer"},"HttpTransferMode":{"locationName":"httpTransferMode"},"NumRetries":{"locationName":"numRetries","type":"integer"},"RestartDelay":{"locationName":"restartDelay","type":"integer"},"Salt":{"locationName":"salt"},"Token":{"locationName":"token"}}},"HlsBasicPutSettings":{"locationName":"hlsBasicPutSettings","type":"structure","members":{"ConnectionRetryInterval":{"locationName":"connectionRetryInterval","type":"integer"},"FilecacheDuration":{"locationName":"filecacheDuration","type":"integer"},"NumRetries":{"locationName":"numRetries","type":"integer"},"RestartDelay":{"locationName":"restartDelay","type":"integer"}}},"HlsMediaStoreSettings":{"locationName":"hlsMediaStoreSettings","type":"structure","members":{"ConnectionRetryInterval":{"locationName":"connectionRetryInterval","type":"integer"},"FilecacheDuration":{"locationName":"filecacheDuration","type":"integer"},"MediaStoreStorageClass":{"locationName":"mediaStoreStorageClass"},"NumRetries":{"locationName":"numRetries","type":"integer"},"RestartDelay":{"locationName":"restartDelay","type":"integer"}}},"HlsWebdavSettings":{"locationName":"hlsWebdavSettings","type":"structure","members":{"ConnectionRetryInterval":{"locationName":"connectionRetryInterval","type":"integer"},"FilecacheDuration":{"locationName":"filecacheDuration","type":"integer"},"HttpTransferMode":{"locationName":"httpTransferMode"},"NumRetries":{"locationName":"numRetries","type":"integer"},"RestartDelay":{"locationName":"restartDelay","type":"integer"}}}}},"IFrameOnlyPlaylists":{"locationName":"iFrameOnlyPlaylists"},"IndexNSegments":{"locationName":"indexNSegments","type":"integer"},"InputLossAction":{"locationName":"inputLossAction"},"IvInManifest":{"locationName":"ivInManifest"},"IvSource":{"locationName":"ivSource"},"KeepSegments":{"locationName":"keepSegments","type":"integer"},"KeyFormat":{"locationName":"keyFormat"},"KeyFormatVersions":{"locationName":"keyFormatVersions"},"KeyProviderSettings":{"locationName":"keyProviderSettings","type":"structure","members":{"StaticKeySettings":{"locationName":"staticKeySettings","type":"structure","members":{"KeyProviderServer":{"shape":"S13","locationName":"keyProviderServer"},"StaticKeyValue":{"locationName":"staticKeyValue"}},"required":["StaticKeyValue"]}}},"ManifestCompression":{"locationName":"manifestCompression"},"ManifestDurationFormat":{"locationName":"manifestDurationFormat"},"MinSegmentLength":{"locationName":"minSegmentLength","type":"integer"},"Mode":{"locationName":"mode"},"OutputSelection":{"locationName":"outputSelection"},"ProgramDateTime":{"locationName":"programDateTime"},"ProgramDateTimePeriod":{"locationName":"programDateTimePeriod","type":"integer"},"RedundantManifest":{"locationName":"redundantManifest"},"SegmentLength":{"locationName":"segmentLength","type":"integer"},"SegmentationMode":{"locationName":"segmentationMode"},"SegmentsPerSubdirectory":{"locationName":"segmentsPerSubdirectory","type":"integer"},"StreamInfResolution":{"locationName":"streamInfResolution"},"TimedMetadataId3Frame":{"locationName":"timedMetadataId3Frame"},"TimedMetadataId3Period":{"locationName":"timedMetadataId3Period","type":"integer"},"TimestampDeltaMilliseconds":{"locationName":"timestampDeltaMilliseconds","type":"integer"},"TsFileMode":{"locationName":"tsFileMode"}},"required":["Destination"]},"MediaPackageGroupSettings":{"locationName":"mediaPackageGroupSettings","type":"structure","members":{"Destination":{"shape":"S4x","locationName":"destination"}},"required":["Destination"]},"MsSmoothGroupSettings":{"locationName":"msSmoothGroupSettings","type":"structure","members":{"AcquisitionPointId":{"locationName":"acquisitionPointId"},"AudioOnlyTimecodeControl":{"locationName":"audioOnlyTimecodeControl"},"CertificateMode":{"locationName":"certificateMode"},"ConnectionRetryInterval":{"locationName":"connectionRetryInterval","type":"integer"},"Destination":{"shape":"S4x","locationName":"destination"},"EventId":{"locationName":"eventId"},"EventIdMode":{"locationName":"eventIdMode"},"EventStopBehavior":{"locationName":"eventStopBehavior"},"FilecacheDuration":{"locationName":"filecacheDuration","type":"integer"},"FragmentLength":{"locationName":"fragmentLength","type":"integer"},"InputLossAction":{"locationName":"inputLossAction"},"NumRetries":{"locationName":"numRetries","type":"integer"},"RestartDelay":{"locationName":"restartDelay","type":"integer"},"SegmentationMode":{"locationName":"segmentationMode"},"SendDelayMs":{"locationName":"sendDelayMs","type":"integer"},"SparseTrackType":{"locationName":"sparseTrackType"},"StreamManifestBehavior":{"locationName":"streamManifestBehavior"},"TimestampOffset":{"locationName":"timestampOffset"},"TimestampOffsetMode":{"locationName":"timestampOffsetMode"}},"required":["Destination"]},"RtmpGroupSettings":{"locationName":"rtmpGroupSettings","type":"structure","members":{"AuthenticationScheme":{"locationName":"authenticationScheme"},"CacheFullBehavior":{"locationName":"cacheFullBehavior"},"CacheLength":{"locationName":"cacheLength","type":"integer"},"CaptionData":{"locationName":"captionData"},"InputLossAction":{"locationName":"inputLossAction"},"RestartDelay":{"locationName":"restartDelay","type":"integer"}}},"UdpGroupSettings":{"locationName":"udpGroupSettings","type":"structure","members":{"InputLossAction":{"locationName":"inputLossAction"},"TimedMetadataId3Frame":{"locationName":"timedMetadataId3Frame"},"TimedMetadataId3Period":{"locationName":"timedMetadataId3Period","type":"integer"}}}}},"Outputs":{"locationName":"outputs","type":"list","member":{"type":"structure","members":{"AudioDescriptionNames":{"shape":"Se","locationName":"audioDescriptionNames"},"CaptionDescriptionNames":{"shape":"Se","locationName":"captionDescriptionNames"},"OutputName":{"locationName":"outputName"},"OutputSettings":{"locationName":"outputSettings","type":"structure","members":{"ArchiveOutputSettings":{"locationName":"archiveOutputSettings","type":"structure","members":{"ContainerSettings":{"locationName":"containerSettings","type":"structure","members":{"M2tsSettings":{"shape":"S6t","locationName":"m2tsSettings"}}},"Extension":{"locationName":"extension"},"NameModifier":{"locationName":"nameModifier"}},"required":["ContainerSettings"]},"FrameCaptureOutputSettings":{"locationName":"frameCaptureOutputSettings","type":"structure","members":{"NameModifier":{"locationName":"nameModifier"}}},"HlsOutputSettings":{"locationName":"hlsOutputSettings","type":"structure","members":{"HlsSettings":{"locationName":"hlsSettings","type":"structure","members":{"AudioOnlyHlsSettings":{"locationName":"audioOnlyHlsSettings","type":"structure","members":{"AudioGroupId":{"locationName":"audioGroupId"},"AudioOnlyImage":{"shape":"S13","locationName":"audioOnlyImage"},"AudioTrackType":{"locationName":"audioTrackType"}}},"StandardHlsSettings":{"locationName":"standardHlsSettings","type":"structure","members":{"AudioRenditionSets":{"locationName":"audioRenditionSets"},"M3u8Settings":{"locationName":"m3u8Settings","type":"structure","members":{"AudioFramesPerPes":{"locationName":"audioFramesPerPes","type":"integer"},"AudioPids":{"locationName":"audioPids"},"EcmPid":{"locationName":"ecmPid"},"PatInterval":{"locationName":"patInterval","type":"integer"},"PcrControl":{"locationName":"pcrControl"},"PcrPeriod":{"locationName":"pcrPeriod","type":"integer"},"PcrPid":{"locationName":"pcrPid"},"PmtInterval":{"locationName":"pmtInterval","type":"integer"},"PmtPid":{"locationName":"pmtPid"},"ProgramNum":{"locationName":"programNum","type":"integer"},"Scte35Behavior":{"locationName":"scte35Behavior"},"Scte35Pid":{"locationName":"scte35Pid"},"TimedMetadataBehavior":{"locationName":"timedMetadataBehavior"},"TimedMetadataPid":{"locationName":"timedMetadataPid"},"TransportStreamId":{"locationName":"transportStreamId","type":"integer"},"VideoPid":{"locationName":"videoPid"}}}},"required":["M3u8Settings"]}}},"NameModifier":{"locationName":"nameModifier"},"SegmentModifier":{"locationName":"segmentModifier"}},"required":["HlsSettings"]},"MediaPackageOutputSettings":{"locationName":"mediaPackageOutputSettings","type":"structure","members":{}},"MsSmoothOutputSettings":{"locationName":"msSmoothOutputSettings","type":"structure","members":{"NameModifier":{"locationName":"nameModifier"}}},"RtmpOutputSettings":{"locationName":"rtmpOutputSettings","type":"structure","members":{"CertificateMode":{"locationName":"certificateMode"},"ConnectionRetryInterval":{"locationName":"connectionRetryInterval","type":"integer"},"Destination":{"shape":"S4x","locationName":"destination"},"NumRetries":{"locationName":"numRetries","type":"integer"}},"required":["Destination"]},"UdpOutputSettings":{"locationName":"udpOutputSettings","type":"structure","members":{"BufferMsec":{"locationName":"bufferMsec","type":"integer"},"ContainerSettings":{"locationName":"containerSettings","type":"structure","members":{"M2tsSettings":{"shape":"S6t","locationName":"m2tsSettings"}}},"Destination":{"shape":"S4x","locationName":"destination"},"FecOutputSettings":{"locationName":"fecOutputSettings","type":"structure","members":{"ColumnDepth":{"locationName":"columnDepth","type":"integer"},"IncludeFec":{"locationName":"includeFec"},"RowLength":{"locationName":"rowLength","type":"integer"}}}},"required":["Destination","ContainerSettings"]}}},"VideoDescriptionName":{"locationName":"videoDescriptionName"}},"required":["OutputSettings"]}}},"required":["Outputs","OutputGroupSettings"]}},"TimecodeConfig":{"locationName":"timecodeConfig","type":"structure","members":{"Source":{"locationName":"source"},"SyncThreshold":{"locationName":"syncThreshold","type":"integer"}},"required":["Source"]},"VideoDescriptions":{"locationName":"videoDescriptions","type":"list","member":{"type":"structure","members":{"CodecSettings":{"locationName":"codecSettings","type":"structure","members":{"FrameCaptureSettings":{"locationName":"frameCaptureSettings","type":"structure","members":{"CaptureInterval":{"locationName":"captureInterval","type":"integer"}},"required":["CaptureInterval"]},"H264Settings":{"locationName":"h264Settings","type":"structure","members":{"AdaptiveQuantization":{"locationName":"adaptiveQuantization"},"AfdSignaling":{"locationName":"afdSignaling"},"Bitrate":{"locationName":"bitrate","type":"integer"},"BufFillPct":{"locationName":"bufFillPct","type":"integer"},"BufSize":{"locationName":"bufSize","type":"integer"},"ColorMetadata":{"locationName":"colorMetadata"},"EntropyEncoding":{"locationName":"entropyEncoding"},"FixedAfd":{"locationName":"fixedAfd"},"FlickerAq":{"locationName":"flickerAq"},"FramerateControl":{"locationName":"framerateControl"},"FramerateDenominator":{"locationName":"framerateDenominator","type":"integer"},"FramerateNumerator":{"locationName":"framerateNumerator","type":"integer"},"GopBReference":{"locationName":"gopBReference"},"GopClosedCadence":{"locationName":"gopClosedCadence","type":"integer"},"GopNumBFrames":{"locationName":"gopNumBFrames","type":"integer"},"GopSize":{"locationName":"gopSize","type":"double"},"GopSizeUnits":{"locationName":"gopSizeUnits"},"Level":{"locationName":"level"},"LookAheadRateControl":{"locationName":"lookAheadRateControl"},"MaxBitrate":{"locationName":"maxBitrate","type":"integer"},"MinIInterval":{"locationName":"minIInterval","type":"integer"},"NumRefFrames":{"locationName":"numRefFrames","type":"integer"},"ParControl":{"locationName":"parControl"},"ParDenominator":{"locationName":"parDenominator","type":"integer"},"ParNumerator":{"locationName":"parNumerator","type":"integer"},"Profile":{"locationName":"profile"},"QvbrQualityLevel":{"locationName":"qvbrQualityLevel","type":"integer"},"RateControlMode":{"locationName":"rateControlMode"},"ScanType":{"locationName":"scanType"},"SceneChangeDetect":{"locationName":"sceneChangeDetect"},"Slices":{"locationName":"slices","type":"integer"},"Softness":{"locationName":"softness","type":"integer"},"SpatialAq":{"locationName":"spatialAq"},"SubgopLength":{"locationName":"subgopLength"},"Syntax":{"locationName":"syntax"},"TemporalAq":{"locationName":"temporalAq"},"TimecodeInsertion":{"locationName":"timecodeInsertion"}}}}},"Height":{"locationName":"height","type":"integer"},"Name":{"locationName":"name"},"RespondToAfd":{"locationName":"respondToAfd"},"ScalingBehavior":{"locationName":"scalingBehavior"},"Sharpness":{"locationName":"sharpness","type":"integer"},"Width":{"locationName":"width","type":"integer"}},"required":["Name"]}}},"required":["VideoDescriptions","AudioDescriptions","OutputGroups","TimecodeConfig"]},"S4x":{"type":"structure","members":{"DestinationRefId":{"locationName":"destinationRefId"}}},"S6t":{"type":"structure","members":{"AbsentInputAudioBehavior":{"locationName":"absentInputAudioBehavior"},"Arib":{"locationName":"arib"},"AribCaptionsPid":{"locationName":"aribCaptionsPid"},"AribCaptionsPidControl":{"locationName":"aribCaptionsPidControl"},"AudioBufferModel":{"locationName":"audioBufferModel"},"AudioFramesPerPes":{"locationName":"audioFramesPerPes","type":"integer"},"AudioPids":{"locationName":"audioPids"},"AudioStreamType":{"locationName":"audioStreamType"},"Bitrate":{"locationName":"bitrate","type":"integer"},"BufferModel":{"locationName":"bufferModel"},"CcDescriptor":{"locationName":"ccDescriptor"},"DvbNitSettings":{"locationName":"dvbNitSettings","type":"structure","members":{"NetworkId":{"locationName":"networkId","type":"integer"},"NetworkName":{"locationName":"networkName"},"RepInterval":{"locationName":"repInterval","type":"integer"}},"required":["NetworkName","NetworkId"]},"DvbSdtSettings":{"locationName":"dvbSdtSettings","type":"structure","members":{"OutputSdt":{"locationName":"outputSdt"},"RepInterval":{"locationName":"repInterval","type":"integer"},"ServiceName":{"locationName":"serviceName"},"ServiceProviderName":{"locationName":"serviceProviderName"}}},"DvbSubPids":{"locationName":"dvbSubPids"},"DvbTdtSettings":{"locationName":"dvbTdtSettings","type":"structure","members":{"RepInterval":{"locationName":"repInterval","type":"integer"}}},"DvbTeletextPid":{"locationName":"dvbTeletextPid"},"Ebif":{"locationName":"ebif"},"EbpAudioInterval":{"locationName":"ebpAudioInterval"},"EbpLookaheadMs":{"locationName":"ebpLookaheadMs","type":"integer"},"EbpPlacement":{"locationName":"ebpPlacement"},"EcmPid":{"locationName":"ecmPid"},"EsRateInPes":{"locationName":"esRateInPes"},"EtvPlatformPid":{"locationName":"etvPlatformPid"},"EtvSignalPid":{"locationName":"etvSignalPid"},"FragmentTime":{"locationName":"fragmentTime","type":"double"},"Klv":{"locationName":"klv"},"KlvDataPids":{"locationName":"klvDataPids"},"NullPacketBitrate":{"locationName":"nullPacketBitrate","type":"double"},"PatInterval":{"locationName":"patInterval","type":"integer"},"PcrControl":{"locationName":"pcrControl"},"PcrPeriod":{"locationName":"pcrPeriod","type":"integer"},"PcrPid":{"locationName":"pcrPid"},"PmtInterval":{"locationName":"pmtInterval","type":"integer"},"PmtPid":{"locationName":"pmtPid"},"ProgramNum":{"locationName":"programNum","type":"integer"},"RateMode":{"locationName":"rateMode"},"Scte27Pids":{"locationName":"scte27Pids"},"Scte35Control":{"locationName":"scte35Control"},"Scte35Pid":{"locationName":"scte35Pid"},"SegmentationMarkers":{"locationName":"segmentationMarkers"},"SegmentationStyle":{"locationName":"segmentationStyle"},"SegmentationTime":{"locationName":"segmentationTime","type":"double"},"TimedMetadataBehavior":{"locationName":"timedMetadataBehavior"},"TimedMetadataPid":{"locationName":"timedMetadataPid"},"TransportStreamId":{"locationName":"transportStreamId","type":"integer"},"VideoPid":{"locationName":"videoPid"}}},"S9c":{"type":"list","member":{"type":"structure","members":{"InputAttachmentName":{"locationName":"inputAttachmentName"},"InputId":{"locationName":"inputId"},"InputSettings":{"locationName":"inputSettings","type":"structure","members":{"AudioSelectors":{"locationName":"audioSelectors","type":"list","member":{"type":"structure","members":{"Name":{"locationName":"name"},"SelectorSettings":{"locationName":"selectorSettings","type":"structure","members":{"AudioLanguageSelection":{"locationName":"audioLanguageSelection","type":"structure","members":{"LanguageCode":{"locationName":"languageCode"},"LanguageSelectionPolicy":{"locationName":"languageSelectionPolicy"}},"required":["LanguageCode"]},"AudioPidSelection":{"locationName":"audioPidSelection","type":"structure","members":{"Pid":{"locationName":"pid","type":"integer"}},"required":["Pid"]}}}},"required":["Name"]}},"CaptionSelectors":{"locationName":"captionSelectors","type":"list","member":{"type":"structure","members":{"LanguageCode":{"locationName":"languageCode"},"Name":{"locationName":"name"},"SelectorSettings":{"locationName":"selectorSettings","type":"structure","members":{"AribSourceSettings":{"locationName":"aribSourceSettings","type":"structure","members":{}},"DvbSubSourceSettings":{"locationName":"dvbSubSourceSettings","type":"structure","members":{"Pid":{"locationName":"pid","type":"integer"}}},"EmbeddedSourceSettings":{"locationName":"embeddedSourceSettings","type":"structure","members":{"Convert608To708":{"locationName":"convert608To708"},"Scte20Detection":{"locationName":"scte20Detection"},"Source608ChannelNumber":{"locationName":"source608ChannelNumber","type":"integer"},"Source608TrackNumber":{"locationName":"source608TrackNumber","type":"integer"}}},"Scte20SourceSettings":{"locationName":"scte20SourceSettings","type":"structure","members":{"Convert608To708":{"locationName":"convert608To708"},"Source608ChannelNumber":{"locationName":"source608ChannelNumber","type":"integer"}}},"Scte27SourceSettings":{"locationName":"scte27SourceSettings","type":"structure","members":{"Pid":{"locationName":"pid","type":"integer"}}},"TeletextSourceSettings":{"locationName":"teletextSourceSettings","type":"structure","members":{"PageNumber":{"locationName":"pageNumber"}}}}}},"required":["Name"]}},"DeblockFilter":{"locationName":"deblockFilter"},"DenoiseFilter":{"locationName":"denoiseFilter"},"FilterStrength":{"locationName":"filterStrength","type":"integer"},"InputFilter":{"locationName":"inputFilter"},"NetworkInputSettings":{"locationName":"networkInputSettings","type":"structure","members":{"HlsInputSettings":{"locationName":"hlsInputSettings","type":"structure","members":{"Bandwidth":{"locationName":"bandwidth","type":"integer"},"BufferSegments":{"locationName":"bufferSegments","type":"integer"},"Retries":{"locationName":"retries","type":"integer"},"RetryInterval":{"locationName":"retryInterval","type":"integer"}}},"ServerValidation":{"locationName":"serverValidation"}}},"SourceEndBehavior":{"locationName":"sourceEndBehavior"},"VideoSelector":{"locationName":"videoSelector","type":"structure","members":{"ColorSpace":{"locationName":"colorSpace"},"ColorSpaceUsage":{"locationName":"colorSpaceUsage"},"SelectorSettings":{"locationName":"selectorSettings","type":"structure","members":{"VideoSelectorPid":{"locationName":"videoSelectorPid","type":"structure","members":{"Pid":{"locationName":"pid","type":"integer"}}},"VideoSelectorProgramId":{"locationName":"videoSelectorProgramId","type":"structure","members":{"ProgramId":{"locationName":"programId","type":"integer"}}}}}}}}}}}},"Sac":{"type":"structure","members":{"Codec":{"locationName":"codec"},"MaximumBitrate":{"locationName":"maximumBitrate"},"Resolution":{"locationName":"resolution"}}},"Sah":{"type":"map","key":{},"value":{}},"Saj":{"type":"structure","members":{"Arn":{"locationName":"arn"},"ChannelClass":{"locationName":"channelClass"},"Destinations":{"shape":"S1i","locationName":"destinations"},"EgressEndpoints":{"shape":"Sak","locationName":"egressEndpoints"},"EncoderSettings":{"shape":"S1p","locationName":"encoderSettings"},"Id":{"locationName":"id"},"InputAttachments":{"shape":"S9c","locationName":"inputAttachments"},"InputSpecification":{"shape":"Sac","locationName":"inputSpecification"},"LogLevel":{"locationName":"logLevel"},"Name":{"locationName":"name"},"PipelineDetails":{"shape":"Sam","locationName":"pipelineDetails"},"PipelinesRunningCount":{"locationName":"pipelinesRunningCount","type":"integer"},"RoleArn":{"locationName":"roleArn"},"State":{"locationName":"state"},"Tags":{"shape":"Sah","locationName":"tags"}}},"Sak":{"type":"list","member":{"type":"structure","members":{"SourceIp":{"locationName":"sourceIp"}}}},"Sam":{"type":"list","member":{"type":"structure","members":{"ActiveInputAttachmentName":{"locationName":"activeInputAttachmentName"},"ActiveInputSwitchActionName":{"locationName":"activeInputSwitchActionName"},"PipelineId":{"locationName":"pipelineId"}}}},"Saq":{"type":"list","member":{"type":"structure","members":{"StreamName":{"locationName":"streamName"}}}},"Sas":{"type":"list","member":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"}}}},"Sau":{"type":"list","member":{"type":"structure","members":{"PasswordParam":{"locationName":"passwordParam"},"Url":{"locationName":"url"},"Username":{"locationName":"username"}}}},"Saz":{"type":"structure","members":{"Arn":{"locationName":"arn"},"AttachedChannels":{"shape":"Se","locationName":"attachedChannels"},"Destinations":{"shape":"Sb0","locationName":"destinations"},"Id":{"locationName":"id"},"InputClass":{"locationName":"inputClass"},"InputSourceType":{"locationName":"inputSourceType"},"MediaConnectFlows":{"shape":"Sb5","locationName":"mediaConnectFlows"},"Name":{"locationName":"name"},"RoleArn":{"locationName":"roleArn"},"SecurityGroups":{"shape":"Se","locationName":"securityGroups"},"Sources":{"shape":"Sb7","locationName":"sources"},"State":{"locationName":"state"},"Tags":{"shape":"Sah","locationName":"tags"},"Type":{"locationName":"type"}}},"Sb0":{"type":"list","member":{"type":"structure","members":{"Ip":{"locationName":"ip"},"Port":{"locationName":"port"},"Url":{"locationName":"url"},"Vpc":{"locationName":"vpc","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}}}}},"Sb5":{"type":"list","member":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"}}}},"Sb7":{"type":"list","member":{"type":"structure","members":{"PasswordParam":{"locationName":"passwordParam"},"Url":{"locationName":"url"},"Username":{"locationName":"username"}}}},"Sbb":{"type":"list","member":{"type":"structure","members":{"Cidr":{"locationName":"cidr"}}}},"Sbe":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Id":{"locationName":"id"},"Inputs":{"shape":"Se","locationName":"inputs"},"State":{"locationName":"state"},"Tags":{"shape":"Sah","locationName":"tags"},"WhitelistRules":{"shape":"Sbg","locationName":"whitelistRules"}}},"Sbg":{"type":"list","member":{"type":"structure","members":{"Cidr":{"locationName":"cidr"}}}},"Sbt":{"type":"structure","members":{"ChannelClass":{"locationName":"channelClass"},"Codec":{"locationName":"codec"},"MaximumBitrate":{"locationName":"maximumBitrate"},"MaximumFramerate":{"locationName":"maximumFramerate"},"Resolution":{"locationName":"resolution"},"ResourceType":{"locationName":"resourceType"},"SpecialFeature":{"locationName":"specialFeature"},"VideoQuality":{"locationName":"videoQuality"}}},"Scz":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Count":{"locationName":"count","type":"integer"},"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"DurationUnits":{"locationName":"durationUnits"},"End":{"locationName":"end"},"FixedPrice":{"locationName":"fixedPrice","type":"double"},"Name":{"locationName":"name"},"OfferingDescription":{"locationName":"offeringDescription"},"OfferingId":{"locationName":"offeringId"},"OfferingType":{"locationName":"offeringType"},"Region":{"locationName":"region"},"ReservationId":{"locationName":"reservationId"},"ResourceSpecification":{"shape":"Sbt","locationName":"resourceSpecification"},"Start":{"locationName":"start"},"State":{"locationName":"state"},"Tags":{"shape":"Sah","locationName":"tags"},"UsagePrice":{"locationName":"usagePrice","type":"double"}}}}}');

});

parcelRequire.register("hHGyn", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeSchedule":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ScheduleActions"},"ListChannels":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Channels"},"ListInputSecurityGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"InputSecurityGroups"},"ListInputs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Inputs"},"ListOfferings":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Offerings"},"ListReservations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Reservations"}}}');

});

parcelRequire.register("fO4m2", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"ChannelCreated":{"description":"Wait until a channel has been created","operation":"DescribeChannel","delay":3,"maxAttempts":5,"acceptors":[{"state":"success","matcher":"path","argument":"State","expected":"IDLE"},{"state":"retry","matcher":"path","argument":"State","expected":"CREATING"},{"state":"retry","matcher":"status","expected":500},{"state":"failure","matcher":"path","argument":"State","expected":"CREATE_FAILED"}]},"ChannelRunning":{"description":"Wait until a channel is running","operation":"DescribeChannel","delay":5,"maxAttempts":120,"acceptors":[{"state":"success","matcher":"path","argument":"State","expected":"RUNNING"},{"state":"retry","matcher":"path","argument":"State","expected":"STARTING"},{"state":"retry","matcher":"status","expected":500}]},"ChannelStopped":{"description":"Wait until a channel has is stopped","operation":"DescribeChannel","delay":5,"maxAttempts":28,"acceptors":[{"state":"success","matcher":"path","argument":"State","expected":"IDLE"},{"state":"retry","matcher":"path","argument":"State","expected":"STOPPING"},{"state":"retry","matcher":"status","expected":500}]},"ChannelDeleted":{"description":"Wait until a channel has been deleted","operation":"DescribeChannel","delay":5,"maxAttempts":20,"acceptors":[{"state":"success","matcher":"path","argument":"State","expected":"DELETED"},{"state":"retry","matcher":"path","argument":"State","expected":"DELETING"},{"state":"retry","matcher":"status","expected":500}]}}}');

});


parcelRequire.register("5ya3x", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $40a7edaae8c48990$var$Service = $dbC7k.Service;
var $40a7edaae8c48990$var$apiLoader = $dbC7k.apiLoader;
$40a7edaae8c48990$var$apiLoader.services["mediapackage"] = {};
$dbC7k.MediaPackage = $40a7edaae8c48990$var$Service.defineService("mediapackage", [
    "2017-10-12"
]);


Object.defineProperty($40a7edaae8c48990$var$apiLoader.services["mediapackage"], "2017-10-12", {
    get: function get() {
        var model = (parcelRequire("8LJep"));
        model.paginators = (parcelRequire("eNkEf")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.MediaPackage;

});
parcelRequire.register("8LJep", function(module, exports) {
module.exports = JSON.parse('{"metadata":{"apiVersion":"2017-10-12","endpointPrefix":"mediapackage","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"MediaPackage","serviceFullName":"AWS Elemental MediaPackage","serviceId":"MediaPackage","signatureVersion":"v4","signingName":"mediapackage","uid":"mediapackage-2017-10-12"},"operations":{"CreateChannel":{"http":{"requestUri":"/channels","responseCode":200},"input":{"members":{"Description":{"locationName":"description"},"Id":{"locationName":"id"},"Tags":{"locationName":"tags","shape":"S3"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"Description":{"locationName":"description"},"HlsIngest":{"locationName":"hlsIngest","shape":"S5"},"Id":{"locationName":"id"},"Tags":{"locationName":"tags","shape":"S3"}},"type":"structure"}},"CreateOriginEndpoint":{"http":{"requestUri":"/origin_endpoints","responseCode":200},"input":{"members":{"ChannelId":{"locationName":"channelId"},"CmafPackage":{"locationName":"cmafPackage","shape":"S9"},"DashPackage":{"locationName":"dashPackage","shape":"So"},"Description":{"locationName":"description"},"HlsPackage":{"locationName":"hlsPackage","shape":"Sv"},"Id":{"locationName":"id"},"ManifestName":{"locationName":"manifestName"},"MssPackage":{"locationName":"mssPackage","shape":"Sy"},"StartoverWindowSeconds":{"locationName":"startoverWindowSeconds","type":"integer"},"Tags":{"locationName":"tags","shape":"S3"},"TimeDelaySeconds":{"locationName":"timeDelaySeconds","type":"integer"},"Whitelist":{"locationName":"whitelist","shape":"Sd"}},"required":["ChannelId","Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"ChannelId":{"locationName":"channelId"},"CmafPackage":{"locationName":"cmafPackage","shape":"S11"},"DashPackage":{"locationName":"dashPackage","shape":"So"},"Description":{"locationName":"description"},"HlsPackage":{"locationName":"hlsPackage","shape":"Sv"},"Id":{"locationName":"id"},"ManifestName":{"locationName":"manifestName"},"MssPackage":{"locationName":"mssPackage","shape":"Sy"},"StartoverWindowSeconds":{"locationName":"startoverWindowSeconds","type":"integer"},"Tags":{"locationName":"tags","shape":"S3"},"TimeDelaySeconds":{"locationName":"timeDelaySeconds","type":"integer"},"Url":{"locationName":"url"},"Whitelist":{"locationName":"whitelist","shape":"Sd"}},"type":"structure"}},"DeleteChannel":{"http":{"method":"DELETE","requestUri":"/channels/{id}","responseCode":202},"input":{"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{},"type":"structure"}},"DeleteOriginEndpoint":{"http":{"method":"DELETE","requestUri":"/origin_endpoints/{id}","responseCode":202},"input":{"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{},"type":"structure"}},"DescribeChannel":{"http":{"method":"GET","requestUri":"/channels/{id}","responseCode":200},"input":{"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"Description":{"locationName":"description"},"HlsIngest":{"locationName":"hlsIngest","shape":"S5"},"Id":{"locationName":"id"},"Tags":{"locationName":"tags","shape":"S3"}},"type":"structure"}},"DescribeOriginEndpoint":{"http":{"method":"GET","requestUri":"/origin_endpoints/{id}","responseCode":200},"input":{"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"ChannelId":{"locationName":"channelId"},"CmafPackage":{"locationName":"cmafPackage","shape":"S11"},"DashPackage":{"locationName":"dashPackage","shape":"So"},"Description":{"locationName":"description"},"HlsPackage":{"locationName":"hlsPackage","shape":"Sv"},"Id":{"locationName":"id"},"ManifestName":{"locationName":"manifestName"},"MssPackage":{"locationName":"mssPackage","shape":"Sy"},"StartoverWindowSeconds":{"locationName":"startoverWindowSeconds","type":"integer"},"Tags":{"locationName":"tags","shape":"S3"},"TimeDelaySeconds":{"locationName":"timeDelaySeconds","type":"integer"},"Url":{"locationName":"url"},"Whitelist":{"locationName":"whitelist","shape":"Sd"}},"type":"structure"}},"ListChannels":{"http":{"method":"GET","requestUri":"/channels","responseCode":200},"input":{"members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"type":"structure"},"output":{"members":{"Channels":{"locationName":"channels","member":{"members":{"Arn":{"locationName":"arn"},"Description":{"locationName":"description"},"HlsIngest":{"locationName":"hlsIngest","shape":"S5"},"Id":{"locationName":"id"},"Tags":{"locationName":"tags","shape":"S3"}},"type":"structure"},"type":"list"},"NextToken":{"locationName":"nextToken"}},"type":"structure"}},"ListOriginEndpoints":{"http":{"method":"GET","requestUri":"/origin_endpoints","responseCode":200},"input":{"members":{"ChannelId":{"location":"querystring","locationName":"channelId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"type":"structure"},"output":{"members":{"NextToken":{"locationName":"nextToken"},"OriginEndpoints":{"locationName":"originEndpoints","member":{"members":{"Arn":{"locationName":"arn"},"ChannelId":{"locationName":"channelId"},"CmafPackage":{"locationName":"cmafPackage","shape":"S11"},"DashPackage":{"locationName":"dashPackage","shape":"So"},"Description":{"locationName":"description"},"HlsPackage":{"locationName":"hlsPackage","shape":"Sv"},"Id":{"locationName":"id"},"ManifestName":{"locationName":"manifestName"},"MssPackage":{"locationName":"mssPackage","shape":"Sy"},"StartoverWindowSeconds":{"locationName":"startoverWindowSeconds","type":"integer"},"Tags":{"locationName":"tags","shape":"S3"},"TimeDelaySeconds":{"locationName":"timeDelaySeconds","type":"integer"},"Url":{"locationName":"url"},"Whitelist":{"locationName":"whitelist","shape":"Sd"}},"type":"structure"},"type":"list"}},"type":"structure"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resource-arn}","responseCode":200},"input":{"members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"}},"required":["ResourceArn"],"type":"structure"},"output":{"members":{"Tags":{"locationName":"tags","shape":"S1n"}},"type":"structure"}},"RotateChannelCredentials":{"deprecated":true,"deprecatedMessage":"This API is deprecated. Please use RotateIngestEndpointCredentials instead","http":{"method":"PUT","requestUri":"/channels/{id}/credentials","responseCode":200},"input":{"deprecated":true,"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"deprecated":true,"members":{"Arn":{"locationName":"arn"},"Description":{"locationName":"description"},"HlsIngest":{"locationName":"hlsIngest","shape":"S5"},"Id":{"locationName":"id"},"Tags":{"locationName":"tags","shape":"S3"}},"type":"structure"}},"RotateIngestEndpointCredentials":{"http":{"method":"PUT","requestUri":"/channels/{id}/ingest_endpoints/{ingest_endpoint_id}/credentials","responseCode":200},"input":{"members":{"Id":{"location":"uri","locationName":"id"},"IngestEndpointId":{"location":"uri","locationName":"ingest_endpoint_id"}},"required":["IngestEndpointId","Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"Description":{"locationName":"description"},"HlsIngest":{"locationName":"hlsIngest","shape":"S5"},"Id":{"locationName":"id"},"Tags":{"locationName":"tags","shape":"S3"}},"type":"structure"}},"TagResource":{"http":{"requestUri":"/tags/{resource-arn}","responseCode":204},"input":{"members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"Tags":{"locationName":"tags","shape":"S1n"}},"required":["ResourceArn","Tags"],"type":"structure"}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resource-arn}","responseCode":204},"input":{"members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","shape":"Sd"}},"required":["TagKeys","ResourceArn"],"type":"structure"}},"UpdateChannel":{"http":{"method":"PUT","requestUri":"/channels/{id}","responseCode":200},"input":{"members":{"Description":{"locationName":"description"},"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"Description":{"locationName":"description"},"HlsIngest":{"locationName":"hlsIngest","shape":"S5"},"Id":{"locationName":"id"},"Tags":{"locationName":"tags","shape":"S3"}},"type":"structure"}},"UpdateOriginEndpoint":{"http":{"method":"PUT","requestUri":"/origin_endpoints/{id}","responseCode":200},"input":{"members":{"CmafPackage":{"locationName":"cmafPackage","shape":"S9"},"DashPackage":{"locationName":"dashPackage","shape":"So"},"Description":{"locationName":"description"},"HlsPackage":{"locationName":"hlsPackage","shape":"Sv"},"Id":{"location":"uri","locationName":"id"},"ManifestName":{"locationName":"manifestName"},"MssPackage":{"locationName":"mssPackage","shape":"Sy"},"StartoverWindowSeconds":{"locationName":"startoverWindowSeconds","type":"integer"},"TimeDelaySeconds":{"locationName":"timeDelaySeconds","type":"integer"},"Whitelist":{"locationName":"whitelist","shape":"Sd"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"ChannelId":{"locationName":"channelId"},"CmafPackage":{"locationName":"cmafPackage","shape":"S11"},"DashPackage":{"locationName":"dashPackage","shape":"So"},"Description":{"locationName":"description"},"HlsPackage":{"locationName":"hlsPackage","shape":"Sv"},"Id":{"locationName":"id"},"ManifestName":{"locationName":"manifestName"},"MssPackage":{"locationName":"mssPackage","shape":"Sy"},"StartoverWindowSeconds":{"locationName":"startoverWindowSeconds","type":"integer"},"Tags":{"locationName":"tags","shape":"S3"},"TimeDelaySeconds":{"locationName":"timeDelaySeconds","type":"integer"},"Url":{"locationName":"url"},"Whitelist":{"locationName":"whitelist","shape":"Sd"}},"type":"structure"}}},"shapes":{"S3":{"key":{},"type":"map","value":{}},"S5":{"members":{"IngestEndpoints":{"locationName":"ingestEndpoints","member":{"members":{"Id":{"locationName":"id"},"Password":{"locationName":"password"},"Url":{"locationName":"url"},"Username":{"locationName":"username"}},"type":"structure"},"type":"list"}},"type":"structure"},"S9":{"members":{"Encryption":{"locationName":"encryption","shape":"Sa"},"HlsManifests":{"locationName":"hlsManifests","member":{"members":{"AdMarkers":{"locationName":"adMarkers"},"AdTriggers":{"locationName":"adTriggers","shape":"Sh"},"AdsOnDeliveryRestrictions":{"locationName":"adsOnDeliveryRestrictions"},"Id":{"locationName":"id"},"IncludeIframeOnlyStream":{"locationName":"includeIframeOnlyStream","type":"boolean"},"ManifestName":{"locationName":"manifestName"},"PlaylistType":{"locationName":"playlistType"},"PlaylistWindowSeconds":{"locationName":"playlistWindowSeconds","type":"integer"},"ProgramDateTimeIntervalSeconds":{"locationName":"programDateTimeIntervalSeconds","type":"integer"}},"required":["Id"],"type":"structure"},"type":"list"},"SegmentDurationSeconds":{"locationName":"segmentDurationSeconds","type":"integer"},"SegmentPrefix":{"locationName":"segmentPrefix"},"StreamSelection":{"locationName":"streamSelection","shape":"Sm"}},"type":"structure"},"Sa":{"members":{"KeyRotationIntervalSeconds":{"locationName":"keyRotationIntervalSeconds","type":"integer"},"SpekeKeyProvider":{"locationName":"spekeKeyProvider","shape":"Sc"}},"required":["SpekeKeyProvider"],"type":"structure"},"Sc":{"members":{"CertificateArn":{"locationName":"certificateArn"},"ResourceId":{"locationName":"resourceId"},"RoleArn":{"locationName":"roleArn"},"SystemIds":{"locationName":"systemIds","shape":"Sd"},"Url":{"locationName":"url"}},"required":["Url","ResourceId","RoleArn","SystemIds"],"type":"structure"},"Sd":{"member":{},"type":"list"},"Sh":{"member":{},"type":"list"},"Sm":{"members":{"MaxVideoBitsPerSecond":{"locationName":"maxVideoBitsPerSecond","type":"integer"},"MinVideoBitsPerSecond":{"locationName":"minVideoBitsPerSecond","type":"integer"},"StreamOrder":{"locationName":"streamOrder"}},"type":"structure"},"So":{"members":{"AdTriggers":{"locationName":"adTriggers","shape":"Sh"},"AdsOnDeliveryRestrictions":{"locationName":"adsOnDeliveryRestrictions"},"Encryption":{"locationName":"encryption","members":{"KeyRotationIntervalSeconds":{"locationName":"keyRotationIntervalSeconds","type":"integer"},"SpekeKeyProvider":{"locationName":"spekeKeyProvider","shape":"Sc"}},"required":["SpekeKeyProvider"],"type":"structure"},"ManifestLayout":{"locationName":"manifestLayout"},"ManifestWindowSeconds":{"locationName":"manifestWindowSeconds","type":"integer"},"MinBufferTimeSeconds":{"locationName":"minBufferTimeSeconds","type":"integer"},"MinUpdatePeriodSeconds":{"locationName":"minUpdatePeriodSeconds","type":"integer"},"PeriodTriggers":{"locationName":"periodTriggers","member":{},"type":"list"},"Profile":{"locationName":"profile"},"SegmentDurationSeconds":{"locationName":"segmentDurationSeconds","type":"integer"},"SegmentTemplateFormat":{"locationName":"segmentTemplateFormat"},"StreamSelection":{"locationName":"streamSelection","shape":"Sm"},"SuggestedPresentationDelaySeconds":{"locationName":"suggestedPresentationDelaySeconds","type":"integer"}},"type":"structure"},"Sv":{"members":{"AdMarkers":{"locationName":"adMarkers"},"AdTriggers":{"locationName":"adTriggers","shape":"Sh"},"AdsOnDeliveryRestrictions":{"locationName":"adsOnDeliveryRestrictions"},"Encryption":{"locationName":"encryption","members":{"ConstantInitializationVector":{"locationName":"constantInitializationVector"},"EncryptionMethod":{"locationName":"encryptionMethod"},"KeyRotationIntervalSeconds":{"locationName":"keyRotationIntervalSeconds","type":"integer"},"RepeatExtXKey":{"locationName":"repeatExtXKey","type":"boolean"},"SpekeKeyProvider":{"locationName":"spekeKeyProvider","shape":"Sc"}},"required":["SpekeKeyProvider"],"type":"structure"},"IncludeIframeOnlyStream":{"locationName":"includeIframeOnlyStream","type":"boolean"},"PlaylistType":{"locationName":"playlistType"},"PlaylistWindowSeconds":{"locationName":"playlistWindowSeconds","type":"integer"},"ProgramDateTimeIntervalSeconds":{"locationName":"programDateTimeIntervalSeconds","type":"integer"},"SegmentDurationSeconds":{"locationName":"segmentDurationSeconds","type":"integer"},"StreamSelection":{"locationName":"streamSelection","shape":"Sm"},"UseAudioRenditionGroup":{"locationName":"useAudioRenditionGroup","type":"boolean"}},"type":"structure"},"Sy":{"members":{"Encryption":{"locationName":"encryption","members":{"SpekeKeyProvider":{"locationName":"spekeKeyProvider","shape":"Sc"}},"required":["SpekeKeyProvider"],"type":"structure"},"ManifestWindowSeconds":{"locationName":"manifestWindowSeconds","type":"integer"},"SegmentDurationSeconds":{"locationName":"segmentDurationSeconds","type":"integer"},"StreamSelection":{"locationName":"streamSelection","shape":"Sm"}},"type":"structure"},"S11":{"members":{"Encryption":{"locationName":"encryption","shape":"Sa"},"HlsManifests":{"locationName":"hlsManifests","member":{"members":{"AdMarkers":{"locationName":"adMarkers"},"Id":{"locationName":"id"},"IncludeIframeOnlyStream":{"locationName":"includeIframeOnlyStream","type":"boolean"},"ManifestName":{"locationName":"manifestName"},"PlaylistType":{"locationName":"playlistType"},"PlaylistWindowSeconds":{"locationName":"playlistWindowSeconds","type":"integer"},"ProgramDateTimeIntervalSeconds":{"locationName":"programDateTimeIntervalSeconds","type":"integer"},"Url":{"locationName":"url"}},"required":["Id"],"type":"structure"},"type":"list"},"SegmentDurationSeconds":{"locationName":"segmentDurationSeconds","type":"integer"},"SegmentPrefix":{"locationName":"segmentPrefix"},"StreamSelection":{"locationName":"streamSelection","shape":"Sm"}},"type":"structure"},"S1n":{"key":{},"type":"map","value":{}}}}');

});

parcelRequire.register("eNkEf", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListChannels":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Channels"},"ListOriginEndpoints":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"OriginEndpoints"}}}');

});


parcelRequire.register("azr8B", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $7b223940aa705673$var$Service = $dbC7k.Service;
var $7b223940aa705673$var$apiLoader = $dbC7k.apiLoader;
$7b223940aa705673$var$apiLoader.services["mediastore"] = {};
$dbC7k.MediaStore = $7b223940aa705673$var$Service.defineService("mediastore", [
    "2017-09-01"
]);


Object.defineProperty($7b223940aa705673$var$apiLoader.services["mediastore"], "2017-09-01", {
    get: function get() {
        var model = (parcelRequire("6NaAA"));
        model.paginators = (parcelRequire("3OqgM")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.MediaStore;

});
parcelRequire.register("6NaAA", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-09-01","endpointPrefix":"mediastore","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"MediaStore","serviceFullName":"AWS Elemental MediaStore","serviceId":"MediaStore","signatureVersion":"v4","signingName":"mediastore","targetPrefix":"MediaStore_20170901","uid":"mediastore-2017-09-01"},"operations":{"CreateContainer":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{},"Tags":{"shape":"S3"}}},"output":{"type":"structure","required":["Container"],"members":{"Container":{"shape":"S8"}}}},"DeleteContainer":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{}}},"output":{"type":"structure","members":{}}},"DeleteContainerPolicy":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{}}},"output":{"type":"structure","members":{}}},"DeleteCorsPolicy":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{}}},"output":{"type":"structure","members":{}}},"DeleteLifecyclePolicy":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{}}},"output":{"type":"structure","members":{}}},"DescribeContainer":{"input":{"type":"structure","members":{"ContainerName":{}}},"output":{"type":"structure","members":{"Container":{"shape":"S8"}}}},"GetContainerPolicy":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{}}},"output":{"type":"structure","required":["Policy"],"members":{"Policy":{}}}},"GetCorsPolicy":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{}}},"output":{"type":"structure","required":["CorsPolicy"],"members":{"CorsPolicy":{"shape":"St"}}}},"GetLifecyclePolicy":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{}}},"output":{"type":"structure","required":["LifecyclePolicy"],"members":{"LifecyclePolicy":{}}}},"ListContainers":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["Containers"],"members":{"Containers":{"type":"list","member":{"shape":"S8"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["Resource"],"members":{"Resource":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S3"}}}},"PutContainerPolicy":{"input":{"type":"structure","required":["ContainerName","Policy"],"members":{"ContainerName":{},"Policy":{}}},"output":{"type":"structure","members":{}}},"PutCorsPolicy":{"input":{"type":"structure","required":["ContainerName","CorsPolicy"],"members":{"ContainerName":{},"CorsPolicy":{"shape":"St"}}},"output":{"type":"structure","members":{}}},"PutLifecyclePolicy":{"input":{"type":"structure","required":["ContainerName","LifecyclePolicy"],"members":{"ContainerName":{},"LifecyclePolicy":{}}},"output":{"type":"structure","members":{}}},"StartAccessLogging":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{}}},"output":{"type":"structure","members":{}}},"StopAccessLogging":{"input":{"type":"structure","required":["ContainerName"],"members":{"ContainerName":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{},"Tags":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S8":{"type":"structure","members":{"Endpoint":{},"CreationTime":{"type":"timestamp"},"ARN":{},"Name":{},"Status":{},"AccessLoggingEnabled":{"type":"boolean"}}},"St":{"type":"list","member":{"type":"structure","required":["AllowedOrigins","AllowedHeaders"],"members":{"AllowedOrigins":{"type":"list","member":{}},"AllowedMethods":{"type":"list","member":{}},"AllowedHeaders":{"type":"list","member":{}},"MaxAgeSeconds":{"type":"integer"},"ExposeHeaders":{"type":"list","member":{}}}}}}}');

});

parcelRequire.register("3OqgM", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListContainers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("1MQ84", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $14d2b5e379cff66c$var$Service = $dbC7k.Service;
var $14d2b5e379cff66c$var$apiLoader = $dbC7k.apiLoader;
$14d2b5e379cff66c$var$apiLoader.services["mediastoredata"] = {};
$dbC7k.MediaStoreData = $14d2b5e379cff66c$var$Service.defineService("mediastoredata", [
    "2017-09-01"
]);


Object.defineProperty($14d2b5e379cff66c$var$apiLoader.services["mediastoredata"], "2017-09-01", {
    get: function get() {
        var model = (parcelRequire("9Mhxq"));
        model.paginators = (parcelRequire("5PO8c")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.MediaStoreData;

});
parcelRequire.register("9Mhxq", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-09-01","endpointPrefix":"data.mediastore","protocol":"rest-json","serviceAbbreviation":"MediaStore Data","serviceFullName":"AWS Elemental MediaStore Data Plane","serviceId":"MediaStore Data","signatureVersion":"v4","signingName":"mediastore","uid":"mediastore-data-2017-09-01"},"operations":{"DeleteObject":{"http":{"method":"DELETE","requestUri":"/{Path+}"},"input":{"type":"structure","required":["Path"],"members":{"Path":{"location":"uri","locationName":"Path"}}},"output":{"type":"structure","members":{}}},"DescribeObject":{"http":{"method":"HEAD","requestUri":"/{Path+}"},"input":{"type":"structure","required":["Path"],"members":{"Path":{"location":"uri","locationName":"Path"}}},"output":{"type":"structure","members":{"ETag":{"location":"header","locationName":"ETag"},"ContentType":{"location":"header","locationName":"Content-Type"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"}}}},"GetObject":{"http":{"method":"GET","requestUri":"/{Path+}"},"input":{"type":"structure","required":["Path"],"members":{"Path":{"location":"uri","locationName":"Path"},"Range":{"location":"header","locationName":"Range"}}},"output":{"type":"structure","required":["StatusCode"],"members":{"Body":{"shape":"Se"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentRange":{"location":"header","locationName":"Content-Range"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ContentType":{"location":"header","locationName":"Content-Type"},"ETag":{"location":"header","locationName":"ETag"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"},"StatusCode":{"location":"statusCode","type":"integer"}},"payload":"Body"}},"ListItems":{"http":{"method":"GET"},"input":{"type":"structure","members":{"Path":{"location":"querystring","locationName":"Path"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Items":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"ETag":{},"LastModified":{"type":"timestamp"},"ContentType":{},"ContentLength":{"type":"long"}}}},"NextToken":{}}}},"PutObject":{"http":{"method":"PUT","requestUri":"/{Path+}"},"input":{"type":"structure","required":["Body","Path"],"members":{"Body":{"shape":"Se"},"Path":{"location":"uri","locationName":"Path"},"ContentType":{"location":"header","locationName":"Content-Type"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"UploadAvailability":{"location":"header","locationName":"x-amz-upload-availability"}},"payload":"Body"},"output":{"type":"structure","members":{"ContentSHA256":{},"ETag":{},"StorageClass":{}}},"authtype":"v4-unsigned-body"}},"shapes":{"Se":{"type":"blob","streaming":true}}}');

});

parcelRequire.register("5PO8c", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListItems":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("b1wwb", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $8069031edf970a8f$var$Service = $dbC7k.Service;
var $8069031edf970a8f$var$apiLoader = $dbC7k.apiLoader;
$8069031edf970a8f$var$apiLoader.services["appsync"] = {};
$dbC7k.AppSync = $8069031edf970a8f$var$Service.defineService("appsync", [
    "2017-07-25"
]);


Object.defineProperty($8069031edf970a8f$var$apiLoader.services["appsync"], "2017-07-25", {
    get: function get() {
        var model = (parcelRequire("lTGsF"));
        model.paginators = (parcelRequire("K0WKt")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.AppSync;

});
parcelRequire.register("lTGsF", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-07-25","endpointPrefix":"appsync","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"AWSAppSync","serviceFullName":"AWS AppSync","serviceId":"AppSync","signatureVersion":"v4","signingName":"appsync","uid":"appsync-2017-07-25"},"operations":{"CreateApiKey":{"http":{"requestUri":"/v1/apis/{apiId}/apikeys"},"input":{"type":"structure","required":["apiId"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"description":{},"expires":{"type":"long"}}},"output":{"type":"structure","members":{"apiKey":{"shape":"S5"}}}},"CreateDataSource":{"http":{"requestUri":"/v1/apis/{apiId}/datasources"},"input":{"type":"structure","required":["apiId","name","type"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"name":{},"description":{},"type":{},"serviceRoleArn":{},"dynamodbConfig":{"shape":"S9"},"lambdaConfig":{"shape":"Sb"},"elasticsearchConfig":{"shape":"Sc"},"httpConfig":{"shape":"Sd"},"relationalDatabaseConfig":{"shape":"Sh"}}},"output":{"type":"structure","members":{"dataSource":{"shape":"Sl"}}}},"CreateFunction":{"http":{"requestUri":"/v1/apis/{apiId}/functions"},"input":{"type":"structure","required":["apiId","name","dataSourceName","requestMappingTemplate","functionVersion"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"name":{},"description":{},"dataSourceName":{},"requestMappingTemplate":{},"responseMappingTemplate":{},"functionVersion":{}}},"output":{"type":"structure","members":{"functionConfiguration":{"shape":"Sp"}}}},"CreateGraphqlApi":{"http":{"requestUri":"/v1/apis"},"input":{"type":"structure","required":["name","authenticationType"],"members":{"name":{},"logConfig":{"shape":"Sr"},"authenticationType":{},"userPoolConfig":{"shape":"Su"},"openIDConnectConfig":{"shape":"Sw"},"tags":{"shape":"Sx"},"additionalAuthenticationProviders":{"shape":"S10"}}},"output":{"type":"structure","members":{"graphqlApi":{"shape":"S14"}}}},"CreateResolver":{"http":{"requestUri":"/v1/apis/{apiId}/types/{typeName}/resolvers"},"input":{"type":"structure","required":["apiId","typeName","fieldName","requestMappingTemplate"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"typeName":{"location":"uri","locationName":"typeName"},"fieldName":{},"dataSourceName":{},"requestMappingTemplate":{},"responseMappingTemplate":{},"kind":{},"pipelineConfig":{"shape":"S18"}}},"output":{"type":"structure","members":{"resolver":{"shape":"S1b"}}}},"CreateType":{"http":{"requestUri":"/v1/apis/{apiId}/types"},"input":{"type":"structure","required":["apiId","definition","format"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"definition":{},"format":{}}},"output":{"type":"structure","members":{"type":{"shape":"S1f"}}}},"DeleteApiKey":{"http":{"method":"DELETE","requestUri":"/v1/apis/{apiId}/apikeys/{id}"},"input":{"type":"structure","required":["apiId","id"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"id":{"location":"uri","locationName":"id"}}},"output":{"type":"structure","members":{}}},"DeleteDataSource":{"http":{"method":"DELETE","requestUri":"/v1/apis/{apiId}/datasources/{name}"},"input":{"type":"structure","required":["apiId","name"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{}}},"DeleteFunction":{"http":{"method":"DELETE","requestUri":"/v1/apis/{apiId}/functions/{functionId}"},"input":{"type":"structure","required":["apiId","functionId"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"functionId":{"location":"uri","locationName":"functionId"}}},"output":{"type":"structure","members":{}}},"DeleteGraphqlApi":{"http":{"method":"DELETE","requestUri":"/v1/apis/{apiId}"},"input":{"type":"structure","required":["apiId"],"members":{"apiId":{"location":"uri","locationName":"apiId"}}},"output":{"type":"structure","members":{}}},"DeleteResolver":{"http":{"method":"DELETE","requestUri":"/v1/apis/{apiId}/types/{typeName}/resolvers/{fieldName}"},"input":{"type":"structure","required":["apiId","typeName","fieldName"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"typeName":{"location":"uri","locationName":"typeName"},"fieldName":{"location":"uri","locationName":"fieldName"}}},"output":{"type":"structure","members":{}}},"DeleteType":{"http":{"method":"DELETE","requestUri":"/v1/apis/{apiId}/types/{typeName}"},"input":{"type":"structure","required":["apiId","typeName"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"typeName":{"location":"uri","locationName":"typeName"}}},"output":{"type":"structure","members":{}}},"GetDataSource":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/datasources/{name}"},"input":{"type":"structure","required":["apiId","name"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"dataSource":{"shape":"Sl"}}}},"GetFunction":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/functions/{functionId}"},"input":{"type":"structure","required":["apiId","functionId"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"functionId":{"location":"uri","locationName":"functionId"}}},"output":{"type":"structure","members":{"functionConfiguration":{"shape":"Sp"}}}},"GetGraphqlApi":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}"},"input":{"type":"structure","required":["apiId"],"members":{"apiId":{"location":"uri","locationName":"apiId"}}},"output":{"type":"structure","members":{"graphqlApi":{"shape":"S14"}}}},"GetIntrospectionSchema":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/schema"},"input":{"type":"structure","required":["apiId","format"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"format":{"location":"querystring","locationName":"format"},"includeDirectives":{"location":"querystring","locationName":"includeDirectives","type":"boolean"}}},"output":{"type":"structure","members":{"schema":{"type":"blob"}},"payload":"schema"}},"GetResolver":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/types/{typeName}/resolvers/{fieldName}"},"input":{"type":"structure","required":["apiId","typeName","fieldName"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"typeName":{"location":"uri","locationName":"typeName"},"fieldName":{"location":"uri","locationName":"fieldName"}}},"output":{"type":"structure","members":{"resolver":{"shape":"S1b"}}}},"GetSchemaCreationStatus":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/schemacreation"},"input":{"type":"structure","required":["apiId"],"members":{"apiId":{"location":"uri","locationName":"apiId"}}},"output":{"type":"structure","members":{"status":{},"details":{}}}},"GetType":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/types/{typeName}"},"input":{"type":"structure","required":["apiId","typeName","format"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"typeName":{"location":"uri","locationName":"typeName"},"format":{"location":"querystring","locationName":"format"}}},"output":{"type":"structure","members":{"type":{"shape":"S1f"}}}},"ListApiKeys":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/apikeys"},"input":{"type":"structure","required":["apiId"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"apiKeys":{"type":"list","member":{"shape":"S5"}},"nextToken":{}}}},"ListDataSources":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/datasources"},"input":{"type":"structure","required":["apiId"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"dataSources":{"type":"list","member":{"shape":"Sl"}},"nextToken":{}}}},"ListFunctions":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/functions"},"input":{"type":"structure","required":["apiId"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"functions":{"type":"list","member":{"shape":"Sp"}},"nextToken":{}}}},"ListGraphqlApis":{"http":{"method":"GET","requestUri":"/v1/apis"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"graphqlApis":{"type":"list","member":{"shape":"S14"}},"nextToken":{}}}},"ListResolvers":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/types/{typeName}/resolvers"},"input":{"type":"structure","required":["apiId","typeName"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"typeName":{"location":"uri","locationName":"typeName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"resolvers":{"shape":"S2q"},"nextToken":{}}}},"ListResolversByFunction":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/functions/{functionId}/resolvers"},"input":{"type":"structure","required":["apiId","functionId"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"functionId":{"location":"uri","locationName":"functionId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"resolvers":{"shape":"S2q"},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/v1/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sx"}}}},"ListTypes":{"http":{"method":"GET","requestUri":"/v1/apis/{apiId}/types"},"input":{"type":"structure","required":["apiId","format"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"format":{"location":"querystring","locationName":"format"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"types":{"type":"list","member":{"shape":"S1f"}},"nextToken":{}}}},"StartSchemaCreation":{"http":{"requestUri":"/v1/apis/{apiId}/schemacreation"},"input":{"type":"structure","required":["apiId","definition"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"definition":{"type":"blob"}}},"output":{"type":"structure","members":{"status":{}}}},"TagResource":{"http":{"requestUri":"/v1/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/v1/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateApiKey":{"http":{"requestUri":"/v1/apis/{apiId}/apikeys/{id}"},"input":{"type":"structure","required":["apiId","id"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"id":{"location":"uri","locationName":"id"},"description":{},"expires":{"type":"long"}}},"output":{"type":"structure","members":{"apiKey":{"shape":"S5"}}}},"UpdateDataSource":{"http":{"requestUri":"/v1/apis/{apiId}/datasources/{name}"},"input":{"type":"structure","required":["apiId","name","type"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"name":{"location":"uri","locationName":"name"},"description":{},"type":{},"serviceRoleArn":{},"dynamodbConfig":{"shape":"S9"},"lambdaConfig":{"shape":"Sb"},"elasticsearchConfig":{"shape":"Sc"},"httpConfig":{"shape":"Sd"},"relationalDatabaseConfig":{"shape":"Sh"}}},"output":{"type":"structure","members":{"dataSource":{"shape":"Sl"}}}},"UpdateFunction":{"http":{"requestUri":"/v1/apis/{apiId}/functions/{functionId}"},"input":{"type":"structure","required":["apiId","name","functionId","dataSourceName","requestMappingTemplate","functionVersion"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"name":{},"description":{},"functionId":{"location":"uri","locationName":"functionId"},"dataSourceName":{},"requestMappingTemplate":{},"responseMappingTemplate":{},"functionVersion":{}}},"output":{"type":"structure","members":{"functionConfiguration":{"shape":"Sp"}}}},"UpdateGraphqlApi":{"http":{"requestUri":"/v1/apis/{apiId}"},"input":{"type":"structure","required":["apiId","name"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"name":{},"logConfig":{"shape":"Sr"},"authenticationType":{},"userPoolConfig":{"shape":"Su"},"openIDConnectConfig":{"shape":"Sw"},"additionalAuthenticationProviders":{"shape":"S10"}}},"output":{"type":"structure","members":{"graphqlApi":{"shape":"S14"}}}},"UpdateResolver":{"http":{"requestUri":"/v1/apis/{apiId}/types/{typeName}/resolvers/{fieldName}"},"input":{"type":"structure","required":["apiId","typeName","fieldName","requestMappingTemplate"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"typeName":{"location":"uri","locationName":"typeName"},"fieldName":{"location":"uri","locationName":"fieldName"},"dataSourceName":{},"requestMappingTemplate":{},"responseMappingTemplate":{},"kind":{},"pipelineConfig":{"shape":"S18"}}},"output":{"type":"structure","members":{"resolver":{"shape":"S1b"}}}},"UpdateType":{"http":{"requestUri":"/v1/apis/{apiId}/types/{typeName}"},"input":{"type":"structure","required":["apiId","typeName","format"],"members":{"apiId":{"location":"uri","locationName":"apiId"},"typeName":{"location":"uri","locationName":"typeName"},"definition":{},"format":{}}},"output":{"type":"structure","members":{"type":{"shape":"S1f"}}}}},"shapes":{"S5":{"type":"structure","members":{"id":{},"description":{},"expires":{"type":"long"}}},"S9":{"type":"structure","required":["tableName","awsRegion"],"members":{"tableName":{},"awsRegion":{},"useCallerCredentials":{"type":"boolean"}}},"Sb":{"type":"structure","required":["lambdaFunctionArn"],"members":{"lambdaFunctionArn":{}}},"Sc":{"type":"structure","required":["endpoint","awsRegion"],"members":{"endpoint":{},"awsRegion":{}}},"Sd":{"type":"structure","members":{"endpoint":{},"authorizationConfig":{"type":"structure","required":["authorizationType"],"members":{"authorizationType":{},"awsIamConfig":{"type":"structure","members":{"signingRegion":{},"signingServiceName":{}}}}}}},"Sh":{"type":"structure","members":{"relationalDatabaseSourceType":{},"rdsHttpEndpointConfig":{"type":"structure","members":{"awsRegion":{},"dbClusterIdentifier":{},"databaseName":{},"schema":{},"awsSecretStoreArn":{}}}}},"Sl":{"type":"structure","members":{"dataSourceArn":{},"name":{},"description":{},"type":{},"serviceRoleArn":{},"dynamodbConfig":{"shape":"S9"},"lambdaConfig":{"shape":"Sb"},"elasticsearchConfig":{"shape":"Sc"},"httpConfig":{"shape":"Sd"},"relationalDatabaseConfig":{"shape":"Sh"}}},"Sp":{"type":"structure","members":{"functionId":{},"functionArn":{},"name":{},"description":{},"dataSourceName":{},"requestMappingTemplate":{},"responseMappingTemplate":{},"functionVersion":{}}},"Sr":{"type":"structure","required":["fieldLogLevel","cloudWatchLogsRoleArn"],"members":{"fieldLogLevel":{},"cloudWatchLogsRoleArn":{},"excludeVerboseContent":{"type":"boolean"}}},"Su":{"type":"structure","required":["userPoolId","awsRegion","defaultAction"],"members":{"userPoolId":{},"awsRegion":{},"defaultAction":{},"appIdClientRegex":{}}},"Sw":{"type":"structure","required":["issuer"],"members":{"issuer":{},"clientId":{},"iatTTL":{"type":"long"},"authTTL":{"type":"long"}}},"Sx":{"type":"map","key":{},"value":{}},"S10":{"type":"list","member":{"type":"structure","members":{"authenticationType":{},"openIDConnectConfig":{"shape":"Sw"},"userPoolConfig":{"type":"structure","required":["userPoolId","awsRegion"],"members":{"userPoolId":{},"awsRegion":{},"appIdClientRegex":{}}}}}},"S14":{"type":"structure","members":{"name":{},"apiId":{},"authenticationType":{},"logConfig":{"shape":"Sr"},"userPoolConfig":{"shape":"Su"},"openIDConnectConfig":{"shape":"Sw"},"arn":{},"uris":{"type":"map","key":{},"value":{}},"tags":{"shape":"Sx"},"additionalAuthenticationProviders":{"shape":"S10"}}},"S18":{"type":"structure","members":{"functions":{"type":"list","member":{}}}},"S1b":{"type":"structure","members":{"typeName":{},"fieldName":{},"dataSourceName":{},"resolverArn":{},"requestMappingTemplate":{},"responseMappingTemplate":{},"kind":{},"pipelineConfig":{"shape":"S18"}}},"S1f":{"type":"structure","members":{"name":{},"description":{},"arn":{},"definition":{},"format":{}}},"S2q":{"type":"list","member":{"shape":"S1b"}}}}');

});

parcelRequire.register("K0WKt", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("bhpjB", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $021e87ec844238d5$var$Service = $dbC7k.Service;
var $021e87ec844238d5$var$apiLoader = $dbC7k.apiLoader;
$021e87ec844238d5$var$apiLoader.services["guardduty"] = {};
$dbC7k.GuardDuty = $021e87ec844238d5$var$Service.defineService("guardduty", [
    "2017-11-28"
]);


Object.defineProperty($021e87ec844238d5$var$apiLoader.services["guardduty"], "2017-11-28", {
    get: function get() {
        var model = (parcelRequire("1HJFj"));
        model.paginators = (parcelRequire("gAfRS")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.GuardDuty;

});
parcelRequire.register("1HJFj", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-11-28","endpointPrefix":"guardduty","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon GuardDuty","serviceId":"GuardDuty","signatureVersion":"v4","signingName":"guardduty","uid":"guardduty-2017-11-28"},"operations":{"AcceptInvitation":{"http":{"requestUri":"/detector/{detectorId}/master","responseCode":200},"input":{"type":"structure","required":["DetectorId","MasterId","InvitationId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"MasterId":{"locationName":"masterId"},"InvitationId":{"locationName":"invitationId"}}},"output":{"type":"structure","members":{}}},"ArchiveFindings":{"http":{"requestUri":"/detector/{detectorId}/findings/archive","responseCode":200},"input":{"type":"structure","required":["DetectorId","FindingIds"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"FindingIds":{"shape":"S6","locationName":"findingIds"}}},"output":{"type":"structure","members":{}}},"CreateDetector":{"http":{"requestUri":"/detector","responseCode":200},"input":{"type":"structure","required":["Enable"],"members":{"Enable":{"locationName":"enable","type":"boolean"},"ClientToken":{"idempotencyToken":true,"locationName":"clientToken"},"FindingPublishingFrequency":{"locationName":"findingPublishingFrequency"},"Tags":{"shape":"Sd","locationName":"tags"}}},"output":{"type":"structure","members":{"DetectorId":{"locationName":"detectorId"}}}},"CreateFilter":{"http":{"requestUri":"/detector/{detectorId}/filter","responseCode":200},"input":{"type":"structure","required":["DetectorId","Name","FindingCriteria"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"Name":{"locationName":"name"},"Description":{"locationName":"description"},"Action":{"locationName":"action"},"Rank":{"locationName":"rank","type":"integer"},"FindingCriteria":{"shape":"Sm","locationName":"findingCriteria"},"ClientToken":{"idempotencyToken":true,"locationName":"clientToken"},"Tags":{"shape":"Sd","locationName":"tags"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{"locationName":"name"}}}},"CreateIPSet":{"http":{"requestUri":"/detector/{detectorId}/ipset","responseCode":200},"input":{"type":"structure","required":["DetectorId","Name","Format","Location","Activate"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"Name":{"locationName":"name"},"Format":{"locationName":"format"},"Location":{"locationName":"location"},"Activate":{"locationName":"activate","type":"boolean"},"ClientToken":{"idempotencyToken":true,"locationName":"clientToken"},"Tags":{"shape":"Sd","locationName":"tags"}}},"output":{"type":"structure","required":["IpSetId"],"members":{"IpSetId":{"locationName":"ipSetId"}}}},"CreateMembers":{"http":{"requestUri":"/detector/{detectorId}/member","responseCode":200},"input":{"type":"structure","required":["DetectorId","AccountDetails"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"AccountDetails":{"locationName":"accountDetails","type":"list","member":{"type":"structure","required":["AccountId","Email"],"members":{"AccountId":{"locationName":"accountId"},"Email":{"locationName":"email"}}}}}},"output":{"type":"structure","required":["UnprocessedAccounts"],"members":{"UnprocessedAccounts":{"shape":"S17","locationName":"unprocessedAccounts"}}}},"CreateSampleFindings":{"http":{"requestUri":"/detector/{detectorId}/findings/create","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"FindingTypes":{"locationName":"findingTypes","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"CreateThreatIntelSet":{"http":{"requestUri":"/detector/{detectorId}/threatintelset","responseCode":200},"input":{"type":"structure","required":["DetectorId","Name","Format","Location","Activate"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"Name":{"locationName":"name"},"Format":{"locationName":"format"},"Location":{"locationName":"location"},"Activate":{"locationName":"activate","type":"boolean"},"ClientToken":{"idempotencyToken":true,"locationName":"clientToken"},"Tags":{"shape":"Sd","locationName":"tags"}}},"output":{"type":"structure","required":["ThreatIntelSetId"],"members":{"ThreatIntelSetId":{"locationName":"threatIntelSetId"}}}},"DeclineInvitations":{"http":{"requestUri":"/invitation/decline","responseCode":200},"input":{"type":"structure","required":["AccountIds"],"members":{"AccountIds":{"shape":"S1h","locationName":"accountIds"}}},"output":{"type":"structure","required":["UnprocessedAccounts"],"members":{"UnprocessedAccounts":{"shape":"S17","locationName":"unprocessedAccounts"}}}},"DeleteDetector":{"http":{"method":"DELETE","requestUri":"/detector/{detectorId}","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"}}},"output":{"type":"structure","members":{}}},"DeleteFilter":{"http":{"method":"DELETE","requestUri":"/detector/{detectorId}/filter/{filterName}","responseCode":200},"input":{"type":"structure","required":["DetectorId","FilterName"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"FilterName":{"location":"uri","locationName":"filterName"}}},"output":{"type":"structure","members":{}}},"DeleteIPSet":{"http":{"method":"DELETE","requestUri":"/detector/{detectorId}/ipset/{ipSetId}","responseCode":200},"input":{"type":"structure","required":["DetectorId","IpSetId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"IpSetId":{"location":"uri","locationName":"ipSetId"}}},"output":{"type":"structure","members":{}}},"DeleteInvitations":{"http":{"requestUri":"/invitation/delete","responseCode":200},"input":{"type":"structure","required":["AccountIds"],"members":{"AccountIds":{"shape":"S1h","locationName":"accountIds"}}},"output":{"type":"structure","required":["UnprocessedAccounts"],"members":{"UnprocessedAccounts":{"shape":"S17","locationName":"unprocessedAccounts"}}}},"DeleteMembers":{"http":{"requestUri":"/detector/{detectorId}/member/delete","responseCode":200},"input":{"type":"structure","required":["DetectorId","AccountIds"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"AccountIds":{"shape":"S1h","locationName":"accountIds"}}},"output":{"type":"structure","required":["UnprocessedAccounts"],"members":{"UnprocessedAccounts":{"shape":"S17","locationName":"unprocessedAccounts"}}}},"DeleteThreatIntelSet":{"http":{"method":"DELETE","requestUri":"/detector/{detectorId}/threatintelset/{threatIntelSetId}","responseCode":200},"input":{"type":"structure","required":["DetectorId","ThreatIntelSetId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"ThreatIntelSetId":{"location":"uri","locationName":"threatIntelSetId"}}},"output":{"type":"structure","members":{}}},"DisassociateFromMasterAccount":{"http":{"requestUri":"/detector/{detectorId}/master/disassociate","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"}}},"output":{"type":"structure","members":{}}},"DisassociateMembers":{"http":{"requestUri":"/detector/{detectorId}/member/disassociate","responseCode":200},"input":{"type":"structure","required":["DetectorId","AccountIds"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"AccountIds":{"shape":"S1h","locationName":"accountIds"}}},"output":{"type":"structure","required":["UnprocessedAccounts"],"members":{"UnprocessedAccounts":{"shape":"S17","locationName":"unprocessedAccounts"}}}},"GetDetector":{"http":{"method":"GET","requestUri":"/detector/{detectorId}","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"}}},"output":{"type":"structure","required":["ServiceRole","Status"],"members":{"CreatedAt":{"locationName":"createdAt"},"FindingPublishingFrequency":{"locationName":"findingPublishingFrequency"},"ServiceRole":{"locationName":"serviceRole"},"Status":{"locationName":"status"},"UpdatedAt":{"locationName":"updatedAt"},"Tags":{"shape":"Sd","locationName":"tags"}}}},"GetFilter":{"http":{"method":"GET","requestUri":"/detector/{detectorId}/filter/{filterName}","responseCode":200},"input":{"type":"structure","required":["DetectorId","FilterName"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"FilterName":{"location":"uri","locationName":"filterName"}}},"output":{"type":"structure","required":["Name","Action","FindingCriteria"],"members":{"Name":{"locationName":"name"},"Description":{"locationName":"description"},"Action":{"locationName":"action"},"Rank":{"locationName":"rank","type":"integer"},"FindingCriteria":{"shape":"Sm","locationName":"findingCriteria"},"Tags":{"shape":"Sd","locationName":"tags"}}}},"GetFindings":{"http":{"requestUri":"/detector/{detectorId}/findings/get","responseCode":200},"input":{"type":"structure","required":["DetectorId","FindingIds"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"FindingIds":{"shape":"S6","locationName":"findingIds"},"SortCriteria":{"shape":"S25","locationName":"sortCriteria"}}},"output":{"type":"structure","required":["Findings"],"members":{"Findings":{"locationName":"findings","type":"list","member":{"type":"structure","required":["AccountId","Arn","CreatedAt","Id","Region","Resource","SchemaVersion","Severity","Type","UpdatedAt"],"members":{"AccountId":{"locationName":"accountId"},"Arn":{"locationName":"arn"},"Confidence":{"locationName":"confidence","type":"double"},"CreatedAt":{"locationName":"createdAt"},"Description":{"locationName":"description"},"Id":{"locationName":"id"},"Partition":{"locationName":"partition"},"Region":{"locationName":"region"},"Resource":{"locationName":"resource","type":"structure","members":{"AccessKeyDetails":{"locationName":"accessKeyDetails","type":"structure","members":{"AccessKeyId":{"locationName":"accessKeyId"},"PrincipalId":{"locationName":"principalId"},"UserName":{"locationName":"userName"},"UserType":{"locationName":"userType"}}},"InstanceDetails":{"locationName":"instanceDetails","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"IamInstanceProfile":{"locationName":"iamInstanceProfile","type":"structure","members":{"Arn":{"locationName":"arn"},"Id":{"locationName":"id"}}},"ImageDescription":{"locationName":"imageDescription"},"ImageId":{"locationName":"imageId"},"InstanceId":{"locationName":"instanceId"},"InstanceState":{"locationName":"instanceState"},"InstanceType":{"locationName":"instanceType"},"LaunchTime":{"locationName":"launchTime"},"NetworkInterfaces":{"locationName":"networkInterfaces","type":"list","member":{"type":"structure","members":{"Ipv6Addresses":{"locationName":"ipv6Addresses","type":"list","member":{}},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"locationName":"privateIpAddresses","type":"list","member":{"type":"structure","members":{"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"PublicDnsName":{"locationName":"publicDnsName"},"PublicIp":{"locationName":"publicIp"},"SecurityGroups":{"locationName":"securityGroups","type":"list","member":{"type":"structure","members":{"GroupId":{"locationName":"groupId"},"GroupName":{"locationName":"groupName"}}}},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"}}}},"Platform":{"locationName":"platform"},"ProductCodes":{"locationName":"productCodes","type":"list","member":{"type":"structure","members":{"Code":{"locationName":"code"},"ProductType":{"locationName":"productType"}}}},"Tags":{"locationName":"tags","type":"list","member":{"type":"structure","members":{"Key":{"locationName":"key"},"Value":{"locationName":"value"}}}}}},"ResourceType":{"locationName":"resourceType"}}},"SchemaVersion":{"locationName":"schemaVersion"},"Service":{"locationName":"service","type":"structure","members":{"Action":{"locationName":"action","type":"structure","members":{"ActionType":{"locationName":"actionType"},"AwsApiCallAction":{"locationName":"awsApiCallAction","type":"structure","members":{"Api":{"locationName":"api"},"CallerType":{"locationName":"callerType"},"DomainDetails":{"locationName":"domainDetails","type":"structure","members":{"Domain":{"locationName":"domain"}}},"RemoteIpDetails":{"shape":"S2u","locationName":"remoteIpDetails"},"ServiceName":{"locationName":"serviceName"}}},"DnsRequestAction":{"locationName":"dnsRequestAction","type":"structure","members":{"Domain":{"locationName":"domain"}}},"NetworkConnectionAction":{"locationName":"networkConnectionAction","type":"structure","members":{"Blocked":{"locationName":"blocked","type":"boolean"},"ConnectionDirection":{"locationName":"connectionDirection"},"LocalPortDetails":{"shape":"S31","locationName":"localPortDetails"},"Protocol":{"locationName":"protocol"},"RemoteIpDetails":{"shape":"S2u","locationName":"remoteIpDetails"},"RemotePortDetails":{"locationName":"remotePortDetails","type":"structure","members":{"Port":{"locationName":"port","type":"integer"},"PortName":{"locationName":"portName"}}}}},"PortProbeAction":{"locationName":"portProbeAction","type":"structure","members":{"Blocked":{"locationName":"blocked","type":"boolean"},"PortProbeDetails":{"locationName":"portProbeDetails","type":"list","member":{"type":"structure","members":{"LocalPortDetails":{"shape":"S31","locationName":"localPortDetails"},"RemoteIpDetails":{"shape":"S2u","locationName":"remoteIpDetails"}}}}}}}},"Evidence":{"locationName":"evidence","type":"structure","members":{"ThreatIntelligenceDetails":{"locationName":"threatIntelligenceDetails","type":"list","member":{"type":"structure","members":{"ThreatListName":{"locationName":"threatListName"},"ThreatNames":{"locationName":"threatNames","type":"list","member":{}}}}}}},"Archived":{"locationName":"archived","type":"boolean"},"Count":{"locationName":"count","type":"integer"},"DetectorId":{"locationName":"detectorId"},"EventFirstSeen":{"locationName":"eventFirstSeen"},"EventLastSeen":{"locationName":"eventLastSeen"},"ResourceRole":{"locationName":"resourceRole"},"ServiceName":{"locationName":"serviceName"},"UserFeedback":{"locationName":"userFeedback"}}},"Severity":{"locationName":"severity","type":"double"},"Title":{"locationName":"title"},"Type":{"locationName":"type"},"UpdatedAt":{"locationName":"updatedAt"}}}}}}},"GetFindingsStatistics":{"http":{"requestUri":"/detector/{detectorId}/findings/statistics","responseCode":200},"input":{"type":"structure","required":["DetectorId","FindingStatisticTypes"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"FindingStatisticTypes":{"locationName":"findingStatisticTypes","type":"list","member":{}},"FindingCriteria":{"shape":"Sm","locationName":"findingCriteria"}}},"output":{"type":"structure","required":["FindingStatistics"],"members":{"FindingStatistics":{"locationName":"findingStatistics","type":"structure","members":{"CountBySeverity":{"locationName":"countBySeverity","type":"map","key":{},"value":{"type":"integer"}}}}}}},"GetIPSet":{"http":{"method":"GET","requestUri":"/detector/{detectorId}/ipset/{ipSetId}","responseCode":200},"input":{"type":"structure","required":["DetectorId","IpSetId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"IpSetId":{"location":"uri","locationName":"ipSetId"}}},"output":{"type":"structure","required":["Name","Format","Location","Status"],"members":{"Name":{"locationName":"name"},"Format":{"locationName":"format"},"Location":{"locationName":"location"},"Status":{"locationName":"status"},"Tags":{"shape":"Sd","locationName":"tags"}}}},"GetInvitationsCount":{"http":{"method":"GET","requestUri":"/invitation/count","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"InvitationsCount":{"locationName":"invitationsCount","type":"integer"}}}},"GetMasterAccount":{"http":{"method":"GET","requestUri":"/detector/{detectorId}/master","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"}}},"output":{"type":"structure","required":["Master"],"members":{"Master":{"locationName":"master","type":"structure","members":{"AccountId":{"locationName":"accountId"},"InvitationId":{"locationName":"invitationId"},"RelationshipStatus":{"locationName":"relationshipStatus"},"InvitedAt":{"locationName":"invitedAt"}}}}}},"GetMembers":{"http":{"requestUri":"/detector/{detectorId}/member/get","responseCode":200},"input":{"type":"structure","required":["DetectorId","AccountIds"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"AccountIds":{"shape":"S1h","locationName":"accountIds"}}},"output":{"type":"structure","required":["Members","UnprocessedAccounts"],"members":{"Members":{"shape":"S3q","locationName":"members"},"UnprocessedAccounts":{"shape":"S17","locationName":"unprocessedAccounts"}}}},"GetThreatIntelSet":{"http":{"method":"GET","requestUri":"/detector/{detectorId}/threatintelset/{threatIntelSetId}","responseCode":200},"input":{"type":"structure","required":["DetectorId","ThreatIntelSetId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"ThreatIntelSetId":{"location":"uri","locationName":"threatIntelSetId"}}},"output":{"type":"structure","required":["Name","Format","Location","Status"],"members":{"Name":{"locationName":"name"},"Format":{"locationName":"format"},"Location":{"locationName":"location"},"Status":{"locationName":"status"},"Tags":{"shape":"Sd","locationName":"tags"}}}},"InviteMembers":{"http":{"requestUri":"/detector/{detectorId}/member/invite","responseCode":200},"input":{"type":"structure","required":["DetectorId","AccountIds"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"AccountIds":{"shape":"S1h","locationName":"accountIds"},"DisableEmailNotification":{"locationName":"disableEmailNotification","type":"boolean"},"Message":{"locationName":"message"}}},"output":{"type":"structure","required":["UnprocessedAccounts"],"members":{"UnprocessedAccounts":{"shape":"S17","locationName":"unprocessedAccounts"}}}},"ListDetectors":{"http":{"method":"GET","requestUri":"/detector","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["DetectorIds"],"members":{"DetectorIds":{"locationName":"detectorIds","type":"list","member":{}},"NextToken":{"locationName":"nextToken"}}}},"ListFilters":{"http":{"method":"GET","requestUri":"/detector/{detectorId}/filter","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["FilterNames"],"members":{"FilterNames":{"locationName":"filterNames","type":"list","member":{}},"NextToken":{"locationName":"nextToken"}}}},"ListFindings":{"http":{"requestUri":"/detector/{detectorId}/findings","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"FindingCriteria":{"shape":"Sm","locationName":"findingCriteria"},"SortCriteria":{"shape":"S25","locationName":"sortCriteria"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","required":["FindingIds"],"members":{"FindingIds":{"shape":"S6","locationName":"findingIds"},"NextToken":{"locationName":"nextToken"}}}},"ListIPSets":{"http":{"method":"GET","requestUri":"/detector/{detectorId}/ipset","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["IpSetIds"],"members":{"IpSetIds":{"locationName":"ipSetIds","type":"list","member":{}},"NextToken":{"locationName":"nextToken"}}}},"ListInvitations":{"http":{"method":"GET","requestUri":"/invitation","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Invitations":{"locationName":"invitations","type":"list","member":{"type":"structure","members":{"AccountId":{"locationName":"accountId"},"InvitationId":{"locationName":"invitationId"},"RelationshipStatus":{"locationName":"relationshipStatus"},"InvitedAt":{"locationName":"invitedAt"}}}},"NextToken":{"locationName":"nextToken"}}}},"ListMembers":{"http":{"method":"GET","requestUri":"/detector/{detectorId}/member","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"OnlyAssociated":{"location":"querystring","locationName":"onlyAssociated"}}},"output":{"type":"structure","members":{"Members":{"shape":"S3q","locationName":"members"},"NextToken":{"locationName":"nextToken"}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sd","locationName":"tags"}}}},"ListThreatIntelSets":{"http":{"method":"GET","requestUri":"/detector/{detectorId}/threatintelset","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["ThreatIntelSetIds"],"members":{"ThreatIntelSetIds":{"locationName":"threatIntelSetIds","type":"list","member":{}},"NextToken":{"locationName":"nextToken"}}}},"StartMonitoringMembers":{"http":{"requestUri":"/detector/{detectorId}/member/start","responseCode":200},"input":{"type":"structure","required":["DetectorId","AccountIds"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"AccountIds":{"shape":"S1h","locationName":"accountIds"}}},"output":{"type":"structure","required":["UnprocessedAccounts"],"members":{"UnprocessedAccounts":{"shape":"S17","locationName":"unprocessedAccounts"}}}},"StopMonitoringMembers":{"http":{"requestUri":"/detector/{detectorId}/member/stop","responseCode":200},"input":{"type":"structure","required":["DetectorId","AccountIds"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"AccountIds":{"shape":"S1h","locationName":"accountIds"}}},"output":{"type":"structure","required":["UnprocessedAccounts"],"members":{"UnprocessedAccounts":{"shape":"S17","locationName":"unprocessedAccounts"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"Tags":{"shape":"Sd","locationName":"tags"}}},"output":{"type":"structure","members":{}}},"UnarchiveFindings":{"http":{"requestUri":"/detector/{detectorId}/findings/unarchive","responseCode":200},"input":{"type":"structure","required":["DetectorId","FindingIds"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"FindingIds":{"shape":"S6","locationName":"findingIds"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDetector":{"http":{"requestUri":"/detector/{detectorId}","responseCode":200},"input":{"type":"structure","required":["DetectorId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"Enable":{"locationName":"enable","type":"boolean"},"FindingPublishingFrequency":{"locationName":"findingPublishingFrequency"}}},"output":{"type":"structure","members":{}}},"UpdateFilter":{"http":{"requestUri":"/detector/{detectorId}/filter/{filterName}","responseCode":200},"input":{"type":"structure","required":["DetectorId","FilterName"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"FilterName":{"location":"uri","locationName":"filterName"},"Description":{"locationName":"description"},"Action":{"locationName":"action"},"Rank":{"locationName":"rank","type":"integer"},"FindingCriteria":{"shape":"Sm","locationName":"findingCriteria"}}},"output":{"type":"structure","required":["Name"],"members":{"Name":{"locationName":"name"}}}},"UpdateFindingsFeedback":{"http":{"requestUri":"/detector/{detectorId}/findings/feedback","responseCode":200},"input":{"type":"structure","required":["DetectorId","FindingIds","Feedback"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"FindingIds":{"shape":"S6","locationName":"findingIds"},"Feedback":{"locationName":"feedback"},"Comments":{"locationName":"comments"}}},"output":{"type":"structure","members":{}}},"UpdateIPSet":{"http":{"requestUri":"/detector/{detectorId}/ipset/{ipSetId}","responseCode":200},"input":{"type":"structure","required":["DetectorId","IpSetId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"IpSetId":{"location":"uri","locationName":"ipSetId"},"Name":{"locationName":"name"},"Location":{"locationName":"location"},"Activate":{"locationName":"activate","type":"boolean"}}},"output":{"type":"structure","members":{}}},"UpdateThreatIntelSet":{"http":{"requestUri":"/detector/{detectorId}/threatintelset/{threatIntelSetId}","responseCode":200},"input":{"type":"structure","required":["DetectorId","ThreatIntelSetId"],"members":{"DetectorId":{"location":"uri","locationName":"detectorId"},"ThreatIntelSetId":{"location":"uri","locationName":"threatIntelSetId"},"Name":{"locationName":"name"},"Location":{"locationName":"location"},"Activate":{"locationName":"activate","type":"boolean"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S6":{"type":"list","member":{}},"Sd":{"type":"map","key":{},"value":{}},"Sm":{"type":"structure","members":{"Criterion":{"locationName":"criterion","type":"map","key":{},"value":{"type":"structure","members":{"Eq":{"deprecated":true,"locationName":"eq","type":"list","member":{}},"Neq":{"deprecated":true,"locationName":"neq","type":"list","member":{}},"Gt":{"deprecated":true,"locationName":"gt","type":"integer"},"Gte":{"deprecated":true,"locationName":"gte","type":"integer"},"Lt":{"deprecated":true,"locationName":"lt","type":"integer"},"Lte":{"deprecated":true,"locationName":"lte","type":"integer"},"Equals":{"locationName":"equals","type":"list","member":{}},"NotEquals":{"locationName":"notEquals","type":"list","member":{}},"GreaterThan":{"locationName":"greaterThan","type":"long"},"GreaterThanOrEqual":{"locationName":"greaterThanOrEqual","type":"long"},"LessThan":{"locationName":"lessThan","type":"long"},"LessThanOrEqual":{"locationName":"lessThanOrEqual","type":"long"}}}}}},"S17":{"type":"list","member":{"type":"structure","required":["AccountId","Result"],"members":{"AccountId":{"locationName":"accountId"},"Result":{"locationName":"result"}}}},"S1h":{"type":"list","member":{}},"S25":{"type":"structure","members":{"AttributeName":{"locationName":"attributeName"},"OrderBy":{"locationName":"orderBy"}}},"S2u":{"type":"structure","members":{"City":{"locationName":"city","type":"structure","members":{"CityName":{"locationName":"cityName"}}},"Country":{"locationName":"country","type":"structure","members":{"CountryCode":{"locationName":"countryCode"},"CountryName":{"locationName":"countryName"}}},"GeoLocation":{"locationName":"geoLocation","type":"structure","members":{"Lat":{"locationName":"lat","type":"double"},"Lon":{"locationName":"lon","type":"double"}}},"IpAddressV4":{"locationName":"ipAddressV4"},"Organization":{"locationName":"organization","type":"structure","members":{"Asn":{"locationName":"asn"},"AsnOrg":{"locationName":"asnOrg"},"Isp":{"locationName":"isp"},"Org":{"locationName":"org"}}}}},"S31":{"type":"structure","members":{"Port":{"locationName":"port","type":"integer"},"PortName":{"locationName":"portName"}}},"S3q":{"type":"list","member":{"type":"structure","required":["AccountId","MasterId","Email","RelationshipStatus","UpdatedAt"],"members":{"AccountId":{"locationName":"accountId"},"DetectorId":{"locationName":"detectorId"},"MasterId":{"locationName":"masterId"},"Email":{"locationName":"email"},"RelationshipStatus":{"locationName":"relationshipStatus"},"InvitedAt":{"locationName":"invitedAt"},"UpdatedAt":{"locationName":"updatedAt"}}}}}}');

});

parcelRequire.register("gAfRS", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListDetectors":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"DetectorIds"},"ListFilters":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"FilterNames"},"ListFindings":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"FindingIds"},"ListIPSets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"IpSetIds"},"ListInvitations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Invitations"},"ListMembers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Members"},"ListThreatIntelSets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ThreatIntelSetIds"}}}');

});


parcelRequire.register("ktBtX", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $ee839740744acb15$var$Service = $dbC7k.Service;
var $ee839740744acb15$var$apiLoader = $dbC7k.apiLoader;
$ee839740744acb15$var$apiLoader.services["mq"] = {};
$dbC7k.MQ = $ee839740744acb15$var$Service.defineService("mq", [
    "2017-11-27"
]);


Object.defineProperty($ee839740744acb15$var$apiLoader.services["mq"], "2017-11-27", {
    get: function get() {
        var model = (parcelRequire("a1CTt"));
        model.paginators = (parcelRequire("3saCD")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.MQ;

});
parcelRequire.register("a1CTt", function(module, exports) {
module.exports = JSON.parse('{"metadata":{"apiVersion":"2017-11-27","endpointPrefix":"mq","signingName":"mq","serviceFullName":"AmazonMQ","serviceId":"mq","protocol":"rest-json","jsonVersion":"1.1","uid":"mq-2017-11-27","signatureVersion":"v4"},"operations":{"CreateBroker":{"http":{"requestUri":"/v1/brokers","responseCode":200},"input":{"type":"structure","members":{"AutoMinorVersionUpgrade":{"locationName":"autoMinorVersionUpgrade","type":"boolean"},"BrokerName":{"locationName":"brokerName"},"Configuration":{"shape":"S4","locationName":"configuration"},"CreatorRequestId":{"locationName":"creatorRequestId","idempotencyToken":true},"DeploymentMode":{"locationName":"deploymentMode"},"EncryptionOptions":{"shape":"S7","locationName":"encryptionOptions"},"EngineType":{"locationName":"engineType"},"EngineVersion":{"locationName":"engineVersion"},"HostInstanceType":{"locationName":"hostInstanceType"},"Logs":{"shape":"S9","locationName":"logs"},"MaintenanceWindowStartTime":{"shape":"Sa","locationName":"maintenanceWindowStartTime"},"PubliclyAccessible":{"locationName":"publiclyAccessible","type":"boolean"},"SecurityGroups":{"shape":"Sc","locationName":"securityGroups"},"SubnetIds":{"shape":"Sc","locationName":"subnetIds"},"Tags":{"shape":"Sd","locationName":"tags"},"Users":{"locationName":"users","type":"list","member":{"type":"structure","members":{"ConsoleAccess":{"locationName":"consoleAccess","type":"boolean"},"Groups":{"shape":"Sc","locationName":"groups"},"Password":{"locationName":"password"},"Username":{"locationName":"username"}}}}}},"output":{"type":"structure","members":{"BrokerArn":{"locationName":"brokerArn"},"BrokerId":{"locationName":"brokerId"}}}},"CreateConfiguration":{"http":{"requestUri":"/v1/configurations","responseCode":200},"input":{"type":"structure","members":{"EngineType":{"locationName":"engineType"},"EngineVersion":{"locationName":"engineVersion"},"Name":{"locationName":"name"},"Tags":{"shape":"Sd","locationName":"tags"}}},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Created":{"shape":"Sj","locationName":"created"},"Id":{"locationName":"id"},"LatestRevision":{"shape":"Sk","locationName":"latestRevision"},"Name":{"locationName":"name"}}}},"CreateTags":{"http":{"requestUri":"/v1/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"Tags":{"shape":"Sd","locationName":"tags"}},"required":["ResourceArn"]}},"CreateUser":{"http":{"requestUri":"/v1/brokers/{broker-id}/users/{username}","responseCode":200},"input":{"type":"structure","members":{"BrokerId":{"location":"uri","locationName":"broker-id"},"ConsoleAccess":{"locationName":"consoleAccess","type":"boolean"},"Groups":{"shape":"Sc","locationName":"groups"},"Password":{"locationName":"password"},"Username":{"location":"uri","locationName":"username"}},"required":["Username","BrokerId"]},"output":{"type":"structure","members":{}}},"DeleteBroker":{"http":{"method":"DELETE","requestUri":"/v1/brokers/{broker-id}","responseCode":200},"input":{"type":"structure","members":{"BrokerId":{"location":"uri","locationName":"broker-id"}},"required":["BrokerId"]},"output":{"type":"structure","members":{"BrokerId":{"locationName":"brokerId"}}}},"DeleteTags":{"http":{"method":"DELETE","requestUri":"/v1/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"TagKeys":{"shape":"Sc","location":"querystring","locationName":"tagKeys"}},"required":["TagKeys","ResourceArn"]}},"DeleteUser":{"http":{"method":"DELETE","requestUri":"/v1/brokers/{broker-id}/users/{username}","responseCode":200},"input":{"type":"structure","members":{"BrokerId":{"location":"uri","locationName":"broker-id"},"Username":{"location":"uri","locationName":"username"}},"required":["Username","BrokerId"]},"output":{"type":"structure","members":{}}},"DescribeBroker":{"http":{"method":"GET","requestUri":"/v1/brokers/{broker-id}","responseCode":200},"input":{"type":"structure","members":{"BrokerId":{"location":"uri","locationName":"broker-id"}},"required":["BrokerId"]},"output":{"type":"structure","members":{"AutoMinorVersionUpgrade":{"locationName":"autoMinorVersionUpgrade","type":"boolean"},"BrokerArn":{"locationName":"brokerArn"},"BrokerId":{"locationName":"brokerId"},"BrokerInstances":{"locationName":"brokerInstances","type":"list","member":{"type":"structure","members":{"ConsoleURL":{"locationName":"consoleURL"},"Endpoints":{"shape":"Sc","locationName":"endpoints"},"IpAddress":{"locationName":"ipAddress"}}}},"BrokerName":{"locationName":"brokerName"},"BrokerState":{"locationName":"brokerState"},"Configurations":{"locationName":"configurations","type":"structure","members":{"Current":{"shape":"S4","locationName":"current"},"History":{"locationName":"history","type":"list","member":{"shape":"S4"}},"Pending":{"shape":"S4","locationName":"pending"}}},"Created":{"shape":"Sj","locationName":"created"},"DeploymentMode":{"locationName":"deploymentMode"},"EncryptionOptions":{"shape":"S7","locationName":"encryptionOptions"},"EngineType":{"locationName":"engineType"},"EngineVersion":{"locationName":"engineVersion"},"HostInstanceType":{"locationName":"hostInstanceType"},"Logs":{"locationName":"logs","type":"structure","members":{"Audit":{"locationName":"audit","type":"boolean"},"AuditLogGroup":{"locationName":"auditLogGroup"},"General":{"locationName":"general","type":"boolean"},"GeneralLogGroup":{"locationName":"generalLogGroup"},"Pending":{"locationName":"pending","type":"structure","members":{"Audit":{"locationName":"audit","type":"boolean"},"General":{"locationName":"general","type":"boolean"}}}}},"MaintenanceWindowStartTime":{"shape":"Sa","locationName":"maintenanceWindowStartTime"},"PendingEngineVersion":{"locationName":"pendingEngineVersion"},"PubliclyAccessible":{"locationName":"publiclyAccessible","type":"boolean"},"SecurityGroups":{"shape":"Sc","locationName":"securityGroups"},"SubnetIds":{"shape":"Sc","locationName":"subnetIds"},"Tags":{"shape":"Sd","locationName":"tags"},"Users":{"shape":"S12","locationName":"users"}}}},"DescribeBrokerEngineTypes":{"http":{"method":"GET","requestUri":"/v1/broker-engine-types","responseCode":200},"input":{"type":"structure","members":{"EngineType":{"location":"querystring","locationName":"engineType"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"BrokerEngineTypes":{"locationName":"brokerEngineTypes","type":"list","member":{"type":"structure","members":{"EngineType":{"locationName":"engineType"},"EngineVersions":{"locationName":"engineVersions","type":"list","member":{"type":"structure","members":{"Name":{"locationName":"name"}}}}}}},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}}},"DescribeBrokerInstanceOptions":{"http":{"method":"GET","requestUri":"/v1/broker-instance-options","responseCode":200},"input":{"type":"structure","members":{"EngineType":{"location":"querystring","locationName":"engineType"},"HostInstanceType":{"location":"querystring","locationName":"hostInstanceType"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"BrokerInstanceOptions":{"locationName":"brokerInstanceOptions","type":"list","member":{"type":"structure","members":{"AvailabilityZones":{"locationName":"availabilityZones","type":"list","member":{"type":"structure","members":{"Name":{"locationName":"name"}}}},"EngineType":{"locationName":"engineType"},"HostInstanceType":{"locationName":"hostInstanceType"},"SupportedEngineVersions":{"shape":"Sc","locationName":"supportedEngineVersions"}}}},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}}},"DescribeConfiguration":{"http":{"method":"GET","requestUri":"/v1/configurations/{configuration-id}","responseCode":200},"input":{"type":"structure","members":{"ConfigurationId":{"location":"uri","locationName":"configuration-id"}},"required":["ConfigurationId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Created":{"shape":"Sj","locationName":"created"},"Description":{"locationName":"description"},"EngineType":{"locationName":"engineType"},"EngineVersion":{"locationName":"engineVersion"},"Id":{"locationName":"id"},"LatestRevision":{"shape":"Sk","locationName":"latestRevision"},"Name":{"locationName":"name"},"Tags":{"shape":"Sd","locationName":"tags"}}}},"DescribeConfigurationRevision":{"http":{"method":"GET","requestUri":"/v1/configurations/{configuration-id}/revisions/{configuration-revision}","responseCode":200},"input":{"type":"structure","members":{"ConfigurationId":{"location":"uri","locationName":"configuration-id"},"ConfigurationRevision":{"location":"uri","locationName":"configuration-revision"}},"required":["ConfigurationRevision","ConfigurationId"]},"output":{"type":"structure","members":{"ConfigurationId":{"locationName":"configurationId"},"Created":{"shape":"Sj","locationName":"created"},"Data":{"locationName":"data"},"Description":{"locationName":"description"}}}},"DescribeUser":{"http":{"method":"GET","requestUri":"/v1/brokers/{broker-id}/users/{username}","responseCode":200},"input":{"type":"structure","members":{"BrokerId":{"location":"uri","locationName":"broker-id"},"Username":{"location":"uri","locationName":"username"}},"required":["Username","BrokerId"]},"output":{"type":"structure","members":{"BrokerId":{"locationName":"brokerId"},"ConsoleAccess":{"locationName":"consoleAccess","type":"boolean"},"Groups":{"shape":"Sc","locationName":"groups"},"Pending":{"locationName":"pending","type":"structure","members":{"ConsoleAccess":{"locationName":"consoleAccess","type":"boolean"},"Groups":{"shape":"Sc","locationName":"groups"},"PendingChange":{"locationName":"pendingChange"}}},"Username":{"locationName":"username"}}}},"ListBrokers":{"http":{"method":"GET","requestUri":"/v1/brokers","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"BrokerSummaries":{"locationName":"brokerSummaries","type":"list","member":{"type":"structure","members":{"BrokerArn":{"locationName":"brokerArn"},"BrokerId":{"locationName":"brokerId"},"BrokerName":{"locationName":"brokerName"},"BrokerState":{"locationName":"brokerState"},"Created":{"shape":"Sj","locationName":"created"},"DeploymentMode":{"locationName":"deploymentMode"},"HostInstanceType":{"locationName":"hostInstanceType"}}}},"NextToken":{"locationName":"nextToken"}}}},"ListConfigurationRevisions":{"http":{"method":"GET","requestUri":"/v1/configurations/{configuration-id}/revisions","responseCode":200},"input":{"type":"structure","members":{"ConfigurationId":{"location":"uri","locationName":"configuration-id"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ConfigurationId"]},"output":{"type":"structure","members":{"ConfigurationId":{"locationName":"configurationId"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"Revisions":{"locationName":"revisions","type":"list","member":{"shape":"Sk"}}}}},"ListConfigurations":{"http":{"method":"GET","requestUri":"/v1/configurations","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Configurations":{"locationName":"configurations","type":"list","member":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Created":{"shape":"Sj","locationName":"created"},"Description":{"locationName":"description"},"EngineType":{"locationName":"engineType"},"EngineVersion":{"locationName":"engineVersion"},"Id":{"locationName":"id"},"LatestRevision":{"shape":"Sk","locationName":"latestRevision"},"Name":{"locationName":"name"},"Tags":{"shape":"Sd","locationName":"tags"}}}},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}}},"ListTags":{"http":{"method":"GET","requestUri":"/v1/tags/{resource-arn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{"Tags":{"shape":"Sd","locationName":"tags"}}}},"ListUsers":{"http":{"method":"GET","requestUri":"/v1/brokers/{broker-id}/users","responseCode":200},"input":{"type":"structure","members":{"BrokerId":{"location":"uri","locationName":"broker-id"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["BrokerId"]},"output":{"type":"structure","members":{"BrokerId":{"locationName":"brokerId"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"Users":{"shape":"S12","locationName":"users"}}}},"RebootBroker":{"http":{"requestUri":"/v1/brokers/{broker-id}/reboot","responseCode":200},"input":{"type":"structure","members":{"BrokerId":{"location":"uri","locationName":"broker-id"}},"required":["BrokerId"]},"output":{"type":"structure","members":{}}},"UpdateBroker":{"http":{"method":"PUT","requestUri":"/v1/brokers/{broker-id}","responseCode":200},"input":{"type":"structure","members":{"AutoMinorVersionUpgrade":{"locationName":"autoMinorVersionUpgrade","type":"boolean"},"BrokerId":{"location":"uri","locationName":"broker-id"},"Configuration":{"shape":"S4","locationName":"configuration"},"EngineVersion":{"locationName":"engineVersion"},"Logs":{"shape":"S9","locationName":"logs"}},"required":["BrokerId"]},"output":{"type":"structure","members":{"AutoMinorVersionUpgrade":{"locationName":"autoMinorVersionUpgrade","type":"boolean"},"BrokerId":{"locationName":"brokerId"},"Configuration":{"shape":"S4","locationName":"configuration"},"EngineVersion":{"locationName":"engineVersion"},"Logs":{"shape":"S9","locationName":"logs"}}}},"UpdateConfiguration":{"http":{"method":"PUT","requestUri":"/v1/configurations/{configuration-id}","responseCode":200},"input":{"type":"structure","members":{"ConfigurationId":{"location":"uri","locationName":"configuration-id"},"Data":{"locationName":"data"},"Description":{"locationName":"description"}},"required":["ConfigurationId"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Created":{"shape":"Sj","locationName":"created"},"Id":{"locationName":"id"},"LatestRevision":{"shape":"Sk","locationName":"latestRevision"},"Name":{"locationName":"name"},"Warnings":{"locationName":"warnings","type":"list","member":{"type":"structure","members":{"AttributeName":{"locationName":"attributeName"},"ElementName":{"locationName":"elementName"},"Reason":{"locationName":"reason"}}}}}}},"UpdateUser":{"http":{"method":"PUT","requestUri":"/v1/brokers/{broker-id}/users/{username}","responseCode":200},"input":{"type":"structure","members":{"BrokerId":{"location":"uri","locationName":"broker-id"},"ConsoleAccess":{"locationName":"consoleAccess","type":"boolean"},"Groups":{"shape":"Sc","locationName":"groups"},"Password":{"locationName":"password"},"Username":{"location":"uri","locationName":"username"}},"required":["Username","BrokerId"]},"output":{"type":"structure","members":{}}}},"shapes":{"S4":{"type":"structure","members":{"Id":{"locationName":"id"},"Revision":{"locationName":"revision","type":"integer"}}},"S7":{"type":"structure","members":{"KmsKeyId":{"locationName":"kmsKeyId"},"UseAwsOwnedKey":{"locationName":"useAwsOwnedKey","type":"boolean"}},"required":["UseAwsOwnedKey"]},"S9":{"type":"structure","members":{"Audit":{"locationName":"audit","type":"boolean"},"General":{"locationName":"general","type":"boolean"}}},"Sa":{"type":"structure","members":{"DayOfWeek":{"locationName":"dayOfWeek"},"TimeOfDay":{"locationName":"timeOfDay"},"TimeZone":{"locationName":"timeZone"}}},"Sc":{"type":"list","member":{}},"Sd":{"type":"map","key":{},"value":{}},"Sj":{"type":"timestamp","timestampFormat":"iso8601"},"Sk":{"type":"structure","members":{"Created":{"shape":"Sj","locationName":"created"},"Description":{"locationName":"description"},"Revision":{"locationName":"revision","type":"integer"}}},"S12":{"type":"list","member":{"type":"structure","members":{"PendingChange":{"locationName":"pendingChange"},"Username":{"locationName":"username"}}}}},"authorizers":{"authorization_strategy":{"name":"authorization_strategy","type":"provided","placement":{"location":"header","name":"Authorization"}}}}');

});

parcelRequire.register("3saCD", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("gCZWu", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $c1b03e70d9907a3f$var$Service = $dbC7k.Service;
var $c1b03e70d9907a3f$var$apiLoader = $dbC7k.apiLoader;
$c1b03e70d9907a3f$var$apiLoader.services["comprehend"] = {};
$dbC7k.Comprehend = $c1b03e70d9907a3f$var$Service.defineService("comprehend", [
    "2017-11-27"
]);


Object.defineProperty($c1b03e70d9907a3f$var$apiLoader.services["comprehend"], "2017-11-27", {
    get: function get() {
        var model = (parcelRequire("1LnxL"));
        model.paginators = (parcelRequire("emFbD")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Comprehend;

});
parcelRequire.register("1LnxL", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-11-27","endpointPrefix":"comprehend","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Comprehend","serviceId":"Comprehend","signatureVersion":"v4","signingName":"comprehend","targetPrefix":"Comprehend_20171127","uid":"comprehend-2017-11-27"},"operations":{"BatchDetectDominantLanguage":{"input":{"type":"structure","required":["TextList"],"members":{"TextList":{"shape":"S2"}}},"output":{"type":"structure","required":["ResultList","ErrorList"],"members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"Languages":{"shape":"S8"}}}},"ErrorList":{"shape":"Sb"}}}},"BatchDetectEntities":{"input":{"type":"structure","required":["TextList","LanguageCode"],"members":{"TextList":{"shape":"S2"},"LanguageCode":{}}},"output":{"type":"structure","required":["ResultList","ErrorList"],"members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"Entities":{"shape":"Si"}}}},"ErrorList":{"shape":"Sb"}}}},"BatchDetectKeyPhrases":{"input":{"type":"structure","required":["TextList","LanguageCode"],"members":{"TextList":{"shape":"S2"},"LanguageCode":{}}},"output":{"type":"structure","required":["ResultList","ErrorList"],"members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"KeyPhrases":{"shape":"Sp"}}}},"ErrorList":{"shape":"Sb"}}}},"BatchDetectSentiment":{"input":{"type":"structure","required":["TextList","LanguageCode"],"members":{"TextList":{"shape":"S2"},"LanguageCode":{}}},"output":{"type":"structure","required":["ResultList","ErrorList"],"members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"Sentiment":{},"SentimentScore":{"shape":"Sw"}}}},"ErrorList":{"shape":"Sb"}}}},"BatchDetectSyntax":{"input":{"type":"structure","required":["TextList","LanguageCode"],"members":{"TextList":{"shape":"S2"},"LanguageCode":{}}},"output":{"type":"structure","required":["ResultList","ErrorList"],"members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"SyntaxTokens":{"shape":"S12"}}}},"ErrorList":{"shape":"Sb"}}}},"CreateDocumentClassifier":{"input":{"type":"structure","required":["DocumentClassifierName","DataAccessRoleArn","InputDataConfig","LanguageCode"],"members":{"DocumentClassifierName":{},"DataAccessRoleArn":{},"Tags":{"shape":"S19"},"InputDataConfig":{"shape":"S1d"},"OutputDataConfig":{"shape":"S1f"},"ClientRequestToken":{"idempotencyToken":true},"LanguageCode":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1i"}}},"output":{"type":"structure","members":{"DocumentClassifierArn":{}}}},"CreateEntityRecognizer":{"input":{"type":"structure","required":["RecognizerName","DataAccessRoleArn","InputDataConfig","LanguageCode"],"members":{"RecognizerName":{},"DataAccessRoleArn":{},"Tags":{"shape":"S19"},"InputDataConfig":{"shape":"S1q"},"ClientRequestToken":{"idempotencyToken":true},"LanguageCode":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1i"}}},"output":{"type":"structure","members":{"EntityRecognizerArn":{}}}},"DeleteDocumentClassifier":{"input":{"type":"structure","required":["DocumentClassifierArn"],"members":{"DocumentClassifierArn":{}}},"output":{"type":"structure","members":{}}},"DeleteEntityRecognizer":{"input":{"type":"structure","required":["EntityRecognizerArn"],"members":{"EntityRecognizerArn":{}}},"output":{"type":"structure","members":{}}},"DescribeDocumentClassificationJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"DocumentClassificationJobProperties":{"shape":"S26"}}}},"DescribeDocumentClassifier":{"input":{"type":"structure","required":["DocumentClassifierArn"],"members":{"DocumentClassifierArn":{}}},"output":{"type":"structure","members":{"DocumentClassifierProperties":{"shape":"S2g"}}}},"DescribeDominantLanguageDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"DominantLanguageDetectionJobProperties":{"shape":"S2n"}}}},"DescribeEntitiesDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"EntitiesDetectionJobProperties":{"shape":"S2q"}}}},"DescribeEntityRecognizer":{"input":{"type":"structure","required":["EntityRecognizerArn"],"members":{"EntityRecognizerArn":{}}},"output":{"type":"structure","members":{"EntityRecognizerProperties":{"shape":"S2t"}}}},"DescribeKeyPhrasesDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"KeyPhrasesDetectionJobProperties":{"shape":"S31"}}}},"DescribeSentimentDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"SentimentDetectionJobProperties":{"shape":"S34"}}}},"DescribeTopicsDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"TopicsDetectionJobProperties":{"shape":"S37"}}}},"DetectDominantLanguage":{"input":{"type":"structure","required":["Text"],"members":{"Text":{}}},"output":{"type":"structure","members":{"Languages":{"shape":"S8"}}}},"DetectEntities":{"input":{"type":"structure","required":["Text","LanguageCode"],"members":{"Text":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"Entities":{"shape":"Si"}}}},"DetectKeyPhrases":{"input":{"type":"structure","required":["Text","LanguageCode"],"members":{"Text":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"KeyPhrases":{"shape":"Sp"}}}},"DetectSentiment":{"input":{"type":"structure","required":["Text","LanguageCode"],"members":{"Text":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"Sentiment":{},"SentimentScore":{"shape":"Sw"}}}},"DetectSyntax":{"input":{"type":"structure","required":["Text","LanguageCode"],"members":{"Text":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"SyntaxTokens":{"shape":"S12"}}}},"ListDocumentClassificationJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DocumentClassificationJobPropertiesList":{"type":"list","member":{"shape":"S26"}},"NextToken":{}}}},"ListDocumentClassifiers":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"Status":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DocumentClassifierPropertiesList":{"type":"list","member":{"shape":"S2g"}},"NextToken":{}}}},"ListDominantLanguageDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DominantLanguageDetectionJobPropertiesList":{"type":"list","member":{"shape":"S2n"}},"NextToken":{}}}},"ListEntitiesDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EntitiesDetectionJobPropertiesList":{"type":"list","member":{"shape":"S2q"}},"NextToken":{}}}},"ListEntityRecognizers":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"Status":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EntityRecognizerPropertiesList":{"type":"list","member":{"shape":"S2t"}},"NextToken":{}}}},"ListKeyPhrasesDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"KeyPhrasesDetectionJobPropertiesList":{"type":"list","member":{"shape":"S31"}},"NextToken":{}}}},"ListSentimentDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SentimentDetectionJobPropertiesList":{"type":"list","member":{"shape":"S34"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"ResourceArn":{},"Tags":{"shape":"S19"}}}},"ListTopicsDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TopicsDetectionJobPropertiesList":{"type":"list","member":{"shape":"S37"}},"NextToken":{}}}},"StartDocumentClassificationJob":{"input":{"type":"structure","required":["DocumentClassifierArn","InputDataConfig","OutputDataConfig","DataAccessRoleArn"],"members":{"JobName":{},"DocumentClassifierArn":{},"InputDataConfig":{"shape":"S2b"},"OutputDataConfig":{"shape":"S2d"},"DataAccessRoleArn":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1i"}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StartDominantLanguageDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn"],"members":{"InputDataConfig":{"shape":"S2b"},"OutputDataConfig":{"shape":"S2d"},"DataAccessRoleArn":{},"JobName":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1i"}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StartEntitiesDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S2b"},"OutputDataConfig":{"shape":"S2d"},"DataAccessRoleArn":{},"JobName":{},"EntityRecognizerArn":{},"LanguageCode":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1i"}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StartKeyPhrasesDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S2b"},"OutputDataConfig":{"shape":"S2d"},"DataAccessRoleArn":{},"JobName":{},"LanguageCode":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1i"}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StartSentimentDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S2b"},"OutputDataConfig":{"shape":"S2d"},"DataAccessRoleArn":{},"JobName":{},"LanguageCode":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1i"}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StartTopicsDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn"],"members":{"InputDataConfig":{"shape":"S2b"},"OutputDataConfig":{"shape":"S2d"},"DataAccessRoleArn":{},"JobName":{},"NumberOfTopics":{"type":"integer"},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1i"}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopDominantLanguageDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopEntitiesDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopKeyPhrasesDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopSentimentDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopTrainingDocumentClassifier":{"input":{"type":"structure","required":["DocumentClassifierArn"],"members":{"DocumentClassifierArn":{}}},"output":{"type":"structure","members":{}}},"StopTrainingEntityRecognizer":{"input":{"type":"structure","required":["EntityRecognizerArn"],"members":{"EntityRecognizerArn":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S19"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S2":{"type":"list","member":{}},"S8":{"type":"list","member":{"type":"structure","members":{"LanguageCode":{},"Score":{"type":"float"}}}},"Sb":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"ErrorCode":{},"ErrorMessage":{}}}},"Si":{"type":"list","member":{"type":"structure","members":{"Score":{"type":"float"},"Type":{},"Text":{},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"}}}},"Sp":{"type":"list","member":{"type":"structure","members":{"Score":{"type":"float"},"Text":{},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"}}}},"Sw":{"type":"structure","members":{"Positive":{"type":"float"},"Negative":{"type":"float"},"Neutral":{"type":"float"},"Mixed":{"type":"float"}}},"S12":{"type":"list","member":{"type":"structure","members":{"TokenId":{"type":"integer"},"Text":{},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"PartOfSpeech":{"type":"structure","members":{"Tag":{},"Score":{"type":"float"}}}}}},"S19":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"S1d":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{}}},"S1f":{"type":"structure","members":{"S3Uri":{},"KmsKeyId":{}}},"S1i":{"type":"structure","required":["SecurityGroupIds","Subnets"],"members":{"SecurityGroupIds":{"type":"list","member":{}},"Subnets":{"type":"list","member":{}}}},"S1q":{"type":"structure","required":["EntityTypes","Documents"],"members":{"EntityTypes":{"type":"list","member":{"type":"structure","required":["Type"],"members":{"Type":{}}}},"Documents":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{}}},"Annotations":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{}}},"EntityList":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{}}}}},"S26":{"type":"structure","members":{"JobId":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"DocumentClassifierArn":{},"InputDataConfig":{"shape":"S2b"},"OutputDataConfig":{"shape":"S2d"},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1i"}}},"S2b":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"InputFormat":{}}},"S2d":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"KmsKeyId":{}}},"S2g":{"type":"structure","members":{"DocumentClassifierArn":{},"LanguageCode":{},"Status":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"TrainingStartTime":{"type":"timestamp"},"TrainingEndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S1d"},"OutputDataConfig":{"shape":"S1f"},"ClassifierMetadata":{"type":"structure","members":{"NumberOfLabels":{"type":"integer"},"NumberOfTrainedDocuments":{"type":"integer"},"NumberOfTestDocuments":{"type":"integer"},"EvaluationMetrics":{"type":"structure","members":{"Accuracy":{"type":"double"},"Precision":{"type":"double"},"Recall":{"type":"double"},"F1Score":{"type":"double"}}}}},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1i"}}},"S2n":{"type":"structure","members":{"JobId":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S2b"},"OutputDataConfig":{"shape":"S2d"},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1i"}}},"S2q":{"type":"structure","members":{"JobId":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"EntityRecognizerArn":{},"InputDataConfig":{"shape":"S2b"},"OutputDataConfig":{"shape":"S2d"},"LanguageCode":{},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1i"}}},"S2t":{"type":"structure","members":{"EntityRecognizerArn":{},"LanguageCode":{},"Status":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"TrainingStartTime":{"type":"timestamp"},"TrainingEndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S1q"},"RecognizerMetadata":{"type":"structure","members":{"NumberOfTrainedDocuments":{"type":"integer"},"NumberOfTestDocuments":{"type":"integer"},"EvaluationMetrics":{"type":"structure","members":{"Precision":{"type":"double"},"Recall":{"type":"double"},"F1Score":{"type":"double"}}},"EntityTypes":{"type":"list","member":{"type":"structure","members":{"Type":{},"EvaluationMetrics":{"type":"structure","members":{"Precision":{"type":"double"},"Recall":{"type":"double"},"F1Score":{"type":"double"}}},"NumberOfTrainMentions":{"type":"integer"}}}}}},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1i"}}},"S31":{"type":"structure","members":{"JobId":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S2b"},"OutputDataConfig":{"shape":"S2d"},"LanguageCode":{},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1i"}}},"S34":{"type":"structure","members":{"JobId":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S2b"},"OutputDataConfig":{"shape":"S2d"},"LanguageCode":{},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1i"}}},"S37":{"type":"structure","members":{"JobId":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S2b"},"OutputDataConfig":{"shape":"S2d"},"NumberOfTopics":{"type":"integer"},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S1i"}}}}}');

});

parcelRequire.register("emFbD", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListDocumentClassificationJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDocumentClassifiers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDominantLanguageDetectionJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListEntitiesDetectionJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListEntityRecognizers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListKeyPhrasesDetectionJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSentimentDetectionJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTopicsDetectionJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("1ctS0", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $0dfe14fb155a0c56$var$Service = $dbC7k.Service;
var $0dfe14fb155a0c56$var$apiLoader = $dbC7k.apiLoader;
$0dfe14fb155a0c56$var$apiLoader.services["iotjobsdataplane"] = {};
$dbC7k.IoTJobsDataPlane = $0dfe14fb155a0c56$var$Service.defineService("iotjobsdataplane", [
    "2017-09-29"
]);


Object.defineProperty($0dfe14fb155a0c56$var$apiLoader.services["iotjobsdataplane"], "2017-09-29", {
    get: function get() {
        var model = (parcelRequire("UcJjt"));
        model.paginators = (parcelRequire("7ZqIg")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.IoTJobsDataPlane;

});
parcelRequire.register("UcJjt", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-09-29","endpointPrefix":"data.jobs.iot","protocol":"rest-json","serviceFullName":"AWS IoT Jobs Data Plane","serviceId":"IoT Jobs Data Plane","signatureVersion":"v4","signingName":"iot-jobs-data","uid":"iot-jobs-data-2017-09-29"},"operations":{"DescribeJobExecution":{"http":{"method":"GET","requestUri":"/things/{thingName}/jobs/{jobId}"},"input":{"type":"structure","required":["jobId","thingName"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"thingName":{"location":"uri","locationName":"thingName"},"includeJobDocument":{"location":"querystring","locationName":"includeJobDocument","type":"boolean"},"executionNumber":{"location":"querystring","locationName":"executionNumber","type":"long"}}},"output":{"type":"structure","members":{"execution":{"shape":"S7"}}}},"GetPendingJobExecutions":{"http":{"method":"GET","requestUri":"/things/{thingName}/jobs"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"}}},"output":{"type":"structure","members":{"inProgressJobs":{"shape":"Sl"},"queuedJobs":{"shape":"Sl"}}}},"StartNextPendingJobExecution":{"http":{"method":"PUT","requestUri":"/things/{thingName}/jobs/$next"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"statusDetails":{"shape":"Sa"},"stepTimeoutInMinutes":{"type":"long"}}},"output":{"type":"structure","members":{"execution":{"shape":"S7"}}}},"UpdateJobExecution":{"http":{"requestUri":"/things/{thingName}/jobs/{jobId}"},"input":{"type":"structure","required":["jobId","thingName","status"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"thingName":{"location":"uri","locationName":"thingName"},"status":{},"statusDetails":{"shape":"Sa"},"stepTimeoutInMinutes":{"type":"long"},"expectedVersion":{"type":"long"},"includeJobExecutionState":{"type":"boolean"},"includeJobDocument":{"type":"boolean"},"executionNumber":{"type":"long"}}},"output":{"type":"structure","members":{"executionState":{"type":"structure","members":{"status":{},"statusDetails":{"shape":"Sa"},"versionNumber":{"type":"long"}}},"jobDocument":{}}}}},"shapes":{"S7":{"type":"structure","members":{"jobId":{},"thingName":{},"status":{},"statusDetails":{"shape":"Sa"},"queuedAt":{"type":"long"},"startedAt":{"type":"long"},"lastUpdatedAt":{"type":"long"},"approximateSecondsBeforeTimedOut":{"type":"long"},"versionNumber":{"type":"long"},"executionNumber":{"type":"long"},"jobDocument":{}}},"Sa":{"type":"map","key":{},"value":{}},"Sl":{"type":"list","member":{"type":"structure","members":{"jobId":{},"queuedAt":{"type":"long"},"startedAt":{"type":"long"},"lastUpdatedAt":{"type":"long"},"versionNumber":{"type":"long"},"executionNumber":{"type":"long"}}}}}}');

});

parcelRequire.register("7ZqIg", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("9qanA", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $6dbe97e49eb08a14$var$Service = $dbC7k.Service;
var $6dbe97e49eb08a14$var$apiLoader = $dbC7k.apiLoader;
$6dbe97e49eb08a14$var$apiLoader.services["kinesisvideoarchivedmedia"] = {};
$dbC7k.KinesisVideoArchivedMedia = $6dbe97e49eb08a14$var$Service.defineService("kinesisvideoarchivedmedia", [
    "2017-09-30"
]);


Object.defineProperty($6dbe97e49eb08a14$var$apiLoader.services["kinesisvideoarchivedmedia"], "2017-09-30", {
    get: function get() {
        var model = (parcelRequire("bpRuV"));
        model.paginators = (parcelRequire("1mIRO")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.KinesisVideoArchivedMedia;

});
parcelRequire.register("bpRuV", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-09-30","endpointPrefix":"kinesisvideo","protocol":"rest-json","serviceAbbreviation":"Kinesis Video Archived Media","serviceFullName":"Amazon Kinesis Video Streams Archived Media","serviceId":"Kinesis Video Archived Media","signatureVersion":"v4","uid":"kinesis-video-archived-media-2017-09-30"},"operations":{"GetDASHStreamingSessionURL":{"http":{"requestUri":"/getDASHStreamingSessionURL"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{},"PlaybackMode":{},"DisplayFragmentTimestamp":{},"DisplayFragmentNumber":{},"DASHFragmentSelector":{"type":"structure","members":{"FragmentSelectorType":{},"TimestampRange":{"type":"structure","members":{"StartTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}}},"Expires":{"type":"integer"},"MaxManifestFragmentResults":{"type":"long"}}},"output":{"type":"structure","members":{"DASHStreamingSessionURL":{}}}},"GetHLSStreamingSessionURL":{"http":{"requestUri":"/getHLSStreamingSessionURL"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{},"PlaybackMode":{},"HLSFragmentSelector":{"type":"structure","members":{"FragmentSelectorType":{},"TimestampRange":{"type":"structure","members":{"StartTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}}},"ContainerFormat":{},"DiscontinuityMode":{},"DisplayFragmentTimestamp":{},"Expires":{"type":"integer"},"MaxMediaPlaylistFragmentResults":{"type":"long"}}},"output":{"type":"structure","members":{"HLSStreamingSessionURL":{}}}},"GetMediaForFragmentList":{"http":{"requestUri":"/getMediaForFragmentList"},"input":{"type":"structure","required":["StreamName","Fragments"],"members":{"StreamName":{},"Fragments":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ContentType":{"location":"header","locationName":"Content-Type"},"Payload":{"type":"blob","streaming":true}},"payload":"Payload"}},"ListFragments":{"http":{"requestUri":"/listFragments"},"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{},"MaxResults":{"type":"long"},"NextToken":{},"FragmentSelector":{"type":"structure","required":["FragmentSelectorType","TimestampRange"],"members":{"FragmentSelectorType":{},"TimestampRange":{"type":"structure","required":["StartTimestamp","EndTimestamp"],"members":{"StartTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}}}}},"output":{"type":"structure","members":{"Fragments":{"type":"list","member":{"type":"structure","members":{"FragmentNumber":{},"FragmentSizeInBytes":{"type":"long"},"ProducerTimestamp":{"type":"timestamp"},"ServerTimestamp":{"type":"timestamp"},"FragmentLengthInMilliseconds":{"type":"long"}}}},"NextToken":{}}}}},"shapes":{}}');

});

parcelRequire.register("1mIRO", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListFragments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Fragments"}}}');

});


parcelRequire.register("9bbp1", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $6aedfc77d58ce594$var$Service = $dbC7k.Service;
var $6aedfc77d58ce594$var$apiLoader = $dbC7k.apiLoader;
$6aedfc77d58ce594$var$apiLoader.services["kinesisvideomedia"] = {};
$dbC7k.KinesisVideoMedia = $6aedfc77d58ce594$var$Service.defineService("kinesisvideomedia", [
    "2017-09-30"
]);


Object.defineProperty($6aedfc77d58ce594$var$apiLoader.services["kinesisvideomedia"], "2017-09-30", {
    get: function get() {
        var model = (parcelRequire("iWwZx"));
        model.paginators = (parcelRequire("guSOt")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.KinesisVideoMedia;

});
parcelRequire.register("iWwZx", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-09-30","endpointPrefix":"kinesisvideo","protocol":"rest-json","serviceAbbreviation":"Kinesis Video Media","serviceFullName":"Amazon Kinesis Video Streams Media","serviceId":"Kinesis Video Media","signatureVersion":"v4","uid":"kinesis-video-media-2017-09-30"},"operations":{"GetMedia":{"http":{"requestUri":"/getMedia"},"input":{"type":"structure","required":["StartSelector"],"members":{"StreamName":{},"StreamARN":{},"StartSelector":{"type":"structure","required":["StartSelectorType"],"members":{"StartSelectorType":{},"AfterFragmentNumber":{},"StartTimestamp":{"type":"timestamp"},"ContinuationToken":{}}}}},"output":{"type":"structure","members":{"ContentType":{"location":"header","locationName":"Content-Type"},"Payload":{"type":"blob","streaming":true}},"payload":"Payload"}}},"shapes":{}}');

});

parcelRequire.register("guSOt", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("9fffT", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $6bb159262d5175d8$var$Service = $dbC7k.Service;
var $6bb159262d5175d8$var$apiLoader = $dbC7k.apiLoader;
$6bb159262d5175d8$var$apiLoader.services["kinesisvideo"] = {};
$dbC7k.KinesisVideo = $6bb159262d5175d8$var$Service.defineService("kinesisvideo", [
    "2017-09-30"
]);


Object.defineProperty($6bb159262d5175d8$var$apiLoader.services["kinesisvideo"], "2017-09-30", {
    get: function get() {
        var model = (parcelRequire("fbNco"));
        model.paginators = (parcelRequire("en5hq")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.KinesisVideo;

});
parcelRequire.register("fbNco", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-09-30","endpointPrefix":"kinesisvideo","protocol":"rest-json","serviceAbbreviation":"Kinesis Video","serviceFullName":"Amazon Kinesis Video Streams","serviceId":"Kinesis Video","signatureVersion":"v4","uid":"kinesisvideo-2017-09-30"},"operations":{"CreateStream":{"http":{"requestUri":"/createStream"},"input":{"type":"structure","required":["StreamName"],"members":{"DeviceName":{},"StreamName":{},"MediaType":{},"KmsKeyId":{},"DataRetentionInHours":{"type":"integer"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"StreamARN":{}}}},"DeleteStream":{"http":{"requestUri":"/deleteStream"},"input":{"type":"structure","required":["StreamARN"],"members":{"StreamARN":{},"CurrentVersion":{}}},"output":{"type":"structure","members":{}}},"DescribeStream":{"http":{"requestUri":"/describeStream"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{}}},"output":{"type":"structure","members":{"StreamInfo":{"shape":"Sh"}}}},"GetDataEndpoint":{"http":{"requestUri":"/getDataEndpoint"},"input":{"type":"structure","required":["APIName"],"members":{"StreamName":{},"StreamARN":{},"APIName":{}}},"output":{"type":"structure","members":{"DataEndpoint":{}}}},"ListStreams":{"http":{"requestUri":"/listStreams"},"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"StreamNameCondition":{"type":"structure","members":{"ComparisonOperator":{},"ComparisonValue":{}}}}},"output":{"type":"structure","members":{"StreamInfoList":{"type":"list","member":{"shape":"Sh"}},"NextToken":{}}}},"ListTagsForStream":{"http":{"requestUri":"/listTagsForStream"},"input":{"type":"structure","members":{"NextToken":{},"StreamARN":{},"StreamName":{}}},"output":{"type":"structure","members":{"NextToken":{},"Tags":{"shape":"S7"}}}},"TagStream":{"http":{"requestUri":"/tagStream"},"input":{"type":"structure","required":["Tags"],"members":{"StreamARN":{},"StreamName":{},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{}}},"UntagStream":{"http":{"requestUri":"/untagStream"},"input":{"type":"structure","required":["TagKeyList"],"members":{"StreamARN":{},"StreamName":{},"TagKeyList":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDataRetention":{"http":{"requestUri":"/updateDataRetention"},"input":{"type":"structure","required":["CurrentVersion","Operation","DataRetentionChangeInHours"],"members":{"StreamName":{},"StreamARN":{},"CurrentVersion":{},"Operation":{},"DataRetentionChangeInHours":{"type":"integer"}}},"output":{"type":"structure","members":{}}},"UpdateStream":{"http":{"requestUri":"/updateStream"},"input":{"type":"structure","required":["CurrentVersion"],"members":{"StreamName":{},"StreamARN":{},"CurrentVersion":{},"DeviceName":{},"MediaType":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S7":{"type":"map","key":{},"value":{}},"Sh":{"type":"structure","members":{"DeviceName":{},"StreamName":{},"StreamARN":{},"MediaType":{},"KmsKeyId":{},"Version":{},"Status":{},"CreationTime":{"type":"timestamp"},"DataRetentionInHours":{"type":"integer"}}}}}');

});

parcelRequire.register("en5hq", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListStreams":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"StreamInfoList"}}}');

});


parcelRequire.register("5EOKc", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $41e80cec902a3818$var$Service = $dbC7k.Service;
var $41e80cec902a3818$var$apiLoader = $dbC7k.apiLoader;
$41e80cec902a3818$var$apiLoader.services["sagemakerruntime"] = {};
$dbC7k.SageMakerRuntime = $41e80cec902a3818$var$Service.defineService("sagemakerruntime", [
    "2017-05-13"
]);


Object.defineProperty($41e80cec902a3818$var$apiLoader.services["sagemakerruntime"], "2017-05-13", {
    get: function get() {
        var model = (parcelRequire("d0rAZ"));
        model.paginators = (parcelRequire("6UEwY")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.SageMakerRuntime;

});
parcelRequire.register("d0rAZ", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-05-13","endpointPrefix":"runtime.sagemaker","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon SageMaker Runtime","serviceId":"SageMaker Runtime","signatureVersion":"v4","signingName":"sagemaker","uid":"runtime.sagemaker-2017-05-13"},"operations":{"InvokeEndpoint":{"http":{"requestUri":"/endpoints/{EndpointName}/invocations"},"input":{"type":"structure","required":["EndpointName","Body"],"members":{"EndpointName":{"location":"uri","locationName":"EndpointName"},"Body":{"shape":"S3"},"ContentType":{"location":"header","locationName":"Content-Type"},"Accept":{"location":"header","locationName":"Accept"},"CustomAttributes":{"shape":"S5","location":"header","locationName":"X-Amzn-SageMaker-Custom-Attributes"}},"payload":"Body"},"output":{"type":"structure","required":["Body"],"members":{"Body":{"shape":"S3"},"ContentType":{"location":"header","locationName":"Content-Type"},"InvokedProductionVariant":{"location":"header","locationName":"x-Amzn-Invoked-Production-Variant"},"CustomAttributes":{"shape":"S5","location":"header","locationName":"X-Amzn-SageMaker-Custom-Attributes"}},"payload":"Body"}}},"shapes":{"S3":{"type":"blob","sensitive":true},"S5":{"type":"string","sensitive":true}}}');

});

parcelRequire.register("6UEwY", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("k3VkF", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $e9b08f73608dd313$var$Service = $dbC7k.Service;
var $e9b08f73608dd313$var$apiLoader = $dbC7k.apiLoader;
$e9b08f73608dd313$var$apiLoader.services["sagemaker"] = {};
$dbC7k.SageMaker = $e9b08f73608dd313$var$Service.defineService("sagemaker", [
    "2017-07-24"
]);



Object.defineProperty($e9b08f73608dd313$var$apiLoader.services["sagemaker"], "2017-07-24", {
    get: function get() {
        var model = (parcelRequire("axvGR"));
        model.paginators = (parcelRequire("i25nS")).pagination;
        model.waiters = (parcelRequire("fRQsU")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.SageMaker;

});
parcelRequire.register("axvGR", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-07-24","endpointPrefix":"api.sagemaker","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"SageMaker","serviceFullName":"Amazon SageMaker Service","serviceId":"SageMaker","signatureVersion":"v4","signingName":"sagemaker","targetPrefix":"SageMaker","uid":"sagemaker-2017-07-24"},"operations":{"AddTags":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S3"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S3"}}}},"CreateAlgorithm":{"input":{"type":"structure","required":["AlgorithmName","TrainingSpecification"],"members":{"AlgorithmName":{},"AlgorithmDescription":{},"TrainingSpecification":{"shape":"Sb"},"InferenceSpecification":{"shape":"S17"},"ValidationSpecification":{"shape":"S1j"},"CertifyForMarketplace":{"type":"boolean"}}},"output":{"type":"structure","required":["AlgorithmArn"],"members":{"AlgorithmArn":{}}}},"CreateCodeRepository":{"input":{"type":"structure","required":["CodeRepositoryName","GitConfig"],"members":{"CodeRepositoryName":{},"GitConfig":{"shape":"S2z"}}},"output":{"type":"structure","required":["CodeRepositoryArn"],"members":{"CodeRepositoryArn":{}}}},"CreateCompilationJob":{"input":{"type":"structure","required":["CompilationJobName","RoleArn","InputConfig","OutputConfig","StoppingCondition"],"members":{"CompilationJobName":{},"RoleArn":{},"InputConfig":{"shape":"S36"},"OutputConfig":{"shape":"S39"},"StoppingCondition":{"shape":"S2c"}}},"output":{"type":"structure","required":["CompilationJobArn"],"members":{"CompilationJobArn":{}}}},"CreateEndpoint":{"input":{"type":"structure","required":["EndpointName","EndpointConfigName"],"members":{"EndpointName":{},"EndpointConfigName":{},"Tags":{"shape":"S3"}}},"output":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}}},"CreateEndpointConfig":{"input":{"type":"structure","required":["EndpointConfigName","ProductionVariants"],"members":{"EndpointConfigName":{},"ProductionVariants":{"shape":"S3j"},"Tags":{"shape":"S3"},"KmsKeyId":{}}},"output":{"type":"structure","required":["EndpointConfigArn"],"members":{"EndpointConfigArn":{}}}},"CreateHyperParameterTuningJob":{"input":{"type":"structure","required":["HyperParameterTuningJobName","HyperParameterTuningJobConfig"],"members":{"HyperParameterTuningJobName":{},"HyperParameterTuningJobConfig":{"shape":"S3u"},"TrainingJobDefinition":{"shape":"S48"},"WarmStartConfig":{"shape":"S4i"},"Tags":{"shape":"S3"}}},"output":{"type":"structure","required":["HyperParameterTuningJobArn"],"members":{"HyperParameterTuningJobArn":{}}}},"CreateLabelingJob":{"input":{"type":"structure","required":["LabelingJobName","LabelAttributeName","InputConfig","OutputConfig","RoleArn","HumanTaskConfig"],"members":{"LabelingJobName":{},"LabelAttributeName":{},"InputConfig":{"shape":"S4r"},"OutputConfig":{"shape":"S4x"},"RoleArn":{},"LabelCategoryConfigS3Uri":{},"StoppingConditions":{"shape":"S4y"},"LabelingJobAlgorithmsConfig":{"shape":"S51"},"HumanTaskConfig":{"shape":"S55"},"Tags":{"shape":"S3"}}},"output":{"type":"structure","required":["LabelingJobArn"],"members":{"LabelingJobArn":{}}}},"CreateModel":{"input":{"type":"structure","required":["ModelName","ExecutionRoleArn"],"members":{"ModelName":{},"PrimaryContainer":{"shape":"S5q"},"Containers":{"shape":"S5u"},"ExecutionRoleArn":{},"Tags":{"shape":"S3"},"VpcConfig":{"shape":"S4c"},"EnableNetworkIsolation":{"type":"boolean"}}},"output":{"type":"structure","required":["ModelArn"],"members":{"ModelArn":{}}}},"CreateModelPackage":{"input":{"type":"structure","required":["ModelPackageName"],"members":{"ModelPackageName":{},"ModelPackageDescription":{},"InferenceSpecification":{"shape":"S17"},"ValidationSpecification":{"shape":"S5x"},"SourceAlgorithmSpecification":{"shape":"S60"},"CertifyForMarketplace":{"type":"boolean"}}},"output":{"type":"structure","required":["ModelPackageArn"],"members":{"ModelPackageArn":{}}}},"CreateNotebookInstance":{"input":{"type":"structure","required":["NotebookInstanceName","InstanceType","RoleArn"],"members":{"NotebookInstanceName":{},"InstanceType":{},"SubnetId":{},"SecurityGroupIds":{"shape":"S68"},"RoleArn":{},"KmsKeyId":{},"Tags":{"shape":"S3"},"LifecycleConfigName":{},"DirectInternetAccess":{},"VolumeSizeInGB":{"type":"integer"},"AcceleratorTypes":{"shape":"S6c"},"DefaultCodeRepository":{},"AdditionalCodeRepositories":{"shape":"S6f"},"RootAccess":{}}},"output":{"type":"structure","members":{"NotebookInstanceArn":{}}}},"CreateNotebookInstanceLifecycleConfig":{"input":{"type":"structure","required":["NotebookInstanceLifecycleConfigName"],"members":{"NotebookInstanceLifecycleConfigName":{},"OnCreate":{"shape":"S6k"},"OnStart":{"shape":"S6k"}}},"output":{"type":"structure","members":{"NotebookInstanceLifecycleConfigArn":{}}}},"CreatePresignedNotebookInstanceUrl":{"input":{"type":"structure","required":["NotebookInstanceName"],"members":{"NotebookInstanceName":{},"SessionExpirationDurationInSeconds":{"type":"integer"}}},"output":{"type":"structure","members":{"AuthorizedUrl":{}}}},"CreateTrainingJob":{"input":{"type":"structure","required":["TrainingJobName","AlgorithmSpecification","RoleArn","OutputDataConfig","ResourceConfig","StoppingCondition"],"members":{"TrainingJobName":{},"HyperParameters":{"shape":"S1o"},"AlgorithmSpecification":{"shape":"S6v"},"RoleArn":{},"InputDataConfig":{"shape":"S1q"},"OutputDataConfig":{"shape":"S27"},"ResourceConfig":{"shape":"S29"},"VpcConfig":{"shape":"S4c"},"StoppingCondition":{"shape":"S2c"},"Tags":{"shape":"S3"},"EnableNetworkIsolation":{"type":"boolean"},"EnableInterContainerTrafficEncryption":{"type":"boolean"},"EnableManagedSpotTraining":{"type":"boolean"},"CheckpointConfig":{"shape":"S4h"}}},"output":{"type":"structure","required":["TrainingJobArn"],"members":{"TrainingJobArn":{}}}},"CreateTransformJob":{"input":{"type":"structure","required":["TransformJobName","ModelName","TransformInput","TransformOutput","TransformResources"],"members":{"TransformJobName":{},"ModelName":{},"MaxConcurrentTransforms":{"type":"integer"},"MaxPayloadInMB":{"type":"integer"},"BatchStrategy":{},"Environment":{"shape":"S2j"},"TransformInput":{"shape":"S2m"},"TransformOutput":{"shape":"S2q"},"TransformResources":{"shape":"S2t"},"DataProcessing":{"shape":"S70"},"Tags":{"shape":"S3"}}},"output":{"type":"structure","required":["TransformJobArn"],"members":{"TransformJobArn":{}}}},"CreateWorkteam":{"input":{"type":"structure","required":["WorkteamName","MemberDefinitions","Description"],"members":{"WorkteamName":{},"MemberDefinitions":{"shape":"S77"},"Description":{},"NotificationConfiguration":{"shape":"S7e"},"Tags":{"shape":"S3"}}},"output":{"type":"structure","members":{"WorkteamArn":{}}}},"DeleteAlgorithm":{"input":{"type":"structure","required":["AlgorithmName"],"members":{"AlgorithmName":{}}}},"DeleteCodeRepository":{"input":{"type":"structure","required":["CodeRepositoryName"],"members":{"CodeRepositoryName":{}}}},"DeleteEndpoint":{"input":{"type":"structure","required":["EndpointName"],"members":{"EndpointName":{}}}},"DeleteEndpointConfig":{"input":{"type":"structure","required":["EndpointConfigName"],"members":{"EndpointConfigName":{}}}},"DeleteModel":{"input":{"type":"structure","required":["ModelName"],"members":{"ModelName":{}}}},"DeleteModelPackage":{"input":{"type":"structure","required":["ModelPackageName"],"members":{"ModelPackageName":{}}}},"DeleteNotebookInstance":{"input":{"type":"structure","required":["NotebookInstanceName"],"members":{"NotebookInstanceName":{}}}},"DeleteNotebookInstanceLifecycleConfig":{"input":{"type":"structure","required":["NotebookInstanceLifecycleConfigName"],"members":{"NotebookInstanceLifecycleConfigName":{}}}},"DeleteTags":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"DeleteWorkteam":{"input":{"type":"structure","required":["WorkteamName"],"members":{"WorkteamName":{}}},"output":{"type":"structure","required":["Success"],"members":{"Success":{"type":"boolean"}}}},"DescribeAlgorithm":{"input":{"type":"structure","required":["AlgorithmName"],"members":{"AlgorithmName":{}}},"output":{"type":"structure","required":["AlgorithmName","AlgorithmArn","CreationTime","TrainingSpecification","AlgorithmStatus","AlgorithmStatusDetails"],"members":{"AlgorithmName":{},"AlgorithmArn":{},"AlgorithmDescription":{},"CreationTime":{"type":"timestamp"},"TrainingSpecification":{"shape":"Sb"},"InferenceSpecification":{"shape":"S17"},"ValidationSpecification":{"shape":"S1j"},"AlgorithmStatus":{},"AlgorithmStatusDetails":{"type":"structure","members":{"ValidationStatuses":{"shape":"S80"},"ImageScanStatuses":{"shape":"S80"}}},"ProductId":{},"CertifyForMarketplace":{"type":"boolean"}}}},"DescribeCodeRepository":{"input":{"type":"structure","required":["CodeRepositoryName"],"members":{"CodeRepositoryName":{}}},"output":{"type":"structure","required":["CodeRepositoryName","CodeRepositoryArn","CreationTime","LastModifiedTime"],"members":{"CodeRepositoryName":{},"CodeRepositoryArn":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"GitConfig":{"shape":"S2z"}}}},"DescribeCompilationJob":{"input":{"type":"structure","required":["CompilationJobName"],"members":{"CompilationJobName":{}}},"output":{"type":"structure","required":["CompilationJobName","CompilationJobArn","CompilationJobStatus","StoppingCondition","CreationTime","LastModifiedTime","FailureReason","ModelArtifacts","RoleArn","InputConfig","OutputConfig"],"members":{"CompilationJobName":{},"CompilationJobArn":{},"CompilationJobStatus":{},"CompilationStartTime":{"type":"timestamp"},"CompilationEndTime":{"type":"timestamp"},"StoppingCondition":{"shape":"S2c"},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"FailureReason":{},"ModelArtifacts":{"shape":"S8c"},"RoleArn":{},"InputConfig":{"shape":"S36"},"OutputConfig":{"shape":"S39"}}}},"DescribeEndpoint":{"input":{"type":"structure","required":["EndpointName"],"members":{"EndpointName":{}}},"output":{"type":"structure","required":["EndpointName","EndpointArn","EndpointConfigName","EndpointStatus","CreationTime","LastModifiedTime"],"members":{"EndpointName":{},"EndpointArn":{},"EndpointConfigName":{},"ProductionVariants":{"type":"list","member":{"type":"structure","required":["VariantName"],"members":{"VariantName":{},"DeployedImages":{"type":"list","member":{"type":"structure","members":{"SpecifiedImage":{},"ResolvedImage":{},"ResolutionTime":{"type":"timestamp"}}}},"CurrentWeight":{"type":"float"},"DesiredWeight":{"type":"float"},"CurrentInstanceCount":{"type":"integer"},"DesiredInstanceCount":{"type":"integer"}}}},"EndpointStatus":{},"FailureReason":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"DescribeEndpointConfig":{"input":{"type":"structure","required":["EndpointConfigName"],"members":{"EndpointConfigName":{}}},"output":{"type":"structure","required":["EndpointConfigName","EndpointConfigArn","ProductionVariants","CreationTime"],"members":{"EndpointConfigName":{},"EndpointConfigArn":{},"ProductionVariants":{"shape":"S3j"},"KmsKeyId":{},"CreationTime":{"type":"timestamp"}}}},"DescribeHyperParameterTuningJob":{"input":{"type":"structure","required":["HyperParameterTuningJobName"],"members":{"HyperParameterTuningJobName":{}}},"output":{"type":"structure","required":["HyperParameterTuningJobName","HyperParameterTuningJobArn","HyperParameterTuningJobConfig","HyperParameterTuningJobStatus","CreationTime","TrainingJobStatusCounters","ObjectiveStatusCounters"],"members":{"HyperParameterTuningJobName":{},"HyperParameterTuningJobArn":{},"HyperParameterTuningJobConfig":{"shape":"S3u"},"TrainingJobDefinition":{"shape":"S48"},"HyperParameterTuningJobStatus":{},"CreationTime":{"type":"timestamp"},"HyperParameterTuningEndTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"TrainingJobStatusCounters":{"shape":"S8p"},"ObjectiveStatusCounters":{"shape":"S8r"},"BestTrainingJob":{"shape":"S8t"},"OverallBestTrainingJob":{"shape":"S8t"},"WarmStartConfig":{"shape":"S4i"},"FailureReason":{}}}},"DescribeLabelingJob":{"input":{"type":"structure","required":["LabelingJobName"],"members":{"LabelingJobName":{}}},"output":{"type":"structure","required":["LabelingJobStatus","LabelCounters","CreationTime","LastModifiedTime","JobReferenceCode","LabelingJobName","LabelingJobArn","InputConfig","OutputConfig","RoleArn","HumanTaskConfig"],"members":{"LabelingJobStatus":{},"LabelCounters":{"shape":"S91"},"FailureReason":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"JobReferenceCode":{},"LabelingJobName":{},"LabelingJobArn":{},"LabelAttributeName":{},"InputConfig":{"shape":"S4r"},"OutputConfig":{"shape":"S4x"},"RoleArn":{},"LabelCategoryConfigS3Uri":{},"StoppingConditions":{"shape":"S4y"},"LabelingJobAlgorithmsConfig":{"shape":"S51"},"HumanTaskConfig":{"shape":"S55"},"Tags":{"shape":"S3"},"LabelingJobOutput":{"shape":"S94"}}}},"DescribeModel":{"input":{"type":"structure","required":["ModelName"],"members":{"ModelName":{}}},"output":{"type":"structure","required":["ModelName","ExecutionRoleArn","CreationTime","ModelArn"],"members":{"ModelName":{},"PrimaryContainer":{"shape":"S5q"},"Containers":{"shape":"S5u"},"ExecutionRoleArn":{},"VpcConfig":{"shape":"S4c"},"CreationTime":{"type":"timestamp"},"ModelArn":{},"EnableNetworkIsolation":{"type":"boolean"}}}},"DescribeModelPackage":{"input":{"type":"structure","required":["ModelPackageName"],"members":{"ModelPackageName":{}}},"output":{"type":"structure","required":["ModelPackageName","ModelPackageArn","CreationTime","ModelPackageStatus","ModelPackageStatusDetails"],"members":{"ModelPackageName":{},"ModelPackageArn":{},"ModelPackageDescription":{},"CreationTime":{"type":"timestamp"},"InferenceSpecification":{"shape":"S17"},"SourceAlgorithmSpecification":{"shape":"S60"},"ValidationSpecification":{"shape":"S5x"},"ModelPackageStatus":{},"ModelPackageStatusDetails":{"type":"structure","required":["ValidationStatuses"],"members":{"ValidationStatuses":{"shape":"S9b"},"ImageScanStatuses":{"shape":"S9b"}}},"CertifyForMarketplace":{"type":"boolean"}}}},"DescribeNotebookInstance":{"input":{"type":"structure","required":["NotebookInstanceName"],"members":{"NotebookInstanceName":{}}},"output":{"type":"structure","members":{"NotebookInstanceArn":{},"NotebookInstanceName":{},"NotebookInstanceStatus":{},"FailureReason":{},"Url":{},"InstanceType":{},"SubnetId":{},"SecurityGroups":{"shape":"S68"},"RoleArn":{},"KmsKeyId":{},"NetworkInterfaceId":{},"LastModifiedTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"},"NotebookInstanceLifecycleConfigName":{},"DirectInternetAccess":{},"VolumeSizeInGB":{"type":"integer"},"AcceleratorTypes":{"shape":"S6c"},"DefaultCodeRepository":{},"AdditionalCodeRepositories":{"shape":"S6f"},"RootAccess":{}}}},"DescribeNotebookInstanceLifecycleConfig":{"input":{"type":"structure","required":["NotebookInstanceLifecycleConfigName"],"members":{"NotebookInstanceLifecycleConfigName":{}}},"output":{"type":"structure","members":{"NotebookInstanceLifecycleConfigArn":{},"NotebookInstanceLifecycleConfigName":{},"OnCreate":{"shape":"S6k"},"OnStart":{"shape":"S6k"},"LastModifiedTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"}}}},"DescribeSubscribedWorkteam":{"input":{"type":"structure","required":["WorkteamArn"],"members":{"WorkteamArn":{}}},"output":{"type":"structure","required":["SubscribedWorkteam"],"members":{"SubscribedWorkteam":{"shape":"S9m"}}}},"DescribeTrainingJob":{"input":{"type":"structure","required":["TrainingJobName"],"members":{"TrainingJobName":{}}},"output":{"type":"structure","required":["TrainingJobName","TrainingJobArn","ModelArtifacts","TrainingJobStatus","SecondaryStatus","AlgorithmSpecification","ResourceConfig","StoppingCondition","CreationTime"],"members":{"TrainingJobName":{},"TrainingJobArn":{},"TuningJobArn":{},"LabelingJobArn":{},"ModelArtifacts":{"shape":"S8c"},"TrainingJobStatus":{},"SecondaryStatus":{},"FailureReason":{},"HyperParameters":{"shape":"S1o"},"AlgorithmSpecification":{"shape":"S6v"},"RoleArn":{},"InputDataConfig":{"shape":"S1q"},"OutputDataConfig":{"shape":"S27"},"ResourceConfig":{"shape":"S29"},"VpcConfig":{"shape":"S4c"},"StoppingCondition":{"shape":"S2c"},"CreationTime":{"type":"timestamp"},"TrainingStartTime":{"type":"timestamp"},"TrainingEndTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"SecondaryStatusTransitions":{"shape":"S9q"},"FinalMetricDataList":{"shape":"S9t"},"EnableNetworkIsolation":{"type":"boolean"},"EnableInterContainerTrafficEncryption":{"type":"boolean"},"EnableManagedSpotTraining":{"type":"boolean"},"CheckpointConfig":{"shape":"S4h"},"TrainingTimeInSeconds":{"type":"integer"},"BillableTimeInSeconds":{"type":"integer"}}}},"DescribeTransformJob":{"input":{"type":"structure","required":["TransformJobName"],"members":{"TransformJobName":{}}},"output":{"type":"structure","required":["TransformJobName","TransformJobArn","TransformJobStatus","ModelName","TransformInput","TransformResources","CreationTime"],"members":{"TransformJobName":{},"TransformJobArn":{},"TransformJobStatus":{},"FailureReason":{},"ModelName":{},"MaxConcurrentTransforms":{"type":"integer"},"MaxPayloadInMB":{"type":"integer"},"BatchStrategy":{},"Environment":{"shape":"S2j"},"TransformInput":{"shape":"S2m"},"TransformOutput":{"shape":"S2q"},"TransformResources":{"shape":"S2t"},"CreationTime":{"type":"timestamp"},"TransformStartTime":{"type":"timestamp"},"TransformEndTime":{"type":"timestamp"},"LabelingJobArn":{},"DataProcessing":{"shape":"S70"}}}},"DescribeWorkteam":{"input":{"type":"structure","required":["WorkteamName"],"members":{"WorkteamName":{}}},"output":{"type":"structure","required":["Workteam"],"members":{"Workteam":{"shape":"Sa3"}}}},"GetSearchSuggestions":{"input":{"type":"structure","required":["Resource"],"members":{"Resource":{},"SuggestionQuery":{"type":"structure","members":{"PropertyNameQuery":{"type":"structure","required":["PropertyNameHint"],"members":{"PropertyNameHint":{}}}}}}},"output":{"type":"structure","members":{"PropertyNameSuggestions":{"type":"list","member":{"type":"structure","members":{"PropertyName":{}}}}}}},"ListAlgorithms":{"input":{"type":"structure","members":{"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NameContains":{},"NextToken":{},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","required":["AlgorithmSummaryList"],"members":{"AlgorithmSummaryList":{"type":"list","member":{"type":"structure","required":["AlgorithmName","AlgorithmArn","CreationTime","AlgorithmStatus"],"members":{"AlgorithmName":{},"AlgorithmArn":{},"AlgorithmDescription":{},"CreationTime":{"type":"timestamp"},"AlgorithmStatus":{}}}},"NextToken":{}}}},"ListCodeRepositories":{"input":{"type":"structure","members":{"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NameContains":{},"NextToken":{},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","required":["CodeRepositorySummaryList"],"members":{"CodeRepositorySummaryList":{"type":"list","member":{"type":"structure","required":["CodeRepositoryName","CodeRepositoryArn","CreationTime","LastModifiedTime"],"members":{"CodeRepositoryName":{},"CodeRepositoryArn":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"GitConfig":{"shape":"S2z"}}}},"NextToken":{}}}},"ListCompilationJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"NameContains":{},"StatusEquals":{},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","required":["CompilationJobSummaries"],"members":{"CompilationJobSummaries":{"type":"list","member":{"type":"structure","required":["CompilationJobName","CompilationJobArn","CreationTime","CompilationTargetDevice","CompilationJobStatus"],"members":{"CompilationJobName":{},"CompilationJobArn":{},"CreationTime":{"type":"timestamp"},"CompilationStartTime":{"type":"timestamp"},"CompilationEndTime":{"type":"timestamp"},"CompilationTargetDevice":{},"LastModifiedTime":{"type":"timestamp"},"CompilationJobStatus":{}}}},"NextToken":{}}}},"ListEndpointConfigs":{"input":{"type":"structure","members":{"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"},"NameContains":{},"CreationTimeBefore":{"type":"timestamp"},"CreationTimeAfter":{"type":"timestamp"}}},"output":{"type":"structure","required":["EndpointConfigs"],"members":{"EndpointConfigs":{"type":"list","member":{"type":"structure","required":["EndpointConfigName","EndpointConfigArn","CreationTime"],"members":{"EndpointConfigName":{},"EndpointConfigArn":{},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListEndpoints":{"input":{"type":"structure","members":{"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"},"NameContains":{},"CreationTimeBefore":{"type":"timestamp"},"CreationTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"StatusEquals":{}}},"output":{"type":"structure","required":["Endpoints"],"members":{"Endpoints":{"type":"list","member":{"type":"structure","required":["EndpointName","EndpointArn","CreationTime","LastModifiedTime","EndpointStatus"],"members":{"EndpointName":{},"EndpointArn":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"EndpointStatus":{}}}},"NextToken":{}}}},"ListHyperParameterTuningJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"SortBy":{},"SortOrder":{},"NameContains":{},"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"StatusEquals":{}}},"output":{"type":"structure","required":["HyperParameterTuningJobSummaries"],"members":{"HyperParameterTuningJobSummaries":{"type":"list","member":{"type":"structure","required":["HyperParameterTuningJobName","HyperParameterTuningJobArn","HyperParameterTuningJobStatus","Strategy","CreationTime","TrainingJobStatusCounters","ObjectiveStatusCounters"],"members":{"HyperParameterTuningJobName":{},"HyperParameterTuningJobArn":{},"HyperParameterTuningJobStatus":{},"Strategy":{},"CreationTime":{"type":"timestamp"},"HyperParameterTuningEndTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"TrainingJobStatusCounters":{"shape":"S8p"},"ObjectiveStatusCounters":{"shape":"S8r"},"ResourceLimits":{"shape":"S3w"}}}},"NextToken":{}}}},"ListLabelingJobs":{"input":{"type":"structure","members":{"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NextToken":{},"NameContains":{},"SortBy":{},"SortOrder":{},"StatusEquals":{}}},"output":{"type":"structure","members":{"LabelingJobSummaryList":{"type":"list","member":{"type":"structure","required":["LabelingJobName","LabelingJobArn","CreationTime","LastModifiedTime","LabelingJobStatus","LabelCounters","WorkteamArn","PreHumanTaskLambdaArn"],"members":{"LabelingJobName":{},"LabelingJobArn":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LabelingJobStatus":{},"LabelCounters":{"shape":"S91"},"WorkteamArn":{},"PreHumanTaskLambdaArn":{},"AnnotationConsolidationLambdaArn":{},"FailureReason":{},"LabelingJobOutput":{"shape":"S94"},"InputConfig":{"shape":"S4r"}}}},"NextToken":{}}}},"ListLabelingJobsForWorkteam":{"input":{"type":"structure","required":["WorkteamArn"],"members":{"WorkteamArn":{},"MaxResults":{"type":"integer"},"NextToken":{},"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"JobReferenceCodeContains":{},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","required":["LabelingJobSummaryList"],"members":{"LabelingJobSummaryList":{"type":"list","member":{"type":"structure","required":["JobReferenceCode","WorkRequesterAccountId","CreationTime"],"members":{"LabelingJobName":{},"JobReferenceCode":{},"WorkRequesterAccountId":{},"CreationTime":{"type":"timestamp"},"LabelCounters":{"type":"structure","members":{"HumanLabeled":{"type":"integer"},"PendingHuman":{"type":"integer"},"Total":{"type":"integer"}}},"NumberOfHumanWorkersPerDataObject":{"type":"integer"}}}},"NextToken":{}}}},"ListModelPackages":{"input":{"type":"structure","members":{"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NameContains":{},"NextToken":{},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","required":["ModelPackageSummaryList"],"members":{"ModelPackageSummaryList":{"type":"list","member":{"type":"structure","required":["ModelPackageName","ModelPackageArn","CreationTime","ModelPackageStatus"],"members":{"ModelPackageName":{},"ModelPackageArn":{},"ModelPackageDescription":{},"CreationTime":{"type":"timestamp"},"ModelPackageStatus":{}}}},"NextToken":{}}}},"ListModels":{"input":{"type":"structure","members":{"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"},"NameContains":{},"CreationTimeBefore":{"type":"timestamp"},"CreationTimeAfter":{"type":"timestamp"}}},"output":{"type":"structure","required":["Models"],"members":{"Models":{"type":"list","member":{"type":"structure","required":["ModelName","ModelArn","CreationTime"],"members":{"ModelName":{},"ModelArn":{},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListNotebookInstanceLifecycleConfigs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"SortBy":{},"SortOrder":{},"NameContains":{},"CreationTimeBefore":{"type":"timestamp"},"CreationTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"}}},"output":{"type":"structure","members":{"NextToken":{},"NotebookInstanceLifecycleConfigs":{"type":"list","member":{"type":"structure","required":["NotebookInstanceLifecycleConfigName","NotebookInstanceLifecycleConfigArn"],"members":{"NotebookInstanceLifecycleConfigName":{},"NotebookInstanceLifecycleConfigArn":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}}}}},"ListNotebookInstances":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"SortBy":{},"SortOrder":{},"NameContains":{},"CreationTimeBefore":{"type":"timestamp"},"CreationTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"StatusEquals":{},"NotebookInstanceLifecycleConfigNameContains":{},"DefaultCodeRepositoryContains":{},"AdditionalCodeRepositoryEquals":{}}},"output":{"type":"structure","members":{"NextToken":{},"NotebookInstances":{"type":"list","member":{"type":"structure","required":["NotebookInstanceName","NotebookInstanceArn"],"members":{"NotebookInstanceName":{},"NotebookInstanceArn":{},"NotebookInstanceStatus":{},"Url":{},"InstanceType":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"NotebookInstanceLifecycleConfigName":{},"DefaultCodeRepository":{},"AdditionalCodeRepositories":{"shape":"S6f"}}}}}}},"ListSubscribedWorkteams":{"input":{"type":"structure","members":{"NameContains":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["SubscribedWorkteams"],"members":{"SubscribedWorkteams":{"type":"list","member":{"shape":"S9m"}},"NextToken":{}}}},"ListTags":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S3"},"NextToken":{}}}},"ListTrainingJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"NameContains":{},"StatusEquals":{},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","required":["TrainingJobSummaries"],"members":{"TrainingJobSummaries":{"type":"list","member":{"type":"structure","required":["TrainingJobName","TrainingJobArn","CreationTime","TrainingJobStatus"],"members":{"TrainingJobName":{},"TrainingJobArn":{},"CreationTime":{"type":"timestamp"},"TrainingEndTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"TrainingJobStatus":{}}}},"NextToken":{}}}},"ListTrainingJobsForHyperParameterTuningJob":{"input":{"type":"structure","required":["HyperParameterTuningJobName"],"members":{"HyperParameterTuningJobName":{},"NextToken":{},"MaxResults":{"type":"integer"},"StatusEquals":{},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","required":["TrainingJobSummaries"],"members":{"TrainingJobSummaries":{"type":"list","member":{"shape":"S8t"}},"NextToken":{}}}},"ListTransformJobs":{"input":{"type":"structure","members":{"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"},"LastModifiedTimeAfter":{"type":"timestamp"},"LastModifiedTimeBefore":{"type":"timestamp"},"NameContains":{},"StatusEquals":{},"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["TransformJobSummaries"],"members":{"TransformJobSummaries":{"type":"list","member":{"type":"structure","required":["TransformJobName","TransformJobArn","CreationTime","TransformJobStatus"],"members":{"TransformJobName":{},"TransformJobArn":{},"CreationTime":{"type":"timestamp"},"TransformEndTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"TransformJobStatus":{},"FailureReason":{}}}},"NextToken":{}}}},"ListWorkteams":{"input":{"type":"structure","members":{"SortBy":{},"SortOrder":{},"NameContains":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["Workteams"],"members":{"Workteams":{"type":"list","member":{"shape":"Sa3"}},"NextToken":{}}}},"RenderUiTemplate":{"input":{"type":"structure","required":["UiTemplate","Task","RoleArn"],"members":{"UiTemplate":{"type":"structure","required":["Content"],"members":{"Content":{}}},"Task":{"type":"structure","required":["Input"],"members":{"Input":{}}},"RoleArn":{}}},"output":{"type":"structure","required":["RenderedContent","Errors"],"members":{"RenderedContent":{},"Errors":{"type":"list","member":{"type":"structure","required":["Code","Message"],"members":{"Code":{},"Message":{}}}}}}},"Search":{"input":{"type":"structure","required":["Resource"],"members":{"Resource":{},"SearchExpression":{"shape":"Sdg"},"SortBy":{},"SortOrder":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"TrainingJob":{"type":"structure","members":{"TrainingJobName":{},"TrainingJobArn":{},"TuningJobArn":{},"LabelingJobArn":{},"ModelArtifacts":{"shape":"S8c"},"TrainingJobStatus":{},"SecondaryStatus":{},"FailureReason":{},"HyperParameters":{"shape":"S1o"},"AlgorithmSpecification":{"shape":"S6v"},"RoleArn":{},"InputDataConfig":{"shape":"S1q"},"OutputDataConfig":{"shape":"S27"},"ResourceConfig":{"shape":"S29"},"VpcConfig":{"shape":"S4c"},"StoppingCondition":{"shape":"S2c"},"CreationTime":{"type":"timestamp"},"TrainingStartTime":{"type":"timestamp"},"TrainingEndTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"SecondaryStatusTransitions":{"shape":"S9q"},"FinalMetricDataList":{"shape":"S9t"},"EnableNetworkIsolation":{"type":"boolean"},"EnableInterContainerTrafficEncryption":{"type":"boolean"},"Tags":{"shape":"S3"}}}}}},"NextToken":{}}}},"StartNotebookInstance":{"input":{"type":"structure","required":["NotebookInstanceName"],"members":{"NotebookInstanceName":{}}}},"StopCompilationJob":{"input":{"type":"structure","required":["CompilationJobName"],"members":{"CompilationJobName":{}}}},"StopHyperParameterTuningJob":{"input":{"type":"structure","required":["HyperParameterTuningJobName"],"members":{"HyperParameterTuningJobName":{}}}},"StopLabelingJob":{"input":{"type":"structure","required":["LabelingJobName"],"members":{"LabelingJobName":{}}}},"StopNotebookInstance":{"input":{"type":"structure","required":["NotebookInstanceName"],"members":{"NotebookInstanceName":{}}}},"StopTrainingJob":{"input":{"type":"structure","required":["TrainingJobName"],"members":{"TrainingJobName":{}}}},"StopTransformJob":{"input":{"type":"structure","required":["TransformJobName"],"members":{"TransformJobName":{}}}},"UpdateCodeRepository":{"input":{"type":"structure","required":["CodeRepositoryName"],"members":{"CodeRepositoryName":{},"GitConfig":{"type":"structure","members":{"SecretArn":{}}}}},"output":{"type":"structure","required":["CodeRepositoryArn"],"members":{"CodeRepositoryArn":{}}}},"UpdateEndpoint":{"input":{"type":"structure","required":["EndpointName","EndpointConfigName"],"members":{"EndpointName":{},"EndpointConfigName":{}}},"output":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}}},"UpdateEndpointWeightsAndCapacities":{"input":{"type":"structure","required":["EndpointName","DesiredWeightsAndCapacities"],"members":{"EndpointName":{},"DesiredWeightsAndCapacities":{"type":"list","member":{"type":"structure","required":["VariantName"],"members":{"VariantName":{},"DesiredWeight":{"type":"float"},"DesiredInstanceCount":{"type":"integer"}}}}}},"output":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}}},"UpdateNotebookInstance":{"input":{"type":"structure","required":["NotebookInstanceName"],"members":{"NotebookInstanceName":{},"InstanceType":{},"RoleArn":{},"LifecycleConfigName":{},"DisassociateLifecycleConfig":{"type":"boolean"},"VolumeSizeInGB":{"type":"integer"},"DefaultCodeRepository":{},"AdditionalCodeRepositories":{"shape":"S6f"},"AcceleratorTypes":{"shape":"S6c"},"DisassociateAcceleratorTypes":{"type":"boolean"},"DisassociateDefaultCodeRepository":{"type":"boolean"},"DisassociateAdditionalCodeRepositories":{"type":"boolean"},"RootAccess":{}}},"output":{"type":"structure","members":{}}},"UpdateNotebookInstanceLifecycleConfig":{"input":{"type":"structure","required":["NotebookInstanceLifecycleConfigName"],"members":{"NotebookInstanceLifecycleConfigName":{},"OnCreate":{"shape":"S6k"},"OnStart":{"shape":"S6k"}}},"output":{"type":"structure","members":{}}},"UpdateWorkteam":{"input":{"type":"structure","required":["WorkteamName"],"members":{"WorkteamName":{},"MemberDefinitions":{"shape":"S77"},"Description":{},"NotificationConfiguration":{"shape":"S7e"}}},"output":{"type":"structure","required":["Workteam"],"members":{"Workteam":{"shape":"Sa3"}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sb":{"type":"structure","required":["TrainingImage","SupportedTrainingInstanceTypes","TrainingChannels"],"members":{"TrainingImage":{},"TrainingImageDigest":{},"SupportedHyperParameters":{"type":"list","member":{"type":"structure","required":["Name","Type"],"members":{"Name":{},"Description":{},"Type":{},"Range":{"type":"structure","members":{"IntegerParameterRangeSpecification":{"type":"structure","required":["MinValue","MaxValue"],"members":{"MinValue":{},"MaxValue":{}}},"ContinuousParameterRangeSpecification":{"type":"structure","required":["MinValue","MaxValue"],"members":{"MinValue":{},"MaxValue":{}}},"CategoricalParameterRangeSpecification":{"type":"structure","required":["Values"],"members":{"Values":{"shape":"Sn"}}}}},"IsTunable":{"type":"boolean"},"IsRequired":{"type":"boolean"},"DefaultValue":{}}}},"SupportedTrainingInstanceTypes":{"type":"list","member":{}},"SupportsDistributedTraining":{"type":"boolean"},"MetricDefinitions":{"shape":"Sr"},"TrainingChannels":{"type":"list","member":{"type":"structure","required":["Name","SupportedContentTypes","SupportedInputModes"],"members":{"Name":{},"Description":{},"IsRequired":{"type":"boolean"},"SupportedContentTypes":{"shape":"Sy"},"SupportedCompressionTypes":{"type":"list","member":{}},"SupportedInputModes":{"type":"list","member":{}}}}},"SupportedTuningJobObjectiveMetrics":{"type":"list","member":{"shape":"S15"}}}},"Sn":{"type":"list","member":{}},"Sr":{"type":"list","member":{"type":"structure","required":["Name","Regex"],"members":{"Name":{},"Regex":{}}}},"Sy":{"type":"list","member":{}},"S15":{"type":"structure","required":["Type","MetricName"],"members":{"Type":{},"MetricName":{}}},"S17":{"type":"structure","required":["Containers","SupportedTransformInstanceTypes","SupportedRealtimeInferenceInstanceTypes","SupportedContentTypes","SupportedResponseMIMETypes"],"members":{"Containers":{"type":"list","member":{"type":"structure","required":["Image"],"members":{"ContainerHostname":{},"Image":{},"ImageDigest":{},"ModelDataUrl":{},"ProductId":{}}}},"SupportedTransformInstanceTypes":{"type":"list","member":{}},"SupportedRealtimeInferenceInstanceTypes":{"type":"list","member":{}},"SupportedContentTypes":{"shape":"Sy"},"SupportedResponseMIMETypes":{"type":"list","member":{}}}},"S1j":{"type":"structure","required":["ValidationRole","ValidationProfiles"],"members":{"ValidationRole":{},"ValidationProfiles":{"type":"list","member":{"type":"structure","required":["ProfileName","TrainingJobDefinition"],"members":{"ProfileName":{},"TrainingJobDefinition":{"type":"structure","required":["TrainingInputMode","InputDataConfig","OutputDataConfig","ResourceConfig","StoppingCondition"],"members":{"TrainingInputMode":{},"HyperParameters":{"shape":"S1o"},"InputDataConfig":{"shape":"S1q"},"OutputDataConfig":{"shape":"S27"},"ResourceConfig":{"shape":"S29"},"StoppingCondition":{"shape":"S2c"}}},"TransformJobDefinition":{"shape":"S2f"}}}}}},"S1o":{"type":"map","key":{},"value":{}},"S1q":{"type":"list","member":{"type":"structure","required":["ChannelName","DataSource"],"members":{"ChannelName":{},"DataSource":{"type":"structure","members":{"S3DataSource":{"type":"structure","required":["S3DataType","S3Uri"],"members":{"S3DataType":{},"S3Uri":{},"S3DataDistributionType":{},"AttributeNames":{"type":"list","member":{}}}},"FileSystemDataSource":{"type":"structure","required":["FileSystemId","FileSystemAccessMode","FileSystemType","DirectoryPath"],"members":{"FileSystemId":{},"FileSystemAccessMode":{},"FileSystemType":{},"DirectoryPath":{}}}}},"ContentType":{},"CompressionType":{},"RecordWrapperType":{},"InputMode":{},"ShuffleConfig":{"type":"structure","required":["Seed"],"members":{"Seed":{"type":"long"}}}}}},"S27":{"type":"structure","required":["S3OutputPath"],"members":{"KmsKeyId":{},"S3OutputPath":{}}},"S29":{"type":"structure","required":["InstanceType","InstanceCount","VolumeSizeInGB"],"members":{"InstanceType":{},"InstanceCount":{"type":"integer"},"VolumeSizeInGB":{"type":"integer"},"VolumeKmsKeyId":{}}},"S2c":{"type":"structure","members":{"MaxRuntimeInSeconds":{"type":"integer"},"MaxWaitTimeInSeconds":{"type":"integer"}}},"S2f":{"type":"structure","required":["TransformInput","TransformOutput","TransformResources"],"members":{"MaxConcurrentTransforms":{"type":"integer"},"MaxPayloadInMB":{"type":"integer"},"BatchStrategy":{},"Environment":{"shape":"S2j"},"TransformInput":{"shape":"S2m"},"TransformOutput":{"shape":"S2q"},"TransformResources":{"shape":"S2t"}}},"S2j":{"type":"map","key":{},"value":{}},"S2m":{"type":"structure","required":["DataSource"],"members":{"DataSource":{"type":"structure","required":["S3DataSource"],"members":{"S3DataSource":{"type":"structure","required":["S3DataType","S3Uri"],"members":{"S3DataType":{},"S3Uri":{}}}}},"ContentType":{},"CompressionType":{},"SplitType":{}}},"S2q":{"type":"structure","required":["S3OutputPath"],"members":{"S3OutputPath":{},"Accept":{},"AssembleWith":{},"KmsKeyId":{}}},"S2t":{"type":"structure","required":["InstanceType","InstanceCount"],"members":{"InstanceType":{},"InstanceCount":{"type":"integer"},"VolumeKmsKeyId":{}}},"S2z":{"type":"structure","required":["RepositoryUrl"],"members":{"RepositoryUrl":{},"Branch":{},"SecretArn":{}}},"S36":{"type":"structure","required":["S3Uri","DataInputConfig","Framework"],"members":{"S3Uri":{},"DataInputConfig":{},"Framework":{}}},"S39":{"type":"structure","required":["S3OutputLocation","TargetDevice"],"members":{"S3OutputLocation":{},"TargetDevice":{}}},"S3j":{"type":"list","member":{"type":"structure","required":["VariantName","ModelName","InitialInstanceCount","InstanceType"],"members":{"VariantName":{},"ModelName":{},"InitialInstanceCount":{"type":"integer"},"InstanceType":{},"InitialVariantWeight":{"type":"float"},"AcceleratorType":{}}}},"S3u":{"type":"structure","required":["Strategy","ResourceLimits"],"members":{"Strategy":{},"HyperParameterTuningJobObjective":{"shape":"S15"},"ResourceLimits":{"shape":"S3w"},"ParameterRanges":{"type":"structure","members":{"IntegerParameterRanges":{"type":"list","member":{"type":"structure","required":["Name","MinValue","MaxValue"],"members":{"Name":{},"MinValue":{},"MaxValue":{},"ScalingType":{}}}},"ContinuousParameterRanges":{"type":"list","member":{"type":"structure","required":["Name","MinValue","MaxValue"],"members":{"Name":{},"MinValue":{},"MaxValue":{},"ScalingType":{}}}},"CategoricalParameterRanges":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"shape":"Sn"}}}}}},"TrainingJobEarlyStoppingType":{}}},"S3w":{"type":"structure","required":["MaxNumberOfTrainingJobs","MaxParallelTrainingJobs"],"members":{"MaxNumberOfTrainingJobs":{"type":"integer"},"MaxParallelTrainingJobs":{"type":"integer"}}},"S48":{"type":"structure","required":["AlgorithmSpecification","RoleArn","OutputDataConfig","ResourceConfig","StoppingCondition"],"members":{"StaticHyperParameters":{"shape":"S1o"},"AlgorithmSpecification":{"type":"structure","required":["TrainingInputMode"],"members":{"TrainingImage":{},"TrainingInputMode":{},"AlgorithmName":{},"MetricDefinitions":{"shape":"Sr"}}},"RoleArn":{},"InputDataConfig":{"shape":"S1q"},"VpcConfig":{"shape":"S4c"},"OutputDataConfig":{"shape":"S27"},"ResourceConfig":{"shape":"S29"},"StoppingCondition":{"shape":"S2c"},"EnableNetworkIsolation":{"type":"boolean"},"EnableInterContainerTrafficEncryption":{"type":"boolean"},"EnableManagedSpotTraining":{"type":"boolean"},"CheckpointConfig":{"shape":"S4h"}}},"S4c":{"type":"structure","required":["SecurityGroupIds","Subnets"],"members":{"SecurityGroupIds":{"type":"list","member":{}},"Subnets":{"type":"list","member":{}}}},"S4h":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"LocalPath":{}}},"S4i":{"type":"structure","required":["ParentHyperParameterTuningJobs","WarmStartType"],"members":{"ParentHyperParameterTuningJobs":{"type":"list","member":{"type":"structure","members":{"HyperParameterTuningJobName":{}}}},"WarmStartType":{}}},"S4r":{"type":"structure","required":["DataSource"],"members":{"DataSource":{"type":"structure","required":["S3DataSource"],"members":{"S3DataSource":{"type":"structure","required":["ManifestS3Uri"],"members":{"ManifestS3Uri":{}}}}},"DataAttributes":{"type":"structure","members":{"ContentClassifiers":{"type":"list","member":{}}}}}},"S4x":{"type":"structure","required":["S3OutputPath"],"members":{"S3OutputPath":{},"KmsKeyId":{}}},"S4y":{"type":"structure","members":{"MaxHumanLabeledObjectCount":{"type":"integer"},"MaxPercentageOfInputDatasetLabeled":{"type":"integer"}}},"S51":{"type":"structure","required":["LabelingJobAlgorithmSpecificationArn"],"members":{"LabelingJobAlgorithmSpecificationArn":{},"InitialActiveLearningModelArn":{},"LabelingJobResourceConfig":{"type":"structure","members":{"VolumeKmsKeyId":{}}}}},"S55":{"type":"structure","required":["WorkteamArn","UiConfig","PreHumanTaskLambdaArn","TaskTitle","TaskDescription","NumberOfHumanWorkersPerDataObject","TaskTimeLimitInSeconds","AnnotationConsolidationConfig"],"members":{"WorkteamArn":{},"UiConfig":{"type":"structure","required":["UiTemplateS3Uri"],"members":{"UiTemplateS3Uri":{}}},"PreHumanTaskLambdaArn":{},"TaskKeywords":{"type":"list","member":{}},"TaskTitle":{},"TaskDescription":{},"NumberOfHumanWorkersPerDataObject":{"type":"integer"},"TaskTimeLimitInSeconds":{"type":"integer"},"TaskAvailabilityLifetimeInSeconds":{"type":"integer"},"MaxConcurrentTaskCount":{"type":"integer"},"AnnotationConsolidationConfig":{"type":"structure","required":["AnnotationConsolidationLambdaArn"],"members":{"AnnotationConsolidationLambdaArn":{}}},"PublicWorkforceTaskPrice":{"type":"structure","members":{"AmountInUsd":{"type":"structure","members":{"Dollars":{"type":"integer"},"Cents":{"type":"integer"},"TenthFractionsOfACent":{"type":"integer"}}}}}}},"S5q":{"type":"structure","members":{"ContainerHostname":{},"Image":{},"ModelDataUrl":{},"Environment":{"type":"map","key":{},"value":{}},"ModelPackageName":{}}},"S5u":{"type":"list","member":{"shape":"S5q"}},"S5x":{"type":"structure","required":["ValidationRole","ValidationProfiles"],"members":{"ValidationRole":{},"ValidationProfiles":{"type":"list","member":{"type":"structure","required":["ProfileName","TransformJobDefinition"],"members":{"ProfileName":{},"TransformJobDefinition":{"shape":"S2f"}}}}}},"S60":{"type":"structure","required":["SourceAlgorithms"],"members":{"SourceAlgorithms":{"type":"list","member":{"type":"structure","required":["AlgorithmName"],"members":{"ModelDataUrl":{},"AlgorithmName":{}}}}}},"S68":{"type":"list","member":{}},"S6c":{"type":"list","member":{}},"S6f":{"type":"list","member":{}},"S6k":{"type":"list","member":{"type":"structure","members":{"Content":{}}}},"S6v":{"type":"structure","required":["TrainingInputMode"],"members":{"TrainingImage":{},"AlgorithmName":{},"TrainingInputMode":{},"MetricDefinitions":{"shape":"Sr"}}},"S70":{"type":"structure","members":{"InputFilter":{},"OutputFilter":{},"JoinSource":{}}},"S77":{"type":"list","member":{"type":"structure","members":{"CognitoMemberDefinition":{"type":"structure","required":["UserPool","UserGroup","ClientId"],"members":{"UserPool":{},"UserGroup":{},"ClientId":{}}}}}},"S7e":{"type":"structure","members":{"NotificationTopicArn":{}}},"S80":{"type":"list","member":{"type":"structure","required":["Name","Status"],"members":{"Name":{},"Status":{},"FailureReason":{}}}},"S8c":{"type":"structure","required":["S3ModelArtifacts"],"members":{"S3ModelArtifacts":{}}},"S8p":{"type":"structure","members":{"Completed":{"type":"integer"},"InProgress":{"type":"integer"},"RetryableError":{"type":"integer"},"NonRetryableError":{"type":"integer"},"Stopped":{"type":"integer"}}},"S8r":{"type":"structure","members":{"Succeeded":{"type":"integer"},"Pending":{"type":"integer"},"Failed":{"type":"integer"}}},"S8t":{"type":"structure","required":["TrainingJobName","TrainingJobArn","CreationTime","TrainingJobStatus","TunedHyperParameters"],"members":{"TrainingJobName":{},"TrainingJobArn":{},"TuningJobName":{},"CreationTime":{"type":"timestamp"},"TrainingStartTime":{"type":"timestamp"},"TrainingEndTime":{"type":"timestamp"},"TrainingJobStatus":{},"TunedHyperParameters":{"shape":"S1o"},"FailureReason":{},"FinalHyperParameterTuningJobObjectiveMetric":{"type":"structure","required":["MetricName","Value"],"members":{"Type":{},"MetricName":{},"Value":{"type":"float"}}},"ObjectiveStatus":{}}},"S91":{"type":"structure","members":{"TotalLabeled":{"type":"integer"},"HumanLabeled":{"type":"integer"},"MachineLabeled":{"type":"integer"},"FailedNonRetryableError":{"type":"integer"},"Unlabeled":{"type":"integer"}}},"S94":{"type":"structure","required":["OutputDatasetS3Uri"],"members":{"OutputDatasetS3Uri":{},"FinalActiveLearningModelArn":{}}},"S9b":{"type":"list","member":{"type":"structure","required":["Name","Status"],"members":{"Name":{},"Status":{},"FailureReason":{}}}},"S9m":{"type":"structure","required":["WorkteamArn"],"members":{"WorkteamArn":{},"MarketplaceTitle":{},"SellerName":{},"MarketplaceDescription":{},"ListingId":{}}},"S9q":{"type":"list","member":{"type":"structure","required":["Status","StartTime"],"members":{"Status":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"StatusMessage":{}}}},"S9t":{"type":"list","member":{"type":"structure","members":{"MetricName":{},"Value":{"type":"float"},"Timestamp":{"type":"timestamp"}}}},"Sa3":{"type":"structure","required":["WorkteamName","MemberDefinitions","WorkteamArn","Description"],"members":{"WorkteamName":{},"MemberDefinitions":{"shape":"S77"},"WorkteamArn":{},"ProductListingIds":{"type":"list","member":{}},"Description":{},"SubDomain":{},"CreateDate":{"type":"timestamp"},"LastUpdatedDate":{"type":"timestamp"},"NotificationConfiguration":{"shape":"S7e"}}},"Sdg":{"type":"structure","members":{"Filters":{"shape":"Sdh"},"NestedFilters":{"type":"list","member":{"type":"structure","required":["NestedPropertyName","Filters"],"members":{"NestedPropertyName":{},"Filters":{"shape":"Sdh"}}}},"SubExpressions":{"type":"list","member":{"shape":"Sdg"}},"Operator":{}}},"Sdh":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Operator":{},"Value":{}}}}}}');

});

parcelRequire.register("i25nS", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListCompilationJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListEndpointConfigs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListEndpoints":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListHyperParameterTuningJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListLabelingJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListLabelingJobsForWorkteam":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListModels":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListNotebookInstanceLifecycleConfigs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListNotebookInstances":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSubscribedWorkteams":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTags":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTrainingJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTrainingJobsForHyperParameterTuningJob":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTransformJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWorkteams":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"Search":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});

parcelRequire.register("fRQsU", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"NotebookInstanceInService":{"delay":30,"maxAttempts":60,"operation":"DescribeNotebookInstance","acceptors":[{"expected":"InService","matcher":"path","state":"success","argument":"NotebookInstanceStatus"},{"expected":"Failed","matcher":"path","state":"failure","argument":"NotebookInstanceStatus"}]},"NotebookInstanceStopped":{"delay":30,"operation":"DescribeNotebookInstance","maxAttempts":60,"acceptors":[{"expected":"Stopped","matcher":"path","state":"success","argument":"NotebookInstanceStatus"},{"expected":"Failed","matcher":"path","state":"failure","argument":"NotebookInstanceStatus"}]},"NotebookInstanceDeleted":{"delay":30,"maxAttempts":60,"operation":"DescribeNotebookInstance","acceptors":[{"expected":"ValidationException","matcher":"error","state":"success"},{"expected":"Failed","matcher":"path","state":"failure","argument":"NotebookInstanceStatus"}]},"TrainingJobCompletedOrStopped":{"delay":120,"maxAttempts":180,"operation":"DescribeTrainingJob","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"TrainingJobStatus"},{"expected":"Stopped","matcher":"path","state":"success","argument":"TrainingJobStatus"},{"expected":"Failed","matcher":"path","state":"failure","argument":"TrainingJobStatus"},{"expected":"ValidationException","matcher":"error","state":"failure"}]},"EndpointInService":{"delay":30,"maxAttempts":120,"operation":"DescribeEndpoint","acceptors":[{"expected":"InService","matcher":"path","state":"success","argument":"EndpointStatus"},{"expected":"Failed","matcher":"path","state":"failure","argument":"EndpointStatus"},{"expected":"ValidationException","matcher":"error","state":"failure"}]},"EndpointDeleted":{"delay":30,"maxAttempts":60,"operation":"DescribeEndpoint","acceptors":[{"expected":"ValidationException","matcher":"error","state":"success"},{"expected":"Failed","matcher":"path","state":"failure","argument":"EndpointStatus"}]},"TransformJobCompletedOrStopped":{"delay":60,"maxAttempts":60,"operation":"DescribeTransformJob","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"TransformJobStatus"},{"expected":"Stopped","matcher":"path","state":"success","argument":"TransformJobStatus"},{"expected":"Failed","matcher":"path","state":"failure","argument":"TransformJobStatus"},{"expected":"ValidationException","matcher":"error","state":"failure"}]}}}');

});


parcelRequire.register("aA9R8", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $7b44e965b57f42ca$var$Service = $dbC7k.Service;
var $7b44e965b57f42ca$var$apiLoader = $dbC7k.apiLoader;
$7b44e965b57f42ca$var$apiLoader.services["resourcegroups"] = {};
$dbC7k.ResourceGroups = $7b44e965b57f42ca$var$Service.defineService("resourcegroups", [
    "2017-11-27"
]);


Object.defineProperty($7b44e965b57f42ca$var$apiLoader.services["resourcegroups"], "2017-11-27", {
    get: function get() {
        var model = (parcelRequire("1h1IL"));
        model.paginators = (parcelRequire("kXX2d")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ResourceGroups;

});
parcelRequire.register("1h1IL", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-11-27","endpointPrefix":"resource-groups","protocol":"rest-json","serviceAbbreviation":"Resource Groups","serviceFullName":"AWS Resource Groups","serviceId":"Resource Groups","signatureVersion":"v4","signingName":"resource-groups","uid":"resource-groups-2017-11-27"},"operations":{"CreateGroup":{"http":{"requestUri":"/groups"},"input":{"type":"structure","required":["Name","ResourceQuery"],"members":{"Name":{},"Description":{},"ResourceQuery":{"shape":"S4"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"Group":{"shape":"Sb"},"ResourceQuery":{"shape":"S4"},"Tags":{"shape":"S7"}}}},"DeleteGroup":{"http":{"method":"DELETE","requestUri":"/groups/{GroupName}"},"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{"location":"uri","locationName":"GroupName"}}},"output":{"type":"structure","members":{"Group":{"shape":"Sb"}}}},"GetGroup":{"http":{"method":"GET","requestUri":"/groups/{GroupName}"},"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{"location":"uri","locationName":"GroupName"}}},"output":{"type":"structure","members":{"Group":{"shape":"Sb"}}}},"GetGroupQuery":{"http":{"method":"GET","requestUri":"/groups/{GroupName}/query"},"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{"location":"uri","locationName":"GroupName"}}},"output":{"type":"structure","members":{"GroupQuery":{"shape":"Sj"}}}},"GetTags":{"http":{"method":"GET","requestUri":"/resources/{Arn}/tags"},"input":{"type":"structure","required":["Arn"],"members":{"Arn":{"location":"uri","locationName":"Arn"}}},"output":{"type":"structure","members":{"Arn":{},"Tags":{"shape":"S7"}}}},"ListGroupResources":{"http":{"requestUri":"/groups/{GroupName}/resource-identifiers-list"},"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{"location":"uri","locationName":"GroupName"},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"ResourceIdentifiers":{"shape":"Sv"},"NextToken":{},"QueryErrors":{"shape":"Sz"}}}},"ListGroups":{"http":{"requestUri":"/groups-list"},"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"GroupIdentifiers":{"type":"list","member":{"type":"structure","members":{"GroupName":{},"GroupArn":{}}}},"Groups":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use GroupIdentifiers instead.","type":"list","member":{"shape":"Sb"}},"NextToken":{}}}},"SearchResources":{"http":{"requestUri":"/resources/search"},"input":{"type":"structure","required":["ResourceQuery"],"members":{"ResourceQuery":{"shape":"S4"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ResourceIdentifiers":{"shape":"Sv"},"NextToken":{},"QueryErrors":{"shape":"Sz"}}}},"Tag":{"http":{"method":"PUT","requestUri":"/resources/{Arn}/tags"},"input":{"type":"structure","required":["Arn","Tags"],"members":{"Arn":{"location":"uri","locationName":"Arn"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"Arn":{},"Tags":{"shape":"S7"}}}},"Untag":{"http":{"method":"PATCH","requestUri":"/resources/{Arn}/tags"},"input":{"type":"structure","required":["Arn","Keys"],"members":{"Arn":{"location":"uri","locationName":"Arn"},"Keys":{"shape":"S1i"}}},"output":{"type":"structure","members":{"Arn":{},"Keys":{"shape":"S1i"}}}},"UpdateGroup":{"http":{"method":"PUT","requestUri":"/groups/{GroupName}"},"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{"location":"uri","locationName":"GroupName"},"Description":{}}},"output":{"type":"structure","members":{"Group":{"shape":"Sb"}}}},"UpdateGroupQuery":{"http":{"method":"PUT","requestUri":"/groups/{GroupName}/query"},"input":{"type":"structure","required":["GroupName","ResourceQuery"],"members":{"GroupName":{"location":"uri","locationName":"GroupName"},"ResourceQuery":{"shape":"S4"}}},"output":{"type":"structure","members":{"GroupQuery":{"shape":"Sj"}}}}},"shapes":{"S4":{"type":"structure","required":["Type","Query"],"members":{"Type":{},"Query":{}}},"S7":{"type":"map","key":{},"value":{}},"Sb":{"type":"structure","required":["GroupArn","Name"],"members":{"GroupArn":{},"Name":{},"Description":{}}},"Sj":{"type":"structure","required":["GroupName","ResourceQuery"],"members":{"GroupName":{},"ResourceQuery":{"shape":"S4"}}},"Sv":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{},"ResourceType":{}}}},"Sz":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"Message":{}}}},"S1i":{"type":"list","member":{}}}}');

});

parcelRequire.register("kXX2d", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListGroupResources":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"SearchResources":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("1McK4", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $14b42874a96f6c1b$var$Service = $dbC7k.Service;
var $14b42874a96f6c1b$var$apiLoader = $dbC7k.apiLoader;
$14b42874a96f6c1b$var$apiLoader.services["alexaforbusiness"] = {};
$dbC7k.AlexaForBusiness = $14b42874a96f6c1b$var$Service.defineService("alexaforbusiness", [
    "2017-11-09"
]);


Object.defineProperty($14b42874a96f6c1b$var$apiLoader.services["alexaforbusiness"], "2017-11-09", {
    get: function get() {
        var model = (parcelRequire("gqHU3"));
        model.paginators = (parcelRequire("2mflp")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.AlexaForBusiness;

});
parcelRequire.register("gqHU3", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-11-09","endpointPrefix":"a4b","jsonVersion":"1.1","protocol":"json","serviceFullName":"Alexa For Business","serviceId":"Alexa For Business","signatureVersion":"v4","targetPrefix":"AlexaForBusiness","uid":"alexaforbusiness-2017-11-09"},"operations":{"ApproveSkill":{"input":{"type":"structure","required":["SkillId"],"members":{"SkillId":{}}},"output":{"type":"structure","members":{}}},"AssociateContactWithAddressBook":{"input":{"type":"structure","required":["ContactArn","AddressBookArn"],"members":{"ContactArn":{},"AddressBookArn":{}}},"output":{"type":"structure","members":{}}},"AssociateDeviceWithNetworkProfile":{"input":{"type":"structure","required":["DeviceArn","NetworkProfileArn"],"members":{"DeviceArn":{},"NetworkProfileArn":{}}},"output":{"type":"structure","members":{}}},"AssociateDeviceWithRoom":{"input":{"type":"structure","members":{"DeviceArn":{},"RoomArn":{}}},"output":{"type":"structure","members":{}}},"AssociateSkillGroupWithRoom":{"input":{"type":"structure","members":{"SkillGroupArn":{},"RoomArn":{}}},"output":{"type":"structure","members":{}}},"AssociateSkillWithSkillGroup":{"input":{"type":"structure","required":["SkillId"],"members":{"SkillGroupArn":{},"SkillId":{}}},"output":{"type":"structure","members":{}}},"AssociateSkillWithUsers":{"input":{"type":"structure","required":["SkillId"],"members":{"SkillId":{}}},"output":{"type":"structure","members":{}}},"CreateAddressBook":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"AddressBookArn":{}}}},"CreateBusinessReportSchedule":{"input":{"type":"structure","required":["Format","ContentRange"],"members":{"ScheduleName":{},"S3BucketName":{},"S3KeyPrefix":{},"Format":{},"ContentRange":{"shape":"Sr"},"Recurrence":{"shape":"St"},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ScheduleArn":{}}}},"CreateConferenceProvider":{"input":{"type":"structure","required":["ConferenceProviderName","ConferenceProviderType","MeetingSetting"],"members":{"ConferenceProviderName":{},"ConferenceProviderType":{},"IPDialIn":{"shape":"Sz"},"PSTNDialIn":{"shape":"S12"},"MeetingSetting":{"shape":"S17"},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ConferenceProviderArn":{}}}},"CreateContact":{"input":{"type":"structure","required":["FirstName"],"members":{"DisplayName":{},"FirstName":{},"LastName":{},"PhoneNumber":{"shape":"S1c"},"PhoneNumbers":{"shape":"S1d"},"SipAddresses":{"shape":"S1g"},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ContactArn":{}}}},"CreateGatewayGroup":{"input":{"type":"structure","required":["Name","ClientRequestToken"],"members":{"Name":{},"Description":{},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"GatewayGroupArn":{}}}},"CreateNetworkProfile":{"input":{"type":"structure","required":["NetworkProfileName","Ssid","SecurityType","ClientRequestToken"],"members":{"NetworkProfileName":{},"Description":{},"Ssid":{},"SecurityType":{},"EapMethod":{},"CurrentPassword":{"shape":"S1v"},"NextPassword":{"shape":"S1w"},"CertificateAuthorityArn":{},"TrustAnchors":{"shape":"S1x"},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"NetworkProfileArn":{}}}},"CreateProfile":{"input":{"type":"structure","required":["ProfileName","Timezone","Address","DistanceUnit","TemperatureUnit","WakeWord"],"members":{"ProfileName":{},"Timezone":{},"Address":{},"DistanceUnit":{},"TemperatureUnit":{},"WakeWord":{},"Locale":{},"ClientRequestToken":{"idempotencyToken":true},"SetupModeDisabled":{"type":"boolean"},"MaxVolumeLimit":{"type":"integer"},"PSTNEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"ProfileArn":{}}}},"CreateRoom":{"input":{"type":"structure","required":["RoomName"],"members":{"RoomName":{},"Description":{},"ProfileArn":{},"ProviderCalendarId":{},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"S2f"}}},"output":{"type":"structure","members":{"RoomArn":{}}}},"CreateSkillGroup":{"input":{"type":"structure","required":["SkillGroupName"],"members":{"SkillGroupName":{},"Description":{},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"SkillGroupArn":{}}}},"CreateUser":{"input":{"type":"structure","required":["UserId"],"members":{"UserId":{},"FirstName":{},"LastName":{},"Email":{},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"S2f"}}},"output":{"type":"structure","members":{"UserArn":{}}}},"DeleteAddressBook":{"input":{"type":"structure","required":["AddressBookArn"],"members":{"AddressBookArn":{}}},"output":{"type":"structure","members":{}}},"DeleteBusinessReportSchedule":{"input":{"type":"structure","required":["ScheduleArn"],"members":{"ScheduleArn":{}}},"output":{"type":"structure","members":{}}},"DeleteConferenceProvider":{"input":{"type":"structure","required":["ConferenceProviderArn"],"members":{"ConferenceProviderArn":{}}},"output":{"type":"structure","members":{}}},"DeleteContact":{"input":{"type":"structure","required":["ContactArn"],"members":{"ContactArn":{}}},"output":{"type":"structure","members":{}}},"DeleteDevice":{"input":{"type":"structure","required":["DeviceArn"],"members":{"DeviceArn":{}}},"output":{"type":"structure","members":{}}},"DeleteDeviceUsageData":{"input":{"type":"structure","required":["DeviceArn","DeviceUsageType"],"members":{"DeviceArn":{},"DeviceUsageType":{}}},"output":{"type":"structure","members":{}}},"DeleteGatewayGroup":{"input":{"type":"structure","required":["GatewayGroupArn"],"members":{"GatewayGroupArn":{}}},"output":{"type":"structure","members":{}}},"DeleteNetworkProfile":{"input":{"type":"structure","required":["NetworkProfileArn"],"members":{"NetworkProfileArn":{}}},"output":{"type":"structure","members":{}}},"DeleteProfile":{"input":{"type":"structure","members":{"ProfileArn":{}}},"output":{"type":"structure","members":{}}},"DeleteRoom":{"input":{"type":"structure","members":{"RoomArn":{}}},"output":{"type":"structure","members":{}}},"DeleteRoomSkillParameter":{"input":{"type":"structure","required":["SkillId","ParameterKey"],"members":{"RoomArn":{},"SkillId":{},"ParameterKey":{}}},"output":{"type":"structure","members":{}}},"DeleteSkillAuthorization":{"input":{"type":"structure","required":["SkillId"],"members":{"SkillId":{},"RoomArn":{}}},"output":{"type":"structure","members":{}}},"DeleteSkillGroup":{"input":{"type":"structure","members":{"SkillGroupArn":{}}},"output":{"type":"structure","members":{}}},"DeleteUser":{"input":{"type":"structure","required":["EnrollmentId"],"members":{"UserArn":{},"EnrollmentId":{}}},"output":{"type":"structure","members":{}}},"DisassociateContactFromAddressBook":{"input":{"type":"structure","required":["ContactArn","AddressBookArn"],"members":{"ContactArn":{},"AddressBookArn":{}}},"output":{"type":"structure","members":{}}},"DisassociateDeviceFromRoom":{"input":{"type":"structure","members":{"DeviceArn":{}}},"output":{"type":"structure","members":{}}},"DisassociateSkillFromSkillGroup":{"input":{"type":"structure","required":["SkillId"],"members":{"SkillGroupArn":{},"SkillId":{}}},"output":{"type":"structure","members":{}}},"DisassociateSkillFromUsers":{"input":{"type":"structure","required":["SkillId"],"members":{"SkillId":{}}},"output":{"type":"structure","members":{}}},"DisassociateSkillGroupFromRoom":{"input":{"type":"structure","members":{"SkillGroupArn":{},"RoomArn":{}}},"output":{"type":"structure","members":{}}},"ForgetSmartHomeAppliances":{"input":{"type":"structure","required":["RoomArn"],"members":{"RoomArn":{}}},"output":{"type":"structure","members":{}}},"GetAddressBook":{"input":{"type":"structure","required":["AddressBookArn"],"members":{"AddressBookArn":{}}},"output":{"type":"structure","members":{"AddressBook":{"type":"structure","members":{"AddressBookArn":{},"Name":{},"Description":{}}}}}},"GetConferencePreference":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"Preference":{"shape":"S46"}}}},"GetConferenceProvider":{"input":{"type":"structure","required":["ConferenceProviderArn"],"members":{"ConferenceProviderArn":{}}},"output":{"type":"structure","members":{"ConferenceProvider":{"shape":"S49"}}}},"GetContact":{"input":{"type":"structure","required":["ContactArn"],"members":{"ContactArn":{}}},"output":{"type":"structure","members":{"Contact":{"type":"structure","members":{"ContactArn":{},"DisplayName":{},"FirstName":{},"LastName":{},"PhoneNumber":{"shape":"S1c"},"PhoneNumbers":{"shape":"S1d"},"SipAddresses":{"shape":"S1g"}}}}}},"GetDevice":{"input":{"type":"structure","members":{"DeviceArn":{}}},"output":{"type":"structure","members":{"Device":{"type":"structure","members":{"DeviceArn":{},"DeviceSerialNumber":{},"DeviceType":{},"DeviceName":{},"SoftwareVersion":{},"MacAddress":{},"RoomArn":{},"DeviceStatus":{},"DeviceStatusInfo":{"shape":"S4m"},"NetworkProfileInfo":{"type":"structure","members":{"NetworkProfileArn":{},"CertificateArn":{},"CertificateExpirationTime":{"type":"timestamp"}}}}}}}},"GetGateway":{"input":{"type":"structure","required":["GatewayArn"],"members":{"GatewayArn":{}}},"output":{"type":"structure","members":{"Gateway":{"type":"structure","members":{"Arn":{},"Name":{},"Description":{},"GatewayGroupArn":{},"SoftwareVersion":{}}}}}},"GetGatewayGroup":{"input":{"type":"structure","required":["GatewayGroupArn"],"members":{"GatewayGroupArn":{}}},"output":{"type":"structure","members":{"GatewayGroup":{"type":"structure","members":{"Arn":{},"Name":{},"Description":{}}}}}},"GetInvitationConfiguration":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"OrganizationName":{},"ContactEmail":{},"PrivateSkillIds":{"shape":"S56"}}}},"GetNetworkProfile":{"input":{"type":"structure","required":["NetworkProfileArn"],"members":{"NetworkProfileArn":{}}},"output":{"type":"structure","members":{"NetworkProfile":{"type":"structure","members":{"NetworkProfileArn":{},"NetworkProfileName":{},"Description":{},"Ssid":{},"SecurityType":{},"EapMethod":{},"CurrentPassword":{"shape":"S1v"},"NextPassword":{"shape":"S1w"},"CertificateAuthorityArn":{},"TrustAnchors":{"shape":"S1x"}}}}}},"GetProfile":{"input":{"type":"structure","members":{"ProfileArn":{}}},"output":{"type":"structure","members":{"Profile":{"type":"structure","members":{"ProfileArn":{},"ProfileName":{},"IsDefault":{"type":"boolean"},"Address":{},"Timezone":{},"DistanceUnit":{},"TemperatureUnit":{},"WakeWord":{},"Locale":{},"SetupModeDisabled":{"type":"boolean"},"MaxVolumeLimit":{"type":"integer"},"PSTNEnabled":{"type":"boolean"},"AddressBookArn":{}}}}}},"GetRoom":{"input":{"type":"structure","members":{"RoomArn":{}}},"output":{"type":"structure","members":{"Room":{"type":"structure","members":{"RoomArn":{},"RoomName":{},"Description":{},"ProviderCalendarId":{},"ProfileArn":{}}}}}},"GetRoomSkillParameter":{"input":{"type":"structure","required":["SkillId","ParameterKey"],"members":{"RoomArn":{},"SkillId":{},"ParameterKey":{}}},"output":{"type":"structure","members":{"RoomSkillParameter":{"shape":"S5i"}}}},"GetSkillGroup":{"input":{"type":"structure","members":{"SkillGroupArn":{}}},"output":{"type":"structure","members":{"SkillGroup":{"type":"structure","members":{"SkillGroupArn":{},"SkillGroupName":{},"Description":{}}}}}},"ListBusinessReportSchedules":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"BusinessReportSchedules":{"type":"list","member":{"type":"structure","members":{"ScheduleArn":{},"ScheduleName":{},"S3BucketName":{},"S3KeyPrefix":{},"Format":{},"ContentRange":{"shape":"Sr"},"Recurrence":{"shape":"St"},"LastBusinessReport":{"type":"structure","members":{"Status":{},"FailureCode":{},"S3Location":{"type":"structure","members":{"Path":{},"BucketName":{}}},"DeliveryTime":{"type":"timestamp"},"DownloadUrl":{}}}}}},"NextToken":{}}}},"ListConferenceProviders":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ConferenceProviders":{"type":"list","member":{"shape":"S49"}},"NextToken":{}}}},"ListDeviceEvents":{"input":{"type":"structure","required":["DeviceArn"],"members":{"DeviceArn":{},"EventType":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DeviceEvents":{"type":"list","member":{"type":"structure","members":{"Type":{},"Value":{},"Timestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListGatewayGroups":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayGroups":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Name":{},"Description":{}}}},"NextToken":{}}}},"ListGateways":{"input":{"type":"structure","members":{"GatewayGroupArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Gateways":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Name":{},"Description":{},"GatewayGroupArn":{},"SoftwareVersion":{}}}},"NextToken":{}}}},"ListSkills":{"input":{"type":"structure","members":{"SkillGroupArn":{},"EnablementType":{},"SkillType":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SkillSummaries":{"type":"list","member":{"type":"structure","members":{"SkillId":{},"SkillName":{},"SupportsLinking":{"type":"boolean"},"EnablementType":{},"SkillType":{}}}},"NextToken":{}}}},"ListSkillsStoreCategories":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"CategoryList":{"type":"list","member":{"type":"structure","members":{"CategoryId":{"type":"long"},"CategoryName":{}}}},"NextToken":{}}}},"ListSkillsStoreSkillsByCategory":{"input":{"type":"structure","required":["CategoryId"],"members":{"CategoryId":{"type":"long"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SkillsStoreSkills":{"type":"list","member":{"type":"structure","members":{"SkillId":{},"SkillName":{},"ShortDescription":{},"IconUrl":{},"SampleUtterances":{"type":"list","member":{}},"SkillDetails":{"type":"structure","members":{"ProductDescription":{},"InvocationPhrase":{},"ReleaseDate":{},"EndUserLicenseAgreement":{},"GenericKeywords":{"type":"list","member":{}},"BulletPoints":{"type":"list","member":{}},"NewInThisVersionBulletPoints":{"type":"list","member":{}},"SkillTypes":{"type":"list","member":{}},"Reviews":{"type":"map","key":{},"value":{}},"DeveloperInfo":{"type":"structure","members":{"DeveloperName":{},"PrivacyPolicy":{},"Email":{},"Url":{}}}}},"SupportsLinking":{"type":"boolean"}}}},"NextToken":{}}}},"ListSmartHomeAppliances":{"input":{"type":"structure","required":["RoomArn"],"members":{"RoomArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"SmartHomeAppliances":{"type":"list","member":{"type":"structure","members":{"FriendlyName":{},"Description":{},"ManufacturerName":{}}}},"NextToken":{}}}},"ListTags":{"input":{"type":"structure","required":["Arn"],"members":{"Arn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S2f"},"NextToken":{}}}},"PutConferencePreference":{"input":{"type":"structure","required":["ConferencePreference"],"members":{"ConferencePreference":{"shape":"S46"}}},"output":{"type":"structure","members":{}}},"PutInvitationConfiguration":{"input":{"type":"structure","required":["OrganizationName"],"members":{"OrganizationName":{},"ContactEmail":{},"PrivateSkillIds":{"shape":"S56"}}},"output":{"type":"structure","members":{}}},"PutRoomSkillParameter":{"input":{"type":"structure","required":["SkillId","RoomSkillParameter"],"members":{"RoomArn":{},"SkillId":{},"RoomSkillParameter":{"shape":"S5i"}}},"output":{"type":"structure","members":{}}},"PutSkillAuthorization":{"input":{"type":"structure","required":["AuthorizationResult","SkillId"],"members":{"AuthorizationResult":{"type":"map","key":{},"value":{},"sensitive":true},"SkillId":{},"RoomArn":{}}},"output":{"type":"structure","members":{}}},"RegisterAVSDevice":{"input":{"type":"structure","required":["ClientId","UserCode","ProductId","DeviceSerialNumber","AmazonId"],"members":{"ClientId":{},"UserCode":{},"ProductId":{},"DeviceSerialNumber":{},"AmazonId":{}}},"output":{"type":"structure","members":{"DeviceArn":{}}}},"RejectSkill":{"input":{"type":"structure","required":["SkillId"],"members":{"SkillId":{}}},"output":{"type":"structure","members":{}}},"ResolveRoom":{"input":{"type":"structure","required":["UserId","SkillId"],"members":{"UserId":{},"SkillId":{}}},"output":{"type":"structure","members":{"RoomArn":{},"RoomName":{},"RoomSkillParameters":{"type":"list","member":{"shape":"S5i"}}}}},"RevokeInvitation":{"input":{"type":"structure","members":{"UserArn":{},"EnrollmentId":{}}},"output":{"type":"structure","members":{}}},"SearchAddressBooks":{"input":{"type":"structure","members":{"Filters":{"shape":"S8q"},"SortCriteria":{"shape":"S8v"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AddressBooks":{"type":"list","member":{"type":"structure","members":{"AddressBookArn":{},"Name":{},"Description":{}}}},"NextToken":{},"TotalCount":{"type":"integer"}}}},"SearchContacts":{"input":{"type":"structure","members":{"Filters":{"shape":"S8q"},"SortCriteria":{"shape":"S8v"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Contacts":{"type":"list","member":{"type":"structure","members":{"ContactArn":{},"DisplayName":{},"FirstName":{},"LastName":{},"PhoneNumber":{"shape":"S1c"},"PhoneNumbers":{"shape":"S1d"},"SipAddresses":{"shape":"S1g"}}}},"NextToken":{},"TotalCount":{"type":"integer"}}}},"SearchDevices":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S8q"},"SortCriteria":{"shape":"S8v"}}},"output":{"type":"structure","members":{"Devices":{"type":"list","member":{"type":"structure","members":{"DeviceArn":{},"DeviceSerialNumber":{},"DeviceType":{},"DeviceName":{},"SoftwareVersion":{},"MacAddress":{},"DeviceStatus":{},"NetworkProfileArn":{},"NetworkProfileName":{},"RoomArn":{},"RoomName":{},"DeviceStatusInfo":{"shape":"S4m"}}}},"NextToken":{},"TotalCount":{"type":"integer"}}}},"SearchNetworkProfiles":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S8q"},"SortCriteria":{"shape":"S8v"}}},"output":{"type":"structure","members":{"NetworkProfiles":{"type":"list","member":{"type":"structure","members":{"NetworkProfileArn":{},"NetworkProfileName":{},"Description":{},"Ssid":{},"SecurityType":{},"EapMethod":{},"CertificateAuthorityArn":{}}}},"NextToken":{},"TotalCount":{"type":"integer"}}}},"SearchProfiles":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S8q"},"SortCriteria":{"shape":"S8v"}}},"output":{"type":"structure","members":{"Profiles":{"type":"list","member":{"type":"structure","members":{"ProfileArn":{},"ProfileName":{},"IsDefault":{"type":"boolean"},"Address":{},"Timezone":{},"DistanceUnit":{},"TemperatureUnit":{},"WakeWord":{},"Locale":{}}}},"NextToken":{},"TotalCount":{"type":"integer"}}}},"SearchRooms":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S8q"},"SortCriteria":{"shape":"S8v"}}},"output":{"type":"structure","members":{"Rooms":{"type":"list","member":{"type":"structure","members":{"RoomArn":{},"RoomName":{},"Description":{},"ProviderCalendarId":{},"ProfileArn":{},"ProfileName":{}}}},"NextToken":{},"TotalCount":{"type":"integer"}}}},"SearchSkillGroups":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S8q"},"SortCriteria":{"shape":"S8v"}}},"output":{"type":"structure","members":{"SkillGroups":{"type":"list","member":{"type":"structure","members":{"SkillGroupArn":{},"SkillGroupName":{},"Description":{}}}},"NextToken":{},"TotalCount":{"type":"integer"}}}},"SearchUsers":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S8q"},"SortCriteria":{"shape":"S8v"}}},"output":{"type":"structure","members":{"Users":{"type":"list","member":{"type":"structure","members":{"UserArn":{},"FirstName":{},"LastName":{},"Email":{},"EnrollmentStatus":{},"EnrollmentId":{}}}},"NextToken":{},"TotalCount":{"type":"integer"}}}},"SendAnnouncement":{"input":{"type":"structure","required":["RoomFilters","Content","ClientRequestToken"],"members":{"RoomFilters":{"shape":"S8q"},"Content":{"type":"structure","members":{"TextList":{"type":"list","member":{"type":"structure","required":["Locale","Value"],"members":{"Locale":{},"Value":{}}}},"SsmlList":{"type":"list","member":{"type":"structure","required":["Locale","Value"],"members":{"Locale":{},"Value":{}}}},"AudioList":{"type":"list","member":{"type":"structure","required":["Locale","Location"],"members":{"Locale":{},"Location":{}}}}}},"TimeToLiveInSeconds":{"type":"integer"},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"AnnouncementArn":{}}}},"SendInvitation":{"input":{"type":"structure","members":{"UserArn":{}}},"output":{"type":"structure","members":{}}},"StartDeviceSync":{"input":{"type":"structure","required":["Features"],"members":{"RoomArn":{},"DeviceArn":{},"Features":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"StartSmartHomeApplianceDiscovery":{"input":{"type":"structure","required":["RoomArn"],"members":{"RoomArn":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["Arn","Tags"],"members":{"Arn":{},"Tags":{"shape":"S2f"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["Arn","TagKeys"],"members":{"Arn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAddressBook":{"input":{"type":"structure","required":["AddressBookArn"],"members":{"AddressBookArn":{},"Name":{},"Description":{}}},"output":{"type":"structure","members":{}}},"UpdateBusinessReportSchedule":{"input":{"type":"structure","required":["ScheduleArn"],"members":{"ScheduleArn":{},"S3BucketName":{},"S3KeyPrefix":{},"Format":{},"ScheduleName":{},"Recurrence":{"shape":"St"}}},"output":{"type":"structure","members":{}}},"UpdateConferenceProvider":{"input":{"type":"structure","required":["ConferenceProviderArn","ConferenceProviderType","MeetingSetting"],"members":{"ConferenceProviderArn":{},"ConferenceProviderType":{},"IPDialIn":{"shape":"Sz"},"PSTNDialIn":{"shape":"S12"},"MeetingSetting":{"shape":"S17"}}},"output":{"type":"structure","members":{}}},"UpdateContact":{"input":{"type":"structure","required":["ContactArn"],"members":{"ContactArn":{},"DisplayName":{},"FirstName":{},"LastName":{},"PhoneNumber":{"shape":"S1c"},"PhoneNumbers":{"shape":"S1d"},"SipAddresses":{"shape":"S1g"}}},"output":{"type":"structure","members":{}}},"UpdateDevice":{"input":{"type":"structure","members":{"DeviceArn":{},"DeviceName":{}}},"output":{"type":"structure","members":{}}},"UpdateGateway":{"input":{"type":"structure","required":["GatewayArn"],"members":{"GatewayArn":{},"Name":{},"Description":{},"SoftwareVersion":{}}},"output":{"type":"structure","members":{}}},"UpdateGatewayGroup":{"input":{"type":"structure","required":["GatewayGroupArn"],"members":{"GatewayGroupArn":{},"Name":{},"Description":{}}},"output":{"type":"structure","members":{}}},"UpdateNetworkProfile":{"input":{"type":"structure","required":["NetworkProfileArn"],"members":{"NetworkProfileArn":{},"NetworkProfileName":{},"Description":{},"CurrentPassword":{"shape":"S1v"},"NextPassword":{"shape":"S1w"},"CertificateAuthorityArn":{},"TrustAnchors":{"shape":"S1x"}}},"output":{"type":"structure","members":{}}},"UpdateProfile":{"input":{"type":"structure","members":{"ProfileArn":{},"ProfileName":{},"IsDefault":{"type":"boolean"},"Timezone":{},"Address":{},"DistanceUnit":{},"TemperatureUnit":{},"WakeWord":{},"Locale":{},"SetupModeDisabled":{"type":"boolean"},"MaxVolumeLimit":{"type":"integer"},"PSTNEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"UpdateRoom":{"input":{"type":"structure","members":{"RoomArn":{},"RoomName":{},"Description":{},"ProviderCalendarId":{},"ProfileArn":{}}},"output":{"type":"structure","members":{}}},"UpdateSkillGroup":{"input":{"type":"structure","members":{"SkillGroupArn":{},"SkillGroupName":{},"Description":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sr":{"type":"structure","members":{"Interval":{}}},"St":{"type":"structure","members":{"StartDate":{}}},"Sz":{"type":"structure","required":["Endpoint","CommsProtocol"],"members":{"Endpoint":{},"CommsProtocol":{}}},"S12":{"type":"structure","required":["CountryCode","PhoneNumber","OneClickIdDelay","OneClickPinDelay"],"members":{"CountryCode":{},"PhoneNumber":{},"OneClickIdDelay":{},"OneClickPinDelay":{}}},"S17":{"type":"structure","required":["RequirePin"],"members":{"RequirePin":{}}},"S1c":{"type":"string","sensitive":true},"S1d":{"type":"list","member":{"type":"structure","required":["Number","Type"],"members":{"Number":{"shape":"S1c"},"Type":{"type":"string","sensitive":true}}}},"S1g":{"type":"list","member":{"type":"structure","required":["Uri","Type"],"members":{"Uri":{"type":"string","sensitive":true},"Type":{"type":"string","sensitive":true}}}},"S1v":{"type":"string","sensitive":true},"S1w":{"type":"string","sensitive":true},"S1x":{"type":"list","member":{}},"S2f":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S46":{"type":"structure","members":{"DefaultConferenceProviderArn":{}}},"S49":{"type":"structure","members":{"Arn":{},"Name":{},"Type":{},"IPDialIn":{"shape":"Sz"},"PSTNDialIn":{"shape":"S12"},"MeetingSetting":{"shape":"S17"}}},"S4m":{"type":"structure","members":{"DeviceStatusDetails":{"type":"list","member":{"type":"structure","members":{"Feature":{},"Code":{}}}},"ConnectionStatus":{}}},"S56":{"type":"list","member":{}},"S5i":{"type":"structure","required":["ParameterKey","ParameterValue"],"members":{"ParameterKey":{},"ParameterValue":{}}},"S8q":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}},"S8v":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}}}}');

});

parcelRequire.register("2mflp", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListBusinessReportSchedules":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListConferenceProviders":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDeviceEvents":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListGatewayGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListGateways":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSkills":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSkillsStoreCategories":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSkillsStoreSkillsByCategory":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSmartHomeAppliances":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTags":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"SearchAddressBooks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"SearchContacts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"SearchDevices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"SearchNetworkProfiles":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"SearchProfiles":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"SearchRooms":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"SearchSkillGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"SearchUsers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("j9Dj4", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $df1d59139d7bc06b$var$Service = $dbC7k.Service;
var $df1d59139d7bc06b$var$apiLoader = $dbC7k.apiLoader;
$df1d59139d7bc06b$var$apiLoader.services["cloud9"] = {};
$dbC7k.Cloud9 = $df1d59139d7bc06b$var$Service.defineService("cloud9", [
    "2017-09-23"
]);


Object.defineProperty($df1d59139d7bc06b$var$apiLoader.services["cloud9"], "2017-09-23", {
    get: function get() {
        var model = (parcelRequire("5a8hq"));
        model.paginators = (parcelRequire("jqeWF")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Cloud9;

});
parcelRequire.register("5a8hq", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-09-23","endpointPrefix":"cloud9","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Cloud9","serviceId":"Cloud9","signatureVersion":"v4","targetPrefix":"AWSCloud9WorkspaceManagementService","uid":"cloud9-2017-09-23"},"operations":{"CreateEnvironmentEC2":{"input":{"type":"structure","required":["name","instanceType"],"members":{"name":{},"description":{"shape":"S3"},"clientRequestToken":{},"instanceType":{},"subnetId":{},"automaticStopTimeMinutes":{"type":"integer"},"ownerArn":{}}},"output":{"type":"structure","members":{"environmentId":{}}},"idempotent":true},"CreateEnvironmentMembership":{"input":{"type":"structure","required":["environmentId","userArn","permissions"],"members":{"environmentId":{},"userArn":{},"permissions":{}}},"output":{"type":"structure","members":{"membership":{"shape":"Se"}}},"idempotent":true},"DeleteEnvironment":{"input":{"type":"structure","required":["environmentId"],"members":{"environmentId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteEnvironmentMembership":{"input":{"type":"structure","required":["environmentId","userArn"],"members":{"environmentId":{},"userArn":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DescribeEnvironmentMemberships":{"input":{"type":"structure","members":{"userArn":{},"environmentId":{},"permissions":{"type":"list","member":{}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"memberships":{"type":"list","member":{"shape":"Se"}},"nextToken":{}}}},"DescribeEnvironmentStatus":{"input":{"type":"structure","required":["environmentId"],"members":{"environmentId":{}}},"output":{"type":"structure","members":{"status":{},"message":{}}}},"DescribeEnvironments":{"input":{"type":"structure","required":["environmentIds"],"members":{"environmentIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"environments":{"type":"list","member":{"type":"structure","members":{"id":{},"name":{},"description":{"shape":"S3"},"type":{},"arn":{},"ownerArn":{},"lifecycle":{"type":"structure","members":{"status":{},"reason":{},"failureResource":{}}}}}}}}},"ListEnvironments":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"nextToken":{},"environmentIds":{"type":"list","member":{}}}}},"UpdateEnvironment":{"input":{"type":"structure","required":["environmentId"],"members":{"environmentId":{},"name":{},"description":{"shape":"S3"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateEnvironmentMembership":{"input":{"type":"structure","required":["environmentId","userArn","permissions"],"members":{"environmentId":{},"userArn":{},"permissions":{}}},"output":{"type":"structure","members":{"membership":{"shape":"Se"}}},"idempotent":true}},"shapes":{"S3":{"type":"string","sensitive":true},"Se":{"type":"structure","members":{"permissions":{},"userId":{},"userArn":{},"environmentId":{},"lastAccess":{"type":"timestamp"}}}}}');

});

parcelRequire.register("jqeWF", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeEnvironmentMemberships":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListEnvironments":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}');

});


parcelRequire.register("3zsbm", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $299a8067470ddb63$var$Service = $dbC7k.Service;
var $299a8067470ddb63$var$apiLoader = $dbC7k.apiLoader;
$299a8067470ddb63$var$apiLoader.services["serverlessapplicationrepository"] = {};
$dbC7k.ServerlessApplicationRepository = $299a8067470ddb63$var$Service.defineService("serverlessapplicationrepository", [
    "2017-09-08"
]);


Object.defineProperty($299a8067470ddb63$var$apiLoader.services["serverlessapplicationrepository"], "2017-09-08", {
    get: function get() {
        var model = (parcelRequire("eFjGK"));
        model.paginators = (parcelRequire("iU2u7")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ServerlessApplicationRepository;

});
parcelRequire.register("eFjGK", function(module, exports) {
module.exports = JSON.parse('{"metadata":{"apiVersion":"2017-09-08","endpointPrefix":"serverlessrepo","signingName":"serverlessrepo","serviceFullName":"AWSServerlessApplicationRepository","serviceId":"ServerlessApplicationRepository","protocol":"rest-json","jsonVersion":"1.1","uid":"serverlessrepo-2017-09-08","signatureVersion":"v4"},"operations":{"CreateApplication":{"http":{"requestUri":"/applications","responseCode":201},"input":{"type":"structure","members":{"Author":{"locationName":"author"},"Description":{"locationName":"description"},"HomePageUrl":{"locationName":"homePageUrl"},"Labels":{"shape":"S3","locationName":"labels"},"LicenseBody":{"locationName":"licenseBody"},"LicenseUrl":{"locationName":"licenseUrl"},"Name":{"locationName":"name"},"ReadmeBody":{"locationName":"readmeBody"},"ReadmeUrl":{"locationName":"readmeUrl"},"SemanticVersion":{"locationName":"semanticVersion"},"SourceCodeArchiveUrl":{"locationName":"sourceCodeArchiveUrl"},"SourceCodeUrl":{"locationName":"sourceCodeUrl"},"SpdxLicenseId":{"locationName":"spdxLicenseId"},"TemplateBody":{"locationName":"templateBody"},"TemplateUrl":{"locationName":"templateUrl"}},"required":["Description","Name","Author"]},"output":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"Author":{"locationName":"author"},"CreationTime":{"locationName":"creationTime"},"Description":{"locationName":"description"},"HomePageUrl":{"locationName":"homePageUrl"},"Labels":{"shape":"S3","locationName":"labels"},"LicenseUrl":{"locationName":"licenseUrl"},"Name":{"locationName":"name"},"ReadmeUrl":{"locationName":"readmeUrl"},"SpdxLicenseId":{"locationName":"spdxLicenseId"},"Version":{"shape":"S5","locationName":"version"}}}},"CreateApplicationVersion":{"http":{"method":"PUT","requestUri":"/applications/{applicationId}/versions/{semanticVersion}","responseCode":201},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"},"SemanticVersion":{"location":"uri","locationName":"semanticVersion"},"SourceCodeArchiveUrl":{"locationName":"sourceCodeArchiveUrl"},"SourceCodeUrl":{"locationName":"sourceCodeUrl"},"TemplateBody":{"locationName":"templateBody"},"TemplateUrl":{"locationName":"templateUrl"}},"required":["ApplicationId","SemanticVersion"]},"output":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"CreationTime":{"locationName":"creationTime"},"ParameterDefinitions":{"shape":"S6","locationName":"parameterDefinitions"},"RequiredCapabilities":{"shape":"Sa","locationName":"requiredCapabilities"},"ResourcesSupported":{"locationName":"resourcesSupported","type":"boolean"},"SemanticVersion":{"locationName":"semanticVersion"},"SourceCodeArchiveUrl":{"locationName":"sourceCodeArchiveUrl"},"SourceCodeUrl":{"locationName":"sourceCodeUrl"},"TemplateUrl":{"locationName":"templateUrl"}}}},"CreateCloudFormationChangeSet":{"http":{"requestUri":"/applications/{applicationId}/changesets","responseCode":201},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"},"Capabilities":{"shape":"S3","locationName":"capabilities"},"ChangeSetName":{"locationName":"changeSetName"},"ClientToken":{"locationName":"clientToken"},"Description":{"locationName":"description"},"NotificationArns":{"shape":"S3","locationName":"notificationArns"},"ParameterOverrides":{"locationName":"parameterOverrides","type":"list","member":{"type":"structure","members":{"Name":{"locationName":"name"},"Value":{"locationName":"value"}},"required":["Value","Name"]}},"ResourceTypes":{"shape":"S3","locationName":"resourceTypes"},"RollbackConfiguration":{"locationName":"rollbackConfiguration","type":"structure","members":{"MonitoringTimeInMinutes":{"locationName":"monitoringTimeInMinutes","type":"integer"},"RollbackTriggers":{"locationName":"rollbackTriggers","type":"list","member":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Type":{"locationName":"type"}},"required":["Type","Arn"]}}}},"SemanticVersion":{"locationName":"semanticVersion"},"StackName":{"locationName":"stackName"},"Tags":{"locationName":"tags","type":"list","member":{"type":"structure","members":{"Key":{"locationName":"key"},"Value":{"locationName":"value"}},"required":["Value","Key"]}},"TemplateId":{"locationName":"templateId"}},"required":["ApplicationId","StackName"]},"output":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"ChangeSetId":{"locationName":"changeSetId"},"SemanticVersion":{"locationName":"semanticVersion"},"StackId":{"locationName":"stackId"}}}},"CreateCloudFormationTemplate":{"http":{"requestUri":"/applications/{applicationId}/templates","responseCode":201},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"},"SemanticVersion":{"locationName":"semanticVersion"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"CreationTime":{"locationName":"creationTime"},"ExpirationTime":{"locationName":"expirationTime"},"SemanticVersion":{"locationName":"semanticVersion"},"Status":{"locationName":"status"},"TemplateId":{"locationName":"templateId"},"TemplateUrl":{"locationName":"templateUrl"}}}},"DeleteApplication":{"http":{"method":"DELETE","requestUri":"/applications/{applicationId}","responseCode":204},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"}},"required":["ApplicationId"]}},"GetApplication":{"http":{"method":"GET","requestUri":"/applications/{applicationId}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"},"SemanticVersion":{"location":"querystring","locationName":"semanticVersion"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"Author":{"locationName":"author"},"CreationTime":{"locationName":"creationTime"},"Description":{"locationName":"description"},"HomePageUrl":{"locationName":"homePageUrl"},"Labels":{"shape":"S3","locationName":"labels"},"LicenseUrl":{"locationName":"licenseUrl"},"Name":{"locationName":"name"},"ReadmeUrl":{"locationName":"readmeUrl"},"SpdxLicenseId":{"locationName":"spdxLicenseId"},"Version":{"shape":"S5","locationName":"version"}}}},"GetApplicationPolicy":{"http":{"method":"GET","requestUri":"/applications/{applicationId}/policy","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"Statements":{"shape":"Sv","locationName":"statements"}}}},"GetCloudFormationTemplate":{"http":{"method":"GET","requestUri":"/applications/{applicationId}/templates/{templateId}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"},"TemplateId":{"location":"uri","locationName":"templateId"}},"required":["ApplicationId","TemplateId"]},"output":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"CreationTime":{"locationName":"creationTime"},"ExpirationTime":{"locationName":"expirationTime"},"SemanticVersion":{"locationName":"semanticVersion"},"Status":{"locationName":"status"},"TemplateId":{"locationName":"templateId"},"TemplateUrl":{"locationName":"templateUrl"}}}},"ListApplicationDependencies":{"http":{"method":"GET","requestUri":"/applications/{applicationId}/dependencies","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"},"MaxItems":{"location":"querystring","locationName":"maxItems","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"SemanticVersion":{"location":"querystring","locationName":"semanticVersion"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"Dependencies":{"locationName":"dependencies","type":"list","member":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"SemanticVersion":{"locationName":"semanticVersion"}},"required":["ApplicationId","SemanticVersion"]}},"NextToken":{"locationName":"nextToken"}}}},"ListApplicationVersions":{"http":{"method":"GET","requestUri":"/applications/{applicationId}/versions","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"},"MaxItems":{"location":"querystring","locationName":"maxItems","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Versions":{"locationName":"versions","type":"list","member":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"CreationTime":{"locationName":"creationTime"},"SemanticVersion":{"locationName":"semanticVersion"},"SourceCodeUrl":{"locationName":"sourceCodeUrl"}},"required":["CreationTime","ApplicationId","SemanticVersion"]}}}}},"ListApplications":{"http":{"method":"GET","requestUri":"/applications","responseCode":200},"input":{"type":"structure","members":{"MaxItems":{"location":"querystring","locationName":"maxItems","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Applications":{"locationName":"applications","type":"list","member":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"Author":{"locationName":"author"},"CreationTime":{"locationName":"creationTime"},"Description":{"locationName":"description"},"HomePageUrl":{"locationName":"homePageUrl"},"Labels":{"shape":"S3","locationName":"labels"},"Name":{"locationName":"name"},"SpdxLicenseId":{"locationName":"spdxLicenseId"}},"required":["Description","Author","ApplicationId","Name"]}},"NextToken":{"locationName":"nextToken"}}}},"PutApplicationPolicy":{"http":{"method":"PUT","requestUri":"/applications/{applicationId}/policy","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"},"Statements":{"shape":"Sv","locationName":"statements"}},"required":["ApplicationId","Statements"]},"output":{"type":"structure","members":{"Statements":{"shape":"Sv","locationName":"statements"}}}},"UpdateApplication":{"http":{"method":"PATCH","requestUri":"/applications/{applicationId}","responseCode":200},"input":{"type":"structure","members":{"ApplicationId":{"location":"uri","locationName":"applicationId"},"Author":{"locationName":"author"},"Description":{"locationName":"description"},"HomePageUrl":{"locationName":"homePageUrl"},"Labels":{"shape":"S3","locationName":"labels"},"ReadmeBody":{"locationName":"readmeBody"},"ReadmeUrl":{"locationName":"readmeUrl"}},"required":["ApplicationId"]},"output":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"Author":{"locationName":"author"},"CreationTime":{"locationName":"creationTime"},"Description":{"locationName":"description"},"HomePageUrl":{"locationName":"homePageUrl"},"Labels":{"shape":"S3","locationName":"labels"},"LicenseUrl":{"locationName":"licenseUrl"},"Name":{"locationName":"name"},"ReadmeUrl":{"locationName":"readmeUrl"},"SpdxLicenseId":{"locationName":"spdxLicenseId"},"Version":{"shape":"S5","locationName":"version"}}}}},"shapes":{"S3":{"type":"list","member":{}},"S5":{"type":"structure","members":{"ApplicationId":{"locationName":"applicationId"},"CreationTime":{"locationName":"creationTime"},"ParameterDefinitions":{"shape":"S6","locationName":"parameterDefinitions"},"RequiredCapabilities":{"shape":"Sa","locationName":"requiredCapabilities"},"ResourcesSupported":{"locationName":"resourcesSupported","type":"boolean"},"SemanticVersion":{"locationName":"semanticVersion"},"SourceCodeArchiveUrl":{"locationName":"sourceCodeArchiveUrl"},"SourceCodeUrl":{"locationName":"sourceCodeUrl"},"TemplateUrl":{"locationName":"templateUrl"}},"required":["TemplateUrl","ParameterDefinitions","ResourcesSupported","CreationTime","RequiredCapabilities","ApplicationId","SemanticVersion"]},"S6":{"type":"list","member":{"type":"structure","members":{"AllowedPattern":{"locationName":"allowedPattern"},"AllowedValues":{"shape":"S3","locationName":"allowedValues"},"ConstraintDescription":{"locationName":"constraintDescription"},"DefaultValue":{"locationName":"defaultValue"},"Description":{"locationName":"description"},"MaxLength":{"locationName":"maxLength","type":"integer"},"MaxValue":{"locationName":"maxValue","type":"integer"},"MinLength":{"locationName":"minLength","type":"integer"},"MinValue":{"locationName":"minValue","type":"integer"},"Name":{"locationName":"name"},"NoEcho":{"locationName":"noEcho","type":"boolean"},"ReferencedByResources":{"shape":"S3","locationName":"referencedByResources"},"Type":{"locationName":"type"}},"required":["ReferencedByResources","Name"]}},"Sa":{"type":"list","member":{}},"Sv":{"type":"list","member":{"type":"structure","members":{"Actions":{"shape":"S3","locationName":"actions"},"Principals":{"shape":"S3","locationName":"principals"},"StatementId":{"locationName":"statementId"}},"required":["Principals","Actions"]}}}}');

});

parcelRequire.register("iU2u7", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListApplicationVersions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxItems"},"ListApplications":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxItems"},"ListApplicationDependencies":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxItems"}}}');

});


parcelRequire.register("x3czj", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $063590f9f3dfd1eb$var$Service = $dbC7k.Service;
var $063590f9f3dfd1eb$var$apiLoader = $dbC7k.apiLoader;
$063590f9f3dfd1eb$var$apiLoader.services["servicediscovery"] = {};
$dbC7k.ServiceDiscovery = $063590f9f3dfd1eb$var$Service.defineService("servicediscovery", [
    "2017-03-14"
]);


Object.defineProperty($063590f9f3dfd1eb$var$apiLoader.services["servicediscovery"], "2017-03-14", {
    get: function get() {
        var model = (parcelRequire("84v1U"));
        model.paginators = (parcelRequire("1AqMu")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ServiceDiscovery;

});
parcelRequire.register("84v1U", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-03-14","endpointPrefix":"servicediscovery","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"ServiceDiscovery","serviceFullName":"AWS Cloud Map","serviceId":"ServiceDiscovery","signatureVersion":"v4","targetPrefix":"Route53AutoNaming_v20170314","uid":"servicediscovery-2017-03-14"},"operations":{"CreateHttpNamespace":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"CreatorRequestId":{"idempotencyToken":true},"Description":{}}},"output":{"type":"structure","members":{"OperationId":{}}}},"CreatePrivateDnsNamespace":{"input":{"type":"structure","required":["Name","Vpc"],"members":{"Name":{},"CreatorRequestId":{"idempotencyToken":true},"Description":{},"Vpc":{}}},"output":{"type":"structure","members":{"OperationId":{}}}},"CreatePublicDnsNamespace":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"CreatorRequestId":{"idempotencyToken":true},"Description":{}}},"output":{"type":"structure","members":{"OperationId":{}}}},"CreateService":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"NamespaceId":{},"CreatorRequestId":{"idempotencyToken":true},"Description":{},"DnsConfig":{"shape":"Sd"},"HealthCheckConfig":{"shape":"Sj"},"HealthCheckCustomConfig":{"shape":"Sn"}}},"output":{"type":"structure","members":{"Service":{"shape":"Sp"}}}},"DeleteNamespace":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{"OperationId":{}}}},"DeleteService":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{}}},"DeregisterInstance":{"input":{"type":"structure","required":["ServiceId","InstanceId"],"members":{"ServiceId":{},"InstanceId":{}}},"output":{"type":"structure","members":{"OperationId":{}}}},"DiscoverInstances":{"input":{"type":"structure","required":["NamespaceName","ServiceName"],"members":{"NamespaceName":{},"ServiceName":{},"MaxResults":{"type":"integer"},"QueryParameters":{"shape":"S11"},"HealthStatus":{}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"NamespaceName":{},"ServiceName":{},"HealthStatus":{},"Attributes":{"shape":"S11"}}}}}},"endpoint":{"hostPrefix":"data-"}},"GetInstance":{"input":{"type":"structure","required":["ServiceId","InstanceId"],"members":{"ServiceId":{},"InstanceId":{}}},"output":{"type":"structure","members":{"Instance":{"type":"structure","required":["Id"],"members":{"Id":{},"CreatorRequestId":{},"Attributes":{"shape":"S11"}}}}}},"GetInstancesHealthStatus":{"input":{"type":"structure","required":["ServiceId"],"members":{"ServiceId":{},"Instances":{"type":"list","member":{}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Status":{"type":"map","key":{},"value":{}},"NextToken":{}}}},"GetNamespace":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{"Namespace":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Type":{},"Description":{},"ServiceCount":{"type":"integer"},"Properties":{"shape":"S1l"},"CreateDate":{"type":"timestamp"},"CreatorRequestId":{}}}}}},"GetOperation":{"input":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}},"output":{"type":"structure","members":{"Operation":{"type":"structure","members":{"Id":{},"Type":{},"Status":{},"ErrorMessage":{},"ErrorCode":{},"CreateDate":{"type":"timestamp"},"UpdateDate":{"type":"timestamp"},"Targets":{"type":"map","key":{},"value":{}}}}}}},"GetService":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{"Service":{"shape":"Sp"}}}},"ListInstances":{"input":{"type":"structure","required":["ServiceId"],"members":{"ServiceId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"Id":{},"Attributes":{"shape":"S11"}}}},"NextToken":{}}}},"ListNamespaces":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"shape":"S27"},"Condition":{}}}}}},"output":{"type":"structure","members":{"Namespaces":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Type":{},"Description":{},"ServiceCount":{"type":"integer"},"Properties":{"shape":"S1l"},"CreateDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListOperations":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"shape":"S27"},"Condition":{}}}}}},"output":{"type":"structure","members":{"Operations":{"type":"list","member":{"type":"structure","members":{"Id":{},"Status":{}}}},"NextToken":{}}}},"ListServices":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"shape":"S27"},"Condition":{}}}}}},"output":{"type":"structure","members":{"Services":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Description":{},"InstanceCount":{"type":"integer"},"DnsConfig":{"shape":"Sd"},"HealthCheckConfig":{"shape":"Sj"},"HealthCheckCustomConfig":{"shape":"Sn"},"CreateDate":{"type":"timestamp"}}}},"NextToken":{}}}},"RegisterInstance":{"input":{"type":"structure","required":["ServiceId","InstanceId","Attributes"],"members":{"ServiceId":{},"InstanceId":{},"CreatorRequestId":{"idempotencyToken":true},"Attributes":{"shape":"S11"}}},"output":{"type":"structure","members":{"OperationId":{}}}},"UpdateInstanceCustomHealthStatus":{"input":{"type":"structure","required":["ServiceId","InstanceId","Status"],"members":{"ServiceId":{},"InstanceId":{},"Status":{}}}},"UpdateService":{"input":{"type":"structure","required":["Id","Service"],"members":{"Id":{},"Service":{"type":"structure","required":["DnsConfig"],"members":{"Description":{},"DnsConfig":{"type":"structure","required":["DnsRecords"],"members":{"DnsRecords":{"shape":"Sf"}}},"HealthCheckConfig":{"shape":"Sj"}}}}},"output":{"type":"structure","members":{"OperationId":{}}}}},"shapes":{"Sd":{"type":"structure","required":["DnsRecords"],"members":{"NamespaceId":{"deprecated":true,"deprecatedMessage":"Top level attribute in request should be used to reference namespace-id"},"RoutingPolicy":{},"DnsRecords":{"shape":"Sf"}}},"Sf":{"type":"list","member":{"type":"structure","required":["Type","TTL"],"members":{"Type":{},"TTL":{"type":"long"}}}},"Sj":{"type":"structure","required":["Type"],"members":{"Type":{},"ResourcePath":{},"FailureThreshold":{"type":"integer"}}},"Sn":{"type":"structure","members":{"FailureThreshold":{"type":"integer"}}},"Sp":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"NamespaceId":{},"Description":{},"InstanceCount":{"type":"integer"},"DnsConfig":{"shape":"Sd"},"HealthCheckConfig":{"shape":"Sj"},"HealthCheckCustomConfig":{"shape":"Sn"},"CreateDate":{"type":"timestamp"},"CreatorRequestId":{}}},"S11":{"type":"map","key":{},"value":{}},"S1l":{"type":"structure","members":{"DnsProperties":{"type":"structure","members":{"HostedZoneId":{}}},"HttpProperties":{"type":"structure","members":{"HttpName":{}}}}},"S27":{"type":"list","member":{}}}}');

});

parcelRequire.register("1AqMu", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"GetInstancesHealthStatus":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListInstances":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListNamespaces":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListOperations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListServices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("86pyA", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $5e62b55877c7b16a$var$Service = $dbC7k.Service;
var $5e62b55877c7b16a$var$apiLoader = $dbC7k.apiLoader;
$5e62b55877c7b16a$var$apiLoader.services["workmail"] = {};
$dbC7k.WorkMail = $5e62b55877c7b16a$var$Service.defineService("workmail", [
    "2017-10-01"
]);


Object.defineProperty($5e62b55877c7b16a$var$apiLoader.services["workmail"], "2017-10-01", {
    get: function get() {
        var model = (parcelRequire("fxov8"));
        model.paginators = (parcelRequire("cEj0W")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.WorkMail;

});
parcelRequire.register("fxov8", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-10-01","endpointPrefix":"workmail","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon WorkMail","serviceId":"WorkMail","signatureVersion":"v4","targetPrefix":"WorkMailService","uid":"workmail-2017-10-01"},"operations":{"AssociateDelegateToResource":{"input":{"type":"structure","required":["OrganizationId","ResourceId","EntityId"],"members":{"OrganizationId":{},"ResourceId":{},"EntityId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"AssociateMemberToGroup":{"input":{"type":"structure","required":["OrganizationId","GroupId","MemberId"],"members":{"OrganizationId":{},"GroupId":{},"MemberId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"CreateAlias":{"input":{"type":"structure","required":["OrganizationId","EntityId","Alias"],"members":{"OrganizationId":{},"EntityId":{},"Alias":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"CreateGroup":{"input":{"type":"structure","required":["OrganizationId","Name"],"members":{"OrganizationId":{},"Name":{}}},"output":{"type":"structure","members":{"GroupId":{}}},"idempotent":true},"CreateResource":{"input":{"type":"structure","required":["OrganizationId","Name","Type"],"members":{"OrganizationId":{},"Name":{},"Type":{}}},"output":{"type":"structure","members":{"ResourceId":{}}},"idempotent":true},"CreateUser":{"input":{"type":"structure","required":["OrganizationId","Name","DisplayName","Password"],"members":{"OrganizationId":{},"Name":{},"DisplayName":{},"Password":{"shape":"Sl"}}},"output":{"type":"structure","members":{"UserId":{}}},"idempotent":true},"DeleteAlias":{"input":{"type":"structure","required":["OrganizationId","EntityId","Alias"],"members":{"OrganizationId":{},"EntityId":{},"Alias":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteGroup":{"input":{"type":"structure","required":["OrganizationId","GroupId"],"members":{"OrganizationId":{},"GroupId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteMailboxPermissions":{"input":{"type":"structure","required":["OrganizationId","EntityId","GranteeId"],"members":{"OrganizationId":{},"EntityId":{},"GranteeId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteResource":{"input":{"type":"structure","required":["OrganizationId","ResourceId"],"members":{"OrganizationId":{},"ResourceId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteUser":{"input":{"type":"structure","required":["OrganizationId","UserId"],"members":{"OrganizationId":{},"UserId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeregisterFromWorkMail":{"input":{"type":"structure","required":["OrganizationId","EntityId"],"members":{"OrganizationId":{},"EntityId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DescribeGroup":{"input":{"type":"structure","required":["OrganizationId","GroupId"],"members":{"OrganizationId":{},"GroupId":{}}},"output":{"type":"structure","members":{"GroupId":{},"Name":{},"Email":{},"State":{},"EnabledDate":{"type":"timestamp"},"DisabledDate":{"type":"timestamp"}}},"idempotent":true},"DescribeOrganization":{"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{}}},"output":{"type":"structure","members":{"OrganizationId":{},"Alias":{},"State":{},"DirectoryId":{},"DirectoryType":{},"DefaultMailDomain":{},"CompletedDate":{"type":"timestamp"},"ErrorMessage":{}}},"idempotent":true},"DescribeResource":{"input":{"type":"structure","required":["OrganizationId","ResourceId"],"members":{"OrganizationId":{},"ResourceId":{}}},"output":{"type":"structure","members":{"ResourceId":{},"Email":{},"Name":{},"Type":{},"BookingOptions":{"shape":"S18"},"State":{},"EnabledDate":{"type":"timestamp"},"DisabledDate":{"type":"timestamp"}}},"idempotent":true},"DescribeUser":{"input":{"type":"structure","required":["OrganizationId","UserId"],"members":{"OrganizationId":{},"UserId":{}}},"output":{"type":"structure","members":{"UserId":{},"Name":{},"Email":{},"DisplayName":{},"State":{},"UserRole":{},"EnabledDate":{"type":"timestamp"},"DisabledDate":{"type":"timestamp"}}},"idempotent":true},"DisassociateDelegateFromResource":{"input":{"type":"structure","required":["OrganizationId","ResourceId","EntityId"],"members":{"OrganizationId":{},"ResourceId":{},"EntityId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DisassociateMemberFromGroup":{"input":{"type":"structure","required":["OrganizationId","GroupId","MemberId"],"members":{"OrganizationId":{},"GroupId":{},"MemberId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"GetMailboxDetails":{"input":{"type":"structure","required":["OrganizationId","UserId"],"members":{"OrganizationId":{},"UserId":{}}},"output":{"type":"structure","members":{"MailboxQuota":{"type":"integer"},"MailboxSize":{"type":"double"}}},"idempotent":true},"ListAliases":{"input":{"type":"structure","required":["OrganizationId","EntityId"],"members":{"OrganizationId":{},"EntityId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Aliases":{"type":"list","member":{}},"NextToken":{}}},"idempotent":true},"ListGroupMembers":{"input":{"type":"structure","required":["OrganizationId","GroupId"],"members":{"OrganizationId":{},"GroupId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Members":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Type":{},"State":{},"EnabledDate":{"type":"timestamp"},"DisabledDate":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListGroups":{"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Groups":{"type":"list","member":{"type":"structure","members":{"Id":{},"Email":{},"Name":{},"State":{},"EnabledDate":{"type":"timestamp"},"DisabledDate":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListMailboxPermissions":{"input":{"type":"structure","required":["OrganizationId","EntityId"],"members":{"OrganizationId":{},"EntityId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Permissions":{"type":"list","member":{"type":"structure","required":["GranteeId","GranteeType","PermissionValues"],"members":{"GranteeId":{},"GranteeType":{},"PermissionValues":{"shape":"S23"}}}},"NextToken":{}}},"idempotent":true},"ListOrganizations":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"OrganizationSummaries":{"type":"list","member":{"type":"structure","members":{"OrganizationId":{},"Alias":{},"ErrorMessage":{},"State":{}}}},"NextToken":{}}},"idempotent":true},"ListResourceDelegates":{"input":{"type":"structure","required":["OrganizationId","ResourceId"],"members":{"OrganizationId":{},"ResourceId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Delegates":{"type":"list","member":{"type":"structure","required":["Id","Type"],"members":{"Id":{},"Type":{}}}},"NextToken":{}}},"idempotent":true},"ListResources":{"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Resources":{"type":"list","member":{"type":"structure","members":{"Id":{},"Email":{},"Name":{},"Type":{},"State":{},"EnabledDate":{"type":"timestamp"},"DisabledDate":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListUsers":{"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Users":{"type":"list","member":{"type":"structure","members":{"Id":{},"Email":{},"Name":{},"DisplayName":{},"State":{},"UserRole":{},"EnabledDate":{"type":"timestamp"},"DisabledDate":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"PutMailboxPermissions":{"input":{"type":"structure","required":["OrganizationId","EntityId","GranteeId","PermissionValues"],"members":{"OrganizationId":{},"EntityId":{},"GranteeId":{},"PermissionValues":{"shape":"S23"}}},"output":{"type":"structure","members":{}},"idempotent":true},"RegisterToWorkMail":{"input":{"type":"structure","required":["OrganizationId","EntityId","Email"],"members":{"OrganizationId":{},"EntityId":{},"Email":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"ResetPassword":{"input":{"type":"structure","required":["OrganizationId","UserId","Password"],"members":{"OrganizationId":{},"UserId":{},"Password":{"shape":"Sl"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateMailboxQuota":{"input":{"type":"structure","required":["OrganizationId","UserId","MailboxQuota"],"members":{"OrganizationId":{},"UserId":{},"MailboxQuota":{"type":"integer"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdatePrimaryEmailAddress":{"input":{"type":"structure","required":["OrganizationId","EntityId","Email"],"members":{"OrganizationId":{},"EntityId":{},"Email":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateResource":{"input":{"type":"structure","required":["OrganizationId","ResourceId"],"members":{"OrganizationId":{},"ResourceId":{},"Name":{},"BookingOptions":{"shape":"S18"}}},"output":{"type":"structure","members":{}},"idempotent":true}},"shapes":{"Sl":{"type":"string","sensitive":true},"S18":{"type":"structure","members":{"AutoAcceptRequests":{"type":"boolean"},"AutoDeclineRecurringRequests":{"type":"boolean"},"AutoDeclineConflictingRequests":{"type":"boolean"}}},"S23":{"type":"list","member":{}}}}');

});

parcelRequire.register("cEj0W", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListAliases":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListGroupMembers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListMailboxPermissions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListOrganizations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListResourceDelegates":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListResources":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListUsers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("l4KIK", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $f57e367a858d456a$var$Service = $dbC7k.Service;
var $f57e367a858d456a$var$apiLoader = $dbC7k.apiLoader;
$f57e367a858d456a$var$apiLoader.services["autoscalingplans"] = {};
$dbC7k.AutoScalingPlans = $f57e367a858d456a$var$Service.defineService("autoscalingplans", [
    "2018-01-06"
]);


Object.defineProperty($f57e367a858d456a$var$apiLoader.services["autoscalingplans"], "2018-01-06", {
    get: function get() {
        var model = (parcelRequire("8lJ69"));
        model.paginators = (parcelRequire("79E6T")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.AutoScalingPlans;

});
parcelRequire.register("8lJ69", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-01-06","endpointPrefix":"autoscaling","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Auto Scaling Plans","serviceId":"Auto Scaling Plans","signatureVersion":"v4","signingName":"autoscaling-plans","targetPrefix":"AnyScaleScalingPlannerFrontendService","uid":"autoscaling-plans-2018-01-06"},"operations":{"CreateScalingPlan":{"input":{"type":"structure","required":["ScalingPlanName","ApplicationSource","ScalingInstructions"],"members":{"ScalingPlanName":{},"ApplicationSource":{"shape":"S3"},"ScalingInstructions":{"shape":"Sa"}}},"output":{"type":"structure","required":["ScalingPlanVersion"],"members":{"ScalingPlanVersion":{"type":"long"}}}},"DeleteScalingPlan":{"input":{"type":"structure","required":["ScalingPlanName","ScalingPlanVersion"],"members":{"ScalingPlanName":{},"ScalingPlanVersion":{"type":"long"}}},"output":{"type":"structure","members":{}}},"DescribeScalingPlanResources":{"input":{"type":"structure","required":["ScalingPlanName","ScalingPlanVersion"],"members":{"ScalingPlanName":{},"ScalingPlanVersion":{"type":"long"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalingPlanResources":{"type":"list","member":{"type":"structure","required":["ScalingPlanName","ScalingPlanVersion","ServiceNamespace","ResourceId","ScalableDimension","ScalingStatusCode"],"members":{"ScalingPlanName":{},"ScalingPlanVersion":{"type":"long"},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"ScalingPolicies":{"type":"list","member":{"type":"structure","required":["PolicyName","PolicyType"],"members":{"PolicyName":{},"PolicyType":{},"TargetTrackingConfiguration":{"shape":"Sh"}}}},"ScalingStatusCode":{},"ScalingStatusMessage":{}}}},"NextToken":{}}}},"DescribeScalingPlans":{"input":{"type":"structure","members":{"ScalingPlanNames":{"type":"list","member":{}},"ScalingPlanVersion":{"type":"long"},"ApplicationSources":{"type":"list","member":{"shape":"S3"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalingPlans":{"type":"list","member":{"type":"structure","required":["ScalingPlanName","ScalingPlanVersion","ApplicationSource","ScalingInstructions","StatusCode"],"members":{"ScalingPlanName":{},"ScalingPlanVersion":{"type":"long"},"ApplicationSource":{"shape":"S3"},"ScalingInstructions":{"shape":"Sa"},"StatusCode":{},"StatusMessage":{},"StatusStartTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"GetScalingPlanResourceForecastData":{"input":{"type":"structure","required":["ScalingPlanName","ScalingPlanVersion","ServiceNamespace","ResourceId","ScalableDimension","ForecastDataType","StartTime","EndTime"],"members":{"ScalingPlanName":{},"ScalingPlanVersion":{"type":"long"},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"ForecastDataType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"output":{"type":"structure","required":["Datapoints"],"members":{"Datapoints":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"timestamp"},"Value":{"type":"double"}}}}}}},"UpdateScalingPlan":{"input":{"type":"structure","required":["ScalingPlanName","ScalingPlanVersion"],"members":{"ScalingPlanName":{},"ScalingPlanVersion":{"type":"long"},"ApplicationSource":{"shape":"S3"},"ScalingInstructions":{"shape":"Sa"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S3":{"type":"structure","members":{"CloudFormationStackARN":{},"TagFilters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}}}},"Sa":{"type":"list","member":{"type":"structure","required":["ServiceNamespace","ResourceId","ScalableDimension","MinCapacity","MaxCapacity","TargetTrackingConfigurations"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"TargetTrackingConfigurations":{"type":"list","member":{"shape":"Sh"}},"PredefinedLoadMetricSpecification":{"type":"structure","required":["PredefinedLoadMetricType"],"members":{"PredefinedLoadMetricType":{},"ResourceLabel":{}}},"CustomizedLoadMetricSpecification":{"type":"structure","required":["MetricName","Namespace","Statistic"],"members":{"MetricName":{},"Namespace":{},"Dimensions":{"shape":"So"},"Statistic":{},"Unit":{}}},"ScheduledActionBufferTime":{"type":"integer"},"PredictiveScalingMaxCapacityBehavior":{},"PredictiveScalingMaxCapacityBuffer":{"type":"integer"},"PredictiveScalingMode":{},"ScalingPolicyUpdateBehavior":{},"DisableDynamicScaling":{"type":"boolean"}}}},"Sh":{"type":"structure","required":["TargetValue"],"members":{"PredefinedScalingMetricSpecification":{"type":"structure","required":["PredefinedScalingMetricType"],"members":{"PredefinedScalingMetricType":{},"ResourceLabel":{}}},"CustomizedScalingMetricSpecification":{"type":"structure","required":["MetricName","Namespace","Statistic"],"members":{"MetricName":{},"Namespace":{},"Dimensions":{"shape":"So"},"Statistic":{},"Unit":{}}},"TargetValue":{"type":"double"},"DisableScaleIn":{"type":"boolean"},"ScaleOutCooldown":{"type":"integer"},"ScaleInCooldown":{"type":"integer"},"EstimatedInstanceWarmup":{"type":"integer"}}},"So":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}}}}');

});

parcelRequire.register("79E6T", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("dwg5e", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $9d7abd5bb87cb8c9$var$Service = $dbC7k.Service;
var $9d7abd5bb87cb8c9$var$apiLoader = $dbC7k.apiLoader;
$9d7abd5bb87cb8c9$var$apiLoader.services["transcribeservice"] = {};
$dbC7k.TranscribeService = $9d7abd5bb87cb8c9$var$Service.defineService("transcribeservice", [
    "2017-10-26"
]);


Object.defineProperty($9d7abd5bb87cb8c9$var$apiLoader.services["transcribeservice"], "2017-10-26", {
    get: function get() {
        var model = (parcelRequire("4OUW0"));
        model.paginators = (parcelRequire("g9vno")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.TranscribeService;

});
parcelRequire.register("4OUW0", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-10-26","endpointPrefix":"transcribe","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Transcribe Service","serviceId":"Transcribe","signatureVersion":"v4","signingName":"transcribe","targetPrefix":"Transcribe","uid":"transcribe-2017-10-26"},"operations":{"CreateVocabulary":{"input":{"type":"structure","required":["VocabularyName","LanguageCode"],"members":{"VocabularyName":{},"LanguageCode":{},"Phrases":{"shape":"S4"},"VocabularyFileUri":{}}},"output":{"type":"structure","members":{"VocabularyName":{},"LanguageCode":{},"VocabularyState":{},"LastModifiedTime":{"type":"timestamp"},"FailureReason":{}}}},"DeleteTranscriptionJob":{"input":{"type":"structure","required":["TranscriptionJobName"],"members":{"TranscriptionJobName":{}}}},"DeleteVocabulary":{"input":{"type":"structure","required":["VocabularyName"],"members":{"VocabularyName":{}}}},"GetTranscriptionJob":{"input":{"type":"structure","required":["TranscriptionJobName"],"members":{"TranscriptionJobName":{}}},"output":{"type":"structure","members":{"TranscriptionJob":{"shape":"Sg"}}}},"GetVocabulary":{"input":{"type":"structure","required":["VocabularyName"],"members":{"VocabularyName":{}}},"output":{"type":"structure","members":{"VocabularyName":{},"LanguageCode":{},"VocabularyState":{},"LastModifiedTime":{"type":"timestamp"},"FailureReason":{},"DownloadUri":{}}}},"ListTranscriptionJobs":{"input":{"type":"structure","members":{"Status":{},"JobNameContains":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Status":{},"NextToken":{},"TranscriptionJobSummaries":{"type":"list","member":{"type":"structure","members":{"TranscriptionJobName":{},"CreationTime":{"type":"timestamp"},"CompletionTime":{"type":"timestamp"},"LanguageCode":{},"TranscriptionJobStatus":{},"FailureReason":{},"OutputLocationType":{}}}}}}},"ListVocabularies":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"StateEquals":{},"NameContains":{}}},"output":{"type":"structure","members":{"Status":{},"NextToken":{},"Vocabularies":{"type":"list","member":{"type":"structure","members":{"VocabularyName":{},"LanguageCode":{},"LastModifiedTime":{"type":"timestamp"},"VocabularyState":{}}}}}}},"StartTranscriptionJob":{"input":{"type":"structure","required":["TranscriptionJobName","LanguageCode","MediaFormat","Media"],"members":{"TranscriptionJobName":{},"LanguageCode":{},"MediaSampleRateHertz":{"type":"integer"},"MediaFormat":{},"Media":{"shape":"Sk"},"OutputBucketName":{},"Settings":{"shape":"Sm"}}},"output":{"type":"structure","members":{"TranscriptionJob":{"shape":"Sg"}}}},"UpdateVocabulary":{"input":{"type":"structure","required":["VocabularyName","LanguageCode"],"members":{"VocabularyName":{},"LanguageCode":{},"Phrases":{"shape":"S4"},"VocabularyFileUri":{}}},"output":{"type":"structure","members":{"VocabularyName":{},"LanguageCode":{},"LastModifiedTime":{"type":"timestamp"},"VocabularyState":{}}}}},"shapes":{"S4":{"type":"list","member":{}},"Sg":{"type":"structure","members":{"TranscriptionJobName":{},"TranscriptionJobStatus":{},"LanguageCode":{},"MediaSampleRateHertz":{"type":"integer"},"MediaFormat":{},"Media":{"shape":"Sk"},"Transcript":{"type":"structure","members":{"TranscriptFileUri":{}}},"CreationTime":{"type":"timestamp"},"CompletionTime":{"type":"timestamp"},"FailureReason":{},"Settings":{"shape":"Sm"}}},"Sk":{"type":"structure","members":{"MediaFileUri":{}}},"Sm":{"type":"structure","members":{"VocabularyName":{},"ShowSpeakerLabels":{"type":"boolean"},"MaxSpeakerLabels":{"type":"integer"},"ChannelIdentification":{"type":"boolean"}}}}}');

});

parcelRequire.register("g9vno", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListTranscriptionJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListVocabularies":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("bkZtL", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $84114072149cbab0$var$Service = $dbC7k.Service;
var $84114072149cbab0$var$apiLoader = $dbC7k.apiLoader;
$84114072149cbab0$var$apiLoader.services["connect"] = {};
$dbC7k.Connect = $84114072149cbab0$var$Service.defineService("connect", [
    "2017-08-08"
]);


Object.defineProperty($84114072149cbab0$var$apiLoader.services["connect"], "2017-08-08", {
    get: function get() {
        var model = (parcelRequire("7NSES"));
        model.paginators = (parcelRequire("4HKzc")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Connect;

});
parcelRequire.register("7NSES", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-08-08","endpointPrefix":"connect","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Amazon Connect","serviceFullName":"Amazon Connect Service","serviceId":"Connect","signatureVersion":"v4","signingName":"connect","uid":"connect-2017-08-08"},"operations":{"CreateUser":{"http":{"method":"PUT","requestUri":"/users/{InstanceId}"},"input":{"type":"structure","required":["Username","PhoneConfig","SecurityProfileIds","RoutingProfileId","InstanceId"],"members":{"Username":{},"Password":{},"IdentityInfo":{"shape":"S4"},"PhoneConfig":{"shape":"S8"},"DirectoryUserId":{},"SecurityProfileIds":{"shape":"Se"},"RoutingProfileId":{},"HierarchyGroupId":{},"InstanceId":{"location":"uri","locationName":"InstanceId"}}},"output":{"type":"structure","members":{"UserId":{},"UserArn":{}}}},"DeleteUser":{"http":{"method":"DELETE","requestUri":"/users/{InstanceId}/{UserId}"},"input":{"type":"structure","required":["InstanceId","UserId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"UserId":{"location":"uri","locationName":"UserId"}}}},"DescribeUser":{"http":{"method":"GET","requestUri":"/users/{InstanceId}/{UserId}"},"input":{"type":"structure","required":["UserId","InstanceId"],"members":{"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}},"output":{"type":"structure","members":{"User":{"type":"structure","members":{"Id":{},"Arn":{},"Username":{},"IdentityInfo":{"shape":"S4"},"PhoneConfig":{"shape":"S8"},"DirectoryUserId":{},"SecurityProfileIds":{"shape":"Se"},"RoutingProfileId":{},"HierarchyGroupId":{}}}}}},"DescribeUserHierarchyGroup":{"http":{"method":"GET","requestUri":"/user-hierarchy-groups/{InstanceId}/{HierarchyGroupId}"},"input":{"type":"structure","required":["HierarchyGroupId","InstanceId"],"members":{"HierarchyGroupId":{"location":"uri","locationName":"HierarchyGroupId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}},"output":{"type":"structure","members":{"HierarchyGroup":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"LevelId":{},"HierarchyPath":{"type":"structure","members":{"LevelOne":{"shape":"Sw"},"LevelTwo":{"shape":"Sw"},"LevelThree":{"shape":"Sw"},"LevelFour":{"shape":"Sw"},"LevelFive":{"shape":"Sw"}}}}}}}},"DescribeUserHierarchyStructure":{"http":{"method":"GET","requestUri":"/user-hierarchy-structure/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"}}},"output":{"type":"structure","members":{"HierarchyStructure":{"type":"structure","members":{"LevelOne":{"shape":"S10"},"LevelTwo":{"shape":"S10"},"LevelThree":{"shape":"S10"},"LevelFour":{"shape":"S10"},"LevelFive":{"shape":"S10"}}}}}},"GetContactAttributes":{"http":{"method":"GET","requestUri":"/contact/attributes/{InstanceId}/{InitialContactId}"},"input":{"type":"structure","required":["InstanceId","InitialContactId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"InitialContactId":{"location":"uri","locationName":"InitialContactId"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S15"}}}},"GetCurrentMetricData":{"http":{"requestUri":"/metrics/current/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Filters","CurrentMetrics"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Filters":{"shape":"S19"},"Groupings":{"shape":"S1e"},"CurrentMetrics":{"type":"list","member":{"shape":"S1h"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"MetricResults":{"type":"list","member":{"type":"structure","members":{"Dimensions":{"shape":"S1p"},"Collections":{"type":"list","member":{"type":"structure","members":{"Metric":{"shape":"S1h"},"Value":{"type":"double"}}}}}}},"DataSnapshotTime":{"type":"timestamp"}}}},"GetFederationToken":{"http":{"method":"GET","requestUri":"/user/federate/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"}}},"output":{"type":"structure","members":{"Credentials":{"type":"structure","members":{"AccessToken":{"shape":"S1y"},"AccessTokenExpiration":{"type":"timestamp"},"RefreshToken":{"shape":"S1y"},"RefreshTokenExpiration":{"type":"timestamp"}}}}}},"GetMetricData":{"http":{"requestUri":"/metrics/historical/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","StartTime","EndTime","Filters","HistoricalMetrics"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Filters":{"shape":"S19"},"Groupings":{"shape":"S1e"},"HistoricalMetrics":{"type":"list","member":{"shape":"S21"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"MetricResults":{"type":"list","member":{"type":"structure","members":{"Dimensions":{"shape":"S1p"},"Collections":{"type":"list","member":{"type":"structure","members":{"Metric":{"shape":"S21"},"Value":{"type":"double"}}}}}}}}}},"ListRoutingProfiles":{"http":{"method":"GET","requestUri":"/routing-profiles-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"RoutingProfileSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{}}}},"NextToken":{}}}},"ListSecurityProfiles":{"http":{"method":"GET","requestUri":"/security-profiles-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"SecurityProfileSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{}}}},"NextToken":{}}}},"ListUserHierarchyGroups":{"http":{"method":"GET","requestUri":"/user-hierarchy-groups-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"UserHierarchyGroupSummaryList":{"type":"list","member":{"shape":"Sw"}},"NextToken":{}}}},"ListUsers":{"http":{"method":"GET","requestUri":"/users-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"UserSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Username":{}}}},"NextToken":{}}}},"StartOutboundVoiceContact":{"http":{"method":"PUT","requestUri":"/contact/outbound-voice"},"input":{"type":"structure","required":["DestinationPhoneNumber","ContactFlowId","InstanceId"],"members":{"DestinationPhoneNumber":{},"ContactFlowId":{},"InstanceId":{},"ClientToken":{"idempotencyToken":true},"SourcePhoneNumber":{},"QueueId":{},"Attributes":{"shape":"S15"}}},"output":{"type":"structure","members":{"ContactId":{}}}},"StopContact":{"http":{"requestUri":"/contact/stop"},"input":{"type":"structure","required":["ContactId","InstanceId"],"members":{"ContactId":{},"InstanceId":{}}},"output":{"type":"structure","members":{}}},"UpdateContactAttributes":{"http":{"requestUri":"/contact/attributes"},"input":{"type":"structure","required":["InitialContactId","InstanceId","Attributes"],"members":{"InitialContactId":{},"InstanceId":{},"Attributes":{"shape":"S15"}}},"output":{"type":"structure","members":{}}},"UpdateUserHierarchy":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/hierarchy"},"input":{"type":"structure","required":["UserId","InstanceId"],"members":{"HierarchyGroupId":{},"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateUserIdentityInfo":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/identity-info"},"input":{"type":"structure","required":["IdentityInfo","UserId","InstanceId"],"members":{"IdentityInfo":{"shape":"S4"},"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateUserPhoneConfig":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/phone-config"},"input":{"type":"structure","required":["PhoneConfig","UserId","InstanceId"],"members":{"PhoneConfig":{"shape":"S8"},"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateUserRoutingProfile":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/routing-profile"},"input":{"type":"structure","required":["RoutingProfileId","UserId","InstanceId"],"members":{"RoutingProfileId":{},"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateUserSecurityProfiles":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/security-profiles"},"input":{"type":"structure","required":["SecurityProfileIds","UserId","InstanceId"],"members":{"SecurityProfileIds":{"shape":"Se"},"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}}},"shapes":{"S4":{"type":"structure","members":{"FirstName":{},"LastName":{},"Email":{}}},"S8":{"type":"structure","required":["PhoneType"],"members":{"PhoneType":{},"AutoAccept":{"type":"boolean"},"AfterContactWorkTimeLimit":{"type":"integer"},"DeskPhoneNumber":{}}},"Se":{"type":"list","member":{}},"Sw":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{}}},"S10":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{}}},"S15":{"type":"map","key":{},"value":{}},"S19":{"type":"structure","members":{"Queues":{"type":"list","member":{}},"Channels":{"type":"list","member":{}}}},"S1e":{"type":"list","member":{}},"S1h":{"type":"structure","members":{"Name":{},"Unit":{}}},"S1p":{"type":"structure","members":{"Queue":{"type":"structure","members":{"Id":{},"Arn":{}}},"Channel":{}}},"S1y":{"type":"string","sensitive":true},"S21":{"type":"structure","members":{"Name":{},"Threshold":{"type":"structure","members":{"Comparison":{},"ThresholdValue":{"type":"double"}}},"Statistic":{},"Unit":{}}}}}');

});

parcelRequire.register("4HKzc", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"GetCurrentMetricData":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetMetricData":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("92RjP", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $695da8fa4d05ccdc$var$Service = $dbC7k.Service;
var $695da8fa4d05ccdc$var$apiLoader = $dbC7k.apiLoader;
$695da8fa4d05ccdc$var$apiLoader.services["acmpca"] = {};
$dbC7k.ACMPCA = $695da8fa4d05ccdc$var$Service.defineService("acmpca", [
    "2017-08-22"
]);



Object.defineProperty($695da8fa4d05ccdc$var$apiLoader.services["acmpca"], "2017-08-22", {
    get: function get() {
        var model = (parcelRequire("eJWhH"));
        model.paginators = (parcelRequire("kKQU8")).pagination;
        model.waiters = (parcelRequire("eT7LL")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ACMPCA;

});
parcelRequire.register("eJWhH", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-08-22","endpointPrefix":"acm-pca","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"ACM-PCA","serviceFullName":"AWS Certificate Manager Private Certificate Authority","serviceId":"ACM PCA","signatureVersion":"v4","targetPrefix":"ACMPrivateCA","uid":"acm-pca-2017-08-22"},"operations":{"CreateCertificateAuthority":{"input":{"type":"structure","required":["CertificateAuthorityConfiguration","CertificateAuthorityType"],"members":{"CertificateAuthorityConfiguration":{"shape":"S2"},"RevocationConfiguration":{"shape":"Se"},"CertificateAuthorityType":{},"IdempotencyToken":{},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"CertificateAuthorityArn":{}}},"idempotent":true},"CreateCertificateAuthorityAuditReport":{"input":{"type":"structure","required":["CertificateAuthorityArn","S3BucketName","AuditReportResponseFormat"],"members":{"CertificateAuthorityArn":{},"S3BucketName":{},"AuditReportResponseFormat":{}}},"output":{"type":"structure","members":{"AuditReportId":{},"S3Key":{}}},"idempotent":true},"CreatePermission":{"input":{"type":"structure","required":["CertificateAuthorityArn","Principal","Actions"],"members":{"CertificateAuthorityArn":{},"Principal":{},"SourceAccount":{},"Actions":{"shape":"S10"}}}},"DeleteCertificateAuthority":{"input":{"type":"structure","required":["CertificateAuthorityArn"],"members":{"CertificateAuthorityArn":{},"PermanentDeletionTimeInDays":{"type":"integer"}}}},"DeletePermission":{"input":{"type":"structure","required":["CertificateAuthorityArn","Principal"],"members":{"CertificateAuthorityArn":{},"Principal":{},"SourceAccount":{}}}},"DescribeCertificateAuthority":{"input":{"type":"structure","required":["CertificateAuthorityArn"],"members":{"CertificateAuthorityArn":{}}},"output":{"type":"structure","members":{"CertificateAuthority":{"shape":"S17"}}}},"DescribeCertificateAuthorityAuditReport":{"input":{"type":"structure","required":["CertificateAuthorityArn","AuditReportId"],"members":{"CertificateAuthorityArn":{},"AuditReportId":{}}},"output":{"type":"structure","members":{"AuditReportStatus":{},"S3BucketName":{},"S3Key":{},"CreatedAt":{"type":"timestamp"}}}},"GetCertificate":{"input":{"type":"structure","required":["CertificateAuthorityArn","CertificateArn"],"members":{"CertificateAuthorityArn":{},"CertificateArn":{}}},"output":{"type":"structure","members":{"Certificate":{},"CertificateChain":{}}}},"GetCertificateAuthorityCertificate":{"input":{"type":"structure","required":["CertificateAuthorityArn"],"members":{"CertificateAuthorityArn":{}}},"output":{"type":"structure","members":{"Certificate":{},"CertificateChain":{}}}},"GetCertificateAuthorityCsr":{"input":{"type":"structure","required":["CertificateAuthorityArn"],"members":{"CertificateAuthorityArn":{}}},"output":{"type":"structure","members":{"Csr":{}}}},"ImportCertificateAuthorityCertificate":{"input":{"type":"structure","required":["CertificateAuthorityArn","Certificate"],"members":{"CertificateAuthorityArn":{},"Certificate":{"type":"blob"},"CertificateChain":{"type":"blob"}}}},"IssueCertificate":{"input":{"type":"structure","required":["CertificateAuthorityArn","Csr","SigningAlgorithm","Validity"],"members":{"CertificateAuthorityArn":{},"Csr":{"type":"blob"},"SigningAlgorithm":{},"TemplateArn":{},"Validity":{"type":"structure","required":["Value","Type"],"members":{"Value":{"type":"long"},"Type":{}}},"IdempotencyToken":{}}},"output":{"type":"structure","members":{"CertificateArn":{}}},"idempotent":true},"ListCertificateAuthorities":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"CertificateAuthorities":{"type":"list","member":{"shape":"S17"}},"NextToken":{}}}},"ListPermissions":{"input":{"type":"structure","required":["CertificateAuthorityArn"],"members":{"CertificateAuthorityArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Permissions":{"type":"list","member":{"type":"structure","members":{"CertificateAuthorityArn":{},"CreatedAt":{"type":"timestamp"},"Principal":{},"SourceAccount":{},"Actions":{"shape":"S10"},"Policy":{}}}},"NextToken":{}}}},"ListTags":{"input":{"type":"structure","required":["CertificateAuthorityArn"],"members":{"CertificateAuthorityArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sm"},"NextToken":{}}}},"RestoreCertificateAuthority":{"input":{"type":"structure","required":["CertificateAuthorityArn"],"members":{"CertificateAuthorityArn":{}}}},"RevokeCertificate":{"input":{"type":"structure","required":["CertificateAuthorityArn","CertificateSerial","RevocationReason"],"members":{"CertificateAuthorityArn":{},"CertificateSerial":{},"RevocationReason":{}}}},"TagCertificateAuthority":{"input":{"type":"structure","required":["CertificateAuthorityArn","Tags"],"members":{"CertificateAuthorityArn":{},"Tags":{"shape":"Sm"}}}},"UntagCertificateAuthority":{"input":{"type":"structure","required":["CertificateAuthorityArn","Tags"],"members":{"CertificateAuthorityArn":{},"Tags":{"shape":"Sm"}}}},"UpdateCertificateAuthority":{"input":{"type":"structure","required":["CertificateAuthorityArn"],"members":{"CertificateAuthorityArn":{},"RevocationConfiguration":{"shape":"Se"},"Status":{}}}}},"shapes":{"S2":{"type":"structure","required":["KeyAlgorithm","SigningAlgorithm","Subject"],"members":{"KeyAlgorithm":{},"SigningAlgorithm":{},"Subject":{"type":"structure","members":{"Country":{},"Organization":{},"OrganizationalUnit":{},"DistinguishedNameQualifier":{},"State":{},"CommonName":{},"SerialNumber":{},"Locality":{},"Title":{},"Surname":{},"GivenName":{},"Initials":{},"Pseudonym":{},"GenerationQualifier":{}}}}},"Se":{"type":"structure","members":{"CrlConfiguration":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"ExpirationInDays":{"type":"integer"},"CustomCname":{},"S3BucketName":{}}}}},"Sm":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"S10":{"type":"list","member":{}},"S17":{"type":"structure","members":{"Arn":{},"CreatedAt":{"type":"timestamp"},"LastStateChangeAt":{"type":"timestamp"},"Type":{},"Serial":{},"Status":{},"NotBefore":{"type":"timestamp"},"NotAfter":{"type":"timestamp"},"FailureReason":{},"CertificateAuthorityConfiguration":{"shape":"S2"},"RevocationConfiguration":{"shape":"Se"},"RestorableUntil":{"type":"timestamp"}}}}}');

});

parcelRequire.register("kKQU8", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListCertificateAuthorities":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CertificateAuthorities"},"ListPermissions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Permissions"},"ListTags":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Tags"}}}');

});

parcelRequire.register("eT7LL", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"CertificateAuthorityCSRCreated":{"description":"Wait until a Certificate Authority CSR is created","operation":"GetCertificateAuthorityCsr","delay":3,"maxAttempts":60,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"RequestInProgressException"}]},"CertificateIssued":{"description":"Wait until a certificate is issued","operation":"GetCertificate","delay":3,"maxAttempts":60,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"RequestInProgressException"}]},"AuditReportCreated":{"description":"Wait until a Audit Report is created","operation":"DescribeCertificateAuthorityAuditReport","delay":3,"maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"AuditReportStatus","expected":"SUCCESS"},{"state":"failure","matcher":"path","argument":"AuditReportStatus","expected":"FAILED"}]}}}');

});


parcelRequire.register("e9PgI", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $a4e9acce54bdfe39$var$Service = $dbC7k.Service;
var $a4e9acce54bdfe39$var$apiLoader = $dbC7k.apiLoader;
$a4e9acce54bdfe39$var$apiLoader.services["fms"] = {};
$dbC7k.FMS = $a4e9acce54bdfe39$var$Service.defineService("fms", [
    "2018-01-01"
]);


Object.defineProperty($a4e9acce54bdfe39$var$apiLoader.services["fms"], "2018-01-01", {
    get: function get() {
        var model = (parcelRequire("jsA7L"));
        model.paginators = (parcelRequire("d0Y0X")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.FMS;

});
parcelRequire.register("jsA7L", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-01-01","endpointPrefix":"fms","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"FMS","serviceFullName":"Firewall Management Service","serviceId":"FMS","signatureVersion":"v4","targetPrefix":"AWSFMS_20180101","uid":"fms-2018-01-01"},"operations":{"AssociateAdminAccount":{"input":{"type":"structure","required":["AdminAccount"],"members":{"AdminAccount":{}}}},"DeleteNotificationChannel":{"input":{"type":"structure","members":{}}},"DeletePolicy":{"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{},"DeleteAllPolicyResources":{"type":"boolean"}}}},"DisassociateAdminAccount":{"input":{"type":"structure","members":{}}},"GetAdminAccount":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AdminAccount":{},"RoleStatus":{}}}},"GetComplianceDetail":{"input":{"type":"structure","required":["PolicyId","MemberAccount"],"members":{"PolicyId":{},"MemberAccount":{}}},"output":{"type":"structure","members":{"PolicyComplianceDetail":{"type":"structure","members":{"PolicyOwner":{},"PolicyId":{},"MemberAccount":{},"Violators":{"type":"list","member":{"type":"structure","members":{"ResourceId":{},"ViolationReason":{},"ResourceType":{}}}},"EvaluationLimitExceeded":{"type":"boolean"},"ExpiredAt":{"type":"timestamp"},"IssueInfoMap":{"shape":"Sk"}}}}}},"GetNotificationChannel":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"SnsTopicArn":{},"SnsRoleName":{}}}},"GetPolicy":{"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{}}},"output":{"type":"structure","members":{"Policy":{"shape":"Ss"},"PolicyArn":{}}}},"GetProtectionStatus":{"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{},"MemberAccountId":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AdminAccountId":{},"ServiceType":{},"Data":{},"NextToken":{}}}},"ListComplianceStatus":{"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PolicyComplianceStatusList":{"type":"list","member":{"type":"structure","members":{"PolicyOwner":{},"PolicyId":{},"PolicyName":{},"MemberAccount":{},"EvaluationResults":{"type":"list","member":{"type":"structure","members":{"ComplianceStatus":{},"ViolatorCount":{"type":"long"},"EvaluationLimitExceeded":{"type":"boolean"}}}},"LastUpdated":{"type":"timestamp"},"IssueInfoMap":{"shape":"Sk"}}}},"NextToken":{}}}},"ListMemberAccounts":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"MemberAccounts":{"type":"list","member":{}},"NextToken":{}}}},"ListPolicies":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PolicyList":{"type":"list","member":{"type":"structure","members":{"PolicyArn":{},"PolicyId":{},"PolicyName":{},"ResourceType":{},"SecurityServiceType":{},"RemediationEnabled":{"type":"boolean"}}}},"NextToken":{}}}},"PutNotificationChannel":{"input":{"type":"structure","required":["SnsTopicArn","SnsRoleName"],"members":{"SnsTopicArn":{},"SnsRoleName":{}}}},"PutPolicy":{"input":{"type":"structure","required":["Policy"],"members":{"Policy":{"shape":"Ss"}}},"output":{"type":"structure","members":{"Policy":{"shape":"Ss"},"PolicyArn":{}}}}},"shapes":{"Sk":{"type":"map","key":{},"value":{}},"Ss":{"type":"structure","required":["PolicyName","SecurityServicePolicyData","ResourceType","ExcludeResourceTags","RemediationEnabled"],"members":{"PolicyId":{},"PolicyName":{},"PolicyUpdateToken":{},"SecurityServicePolicyData":{"type":"structure","required":["Type"],"members":{"Type":{},"ManagedServiceData":{}}},"ResourceType":{},"ResourceTypeList":{"type":"list","member":{}},"ResourceTags":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"ExcludeResourceTags":{"type":"boolean"},"RemediationEnabled":{"type":"boolean"},"IncludeMap":{"shape":"S13"},"ExcludeMap":{"shape":"S13"}}},"S13":{"type":"map","key":{},"value":{"type":"list","member":{}}}}}');

});

parcelRequire.register("d0Y0X", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListComplianceStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PolicyComplianceStatusList"},"ListMemberAccounts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"MemberAccounts"},"ListPolicies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PolicyList"}}}');

});


parcelRequire.register("afQhB", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $7773dc690054fbb7$var$Service = $dbC7k.Service;
var $7773dc690054fbb7$var$apiLoader = $dbC7k.apiLoader;
$7773dc690054fbb7$var$apiLoader.services["secretsmanager"] = {};
$dbC7k.SecretsManager = $7773dc690054fbb7$var$Service.defineService("secretsmanager", [
    "2017-10-17"
]);


Object.defineProperty($7773dc690054fbb7$var$apiLoader.services["secretsmanager"], "2017-10-17", {
    get: function get() {
        var model = (parcelRequire("62XGT"));
        model.paginators = (parcelRequire("7O4WZ")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.SecretsManager;

});
parcelRequire.register("62XGT", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-10-17","endpointPrefix":"secretsmanager","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Secrets Manager","serviceId":"Secrets Manager","signatureVersion":"v4","signingName":"secretsmanager","targetPrefix":"secretsmanager","uid":"secretsmanager-2017-10-17"},"operations":{"CancelRotateSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{}}}},"CreateSecret":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"ClientRequestToken":{"idempotencyToken":true},"Description":{},"KmsKeyId":{},"SecretBinary":{"shape":"Sc"},"SecretString":{"shape":"Sd"},"Tags":{"shape":"Se"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{}}}},"DeleteResourcePolicy":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{}}}},"DeleteSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"RecoveryWindowInDays":{"type":"long"},"ForceDeleteWithoutRecovery":{"type":"boolean"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"DeletionDate":{"type":"timestamp"}}}},"DescribeSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"Description":{},"KmsKeyId":{},"RotationEnabled":{"type":"boolean"},"RotationLambdaARN":{},"RotationRules":{"shape":"Su"},"LastRotatedDate":{"type":"timestamp"},"LastChangedDate":{"type":"timestamp"},"LastAccessedDate":{"type":"timestamp"},"DeletedDate":{"type":"timestamp"},"Tags":{"shape":"Se"},"VersionIdsToStages":{"shape":"S10"},"OwningService":{}}}},"GetRandomPassword":{"input":{"type":"structure","members":{"PasswordLength":{"type":"long"},"ExcludeCharacters":{},"ExcludeNumbers":{"type":"boolean"},"ExcludePunctuation":{"type":"boolean"},"ExcludeUppercase":{"type":"boolean"},"ExcludeLowercase":{"type":"boolean"},"IncludeSpace":{"type":"boolean"},"RequireEachIncludedType":{"type":"boolean"}}},"output":{"type":"structure","members":{"RandomPassword":{"type":"string","sensitive":true}}}},"GetResourcePolicy":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"ResourcePolicy":{}}}},"GetSecretValue":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"VersionId":{},"VersionStage":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{},"SecretBinary":{"shape":"Sc"},"SecretString":{"shape":"Sd"},"VersionStages":{"shape":"S11"},"CreatedDate":{"type":"timestamp"}}}},"ListSecretVersionIds":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"MaxResults":{"type":"integer"},"NextToken":{},"IncludeDeprecated":{"type":"boolean"}}},"output":{"type":"structure","members":{"Versions":{"type":"list","member":{"type":"structure","members":{"VersionId":{},"VersionStages":{"shape":"S11"},"LastAccessedDate":{"type":"timestamp"},"CreatedDate":{"type":"timestamp"}}}},"NextToken":{},"ARN":{},"Name":{}}}},"ListSecrets":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"SecretList":{"type":"list","member":{"type":"structure","members":{"ARN":{},"Name":{},"Description":{},"KmsKeyId":{},"RotationEnabled":{"type":"boolean"},"RotationLambdaARN":{},"RotationRules":{"shape":"Su"},"LastRotatedDate":{"type":"timestamp"},"LastChangedDate":{"type":"timestamp"},"LastAccessedDate":{"type":"timestamp"},"DeletedDate":{"type":"timestamp"},"Tags":{"shape":"Se"},"SecretVersionsToStages":{"shape":"S10"},"OwningService":{}}}},"NextToken":{}}}},"PutResourcePolicy":{"input":{"type":"structure","required":["SecretId","ResourcePolicy"],"members":{"SecretId":{},"ResourcePolicy":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{}}}},"PutSecretValue":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"ClientRequestToken":{"idempotencyToken":true},"SecretBinary":{"shape":"Sc"},"SecretString":{"shape":"Sd"},"VersionStages":{"shape":"S11"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{},"VersionStages":{"shape":"S11"}}}},"RestoreSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{}}}},"RotateSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"ClientRequestToken":{"idempotencyToken":true},"RotationLambdaARN":{},"RotationRules":{"shape":"Su"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{}}}},"TagResource":{"input":{"type":"structure","required":["SecretId","Tags"],"members":{"SecretId":{},"Tags":{"shape":"Se"}}}},"UntagResource":{"input":{"type":"structure","required":["SecretId","TagKeys"],"members":{"SecretId":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"ClientRequestToken":{"idempotencyToken":true},"Description":{},"KmsKeyId":{},"SecretBinary":{"shape":"Sc"},"SecretString":{"shape":"Sd"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{}}}},"UpdateSecretVersionStage":{"input":{"type":"structure","required":["SecretId","VersionStage"],"members":{"SecretId":{},"VersionStage":{},"RemoveFromVersionId":{},"MoveToVersionId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{}}}}},"shapes":{"Sc":{"type":"blob","sensitive":true},"Sd":{"type":"string","sensitive":true},"Se":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Su":{"type":"structure","members":{"AutomaticallyAfterDays":{"type":"long"}}},"S10":{"type":"map","key":{},"value":{"shape":"S11"}},"S11":{"type":"list","member":{}}}}');

});

parcelRequire.register("7O4WZ", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListSecretVersionIds":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSecrets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("c4Auk", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $8ca2298e184038ab$var$Service = $dbC7k.Service;
var $8ca2298e184038ab$var$apiLoader = $dbC7k.apiLoader;
$8ca2298e184038ab$var$apiLoader.services["iotanalytics"] = {};
$dbC7k.IoTAnalytics = $8ca2298e184038ab$var$Service.defineService("iotanalytics", [
    "2017-11-27"
]);


Object.defineProperty($8ca2298e184038ab$var$apiLoader.services["iotanalytics"], "2017-11-27", {
    get: function get() {
        var model = (parcelRequire("jP9oW"));
        model.paginators = (parcelRequire("9NGRM")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.IoTAnalytics;

});
parcelRequire.register("jP9oW", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-11-27","endpointPrefix":"iotanalytics","protocol":"rest-json","serviceFullName":"AWS IoT Analytics","serviceId":"IoTAnalytics","signatureVersion":"v4","signingName":"iotanalytics","uid":"iotanalytics-2017-11-27"},"operations":{"BatchPutMessage":{"http":{"requestUri":"/messages/batch","responseCode":200},"input":{"type":"structure","required":["channelName","messages"],"members":{"channelName":{},"messages":{"type":"list","member":{"type":"structure","required":["messageId","payload"],"members":{"messageId":{},"payload":{"type":"blob"}}}}}},"output":{"type":"structure","members":{"batchPutMessageErrorEntries":{"type":"list","member":{"type":"structure","members":{"messageId":{},"errorCode":{},"errorMessage":{}}}}}}},"CancelPipelineReprocessing":{"http":{"method":"DELETE","requestUri":"/pipelines/{pipelineName}/reprocessing/{reprocessingId}"},"input":{"type":"structure","required":["pipelineName","reprocessingId"],"members":{"pipelineName":{"location":"uri","locationName":"pipelineName"},"reprocessingId":{"location":"uri","locationName":"reprocessingId"}}},"output":{"type":"structure","members":{}}},"CreateChannel":{"http":{"requestUri":"/channels","responseCode":201},"input":{"type":"structure","required":["channelName"],"members":{"channelName":{},"channelStorage":{"shape":"Sh"},"retentionPeriod":{"shape":"Sn"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"channelName":{},"channelArn":{},"retentionPeriod":{"shape":"Sn"}}}},"CreateDataset":{"http":{"requestUri":"/datasets","responseCode":201},"input":{"type":"structure","required":["datasetName","actions"],"members":{"datasetName":{},"actions":{"shape":"Sy"},"triggers":{"shape":"S1l"},"contentDeliveryRules":{"shape":"S1q"},"retentionPeriod":{"shape":"Sn"},"versioningConfiguration":{"shape":"S21"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"datasetName":{},"datasetArn":{},"retentionPeriod":{"shape":"Sn"}}}},"CreateDatasetContent":{"http":{"requestUri":"/datasets/{datasetName}/content"},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"}}},"output":{"type":"structure","members":{"versionId":{}}}},"CreateDatastore":{"http":{"requestUri":"/datastores","responseCode":201},"input":{"type":"structure","required":["datastoreName"],"members":{"datastoreName":{},"datastoreStorage":{"shape":"S2b"},"retentionPeriod":{"shape":"Sn"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"datastoreName":{},"datastoreArn":{},"retentionPeriod":{"shape":"Sn"}}}},"CreatePipeline":{"http":{"requestUri":"/pipelines","responseCode":201},"input":{"type":"structure","required":["pipelineName","pipelineActivities"],"members":{"pipelineName":{},"pipelineActivities":{"shape":"S2h"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"pipelineName":{},"pipelineArn":{}}}},"DeleteChannel":{"http":{"method":"DELETE","requestUri":"/channels/{channelName}","responseCode":204},"input":{"type":"structure","required":["channelName"],"members":{"channelName":{"location":"uri","locationName":"channelName"}}}},"DeleteDataset":{"http":{"method":"DELETE","requestUri":"/datasets/{datasetName}","responseCode":204},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"}}}},"DeleteDatasetContent":{"http":{"method":"DELETE","requestUri":"/datasets/{datasetName}/content","responseCode":204},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"},"versionId":{"location":"querystring","locationName":"versionId"}}}},"DeleteDatastore":{"http":{"method":"DELETE","requestUri":"/datastores/{datastoreName}","responseCode":204},"input":{"type":"structure","required":["datastoreName"],"members":{"datastoreName":{"location":"uri","locationName":"datastoreName"}}}},"DeletePipeline":{"http":{"method":"DELETE","requestUri":"/pipelines/{pipelineName}","responseCode":204},"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{"location":"uri","locationName":"pipelineName"}}}},"DescribeChannel":{"http":{"method":"GET","requestUri":"/channels/{channelName}"},"input":{"type":"structure","required":["channelName"],"members":{"channelName":{"location":"uri","locationName":"channelName"},"includeStatistics":{"location":"querystring","locationName":"includeStatistics","type":"boolean"}}},"output":{"type":"structure","members":{"channel":{"type":"structure","members":{"name":{},"storage":{"shape":"Sh"},"arn":{},"status":{},"retentionPeriod":{"shape":"Sn"},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}},"statistics":{"type":"structure","members":{"size":{"shape":"S3f"}}}}}},"DescribeDataset":{"http":{"method":"GET","requestUri":"/datasets/{datasetName}"},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"}}},"output":{"type":"structure","members":{"dataset":{"type":"structure","members":{"name":{},"arn":{},"actions":{"shape":"Sy"},"triggers":{"shape":"S1l"},"contentDeliveryRules":{"shape":"S1q"},"status":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"retentionPeriod":{"shape":"Sn"},"versioningConfiguration":{"shape":"S21"}}}}}},"DescribeDatastore":{"http":{"method":"GET","requestUri":"/datastores/{datastoreName}"},"input":{"type":"structure","required":["datastoreName"],"members":{"datastoreName":{"location":"uri","locationName":"datastoreName"},"includeStatistics":{"location":"querystring","locationName":"includeStatistics","type":"boolean"}}},"output":{"type":"structure","members":{"datastore":{"type":"structure","members":{"name":{},"storage":{"shape":"S2b"},"arn":{},"status":{},"retentionPeriod":{"shape":"Sn"},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}},"statistics":{"type":"structure","members":{"size":{"shape":"S3f"}}}}}},"DescribeLoggingOptions":{"http":{"method":"GET","requestUri":"/logging"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"loggingOptions":{"shape":"S3s"}}}},"DescribePipeline":{"http":{"method":"GET","requestUri":"/pipelines/{pipelineName}"},"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{"location":"uri","locationName":"pipelineName"}}},"output":{"type":"structure","members":{"pipeline":{"type":"structure","members":{"name":{},"arn":{},"activities":{"shape":"S2h"},"reprocessingSummaries":{"shape":"S3y"},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}}}}},"GetDatasetContent":{"http":{"method":"GET","requestUri":"/datasets/{datasetName}/content"},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"},"versionId":{"location":"querystring","locationName":"versionId"}}},"output":{"type":"structure","members":{"entries":{"type":"list","member":{"type":"structure","members":{"entryName":{},"dataURI":{}}}},"timestamp":{"type":"timestamp"},"status":{"shape":"S46"}}}},"ListChannels":{"http":{"method":"GET","requestUri":"/channels"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"channelSummaries":{"type":"list","member":{"type":"structure","members":{"channelName":{},"channelStorage":{"type":"structure","members":{"serviceManagedS3":{"type":"structure","members":{}},"customerManagedS3":{"type":"structure","members":{"bucket":{},"keyPrefix":{},"roleArn":{}}}}},"status":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListDatasetContents":{"http":{"method":"GET","requestUri":"/datasets/{datasetName}/contents"},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"scheduledOnOrAfter":{"location":"querystring","locationName":"scheduledOnOrAfter","type":"timestamp"},"scheduledBefore":{"location":"querystring","locationName":"scheduledBefore","type":"timestamp"}}},"output":{"type":"structure","members":{"datasetContentSummaries":{"type":"list","member":{"type":"structure","members":{"version":{},"status":{"shape":"S46"},"creationTime":{"type":"timestamp"},"scheduleTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListDatasets":{"http":{"method":"GET","requestUri":"/datasets"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"datasetSummaries":{"type":"list","member":{"type":"structure","members":{"datasetName":{},"status":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"triggers":{"shape":"S1l"},"actions":{"type":"list","member":{"type":"structure","members":{"actionName":{},"actionType":{}}}}}}},"nextToken":{}}}},"ListDatastores":{"http":{"method":"GET","requestUri":"/datastores"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"datastoreSummaries":{"type":"list","member":{"type":"structure","members":{"datastoreName":{},"datastoreStorage":{"type":"structure","members":{"serviceManagedS3":{"type":"structure","members":{}},"customerManagedS3":{"type":"structure","members":{"bucket":{},"keyPrefix":{},"roleArn":{}}}}},"status":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListPipelines":{"http":{"method":"GET","requestUri":"/pipelines"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"pipelineSummaries":{"type":"list","member":{"type":"structure","members":{"pipelineName":{},"reprocessingSummaries":{"shape":"S3y"},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sq"}}}},"PutLoggingOptions":{"http":{"method":"PUT","requestUri":"/logging"},"input":{"type":"structure","required":["loggingOptions"],"members":{"loggingOptions":{"shape":"S3s"}}}},"RunPipelineActivity":{"http":{"requestUri":"/pipelineactivities/run"},"input":{"type":"structure","required":["pipelineActivity","payloads"],"members":{"pipelineActivity":{"shape":"S2i"},"payloads":{"shape":"S59"}}},"output":{"type":"structure","members":{"payloads":{"shape":"S59"},"logResult":{}}}},"SampleChannelData":{"http":{"method":"GET","requestUri":"/channels/{channelName}/sample"},"input":{"type":"structure","required":["channelName"],"members":{"channelName":{"location":"uri","locationName":"channelName"},"maxMessages":{"location":"querystring","locationName":"maxMessages","type":"integer"},"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"}}},"output":{"type":"structure","members":{"payloads":{"shape":"S59"}}}},"StartPipelineReprocessing":{"http":{"requestUri":"/pipelines/{pipelineName}/reprocessing"},"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{"location":"uri","locationName":"pipelineName"},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"reprocessingId":{}}}},"TagResource":{"http":{"requestUri":"/tags","responseCode":204},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags","responseCode":204},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateChannel":{"http":{"method":"PUT","requestUri":"/channels/{channelName}"},"input":{"type":"structure","required":["channelName"],"members":{"channelName":{"location":"uri","locationName":"channelName"},"channelStorage":{"shape":"Sh"},"retentionPeriod":{"shape":"Sn"}}}},"UpdateDataset":{"http":{"method":"PUT","requestUri":"/datasets/{datasetName}"},"input":{"type":"structure","required":["datasetName","actions"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"},"actions":{"shape":"Sy"},"triggers":{"shape":"S1l"},"contentDeliveryRules":{"shape":"S1q"},"retentionPeriod":{"shape":"Sn"},"versioningConfiguration":{"shape":"S21"}}}},"UpdateDatastore":{"http":{"method":"PUT","requestUri":"/datastores/{datastoreName}"},"input":{"type":"structure","required":["datastoreName"],"members":{"datastoreName":{"location":"uri","locationName":"datastoreName"},"retentionPeriod":{"shape":"Sn"},"datastoreStorage":{"shape":"S2b"}}}},"UpdatePipeline":{"http":{"method":"PUT","requestUri":"/pipelines/{pipelineName}"},"input":{"type":"structure","required":["pipelineName","pipelineActivities"],"members":{"pipelineName":{"location":"uri","locationName":"pipelineName"},"pipelineActivities":{"shape":"S2h"}}}}},"shapes":{"Sh":{"type":"structure","members":{"serviceManagedS3":{"type":"structure","members":{}},"customerManagedS3":{"type":"structure","required":["bucket","roleArn"],"members":{"bucket":{},"keyPrefix":{},"roleArn":{}}}}},"Sn":{"type":"structure","members":{"unlimited":{"type":"boolean"},"numberOfDays":{"type":"integer"}}},"Sq":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Sy":{"type":"list","member":{"type":"structure","members":{"actionName":{},"queryAction":{"type":"structure","required":["sqlQuery"],"members":{"sqlQuery":{},"filters":{"type":"list","member":{"type":"structure","members":{"deltaTime":{"type":"structure","required":["offsetSeconds","timeExpression"],"members":{"offsetSeconds":{"type":"integer"},"timeExpression":{}}}}}}}},"containerAction":{"type":"structure","required":["image","executionRoleArn","resourceConfiguration"],"members":{"image":{},"executionRoleArn":{},"resourceConfiguration":{"type":"structure","required":["computeType","volumeSizeInGB"],"members":{"computeType":{},"volumeSizeInGB":{"type":"integer"}}},"variables":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{},"stringValue":{},"doubleValue":{"type":"double"},"datasetContentVersionValue":{"type":"structure","required":["datasetName"],"members":{"datasetName":{}}},"outputFileUriValue":{"type":"structure","required":["fileName"],"members":{"fileName":{}}}}}}}}}}},"S1l":{"type":"list","member":{"type":"structure","members":{"schedule":{"type":"structure","members":{"expression":{}}},"dataset":{"type":"structure","required":["name"],"members":{"name":{}}}}}},"S1q":{"type":"list","member":{"type":"structure","required":["destination"],"members":{"entryName":{},"destination":{"type":"structure","members":{"iotEventsDestinationConfiguration":{"type":"structure","required":["inputName","roleArn"],"members":{"inputName":{},"roleArn":{}}},"s3DestinationConfiguration":{"type":"structure","required":["bucket","key","roleArn"],"members":{"bucket":{},"key":{},"glueConfiguration":{"type":"structure","required":["tableName","databaseName"],"members":{"tableName":{},"databaseName":{}}},"roleArn":{}}}}}}}},"S21":{"type":"structure","members":{"unlimited":{"type":"boolean"},"maxVersions":{"type":"integer"}}},"S2b":{"type":"structure","members":{"serviceManagedS3":{"type":"structure","members":{}},"customerManagedS3":{"type":"structure","required":["bucket","roleArn"],"members":{"bucket":{},"keyPrefix":{},"roleArn":{}}}}},"S2h":{"type":"list","member":{"shape":"S2i"}},"S2i":{"type":"structure","members":{"channel":{"type":"structure","required":["name","channelName"],"members":{"name":{},"channelName":{},"next":{}}},"lambda":{"type":"structure","required":["name","lambdaName","batchSize"],"members":{"name":{},"lambdaName":{},"batchSize":{"type":"integer"},"next":{}}},"datastore":{"type":"structure","required":["name","datastoreName"],"members":{"name":{},"datastoreName":{}}},"addAttributes":{"type":"structure","required":["name","attributes"],"members":{"name":{},"attributes":{"type":"map","key":{},"value":{}},"next":{}}},"removeAttributes":{"type":"structure","required":["name","attributes"],"members":{"name":{},"attributes":{"shape":"S2t"},"next":{}}},"selectAttributes":{"type":"structure","required":["name","attributes"],"members":{"name":{},"attributes":{"shape":"S2t"},"next":{}}},"filter":{"type":"structure","required":["name","filter"],"members":{"name":{},"filter":{},"next":{}}},"math":{"type":"structure","required":["name","attribute","math"],"members":{"name":{},"attribute":{},"math":{},"next":{}}},"deviceRegistryEnrich":{"type":"structure","required":["name","attribute","thingName","roleArn"],"members":{"name":{},"attribute":{},"thingName":{},"roleArn":{},"next":{}}},"deviceShadowEnrich":{"type":"structure","required":["name","attribute","thingName","roleArn"],"members":{"name":{},"attribute":{},"thingName":{},"roleArn":{},"next":{}}}}},"S2t":{"type":"list","member":{}},"S3f":{"type":"structure","members":{"estimatedSizeInBytes":{"type":"double"},"estimatedOn":{"type":"timestamp"}}},"S3s":{"type":"structure","required":["roleArn","level","enabled"],"members":{"roleArn":{},"level":{},"enabled":{"type":"boolean"}}},"S3y":{"type":"list","member":{"type":"structure","members":{"id":{},"status":{},"creationTime":{"type":"timestamp"}}}},"S46":{"type":"structure","members":{"state":{},"reason":{}}},"S59":{"type":"list","member":{"type":"blob"}}}}');

});

parcelRequire.register("9NGRM", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListChannels":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListDatasetContents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListDatasets":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListDatastores":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListPipelines":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}');

});


parcelRequire.register("j4h8u", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $de1baee4740ace6e$var$Service = $dbC7k.Service;
var $de1baee4740ace6e$var$apiLoader = $dbC7k.apiLoader;
$de1baee4740ace6e$var$apiLoader.services["iot1clickdevicesservice"] = {};
$dbC7k.IoT1ClickDevicesService = $de1baee4740ace6e$var$Service.defineService("iot1clickdevicesservice", [
    "2018-05-14"
]);

Object.defineProperty($de1baee4740ace6e$var$apiLoader.services["iot1clickdevicesservice"], "2018-05-14", {
    get: function get() {
        var model = (parcelRequire("eZb8A"));
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.IoT1ClickDevicesService;

});
parcelRequire.register("eZb8A", function(module, exports) {
module.exports = JSON.parse('{"metadata":{"apiVersion":"2018-05-14","endpointPrefix":"devices.iot1click","signingName":"iot1click","serviceFullName":"AWS IoT 1-Click Devices Service","serviceId":"IoT 1Click Devices Service","protocol":"rest-json","jsonVersion":"1.1","uid":"devices-2018-05-14","signatureVersion":"v4"},"operations":{"ClaimDevicesByClaimCode":{"http":{"method":"PUT","requestUri":"/claims/{claimCode}","responseCode":200},"input":{"type":"structure","members":{"ClaimCode":{"location":"uri","locationName":"claimCode"}},"required":["ClaimCode"]},"output":{"type":"structure","members":{"ClaimCode":{"locationName":"claimCode"},"Total":{"locationName":"total","type":"integer"}}}},"DescribeDevice":{"http":{"method":"GET","requestUri":"/devices/{deviceId}","responseCode":200},"input":{"type":"structure","members":{"DeviceId":{"location":"uri","locationName":"deviceId"}},"required":["DeviceId"]},"output":{"type":"structure","members":{"DeviceDescription":{"shape":"S8","locationName":"deviceDescription"}}}},"FinalizeDeviceClaim":{"http":{"method":"PUT","requestUri":"/devices/{deviceId}/finalize-claim","responseCode":200},"input":{"type":"structure","members":{"DeviceId":{"location":"uri","locationName":"deviceId"},"Tags":{"shape":"Sc","locationName":"tags"}},"required":["DeviceId"]},"output":{"type":"structure","members":{"State":{"locationName":"state"}}}},"GetDeviceMethods":{"http":{"method":"GET","requestUri":"/devices/{deviceId}/methods","responseCode":200},"input":{"type":"structure","members":{"DeviceId":{"location":"uri","locationName":"deviceId"}},"required":["DeviceId"]},"output":{"type":"structure","members":{"DeviceMethods":{"locationName":"deviceMethods","type":"list","member":{"shape":"Si"}}}}},"InitiateDeviceClaim":{"http":{"method":"PUT","requestUri":"/devices/{deviceId}/initiate-claim","responseCode":200},"input":{"type":"structure","members":{"DeviceId":{"location":"uri","locationName":"deviceId"}},"required":["DeviceId"]},"output":{"type":"structure","members":{"State":{"locationName":"state"}}}},"InvokeDeviceMethod":{"http":{"requestUri":"/devices/{deviceId}/methods","responseCode":200},"input":{"type":"structure","members":{"DeviceId":{"location":"uri","locationName":"deviceId"},"DeviceMethod":{"shape":"Si","locationName":"deviceMethod"},"DeviceMethodParameters":{"locationName":"deviceMethodParameters"}},"required":["DeviceId"]},"output":{"type":"structure","members":{"DeviceMethodResponse":{"locationName":"deviceMethodResponse"}}}},"ListDeviceEvents":{"http":{"method":"GET","requestUri":"/devices/{deviceId}/events","responseCode":200},"input":{"type":"structure","members":{"DeviceId":{"location":"uri","locationName":"deviceId"},"FromTimeStamp":{"shape":"So","location":"querystring","locationName":"fromTimeStamp"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"ToTimeStamp":{"shape":"So","location":"querystring","locationName":"toTimeStamp"}},"required":["DeviceId","FromTimeStamp","ToTimeStamp"]},"output":{"type":"structure","members":{"Events":{"locationName":"events","type":"list","member":{"type":"structure","members":{"Device":{"locationName":"device","type":"structure","members":{"Attributes":{"locationName":"attributes","type":"structure","members":{}},"DeviceId":{"locationName":"deviceId"},"Type":{"locationName":"type"}}},"StdEvent":{"locationName":"stdEvent"}}}},"NextToken":{"locationName":"nextToken"}}}},"ListDevices":{"http":{"method":"GET","requestUri":"/devices","responseCode":200},"input":{"type":"structure","members":{"DeviceType":{"location":"querystring","locationName":"deviceType"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Devices":{"locationName":"devices","type":"list","member":{"shape":"S8"}},"NextToken":{"locationName":"nextToken"}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resource-arn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{"Tags":{"shape":"Sc","locationName":"tags"}}}},"TagResource":{"http":{"requestUri":"/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"Tags":{"shape":"Sc","locationName":"tags"}},"required":["ResourceArn","Tags"]}},"UnclaimDevice":{"http":{"method":"PUT","requestUri":"/devices/{deviceId}/unclaim","responseCode":200},"input":{"type":"structure","members":{"DeviceId":{"location":"uri","locationName":"deviceId"}},"required":["DeviceId"]},"output":{"type":"structure","members":{"State":{"locationName":"state"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}},"required":["TagKeys","ResourceArn"]}},"UpdateDeviceState":{"http":{"method":"PUT","requestUri":"/devices/{deviceId}/state","responseCode":200},"input":{"type":"structure","members":{"DeviceId":{"location":"uri","locationName":"deviceId"},"Enabled":{"locationName":"enabled","type":"boolean"}},"required":["DeviceId"]},"output":{"type":"structure","members":{}}}},"shapes":{"S8":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Attributes":{"locationName":"attributes","type":"map","key":{},"value":{}},"DeviceId":{"locationName":"deviceId"},"Enabled":{"locationName":"enabled","type":"boolean"},"RemainingLife":{"locationName":"remainingLife","type":"double"},"Type":{"locationName":"type"},"Tags":{"shape":"Sc","locationName":"tags"}}},"Sc":{"type":"map","key":{},"value":{}},"Si":{"type":"structure","members":{"DeviceType":{"locationName":"deviceType"},"MethodName":{"locationName":"methodName"}}},"So":{"type":"timestamp","timestampFormat":"iso8601"}}}');

});


parcelRequire.register("XW1VW", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $0b428663a6dc5a35$var$Service = $dbC7k.Service;
var $0b428663a6dc5a35$var$apiLoader = $dbC7k.apiLoader;
$0b428663a6dc5a35$var$apiLoader.services["iot1clickprojects"] = {};
$dbC7k.IoT1ClickProjects = $0b428663a6dc5a35$var$Service.defineService("iot1clickprojects", [
    "2018-05-14"
]);


Object.defineProperty($0b428663a6dc5a35$var$apiLoader.services["iot1clickprojects"], "2018-05-14", {
    get: function get() {
        var model = (parcelRequire("847C2"));
        model.paginators = (parcelRequire("gvneh")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.IoT1ClickProjects;

});
parcelRequire.register("847C2", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-05-14","endpointPrefix":"projects.iot1click","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"AWS IoT 1-Click Projects","serviceFullName":"AWS IoT 1-Click Projects Service","serviceId":"IoT 1Click Projects","signatureVersion":"v4","signingName":"iot1click","uid":"iot1click-projects-2018-05-14"},"operations":{"AssociateDeviceWithPlacement":{"http":{"method":"PUT","requestUri":"/projects/{projectName}/placements/{placementName}/devices/{deviceTemplateName}"},"input":{"type":"structure","required":["projectName","placementName","deviceId","deviceTemplateName"],"members":{"projectName":{"location":"uri","locationName":"projectName"},"placementName":{"location":"uri","locationName":"placementName"},"deviceId":{},"deviceTemplateName":{"location":"uri","locationName":"deviceTemplateName"}}},"output":{"type":"structure","members":{}}},"CreatePlacement":{"http":{"requestUri":"/projects/{projectName}/placements"},"input":{"type":"structure","required":["placementName","projectName"],"members":{"placementName":{},"projectName":{"location":"uri","locationName":"projectName"},"attributes":{"shape":"S8"}}},"output":{"type":"structure","members":{}}},"CreateProject":{"http":{"requestUri":"/projects"},"input":{"type":"structure","required":["projectName"],"members":{"projectName":{},"description":{},"placementTemplate":{"shape":"Se"},"tags":{"shape":"Sn"}}},"output":{"type":"structure","members":{}}},"DeletePlacement":{"http":{"method":"DELETE","requestUri":"/projects/{projectName}/placements/{placementName}"},"input":{"type":"structure","required":["placementName","projectName"],"members":{"placementName":{"location":"uri","locationName":"placementName"},"projectName":{"location":"uri","locationName":"projectName"}}},"output":{"type":"structure","members":{}}},"DeleteProject":{"http":{"method":"DELETE","requestUri":"/projects/{projectName}"},"input":{"type":"structure","required":["projectName"],"members":{"projectName":{"location":"uri","locationName":"projectName"}}},"output":{"type":"structure","members":{}}},"DescribePlacement":{"http":{"method":"GET","requestUri":"/projects/{projectName}/placements/{placementName}"},"input":{"type":"structure","required":["placementName","projectName"],"members":{"placementName":{"location":"uri","locationName":"placementName"},"projectName":{"location":"uri","locationName":"projectName"}}},"output":{"type":"structure","required":["placement"],"members":{"placement":{"type":"structure","required":["projectName","placementName","attributes","createdDate","updatedDate"],"members":{"projectName":{},"placementName":{},"attributes":{"shape":"S8"},"createdDate":{"type":"timestamp"},"updatedDate":{"type":"timestamp"}}}}}},"DescribeProject":{"http":{"method":"GET","requestUri":"/projects/{projectName}"},"input":{"type":"structure","required":["projectName"],"members":{"projectName":{"location":"uri","locationName":"projectName"}}},"output":{"type":"structure","required":["project"],"members":{"project":{"type":"structure","required":["projectName","createdDate","updatedDate"],"members":{"arn":{},"projectName":{},"description":{},"createdDate":{"type":"timestamp"},"updatedDate":{"type":"timestamp"},"placementTemplate":{"shape":"Se"},"tags":{"shape":"Sn"}}}}}},"DisassociateDeviceFromPlacement":{"http":{"method":"DELETE","requestUri":"/projects/{projectName}/placements/{placementName}/devices/{deviceTemplateName}"},"input":{"type":"structure","required":["projectName","placementName","deviceTemplateName"],"members":{"projectName":{"location":"uri","locationName":"projectName"},"placementName":{"location":"uri","locationName":"placementName"},"deviceTemplateName":{"location":"uri","locationName":"deviceTemplateName"}}},"output":{"type":"structure","members":{}}},"GetDevicesInPlacement":{"http":{"method":"GET","requestUri":"/projects/{projectName}/placements/{placementName}/devices"},"input":{"type":"structure","required":["projectName","placementName"],"members":{"projectName":{"location":"uri","locationName":"projectName"},"placementName":{"location":"uri","locationName":"placementName"}}},"output":{"type":"structure","required":["devices"],"members":{"devices":{"type":"map","key":{},"value":{}}}}},"ListPlacements":{"http":{"method":"GET","requestUri":"/projects/{projectName}/placements"},"input":{"type":"structure","required":["projectName"],"members":{"projectName":{"location":"uri","locationName":"projectName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["placements"],"members":{"placements":{"type":"list","member":{"type":"structure","required":["projectName","placementName","createdDate","updatedDate"],"members":{"projectName":{},"placementName":{},"createdDate":{"type":"timestamp"},"updatedDate":{"type":"timestamp"}}}},"nextToken":{}}}},"ListProjects":{"http":{"method":"GET","requestUri":"/projects"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["projects"],"members":{"projects":{"type":"list","member":{"type":"structure","required":["projectName","createdDate","updatedDate"],"members":{"arn":{},"projectName":{},"createdDate":{"type":"timestamp"},"updatedDate":{"type":"timestamp"},"tags":{"shape":"Sn"}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sn"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sn"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdatePlacement":{"http":{"method":"PUT","requestUri":"/projects/{projectName}/placements/{placementName}"},"input":{"type":"structure","required":["placementName","projectName"],"members":{"placementName":{"location":"uri","locationName":"placementName"},"projectName":{"location":"uri","locationName":"projectName"},"attributes":{"shape":"S8"}}},"output":{"type":"structure","members":{}}},"UpdateProject":{"http":{"method":"PUT","requestUri":"/projects/{projectName}"},"input":{"type":"structure","required":["projectName"],"members":{"projectName":{"location":"uri","locationName":"projectName"},"description":{},"placementTemplate":{"shape":"Se"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S8":{"type":"map","key":{},"value":{}},"Se":{"type":"structure","members":{"defaultAttributes":{"type":"map","key":{},"value":{}},"deviceTemplates":{"type":"map","key":{},"value":{"type":"structure","members":{"deviceType":{},"callbackOverrides":{"type":"map","key":{},"value":{}}}}}}},"Sn":{"type":"map","key":{},"value":{}}}}');

});

parcelRequire.register("gvneh", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListPlacements":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"placements"},"ListProjects":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"projects"}}}');

});


parcelRequire.register("6TmrW", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $50494b2af9755f6e$var$Service = $dbC7k.Service;
var $50494b2af9755f6e$var$apiLoader = $dbC7k.apiLoader;
$50494b2af9755f6e$var$apiLoader.services["pi"] = {};
$dbC7k.PI = $50494b2af9755f6e$var$Service.defineService("pi", [
    "2018-02-27"
]);


Object.defineProperty($50494b2af9755f6e$var$apiLoader.services["pi"], "2018-02-27", {
    get: function get() {
        var model = (parcelRequire("1wT3W"));
        model.paginators = (parcelRequire("1NyLH")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.PI;

});
parcelRequire.register("1wT3W", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-02-27","endpointPrefix":"pi","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"AWS PI","serviceFullName":"AWS Performance Insights","serviceId":"PI","signatureVersion":"v4","signingName":"pi","targetPrefix":"PerformanceInsightsv20180227","uid":"pi-2018-02-27"},"operations":{"DescribeDimensionKeys":{"input":{"type":"structure","required":["ServiceType","Identifier","StartTime","EndTime","Metric","GroupBy"],"members":{"ServiceType":{},"Identifier":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Metric":{},"PeriodInSeconds":{"type":"integer"},"GroupBy":{"shape":"S6"},"PartitionBy":{"shape":"S6"},"Filter":{"shape":"S9"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AlignedStartTime":{"type":"timestamp"},"AlignedEndTime":{"type":"timestamp"},"PartitionKeys":{"type":"list","member":{"type":"structure","required":["Dimensions"],"members":{"Dimensions":{"shape":"Se"}}}},"Keys":{"type":"list","member":{"type":"structure","members":{"Dimensions":{"shape":"Se"},"Total":{"type":"double"},"Partitions":{"type":"list","member":{"type":"double"}}}}},"NextToken":{}}}},"GetResourceMetrics":{"input":{"type":"structure","required":["ServiceType","Identifier","MetricQueries","StartTime","EndTime"],"members":{"ServiceType":{},"Identifier":{},"MetricQueries":{"type":"list","member":{"type":"structure","required":["Metric"],"members":{"Metric":{},"GroupBy":{"shape":"S6"},"Filter":{"shape":"S9"}}}},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"PeriodInSeconds":{"type":"integer"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AlignedStartTime":{"type":"timestamp"},"AlignedEndTime":{"type":"timestamp"},"Identifier":{},"MetricList":{"type":"list","member":{"type":"structure","members":{"Key":{"type":"structure","required":["Metric"],"members":{"Metric":{},"Dimensions":{"shape":"Se"}}},"DataPoints":{"type":"list","member":{"type":"structure","required":["Timestamp","Value"],"members":{"Timestamp":{"type":"timestamp"},"Value":{"type":"double"}}}}}}},"NextToken":{}}}}},"shapes":{"S6":{"type":"structure","required":["Group"],"members":{"Group":{},"Dimensions":{"type":"list","member":{}},"Limit":{"type":"integer"}}},"S9":{"type":"map","key":{},"value":{}},"Se":{"type":"map","key":{},"value":{}}}}');

});

parcelRequire.register("1NyLH", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("dxfDP", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $9daa7d769d44a8c4$var$Service = $dbC7k.Service;
var $9daa7d769d44a8c4$var$apiLoader = $dbC7k.apiLoader;
$9daa7d769d44a8c4$var$apiLoader.services["neptune"] = {};
$dbC7k.Neptune = $9daa7d769d44a8c4$var$Service.defineService("neptune", [
    "2014-10-31"
]);



Object.defineProperty($9daa7d769d44a8c4$var$apiLoader.services["neptune"], "2014-10-31", {
    get: function get() {
        var model = (parcelRequire("jk5z8"));
        model.paginators = (parcelRequire("HNCMr")).pagination;
        model.waiters = (parcelRequire("7D30Q")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Neptune;

});
parcelRequire.register("jk5z8", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2014-10-31","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon Neptune","serviceFullName":"Amazon Neptune","serviceId":"Neptune","signatureVersion":"v4","signingName":"rds","uid":"neptune-2014-10-31","xmlNamespace":"http://rds.amazonaws.com/doc/2014-10-31/"},"operations":{"AddRoleToDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","RoleArn"],"members":{"DBClusterIdentifier":{},"RoleArn":{}}}},"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S5"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"Sa"}}}},"ApplyPendingMaintenanceAction":{"input":{"type":"structure","required":["ResourceIdentifier","ApplyAction","OptInType"],"members":{"ResourceIdentifier":{},"ApplyAction":{},"OptInType":{}}},"output":{"resultWrapper":"ApplyPendingMaintenanceActionResult","type":"structure","members":{"ResourcePendingMaintenanceActions":{"shape":"Se"}}}},"CopyDBClusterParameterGroup":{"input":{"type":"structure","required":["SourceDBClusterParameterGroupIdentifier","TargetDBClusterParameterGroupIdentifier","TargetDBClusterParameterGroupDescription"],"members":{"SourceDBClusterParameterGroupIdentifier":{},"TargetDBClusterParameterGroupIdentifier":{},"TargetDBClusterParameterGroupDescription":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CopyDBClusterParameterGroupResult","type":"structure","members":{"DBClusterParameterGroup":{"shape":"Sk"}}}},"CopyDBClusterSnapshot":{"input":{"type":"structure","required":["SourceDBClusterSnapshotIdentifier","TargetDBClusterSnapshotIdentifier"],"members":{"SourceDBClusterSnapshotIdentifier":{},"TargetDBClusterSnapshotIdentifier":{},"KmsKeyId":{},"PreSignedUrl":{},"CopyTags":{"type":"boolean"},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CopyDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"So"}}}},"CopyDBParameterGroup":{"input":{"type":"structure","required":["SourceDBParameterGroupIdentifier","TargetDBParameterGroupIdentifier","TargetDBParameterGroupDescription"],"members":{"SourceDBParameterGroupIdentifier":{},"TargetDBParameterGroupIdentifier":{},"TargetDBParameterGroupDescription":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CopyDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"St"}}}},"CreateDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","Engine"],"members":{"AvailabilityZones":{"shape":"Sp"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"Sw"},"DBSubnetGroupName":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"MasterUsername":{},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"ReplicationSourceIdentifier":{},"Tags":{"shape":"Sa"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"PreSignedUrl":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnableCloudwatchLogsExports":{"shape":"Sx"}}},"output":{"resultWrapper":"CreateDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sz"}}}},"CreateDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBClusterParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateDBClusterParameterGroupResult","type":"structure","members":{"DBClusterParameterGroup":{"shape":"Sk"}}}},"CreateDBClusterSnapshot":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier","DBClusterIdentifier"],"members":{"DBClusterSnapshotIdentifier":{},"DBClusterIdentifier":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"So"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBInstanceClass","Engine"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"S1e"},"VpcSecurityGroupIds":{"shape":"Sw"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"deprecated":true,"type":"boolean"},"Tags":{"shape":"Sa"},"DBClusterIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"Domain":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"DomainIAMRoleName":{},"PromotionTier":{"type":"integer"},"Timezone":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"EnableCloudwatchLogsExports":{"shape":"Sx"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1g"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"St"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S23"},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S1m"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S7"},"SourceIds":{"shape":"S6"},"Enabled":{"type":"boolean"},"Tags":{"shape":"Sa"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S5"}}}},"DeleteDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sz"}}}},"DeleteDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{}}}},"DeleteDBClusterSnapshot":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier"],"members":{"DBClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"So"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1g"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S5"}}}},"DescribeDBClusterParameterGroups":{"input":{"type":"structure","members":{"DBClusterParameterGroupName":{},"Filters":{"shape":"S2j"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterParameterGroupsResult","type":"structure","members":{"Marker":{},"DBClusterParameterGroups":{"type":"list","member":{"shape":"Sk","locationName":"DBClusterParameterGroup"}}}}},"DescribeDBClusterParameters":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{},"Source":{},"Filters":{"shape":"S2j"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterParametersResult","type":"structure","members":{"Parameters":{"shape":"S2q"},"Marker":{}}}},"DescribeDBClusterSnapshotAttributes":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier"],"members":{"DBClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DescribeDBClusterSnapshotAttributesResult","type":"structure","members":{"DBClusterSnapshotAttributesResult":{"shape":"S2v"}}}},"DescribeDBClusterSnapshots":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"DBClusterSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S2j"},"MaxRecords":{"type":"integer"},"Marker":{},"IncludeShared":{"type":"boolean"},"IncludePublic":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBClusterSnapshotsResult","type":"structure","members":{"Marker":{},"DBClusterSnapshots":{"type":"list","member":{"shape":"So","locationName":"DBClusterSnapshot"}}}}},"DescribeDBClusters":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"Filters":{"shape":"S2j"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClustersResult","type":"structure","members":{"Marker":{},"DBClusters":{"type":"list","member":{"shape":"Sz","locationName":"DBCluster"}}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S2j"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"},"ListSupportedTimezones":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S39"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S39","locationName":"CharacterSet"}},"ValidUpgradeTarget":{"type":"list","member":{"locationName":"UpgradeTarget","type":"structure","members":{"Engine":{},"EngineVersion":{},"Description":{},"AutoUpgrade":{"type":"boolean"},"IsMajorVersionUpgrade":{"type":"boolean"}}}},"SupportedTimezones":{"type":"list","member":{"locationName":"Timezone","type":"structure","members":{"TimezoneName":{}}}},"ExportableLogTypes":{"shape":"Sx"},"SupportsLogExportsToCloudwatchLogs":{"type":"boolean"},"SupportsReadReplica":{"type":"boolean"}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S2j"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"S1g","locationName":"DBInstance"}}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"Filters":{"shape":"S2j"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"St","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"Filters":{"shape":"S2j"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2q"},"Marker":{}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S2j"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S1m","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultClusterParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S2j"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultClusterParametersResult","type":"structure","members":{"EngineDefaults":{"shape":"S3s"}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S2j"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"shape":"S3s"}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S2j"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S7"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S2j"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S5","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S7"},"Filters":{"shape":"S2j"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S7"},"Date":{"type":"timestamp"},"SourceArn":{}}}}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S2j"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S1p","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"},"SupportsStorageEncryption":{"type":"boolean"},"StorageType":{},"SupportsIops":{"type":"boolean"},"SupportsEnhancedMonitoring":{"type":"boolean"},"SupportsIAMDatabaseAuthentication":{"type":"boolean"},"SupportsPerformanceInsights":{"type":"boolean"},"MinStorageSize":{"type":"integer"},"MaxStorageSize":{"type":"integer"},"MinIopsPerDbInstance":{"type":"integer"},"MaxIopsPerDbInstance":{"type":"integer"},"MinIopsPerGib":{"type":"double"},"MaxIopsPerGib":{"type":"double"}},"wrapper":true}},"Marker":{}}}},"DescribePendingMaintenanceActions":{"input":{"type":"structure","members":{"ResourceIdentifier":{},"Filters":{"shape":"S2j"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribePendingMaintenanceActionsResult","type":"structure","members":{"PendingMaintenanceActions":{"type":"list","member":{"shape":"Se","locationName":"ResourcePendingMaintenanceActions"}},"Marker":{}}}},"DescribeValidDBInstanceModifications":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"DescribeValidDBInstanceModificationsResult","type":"structure","members":{"ValidDBInstanceModificationsMessage":{"type":"structure","members":{"Storage":{"type":"list","member":{"locationName":"ValidStorageOptions","type":"structure","members":{"StorageType":{},"StorageSize":{"shape":"S4l"},"ProvisionedIops":{"shape":"S4l"},"IopsToStorageRatio":{"type":"list","member":{"locationName":"DoubleRange","type":"structure","members":{"From":{"type":"double"},"To":{"type":"double"}}}}}}}},"wrapper":true}}}},"FailoverDBCluster":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"TargetDBInstanceIdentifier":{}}},"output":{"resultWrapper":"FailoverDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sz"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S2j"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"Sa"}}}},"ModifyDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"NewDBClusterIdentifier":{},"ApplyImmediately":{"type":"boolean"},"BackupRetentionPeriod":{"type":"integer"},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"Sw"},"Port":{"type":"integer"},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"CloudwatchLogsExportConfiguration":{"shape":"S4v"},"EngineVersion":{}}},"output":{"resultWrapper":"ModifyDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sz"}}}},"ModifyDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName","Parameters"],"members":{"DBClusterParameterGroupName":{},"Parameters":{"shape":"S2q"}}},"output":{"shape":"S4y","resultWrapper":"ModifyDBClusterParameterGroupResult"}},"ModifyDBClusterSnapshotAttribute":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier","AttributeName"],"members":{"DBClusterSnapshotIdentifier":{},"AttributeName":{},"ValuesToAdd":{"shape":"S2y"},"ValuesToRemove":{"shape":"S2y"}}},"output":{"resultWrapper":"ModifyDBClusterSnapshotAttributeResult","type":"structure","members":{"DBClusterSnapshotAttributesResult":{"shape":"S2v"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSubnetGroupName":{},"DBSecurityGroups":{"shape":"S1e"},"VpcSecurityGroupIds":{"shape":"Sw"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"CACertificateIdentifier":{},"Domain":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"DBPortNumber":{"type":"integer"},"PubliclyAccessible":{"deprecated":true,"type":"boolean"},"MonitoringRoleArn":{},"DomainIAMRoleName":{},"PromotionTier":{"type":"integer"},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"CloudwatchLogsExportConfiguration":{"shape":"S4v"}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1g"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2q"}}},"output":{"shape":"S54","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S23"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S1m"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S7"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S5"}}}},"PromoteReadReplicaDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"PromoteReadReplicaDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sz"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S1g"}}}},"RemoveRoleFromDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","RoleArn"],"members":{"DBClusterIdentifier":{},"RoleArn":{}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S5"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2q"}}},"output":{"shape":"S4y","resultWrapper":"ResetDBClusterParameterGroupResult"}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2q"}}},"output":{"shape":"S54","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBClusterFromSnapshot":{"input":{"type":"structure","required":["DBClusterIdentifier","SnapshotIdentifier","Engine"],"members":{"AvailabilityZones":{"shape":"Sp"},"DBClusterIdentifier":{},"SnapshotIdentifier":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"DBSubnetGroupName":{},"DatabaseName":{},"OptionGroupName":{},"VpcSecurityGroupIds":{"shape":"Sw"},"Tags":{"shape":"Sa"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnableCloudwatchLogsExports":{"shape":"Sx"},"DBClusterParameterGroupName":{}}},"output":{"resultWrapper":"RestoreDBClusterFromSnapshotResult","type":"structure","members":{"DBCluster":{"shape":"Sz"}}}},"RestoreDBClusterToPointInTime":{"input":{"type":"structure","required":["DBClusterIdentifier","SourceDBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"RestoreType":{},"SourceDBClusterIdentifier":{},"RestoreToTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"Port":{"type":"integer"},"DBSubnetGroupName":{},"OptionGroupName":{},"VpcSecurityGroupIds":{"shape":"Sw"},"Tags":{"shape":"Sa"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnableCloudwatchLogsExports":{"shape":"Sx"},"DBClusterParameterGroupName":{}}},"output":{"resultWrapper":"RestoreDBClusterToPointInTimeResult","type":"structure","members":{"DBCluster":{"shape":"Sz"}}}}},"shapes":{"S5":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S6"},"EventCategoriesList":{"shape":"S7"},"Enabled":{"type":"boolean"},"EventSubscriptionArn":{}},"wrapper":true},"S6":{"type":"list","member":{"locationName":"SourceId"}},"S7":{"type":"list","member":{"locationName":"EventCategory"}},"Sa":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Se":{"type":"structure","members":{"ResourceIdentifier":{},"PendingMaintenanceActionDetails":{"type":"list","member":{"locationName":"PendingMaintenanceAction","type":"structure","members":{"Action":{},"AutoAppliedAfterDate":{"type":"timestamp"},"ForcedApplyDate":{"type":"timestamp"},"OptInStatus":{},"CurrentApplyDate":{"type":"timestamp"},"Description":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBClusterParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"DBClusterParameterGroupArn":{}},"wrapper":true},"So":{"type":"structure","members":{"AvailabilityZones":{"shape":"Sp"},"DBClusterSnapshotIdentifier":{},"DBClusterIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"VpcId":{},"ClusterCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"PercentProgress":{"type":"integer"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DBClusterSnapshotArn":{},"SourceDBClusterSnapshotArn":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"AvailabilityZone"}},"St":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"DBParameterGroupArn":{}},"wrapper":true},"Sw":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"Sx":{"type":"list","member":{}},"Sz":{"type":"structure","members":{"AllocatedStorage":{"type":"integer"},"AvailabilityZones":{"shape":"Sp"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroup":{},"DBSubnetGroup":{},"Status":{},"PercentProgress":{},"EarliestRestorableTime":{"type":"timestamp"},"Endpoint":{},"ReaderEndpoint":{},"MultiAZ":{"type":"boolean"},"Engine":{},"EngineVersion":{},"LatestRestorableTime":{"type":"timestamp"},"Port":{"type":"integer"},"MasterUsername":{},"DBClusterOptionGroupMemberships":{"type":"list","member":{"locationName":"DBClusterOptionGroup","type":"structure","members":{"DBClusterOptionGroupName":{},"Status":{}}}},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"ReplicationSourceIdentifier":{},"ReadReplicaIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaIdentifier"}},"DBClusterMembers":{"type":"list","member":{"locationName":"DBClusterMember","type":"structure","members":{"DBInstanceIdentifier":{},"IsClusterWriter":{"type":"boolean"},"DBClusterParameterGroupStatus":{},"PromotionTier":{"type":"integer"}},"wrapper":true}},"VpcSecurityGroups":{"shape":"S15"},"HostedZoneId":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbClusterResourceId":{},"DBClusterArn":{},"AssociatedRoles":{"type":"list","member":{"locationName":"DBClusterRole","type":"structure","members":{"RoleArn":{},"Status":{}}}},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"CloneGroupId":{},"ClusterCreateTime":{"type":"timestamp"},"EnabledCloudwatchLogsExports":{"shape":"Sx"}},"wrapper":true},"S15":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S1e":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"S1g":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"},"HostedZoneId":{}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"VpcSecurityGroups":{"shape":"S15"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S1m"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"LicenseModel":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{},"StorageType":{},"CACertificateIdentifier":{},"DBSubnetGroupName":{},"PendingCloudwatchLogsExports":{"type":"structure","members":{"LogTypesToEnable":{"shape":"Sx"},"LogTypesToDisable":{"shape":"Sx"}}}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"ReadReplicaDBClusterIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBClusterIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"deprecated":true,"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}},"StorageType":{},"TdeCredentialArn":{},"DbInstancePort":{"type":"integer"},"DBClusterIdentifier":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbiResourceId":{},"CACertificateIdentifier":{},"DomainMemberships":{"type":"list","member":{"locationName":"DomainMembership","type":"structure","members":{"Domain":{},"Status":{},"FQDN":{},"IAMRoleName":{}}}},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"EnhancedMonitoringResourceArn":{},"MonitoringRoleArn":{},"PromotionTier":{"type":"integer"},"DBInstanceArn":{},"Timezone":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"PerformanceInsightsEnabled":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"EnabledCloudwatchLogsExports":{"shape":"Sx"}},"wrapper":true},"S1m":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S1p"},"SubnetStatus":{}}}},"DBSubnetGroupArn":{}},"wrapper":true},"S1p":{"type":"structure","members":{"Name":{}},"wrapper":true},"S23":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S2j":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S2q":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S2v":{"type":"structure","members":{"DBClusterSnapshotIdentifier":{},"DBClusterSnapshotAttributes":{"type":"list","member":{"locationName":"DBClusterSnapshotAttribute","type":"structure","members":{"AttributeName":{},"AttributeValues":{"shape":"S2y"}}}}},"wrapper":true},"S2y":{"type":"list","member":{"locationName":"AttributeValue"}},"S39":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S3s":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2q"}},"wrapper":true},"S4l":{"type":"list","member":{"locationName":"Range","type":"structure","members":{"From":{"type":"integer"},"To":{"type":"integer"},"Step":{"type":"integer"}}}},"S4v":{"type":"structure","members":{"EnableLogTypes":{"shape":"Sx"},"DisableLogTypes":{"shape":"Sx"}}},"S4y":{"type":"structure","members":{"DBClusterParameterGroupName":{}}},"S54":{"type":"structure","members":{"DBParameterGroupName":{}}}}}');

});

parcelRequire.register("HNCMr", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"ListTagsForResource":{"result_key":"TagList"}}}');

});

parcelRequire.register("7D30Q", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"DBInstanceAvailable":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBInstanceDeleted":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"DBInstanceNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]}}}');

});


parcelRequire.register("iUX15", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $dc5b3c67b04f600c$var$Service = $dbC7k.Service;
var $dc5b3c67b04f600c$var$apiLoader = $dbC7k.apiLoader;
$dc5b3c67b04f600c$var$apiLoader.services["mediatailor"] = {};
$dbC7k.MediaTailor = $dc5b3c67b04f600c$var$Service.defineService("mediatailor", [
    "2018-04-23"
]);


Object.defineProperty($dc5b3c67b04f600c$var$apiLoader.services["mediatailor"], "2018-04-23", {
    get: function get() {
        var model = (parcelRequire("hRNHS"));
        model.paginators = (parcelRequire("aAVQ2")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.MediaTailor;

});
parcelRequire.register("hRNHS", function(module, exports) {
module.exports = JSON.parse('{"metadata":{"apiVersion":"2018-04-23","endpointPrefix":"api.mediatailor","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"MediaTailor","serviceFullName":"AWS MediaTailor","serviceId":"MediaTailor","signatureVersion":"v4","signingName":"mediatailor","uid":"mediatailor-2018-04-23"},"operations":{"DeletePlaybackConfiguration":{"http":{"method":"DELETE","requestUri":"/playbackConfiguration/{Name}","responseCode":204},"input":{"members":{"Name":{"location":"uri","locationName":"Name"}},"required":["Name"],"type":"structure"},"output":{"members":{},"type":"structure"}},"GetPlaybackConfiguration":{"http":{"method":"GET","requestUri":"/playbackConfiguration/{Name}","responseCode":200},"input":{"members":{"Name":{"location":"uri","locationName":"Name"}},"required":["Name"],"type":"structure"},"output":{"members":{"AdDecisionServerUrl":{},"CdnConfiguration":{"shape":"S6"},"DashConfiguration":{"shape":"S7"},"HlsConfiguration":{"shape":"S9"},"Name":{},"PlaybackConfigurationArn":{},"PlaybackEndpointPrefix":{},"SessionInitializationEndpointPrefix":{},"SlateAdUrl":{},"Tags":{"locationName":"tags","shape":"Sa"},"TranscodeProfileName":{},"VideoContentSourceUrl":{}},"type":"structure"}},"ListPlaybackConfigurations":{"http":{"method":"GET","requestUri":"/playbackConfigurations","responseCode":200},"input":{"members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}},"type":"structure"},"output":{"members":{"Items":{"member":{"members":{"AdDecisionServerUrl":{},"CdnConfiguration":{"shape":"S6"},"DashConfiguration":{"shape":"S7"},"HlsConfiguration":{"shape":"S9"},"Name":{},"PlaybackConfigurationArn":{},"PlaybackEndpointPrefix":{},"SessionInitializationEndpointPrefix":{},"SlateAdUrl":{},"Tags":{"locationName":"tags","shape":"Sa"},"TranscodeProfileName":{},"VideoContentSourceUrl":{}},"type":"structure"},"type":"list"},"NextToken":{}},"type":"structure"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"}},"required":["ResourceArn"],"type":"structure"},"output":{"members":{"Tags":{"locationName":"tags","shape":"Sa"}},"type":"structure"}},"PutPlaybackConfiguration":{"http":{"method":"PUT","requestUri":"/playbackConfiguration","responseCode":200},"input":{"members":{"AdDecisionServerUrl":{},"CdnConfiguration":{"shape":"S6"},"DashConfiguration":{"members":{"MpdLocation":{},"OriginManifestType":{}},"type":"structure"},"Name":{},"SlateAdUrl":{},"Tags":{"locationName":"tags","shape":"Sa"},"TranscodeProfileName":{},"VideoContentSourceUrl":{}},"type":"structure"},"output":{"members":{"AdDecisionServerUrl":{},"CdnConfiguration":{"shape":"S6"},"DashConfiguration":{"shape":"S7"},"HlsConfiguration":{"shape":"S9"},"Name":{},"PlaybackConfigurationArn":{},"PlaybackEndpointPrefix":{},"SessionInitializationEndpointPrefix":{},"SlateAdUrl":{},"Tags":{"locationName":"tags","shape":"Sa"},"TranscodeProfileName":{},"VideoContentSourceUrl":{}},"type":"structure"}},"TagResource":{"http":{"requestUri":"/tags/{ResourceArn}","responseCode":204},"input":{"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"Tags":{"locationName":"tags","shape":"Sa"}},"required":["ResourceArn","Tags"],"type":"structure"}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{ResourceArn}","responseCode":204},"input":{"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","member":{},"type":"list"}},"required":["ResourceArn","TagKeys"],"type":"structure"}}},"shapes":{"S6":{"members":{"AdSegmentUrlPrefix":{},"ContentSegmentUrlPrefix":{}},"type":"structure"},"S7":{"members":{"ManifestEndpointPrefix":{},"MpdLocation":{},"OriginManifestType":{}},"type":"structure"},"S9":{"members":{"ManifestEndpointPrefix":{}},"type":"structure"},"Sa":{"key":{},"type":"map","value":{}}}}');

});

parcelRequire.register("aAVQ2", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("kSCoZ", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $f336a3a65be21753$var$Service = $dbC7k.Service;
var $f336a3a65be21753$var$apiLoader = $dbC7k.apiLoader;
$f336a3a65be21753$var$apiLoader.services["eks"] = {};
$dbC7k.EKS = $f336a3a65be21753$var$Service.defineService("eks", [
    "2017-11-01"
]);



Object.defineProperty($f336a3a65be21753$var$apiLoader.services["eks"], "2017-11-01", {
    get: function get() {
        var model = (parcelRequire("jvaiQ"));
        model.paginators = (parcelRequire("cCIAM")).pagination;
        model.waiters = (parcelRequire("cCYBW")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.EKS;

});
parcelRequire.register("jvaiQ", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-11-01","endpointPrefix":"eks","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Amazon EKS","serviceFullName":"Amazon Elastic Kubernetes Service","serviceId":"EKS","signatureVersion":"v4","signingName":"eks","uid":"eks-2017-11-01"},"operations":{"CreateCluster":{"http":{"requestUri":"/clusters"},"input":{"type":"structure","required":["name","roleArn","resourcesVpcConfig"],"members":{"name":{},"version":{},"roleArn":{},"resourcesVpcConfig":{"shape":"S4"},"logging":{"shape":"S7"},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"cluster":{"shape":"Sd"}}}},"DeleteCluster":{"http":{"method":"DELETE","requestUri":"/clusters/{name}"},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"cluster":{"shape":"Sd"}}}},"DescribeCluster":{"http":{"method":"GET","requestUri":"/clusters/{name}"},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"cluster":{"shape":"Sd"}}}},"DescribeUpdate":{"http":{"method":"GET","requestUri":"/clusters/{name}/updates/{updateId}"},"input":{"type":"structure","required":["name","updateId"],"members":{"name":{"location":"uri","locationName":"name"},"updateId":{"location":"uri","locationName":"updateId"}}},"output":{"type":"structure","members":{"update":{"shape":"Sp"}}}},"ListClusters":{"http":{"method":"GET","requestUri":"/clusters"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"clusters":{"shape":"S5"},"nextToken":{}}}},"ListUpdates":{"http":{"method":"GET","requestUri":"/clusters/{name}/updates"},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"updateIds":{"shape":"S5"},"nextToken":{}}}},"UpdateClusterConfig":{"http":{"requestUri":"/clusters/{name}/update-config"},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"resourcesVpcConfig":{"shape":"S4"},"logging":{"shape":"S7"},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"update":{"shape":"Sp"}}}},"UpdateClusterVersion":{"http":{"requestUri":"/clusters/{name}/updates"},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"update":{"shape":"Sp"}}}}},"shapes":{"S4":{"type":"structure","members":{"subnetIds":{"shape":"S5"},"securityGroupIds":{"shape":"S5"},"endpointPublicAccess":{"type":"boolean"},"endpointPrivateAccess":{"type":"boolean"}}},"S5":{"type":"list","member":{}},"S7":{"type":"structure","members":{"clusterLogging":{"type":"list","member":{"type":"structure","members":{"types":{"type":"list","member":{}},"enabled":{"type":"boolean"}}}}}},"Sd":{"type":"structure","members":{"name":{},"arn":{},"createdAt":{"type":"timestamp"},"version":{},"endpoint":{},"roleArn":{},"resourcesVpcConfig":{"type":"structure","members":{"subnetIds":{"shape":"S5"},"securityGroupIds":{"shape":"S5"},"vpcId":{},"endpointPublicAccess":{"type":"boolean"},"endpointPrivateAccess":{"type":"boolean"}}},"logging":{"shape":"S7"},"status":{},"certificateAuthority":{"type":"structure","members":{"data":{}}},"clientRequestToken":{},"platformVersion":{}}},"Sp":{"type":"structure","members":{"id":{},"status":{},"type":{},"params":{"type":"list","member":{"type":"structure","members":{"type":{},"value":{}}}},"createdAt":{"type":"timestamp"},"errors":{"type":"list","member":{"type":"structure","members":{"errorCode":{},"errorMessage":{},"resourceIds":{"shape":"S5"}}}}}}}}');

});

parcelRequire.register("cCIAM", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});

parcelRequire.register("cCYBW", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"ClusterActive":{"delay":30,"operation":"DescribeCluster","maxAttempts":40,"acceptors":[{"expected":"DELETING","matcher":"path","state":"failure","argument":"cluster.status"},{"expected":"FAILED","matcher":"path","state":"failure","argument":"cluster.status"},{"expected":"ACTIVE","matcher":"path","state":"success","argument":"cluster.status"}]},"ClusterDeleted":{"delay":30,"operation":"DescribeCluster","maxAttempts":40,"acceptors":[{"expected":"ACTIVE","matcher":"path","state":"failure","argument":"cluster.status"},{"expected":"CREATING","matcher":"path","state":"failure","argument":"cluster.status"},{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]}}}');

});


parcelRequire.register("9HUEc", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $71141236664d7812$var$Service = $dbC7k.Service;
var $71141236664d7812$var$apiLoader = $dbC7k.apiLoader;
$71141236664d7812$var$apiLoader.services["macie"] = {};
$dbC7k.Macie = $71141236664d7812$var$Service.defineService("macie", [
    "2017-12-19"
]);


Object.defineProperty($71141236664d7812$var$apiLoader.services["macie"], "2017-12-19", {
    get: function get() {
        var model = (parcelRequire("aMMCf"));
        model.paginators = (parcelRequire("FAAxK")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Macie;

});
parcelRequire.register("aMMCf", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-12-19","endpointPrefix":"macie","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Macie","serviceId":"Macie","signatureVersion":"v4","targetPrefix":"MacieService","uid":"macie-2017-12-19"},"operations":{"AssociateMemberAccount":{"input":{"type":"structure","required":["memberAccountId"],"members":{"memberAccountId":{}}}},"AssociateS3Resources":{"input":{"type":"structure","required":["s3Resources"],"members":{"memberAccountId":{},"s3Resources":{"shape":"S4"}}},"output":{"type":"structure","members":{"failedS3Resources":{"shape":"Sc"}}}},"DisassociateMemberAccount":{"input":{"type":"structure","required":["memberAccountId"],"members":{"memberAccountId":{}}}},"DisassociateS3Resources":{"input":{"type":"structure","required":["associatedS3Resources"],"members":{"memberAccountId":{},"associatedS3Resources":{"type":"list","member":{"shape":"Se"}}}},"output":{"type":"structure","members":{"failedS3Resources":{"shape":"Sc"}}}},"ListMemberAccounts":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"memberAccounts":{"type":"list","member":{"type":"structure","members":{"accountId":{}}}},"nextToken":{}}}},"ListS3Resources":{"input":{"type":"structure","members":{"memberAccountId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"s3Resources":{"shape":"S4"},"nextToken":{}}}},"UpdateS3Resources":{"input":{"type":"structure","required":["s3ResourcesUpdate"],"members":{"memberAccountId":{},"s3ResourcesUpdate":{"type":"list","member":{"type":"structure","required":["bucketName","classificationTypeUpdate"],"members":{"bucketName":{},"prefix":{},"classificationTypeUpdate":{"type":"structure","members":{"oneTime":{},"continuous":{}}}}}}}},"output":{"type":"structure","members":{"failedS3Resources":{"shape":"Sc"}}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","required":["bucketName","classificationType"],"members":{"bucketName":{},"prefix":{},"classificationType":{"type":"structure","required":["oneTime","continuous"],"members":{"oneTime":{},"continuous":{}}}}}},"Sc":{"type":"list","member":{"type":"structure","members":{"failedItem":{"shape":"Se"},"errorCode":{},"errorMessage":{}}}},"Se":{"type":"structure","required":["bucketName"],"members":{"bucketName":{},"prefix":{}}}}}');

});

parcelRequire.register("FAAxK", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListMemberAccounts":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListS3Resources":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}');

});


parcelRequire.register("8Isi7", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $01a33b5e4cd6d08d$var$Service = $dbC7k.Service;
var $01a33b5e4cd6d08d$var$apiLoader = $dbC7k.apiLoader;
$01a33b5e4cd6d08d$var$apiLoader.services["dlm"] = {};
$dbC7k.DLM = $01a33b5e4cd6d08d$var$Service.defineService("dlm", [
    "2018-01-12"
]);


Object.defineProperty($01a33b5e4cd6d08d$var$apiLoader.services["dlm"], "2018-01-12", {
    get: function get() {
        var model = (parcelRequire("1XRJH"));
        model.paginators = (parcelRequire("gsOzt")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.DLM;

});
parcelRequire.register("1XRJH", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-01-12","endpointPrefix":"dlm","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Amazon DLM","serviceFullName":"Amazon Data Lifecycle Manager","serviceId":"DLM","signatureVersion":"v4","signingName":"dlm","uid":"dlm-2018-01-12"},"operations":{"CreateLifecyclePolicy":{"http":{"requestUri":"/policies"},"input":{"type":"structure","required":["ExecutionRoleArn","Description","State","PolicyDetails"],"members":{"ExecutionRoleArn":{},"Description":{},"State":{},"PolicyDetails":{"shape":"S5"}}},"output":{"type":"structure","members":{"PolicyId":{}}}},"DeleteLifecyclePolicy":{"http":{"method":"DELETE","requestUri":"/policies/{policyId}/"},"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{"location":"uri","locationName":"policyId"}}},"output":{"type":"structure","members":{}}},"GetLifecyclePolicies":{"http":{"method":"GET","requestUri":"/policies"},"input":{"type":"structure","members":{"PolicyIds":{"location":"querystring","locationName":"policyIds","type":"list","member":{}},"State":{"location":"querystring","locationName":"state"},"ResourceTypes":{"shape":"S7","location":"querystring","locationName":"resourceTypes"},"TargetTags":{"location":"querystring","locationName":"targetTags","type":"list","member":{}},"TagsToAdd":{"location":"querystring","locationName":"tagsToAdd","type":"list","member":{}}}},"output":{"type":"structure","members":{"Policies":{"type":"list","member":{"type":"structure","members":{"PolicyId":{},"Description":{},"State":{}}}}}}},"GetLifecyclePolicy":{"http":{"method":"GET","requestUri":"/policies/{policyId}/"},"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{"location":"uri","locationName":"policyId"}}},"output":{"type":"structure","members":{"Policy":{"type":"structure","members":{"PolicyId":{},"Description":{},"State":{},"ExecutionRoleArn":{},"DateCreated":{"shape":"S17"},"DateModified":{"shape":"S17"},"PolicyDetails":{"shape":"S5"}}}}}},"UpdateLifecyclePolicy":{"http":{"method":"PATCH","requestUri":"/policies/{policyId}"},"input":{"type":"structure","required":["PolicyId"],"members":{"PolicyId":{"location":"uri","locationName":"policyId"},"ExecutionRoleArn":{},"State":{},"Description":{},"PolicyDetails":{"shape":"S5"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S5":{"type":"structure","members":{"PolicyType":{},"ResourceTypes":{"shape":"S7"},"TargetTags":{"type":"list","member":{"shape":"Sa"}},"Schedules":{"type":"list","member":{"type":"structure","members":{"Name":{},"CopyTags":{"type":"boolean"},"TagsToAdd":{"type":"list","member":{"shape":"Sa"}},"VariableTags":{"type":"list","member":{"shape":"Sa"}},"CreateRule":{"type":"structure","required":["Interval","IntervalUnit"],"members":{"Interval":{"type":"integer"},"IntervalUnit":{},"Times":{"type":"list","member":{}}}},"RetainRule":{"type":"structure","required":["Count"],"members":{"Count":{"type":"integer"}}}}}},"Parameters":{"type":"structure","members":{"ExcludeBootVolume":{"type":"boolean"}}}}},"S7":{"type":"list","member":{}},"Sa":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"S17":{"type":"timestamp","timestampFormat":"iso8601"}}}');

});

parcelRequire.register("gsOzt", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("1dwEY", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $0e3056e979baea88$var$Service = $dbC7k.Service;
var $0e3056e979baea88$var$apiLoader = $dbC7k.apiLoader;
$0e3056e979baea88$var$apiLoader.services["signer"] = {};
$dbC7k.Signer = $0e3056e979baea88$var$Service.defineService("signer", [
    "2017-08-25"
]);



Object.defineProperty($0e3056e979baea88$var$apiLoader.services["signer"], "2017-08-25", {
    get: function get() {
        var model = (parcelRequire("cBTvi"));
        model.paginators = (parcelRequire("28NjI")).pagination;
        model.waiters = (parcelRequire("1p2dI")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Signer;

});
parcelRequire.register("cBTvi", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-08-25","endpointPrefix":"signer","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"signer","serviceFullName":"AWS Signer","serviceId":"signer","signatureVersion":"v4","signingName":"signer","uid":"signer-2017-08-25"},"operations":{"CancelSigningProfile":{"http":{"method":"DELETE","requestUri":"/signing-profiles/{profileName}"},"input":{"type":"structure","required":["profileName"],"members":{"profileName":{"location":"uri","locationName":"profileName"}}}},"DescribeSigningJob":{"http":{"method":"GET","requestUri":"/signing-jobs/{jobId}"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"type":"structure","members":{"jobId":{},"source":{"shape":"S6"},"signingMaterial":{"shape":"Sb"},"platformId":{},"profileName":{},"overrides":{"shape":"Se"},"signingParameters":{"shape":"Si"},"createdAt":{"type":"timestamp"},"completedAt":{"type":"timestamp"},"requestedBy":{},"status":{},"statusReason":{},"signedObject":{"shape":"Sq"}}}},"GetSigningPlatform":{"http":{"method":"GET","requestUri":"/signing-platforms/{platformId}"},"input":{"type":"structure","required":["platformId"],"members":{"platformId":{"location":"uri","locationName":"platformId"}}},"output":{"type":"structure","members":{"platformId":{},"displayName":{},"partner":{},"target":{},"category":{},"signingConfiguration":{"shape":"Sy"},"signingImageFormat":{"shape":"S13"},"maxSizeInMB":{"type":"integer"}}}},"GetSigningProfile":{"http":{"method":"GET","requestUri":"/signing-profiles/{profileName}"},"input":{"type":"structure","required":["profileName"],"members":{"profileName":{"location":"uri","locationName":"profileName"}}},"output":{"type":"structure","members":{"profileName":{},"signingMaterial":{"shape":"Sb"},"platformId":{},"overrides":{"shape":"Se"},"signingParameters":{"shape":"Si"},"status":{}}}},"ListSigningJobs":{"http":{"method":"GET","requestUri":"/signing-jobs"},"input":{"type":"structure","members":{"status":{"location":"querystring","locationName":"status"},"platformId":{"location":"querystring","locationName":"platformId"},"requestedBy":{"location":"querystring","locationName":"requestedBy"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","members":{"jobId":{},"source":{"shape":"S6"},"signedObject":{"shape":"Sq"},"signingMaterial":{"shape":"Sb"},"createdAt":{"type":"timestamp"},"status":{}}}},"nextToken":{}}}},"ListSigningPlatforms":{"http":{"method":"GET","requestUri":"/signing-platforms"},"input":{"type":"structure","members":{"category":{"location":"querystring","locationName":"category"},"partner":{"location":"querystring","locationName":"partner"},"target":{"location":"querystring","locationName":"target"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"platforms":{"type":"list","member":{"type":"structure","members":{"platformId":{},"displayName":{},"partner":{},"target":{},"category":{},"signingConfiguration":{"shape":"Sy"},"signingImageFormat":{"shape":"S13"},"maxSizeInMB":{"type":"integer"}}}},"nextToken":{}}}},"ListSigningProfiles":{"http":{"method":"GET","requestUri":"/signing-profiles"},"input":{"type":"structure","members":{"includeCanceled":{"location":"querystring","locationName":"includeCanceled","type":"boolean"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"profiles":{"type":"list","member":{"type":"structure","members":{"profileName":{},"signingMaterial":{"shape":"Sb"},"platformId":{},"signingParameters":{"shape":"Si"},"status":{}}}},"nextToken":{}}}},"PutSigningProfile":{"http":{"method":"PUT","requestUri":"/signing-profiles/{profileName}"},"input":{"type":"structure","required":["profileName","signingMaterial","platformId"],"members":{"profileName":{"location":"uri","locationName":"profileName"},"signingMaterial":{"shape":"Sb"},"platformId":{},"overrides":{"shape":"Se"},"signingParameters":{"shape":"Si"}}},"output":{"type":"structure","members":{"arn":{}}}},"StartSigningJob":{"http":{"requestUri":"/signing-jobs"},"input":{"type":"structure","required":["source","destination","clientRequestToken"],"members":{"source":{"shape":"S6"},"destination":{"type":"structure","members":{"s3":{"type":"structure","members":{"bucketName":{},"prefix":{}}}}},"profileName":{},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"jobId":{}}}}},"shapes":{"S6":{"type":"structure","members":{"s3":{"type":"structure","required":["bucketName","key","version"],"members":{"bucketName":{},"key":{},"version":{}}}}},"Sb":{"type":"structure","required":["certificateArn"],"members":{"certificateArn":{}}},"Se":{"type":"structure","members":{"signingConfiguration":{"type":"structure","members":{"encryptionAlgorithm":{},"hashAlgorithm":{}}}}},"Si":{"type":"map","key":{},"value":{}},"Sq":{"type":"structure","members":{"s3":{"type":"structure","members":{"bucketName":{},"key":{}}}}},"Sy":{"type":"structure","required":["encryptionAlgorithmOptions","hashAlgorithmOptions"],"members":{"encryptionAlgorithmOptions":{"type":"structure","required":["allowedValues","defaultValue"],"members":{"allowedValues":{"type":"list","member":{}},"defaultValue":{}}},"hashAlgorithmOptions":{"type":"structure","required":["allowedValues","defaultValue"],"members":{"allowedValues":{"type":"list","member":{}},"defaultValue":{}}}}},"S13":{"type":"structure","required":["supportedFormats","defaultFormat"],"members":{"supportedFormats":{"type":"list","member":{}},"defaultFormat":{}}}}}');

});

parcelRequire.register("28NjI", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListSigningJobs":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListSigningPlatforms":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListSigningProfiles":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}');

});

parcelRequire.register("1p2dI", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"SuccessfulSigningJob":{"delay":20,"operation":"DescribeSigningJob","maxAttempts":25,"acceptors":[{"expected":"Succeeded","matcher":"path","state":"success","argument":"status"},{"expected":"Failed","matcher":"path","state":"failure","argument":"status"},{"expected":"ResourceNotFoundException","matcher":"error","state":"failure"}]}}}');

});


parcelRequire.register("7NETQ", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $5adcd5d9711dbddb$var$Service = $dbC7k.Service;
var $5adcd5d9711dbddb$var$apiLoader = $dbC7k.apiLoader;
$5adcd5d9711dbddb$var$apiLoader.services["chime"] = {};
$dbC7k.Chime = $5adcd5d9711dbddb$var$Service.defineService("chime", [
    "2018-05-01"
]);


Object.defineProperty($5adcd5d9711dbddb$var$apiLoader.services["chime"], "2018-05-01", {
    get: function get() {
        var model = (parcelRequire("9p2jd"));
        model.paginators = (parcelRequire("1hd94")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Chime;

});
parcelRequire.register("9p2jd", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-05-01","endpointPrefix":"chime","protocol":"rest-json","serviceFullName":"Amazon Chime","serviceId":"Chime","signatureVersion":"v4","uid":"chime-2018-05-01"},"operations":{"AssociatePhoneNumberWithUser":{"http":{"requestUri":"/accounts/{accountId}/users/{userId}?operation=associate-phone-number","responseCode":200},"input":{"type":"structure","required":["AccountId","UserId","E164PhoneNumber"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserId":{"location":"uri","locationName":"userId"},"E164PhoneNumber":{"shape":"S3"}}},"output":{"type":"structure","members":{}}},"AssociatePhoneNumbersWithVoiceConnector":{"http":{"requestUri":"/voice-connectors/{voiceConnectorId}?operation=associate-phone-numbers","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"E164PhoneNumbers":{"shape":"S7"}}},"output":{"type":"structure","members":{"PhoneNumberErrors":{"shape":"S9"}}}},"BatchDeletePhoneNumber":{"http":{"requestUri":"/phone-numbers?operation=batch-delete","responseCode":200},"input":{"type":"structure","required":["PhoneNumberIds"],"members":{"PhoneNumberIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"PhoneNumberErrors":{"shape":"S9"}}}},"BatchSuspendUser":{"http":{"requestUri":"/accounts/{accountId}/users?operation=suspend","responseCode":200},"input":{"type":"structure","required":["AccountId","UserIdList"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserIdList":{"shape":"Sg"}}},"output":{"type":"structure","members":{"UserErrors":{"shape":"Si"}}}},"BatchUnsuspendUser":{"http":{"requestUri":"/accounts/{accountId}/users?operation=unsuspend","responseCode":200},"input":{"type":"structure","required":["AccountId","UserIdList"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserIdList":{"shape":"Sg"}}},"output":{"type":"structure","members":{"UserErrors":{"shape":"Si"}}}},"BatchUpdatePhoneNumber":{"http":{"requestUri":"/phone-numbers?operation=batch-update","responseCode":200},"input":{"type":"structure","required":["UpdatePhoneNumberRequestItems"],"members":{"UpdatePhoneNumberRequestItems":{"type":"list","member":{"type":"structure","required":["PhoneNumberId"],"members":{"PhoneNumberId":{},"ProductType":{}}}}}},"output":{"type":"structure","members":{"PhoneNumberErrors":{"shape":"S9"}}}},"BatchUpdateUser":{"http":{"requestUri":"/accounts/{accountId}/users","responseCode":200},"input":{"type":"structure","required":["AccountId","UpdateUserRequestItems"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UpdateUserRequestItems":{"type":"list","member":{"type":"structure","required":["UserId"],"members":{"UserId":{},"LicenseType":{}}}}}},"output":{"type":"structure","members":{"UserErrors":{"shape":"Si"}}}},"CreateAccount":{"http":{"requestUri":"/accounts","responseCode":201},"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Account":{"shape":"Sz"}}}},"CreateBot":{"http":{"requestUri":"/accounts/{accountId}/bots","responseCode":201},"input":{"type":"structure","required":["DisplayName","AccountId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"DisplayName":{"shape":"S14"},"Domain":{}}},"output":{"type":"structure","members":{"Bot":{"shape":"S16"}}}},"CreatePhoneNumberOrder":{"http":{"requestUri":"/phone-number-orders","responseCode":201},"input":{"type":"structure","required":["ProductType","E164PhoneNumbers"],"members":{"ProductType":{},"E164PhoneNumbers":{"shape":"S7"}}},"output":{"type":"structure","members":{"PhoneNumberOrder":{"shape":"S1b"}}}},"CreateVoiceConnector":{"http":{"requestUri":"/voice-connectors","responseCode":201},"input":{"type":"structure","required":["Name","RequireEncryption"],"members":{"Name":{},"RequireEncryption":{"type":"boolean"}}},"output":{"type":"structure","members":{"VoiceConnector":{"shape":"S1l"}}}},"DeleteAccount":{"http":{"method":"DELETE","requestUri":"/accounts/{accountId}","responseCode":204},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"}}},"output":{"type":"structure","members":{}}},"DeleteEventsConfiguration":{"http":{"method":"DELETE","requestUri":"/accounts/{accountId}/bots/{botId}/events-configuration","responseCode":204},"input":{"type":"structure","required":["AccountId","BotId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"BotId":{"location":"uri","locationName":"botId"}}}},"DeletePhoneNumber":{"http":{"method":"DELETE","requestUri":"/phone-numbers/{phoneNumberId}","responseCode":204},"input":{"type":"structure","required":["PhoneNumberId"],"members":{"PhoneNumberId":{"location":"uri","locationName":"phoneNumberId"}}}},"DeleteVoiceConnector":{"http":{"method":"DELETE","requestUri":"/voice-connectors/{voiceConnectorId}","responseCode":204},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}}},"DeleteVoiceConnectorOrigination":{"http":{"method":"DELETE","requestUri":"/voice-connectors/{voiceConnectorId}/origination","responseCode":204},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}}},"DeleteVoiceConnectorTermination":{"http":{"method":"DELETE","requestUri":"/voice-connectors/{voiceConnectorId}/termination","responseCode":204},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}}},"DeleteVoiceConnectorTerminationCredentials":{"http":{"requestUri":"/voice-connectors/{voiceConnectorId}/termination/credentials?operation=delete","responseCode":204},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"Usernames":{"shape":"S1u"}}}},"DisassociatePhoneNumberFromUser":{"http":{"requestUri":"/accounts/{accountId}/users/{userId}?operation=disassociate-phone-number","responseCode":200},"input":{"type":"structure","required":["AccountId","UserId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserId":{"location":"uri","locationName":"userId"}}},"output":{"type":"structure","members":{}}},"DisassociatePhoneNumbersFromVoiceConnector":{"http":{"requestUri":"/voice-connectors/{voiceConnectorId}?operation=disassociate-phone-numbers","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"E164PhoneNumbers":{"shape":"S7"}}},"output":{"type":"structure","members":{"PhoneNumberErrors":{"shape":"S9"}}}},"GetAccount":{"http":{"method":"GET","requestUri":"/accounts/{accountId}"},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"}}},"output":{"type":"structure","members":{"Account":{"shape":"Sz"}}}},"GetAccountSettings":{"http":{"method":"GET","requestUri":"/accounts/{accountId}/settings"},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"}}},"output":{"type":"structure","members":{"AccountSettings":{"shape":"S23"}}}},"GetBot":{"http":{"method":"GET","requestUri":"/accounts/{accountId}/bots/{botId}","responseCode":200},"input":{"type":"structure","required":["AccountId","BotId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"BotId":{"location":"uri","locationName":"botId"}}},"output":{"type":"structure","members":{"Bot":{"shape":"S16"}}}},"GetEventsConfiguration":{"http":{"method":"GET","requestUri":"/accounts/{accountId}/bots/{botId}/events-configuration","responseCode":200},"input":{"type":"structure","required":["AccountId","BotId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"BotId":{"location":"uri","locationName":"botId"}}},"output":{"type":"structure","members":{"EventsConfiguration":{"shape":"S28"}}}},"GetGlobalSettings":{"http":{"method":"GET","requestUri":"/settings","responseCode":200},"output":{"type":"structure","members":{"BusinessCalling":{"shape":"S2a"},"VoiceConnector":{"shape":"S2b"}}}},"GetPhoneNumber":{"http":{"method":"GET","requestUri":"/phone-numbers/{phoneNumberId}"},"input":{"type":"structure","required":["PhoneNumberId"],"members":{"PhoneNumberId":{"location":"uri","locationName":"phoneNumberId"}}},"output":{"type":"structure","members":{"PhoneNumber":{"shape":"S2e"}}}},"GetPhoneNumberOrder":{"http":{"method":"GET","requestUri":"/phone-number-orders/{phoneNumberOrderId}","responseCode":200},"input":{"type":"structure","required":["PhoneNumberOrderId"],"members":{"PhoneNumberOrderId":{"location":"uri","locationName":"phoneNumberOrderId"}}},"output":{"type":"structure","members":{"PhoneNumberOrder":{"shape":"S1b"}}}},"GetUser":{"http":{"method":"GET","requestUri":"/accounts/{accountId}/users/{userId}","responseCode":200},"input":{"type":"structure","required":["AccountId","UserId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserId":{"location":"uri","locationName":"userId"}}},"output":{"type":"structure","members":{"User":{"shape":"S2p"}}}},"GetUserSettings":{"http":{"method":"GET","requestUri":"/accounts/{accountId}/users/{userId}/settings","responseCode":200},"input":{"type":"structure","required":["AccountId","UserId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserId":{"location":"uri","locationName":"userId"}}},"output":{"type":"structure","members":{"UserSettings":{"shape":"S2v"}}}},"GetVoiceConnector":{"http":{"method":"GET","requestUri":"/voice-connectors/{voiceConnectorId}","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}},"output":{"type":"structure","members":{"VoiceConnector":{"shape":"S1l"}}}},"GetVoiceConnectorOrigination":{"http":{"method":"GET","requestUri":"/voice-connectors/{voiceConnectorId}/origination","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}},"output":{"type":"structure","members":{"Origination":{"shape":"S31"}}}},"GetVoiceConnectorTermination":{"http":{"method":"GET","requestUri":"/voice-connectors/{voiceConnectorId}/termination","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}},"output":{"type":"structure","members":{"Termination":{"shape":"S3a"}}}},"GetVoiceConnectorTerminationHealth":{"http":{"method":"GET","requestUri":"/voice-connectors/{voiceConnectorId}/termination/health","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}},"output":{"type":"structure","members":{"TerminationHealth":{"type":"structure","members":{"Timestamp":{"shape":"S11"},"Source":{}}}}}},"InviteUsers":{"http":{"requestUri":"/accounts/{accountId}/users?operation=add","responseCode":201},"input":{"type":"structure","required":["AccountId","UserEmailList"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserEmailList":{"type":"list","member":{"shape":"S2q"}}}},"output":{"type":"structure","members":{"Invites":{"type":"list","member":{"type":"structure","members":{"InviteId":{},"Status":{},"EmailAddress":{"shape":"S2q"},"EmailStatus":{}}}}}}},"ListAccounts":{"http":{"method":"GET","requestUri":"/accounts"},"input":{"type":"structure","members":{"Name":{"location":"querystring","locationName":"name"},"UserEmail":{"shape":"S2q","location":"querystring","locationName":"user-email"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"Accounts":{"type":"list","member":{"shape":"Sz"}},"NextToken":{}}}},"ListBots":{"http":{"method":"GET","requestUri":"/accounts/{accountId}/bots","responseCode":200},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"Bots":{"type":"list","member":{"shape":"S16"}},"NextToken":{}}}},"ListPhoneNumberOrders":{"http":{"method":"GET","requestUri":"/phone-number-orders","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"PhoneNumberOrders":{"type":"list","member":{"shape":"S1b"}},"NextToken":{}}}},"ListPhoneNumbers":{"http":{"method":"GET","requestUri":"/phone-numbers"},"input":{"type":"structure","members":{"Status":{"location":"querystring","locationName":"status"},"ProductType":{"location":"querystring","locationName":"product-type"},"FilterName":{"location":"querystring","locationName":"filter-name"},"FilterValue":{"location":"querystring","locationName":"filter-value"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"PhoneNumbers":{"type":"list","member":{"shape":"S2e"}},"NextToken":{}}}},"ListUsers":{"http":{"method":"GET","requestUri":"/accounts/{accountId}/users","responseCode":200},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserEmail":{"shape":"S2q","location":"querystring","locationName":"user-email"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"Users":{"type":"list","member":{"shape":"S2p"}},"NextToken":{}}}},"ListVoiceConnectorTerminationCredentials":{"http":{"method":"GET","requestUri":"/voice-connectors/{voiceConnectorId}/termination/credentials","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"}}},"output":{"type":"structure","members":{"Usernames":{"shape":"S1u"}}}},"ListVoiceConnectors":{"http":{"method":"GET","requestUri":"/voice-connectors","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"VoiceConnectors":{"type":"list","member":{"shape":"S1l"}},"NextToken":{}}}},"LogoutUser":{"http":{"requestUri":"/accounts/{accountId}/users/{userId}?operation=logout","responseCode":204},"input":{"type":"structure","required":["AccountId","UserId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserId":{"location":"uri","locationName":"userId"}}},"output":{"type":"structure","members":{}}},"PutEventsConfiguration":{"http":{"method":"PUT","requestUri":"/accounts/{accountId}/bots/{botId}/events-configuration","responseCode":201},"input":{"type":"structure","required":["AccountId","BotId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"BotId":{"location":"uri","locationName":"botId"},"OutboundEventsHTTPSEndpoint":{"shape":"S14"},"LambdaFunctionArn":{"shape":"S14"}}},"output":{"type":"structure","members":{"EventsConfiguration":{"shape":"S28"}}}},"PutVoiceConnectorOrigination":{"http":{"method":"PUT","requestUri":"/voice-connectors/{voiceConnectorId}/origination","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId","Origination"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"Origination":{"shape":"S31"}}},"output":{"type":"structure","members":{"Origination":{"shape":"S31"}}}},"PutVoiceConnectorTermination":{"http":{"method":"PUT","requestUri":"/voice-connectors/{voiceConnectorId}/termination","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId","Termination"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"Termination":{"shape":"S3a"}}},"output":{"type":"structure","members":{"Termination":{"shape":"S3a"}}}},"PutVoiceConnectorTerminationCredentials":{"http":{"requestUri":"/voice-connectors/{voiceConnectorId}/termination/credentials?operation=put","responseCode":204},"input":{"type":"structure","required":["VoiceConnectorId"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"Credentials":{"type":"list","member":{"type":"structure","members":{"Username":{"shape":"S14"},"Password":{"shape":"S14"}}}}}}},"RegenerateSecurityToken":{"http":{"requestUri":"/accounts/{accountId}/bots/{botId}?operation=regenerate-security-token","responseCode":200},"input":{"type":"structure","required":["AccountId","BotId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"BotId":{"location":"uri","locationName":"botId"}}},"output":{"type":"structure","members":{"Bot":{"shape":"S16"}}}},"ResetPersonalPIN":{"http":{"requestUri":"/accounts/{accountId}/users/{userId}?operation=reset-personal-pin","responseCode":200},"input":{"type":"structure","required":["AccountId","UserId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserId":{"location":"uri","locationName":"userId"}}},"output":{"type":"structure","members":{"User":{"shape":"S2p"}}}},"RestorePhoneNumber":{"http":{"requestUri":"/phone-numbers/{phoneNumberId}?operation=restore","responseCode":200},"input":{"type":"structure","required":["PhoneNumberId"],"members":{"PhoneNumberId":{"location":"uri","locationName":"phoneNumberId"}}},"output":{"type":"structure","members":{"PhoneNumber":{"shape":"S2e"}}}},"SearchAvailablePhoneNumbers":{"http":{"method":"GET","requestUri":"/search?type=phone-numbers"},"input":{"type":"structure","members":{"AreaCode":{"location":"querystring","locationName":"area-code"},"City":{"location":"querystring","locationName":"city"},"Country":{"location":"querystring","locationName":"country"},"State":{"location":"querystring","locationName":"state"},"TollFreePrefix":{"location":"querystring","locationName":"toll-free-prefix"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"NextToken":{"location":"querystring","locationName":"next-token"}}},"output":{"type":"structure","members":{"E164PhoneNumbers":{"shape":"S7"}}}},"UpdateAccount":{"http":{"requestUri":"/accounts/{accountId}","responseCode":200},"input":{"type":"structure","required":["AccountId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"Name":{}}},"output":{"type":"structure","members":{"Account":{"shape":"Sz"}}}},"UpdateAccountSettings":{"http":{"method":"PUT","requestUri":"/accounts/{accountId}/settings","responseCode":204},"input":{"type":"structure","required":["AccountId","AccountSettings"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"AccountSettings":{"shape":"S23"}}},"output":{"type":"structure","members":{}}},"UpdateBot":{"http":{"requestUri":"/accounts/{accountId}/bots/{botId}","responseCode":200},"input":{"type":"structure","required":["AccountId","BotId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"BotId":{"location":"uri","locationName":"botId"},"Disabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"Bot":{"shape":"S16"}}}},"UpdateGlobalSettings":{"http":{"method":"PUT","requestUri":"/settings","responseCode":204},"input":{"type":"structure","required":["BusinessCalling","VoiceConnector"],"members":{"BusinessCalling":{"shape":"S2a"},"VoiceConnector":{"shape":"S2b"}}}},"UpdatePhoneNumber":{"http":{"requestUri":"/phone-numbers/{phoneNumberId}","responseCode":200},"input":{"type":"structure","required":["PhoneNumberId"],"members":{"PhoneNumberId":{"location":"uri","locationName":"phoneNumberId"},"ProductType":{}}},"output":{"type":"structure","members":{"PhoneNumber":{"shape":"S2e"}}}},"UpdateUser":{"http":{"requestUri":"/accounts/{accountId}/users/{userId}","responseCode":200},"input":{"type":"structure","required":["AccountId","UserId"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserId":{"location":"uri","locationName":"userId"},"LicenseType":{}}},"output":{"type":"structure","members":{"User":{"shape":"S2p"}}}},"UpdateUserSettings":{"http":{"method":"PUT","requestUri":"/accounts/{accountId}/users/{userId}/settings","responseCode":204},"input":{"type":"structure","required":["AccountId","UserId","UserSettings"],"members":{"AccountId":{"location":"uri","locationName":"accountId"},"UserId":{"location":"uri","locationName":"userId"},"UserSettings":{"shape":"S2v"}}}},"UpdateVoiceConnector":{"http":{"method":"PUT","requestUri":"/voice-connectors/{voiceConnectorId}","responseCode":200},"input":{"type":"structure","required":["VoiceConnectorId","Name","RequireEncryption"],"members":{"VoiceConnectorId":{"location":"uri","locationName":"voiceConnectorId"},"Name":{},"RequireEncryption":{"type":"boolean"}}},"output":{"type":"structure","members":{"VoiceConnector":{"shape":"S1l"}}}}},"shapes":{"S3":{"type":"string","sensitive":true},"S7":{"type":"list","member":{"shape":"S3"}},"S9":{"type":"list","member":{"type":"structure","members":{"PhoneNumberId":{},"ErrorCode":{},"ErrorMessage":{}}}},"Sg":{"type":"list","member":{}},"Si":{"type":"list","member":{"type":"structure","members":{"UserId":{},"ErrorCode":{},"ErrorMessage":{}}}},"Sz":{"type":"structure","required":["AwsAccountId","AccountId","Name"],"members":{"AwsAccountId":{},"AccountId":{},"Name":{},"AccountType":{},"CreatedTimestamp":{"shape":"S11"},"DefaultLicense":{},"SupportedLicenses":{"type":"list","member":{}}}},"S11":{"type":"timestamp","timestampFormat":"iso8601"},"S14":{"type":"string","sensitive":true},"S16":{"type":"structure","members":{"BotId":{},"UserId":{},"DisplayName":{"shape":"S14"},"BotType":{},"Disabled":{"type":"boolean"},"CreatedTimestamp":{"shape":"S11"},"UpdatedTimestamp":{"shape":"S11"},"BotEmail":{"shape":"S14"},"SecurityToken":{"shape":"S14"}}},"S1b":{"type":"structure","members":{"PhoneNumberOrderId":{},"ProductType":{},"Status":{},"OrderedPhoneNumbers":{"type":"list","member":{"type":"structure","members":{"E164PhoneNumber":{"shape":"S3"},"Status":{}}}},"CreatedTimestamp":{"shape":"S11"},"UpdatedTimestamp":{"shape":"S11"}}},"S1l":{"type":"structure","members":{"VoiceConnectorId":{},"Name":{},"OutboundHostName":{},"RequireEncryption":{"type":"boolean"},"CreatedTimestamp":{"shape":"S11"},"UpdatedTimestamp":{"shape":"S11"}}},"S1u":{"type":"list","member":{"shape":"S14"}},"S23":{"type":"structure","members":{"DisableRemoteControl":{"type":"boolean"},"EnableDialOut":{"type":"boolean"}}},"S28":{"type":"structure","members":{"BotId":{},"OutboundEventsHTTPSEndpoint":{"shape":"S14"},"LambdaFunctionArn":{"shape":"S14"}}},"S2a":{"type":"structure","members":{"CdrBucket":{}}},"S2b":{"type":"structure","members":{"CdrBucket":{}}},"S2e":{"type":"structure","members":{"PhoneNumberId":{},"E164PhoneNumber":{"shape":"S3"},"Type":{},"ProductType":{},"Status":{},"Capabilities":{"type":"structure","members":{"InboundCall":{"type":"boolean"},"OutboundCall":{"type":"boolean"},"InboundSMS":{"type":"boolean"},"OutboundSMS":{"type":"boolean"},"InboundMMS":{"type":"boolean"},"OutboundMMS":{"type":"boolean"}}},"Associations":{"type":"list","member":{"type":"structure","members":{"Value":{},"Name":{},"AssociatedTimestamp":{"shape":"S11"}}}},"CreatedTimestamp":{"shape":"S11"},"UpdatedTimestamp":{"shape":"S11"},"DeletionTimestamp":{"shape":"S11"}}},"S2p":{"type":"structure","required":["UserId"],"members":{"UserId":{},"AccountId":{},"PrimaryEmail":{"shape":"S2q"},"PrimaryProvisionedNumber":{"shape":"S14"},"DisplayName":{"shape":"S14"},"LicenseType":{},"UserRegistrationStatus":{},"UserInvitationStatus":{},"RegisteredOn":{"shape":"S11"},"InvitedOn":{"shape":"S11"},"PersonalPIN":{}}},"S2q":{"type":"string","sensitive":true},"S2v":{"type":"structure","required":["Telephony"],"members":{"Telephony":{"type":"structure","required":["InboundCalling","OutboundCalling","SMS"],"members":{"InboundCalling":{"type":"boolean"},"OutboundCalling":{"type":"boolean"},"SMS":{"type":"boolean"}}}}},"S31":{"type":"structure","members":{"Routes":{"type":"list","member":{"type":"structure","members":{"Host":{},"Port":{"type":"integer"},"Protocol":{},"Priority":{"type":"integer"},"Weight":{"type":"integer"}}}},"Disabled":{"type":"boolean"}}},"S3a":{"type":"structure","members":{"CpsLimit":{"type":"integer"},"DefaultPhoneNumber":{"shape":"S3"},"CallingRegions":{"type":"list","member":{}},"CidrAllowedList":{"type":"list","member":{}},"Disabled":{"type":"boolean"}}}}}');

});

parcelRequire.register("1hd94", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListAccounts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListPhoneNumberOrders":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListPhoneNumbers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListUsers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListVoiceConnectors":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("cLTJx", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $94c51b51c22bf3a5$var$Service = $dbC7k.Service;
var $94c51b51c22bf3a5$var$apiLoader = $dbC7k.apiLoader;
$94c51b51c22bf3a5$var$apiLoader.services["pinpointemail"] = {};
$dbC7k.PinpointEmail = $94c51b51c22bf3a5$var$Service.defineService("pinpointemail", [
    "2018-07-26"
]);


Object.defineProperty($94c51b51c22bf3a5$var$apiLoader.services["pinpointemail"], "2018-07-26", {
    get: function get() {
        var model = (parcelRequire("aC9K2"));
        model.paginators = (parcelRequire("emXhg")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.PinpointEmail;

});
parcelRequire.register("aC9K2", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-07-26","endpointPrefix":"email","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Pinpoint Email","serviceFullName":"Amazon Pinpoint Email Service","serviceId":"Pinpoint Email","signatureVersion":"v4","signingName":"ses","uid":"pinpoint-email-2018-07-26"},"operations":{"CreateConfigurationSet":{"http":{"requestUri":"/v1/email/configuration-sets"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{},"TrackingOptions":{"shape":"S3"},"DeliveryOptions":{"shape":"S5"},"ReputationOptions":{"shape":"S8"},"SendingOptions":{"shape":"Sb"},"Tags":{"shape":"Sc"}}},"output":{"type":"structure","members":{}}},"CreateConfigurationSetEventDestination":{"http":{"requestUri":"/v1/email/configuration-sets/{ConfigurationSetName}/event-destinations"},"input":{"type":"structure","required":["ConfigurationSetName","EventDestinationName","EventDestination"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"EventDestinationName":{},"EventDestination":{"shape":"Sj"}}},"output":{"type":"structure","members":{}}},"CreateDedicatedIpPool":{"http":{"requestUri":"/v1/email/dedicated-ip-pools"},"input":{"type":"structure","required":["PoolName"],"members":{"PoolName":{},"Tags":{"shape":"Sc"}}},"output":{"type":"structure","members":{}}},"CreateDeliverabilityTestReport":{"http":{"requestUri":"/v1/email/deliverability-dashboard/test"},"input":{"type":"structure","required":["FromEmailAddress","Content"],"members":{"ReportName":{},"FromEmailAddress":{},"Content":{"shape":"S12"},"Tags":{"shape":"Sc"}}},"output":{"type":"structure","required":["ReportId","DeliverabilityTestStatus"],"members":{"ReportId":{},"DeliverabilityTestStatus":{}}}},"CreateEmailIdentity":{"http":{"requestUri":"/v1/email/identities"},"input":{"type":"structure","required":["EmailIdentity"],"members":{"EmailIdentity":{},"Tags":{"shape":"Sc"}}},"output":{"type":"structure","members":{"IdentityType":{},"VerifiedForSendingStatus":{"type":"boolean"},"DkimAttributes":{"shape":"S1h"}}}},"DeleteConfigurationSet":{"http":{"method":"DELETE","requestUri":"/v1/email/configuration-sets/{ConfigurationSetName}"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"}}},"output":{"type":"structure","members":{}}},"DeleteConfigurationSetEventDestination":{"http":{"method":"DELETE","requestUri":"/v1/email/configuration-sets/{ConfigurationSetName}/event-destinations/{EventDestinationName}"},"input":{"type":"structure","required":["ConfigurationSetName","EventDestinationName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"EventDestinationName":{"location":"uri","locationName":"EventDestinationName"}}},"output":{"type":"structure","members":{}}},"DeleteDedicatedIpPool":{"http":{"method":"DELETE","requestUri":"/v1/email/dedicated-ip-pools/{PoolName}"},"input":{"type":"structure","required":["PoolName"],"members":{"PoolName":{"location":"uri","locationName":"PoolName"}}},"output":{"type":"structure","members":{}}},"DeleteEmailIdentity":{"http":{"method":"DELETE","requestUri":"/v1/email/identities/{EmailIdentity}"},"input":{"type":"structure","required":["EmailIdentity"],"members":{"EmailIdentity":{"location":"uri","locationName":"EmailIdentity"}}},"output":{"type":"structure","members":{}}},"GetAccount":{"http":{"method":"GET","requestUri":"/v1/email/account"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"SendQuota":{"type":"structure","members":{"Max24HourSend":{"type":"double"},"MaxSendRate":{"type":"double"},"SentLast24Hours":{"type":"double"}}},"SendingEnabled":{"type":"boolean"},"DedicatedIpAutoWarmupEnabled":{"type":"boolean"},"EnforcementStatus":{},"ProductionAccessEnabled":{"type":"boolean"}}}},"GetBlacklistReports":{"http":{"method":"GET","requestUri":"/v1/email/deliverability-dashboard/blacklist-report"},"input":{"type":"structure","required":["BlacklistItemNames"],"members":{"BlacklistItemNames":{"location":"querystring","locationName":"BlacklistItemNames","type":"list","member":{}}}},"output":{"type":"structure","required":["BlacklistReport"],"members":{"BlacklistReport":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"RblName":{},"ListingTime":{"type":"timestamp"},"Description":{}}}}}}}},"GetConfigurationSet":{"http":{"method":"GET","requestUri":"/v1/email/configuration-sets/{ConfigurationSetName}"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"}}},"output":{"type":"structure","members":{"ConfigurationSetName":{},"TrackingOptions":{"shape":"S3"},"DeliveryOptions":{"shape":"S5"},"ReputationOptions":{"shape":"S8"},"SendingOptions":{"shape":"Sb"},"Tags":{"shape":"Sc"}}}},"GetConfigurationSetEventDestinations":{"http":{"method":"GET","requestUri":"/v1/email/configuration-sets/{ConfigurationSetName}/event-destinations"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"}}},"output":{"type":"structure","members":{"EventDestinations":{"type":"list","member":{"type":"structure","required":["Name","MatchingEventTypes"],"members":{"Name":{},"Enabled":{"type":"boolean"},"MatchingEventTypes":{"shape":"Sk"},"KinesisFirehoseDestination":{"shape":"Sm"},"CloudWatchDestination":{"shape":"So"},"SnsDestination":{"shape":"Su"},"PinpointDestination":{"shape":"Sv"}}}}}}},"GetDedicatedIp":{"http":{"method":"GET","requestUri":"/v1/email/dedicated-ips/{IP}"},"input":{"type":"structure","required":["Ip"],"members":{"Ip":{"location":"uri","locationName":"IP"}}},"output":{"type":"structure","members":{"DedicatedIp":{"shape":"S2j"}}}},"GetDedicatedIps":{"http":{"method":"GET","requestUri":"/v1/email/dedicated-ips"},"input":{"type":"structure","members":{"PoolName":{"location":"querystring","locationName":"PoolName"},"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","members":{"DedicatedIps":{"type":"list","member":{"shape":"S2j"}},"NextToken":{}}}},"GetDeliverabilityDashboardOptions":{"http":{"method":"GET","requestUri":"/v1/email/deliverability-dashboard"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["DashboardEnabled"],"members":{"DashboardEnabled":{"type":"boolean"},"SubscriptionExpiryDate":{"type":"timestamp"},"AccountStatus":{},"ActiveSubscribedDomains":{"shape":"S2u"},"PendingExpirationSubscribedDomains":{"shape":"S2u"}}}},"GetDeliverabilityTestReport":{"http":{"method":"GET","requestUri":"/v1/email/deliverability-dashboard/test-reports/{ReportId}"},"input":{"type":"structure","required":["ReportId"],"members":{"ReportId":{"location":"uri","locationName":"ReportId"}}},"output":{"type":"structure","required":["DeliverabilityTestReport","OverallPlacement","IspPlacements"],"members":{"DeliverabilityTestReport":{"shape":"S32"},"OverallPlacement":{"shape":"S34"},"IspPlacements":{"type":"list","member":{"type":"structure","members":{"IspName":{},"PlacementStatistics":{"shape":"S34"}}}},"Message":{},"Tags":{"shape":"Sc"}}}},"GetDomainDeliverabilityCampaign":{"http":{"method":"GET","requestUri":"/v1/email/deliverability-dashboard/campaigns/{CampaignId}"},"input":{"type":"structure","required":["CampaignId"],"members":{"CampaignId":{"location":"uri","locationName":"CampaignId"}}},"output":{"type":"structure","required":["DomainDeliverabilityCampaign"],"members":{"DomainDeliverabilityCampaign":{"shape":"S3c"}}}},"GetDomainStatisticsReport":{"http":{"method":"GET","requestUri":"/v1/email/deliverability-dashboard/statistics-report/{Domain}"},"input":{"type":"structure","required":["Domain","StartDate","EndDate"],"members":{"Domain":{"location":"uri","locationName":"Domain"},"StartDate":{"location":"querystring","locationName":"StartDate","type":"timestamp"},"EndDate":{"location":"querystring","locationName":"EndDate","type":"timestamp"}}},"output":{"type":"structure","required":["OverallVolume","DailyVolumes"],"members":{"OverallVolume":{"type":"structure","members":{"VolumeStatistics":{"shape":"S3m"},"ReadRatePercent":{"type":"double"},"DomainIspPlacements":{"shape":"S3n"}}},"DailyVolumes":{"type":"list","member":{"type":"structure","members":{"StartDate":{"type":"timestamp"},"VolumeStatistics":{"shape":"S3m"},"DomainIspPlacements":{"shape":"S3n"}}}}}}},"GetEmailIdentity":{"http":{"method":"GET","requestUri":"/v1/email/identities/{EmailIdentity}"},"input":{"type":"structure","required":["EmailIdentity"],"members":{"EmailIdentity":{"location":"uri","locationName":"EmailIdentity"}}},"output":{"type":"structure","members":{"IdentityType":{},"FeedbackForwardingStatus":{"type":"boolean"},"VerifiedForSendingStatus":{"type":"boolean"},"DkimAttributes":{"shape":"S1h"},"MailFromAttributes":{"type":"structure","required":["MailFromDomain","MailFromDomainStatus","BehaviorOnMxFailure"],"members":{"MailFromDomain":{},"MailFromDomainStatus":{},"BehaviorOnMxFailure":{}}},"Tags":{"shape":"Sc"}}}},"ListConfigurationSets":{"http":{"method":"GET","requestUri":"/v1/email/configuration-sets"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","members":{"ConfigurationSets":{"type":"list","member":{}},"NextToken":{}}}},"ListDedicatedIpPools":{"http":{"method":"GET","requestUri":"/v1/email/dedicated-ip-pools"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","members":{"DedicatedIpPools":{"type":"list","member":{}},"NextToken":{}}}},"ListDeliverabilityTestReports":{"http":{"method":"GET","requestUri":"/v1/email/deliverability-dashboard/test-reports"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","required":["DeliverabilityTestReports"],"members":{"DeliverabilityTestReports":{"type":"list","member":{"shape":"S32"}},"NextToken":{}}}},"ListDomainDeliverabilityCampaigns":{"http":{"method":"GET","requestUri":"/v1/email/deliverability-dashboard/domains/{SubscribedDomain}/campaigns"},"input":{"type":"structure","required":["StartDate","EndDate","SubscribedDomain"],"members":{"StartDate":{"location":"querystring","locationName":"StartDate","type":"timestamp"},"EndDate":{"location":"querystring","locationName":"EndDate","type":"timestamp"},"SubscribedDomain":{"location":"uri","locationName":"SubscribedDomain"},"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","required":["DomainDeliverabilityCampaigns"],"members":{"DomainDeliverabilityCampaigns":{"type":"list","member":{"shape":"S3c"}},"NextToken":{}}}},"ListEmailIdentities":{"http":{"method":"GET","requestUri":"/v1/email/identities"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize","type":"integer"}}},"output":{"type":"structure","members":{"EmailIdentities":{"type":"list","member":{"type":"structure","members":{"IdentityType":{},"IdentityName":{},"SendingEnabled":{"type":"boolean"}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/v1/email/tags"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"querystring","locationName":"ResourceArn"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"Sc"}}}},"PutAccountDedicatedIpWarmupAttributes":{"http":{"method":"PUT","requestUri":"/v1/email/account/dedicated-ips/warmup"},"input":{"type":"structure","members":{"AutoWarmupEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"PutAccountSendingAttributes":{"http":{"method":"PUT","requestUri":"/v1/email/account/sending"},"input":{"type":"structure","members":{"SendingEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"PutConfigurationSetDeliveryOptions":{"http":{"method":"PUT","requestUri":"/v1/email/configuration-sets/{ConfigurationSetName}/delivery-options"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"TlsPolicy":{},"SendingPoolName":{}}},"output":{"type":"structure","members":{}}},"PutConfigurationSetReputationOptions":{"http":{"method":"PUT","requestUri":"/v1/email/configuration-sets/{ConfigurationSetName}/reputation-options"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"ReputationMetricsEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"PutConfigurationSetSendingOptions":{"http":{"method":"PUT","requestUri":"/v1/email/configuration-sets/{ConfigurationSetName}/sending"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"SendingEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"PutConfigurationSetTrackingOptions":{"http":{"method":"PUT","requestUri":"/v1/email/configuration-sets/{ConfigurationSetName}/tracking-options"},"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"CustomRedirectDomain":{}}},"output":{"type":"structure","members":{}}},"PutDedicatedIpInPool":{"http":{"method":"PUT","requestUri":"/v1/email/dedicated-ips/{IP}/pool"},"input":{"type":"structure","required":["Ip","DestinationPoolName"],"members":{"Ip":{"location":"uri","locationName":"IP"},"DestinationPoolName":{}}},"output":{"type":"structure","members":{}}},"PutDedicatedIpWarmupAttributes":{"http":{"method":"PUT","requestUri":"/v1/email/dedicated-ips/{IP}/warmup"},"input":{"type":"structure","required":["Ip","WarmupPercentage"],"members":{"Ip":{"location":"uri","locationName":"IP"},"WarmupPercentage":{"type":"integer"}}},"output":{"type":"structure","members":{}}},"PutDeliverabilityDashboardOption":{"http":{"method":"PUT","requestUri":"/v1/email/deliverability-dashboard"},"input":{"type":"structure","required":["DashboardEnabled"],"members":{"DashboardEnabled":{"type":"boolean"},"SubscribedDomains":{"shape":"S2u"}}},"output":{"type":"structure","members":{}}},"PutEmailIdentityDkimAttributes":{"http":{"method":"PUT","requestUri":"/v1/email/identities/{EmailIdentity}/dkim"},"input":{"type":"structure","required":["EmailIdentity"],"members":{"EmailIdentity":{"location":"uri","locationName":"EmailIdentity"},"SigningEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"PutEmailIdentityFeedbackAttributes":{"http":{"method":"PUT","requestUri":"/v1/email/identities/{EmailIdentity}/feedback"},"input":{"type":"structure","required":["EmailIdentity"],"members":{"EmailIdentity":{"location":"uri","locationName":"EmailIdentity"},"EmailForwardingEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"PutEmailIdentityMailFromAttributes":{"http":{"method":"PUT","requestUri":"/v1/email/identities/{EmailIdentity}/mail-from"},"input":{"type":"structure","required":["EmailIdentity"],"members":{"EmailIdentity":{"location":"uri","locationName":"EmailIdentity"},"MailFromDomain":{},"BehaviorOnMxFailure":{}}},"output":{"type":"structure","members":{}}},"SendEmail":{"http":{"requestUri":"/v1/email/outbound-emails"},"input":{"type":"structure","required":["Destination","Content"],"members":{"FromEmailAddress":{},"Destination":{"type":"structure","members":{"ToAddresses":{"shape":"S56"},"CcAddresses":{"shape":"S56"},"BccAddresses":{"shape":"S56"}}},"ReplyToAddresses":{"shape":"S56"},"FeedbackForwardingEmailAddress":{},"Content":{"shape":"S12"},"EmailTags":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"ConfigurationSetName":{}}},"output":{"type":"structure","members":{"MessageId":{}}}},"TagResource":{"http":{"requestUri":"/v1/email/tags"},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sc"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/v1/email/tags"},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"querystring","locationName":"ResourceArn"},"TagKeys":{"location":"querystring","locationName":"TagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateConfigurationSetEventDestination":{"http":{"method":"PUT","requestUri":"/v1/email/configuration-sets/{ConfigurationSetName}/event-destinations/{EventDestinationName}"},"input":{"type":"structure","required":["ConfigurationSetName","EventDestinationName","EventDestination"],"members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"EventDestinationName":{"location":"uri","locationName":"EventDestinationName"},"EventDestination":{"shape":"Sj"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S3":{"type":"structure","required":["CustomRedirectDomain"],"members":{"CustomRedirectDomain":{}}},"S5":{"type":"structure","members":{"TlsPolicy":{},"SendingPoolName":{}}},"S8":{"type":"structure","members":{"ReputationMetricsEnabled":{"type":"boolean"},"LastFreshStart":{"type":"timestamp"}}},"Sb":{"type":"structure","members":{"SendingEnabled":{"type":"boolean"}}},"Sc":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sj":{"type":"structure","members":{"Enabled":{"type":"boolean"},"MatchingEventTypes":{"shape":"Sk"},"KinesisFirehoseDestination":{"shape":"Sm"},"CloudWatchDestination":{"shape":"So"},"SnsDestination":{"shape":"Su"},"PinpointDestination":{"shape":"Sv"}}},"Sk":{"type":"list","member":{}},"Sm":{"type":"structure","required":["IamRoleArn","DeliveryStreamArn"],"members":{"IamRoleArn":{},"DeliveryStreamArn":{}}},"So":{"type":"structure","required":["DimensionConfigurations"],"members":{"DimensionConfigurations":{"type":"list","member":{"type":"structure","required":["DimensionName","DimensionValueSource","DefaultDimensionValue"],"members":{"DimensionName":{},"DimensionValueSource":{},"DefaultDimensionValue":{}}}}}},"Su":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{}}},"Sv":{"type":"structure","members":{"ApplicationArn":{}}},"S12":{"type":"structure","members":{"Simple":{"type":"structure","required":["Subject","Body"],"members":{"Subject":{"shape":"S14"},"Body":{"type":"structure","members":{"Text":{"shape":"S14"},"Html":{"shape":"S14"}}}}},"Raw":{"type":"structure","required":["Data"],"members":{"Data":{"type":"blob"}}}}},"S14":{"type":"structure","required":["Data"],"members":{"Data":{},"Charset":{}}},"S1h":{"type":"structure","members":{"SigningEnabled":{"type":"boolean"},"Status":{},"Tokens":{"type":"list","member":{}}}},"S2j":{"type":"structure","required":["Ip","WarmupStatus","WarmupPercentage"],"members":{"Ip":{},"WarmupStatus":{},"WarmupPercentage":{"type":"integer"},"PoolName":{}}},"S2u":{"type":"list","member":{"type":"structure","members":{"Domain":{},"SubscriptionStartDate":{"type":"timestamp"},"InboxPlacementTrackingOption":{"type":"structure","members":{"Global":{"type":"boolean"},"TrackedIsps":{"type":"list","member":{}}}}}}},"S32":{"type":"structure","members":{"ReportId":{},"ReportName":{},"Subject":{},"FromEmailAddress":{},"CreateDate":{"type":"timestamp"},"DeliverabilityTestStatus":{}}},"S34":{"type":"structure","members":{"InboxPercentage":{"type":"double"},"SpamPercentage":{"type":"double"},"MissingPercentage":{"type":"double"},"SpfPercentage":{"type":"double"},"DkimPercentage":{"type":"double"}}},"S3c":{"type":"structure","members":{"CampaignId":{},"ImageUrl":{},"Subject":{},"FromAddress":{},"SendingIps":{"type":"list","member":{}},"FirstSeenDateTime":{"type":"timestamp"},"LastSeenDateTime":{"type":"timestamp"},"InboxCount":{"type":"long"},"SpamCount":{"type":"long"},"ReadRate":{"type":"double"},"DeleteRate":{"type":"double"},"ReadDeleteRate":{"type":"double"},"ProjectedVolume":{"type":"long"},"Esps":{"type":"list","member":{}}}},"S3m":{"type":"structure","members":{"InboxRawCount":{"type":"long"},"SpamRawCount":{"type":"long"},"ProjectedInbox":{"type":"long"},"ProjectedSpam":{"type":"long"}}},"S3n":{"type":"list","member":{"type":"structure","members":{"IspName":{},"InboxRawCount":{"type":"long"},"SpamRawCount":{"type":"long"},"InboxPercentage":{"type":"double"},"SpamPercentage":{"type":"double"}}}},"S56":{"type":"list","member":{}}}}');

});

parcelRequire.register("emXhg", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"GetDedicatedIps":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"},"ListConfigurationSets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"},"ListDedicatedIpPools":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"},"ListDeliverabilityTestReports":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"},"ListDomainDeliverabilityCampaigns":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"},"ListEmailIdentities":{"input_token":"NextToken","output_token":"NextToken","limit_key":"PageSize"}}}');

});


parcelRequire.register("dOzzt", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $a0eb89916c850789$var$Service = $dbC7k.Service;
var $a0eb89916c850789$var$apiLoader = $dbC7k.apiLoader;
$a0eb89916c850789$var$apiLoader.services["ram"] = {};
$dbC7k.RAM = $a0eb89916c850789$var$Service.defineService("ram", [
    "2018-01-04"
]);


Object.defineProperty($a0eb89916c850789$var$apiLoader.services["ram"], "2018-01-04", {
    get: function get() {
        var model = (parcelRequire("7pYG1"));
        model.paginators = (parcelRequire("hRL3a")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.RAM;

});
parcelRequire.register("7pYG1", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-01-04","endpointPrefix":"ram","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"RAM","serviceFullName":"AWS Resource Access Manager","serviceId":"RAM","signatureVersion":"v4","uid":"ram-2018-01-04"},"operations":{"AcceptResourceShareInvitation":{"http":{"requestUri":"/acceptresourceshareinvitation"},"input":{"type":"structure","required":["resourceShareInvitationArn"],"members":{"resourceShareInvitationArn":{},"clientToken":{}}},"output":{"type":"structure","members":{"resourceShareInvitation":{"shape":"S4"},"clientToken":{}}}},"AssociateResourceShare":{"http":{"requestUri":"/associateresourceshare"},"input":{"type":"structure","required":["resourceShareArn"],"members":{"resourceShareArn":{},"resourceArns":{"shape":"Sd"},"principals":{"shape":"Se"},"clientToken":{}}},"output":{"type":"structure","members":{"resourceShareAssociations":{"shape":"S7"},"clientToken":{}}}},"CreateResourceShare":{"http":{"requestUri":"/createresourceshare"},"input":{"type":"structure","required":["name"],"members":{"name":{},"resourceArns":{"shape":"Sd"},"principals":{"shape":"Se"},"tags":{"shape":"Sh"},"allowExternalPrincipals":{"type":"boolean"},"clientToken":{}}},"output":{"type":"structure","members":{"resourceShare":{"shape":"Sm"},"clientToken":{}}}},"DeleteResourceShare":{"http":{"method":"DELETE","requestUri":"/deleteresourceshare"},"input":{"type":"structure","required":["resourceShareArn"],"members":{"resourceShareArn":{"location":"querystring","locationName":"resourceShareArn"},"clientToken":{"location":"querystring","locationName":"clientToken"}}},"output":{"type":"structure","members":{"returnValue":{"type":"boolean"},"clientToken":{}}}},"DisassociateResourceShare":{"http":{"requestUri":"/disassociateresourceshare"},"input":{"type":"structure","required":["resourceShareArn"],"members":{"resourceShareArn":{},"resourceArns":{"shape":"Sd"},"principals":{"shape":"Se"},"clientToken":{}}},"output":{"type":"structure","members":{"resourceShareAssociations":{"shape":"S7"},"clientToken":{}}}},"EnableSharingWithAwsOrganization":{"http":{"requestUri":"/enablesharingwithawsorganization"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"returnValue":{"type":"boolean"}}}},"GetResourcePolicies":{"http":{"requestUri":"/getresourcepolicies"},"input":{"type":"structure","required":["resourceArns"],"members":{"resourceArns":{"shape":"Sd"},"principal":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"policies":{"type":"list","member":{}},"nextToken":{}}}},"GetResourceShareAssociations":{"http":{"requestUri":"/getresourceshareassociations"},"input":{"type":"structure","required":["associationType"],"members":{"associationType":{},"resourceShareArns":{"shape":"S10"},"resourceArn":{},"principal":{},"associationStatus":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"resourceShareAssociations":{"shape":"S7"},"nextToken":{}}}},"GetResourceShareInvitations":{"http":{"requestUri":"/getresourceshareinvitations"},"input":{"type":"structure","members":{"resourceShareInvitationArns":{"type":"list","member":{}},"resourceShareArns":{"shape":"S10"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"resourceShareInvitations":{"type":"list","member":{"shape":"S4"}},"nextToken":{}}}},"GetResourceShares":{"http":{"requestUri":"/getresourceshares"},"input":{"type":"structure","required":["resourceOwner"],"members":{"resourceShareArns":{"shape":"S10"},"resourceShareStatus":{},"resourceOwner":{},"name":{},"tagFilters":{"type":"list","member":{"type":"structure","members":{"tagKey":{},"tagValues":{"type":"list","member":{}}}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"resourceShares":{"type":"list","member":{"shape":"Sm"}},"nextToken":{}}}},"ListPrincipals":{"http":{"requestUri":"/listprincipals"},"input":{"type":"structure","required":["resourceOwner"],"members":{"resourceOwner":{},"resourceArn":{},"principals":{"shape":"Se"},"resourceType":{},"resourceShareArns":{"shape":"S10"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"principals":{"type":"list","member":{"type":"structure","members":{"id":{},"resourceShareArn":{},"creationTime":{"type":"timestamp"},"lastUpdatedTime":{"type":"timestamp"},"external":{"type":"boolean"}}}},"nextToken":{}}}},"ListResources":{"http":{"requestUri":"/listresources"},"input":{"type":"structure","required":["resourceOwner"],"members":{"resourceOwner":{},"principal":{},"resourceType":{},"resourceArns":{"shape":"Sd"},"resourceShareArns":{"shape":"S10"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"resources":{"type":"list","member":{"type":"structure","members":{"arn":{},"type":{},"resourceShareArn":{},"status":{},"statusMessage":{},"creationTime":{"type":"timestamp"},"lastUpdatedTime":{"type":"timestamp"}}}},"nextToken":{}}}},"RejectResourceShareInvitation":{"http":{"requestUri":"/rejectresourceshareinvitation"},"input":{"type":"structure","required":["resourceShareInvitationArn"],"members":{"resourceShareInvitationArn":{},"clientToken":{}}},"output":{"type":"structure","members":{"resourceShareInvitation":{"shape":"S4"},"clientToken":{}}}},"TagResource":{"http":{"requestUri":"/tagresource"},"input":{"type":"structure","required":["resourceShareArn","tags"],"members":{"resourceShareArn":{},"tags":{"shape":"Sh"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"requestUri":"/untagresource"},"input":{"type":"structure","required":["resourceShareArn","tagKeys"],"members":{"resourceShareArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateResourceShare":{"http":{"requestUri":"/updateresourceshare"},"input":{"type":"structure","required":["resourceShareArn"],"members":{"resourceShareArn":{},"name":{},"allowExternalPrincipals":{"type":"boolean"},"clientToken":{}}},"output":{"type":"structure","members":{"resourceShare":{"shape":"Sm"},"clientToken":{}}}}},"shapes":{"S4":{"type":"structure","members":{"resourceShareInvitationArn":{},"resourceShareName":{},"resourceShareArn":{},"senderAccountId":{},"receiverAccountId":{},"invitationTimestamp":{"type":"timestamp"},"status":{},"resourceShareAssociations":{"shape":"S7"}}},"S7":{"type":"list","member":{"type":"structure","members":{"resourceShareArn":{},"associatedEntity":{},"associationType":{},"status":{},"statusMessage":{},"creationTime":{"type":"timestamp"},"lastUpdatedTime":{"type":"timestamp"},"external":{"type":"boolean"}}}},"Sd":{"type":"list","member":{}},"Se":{"type":"list","member":{}},"Sh":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}}},"Sm":{"type":"structure","members":{"resourceShareArn":{},"name":{},"owningAccountId":{},"allowExternalPrincipals":{"type":"boolean"},"status":{},"statusMessage":{},"tags":{"shape":"Sh"},"creationTime":{"type":"timestamp"},"lastUpdatedTime":{"type":"timestamp"}}},"S10":{"type":"list","member":{}}}}');

});

parcelRequire.register("hRL3a", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"GetResourcePolicies":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetResourceShareAssociations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetResourceShareInvitations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetResourceShares":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListPrincipals":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListResources":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}');

});


parcelRequire.register("5ufha", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $3feb9a9429931388$var$Service = $dbC7k.Service;
var $3feb9a9429931388$var$apiLoader = $dbC7k.apiLoader;
$3feb9a9429931388$var$apiLoader.services["route53resolver"] = {};
$dbC7k.Route53Resolver = $3feb9a9429931388$var$Service.defineService("route53resolver", [
    "2018-04-01"
]);


Object.defineProperty($3feb9a9429931388$var$apiLoader.services["route53resolver"], "2018-04-01", {
    get: function get() {
        var model = (parcelRequire("gkOiB"));
        model.paginators = (parcelRequire("4896n")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Route53Resolver;

});
parcelRequire.register("gkOiB", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-04-01","endpointPrefix":"route53resolver","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Route53Resolver","serviceFullName":"Amazon Route 53 Resolver","serviceId":"Route53Resolver","signatureVersion":"v4","targetPrefix":"Route53Resolver","uid":"route53resolver-2018-04-01"},"operations":{"AssociateResolverEndpointIpAddress":{"input":{"type":"structure","required":["ResolverEndpointId","IpAddress"],"members":{"ResolverEndpointId":{},"IpAddress":{"shape":"S3"}}},"output":{"type":"structure","members":{"ResolverEndpoint":{"shape":"S7"}}}},"AssociateResolverRule":{"input":{"type":"structure","required":["ResolverRuleId","VPCId"],"members":{"ResolverRuleId":{},"Name":{},"VPCId":{}}},"output":{"type":"structure","members":{"ResolverRuleAssociation":{"shape":"Sj"}}}},"CreateResolverEndpoint":{"input":{"type":"structure","required":["CreatorRequestId","SecurityGroupIds","Direction","IpAddresses"],"members":{"CreatorRequestId":{},"Name":{},"SecurityGroupIds":{"shape":"Sb"},"Direction":{},"IpAddresses":{"type":"list","member":{"type":"structure","required":["SubnetId"],"members":{"SubnetId":{},"Ip":{}}}},"Tags":{"shape":"So"}}},"output":{"type":"structure","members":{"ResolverEndpoint":{"shape":"S7"}}}},"CreateResolverRule":{"input":{"type":"structure","required":["CreatorRequestId","RuleType","DomainName"],"members":{"CreatorRequestId":{},"Name":{},"RuleType":{},"DomainName":{},"TargetIps":{"shape":"Sw"},"ResolverEndpointId":{},"Tags":{"shape":"So"}}},"output":{"type":"structure","members":{"ResolverRule":{"shape":"S10"}}}},"DeleteResolverEndpoint":{"input":{"type":"structure","required":["ResolverEndpointId"],"members":{"ResolverEndpointId":{}}},"output":{"type":"structure","members":{"ResolverEndpoint":{"shape":"S7"}}}},"DeleteResolverRule":{"input":{"type":"structure","required":["ResolverRuleId"],"members":{"ResolverRuleId":{}}},"output":{"type":"structure","members":{"ResolverRule":{"shape":"S10"}}}},"DisassociateResolverEndpointIpAddress":{"input":{"type":"structure","required":["ResolverEndpointId","IpAddress"],"members":{"ResolverEndpointId":{},"IpAddress":{"shape":"S3"}}},"output":{"type":"structure","members":{"ResolverEndpoint":{"shape":"S7"}}}},"DisassociateResolverRule":{"input":{"type":"structure","required":["VPCId","ResolverRuleId"],"members":{"VPCId":{},"ResolverRuleId":{}}},"output":{"type":"structure","members":{"ResolverRuleAssociation":{"shape":"Sj"}}}},"GetResolverEndpoint":{"input":{"type":"structure","required":["ResolverEndpointId"],"members":{"ResolverEndpointId":{}}},"output":{"type":"structure","members":{"ResolverEndpoint":{"shape":"S7"}}}},"GetResolverRule":{"input":{"type":"structure","required":["ResolverRuleId"],"members":{"ResolverRuleId":{}}},"output":{"type":"structure","members":{"ResolverRule":{"shape":"S10"}}}},"GetResolverRuleAssociation":{"input":{"type":"structure","required":["ResolverRuleAssociationId"],"members":{"ResolverRuleAssociationId":{}}},"output":{"type":"structure","members":{"ResolverRuleAssociation":{"shape":"Sj"}}}},"GetResolverRulePolicy":{"input":{"type":"structure","required":["Arn"],"members":{"Arn":{}}},"output":{"type":"structure","members":{"ResolverRulePolicy":{}}}},"ListResolverEndpointIpAddresses":{"input":{"type":"structure","required":["ResolverEndpointId"],"members":{"ResolverEndpointId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"IpAddresses":{"type":"list","member":{"type":"structure","members":{"IpId":{},"SubnetId":{},"Ip":{},"Status":{},"StatusMessage":{},"CreationTime":{},"ModificationTime":{}}}}}}},"ListResolverEndpoints":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S1t"}}},"output":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"ResolverEndpoints":{"type":"list","member":{"shape":"S7"}}}}},"ListResolverRuleAssociations":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S1t"}}},"output":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"ResolverRuleAssociations":{"type":"list","member":{"shape":"Sj"}}}}},"ListResolverRules":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S1t"}}},"output":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"ResolverRules":{"type":"list","member":{"shape":"S10"}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"So"},"NextToken":{}}}},"PutResolverRulePolicy":{"input":{"type":"structure","required":["Arn","ResolverRulePolicy"],"members":{"Arn":{},"ResolverRulePolicy":{}}},"output":{"type":"structure","members":{"ReturnValue":{"type":"boolean"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"So"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateResolverEndpoint":{"input":{"type":"structure","required":["ResolverEndpointId"],"members":{"ResolverEndpointId":{},"Name":{}}},"output":{"type":"structure","members":{"ResolverEndpoint":{"shape":"S7"}}}},"UpdateResolverRule":{"input":{"type":"structure","required":["ResolverRuleId","Config"],"members":{"ResolverRuleId":{},"Config":{"type":"structure","members":{"Name":{},"TargetIps":{"shape":"Sw"},"ResolverEndpointId":{}}}}},"output":{"type":"structure","members":{"ResolverRule":{"shape":"S10"}}}}},"shapes":{"S3":{"type":"structure","members":{"IpId":{},"SubnetId":{},"Ip":{}}},"S7":{"type":"structure","members":{"Id":{},"CreatorRequestId":{},"Arn":{},"Name":{},"SecurityGroupIds":{"shape":"Sb"},"Direction":{},"IpAddressCount":{"type":"integer"},"HostVPCId":{},"Status":{},"StatusMessage":{},"CreationTime":{},"ModificationTime":{}}},"Sb":{"type":"list","member":{}},"Sj":{"type":"structure","members":{"Id":{},"ResolverRuleId":{},"Name":{},"VPCId":{},"Status":{},"StatusMessage":{}}},"So":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Sw":{"type":"list","member":{"type":"structure","required":["Ip"],"members":{"Ip":{},"Port":{"type":"integer"}}}},"S10":{"type":"structure","members":{"Id":{},"CreatorRequestId":{},"Arn":{},"DomainName":{},"Status":{},"StatusMessage":{},"RuleType":{},"Name":{},"TargetIps":{"shape":"Sw"},"ResolverEndpointId":{},"OwnerId":{},"ShareStatus":{}}},"S1t":{"type":"list","member":{"type":"structure","members":{"Name":{},"Values":{"type":"list","member":{}}}}}}}');

});

parcelRequire.register("4896n", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListResolverEndpointIpAddresses":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListResolverEndpoints":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListResolverRuleAssociations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListResolverRules":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("3yBwy", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $2971a796f35d4d91$var$Service = $dbC7k.Service;
var $2971a796f35d4d91$var$apiLoader = $dbC7k.apiLoader;
$2971a796f35d4d91$var$apiLoader.services["pinpointsmsvoice"] = {};
$dbC7k.PinpointSMSVoice = $2971a796f35d4d91$var$Service.defineService("pinpointsmsvoice", [
    "2018-09-05"
]);

Object.defineProperty($2971a796f35d4d91$var$apiLoader.services["pinpointsmsvoice"], "2018-09-05", {
    get: function get() {
        var model = (parcelRequire("goF8Z"));
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.PinpointSMSVoice;

});
parcelRequire.register("goF8Z", function(module, exports) {
module.exports = JSON.parse('{"metadata":{"apiVersion":"2018-09-05","endpointPrefix":"sms-voice.pinpoint","signingName":"sms-voice","serviceAbbreviation":"Pinpoint SMS Voice","serviceFullName":"Amazon Pinpoint SMS and Voice Service","serviceId":"Pinpoint SMS Voice","protocol":"rest-json","jsonVersion":"1.1","uid":"pinpoint-sms-voice-2018-09-05","signatureVersion":"v4"},"operations":{"CreateConfigurationSet":{"http":{"requestUri":"/v1/sms-voice/configuration-sets","responseCode":200},"input":{"type":"structure","members":{"ConfigurationSetName":{}}},"output":{"type":"structure","members":{}}},"CreateConfigurationSetEventDestination":{"http":{"requestUri":"/v1/sms-voice/configuration-sets/{ConfigurationSetName}/event-destinations","responseCode":200},"input":{"type":"structure","members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"EventDestination":{"shape":"S6"},"EventDestinationName":{}},"required":["ConfigurationSetName"]},"output":{"type":"structure","members":{}}},"DeleteConfigurationSet":{"http":{"method":"DELETE","requestUri":"/v1/sms-voice/configuration-sets/{ConfigurationSetName}","responseCode":200},"input":{"type":"structure","members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"}},"required":["ConfigurationSetName"]},"output":{"type":"structure","members":{}}},"DeleteConfigurationSetEventDestination":{"http":{"method":"DELETE","requestUri":"/v1/sms-voice/configuration-sets/{ConfigurationSetName}/event-destinations/{EventDestinationName}","responseCode":200},"input":{"type":"structure","members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"EventDestinationName":{"location":"uri","locationName":"EventDestinationName"}},"required":["EventDestinationName","ConfigurationSetName"]},"output":{"type":"structure","members":{}}},"GetConfigurationSetEventDestinations":{"http":{"method":"GET","requestUri":"/v1/sms-voice/configuration-sets/{ConfigurationSetName}/event-destinations","responseCode":200},"input":{"type":"structure","members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"}},"required":["ConfigurationSetName"]},"output":{"type":"structure","members":{"EventDestinations":{"type":"list","member":{"type":"structure","members":{"CloudWatchLogsDestination":{"shape":"S7"},"Enabled":{"type":"boolean"},"KinesisFirehoseDestination":{"shape":"Sa"},"MatchingEventTypes":{"shape":"Sb"},"Name":{},"SnsDestination":{"shape":"Sd"}}}}}}},"ListConfigurationSets":{"http":{"method":"GET","requestUri":"/v1/sms-voice/configuration-sets","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"PageSize":{"location":"querystring","locationName":"PageSize"}}},"output":{"type":"structure","members":{"ConfigurationSets":{"type":"list","member":{}},"NextToken":{}}}},"SendVoiceMessage":{"http":{"requestUri":"/v1/sms-voice/voice/message","responseCode":200},"input":{"type":"structure","members":{"CallerId":{},"ConfigurationSetName":{},"Content":{"type":"structure","members":{"CallInstructionsMessage":{"type":"structure","members":{"Text":{}},"required":[]},"PlainTextMessage":{"type":"structure","members":{"LanguageCode":{},"Text":{},"VoiceId":{}},"required":[]},"SSMLMessage":{"type":"structure","members":{"LanguageCode":{},"Text":{},"VoiceId":{}},"required":[]}}},"DestinationPhoneNumber":{},"OriginationPhoneNumber":{}}},"output":{"type":"structure","members":{"MessageId":{}}}},"UpdateConfigurationSetEventDestination":{"http":{"method":"PUT","requestUri":"/v1/sms-voice/configuration-sets/{ConfigurationSetName}/event-destinations/{EventDestinationName}","responseCode":200},"input":{"type":"structure","members":{"ConfigurationSetName":{"location":"uri","locationName":"ConfigurationSetName"},"EventDestination":{"shape":"S6"},"EventDestinationName":{"location":"uri","locationName":"EventDestinationName"}},"required":["EventDestinationName","ConfigurationSetName"]},"output":{"type":"structure","members":{}}}},"shapes":{"S6":{"type":"structure","members":{"CloudWatchLogsDestination":{"shape":"S7"},"Enabled":{"type":"boolean"},"KinesisFirehoseDestination":{"shape":"Sa"},"MatchingEventTypes":{"shape":"Sb"},"SnsDestination":{"shape":"Sd"}},"required":[]},"S7":{"type":"structure","members":{"IamRoleArn":{},"LogGroupArn":{}},"required":[]},"Sa":{"type":"structure","members":{"DeliveryStreamArn":{},"IamRoleArn":{}},"required":[]},"Sb":{"type":"list","member":{}},"Sd":{"type":"structure","members":{"TopicArn":{}},"required":[]}}}');

});


parcelRequire.register("il6YC", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $d59f9993d484515d$var$Service = $dbC7k.Service;
var $d59f9993d484515d$var$apiLoader = $dbC7k.apiLoader;
$d59f9993d484515d$var$apiLoader.services["quicksight"] = {};
$dbC7k.QuickSight = $d59f9993d484515d$var$Service.defineService("quicksight", [
    "2018-04-01"
]);


Object.defineProperty($d59f9993d484515d$var$apiLoader.services["quicksight"], "2018-04-01", {
    get: function get() {
        var model = (parcelRequire("atMMW"));
        model.paginators = (parcelRequire("3wyuw")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.QuickSight;

});
parcelRequire.register("atMMW", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-04-01","endpointPrefix":"quicksight","jsonVersion":"1.0","protocol":"rest-json","serviceFullName":"Amazon QuickSight","serviceId":"QuickSight","signatureVersion":"v4","uid":"quicksight-2018-04-01"},"operations":{"CreateGroup":{"http":{"requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/groups"},"input":{"type":"structure","required":["GroupName","AwsAccountId","Namespace"],"members":{"GroupName":{},"Description":{},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"Group":{"shape":"S7"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"CreateGroupMembership":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/groups/{GroupName}/members/{MemberName}"},"input":{"type":"structure","required":["MemberName","GroupName","AwsAccountId","Namespace"],"members":{"MemberName":{"location":"uri","locationName":"MemberName"},"GroupName":{"location":"uri","locationName":"GroupName"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"GroupMember":{"shape":"Se"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DeleteGroup":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/groups/{GroupName}"},"input":{"type":"structure","required":["GroupName","AwsAccountId","Namespace"],"members":{"GroupName":{"location":"uri","locationName":"GroupName"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DeleteGroupMembership":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/groups/{GroupName}/members/{MemberName}"},"input":{"type":"structure","required":["MemberName","GroupName","AwsAccountId","Namespace"],"members":{"MemberName":{"location":"uri","locationName":"MemberName"},"GroupName":{"location":"uri","locationName":"GroupName"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DeleteUser":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/users/{UserName}"},"input":{"type":"structure","required":["UserName","AwsAccountId","Namespace"],"members":{"UserName":{"location":"uri","locationName":"UserName"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DeleteUserByPrincipalId":{"http":{"method":"DELETE","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/user-principals/{PrincipalId}"},"input":{"type":"structure","required":["PrincipalId","AwsAccountId","Namespace"],"members":{"PrincipalId":{"location":"uri","locationName":"PrincipalId"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DescribeGroup":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/groups/{GroupName}"},"input":{"type":"structure","required":["GroupName","AwsAccountId","Namespace"],"members":{"GroupName":{"location":"uri","locationName":"GroupName"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"Group":{"shape":"S7"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"DescribeUser":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/users/{UserName}"},"input":{"type":"structure","required":["UserName","AwsAccountId","Namespace"],"members":{"UserName":{"location":"uri","locationName":"UserName"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"User":{"shape":"Ss"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"GetDashboardEmbedUrl":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/dashboards/{DashboardId}/embed-url"},"input":{"type":"structure","required":["AwsAccountId","DashboardId","IdentityType"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"DashboardId":{"location":"uri","locationName":"DashboardId"},"IdentityType":{"location":"querystring","locationName":"creds-type"},"SessionLifetimeInMinutes":{"location":"querystring","locationName":"session-lifetime","type":"long"},"UndoRedoDisabled":{"location":"querystring","locationName":"undo-redo-disabled","type":"boolean"},"ResetDisabled":{"location":"querystring","locationName":"reset-disabled","type":"boolean"},"UserArn":{"location":"querystring","locationName":"user-arn"}}},"output":{"type":"structure","members":{"EmbedUrl":{"type":"string","sensitive":true},"Status":{"location":"statusCode","type":"integer"},"RequestId":{}}}},"ListGroupMemberships":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/groups/{GroupName}/members"},"input":{"type":"structure","required":["GroupName","AwsAccountId","Namespace"],"members":{"GroupName":{"location":"uri","locationName":"GroupName"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"GroupMemberList":{"type":"list","member":{"shape":"Se"}},"NextToken":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"ListGroups":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/groups"},"input":{"type":"structure","required":["AwsAccountId","Namespace"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"GroupList":{"shape":"S17"},"NextToken":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"ListUserGroups":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/users/{UserName}/groups"},"input":{"type":"structure","required":["UserName","AwsAccountId","Namespace"],"members":{"UserName":{"location":"uri","locationName":"UserName"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"}}},"output":{"type":"structure","members":{"GroupList":{"shape":"S17"},"NextToken":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"ListUsers":{"http":{"method":"GET","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/users"},"input":{"type":"structure","required":["AwsAccountId","Namespace"],"members":{"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"NextToken":{"location":"querystring","locationName":"next-token"},"MaxResults":{"location":"querystring","locationName":"max-results","type":"integer"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"UserList":{"type":"list","member":{"shape":"Ss"}},"NextToken":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"RegisterUser":{"http":{"requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/users"},"input":{"type":"structure","required":["IdentityType","Email","UserRole","AwsAccountId","Namespace"],"members":{"IdentityType":{},"Email":{},"UserRole":{},"IamArn":{},"SessionName":{},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"},"UserName":{}}},"output":{"type":"structure","members":{"User":{"shape":"Ss"},"UserInvitationUrl":{},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"UpdateGroup":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/groups/{GroupName}"},"input":{"type":"structure","required":["GroupName","AwsAccountId","Namespace"],"members":{"GroupName":{"location":"uri","locationName":"GroupName"},"Description":{},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"}}},"output":{"type":"structure","members":{"Group":{"shape":"S7"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}},"UpdateUser":{"http":{"method":"PUT","requestUri":"/accounts/{AwsAccountId}/namespaces/{Namespace}/users/{UserName}"},"input":{"type":"structure","required":["UserName","AwsAccountId","Namespace","Email","Role"],"members":{"UserName":{"location":"uri","locationName":"UserName"},"AwsAccountId":{"location":"uri","locationName":"AwsAccountId"},"Namespace":{"location":"uri","locationName":"Namespace"},"Email":{},"Role":{}}},"output":{"type":"structure","members":{"User":{"shape":"Ss"},"RequestId":{},"Status":{"location":"statusCode","type":"integer"}}}}},"shapes":{"S7":{"type":"structure","members":{"Arn":{},"GroupName":{},"Description":{},"PrincipalId":{}}},"Se":{"type":"structure","members":{"Arn":{},"MemberName":{}}},"Ss":{"type":"structure","members":{"Arn":{},"UserName":{},"Email":{},"Role":{},"IdentityType":{},"Active":{"type":"boolean"},"PrincipalId":{}}},"S17":{"type":"list","member":{"shape":"S7"}}}}');

});

parcelRequire.register("3wyuw", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("3FYNA", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $2ad45cd38a82eb87$var$Service = $dbC7k.Service;
var $2ad45cd38a82eb87$var$apiLoader = $dbC7k.apiLoader;
$2ad45cd38a82eb87$var$apiLoader.services["rdsdataservice"] = {};
$dbC7k.RDSDataService = $2ad45cd38a82eb87$var$Service.defineService("rdsdataservice", [
    "2018-08-01"
]);


Object.defineProperty($2ad45cd38a82eb87$var$apiLoader.services["rdsdataservice"], "2018-08-01", {
    get: function get() {
        var model = (parcelRequire("1uzlt"));
        model.paginators = (parcelRequire("lnX3a")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.RDSDataService;

});
parcelRequire.register("1uzlt", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-08-01","endpointPrefix":"rds-data","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS RDS DataService","serviceId":"RDS Data","signatureVersion":"v4","signingName":"rds-data","uid":"rds-data-2018-08-01"},"operations":{"BatchExecuteStatement":{"http":{"requestUri":"/BatchExecute","responseCode":200},"input":{"type":"structure","required":["resourceArn","secretArn","sql"],"members":{"database":{},"parameterSets":{"type":"list","member":{"shape":"S4"}},"resourceArn":{},"schema":{},"secretArn":{},"sql":{},"transactionId":{}}},"output":{"type":"structure","members":{"updateResults":{"type":"list","member":{"type":"structure","members":{"generatedFields":{"shape":"Sj"}}}}}}},"BeginTransaction":{"http":{"requestUri":"/BeginTransaction","responseCode":200},"input":{"type":"structure","required":["resourceArn","secretArn"],"members":{"database":{},"resourceArn":{},"schema":{},"secretArn":{}}},"output":{"type":"structure","members":{"transactionId":{}}}},"CommitTransaction":{"http":{"requestUri":"/CommitTransaction","responseCode":200},"input":{"type":"structure","required":["resourceArn","secretArn","transactionId"],"members":{"resourceArn":{},"secretArn":{},"transactionId":{}}},"output":{"type":"structure","members":{"transactionStatus":{}}}},"ExecuteSql":{"http":{"requestUri":"/ExecuteSql","responseCode":200},"input":{"type":"structure","required":["awsSecretStoreArn","dbClusterOrInstanceArn","sqlStatements"],"members":{"awsSecretStoreArn":{},"database":{},"dbClusterOrInstanceArn":{},"schema":{},"sqlStatements":{}}},"output":{"type":"structure","members":{"sqlStatementResults":{"type":"list","member":{"type":"structure","members":{"numberOfRecordsUpdated":{"type":"long"},"resultFrame":{"type":"structure","members":{"records":{"type":"list","member":{"type":"structure","members":{"values":{"type":"list","member":{"shape":"Sy"}}}}},"resultSetMetadata":{"type":"structure","members":{"columnCount":{"type":"long"},"columnMetadata":{"shape":"S15"}}}}}}}}}},"deprecated":true},"ExecuteStatement":{"http":{"requestUri":"/Execute","responseCode":200},"input":{"type":"structure","required":["resourceArn","secretArn","sql"],"members":{"continueAfterTimeout":{"type":"boolean"},"database":{},"includeResultMetadata":{"type":"boolean"},"parameters":{"shape":"S4"},"resourceArn":{},"schema":{},"secretArn":{},"sql":{},"transactionId":{}}},"output":{"type":"structure","members":{"columnMetadata":{"shape":"S15"},"generatedFields":{"shape":"Sj"},"numberOfRecordsUpdated":{"type":"long"},"records":{"type":"list","member":{"shape":"Sj"}}}}},"RollbackTransaction":{"http":{"requestUri":"/RollbackTransaction","responseCode":200},"input":{"type":"structure","required":["resourceArn","secretArn","transactionId"],"members":{"resourceArn":{},"secretArn":{},"transactionId":{}}},"output":{"type":"structure","members":{"transactionStatus":{}}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{"shape":"S7"}}}},"S7":{"type":"structure","members":{"blobValue":{"type":"blob"},"booleanValue":{"type":"boolean"},"doubleValue":{"type":"double"},"isNull":{"type":"boolean"},"longValue":{"type":"long"},"stringValue":{}}},"Sj":{"type":"list","member":{"shape":"S7"}},"Sy":{"type":"structure","members":{"arrayValues":{"shape":"Sz"},"bigIntValue":{"type":"long"},"bitValue":{"type":"boolean"},"blobValue":{"type":"blob"},"doubleValue":{"type":"double"},"intValue":{"type":"integer"},"isNull":{"type":"boolean"},"realValue":{"type":"float"},"stringValue":{},"structValue":{"type":"structure","members":{"attributes":{"shape":"Sz"}}}}},"Sz":{"type":"list","member":{"shape":"Sy"}},"S15":{"type":"list","member":{"type":"structure","members":{"arrayBaseColumnType":{"type":"integer"},"isAutoIncrement":{"type":"boolean"},"isCaseSensitive":{"type":"boolean"},"isCurrency":{"type":"boolean"},"isSigned":{"type":"boolean"},"label":{},"name":{},"nullable":{"type":"integer"},"precision":{"type":"integer"},"scale":{"type":"integer"},"schemaName":{},"tableName":{},"type":{"type":"integer"},"typeName":{}}}}}}');

});

parcelRequire.register("lnX3a", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("dlJxB", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $9b80900435ca9bc5$var$Service = $dbC7k.Service;
var $9b80900435ca9bc5$var$apiLoader = $dbC7k.apiLoader;
$9b80900435ca9bc5$var$apiLoader.services["amplify"] = {};
$dbC7k.Amplify = $9b80900435ca9bc5$var$Service.defineService("amplify", [
    "2017-07-25"
]);


Object.defineProperty($9b80900435ca9bc5$var$apiLoader.services["amplify"], "2017-07-25", {
    get: function get() {
        var model = (parcelRequire("hPJ9p"));
        model.paginators = (parcelRequire("57cAK")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Amplify;

});
parcelRequire.register("hPJ9p", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-07-25","endpointPrefix":"amplify","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"Amplify","serviceFullName":"AWS Amplify","serviceId":"Amplify","signatureVersion":"v4","signingName":"amplify","uid":"amplify-2017-07-25"},"operations":{"CreateApp":{"http":{"requestUri":"/apps"},"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"repository":{},"platform":{},"iamServiceRoleArn":{},"oauthToken":{},"accessToken":{},"environmentVariables":{"shape":"S9"},"enableBranchAutoBuild":{"type":"boolean"},"enableBasicAuth":{"type":"boolean"},"basicAuthCredentials":{},"customRules":{"shape":"Sf"},"tags":{"shape":"Sl"},"buildSpec":{},"enableAutoBranchCreation":{"type":"boolean"},"autoBranchCreationPatterns":{"shape":"Sq"},"autoBranchCreationConfig":{"shape":"Ss"}}},"output":{"type":"structure","required":["app"],"members":{"app":{"shape":"Sx"}}}},"CreateBranch":{"http":{"requestUri":"/apps/{appId}/branches"},"input":{"type":"structure","required":["appId","branchName"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{},"description":{},"stage":{},"framework":{},"enableNotification":{"type":"boolean"},"enableAutoBuild":{"type":"boolean"},"environmentVariables":{"shape":"S9"},"basicAuthCredentials":{},"enableBasicAuth":{"type":"boolean"},"tags":{"shape":"Sl"},"buildSpec":{},"ttl":{},"displayName":{}}},"output":{"type":"structure","required":["branch"],"members":{"branch":{"shape":"S1c"}}}},"CreateDeployment":{"http":{"requestUri":"/apps/{appId}/branches/{branchName}/deployments"},"input":{"type":"structure","required":["appId","branchName"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{"location":"uri","locationName":"branchName"},"fileMap":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","required":["fileUploadUrls","zipUploadUrl"],"members":{"jobId":{},"fileUploadUrls":{"type":"map","key":{},"value":{}},"zipUploadUrl":{}}}},"CreateDomainAssociation":{"http":{"requestUri":"/apps/{appId}/domains"},"input":{"type":"structure","required":["appId","domainName","subDomainSettings"],"members":{"appId":{"location":"uri","locationName":"appId"},"domainName":{},"enableAutoSubDomain":{"type":"boolean"},"subDomainSettings":{"shape":"S1v"}}},"output":{"type":"structure","required":["domainAssociation"],"members":{"domainAssociation":{"shape":"S1z"}}}},"CreateWebhook":{"http":{"requestUri":"/apps/{appId}/webhooks"},"input":{"type":"structure","required":["appId","branchName"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{},"description":{}}},"output":{"type":"structure","required":["webhook"],"members":{"webhook":{"shape":"S2a"}}}},"DeleteApp":{"http":{"method":"DELETE","requestUri":"/apps/{appId}"},"input":{"type":"structure","required":["appId"],"members":{"appId":{"location":"uri","locationName":"appId"}}},"output":{"type":"structure","required":["app"],"members":{"app":{"shape":"Sx"}}}},"DeleteBranch":{"http":{"method":"DELETE","requestUri":"/apps/{appId}/branches/{branchName}"},"input":{"type":"structure","required":["appId","branchName"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{"location":"uri","locationName":"branchName"}}},"output":{"type":"structure","required":["branch"],"members":{"branch":{"shape":"S1c"}}}},"DeleteDomainAssociation":{"http":{"method":"DELETE","requestUri":"/apps/{appId}/domains/{domainName}"},"input":{"type":"structure","required":["appId","domainName"],"members":{"appId":{"location":"uri","locationName":"appId"},"domainName":{"location":"uri","locationName":"domainName"}}},"output":{"type":"structure","required":["domainAssociation"],"members":{"domainAssociation":{"shape":"S1z"}}}},"DeleteJob":{"http":{"method":"DELETE","requestUri":"/apps/{appId}/branches/{branchName}/jobs/{jobId}"},"input":{"type":"structure","required":["appId","branchName","jobId"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{"location":"uri","locationName":"branchName"},"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"type":"structure","required":["jobSummary"],"members":{"jobSummary":{"shape":"S2m"}}}},"DeleteWebhook":{"http":{"method":"DELETE","requestUri":"/webhooks/{webhookId}"},"input":{"type":"structure","required":["webhookId"],"members":{"webhookId":{"location":"uri","locationName":"webhookId"}}},"output":{"type":"structure","required":["webhook"],"members":{"webhook":{"shape":"S2a"}}}},"GetApp":{"http":{"method":"GET","requestUri":"/apps/{appId}"},"input":{"type":"structure","required":["appId"],"members":{"appId":{"location":"uri","locationName":"appId"}}},"output":{"type":"structure","required":["app"],"members":{"app":{"shape":"Sx"}}}},"GetBranch":{"http":{"method":"GET","requestUri":"/apps/{appId}/branches/{branchName}"},"input":{"type":"structure","required":["appId","branchName"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{"location":"uri","locationName":"branchName"}}},"output":{"type":"structure","required":["branch"],"members":{"branch":{"shape":"S1c"}}}},"GetDomainAssociation":{"http":{"method":"GET","requestUri":"/apps/{appId}/domains/{domainName}"},"input":{"type":"structure","required":["appId","domainName"],"members":{"appId":{"location":"uri","locationName":"appId"},"domainName":{"location":"uri","locationName":"domainName"}}},"output":{"type":"structure","required":["domainAssociation"],"members":{"domainAssociation":{"shape":"S1z"}}}},"GetJob":{"http":{"method":"GET","requestUri":"/apps/{appId}/branches/{branchName}/jobs/{jobId}"},"input":{"type":"structure","required":["appId","branchName","jobId"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{"location":"uri","locationName":"branchName"},"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"type":"structure","required":["job"],"members":{"job":{"type":"structure","required":["summary","steps"],"members":{"summary":{"shape":"S2m"},"steps":{"type":"list","member":{"type":"structure","required":["stepName","startTime","status","endTime"],"members":{"stepName":{},"startTime":{"type":"timestamp"},"status":{},"endTime":{"type":"timestamp"},"logUrl":{},"artifactsUrl":{},"screenshots":{"type":"map","key":{},"value":{}},"statusReason":{},"context":{}}}}}}}}},"GetWebhook":{"http":{"method":"GET","requestUri":"/webhooks/{webhookId}"},"input":{"type":"structure","required":["webhookId"],"members":{"webhookId":{"location":"uri","locationName":"webhookId"}}},"output":{"type":"structure","required":["webhook"],"members":{"webhook":{"shape":"S2a"}}}},"ListApps":{"http":{"method":"GET","requestUri":"/apps"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["apps"],"members":{"apps":{"type":"list","member":{"shape":"Sx"}},"nextToken":{}}}},"ListBranches":{"http":{"method":"GET","requestUri":"/apps/{appId}/branches"},"input":{"type":"structure","required":["appId"],"members":{"appId":{"location":"uri","locationName":"appId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["branches"],"members":{"branches":{"type":"list","member":{"shape":"S1c"}},"nextToken":{}}}},"ListDomainAssociations":{"http":{"method":"GET","requestUri":"/apps/{appId}/domains"},"input":{"type":"structure","required":["appId"],"members":{"appId":{"location":"uri","locationName":"appId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["domainAssociations"],"members":{"domainAssociations":{"type":"list","member":{"shape":"S1z"}},"nextToken":{}}}},"ListJobs":{"http":{"method":"GET","requestUri":"/apps/{appId}/branches/{branchName}/jobs"},"input":{"type":"structure","required":["appId","branchName"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{"location":"uri","locationName":"branchName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["jobSummaries"],"members":{"jobSummaries":{"type":"list","member":{"shape":"S2m"}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sl"}}}},"ListWebhooks":{"http":{"method":"GET","requestUri":"/apps/{appId}/webhooks"},"input":{"type":"structure","required":["appId"],"members":{"appId":{"location":"uri","locationName":"appId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","required":["webhooks"],"members":{"webhooks":{"type":"list","member":{"shape":"S2a"}},"nextToken":{}}}},"StartDeployment":{"http":{"requestUri":"/apps/{appId}/branches/{branchName}/deployments/start"},"input":{"type":"structure","required":["appId","branchName"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{"location":"uri","locationName":"branchName"},"jobId":{},"sourceUrl":{}}},"output":{"type":"structure","required":["jobSummary"],"members":{"jobSummary":{"shape":"S2m"}}}},"StartJob":{"http":{"requestUri":"/apps/{appId}/branches/{branchName}/jobs"},"input":{"type":"structure","required":["appId","branchName","jobType"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{"location":"uri","locationName":"branchName"},"jobId":{},"jobType":{},"jobReason":{},"commitId":{},"commitMessage":{},"commitTime":{"type":"timestamp"}}},"output":{"type":"structure","required":["jobSummary"],"members":{"jobSummary":{"shape":"S2m"}}}},"StopJob":{"http":{"method":"DELETE","requestUri":"/apps/{appId}/branches/{branchName}/jobs/{jobId}/stop"},"input":{"type":"structure","required":["appId","branchName","jobId"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{"location":"uri","locationName":"branchName"},"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"type":"structure","required":["jobSummary"],"members":{"jobSummary":{"shape":"S2m"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sl"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateApp":{"http":{"requestUri":"/apps/{appId}"},"input":{"type":"structure","required":["appId"],"members":{"appId":{"location":"uri","locationName":"appId"},"name":{},"description":{},"platform":{},"iamServiceRoleArn":{},"environmentVariables":{"shape":"S9"},"enableBranchAutoBuild":{"type":"boolean"},"enableBasicAuth":{"type":"boolean"},"basicAuthCredentials":{},"customRules":{"shape":"Sf"},"buildSpec":{},"enableAutoBranchCreation":{"type":"boolean"},"autoBranchCreationPatterns":{"shape":"Sq"},"autoBranchCreationConfig":{"shape":"Ss"}}},"output":{"type":"structure","required":["app"],"members":{"app":{"shape":"Sx"}}}},"UpdateBranch":{"http":{"requestUri":"/apps/{appId}/branches/{branchName}"},"input":{"type":"structure","required":["appId","branchName"],"members":{"appId":{"location":"uri","locationName":"appId"},"branchName":{"location":"uri","locationName":"branchName"},"description":{},"framework":{},"stage":{},"enableNotification":{"type":"boolean"},"enableAutoBuild":{"type":"boolean"},"environmentVariables":{"shape":"S9"},"basicAuthCredentials":{},"enableBasicAuth":{"type":"boolean"},"buildSpec":{},"ttl":{},"displayName":{}}},"output":{"type":"structure","required":["branch"],"members":{"branch":{"shape":"S1c"}}}},"UpdateDomainAssociation":{"http":{"requestUri":"/apps/{appId}/domains/{domainName}"},"input":{"type":"structure","required":["appId","domainName","subDomainSettings"],"members":{"appId":{"location":"uri","locationName":"appId"},"domainName":{"location":"uri","locationName":"domainName"},"enableAutoSubDomain":{"type":"boolean"},"subDomainSettings":{"shape":"S1v"}}},"output":{"type":"structure","required":["domainAssociation"],"members":{"domainAssociation":{"shape":"S1z"}}}},"UpdateWebhook":{"http":{"requestUri":"/webhooks/{webhookId}"},"input":{"type":"structure","required":["webhookId"],"members":{"webhookId":{"location":"uri","locationName":"webhookId"},"branchName":{},"description":{}}},"output":{"type":"structure","required":["webhook"],"members":{"webhook":{"shape":"S2a"}}}}},"shapes":{"S9":{"type":"map","key":{},"value":{}},"Sf":{"type":"list","member":{"type":"structure","required":["source","target"],"members":{"source":{},"target":{},"status":{},"condition":{}}}},"Sl":{"type":"map","key":{},"value":{}},"Sq":{"type":"list","member":{}},"Ss":{"type":"structure","members":{"stage":{},"framework":{},"enableAutoBuild":{"type":"boolean"},"environmentVariables":{"shape":"S9"},"basicAuthCredentials":{},"enableBasicAuth":{"type":"boolean"},"buildSpec":{}}},"Sx":{"type":"structure","required":["appId","appArn","name","description","repository","platform","createTime","updateTime","environmentVariables","defaultDomain","enableBranchAutoBuild","enableBasicAuth"],"members":{"appId":{},"appArn":{},"name":{},"tags":{"shape":"Sl"},"description":{},"repository":{},"platform":{},"createTime":{"type":"timestamp"},"updateTime":{"type":"timestamp"},"iamServiceRoleArn":{},"environmentVariables":{"shape":"S9"},"defaultDomain":{},"enableBranchAutoBuild":{"type":"boolean"},"enableBasicAuth":{"type":"boolean"},"basicAuthCredentials":{},"customRules":{"shape":"Sf"},"productionBranch":{"type":"structure","members":{"lastDeployTime":{"type":"timestamp"},"status":{},"thumbnailUrl":{},"branchName":{}}},"buildSpec":{},"enableAutoBranchCreation":{"type":"boolean"},"autoBranchCreationPatterns":{"shape":"Sq"},"autoBranchCreationConfig":{"shape":"Ss"}}},"S1c":{"type":"structure","required":["branchArn","branchName","description","stage","displayName","enableNotification","createTime","updateTime","environmentVariables","enableAutoBuild","customDomains","framework","activeJobId","totalNumberOfJobs","enableBasicAuth","ttl"],"members":{"branchArn":{},"branchName":{},"description":{},"tags":{"shape":"Sl"},"stage":{},"displayName":{},"enableNotification":{"type":"boolean"},"createTime":{"type":"timestamp"},"updateTime":{"type":"timestamp"},"environmentVariables":{"shape":"S9"},"enableAutoBuild":{"type":"boolean"},"customDomains":{"type":"list","member":{}},"framework":{},"activeJobId":{},"totalNumberOfJobs":{},"enableBasicAuth":{"type":"boolean"},"thumbnailUrl":{},"basicAuthCredentials":{},"buildSpec":{},"ttl":{},"associatedResources":{"type":"list","member":{}}}},"S1v":{"type":"list","member":{"shape":"S1w"}},"S1w":{"type":"structure","required":["prefix","branchName"],"members":{"prefix":{},"branchName":{}}},"S1z":{"type":"structure","required":["domainAssociationArn","domainName","enableAutoSubDomain","domainStatus","statusReason","subDomains"],"members":{"domainAssociationArn":{},"domainName":{},"enableAutoSubDomain":{"type":"boolean"},"domainStatus":{},"statusReason":{},"certificateVerificationDNSRecord":{},"subDomains":{"type":"list","member":{"type":"structure","required":["subDomainSetting","verified","dnsRecord"],"members":{"subDomainSetting":{"shape":"S1w"},"verified":{"type":"boolean"},"dnsRecord":{}}}}}},"S2a":{"type":"structure","required":["webhookArn","webhookId","webhookUrl","branchName","description","createTime","updateTime"],"members":{"webhookArn":{},"webhookId":{},"webhookUrl":{},"branchName":{},"description":{},"createTime":{"type":"timestamp"},"updateTime":{"type":"timestamp"}}},"S2m":{"type":"structure","required":["jobArn","jobId","commitId","commitMessage","commitTime","startTime","status","jobType"],"members":{"jobArn":{},"jobId":{},"commitId":{},"commitMessage":{},"commitTime":{"type":"timestamp"},"startTime":{"type":"timestamp"},"status":{},"endTime":{"type":"timestamp"},"jobType":{}}}}}');

});

parcelRequire.register("57cAK", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("4IPZ5", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $3703987731eeea48$var$Service = $dbC7k.Service;
var $3703987731eeea48$var$apiLoader = $dbC7k.apiLoader;
$3703987731eeea48$var$apiLoader.services["datasync"] = {};
$dbC7k.DataSync = $3703987731eeea48$var$Service.defineService("datasync", [
    "2018-11-09"
]);


Object.defineProperty($3703987731eeea48$var$apiLoader.services["datasync"], "2018-11-09", {
    get: function get() {
        var model = (parcelRequire("l2C3s"));
        model.paginators = (parcelRequire("jTJQ2")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.DataSync;

});
parcelRequire.register("l2C3s", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-11-09","endpointPrefix":"datasync","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"DataSync","serviceFullName":"AWS DataSync","serviceId":"DataSync","signatureVersion":"v4","signingName":"datasync","targetPrefix":"FmrsService","uid":"datasync-2018-11-09"},"operations":{"CancelTaskExecution":{"input":{"type":"structure","required":["TaskExecutionArn"],"members":{"TaskExecutionArn":{}}},"output":{"type":"structure","members":{}}},"CreateAgent":{"input":{"type":"structure","required":["ActivationKey"],"members":{"ActivationKey":{},"AgentName":{},"Tags":{"shape":"S7"},"VpcEndpointId":{},"SubnetArns":{"shape":"Sb"},"SecurityGroupArns":{"shape":"Sd"}}},"output":{"type":"structure","members":{"AgentArn":{}}}},"CreateLocationEfs":{"input":{"type":"structure","required":["EfsFilesystemArn","Ec2Config"],"members":{"Subdirectory":{},"EfsFilesystemArn":{},"Ec2Config":{"shape":"Sk"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"LocationArn":{}}}},"CreateLocationNfs":{"input":{"type":"structure","required":["Subdirectory","ServerHostname","OnPremConfig"],"members":{"Subdirectory":{},"ServerHostname":{},"OnPremConfig":{"shape":"Sr"},"MountOptions":{"shape":"St"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"LocationArn":{}}}},"CreateLocationS3":{"input":{"type":"structure","required":["S3BucketArn","S3Config"],"members":{"Subdirectory":{},"S3BucketArn":{},"S3Config":{"shape":"Sy"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"LocationArn":{}}}},"CreateLocationSmb":{"input":{"type":"structure","required":["Subdirectory","ServerHostname","User","Password","AgentArns"],"members":{"Subdirectory":{},"ServerHostname":{},"User":{},"Domain":{},"Password":{},"AgentArns":{"shape":"Ss"},"MountOptions":{"shape":"S15"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"LocationArn":{}}}},"CreateTask":{"input":{"type":"structure","required":["SourceLocationArn","DestinationLocationArn"],"members":{"SourceLocationArn":{},"DestinationLocationArn":{},"CloudWatchLogGroupArn":{},"Name":{},"Options":{"shape":"S1a"},"Excludes":{"shape":"S1k"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"TaskArn":{}}}},"DeleteAgent":{"input":{"type":"structure","required":["AgentArn"],"members":{"AgentArn":{}}},"output":{"type":"structure","members":{}}},"DeleteLocation":{"input":{"type":"structure","required":["LocationArn"],"members":{"LocationArn":{}}},"output":{"type":"structure","members":{}}},"DeleteTask":{"input":{"type":"structure","required":["TaskArn"],"members":{"TaskArn":{}}},"output":{"type":"structure","members":{}}},"DescribeAgent":{"input":{"type":"structure","required":["AgentArn"],"members":{"AgentArn":{}}},"output":{"type":"structure","members":{"AgentArn":{},"Name":{},"Status":{},"LastConnectionTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"},"EndpointType":{},"PrivateLinkConfig":{"type":"structure","members":{"VpcEndpointId":{},"PrivateLinkEndpoint":{},"SubnetArns":{"shape":"Sb"},"SecurityGroupArns":{"shape":"Sd"}}}}}},"DescribeLocationEfs":{"input":{"type":"structure","required":["LocationArn"],"members":{"LocationArn":{}}},"output":{"type":"structure","members":{"LocationArn":{},"LocationUri":{},"Ec2Config":{"shape":"Sk"},"CreationTime":{"type":"timestamp"}}}},"DescribeLocationNfs":{"input":{"type":"structure","required":["LocationArn"],"members":{"LocationArn":{}}},"output":{"type":"structure","members":{"LocationArn":{},"LocationUri":{},"OnPremConfig":{"shape":"Sr"},"MountOptions":{"shape":"St"},"CreationTime":{"type":"timestamp"}}}},"DescribeLocationS3":{"input":{"type":"structure","required":["LocationArn"],"members":{"LocationArn":{}}},"output":{"type":"structure","members":{"LocationArn":{},"LocationUri":{},"S3Config":{"shape":"Sy"},"CreationTime":{"type":"timestamp"}}}},"DescribeLocationSmb":{"input":{"type":"structure","required":["LocationArn"],"members":{"LocationArn":{}}},"output":{"type":"structure","members":{"LocationArn":{},"LocationUri":{},"AgentArns":{"shape":"Ss"},"User":{},"Domain":{},"MountOptions":{"shape":"S15"},"CreationTime":{"type":"timestamp"}}}},"DescribeTask":{"input":{"type":"structure","required":["TaskArn"],"members":{"TaskArn":{}}},"output":{"type":"structure","members":{"TaskArn":{},"Status":{},"Name":{},"CurrentTaskExecutionArn":{},"SourceLocationArn":{},"DestinationLocationArn":{},"CloudWatchLogGroupArn":{},"SourceNetworkInterfaceArns":{"type":"list","member":{}},"DestinationNetworkInterfaceArns":{"type":"list","member":{}},"Options":{"shape":"S1a"},"Excludes":{"shape":"S1k"},"ErrorCode":{},"ErrorDetail":{},"CreationTime":{"type":"timestamp"}}}},"DescribeTaskExecution":{"input":{"type":"structure","required":["TaskExecutionArn"],"members":{"TaskExecutionArn":{}}},"output":{"type":"structure","members":{"TaskExecutionArn":{},"Status":{},"Options":{"shape":"S1a"},"Excludes":{"shape":"S1k"},"Includes":{"shape":"S1k"},"StartTime":{"type":"timestamp"},"EstimatedFilesToTransfer":{"type":"long"},"EstimatedBytesToTransfer":{"type":"long"},"FilesTransferred":{"type":"long"},"BytesWritten":{"type":"long"},"BytesTransferred":{"type":"long"},"Result":{"type":"structure","members":{"PrepareDuration":{"type":"long"},"PrepareStatus":{},"TransferDuration":{"type":"long"},"TransferStatus":{},"VerifyDuration":{"type":"long"},"VerifyStatus":{},"ErrorCode":{},"ErrorDetail":{}}}}}},"ListAgents":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Agents":{"type":"list","member":{"type":"structure","members":{"AgentArn":{},"Name":{},"Status":{}}}},"NextToken":{}}}},"ListLocations":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Locations":{"type":"list","member":{"type":"structure","members":{"LocationArn":{},"LocationUri":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S7"},"NextToken":{}}}},"ListTaskExecutions":{"input":{"type":"structure","members":{"TaskArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"TaskExecutions":{"type":"list","member":{"type":"structure","members":{"TaskExecutionArn":{},"Status":{}}}},"NextToken":{}}}},"ListTasks":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tasks":{"type":"list","member":{"type":"structure","members":{"TaskArn":{},"Status":{},"Name":{}}}},"NextToken":{}}}},"StartTaskExecution":{"input":{"type":"structure","required":["TaskArn"],"members":{"TaskArn":{},"OverrideOptions":{"shape":"S1a"},"Includes":{"shape":"S1k"}}},"output":{"type":"structure","members":{"TaskExecutionArn":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","Keys"],"members":{"ResourceArn":{},"Keys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAgent":{"input":{"type":"structure","required":["AgentArn"],"members":{"AgentArn":{},"Name":{}}},"output":{"type":"structure","members":{}}},"UpdateTask":{"input":{"type":"structure","required":["TaskArn"],"members":{"TaskArn":{},"Options":{"shape":"S1a"},"Excludes":{"shape":"S1k"},"Name":{},"CloudWatchLogGroupArn":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S7":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sb":{"type":"list","member":{}},"Sd":{"type":"list","member":{}},"Sk":{"type":"structure","required":["SubnetArn","SecurityGroupArns"],"members":{"SubnetArn":{},"SecurityGroupArns":{"type":"list","member":{}}}},"Sr":{"type":"structure","required":["AgentArns"],"members":{"AgentArns":{"shape":"Ss"}}},"Ss":{"type":"list","member":{}},"St":{"type":"structure","members":{"Version":{}}},"Sy":{"type":"structure","required":["BucketAccessRoleArn"],"members":{"BucketAccessRoleArn":{}}},"S15":{"type":"structure","members":{"Version":{}}},"S1a":{"type":"structure","members":{"VerifyMode":{},"Atime":{},"Mtime":{},"Uid":{},"Gid":{},"PreserveDeletedFiles":{},"PreserveDevices":{},"PosixPermissions":{},"BytesPerSecond":{"type":"long"}}},"S1k":{"type":"list","member":{"type":"structure","members":{"FilterType":{},"Value":{}}}}}}');

});

parcelRequire.register("jTJQ2", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListAgents":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListLocations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTagsForResource":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTaskExecutions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTasks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("jSc6B", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $e77c735a865ea21d$var$Service = $dbC7k.Service;
var $e77c735a865ea21d$var$apiLoader = $dbC7k.apiLoader;
$e77c735a865ea21d$var$apiLoader.services["robomaker"] = {};
$dbC7k.RoboMaker = $e77c735a865ea21d$var$Service.defineService("robomaker", [
    "2018-06-29"
]);


Object.defineProperty($e77c735a865ea21d$var$apiLoader.services["robomaker"], "2018-06-29", {
    get: function get() {
        var model = (parcelRequire("65P56"));
        model.paginators = (parcelRequire("nVIyd")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.RoboMaker;

});
parcelRequire.register("65P56", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-06-29","endpointPrefix":"robomaker","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"RoboMaker","serviceFullName":"AWS RoboMaker","serviceId":"RoboMaker","signatureVersion":"v4","signingName":"robomaker","uid":"robomaker-2018-06-29"},"operations":{"BatchDescribeSimulationJob":{"http":{"requestUri":"/batchDescribeSimulationJob"},"input":{"type":"structure","required":["jobs"],"members":{"jobs":{"shape":"S2"}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","members":{"arn":{},"name":{},"status":{},"lastStartedAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"failureBehavior":{},"failureCode":{},"failureReason":{},"clientRequestToken":{},"outputLocation":{"shape":"Sf"},"loggingConfig":{"shape":"Si"},"maxJobDurationInSeconds":{"type":"long"},"simulationTimeMillis":{"type":"long"},"iamRole":{},"robotApplications":{"shape":"Sn"},"simulationApplications":{"shape":"Sv"},"dataSources":{"shape":"Sx"},"tags":{"shape":"S12"},"vpcConfig":{"shape":"S15"}}}},"unprocessedJobs":{"shape":"S2"}}}},"CancelDeploymentJob":{"http":{"requestUri":"/cancelDeploymentJob"},"input":{"type":"structure","required":["job"],"members":{"job":{}}},"output":{"type":"structure","members":{}}},"CancelSimulationJob":{"http":{"requestUri":"/cancelSimulationJob"},"input":{"type":"structure","required":["job"],"members":{"job":{}}},"output":{"type":"structure","members":{}}},"CreateDeploymentJob":{"http":{"requestUri":"/createDeploymentJob"},"input":{"type":"structure","required":["clientRequestToken","fleet","deploymentApplicationConfigs"],"members":{"deploymentConfig":{"shape":"S1f"},"clientRequestToken":{"idempotencyToken":true},"fleet":{},"deploymentApplicationConfigs":{"shape":"S1i"},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{"arn":{},"fleet":{},"status":{},"deploymentApplicationConfigs":{"shape":"S1i"},"failureReason":{},"failureCode":{},"createdAt":{"type":"timestamp"},"deploymentConfig":{"shape":"S1f"},"tags":{"shape":"S12"}}}},"CreateFleet":{"http":{"requestUri":"/createFleet"},"input":{"type":"structure","required":["name"],"members":{"name":{},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{"arn":{},"name":{},"createdAt":{"type":"timestamp"},"tags":{"shape":"S12"}}}},"CreateRobot":{"http":{"requestUri":"/createRobot"},"input":{"type":"structure","required":["name","architecture","greengrassGroupId"],"members":{"name":{},"architecture":{},"greengrassGroupId":{},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{"arn":{},"name":{},"createdAt":{"type":"timestamp"},"greengrassGroupId":{},"architecture":{},"tags":{"shape":"S12"}}}},"CreateRobotApplication":{"http":{"requestUri":"/createRobotApplication"},"input":{"type":"structure","required":["name","sources","robotSoftwareSuite"],"members":{"name":{},"sources":{"shape":"S1y"},"robotSoftwareSuite":{"shape":"S20"},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{"arn":{},"name":{},"version":{},"sources":{"shape":"S24"},"robotSoftwareSuite":{"shape":"S20"},"lastUpdatedAt":{"type":"timestamp"},"revisionId":{},"tags":{"shape":"S12"}}}},"CreateRobotApplicationVersion":{"http":{"requestUri":"/createRobotApplicationVersion"},"input":{"type":"structure","required":["application"],"members":{"application":{},"currentRevisionId":{}}},"output":{"type":"structure","members":{"arn":{},"name":{},"version":{},"sources":{"shape":"S24"},"robotSoftwareSuite":{"shape":"S20"},"lastUpdatedAt":{"type":"timestamp"},"revisionId":{}}}},"CreateSimulationApplication":{"http":{"requestUri":"/createSimulationApplication"},"input":{"type":"structure","required":["name","sources","simulationSoftwareSuite","robotSoftwareSuite"],"members":{"name":{},"sources":{"shape":"S1y"},"simulationSoftwareSuite":{"shape":"S2a"},"robotSoftwareSuite":{"shape":"S20"},"renderingEngine":{"shape":"S2d"},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{"arn":{},"name":{},"version":{},"sources":{"shape":"S24"},"simulationSoftwareSuite":{"shape":"S2a"},"robotSoftwareSuite":{"shape":"S20"},"renderingEngine":{"shape":"S2d"},"lastUpdatedAt":{"type":"timestamp"},"revisionId":{},"tags":{"shape":"S12"}}}},"CreateSimulationApplicationVersion":{"http":{"requestUri":"/createSimulationApplicationVersion"},"input":{"type":"structure","required":["application"],"members":{"application":{},"currentRevisionId":{}}},"output":{"type":"structure","members":{"arn":{},"name":{},"version":{},"sources":{"shape":"S24"},"simulationSoftwareSuite":{"shape":"S2a"},"robotSoftwareSuite":{"shape":"S20"},"renderingEngine":{"shape":"S2d"},"lastUpdatedAt":{"type":"timestamp"},"revisionId":{}}}},"CreateSimulationJob":{"http":{"requestUri":"/createSimulationJob"},"input":{"type":"structure","required":["maxJobDurationInSeconds","iamRole"],"members":{"clientRequestToken":{"idempotencyToken":true},"outputLocation":{"shape":"Sf"},"loggingConfig":{"shape":"Si"},"maxJobDurationInSeconds":{"type":"long"},"iamRole":{},"failureBehavior":{},"robotApplications":{"shape":"Sn"},"simulationApplications":{"shape":"Sv"},"dataSources":{"type":"list","member":{"type":"structure","required":["name","s3Bucket","s3Keys"],"members":{"name":{},"s3Bucket":{},"s3Keys":{"type":"list","member":{}}}}},"tags":{"shape":"S12"},"vpcConfig":{"type":"structure","required":["subnets"],"members":{"subnets":{"shape":"S16"},"securityGroups":{"shape":"S18"},"assignPublicIp":{"type":"boolean"}}}}},"output":{"type":"structure","members":{"arn":{},"status":{},"lastStartedAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"failureBehavior":{},"failureCode":{},"clientRequestToken":{},"outputLocation":{"shape":"Sf"},"loggingConfig":{"shape":"Si"},"maxJobDurationInSeconds":{"type":"long"},"simulationTimeMillis":{"type":"long"},"iamRole":{},"robotApplications":{"shape":"Sn"},"simulationApplications":{"shape":"Sv"},"dataSources":{"shape":"Sx"},"tags":{"shape":"S12"},"vpcConfig":{"shape":"S15"}}}},"DeleteFleet":{"http":{"requestUri":"/deleteFleet"},"input":{"type":"structure","required":["fleet"],"members":{"fleet":{}}},"output":{"type":"structure","members":{}}},"DeleteRobot":{"http":{"requestUri":"/deleteRobot"},"input":{"type":"structure","required":["robot"],"members":{"robot":{}}},"output":{"type":"structure","members":{}}},"DeleteRobotApplication":{"http":{"requestUri":"/deleteRobotApplication"},"input":{"type":"structure","required":["application"],"members":{"application":{},"applicationVersion":{}}},"output":{"type":"structure","members":{}}},"DeleteSimulationApplication":{"http":{"requestUri":"/deleteSimulationApplication"},"input":{"type":"structure","required":["application"],"members":{"application":{},"applicationVersion":{}}},"output":{"type":"structure","members":{}}},"DeregisterRobot":{"http":{"requestUri":"/deregisterRobot"},"input":{"type":"structure","required":["fleet","robot"],"members":{"fleet":{},"robot":{}}},"output":{"type":"structure","members":{"fleet":{},"robot":{}}}},"DescribeDeploymentJob":{"http":{"requestUri":"/describeDeploymentJob"},"input":{"type":"structure","required":["job"],"members":{"job":{}}},"output":{"type":"structure","members":{"arn":{},"fleet":{},"status":{},"deploymentConfig":{"shape":"S1f"},"deploymentApplicationConfigs":{"shape":"S1i"},"failureReason":{},"failureCode":{},"createdAt":{"type":"timestamp"},"robotDeploymentSummary":{"type":"list","member":{"type":"structure","members":{"arn":{},"deploymentStartTime":{"type":"timestamp"},"deploymentFinishTime":{"type":"timestamp"},"status":{},"progressDetail":{"type":"structure","members":{"currentProgress":{},"percentDone":{"type":"float"},"estimatedTimeRemainingSeconds":{"type":"integer"},"targetResource":{}}},"failureReason":{},"failureCode":{}}}},"tags":{"shape":"S12"}}}},"DescribeFleet":{"http":{"requestUri":"/describeFleet"},"input":{"type":"structure","required":["fleet"],"members":{"fleet":{}}},"output":{"type":"structure","members":{"name":{},"arn":{},"robots":{"shape":"S3a"},"createdAt":{"type":"timestamp"},"lastDeploymentStatus":{},"lastDeploymentJob":{},"lastDeploymentTime":{"type":"timestamp"},"tags":{"shape":"S12"}}}},"DescribeRobot":{"http":{"requestUri":"/describeRobot"},"input":{"type":"structure","required":["robot"],"members":{"robot":{}}},"output":{"type":"structure","members":{"arn":{},"name":{},"fleetArn":{},"status":{},"greengrassGroupId":{},"createdAt":{"type":"timestamp"},"architecture":{},"lastDeploymentJob":{},"lastDeploymentTime":{"type":"timestamp"},"tags":{"shape":"S12"}}}},"DescribeRobotApplication":{"http":{"requestUri":"/describeRobotApplication"},"input":{"type":"structure","required":["application"],"members":{"application":{},"applicationVersion":{}}},"output":{"type":"structure","members":{"arn":{},"name":{},"version":{},"sources":{"shape":"S24"},"robotSoftwareSuite":{"shape":"S20"},"revisionId":{},"lastUpdatedAt":{"type":"timestamp"},"tags":{"shape":"S12"}}}},"DescribeSimulationApplication":{"http":{"requestUri":"/describeSimulationApplication"},"input":{"type":"structure","required":["application"],"members":{"application":{},"applicationVersion":{}}},"output":{"type":"structure","members":{"arn":{},"name":{},"version":{},"sources":{"shape":"S24"},"simulationSoftwareSuite":{"shape":"S2a"},"robotSoftwareSuite":{"shape":"S20"},"renderingEngine":{"shape":"S2d"},"revisionId":{},"lastUpdatedAt":{"type":"timestamp"},"tags":{"shape":"S12"}}}},"DescribeSimulationJob":{"http":{"requestUri":"/describeSimulationJob"},"input":{"type":"structure","required":["job"],"members":{"job":{}}},"output":{"type":"structure","members":{"arn":{},"name":{},"status":{},"lastStartedAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"failureBehavior":{},"failureCode":{},"failureReason":{},"clientRequestToken":{},"outputLocation":{"shape":"Sf"},"loggingConfig":{"shape":"Si"},"maxJobDurationInSeconds":{"type":"long"},"simulationTimeMillis":{"type":"long"},"iamRole":{},"robotApplications":{"shape":"Sn"},"simulationApplications":{"shape":"Sv"},"dataSources":{"shape":"Sx"},"tags":{"shape":"S12"},"vpcConfig":{"shape":"S15"}}}},"ListDeploymentJobs":{"http":{"requestUri":"/listDeploymentJobs"},"input":{"type":"structure","members":{"filters":{"shape":"S3l"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"deploymentJobs":{"type":"list","member":{"type":"structure","members":{"arn":{},"fleet":{},"status":{},"deploymentApplicationConfigs":{"shape":"S1i"},"deploymentConfig":{"shape":"S1f"},"failureReason":{},"failureCode":{},"createdAt":{"type":"timestamp"}}}},"nextToken":{}}}},"ListFleets":{"http":{"requestUri":"/listFleets"},"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"},"filters":{"shape":"S3l"}}},"output":{"type":"structure","members":{"fleetDetails":{"type":"list","member":{"type":"structure","members":{"name":{},"arn":{},"createdAt":{"type":"timestamp"},"lastDeploymentStatus":{},"lastDeploymentJob":{},"lastDeploymentTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListRobotApplications":{"http":{"requestUri":"/listRobotApplications"},"input":{"type":"structure","members":{"versionQualifier":{},"nextToken":{},"maxResults":{"type":"integer"},"filters":{"shape":"S3l"}}},"output":{"type":"structure","members":{"robotApplicationSummaries":{"type":"list","member":{"type":"structure","members":{"name":{},"arn":{},"version":{},"lastUpdatedAt":{"type":"timestamp"},"robotSoftwareSuite":{"shape":"S20"}}}},"nextToken":{}}}},"ListRobots":{"http":{"requestUri":"/listRobots"},"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"},"filters":{"shape":"S3l"}}},"output":{"type":"structure","members":{"robots":{"shape":"S3a"},"nextToken":{}}}},"ListSimulationApplications":{"http":{"requestUri":"/listSimulationApplications"},"input":{"type":"structure","members":{"versionQualifier":{},"nextToken":{},"maxResults":{"type":"integer"},"filters":{"shape":"S3l"}}},"output":{"type":"structure","members":{"simulationApplicationSummaries":{"type":"list","member":{"type":"structure","members":{"name":{},"arn":{},"version":{},"lastUpdatedAt":{"type":"timestamp"},"robotSoftwareSuite":{"shape":"S20"},"simulationSoftwareSuite":{"shape":"S2a"}}}},"nextToken":{}}}},"ListSimulationJobs":{"http":{"requestUri":"/listSimulationJobs"},"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"},"filters":{"shape":"S3l"}}},"output":{"type":"structure","required":["simulationJobSummaries"],"members":{"simulationJobSummaries":{"type":"list","member":{"type":"structure","members":{"arn":{},"lastUpdatedAt":{"type":"timestamp"},"name":{},"status":{},"simulationApplicationNames":{"type":"list","member":{}},"robotApplicationNames":{"type":"list","member":{}},"dataSourceNames":{"type":"list","member":{}}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S12"}}}},"RegisterRobot":{"http":{"requestUri":"/registerRobot"},"input":{"type":"structure","required":["fleet","robot"],"members":{"fleet":{},"robot":{}}},"output":{"type":"structure","members":{"fleet":{},"robot":{}}}},"RestartSimulationJob":{"http":{"requestUri":"/restartSimulationJob"},"input":{"type":"structure","required":["job"],"members":{"job":{}}},"output":{"type":"structure","members":{}}},"SyncDeploymentJob":{"http":{"requestUri":"/syncDeploymentJob"},"input":{"type":"structure","required":["clientRequestToken","fleet"],"members":{"clientRequestToken":{"idempotencyToken":true},"fleet":{}}},"output":{"type":"structure","members":{"arn":{},"fleet":{},"status":{},"deploymentConfig":{"shape":"S1f"},"deploymentApplicationConfigs":{"shape":"S1i"},"failureReason":{},"failureCode":{},"createdAt":{"type":"timestamp"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S12"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateRobotApplication":{"http":{"requestUri":"/updateRobotApplication"},"input":{"type":"structure","required":["application","sources","robotSoftwareSuite"],"members":{"application":{},"sources":{"shape":"S1y"},"robotSoftwareSuite":{"shape":"S20"},"currentRevisionId":{}}},"output":{"type":"structure","members":{"arn":{},"name":{},"version":{},"sources":{"shape":"S24"},"robotSoftwareSuite":{"shape":"S20"},"lastUpdatedAt":{"type":"timestamp"},"revisionId":{}}}},"UpdateSimulationApplication":{"http":{"requestUri":"/updateSimulationApplication"},"input":{"type":"structure","required":["application","sources","simulationSoftwareSuite","robotSoftwareSuite"],"members":{"application":{},"sources":{"shape":"S1y"},"simulationSoftwareSuite":{"shape":"S2a"},"robotSoftwareSuite":{"shape":"S20"},"renderingEngine":{"shape":"S2d"},"currentRevisionId":{}}},"output":{"type":"structure","members":{"arn":{},"name":{},"version":{},"sources":{"shape":"S24"},"simulationSoftwareSuite":{"shape":"S2a"},"robotSoftwareSuite":{"shape":"S20"},"renderingEngine":{"shape":"S2d"},"lastUpdatedAt":{"type":"timestamp"},"revisionId":{}}}}},"shapes":{"S2":{"type":"list","member":{}},"Sf":{"type":"structure","members":{"s3Bucket":{},"s3Prefix":{}}},"Si":{"type":"structure","required":["recordAllRosTopics"],"members":{"recordAllRosTopics":{"type":"boolean"}}},"Sn":{"type":"list","member":{"type":"structure","required":["application","launchConfig"],"members":{"application":{},"applicationVersion":{},"launchConfig":{"shape":"Sq"}}}},"Sq":{"type":"structure","required":["packageName","launchFile"],"members":{"packageName":{},"launchFile":{},"environmentVariables":{"shape":"Ss"}}},"Ss":{"type":"map","key":{},"value":{}},"Sv":{"type":"list","member":{"type":"structure","required":["application","launchConfig"],"members":{"application":{},"applicationVersion":{},"launchConfig":{"shape":"Sq"}}}},"Sx":{"type":"list","member":{"type":"structure","members":{"name":{},"s3Bucket":{},"s3Keys":{"type":"list","member":{"type":"structure","members":{"s3Key":{},"etag":{}}}}}}},"S12":{"type":"map","key":{},"value":{}},"S15":{"type":"structure","members":{"subnets":{"shape":"S16"},"securityGroups":{"shape":"S18"},"vpcId":{},"assignPublicIp":{"type":"boolean"}}},"S16":{"type":"list","member":{}},"S18":{"type":"list","member":{}},"S1f":{"type":"structure","members":{"concurrentDeploymentPercentage":{"type":"integer"},"failureThresholdPercentage":{"type":"integer"},"robotDeploymentTimeoutInSeconds":{"type":"long"}}},"S1i":{"type":"list","member":{"type":"structure","required":["application","applicationVersion","launchConfig"],"members":{"application":{},"applicationVersion":{},"launchConfig":{"type":"structure","required":["packageName","launchFile"],"members":{"packageName":{},"preLaunchFile":{},"launchFile":{},"postLaunchFile":{},"environmentVariables":{"shape":"Ss"}}}}}},"S1y":{"type":"list","member":{"type":"structure","members":{"s3Bucket":{},"s3Key":{},"architecture":{}}}},"S20":{"type":"structure","members":{"name":{},"version":{}}},"S24":{"type":"list","member":{"type":"structure","members":{"s3Bucket":{},"s3Key":{},"etag":{},"architecture":{}}}},"S2a":{"type":"structure","members":{"name":{},"version":{}}},"S2d":{"type":"structure","members":{"name":{},"version":{}}},"S3a":{"type":"list","member":{"type":"structure","members":{"arn":{},"name":{},"fleetArn":{},"status":{},"greenGrassGroupId":{},"createdAt":{"type":"timestamp"},"architecture":{},"lastDeploymentJob":{},"lastDeploymentTime":{"type":"timestamp"}}}},"S3l":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"type":"list","member":{}}}}}}}');

});

parcelRequire.register("nVIyd", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListDeploymentJobs":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListFleets":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListRobotApplications":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListRobots":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListSimulationApplications":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListSimulationJobs":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}');

});


parcelRequire.register("35PO7", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $240a069919120910$var$Service = $dbC7k.Service;
var $240a069919120910$var$apiLoader = $dbC7k.apiLoader;
$240a069919120910$var$apiLoader.services["transfer"] = {};
$dbC7k.Transfer = $240a069919120910$var$Service.defineService("transfer", [
    "2018-11-05"
]);


Object.defineProperty($240a069919120910$var$apiLoader.services["transfer"], "2018-11-05", {
    get: function get() {
        var model = (parcelRequire("jStOU"));
        model.paginators = (parcelRequire("3fiWX")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Transfer;

});
parcelRequire.register("jStOU", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-11-05","endpointPrefix":"transfer","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"AWS Transfer","serviceFullName":"AWS Transfer for SFTP","serviceId":"Transfer","signatureVersion":"v4","signingName":"transfer","targetPrefix":"TransferService","uid":"transfer-2018-11-05"},"operations":{"CreateServer":{"input":{"type":"structure","members":{"EndpointDetails":{"shape":"S2"},"EndpointType":{},"HostKey":{"shape":"S5"},"IdentityProviderDetails":{"shape":"S6"},"IdentityProviderType":{},"LoggingRole":{},"Tags":{"shape":"Sa"}}},"output":{"type":"structure","required":["ServerId"],"members":{"ServerId":{}}}},"CreateUser":{"input":{"type":"structure","required":["Role","ServerId","UserName"],"members":{"HomeDirectory":{},"Policy":{},"Role":{},"ServerId":{},"SshPublicKeyBody":{},"Tags":{"shape":"Sa"},"UserName":{}}},"output":{"type":"structure","required":["ServerId","UserName"],"members":{"ServerId":{},"UserName":{}}}},"DeleteServer":{"input":{"type":"structure","required":["ServerId"],"members":{"ServerId":{}}}},"DeleteSshPublicKey":{"input":{"type":"structure","required":["ServerId","SshPublicKeyId","UserName"],"members":{"ServerId":{},"SshPublicKeyId":{},"UserName":{}}}},"DeleteUser":{"input":{"type":"structure","required":["ServerId","UserName"],"members":{"ServerId":{},"UserName":{}}}},"DescribeServer":{"input":{"type":"structure","required":["ServerId"],"members":{"ServerId":{}}},"output":{"type":"structure","required":["Server"],"members":{"Server":{"type":"structure","required":["Arn"],"members":{"Arn":{},"EndpointDetails":{"shape":"S2"},"EndpointType":{},"HostKeyFingerprint":{},"IdentityProviderDetails":{"shape":"S6"},"IdentityProviderType":{},"LoggingRole":{},"ServerId":{},"State":{},"Tags":{"shape":"Sa"},"UserCount":{"type":"integer"}}}}}},"DescribeUser":{"input":{"type":"structure","required":["ServerId","UserName"],"members":{"ServerId":{},"UserName":{}}},"output":{"type":"structure","required":["ServerId","User"],"members":{"ServerId":{},"User":{"type":"structure","required":["Arn"],"members":{"Arn":{},"HomeDirectory":{},"Policy":{},"Role":{},"SshPublicKeys":{"type":"list","member":{"type":"structure","required":["DateImported","SshPublicKeyBody","SshPublicKeyId"],"members":{"DateImported":{"type":"timestamp"},"SshPublicKeyBody":{},"SshPublicKeyId":{}}}},"Tags":{"shape":"Sa"},"UserName":{}}}}}},"ImportSshPublicKey":{"input":{"type":"structure","required":["ServerId","SshPublicKeyBody","UserName"],"members":{"ServerId":{},"SshPublicKeyBody":{},"UserName":{}}},"output":{"type":"structure","required":["ServerId","SshPublicKeyId","UserName"],"members":{"ServerId":{},"SshPublicKeyId":{},"UserName":{}}}},"ListServers":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Servers"],"members":{"NextToken":{},"Servers":{"type":"list","member":{"type":"structure","required":["Arn"],"members":{"Arn":{},"IdentityProviderType":{},"EndpointType":{},"LoggingRole":{},"ServerId":{},"State":{},"UserCount":{"type":"integer"}}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["Arn"],"members":{"Arn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Arn":{},"NextToken":{},"Tags":{"shape":"Sa"}}}},"ListUsers":{"input":{"type":"structure","required":["ServerId"],"members":{"MaxResults":{"type":"integer"},"NextToken":{},"ServerId":{}}},"output":{"type":"structure","required":["ServerId","Users"],"members":{"NextToken":{},"ServerId":{},"Users":{"type":"list","member":{"type":"structure","required":["Arn"],"members":{"Arn":{},"HomeDirectory":{},"Role":{},"SshPublicKeyCount":{"type":"integer"},"UserName":{}}}}}}},"StartServer":{"input":{"type":"structure","required":["ServerId"],"members":{"ServerId":{}}}},"StopServer":{"input":{"type":"structure","required":["ServerId"],"members":{"ServerId":{}}}},"TagResource":{"input":{"type":"structure","required":["Arn","Tags"],"members":{"Arn":{},"Tags":{"shape":"Sa"}}}},"TestIdentityProvider":{"input":{"type":"structure","required":["ServerId","UserName"],"members":{"ServerId":{},"UserName":{},"UserPassword":{"type":"string","sensitive":true}}},"output":{"type":"structure","required":["StatusCode","Url"],"members":{"Response":{},"StatusCode":{"type":"integer"},"Message":{},"Url":{}}}},"UntagResource":{"input":{"type":"structure","required":["Arn","TagKeys"],"members":{"Arn":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateServer":{"input":{"type":"structure","required":["ServerId"],"members":{"EndpointDetails":{"shape":"S2"},"EndpointType":{},"HostKey":{"shape":"S5"},"IdentityProviderDetails":{"shape":"S6"},"LoggingRole":{},"ServerId":{}}},"output":{"type":"structure","required":["ServerId"],"members":{"ServerId":{}}}},"UpdateUser":{"input":{"type":"structure","required":["ServerId","UserName"],"members":{"HomeDirectory":{},"Policy":{},"Role":{},"ServerId":{},"UserName":{}}},"output":{"type":"structure","required":["ServerId","UserName"],"members":{"ServerId":{},"UserName":{}}}}},"shapes":{"S2":{"type":"structure","members":{"VpcEndpointId":{}}},"S5":{"type":"string","sensitive":true},"S6":{"type":"structure","members":{"Url":{},"InvocationRole":{}}},"Sa":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}}}}');

});

parcelRequire.register("3fiWX", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListServers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTagsForResource":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListUsers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("iXtd0", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $dcd464f1d11fb624$var$Service = $dbC7k.Service;
var $dcd464f1d11fb624$var$apiLoader = $dbC7k.apiLoader;
$dcd464f1d11fb624$var$apiLoader.services["globalaccelerator"] = {};
$dbC7k.GlobalAccelerator = $dcd464f1d11fb624$var$Service.defineService("globalaccelerator", [
    "2018-08-08"
]);


Object.defineProperty($dcd464f1d11fb624$var$apiLoader.services["globalaccelerator"], "2018-08-08", {
    get: function get() {
        var model = (parcelRequire("joJV8"));
        model.paginators = (parcelRequire("9FwHh")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.GlobalAccelerator;

});
parcelRequire.register("joJV8", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-08-08","endpointPrefix":"globalaccelerator","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Global Accelerator","serviceId":"Global Accelerator","signatureVersion":"v4","signingName":"globalaccelerator","targetPrefix":"GlobalAccelerator_V20180706","uid":"globalaccelerator-2018-08-08"},"operations":{"CreateAccelerator":{"input":{"type":"structure","required":["Name","IdempotencyToken"],"members":{"Name":{},"IpAddressType":{},"Enabled":{"type":"boolean"},"IdempotencyToken":{}}},"output":{"type":"structure","members":{"Accelerator":{"shape":"S7"}}}},"CreateEndpointGroup":{"input":{"type":"structure","required":["ListenerArn","EndpointGroupRegion","IdempotencyToken"],"members":{"ListenerArn":{},"EndpointGroupRegion":{},"EndpointConfigurations":{"shape":"Sf"},"TrafficDialPercentage":{"type":"float"},"HealthCheckPort":{"type":"integer"},"HealthCheckProtocol":{},"HealthCheckPath":{},"HealthCheckIntervalSeconds":{"type":"integer"},"ThresholdCount":{"type":"integer"},"IdempotencyToken":{}}},"output":{"type":"structure","members":{"EndpointGroup":{"shape":"So"}}}},"CreateListener":{"input":{"type":"structure","required":["AcceleratorArn","PortRanges","Protocol","IdempotencyToken"],"members":{"AcceleratorArn":{},"PortRanges":{"shape":"St"},"Protocol":{},"ClientAffinity":{},"IdempotencyToken":{}}},"output":{"type":"structure","members":{"Listener":{"shape":"Sz"}}}},"DeleteAccelerator":{"input":{"type":"structure","required":["AcceleratorArn"],"members":{"AcceleratorArn":{}}}},"DeleteEndpointGroup":{"input":{"type":"structure","required":["EndpointGroupArn"],"members":{"EndpointGroupArn":{}}}},"DeleteListener":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{}}}},"DescribeAccelerator":{"input":{"type":"structure","required":["AcceleratorArn"],"members":{"AcceleratorArn":{}}},"output":{"type":"structure","members":{"Accelerator":{"shape":"S7"}}}},"DescribeAcceleratorAttributes":{"input":{"type":"structure","members":{"AcceleratorArn":{}}},"output":{"type":"structure","members":{"AcceleratorAttributes":{"shape":"S17"}}}},"DescribeEndpointGroup":{"input":{"type":"structure","required":["EndpointGroupArn"],"members":{"EndpointGroupArn":{}}},"output":{"type":"structure","members":{"EndpointGroup":{"shape":"So"}}}},"DescribeListener":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{}}},"output":{"type":"structure","members":{"Listener":{"shape":"Sz"}}}},"ListAccelerators":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Accelerators":{"type":"list","member":{"shape":"S7"}},"NextToken":{}}}},"ListEndpointGroups":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"EndpointGroups":{"type":"list","member":{"shape":"So"}},"NextToken":{}}}},"ListListeners":{"input":{"type":"structure","required":["AcceleratorArn"],"members":{"AcceleratorArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Listeners":{"type":"list","member":{"shape":"Sz"}},"NextToken":{}}}},"UpdateAccelerator":{"input":{"type":"structure","required":["AcceleratorArn"],"members":{"AcceleratorArn":{},"Name":{},"IpAddressType":{},"Enabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"Accelerator":{"shape":"S7"}}}},"UpdateAcceleratorAttributes":{"input":{"type":"structure","members":{"AcceleratorArn":{},"FlowLogsEnabled":{"type":"boolean"},"FlowLogsS3Bucket":{},"FlowLogsS3Prefix":{}}},"output":{"type":"structure","members":{"AcceleratorAttributes":{"shape":"S17"}}}},"UpdateEndpointGroup":{"input":{"type":"structure","required":["EndpointGroupArn"],"members":{"EndpointGroupArn":{},"EndpointConfigurations":{"shape":"Sf"},"TrafficDialPercentage":{"type":"float"},"HealthCheckPort":{"type":"integer"},"HealthCheckProtocol":{},"HealthCheckPath":{},"HealthCheckIntervalSeconds":{"type":"integer"},"ThresholdCount":{"type":"integer"}}},"output":{"type":"structure","members":{"EndpointGroup":{"shape":"So"}}}},"UpdateListener":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{},"PortRanges":{"shape":"St"},"Protocol":{},"ClientAffinity":{}}},"output":{"type":"structure","members":{"Listener":{"shape":"Sz"}}}}},"shapes":{"S7":{"type":"structure","members":{"AcceleratorArn":{},"Name":{},"IpAddressType":{},"Enabled":{"type":"boolean"},"IpSets":{"type":"list","member":{"type":"structure","members":{"IpFamily":{},"IpAddresses":{"type":"list","member":{}}}}},"Status":{},"CreatedTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}},"Sf":{"type":"list","member":{"type":"structure","members":{"EndpointId":{},"Weight":{"type":"integer"}}}},"So":{"type":"structure","members":{"EndpointGroupArn":{},"EndpointGroupRegion":{},"EndpointDescriptions":{"type":"list","member":{"type":"structure","members":{"EndpointId":{},"Weight":{"type":"integer"},"HealthState":{},"HealthReason":{}}}},"TrafficDialPercentage":{"type":"float"},"HealthCheckPort":{"type":"integer"},"HealthCheckProtocol":{},"HealthCheckPath":{},"HealthCheckIntervalSeconds":{"type":"integer"},"ThresholdCount":{"type":"integer"}}},"St":{"type":"list","member":{"type":"structure","members":{"FromPort":{"type":"integer"},"ToPort":{"type":"integer"}}}},"Sz":{"type":"structure","members":{"ListenerArn":{},"PortRanges":{"shape":"St"},"Protocol":{},"ClientAffinity":{}}},"S17":{"type":"structure","members":{"FlowLogsEnabled":{"type":"boolean"},"FlowLogsS3Bucket":{},"FlowLogsS3Prefix":{}}}}}');

});

parcelRequire.register("9FwHh", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("eBfVx", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $aa10e02649716963$var$Service = $dbC7k.Service;
var $aa10e02649716963$var$apiLoader = $dbC7k.apiLoader;
$aa10e02649716963$var$apiLoader.services["comprehendmedical"] = {};
$dbC7k.ComprehendMedical = $aa10e02649716963$var$Service.defineService("comprehendmedical", [
    "2018-10-30"
]);


Object.defineProperty($aa10e02649716963$var$apiLoader.services["comprehendmedical"], "2018-10-30", {
    get: function get() {
        var model = (parcelRequire("7DXYg"));
        model.paginators = (parcelRequire("aHlCY")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ComprehendMedical;

});
parcelRequire.register("7DXYg", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-10-30","endpointPrefix":"comprehendmedical","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"ComprehendMedical","serviceFullName":"AWS Comprehend Medical","serviceId":"ComprehendMedical","signatureVersion":"v4","signingName":"comprehendmedical","targetPrefix":"ComprehendMedical_20181030","uid":"comprehendmedical-2018-10-30"},"operations":{"DetectEntities":{"input":{"type":"structure","required":["Text"],"members":{"Text":{}}},"output":{"type":"structure","required":["Entities"],"members":{"Entities":{"shape":"S4"},"UnmappedAttributes":{"type":"list","member":{"type":"structure","members":{"Type":{},"Attribute":{"shape":"Sf"}}}},"PaginationToken":{}}}},"DetectPHI":{"input":{"type":"structure","required":["Text"],"members":{"Text":{}}},"output":{"type":"structure","required":["Entities"],"members":{"Entities":{"shape":"S4"},"PaginationToken":{}}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","members":{"Id":{"type":"integer"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Score":{"type":"float"},"Text":{},"Category":{},"Type":{},"Traits":{"shape":"Sb"},"Attributes":{"type":"list","member":{"shape":"Sf"}}}}},"Sb":{"type":"list","member":{"type":"structure","members":{"Name":{},"Score":{"type":"float"}}}},"Sf":{"type":"structure","members":{"Type":{},"Score":{"type":"float"},"RelationshipScore":{"type":"float"},"Id":{"type":"integer"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Text":{},"Traits":{"shape":"Sb"}}}}}');

});

parcelRequire.register("aHlCY", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("cpzJU", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $90938af0899b3146$var$Service = $dbC7k.Service;
var $90938af0899b3146$var$apiLoader = $dbC7k.apiLoader;
$90938af0899b3146$var$apiLoader.services["kinesisanalyticsv2"] = {};
$dbC7k.KinesisAnalyticsV2 = $90938af0899b3146$var$Service.defineService("kinesisanalyticsv2", [
    "2018-05-23"
]);


Object.defineProperty($90938af0899b3146$var$apiLoader.services["kinesisanalyticsv2"], "2018-05-23", {
    get: function get() {
        var model = (parcelRequire("ezNhI"));
        model.paginators = (parcelRequire("aVSZV")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.KinesisAnalyticsV2;

});
parcelRequire.register("ezNhI", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-05-23","endpointPrefix":"kinesisanalytics","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Kinesis Analytics V2","serviceFullName":"Amazon Kinesis Analytics","serviceId":"Kinesis Analytics V2","signatureVersion":"v4","signingName":"kinesisanalytics","targetPrefix":"KinesisAnalytics_20180523","uid":"kinesisanalyticsv2-2018-05-23"},"operations":{"AddApplicationCloudWatchLoggingOption":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","CloudWatchLoggingOption"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"CloudWatchLoggingOption":{"shape":"S4"}}},"output":{"type":"structure","members":{"ApplicationARN":{},"ApplicationVersionId":{"type":"long"},"CloudWatchLoggingOptionDescriptions":{"shape":"S8"}}}},"AddApplicationInput":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","Input"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"Input":{"shape":"Sd"}}},"output":{"type":"structure","members":{"ApplicationARN":{},"ApplicationVersionId":{"type":"long"},"InputDescriptions":{"shape":"S11"}}}},"AddApplicationInputProcessingConfiguration":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","InputId","InputProcessingConfiguration"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"InputId":{},"InputProcessingConfiguration":{"shape":"Sf"}}},"output":{"type":"structure","members":{"ApplicationARN":{},"ApplicationVersionId":{"type":"long"},"InputId":{},"InputProcessingConfigurationDescription":{"shape":"S14"}}}},"AddApplicationOutput":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","Output"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"Output":{"shape":"S1d"}}},"output":{"type":"structure","members":{"ApplicationARN":{},"ApplicationVersionId":{"type":"long"},"OutputDescriptions":{"shape":"S1j"}}}},"AddApplicationReferenceDataSource":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","ReferenceDataSource"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"ReferenceDataSource":{"shape":"S1p"}}},"output":{"type":"structure","members":{"ApplicationARN":{},"ApplicationVersionId":{"type":"long"},"ReferenceDataSourceDescriptions":{"shape":"S1v"}}}},"CreateApplication":{"input":{"type":"structure","required":["ApplicationName","RuntimeEnvironment","ServiceExecutionRole"],"members":{"ApplicationName":{},"ApplicationDescription":{},"RuntimeEnvironment":{},"ServiceExecutionRole":{},"ApplicationConfiguration":{"type":"structure","required":["ApplicationCodeConfiguration"],"members":{"SqlApplicationConfiguration":{"type":"structure","members":{"Inputs":{"type":"list","member":{"shape":"Sd"}},"Outputs":{"type":"list","member":{"shape":"S1d"}},"ReferenceDataSources":{"type":"list","member":{"shape":"S1p"}}}},"FlinkApplicationConfiguration":{"type":"structure","members":{"CheckpointConfiguration":{"type":"structure","required":["ConfigurationType"],"members":{"ConfigurationType":{},"CheckpointingEnabled":{"type":"boolean"},"CheckpointInterval":{"type":"long"},"MinPauseBetweenCheckpoints":{"type":"long"}}},"MonitoringConfiguration":{"type":"structure","required":["ConfigurationType"],"members":{"ConfigurationType":{},"MetricsLevel":{},"LogLevel":{}}},"ParallelismConfiguration":{"type":"structure","required":["ConfigurationType"],"members":{"ConfigurationType":{},"Parallelism":{"type":"integer"},"ParallelismPerKPU":{"type":"integer"},"AutoScalingEnabled":{"type":"boolean"}}}}},"EnvironmentProperties":{"type":"structure","required":["PropertyGroups"],"members":{"PropertyGroups":{"shape":"S2j"}}},"ApplicationCodeConfiguration":{"type":"structure","required":["CodeContentType"],"members":{"CodeContent":{"type":"structure","members":{"TextContent":{},"ZipFileContent":{"type":"blob"},"S3ContentLocation":{"type":"structure","required":["BucketARN","FileKey"],"members":{"BucketARN":{},"FileKey":{},"ObjectVersion":{}}}}},"CodeContentType":{}}},"ApplicationSnapshotConfiguration":{"type":"structure","required":["SnapshotsEnabled"],"members":{"SnapshotsEnabled":{"type":"boolean"}}}}},"CloudWatchLoggingOptions":{"type":"list","member":{"shape":"S4"}},"Tags":{"shape":"S2x"}}},"output":{"type":"structure","required":["ApplicationDetail"],"members":{"ApplicationDetail":{"shape":"S32"}}}},"CreateApplicationSnapshot":{"input":{"type":"structure","required":["ApplicationName","SnapshotName"],"members":{"ApplicationName":{},"SnapshotName":{}}},"output":{"type":"structure","members":{}}},"DeleteApplication":{"input":{"type":"structure","required":["ApplicationName","CreateTimestamp"],"members":{"ApplicationName":{},"CreateTimestamp":{"type":"timestamp"}}},"output":{"type":"structure","members":{}}},"DeleteApplicationCloudWatchLoggingOption":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","CloudWatchLoggingOptionId"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"CloudWatchLoggingOptionId":{}}},"output":{"type":"structure","members":{"ApplicationARN":{},"ApplicationVersionId":{"type":"long"},"CloudWatchLoggingOptionDescriptions":{"shape":"S8"}}}},"DeleteApplicationInputProcessingConfiguration":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","InputId"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"InputId":{}}},"output":{"type":"structure","members":{"ApplicationARN":{},"ApplicationVersionId":{"type":"long"}}}},"DeleteApplicationOutput":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","OutputId"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"OutputId":{}}},"output":{"type":"structure","members":{"ApplicationARN":{},"ApplicationVersionId":{"type":"long"}}}},"DeleteApplicationReferenceDataSource":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId","ReferenceId"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"ReferenceId":{}}},"output":{"type":"structure","members":{"ApplicationARN":{},"ApplicationVersionId":{"type":"long"}}}},"DeleteApplicationSnapshot":{"input":{"type":"structure","required":["ApplicationName","SnapshotName","SnapshotCreationTimestamp"],"members":{"ApplicationName":{},"SnapshotName":{},"SnapshotCreationTimestamp":{"type":"timestamp"}}},"output":{"type":"structure","members":{}}},"DescribeApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"IncludeAdditionalDetails":{"type":"boolean"}}},"output":{"type":"structure","required":["ApplicationDetail"],"members":{"ApplicationDetail":{"shape":"S32"}}}},"DescribeApplicationSnapshot":{"input":{"type":"structure","required":["ApplicationName","SnapshotName"],"members":{"ApplicationName":{},"SnapshotName":{}}},"output":{"type":"structure","required":["SnapshotDetails"],"members":{"SnapshotDetails":{"shape":"S45"}}}},"DiscoverInputSchema":{"input":{"type":"structure","required":["ServiceExecutionRole"],"members":{"ResourceARN":{},"ServiceExecutionRole":{},"InputStartingPositionConfiguration":{"shape":"S18"},"S3Configuration":{"type":"structure","required":["BucketARN","FileKey"],"members":{"BucketARN":{},"FileKey":{}}},"InputProcessingConfiguration":{"shape":"Sf"}}},"output":{"type":"structure","members":{"InputSchema":{"shape":"Sl"},"ParsedInputRecords":{"type":"list","member":{"type":"list","member":{}}},"ProcessedInputRecords":{"type":"list","member":{}},"RawInputRecords":{"type":"list","member":{}}}}},"ListApplicationSnapshots":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"SnapshotSummaries":{"type":"list","member":{"shape":"S45"}},"NextToken":{}}}},"ListApplications":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ApplicationSummaries"],"members":{"ApplicationSummaries":{"type":"list","member":{"type":"structure","required":["ApplicationName","ApplicationARN","ApplicationStatus","ApplicationVersionId","RuntimeEnvironment"],"members":{"ApplicationName":{},"ApplicationARN":{},"ApplicationStatus":{},"ApplicationVersionId":{"type":"long"},"RuntimeEnvironment":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S2x"}}}},"StartApplication":{"input":{"type":"structure","required":["ApplicationName","RunConfiguration"],"members":{"ApplicationName":{},"RunConfiguration":{"type":"structure","members":{"SqlRunConfigurations":{"type":"list","member":{"type":"structure","required":["InputId","InputStartingPositionConfiguration"],"members":{"InputId":{},"InputStartingPositionConfiguration":{"shape":"S18"}}}},"ApplicationRestoreConfiguration":{"shape":"S3d"}}}}},"output":{"type":"structure","members":{}}},"StopApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S2x"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateApplication":{"input":{"type":"structure","required":["ApplicationName","CurrentApplicationVersionId"],"members":{"ApplicationName":{},"CurrentApplicationVersionId":{"type":"long"},"ApplicationConfigurationUpdate":{"type":"structure","members":{"SqlApplicationConfigurationUpdate":{"type":"structure","members":{"InputUpdates":{"type":"list","member":{"type":"structure","required":["InputId"],"members":{"InputId":{},"NamePrefixUpdate":{},"InputProcessingConfigurationUpdate":{"type":"structure","required":["InputLambdaProcessorUpdate"],"members":{"InputLambdaProcessorUpdate":{"type":"structure","required":["ResourceARNUpdate"],"members":{"ResourceARNUpdate":{}}}}},"KinesisStreamsInputUpdate":{"type":"structure","required":["ResourceARNUpdate"],"members":{"ResourceARNUpdate":{}}},"KinesisFirehoseInputUpdate":{"type":"structure","required":["ResourceARNUpdate"],"members":{"ResourceARNUpdate":{}}},"InputSchemaUpdate":{"type":"structure","members":{"RecordFormatUpdate":{"shape":"Sm"},"RecordEncodingUpdate":{},"RecordColumnUpdates":{"shape":"Sv"}}},"InputParallelismUpdate":{"type":"structure","required":["CountUpdate"],"members":{"CountUpdate":{"type":"integer"}}}}}},"OutputUpdates":{"type":"list","member":{"type":"structure","required":["OutputId"],"members":{"OutputId":{},"NameUpdate":{},"KinesisStreamsOutputUpdate":{"type":"structure","required":["ResourceARNUpdate"],"members":{"ResourceARNUpdate":{}}},"KinesisFirehoseOutputUpdate":{"type":"structure","required":["ResourceARNUpdate"],"members":{"ResourceARNUpdate":{}}},"LambdaOutputUpdate":{"type":"structure","required":["ResourceARNUpdate"],"members":{"ResourceARNUpdate":{}}},"DestinationSchemaUpdate":{"shape":"S1h"}}}},"ReferenceDataSourceUpdates":{"type":"list","member":{"type":"structure","required":["ReferenceId"],"members":{"ReferenceId":{},"TableNameUpdate":{},"S3ReferenceDataSourceUpdate":{"type":"structure","members":{"BucketARNUpdate":{},"FileKeyUpdate":{}}},"ReferenceSchemaUpdate":{"shape":"Sl"}}}}}},"ApplicationCodeConfigurationUpdate":{"type":"structure","members":{"CodeContentTypeUpdate":{},"CodeContentUpdate":{"type":"structure","members":{"TextContentUpdate":{},"ZipFileContentUpdate":{"type":"blob"},"S3ContentLocationUpdate":{"type":"structure","members":{"BucketARNUpdate":{},"FileKeyUpdate":{},"ObjectVersionUpdate":{}}}}}}},"FlinkApplicationConfigurationUpdate":{"type":"structure","members":{"CheckpointConfigurationUpdate":{"type":"structure","members":{"ConfigurationTypeUpdate":{},"CheckpointingEnabledUpdate":{"type":"boolean"},"CheckpointIntervalUpdate":{"type":"long"},"MinPauseBetweenCheckpointsUpdate":{"type":"long"}}},"MonitoringConfigurationUpdate":{"type":"structure","members":{"ConfigurationTypeUpdate":{},"MetricsLevelUpdate":{},"LogLevelUpdate":{}}},"ParallelismConfigurationUpdate":{"type":"structure","members":{"ConfigurationTypeUpdate":{},"ParallelismUpdate":{"type":"integer"},"ParallelismPerKPUUpdate":{"type":"integer"},"AutoScalingEnabledUpdate":{"type":"boolean"}}}}},"EnvironmentPropertyUpdates":{"type":"structure","required":["PropertyGroups"],"members":{"PropertyGroups":{"shape":"S2j"}}},"ApplicationSnapshotConfigurationUpdate":{"type":"structure","required":["SnapshotsEnabledUpdate"],"members":{"SnapshotsEnabledUpdate":{"type":"boolean"}}}}},"ServiceExecutionRoleUpdate":{},"RunConfigurationUpdate":{"type":"structure","members":{"ApplicationRestoreConfiguration":{"shape":"S3d"}}},"CloudWatchLoggingOptionUpdates":{"type":"list","member":{"type":"structure","required":["CloudWatchLoggingOptionId"],"members":{"CloudWatchLoggingOptionId":{},"LogStreamARNUpdate":{}}}}}},"output":{"type":"structure","required":["ApplicationDetail"],"members":{"ApplicationDetail":{"shape":"S32"}}}}},"shapes":{"S4":{"type":"structure","required":["LogStreamARN"],"members":{"LogStreamARN":{}}},"S8":{"type":"list","member":{"type":"structure","required":["LogStreamARN"],"members":{"CloudWatchLoggingOptionId":{},"LogStreamARN":{},"RoleARN":{}}}},"Sd":{"type":"structure","required":["NamePrefix","InputSchema"],"members":{"NamePrefix":{},"InputProcessingConfiguration":{"shape":"Sf"},"KinesisStreamsInput":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"KinesisFirehoseInput":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"InputParallelism":{"shape":"Sj"},"InputSchema":{"shape":"Sl"}}},"Sf":{"type":"structure","required":["InputLambdaProcessor"],"members":{"InputLambdaProcessor":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}}}},"Sj":{"type":"structure","members":{"Count":{"type":"integer"}}},"Sl":{"type":"structure","required":["RecordFormat","RecordColumns"],"members":{"RecordFormat":{"shape":"Sm"},"RecordEncoding":{},"RecordColumns":{"shape":"Sv"}}},"Sm":{"type":"structure","required":["RecordFormatType"],"members":{"RecordFormatType":{},"MappingParameters":{"type":"structure","members":{"JSONMappingParameters":{"type":"structure","required":["RecordRowPath"],"members":{"RecordRowPath":{}}},"CSVMappingParameters":{"type":"structure","required":["RecordRowDelimiter","RecordColumnDelimiter"],"members":{"RecordRowDelimiter":{},"RecordColumnDelimiter":{}}}}}}},"Sv":{"type":"list","member":{"type":"structure","required":["Name","SqlType"],"members":{"Name":{},"Mapping":{},"SqlType":{}}}},"S11":{"type":"list","member":{"type":"structure","members":{"InputId":{},"NamePrefix":{},"InAppStreamNames":{"type":"list","member":{}},"InputProcessingConfigurationDescription":{"shape":"S14"},"KinesisStreamsInputDescription":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"RoleARN":{}}},"KinesisFirehoseInputDescription":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"RoleARN":{}}},"InputSchema":{"shape":"Sl"},"InputParallelism":{"shape":"Sj"},"InputStartingPositionConfiguration":{"shape":"S18"}}}},"S14":{"type":"structure","members":{"InputLambdaProcessorDescription":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"RoleARN":{}}}}},"S18":{"type":"structure","members":{"InputStartingPosition":{}}},"S1d":{"type":"structure","required":["Name","DestinationSchema"],"members":{"Name":{},"KinesisStreamsOutput":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"KinesisFirehoseOutput":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"LambdaOutput":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"DestinationSchema":{"shape":"S1h"}}},"S1h":{"type":"structure","required":["RecordFormatType"],"members":{"RecordFormatType":{}}},"S1j":{"type":"list","member":{"type":"structure","members":{"OutputId":{},"Name":{},"KinesisStreamsOutputDescription":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"RoleARN":{}}},"KinesisFirehoseOutputDescription":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"RoleARN":{}}},"LambdaOutputDescription":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"RoleARN":{}}},"DestinationSchema":{"shape":"S1h"}}}},"S1p":{"type":"structure","required":["TableName","ReferenceSchema"],"members":{"TableName":{},"S3ReferenceDataSource":{"type":"structure","members":{"BucketARN":{},"FileKey":{}}},"ReferenceSchema":{"shape":"Sl"}}},"S1v":{"type":"list","member":{"type":"structure","required":["ReferenceId","TableName","S3ReferenceDataSourceDescription"],"members":{"ReferenceId":{},"TableName":{},"S3ReferenceDataSourceDescription":{"type":"structure","required":["BucketARN","FileKey"],"members":{"BucketARN":{},"FileKey":{},"ReferenceRoleARN":{}}},"ReferenceSchema":{"shape":"Sl"}}}},"S2j":{"type":"list","member":{"type":"structure","required":["PropertyGroupId","PropertyMap"],"members":{"PropertyGroupId":{},"PropertyMap":{"type":"map","key":{},"value":{}}}}},"S2x":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"S32":{"type":"structure","required":["ApplicationARN","ApplicationName","RuntimeEnvironment","ApplicationStatus","ApplicationVersionId"],"members":{"ApplicationARN":{},"ApplicationDescription":{},"ApplicationName":{},"RuntimeEnvironment":{},"ServiceExecutionRole":{},"ApplicationStatus":{},"ApplicationVersionId":{"type":"long"},"CreateTimestamp":{"type":"timestamp"},"LastUpdateTimestamp":{"type":"timestamp"},"ApplicationConfigurationDescription":{"type":"structure","members":{"SqlApplicationConfigurationDescription":{"type":"structure","members":{"InputDescriptions":{"shape":"S11"},"OutputDescriptions":{"shape":"S1j"},"ReferenceDataSourceDescriptions":{"shape":"S1v"}}},"ApplicationCodeConfigurationDescription":{"type":"structure","required":["CodeContentType"],"members":{"CodeContentType":{},"CodeContentDescription":{"type":"structure","members":{"TextContent":{},"CodeMD5":{},"CodeSize":{"type":"long"},"S3ApplicationCodeLocationDescription":{"type":"structure","required":["BucketARN","FileKey"],"members":{"BucketARN":{},"FileKey":{},"ObjectVersion":{}}}}}}},"RunConfigurationDescription":{"type":"structure","members":{"ApplicationRestoreConfigurationDescription":{"shape":"S3d"}}},"FlinkApplicationConfigurationDescription":{"type":"structure","members":{"CheckpointConfigurationDescription":{"type":"structure","members":{"ConfigurationType":{},"CheckpointingEnabled":{"type":"boolean"},"CheckpointInterval":{"type":"long"},"MinPauseBetweenCheckpoints":{"type":"long"}}},"MonitoringConfigurationDescription":{"type":"structure","members":{"ConfigurationType":{},"MetricsLevel":{},"LogLevel":{}}},"ParallelismConfigurationDescription":{"type":"structure","members":{"ConfigurationType":{},"Parallelism":{"type":"integer"},"ParallelismPerKPU":{"type":"integer"},"CurrentParallelism":{"type":"integer"},"AutoScalingEnabled":{"type":"boolean"}}},"JobPlanDescription":{}}},"EnvironmentPropertyDescriptions":{"type":"structure","members":{"PropertyGroupDescriptions":{"shape":"S2j"}}},"ApplicationSnapshotConfigurationDescription":{"type":"structure","required":["SnapshotsEnabled"],"members":{"SnapshotsEnabled":{"type":"boolean"}}}}},"CloudWatchLoggingOptionDescriptions":{"shape":"S8"}}},"S3d":{"type":"structure","required":["ApplicationRestoreType"],"members":{"ApplicationRestoreType":{},"SnapshotName":{}}},"S45":{"type":"structure","required":["SnapshotName","SnapshotStatus","ApplicationVersionId"],"members":{"SnapshotName":{},"SnapshotStatus":{},"ApplicationVersionId":{"type":"long"},"SnapshotCreationTimestamp":{"type":"timestamp"}}}}}');

});

parcelRequire.register("aVSZV", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("cYUp8", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $9736d75a2a0d824c$var$Service = $dbC7k.Service;
var $9736d75a2a0d824c$var$apiLoader = $dbC7k.apiLoader;
$9736d75a2a0d824c$var$apiLoader.services["mediaconnect"] = {};
$dbC7k.MediaConnect = $9736d75a2a0d824c$var$Service.defineService("mediaconnect", [
    "2018-11-14"
]);


Object.defineProperty($9736d75a2a0d824c$var$apiLoader.services["mediaconnect"], "2018-11-14", {
    get: function get() {
        var model = (parcelRequire("gnUAw"));
        model.paginators = (parcelRequire("gMIw2")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.MediaConnect;

});
parcelRequire.register("gnUAw", function(module, exports) {
module.exports = JSON.parse('{"metadata":{"apiVersion":"2018-11-14","endpointPrefix":"mediaconnect","signingName":"mediaconnect","serviceFullName":"AWS MediaConnect","serviceId":"MediaConnect","protocol":"rest-json","jsonVersion":"1.1","uid":"mediaconnect-2018-11-14","signatureVersion":"v4"},"operations":{"AddFlowOutputs":{"http":{"requestUri":"/v1/flows/{flowArn}/outputs","responseCode":201},"input":{"type":"structure","members":{"FlowArn":{"location":"uri","locationName":"flowArn"},"Outputs":{"shape":"S3","locationName":"outputs"}},"required":["FlowArn","Outputs"]},"output":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"},"Outputs":{"shape":"Sc","locationName":"outputs"}}}},"CreateFlow":{"http":{"requestUri":"/v1/flows","responseCode":201},"input":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Entitlements":{"shape":"Sg","locationName":"entitlements"},"Name":{"locationName":"name"},"Outputs":{"shape":"S3","locationName":"outputs"},"Source":{"locationName":"source","type":"structure","members":{"Decryption":{"shape":"S6","locationName":"decryption"},"Description":{"locationName":"description"},"EntitlementArn":{"locationName":"entitlementArn"},"IngestPort":{"locationName":"ingestPort","type":"integer"},"MaxBitrate":{"locationName":"maxBitrate","type":"integer"},"MaxLatency":{"locationName":"maxLatency","type":"integer"},"Name":{"locationName":"name"},"Protocol":{"locationName":"protocol"},"StreamId":{"locationName":"streamId"},"WhitelistCidr":{"locationName":"whitelistCidr"}}}},"required":["Source","Name"]},"output":{"type":"structure","members":{"Flow":{"shape":"Sk","locationName":"flow"}}}},"DeleteFlow":{"http":{"method":"DELETE","requestUri":"/v1/flows/{flowArn}","responseCode":202},"input":{"type":"structure","members":{"FlowArn":{"location":"uri","locationName":"flowArn"}},"required":["FlowArn"]},"output":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"},"Status":{"locationName":"status"}}}},"DescribeFlow":{"http":{"method":"GET","requestUri":"/v1/flows/{flowArn}","responseCode":200},"input":{"type":"structure","members":{"FlowArn":{"location":"uri","locationName":"flowArn"}},"required":["FlowArn"]},"output":{"type":"structure","members":{"Flow":{"shape":"Sk","locationName":"flow"},"Messages":{"locationName":"messages","type":"structure","members":{"Errors":{"shape":"S5","locationName":"errors"}},"required":["Errors"]}}}},"GrantFlowEntitlements":{"http":{"requestUri":"/v1/flows/{flowArn}/entitlements","responseCode":200},"input":{"type":"structure","members":{"Entitlements":{"shape":"Sg","locationName":"entitlements"},"FlowArn":{"location":"uri","locationName":"flowArn"}},"required":["FlowArn","Entitlements"]},"output":{"type":"structure","members":{"Entitlements":{"shape":"Sl","locationName":"entitlements"},"FlowArn":{"locationName":"flowArn"}}}},"ListEntitlements":{"http":{"method":"GET","requestUri":"/v1/entitlements","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Entitlements":{"locationName":"entitlements","type":"list","member":{"type":"structure","members":{"EntitlementArn":{"locationName":"entitlementArn"},"EntitlementName":{"locationName":"entitlementName"}},"required":["EntitlementArn","EntitlementName"]}},"NextToken":{"locationName":"nextToken"}}}},"ListFlows":{"http":{"method":"GET","requestUri":"/v1/flows","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Flows":{"locationName":"flows","type":"list","member":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Description":{"locationName":"description"},"FlowArn":{"locationName":"flowArn"},"Name":{"locationName":"name"},"SourceType":{"locationName":"sourceType"},"Status":{"locationName":"status"}},"required":["Status","Description","SourceType","AvailabilityZone","FlowArn","Name"]}},"NextToken":{"locationName":"nextToken"}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{"Tags":{"shape":"S18","locationName":"tags"}}}},"RemoveFlowOutput":{"http":{"method":"DELETE","requestUri":"/v1/flows/{flowArn}/outputs/{outputArn}","responseCode":202},"input":{"type":"structure","members":{"FlowArn":{"location":"uri","locationName":"flowArn"},"OutputArn":{"location":"uri","locationName":"outputArn"}},"required":["FlowArn","OutputArn"]},"output":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"},"OutputArn":{"locationName":"outputArn"}}}},"RevokeFlowEntitlement":{"http":{"method":"DELETE","requestUri":"/v1/flows/{flowArn}/entitlements/{entitlementArn}","responseCode":202},"input":{"type":"structure","members":{"EntitlementArn":{"location":"uri","locationName":"entitlementArn"},"FlowArn":{"location":"uri","locationName":"flowArn"}},"required":["FlowArn","EntitlementArn"]},"output":{"type":"structure","members":{"EntitlementArn":{"locationName":"entitlementArn"},"FlowArn":{"locationName":"flowArn"}}}},"StartFlow":{"http":{"requestUri":"/v1/flows/start/{flowArn}","responseCode":202},"input":{"type":"structure","members":{"FlowArn":{"location":"uri","locationName":"flowArn"}},"required":["FlowArn"]},"output":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"},"Status":{"locationName":"status"}}}},"StopFlow":{"http":{"requestUri":"/v1/flows/stop/{flowArn}","responseCode":202},"input":{"type":"structure","members":{"FlowArn":{"location":"uri","locationName":"flowArn"}},"required":["FlowArn"]},"output":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"},"Status":{"locationName":"status"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"Tags":{"shape":"S18","locationName":"tags"}},"required":["ResourceArn","Tags"]}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"TagKeys":{"shape":"S5","location":"querystring","locationName":"tagKeys"}},"required":["TagKeys","ResourceArn"]}},"UpdateFlowEntitlement":{"http":{"method":"PUT","requestUri":"/v1/flows/{flowArn}/entitlements/{entitlementArn}","responseCode":202},"input":{"type":"structure","members":{"Description":{"locationName":"description"},"Encryption":{"shape":"S1k","locationName":"encryption"},"EntitlementArn":{"location":"uri","locationName":"entitlementArn"},"FlowArn":{"location":"uri","locationName":"flowArn"},"Subscribers":{"shape":"S5","locationName":"subscribers"}},"required":["FlowArn","EntitlementArn"]},"output":{"type":"structure","members":{"Entitlement":{"shape":"Sm","locationName":"entitlement"},"FlowArn":{"locationName":"flowArn"}}}},"UpdateFlowOutput":{"http":{"method":"PUT","requestUri":"/v1/flows/{flowArn}/outputs/{outputArn}","responseCode":202},"input":{"type":"structure","members":{"CidrAllowList":{"shape":"S5","locationName":"cidrAllowList"},"Description":{"locationName":"description"},"Destination":{"locationName":"destination"},"Encryption":{"shape":"S1k","locationName":"encryption"},"FlowArn":{"location":"uri","locationName":"flowArn"},"MaxLatency":{"locationName":"maxLatency","type":"integer"},"OutputArn":{"location":"uri","locationName":"outputArn"},"Port":{"locationName":"port","type":"integer"},"Protocol":{"locationName":"protocol"},"RemoteId":{"locationName":"remoteId"},"SmoothingLatency":{"locationName":"smoothingLatency","type":"integer"},"StreamId":{"locationName":"streamId"}},"required":["FlowArn","OutputArn"]},"output":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"},"Output":{"shape":"Sd","locationName":"output"}}}},"UpdateFlowSource":{"http":{"method":"PUT","requestUri":"/v1/flows/{flowArn}/source/{sourceArn}","responseCode":202},"input":{"type":"structure","members":{"Decryption":{"shape":"S1k","locationName":"decryption"},"Description":{"locationName":"description"},"EntitlementArn":{"locationName":"entitlementArn"},"FlowArn":{"location":"uri","locationName":"flowArn"},"IngestPort":{"locationName":"ingestPort","type":"integer"},"MaxBitrate":{"locationName":"maxBitrate","type":"integer"},"MaxLatency":{"locationName":"maxLatency","type":"integer"},"Protocol":{"locationName":"protocol"},"SourceArn":{"location":"uri","locationName":"sourceArn"},"StreamId":{"locationName":"streamId"},"WhitelistCidr":{"locationName":"whitelistCidr"}},"required":["FlowArn","SourceArn"]},"output":{"type":"structure","members":{"FlowArn":{"locationName":"flowArn"},"Source":{"shape":"Sn","locationName":"source"}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","members":{"CidrAllowList":{"shape":"S5","locationName":"cidrAllowList"},"Description":{"locationName":"description"},"Destination":{"locationName":"destination"},"Encryption":{"shape":"S6","locationName":"encryption"},"MaxLatency":{"locationName":"maxLatency","type":"integer"},"Name":{"locationName":"name"},"Port":{"locationName":"port","type":"integer"},"Protocol":{"locationName":"protocol"},"RemoteId":{"locationName":"remoteId"},"SmoothingLatency":{"locationName":"smoothingLatency","type":"integer"},"StreamId":{"locationName":"streamId"}},"required":["Protocol"]}},"S5":{"type":"list","member":{}},"S6":{"type":"structure","members":{"Algorithm":{"locationName":"algorithm"},"ConstantInitializationVector":{"locationName":"constantInitializationVector"},"DeviceId":{"locationName":"deviceId"},"KeyType":{"locationName":"keyType"},"Region":{"locationName":"region"},"ResourceId":{"locationName":"resourceId"},"RoleArn":{"locationName":"roleArn"},"SecretArn":{"locationName":"secretArn"},"Url":{"locationName":"url"}},"required":["Algorithm","RoleArn"]},"Sc":{"type":"list","member":{"shape":"Sd"}},"Sd":{"type":"structure","members":{"Description":{"locationName":"description"},"Destination":{"locationName":"destination"},"Encryption":{"shape":"S6","locationName":"encryption"},"EntitlementArn":{"locationName":"entitlementArn"},"MediaLiveInputArn":{"locationName":"mediaLiveInputArn"},"Name":{"locationName":"name"},"OutputArn":{"locationName":"outputArn"},"Port":{"locationName":"port","type":"integer"},"Transport":{"shape":"Se","locationName":"transport"}},"required":["OutputArn","Name"]},"Se":{"type":"structure","members":{"CidrAllowList":{"shape":"S5","locationName":"cidrAllowList"},"MaxBitrate":{"locationName":"maxBitrate","type":"integer"},"MaxLatency":{"locationName":"maxLatency","type":"integer"},"Protocol":{"locationName":"protocol"},"RemoteId":{"locationName":"remoteId"},"SmoothingLatency":{"locationName":"smoothingLatency","type":"integer"},"StreamId":{"locationName":"streamId"}},"required":["Protocol"]},"Sg":{"type":"list","member":{"type":"structure","members":{"Description":{"locationName":"description"},"Encryption":{"shape":"S6","locationName":"encryption"},"Name":{"locationName":"name"},"Subscribers":{"shape":"S5","locationName":"subscribers"}},"required":["Subscribers"]}},"Sk":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Description":{"locationName":"description"},"EgressIp":{"locationName":"egressIp"},"Entitlements":{"shape":"Sl","locationName":"entitlements"},"FlowArn":{"locationName":"flowArn"},"Name":{"locationName":"name"},"Outputs":{"shape":"Sc","locationName":"outputs"},"Source":{"shape":"Sn","locationName":"source"},"Status":{"locationName":"status"}},"required":["Status","Entitlements","Outputs","AvailabilityZone","FlowArn","Source","Name"]},"Sl":{"type":"list","member":{"shape":"Sm"}},"Sm":{"type":"structure","members":{"Description":{"locationName":"description"},"Encryption":{"shape":"S6","locationName":"encryption"},"EntitlementArn":{"locationName":"entitlementArn"},"Name":{"locationName":"name"},"Subscribers":{"shape":"S5","locationName":"subscribers"}},"required":["EntitlementArn","Subscribers","Name"]},"Sn":{"type":"structure","members":{"Decryption":{"shape":"S6","locationName":"decryption"},"Description":{"locationName":"description"},"EntitlementArn":{"locationName":"entitlementArn"},"IngestIp":{"locationName":"ingestIp"},"IngestPort":{"locationName":"ingestPort","type":"integer"},"Name":{"locationName":"name"},"SourceArn":{"locationName":"sourceArn"},"Transport":{"shape":"Se","locationName":"transport"},"WhitelistCidr":{"locationName":"whitelistCidr"}},"required":["SourceArn","Name"]},"S18":{"type":"map","key":{},"value":{}},"S1k":{"type":"structure","members":{"Algorithm":{"locationName":"algorithm"},"ConstantInitializationVector":{"locationName":"constantInitializationVector"},"DeviceId":{"locationName":"deviceId"},"KeyType":{"locationName":"keyType"},"Region":{"locationName":"region"},"ResourceId":{"locationName":"resourceId"},"RoleArn":{"locationName":"roleArn"},"SecretArn":{"locationName":"secretArn"},"Url":{"locationName":"url"}}}}}');

});

parcelRequire.register("gMIw2", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListEntitlements":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Entitlements"},"ListFlows":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Flows"}}}');

});


parcelRequire.register("8FG7D", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $6502d3a10bc45ed3$var$Service = $dbC7k.Service;
var $6502d3a10bc45ed3$var$apiLoader = $dbC7k.apiLoader;
$6502d3a10bc45ed3$var$apiLoader.services["fsx"] = {};
$dbC7k.FSx = $6502d3a10bc45ed3$var$Service.defineService("fsx", [
    "2018-03-01"
]);


Object.defineProperty($6502d3a10bc45ed3$var$apiLoader.services["fsx"], "2018-03-01", {
    get: function get() {
        var model = (parcelRequire("iJW8L"));
        model.paginators = (parcelRequire("1pELj")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.FSx;

});
parcelRequire.register("iJW8L", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-03-01","endpointPrefix":"fsx","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon FSx","serviceId":"FSx","signatureVersion":"v4","targetPrefix":"AWSSimbaAPIService_v20180301","uid":"fsx-2018-03-01"},"operations":{"CreateBackup":{"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"Backup":{"shape":"S9"}}},"idempotent":true},"CreateFileSystem":{"input":{"type":"structure","required":["FileSystemType","StorageCapacity","SubnetIds"],"members":{"ClientRequestToken":{"idempotencyToken":true},"FileSystemType":{},"StorageCapacity":{"type":"integer"},"SubnetIds":{"shape":"Sq"},"SecurityGroupIds":{"shape":"S1h"},"Tags":{"shape":"S4"},"KmsKeyId":{},"WindowsConfiguration":{"shape":"S1j"},"LustreConfiguration":{"type":"structure","members":{"WeeklyMaintenanceStartTime":{},"ImportPath":{},"ExportPath":{},"ImportedFileChunkSize":{"type":"integer"}}}}},"output":{"type":"structure","members":{"FileSystem":{"shape":"Sj"}}}},"CreateFileSystemFromBackup":{"input":{"type":"structure","required":["BackupId","SubnetIds"],"members":{"BackupId":{},"ClientRequestToken":{"idempotencyToken":true},"SubnetIds":{"shape":"Sq"},"SecurityGroupIds":{"shape":"S1h"},"Tags":{"shape":"S4"},"WindowsConfiguration":{"shape":"S1j"}}},"output":{"type":"structure","members":{"FileSystem":{"shape":"Sj"}}}},"DeleteBackup":{"input":{"type":"structure","required":["BackupId"],"members":{"BackupId":{},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"BackupId":{},"Lifecycle":{}}},"idempotent":true},"DeleteFileSystem":{"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{},"ClientRequestToken":{"idempotencyToken":true},"WindowsConfiguration":{"type":"structure","members":{"SkipFinalBackup":{"type":"boolean"},"FinalBackupTags":{"shape":"S4"}}}}},"output":{"type":"structure","members":{"FileSystemId":{},"Lifecycle":{},"WindowsResponse":{"type":"structure","members":{"FinalBackupId":{},"FinalBackupTags":{"shape":"S4"}}}}},"idempotent":true},"DescribeBackups":{"input":{"type":"structure","members":{"BackupIds":{"type":"list","member":{}},"Filters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Backups":{"type":"list","member":{"shape":"S9"}},"NextToken":{}}}},"DescribeFileSystems":{"input":{"type":"structure","members":{"FileSystemIds":{"type":"list","member":{}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FileSystems":{"type":"list","member":{"shape":"Sj"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S4"},"NextToken":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateFileSystem":{"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{},"ClientRequestToken":{"idempotencyToken":true},"WindowsConfiguration":{"type":"structure","members":{"WeeklyMaintenanceStartTime":{},"DailyAutomaticBackupStartTime":{},"AutomaticBackupRetentionDays":{"type":"integer"},"SelfManagedActiveDirectoryConfiguration":{"type":"structure","members":{"UserName":{},"Password":{"shape":"S1l"},"DnsIps":{"shape":"S12"}}}}},"LustreConfiguration":{"type":"structure","members":{"WeeklyMaintenanceStartTime":{}}}}},"output":{"type":"structure","members":{"FileSystem":{"shape":"Sj"}}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S9":{"type":"structure","required":["BackupId","Lifecycle","Type","CreationTime","FileSystem"],"members":{"BackupId":{},"Lifecycle":{},"FailureDetails":{"type":"structure","members":{"Message":{}}},"Type":{},"ProgressPercent":{"type":"integer"},"CreationTime":{"type":"timestamp"},"KmsKeyId":{},"ResourceARN":{},"Tags":{"shape":"S4"},"FileSystem":{"shape":"Sj"},"DirectoryInformation":{"type":"structure","members":{"DomainName":{},"ActiveDirectoryId":{}}}}},"Sj":{"type":"structure","members":{"OwnerId":{},"CreationTime":{"type":"timestamp"},"FileSystemId":{},"FileSystemType":{},"Lifecycle":{},"FailureDetails":{"type":"structure","members":{"Message":{}}},"StorageCapacity":{"type":"integer"},"VpcId":{},"SubnetIds":{"shape":"Sq"},"NetworkInterfaceIds":{"type":"list","member":{}},"DNSName":{},"KmsKeyId":{},"ResourceARN":{},"Tags":{"shape":"S4"},"WindowsConfiguration":{"type":"structure","members":{"ActiveDirectoryId":{},"SelfManagedActiveDirectoryConfiguration":{"type":"structure","members":{"DomainName":{},"OrganizationalUnitDistinguishedName":{},"FileSystemAdministratorsGroup":{},"UserName":{},"DnsIps":{"shape":"S12"}}},"ThroughputCapacity":{"type":"integer"},"MaintenanceOperationsInProgress":{"type":"list","member":{}},"WeeklyMaintenanceStartTime":{},"DailyAutomaticBackupStartTime":{},"AutomaticBackupRetentionDays":{"type":"integer"},"CopyTagsToBackups":{"type":"boolean"}}},"LustreConfiguration":{"type":"structure","members":{"WeeklyMaintenanceStartTime":{},"DataRepositoryConfiguration":{"type":"structure","members":{"ImportPath":{},"ExportPath":{},"ImportedFileChunkSize":{"type":"integer"}}}}}}},"Sq":{"type":"list","member":{}},"S12":{"type":"list","member":{}},"S1h":{"type":"list","member":{}},"S1j":{"type":"structure","required":["ThroughputCapacity"],"members":{"ActiveDirectoryId":{},"SelfManagedActiveDirectoryConfiguration":{"type":"structure","required":["DomainName","UserName","Password","DnsIps"],"members":{"DomainName":{},"OrganizationalUnitDistinguishedName":{},"FileSystemAdministratorsGroup":{},"UserName":{},"Password":{"shape":"S1l"},"DnsIps":{"shape":"S12"}}},"ThroughputCapacity":{"type":"integer"},"WeeklyMaintenanceStartTime":{},"DailyAutomaticBackupStartTime":{},"AutomaticBackupRetentionDays":{"type":"integer"},"CopyTagsToBackups":{"type":"boolean"}}},"S1l":{"type":"string","sensitive":true}}}');

});

parcelRequire.register("1pELj", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeBackups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeFileSystems":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("gRQWf", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $c47aa9127d283d3e$var$Service = $dbC7k.Service;
var $c47aa9127d283d3e$var$apiLoader = $dbC7k.apiLoader;
$c47aa9127d283d3e$var$apiLoader.services["securityhub"] = {};
$dbC7k.SecurityHub = $c47aa9127d283d3e$var$Service.defineService("securityhub", [
    "2018-10-26"
]);


Object.defineProperty($c47aa9127d283d3e$var$apiLoader.services["securityhub"], "2018-10-26", {
    get: function get() {
        var model = (parcelRequire("5ZbqJ"));
        model.paginators = (parcelRequire("e7NyM")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.SecurityHub;

});
parcelRequire.register("5ZbqJ", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-10-26","endpointPrefix":"securityhub","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS SecurityHub","serviceId":"SecurityHub","signatureVersion":"v4","signingName":"securityhub","uid":"securityhub-2018-10-26"},"operations":{"AcceptInvitation":{"http":{"requestUri":"/master"},"input":{"type":"structure","required":["MasterId","InvitationId"],"members":{"MasterId":{},"InvitationId":{}}},"output":{"type":"structure","members":{}}},"BatchDisableStandards":{"http":{"requestUri":"/standards/deregister"},"input":{"type":"structure","required":["StandardsSubscriptionArns"],"members":{"StandardsSubscriptionArns":{"shape":"S5"}}},"output":{"type":"structure","members":{"StandardsSubscriptions":{"shape":"S7"}}}},"BatchEnableStandards":{"http":{"requestUri":"/standards/register"},"input":{"type":"structure","required":["StandardsSubscriptionRequests"],"members":{"StandardsSubscriptionRequests":{"type":"list","member":{"type":"structure","required":["StandardsArn"],"members":{"StandardsArn":{},"StandardsInput":{"shape":"S9"}}}}}},"output":{"type":"structure","members":{"StandardsSubscriptions":{"shape":"S7"}}}},"BatchImportFindings":{"http":{"requestUri":"/findings/import"},"input":{"type":"structure","required":["Findings"],"members":{"Findings":{"shape":"Sg"}}},"output":{"type":"structure","required":["FailedCount","SuccessCount"],"members":{"FailedCount":{"type":"integer"},"SuccessCount":{"type":"integer"},"FailedFindings":{"type":"list","member":{"type":"structure","required":["Id","ErrorCode","ErrorMessage"],"members":{"Id":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"CreateActionTarget":{"http":{"requestUri":"/actionTargets"},"input":{"type":"structure","required":["Name","Description","Id"],"members":{"Name":{},"Description":{},"Id":{}}},"output":{"type":"structure","required":["ActionTargetArn"],"members":{"ActionTargetArn":{}}}},"CreateInsight":{"http":{"requestUri":"/insights"},"input":{"type":"structure","required":["Name","Filters","GroupByAttribute"],"members":{"Name":{},"Filters":{"shape":"S1o"},"GroupByAttribute":{}}},"output":{"type":"structure","required":["InsightArn"],"members":{"InsightArn":{}}}},"CreateMembers":{"http":{"requestUri":"/members"},"input":{"type":"structure","members":{"AccountDetails":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"Email":{}}}}}},"output":{"type":"structure","members":{"UnprocessedAccounts":{"shape":"S2b"}}}},"DeclineInvitations":{"http":{"requestUri":"/invitations/decline"},"input":{"type":"structure","required":["AccountIds"],"members":{"AccountIds":{"shape":"S2e"}}},"output":{"type":"structure","members":{"UnprocessedAccounts":{"shape":"S2b"}}}},"DeleteActionTarget":{"http":{"method":"DELETE","requestUri":"/actionTargets/{ActionTargetArn+}"},"input":{"type":"structure","required":["ActionTargetArn"],"members":{"ActionTargetArn":{"location":"uri","locationName":"ActionTargetArn"}}},"output":{"type":"structure","required":["ActionTargetArn"],"members":{"ActionTargetArn":{}}}},"DeleteInsight":{"http":{"method":"DELETE","requestUri":"/insights/{InsightArn+}"},"input":{"type":"structure","required":["InsightArn"],"members":{"InsightArn":{"location":"uri","locationName":"InsightArn"}}},"output":{"type":"structure","required":["InsightArn"],"members":{"InsightArn":{}}}},"DeleteInvitations":{"http":{"requestUri":"/invitations/delete"},"input":{"type":"structure","required":["AccountIds"],"members":{"AccountIds":{"shape":"S2e"}}},"output":{"type":"structure","members":{"UnprocessedAccounts":{"shape":"S2b"}}}},"DeleteMembers":{"http":{"requestUri":"/members/delete"},"input":{"type":"structure","members":{"AccountIds":{"shape":"S2e"}}},"output":{"type":"structure","members":{"UnprocessedAccounts":{"shape":"S2b"}}}},"DescribeActionTargets":{"http":{"requestUri":"/actionTargets/get"},"input":{"type":"structure","members":{"ActionTargetArns":{"shape":"S2p"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["ActionTargets"],"members":{"ActionTargets":{"type":"list","member":{"type":"structure","required":["ActionTargetArn","Name","Description"],"members":{"ActionTargetArn":{},"Name":{},"Description":{}}}},"NextToken":{}}}},"DescribeHub":{"http":{"method":"GET","requestUri":"/accounts"},"input":{"type":"structure","members":{"HubArn":{"location":"querystring","locationName":"HubArn"}}},"output":{"type":"structure","members":{"HubArn":{},"SubscribedAt":{}}}},"DescribeProducts":{"http":{"method":"GET","requestUri":"/products"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"}}},"output":{"type":"structure","required":["Products"],"members":{"Products":{"type":"list","member":{"type":"structure","required":["ProductArn"],"members":{"ProductArn":{},"ProductName":{},"CompanyName":{},"Description":{},"Categories":{"type":"list","member":{}},"MarketplaceUrl":{},"ActivationUrl":{},"ProductSubscriptionResourcePolicy":{}}}},"NextToken":{}}}},"DisableImportFindingsForProduct":{"http":{"method":"DELETE","requestUri":"/productSubscriptions/{ProductSubscriptionArn+}"},"input":{"type":"structure","required":["ProductSubscriptionArn"],"members":{"ProductSubscriptionArn":{"location":"uri","locationName":"ProductSubscriptionArn"}}},"output":{"type":"structure","members":{}}},"DisableSecurityHub":{"http":{"method":"DELETE","requestUri":"/accounts"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DisassociateFromMasterAccount":{"http":{"requestUri":"/master/disassociate"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DisassociateMembers":{"http":{"requestUri":"/members/disassociate"},"input":{"type":"structure","members":{"AccountIds":{"shape":"S2e"}}},"output":{"type":"structure","members":{}}},"EnableImportFindingsForProduct":{"http":{"requestUri":"/productSubscriptions"},"input":{"type":"structure","required":["ProductArn"],"members":{"ProductArn":{}}},"output":{"type":"structure","members":{"ProductSubscriptionArn":{}}}},"EnableSecurityHub":{"http":{"requestUri":"/accounts"},"input":{"type":"structure","members":{"Tags":{"shape":"S3d"}}},"output":{"type":"structure","members":{}}},"GetEnabledStandards":{"http":{"requestUri":"/standards/get"},"input":{"type":"structure","members":{"StandardsSubscriptionArns":{"shape":"S5"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"StandardsSubscriptions":{"shape":"S7"},"NextToken":{}}}},"GetFindings":{"http":{"requestUri":"/findings"},"input":{"type":"structure","members":{"Filters":{"shape":"S1o"},"SortCriteria":{"type":"list","member":{"type":"structure","members":{"Field":{},"SortOrder":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["Findings"],"members":{"Findings":{"shape":"Sg"},"NextToken":{}}}},"GetInsightResults":{"http":{"method":"GET","requestUri":"/insights/results/{InsightArn+}"},"input":{"type":"structure","required":["InsightArn"],"members":{"InsightArn":{"location":"uri","locationName":"InsightArn"}}},"output":{"type":"structure","required":["InsightResults"],"members":{"InsightResults":{"type":"structure","required":["InsightArn","GroupByAttribute","ResultValues"],"members":{"InsightArn":{},"GroupByAttribute":{},"ResultValues":{"type":"list","member":{"type":"structure","required":["GroupByAttributeValue","Count"],"members":{"GroupByAttributeValue":{},"Count":{"type":"integer"}}}}}}}}},"GetInsights":{"http":{"requestUri":"/insights/get"},"input":{"type":"structure","members":{"InsightArns":{"shape":"S2p"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["Insights"],"members":{"Insights":{"type":"list","member":{"type":"structure","required":["InsightArn","Name","Filters","GroupByAttribute"],"members":{"InsightArn":{},"Name":{},"Filters":{"shape":"S1o"},"GroupByAttribute":{}}}},"NextToken":{}}}},"GetInvitationsCount":{"http":{"method":"GET","requestUri":"/invitations/count"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"InvitationsCount":{"type":"integer"}}}},"GetMasterAccount":{"http":{"method":"GET","requestUri":"/master"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"Master":{"shape":"S41"}}}},"GetMembers":{"http":{"requestUri":"/members/get"},"input":{"type":"structure","required":["AccountIds"],"members":{"AccountIds":{"shape":"S2e"}}},"output":{"type":"structure","members":{"Members":{"shape":"S45"},"UnprocessedAccounts":{"shape":"S2b"}}}},"InviteMembers":{"http":{"requestUri":"/members/invite"},"input":{"type":"structure","members":{"AccountIds":{"shape":"S2e"}}},"output":{"type":"structure","members":{"UnprocessedAccounts":{"shape":"S2b"}}}},"ListEnabledProductsForImport":{"http":{"method":"GET","requestUri":"/productSubscriptions"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"}}},"output":{"type":"structure","members":{"ProductSubscriptions":{"type":"list","member":{}},"NextToken":{}}}},"ListInvitations":{"http":{"method":"GET","requestUri":"/invitations"},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Invitations":{"type":"list","member":{"shape":"S41"}},"NextToken":{}}}},"ListMembers":{"http":{"method":"GET","requestUri":"/members"},"input":{"type":"structure","members":{"OnlyAssociated":{"location":"querystring","locationName":"OnlyAssociated","type":"boolean"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Members":{"shape":"S45"},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{ResourceArn}"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S3d"}}}},"TagResource":{"http":{"requestUri":"/tags/{ResourceArn}"},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"Tags":{"shape":"S3d"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{ResourceArn}"},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateActionTarget":{"http":{"method":"PATCH","requestUri":"/actionTargets/{ActionTargetArn+}"},"input":{"type":"structure","required":["ActionTargetArn"],"members":{"ActionTargetArn":{"location":"uri","locationName":"ActionTargetArn"},"Name":{},"Description":{}}},"output":{"type":"structure","members":{}}},"UpdateFindings":{"http":{"method":"PATCH","requestUri":"/findings"},"input":{"type":"structure","required":["Filters"],"members":{"Filters":{"shape":"S1o"},"Note":{"type":"structure","required":["Text","UpdatedBy"],"members":{"Text":{},"UpdatedBy":{}}},"RecordState":{}}},"output":{"type":"structure","members":{}}},"UpdateInsight":{"http":{"method":"PATCH","requestUri":"/insights/{InsightArn+}"},"input":{"type":"structure","required":["InsightArn"],"members":{"InsightArn":{"location":"uri","locationName":"InsightArn"},"Name":{},"Filters":{"shape":"S1o"},"GroupByAttribute":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S5":{"type":"list","member":{}},"S7":{"type":"list","member":{"type":"structure","required":["StandardsSubscriptionArn","StandardsArn","StandardsInput","StandardsStatus"],"members":{"StandardsSubscriptionArn":{},"StandardsArn":{},"StandardsInput":{"shape":"S9"},"StandardsStatus":{}}}},"S9":{"type":"map","key":{},"value":{}},"Sg":{"type":"list","member":{"type":"structure","required":["SchemaVersion","Id","ProductArn","GeneratorId","AwsAccountId","Types","CreatedAt","UpdatedAt","Severity","Title","Description","Resources"],"members":{"SchemaVersion":{},"Id":{},"ProductArn":{},"GeneratorId":{},"AwsAccountId":{},"Types":{"type":"list","member":{}},"FirstObservedAt":{},"LastObservedAt":{},"CreatedAt":{},"UpdatedAt":{},"Severity":{"type":"structure","required":["Normalized"],"members":{"Product":{"type":"double"},"Normalized":{"type":"integer"}}},"Confidence":{"type":"integer"},"Criticality":{"type":"integer"},"Title":{},"Description":{},"Remediation":{"type":"structure","members":{"Recommendation":{"type":"structure","members":{"Text":{},"Url":{}}}}},"SourceUrl":{},"ProductFields":{"shape":"So"},"UserDefinedFields":{"shape":"So"},"Malware":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Type":{},"Path":{},"State":{}}}},"Network":{"type":"structure","members":{"Direction":{},"Protocol":{},"SourceIpV4":{},"SourceIpV6":{},"SourcePort":{"type":"integer"},"SourceDomain":{},"SourceMac":{},"DestinationIpV4":{},"DestinationIpV6":{},"DestinationPort":{"type":"integer"},"DestinationDomain":{}}},"Process":{"type":"structure","members":{"Name":{},"Path":{},"Pid":{"type":"integer"},"ParentPid":{"type":"integer"},"LaunchedAt":{},"TerminatedAt":{}}},"ThreatIntelIndicators":{"type":"list","member":{"type":"structure","members":{"Type":{},"Value":{},"Category":{},"LastObservedAt":{},"Source":{},"SourceUrl":{}}}},"Resources":{"type":"list","member":{"type":"structure","required":["Type","Id"],"members":{"Type":{},"Id":{},"Partition":{},"Region":{},"Tags":{"shape":"So"},"Details":{"type":"structure","members":{"AwsEc2Instance":{"type":"structure","members":{"Type":{},"ImageId":{},"IpV4Addresses":{"shape":"S15"},"IpV6Addresses":{"shape":"S15"},"KeyName":{},"IamInstanceProfileArn":{},"VpcId":{},"SubnetId":{},"LaunchedAt":{}}},"AwsS3Bucket":{"type":"structure","members":{"OwnerId":{},"OwnerName":{}}},"AwsIamAccessKey":{"type":"structure","members":{"UserName":{},"Status":{},"CreatedAt":{}}},"Container":{"type":"structure","members":{"Name":{},"ImageId":{},"ImageName":{},"LaunchedAt":{}}},"Other":{"shape":"So"}}}}}},"Compliance":{"type":"structure","members":{"Status":{}}},"VerificationState":{},"WorkflowState":{},"RecordState":{},"RelatedFindings":{"type":"list","member":{"type":"structure","required":["ProductArn","Id"],"members":{"ProductArn":{},"Id":{}}}},"Note":{"type":"structure","required":["Text","UpdatedBy","UpdatedAt"],"members":{"Text":{},"UpdatedBy":{},"UpdatedAt":{}}}}}},"So":{"type":"map","key":{},"value":{}},"S15":{"type":"list","member":{}},"S1o":{"type":"structure","members":{"ProductArn":{"shape":"S1p"},"AwsAccountId":{"shape":"S1p"},"Id":{"shape":"S1p"},"GeneratorId":{"shape":"S1p"},"Type":{"shape":"S1p"},"FirstObservedAt":{"shape":"S1s"},"LastObservedAt":{"shape":"S1s"},"CreatedAt":{"shape":"S1s"},"UpdatedAt":{"shape":"S1s"},"SeverityProduct":{"shape":"S1w"},"SeverityNormalized":{"shape":"S1w"},"SeverityLabel":{"shape":"S1p"},"Confidence":{"shape":"S1w"},"Criticality":{"shape":"S1w"},"Title":{"shape":"S1p"},"Description":{"shape":"S1p"},"RecommendationText":{"shape":"S1p"},"SourceUrl":{"shape":"S1p"},"ProductFields":{"shape":"S1y"},"ProductName":{"shape":"S1p"},"CompanyName":{"shape":"S1p"},"UserDefinedFields":{"shape":"S1y"},"MalwareName":{"shape":"S1p"},"MalwareType":{"shape":"S1p"},"MalwarePath":{"shape":"S1p"},"MalwareState":{"shape":"S1p"},"NetworkDirection":{"shape":"S1p"},"NetworkProtocol":{"shape":"S1p"},"NetworkSourceIpV4":{"shape":"S21"},"NetworkSourceIpV6":{"shape":"S21"},"NetworkSourcePort":{"shape":"S1w"},"NetworkSourceDomain":{"shape":"S1p"},"NetworkSourceMac":{"shape":"S1p"},"NetworkDestinationIpV4":{"shape":"S21"},"NetworkDestinationIpV6":{"shape":"S21"},"NetworkDestinationPort":{"shape":"S1w"},"NetworkDestinationDomain":{"shape":"S1p"},"ProcessName":{"shape":"S1p"},"ProcessPath":{"shape":"S1p"},"ProcessPid":{"shape":"S1w"},"ProcessParentPid":{"shape":"S1w"},"ProcessLaunchedAt":{"shape":"S1s"},"ProcessTerminatedAt":{"shape":"S1s"},"ThreatIntelIndicatorType":{"shape":"S1p"},"ThreatIntelIndicatorValue":{"shape":"S1p"},"ThreatIntelIndicatorCategory":{"shape":"S1p"},"ThreatIntelIndicatorLastObservedAt":{"shape":"S1s"},"ThreatIntelIndicatorSource":{"shape":"S1p"},"ThreatIntelIndicatorSourceUrl":{"shape":"S1p"},"ResourceType":{"shape":"S1p"},"ResourceId":{"shape":"S1p"},"ResourcePartition":{"shape":"S1p"},"ResourceRegion":{"shape":"S1p"},"ResourceTags":{"shape":"S1y"},"ResourceAwsEc2InstanceType":{"shape":"S1p"},"ResourceAwsEc2InstanceImageId":{"shape":"S1p"},"ResourceAwsEc2InstanceIpV4Addresses":{"shape":"S21"},"ResourceAwsEc2InstanceIpV6Addresses":{"shape":"S21"},"ResourceAwsEc2InstanceKeyName":{"shape":"S1p"},"ResourceAwsEc2InstanceIamInstanceProfileArn":{"shape":"S1p"},"ResourceAwsEc2InstanceVpcId":{"shape":"S1p"},"ResourceAwsEc2InstanceSubnetId":{"shape":"S1p"},"ResourceAwsEc2InstanceLaunchedAt":{"shape":"S1s"},"ResourceAwsS3BucketOwnerId":{"shape":"S1p"},"ResourceAwsS3BucketOwnerName":{"shape":"S1p"},"ResourceAwsIamAccessKeyUserName":{"shape":"S1p"},"ResourceAwsIamAccessKeyStatus":{"shape":"S1p"},"ResourceAwsIamAccessKeyCreatedAt":{"shape":"S1s"},"ResourceContainerName":{"shape":"S1p"},"ResourceContainerImageId":{"shape":"S1p"},"ResourceContainerImageName":{"shape":"S1p"},"ResourceContainerLaunchedAt":{"shape":"S1s"},"ResourceDetailsOther":{"shape":"S1y"},"ComplianceStatus":{"shape":"S1p"},"VerificationState":{"shape":"S1p"},"WorkflowState":{"shape":"S1p"},"RecordState":{"shape":"S1p"},"RelatedFindingsProductArn":{"shape":"S1p"},"RelatedFindingsId":{"shape":"S1p"},"NoteText":{"shape":"S1p"},"NoteUpdatedAt":{"shape":"S1s"},"NoteUpdatedBy":{"shape":"S1p"},"Keyword":{"type":"list","member":{"type":"structure","members":{"Value":{}}}}}},"S1p":{"type":"list","member":{"type":"structure","members":{"Value":{},"Comparison":{}}}},"S1s":{"type":"list","member":{"type":"structure","members":{"Start":{},"End":{},"DateRange":{"type":"structure","members":{"Value":{"type":"integer"},"Unit":{}}}}}},"S1w":{"type":"list","member":{"type":"structure","members":{"Gte":{"type":"double"},"Lte":{"type":"double"},"Eq":{"type":"double"}}}},"S1y":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"Comparison":{}}}},"S21":{"type":"list","member":{"type":"structure","members":{"Cidr":{}}}},"S2b":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"ProcessingResult":{}}}},"S2e":{"type":"list","member":{}},"S2p":{"type":"list","member":{}},"S3d":{"type":"map","key":{},"value":{}},"S41":{"type":"structure","members":{"AccountId":{},"InvitationId":{},"InvitedAt":{"shape":"S42"},"MemberStatus":{}}},"S42":{"type":"timestamp","timestampFormat":"iso8601"},"S45":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"Email":{},"MasterId":{},"MemberStatus":{},"InvitedAt":{"shape":"S42"},"UpdatedAt":{"shape":"S42"}}}}}}');

});

parcelRequire.register("e7NyM", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeActionTargets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeProducts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetFindings":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetInsights":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListEnabledProductsForImport":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("e9g2s", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $a4ce58e0871a5fa1$var$Service = $dbC7k.Service;
var $a4ce58e0871a5fa1$var$apiLoader = $dbC7k.apiLoader;
$a4ce58e0871a5fa1$var$apiLoader.services["appmesh"] = {};
$dbC7k.AppMesh = $a4ce58e0871a5fa1$var$Service.defineService("appmesh", [
    "2018-10-01",
    "2018-10-01*",
    "2019-01-25"
]);


Object.defineProperty($a4ce58e0871a5fa1$var$apiLoader.services["appmesh"], "2018-10-01", {
    get: function get() {
        var model = (parcelRequire("7bnGu"));
        model.paginators = (parcelRequire("gHLWh")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});


Object.defineProperty($a4ce58e0871a5fa1$var$apiLoader.services["appmesh"], "2019-01-25", {
    get: function get() {
        var model = (parcelRequire("46wOf"));
        model.paginators = (parcelRequire("lIW81")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.AppMesh;

});
parcelRequire.register("7bnGu", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-10-01","endpointPrefix":"appmesh","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS App Mesh","serviceId":"App Mesh","signatureVersion":"v4","signingName":"appmesh","uid":"appmesh-2018-10-01"},"operations":{"CreateMesh":{"http":{"method":"PUT","requestUri":"/meshes","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{}}},"output":{"type":"structure","members":{"mesh":{"shape":"S5"}},"payload":"mesh"},"idempotent":true},"CreateRoute":{"http":{"method":"PUT","requestUri":"/meshes/{meshName}/virtualRouter/{virtualRouterName}/routes","responseCode":200},"input":{"type":"structure","required":["meshName","routeName","spec","virtualRouterName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"routeName":{},"spec":{"shape":"Sd"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","members":{"route":{"shape":"Sl"}},"payload":"route"},"idempotent":true},"CreateVirtualNode":{"http":{"method":"PUT","requestUri":"/meshes/{meshName}/virtualNodes","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualNodeName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"spec":{"shape":"Sp"},"virtualNodeName":{}}},"output":{"type":"structure","members":{"virtualNode":{"shape":"S14"}},"payload":"virtualNode"},"idempotent":true},"CreateVirtualRouter":{"http":{"method":"PUT","requestUri":"/meshes/{meshName}/virtualRouters","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualRouterName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"spec":{"shape":"S18"},"virtualRouterName":{}}},"output":{"type":"structure","members":{"virtualRouter":{"shape":"S1b"}},"payload":"virtualRouter"},"idempotent":true},"DeleteMesh":{"http":{"method":"DELETE","requestUri":"/meshes/{meshName}","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"meshName":{"location":"uri","locationName":"meshName"}}},"output":{"type":"structure","members":{"mesh":{"shape":"S5"}},"payload":"mesh"},"idempotent":true},"DeleteRoute":{"http":{"method":"DELETE","requestUri":"/meshes/{meshName}/virtualRouter/{virtualRouterName}/routes/{routeName}","responseCode":200},"input":{"type":"structure","required":["meshName","routeName","virtualRouterName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"routeName":{"location":"uri","locationName":"routeName"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","members":{"route":{"shape":"Sl"}},"payload":"route"},"idempotent":true},"DeleteVirtualNode":{"http":{"method":"DELETE","requestUri":"/meshes/{meshName}/virtualNodes/{virtualNodeName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualNodeName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"virtualNodeName":{"location":"uri","locationName":"virtualNodeName"}}},"output":{"type":"structure","members":{"virtualNode":{"shape":"S14"}},"payload":"virtualNode"},"idempotent":true},"DeleteVirtualRouter":{"http":{"method":"DELETE","requestUri":"/meshes/{meshName}/virtualRouters/{virtualRouterName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualRouterName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","members":{"virtualRouter":{"shape":"S1b"}},"payload":"virtualRouter"},"idempotent":true},"DescribeMesh":{"http":{"method":"GET","requestUri":"/meshes/{meshName}","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"meshName":{"location":"uri","locationName":"meshName"}}},"output":{"type":"structure","members":{"mesh":{"shape":"S5"}},"payload":"mesh"}},"DescribeRoute":{"http":{"method":"GET","requestUri":"/meshes/{meshName}/virtualRouter/{virtualRouterName}/routes/{routeName}","responseCode":200},"input":{"type":"structure","required":["meshName","routeName","virtualRouterName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"routeName":{"location":"uri","locationName":"routeName"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","members":{"route":{"shape":"Sl"}},"payload":"route"}},"DescribeVirtualNode":{"http":{"method":"GET","requestUri":"/meshes/{meshName}/virtualNodes/{virtualNodeName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualNodeName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"virtualNodeName":{"location":"uri","locationName":"virtualNodeName"}}},"output":{"type":"structure","members":{"virtualNode":{"shape":"S14"}},"payload":"virtualNode"}},"DescribeVirtualRouter":{"http":{"method":"GET","requestUri":"/meshes/{meshName}/virtualRouters/{virtualRouterName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualRouterName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","members":{"virtualRouter":{"shape":"S1b"}},"payload":"virtualRouter"}},"ListMeshes":{"http":{"method":"GET","requestUri":"/meshes","responseCode":200},"input":{"type":"structure","members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["meshes"],"members":{"meshes":{"type":"list","member":{"type":"structure","members":{"arn":{},"meshName":{}}}},"nextToken":{}}}},"ListRoutes":{"http":{"method":"GET","requestUri":"/meshes/{meshName}/virtualRouter/{virtualRouterName}/routes","responseCode":200},"input":{"type":"structure","required":["meshName","virtualRouterName"],"members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"meshName":{"location":"uri","locationName":"meshName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","required":["routes"],"members":{"nextToken":{},"routes":{"type":"list","member":{"type":"structure","members":{"arn":{},"meshName":{},"routeName":{},"virtualRouterName":{}}}}}}},"ListVirtualNodes":{"http":{"method":"GET","requestUri":"/meshes/{meshName}/virtualNodes","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"meshName":{"location":"uri","locationName":"meshName"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["virtualNodes"],"members":{"nextToken":{},"virtualNodes":{"type":"list","member":{"type":"structure","members":{"arn":{},"meshName":{},"virtualNodeName":{}}}}}}},"ListVirtualRouters":{"http":{"method":"GET","requestUri":"/meshes/{meshName}/virtualRouters","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"meshName":{"location":"uri","locationName":"meshName"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["virtualRouters"],"members":{"nextToken":{},"virtualRouters":{"type":"list","member":{"type":"structure","members":{"arn":{},"meshName":{},"virtualRouterName":{}}}}}}},"UpdateRoute":{"http":{"method":"PUT","requestUri":"/meshes/{meshName}/virtualRouter/{virtualRouterName}/routes/{routeName}","responseCode":200},"input":{"type":"structure","required":["meshName","routeName","spec","virtualRouterName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"routeName":{"location":"uri","locationName":"routeName"},"spec":{"shape":"Sd"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","members":{"route":{"shape":"Sl"}},"payload":"route"},"idempotent":true},"UpdateVirtualNode":{"http":{"method":"PUT","requestUri":"/meshes/{meshName}/virtualNodes/{virtualNodeName}","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualNodeName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"spec":{"shape":"Sp"},"virtualNodeName":{"location":"uri","locationName":"virtualNodeName"}}},"output":{"type":"structure","members":{"virtualNode":{"shape":"S14"}},"payload":"virtualNode"},"idempotent":true},"UpdateVirtualRouter":{"http":{"method":"PUT","requestUri":"/meshes/{meshName}/virtualRouters/{virtualRouterName}","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualRouterName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"spec":{"shape":"S18"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","members":{"virtualRouter":{"shape":"S1b"}},"payload":"virtualRouter"},"idempotent":true}},"shapes":{"S5":{"type":"structure","required":["meshName","metadata"],"members":{"meshName":{},"metadata":{"shape":"S6"},"status":{"type":"structure","members":{"status":{}}}}},"S6":{"type":"structure","members":{"arn":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"uid":{},"version":{"type":"long"}}},"Sd":{"type":"structure","members":{"httpRoute":{"type":"structure","members":{"action":{"type":"structure","members":{"weightedTargets":{"type":"list","member":{"type":"structure","members":{"virtualNode":{},"weight":{"type":"integer"}}}}}},"match":{"type":"structure","members":{"prefix":{}}}}}}},"Sl":{"type":"structure","required":["meshName","routeName","virtualRouterName"],"members":{"meshName":{},"metadata":{"shape":"S6"},"routeName":{},"spec":{"shape":"Sd"},"status":{"type":"structure","members":{"status":{}}},"virtualRouterName":{}}},"Sp":{"type":"structure","members":{"backends":{"type":"list","member":{}},"listeners":{"type":"list","member":{"type":"structure","members":{"healthCheck":{"type":"structure","required":["healthyThreshold","intervalMillis","protocol","timeoutMillis","unhealthyThreshold"],"members":{"healthyThreshold":{"type":"integer"},"intervalMillis":{"type":"long"},"path":{},"port":{"type":"integer"},"protocol":{},"timeoutMillis":{"type":"long"},"unhealthyThreshold":{"type":"integer"}}},"portMapping":{"type":"structure","members":{"port":{"type":"integer"},"protocol":{}}}}}},"serviceDiscovery":{"type":"structure","members":{"dns":{"type":"structure","members":{"serviceName":{}}}}}}},"S14":{"type":"structure","required":["meshName","virtualNodeName"],"members":{"meshName":{},"metadata":{"shape":"S6"},"spec":{"shape":"Sp"},"status":{"type":"structure","members":{"status":{}}},"virtualNodeName":{}}},"S18":{"type":"structure","members":{"serviceNames":{"type":"list","member":{}}}},"S1b":{"type":"structure","required":["meshName","virtualRouterName"],"members":{"meshName":{},"metadata":{"shape":"S6"},"spec":{"shape":"S18"},"status":{"type":"structure","members":{"status":{}}},"virtualRouterName":{}}}}}');

});

parcelRequire.register("gHLWh", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListMeshes":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"meshes"},"ListRoutes":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"routes"},"ListVirtualNodes":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"virtualNodes"},"ListVirtualRouters":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"virtualRouters"}}}');

});

parcelRequire.register("46wOf", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2019-01-25","endpointPrefix":"appmesh","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS App Mesh","serviceId":"App Mesh","signatureVersion":"v4","signingName":"appmesh","uid":"appmesh-2019-01-25"},"operations":{"CreateMesh":{"http":{"method":"PUT","requestUri":"/v20190125/meshes","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{},"spec":{"shape":"S4"},"tags":{"shape":"S7"}}},"output":{"type":"structure","required":["mesh"],"members":{"mesh":{"shape":"Sc"}},"payload":"mesh"},"idempotent":true},"CreateRoute":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}/virtualRouter/{virtualRouterName}/routes","responseCode":200},"input":{"type":"structure","required":["meshName","routeName","spec","virtualRouterName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"routeName":{},"spec":{"shape":"Sk"},"tags":{"shape":"S7"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","required":["route"],"members":{"route":{"shape":"S14"}},"payload":"route"},"idempotent":true},"CreateVirtualNode":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}/virtualNodes","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualNodeName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"spec":{"shape":"S18"},"tags":{"shape":"S7"},"virtualNodeName":{}}},"output":{"type":"structure","required":["virtualNode"],"members":{"virtualNode":{"shape":"S20"}},"payload":"virtualNode"},"idempotent":true},"CreateVirtualRouter":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}/virtualRouters","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualRouterName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"spec":{"shape":"S24"},"tags":{"shape":"S7"},"virtualRouterName":{}}},"output":{"type":"structure","required":["virtualRouter"],"members":{"virtualRouter":{"shape":"S28"}},"payload":"virtualRouter"},"idempotent":true},"CreateVirtualService":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}/virtualServices","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualServiceName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"spec":{"shape":"S2c"},"tags":{"shape":"S7"},"virtualServiceName":{}}},"output":{"type":"structure","required":["virtualService"],"members":{"virtualService":{"shape":"S2h"}},"payload":"virtualService"},"idempotent":true},"DeleteMesh":{"http":{"method":"DELETE","requestUri":"/v20190125/meshes/{meshName}","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"meshName":{"location":"uri","locationName":"meshName"}}},"output":{"type":"structure","required":["mesh"],"members":{"mesh":{"shape":"Sc"}},"payload":"mesh"},"idempotent":true},"DeleteRoute":{"http":{"method":"DELETE","requestUri":"/v20190125/meshes/{meshName}/virtualRouter/{virtualRouterName}/routes/{routeName}","responseCode":200},"input":{"type":"structure","required":["meshName","routeName","virtualRouterName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"routeName":{"location":"uri","locationName":"routeName"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","required":["route"],"members":{"route":{"shape":"S14"}},"payload":"route"},"idempotent":true},"DeleteVirtualNode":{"http":{"method":"DELETE","requestUri":"/v20190125/meshes/{meshName}/virtualNodes/{virtualNodeName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualNodeName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"virtualNodeName":{"location":"uri","locationName":"virtualNodeName"}}},"output":{"type":"structure","required":["virtualNode"],"members":{"virtualNode":{"shape":"S20"}},"payload":"virtualNode"},"idempotent":true},"DeleteVirtualRouter":{"http":{"method":"DELETE","requestUri":"/v20190125/meshes/{meshName}/virtualRouters/{virtualRouterName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualRouterName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","required":["virtualRouter"],"members":{"virtualRouter":{"shape":"S28"}},"payload":"virtualRouter"},"idempotent":true},"DeleteVirtualService":{"http":{"method":"DELETE","requestUri":"/v20190125/meshes/{meshName}/virtualServices/{virtualServiceName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualServiceName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"virtualServiceName":{"location":"uri","locationName":"virtualServiceName"}}},"output":{"type":"structure","required":["virtualService"],"members":{"virtualService":{"shape":"S2h"}},"payload":"virtualService"},"idempotent":true},"DescribeMesh":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"meshName":{"location":"uri","locationName":"meshName"}}},"output":{"type":"structure","required":["mesh"],"members":{"mesh":{"shape":"Sc"}},"payload":"mesh"}},"DescribeRoute":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}/virtualRouter/{virtualRouterName}/routes/{routeName}","responseCode":200},"input":{"type":"structure","required":["meshName","routeName","virtualRouterName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"routeName":{"location":"uri","locationName":"routeName"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","required":["route"],"members":{"route":{"shape":"S14"}},"payload":"route"}},"DescribeVirtualNode":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}/virtualNodes/{virtualNodeName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualNodeName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"virtualNodeName":{"location":"uri","locationName":"virtualNodeName"}}},"output":{"type":"structure","required":["virtualNode"],"members":{"virtualNode":{"shape":"S20"}},"payload":"virtualNode"}},"DescribeVirtualRouter":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}/virtualRouters/{virtualRouterName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualRouterName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","required":["virtualRouter"],"members":{"virtualRouter":{"shape":"S28"}},"payload":"virtualRouter"}},"DescribeVirtualService":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}/virtualServices/{virtualServiceName}","responseCode":200},"input":{"type":"structure","required":["meshName","virtualServiceName"],"members":{"meshName":{"location":"uri","locationName":"meshName"},"virtualServiceName":{"location":"uri","locationName":"virtualServiceName"}}},"output":{"type":"structure","required":["virtualService"],"members":{"virtualService":{"shape":"S2h"}},"payload":"virtualService"}},"ListMeshes":{"http":{"method":"GET","requestUri":"/v20190125/meshes","responseCode":200},"input":{"type":"structure","members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["meshes"],"members":{"meshes":{"type":"list","member":{"type":"structure","required":["arn","meshName"],"members":{"arn":{},"meshName":{}}}},"nextToken":{}}}},"ListRoutes":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}/virtualRouter/{virtualRouterName}/routes","responseCode":200},"input":{"type":"structure","required":["meshName","virtualRouterName"],"members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"meshName":{"location":"uri","locationName":"meshName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","required":["routes"],"members":{"nextToken":{},"routes":{"type":"list","member":{"type":"structure","required":["arn","meshName","routeName","virtualRouterName"],"members":{"arn":{},"meshName":{},"routeName":{},"virtualRouterName":{}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/v20190125/tags","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"resourceArn":{"location":"querystring","locationName":"resourceArn"}}},"output":{"type":"structure","required":["tags"],"members":{"nextToken":{},"tags":{"shape":"S7"}}}},"ListVirtualNodes":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}/virtualNodes","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"meshName":{"location":"uri","locationName":"meshName"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["virtualNodes"],"members":{"nextToken":{},"virtualNodes":{"type":"list","member":{"type":"structure","required":["arn","meshName","virtualNodeName"],"members":{"arn":{},"meshName":{},"virtualNodeName":{}}}}}}},"ListVirtualRouters":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}/virtualRouters","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"meshName":{"location":"uri","locationName":"meshName"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["virtualRouters"],"members":{"nextToken":{},"virtualRouters":{"type":"list","member":{"type":"structure","required":["arn","meshName","virtualRouterName"],"members":{"arn":{},"meshName":{},"virtualRouterName":{}}}}}}},"ListVirtualServices":{"http":{"method":"GET","requestUri":"/v20190125/meshes/{meshName}/virtualServices","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"limit":{"location":"querystring","locationName":"limit","type":"integer"},"meshName":{"location":"uri","locationName":"meshName"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["virtualServices"],"members":{"nextToken":{},"virtualServices":{"type":"list","member":{"type":"structure","required":["arn","meshName","virtualServiceName"],"members":{"arn":{},"meshName":{},"virtualServiceName":{}}}}}}},"TagResource":{"http":{"method":"PUT","requestUri":"/v20190125/tag","responseCode":200},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"tags":{"shape":"S7"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UntagResource":{"http":{"method":"PUT","requestUri":"/v20190125/untag","responseCode":200},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateMesh":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}","responseCode":200},"input":{"type":"structure","required":["meshName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"spec":{"shape":"S4"}}},"output":{"type":"structure","required":["mesh"],"members":{"mesh":{"shape":"Sc"}},"payload":"mesh"},"idempotent":true},"UpdateRoute":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}/virtualRouter/{virtualRouterName}/routes/{routeName}","responseCode":200},"input":{"type":"structure","required":["meshName","routeName","spec","virtualRouterName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"routeName":{"location":"uri","locationName":"routeName"},"spec":{"shape":"Sk"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","required":["route"],"members":{"route":{"shape":"S14"}},"payload":"route"},"idempotent":true},"UpdateVirtualNode":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}/virtualNodes/{virtualNodeName}","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualNodeName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"spec":{"shape":"S18"},"virtualNodeName":{"location":"uri","locationName":"virtualNodeName"}}},"output":{"type":"structure","required":["virtualNode"],"members":{"virtualNode":{"shape":"S20"}},"payload":"virtualNode"},"idempotent":true},"UpdateVirtualRouter":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}/virtualRouters/{virtualRouterName}","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualRouterName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"spec":{"shape":"S24"},"virtualRouterName":{"location":"uri","locationName":"virtualRouterName"}}},"output":{"type":"structure","required":["virtualRouter"],"members":{"virtualRouter":{"shape":"S28"}},"payload":"virtualRouter"},"idempotent":true},"UpdateVirtualService":{"http":{"method":"PUT","requestUri":"/v20190125/meshes/{meshName}/virtualServices/{virtualServiceName}","responseCode":200},"input":{"type":"structure","required":["meshName","spec","virtualServiceName"],"members":{"clientToken":{"idempotencyToken":true},"meshName":{"location":"uri","locationName":"meshName"},"spec":{"shape":"S2c"},"virtualServiceName":{"location":"uri","locationName":"virtualServiceName"}}},"output":{"type":"structure","required":["virtualService"],"members":{"virtualService":{"shape":"S2h"}},"payload":"virtualService"},"idempotent":true}},"shapes":{"S4":{"type":"structure","members":{"egressFilter":{"type":"structure","required":["type"],"members":{"type":{}}}}},"S7":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}}},"Sc":{"type":"structure","required":["meshName","metadata","spec","status"],"members":{"meshName":{},"metadata":{"shape":"Sd"},"spec":{"shape":"S4"},"status":{"type":"structure","members":{"status":{}}}}},"Sd":{"type":"structure","required":["arn","createdAt","lastUpdatedAt","uid","version"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"uid":{},"version":{"type":"long"}}},"Sk":{"type":"structure","members":{"httpRoute":{"type":"structure","required":["action","match"],"members":{"action":{"type":"structure","required":["weightedTargets"],"members":{"weightedTargets":{"shape":"Sn"}}},"match":{"type":"structure","required":["prefix"],"members":{"headers":{"type":"list","member":{"type":"structure","required":["name"],"members":{"invert":{"type":"boolean"},"match":{"type":"structure","members":{"exact":{},"prefix":{},"range":{"type":"structure","required":["end","start"],"members":{"end":{"type":"long"},"start":{"type":"long"}}},"regex":{},"suffix":{}}},"name":{}}}},"method":{},"prefix":{},"scheme":{}}}}},"priority":{"type":"integer"},"tcpRoute":{"type":"structure","required":["action"],"members":{"action":{"type":"structure","required":["weightedTargets"],"members":{"weightedTargets":{"shape":"Sn"}}}}}}},"Sn":{"type":"list","member":{"type":"structure","required":["virtualNode","weight"],"members":{"virtualNode":{},"weight":{"type":"integer"}}}},"S14":{"type":"structure","required":["meshName","metadata","routeName","spec","status","virtualRouterName"],"members":{"meshName":{},"metadata":{"shape":"Sd"},"routeName":{},"spec":{"shape":"Sk"},"status":{"type":"structure","required":["status"],"members":{"status":{}}},"virtualRouterName":{}}},"S18":{"type":"structure","members":{"backends":{"type":"list","member":{"type":"structure","members":{"virtualService":{"type":"structure","required":["virtualServiceName"],"members":{"virtualServiceName":{}}}}}},"listeners":{"type":"list","member":{"type":"structure","required":["portMapping"],"members":{"healthCheck":{"type":"structure","required":["healthyThreshold","intervalMillis","protocol","timeoutMillis","unhealthyThreshold"],"members":{"healthyThreshold":{"type":"integer"},"intervalMillis":{"type":"long"},"path":{},"port":{"type":"integer"},"protocol":{},"timeoutMillis":{"type":"long"},"unhealthyThreshold":{"type":"integer"}}},"portMapping":{"shape":"S1l"}}}},"logging":{"type":"structure","members":{"accessLog":{"type":"structure","members":{"file":{"type":"structure","required":["path"],"members":{"path":{}}}}}}},"serviceDiscovery":{"type":"structure","members":{"awsCloudMap":{"type":"structure","required":["namespaceName","serviceName"],"members":{"attributes":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"namespaceName":{},"serviceName":{}}},"dns":{"type":"structure","required":["hostname"],"members":{"hostname":{}}}}}}},"S1l":{"type":"structure","required":["port","protocol"],"members":{"port":{"type":"integer"},"protocol":{}}},"S20":{"type":"structure","required":["meshName","metadata","spec","status","virtualNodeName"],"members":{"meshName":{},"metadata":{"shape":"Sd"},"spec":{"shape":"S18"},"status":{"type":"structure","required":["status"],"members":{"status":{}}},"virtualNodeName":{}}},"S24":{"type":"structure","members":{"listeners":{"type":"list","member":{"type":"structure","required":["portMapping"],"members":{"portMapping":{"shape":"S1l"}}}}}},"S28":{"type":"structure","required":["meshName","metadata","spec","status","virtualRouterName"],"members":{"meshName":{},"metadata":{"shape":"Sd"},"spec":{"shape":"S24"},"status":{"type":"structure","required":["status"],"members":{"status":{}}},"virtualRouterName":{}}},"S2c":{"type":"structure","members":{"provider":{"type":"structure","members":{"virtualNode":{"type":"structure","required":["virtualNodeName"],"members":{"virtualNodeName":{}}},"virtualRouter":{"type":"structure","required":["virtualRouterName"],"members":{"virtualRouterName":{}}}}}}},"S2h":{"type":"structure","required":["meshName","metadata","spec","status","virtualServiceName"],"members":{"meshName":{},"metadata":{"shape":"Sd"},"spec":{"shape":"S2c"},"status":{"type":"structure","required":["status"],"members":{"status":{}}},"virtualServiceName":{}}}}}');

});

parcelRequire.register("lIW81", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListMeshes":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"meshes"},"ListRoutes":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"routes"},"ListTagsForResource":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"tags"},"ListVirtualNodes":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"virtualNodes"},"ListVirtualRouters":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"virtualRouters"},"ListVirtualServices":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"virtualServices"}}}');

});


parcelRequire.register("6SiC5", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $5016397456165765$var$Service = $dbC7k.Service;
var $5016397456165765$var$apiLoader = $dbC7k.apiLoader;
$5016397456165765$var$apiLoader.services["licensemanager"] = {};
$dbC7k.LicenseManager = $5016397456165765$var$Service.defineService("licensemanager", [
    "2018-08-01"
]);


Object.defineProperty($5016397456165765$var$apiLoader.services["licensemanager"], "2018-08-01", {
    get: function get() {
        var model = (parcelRequire("i8M7c"));
        model.paginators = (parcelRequire("1jQeG")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.LicenseManager;

});
parcelRequire.register("i8M7c", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-08-01","endpointPrefix":"license-manager","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS License Manager","serviceId":"License Manager","signatureVersion":"v4","targetPrefix":"AWSLicenseManager","uid":"license-manager-2018-08-01"},"operations":{"CreateLicenseConfiguration":{"input":{"type":"structure","required":["Name","LicenseCountingType"],"members":{"Name":{},"Description":{},"LicenseCountingType":{},"LicenseCount":{"type":"long"},"LicenseCountHardLimit":{"type":"boolean"},"LicenseRules":{"shape":"S6"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"LicenseConfigurationArn":{}}}},"DeleteLicenseConfiguration":{"input":{"type":"structure","required":["LicenseConfigurationArn"],"members":{"LicenseConfigurationArn":{}}},"output":{"type":"structure","members":{}}},"GetLicenseConfiguration":{"input":{"type":"structure","required":["LicenseConfigurationArn"],"members":{"LicenseConfigurationArn":{}}},"output":{"type":"structure","members":{"LicenseConfigurationId":{},"LicenseConfigurationArn":{},"Name":{},"Description":{},"LicenseCountingType":{},"LicenseRules":{"shape":"S6"},"LicenseCount":{"type":"long"},"LicenseCountHardLimit":{"type":"boolean"},"ConsumedLicenses":{"type":"long"},"Status":{},"OwnerAccountId":{},"ConsumedLicenseSummaryList":{"shape":"Se"},"ManagedResourceSummaryList":{"shape":"Sh"},"Tags":{"shape":"S7"}}}},"GetServiceSettings":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"S3BucketArn":{},"SnsTopicArn":{},"OrganizationConfiguration":{"shape":"Sl"},"EnableCrossAccountsDiscovery":{"type":"boolean"}}}},"ListAssociationsForLicenseConfiguration":{"input":{"type":"structure","required":["LicenseConfigurationArn"],"members":{"LicenseConfigurationArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"LicenseConfigurationAssociations":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{},"ResourceType":{},"ResourceOwnerId":{},"AssociationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListLicenseConfigurations":{"input":{"type":"structure","members":{"LicenseConfigurationArns":{"shape":"S6"},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Su"}}},"output":{"type":"structure","members":{"LicenseConfigurations":{"type":"list","member":{"type":"structure","members":{"LicenseConfigurationId":{},"LicenseConfigurationArn":{},"Name":{},"Description":{},"LicenseCountingType":{},"LicenseRules":{"shape":"S6"},"LicenseCount":{"type":"long"},"LicenseCountHardLimit":{"type":"boolean"},"ConsumedLicenses":{"type":"long"},"Status":{},"OwnerAccountId":{},"ConsumedLicenseSummaryList":{"shape":"Se"},"ManagedResourceSummaryList":{"shape":"Sh"}}}},"NextToken":{}}}},"ListLicenseSpecificationsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"LicenseSpecifications":{"shape":"S14"},"NextToken":{}}}},"ListResourceInventory":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Condition"],"members":{"Name":{},"Condition":{},"Value":{}}}}}},"output":{"type":"structure","members":{"ResourceInventoryList":{"type":"list","member":{"type":"structure","members":{"ResourceId":{},"ResourceType":{},"ResourceArn":{},"Platform":{},"PlatformVersion":{},"ResourceOwningAccountId":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S7"}}}},"ListUsageForLicenseConfiguration":{"input":{"type":"structure","required":["LicenseConfigurationArn"],"members":{"LicenseConfigurationArn":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Su"}}},"output":{"type":"structure","members":{"LicenseConfigurationUsageList":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{},"ResourceType":{},"ResourceStatus":{},"ResourceOwnerId":{},"AssociationTime":{"type":"timestamp"},"ConsumedLicenses":{"type":"long"}}}},"NextToken":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateLicenseConfiguration":{"input":{"type":"structure","required":["LicenseConfigurationArn"],"members":{"LicenseConfigurationArn":{},"LicenseConfigurationStatus":{},"LicenseRules":{"shape":"S6"},"LicenseCount":{"type":"long"},"LicenseCountHardLimit":{"type":"boolean"},"Name":{},"Description":{}}},"output":{"type":"structure","members":{}}},"UpdateLicenseSpecificationsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"AddLicenseSpecifications":{"shape":"S14"},"RemoveLicenseSpecifications":{"shape":"S14"}}},"output":{"type":"structure","members":{}}},"UpdateServiceSettings":{"input":{"type":"structure","members":{"S3BucketArn":{},"SnsTopicArn":{},"OrganizationConfiguration":{"shape":"Sl"},"EnableCrossAccountsDiscovery":{"type":"boolean"}}},"output":{"type":"structure","members":{}}}},"shapes":{"S6":{"type":"list","member":{}},"S7":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Se":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ConsumedLicenses":{"type":"long"}}}},"Sh":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"AssociationCount":{"type":"long"}}}},"Sl":{"type":"structure","required":["EnableIntegration"],"members":{"EnableIntegration":{"type":"boolean"}}},"Su":{"type":"list","member":{"type":"structure","members":{"Name":{},"Values":{"type":"list","member":{}}}}},"S14":{"type":"list","member":{"type":"structure","required":["LicenseConfigurationArn"],"members":{"LicenseConfigurationArn":{}}}}}}');

});

parcelRequire.register("1jQeG", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("2L4Zo", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $2023d751bbe3c3c6$var$Service = $dbC7k.Service;
var $2023d751bbe3c3c6$var$apiLoader = $dbC7k.apiLoader;
$2023d751bbe3c3c6$var$apiLoader.services["kafka"] = {};
$dbC7k.Kafka = $2023d751bbe3c3c6$var$Service.defineService("kafka", [
    "2018-11-14"
]);


Object.defineProperty($2023d751bbe3c3c6$var$apiLoader.services["kafka"], "2018-11-14", {
    get: function get() {
        var model = (parcelRequire("kinIZ"));
        model.paginators = (parcelRequire("djNR7")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Kafka;

});
parcelRequire.register("kinIZ", function(module, exports) {
module.exports = JSON.parse('{"metadata":{"apiVersion":"2018-11-14","endpointPrefix":"kafka","signingName":"kafka","serviceFullName":"Managed Streaming for Kafka","serviceAbbreviation":"Kafka","serviceId":"Kafka","protocol":"rest-json","jsonVersion":"1.1","uid":"kafka-2018-11-14","signatureVersion":"v4"},"operations":{"CreateCluster":{"http":{"requestUri":"/v1/clusters","responseCode":200},"input":{"type":"structure","members":{"BrokerNodeGroupInfo":{"shape":"S2","locationName":"brokerNodeGroupInfo"},"ClientAuthentication":{"shape":"Sa","locationName":"clientAuthentication"},"ClusterName":{"locationName":"clusterName"},"ConfigurationInfo":{"shape":"Sd","locationName":"configurationInfo"},"EncryptionInfo":{"shape":"Sf","locationName":"encryptionInfo"},"EnhancedMonitoring":{"locationName":"enhancedMonitoring"},"KafkaVersion":{"locationName":"kafkaVersion"},"NumberOfBrokerNodes":{"locationName":"numberOfBrokerNodes","type":"integer"},"Tags":{"shape":"Sn","locationName":"tags"}},"required":["BrokerNodeGroupInfo","KafkaVersion","NumberOfBrokerNodes","ClusterName"]},"output":{"type":"structure","members":{"ClusterArn":{"locationName":"clusterArn"},"ClusterName":{"locationName":"clusterName"},"State":{"locationName":"state"}}}},"CreateConfiguration":{"http":{"requestUri":"/v1/configurations","responseCode":200},"input":{"type":"structure","members":{"Description":{"locationName":"description"},"KafkaVersions":{"shape":"S4","locationName":"kafkaVersions"},"Name":{"locationName":"name"},"ServerProperties":{"locationName":"serverProperties","type":"blob"}},"required":["ServerProperties","KafkaVersions","Name"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"CreationTime":{"shape":"St","locationName":"creationTime"},"LatestRevision":{"shape":"Su","locationName":"latestRevision"},"Name":{"locationName":"name"}}}},"DeleteCluster":{"http":{"method":"DELETE","requestUri":"/v1/clusters/{clusterArn}","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"},"CurrentVersion":{"location":"querystring","locationName":"currentVersion"}},"required":["ClusterArn"]},"output":{"type":"structure","members":{"ClusterArn":{"locationName":"clusterArn"},"State":{"locationName":"state"}}}},"DescribeCluster":{"http":{"method":"GET","requestUri":"/v1/clusters/{clusterArn}","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"}},"required":["ClusterArn"]},"output":{"type":"structure","members":{"ClusterInfo":{"shape":"Sz","locationName":"clusterInfo"}}}},"DescribeClusterOperation":{"http":{"method":"GET","requestUri":"/v1/operations/{clusterOperationArn}","responseCode":200},"input":{"type":"structure","members":{"ClusterOperationArn":{"location":"uri","locationName":"clusterOperationArn"}},"required":["ClusterOperationArn"]},"output":{"type":"structure","members":{"ClusterOperationInfo":{"shape":"S14","locationName":"clusterOperationInfo"}}}},"DescribeConfiguration":{"http":{"method":"GET","requestUri":"/v1/configurations/{arn}","responseCode":200},"input":{"type":"structure","members":{"Arn":{"location":"uri","locationName":"arn"}},"required":["Arn"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"CreationTime":{"shape":"St","locationName":"creationTime"},"Description":{"locationName":"description"},"KafkaVersions":{"shape":"S4","locationName":"kafkaVersions"},"LatestRevision":{"shape":"Su","locationName":"latestRevision"},"Name":{"locationName":"name"}}}},"DescribeConfigurationRevision":{"http":{"method":"GET","requestUri":"/v1/configurations/{arn}/revisions/{revision}","responseCode":200},"input":{"type":"structure","members":{"Arn":{"location":"uri","locationName":"arn"},"Revision":{"location":"uri","locationName":"revision","type":"long"}},"required":["Revision","Arn"]},"output":{"type":"structure","members":{"Arn":{"locationName":"arn"},"CreationTime":{"shape":"St","locationName":"creationTime"},"Description":{"locationName":"description"},"Revision":{"locationName":"revision","type":"long"},"ServerProperties":{"locationName":"serverProperties","type":"blob"}}}},"GetBootstrapBrokers":{"http":{"method":"GET","requestUri":"/v1/clusters/{clusterArn}/bootstrap-brokers","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"}},"required":["ClusterArn"]},"output":{"type":"structure","members":{"BootstrapBrokerString":{"locationName":"bootstrapBrokerString"},"BootstrapBrokerStringTls":{"locationName":"bootstrapBrokerStringTls"}}}},"ListClusterOperations":{"http":{"method":"GET","requestUri":"/v1/clusters/{clusterArn}/operations","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ClusterArn"]},"output":{"type":"structure","members":{"ClusterOperationInfoList":{"locationName":"clusterOperationInfoList","type":"list","member":{"shape":"S14"}},"NextToken":{"locationName":"nextToken"}}}},"ListClusters":{"http":{"method":"GET","requestUri":"/v1/clusters","responseCode":200},"input":{"type":"structure","members":{"ClusterNameFilter":{"location":"querystring","locationName":"clusterNameFilter"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"ClusterInfoList":{"locationName":"clusterInfoList","type":"list","member":{"shape":"Sz"}},"NextToken":{"locationName":"nextToken"}}}},"ListConfigurationRevisions":{"http":{"method":"GET","requestUri":"/v1/configurations/{arn}/revisions","responseCode":200},"input":{"type":"structure","members":{"Arn":{"location":"uri","locationName":"arn"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["Arn"]},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Revisions":{"locationName":"revisions","type":"list","member":{"shape":"Su"}}}}},"ListConfigurations":{"http":{"method":"GET","requestUri":"/v1/configurations","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Configurations":{"locationName":"configurations","type":"list","member":{"type":"structure","members":{"Arn":{"locationName":"arn"},"CreationTime":{"shape":"St","locationName":"creationTime"},"Description":{"locationName":"description"},"KafkaVersions":{"shape":"S4","locationName":"kafkaVersions"},"LatestRevision":{"shape":"Su","locationName":"latestRevision"},"Name":{"locationName":"name"}},"required":["Description","LatestRevision","CreationTime","KafkaVersions","Arn","Name"]}},"NextToken":{"locationName":"nextToken"}}}},"ListNodes":{"http":{"method":"GET","requestUri":"/v1/clusters/{clusterArn}/nodes","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ClusterArn"]},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"NodeInfoList":{"locationName":"nodeInfoList","type":"list","member":{"type":"structure","members":{"AddedToClusterTime":{"locationName":"addedToClusterTime"},"BrokerNodeInfo":{"locationName":"brokerNodeInfo","type":"structure","members":{"AttachedENIId":{"locationName":"attachedENIId"},"BrokerId":{"locationName":"brokerId","type":"double"},"ClientSubnet":{"locationName":"clientSubnet"},"ClientVpcIpAddress":{"locationName":"clientVpcIpAddress"},"CurrentBrokerSoftwareInfo":{"shape":"S10","locationName":"currentBrokerSoftwareInfo"},"Endpoints":{"shape":"S4","locationName":"endpoints"}}},"InstanceType":{"locationName":"instanceType"},"NodeARN":{"locationName":"nodeARN"},"NodeType":{"locationName":"nodeType"},"ZookeeperNodeInfo":{"locationName":"zookeeperNodeInfo","type":"structure","members":{"AttachedENIId":{"locationName":"attachedENIId"},"ClientVpcIpAddress":{"locationName":"clientVpcIpAddress"},"Endpoints":{"shape":"S4","locationName":"endpoints"},"ZookeeperId":{"locationName":"zookeeperId","type":"double"},"ZookeeperVersion":{"locationName":"zookeeperVersion"}}}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/v1/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{"Tags":{"shape":"Sn","locationName":"tags"}}}},"TagResource":{"http":{"requestUri":"/v1/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"Tags":{"shape":"Sn","locationName":"tags"}},"required":["ResourceArn","Tags"]}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/v1/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"TagKeys":{"shape":"S4","location":"querystring","locationName":"tagKeys"}},"required":["TagKeys","ResourceArn"]}},"UpdateBrokerStorage":{"http":{"method":"PUT","requestUri":"/v1/clusters/{clusterArn}/nodes/storage","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"},"CurrentVersion":{"locationName":"currentVersion"},"TargetBrokerEBSVolumeInfo":{"shape":"S17","locationName":"targetBrokerEBSVolumeInfo"}},"required":["ClusterArn","TargetBrokerEBSVolumeInfo","CurrentVersion"]},"output":{"type":"structure","members":{"ClusterArn":{"locationName":"clusterArn"},"ClusterOperationArn":{"locationName":"clusterOperationArn"}}}},"UpdateClusterConfiguration":{"http":{"method":"PUT","requestUri":"/v1/clusters/{clusterArn}/configuration","responseCode":200},"input":{"type":"structure","members":{"ClusterArn":{"location":"uri","locationName":"clusterArn"},"ConfigurationInfo":{"shape":"Sd","locationName":"configurationInfo"},"CurrentVersion":{"locationName":"currentVersion"}},"required":["ClusterArn","CurrentVersion","ConfigurationInfo"]},"output":{"type":"structure","members":{"ClusterArn":{"locationName":"clusterArn"},"ClusterOperationArn":{"locationName":"clusterOperationArn"}}}}},"shapes":{"S2":{"type":"structure","members":{"BrokerAZDistribution":{"locationName":"brokerAZDistribution"},"ClientSubnets":{"shape":"S4","locationName":"clientSubnets"},"InstanceType":{"locationName":"instanceType"},"SecurityGroups":{"shape":"S4","locationName":"securityGroups"},"StorageInfo":{"locationName":"storageInfo","type":"structure","members":{"EbsStorageInfo":{"locationName":"ebsStorageInfo","type":"structure","members":{"VolumeSize":{"locationName":"volumeSize","type":"integer"}}}}}},"required":["ClientSubnets","InstanceType"]},"S4":{"type":"list","member":{}},"Sa":{"type":"structure","members":{"Tls":{"locationName":"tls","type":"structure","members":{"CertificateAuthorityArnList":{"shape":"S4","locationName":"certificateAuthorityArnList"}}}}},"Sd":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Revision":{"locationName":"revision","type":"long"}},"required":["Revision","Arn"]},"Sf":{"type":"structure","members":{"EncryptionAtRest":{"locationName":"encryptionAtRest","type":"structure","members":{"DataVolumeKMSKeyId":{"locationName":"dataVolumeKMSKeyId"}},"required":["DataVolumeKMSKeyId"]},"EncryptionInTransit":{"locationName":"encryptionInTransit","type":"structure","members":{"ClientBroker":{"locationName":"clientBroker"},"InCluster":{"locationName":"inCluster","type":"boolean"}}}}},"Sn":{"type":"map","key":{},"value":{}},"St":{"type":"timestamp","timestampFormat":"iso8601"},"Su":{"type":"structure","members":{"CreationTime":{"shape":"St","locationName":"creationTime"},"Description":{"locationName":"description"},"Revision":{"locationName":"revision","type":"long"}},"required":["Revision","CreationTime"]},"Sz":{"type":"structure","members":{"ActiveOperationArn":{"locationName":"activeOperationArn"},"BrokerNodeGroupInfo":{"shape":"S2","locationName":"brokerNodeGroupInfo"},"ClientAuthentication":{"shape":"Sa","locationName":"clientAuthentication"},"ClusterArn":{"locationName":"clusterArn"},"ClusterName":{"locationName":"clusterName"},"CreationTime":{"shape":"St","locationName":"creationTime"},"CurrentBrokerSoftwareInfo":{"shape":"S10","locationName":"currentBrokerSoftwareInfo"},"CurrentVersion":{"locationName":"currentVersion"},"EncryptionInfo":{"shape":"Sf","locationName":"encryptionInfo"},"EnhancedMonitoring":{"locationName":"enhancedMonitoring"},"NumberOfBrokerNodes":{"locationName":"numberOfBrokerNodes","type":"integer"},"State":{"locationName":"state"},"Tags":{"shape":"Sn","locationName":"tags"},"ZookeeperConnectString":{"locationName":"zookeeperConnectString"}}},"S10":{"type":"structure","members":{"ConfigurationArn":{"locationName":"configurationArn"},"ConfigurationRevision":{"locationName":"configurationRevision","type":"long"},"KafkaVersion":{"locationName":"kafkaVersion"}}},"S14":{"type":"structure","members":{"ClientRequestId":{"locationName":"clientRequestId"},"ClusterArn":{"locationName":"clusterArn"},"CreationTime":{"shape":"St","locationName":"creationTime"},"EndTime":{"shape":"St","locationName":"endTime"},"ErrorInfo":{"locationName":"errorInfo","type":"structure","members":{"ErrorCode":{"locationName":"errorCode"},"ErrorString":{"locationName":"errorString"}}},"OperationArn":{"locationName":"operationArn"},"OperationState":{"locationName":"operationState"},"OperationType":{"locationName":"operationType"},"SourceClusterInfo":{"shape":"S16","locationName":"sourceClusterInfo"},"TargetClusterInfo":{"shape":"S16","locationName":"targetClusterInfo"}}},"S16":{"type":"structure","members":{"BrokerEBSVolumeInfo":{"shape":"S17","locationName":"brokerEBSVolumeInfo"},"ConfigurationInfo":{"shape":"Sd","locationName":"configurationInfo"},"NumberOfBrokerNodes":{"locationName":"numberOfBrokerNodes","type":"integer"}}},"S17":{"type":"list","member":{"type":"structure","members":{"KafkaBrokerNodeId":{"locationName":"kafkaBrokerNodeId"},"VolumeSizeGB":{"locationName":"volumeSizeGB","type":"integer"}},"required":["VolumeSizeGB","KafkaBrokerNodeId"]}}}}');

});

parcelRequire.register("djNR7", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListClusters":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ClusterInfoList"},"ListConfigurations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Configurations"},"ListNodes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"NodeInfoList"},"ListClusterOperations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ClusterOperationInfoList"},"ListConfigurationRevisions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Revisions"}}}');

});


parcelRequire.register("3h5GF", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $26275efe1b049af4$var$Service = $dbC7k.Service;
var $26275efe1b049af4$var$apiLoader = $dbC7k.apiLoader;
$26275efe1b049af4$var$apiLoader.services["apigatewaymanagementapi"] = {};
$dbC7k.ApiGatewayManagementApi = $26275efe1b049af4$var$Service.defineService("apigatewaymanagementapi", [
    "2018-11-29"
]);


Object.defineProperty($26275efe1b049af4$var$apiLoader.services["apigatewaymanagementapi"], "2018-11-29", {
    get: function get() {
        var model = (parcelRequire("96bx4"));
        model.paginators = (parcelRequire("gBXzh")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ApiGatewayManagementApi;

});
parcelRequire.register("96bx4", function(module, exports) {
module.exports = JSON.parse('{"metadata":{"apiVersion":"2018-11-29","endpointPrefix":"execute-api","signingName":"execute-api","serviceFullName":"AmazonApiGatewayManagementApi","serviceId":"ApiGatewayManagementApi","protocol":"rest-json","jsonVersion":"1.1","uid":"apigatewaymanagementapi-2018-11-29","signatureVersion":"v4"},"operations":{"PostToConnection":{"http":{"requestUri":"/@connections/{connectionId}","responseCode":200},"input":{"type":"structure","members":{"Data":{"type":"blob"},"ConnectionId":{"location":"uri","locationName":"connectionId"}},"required":["ConnectionId","Data"],"payload":"Data"}}},"shapes":{}}');

});

parcelRequire.register("gBXzh", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("kJOLS", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $f18f64b3e891a491$var$Service = $dbC7k.Service;
var $f18f64b3e891a491$var$apiLoader = $dbC7k.apiLoader;
$f18f64b3e891a491$var$apiLoader.services["apigatewayv2"] = {};
$dbC7k.ApiGatewayV2 = $f18f64b3e891a491$var$Service.defineService("apigatewayv2", [
    "2018-11-29"
]);


Object.defineProperty($f18f64b3e891a491$var$apiLoader.services["apigatewayv2"], "2018-11-29", {
    get: function get() {
        var model = (parcelRequire("3QMKO"));
        model.paginators = (parcelRequire("iAxlP")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ApiGatewayV2;

});
parcelRequire.register("3QMKO", function(module, exports) {
module.exports = JSON.parse('{"metadata":{"apiVersion":"2018-11-29","endpointPrefix":"apigateway","signingName":"apigateway","serviceFullName":"AmazonApiGatewayV2","serviceId":"ApiGatewayV2","protocol":"rest-json","jsonVersion":"1.1","uid":"apigatewayv2-2018-11-29","signatureVersion":"v4"},"operations":{"CreateApi":{"http":{"requestUri":"/v2/apis","responseCode":201},"input":{"type":"structure","members":{"ApiKeySelectionExpression":{"locationName":"apiKeySelectionExpression"},"Description":{"locationName":"description"},"DisableSchemaValidation":{"locationName":"disableSchemaValidation","type":"boolean"},"Name":{"locationName":"name"},"ProtocolType":{"locationName":"protocolType"},"RouteSelectionExpression":{"locationName":"routeSelectionExpression"},"Version":{"locationName":"version"},"Tags":{"shape":"S8","locationName":"tags"}},"required":["RouteSelectionExpression","ProtocolType","Name"]},"output":{"type":"structure","members":{"ApiEndpoint":{"locationName":"apiEndpoint"},"ApiId":{"locationName":"apiId"},"ApiKeySelectionExpression":{"locationName":"apiKeySelectionExpression"},"CreatedDate":{"shape":"Sd","locationName":"createdDate"},"Description":{"locationName":"description"},"DisableSchemaValidation":{"locationName":"disableSchemaValidation","type":"boolean"},"Name":{"locationName":"name"},"ProtocolType":{"locationName":"protocolType"},"RouteSelectionExpression":{"locationName":"routeSelectionExpression"},"Version":{"locationName":"version"},"Warnings":{"shape":"Se","locationName":"warnings"},"Tags":{"shape":"S8","locationName":"tags"}}}},"CreateApiMapping":{"http":{"requestUri":"/v2/domainnames/{domainName}/apimappings","responseCode":201},"input":{"type":"structure","members":{"ApiId":{"locationName":"apiId"},"ApiMappingKey":{"locationName":"apiMappingKey"},"DomainName":{"location":"uri","locationName":"domainName"},"Stage":{"locationName":"stage"}},"required":["DomainName","Stage","ApiId"]},"output":{"type":"structure","members":{"ApiId":{"locationName":"apiId"},"ApiMappingId":{"locationName":"apiMappingId"},"ApiMappingKey":{"locationName":"apiMappingKey"},"Stage":{"locationName":"stage"}}}},"CreateAuthorizer":{"http":{"requestUri":"/v2/apis/{apiId}/authorizers","responseCode":201},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"AuthorizerCredentialsArn":{"locationName":"authorizerCredentialsArn"},"AuthorizerResultTtlInSeconds":{"locationName":"authorizerResultTtlInSeconds","type":"integer"},"AuthorizerType":{"locationName":"authorizerType"},"AuthorizerUri":{"locationName":"authorizerUri"},"IdentitySource":{"shape":"Sn","locationName":"identitySource"},"IdentityValidationExpression":{"locationName":"identityValidationExpression"},"Name":{"locationName":"name"},"ProviderArns":{"shape":"So","locationName":"providerArns"}},"required":["ApiId","AuthorizerUri","AuthorizerType","IdentitySource","Name"]},"output":{"type":"structure","members":{"AuthorizerCredentialsArn":{"locationName":"authorizerCredentialsArn"},"AuthorizerId":{"locationName":"authorizerId"},"AuthorizerResultTtlInSeconds":{"locationName":"authorizerResultTtlInSeconds","type":"integer"},"AuthorizerType":{"locationName":"authorizerType"},"AuthorizerUri":{"locationName":"authorizerUri"},"IdentitySource":{"shape":"Sn","locationName":"identitySource"},"IdentityValidationExpression":{"locationName":"identityValidationExpression"},"Name":{"locationName":"name"},"ProviderArns":{"shape":"So","locationName":"providerArns"}}}},"CreateDeployment":{"http":{"requestUri":"/v2/apis/{apiId}/deployments","responseCode":201},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"Description":{"locationName":"description"},"StageName":{"locationName":"stageName"}},"required":["ApiId"]},"output":{"type":"structure","members":{"CreatedDate":{"shape":"Sd","locationName":"createdDate"},"DeploymentId":{"locationName":"deploymentId"},"DeploymentStatus":{"locationName":"deploymentStatus"},"DeploymentStatusMessage":{"locationName":"deploymentStatusMessage"},"Description":{"locationName":"description"}}}},"CreateDomainName":{"http":{"requestUri":"/v2/domainnames","responseCode":201},"input":{"type":"structure","members":{"DomainName":{"locationName":"domainName"},"DomainNameConfigurations":{"shape":"Sv","locationName":"domainNameConfigurations"},"Tags":{"shape":"S8","locationName":"tags"}},"required":["DomainName"]},"output":{"type":"structure","members":{"ApiMappingSelectionExpression":{"locationName":"apiMappingSelectionExpression"},"DomainName":{"locationName":"domainName"},"DomainNameConfigurations":{"shape":"Sv","locationName":"domainNameConfigurations"},"Tags":{"shape":"S8","locationName":"tags"}}}},"CreateIntegration":{"http":{"requestUri":"/v2/apis/{apiId}/integrations","responseCode":201},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ConnectionId":{"locationName":"connectionId"},"ConnectionType":{"locationName":"connectionType"},"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"CredentialsArn":{"locationName":"credentialsArn"},"Description":{"locationName":"description"},"IntegrationMethod":{"locationName":"integrationMethod"},"IntegrationType":{"locationName":"integrationType"},"IntegrationUri":{"locationName":"integrationUri"},"PassthroughBehavior":{"locationName":"passthroughBehavior"},"RequestParameters":{"shape":"S17","locationName":"requestParameters"},"RequestTemplates":{"shape":"S18","locationName":"requestTemplates"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"},"TimeoutInMillis":{"locationName":"timeoutInMillis","type":"integer"}},"required":["ApiId","IntegrationType"]},"output":{"type":"structure","members":{"ConnectionId":{"locationName":"connectionId"},"ConnectionType":{"locationName":"connectionType"},"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"CredentialsArn":{"locationName":"credentialsArn"},"Description":{"locationName":"description"},"IntegrationId":{"locationName":"integrationId"},"IntegrationMethod":{"locationName":"integrationMethod"},"IntegrationResponseSelectionExpression":{"locationName":"integrationResponseSelectionExpression"},"IntegrationType":{"locationName":"integrationType"},"IntegrationUri":{"locationName":"integrationUri"},"PassthroughBehavior":{"locationName":"passthroughBehavior"},"RequestParameters":{"shape":"S17","locationName":"requestParameters"},"RequestTemplates":{"shape":"S18","locationName":"requestTemplates"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"},"TimeoutInMillis":{"locationName":"timeoutInMillis","type":"integer"}}}},"CreateIntegrationResponse":{"http":{"requestUri":"/v2/apis/{apiId}/integrations/{integrationId}/integrationresponses","responseCode":201},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"IntegrationId":{"location":"uri","locationName":"integrationId"},"IntegrationResponseKey":{"locationName":"integrationResponseKey"},"ResponseParameters":{"shape":"S17","locationName":"responseParameters"},"ResponseTemplates":{"shape":"S18","locationName":"responseTemplates"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"}},"required":["ApiId","IntegrationId","IntegrationResponseKey"]},"output":{"type":"structure","members":{"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"IntegrationResponseId":{"locationName":"integrationResponseId"},"IntegrationResponseKey":{"locationName":"integrationResponseKey"},"ResponseParameters":{"shape":"S17","locationName":"responseParameters"},"ResponseTemplates":{"shape":"S18","locationName":"responseTemplates"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"}}}},"CreateModel":{"http":{"requestUri":"/v2/apis/{apiId}/models","responseCode":201},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ContentType":{"locationName":"contentType"},"Description":{"locationName":"description"},"Name":{"locationName":"name"},"Schema":{"locationName":"schema"}},"required":["ApiId","Schema","Name"]},"output":{"type":"structure","members":{"ContentType":{"locationName":"contentType"},"Description":{"locationName":"description"},"ModelId":{"locationName":"modelId"},"Name":{"locationName":"name"},"Schema":{"locationName":"schema"}}}},"CreateRoute":{"http":{"requestUri":"/v2/apis/{apiId}/routes","responseCode":201},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ApiKeyRequired":{"locationName":"apiKeyRequired","type":"boolean"},"AuthorizationScopes":{"shape":"S1i","locationName":"authorizationScopes"},"AuthorizationType":{"locationName":"authorizationType"},"AuthorizerId":{"locationName":"authorizerId"},"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"OperationName":{"locationName":"operationName"},"RequestModels":{"shape":"S1k","locationName":"requestModels"},"RequestParameters":{"shape":"S1l","locationName":"requestParameters"},"RouteKey":{"locationName":"routeKey"},"RouteResponseSelectionExpression":{"locationName":"routeResponseSelectionExpression"},"Target":{"locationName":"target"}},"required":["ApiId","RouteKey"]},"output":{"type":"structure","members":{"ApiKeyRequired":{"locationName":"apiKeyRequired","type":"boolean"},"AuthorizationScopes":{"shape":"S1i","locationName":"authorizationScopes"},"AuthorizationType":{"locationName":"authorizationType"},"AuthorizerId":{"locationName":"authorizerId"},"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"OperationName":{"locationName":"operationName"},"RequestModels":{"shape":"S1k","locationName":"requestModels"},"RequestParameters":{"shape":"S1l","locationName":"requestParameters"},"RouteId":{"locationName":"routeId"},"RouteKey":{"locationName":"routeKey"},"RouteResponseSelectionExpression":{"locationName":"routeResponseSelectionExpression"},"Target":{"locationName":"target"}}}},"CreateRouteResponse":{"http":{"requestUri":"/v2/apis/{apiId}/routes/{routeId}/routeresponses","responseCode":201},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"ResponseModels":{"shape":"S1k","locationName":"responseModels"},"ResponseParameters":{"shape":"S1l","locationName":"responseParameters"},"RouteId":{"location":"uri","locationName":"routeId"},"RouteResponseKey":{"locationName":"routeResponseKey"}},"required":["ApiId","RouteId","RouteResponseKey"]},"output":{"type":"structure","members":{"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"ResponseModels":{"shape":"S1k","locationName":"responseModels"},"ResponseParameters":{"shape":"S1l","locationName":"responseParameters"},"RouteResponseId":{"locationName":"routeResponseId"},"RouteResponseKey":{"locationName":"routeResponseKey"}}}},"CreateStage":{"http":{"requestUri":"/v2/apis/{apiId}/stages","responseCode":201},"input":{"type":"structure","members":{"AccessLogSettings":{"shape":"S1r","locationName":"accessLogSettings"},"ApiId":{"location":"uri","locationName":"apiId"},"ClientCertificateId":{"locationName":"clientCertificateId"},"DefaultRouteSettings":{"shape":"S1s","locationName":"defaultRouteSettings"},"DeploymentId":{"locationName":"deploymentId"},"Description":{"locationName":"description"},"RouteSettings":{"shape":"S1w","locationName":"routeSettings"},"StageName":{"locationName":"stageName"},"StageVariables":{"shape":"S1x","locationName":"stageVariables"},"Tags":{"shape":"S8","locationName":"tags"}},"required":["ApiId","StageName"]},"output":{"type":"structure","members":{"AccessLogSettings":{"shape":"S1r","locationName":"accessLogSettings"},"ClientCertificateId":{"locationName":"clientCertificateId"},"CreatedDate":{"shape":"Sd","locationName":"createdDate"},"DefaultRouteSettings":{"shape":"S1s","locationName":"defaultRouteSettings"},"DeploymentId":{"locationName":"deploymentId"},"Description":{"locationName":"description"},"LastUpdatedDate":{"shape":"Sd","locationName":"lastUpdatedDate"},"RouteSettings":{"shape":"S1w","locationName":"routeSettings"},"StageName":{"locationName":"stageName"},"StageVariables":{"shape":"S1x","locationName":"stageVariables"},"Tags":{"shape":"S8","locationName":"tags"}}}},"DeleteApi":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"}},"required":["ApiId"]}},"DeleteApiMapping":{"http":{"method":"DELETE","requestUri":"/v2/domainnames/{domainName}/apimappings/{apiMappingId}","responseCode":204},"input":{"type":"structure","members":{"ApiMappingId":{"location":"uri","locationName":"apiMappingId"},"DomainName":{"location":"uri","locationName":"domainName"}},"required":["ApiMappingId","DomainName"]}},"DeleteAuthorizer":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}/authorizers/{authorizerId}","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"AuthorizerId":{"location":"uri","locationName":"authorizerId"}},"required":["AuthorizerId","ApiId"]}},"DeleteDeployment":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}/deployments/{deploymentId}","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"DeploymentId":{"location":"uri","locationName":"deploymentId"}},"required":["ApiId","DeploymentId"]}},"DeleteDomainName":{"http":{"method":"DELETE","requestUri":"/v2/domainnames/{domainName}","responseCode":204},"input":{"type":"structure","members":{"DomainName":{"location":"uri","locationName":"domainName"}},"required":["DomainName"]}},"DeleteIntegration":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}/integrations/{integrationId}","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"IntegrationId":{"location":"uri","locationName":"integrationId"}},"required":["ApiId","IntegrationId"]}},"DeleteIntegrationResponse":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}/integrations/{integrationId}/integrationresponses/{integrationResponseId}","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"IntegrationId":{"location":"uri","locationName":"integrationId"},"IntegrationResponseId":{"location":"uri","locationName":"integrationResponseId"}},"required":["ApiId","IntegrationResponseId","IntegrationId"]}},"DeleteModel":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}/models/{modelId}","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ModelId":{"location":"uri","locationName":"modelId"}},"required":["ModelId","ApiId"]}},"DeleteRoute":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}/routes/{routeId}","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"RouteId":{"location":"uri","locationName":"routeId"}},"required":["ApiId","RouteId"]}},"DeleteRouteResponse":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}/routes/{routeId}/routeresponses/{routeResponseId}","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"RouteId":{"location":"uri","locationName":"routeId"},"RouteResponseId":{"location":"uri","locationName":"routeResponseId"}},"required":["RouteResponseId","ApiId","RouteId"]}},"DeleteStage":{"http":{"method":"DELETE","requestUri":"/v2/apis/{apiId}/stages/{stageName}","responseCode":204},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"StageName":{"location":"uri","locationName":"stageName"}},"required":["StageName","ApiId"]}},"GetApi":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"}},"required":["ApiId"]},"output":{"type":"structure","members":{"ApiEndpoint":{"locationName":"apiEndpoint"},"ApiId":{"locationName":"apiId"},"ApiKeySelectionExpression":{"locationName":"apiKeySelectionExpression"},"CreatedDate":{"shape":"Sd","locationName":"createdDate"},"Description":{"locationName":"description"},"DisableSchemaValidation":{"locationName":"disableSchemaValidation","type":"boolean"},"Name":{"locationName":"name"},"ProtocolType":{"locationName":"protocolType"},"RouteSelectionExpression":{"locationName":"routeSelectionExpression"},"Version":{"locationName":"version"},"Warnings":{"shape":"Se","locationName":"warnings"},"Tags":{"shape":"S8","locationName":"tags"}}}},"GetApiMapping":{"http":{"method":"GET","requestUri":"/v2/domainnames/{domainName}/apimappings/{apiMappingId}","responseCode":200},"input":{"type":"structure","members":{"ApiMappingId":{"location":"uri","locationName":"apiMappingId"},"DomainName":{"location":"uri","locationName":"domainName"}},"required":["ApiMappingId","DomainName"]},"output":{"type":"structure","members":{"ApiId":{"locationName":"apiId"},"ApiMappingId":{"locationName":"apiMappingId"},"ApiMappingKey":{"locationName":"apiMappingKey"},"Stage":{"locationName":"stage"}}}},"GetApiMappings":{"http":{"method":"GET","requestUri":"/v2/domainnames/{domainName}/apimappings","responseCode":200},"input":{"type":"structure","members":{"DomainName":{"location":"uri","locationName":"domainName"},"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["DomainName"]},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"ApiId":{"locationName":"apiId"},"ApiMappingId":{"locationName":"apiMappingId"},"ApiMappingKey":{"locationName":"apiMappingKey"},"Stage":{"locationName":"stage"}},"required":["Stage","ApiId"]}},"NextToken":{"locationName":"nextToken"}}}},"GetApis":{"http":{"method":"GET","requestUri":"/v2/apis","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"ApiEndpoint":{"locationName":"apiEndpoint"},"ApiId":{"locationName":"apiId"},"ApiKeySelectionExpression":{"locationName":"apiKeySelectionExpression"},"CreatedDate":{"shape":"Sd","locationName":"createdDate"},"Description":{"locationName":"description"},"DisableSchemaValidation":{"locationName":"disableSchemaValidation","type":"boolean"},"Name":{"locationName":"name"},"ProtocolType":{"locationName":"protocolType"},"RouteSelectionExpression":{"locationName":"routeSelectionExpression"},"Version":{"locationName":"version"},"Warnings":{"shape":"Se","locationName":"warnings"},"Tags":{"shape":"S8","locationName":"tags"}},"required":["RouteSelectionExpression","ProtocolType","Name"]}},"NextToken":{"locationName":"nextToken"}}}},"GetAuthorizer":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/authorizers/{authorizerId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"AuthorizerId":{"location":"uri","locationName":"authorizerId"}},"required":["AuthorizerId","ApiId"]},"output":{"type":"structure","members":{"AuthorizerCredentialsArn":{"locationName":"authorizerCredentialsArn"},"AuthorizerId":{"locationName":"authorizerId"},"AuthorizerResultTtlInSeconds":{"locationName":"authorizerResultTtlInSeconds","type":"integer"},"AuthorizerType":{"locationName":"authorizerType"},"AuthorizerUri":{"locationName":"authorizerUri"},"IdentitySource":{"shape":"Sn","locationName":"identitySource"},"IdentityValidationExpression":{"locationName":"identityValidationExpression"},"Name":{"locationName":"name"},"ProviderArns":{"shape":"So","locationName":"providerArns"}}}},"GetAuthorizers":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/authorizers","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ApiId"]},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"AuthorizerCredentialsArn":{"locationName":"authorizerCredentialsArn"},"AuthorizerId":{"locationName":"authorizerId"},"AuthorizerResultTtlInSeconds":{"locationName":"authorizerResultTtlInSeconds","type":"integer"},"AuthorizerType":{"locationName":"authorizerType"},"AuthorizerUri":{"locationName":"authorizerUri"},"IdentitySource":{"shape":"Sn","locationName":"identitySource"},"IdentityValidationExpression":{"locationName":"identityValidationExpression"},"Name":{"locationName":"name"},"ProviderArns":{"shape":"So","locationName":"providerArns"}},"required":["Name"]}},"NextToken":{"locationName":"nextToken"}}}},"GetDeployment":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/deployments/{deploymentId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"DeploymentId":{"location":"uri","locationName":"deploymentId"}},"required":["ApiId","DeploymentId"]},"output":{"type":"structure","members":{"CreatedDate":{"shape":"Sd","locationName":"createdDate"},"DeploymentId":{"locationName":"deploymentId"},"DeploymentStatus":{"locationName":"deploymentStatus"},"DeploymentStatusMessage":{"locationName":"deploymentStatusMessage"},"Description":{"locationName":"description"}}}},"GetDeployments":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/deployments","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ApiId"]},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"CreatedDate":{"shape":"Sd","locationName":"createdDate"},"DeploymentId":{"locationName":"deploymentId"},"DeploymentStatus":{"locationName":"deploymentStatus"},"DeploymentStatusMessage":{"locationName":"deploymentStatusMessage"},"Description":{"locationName":"description"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetDomainName":{"http":{"method":"GET","requestUri":"/v2/domainnames/{domainName}","responseCode":200},"input":{"type":"structure","members":{"DomainName":{"location":"uri","locationName":"domainName"}},"required":["DomainName"]},"output":{"type":"structure","members":{"ApiMappingSelectionExpression":{"locationName":"apiMappingSelectionExpression"},"DomainName":{"locationName":"domainName"},"DomainNameConfigurations":{"shape":"Sv","locationName":"domainNameConfigurations"},"Tags":{"shape":"S8","locationName":"tags"}}}},"GetDomainNames":{"http":{"method":"GET","requestUri":"/v2/domainnames","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"ApiMappingSelectionExpression":{"locationName":"apiMappingSelectionExpression"},"DomainName":{"locationName":"domainName"},"DomainNameConfigurations":{"shape":"Sv","locationName":"domainNameConfigurations"},"Tags":{"shape":"S8","locationName":"tags"}},"required":["DomainName"]}},"NextToken":{"locationName":"nextToken"}}}},"GetIntegration":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/integrations/{integrationId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"IntegrationId":{"location":"uri","locationName":"integrationId"}},"required":["ApiId","IntegrationId"]},"output":{"type":"structure","members":{"ConnectionId":{"locationName":"connectionId"},"ConnectionType":{"locationName":"connectionType"},"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"CredentialsArn":{"locationName":"credentialsArn"},"Description":{"locationName":"description"},"IntegrationId":{"locationName":"integrationId"},"IntegrationMethod":{"locationName":"integrationMethod"},"IntegrationResponseSelectionExpression":{"locationName":"integrationResponseSelectionExpression"},"IntegrationType":{"locationName":"integrationType"},"IntegrationUri":{"locationName":"integrationUri"},"PassthroughBehavior":{"locationName":"passthroughBehavior"},"RequestParameters":{"shape":"S17","locationName":"requestParameters"},"RequestTemplates":{"shape":"S18","locationName":"requestTemplates"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"},"TimeoutInMillis":{"locationName":"timeoutInMillis","type":"integer"}}}},"GetIntegrationResponse":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/integrations/{integrationId}/integrationresponses/{integrationResponseId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"IntegrationId":{"location":"uri","locationName":"integrationId"},"IntegrationResponseId":{"location":"uri","locationName":"integrationResponseId"}},"required":["ApiId","IntegrationResponseId","IntegrationId"]},"output":{"type":"structure","members":{"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"IntegrationResponseId":{"locationName":"integrationResponseId"},"IntegrationResponseKey":{"locationName":"integrationResponseKey"},"ResponseParameters":{"shape":"S17","locationName":"responseParameters"},"ResponseTemplates":{"shape":"S18","locationName":"responseTemplates"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"}}}},"GetIntegrationResponses":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/integrations/{integrationId}/integrationresponses","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"IntegrationId":{"location":"uri","locationName":"integrationId"},"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["IntegrationId","ApiId"]},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"IntegrationResponseId":{"locationName":"integrationResponseId"},"IntegrationResponseKey":{"locationName":"integrationResponseKey"},"ResponseParameters":{"shape":"S17","locationName":"responseParameters"},"ResponseTemplates":{"shape":"S18","locationName":"responseTemplates"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"}},"required":["IntegrationResponseKey"]}},"NextToken":{"locationName":"nextToken"}}}},"GetIntegrations":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/integrations","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ApiId"]},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"ConnectionId":{"locationName":"connectionId"},"ConnectionType":{"locationName":"connectionType"},"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"CredentialsArn":{"locationName":"credentialsArn"},"Description":{"locationName":"description"},"IntegrationId":{"locationName":"integrationId"},"IntegrationMethod":{"locationName":"integrationMethod"},"IntegrationResponseSelectionExpression":{"locationName":"integrationResponseSelectionExpression"},"IntegrationType":{"locationName":"integrationType"},"IntegrationUri":{"locationName":"integrationUri"},"PassthroughBehavior":{"locationName":"passthroughBehavior"},"RequestParameters":{"shape":"S17","locationName":"requestParameters"},"RequestTemplates":{"shape":"S18","locationName":"requestTemplates"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"},"TimeoutInMillis":{"locationName":"timeoutInMillis","type":"integer"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetModel":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/models/{modelId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ModelId":{"location":"uri","locationName":"modelId"}},"required":["ModelId","ApiId"]},"output":{"type":"structure","members":{"ContentType":{"locationName":"contentType"},"Description":{"locationName":"description"},"ModelId":{"locationName":"modelId"},"Name":{"locationName":"name"},"Schema":{"locationName":"schema"}}}},"GetModelTemplate":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/models/{modelId}/template","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ModelId":{"location":"uri","locationName":"modelId"}},"required":["ModelId","ApiId"]},"output":{"type":"structure","members":{"Value":{"locationName":"value"}}}},"GetModels":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/models","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ApiId"]},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"ContentType":{"locationName":"contentType"},"Description":{"locationName":"description"},"ModelId":{"locationName":"modelId"},"Name":{"locationName":"name"},"Schema":{"locationName":"schema"}},"required":["Name"]}},"NextToken":{"locationName":"nextToken"}}}},"GetRoute":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/routes/{routeId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"RouteId":{"location":"uri","locationName":"routeId"}},"required":["ApiId","RouteId"]},"output":{"type":"structure","members":{"ApiKeyRequired":{"locationName":"apiKeyRequired","type":"boolean"},"AuthorizationScopes":{"shape":"S1i","locationName":"authorizationScopes"},"AuthorizationType":{"locationName":"authorizationType"},"AuthorizerId":{"locationName":"authorizerId"},"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"OperationName":{"locationName":"operationName"},"RequestModels":{"shape":"S1k","locationName":"requestModels"},"RequestParameters":{"shape":"S1l","locationName":"requestParameters"},"RouteId":{"locationName":"routeId"},"RouteKey":{"locationName":"routeKey"},"RouteResponseSelectionExpression":{"locationName":"routeResponseSelectionExpression"},"Target":{"locationName":"target"}}}},"GetRouteResponse":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/routes/{routeId}/routeresponses/{routeResponseId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"RouteId":{"location":"uri","locationName":"routeId"},"RouteResponseId":{"location":"uri","locationName":"routeResponseId"}},"required":["RouteResponseId","ApiId","RouteId"]},"output":{"type":"structure","members":{"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"ResponseModels":{"shape":"S1k","locationName":"responseModels"},"ResponseParameters":{"shape":"S1l","locationName":"responseParameters"},"RouteResponseId":{"locationName":"routeResponseId"},"RouteResponseKey":{"locationName":"routeResponseKey"}}}},"GetRouteResponses":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/routes/{routeId}/routeresponses","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"},"RouteId":{"location":"uri","locationName":"routeId"}},"required":["RouteId","ApiId"]},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"ResponseModels":{"shape":"S1k","locationName":"responseModels"},"ResponseParameters":{"shape":"S1l","locationName":"responseParameters"},"RouteResponseId":{"locationName":"routeResponseId"},"RouteResponseKey":{"locationName":"routeResponseKey"}},"required":["RouteResponseKey"]}},"NextToken":{"locationName":"nextToken"}}}},"GetRoutes":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/routes","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ApiId"]},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"ApiKeyRequired":{"locationName":"apiKeyRequired","type":"boolean"},"AuthorizationScopes":{"shape":"S1i","locationName":"authorizationScopes"},"AuthorizationType":{"locationName":"authorizationType"},"AuthorizerId":{"locationName":"authorizerId"},"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"OperationName":{"locationName":"operationName"},"RequestModels":{"shape":"S1k","locationName":"requestModels"},"RequestParameters":{"shape":"S1l","locationName":"requestParameters"},"RouteId":{"locationName":"routeId"},"RouteKey":{"locationName":"routeKey"},"RouteResponseSelectionExpression":{"locationName":"routeResponseSelectionExpression"},"Target":{"locationName":"target"}},"required":["RouteKey"]}},"NextToken":{"locationName":"nextToken"}}}},"GetStage":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/stages/{stageName}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"StageName":{"location":"uri","locationName":"stageName"}},"required":["StageName","ApiId"]},"output":{"type":"structure","members":{"AccessLogSettings":{"shape":"S1r","locationName":"accessLogSettings"},"ClientCertificateId":{"locationName":"clientCertificateId"},"CreatedDate":{"shape":"Sd","locationName":"createdDate"},"DefaultRouteSettings":{"shape":"S1s","locationName":"defaultRouteSettings"},"DeploymentId":{"locationName":"deploymentId"},"Description":{"locationName":"description"},"LastUpdatedDate":{"shape":"Sd","locationName":"lastUpdatedDate"},"RouteSettings":{"shape":"S1w","locationName":"routeSettings"},"StageName":{"locationName":"stageName"},"StageVariables":{"shape":"S1x","locationName":"stageVariables"},"Tags":{"shape":"S8","locationName":"tags"}}}},"GetStages":{"http":{"method":"GET","requestUri":"/v2/apis/{apiId}/stages","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"MaxResults":{"location":"querystring","locationName":"maxResults"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"required":["ApiId"]},"output":{"type":"structure","members":{"Items":{"locationName":"items","type":"list","member":{"type":"structure","members":{"AccessLogSettings":{"shape":"S1r","locationName":"accessLogSettings"},"ClientCertificateId":{"locationName":"clientCertificateId"},"CreatedDate":{"shape":"Sd","locationName":"createdDate"},"DefaultRouteSettings":{"shape":"S1s","locationName":"defaultRouteSettings"},"DeploymentId":{"locationName":"deploymentId"},"Description":{"locationName":"description"},"LastUpdatedDate":{"shape":"Sd","locationName":"lastUpdatedDate"},"RouteSettings":{"shape":"S1w","locationName":"routeSettings"},"StageName":{"locationName":"stageName"},"StageVariables":{"shape":"S1x","locationName":"stageVariables"},"Tags":{"shape":"S8","locationName":"tags"}},"required":["StageName"]}},"NextToken":{"locationName":"nextToken"}}}},"GetTags":{"http":{"method":"GET","requestUri":"/v2/tags/{resource-arn}","responseCode":200},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{"Tags":{"locationName":"tags","type":"map","key":{},"value":{}}}}},"TagResource":{"http":{"requestUri":"/v2/tags/{resource-arn}","responseCode":201},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"Tags":{"shape":"S8","locationName":"tags"}},"required":["ResourceArn"]},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/v2/tags/{resource-arn}","responseCode":204},"input":{"type":"structure","members":{"ResourceArn":{"location":"uri","locationName":"resource-arn"},"TagKeys":{"shape":"Se","location":"querystring","locationName":"tagKeys"}},"required":["TagKeys","ResourceArn"]}},"UpdateApi":{"http":{"method":"PATCH","requestUri":"/v2/apis/{apiId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ApiKeySelectionExpression":{"locationName":"apiKeySelectionExpression"},"Description":{"locationName":"description"},"DisableSchemaValidation":{"locationName":"disableSchemaValidation","type":"boolean"},"Name":{"locationName":"name"},"RouteSelectionExpression":{"locationName":"routeSelectionExpression"},"Version":{"locationName":"version"}},"required":["ApiId"]},"output":{"type":"structure","members":{"ApiEndpoint":{"locationName":"apiEndpoint"},"ApiId":{"locationName":"apiId"},"ApiKeySelectionExpression":{"locationName":"apiKeySelectionExpression"},"CreatedDate":{"shape":"Sd","locationName":"createdDate"},"Description":{"locationName":"description"},"DisableSchemaValidation":{"locationName":"disableSchemaValidation","type":"boolean"},"Name":{"locationName":"name"},"ProtocolType":{"locationName":"protocolType"},"RouteSelectionExpression":{"locationName":"routeSelectionExpression"},"Version":{"locationName":"version"},"Warnings":{"shape":"Se","locationName":"warnings"},"Tags":{"shape":"S8","locationName":"tags"}}}},"UpdateApiMapping":{"http":{"method":"PATCH","requestUri":"/v2/domainnames/{domainName}/apimappings/{apiMappingId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"locationName":"apiId"},"ApiMappingId":{"location":"uri","locationName":"apiMappingId"},"ApiMappingKey":{"locationName":"apiMappingKey"},"DomainName":{"location":"uri","locationName":"domainName"},"Stage":{"locationName":"stage"}},"required":["ApiMappingId","ApiId","DomainName"]},"output":{"type":"structure","members":{"ApiId":{"locationName":"apiId"},"ApiMappingId":{"locationName":"apiMappingId"},"ApiMappingKey":{"locationName":"apiMappingKey"},"Stage":{"locationName":"stage"}}}},"UpdateAuthorizer":{"http":{"method":"PATCH","requestUri":"/v2/apis/{apiId}/authorizers/{authorizerId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"AuthorizerCredentialsArn":{"locationName":"authorizerCredentialsArn"},"AuthorizerId":{"location":"uri","locationName":"authorizerId"},"AuthorizerResultTtlInSeconds":{"locationName":"authorizerResultTtlInSeconds","type":"integer"},"AuthorizerType":{"locationName":"authorizerType"},"AuthorizerUri":{"locationName":"authorizerUri"},"IdentitySource":{"shape":"Sn","locationName":"identitySource"},"IdentityValidationExpression":{"locationName":"identityValidationExpression"},"Name":{"locationName":"name"},"ProviderArns":{"shape":"So","locationName":"providerArns"}},"required":["AuthorizerId","ApiId"]},"output":{"type":"structure","members":{"AuthorizerCredentialsArn":{"locationName":"authorizerCredentialsArn"},"AuthorizerId":{"locationName":"authorizerId"},"AuthorizerResultTtlInSeconds":{"locationName":"authorizerResultTtlInSeconds","type":"integer"},"AuthorizerType":{"locationName":"authorizerType"},"AuthorizerUri":{"locationName":"authorizerUri"},"IdentitySource":{"shape":"Sn","locationName":"identitySource"},"IdentityValidationExpression":{"locationName":"identityValidationExpression"},"Name":{"locationName":"name"},"ProviderArns":{"shape":"So","locationName":"providerArns"}}}},"UpdateDeployment":{"http":{"method":"PATCH","requestUri":"/v2/apis/{apiId}/deployments/{deploymentId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"DeploymentId":{"location":"uri","locationName":"deploymentId"},"Description":{"locationName":"description"}},"required":["ApiId","DeploymentId"]},"output":{"type":"structure","members":{"CreatedDate":{"shape":"Sd","locationName":"createdDate"},"DeploymentId":{"locationName":"deploymentId"},"DeploymentStatus":{"locationName":"deploymentStatus"},"DeploymentStatusMessage":{"locationName":"deploymentStatusMessage"},"Description":{"locationName":"description"}}}},"UpdateDomainName":{"http":{"method":"PATCH","requestUri":"/v2/domainnames/{domainName}","responseCode":200},"input":{"type":"structure","members":{"DomainName":{"location":"uri","locationName":"domainName"},"DomainNameConfigurations":{"shape":"Sv","locationName":"domainNameConfigurations"}},"required":["DomainName"]},"output":{"type":"structure","members":{"ApiMappingSelectionExpression":{"locationName":"apiMappingSelectionExpression"},"DomainName":{"locationName":"domainName"},"DomainNameConfigurations":{"shape":"Sv","locationName":"domainNameConfigurations"},"Tags":{"shape":"S8","locationName":"tags"}}}},"UpdateIntegration":{"http":{"method":"PATCH","requestUri":"/v2/apis/{apiId}/integrations/{integrationId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ConnectionId":{"locationName":"connectionId"},"ConnectionType":{"locationName":"connectionType"},"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"CredentialsArn":{"locationName":"credentialsArn"},"Description":{"locationName":"description"},"IntegrationId":{"location":"uri","locationName":"integrationId"},"IntegrationMethod":{"locationName":"integrationMethod"},"IntegrationType":{"locationName":"integrationType"},"IntegrationUri":{"locationName":"integrationUri"},"PassthroughBehavior":{"locationName":"passthroughBehavior"},"RequestParameters":{"shape":"S17","locationName":"requestParameters"},"RequestTemplates":{"shape":"S18","locationName":"requestTemplates"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"},"TimeoutInMillis":{"locationName":"timeoutInMillis","type":"integer"}},"required":["ApiId","IntegrationId"]},"output":{"type":"structure","members":{"ConnectionId":{"locationName":"connectionId"},"ConnectionType":{"locationName":"connectionType"},"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"CredentialsArn":{"locationName":"credentialsArn"},"Description":{"locationName":"description"},"IntegrationId":{"locationName":"integrationId"},"IntegrationMethod":{"locationName":"integrationMethod"},"IntegrationResponseSelectionExpression":{"locationName":"integrationResponseSelectionExpression"},"IntegrationType":{"locationName":"integrationType"},"IntegrationUri":{"locationName":"integrationUri"},"PassthroughBehavior":{"locationName":"passthroughBehavior"},"RequestParameters":{"shape":"S17","locationName":"requestParameters"},"RequestTemplates":{"shape":"S18","locationName":"requestTemplates"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"},"TimeoutInMillis":{"locationName":"timeoutInMillis","type":"integer"}}}},"UpdateIntegrationResponse":{"http":{"method":"PATCH","requestUri":"/v2/apis/{apiId}/integrations/{integrationId}/integrationresponses/{integrationResponseId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"IntegrationId":{"location":"uri","locationName":"integrationId"},"IntegrationResponseId":{"location":"uri","locationName":"integrationResponseId"},"IntegrationResponseKey":{"locationName":"integrationResponseKey"},"ResponseParameters":{"shape":"S17","locationName":"responseParameters"},"ResponseTemplates":{"shape":"S18","locationName":"responseTemplates"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"}},"required":["ApiId","IntegrationResponseId","IntegrationId"]},"output":{"type":"structure","members":{"ContentHandlingStrategy":{"locationName":"contentHandlingStrategy"},"IntegrationResponseId":{"locationName":"integrationResponseId"},"IntegrationResponseKey":{"locationName":"integrationResponseKey"},"ResponseParameters":{"shape":"S17","locationName":"responseParameters"},"ResponseTemplates":{"shape":"S18","locationName":"responseTemplates"},"TemplateSelectionExpression":{"locationName":"templateSelectionExpression"}}}},"UpdateModel":{"http":{"method":"PATCH","requestUri":"/v2/apis/{apiId}/models/{modelId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ContentType":{"locationName":"contentType"},"Description":{"locationName":"description"},"ModelId":{"location":"uri","locationName":"modelId"},"Name":{"locationName":"name"},"Schema":{"locationName":"schema"}},"required":["ModelId","ApiId"]},"output":{"type":"structure","members":{"ContentType":{"locationName":"contentType"},"Description":{"locationName":"description"},"ModelId":{"locationName":"modelId"},"Name":{"locationName":"name"},"Schema":{"locationName":"schema"}}}},"UpdateRoute":{"http":{"method":"PATCH","requestUri":"/v2/apis/{apiId}/routes/{routeId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ApiKeyRequired":{"locationName":"apiKeyRequired","type":"boolean"},"AuthorizationScopes":{"shape":"S1i","locationName":"authorizationScopes"},"AuthorizationType":{"locationName":"authorizationType"},"AuthorizerId":{"locationName":"authorizerId"},"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"OperationName":{"locationName":"operationName"},"RequestModels":{"shape":"S1k","locationName":"requestModels"},"RequestParameters":{"shape":"S1l","locationName":"requestParameters"},"RouteId":{"location":"uri","locationName":"routeId"},"RouteKey":{"locationName":"routeKey"},"RouteResponseSelectionExpression":{"locationName":"routeResponseSelectionExpression"},"Target":{"locationName":"target"}},"required":["ApiId","RouteId"]},"output":{"type":"structure","members":{"ApiKeyRequired":{"locationName":"apiKeyRequired","type":"boolean"},"AuthorizationScopes":{"shape":"S1i","locationName":"authorizationScopes"},"AuthorizationType":{"locationName":"authorizationType"},"AuthorizerId":{"locationName":"authorizerId"},"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"OperationName":{"locationName":"operationName"},"RequestModels":{"shape":"S1k","locationName":"requestModels"},"RequestParameters":{"shape":"S1l","locationName":"requestParameters"},"RouteId":{"locationName":"routeId"},"RouteKey":{"locationName":"routeKey"},"RouteResponseSelectionExpression":{"locationName":"routeResponseSelectionExpression"},"Target":{"locationName":"target"}}}},"UpdateRouteResponse":{"http":{"method":"PATCH","requestUri":"/v2/apis/{apiId}/routes/{routeId}/routeresponses/{routeResponseId}","responseCode":200},"input":{"type":"structure","members":{"ApiId":{"location":"uri","locationName":"apiId"},"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"ResponseModels":{"shape":"S1k","locationName":"responseModels"},"ResponseParameters":{"shape":"S1l","locationName":"responseParameters"},"RouteId":{"location":"uri","locationName":"routeId"},"RouteResponseId":{"location":"uri","locationName":"routeResponseId"},"RouteResponseKey":{"locationName":"routeResponseKey"}},"required":["RouteResponseId","ApiId","RouteId"]},"output":{"type":"structure","members":{"ModelSelectionExpression":{"locationName":"modelSelectionExpression"},"ResponseModels":{"shape":"S1k","locationName":"responseModels"},"ResponseParameters":{"shape":"S1l","locationName":"responseParameters"},"RouteResponseId":{"locationName":"routeResponseId"},"RouteResponseKey":{"locationName":"routeResponseKey"}}}},"UpdateStage":{"http":{"method":"PATCH","requestUri":"/v2/apis/{apiId}/stages/{stageName}","responseCode":200},"input":{"type":"structure","members":{"AccessLogSettings":{"shape":"S1r","locationName":"accessLogSettings"},"ApiId":{"location":"uri","locationName":"apiId"},"ClientCertificateId":{"locationName":"clientCertificateId"},"DefaultRouteSettings":{"shape":"S1s","locationName":"defaultRouteSettings"},"DeploymentId":{"locationName":"deploymentId"},"Description":{"locationName":"description"},"RouteSettings":{"shape":"S1w","locationName":"routeSettings"},"StageName":{"location":"uri","locationName":"stageName"},"StageVariables":{"shape":"S1x","locationName":"stageVariables"}},"required":["StageName","ApiId"]},"output":{"type":"structure","members":{"AccessLogSettings":{"shape":"S1r","locationName":"accessLogSettings"},"ClientCertificateId":{"locationName":"clientCertificateId"},"CreatedDate":{"shape":"Sd","locationName":"createdDate"},"DefaultRouteSettings":{"shape":"S1s","locationName":"defaultRouteSettings"},"DeploymentId":{"locationName":"deploymentId"},"Description":{"locationName":"description"},"LastUpdatedDate":{"shape":"Sd","locationName":"lastUpdatedDate"},"RouteSettings":{"shape":"S1w","locationName":"routeSettings"},"StageName":{"locationName":"stageName"},"StageVariables":{"shape":"S1x","locationName":"stageVariables"},"Tags":{"shape":"S8","locationName":"tags"}}}}},"shapes":{"S8":{"type":"map","key":{},"value":{}},"Sd":{"type":"timestamp","timestampFormat":"iso8601"},"Se":{"type":"list","member":{}},"Sn":{"type":"list","member":{}},"So":{"type":"list","member":{}},"Sv":{"type":"list","member":{"type":"structure","members":{"ApiGatewayDomainName":{"locationName":"apiGatewayDomainName"},"CertificateArn":{"locationName":"certificateArn"},"CertificateName":{"locationName":"certificateName"},"CertificateUploadDate":{"shape":"Sd","locationName":"certificateUploadDate"},"EndpointType":{"locationName":"endpointType"},"HostedZoneId":{"locationName":"hostedZoneId"},"SecurityPolicy":{"locationName":"securityPolicy"},"DomainNameStatus":{"locationName":"domainNameStatus"},"DomainNameStatusMessage":{"locationName":"domainNameStatusMessage"}}}},"S17":{"type":"map","key":{},"value":{}},"S18":{"type":"map","key":{},"value":{}},"S1i":{"type":"list","member":{}},"S1k":{"type":"map","key":{},"value":{}},"S1l":{"type":"map","key":{},"value":{"type":"structure","members":{"Required":{"locationName":"required","type":"boolean"}}}},"S1r":{"type":"structure","members":{"DestinationArn":{"locationName":"destinationArn"},"Format":{"locationName":"format"}}},"S1s":{"type":"structure","members":{"DataTraceEnabled":{"locationName":"dataTraceEnabled","type":"boolean"},"DetailedMetricsEnabled":{"locationName":"detailedMetricsEnabled","type":"boolean"},"LoggingLevel":{"locationName":"loggingLevel"},"ThrottlingBurstLimit":{"locationName":"throttlingBurstLimit","type":"integer"},"ThrottlingRateLimit":{"locationName":"throttlingRateLimit","type":"double"}}},"S1w":{"type":"map","key":{},"value":{"shape":"S1s"}},"S1x":{"type":"map","key":{},"value":{}}},"authorizers":{"authorization_strategy":{"name":"authorization_strategy","type":"provided","placement":{"location":"header","name":"Authorization"}}}}');

});

parcelRequire.register("iAxlP", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("iNer6", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $dae8005669a67c4b$var$Service = $dbC7k.Service;
var $dae8005669a67c4b$var$apiLoader = $dbC7k.apiLoader;
$dae8005669a67c4b$var$apiLoader.services["docdb"] = {};
$dbC7k.DocDB = $dae8005669a67c4b$var$Service.defineService("docdb", [
    "2014-10-31"
]);



Object.defineProperty($dae8005669a67c4b$var$apiLoader.services["docdb"], "2014-10-31", {
    get: function get() {
        var model = (parcelRequire("a2kxs"));
        model.paginators = (parcelRequire("8M80b")).pagination;
        model.waiters = (parcelRequire("anq2i")).waiters;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.DocDB;

});
parcelRequire.register("a2kxs", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2014-10-31","endpointPrefix":"rds","protocol":"query","serviceAbbreviation":"Amazon DocDB","serviceFullName":"Amazon DocumentDB with MongoDB compatibility","serviceId":"DocDB","signatureVersion":"v4","signingName":"rds","uid":"docdb-2014-10-31","xmlNamespace":"http://rds.amazonaws.com/doc/2014-10-31/"},"operations":{"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S3"}}}},"ApplyPendingMaintenanceAction":{"input":{"type":"structure","required":["ResourceIdentifier","ApplyAction","OptInType"],"members":{"ResourceIdentifier":{},"ApplyAction":{},"OptInType":{}}},"output":{"resultWrapper":"ApplyPendingMaintenanceActionResult","type":"structure","members":{"ResourcePendingMaintenanceActions":{"shape":"S7"}}}},"CopyDBClusterParameterGroup":{"input":{"type":"structure","required":["SourceDBClusterParameterGroupIdentifier","TargetDBClusterParameterGroupIdentifier","TargetDBClusterParameterGroupDescription"],"members":{"SourceDBClusterParameterGroupIdentifier":{},"TargetDBClusterParameterGroupIdentifier":{},"TargetDBClusterParameterGroupDescription":{},"Tags":{"shape":"S3"}}},"output":{"resultWrapper":"CopyDBClusterParameterGroupResult","type":"structure","members":{"DBClusterParameterGroup":{"shape":"Sd"}}}},"CopyDBClusterSnapshot":{"input":{"type":"structure","required":["SourceDBClusterSnapshotIdentifier","TargetDBClusterSnapshotIdentifier"],"members":{"SourceDBClusterSnapshotIdentifier":{},"TargetDBClusterSnapshotIdentifier":{},"KmsKeyId":{},"PreSignedUrl":{},"CopyTags":{"type":"boolean"},"Tags":{"shape":"S3"}}},"output":{"resultWrapper":"CopyDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"Sh"}}}},"CreateDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","Engine","MasterUsername","MasterUserPassword"],"members":{"AvailabilityZones":{"shape":"Si"},"BackupRetentionPeriod":{"type":"integer"},"DBClusterIdentifier":{},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"Sn"},"DBSubnetGroupName":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"MasterUsername":{},"MasterUserPassword":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"Tags":{"shape":"S3"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"EnableCloudwatchLogsExports":{"shape":"So"},"DeletionProtection":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sq"}}}},"CreateDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBClusterParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"S3"}}},"output":{"resultWrapper":"CreateDBClusterParameterGroupResult","type":"structure","members":{"DBClusterParameterGroup":{"shape":"Sd"}}}},"CreateDBClusterSnapshot":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier","DBClusterIdentifier"],"members":{"DBClusterSnapshotIdentifier":{},"DBClusterIdentifier":{},"Tags":{"shape":"S3"}}},"output":{"resultWrapper":"CreateDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"Sh"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBInstanceClass","Engine","DBClusterIdentifier"],"members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"AvailabilityZone":{},"PreferredMaintenanceWindow":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"Tags":{"shape":"S3"},"DBClusterIdentifier":{},"PromotionTier":{"type":"integer"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S13"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1e"},"Tags":{"shape":"S3"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S15"}}}},"DeleteDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sq"}}}},"DeleteDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{}}}},"DeleteDBClusterSnapshot":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier"],"members":{"DBClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"Sh"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S13"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DescribeDBClusterParameterGroups":{"input":{"type":"structure","members":{"DBClusterParameterGroupName":{},"Filters":{"shape":"S1p"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterParameterGroupsResult","type":"structure","members":{"Marker":{},"DBClusterParameterGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBClusterParameterGroup"}}}}},"DescribeDBClusterParameters":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{},"Source":{},"Filters":{"shape":"S1p"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterParametersResult","type":"structure","members":{"Parameters":{"shape":"S1w"},"Marker":{}}}},"DescribeDBClusterSnapshotAttributes":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier"],"members":{"DBClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DescribeDBClusterSnapshotAttributesResult","type":"structure","members":{"DBClusterSnapshotAttributesResult":{"shape":"S21"}}}},"DescribeDBClusterSnapshots":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"DBClusterSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S1p"},"MaxRecords":{"type":"integer"},"Marker":{},"IncludeShared":{"type":"boolean"},"IncludePublic":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBClusterSnapshotsResult","type":"structure","members":{"Marker":{},"DBClusterSnapshots":{"type":"list","member":{"shape":"Sh","locationName":"DBClusterSnapshot"}}}}},"DescribeDBClusters":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"Filters":{"shape":"S1p"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClustersResult","type":"structure","members":{"Marker":{},"DBClusters":{"type":"list","member":{"shape":"Sq","locationName":"DBCluster"}}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S1p"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"},"ListSupportedTimezones":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"ValidUpgradeTarget":{"type":"list","member":{"locationName":"UpgradeTarget","type":"structure","members":{"Engine":{},"EngineVersion":{},"Description":{},"AutoUpgrade":{"type":"boolean"},"IsMajorVersionUpgrade":{"type":"boolean"}}}},"ExportableLogTypes":{"shape":"So"},"SupportsLogExportsToCloudwatchLogs":{"type":"boolean"}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S1p"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"S13","locationName":"DBInstance"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S1p"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S15","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultClusterParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S1p"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultClusterParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S1w"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S1p"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S2u"}},"wrapper":true}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S2u"},"Filters":{"shape":"S1p"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S2u"},"Date":{"type":"timestamp"},"SourceArn":{}}}}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S1p"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S18","locationName":"AvailabilityZone"}},"Vpc":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribePendingMaintenanceActions":{"input":{"type":"structure","members":{"ResourceIdentifier":{},"Filters":{"shape":"S1p"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribePendingMaintenanceActionsResult","type":"structure","members":{"PendingMaintenanceActions":{"type":"list","member":{"shape":"S7","locationName":"ResourcePendingMaintenanceActions"}},"Marker":{}}}},"FailoverDBCluster":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"TargetDBInstanceIdentifier":{}}},"output":{"resultWrapper":"FailoverDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sq"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S1p"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S3"}}}},"ModifyDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"NewDBClusterIdentifier":{},"ApplyImmediately":{"type":"boolean"},"BackupRetentionPeriod":{"type":"integer"},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"Sn"},"Port":{"type":"integer"},"MasterUserPassword":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"CloudwatchLogsExportConfiguration":{"type":"structure","members":{"EnableLogTypes":{"shape":"So"},"DisableLogTypes":{"shape":"So"}}},"EngineVersion":{},"DeletionProtection":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sq"}}}},"ModifyDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName","Parameters"],"members":{"DBClusterParameterGroupName":{},"Parameters":{"shape":"S1w"}}},"output":{"shape":"S3g","resultWrapper":"ModifyDBClusterParameterGroupResult"}},"ModifyDBClusterSnapshotAttribute":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier","AttributeName"],"members":{"DBClusterSnapshotIdentifier":{},"AttributeName":{},"ValuesToAdd":{"shape":"S24"},"ValuesToRemove":{"shape":"S24"}}},"output":{"resultWrapper":"ModifyDBClusterSnapshotAttributeResult","type":"structure","members":{"DBClusterSnapshotAttributesResult":{"shape":"S21"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"ApplyImmediately":{"type":"boolean"},"PreferredMaintenanceWindow":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"NewDBInstanceIdentifier":{},"PromotionTier":{"type":"integer"}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S13"}}}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1e"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S15"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S13"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S1w"}}},"output":{"shape":"S3g","resultWrapper":"ResetDBClusterParameterGroupResult"}},"RestoreDBClusterFromSnapshot":{"input":{"type":"structure","required":["DBClusterIdentifier","SnapshotIdentifier","Engine"],"members":{"AvailabilityZones":{"shape":"Si"},"DBClusterIdentifier":{},"SnapshotIdentifier":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"DBSubnetGroupName":{},"VpcSecurityGroupIds":{"shape":"Sn"},"Tags":{"shape":"S3"},"KmsKeyId":{},"EnableCloudwatchLogsExports":{"shape":"So"},"DeletionProtection":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreDBClusterFromSnapshotResult","type":"structure","members":{"DBCluster":{"shape":"Sq"}}}},"RestoreDBClusterToPointInTime":{"input":{"type":"structure","required":["DBClusterIdentifier","SourceDBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"SourceDBClusterIdentifier":{},"RestoreToTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"Port":{"type":"integer"},"DBSubnetGroupName":{},"VpcSecurityGroupIds":{"shape":"Sn"},"Tags":{"shape":"S3"},"KmsKeyId":{},"EnableCloudwatchLogsExports":{"shape":"So"},"DeletionProtection":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreDBClusterToPointInTimeResult","type":"structure","members":{"DBCluster":{"shape":"Sq"}}}},"StartDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"StartDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sq"}}}},"StopDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"StopDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"Sq"}}}}},"shapes":{"S3":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"S7":{"type":"structure","members":{"ResourceIdentifier":{},"PendingMaintenanceActionDetails":{"type":"list","member":{"locationName":"PendingMaintenanceAction","type":"structure","members":{"Action":{},"AutoAppliedAfterDate":{"type":"timestamp"},"ForcedApplyDate":{"type":"timestamp"},"OptInStatus":{},"CurrentApplyDate":{"type":"timestamp"},"Description":{}}}}},"wrapper":true},"Sd":{"type":"structure","members":{"DBClusterParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"DBClusterParameterGroupArn":{}},"wrapper":true},"Sh":{"type":"structure","members":{"AvailabilityZones":{"shape":"Si"},"DBClusterSnapshotIdentifier":{},"DBClusterIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"Status":{},"Port":{"type":"integer"},"VpcId":{},"ClusterCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"SnapshotType":{},"PercentProgress":{"type":"integer"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DBClusterSnapshotArn":{},"SourceDBClusterSnapshotArn":{}},"wrapper":true},"Si":{"type":"list","member":{"locationName":"AvailabilityZone"}},"Sn":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"So":{"type":"list","member":{}},"Sq":{"type":"structure","members":{"AvailabilityZones":{"shape":"Si"},"BackupRetentionPeriod":{"type":"integer"},"DBClusterIdentifier":{},"DBClusterParameterGroup":{},"DBSubnetGroup":{},"Status":{},"PercentProgress":{},"EarliestRestorableTime":{"type":"timestamp"},"Endpoint":{},"ReaderEndpoint":{},"MultiAZ":{"type":"boolean"},"Engine":{},"EngineVersion":{},"LatestRestorableTime":{"type":"timestamp"},"Port":{"type":"integer"},"MasterUsername":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"DBClusterMembers":{"type":"list","member":{"locationName":"DBClusterMember","type":"structure","members":{"DBInstanceIdentifier":{},"IsClusterWriter":{"type":"boolean"},"DBClusterParameterGroupStatus":{},"PromotionTier":{"type":"integer"}},"wrapper":true}},"VpcSecurityGroups":{"shape":"St"},"HostedZoneId":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbClusterResourceId":{},"DBClusterArn":{},"AssociatedRoles":{"type":"list","member":{"locationName":"DBClusterRole","type":"structure","members":{"RoleArn":{},"Status":{}}}},"ClusterCreateTime":{"type":"timestamp"},"EnabledCloudwatchLogsExports":{"shape":"So"},"DeletionProtection":{"type":"boolean"}},"wrapper":true},"St":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S13":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"},"HostedZoneId":{}}},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"VpcSecurityGroups":{"shape":"St"},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S15"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"LicenseModel":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{},"StorageType":{},"CACertificateIdentifier":{},"DBSubnetGroupName":{},"PendingCloudwatchLogsExports":{"type":"structure","members":{"LogTypesToEnable":{"shape":"So"},"LogTypesToDisable":{"shape":"So"}}}}},"LatestRestorableTime":{"type":"timestamp"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}},"DBClusterIdentifier":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbiResourceId":{},"PromotionTier":{"type":"integer"},"DBInstanceArn":{},"EnabledCloudwatchLogsExports":{"shape":"So"}},"wrapper":true},"S15":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S18"},"SubnetStatus":{}}}},"DBSubnetGroupArn":{}},"wrapper":true},"S18":{"type":"structure","members":{"Name":{}},"wrapper":true},"S1e":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1p":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S1w":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S21":{"type":"structure","members":{"DBClusterSnapshotIdentifier":{},"DBClusterSnapshotAttributes":{"type":"list","member":{"locationName":"DBClusterSnapshotAttribute","type":"structure","members":{"AttributeName":{},"AttributeValues":{"shape":"S24"}}}}},"wrapper":true},"S24":{"type":"list","member":{"locationName":"AttributeValue"}},"S2u":{"type":"list","member":{"locationName":"EventCategory"}},"S3g":{"type":"structure","members":{"DBClusterParameterGroupName":{}}}}}');

});

parcelRequire.register("8M80b", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"DescribeDBClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusters"},"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"ListTagsForResource":{"result_key":"TagList"}}}');

});

parcelRequire.register("anq2i", function(module, exports) {
module.exports = JSON.parse('{"version":2,"waiters":{"DBInstanceAvailable":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBInstanceDeleted":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"DBInstanceNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]}}}');

});


parcelRequire.register("ap3cB", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $792eb91575874da8$var$Service = $dbC7k.Service;
var $792eb91575874da8$var$apiLoader = $dbC7k.apiLoader;
$792eb91575874da8$var$apiLoader.services["backup"] = {};
$dbC7k.Backup = $792eb91575874da8$var$Service.defineService("backup", [
    "2018-11-15"
]);


Object.defineProperty($792eb91575874da8$var$apiLoader.services["backup"], "2018-11-15", {
    get: function get() {
        var model = (parcelRequire("laLtI"));
        model.paginators = (parcelRequire("aMcGn")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Backup;

});
parcelRequire.register("laLtI", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-11-15","endpointPrefix":"backup","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS Backup","serviceId":"Backup","signatureVersion":"v4","uid":"backup-2018-11-15"},"operations":{"CreateBackupPlan":{"http":{"method":"PUT","requestUri":"/backup/plans/"},"input":{"type":"structure","required":["BackupPlan"],"members":{"BackupPlan":{"shape":"S2"},"BackupPlanTags":{"shape":"Sc"},"CreatorRequestId":{}}},"output":{"type":"structure","members":{"BackupPlanId":{},"BackupPlanArn":{},"CreationDate":{"type":"timestamp"},"VersionId":{}}},"idempotent":true},"CreateBackupSelection":{"http":{"method":"PUT","requestUri":"/backup/plans/{backupPlanId}/selections/"},"input":{"type":"structure","required":["BackupPlanId","BackupSelection"],"members":{"BackupPlanId":{"location":"uri","locationName":"backupPlanId"},"BackupSelection":{"shape":"Sk"},"CreatorRequestId":{}}},"output":{"type":"structure","members":{"SelectionId":{},"BackupPlanId":{},"CreationDate":{"type":"timestamp"}}},"idempotent":true},"CreateBackupVault":{"http":{"method":"PUT","requestUri":"/backup-vaults/{backupVaultName}"},"input":{"type":"structure","required":["BackupVaultName"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"},"BackupVaultTags":{"shape":"Sc"},"EncryptionKeyArn":{},"CreatorRequestId":{}}},"output":{"type":"structure","members":{"BackupVaultName":{},"BackupVaultArn":{},"CreationDate":{"type":"timestamp"}}},"idempotent":true},"DeleteBackupPlan":{"http":{"method":"DELETE","requestUri":"/backup/plans/{backupPlanId}"},"input":{"type":"structure","required":["BackupPlanId"],"members":{"BackupPlanId":{"location":"uri","locationName":"backupPlanId"}}},"output":{"type":"structure","members":{"BackupPlanId":{},"BackupPlanArn":{},"DeletionDate":{"type":"timestamp"},"VersionId":{}}}},"DeleteBackupSelection":{"http":{"method":"DELETE","requestUri":"/backup/plans/{backupPlanId}/selections/{selectionId}"},"input":{"type":"structure","required":["BackupPlanId","SelectionId"],"members":{"BackupPlanId":{"location":"uri","locationName":"backupPlanId"},"SelectionId":{"location":"uri","locationName":"selectionId"}}}},"DeleteBackupVault":{"http":{"method":"DELETE","requestUri":"/backup-vaults/{backupVaultName}"},"input":{"type":"structure","required":["BackupVaultName"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"}}}},"DeleteBackupVaultAccessPolicy":{"http":{"method":"DELETE","requestUri":"/backup-vaults/{backupVaultName}/access-policy"},"input":{"type":"structure","required":["BackupVaultName"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"}}},"idempotent":true},"DeleteBackupVaultNotifications":{"http":{"method":"DELETE","requestUri":"/backup-vaults/{backupVaultName}/notification-configuration"},"input":{"type":"structure","required":["BackupVaultName"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"}}},"idempotent":true},"DeleteRecoveryPoint":{"http":{"method":"DELETE","requestUri":"/backup-vaults/{backupVaultName}/recovery-points/{recoveryPointArn}"},"input":{"type":"structure","required":["BackupVaultName","RecoveryPointArn"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"},"RecoveryPointArn":{"location":"uri","locationName":"recoveryPointArn"}}},"idempotent":true},"DescribeBackupJob":{"http":{"method":"GET","requestUri":"/backup-jobs/{backupJobId}"},"input":{"type":"structure","required":["BackupJobId"],"members":{"BackupJobId":{"location":"uri","locationName":"backupJobId"}}},"output":{"type":"structure","members":{"BackupJobId":{},"BackupVaultName":{},"BackupVaultArn":{},"RecoveryPointArn":{},"ResourceArn":{},"CreationDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"State":{},"StatusMessage":{},"PercentDone":{},"BackupSizeInBytes":{"type":"long"},"IamRoleArn":{},"CreatedBy":{"shape":"S16"},"ResourceType":{},"BytesTransferred":{"type":"long"},"ExpectedCompletionDate":{"type":"timestamp"},"StartBy":{"type":"timestamp"}}},"idempotent":true},"DescribeBackupVault":{"http":{"method":"GET","requestUri":"/backup-vaults/{backupVaultName}"},"input":{"type":"structure","required":["BackupVaultName"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"}}},"output":{"type":"structure","members":{"BackupVaultName":{},"BackupVaultArn":{},"EncryptionKeyArn":{},"CreationDate":{"type":"timestamp"},"CreatorRequestId":{},"NumberOfRecoveryPoints":{"type":"long"}}},"idempotent":true},"DescribeProtectedResource":{"http":{"method":"GET","requestUri":"/resources/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"ResourceArn":{},"ResourceType":{},"LastBackupTime":{"type":"timestamp"}}},"idempotent":true},"DescribeRecoveryPoint":{"http":{"method":"GET","requestUri":"/backup-vaults/{backupVaultName}/recovery-points/{recoveryPointArn}"},"input":{"type":"structure","required":["BackupVaultName","RecoveryPointArn"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"},"RecoveryPointArn":{"location":"uri","locationName":"recoveryPointArn"}}},"output":{"type":"structure","members":{"RecoveryPointArn":{},"BackupVaultName":{},"BackupVaultArn":{},"ResourceArn":{},"ResourceType":{},"CreatedBy":{"shape":"S16"},"IamRoleArn":{},"Status":{},"CreationDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"BackupSizeInBytes":{"type":"long"},"CalculatedLifecycle":{"shape":"S1g"},"Lifecycle":{"shape":"Sa"},"EncryptionKeyArn":{},"IsEncrypted":{"type":"boolean"},"StorageClass":{},"LastRestoreTime":{"type":"timestamp"}}},"idempotent":true},"DescribeRestoreJob":{"http":{"method":"GET","requestUri":"/restore-jobs/{restoreJobId}"},"input":{"type":"structure","required":["RestoreJobId"],"members":{"RestoreJobId":{"location":"uri","locationName":"restoreJobId"}}},"output":{"type":"structure","members":{"RestoreJobId":{},"RecoveryPointArn":{},"CreationDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"Status":{},"StatusMessage":{},"PercentDone":{},"BackupSizeInBytes":{"type":"long"},"IamRoleArn":{},"ExpectedCompletionTimeMinutes":{"type":"long"},"CreatedResourceArn":{}}},"idempotent":true},"ExportBackupPlanTemplate":{"http":{"method":"GET","requestUri":"/backup/plans/{backupPlanId}/toTemplate/"},"input":{"type":"structure","required":["BackupPlanId"],"members":{"BackupPlanId":{"location":"uri","locationName":"backupPlanId"}}},"output":{"type":"structure","members":{"BackupPlanTemplateJson":{}}}},"GetBackupPlan":{"http":{"method":"GET","requestUri":"/backup/plans/{backupPlanId}/"},"input":{"type":"structure","required":["BackupPlanId"],"members":{"BackupPlanId":{"location":"uri","locationName":"backupPlanId"},"VersionId":{"location":"querystring","locationName":"versionId"}}},"output":{"type":"structure","members":{"BackupPlan":{"shape":"S1r"},"BackupPlanId":{},"BackupPlanArn":{},"VersionId":{},"CreatorRequestId":{},"CreationDate":{"type":"timestamp"},"DeletionDate":{"type":"timestamp"},"LastExecutionDate":{"type":"timestamp"}}},"idempotent":true},"GetBackupPlanFromJSON":{"http":{"requestUri":"/backup/template/json/toPlan"},"input":{"type":"structure","required":["BackupPlanTemplateJson"],"members":{"BackupPlanTemplateJson":{}}},"output":{"type":"structure","members":{"BackupPlan":{"shape":"S1r"}}}},"GetBackupPlanFromTemplate":{"http":{"method":"GET","requestUri":"/backup/template/plans/{templateId}/toPlan"},"input":{"type":"structure","required":["BackupPlanTemplateId"],"members":{"BackupPlanTemplateId":{"location":"uri","locationName":"templateId"}}},"output":{"type":"structure","members":{"BackupPlanDocument":{"shape":"S1r"}}}},"GetBackupSelection":{"http":{"method":"GET","requestUri":"/backup/plans/{backupPlanId}/selections/{selectionId}"},"input":{"type":"structure","required":["BackupPlanId","SelectionId"],"members":{"BackupPlanId":{"location":"uri","locationName":"backupPlanId"},"SelectionId":{"location":"uri","locationName":"selectionId"}}},"output":{"type":"structure","members":{"BackupSelection":{"shape":"Sk"},"SelectionId":{},"BackupPlanId":{},"CreationDate":{"type":"timestamp"},"CreatorRequestId":{}}},"idempotent":true},"GetBackupVaultAccessPolicy":{"http":{"method":"GET","requestUri":"/backup-vaults/{backupVaultName}/access-policy"},"input":{"type":"structure","required":["BackupVaultName"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"}}},"output":{"type":"structure","members":{"BackupVaultName":{},"BackupVaultArn":{},"Policy":{}}},"idempotent":true},"GetBackupVaultNotifications":{"http":{"method":"GET","requestUri":"/backup-vaults/{backupVaultName}/notification-configuration"},"input":{"type":"structure","required":["BackupVaultName"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"}}},"output":{"type":"structure","members":{"BackupVaultName":{},"BackupVaultArn":{},"SNSTopicArn":{},"BackupVaultEvents":{"shape":"S25"}}},"idempotent":true},"GetRecoveryPointRestoreMetadata":{"http":{"method":"GET","requestUri":"/backup-vaults/{backupVaultName}/recovery-points/{recoveryPointArn}/restore-metadata"},"input":{"type":"structure","required":["BackupVaultName","RecoveryPointArn"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"},"RecoveryPointArn":{"location":"uri","locationName":"recoveryPointArn"}}},"output":{"type":"structure","members":{"BackupVaultArn":{},"RecoveryPointArn":{},"RestoreMetadata":{"shape":"S29"}}},"idempotent":true},"GetSupportedResourceTypes":{"http":{"method":"GET","requestUri":"/supported-resource-types"},"output":{"type":"structure","members":{"ResourceTypes":{"type":"list","member":{}}}}},"ListBackupJobs":{"http":{"method":"GET","requestUri":"/backup-jobs/"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"ByResourceArn":{"location":"querystring","locationName":"resourceArn"},"ByState":{"location":"querystring","locationName":"state"},"ByBackupVaultName":{"location":"querystring","locationName":"backupVaultName"},"ByCreatedBefore":{"location":"querystring","locationName":"createdBefore","type":"timestamp"},"ByCreatedAfter":{"location":"querystring","locationName":"createdAfter","type":"timestamp"},"ByResourceType":{"location":"querystring","locationName":"resourceType"}}},"output":{"type":"structure","members":{"BackupJobs":{"type":"list","member":{"type":"structure","members":{"BackupJobId":{},"BackupVaultName":{},"BackupVaultArn":{},"RecoveryPointArn":{},"ResourceArn":{},"CreationDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"State":{},"StatusMessage":{},"PercentDone":{},"BackupSizeInBytes":{"type":"long"},"IamRoleArn":{},"CreatedBy":{"shape":"S16"},"ExpectedCompletionDate":{"type":"timestamp"},"StartBy":{"type":"timestamp"},"ResourceType":{},"BytesTransferred":{"type":"long"}}}},"NextToken":{}}},"idempotent":true},"ListBackupPlanTemplates":{"http":{"method":"GET","requestUri":"/backup/template/plans"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"BackupPlanTemplatesList":{"type":"list","member":{"type":"structure","members":{"BackupPlanTemplateId":{},"BackupPlanTemplateName":{}}}}}}},"ListBackupPlanVersions":{"http":{"method":"GET","requestUri":"/backup/plans/{backupPlanId}/versions/"},"input":{"type":"structure","required":["BackupPlanId"],"members":{"BackupPlanId":{"location":"uri","locationName":"backupPlanId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"BackupPlanVersionsList":{"type":"list","member":{"shape":"S2q"}}}},"idempotent":true},"ListBackupPlans":{"http":{"method":"GET","requestUri":"/backup/plans/"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"IncludeDeleted":{"location":"querystring","locationName":"includeDeleted","type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{},"BackupPlansList":{"type":"list","member":{"shape":"S2q"}}}},"idempotent":true},"ListBackupSelections":{"http":{"method":"GET","requestUri":"/backup/plans/{backupPlanId}/selections/"},"input":{"type":"structure","required":["BackupPlanId"],"members":{"BackupPlanId":{"location":"uri","locationName":"backupPlanId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"BackupSelectionsList":{"type":"list","member":{"type":"structure","members":{"SelectionId":{},"SelectionName":{},"BackupPlanId":{},"CreationDate":{"type":"timestamp"},"CreatorRequestId":{},"IamRoleArn":{}}}}}},"idempotent":true},"ListBackupVaults":{"http":{"method":"GET","requestUri":"/backup-vaults/"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"BackupVaultList":{"type":"list","member":{"type":"structure","members":{"BackupVaultName":{},"BackupVaultArn":{},"CreationDate":{"type":"timestamp"},"EncryptionKeyArn":{},"CreatorRequestId":{},"NumberOfRecoveryPoints":{"type":"long"}}}},"NextToken":{}}},"idempotent":true},"ListProtectedResources":{"http":{"method":"GET","requestUri":"/resources/"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{},"ResourceType":{},"LastBackupTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListRecoveryPointsByBackupVault":{"http":{"method":"GET","requestUri":"/backup-vaults/{backupVaultName}/recovery-points/"},"input":{"type":"structure","required":["BackupVaultName"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"ByResourceArn":{"location":"querystring","locationName":"resourceArn"},"ByResourceType":{"location":"querystring","locationName":"resourceType"},"ByBackupPlanId":{"location":"querystring","locationName":"backupPlanId"},"ByCreatedBefore":{"location":"querystring","locationName":"createdBefore","type":"timestamp"},"ByCreatedAfter":{"location":"querystring","locationName":"createdAfter","type":"timestamp"}}},"output":{"type":"structure","members":{"NextToken":{},"RecoveryPoints":{"type":"list","member":{"type":"structure","members":{"RecoveryPointArn":{},"BackupVaultName":{},"BackupVaultArn":{},"ResourceArn":{},"ResourceType":{},"CreatedBy":{"shape":"S16"},"IamRoleArn":{},"Status":{},"CreationDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"BackupSizeInBytes":{"type":"long"},"CalculatedLifecycle":{"shape":"S1g"},"Lifecycle":{"shape":"Sa"},"EncryptionKeyArn":{},"IsEncrypted":{"type":"boolean"},"LastRestoreTime":{"type":"timestamp"}}}}}},"idempotent":true},"ListRecoveryPointsByResource":{"http":{"method":"GET","requestUri":"/resources/{resourceArn}/recovery-points/"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"RecoveryPoints":{"type":"list","member":{"type":"structure","members":{"RecoveryPointArn":{},"CreationDate":{"type":"timestamp"},"Status":{},"EncryptionKeyArn":{},"BackupSizeBytes":{"type":"long"},"BackupVaultName":{}}}}}},"idempotent":true},"ListRestoreJobs":{"http":{"method":"GET","requestUri":"/restore-jobs/"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"RestoreJobs":{"type":"list","member":{"type":"structure","members":{"RestoreJobId":{},"RecoveryPointArn":{},"CreationDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"Status":{},"StatusMessage":{},"PercentDone":{},"BackupSizeInBytes":{"type":"long"},"IamRoleArn":{},"ExpectedCompletionTimeMinutes":{"type":"long"},"CreatedResourceArn":{}}}},"NextToken":{}}},"idempotent":true},"ListTags":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}/"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"Tags":{"shape":"Sc"}}},"idempotent":true},"PutBackupVaultAccessPolicy":{"http":{"method":"PUT","requestUri":"/backup-vaults/{backupVaultName}/access-policy"},"input":{"type":"structure","required":["BackupVaultName"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"},"Policy":{}}},"idempotent":true},"PutBackupVaultNotifications":{"http":{"method":"PUT","requestUri":"/backup-vaults/{backupVaultName}/notification-configuration"},"input":{"type":"structure","required":["BackupVaultName","SNSTopicArn","BackupVaultEvents"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"},"SNSTopicArn":{},"BackupVaultEvents":{"shape":"S25"}}},"idempotent":true},"StartBackupJob":{"http":{"method":"PUT","requestUri":"/backup-jobs"},"input":{"type":"structure","required":["BackupVaultName","ResourceArn","IamRoleArn"],"members":{"BackupVaultName":{},"ResourceArn":{},"IamRoleArn":{},"IdempotencyToken":{},"StartWindowMinutes":{"type":"long"},"CompleteWindowMinutes":{"type":"long"},"Lifecycle":{"shape":"Sa"},"RecoveryPointTags":{"shape":"Sc"}}},"output":{"type":"structure","members":{"BackupJobId":{},"RecoveryPointArn":{},"CreationDate":{"type":"timestamp"}}},"idempotent":true},"StartRestoreJob":{"http":{"method":"PUT","requestUri":"/restore-jobs"},"input":{"type":"structure","required":["RecoveryPointArn","Metadata","IamRoleArn"],"members":{"RecoveryPointArn":{},"Metadata":{"shape":"S29"},"IamRoleArn":{},"IdempotencyToken":{},"ResourceType":{}}},"output":{"type":"structure","members":{"RestoreJobId":{}}},"idempotent":true},"StopBackupJob":{"http":{"requestUri":"/backup-jobs/{backupJobId}"},"input":{"type":"structure","required":["BackupJobId"],"members":{"BackupJobId":{"location":"uri","locationName":"backupJobId"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"Tags":{"shape":"Sc"}}},"idempotent":true},"UntagResource":{"http":{"requestUri":"/untag/{resourceArn}"},"input":{"type":"structure","required":["ResourceArn","TagKeyList"],"members":{"ResourceArn":{"location":"uri","locationName":"resourceArn"},"TagKeyList":{"type":"list","member":{},"sensitive":true}}},"idempotent":true},"UpdateBackupPlan":{"http":{"requestUri":"/backup/plans/{backupPlanId}"},"input":{"type":"structure","required":["BackupPlanId","BackupPlan"],"members":{"BackupPlanId":{"location":"uri","locationName":"backupPlanId"},"BackupPlan":{"shape":"S2"}}},"output":{"type":"structure","members":{"BackupPlanId":{},"BackupPlanArn":{},"CreationDate":{"type":"timestamp"},"VersionId":{}}},"idempotent":true},"UpdateRecoveryPointLifecycle":{"http":{"requestUri":"/backup-vaults/{backupVaultName}/recovery-points/{recoveryPointArn}"},"input":{"type":"structure","required":["BackupVaultName","RecoveryPointArn"],"members":{"BackupVaultName":{"location":"uri","locationName":"backupVaultName"},"RecoveryPointArn":{"location":"uri","locationName":"recoveryPointArn"},"Lifecycle":{"shape":"Sa"}}},"output":{"type":"structure","members":{"BackupVaultArn":{},"RecoveryPointArn":{},"Lifecycle":{"shape":"Sa"},"CalculatedLifecycle":{"shape":"S1g"}}},"idempotent":true}},"shapes":{"S2":{"type":"structure","required":["BackupPlanName","Rules"],"members":{"BackupPlanName":{},"Rules":{"type":"list","member":{"type":"structure","required":["RuleName","TargetBackupVaultName"],"members":{"RuleName":{},"TargetBackupVaultName":{},"ScheduleExpression":{},"StartWindowMinutes":{"type":"long"},"CompletionWindowMinutes":{"type":"long"},"Lifecycle":{"shape":"Sa"},"RecoveryPointTags":{"shape":"Sc"}}}}}},"Sa":{"type":"structure","members":{"MoveToColdStorageAfterDays":{"type":"long"},"DeleteAfterDays":{"type":"long"}}},"Sc":{"type":"map","key":{},"value":{},"sensitive":true},"Sk":{"type":"structure","required":["SelectionName","IamRoleArn"],"members":{"SelectionName":{},"IamRoleArn":{},"Resources":{"type":"list","member":{}},"ListOfTags":{"type":"list","member":{"type":"structure","required":["ConditionType","ConditionKey","ConditionValue"],"members":{"ConditionType":{},"ConditionKey":{},"ConditionValue":{}}}}}},"S16":{"type":"structure","members":{"BackupPlanId":{},"BackupPlanArn":{},"BackupPlanVersion":{},"BackupRuleId":{}}},"S1g":{"type":"structure","members":{"MoveToColdStorageAt":{"type":"timestamp"},"DeleteAt":{"type":"timestamp"}}},"S1r":{"type":"structure","required":["BackupPlanName","Rules"],"members":{"BackupPlanName":{},"Rules":{"type":"list","member":{"type":"structure","required":["RuleName","TargetBackupVaultName"],"members":{"RuleName":{},"TargetBackupVaultName":{},"ScheduleExpression":{},"StartWindowMinutes":{"type":"long"},"CompletionWindowMinutes":{"type":"long"},"Lifecycle":{"shape":"Sa"},"RecoveryPointTags":{"shape":"Sc"},"RuleId":{}}}}}},"S25":{"type":"list","member":{}},"S29":{"type":"map","key":{},"value":{}},"S2q":{"type":"structure","members":{"BackupPlanArn":{},"BackupPlanId":{},"CreationDate":{"type":"timestamp"},"DeletionDate":{"type":"timestamp"},"VersionId":{},"BackupPlanName":{},"CreatorRequestId":{},"LastExecutionDate":{"type":"timestamp"}}}}}');

});

parcelRequire.register("aMcGn", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListBackupJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListBackupPlanTemplates":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListBackupPlanVersions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListBackupPlans":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListBackupSelections":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListBackupVaults":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListProtectedResources":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListRecoveryPointsByBackupVault":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListRecoveryPointsByResource":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListRestoreJobs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTags":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("aKTDz", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $7d495ba9df30c690$var$Service = $dbC7k.Service;
var $7d495ba9df30c690$var$apiLoader = $dbC7k.apiLoader;
$7d495ba9df30c690$var$apiLoader.services["worklink"] = {};
$dbC7k.WorkLink = $7d495ba9df30c690$var$Service.defineService("worklink", [
    "2018-09-25"
]);


Object.defineProperty($7d495ba9df30c690$var$apiLoader.services["worklink"], "2018-09-25", {
    get: function get() {
        var model = (parcelRequire("bg1bp"));
        model.paginators = (parcelRequire("hQGZP")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.WorkLink;

});
parcelRequire.register("bg1bp", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-09-25","endpointPrefix":"worklink","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"WorkLink","serviceFullName":"Amazon WorkLink","serviceId":"WorkLink","signatureVersion":"v4","signingName":"worklink","uid":"worklink-2018-09-25"},"operations":{"AssociateDomain":{"http":{"requestUri":"/associateDomain"},"input":{"type":"structure","required":["FleetArn","DomainName","AcmCertificateArn"],"members":{"FleetArn":{},"DomainName":{},"DisplayName":{},"AcmCertificateArn":{}}},"output":{"type":"structure","members":{}}},"AssociateWebsiteAuthorizationProvider":{"http":{"requestUri":"/associateWebsiteAuthorizationProvider"},"input":{"type":"structure","required":["FleetArn","AuthorizationProviderType"],"members":{"FleetArn":{},"AuthorizationProviderType":{},"DomainName":{}}},"output":{"type":"structure","members":{"AuthorizationProviderId":{}}}},"AssociateWebsiteCertificateAuthority":{"http":{"requestUri":"/associateWebsiteCertificateAuthority"},"input":{"type":"structure","required":["FleetArn","Certificate"],"members":{"FleetArn":{},"Certificate":{},"DisplayName":{}}},"output":{"type":"structure","members":{"WebsiteCaId":{}}}},"CreateFleet":{"http":{"requestUri":"/createFleet"},"input":{"type":"structure","required":["FleetName"],"members":{"FleetName":{},"DisplayName":{},"OptimizeForEndUserLocation":{"type":"boolean"}}},"output":{"type":"structure","members":{"FleetArn":{}}}},"DeleteFleet":{"http":{"requestUri":"/deleteFleet"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{}}},"output":{"type":"structure","members":{}}},"DescribeAuditStreamConfiguration":{"http":{"requestUri":"/describeAuditStreamConfiguration"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{}}},"output":{"type":"structure","members":{"AuditStreamArn":{}}}},"DescribeCompanyNetworkConfiguration":{"http":{"requestUri":"/describeCompanyNetworkConfiguration"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{}}},"output":{"type":"structure","members":{"VpcId":{},"SubnetIds":{"shape":"Sq"},"SecurityGroupIds":{"shape":"Ss"}}}},"DescribeDevice":{"http":{"requestUri":"/describeDevice"},"input":{"type":"structure","required":["FleetArn","DeviceId"],"members":{"FleetArn":{},"DeviceId":{}}},"output":{"type":"structure","members":{"Status":{},"Model":{},"Manufacturer":{},"OperatingSystem":{},"OperatingSystemVersion":{},"PatchLevel":{},"FirstAccessedTime":{"type":"timestamp"},"LastAccessedTime":{"type":"timestamp"},"Username":{}}}},"DescribeDevicePolicyConfiguration":{"http":{"requestUri":"/describeDevicePolicyConfiguration"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{}}},"output":{"type":"structure","members":{"DeviceCaCertificate":{}}}},"DescribeDomain":{"http":{"requestUri":"/describeDomain"},"input":{"type":"structure","required":["FleetArn","DomainName"],"members":{"FleetArn":{},"DomainName":{}}},"output":{"type":"structure","members":{"DomainName":{},"DisplayName":{},"CreatedTime":{"type":"timestamp"},"DomainStatus":{},"AcmCertificateArn":{}}}},"DescribeFleetMetadata":{"http":{"requestUri":"/describeFleetMetadata"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{}}},"output":{"type":"structure","members":{"CreatedTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"FleetName":{},"DisplayName":{},"OptimizeForEndUserLocation":{"type":"boolean"},"CompanyCode":{},"FleetStatus":{}}}},"DescribeIdentityProviderConfiguration":{"http":{"requestUri":"/describeIdentityProviderConfiguration"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{}}},"output":{"type":"structure","members":{"IdentityProviderType":{},"ServiceProviderSamlMetadata":{},"IdentityProviderSamlMetadata":{}}}},"DescribeWebsiteCertificateAuthority":{"http":{"requestUri":"/describeWebsiteCertificateAuthority"},"input":{"type":"structure","required":["FleetArn","WebsiteCaId"],"members":{"FleetArn":{},"WebsiteCaId":{}}},"output":{"type":"structure","members":{"Certificate":{},"CreatedTime":{"type":"timestamp"},"DisplayName":{}}}},"DisassociateDomain":{"http":{"requestUri":"/disassociateDomain"},"input":{"type":"structure","required":["FleetArn","DomainName"],"members":{"FleetArn":{},"DomainName":{}}},"output":{"type":"structure","members":{}}},"DisassociateWebsiteAuthorizationProvider":{"http":{"requestUri":"/disassociateWebsiteAuthorizationProvider"},"input":{"type":"structure","required":["FleetArn","AuthorizationProviderId"],"members":{"FleetArn":{},"AuthorizationProviderId":{}}},"output":{"type":"structure","members":{}}},"DisassociateWebsiteCertificateAuthority":{"http":{"requestUri":"/disassociateWebsiteCertificateAuthority"},"input":{"type":"structure","required":["FleetArn","WebsiteCaId"],"members":{"FleetArn":{},"WebsiteCaId":{}}},"output":{"type":"structure","members":{}}},"ListDevices":{"http":{"requestUri":"/listDevices"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Devices":{"type":"list","member":{"type":"structure","members":{"DeviceId":{},"DeviceStatus":{}}}},"NextToken":{}}}},"ListDomains":{"http":{"requestUri":"/listDomains"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Domains":{"type":"list","member":{"type":"structure","required":["DomainName","CreatedTime","DomainStatus"],"members":{"DomainName":{},"DisplayName":{},"CreatedTime":{"type":"timestamp"},"DomainStatus":{}}}},"NextToken":{}}}},"ListFleets":{"http":{"requestUri":"/listFleets"},"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FleetSummaryList":{"type":"list","member":{"type":"structure","members":{"FleetArn":{},"CreatedTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"FleetName":{},"DisplayName":{},"CompanyCode":{},"FleetStatus":{}}}},"NextToken":{}}}},"ListWebsiteAuthorizationProviders":{"http":{"requestUri":"/listWebsiteAuthorizationProviders"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"WebsiteAuthorizationProviders":{"type":"list","member":{"type":"structure","required":["AuthorizationProviderType"],"members":{"AuthorizationProviderId":{},"AuthorizationProviderType":{},"DomainName":{},"CreatedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListWebsiteCertificateAuthorities":{"http":{"requestUri":"/listWebsiteCertificateAuthorities"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WebsiteCertificateAuthorities":{"type":"list","member":{"type":"structure","members":{"WebsiteCaId":{},"CreatedTime":{"type":"timestamp"},"DisplayName":{}}}},"NextToken":{}}}},"RestoreDomainAccess":{"http":{"requestUri":"/restoreDomainAccess"},"input":{"type":"structure","required":["FleetArn","DomainName"],"members":{"FleetArn":{},"DomainName":{}}},"output":{"type":"structure","members":{}}},"RevokeDomainAccess":{"http":{"requestUri":"/revokeDomainAccess"},"input":{"type":"structure","required":["FleetArn","DomainName"],"members":{"FleetArn":{},"DomainName":{}}},"output":{"type":"structure","members":{}}},"SignOutUser":{"http":{"requestUri":"/signOutUser"},"input":{"type":"structure","required":["FleetArn","Username"],"members":{"FleetArn":{},"Username":{}}},"output":{"type":"structure","members":{}}},"UpdateAuditStreamConfiguration":{"http":{"requestUri":"/updateAuditStreamConfiguration"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{},"AuditStreamArn":{}}},"output":{"type":"structure","members":{}}},"UpdateCompanyNetworkConfiguration":{"http":{"requestUri":"/updateCompanyNetworkConfiguration"},"input":{"type":"structure","required":["FleetArn","VpcId","SubnetIds","SecurityGroupIds"],"members":{"FleetArn":{},"VpcId":{},"SubnetIds":{"shape":"Sq"},"SecurityGroupIds":{"shape":"Ss"}}},"output":{"type":"structure","members":{}}},"UpdateDevicePolicyConfiguration":{"http":{"requestUri":"/updateDevicePolicyConfiguration"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{},"DeviceCaCertificate":{}}},"output":{"type":"structure","members":{}}},"UpdateDomainMetadata":{"http":{"requestUri":"/updateDomainMetadata"},"input":{"type":"structure","required":["FleetArn","DomainName"],"members":{"FleetArn":{},"DomainName":{},"DisplayName":{}}},"output":{"type":"structure","members":{}}},"UpdateFleetMetadata":{"http":{"requestUri":"/UpdateFleetMetadata"},"input":{"type":"structure","required":["FleetArn"],"members":{"FleetArn":{},"DisplayName":{},"OptimizeForEndUserLocation":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"UpdateIdentityProviderConfiguration":{"http":{"requestUri":"/updateIdentityProviderConfiguration"},"input":{"type":"structure","required":["FleetArn","IdentityProviderType"],"members":{"FleetArn":{},"IdentityProviderType":{},"IdentityProviderSamlMetadata":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sq":{"type":"list","member":{}},"Ss":{"type":"list","member":{}}}}');

});

parcelRequire.register("hQGZP", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListDevices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListDomains":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListFleets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWebsiteAuthorizationProviders":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWebsiteCertificateAuthorities":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("bdvfx", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $82a9261ea0022fd5$var$Service = $dbC7k.Service;
var $82a9261ea0022fd5$var$apiLoader = $dbC7k.apiLoader;
$82a9261ea0022fd5$var$apiLoader.services["managedblockchain"] = {};
$dbC7k.ManagedBlockchain = $82a9261ea0022fd5$var$Service.defineService("managedblockchain", [
    "2018-09-24"
]);


Object.defineProperty($82a9261ea0022fd5$var$apiLoader.services["managedblockchain"], "2018-09-24", {
    get: function get() {
        var model = (parcelRequire("e41Mx"));
        model.paginators = (parcelRequire("hnyUP")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ManagedBlockchain;

});
parcelRequire.register("e41Mx", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-09-24","endpointPrefix":"managedblockchain","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"ManagedBlockchain","serviceFullName":"Amazon Managed Blockchain","serviceId":"ManagedBlockchain","signatureVersion":"v4","signingName":"managedblockchain","uid":"managedblockchain-2018-09-24"},"operations":{"CreateMember":{"http":{"requestUri":"/networks/{networkId}/members"},"input":{"type":"structure","required":["ClientRequestToken","InvitationId","NetworkId","MemberConfiguration"],"members":{"ClientRequestToken":{"idempotencyToken":true},"InvitationId":{},"NetworkId":{"location":"uri","locationName":"networkId"},"MemberConfiguration":{"shape":"S4"}}},"output":{"type":"structure","members":{"MemberId":{}}}},"CreateNetwork":{"http":{"requestUri":"/networks"},"input":{"type":"structure","required":["ClientRequestToken","Name","Framework","FrameworkVersion","VotingPolicy","MemberConfiguration"],"members":{"ClientRequestToken":{"idempotencyToken":true},"Name":{},"Description":{},"Framework":{},"FrameworkVersion":{},"FrameworkConfiguration":{"type":"structure","members":{"Fabric":{"type":"structure","required":["Edition"],"members":{"Edition":{}}}}},"VotingPolicy":{"shape":"Sj"},"MemberConfiguration":{"shape":"S4"}}},"output":{"type":"structure","members":{"NetworkId":{},"MemberId":{}}}},"CreateNode":{"http":{"requestUri":"/networks/{networkId}/members/{memberId}/nodes"},"input":{"type":"structure","required":["ClientRequestToken","NetworkId","MemberId","NodeConfiguration"],"members":{"ClientRequestToken":{"idempotencyToken":true},"NetworkId":{"location":"uri","locationName":"networkId"},"MemberId":{"location":"uri","locationName":"memberId"},"NodeConfiguration":{"type":"structure","required":["InstanceType","AvailabilityZone"],"members":{"InstanceType":{},"AvailabilityZone":{}}}}},"output":{"type":"structure","members":{"NodeId":{}}}},"CreateProposal":{"http":{"requestUri":"/networks/{networkId}/proposals"},"input":{"type":"structure","required":["ClientRequestToken","NetworkId","MemberId","Actions"],"members":{"ClientRequestToken":{"idempotencyToken":true},"NetworkId":{"location":"uri","locationName":"networkId"},"MemberId":{},"Actions":{"shape":"Sv"},"Description":{}}},"output":{"type":"structure","members":{"ProposalId":{}}}},"DeleteMember":{"http":{"method":"DELETE","requestUri":"/networks/{networkId}/members/{memberId}"},"input":{"type":"structure","required":["NetworkId","MemberId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"MemberId":{"location":"uri","locationName":"memberId"}}},"output":{"type":"structure","members":{}}},"DeleteNode":{"http":{"method":"DELETE","requestUri":"/networks/{networkId}/members/{memberId}/nodes/{nodeId}"},"input":{"type":"structure","required":["NetworkId","MemberId","NodeId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"MemberId":{"location":"uri","locationName":"memberId"},"NodeId":{"location":"uri","locationName":"nodeId"}}},"output":{"type":"structure","members":{}}},"GetMember":{"http":{"method":"GET","requestUri":"/networks/{networkId}/members/{memberId}"},"input":{"type":"structure","required":["NetworkId","MemberId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"MemberId":{"location":"uri","locationName":"memberId"}}},"output":{"type":"structure","members":{"Member":{"type":"structure","members":{"NetworkId":{},"Id":{},"Name":{},"Description":{},"FrameworkAttributes":{"type":"structure","members":{"Fabric":{"type":"structure","members":{"AdminUsername":{},"CaEndpoint":{}}}}},"Status":{},"CreationDate":{"shape":"S1d"}}}}}},"GetNetwork":{"http":{"method":"GET","requestUri":"/networks/{networkId}"},"input":{"type":"structure","required":["NetworkId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"}}},"output":{"type":"structure","members":{"Network":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"Framework":{},"FrameworkVersion":{},"FrameworkAttributes":{"type":"structure","members":{"Fabric":{"type":"structure","members":{"OrderingServiceEndpoint":{},"Edition":{}}}}},"VpcEndpointServiceName":{},"VotingPolicy":{"shape":"Sj"},"Status":{},"CreationDate":{"shape":"S1d"}}}}}},"GetNode":{"http":{"method":"GET","requestUri":"/networks/{networkId}/members/{memberId}/nodes/{nodeId}"},"input":{"type":"structure","required":["NetworkId","MemberId","NodeId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"MemberId":{"location":"uri","locationName":"memberId"},"NodeId":{"location":"uri","locationName":"nodeId"}}},"output":{"type":"structure","members":{"Node":{"type":"structure","members":{"NetworkId":{},"MemberId":{},"Id":{},"InstanceType":{},"AvailabilityZone":{},"FrameworkAttributes":{"type":"structure","members":{"Fabric":{"type":"structure","members":{"PeerEndpoint":{},"PeerEventEndpoint":{}}}}},"Status":{},"CreationDate":{"shape":"S1d"}}}}}},"GetProposal":{"http":{"method":"GET","requestUri":"/networks/{networkId}/proposals/{proposalId}"},"input":{"type":"structure","required":["NetworkId","ProposalId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"ProposalId":{"location":"uri","locationName":"proposalId"}}},"output":{"type":"structure","members":{"Proposal":{"type":"structure","members":{"ProposalId":{},"NetworkId":{},"Description":{},"Actions":{"shape":"Sv"},"ProposedByMemberId":{},"ProposedByMemberName":{},"Status":{},"CreationDate":{"shape":"S1d"},"ExpirationDate":{"shape":"S1d"},"YesVoteCount":{"type":"integer"},"NoVoteCount":{"type":"integer"},"OutstandingVoteCount":{"type":"integer"}}}}}},"ListInvitations":{"http":{"method":"GET","requestUri":"/invitations"},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Invitations":{"type":"list","member":{"type":"structure","members":{"InvitationId":{},"CreationDate":{"shape":"S1d"},"ExpirationDate":{"shape":"S1d"},"Status":{},"NetworkSummary":{"shape":"S22"}}}},"NextToken":{}}}},"ListMembers":{"http":{"method":"GET","requestUri":"/networks/{networkId}/members"},"input":{"type":"structure","required":["NetworkId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"Name":{"location":"querystring","locationName":"name"},"Status":{"location":"querystring","locationName":"status"},"IsOwned":{"location":"querystring","locationName":"isOwned","type":"boolean"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Members":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"Status":{},"CreationDate":{"shape":"S1d"},"IsOwned":{"type":"boolean"}}}},"NextToken":{}}}},"ListNetworks":{"http":{"method":"GET","requestUri":"/networks"},"input":{"type":"structure","members":{"Name":{"location":"querystring","locationName":"name"},"Framework":{"location":"querystring","locationName":"framework"},"Status":{"location":"querystring","locationName":"status"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Networks":{"type":"list","member":{"shape":"S22"}},"NextToken":{}}}},"ListNodes":{"http":{"method":"GET","requestUri":"/networks/{networkId}/members/{memberId}/nodes"},"input":{"type":"structure","required":["NetworkId","MemberId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"MemberId":{"location":"uri","locationName":"memberId"},"Status":{"location":"querystring","locationName":"status"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Nodes":{"type":"list","member":{"type":"structure","members":{"Id":{},"Status":{},"CreationDate":{"shape":"S1d"},"AvailabilityZone":{},"InstanceType":{}}}},"NextToken":{}}}},"ListProposalVotes":{"http":{"method":"GET","requestUri":"/networks/{networkId}/proposals/{proposalId}/votes"},"input":{"type":"structure","required":["NetworkId","ProposalId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"ProposalId":{"location":"uri","locationName":"proposalId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"ProposalVotes":{"type":"list","member":{"type":"structure","members":{"Vote":{},"MemberName":{},"MemberId":{}}}},"NextToken":{}}}},"ListProposals":{"http":{"method":"GET","requestUri":"/networks/{networkId}/proposals"},"input":{"type":"structure","required":["NetworkId"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"Proposals":{"type":"list","member":{"type":"structure","members":{"ProposalId":{},"Description":{},"ProposedByMemberId":{},"ProposedByMemberName":{},"Status":{},"CreationDate":{"shape":"S1d"},"ExpirationDate":{"shape":"S1d"}}}},"NextToken":{}}}},"RejectInvitation":{"http":{"method":"DELETE","requestUri":"/invitations/{invitationId}"},"input":{"type":"structure","required":["InvitationId"],"members":{"InvitationId":{"location":"uri","locationName":"invitationId"}}},"output":{"type":"structure","members":{}}},"VoteOnProposal":{"http":{"requestUri":"/networks/{networkId}/proposals/{proposalId}/votes"},"input":{"type":"structure","required":["NetworkId","ProposalId","VoterMemberId","Vote"],"members":{"NetworkId":{"location":"uri","locationName":"networkId"},"ProposalId":{"location":"uri","locationName":"proposalId"},"VoterMemberId":{},"Vote":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S4":{"type":"structure","required":["Name","FrameworkConfiguration"],"members":{"Name":{},"Description":{},"FrameworkConfiguration":{"type":"structure","members":{"Fabric":{"type":"structure","required":["AdminUsername","AdminPassword"],"members":{"AdminUsername":{},"AdminPassword":{"type":"string","sensitive":true}}}}}}},"Sj":{"type":"structure","members":{"ApprovalThresholdPolicy":{"type":"structure","members":{"ThresholdPercentage":{"type":"integer"},"ProposalDurationInHours":{"type":"integer"},"ThresholdComparator":{}}}}},"Sv":{"type":"structure","members":{"Invitations":{"type":"list","member":{"type":"structure","required":["Principal"],"members":{"Principal":{}}}},"Removals":{"type":"list","member":{"type":"structure","required":["MemberId"],"members":{"MemberId":{}}}}}},"S1d":{"type":"timestamp","timestampFormat":"iso8601"},"S22":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"Framework":{},"FrameworkVersion":{},"Status":{},"CreationDate":{"shape":"S1d"}}}}}');

});

parcelRequire.register("hnyUP", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListInvitations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListMembers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListNetworks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListNodes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListProposalVotes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListProposals":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("5HK0a", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $4274a6dd09dd57f0$var$Service = $dbC7k.Service;
var $4274a6dd09dd57f0$var$apiLoader = $dbC7k.apiLoader;
$4274a6dd09dd57f0$var$apiLoader.services["mediapackagevod"] = {};
$dbC7k.MediaPackageVod = $4274a6dd09dd57f0$var$Service.defineService("mediapackagevod", [
    "2018-11-07"
]);


Object.defineProperty($4274a6dd09dd57f0$var$apiLoader.services["mediapackagevod"], "2018-11-07", {
    get: function get() {
        var model = (parcelRequire("8T0oy"));
        model.paginators = (parcelRequire("k4M4p")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.MediaPackageVod;

});
parcelRequire.register("8T0oy", function(module, exports) {
module.exports = JSON.parse('{"metadata":{"apiVersion":"2018-11-07","endpointPrefix":"mediapackage-vod","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"MediaPackage Vod","serviceFullName":"AWS Elemental MediaPackage VOD","serviceId":"MediaPackage Vod","signatureVersion":"v4","signingName":"mediapackage-vod","uid":"mediapackage-vod-2018-11-07"},"operations":{"CreateAsset":{"http":{"requestUri":"/assets","responseCode":200},"input":{"members":{"Id":{"locationName":"id"},"PackagingGroupId":{"locationName":"packagingGroupId"},"ResourceId":{"locationName":"resourceId"},"SourceArn":{"locationName":"sourceArn"},"SourceRoleArn":{"locationName":"sourceRoleArn"}},"required":["SourceArn","Id","PackagingGroupId","SourceRoleArn"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"EgressEndpoints":{"locationName":"egressEndpoints","shape":"S4"},"Id":{"locationName":"id"},"PackagingGroupId":{"locationName":"packagingGroupId"},"ResourceId":{"locationName":"resourceId"},"SourceArn":{"locationName":"sourceArn"},"SourceRoleArn":{"locationName":"sourceRoleArn"}},"type":"structure"}},"CreatePackagingConfiguration":{"http":{"requestUri":"/packaging_configurations","responseCode":200},"input":{"members":{"CmafPackage":{"locationName":"cmafPackage","shape":"S7"},"DashPackage":{"locationName":"dashPackage","shape":"Si"},"HlsPackage":{"locationName":"hlsPackage","shape":"Sn"},"Id":{"locationName":"id"},"MssPackage":{"locationName":"mssPackage","shape":"Sq"},"PackagingGroupId":{"locationName":"packagingGroupId"}},"required":["Id","PackagingGroupId"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"CmafPackage":{"locationName":"cmafPackage","shape":"S7"},"DashPackage":{"locationName":"dashPackage","shape":"Si"},"HlsPackage":{"locationName":"hlsPackage","shape":"Sn"},"Id":{"locationName":"id"},"MssPackage":{"locationName":"mssPackage","shape":"Sq"},"PackagingGroupId":{"locationName":"packagingGroupId"}},"type":"structure"}},"CreatePackagingGroup":{"http":{"requestUri":"/packaging_groups","responseCode":200},"input":{"members":{"Id":{"locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"Id":{"locationName":"id"}},"type":"structure"}},"DeleteAsset":{"http":{"method":"DELETE","requestUri":"/assets/{id}","responseCode":202},"input":{"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{},"type":"structure"}},"DeletePackagingConfiguration":{"http":{"method":"DELETE","requestUri":"/packaging_configurations/{id}","responseCode":202},"input":{"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{},"type":"structure"}},"DeletePackagingGroup":{"http":{"method":"DELETE","requestUri":"/packaging_groups/{id}","responseCode":202},"input":{"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{},"type":"structure"}},"DescribeAsset":{"http":{"method":"GET","requestUri":"/assets/{id}","responseCode":200},"input":{"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"EgressEndpoints":{"locationName":"egressEndpoints","shape":"S4"},"Id":{"locationName":"id"},"PackagingGroupId":{"locationName":"packagingGroupId"},"ResourceId":{"locationName":"resourceId"},"SourceArn":{"locationName":"sourceArn"},"SourceRoleArn":{"locationName":"sourceRoleArn"}},"type":"structure"}},"DescribePackagingConfiguration":{"http":{"method":"GET","requestUri":"/packaging_configurations/{id}","responseCode":200},"input":{"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"CmafPackage":{"locationName":"cmafPackage","shape":"S7"},"DashPackage":{"locationName":"dashPackage","shape":"Si"},"HlsPackage":{"locationName":"hlsPackage","shape":"Sn"},"Id":{"locationName":"id"},"MssPackage":{"locationName":"mssPackage","shape":"Sq"},"PackagingGroupId":{"locationName":"packagingGroupId"}},"type":"structure"}},"DescribePackagingGroup":{"http":{"method":"GET","requestUri":"/packaging_groups/{id}","responseCode":200},"input":{"members":{"Id":{"location":"uri","locationName":"id"}},"required":["Id"],"type":"structure"},"output":{"members":{"Arn":{"locationName":"arn"},"Id":{"locationName":"id"}},"type":"structure"}},"ListAssets":{"http":{"method":"GET","requestUri":"/assets","responseCode":200},"input":{"members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"PackagingGroupId":{"location":"querystring","locationName":"packagingGroupId"}},"type":"structure"},"output":{"members":{"Assets":{"locationName":"assets","member":{"members":{"Arn":{"locationName":"arn"},"Id":{"locationName":"id"},"PackagingGroupId":{"locationName":"packagingGroupId"},"ResourceId":{"locationName":"resourceId"},"SourceArn":{"locationName":"sourceArn"},"SourceRoleArn":{"locationName":"sourceRoleArn"}},"type":"structure"},"type":"list"},"NextToken":{"locationName":"nextToken"}},"type":"structure"}},"ListPackagingConfigurations":{"http":{"method":"GET","requestUri":"/packaging_configurations","responseCode":200},"input":{"members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"PackagingGroupId":{"location":"querystring","locationName":"packagingGroupId"}},"type":"structure"},"output":{"members":{"NextToken":{"locationName":"nextToken"},"PackagingConfigurations":{"locationName":"packagingConfigurations","member":{"members":{"Arn":{"locationName":"arn"},"CmafPackage":{"locationName":"cmafPackage","shape":"S7"},"DashPackage":{"locationName":"dashPackage","shape":"Si"},"HlsPackage":{"locationName":"hlsPackage","shape":"Sn"},"Id":{"locationName":"id"},"MssPackage":{"locationName":"mssPackage","shape":"Sq"},"PackagingGroupId":{"locationName":"packagingGroupId"}},"type":"structure"},"type":"list"}},"type":"structure"}},"ListPackagingGroups":{"http":{"method":"GET","requestUri":"/packaging_groups","responseCode":200},"input":{"members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}},"type":"structure"},"output":{"members":{"NextToken":{"locationName":"nextToken"},"PackagingGroups":{"locationName":"packagingGroups","member":{"members":{"Arn":{"locationName":"arn"},"Id":{"locationName":"id"}},"type":"structure"},"type":"list"}},"type":"structure"}}},"shapes":{"S4":{"member":{"members":{"PackagingConfigurationId":{"locationName":"packagingConfigurationId"},"Url":{"locationName":"url"}},"type":"structure"},"type":"list"},"S7":{"members":{"Encryption":{"locationName":"encryption","members":{"SpekeKeyProvider":{"locationName":"spekeKeyProvider","shape":"S9"}},"required":["SpekeKeyProvider"],"type":"structure"},"HlsManifests":{"locationName":"hlsManifests","shape":"Sb"},"SegmentDurationSeconds":{"locationName":"segmentDurationSeconds","type":"integer"}},"required":["HlsManifests"],"type":"structure"},"S9":{"members":{"RoleArn":{"locationName":"roleArn"},"SystemIds":{"locationName":"systemIds","member":{},"type":"list"},"Url":{"locationName":"url"}},"required":["SystemIds","Url","RoleArn"],"type":"structure"},"Sb":{"member":{"members":{"AdMarkers":{"locationName":"adMarkers"},"IncludeIframeOnlyStream":{"locationName":"includeIframeOnlyStream","type":"boolean"},"ManifestName":{"locationName":"manifestName"},"ProgramDateTimeIntervalSeconds":{"locationName":"programDateTimeIntervalSeconds","type":"integer"},"RepeatExtXKey":{"locationName":"repeatExtXKey","type":"boolean"},"StreamSelection":{"locationName":"streamSelection","shape":"Sg"}},"type":"structure"},"type":"list"},"Sg":{"members":{"MaxVideoBitsPerSecond":{"locationName":"maxVideoBitsPerSecond","type":"integer"},"MinVideoBitsPerSecond":{"locationName":"minVideoBitsPerSecond","type":"integer"},"StreamOrder":{"locationName":"streamOrder"}},"type":"structure"},"Si":{"members":{"DashManifests":{"locationName":"dashManifests","member":{"members":{"ManifestName":{"locationName":"manifestName"},"MinBufferTimeSeconds":{"locationName":"minBufferTimeSeconds","type":"integer"},"Profile":{"locationName":"profile"},"StreamSelection":{"locationName":"streamSelection","shape":"Sg"}},"type":"structure"},"type":"list"},"Encryption":{"locationName":"encryption","members":{"SpekeKeyProvider":{"locationName":"spekeKeyProvider","shape":"S9"}},"required":["SpekeKeyProvider"],"type":"structure"},"SegmentDurationSeconds":{"locationName":"segmentDurationSeconds","type":"integer"}},"required":["DashManifests"],"type":"structure"},"Sn":{"members":{"Encryption":{"locationName":"encryption","members":{"ConstantInitializationVector":{"locationName":"constantInitializationVector"},"EncryptionMethod":{"locationName":"encryptionMethod"},"SpekeKeyProvider":{"locationName":"spekeKeyProvider","shape":"S9"}},"required":["SpekeKeyProvider"],"type":"structure"},"HlsManifests":{"locationName":"hlsManifests","shape":"Sb"},"SegmentDurationSeconds":{"locationName":"segmentDurationSeconds","type":"integer"},"UseAudioRenditionGroup":{"locationName":"useAudioRenditionGroup","type":"boolean"}},"required":["HlsManifests"],"type":"structure"},"Sq":{"members":{"Encryption":{"locationName":"encryption","members":{"SpekeKeyProvider":{"locationName":"spekeKeyProvider","shape":"S9"}},"required":["SpekeKeyProvider"],"type":"structure"},"MssManifests":{"locationName":"mssManifests","member":{"members":{"ManifestName":{"locationName":"manifestName"},"StreamSelection":{"locationName":"streamSelection","shape":"Sg"}},"type":"structure"},"type":"list"},"SegmentDurationSeconds":{"locationName":"segmentDurationSeconds","type":"integer"}},"required":["MssManifests"],"type":"structure"}}}');

});

parcelRequire.register("k4M4p", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListAssets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Assets"},"ListPackagingConfigurations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PackagingConfigurations"},"ListPackagingGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PackagingGroups"}}}');

});


parcelRequire.register("2Z6oX", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $22c63e7d1932b681$var$Service = $dbC7k.Service;
var $22c63e7d1932b681$var$apiLoader = $dbC7k.apiLoader;
$22c63e7d1932b681$var$apiLoader.services["groundstation"] = {};
$dbC7k.GroundStation = $22c63e7d1932b681$var$Service.defineService("groundstation", [
    "2019-05-23"
]);


Object.defineProperty($22c63e7d1932b681$var$apiLoader.services["groundstation"], "2019-05-23", {
    get: function get() {
        var model = (parcelRequire("1LVUD"));
        model.paginators = (parcelRequire("ch8Kb")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.GroundStation;

});
parcelRequire.register("1LVUD", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2019-05-23","endpointPrefix":"groundstation","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"AWS Ground Station","serviceId":"GroundStation","signatureVersion":"v4","signingName":"groundstation","uid":"groundstation-2019-05-23"},"operations":{"CancelContact":{"http":{"method":"DELETE","requestUri":"/contact/{contactId}","responseCode":200},"input":{"type":"structure","required":["contactId"],"members":{"contactId":{"location":"uri","locationName":"contactId"}}},"output":{"shape":"S3"},"idempotent":true},"CreateConfig":{"http":{"requestUri":"/config","responseCode":200},"input":{"type":"structure","required":["configData","name"],"members":{"configData":{"shape":"S5"},"name":{},"tags":{"shape":"St"}}},"output":{"shape":"Su"}},"CreateDataflowEndpointGroup":{"http":{"requestUri":"/dataflowEndpointGroup","responseCode":200},"input":{"type":"structure","required":["endpointDetails"],"members":{"endpointDetails":{"shape":"Sx"},"tags":{"shape":"St"}}},"output":{"shape":"S17"}},"CreateMissionProfile":{"http":{"requestUri":"/missionprofile","responseCode":200},"input":{"type":"structure","required":["dataflowEdges","minimumViableContactDurationSeconds","name","trackingConfigArn"],"members":{"contactPostPassDurationSeconds":{"type":"integer"},"contactPrePassDurationSeconds":{"type":"integer"},"dataflowEdges":{"shape":"S1a"},"minimumViableContactDurationSeconds":{"type":"integer"},"name":{},"tags":{"shape":"St"},"trackingConfigArn":{}}},"output":{"shape":"S1c"}},"DeleteConfig":{"http":{"method":"DELETE","requestUri":"/config/{configType}/{configId}","responseCode":200},"input":{"type":"structure","required":["configId","configType"],"members":{"configId":{"location":"uri","locationName":"configId"},"configType":{"location":"uri","locationName":"configType"}}},"output":{"shape":"Su"},"idempotent":true},"DeleteDataflowEndpointGroup":{"http":{"method":"DELETE","requestUri":"/dataflowEndpointGroup/{dataflowEndpointGroupId}","responseCode":200},"input":{"type":"structure","required":["dataflowEndpointGroupId"],"members":{"dataflowEndpointGroupId":{"location":"uri","locationName":"dataflowEndpointGroupId"}}},"output":{"shape":"S17"},"idempotent":true},"DeleteMissionProfile":{"http":{"method":"DELETE","requestUri":"/missionprofile/{missionProfileId}","responseCode":200},"input":{"type":"structure","required":["missionProfileId"],"members":{"missionProfileId":{"location":"uri","locationName":"missionProfileId"}}},"output":{"shape":"S1c"},"idempotent":true},"DescribeContact":{"http":{"method":"GET","requestUri":"/contact/{contactId}","responseCode":200},"input":{"type":"structure","required":["contactId"],"members":{"contactId":{"location":"uri","locationName":"contactId"}}},"output":{"type":"structure","members":{"contactId":{},"contactStatus":{},"endTime":{"type":"timestamp"},"errorMessage":{},"groundStation":{},"maximumElevation":{"shape":"S1k"},"missionProfileArn":{},"postPassEndTime":{"type":"timestamp"},"prePassStartTime":{"type":"timestamp"},"satelliteArn":{},"startTime":{"type":"timestamp"},"tags":{"shape":"St"}}}},"GetConfig":{"http":{"method":"GET","requestUri":"/config/{configType}/{configId}","responseCode":200},"input":{"type":"structure","required":["configId","configType"],"members":{"configId":{"location":"uri","locationName":"configId"},"configType":{"location":"uri","locationName":"configType"}}},"output":{"type":"structure","required":["configArn","configData","configId","name"],"members":{"configArn":{},"configData":{"shape":"S5"},"configId":{},"configType":{},"name":{},"tags":{"shape":"St"}}}},"GetDataflowEndpointGroup":{"http":{"method":"GET","requestUri":"/dataflowEndpointGroup/{dataflowEndpointGroupId}","responseCode":200},"input":{"type":"structure","required":["dataflowEndpointGroupId"],"members":{"dataflowEndpointGroupId":{"location":"uri","locationName":"dataflowEndpointGroupId"}}},"output":{"type":"structure","members":{"dataflowEndpointGroupArn":{},"dataflowEndpointGroupId":{},"endpointsDetails":{"shape":"Sx"},"tags":{"shape":"St"}}}},"GetMissionProfile":{"http":{"method":"GET","requestUri":"/missionprofile/{missionProfileId}","responseCode":200},"input":{"type":"structure","required":["missionProfileId"],"members":{"missionProfileId":{"location":"uri","locationName":"missionProfileId"}}},"output":{"type":"structure","members":{"contactPostPassDurationSeconds":{"type":"integer"},"contactPrePassDurationSeconds":{"type":"integer"},"dataflowEdges":{"shape":"S1a"},"minimumViableContactDurationSeconds":{"type":"integer"},"missionProfileArn":{},"missionProfileId":{},"name":{},"region":{},"tags":{"shape":"St"},"trackingConfigArn":{}}}},"ListConfigs":{"http":{"method":"GET","requestUri":"/config","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"configList":{"type":"list","member":{"type":"structure","members":{"configArn":{},"configId":{},"configType":{},"name":{}}}},"nextToken":{}}}},"ListContacts":{"http":{"requestUri":"/contacts","responseCode":200},"input":{"type":"structure","required":["endTime","startTime","statusList"],"members":{"endTime":{"type":"timestamp"},"groundStation":{},"maxResults":{"type":"integer"},"missionProfileArn":{},"nextToken":{},"satelliteArn":{},"startTime":{"type":"timestamp"},"statusList":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"contactList":{"type":"list","member":{"type":"structure","members":{"contactId":{},"contactStatus":{},"endTime":{"type":"timestamp"},"errorMessage":{},"groundStation":{},"maximumElevation":{"shape":"S1k"},"missionProfileArn":{},"postPassEndTime":{"type":"timestamp"},"prePassStartTime":{"type":"timestamp"},"satelliteArn":{},"startTime":{"type":"timestamp"},"tags":{"shape":"St"}}}},"nextToken":{}}}},"ListDataflowEndpointGroups":{"http":{"method":"GET","requestUri":"/dataflowEndpointGroup","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"dataflowEndpointGroupList":{"type":"list","member":{"type":"structure","members":{"dataflowEndpointGroupArn":{},"dataflowEndpointGroupId":{}}}},"nextToken":{}}}},"ListMissionProfiles":{"http":{"method":"GET","requestUri":"/missionprofile","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"missionProfileList":{"type":"list","member":{"type":"structure","members":{"missionProfileArn":{},"missionProfileId":{},"name":{},"region":{}}}},"nextToken":{}}}},"ReserveContact":{"http":{"requestUri":"/contact","responseCode":200},"input":{"type":"structure","required":["endTime","groundStation","missionProfileArn","satelliteArn","startTime"],"members":{"endTime":{"type":"timestamp"},"groundStation":{},"missionProfileArn":{},"satelliteArn":{},"startTime":{"type":"timestamp"},"tags":{"shape":"St"}}},"output":{"shape":"S3"}},"UpdateConfig":{"http":{"method":"PUT","requestUri":"/config/{configType}/{configId}","responseCode":200},"input":{"type":"structure","required":["configData","configId","configType","name"],"members":{"configData":{"shape":"S5"},"configId":{"location":"uri","locationName":"configId"},"configType":{"location":"uri","locationName":"configType"},"name":{}}},"output":{"shape":"Su"},"idempotent":true},"UpdateMissionProfile":{"http":{"method":"PUT","requestUri":"/missionprofile/{missionProfileId}","responseCode":200},"input":{"type":"structure","required":["missionProfileId"],"members":{"contactPostPassDurationSeconds":{"type":"integer"},"contactPrePassDurationSeconds":{"type":"integer"},"dataflowEdges":{"shape":"S1a"},"minimumViableContactDurationSeconds":{"type":"integer"},"missionProfileId":{"location":"uri","locationName":"missionProfileId"},"name":{},"trackingConfigArn":{}}},"output":{"shape":"S1c"},"idempotent":true},"GetMinuteUsage":{"http":{"requestUri":"/minute-usage","responseCode":200},"input":{"type":"structure","required":["month","year"],"members":{"month":{"type":"integer"},"year":{"type":"integer"}}},"output":{"type":"structure","members":{"estimatedMinutesRemaining":{"type":"integer"},"isReservedMinutesCustomer":{"type":"boolean"},"totalReservedMinuteAllocation":{"type":"integer"},"totalScheduledMinutes":{"type":"integer"},"upcomingMinutesScheduled":{"type":"integer"}}}},"GetSatellite":{"http":{"method":"GET","requestUri":"/satellite/{satelliteId}","responseCode":200},"input":{"type":"structure","required":["satelliteId"],"members":{"satelliteId":{"location":"uri","locationName":"satelliteId"}}},"output":{"type":"structure","members":{"dateCreated":{"type":"timestamp"},"lastUpdated":{"type":"timestamp"},"noradSatelliteID":{"type":"integer"},"satelliteArn":{},"satelliteId":{},"tags":{"shape":"St"}}}},"ListGroundStations":{"http":{"method":"GET","requestUri":"/groundstation","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"groundStationList":{"type":"list","member":{"type":"structure","members":{"groundStationId":{},"groundStationName":{},"region":{}}}},"nextToken":{}}}},"ListSatellites":{"http":{"method":"GET","requestUri":"/satellite","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"nextToken":{},"satellites":{"type":"list","member":{"type":"structure","members":{"noradSatelliteID":{"type":"integer"},"satelliteArn":{},"satelliteId":{}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"St"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"St"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true}},"shapes":{"S3":{"type":"structure","members":{"contactId":{}}},"S5":{"type":"structure","members":{"antennaDownlinkConfig":{"type":"structure","required":["spectrumConfig"],"members":{"spectrumConfig":{"shape":"S7"}}},"antennaDownlinkDemodDecodeConfig":{"type":"structure","required":["decodeConfig","demodulationConfig","spectrumConfig"],"members":{"decodeConfig":{"type":"structure","required":["unvalidatedJSON"],"members":{"unvalidatedJSON":{}}},"demodulationConfig":{"type":"structure","required":["unvalidatedJSON"],"members":{"unvalidatedJSON":{}}},"spectrumConfig":{"shape":"S7"}}},"antennaUplinkConfig":{"type":"structure","required":["spectrumConfig","targetEirp"],"members":{"spectrumConfig":{"type":"structure","required":["centerFrequency"],"members":{"centerFrequency":{"shape":"Sb"},"polarization":{}}},"targetEirp":{"type":"structure","required":["units","value"],"members":{"units":{},"value":{"type":"double"}}}}},"dataflowEndpointConfig":{"type":"structure","required":["dataflowEndpointName"],"members":{"dataflowEndpointName":{}}},"trackingConfig":{"type":"structure","required":["autotrack"],"members":{"autotrack":{}}},"uplinkEchoConfig":{"type":"structure","required":["antennaUplinkConfigArn","enabled"],"members":{"antennaUplinkConfigArn":{},"enabled":{"type":"boolean"}}}}},"S7":{"type":"structure","required":["bandwidth","centerFrequency"],"members":{"bandwidth":{"type":"structure","required":["units","value"],"members":{"units":{},"value":{"type":"double"}}},"centerFrequency":{"shape":"Sb"},"polarization":{}}},"Sb":{"type":"structure","required":["units","value"],"members":{"units":{},"value":{"type":"double"}}},"St":{"type":"map","key":{},"value":{}},"Su":{"type":"structure","members":{"configArn":{},"configId":{},"configType":{}}},"Sx":{"type":"list","member":{"type":"structure","members":{"endpoint":{"type":"structure","members":{"address":{"type":"structure","required":["name","port"],"members":{"name":{},"port":{"type":"integer"}}},"name":{},"status":{}}},"securityDetails":{"type":"structure","required":["roleArn","securityGroupIds","subnetIds"],"members":{"roleArn":{},"securityGroupIds":{"type":"list","member":{}},"subnetIds":{"type":"list","member":{}}}}}}},"S17":{"type":"structure","members":{"dataflowEndpointGroupId":{}}},"S1a":{"type":"list","member":{"type":"list","member":{}}},"S1c":{"type":"structure","members":{"missionProfileId":{}}},"S1k":{"type":"structure","required":["unit","value"],"members":{"unit":{},"value":{"type":"double"}}}}}');

});

parcelRequire.register("ch8Kb", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListConfigs":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"configList"},"ListContacts":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"contactList"},"ListDataflowEndpointGroups":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"dataflowEndpointGroupList"},"ListMissionProfiles":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"missionProfileList"},"ListGroundStations":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"groundStationList"},"ListSatellites":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"satellites"}}}');

});


parcelRequire.register("7vbsP", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $5764522745dd387a$var$Service = $dbC7k.Service;
var $5764522745dd387a$var$apiLoader = $dbC7k.apiLoader;
$5764522745dd387a$var$apiLoader.services["iotthingsgraph"] = {};
$dbC7k.IoTThingsGraph = $5764522745dd387a$var$Service.defineService("iotthingsgraph", [
    "2018-09-06"
]);


Object.defineProperty($5764522745dd387a$var$apiLoader.services["iotthingsgraph"], "2018-09-06", {
    get: function get() {
        var model = (parcelRequire("1uk1G"));
        model.paginators = (parcelRequire("hxDRW")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.IoTThingsGraph;

});
parcelRequire.register("1uk1G", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-09-06","endpointPrefix":"iotthingsgraph","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS IoT Things Graph","serviceId":"IoTThingsGraph","signatureVersion":"v4","signingName":"iotthingsgraph","targetPrefix":"IotThingsGraphFrontEndService","uid":"iotthingsgraph-2018-09-06"},"operations":{"AssociateEntityToThing":{"input":{"type":"structure","required":["thingName","entityId"],"members":{"thingName":{},"entityId":{},"namespaceVersion":{"type":"long"}}},"output":{"type":"structure","members":{}}},"CreateFlowTemplate":{"input":{"type":"structure","required":["definition"],"members":{"definition":{"shape":"S7"},"compatibleNamespaceVersion":{"type":"long"}}},"output":{"type":"structure","members":{"summary":{"shape":"Sb"}}}},"CreateSystemInstance":{"input":{"type":"structure","required":["definition","target"],"members":{"tags":{"shape":"Sf"},"definition":{"shape":"S7"},"target":{},"greengrassGroupName":{},"s3BucketName":{},"metricsConfiguration":{"shape":"Sm"},"flowActionsRoleArn":{}}},"output":{"type":"structure","members":{"summary":{"shape":"Sq"}}}},"CreateSystemTemplate":{"input":{"type":"structure","required":["definition"],"members":{"definition":{"shape":"S7"},"compatibleNamespaceVersion":{"type":"long"}}},"output":{"type":"structure","members":{"summary":{"shape":"Sw"}}}},"DeleteFlowTemplate":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{}}},"DeleteNamespace":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"namespaceArn":{},"namespaceName":{}}}},"DeleteSystemInstance":{"input":{"type":"structure","members":{"id":{}}},"output":{"type":"structure","members":{}}},"DeleteSystemTemplate":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{}}},"DeploySystemInstance":{"input":{"type":"structure","members":{"id":{}}},"output":{"type":"structure","required":["summary"],"members":{"summary":{"shape":"Sq"},"greengrassDeploymentId":{}}}},"DeprecateFlowTemplate":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{}}},"DeprecateSystemTemplate":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{}}},"DescribeNamespace":{"input":{"type":"structure","members":{"namespaceName":{}}},"output":{"type":"structure","members":{"namespaceArn":{},"namespaceName":{},"trackingNamespaceName":{},"trackingNamespaceVersion":{"type":"long"},"namespaceVersion":{"type":"long"}}}},"DissociateEntityFromThing":{"input":{"type":"structure","required":["thingName","entityType"],"members":{"thingName":{},"entityType":{}}},"output":{"type":"structure","members":{}}},"GetEntities":{"input":{"type":"structure","required":["ids"],"members":{"ids":{"type":"list","member":{}},"namespaceVersion":{"type":"long"}}},"output":{"type":"structure","members":{"descriptions":{"shape":"S1l"}}}},"GetFlowTemplate":{"input":{"type":"structure","required":["id"],"members":{"id":{},"revisionNumber":{"type":"long"}}},"output":{"type":"structure","members":{"description":{"type":"structure","members":{"summary":{"shape":"Sb"},"definition":{"shape":"S7"},"validatedNamespaceVersion":{"type":"long"}}}}}},"GetFlowTemplateRevisions":{"input":{"type":"structure","required":["id"],"members":{"id":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"summaries":{"shape":"S1u"},"nextToken":{}}}},"GetNamespaceDeletionStatus":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"namespaceArn":{},"namespaceName":{},"status":{},"errorCode":{},"errorMessage":{}}}},"GetSystemInstance":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{"description":{"type":"structure","members":{"summary":{"shape":"Sq"},"definition":{"shape":"S7"},"s3BucketName":{},"metricsConfiguration":{"shape":"Sm"},"validatedNamespaceVersion":{"type":"long"},"validatedDependencyRevisions":{"type":"list","member":{"type":"structure","members":{"id":{},"revisionNumber":{"type":"long"}}}},"flowActionsRoleArn":{}}}}}},"GetSystemTemplate":{"input":{"type":"structure","required":["id"],"members":{"id":{},"revisionNumber":{"type":"long"}}},"output":{"type":"structure","members":{"description":{"type":"structure","members":{"summary":{"shape":"Sw"},"definition":{"shape":"S7"},"validatedNamespaceVersion":{"type":"long"}}}}}},"GetSystemTemplateRevisions":{"input":{"type":"structure","required":["id"],"members":{"id":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"summaries":{"shape":"S2a"},"nextToken":{}}}},"GetUploadStatus":{"input":{"type":"structure","required":["uploadId"],"members":{"uploadId":{}}},"output":{"type":"structure","required":["uploadId","uploadStatus","createdDate"],"members":{"uploadId":{},"uploadStatus":{},"namespaceArn":{},"namespaceName":{},"namespaceVersion":{"type":"long"},"failureReason":{"type":"list","member":{}},"createdDate":{"type":"timestamp"}}}},"ListFlowExecutionMessages":{"input":{"type":"structure","required":["flowExecutionId"],"members":{"flowExecutionId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"messages":{"type":"list","member":{"type":"structure","members":{"messageId":{},"eventType":{},"timestamp":{"type":"timestamp"},"payload":{}}}},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"maxResults":{"type":"integer"},"resourceArn":{},"nextToken":{}}},"output":{"type":"structure","members":{"tags":{"shape":"Sf"},"nextToken":{}}}},"SearchEntities":{"input":{"type":"structure","required":["entityTypes"],"members":{"entityTypes":{"type":"list","member":{}},"filters":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{"type":"list","member":{}}}}},"nextToken":{},"maxResults":{"type":"integer"},"namespaceVersion":{"type":"long"}}},"output":{"type":"structure","members":{"descriptions":{"shape":"S1l"},"nextToken":{}}}},"SearchFlowExecutions":{"input":{"type":"structure","required":["systemInstanceId"],"members":{"systemInstanceId":{},"flowExecutionId":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"summaries":{"type":"list","member":{"type":"structure","members":{"flowExecutionId":{},"status":{},"systemInstanceId":{},"flowTemplateId":{},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"}}}},"nextToken":{}}}},"SearchFlowTemplates":{"input":{"type":"structure","members":{"filters":{"type":"list","member":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{"type":"list","member":{}}}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"summaries":{"shape":"S1u"},"nextToken":{}}}},"SearchSystemInstances":{"input":{"type":"structure","members":{"filters":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{"type":"list","member":{}}}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"summaries":{"type":"list","member":{"shape":"Sq"}},"nextToken":{}}}},"SearchSystemTemplates":{"input":{"type":"structure","members":{"filters":{"type":"list","member":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{"type":"list","member":{}}}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"summaries":{"shape":"S2a"},"nextToken":{}}}},"SearchThings":{"input":{"type":"structure","required":["entityId"],"members":{"entityId":{},"nextToken":{},"maxResults":{"type":"integer"},"namespaceVersion":{"type":"long"}}},"output":{"type":"structure","members":{"things":{"type":"list","member":{"type":"structure","members":{"thingArn":{},"thingName":{}}}},"nextToken":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"UndeploySystemInstance":{"input":{"type":"structure","members":{"id":{}}},"output":{"type":"structure","members":{"summary":{"shape":"Sq"}}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateFlowTemplate":{"input":{"type":"structure","required":["id","definition"],"members":{"id":{},"definition":{"shape":"S7"},"compatibleNamespaceVersion":{"type":"long"}}},"output":{"type":"structure","members":{"summary":{"shape":"Sb"}}}},"UpdateSystemTemplate":{"input":{"type":"structure","required":["id","definition"],"members":{"id":{},"definition":{"shape":"S7"},"compatibleNamespaceVersion":{"type":"long"}}},"output":{"type":"structure","members":{"summary":{"shape":"Sw"}}}},"UploadEntityDefinitions":{"input":{"type":"structure","members":{"document":{"shape":"S7"},"syncWithPublicNamespace":{"type":"boolean"},"deprecateExistingEntities":{"type":"boolean"}}},"output":{"type":"structure","required":["uploadId"],"members":{"uploadId":{}}}}},"shapes":{"S7":{"type":"structure","required":["language","text"],"members":{"language":{},"text":{}}},"Sb":{"type":"structure","members":{"id":{},"arn":{},"revisionNumber":{"type":"long"},"createdAt":{"type":"timestamp"}}},"Sf":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Sm":{"type":"structure","members":{"cloudMetricEnabled":{"type":"boolean"},"metricRuleRoleArn":{}}},"Sq":{"type":"structure","members":{"id":{},"arn":{},"status":{},"target":{},"greengrassGroupName":{},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"},"greengrassGroupId":{},"greengrassGroupVersionId":{}}},"Sw":{"type":"structure","members":{"id":{},"arn":{},"revisionNumber":{"type":"long"},"createdAt":{"type":"timestamp"}}},"S1l":{"type":"list","member":{"type":"structure","members":{"id":{},"arn":{},"type":{},"createdAt":{"type":"timestamp"},"definition":{"shape":"S7"}}}},"S1u":{"type":"list","member":{"shape":"Sb"}},"S2a":{"type":"list","member":{"shape":"Sw"}}}}');

});

parcelRequire.register("hxDRW", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"GetFlowTemplateRevisions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"summaries"},"GetSystemTemplateRevisions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"summaries"},"ListFlowExecutionMessages":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"messages"},"ListTagsForResource":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"tags"},"SearchEntities":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"descriptions"},"SearchFlowExecutions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"summaries"},"SearchFlowTemplates":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"summaries"},"SearchSystemInstances":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"summaries"},"SearchSystemTemplates":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"summaries"},"SearchThings":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"things"}}}');

});


parcelRequire.register("bZ5ph", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $8b9995e7bbb8056c$var$Service = $dbC7k.Service;
var $8b9995e7bbb8056c$var$apiLoader = $dbC7k.apiLoader;
$8b9995e7bbb8056c$var$apiLoader.services["iotevents"] = {};
$dbC7k.IoTEvents = $8b9995e7bbb8056c$var$Service.defineService("iotevents", [
    "2018-07-27"
]);


Object.defineProperty($8b9995e7bbb8056c$var$apiLoader.services["iotevents"], "2018-07-27", {
    get: function get() {
        var model = (parcelRequire("c1VyD"));
        model.paginators = (parcelRequire("47I3P")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.IoTEvents;

});
parcelRequire.register("c1VyD", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-07-27","endpointPrefix":"iotevents","protocol":"rest-json","serviceFullName":"AWS IoT Events","serviceId":"IoT Events","signatureVersion":"v4","signingName":"iotevents","uid":"iotevents-2018-07-27"},"operations":{"CreateDetectorModel":{"http":{"requestUri":"/detector-models"},"input":{"type":"structure","required":["detectorModelName","detectorModelDefinition","roleArn"],"members":{"detectorModelName":{},"detectorModelDefinition":{"shape":"S3"},"detectorModelDescription":{},"key":{},"roleArn":{},"tags":{"shape":"S15"}}},"output":{"type":"structure","members":{"detectorModelConfiguration":{"shape":"S1a"}}}},"CreateInput":{"http":{"requestUri":"/inputs","responseCode":201},"input":{"type":"structure","required":["inputName","inputDefinition"],"members":{"inputName":{},"inputDescription":{},"inputDefinition":{"shape":"S1h"},"tags":{"shape":"S15"}}},"output":{"type":"structure","members":{"inputConfiguration":{"shape":"S1l"}}}},"DeleteDetectorModel":{"http":{"method":"DELETE","requestUri":"/detector-models/{detectorModelName}","responseCode":204},"input":{"type":"structure","required":["detectorModelName"],"members":{"detectorModelName":{"location":"uri","locationName":"detectorModelName"}}},"output":{"type":"structure","members":{}}},"DeleteInput":{"http":{"method":"DELETE","requestUri":"/inputs/{inputName}"},"input":{"type":"structure","required":["inputName"],"members":{"inputName":{"location":"uri","locationName":"inputName"}}},"output":{"type":"structure","members":{}}},"DescribeDetectorModel":{"http":{"method":"GET","requestUri":"/detector-models/{detectorModelName}"},"input":{"type":"structure","required":["detectorModelName"],"members":{"detectorModelName":{"location":"uri","locationName":"detectorModelName"},"detectorModelVersion":{"location":"querystring","locationName":"version"}}},"output":{"type":"structure","members":{"detectorModel":{"type":"structure","members":{"detectorModelDefinition":{"shape":"S3"},"detectorModelConfiguration":{"shape":"S1a"}}}}}},"DescribeInput":{"http":{"method":"GET","requestUri":"/inputs/{inputName}"},"input":{"type":"structure","required":["inputName"],"members":{"inputName":{"location":"uri","locationName":"inputName"}}},"output":{"type":"structure","members":{"input":{"type":"structure","members":{"inputConfiguration":{"shape":"S1l"},"inputDefinition":{"shape":"S1h"}}}}}},"DescribeLoggingOptions":{"http":{"method":"GET","requestUri":"/logging"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"loggingOptions":{"shape":"S20"}}}},"ListDetectorModelVersions":{"http":{"method":"GET","requestUri":"/detector-models/{detectorModelName}/versions"},"input":{"type":"structure","required":["detectorModelName"],"members":{"detectorModelName":{"location":"uri","locationName":"detectorModelName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"detectorModelVersionSummaries":{"type":"list","member":{"type":"structure","members":{"detectorModelName":{},"detectorModelVersion":{},"detectorModelArn":{},"roleArn":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"status":{}}}},"nextToken":{}}}},"ListDetectorModels":{"http":{"method":"GET","requestUri":"/detector-models"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"detectorModelSummaries":{"type":"list","member":{"type":"structure","members":{"detectorModelName":{},"detectorModelDescription":{},"creationTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListInputs":{"http":{"method":"GET","requestUri":"/inputs"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"inputSummaries":{"type":"list","member":{"type":"structure","members":{"inputName":{},"inputDescription":{},"inputArn":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"status":{}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S15"}}}},"PutLoggingOptions":{"http":{"method":"PUT","requestUri":"/logging"},"input":{"type":"structure","required":["loggingOptions"],"members":{"loggingOptions":{"shape":"S20"}}}},"TagResource":{"http":{"requestUri":"/tags"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"tags":{"shape":"S15"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDetectorModel":{"http":{"requestUri":"/detector-models/{detectorModelName}"},"input":{"type":"structure","required":["detectorModelName","detectorModelDefinition","roleArn"],"members":{"detectorModelName":{"location":"uri","locationName":"detectorModelName"},"detectorModelDefinition":{"shape":"S3"},"detectorModelDescription":{},"roleArn":{}}},"output":{"type":"structure","members":{"detectorModelConfiguration":{"shape":"S1a"}}}},"UpdateInput":{"http":{"method":"PUT","requestUri":"/inputs/{inputName}"},"input":{"type":"structure","required":["inputName","inputDefinition"],"members":{"inputName":{"location":"uri","locationName":"inputName"},"inputDescription":{},"inputDefinition":{"shape":"S1h"}}},"output":{"type":"structure","members":{"inputConfiguration":{"shape":"S1l"}}}}},"shapes":{"S3":{"type":"structure","required":["states","initialStateName"],"members":{"states":{"type":"list","member":{"type":"structure","required":["stateName"],"members":{"stateName":{},"onInput":{"type":"structure","members":{"events":{"shape":"S8"},"transitionEvents":{"type":"list","member":{"type":"structure","required":["eventName","condition","nextState"],"members":{"eventName":{},"condition":{},"actions":{"shape":"Sc"},"nextState":{}}}}}},"onEnter":{"type":"structure","members":{"events":{"shape":"S8"}}},"onExit":{"type":"structure","members":{"events":{"shape":"S8"}}}}}},"initialStateName":{}}},"S8":{"type":"list","member":{"type":"structure","required":["eventName"],"members":{"eventName":{},"condition":{},"actions":{"shape":"Sc"}}}},"Sc":{"type":"list","member":{"type":"structure","members":{"setVariable":{"type":"structure","required":["variableName","value"],"members":{"variableName":{},"value":{}}},"sns":{"type":"structure","required":["targetArn"],"members":{"targetArn":{}}},"iotTopicPublish":{"type":"structure","required":["mqttTopic"],"members":{"mqttTopic":{}}},"setTimer":{"type":"structure","required":["timerName","seconds"],"members":{"timerName":{},"seconds":{"type":"integer"}}},"clearTimer":{"type":"structure","required":["timerName"],"members":{"timerName":{}}},"resetTimer":{"type":"structure","required":["timerName"],"members":{"timerName":{}}},"lambda":{"type":"structure","required":["functionArn"],"members":{"functionArn":{}}},"iotEvents":{"type":"structure","required":["inputName"],"members":{"inputName":{}}},"sqs":{"type":"structure","required":["queueUrl"],"members":{"queueUrl":{},"useBase64":{"type":"boolean"}}},"firehose":{"type":"structure","required":["deliveryStreamName"],"members":{"deliveryStreamName":{},"separator":{}}}}}},"S15":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"S1a":{"type":"structure","members":{"detectorModelName":{},"detectorModelVersion":{},"detectorModelDescription":{},"detectorModelArn":{},"roleArn":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"status":{},"key":{}}},"S1h":{"type":"structure","required":["attributes"],"members":{"attributes":{"type":"list","member":{"type":"structure","required":["jsonPath"],"members":{"jsonPath":{}}}}}},"S1l":{"type":"structure","required":["inputName","inputArn","creationTime","lastUpdateTime","status"],"members":{"inputName":{},"inputDescription":{},"inputArn":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"status":{}}},"S20":{"type":"structure","required":["roleArn","level","enabled"],"members":{"roleArn":{},"level":{},"enabled":{"type":"boolean"},"detectorDebugOptions":{"type":"list","member":{"type":"structure","required":["detectorModelName"],"members":{"detectorModelName":{},"keyValue":{}}}}}}}}');

});

parcelRequire.register("47I3P", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("7EhQV", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $591a1e0393712683$var$Service = $dbC7k.Service;
var $591a1e0393712683$var$apiLoader = $dbC7k.apiLoader;
$591a1e0393712683$var$apiLoader.services["ioteventsdata"] = {};
$dbC7k.IoTEventsData = $591a1e0393712683$var$Service.defineService("ioteventsdata", [
    "2018-10-23"
]);


Object.defineProperty($591a1e0393712683$var$apiLoader.services["ioteventsdata"], "2018-10-23", {
    get: function get() {
        var model = (parcelRequire("3EYUq"));
        model.paginators = (parcelRequire("c4ytu")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.IoTEventsData;

});
parcelRequire.register("3EYUq", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-10-23","endpointPrefix":"data.iotevents","protocol":"rest-json","serviceFullName":"AWS IoT Events Data","serviceId":"IoT Events Data","signatureVersion":"v4","signingName":"ioteventsdata","uid":"iotevents-data-2018-10-23"},"operations":{"BatchPutMessage":{"http":{"requestUri":"/inputs/messages","responseCode":200},"input":{"type":"structure","required":["messages"],"members":{"messages":{"type":"list","member":{"type":"structure","required":["messageId","inputName","payload"],"members":{"messageId":{},"inputName":{},"payload":{"type":"blob"}}}}}},"output":{"type":"structure","members":{"BatchPutMessageErrorEntries":{"type":"list","member":{"type":"structure","members":{"messageId":{},"errorCode":{},"errorMessage":{}}}}}}},"BatchUpdateDetector":{"http":{"requestUri":"/detectors","responseCode":200},"input":{"type":"structure","required":["detectors"],"members":{"detectors":{"type":"list","member":{"type":"structure","required":["messageId","detectorModelName","state"],"members":{"messageId":{},"detectorModelName":{},"keyValue":{},"state":{"type":"structure","required":["stateName","variables","timers"],"members":{"stateName":{},"variables":{"type":"list","member":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{}}}},"timers":{"type":"list","member":{"type":"structure","required":["name","seconds"],"members":{"name":{},"seconds":{"type":"integer"}}}}}}}}}}},"output":{"type":"structure","members":{"batchUpdateDetectorErrorEntries":{"type":"list","member":{"type":"structure","members":{"messageId":{},"errorCode":{},"errorMessage":{}}}}}}},"DescribeDetector":{"http":{"method":"GET","requestUri":"/detectors/{detectorModelName}/keyValues/"},"input":{"type":"structure","required":["detectorModelName"],"members":{"detectorModelName":{"location":"uri","locationName":"detectorModelName"},"keyValue":{"location":"querystring","locationName":"keyValue"}}},"output":{"type":"structure","members":{"detector":{"type":"structure","members":{"detectorModelName":{},"keyValue":{},"detectorModelVersion":{},"state":{"type":"structure","required":["stateName","variables","timers"],"members":{"stateName":{},"variables":{"type":"list","member":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{}}}},"timers":{"type":"list","member":{"type":"structure","required":["name","timestamp"],"members":{"name":{},"timestamp":{"type":"timestamp"}}}}}},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}}}}},"ListDetectors":{"http":{"method":"GET","requestUri":"/detectors/{detectorModelName}"},"input":{"type":"structure","required":["detectorModelName"],"members":{"detectorModelName":{"location":"uri","locationName":"detectorModelName"},"stateName":{"location":"querystring","locationName":"stateName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"detectorSummaries":{"type":"list","member":{"type":"structure","members":{"detectorModelName":{},"keyValue":{},"detectorModelVersion":{},"state":{"type":"structure","members":{"stateName":{}}},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}}},"nextToken":{}}}}},"shapes":{}}');

});

parcelRequire.register("c4ytu", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("gM8i6", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $c3678f7283b2c955$var$Service = $dbC7k.Service;
var $c3678f7283b2c955$var$apiLoader = $dbC7k.apiLoader;
$c3678f7283b2c955$var$apiLoader.services["personalize"] = {};
$dbC7k.Personalize = $c3678f7283b2c955$var$Service.defineService("personalize", [
    "2018-05-22"
]);


Object.defineProperty($c3678f7283b2c955$var$apiLoader.services["personalize"], "2018-05-22", {
    get: function get() {
        var model = (parcelRequire("gyYhY"));
        model.paginators = (parcelRequire("kfzIQ")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.Personalize;

});
parcelRequire.register("gyYhY", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-05-22","endpointPrefix":"personalize","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Personalize","serviceId":"Personalize","signatureVersion":"v4","signingName":"personalize","targetPrefix":"AmazonPersonalize","uid":"personalize-2018-05-22"},"operations":{"CreateCampaign":{"input":{"type":"structure","required":["name","solutionVersionArn","minProvisionedTPS"],"members":{"name":{},"solutionVersionArn":{},"minProvisionedTPS":{"type":"integer"}}},"output":{"type":"structure","members":{"campaignArn":{}}},"idempotent":true},"CreateDataset":{"input":{"type":"structure","required":["name","schemaArn","datasetGroupArn","datasetType"],"members":{"name":{},"schemaArn":{},"datasetGroupArn":{},"datasetType":{}}},"output":{"type":"structure","members":{"datasetArn":{}}},"idempotent":true},"CreateDatasetGroup":{"input":{"type":"structure","required":["name"],"members":{"name":{},"roleArn":{},"kmsKeyArn":{}}},"output":{"type":"structure","members":{"datasetGroupArn":{}}}},"CreateDatasetImportJob":{"input":{"type":"structure","required":["jobName","datasetArn","dataSource","roleArn"],"members":{"jobName":{},"datasetArn":{},"dataSource":{"shape":"Se"},"roleArn":{}}},"output":{"type":"structure","members":{"datasetImportJobArn":{}}}},"CreateEventTracker":{"input":{"type":"structure","required":["name","datasetGroupArn"],"members":{"name":{},"datasetGroupArn":{}}},"output":{"type":"structure","members":{"eventTrackerArn":{},"trackingId":{}}},"idempotent":true},"CreateSchema":{"input":{"type":"structure","required":["name","schema"],"members":{"name":{},"schema":{}}},"output":{"type":"structure","members":{"schemaArn":{}}},"idempotent":true},"CreateSolution":{"input":{"type":"structure","required":["name","datasetGroupArn"],"members":{"name":{},"performHPO":{"type":"boolean"},"performAutoML":{"type":"boolean"},"recipeArn":{},"datasetGroupArn":{},"eventType":{},"solutionConfig":{"shape":"Sr"}}},"output":{"type":"structure","members":{"solutionArn":{}}}},"CreateSolutionVersion":{"input":{"type":"structure","required":["solutionArn"],"members":{"solutionArn":{}}},"output":{"type":"structure","members":{"solutionVersionArn":{}}}},"DeleteCampaign":{"input":{"type":"structure","required":["campaignArn"],"members":{"campaignArn":{}}},"idempotent":true},"DeleteDataset":{"input":{"type":"structure","required":["datasetArn"],"members":{"datasetArn":{}}},"idempotent":true},"DeleteDatasetGroup":{"input":{"type":"structure","required":["datasetGroupArn"],"members":{"datasetGroupArn":{}}},"idempotent":true},"DeleteEventTracker":{"input":{"type":"structure","required":["eventTrackerArn"],"members":{"eventTrackerArn":{}}},"idempotent":true},"DeleteSchema":{"input":{"type":"structure","required":["schemaArn"],"members":{"schemaArn":{}}},"idempotent":true},"DeleteSolution":{"input":{"type":"structure","required":["solutionArn"],"members":{"solutionArn":{}}},"idempotent":true},"DescribeAlgorithm":{"input":{"type":"structure","required":["algorithmArn"],"members":{"algorithmArn":{}}},"output":{"type":"structure","members":{"algorithm":{"type":"structure","members":{"name":{},"algorithmArn":{},"algorithmImage":{"type":"structure","required":["dockerURI"],"members":{"name":{},"dockerURI":{}}},"defaultHyperParameters":{"shape":"S1e"},"defaultHyperParameterRanges":{"type":"structure","members":{"integerHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"minValue":{"type":"integer"},"maxValue":{"type":"integer"},"isTunable":{"type":"boolean"}}}},"continuousHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"minValue":{"type":"double"},"maxValue":{"type":"double"},"isTunable":{"type":"boolean"}}}},"categoricalHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"shape":"S1c"},"isTunable":{"type":"boolean"}}}}}},"defaultResourceConfig":{"type":"map","key":{},"value":{}},"trainingInputMode":{},"roleArn":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeCampaign":{"input":{"type":"structure","required":["campaignArn"],"members":{"campaignArn":{}}},"output":{"type":"structure","members":{"campaign":{"type":"structure","members":{"name":{},"campaignArn":{},"solutionVersionArn":{},"minProvisionedTPS":{"type":"integer"},"status":{},"failureReason":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"latestCampaignUpdate":{"type":"structure","members":{"solutionVersionArn":{},"minProvisionedTPS":{"type":"integer"},"status":{},"failureReason":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}}}},"idempotent":true},"DescribeDataset":{"input":{"type":"structure","required":["datasetArn"],"members":{"datasetArn":{}}},"output":{"type":"structure","members":{"dataset":{"type":"structure","members":{"name":{},"datasetArn":{},"datasetGroupArn":{},"datasetType":{},"schemaArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeDatasetGroup":{"input":{"type":"structure","required":["datasetGroupArn"],"members":{"datasetGroupArn":{}}},"output":{"type":"structure","members":{"datasetGroup":{"type":"structure","members":{"name":{},"datasetGroupArn":{},"status":{},"roleArn":{},"kmsKeyArn":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}}},"idempotent":true},"DescribeDatasetImportJob":{"input":{"type":"structure","required":["datasetImportJobArn"],"members":{"datasetImportJobArn":{}}},"output":{"type":"structure","members":{"datasetImportJob":{"type":"structure","members":{"jobName":{},"datasetImportJobArn":{},"datasetArn":{},"dataSource":{"shape":"Se"},"roleArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}}},"idempotent":true},"DescribeEventTracker":{"input":{"type":"structure","required":["eventTrackerArn"],"members":{"eventTrackerArn":{}}},"output":{"type":"structure","members":{"eventTracker":{"type":"structure","members":{"name":{},"eventTrackerArn":{},"accountId":{},"trackingId":{},"datasetGroupArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeFeatureTransformation":{"input":{"type":"structure","required":["featureTransformationArn"],"members":{"featureTransformationArn":{}}},"output":{"type":"structure","members":{"featureTransformation":{"type":"structure","members":{"name":{},"featureTransformationArn":{},"defaultParameters":{"type":"map","key":{},"value":{}},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"status":{}}}}},"idempotent":true},"DescribeRecipe":{"input":{"type":"structure","required":["recipeArn"],"members":{"recipeArn":{}}},"output":{"type":"structure","members":{"recipe":{"type":"structure","members":{"name":{},"recipeArn":{},"algorithmArn":{},"featureTransformationArn":{},"status":{},"description":{},"creationDateTime":{"type":"timestamp"},"recipeType":{},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeSchema":{"input":{"type":"structure","required":["schemaArn"],"members":{"schemaArn":{}}},"output":{"type":"structure","members":{"schema":{"type":"structure","members":{"name":{},"schemaArn":{},"schema":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeSolution":{"input":{"type":"structure","required":["solutionArn"],"members":{"solutionArn":{}}},"output":{"type":"structure","members":{"solution":{"type":"structure","members":{"name":{},"solutionArn":{},"performHPO":{"type":"boolean"},"performAutoML":{"type":"boolean"},"recipeArn":{},"datasetGroupArn":{},"eventType":{},"solutionConfig":{"shape":"Sr"},"autoMLResult":{"type":"structure","members":{"bestRecipeArn":{}}},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"latestSolutionVersion":{"shape":"S37"}}}}},"idempotent":true},"DescribeSolutionVersion":{"input":{"type":"structure","required":["solutionVersionArn"],"members":{"solutionVersionArn":{}}},"output":{"type":"structure","members":{"solutionVersion":{"type":"structure","members":{"solutionVersionArn":{},"solutionArn":{},"performHPO":{"type":"boolean"},"performAutoML":{"type":"boolean"},"recipeArn":{},"eventType":{},"datasetGroupArn":{},"solutionConfig":{"shape":"Sr"},"status":{},"failureReason":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"GetSolutionMetrics":{"input":{"type":"structure","required":["solutionVersionArn"],"members":{"solutionVersionArn":{}}},"output":{"type":"structure","members":{"solutionVersionArn":{},"metrics":{"type":"map","key":{},"value":{"type":"double"}}}}},"ListCampaigns":{"input":{"type":"structure","members":{"solutionArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"campaigns":{"type":"list","member":{"type":"structure","members":{"name":{},"campaignArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}},"nextToken":{}}},"idempotent":true},"ListDatasetGroups":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"datasetGroups":{"type":"list","member":{"type":"structure","members":{"name":{},"datasetGroupArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}},"nextToken":{}}},"idempotent":true},"ListDatasetImportJobs":{"input":{"type":"structure","members":{"datasetArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"datasetImportJobs":{"type":"list","member":{"type":"structure","members":{"datasetImportJobArn":{},"jobName":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}},"nextToken":{}}},"idempotent":true},"ListDatasets":{"input":{"type":"structure","members":{"datasetGroupArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"datasets":{"type":"list","member":{"type":"structure","members":{"name":{},"datasetArn":{},"datasetType":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{}}},"idempotent":true},"ListEventTrackers":{"input":{"type":"structure","members":{"datasetGroupArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"eventTrackers":{"type":"list","member":{"type":"structure","members":{"name":{},"eventTrackerArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{}}},"idempotent":true},"ListRecipes":{"input":{"type":"structure","members":{"recipeProvider":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"recipes":{"type":"list","member":{"type":"structure","members":{"name":{},"recipeArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{}}},"idempotent":true},"ListSchemas":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"schemas":{"type":"list","member":{"type":"structure","members":{"name":{},"schemaArn":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{}}},"idempotent":true},"ListSolutionVersions":{"input":{"type":"structure","members":{"solutionArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"solutionVersions":{"type":"list","member":{"shape":"S37"}},"nextToken":{}}},"idempotent":true},"ListSolutions":{"input":{"type":"structure","members":{"datasetGroupArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"solutions":{"type":"list","member":{"type":"structure","members":{"name":{},"solutionArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{}}},"idempotent":true},"UpdateCampaign":{"input":{"type":"structure","required":["campaignArn"],"members":{"campaignArn":{},"solutionVersionArn":{},"minProvisionedTPS":{"type":"integer"}}},"output":{"type":"structure","members":{"campaignArn":{}}},"idempotent":true}},"shapes":{"Se":{"type":"structure","members":{"dataLocation":{}}},"Sr":{"type":"structure","members":{"eventValueThreshold":{},"hpoConfig":{"type":"structure","members":{"hpoObjective":{"type":"structure","members":{"type":{},"metricName":{},"metricRegex":{}}},"hpoResourceConfig":{"type":"structure","members":{"maxNumberOfTrainingJobs":{},"maxParallelTrainingJobs":{}}},"algorithmHyperParameterRanges":{"type":"structure","members":{"integerHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"minValue":{"type":"integer"},"maxValue":{"type":"integer"}}}},"continuousHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"minValue":{"type":"double"},"maxValue":{"type":"double"}}}},"categoricalHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"shape":"S1c"}}}}}}}},"algorithmHyperParameters":{"shape":"S1e"},"featureTransformationParameters":{"type":"map","key":{},"value":{}},"autoMLConfig":{"type":"structure","members":{"metricName":{},"recipeList":{"type":"list","member":{}}}}}},"S1c":{"type":"list","member":{}},"S1e":{"type":"map","key":{},"value":{}},"S37":{"type":"structure","members":{"solutionVersionArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}}}');

});

parcelRequire.register("kfzIQ", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListCampaigns":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"campaigns"},"ListDatasetGroups":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"datasetGroups"},"ListDatasetImportJobs":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"datasetImportJobs"},"ListDatasets":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"datasets"},"ListEventTrackers":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"eventTrackers"},"ListRecipes":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"recipes"},"ListSchemas":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"schemas"},"ListSolutionVersions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"solutionVersions"},"ListSolutions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"solutions"}}}');

});


parcelRequire.register("dw836", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $9d7481e6878c04bb$var$Service = $dbC7k.Service;
var $9d7481e6878c04bb$var$apiLoader = $dbC7k.apiLoader;
$9d7481e6878c04bb$var$apiLoader.services["personalizeruntime"] = {};
$dbC7k.PersonalizeRuntime = $9d7481e6878c04bb$var$Service.defineService("personalizeruntime", [
    "2018-05-22"
]);


Object.defineProperty($9d7481e6878c04bb$var$apiLoader.services["personalizeruntime"], "2018-05-22", {
    get: function get() {
        var model = (parcelRequire("5oUMZ"));
        model.paginators = (parcelRequire("2nkZk")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.PersonalizeRuntime;

});
parcelRequire.register("5oUMZ", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-05-22","endpointPrefix":"personalize-runtime","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Personalize Runtime","serviceId":"Personalize Runtime","signatureVersion":"v4","signingName":"personalize","uid":"personalize-runtime-2018-05-22"},"operations":{"GetPersonalizedRanking":{"http":{"requestUri":"/personalize-ranking"},"input":{"type":"structure","required":["campaignArn","inputList","userId"],"members":{"campaignArn":{},"inputList":{"type":"list","member":{}},"userId":{}}},"output":{"type":"structure","members":{"personalizedRanking":{"shape":"S7"}}},"idempotent":true},"GetRecommendations":{"http":{"requestUri":"/recommendations"},"input":{"type":"structure","required":["campaignArn"],"members":{"campaignArn":{},"itemId":{},"userId":{},"numResults":{"type":"integer"}}},"output":{"type":"structure","members":{"itemList":{"shape":"S7"}}},"idempotent":true}},"shapes":{"S7":{"type":"list","member":{"type":"structure","members":{"itemId":{}}}}}}');

});

parcelRequire.register("2nkZk", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("fxe10", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $b4f4cf3632163530$var$Service = $dbC7k.Service;
var $b4f4cf3632163530$var$apiLoader = $dbC7k.apiLoader;
$b4f4cf3632163530$var$apiLoader.services["applicationinsights"] = {};
$dbC7k.ApplicationInsights = $b4f4cf3632163530$var$Service.defineService("applicationinsights", [
    "2018-11-25"
]);


Object.defineProperty($b4f4cf3632163530$var$apiLoader.services["applicationinsights"], "2018-11-25", {
    get: function get() {
        var model = (parcelRequire("2kEtb"));
        model.paginators = (parcelRequire("8sq4i")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ApplicationInsights;

});
parcelRequire.register("2kEtb", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-11-25","endpointPrefix":"applicationinsights","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Application Insights","serviceFullName":"Amazon CloudWatch Application Insights","serviceId":"Application Insights","signatureVersion":"v4","signingName":"applicationinsights","targetPrefix":"EC2WindowsBarleyService","uid":"application-insights-2018-11-25"},"operations":{"CreateApplication":{"input":{"type":"structure","required":["ResourceGroupName"],"members":{"ResourceGroupName":{},"OpsCenterEnabled":{"type":"boolean"},"OpsItemSNSTopicArn":{}}},"output":{"type":"structure","members":{"ApplicationInfo":{"shape":"S6"}}}},"CreateComponent":{"input":{"type":"structure","required":["ResourceGroupName","ComponentName","ResourceList"],"members":{"ResourceGroupName":{},"ComponentName":{},"ResourceList":{"shape":"Sb"}}},"output":{"type":"structure","members":{}}},"DeleteApplication":{"input":{"type":"structure","required":["ResourceGroupName"],"members":{"ResourceGroupName":{}}},"output":{"type":"structure","members":{}}},"DeleteComponent":{"input":{"type":"structure","required":["ResourceGroupName","ComponentName"],"members":{"ResourceGroupName":{},"ComponentName":{}}},"output":{"type":"structure","members":{}}},"DescribeApplication":{"input":{"type":"structure","required":["ResourceGroupName"],"members":{"ResourceGroupName":{}}},"output":{"type":"structure","members":{"ApplicationInfo":{"shape":"S6"}}}},"DescribeComponent":{"input":{"type":"structure","required":["ResourceGroupName","ComponentName"],"members":{"ResourceGroupName":{},"ComponentName":{}}},"output":{"type":"structure","members":{"ApplicationComponent":{"shape":"Sm"},"ResourceList":{"shape":"Sb"}}}},"DescribeComponentConfiguration":{"input":{"type":"structure","required":["ResourceGroupName","ComponentName"],"members":{"ResourceGroupName":{},"ComponentName":{}}},"output":{"type":"structure","members":{"Monitor":{"type":"boolean"},"Tier":{},"ComponentConfiguration":{}}}},"DescribeComponentConfigurationRecommendation":{"input":{"type":"structure","required":["ResourceGroupName","ComponentName","Tier"],"members":{"ResourceGroupName":{},"ComponentName":{},"Tier":{}}},"output":{"type":"structure","members":{"ComponentConfiguration":{}}}},"DescribeObservation":{"input":{"type":"structure","required":["ObservationId"],"members":{"ObservationId":{}}},"output":{"type":"structure","members":{"Observation":{"shape":"Sy"}}}},"DescribeProblem":{"input":{"type":"structure","required":["ProblemId"],"members":{"ProblemId":{}}},"output":{"type":"structure","members":{"Problem":{"shape":"S1e"}}}},"DescribeProblemObservations":{"input":{"type":"structure","required":["ProblemId"],"members":{"ProblemId":{}}},"output":{"type":"structure","members":{"RelatedObservations":{"type":"structure","members":{"ObservationList":{"type":"list","member":{"shape":"Sy"}}}}}}},"ListApplications":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ApplicationInfoList":{"type":"list","member":{"shape":"S6"}},"NextToken":{}}}},"ListComponents":{"input":{"type":"structure","required":["ResourceGroupName"],"members":{"ResourceGroupName":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ApplicationComponentList":{"type":"list","member":{"shape":"Sm"}},"NextToken":{}}}},"ListProblems":{"input":{"type":"structure","members":{"ResourceGroupName":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ProblemList":{"type":"list","member":{"shape":"S1e"}},"NextToken":{}}}},"UpdateApplication":{"input":{"type":"structure","required":["ResourceGroupName"],"members":{"ResourceGroupName":{},"OpsCenterEnabled":{"type":"boolean"},"OpsItemSNSTopicArn":{},"RemoveSNSTopic":{"type":"boolean"}}},"output":{"type":"structure","members":{"ApplicationInfo":{"shape":"S6"}}}},"UpdateComponent":{"input":{"type":"structure","required":["ResourceGroupName","ComponentName"],"members":{"ResourceGroupName":{},"ComponentName":{},"NewComponentName":{},"ResourceList":{"shape":"Sb"}}},"output":{"type":"structure","members":{}}},"UpdateComponentConfiguration":{"input":{"type":"structure","required":["ResourceGroupName","ComponentName"],"members":{"ResourceGroupName":{},"ComponentName":{},"Monitor":{"type":"boolean"},"Tier":{},"ComponentConfiguration":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S6":{"type":"structure","members":{"ResourceGroupName":{},"LifeCycle":{},"OpsItemSNSTopicArn":{},"OpsCenterEnabled":{"type":"boolean"},"Remarks":{}}},"Sb":{"type":"list","member":{}},"Sm":{"type":"structure","members":{"ComponentName":{},"ResourceType":{},"Tier":{},"Monitor":{"type":"boolean"}}},"Sy":{"type":"structure","members":{"Id":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"SourceType":{},"SourceARN":{},"LogGroup":{},"LineTime":{"type":"timestamp"},"LogText":{},"LogFilter":{},"MetricNamespace":{},"MetricName":{},"Unit":{},"Value":{"type":"double"}}},"S1e":{"type":"structure","members":{"Id":{},"Title":{},"Insights":{},"Status":{},"AffectedResource":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"SeverityLevel":{},"ResourceGroupName":{},"Feedback":{"type":"map","key":{},"value":{}}}}}}');

});

parcelRequire.register("8sq4i", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListApplications":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListComponents":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListProblems":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("aJDKj", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $7d0cf01131a4788f$var$Service = $dbC7k.Service;
var $7d0cf01131a4788f$var$apiLoader = $dbC7k.apiLoader;
$7d0cf01131a4788f$var$apiLoader.services["servicequotas"] = {};
$dbC7k.ServiceQuotas = $7d0cf01131a4788f$var$Service.defineService("servicequotas", [
    "2019-06-24"
]);


Object.defineProperty($7d0cf01131a4788f$var$apiLoader.services["servicequotas"], "2019-06-24", {
    get: function get() {
        var model = (parcelRequire("jnNAk"));
        model.paginators = (parcelRequire("4PKL5")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ServiceQuotas;

});
parcelRequire.register("jnNAk", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2019-06-24","endpointPrefix":"servicequotas","jsonVersion":"1.1","protocol":"json","serviceFullName":"Service Quotas","serviceId":"Service Quotas","signatureVersion":"v4","targetPrefix":"ServiceQuotasV20190624","uid":"service-quotas-2019-06-24"},"operations":{"AssociateServiceQuotaTemplate":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DeleteServiceQuotaIncreaseRequestFromTemplate":{"input":{"type":"structure","required":["ServiceCode","QuotaCode","AwsRegion"],"members":{"ServiceCode":{},"QuotaCode":{},"AwsRegion":{}}},"output":{"type":"structure","members":{}}},"DisassociateServiceQuotaTemplate":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"GetAWSDefaultServiceQuota":{"input":{"type":"structure","required":["ServiceCode","QuotaCode"],"members":{"ServiceCode":{},"QuotaCode":{}}},"output":{"type":"structure","members":{"Quota":{"shape":"Sc"}}}},"GetAssociationForServiceQuotaTemplate":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"ServiceQuotaTemplateAssociationStatus":{}}}},"GetRequestedServiceQuotaChange":{"input":{"type":"structure","required":["RequestId"],"members":{"RequestId":{}}},"output":{"type":"structure","members":{"RequestedQuota":{"shape":"S13"}}}},"GetServiceQuota":{"input":{"type":"structure","required":["ServiceCode","QuotaCode"],"members":{"ServiceCode":{},"QuotaCode":{}}},"output":{"type":"structure","members":{"Quota":{"shape":"Sc"}}}},"GetServiceQuotaIncreaseRequestFromTemplate":{"input":{"type":"structure","required":["ServiceCode","QuotaCode","AwsRegion"],"members":{"ServiceCode":{},"QuotaCode":{},"AwsRegion":{}}},"output":{"type":"structure","members":{"ServiceQuotaIncreaseRequestInTemplate":{"shape":"S1c"}}}},"ListAWSDefaultServiceQuotas":{"input":{"type":"structure","required":["ServiceCode"],"members":{"ServiceCode":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"Quotas":{"shape":"S1h"}}}},"ListRequestedServiceQuotaChangeHistory":{"input":{"type":"structure","members":{"ServiceCode":{},"Status":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"RequestedQuotas":{"shape":"S1k"}}}},"ListRequestedServiceQuotaChangeHistoryByQuota":{"input":{"type":"structure","required":["ServiceCode","QuotaCode"],"members":{"ServiceCode":{},"QuotaCode":{},"Status":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"RequestedQuotas":{"shape":"S1k"}}}},"ListServiceQuotaIncreaseRequestsInTemplate":{"input":{"type":"structure","members":{"ServiceCode":{},"AwsRegion":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ServiceQuotaIncreaseRequestInTemplateList":{"type":"list","member":{"shape":"S1c"}},"NextToken":{}}}},"ListServiceQuotas":{"input":{"type":"structure","required":["ServiceCode"],"members":{"ServiceCode":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"Quotas":{"shape":"S1h"}}}},"ListServices":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"Services":{"type":"list","member":{"type":"structure","members":{"ServiceCode":{},"ServiceName":{}}}}}}},"PutServiceQuotaIncreaseRequestIntoTemplate":{"input":{"type":"structure","required":["QuotaCode","ServiceCode","AwsRegion","DesiredValue"],"members":{"QuotaCode":{},"ServiceCode":{},"AwsRegion":{},"DesiredValue":{"type":"double"}}},"output":{"type":"structure","members":{"ServiceQuotaIncreaseRequestInTemplate":{"shape":"S1c"}}}},"RequestServiceQuotaIncrease":{"input":{"type":"structure","required":["ServiceCode","QuotaCode","DesiredValue"],"members":{"ServiceCode":{},"QuotaCode":{},"DesiredValue":{"type":"double"}}},"output":{"type":"structure","members":{"RequestedQuota":{"shape":"S13"}}}}},"shapes":{"Sc":{"type":"structure","members":{"ServiceCode":{},"ServiceName":{},"QuotaArn":{},"QuotaCode":{},"QuotaName":{},"Value":{"type":"double"},"Unit":{},"Adjustable":{"type":"boolean"},"GlobalQuota":{"type":"boolean"},"UsageMetric":{"type":"structure","members":{"MetricNamespace":{},"MetricName":{},"MetricDimensions":{"type":"map","key":{},"value":{}},"MetricStatisticRecommendation":{}}},"Period":{"type":"structure","members":{"PeriodValue":{"type":"integer"},"PeriodUnit":{}}},"ErrorReason":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{}}}}},"S13":{"type":"structure","members":{"Id":{},"CaseId":{},"ServiceCode":{},"ServiceName":{},"QuotaCode":{},"QuotaName":{},"DesiredValue":{"type":"double"},"Status":{},"Created":{"type":"timestamp"},"LastUpdated":{"type":"timestamp"},"Requester":{},"QuotaArn":{},"GlobalQuota":{"type":"boolean"},"Unit":{}}},"S1c":{"type":"structure","members":{"ServiceCode":{},"ServiceName":{},"QuotaCode":{},"QuotaName":{},"DesiredValue":{"type":"double"},"AwsRegion":{},"Unit":{},"GlobalQuota":{"type":"boolean"}}},"S1h":{"type":"list","member":{"shape":"Sc"}},"S1k":{"type":"list","member":{"shape":"S13"}}}}');

});

parcelRequire.register("4PKL5", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListAWSDefaultServiceQuotas":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Quotas"},"ListRequestedServiceQuotaChangeHistory":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"RequestedQuotas"},"ListRequestedServiceQuotaChangeHistoryByQuota":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"RequestedQuotas"},"ListServiceQuotaIncreaseRequestsInTemplate":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ServiceQuotaIncreaseRequestInTemplateList"},"ListServiceQuotas":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Quotas"},"ListServices":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Services"}}}');

});


parcelRequire.register("bCxOy", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $875d79299e944d97$var$Service = $dbC7k.Service;
var $875d79299e944d97$var$apiLoader = $dbC7k.apiLoader;
$875d79299e944d97$var$apiLoader.services["ec2instanceconnect"] = {};
$dbC7k.EC2InstanceConnect = $875d79299e944d97$var$Service.defineService("ec2instanceconnect", [
    "2018-04-02"
]);


Object.defineProperty($875d79299e944d97$var$apiLoader.services["ec2instanceconnect"], "2018-04-02", {
    get: function get() {
        var model = (parcelRequire("7ldlp"));
        model.paginators = (parcelRequire("eAp2y")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.EC2InstanceConnect;

});
parcelRequire.register("7ldlp", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-04-02","endpointPrefix":"ec2-instance-connect","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"EC2 Instance Connect","serviceFullName":"AWS EC2 Instance Connect","serviceId":"EC2 Instance Connect","signatureVersion":"v4","targetPrefix":"AWSEC2InstanceConnectService","uid":"ec2-instance-connect-2018-04-02"},"operations":{"SendSSHPublicKey":{"input":{"type":"structure","required":["InstanceId","InstanceOSUser","SSHPublicKey","AvailabilityZone"],"members":{"InstanceId":{},"InstanceOSUser":{},"SSHPublicKey":{},"AvailabilityZone":{}}},"output":{"type":"structure","members":{"RequestId":{},"Success":{"type":"boolean"}}}}},"shapes":{}}');

});

parcelRequire.register("eAp2y", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("74y33", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $52635169f433d276$var$Service = $dbC7k.Service;
var $52635169f433d276$var$apiLoader = $dbC7k.apiLoader;
$52635169f433d276$var$apiLoader.services["eventbridge"] = {};
$dbC7k.EventBridge = $52635169f433d276$var$Service.defineService("eventbridge", [
    "2015-10-07"
]);


Object.defineProperty($52635169f433d276$var$apiLoader.services["eventbridge"], "2015-10-07", {
    get: function get() {
        var model = (parcelRequire("5xTOb"));
        model.paginators = (parcelRequire("euvhW")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.EventBridge;

});
parcelRequire.register("5xTOb", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2015-10-07","endpointPrefix":"events","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon EventBridge","serviceId":"EventBridge","signatureVersion":"v4","targetPrefix":"AWSEvents","uid":"eventbridge-2015-10-07"},"operations":{"ActivateEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"CreateEventBus":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventSourceName":{}}},"output":{"type":"structure","members":{"EventBusArn":{}}}},"CreatePartnerEventSource":{"input":{"type":"structure","required":["Name","Account"],"members":{"Name":{},"Account":{}}},"output":{"type":"structure","members":{"EventSourceArn":{}}}},"DeactivateEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DeleteEventBus":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DeletePartnerEventSource":{"input":{"type":"structure","required":["Name","Account"],"members":{"Name":{},"Account":{}}}},"DeleteRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{},"Force":{"type":"boolean"}}}},"DescribeEventBus":{"input":{"type":"structure","members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"Policy":{}}}},"DescribeEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Arn":{},"CreatedBy":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"Name":{},"State":{}}}},"DescribePartnerEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Arn":{},"Name":{}}}},"DescribeRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"EventPattern":{},"ScheduleExpression":{},"State":{},"Description":{},"RoleArn":{},"ManagedBy":{},"EventBusName":{}}}},"DisableRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{}}}},"EnableRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{}}}},"ListEventBuses":{"input":{"type":"structure","members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"EventBuses":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{},"Policy":{}}}},"NextToken":{}}}},"ListEventSources":{"input":{"type":"structure","members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"EventSources":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreatedBy":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"Name":{},"State":{}}}},"NextToken":{}}}},"ListPartnerEventSourceAccounts":{"input":{"type":"structure","required":["EventSourceName"],"members":{"EventSourceName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"PartnerEventSourceAccounts":{"type":"list","member":{"type":"structure","members":{"Account":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"State":{}}}},"NextToken":{}}}},"ListPartnerEventSources":{"input":{"type":"structure","required":["NamePrefix"],"members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"PartnerEventSources":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Name":{}}}},"NextToken":{}}}},"ListRuleNamesByTarget":{"input":{"type":"structure","required":["TargetArn"],"members":{"TargetArn":{},"EventBusName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"RuleNames":{"type":"list","member":{}},"NextToken":{}}}},"ListRules":{"input":{"type":"structure","members":{"NamePrefix":{},"EventBusName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Rules":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{},"EventPattern":{},"State":{},"Description":{},"ScheduleExpression":{},"RoleArn":{},"ManagedBy":{},"EventBusName":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S1u"}}}},"ListTargetsByRule":{"input":{"type":"structure","required":["Rule"],"members":{"Rule":{},"EventBusName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Targets":{"shape":"S20"},"NextToken":{}}}},"PutEvents":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","members":{"Time":{"type":"timestamp"},"Source":{},"Resources":{"shape":"S2y"},"DetailType":{},"Detail":{},"EventBusName":{}}}}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"Entries":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"PutPartnerEvents":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","members":{"Time":{"type":"timestamp"},"Source":{},"Resources":{"shape":"S2y"},"DetailType":{},"Detail":{}}}}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"Entries":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"PutPermission":{"input":{"type":"structure","required":["Action","Principal","StatementId"],"members":{"EventBusName":{},"Action":{},"Principal":{},"StatementId":{},"Condition":{"type":"structure","required":["Type","Key","Value"],"members":{"Type":{},"Key":{},"Value":{}}}}}},"PutRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"ScheduleExpression":{},"EventPattern":{},"State":{},"Description":{},"RoleArn":{},"Tags":{"shape":"S1u"},"EventBusName":{}}},"output":{"type":"structure","members":{"RuleArn":{}}}},"PutTargets":{"input":{"type":"structure","required":["Rule","Targets"],"members":{"Rule":{},"EventBusName":{},"Targets":{"shape":"S20"}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"FailedEntries":{"type":"list","member":{"type":"structure","members":{"TargetId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"RemovePermission":{"input":{"type":"structure","required":["StatementId"],"members":{"StatementId":{},"EventBusName":{}}}},"RemoveTargets":{"input":{"type":"structure","required":["Rule","Ids"],"members":{"Rule":{},"EventBusName":{},"Ids":{"type":"list","member":{}},"Force":{"type":"boolean"}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"FailedEntries":{"type":"list","member":{"type":"structure","members":{"TargetId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S1u"}}},"output":{"type":"structure","members":{}}},"TestEventPattern":{"input":{"type":"structure","required":["EventPattern","Event"],"members":{"EventPattern":{},"Event":{}}},"output":{"type":"structure","members":{"Result":{"type":"boolean"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S1u":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S20":{"type":"list","member":{"type":"structure","required":["Id","Arn"],"members":{"Id":{},"Arn":{},"RoleArn":{},"Input":{},"InputPath":{},"InputTransformer":{"type":"structure","required":["InputTemplate"],"members":{"InputPathsMap":{"type":"map","key":{},"value":{}},"InputTemplate":{}}},"KinesisParameters":{"type":"structure","required":["PartitionKeyPath"],"members":{"PartitionKeyPath":{}}},"RunCommandParameters":{"type":"structure","required":["RunCommandTargets"],"members":{"RunCommandTargets":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}}}},"EcsParameters":{"type":"structure","required":["TaskDefinitionArn"],"members":{"TaskDefinitionArn":{},"TaskCount":{"type":"integer"},"LaunchType":{},"NetworkConfiguration":{"type":"structure","members":{"awsvpcConfiguration":{"type":"structure","required":["Subnets"],"members":{"Subnets":{"shape":"S2m"},"SecurityGroups":{"shape":"S2m"},"AssignPublicIp":{}}}}},"PlatformVersion":{},"Group":{}}},"BatchParameters":{"type":"structure","required":["JobDefinition","JobName"],"members":{"JobDefinition":{},"JobName":{},"ArrayProperties":{"type":"structure","members":{"Size":{"type":"integer"}}},"RetryStrategy":{"type":"structure","members":{"Attempts":{"type":"integer"}}}}},"SqsParameters":{"type":"structure","members":{"MessageGroupId":{}}}}}},"S2m":{"type":"list","member":{}},"S2y":{"type":"list","member":{}}}}');

});

parcelRequire.register("euvhW", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});


parcelRequire.register("c90QS", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $8d76fc795d7b47c3$var$Service = $dbC7k.Service;
var $8d76fc795d7b47c3$var$apiLoader = $dbC7k.apiLoader;
$8d76fc795d7b47c3$var$apiLoader.services["lakeformation"] = {};
$dbC7k.LakeFormation = $8d76fc795d7b47c3$var$Service.defineService("lakeformation", [
    "2017-03-31"
]);


Object.defineProperty($8d76fc795d7b47c3$var$apiLoader.services["lakeformation"], "2017-03-31", {
    get: function get() {
        var model = (parcelRequire("lredC"));
        model.paginators = (parcelRequire("hvygg")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.LakeFormation;

});
parcelRequire.register("lredC", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2017-03-31","endpointPrefix":"lakeformation","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Lake Formation","serviceId":"LakeFormation","signatureVersion":"v4","signingName":"lakeformation","targetPrefix":"AWSLakeFormation","uid":"lakeformation-2017-03-31"},"operations":{"BatchGrantPermissions":{"input":{"type":"structure","required":["Entries"],"members":{"CatalogId":{},"Entries":{"shape":"S3"}}},"output":{"type":"structure","members":{"Failures":{"shape":"Sl"}}}},"BatchRevokePermissions":{"input":{"type":"structure","required":["Entries"],"members":{"CatalogId":{},"Entries":{"shape":"S3"}}},"output":{"type":"structure","members":{"Failures":{"shape":"Sl"}}}},"DeregisterResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"DescribeResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"ResourceInfo":{"shape":"Sv"}}}},"GetDataLakeSettings":{"input":{"type":"structure","members":{"CatalogId":{}}},"output":{"type":"structure","members":{"DataLakeSettings":{"shape":"S10"}}}},"GetEffectivePermissionsForPath":{"input":{"type":"structure","required":["ResourceArn"],"members":{"CatalogId":{},"ResourceArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Permissions":{"shape":"S18"},"NextToken":{}}}},"GrantPermissions":{"input":{"type":"structure","required":["Principal","Resource","Permissions"],"members":{"CatalogId":{},"Principal":{"shape":"S6"},"Resource":{"shape":"S8"},"Permissions":{"shape":"Si"},"PermissionsWithGrantOption":{"shape":"Si"}}},"output":{"type":"structure","members":{}}},"ListPermissions":{"input":{"type":"structure","members":{"CatalogId":{},"Principal":{"shape":"S6"},"ResourceType":{},"Resource":{"shape":"S8"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PrincipalResourcePermissions":{"shape":"S18"},"NextToken":{}}}},"ListResources":{"input":{"type":"structure","members":{"FilterConditionList":{"type":"list","member":{"type":"structure","members":{"Field":{},"ComparisonOperator":{},"StringValueList":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ResourceInfoList":{"type":"list","member":{"shape":"Sv"}},"NextToken":{}}}},"PutDataLakeSettings":{"input":{"type":"structure","required":["DataLakeSettings"],"members":{"CatalogId":{},"DataLakeSettings":{"shape":"S10"}}},"output":{"type":"structure","members":{}}},"RegisterResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"UseServiceLinkedRole":{"type":"boolean"},"RoleArn":{}}},"output":{"type":"structure","members":{}}},"RevokePermissions":{"input":{"type":"structure","required":["Principal","Resource","Permissions"],"members":{"CatalogId":{},"Principal":{"shape":"S6"},"Resource":{"shape":"S8"},"Permissions":{"shape":"Si"},"PermissionsWithGrantOption":{"shape":"Si"}}},"output":{"type":"structure","members":{}}},"UpdateResource":{"input":{"type":"structure","required":["RoleArn","ResourceArn"],"members":{"RoleArn":{},"ResourceArn":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S3":{"type":"list","member":{"shape":"S4"}},"S4":{"type":"structure","required":["Id"],"members":{"Id":{},"Principal":{"shape":"S6"},"Resource":{"shape":"S8"},"Permissions":{"shape":"Si"},"PermissionsWithGrantOption":{"shape":"Si"}}},"S6":{"type":"structure","members":{"DataLakePrincipalIdentifier":{}}},"S8":{"type":"structure","members":{"Catalog":{"type":"structure","members":{}},"Database":{"type":"structure","required":["Name"],"members":{"Name":{}}},"Table":{"type":"structure","required":["DatabaseName","Name"],"members":{"DatabaseName":{},"Name":{}}},"TableWithColumns":{"type":"structure","members":{"DatabaseName":{},"Name":{},"ColumnNames":{"shape":"Se"},"ColumnWildcard":{"type":"structure","members":{"ExcludedColumnNames":{"shape":"Se"}}}}},"DataLocation":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}}}},"Se":{"type":"list","member":{}},"Si":{"type":"list","member":{}},"Sl":{"type":"list","member":{"type":"structure","members":{"RequestEntry":{"shape":"S4"},"Error":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{}}}}}},"Sv":{"type":"structure","members":{"ResourceArn":{},"RoleArn":{},"LastModified":{"type":"timestamp"}}},"S10":{"type":"structure","members":{"DataLakeAdmins":{"type":"list","member":{"shape":"S6"}},"CreateDatabaseDefaultPermissions":{"shape":"S12"},"CreateTableDefaultPermissions":{"shape":"S12"}}},"S12":{"type":"list","member":{"type":"structure","members":{"Principal":{"shape":"S6"},"Permissions":{"shape":"Si"}}}},"S18":{"type":"list","member":{"type":"structure","members":{"Principal":{"shape":"S6"},"Resource":{"shape":"S8"},"Permissions":{"shape":"Si"},"PermissionsWithGrantOption":{"shape":"Si"}}}}}}');

});

parcelRequire.register("hvygg", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"GetEffectivePermissionsForPath":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListPermissions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListResources":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}');

});


parcelRequire.register("cvExU", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $91b7d4e1d60b9ff0$var$Service = $dbC7k.Service;
var $91b7d4e1d60b9ff0$var$apiLoader = $dbC7k.apiLoader;
$91b7d4e1d60b9ff0$var$apiLoader.services["forecastservice"] = {};
$dbC7k.ForecastService = $91b7d4e1d60b9ff0$var$Service.defineService("forecastservice", [
    "2018-06-26"
]);


Object.defineProperty($91b7d4e1d60b9ff0$var$apiLoader.services["forecastservice"], "2018-06-26", {
    get: function get() {
        var model = (parcelRequire("i7X9B"));
        model.paginators = (parcelRequire("4mP46")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ForecastService;

});
parcelRequire.register("i7X9B", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-06-26","endpointPrefix":"forecast","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Forecast Service","serviceId":"forecast","signatureVersion":"v4","signingName":"forecast","targetPrefix":"AmazonForecast","uid":"forecast-2018-06-26"},"operations":{"CreateDataset":{"input":{"type":"structure","required":["DatasetName","Domain","DatasetType","Schema"],"members":{"DatasetName":{},"Domain":{},"DatasetType":{},"DataFrequency":{},"Schema":{"shape":"S6"},"EncryptionConfig":{"shape":"Sa"}}},"output":{"type":"structure","members":{"DatasetArn":{}}}},"CreateDatasetGroup":{"input":{"type":"structure","required":["DatasetGroupName","Domain"],"members":{"DatasetGroupName":{},"Domain":{},"DatasetArns":{"shape":"Sf"}}},"output":{"type":"structure","members":{"DatasetGroupArn":{}}}},"CreateDatasetImportJob":{"input":{"type":"structure","required":["DatasetImportJobName","DatasetArn","DataSource"],"members":{"DatasetImportJobName":{},"DatasetArn":{},"DataSource":{"shape":"Si"},"TimestampFormat":{}}},"output":{"type":"structure","members":{"DatasetImportJobArn":{}}}},"CreateForecast":{"input":{"type":"structure","required":["ForecastName","PredictorArn"],"members":{"ForecastName":{},"PredictorArn":{}}},"output":{"type":"structure","members":{"ForecastArn":{}}}},"CreateForecastExportJob":{"input":{"type":"structure","required":["ForecastExportJobName","ForecastArn","Destination"],"members":{"ForecastExportJobName":{},"ForecastArn":{},"Destination":{"shape":"Sq"}}},"output":{"type":"structure","members":{"ForecastExportJobArn":{}}}},"CreatePredictor":{"input":{"type":"structure","required":["PredictorName","ForecastHorizon","InputDataConfig","FeaturizationConfig"],"members":{"PredictorName":{},"AlgorithmArn":{},"ForecastHorizon":{"type":"integer"},"PerformAutoML":{"type":"boolean"},"PerformHPO":{"type":"boolean"},"TrainingParameters":{"shape":"Sv"},"EvaluationParameters":{"shape":"Sy"},"HPOConfig":{"shape":"Sz"},"InputDataConfig":{"shape":"S1b"},"FeaturizationConfig":{"shape":"S1e"},"EncryptionConfig":{"shape":"Sa"}}},"output":{"type":"structure","members":{"PredictorArn":{}}}},"DeleteDataset":{"input":{"type":"structure","required":["DatasetArn"],"members":{"DatasetArn":{}}},"idempotent":true},"DeleteDatasetGroup":{"input":{"type":"structure","required":["DatasetGroupArn"],"members":{"DatasetGroupArn":{}}},"idempotent":true},"DeleteDatasetImportJob":{"input":{"type":"structure","required":["DatasetImportJobArn"],"members":{"DatasetImportJobArn":{}}},"idempotent":true},"DeleteForecast":{"input":{"type":"structure","required":["ForecastArn"],"members":{"ForecastArn":{}}},"idempotent":true},"DeleteForecastExportJob":{"input":{"type":"structure","required":["ForecastExportJobArn"],"members":{"ForecastExportJobArn":{}}},"idempotent":true},"DeletePredictor":{"input":{"type":"structure","required":["PredictorArn"],"members":{"PredictorArn":{}}},"idempotent":true},"DescribeDataset":{"input":{"type":"structure","required":["DatasetArn"],"members":{"DatasetArn":{}}},"output":{"type":"structure","members":{"DatasetArn":{},"DatasetName":{},"Domain":{},"DatasetType":{},"DataFrequency":{},"Schema":{"shape":"S6"},"EncryptionConfig":{"shape":"Sa"},"Status":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"DescribeDatasetGroup":{"input":{"type":"structure","required":["DatasetGroupArn"],"members":{"DatasetGroupArn":{}}},"output":{"type":"structure","members":{"DatasetGroupName":{},"DatasetGroupArn":{},"DatasetArns":{"shape":"Sf"},"Domain":{},"Status":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"DescribeDatasetImportJob":{"input":{"type":"structure","required":["DatasetImportJobArn"],"members":{"DatasetImportJobArn":{}}},"output":{"type":"structure","members":{"DatasetImportJobName":{},"DatasetImportJobArn":{},"DatasetArn":{},"TimestampFormat":{},"DataSource":{"shape":"Si"},"FieldStatistics":{"type":"map","key":{},"value":{"type":"structure","members":{"Count":{"type":"integer"},"CountDistinct":{"type":"integer"},"CountNull":{"type":"integer"},"CountNan":{"type":"integer"},"Min":{},"Max":{},"Avg":{"type":"double"},"Stddev":{"type":"double"}}}},"DataSize":{"type":"double"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"DescribeForecast":{"input":{"type":"structure","required":["ForecastArn"],"members":{"ForecastArn":{}}},"output":{"type":"structure","members":{"ForecastArn":{},"ForecastName":{},"PredictorArn":{},"DatasetGroupArn":{},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"DescribeForecastExportJob":{"input":{"type":"structure","required":["ForecastExportJobArn"],"members":{"ForecastExportJobArn":{}}},"output":{"type":"structure","members":{"ForecastExportJobArn":{},"ForecastExportJobName":{},"ForecastArn":{},"Destination":{"shape":"Sq"},"Message":{},"Status":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"DescribePredictor":{"input":{"type":"structure","required":["PredictorArn"],"members":{"PredictorArn":{}}},"output":{"type":"structure","members":{"PredictorArn":{},"PredictorName":{},"AlgorithmArn":{},"ForecastHorizon":{"type":"integer"},"PerformAutoML":{"type":"boolean"},"PerformHPO":{"type":"boolean"},"TrainingParameters":{"shape":"Sv"},"EvaluationParameters":{"shape":"Sy"},"HPOConfig":{"shape":"Sz"},"InputDataConfig":{"shape":"S1b"},"FeaturizationConfig":{"shape":"S1e"},"EncryptionConfig":{"shape":"Sa"},"DatasetImportJobArns":{"shape":"Sf"},"AutoMLAlgorithmArns":{"shape":"Sf"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"GetAccuracyMetrics":{"input":{"type":"structure","required":["PredictorArn"],"members":{"PredictorArn":{}}},"output":{"type":"structure","members":{"PredictorEvaluationResults":{"type":"list","member":{"type":"structure","members":{"AlgorithmArn":{},"TestWindows":{"type":"list","member":{"type":"structure","members":{"TestWindowStart":{"type":"timestamp"},"TestWindowEnd":{"type":"timestamp"},"ItemCount":{"type":"integer"},"EvaluationType":{},"Metrics":{"type":"structure","members":{"RMSE":{"type":"double"},"WeightedQuantileLosses":{"type":"list","member":{"type":"structure","members":{"Quantile":{"type":"double"},"LossValue":{"type":"double"}}}}}}}}}}}}}},"idempotent":true},"ListDatasetGroups":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DatasetGroups":{"type":"list","member":{"type":"structure","members":{"DatasetGroupArn":{},"DatasetGroupName":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListDatasetImportJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S2t"}}},"output":{"type":"structure","members":{"DatasetImportJobs":{"type":"list","member":{"type":"structure","members":{"DatasetImportJobArn":{},"DatasetImportJobName":{},"DataSource":{"shape":"Si"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListDatasets":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Datasets":{"type":"list","member":{"type":"structure","members":{"DatasetArn":{},"DatasetName":{},"DatasetType":{},"Domain":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListForecastExportJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S2t"}}},"output":{"type":"structure","members":{"ForecastExportJobs":{"type":"list","member":{"type":"structure","members":{"ForecastExportJobArn":{},"ForecastExportJobName":{},"Destination":{"shape":"Sq"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListForecasts":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S2t"}}},"output":{"type":"structure","members":{"Forecasts":{"type":"list","member":{"type":"structure","members":{"ForecastArn":{},"ForecastName":{},"PredictorArn":{},"DatasetGroupArn":{},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListPredictors":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S2t"}}},"output":{"type":"structure","members":{"Predictors":{"type":"list","member":{"type":"structure","members":{"PredictorArn":{},"PredictorName":{},"DatasetGroupArn":{},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"UpdateDatasetGroup":{"input":{"type":"structure","required":["DatasetGroupArn","DatasetArns"],"members":{"DatasetGroupArn":{},"DatasetArns":{"shape":"Sf"}}},"output":{"type":"structure","members":{}},"idempotent":true}},"shapes":{"S6":{"type":"structure","members":{"Attributes":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeType":{}}}}}},"Sa":{"type":"structure","required":["RoleArn","KMSKeyArn"],"members":{"RoleArn":{},"KMSKeyArn":{}}},"Sf":{"type":"list","member":{}},"Si":{"type":"structure","required":["S3Config"],"members":{"S3Config":{"shape":"Sj"}}},"Sj":{"type":"structure","required":["Path","RoleArn"],"members":{"Path":{},"RoleArn":{},"KMSKeyArn":{}}},"Sq":{"type":"structure","required":["S3Config"],"members":{"S3Config":{"shape":"Sj"}}},"Sv":{"type":"map","key":{},"value":{}},"Sy":{"type":"structure","members":{"NumberOfBacktestWindows":{"type":"integer"},"BackTestWindowOffset":{"type":"integer"}}},"Sz":{"type":"structure","members":{"ParameterRanges":{"type":"structure","members":{"CategoricalParameterRanges":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{}}}}},"ContinuousParameterRanges":{"type":"list","member":{"type":"structure","required":["Name","MaxValue","MinValue"],"members":{"Name":{},"MaxValue":{"type":"double"},"MinValue":{"type":"double"},"ScalingType":{}}}},"IntegerParameterRanges":{"type":"list","member":{"type":"structure","required":["Name","MaxValue","MinValue"],"members":{"Name":{},"MaxValue":{"type":"integer"},"MinValue":{"type":"integer"},"ScalingType":{}}}}}}}},"S1b":{"type":"structure","required":["DatasetGroupArn"],"members":{"DatasetGroupArn":{},"SupplementaryFeatures":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}}}},"S1e":{"type":"structure","required":["ForecastFrequency"],"members":{"ForecastFrequency":{},"ForecastDimensions":{"type":"list","member":{}},"Featurizations":{"type":"list","member":{"type":"structure","required":["AttributeName"],"members":{"AttributeName":{},"FeaturizationPipeline":{"type":"list","member":{"type":"structure","required":["FeaturizationMethodName"],"members":{"FeaturizationMethodName":{},"FeaturizationMethodParameters":{"type":"map","key":{},"value":{}}}}}}}}}},"S2t":{"type":"list","member":{"type":"structure","required":["Key","Value","Condition"],"members":{"Key":{},"Value":{},"Condition":{}}}}}}');

});

parcelRequire.register("4mP46", function(module, exports) {
module.exports = JSON.parse('{"pagination":{"ListDatasetGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DatasetGroups"},"ListDatasetImportJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DatasetImportJobs"},"ListDatasets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Datasets"},"ListForecastExportJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ForecastExportJobs"},"ListForecasts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Forecasts"},"ListPredictors":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Predictors"}}}');

});


parcelRequire.register("cfIZP", function(module, exports) {
parcelRequire("hDDYX");

var $dbC7k = parcelRequire("dbC7k");
var $8eb9ca0f0e1b58b3$var$Service = $dbC7k.Service;
var $8eb9ca0f0e1b58b3$var$apiLoader = $dbC7k.apiLoader;
$8eb9ca0f0e1b58b3$var$apiLoader.services["forecastqueryservice"] = {};
$dbC7k.ForecastQueryService = $8eb9ca0f0e1b58b3$var$Service.defineService("forecastqueryservice", [
    "2018-06-26"
]);


Object.defineProperty($8eb9ca0f0e1b58b3$var$apiLoader.services["forecastqueryservice"], "2018-06-26", {
    get: function get() {
        var model = (parcelRequire("hZqoO"));
        model.paginators = (parcelRequire("e0Ewp")).pagination;
        return model;
    },
    enumerable: true,
    configurable: true
});
module.exports = $dbC7k.ForecastQueryService;

});
parcelRequire.register("hZqoO", function(module, exports) {
module.exports = JSON.parse('{"version":"2.0","metadata":{"apiVersion":"2018-06-26","endpointPrefix":"forecastquery","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Forecast Query Service","serviceId":"forecastquery","signatureVersion":"v4","signingName":"forecast","targetPrefix":"AmazonForecastRuntime","uid":"forecastquery-2018-06-26"},"operations":{"QueryForecast":{"input":{"type":"structure","required":["ForecastArn","Filters"],"members":{"ForecastArn":{},"StartDate":{},"EndDate":{},"Filters":{"type":"map","key":{},"value":{}},"NextToken":{}}},"output":{"type":"structure","members":{"Forecast":{"type":"structure","members":{"Predictions":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"Timestamp":{},"Value":{"type":"double"}}}}}}}}}}},"shapes":{}}');

});

parcelRequire.register("e0Ewp", function(module, exports) {
module.exports = JSON.parse('{"pagination":{}}');

});





parcelRequire.register("3K689", function(module, exports) {
parcelRequire("eOV94");
var $rynSq = parcelRequire("rynSq");
parcelRequire("lnK4H");
var $g0yeX = parcelRequire("g0yeX");
var $1B2FB = parcelRequire("1B2FB");
var $eHzYr = parcelRequire("eHzYr");
var $2b9a6c59998651c5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2b9a6c59998651c5$var$AmazonAIPredictionsProvider = /** @class */ function(_super) {
    $2b9a6c59998651c5$var$__extends(AmazonAIPredictionsProvider, _super);
    function AmazonAIPredictionsProvider() {
        var _this = _super.call(this) || this;
        _this.convertProvider = new (0, $g0yeX.default)();
        _this.identifyProvider = new (0, $1B2FB.default)();
        _this.interpretProvider = new (0, $eHzYr.default)();
        return _this;
    }
    AmazonAIPredictionsProvider.prototype.getCategory = function() {
        return "Predictions";
    };
    AmazonAIPredictionsProvider.prototype.getProviderName = function() {
        return "AmazonAIPredictionsProvider";
    };
    AmazonAIPredictionsProvider.prototype.configure = function(config) {
        this.convertProvider.configure(config.convert);
        this.identifyProvider.configure(config.identify);
        this.interpretProvider.configure(config.interpret);
        return config;
    };
    AmazonAIPredictionsProvider.prototype.interpret = function(input) {
        return this.interpretProvider.interpret(input);
    };
    AmazonAIPredictionsProvider.prototype.convert = function(input) {
        return this.convertProvider.convert(input);
    };
    AmazonAIPredictionsProvider.prototype.identify = function(input) {
        return this.identifyProvider.identify(input);
    };
    return AmazonAIPredictionsProvider;
}((0, $rynSq.AbstractPredictionsProvider));
var $2b9a6c59998651c5$export$2e2bcd8739ae039 = $2b9a6c59998651c5$var$AmazonAIPredictionsProvider;

});



parcelRequire.register("aVHtR", function(module, exports) {

$parcel$export(module.exports, "DataStore", function () { return (parcelRequire("fT5s7")).DataStore; });

var $2hWDt = parcelRequire("2hWDt");

var $fT5s7 = parcelRequire("fT5s7");

var $55dhS = parcelRequire("55dhS");
parcelRequire("6BLoD");
(0, $2hWDt.default).register((0, $fT5s7.DataStore));

});
parcelRequire.register("fT5s7", function(module, exports) {

$parcel$export(module.exports, "DataStore", function () { return $b91038d986fb67bc$export$47a0e4800a1fd7dc; });
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");

var $3T1MG = parcelRequire("3T1MG");

var $toYCK = parcelRequire("toYCK");

var $eOKlk = parcelRequire("eOKlk");

var $55dhS = parcelRequire("55dhS");

var $gy2GN = parcelRequire("gy2GN");

var $jhcba = parcelRequire("jhcba");

var $6BLoD = parcelRequire("6BLoD");

var $6uSfH = parcelRequire("6uSfH");
var $b91038d986fb67bc$var$__assign = undefined && undefined.__assign || function() {
    $b91038d986fb67bc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b91038d986fb67bc$var$__assign.apply(this, arguments);
};
var $b91038d986fb67bc$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b91038d986fb67bc$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $b91038d986fb67bc$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
(0, $3T1MG.setAutoFreeze)(true);
var $b91038d986fb67bc$var$logger = new (0, $gBqCF.ConsoleLogger)("DataStore");
var $b91038d986fb67bc$var$SETTING_SCHEMA_VERSION = "schemaVersion";
var $b91038d986fb67bc$var$storage;
var $b91038d986fb67bc$var$schema;
var $b91038d986fb67bc$var$modelNamespaceMap = new WeakMap();
var $b91038d986fb67bc$var$getModelDefinition = function(modelConstructor) {
    var namespace = $b91038d986fb67bc$var$modelNamespaceMap.get(modelConstructor);
    return $b91038d986fb67bc$var$schema.namespaces[namespace].models[modelConstructor.name];
};
var $b91038d986fb67bc$var$isValidModelConstructor = function(obj) {
    return (0, $6uSfH.isModelConstructor)(obj) && $b91038d986fb67bc$var$modelNamespaceMap.has(obj);
};
var $b91038d986fb67bc$var$namespaceResolver = function(modelConstructor) {
    return $b91038d986fb67bc$var$modelNamespaceMap.get(modelConstructor);
};
var $b91038d986fb67bc$var$dataStoreClasses;
var $b91038d986fb67bc$var$userClasses;
var $b91038d986fb67bc$var$syncClasses;
var $b91038d986fb67bc$var$storageClasses;
var $b91038d986fb67bc$export$4bef7a97dd1e4451 = function(userSchema) {
    var _a;
    if ($b91038d986fb67bc$var$schema !== undefined) throw new Error("The schema has already been initialized");
    $b91038d986fb67bc$var$logger.log("validating schema", {
        schema: userSchema
    });
    var internalUserNamespace = $b91038d986fb67bc$var$__assign({
        name: (0, $6uSfH.USER)
    }, userSchema);
    $b91038d986fb67bc$var$logger.log("DataStore", "Init models");
    $b91038d986fb67bc$var$userClasses = $b91038d986fb67bc$var$createTypeClasses(internalUserNamespace);
    $b91038d986fb67bc$var$logger.log("DataStore", "Models initialized");
    var dataStoreNamespace = $b91038d986fb67bc$var$getNamespace();
    var storageNamespace = (0, $gy2GN.default).getNamespace();
    var syncNamespace = (0, $jhcba.SyncEngine).getNamespace();
    $b91038d986fb67bc$var$dataStoreClasses = $b91038d986fb67bc$var$createTypeClasses(dataStoreNamespace);
    $b91038d986fb67bc$var$storageClasses = $b91038d986fb67bc$var$createTypeClasses(storageNamespace);
    $b91038d986fb67bc$var$syncClasses = $b91038d986fb67bc$var$createTypeClasses(syncNamespace);
    $b91038d986fb67bc$var$schema = {
        namespaces: (_a = {}, _a[dataStoreNamespace.name] = dataStoreNamespace, _a[internalUserNamespace.name] = internalUserNamespace, _a[storageNamespace.name] = storageNamespace, _a[syncNamespace.name] = syncNamespace, _a),
        version: userSchema.version
    };
    Object.keys($b91038d986fb67bc$var$schema.namespaces).forEach(function(namespace) {
        $b91038d986fb67bc$var$schema.namespaces[namespace].relationships = (0, $6uSfH.establishRelation)($b91038d986fb67bc$var$schema.namespaces[namespace]);
        var modelAssociations = new Map();
        Object.values($b91038d986fb67bc$var$schema.namespaces[namespace].models).forEach(function(model) {
            var wea = [];
            Object.values(model.fields).filter(function(field) {
                return field.association && field.association.connectionType === "BELONGS_TO" && field.type.model !== model.name;
            }).forEach(function(field) {
                return wea.push(field.type.model);
            });
            modelAssociations.set(model.name, wea);
        });
        var result = new Map();
        var count = 1000;
        while(count > 0){
            if (modelAssociations.size === 0) break;
            count--;
            if (count === 0) throw new Error("Models are not topologically sortable. Please verify your schema.");
            for(var _i = 0, _a = Array.from(modelAssociations.keys()); _i < _a.length; _i++){
                var modelName = _a[_i];
                var parents = modelAssociations.get(modelName);
                if (parents.every(function(x) {
                    return result.has(x);
                })) result.set(modelName, parents);
            }
            Array.from(result.keys()).forEach(function(x) {
                return modelAssociations.delete(x);
            });
        }
        $b91038d986fb67bc$var$schema.namespaces[namespace].modelTopologicalOrdering = result;
    });
    return $b91038d986fb67bc$var$userClasses;
};
var $b91038d986fb67bc$var$createTypeClasses = function(namespace) {
    var classes = {};
    Object.entries(namespace.models).forEach(function(_a) {
        var modelName = _a[0], modelDefinition = _a[1];
        var clazz = $b91038d986fb67bc$var$createModelClass(modelDefinition);
        classes[modelName] = clazz;
        $b91038d986fb67bc$var$modelNamespaceMap.set(clazz, namespace.name);
    });
    Object.entries(namespace.nonModels || {}).forEach(function(_a) {
        var typeName = _a[0], typeDefinition = _a[1];
        var clazz = $b91038d986fb67bc$var$createNonModelClass(typeDefinition);
        classes[typeName] = clazz;
    });
    return classes;
};
var $b91038d986fb67bc$var$instancesMetadata = new WeakSet();
function $b91038d986fb67bc$var$modelInstanceCreator(modelConstructor, init) {
    $b91038d986fb67bc$var$instancesMetadata.add(init);
    return new modelConstructor(init);
}
var $b91038d986fb67bc$var$initializeInstance = function(init, modelDefinition, draft) {
    Object.entries(init).forEach(function(_a) {
        var k = _a[0], v = _a[1];
        var fieldDefinition = modelDefinition.fields[k];
        if (fieldDefinition !== undefined) {
            var type = fieldDefinition.type, isRequired = fieldDefinition.isRequired, name_1 = fieldDefinition.name, isArray = fieldDefinition.isArray;
            if (isRequired && (v === null || v === undefined)) throw new Error("Field " + name_1 + " is required");
            if ((0, $6BLoD.isGraphQLScalarType)(type)) {
                var jsType_1 = (0, $6BLoD.GraphQLScalarType).getJSType(type);
                if (isArray) {
                    if (!Array.isArray(v)) throw new Error("Field " + name_1 + " should be of type " + jsType_1 + "[], " + typeof v + " received. " + v);
                    if (v.some(function(e) {
                        return typeof e !== jsType_1;
                    })) {
                        var elemTypes = v.map(function(e) {
                            return typeof e;
                        }).join(",");
                        throw new Error("All elements in the " + name_1 + " array should be of type " + jsType_1 + ", [" + elemTypes + "] received. " + v);
                    }
                } else if (typeof v !== jsType_1 && v !== null) throw new Error("Field " + name_1 + " should be of type " + jsType_1 + ", " + typeof v + " received. " + v);
            }
        }
        draft[k] = v;
    });
};
var $b91038d986fb67bc$var$createModelClass = function(modelDefinition) {
    var clazz = /** @class */ function() {
        function Model(init) {
            var instance = (0, $3T1MG.produce)(this, function(draft) {
                $b91038d986fb67bc$var$initializeInstance(init, modelDefinition, draft);
                var modelInstanceMetadata = $b91038d986fb67bc$var$instancesMetadata.has(init) ? init : {};
                var _id = modelInstanceMetadata.id, _version = modelInstanceMetadata._version, _lastChangedAt = modelInstanceMetadata._lastChangedAt, _deleted = modelInstanceMetadata._deleted;
                var id = // instancesIds is set by modelInstanceCreator, it is accessible only internally
                _id !== null && _id !== undefined ? _id : modelDefinition.syncable ? (0, $toYCK.v4)() : (0, $toYCK.v1)().replace(/^(.{8})-(.{4})-(.{4})/, "$3-$2-$1");
                draft.id = id;
                if (modelDefinition.syncable) {
                    draft._version = _version;
                    draft._lastChangedAt = _lastChangedAt;
                    draft._deleted = _deleted;
                }
            });
            return instance;
        }
        Model.copyOf = function(source, fn) {
            var modelConstructor = Object.getPrototypeOf(source || {}).constructor;
            if (!$b91038d986fb67bc$var$isValidModelConstructor(modelConstructor)) {
                var msg = "The source object is not a valid model";
                $b91038d986fb67bc$var$logger.error(msg, {
                    source: source
                });
                throw new Error(msg);
            }
            return (0, $3T1MG.produce)(source, function(draft) {
                fn(draft);
                draft.id = source.id;
            });
        };
        return Model;
    }();
    clazz[0, $3T1MG.immerable] = true;
    Object.defineProperty(clazz, "name", {
        value: modelDefinition.name
    });
    return clazz;
};
var $b91038d986fb67bc$var$createNonModelClass = function(typeDefinition) {
    var clazz = /** @class */ function() {
        function Model(init) {
            var instance = (0, $3T1MG.produce)(this, function(draft) {
                $b91038d986fb67bc$var$initializeInstance(init, typeDefinition, draft);
            });
            return instance;
        }
        return Model;
    }();
    clazz[0, $3T1MG.immerable] = true;
    Object.defineProperty(clazz, "name", {
        value: typeDefinition.name
    });
    return clazz;
};
var $b91038d986fb67bc$var$save = function(model, condition) {
    return $b91038d986fb67bc$var$__awaiter(void 0, void 0, void 0, function() {
        var modelConstructor, msg, modelDefinition, producedCondition, savedModel;
        return $b91038d986fb67bc$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $b91038d986fb67bc$var$start()
                    ];
                case 1:
                    _a.sent();
                    modelConstructor = model ? model.constructor : undefined;
                    if (!$b91038d986fb67bc$var$isValidModelConstructor(modelConstructor)) {
                        msg = "Object is not an instance of a valid model";
                        $b91038d986fb67bc$var$logger.error(msg, {
                            model: model
                        });
                        throw new Error(msg);
                    }
                    modelDefinition = $b91038d986fb67bc$var$getModelDefinition(modelConstructor);
                    producedCondition = (0, $55dhS.ModelPredicateCreator).createFromExisting(modelDefinition, condition);
                    return [
                        4 /*yield*/ ,
                        $b91038d986fb67bc$var$storage.runExclusive(function(s) {
                            return $b91038d986fb67bc$var$__awaiter(void 0, void 0, void 0, function() {
                                return $b91038d986fb67bc$var$__generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                s.save(model, producedCondition)
                                            ];
                                        case 1:
                                            _a.sent();
                                            return [
                                                2 /*return*/ ,
                                                s.query(modelConstructor, (0, $55dhS.ModelPredicateCreator).createForId(modelDefinition, model.id))
                                            ];
                                    }
                                });
                            });
                        })
                    ];
                case 2:
                    savedModel = _a.sent()[0];
                    return [
                        2 /*return*/ ,
                        savedModel
                    ];
            }
        });
    });
};
var $b91038d986fb67bc$var$remove = function(modelOrConstructor, idOrCriteria) {
    return $b91038d986fb67bc$var$__awaiter(void 0, void 0, void 0, function() {
        var condition, msg, modelConstructor, msg, msg, deleted, model, modelConstructor, msg, modelDefinition, idPredicate, msg, deleted;
        return $b91038d986fb67bc$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $b91038d986fb67bc$var$start()
                    ];
                case 1:
                    _a.sent();
                    if (!modelOrConstructor) {
                        msg = "Model or Model Constructor required";
                        $b91038d986fb67bc$var$logger.error(msg, {
                            modelOrConstructor: modelOrConstructor
                        });
                        throw new Error(msg);
                    }
                    if (!$b91038d986fb67bc$var$isValidModelConstructor(modelOrConstructor)) return [
                        3 /*break*/ ,
                        3
                    ];
                    modelConstructor = modelOrConstructor;
                    if (!idOrCriteria) {
                        msg = "Id to delete or criteria required. Do you want to delete all? Pass Predicates.ALL";
                        $b91038d986fb67bc$var$logger.error(msg, {
                            idOrCriteria: idOrCriteria
                        });
                        throw new Error(msg);
                    }
                    if (typeof idOrCriteria === "string") condition = (0, $55dhS.ModelPredicateCreator).createForId($b91038d986fb67bc$var$getModelDefinition(modelConstructor), idOrCriteria);
                    else {
                        condition = (0, $55dhS.ModelPredicateCreator).createFromExisting($b91038d986fb67bc$var$getModelDefinition(modelConstructor), /**
                     * idOrCriteria is always a ProducerModelPredicate<T>, never a symbol.
                     * The symbol is used only for typing purposes. e.g. see Predicates.ALL
                     */ idOrCriteria);
                        if (!condition || !(0, $55dhS.ModelPredicateCreator).isValidPredicate(condition)) {
                            msg = "Criteria required. Do you want to delete all? Pass Predicates.ALL";
                            $b91038d986fb67bc$var$logger.error(msg, {
                                condition: condition
                            });
                            throw new Error(msg);
                        }
                    }
                    return [
                        4 /*yield*/ ,
                        $b91038d986fb67bc$var$storage.delete(modelConstructor, condition)
                    ];
                case 2:
                    deleted = _a.sent()[0];
                    return [
                        2 /*return*/ ,
                        deleted
                    ];
                case 3:
                    model = modelOrConstructor;
                    modelConstructor = Object.getPrototypeOf(model || {}).constructor;
                    if (!$b91038d986fb67bc$var$isValidModelConstructor(modelConstructor)) {
                        msg = "Object is not an instance of a valid model";
                        $b91038d986fb67bc$var$logger.error(msg, {
                            model: model
                        });
                        throw new Error(msg);
                    }
                    modelDefinition = $b91038d986fb67bc$var$getModelDefinition(modelConstructor);
                    idPredicate = (0, $55dhS.ModelPredicateCreator).createForId(modelDefinition, model.id);
                    if (idOrCriteria) {
                        if (typeof idOrCriteria !== "function") {
                            msg = "Invalid criteria";
                            $b91038d986fb67bc$var$logger.error(msg, {
                                idOrCriteria: idOrCriteria
                            });
                            throw new Error(msg);
                        }
                        condition = idOrCriteria(idPredicate);
                    } else condition = idPredicate;
                    return [
                        4 /*yield*/ ,
                        $b91038d986fb67bc$var$storage.delete(model, condition)
                    ];
                case 4:
                    deleted = _a.sent()[0][0];
                    return [
                        2 /*return*/ ,
                        deleted
                    ];
            }
        });
    });
};
var $b91038d986fb67bc$var$observe = function(modelConstructor, idOrCriteria) {
    var predicate;
    if (idOrCriteria !== undefined && modelConstructor === undefined) {
        var msg = "Cannot provide criteria without a modelConstructor";
        $b91038d986fb67bc$var$logger.error(msg, idOrCriteria);
        throw new Error(msg);
    }
    if (modelConstructor && !$b91038d986fb67bc$var$isValidModelConstructor(modelConstructor)) {
        var msg = "Constructor is not for a valid model";
        $b91038d986fb67bc$var$logger.error(msg, {
            modelConstructor: modelConstructor
        });
        throw new Error(msg);
    }
    if (typeof idOrCriteria === "string") predicate = (0, $55dhS.ModelPredicateCreator).createForId($b91038d986fb67bc$var$getModelDefinition(modelConstructor), idOrCriteria);
    else predicate = modelConstructor && (0, $55dhS.ModelPredicateCreator).createFromExisting($b91038d986fb67bc$var$getModelDefinition(modelConstructor), idOrCriteria);
    return new (0, $eOKlk.default)(function(observer) {
        var handle;
        (function() {
            return $b91038d986fb67bc$var$__awaiter(void 0, void 0, void 0, function() {
                return $b91038d986fb67bc$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                $b91038d986fb67bc$var$start()
                            ];
                        case 1:
                            _a.sent();
                            handle = $b91038d986fb67bc$var$storage.observe(modelConstructor, predicate).filter(function(_a) {
                                var model = _a.model;
                                return $b91038d986fb67bc$var$namespaceResolver(model) === (0, $6uSfH.USER);
                            }).subscribe(observer);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        })();
        return function() {
            if (handle) handle.unsubscribe();
        };
    });
};
var $b91038d986fb67bc$var$query = function(modelConstructor, idOrCriteria, pagination) {
    return $b91038d986fb67bc$var$__awaiter(void 0, void 0, void 0, function() {
        var msg, predicate_1, result, criteria, predicate, _a, limit, page;
        return $b91038d986fb67bc$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $b91038d986fb67bc$var$start()
                    ];
                case 1:
                    _b.sent();
                    if (!$b91038d986fb67bc$var$isValidModelConstructor(modelConstructor)) {
                        msg = "Constructor is not for a valid model";
                        $b91038d986fb67bc$var$logger.error(msg, {
                            modelConstructor: modelConstructor
                        });
                        throw new Error(msg);
                    }
                    if (!(typeof idOrCriteria === "string")) return [
                        3 /*break*/ ,
                        3
                    ];
                    if (pagination !== undefined) $b91038d986fb67bc$var$logger.warn("Pagination is ignored when querying by id");
                    predicate_1 = (0, $55dhS.ModelPredicateCreator).createForId($b91038d986fb67bc$var$getModelDefinition(modelConstructor), idOrCriteria);
                    return [
                        4 /*yield*/ ,
                        $b91038d986fb67bc$var$storage.query(modelConstructor, predicate_1)
                    ];
                case 2:
                    result = _b.sent()[0];
                    if (result) return [
                        2 /*return*/ ,
                        result
                    ];
                    return [
                        2 /*return*/ ,
                        undefined
                    ];
                case 3:
                    criteria = idOrCriteria;
                    predicate = !(0, $55dhS.isPredicatesAll)(criteria) ? (0, $55dhS.ModelPredicateCreator).createFromExisting($b91038d986fb67bc$var$getModelDefinition(modelConstructor), criteria) : undefined;
                    _a = pagination || {}, limit = _a.limit, page = _a.page;
                    if (page !== undefined && limit === undefined) throw new Error("Limit is required when requesting a page");
                    if (page !== undefined) {
                        if (typeof page !== "number") throw new Error("Page should be a number");
                        if (page < 0) throw new Error("Page can't be negative");
                    }
                    if (limit !== undefined) {
                        if (typeof limit !== "number") throw new Error("Limit should be a number");
                        if (limit < 0) throw new Error("Limit can't be negative");
                    }
                    return [
                        2 /*return*/ ,
                        $b91038d986fb67bc$var$storage.query(modelConstructor, predicate, pagination)
                    ];
            }
        });
    });
};
var $b91038d986fb67bc$var$sync;
var $b91038d986fb67bc$var$amplifyConfig = {};
var $b91038d986fb67bc$var$conflictHandler;
var $b91038d986fb67bc$var$errorHandler;
var $b91038d986fb67bc$var$maxRecordsToSync;
var $b91038d986fb67bc$var$syncPageSize;
var $b91038d986fb67bc$var$fullSyncInterval;
function $b91038d986fb67bc$var$configure(config) {
    if (config === void 0) config = {};
    var configDataStore = config.DataStore, configConflictHandler = config.conflictHandler, configErrorHandler = config.errorHandler, configMaxRecordsToSync = config.maxRecordsToSync, configSyncPageSize = config.syncPageSize, configFullSyncInterval = config.fullSyncInterval, configFromAmplify = $b91038d986fb67bc$var$__rest(config, [
        "DataStore",
        "conflictHandler",
        "errorHandler",
        "maxRecordsToSync",
        "syncPageSize",
        "fullSyncInterval"
    ]);
    $b91038d986fb67bc$var$amplifyConfig = $b91038d986fb67bc$var$__assign($b91038d986fb67bc$var$__assign({}, configFromAmplify), $b91038d986fb67bc$var$amplifyConfig);
    $b91038d986fb67bc$var$conflictHandler = configDataStore && configDataStore.conflictHandler || $b91038d986fb67bc$var$conflictHandler || config.conflictHandler || $b91038d986fb67bc$var$defaultConflictHandler;
    $b91038d986fb67bc$var$errorHandler = configDataStore && configDataStore.errorHandler || $b91038d986fb67bc$var$errorHandler || config.errorHandler || $b91038d986fb67bc$var$defaultErrorHandler;
    $b91038d986fb67bc$var$maxRecordsToSync = configDataStore && configDataStore.maxRecordsToSync || $b91038d986fb67bc$var$maxRecordsToSync || config.maxRecordsToSync;
    $b91038d986fb67bc$var$syncPageSize = configDataStore && configDataStore.syncPageSize || $b91038d986fb67bc$var$syncPageSize || config.syncPageSize;
    $b91038d986fb67bc$var$fullSyncInterval = configDataStore && configDataStore.fullSyncInterval || configFullSyncInterval || config.fullSyncInterval || 1440; // 1 day
}
function $b91038d986fb67bc$var$defaultConflictHandler(conflictData) {
    var localModel = conflictData.localModel, modelConstructor = conflictData.modelConstructor, remoteModel = conflictData.remoteModel;
    var _version = remoteModel._version;
    return $b91038d986fb67bc$var$modelInstanceCreator(modelConstructor, $b91038d986fb67bc$var$__assign($b91038d986fb67bc$var$__assign({}, localModel), {
        _version: _version
    }));
}
function $b91038d986fb67bc$var$defaultErrorHandler(error) {
    $b91038d986fb67bc$var$logger.warn(error);
}
function $b91038d986fb67bc$var$getModelConstructorByModelName(namespaceName, modelName) {
    var result;
    switch(namespaceName){
        case 0, $6uSfH.DATASTORE:
            result = $b91038d986fb67bc$var$dataStoreClasses[modelName];
            break;
        case 0, $6uSfH.USER:
            result = $b91038d986fb67bc$var$userClasses[modelName];
            break;
        case 0, $6uSfH.SYNC:
            result = $b91038d986fb67bc$var$syncClasses[modelName];
            break;
        case 0, $6uSfH.STORAGE:
            result = $b91038d986fb67bc$var$storageClasses[modelName];
            break;
        default:
            (0, $6uSfH.exhaustiveCheck)(namespaceName);
            break;
    }
    if ($b91038d986fb67bc$var$isValidModelConstructor(result)) return result;
    else {
        var msg = "Model name is not valid for namespace. modelName: " + modelName + ", namespace: " + namespaceName;
        $b91038d986fb67bc$var$logger.error(msg);
        throw new Error(msg);
    }
}
function $b91038d986fb67bc$var$checkSchemaVersion(storage, version) {
    return $b91038d986fb67bc$var$__awaiter(this, void 0, void 0, function() {
        var Setting, modelDefinition;
        var _this = this;
        return $b91038d986fb67bc$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    Setting = $b91038d986fb67bc$var$dataStoreClasses.Setting;
                    modelDefinition = $b91038d986fb67bc$var$schema.namespaces[0, $6uSfH.DATASTORE].models.Setting;
                    return [
                        4 /*yield*/ ,
                        storage.runExclusive(function(s) {
                            return $b91038d986fb67bc$var$__awaiter(_this, void 0, void 0, function() {
                                var schemaVersionSetting, storedValue;
                                return $b91038d986fb67bc$var$__generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                s.query(Setting, (0, $55dhS.ModelPredicateCreator).createFromExisting(modelDefinition, function(c) {
                                                    return c.key("eq", $b91038d986fb67bc$var$SETTING_SCHEMA_VERSION);
                                                }))
                                            ];
                                        case 1:
                                            schemaVersionSetting = _a.sent()[0];
                                            if (!(schemaVersionSetting !== undefined)) return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                            storedValue = JSON.parse(schemaVersionSetting.value);
                                            if (!(storedValue !== version)) return [
                                                3 /*break*/ ,
                                                3
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                s.clear(false)
                                            ];
                                        case 2:
                                            _a.sent();
                                            _a.label = 3;
                                        case 3:
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 4:
                                            return [
                                                4 /*yield*/ ,
                                                s.save($b91038d986fb67bc$var$modelInstanceCreator(Setting, {
                                                    key: $b91038d986fb67bc$var$SETTING_SCHEMA_VERSION,
                                                    value: JSON.stringify(version)
                                                }))
                                            ];
                                        case 5:
                                            _a.sent();
                                            _a.label = 6;
                                        case 6:
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        })
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
var $b91038d986fb67bc$var$syncSubscription;
var $b91038d986fb67bc$var$initResolve;
var $b91038d986fb67bc$var$initialized;
function $b91038d986fb67bc$var$start() {
    return $b91038d986fb67bc$var$__awaiter(this, void 0, void 0, function() {
        var aws_appsync_graphqlEndpoint, fullSyncIntervalInMilliseconds;
        return $b91038d986fb67bc$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!($b91038d986fb67bc$var$initialized === undefined)) return [
                        3 /*break*/ ,
                        1
                    ];
                    $b91038d986fb67bc$var$initialized = new Promise(function(res) {
                        $b91038d986fb67bc$var$initResolve = res;
                    });
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 1:
                    return [
                        4 /*yield*/ ,
                        $b91038d986fb67bc$var$initialized
                    ];
                case 2:
                    _a.sent();
                    return [
                        2 /*return*/ 
                    ];
                case 3:
                    $b91038d986fb67bc$var$storage = new (0, $gy2GN.default)($b91038d986fb67bc$var$schema, $b91038d986fb67bc$var$namespaceResolver, $b91038d986fb67bc$var$getModelConstructorByModelName, $b91038d986fb67bc$var$modelInstanceCreator);
                    return [
                        4 /*yield*/ ,
                        $b91038d986fb67bc$var$checkSchemaVersion($b91038d986fb67bc$var$storage, $b91038d986fb67bc$var$schema.version)
                    ];
                case 4:
                    _a.sent();
                    aws_appsync_graphqlEndpoint = $b91038d986fb67bc$var$amplifyConfig.aws_appsync_graphqlEndpoint;
                    if (aws_appsync_graphqlEndpoint) {
                        $b91038d986fb67bc$var$sync = new (0, $jhcba.SyncEngine)($b91038d986fb67bc$var$schema, $b91038d986fb67bc$var$namespaceResolver, $b91038d986fb67bc$var$syncClasses, $b91038d986fb67bc$var$userClasses, $b91038d986fb67bc$var$storage, $b91038d986fb67bc$var$modelInstanceCreator, $b91038d986fb67bc$var$maxRecordsToSync, $b91038d986fb67bc$var$syncPageSize, $b91038d986fb67bc$var$conflictHandler, $b91038d986fb67bc$var$errorHandler);
                        fullSyncIntervalInMilliseconds = $b91038d986fb67bc$var$fullSyncInterval * 60000;
                        $b91038d986fb67bc$var$syncSubscription = $b91038d986fb67bc$var$sync.start({
                            fullSyncInterval: fullSyncIntervalInMilliseconds
                        }).subscribe({
                            error: function(err) {
                                $b91038d986fb67bc$var$logger.warn("Sync error", err);
                            }
                        });
                    }
                    $b91038d986fb67bc$var$initResolve();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $b91038d986fb67bc$var$clear() {
    return $b91038d986fb67bc$var$__awaiter(this, void 0, void 0, function() {
        return $b91038d986fb67bc$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    if ($b91038d986fb67bc$var$storage === undefined) return [
                        2 /*return*/ 
                    ];
                    if ($b91038d986fb67bc$var$syncSubscription && !$b91038d986fb67bc$var$syncSubscription.closed) $b91038d986fb67bc$var$syncSubscription.unsubscribe();
                    return [
                        4 /*yield*/ ,
                        $b91038d986fb67bc$var$storage.clear()
                    ];
                case 1:
                    _a.sent();
                    $b91038d986fb67bc$var$initialized = undefined; // Should re-initialize when start() is called.
                    $b91038d986fb67bc$var$storage = undefined;
                    $b91038d986fb67bc$var$sync = undefined;
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $b91038d986fb67bc$var$getNamespace() {
    var namespace = {
        name: (0, $6uSfH.DATASTORE),
        relationships: {},
        enums: {},
        nonModels: {},
        models: {
            Setting: {
                name: "Setting",
                pluralName: "Settings",
                syncable: false,
                fields: {
                    id: {
                        name: "id",
                        type: "ID",
                        isRequired: true,
                        isArray: false
                    },
                    key: {
                        name: "key",
                        type: "String",
                        isRequired: true,
                        isArray: false
                    },
                    value: {
                        name: "value",
                        type: "String",
                        isRequired: true,
                        isArray: false
                    }
                }
            }
        }
    };
    return namespace;
}
var $b91038d986fb67bc$export$47a0e4800a1fd7dc = /** @class */ function() {
    function DataStore() {}
    DataStore.getModuleName = function() {
        return "DataStore";
    };
    DataStore.query = $b91038d986fb67bc$var$query;
    DataStore.save = $b91038d986fb67bc$var$save;
    DataStore.delete = $b91038d986fb67bc$var$remove;
    DataStore.observe = $b91038d986fb67bc$var$observe;
    DataStore.configure = $b91038d986fb67bc$var$configure;
    DataStore.clear = $b91038d986fb67bc$var$clear;
    return DataStore;
}();

});
parcelRequire.register("3T1MG", function(module, exports) {

$parcel$export(module.exports, "immerable", function () { return $2d47e473ea7f7d0f$export$6ee2082928bcb0ee; });
$parcel$export(module.exports, "produce", function () { return $2d47e473ea7f7d0f$export$b46cabe22e78bc00; });
$parcel$export(module.exports, "setAutoFreeze", function () { return $2d47e473ea7f7d0f$export$573f26f60825c493; });
function $2d47e473ea7f7d0f$var$n(n) {
    for(var t = arguments.length, r = Array(t > 1 ? t - 1 : 0), e = 1; e < t; e++)r[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (r.length ? " " + r.join(",") : "") + ". Find the full error at: https://bit.ly/38PiBHb");
}
function $2d47e473ea7f7d0f$export$541ac630993a4c84(n) {
    return !!n && !!n[$2d47e473ea7f7d0f$var$G];
}
function $2d47e473ea7f7d0f$export$16e3aed3edb85946(n) {
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var t = Object.getPrototypeOf(n);
        return !t || t === Object.prototype;
    }(n) || Array.isArray(n) || !!n[$2d47e473ea7f7d0f$export$6ee2082928bcb0ee] || !!n.constructor[$2d47e473ea7f7d0f$export$6ee2082928bcb0ee] || $2d47e473ea7f7d0f$var$c(n) || $2d47e473ea7f7d0f$var$s(n));
}
function $2d47e473ea7f7d0f$export$22e8af3f75a010e3(n) {
    if (n && n[$2d47e473ea7f7d0f$var$G]) return n[$2d47e473ea7f7d0f$var$G].t;
}
function $2d47e473ea7f7d0f$var$i(n, t) {
    0 === $2d47e473ea7f7d0f$var$o(n) ? $2d47e473ea7f7d0f$var$V(n).forEach(function(r) {
        return t(r, n[r], n);
    }) : n.forEach(function(r, e) {
        return t(e, r, n);
    });
}
function $2d47e473ea7f7d0f$var$o(n) {
    var t = n[$2d47e473ea7f7d0f$var$G];
    return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(n) ? 1 : $2d47e473ea7f7d0f$var$c(n) ? 2 : $2d47e473ea7f7d0f$var$s(n) ? 3 : 0;
}
function $2d47e473ea7f7d0f$var$u(n, t) {
    return 2 === $2d47e473ea7f7d0f$var$o(n) ? n.has(t) : Object.prototype.hasOwnProperty.call(n, t);
}
function $2d47e473ea7f7d0f$var$a(n, t) {
    return 2 === $2d47e473ea7f7d0f$var$o(n) ? n.get(t) : n[t];
}
function $2d47e473ea7f7d0f$var$f(n, t) {
    return n === t ? 0 !== n || 1 / n == 1 / t : n != n && t != t;
}
function $2d47e473ea7f7d0f$var$c(n) {
    return $2d47e473ea7f7d0f$var$B && n instanceof Map;
}
function $2d47e473ea7f7d0f$var$s(n) {
    return $2d47e473ea7f7d0f$var$H && n instanceof Set;
}
function $2d47e473ea7f7d0f$var$v(n) {
    return n.o || n.t;
}
function $2d47e473ea7f7d0f$var$p(t, r) {
    if (void 0 === r && (r = !1), Array.isArray(t)) return t.slice();
    var e = Object.create(Object.getPrototypeOf(t));
    return $2d47e473ea7f7d0f$var$i(t, function(i) {
        if (i !== $2d47e473ea7f7d0f$var$G) {
            var o = Object.getOwnPropertyDescriptor(t, i), u = o.value;
            o.get && (r || $2d47e473ea7f7d0f$var$n(1), u = o.get.call(t)), o.enumerable ? e[i] = u : Object.defineProperty(e, i, {
                value: u,
                writable: !0,
                configurable: !0
            });
        }
    }), e;
}
function $2d47e473ea7f7d0f$var$d(n, e) {
    $2d47e473ea7f7d0f$export$541ac630993a4c84(n) || Object.isFrozen(n) || !$2d47e473ea7f7d0f$export$16e3aed3edb85946(n) || ($2d47e473ea7f7d0f$var$o(n) > 1 && (n.set = n.add = n.clear = n.delete = $2d47e473ea7f7d0f$var$l), Object.freeze(n), e && $2d47e473ea7f7d0f$var$i(n, function(n, t) {
        return $2d47e473ea7f7d0f$var$d(t, !0);
    }));
}
function $2d47e473ea7f7d0f$var$l() {
    $2d47e473ea7f7d0f$var$n(2);
}
function $2d47e473ea7f7d0f$var$h(t) {
    var r = $2d47e473ea7f7d0f$var$W[t];
    return r || $2d47e473ea7f7d0f$var$n(19, t), r;
}
function $2d47e473ea7f7d0f$var$y(n, t) {
    $2d47e473ea7f7d0f$var$W[n] = t;
}
function $2d47e473ea7f7d0f$var$b() {
    return $2d47e473ea7f7d0f$var$J;
}
function $2d47e473ea7f7d0f$var$m(n, t) {
    t && ($2d47e473ea7f7d0f$var$h("Patches"), n.u = [], n.s = [], n.v = t);
}
function $2d47e473ea7f7d0f$var$_(n) {
    $2d47e473ea7f7d0f$var$j(n), n.p.forEach($2d47e473ea7f7d0f$var$g), n.p = null;
}
function $2d47e473ea7f7d0f$var$j(n) {
    n === $2d47e473ea7f7d0f$var$J && ($2d47e473ea7f7d0f$var$J = n.l);
}
function $2d47e473ea7f7d0f$var$O(n) {
    return $2d47e473ea7f7d0f$var$J = {
        p: [],
        l: $2d47e473ea7f7d0f$var$J,
        h: n,
        m: !0,
        _: 0
    };
}
function $2d47e473ea7f7d0f$var$g(n) {
    var t = n[$2d47e473ea7f7d0f$var$G];
    0 === t.i || 1 === t.i ? t.j() : t.O = !0;
}
function $2d47e473ea7f7d0f$var$w(t, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== t && t !== i;
    return e.h.g || $2d47e473ea7f7d0f$var$h("ES5").P(e, t, o), o ? (i[$2d47e473ea7f7d0f$var$G].S && ($2d47e473ea7f7d0f$var$_(e), $2d47e473ea7f7d0f$var$n(4)), $2d47e473ea7f7d0f$export$16e3aed3edb85946(t) && (t = $2d47e473ea7f7d0f$var$P(e, t), e.l || $2d47e473ea7f7d0f$var$M(e, t)), e.u && $2d47e473ea7f7d0f$var$h("Patches").M(i[$2d47e473ea7f7d0f$var$G], t, e.u, e.s)) : t = $2d47e473ea7f7d0f$var$P(e, i, []), $2d47e473ea7f7d0f$var$_(e), e.u && e.v(e.u, e.s), t !== $2d47e473ea7f7d0f$export$45b790e32b2810ee ? t : void 0;
}
function $2d47e473ea7f7d0f$var$P(n, t, r) {
    if (Object.isFrozen(t)) return t;
    var e = t[$2d47e473ea7f7d0f$var$G];
    if (!e) return $2d47e473ea7f7d0f$var$i(t, function(i, o) {
        return $2d47e473ea7f7d0f$var$S(n, e, t, i, o, r);
    }), t;
    if (e.A !== n) return t;
    if (!e.S) return $2d47e473ea7f7d0f$var$M(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = $2d47e473ea7f7d0f$var$p(e.k, !0) : e.o;
        $2d47e473ea7f7d0f$var$i(o, function(t, i) {
            return $2d47e473ea7f7d0f$var$S(n, e, o, t, i, r);
        }), $2d47e473ea7f7d0f$var$M(n, o, !1), r && n.u && $2d47e473ea7f7d0f$var$h("Patches").R(e, r, n.u, n.s);
    }
    return e.o;
}
function $2d47e473ea7f7d0f$var$S(e, i, c, s, v, p) {
    if ($2d47e473ea7f7d0f$export$541ac630993a4c84(v)) {
        var d = $2d47e473ea7f7d0f$var$P(e, v, p && i && 3 !== i.i && !$2d47e473ea7f7d0f$var$u(i.D, s) ? p.concat(s) : void 0);
        if (h = s, y = d, 2 === (b = $2d47e473ea7f7d0f$var$o(l = c)) ? l.set(h, y) : 3 === b ? (l.delete(h), l.add(y)) : l[h] = y, !$2d47e473ea7f7d0f$export$541ac630993a4c84(d)) return;
        e.m = !1;
    }
    var l, h, y, b;
    if ((!i || !$2d47e473ea7f7d0f$var$f(v, $2d47e473ea7f7d0f$var$a(i.t, s))) && $2d47e473ea7f7d0f$export$16e3aed3edb85946(v)) {
        if (!e.h.N && e._ < 1) return;
        $2d47e473ea7f7d0f$var$P(e, v), i && i.A.l || $2d47e473ea7f7d0f$var$M(e, v);
    }
}
function $2d47e473ea7f7d0f$var$M(n, t, r) {
    void 0 === r && (r = !1), n.h.N && n.m && $2d47e473ea7f7d0f$var$d(t, r);
}
function $2d47e473ea7f7d0f$var$A(n, t) {
    var r = n[$2d47e473ea7f7d0f$var$G], e = Reflect.getOwnPropertyDescriptor(r ? $2d47e473ea7f7d0f$var$v(r) : n, t);
    return e && e.value;
}
function $2d47e473ea7f7d0f$var$z(n) {
    if (!n.S) {
        if (n.S = !0, 0 === n.i || 1 === n.i) {
            var t = n.o = $2d47e473ea7f7d0f$var$p(n.t);
            $2d47e473ea7f7d0f$var$i(n.p, function(n, r) {
                t[n] = r;
            }), n.p = void 0;
        }
        n.l && $2d47e473ea7f7d0f$var$z(n.l);
    }
}
function $2d47e473ea7f7d0f$var$x(n) {
    n.o || (n.o = $2d47e473ea7f7d0f$var$p(n.t));
}
function $2d47e473ea7f7d0f$var$I(n, t, r) {
    var e = $2d47e473ea7f7d0f$var$c(t) ? $2d47e473ea7f7d0f$var$h("MapSet").T(t, r) : $2d47e473ea7f7d0f$var$s(t) ? $2d47e473ea7f7d0f$var$h("MapSet").F(t, r) : n.g ? function(n, t) {
        var r = Array.isArray(n), e = {
            i: r ? 1 : 0,
            A: t ? t.A : $2d47e473ea7f7d0f$var$b(),
            S: !1,
            I: !1,
            D: {},
            l: t,
            t: n,
            k: null,
            p: {},
            o: null,
            j: null,
            C: !1
        }, i = e, o = $2d47e473ea7f7d0f$var$X;
        r && (i = [
            e
        ], o = $2d47e473ea7f7d0f$var$Y);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(t, r) : $2d47e473ea7f7d0f$var$h("ES5").J(t, r);
    return (r ? r.A : $2d47e473ea7f7d0f$var$b()).p.push(e), e;
}
function $2d47e473ea7f7d0f$var$E(n, t) {
    n.g ? $2d47e473ea7f7d0f$var$z(t) : $2d47e473ea7f7d0f$var$h("ES5").$(t);
}
function $2d47e473ea7f7d0f$export$56771cf63ee491f5() {
    function e(n, t) {
        var r = n[$2d47e473ea7f7d0f$var$G];
        if (r && !r.B) {
            r.B = !0;
            var e = n[t];
            return r.B = !1, e;
        }
        return n[t];
    }
    function o(n) {
        n.S || (n.S = !0, n.l && o(n.l));
    }
    function a(n) {
        n.o || (n.o = c(n.t));
    }
    function c(n) {
        var t = n && n[$2d47e473ea7f7d0f$var$G];
        if (t) {
            t.B = !0;
            var r = $2d47e473ea7f7d0f$var$p(t.k, !0);
            return t.B = !1, r;
        }
        return $2d47e473ea7f7d0f$var$p(n);
    }
    function s(n) {
        for(var t = n.length - 1; t >= 0; t--){
            var r = n[t][$2d47e473ea7f7d0f$var$G];
            if (!r.S) switch(r.i){
                case 5:
                    l(r) && o(r);
                    break;
                case 4:
                    d(r) && o(r);
            }
        }
    }
    function d(n) {
        for(var t = n.t, r = n.k, e = Object.keys(r), i = e.length - 1; i >= 0; i--){
            var o = e[i], a = t[o];
            if (void 0 === a && !$2d47e473ea7f7d0f$var$u(t, o)) return !0;
            var c = r[o], s = c && c[$2d47e473ea7f7d0f$var$G];
            if (s ? s.t !== a : !$2d47e473ea7f7d0f$var$f(c, a)) return !0;
        }
        return e.length !== Object.keys(t).length;
    }
    function l(n) {
        var t = n.k;
        if (t.length !== n.t.length) return !0;
        var r = Object.getOwnPropertyDescriptor(t, t.length - 1);
        return !(!r || r.get);
    }
    function h(t) {
        t.O && $2d47e473ea7f7d0f$var$n(3, JSON.stringify($2d47e473ea7f7d0f$var$v(t)));
    }
    var m = {};
    $2d47e473ea7f7d0f$var$y("ES5", {
        J: function(n, t) {
            var u = Array.isArray(n), s = c(n);
            $2d47e473ea7f7d0f$var$i(s, function(t) {
                !function(n, t, i) {
                    var u = m[t];
                    u ? u.enumerable = i : m[t] = u = {
                        enumerable: i,
                        get: function() {
                            return function(n, t) {
                                h(n);
                                var i = e($2d47e473ea7f7d0f$var$v(n), t);
                                return n.B ? i : i === e(n.t, t) && $2d47e473ea7f7d0f$export$16e3aed3edb85946(i) ? (a(n), n.o[t] = $2d47e473ea7f7d0f$var$I(n.A.h, i, n)) : i;
                            }(this[$2d47e473ea7f7d0f$var$G], t);
                        },
                        set: function(n) {
                            !function(n, t, r) {
                                if (h(n), n.D[t] = !0, !n.S) {
                                    if ($2d47e473ea7f7d0f$var$f(r, e($2d47e473ea7f7d0f$var$v(n), t))) return;
                                    o(n), a(n);
                                }
                                n.o[t] = r;
                            }(this[$2d47e473ea7f7d0f$var$G], t, n);
                        }
                    }, Object.defineProperty(n, t, u);
                }(s, t, u || function(n, t) {
                    var r = Object.getOwnPropertyDescriptor(n, t);
                    return !(!r || !r.enumerable);
                }(n, t));
            });
            var p = {
                i: u ? 5 : 4,
                A: t ? t.A : $2d47e473ea7f7d0f$var$b(),
                S: !1,
                B: !1,
                I: !1,
                D: {},
                l: t,
                t: n,
                k: s,
                o: null,
                O: !1,
                C: !1
            };
            return Object.defineProperty(s, $2d47e473ea7f7d0f$var$G, {
                value: p,
                writable: !0
            }), s;
        },
        $: o,
        P: function(n, r, e) {
            n.p.forEach(function(n) {
                n[$2d47e473ea7f7d0f$var$G].B = !0;
            }), e ? $2d47e473ea7f7d0f$export$541ac630993a4c84(r) && r[$2d47e473ea7f7d0f$var$G].A === n && s(n.p) : (n.u && function n(t) {
                if (t && "object" == typeof t) {
                    var r = t[$2d47e473ea7f7d0f$var$G];
                    if (r) {
                        var e = r.t, a = r.k, f = r.D, c = r.i;
                        if (4 === c) $2d47e473ea7f7d0f$var$i(a, function(t) {
                            t !== $2d47e473ea7f7d0f$var$G && (void 0 !== e[t] || $2d47e473ea7f7d0f$var$u(e, t) ? f[t] || n(a[t]) : (f[t] = !0, o(r)));
                        }), $2d47e473ea7f7d0f$var$i(e, function(n) {
                            void 0 !== a[n] || $2d47e473ea7f7d0f$var$u(a, n) || (f[n] = !1, o(r));
                        });
                        else if (5 === c) {
                            if (l(r) && (o(r), f.length = !0), a.length < e.length) for(var s = a.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < a.length; v++)f[v] = !0;
                            for(var p = Math.min(a.length, e.length), d = 0; d < p; d++)void 0 === f[d] && n(a[d]);
                        }
                    }
                }
            }(n.p[0]), s(n.p));
        }
    });
}
function $2d47e473ea7f7d0f$export$d3a6659991a0696c() {
    function t(n) {
        if (!n || "object" != typeof n) return n;
        if (Array.isArray(n)) return n.map(t);
        if ($2d47e473ea7f7d0f$var$c(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                t(n[1])
            ];
        }));
        if ($2d47e473ea7f7d0f$var$s(n)) return new Set(Array.from(n).map(t));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var e in n)r[e] = t(n[e]);
        return r;
    }
    var r = "add";
    $2d47e473ea7f7d0f$var$y("Patches", {
        H: function(e, i) {
            return i.forEach(function(i) {
                for(var u = i.path, f = i.op, c = e, s = 0; s < u.length - 1; s++)"object" != typeof (c = $2d47e473ea7f7d0f$var$a(c, u[s])) && $2d47e473ea7f7d0f$var$n(15, u.join("/"));
                var v = $2d47e473ea7f7d0f$var$o(c), p = t(i.value), d = u[u.length - 1];
                switch(f){
                    case "replace":
                        switch(v){
                            case 2:
                                return c.set(d, p);
                            case 3:
                                $2d47e473ea7f7d0f$var$n(16);
                            default:
                                return c[d] = p;
                        }
                    case r:
                        switch(v){
                            case 1:
                                return c.splice(d, 0, p);
                            case 2:
                                return c.set(d, p);
                            case 3:
                                return c.add(p);
                            default:
                                return c[d] = p;
                        }
                    case "remove":
                        switch(v){
                            case 1:
                                return c.splice(d, 1);
                            case 2:
                                return c.delete(d);
                            case 3:
                                return c.delete(i.value);
                            default:
                                return delete c[d];
                        }
                    default:
                        $2d47e473ea7f7d0f$var$n(17, f);
                }
            }), e;
        },
        R: function(n, t, e, o) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, t, e, o) {
                        var f = n.t, c = n.o;
                        $2d47e473ea7f7d0f$var$i(n.D, function(n, i) {
                            var s = $2d47e473ea7f7d0f$var$a(f, n), v = $2d47e473ea7f7d0f$var$a(c, n), p = i ? $2d47e473ea7f7d0f$var$u(f, n) ? "replace" : r : "remove";
                            if (s !== v || "replace" !== p) {
                                var d = t.concat(n);
                                e.push("remove" === p ? {
                                    op: p,
                                    path: d
                                } : {
                                    op: p,
                                    path: d,
                                    value: v
                                }), o.push(p === r ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === p ? {
                                    op: r,
                                    path: d,
                                    value: s
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: s
                                });
                            }
                        });
                    }(n, t, e, o);
                case 5:
                case 1:
                    return function(n, t, e, i) {
                        var o = n.t, u = n.D, a = n.o;
                        if (a.length < o.length) {
                            var f = [
                                a,
                                o
                            ];
                            o = f[0], a = f[1];
                            var c = [
                                i,
                                e
                            ];
                            e = c[0], i = c[1];
                        }
                        for(var s = a.length - o.length, v = 0; o[v] === a[v] && v < o.length;)++v;
                        for(var p = o.length; p > v && o[p - 1] === a[p + s - 1];)--p;
                        for(var d = v; d < p; ++d)if (u[d] && a[d] !== o[d]) {
                            var l = t.concat([
                                d
                            ]);
                            e.push({
                                op: "replace",
                                path: l,
                                value: a[d]
                            }), i.push({
                                op: "replace",
                                path: l,
                                value: o[d]
                            });
                        }
                        for(var h = e.length, y = p + s - 1; y >= p; --y){
                            var b = t.concat([
                                y
                            ]);
                            e[h + y - p] = {
                                op: r,
                                path: b,
                                value: a[y]
                            }, i.push({
                                op: "remove",
                                path: b
                            });
                        }
                    }(n, t, e, o);
                case 3:
                    return function(n, t, e, i) {
                        var o = n.t, u = n.o, a = 0;
                        o.forEach(function(n) {
                            if (!u.has(n)) {
                                var o = t.concat([
                                    a
                                ]);
                                e.push({
                                    op: "remove",
                                    path: o,
                                    value: n
                                }), i.unshift({
                                    op: r,
                                    path: o,
                                    value: n
                                });
                            }
                            a++;
                        }), a = 0, u.forEach(function(n) {
                            if (!o.has(n)) {
                                var u = t.concat([
                                    a
                                ]);
                                e.push({
                                    op: r,
                                    path: u,
                                    value: n
                                }), i.unshift({
                                    op: "remove",
                                    path: u,
                                    value: n
                                });
                            }
                            a++;
                        });
                    }(n, t, e, o);
            }
        },
        M: function(n, t, r, e) {
            r.push({
                op: "replace",
                path: [],
                value: t
            }), e.push({
                op: "replace",
                path: [],
                value: n.t
            });
        }
    });
}
function $2d47e473ea7f7d0f$export$7d9f65390203b435() {
    function t(n, t) {
        function r() {
            this.constructor = n;
        }
        u(n, t), n.prototype = (r.prototype = t.prototype, new r);
    }
    function e(n) {
        n.o || (n.D = new Map, n.o = new Map(n.t));
    }
    function i(n) {
        n.o || (n.o = new Set, n.t.forEach(function(t) {
            if ($2d47e473ea7f7d0f$export$16e3aed3edb85946(t)) {
                var e = $2d47e473ea7f7d0f$var$I(n.A.h, t, n);
                n.p.set(t, e), n.o.add(e);
            } else n.o.add(t);
        }));
    }
    function o(t) {
        t.O && $2d47e473ea7f7d0f$var$n(3, JSON.stringify($2d47e473ea7f7d0f$var$v(t)));
    }
    var u = function(n, t) {
        return (u = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, t) {
            n.__proto__ = t;
        } || function(n, t) {
            for(var r in t)t.hasOwnProperty(r) && (n[r] = t[r]);
        })(n, t);
    }, a = function() {
        function n(n, t) {
            return this[$2d47e473ea7f7d0f$var$G] = {
                i: 2,
                l: t,
                A: t ? t.A : $2d47e473ea7f7d0f$var$b(),
                S: !1,
                I: !1,
                o: void 0,
                D: void 0,
                t: n,
                k: this,
                C: !1,
                O: !1
            }, this;
        }
        t(n, Map);
        var i = n.prototype;
        return Object.defineProperty(i, "size", {
            get: function() {
                return $2d47e473ea7f7d0f$var$v(this[$2d47e473ea7f7d0f$var$G]).size;
            }
        }), i.has = function(n) {
            return $2d47e473ea7f7d0f$var$v(this[$2d47e473ea7f7d0f$var$G]).has(n);
        }, i.set = function(n, t) {
            var r = this[$2d47e473ea7f7d0f$var$G];
            return o(r), $2d47e473ea7f7d0f$var$v(r).get(n) !== t && (e(r), $2d47e473ea7f7d0f$var$E(r.A.h, r), r.D.set(n, !0), r.o.set(n, t), r.D.set(n, !0)), this;
        }, i.delete = function(n) {
            if (!this.has(n)) return !1;
            var t = this[$2d47e473ea7f7d0f$var$G];
            return o(t), e(t), $2d47e473ea7f7d0f$var$E(t.A.h, t), t.D.set(n, !1), t.o.delete(n), !0;
        }, i.clear = function() {
            var n = this[$2d47e473ea7f7d0f$var$G];
            return o(n), e(n), $2d47e473ea7f7d0f$var$E(n.A.h, n), n.D = new Map, n.o.clear();
        }, i.forEach = function(n, t) {
            var r = this;
            $2d47e473ea7f7d0f$var$v(this[$2d47e473ea7f7d0f$var$G]).forEach(function(e, i) {
                n.call(t, r.get(i), i, r);
            });
        }, i.get = function(n) {
            var t = this[$2d47e473ea7f7d0f$var$G];
            o(t);
            var i = $2d47e473ea7f7d0f$var$v(t).get(n);
            if (t.I || !$2d47e473ea7f7d0f$export$16e3aed3edb85946(i)) return i;
            if (i !== t.t.get(n)) return i;
            var u = $2d47e473ea7f7d0f$var$I(t.A.h, i, t);
            return e(t), t.o.set(n, u), u;
        }, i.keys = function() {
            return $2d47e473ea7f7d0f$var$v(this[$2d47e473ea7f7d0f$var$G]).keys();
        }, i.values = function() {
            var n, t = this, r = this.keys();
            return (n = {})[$2d47e473ea7f7d0f$var$L] = function() {
                return t.values();
            }, n.next = function() {
                var n = r.next();
                return n.done ? n : {
                    done: !1,
                    value: t.get(n.value)
                };
            }, n;
        }, i.entries = function() {
            var n, t = this, r = this.keys();
            return (n = {})[$2d47e473ea7f7d0f$var$L] = function() {
                return t.entries();
            }, n.next = function() {
                var n = r.next();
                if (n.done) return n;
                var e = t.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, i[$2d47e473ea7f7d0f$var$L] = function() {
            return this.entries();
        }, n;
    }(), f = function() {
        function n(n, t) {
            return this[$2d47e473ea7f7d0f$var$G] = {
                i: 3,
                l: t,
                A: t ? t.A : $2d47e473ea7f7d0f$var$b(),
                S: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                O: !1,
                C: !1
            }, this;
        }
        t(n, Set);
        var r = n.prototype;
        return Object.defineProperty(r, "size", {
            get: function() {
                return $2d47e473ea7f7d0f$var$v(this[$2d47e473ea7f7d0f$var$G]).size;
            }
        }), r.has = function(n) {
            var t = this[$2d47e473ea7f7d0f$var$G];
            return o(t), t.o ? !!t.o.has(n) || !(!t.p.has(n) || !t.o.has(t.p.get(n))) : t.t.has(n);
        }, r.add = function(n) {
            var t = this[$2d47e473ea7f7d0f$var$G];
            return o(t), t.o ? t.o.add(n) : t.t.has(n) || (i(t), $2d47e473ea7f7d0f$var$E(t.A.h, t), t.o.add(n)), this;
        }, r.delete = function(n) {
            if (!this.has(n)) return !1;
            var t = this[$2d47e473ea7f7d0f$var$G];
            return o(t), i(t), $2d47e473ea7f7d0f$var$E(t.A.h, t), t.o.delete(n) || !!t.p.has(n) && t.o.delete(t.p.get(n));
        }, r.clear = function() {
            var n = this[$2d47e473ea7f7d0f$var$G];
            return o(n), i(n), $2d47e473ea7f7d0f$var$E(n.A.h, n), n.o.clear();
        }, r.values = function() {
            var n = this[$2d47e473ea7f7d0f$var$G];
            return o(n), i(n), n.o.values();
        }, r.entries = function() {
            var n = this[$2d47e473ea7f7d0f$var$G];
            return o(n), i(n), n.o.entries();
        }, r.keys = function() {
            return this.values();
        }, r[$2d47e473ea7f7d0f$var$L] = function() {
            return this.values();
        }, r.forEach = function(n, t) {
            for(var r = this.values(), e = r.next(); !e.done;)n.call(t, e.value, e.value, this), e = r.next();
        }, n;
    }();
    $2d47e473ea7f7d0f$var$y("MapSet", {
        T: function(n, t) {
            return new a(n, t);
        },
        F: function(n, t) {
            return new f(n, t);
        }
    });
}
function $2d47e473ea7f7d0f$export$cae049b67c7d1bc9() {
    $2d47e473ea7f7d0f$export$56771cf63ee491f5(), $2d47e473ea7f7d0f$export$7d9f65390203b435(), $2d47e473ea7f7d0f$export$d3a6659991a0696c();
}
function $2d47e473ea7f7d0f$export$c05b21e3257751e5(n) {
    return n;
}
function $2d47e473ea7f7d0f$export$20f911b3f8cf0b74(n) {
    return n;
}
var $2d47e473ea7f7d0f$var$C, $2d47e473ea7f7d0f$var$J, $2d47e473ea7f7d0f$var$$ = "undefined" != typeof Symbol, $2d47e473ea7f7d0f$var$B = "undefined" != typeof Map, $2d47e473ea7f7d0f$var$H = "undefined" != typeof Set, $2d47e473ea7f7d0f$var$K = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, $2d47e473ea7f7d0f$export$45b790e32b2810ee = $2d47e473ea7f7d0f$var$$ ? Symbol("immer-nothing") : (($2d47e473ea7f7d0f$var$C = {})["immer-nothing"] = !0, $2d47e473ea7f7d0f$var$C), $2d47e473ea7f7d0f$export$6ee2082928bcb0ee = $2d47e473ea7f7d0f$var$$ ? Symbol("immer-draftable") : "__$immer_draftable", $2d47e473ea7f7d0f$var$G = $2d47e473ea7f7d0f$var$$ ? Symbol("immer-state") : "__$immer_state", $2d47e473ea7f7d0f$var$L = $2d47e473ea7f7d0f$var$$ ? Symbol.iterator : "@@iterator", $2d47e473ea7f7d0f$var$Q = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    19: "plugin not loaded",
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available"
}, $2d47e473ea7f7d0f$var$V = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, $2d47e473ea7f7d0f$var$W = {}, $2d47e473ea7f7d0f$var$X = {
    get: function(n, t) {
        if (t === $2d47e473ea7f7d0f$var$G) return n;
        var e = n.p;
        if (!n.S && $2d47e473ea7f7d0f$var$u(e, t)) return e[t];
        var i = $2d47e473ea7f7d0f$var$v(n)[t];
        if (n.I || !$2d47e473ea7f7d0f$export$16e3aed3edb85946(i)) return i;
        if (n.S) {
            if (i !== $2d47e473ea7f7d0f$var$A(n.t, t)) return i;
            e = n.o;
        }
        return e[t] = $2d47e473ea7f7d0f$var$I(n.A.h, i, n);
    },
    has: function(n, t) {
        return t in $2d47e473ea7f7d0f$var$v(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys($2d47e473ea7f7d0f$var$v(n));
    },
    set: function(n, t, r) {
        if (!n.S) {
            var e = $2d47e473ea7f7d0f$var$A(n.t, t);
            if (r ? $2d47e473ea7f7d0f$var$f(e, r) || r === n.p[t] : $2d47e473ea7f7d0f$var$f(e, r) && t in n.t) return !0;
            $2d47e473ea7f7d0f$var$x(n), $2d47e473ea7f7d0f$var$z(n);
        }
        return n.D[t] = !0, n.o[t] = r, !0;
    },
    deleteProperty: function(n, t) {
        return void 0 !== $2d47e473ea7f7d0f$var$A(n.t, t) || t in n.t ? (n.D[t] = !1, $2d47e473ea7f7d0f$var$x(n), $2d47e473ea7f7d0f$var$z(n)) : n.D[t] && delete n.D[t], n.o && delete n.o[t], !0;
    },
    getOwnPropertyDescriptor: function(n, t) {
        var r = $2d47e473ea7f7d0f$var$v(n), e = Reflect.getOwnPropertyDescriptor(r, t);
        return e && (e.writable = !0, e.configurable = 1 !== n.i || "length" !== t), e;
    },
    defineProperty: function() {
        $2d47e473ea7f7d0f$var$n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        $2d47e473ea7f7d0f$var$n(12);
    }
}, $2d47e473ea7f7d0f$var$Y = {};
$2d47e473ea7f7d0f$var$i($2d47e473ea7f7d0f$var$X, function(n, t) {
    $2d47e473ea7f7d0f$var$Y[n] = function() {
        return arguments[0] = arguments[0][0], t.apply(this, arguments);
    };
}), $2d47e473ea7f7d0f$var$Y.deleteProperty = function(t, r) {
    return $2d47e473ea7f7d0f$var$X.deleteProperty.call(this, t[0], r);
}, $2d47e473ea7f7d0f$var$Y.set = function(t, r, e) {
    return $2d47e473ea7f7d0f$var$X.set.call(this, t[0], r, e, t[0]);
};
var $2d47e473ea7f7d0f$export$aaadc6ff0f822719 = function() {
    function e(n) {
        this.g = $2d47e473ea7f7d0f$var$K, this.N = false, "boolean" == typeof (null == n ? void 0 : n.useProxies) && this.setUseProxies(n.useProxies), "boolean" == typeof (null == n ? void 0 : n.autoFreeze) && this.setAutoFreeze(n.autoFreeze), this.produce = this.produce.bind(this), this.produceWithPatches = this.produceWithPatches.bind(this);
    }
    var i = e.prototype;
    return i.produce = function(t, e, i) {
        if ("function" == typeof t && "function" != typeof e) {
            var o = e;
            e = t;
            var u = this;
            return function(n) {
                var t = this;
                void 0 === n && (n = o);
                for(var r = arguments.length, i = Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)i[a - 1] = arguments[a];
                return u.produce(n, function(n) {
                    var r;
                    return (r = e).call.apply(r, [
                        t,
                        n
                    ].concat(i));
                });
            };
        }
        var a;
        if ("function" != typeof e && $2d47e473ea7f7d0f$var$n(6), void 0 !== i && "function" != typeof i && $2d47e473ea7f7d0f$var$n(7), $2d47e473ea7f7d0f$export$16e3aed3edb85946(t)) {
            var f = $2d47e473ea7f7d0f$var$O(this), c = $2d47e473ea7f7d0f$var$I(this, t, void 0), s = !0;
            try {
                a = e(c), s = !1;
            } finally{
                s ? $2d47e473ea7f7d0f$var$_(f) : $2d47e473ea7f7d0f$var$j(f);
            }
            return "undefined" != typeof Promise && a instanceof Promise ? a.then(function(n) {
                return $2d47e473ea7f7d0f$var$m(f, i), $2d47e473ea7f7d0f$var$w(n, f);
            }, function(n) {
                throw $2d47e473ea7f7d0f$var$_(f), n;
            }) : ($2d47e473ea7f7d0f$var$m(f, i), $2d47e473ea7f7d0f$var$w(a, f));
        }
        if ((a = e(t)) !== $2d47e473ea7f7d0f$export$45b790e32b2810ee) return void 0 === a && (a = t), this.N && $2d47e473ea7f7d0f$var$d(a, !0), a;
    }, i.produceWithPatches = function(n, t) {
        var r, e, i = this;
        return "function" == typeof n ? function(t) {
            for(var r = arguments.length, e = Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)e[o - 1] = arguments[o];
            return i.produceWithPatches(t, function(t) {
                return n.apply(void 0, [
                    t
                ].concat(e));
            });
        } : [
            this.produce(n, t, function(n, t) {
                r = n, e = t;
            }),
            r,
            e
        ];
    }, i.createDraft = function(t) {
        $2d47e473ea7f7d0f$export$16e3aed3edb85946(t) || $2d47e473ea7f7d0f$var$n(8);
        var e = $2d47e473ea7f7d0f$var$O(this), i = $2d47e473ea7f7d0f$var$I(this, t, void 0);
        return i[$2d47e473ea7f7d0f$var$G].C = !0, $2d47e473ea7f7d0f$var$j(e), i;
    }, i.finishDraft = function(t, r) {
        var e = t && t[$2d47e473ea7f7d0f$var$G];
        var i = e.A;
        return $2d47e473ea7f7d0f$var$m(i, r), $2d47e473ea7f7d0f$var$w(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.N = n;
    }, i.setUseProxies = function(t) {
        $2d47e473ea7f7d0f$var$K || $2d47e473ea7f7d0f$var$n(20), this.g = t;
    }, i.applyPatches = function(n, r) {
        var e;
        for(e = r.length - 1; e >= 0; e--){
            var i = r[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        var o = $2d47e473ea7f7d0f$var$h("Patches").H;
        return $2d47e473ea7f7d0f$export$541ac630993a4c84(n) ? o(n, r) : this.produce(n, function(n) {
            return o(n, r.slice(e + 1));
        });
    }, e;
}(), $2d47e473ea7f7d0f$var$nn = new $2d47e473ea7f7d0f$export$aaadc6ff0f822719, $2d47e473ea7f7d0f$export$b46cabe22e78bc00 = $2d47e473ea7f7d0f$var$nn.produce, $2d47e473ea7f7d0f$export$4da66d41c9492c78 = $2d47e473ea7f7d0f$var$nn.produceWithPatches.bind($2d47e473ea7f7d0f$var$nn), $2d47e473ea7f7d0f$export$573f26f60825c493 = $2d47e473ea7f7d0f$var$nn.setAutoFreeze.bind($2d47e473ea7f7d0f$var$nn), $2d47e473ea7f7d0f$export$36ccd207ae29b74e = $2d47e473ea7f7d0f$var$nn.setUseProxies.bind($2d47e473ea7f7d0f$var$nn), $2d47e473ea7f7d0f$export$a8b8e03e6bbe5473 = $2d47e473ea7f7d0f$var$nn.applyPatches.bind($2d47e473ea7f7d0f$var$nn), $2d47e473ea7f7d0f$export$3c3214997190395f = $2d47e473ea7f7d0f$var$nn.createDraft.bind($2d47e473ea7f7d0f$var$nn), $2d47e473ea7f7d0f$export$c60f5e69c521b528 = $2d47e473ea7f7d0f$var$nn.finishDraft.bind($2d47e473ea7f7d0f$var$nn);
var $2d47e473ea7f7d0f$export$2e2bcd8739ae039 = $2d47e473ea7f7d0f$export$b46cabe22e78bc00;

});

parcelRequire.register("toYCK", function(module, exports) {

var $7tBAB = parcelRequire("7tBAB");

var $kT5t7 = parcelRequire("kT5t7");
var $0586156be25f13d0$var$uuid = $kT5t7;
$0586156be25f13d0$var$uuid.v1 = $7tBAB;
$0586156be25f13d0$var$uuid.v4 = $kT5t7;
module.exports = $0586156be25f13d0$var$uuid;

});
parcelRequire.register("7tBAB", function(module, exports) {

var $5oFA8 = parcelRequire("5oFA8");

var $1dLM2 = parcelRequire("1dLM2");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $5718664bd33141d6$var$_nodeId;
var $5718664bd33141d6$var$_clockseq;
// Previous uuid creation time
var $5718664bd33141d6$var$_lastMSecs = 0;
var $5718664bd33141d6$var$_lastNSecs = 0;
// See https://github.com/broofa/node-uuid for API details
function $5718664bd33141d6$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $5718664bd33141d6$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $5718664bd33141d6$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $5oFA8();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $5718664bd33141d6$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $5718664bd33141d6$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $5718664bd33141d6$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $5718664bd33141d6$var$_lastMSecs + (nsecs - $5718664bd33141d6$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $5718664bd33141d6$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $5718664bd33141d6$var$_lastMSecs = msecs;
    $5718664bd33141d6$var$_lastNSecs = nsecs;
    $5718664bd33141d6$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $1dLM2(b);
}
module.exports = $5718664bd33141d6$var$v1;

});
parcelRequire.register("5oFA8", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $3edf72ed5b140ad0$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($3edf72ed5b140ad0$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $3edf72ed5b140ad0$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $3edf72ed5b140ad0$var$getRandomValues($3edf72ed5b140ad0$var$rnds8);
        return $3edf72ed5b140ad0$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $3edf72ed5b140ad0$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $3edf72ed5b140ad0$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $3edf72ed5b140ad0$var$rnds;
    };
}

});

parcelRequire.register("1dLM2", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $0e3c103a4bfbcaab$var$byteToHex = [];
for(var $0e3c103a4bfbcaab$var$i = 0; $0e3c103a4bfbcaab$var$i < 256; ++$0e3c103a4bfbcaab$var$i)$0e3c103a4bfbcaab$var$byteToHex[$0e3c103a4bfbcaab$var$i] = ($0e3c103a4bfbcaab$var$i + 0x100).toString(16).substr(1);
function $0e3c103a4bfbcaab$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $0e3c103a4bfbcaab$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $0e3c103a4bfbcaab$var$bytesToUuid;

});


parcelRequire.register("kT5t7", function(module, exports) {

var $5oFA8 = parcelRequire("5oFA8");

var $1dLM2 = parcelRequire("1dLM2");
function $f34d2fb033c9f7e4$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $5oFA8)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $1dLM2(rnds);
}
module.exports = $f34d2fb033c9f7e4$var$v4;

});


parcelRequire.register("eOKlk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac99aef90166d300$export$2e2bcd8739ae039; });

var $gbejU = parcelRequire("gbejU");
var $ac99aef90166d300$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($gbejU)));
var $ac99aef90166d300$export$2e2bcd8739ae039 = $ac99aef90166d300$export$77cea355fa80b5f4;

});

parcelRequire.register("55dhS", function(module, exports) {

$parcel$export(module.exports, "isPredicatesAll", function () { return $3b37b9f7af5785a4$export$ce109e100702c250; });
$parcel$export(module.exports, "ModelPredicateCreator", function () { return $3b37b9f7af5785a4$export$53bf4136314abd55; });

var $6uSfH = parcelRequire("6uSfH");
var $3b37b9f7af5785a4$var$predicatesAllSet = new WeakSet();
function $3b37b9f7af5785a4$export$ce109e100702c250(predicate) {
    return $3b37b9f7af5785a4$var$predicatesAllSet.has(predicate);
}
var $3b37b9f7af5785a4$export$e9a43fc3b0686488 = Symbol("A predicate that matches all records");
var $3b37b9f7af5785a4$export$59eb4807b6adef08 = /** @class */ function() {
    function Predicates() {}
    Object.defineProperty(Predicates, "ALL", {
        get: function() {
            var predicate = function(c) {
                return c;
            };
            $3b37b9f7af5785a4$var$predicatesAllSet.add(predicate);
            return predicate;
        },
        enumerable: true,
        configurable: true
    });
    return Predicates;
}();
var $3b37b9f7af5785a4$export$53bf4136314abd55 = /** @class */ function() {
    function ModelPredicateCreator() {}
    ModelPredicateCreator.createPredicateBuilder = function(modelDefinition) {
        var modelName = modelDefinition.name;
        var fieldNames = new Set(Object.keys(modelDefinition.fields));
        var handler;
        var predicate = new Proxy({}, handler = {
            get: function(_target, propertyKey, receiver) {
                var groupType = propertyKey;
                switch(groupType){
                    case "and":
                    case "or":
                    case "not":
                        var result_1 = function(newPredicate) {
                            var group = {
                                type: groupType,
                                predicates: []
                            };
                            // Create a new recorder
                            var tmpPredicateRecorder = new Proxy({}, handler);
                            // Set the recorder group
                            ModelPredicateCreator.predicateGroupsMap.set(tmpPredicateRecorder, group);
                            // Apply the predicates to the recorder (this is the step that records the changes)
                            newPredicate(tmpPredicateRecorder);
                            // Push the group to the top-level recorder
                            ModelPredicateCreator.predicateGroupsMap.get(receiver).predicates.push(group);
                            return receiver;
                        };
                        return result_1;
                    default:
                        (0, $6uSfH.exhaustiveCheck)(groupType, false);
                }
                var field = propertyKey;
                if (!fieldNames.has(field)) throw new Error("Invalid field for model. field: " + field + ", model: " + modelName);
                var result = function(operator, operand) {
                    ModelPredicateCreator.predicateGroupsMap.get(receiver).predicates.push({
                        field: field,
                        operator: operator,
                        operand: operand
                    });
                    return receiver;
                };
                return result;
            }
        });
        var group = {
            type: "and",
            predicates: []
        };
        ModelPredicateCreator.predicateGroupsMap.set(predicate, group);
        return predicate;
    };
    ModelPredicateCreator.isValidPredicate = function(predicate) {
        return ModelPredicateCreator.predicateGroupsMap.has(predicate);
    };
    ModelPredicateCreator.getPredicates = function(predicate, throwOnInvalid) {
        if (throwOnInvalid === void 0) throwOnInvalid = true;
        if (throwOnInvalid && !ModelPredicateCreator.isValidPredicate(predicate)) throw new Error("The predicate is not valid");
        return ModelPredicateCreator.predicateGroupsMap.get(predicate);
    };
    ModelPredicateCreator.createFromExisting = function(modelDefinition, existing) {
        if (!existing || !modelDefinition) return undefined;
        return existing(ModelPredicateCreator.createPredicateBuilder(modelDefinition));
    };
    ModelPredicateCreator.createForId = function(modelDefinition, id) {
        return ModelPredicateCreator.createPredicateBuilder(modelDefinition).id("eq", id);
    };
    ModelPredicateCreator.predicateGroupsMap = new WeakMap();
    return ModelPredicateCreator;
}();

});
parcelRequire.register("6uSfH", function(module, exports) {

$parcel$export(module.exports, "exhaustiveCheck", function () { return $4bafa0c68fcf602a$export$7212e0e3e3b6e766; });
$parcel$export(module.exports, "validatePredicate", function () { return $4bafa0c68fcf602a$export$8419f1a43cfd5ce7; });
$parcel$export(module.exports, "isModelConstructor", function () { return $4bafa0c68fcf602a$export$c68f2c37a2f5bf2b; });
$parcel$export(module.exports, "establishRelation", function () { return $4bafa0c68fcf602a$export$dec80129575a7248; });
$parcel$export(module.exports, "traverseModel", function () { return $4bafa0c68fcf602a$export$8383e2c3dcf87567; });
$parcel$export(module.exports, "getIndex", function () { return $4bafa0c68fcf602a$export$ddfa24987dade61b; });
$parcel$export(module.exports, "DATASTORE", function () { return $4bafa0c68fcf602a$export$3ad41b3c75585f46; });
$parcel$export(module.exports, "USER", function () { return $4bafa0c68fcf602a$export$ff09b90989b21a8; });
$parcel$export(module.exports, "SYNC", function () { return $4bafa0c68fcf602a$export$c1d71ceefe04e35a; });
$parcel$export(module.exports, "STORAGE", function () { return $4bafa0c68fcf602a$export$e52920da3d8ae458; });
$parcel$export(module.exports, "isPrivateMode", function () { return $4bafa0c68fcf602a$export$da1531158eb11a27; });

var $6BLoD = parcelRequire("6BLoD");

var $toYCK = parcelRequire("toYCK");
var $4bafa0c68fcf602a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4bafa0c68fcf602a$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $4bafa0c68fcf602a$export$7212e0e3e3b6e766 = function(obj, throwOnError) {
    if (throwOnError === void 0) throwOnError = true;
    if (throwOnError) throw new Error("Invalid " + obj);
};
var $4bafa0c68fcf602a$export$8419f1a43cfd5ce7 = function(model, groupType, predicatesOrGroups) {
    var filterType;
    var isNegation = false;
    if (predicatesOrGroups.length === 0) return true;
    switch(groupType){
        case "not":
            filterType = "every";
            isNegation = true;
            break;
        case "and":
            filterType = "every";
            break;
        case "or":
            filterType = "some";
            break;
        default:
            $4bafa0c68fcf602a$export$7212e0e3e3b6e766(groupType);
    }
    var result = predicatesOrGroups[filterType](function(predicateOrGroup) {
        if ((0, $6BLoD.isPredicateObj)(predicateOrGroup)) {
            var field = predicateOrGroup.field, operator = predicateOrGroup.operator, operand = predicateOrGroup.operand;
            var value = model[field];
            return $4bafa0c68fcf602a$var$validatePredicateField(value, operator, operand);
        }
        if ((0, $6BLoD.isPredicateGroup)(predicateOrGroup)) {
            var type = predicateOrGroup.type, predicates = predicateOrGroup.predicates;
            return $4bafa0c68fcf602a$export$8419f1a43cfd5ce7(model, type, predicates);
        }
        throw new Error("Not a predicate or group");
    });
    return isNegation ? !result : result;
};
var $4bafa0c68fcf602a$var$validatePredicateField = function(value, operator, operand) {
    switch(operator){
        case "ne":
            return value !== operand;
        case "eq":
            return value === operand;
        case "le":
            return value <= operand;
        case "lt":
            return value < operand;
        case "ge":
            return value >= operand;
        case "gt":
            return value > operand;
        case "between":
            var _a = operand, min = _a[0], max = _a[1];
            return value >= min && value <= max;
        case "beginsWith":
            return value.startsWith(operand);
        case "contains":
            return value.indexOf(operand) > -1;
        case "notContains":
            return value.indexOf(operand) === -1;
        default:
            $4bafa0c68fcf602a$export$7212e0e3e3b6e766(operator, false);
            return false;
    }
};
var $4bafa0c68fcf602a$export$c68f2c37a2f5bf2b = function(obj) {
    return obj && typeof obj.copyOf === "function";
};
var $4bafa0c68fcf602a$export$dec80129575a7248 = function(namespace) {
    var relationship = {};
    Object.keys(namespace.models).forEach(function(mKey) {
        relationship[mKey] = {
            indexes: [],
            relationTypes: []
        };
        var model = namespace.models[mKey];
        Object.keys(model.fields).forEach(function(attr) {
            var fieldAttribute = model.fields[attr];
            if (typeof fieldAttribute.type === "object" && "model" in fieldAttribute.type) {
                var connectionType = fieldAttribute.association.connectionType;
                relationship[mKey].relationTypes.push({
                    fieldName: fieldAttribute.name,
                    modelName: fieldAttribute.type.model,
                    relationType: connectionType,
                    targetName: fieldAttribute.association["targetName"]
                });
                if (connectionType === "BELONGS_TO") relationship[mKey].indexes.push(fieldAttribute.association["targetName"]);
            }
        });
    });
    return relationship;
};
var $4bafa0c68fcf602a$var$topologicallySortedModels = new WeakMap();
var $4bafa0c68fcf602a$export$8383e2c3dcf87567 = function(srcModelName, instance, namespace, modelInstanceCreator, getModelConstructorByModelName) {
    var relationships = namespace.relationships;
    var modelConstructor = getModelConstructorByModelName(namespace.name, srcModelName);
    var relation = relationships[srcModelName];
    var result = [];
    var newInstance = modelConstructor.copyOf(instance, function(draftInstance) {
        relation.relationTypes.forEach(function(rItem) {
            var modelConstructor = getModelConstructorByModelName(namespace.name, rItem.modelName);
            switch(rItem.relationType){
                case "HAS_ONE":
                    if (instance[rItem.fieldName]) {
                        var modelInstance = void 0;
                        try {
                            modelInstance = modelInstanceCreator(modelConstructor, instance[rItem.fieldName]);
                        } catch (error) {
                        // Do nothing
                        }
                        result.push({
                            modelName: rItem.modelName,
                            item: instance[rItem.fieldName],
                            instance: modelInstance
                        });
                        draftInstance[rItem.fieldName] = draftInstance[rItem.fieldName].id;
                    }
                    break;
                case "BELONGS_TO":
                    if (instance[rItem.fieldName]) {
                        var modelInstance = void 0;
                        try {
                            modelInstance = modelInstanceCreator(modelConstructor, instance[rItem.fieldName]);
                        } catch (error) {
                        // Do nothing
                        }
                        var isDeleted = draftInstance[rItem.fieldName]._deleted;
                        if (!isDeleted) result.push({
                            modelName: rItem.modelName,
                            item: instance[rItem.fieldName],
                            instance: modelInstance
                        });
                    }
                    draftInstance[rItem.targetName] = draftInstance[rItem.fieldName] ? draftInstance[rItem.fieldName].id : null;
                    delete draftInstance[rItem.fieldName];
                    break;
                case "HAS_MANY":
                    break;
                default:
                    $4bafa0c68fcf602a$export$7212e0e3e3b6e766(rItem.relationType);
                    break;
            }
        });
    });
    result.unshift({
        modelName: srcModelName,
        item: newInstance,
        instance: newInstance
    });
    if (!$4bafa0c68fcf602a$var$topologicallySortedModels.has(namespace)) $4bafa0c68fcf602a$var$topologicallySortedModels.set(namespace, Array.from(namespace.modelTopologicalOrdering.keys()));
    var sortedModels = $4bafa0c68fcf602a$var$topologicallySortedModels.get(namespace);
    result.sort(function(a, b) {
        return sortedModels.indexOf(a.modelName) - sortedModels.indexOf(b.modelName);
    });
    return result;
};
var $4bafa0c68fcf602a$export$ddfa24987dade61b = function(rel, src) {
    var index = "";
    rel.some(function(relItem) {
        if (relItem.modelName === src) index = relItem.targetName;
    });
    return index;
};
var $4bafa0c68fcf602a$export$4d2fb7344096e022;
(function(NAMESPACES) {
    NAMESPACES["DATASTORE"] = "datastore";
    NAMESPACES["USER"] = "user";
    NAMESPACES["SYNC"] = "sync";
    NAMESPACES["STORAGE"] = "storage";
})($4bafa0c68fcf602a$export$4d2fb7344096e022 || ($4bafa0c68fcf602a$export$4d2fb7344096e022 = {}));
var $4bafa0c68fcf602a$export$3ad41b3c75585f46 = $4bafa0c68fcf602a$export$4d2fb7344096e022.DATASTORE;
var $4bafa0c68fcf602a$export$ff09b90989b21a8 = $4bafa0c68fcf602a$export$4d2fb7344096e022.USER;
var $4bafa0c68fcf602a$export$c1d71ceefe04e35a = $4bafa0c68fcf602a$export$4d2fb7344096e022.SYNC;
var $4bafa0c68fcf602a$export$e52920da3d8ae458 = $4bafa0c68fcf602a$export$4d2fb7344096e022.STORAGE;
var $4bafa0c68fcf602a$var$privateModeCheckResult;
var $4bafa0c68fcf602a$export$da1531158eb11a27 = function() {
    return new Promise(function(resolve) {
        var dbname = (0, $toYCK.v4)();
        var db;
        var isPrivate = function() {
            $4bafa0c68fcf602a$var$privateModeCheckResult = false;
            resolve(true);
        };
        var isNotPrivate = function() {
            return $4bafa0c68fcf602a$var$__awaiter(void 0, void 0, void 0, function() {
                return $4bafa0c68fcf602a$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(db && db.result && typeof db.result.close === "function")) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                db.result.close()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                4 /*yield*/ ,
                                indexedDB.deleteDatabase(dbname)
                            ];
                        case 3:
                            _a.sent();
                            $4bafa0c68fcf602a$var$privateModeCheckResult = true;
                            return [
                                2 /*return*/ ,
                                resolve(false)
                            ];
                    }
                });
            });
        };
        if ($4bafa0c68fcf602a$var$privateModeCheckResult === true) return isNotPrivate();
        if ($4bafa0c68fcf602a$var$privateModeCheckResult === false) return isPrivate();
        if (indexedDB === null) return isPrivate();
        db = indexedDB.open(dbname);
        db.onerror = isPrivate;
        db.onsuccess = isNotPrivate;
    });
};

});
parcelRequire.register("6BLoD", function(module, exports) {

$parcel$export(module.exports, "isSchemaModel", function () { return $4cfaf6aea09ac675$export$fa1fcd58836edcfa; });
$parcel$export(module.exports, "isTargetNameAssociation", function () { return $4cfaf6aea09ac675$export$c15b1a02dfd21bde; });
$parcel$export(module.exports, "GraphQLScalarType", function () { return $4cfaf6aea09ac675$export$64842b98ea53a3c9; });
$parcel$export(module.exports, "isGraphQLScalarType", function () { return $4cfaf6aea09ac675$export$e41f986aeddadb3f; });
$parcel$export(module.exports, "isModelFieldType", function () { return $4cfaf6aea09ac675$export$e12a141239100727; });
$parcel$export(module.exports, "isNonModelFieldType", function () { return $4cfaf6aea09ac675$export$c677372b3442319c; });
$parcel$export(module.exports, "isEnumFieldType", function () { return $4cfaf6aea09ac675$export$e8edde0e3b7d324a; });
$parcel$export(module.exports, "OpType", function () { return $4cfaf6aea09ac675$export$fe8433fef6710b9c; });
$parcel$export(module.exports, "isPredicateObj", function () { return $4cfaf6aea09ac675$export$c743510e5858fc7f; });
$parcel$export(module.exports, "isPredicateGroup", function () { return $4cfaf6aea09ac675$export$aabef21a553cc8e1; });
$parcel$export(module.exports, "QueryOne", function () { return $4cfaf6aea09ac675$export$cc47329410e31a04; });
$parcel$export(module.exports, "DISCARD", function () { return $4cfaf6aea09ac675$export$2eba9c1b71b4d659; });

var $6uSfH = parcelRequire("6uSfH");
function $4cfaf6aea09ac675$export$fa1fcd58836edcfa(obj) {
    return obj && obj.pluralName !== undefined;
}
function $4cfaf6aea09ac675$export$ca96814e78a98080(obj) {
    return obj && obj.associatedWith;
}
function $4cfaf6aea09ac675$export$c15b1a02dfd21bde(obj) {
    return obj && obj.targetName;
}
var $4cfaf6aea09ac675$export$64842b98ea53a3c9;
(function(GraphQLScalarType) {
    GraphQLScalarType[GraphQLScalarType["ID"] = 0] = "ID";
    GraphQLScalarType[GraphQLScalarType["String"] = 1] = "String";
    GraphQLScalarType[GraphQLScalarType["Int"] = 2] = "Int";
    GraphQLScalarType[GraphQLScalarType["Float"] = 3] = "Float";
    GraphQLScalarType[GraphQLScalarType["Boolean"] = 4] = "Boolean";
    GraphQLScalarType[GraphQLScalarType["AWSDate"] = 5] = "AWSDate";
    GraphQLScalarType[GraphQLScalarType["AWSTime"] = 6] = "AWSTime";
    GraphQLScalarType[GraphQLScalarType["AWSDateTime"] = 7] = "AWSDateTime";
    GraphQLScalarType[GraphQLScalarType["AWSTimestamp"] = 8] = "AWSTimestamp";
    GraphQLScalarType[GraphQLScalarType["AWSEmail"] = 9] = "AWSEmail";
    GraphQLScalarType[GraphQLScalarType["AWSJSON"] = 10] = "AWSJSON";
    GraphQLScalarType[GraphQLScalarType["AWSURL"] = 11] = "AWSURL";
    GraphQLScalarType[GraphQLScalarType["AWSPhone"] = 12] = "AWSPhone";
    GraphQLScalarType[GraphQLScalarType["AWSIPAddress"] = 13] = "AWSIPAddress";
})($4cfaf6aea09ac675$export$64842b98ea53a3c9 || ($4cfaf6aea09ac675$export$64842b98ea53a3c9 = {}));
(function(GraphQLScalarType) {
    function getJSType(scalar) {
        switch(scalar){
            case "Boolean":
                return "boolean";
            case "ID":
            case "String":
            case "AWSDate":
            case "AWSTime":
            case "AWSDateTime":
            case "AWSEmail":
            case "AWSJSON":
            case "AWSURL":
            case "AWSPhone":
            case "AWSIPAddress":
                return "string";
            case "Int":
            case "Float":
            case "AWSTimestamp":
                return "number";
            default:
                (0, $6uSfH.exhaustiveCheck)(scalar);
        }
    }
    GraphQLScalarType.getJSType = getJSType;
})($4cfaf6aea09ac675$export$64842b98ea53a3c9 || ($4cfaf6aea09ac675$export$64842b98ea53a3c9 = {}));
function $4cfaf6aea09ac675$export$e41f986aeddadb3f(obj) {
    return obj && $4cfaf6aea09ac675$export$64842b98ea53a3c9[obj] !== undefined;
}
function $4cfaf6aea09ac675$export$e12a141239100727(obj) {
    var modelField = "model";
    if (obj && obj[modelField]) return true;
    return false;
}
function $4cfaf6aea09ac675$export$c677372b3442319c(obj) {
    var typeField = "nonModel";
    if (obj && obj[typeField]) return true;
    return false;
}
function $4cfaf6aea09ac675$export$e8edde0e3b7d324a(obj) {
    var modelField = "enum";
    if (obj && obj[modelField]) return true;
    return false;
}
var $4cfaf6aea09ac675$export$fe8433fef6710b9c;
(function(OpType) {
    OpType["INSERT"] = "INSERT";
    OpType["UPDATE"] = "UPDATE";
    OpType["DELETE"] = "DELETE";
})($4cfaf6aea09ac675$export$fe8433fef6710b9c || ($4cfaf6aea09ac675$export$fe8433fef6710b9c = {}));
function $4cfaf6aea09ac675$export$c743510e5858fc7f(obj) {
    return obj && obj.field !== undefined;
}
function $4cfaf6aea09ac675$export$aabef21a553cc8e1(obj) {
    return obj && obj.type !== undefined;
}
var $4cfaf6aea09ac675$export$cc47329410e31a04;
(function(QueryOne) {
    QueryOne[QueryOne["FIRST"] = 0] = "FIRST";
    QueryOne[QueryOne["LAST"] = 1] = "LAST";
})($4cfaf6aea09ac675$export$cc47329410e31a04 || ($4cfaf6aea09ac675$export$cc47329410e31a04 = {}));
var $4cfaf6aea09ac675$export$2eba9c1b71b4d659 = Symbol("DISCARD"); //#endregion

});



parcelRequire.register("gy2GN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0c1e8561ef943a3$export$2e2bcd8739ae039; });
parcelRequire("2hWDt");
var $bU8Gd = parcelRequire("bU8Gd");

var $RdWDe = parcelRequire("RdWDe");

var $55dhS = parcelRequire("55dhS");

var $6BLoD = parcelRequire("6BLoD");

var $6uSfH = parcelRequire("6uSfH");

var $623cV = parcelRequire("623cV");
var $c0c1e8561ef943a3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c0c1e8561ef943a3$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $c0c1e8561ef943a3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c0c1e8561ef943a3$var$Storage = /** @class */ function() {
    function Storage(schema, namespaceResolver, getModelConstructorByModelName, modelInstanceCreator, adapter) {
        this.schema = schema;
        this.namespaceResolver = namespaceResolver;
        this.getModelConstructorByModelName = getModelConstructorByModelName;
        this.modelInstanceCreator = modelInstanceCreator;
        this.adapter = adapter;
        this.adapter = (0, $623cV.default)();
        this.pushStream = new $RdWDe();
    }
    Storage.getNamespace = function() {
        var namespace = {
            name: (0, $6uSfH.STORAGE),
            relationships: {},
            enums: {},
            models: {},
            nonModels: {}
        };
        return namespace;
    };
    Storage.prototype.init = function() {
        return $c0c1e8561ef943a3$var$__awaiter(this, void 0, void 0, function() {
            var resolve, reject;
            return $c0c1e8561ef943a3$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.initialized !== undefined) return [
                            2 /*return*/ 
                        ];
                        this.initialized = new Promise(function(res, rej) {
                            resolve = res;
                            reject = rej;
                        });
                        this.adapter.setUp(this.schema, this.namespaceResolver, this.modelInstanceCreator, this.getModelConstructorByModelName).then(resolve, reject);
                        return [
                            4 /*yield*/ ,
                            this.initialized
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Storage.prototype.save = function(model, condition, mutator) {
        return $c0c1e8561ef943a3$var$__awaiter(this, void 0, void 0, function() {
            var result;
            var _this = this;
            return $c0c1e8561ef943a3$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.init()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.adapter.save(model, condition)
                        ];
                    case 2:
                        result = _a.sent();
                        result.forEach(function(r) {
                            var element = r[0], opType = r[1];
                            var modelConstructor = Object.getPrototypeOf(element).constructor;
                            _this.pushStream.next({
                                model: modelConstructor,
                                opType: opType,
                                element: element,
                                mutator: mutator,
                                condition: (0, $55dhS.ModelPredicateCreator).getPredicates(condition, false)
                            });
                        });
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    Storage.prototype.delete = function(modelOrModelConstructor, condition, mutator) {
        return $c0c1e8561ef943a3$var$__awaiter(this, void 0, void 0, function() {
            var deleted, models, modelIds;
            var _a;
            var _this = this;
            return $c0c1e8561ef943a3$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.init()
                        ];
                    case 1:
                        _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.adapter.delete(modelOrModelConstructor, condition)
                        ];
                    case 2:
                        _a = _b.sent(), models = _a[0], deleted = _a[1];
                        modelIds = new Set(models.map(function(_a) {
                            var id = _a.id;
                            return id;
                        }));
                        if (!(0, $6uSfH.isModelConstructor)(modelOrModelConstructor) && !Array.isArray(deleted)) deleted = [
                            deleted
                        ];
                        deleted.forEach(function(model) {
                            var modelConstructor = Object.getPrototypeOf(model).constructor;
                            var theCondition;
                            if (!(0, $6uSfH.isModelConstructor)(modelOrModelConstructor)) theCondition = modelIds.has(model.id) ? (0, $55dhS.ModelPredicateCreator).getPredicates(condition, false) : undefined;
                            _this.pushStream.next({
                                model: modelConstructor,
                                opType: (0, $6BLoD.OpType).DELETE,
                                element: model,
                                mutator: mutator,
                                condition: theCondition
                            });
                        });
                        return [
                            2 /*return*/ ,
                            [
                                models,
                                deleted
                            ]
                        ];
                }
            });
        });
    };
    Storage.prototype.query = function(modelConstructor, predicate, pagination) {
        return $c0c1e8561ef943a3$var$__awaiter(this, void 0, void 0, function() {
            return $c0c1e8561ef943a3$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.init()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.adapter.query(modelConstructor, predicate, pagination)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    Storage.prototype.queryOne = function(modelConstructor, firstOrLast) {
        if (firstOrLast === void 0) firstOrLast = (0, $6BLoD.QueryOne).FIRST;
        return $c0c1e8561ef943a3$var$__awaiter(this, void 0, void 0, function() {
            var record;
            return $c0c1e8561ef943a3$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.init()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.adapter.queryOne(modelConstructor, firstOrLast)
                        ];
                    case 2:
                        record = _a.sent();
                        return [
                            2 /*return*/ ,
                            record
                        ];
                }
            });
        });
    };
    Storage.prototype.observe = function(modelConstructor, predicate, skipOwn) {
        var _a;
        var listenToAll = !modelConstructor;
        var hasPredicate = !!predicate;
        var result = this.pushStream.observable.filter(function(_a) {
            var mutator = _a.mutator;
            return !skipOwn || mutator !== skipOwn;
        }).map(function(_a) {
            var _mutator = _a.mutator, message = $c0c1e8561ef943a3$var$__rest(_a, [
                "mutator"
            ]);
            return message;
        });
        if (!listenToAll) {
            var predicates_1, type_1;
            if (hasPredicate) _a = (0, $55dhS.ModelPredicateCreator).getPredicates(predicate), predicates_1 = _a.predicates, type_1 = _a.type;
            result = result.filter(function(_a) {
                var model = _a.model, element = _a.element;
                if (modelConstructor !== model) return false;
                if (hasPredicate) return (0, $6uSfH.validatePredicate)(element, type_1, predicates_1);
                return true;
            });
        }
        return result;
    };
    Storage.prototype.clear = function(completeObservable) {
        if (completeObservable === void 0) completeObservable = true;
        return $c0c1e8561ef943a3$var$__awaiter(this, void 0, void 0, function() {
            return $c0c1e8561ef943a3$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.initialized = undefined;
                        return [
                            4 /*yield*/ ,
                            this.adapter.clear()
                        ];
                    case 1:
                        _a.sent();
                        if (completeObservable) this.pushStream.complete();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return Storage;
}();
var $c0c1e8561ef943a3$var$ExclusiveStorage = /** @class */ function() {
    function ExclusiveStorage(schema, namespaceResolver, getModelConstructorByModelName, modelInstanceCreator, adapter) {
        this.mutex = new (0, $bU8Gd.default)();
        this.storage = new $c0c1e8561ef943a3$var$Storage(schema, namespaceResolver, getModelConstructorByModelName, modelInstanceCreator, adapter);
    }
    ExclusiveStorage.prototype.runExclusive = function(fn) {
        return this.mutex.runExclusive(fn.bind(this, this.storage));
    };
    ExclusiveStorage.prototype.save = function(model, condition, mutator) {
        return $c0c1e8561ef943a3$var$__awaiter(this, void 0, void 0, function() {
            return $c0c1e8561ef943a3$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.runExclusive(function(storage) {
                        return storage.save(model, condition, mutator);
                    })
                ];
            });
        });
    };
    ExclusiveStorage.prototype.delete = function(modelOrModelConstructor, condition, mutator) {
        return $c0c1e8561ef943a3$var$__awaiter(this, void 0, void 0, function() {
            return $c0c1e8561ef943a3$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.runExclusive(function(storage) {
                        if ((0, $6uSfH.isModelConstructor)(modelOrModelConstructor)) {
                            var modelConstructor = modelOrModelConstructor;
                            return storage.delete(modelConstructor, condition, mutator);
                        } else {
                            var model = modelOrModelConstructor;
                            return storage.delete(model, condition, mutator);
                        }
                    })
                ];
            });
        });
    };
    ExclusiveStorage.prototype.query = function(modelConstructor, predicate, pagination) {
        return $c0c1e8561ef943a3$var$__awaiter(this, void 0, void 0, function() {
            return $c0c1e8561ef943a3$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.runExclusive(function(storage) {
                        return storage.query(modelConstructor, predicate, pagination);
                    })
                ];
            });
        });
    };
    ExclusiveStorage.prototype.queryOne = function(modelConstructor, firstOrLast) {
        if (firstOrLast === void 0) firstOrLast = (0, $6BLoD.QueryOne).FIRST;
        return $c0c1e8561ef943a3$var$__awaiter(this, void 0, void 0, function() {
            return $c0c1e8561ef943a3$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.runExclusive(function(storage) {
                        return storage.queryOne(modelConstructor, firstOrLast);
                    })
                ];
            });
        });
    };
    ExclusiveStorage.getNamespace = function() {
        return $c0c1e8561ef943a3$var$Storage.getNamespace();
    };
    ExclusiveStorage.prototype.observe = function(modelConstructor, predicate, skipOwn) {
        return this.storage.observe(modelConstructor, predicate, skipOwn);
    };
    ExclusiveStorage.prototype.clear = function() {
        return $c0c1e8561ef943a3$var$__awaiter(this, void 0, void 0, function() {
            return $c0c1e8561ef943a3$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.storage.clear()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return ExclusiveStorage;
}();
var $c0c1e8561ef943a3$export$2e2bcd8739ae039 = $c0c1e8561ef943a3$var$ExclusiveStorage;

});
parcelRequire.register("RdWDe", function(module, exports) {
"use strict";

var $a4gN5 = parcelRequire("a4gN5");
function $09ffc4792e7f6dea$var$addMethods(target, methods) {
    Object.keys(methods).forEach(function(k) {
        var desc = Object.getOwnPropertyDescriptor(methods, k);
        desc.enumerable = false;
        Object.defineProperty(target, k, desc);
    });
}
function $09ffc4792e7f6dea$var$send(p, message, value) {
    if (p._observer) $09ffc4792e7f6dea$var$sendMessage(p._observer, message, value);
    else if (p._observers) {
        var list = [];
        p._observers.forEach(function(to) {
            list.push(to);
        });
        list.forEach(function(to) {
            $09ffc4792e7f6dea$var$sendMessage(to, message, value);
        });
    }
}
function $09ffc4792e7f6dea$var$sendMessage(observer, message, value) {
    if (observer.closed) return;
    switch(message){
        case "next":
            return observer.next(value);
        case "error":
            return observer.error(value);
        case "complete":
            return observer.complete(value);
    }
}
function $09ffc4792e7f6dea$var$hasObserver(p) {
    return p._observer || p._observers && p._observers.size > 0;
}
function $09ffc4792e7f6dea$var$addObserver(p, observer) {
    if (p._observers) p._observers.add(observer);
    else if (!p._observer) p._observer = observer;
    else {
        p._observers = new Set();
        p._observers.add(p._observer);
        p._observers.add(observer);
        p._observer = null;
    }
}
function $09ffc4792e7f6dea$var$deleteObserver(p, observer) {
    if (p._observers) p._observers.delete(observer);
    else if (p._observer === observer) p._observer = null;
}
function $09ffc4792e7f6dea$var$notifyStart(p, opts) {
    !$09ffc4792e7f6dea$var$hasObserver(p) && opts && opts.start && opts.start();
}
function $09ffc4792e7f6dea$var$notifyPause(p, opts) {
    !$09ffc4792e7f6dea$var$hasObserver(p) && opts && opts.pause && opts.pause();
}
function $09ffc4792e7f6dea$var$PushStream(opts) {
    var p = this;
    this._observer = null;
    this._observers = null;
    this._observable = new $a4gN5(function(observer) {
        $09ffc4792e7f6dea$var$notifyStart(p, opts);
        $09ffc4792e7f6dea$var$addObserver(p, observer);
        return function() {
            $09ffc4792e7f6dea$var$deleteObserver(p, observer);
            $09ffc4792e7f6dea$var$notifyPause(p, opts);
        };
    });
}
$09ffc4792e7f6dea$var$addMethods($09ffc4792e7f6dea$var$PushStream.prototype, {
    get observable () {
        return this._observable;
    },
    get observed () {
        return $09ffc4792e7f6dea$var$hasObserver(this);
    },
    next: function(x) {
        $09ffc4792e7f6dea$var$send(this, "next", x);
    },
    error: function(e) {
        $09ffc4792e7f6dea$var$send(this, "error", e);
    },
    complete: function(x) {
        $09ffc4792e7f6dea$var$send(this, "complete", x);
    }
});
module.exports = $09ffc4792e7f6dea$var$PushStream;

});
parcelRequire.register("a4gN5", function(module, exports) {

module.exports = (parcelRequire("hCotE")).Observable;

});
parcelRequire.register("hCotE", function(module, exports) {
"use strict";
(function(fn, name) {
    var e;
    fn(exports, module);
})(function(exports1, module1) {
    function hasSymbol(name) {
        return typeof Symbol === "function" && Boolean(Symbol[name]);
    }
    function getSymbol(name) {
        return hasSymbol(name) ? Symbol[name] : "@@" + name;
    }
    // Ponyfill Symbol.observable for interoperability with other libraries
    if (typeof Symbol === "function" && !Symbol.observable) Symbol.observable = Symbol("observable");
    // === Abstract Operations ===
    function hostReportError(e) {
        setTimeout(function() {
            throw e;
        });
    }
    function getMethod(obj, key) {
        var value = obj[key];
        if (value == null) return undefined;
        if (typeof value !== "function") throw new TypeError(value + " is not a function");
        return value;
    }
    function getSpecies(obj) {
        var ctor = obj.constructor;
        if (ctor !== undefined) {
            ctor = ctor[getSymbol("species")];
            if (ctor === null) ctor = undefined;
        }
        return ctor !== undefined ? ctor : Observable;
    }
    function addMethods(target, methods) {
        Object.keys(methods).forEach(function(k) {
            var desc = Object.getOwnPropertyDescriptor(methods, k);
            desc.enumerable = false;
            Object.defineProperty(target, k, desc);
        });
    }
    function cleanupSubscription(subscription) {
        // Assert:  observer._observer is undefined
        var cleanup = subscription._cleanup;
        if (!cleanup) return;
        // Drop the reference to the cleanup function so that we won't call it
        // more than once
        subscription._cleanup = undefined;
        // Call the cleanup function
        try {
            cleanup();
        } catch (e) {
            hostReportError(e);
        }
    }
    function subscriptionClosed(subscription) {
        return subscription._observer === undefined;
    }
    function closeSubscription(subscription) {
        if (subscriptionClosed(subscription)) return;
        subscription._observer = undefined;
        cleanupSubscription(subscription);
    }
    function cleanupFromSubscription(subscription) {
        return function() {
            subscription.unsubscribe();
        };
    }
    function Subscription(observer, subscriber) {
        // Assert: subscriber is callable
        // The observer must be an object
        if (Object(observer) !== observer) throw new TypeError("Observer must be an object");
        this._cleanup = undefined;
        this._observer = observer;
        try {
            var start$0 = getMethod(observer, "start");
            if (start$0) start$0.call(observer, this);
        } catch (e) {
            hostReportError(e);
        }
        if (subscriptionClosed(this)) return;
        observer = new SubscriptionObserver(this);
        try {
            // Call the subscriber function
            var cleanup$0 = subscriber.call(undefined, observer);
            // The return value must be undefined, null, a subscription object, or a function
            if (cleanup$0 != null) {
                if (typeof cleanup$0.unsubscribe === "function") cleanup$0 = cleanupFromSubscription(cleanup$0);
                else if (typeof cleanup$0 !== "function") throw new TypeError(cleanup$0 + " is not a function");
                this._cleanup = cleanup$0;
            }
        } catch (e) {
            // If an error occurs during startup, then attempt to send the error
            // to the observer
            observer.error(e);
            return;
        }
        // If the stream is already finished, then perform cleanup
        if (subscriptionClosed(this)) cleanupSubscription(this);
    }
    addMethods(Subscription.prototype = {}, {
        get closed () {
            return subscriptionClosed(this);
        },
        unsubscribe: function() {
            closeSubscription(this);
        }
    });
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    addMethods(SubscriptionObserver.prototype = {}, {
        get closed () {
            return subscriptionClosed(this._subscription);
        },
        next: function(value) {
            var subscription = this._subscription;
            // If the stream is closed, then return undefined
            if (subscriptionClosed(subscription)) return;
            var observer = subscription._observer;
            try {
                // If the observer has a "next" method, send the next value
                var m$0 = getMethod(observer, "next");
                if (m$0) m$0.call(observer, value);
            } catch (e) {
                hostReportError(e);
            }
        },
        error: function(value) {
            var subscription = this._subscription;
            // If the stream is closed, throw the error to the caller
            if (subscriptionClosed(subscription)) {
                hostReportError(value);
                return;
            }
            var observer = subscription._observer;
            subscription._observer = undefined;
            try {
                var m$1 = getMethod(observer, "error");
                if (m$1) m$1.call(observer, value);
                else throw value;
            } catch (e) {
                hostReportError(e);
            }
            cleanupSubscription(subscription);
        },
        complete: function() {
            var subscription = this._subscription;
            if (subscriptionClosed(subscription)) return;
            var observer = subscription._observer;
            subscription._observer = undefined;
            try {
                var m$2 = getMethod(observer, "complete");
                if (m$2) m$2.call(observer);
            } catch (e) {
                hostReportError(e);
            }
            cleanupSubscription(subscription);
        }
    });
    function Observable(subscriber) {
        // Constructor cannot be called as a function
        if (!(this instanceof Observable)) throw new TypeError("Observable cannot be called as a function");
        // The stream subscriber must be a function
        if (typeof subscriber !== "function") throw new TypeError("Observable initializer must be a function");
        this._subscriber = subscriber;
    }
    addMethods(Observable.prototype, {
        subscribe: function(observer) {
            for(var args = [], __$0 = 1; __$0 < arguments.length; ++__$0)args.push(arguments[__$0]);
            if (typeof observer === "function") observer = {
                next: observer,
                error: args[0],
                complete: args[1]
            };
            else if (typeof observer !== "object" || observer === null) observer = {};
            return new Subscription(observer, this._subscriber);
        },
        forEach: function(fn) {
            var __this = this;
            return new Promise(function(resolve, reject) {
                if (typeof fn !== "function") return Promise.reject(new TypeError(fn + " is not a function"));
                __this.subscribe({
                    _subscription: null,
                    start: function(subscription) {
                        if (Object(subscription) !== subscription) throw new TypeError(subscription + " is not an object");
                        this._subscription = subscription;
                    },
                    next: function(value) {
                        var subscription = this._subscription;
                        if (subscription.closed) return;
                        try {
                            fn(value);
                        } catch (err) {
                            reject(err);
                            subscription.unsubscribe();
                        }
                    },
                    error: reject,
                    complete: resolve
                });
            });
        },
        map: function(fn) {
            var __this = this;
            if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
            var C = getSpecies(this);
            return new C(function(observer) {
                return __this.subscribe({
                    next: function(value) {
                        if (observer.closed) return;
                        try {
                            value = fn(value);
                        } catch (e) {
                            return observer.error(e);
                        }
                        observer.next(value);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        observer.complete();
                    }
                });
            });
        },
        filter: function(fn) {
            var __this = this;
            if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
            var C = getSpecies(this);
            return new C(function(observer) {
                return __this.subscribe({
                    next: function(value) {
                        if (observer.closed) return;
                        try {
                            if (!fn(value)) return;
                        } catch (e) {
                            return observer.error(e);
                        }
                        observer.next(value);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        observer.complete();
                    }
                });
            });
        },
        reduce: function(fn) {
            var __this = this;
            if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
            var C = getSpecies(this);
            var hasSeed = arguments.length > 1;
            var hasValue = false;
            var seed = arguments[1];
            var acc = seed;
            return new C(function(observer) {
                return __this.subscribe({
                    next: function(value) {
                        if (observer.closed) return;
                        var first = !hasValue;
                        hasValue = true;
                        if (!first || hasSeed) try {
                            acc = fn(acc, value);
                        } catch (e) {
                            return observer.error(e);
                        }
                        else acc = value;
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (!hasValue && !hasSeed) return observer.error(new TypeError("Cannot reduce an empty sequence"));
                        observer.next(acc);
                        observer.complete();
                    }
                });
            });
        }
    });
    Object.defineProperty(Observable.prototype, getSymbol("observable"), {
        value: function() {
            return this;
        },
        writable: true,
        configurable: true
    });
    addMethods(Observable, {
        from: function(x) {
            var C = typeof this === "function" ? this : Observable;
            if (x == null) throw new TypeError(x + " is not an object");
            var method = getMethod(x, getSymbol("observable"));
            if (method) {
                var observable$0 = method.call(x);
                if (Object(observable$0) !== observable$0) throw new TypeError(observable$0 + " is not an object");
                if (observable$0.constructor === C) return observable$0;
                return new C(function(observer) {
                    return observable$0.subscribe(observer);
                });
            }
            if (hasSymbol("iterator") && (method = getMethod(x, getSymbol("iterator")))) return new C(function(observer) {
                for(var __$0 = method.call(x)[Symbol.iterator](), __$1; __$1 = __$0.next(), !__$1.done;){
                    var item$0 = __$1.value;
                    observer.next(item$0);
                    if (observer.closed) return;
                }
                observer.complete();
            });
            if (Array.isArray(x)) return new C(function(observer) {
                for(var i$0 = 0; i$0 < x.length; ++i$0){
                    observer.next(x[i$0]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
            throw new TypeError(x + " is not observable");
        },
        of: function() {
            for(var items = [], __$0 = 0; __$0 < arguments.length; ++__$0)items.push(arguments[__$0]);
            var C = typeof this === "function" ? this : Observable;
            return new C(function(observer) {
                for(var i$1 = 0; i$1 < items.length; ++i$1){
                    observer.next(items[i$1]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        }
    });
    Object.defineProperty(Observable, getSymbol("species"), {
        get: function() {
            return this;
        },
        configurable: true
    });
    Object.defineProperty(Observable, "extensions", {
        value: {
            observableSymbol: getSymbol("observable"),
            setHostReportError: function(fn) {
                hostReportError = fn;
            }
        }
    });
    exports1.Observable = Observable;
}, "*");

});



parcelRequire.register("623cV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46456aead189332c$export$2e2bcd8739ae039; });

var $e67mm = parcelRequire("e67mm");

var $46456aead189332c$var$getDefaultAdapter = function() {
    if (window.indexedDB) return (parcelRequire("hAsiT")).default;
    if ($e67mm && $e67mm.env) throw new Error("Node is not supported");
};
var $46456aead189332c$export$2e2bcd8739ae039 = $46456aead189332c$var$getDefaultAdapter;

});
parcelRequire.register("hAsiT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccdbc102986f69d5$export$2e2bcd8739ae039; });
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");

var $lnHqh = parcelRequire("lnHqh");

var $55dhS = parcelRequire("55dhS");

var $6BLoD = parcelRequire("6BLoD");

var $6uSfH = parcelRequire("6uSfH");
var $ccdbc102986f69d5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ccdbc102986f69d5$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $ccdbc102986f69d5$var$__asyncValues = undefined && undefined.__asyncValues || function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $ccdbc102986f69d5$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $ccdbc102986f69d5$var$logger = new (0, $gBqCF.ConsoleLogger)("DataStore");
var $ccdbc102986f69d5$var$DB_NAME = "amplify-datastore";
var $ccdbc102986f69d5$var$IndexedDBAdapter = /** @class */ function() {
    function IndexedDBAdapter() {}
    IndexedDBAdapter.prototype.checkPrivate = function() {
        return $ccdbc102986f69d5$var$__awaiter(this, void 0, void 0, function() {
            var isPrivate;
            return $ccdbc102986f69d5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $6uSfH.isPrivateMode)().then(function(isPrivate) {
                                return isPrivate;
                            })
                        ];
                    case 1:
                        isPrivate = _a.sent();
                        if (isPrivate) {
                            $ccdbc102986f69d5$var$logger.error("IndexedDB not supported in this browser's private mode");
                            return [
                                2 /*return*/ ,
                                Promise.reject("IndexedDB not supported in this browser's private mode")
                            ];
                        } else return [
                            2 /*return*/ ,
                            Promise.resolve()
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.getStorenameForModel = function(modelConstructor) {
        var namespace = this.namespaceResolver(modelConstructor);
        var modelName = modelConstructor.name;
        return this.getStorename(namespace, modelName);
    };
    IndexedDBAdapter.prototype.getStorename = function(namespace, modelName) {
        var storeName = namespace + "_" + modelName;
        return storeName;
    };
    IndexedDBAdapter.prototype.setUp = function(theSchema, namespaceResolver, modelInstanceCreator, getModelConstructorByModelName) {
        return $ccdbc102986f69d5$var$__awaiter(this, void 0, void 0, function() {
            var _a, error_1;
            var _this = this;
            return $ccdbc102986f69d5$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _b.sent();
                        if (!!this.initPromise) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.initPromise = new Promise(function(res, rej) {
                            _this.resolve = res;
                            _this.reject = rej;
                        });
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            this.initPromise
                        ];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        this.schema = theSchema;
                        this.namespaceResolver = namespaceResolver;
                        this.modelInstanceCreator = modelInstanceCreator;
                        this.getModelConstructorByModelName = getModelConstructorByModelName;
                        _b.label = 5;
                    case 5:
                        _b.trys.push([
                            5,
                            8,
                            ,
                            9
                        ]);
                        if (!!this.db) return [
                            3 /*break*/ ,
                            7
                        ];
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            $lnHqh.openDB($ccdbc102986f69d5$var$DB_NAME, 1, {
                                upgrade: function(db, _oldVersion, _newVersion, _txn) {
                                    var keyPath = "id";
                                    Object.keys(theSchema.namespaces).forEach(function(namespaceName) {
                                        var namespace = theSchema.namespaces[namespaceName];
                                        Object.keys(namespace.models).forEach(function(modelName) {
                                            var indexes = _this.schema.namespaces[namespaceName].relationships[modelName].indexes;
                                            var storeName = _this.getStorename(namespaceName, modelName);
                                            var store = db.createObjectStore(storeName, {
                                                keyPath: keyPath
                                            });
                                            indexes.forEach(function(index) {
                                                return store.createIndex(index, index);
                                            });
                                        });
                                    });
                                }
                            })
                        ];
                    case 6:
                        _a.db = _b.sent();
                        this.resolve();
                        _b.label = 7;
                    case 7:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        error_1 = _b.sent();
                        this.reject(error_1);
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.save = function(model, condition) {
        var e_1, _a;
        return $ccdbc102986f69d5$var$__awaiter(this, void 0, void 0, function() {
            var modelConstructor, storeName, connectedModels, namespaceName, set, connectionStoreNames, tx, store, fromDB, predicates, predicateObjs, type, isValid, msg, result, connectionStoreNames_1, connectionStoreNames_1_1, resItem, storeName_1, item, instance, store_1, id, opType, e_1_1;
            var _this = this;
            return $ccdbc102986f69d5$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _b.sent();
                        modelConstructor = Object.getPrototypeOf(model).constructor;
                        storeName = this.getStorenameForModel(modelConstructor);
                        connectedModels = (0, $6uSfH.traverseModel)(modelConstructor.name, model, this.schema.namespaces[this.namespaceResolver(modelConstructor)], this.modelInstanceCreator, this.getModelConstructorByModelName);
                        namespaceName = this.namespaceResolver(modelConstructor);
                        set = new Set();
                        connectionStoreNames = Object.values(connectedModels).map(function(_a) {
                            var modelName = _a.modelName, item = _a.item, instance = _a.instance;
                            var storeName = _this.getStorename(namespaceName, modelName);
                            set.add(storeName);
                            return {
                                storeName: storeName,
                                item: item,
                                instance: instance
                            };
                        });
                        tx = this.db.transaction($ccdbc102986f69d5$var$__spreadArrays([
                            storeName
                        ], Array.from(set.values())), "readwrite");
                        store = tx.objectStore(storeName);
                        return [
                            4 /*yield*/ ,
                            store.get(model.id)
                        ];
                    case 2:
                        fromDB = _b.sent();
                        if (condition) {
                            predicates = (0, $55dhS.ModelPredicateCreator).getPredicates(condition);
                            predicateObjs = predicates.predicates, type = predicates.type;
                            isValid = (0, $6uSfH.validatePredicate)(fromDB, type, predicateObjs);
                            if (!isValid) {
                                msg = "Conditional update failed";
                                $ccdbc102986f69d5$var$logger.error(msg, {
                                    model: fromDB,
                                    condition: predicateObjs
                                });
                                throw new Error(msg);
                            }
                        }
                        result = [];
                        _b.label = 3;
                    case 3:
                        _b.trys.push([
                            3,
                            12,
                            13,
                            18
                        ]);
                        connectionStoreNames_1 = $ccdbc102986f69d5$var$__asyncValues(connectionStoreNames);
                        _b.label = 4;
                    case 4:
                        return [
                            4 /*yield*/ ,
                            connectionStoreNames_1.next()
                        ];
                    case 5:
                        if (!(connectionStoreNames_1_1 = _b.sent(), !connectionStoreNames_1_1.done)) return [
                            3 /*break*/ ,
                            11
                        ];
                        resItem = connectionStoreNames_1_1.value;
                        storeName_1 = resItem.storeName, item = resItem.item, instance = resItem.instance;
                        store_1 = tx.objectStore(storeName_1);
                        id = item.id;
                        return [
                            4 /*yield*/ ,
                            store_1.get(id)
                        ];
                    case 6:
                        opType = _b.sent() === undefined ? (0, $6BLoD.OpType).INSERT : (0, $6BLoD.OpType).UPDATE;
                        if (!(id === model.id)) return [
                            3 /*break*/ ,
                            8
                        ];
                        return [
                            4 /*yield*/ ,
                            store_1.put(item)
                        ];
                    case 7:
                        _b.sent();
                        result.push([
                            instance,
                            opType
                        ]);
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 8:
                        if (!(opType === (0, $6BLoD.OpType).INSERT)) return [
                            3 /*break*/ ,
                            10
                        ];
                        return [
                            4 /*yield*/ ,
                            store_1.put(item)
                        ];
                    case 9:
                        _b.sent();
                        result.push([
                            instance,
                            opType
                        ]);
                        _b.label = 10;
                    case 10:
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 11:
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 12:
                        e_1_1 = _b.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 13:
                        _b.trys.push([
                            13,
                            ,
                            16,
                            17
                        ]);
                        if (!(connectionStoreNames_1_1 && !connectionStoreNames_1_1.done && (_a = connectionStoreNames_1.return))) return [
                            3 /*break*/ ,
                            15
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(connectionStoreNames_1)
                        ];
                    case 14:
                        _b.sent();
                        _b.label = 15;
                    case 15:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 16:
                        if (e_1) throw e_1.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 17:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 18:
                        return [
                            4 /*yield*/ ,
                            tx.done
                        ];
                    case 19:
                        _b.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.load = function(namespaceName, srcModelName, records) {
        var records_1, records_1_1, records_2, records_2_1;
        var e_2, _a, e_3, _b, e_4, _c;
        return $ccdbc102986f69d5$var$__awaiter(this, void 0, void 0, function() {
            var namespace, relations, connectionStoreNames, modelConstructor, tx, relations_1, relations_1_1, relation, fieldName, modelName, targetName, storeName, store, modelConstructor_1, _d, recordItem, connectionRecord, e_3_1, recordItem, connectionRecord, e_4_1, e_2_1;
            var _this = this;
            return $ccdbc102986f69d5$var$__generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        namespace = this.schema.namespaces[namespaceName];
                        relations = namespace.relationships[srcModelName].relationTypes;
                        connectionStoreNames = relations.map(function(_a) {
                            var modelName = _a.modelName;
                            return _this.getStorename(namespaceName, modelName);
                        });
                        modelConstructor = this.getModelConstructorByModelName(namespaceName, srcModelName);
                        if (connectionStoreNames.length === 0) return [
                            2 /*return*/ ,
                            records.map(function(record) {
                                return _this.modelInstanceCreator(modelConstructor, record);
                            })
                        ];
                        tx = this.db.transaction($ccdbc102986f69d5$var$__spreadArrays(connectionStoreNames), "readonly");
                        _e.label = 1;
                    case 1:
                        _e.trys.push([
                            1,
                            34,
                            35,
                            40
                        ]);
                        relations_1 = $ccdbc102986f69d5$var$__asyncValues(relations);
                        _e.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            relations_1.next()
                        ];
                    case 3:
                        if (!(relations_1_1 = _e.sent(), !relations_1_1.done)) return [
                            3 /*break*/ ,
                            33
                        ];
                        relation = relations_1_1.value;
                        fieldName = relation.fieldName, modelName = relation.modelName, targetName = relation.targetName;
                        storeName = this.getStorename(namespaceName, modelName);
                        store = tx.objectStore(storeName);
                        modelConstructor_1 = this.getModelConstructorByModelName(namespaceName, modelName);
                        _d = relation.relationType;
                        switch(_d){
                            case "HAS_ONE":
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case "BELONGS_TO":
                                return [
                                    3 /*break*/ ,
                                    17
                                ];
                            case "HAS_MANY":
                                return [
                                    3 /*break*/ ,
                                    30
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            31
                        ];
                    case 4:
                        _e.trys.push([
                            4,
                            10,
                            11,
                            16
                        ]);
                        records_1 = $ccdbc102986f69d5$var$__asyncValues(records);
                        _e.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            records_1.next()
                        ];
                    case 6:
                        if (!(records_1_1 = _e.sent(), !records_1_1.done)) return [
                            3 /*break*/ ,
                            9
                        ];
                        recordItem = records_1_1.value;
                        if (!recordItem[fieldName]) return [
                            3 /*break*/ ,
                            8
                        ];
                        return [
                            4 /*yield*/ ,
                            store.get(recordItem[fieldName])
                        ];
                    case 7:
                        connectionRecord = _e.sent();
                        recordItem[fieldName] = connectionRecord && this.modelInstanceCreator(modelConstructor_1, connectionRecord);
                        _e.label = 8;
                    case 8:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 9:
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 10:
                        e_3_1 = _e.sent();
                        e_3 = {
                            error: e_3_1
                        };
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 11:
                        _e.trys.push([
                            11,
                            ,
                            14,
                            15
                        ]);
                        if (!(records_1_1 && !records_1_1.done && (_b = records_1.return))) return [
                            3 /*break*/ ,
                            13
                        ];
                        return [
                            4 /*yield*/ ,
                            _b.call(records_1)
                        ];
                    case 12:
                        _e.sent();
                        _e.label = 13;
                    case 13:
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 14:
                        if (e_3) throw e_3.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 15:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 16:
                        return [
                            3 /*break*/ ,
                            32
                        ];
                    case 17:
                        _e.trys.push([
                            17,
                            23,
                            24,
                            29
                        ]);
                        records_2 = $ccdbc102986f69d5$var$__asyncValues(records);
                        _e.label = 18;
                    case 18:
                        return [
                            4 /*yield*/ ,
                            records_2.next()
                        ];
                    case 19:
                        if (!(records_2_1 = _e.sent(), !records_2_1.done)) return [
                            3 /*break*/ ,
                            22
                        ];
                        recordItem = records_2_1.value;
                        if (!recordItem[targetName]) return [
                            3 /*break*/ ,
                            21
                        ];
                        return [
                            4 /*yield*/ ,
                            store.get(recordItem[targetName])
                        ];
                    case 20:
                        connectionRecord = _e.sent();
                        recordItem[fieldName] = connectionRecord && this.modelInstanceCreator(modelConstructor_1, connectionRecord);
                        delete recordItem[targetName];
                        _e.label = 21;
                    case 21:
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 22:
                        return [
                            3 /*break*/ ,
                            29
                        ];
                    case 23:
                        e_4_1 = _e.sent();
                        e_4 = {
                            error: e_4_1
                        };
                        return [
                            3 /*break*/ ,
                            29
                        ];
                    case 24:
                        _e.trys.push([
                            24,
                            ,
                            27,
                            28
                        ]);
                        if (!(records_2_1 && !records_2_1.done && (_c = records_2.return))) return [
                            3 /*break*/ ,
                            26
                        ];
                        return [
                            4 /*yield*/ ,
                            _c.call(records_2)
                        ];
                    case 25:
                        _e.sent();
                        _e.label = 26;
                    case 26:
                        return [
                            3 /*break*/ ,
                            28
                        ];
                    case 27:
                        if (e_4) throw e_4.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 28:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 29:
                        return [
                            3 /*break*/ ,
                            32
                        ];
                    case 30:
                        // TODO: Lazy loading
                        return [
                            3 /*break*/ ,
                            32
                        ];
                    case 31:
                        (0, $6uSfH.exhaustiveCheck)(relation.relationType);
                        return [
                            3 /*break*/ ,
                            32
                        ];
                    case 32:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 33:
                        return [
                            3 /*break*/ ,
                            40
                        ];
                    case 34:
                        e_2_1 = _e.sent();
                        e_2 = {
                            error: e_2_1
                        };
                        return [
                            3 /*break*/ ,
                            40
                        ];
                    case 35:
                        _e.trys.push([
                            35,
                            ,
                            38,
                            39
                        ]);
                        if (!(relations_1_1 && !relations_1_1.done && (_a = relations_1.return))) return [
                            3 /*break*/ ,
                            37
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(relations_1)
                        ];
                    case 36:
                        _e.sent();
                        _e.label = 37;
                    case 37:
                        return [
                            3 /*break*/ ,
                            39
                        ];
                    case 38:
                        if (e_2) throw e_2.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 39:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 40:
                        return [
                            2 /*return*/ ,
                            records.map(function(record) {
                                return _this.modelInstanceCreator(modelConstructor, record);
                            })
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.query = function(modelConstructor, predicate, pagination) {
        return $ccdbc102986f69d5$var$__awaiter(this, void 0, void 0, function() {
            var storeName, namespaceName, predicates, predicateObjs_1, type_1, idPredicate, id, record, x, all, filtered, _a, _b;
            return $ccdbc102986f69d5$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _c.sent();
                        storeName = this.getStorenameForModel(modelConstructor);
                        namespaceName = this.namespaceResolver(modelConstructor);
                        if (!predicate) return [
                            3 /*break*/ ,
                            8
                        ];
                        predicates = (0, $55dhS.ModelPredicateCreator).getPredicates(predicate);
                        if (!predicates) return [
                            3 /*break*/ ,
                            8
                        ];
                        predicateObjs_1 = predicates.predicates, type_1 = predicates.type;
                        idPredicate = predicateObjs_1.length === 1 && predicateObjs_1.find(function(p) {
                            return (0, $6BLoD.isPredicateObj)(p) && p.field === "id" && p.operator === "eq";
                        });
                        if (!idPredicate) return [
                            3 /*break*/ ,
                            5
                        ];
                        id = idPredicate.operand;
                        return [
                            4 /*yield*/ ,
                            this.db.get(storeName, id)
                        ];
                    case 2:
                        record = _c.sent();
                        if (!record) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this.load(namespaceName, modelConstructor.name, [
                                record
                            ])
                        ];
                    case 3:
                        x = _c.sent()[0];
                        return [
                            2 /*return*/ ,
                            [
                                x
                            ]
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            []
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            this.db.getAll(storeName)
                        ];
                    case 6:
                        all = _c.sent();
                        filtered = predicateObjs_1 ? all.filter(function(m) {
                            return (0, $6uSfH.validatePredicate)(m, type_1, predicateObjs_1);
                        }) : all;
                        return [
                            4 /*yield*/ ,
                            this.load(namespaceName, modelConstructor.name, this.inMemoryPagination(filtered, pagination))
                        ];
                    case 7:
                        return [
                            2 /*return*/ ,
                            _c.sent()
                        ];
                    case 8:
                        _a = this.load;
                        _b = [
                            namespaceName,
                            modelConstructor.name
                        ];
                        return [
                            4 /*yield*/ ,
                            this.enginePagination(storeName, pagination)
                        ];
                    case 9:
                        return [
                            4 /*yield*/ ,
                            _a.apply(this, _b.concat([
                                _c.sent()
                            ]))
                        ];
                    case 10:
                        return [
                            2 /*return*/ ,
                            _c.sent()
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.inMemoryPagination = function(records, pagination) {
        if (pagination) {
            var _a = pagination.page, page = _a === void 0 ? 0 : _a, _b = pagination.limit, limit = _b === void 0 ? 0 : _b;
            var start = Math.max(0, page * limit) || 0;
            var end = limit > 0 ? start + limit : records.length;
            return records.slice(start, end);
        }
        return records;
    };
    IndexedDBAdapter.prototype.enginePagination = function(storeName, pagination) {
        return $ccdbc102986f69d5$var$__awaiter(this, void 0, void 0, function() {
            var result, _a, page, _b, limit, initialRecord, cursor, pageResults, hasLimit, moreRecords, itemsLeft;
            return $ccdbc102986f69d5$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (!pagination) return [
                            3 /*break*/ ,
                            7
                        ];
                        _a = pagination.page, page = _a === void 0 ? 0 : _a, _b = pagination.limit, limit = _b === void 0 ? 0 : _b;
                        initialRecord = Math.max(0, page * limit) || 0;
                        return [
                            4 /*yield*/ ,
                            this.db.transaction(storeName).objectStore(storeName).openCursor()
                        ];
                    case 1:
                        cursor = _c.sent();
                        if (!(initialRecord > 0)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            cursor.advance(initialRecord)
                        ];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        pageResults = [];
                        hasLimit = typeof limit === "number" && limit > 0;
                        moreRecords = true;
                        itemsLeft = limit;
                        _c.label = 4;
                    case 4:
                        if (!(moreRecords && cursor.value)) return [
                            3 /*break*/ ,
                            6
                        ];
                        pageResults.push(cursor.value);
                        return [
                            4 /*yield*/ ,
                            cursor.continue()
                        ];
                    case 5:
                        cursor = _c.sent();
                        if (hasLimit) {
                            itemsLeft--;
                            moreRecords = itemsLeft > 0 && cursor !== null;
                        } else moreRecords = cursor !== null;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 6:
                        result = pageResults;
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 7:
                        return [
                            4 /*yield*/ ,
                            this.db.getAll(storeName)
                        ];
                    case 8:
                        result = _c.sent();
                        _c.label = 9;
                    case 9:
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.queryOne = function(modelConstructor, firstOrLast) {
        if (firstOrLast === void 0) firstOrLast = (0, $6BLoD.QueryOne).FIRST;
        return $ccdbc102986f69d5$var$__awaiter(this, void 0, void 0, function() {
            var storeName, cursor, result;
            return $ccdbc102986f69d5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _a.sent();
                        storeName = this.getStorenameForModel(modelConstructor);
                        return [
                            4 /*yield*/ ,
                            this.db.transaction([
                                storeName
                            ], "readonly").objectStore(storeName).openCursor(undefined, firstOrLast === (0, $6BLoD.QueryOne).FIRST ? "next" : "prev")
                        ];
                    case 2:
                        cursor = _a.sent();
                        result = cursor ? cursor.value : undefined;
                        return [
                            2 /*return*/ ,
                            result && this.modelInstanceCreator(modelConstructor, result)
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.delete = function(modelOrModelConstructor, condition) {
        return $ccdbc102986f69d5$var$__awaiter(this, void 0, void 0, function() {
            var deleteQueue, modelConstructor, nameSpace, storeName, models, relations, deletedModels, deletedModels, model, modelConstructor, nameSpace, storeName, tx, store, fromDB, msg, predicates, predicateObjs, type, isValid, msg, relations, relations, deletedModels;
            return $ccdbc102986f69d5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _a.sent();
                        deleteQueue = [];
                        if (!(0, $6uSfH.isModelConstructor)(modelOrModelConstructor)) return [
                            3 /*break*/ ,
                            9
                        ];
                        modelConstructor = modelOrModelConstructor;
                        nameSpace = this.namespaceResolver(modelConstructor);
                        storeName = this.getStorenameForModel(modelConstructor);
                        return [
                            4 /*yield*/ ,
                            this.query(modelConstructor, condition)
                        ];
                    case 2:
                        models = _a.sent();
                        relations = this.schema.namespaces[nameSpace].relationships[modelConstructor.name].relationTypes;
                        if (!(condition !== undefined)) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.deleteTraverse(relations, models, modelConstructor.name, nameSpace, deleteQueue)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.deleteItem(deleteQueue)
                        ];
                    case 4:
                        _a.sent();
                        deletedModels = deleteQueue.reduce(function(acc, _a) {
                            var items = _a.items;
                            return acc.concat(items);
                        }, []);
                        return [
                            2 /*return*/ ,
                            [
                                models,
                                deletedModels
                            ]
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            this.deleteTraverse(relations, models, modelConstructor.name, nameSpace, deleteQueue)
                        ];
                    case 6:
                        _a.sent();
                        // Delete all
                        return [
                            4 /*yield*/ ,
                            this.db.transaction([
                                storeName
                            ], "readwrite").objectStore(storeName).clear()
                        ];
                    case 7:
                        // Delete all
                        _a.sent();
                        deletedModels = deleteQueue.reduce(function(acc, _a) {
                            var items = _a.items;
                            return acc.concat(items);
                        }, []);
                        return [
                            2 /*return*/ ,
                            [
                                models,
                                deletedModels
                            ]
                        ];
                    case 8:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 9:
                        model = modelOrModelConstructor;
                        modelConstructor = Object.getPrototypeOf(model).constructor;
                        nameSpace = this.namespaceResolver(modelConstructor);
                        storeName = this.getStorenameForModel(modelConstructor);
                        if (!condition) return [
                            3 /*break*/ ,
                            13
                        ];
                        tx = this.db.transaction([
                            storeName
                        ], "readwrite");
                        store = tx.objectStore(storeName);
                        return [
                            4 /*yield*/ ,
                            store.get(model.id)
                        ];
                    case 10:
                        fromDB = _a.sent();
                        if (fromDB === undefined) {
                            msg = "Model instance not found in storage";
                            $ccdbc102986f69d5$var$logger.warn(msg, {
                                model: model
                            });
                            return [
                                2 /*return*/ ,
                                [
                                    [
                                        model
                                    ],
                                    []
                                ]
                            ];
                        }
                        predicates = (0, $55dhS.ModelPredicateCreator).getPredicates(condition);
                        predicateObjs = predicates.predicates, type = predicates.type;
                        isValid = (0, $6uSfH.validatePredicate)(fromDB, type, predicateObjs);
                        if (!isValid) {
                            msg = "Conditional update failed";
                            $ccdbc102986f69d5$var$logger.error(msg, {
                                model: fromDB,
                                condition: predicateObjs
                            });
                            throw new Error(msg);
                        }
                        return [
                            4 /*yield*/ ,
                            tx.done
                        ];
                    case 11:
                        _a.sent();
                        relations = this.schema.namespaces[nameSpace].relationships[modelConstructor.name].relationTypes;
                        return [
                            4 /*yield*/ ,
                            this.deleteTraverse(relations, [
                                model
                            ], modelConstructor.name, nameSpace, deleteQueue)
                        ];
                    case 12:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 13:
                        relations = this.schema.namespaces[nameSpace].relationships[modelConstructor.name].relationTypes;
                        return [
                            4 /*yield*/ ,
                            this.deleteTraverse(relations, [
                                model
                            ], modelConstructor.name, nameSpace, deleteQueue)
                        ];
                    case 14:
                        _a.sent();
                        _a.label = 15;
                    case 15:
                        return [
                            4 /*yield*/ ,
                            this.deleteItem(deleteQueue)
                        ];
                    case 16:
                        _a.sent();
                        deletedModels = deleteQueue.reduce(function(acc, _a) {
                            var items = _a.items;
                            return acc.concat(items);
                        }, []);
                        return [
                            2 /*return*/ ,
                            [
                                [
                                    model
                                ],
                                deletedModels
                            ]
                        ];
                    case 17:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.deleteItem = function(deleteQueue) {
        var deleteQueue_1, deleteQueue_1_1;
        var e_5, _a, e_6, _b;
        return $ccdbc102986f69d5$var$__awaiter(this, void 0, void 0, function() {
            var connectionStoreNames, tx, deleteItem, storeName, items, store, items_1, items_1_1, item, e_6_1, e_5_1;
            return $ccdbc102986f69d5$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        connectionStoreNames = deleteQueue.map(function(_a) {
                            var storeName = _a.storeName;
                            return storeName;
                        });
                        tx = this.db.transaction($ccdbc102986f69d5$var$__spreadArrays(connectionStoreNames), "readwrite");
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            20,
                            21,
                            26
                        ]);
                        deleteQueue_1 = $ccdbc102986f69d5$var$__asyncValues(deleteQueue);
                        _c.label = 2;
                    case 2:
                        return [
                            4 /*yield*/ ,
                            deleteQueue_1.next()
                        ];
                    case 3:
                        if (!(deleteQueue_1_1 = _c.sent(), !deleteQueue_1_1.done)) return [
                            3 /*break*/ ,
                            19
                        ];
                        deleteItem = deleteQueue_1_1.value;
                        storeName = deleteItem.storeName, items = deleteItem.items;
                        store = tx.objectStore(storeName);
                        _c.label = 4;
                    case 4:
                        _c.trys.push([
                            4,
                            12,
                            13,
                            18
                        ]);
                        items_1 = $ccdbc102986f69d5$var$__asyncValues(items);
                        _c.label = 5;
                    case 5:
                        return [
                            4 /*yield*/ ,
                            items_1.next()
                        ];
                    case 6:
                        if (!(items_1_1 = _c.sent(), !items_1_1.done)) return [
                            3 /*break*/ ,
                            11
                        ];
                        item = items_1_1.value;
                        if (!item) return [
                            3 /*break*/ ,
                            10
                        ];
                        if (!(typeof item === "object")) return [
                            3 /*break*/ ,
                            8
                        ];
                        return [
                            4 /*yield*/ ,
                            store.delete(item["id"])
                        ];
                    case 7:
                        _c.sent();
                        _c.label = 8;
                    case 8:
                        return [
                            4 /*yield*/ ,
                            store.delete(item.toString())
                        ];
                    case 9:
                        _c.sent();
                        _c.label = 10;
                    case 10:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 11:
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 12:
                        e_6_1 = _c.sent();
                        e_6 = {
                            error: e_6_1
                        };
                        return [
                            3 /*break*/ ,
                            18
                        ];
                    case 13:
                        _c.trys.push([
                            13,
                            ,
                            16,
                            17
                        ]);
                        if (!(items_1_1 && !items_1_1.done && (_b = items_1.return))) return [
                            3 /*break*/ ,
                            15
                        ];
                        return [
                            4 /*yield*/ ,
                            _b.call(items_1)
                        ];
                    case 14:
                        _c.sent();
                        _c.label = 15;
                    case 15:
                        return [
                            3 /*break*/ ,
                            17
                        ];
                    case 16:
                        if (e_6) throw e_6.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 17:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 18:
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 19:
                        return [
                            3 /*break*/ ,
                            26
                        ];
                    case 20:
                        e_5_1 = _c.sent();
                        e_5 = {
                            error: e_5_1
                        };
                        return [
                            3 /*break*/ ,
                            26
                        ];
                    case 21:
                        _c.trys.push([
                            21,
                            ,
                            24,
                            25
                        ]);
                        if (!(deleteQueue_1_1 && !deleteQueue_1_1.done && (_a = deleteQueue_1.return))) return [
                            3 /*break*/ ,
                            23
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(deleteQueue_1)
                        ];
                    case 22:
                        _c.sent();
                        _c.label = 23;
                    case 23:
                        return [
                            3 /*break*/ ,
                            25
                        ];
                    case 24:
                        if (e_5) throw e_5.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 25:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 26:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.deleteTraverse = function(relations, models, srcModel, nameSpace, deleteQueue) {
        var relations_2, relations_2_1, models_1, models_1_1, models_2, models_2_1;
        var e_7, _a, e_8, _b, e_9, _c;
        return $ccdbc102986f69d5$var$__awaiter(this, void 0, void 0, function() {
            var rel, relationType, fieldName, modelName, storeName, _d, model, index_1, recordToDelete, e_8_1, index, model, childrenArray, e_9_1, e_7_1;
            var _this = this;
            return $ccdbc102986f69d5$var$__generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _e.trys.push([
                            0,
                            36,
                            37,
                            42
                        ]);
                        relations_2 = $ccdbc102986f69d5$var$__asyncValues(relations);
                        _e.label = 1;
                    case 1:
                        return [
                            4 /*yield*/ ,
                            relations_2.next()
                        ];
                    case 2:
                        if (!(relations_2_1 = _e.sent(), !relations_2_1.done)) return [
                            3 /*break*/ ,
                            35
                        ];
                        rel = relations_2_1.value;
                        relationType = rel.relationType, fieldName = rel.fieldName, modelName = rel.modelName;
                        storeName = this.getStorename(nameSpace, modelName);
                        _d = relationType;
                        switch(_d){
                            case "HAS_ONE":
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case "HAS_MANY":
                                return [
                                    3 /*break*/ ,
                                    17
                                ];
                            case "BELONGS_TO":
                                return [
                                    3 /*break*/ ,
                                    32
                                ];
                        }
                        return [
                            3 /*break*/ ,
                            33
                        ];
                    case 3:
                        _e.trys.push([
                            3,
                            10,
                            11,
                            16
                        ]);
                        models_1 = $ccdbc102986f69d5$var$__asyncValues(models);
                        _e.label = 4;
                    case 4:
                        return [
                            4 /*yield*/ ,
                            models_1.next()
                        ];
                    case 5:
                        if (!(models_1_1 = _e.sent(), !models_1_1.done)) return [
                            3 /*break*/ ,
                            9
                        ];
                        model = models_1_1.value;
                        index_1 = (0, $6uSfH.getIndex)(this.schema.namespaces[nameSpace].relationships[modelName].relationTypes, srcModel);
                        return [
                            4 /*yield*/ ,
                            this.db.transaction(storeName, "readwrite").objectStore(storeName).index(index_1).get(model.id)
                        ];
                    case 6:
                        recordToDelete = _e.sent();
                        return [
                            4 /*yield*/ ,
                            this.deleteTraverse(this.schema.namespaces[nameSpace].relationships[modelName].relationTypes, recordToDelete ? [
                                recordToDelete
                            ] : [], modelName, nameSpace, deleteQueue)
                        ];
                    case 7:
                        _e.sent();
                        _e.label = 8;
                    case 8:
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 9:
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 10:
                        e_8_1 = _e.sent();
                        e_8 = {
                            error: e_8_1
                        };
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 11:
                        _e.trys.push([
                            11,
                            ,
                            14,
                            15
                        ]);
                        if (!(models_1_1 && !models_1_1.done && (_b = models_1.return))) return [
                            3 /*break*/ ,
                            13
                        ];
                        return [
                            4 /*yield*/ ,
                            _b.call(models_1)
                        ];
                    case 12:
                        _e.sent();
                        _e.label = 13;
                    case 13:
                        return [
                            3 /*break*/ ,
                            15
                        ];
                    case 14:
                        if (e_8) throw e_8.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 15:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 16:
                        return [
                            3 /*break*/ ,
                            34
                        ];
                    case 17:
                        index = (0, $6uSfH.getIndex)(this.schema.namespaces[nameSpace].relationships[modelName].relationTypes, srcModel);
                        _e.label = 18;
                    case 18:
                        _e.trys.push([
                            18,
                            25,
                            26,
                            31
                        ]);
                        models_2 = $ccdbc102986f69d5$var$__asyncValues(models);
                        _e.label = 19;
                    case 19:
                        return [
                            4 /*yield*/ ,
                            models_2.next()
                        ];
                    case 20:
                        if (!(models_2_1 = _e.sent(), !models_2_1.done)) return [
                            3 /*break*/ ,
                            24
                        ];
                        model = models_2_1.value;
                        return [
                            4 /*yield*/ ,
                            this.db.transaction(storeName, "readwrite").objectStore(storeName).index(index).getAll(model["id"])
                        ];
                    case 21:
                        childrenArray = _e.sent();
                        return [
                            4 /*yield*/ ,
                            this.deleteTraverse(this.schema.namespaces[nameSpace].relationships[modelName].relationTypes, childrenArray, modelName, nameSpace, deleteQueue)
                        ];
                    case 22:
                        _e.sent();
                        _e.label = 23;
                    case 23:
                        return [
                            3 /*break*/ ,
                            19
                        ];
                    case 24:
                        return [
                            3 /*break*/ ,
                            31
                        ];
                    case 25:
                        e_9_1 = _e.sent();
                        e_9 = {
                            error: e_9_1
                        };
                        return [
                            3 /*break*/ ,
                            31
                        ];
                    case 26:
                        _e.trys.push([
                            26,
                            ,
                            29,
                            30
                        ]);
                        if (!(models_2_1 && !models_2_1.done && (_c = models_2.return))) return [
                            3 /*break*/ ,
                            28
                        ];
                        return [
                            4 /*yield*/ ,
                            _c.call(models_2)
                        ];
                    case 27:
                        _e.sent();
                        _e.label = 28;
                    case 28:
                        return [
                            3 /*break*/ ,
                            30
                        ];
                    case 29:
                        if (e_9) throw e_9.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 30:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 31:
                        return [
                            3 /*break*/ ,
                            34
                        ];
                    case 32:
                        // Intentionally blank
                        return [
                            3 /*break*/ ,
                            34
                        ];
                    case 33:
                        (0, $6uSfH.exhaustiveCheck)(relationType);
                        return [
                            3 /*break*/ ,
                            34
                        ];
                    case 34:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 35:
                        return [
                            3 /*break*/ ,
                            42
                        ];
                    case 36:
                        e_7_1 = _e.sent();
                        e_7 = {
                            error: e_7_1
                        };
                        return [
                            3 /*break*/ ,
                            42
                        ];
                    case 37:
                        _e.trys.push([
                            37,
                            ,
                            40,
                            41
                        ]);
                        if (!(relations_2_1 && !relations_2_1.done && (_a = relations_2.return))) return [
                            3 /*break*/ ,
                            39
                        ];
                        return [
                            4 /*yield*/ ,
                            _a.call(relations_2)
                        ];
                    case 38:
                        _e.sent();
                        _e.label = 39;
                    case 39:
                        return [
                            3 /*break*/ ,
                            41
                        ];
                    case 40:
                        if (e_7) throw e_7.error;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 41:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 42:
                        deleteQueue.push({
                            storeName: this.getStorename(nameSpace, srcModel),
                            items: models.map(function(record) {
                                return _this.modelInstanceCreator(_this.getModelConstructorByModelName(nameSpace, srcModel), record);
                            })
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    IndexedDBAdapter.prototype.clear = function() {
        return $ccdbc102986f69d5$var$__awaiter(this, void 0, void 0, function() {
            return $ccdbc102986f69d5$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.checkPrivate()
                        ];
                    case 1:
                        _a.sent();
                        this.db.close();
                        return [
                            4 /*yield*/ ,
                            $lnHqh.deleteDB($ccdbc102986f69d5$var$DB_NAME)
                        ];
                    case 2:
                        _a.sent();
                        this.db = undefined;
                        this.initPromise = undefined;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return IndexedDBAdapter;
}();
var $ccdbc102986f69d5$export$2e2bcd8739ae039 = new $ccdbc102986f69d5$var$IndexedDBAdapter();

});
parcelRequire.register("lnHqh", function(module, exports) {

$parcel$export(module.exports, "openDB", function () { return $f90d6dd76c16f9ab$export$ca0ed41b1a2af7e; });
$parcel$export(module.exports, "deleteDB", function () { return $f90d6dd76c16f9ab$export$9d6df0ac66a98bb2; });

var $7PGFG = parcelRequire("7PGFG");
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $f90d6dd76c16f9ab$export$ca0ed41b1a2af7e(name, version, { blocked: blocked , upgrade: upgrade , blocking: blocking  } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $7PGFG.a)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $7PGFG.a)(request.result), event.oldVersion, event.newVersion, (0, $7PGFG.a)(request.transaction));
    });
    if (blocked) request.addEventListener("blocked", ()=>blocked());
    if (blocking) openPromise.then((db)=>db.addEventListener("versionchange", blocking));
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $f90d6dd76c16f9ab$export$9d6df0ac66a98bb2(name, { blocked: blocked  } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", ()=>blocked());
    return (0, $7PGFG.a)(request).then(()=>undefined);
}
const $f90d6dd76c16f9ab$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $f90d6dd76c16f9ab$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $f90d6dd76c16f9ab$var$cachedMethods = new Map();
function $f90d6dd76c16f9ab$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($f90d6dd76c16f9ab$var$cachedMethods.get(prop)) return $f90d6dd76c16f9ab$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $f90d6dd76c16f9ab$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $f90d6dd76c16f9ab$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        const returnVal = target[targetFuncName](...args);
        if (isWrite) await tx.done;
        return returnVal;
    };
    $f90d6dd76c16f9ab$var$cachedMethods.set(prop, method);
    return method;
}
(0, $7PGFG.b)((oldTraps)=>({
        get: (target, prop, receiver)=>$f90d6dd76c16f9ab$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$f90d6dd76c16f9ab$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));

});
parcelRequire.register("7PGFG", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $5b3e657691906156$export$407448d2b89b1813; });
$parcel$export(module.exports, "b", function () { return $5b3e657691906156$export$8b22cf2602fb60ce; });
const $5b3e657691906156$export$db3b6bfb95261072 = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $5b3e657691906156$var$idbProxyableTypes;
let $5b3e657691906156$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $5b3e657691906156$var$getIdbProxyableTypes() {
    return $5b3e657691906156$var$idbProxyableTypes || ($5b3e657691906156$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $5b3e657691906156$var$getCursorAdvanceMethods() {
    return $5b3e657691906156$var$cursorAdvanceMethods || ($5b3e657691906156$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $5b3e657691906156$var$cursorRequestMap = new WeakMap();
const $5b3e657691906156$var$transactionDoneMap = new WeakMap();
const $5b3e657691906156$var$transactionStoreNamesMap = new WeakMap();
const $5b3e657691906156$var$transformCache = new WeakMap();
const $5b3e657691906156$export$4368d992c4eafac0 = new WeakMap();
function $5b3e657691906156$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($5b3e657691906156$export$407448d2b89b1813(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $5b3e657691906156$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $5b3e657691906156$export$4368d992c4eafac0.set(promise, request);
    return promise;
}
function $5b3e657691906156$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($5b3e657691906156$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error);
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $5b3e657691906156$var$transactionDoneMap.set(tx, done);
}
let $5b3e657691906156$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $5b3e657691906156$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $5b3e657691906156$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $5b3e657691906156$export$407448d2b89b1813(target[prop]);
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $5b3e657691906156$export$8b22cf2602fb60ce(callback) {
    $5b3e657691906156$var$idbProxyTraps = callback($5b3e657691906156$var$idbProxyTraps);
}
function $5b3e657691906156$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($5b3e657691906156$export$f1e1789686576879(this), storeNames, ...args);
        $5b3e657691906156$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $5b3e657691906156$export$407448d2b89b1813(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($5b3e657691906156$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($5b3e657691906156$export$f1e1789686576879(this), args);
        return $5b3e657691906156$export$407448d2b89b1813($5b3e657691906156$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $5b3e657691906156$export$407448d2b89b1813(func.apply($5b3e657691906156$export$f1e1789686576879(this), args));
    };
}
function $5b3e657691906156$var$transformCachableValue(value) {
    if (typeof value === "function") return $5b3e657691906156$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $5b3e657691906156$var$cacheDonePromiseForTransaction(value);
    if ($5b3e657691906156$export$db3b6bfb95261072(value, $5b3e657691906156$var$getIdbProxyableTypes())) return new Proxy(value, $5b3e657691906156$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $5b3e657691906156$export$407448d2b89b1813(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $5b3e657691906156$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($5b3e657691906156$var$transformCache.has(value)) return $5b3e657691906156$var$transformCache.get(value);
    const newValue = $5b3e657691906156$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $5b3e657691906156$var$transformCache.set(value, newValue);
        $5b3e657691906156$export$4368d992c4eafac0.set(newValue, value);
    }
    return newValue;
}
const $5b3e657691906156$export$f1e1789686576879 = (value)=>$5b3e657691906156$export$4368d992c4eafac0.get(value);

});





parcelRequire.register("jhcba", function(module, exports) {

$parcel$export(module.exports, "SyncEngine", function () { return $e0890d59e5067205$export$a108e476d76cdffb; });
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");

var $9fvEQ = parcelRequire("9fvEQ");

var $eOKlk = parcelRequire("eOKlk");

var $55dhS = parcelRequire("55dhS");

var $6uSfH = parcelRequire("6uSfH");

var $bGVVj = parcelRequire("bGVVj");

var $UtQ2R = parcelRequire("UtQ2R");

var $izyzt = parcelRequire("izyzt");

var $1ncV3 = parcelRequire("1ncV3");

var $MV52f = parcelRequire("MV52f");

var $kCEcI = parcelRequire("kCEcI");

var $bCU9m = parcelRequire("bCU9m");
var $e0890d59e5067205$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e0890d59e5067205$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $e0890d59e5067205$var$logger = new (0, $gBqCF.ConsoleLogger)("DataStore");
var $e0890d59e5067205$var$ownSymbol = Symbol("sync");
var $e0890d59e5067205$export$a108e476d76cdffb = /** @class */ function() {
    function SyncEngine(schema, namespaceResolver, modelClasses, userModelClasses, storage, modelInstanceCreator, maxRecordsToSync, syncPageSize, conflictHandler, errorHandler) {
        this.schema = schema;
        this.namespaceResolver = namespaceResolver;
        this.modelClasses = modelClasses;
        this.userModelClasses = userModelClasses;
        this.storage = storage;
        this.modelInstanceCreator = modelInstanceCreator;
        this.maxRecordsToSync = maxRecordsToSync;
        this.syncPageSize = syncPageSize;
        this.started = false;
        this.online = false;
        this.processingMutations = false;
        var MutationEvent = this.modelClasses["MutationEvent"];
        this.outbox = new (0, $izyzt.MutationEventOutbox)(this.schema, this.namespaceResolver, MutationEvent, $e0890d59e5067205$var$ownSymbol);
        this.modelMerger = new (0, $UtQ2R.ModelMerger)(this.outbox, $e0890d59e5067205$var$ownSymbol);
        this.syncQueriesProcessor = new (0, $kCEcI.SyncProcessor)(this.schema, maxRecordsToSync, syncPageSize);
        this.subscriptionsProcessor = new (0, $MV52f.SubscriptionProcessor)(this.schema);
        this.mutationsProcessor = new (0, $1ncV3.MutationProcessor)(this.schema, this.storage, this.userModelClasses, this.outbox, this.modelInstanceCreator, MutationEvent, conflictHandler, errorHandler);
    }
    SyncEngine.prototype.start = function(params) {
        var _this = this;
        return new (0, $eOKlk.default)(function(observer) {
            $e0890d59e5067205$var$logger.log("starting sync engine...");
            _this.started = true;
            var subscriptions = [];
            (function() {
                return $e0890d59e5067205$var$__awaiter(_this, void 0, void 0, function() {
                    var err_1, datastoreConnectivity;
                    var _this = this;
                    return $e0890d59e5067205$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                _a.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.setupModels(params)
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                err_1 = _a.sent();
                                $e0890d59e5067205$var$logger.error("Sync engine error on start", err_1);
                                return [
                                    2 /*return*/ 
                                ];
                            case 3:
                                datastoreConnectivity = new (0, $bGVVj.default)();
                                datastoreConnectivity.status().subscribe(function(_a) {
                                    var online = _a.online;
                                    return $e0890d59e5067205$var$__awaiter(_this, void 0, void 0, function() {
                                        var _b, ctlSubsObservable, dataSubsObservable, errorHandler, _c, _d, err_2, currentTimeStamp, modelLastSync, paginatingModels, syncQueriesObservable, syncQuerySubscription, err_3;
                                        var _this = this;
                                        return $e0890d59e5067205$var$__generator(this, function(_e) {
                                            switch(_e.label){
                                                case 0:
                                                    if (!(online && !this.online)) return [
                                                        3 /*break*/ ,
                                                        10
                                                    ];
                                                    _b = this.subscriptionsProcessor.start(), ctlSubsObservable = _b[0], dataSubsObservable = _b[1];
                                                    errorHandler = this.disconnectionHandler(datastoreConnectivity);
                                                    _e.label = 1;
                                                case 1:
                                                    _e.trys.push([
                                                        1,
                                                        3,
                                                        ,
                                                        4
                                                    ]);
                                                    _d = (_c = subscriptions).push;
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.waitForSubscriptionsReady(ctlSubsObservable, errorHandler)
                                                    ];
                                                case 2:
                                                    _d.apply(_c, [
                                                        _e.sent()
                                                    ]);
                                                    return [
                                                        3 /*break*/ ,
                                                        4
                                                    ];
                                                case 3:
                                                    err_2 = _e.sent();
                                                    observer.error(err_2);
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                case 4:
                                                    $e0890d59e5067205$var$logger.log("Realtime ready");
                                                    currentTimeStamp = new Date().getTime();
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.getModelsMetadataWithNextFullSync(currentTimeStamp)
                                                    ];
                                                case 5:
                                                    modelLastSync = _e.sent();
                                                    paginatingModels = new Set(modelLastSync.keys());
                                                    syncQueriesObservable = this.syncQueriesProcessor.start(modelLastSync);
                                                    if (this.isFullSync(modelLastSync)) {
                                                        clearTimeout(this.fullSyncTimeoutId);
                                                        this.fullSyncTimeoutId = undefined;
                                                    }
                                                    _e.label = 6;
                                                case 6:
                                                    _e.trys.push([
                                                        6,
                                                        8,
                                                        ,
                                                        9
                                                    ]);
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.waitForSyncQueries(syncQueriesObservable, paginatingModels)
                                                    ];
                                                case 7:
                                                    syncQuerySubscription = _e.sent();
                                                    if (syncQuerySubscription) subscriptions.push(syncQuerySubscription);
                                                    return [
                                                        3 /*break*/ ,
                                                        9
                                                    ];
                                                case 8:
                                                    err_3 = _e.sent();
                                                    observer.error(err_3);
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                                case 9:
                                                    //#endregion
                                                    //#region process mutations
                                                    subscriptions.push(this.mutationsProcessor.start().subscribe(function(_a) {
                                                        var _transformerMutationType = _a[0], modelDefinition = _a[1], item = _a[2];
                                                        var modelConstructor = _this.userModelClasses[modelDefinition.name];
                                                        var model = _this.modelInstanceCreator(modelConstructor, item);
                                                        _this.modelMerger.merge(_this.storage, model);
                                                    }));
                                                    //#endregion
                                                    // TODO: extract to function
                                                    subscriptions.push(dataSubsObservable.subscribe(function(_a) {
                                                        var _transformerMutationType = _a[0], modelDefinition = _a[1], item = _a[2];
                                                        var modelConstructor = _this.userModelClasses[modelDefinition.name];
                                                        var model = _this.modelInstanceCreator(modelConstructor, item);
                                                        _this.modelMerger.merge(_this.storage, model);
                                                    }));
                                                    return [
                                                        3 /*break*/ ,
                                                        11
                                                    ];
                                                case 10:
                                                    if (!online) {
                                                        subscriptions.forEach(function(sub) {
                                                            return sub.unsubscribe();
                                                        });
                                                        subscriptions = [];
                                                    }
                                                    _e.label = 11;
                                                case 11:
                                                    this.online = online;
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                });
                                this.storage.observe(null, null, $e0890d59e5067205$var$ownSymbol).filter(function(_a) {
                                    var model = _a.model;
                                    var modelDefinition = _this.getModelDefinition(model);
                                    return modelDefinition.syncable === true;
                                }).subscribe({
                                    next: function(_a) {
                                        var opType = _a.opType, model = _a.model, element = _a.element, condition = _a.condition;
                                        return $e0890d59e5067205$var$__awaiter(_this, void 0, void 0, function() {
                                            var namespace, MutationEventConstructor, graphQLCondition, mutationEvent;
                                            return $e0890d59e5067205$var$__generator(this, function(_b) {
                                                switch(_b.label){
                                                    case 0:
                                                        namespace = this.schema.namespaces[this.namespaceResolver(model)];
                                                        MutationEventConstructor = this.modelClasses["MutationEvent"];
                                                        graphQLCondition = (0, $bCU9m.predicateToGraphQLCondition)(condition);
                                                        mutationEvent = (0, $bCU9m.createMutationInstanceFromModelOperation)(namespace.relationships, this.getModelDefinition(model), opType, model, element, graphQLCondition, MutationEventConstructor, this.modelInstanceCreator);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.outbox.enqueue(this.storage, mutationEvent)
                                                        ];
                                                    case 1:
                                                        _b.sent();
                                                        if (this.online) this.mutationsProcessor.resume();
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    }
                                });
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            })();
            return function() {
                subscriptions.forEach(function(sub) {
                    return sub.unsubscribe();
                });
            };
        });
    };
    SyncEngine.prototype.getModelsMetadataWithNextFullSync = function(currentTimeStamp) {
        return $e0890d59e5067205$var$__awaiter(this, void 0, void 0, function() {
            var modelLastSync, _a;
            var _this = this;
            return $e0890d59e5067205$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = Map.bind;
                        return [
                            4 /*yield*/ ,
                            this.getModelsMetadata()
                        ];
                    case 1:
                        modelLastSync = new (_a.apply(Map, [
                            void 0,
                            _b.sent().map(function(_a) {
                                var namespace = _a.namespace, model = _a.model, lastSync = _a.lastSync, lastFullSync = _a.lastFullSync, fullSyncInterval = _a.fullSyncInterval;
                                var nextFullSync = lastFullSync + fullSyncInterval;
                                var syncFrom = !lastFullSync || nextFullSync < currentTimeStamp ? 0 // perform full sync if expired
                                 : lastSync; // perform delta sync
                                return [
                                    _this.schema.namespaces[namespace].models[model],
                                    [
                                        namespace,
                                        syncFrom
                                    ]
                                ];
                            })
                        ]))();
                        return [
                            2 /*return*/ ,
                            modelLastSync
                        ];
                }
            });
        });
    };
    SyncEngine.prototype.isFullSync = function(modelsMap) {
        for(var _i = 0, _a = Array.from(modelsMap.values()); _i < _a.length; _i++){
            var _b = _a[_i], syncFrom = _b[1];
            if (syncFrom === 0) return true;
        }
        return false;
    };
    SyncEngine.prototype.waitForSyncQueries = function(observable, paginatingModels) {
        return $e0890d59e5067205$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $e0890d59e5067205$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        if (!_this.online) resolve();
                        var currentTimeStamp = new Date().getTime();
                        var subscription = observable.subscribe({
                            error: function(err) {
                                reject(err);
                            },
                            next: function(_a) {
                                var namespace = _a.namespace, modelDefinition = _a.modelDefinition, items = _a.items, done = _a.done, startedAt = _a.startedAt, isFullSync = _a.isFullSync;
                                return $e0890d59e5067205$var$__awaiter(_this, void 0, void 0, function() {
                                    var promises, modelMetadata_1, fullSyncInterval;
                                    var _this = this;
                                    return $e0890d59e5067205$var$__generator(this, function(_b) {
                                        switch(_b.label){
                                            case 0:
                                                promises = items.map(function(item) {
                                                    return $e0890d59e5067205$var$__awaiter(_this, void 0, void 0, function() {
                                                        var modelConstructor, model;
                                                        return $e0890d59e5067205$var$__generator(this, function(_a) {
                                                            modelConstructor = this.userModelClasses[modelDefinition.name];
                                                            model = this.modelInstanceCreator(modelConstructor, item);
                                                            return [
                                                                2 /*return*/ ,
                                                                this.modelMerger.merge(this.storage, model)
                                                            ];
                                                        });
                                                    });
                                                });
                                                return [
                                                    4 /*yield*/ ,
                                                    Promise.all(promises)
                                                ];
                                            case 1:
                                                _b.sent();
                                                if (!done) return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                                paginatingModels.delete(modelDefinition);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.getModelMetadata(namespace, modelDefinition.name)
                                                ];
                                            case 2:
                                                modelMetadata_1 = _b.sent();
                                                modelMetadata_1 = this.modelClasses.ModelMetadata.copyOf(modelMetadata_1, function(draft) {
                                                    draft.lastSync = startedAt;
                                                    draft.lastFullSync = isFullSync ? currentTimeStamp : modelMetadata_1.lastFullSync;
                                                });
                                                fullSyncInterval = modelMetadata_1.fullSyncInterval;
                                                return [
                                                    4 /*yield*/ ,
                                                    this.storage.save(modelMetadata_1, undefined, $e0890d59e5067205$var$ownSymbol)
                                                ];
                                            case 3:
                                                _b.sent();
                                                // resolve promise if all done
                                                if (paginatingModels.size === 0) resolve(subscription);
                                                if (isFullSync && !this.fullSyncTimeoutId) // register next full sync when no full sync is already scheduled
                                                this.fullSyncTimeoutId = setTimeout(function() {
                                                    return $e0890d59e5067205$var$__awaiter(_this, void 0, void 0, function() {
                                                        var currentTimeStamp, modelLastSync, paginatingModels, syncQueriesObservable;
                                                        return $e0890d59e5067205$var$__generator(this, function(_a) {
                                                            switch(_a.label){
                                                                case 0:
                                                                    currentTimeStamp = new Date().getTime();
                                                                    return [
                                                                        4 /*yield*/ ,
                                                                        this.getModelsMetadataWithNextFullSync(currentTimeStamp)
                                                                    ];
                                                                case 1:
                                                                    modelLastSync = _a.sent();
                                                                    paginatingModels = new Set(modelLastSync.keys());
                                                                    syncQueriesObservable = this.syncQueriesProcessor.start(modelLastSync);
                                                                    this.fullSyncTimeoutId = undefined;
                                                                    this.waitForSyncQueries(syncQueriesObservable, paginatingModels);
                                                                    return [
                                                                        2 /*return*/ 
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                }, fullSyncInterval);
                                                _b.label = 4;
                                            case 4:
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }
                        });
                    })
                ];
            });
        });
    };
    SyncEngine.prototype.disconnectionHandler = function(datastoreConnectivity) {
        return function(msg) {
            // This implementation is tight to AWSAppSyncRealTimeProvider 'Connection closed', 'Timeout disconnect' msg
            if ((0, $9fvEQ.CONTROL_MSG).CONNECTION_CLOSED === msg || (0, $9fvEQ.CONTROL_MSG).TIMEOUT_DISCONNECT === msg) datastoreConnectivity.socketDisconnected();
        };
    };
    SyncEngine.prototype.waitForSubscriptionsReady = function(ctlSubsObservable, errorHandler) {
        return $e0890d59e5067205$var$__awaiter(this, void 0, void 0, function() {
            return $e0890d59e5067205$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var subscription = ctlSubsObservable.subscribe({
                            next: function(msg) {
                                if (msg === (0, $MV52f.CONTROL_MSG).CONNECTED) resolve(subscription);
                            },
                            error: function(err) {
                                reject("subscription failed " + err);
                                errorHandler(err);
                            }
                        });
                    })
                ];
            });
        });
    };
    SyncEngine.prototype.setupModels = function(params) {
        return $e0890d59e5067205$var$__awaiter(this, void 0, void 0, function() {
            var fullSyncInterval, ModelMetadata, models, promises;
            var _this = this;
            return $e0890d59e5067205$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        fullSyncInterval = params.fullSyncInterval;
                        ModelMetadata = this.modelClasses.ModelMetadata;
                        models = [];
                        Object.values(this.schema.namespaces).forEach(function(namespace) {
                            Object.values(namespace.models).filter(function(_a) {
                                var syncable = _a.syncable;
                                return syncable;
                            }).forEach(function(model) {
                                models.push([
                                    namespace.name,
                                    model.name
                                ]);
                            });
                        });
                        promises = models.map(function(_a) {
                            var namespace = _a[0], model = _a[1];
                            return $e0890d59e5067205$var$__awaiter(_this, void 0, void 0, function() {
                                var modelMetadata;
                                return $e0890d59e5067205$var$__generator(this, function(_b) {
                                    switch(_b.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                this.getModelMetadata(namespace, model)
                                            ];
                                        case 1:
                                            modelMetadata = _b.sent();
                                            if (!(modelMetadata === undefined)) return [
                                                3 /*break*/ ,
                                                3
                                            ];
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.save(this.modelInstanceCreator(ModelMetadata, {
                                                    model: model,
                                                    namespace: namespace,
                                                    lastSync: null,
                                                    fullSyncInterval: fullSyncInterval,
                                                    lastFullSync: null
                                                }), undefined, $e0890d59e5067205$var$ownSymbol)
                                            ];
                                        case 2:
                                            _b.sent();
                                            return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                        case 3:
                                            return [
                                                4 /*yield*/ ,
                                                this.storage.save(this.modelClasses.ModelMetadata.copyOf(modelMetadata, function(draft) {
                                                    draft.fullSyncInterval = fullSyncInterval;
                                                }))
                                            ];
                                        case 4:
                                            _b.sent();
                                            _b.label = 5;
                                        case 5:
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            });
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(promises)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SyncEngine.prototype.getModelsMetadata = function() {
        return $e0890d59e5067205$var$__awaiter(this, void 0, void 0, function() {
            var ModelMetadata, modelsMetadata;
            return $e0890d59e5067205$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ModelMetadata = this.modelClasses.ModelMetadata;
                        return [
                            4 /*yield*/ ,
                            this.storage.query(ModelMetadata)
                        ];
                    case 1:
                        modelsMetadata = _a.sent();
                        return [
                            2 /*return*/ ,
                            modelsMetadata
                        ];
                }
            });
        });
    };
    SyncEngine.prototype.getModelMetadata = function(namespace, model) {
        return $e0890d59e5067205$var$__awaiter(this, void 0, void 0, function() {
            var ModelMetadata, predicate, modelMetadata;
            return $e0890d59e5067205$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ModelMetadata = this.modelClasses.ModelMetadata;
                        predicate = (0, $55dhS.ModelPredicateCreator).createFromExisting(this.schema.namespaces[0, $6uSfH.SYNC].models[ModelMetadata.name], function(c) {
                            return c.namespace("eq", namespace).model("eq", model);
                        });
                        return [
                            4 /*yield*/ ,
                            this.storage.query(ModelMetadata, predicate)
                        ];
                    case 1:
                        modelMetadata = _a.sent()[0];
                        return [
                            2 /*return*/ ,
                            modelMetadata
                        ];
                }
            });
        });
    };
    SyncEngine.prototype.getModelDefinition = function(modelConstructor) {
        var namespaceName = this.namespaceResolver(modelConstructor);
        var modelDefinition = this.schema.namespaces[namespaceName].models[modelConstructor.name];
        return modelDefinition;
    };
    SyncEngine.getNamespace = function() {
        var namespace = {
            name: (0, $6uSfH.SYNC),
            relationships: {},
            enums: {
                OperationType: {
                    name: "OperationType",
                    values: [
                        "CREATE",
                        "UPDATE",
                        "DELETE"
                    ]
                }
            },
            nonModels: {},
            models: {
                MutationEvent: {
                    name: "MutationEvent",
                    pluralName: "MutationEvents",
                    syncable: false,
                    fields: {
                        id: {
                            name: "id",
                            type: "ID",
                            isRequired: true,
                            isArray: false
                        },
                        model: {
                            name: "model",
                            type: "String",
                            isRequired: true,
                            isArray: false
                        },
                        data: {
                            name: "data",
                            type: "String",
                            isRequired: true,
                            isArray: false
                        },
                        modelId: {
                            name: "modelId",
                            type: "String",
                            isRequired: true,
                            isArray: false
                        },
                        operation: {
                            name: "operation",
                            type: {
                                enum: "Operationtype"
                            },
                            isArray: false,
                            isRequired: true
                        },
                        condition: {
                            name: "condition",
                            type: "String",
                            isArray: false,
                            isRequired: true
                        }
                    }
                },
                ModelMetadata: {
                    name: "ModelMetadata",
                    pluralName: "ModelsMetadata",
                    syncable: false,
                    fields: {
                        id: {
                            name: "id",
                            type: "ID",
                            isRequired: true,
                            isArray: false
                        },
                        namespace: {
                            name: "namespace",
                            type: "String",
                            isRequired: true,
                            isArray: false
                        },
                        model: {
                            name: "model",
                            type: "String",
                            isRequired: true,
                            isArray: false
                        },
                        lastSync: {
                            name: "lastSync",
                            type: "Int",
                            isRequired: false,
                            isArray: false
                        },
                        lastFullSync: {
                            name: "lastFullSync",
                            type: "Int",
                            isRequired: false,
                            isArray: false
                        },
                        fullSyncInterval: {
                            name: "fullSyncInterval",
                            type: "Int",
                            isRequired: true,
                            isArray: false
                        }
                    }
                }
            }
        };
        return namespace;
    };
    return SyncEngine;
}();

});
parcelRequire.register("9fvEQ", function(module, exports) {

$parcel$export(module.exports, "CONTROL_MSG", function () { return $6bbe1259414cdb85$export$f96baa4bc836aea4; });
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $iO4Fu = parcelRequire("iO4Fu");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $2hWDt = parcelRequire("2hWDt");

var $8ii8v = parcelRequire("8ii8v");
var $6bbe1259414cdb85$var$logger = new (0, $gBqCF.ConsoleLogger)("PubSub");
var $6bbe1259414cdb85$export$f96baa4bc836aea4;
(function(CONTROL_MSG) {
    CONTROL_MSG["CONNECTION_CLOSED"] = "Connection closed";
    CONTROL_MSG["TIMEOUT_DISCONNECT"] = "Timeout disconnect";
})($6bbe1259414cdb85$export$f96baa4bc836aea4 || ($6bbe1259414cdb85$export$f96baa4bc836aea4 = {}));
var $6bbe1259414cdb85$var$_instance = null;
if (!$6bbe1259414cdb85$var$_instance) {
    $6bbe1259414cdb85$var$logger.debug("Create PubSub Instance");
    $6bbe1259414cdb85$var$_instance = new (0, $iO4Fu.default)(null);
}
var $6bbe1259414cdb85$var$PubSub = $6bbe1259414cdb85$var$_instance;
(0, $2hWDt.default).register($6bbe1259414cdb85$var$PubSub);
var $6bbe1259414cdb85$export$2e2bcd8739ae039 = $6bbe1259414cdb85$var$PubSub;
$parcel$exportWildcard(module.exports, $8ii8v);

});
parcelRequire.register("iO4Fu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db10848951e3e9fc$export$2e2bcd8739ae039; });

var $gbejU = parcelRequire("gbejU");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $2SWCi = parcelRequire("2SWCi");
parcelRequire("e0UL9");
var $eMsKa = parcelRequire("eMsKa");
var $kP1l1 = parcelRequire("kP1l1");
var $db10848951e3e9fc$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $db10848951e3e9fc$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $db10848951e3e9fc$var$logger = new (0, $gBqCF.ConsoleLogger)("PubSub");
var $db10848951e3e9fc$var$PubSub = /** @class */ function() {
    /**
     * Initialize PubSub with AWS configurations
     *
     * @param {PubSubOptions} options - Configuration object for PubSub
     */ function PubSub(options) {
        this._options = options;
        $db10848951e3e9fc$var$logger.debug("PubSub Options", this._options);
        this._pluggables = [];
        this.subscribe = this.subscribe.bind(this);
    }
    Object.defineProperty(PubSub.prototype, "awsAppSyncProvider", {
        /**
         * Lazy instantiate AWSAppSyncProvider when it is required by the API category
         */ get: function() {
            if (!this._awsAppSyncProvider) this._awsAppSyncProvider = new (0, $eMsKa.AWSAppSyncProvider)(this._options);
            return this._awsAppSyncProvider;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PubSub.prototype, "awsAppSyncRealTimeProvider", {
        /**
         * Lazy instantiate AWSAppSyncRealTimeProvider when it is required by the API category
         */ get: function() {
            if (!this._awsAppSyncRealTimeProvider) this._awsAppSyncRealTimeProvider = new (0, $kP1l1.AWSAppSyncRealTimeProvider)(this._options);
            return this._awsAppSyncRealTimeProvider;
        },
        enumerable: true,
        configurable: true
    });
    PubSub.prototype.getModuleName = function() {
        return "PubSub";
    };
    /**
     * Configure PubSub part with configurations
     *
     * @param {PubSubOptions} config - Configuration for PubSub
     * @return {Object} - The current configuration
     */ PubSub.prototype.configure = function(options) {
        var _this = this;
        var opt = options ? options.PubSub || options : {};
        $db10848951e3e9fc$var$logger.debug("configure PubSub", {
            opt: opt
        });
        this._options = Object.assign({}, this._options, opt);
        this._pluggables.map(function(pluggable) {
            return pluggable.configure(_this._options);
        });
        return this._options;
    };
    /**
     * add plugin into Analytics category
     * @param {Object} pluggable - an instance of the plugin
     */ PubSub.prototype.addPluggable = function(pluggable) {
        return $db10848951e3e9fc$var$__awaiter(this, void 0, void 0, function() {
            var config;
            return $db10848951e3e9fc$var$__generator(this, function(_a) {
                if (pluggable && pluggable.getCategory() === "PubSub") {
                    this._pluggables.push(pluggable);
                    config = pluggable.configure(this._options);
                    return [
                        2 /*return*/ ,
                        config
                    ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    PubSub.prototype.getProviderByName = function(providerName) {
        if (providerName === (0, $2SWCi.INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER)) return this.awsAppSyncProvider;
        if (providerName === (0, $2SWCi.INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER)) return this.awsAppSyncRealTimeProvider;
        return this._pluggables.find(function(pluggable) {
            return pluggable.getProviderName() === providerName;
        });
    };
    PubSub.prototype.getProviders = function(options) {
        if (options === void 0) options = {};
        var providerName = options.provider;
        if (!providerName) return this._pluggables;
        var provider = this.getProviderByName(providerName);
        if (!provider) throw new Error("Could not find provider named " + providerName);
        return [
            provider
        ];
    };
    PubSub.prototype.publish = function(topics, msg, options) {
        return $db10848951e3e9fc$var$__awaiter(this, void 0, void 0, function() {
            return $db10848951e3e9fc$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    Promise.all(this.getProviders(options).map(function(provider) {
                        return provider.publish(topics, msg, options);
                    }))
                ];
            });
        });
    };
    PubSub.prototype.subscribe = function(topics, options) {
        $db10848951e3e9fc$var$logger.debug("subscribe options", options);
        var providers = this.getProviders(options);
        return new $gbejU(function(observer) {
            var observables = providers.map(function(provider) {
                return {
                    provider: provider,
                    observable: provider.subscribe(topics, options)
                };
            });
            var subscriptions = observables.map(function(_a) {
                var provider = _a.provider, observable = _a.observable;
                return observable.subscribe({
                    start: console.error,
                    next: function(value) {
                        return observer.next({
                            provider: provider,
                            value: value
                        });
                    },
                    error: function(error) {
                        return observer.error({
                            provider: provider,
                            error: error
                        });
                    }
                });
            });
            return function() {
                return subscriptions.forEach(function(subscription) {
                    return subscription.unsubscribe();
                });
            };
        });
    };
    return PubSub;
}();
var $db10848951e3e9fc$export$2e2bcd8739ae039 = $db10848951e3e9fc$var$PubSub;

});
parcelRequire.register("e0UL9", function(module, exports) {
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */ 
var $a6BNt = parcelRequire("a6BNt");

var $eMsKa = parcelRequire("eMsKa");

var $kP1l1 = parcelRequire("kP1l1");

var $8ii8v = parcelRequire("8ii8v");

var $6XBdA = parcelRequire("6XBdA");
$parcel$exportWildcard(module.exports, $a6BNt);
$parcel$exportWildcard(module.exports, $eMsKa);
$parcel$exportWildcard(module.exports, $kP1l1);
$parcel$exportWildcard(module.exports, $8ii8v);
$parcel$exportWildcard(module.exports, $6XBdA);

});
parcelRequire.register("a6BNt", function(module, exports) {

$parcel$export(module.exports, "AbstractPubSubProvider", function () { return $75b7c89fdabfd679$export$38596aa9173af3e4; });
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $75b7c89fdabfd679$var$__assign = undefined && undefined.__assign || function() {
    $75b7c89fdabfd679$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $75b7c89fdabfd679$var$__assign.apply(this, arguments);
};
var $75b7c89fdabfd679$var$logger = new (0, $gBqCF.ConsoleLogger)("AbstractPubSubProvider");
var $75b7c89fdabfd679$export$38596aa9173af3e4 = /** @class */ function() {
    function AbstractPubSubProvider(options) {
        if (options === void 0) options = {};
        this._config = options;
    }
    AbstractPubSubProvider.prototype.configure = function(config) {
        if (config === void 0) config = {};
        this._config = $75b7c89fdabfd679$var$__assign($75b7c89fdabfd679$var$__assign({}, config), this._config);
        $75b7c89fdabfd679$var$logger.debug("configure " + this.getProviderName(), this._config);
        return this.options;
    };
    AbstractPubSubProvider.prototype.getCategory = function() {
        return "PubSub";
    };
    Object.defineProperty(AbstractPubSubProvider.prototype, "options", {
        get: function() {
            return $75b7c89fdabfd679$var$__assign({}, this._config);
        },
        enumerable: true,
        configurable: true
    });
    return AbstractPubSubProvider;
}();

});

parcelRequire.register("eMsKa", function(module, exports) {

$parcel$export(module.exports, "AWSAppSyncProvider", function () { return $ac2bd844f76f30ce$export$937fc88a753c4320; });

var $gbejU = parcelRequire("gbejU");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");

var $6XBdA = parcelRequire("6XBdA");
var $ac2bd844f76f30ce$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ac2bd844f76f30ce$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ac2bd844f76f30ce$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $ac2bd844f76f30ce$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ac2bd844f76f30ce$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $ac2bd844f76f30ce$var$logger = new (0, $gBqCF.ConsoleLogger)("AWSAppSyncProvider");
var $ac2bd844f76f30ce$export$937fc88a753c4320 = /** @class */ function(_super) {
    $ac2bd844f76f30ce$var$__extends(AWSAppSyncProvider, _super);
    function AWSAppSyncProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._topicClient = new Map();
        _this._topicAlias = new Map();
        return _this;
    }
    Object.defineProperty(AWSAppSyncProvider.prototype, "endpoint", {
        get: function() {
            throw new Error("Not supported");
        },
        enumerable: true,
        configurable: true
    });
    AWSAppSyncProvider.prototype.getProviderName = function() {
        return "AWSAppSyncProvider";
    };
    AWSAppSyncProvider.prototype.publish = function(topics, msg, options) {
        return $ac2bd844f76f30ce$var$__awaiter(this, void 0, void 0, function() {
            return $ac2bd844f76f30ce$var$__generator(this, function(_a) {
                throw new Error("Operation not supported");
            });
        });
    };
    AWSAppSyncProvider.prototype._cleanUp = function(clientId) {
        var _this = this;
        var topicsForClient = Array.from(this._topicClient.entries()).filter(function(_a) {
            var c = _a[1];
            return c.clientId === clientId;
        }).map(function(_a) {
            var t = _a[0];
            return t;
        });
        topicsForClient.forEach(function(t) {
            return _this._cleanUpForTopic(t);
        });
    };
    AWSAppSyncProvider.prototype._cleanUpForTopic = function(topic) {
        this._topicClient.delete(topic);
        this._topicAlias.delete(topic);
    };
    AWSAppSyncProvider.prototype.onDisconnect = function(_a) {
        var _this = this;
        var clientId = _a.clientId, errorCode = _a.errorCode, args = $ac2bd844f76f30ce$var$__rest(_a, [
            "clientId",
            "errorCode"
        ]);
        if (errorCode !== 0) {
            var topicsForClient = Array.from(this._topicClient.entries()).filter(function(_a) {
                var c = _a[1];
                return c.clientId === clientId;
            }).map(function(_a) {
                var t = _a[0];
                return t;
            });
            topicsForClient.forEach(function(topic) {
                if (_this._topicObservers.has(topic)) {
                    _this._topicObservers.get(topic).forEach(function(obs) {
                        if (!obs.closed) obs.error(args);
                    });
                    _this._topicObservers.delete(topic);
                }
            });
            this._cleanUp(clientId);
        }
    };
    AWSAppSyncProvider.prototype.disconnect = function(clientId) {
        return $ac2bd844f76f30ce$var$__awaiter(this, void 0, void 0, function() {
            var client;
            return $ac2bd844f76f30ce$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.clientsQueue.get(clientId, function() {
                                return null;
                            })
                        ];
                    case 1:
                        client = _a.sent();
                        return [
                            4 /*yield*/ ,
                            _super.prototype.disconnect.call(this, clientId)
                        ];
                    case 2:
                        _a.sent();
                        this._cleanUp(clientId);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSAppSyncProvider.prototype.subscribe = function(topics, options) {
        var _this = this;
        if (options === void 0) options = {};
        var result = new $gbejU(function(observer) {
            var targetTopics = [].concat(topics);
            $ac2bd844f76f30ce$var$logger.debug("Subscribing to topic(s)", targetTopics.join(","));
            (function() {
                return $ac2bd844f76f30ce$var$__awaiter(_this, void 0, void 0, function() {
                    var _a, mqttConnections, newSubscriptions, newAliases, map;
                    var _this = this;
                    return $ac2bd844f76f30ce$var$__generator(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                // Add these topics to map
                                targetTopics.forEach(function(t) {
                                    if (!_this._topicObservers.has(t)) _this._topicObservers.set(t, new Set());
                                    _this._topicObservers.get(t).add(observer);
                                });
                                _a = options.mqttConnections, mqttConnections = _a === void 0 ? [] : _a, newSubscriptions = options.newSubscriptions;
                                newAliases = Object.entries(newSubscriptions).map(function(_a) {
                                    var alias = _a[0], v = _a[1];
                                    return [
                                        v.topic,
                                        alias
                                    ];
                                });
                                // Merge new aliases with old ones
                                this._topicAlias = new Map($ac2bd844f76f30ce$var$__spreadArrays(Array.from(this._topicAlias.entries()), newAliases));
                                map = Object.entries(targetTopics.reduce(function(acc, elem) {
                                    var connectionInfoForTopic = mqttConnections.find(function(c) {
                                        return c.topics.indexOf(elem) > -1;
                                    });
                                    if (connectionInfoForTopic) {
                                        var clientId = connectionInfoForTopic.client, url = connectionInfoForTopic.url;
                                        if (!acc[clientId]) acc[clientId] = {
                                            url: url,
                                            topics: new Set()
                                        };
                                        acc[clientId].topics.add(elem);
                                    }
                                    return acc;
                                }, {}));
                                // reconnect everything we have in the map
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(map.map(function(_a) {
                                        var clientId = _a[0], _b = _a[1], url = _b.url, topics = _b.topics;
                                        return $ac2bd844f76f30ce$var$__awaiter(_this, void 0, void 0, function() {
                                            var client, err_1;
                                            var _this = this;
                                            return $ac2bd844f76f30ce$var$__generator(this, function(_c) {
                                                switch(_c.label){
                                                    case 0:
                                                        client = null;
                                                        _c.label = 1;
                                                    case 1:
                                                        _c.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4 /*yield*/ ,
                                                            this.connect(clientId, {
                                                                clientId: clientId,
                                                                url: url
                                                            })
                                                        ];
                                                    case 2:
                                                        client = _c.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            4
                                                        ];
                                                    case 3:
                                                        err_1 = _c.sent();
                                                        observer.error({
                                                            message: "Failed to connect",
                                                            error: err_1
                                                        });
                                                        observer.complete();
                                                        return [
                                                            2 /*return*/ ,
                                                            undefined
                                                        ];
                                                    case 4:
                                                        // subscribe to all topics for this client
                                                        // store topic-client mapping
                                                        topics.forEach(function(topic) {
                                                            if (client.isConnected()) {
                                                                client.subscribe(topic);
                                                                _this._topicClient.set(topic, client);
                                                            }
                                                        });
                                                        return [
                                                            2 /*return*/ ,
                                                            client
                                                        ];
                                                }
                                            });
                                        });
                                    }))
                                ];
                            case 1:
                                // reconnect everything we have in the map
                                _b.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            })();
            return function() {
                $ac2bd844f76f30ce$var$logger.debug("Unsubscribing from topic(s)", targetTopics.join(","));
                targetTopics.forEach(function(t) {
                    var client = _this._topicClient.get(t);
                    if (client && client.isConnected()) {
                        client.unsubscribe(t);
                        _this._topicClient.delete(t);
                        if (!Array.from(_this._topicClient.values()).some(function(c) {
                            return c === client;
                        })) _this.disconnect(client.clientId);
                    }
                    _this._topicObservers.delete(t);
                });
            };
        });
        return $gbejU.from(result).map(function(value) {
            var topic = _this.getTopicForValue(value);
            var alias = _this._topicAlias.get(topic);
            value.data = Object.entries(value.data).reduce(function(obj, _a) {
                var origKey = _a[0], val = _a[1];
                return obj[alias || origKey] = val, obj;
            }, {});
            return value;
        });
    };
    return AWSAppSyncProvider;
}((0, $6XBdA.MqttOverWSProvider));

});
parcelRequire.register("6XBdA", function(module, exports) {

$parcel$export(module.exports, "MqttOverWSProvider", function () { return $51151f7d6b9dcdc2$export$4e8eac6aa347b425; });

var $anDWk = parcelRequire("anDWk");

var $toYCK = parcelRequire("toYCK");

var $gbejU = parcelRequire("gbejU");

var $a6BNt = parcelRequire("a6BNt");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $51151f7d6b9dcdc2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $51151f7d6b9dcdc2$var$__assign = undefined && undefined.__assign || function() {
    $51151f7d6b9dcdc2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $51151f7d6b9dcdc2$var$__assign.apply(this, arguments);
};
var $51151f7d6b9dcdc2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $51151f7d6b9dcdc2$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $51151f7d6b9dcdc2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $51151f7d6b9dcdc2$var$logger = new (0, $gBqCF.ConsoleLogger)("MqttOverWSProvider");
function $51151f7d6b9dcdc2$export$4848305770dbede7(filter, topic) {
    var filterArray = filter.split("/");
    var length = filterArray.length;
    var topicArray = topic.split("/");
    for(var i = 0; i < length; ++i){
        var left = filterArray[i];
        var right = topicArray[i];
        if (left === "#") return topicArray.length >= length;
        if (left !== "+" && left !== right) return false;
    }
    return length === topicArray.length;
}
var $51151f7d6b9dcdc2$var$ClientsQueue = /** @class */ function() {
    function ClientsQueue() {
        this.promises = new Map();
    }
    ClientsQueue.prototype.get = function(clientId, clientFactory) {
        return $51151f7d6b9dcdc2$var$__awaiter(this, void 0, void 0, function() {
            var promise;
            return $51151f7d6b9dcdc2$var$__generator(this, function(_a) {
                promise = this.promises.get(clientId);
                if (promise) return [
                    2 /*return*/ ,
                    promise
                ];
                promise = clientFactory(clientId);
                this.promises.set(clientId, promise);
                return [
                    2 /*return*/ ,
                    promise
                ];
            });
        });
    };
    Object.defineProperty(ClientsQueue.prototype, "allClients", {
        get: function() {
            return Array.from(this.promises.keys());
        },
        enumerable: true,
        configurable: true
    });
    ClientsQueue.prototype.remove = function(clientId) {
        this.promises.delete(clientId);
    };
    return ClientsQueue;
}();
var $51151f7d6b9dcdc2$var$topicSymbol = typeof Symbol !== "undefined" ? Symbol("topic") : "@@topic";
var $51151f7d6b9dcdc2$export$4e8eac6aa347b425 = /** @class */ function(_super) {
    $51151f7d6b9dcdc2$var$__extends(MqttOverWSProvider, _super);
    function MqttOverWSProvider(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, $51151f7d6b9dcdc2$var$__assign($51151f7d6b9dcdc2$var$__assign({}, options), {
            clientId: options.clientId || (0, $toYCK.v4)()
        })) || this;
        _this._clientsQueue = new $51151f7d6b9dcdc2$var$ClientsQueue();
        _this._topicObservers = new Map();
        _this._clientIdObservers = new Map();
        return _this;
    }
    Object.defineProperty(MqttOverWSProvider.prototype, "clientId", {
        get: function() {
            return this.options.clientId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MqttOverWSProvider.prototype, "endpoint", {
        get: function() {
            return this.options.aws_pubsub_endpoint;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MqttOverWSProvider.prototype, "clientsQueue", {
        get: function() {
            return this._clientsQueue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MqttOverWSProvider.prototype, "isSSLEnabled", {
        get: function() {
            return !this.options.aws_appsync_dangerously_connect_to_http_endpoint_for_testing;
        },
        enumerable: true,
        configurable: true
    });
    MqttOverWSProvider.prototype.getTopicForValue = function(value) {
        return typeof value === "object" && value[$51151f7d6b9dcdc2$var$topicSymbol];
    };
    MqttOverWSProvider.prototype.getProviderName = function() {
        return "MqttOverWSProvider";
    };
    MqttOverWSProvider.prototype.onDisconnect = function(_a) {
        var _this = this;
        var clientId = _a.clientId, errorCode = _a.errorCode, args = $51151f7d6b9dcdc2$var$__rest(_a, [
            "clientId",
            "errorCode"
        ]);
        if (errorCode !== 0) {
            $51151f7d6b9dcdc2$var$logger.warn(clientId, JSON.stringify($51151f7d6b9dcdc2$var$__assign({
                errorCode: errorCode
            }, args), null, 2));
            var topicsToDelete_1 = [];
            var clientIdObservers = this._clientIdObservers.get(clientId);
            if (!clientIdObservers) return;
            clientIdObservers.forEach(function(observer) {
                observer.error("Disconnected, error code: " + errorCode);
                // removing observers for disconnected clientId
                _this._topicObservers.forEach(function(observerForTopic, observerTopic) {
                    observerForTopic.delete(observer);
                    if (observerForTopic.size === 0) topicsToDelete_1.push(observerTopic);
                });
            });
            // forgiving any trace of clientId
            this._clientIdObservers.delete(clientId);
            // Removing topics that are not listen by an observer
            topicsToDelete_1.forEach(function(topic) {
                _this._topicObservers.delete(topic);
            });
        }
    };
    MqttOverWSProvider.prototype.newClient = function(_a) {
        var url = _a.url, clientId = _a.clientId;
        return $51151f7d6b9dcdc2$var$__awaiter(this, void 0, void 0, function() {
            var client;
            var _this = this;
            return $51151f7d6b9dcdc2$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $51151f7d6b9dcdc2$var$logger.debug("Creating new MQTT client", clientId);
                        client = new $anDWk.Client(url, clientId);
                        // client.trace = (args) => logger.debug(clientId, JSON.stringify(args, null, 2));
                        client.onMessageArrived = function(_a) {
                            var topic = _a.destinationName, msg = _a.payloadString;
                            _this._onMessage(topic, msg);
                        };
                        client.onConnectionLost = function(_a) {
                            var errorCode = _a.errorCode, args = $51151f7d6b9dcdc2$var$__rest(_a, [
                                "errorCode"
                            ]);
                            _this.onDisconnect($51151f7d6b9dcdc2$var$__assign({
                                clientId: clientId,
                                errorCode: errorCode
                            }, args));
                        };
                        return [
                            4 /*yield*/ ,
                            new Promise(function(resolve, reject) {
                                client.connect({
                                    useSSL: _this.isSSLEnabled,
                                    mqttVersion: 3,
                                    onSuccess: function() {
                                        return resolve(client);
                                    },
                                    onFailure: reject
                                });
                            })
                        ];
                    case 1:
                        _b.sent();
                        return [
                            2 /*return*/ ,
                            client
                        ];
                }
            });
        });
    };
    MqttOverWSProvider.prototype.connect = function(clientId, options) {
        if (options === void 0) options = {};
        return $51151f7d6b9dcdc2$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $51151f7d6b9dcdc2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.clientsQueue.get(clientId, function(clientId) {
                                return _this.newClient($51151f7d6b9dcdc2$var$__assign($51151f7d6b9dcdc2$var$__assign({}, options), {
                                    clientId: clientId
                                }));
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    MqttOverWSProvider.prototype.disconnect = function(clientId) {
        return $51151f7d6b9dcdc2$var$__awaiter(this, void 0, void 0, function() {
            var client;
            return $51151f7d6b9dcdc2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.clientsQueue.get(clientId, function() {
                                return null;
                            })
                        ];
                    case 1:
                        client = _a.sent();
                        if (client && client.isConnected()) client.disconnect();
                        this.clientsQueue.remove(clientId);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MqttOverWSProvider.prototype.publish = function(topics, msg) {
        return $51151f7d6b9dcdc2$var$__awaiter(this, void 0, void 0, function() {
            var targetTopics, message, url, client;
            return $51151f7d6b9dcdc2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        targetTopics = [].concat(topics);
                        message = JSON.stringify(msg);
                        return [
                            4 /*yield*/ ,
                            this.endpoint
                        ];
                    case 1:
                        url = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.connect(this.clientId, {
                                url: url
                            })
                        ];
                    case 2:
                        client = _a.sent();
                        $51151f7d6b9dcdc2$var$logger.debug("Publishing to topic(s)", targetTopics.join(","), message);
                        targetTopics.forEach(function(topic) {
                            return client.send(topic, message);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MqttOverWSProvider.prototype._onMessage = function(topic, msg) {
        try {
            var matchedTopicObservers_1 = [];
            this._topicObservers.forEach(function(observerForTopic, observerTopic) {
                if ($51151f7d6b9dcdc2$export$4848305770dbede7(observerTopic, topic)) matchedTopicObservers_1.push(observerForTopic);
            });
            var parsedMessage_1 = JSON.parse(msg);
            if (typeof parsedMessage_1 === "object") parsedMessage_1[$51151f7d6b9dcdc2$var$topicSymbol] = topic;
            matchedTopicObservers_1.forEach(function(observersForTopic) {
                observersForTopic.forEach(function(observer) {
                    return observer.next(parsedMessage_1);
                });
            });
        } catch (error) {
            $51151f7d6b9dcdc2$var$logger.warn("Error handling message", error, msg);
        }
    };
    MqttOverWSProvider.prototype.subscribe = function(topics, options) {
        var _this = this;
        if (options === void 0) options = {};
        var targetTopics = [].concat(topics);
        $51151f7d6b9dcdc2$var$logger.debug("Subscribing to topic(s)", targetTopics.join(","));
        return new $gbejU(function(observer) {
            targetTopics.forEach(function(topic) {
                // this._topicObservers is used to notify the observers according to the topic received on the message
                var observersForTopic = _this._topicObservers.get(topic);
                if (!observersForTopic) {
                    observersForTopic = new Set();
                    _this._topicObservers.set(topic, observersForTopic);
                }
                observersForTopic.add(observer);
            });
            // @ts-ignore
            var client;
            var _a = options.clientId, clientId = _a === void 0 ? _this.clientId : _a;
            // this._clientIdObservers is used to close observers when client gets disconnected
            var observersForClientId = _this._clientIdObservers.get(clientId);
            if (!observersForClientId) observersForClientId = new Set();
            observersForClientId.add(observer);
            _this._clientIdObservers.set(clientId, observersForClientId);
            (function() {
                return $51151f7d6b9dcdc2$var$__awaiter(_this, void 0, void 0, function() {
                    var _a, url, _b, e_1;
                    return $51151f7d6b9dcdc2$var$__generator(this, function(_c) {
                        switch(_c.label){
                            case 0:
                                _a = options.url;
                                if (!(_a === void 0)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    this.endpoint
                                ];
                            case 1:
                                _b = _c.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                _b = _a;
                                _c.label = 3;
                            case 3:
                                url = _b;
                                _c.label = 4;
                            case 4:
                                _c.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    this.connect(clientId, {
                                        url: url
                                    })
                                ];
                            case 5:
                                client = _c.sent();
                                targetTopics.forEach(function(topic) {
                                    client.subscribe(topic);
                                });
                                return [
                                    3 /*break*/ ,
                                    7
                                ];
                            case 6:
                                e_1 = _c.sent();
                                observer.error(e_1);
                                return [
                                    3 /*break*/ ,
                                    7
                                ];
                            case 7:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            })();
            return function() {
                $51151f7d6b9dcdc2$var$logger.debug("Unsubscribing from topic(s)", targetTopics.join(","));
                if (client) {
                    _this._clientIdObservers.get(clientId).delete(observer);
                    // No more observers per client => client not needed anymore
                    if (_this._clientIdObservers.get(clientId).size === 0) {
                        _this.disconnect(clientId);
                        _this._clientIdObservers.delete(clientId);
                    }
                    targetTopics.forEach(function(topic) {
                        var observersForTopic = _this._topicObservers.get(topic) || new Set();
                        observersForTopic.delete(observer);
                        // if no observers exists for the topic, topic should be removed
                        if (observersForTopic.size === 0) {
                            _this._topicObservers.delete(topic);
                            if (client.isConnected()) client.unsubscribe(topic);
                        }
                    });
                }
                return null;
            };
        });
    };
    return MqttOverWSProvider;
}((0, $a6BNt.AbstractPubSubProvider));

});


parcelRequire.register("kP1l1", function(module, exports) {

$parcel$export(module.exports, "AWSAppSyncRealTimeProvider", function () { return $f2899bc91e1f2d7a$export$b7b5e6371992068d; });

var $gbejU = parcelRequire("gbejU");

var $a4gcw = parcelRequire("a4gcw");

var $i3eDV = parcelRequire("i3eDV");

var $toYCK = parcelRequire("toYCK");

var $5oOz5 = parcelRequire("5oOz5");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $iZUWK = parcelRequire("iZUWK");
var $2SWCi = parcelRequire("2SWCi");
var $2hWDt = parcelRequire("2hWDt");
var $9opJY = parcelRequire("9opJY");
var $aCVDw = parcelRequire("aCVDw");
var $kP2rz = parcelRequire("kP2rz");

var $9x214 = parcelRequire("9x214");

var $hbz3E = parcelRequire("hbz3E");

var $a6BNt = parcelRequire("a6BNt");

var $9fvEQ = parcelRequire("9fvEQ");
var $f2899bc91e1f2d7a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f2899bc91e1f2d7a$var$__assign = undefined && undefined.__assign || function() {
    $f2899bc91e1f2d7a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f2899bc91e1f2d7a$var$__assign.apply(this, arguments);
};
var $f2899bc91e1f2d7a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f2899bc91e1f2d7a$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f2899bc91e1f2d7a$var$logger = new (0, $gBqCF.ConsoleLogger)("AWSAppSyncRealTimeProvider");
var $f2899bc91e1f2d7a$var$AMPLIFY_SYMBOL = typeof Symbol !== "undefined" && typeof Symbol.for === "function" ? Symbol.for("amplify_default") : "@@amplify_default";
var $f2899bc91e1f2d7a$var$dispatchApiEvent = function(event, data, message) {
    (0, $iZUWK.default).dispatch("api", {
        event: event,
        data: data,
        message: message
    }, "PubSub", $f2899bc91e1f2d7a$var$AMPLIFY_SYMBOL);
};
var $f2899bc91e1f2d7a$var$MAX_DELAY_MS = 5000;
var $f2899bc91e1f2d7a$var$NON_RETRYABLE_CODES = [
    400,
    401,
    403
];
var $f2899bc91e1f2d7a$var$MESSAGE_TYPES;
(function(MESSAGE_TYPES) {
    /**
     * Client -> Server message.
     * This message type is the first message after handshake and this will initialize AWS AppSync RealTime communication
     */ MESSAGE_TYPES["GQL_CONNECTION_INIT"] = "connection_init";
    /**
     * Server -> Client message
     * This message type is in case there is an issue with AWS AppSync RealTime when establishing connection
     */ MESSAGE_TYPES["GQL_CONNECTION_ERROR"] = "connection_error";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_CONNECTION_INIT message
     */ MESSAGE_TYPES["GQL_CONNECTION_ACK"] = "connection_ack";
    /**
     * Client -> Server message.
     * This message type is for register subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_START"] = "start";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_START message
     */ MESSAGE_TYPES["GQL_START_ACK"] = "start_ack";
    /**
     * Server -> Client message.
     * This message type is for subscription message from AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_DATA"] = "data";
    /**
     * Server -> Client message.
     * This message type helps the client to know is still receiving messages from AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_CONNECTION_KEEP_ALIVE"] = "ka";
    /**
     * Client -> Server message.
     * This message type is for unregister subscriptions with AWS AppSync RealTime
     */ MESSAGE_TYPES["GQL_STOP"] = "stop";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_STOP message
     */ MESSAGE_TYPES["GQL_COMPLETE"] = "complete";
    /**
     * Server -> Client message.
     * This message type is for sending error messages from AWS AppSync RealTime to the client
     */ MESSAGE_TYPES["GQL_ERROR"] = "error";
})($f2899bc91e1f2d7a$var$MESSAGE_TYPES || ($f2899bc91e1f2d7a$var$MESSAGE_TYPES = {}));
var $f2899bc91e1f2d7a$var$SUBSCRIPTION_STATUS;
(function(SUBSCRIPTION_STATUS) {
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["PENDING"] = 0] = "PENDING";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["CONNECTED"] = 1] = "CONNECTED";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["FAILED"] = 2] = "FAILED";
})($f2899bc91e1f2d7a$var$SUBSCRIPTION_STATUS || ($f2899bc91e1f2d7a$var$SUBSCRIPTION_STATUS = {}));
var $f2899bc91e1f2d7a$var$SOCKET_STATUS;
(function(SOCKET_STATUS) {
    SOCKET_STATUS[SOCKET_STATUS["CLOSED"] = 0] = "CLOSED";
    SOCKET_STATUS[SOCKET_STATUS["READY"] = 1] = "READY";
    SOCKET_STATUS[SOCKET_STATUS["CONNECTING"] = 2] = "CONNECTING";
})($f2899bc91e1f2d7a$var$SOCKET_STATUS || ($f2899bc91e1f2d7a$var$SOCKET_STATUS = {}));
var $f2899bc91e1f2d7a$var$AWS_APPSYNC_REALTIME_HEADERS = {
    accept: "application/json, text/javascript",
    "content-encoding": "amz-1.0",
    "content-type": "application/json; charset=UTF-8"
};
/**
 * Time in milleseconds to wait for GQL_CONNECTION_INIT message
 */ var $f2899bc91e1f2d7a$var$CONNECTION_INIT_TIMEOUT = 15000;
/**
 * Time in milleseconds to wait for GQL_START_ACK message
 */ var $f2899bc91e1f2d7a$var$START_ACK_TIMEOUT = 15000;
/**
 * Default Time in milleseconds to wait for GQL_CONNECTION_KEEP_ALIVE message
 */ var $f2899bc91e1f2d7a$var$DEFAULT_KEEP_ALIVE_TIMEOUT = 300000;
var $f2899bc91e1f2d7a$export$b7b5e6371992068d = /** @class */ function(_super) {
    $f2899bc91e1f2d7a$var$__extends(AWSAppSyncRealTimeProvider, _super);
    function AWSAppSyncRealTimeProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.socketStatus = $f2899bc91e1f2d7a$var$SOCKET_STATUS.CLOSED;
        _this.keepAliveTimeout = $f2899bc91e1f2d7a$var$DEFAULT_KEEP_ALIVE_TIMEOUT;
        _this.subscriptionObserverMap = new Map();
        _this.promiseArray = [];
        return _this;
    }
    AWSAppSyncRealTimeProvider.prototype.getProviderName = function() {
        return "AWSAppSyncRealTimeProvider";
    };
    AWSAppSyncRealTimeProvider.prototype.newClient = function() {
        throw new Error("Not used here");
    };
    AWSAppSyncRealTimeProvider.prototype.publish = function(_topics, _msg, _options) {
        return $f2899bc91e1f2d7a$var$__awaiter(this, void 0, void 0, function() {
            return $f2899bc91e1f2d7a$var$__generator(this, function(_a) {
                throw new Error("Operation not supported");
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype.subscribe = function(_topics, options) {
        var _this = this;
        var appSyncGraphqlEndpoint = options.appSyncGraphqlEndpoint;
        return new $gbejU(function(observer) {
            if (!appSyncGraphqlEndpoint) {
                observer.error({
                    errors: [
                        $f2899bc91e1f2d7a$var$__assign({}, new (0, $a4gcw.GraphQLError)("Subscribe only available for AWS AppSync endpoint"))
                    ]
                });
                observer.complete();
            } else {
                var subscriptionId_1 = (0, $toYCK.v4)();
                _this._startSubscriptionWithAWSAppSyncRealTime({
                    options: options,
                    observer: observer,
                    subscriptionId: subscriptionId_1
                });
                return function() {
                    return $f2899bc91e1f2d7a$var$__awaiter(_this, void 0, void 0, function() {
                        var subscriptionState, err_1;
                        return $f2899bc91e1f2d7a$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    _a.trys.push([
                                        0,
                                        2,
                                        3,
                                        4
                                    ]);
                                    // Waiting that subscription has been connected before trying to unsubscribe
                                    return [
                                        4 /*yield*/ ,
                                        this._waitForSubscriptionToBeConnected(subscriptionId_1)
                                    ];
                                case 1:
                                    // Waiting that subscription has been connected before trying to unsubscribe
                                    _a.sent();
                                    subscriptionState = (this.subscriptionObserverMap.get(subscriptionId_1) || {}).subscriptionState;
                                    if (!subscriptionState) // subscription already unsubscribed
                                    return [
                                        2 /*return*/ 
                                    ];
                                    if (subscriptionState === $f2899bc91e1f2d7a$var$SUBSCRIPTION_STATUS.CONNECTED) this._sendUnsubscriptionMessage(subscriptionId_1);
                                    else throw new Error("Subscription never connected");
                                    return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                case 2:
                                    err_1 = _a.sent();
                                    $f2899bc91e1f2d7a$var$logger.debug("Error while unsubscribing " + err_1);
                                    return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                case 3:
                                    this._removeSubscriptionObserver(subscriptionId_1);
                                    return [
                                        7 /*endfinally*/ 
                                    ];
                                case 4:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
            }
        });
    };
    AWSAppSyncRealTimeProvider.prototype._startSubscriptionWithAWSAppSyncRealTime = function(_a) {
        var options = _a.options, observer = _a.observer, subscriptionId = _a.subscriptionId;
        return $f2899bc91e1f2d7a$var$__awaiter(this, void 0, void 0, function() {
            var appSyncGraphqlEndpoint, authenticationType, query, variables, apiKey, region, _b, graphql_headers, subscriptionState, data, dataString, headerObj, _c, _d, subscriptionMessage, stringToAWSRealTime, err_2, _e, message, subscriptionFailedCallback_1, _f, subscriptionFailedCallback, subscriptionReadyCallback;
            var _g;
            var _this = this;
            return $f2899bc91e1f2d7a$var$__generator(this, function(_h) {
                switch(_h.label){
                    case 0:
                        appSyncGraphqlEndpoint = options.appSyncGraphqlEndpoint, authenticationType = options.authenticationType, query = options.query, variables = options.variables, apiKey = options.apiKey, region = options.region, _b = options.graphql_headers, graphql_headers = _b === void 0 ? function() {
                            return {};
                        } : _b;
                        subscriptionState = $f2899bc91e1f2d7a$var$SUBSCRIPTION_STATUS.PENDING;
                        data = {
                            query: query,
                            variables: variables
                        };
                        // Having a subscription id map will make it simple to forward messages received
                        this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            query: query,
                            variables: variables,
                            subscriptionState: subscriptionState,
                            startAckTimeoutId: null
                        });
                        dataString = JSON.stringify(data);
                        _c = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this._awsRealTimeHeaderBasedAuth({
                                apiKey: apiKey,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                authenticationType: authenticationType,
                                payload: dataString,
                                canonicalUri: "",
                                region: region
                            })
                        ];
                    case 1:
                        _d = [
                            $f2899bc91e1f2d7a$var$__assign.apply(void 0, _c.concat([
                                _h.sent()
                            ]))
                        ];
                        return [
                            4 /*yield*/ ,
                            graphql_headers()
                        ];
                    case 2:
                        headerObj = $f2899bc91e1f2d7a$var$__assign.apply(void 0, [
                            $f2899bc91e1f2d7a$var$__assign.apply(void 0, _d.concat([
                                _h.sent()
                            ])),
                            (_g = {}, _g[0, $2SWCi.USER_AGENT_HEADER] = (0, $2hWDt.Constants).userAgent, _g)
                        ]);
                        subscriptionMessage = {
                            id: subscriptionId,
                            payload: {
                                data: dataString,
                                extensions: {
                                    authorization: $f2899bc91e1f2d7a$var$__assign({}, headerObj)
                                }
                            },
                            type: $f2899bc91e1f2d7a$var$MESSAGE_TYPES.GQL_START
                        };
                        stringToAWSRealTime = JSON.stringify(subscriptionMessage);
                        _h.label = 3;
                    case 3:
                        _h.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            this._initializeWebSocketConnection({
                                apiKey: apiKey,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                authenticationType: authenticationType,
                                region: region
                            })
                        ];
                    case 4:
                        _h.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        err_2 = _h.sent();
                        $f2899bc91e1f2d7a$var$logger.debug({
                            err: err_2
                        });
                        _e = err_2.message, message = _e === void 0 ? "" : _e;
                        observer.error({
                            errors: [
                                $f2899bc91e1f2d7a$var$__assign({}, new (0, $a4gcw.GraphQLError)("Connection failed: " + message))
                            ]
                        });
                        observer.complete();
                        subscriptionFailedCallback_1 = (this.subscriptionObserverMap.get(subscriptionId) || {}).subscriptionFailedCallback;
                        // Notify concurrent unsubscription
                        if (typeof subscriptionFailedCallback_1 === "function") subscriptionFailedCallback_1();
                        return [
                            2 /*return*/ 
                        ];
                    case 6:
                        _f = this.subscriptionObserverMap.get(subscriptionId), subscriptionFailedCallback = _f.subscriptionFailedCallback, subscriptionReadyCallback = _f.subscriptionReadyCallback;
                        // This must be done before sending the message in order to be listening immediately
                        this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            subscriptionState: subscriptionState,
                            variables: variables,
                            query: query,
                            subscriptionReadyCallback: subscriptionReadyCallback,
                            subscriptionFailedCallback: subscriptionFailedCallback,
                            startAckTimeoutId: setTimeout(function() {
                                _this._timeoutStartSubscriptionAck.call(_this, subscriptionId);
                            }, $f2899bc91e1f2d7a$var$START_ACK_TIMEOUT)
                        });
                        this.awsRealTimeSocket.send(stringToAWSRealTime);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Waiting that subscription has been connected before trying to unsubscribe
    AWSAppSyncRealTimeProvider.prototype._waitForSubscriptionToBeConnected = function(subscriptionId) {
        return $f2899bc91e1f2d7a$var$__awaiter(this, void 0, void 0, function() {
            var subscriptionState;
            var _this = this;
            return $f2899bc91e1f2d7a$var$__generator(this, function(_a) {
                subscriptionState = this.subscriptionObserverMap.get(subscriptionId).subscriptionState;
                // This in case unsubscribe is invoked before sending start subscription message
                if (subscriptionState === $f2899bc91e1f2d7a$var$SUBSCRIPTION_STATUS.PENDING) return [
                    2 /*return*/ ,
                    new Promise(function(res, rej) {
                        var _a = _this.subscriptionObserverMap.get(subscriptionId), observer = _a.observer, subscriptionState = _a.subscriptionState, variables = _a.variables, query = _a.query;
                        _this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            subscriptionState: subscriptionState,
                            variables: variables,
                            query: query,
                            subscriptionReadyCallback: res,
                            subscriptionFailedCallback: rej
                        });
                    })
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._sendUnsubscriptionMessage = function(subscriptionId) {
        try {
            if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN && this.socketStatus === $f2899bc91e1f2d7a$var$SOCKET_STATUS.READY) {
                // Preparing unsubscribe message to stop receiving messages for that subscription
                var unsubscribeMessage = {
                    id: subscriptionId,
                    type: $f2899bc91e1f2d7a$var$MESSAGE_TYPES.GQL_STOP
                };
                var stringToAWSRealTime = JSON.stringify(unsubscribeMessage);
                this.awsRealTimeSocket.send(stringToAWSRealTime);
            }
        } catch (err) {
            // If GQL_STOP is not sent because of disconnection issue, then there is nothing the client can do
            $f2899bc91e1f2d7a$var$logger.debug({
                err: err
            });
        }
    };
    AWSAppSyncRealTimeProvider.prototype._removeSubscriptionObserver = function(subscriptionId) {
        this.subscriptionObserverMap.delete(subscriptionId);
        // Verifying 1000ms after removing subscription in case there are new subscription unmount/mount
        setTimeout(this._closeSocketIfRequired.bind(this), 1000);
    };
    AWSAppSyncRealTimeProvider.prototype._closeSocketIfRequired = function() {
        if (this.subscriptionObserverMap.size > 0) // Active subscriptions on the WebSocket
        return;
        if (!this.awsRealTimeSocket) {
            this.socketStatus = $f2899bc91e1f2d7a$var$SOCKET_STATUS.CLOSED;
            return;
        }
        if (this.awsRealTimeSocket.bufferedAmount > 0) // Still data on the WebSocket
        setTimeout(this._closeSocketIfRequired.bind(this), 1000);
        else {
            $f2899bc91e1f2d7a$var$logger.debug("closing WebSocket...");
            clearTimeout(this.keepAliveTimeoutId);
            var tempSocket = this.awsRealTimeSocket;
            // Cleaning callbacks to avoid race condition, socket still exists
            tempSocket.onclose = undefined;
            tempSocket.onerror = undefined;
            tempSocket.close(1000);
            this.awsRealTimeSocket = null;
            this.socketStatus = $f2899bc91e1f2d7a$var$SOCKET_STATUS.CLOSED;
        }
    };
    AWSAppSyncRealTimeProvider.prototype._handleIncomingSubscriptionMessage = function(message) {
        $f2899bc91e1f2d7a$var$logger.debug("subscription message from AWS AppSync RealTime: " + message.data);
        var _a = JSON.parse(message.data), _b = _a.id, id = _b === void 0 ? "" : _b, payload = _a.payload, type = _a.type;
        var _c = this.subscriptionObserverMap.get(id) || {}, _d = _c.observer, observer = _d === void 0 ? null : _d, _e = _c.query, query = _e === void 0 ? "" : _e, _f = _c.variables, variables = _f === void 0 ? {} : _f, startAckTimeoutId = _c.startAckTimeoutId, subscriptionReadyCallback = _c.subscriptionReadyCallback, subscriptionFailedCallback = _c.subscriptionFailedCallback;
        $f2899bc91e1f2d7a$var$logger.debug({
            id: id,
            observer: observer,
            query: query,
            variables: variables
        });
        if (type === $f2899bc91e1f2d7a$var$MESSAGE_TYPES.GQL_DATA && payload && payload.data) {
            if (observer) observer.next(payload);
            else $f2899bc91e1f2d7a$var$logger.debug("observer not found for id: " + id);
            return;
        }
        if (type === $f2899bc91e1f2d7a$var$MESSAGE_TYPES.GQL_START_ACK) {
            $f2899bc91e1f2d7a$var$logger.debug("subscription ready for " + JSON.stringify({
                query: query,
                variables: variables
            }));
            if (typeof subscriptionReadyCallback === "function") subscriptionReadyCallback();
            clearTimeout(startAckTimeoutId);
            $f2899bc91e1f2d7a$var$dispatchApiEvent("connected", {
                query: query,
                variables: variables
            }, "Connection established for subscription");
            var subscriptionState = $f2899bc91e1f2d7a$var$SUBSCRIPTION_STATUS.CONNECTED;
            this.subscriptionObserverMap.set(id, {
                observer: observer,
                query: query,
                variables: variables,
                startAckTimeoutId: null,
                subscriptionState: subscriptionState,
                subscriptionReadyCallback: subscriptionReadyCallback,
                subscriptionFailedCallback: subscriptionFailedCallback
            });
            // TODO: emit event on hub but it requires to store the id first
            return;
        }
        if (type === $f2899bc91e1f2d7a$var$MESSAGE_TYPES.GQL_CONNECTION_KEEP_ALIVE) {
            clearTimeout(this.keepAliveTimeoutId);
            this.keepAliveTimeoutId = setTimeout(this._errorDisconnect.bind(this, (0, $9fvEQ.CONTROL_MSG).TIMEOUT_DISCONNECT), this.keepAliveTimeout);
            return;
        }
        if (type === $f2899bc91e1f2d7a$var$MESSAGE_TYPES.GQL_ERROR) {
            var subscriptionState = $f2899bc91e1f2d7a$var$SUBSCRIPTION_STATUS.FAILED;
            this.subscriptionObserverMap.set(id, {
                observer: observer,
                query: query,
                variables: variables,
                startAckTimeoutId: startAckTimeoutId,
                subscriptionReadyCallback: subscriptionReadyCallback,
                subscriptionFailedCallback: subscriptionFailedCallback,
                subscriptionState: subscriptionState
            });
            observer.error({
                errors: [
                    $f2899bc91e1f2d7a$var$__assign({}, new (0, $a4gcw.GraphQLError)("Connection failed: " + JSON.stringify(payload)))
                ]
            });
            clearTimeout(startAckTimeoutId);
            observer.complete();
            if (typeof subscriptionFailedCallback === "function") subscriptionFailedCallback();
        }
    };
    AWSAppSyncRealTimeProvider.prototype._errorDisconnect = function(msg) {
        $f2899bc91e1f2d7a$var$logger.debug("Disconnect error: " + msg);
        this.subscriptionObserverMap.forEach(function(_a) {
            var observer = _a.observer;
            if (!observer.closed) observer.error({
                errors: [
                    $f2899bc91e1f2d7a$var$__assign({}, new (0, $a4gcw.GraphQLError)(msg))
                ]
            });
        });
        this.subscriptionObserverMap.clear();
        if (this.awsRealTimeSocket) this.awsRealTimeSocket.close();
        this.socketStatus = $f2899bc91e1f2d7a$var$SOCKET_STATUS.CLOSED;
    };
    AWSAppSyncRealTimeProvider.prototype._timeoutStartSubscriptionAck = function(subscriptionId) {
        var _a = this.subscriptionObserverMap.get(subscriptionId) || {}, observer = _a.observer, query = _a.query, variables = _a.variables;
        if (!observer) return;
        this.subscriptionObserverMap.set(subscriptionId, {
            observer: observer,
            query: query,
            variables: variables,
            subscriptionState: $f2899bc91e1f2d7a$var$SUBSCRIPTION_STATUS.FAILED
        });
        if (observer && !observer.closed) {
            observer.error({
                errors: [
                    $f2899bc91e1f2d7a$var$__assign({}, new (0, $a4gcw.GraphQLError)("Subscription timeout " + JSON.stringify({
                        query: query,
                        variables: variables
                    })))
                ]
            });
            // Cleanup will be automatically executed
            observer.complete();
        }
        $f2899bc91e1f2d7a$var$logger.debug("timeoutStartSubscription", JSON.stringify({
            query: query,
            variables: variables
        }));
    };
    AWSAppSyncRealTimeProvider.prototype._initializeWebSocketConnection = function(_a) {
        var _this = this;
        var appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, authenticationType = _a.authenticationType, apiKey = _a.apiKey, region = _a.region;
        if (this.socketStatus === $f2899bc91e1f2d7a$var$SOCKET_STATUS.READY) return;
        return new Promise(function(res, rej) {
            return $f2899bc91e1f2d7a$var$__awaiter(_this, void 0, void 0, function() {
                var discoverableEndpoint, payloadString, headerString, _a, _b, headerQs, payloadQs, awsRealTimeUrl, err_3;
                return $f2899bc91e1f2d7a$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.promiseArray.push({
                                res: res,
                                rej: rej
                            });
                            if (!(this.socketStatus === $f2899bc91e1f2d7a$var$SOCKET_STATUS.CLOSED)) return [
                                3 /*break*/ ,
                                5
                            ];
                            _c.label = 1;
                        case 1:
                            _c.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            this.socketStatus = $f2899bc91e1f2d7a$var$SOCKET_STATUS.CONNECTING;
                            discoverableEndpoint = appSyncGraphqlEndpoint.replace("https://", "wss://").replace("appsync-api", "appsync-realtime-api").replace("gogi-beta", "grt-beta");
                            payloadString = "{}";
                            _b = (_a = JSON).stringify;
                            return [
                                4 /*yield*/ ,
                                this._awsRealTimeHeaderBasedAuth({
                                    authenticationType: authenticationType,
                                    payload: payloadString,
                                    canonicalUri: "/connect",
                                    apiKey: apiKey,
                                    appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                    region: region
                                })
                            ];
                        case 2:
                            headerString = _b.apply(_a, [
                                _c.sent()
                            ]);
                            headerQs = (0, $5oOz5.Buffer).from(headerString).toString("base64");
                            payloadQs = (0, $5oOz5.Buffer).from(payloadString).toString("base64");
                            awsRealTimeUrl = discoverableEndpoint + "?header=" + headerQs + "&payload=" + payloadQs;
                            return [
                                4 /*yield*/ ,
                                this._initializeRetryableHandshake({
                                    awsRealTimeUrl: awsRealTimeUrl
                                })
                            ];
                        case 3:
                            _c.sent();
                            this.promiseArray.forEach(function(_a) {
                                var res = _a.res;
                                $f2899bc91e1f2d7a$var$logger.debug("Notifying connection successful");
                                res();
                            });
                            this.socketStatus = $f2899bc91e1f2d7a$var$SOCKET_STATUS.READY;
                            this.promiseArray = [];
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            err_3 = _c.sent();
                            this.promiseArray.forEach(function(_a) {
                                var rej = _a.rej;
                                return rej(err_3);
                            });
                            this.promiseArray = [];
                            if (this.awsRealTimeSocket && this.awsRealTimeSocket.readyState === WebSocket.OPEN) this.awsRealTimeSocket.close(3001);
                            this.awsRealTimeSocket = null;
                            this.socketStatus = $f2899bc91e1f2d7a$var$SOCKET_STATUS.CLOSED;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._initializeRetryableHandshake = function(_a) {
        var awsRealTimeUrl = _a.awsRealTimeUrl;
        return $f2899bc91e1f2d7a$var$__awaiter(this, void 0, void 0, function() {
            return $f2899bc91e1f2d7a$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $f2899bc91e1f2d7a$var$logger.debug("Initializaling retryable Handshake");
                        return [
                            4 /*yield*/ ,
                            (0, $9opJY.jitteredExponentialRetry)(this._initializeHandshake.bind(this), [
                                {
                                    awsRealTimeUrl: awsRealTimeUrl
                                }
                            ], $f2899bc91e1f2d7a$var$MAX_DELAY_MS)
                        ];
                    case 1:
                        _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._initializeHandshake = function(_a) {
        var awsRealTimeUrl = _a.awsRealTimeUrl;
        return $f2899bc91e1f2d7a$var$__awaiter(this, void 0, void 0, function() {
            var err_4, errorType, errorCode;
            var _this = this;
            return $f2899bc91e1f2d7a$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        $f2899bc91e1f2d7a$var$logger.debug("Initializing handshake " + awsRealTimeUrl);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            function() {
                                return new Promise(function(res, rej) {
                                    var newSocket = new WebSocket(awsRealTimeUrl, "graphql-ws");
                                    newSocket.onerror = function() {
                                        $f2899bc91e1f2d7a$var$logger.debug("WebSocket connection error");
                                    };
                                    newSocket.onclose = function() {
                                        rej(new Error("Connection handshake error"));
                                    };
                                    newSocket.onopen = function() {
                                        _this.awsRealTimeSocket = newSocket;
                                        return res();
                                    };
                                });
                            }()
                        ];
                    case 2:
                        _b.sent();
                        // Step 2: wait for ack from AWS AppSyncReaTime after sending init
                        return [
                            4 /*yield*/ ,
                            function() {
                                return new Promise(function(res, rej) {
                                    var ackOk = false;
                                    _this.awsRealTimeSocket.onerror = function(error) {
                                        $f2899bc91e1f2d7a$var$logger.debug("WebSocket error " + JSON.stringify(error));
                                    };
                                    _this.awsRealTimeSocket.onclose = function(event) {
                                        $f2899bc91e1f2d7a$var$logger.debug("WebSocket closed " + event.reason);
                                        rej(new Error(JSON.stringify(event)));
                                    };
                                    _this.awsRealTimeSocket.onmessage = function(message) {
                                        $f2899bc91e1f2d7a$var$logger.debug("subscription message from AWS AppSyncRealTime: " + message.data + " ");
                                        var data = JSON.parse(message.data);
                                        var type = data.type, _a = data.payload, _b = (_a === void 0 ? {} : _a).connectionTimeoutMs, connectionTimeoutMs = _b === void 0 ? $f2899bc91e1f2d7a$var$DEFAULT_KEEP_ALIVE_TIMEOUT : _b;
                                        if (type === $f2899bc91e1f2d7a$var$MESSAGE_TYPES.GQL_CONNECTION_ACK) {
                                            ackOk = true;
                                            _this.keepAliveTimeout = connectionTimeoutMs;
                                            _this.awsRealTimeSocket.onmessage = _this._handleIncomingSubscriptionMessage.bind(_this);
                                            _this.awsRealTimeSocket.onerror = function(err) {
                                                $f2899bc91e1f2d7a$var$logger.debug(err);
                                                _this._errorDisconnect((0, $9fvEQ.CONTROL_MSG).CONNECTION_CLOSED);
                                            };
                                            res("Cool, connected to AWS AppSyncRealTime");
                                            return;
                                        }
                                        if (type === $f2899bc91e1f2d7a$var$MESSAGE_TYPES.GQL_CONNECTION_ERROR) {
                                            var _c = data.payload, _d = (_c === void 0 ? {} : _c).errors, _e = (_d === void 0 ? [] : _d)[0], _f = _e === void 0 ? {} : _e, _g = _f.errorType, errorType = _g === void 0 ? "" : _g, _h = _f.errorCode, errorCode = _h === void 0 ? 0 : _h;
                                            rej({
                                                errorType: errorType,
                                                errorCode: errorCode
                                            });
                                        }
                                    };
                                    var gqlInit = {
                                        type: $f2899bc91e1f2d7a$var$MESSAGE_TYPES.GQL_CONNECTION_INIT
                                    };
                                    _this.awsRealTimeSocket.send(JSON.stringify(gqlInit));
                                    function checkAckOk() {
                                        if (!ackOk) rej(new Error("Connection timeout: ack from AWSRealTime was not received on " + $f2899bc91e1f2d7a$var$CONNECTION_INIT_TIMEOUT + " ms"));
                                    }
                                    setTimeout(checkAckOk.bind(_this), $f2899bc91e1f2d7a$var$CONNECTION_INIT_TIMEOUT);
                                });
                            }()
                        ];
                    case 3:
                        // Step 2: wait for ack from AWS AppSyncReaTime after sending init
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        err_4 = _b.sent();
                        errorType = err_4.errorType, errorCode = err_4.errorCode;
                        if ($f2899bc91e1f2d7a$var$NON_RETRYABLE_CODES.includes(errorCode)) throw new (0, $9opJY.NonRetryableError)(errorType);
                        else if (errorType) throw new Error(errorType);
                        else throw err_4;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeHeaderBasedAuth = function(_a) {
        var authenticationType = _a.authenticationType, payload = _a.payload, canonicalUri = _a.canonicalUri, appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, apiKey = _a.apiKey, region = _a.region;
        return $f2899bc91e1f2d7a$var$__awaiter(this, void 0, void 0, function() {
            var headerHandler, handler, host, result;
            return $f2899bc91e1f2d7a$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        headerHandler = {
                            API_KEY: this._awsRealTimeApiKeyHeader.bind(this),
                            AWS_IAM: this._awsRealTimeIAMHeader.bind(this),
                            OPENID_CONNECT: this._awsRealTimeOPENIDHeader.bind(this),
                            AMAZON_COGNITO_USER_POOLS: this._awsRealTimeCUPHeader.bind(this)
                        };
                        handler = headerHandler[authenticationType];
                        if (typeof handler !== "function") {
                            $f2899bc91e1f2d7a$var$logger.debug("Authentication type " + authenticationType + " not supported");
                            return [
                                2 /*return*/ ,
                                ""
                            ];
                        }
                        host = $i3eDV.parse(appSyncGraphqlEndpoint).host;
                        return [
                            4 /*yield*/ ,
                            handler({
                                payload: payload,
                                canonicalUri: canonicalUri,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                apiKey: apiKey,
                                region: region,
                                host: host
                            })
                        ];
                    case 1:
                        result = _b.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeCUPHeader = function(_a) {
        var host = _a.host;
        return $f2899bc91e1f2d7a$var$__awaiter(this, void 0, void 0, function() {
            var session;
            return $f2899bc91e1f2d7a$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $hbz3E.default).currentSession()
                        ];
                    case 1:
                        session = _b.sent();
                        return [
                            2 /*return*/ ,
                            {
                                Authorization: session.getAccessToken().getJwtToken(),
                                host: host
                            }
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeOPENIDHeader = function(_a) {
        var host = _a.host;
        return $f2899bc91e1f2d7a$var$__awaiter(this, void 0, void 0, function() {
            var federatedInfo;
            return $f2899bc91e1f2d7a$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $9x214.default).getItem("federatedInfo")
                        ];
                    case 1:
                        federatedInfo = _b.sent();
                        if (!federatedInfo || !federatedInfo.token) throw new Error("No federated jwt");
                        return [
                            2 /*return*/ ,
                            {
                                Authorization: federatedInfo.token,
                                host: host
                            }
                        ];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeApiKeyHeader = function(_a) {
        var apiKey = _a.apiKey, host = _a.host;
        return $f2899bc91e1f2d7a$var$__awaiter(this, void 0, void 0, function() {
            var dt, dtStr;
            return $f2899bc91e1f2d7a$var$__generator(this, function(_b) {
                dt = new Date();
                dtStr = dt.toISOString().replace(/[:\-]|\.\d{3}/g, "");
                return [
                    2 /*return*/ ,
                    {
                        host: host,
                        "x-amz-date": dtStr,
                        "x-api-key": apiKey
                    }
                ];
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeIAMHeader = function(_a) {
        var payload = _a.payload, canonicalUri = _a.canonicalUri, appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, region = _a.region;
        return $f2899bc91e1f2d7a$var$__awaiter(this, void 0, void 0, function() {
            var endpointInfo, credentialsOK, creds, request, signed_params;
            return $f2899bc91e1f2d7a$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        endpointInfo = {
                            region: region,
                            service: "appsync"
                        };
                        return [
                            4 /*yield*/ ,
                            this._ensureCredentials()
                        ];
                    case 1:
                        credentialsOK = _b.sent();
                        if (!credentialsOK) throw new Error("No credentials");
                        return [
                            4 /*yield*/ ,
                            (0, $aCVDw.default).get().then(function(credentials) {
                                return {
                                    secret_key: credentials.secretAccessKey,
                                    access_key: credentials.accessKeyId,
                                    session_token: credentials.sessionToken
                                };
                            })
                        ];
                    case 2:
                        creds = _b.sent();
                        request = {
                            url: "" + appSyncGraphqlEndpoint + canonicalUri,
                            data: payload,
                            method: "POST",
                            headers: $f2899bc91e1f2d7a$var$__assign({}, $f2899bc91e1f2d7a$var$AWS_APPSYNC_REALTIME_HEADERS)
                        };
                        signed_params = (0, $kP2rz.default).sign(request, creds, endpointInfo);
                        return [
                            2 /*return*/ ,
                            signed_params.headers
                        ];
                }
            });
        });
    };
    /**
     * @private
     */ AWSAppSyncRealTimeProvider.prototype._ensureCredentials = function() {
        return (0, $aCVDw.default).get().then(function(credentials) {
            if (!credentials) return false;
            var cred = (0, $aCVDw.default).shear(credentials);
            $f2899bc91e1f2d7a$var$logger.debug("set credentials for AWSAppSyncRealTimeProvider", cred);
            return true;
        }).catch(function(err) {
            $f2899bc91e1f2d7a$var$logger.warn("ensure credentials error", err);
            return false;
        });
    };
    return AWSAppSyncRealTimeProvider;
}((0, $a6BNt.AbstractPubSubProvider));

});
parcelRequire.register("a4gcw", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", function () { return $c47ca8e9e831fccb$export$92d6ed0888e7cb7f; });
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ 
var $cFTZ8 = parcelRequire("cFTZ8");

var $8pJUw = parcelRequire("8pJUw");
function $c47ca8e9e831fccb$export$92d6ed0888e7cb7f(message, nodes, source, positions, path, originalError, extensions) {
    // Compute list of blame nodes.
    var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [
        nodes
    ] : undefined; // Compute locations in the source for the given nodes/positions.
    var _source = source;
    if (!_source && _nodes) {
        var node = _nodes[0];
        _source = node && node.loc && node.loc.source;
    }
    var _positions = positions;
    if (!_positions && _nodes) _positions = _nodes.reduce(function(list, node) {
        if (node.loc) list.push(node.loc.start);
        return list;
    }, []);
    if (_positions && _positions.length === 0) _positions = undefined;
    var _locations;
    if (positions && source) _locations = positions.map(function(pos) {
        return (0, $8pJUw.getLocation)(source, pos);
    });
    else if (_nodes) _locations = _nodes.reduce(function(list, node) {
        if (node.loc) list.push((0, $8pJUw.getLocation)(node.loc.source, node.loc.start));
        return list;
    }, []);
    var _extensions = extensions || originalError && originalError.extensions;
    Object.defineProperties(this, {
        message: {
            value: message,
            // By being enumerable, JSON.stringify will include `message` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: true,
            writable: true
        },
        locations: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _locations || undefined,
            // By being enumerable, JSON.stringify will include `locations` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(_locations)
        },
        path: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: path || undefined,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(path)
        },
        nodes: {
            value: _nodes || undefined
        },
        source: {
            value: _source || undefined
        },
        positions: {
            value: _positions || undefined
        },
        originalError: {
            value: originalError
        },
        extensions: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _extensions || undefined,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(_extensions)
        }
    }); // Include (non-enumerable) stack trace.
    if (originalError && originalError.stack) Object.defineProperty(this, "stack", {
        value: originalError.stack,
        writable: true,
        configurable: true
    });
    else if (Error.captureStackTrace) Error.captureStackTrace(this, $c47ca8e9e831fccb$export$92d6ed0888e7cb7f);
    else Object.defineProperty(this, "stack", {
        value: Error().stack,
        writable: true,
        configurable: true
    });
}
$c47ca8e9e831fccb$export$92d6ed0888e7cb7f.prototype = Object.create(Error.prototype, {
    constructor: {
        value: $c47ca8e9e831fccb$export$92d6ed0888e7cb7f
    },
    name: {
        value: "GraphQLError"
    },
    toString: {
        value: function toString() {
            return (0, $cFTZ8.printError)(this);
        }
    }
});

});
parcelRequire.register("cFTZ8", function(module, exports) {

$parcel$export(module.exports, "printError", function () { return $d621aae6acaba7a7$export$55ee1551a3f962e6; });
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ 
var $8pJUw = parcelRequire("8pJUw");
function $d621aae6acaba7a7$export$55ee1551a3f962e6(error) {
    var printedLocations = [];
    if (error.nodes) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = error.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var node = _step.value;
                if (node.loc) printedLocations.push($d621aae6acaba7a7$var$highlightSourceAtLocation(node.loc.source, (0, $8pJUw.getLocation)(node.loc.source, node.loc.start)));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
    } else if (error.source && error.locations) {
        var source = error.source;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;
        try {
            for(var _iterator2 = error.locations[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var location = _step2.value;
                printedLocations.push($d621aae6acaba7a7$var$highlightSourceAtLocation(source, location));
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) _iterator2.return();
            } finally{
                if (_didIteratorError2) throw _iteratorError2;
            }
        }
    }
    return printedLocations.length === 0 ? error.message : [
        error.message
    ].concat(printedLocations).join("\n\n") + "\n";
}
/**
 * Render a helpful description of the location of the error in the GraphQL
 * Source document.
 */ function $d621aae6acaba7a7$var$highlightSourceAtLocation(source, location) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $d621aae6acaba7a7$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = location.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = location.line + lineOffset;
    var columnOffset = location.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = location.column + columnOffset;
    var lines = body.split(/\r\n|[\n\r]/g);
    return "".concat(source.name, " (").concat(lineNum, ":").concat(columnNum, ")\n") + $d621aae6acaba7a7$var$printPrefixedLines([
        [
            "".concat(lineNum - 1, ": "),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum, ": "),
            lines[lineIndex]
        ],
        [
            "",
            $d621aae6acaba7a7$var$whitespace(columnNum - 1) + "^"
        ],
        [
            "".concat(lineNum + 1, ": "),
            lines[lineIndex + 1]
        ]
    ]);
}
function $d621aae6acaba7a7$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = 0;
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;
    try {
        for(var _iterator3 = existingLines[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
            var _ref4 = _step3.value;
            var prefix = _ref4[0];
            padLen = Math.max(padLen, prefix.length);
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) _iterator3.return();
        } finally{
            if (_didIteratorError3) throw _iteratorError3;
        }
    }
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $d621aae6acaba7a7$var$lpad(padLen, prefix) + line;
    }).join("\n");
}
function $d621aae6acaba7a7$var$whitespace(len) {
    return Array(len + 1).join(" ");
}
function $d621aae6acaba7a7$var$lpad(len, str) {
    return $d621aae6acaba7a7$var$whitespace(len - str.length) + str;
}

});
parcelRequire.register("8pJUw", function(module, exports) {

$parcel$export(module.exports, "getLocation", function () { return $878df6271107a8e5$export$e7fd20fad3cf4b5f; });
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */ /**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $878df6271107a8e5$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});




parcelRequire.register("8ii8v", function(module, exports) {

var $6XBdA = parcelRequire("6XBdA");
parcelRequire("2hWDt");
var $aCVDw = parcelRequire("aCVDw");
var $kP2rz = parcelRequire("kP2rz");
var $609e12aa5922a1a6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $609e12aa5922a1a6$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $609e12aa5922a1a6$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $609e12aa5922a1a6$var$SERVICE_NAME = "iotdevicegateway";
var $609e12aa5922a1a6$export$5c9ec3d843e2180d = /** @class */ function(_super) {
    $609e12aa5922a1a6$var$__extends(AWSIoTProvider, _super);
    function AWSIoTProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AWSIoTProvider.prototype, "region", {
        get: function() {
            return this.options.aws_pubsub_region;
        },
        enumerable: true,
        configurable: true
    });
    AWSIoTProvider.prototype.getProviderName = function() {
        return "AWSIoTProvider";
    };
    Object.defineProperty(AWSIoTProvider.prototype, "endpoint", {
        get: function() {
            var _this = this;
            return function() {
                return $609e12aa5922a1a6$var$__awaiter(_this, void 0, void 0, function() {
                    var endpoint, serviceInfo, _a, access_key, secret_key, session_token, result;
                    return $609e12aa5922a1a6$var$__generator(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                endpoint = this.options.aws_pubsub_endpoint;
                                serviceInfo = {
                                    service: $609e12aa5922a1a6$var$SERVICE_NAME,
                                    region: this.region
                                };
                                return [
                                    4 /*yield*/ ,
                                    (0, $aCVDw.default).get()
                                ];
                            case 1:
                                _a = _b.sent(), access_key = _a.accessKeyId, secret_key = _a.secretAccessKey, session_token = _a.sessionToken;
                                result = (0, $kP2rz.default).signUrl(endpoint, {
                                    access_key: access_key,
                                    secret_key: secret_key,
                                    session_token: session_token
                                }, serviceInfo);
                                return [
                                    2 /*return*/ ,
                                    result
                                ];
                        }
                    });
                });
            }();
        },
        enumerable: true,
        configurable: true
    });
    return AWSIoTProvider;
}((0, $6XBdA.MqttOverWSProvider));

});




parcelRequire.register("bGVVj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88308c547981e0df$export$2e2bcd8739ae039; });

var $gbejU = parcelRequire("gbejU");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $1hyL4 = parcelRequire("1hyL4");
var $88308c547981e0df$var$__assign = undefined && undefined.__assign || function() {
    $88308c547981e0df$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $88308c547981e0df$var$__assign.apply(this, arguments);
};
var $88308c547981e0df$var$logger = new (0, $gBqCF.ConsoleLogger)("DataStore");
var $88308c547981e0df$var$RECONNECTING_IN = 5000; // 5s this may be configurable in the future
var $88308c547981e0df$var$DataStoreConnectivity = /** @class */ function() {
    function DataStoreConnectivity() {
        this.connectionStatus = {
            online: false
        };
    }
    DataStoreConnectivity.prototype.status = function() {
        var _this = this;
        if (this.observer) throw new Error("Subscriber already exists");
        return new $gbejU(function(observer) {
            _this.observer = observer;
            // Will be used to forward socket connection changes, enhancing Reachability
            var subs = new (0, $1hyL4.default)().networkMonitor().subscribe(function(_a) {
                var online = _a.online;
                _this.connectionStatus.online = online;
                var observerResult = $88308c547981e0df$var$__assign({}, _this.connectionStatus); // copyOf status
                observer.next(observerResult);
            });
            return function() {
                subs.unsubscribe();
            };
        });
    };
    DataStoreConnectivity.prototype.socketDisconnected = function() {
        var _this = this;
        if (this.observer && typeof this.observer.next === "function") {
            this.observer.next({
                online: false
            }); // Notify network issue from the socket
            setTimeout(function() {
                var observerResult = $88308c547981e0df$var$__assign({}, _this.connectionStatus); // copyOf status
                _this.observer.next(observerResult);
            }, $88308c547981e0df$var$RECONNECTING_IN); // giving time for socket cleanup and network status stabilization
        }
    };
    return DataStoreConnectivity;
}();
var $88308c547981e0df$export$2e2bcd8739ae039 = $88308c547981e0df$var$DataStoreConnectivity;

});

parcelRequire.register("UtQ2R", function(module, exports) {

$parcel$export(module.exports, "ModelMerger", function () { return $0a9c605ead0e0f3d$export$6b8e57c4deb57ced; });
var $0a9c605ead0e0f3d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0a9c605ead0e0f3d$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $0a9c605ead0e0f3d$export$6b8e57c4deb57ced = /** @class */ function() {
    function ModelMerger(outbox, ownSymbol) {
        this.outbox = outbox;
        this.ownSymbol = ownSymbol;
    }
    ModelMerger.prototype.merge = function(exclusiveStorage, model) {
        return $0a9c605ead0e0f3d$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $0a9c605ead0e0f3d$var$__generator(this, function(_a) {
                exclusiveStorage.runExclusive(function(storage) {
                    return $0a9c605ead0e0f3d$var$__awaiter(_this, void 0, void 0, function() {
                        var mutationsForModel, isDelete;
                        return $0a9c605ead0e0f3d$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    return [
                                        4 /*yield*/ ,
                                        this.outbox.getForModel(storage, model)
                                    ];
                                case 1:
                                    mutationsForModel = _a.sent();
                                    isDelete = model._deleted;
                                    if (!(mutationsForModel.length === 0)) return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                    if (!isDelete) return [
                                        3 /*break*/ ,
                                        3
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        storage.delete(model, undefined, this.ownSymbol)
                                    ];
                                case 2:
                                    _a.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 3:
                                    return [
                                        4 /*yield*/ ,
                                        storage.save(model, undefined, this.ownSymbol)
                                    ];
                                case 4:
                                    _a.sent();
                                    _a.label = 5;
                                case 5:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                });
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return ModelMerger;
}();

});

parcelRequire.register("izyzt", function(module, exports) {

$parcel$export(module.exports, "MutationEventOutbox", function () { return $d8565002be595380$export$c76cfdf14a7275f7; });

var $55dhS = parcelRequire("55dhS");

var $6BLoD = parcelRequire("6BLoD");

var $6uSfH = parcelRequire("6uSfH");

var $bCU9m = parcelRequire("bCU9m");
var $d8565002be595380$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d8565002be595380$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
// TODO: Persist deleted ids
var $d8565002be595380$export$c76cfdf14a7275f7 = /** @class */ function() {
    function MutationEventOutbox(schema, namespaceResolver, MutationEvent, ownSymbol) {
        this.schema = schema;
        this.namespaceResolver = namespaceResolver;
        this.MutationEvent = MutationEvent;
        this.ownSymbol = ownSymbol;
    }
    MutationEventOutbox.prototype.enqueue = function(storage, mutationEvent) {
        return $d8565002be595380$var$__awaiter(this, void 0, void 0, function() {
            var mutationEventModelDefinition, predicate, first, incomingMutationType, incomingConditionJSON, incomingCondition;
            var _this = this;
            return $d8565002be595380$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        mutationEventModelDefinition = this.schema.namespaces[0, $6uSfH.SYNC].models["MutationEvent"];
                        predicate = (0, $55dhS.ModelPredicateCreator).createFromExisting(mutationEventModelDefinition, function(c) {
                            return c.modelId("eq", mutationEvent.modelId).id("ne", _this.inProgressMutationEventId);
                        });
                        return [
                            4 /*yield*/ ,
                            storage.query(this.MutationEvent, predicate)
                        ];
                    case 1:
                        first = _a.sent()[0];
                        if (!(first === undefined)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            storage.save(mutationEvent, undefined, this.ownSymbol)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 3:
                        incomingMutationType = mutationEvent.operation;
                        if (!(first.operation === (0, $bCU9m.TransformerMutationType).CREATE)) return [
                            3 /*break*/ ,
                            8
                        ];
                        if (!(incomingMutationType === (0, $bCU9m.TransformerMutationType).DELETE)) return [
                            3 /*break*/ ,
                            5
                        ];
                        // delete all for model
                        return [
                            4 /*yield*/ ,
                            storage.delete(this.MutationEvent, predicate)
                        ];
                    case 4:
                        // delete all for model
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 5:
                        // first gets updated with incoming's data, condition intentionally skiped
                        return [
                            4 /*yield*/ ,
                            storage.save(this.MutationEvent.copyOf(first, function(draft) {
                                draft.data = mutationEvent.data;
                            }), undefined, this.ownSymbol)
                        ];
                    case 6:
                        // first gets updated with incoming's data, condition intentionally skiped
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 8:
                        incomingConditionJSON = mutationEvent.condition;
                        incomingCondition = JSON.parse(incomingConditionJSON);
                        if (!(Object.keys(incomingCondition).length === 0)) return [
                            3 /*break*/ ,
                            10
                        ];
                        // delete all for model
                        return [
                            4 /*yield*/ ,
                            storage.delete(this.MutationEvent, predicate)
                        ];
                    case 9:
                        // delete all for model
                        _a.sent();
                        _a.label = 10;
                    case 10:
                        // Enqueue new one
                        return [
                            4 /*yield*/ ,
                            storage.save(mutationEvent, undefined, this.ownSymbol)
                        ];
                    case 11:
                        // Enqueue new one
                        _a.sent();
                        _a.label = 12;
                    case 12:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MutationEventOutbox.prototype.dequeue = function(storage) {
        return $d8565002be595380$var$__awaiter(this, void 0, void 0, function() {
            var head;
            return $d8565002be595380$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.peek(storage)
                        ];
                    case 1:
                        head = _a.sent();
                        return [
                            4 /*yield*/ ,
                            storage.delete(head)
                        ];
                    case 2:
                        _a.sent();
                        this.inProgressMutationEventId = undefined;
                        return [
                            2 /*return*/ ,
                            head
                        ];
                }
            });
        });
    };
    /**
     * Doing a peek() implies that the mutation goes "inProgress"
     *
     * @param storage
     */ MutationEventOutbox.prototype.peek = function(storage) {
        return $d8565002be595380$var$__awaiter(this, void 0, void 0, function() {
            var head;
            return $d8565002be595380$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            storage.queryOne(this.MutationEvent, (0, $6BLoD.QueryOne).FIRST)
                        ];
                    case 1:
                        head = _a.sent();
                        this.inProgressMutationEventId = head ? head.id : undefined;
                        return [
                            2 /*return*/ ,
                            head
                        ];
                }
            });
        });
    };
    MutationEventOutbox.prototype.getForModel = function(storage, model) {
        return $d8565002be595380$var$__awaiter(this, void 0, void 0, function() {
            var mutationEventModelDefinition, mutationEvents;
            return $d8565002be595380$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        mutationEventModelDefinition = this.schema.namespaces[0, $6uSfH.SYNC].models.MutationEvent;
                        return [
                            4 /*yield*/ ,
                            storage.query(this.MutationEvent, (0, $55dhS.ModelPredicateCreator).createFromExisting(mutationEventModelDefinition, function(c) {
                                return c.modelId("eq", model.id);
                            }))
                        ];
                    case 1:
                        mutationEvents = _a.sent();
                        return [
                            2 /*return*/ ,
                            mutationEvents
                        ];
                }
            });
        });
    };
    return MutationEventOutbox;
}();

});
parcelRequire.register("bCU9m", function(module, exports) {

$parcel$export(module.exports, "TransformerMutationType", function () { return $876ecc8a1e3e0bfa$export$9bcccf0e728b2aab; });
$parcel$export(module.exports, "getAuthorizationRules", function () { return $876ecc8a1e3e0bfa$export$bdfaac1f5479095d; });
$parcel$export(module.exports, "buildSubscriptionGraphQLOperation", function () { return $876ecc8a1e3e0bfa$export$30b7ec2b779788cb; });
$parcel$export(module.exports, "buildGraphQLOperation", function () { return $876ecc8a1e3e0bfa$export$2f950813a5fb99c9; });
$parcel$export(module.exports, "createMutationInstanceFromModelOperation", function () { return $876ecc8a1e3e0bfa$export$236bff8c0ac4a9e6; });
$parcel$export(module.exports, "predicateToGraphQLCondition", function () { return $876ecc8a1e3e0bfa$export$89e56ddbfa1b1c0f; });

var $6BLoD = parcelRequire("6BLoD");

var $6uSfH = parcelRequire("6uSfH");
var $876ecc8a1e3e0bfa$var$__assign = undefined && undefined.__assign || function() {
    $876ecc8a1e3e0bfa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $876ecc8a1e3e0bfa$var$__assign.apply(this, arguments);
};
var $876ecc8a1e3e0bfa$var$GraphQLOperationType;
(function(GraphQLOperationType) {
    GraphQLOperationType["LIST"] = "query";
    GraphQLOperationType["CREATE"] = "mutation";
    GraphQLOperationType["UPDATE"] = "mutation";
    GraphQLOperationType["DELETE"] = "mutation";
    GraphQLOperationType["GET"] = "query";
})($876ecc8a1e3e0bfa$var$GraphQLOperationType || ($876ecc8a1e3e0bfa$var$GraphQLOperationType = {}));
var $876ecc8a1e3e0bfa$export$9bcccf0e728b2aab;
(function(TransformerMutationType) {
    TransformerMutationType["CREATE"] = "Create";
    TransformerMutationType["UPDATE"] = "Update";
    TransformerMutationType["DELETE"] = "Delete";
    TransformerMutationType["GET"] = "Get";
})($876ecc8a1e3e0bfa$export$9bcccf0e728b2aab || ($876ecc8a1e3e0bfa$export$9bcccf0e728b2aab = {}));
var $876ecc8a1e3e0bfa$var$dummyMetadata = {
    _version: undefined,
    _lastChangedAt: undefined,
    _deleted: undefined
};
var $876ecc8a1e3e0bfa$var$metadataFields = Object.keys($876ecc8a1e3e0bfa$var$dummyMetadata);
function $876ecc8a1e3e0bfa$export$d1778ef88634346c() {
    return $876ecc8a1e3e0bfa$var$metadataFields;
}
function $876ecc8a1e3e0bfa$var$generateSelectionSet(namespace, modelDefinition) {
    var scalarFields = $876ecc8a1e3e0bfa$var$getScalarFields(modelDefinition);
    var nonModelFields = $876ecc8a1e3e0bfa$var$getNonModelFields(namespace, modelDefinition);
    var scalarAndMetadataFields = Object.values(scalarFields).map(function(_a) {
        var name = _a.name;
        return name;
    }).concat(nonModelFields);
    if ((0, $6BLoD.isSchemaModel)(modelDefinition)) scalarAndMetadataFields = scalarAndMetadataFields.concat($876ecc8a1e3e0bfa$export$d1778ef88634346c()).concat($876ecc8a1e3e0bfa$var$getConnectionFields(modelDefinition));
    var result = scalarAndMetadataFields.join("\n");
    return result;
}
function $876ecc8a1e3e0bfa$var$getScalarFields(modelDefinition) {
    var fields = modelDefinition.fields;
    var result = Object.values(fields).filter(function(field) {
        if ((0, $6BLoD.isGraphQLScalarType)(field.type) || (0, $6BLoD.isEnumFieldType)(field.type)) return true;
        return false;
    }).reduce(function(acc, field) {
        acc[field.name] = field;
        return acc;
    }, {});
    return result;
}
function $876ecc8a1e3e0bfa$var$getConnectionFields(modelDefinition) {
    var result = [];
    Object.values(modelDefinition.fields).filter(function(_a) {
        var association = _a.association;
        return association && Object.keys(association).length;
    }).forEach(function(_a) {
        var name = _a.name, association = _a.association;
        var connectionType = association.connectionType;
        switch(connectionType){
            case "HAS_ONE":
            case "HAS_MANY":
                break;
            case "BELONGS_TO":
                if ((0, $6BLoD.isTargetNameAssociation)(association)) result.push(name + " { id _deleted }");
                break;
            default:
                (0, $6uSfH.exhaustiveCheck)(connectionType);
        }
    });
    return result;
}
function $876ecc8a1e3e0bfa$var$getNonModelFields(namespace, modelDefinition) {
    var result = [];
    Object.values(modelDefinition.fields).forEach(function(_a) {
        var name = _a.name, type = _a.type;
        if ((0, $6BLoD.isNonModelFieldType)(type)) {
            var typeDefinition = namespace.nonModels[type.nonModel];
            var scalarFields = Object.values($876ecc8a1e3e0bfa$var$getScalarFields(typeDefinition)).map(function(_a) {
                var name = _a.name;
                return name;
            });
            var nested_1 = [];
            Object.values(typeDefinition.fields).forEach(function(field) {
                var type = field.type, name = field.name;
                if ((0, $6BLoD.isNonModelFieldType)(type)) {
                    var typeDefinition_1 = namespace.nonModels[type.nonModel];
                    nested_1.push(name + " { " + $876ecc8a1e3e0bfa$var$generateSelectionSet(namespace, typeDefinition_1) + " }");
                }
            });
            result.push(name + " { " + scalarFields.join(" ") + " " + nested_1.join(" ") + " }");
        }
    });
    return result;
}
function $876ecc8a1e3e0bfa$export$bdfaac1f5479095d(modelDefinition, transformerOpType) {
    // Searching for owner authorization on attributes
    var authConfig = [].concat(modelDefinition.attributes).find(function(attr) {
        return attr && attr.type === "auth";
    });
    var _a = (authConfig || {}).properties, _b = (_a === void 0 ? {} : _a).rules, rules = _b === void 0 ? [] : _b;
    var resultRules = [];
    // Multiple rules can be declared for allow: owner
    rules.forEach(function(rule) {
        // setting defaults for backwards compatibility with old cli
        var _a = rule.identityClaim, identityClaim = _a === void 0 ? "cognito:username" : _a, _b = rule.ownerField, ownerField = _b === void 0 ? "owner" : _b, _c = rule.operations, operations = _c === void 0 ? [
            "create",
            "update",
            "delete"
        ] : _c, _d = rule.provider, provider = _d === void 0 ? "userPools" : _d, _e = rule.groupClaim, groupClaim = _e === void 0 ? "cognito:groups" : _e, _f = rule.allow, authStrategy = _f === void 0 ? "iam" : _f, _g = rule.groups, groups = _g === void 0 ? [] : _g;
        var isOperationAuthorized = operations.find(function(operation) {
            return operation.toLowerCase() === transformerOpType.toLowerCase();
        });
        if (isOperationAuthorized) {
            var rule_1 = {
                identityClaim: identityClaim,
                ownerField: ownerField,
                provider: provider,
                groupClaim: groupClaim,
                authStrategy: authStrategy,
                groups: groups
            };
            // owner rules has least priority
            if (authStrategy === "owner") resultRules.push(rule_1);
            else resultRules.unshift(rule_1);
        }
    });
    return resultRules;
}
function $876ecc8a1e3e0bfa$export$30b7ec2b779788cb(namespace, modelDefinition, transformerMutationType, isOwnerAuthorization, ownerField) {
    var selectionSet = $876ecc8a1e3e0bfa$var$generateSelectionSet(namespace, modelDefinition);
    var typeName = modelDefinition.name, pluralTypeName = modelDefinition.pluralName;
    var opName = "on" + transformerMutationType + typeName;
    var docArgs = "";
    var opArgs = "";
    if (isOwnerAuthorization) {
        docArgs = "($" + ownerField + ": String!)";
        opArgs = "(" + ownerField + ": $" + ownerField + ")";
    }
    return [
        transformerMutationType,
        opName,
        "subscription operation" + docArgs + "{\n			" + opName + opArgs + "{\n				" + selectionSet + "\n			}\n		}"
    ];
}
function $876ecc8a1e3e0bfa$export$2f950813a5fb99c9(namespace, modelDefinition, graphQLOpType) {
    var selectionSet = $876ecc8a1e3e0bfa$var$generateSelectionSet(namespace, modelDefinition);
    var typeName = modelDefinition.name, pluralTypeName = modelDefinition.pluralName;
    var operation;
    var documentArgs = " ";
    var operationArgs = " ";
    var transformerMutationType;
    switch(graphQLOpType){
        case "LIST":
            operation = "sync" + pluralTypeName;
            documentArgs = "($limit: Int, $nextToken: String, $lastSync: AWSTimestamp)";
            operationArgs = "(limit: $limit, nextToken: $nextToken, lastSync: $lastSync)";
            selectionSet = "items {\n							" + selectionSet + "\n						}\n						nextToken\n						startedAt";
            break;
        case "CREATE":
            operation = "create" + typeName;
            documentArgs = "($input: Create" + typeName + "Input!)";
            operationArgs = "(input: $input)";
            transformerMutationType = $876ecc8a1e3e0bfa$export$9bcccf0e728b2aab.CREATE;
            break;
        case "UPDATE":
            operation = "update" + typeName;
            documentArgs = "($input: Update" + typeName + "Input!, $condition: Model" + typeName + "ConditionInput)";
            operationArgs = "(input: $input, condition: $condition)";
            transformerMutationType = $876ecc8a1e3e0bfa$export$9bcccf0e728b2aab.UPDATE;
            break;
        case "DELETE":
            operation = "delete" + typeName;
            documentArgs = "($input: Delete" + typeName + "Input!, $condition: Model" + typeName + "ConditionInput)";
            operationArgs = "(input: $input, condition: $condition)";
            transformerMutationType = $876ecc8a1e3e0bfa$export$9bcccf0e728b2aab.DELETE;
            break;
        case "GET":
            operation = "get" + typeName;
            documentArgs = "($id: ID!)";
            operationArgs = "(id: $id)";
            transformerMutationType = $876ecc8a1e3e0bfa$export$9bcccf0e728b2aab.GET;
            break;
        default:
            (0, $6uSfH.exhaustiveCheck)(graphQLOpType);
    }
    return [
        [
            transformerMutationType,
            operation,
            $876ecc8a1e3e0bfa$var$GraphQLOperationType[graphQLOpType] + " operation" + documentArgs + "{\n		" + operation + operationArgs + "{\n			" + selectionSet + "\n		}\n	}"
        ]
    ];
}
function $876ecc8a1e3e0bfa$export$236bff8c0ac4a9e6(relationships, modelDefinition, opType, model, element, condition, MutationEventConstructor, modelInstanceCreator, id) {
    var operation;
    switch(opType){
        case (0, $6BLoD.OpType).INSERT:
            operation = $876ecc8a1e3e0bfa$export$9bcccf0e728b2aab.CREATE;
            break;
        case (0, $6BLoD.OpType).UPDATE:
            operation = $876ecc8a1e3e0bfa$export$9bcccf0e728b2aab.UPDATE;
            break;
        case (0, $6BLoD.OpType).DELETE:
            operation = $876ecc8a1e3e0bfa$export$9bcccf0e728b2aab.DELETE;
            break;
        default:
            (0, $6uSfH.exhaustiveCheck)(opType);
    }
    var mutationEvent = modelInstanceCreator(MutationEventConstructor, $876ecc8a1e3e0bfa$var$__assign($876ecc8a1e3e0bfa$var$__assign({}, id ? {
        id: id
    } : {}), {
        data: JSON.stringify(element),
        modelId: element.id,
        model: model.name,
        operation: operation,
        condition: JSON.stringify(condition)
    }));
    return mutationEvent;
}
function $876ecc8a1e3e0bfa$export$89e56ddbfa1b1c0f(predicate) {
    var result = {};
    if (!predicate || !Array.isArray(predicate.predicates)) return result;
    predicate.predicates.forEach(function(p) {
        var _a;
        if ((0, $6BLoD.isPredicateObj)(p)) {
            var field = p.field, operator = p.operator, operand = p.operand;
            if (field === "id") return;
            result[field] = (_a = {}, _a[operator] = operand, _a);
        } else result[p.type] = $876ecc8a1e3e0bfa$export$89e56ddbfa1b1c0f(p);
    });
    return result;
}

});


parcelRequire.register("1ncV3", function(module, exports) {

$parcel$export(module.exports, "MutationProcessor", function () { return $1001f5e804d35be2$export$5e12b861604a0f67; });

var $5Q7Dg = parcelRequire("5Q7Dg");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $9opJY = parcelRequire("9opJY");

var $eOKlk = parcelRequire("eOKlk");

var $6BLoD = parcelRequire("6BLoD");

var $6uSfH = parcelRequire("6uSfH");

var $bCU9m = parcelRequire("bCU9m");
var $1001f5e804d35be2$var$__assign = undefined && undefined.__assign || function() {
    $1001f5e804d35be2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1001f5e804d35be2$var$__assign.apply(this, arguments);
};
var $1001f5e804d35be2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $1001f5e804d35be2$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $1001f5e804d35be2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1001f5e804d35be2$var$MAX_ATTEMPTS = 10;
var $1001f5e804d35be2$var$logger = new (0, $gBqCF.ConsoleLogger)("DataStore");
var $1001f5e804d35be2$export$5e12b861604a0f67 = /** @class */ function() {
    function MutationProcessor(schema, storage, userClasses, outbox, modelInstanceCreator, MutationEvent, conflictHandler, errorHandler) {
        this.schema = schema;
        this.storage = storage;
        this.userClasses = userClasses;
        this.outbox = outbox;
        this.modelInstanceCreator = modelInstanceCreator;
        this.MutationEvent = MutationEvent;
        this.conflictHandler = conflictHandler;
        this.errorHandler = errorHandler;
        this.typeQuery = new WeakMap();
        this.processing = false;
        this.generateQueries();
    }
    MutationProcessor.prototype.generateQueries = function() {
        var _this = this;
        Object.values(this.schema.namespaces).forEach(function(namespace) {
            Object.values(namespace.models).filter(function(_a) {
                var syncable = _a.syncable;
                return syncable;
            }).forEach(function(model) {
                var createMutation = (0, $bCU9m.buildGraphQLOperation)(namespace, model, "CREATE")[0];
                var updateMutation = (0, $bCU9m.buildGraphQLOperation)(namespace, model, "UPDATE")[0];
                var deleteMutation = (0, $bCU9m.buildGraphQLOperation)(namespace, model, "DELETE")[0];
                _this.typeQuery.set(model, [
                    createMutation,
                    updateMutation,
                    deleteMutation
                ]);
            });
        });
    };
    MutationProcessor.prototype.isReady = function() {
        return this.observer !== undefined;
    };
    MutationProcessor.prototype.start = function() {
        var _this = this;
        var observable = new (0, $eOKlk.default)(function(observer) {
            _this.observer = observer;
            _this.resume();
            return function() {
                _this.pause();
            };
        });
        return observable;
    };
    MutationProcessor.prototype.resume = function() {
        return $1001f5e804d35be2$var$__awaiter(this, void 0, void 0, function() {
            var head, namespaceName, _a, model, operation, data, condition, modelConstructor, result, opName, modelDefinition, error_1, record;
            var _b;
            return $1001f5e804d35be2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (this.processing || !this.isReady()) return [
                            2 /*return*/ 
                        ];
                        this.processing = true;
                        namespaceName = (0, $6uSfH.USER);
                        _c.label = 1;
                    case 1:
                        _a = this.processing;
                        if (!_a) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.outbox.peek(this.storage)
                        ];
                    case 2:
                        _a = head = _c.sent();
                        _c.label = 3;
                    case 3:
                        if (!_a) return [
                            3 /*break*/ ,
                            11
                        ];
                        model = head.model, operation = head.operation, data = head.data, condition = head.condition;
                        modelConstructor = this.userClasses[model];
                        result = void 0;
                        opName = void 0;
                        modelDefinition = void 0;
                        _c.label = 4;
                    case 4:
                        _c.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.jitteredRetry(namespaceName, model, operation, data, condition, modelConstructor, this.MutationEvent, head)
                        ];
                    case 5:
                        _b = _c.sent(), result = _b[0], opName = _b[1], modelDefinition = _b[2];
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        error_1 = _c.sent();
                        if (error_1.message === "Offline" || error_1.message === "RetryMutation") return [
                            3 /*break*/ ,
                            1
                        ];
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 7:
                        if (!(result === undefined)) return [
                            3 /*break*/ ,
                            9
                        ];
                        $1001f5e804d35be2$var$logger.debug("done retrying");
                        return [
                            4 /*yield*/ ,
                            this.outbox.dequeue(this.storage)
                        ];
                    case 8:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 9:
                        record = result.data[opName];
                        return [
                            4 /*yield*/ ,
                            this.outbox.dequeue(this.storage)
                        ];
                    case 10:
                        _c.sent();
                        this.observer.next([
                            operation,
                            modelDefinition,
                            record
                        ]);
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 11:
                        // pauses itself
                        this.pause();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    MutationProcessor.prototype.jitteredRetry = function(namespaceName, model, operation, data, condition, modelConstructor, MutationEvent, mutationEvent) {
        return $1001f5e804d35be2$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $1001f5e804d35be2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $9opJY.jitteredExponentialRetry)(function(model, operation, data, condition, modelConstructor, MutationEvent, mutationEvent) {
                                return $1001f5e804d35be2$var$__awaiter(_this, void 0, void 0, function() {
                                    var _a, query, variables, graphQLCondition, opName, modelDefinition, tryWith, attempt, opType, result, err_1, error, retryWith, err_2, _b, opName_1, query_1, serverData, namespace, updatedMutation;
                                    var _c;
                                    return $1001f5e804d35be2$var$__generator(this, function(_d) {
                                        switch(_d.label){
                                            case 0:
                                                _a = this.createQueryVariables(namespaceName, model, operation, data, condition), query = _a[0], variables = _a[1], graphQLCondition = _a[2], opName = _a[3], modelDefinition = _a[4];
                                                tryWith = {
                                                    query: query,
                                                    variables: variables
                                                };
                                                attempt = 0;
                                                opType = this.opTypeFromTransformerOperation(operation);
                                                _d.label = 1;
                                            case 1:
                                                _d.trys.push([
                                                    1,
                                                    3,
                                                    ,
                                                    13
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    (0, $5Q7Dg.default).graphql(tryWith)
                                                ];
                                            case 2:
                                                result = _d.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    [
                                                        result,
                                                        opName,
                                                        modelDefinition
                                                    ]
                                                ];
                                            case 3:
                                                err_1 = _d.sent();
                                                if (!(err_1.errors && err_1.errors.length > 0)) return [
                                                    3 /*break*/ ,
                                                    12
                                                ];
                                                error = err_1.errors[0];
                                                if (error.message === "Network Error") {
                                                    if (!this.processing) throw new (0, $9opJY.NonRetryableError)("Offline");
                                                    // TODO: Check errors on different env (react-native or other browsers)
                                                    throw new Error("Network Error");
                                                }
                                                if (!(error.errorType === "ConflictUnhandled")) return [
                                                    3 /*break*/ ,
                                                    11
                                                ];
                                                attempt++;
                                                retryWith = void 0;
                                                if (!(attempt > $1001f5e804d35be2$var$MAX_ATTEMPTS)) return [
                                                    3 /*break*/ ,
                                                    4
                                                ];
                                                retryWith = (0, $6BLoD.DISCARD);
                                                return [
                                                    3 /*break*/ ,
                                                    7
                                                ];
                                            case 4:
                                                _d.trys.push([
                                                    4,
                                                    6,
                                                    ,
                                                    7
                                                ]);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.conflictHandler({
                                                        modelConstructor: modelConstructor,
                                                        localModel: this.modelInstanceCreator(modelConstructor, variables.input),
                                                        remoteModel: this.modelInstanceCreator(modelConstructor, error.data),
                                                        operation: opType,
                                                        attempts: attempt
                                                    })
                                                ];
                                            case 5:
                                                retryWith = _d.sent();
                                                return [
                                                    3 /*break*/ ,
                                                    7
                                                ];
                                            case 6:
                                                err_2 = _d.sent();
                                                $1001f5e804d35be2$var$logger.warn("conflict trycatch", err_2);
                                                return [
                                                    3 /*break*/ ,
                                                    13
                                                ];
                                            case 7:
                                                if (!(retryWith === (0, $6BLoD.DISCARD))) return [
                                                    3 /*break*/ ,
                                                    9
                                                ];
                                                _b = (0, $bCU9m.buildGraphQLOperation)(this.schema.namespaces[namespaceName], modelDefinition, "GET")[0], opName_1 = _b[1], query_1 = _b[2];
                                                return [
                                                    4 /*yield*/ ,
                                                    (0, $5Q7Dg.default).graphql({
                                                        query: query_1,
                                                        variables: {
                                                            id: variables.input.id
                                                        }
                                                    })
                                                ];
                                            case 8:
                                                serverData = _d.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    [
                                                        serverData,
                                                        opName_1,
                                                        modelDefinition
                                                    ]
                                                ];
                                            case 9:
                                                namespace = this.schema.namespaces[namespaceName];
                                                updatedMutation = (0, $bCU9m.createMutationInstanceFromModelOperation)(namespace.relationships, modelDefinition, opType, modelConstructor, retryWith, graphQLCondition, MutationEvent, this.modelInstanceCreator, mutationEvent.id);
                                                return [
                                                    4 /*yield*/ ,
                                                    this.storage.save(updatedMutation)
                                                ];
                                            case 10:
                                                _d.sent();
                                                throw new (0, $9opJY.NonRetryableError)("RetryMutation");
                                            case 11:
                                                try {
                                                    this.errorHandler({
                                                        localModel: this.modelInstanceCreator(modelConstructor, variables.input),
                                                        message: error.message,
                                                        operation: operation,
                                                        errorType: error.errorType,
                                                        errorInfo: error.errorInfo,
                                                        remoteModel: error.data ? this.modelInstanceCreator(modelConstructor, error.data) : null
                                                    });
                                                } catch (err) {
                                                    $1001f5e804d35be2$var$logger.warn({
                                                        _err: err
                                                    });
                                                } finally{
                                                    // Return empty tuple, dequeues the mutation
                                                    return [
                                                        2 /*return*/ ,
                                                        error.data ? [
                                                            {
                                                                data: (_c = {}, _c[opName] = error.data, _c)
                                                            },
                                                            opName,
                                                            modelDefinition
                                                        ] : []
                                                    ];
                                                }
                                                _d.label = 12;
                                            case 12:
                                                return [
                                                    3 /*break*/ ,
                                                    13
                                                ];
                                            case 13:
                                                if (tryWith) return [
                                                    3 /*break*/ ,
                                                    1
                                                ];
                                                _d.label = 14;
                                            case 14:
                                                return [
                                                    2 /*return*/ 
                                                ];
                                        }
                                    });
                                });
                            }, [
                                model,
                                operation,
                                data,
                                condition,
                                modelConstructor,
                                MutationEvent,
                                mutationEvent
                            ])
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    MutationProcessor.prototype.createQueryVariables = function(namespaceName, model, operation, data, condition) {
        var modelDefinition = this.schema.namespaces[namespaceName].models[model];
        var queriesTuples = this.typeQuery.get(modelDefinition);
        var _a = queriesTuples.find(function(_a) {
            var transformerMutationType = _a[0];
            return transformerMutationType === operation;
        }), opName = _a[1], query = _a[2];
        var _b = JSON.parse(data), _version = _b._version, parsedData = $1001f5e804d35be2$var$__rest(_b, [
            "_version"
        ]);
        var filteredData = operation === (0, $bCU9m.TransformerMutationType).DELETE ? {
            id: parsedData.id
        } // For DELETE mutations, only ID is sent
         : Object.values(modelDefinition.fields).filter(function(_a) {
            var type = _a.type, association = _a.association;
            // connections
            if ((0, $6BLoD.isModelFieldType)(type)) {
                // BELONGS_TO
                if ((0, $6BLoD.isTargetNameAssociation)(association) && association.connectionType === "BELONGS_TO") return true;
                // All other connections
                return false;
            }
            // scalars and non-model types
            return true;
        }).map(function(_a) {
            var name = _a.name, type = _a.type, association = _a.association;
            var fieldName = name;
            var val = parsedData[name];
            if ((0, $6BLoD.isModelFieldType)(type) && (0, $6BLoD.isTargetNameAssociation)(association)) {
                fieldName = association.targetName;
                val = parsedData[fieldName];
            }
            return [
                fieldName,
                val
            ];
        }).reduce(function(acc, _a) {
            var k = _a[0], v = _a[1];
            acc[k] = v;
            return acc;
        }, {});
        // Build mutation variables input object
        var input = $1001f5e804d35be2$var$__assign($1001f5e804d35be2$var$__assign({}, filteredData), {
            _version: _version
        });
        var graphQLCondition = JSON.parse(condition);
        var variables = $1001f5e804d35be2$var$__assign({
            input: input
        }, operation === (0, $bCU9m.TransformerMutationType).CREATE ? {} : {
            condition: Object.keys(graphQLCondition).length > 0 ? graphQLCondition : null
        });
        return [
            query,
            variables,
            graphQLCondition,
            opName,
            modelDefinition
        ];
    };
    MutationProcessor.prototype.opTypeFromTransformerOperation = function(operation) {
        switch(operation){
            case (0, $bCU9m.TransformerMutationType).CREATE:
                return (0, $6BLoD.OpType).INSERT;
            case (0, $bCU9m.TransformerMutationType).DELETE:
                return (0, $6BLoD.OpType).DELETE;
            case (0, $bCU9m.TransformerMutationType).UPDATE:
                return (0, $6BLoD.OpType).UPDATE;
            case (0, $bCU9m.TransformerMutationType).GET:
                break;
            default:
                (0, $6uSfH.exhaustiveCheck)(operation);
        }
    };
    MutationProcessor.prototype.pause = function() {
        this.processing = false;
    };
    return MutationProcessor;
}();

});

parcelRequire.register("MV52f", function(module, exports) {

$parcel$export(module.exports, "CONTROL_MSG", function () { return $0930c2c04e465596$export$f96baa4bc836aea4; });
$parcel$export(module.exports, "SubscriptionProcessor", function () { return $0930c2c04e465596$export$b43d488bed694ad8; });
parcelRequire("5Q7Dg");
var $IRLYq = parcelRequire("IRLYq");
var $5Q7Dg = parcelRequire("5Q7Dg");

var $hbz3E = parcelRequire("hbz3E");

var $9x214 = parcelRequire("9x214");
parcelRequire("2hWDt");
var $gBqCF = parcelRequire("gBqCF");
var $iZUWK = parcelRequire("iZUWK");
parcelRequire("9fvEQ");

var $eOKlk = parcelRequire("eOKlk");

var $bCU9m = parcelRequire("bCU9m");

var $5oOz5 = parcelRequire("5oOz5");
var $0930c2c04e465596$require$Buffer = $5oOz5.Buffer;
var $0930c2c04e465596$var$__assign = undefined && undefined.__assign || function() {
    $0930c2c04e465596$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0930c2c04e465596$var$__assign.apply(this, arguments);
};
var $0930c2c04e465596$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0930c2c04e465596$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $0930c2c04e465596$var$logger = new (0, $gBqCF.ConsoleLogger)("DataStore");
var $0930c2c04e465596$export$f96baa4bc836aea4;
(function(CONTROL_MSG) {
    CONTROL_MSG["CONNECTED"] = "CONNECTED";
})($0930c2c04e465596$export$f96baa4bc836aea4 || ($0930c2c04e465596$export$f96baa4bc836aea4 = {}));
var $0930c2c04e465596$export$a4093ad6b05b5f9f;
(function(USER_CREDENTIALS) {
    USER_CREDENTIALS[USER_CREDENTIALS["none"] = 0] = "none";
    USER_CREDENTIALS[USER_CREDENTIALS["unauth"] = 1] = "unauth";
    USER_CREDENTIALS[USER_CREDENTIALS["auth"] = 2] = "auth";
})($0930c2c04e465596$export$a4093ad6b05b5f9f || ($0930c2c04e465596$export$a4093ad6b05b5f9f = {}));
var $0930c2c04e465596$export$b43d488bed694ad8 = /** @class */ function() {
    function SubscriptionProcessor(schema) {
        this.schema = schema;
        this.typeQuery = new WeakMap();
        this.buffer = [];
    }
    SubscriptionProcessor.prototype.buildSubscription = function(namespace, model, transformerMutationType, userCredentials, cognitoTokenPayload, oidcTokenPayload) {
        var _a = this.getAuthorizationInfo(model, transformerMutationType, userCredentials, cognitoTokenPayload, oidcTokenPayload) || {}, authMode = _a.authMode, isOwner = _a.isOwner, ownerField = _a.ownerField, ownerValue = _a.ownerValue;
        var _b = (0, $bCU9m.buildSubscriptionGraphQLOperation)(namespace, model, transformerMutationType, isOwner, ownerField), opType = _b[0], opName = _b[1], query = _b[2];
        return {
            authMode: authMode,
            opType: opType,
            opName: opName,
            query: query,
            isOwner: isOwner,
            ownerField: ownerField,
            ownerValue: ownerValue
        };
    };
    SubscriptionProcessor.prototype.getAuthorizationInfo = function(model, transformerMutationType, userCredentials, cognitoTokenPayload, oidcTokenPayload) {
        if (cognitoTokenPayload === void 0) cognitoTokenPayload = {};
        if (oidcTokenPayload === void 0) oidcTokenPayload = {};
        var result;
        var rules = (0, $bCU9m.getAuthorizationRules)(model, transformerMutationType);
        // check if has apiKey and public authorization
        var apiKeyAuth = rules.find(function(rule) {
            return rule.authStrategy === "public" && rule.provider === "apiKey";
        });
        if (apiKeyAuth) return {
            authMode: (0, $IRLYq.GRAPHQL_AUTH_MODE).API_KEY,
            isOwner: false
        };
        // check if has iam authorization
        if (userCredentials === $0930c2c04e465596$export$a4093ad6b05b5f9f.unauth || userCredentials === $0930c2c04e465596$export$a4093ad6b05b5f9f.auth) {
            var iamPublicAuth = rules.find(function(rule) {
                return rule.authStrategy === "public" && rule.provider === "iam";
            });
            if (iamPublicAuth) return {
                authMode: (0, $IRLYq.GRAPHQL_AUTH_MODE).AWS_IAM,
                isOwner: false
            };
            var iamPrivateAuth = userCredentials === $0930c2c04e465596$export$a4093ad6b05b5f9f.auth && rules.find(function(rule) {
                return rule.authStrategy === "private" && rule.provider === "iam";
            });
            if (iamPrivateAuth) return {
                authMode: (0, $IRLYq.GRAPHQL_AUTH_MODE).AWS_IAM,
                isOwner: false
            };
        }
        // if not check if has groups authorization and token has groupClaim allowed for cognito token
        var groupAuthRules = rules.filter(function(rule) {
            return rule.authStrategy === "group" && rule.provider === "userPools";
        });
        var validCognitoGroup = groupAuthRules.find(function(groupAuthRule) {
            // validate token agains groupClaim
            var userGroups = cognitoTokenPayload[groupAuthRule.groupClaim] || [];
            return userGroups.find(function(userGroup) {
                return groupAuthRule.groups.find(function(group) {
                    return group === userGroup;
                });
            });
        });
        if (validCognitoGroup) return {
            authMode: (0, $IRLYq.GRAPHQL_AUTH_MODE).AMAZON_COGNITO_USER_POOLS,
            isOwner: false
        };
        // if not check if has groups authorization and token has groupClaim allowed for oidc token
        groupAuthRules = rules.filter(function(rule) {
            return rule.authStrategy === "group" && rule.provider === "oidc";
        });
        var validOidcGroup = groupAuthRules.find(function(groupAuthRule) {
            // validate token agains groupClaim
            var userGroups = oidcTokenPayload[groupAuthRule.groupClaim] || [];
            userGroups.find(function(userGroup) {
                return groupAuthRule.groups.find(function(group) {
                    return group === userGroup;
                });
            });
        });
        if (validOidcGroup) return {
            authMode: (0, $IRLYq.GRAPHQL_AUTH_MODE).OPENID_CONNECT,
            isOwner: false
        };
        // check if has owner auth authorization and token ownerField for cognito token
        var ownerAuthRules = rules.filter(function(rule) {
            return rule.authStrategy === "owner" && rule.provider === "userPools";
        });
        ownerAuthRules.forEach(function(ownerAuthRule) {
            var ownerValue = cognitoTokenPayload[ownerAuthRule.identityClaim];
            if (ownerValue) result = {
                authMode: (0, $IRLYq.GRAPHQL_AUTH_MODE).AMAZON_COGNITO_USER_POOLS,
                isOwner: true,
                ownerField: ownerAuthRule.ownerField,
                ownerValue: ownerValue
            };
        });
        if (result) return result;
        // check if has owner auth authorization and token ownerField for oidc token
        ownerAuthRules = rules.filter(function(rule) {
            return rule.authStrategy === "owner" && rule.provider === "oidc";
        });
        ownerAuthRules.forEach(function(ownerAuthRule) {
            var ownerValue = oidcTokenPayload[ownerAuthRule.identityClaim];
            if (ownerValue) result = {
                authMode: (0, $IRLYq.GRAPHQL_AUTH_MODE).OPENID_CONNECT,
                isOwner: true,
                ownerField: ownerAuthRule.ownerField,
                ownerValue: ownerValue
            };
        });
        if (result) return result;
        return null;
    };
    SubscriptionProcessor.prototype.hubQueryCompletionListener = function(completed, variables, capsule) {
        if (variables === capsule.payload.data.variables) completed();
    };
    SubscriptionProcessor.prototype.start = function() {
        var _this = this;
        var ctlObservable = new (0, $eOKlk.default)(function(observer) {
            var promises = [];
            var subscriptions = [];
            var cognitoTokenPayload, oidcTokenPayload;
            var userCredentials = $0930c2c04e465596$export$a4093ad6b05b5f9f.none;
            (function() {
                return $0930c2c04e465596$var$__awaiter(_this, void 0, void 0, function() {
                    var credentials, err_1, session, err_2, federatedInfo, token, payload, err_3;
                    var _this = this;
                    return $0930c2c04e465596$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                _a.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    (0, $hbz3E.default).currentCredentials()
                                ];
                            case 1:
                                credentials = _a.sent();
                                userCredentials = credentials.authenticated ? $0930c2c04e465596$export$a4093ad6b05b5f9f.auth : $0930c2c04e465596$export$a4093ad6b05b5f9f.unauth;
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                err_1 = _a.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 3:
                                _a.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    (0, $hbz3E.default).currentSession()
                                ];
                            case 4:
                                session = _a.sent();
                                cognitoTokenPayload = session.getIdToken().decodePayload();
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                err_2 = _a.sent();
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 6:
                                _a.trys.push([
                                    6,
                                    8,
                                    ,
                                    9
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    (0, $9x214.default).getItem("federatedInfo")
                                ];
                            case 7:
                                federatedInfo = _a.sent();
                                token = federatedInfo.token;
                                payload = token.split(".")[1];
                                oidcTokenPayload = JSON.parse($0930c2c04e465596$require$Buffer.from(payload, "base64").toString("utf8"));
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 8:
                                err_3 = _a.sent();
                                return [
                                    3 /*break*/ ,
                                    9
                                ];
                            case 9:
                                Object.values(this.schema.namespaces).forEach(function(namespace) {
                                    Object.values(namespace.models).filter(function(_a) {
                                        var syncable = _a.syncable;
                                        return syncable;
                                    }).forEach(function(modelDefinition) {
                                        return $0930c2c04e465596$var$__awaiter(_this, void 0, void 0, function() {
                                            var queriesMetadata;
                                            var _this = this;
                                            return $0930c2c04e465596$var$__generator(this, function(_a) {
                                                queriesMetadata = [
                                                    (0, $bCU9m.TransformerMutationType).CREATE,
                                                    (0, $bCU9m.TransformerMutationType).UPDATE,
                                                    (0, $bCU9m.TransformerMutationType).DELETE
                                                ].map(function(op) {
                                                    return _this.buildSubscription(namespace, modelDefinition, op, userCredentials, cognitoTokenPayload, oidcTokenPayload);
                                                });
                                                queriesMetadata.forEach(function(_a) {
                                                    var transformerMutationType = _a.opType, opName = _a.opName, query = _a.query, isOwner = _a.isOwner, ownerField = _a.ownerField, ownerValue = _a.ownerValue, authMode = _a.authMode;
                                                    return $0930c2c04e465596$var$__awaiter(_this, void 0, void 0, function() {
                                                        var marker, queryObservable;
                                                        var _this = this;
                                                        return $0930c2c04e465596$var$__generator(this, function(_b) {
                                                            marker = {};
                                                            if (isOwner) {
                                                                if (!ownerValue) {
                                                                    // Check if there is an owner field, check where this error should be located
                                                                    observer.error("Owner field required, sign in is needed in order to perform this operation");
                                                                    return [
                                                                        2 /*return*/ 
                                                                    ];
                                                                }
                                                                marker[ownerField] = ownerValue;
                                                            }
                                                            queryObservable = (0, $5Q7Dg.default).graphql($0930c2c04e465596$var$__assign({
                                                                query: query,
                                                                variables: marker
                                                            }, {
                                                                authMode: authMode
                                                            }));
                                                            subscriptions.push(queryObservable.map(function(_a) {
                                                                var value = _a.value;
                                                                return value;
                                                            }).subscribe({
                                                                next: function(_a) {
                                                                    var data = _a.data, errors = _a.errors;
                                                                    if (Array.isArray(errors) && errors.length > 0) {
                                                                        var messages = errors.map(function(_a) {
                                                                            var message = _a.message;
                                                                            return message;
                                                                        });
                                                                        $0930c2c04e465596$var$logger.warn("Skipping incoming subscription. Messages: " + messages.join("\n"));
                                                                        _this.drainBuffer();
                                                                        return;
                                                                    }
                                                                    var _b = opName, record = data[_b];
                                                                    _this.pushToBuffer(transformerMutationType, modelDefinition, record);
                                                                    _this.drainBuffer();
                                                                },
                                                                error: function(subscriptionError) {
                                                                    var _a = subscriptionError.error, _b = (_a === void 0 ? {
                                                                        errors: []
                                                                    } : _a).errors[0], _c = (_b === void 0 ? {} : _b).message, message = _c === void 0 ? "" : _c;
                                                                    observer.error(message);
                                                                }
                                                            }));
                                                            promises.push(function() {
                                                                return $0930c2c04e465596$var$__awaiter(_this, void 0, void 0, function() {
                                                                    var boundFunction;
                                                                    var _this = this;
                                                                    return $0930c2c04e465596$var$__generator(this, function(_a) {
                                                                        switch(_a.label){
                                                                            case 0:
                                                                                return [
                                                                                    4 /*yield*/ ,
                                                                                    new Promise(function(res) {
                                                                                        boundFunction = _this.hubQueryCompletionListener.bind(_this, res, marker);
                                                                                        (0, $iZUWK.default).listen("api", boundFunction);
                                                                                    })
                                                                                ];
                                                                            case 1:
                                                                                _a.sent();
                                                                                (0, $iZUWK.default).remove("api", boundFunction);
                                                                                return [
                                                                                    2 /*return*/ 
                                                                                ];
                                                                        }
                                                                    });
                                                                });
                                                            }());
                                                            return [
                                                                2 /*return*/ 
                                                            ];
                                                        });
                                                    });
                                                });
                                                return [
                                                    2 /*return*/ 
                                                ];
                                            });
                                        });
                                    });
                                });
                                Promise.all(promises).then(function() {
                                    return observer.next($0930c2c04e465596$export$f96baa4bc836aea4.CONNECTED);
                                });
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            })();
            return function() {
                subscriptions.forEach(function(subscription) {
                    return subscription.unsubscribe();
                });
            };
        });
        var dataObservable = new (0, $eOKlk.default)(function(observer) {
            _this.dataObserver = observer;
            _this.drainBuffer();
            return function() {
                _this.dataObserver = null;
            };
        });
        return [
            ctlObservable,
            dataObservable
        ];
    };
    SubscriptionProcessor.prototype.pushToBuffer = function(transformerMutationType, modelDefinition, data) {
        this.buffer.push([
            transformerMutationType,
            modelDefinition,
            data
        ]);
    };
    SubscriptionProcessor.prototype.drainBuffer = function() {
        var _this = this;
        if (this.dataObserver) {
            this.buffer.forEach(function(data) {
                return _this.dataObserver.next(data);
            });
            this.buffer = [];
        }
    };
    return SubscriptionProcessor;
}();

});

parcelRequire.register("kCEcI", function(module, exports) {

$parcel$export(module.exports, "SyncProcessor", function () { return $f0368af744c38d78$export$d5bf39b637851bfb; });

var $5Q7Dg = parcelRequire("5Q7Dg");

var $eOKlk = parcelRequire("eOKlk");

var $bCU9m = parcelRequire("bCU9m");
parcelRequire("2hWDt");
var $9opJY = parcelRequire("9opJY");
var $f0368af744c38d78$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f0368af744c38d78$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $f0368af744c38d78$var$DEFAULT_PAGINATION_LIMIT = 100;
var $f0368af744c38d78$var$DEFAULT_MAX_RECORDS_TO_SYNC = 10000;
var $f0368af744c38d78$export$d5bf39b637851bfb = /** @class */ function() {
    function SyncProcessor(schema, maxRecordsToSync, syncPageSize) {
        if (maxRecordsToSync === void 0) maxRecordsToSync = $f0368af744c38d78$var$DEFAULT_MAX_RECORDS_TO_SYNC;
        if (syncPageSize === void 0) syncPageSize = $f0368af744c38d78$var$DEFAULT_PAGINATION_LIMIT;
        this.schema = schema;
        this.maxRecordsToSync = maxRecordsToSync;
        this.syncPageSize = syncPageSize;
        this.typeQuery = new WeakMap();
        this.generateQueries();
    }
    SyncProcessor.prototype.generateQueries = function() {
        var _this = this;
        Object.values(this.schema.namespaces).forEach(function(namespace) {
            Object.values(namespace.models).filter(function(_a) {
                var syncable = _a.syncable;
                return syncable;
            }).forEach(function(model) {
                var _a = (0, $bCU9m.buildGraphQLOperation)(namespace, model, "LIST")[0], opNameQuery = _a.slice(1);
                _this.typeQuery.set(model, opNameQuery);
            });
        });
    };
    SyncProcessor.prototype.retrievePage = function(modelDefinition, lastSync, nextToken, limit) {
        if (limit === void 0) limit = null;
        return $f0368af744c38d78$var$__awaiter(this, void 0, void 0, function() {
            var _a, opName, query, variables, data, _b, opResult, items, newNextToken, startedAt;
            return $f0368af744c38d78$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = this.typeQuery.get(modelDefinition), opName = _a[0], query = _a[1];
                        variables = {
                            limit: limit,
                            nextToken: nextToken,
                            lastSync: lastSync
                        };
                        return [
                            4 /*yield*/ ,
                            this.jitteredRetry(query, variables)
                        ];
                    case 1:
                        data = _c.sent().data;
                        _b = opName, opResult = data[_b];
                        items = opResult.items, newNextToken = opResult.nextToken, startedAt = opResult.startedAt;
                        return [
                            2 /*return*/ ,
                            {
                                nextToken: newNextToken,
                                startedAt: startedAt,
                                items: items
                            }
                        ];
                }
            });
        });
    };
    SyncProcessor.prototype.jitteredRetry = function(query, variables) {
        return $f0368af744c38d78$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $f0368af744c38d78$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $9opJY.jitteredExponentialRetry)(function(query, variables) {
                                return $f0368af744c38d78$var$__awaiter(_this, void 0, void 0, function() {
                                    return $f0368af744c38d78$var$__generator(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    (0, $5Q7Dg.default).graphql({
                                                        query: query,
                                                        variables: variables
                                                    })
                                                ];
                                            case 1:
                                                return [
                                                    2 /*return*/ ,
                                                    _a.sent()
                                                ];
                                        }
                                    });
                                });
                            }, [
                                query,
                                variables
                            ])
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    SyncProcessor.prototype.start = function(typesLastSync) {
        var _this = this;
        var processing = true;
        var maxRecordsToSync = this.maxRecordsToSync !== undefined ? this.maxRecordsToSync : $f0368af744c38d78$var$DEFAULT_MAX_RECORDS_TO_SYNC;
        var syncPageSize = this.syncPageSize !== undefined ? this.syncPageSize : $f0368af744c38d78$var$DEFAULT_PAGINATION_LIMIT;
        var parentPromises = new Map();
        var observable = new (0, $eOKlk.default)(function(observer) {
            var sortedTypesLastSyncs = Object.values(_this.schema.namespaces).reduce(function(map, namespace) {
                for(var _i = 0, _a = Array.from(namespace.modelTopologicalOrdering.keys()); _i < _a.length; _i++){
                    var modelName = _a[_i];
                    var typeLastSync = typesLastSync.get(namespace.models[modelName]);
                    map.set(namespace.models[modelName], typeLastSync);
                }
                return map;
            }, new Map());
            var allModelsReady = Array.from(sortedTypesLastSyncs.entries()).filter(function(_a) {
                var syncable = _a[0].syncable;
                return syncable;
            }).map(function(_a) {
                var modelDefinition = _a[0], _b = _a[1], namespace = _b[0], lastSync = _b[1];
                return $f0368af744c38d78$var$__awaiter(_this, void 0, void 0, function() {
                    var done, nextToken, startedAt, items, recordsReceived, parents, promises, promise;
                    var _this = this;
                    return $f0368af744c38d78$var$__generator(this, function(_c) {
                        switch(_c.label){
                            case 0:
                                done = false;
                                nextToken = null;
                                startedAt = null;
                                items = null;
                                recordsReceived = 0;
                                parents = this.schema.namespaces[namespace].modelTopologicalOrdering.get(modelDefinition.name);
                                promises = parents.map(function(parent) {
                                    return parentPromises.get(namespace + "_" + parent);
                                });
                                promise = new Promise(function(res) {
                                    return $f0368af744c38d78$var$__awaiter(_this, void 0, void 0, function() {
                                        var limit;
                                        var _a;
                                        return $f0368af744c38d78$var$__generator(this, function(_b) {
                                            switch(_b.label){
                                                case 0:
                                                    return [
                                                        4 /*yield*/ ,
                                                        Promise.all(promises)
                                                    ];
                                                case 1:
                                                    _b.sent();
                                                    _b.label = 2;
                                                case 2:
                                                    if (!processing) return [
                                                        2 /*return*/ 
                                                    ];
                                                    limit = Math.min(maxRecordsToSync - recordsReceived, syncPageSize);
                                                    return [
                                                        4 /*yield*/ ,
                                                        this.retrievePage(modelDefinition, lastSync, nextToken, limit)
                                                    ];
                                                case 3:
                                                    _a = _b.sent(), items = _a.items, nextToken = _a.nextToken, startedAt = _a.startedAt;
                                                    recordsReceived += items.length;
                                                    done = nextToken === null || recordsReceived >= maxRecordsToSync;
                                                    observer.next({
                                                        namespace: namespace,
                                                        modelDefinition: modelDefinition,
                                                        items: items,
                                                        done: done,
                                                        startedAt: startedAt,
                                                        isFullSync: !lastSync
                                                    });
                                                    _b.label = 4;
                                                case 4:
                                                    if (!done) return [
                                                        3 /*break*/ ,
                                                        2
                                                    ];
                                                    _b.label = 5;
                                                case 5:
                                                    res();
                                                    return [
                                                        2 /*return*/ 
                                                    ];
                                            }
                                        });
                                    });
                                });
                                parentPromises.set(namespace + "_" + modelDefinition.name, promise);
                                return [
                                    4 /*yield*/ ,
                                    promise
                                ];
                            case 1:
                                _c.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            });
            Promise.all(allModelsReady).then(function() {
                observer.complete();
            });
            return function() {
                processing = false;
            };
        });
        return observable;
    };
    return SyncProcessor;
}();

});






parcelRequire.register("6Sno5", function(module, exports) {

$parcel$export(module.exports, "PageHeading", function () { return $50811834526e50a9$export$9716a88f5535df7c; });

var $dYG3T = parcelRequire("dYG3T");
parcelRequire("fV3WI");

var $hhXI3 = parcelRequire("hhXI3");

var $hScOl = parcelRequire("hScOl");
const $50811834526e50a9$var$pageHeadingStyles = (0, $hhXI3.css)`
  font-weight: bold;
  margin-bottom: 24px;
`;
const $50811834526e50a9$export$9716a88f5535df7c = ({ children: children , ...rest })=>/*#__PURE__*/ (0, $dYG3T.jsx)((0, $hScOl.default), {
        variant: "body1",
        css: $50811834526e50a9$var$pageHeadingStyles,
        ...rest,
        children: children
    });

});

parcelRequire.register("aKrmE", function(module, exports) {



module.exports = (parcelRequire("c5CTK"))((parcelRequire("3qc09")).getBundleURL("kAnEi") + (parcelRequire("3Cqyy")).resolve("4ATA0")).then(()=>parcelRequire("4NbLW"));

});
parcelRequire.register("c5CTK", function(module, exports) {
"use strict";

var $aqRiN = parcelRequire("aqRiN");
module.exports = $aqRiN(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRequire.register("aqRiN", function(module, exports) {
"use strict";
var $7985adc3c214172c$var$cachedBundles = {};
var $7985adc3c214172c$var$cachedPreloads = {};
var $7985adc3c214172c$var$cachedPrefetches = {};
function $7985adc3c214172c$var$getCache(type) {
    switch(type){
        case "preload":
            return $7985adc3c214172c$var$cachedPreloads;
        case "prefetch":
            return $7985adc3c214172c$var$cachedPrefetches;
        default:
            return $7985adc3c214172c$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $7985adc3c214172c$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRequire.register("3qc09", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $27dd1c08178763b7$export$bdfd709ae4826697; }, function (v) { return $27dd1c08178763b7$export$bdfd709ae4826697 = v; });
var $27dd1c08178763b7$export$bdfd709ae4826697;
var $27dd1c08178763b7$export$c9e73fbda7da57b6;
var $27dd1c08178763b7$export$5a759dc7a1cfb72a;
"use strict";
var $27dd1c08178763b7$var$bundleURL = {};
function $27dd1c08178763b7$var$getBundleURLCached(id) {
    var value = $27dd1c08178763b7$var$bundleURL[id];
    if (!value) {
        value = $27dd1c08178763b7$var$getBundleURL();
        $27dd1c08178763b7$var$bundleURL[id] = value;
    }
    return value;
}
function $27dd1c08178763b7$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $27dd1c08178763b7$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $27dd1c08178763b7$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $27dd1c08178763b7$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$27dd1c08178763b7$export$bdfd709ae4826697 = $27dd1c08178763b7$var$getBundleURLCached;
$27dd1c08178763b7$export$c9e73fbda7da57b6 = $27dd1c08178763b7$var$getBaseURL;
$27dd1c08178763b7$export$5a759dc7a1cfb72a = $27dd1c08178763b7$var$getOrigin;

});


parcelRequire.register("7lqkF", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("c5CTK"))((parcelRequire("3qc09")).getBundleURL("kAnEi") + (parcelRequire("3Cqyy")).resolve("gmog8")),
    (parcelRequire("c5CTK"))((parcelRequire("3qc09")).getBundleURL("kAnEi") + (parcelRequire("3Cqyy")).resolve("5fKnl"))
]).then(()=>parcelRequire("doTcc"));

});

parcelRequire.register("fnhb1", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("c5CTK"))((parcelRequire("3qc09")).getBundleURL("kAnEi") + (parcelRequire("3Cqyy")).resolve("gmog8")),
    (parcelRequire("c5CTK"))((parcelRequire("3qc09")).getBundleURL("kAnEi") + (parcelRequire("3Cqyy")).resolve("8skMd"))
]).then(()=>parcelRequire("kz0RO"));

});

parcelRequire.register("6RIdp", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("c5CTK"))((parcelRequire("3qc09")).getBundleURL("kAnEi") + (parcelRequire("3Cqyy")).resolve("gmog8")),
    (parcelRequire("c5CTK"))((parcelRequire("3qc09")).getBundleURL("kAnEi") + (parcelRequire("3Cqyy")).resolve("agXm2"))
]).then(()=>parcelRequire("8soOH"));

});

parcelRequire.register("2iTIk", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("c5CTK"))((parcelRequire("3qc09")).getBundleURL("kAnEi") + (parcelRequire("3Cqyy")).resolve("gmog8")),
    (parcelRequire("c5CTK"))((parcelRequire("3qc09")).getBundleURL("kAnEi") + (parcelRequire("3Cqyy")).resolve("czyqf"))
]).then(()=>parcelRequire("9t7Pe"));

});


var $dYG3T = parcelRequire("dYG3T");
parcelRequire("fV3WI");
var $3045335d06a4a99d$export$882461b6382ed46c;
var $3045335d06a4a99d$export$757ceba2d55c277e;
"use strict";

var $fXLKn = parcelRequire("fXLKn");
var $3045335d06a4a99d$var$i;
$3045335d06a4a99d$export$882461b6382ed46c = $fXLKn.createRoot;
$3045335d06a4a99d$export$757ceba2d55c277e = $fXLKn.hydrateRoot;



var $dYG3T = parcelRequire("dYG3T");
parcelRequire("fV3WI");

var $gAFWW = parcelRequire("gAFWW");

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $1aaf9c65fb7afb7d$var$extendStatics = function(d, b) {
    $1aaf9c65fb7afb7d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $1aaf9c65fb7afb7d$var$extendStatics(d, b);
};
function $1aaf9c65fb7afb7d$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $1aaf9c65fb7afb7d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1aaf9c65fb7afb7d$export$18ce0697a983be9b = function() {
    $1aaf9c65fb7afb7d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1aaf9c65fb7afb7d$export$18ce0697a983be9b.apply(this, arguments);
};
function $1aaf9c65fb7afb7d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1aaf9c65fb7afb7d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $1aaf9c65fb7afb7d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $1aaf9c65fb7afb7d$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $1aaf9c65fb7afb7d$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $1aaf9c65fb7afb7d$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $1aaf9c65fb7afb7d$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $1aaf9c65fb7afb7d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $1aaf9c65fb7afb7d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1aaf9c65fb7afb7d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $1aaf9c65fb7afb7d$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $1aaf9c65fb7afb7d$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $1aaf9c65fb7afb7d$export$45d3717a4c69092e(o, m, p);
}
function $1aaf9c65fb7afb7d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1aaf9c65fb7afb7d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1aaf9c65fb7afb7d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1aaf9c65fb7afb7d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $1aaf9c65fb7afb7d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $1aaf9c65fb7afb7d$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $1aaf9c65fb7afb7d$export$10c90e4f7922046c(v) {
    return this instanceof $1aaf9c65fb7afb7d$export$10c90e4f7922046c ? (this.v = v, this) : new $1aaf9c65fb7afb7d$export$10c90e4f7922046c(v);
}
function $1aaf9c65fb7afb7d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $1aaf9c65fb7afb7d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $1aaf9c65fb7afb7d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $1aaf9c65fb7afb7d$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $1aaf9c65fb7afb7d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $1aaf9c65fb7afb7d$export$19a8beecd37a4c45 === "function" ? $1aaf9c65fb7afb7d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $1aaf9c65fb7afb7d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $1aaf9c65fb7afb7d$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $1aaf9c65fb7afb7d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1aaf9c65fb7afb7d$export$45d3717a4c69092e(result, mod, k);
    }
    $1aaf9c65fb7afb7d$var$__setModuleDefault(result, mod);
    return result;
}
function $1aaf9c65fb7afb7d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $1aaf9c65fb7afb7d$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $1aaf9c65fb7afb7d$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $1aaf9c65fb7afb7d$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
var $1aaf9c65fb7afb7d$export$2e2bcd8739ae039 = {
    __extends: $1aaf9c65fb7afb7d$export$a8ba968b8961cb8a,
    __assign: $1aaf9c65fb7afb7d$export$18ce0697a983be9b,
    __rest: $1aaf9c65fb7afb7d$export$3c9a16f847548506,
    __decorate: $1aaf9c65fb7afb7d$export$29e00dfd3077644b,
    __param: $1aaf9c65fb7afb7d$export$d5ad3fd78186038f,
    __metadata: $1aaf9c65fb7afb7d$export$f1db080c865becb9,
    __awaiter: $1aaf9c65fb7afb7d$export$1050f835b63b671e,
    __generator: $1aaf9c65fb7afb7d$export$67ebef60e6f28a6,
    __createBinding: $1aaf9c65fb7afb7d$export$45d3717a4c69092e,
    __exportStar: $1aaf9c65fb7afb7d$export$f33643c0debef087,
    __values: $1aaf9c65fb7afb7d$export$19a8beecd37a4c45,
    __read: $1aaf9c65fb7afb7d$export$8d051b38c9118094,
    __spread: $1aaf9c65fb7afb7d$export$afc72e2116322959,
    __spreadArrays: $1aaf9c65fb7afb7d$export$6388937ca91ccae8,
    __spreadArray: $1aaf9c65fb7afb7d$export$1216008129fb82ed,
    __await: $1aaf9c65fb7afb7d$export$10c90e4f7922046c,
    __asyncGenerator: $1aaf9c65fb7afb7d$export$e427f37a30a4de9b,
    __asyncDelegator: $1aaf9c65fb7afb7d$export$bbd80228419bb833,
    __asyncValues: $1aaf9c65fb7afb7d$export$e3b29a3d6162315f,
    __makeTemplateObject: $1aaf9c65fb7afb7d$export$4fb47efe1390b86f,
    __importStar: $1aaf9c65fb7afb7d$export$c21735bcef00d192,
    __importDefault: $1aaf9c65fb7afb7d$export$da59b14a69baef04,
    __classPrivateFieldGet: $1aaf9c65fb7afb7d$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $1aaf9c65fb7afb7d$export$d40a35129aaff81f,
    __classPrivateFieldIn: $1aaf9c65fb7afb7d$export$81fdc39f203e4e04
};



var $a670ecbae0a62090$var$genericMessage = "Invariant Violation";
var $a670ecbae0a62090$var$_a = Object.setPrototypeOf, $a670ecbae0a62090$var$setPrototypeOf = $a670ecbae0a62090$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $a670ecbae0a62090$var$_a;
var $a670ecbae0a62090$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $1aaf9c65fb7afb7d$export$a8ba968b8961cb8a)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $a670ecbae0a62090$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $a670ecbae0a62090$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $a670ecbae0a62090$var$genericMessage;
        $a670ecbae0a62090$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $a670ecbae0a62090$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $a670ecbae0a62090$export$cea12affaee22fe8(message);
}
var $a670ecbae0a62090$var$verbosityLevels = [
    "debug",
    "log",
    "warn",
    "error",
    "silent"
];
var $a670ecbae0a62090$var$verbosityLevel = $a670ecbae0a62090$var$verbosityLevels.indexOf("log");
function $a670ecbae0a62090$var$wrapConsoleMethod(name) {
    return function() {
        if ($a670ecbae0a62090$var$verbosityLevels.indexOf(name) >= $a670ecbae0a62090$var$verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function(invariant) {
    invariant.debug = $a670ecbae0a62090$var$wrapConsoleMethod("debug");
    invariant.log = $a670ecbae0a62090$var$wrapConsoleMethod("log");
    invariant.warn = $a670ecbae0a62090$var$wrapConsoleMethod("warn");
    invariant.error = $a670ecbae0a62090$var$wrapConsoleMethod("error");
})($a670ecbae0a62090$export$f5708dca728d7177 || ($a670ecbae0a62090$export$f5708dca728d7177 = {}));
function $a670ecbae0a62090$export$a80e09f2cd325fb8(level) {
    var old = $a670ecbae0a62090$var$verbosityLevels[$a670ecbae0a62090$var$verbosityLevel];
    $a670ecbae0a62090$var$verbosityLevel = Math.max(0, $a670ecbae0a62090$var$verbosityLevels.indexOf(level));
    return old;
}
var $a670ecbae0a62090$export$2e2bcd8739ae039 = $a670ecbae0a62090$export$f5708dca728d7177;


function $bb6005294753e564$export$f8b8b9ce72e9ccbf(thunk) {
    try {
        return thunk();
    } catch (_a) {}
}


var $294cc824aee3c75e$export$2e2bcd8739ae039 = (0, $bb6005294753e564$export$f8b8b9ce72e9ccbf)(function() {
    return globalThis;
}) || (0, $bb6005294753e564$export$f8b8b9ce72e9ccbf)(function() {
    return window;
}) || (0, $bb6005294753e564$export$f8b8b9ce72e9ccbf)(function() {
    return self;
}) || (0, $bb6005294753e564$export$f8b8b9ce72e9ccbf)(function() {
    return $parcel$global;
}) || (0, $bb6005294753e564$export$f8b8b9ce72e9ccbf)(function() {
    return (0, $bb6005294753e564$export$f8b8b9ce72e9ccbf).constructor("return this")();
});



var $a3e0e388557fc46f$var$__ = "__";
var $a3e0e388557fc46f$var$GLOBAL_KEY = [
    $a3e0e388557fc46f$var$__,
    $a3e0e388557fc46f$var$__
].join("DEV");
function $a3e0e388557fc46f$var$getDEV() {
    try {
        return Boolean(__DEV__);
    } catch (_a) {
        Object.defineProperty((0, $294cc824aee3c75e$export$2e2bcd8739ae039), $a3e0e388557fc46f$var$GLOBAL_KEY, {
            value: (0, $bb6005294753e564$export$f8b8b9ce72e9ccbf)(function() {
                return "production";
            }) !== "production",
            enumerable: false,
            configurable: true,
            writable: true
        });
        return (0, $294cc824aee3c75e$export$2e2bcd8739ae039)[$a3e0e388557fc46f$var$GLOBAL_KEY];
    }
}
var $a3e0e388557fc46f$export$2e2bcd8739ae039 = $a3e0e388557fc46f$var$getDEV();



var $e67mm = parcelRequire("e67mm");
function $d97e388384da3846$var$maybe(thunk) {
    try {
        return thunk();
    } catch (_) {}
}
var $d97e388384da3846$var$safeGlobal = $d97e388384da3846$var$maybe(function() {
    return globalThis;
}) || $d97e388384da3846$var$maybe(function() {
    return window;
}) || $d97e388384da3846$var$maybe(function() {
    return self;
}) || $d97e388384da3846$var$maybe(function() {
    return $parcel$global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
$d97e388384da3846$var$maybe(function() {
    return $d97e388384da3846$var$maybe.constructor("return this")();
});
var $d97e388384da3846$var$needToRemove = false;
function $d97e388384da3846$export$4b3e715f166fdd78() {
    if ($d97e388384da3846$var$safeGlobal && !$d97e388384da3846$var$maybe(function() {
        return "production";
    }) && !$d97e388384da3846$var$maybe(function() {
        return $e67mm;
    })) {
        Object.defineProperty($d97e388384da3846$var$safeGlobal, "process", {
            value: {
                env: {
                    // This default needs to be "production" instead of "development", to
                    // avoid the problem https://github.com/graphql/graphql-js/pull/2894
                    // will eventually solve, once merged and released.
                    NODE_ENV: "production"
                }
            },
            // Let anyone else change global.process as they see fit, but hide it from
            // Object.keys(global) enumeration.
            configurable: true,
            enumerable: false,
            writable: true
        });
        $d97e388384da3846$var$needToRemove = true;
    }
}
// Call install() at least once, when this module is imported.
$d97e388384da3846$export$4b3e715f166fdd78();
function $d97e388384da3846$export$cd7f480d6b8286c3() {
    if ($d97e388384da3846$var$needToRemove) {
        delete $d97e388384da3846$var$safeGlobal.process;
        $d97e388384da3846$var$needToRemove = false;
    }
}


function $6ea5346a534b6bc4$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


const $1e7075d15644e1ea$var$MAX_ARRAY_LENGTH = 10;
const $1e7075d15644e1ea$var$MAX_RECURSIVE_DEPTH = 2;
function $1e7075d15644e1ea$export$9dec5d1b3b6a130d(value) {
    return $1e7075d15644e1ea$var$formatValue(value, []);
}
function $1e7075d15644e1ea$var$formatValue(value, seenValues) {
    switch(typeof value){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? `[function ${value.name}]` : "[function]";
        case "object":
            return $1e7075d15644e1ea$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $1e7075d15644e1ea$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return "null";
    if (previouslySeenValues.includes(value)) return "[Circular]";
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($1e7075d15644e1ea$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === "string" ? jsonValue : $1e7075d15644e1ea$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $1e7075d15644e1ea$var$formatArray(value, seenValues);
    return $1e7075d15644e1ea$var$formatObject(value, seenValues);
}
function $1e7075d15644e1ea$var$isJSONable(value) {
    return typeof value.toJSON === "function";
}
function $1e7075d15644e1ea$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return "{}";
    if (seenValues.length > $1e7075d15644e1ea$var$MAX_RECURSIVE_DEPTH) return "[" + $1e7075d15644e1ea$var$getObjectTag(object) + "]";
    const properties = entries.map(([key, value])=>key + ": " + $1e7075d15644e1ea$var$formatValue(value, seenValues));
    return "{ " + properties.join(", ") + " }";
}
function $1e7075d15644e1ea$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $1e7075d15644e1ea$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    const len = Math.min($1e7075d15644e1ea$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($1e7075d15644e1ea$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return "[" + items.join(", ") + "]";
}
function $1e7075d15644e1ea$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        const name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}



const $74008284450d2feb$export$ca03416d6c9e029e = function instanceOf(value, constructor) {
    return value instanceof constructor;
};


class $c4ec1a2fa1401965$export$1d2df86270c81ecb {
    constructor(body, name = "GraphQL request", locationOffset = {
        line: 1,
        column: 1
    }){
        typeof body === "string" || (0, $6ea5346a534b6bc4$export$b6cb5906f04696c8)(false, `Body must be a string. Received: ${(0, $1e7075d15644e1ea$export$9dec5d1b3b6a130d)(body)}.`);
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $6ea5346a534b6bc4$export$b6cb5906f04696c8)(false, "line in locationOffset is 1-indexed and must be positive.");
        this.locationOffset.column > 0 || (0, $6ea5346a534b6bc4$export$b6cb5906f04696c8)(false, "column in locationOffset is 1-indexed and must be positive.");
    }
    get [Symbol.toStringTag]() {
        return "Source";
    }
}
function $c4ec1a2fa1401965$export$75135ee9ed6e435b(source) {
    return (0, $74008284450d2feb$export$ca03416d6c9e029e)(source, $c4ec1a2fa1401965$export$1d2df86270c81ecb);
}


function $bb2005374e0eda76$export$645629cf60cf5775() {
    return typeof (0, $c4ec1a2fa1401965$export$1d2df86270c81ecb) === "function" ? (0, $d97e388384da3846$export$cd7f480d6b8286c3)() : (0, $d97e388384da3846$export$cd7f480d6b8286c3)();
}




function $afc44bd9db1b27be$export$94b45febe34b7938() {
    __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)("boolean" === typeof (0, $a3e0e388557fc46f$export$2e2bcd8739ae039), (0, $a3e0e388557fc46f$export$2e2bcd8739ae039)) : (0, $a670ecbae0a62090$export$f5708dca728d7177)("boolean" === typeof (0, $a3e0e388557fc46f$export$2e2bcd8739ae039), 39);
}
(0, $bb2005374e0eda76$export$645629cf60cf5775)();
$afc44bd9db1b27be$export$94b45febe34b7938();




function $665f4cdbf299a5bf$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $665f4cdbf299a5bf$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $665f4cdbf299a5bf$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $665f4cdbf299a5bf$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $665f4cdbf299a5bf$var$_arrayLikeToArray(o, minLen);
}
function $665f4cdbf299a5bf$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $665f4cdbf299a5bf$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $665f4cdbf299a5bf$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $665f4cdbf299a5bf$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $665f4cdbf299a5bf$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// === Symbol Support ===
var $665f4cdbf299a5bf$var$hasSymbols = function() {
    return typeof Symbol === "function";
};
var $665f4cdbf299a5bf$var$hasSymbol = function(name) {
    return $665f4cdbf299a5bf$var$hasSymbols() && Boolean(Symbol[name]);
};
var $665f4cdbf299a5bf$var$getSymbol = function(name) {
    return $665f4cdbf299a5bf$var$hasSymbol(name) ? Symbol[name] : "@@" + name;
};
if ($665f4cdbf299a5bf$var$hasSymbols() && !$665f4cdbf299a5bf$var$hasSymbol("observable")) Symbol.observable = Symbol("observable");
var $665f4cdbf299a5bf$var$SymbolIterator = $665f4cdbf299a5bf$var$getSymbol("iterator");
var $665f4cdbf299a5bf$var$SymbolObservable = $665f4cdbf299a5bf$var$getSymbol("observable");
var $665f4cdbf299a5bf$var$SymbolSpecies = $665f4cdbf299a5bf$var$getSymbol("species"); // === Abstract Operations ===
function $665f4cdbf299a5bf$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== "function") throw new TypeError(value + " is not a function");
    return value;
}
function $665f4cdbf299a5bf$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$665f4cdbf299a5bf$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $665f4cdbf299a5bf$export$77cea355fa80b5f4;
}
function $665f4cdbf299a5bf$var$isObservable(x) {
    return x instanceof $665f4cdbf299a5bf$export$77cea355fa80b5f4; // SPEC: Brand check
}
function $665f4cdbf299a5bf$var$hostReportError(e) {
    if ($665f4cdbf299a5bf$var$hostReportError.log) $665f4cdbf299a5bf$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $665f4cdbf299a5bf$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $665f4cdbf299a5bf$var$hostReportError(e);
        }
    });
}
function $665f4cdbf299a5bf$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === "function") cleanup();
        else {
            var unsubscribe = $665f4cdbf299a5bf$var$getMethod(cleanup, "unsubscribe");
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $665f4cdbf299a5bf$var$hostReportError(e);
    }
}
function $665f4cdbf299a5bf$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = "closed";
}
function $665f4cdbf299a5bf$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = "ready";
    for(var i = 0; i < queue.length; ++i){
        $665f4cdbf299a5bf$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === "closed") break;
    }
}
function $665f4cdbf299a5bf$var$notifySubscription(subscription, type, value) {
    subscription._state = "running";
    var observer = subscription._observer;
    try {
        var m = $665f4cdbf299a5bf$var$getMethod(observer, type);
        switch(type){
            case "next":
                if (m) m.call(observer, value);
                break;
            case "error":
                $665f4cdbf299a5bf$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case "complete":
                $665f4cdbf299a5bf$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $665f4cdbf299a5bf$var$hostReportError(e);
    }
    if (subscription._state === "closed") $665f4cdbf299a5bf$var$cleanupSubscription(subscription);
    else if (subscription._state === "running") subscription._state = "ready";
}
function $665f4cdbf299a5bf$var$onNotify(subscription, type, value) {
    if (subscription._state === "closed") return;
    if (subscription._state === "buffering") {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== "ready") {
        subscription._state = "buffering";
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $665f4cdbf299a5bf$var$enqueue(function() {
            return $665f4cdbf299a5bf$var$flushSubscription(subscription);
        });
        return;
    }
    $665f4cdbf299a5bf$var$notifySubscription(subscription, type, value);
}
var $665f4cdbf299a5bf$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = "initializing";
        var subscriptionObserver = new $665f4cdbf299a5bf$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === "initializing") this._state = "ready";
    }
    var _proto = Subscription.prototype;
    _proto.unsubscribe = function unsubscribe() {
        if (this._state !== "closed") {
            $665f4cdbf299a5bf$var$closeSubscription(this);
            $665f4cdbf299a5bf$var$cleanupSubscription(this);
        }
    };
    $665f4cdbf299a5bf$var$_createClass(Subscription, [
        {
            key: "closed",
            get: function() {
                return this._state === "closed";
            }
        }
    ]);
    return Subscription;
}();
var $665f4cdbf299a5bf$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    var _proto2 = SubscriptionObserver.prototype;
    _proto2.next = function next(value) {
        $665f4cdbf299a5bf$var$onNotify(this._subscription, "next", value);
    };
    _proto2.error = function error(value) {
        $665f4cdbf299a5bf$var$onNotify(this._subscription, "error", value);
    };
    _proto2.complete = function complete() {
        $665f4cdbf299a5bf$var$onNotify(this._subscription, "complete");
    };
    $665f4cdbf299a5bf$var$_createClass(SubscriptionObserver, [
        {
            key: "closed",
            get: function() {
                return this._subscription._state === "closed";
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $665f4cdbf299a5bf$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        if (!(this instanceof Observable)) throw new TypeError("Observable cannot be called as a function");
        if (typeof subscriber !== "function") throw new TypeError("Observable initializer must be a function");
        this._subscriber = subscriber;
    }
    var _proto3 = Observable.prototype;
    _proto3.subscribe = function subscribe(observer) {
        if (typeof observer !== "object" || observer === null) observer = {
            next: observer,
            error: arguments[1],
            complete: arguments[2]
        };
        return new $665f4cdbf299a5bf$var$Subscription(observer, this._subscriber);
    };
    _proto3.forEach = function forEach(fn) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            if (typeof fn !== "function") {
                reject(new TypeError(fn + " is not a function"));
                return;
            }
            function done() {
                subscription.unsubscribe();
                resolve();
            }
            var subscription = _this.subscribe({
                next: function(value) {
                    try {
                        fn(value, done);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    _proto3.map = function map(fn) {
        var _this2 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = $665f4cdbf299a5bf$var$getSpecies(this);
        return new C(function(observer) {
            return _this2.subscribe({
                next: function(value) {
                    try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.filter = function filter(fn) {
        var _this3 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = $665f4cdbf299a5bf$var$getSpecies(this);
        return new C(function(observer) {
            return _this3.subscribe({
                next: function(value) {
                    try {
                        if (!fn(value)) return;
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.reduce = function reduce(fn) {
        var _this4 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = $665f4cdbf299a5bf$var$getSpecies(this);
        var hasSeed = arguments.length > 1;
        var hasValue = false;
        var seed = arguments[1];
        var acc = seed;
        return new C(function(observer) {
            return _this4.subscribe({
                next: function(value) {
                    var first = !hasValue;
                    hasValue = true;
                    if (!first || hasSeed) try {
                        acc = fn(acc, value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    else acc = value;
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    if (!hasValue && !hasSeed) return observer.error(new TypeError("Cannot reduce an empty sequence"));
                    observer.next(acc);
                    observer.complete();
                }
            });
        });
    };
    _proto3.concat = function concat() {
        var _this5 = this;
        for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
        var C = $665f4cdbf299a5bf$var$getSpecies(this);
        return new C(function(observer) {
            var subscription;
            var index = 0;
            function startNext(next) {
                subscription = next.subscribe({
                    next: function(v) {
                        observer.next(v);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (index === sources.length) {
                            subscription = undefined;
                            observer.complete();
                        } else startNext(C.from(sources[index++]));
                    }
                });
            }
            startNext(_this5);
            return function() {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        });
    };
    _proto3.flatMap = function flatMap(fn) {
        var _this6 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = $665f4cdbf299a5bf$var$getSpecies(this);
        return new C(function(observer) {
            var subscriptions = [];
            var outer = _this6.subscribe({
                next: function(value) {
                    if (fn) try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    var inner = C.from(value).subscribe({
                        next: function(value) {
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            var i = subscriptions.indexOf(inner);
                            if (i >= 0) subscriptions.splice(i, 1);
                            completeIfDone();
                        }
                    });
                    subscriptions.push(inner);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    completeIfDone();
                }
            });
            function completeIfDone() {
                if (outer.closed && subscriptions.length === 0) observer.complete();
            }
            return function() {
                subscriptions.forEach(function(s) {
                    return s.unsubscribe();
                });
                outer.unsubscribe();
            };
        });
    };
    _proto3[$665f4cdbf299a5bf$var$SymbolObservable] = function() {
        return this;
    };
    Observable.from = function from(x) {
        var C = typeof this === "function" ? this : Observable;
        if (x == null) throw new TypeError(x + " is not an object");
        var method = $665f4cdbf299a5bf$var$getMethod(x, $665f4cdbf299a5bf$var$SymbolObservable);
        if (method) {
            var observable = method.call(x);
            if (Object(observable) !== observable) throw new TypeError(observable + " is not an object");
            if ($665f4cdbf299a5bf$var$isObservable(observable) && observable.constructor === C) return observable;
            return new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        if ($665f4cdbf299a5bf$var$hasSymbol("iterator")) {
            method = $665f4cdbf299a5bf$var$getMethod(x, $665f4cdbf299a5bf$var$SymbolIterator);
            if (method) return new C(function(observer) {
                $665f4cdbf299a5bf$var$enqueue(function() {
                    if (observer.closed) return;
                    for(var _iterator = $665f4cdbf299a5bf$var$_createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;){
                        var item = _step.value;
                        observer.next(item);
                        if (observer.closed) return;
                    }
                    observer.complete();
                });
            });
        }
        if (Array.isArray(x)) return new C(function(observer) {
            $665f4cdbf299a5bf$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < x.length; ++i){
                    observer.next(x[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
        throw new TypeError(x + " is not observable");
    };
    Observable.of = function of() {
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        var C = typeof this === "function" ? this : Observable;
        return new C(function(observer) {
            $665f4cdbf299a5bf$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < items.length; ++i){
                    observer.next(items[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
    };
    $665f4cdbf299a5bf$var$_createClass(Observable, null, [
        {
            key: $665f4cdbf299a5bf$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
if ($665f4cdbf299a5bf$var$hasSymbols()) Object.defineProperty($665f4cdbf299a5bf$export$77cea355fa80b5f4, Symbol("extensions"), {
    value: {
        symbol: $665f4cdbf299a5bf$var$SymbolObservable,
        hostReportError: $665f4cdbf299a5bf$var$hostReportError
    },
    configurable: true
});


parcelRequire("67qMW");
var $be6d375bf7bd710f$var$prototype = (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4).prototype;
var $be6d375bf7bd710f$var$fakeObsSymbol = "@@observable";
if (!$be6d375bf7bd710f$var$prototype[$be6d375bf7bd710f$var$fakeObsSymbol]) $be6d375bf7bd710f$var$prototype[$be6d375bf7bd710f$var$fakeObsSymbol] = function() {
    return this;
};



function $f5854d48e3d1c51d$export$f29bedd62f56fcb2(starting, operation) {
    var context = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, starting);
    var setContext = function(next) {
        if (typeof next === "function") context = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, context), next(context));
        else context = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, context), next);
    };
    var getContext = function() {
        return (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, context);
    };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext
    });
    return operation;
}



function $450e50257530cd67$export$417207af72fad9c9(obj) {
    return obj !== null && typeof obj === "object";
}




function $f80c7baa4263f96d$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === "OperationDefinition") throw __DEV__ ? new (0, $a670ecbae0a62090$export$cea12affaee22fe8)("Found a ".concat(definition.operation, " operation").concat(definition.name ? " named '".concat(definition.name.value, "'") : "", ". ") + "No operations are allowed when using a fragment as a query. Only fragments are allowed.") : new (0, $a670ecbae0a62090$export$cea12affaee22fe8)(44);
        if (definition.kind === "FragmentDefinition") fragments.push(definition);
    });
    if (typeof actualFragmentName === "undefined") {
        __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(fragments.length === 1, "Found ".concat(fragments.length, " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.")) : (0, $a670ecbae0a62090$export$f5708dca728d7177)(fragments.length === 1, 45);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, document), {
        definitions: (0, $1aaf9c65fb7afb7d$export$1216008129fb82ed)([
            {
                kind: "OperationDefinition",
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions, true)
    });
    return query;
}
function $f80c7baa4263f96d$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $f80c7baa4263f96d$export$f80bdb85f299186(selection, fragmentMap) {
    switch(selection.kind){
        case "InlineFragment":
            return selection;
        case "FragmentSpread":
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") return fragmentMap(fragmentName);
            var fragment = fragmentMap && fragmentMap[fragmentName];
            __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(fragment, "No fragment named ".concat(fragmentName)) : (0, $a670ecbae0a62090$export$f5708dca728d7177)(fragment, 46);
            return fragment || null;
        default:
            return null;
    }
}


function $5763c7b47888ba33$export$634ae0e932e9be99(id) {
    return {
        __ref: String(id)
    };
}
function $5763c7b47888ba33$export$fa99cac1c0883c47(obj) {
    return Boolean(obj && typeof obj === "object" && typeof obj.__ref === "string");
}
function $5763c7b47888ba33$export$540432d49fcec6c9(value) {
    return (0, $450e50257530cd67$export$417207af72fad9c9)(value) && value.kind === "Document" && Array.isArray(value.definitions);
}
function $5763c7b47888ba33$var$isStringValue(value) {
    return value.kind === "StringValue";
}
function $5763c7b47888ba33$var$isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function $5763c7b47888ba33$var$isIntValue(value) {
    return value.kind === "IntValue";
}
function $5763c7b47888ba33$var$isFloatValue(value) {
    return value.kind === "FloatValue";
}
function $5763c7b47888ba33$var$isVariable(value) {
    return value.kind === "Variable";
}
function $5763c7b47888ba33$var$isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function $5763c7b47888ba33$var$isListValue(value) {
    return value.kind === "ListValue";
}
function $5763c7b47888ba33$var$isEnumValue(value) {
    return value.kind === "EnumValue";
}
function $5763c7b47888ba33$var$isNullValue(value) {
    return value.kind === "NullValue";
}
function $5763c7b47888ba33$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($5763c7b47888ba33$var$isIntValue(value) || $5763c7b47888ba33$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($5763c7b47888ba33$var$isBooleanValue(value) || $5763c7b47888ba33$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($5763c7b47888ba33$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $5763c7b47888ba33$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($5763c7b47888ba33$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($5763c7b47888ba33$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $5763c7b47888ba33$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($5763c7b47888ba33$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($5763c7b47888ba33$var$isNullValue(value)) argObj[name.value] = null;
    else throw __DEV__ ? new (0, $a670ecbae0a62090$export$cea12affaee22fe8)('The inline argument "'.concat(name.value, '" of kind "').concat(value.kind, '"') + "is not supported. Use variables instead of inline arguments to " + "overcome this limitation.") : new (0, $a670ecbae0a62090$export$cea12affaee22fe8)(55);
}
function $5763c7b47888ba33$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $5763c7b47888ba33$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $5763c7b47888ba33$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $5763c7b47888ba33$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $5763c7b47888ba33$var$KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export"
];
var $5763c7b47888ba33$export$3cdb6c178b88cabe = Object.assign(function(fieldName, args, directives) {
    if (args && directives && directives["connection"] && directives["connection"]["key"]) {
        if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives["connection"]["key"], "(").concat($5763c7b47888ba33$var$stringify(filteredArgs_1), ")");
        } else return directives["connection"]["key"];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = $5763c7b47888ba33$var$stringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($5763c7b47888ba33$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@".concat(key, "(").concat($5763c7b47888ba33$var$stringify(directives[key]), ")");
        else completeFieldName += "@".concat(key);
    });
    return completeFieldName;
}, {
    setStringify: function(s) {
        var previous = $5763c7b47888ba33$var$stringify;
        $5763c7b47888ba33$var$stringify = s;
        return previous;
    }
});
var $5763c7b47888ba33$var$stringify = function defaultStringify(value) {
    return JSON.stringify(value, $5763c7b47888ba33$var$stringifyReplacer);
};
function $5763c7b47888ba33$var$stringifyReplacer(_key, value) {
    if ((0, $450e50257530cd67$export$417207af72fad9c9)(value) && !Array.isArray(value)) value = Object.keys(value).sort().reduce(function(copy, key) {
        copy[key] = value[key];
        return copy;
    }, {});
    return value;
}
function $5763c7b47888ba33$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $5763c7b47888ba33$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $5763c7b47888ba33$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $5763c7b47888ba33$export$cf7bf7e4f289cc26(result, selectionSet, fragmentMap) {
    var fragments;
    for(var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++){
        var selection = _a[_i];
        if ($5763c7b47888ba33$export$fb56ad75dd311c12(selection)) {
            if (selection.name.value === "__typename") return result[$5763c7b47888ba33$export$7d1ad22471852218(selection)];
        } else if (fragments) fragments.push(selection);
        else fragments = [
            selection
        ];
    }
    if (typeof result.__typename === "string") return result.__typename;
    if (fragments) for(var _b = 0, fragments_1 = fragments; _b < fragments_1.length; _b++){
        var selection = fragments_1[_b];
        var typename = $5763c7b47888ba33$export$cf7bf7e4f289cc26(result, (0, $f80c7baa4263f96d$export$f80bdb85f299186)(selection, fragmentMap).selectionSet, fragmentMap);
        if (typeof typename === "string") return typename;
    }
}
function $5763c7b47888ba33$export$fb56ad75dd311c12(selection) {
    return selection.kind === "Field";
}
function $5763c7b47888ba33$export$22a1cdafaf27bcff(selection) {
    return selection.kind === "InlineFragment";
}


function $91fde6eb370810ac$export$a7d0d8111d2386df(doc) {
    __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(doc && doc.kind === "Document", 'Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql') : (0, $a670ecbae0a62090$export$f5708dca728d7177)(doc && doc.kind === "Document", 47);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== "FragmentDefinition";
    }).map(function(definition) {
        if (definition.kind !== "OperationDefinition") throw __DEV__ ? new (0, $a670ecbae0a62090$export$cea12affaee22fe8)('Schema type definitions not allowed in queries. Found: "'.concat(definition.kind, '"')) : new (0, $a670ecbae0a62090$export$cea12affaee22fe8)(48);
        return definition;
    });
    __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(operations.length <= 1, "Ambiguous GraphQL document: contains ".concat(operations.length, " operations")) : (0, $a670ecbae0a62090$export$f5708dca728d7177)(operations.length <= 1, 49);
    return doc;
}
function $91fde6eb370810ac$export$7a5b1fa979d2c158(doc) {
    $91fde6eb370810ac$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function $91fde6eb370810ac$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && !!definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $91fde6eb370810ac$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function $91fde6eb370810ac$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $91fde6eb370810ac$export$7a5b1fa979d2c158(doc);
    __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(queryDef && queryDef.operation === "query", "Must contain a query definition.") : (0, $a670ecbae0a62090$export$f5708dca728d7177)(queryDef && queryDef.operation === "query", 50);
    return queryDef;
}
function $91fde6eb370810ac$export$772111caef41b3f5(doc) {
    __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(doc.kind === "Document", 'Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql') : (0, $a670ecbae0a62090$export$f5708dca728d7177)(doc.kind === "Document", 51);
    __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(doc.definitions.length <= 1, "Fragment must have exactly one definition.") : (0, $a670ecbae0a62090$export$f5708dca728d7177)(doc.definitions.length <= 1, 52);
    var fragmentDef = doc.definitions[0];
    __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(fragmentDef.kind === "FragmentDefinition", "Must be a fragment definition.") : (0, $a670ecbae0a62090$export$f5708dca728d7177)(fragmentDef.kind === "FragmentDefinition", 53);
    return fragmentDef;
}
function $91fde6eb370810ac$export$f431198736b7f96d(queryDoc) {
    $91fde6eb370810ac$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" || operation === "mutation" || operation === "subscription") return definition;
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw __DEV__ ? new (0, $a670ecbae0a62090$export$cea12affaee22fe8)("Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.") : new (0, $a670ecbae0a62090$export$cea12affaee22fe8)(54);
}
function $91fde6eb370810ac$export$84c19026e616569e(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) defs.forEach(function(def) {
        if (def.defaultValue) (0, $5763c7b47888ba33$export$a1dab82d368d6525)(defaultValues, def.variable.name, def.defaultValue);
    });
    return defaultValues;
}


function $5ddb67c715765379$export$4f3f7df1b558c729(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== "string" ? (0, $91fde6eb370810ac$export$41bca9dc6871dd4e)(transformedOperation.query) || undefined : "";
    return transformedOperation;
}


function $5a570eff44499bdc$export$a92a48117d546c9(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context"
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw __DEV__ ? new (0, $a670ecbae0a62090$export$cea12affaee22fe8)("illegal argument: ".concat(key)) : new (0, $a670ecbae0a62090$export$cea12affaee22fe8)(27);
    }
    return operation;
}


function $29b9899e03084364$var$passthrough(op, forward) {
    return forward ? forward(op) : (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4).of();
}
function $29b9899e03084364$var$toLink(handler) {
    return typeof handler === "function" ? new $29b9899e03084364$export$2fed3d61f740bc7f(handler) : handler;
}
function $29b9899e03084364$var$isTerminating(link) {
    return link.request.length <= 1;
}
var $29b9899e03084364$var$LinkError = function(_super) {
    (0, $1aaf9c65fb7afb7d$export$a8ba968b8961cb8a)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
var $29b9899e03084364$export$2fed3d61f740bc7f = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.empty = function() {
        return new ApolloLink(function() {
            return (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4).of();
        });
    };
    ApolloLink.from = function(links) {
        if (links.length === 0) return ApolloLink.empty();
        return links.map($29b9899e03084364$var$toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    };
    ApolloLink.split = function(test, left, right) {
        var leftLink = $29b9899e03084364$var$toLink(left);
        var rightLink = $29b9899e03084364$var$toLink(right || new ApolloLink($29b9899e03084364$var$passthrough));
        if ($29b9899e03084364$var$isTerminating(leftLink) && $29b9899e03084364$var$isTerminating(rightLink)) return new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4).of() : rightLink.request(operation) || (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4).of() : rightLink.request(operation, forward) || (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4).of();
        });
    };
    ApolloLink.execute = function(link, operation) {
        return link.request((0, $f5854d48e3d1c51d$export$f29bedd62f56fcb2)(operation.context, (0, $5ddb67c715765379$export$4f3f7df1b558c729)((0, $5a570eff44499bdc$export$a92a48117d546c9)(operation)))) || (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4).of();
    };
    ApolloLink.concat = function(first, second) {
        var firstLink = $29b9899e03084364$var$toLink(first);
        if ($29b9899e03084364$var$isTerminating(firstLink)) {
            __DEV__ && (0, $a670ecbae0a62090$export$f5708dca728d7177).warn(new $29b9899e03084364$var$LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
            return firstLink;
        }
        var nextLink = $29b9899e03084364$var$toLink(second);
        if ($29b9899e03084364$var$isTerminating(nextLink)) return new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4).of();
            }) || (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4).of();
            }) || (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4).of();
        });
    };
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink($29b9899e03084364$var$passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw __DEV__ ? new (0, $a670ecbae0a62090$export$cea12affaee22fe8)("request is not implemented") : new (0, $a670ecbae0a62090$export$cea12affaee22fe8)(22);
    };
    ApolloLink.prototype.onError = function(error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            return false;
        }
        throw error;
    };
    ApolloLink.prototype.setOnError = function(fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}();


var $ec7e7c0e19838dfc$export$51396ec711da548b = (0, $29b9899e03084364$export$2fed3d61f740bc7f).execute;


var $108da7bfe799aabe$export$83d89fbfd8236492 = "3.7.15";








/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $90cc3a02f3208803$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return "Location";
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $90cc3a02f3208803$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return "Token";
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $90cc3a02f3208803$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
const $90cc3a02f3208803$var$kindValues = new Set(Object.keys($90cc3a02f3208803$export$4fcd777a40ccf407));
function $90cc3a02f3208803$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === "string" && $90cc3a02f3208803$var$kindValues.has(maybeKind);
}
/** Name */ var $90cc3a02f3208803$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode["QUERY"] = "query";
    OperationTypeNode["MUTATION"] = "mutation";
    OperationTypeNode["SUBSCRIPTION"] = "subscription";
})($90cc3a02f3208803$export$f58c50edb4aef9d4 || ($90cc3a02f3208803$export$f58c50edb4aef9d4 = {}));


/**
 * The set of allowed kind values for AST nodes.
 */ var $5a7bd784209d2d45$export$a84bdc57c5122798;
(function(Kind) {
    Kind["NAME"] = "Name";
    Kind["DOCUMENT"] = "Document";
    Kind["OPERATION_DEFINITION"] = "OperationDefinition";
    Kind["VARIABLE_DEFINITION"] = "VariableDefinition";
    Kind["SELECTION_SET"] = "SelectionSet";
    Kind["FIELD"] = "Field";
    Kind["ARGUMENT"] = "Argument";
    Kind["FRAGMENT_SPREAD"] = "FragmentSpread";
    Kind["INLINE_FRAGMENT"] = "InlineFragment";
    Kind["FRAGMENT_DEFINITION"] = "FragmentDefinition";
    Kind["VARIABLE"] = "Variable";
    Kind["INT"] = "IntValue";
    Kind["FLOAT"] = "FloatValue";
    Kind["STRING"] = "StringValue";
    Kind["BOOLEAN"] = "BooleanValue";
    Kind["NULL"] = "NullValue";
    Kind["ENUM"] = "EnumValue";
    Kind["LIST"] = "ListValue";
    Kind["OBJECT"] = "ObjectValue";
    Kind["OBJECT_FIELD"] = "ObjectField";
    Kind["DIRECTIVE"] = "Directive";
    Kind["NAMED_TYPE"] = "NamedType";
    Kind["LIST_TYPE"] = "ListType";
    Kind["NON_NULL_TYPE"] = "NonNullType";
    Kind["SCHEMA_DEFINITION"] = "SchemaDefinition";
    Kind["OPERATION_TYPE_DEFINITION"] = "OperationTypeDefinition";
    Kind["SCALAR_TYPE_DEFINITION"] = "ScalarTypeDefinition";
    Kind["OBJECT_TYPE_DEFINITION"] = "ObjectTypeDefinition";
    Kind["FIELD_DEFINITION"] = "FieldDefinition";
    Kind["INPUT_VALUE_DEFINITION"] = "InputValueDefinition";
    Kind["INTERFACE_TYPE_DEFINITION"] = "InterfaceTypeDefinition";
    Kind["UNION_TYPE_DEFINITION"] = "UnionTypeDefinition";
    Kind["ENUM_TYPE_DEFINITION"] = "EnumTypeDefinition";
    Kind["ENUM_VALUE_DEFINITION"] = "EnumValueDefinition";
    Kind["INPUT_OBJECT_TYPE_DEFINITION"] = "InputObjectTypeDefinition";
    Kind["DIRECTIVE_DEFINITION"] = "DirectiveDefinition";
    Kind["SCHEMA_EXTENSION"] = "SchemaExtension";
    Kind["SCALAR_TYPE_EXTENSION"] = "ScalarTypeExtension";
    Kind["OBJECT_TYPE_EXTENSION"] = "ObjectTypeExtension";
    Kind["INTERFACE_TYPE_EXTENSION"] = "InterfaceTypeExtension";
    Kind["UNION_TYPE_EXTENSION"] = "UnionTypeExtension";
    Kind["ENUM_TYPE_EXTENSION"] = "EnumTypeExtension";
    Kind["INPUT_OBJECT_TYPE_EXTENSION"] = "InputObjectTypeExtension";
})($5a7bd784209d2d45$export$a84bdc57c5122798 || ($5a7bd784209d2d45$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 

const $5df15baf989f8f0b$export$a89c95c098ac2a58 = Object.freeze({});
function $5df15baf989f8f0b$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $90cc3a02f3208803$export$4fcd777a40ccf407)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $5a7bd784209d2d45$export$a84bdc57c5122798)))enterLeaveMap.set(kind, $5df15baf989f8f0b$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $90cc3a02f3208803$export$8ee0fc9ee280b4ee)(node) || (0, $6ea5346a534b6bc4$export$b6cb5906f04696c8)(false, `Invalid AST Node: ${(0, $1e7075d15644e1ea$export$9dec5d1b3b6a130d)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $5df15baf989f8f0b$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $90cc3a02f3208803$export$8ee0fc9ee280b4ee)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $5df15baf989f8f0b$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $5a7bd784209d2d45$export$a84bdc57c5122798))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter , leave: leave  } = $5df15baf989f8f0b$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $5df15baf989f8f0b$export$a89c95c098ac2a58) skipping[i] = $5df15baf989f8f0b$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $5df15baf989f8f0b$export$a89c95c098ac2a58) skipping[i] = $5df15baf989f8f0b$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $5df15baf989f8f0b$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === "object") // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === "function") // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $5df15baf989f8f0b$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter , leave: leave  } = $5df15baf989f8f0b$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}





function $62aba4d864227324$export$3dc388a5f013b4a5(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) return true;
    return $62aba4d864227324$export$b7bdffb7e6f1ef53(directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue = variables && variables[ifArgument.value.name.value];
            __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(evaledValue !== void 0, "Invalid variable referenced in @".concat(directive.name.value, " directive.")) : (0, $a670ecbae0a62090$export$f5708dca728d7177)(evaledValue !== void 0, 40);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function $62aba4d864227324$export$1b217de6ce18b9a(root) {
    var names = [];
    (0, $5df15baf989f8f0b$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
var $62aba4d864227324$export$528b5e7d8ba07fbf = function(names, root) {
    return $62aba4d864227324$export$2dafb573e282fe8d(names, root, false);
};
var $62aba4d864227324$export$ad1b63b26c1a9b76 = function(names, root) {
    return $62aba4d864227324$export$2dafb573e282fe8d(names, root, true);
};
function $62aba4d864227324$export$2dafb573e282fe8d(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0, $5df15baf989f8f0b$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) return 0, $5df15baf989f8f0b$export$a89c95c098ac2a58;
        }
    });
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function $62aba4d864227324$export$8d1e9e5bbfa5d09a(document) {
    return document && $62aba4d864227324$export$2dafb573e282fe8d([
        "client",
        "export"
    ], document, true);
}
function $62aba4d864227324$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === "skip" || value === "include";
}
function $62aba4d864227324$export$b7bdffb7e6f1ef53(directives) {
    var result = [];
    if (directives && directives.length) directives.forEach(function(directive) {
        if (!$62aba4d864227324$var$isInclusionDirective(directive)) return;
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(directiveArguments && directiveArguments.length === 1, "Incorrect number of arguments for the @".concat(directiveName, " directive.")) : (0, $a670ecbae0a62090$export$f5708dca728d7177)(directiveArguments && directiveArguments.length === 1, 41);
        var ifArgument = directiveArguments[0];
        __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(ifArgument.name && ifArgument.name.value === "if", "Invalid argument for the @".concat(directiveName, " directive.")) : (0, $a670ecbae0a62090$export$f5708dca728d7177)(ifArgument.name && ifArgument.name.value === "if", 42);
        var ifValue = ifArgument.value;
        __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), "Argument for the @".concat(directiveName, " directive must be a variable or a boolean value.")) : (0, $a670ecbae0a62090$export$f5708dca728d7177)(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 43);
        result.push({
            directive: directive,
            ifArgument: ifArgument
        });
    });
    return result;
}



var $3b06e88edcf47dda$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = __DEV__ ? new (0, $a670ecbae0a62090$export$cea12affaee22fe8)("Network request failed. ".concat(label, " is not serializable: ").concat(e.message)) : new (0, $a670ecbae0a62090$export$cea12affaee22fe8)(24);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};


var $2ccabe2f3fc74e73$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === "function") return fallbackURI(operation);
    else return fallbackURI || "/graphql";
};




var $a90b2277f663d01f$export$772fbc04a0ad4ce9 = typeof WeakMap === "function" && (0, $bb6005294753e564$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.product;
}) !== "ReactNative";
var $a90b2277f663d01f$export$7293b8a0b474028d = typeof WeakSet === "function";
var $a90b2277f663d01f$export$23ba675b4b838b92 = typeof Symbol === "function" && typeof Symbol.for === "function";
var $a90b2277f663d01f$export$c34f882e9f1c1637 = $a90b2277f663d01f$export$23ba675b4b838b92 && Symbol.asyncIterator;
var $a90b2277f663d01f$export$71594e8a50f746f4 = typeof (0, $bb6005294753e564$export$f8b8b9ce72e9ccbf)(function() {
    return window.document.createElement;
}) === "function";
var $a90b2277f663d01f$var$usingJSDOM = (0, $bb6005294753e564$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
}) || false;
var $a90b2277f663d01f$export$4001f6cd4a62405b = $a90b2277f663d01f$export$71594e8a50f746f4 && !$a90b2277f663d01f$var$usingJSDOM;


function $aac2965f91b739f8$export$18f63c735264ee11(value) {
    return !!value.body;
}
function $aac2965f91b739f8$export$ac613ff475b69d05(value) {
    return !!value.getReader;
}
function $aac2965f91b739f8$export$fe1556bffc7e68ee(value) {
    return !!((0, $a90b2277f663d01f$export$c34f882e9f1c1637) && value[Symbol.asyncIterator]);
}
function $aac2965f91b739f8$export$70be23b513fb72ac(value) {
    return !!value.stream;
}
function $aac2965f91b739f8$export$5bcd6e94ed871c88(value) {
    return !!value.arrayBuffer;
}
function $aac2965f91b739f8$export$530196473208426f(value) {
    return !!value.pipe;
}


function $6cb272f0f02e43bd$export$2e2bcd8739ae039(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
        next: function() {
            return iterator.next();
        }
    }, _a[Symbol.asyncIterator] = function() {
        return this;
    }, _a;
}



function $c0b48d7582a51f9d$export$2e2bcd8739ae039(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error) return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) return shiftedArr[0]({
                value: chunk,
                done: false
            });
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[0]({
                value: undefined,
                done: true
            });
        });
        !cleanup || cleanup();
    }
    cleanup = function() {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function(resolve, reject) {
            if (error) return reject(error);
            if (data.length) return resolve({
                value: data.shift(),
                done: false
            });
            if (done) return resolve({
                value: undefined,
                done: true
            });
            waiting.push([
                resolve,
                reject
            ]);
        });
    }
    var iterator = {
        next: function() {
            return getNext();
        }
    };
    if (0, $a90b2277f663d01f$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}



function $a645bfe55c814c15$export$2e2bcd8739ae039(promise) {
    var resolved = false;
    var iterator = {
        next: function() {
            if (resolved) return Promise.resolve({
                value: undefined,
                done: true
            });
            resolved = true;
            return new Promise(function(resolve, reject) {
                promise.then(function(value) {
                    resolve({
                        value: value,
                        done: false
                    });
                }).catch(reject);
            });
        }
    };
    if (0, $a90b2277f663d01f$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}



function $df8baebd60cff54d$export$2e2bcd8739ae039(reader) {
    var iterator = {
        next: function() {
            return reader.read();
        }
    };
    if (0, $a90b2277f663d01f$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


function $2cc181c40ee313f8$export$7e4ac9ed9577f145(response) {
    var body = response;
    if ((0, $aac2965f91b739f8$export$18f63c735264ee11)(response)) body = response.body;
    if ((0, $aac2965f91b739f8$export$fe1556bffc7e68ee)(body)) return (0, $6cb272f0f02e43bd$export$2e2bcd8739ae039)(body);
    if ((0, $aac2965f91b739f8$export$ac613ff475b69d05)(body)) return (0, $df8baebd60cff54d$export$2e2bcd8739ae039)(body.getReader());
    if ((0, $aac2965f91b739f8$export$70be23b513fb72ac)(body)) return (0, $df8baebd60cff54d$export$2e2bcd8739ae039)(body.stream().getReader());
    if ((0, $aac2965f91b739f8$export$5bcd6e94ed871c88)(body)) return (0, $a645bfe55c814c15$export$2e2bcd8739ae039)(body.arrayBuffer());
    if ((0, $aac2965f91b739f8$export$530196473208426f)(body)) return (0, $c0b48d7582a51f9d$export$2e2bcd8739ae039)(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}


var $d4565d49db1eab2a$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = "ServerError";
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};





var $783678ef924f64c3$export$4995664c1b49842e = Symbol();
function $783678ef924f64c3$export$345f95cc6b6b9b0b(result) {
    if (result.extensions) return Array.isArray(result.extensions[$783678ef924f64c3$export$4995664c1b49842e]);
    return false;
}
function $783678ef924f64c3$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty("graphQLErrors");
}
var $783678ef924f64c3$var$generateErrorMessage = function(err) {
    var errors = (0, $1aaf9c65fb7afb7d$export$1216008129fb82ed)((0, $1aaf9c65fb7afb7d$export$1216008129fb82ed)((0, $1aaf9c65fb7afb7d$export$1216008129fb82ed)([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError) errors.push(err.networkError);
    return errors.map(function(err) {
        return (0, $450e50257530cd67$export$417207af72fad9c9)(err) && err.message || "Error message not found.";
    }).join("\n");
};
var $783678ef924f64c3$export$26a337512320b8c6 = function(_super) {
    (0, $1aaf9c65fb7afb7d$export$a8ba968b8961cb8a)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = "ApolloError";
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || $783678ef924f64c3$var$generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);



var $f58ee2abdca915e4$export$43bee75e5e14138e = Array.isArray;
function $f58ee2abdca915e4$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}




var $5354ae177e970f6d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $5354ae177e970f6d$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $5354ae177e970f6d$export$160070228be94b08(sources);
}
function $5354ae177e970f6d$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new $5354ae177e970f6d$export$509e11c221f576c0();
        for(var i = 1; i < count; ++i)target = merger.merge(target, sources[i]);
    }
    return target;
}
var $5354ae177e970f6d$var$defaultReconciler = function(target, source, property) {
    return this.merge(target[property], source[property]);
};
var $5354ae177e970f6d$export$509e11c221f576c0 = function() {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) reconciler = $5354ae177e970f6d$var$defaultReconciler;
        this.reconciler = reconciler;
        this.isObject = (0, $450e50257530cd67$export$417207af72fad9c9);
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function(target, source) {
        var _this = this;
        var context = [];
        for(var _i = 2; _i < arguments.length; _i++)context[_i - 2] = arguments[_i];
        if ((0, $450e50257530cd67$export$417207af72fad9c9)(source) && (0, $450e50257530cd67$export$417207af72fad9c9)(target)) {
            Object.keys(source).forEach(function(sourceKey) {
                if ($5354ae177e970f6d$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0, $1aaf9c65fb7afb7d$export$1216008129fb82ed)([
                            target,
                            source,
                            sourceKey
                        ], context, false));
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                } else {
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function(value) {
        if ((0, $450e50257530cd67$export$417207af72fad9c9)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) value = value.slice(0);
                else value = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({
                    __proto__: Object.getPrototypeOf(value)
                }, value);
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}();


function $402a196e797ba47a$export$879767c5cdf33cb3(value) {
    return "incremental" in value;
}
function $402a196e797ba47a$export$6c17a45d8c64ff02(value) {
    return "hasNext" in value && "data" in value;
}
function $402a196e797ba47a$export$f90dc0a3531b8b83(value) {
    return $402a196e797ba47a$export$879767c5cdf33cb3(value) || $402a196e797ba47a$export$6c17a45d8c64ff02(value);
}
function $402a196e797ba47a$export$3f32b6369f408f33(value) {
    return (0, $450e50257530cd67$export$417207af72fad9c9)(value) && "payload" in value;
}
function $402a196e797ba47a$export$9a905f57d6393874(prevResult, result) {
    var mergedData = prevResult;
    var merger = new (0, $5354ae177e970f6d$export$509e11c221f576c0)();
    if ($402a196e797ba47a$export$879767c5cdf33cb3(result) && (0, $f58ee2abdca915e4$export$d307f5934e447d0e)(result.incremental)) result.incremental.forEach(function(_a) {
        var data = _a.data, path = _a.path;
        for(var i = path.length - 1; i >= 0; --i){
            var key = path[i];
            var isNumericKey = !isNaN(+key);
            var parent_1 = isNumericKey ? [] : {};
            parent_1[key] = data;
            data = parent_1;
        }
        mergedData = merger.merge(mergedData, data);
    });
    return mergedData;
}


var $e2c9f3eb7b4d09fd$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $e2c9f3eb7b4d09fd$export$ccb60864026baf09(response, observer) {
    var _a, _b, _c, _d, _e;
    return (0, $1aaf9c65fb7afb7d$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _f, value, done, chunk, searchFrom, bi, message, i, headers, contentType_1, body, result, next;
        var _g, _h;
        return (0, $1aaf9c65fb7afb7d$export$67ebef60e6f28a6)(this, function(_j) {
            switch(_j.label){
                case 0:
                    if (TextDecoder === undefined) throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    decoder = new TextDecoder("utf-8");
                    contentType = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter)) ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-";
                    boundary = "\r\n--".concat(boundaryVal);
                    buffer = "";
                    iterator = (0, $2cc181c40ee313f8$export$7e4ac9ed9577f145)(response);
                    running = true;
                    _j.label = 1;
                case 1:
                    if (!running) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        iterator.next()
                    ];
                case 2:
                    _f = _j.sent(), value = _f.value, done = _f.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    searchFrom = buffer.length - boundary.length + 1;
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary, searchFrom);
                    while(bi > -1){
                        message = void 0;
                        _g = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length)
                        ], message = _g[0], buffer = _g[1];
                        i = message.indexOf("\r\n\r\n");
                        headers = $e2c9f3eb7b4d09fd$export$eea2c1c5e1a37e50(message.slice(0, i));
                        contentType_1 = headers["content-type"];
                        if (contentType_1 && contentType_1.toLowerCase().indexOf("application/json") === -1) throw new Error("Unsupported patch content type: application/json is required.");
                        body = message.slice(i);
                        if (body) try {
                            result = $e2c9f3eb7b4d09fd$export$759bcb35b0d1bf81(response, body);
                            if (Object.keys(result).length > 1 || "data" in result || "incremental" in result || "errors" in result || "payload" in result) {
                                if ((0, $402a196e797ba47a$export$3f32b6369f408f33)(result)) {
                                    next = {};
                                    if ("payload" in result) next = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, result.payload);
                                    if ("errors" in result) next = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, next), {
                                        extensions: (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, "extensions" in next ? next.extensions : null), (_h = {}, _h[0, $783678ef924f64c3$export$4995664c1b49842e] = result.errors, _h))
                                    });
                                    (_b = observer.next) === null || _b === void 0 || _b.call(observer, next);
                                } else (_c = observer.next) === null || _c === void 0 || _c.call(observer, result);
                            } else if (Object.keys(result).length === 1 && "hasNext" in result && !result.hasNext) (_d = observer.complete) === null || _d === void 0 || _d.call(observer);
                        } catch (err) {
                            $e2c9f3eb7b4d09fd$export$d3da1ecaf1206c58(err, observer);
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [
                        3,
                        1
                    ];
                case 3:
                    (_e = observer.complete) === null || _e === void 0 || _e.call(observer);
                    return [
                        2
                    ];
            }
        });
    });
}
function $e2c9f3eb7b4d09fd$export$eea2c1c5e1a37e50(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function(line) {
        var i = line.indexOf(":");
        if (i > -1) {
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function $e2c9f3eb7b4d09fd$export$759bcb35b0d1bf81(response, bodyText) {
    if (response.status >= 300) {
        var getResult = function() {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                return bodyText;
            }
        };
        (0, $d4565d49db1eab2a$export$c33ef9219f27efd7)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    } catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function $e2c9f3eb7b4d09fd$export$d3da1ecaf1206c58(err, observer) {
    var _a, _b;
    if (err.name === "AbortError") return;
    if (err.result && err.result.errors && err.result.data) (_a = observer.next) === null || _a === void 0 || _a.call(observer, err.result);
    (_b = observer.error) === null || _b === void 0 || _b.call(observer, err);
}
function $e2c9f3eb7b4d09fd$export$239a7c04069f210b(response, operation, observer) {
    $e2c9f3eb7b4d09fd$export$d4051215bea0639f(operation)(response).then(function(result) {
        var _a, _b;
        (_a = observer.next) === null || _a === void 0 || _a.call(observer, result);
        (_b = observer.complete) === null || _b === void 0 || _b.call(observer);
    }).catch(function(err) {
        return $e2c9f3eb7b4d09fd$export$d3da1ecaf1206c58(err, observer);
    });
}
function $e2c9f3eb7b4d09fd$export$d4051215bea0639f(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            return $e2c9f3eb7b4d09fd$export$759bcb35b0d1bf81(response, bodyText);
        }).then(function(result) {
            if (response.status >= 300) (0, $d4565d49db1eab2a$export$c33ef9219f27efd7)(response, result, "Response not successful: Received status code ".concat(response.status));
            if (!Array.isArray(result) && !$e2c9f3eb7b4d09fd$var$hasOwnProperty.call(result, "data") && !$e2c9f3eb7b4d09fd$var$hasOwnProperty.call(result, "errors")) (0, $d4565d49db1eab2a$export$c33ef9219f27efd7)(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName, "'."));
            return result;
        });
    };
}



var $210bdd8f620d0bdc$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === "undefined") throw __DEV__ ? new (0, $a670ecbae0a62090$export$cea12affaee22fe8)("\n\"fetch\" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:\n\nimport fetch from 'cross-fetch';\nimport { ApolloClient, HttpLink } from '@apollo/client';\nconst client = new ApolloClient({\n  link: new HttpLink({ uri: '/graphql', fetch })\n});\n    ") : new (0, $a670ecbae0a62090$export$cea12affaee22fe8)(23);
};



/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $996a4c2663561fcb$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $996a4c2663561fcb$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $996a4c2663561fcb$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $996a4c2663561fcb$export$45a677ea7cb6d5c8(code) {
    return $996a4c2663561fcb$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $996a4c2663561fcb$export$d3f406ff46035894(code) {
    return $996a4c2663561fcb$export$79c5d5217943d6a7(code) || $996a4c2663561fcb$export$727d9dbc4fbb948f(code) || code === 0x005f;
}


function $3caa7105ac3470f5$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $3caa7105ac3470f5$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $3caa7105ac3470f5$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $996a4c2663561fcb$export$3c52dd84024ae72c)(str.charCodeAt(i)))++i;
    return i;
}
function $3caa7105ac3470f5$export$40862a63ef85e395(value) {
    if (value === "") return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $3caa7105ac3470f5$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $996a4c2663561fcb$export$3c52dd84024ae72c)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith("\\");
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ""; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $996a4c2663561fcb$export$3c52dd84024ae72c)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += "\n";
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += "\n";
    return '"""' + result + '"""';
}


/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $143e71e5799c0507$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($143e71e5799c0507$var$escapedRegExp, $143e71e5799c0507$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $143e71e5799c0507$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $143e71e5799c0507$var$escapedReplacer(str) {
    return $143e71e5799c0507$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $143e71e5799c0507$var$escapeSequences = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "\\t",
    "\\n",
    "\\u000B",
    "\\f",
    "\\r",
    "\\u000E",
    "\\u000F",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001A",
    "\\u001B",
    "\\u001C",
    "\\u001D",
    "\\u001E",
    "\\u001F",
    "",
    "",
    '\\"',
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\\\",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\u007F",
    "\\u0080",
    "\\u0081",
    "\\u0082",
    "\\u0083",
    "\\u0084",
    "\\u0085",
    "\\u0086",
    "\\u0087",
    "\\u0088",
    "\\u0089",
    "\\u008A",
    "\\u008B",
    "\\u008C",
    "\\u008D",
    "\\u008E",
    "\\u008F",
    "\\u0090",
    "\\u0091",
    "\\u0092",
    "\\u0093",
    "\\u0094",
    "\\u0095",
    "\\u0096",
    "\\u0097",
    "\\u0098",
    "\\u0099",
    "\\u009A",
    "\\u009B",
    "\\u009C",
    "\\u009D",
    "\\u009E",
    "\\u009F"
];



function $715da05bd0c85917$export$c2d084dc44961371(ast) {
    return (0, $5df15baf989f8f0b$export$bf638b60ea8b89b7)(ast, $715da05bd0c85917$var$printDocASTReducer);
}
const $715da05bd0c85917$var$MAX_LINE_LENGTH = 80;
const $715da05bd0c85917$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>"$" + node.name
    },
    // Document
    Document: {
        leave: (node)=>$715da05bd0c85917$var$join(node.definitions, "\n\n")
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $715da05bd0c85917$var$wrap("(", $715da05bd0c85917$var$join(node.variableDefinitions, ", "), ")");
            const prefix = $715da05bd0c85917$var$join([
                node.operation,
                $715da05bd0c85917$var$join([
                    node.name,
                    varDefs
                ]),
                $715da05bd0c85917$var$join(node.directives, " ")
            ], " "); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === "query" ? "" : prefix + " ") + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable , type: type , defaultValue: defaultValue , directives: directives  })=>variable + ": " + type + $715da05bd0c85917$var$wrap(" = ", defaultValue) + $715da05bd0c85917$var$wrap(" ", $715da05bd0c85917$var$join(directives, " "))
    },
    SelectionSet: {
        leave: ({ selections: selections  })=>$715da05bd0c85917$var$block(selections)
    },
    Field: {
        leave ({ alias: alias , name: name , arguments: args , directives: directives , selectionSet: selectionSet  }) {
            const prefix = $715da05bd0c85917$var$wrap("", alias, ": ") + name;
            let argsLine = prefix + $715da05bd0c85917$var$wrap("(", $715da05bd0c85917$var$join(args, ", "), ")");
            if (argsLine.length > $715da05bd0c85917$var$MAX_LINE_LENGTH) argsLine = prefix + $715da05bd0c85917$var$wrap("(\n", $715da05bd0c85917$var$indent($715da05bd0c85917$var$join(args, "\n")), "\n)");
            return $715da05bd0c85917$var$join([
                argsLine,
                $715da05bd0c85917$var$join(directives, " "),
                selectionSet
            ], " ");
        }
    },
    Argument: {
        leave: ({ name: name , value: value  })=>name + ": " + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name , directives: directives  })=>"..." + name + $715da05bd0c85917$var$wrap(" ", $715da05bd0c85917$var$join(directives, " "))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition , directives: directives , selectionSet: selectionSet  })=>$715da05bd0c85917$var$join([
                "...",
                $715da05bd0c85917$var$wrap("on ", typeCondition),
                $715da05bd0c85917$var$join(directives, " "),
                selectionSet
            ], " ")
    },
    FragmentDefinition: {
        leave: ({ name: name , typeCondition: typeCondition , variableDefinitions: variableDefinitions , directives: directives , selectionSet: selectionSet  })=>// or removed in the future.
            `fragment ${name}${$715da05bd0c85917$var$wrap("(", $715da05bd0c85917$var$join(variableDefinitions, ", "), ")")} ` + `on ${typeCondition} ${$715da05bd0c85917$var$wrap("", $715da05bd0c85917$var$join(directives, " "), " ")}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value  })=>value
    },
    FloatValue: {
        leave: ({ value: value  })=>value
    },
    StringValue: {
        leave: ({ value: value , block: isBlockString  })=>isBlockString ? (0, $3caa7105ac3470f5$export$adb6ca997eeb1f45)(value) : (0, $143e71e5799c0507$export$3cdec7cf614a0ecc)(value)
    },
    BooleanValue: {
        leave: ({ value: value  })=>value ? "true" : "false"
    },
    NullValue: {
        leave: ()=>"null"
    },
    EnumValue: {
        leave: ({ value: value  })=>value
    },
    ListValue: {
        leave: ({ values: values  })=>"[" + $715da05bd0c85917$var$join(values, ", ") + "]"
    },
    ObjectValue: {
        leave: ({ fields: fields  })=>"{" + $715da05bd0c85917$var$join(fields, ", ") + "}"
    },
    ObjectField: {
        leave: ({ name: name , value: value  })=>name + ": " + value
    },
    // Directive
    Directive: {
        leave: ({ name: name , arguments: args  })=>"@" + name + $715da05bd0c85917$var$wrap("(", $715da05bd0c85917$var$join(args, ", "), ")")
    },
    // Type
    NamedType: {
        leave: ({ name: name  })=>name
    },
    ListType: {
        leave: ({ type: type  })=>"[" + type + "]"
    },
    NonNullType: {
        leave: ({ type: type  })=>type + "!"
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description , directives: directives , operationTypes: operationTypes  })=>$715da05bd0c85917$var$wrap("", description, "\n") + $715da05bd0c85917$var$join([
                "schema",
                $715da05bd0c85917$var$join(directives, " "),
                $715da05bd0c85917$var$block(operationTypes)
            ], " ")
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation , type: type  })=>operation + ": " + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description , name: name , directives: directives  })=>$715da05bd0c85917$var$wrap("", description, "\n") + $715da05bd0c85917$var$join([
                "scalar",
                name,
                $715da05bd0c85917$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeDefinition: {
        leave: ({ description: description , name: name , interfaces: interfaces , directives: directives , fields: fields  })=>$715da05bd0c85917$var$wrap("", description, "\n") + $715da05bd0c85917$var$join([
                "type",
                name,
                $715da05bd0c85917$var$wrap("implements ", $715da05bd0c85917$var$join(interfaces, " & ")),
                $715da05bd0c85917$var$join(directives, " "),
                $715da05bd0c85917$var$block(fields)
            ], " ")
    },
    FieldDefinition: {
        leave: ({ description: description , name: name , arguments: args , type: type , directives: directives  })=>$715da05bd0c85917$var$wrap("", description, "\n") + name + ($715da05bd0c85917$var$hasMultilineItems(args) ? $715da05bd0c85917$var$wrap("(\n", $715da05bd0c85917$var$indent($715da05bd0c85917$var$join(args, "\n")), "\n)") : $715da05bd0c85917$var$wrap("(", $715da05bd0c85917$var$join(args, ", "), ")")) + ": " + type + $715da05bd0c85917$var$wrap(" ", $715da05bd0c85917$var$join(directives, " "))
    },
    InputValueDefinition: {
        leave: ({ description: description , name: name , type: type , defaultValue: defaultValue , directives: directives  })=>$715da05bd0c85917$var$wrap("", description, "\n") + $715da05bd0c85917$var$join([
                name + ": " + type,
                $715da05bd0c85917$var$wrap("= ", defaultValue),
                $715da05bd0c85917$var$join(directives, " ")
            ], " ")
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description , name: name , interfaces: interfaces , directives: directives , fields: fields  })=>$715da05bd0c85917$var$wrap("", description, "\n") + $715da05bd0c85917$var$join([
                "interface",
                name,
                $715da05bd0c85917$var$wrap("implements ", $715da05bd0c85917$var$join(interfaces, " & ")),
                $715da05bd0c85917$var$join(directives, " "),
                $715da05bd0c85917$var$block(fields)
            ], " ")
    },
    UnionTypeDefinition: {
        leave: ({ description: description , name: name , directives: directives , types: types  })=>$715da05bd0c85917$var$wrap("", description, "\n") + $715da05bd0c85917$var$join([
                "union",
                name,
                $715da05bd0c85917$var$join(directives, " "),
                $715da05bd0c85917$var$wrap("= ", $715da05bd0c85917$var$join(types, " | "))
            ], " ")
    },
    EnumTypeDefinition: {
        leave: ({ description: description , name: name , directives: directives , values: values  })=>$715da05bd0c85917$var$wrap("", description, "\n") + $715da05bd0c85917$var$join([
                "enum",
                name,
                $715da05bd0c85917$var$join(directives, " "),
                $715da05bd0c85917$var$block(values)
            ], " ")
    },
    EnumValueDefinition: {
        leave: ({ description: description , name: name , directives: directives  })=>$715da05bd0c85917$var$wrap("", description, "\n") + $715da05bd0c85917$var$join([
                name,
                $715da05bd0c85917$var$join(directives, " ")
            ], " ")
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description , name: name , directives: directives , fields: fields  })=>$715da05bd0c85917$var$wrap("", description, "\n") + $715da05bd0c85917$var$join([
                "input",
                name,
                $715da05bd0c85917$var$join(directives, " "),
                $715da05bd0c85917$var$block(fields)
            ], " ")
    },
    DirectiveDefinition: {
        leave: ({ description: description , name: name , arguments: args , repeatable: repeatable , locations: locations  })=>$715da05bd0c85917$var$wrap("", description, "\n") + "directive @" + name + ($715da05bd0c85917$var$hasMultilineItems(args) ? $715da05bd0c85917$var$wrap("(\n", $715da05bd0c85917$var$indent($715da05bd0c85917$var$join(args, "\n")), "\n)") : $715da05bd0c85917$var$wrap("(", $715da05bd0c85917$var$join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + $715da05bd0c85917$var$join(locations, " | ")
    },
    SchemaExtension: {
        leave: ({ directives: directives , operationTypes: operationTypes  })=>$715da05bd0c85917$var$join([
                "extend schema",
                $715da05bd0c85917$var$join(directives, " "),
                $715da05bd0c85917$var$block(operationTypes)
            ], " ")
    },
    ScalarTypeExtension: {
        leave: ({ name: name , directives: directives  })=>$715da05bd0c85917$var$join([
                "extend scalar",
                name,
                $715da05bd0c85917$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeExtension: {
        leave: ({ name: name , interfaces: interfaces , directives: directives , fields: fields  })=>$715da05bd0c85917$var$join([
                "extend type",
                name,
                $715da05bd0c85917$var$wrap("implements ", $715da05bd0c85917$var$join(interfaces, " & ")),
                $715da05bd0c85917$var$join(directives, " "),
                $715da05bd0c85917$var$block(fields)
            ], " ")
    },
    InterfaceTypeExtension: {
        leave: ({ name: name , interfaces: interfaces , directives: directives , fields: fields  })=>$715da05bd0c85917$var$join([
                "extend interface",
                name,
                $715da05bd0c85917$var$wrap("implements ", $715da05bd0c85917$var$join(interfaces, " & ")),
                $715da05bd0c85917$var$join(directives, " "),
                $715da05bd0c85917$var$block(fields)
            ], " ")
    },
    UnionTypeExtension: {
        leave: ({ name: name , directives: directives , types: types  })=>$715da05bd0c85917$var$join([
                "extend union",
                name,
                $715da05bd0c85917$var$join(directives, " "),
                $715da05bd0c85917$var$wrap("= ", $715da05bd0c85917$var$join(types, " | "))
            ], " ")
    },
    EnumTypeExtension: {
        leave: ({ name: name , directives: directives , values: values  })=>$715da05bd0c85917$var$join([
                "extend enum",
                name,
                $715da05bd0c85917$var$join(directives, " "),
                $715da05bd0c85917$var$block(values)
            ], " ")
    },
    InputObjectTypeExtension: {
        leave: ({ name: name , directives: directives , fields: fields  })=>$715da05bd0c85917$var$join([
                "extend input",
                name,
                $715da05bd0c85917$var$join(directives, " "),
                $715da05bd0c85917$var$block(fields)
            ], " ")
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $715da05bd0c85917$var$join(maybeArray, separator = "") {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $715da05bd0c85917$var$block(array) {
    return $715da05bd0c85917$var$wrap("{\n", $715da05bd0c85917$var$indent($715da05bd0c85917$var$join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $715da05bd0c85917$var$wrap(start, maybeString, end = "") {
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function $715da05bd0c85917$var$indent(str) {
    return $715da05bd0c85917$var$wrap("  ", str.replace(/\n/g, "\n  "));
}
function $715da05bd0c85917$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes("\n"))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}


var $969e0a2c09e222dd$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false
};
var $969e0a2c09e222dd$var$defaultHeaders = {
    accept: "*/*",
    "content-type": "application/json"
};
var $969e0a2c09e222dd$var$defaultOptions = {
    method: "POST"
};
var $969e0a2c09e222dd$export$dd86f00dc866e75d = {
    http: $969e0a2c09e222dd$var$defaultHttpOptions,
    headers: $969e0a2c09e222dd$var$defaultHeaders,
    options: $969e0a2c09e222dd$var$defaultOptions
};
var $969e0a2c09e222dd$export$e88934976ca4fd65 = function(ast, printer) {
    return printer(ast);
};
function $969e0a2c09e222dd$export$a00ebfd5f1eebfb1(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    configs.unshift(fallbackConfig);
    return $969e0a2c09e222dd$export$12d90ccf75844275.apply(void 0, (0, $1aaf9c65fb7afb7d$export$1216008129fb82ed)([
        operation,
        $969e0a2c09e222dd$export$e88934976ca4fd65
    ], configs, false));
}
function $969e0a2c09e222dd$export$12d90ccf75844275(operation, printer) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = {};
    var http = {};
    configs.forEach(function(config) {
        options = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, options), config.options), {
            headers: (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, options.headers), config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, http), config.http);
    });
    if (options.headers) options.headers = $969e0a2c09e222dd$var$removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = printer(query, (0, $715da05bd0c85917$export$c2d084dc44961371));
    return {
        options: options,
        body: body
    };
}
function $969e0a2c09e222dd$var$removeDuplicateHeaders(headers, preserveHeaderCase) {
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = Object.create(null);
        Object.keys(Object(headers)).forEach(function(name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    var headerData = Object.create(null);
    Object.keys(Object(headers)).forEach(function(name) {
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name]
        };
    });
    var normalizedHeaders = Object.create(null);
    Object.keys(headerData).forEach(function(name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}


var $75076938ef6773e5$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === "undefined") return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};



function $8b9c281af0036d49$export$fb82bb094b6f76b5(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ("query" in body) addQueryParam("query", body.query);
    if (body.operationName) addQueryParam("operationName", body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $3b06e88edcf47dda$export$5f8e80ac52052e28)(body.variables, "Variables map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $3b06e88edcf47dda$export$5f8e80ac52052e28)(body.extensions, "Extensions map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    var fragment = "", preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    var newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return {
        newURI: newURI
    };
}



function $6104603d01b1a4f0$export$4fd972edbe7450d3(errorValue) {
    return new (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4)(function(observer) {
        observer.error(errorValue);
    });
}


var $2bd54c7bb6d7ea46$var$backupFetch = (0, $bb6005294753e564$export$f8b8b9ce72e9ccbf)(function() {
    return fetch;
});
var $2bd54c7bb6d7ea46$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? "/graphql" : _a, preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? (0, $969e0a2c09e222dd$export$e88934976ca4fd65) : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0, $1aaf9c65fb7afb7d$export$3c9a16f847548506)(linkOptions, [
        "uri",
        "fetch",
        "print",
        "includeExtensions",
        "preserveHeaderCase",
        "useGETForQueries",
        "includeUnusedVariables"
    ]);
    if (__DEV__) (0, $210bdd8f620d0bdc$export$8423f0cd3773115e)(preferredFetch || $2bd54c7bb6d7ea46$var$backupFetch);
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions,
            preserveHeaderCase: preserveHeaderCase
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $29b9899e03084364$export$2fed3d61f740bc7f)(function(operation) {
        var chosenURI = (0, $2ccabe2f3fc74e73$export$63ccc2571850f81a)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders["apollographql-client-name"] = name_1;
            if (version) clientAwarenessHeaders["apollographql-client-version"] = version;
        }
        var contextHeaders = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $969e0a2c09e222dd$export$12d90ccf75844275)(operation, print, (0, $969e0a2c09e222dd$export$dd86f00dc866e75d), linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) {
            var unusedNames_1 = new Set(Object.keys(body.variables));
            (0, $5df15baf989f8f0b$export$bf638b60ea8b89b7)(operation.query, {
                Variable: function(node, _key, parent) {
                    if (parent && parent.kind !== "VariableDefinition") unusedNames_1.delete(node.name.value);
                }
            });
            if (unusedNames_1.size) {
                body.variables = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, body.variables);
                unusedNames_1.forEach(function(name) {
                    delete body.variables[name];
                });
            }
        }
        var controller;
        if (!options.signal) {
            var _c = (0, $75076938ef6773e5$export$f5853cd1fc39aea6)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "mutation";
        };
        var definitionIsSubscription = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "subscription";
        };
        var isSubscription = definitionIsSubscription((0, $91fde6eb370810ac$export$f431198736b7f96d)(operation.query));
        var hasDefer = (0, $62aba4d864227324$export$2dafb573e282fe8d)([
            "defer"
        ], operation.query);
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = "GET";
        if (hasDefer || isSubscription) {
            options.headers = options.headers || {};
            var acceptHeader = "multipart/mixed;";
            if (isSubscription && hasDefer) __DEV__ && (0, $a670ecbae0a62090$export$f5708dca728d7177).warn("Multipart-subscriptions do not support @defer");
            if (isSubscription) acceptHeader += "boundary=graphql;subscriptionSpec=1.0,application/json";
            else if (hasDefer) acceptHeader += "deferSpec=20220824,application/json";
            options.headers.accept = acceptHeader;
        }
        if (options.method === "GET") {
            var _d = (0, $8b9c281af0036d49$export$fb82bb094b6f76b5)(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $6104603d01b1a4f0$export$4fd972edbe7450d3)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $3b06e88edcf47dda$export$5f8e80ac52052e28)(body, "Payload");
        } catch (parseError) {
            return (0, $6104603d01b1a4f0$export$4fd972edbe7450d3)(parseError);
        }
        return new (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4)(function(observer) {
            var currentFetch = preferredFetch || (0, $bb6005294753e564$export$f8b8b9ce72e9ccbf)(function() {
                return fetch;
            }) || $2bd54c7bb6d7ea46$var$backupFetch;
            currentFetch(chosenURI, options).then(function(response) {
                var _a;
                operation.setContext({
                    response: response
                });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) return (0, $e2c9f3eb7b4d09fd$export$ccb60864026baf09)(response, observer);
                else return (0, $e2c9f3eb7b4d09fd$export$239a7c04069f210b)(response, operation, observer);
            }).catch(function(err) {
                return (0, $e2c9f3eb7b4d09fd$export$d3da1ecaf1206c58)(err, observer);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};


var $4071829aa7d2097e$export$f4bbf1aec241cc1 = function(_super) {
    (0, $1aaf9c65fb7afb7d$export$a8ba968b8961cb8a)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, (0, $2bd54c7bb6d7ea46$export$95180a16573d6675)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}((0, $29b9899e03084364$export$2fed3d61f740bc7f));




const { toString: $9e23b7a204e68d42$var$toString , hasOwnProperty: $9e23b7a204e68d42$var$hasOwnProperty  } = Object.prototype;
const $9e23b7a204e68d42$var$fnToStr = Function.prototype.toString;
const $9e23b7a204e68d42$var$previousComparisons = new Map();
function $9e23b7a204e68d42$export$411ce8e5a71e3069(a, b) {
    try {
        return $9e23b7a204e68d42$var$check(a, b);
    } finally{
        $9e23b7a204e68d42$var$previousComparisons.clear();
    }
}
var // Allow default imports as well.
$9e23b7a204e68d42$export$2e2bcd8739ae039 = $9e23b7a204e68d42$export$411ce8e5a71e3069;
function $9e23b7a204e68d42$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    const aTag = $9e23b7a204e68d42$var$toString.call(a);
    const bTag = $9e23b7a204e68d42$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case "[object Array]":
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case "[object Object]":
            {
                if ($9e23b7a204e68d42$var$previouslyCompared(a, b)) return true;
                const aKeys = $9e23b7a204e68d42$var$definedKeys(a);
                const bKeys = $9e23b7a204e68d42$var$definedKeys(b);
                // If `a` and `b` have a different number of enumerable keys, they
                // must be different.
                const keyCount = aKeys.length;
                if (keyCount !== bKeys.length) return false;
                // Now make sure they have the same keys.
                for(let k = 0; k < keyCount; ++k){
                    if (!$9e23b7a204e68d42$var$hasOwnProperty.call(b, aKeys[k])) return false;
                }
                // Finally, check deep equality of all child properties.
                for(let k = 0; k < keyCount; ++k){
                    const key = aKeys[k];
                    if (!$9e23b7a204e68d42$var$check(a[key], b[key])) return false;
                }
                return true;
            }
        case "[object Error]":
            return a.name === b.name && a.message === b.message;
        case "[object Number]":
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case "[object Boolean]":
        case "[object Date]":
            return +a === +b;
        case "[object RegExp]":
        case "[object String]":
            return a == `${b}`;
        case "[object Map]":
        case "[object Set]":
            {
                if (a.size !== b.size) return false;
                if ($9e23b7a204e68d42$var$previouslyCompared(a, b)) return true;
                const aIterator = a.entries();
                const isMap = aTag === "[object Map]";
                while(true){
                    const info = aIterator.next();
                    if (info.done) break;
                    // If a instanceof Set, aValue === aKey.
                    const [aKey, aValue] = info.value;
                    // So this works the same way for both Set and Map.
                    if (!b.has(aKey)) return false;
                    // However, we care about deep equality of values only when dealing
                    // with Map structures.
                    if (isMap && !$9e23b7a204e68d42$var$check(aValue, b.get(aKey))) return false;
                }
                return true;
            }
        case "[object Uint16Array]":
        case "[object Uint8Array]":
        case "[object Uint32Array]":
        case "[object Int32Array]":
        case "[object Int8Array]":
        case "[object Int16Array]":
        case "[object ArrayBuffer]":
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case "[object DataView]":
            {
                let len = a.byteLength;
                if (len === b.byteLength) {
                    while(len-- && a[len] === b[len]);
                }
                return len === -1;
            }
        case "[object AsyncFunction]":
        case "[object GeneratorFunction]":
        case "[object AsyncGeneratorFunction]":
        case "[object Function]":
            {
                const aCode = $9e23b7a204e68d42$var$fnToStr.call(a);
                if (aCode !== $9e23b7a204e68d42$var$fnToStr.call(b)) return false;
                // We consider non-native functions equal if they have the same code
                // (native functions require === because their code is censored).
                // Note that this behavior is not entirely sound, since !== function
                // objects with the same code can behave differently depending on
                // their closure scope. However, any function can behave differently
                // depending on the values of its input arguments (including this)
                // and its calling context (including its closure scope), even
                // though the function object is === to itself; and it is entirely
                // possible for functions that are not === to behave exactly the
                // same under all conceivable circumstances. Because none of these
                // factors are statically decidable in JavaScript, JS function
                // equality is not well-defined. This ambiguity allows us to
                // consider the best possible heuristic among various imperfect
                // options, and equating non-native functions that have the same
                // code has enormous practical benefits, such as when comparing
                // functions that are repeatedly passed as fresh function
                // expressions within objects that are otherwise deeply equal. Since
                // any function created from the same syntactic expression (in the
                // same code location) will always stringify to the same code
                // according to fnToStr.call, we can reasonably expect these
                // repeatedly passed function expressions to have the same code, and
                // thus behave "the same" (with all the caveats mentioned above),
                // even though the runtime function objects are !== to one another.
                return !$9e23b7a204e68d42$var$endsWith(aCode, $9e23b7a204e68d42$var$nativeCodeSuffix);
            }
    }
    // Otherwise the values are not equal.
    return false;
}
function $9e23b7a204e68d42$var$definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter($9e23b7a204e68d42$var$isDefinedKey, obj);
}
function $9e23b7a204e68d42$var$isDefinedKey(key) {
    return this[key] !== void 0;
}
const $9e23b7a204e68d42$var$nativeCodeSuffix = "{ [native code] }";
function $9e23b7a204e68d42$var$endsWith(full, suffix) {
    const fromIndex = full.length - suffix.length;
    return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
function $9e23b7a204e68d42$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    let bSet = $9e23b7a204e68d42$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $9e23b7a204e68d42$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}






// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const $a3459a40f94912aa$var$defaultMakeData = ()=>Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach: $a3459a40f94912aa$var$forEach , slice: $a3459a40f94912aa$var$slice  } = Array.prototype;
const { hasOwnProperty: $a3459a40f94912aa$var$hasOwnProperty  } = Object.prototype;
class $a3459a40f94912aa$export$73571c50d0f2507e {
    constructor(weakness = true, makeData = $a3459a40f94912aa$var$defaultMakeData){
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup(...array) {
        return this.lookupArray(array);
    }
    lookupArray(array) {
        let node = this;
        $a3459a40f94912aa$var$forEach.call(array, (key)=>node = node.getChildTrie(key));
        return $a3459a40f94912aa$var$hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData($a3459a40f94912aa$var$slice.call(array));
    }
    peek(...array) {
        return this.peekArray(array);
    }
    peekArray(array) {
        let node = this;
        for(let i = 0, len = array.length; node && i < len; ++i){
            const map = this.weakness && $a3459a40f94912aa$var$isObjRef(array[i]) ? node.weak : node.strong;
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    getChildTrie(key) {
        const map = this.weakness && $a3459a40f94912aa$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        let child = map.get(key);
        if (!child) map.set(key, child = new $a3459a40f94912aa$export$73571c50d0f2507e(this.weakness, this.makeData));
        return child;
    }
}
function $a3459a40f94912aa$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}



function $7152c55085831e38$export$8e16b83750b44988() {
    var objects = [];
    for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
    var result = Object.create(null);
    objects.forEach(function(obj) {
        if (!obj) return;
        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (value !== void 0) result[key] = value;
        });
    });
    return result;
}


var $06d0621c9b9386d3$export$b5a638e9b3fff9f3 = Object.prototype.hasOwnProperty;
function $06d0621c9b9386d3$export$b931b78cbb3caf86(value) {
    return value === null || value === void 0;
}
function $06d0621c9b9386d3$export$bd03c5a9c99d6bce(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) context.keyObject = !$06d0621c9b9386d3$export$b931b78cbb3caf86(id) ? {
            id: id
        } : !$06d0621c9b9386d3$export$b931b78cbb3caf86(_id) ? {
            _id: _id
        } : void 0;
        if ($06d0621c9b9386d3$export$b931b78cbb3caf86(id) && !$06d0621c9b9386d3$export$b931b78cbb3caf86(_id)) id = _id;
        if (!$06d0621c9b9386d3$export$b931b78cbb3caf86(id)) return "".concat(__typename, ":").concat(typeof id === "number" || typeof id === "string" ? id : JSON.stringify(id));
    }
}
var $06d0621c9b9386d3$var$defaultConfig = {
    dataIdFromObject: $06d0621c9b9386d3$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    canonizeResults: false
};
function $06d0621c9b9386d3$export$fa542f9ee3f7f4e2(config) {
    return (0, $7152c55085831e38$export$8e16b83750b44988)($06d0621c9b9386d3$var$defaultConfig, config);
}
function $06d0621c9b9386d3$export$3ac2a95fbd99c479(config) {
    var value = config.canonizeResults;
    return value === void 0 ? $06d0621c9b9386d3$var$defaultConfig.canonizeResults : value;
}
function $06d0621c9b9386d3$export$fdef206c83ff2c09(store, objectOrReference) {
    return (0, $5763c7b47888ba33$export$fa99cac1c0883c47)(objectOrReference) ? store.get(objectOrReference.__ref, "__typename") : objectOrReference && objectOrReference.__typename;
}
var $06d0621c9b9386d3$export$6ed54d4784f1ce28 = /^[_a-z][_0-9a-z]*/i;
function $06d0621c9b9386d3$export$37874422037b6029(storeFieldName) {
    var match = storeFieldName.match($06d0621c9b9386d3$export$6ed54d4784f1ce28);
    return match ? match[0] : storeFieldName;
}
function $06d0621c9b9386d3$export$60bd1cbb09c1a4a2(selectionSet, result, variables) {
    if ((0, $450e50257530cd67$export$417207af72fad9c9)(result)) return (0, $f58ee2abdca915e4$export$43bee75e5e14138e)(result) ? result.every(function(item) {
        return $06d0621c9b9386d3$export$60bd1cbb09c1a4a2(selectionSet, item, variables);
    }) : selectionSet.selections.every(function(field) {
        if ((0, $5763c7b47888ba33$export$fb56ad75dd311c12)(field) && (0, $62aba4d864227324$export$3dc388a5f013b4a5)(field, variables)) {
            var key = (0, $5763c7b47888ba33$export$7d1ad22471852218)(field);
            return $06d0621c9b9386d3$export$b5a638e9b3fff9f3.call(result, key) && (!field.selectionSet || $06d0621c9b9386d3$export$60bd1cbb09c1a4a2(field.selectionSet, result[key], variables));
        }
        return true;
    });
    return false;
}
function $06d0621c9b9386d3$export$4f39afca21bd938e(value) {
    return (0, $450e50257530cd67$export$417207af72fad9c9)(value) && !(0, $5763c7b47888ba33$export$fa99cac1c0883c47)(value) && !(0, $f58ee2abdca915e4$export$43bee75e5e14138e)(value);
}
function $06d0621c9b9386d3$export$b874a818f7a2fa6d() {
    return new (0, $5354ae177e970f6d$export$509e11c221f576c0);
}
function $06d0621c9b9386d3$export$3a33c00f0ae4a480(document, fragments) {
    var fragmentMap = (0, $f80c7baa4263f96d$export$193789b4c8246dd4)((0, $91fde6eb370810ac$export$5320a7ba9466a3df)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function(name) {
            var def = fragmentMap[name];
            if (!def && fragments) def = fragments.lookup(name);
            return def || null;
        }
    };
}


function $bee4e4af2a14c8d6$var$shallowCopy(value) {
    if ((0, $450e50257530cd67$export$417207af72fad9c9)(value)) return (0, $f58ee2abdca915e4$export$43bee75e5e14138e)(value) ? value.slice(0) : (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({
        __proto__: Object.getPrototypeOf(value)
    }, value);
    return value;
}
var $bee4e4af2a14c8d6$export$c2e7fdd82233f4a4 = function() {
    function ObjectCanon() {
        this.known = new ((0, $a90b2277f663d01f$export$7293b8a0b474028d) ? WeakSet : Set)();
        this.pool = new (0, $a3459a40f94912aa$export$73571c50d0f2507e)((0, $a90b2277f663d01f$export$772fbc04a0ad4ce9));
        this.passes = new WeakMap();
        this.keysByJSON = new Map();
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function(value) {
        return (0, $450e50257530cd67$export$417207af72fad9c9)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function(value) {
        if ((0, $450e50257530cd67$export$417207af72fad9c9)(value)) {
            var copy = $bee4e4af2a14c8d6$var$shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function(value) {
        var _this = this;
        if ((0, $450e50257530cd67$export$417207af72fad9c9)(value)) {
            var original = this.passes.get(value);
            if (original) return original;
            var proto = Object.getPrototypeOf(value);
            switch(proto){
                case Array.prototype:
                    if (this.known.has(value)) return value;
                    var array = value.map(this.admit, this);
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        if (__DEV__) Object.freeze(array);
                    }
                    return node.array;
                case null:
                case Object.prototype:
                    if (this.known.has(value)) return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [
                        proto_1
                    ];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function(key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function(key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        if (__DEV__) Object.freeze(obj_1);
                    }
                    return node.object;
            }
        }
        return value;
    };
    ObjectCanon.prototype.sortedKeys = function(obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) this.keysByJSON.set(json, node.keys = {
                sorted: keys,
                json: json
            });
        }
        return node.keys;
    };
    return ObjectCanon;
}();
var $bee4e4af2a14c8d6$export$88a0ad9b6f961b51 = Object.assign(function(value) {
    if ((0, $450e50257530cd67$export$417207af72fad9c9)(value)) {
        if ($bee4e4af2a14c8d6$var$stringifyCanon === void 0) $bee4e4af2a14c8d6$var$resetCanonicalStringify();
        var canonical = $bee4e4af2a14c8d6$var$stringifyCanon.admit(value);
        var json = $bee4e4af2a14c8d6$var$stringifyCache.get(canonical);
        if (json === void 0) $bee4e4af2a14c8d6$var$stringifyCache.set(canonical, json = JSON.stringify(canonical));
        return json;
    }
    return JSON.stringify(value);
}, {
    reset: $bee4e4af2a14c8d6$var$resetCanonicalStringify
});
var $bee4e4af2a14c8d6$var$stringifyCanon;
var $bee4e4af2a14c8d6$var$stringifyCache;
function $bee4e4af2a14c8d6$var$resetCanonicalStringify() {
    $bee4e4af2a14c8d6$var$stringifyCanon = new $bee4e4af2a14c8d6$export$c2e7fdd82233f4a4;
    $bee4e4af2a14c8d6$var$stringifyCache = new ((0, $a90b2277f663d01f$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
}



function $bfa90a84bdddeaf8$export$707ee4c4c95d39e3(observable, mapFn, catchFn) {
    return new (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4)(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeCallbackCount = 0;
        var completed = false;
        var promiseQueue = {
            then: function(callback) {
                return new Promise(function(resolve) {
                    return resolve(callback());
                });
            }
        };
        function makeCallback(examiner, delegate) {
            if (examiner) return function(arg) {
                ++activeCallbackCount;
                var both = function() {
                    return examiner(arg);
                };
                promiseQueue = promiseQueue.then(both, both).then(function(result) {
                    --activeCallbackCount;
                    next && next.call(observer, result);
                    if (completed) handler.complete();
                }, function(error) {
                    --activeCallbackCount;
                    throw error;
                }).catch(function(caught) {
                    error && error.call(observer, caught);
                });
            };
            else return function(arg) {
                return delegate && delegate.call(observer, arg);
            };
        }
        var handler = {
            next: makeCallback(mapFn, next),
            error: makeCallback(catchFn, error),
            complete: function() {
                completed = true;
                if (!activeCallbackCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}



function $32643571e181e5f5$export$9f6c99ae166dbeca(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}




function $edc59b1e08b04dd3$export$33c8bd820eece9b2(subclass) {
    function set(key) {
        Object.defineProperty(subclass, key, {
            value: (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4)
        });
    }
    if ((0, $a90b2277f663d01f$export$23ba675b4b838b92) && Symbol.species) set(Symbol.species);
    set("@@species");
    return subclass;
}


function $9f104560ce05ec3c$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
var $9f104560ce05ec3c$export$ae0cf2ec7a6fa78e = function(_super) {
    (0, $1aaf9c65fb7afb7d$export$a8ba968b8961cb8a)(Concast, _super);
    function Concast(sources) {
        var _this = _super.call(this, function(observer) {
            _this.addObserver(observer);
            return function() {
                return _this.removeObserver(observer);
            };
        }) || this;
        _this.observers = new Set();
        _this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        _this.handlers = {
            next: function(result) {
                if (_this.sub !== null) {
                    _this.latest = [
                        "next",
                        result
                    ];
                    _this.notify("next", result);
                    (0, $32643571e181e5f5$export$9f6c99ae166dbeca)(_this.observers, "next", result);
                }
            },
            error: function(error) {
                var sub = _this.sub;
                if (sub !== null) {
                    if (sub) setTimeout(function() {
                        return sub.unsubscribe();
                    });
                    _this.sub = null;
                    _this.latest = [
                        "error",
                        error
                    ];
                    _this.reject(error);
                    _this.notify("error", error);
                    (0, $32643571e181e5f5$export$9f6c99ae166dbeca)(_this.observers, "error", error);
                }
            },
            complete: function() {
                var _a = _this, sub = _a.sub, _b = _a.sources, sources = _b === void 0 ? [] : _b;
                if (sub !== null) {
                    var value = sources.shift();
                    if (!value) {
                        if (sub) setTimeout(function() {
                            return sub.unsubscribe();
                        });
                        _this.sub = null;
                        if (_this.latest && _this.latest[0] === "next") _this.resolve(_this.latest[1]);
                        else _this.resolve();
                        _this.notify("complete");
                        (0, $32643571e181e5f5$export$9f6c99ae166dbeca)(_this.observers, "complete");
                    } else if ($9f104560ce05ec3c$var$isPromiseLike(value)) value.then(function(obs) {
                        return _this.sub = obs.subscribe(_this.handlers);
                    });
                    else _this.sub = value.subscribe(_this.handlers);
                }
            }
        };
        _this.nextResultListeners = new Set();
        _this.cancel = function(reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        _this.promise.catch(function(_) {});
        if (typeof sources === "function") sources = [
            new (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4)(sources)
        ];
        if ($9f104560ce05ec3c$var$isPromiseLike(sources)) sources.then(function(iterable) {
            return _this.start(iterable);
        }, _this.handlers.error);
        else _this.start(sources);
        return _this;
    }
    Concast.prototype.start = function(sources) {
        if (this.sub !== void 0) return;
        this.sources = Array.from(sources);
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function(observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) method.call(observer, this.latest[1]);
            if (this.sub === null && nextOrError === "next" && observer.complete) observer.complete();
        }
    };
    Concast.prototype.addObserver = function(observer) {
        if (!this.observers.has(observer)) {
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function(observer) {
        if (this.observers.delete(observer) && this.observers.size < 1) this.handlers.complete();
    };
    Concast.prototype.notify = function(method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            this.nextResultListeners = new Set;
            nextResultListeners.forEach(function(listener) {
                return listener(method, arg);
            });
        }
    };
    Concast.prototype.beforeNext = function(callback) {
        var called = false;
        this.nextResultListeners.add(function(method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}((0, $665f4cdbf299a5bf$export$77cea355fa80b5f4));
(0, $edc59b1e08b04dd3$export$33c8bd820eece9b2)($9f104560ce05ec3c$export$ae0cf2ec7a6fa78e);



function $dd2a078388f31bf4$export$b4df399e879e53ab(result) {
    var errors = $dd2a078388f31bf4$export$a163557155188b6e(result);
    return (0, $f58ee2abdca915e4$export$d307f5934e447d0e)(errors);
}
function $dd2a078388f31bf4$export$a163557155188b6e(result) {
    var graphQLErrors = (0, $f58ee2abdca915e4$export$d307f5934e447d0e)(result.errors) ? result.errors.slice(0) : [];
    if ((0, $402a196e797ba47a$export$879767c5cdf33cb3)(result) && (0, $f58ee2abdca915e4$export$d307f5934e447d0e)(result.incremental)) result.incremental.forEach(function(incrementalResult) {
        if (incrementalResult.errors) graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
    });
    return graphQLErrors;
}

var $e71eecefd4cc421f$var$prefixCounts = new Map();
function $e71eecefd4cc421f$export$d0c8ec0fe1b18b70(prefix) {
    var count = $e71eecefd4cc421f$var$prefixCounts.get(prefix) || 1;
    $e71eecefd4cc421f$var$prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}








var $6457d3104a36d467$var$TYPENAME_FIELD = {
    kind: (0, $5a7bd784209d2d45$export$a84bdc57c5122798).FIELD,
    name: {
        kind: (0, $5a7bd784209d2d45$export$a84bdc57c5122798).NAME,
        value: "__typename"
    }
};
function $6457d3104a36d467$var$isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function(selection) {
        return selection.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).FRAGMENT_SPREAD && $6457d3104a36d467$var$isEmpty(fragmentMap[selection.name.value], fragmentMap);
    });
}
function $6457d3104a36d467$var$nullIfDocIsEmpty(doc) {
    return $6457d3104a36d467$var$isEmpty((0, $91fde6eb370810ac$export$7a5b1fa979d2c158)(doc) || (0, $91fde6eb370810ac$export$772111caef41b3f5)(doc), (0, $f80c7baa4263f96d$export$193789b4c8246dd4)((0, $91fde6eb370810ac$export$5320a7ba9466a3df)(doc))) ? null : doc;
}
function $6457d3104a36d467$var$getDirectiveMatcher(directives) {
    var nameSet = new Set();
    var tests = [];
    directives.forEach(function(directive) {
        if (directive.name) nameSet.add(directive.name);
        else if (directive.test) tests.push(directive.test);
    });
    return function(directive) {
        return nameSet.has(directive.name.value) || tests.some(function(test) {
            return test(directive);
        });
    };
}
function $6457d3104a36d467$var$makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) key = defaultKey;
        var inUse = map.get(key);
        if (!inUse) map.set(key, inUse = {
            variables: new Set,
            fragmentSpreads: new Set
        });
        return inUse;
    };
}
function $6457d3104a36d467$export$e5ae0530da5fe96c(directives, doc) {
    var getInUseByOperationName = $6457d3104a36d467$var$makeInUseGetterFunction("");
    var getInUseByFragmentName = $6457d3104a36d467$var$makeInUseGetterFunction("");
    var getInUse = function(ancestors) {
        for(var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p){
            if ((0, $f58ee2abdca915e4$export$43bee75e5e14138e)(ancestor)) continue;
            if (ancestor.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).OPERATION_DEFINITION) return getInUseByOperationName(ancestor.name && ancestor.name.value);
            if (ancestor.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).FRAGMENT_DEFINITION) return getInUseByFragmentName(ancestor.name.value);
        }
        __DEV__ && (0, $a670ecbae0a62090$export$f5708dca728d7177).error("Could not find operation or fragment");
        return null;
    };
    var operationCount = 0;
    for(var i = doc.definitions.length - 1; i >= 0; --i)if (doc.definitions[i].kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).OPERATION_DEFINITION) ++operationCount;
    var directiveMatcher = $6457d3104a36d467$var$getDirectiveMatcher(directives);
    var hasRemoveDirective = directives.some(function(directive) {
        return directive.remove;
    });
    var shouldRemoveField = function(nodeDirectives) {
        return hasRemoveDirective && nodeDirectives && nodeDirectives.some(directiveMatcher);
    };
    var originalFragmentDefsByPath = new Map();
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function(node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        }
    };
    var docWithoutDirectiveSubtrees = (0, $5df15baf989f8f0b$export$bf638b60ea8b89b7)(doc, {
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function() {
                return false;
            }
        },
        Variable: {
            enter: function(node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) inUse.variables.add(node.name.value);
            }
        },
        FragmentSpread: {
            enter: function(node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) inUse.fragmentSpreads.add(node.name.value);
            }
        },
        FragmentDefinition: {
            enter: function(node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function(node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) return node;
                if (operationCount > 0 && node.selectionSet.selections.every(function(selection) {
                    return selection.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).FIELD && selection.name.value === "__typename";
                })) {
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        },
        Directive: {
            leave: function(node) {
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        }
    });
    if (!firstVisitMadeChanges) return doc;
    var populateTransitiveVars = function(inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) inUse.fragmentSpreads.forEach(function(childFragmentName) {
                populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function(varName) {
                    inUse.transitiveVars.add(varName);
                });
            });
        }
        return inUse;
    };
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function(def) {
        if (def.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).OPERATION_DEFINITION) populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
        else if (def.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).FRAGMENT_DEFINITION && operationCount === 0 && !getInUseByFragmentName(def.name.value).removed) allFragmentNamesUsed.add(def.name.value);
    });
    allFragmentNamesUsed.forEach(function(fragmentName) {
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function(fragmentName) {
        return !!(!allFragmentNamesUsed.has(fragmentName) || getInUseByFragmentName(fragmentName).removed);
    };
    var enterVisitor = {
        enter: function(node) {
            if (fragmentWillBeRemoved(node.name.value)) return null;
        }
    };
    return $6457d3104a36d467$var$nullIfDocIsEmpty((0, $5df15baf989f8f0b$export$bf638b60ea8b89b7)(docWithoutDirectiveSubtrees, {
        FragmentSpread: enterVisitor,
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function(node) {
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    if (usedVariableNames_1.size < node.variableDefinitions.length) return (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, node), {
                        variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                            return usedVariableNames_1.has(varDef.variable.name.value);
                        })
                    });
                }
            }
        }
    }));
}
var $6457d3104a36d467$export$43b332f87950a467 = Object.assign(function(doc) {
    return (0, $5df15baf989f8f0b$export$bf638b60ea8b89b7)(doc, {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).OPERATION_DEFINITION) return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return (0, $5763c7b47888ba33$export$fb56ad75dd311c12)(selection) && (selection.name.value === "__typename" || selection.name.value.lastIndexOf("__", 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ((0, $5763c7b47888ba33$export$fb56ad75dd311c12)(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === "export";
                })) return;
                return (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, node), {
                    selections: (0, $1aaf9c65fb7afb7d$export$1216008129fb82ed)((0, $1aaf9c65fb7afb7d$export$1216008129fb82ed)([], selections, true), [
                        $6457d3104a36d467$var$TYPENAME_FIELD
                    ], false)
                });
            }
        }
    });
}, {
    added: function(field) {
        return field === $6457d3104a36d467$var$TYPENAME_FIELD;
    }
});
var $6457d3104a36d467$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === "connection";
        if (willRemove) {
            if (!directive.arguments || !directive.arguments.some(function(arg) {
                return arg.name.value === "key";
            })) __DEV__ && (0, $a670ecbae0a62090$export$f5708dca728d7177).warn("Removing an @connection directive even though it does not have a key. You may want to use the key parameter to specify a store key.");
        }
        return willRemove;
    }
};
function $6457d3104a36d467$export$74985f3324559867(doc) {
    return $6457d3104a36d467$export$e5ae0530da5fe96c([
        $6457d3104a36d467$var$connectionRemoveConfig
    ], (0, $91fde6eb370810ac$export$a7d0d8111d2386df)(doc));
}
function $6457d3104a36d467$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return !!selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $6457d3104a36d467$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $6457d3104a36d467$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!(0, $5763c7b47888ba33$export$fb56ad75dd311c12)(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($6457d3104a36d467$var$getDirectiveMatcher(directives)) || nestedCheck && $6457d3104a36d467$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $6457d3104a36d467$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).VARIABLE && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $6457d3104a36d467$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $6457d3104a36d467$var$getArgumentMatcher(config);
    return $6457d3104a36d467$var$nullIfDocIsEmpty((0, $5df15baf989f8f0b$export$bf638b60ea8b89b7)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, node), {
                    variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    }) : []
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $6457d3104a36d467$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $6457d3104a36d467$var$nullIfDocIsEmpty((0, $5df15baf989f8f0b$export$bf638b60ea8b89b7)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $6457d3104a36d467$export$57c368c23873f32b(document) {
    var definition = (0, $91fde6eb370810ac$export$f431198736b7f96d)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === "query") return document;
    var modifiedDoc = (0, $5df15baf989f8f0b$export$bf638b60ea8b89b7)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, node), {
                    operation: "query"
                });
            }
        }
    });
    return modifiedDoc;
}
function $6457d3104a36d467$export$8eae69e876ee321e(document) {
    (0, $91fde6eb370810ac$export$a7d0d8111d2386df)(document);
    var modifiedDoc = $6457d3104a36d467$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === "client";
            },
            remove: true
        }
    ], document);
    return modifiedDoc;
}






var $3e16f6dd50a68d19$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($3e16f6dd50a68d19$export$bd096ddbd246c79c || ($3e16f6dd50a68d19$export$bd096ddbd246c79c = {}));
function $3e16f6dd50a68d19$export$37509604341a3464(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}


var $70b1e5e671b77ed0$var$toString = Object.prototype.toString;
function $70b1e5e671b77ed0$export$629a2bd3f5a49ecc(value) {
    return $70b1e5e671b77ed0$var$cloneDeepHelper(value);
}
function $70b1e5e671b77ed0$var$cloneDeepHelper(val, seen) {
    switch($70b1e5e671b77ed0$var$toString.call(val)){
        case "[object Array]":
            seen = seen || new Map;
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $70b1e5e671b77ed0$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            seen = seen || new Map;
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $70b1e5e671b77ed0$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}


var $4247e555a8486dc0$var$assign = Object.assign, $4247e555a8486dc0$var$hasOwnProperty = Object.hasOwnProperty;
var $4247e555a8486dc0$export$6c1b56eac59c9584 = function(_super) {
    (0, $1aaf9c65fb7afb7d$export$a8ba968b8961cb8a)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function(observer) {
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) subObserver.error = $4247e555a8486dc0$var$defaultSubscriptionObserverErrorCallback;
            } catch (_a) {}
            var first = !_this.observers.size;
            _this.observers.add(observer);
            var last = _this.last;
            if (last && last.error) observer.error && observer.error(last.error);
            else if (last && last.result) observer.next && observer.next(last.result);
            if (first) _this.reobserve().catch(function() {});
            return function() {
                if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        _this.isTornDown = false;
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, _f = options.initialFetchPolicy, initialFetchPolicy = _f === void 0 ? fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy : _f;
        _this.options = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, options), {
            initialFetchPolicy: initialFetchPolicy,
            fetchPolicy: fetchPolicy
        });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = (0, $91fde6eb370810ac$export$7a5b1fa979d2c158)(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        get: function() {
            return this.queryManager.transform(this.options.query).document;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        get: function() {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.getCurrentResult = function(saveAsLastResult) {
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus || lastResult && lastResult.networkStatus || (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).ready;
        var result = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, lastResult), {
            loading: (0, $3e16f6dd50a68d19$export$37509604341a3464)(networkStatus),
            networkStatus: networkStatus
        });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (fetchPolicy === "network-only" || fetchPolicy === "no-cache" || fetchPolicy === "standby" || this.queryManager.transform(this.options.query).hasForcedResolvers) ;
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) result.data = diff.result;
            if ((0, $9e23b7a204e68d42$export$411ce8e5a71e3069)(result.data, {})) result.data = void 0;
            if (diff.complete) {
                delete result.partial;
                if (diff.complete && result.networkStatus === (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).loading && (fetchPolicy === "cache-first" || fetchPolicy === "cache-only")) {
                    result.networkStatus = (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).ready;
                    result.loading = false;
                }
            } else result.partial = true;
            if (__DEV__ && !diff.complete && !this.options.partialRefetch && !result.loading && !result.data && !result.error) $4247e555a8486dc0$export$b7e1973aacac3ae7(diff.missing);
        }
        if (saveAsLastResult) this.updateLastResult(result);
        return result;
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult, variables) {
        return !this.last || !(0, $9e23b7a204e68d42$export$411ce8e5a71e3069)(this.last.result, newResult) || variables && !(0, $9e23b7a204e68d42$export$411ce8e5a71e3069)(this.last.variables, variables);
    };
    ObservableQuery.prototype.getLast = function(key, variablesMustMatch) {
        var last = this.last;
        if (last && last[key] && (!variablesMustMatch || (0, $9e23b7a204e68d42$export$411ce8e5a71e3069)(last.variables, this.variables))) return last[key];
    };
    ObservableQuery.prototype.getLastResult = function(variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function(variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        this.queryManager.resetErrors(this.queryId);
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var _a;
        var reobserveOptions = {
            pollInterval: 0
        };
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === "cache-and-network") reobserveOptions.fetchPolicy = fetchPolicy;
        else if (fetchPolicy === "no-cache") reobserveOptions.fetchPolicy = "no-cache";
        else reobserveOptions.fetchPolicy = "network-only";
        if (__DEV__ && variables && $4247e555a8486dc0$var$hasOwnProperty.call(variables, "variables")) {
            var queryDef = (0, $91fde6eb370810ac$export$d96b2213c1b9d3a9)(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function(v) {
                return v.variable.name.value === "variables";
            })) __DEV__ && (0, $a670ecbae0a62090$export$f5708dca728d7177).warn("Called refetch(".concat(JSON.stringify(variables), ") for query ").concat(((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || JSON.stringify(queryDef), ", which does not declare a $variables variable.\nDid you mean to call refetch(variables) instead of refetch({ variables })?"));
        }
        if (variables && !(0, $9e23b7a204e68d42$export$411ce8e5a71e3069)(this.options.variables, variables)) reobserveOptions.variables = this.options.variables = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, this.options.variables), variables);
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, this.options), {
            query: this.query
        }), fetchMoreOptions), {
            variables: (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, this.options.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: "no-cache"
        });
        var qid = this.queryManager.generateQueryId();
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) this.observe();
        var updatedQuerySet = new Set();
        return this.queryManager.fetchQuery(qid, combinedOptions, (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).fetchMore).then(function(fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).fetchMore) queryInfo.networkStatus = originalNetworkStatus;
            _this.queryManager.cache.batch({
                update: function(cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) cache.updateQuery({
                        query: _this.query,
                        variables: _this.variables,
                        returnPartialData: true,
                        optimistic: false
                    }, function(previous) {
                        return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables
                        });
                    });
                    else cache.writeQuery({
                        query: combinedOptions.query,
                        variables: combinedOptions.variables,
                        data: fetchMoreResult.data
                    });
                },
                onWatchUpdated: function(watch) {
                    updatedQuerySet.add(watch.query);
                }
            });
            return fetchMoreResult;
        }).finally(function() {
            if (!updatedQuerySet.has(_this.query)) $4247e555a8486dc0$export$419171d60552792a(_this);
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                __DEV__ && (0, $a670ecbae0a62090$export$f5708dca728d7177).error("Unhandled GraphQL subscription error", err);
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.setVariables = function(variables) {
        if ((0, $9e23b7a204e68d42$export$411ce8e5a71e3069)(this.variables, variables)) return this.observers.size ? this.result() : Promise.resolve();
        this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.reobserve({
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables
        }, (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).setVariables);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables
            });
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    ObservableQuery.prototype.applyNextFetchPolicy = function(reason, options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") ;
            else if (typeof options.nextFetchPolicy === "function") options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                reason: reason,
                options: options,
                observable: this,
                initialFetchPolicy: initialFetchPolicy
            });
            else if (reason === "variables-changed") options.fetchPolicy = initialFetchPolicy;
            else options.fetchPolicy = options.nextFetchPolicy;
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function(options, newNetworkStatus) {
        this.queryManager.setObservableQuery(this);
        return this.queryManager["fetchConcastWithInfo"](this.queryId, options, newNetworkStatus);
    };
    ObservableQuery.prototype.updatePolling = function() {
        var _this = this;
        if (this.queryManager.ssrMode) return;
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo && pollingInfo.interval === pollInterval) return;
        __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(pollInterval, "Attempted to start a polling query without a polling interval.") : (0, $a670ecbae0a62090$export$f5708dca728d7177)(pollInterval, 13);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function() {
            if (_this.pollingInfo) {
                if (!(0, $3e16f6dd50a68d19$export$37509604341a3464)(_this.queryInfo.networkStatus)) _this.reobserve({
                    fetchPolicy: _this.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
                }, (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).poll).then(poll, poll);
                else poll();
            }
        };
        var poll = function() {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function(newResult, variables) {
        if (variables === void 0) variables = this.variables;
        this.last = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, this.last), {
            result: this.queryManager.assumeImmutableResults ? newResult : (0, $70b1e5e671b77ed0$export$629a2bd3f5a49ecc)(newResult),
            variables: variables
        });
        if (!(0, $f58ee2abdca915e4$export$d307f5934e447d0e)(newResult.errors)) delete this.last.error;
        return this.last;
    };
    ObservableQuery.prototype.reobserveAsConcast = function(newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = newNetworkStatus === (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).refetch || newNetworkStatus === (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).fetchMore || newNetworkStatus === (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).poll;
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0, $7152c55085831e38$export$8e16b83750b44988)(this.options, newOptions || {});
        var options = useDisposableConcast ? mergedOptions : $4247e555a8486dc0$var$assign(this.options, mergedOptions);
        if (!useDisposableConcast) {
            this.updatePolling();
            if (newOptions && newOptions.variables && !(0, $9e23b7a204e68d42$export$411ce8e5a71e3069)(newOptions.variables, oldVariables) && options.fetchPolicy !== "standby" && options.fetchPolicy === oldFetchPolicy) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) newNetworkStatus = (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).setVariables;
            }
        }
        var variables = options.variables && (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, options.variables);
        var _a = this.fetch(options, newNetworkStatus), concast = _a.concast, fromLink = _a.fromLink;
        var observer = {
            next: function(result) {
                _this.reportResult(result, variables);
            },
            error: function(error) {
                _this.reportError(error, variables);
            }
        };
        if (!useDisposableConcast && fromLink) {
            if (this.concast && this.observer) this.concast.removeObserver(this.observer);
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast;
    };
    ObservableQuery.prototype.reobserve = function(newOptions, newNetworkStatus) {
        return this.reobserveAsConcast(newOptions, newNetworkStatus).promise;
    };
    ObservableQuery.prototype.observe = function() {
        this.reportResult(this.getCurrentResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function(result, variables) {
        var lastError = this.getLastError();
        if (lastError || this.isDifferentFromLastResult(result, variables)) {
            if (lastError || !result.partial || this.options.returnPartialData) this.updateLastResult(result, variables);
            (0, $32643571e181e5f5$export$9f6c99ae166dbeca)(this.observers, "next", result);
        }
    };
    ObservableQuery.prototype.reportError = function(error, variables) {
        var errorResult = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, this.getLastResult()), {
            error: error,
            errors: error.graphQLErrors,
            networkStatus: (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).error,
            loading: false
        });
        this.updateLastResult(errorResult, variables);
        (0, $32643571e181e5f5$export$9f6c99ae166dbeca)(this.observers, "error", this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function() {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        if (this.isTornDown) return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    return ObservableQuery;
}((0, $665f4cdbf299a5bf$export$77cea355fa80b5f4));
(0, $edc59b1e08b04dd3$export$33c8bd820eece9b2)($4247e555a8486dc0$export$6c1b56eac59c9584);
function $4247e555a8486dc0$export$419171d60552792a(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" || fetchPolicy === "network-only") return obsQuery.reobserve({
        fetchPolicy: "cache-first",
        nextFetchPolicy: function() {
            this.nextFetchPolicy = nextFetchPolicy;
            if (typeof nextFetchPolicy === "function") return nextFetchPolicy.apply(this, arguments);
            return fetchPolicy;
        }
    });
    return obsQuery.reobserve();
}
function $4247e555a8486dc0$var$defaultSubscriptionObserverErrorCallback(error) {
    __DEV__ && (0, $a670ecbae0a62090$export$f5708dca728d7177).error("Unhandled error", error.message, error.stack);
}
function $4247e555a8486dc0$export$b7e1973aacac3ae7(missing) {
    if (__DEV__ && missing) __DEV__ && (0, $a670ecbae0a62090$export$f5708dca728d7177).debug("Missing cache result fields: ".concat(JSON.stringify(missing)), missing);
}






function $1afc1f58e1d6a2f3$export$e7ecd7c16613ccfd(node) {
    return $1afc1f58e1d6a2f3$export$4cedd8740794bd78(node) || $1afc1f58e1d6a2f3$export$b05c7141ec7770ba(node) || $1afc1f58e1d6a2f3$export$fbc18e88163d676d(node);
}
function $1afc1f58e1d6a2f3$export$4cedd8740794bd78(node) {
    return node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).OPERATION_DEFINITION || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).FRAGMENT_DEFINITION;
}
function $1afc1f58e1d6a2f3$export$65772b71e1d017ba(node) {
    return node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).FIELD || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).FRAGMENT_SPREAD || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).INLINE_FRAGMENT;
}
function $1afc1f58e1d6a2f3$export$ab65b54ec7cbe9e4(node) {
    return node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).VARIABLE || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).INT || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).FLOAT || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).STRING || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).BOOLEAN || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).NULL || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).ENUM || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).LIST || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).OBJECT;
}
function $1afc1f58e1d6a2f3$export$f95bfad9e6aea45f(node) {
    return $1afc1f58e1d6a2f3$export$ab65b54ec7cbe9e4(node) && (node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).LIST ? node.values.some($1afc1f58e1d6a2f3$export$f95bfad9e6aea45f) : node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).OBJECT ? node.fields.some((field)=>$1afc1f58e1d6a2f3$export$f95bfad9e6aea45f(field.value)) : node.kind !== (0, $5a7bd784209d2d45$export$a84bdc57c5122798).VARIABLE);
}
function $1afc1f58e1d6a2f3$export$26e8a4730f4310f4(node) {
    return node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).NAMED_TYPE || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).LIST_TYPE || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).NON_NULL_TYPE;
}
function $1afc1f58e1d6a2f3$export$b05c7141ec7770ba(node) {
    return node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).SCHEMA_DEFINITION || $1afc1f58e1d6a2f3$export$a3584bba04f5bfe0(node) || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).DIRECTIVE_DEFINITION;
}
function $1afc1f58e1d6a2f3$export$a3584bba04f5bfe0(node) {
    return node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).UNION_TYPE_DEFINITION || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION;
}
function $1afc1f58e1d6a2f3$export$fbc18e88163d676d(node) {
    return node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).SCHEMA_EXTENSION || $1afc1f58e1d6a2f3$export$d7907721b241e11f(node);
}
function $1afc1f58e1d6a2f3$export$d7907721b241e11f(node) {
    return node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).UNION_TYPE_EXTENSION || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION || node.kind === (0, $5a7bd784209d2d45$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION;
}



// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
var $3f4d6b9bcf7217a2$var$defaultMakeData = function() {
    return Object.create(null);
};
// Useful for processing arguments objects as well as arrays.
var $3f4d6b9bcf7217a2$var$_a = Array.prototype, $3f4d6b9bcf7217a2$var$forEach = $3f4d6b9bcf7217a2$var$_a.forEach, $3f4d6b9bcf7217a2$var$slice = $3f4d6b9bcf7217a2$var$_a.slice;
var $3f4d6b9bcf7217a2$export$73571c50d0f2507e = /** @class */ function() {
    function Trie(weakness, makeData) {
        if (weakness === void 0) weakness = true;
        if (makeData === void 0) makeData = $3f4d6b9bcf7217a2$var$defaultMakeData;
        this.weakness = weakness;
        this.makeData = makeData;
    }
    Trie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    Trie.prototype.lookupArray = function(array) {
        var node = this;
        $3f4d6b9bcf7217a2$var$forEach.call(array, function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = this.makeData($3f4d6b9bcf7217a2$var$slice.call(array)));
    };
    Trie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $3f4d6b9bcf7217a2$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    };
    return Trie;
}();
function $3f4d6b9bcf7217a2$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}


// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let $83a81166fe444afc$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const $83a81166fe444afc$var$MISSING_VALUE = {};
let $83a81166fe444afc$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const $83a81166fe444afc$var$makeSlotClass = ()=>class Slot {
        constructor(){
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $83a81166fe444afc$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        hasValue() {
            for(let context = $83a81166fe444afc$var$currentContext; context; context = context.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === $83a81166fe444afc$var$MISSING_VALUE) break;
                if (context !== $83a81166fe444afc$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $83a81166fe444afc$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($83a81166fe444afc$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $83a81166fe444afc$var$currentContext.slots[this.id] = $83a81166fe444afc$var$MISSING_VALUE;
            return false;
        }
        getValue() {
            if (this.hasValue()) return $83a81166fe444afc$var$currentContext.slots[this.id];
        }
        withValue(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            const slots = {
                __proto__: null,
                [this.id]: value
            };
            const parent = $83a81166fe444afc$var$currentContext;
            $83a81166fe444afc$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $83a81166fe444afc$var$currentContext = parent;
            }
        }
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        static bind(callback) {
            const context = $83a81166fe444afc$var$currentContext;
            return function() {
                const saved = $83a81166fe444afc$var$currentContext;
                try {
                    $83a81166fe444afc$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $83a81166fe444afc$var$currentContext = saved;
                }
            };
        }
        // Immediately run a callback function without any captured context.
        static noContext(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($83a81166fe444afc$var$currentContext) {
                const saved = $83a81166fe444afc$var$currentContext;
                try {
                    $83a81166fe444afc$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $83a81166fe444afc$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        }
    };
function $83a81166fe444afc$var$maybe(fn) {
    try {
        return fn();
    } catch (ignored) {}
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const $83a81166fe444afc$var$globalKey = "@wry/context:Slot";
const $83a81166fe444afc$var$host = // Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
$83a81166fe444afc$var$maybe(()=>globalThis) || // Fall back to global, which works in Node.js and may be converted by some
// bundlers to the appropriate identifier (window, self, ...) depending on the
// bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
$83a81166fe444afc$var$maybe(()=>$parcel$global) || // Otherwise, use a dummy host that's local to this module. We used to fall
// back to using the Array constructor as a namespace, but that was flagged in
// https://github.com/benjamn/wryware/issues/347, and can be avoided.
Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const $83a81166fe444afc$var$globalHost = $83a81166fe444afc$var$host;
const $83a81166fe444afc$export$8c6ed5c666ac1360 = $83a81166fe444afc$var$globalHost[$83a81166fe444afc$var$globalKey] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[$83a81166fe444afc$var$globalKey] || function(Slot) {
    try {
        Object.defineProperty($83a81166fe444afc$var$globalHost, $83a81166fe444afc$var$globalKey, {
            value: Slot,
            enumerable: false,
            writable: false,
            // When it was possible for globalHost to be the Array constructor (a
            // legacy Slot dedup strategy), it was important for the property to be
            // configurable:true so it could be deleted. That does not seem to be as
            // important when globalHost is the global object, but I don't want to
            // cause similar problems again, and configurable:true seems safest.
            // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
            configurable: true
        });
    } finally{
        return Slot;
    }
}($83a81166fe444afc$var$makeSlotClass());


const { bind: $2fc9e2774ee3fefa$export$2385a24977818dd0 , noContext: $2fc9e2774ee3fefa$export$9fa6f2e300a97f8  } = (0, $83a81166fe444afc$export$8c6ed5c666ac1360);
function $2fc9e2774ee3fefa$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($2fc9e2774ee3fefa$export$2385a24977818dd0(callback), delay);
}
function $2fc9e2774ee3fefa$export$d5d7536e965c82da(genFn) {
    return function() {
        const gen = genFn.apply(this, arguments);
        const boundNext = $2fc9e2774ee3fefa$export$2385a24977818dd0(gen.next);
        const boundThrow = $2fc9e2774ee3fefa$export$2385a24977818dd0(gen.throw);
        return new Promise((resolve, reject)=>{
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if ($2fc9e2774ee3fefa$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            const invokeNext = (value)=>invoke(boundNext, value);
            const invokeThrow = (error)=>invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function $2fc9e2774ee3fefa$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const $2fc9e2774ee3fefa$var$wrappedFibers = [];
function $2fc9e2774ee3fefa$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($2fc9e2774ee3fefa$var$wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method)=>{
            const fn = obj[method];
            obj[method] = function() {
                return $2fc9e2774ee3fefa$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $2fc9e2774ee3fefa$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}


function $440f5337124fee2c$var$defaultDispose() {}
var $440f5337124fee2c$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $440f5337124fee2c$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var node = this.getNode(key);
        return node && node.value;
    };
    Cache.prototype.getNode = function(key) {
        var node = this.map.get(key);
        if (node && node !== this.newest) {
            var older = node.older, newer = node.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    };
    Cache.prototype.set = function(key, value) {
        var node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var node = this.map.get(key);
        if (node) {
            if (node === this.newest) this.newest = node.older;
            if (node === this.oldest) this.oldest = node.newer;
            if (node.newer) node.newer.older = node.older;
            if (node.older) node.older.newer = node.newer;
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $440f5337124fee2c$var$parentEntrySlot = new (0, $83a81166fe444afc$export$8c6ed5c666ac1360)();
var $440f5337124fee2c$var$_a;
var $440f5337124fee2c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var // This Array.from polyfill is restricted to working with Set<any> for now,
// but we can improve the polyfill and add other input types, as needed. Note
// that this fallback implementation will only be used if the host environment
// does not support a native Array.from function. In most modern JS runtimes,
// the toArray function exported here will be === Array.from.
$440f5337124fee2c$var$toArray = ($440f5337124fee2c$var$_a = Array.from, $440f5337124fee2c$var$_a === void 0 ? function(collection) {
    var array = [];
    collection.forEach(function(item) {
        return array.push(item);
    });
    return array;
} : $440f5337124fee2c$var$_a);
function $440f5337124fee2c$var$maybeUnsubscribe(entryOrDep) {
    var unsubscribe = entryOrDep.unsubscribe;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}
var $440f5337124fee2c$var$emptySetPool = [];
var $440f5337124fee2c$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $440f5337124fee2c$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $440f5337124fee2c$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $440f5337124fee2c$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $440f5337124fee2c$var$valueCopy(value) {
    return value.slice(0);
}
var $440f5337124fee2c$var$Entry = /** @class */ function() {
    function Entry(fn) {
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++Entry.count;
    }
    Entry.prototype.peek = function() {
        if (this.value.length === 1 && !$440f5337124fee2c$var$mightBeDirty(this)) {
            $440f5337124fee2c$var$rememberParent(this);
            return this.value[0];
        }
    };
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function(args) {
        $440f5337124fee2c$var$assert(!this.recomputing, "already recomputing");
        $440f5337124fee2c$var$rememberParent(this);
        return $440f5337124fee2c$var$mightBeDirty(this) ? $440f5337124fee2c$var$reallyRecompute(this, args) : $440f5337124fee2c$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $440f5337124fee2c$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $440f5337124fee2c$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        $440f5337124fee2c$var$forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        $440f5337124fee2c$var$eachParent(this, function(parent, child) {
            parent.setDirty();
            $440f5337124fee2c$var$forgetChild(parent, _this);
        });
    };
    Entry.prototype.forget = function() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    };
    Entry.prototype.dependOn = function(dep) {
        dep.add(this);
        if (!this.deps) this.deps = $440f5337124fee2c$var$emptySetPool.pop() || new Set();
        this.deps.add(dep);
    };
    Entry.prototype.forgetDeps = function() {
        var _this = this;
        if (this.deps) {
            $440f5337124fee2c$var$toArray(this.deps).forEach(function(dep) {
                return dep.delete(_this);
            });
            this.deps.clear();
            $440f5337124fee2c$var$emptySetPool.push(this.deps);
            this.deps = null;
        }
    };
    Entry.count = 0;
    return Entry;
}();
function $440f5337124fee2c$var$rememberParent(child) {
    var parent = $440f5337124fee2c$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($440f5337124fee2c$var$mightBeDirty(child)) $440f5337124fee2c$var$reportDirtyChild(parent, child);
        else $440f5337124fee2c$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $440f5337124fee2c$var$reallyRecompute(entry, args) {
    $440f5337124fee2c$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $440f5337124fee2c$var$parentEntrySlot.withValue(entry, $440f5337124fee2c$var$recomputeNewValue, [
        entry,
        args
    ]);
    if ($440f5337124fee2c$var$maybeSubscribe(entry, args)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $440f5337124fee2c$var$setClean(entry);
    return $440f5337124fee2c$var$valueGet(entry.value);
}
function $440f5337124fee2c$var$recomputeNewValue(entry, args) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $440f5337124fee2c$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $440f5337124fee2c$var$setClean(entry) {
    entry.dirty = false;
    if ($440f5337124fee2c$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $440f5337124fee2c$var$reportClean(entry);
}
function $440f5337124fee2c$var$reportDirty(child) {
    $440f5337124fee2c$var$eachParent(child, $440f5337124fee2c$var$reportDirtyChild);
}
function $440f5337124fee2c$var$reportClean(child) {
    $440f5337124fee2c$var$eachParent(child, $440f5337124fee2c$var$reportCleanChild);
}
function $440f5337124fee2c$var$eachParent(child, callback) {
    var parentCount = child.parents.size;
    if (parentCount) {
        var parents = $440f5337124fee2c$var$toArray(child.parents);
        for(var i = 0; i < parentCount; ++i)callback(parents[i], child);
    }
}
// Let a parent Entry know that one of its children may be dirty.
function $440f5337124fee2c$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $440f5337124fee2c$var$assert(parent.childValues.has(child));
    $440f5337124fee2c$var$assert($440f5337124fee2c$var$mightBeDirty(child));
    var parentWasClean = !$440f5337124fee2c$var$mightBeDirty(parent);
    if (!parent.dirtyChildren) parent.dirtyChildren = $440f5337124fee2c$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) $440f5337124fee2c$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $440f5337124fee2c$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $440f5337124fee2c$var$assert(parent.childValues.has(child));
    $440f5337124fee2c$var$assert(!$440f5337124fee2c$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $440f5337124fee2c$var$valueCopy(child.value));
    else if (!$440f5337124fee2c$var$valueIs(childValue, child.value)) parent.setDirty();
    $440f5337124fee2c$var$removeDirtyChild(parent, child);
    if ($440f5337124fee2c$var$mightBeDirty(parent)) return;
    $440f5337124fee2c$var$reportClean(parent);
}
function $440f5337124fee2c$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($440f5337124fee2c$var$emptySetPool.length < $440f5337124fee2c$var$POOL_TARGET_SIZE) $440f5337124fee2c$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function $440f5337124fee2c$var$forgetChildren(parent) {
    if (parent.childValues.size > 0) parent.childValues.forEach(function(_value, child) {
        $440f5337124fee2c$var$forgetChild(parent, child);
    });
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $440f5337124fee2c$var$assert(parent.dirtyChildren === null);
}
function $440f5337124fee2c$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $440f5337124fee2c$var$removeDirtyChild(parent, child);
}
function $440f5337124fee2c$var$maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") try {
        $440f5337124fee2c$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
var $440f5337124fee2c$var$EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true
};
function $440f5337124fee2c$export$c723b7eff9d8f870(options) {
    var depsByKey = new Map();
    var subscribe = options && options.subscribe;
    function depend(key) {
        var parent = $440f5337124fee2c$var$parentEntrySlot.getValue();
        if (parent) {
            var dep_1 = depsByKey.get(key);
            if (!dep_1) depsByKey.set(key, dep_1 = new Set);
            parent.dependOn(dep_1);
            if (typeof subscribe === "function") {
                $440f5337124fee2c$var$maybeUnsubscribe(dep_1);
                dep_1.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        var dep = depsByKey.get(key);
        if (dep) {
            var m_1 = entryMethodName && $440f5337124fee2c$var$hasOwnProperty.call($440f5337124fee2c$var$EntryMethods, entryMethodName) ? entryMethodName : "setDirty";
            // We have to use toArray(dep).forEach instead of dep.forEach, because
            // modifying a Set while iterating over it can cause elements in the Set
            // to be removed from the Set before they've been iterated over.
            $440f5337124fee2c$var$toArray(dep).forEach(function(entry) {
                return entry[m_1]();
            });
            depsByKey.delete(key);
            $440f5337124fee2c$var$maybeUnsubscribe(dep);
        }
    };
    return depend;
}
function $440f5337124fee2c$var$makeDefaultMakeCacheKeyFunction() {
    var keyTrie = new (0, $3f4d6b9bcf7217a2$export$73571c50d0f2507e)(typeof WeakMap === "function");
    return function() {
        return keyTrie.lookupArray(arguments);
    };
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $440f5337124fee2c$export$cd3144f8dd136006 = $440f5337124fee2c$var$makeDefaultMakeCacheKeyFunction();
var $440f5337124fee2c$var$caches = new Set();
function $440f5337124fee2c$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $440f5337124fee2c$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var keyArgs = options.keyArgs;
    var makeCacheKey = options.makeCacheKey || $440f5337124fee2c$var$makeDefaultMakeCacheKeyFunction();
    var optimistic = function() {
        var key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new $440f5337124fee2c$var$Entry(originalFunction));
            entry.subscribe = options.subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $440f5337124fee2c$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$440f5337124fee2c$var$parentEntrySlot.hasValue()) {
            $440f5337124fee2c$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $440f5337124fee2c$var$caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: function() {
            return cache["map"].size;
        },
        configurable: false,
        enumerable: false
    });
    function dirtyKey(key) {
        var entry = cache.get(key);
        if (entry) entry.setDirty();
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        var entry = cache.get(key);
        if (entry) return entry.peek();
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return cache.delete(key);
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}



var $67dda3abe8e2dcd2$export$ac9723609f5c76c2 = new (0, $83a81166fe444afc$export$8c6ed5c666ac1360)();
var $67dda3abe8e2dcd2$var$cacheInfoMap = new WeakMap();
function $67dda3abe8e2dcd2$var$getCacheInfo(cache) {
    var info = $67dda3abe8e2dcd2$var$cacheInfoMap.get(cache);
    if (!info) $67dda3abe8e2dcd2$var$cacheInfoMap.set(cache, info = {
        vars: new Set,
        dep: (0, $440f5337124fee2c$export$c723b7eff9d8f870)()
    });
    return info;
}
function $67dda3abe8e2dcd2$export$cbe12faed7725318(cache) {
    $67dda3abe8e2dcd2$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.forgetCache(cache);
    });
}
function $67dda3abe8e2dcd2$export$f342bdd61b3e9412(cache) {
    $67dda3abe8e2dcd2$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.attachCache(cache);
    });
}
function $67dda3abe8e2dcd2$export$5345c8ac69b4a9db(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function(newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function(cache) {
                    $67dda3abe8e2dcd2$var$getCacheInfo(cache).dep.dirty(rv);
                    $67dda3abe8e2dcd2$var$broadcast(cache);
                });
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function(listener) {
                    return listener(value);
                });
            }
        } else {
            var cache = $67dda3abe8e2dcd2$export$ac9723609f5c76c2.getValue();
            if (cache) {
                attach(cache);
                $67dda3abe8e2dcd2$var$getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function(listener) {
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function(cache) {
        caches.add(cache);
        $67dda3abe8e2dcd2$var$getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function(cache) {
        return caches.delete(cache);
    };
    return rv;
}
function $67dda3abe8e2dcd2$var$broadcast(cache) {
    if (cache.broadcastWatches) cache.broadcastWatches();
}


var $aee3cb4d5670c812$export$19901bcd339c3ded = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.selectionsToResolveCache = new WeakMap();
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $5354ae177e970f6d$export$dd702b3c8240390c)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $5354ae177e970f6d$export$dd702b3c8240390c)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $1aaf9c65fb7afb7d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $1aaf9c65fb7afb7d$export$67ebef60e6f28a6)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $62aba4d864227324$export$2dafb573e282fe8d)([
            "client"
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return (0, $6457d3104a36d467$export$8eae69e876ee321e)(document);
    };
    LocalState.prototype.prepareContext = function(context) {
        var cache = this.cache;
        return (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                return cache.identify(obj);
            }
        });
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $1aaf9c65fb7afb7d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $1aaf9c65fb7afb7d$export$67ebef60e6f28a6)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $5df15baf989f8f0b$export$bf638b60ea8b89b7)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === "client" && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === "always" && arg.value.kind === "BooleanValue" && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $5df15baf989f8f0b$export$a89c95c098ac2a58;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $6457d3104a36d467$export$57c368c23873f32b)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $1aaf9c65fb7afb7d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, selectionsToResolve, definitionOperation, defaultOperationType, _a, cache, client, execContext, isClientFieldDescendant;
            return (0, $1aaf9c65fb7afb7d$export$67ebef60e6f28a6)(this, function(_b) {
                mainDefinition = (0, $91fde6eb370810ac$export$f431198736b7f96d)(document);
                fragments = (0, $91fde6eb370810ac$export$5320a7ba9466a3df)(document);
                fragmentMap = (0, $f80c7baa4263f96d$export$193789b4c8246dd4)(fragments);
                selectionsToResolve = this.collectSelectionsToResolve(mainDefinition, fragmentMap);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? definitionOperation.charAt(0).toUpperCase() + definitionOperation.slice(1) : "Query";
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    selectionsToResolve: selectionsToResolve,
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                isClientFieldDescendant = false;
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, isClientFieldDescendant, rootValue, execContext) {
        return (0, $1aaf9c65fb7afb7d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $1aaf9c65fb7afb7d$export$67ebef60e6f28a6)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $1aaf9c65fb7afb7d$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $1aaf9c65fb7afb7d$export$67ebef60e6f28a6)(this, function(_a) {
                            if (!isClientFieldDescendant && !execContext.selectionsToResolve.has(selection)) return [
                                2
                            ];
                            if (!(0, $62aba4d864227324$export$3dc388a5f013b4a5)(selection, variables)) return [
                                2
                            ];
                            if ((0, $5763c7b47888ba33$export$fb56ad75dd311c12)(selection)) return [
                                2,
                                this.resolveField(selection, isClientFieldDescendant, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== "undefined") resultsToMerge.push((_a = {}, _a[(0, $5763c7b47888ba33$export$7d1ad22471852218)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $5763c7b47888ba33$export$22a1cdafaf27bcff)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(fragment, "No fragment named ".concat(selection.name.value)) : (0, $a670ecbae0a62090$export$f5708dca728d7177)(fragment, 11);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $5354ae177e970f6d$export$160070228be94b08)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, isClientFieldDescendant, rootValue, execContext) {
        return (0, $1aaf9c65fb7afb7d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $1aaf9c65fb7afb7d$export$67ebef60e6f28a6)(this, function(_a) {
                if (!rootValue) return [
                    2,
                    null
                ];
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $5763c7b47888ba33$export$7d1ad22471852218)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve((0, $67dda3abe8e2dcd2$export$ac9723609f5c76c2).withValue(this.cache, resolve, [
                            rootValue,
                            (0, $5763c7b47888ba33$export$3f5a60fb6a781b4f)(field, variables),
                            execContext.context,
                            {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }
                        ]));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        var _a, _b;
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === "export" && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === "as" && arg.value.kind === "StringValue") execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        var isClientField = (_b = (_a = field.directives) === null || _a === void 0 ? void 0 : _a.some(function(d) {
                            return d.name.value === "client";
                        })) !== null && _b !== void 0 ? _b : false;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant || isClientField, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant || isClientField, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, isClientFieldDescendant, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext);
        }));
    };
    LocalState.prototype.collectSelectionsToResolve = function(mainDefinition, fragmentMap) {
        var isSingleASTNode = function(node) {
            return !Array.isArray(node);
        };
        var selectionsToResolveCache = this.selectionsToResolveCache;
        function collectByDefinition(definitionNode) {
            if (!selectionsToResolveCache.has(definitionNode)) {
                var matches_1 = new Set();
                selectionsToResolveCache.set(definitionNode, matches_1);
                (0, $5df15baf989f8f0b$export$bf638b60ea8b89b7)(definitionNode, {
                    Directive: function(node, _, __, ___, ancestors) {
                        if (node.name.value === "client") ancestors.forEach(function(node) {
                            if (isSingleASTNode(node) && (0, $1afc1f58e1d6a2f3$export$65772b71e1d017ba)(node)) matches_1.add(node);
                        });
                    },
                    FragmentSpread: function(spread, _, __, ___, ancestors) {
                        var fragment = fragmentMap[spread.name.value];
                        __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(fragment, "No fragment named ".concat(spread.name.value)) : (0, $a670ecbae0a62090$export$f5708dca728d7177)(fragment, 12);
                        var fragmentSelections = collectByDefinition(fragment);
                        if (fragmentSelections.size > 0) {
                            ancestors.forEach(function(node) {
                                if (isSingleASTNode(node) && (0, $1afc1f58e1d6a2f3$export$65772b71e1d017ba)(node)) matches_1.add(node);
                            });
                            matches_1.add(spread);
                            fragmentSelections.forEach(function(selection) {
                                matches_1.add(selection);
                            });
                        }
                    }
                });
            }
            return selectionsToResolveCache.get(definitionNode);
        }
        return collectByDefinition(mainDefinition);
    };
    return LocalState;
}();








var $741f0321bdcf61c0$var$destructiveMethodCounts = new ((0, $a90b2277f663d01f$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
function $741f0321bdcf61c0$var$wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") cache[methodName] = function() {
        $741f0321bdcf61c0$var$destructiveMethodCounts.set(cache, ($741f0321bdcf61c0$var$destructiveMethodCounts.get(cache) + 1) % 1e15);
        return original.apply(this, arguments);
    };
}
function $741f0321bdcf61c0$var$cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
var $741f0321bdcf61c0$export$79a6120a39c90b6a = function() {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) queryId = queryManager.generateQueryId();
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.subscriptions = new Set();
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        if (!$741f0321bdcf61c0$var$destructiveMethodCounts.has(cache)) {
            $741f0321bdcf61c0$var$destructiveMethodCounts.set(cache, 0);
            $741f0321bdcf61c0$var$wrapDestructiveCacheMethod(cache, "evict");
            $741f0321bdcf61c0$var$wrapDestructiveCacheMethod(cache, "modify");
            $741f0321bdcf61c0$var$wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function(query) {
        var networkStatus = query.networkStatus || (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).loading;
        if (this.variables && this.networkStatus !== (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).loading && !(0, $9e23b7a204e68d42$export$411ce8e5a71e3069)(this.variables, query.variables)) networkStatus = (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).setVariables;
        if (!(0, $9e23b7a204e68d42$export$411ce8e5a71e3069)(query.variables, this.variables)) this.lastDiff = void 0;
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus
        });
        if (query.observableQuery) this.setObservableQuery(query.observableQuery);
        if (query.lastRequestId) this.lastRequestId = query.lastRequestId;
        return this;
    };
    QueryInfo.prototype.reset = function() {
        $741f0321bdcf61c0$var$cancelNotifyTimeout(this);
        this.dirty = false;
    };
    QueryInfo.prototype.getDiff = function(variables) {
        if (variables === void 0) variables = this.variables;
        var options = this.getDiffOptions(variables);
        if (this.lastDiff && (0, $9e23b7a204e68d42$export$411ce8e5a71e3069)(options, this.lastDiff.options)) return this.lastDiff.diff;
        this.updateWatch(this.variables = variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return {
            complete: false
        };
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function(diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions()
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function(variables) {
        var _a;
        if (variables === void 0) variables = this.variables;
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults
        };
    };
    QueryInfo.prototype.setDiff = function(diff) {
        var _this = this;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        this.updateLastDiff(diff);
        if (!this.dirty && !(0, $9e23b7a204e68d42$export$411ce8e5a71e3069)(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) this.notifyTimeout = setTimeout(function() {
                return _this.notify();
            }, 0);
        }
    };
    QueryInfo.prototype.setObservableQuery = function(oq) {
        var _this = this;
        if (oq === this.observableQuery) return;
        if (this.oqListener) this.listeners.delete(this.oqListener);
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function() {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) oq["observe"]();
                else (0, $4247e555a8486dc0$export$419171d60552792a)(oq);
            });
        } else delete this.oqListener;
    };
    QueryInfo.prototype.notify = function() {
        var _this = this;
        $741f0321bdcf61c0$var$cancelNotifyTimeout(this);
        if (this.shouldNotify()) this.listeners.forEach(function(listener) {
            return listener(_this);
        });
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function() {
        if (!this.dirty || !this.listeners.size) return false;
        if ((0, $3e16f6dd50a68d19$export$37509604341a3464)(this.networkStatus) && this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" && fetchPolicy !== "cache-and-network") return false;
        }
        return true;
    };
    QueryInfo.prototype.stop = function() {
        if (!this.stopped) {
            this.stopped = true;
            this.reset();
            this.cancel();
            this.cancel = QueryInfo.prototype.cancel;
            this.subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            var oq = this.observableQuery;
            if (oq) oq.stopPolling();
        }
    };
    QueryInfo.prototype.cancel = function() {};
    QueryInfo.prototype.updateWatch = function(variables) {
        var _this = this;
        if (variables === void 0) variables = this.variables;
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return;
        var watchOptions = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, this.getDiffOptions(variables)), {
            watcher: this,
            callback: function(diff) {
                return _this.setDiff(diff);
            }
        });
        if (!this.lastWatch || !(0, $9e23b7a204e68d42$export$411ce8e5a71e3069)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function() {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function(result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite && lastWrite.dmCount === $741f0321bdcf61c0$var$destructiveMethodCounts.get(this.cache) && (0, $9e23b7a204e68d42$export$411ce8e5a71e3069)(variables, lastWrite.variables) && (0, $9e23b7a204e68d42$export$411ce8e5a71e3069)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function(result, document, options, cacheWriteBehavior) {
        var _this = this;
        var merger = new (0, $5354ae177e970f6d$export$509e11c221f576c0)();
        var graphQLErrors = (0, $f58ee2abdca915e4$export$d307f5934e447d0e)(result.errors) ? result.errors.slice(0) : [];
        this.reset();
        if ("incremental" in result && (0, $f58ee2abdca915e4$export$d307f5934e447d0e)(result.incremental)) {
            var mergedData = (0, $402a196e797ba47a$export$9a905f57d6393874)(this.getDiff().result, result);
            result.data = mergedData;
        } else if ("hasNext" in result && result.hasNext) {
            var diff = this.getDiff();
            result.data = merger.merge(diff.result, result.data);
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === "no-cache") this.updateLastDiff({
            result: result.data,
            complete: true
        }, this.getDiffOptions(options.variables));
        else if (cacheWriteBehavior !== 0) {
            if ($741f0321bdcf61c0$export$5f47a9fb9a521654(result, options.errorPolicy)) this.cache.performTransaction(function(cache) {
                if (_this.shouldWrite(result, options.variables)) {
                    cache.writeQuery({
                        query: document,
                        data: result.data,
                        variables: options.variables,
                        overwrite: cacheWriteBehavior === 1
                    });
                    _this.lastWrite = {
                        result: result,
                        variables: options.variables,
                        dmCount: $741f0321bdcf61c0$var$destructiveMethodCounts.get(_this.cache)
                    };
                } else if (_this.lastDiff && _this.lastDiff.diff.complete) {
                    result.data = _this.lastDiff.diff.result;
                    return;
                }
                var diffOptions = _this.getDiffOptions(options.variables);
                var diff = cache.diff(diffOptions);
                if (!_this.stopped) _this.updateWatch(options.variables);
                _this.updateLastDiff(diff, diffOptions);
                if (diff.complete) result.data = diff.result;
            });
            else this.lastWrite = void 0;
        }
    };
    QueryInfo.prototype.markReady = function() {
        this.networkError = null;
        return this.networkStatus = (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).ready;
    };
    QueryInfo.prototype.markError = function(error) {
        this.networkStatus = (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) this.graphQLErrors = error.graphQLErrors;
        if (error.networkError) this.networkError = error.networkError;
        return error;
    };
    return QueryInfo;
}();
function $741f0321bdcf61c0$export$5f47a9fb9a521654(result, errorPolicy) {
    if (errorPolicy === void 0) errorPolicy = "none";
    var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    var writeWithErrors = !(0, $dd2a078388f31bf4$export$b4df399e879e53ab)(result);
    if (!writeWithErrors && ignoreErrors && result.data) writeWithErrors = true;
    return writeWithErrors;
}


var $ad42edcf594030a7$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $ad42edcf594030a7$export$b986383a50b53ea4 = function() {
    function QueryManager(_a) {
        var cache = _a.cache, link = _a.link, defaultOptions = _a.defaultOptions, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, onBroadcast = _a.onBroadcast, _c = _a.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _a.clientAwareness, clientAwareness = _d === void 0 ? {} : _d, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.clientAwareness = {};
        this.queries = new Map();
        this.fetchCancelFns = new Map();
        this.transformCache = new ((0, $a90b2277f663d01f$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        this.inFlightLinkObservables = new Map();
        this.cache = cache;
        this.link = link;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.queryDeduplication = queryDeduplication;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new (0, $aee3cb4d5670c812$export$19901bcd339c3ded)({
            cache: cache
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
        if (this.onBroadcast = onBroadcast) this.mutationStore = Object.create(null);
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches(__DEV__ ? new (0, $a670ecbae0a62090$export$cea12affaee22fe8)("QueryManager stopped while query was in flight") : new (0, $a670ecbae0a62090$export$cea12affaee22fe8)(14));
    };
    QueryManager.prototype.cancelPendingFetches = function(error) {
        this.fetchCancelFns.forEach(function(cancel) {
            return cancel(error);
        });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function(_a) {
        var _b, _c;
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueries = _a.updateQueries, _d = _a.refetchQueries, refetchQueries = _d === void 0 ? [] : _d, _e = _a.awaitRefetchQueries, awaitRefetchQueries = _e === void 0 ? false : _e, updateWithProxyFn = _a.update, onQueryUpdated = _a.onQueryUpdated, _f = _a.fetchPolicy, fetchPolicy = _f === void 0 ? ((_b = this.defaultOptions.mutate) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "network-only" : _f, _g = _a.errorPolicy, errorPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.errorPolicy) || "none" : _g, keepRootFields = _a.keepRootFields, context = _a.context;
        return (0, $1aaf9c65fb7afb7d$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var mutationId, _h, document, hasClientExports, mutationStoreValue, self;
            return (0, $1aaf9c65fb7afb7d$export$67ebef60e6f28a6)(this, function(_j) {
                switch(_j.label){
                    case 0:
                        __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(mutation, "mutation option is required. You must specify your GraphQL document in the mutation option.") : (0, $a670ecbae0a62090$export$f5708dca728d7177)(mutation, 15);
                        __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(fetchPolicy === "network-only" || fetchPolicy === "no-cache", "Mutations support only 'network-only' or 'no-cache' fetchPolicy strings. The default `network-only` behavior automatically writes mutation results to the cache. Passing `no-cache` skips the cache write.") : (0, $a670ecbae0a62090$export$f5708dca728d7177)(fetchPolicy === "network-only" || fetchPolicy === "no-cache", 16);
                        mutationId = this.generateMutationId();
                        _h = this.transform(mutation), document = _h.document, hasClientExports = _h.hasClientExports;
                        mutation = this.cache.transformForLink(document);
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _j.sent();
                        _j.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore && (this.mutationStore[mutationId] = {
                            mutation: mutation,
                            variables: variables,
                            loading: true,
                            error: null
                        });
                        if (optimisticResponse) this.markMutationOptimistic(optimisticResponse, {
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            fetchPolicy: fetchPolicy,
                            errorPolicy: errorPolicy,
                            context: context,
                            updateQueries: updateQueries,
                            update: updateWithProxyFn,
                            keepRootFields: keepRootFields
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                return (0, $bfa90a84bdddeaf8$export$707ee4c4c95d39e3)(self.getObservableFromLink(mutation, (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false), function(result) {
                                    if ((0, $dd2a078388f31bf4$export$b4df399e879e53ab)(result) && errorPolicy === "none") throw new (0, $783678ef924f64c3$export$26a337512320b8c6)({
                                        graphQLErrors: (0, $dd2a078388f31bf4$export$a163557155188b6e)(result)
                                    });
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, result);
                                    if (typeof refetchQueries === "function") refetchQueries = refetchQueries(storeResult);
                                    if (errorPolicy === "ignore" && (0, $dd2a078388f31bf4$export$b4df399e879e53ab)(storeResult)) delete storeResult.errors;
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: optimisticResponse ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields
                                    });
                                }).subscribe({
                                    next: function(storeResult) {
                                        self.broadcastQueries();
                                        if (!("hasNext" in storeResult) || storeResult.hasNext === false) resolve(storeResult);
                                    },
                                    error: function(err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (optimisticResponse) self.cache.removeOptimistic(mutationId);
                                        self.broadcastQueries();
                                        reject(err instanceof (0, $783678ef924f64c3$export$26a337512320b8c6) ? err : new (0, $783678ef924f64c3$export$26a337512320b8c6)({
                                            networkError: err
                                        }));
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function(mutation, cache) {
        var _this = this;
        if (cache === void 0) cache = this.cache;
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && (0, $741f0321bdcf61c0$export$5f47a9fb9a521654)(result, mutation.errorPolicy)) {
            if (!(0, $402a196e797ba47a$export$879767c5cdf33cb3)(result)) cacheWrites.push({
                result: result.data,
                dataId: "ROOT_MUTATION",
                query: mutation.document,
                variables: mutation.variables
            });
            if ((0, $402a196e797ba47a$export$879767c5cdf33cb3)(result) && (0, $f58ee2abdca915e4$export$d307f5934e447d0e)(result.incremental)) {
                var diff = cache.diff({
                    id: "ROOT_MUTATION",
                    query: this.transform(mutation.document).asQuery,
                    variables: mutation.variables,
                    optimistic: false,
                    returnPartialData: true
                });
                var mergedData = void 0;
                if (diff.result) mergedData = (0, $402a196e797ba47a$export$9a905f57d6393874)(diff.result, result);
                if (typeof mergedData !== "undefined") {
                    result.data = mergedData;
                    cacheWrites.push({
                        result: mergedData,
                        dataId: "ROOT_MUTATION",
                        query: mutation.document,
                        variables: mutation.variables
                    });
                }
            }
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                var queryName = observableQuery && observableQuery.queryName;
                if (!queryName || !$ad42edcf594030a7$var$hasOwnProperty.call(updateQueries_1, queryName)) return;
                var updater = updateQueries_1[queryName];
                var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                var _c = cache.diff({
                    query: document,
                    variables: variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _c.result, complete = _c.complete;
                if (complete && currentQueryResult) {
                    var nextQueryResult = updater(currentQueryResult, {
                        mutationResult: result,
                        queryName: document && (0, $91fde6eb370810ac$export$41bca9dc6871dd4e)(document) || void 0,
                        queryVariables: variables
                    });
                    if (nextQueryResult) cacheWrites.push({
                        result: nextQueryResult,
                        dataId: "ROOT_QUERY",
                        query: document,
                        variables: variables
                    });
                }
            });
        }
        if (cacheWrites.length > 0 || mutation.refetchQueries || mutation.update || mutation.onQueryUpdated || mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function(cache) {
                    if (!skipCache) cacheWrites.forEach(function(write) {
                        return cache.write(write);
                    });
                    var update = mutation.update;
                    var isFinalResult = !(0, $402a196e797ba47a$export$f90dc0a3531b8b83)(result) || (0, $402a196e797ba47a$export$879767c5cdf33cb3)(result) && !result.hasNext;
                    if (update) {
                        if (!skipCache) {
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                query: _this.transform(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true
                            });
                            if (diff.complete) {
                                result = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, result), {
                                    data: diff.result
                                });
                                if ("incremental" in result) delete result.incremental;
                                if ("hasNext" in result) delete result.hasNext;
                            }
                        }
                        if (isFinalResult) update(cache, result, {
                            context: mutation.context,
                            variables: mutation.variables
                        });
                    }
                    if (!skipCache && !mutation.keepRootFields && isFinalResult) cache.modify({
                        id: "ROOT_MUTATION",
                        fields: function(value, _a) {
                            var fieldName = _a.fieldName, DELETE = _a.DELETE;
                            return fieldName === "__typename" ? value : DELETE;
                        }
                    });
                },
                include: mutation.refetchQueries,
                optimistic: false,
                removeOptimistic: mutation.removeOptimistic,
                onQueryUpdated: mutation.onQueryUpdated || null
            }).forEach(function(result) {
                return results_1.push(result);
            });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) return Promise.all(results_1).then(function() {
                return result;
            });
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function(optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function" ? optimisticResponse(mutation.variables) : optimisticResponse;
        return this.cache.recordOptimisticTransaction(function(cache) {
            try {
                _this.markMutationResult((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, mutation), {
                    result: {
                        data: data
                    }
                }), cache);
            } catch (error) {
                __DEV__ && (0, $a670ecbae0a62090$export$f5708dca728d7177).error(error);
            }
        }, mutation.mutationId);
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, networkStatus) {
        return this.fetchQueryObservable(queryId, options, networkStatus).promise;
    };
    QueryManager.prototype.getQueryStore = function() {
        var store = Object.create(null);
        this.queries.forEach(function(info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var transformed = this.cache.transformDocument(document);
            var noConnection = (0, $6457d3104a36d467$export$74985f3324559867)(transformed);
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = noConnection && this.localState.serverQuery(noConnection);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $62aba4d864227324$export$8d1e9e5bbfa5d09a)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $91fde6eb370810ac$export$84c19026e616569e)((0, $91fde6eb370810ac$export$7a5b1fa979d2c158)(transformed)),
                asQuery: (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, transformed), {
                    definitions: transformed.definitions.map(function(def) {
                        if (def.kind === "OperationDefinition" && def.operation !== "query") return (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, def), {
                            operation: "query"
                        });
                        return def;
                    })
                })
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options) {
        options = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, options), {
            variables: this.getVariables(options.query, options.variables)
        });
        if (typeof options.notifyOnNetworkStatusChange === "undefined") options.notifyOnNetworkStatusChange = false;
        var queryInfo = new (0, $741f0321bdcf61c0$export$79a6120a39c90b6a)(this);
        var observable = new (0, $4247e555a8486dc0$export$6c1b56eac59c9584)({
            queryManager: this,
            queryInfo: queryInfo,
            options: options
        });
        this.queries.set(observable.queryId, queryInfo);
        queryInfo.init({
            document: observable.query,
            observableQuery: observable,
            variables: observable.variables
        });
        return observable;
    };
    QueryManager.prototype.query = function(options, queryId) {
        var _this = this;
        if (queryId === void 0) queryId = this.generateQueryId();
        __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(options.query, "query option is required. You must specify your GraphQL document in the query option.") : (0, $a670ecbae0a62090$export$f5708dca728d7177)(options.query, 17);
        __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(options.query.kind === "Document", 'You must wrap the query string in a "gql" tag.') : (0, $a670ecbae0a62090$export$f5708dca728d7177)(options.query.kind === "Document", 18);
        __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(!options.returnPartialData, "returnPartialData option only supported on watchQuery.") : (0, $a670ecbae0a62090$export$f5708dca728d7177)(!options.returnPartialData, 19);
        __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(!options.pollInterval, "pollInterval option only supported on watchQuery.") : (0, $a670ecbae0a62090$export$f5708dca728d7177)(!options.pollInterval, 20);
        return this.fetchQuery(queryId, options).finally(function() {
            return _this.stopQuery(queryId);
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function() {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function() {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function(options) {
        if (options === void 0) options = {
            discardWatches: true
        };
        this.cancelPendingFetches(__DEV__ ? new (0, $a670ecbae0a62090$export$cea12affaee22fe8)("Store reset while query was in flight (not completed in link chain)") : new (0, $a670ecbae0a62090$export$cea12affaee22fe8)(21));
        this.queries.forEach(function(queryInfo) {
            if (queryInfo.observableQuery) queryInfo.networkStatus = (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).loading;
            else queryInfo.stop();
        });
        if (this.mutationStore) this.mutationStore = Object.create(null);
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function(include) {
        var _this = this;
        if (include === void 0) include = "active";
        var queries = new Map();
        var queryNamesAndDocs = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) include.forEach(function(desc) {
            if (typeof desc === "string") queryNamesAndDocs.set(desc, false);
            else if ((0, $5763c7b47888ba33$export$540432d49fcec6c9)(desc)) queryNamesAndDocs.set(_this.transform(desc).document, false);
            else if ((0, $450e50257530cd67$export$417207af72fad9c9)(desc) && desc.query) legacyQueryOptions.add(desc);
        });
        this.queries.forEach(function(_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" || include === "active" && !oq.hasObservers()) return;
                if (include === "active" || queryName && queryNamesAndDocs.has(queryName) || document && queryNamesAndDocs.has(document)) {
                    queries.set(queryId, oq);
                    if (queryName) queryNamesAndDocs.set(queryName, true);
                    if (document) queryNamesAndDocs.set(document, true);
                }
            }
        });
        if (legacyQueryOptions.size) legacyQueryOptions.forEach(function(options) {
            var queryId = (0, $e71eecefd4cc421f$export$d0c8ec0fe1b18b70)("legacyOneTimeQuery");
            var queryInfo = _this.getQuery(queryId).init({
                document: options.query,
                variables: options.variables
            });
            var oq = new (0, $4247e555a8486dc0$export$6c1b56eac59c9584)({
                queryManager: _this,
                queryInfo: queryInfo,
                options: (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, options), {
                    fetchPolicy: "network-only"
                })
            });
            (0, $a670ecbae0a62090$export$f5708dca728d7177)(oq.queryId === queryId);
            queryInfo.setObservableQuery(oq);
            queries.set(queryId, oq);
        });
        if (__DEV__ && queryNamesAndDocs.size) queryNamesAndDocs.forEach(function(included, nameOrDoc) {
            if (!included) __DEV__ && (0, $a670ecbae0a62090$export$f5708dca728d7177).warn("Unknown query ".concat(typeof nameOrDoc === "string" ? "named " : "").concat(JSON.stringify(nameOrDoc, null, 2), " requested in refetchQueries options.include array"));
        });
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function(observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby || fetchPolicy !== "standby" && fetchPolicy !== "cache-only") observableQueryPromises.push(observableQuery.refetch());
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function(observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, errorPolicy = _a.errorPolicy, variables = _a.variables, _b = _a.context, context = _b === void 0 ? {} : _b;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, context, variables).map(function(result) {
                if (fetchPolicy !== "no-cache") {
                    if ((0, $741f0321bdcf61c0$export$5f47a9fb9a521654)(result, errorPolicy)) _this.cache.write({
                        query: query,
                        result: result.data,
                        dataId: "ROOT_SUBSCRIPTION",
                        variables: variables
                    });
                    _this.broadcastQueries();
                }
                var hasErrors = (0, $dd2a078388f31bf4$export$b4df399e879e53ab)(result);
                var hasProtocolErrors = (0, $783678ef924f64c3$export$345f95cc6b6b9b0b)(result);
                if (hasErrors || hasProtocolErrors) {
                    var errors = {};
                    if (hasErrors) errors.graphQLErrors = result.errors;
                    if (hasProtocolErrors) errors.protocolErrors = result.extensions[0, $783678ef924f64c3$export$4995664c1b49842e];
                    throw new (0, $783678ef924f64c3$export$26a337512320b8c6)(errors);
                }
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4)(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function() {
        if (this.onBroadcast) this.onBroadcast();
        this.queries.forEach(function(info) {
            return info.notify();
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _b = this, inFlightLinkObservables_1 = _b.inFlightLinkObservables, link = _b.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $91fde6eb370810ac$export$41bca9dc6871dd4e)(serverQuery) || void 0,
                context: this.prepareContext((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = (0, $bee4e4af2a14c8d6$export$88a0ad9b6f961b51)(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    var concast = new (0, $9f104560ce05ec3c$export$ae0cf2ec7a6fa78e)([
                        (0, $ec7e7c0e19838dfc$export$51396ec711da548b)(link, operation)
                    ]);
                    byVariables_1.set(varJson_1, observable = concast);
                    concast.beforeNext(function() {
                        if (byVariables_1.delete(varJson_1) && byVariables_1.size < 1) inFlightLinkObservables_1.delete(serverQuery);
                    });
                }
            } else observable = new (0, $9f104560ce05ec3c$export$ae0cf2ec7a6fa78e)([
                (0, $ec7e7c0e19838dfc$export$51396ec711da548b)(link, operation)
            ]);
        } else {
            observable = new (0, $9f104560ce05ec3c$export$ae0cf2ec7a6fa78e)([
                (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4).of({
                    data: {}
                })
            ]);
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = (0, $bfa90a84bdddeaf8$export$707ee4c4c95d39e3)(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function(queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        var linkDocument = this.cache.transformForLink(this.transform(queryInfo.document).document);
        return (0, $bfa90a84bdddeaf8$export$707ee4c4c95d39e3)(this.getObservableFromLink(linkDocument, options.context, options.variables), function(result) {
            var graphQLErrors = (0, $dd2a078388f31bf4$export$a163557155188b6e)(result);
            var hasErrors = graphQLErrors.length > 0;
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") throw queryInfo.markError(new (0, $783678ef924f64c3$export$26a337512320b8c6)({
                    graphQLErrors: graphQLErrors
                }));
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).ready
            };
            if (hasErrors && options.errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).error;
            }
            return aqr;
        }, function(networkError) {
            var error = (0, $783678ef924f64c3$export$17f5e6bd290bb15d)(networkError) ? networkError : new (0, $783678ef924f64c3$export$26a337512320b8c6)({
                networkError: networkError
            });
            if (requestId >= queryInfo.lastRequestId) queryInfo.markError(error);
            throw error;
        });
    };
    QueryManager.prototype.fetchQueryObservable = function(queryId, options, networkStatus) {
        return this.fetchConcastWithInfo(queryId, options, networkStatus).concast;
    };
    QueryManager.prototype.fetchConcastWithInfo = function(queryId, options, networkStatus) {
        var _this = this;
        if (networkStatus === void 0) networkStatus = (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).loading;
        var query = this.transform(options.query).document;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context
        });
        var fromVariables = function(variables) {
            normalized.variables = variables;
            var sourcesWithInfo = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (normalized.fetchPolicy !== "standby" && sourcesWithInfo.sources.length > 0 && queryInfo.observableQuery) queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            return sourcesWithInfo;
        };
        var cleanupCancelFn = function() {
            return _this.fetchCancelFns.delete(queryId);
        };
        this.fetchCancelFns.set(queryId, function(reason) {
            cleanupCancelFn();
            setTimeout(function() {
                return concast.cancel(reason);
            });
        });
        var concast, containsDataFromLink;
        if (this.transform(normalized.query).hasClientExports) {
            concast = new (0, $9f104560ce05ec3c$export$ae0cf2ec7a6fa78e)(this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables).then(function(sourcesWithInfo) {
                return sourcesWithInfo.sources;
            }));
            containsDataFromLink = true;
        } else {
            var sourcesWithInfo = fromVariables(normalized.variables);
            containsDataFromLink = sourcesWithInfo.fromLink;
            concast = new (0, $9f104560ce05ec3c$export$ae0cf2ec7a6fa78e)(sourcesWithInfo.sources);
        }
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return {
            concast: concast,
            fromLink: containsDataFromLink
        };
    };
    QueryManager.prototype.refetchQueries = function(_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? (0, $e71eecefd4cc421f$export$d0c8ec0fe1b18b70)("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) this.getObservableQueries(include).forEach(function(oq, queryId) {
            includedQueriesById.set(queryId, {
                oq: oq,
                lastDiff: _this.getQuery(queryId).getDiff()
            });
        });
        var results = new Map;
        if (updateCache) this.cache.batch({
            update: updateCache,
            optimistic: optimistic && removeOptimistic || false,
            removeOptimistic: removeOptimistic,
            onWatchUpdated: function(watch, diff, lastDiff) {
                var oq = watch.watcher instanceof (0, $741f0321bdcf61c0$export$79a6120a39c90b6a) && watch.watcher.observableQuery;
                if (oq) {
                    if (onQueryUpdated) {
                        includedQueriesById.delete(oq.queryId);
                        var result = onQueryUpdated(oq, diff, lastDiff);
                        if (result === true) result = oq.refetch();
                        if (result !== false) results.set(oq, result);
                        return result;
                    }
                    if (onQueryUpdated !== null) includedQueriesById.set(oq.queryId, {
                        oq: oq,
                        lastDiff: lastDiff,
                        diff: diff
                    });
                }
            }
        });
        if (includedQueriesById.size) includedQueriesById.forEach(function(_a, queryId) {
            var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
            var result;
            if (onQueryUpdated) {
                if (!diff) {
                    var info = oq["queryInfo"];
                    info.reset();
                    diff = info.getDiff();
                }
                result = onQueryUpdated(oq, diff, lastDiff);
            }
            if (!onQueryUpdated || result === true) result = oq.refetch();
            if (result !== false) results.set(oq, result);
            if (queryId.indexOf("legacyOneTimeQuery") >= 0) _this.stopQueryNoBroadcast(queryId);
        });
        if (removeOptimistic) this.cache.removeOptimistic(removeOptimistic);
        return results;
    };
    QueryManager.prototype.fetchQueryByPolicy = function(queryInfo, _a, networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: this.transform(query).document,
            variables: variables,
            networkStatus: networkStatus
        });
        var readCache = function() {
            return queryInfo.getDiff(variables);
        };
        var resultsFromCache = function(diff, networkStatus) {
            if (networkStatus === void 0) networkStatus = queryInfo.networkStatus || (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).loading;
            var data = diff.result;
            if (__DEV__ && !returnPartialData && !(0, $9e23b7a204e68d42$export$411ce8e5a71e3069)(data, {})) (0, $4247e555a8486dc0$export$b7e1973aacac3ae7)(diff.missing);
            var fromData = function(data) {
                return (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4).of((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({
                    data: data,
                    loading: (0, $3e16f6dd50a68d19$export$37509604341a3464)(networkStatus),
                    networkStatus: networkStatus
                }, diff.complete ? null : {
                    partial: true
                }));
            };
            if (data && _this.transform(query).hasForcedResolvers) return _this.localState.runResolvers({
                document: query,
                remoteResult: {
                    data: data
                },
                context: context,
                variables: variables,
                onlyRunForcedResolvers: true
            }).then(function(resolved) {
                return fromData(resolved.data || void 0);
            });
            if (errorPolicy === "none" && networkStatus === (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).refetch && Array.isArray(diff.missing)) return fromData(void 0);
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 : networkStatus === (0, $3e16f6dd50a68d19$export$bd096ddbd246c79c).refetch && refetchWritePolicy !== "merge" ? 1 : 2;
        var resultsFromLink = function() {
            return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy
            });
        };
        var shouldNotify = notifyOnNetworkStatusChange && typeof oldNetworkStatus === "number" && oldNetworkStatus !== networkStatus && (0, $3e16f6dd50a68d19$export$37509604341a3464)(networkStatus);
        switch(fetchPolicy){
            default:
            case "cache-first":
                var diff = readCache();
                if (diff.complete) return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(diff, queryInfo.markReady())
                    ]
                };
                if (returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-and-network":
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-only":
                return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(readCache(), queryInfo.markReady())
                    ]
                };
            case "network-only":
                if (shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(readCache()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "no-cache":
                if (shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(queryInfo.getDiff()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "standby":
                return {
                    fromLink: false,
                    sources: []
                };
        }
    };
    QueryManager.prototype.getQuery = function(queryId) {
        if (queryId && !this.queries.has(queryId)) this.queries.set(queryId, new (0, $741f0321bdcf61c0$export$79a6120a39c90b6a)(this, queryId));
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    return QueryManager;
}();





function $90eefea6f1a3239e$export$235b7fc70b9fc359(defaults, options) {
    return (0, $7152c55085831e38$export$8e16b83750b44988)(defaults, options, options.variables && {
        variables: (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, defaults && defaults.variables), options.variables)
    });
}


var $7209d71eed1c6aae$var$hasSuggestedDevtools = false;
var $7209d71eed1c6aae$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, _c = options.connectToDevTools, connectToDevTools = _c === void 0 ? typeof window === "object" && !window.__APOLLO_CLIENT__ && __DEV__ : _c, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? false : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) link = uri ? new (0, $4071829aa7d2097e$export$f4bbf1aec241cc1)({
            uri: uri,
            credentials: credentials,
            headers: headers
        }) : (0, $29b9899e03084364$export$2fed3d61f740bc7f).empty();
        if (!cache) throw __DEV__ ? new (0, $a670ecbae0a62090$export$cea12affaee22fe8)("To initialize Apollo Client, you must specify a 'cache' property in the options object. \nFor more information, please visit: https://go.apollo.dev/c/docs") : new (0, $a670ecbae0a62090$export$cea12affaee22fe8)(9);
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        if (connectToDevTools && typeof window === "object") window.__APOLLO_CLIENT__ = this;
        if (!$7209d71eed1c6aae$var$hasSuggestedDevtools && connectToDevTools && __DEV__) {
            $7209d71eed1c6aae$var$hasSuggestedDevtools = true;
            if (typeof window !== "undefined" && window.document && window.top === window.self && !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                var nav = window.navigator;
                var ua = nav && nav.userAgent;
                var url = void 0;
                if (typeof ua === "string") {
                    if (ua.indexOf("Chrome/") > -1) url = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                    else if (ua.indexOf("Firefox/") > -1) url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                }
                if (url) __DEV__ && (0, $a670ecbae0a62090$export$f5708dca728d7177).log("Download the Apollo DevTools for a better development experience: " + url);
            }
        }
        this.version = (0, $108da7bfe799aabe$export$83d89fbfd8236492);
        this.localState = new (0, $aee3cb4d5670c812$export$19901bcd339c3ded)({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new (0, $ad42edcf594030a7$export$b986383a50b53ea4)({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: connectToDevTools ? function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.getQueryStore(),
                        mutations: _this.queryManager.mutationStore || {}
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            } : void 0
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $90eefea6f1a3239e$export$235b7fc70b9fc359)(this.defaultOptions.watchQuery, options);
        if (this.disableNetworkFetches && (options.fetchPolicy === "network-only" || options.fetchPolicy === "cache-and-network")) options = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $90eefea6f1a3239e$export$235b7fc70b9fc359)(this.defaultOptions.query, options);
        __DEV__ ? (0, $a670ecbae0a62090$export$f5708dca728d7177)(options.fetchPolicy !== "cache-and-network", "The cache-and-network fetchPolicy does not work with client.query, because client.query can only return a single result. Please use client.watchQuery to receive multiple results from the cache and the network, or consider using a different fetchPolicy, such as cache-first or network-only.") : (0, $a670ecbae0a62090$export$f5708dca728d7177)(options.fetchPolicy !== "cache-and-network", 10);
        if (this.disableNetworkFetches && options.fetchPolicy === "network-only") options = (0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)((0, $1aaf9c65fb7afb7d$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $90eefea6f1a3239e$export$235b7fc70b9fc359)(this.defaultOptions.mutate, options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $ec7e7c0e19838dfc$export$51396ec711da548b)(this.link, payload);
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: false
            });
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: true
            });
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.refetchQueries = function(options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function(result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        result.queries = queries;
        result.results = results;
        result.catch(function(error) {
            __DEV__ && (0, $a670ecbae0a62090$export$f5708dca728d7177).debug("In client.refetchQueries, Promise.all promise rejected with error ".concat(error));
        });
        return result;
    };
    ApolloClient.prototype.getObservableQueries = function(include) {
        if (include === void 0) include = "active";
        return this.queryManager.getObservableQueries(include);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    ApolloClient.prototype.setLink = function(newLink) {
        this.link = this.queryManager.link = newLink;
    };
    return ApolloClient;
}();


var $1b68500f0c3c9369$export$ee1b3e54f0441b22 = (0, $29b9899e03084364$export$2fed3d61f740bc7f).concat;


var $ed43c0849025d39c$exports = {};
"use strict";
Object.defineProperty($ed43c0849025d39c$exports, "__esModule", {
    value: true
});
var $aaaa754dc2a4d49d$exports = {};
"use strict";
var $aaaa754dc2a4d49d$var$__extends = $aaaa754dc2a4d49d$exports && $aaaa754dc2a4d49d$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $aaaa754dc2a4d49d$var$__assign = $aaaa754dc2a4d49d$exports && $aaaa754dc2a4d49d$exports.__assign || function() {
    $aaaa754dc2a4d49d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $aaaa754dc2a4d49d$var$__assign.apply(this, arguments);
};
var $aaaa754dc2a4d49d$var$__awaiter = $aaaa754dc2a4d49d$exports && $aaaa754dc2a4d49d$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $aaaa754dc2a4d49d$var$__generator = $aaaa754dc2a4d49d$exports && $aaaa754dc2a4d49d$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($aaaa754dc2a4d49d$exports, "__esModule", {
    value: true
});

var $51327db84c201e34$exports = {};
"use strict";
Object.defineProperty($51327db84c201e34$exports, "__esModule", {
    value: true
});
$51327db84c201e34$exports.print = $51327db84c201e34$var$print;
var $7444418d1ecb77e5$exports = {};
"use strict";
Object.defineProperty($7444418d1ecb77e5$exports, "__esModule", {
    value: true
});
$7444418d1ecb77e5$exports.dedentBlockStringLines = $7444418d1ecb77e5$var$dedentBlockStringLines;
$7444418d1ecb77e5$exports.isPrintableAsBlockString = $7444418d1ecb77e5$var$isPrintableAsBlockString;
$7444418d1ecb77e5$exports.printBlockString = $7444418d1ecb77e5$var$printBlockString;
var $f21d35f6366d5c39$exports = {};
"use strict";
Object.defineProperty($f21d35f6366d5c39$exports, "__esModule", {
    value: true
});
$f21d35f6366d5c39$exports.isDigit = $f21d35f6366d5c39$var$isDigit;
$f21d35f6366d5c39$exports.isLetter = $f21d35f6366d5c39$var$isLetter;
$f21d35f6366d5c39$exports.isNameContinue = $f21d35f6366d5c39$var$isNameContinue;
$f21d35f6366d5c39$exports.isNameStart = $f21d35f6366d5c39$var$isNameStart;
$f21d35f6366d5c39$exports.isWhiteSpace = $f21d35f6366d5c39$var$isWhiteSpace;
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $f21d35f6366d5c39$var$isWhiteSpace(code) {
    return code === 0x0009 || code === 0x0020;
}
/**
 * ```
 * Digit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 * ```
 * @internal
 */ function $f21d35f6366d5c39$var$isDigit(code) {
    return code >= 0x0030 && code <= 0x0039;
}
/**
 * ```
 * Letter :: one of
 *   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
 *   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
 *   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
 *   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
 * ```
 * @internal
 */ function $f21d35f6366d5c39$var$isLetter(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
/**
 * ```
 * NameStart ::
 *   - Letter
 *   - `_`
 * ```
 * @internal
 */ function $f21d35f6366d5c39$var$isNameStart(code) {
    return $f21d35f6366d5c39$var$isLetter(code) || code === 0x005f;
}
/**
 * ```
 * NameContinue ::
 *   - Letter
 *   - Digit
 *   - `_`
 * ```
 * @internal
 */ function $f21d35f6366d5c39$var$isNameContinue(code) {
    return $f21d35f6366d5c39$var$isLetter(code) || $f21d35f6366d5c39$var$isDigit(code) || code === 0x005f;
}


/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $7444418d1ecb77e5$var$dedentBlockStringLines(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $7444418d1ecb77e5$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $7444418d1ecb77e5$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $f21d35f6366d5c39$exports.isWhiteSpace)(str.charCodeAt(i)))++i;
    return i;
}
/**
 * @internal
 */ function $7444418d1ecb77e5$var$isPrintableAsBlockString(value) {
    if (value === "") return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */ function $7444418d1ecb77e5$var$printBlockString(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $f21d35f6366d5c39$exports.isWhiteSpace)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith("\\");
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ""; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $f21d35f6366d5c39$exports.isWhiteSpace)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += "\n";
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += "\n";
    return '"""' + result + '"""';
}


var $08631022d1dc6076$exports = {};
"use strict";
Object.defineProperty($08631022d1dc6076$exports, "__esModule", {
    value: true
});
$08631022d1dc6076$exports.printString = $08631022d1dc6076$var$printString;
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $08631022d1dc6076$var$printString(str) {
    return `"${str.replace($08631022d1dc6076$var$escapedRegExp, $08631022d1dc6076$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $08631022d1dc6076$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $08631022d1dc6076$var$escapedReplacer(str) {
    return $08631022d1dc6076$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $08631022d1dc6076$var$escapeSequences = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "\\t",
    "\\n",
    "\\u000B",
    "\\f",
    "\\r",
    "\\u000E",
    "\\u000F",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001A",
    "\\u001B",
    "\\u001C",
    "\\u001D",
    "\\u001E",
    "\\u001F",
    "",
    "",
    '\\"',
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\\\",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\u007F",
    "\\u0080",
    "\\u0081",
    "\\u0082",
    "\\u0083",
    "\\u0084",
    "\\u0085",
    "\\u0086",
    "\\u0087",
    "\\u0088",
    "\\u0089",
    "\\u008A",
    "\\u008B",
    "\\u008C",
    "\\u008D",
    "\\u008E",
    "\\u008F",
    "\\u0090",
    "\\u0091",
    "\\u0092",
    "\\u0093",
    "\\u0094",
    "\\u0095",
    "\\u0096",
    "\\u0097",
    "\\u0098",
    "\\u0099",
    "\\u009A",
    "\\u009B",
    "\\u009C",
    "\\u009D",
    "\\u009E",
    "\\u009F"
];


var $158e071bad2f9869$exports = {};
"use strict";
Object.defineProperty($158e071bad2f9869$exports, "__esModule", {
    value: true
});
$158e071bad2f9869$exports.BREAK = void 0;
$158e071bad2f9869$exports.getEnterLeaveForKind = $158e071bad2f9869$var$getEnterLeaveForKind;
$158e071bad2f9869$exports.getVisitFn = $158e071bad2f9869$var$getVisitFn;
$158e071bad2f9869$exports.visit = $158e071bad2f9869$var$visit;
$158e071bad2f9869$exports.visitInParallel = $158e071bad2f9869$var$visitInParallel;
var $066532d3a88fa2b1$exports = {};
"use strict";
Object.defineProperty($066532d3a88fa2b1$exports, "__esModule", {
    value: true
});
$066532d3a88fa2b1$exports.devAssert = $066532d3a88fa2b1$var$devAssert;
function $066532d3a88fa2b1$var$devAssert(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


var $214cdd927d818d79$exports = {};
"use strict";
Object.defineProperty($214cdd927d818d79$exports, "__esModule", {
    value: true
});
$214cdd927d818d79$exports.inspect = $214cdd927d818d79$var$inspect;
const $214cdd927d818d79$var$MAX_ARRAY_LENGTH = 10;
const $214cdd927d818d79$var$MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */ function $214cdd927d818d79$var$inspect(value) {
    return $214cdd927d818d79$var$formatValue(value, []);
}
function $214cdd927d818d79$var$formatValue(value, seenValues) {
    switch(typeof value){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? `[function ${value.name}]` : "[function]";
        case "object":
            return $214cdd927d818d79$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $214cdd927d818d79$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return "null";
    if (previouslySeenValues.includes(value)) return "[Circular]";
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($214cdd927d818d79$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === "string" ? jsonValue : $214cdd927d818d79$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $214cdd927d818d79$var$formatArray(value, seenValues);
    return $214cdd927d818d79$var$formatObject(value, seenValues);
}
function $214cdd927d818d79$var$isJSONable(value) {
    return typeof value.toJSON === "function";
}
function $214cdd927d818d79$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return "{}";
    if (seenValues.length > $214cdd927d818d79$var$MAX_RECURSIVE_DEPTH) return "[" + $214cdd927d818d79$var$getObjectTag(object) + "]";
    const properties = entries.map(([key, value])=>key + ": " + $214cdd927d818d79$var$formatValue(value, seenValues));
    return "{ " + properties.join(", ") + " }";
}
function $214cdd927d818d79$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $214cdd927d818d79$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    const len = Math.min($214cdd927d818d79$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($214cdd927d818d79$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return "[" + items.join(", ") + "]";
}
function $214cdd927d818d79$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        const name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}


var $59d3be490c0f28dc$exports = {};
"use strict";
Object.defineProperty($59d3be490c0f28dc$exports, "__esModule", {
    value: true
});
$59d3be490c0f28dc$exports.Token = $59d3be490c0f28dc$exports.QueryDocumentKeys = $59d3be490c0f28dc$exports.OperationTypeNode = $59d3be490c0f28dc$exports.Location = void 0;
$59d3be490c0f28dc$exports.isNode = $59d3be490c0f28dc$var$isNode;
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $59d3be490c0f28dc$var$Location {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return "Location";
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */ $59d3be490c0f28dc$exports.Location = $59d3be490c0f28dc$var$Location;
class $59d3be490c0f28dc$var$Token {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return "Token";
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
/**
 * The list of all possible AST node types.
 */ $59d3be490c0f28dc$exports.Token = $59d3be490c0f28dc$var$Token;
/**
 * @internal
 */ const $59d3be490c0f28dc$var$QueryDocumentKeys = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
$59d3be490c0f28dc$exports.QueryDocumentKeys = $59d3be490c0f28dc$var$QueryDocumentKeys;
const $59d3be490c0f28dc$var$kindValues = new Set(Object.keys($59d3be490c0f28dc$var$QueryDocumentKeys));
/**
 * @internal
 */ function $59d3be490c0f28dc$var$isNode(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === "string" && $59d3be490c0f28dc$var$kindValues.has(maybeKind);
}
/** Name */ var $59d3be490c0f28dc$var$OperationTypeNode;
$59d3be490c0f28dc$exports.OperationTypeNode = $59d3be490c0f28dc$var$OperationTypeNode;
(function(OperationTypeNode) {
    OperationTypeNode["QUERY"] = "query";
    OperationTypeNode["MUTATION"] = "mutation";
    OperationTypeNode["SUBSCRIPTION"] = "subscription";
})($59d3be490c0f28dc$var$OperationTypeNode || ($59d3be490c0f28dc$exports.OperationTypeNode = $59d3be490c0f28dc$var$OperationTypeNode = {}));


var $6e748026dbb61fae$exports = {};
"use strict";
Object.defineProperty($6e748026dbb61fae$exports, "__esModule", {
    value: true
});
$6e748026dbb61fae$exports.Kind = void 0;
/**
 * The set of allowed kind values for AST nodes.
 */ var $6e748026dbb61fae$var$Kind;
$6e748026dbb61fae$exports.Kind = $6e748026dbb61fae$var$Kind;
(function(Kind) {
    Kind["NAME"] = "Name";
    Kind["DOCUMENT"] = "Document";
    Kind["OPERATION_DEFINITION"] = "OperationDefinition";
    Kind["VARIABLE_DEFINITION"] = "VariableDefinition";
    Kind["SELECTION_SET"] = "SelectionSet";
    Kind["FIELD"] = "Field";
    Kind["ARGUMENT"] = "Argument";
    Kind["FRAGMENT_SPREAD"] = "FragmentSpread";
    Kind["INLINE_FRAGMENT"] = "InlineFragment";
    Kind["FRAGMENT_DEFINITION"] = "FragmentDefinition";
    Kind["VARIABLE"] = "Variable";
    Kind["INT"] = "IntValue";
    Kind["FLOAT"] = "FloatValue";
    Kind["STRING"] = "StringValue";
    Kind["BOOLEAN"] = "BooleanValue";
    Kind["NULL"] = "NullValue";
    Kind["ENUM"] = "EnumValue";
    Kind["LIST"] = "ListValue";
    Kind["OBJECT"] = "ObjectValue";
    Kind["OBJECT_FIELD"] = "ObjectField";
    Kind["DIRECTIVE"] = "Directive";
    Kind["NAMED_TYPE"] = "NamedType";
    Kind["LIST_TYPE"] = "ListType";
    Kind["NON_NULL_TYPE"] = "NonNullType";
    Kind["SCHEMA_DEFINITION"] = "SchemaDefinition";
    Kind["OPERATION_TYPE_DEFINITION"] = "OperationTypeDefinition";
    Kind["SCALAR_TYPE_DEFINITION"] = "ScalarTypeDefinition";
    Kind["OBJECT_TYPE_DEFINITION"] = "ObjectTypeDefinition";
    Kind["FIELD_DEFINITION"] = "FieldDefinition";
    Kind["INPUT_VALUE_DEFINITION"] = "InputValueDefinition";
    Kind["INTERFACE_TYPE_DEFINITION"] = "InterfaceTypeDefinition";
    Kind["UNION_TYPE_DEFINITION"] = "UnionTypeDefinition";
    Kind["ENUM_TYPE_DEFINITION"] = "EnumTypeDefinition";
    Kind["ENUM_VALUE_DEFINITION"] = "EnumValueDefinition";
    Kind["INPUT_OBJECT_TYPE_DEFINITION"] = "InputObjectTypeDefinition";
    Kind["DIRECTIVE_DEFINITION"] = "DirectiveDefinition";
    Kind["SCHEMA_EXTENSION"] = "SchemaExtension";
    Kind["SCALAR_TYPE_EXTENSION"] = "ScalarTypeExtension";
    Kind["OBJECT_TYPE_EXTENSION"] = "ObjectTypeExtension";
    Kind["INTERFACE_TYPE_EXTENSION"] = "InterfaceTypeExtension";
    Kind["UNION_TYPE_EXTENSION"] = "UnionTypeExtension";
    Kind["ENUM_TYPE_EXTENSION"] = "EnumTypeExtension";
    Kind["INPUT_OBJECT_TYPE_EXTENSION"] = "InputObjectTypeExtension";
})($6e748026dbb61fae$var$Kind || ($6e748026dbb61fae$exports.Kind = $6e748026dbb61fae$var$Kind = {})); /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 


const $158e071bad2f9869$var$BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 * ```ts
 * const editedAST = visit(ast, {
 *   enter(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: skip visiting this node
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   },
 *   leave(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: no action
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   }
 * });
 * ```
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to three permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind(node) {
 *     // enter the "Kind" node
 *   }
 * })
 * ```
 *
 * 2) Named visitors that trigger upon entering and leaving a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind: {
 *     enter(node) {
 *       // enter the "Kind" node
 *     }
 *     leave(node) {
 *       // leave the "Kind" node
 *     }
 *   }
 * })
 * ```
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 * ```ts
 * visit(ast, {
 *   enter(node) {
 *     // enter any node
 *   },
 *   leave(node) {
 *     // leave any node
 *   }
 * })
 * ```
 */ $158e071bad2f9869$exports.BREAK = $158e071bad2f9869$var$BREAK;
function $158e071bad2f9869$var$visit(root, visitor, visitorKeys = $59d3be490c0f28dc$exports.QueryDocumentKeys) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values($6e748026dbb61fae$exports.Kind))enterLeaveMap.set(kind, $158e071bad2f9869$var$getEnterLeaveForKind(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $59d3be490c0f28dc$exports.isNode)(node) || (0, $066532d3a88fa2b1$exports.devAssert)(false, `Invalid AST Node: ${(0, $214cdd927d818d79$exports.inspect)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $158e071bad2f9869$var$BREAK) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $59d3be490c0f28dc$exports.isNode)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */ function $158e071bad2f9869$var$visitInParallel(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values($6e748026dbb61fae$exports.Kind)){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter , leave: leave  } = $158e071bad2f9869$var$getEnterLeaveForKind(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $158e071bad2f9869$var$BREAK) skipping[i] = $158e071bad2f9869$var$BREAK;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $158e071bad2f9869$var$BREAK) skipping[i] = $158e071bad2f9869$var$BREAK;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
/**
 * Given a visitor instance and a node kind, return EnterLeaveVisitor for that kind.
 */ function $158e071bad2f9869$var$getEnterLeaveForKind(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === "object") // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === "function") // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 *
 * @deprecated Please use `getEnterLeaveForKind` instead. Will be removed in v17
 */ /* c8 ignore next 8 */ function $158e071bad2f9869$var$getVisitFn(visitor, kind, isLeaving) {
    const { enter: enter , leave: leave  } = $158e071bad2f9869$var$getEnterLeaveForKind(visitor, kind);
    return isLeaving ? leave : enter;
}


/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */ function $51327db84c201e34$var$print(ast) {
    return (0, $158e071bad2f9869$exports.visit)(ast, $51327db84c201e34$var$printDocASTReducer);
}
const $51327db84c201e34$var$MAX_LINE_LENGTH = 80;
const $51327db84c201e34$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>"$" + node.name
    },
    // Document
    Document: {
        leave: (node)=>$51327db84c201e34$var$join(node.definitions, "\n\n")
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $51327db84c201e34$var$wrap("(", $51327db84c201e34$var$join(node.variableDefinitions, ", "), ")");
            const prefix = $51327db84c201e34$var$join([
                node.operation,
                $51327db84c201e34$var$join([
                    node.name,
                    varDefs
                ]),
                $51327db84c201e34$var$join(node.directives, " ")
            ], " "); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === "query" ? "" : prefix + " ") + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable , type: type , defaultValue: defaultValue , directives: directives  })=>variable + ": " + type + $51327db84c201e34$var$wrap(" = ", defaultValue) + $51327db84c201e34$var$wrap(" ", $51327db84c201e34$var$join(directives, " "))
    },
    SelectionSet: {
        leave: ({ selections: selections  })=>$51327db84c201e34$var$block(selections)
    },
    Field: {
        leave ({ alias: alias , name: name , arguments: args , directives: directives , selectionSet: selectionSet  }) {
            const prefix = $51327db84c201e34$var$wrap("", alias, ": ") + name;
            let argsLine = prefix + $51327db84c201e34$var$wrap("(", $51327db84c201e34$var$join(args, ", "), ")");
            if (argsLine.length > $51327db84c201e34$var$MAX_LINE_LENGTH) argsLine = prefix + $51327db84c201e34$var$wrap("(\n", $51327db84c201e34$var$indent($51327db84c201e34$var$join(args, "\n")), "\n)");
            return $51327db84c201e34$var$join([
                argsLine,
                $51327db84c201e34$var$join(directives, " "),
                selectionSet
            ], " ");
        }
    },
    Argument: {
        leave: ({ name: name , value: value  })=>name + ": " + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name , directives: directives  })=>"..." + name + $51327db84c201e34$var$wrap(" ", $51327db84c201e34$var$join(directives, " "))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition , directives: directives , selectionSet: selectionSet  })=>$51327db84c201e34$var$join([
                "...",
                $51327db84c201e34$var$wrap("on ", typeCondition),
                $51327db84c201e34$var$join(directives, " "),
                selectionSet
            ], " ")
    },
    FragmentDefinition: {
        leave: ({ name: name , typeCondition: typeCondition , variableDefinitions: variableDefinitions , directives: directives , selectionSet: selectionSet  })=>// or removed in the future.
            `fragment ${name}${$51327db84c201e34$var$wrap("(", $51327db84c201e34$var$join(variableDefinitions, ", "), ")")} ` + `on ${typeCondition} ${$51327db84c201e34$var$wrap("", $51327db84c201e34$var$join(directives, " "), " ")}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value  })=>value
    },
    FloatValue: {
        leave: ({ value: value  })=>value
    },
    StringValue: {
        leave: ({ value: value , block: isBlockString  })=>isBlockString ? (0, $7444418d1ecb77e5$exports.printBlockString)(value) : (0, $08631022d1dc6076$exports.printString)(value)
    },
    BooleanValue: {
        leave: ({ value: value  })=>value ? "true" : "false"
    },
    NullValue: {
        leave: ()=>"null"
    },
    EnumValue: {
        leave: ({ value: value  })=>value
    },
    ListValue: {
        leave: ({ values: values  })=>"[" + $51327db84c201e34$var$join(values, ", ") + "]"
    },
    ObjectValue: {
        leave: ({ fields: fields  })=>"{" + $51327db84c201e34$var$join(fields, ", ") + "}"
    },
    ObjectField: {
        leave: ({ name: name , value: value  })=>name + ": " + value
    },
    // Directive
    Directive: {
        leave: ({ name: name , arguments: args  })=>"@" + name + $51327db84c201e34$var$wrap("(", $51327db84c201e34$var$join(args, ", "), ")")
    },
    // Type
    NamedType: {
        leave: ({ name: name  })=>name
    },
    ListType: {
        leave: ({ type: type  })=>"[" + type + "]"
    },
    NonNullType: {
        leave: ({ type: type  })=>type + "!"
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description , directives: directives , operationTypes: operationTypes  })=>$51327db84c201e34$var$wrap("", description, "\n") + $51327db84c201e34$var$join([
                "schema",
                $51327db84c201e34$var$join(directives, " "),
                $51327db84c201e34$var$block(operationTypes)
            ], " ")
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation , type: type  })=>operation + ": " + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description , name: name , directives: directives  })=>$51327db84c201e34$var$wrap("", description, "\n") + $51327db84c201e34$var$join([
                "scalar",
                name,
                $51327db84c201e34$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeDefinition: {
        leave: ({ description: description , name: name , interfaces: interfaces , directives: directives , fields: fields  })=>$51327db84c201e34$var$wrap("", description, "\n") + $51327db84c201e34$var$join([
                "type",
                name,
                $51327db84c201e34$var$wrap("implements ", $51327db84c201e34$var$join(interfaces, " & ")),
                $51327db84c201e34$var$join(directives, " "),
                $51327db84c201e34$var$block(fields)
            ], " ")
    },
    FieldDefinition: {
        leave: ({ description: description , name: name , arguments: args , type: type , directives: directives  })=>$51327db84c201e34$var$wrap("", description, "\n") + name + ($51327db84c201e34$var$hasMultilineItems(args) ? $51327db84c201e34$var$wrap("(\n", $51327db84c201e34$var$indent($51327db84c201e34$var$join(args, "\n")), "\n)") : $51327db84c201e34$var$wrap("(", $51327db84c201e34$var$join(args, ", "), ")")) + ": " + type + $51327db84c201e34$var$wrap(" ", $51327db84c201e34$var$join(directives, " "))
    },
    InputValueDefinition: {
        leave: ({ description: description , name: name , type: type , defaultValue: defaultValue , directives: directives  })=>$51327db84c201e34$var$wrap("", description, "\n") + $51327db84c201e34$var$join([
                name + ": " + type,
                $51327db84c201e34$var$wrap("= ", defaultValue),
                $51327db84c201e34$var$join(directives, " ")
            ], " ")
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description , name: name , interfaces: interfaces , directives: directives , fields: fields  })=>$51327db84c201e34$var$wrap("", description, "\n") + $51327db84c201e34$var$join([
                "interface",
                name,
                $51327db84c201e34$var$wrap("implements ", $51327db84c201e34$var$join(interfaces, " & ")),
                $51327db84c201e34$var$join(directives, " "),
                $51327db84c201e34$var$block(fields)
            ], " ")
    },
    UnionTypeDefinition: {
        leave: ({ description: description , name: name , directives: directives , types: types  })=>$51327db84c201e34$var$wrap("", description, "\n") + $51327db84c201e34$var$join([
                "union",
                name,
                $51327db84c201e34$var$join(directives, " "),
                $51327db84c201e34$var$wrap("= ", $51327db84c201e34$var$join(types, " | "))
            ], " ")
    },
    EnumTypeDefinition: {
        leave: ({ description: description , name: name , directives: directives , values: values  })=>$51327db84c201e34$var$wrap("", description, "\n") + $51327db84c201e34$var$join([
                "enum",
                name,
                $51327db84c201e34$var$join(directives, " "),
                $51327db84c201e34$var$block(values)
            ], " ")
    },
    EnumValueDefinition: {
        leave: ({ description: description , name: name , directives: directives  })=>$51327db84c201e34$var$wrap("", description, "\n") + $51327db84c201e34$var$join([
                name,
                $51327db84c201e34$var$join(directives, " ")
            ], " ")
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description , name: name , directives: directives , fields: fields  })=>$51327db84c201e34$var$wrap("", description, "\n") + $51327db84c201e34$var$join([
                "input",
                name,
                $51327db84c201e34$var$join(directives, " "),
                $51327db84c201e34$var$block(fields)
            ], " ")
    },
    DirectiveDefinition: {
        leave: ({ description: description , name: name , arguments: args , repeatable: repeatable , locations: locations  })=>$51327db84c201e34$var$wrap("", description, "\n") + "directive @" + name + ($51327db84c201e34$var$hasMultilineItems(args) ? $51327db84c201e34$var$wrap("(\n", $51327db84c201e34$var$indent($51327db84c201e34$var$join(args, "\n")), "\n)") : $51327db84c201e34$var$wrap("(", $51327db84c201e34$var$join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + $51327db84c201e34$var$join(locations, " | ")
    },
    SchemaExtension: {
        leave: ({ directives: directives , operationTypes: operationTypes  })=>$51327db84c201e34$var$join([
                "extend schema",
                $51327db84c201e34$var$join(directives, " "),
                $51327db84c201e34$var$block(operationTypes)
            ], " ")
    },
    ScalarTypeExtension: {
        leave: ({ name: name , directives: directives  })=>$51327db84c201e34$var$join([
                "extend scalar",
                name,
                $51327db84c201e34$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeExtension: {
        leave: ({ name: name , interfaces: interfaces , directives: directives , fields: fields  })=>$51327db84c201e34$var$join([
                "extend type",
                name,
                $51327db84c201e34$var$wrap("implements ", $51327db84c201e34$var$join(interfaces, " & ")),
                $51327db84c201e34$var$join(directives, " "),
                $51327db84c201e34$var$block(fields)
            ], " ")
    },
    InterfaceTypeExtension: {
        leave: ({ name: name , interfaces: interfaces , directives: directives , fields: fields  })=>$51327db84c201e34$var$join([
                "extend interface",
                name,
                $51327db84c201e34$var$wrap("implements ", $51327db84c201e34$var$join(interfaces, " & ")),
                $51327db84c201e34$var$join(directives, " "),
                $51327db84c201e34$var$block(fields)
            ], " ")
    },
    UnionTypeExtension: {
        leave: ({ name: name , directives: directives , types: types  })=>$51327db84c201e34$var$join([
                "extend union",
                name,
                $51327db84c201e34$var$join(directives, " "),
                $51327db84c201e34$var$wrap("= ", $51327db84c201e34$var$join(types, " | "))
            ], " ")
    },
    EnumTypeExtension: {
        leave: ({ name: name , directives: directives , values: values  })=>$51327db84c201e34$var$join([
                "extend enum",
                name,
                $51327db84c201e34$var$join(directives, " "),
                $51327db84c201e34$var$block(values)
            ], " ")
    },
    InputObjectTypeExtension: {
        leave: ({ name: name , directives: directives , fields: fields  })=>$51327db84c201e34$var$join([
                "extend input",
                name,
                $51327db84c201e34$var$join(directives, " "),
                $51327db84c201e34$var$block(fields)
            ], " ")
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $51327db84c201e34$var$join(maybeArray, separator = "") {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $51327db84c201e34$var$block(array) {
    return $51327db84c201e34$var$wrap("{\n", $51327db84c201e34$var$indent($51327db84c201e34$var$join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $51327db84c201e34$var$wrap(start, maybeString, end = "") {
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function $51327db84c201e34$var$indent(str) {
    return $51327db84c201e34$var$wrap("  ", str.replace(/\n/g, "\n  "));
}
function $51327db84c201e34$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes("\n"))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}


var $3a21075a993a0ca6$exports = {};
"use strict";
function $3a21075a993a0ca6$var$__export(m) {
    for(var p in m)if (!$3a21075a993a0ca6$exports.hasOwnProperty(p)) $3a21075a993a0ca6$exports[p] = m[p];
}
Object.defineProperty($3a21075a993a0ca6$exports, "__esModule", {
    value: true
});

/*!
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */ $3a21075a993a0ca6$var$__export((parcelRequire("66QfP")));



var $i3eDV = parcelRequire("i3eDV");
var $618f6f753c2831a9$exports = {};
"use strict";
Object.defineProperty($618f6f753c2831a9$exports, "__esModule", {
    value: true
});
var $618f6f753c2831a9$var$userAgent = "";
$618f6f753c2831a9$exports.userAgent = $618f6f753c2831a9$var$userAgent;


var $5948943834f5dcbb$exports = {};
$5948943834f5dcbb$exports = JSON.parse('{"name":"aws-appsync-auth-link","version":"3.0.7","main":"lib/index.js","license":"Apache-2.0","description":"AWS Mobile AppSync Auth Link for JavaScript","author":{"name":"Amazon Web Services","url":"https://aws.amazon.com/"},"homepage":"https://github.com/awslabs/aws-mobile-appsync-sdk-js.git","repository":{"type":"git","url":"https://github.com/awslabs/aws-mobile-appsync-sdk-js.git"},"scripts":{"prepare":"tsc","test":"jest --coverage --coverageReporters=text --passWithNoTests","test-watch":"jest --watch"},"dependencies":{"@aws-crypto/sha256-js":"^1.2.0","@aws-sdk/types":"^3.25.0","@aws-sdk/util-hex-encoding":"^3.29.0","debug":"2.6.9"},"devDependencies":{"@apollo/client":"^3.2.0"},"peerDependencies":{"@apollo/client":"3.x"}}');


var $aaaa754dc2a4d49d$var$SERVICE = "appsync";
$aaaa754dc2a4d49d$exports.USER_AGENT_HEADER = "x-amz-user-agent";
$aaaa754dc2a4d49d$exports.USER_AGENT = "aws-amplify/" + $5948943834f5dcbb$exports.version + ($618f6f753c2831a9$exports.userAgent && " ") + $618f6f753c2831a9$exports.userAgent;
var $aaaa754dc2a4d49d$var$AUTH_TYPE;
(function(AUTH_TYPE) {
    AUTH_TYPE["NONE"] = "NONE";
    AUTH_TYPE["API_KEY"] = "API_KEY";
    AUTH_TYPE["AWS_IAM"] = "AWS_IAM";
    AUTH_TYPE["AMAZON_COGNITO_USER_POOLS"] = "AMAZON_COGNITO_USER_POOLS";
    AUTH_TYPE["OPENID_CONNECT"] = "OPENID_CONNECT";
    AUTH_TYPE["AWS_LAMBDA"] = "AWS_LAMBDA";
})($aaaa754dc2a4d49d$var$AUTH_TYPE = $aaaa754dc2a4d49d$exports.AUTH_TYPE || ($aaaa754dc2a4d49d$exports.AUTH_TYPE = {}));
var $aaaa754dc2a4d49d$var$AuthLink = /** @class */ function(_super) {
    $aaaa754dc2a4d49d$var$__extends(AuthLink, _super);
    /**
     *
     * @param {*} options
     */ function AuthLink(options) {
        var _this = _super.call(this) || this;
        _this.link = $aaaa754dc2a4d49d$exports.authLink(options);
        return _this;
    }
    AuthLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return AuthLink;
}($29b9899e03084364$export$2fed3d61f740bc7f);
$aaaa754dc2a4d49d$exports.AuthLink = $aaaa754dc2a4d49d$var$AuthLink;
var $aaaa754dc2a4d49d$var$headerBasedAuth = function(_a, operation, forward) {
    var _b = _a === void 0 ? {
        header: "",
        value: ""
    } : _a, header = _b.header, value = _b.value;
    return $aaaa754dc2a4d49d$var$__awaiter(void 0, void 0, void 0, function() {
        var origContext, headers, headerValue, _c;
        var _d, _e;
        return $aaaa754dc2a4d49d$var$__generator(this, function(_f) {
            switch(_f.label){
                case 0:
                    origContext = operation.getContext();
                    headers = $aaaa754dc2a4d49d$var$__assign($aaaa754dc2a4d49d$var$__assign({}, origContext.headers), (_d = {}, _d[$aaaa754dc2a4d49d$exports.USER_AGENT_HEADER] = $aaaa754dc2a4d49d$exports.USER_AGENT, _d));
                    if (!(header && value)) return [
                        3 /*break*/ ,
                        5
                    ];
                    if (!(typeof value === "function")) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        value.call(undefined)
                    ];
                case 1:
                    _c = _f.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    return [
                        4 /*yield*/ ,
                        value
                    ];
                case 3:
                    _c = _f.sent();
                    _f.label = 4;
                case 4:
                    headerValue = _c;
                    headers = $aaaa754dc2a4d49d$var$__assign((_e = {}, _e[header] = headerValue, _e), headers);
                    _f.label = 5;
                case 5:
                    operation.setContext($aaaa754dc2a4d49d$var$__assign($aaaa754dc2a4d49d$var$__assign({}, origContext), {
                        headers: headers
                    }));
                    return [
                        2 /*return*/ ,
                        forward(operation)
                    ];
            }
        });
    });
};
var $aaaa754dc2a4d49d$var$iamBasedAuth = function(_a, operation, forward) {
    var credentials = _a.credentials, region = _a.region, url = _a.url;
    return $aaaa754dc2a4d49d$var$__awaiter(void 0, void 0, void 0, function() {
        var service, origContext, creds, _b, accessKeyId, secretAccessKey, sessionToken, _c, host, path, formatted, headers;
        var _d;
        return $aaaa754dc2a4d49d$var$__generator(this, function(_e) {
            switch(_e.label){
                case 0:
                    service = $aaaa754dc2a4d49d$var$SERVICE;
                    origContext = operation.getContext();
                    creds = typeof credentials === "function" ? credentials.call() : credentials || {};
                    if (!(creds && typeof creds.getPromise === "function")) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        creds.getPromise()
                    ];
                case 1:
                    _e.sent();
                    _e.label = 2;
                case 2:
                    return [
                        4 /*yield*/ ,
                        creds
                    ];
                case 3:
                    _b = _e.sent(), accessKeyId = _b.accessKeyId, secretAccessKey = _b.secretAccessKey, sessionToken = _b.sessionToken;
                    _c = $i3eDV.parse(url), host = _c.host, path = _c.path;
                    formatted = $aaaa754dc2a4d49d$var$__assign($aaaa754dc2a4d49d$var$__assign({}, $aaaa754dc2a4d49d$var$formatAsRequest(operation, {})), {
                        service: service,
                        region: region,
                        url: url,
                        host: host,
                        path: path
                    });
                    headers = $3a21075a993a0ca6$exports.Signer.sign(formatted, {
                        access_key: accessKeyId,
                        secret_key: secretAccessKey,
                        session_token: sessionToken
                    }).headers;
                    operation.setContext($aaaa754dc2a4d49d$var$__assign($aaaa754dc2a4d49d$var$__assign({}, origContext), {
                        headers: $aaaa754dc2a4d49d$var$__assign($aaaa754dc2a4d49d$var$__assign($aaaa754dc2a4d49d$var$__assign({}, origContext.headers), headers), (_d = {}, _d[$aaaa754dc2a4d49d$exports.USER_AGENT_HEADER] = $aaaa754dc2a4d49d$exports.USER_AGENT, _d))
                    }));
                    return [
                        2 /*return*/ ,
                        forward(operation)
                    ];
            }
        });
    });
};
$aaaa754dc2a4d49d$exports.authLink = function(_a) {
    var url = _a.url, region = _a.region, _b = _a.auth, type = (_b === void 0 ? {} : _b).type, auth = _a.auth;
    return new $29b9899e03084364$export$2fed3d61f740bc7f(function(operation, forward) {
        return new $665f4cdbf299a5bf$export$77cea355fa80b5f4(function(observer) {
            var handle;
            var promise;
            switch(type){
                case $aaaa754dc2a4d49d$var$AUTH_TYPE.NONE:
                    promise = $aaaa754dc2a4d49d$var$headerBasedAuth(undefined, operation, forward);
                    break;
                case $aaaa754dc2a4d49d$var$AUTH_TYPE.AWS_IAM:
                    var _a = auth.credentials, credentials = _a === void 0 ? {} : _a;
                    promise = $aaaa754dc2a4d49d$var$iamBasedAuth({
                        credentials: credentials,
                        region: region,
                        url: url
                    }, operation, forward);
                    break;
                case $aaaa754dc2a4d49d$var$AUTH_TYPE.API_KEY:
                    var _b = auth.apiKey, apiKey = _b === void 0 ? "" : _b;
                    promise = $aaaa754dc2a4d49d$var$headerBasedAuth({
                        header: "X-Api-Key",
                        value: apiKey
                    }, operation, forward);
                    break;
                case $aaaa754dc2a4d49d$var$AUTH_TYPE.AMAZON_COGNITO_USER_POOLS:
                case $aaaa754dc2a4d49d$var$AUTH_TYPE.OPENID_CONNECT:
                    var _c = auth.jwtToken, jwtToken = _c === void 0 ? "" : _c;
                    promise = $aaaa754dc2a4d49d$var$headerBasedAuth({
                        header: "Authorization",
                        value: jwtToken
                    }, operation, forward);
                    break;
                case $aaaa754dc2a4d49d$var$AUTH_TYPE.AWS_LAMBDA:
                    var _d = auth.token, token = _d === void 0 ? "" : _d;
                    promise = $aaaa754dc2a4d49d$var$headerBasedAuth({
                        header: "Authorization",
                        value: token
                    }, operation, forward);
                    break;
                default:
                    var error = new Error("Invalid AUTH_TYPE: " + auth.type);
                    throw error;
            }
            promise.then(function(observable) {
                handle = observable.subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            });
            return function() {
                if (handle) handle.unsubscribe();
            };
        });
    });
};
var $aaaa754dc2a4d49d$var$formatAsRequest = function(_a, options) {
    var operationName = _a.operationName, variables = _a.variables, query = _a.query;
    var body = {
        operationName: operationName,
        variables: $aaaa754dc2a4d49d$var$removeTemporaryVariables(variables),
        query: $51327db84c201e34$exports.print(query)
    };
    return $aaaa754dc2a4d49d$var$__assign($aaaa754dc2a4d49d$var$__assign({
        body: JSON.stringify(body),
        method: "POST"
    }, options), {
        headers: $aaaa754dc2a4d49d$var$__assign({
            accept: "*/*",
            "content-type": "application/json; charset=UTF-8"
        }, options.headers)
    });
};
/**
 * Removes all temporary variables (starting with '@@') so that the signature matches the final request.
 */ var $aaaa754dc2a4d49d$var$removeTemporaryVariables = function(variables) {
    return Object.keys(variables).filter(function(key) {
        return !key.startsWith("@@");
    }).reduce(function(acc, key) {
        acc[key] = variables[key];
        return acc;
    }, {});
};


$ed43c0849025d39c$exports.AuthLink = $aaaa754dc2a4d49d$exports.AuthLink;
$ed43c0849025d39c$exports.AUTH_TYPE = $aaaa754dc2a4d49d$exports.AUTH_TYPE;
$ed43c0849025d39c$exports.USER_AGENT_HEADER = $aaaa754dc2a4d49d$exports.USER_AGENT_HEADER;
$ed43c0849025d39c$exports.USER_AGENT = $aaaa754dc2a4d49d$exports.USER_AGENT;
$ed43c0849025d39c$exports.createAuthLink = function(_a) {
    var url = _a.url, region = _a.region, auth = _a.auth;
    return new $aaaa754dc2a4d49d$exports.AuthLink({
        url: url,
        region: region,
        auth: auth
    });
};

$ed43c0849025d39c$exports.Signer = $3a21075a993a0ca6$exports.Signer;


var $9efa2e8b576f37ff$exports = {};
(function(global, factory) {
    $9efa2e8b576f37ff$exports = factory();
})($9efa2e8b576f37ff$exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});





function $a11faa240a7c3670$export$2288787135a8f66e(errorHandler) {
    return new (0, $29b9899e03084364$export$2fed3d61f740bc7f)(function(operation, forward) {
        return new (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $a11faa240a7c3670$export$d2c8415987899609 = function(_super) {
    (0, $1aaf9c65fb7afb7d$export$a8ba968b8961cb8a)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $a11faa240a7c3670$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $29b9899e03084364$export$2fed3d61f740bc7f));





function $50e82af4701276a4$export$9b78b6e2e23bb740(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}


function $41d0b4a299f43783$export$6ec38d408c35f4c9(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}


var $ef5434c5fe0a2bce$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $1aaf9c65fb7afb7d$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $1aaf9c65fb7afb7d$export$67ebef60e6f28a6)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = undefined;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = undefined;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $ef5434c5fe0a2bce$export$943d544ad120494a = function(_super) {
    (0, $1aaf9c65fb7afb7d$export$a8ba968b8961cb8a)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === "function" ? delay : (0, $50e82af4701276a4$export$9b78b6e2e23bb740)(delay);
        _this.retryIf = typeof attempts === "function" ? attempts : (0, $41d0b4a299f43783$export$6ec38d408c35f4c9)(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $ef5434c5fe0a2bce$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $665f4cdbf299a5bf$export$77cea355fa80b5f4)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $29b9899e03084364$export$2fed3d61f740bc7f));



var $3lHwZ = parcelRequire("3lHwZ");
var $iMHif = parcelRequire("iMHif");

var $kDFdm = parcelRequire("kDFdm");
// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $6a14300e075c8f51$export$f5282963edea4a68(exception, captureContext) {
    return (0, $kDFdm.getCurrentHub)().captureException(exception, {
        captureContext: captureContext
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */ function $6a14300e075c8f51$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return (0, $kDFdm.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */ function $6a14300e075c8f51$export$1462b974fdcf6ba2(event, hint) {
    return (0, $kDFdm.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */ function $6a14300e075c8f51$export$99d44f04437e9cb8(callback) {
    (0, $kDFdm.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ function $6a14300e075c8f51$export$efda9a273d7a036d(breadcrumb) {
    (0, $kDFdm.getCurrentHub)().addBreadcrumb(breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6a14300e075c8f51$export$2f04de43fe27971a(name, context) {
    (0, $kDFdm.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $6a14300e075c8f51$export$bb4922da0dd51b92(extras) {
    (0, $kDFdm.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $6a14300e075c8f51$export$8e8e7789d42ed61d(key, extra) {
    (0, $kDFdm.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $6a14300e075c8f51$export$74a8fb34822092e6(tags) {
    (0, $kDFdm.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $6a14300e075c8f51$export$a37d07ee78eb4569(key, value) {
    (0, $kDFdm.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $6a14300e075c8f51$export$8b6bb3dd62a01be2(user) {
    (0, $kDFdm.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */ function $6a14300e075c8f51$export$ec58d9285c204497(callback) {
    (0, $kDFdm.getCurrentHub)().withScope(callback);
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */ function $6a14300e075c8f51$export$e262da7ae6480481(context, customSamplingContext) {
    return (0, $kDFdm.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $6a14300e075c8f51$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const client = (0, $kDFdm.getCurrentHub)().getClient();
    if (!client) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig);
    return (0, $iMHif.uuid4)();
}


var $kDFdm = parcelRequire("kDFdm");
var $kDFdm = parcelRequire("kDFdm");
var $iMHif = parcelRequire("iMHif");
var $3lHwZ = parcelRequire("3lHwZ");

var $kDFdm = parcelRequire("kDFdm");

var $f3hBG = parcelRequire("f3hBG");
const $085e355929473ea4$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $085e355929473ea4$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name  } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $085e355929473ea4$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $iMHif.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $085e355929473ea4$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $085e355929473ea4$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $085e355929473ea4$export$51abed9797baa598(integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $085e355929473ea4$export$e7390a03b70a6f2f(integration, integrationIndex);
    });
    return integrationIndex;
}
/** Setup a single integration.  */ function $085e355929473ea4$export$e7390a03b70a6f2f(integration, integrationIndex) {
    integrationIndex[integration.name] = integration;
    if ($085e355929473ea4$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        integration.setupOnce((0, $f3hBG.addGlobalEventProcessor), (0, $kDFdm.getCurrentHub));
        $085e355929473ea4$export$b14a8888f80a0b3e.push(integration.name);
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log(`Integration installed: ${integration.name}`);
    }
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $085e355929473ea4$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}


var $3lHwZ = parcelRequire("3lHwZ");
/** Regular expression used to parse a Dsn. */ const $09abc0e0994b80ec$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $09abc0e0994b80ec$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $09abc0e0994b80ec$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host , path: path , pass: pass , port: port , projectId: projectId , protocol: protocol , publicKey: publicKey  } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $09abc0e0994b80ec$export$b892860177f70a30(str) {
    const match = $09abc0e0994b80ec$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        // eslint-disable-next-line no-console
        console.error(`Invalid Sentry Dsn: ${str}`);
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $09abc0e0994b80ec$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $09abc0e0994b80ec$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $09abc0e0994b80ec$var$validateDsn(dsn) {
    if (!(typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__)) return true;
    const { port: port , projectId: projectId , protocol: protocol  } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $3lHwZ.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $3lHwZ.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$09abc0e0994b80ec$var$isValidProtocol(protocol)) {
        (0, $3lHwZ.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $3lHwZ.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $09abc0e0994b80ec$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $09abc0e0994b80ec$export$b892860177f70a30(from) : $09abc0e0994b80ec$var$dsnFromComponents(from);
    if (!components || !$09abc0e0994b80ec$var$validateDsn(components)) return undefined;
    return components;
}


var $jl9W5 = parcelRequire("jl9W5");
const $f226b942c7d61f1e$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $f226b942c7d61f1e$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $f226b942c7d61f1e$var$_getIngestEndpoint(dsn) {
    return `${$f226b942c7d61f1e$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $f226b942c7d61f1e$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $jl9W5.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $f226b942c7d61f1e$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $f226b942c7d61f1e$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$f226b942c7d61f1e$var$_getIngestEndpoint(dsn)}?${$f226b942c7d61f1e$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $f226b942c7d61f1e$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $09abc0e0994b80ec$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$f226b942c7d61f1e$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $09abc0e0994b80ec$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}


var $3lHwZ = parcelRequire("3lHwZ");

var $kDFdm = parcelRequire("kDFdm");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $c9dd657a3670fe02$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) (0, $3lHwZ.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
    }
    const hub = (0, $kDFdm.getCurrentHub)();
    const scope = hub.getScope();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    hub.bindClient(client);
}

var $029e55d274d7ae8f$exports = {};

$parcel$export($029e55d274d7ae8f$exports, "FunctionToString", function () { return $646739ab2d0dd346$export$da4704525c20ae79; });
$parcel$export($029e55d274d7ae8f$exports, "InboundFilters", function () { return $39307e9f674bfd3a$export$2ffbb5359dcc6be4; });

var $jl9W5 = parcelRequire("jl9W5");
let $646739ab2d0dd346$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ class $646739ab2d0dd346$export$da4704525c20ae79 {
    constructor(){
        $646739ab2d0dd346$export$da4704525c20ae79.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "FunctionToString";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $646739ab2d0dd346$export$da4704525c20ae79.id;
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $646739ab2d0dd346$var$originalFunctionToString = Function.prototype.toString;
        // intrinsics (like Function.prototype) might be immutable in some environments
        // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            Function.prototype.toString = function(...args) {
                const context = (0, $jl9W5.getOriginalFunction)(this) || this;
                return $646739ab2d0dd346$var$originalFunctionToString.apply(context, args);
            };
        } catch (e) {
        // ignore errors here, just don't patch this
        }
    }
}
$646739ab2d0dd346$export$da4704525c20ae79.__initStatic();



var $iMHif = parcelRequire("iMHif");
var $3lHwZ = parcelRequire("3lHwZ");
var $geIBs = parcelRequire("geIBs");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $39307e9f674bfd3a$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
const $39307e9f674bfd3a$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*healthcheck.*$/,
    /^.*healthy.*$/,
    /^.*live.*$/,
    /^.*ready.*$/,
    /^.*heartbeat.*$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ /** Inbound filters configurable by the user */ class $39307e9f674bfd3a$export$2ffbb5359dcc6be4 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "InboundFilters";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $39307e9f674bfd3a$export$2ffbb5359dcc6be4.id;
    }
    constructor(_options = {}){
        this._options = _options;
        $39307e9f674bfd3a$export$2ffbb5359dcc6be4.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ setupOnce(addGlobalEventProcessor, getCurrentHub) {
        const eventProcess = (event)=>{
            const hub = getCurrentHub();
            if (hub) {
                const self = hub.getIntegration($39307e9f674bfd3a$export$2ffbb5359dcc6be4);
                if (self) {
                    const client = hub.getClient();
                    const clientOptions = client ? client.getOptions() : {};
                    const options = $39307e9f674bfd3a$export$6620a151868b99aa(self._options, clientOptions);
                    return $39307e9f674bfd3a$export$3c6361fddf6cd929(event, options) ? null : event;
                }
            }
            return event;
        };
        eventProcess.id = this.name;
        addGlobalEventProcessor(eventProcess);
    }
}
$39307e9f674bfd3a$export$2ffbb5359dcc6be4.__initStatic();
/** JSDoc */ function $39307e9f674bfd3a$export$6620a151868b99aa(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $39307e9f674bfd3a$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $39307e9f674bfd3a$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
/** JSDoc */ function $39307e9f674bfd3a$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $39307e9f674bfd3a$var$_isSentryError(event)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $iMHif.getEventDescription)(event)}`);
        return true;
    }
    if ($39307e9f674bfd3a$var$_isIgnoredError(event, options.ignoreErrors)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $iMHif.getEventDescription)(event)}`);
        return true;
    }
    if ($39307e9f674bfd3a$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $iMHif.getEventDescription)(event)}`);
        return true;
    }
    if ($39307e9f674bfd3a$var$_isDeniedUrl(event, options.denyUrls)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $iMHif.getEventDescription)(event)}.\nUrl: ${$39307e9f674bfd3a$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$39307e9f674bfd3a$var$_isAllowedUrl(event, options.allowUrls)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $iMHif.getEventDescription)(event)}.\nUrl: ${$39307e9f674bfd3a$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $39307e9f674bfd3a$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $39307e9f674bfd3a$var$_getPossibleEventMessages(event).some((message)=>(0, $geIBs.stringMatchesSomePattern)(message, ignoreErrors));
}
function $39307e9f674bfd3a$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $geIBs.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $39307e9f674bfd3a$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $39307e9f674bfd3a$var$_getEventFilterUrl(event);
    return !url ? false : (0, $geIBs.stringMatchesSomePattern)(url, denyUrls);
}
function $39307e9f674bfd3a$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $39307e9f674bfd3a$var$_getEventFilterUrl(event);
    return !url ? true : (0, $geIBs.stringMatchesSomePattern)(url, allowUrls);
}
function $39307e9f674bfd3a$var$_getPossibleEventMessages(event) {
    if (event.message) return [
        event.message
    ];
    if (event.exception) {
        const { values: values  } = event.exception;
        try {
            const { type: type = "" , value: value = ""  } = values && values[values.length - 1] || {};
            return [
                `${value}`,
                `${type}: ${value}`
            ];
        } catch (oO) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error(`Cannot extract message for event ${(0, $iMHif.getEventDescription)(event)}`);
            return [];
        }
    }
    return [];
}
function $39307e9f674bfd3a$var$_isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $39307e9f674bfd3a$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $39307e9f674bfd3a$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $39307e9f674bfd3a$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error(`Cannot extract url for event ${(0, $iMHif.getEventDescription)(event)}`);
        return null;
    }
}





var $cIWhk = parcelRequire("cIWhk");
var $3lHwZ = parcelRequire("3lHwZ");
var $3tE1b = parcelRequire("3tE1b");
var $5GZga = parcelRequire("5GZga");
var $e8jUR = parcelRequire("e8jUR");


var $d2unA = parcelRequire("d2unA");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $4d9c36fd831c6738$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}



var $jl9W5 = parcelRequire("jl9W5");

var $5GZga = parcelRequire("5GZga");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $fa9ac95e0af8817a$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $fa9ac95e0af8817a$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $fa9ac95e0af8817a$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $fa9ac95e0af8817a$export$a3295358bff77e(object, depth);
    if ($fa9ac95e0af8817a$var$jsonSize(normalized) > maxSize) return $fa9ac95e0af8817a$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $fa9ac95e0af8817a$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $4d9c36fd831c6738$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $d2unA.isNaN)(value)) return value;
    const stringified = $fa9ac95e0af8817a$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $fa9ac95e0af8817a$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $jl9W5.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $fa9ac95e0af8817a$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $fa9ac95e0af8817a$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        // React's SyntheticEvent thingy
        if ((0, $d2unA.isSyntheticEvent)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $5GZga.getFunctionName)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $fa9ac95e0af8817a$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $fa9ac95e0af8817a$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $fa9ac95e0af8817a$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $fa9ac95e0af8817a$var$jsonSize(value) {
    return $fa9ac95e0af8817a$var$utf8Length(JSON.stringify(value));
}



var $jl9W5 = parcelRequire("jl9W5");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $1d1870952790bd6e$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $1d1870952790bd6e$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $1d1870952790bd6e$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $1d1870952790bd6e$export$604a45d95a155e2b(envelope, types) {
    return $1d1870952790bd6e$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $1d1870952790bd6e$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $1d1870952790bd6e$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $1d1870952790bd6e$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $1d1870952790bd6e$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $fa9ac95e0af8817a$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $1d1870952790bd6e$var$concatBuffers(parts);
}
function $1d1870952790bd6e$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $1d1870952790bd6e$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $1d1870952790bd6e$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $1d1870952790bd6e$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $jl9W5.dropUndefinedKeys)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $1d1870952790bd6e$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $1d1870952790bd6e$export$b11169581eeaf237(type) {
    return $1d1870952790bd6e$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from from the metadata or an events */ function $1d1870952790bd6e$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name , version: version  } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $1d1870952790bd6e$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && {
            dsn: (0, $09abc0e0994b80ec$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $jl9W5.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}


var $iMHif = parcelRequire("iMHif");
var $d2unA = parcelRequire("d2unA");
var $3lHwZ = parcelRequire("3lHwZ");
var $3tE1b = parcelRequire("3tE1b");/** An error emitted by Sentry SDKs and related utilities. */ class $bcc0425d0edf52bf$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}




/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $f49c9a94424fbc50$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $f49c9a94424fbc50$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $1d1870952790bd6e$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && {
            dsn: (0, $09abc0e0994b80ec$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $1d1870952790bd6e$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $f49c9a94424fbc50$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $1d1870952790bd6e$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $f49c9a94424fbc50$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $1d1870952790bd6e$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $1d1870952790bd6e$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}




var $dOBEf = parcelRequire("dOBEf");

var $52JFH = parcelRequire("52JFH");
var $bayd0 = parcelRequire("bayd0");
var $3tE1b = parcelRequire("3tE1b");
var $geIBs = parcelRequire("geIBs");
var $iMHif = parcelRequire("iMHif");

var $gmhqD = parcelRequire("gmhqD");

var $f3hBG = parcelRequire("f3hBG");
/**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $2c3657f9007b6f81$export$2d67fb380bd11267(options, event, hint, scope) {
    const { normalizeDepth: normalizeDepth = 3 , normalizeMaxBreadth: normalizeMaxBreadth = 1000  } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $iMHif.uuid4)(),
        timestamp: event.timestamp || (0, $52JFH.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $2c3657f9007b6f81$var$applyClientOptions(prepared, options);
    $2c3657f9007b6f81$var$applyIntegrationsMetadata(prepared, integrations);
    // Only apply debug metadata to error events.
    if (event.type === undefined) $2c3657f9007b6f81$export$4c0b0d8ee0d018b5(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    let finalScope = scope;
    if (hint.captureContext) finalScope = (0, $f3hBG.Scope).clone(finalScope).update(hint.captureContext);
    // We prepare the result here with a resolved Event.
    let result = (0, $3tE1b.resolvedSyncPromise)(prepared);
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    //
    // We need to check for the existence of `finalScope.getAttachments`
    // because `getAttachments` can be undefined if users are using an older version
    // of `@sentry/core` that does not have the `getAttachments` method.
    // See: https://github.com/getsentry/sentry-javascript/issues/5229
    if (finalScope) {
        // Collect attachments from the hint and scope
        if (finalScope.getAttachments) {
            const attachments = [
                ...hint.attachments || [],
                ...finalScope.getAttachments()
            ];
            if (attachments.length) hint.attachments = attachments;
        }
        // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
    }
    return result.then((evt)=>{
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $2c3657f9007b6f81$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $2c3657f9007b6f81$var$applyClientOptions(event, options) {
    const { environment: environment , release: release , dist: dist , maxValueLength: maxValueLength = 250  } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $gmhqD.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $geIBs.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $geIBs.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $geIBs.truncate)(request.url, maxValueLength);
}
const $2c3657f9007b6f81$var$debugIdStackParserCache = new WeakMap();
/**
 * Applies debug metadata images to the event in order to apply source maps by looking up their debug ID.
 */ function $2c3657f9007b6f81$export$4c0b0d8ee0d018b5(event, stackParser) {
    const debugIdMap = (0, $bayd0.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $2c3657f9007b6f81$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $2c3657f9007b6f81$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    // Get a Set of filenames in the stack trace
    const errorFileNames = new Set();
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) errorFileNames.add(frame.filename);
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    errorFileNames.forEach((filename)=>{
        if (filenameDebugIdMap[filename]) images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $2c3657f9007b6f81$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $2c3657f9007b6f81$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $fa9ac95e0af8817a$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $fa9ac95e0af8817a$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $fa9ac95e0af8817a$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $fa9ac95e0af8817a$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $fa9ac95e0af8817a$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
        if (span.data) span.data = (0, $fa9ac95e0af8817a$export$a3295358bff77e)(span.data, depth, maxBreadth);
        return span;
    });
    return normalized;
}


const $7433034e0cbc4d17$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $7433034e0cbc4d17$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ __init() {
        this._integrations = {};
    }
    /** Indicates whether this client's integrations have been set up. */ __init2() {
        this._integrationsInitialized = false;
    }
    /** Number of calls being processed */ __init3() {
        this._numProcessing = 0;
    }
    /** Holds flushable  */ __init4() {
        this._outcomes = {};
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    __init5() {
        this._hooks = {};
    }
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        $7433034e0cbc4d17$export$4f22f74eddb7716a.prototype.__init.call(this);
        $7433034e0cbc4d17$export$4f22f74eddb7716a.prototype.__init2.call(this);
        $7433034e0cbc4d17$export$4f22f74eddb7716a.prototype.__init3.call(this);
        $7433034e0cbc4d17$export$4f22f74eddb7716a.prototype.__init4.call(this);
        $7433034e0cbc4d17$export$4f22f74eddb7716a.prototype.__init5.call(this);
        this._options = options;
        if (options.dsn) this._dsn = (0, $09abc0e0994b80ec$export$128827c3562ec0cb)(options.dsn);
        else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn("No DSN provided, client will not do anything.");
        if (this._dsn) {
            const url = (0, $f226b942c7d61f1e$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $iMHif.checkOrSetAlreadyCaught)(exception)) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log($7433034e0cbc4d17$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const promisedEvent = (0, $d2unA.isPrimitive)(message) ? this.eventFromMessage(String(message), level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $iMHif.checkOrSetAlreadyCaught)(hint.originalException)) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log($7433034e0cbc4d17$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!this._isEnabled()) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn("SDK not enabled, will not capture session.");
            return;
        }
        if (!(typeof session.release === "string")) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $dOBEf.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
            return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
        });
        else return (0, $3tE1b.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            return result;
        });
    }
    /**
   * Sets up the integrations
   */ setupIntegrations() {
        if (this._isEnabled() && !this._integrationsInitialized) {
            this._integrations = (0, $085e355929473ea4$export$51abed9797baa598)(this._options.integrations);
            this._integrationsInitialized = true;
        }
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */ getIntegrationById(integrationId) {
        return this._integrations[integrationId];
    }
    /**
   * @inheritDoc
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        (0, $085e355929473ea4$export$e7390a03b70a6f2f)(integration, this._integrations);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        if (this._dsn) {
            let env = (0, $f49c9a94424fbc50$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
            for (const attachment of hint.attachments || [])env = (0, $1d1870952790bd6e$export$d650323442802f6f)(env, (0, $1d1870952790bd6e$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
            const promise = this._sendEnvelope(env);
            if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
        }
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        if (this._dsn) {
            const env = (0, $f49c9a94424fbc50$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
            this._sendEnvelope(env);
        }
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, _event) {
        // Note: we use `event` in replay, where we overwrite this hook.
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-ignore We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) // @ts-ignore we cannot enforce the callback to match the hook
        this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $dOBEf.updateSession)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $3tE1b.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        return (0, $2c3657f9007b6f81$export$2d67fb380bd11267)(options, event, hint, scope);
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $3lHwZ.logger).log(sentryError.message);
                else (0, $3lHwZ.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate  } = options;
        if (!this._isEnabled()) return (0, $3tE1b.rejectedSyncPromise)(new (0, $bcc0425d0edf52bf$export$5949942ba2a7c0e2)("SDK not enabled, will not capture event.", "log"));
        const isTransaction = $7433034e0cbc4d17$var$isTransactionEvent(event);
        const isError = $7433034e0cbc4d17$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $3tE1b.rejectedSyncPromise)(new (0, $bcc0425d0edf52bf$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        return this._prepareEvent(event, hint, scope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $bcc0425d0edf52bf$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $7433034e0cbc4d17$var$processBeforeSend(options, prepared, hint);
            return $7433034e0cbc4d17$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                throw new (0, $bcc0425d0edf52bf$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $bcc0425d0edf52bf$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $bcc0425d0edf52bf$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        if (this._transport && this._dsn) {
            this.emit("beforeEnvelope", envelope);
            return this._transport.send(envelope).then(null, (reason)=>{
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error("Error while sending event:", reason);
            });
        } else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $7433034e0cbc4d17$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $d2unA.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $d2unA.isPlainObject)(event) && event !== null) throw new (0, $bcc0425d0edf52bf$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $bcc0425d0edf52bf$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $d2unA.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $bcc0425d0edf52bf$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $7433034e0cbc4d17$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend , beforeSendTransaction: beforeSendTransaction  } = options;
    if ($7433034e0cbc4d17$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($7433034e0cbc4d17$var$isTransactionEvent(event) && beforeSendTransaction) return beforeSendTransaction(event, hint);
    return event;
}
function $7433034e0cbc4d17$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $7433034e0cbc4d17$var$isTransactionEvent(event) {
    return event.type === "transaction";
}

const $830e77fc99740b62$export$31499a9cd224b78c = "7.54.0";




var $52JFH = parcelRequire("52JFH");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $96780474e101edc1$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $52JFH.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $1d1870952790bd6e$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


var $42Tef = parcelRequire("42Tef");
var $3lHwZ = parcelRequire("3lHwZ");

var $kDFdm = parcelRequire("kDFdm");

var $iMHif = parcelRequire("iMHif");
var $jl9W5 = parcelRequire("jl9W5");
var $d2unA = parcelRequire("d2unA");
var $3tE1b = parcelRequire("3tE1b");
/**
 * This function creates an exception from a JavaScript Error
 */ function $eab4e78c5ab69056$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $eab4e78c5ab69056$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $eab4e78c5ab69056$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $eab4e78c5ab69056$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const hub = (0, $kDFdm.getCurrentHub)();
    const client = hub.getClient();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $d2unA.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: `Non-Error ${isUnhandledRejection ? "promise rejection" : "exception"} captured with keys: ${(0, $jl9W5.extractExceptionKeysForMessage)(exception)}`
                }
            ]
        },
        extra: {
            __serialized__: (0, $fa9ac95e0af8817a$export$23fbbb20bed71033)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $eab4e78c5ab69056$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $eab4e78c5ab69056$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $eab4e78c5ab69056$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $eab4e78c5ab69056$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = $eab4e78c5ab69056$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $eab4e78c5ab69056$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $eab4e78c5ab69056$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($eab4e78c5ab69056$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $eab4e78c5ab69056$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $eab4e78c5ab69056$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $eab4e78c5ab69056$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $iMHif.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $3tE1b.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $eab4e78c5ab69056$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $eab4e78c5ab69056$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $3tE1b.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $eab4e78c5ab69056$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $d2unA.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $eab4e78c5ab69056$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $d2unA.isDOMError)(exception) || (0, $d2unA.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $eab4e78c5ab69056$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $d2unA.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $eab4e78c5ab69056$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $iMHif.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $d2unA.isError)(exception)) // we have a real Error object, do nothing
    return $eab4e78c5ab69056$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $d2unA.isPlainObject)(exception) || (0, $d2unA.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $eab4e78c5ab69056$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $iMHif.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $eab4e78c5ab69056$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $iMHif.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $iMHif.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $eab4e78c5ab69056$export$47d86ae4b3c9994(stackParser, input, syntheticException, attachStacktrace) {
    const event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        const frames = $eab4e78c5ab69056$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: input,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    return event;
}




var $iMHif = parcelRequire("iMHif");
var $jl9W5 = parcelRequire("jl9W5");
var $bayd0 = parcelRequire("bayd0");
const $a4fbd4ce490a2c64$export$56d8a8a25bd48b81 = (0, $bayd0.GLOBAL_OBJ);
let $a4fbd4ce490a2c64$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $a4fbd4ce490a2c64$export$b79738ab10c590b2() {
    return $a4fbd4ce490a2c64$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $a4fbd4ce490a2c64$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $a4fbd4ce490a2c64$var$ignoreOnError++;
    setTimeout(()=>{
        $a4fbd4ce490a2c64$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $a4fbd4ce490a2c64$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $jl9W5.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$a4fbd4ce490a2c64$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $a4fbd4ce490a2c64$export$1265a142ff5ba165();
            (0, $6a14300e075c8f51$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $iMHif.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $iMHif.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $6a14300e075c8f51$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $jl9W5.markFunctionWrapped)(sentryWrapped, fn);
    (0, $jl9W5.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



var $kDFdm = parcelRequire("kDFdm");

var $cIWhk = parcelRequire("cIWhk");
var $iMHif = parcelRequire("iMHif");
var $iTlxf = parcelRequire("iTlxf");
var $3lHwZ = parcelRequire("3lHwZ");/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $0ea526eae9bcadb2$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $0ea526eae9bcadb2$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $0ea526eae9bcadb2$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $0ea526eae9bcadb2$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol , host: host , path: path  } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    .replace(":80", "").replace(":443", "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}


var $geIBs = parcelRequire("geIBs");// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $f76e950a18c30a8f$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $f76e950a18c30a8f$export$e01cef29b4327697(level) {
    return $f76e950a18c30a8f$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $f76e950a18c30a8f$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $f76e950a18c30a8f$export$411d0ffdba845b6c.includes(level) ? level : "log";
}



/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $44c0a8599621b4f0$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $44c0a8599621b4f0$export$6d0f6df16bece7bf = "Breadcrumbs";
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ class $44c0a8599621b4f0$export$2dc68d50d56fbbd {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = $44c0a8599621b4f0$export$6d0f6df16bece7bf;
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $44c0a8599621b4f0$export$2dc68d50d56fbbd.id;
    }
    /**
   * Options of the breadcrumbs integration.
   */ // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.
    /**
   * @inheritDoc
   */ constructor(options){
        $44c0a8599621b4f0$export$2dc68d50d56fbbd.prototype.__init.call(this);
        this.options = {
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true,
            ...options
        };
    }
    /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */ setupOnce() {
        if (this.options.console) (0, $cIWhk.addInstrumentationHandler)("console", $44c0a8599621b4f0$var$_consoleBreadcrumb);
        if (this.options.dom) (0, $cIWhk.addInstrumentationHandler)("dom", $44c0a8599621b4f0$var$_domBreadcrumb(this.options.dom));
        if (this.options.xhr) (0, $cIWhk.addInstrumentationHandler)("xhr", $44c0a8599621b4f0$var$_xhrBreadcrumb);
        if (this.options.fetch) (0, $cIWhk.addInstrumentationHandler)("fetch", $44c0a8599621b4f0$var$_fetchBreadcrumb);
        if (this.options.history) (0, $cIWhk.addInstrumentationHandler)("history", $44c0a8599621b4f0$var$_historyBreadcrumb);
    }
    /**
   * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
   */ addSentryBreadcrumb(event) {
        if (this.options.sentry) (0, $kDFdm.getCurrentHub)().addBreadcrumb({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $iMHif.getEventDescription)(event)
        }, {
            event: event
        });
    }
}
$44c0a8599621b4f0$export$2dc68d50d56fbbd.__initStatic();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $44c0a8599621b4f0$var$_domBreadcrumb(dom) {
    function _innerDomBreadcrumb(handlerData) {
        let target;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $44c0a8599621b4f0$var$MAX_ALLOWED_STRING_LENGTH) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$44c0a8599621b4f0$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$44c0a8599621b4f0$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $44c0a8599621b4f0$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            target = $44c0a8599621b4f0$var$_isEvent(event) ? (0, $iTlxf.htmlTreeAsString)(event.target, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            }) : (0, $iTlxf.htmlTreeAsString)(event, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        (0, $kDFdm.getCurrentHub)().addBreadcrumb({
            category: `ui.${handlerData.name}`,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ function $44c0a8599621b4f0$var$_consoleBreadcrumb(handlerData) {
    // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
    // console warnings. This happens when a Vue template is rendered with
    // an undeclared variable, which we try to stringify, ultimately causing
    // Vue to issue another warning which repeats indefinitely.
    // see: https://github.com/getsentry/sentry-javascript/pull/6010
    // see: https://github.com/getsentry/sentry-javascript/issues/5916
    for(let i = 0; i < handlerData.args.length; i++)if (handlerData.args[i] === "ref=Ref<") {
        handlerData.args[i + 1] = "viewRef";
        break;
    }
    const breadcrumb = {
        category: "console",
        data: {
            arguments: handlerData.args,
            logger: "console"
        },
        level: (0, $f76e950a18c30a8f$export$d771ef054122c30a)(handlerData.level),
        message: (0, $geIBs.safeJoin)(handlerData.args, " ")
    };
    if (handlerData.level === "assert") {
        if (handlerData.args[0] === false) {
            breadcrumb.message = `Assertion failed: ${(0, $geIBs.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $kDFdm.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $44c0a8599621b4f0$var$_xhrBreadcrumb(handlerData) {
    const { startTimestamp: startTimestamp , endTimestamp: endTimestamp  } = handlerData;
    const sentryXhrData = handlerData.xhr[0, $cIWhk.SENTRY_XHR_DATA_KEY];
    // We only capture complete, non-sentry requests
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
    const { method: method , url: url , status_code: status_code , body: body  } = sentryXhrData;
    const data = {
        method: method,
        url: url,
        status_code: status_code
    };
    const hint = {
        xhr: handlerData.xhr,
        input: body,
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp
    };
    (0, $kDFdm.getCurrentHub)().addBreadcrumb({
        category: "xhr",
        data: data,
        type: "http"
    }, hint);
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $44c0a8599621b4f0$var$_fetchBreadcrumb(handlerData) {
    const { startTimestamp: startTimestamp , endTimestamp: endTimestamp  } = handlerData;
    // We only capture complete fetch requests
    if (!endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) {
        const data = handlerData.fetchData;
        const hint = {
            data: handlerData.error,
            input: handlerData.args,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $kDFdm.getCurrentHub)().addBreadcrumb({
            category: "fetch",
            data: data,
            level: "error",
            type: "http"
        }, hint);
    } else {
        const data = {
            ...handlerData.fetchData,
            status_code: handlerData.response && handlerData.response.status
        };
        const hint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $kDFdm.getCurrentHub)().addBreadcrumb({
            category: "fetch",
            data: data,
            type: "http"
        }, hint);
    }
}
/**
 * Creates breadcrumbs from history API calls
 */ function $44c0a8599621b4f0$var$_historyBreadcrumb(handlerData) {
    let from = handlerData.from;
    let to = handlerData.to;
    const parsedLoc = (0, $0ea526eae9bcadb2$export$7a5253c0f62e0150)((0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).location.href);
    let parsedFrom = (0, $0ea526eae9bcadb2$export$7a5253c0f62e0150)(from);
    const parsedTo = (0, $0ea526eae9bcadb2$export$7a5253c0f62e0150)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $kDFdm.getCurrentHub)().addBreadcrumb({
        category: "navigation",
        data: {
            from: from,
            to: to
        }
    });
}
function $44c0a8599621b4f0$var$_isEvent(event) {
    return event && !!event.target;
}



/**
 * Creates an envelope from a user feedback.
 */ function $5b377fcdef742dc4$export$24a4dfcb686ee5bf(feedback, { metadata: metadata , tunnel: tunnel , dsn: dsn  }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $09abc0e0994b80ec$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $5b377fcdef742dc4$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $1d1870952790bd6e$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $5b377fcdef742dc4$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $c9498704cc142a89$export$1df9218a526d318d extends (0, $7433034e0cbc4d17$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $42Tef.getSDKSource)();
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: "sentry.javascript.browser",
            packages: [
                {
                    name: `${sdkSource}:@sentry/browser`,
                    version: (0, $830e77fc99740b62$export$31499a9cd224b78c)
                }
            ],
            version: (0, $830e77fc99740b62$export$31499a9cd224b78c)
        };
        super(options);
        if (options.sendClientReports && (0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).document) (0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $eab4e78c5ab69056$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, $eab4e78c5ab69056$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint) {
        // We only want to add the sentry event breadcrumb when the user has the breadcrumb integration installed and
        // activated its `sentry` option.
        // We also do not want to use the `Breadcrumbs` class here directly, because we do not want it to be included in
        // bundles, if it is not used by the SDK.
        // This all sadly is a bit ugly, but we currently don't have a "pre-send" hook on the integrations so we do it this
        // way for now.
        const breadcrumbIntegration = this.getIntegrationById((0, $44c0a8599621b4f0$export$6d0f6df16bece7bf));
        // We check for definedness of `addSentryBreadcrumb` in case users provided their own integration with id
        // "Breadcrumbs" that does not have this function.
        if (breadcrumbIntegration && breadcrumbIntegration.addSentryBreadcrumb) breadcrumbIntegration.addSentryBreadcrumb(event);
        super.sendEvent(event, hint);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $5b377fcdef742dc4$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("No outcomes to send");
            return;
        }
        if (!this._dsn) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("No dsn provided, will not send outcomes");
            return;
        }
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("Sending outcomes:", outcomes);
        const envelope = (0, $96780474e101edc1$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $09abc0e0994b80ec$export$44d472fbb931a776)(this._dsn));
        this._sendEnvelope(envelope);
    }
}




var $kDFdm = parcelRequire("kDFdm");

var $iMHif = parcelRequire("iMHif");
var $cIWhk = parcelRequire("cIWhk");
var $iTlxf = parcelRequire("iTlxf");
var $d2unA = parcelRequire("d2unA");
var $3lHwZ = parcelRequire("3lHwZ");


/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Global handlers */ class $f15d8f7343257e88$export$204155decbc90e5a {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "GlobalHandlers";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $f15d8f7343257e88$export$204155decbc90e5a.id;
    }
    /** JSDoc */ /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */ __init2() {
        this._installFunc = {
            onerror: $f15d8f7343257e88$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $f15d8f7343257e88$var$_installGlobalOnUnhandledRejectionHandler
        };
    }
    /** JSDoc */ constructor(options){
        $f15d8f7343257e88$export$204155decbc90e5a.prototype.__init.call(this);
        $f15d8f7343257e88$export$204155decbc90e5a.prototype.__init2.call(this);
        this._options = {
            onerror: true,
            onunhandledrejection: true,
            ...options
        };
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        Error.stackTraceLimit = 50;
        const options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(const key in options){
            const installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $f15d8f7343257e88$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    }
}
$f15d8f7343257e88$export$204155decbc90e5a.__initStatic();
/** JSDoc */ function $f15d8f7343257e88$var$_installGlobalOnErrorHandler() {
    (0, $cIWhk.addInstrumentationHandler)("error", // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (data)=>{
        const [hub, stackParser, attachStacktrace] = $f15d8f7343257e88$var$getHubAndOptions();
        if (!hub.getIntegration($f15d8f7343257e88$export$204155decbc90e5a)) return;
        const { msg: msg , url: url , line: line , column: column , error: error  } = data;
        if ((0, $a4fbd4ce490a2c64$export$b79738ab10c590b2)() || error && error.__sentry_own_request__) return;
        const event = error === undefined && (0, $d2unA.isString)(msg) ? $f15d8f7343257e88$var$_eventFromIncompleteOnError(msg, url, line, column) : $f15d8f7343257e88$var$_enhanceEventWithInitialFrame((0, $eab4e78c5ab69056$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        $f15d8f7343257e88$var$addMechanismAndCapture(hub, error, event, "onerror");
    });
}
/** JSDoc */ function $f15d8f7343257e88$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $cIWhk.addInstrumentationHandler)("unhandledrejection", // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e)=>{
        const [hub, stackParser, attachStacktrace] = $f15d8f7343257e88$var$getHubAndOptions();
        if (!hub.getIntegration($f15d8f7343257e88$export$204155decbc90e5a)) return;
        let error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ("reason" in e) error = e.reason;
            else if ("detail" in e && "reason" in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $a4fbd4ce490a2c64$export$b79738ab10c590b2)() || error && error.__sentry_own_request__) return true;
        const event = (0, $d2unA.isPrimitive)(error) ? $f15d8f7343257e88$var$_eventFromRejectionWithPrimitive(error) : (0, $eab4e78c5ab69056$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        $f15d8f7343257e88$var$addMechanismAndCapture(hub, error, event, "onunhandledrejection");
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $f15d8f7343257e88$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f15d8f7343257e88$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $d2unA.isErrorEvent)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $f15d8f7343257e88$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f15d8f7343257e88$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $d2unA.isString)(url) && url.length > 0 ? url : (0, $iTlxf.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $f15d8f7343257e88$var$globalHandlerLog(type) {
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log(`Global Handler attached: ${type}`);
}
function $f15d8f7343257e88$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $iMHif.addExceptionMechanism)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $f15d8f7343257e88$var$getHubAndOptions() {
    const hub = (0, $kDFdm.getCurrentHub)();
    const client = hub.getClient();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return [
        hub,
        options.stackParser,
        options.attachStacktrace
    ];
}



var $jl9W5 = parcelRequire("jl9W5");
var $5GZga = parcelRequire("5GZga");

const $a2e9d2b036437b6a$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ class $a2e9d2b036437b6a$export$f1a018517668e6d3 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "TryCatch";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $a2e9d2b036437b6a$export$f1a018517668e6d3.id;
    }
    /** JSDoc */ /**
   * @inheritDoc
   */ constructor(options){
        $a2e9d2b036437b6a$export$f1a018517668e6d3.prototype.__init.call(this);
        this._options = {
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true,
            ...options
        };
    }
    /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */ setupOnce() {
        if (this._options.setTimeout) (0, $jl9W5.fill)((0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81), "setTimeout", $a2e9d2b036437b6a$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $jl9W5.fill)((0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81), "setInterval", $a2e9d2b036437b6a$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $jl9W5.fill)((0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81), "requestAnimationFrame", $a2e9d2b036437b6a$var$_wrapRAF);
        if (this._options.XMLHttpRequest && "XMLHttpRequest" in (0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81)) (0, $jl9W5.fill)(XMLHttpRequest.prototype, "send", $a2e9d2b036437b6a$var$_wrapXHR);
        const eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $a2e9d2b036437b6a$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($a2e9d2b036437b6a$var$_wrapEventTarget);
        }
    }
}
$a2e9d2b036437b6a$export$f1a018517668e6d3.__initStatic();
/** JSDoc */ function $a2e9d2b036437b6a$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $a4fbd4ce490a2c64$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $5GZga.getFunctionName)(original)
                },
                handled: true,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a2e9d2b036437b6a$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $a4fbd4ce490a2c64$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $5GZga.getFunctionName)(original)
                    },
                    handled: true,
                    type: "instrument"
                }
            })
        ]);
    };
}
/** JSDoc */ function $a2e9d2b036437b6a$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $jl9W5.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $5GZga.getFunctionName)(original)
                        },
                        handled: true,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $jl9W5.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $5GZga.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $a4fbd4ce490a2c64$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $a2e9d2b036437b6a$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $jl9W5.fill)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $a4fbd4ce490a2c64$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $5GZga.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $a4fbd4ce490a2c64$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $5GZga.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $jl9W5.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}




var $f3hBG = parcelRequire("f3hBG");
var $kDFdm = parcelRequire("kDFdm");

var $d2unA = parcelRequire("d2unA");

const $b19b361fe834cf5d$var$DEFAULT_KEY = "cause";
const $b19b361fe834cf5d$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ class $b19b361fe834cf5d$export$8d1e60aaf616fb4f {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "LinkedErrors";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $b19b361fe834cf5d$export$8d1e60aaf616fb4f.id;
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        $b19b361fe834cf5d$export$8d1e60aaf616fb4f.prototype.__init.call(this);
        this._key = options.key || $b19b361fe834cf5d$var$DEFAULT_KEY;
        this._limit = options.limit || $b19b361fe834cf5d$var$DEFAULT_LIMIT;
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        const client = (0, $kDFdm.getCurrentHub)().getClient();
        if (!client) return;
        (0, $f3hBG.addGlobalEventProcessor)((event, hint)=>{
            const self = (0, $kDFdm.getCurrentHub)().getIntegration($b19b361fe834cf5d$export$8d1e60aaf616fb4f);
            return self ? $b19b361fe834cf5d$export$7bd713d0612d8839(client.getOptions().stackParser, self._key, self._limit, event, hint) : event;
        });
    }
}
$b19b361fe834cf5d$export$8d1e60aaf616fb4f.__initStatic();
/**
 * @inheritDoc
 */ function $b19b361fe834cf5d$export$7bd713d0612d8839(parser, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $d2unA.isInstanceOf)(hint.originalException, Error)) return event;
    const linkedErrors = $b19b361fe834cf5d$export$e4e3ecf6f8f76c75(parser, limit, hint.originalException, key);
    event.exception.values = [
        ...linkedErrors,
        ...event.exception.values
    ];
    return event;
}
/**
 * JSDOC
 */ function $b19b361fe834cf5d$export$e4e3ecf6f8f76c75(parser, limit, error, key, stack = []) {
    if (!(0, $d2unA.isInstanceOf)(error[key], Error) || stack.length + 1 >= limit) return stack;
    const exception = (0, $eab4e78c5ab69056$export$a6c2d27607295951)(parser, error[key]);
    return $b19b361fe834cf5d$export$e4e3ecf6f8f76c75(parser, limit, error[key], key, [
        exception,
        ...stack
    ]);
}



var $f3hBG = parcelRequire("f3hBG");
var $kDFdm = parcelRequire("kDFdm");

/** HttpContext integration collects information about HTTP request headers */ class $bc1843e8329ce39e$export$5d2ee9a544b09a94 {
    constructor(){
        $bc1843e8329ce39e$export$5d2ee9a544b09a94.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "HttpContext";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $bc1843e8329ce39e$export$5d2ee9a544b09a94.id;
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        (0, $f3hBG.addGlobalEventProcessor)((event)=>{
            if ((0, $kDFdm.getCurrentHub)().getIntegration($bc1843e8329ce39e$export$5d2ee9a544b09a94)) {
                // if none of the information we want exists, don't bother
                if (!(0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).navigator && !(0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).location && !(0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).document) return event;
                // grab as much info as exists and add it to the event
                const url = event.request && event.request.url || (0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).location && (0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).location.href;
                const { referrer: referrer  } = (0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).document || {};
                const { userAgent: userAgent  } = (0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).navigator || {};
                const headers = {
                    ...event.request && event.request.headers,
                    ...referrer && {
                        Referer: referrer
                    },
                    ...userAgent && {
                        "User-Agent": userAgent
                    }
                };
                const request = {
                    ...event.request,
                    ...url && {
                        url: url
                    },
                    headers: headers
                };
                return {
                    ...event,
                    request: request
                };
            }
            return event;
        });
    }
}
$bc1843e8329ce39e$export$5d2ee9a544b09a94.__initStatic();



var $3lHwZ = parcelRequire("3lHwZ");
/** Deduplication filter */ class $5594dc2825d91ea9$export$688d98c249d31ad3 {
    constructor(){
        $5594dc2825d91ea9$export$688d98c249d31ad3.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Dedupe";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $5594dc2825d91ea9$export$688d98c249d31ad3.id;
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ setupOnce(addGlobalEventProcessor, getCurrentHub) {
        const eventProcessor = (currentEvent)=>{
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            const self = getCurrentHub().getIntegration($5594dc2825d91ea9$export$688d98c249d31ad3);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($5594dc2825d91ea9$var$_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn("Event dropped due to being a duplicate of previously captured event.");
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        };
        eventProcessor.id = this.name;
        addGlobalEventProcessor(eventProcessor);
    }
}
$5594dc2825d91ea9$export$688d98c249d31ad3.__initStatic();
/** JSDoc */ function $5594dc2825d91ea9$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($5594dc2825d91ea9$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($5594dc2825d91ea9$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $5594dc2825d91ea9$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$5594dc2825d91ea9$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$5594dc2825d91ea9$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $5594dc2825d91ea9$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $5594dc2825d91ea9$var$_getExceptionFromEvent(previousEvent);
    const currentException = $5594dc2825d91ea9$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$5594dc2825d91ea9$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$5594dc2825d91ea9$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $5594dc2825d91ea9$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $5594dc2825d91ea9$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $5594dc2825d91ea9$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $5594dc2825d91ea9$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $5594dc2825d91ea9$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $5594dc2825d91ea9$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}



var $5GZga = parcelRequire("5GZga");
// global reference to slice
const $0b56feb88b150b43$var$UNKNOWN_FUNCTION = "?";
const $0b56feb88b150b43$var$OPERA10_PRIORITY = 10;
const $0b56feb88b150b43$var$OPERA11_PRIORITY = 20;
const $0b56feb88b150b43$var$CHROME_PRIORITY = 30;
const $0b56feb88b150b43$var$WINJS_PRIORITY = 40;
const $0b56feb88b150b43$var$GECKO_PRIORITY = 50;
function $0b56feb88b150b43$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $0b56feb88b150b43$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $0b56feb88b150b43$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $0b56feb88b150b43$var$chrome = (line)=>{
    const parts = $0b56feb88b150b43$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $0b56feb88b150b43$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $0b56feb88b150b43$var$extractSafariExtensionDetails(parts[1] || $0b56feb88b150b43$var$UNKNOWN_FUNCTION, parts[2]);
        return $0b56feb88b150b43$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $0b56feb88b150b43$export$263a749fff749872 = [
    $0b56feb88b150b43$var$CHROME_PRIORITY,
    $0b56feb88b150b43$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $0b56feb88b150b43$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $0b56feb88b150b43$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $0b56feb88b150b43$var$gecko = (line)=>{
    const parts = $0b56feb88b150b43$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $0b56feb88b150b43$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $0b56feb88b150b43$var$UNKNOWN_FUNCTION;
        [func, filename] = $0b56feb88b150b43$var$extractSafariExtensionDetails(func, filename);
        return $0b56feb88b150b43$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $0b56feb88b150b43$export$cdba47a5dd2804d = [
    $0b56feb88b150b43$var$GECKO_PRIORITY,
    $0b56feb88b150b43$var$gecko
];
const $0b56feb88b150b43$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $0b56feb88b150b43$var$winjs = (line)=>{
    const parts = $0b56feb88b150b43$var$winjsRegex.exec(line);
    return parts ? $0b56feb88b150b43$var$createFrame(parts[2], parts[1] || $0b56feb88b150b43$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $0b56feb88b150b43$export$179460296da408e8 = [
    $0b56feb88b150b43$var$WINJS_PRIORITY,
    $0b56feb88b150b43$var$winjs
];
const $0b56feb88b150b43$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $0b56feb88b150b43$var$opera10 = (line)=>{
    const parts = $0b56feb88b150b43$var$opera10Regex.exec(line);
    return parts ? $0b56feb88b150b43$var$createFrame(parts[2], parts[3] || $0b56feb88b150b43$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $0b56feb88b150b43$export$f892b52c880ffc7a = [
    $0b56feb88b150b43$var$OPERA10_PRIORITY,
    $0b56feb88b150b43$var$opera10
];
const $0b56feb88b150b43$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $0b56feb88b150b43$var$opera11 = (line)=>{
    const parts = $0b56feb88b150b43$var$opera11Regex.exec(line);
    return parts ? $0b56feb88b150b43$var$createFrame(parts[5], parts[3] || parts[4] || $0b56feb88b150b43$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $0b56feb88b150b43$export$af11af13f09fb0dc = [
    $0b56feb88b150b43$var$OPERA11_PRIORITY,
    $0b56feb88b150b43$var$opera11
];
const $0b56feb88b150b43$export$7197c0fe6554c079 = [
    $0b56feb88b150b43$export$263a749fff749872,
    $0b56feb88b150b43$export$cdba47a5dd2804d,
    $0b56feb88b150b43$export$179460296da408e8
];
const $0b56feb88b150b43$export$2b2b997d81bf3907 = (0, $5GZga.createStackParser)(...$0b56feb88b150b43$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $0b56feb88b150b43$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $0b56feb88b150b43$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $064bb2ea657e6ae6$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $064bb2ea657e6ae6$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $064bb2ea657e6ae6$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $064bb2ea657e6ae6$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $064bb2ea657e6ae6$export$6c91fec22056810a(limits, category, now = Date.now()) {
    return $064bb2ea657e6ae6$export$b89fc7b2e4c799e7(limits, category) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $064bb2ea657e6ae6$export$699aff705e0d49d4(limits, { statusCode: statusCode , headers: headers  }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories] = limit.split(":", 2);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";"))updatedRateLimits[category] = now + delay;
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $064bb2ea657e6ae6$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}


var $3lHwZ = parcelRequire("3lHwZ");

var $3tE1b = parcelRequire("3tE1b");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $6a220a9186df1334$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $3tE1b.rejectedSyncPromise)(new (0, $bcc0425d0edf52bf$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $3tE1b.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $3tE1b.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


var $3tE1b = parcelRequire("3tE1b");
const $67b4b07190248761$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $67b4b07190248761$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $6a220a9186df1334$export$85a4f67f852183e6)(options.bufferSize || $67b4b07190248761$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $1d1870952790bd6e$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const envelopeItemDataCategory = (0, $1d1870952790bd6e$export$b11169581eeaf237)(type);
            if ((0, $064bb2ea657e6ae6$export$6c91fec22056810a)(rateLimits, envelopeItemDataCategory)) {
                const event = $67b4b07190248761$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", envelopeItemDataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $3tE1b.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $1d1870952790bd6e$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $1d1870952790bd6e$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $67b4b07190248761$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $1d1870952790bd6e$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $1d1870952790bd6e$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $064bb2ea657e6ae6$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $bcc0425d0edf52bf$export$5949942ba2a7c0e2)) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $3tE1b.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $67b4b07190248761$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}



var $3tE1b = parcelRequire("3tE1b");

var $e8jUR = parcelRequire("e8jUR");
var $3lHwZ = parcelRequire("3lHwZ");

let $44f21e4fef8cdb6d$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $44f21e4fef8cdb6d$export$8be2119ce08e3379() {
    if ($44f21e4fef8cdb6d$var$cachedFetchImpl) return $44f21e4fef8cdb6d$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $e8jUR.isNativeFetch)((0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).fetch)) return $44f21e4fef8cdb6d$var$cachedFetchImpl = (0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).fetch.bind((0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81));
    const document = (0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $44f21e4fef8cdb6d$var$cachedFetchImpl = fetchImpl.bind((0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $44f21e4fef8cdb6d$export$d499686d2dd738c6() {
    $44f21e4fef8cdb6d$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $8a0b5920aacf96b5$export$b2311068c46d7cc8(options, nativeFetch = (0, $44f21e4fef8cdb6d$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $44f21e4fef8cdb6d$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $3tE1b.rejectedSyncPromise)(e);
        }
    }
    return (0, $67b4b07190248761$export$d09f50d9ab7f7b69)(options, makeRequest);
}




var $3tE1b = parcelRequire("3tE1b");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $b9f22530b595a6af$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $b9f22530b595a6af$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $3tE1b.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $b9f22530b595a6af$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $67b4b07190248761$export$d09f50d9ab7f7b69)(options, makeRequest);
}


const $f1cd10ba6d289211$export$5ef831fccfce35e5 = [
    new (0, $029e55d274d7ae8f$exports).InboundFilters(),
    new (0, $029e55d274d7ae8f$exports).FunctionToString(),
    new (0, $a2e9d2b036437b6a$export$f1a018517668e6d3)(),
    new (0, $44c0a8599621b4f0$export$2dc68d50d56fbbd)(),
    new (0, $f15d8f7343257e88$export$204155decbc90e5a)(),
    new (0, $b19b361fe834cf5d$export$8d1e60aaf616fb4f)(),
    new (0, $5594dc2825d91ea9$export$688d98c249d31ad3)(),
    new (0, $bc1843e8329ce39e$export$5d2ee9a544b09a94)()
];
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $f1cd10ba6d289211$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $f1cd10ba6d289211$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $5GZga.stackParserFromStackParserOptions)(options.stackParser || (0, $0b56feb88b150b43$export$2b2b997d81bf3907)),
        integrations: (0, $085e355929473ea4$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $e8jUR.supportsFetch)() ? (0, $8a0b5920aacf96b5$export$b2311068c46d7cc8) : (0, $b9f22530b595a6af$export$5e1441cee30d5a39))
    };
    (0, $c9dd657a3670fe02$export$5333c3f1c58d9bc1)((0, $c9498704cc142a89$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $f1cd10ba6d289211$var$startSessionTracking();
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $f1cd10ba6d289211$export$3a8fd680da42627b(options = {}, hub = (0, $kDFdm.getCurrentHub)()) {
    // doesn't work without a document (React Native)
    if (!(0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).document) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error("Global document not defined in showReportDialog call");
        return;
    }
    const { client: client , scope: scope  } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) options.eventId = hub.lastEventId();
    const script = (0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.src = (0, $f226b942c7d61f1e$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const injectionPoint = (0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).document.head || (0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error("Not injecting report dialog. No injection point found in HTML");
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $f1cd10ba6d289211$export$5d4e9fd7fac8e617() {
    return (0, $kDFdm.getCurrentHub)().lastEventId();
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $f1cd10ba6d289211$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $f1cd10ba6d289211$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ function $f1cd10ba6d289211$export$4909b86c8034bf73(timeout) {
    const client = (0, $kDFdm.getCurrentHub)().getClient();
    if (client) return client.flush(timeout);
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn("Cannot flush events. No client defined.");
    return (0, $3tE1b.resolvedSyncPromise)(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ function $f1cd10ba6d289211$export$8360e631d277ea4d(timeout) {
    const client = (0, $kDFdm.getCurrentHub)().getClient();
    if (client) return client.close(timeout);
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn("Cannot flush events and disable SDK. No client defined.");
    return (0, $3tE1b.resolvedSyncPromise)(false);
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f1cd10ba6d289211$export$4997ffc0176396a6(fn) {
    return (0, $a4fbd4ce490a2c64$export$4997ffc0176396a6)(fn)();
}
function $f1cd10ba6d289211$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $f1cd10ba6d289211$var$startSessionTracking() {
    if (typeof (0, $a4fbd4ce490a2c64$export$56d8a8a25bd48b81).document === "undefined") {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    const hub = (0, $kDFdm.getCurrentHub)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $f1cd10ba6d289211$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $cIWhk.addInstrumentationHandler)("history", ({ from: from , to: to  })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $f1cd10ba6d289211$var$startSessionOnHub((0, $kDFdm.getCurrentHub)());
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $f1cd10ba6d289211$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $kDFdm.getCurrentHub)().getClient();
    if (client) client.captureUserFeedback(feedback);
}



var $d2unA = parcelRequire("d2unA");
var $3lHwZ = parcelRequire("3lHwZ");

var $OTT3m = parcelRequire("OTT3m");

var $fV3WI = parcelRequire("fV3WI");
const $e345b001154c27fb$var$_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/errorboundary.tsx";
function $e345b001154c27fb$export$a87138b73900f5b(version) {
    const major = version.match(/^([^.]+)/);
    return major !== null && parseInt(major[0]) >= 17;
}
const $e345b001154c27fb$export$6ef4c0367e27f2d5 = "unknown";
const $e345b001154c27fb$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
function $e345b001154c27fb$var$setCause(error, cause) {
    const seenErrors = new WeakMap();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.set(error, true);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * A ErrorBoundary component that logs errors to Sentry. Requires React >= 16.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ class $e345b001154c27fb$export$e926676385687eaf extends $fV3WI.Component {
    __init() {
        this.state = $e345b001154c27fb$var$INITIAL_STATE;
    }
    __init2() {
        this._openFallbackReportDialog = true;
    }
    constructor(props){
        super(props);
        $e345b001154c27fb$export$e926676385687eaf.prototype.__init.call(this);
        $e345b001154c27fb$export$e926676385687eaf.prototype.__init2.call(this);
        $e345b001154c27fb$export$e926676385687eaf.prototype.__init3.call(this);
        const client = (0, $kDFdm.getCurrentHub)().getClient();
        if (client && client.on && props.showDialog) {
            this._openFallbackReportDialog = false;
            client.on("afterSendEvent", (event)=>{
                if (!event.type && event.event_id === this._lastEventId) (0, $f1cd10ba6d289211$export$3a8fd680da42627b)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, { componentStack: componentStack  }) {
        const { beforeCapture: beforeCapture , onError: onError , showDialog: showDialog , dialogOptions: dialogOptions  } = this.props;
        (0, $6a14300e075c8f51$export$ec58d9285c204497)((scope)=>{
            // If on React version >= 17, create stack trace from componentStack param and links
            // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
            // Linking errors requires the `LinkedErrors` integration be enabled.
            // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
            //
            // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
            // with non-error objects. This is why we need to check if the error is an error-like object.
            // See: https://github.com/getsentry/sentry-javascript/issues/6167
            if ($e345b001154c27fb$export$a87138b73900f5b($fV3WI.version) && (0, $d2unA.isError)(error)) {
                const errorBoundaryError = new Error(error.message);
                errorBoundaryError.name = `React ErrorBoundary ${errorBoundaryError.name}`;
                errorBoundaryError.stack = componentStack;
                // Using the `LinkedErrors` integration to link the errors together.
                $e345b001154c27fb$var$setCause(error, errorBoundaryError);
            }
            if (beforeCapture) beforeCapture(scope, error, componentStack);
            const eventId = (0, $6a14300e075c8f51$export$f5282963edea4a68)(error, {
                contexts: {
                    react: {
                        componentStack: componentStack
                    }
                }
            });
            if (onError) onError(error, componentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $f1cd10ba6d289211$export$3a8fd680da42627b)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount  } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error , componentStack: componentStack , eventId: eventId  } = this.state;
        const { onUnmount: onUnmount  } = this.props;
        if (onUnmount) onUnmount(error, componentStack, eventId);
    }
    __init3() {
        this.resetErrorBoundary = ()=>{
            const { onReset: onReset  } = this.props;
            const { error: error , componentStack: componentStack , eventId: eventId  } = this.state;
            if (onReset) onReset(error, componentStack, eventId);
            this.setState($e345b001154c27fb$var$INITIAL_STATE);
        };
    }
    render() {
        const { fallback: fallback , children: children  } = this.props;
        const state = this.state;
        if (state.error) {
            let element = undefined;
            if (typeof fallback === "function") element = fallback({
                error: state.error,
                componentStack: state.componentStack,
                resetError: this.resetErrorBoundary,
                eventId: state.eventId
            });
            else element = fallback;
            if ($fV3WI.isValidElement(element)) return element;
            if (fallback) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn("fallback did not produce a valid ReactElement");
            // Fail gracefully if no fallback provided or is not valid
            return null;
        }
        if (typeof children === "function") return children();
        return children;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e345b001154c27fb$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $e345b001154c27fb$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$fV3WI.createElement($e345b001154c27fb$export$e926676385687eaf, {
            ...errorBoundaryOptions,
            __self: this,
            __source: {
                fileName: $e345b001154c27fb$var$_jsxFileName,
                lineNumber: 224
            }
        }, $fV3WI.createElement(WrappedComponent, {
            ...props,
            __self: this,
            __source: {
                fileName: $e345b001154c27fb$var$_jsxFileName,
                lineNumber: 225
            }
        }));
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, (/*@__PURE__*/$parcel$interopDefault($OTT3m)))(Wrapped, WrappedComponent);
    return Wrapped;
}


/**
 * Inits the React SDK
 */ function $8b48b57f3fb14717$export$2cd8252107eb640b(options) {
    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
        name: "sentry.javascript.react",
        packages: [
            {
                name: "npm:@sentry/react",
                version: (0, $830e77fc99740b62$export$31499a9cd224b78c)
            }
        ],
        version: (0, $830e77fc99740b62$export$31499a9cd224b78c)
    };
    (0, $f1cd10ba6d289211$export$2cd8252107eb640b)(options);
}


var $f3hBG = parcelRequire("f3hBG");
var $kDFdm = parcelRequire("kDFdm");

var $cIWhk = parcelRequire("cIWhk");
var $52JFH = parcelRequire("52JFH");
var $jl9W5 = parcelRequire("jl9W5");
var $bayd0 = parcelRequire("bayd0");
var $iTlxf = parcelRequire("iTlxf");
var $6QG3c = parcelRequire("6QG3c");
var $3lHwZ = parcelRequire("3lHwZ");
var $geIBs = parcelRequire("geIBs");
var $iMHif = parcelRequire("iMHif");

var $e67mm = parcelRequire("e67mm");
// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $43b02a39892a2119$var$WINDOW = (0, $bayd0.GLOBAL_OBJ);
const $43b02a39892a2119$var$REPLAY_SESSION_KEY = "sentryReplaySession";
const $43b02a39892a2119$var$REPLAY_EVENT_NAME = "replay_event";
const $43b02a39892a2119$var$UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
// The idle limit for a session after which recording is paused.
const $43b02a39892a2119$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $43b02a39892a2119$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
// The maximum length of a session
const $43b02a39892a2119$var$MAX_SESSION_LIFE = 3600000; // 60 minutes in ms
/** Default flush delays */ const $43b02a39892a2119$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $43b02a39892a2119$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $43b02a39892a2119$var$BUFFER_CHECKOUT_TIME = 60000;
const $43b02a39892a2119$var$RETRY_BASE_INTERVAL = 5000;
const $43b02a39892a2119$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $43b02a39892a2119$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $43b02a39892a2119$var$CONSOLE_ARG_MAX_SIZE = 5000;
var $43b02a39892a2119$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($43b02a39892a2119$var$NodeType$1 || ($43b02a39892a2119$var$NodeType$1 = {}));
function $43b02a39892a2119$var$isElement(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $43b02a39892a2119$var$isShadowRoot(n) {
    const host = n === null || n === void 0 ? void 0 : n.host;
    return Boolean(host && host.shadowRoot && host.shadowRoot === n);
}
function $43b02a39892a2119$var$isInputTypeMasked({ maskInputOptions: maskInputOptions , tagName: tagName , type: type  }) {
    if (tagName.toLowerCase() === "option") tagName = "select";
    const actualType = typeof type === "string" ? type.toLowerCase() : undefined;
    return maskInputOptions[tagName.toLowerCase()] || actualType && maskInputOptions[actualType] || actualType === "password" || tagName === "input" && !type && maskInputOptions["text"];
}
function $43b02a39892a2119$var$hasInputMaskOptions({ tagName: tagName , type: type , maskInputOptions: maskInputOptions , maskInputSelector: maskInputSelector  }) {
    return maskInputSelector || $43b02a39892a2119$var$isInputTypeMasked({
        maskInputOptions: maskInputOptions,
        tagName: tagName,
        type: type
    });
}
function $43b02a39892a2119$var$maskInputValue({ input: input , maskInputSelector: maskInputSelector , unmaskInputSelector: unmaskInputSelector , maskInputOptions: maskInputOptions , tagName: tagName , type: type , value: value , maskInputFn: maskInputFn  }) {
    let text = value || "";
    if (unmaskInputSelector && input.matches(unmaskInputSelector)) return text;
    if (input.hasAttribute("data-rr-is-password")) type = "password";
    if ($43b02a39892a2119$var$isInputTypeMasked({
        maskInputOptions: maskInputOptions,
        tagName: tagName,
        type: type
    }) || maskInputSelector && input.matches(maskInputSelector)) {
        if (maskInputFn) text = maskInputFn(text);
        else text = "*".repeat(text.length);
    }
    return text;
}
const $43b02a39892a2119$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $43b02a39892a2119$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $43b02a39892a2119$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$43b02a39892a2119$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $43b02a39892a2119$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? type.toLowerCase() : null;
}
function $43b02a39892a2119$var$getInputValue(el, tagName, type) {
    typeof type === "string" && type.toLowerCase();
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
let $43b02a39892a2119$var$_id = 1;
const $43b02a39892a2119$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $43b02a39892a2119$var$IGNORED_NODE = -2;
function $43b02a39892a2119$var$defaultMaskFn(str) {
    return str ? str.replace(/[\S]/g, "*") : "";
}
function $43b02a39892a2119$var$genId() {
    return $43b02a39892a2119$var$_id++;
}
function $43b02a39892a2119$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = element.tagName.toLowerCase().trim();
    if ($43b02a39892a2119$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $43b02a39892a2119$var$getCssRulesString(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? Array.from(rules).map($43b02a39892a2119$var$getCssRuleString).join("") : null;
    } catch (error) {
        return null;
    }
}
function $43b02a39892a2119$var$getCssRuleString(rule) {
    let cssStringified = rule.cssText;
    if ($43b02a39892a2119$var$isCSSImportRule(rule)) try {
        cssStringified = $43b02a39892a2119$var$getCssRulesString(rule.styleSheet) || cssStringified;
    } catch (_a) {}
    return $43b02a39892a2119$var$validateStringifiedCssRule(cssStringified);
}
function $43b02a39892a2119$var$validateStringifiedCssRule(cssStringified) {
    if (cssStringified.indexOf(":") > -1) {
        const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
        return cssStringified.replace(regex, "$1\\$2");
    }
    return cssStringified;
}
function $43b02a39892a2119$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $43b02a39892a2119$var$stringifyStyleSheet(sheet) {
    return sheet.cssRules ? Array.from(sheet.cssRules).map((rule)=>rule.cssText ? $43b02a39892a2119$var$validateStringifiedCssRule(rule.cssText) : "").join("") : "";
}
function $43b02a39892a2119$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $43b02a39892a2119$var$canvasService;
let $43b02a39892a2119$var$canvasCtx;
const $43b02a39892a2119$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $43b02a39892a2119$var$RELATIVE_PATH = /^(?!www\.|(?:http|ftp)s?:\/\/|[A-Za-z]:\\|\/\/|#).*/;
const $43b02a39892a2119$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $43b02a39892a2119$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($43b02a39892a2119$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if (!$43b02a39892a2119$var$RELATIVE_PATH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($43b02a39892a2119$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$43b02a39892a2119$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $43b02a39892a2119$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $43b02a39892a2119$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $43b02a39892a2119$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        let match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return "";
    }
    let output = [];
    while(true){
        collectCharacters($43b02a39892a2119$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($43b02a39892a2119$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $43b02a39892a2119$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $43b02a39892a2119$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                let c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
function $43b02a39892a2119$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    const a = doc.createElement("a");
    a.href = attributeValue;
    return a.href;
}
function $43b02a39892a2119$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $43b02a39892a2119$var$getHref() {
    const a = document.createElement("a");
    a.href = "";
    return a.href;
}
function $43b02a39892a2119$var$transformAttribute(doc, element, _tagName, _name, value, maskAllText, unmaskTextSelector, maskTextFn) {
    if (!value) return value;
    const name = _name.toLowerCase();
    const tagName = _tagName.toLowerCase();
    if (name === "src" || name === "href") return $43b02a39892a2119$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $43b02a39892a2119$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $43b02a39892a2119$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $43b02a39892a2119$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $43b02a39892a2119$var$absoluteToStylesheet(value, $43b02a39892a2119$var$getHref());
    else if (tagName === "object" && name === "data") return $43b02a39892a2119$var$absoluteToDoc(doc, value);
    else if (maskAllText && $43b02a39892a2119$var$_shouldMaskAttribute(element, name, tagName, unmaskTextSelector)) return maskTextFn ? maskTextFn(value) : $43b02a39892a2119$var$defaultMaskFn(value);
    return value;
}
function $43b02a39892a2119$var$_shouldMaskAttribute(element, attribute, tagName, unmaskTextSelector) {
    if (unmaskTextSelector && element.matches(unmaskTextSelector)) return false;
    return [
        "placeholder",
        "title",
        "aria-label"
    ].indexOf(attribute) > -1 || tagName === "input" && attribute === "value" && element.hasAttribute("type") && [
        "submit",
        "button"
    ].indexOf(element.getAttribute("type").toLowerCase()) > -1;
}
function $43b02a39892a2119$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    if (unblockSelector && element.matches(unblockSelector)) return false;
    if (typeof blockClass === "string") {
        if (element.classList.contains(blockClass)) return true;
    } else for(let eIndex = 0; eIndex < element.classList.length; eIndex++){
        const className = element.classList[eIndex];
        if (blockClass.test(className)) return true;
    }
    if (blockSelector) return element.matches(blockSelector);
    return false;
}
function $43b02a39892a2119$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText) {
    if (!node) return false;
    if (node.nodeType !== node.ELEMENT_NODE) return $43b02a39892a2119$var$needMaskingText(node.parentNode, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText);
    if (unmaskTextSelector) {
        if (node.matches(unmaskTextSelector) || node.closest(unmaskTextSelector)) return false;
    }
    if (maskAllText) return true;
    if (typeof maskTextClass === "string") {
        if (node.classList.contains(maskTextClass)) return true;
    } else for(let eIndex = 0; eIndex < node.classList.length; eIndex++){
        const className = node.classList[eIndex];
        if (maskTextClass.test(className)) return true;
    }
    if (maskTextSelector) {
        if (node.matches(maskTextSelector)) return true;
    }
    return $43b02a39892a2119$var$needMaskingText(node.parentNode, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText);
}
function $43b02a39892a2119$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return;
    }
    iframeEl.addEventListener("load", listener);
}
function $43b02a39892a2119$var$serializeNode(n, options) {
    var _a;
    const { doc: doc , blockClass: blockClass , blockSelector: blockSelector , unblockSelector: unblockSelector , maskTextClass: maskTextClass , maskTextSelector: maskTextSelector , unmaskTextSelector: unmaskTextSelector , inlineStylesheet: inlineStylesheet , maskInputSelector: maskInputSelector , unmaskInputSelector: unmaskInputSelector , maskAllText: maskAllText , maskInputOptions: maskInputOptions = {} , maskTextFn: maskTextFn , maskInputFn: maskInputFn , dataURLOptions: dataURLOptions = {} , inlineImages: inlineImages , recordCanvas: recordCanvas , keepIframeSrcFn: keepIframeSrcFn  } = options;
    let rootId;
    if (doc.__sn) {
        const docId = doc.__sn.id;
        rootId = docId === 1 ? undefined : docId;
    }
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: $43b02a39892a2119$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode,
                rootId: rootId
            };
            else return {
                type: $43b02a39892a2119$var$NodeType$1.Document,
                childNodes: [],
                rootId: rootId
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $43b02a39892a2119$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            const needBlock = $43b02a39892a2119$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
            const tagName = $43b02a39892a2119$var$getValidTagName(n);
            let attributes = {};
            for (const { name: name , value: value  } of Array.from(n.attributes))if (!$43b02a39892a2119$var$skipAttribute(tagName, name)) attributes[name] = $43b02a39892a2119$var$transformAttribute(doc, n, tagName, name, value, maskAllText, unmaskTextSelector, maskTextFn);
            if (tagName === "link" && inlineStylesheet) {
                const stylesheet = Array.from(doc.styleSheets).find((s)=>{
                    return s.href === n.href;
                });
                let cssText = null;
                if (stylesheet) cssText = $43b02a39892a2119$var$getCssRulesString(stylesheet);
                if (cssText) {
                    delete attributes.rel;
                    delete attributes.href;
                    attributes._cssText = $43b02a39892a2119$var$absoluteToStylesheet(cssText, stylesheet.href);
                }
            }
            if (tagName === "style" && n.sheet && !(n.innerText || n.textContent || "").trim().length) {
                const cssText = $43b02a39892a2119$var$getCssRulesString(n.sheet);
                if (cssText) attributes._cssText = $43b02a39892a2119$var$absoluteToStylesheet(cssText, $43b02a39892a2119$var$getHref());
            }
            if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
                const el = n;
                const type = $43b02a39892a2119$var$getInputType(el);
                const value = $43b02a39892a2119$var$getInputValue(el, tagName.toUpperCase(), type);
                const checked = n.checked;
                if (type !== "submit" && type !== "button" && value) attributes.value = $43b02a39892a2119$var$maskInputValue({
                    input: el,
                    type: type,
                    tagName: tagName,
                    value: value,
                    maskInputSelector: maskInputSelector,
                    unmaskInputSelector: unmaskInputSelector,
                    maskInputOptions: maskInputOptions,
                    maskInputFn: maskInputFn
                });
                if (checked) attributes.checked = checked;
            }
            if (tagName === "option") {
                if (n.selected && !maskInputOptions["select"]) attributes.selected = true;
                else delete attributes.selected;
            }
            if (tagName === "canvas" && recordCanvas) {
                if (n.__context === "2d") {
                    if (!$43b02a39892a2119$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                } else if (!("__context" in n)) {
                    const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    const blankCanvas = document.createElement("canvas");
                    blankCanvas.width = n.width;
                    blankCanvas.height = n.height;
                    const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
                }
            }
            if (tagName === "img" && inlineImages) {
                if (!$43b02a39892a2119$var$canvasService) {
                    $43b02a39892a2119$var$canvasService = doc.createElement("canvas");
                    $43b02a39892a2119$var$canvasCtx = $43b02a39892a2119$var$canvasService.getContext("2d");
                }
                const image = n;
                const oldValue = image.crossOrigin;
                image.crossOrigin = "anonymous";
                const recordInlineImage = ()=>{
                    try {
                        $43b02a39892a2119$var$canvasService.width = image.naturalWidth;
                        $43b02a39892a2119$var$canvasService.height = image.naturalHeight;
                        $43b02a39892a2119$var$canvasCtx.drawImage(image, 0, 0);
                        attributes.rr_dataURL = $43b02a39892a2119$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    } catch (err) {
                        console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
                    }
                    oldValue ? attributes.crossOrigin = oldValue : delete attributes.crossOrigin;
                };
                if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                else image.onload = recordInlineImage;
            }
            if (tagName === "audio" || tagName === "video") {
                attributes.rr_mediaState = n.paused ? "paused" : "played";
                attributes.rr_mediaCurrentTime = n.currentTime;
            }
            if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
            if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
            if (needBlock) {
                const { width: width , height: height  } = n.getBoundingClientRect();
                attributes = {
                    class: attributes.class,
                    rr_width: `${width}px`,
                    rr_height: `${height}px`
                };
            }
            if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
                if (!n.contentDocument) attributes.rr_src = attributes.src;
                delete attributes.src;
            }
            return {
                type: $43b02a39892a2119$var$NodeType$1.Element,
                tagName: tagName,
                attributes: attributes,
                childNodes: [],
                isSVG: $43b02a39892a2119$var$isSVGElement(n) || undefined,
                needBlock: needBlock,
                rootId: rootId
            };
        case n.TEXT_NODE:
            const parentTagName = n.parentNode && n.parentNode.tagName;
            let textContent = n.textContent;
            const isStyle = parentTagName === "STYLE" ? true : undefined;
            const isScript = parentTagName === "SCRIPT" ? true : undefined;
            if (isStyle && textContent) {
                try {
                    if (n.nextSibling || n.previousSibling) ;
                    else if ((_a = n.parentNode.sheet) === null || _a === void 0 ? void 0 : _a.cssRules) textContent = $43b02a39892a2119$var$stringifyStyleSheet(n.parentNode.sheet);
                } catch (err) {
                    console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
                }
                textContent = $43b02a39892a2119$var$absoluteToStylesheet(textContent, $43b02a39892a2119$var$getHref());
            }
            if (isScript) textContent = "SCRIPT_PLACEHOLDER";
            if (parentTagName === "TEXTAREA" && textContent) textContent = "";
            else if (parentTagName === "OPTION" && textContent) {
                const option = n.parentNode;
                textContent = $43b02a39892a2119$var$maskInputValue({
                    input: option,
                    type: null,
                    tagName: parentTagName,
                    value: textContent,
                    maskInputSelector: maskInputSelector,
                    unmaskInputSelector: unmaskInputSelector,
                    maskInputOptions: maskInputOptions,
                    maskInputFn: maskInputFn
                });
            } else if (!isStyle && !isScript && $43b02a39892a2119$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText) && textContent) textContent = maskTextFn ? maskTextFn(textContent) : $43b02a39892a2119$var$defaultMaskFn(textContent);
            return {
                type: $43b02a39892a2119$var$NodeType$1.Text,
                textContent: textContent || "",
                isStyle: isStyle,
                rootId: rootId
            };
        case n.CDATA_SECTION_NODE:
            return {
                type: $43b02a39892a2119$var$NodeType$1.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $43b02a39892a2119$var$NodeType$1.Comment,
                textContent: n.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $43b02a39892a2119$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $43b02a39892a2119$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $43b02a39892a2119$var$NodeType$1.Comment) return true;
    else if (sn.type === $43b02a39892a2119$var$NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === "script" || sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && sn.attributes.href.endsWith(".js"))) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($43b02a39892a2119$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $43b02a39892a2119$var$lowerIfExists(sn.attributes.name) === "application-name" || $43b02a39892a2119$var$lowerIfExists(sn.attributes.rel) === "icon" || $43b02a39892a2119$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $43b02a39892a2119$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $43b02a39892a2119$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($43b02a39892a2119$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $43b02a39892a2119$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $43b02a39892a2119$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($43b02a39892a2119$var$lowerIfExists(sn.attributes.name) === "robots" || $43b02a39892a2119$var$lowerIfExists(sn.attributes.name) === "googlebot" || $43b02a39892a2119$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($43b02a39892a2119$var$lowerIfExists(sn.attributes.name) === "author" || $43b02a39892a2119$var$lowerIfExists(sn.attributes.name) === "generator" || $43b02a39892a2119$var$lowerIfExists(sn.attributes.name) === "framework" || $43b02a39892a2119$var$lowerIfExists(sn.attributes.name) === "publisher" || $43b02a39892a2119$var$lowerIfExists(sn.attributes.name) === "progid" || $43b02a39892a2119$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $43b02a39892a2119$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($43b02a39892a2119$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $43b02a39892a2119$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $43b02a39892a2119$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $43b02a39892a2119$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $43b02a39892a2119$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $43b02a39892a2119$var$lowerIfExists(sn.attributes.name) === "verification" || $43b02a39892a2119$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $43b02a39892a2119$var$serializeNodeWithId(n, options) {
    const { doc: doc , map: map , blockClass: blockClass , blockSelector: blockSelector , unblockSelector: unblockSelector , maskTextClass: maskTextClass , maskTextSelector: maskTextSelector , unmaskTextSelector: unmaskTextSelector , skipChild: skipChild = false , inlineStylesheet: inlineStylesheet = true , maskInputSelector: maskInputSelector , unmaskInputSelector: unmaskInputSelector , maskAllText: maskAllText , maskInputOptions: maskInputOptions = {} , maskTextFn: maskTextFn , maskInputFn: maskInputFn , slimDOMOptions: slimDOMOptions , dataURLOptions: dataURLOptions = {} , inlineImages: inlineImages = false , recordCanvas: recordCanvas = false , onSerialize: onSerialize , onIframeLoad: onIframeLoad , iframeLoadTimeout: iframeLoadTimeout = 5000 , keepIframeSrcFn: keepIframeSrcFn = ()=>false  } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true  } = options;
    const _serializedNode = $43b02a39892a2119$var$serializeNode(n, {
        doc: doc,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputSelector: maskInputSelector,
        unmaskInputSelector: unmaskInputSelector,
        maskAllText: maskAllText,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if ("__sn" in n) id = n.__sn.id;
    else if ($43b02a39892a2119$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $43b02a39892a2119$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $43b02a39892a2119$var$IGNORED_NODE;
    else id = $43b02a39892a2119$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    n.__sn = serializedNode;
    if (id === $43b02a39892a2119$var$IGNORED_NODE) return null;
    map[id] = n;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $43b02a39892a2119$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        if (n.shadowRoot) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $43b02a39892a2119$var$NodeType$1.Document || serializedNode.type === $43b02a39892a2119$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && _serializedNode.type === $43b02a39892a2119$var$NodeType$1.Element && _serializedNode.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            map: map,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputSelector: maskInputSelector,
            unmaskInputSelector: unmaskInputSelector,
            maskAllText: maskAllText,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $43b02a39892a2119$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($43b02a39892a2119$var$isElement(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $43b02a39892a2119$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                serializedChildNode.isShadow = true;
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $43b02a39892a2119$var$isShadowRoot(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $43b02a39892a2119$var$NodeType$1.Element && serializedNode.tagName === "iframe") $43b02a39892a2119$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $43b02a39892a2119$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                map: map,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputSelector: maskInputSelector,
                unmaskInputSelector: unmaskInputSelector,
                maskAllText: maskAllText,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    return serializedNode;
}
function $43b02a39892a2119$var$snapshot(n, options) {
    const { blockClass: blockClass = "rr-block" , blockSelector: blockSelector = null , unblockSelector: unblockSelector = null , maskTextClass: maskTextClass = "rr-mask" , maskTextSelector: maskTextSelector = null , unmaskTextSelector: unmaskTextSelector = null , inlineStylesheet: inlineStylesheet = true , inlineImages: inlineImages = false , recordCanvas: recordCanvas = false , maskInputSelector: maskInputSelector = null , unmaskInputSelector: unmaskInputSelector = null , maskAllText: maskAllText = false , maskAllInputs: maskAllInputs = false , maskTextFn: maskTextFn , maskInputFn: maskInputFn , slimDOM: slimDOM = false , dataURLOptions: dataURLOptions , preserveWhiteSpace: preserveWhiteSpace , onSerialize: onSerialize , onIframeLoad: onIframeLoad , iframeLoadTimeout: iframeLoadTimeout , keepIframeSrcFn: keepIframeSrcFn = ()=>false  } = options || {};
    const idNodeMap = {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return [
        $43b02a39892a2119$var$serializeNodeWithId(n, {
            doc: n,
            map: idNodeMap,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: false,
            inlineStylesheet: inlineStylesheet,
            maskInputSelector: maskInputSelector,
            unmaskInputSelector: unmaskInputSelector,
            maskAllText: maskAllText,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        }),
        idNodeMap
    ];
}
function $43b02a39892a2119$var$skipAttribute(tagName, attributeName, value) {
    return (tagName === "video" || tagName === "audio") && attributeName === "autoplay";
}
var $43b02a39892a2119$var$EventType$1;
(function(EventType) {
    EventType[EventType["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType[EventType["Load"] = 1] = "Load";
    EventType[EventType["FullSnapshot"] = 2] = "FullSnapshot";
    EventType[EventType["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType[EventType["Meta"] = 4] = "Meta";
    EventType[EventType["Custom"] = 5] = "Custom";
    EventType[EventType["Plugin"] = 6] = "Plugin";
})($43b02a39892a2119$var$EventType$1 || ($43b02a39892a2119$var$EventType$1 = {}));
var $43b02a39892a2119$var$IncrementalSource;
(function(IncrementalSource) {
    IncrementalSource[IncrementalSource["Mutation"] = 0] = "Mutation";
    IncrementalSource[IncrementalSource["MouseMove"] = 1] = "MouseMove";
    IncrementalSource[IncrementalSource["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource[IncrementalSource["Scroll"] = 3] = "Scroll";
    IncrementalSource[IncrementalSource["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource[IncrementalSource["Input"] = 5] = "Input";
    IncrementalSource[IncrementalSource["TouchMove"] = 6] = "TouchMove";
    IncrementalSource[IncrementalSource["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource[IncrementalSource["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource[IncrementalSource["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource[IncrementalSource["Font"] = 10] = "Font";
    IncrementalSource[IncrementalSource["Log"] = 11] = "Log";
    IncrementalSource[IncrementalSource["Drag"] = 12] = "Drag";
    IncrementalSource[IncrementalSource["StyleDeclaration"] = 13] = "StyleDeclaration";
})($43b02a39892a2119$var$IncrementalSource || ($43b02a39892a2119$var$IncrementalSource = {}));
var $43b02a39892a2119$var$MouseInteractions;
(function(MouseInteractions) {
    MouseInteractions[MouseInteractions["MouseUp"] = 0] = "MouseUp";
    MouseInteractions[MouseInteractions["MouseDown"] = 1] = "MouseDown";
    MouseInteractions[MouseInteractions["Click"] = 2] = "Click";
    MouseInteractions[MouseInteractions["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions[MouseInteractions["DblClick"] = 4] = "DblClick";
    MouseInteractions[MouseInteractions["Focus"] = 5] = "Focus";
    MouseInteractions[MouseInteractions["Blur"] = 6] = "Blur";
    MouseInteractions[MouseInteractions["TouchStart"] = 7] = "TouchStart";
    MouseInteractions[MouseInteractions["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions[MouseInteractions["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions[MouseInteractions["TouchCancel"] = 10] = "TouchCancel";
})($43b02a39892a2119$var$MouseInteractions || ($43b02a39892a2119$var$MouseInteractions = {}));
var $43b02a39892a2119$var$CanvasContext;
(function(CanvasContext) {
    CanvasContext[CanvasContext["2D"] = 0] = "2D";
    CanvasContext[CanvasContext["WebGL"] = 1] = "WebGL";
    CanvasContext[CanvasContext["WebGL2"] = 2] = "WebGL2";
})($43b02a39892a2119$var$CanvasContext || ($43b02a39892a2119$var$CanvasContext = {}));
var $43b02a39892a2119$var$MediaInteractions;
(function(MediaInteractions) {
    MediaInteractions[MediaInteractions["Play"] = 0] = "Play";
    MediaInteractions[MediaInteractions["Pause"] = 1] = "Pause";
    MediaInteractions[MediaInteractions["Seeked"] = 2] = "Seeked";
    MediaInteractions[MediaInteractions["VolumeChange"] = 3] = "VolumeChange";
})($43b02a39892a2119$var$MediaInteractions || ($43b02a39892a2119$var$MediaInteractions = {}));
var $43b02a39892a2119$var$ReplayerEvents;
(function(ReplayerEvents) {
    ReplayerEvents["Start"] = "start";
    ReplayerEvents["Pause"] = "pause";
    ReplayerEvents["Resume"] = "resume";
    ReplayerEvents["Resize"] = "resize";
    ReplayerEvents["Finish"] = "finish";
    ReplayerEvents["FullsnapshotRebuilded"] = "fullsnapshot-rebuilded";
    ReplayerEvents["LoadStylesheetStart"] = "load-stylesheet-start";
    ReplayerEvents["LoadStylesheetEnd"] = "load-stylesheet-end";
    ReplayerEvents["SkipStart"] = "skip-start";
    ReplayerEvents["SkipEnd"] = "skip-end";
    ReplayerEvents["MouseInteraction"] = "mouse-interaction";
    ReplayerEvents["EventCast"] = "event-cast";
    ReplayerEvents["CustomEvent"] = "custom-event";
    ReplayerEvents["Flush"] = "flush";
    ReplayerEvents["StateChange"] = "state-change";
    ReplayerEvents["PlayBack"] = "play-back";
})($43b02a39892a2119$var$ReplayerEvents || ($43b02a39892a2119$var$ReplayerEvents = {}));
function $43b02a39892a2119$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
function $43b02a39892a2119$var$createMirror() {
    return {
        map: {},
        getId (n) {
            if (!n || !n.__sn) return -1;
            return n.__sn.id;
        },
        getNode (id) {
            return this.map[id] || null;
        },
        removeNodeFromMap (n) {
            const id = n.__sn && n.__sn.id;
            delete this.map[id];
            if (n.childNodes) n.childNodes.forEach((child)=>this.removeNodeFromMap(child));
        },
        has (id) {
            return this.map.hasOwnProperty(id);
        },
        reset () {
            this.map = {};
        }
    };
}
const $43b02a39892a2119$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $43b02a39892a2119$var$_mirror = {
    map: {},
    getId () {
        console.error($43b02a39892a2119$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($43b02a39892a2119$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($43b02a39892a2119$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($43b02a39892a2119$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($43b02a39892a2119$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $43b02a39892a2119$var$_mirror = new Proxy($43b02a39892a2119$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($43b02a39892a2119$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $43b02a39892a2119$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(arg) {
        let now = Date.now();
        if (!previous && options.leading === false) previous = now;
        let remaining = wait - (now - previous);
        let context = this;
        let args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $43b02a39892a2119$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            setTimeout(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$43b02a39892a2119$var$hookSetter(target, key, original || {}, true);
}
function $43b02a39892a2119$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (_a) {
        return ()=>{};
    }
}
function $43b02a39892a2119$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $43b02a39892a2119$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $43b02a39892a2119$var$isBlocked(node, blockClass, blockSelector, unblockSelector) {
    if (!node) return false;
    if (node.nodeType === node.ELEMENT_NODE) {
        let needBlock = false;
        const needUnblock = unblockSelector && node.matches(unblockSelector);
        if (typeof blockClass === "string") {
            if (node.closest !== undefined) needBlock = !needUnblock && node.closest("." + blockClass) !== null;
            else needBlock = !needUnblock && node.classList.contains(blockClass);
        } else !needUnblock && node.classList.forEach((className)=>{
            if (blockClass.test(className)) needBlock = true;
        });
        if (!needBlock && blockSelector) needBlock = node.matches(blockSelector);
        return !needUnblock && needBlock || $43b02a39892a2119$var$isBlocked(node.parentNode, blockClass, blockSelector, unblockSelector);
    }
    if (node.nodeType === node.TEXT_NODE) return $43b02a39892a2119$var$isBlocked(node.parentNode, blockClass, blockSelector, unblockSelector);
    return $43b02a39892a2119$var$isBlocked(node.parentNode, blockClass, blockSelector, unblockSelector);
}
function $43b02a39892a2119$var$isIgnored(n) {
    if ("__sn" in n) return n.__sn.id === $43b02a39892a2119$var$IGNORED_NODE;
    return false;
}
function $43b02a39892a2119$var$isAncestorRemoved(target, mirror) {
    if ($43b02a39892a2119$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $43b02a39892a2119$var$isAncestorRemoved(target.parentNode, mirror);
}
function $43b02a39892a2119$var$isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $43b02a39892a2119$var$polyfill(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = function contains(node) {
        if (!(0 in arguments)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $43b02a39892a2119$var$isIframeINode(node) {
    if ("__sn" in node) return node.__sn.type === $43b02a39892a2119$var$NodeType$1.Element && node.__sn.tagName === "iframe";
    return false;
}
function $43b02a39892a2119$var$hasShadowRoot(n) {
    return Boolean(n === null || n === void 0 ? void 0 : n.shadowRoot);
}
function $43b02a39892a2119$var$isNodeInLinkedList(n) {
    return "__ln" in n;
}
class $43b02a39892a2119$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = (current === null || current === void 0 ? void 0 : current.next) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $43b02a39892a2119$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $43b02a39892a2119$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $43b02a39892a2119$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
function $43b02a39892a2119$var$isINode(n) {
    return "__sn" in n;
}
class $43b02a39892a2119$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addList = new $43b02a39892a2119$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $43b02a39892a2119$var$IGNORED_NODE;
                while(nextId === $43b02a39892a2119$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                var _a, _b, _c, _d, _e;
                const shadowHost = n.getRootNode ? (_a = n.getRootNode()) === null || _a === void 0 ? void 0 : _a.host : null;
                let rootShadowHost = shadowHost;
                while((_c = (_b = rootShadowHost === null || rootShadowHost === void 0 ? void 0 : rootShadowHost.getRootNode) === null || _b === void 0 ? void 0 : _b.call(rootShadowHost)) === null || _c === void 0 ? void 0 : _c.host)rootShadowHost = ((_e = (_d = rootShadowHost === null || rootShadowHost === void 0 ? void 0 : rootShadowHost.getRootNode) === null || _d === void 0 ? void 0 : _d.call(rootShadowHost)) === null || _e === void 0 ? void 0 : _e.host) || null;
                const notInDoc = !this.doc.contains(n) && (!rootShadowHost || !this.doc.contains(rootShadowHost));
                if (!n.parentNode || notInDoc) return;
                const parentId = $43b02a39892a2119$var$isShadowRoot(n.parentNode) ? this.mirror.getId(shadowHost) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                let sn = $43b02a39892a2119$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    map: this.mirror.map,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    maskInputSelector: this.maskInputSelector,
                    unmaskInputSelector: this.unmaskInputSelector,
                    skipChild: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskAllText: this.maskAllText,
                    maskInputOptions: this.maskInputOptions,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($43b02a39892a2119$var$isIframeINode(currentN)) this.iframeManager.addIframe(currentN);
                        if ($43b02a39892a2119$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, document);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    }
                });
                if (sn) adds.push({
                    parentId: parentId,
                    nextId: nextId,
                    node: sn
                });
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($43b02a39892a2119$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$43b02a39892a2119$var$isAncestorInSet(this.droppedSet, n) && !$43b02a39892a2119$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($43b02a39892a2119$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) for(let index = addList.length - 1; index >= 0; index--){
                    const _node = addList.get(index);
                    if (_node) {
                        const parentId = this.mirror.getId(_node.value.parentNode);
                        const nextId = getNextId(_node.value);
                        if (parentId !== -1 && nextId !== -1) {
                            node = _node;
                            break;
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>({
                        id: this.mirror.getId(attribute.node),
                        attributes: attribute.attributes
                    })).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($43b02a39892a2119$var$isIgnored(m.target)) return;
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$43b02a39892a2119$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector) && value !== m.oldValue) this.texts.push({
                            value: $43b02a39892a2119$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let value = target.getAttribute(m.attributeName);
                        if (m.attributeName === "value") value = $43b02a39892a2119$var$maskInputValue({
                            input: target,
                            maskInputSelector: this.maskInputSelector,
                            unmaskInputSelector: this.unmaskInputSelector,
                            maskInputOptions: this.maskInputOptions,
                            tagName: target.tagName,
                            type: target.getAttribute("type"),
                            value: value,
                            maskInputFn: this.maskInputFn
                        });
                        if ($43b02a39892a2119$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector) || value === m.oldValue) return;
                        let item = this.attributes.find((a)=>a.node === m.target);
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {}
                            };
                            this.attributes.push(item);
                        }
                        if (m.attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (m.attributeName === "style") {
                            const old = this.doc.createElement("span");
                            if (m.oldValue) old.setAttribute("style", m.oldValue);
                            if (item.attributes.style === undefined || item.attributes.style === null) item.attributes.style = {};
                            try {
                                const styleObj = item.attributes.style;
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === "") styleObj[pname] = newValue;
                                        else styleObj[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    }
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === "") styleObj[pname] = false;
                            } catch (error) {
                                console.warn("[rrweb] Error when parsing update to style attribute:", error);
                            }
                        } else {
                            const element = m.target;
                            item.attributes[m.attributeName] = $43b02a39892a2119$var$transformAttribute(this.doc, element, element.tagName, m.attributeName, value, this.maskAllText, this.unmaskTextSelector, this.maskTextFn);
                        }
                        break;
                    }
                case "childList":
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $43b02a39892a2119$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($43b02a39892a2119$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector) || $43b02a39892a2119$var$isIgnored(n)) return;
                        if (this.addedSet.has(n)) {
                            $43b02a39892a2119$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($43b02a39892a2119$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$43b02a39892a2119$var$moveKey(nodeId, parentId)]) $43b02a39892a2119$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $43b02a39892a2119$var$isShadowRoot(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (target && $43b02a39892a2119$var$isBlocked(target, this.blockClass, this.blockSelector, this.unblockSelector)) return;
            if ($43b02a39892a2119$var$isINode(n)) {
                if ($43b02a39892a2119$var$isIgnored(n)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && $43b02a39892a2119$var$isINode(target)) targetId = target.__sn.id;
                if (targetId) this.movedMap[$43b02a39892a2119$var$moveKey(n.__sn.id, targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$43b02a39892a2119$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector)) n.childNodes.forEach((childN)=>this.genAdds(childN));
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "maskInputSelector",
            "unmaskInputSelector",
            "inlineStylesheet",
            "maskAllText",
            "maskInputOptions",
            "maskTextFn",
            "maskInputFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "doc",
            "mirror",
            "iframeManager",
            "shadowDomManager",
            "canvasManager"
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $43b02a39892a2119$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$43b02a39892a2119$var$deepDelete(addsSet, childN));
}
function $43b02a39892a2119$var$isParentRemoved(removes, n, mirror) {
    const { parentNode: parentNode  } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return $43b02a39892a2119$var$isParentRemoved(removes, parentNode, mirror);
}
function $43b02a39892a2119$var$isAncestorInSet(set, n) {
    const { parentNode: parentNode  } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $43b02a39892a2119$var$isAncestorInSet(set, parentNode);
}
const $43b02a39892a2119$var$callbackWrapper = (cb)=>{
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            try {
                error.__rrweb__ = true;
            } catch (_a) {}
            throw error;
        }
    };
    return rrwebWrapped;
};
const $43b02a39892a2119$var$mutationBuffers = [];
function $43b02a39892a2119$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (_a) {}
    return event && event.target;
}
function $43b02a39892a2119$var$initMutationObserver(options, rootEl) {
    var _a, _b;
    const mutationBuffer = new $43b02a39892a2119$var$MutationBuffer();
    $43b02a39892a2119$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = (_b = (_a = window === null || window === void 0 ? void 0 : window.Zone) === null || _a === void 0 ? void 0 : _a.__symbol__) === null || _b === void 0 ? void 0 : _b.call(_a, "MutationObserver");
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($43b02a39892a2119$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $43b02a39892a2119$var$initMoveObserver({ mousemoveCb: mousemoveCb , sampling: sampling , doc: doc , mirror: mirror  }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $43b02a39892a2119$var$throttle$1((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        $43b02a39892a2119$var$callbackWrapper(mousemoveCb)(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }, callbackThreshold);
    const updatePosition = $43b02a39892a2119$var$throttle$1((evt)=>{
        const target = $43b02a39892a2119$var$getEventTarget(evt);
        const { clientX: clientX , clientY: clientY  } = $43b02a39892a2119$var$isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = Date.now();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: Date.now() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $43b02a39892a2119$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $43b02a39892a2119$var$IncrementalSource.MouseMove : $43b02a39892a2119$var$IncrementalSource.TouchMove);
    }, threshold, {
        trailing: false
    });
    const handlers = [
        $43b02a39892a2119$var$on("mousemove", $43b02a39892a2119$var$callbackWrapper(updatePosition), doc),
        $43b02a39892a2119$var$on("touchmove", $43b02a39892a2119$var$callbackWrapper(updatePosition), doc),
        $43b02a39892a2119$var$on("drag", $43b02a39892a2119$var$callbackWrapper(updatePosition), doc)
    ];
    return $43b02a39892a2119$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $43b02a39892a2119$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb , doc: doc , mirror: mirror , blockClass: blockClass , blockSelector: blockSelector , unblockSelector: unblockSelector , sampling: sampling  }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $43b02a39892a2119$var$getEventTarget(event);
            if ($43b02a39892a2119$var$isBlocked(target, blockClass, blockSelector, unblockSelector)) return;
            const e = $43b02a39892a2119$var$isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX , clientY: clientY  } = e;
            $43b02a39892a2119$var$callbackWrapper(mouseInteractionCb)({
                type: $43b02a39892a2119$var$MouseInteractions[eventKey],
                id: id,
                x: clientX,
                y: clientY
            });
        };
    };
    Object.keys($43b02a39892a2119$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        const eventName = eventKey.toLowerCase();
        const handler = $43b02a39892a2119$var$callbackWrapper(getHandler(eventKey));
        handlers.push($43b02a39892a2119$var$on(eventName, handler, doc));
    });
    return $43b02a39892a2119$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $43b02a39892a2119$var$initScrollObserver({ scrollCb: scrollCb , doc: doc , mirror: mirror , blockClass: blockClass , blockSelector: blockSelector , unblockSelector: unblockSelector , sampling: sampling  }) {
    const updatePosition = $43b02a39892a2119$var$throttle$1((evt)=>{
        const target = $43b02a39892a2119$var$getEventTarget(evt);
        if (!target || $43b02a39892a2119$var$isBlocked(target, blockClass, blockSelector, unblockSelector)) return;
        const id = mirror.getId(target);
        if (target === doc) {
            const scrollEl = doc.scrollingElement || doc.documentElement;
            $43b02a39892a2119$var$callbackWrapper(scrollCb)({
                id: id,
                x: scrollEl.scrollLeft,
                y: scrollEl.scrollTop
            });
        } else $43b02a39892a2119$var$callbackWrapper(scrollCb)({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }, sampling.scroll || 100);
    return $43b02a39892a2119$var$on("scroll", $43b02a39892a2119$var$callbackWrapper(updatePosition), doc);
}
function $43b02a39892a2119$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb  }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $43b02a39892a2119$var$throttle$1(()=>{
        const height = $43b02a39892a2119$var$getWindowHeight();
        const width = $43b02a39892a2119$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            $43b02a39892a2119$var$callbackWrapper(viewportResizeCb)({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }, 200);
    return $43b02a39892a2119$var$on("resize", $43b02a39892a2119$var$callbackWrapper(updateDimension), window);
}
function $43b02a39892a2119$var$wrapEventWithUserTriggeredFlag(v, enable) {
    const value = Object.assign({}, v);
    if (!enable) delete value.userTriggered;
    return value;
}
const $43b02a39892a2119$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $43b02a39892a2119$var$lastInputValueMap = new WeakMap();
function $43b02a39892a2119$var$initInputObserver({ inputCb: inputCb , doc: doc , mirror: mirror , blockClass: blockClass , blockSelector: blockSelector , unblockSelector: unblockSelector , ignoreClass: ignoreClass , ignoreSelector: ignoreSelector , maskInputSelector: maskInputSelector , unmaskInputSelector: unmaskInputSelector , maskInputOptions: maskInputOptions , maskInputFn: maskInputFn , sampling: sampling , userTriggeredOnInput: userTriggeredOnInput  }) {
    function eventHandler(event) {
        let target = $43b02a39892a2119$var$getEventTarget(event);
        const tagName = target && target.tagName;
        const userTriggered = event.isTrusted;
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $43b02a39892a2119$var$INPUT_TAGS.indexOf(tagName) < 0 || $43b02a39892a2119$var$isBlocked(target, blockClass, blockSelector, unblockSelector)) return;
        const el = target;
        const type = $43b02a39892a2119$var$getInputType(el);
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        let text = $43b02a39892a2119$var$getInputValue(el, tagName, type);
        let isChecked = false;
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        if ($43b02a39892a2119$var$hasInputMaskOptions({
            maskInputOptions: maskInputOptions,
            maskInputSelector: maskInputSelector,
            tagName: tagName,
            type: type
        })) text = $43b02a39892a2119$var$maskInputValue({
            input: el,
            maskInputOptions: maskInputOptions,
            maskInputSelector: maskInputSelector,
            unmaskInputSelector: unmaskInputSelector,
            tagName: tagName,
            type: type,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, $43b02a39892a2119$var$callbackWrapper($43b02a39892a2119$var$wrapEventWithUserTriggeredFlag)({
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        }, userTriggeredOnInput));
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $43b02a39892a2119$var$maskInputValue({
                    input: el,
                    maskInputOptions: maskInputOptions,
                    maskInputSelector: maskInputSelector,
                    unmaskInputSelector: unmaskInputSelector,
                    tagName: tagName,
                    type: type,
                    value: $43b02a39892a2119$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, $43b02a39892a2119$var$callbackWrapper($43b02a39892a2119$var$wrapEventWithUserTriggeredFlag)({
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                }, userTriggeredOnInput));
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $43b02a39892a2119$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $43b02a39892a2119$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            inputCb(Object.assign(Object.assign({}, v), {
                id: id
            }));
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$43b02a39892a2119$var$on(eventName, $43b02a39892a2119$var$callbackWrapper(eventHandler), doc));
    const propertyDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            HTMLInputElement.prototype,
            "value"
        ],
        [
            HTMLInputElement.prototype,
            "checked"
        ],
        [
            HTMLSelectElement.prototype,
            "value"
        ],
        [
            HTMLTextAreaElement.prototype,
            "value"
        ],
        [
            HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$43b02a39892a2119$var$hookSetter(p[0], p[1], {
            set () {
                $43b02a39892a2119$var$callbackWrapper(eventHandler)({
                    target: this
                });
            }
        })));
    return $43b02a39892a2119$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $43b02a39892a2119$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($43b02a39892a2119$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $43b02a39892a2119$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $43b02a39892a2119$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $43b02a39892a2119$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $43b02a39892a2119$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb , mirror: mirror  }, { win: win  }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $43b02a39892a2119$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const id = mirror.getId(thisArg.ownerNode);
            if (id !== -1) styleSheetRuleCb({
                id: id,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $43b02a39892a2119$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const id = mirror.getId(thisArg.ownerNode);
            if (id !== -1) styleSheetRuleCb({
                id: id,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const supportedNestedCSSRuleTypes = {};
    if ($43b02a39892a2119$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($43b02a39892a2119$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($43b02a39892a2119$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($43b02a39892a2119$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $43b02a39892a2119$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const id = mirror.getId(thisArg.parentStyleSheet.ownerNode);
                if (id !== -1) styleSheetRuleCb({
                    id: id,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$43b02a39892a2119$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $43b02a39892a2119$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const id = mirror.getId(thisArg.parentStyleSheet.ownerNode);
                if (id !== -1) styleSheetRuleCb({
                    id: id,
                    removes: [
                        {
                            index: [
                                ...$43b02a39892a2119$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $43b02a39892a2119$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $43b02a39892a2119$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb , mirror: mirror  }, { win: win  }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $43b02a39892a2119$var$callbackWrapper((target, thisArg, argumentsList)=>{
            var _a, _b;
            const [property, value, priority] = argumentsList;
            const id = mirror.getId((_b = (_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet) === null || _b === void 0 ? void 0 : _b.ownerNode);
            if (id !== -1) styleDeclarationCb({
                id: id,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $43b02a39892a2119$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $43b02a39892a2119$var$callbackWrapper((target, thisArg, argumentsList)=>{
            var _a, _b;
            const [property] = argumentsList;
            const id = mirror.getId((_b = (_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet) === null || _b === void 0 ? void 0 : _b.ownerNode);
            if (id !== -1) styleDeclarationCb({
                id: id,
                remove: {
                    property: property
                },
                index: $43b02a39892a2119$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $43b02a39892a2119$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $43b02a39892a2119$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb , blockClass: blockClass , blockSelector: blockSelector , unblockSelector: unblockSelector , mirror: mirror , sampling: sampling  }) {
    const handler = (type)=>$43b02a39892a2119$var$throttle$1($43b02a39892a2119$var$callbackWrapper((event)=>{
            const target = $43b02a39892a2119$var$getEventTarget(event);
            if (!target || $43b02a39892a2119$var$isBlocked(target, blockClass, blockSelector, unblockSelector)) return;
            const { currentTime: currentTime , volume: volume , muted: muted  } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted
            });
        }), sampling.media || 500);
    const handlers = [
        $43b02a39892a2119$var$on("play", handler(0)),
        $43b02a39892a2119$var$on("pause", handler(1)),
        $43b02a39892a2119$var$on("seeked", handler(2)),
        $43b02a39892a2119$var$on("volumechange", handler(3))
    ];
    return $43b02a39892a2119$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $43b02a39892a2119$var$initFontObserver({ fontCb: fontCb , doc: doc  }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $43b02a39892a2119$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            setTimeout(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }, 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $43b02a39892a2119$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $43b02a39892a2119$var$mergeHooks(o, hooks) {
    const { mutationCb: mutationCb , mousemoveCb: mousemoveCb , mouseInteractionCb: mouseInteractionCb , scrollCb: scrollCb , viewportResizeCb: viewportResizeCb , inputCb: inputCb , mediaInteractionCb: mediaInteractionCb , styleSheetRuleCb: styleSheetRuleCb , styleDeclarationCb: styleDeclarationCb , canvasMutationCb: canvasMutationCb , fontCb: fontCb  } = o;
    o.mutationCb = (...p)=>{
        if (hooks.mutation) hooks.mutation(...p);
        mutationCb(...p);
    };
    o.mousemoveCb = (...p)=>{
        if (hooks.mousemove) hooks.mousemove(...p);
        mousemoveCb(...p);
    };
    o.mouseInteractionCb = (...p)=>{
        if (hooks.mouseInteraction) hooks.mouseInteraction(...p);
        mouseInteractionCb(...p);
    };
    o.scrollCb = (...p)=>{
        if (hooks.scroll) hooks.scroll(...p);
        scrollCb(...p);
    };
    o.viewportResizeCb = (...p)=>{
        if (hooks.viewportResize) hooks.viewportResize(...p);
        viewportResizeCb(...p);
    };
    o.inputCb = (...p)=>{
        if (hooks.input) hooks.input(...p);
        inputCb(...p);
    };
    o.mediaInteractionCb = (...p)=>{
        if (hooks.mediaInteaction) hooks.mediaInteaction(...p);
        mediaInteractionCb(...p);
    };
    o.styleSheetRuleCb = (...p)=>{
        if (hooks.styleSheetRule) hooks.styleSheetRule(...p);
        styleSheetRuleCb(...p);
    };
    o.styleDeclarationCb = (...p)=>{
        if (hooks.styleDeclaration) hooks.styleDeclaration(...p);
        styleDeclarationCb(...p);
    };
    o.canvasMutationCb = (...p)=>{
        if (hooks.canvasMutation) hooks.canvasMutation(...p);
        canvasMutationCb(...p);
    };
    o.fontCb = (...p)=>{
        if (hooks.font) hooks.font(...p);
        fontCb(...p);
    };
}
function $43b02a39892a2119$var$initObservers(o, hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    $43b02a39892a2119$var$mergeHooks(o, hooks);
    const mutationObserver = $43b02a39892a2119$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $43b02a39892a2119$var$initMoveObserver(o);
    const mouseInteractionHandler = $43b02a39892a2119$var$initMouseInteractionObserver(o);
    const scrollHandler = $43b02a39892a2119$var$initScrollObserver(o);
    const viewportResizeHandler = $43b02a39892a2119$var$initViewportResizeObserver(o);
    const inputHandler = $43b02a39892a2119$var$initInputObserver(o);
    const mediaInteractionHandler = $43b02a39892a2119$var$initMediaInteractionObserver(o);
    const styleSheetObserver = $43b02a39892a2119$var$initStyleSheetObserver(o, {
        win: currentWindow
    });
    const styleDeclarationObserver = $43b02a39892a2119$var$initStyleDeclarationObserver(o, {
        win: currentWindow
    });
    const fontObserver = o.collectFonts ? $43b02a39892a2119$var$initFontObserver(o) : ()=>{};
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $43b02a39892a2119$var$callbackWrapper(()=>{
        $43b02a39892a2119$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        try {
            styleSheetObserver();
            styleDeclarationObserver();
        } catch (e) {}
        fontObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $43b02a39892a2119$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $43b02a39892a2119$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $43b02a39892a2119$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.mutationCb = options.mutationCb;
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        var _a;
        this.mutationCb({
            adds: [
                {
                    parentId: iframeEl.__sn.id,
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        (_a = this.loadListener) === null || _a === void 0 || _a.call(this, iframeEl);
    }
}
class $43b02a39892a2119$var$ShadowDomManager {
    constructor(options){
        this.restorePatches = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        const manager = this;
        this.restorePatches.push($43b02a39892a2119$var$patch(HTMLElement.prototype, "attachShadow", function(original) {
            return function() {
                const shadowRoot = original.apply(this, arguments);
                if (this.shadowRoot) manager.addShadowRoot(this.shadowRoot, this.ownerDocument);
                return shadowRoot;
            };
        }));
    }
    addShadowRoot(shadowRoot, doc) {
        $43b02a39892a2119$var$initMutationObserver(Object.assign(Object.assign({}, this.bypassOptions), {
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }), shadowRoot);
        $43b02a39892a2119$var$initScrollObserver(Object.assign(Object.assign({}, this.bypassOptions), {
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
    }
    observeAttachShadow(iframeElement) {
        if (iframeElement.contentWindow) {
            const manager = this;
            this.restorePatches.push($43b02a39892a2119$var$patch(iframeElement.contentWindow.HTMLElement.prototype, "attachShadow", function(original) {
                return function() {
                    const shadowRoot = original.apply(this, arguments);
                    if (this.shadowRoot) manager.addShadowRoot(this.shadowRoot, iframeElement.contentDocument);
                    return shadowRoot;
                };
            }));
        }
    }
    reset() {
        this.restorePatches.forEach((restorePatch)=>restorePatch());
    }
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $43b02a39892a2119$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $43b02a39892a2119$var$initCanvas2DMutationObserver(cb, win, blockClass, unblockSelector, blockSelector, mirror) {
    const handlers = [];
    const props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for (const prop of props2D)try {
        if (typeof win.CanvasRenderingContext2D.prototype[prop] !== "function") continue;
        const restoreHandler = $43b02a39892a2119$var$patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
            return function(...args) {
                if (!$43b02a39892a2119$var$isBlocked(this.canvas, blockClass, blockSelector, unblockSelector)) setTimeout(()=>{
                    const recordArgs = [
                        ...args
                    ];
                    if (prop === "drawImage") {
                        if (recordArgs[0] && recordArgs[0] instanceof HTMLCanvasElement) {
                            const canvas = recordArgs[0];
                            const ctx = canvas.getContext("2d");
                            let imgd = ctx === null || ctx === void 0 ? void 0 : ctx.getImageData(0, 0, canvas.width, canvas.height);
                            let pix = imgd === null || imgd === void 0 ? void 0 : imgd.data;
                            recordArgs[0] = JSON.stringify(pix);
                        }
                    }
                    cb(this.canvas, {
                        type: $43b02a39892a2119$var$CanvasContext["2D"],
                        property: prop,
                        args: recordArgs
                    });
                }, 0);
                return original.apply(this, args);
            };
        });
        handlers.push(restoreHandler);
    } catch (_a) {
        const hookHandler = $43b02a39892a2119$var$hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
            set (v) {
                cb(this.canvas, {
                    type: $43b02a39892a2119$var$CanvasContext["2D"],
                    property: prop,
                    args: [
                        v
                    ],
                    setter: true
                });
            }
        });
        handlers.push(hookHandler);
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $43b02a39892a2119$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector) {
    const handlers = [];
    try {
        const restoreHandler = $43b02a39892a2119$var$patch(win.HTMLCanvasElement.prototype, "getContext", function(original) {
            return function(contextType, ...args) {
                if (!$43b02a39892a2119$var$isBlocked(this, blockClass, blockSelector, unblockSelector)) {
                    if (!("__context" in this)) this.__context = contextType;
                }
                return original.apply(this, [
                    contextType,
                    ...args
                ]);
            };
        });
        handlers.push(restoreHandler);
    } catch (_a) {
        console.error("failed to patch HTMLCanvasElement.prototype.getContext");
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
/*
 * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ var $43b02a39892a2119$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
var $43b02a39892a2119$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $43b02a39892a2119$var$i = 0; $43b02a39892a2119$var$i < $43b02a39892a2119$var$chars.length; $43b02a39892a2119$var$i++)$43b02a39892a2119$var$lookup[$43b02a39892a2119$var$chars.charCodeAt($43b02a39892a2119$var$i)] = $43b02a39892a2119$var$i;
var $43b02a39892a2119$var$encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
    for(i = 0; i < len; i += 3){
        base64 += $43b02a39892a2119$var$chars[bytes[i] >> 2];
        base64 += $43b02a39892a2119$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $43b02a39892a2119$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $43b02a39892a2119$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
const $43b02a39892a2119$var$webGLVarMap = new Map();
function $43b02a39892a2119$var$variableListFor(ctx, ctor) {
    let contextMap = $43b02a39892a2119$var$webGLVarMap.get(ctx);
    if (!contextMap) {
        contextMap = new Map();
        $43b02a39892a2119$var$webGLVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
const $43b02a39892a2119$var$saveWebGLVar = (value, win, ctx)=>{
    if (!value || !($43b02a39892a2119$var$isInstanceOfWebGLObject(value, win) || typeof value === "object")) return;
    const name = value.constructor.name;
    const list = $43b02a39892a2119$var$variableListFor(ctx, name);
    let index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function $43b02a39892a2119$var$serializeArg(value, win, ctx) {
    if (value instanceof Array) return value.map((arg)=>$43b02a39892a2119$var$serializeArg(arg, win, ctx));
    else if (value === null) return value;
    else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (value instanceof ArrayBuffer) {
        const name = value.constructor.name;
        const base64 = $43b02a39892a2119$var$encode(value);
        return {
            rr_type: name,
            base64: base64
        };
    } else if (value instanceof DataView) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $43b02a39892a2119$var$serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if (value instanceof HTMLImageElement) {
        const name = value.constructor.name;
        const { src: src  } = value;
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof ImageData) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $43b02a39892a2119$var$serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if ($43b02a39892a2119$var$isInstanceOfWebGLObject(value, win) || typeof value === "object") {
        const name = value.constructor.name;
        const index = $43b02a39892a2119$var$saveWebGLVar(value, win, ctx);
        return {
            rr_type: name,
            index: index
        };
    }
    return value;
}
const $43b02a39892a2119$var$serializeArgs = (args, win, ctx)=>{
    return [
        ...args
    ].map((arg)=>$43b02a39892a2119$var$serializeArg(arg, win, ctx));
};
const $43b02a39892a2119$var$isInstanceOfWebGLObject = (value, win)=>{
    const webGLConstructorNames = [
        "WebGLActiveInfo",
        "WebGLBuffer",
        "WebGLFramebuffer",
        "WebGLProgram",
        "WebGLRenderbuffer",
        "WebGLShader",
        "WebGLShaderPrecisionFormat",
        "WebGLTexture",
        "WebGLUniformLocation",
        "WebGLVertexArrayObject",
        "WebGLVertexArrayObjectOES"
    ];
    const supportedWebGLConstructorNames = webGLConstructorNames.filter((name)=>typeof win[name] === "function");
    return Boolean(supportedWebGLConstructorNames.find((name)=>value instanceof win[name]));
};
function $43b02a39892a2119$var$patchGLPrototype(prototype, type, cb, blockClass, unblockSelector, blockSelector, mirror, win) {
    const handlers = [];
    const props = Object.getOwnPropertyNames(prototype);
    for (const prop of props)try {
        if (typeof prototype[prop] !== "function") continue;
        const restoreHandler = $43b02a39892a2119$var$patch(prototype, prop, function(original) {
            return function(...args) {
                const result = original.apply(this, args);
                $43b02a39892a2119$var$saveWebGLVar(result, win, prototype);
                if (!$43b02a39892a2119$var$isBlocked(this.canvas, blockClass, blockSelector, unblockSelector)) {
                    const id = mirror.getId(this.canvas);
                    const recordArgs = $43b02a39892a2119$var$serializeArgs([
                        ...args
                    ], win, prototype);
                    const mutation = {
                        type: type,
                        property: prop,
                        args: recordArgs
                    };
                    cb(this.canvas, mutation);
                }
                return result;
            };
        });
        handlers.push(restoreHandler);
    } catch (_a) {
        const hookHandler = $43b02a39892a2119$var$hookSetter(prototype, prop, {
            set (v) {
                cb(this.canvas, {
                    type: type,
                    property: prop,
                    args: [
                        v
                    ],
                    setter: true
                });
            }
        });
        handlers.push(hookHandler);
    }
    return handlers;
}
function $43b02a39892a2119$var$initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector, unblockSelector, mirror) {
    const handlers = [];
    handlers.push(...$43b02a39892a2119$var$patchGLPrototype(win.WebGLRenderingContext.prototype, $43b02a39892a2119$var$CanvasContext.WebGL, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    if (typeof win.WebGL2RenderingContext !== "undefined") handlers.push(...$43b02a39892a2119$var$patchGLPrototype(win.WebGL2RenderingContext.prototype, $43b02a39892a2119$var$CanvasContext.WebGL2, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
class $43b02a39892a2119$var$CanvasManager {
    reset() {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    }
    freeze() {
        this.frozen = true;
    }
    unfreeze() {
        this.frozen = false;
    }
    lock() {
        this.locked = true;
    }
    unlock() {
        this.locked = false;
    }
    constructor(options){
        this.pendingCanvasMutations = new Map();
        this.rafStamps = {
            latestId: 0,
            invokeId: null
        };
        this.frozen = false;
        this.locked = false;
        this.processMutation = function(target, mutation) {
            const newFrame = this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId;
            if (newFrame || !this.rafStamps.invokeId) this.rafStamps.invokeId = this.rafStamps.latestId;
            if (!this.pendingCanvasMutations.has(target)) this.pendingCanvasMutations.set(target, []);
            this.pendingCanvasMutations.get(target).push(mutation);
        };
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        if (options.recordCanvas === true) this.initCanvasMutationObserver(options.win, options.blockClass, options.blockSelector, options.unblockSelector);
    }
    initCanvasMutationObserver(win, blockClass, unblockSelector, blockSelector) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        const canvasContextReset = $43b02a39892a2119$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector);
        const canvas2DReset = $43b02a39892a2119$var$initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
        const canvasWebGL1and2Reset = $43b02a39892a2119$var$initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
        this.resetObservers = ()=>{
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    }
    startPendingCanvasMutationFlusher() {
        requestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    startRAFTimestamping() {
        const setLatestRAFTimestamp = (timestamp)=>{
            this.rafStamps.latestId = timestamp;
            requestAnimationFrame(setLatestRAFTimestamp);
        };
        requestAnimationFrame(setLatestRAFTimestamp);
    }
    flushPendingCanvasMutations() {
        this.pendingCanvasMutations.forEach((values, canvas)=>{
            const id = this.mirror.getId(canvas);
            this.flushPendingCanvasMutationFor(canvas, id);
        });
        requestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) return;
        const valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        const values = valuesWithType.map((value)=>{
            const rest = $43b02a39892a2119$var$__rest(value, [
                "type"
            ]);
            return rest;
        });
        const { type: type  } = valuesWithType[0];
        this.mutationCb({
            id: id,
            type: type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    }
}
function $43b02a39892a2119$var$wrapEvent(e) {
    return Object.assign(Object.assign({}, e), {
        timestamp: Date.now()
    });
}
let $43b02a39892a2119$var$wrappedEmit;
let $43b02a39892a2119$var$takeFullSnapshot;
const $43b02a39892a2119$var$mirror = $43b02a39892a2119$var$createMirror();
function $43b02a39892a2119$var$record(options = {}) {
    const { emit: emit , checkoutEveryNms: checkoutEveryNms , checkoutEveryNth: checkoutEveryNth , blockClass: blockClass = "rr-block" , blockSelector: blockSelector = null , unblockSelector: unblockSelector = null , ignoreClass: ignoreClass = "rr-ignore" , ignoreSelector: ignoreSelector = null , maskTextClass: maskTextClass = "rr-mask" , maskTextSelector: maskTextSelector = null , maskInputSelector: maskInputSelector = null , unmaskTextSelector: unmaskTextSelector = null , unmaskInputSelector: unmaskInputSelector = null , inlineStylesheet: inlineStylesheet = true , maskAllText: maskAllText = false , maskAllInputs: maskAllInputs , maskInputOptions: _maskInputOptions , slimDOMOptions: _slimDOMOptions , maskInputFn: maskInputFn , maskTextFn: maskTextFn , hooks: hooks , packFn: packFn , sampling: sampling = {} , mousemoveWait: mousemoveWait , recordCanvas: recordCanvas = false , userTriggeredOnInput: userTriggeredOnInput = false , collectFonts: collectFonts = false , inlineImages: inlineImages = false , plugins: plugins , keepIframeSrcFn: keepIframeSrcFn = ()=>false , onMutation: onMutation  } = options;
    if (!emit) throw new Error("emit function is required");
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $43b02a39892a2119$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn) e = packFn(e);
        return e;
    };
    $43b02a39892a2119$var$wrappedEmit = (e, isCheckout)=>{
        var _a;
        if (((_a = $43b02a39892a2119$var$mutationBuffers[0]) === null || _a === void 0 ? void 0 : _a.isFrozen()) && e.type !== $43b02a39892a2119$var$EventType$1.FullSnapshot && !(e.type === $43b02a39892a2119$var$EventType$1.IncrementalSnapshot && e.data.source === $43b02a39892a2119$var$IncrementalSource.Mutation)) $43b02a39892a2119$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        emit(eventProcessor(e), isCheckout);
        if (e.type === $43b02a39892a2119$var$EventType$1.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $43b02a39892a2119$var$EventType$1.IncrementalSnapshot) {
            if (e.data.source === $43b02a39892a2119$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) $43b02a39892a2119$var$takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $43b02a39892a2119$var$wrappedEmit($43b02a39892a2119$var$wrapEvent({
            type: $43b02a39892a2119$var$EventType$1.IncrementalSnapshot,
            data: Object.assign({
                source: $43b02a39892a2119$var$IncrementalSource.Mutation
            }, m)
        }));
    };
    const wrappedScrollEmit = (p)=>$43b02a39892a2119$var$wrappedEmit($43b02a39892a2119$var$wrapEvent({
            type: $43b02a39892a2119$var$EventType$1.IncrementalSnapshot,
            data: Object.assign({
                source: $43b02a39892a2119$var$IncrementalSource.Scroll
            }, p)
        }));
    const wrappedCanvasMutationEmit = (p)=>$43b02a39892a2119$var$wrappedEmit($43b02a39892a2119$var$wrapEvent({
            type: $43b02a39892a2119$var$EventType$1.IncrementalSnapshot,
            data: Object.assign({
                source: $43b02a39892a2119$var$IncrementalSource.CanvasMutation
            }, p)
        }));
    const iframeManager = new $43b02a39892a2119$var$IframeManager({
        mutationCb: wrappedMutationEmit
    });
    const canvasManager = new $43b02a39892a2119$var$CanvasManager({
        recordCanvas: recordCanvas,
        mutationCb: wrappedCanvasMutationEmit,
        win: window,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        mirror: $43b02a39892a2119$var$mirror
    });
    const shadowDomManager = new $43b02a39892a2119$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            maskInputSelector: maskInputSelector,
            unmaskInputSelector: unmaskInputSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllText: maskAllText,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            canvasManager: canvasManager
        },
        mirror: $43b02a39892a2119$var$mirror
    });
    $43b02a39892a2119$var$takeFullSnapshot = (isCheckout = false)=>{
        var _a, _b, _c, _d;
        $43b02a39892a2119$var$wrappedEmit($43b02a39892a2119$var$wrapEvent({
            type: $43b02a39892a2119$var$EventType$1.Meta,
            data: {
                href: window.location.href,
                width: $43b02a39892a2119$var$getWindowWidth(),
                height: $43b02a39892a2119$var$getWindowHeight()
            }
        }), isCheckout);
        $43b02a39892a2119$var$mutationBuffers.forEach((buf)=>buf.lock());
        const [node, idNodeMap] = $43b02a39892a2119$var$snapshot(document, {
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            maskInputSelector: maskInputSelector,
            unmaskInputSelector: unmaskInputSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllText: maskAllText,
            maskAllInputs: maskInputOptions,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($43b02a39892a2119$var$isIframeINode(n)) iframeManager.addIframe(n);
                if ($43b02a39892a2119$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn("Failed to snapshot the document");
        $43b02a39892a2119$var$mirror.map = idNodeMap;
        $43b02a39892a2119$var$wrappedEmit($43b02a39892a2119$var$wrapEvent({
            type: $43b02a39892a2119$var$EventType$1.FullSnapshot,
            data: {
                node: node,
                initialOffset: {
                    left: window.pageXOffset !== undefined ? window.pageXOffset : (document === null || document === void 0 ? void 0 : document.documentElement.scrollLeft) || ((_b = (_a = document === null || document === void 0 ? void 0 : document.body) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.scrollLeft) || (document === null || document === void 0 ? void 0 : document.body.scrollLeft) || 0,
                    top: window.pageYOffset !== undefined ? window.pageYOffset : (document === null || document === void 0 ? void 0 : document.documentElement.scrollTop) || ((_d = (_c = document === null || document === void 0 ? void 0 : document.body) === null || _c === void 0 ? void 0 : _c.parentElement) === null || _d === void 0 ? void 0 : _d.scrollTop) || (document === null || document === void 0 ? void 0 : document.body.scrollTop) || 0
                }
            }
        }));
        $43b02a39892a2119$var$mutationBuffers.forEach((buf)=>buf.unlock());
    };
    try {
        const handlers = [];
        handlers.push($43b02a39892a2119$var$on("DOMContentLoaded", ()=>{
            $43b02a39892a2119$var$wrappedEmit($43b02a39892a2119$var$wrapEvent({
                type: $43b02a39892a2119$var$EventType$1.DomContentLoaded,
                data: {}
            }));
        }));
        const observe = (doc)=>{
            var _a;
            return $43b02a39892a2119$var$callbackWrapper($43b02a39892a2119$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$43b02a39892a2119$var$wrappedEmit($43b02a39892a2119$var$wrapEvent({
                        type: $43b02a39892a2119$var$EventType$1.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    })),
                mouseInteractionCb: (d)=>$43b02a39892a2119$var$wrappedEmit($43b02a39892a2119$var$wrapEvent({
                        type: $43b02a39892a2119$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $43b02a39892a2119$var$IncrementalSource.MouseInteraction
                        }, d)
                    })),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$43b02a39892a2119$var$wrappedEmit($43b02a39892a2119$var$wrapEvent({
                        type: $43b02a39892a2119$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $43b02a39892a2119$var$IncrementalSource.ViewportResize
                        }, d)
                    })),
                inputCb: (v)=>$43b02a39892a2119$var$wrappedEmit($43b02a39892a2119$var$wrapEvent({
                        type: $43b02a39892a2119$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $43b02a39892a2119$var$IncrementalSource.Input
                        }, v)
                    })),
                mediaInteractionCb: (p)=>$43b02a39892a2119$var$wrappedEmit($43b02a39892a2119$var$wrapEvent({
                        type: $43b02a39892a2119$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $43b02a39892a2119$var$IncrementalSource.MediaInteraction
                        }, p)
                    })),
                styleSheetRuleCb: (r)=>$43b02a39892a2119$var$wrappedEmit($43b02a39892a2119$var$wrapEvent({
                        type: $43b02a39892a2119$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $43b02a39892a2119$var$IncrementalSource.StyleSheetRule
                        }, r)
                    })),
                styleDeclarationCb: (r)=>$43b02a39892a2119$var$wrappedEmit($43b02a39892a2119$var$wrapEvent({
                        type: $43b02a39892a2119$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $43b02a39892a2119$var$IncrementalSource.StyleDeclaration
                        }, r)
                    })),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$43b02a39892a2119$var$wrappedEmit($43b02a39892a2119$var$wrapEvent({
                        type: $43b02a39892a2119$var$EventType$1.IncrementalSnapshot,
                        data: Object.assign({
                            source: $43b02a39892a2119$var$IncrementalSource.Font
                        }, p)
                    })),
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputSelector: maskInputSelector,
                unmaskInputSelector: unmaskInputSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAllText: maskAllText,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                mirror: $43b02a39892a2119$var$mirror,
                iframeManager: iframeManager,
                shadowDomManager: shadowDomManager,
                canvasManager: canvasManager,
                plugins: ((_a = plugins === null || plugins === void 0 ? void 0 : plugins.filter((p)=>p.observer)) === null || _a === void 0 ? void 0 : _a.map((p)=>({
                        observer: p.observer,
                        options: p.options,
                        callback: (payload)=>$43b02a39892a2119$var$wrappedEmit($43b02a39892a2119$var$wrapEvent({
                                type: $43b02a39892a2119$var$EventType$1.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            }))
                    }))) || []
            }, hooks);
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            $43b02a39892a2119$var$takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else handlers.push($43b02a39892a2119$var$on("load", ()=>{
            $43b02a39892a2119$var$wrappedEmit($43b02a39892a2119$var$wrapEvent({
                type: $43b02a39892a2119$var$EventType$1.Load,
                data: {}
            }));
            init();
        }, window));
        return ()=>{
            handlers.forEach((h)=>h());
        };
    } catch (error) {
        console.warn(error);
    }
}
$43b02a39892a2119$var$record.addCustomEvent = (tag, payload)=>{
    if (!$43b02a39892a2119$var$wrappedEmit) throw new Error("please add custom event after start recording");
    $43b02a39892a2119$var$wrappedEmit($43b02a39892a2119$var$wrapEvent({
        type: $43b02a39892a2119$var$EventType$1.Custom,
        data: {
            tag: tag,
            payload: payload
        }
    }));
};
$43b02a39892a2119$var$record.freezePage = ()=>{
    $43b02a39892a2119$var$mutationBuffers.forEach((buf)=>buf.freeze());
};
$43b02a39892a2119$var$record.takeFullSnapshot = (isCheckout)=>{
    if (!$43b02a39892a2119$var$takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $43b02a39892a2119$var$takeFullSnapshot(isCheckout);
};
$43b02a39892a2119$var$record.mirror = $43b02a39892a2119$var$mirror;
/**
 * Create a breadcrumb for a replay.
 */ function $43b02a39892a2119$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: "default",
        ...breadcrumb
    };
}
var $43b02a39892a2119$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($43b02a39892a2119$var$NodeType || ($43b02a39892a2119$var$NodeType = {}));
/**
 * Add a breadcrumb event to replay.
 */ function $43b02a39892a2119$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === "sentry.transaction") return;
    if ([
        "ui.click",
        "ui.input"
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        replay.throttledAddEvent({
            type: $43b02a39892a2119$var$EventType$1.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: "breadcrumb",
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $fa9ac95e0af8817a$export$a3295358bff77e)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === "console";
    });
}
/**
 * Detect a slow click on a button/a tag,
 * and potentially create a corresponding breadcrumb.
 */ function $43b02a39892a2119$var$detectSlowClick(replay, config, clickBreadcrumb, node) {
    if ($43b02a39892a2119$var$ignoreElement(node, config)) return;
    /*
    We consider a slow click a click on a button/a, which does not trigger one of:
     - DOM mutation
     - Scroll (within 100ms)
     Within the given threshold time.
     After time timeout time, we stop listening and mark it as a slow click anyhow.
  */ let cleanup = ()=>{
    // replaced further down
    };
    // After timeout time, def. consider this a slow click, and stop watching for mutations
    const timeout = setTimeout(()=>{
        $43b02a39892a2119$var$handleSlowClick(replay, clickBreadcrumb, config.timeout, "timeout");
        cleanup();
    }, config.timeout);
    const mutationHandler = ()=>{
        $43b02a39892a2119$var$maybeHandleSlowClick(replay, clickBreadcrumb, config.threshold, config.timeout, "mutation");
        cleanup();
    };
    const scrollHandler = ()=>{
        $43b02a39892a2119$var$maybeHandleSlowClick(replay, clickBreadcrumb, config.scrollTimeout, config.timeout, "scroll");
        cleanup();
    };
    const obs = new MutationObserver(mutationHandler);
    obs.observe($43b02a39892a2119$var$WINDOW.document.documentElement, {
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true
    });
    $43b02a39892a2119$var$WINDOW.addEventListener("scroll", scrollHandler);
    // Stop listening to scroll timeouts early
    const scrollTimeout = setTimeout(()=>{
        $43b02a39892a2119$var$WINDOW.removeEventListener("scroll", scrollHandler);
    }, config.scrollTimeout);
    cleanup = ()=>{
        clearTimeout(timeout);
        clearTimeout(scrollTimeout);
        obs.disconnect();
        $43b02a39892a2119$var$WINDOW.removeEventListener("scroll", scrollHandler);
    };
}
function $43b02a39892a2119$var$maybeHandleSlowClick(replay, clickBreadcrumb, threshold, timeout, endReason) {
    const now = Date.now();
    const timeAfterClickMs = now - clickBreadcrumb.timestamp * 1000;
    if (timeAfterClickMs > threshold) {
        $43b02a39892a2119$var$handleSlowClick(replay, clickBreadcrumb, Math.min(timeAfterClickMs, timeout), endReason);
        return true;
    }
    return false;
}
function $43b02a39892a2119$var$handleSlowClick(replay, clickBreadcrumb, timeAfterClickMs, endReason) {
    const breadcrumb = {
        message: clickBreadcrumb.message,
        timestamp: clickBreadcrumb.timestamp,
        category: "ui.slowClickDetected",
        data: {
            ...clickBreadcrumb.data,
            url: $43b02a39892a2119$var$WINDOW.location.href,
            timeAfterClickMs: // TODO FN: add parametrized route, when possible
            timeAfterClickMs,
            endReason: endReason
        }
    };
    $43b02a39892a2119$var$addBreadcrumbEvent(replay, breadcrumb);
}
const $43b02a39892a2119$var$SLOW_CLICK_IGNORE_TAGS = [
    "SELECT",
    "OPTION"
];
function $43b02a39892a2119$var$ignoreElement(node, config) {
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === "INPUT" && ![
        "submit",
        "button"
    ].includes(node.getAttribute("type") || "")) return true;
    if ($43b02a39892a2119$var$SLOW_CLICK_IGNORE_TAGS.includes(node.tagName)) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) return true;
    if (config.ignoreSelector && node.matches(config.ignoreSelector)) return true;
    return false;
}
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $43b02a39892a2119$var$ATTRIBUTES_TO_RECORD = new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid"
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $43b02a39892a2119$var$getAttributesToRecord(attributes) {
    const obj = {};
    for(const key in attributes)if ($43b02a39892a2119$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === "data-testid" || key === "data-test-id") normalizedKey = "testId";
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $43b02a39892a2119$var$handleDomListener = (replay)=>{
    const slowClickExperiment = replay.getOptions()._experiments.slowClicks;
    const slowClickConfig = slowClickExperiment ? {
        threshold: slowClickExperiment.threshold,
        timeout: slowClickExperiment.timeout,
        scrollTimeout: slowClickExperiment.scrollTimeout,
        ignoreSelector: slowClickExperiment.ignoreSelectors ? slowClickExperiment.ignoreSelectors.join(",") : ""
    } : undefined;
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $43b02a39892a2119$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === "click";
        const event = isClick && handlerData.event;
        // Ignore clicks if ctrl/alt/meta keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && slowClickConfig && event && !event.altKey && !event.metaKey && !event.ctrlKey) $43b02a39892a2119$var$detectSlowClick(replay, slowClickConfig, result, $43b02a39892a2119$var$getClickTargetNode(handlerData.event));
        $43b02a39892a2119$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $43b02a39892a2119$var$getBaseDomBreadcrumb(target, message) {
    // `__sn` property is the serialized node created by rrweb
    const serializedNode = target && $43b02a39892a2119$var$isRrwebNode(target) && target.__sn.type === $43b02a39892a2119$var$NodeType.Element ? target.__sn : null;
    return {
        message: message,
        data: serializedNode ? {
            nodeId: serializedNode.id,
            node: {
                id: serializedNode.id,
                tagName: serializedNode.tagName,
                textContent: target ? Array.from(target.childNodes).map((node)=>"__sn" in node && node.__sn.type === $43b02a39892a2119$var$NodeType.Text && node.__sn.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join("") : "",
                attributes: $43b02a39892a2119$var$getAttributesToRecord(serializedNode.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $43b02a39892a2119$var$handleDom(handlerData) {
    const { target: target , message: message  } = $43b02a39892a2119$var$getDomTarget(handlerData);
    return $43b02a39892a2119$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$43b02a39892a2119$var$getBaseDomBreadcrumb(target, message)
    });
}
function $43b02a39892a2119$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === "click";
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $43b02a39892a2119$var$getClickTargetNode(handlerData.event) : $43b02a39892a2119$var$getTargetNode(handlerData.event);
        message = (0, $iTlxf.htmlTreeAsString)(target, {
            maxStringLength: 200
        }) || "<unknown>";
    } catch (e) {
        message = "<unknown>";
    }
    return {
        target: target,
        message: message
    };
}
function $43b02a39892a2119$var$isRrwebNode(node) {
    return "__sn" in node;
}
function $43b02a39892a2119$var$getTargetNode(event) {
    if ($43b02a39892a2119$var$isEventWithTarget(event)) return event.target;
    return event;
}
const $43b02a39892a2119$var$INTERACTIVE_SELECTOR = "button,a";
// For clicks, we check if the target is inside of a button or link
// If so, we use this as the target instead
// This is useful because if you click on the image in <button><img></button>,
// The target will be the image, not the button, which we don't want here
function $43b02a39892a2119$var$getClickTargetNode(event) {
    const target = $43b02a39892a2119$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    const closestInteractive = target.closest($43b02a39892a2119$var$INTERACTIVE_SELECTOR);
    return closestInteractive || target;
}
function $43b02a39892a2119$var$isEventWithTarget(event) {
    return typeof event === "object" && !!event && "target" in event;
}
/** Handle keyboard events & create breadcrumbs. */ function $43b02a39892a2119$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    replay.triggerUserActivity();
    const breadcrumb = $43b02a39892a2119$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $43b02a39892a2119$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $43b02a39892a2119$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey , shiftKey: shiftKey , ctrlKey: ctrlKey , altKey: altKey , key: key , target: target  } = event;
    // never capture for input fields
    if (!target || $43b02a39892a2119$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $iTlxf.htmlTreeAsString)(target, {
        maxStringLength: 200
    }) || "<unknown>";
    const baseBreadcrumb = $43b02a39892a2119$var$getBaseDomBreadcrumb(target, message);
    return $43b02a39892a2119$var$createBreadcrumb({
        category: "ui.keyDown",
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $43b02a39892a2119$var$isInputElement(target) {
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
const $43b02a39892a2119$var$NAVIGATION_ENTRY_KEYS = [
    "name",
    "type",
    "startTime",
    "transferSize",
    "duration"
];
function $43b02a39892a2119$var$isNavigationEntryEqual(a) {
    return function(b) {
        return $43b02a39892a2119$var$NAVIGATION_ENTRY_KEYS.every((key)=>a[key] === b[key]);
    };
}
/**
 * There are some difficulties diagnosing why there are duplicate navigation
 * entries. We've witnessed several intermittent results:
 * - duplicate entries have duration = 0
 * - duplicate entries are the same object reference
 * - none of the above
 *
 * Compare the values of several keys to determine if the entries are duplicates or not.
 */ // TODO (high-prio): Figure out wth is returned here
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function $43b02a39892a2119$var$dedupePerformanceEntries(currentList, newList) {
    // Partition `currentList` into 3 different lists based on entryType
    const [existingNavigationEntries, existingLcpEntries, existingEntries] = currentList.reduce((acc, entry)=>{
        if (entry.entryType === "navigation") acc[0].push(entry);
        else if (entry.entryType === "largest-contentful-paint") acc[1].push(entry);
        else acc[2].push(entry);
        return acc;
    }, [
        [],
        [],
        []
    ]);
    const newEntries = [];
    const newNavigationEntries = [];
    let newLcpEntry = existingLcpEntries.length ? existingLcpEntries[existingLcpEntries.length - 1] // Take the last element as list is sorted
     : undefined;
    newList.forEach((entry)=>{
        if (entry.entryType === "largest-contentful-paint") {
            // We want the latest LCP event only
            if (!newLcpEntry || newLcpEntry.startTime < entry.startTime) newLcpEntry = entry;
            return;
        }
        if (entry.entryType === "navigation") {
            const navigationEntry = entry;
            // Check if the navigation entry is contained in currentList or newList
            if (// Ignore any navigation entries with duration 0, as they are likely duplicates
            entry.duration > 0 && // Ensure new entry does not already exist in existing entries
            !existingNavigationEntries.find($43b02a39892a2119$var$isNavigationEntryEqual(navigationEntry)) && // Ensure new entry does not already exist in new list of navigation entries
            !newNavigationEntries.find($43b02a39892a2119$var$isNavigationEntryEqual(navigationEntry))) newNavigationEntries.push(navigationEntry);
            // Otherwise this navigation entry is considered a duplicate and is thrown away
            return;
        }
        newEntries.push(entry);
    });
    // Re-combine and sort by startTime
    return [
        ...newLcpEntry ? [
            newLcpEntry
        ] : [],
        ...existingNavigationEntries,
        ...existingEntries,
        ...newEntries,
        ...newNavigationEntries
    ].sort((a, b)=>a.startTime - b.startTime);
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 */ function $43b02a39892a2119$var$setupPerformanceObserver(replay) {
    const performanceObserverHandler = (list)=>{
        // For whatever reason the observer was returning duplicate navigation
        // entries (the other entry types were not duplicated).
        const newPerformanceEntries = $43b02a39892a2119$var$dedupePerformanceEntries(replay.performanceEvents, list.getEntries());
        replay.performanceEvents = newPerformanceEntries;
    };
    const performanceObserver = new PerformanceObserver(performanceObserverHandler);
    [
        "element",
        "event",
        "first-input",
        "largest-contentful-paint",
        "layout-shift",
        "longtask",
        "navigation",
        "paint",
        "resource"
    ].forEach((type)=>{
        try {
            performanceObserver.observe({
                type: type,
                buffered: true
            });
        } catch (e) {
        // This can throw if an entry type is not supported in the browser.
        // Ignore these errors.
        }
    });
    return performanceObserver;
}
const $43b02a39892a2119$var$r = `/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */
function t(t){let e=t.length;for(;--e>=0;)t[e]=0}const e=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),a=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),i=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),n=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=new Array(576);t(s);const r=new Array(60);t(r);const o=new Array(512);t(o);const l=new Array(256);t(l);const h=new Array(29);t(h);const d=new Array(30);function _(t,e,a,i,n){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=i,this.max_length=n,this.has_stree=t&&t.length}let f,c,u;function w(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}t(d);const m=t=>t<256?o[t]:o[256+(t>>>7)],b=(t,e)=>{t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},g=(t,e,a)=>{t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,b(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},p=(t,e,a)=>{g(t,a[2*e],a[2*e+1])},k=(t,e)=>{let a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},v=(t,e,a)=>{const i=new Array(16);let n,s,r=0;for(n=1;n<=15;n++)r=r+a[n-1]<<1,i[n]=r;for(s=0;s<=e;s++){let e=t[2*s+1];0!==e&&(t[2*s]=k(i[e]++,e))}},y=t=>{let e;for(e=0;e<286;e++)t.dyn_ltree[2*e]=0;for(e=0;e<30;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.sym_next=t.matches=0},x=t=>{t.bi_valid>8?b(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},z=(t,e,a,i)=>{const n=2*e,s=2*a;return t[n]<t[s]||t[n]===t[s]&&i[e]<=i[a]},A=(t,e,a)=>{const i=t.heap[a];let n=a<<1;for(;n<=t.heap_len&&(n<t.heap_len&&z(e,t.heap[n+1],t.heap[n],t.depth)&&n++,!z(e,i,t.heap[n],t.depth));)t.heap[a]=t.heap[n],a=n,n<<=1;t.heap[a]=i},E=(t,i,n)=>{let s,r,o,_,f=0;if(0!==t.sym_next)do{s=255&t.pending_buf[t.sym_buf+f++],s+=(255&t.pending_buf[t.sym_buf+f++])<<8,r=t.pending_buf[t.sym_buf+f++],0===s?p(t,r,i):(o=l[r],p(t,o+256+1,i),_=e[o],0!==_&&(r-=h[o],g(t,r,_)),s--,o=m(s),p(t,o,n),_=a[o],0!==_&&(s-=d[o],g(t,s,_)))}while(f<t.sym_next);p(t,256,i)},R=(t,e)=>{const a=e.dyn_tree,i=e.stat_desc.static_tree,n=e.stat_desc.has_stree,s=e.stat_desc.elems;let r,o,l,h=-1;for(t.heap_len=0,t.heap_max=573,r=0;r<s;r++)0!==a[2*r]?(t.heap[++t.heap_len]=h=r,t.depth[r]=0):a[2*r+1]=0;for(;t.heap_len<2;)l=t.heap[++t.heap_len]=h<2?++h:0,a[2*l]=1,t.depth[l]=0,t.opt_len--,n&&(t.static_len-=i[2*l+1]);for(e.max_code=h,r=t.heap_len>>1;r>=1;r--)A(t,a,r);l=s;do{r=t.heap[1],t.heap[1]=t.heap[t.heap_len--],A(t,a,1),o=t.heap[1],t.heap[--t.heap_max]=r,t.heap[--t.heap_max]=o,a[2*l]=a[2*r]+a[2*o],t.depth[l]=(t.depth[r]>=t.depth[o]?t.depth[r]:t.depth[o])+1,a[2*r+1]=a[2*o+1]=l,t.heap[1]=l++,A(t,a,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],((t,e)=>{const a=e.dyn_tree,i=e.max_code,n=e.stat_desc.static_tree,s=e.stat_desc.has_stree,r=e.stat_desc.extra_bits,o=e.stat_desc.extra_base,l=e.stat_desc.max_length;let h,d,_,f,c,u,w=0;for(f=0;f<=15;f++)t.bl_count[f]=0;for(a[2*t.heap[t.heap_max]+1]=0,h=t.heap_max+1;h<573;h++)d=t.heap[h],f=a[2*a[2*d+1]+1]+1,f>l&&(f=l,w++),a[2*d+1]=f,d>i||(t.bl_count[f]++,c=0,d>=o&&(c=r[d-o]),u=a[2*d],t.opt_len+=u*(f+c),s&&(t.static_len+=u*(n[2*d+1]+c)));if(0!==w){do{for(f=l-1;0===t.bl_count[f];)f--;t.bl_count[f]--,t.bl_count[f+1]+=2,t.bl_count[l]--,w-=2}while(w>0);for(f=l;0!==f;f--)for(d=t.bl_count[f];0!==d;)_=t.heap[--h],_>i||(a[2*_+1]!==f&&(t.opt_len+=(f-a[2*_+1])*a[2*_],a[2*_+1]=f),d--)}})(t,e),v(a,h,t.bl_count)},Z=(t,e,a)=>{let i,n,s=-1,r=e[1],o=0,l=7,h=4;for(0===r&&(l=138,h=3),e[2*(a+1)+1]=65535,i=0;i<=a;i++)n=r,r=e[2*(i+1)+1],++o<l&&n===r||(o<h?t.bl_tree[2*n]+=o:0!==n?(n!==s&&t.bl_tree[2*n]++,t.bl_tree[32]++):o<=10?t.bl_tree[34]++:t.bl_tree[36]++,o=0,s=n,0===r?(l=138,h=3):n===r?(l=6,h=3):(l=7,h=4))},U=(t,e,a)=>{let i,n,s=-1,r=e[1],o=0,l=7,h=4;for(0===r&&(l=138,h=3),i=0;i<=a;i++)if(n=r,r=e[2*(i+1)+1],!(++o<l&&n===r)){if(o<h)do{p(t,n,t.bl_tree)}while(0!=--o);else 0!==n?(n!==s&&(p(t,n,t.bl_tree),o--),p(t,16,t.bl_tree),g(t,o-3,2)):o<=10?(p(t,17,t.bl_tree),g(t,o-3,3)):(p(t,18,t.bl_tree),g(t,o-11,7));o=0,s=n,0===r?(l=138,h=3):n===r?(l=6,h=3):(l=7,h=4)}};let S=!1;const D=(t,e,a,i)=>{g(t,0+(i?1:0),3),x(t),b(t,a),b(t,~a),a&&t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a};var T=(t,e,a,i)=>{let o,l,h=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=(t=>{let e,a=4093624447;for(e=0;e<=31;e++,a>>>=1)if(1&a&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<256;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0})(t)),R(t,t.l_desc),R(t,t.d_desc),h=(t=>{let e;for(Z(t,t.dyn_ltree,t.l_desc.max_code),Z(t,t.dyn_dtree,t.d_desc.max_code),R(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*n[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e})(t),o=t.opt_len+3+7>>>3,l=t.static_len+3+7>>>3,l<=o&&(o=l)):o=l=a+5,a+4<=o&&-1!==e?D(t,e,a,i):4===t.strategy||l===o?(g(t,2+(i?1:0),3),E(t,s,r)):(g(t,4+(i?1:0),3),((t,e,a,i)=>{let s;for(g(t,e-257,5),g(t,a-1,5),g(t,i-4,4),s=0;s<i;s++)g(t,t.bl_tree[2*n[s]+1],3);U(t,t.dyn_ltree,e-1),U(t,t.dyn_dtree,a-1)})(t,t.l_desc.max_code+1,t.d_desc.max_code+1,h+1),E(t,t.dyn_ltree,t.dyn_dtree)),y(t),i&&x(t)},O={_tr_init:t=>{S||((()=>{let t,n,w,m,b;const g=new Array(16);for(w=0,m=0;m<28;m++)for(h[m]=w,t=0;t<1<<e[m];t++)l[w++]=m;for(l[w-1]=m,b=0,m=0;m<16;m++)for(d[m]=b,t=0;t<1<<a[m];t++)o[b++]=m;for(b>>=7;m<30;m++)for(d[m]=b<<7,t=0;t<1<<a[m]-7;t++)o[256+b++]=m;for(n=0;n<=15;n++)g[n]=0;for(t=0;t<=143;)s[2*t+1]=8,t++,g[8]++;for(;t<=255;)s[2*t+1]=9,t++,g[9]++;for(;t<=279;)s[2*t+1]=7,t++,g[7]++;for(;t<=287;)s[2*t+1]=8,t++,g[8]++;for(v(s,287,g),t=0;t<30;t++)r[2*t+1]=5,r[2*t]=k(t,5);f=new _(s,e,257,286,15),c=new _(r,a,0,30,15),u=new _(new Array(0),i,0,19,7)})(),S=!0),t.l_desc=new w(t.dyn_ltree,f),t.d_desc=new w(t.dyn_dtree,c),t.bl_desc=new w(t.bl_tree,u),t.bi_buf=0,t.bi_valid=0,y(t)},_tr_stored_block:D,_tr_flush_block:T,_tr_tally:(t,e,a)=>(t.pending_buf[t.sym_buf+t.sym_next++]=e,t.pending_buf[t.sym_buf+t.sym_next++]=e>>8,t.pending_buf[t.sym_buf+t.sym_next++]=a,0===e?t.dyn_ltree[2*a]++:(t.matches++,e--,t.dyn_ltree[2*(l[a]+256+1)]++,t.dyn_dtree[2*m(e)]++),t.sym_next===t.sym_end),_tr_align:t=>{g(t,2,3),p(t,256,s),(t=>{16===t.bi_valid?(b(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)})(t)}};var F=(t,e,a,i)=>{let n=65535&t|0,s=t>>>16&65535|0,r=0;for(;0!==a;){r=a>2e3?2e3:a,a-=r;do{n=n+e[i++]|0,s=s+n|0}while(--r);n%=65521,s%=65521}return n|s<<16|0};const L=new Uint32Array((()=>{let t,e=[];for(var a=0;a<256;a++){t=a;for(var i=0;i<8;i++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e})());var N=(t,e,a,i)=>{const n=L,s=i+a;t^=-1;for(let a=i;a<s;a++)t=t>>>8^n[255&(t^e[a])];return-1^t},I={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"},B={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_MEM_ERROR:-4,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8};const{_tr_init:C,_tr_stored_block:H,_tr_flush_block:M,_tr_tally:j,_tr_align:K}=O,{Z_NO_FLUSH:P,Z_PARTIAL_FLUSH:Y,Z_FULL_FLUSH:G,Z_FINISH:X,Z_BLOCK:W,Z_OK:q,Z_STREAM_END:J,Z_STREAM_ERROR:Q,Z_DATA_ERROR:V,Z_BUF_ERROR:$,Z_DEFAULT_COMPRESSION:tt,Z_FILTERED:et,Z_HUFFMAN_ONLY:at,Z_RLE:it,Z_FIXED:nt,Z_DEFAULT_STRATEGY:st,Z_UNKNOWN:rt,Z_DEFLATED:ot}=B,lt=(t,e)=>(t.msg=I[e],e),ht=t=>2*t-(t>4?9:0),dt=t=>{let e=t.length;for(;--e>=0;)t[e]=0},_t=t=>{let e,a,i,n=t.w_size;e=t.hash_size,i=e;do{a=t.head[--i],t.head[i]=a>=n?a-n:0}while(--e);e=n,i=e;do{a=t.prev[--i],t.prev[i]=a>=n?a-n:0}while(--e)};let ft=(t,e,a)=>(e<<t.hash_shift^a)&t.hash_mask;const ct=t=>{const e=t.state;let a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},ut=(t,e)=>{M(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,ct(t.strm)},wt=(t,e)=>{t.pending_buf[t.pending++]=e},mt=(t,e)=>{t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},bt=(t,e,a,i)=>{let n=t.avail_in;return n>i&&(n=i),0===n?0:(t.avail_in-=n,e.set(t.input.subarray(t.next_in,t.next_in+n),a),1===t.state.wrap?t.adler=F(t.adler,e,n,a):2===t.state.wrap&&(t.adler=N(t.adler,e,n,a)),t.next_in+=n,t.total_in+=n,n)},gt=(t,e)=>{let a,i,n=t.max_chain_length,s=t.strstart,r=t.prev_length,o=t.nice_match;const l=t.strstart>t.w_size-262?t.strstart-(t.w_size-262):0,h=t.window,d=t.w_mask,_=t.prev,f=t.strstart+258;let c=h[s+r-1],u=h[s+r];t.prev_length>=t.good_match&&(n>>=2),o>t.lookahead&&(o=t.lookahead);do{if(a=e,h[a+r]===u&&h[a+r-1]===c&&h[a]===h[s]&&h[++a]===h[s+1]){s+=2,a++;do{}while(h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&s<f);if(i=258-(f-s),s=f-258,i>r){if(t.match_start=e,r=i,i>=o)break;c=h[s+r-1],u=h[s+r]}}}while((e=_[e&d])>l&&0!=--n);return r<=t.lookahead?r:t.lookahead},pt=t=>{const e=t.w_size;let a,i,n;do{if(i=t.window_size-t.lookahead-t.strstart,t.strstart>=e+(e-262)&&(t.window.set(t.window.subarray(e,e+e-i),0),t.match_start-=e,t.strstart-=e,t.block_start-=e,t.insert>t.strstart&&(t.insert=t.strstart),_t(t),i+=e),0===t.strm.avail_in)break;if(a=bt(t.strm,t.window,t.strstart+t.lookahead,i),t.lookahead+=a,t.lookahead+t.insert>=3)for(n=t.strstart-t.insert,t.ins_h=t.window[n],t.ins_h=ft(t,t.ins_h,t.window[n+1]);t.insert&&(t.ins_h=ft(t,t.ins_h,t.window[n+3-1]),t.prev[n&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=n,n++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<262&&0!==t.strm.avail_in)},kt=(t,e)=>{let a,i,n,s=t.pending_buf_size-5>t.w_size?t.w_size:t.pending_buf_size-5,r=0,o=t.strm.avail_in;do{if(a=65535,n=t.bi_valid+42>>3,t.strm.avail_out<n)break;if(n=t.strm.avail_out-n,i=t.strstart-t.block_start,a>i+t.strm.avail_in&&(a=i+t.strm.avail_in),a>n&&(a=n),a<s&&(0===a&&e!==X||e===P||a!==i+t.strm.avail_in))break;r=e===X&&a===i+t.strm.avail_in?1:0,H(t,0,0,r),t.pending_buf[t.pending-4]=a,t.pending_buf[t.pending-3]=a>>8,t.pending_buf[t.pending-2]=~a,t.pending_buf[t.pending-1]=~a>>8,ct(t.strm),i&&(i>a&&(i=a),t.strm.output.set(t.window.subarray(t.block_start,t.block_start+i),t.strm.next_out),t.strm.next_out+=i,t.strm.avail_out-=i,t.strm.total_out+=i,t.block_start+=i,a-=i),a&&(bt(t.strm,t.strm.output,t.strm.next_out,a),t.strm.next_out+=a,t.strm.avail_out-=a,t.strm.total_out+=a)}while(0===r);return o-=t.strm.avail_in,o&&(o>=t.w_size?(t.matches=2,t.window.set(t.strm.input.subarray(t.strm.next_in-t.w_size,t.strm.next_in),0),t.strstart=t.w_size,t.insert=t.strstart):(t.window_size-t.strstart<=o&&(t.strstart-=t.w_size,t.window.set(t.window.subarray(t.w_size,t.w_size+t.strstart),0),t.matches<2&&t.matches++,t.insert>t.strstart&&(t.insert=t.strstart)),t.window.set(t.strm.input.subarray(t.strm.next_in-o,t.strm.next_in),t.strstart),t.strstart+=o,t.insert+=o>t.w_size-t.insert?t.w_size-t.insert:o),t.block_start=t.strstart),t.high_water<t.strstart&&(t.high_water=t.strstart),r?4:e!==P&&e!==X&&0===t.strm.avail_in&&t.strstart===t.block_start?2:(n=t.window_size-t.strstart,t.strm.avail_in>n&&t.block_start>=t.w_size&&(t.block_start-=t.w_size,t.strstart-=t.w_size,t.window.set(t.window.subarray(t.w_size,t.w_size+t.strstart),0),t.matches<2&&t.matches++,n+=t.w_size,t.insert>t.strstart&&(t.insert=t.strstart)),n>t.strm.avail_in&&(n=t.strm.avail_in),n&&(bt(t.strm,t.window,t.strstart,n),t.strstart+=n,t.insert+=n>t.w_size-t.insert?t.w_size-t.insert:n),t.high_water<t.strstart&&(t.high_water=t.strstart),n=t.bi_valid+42>>3,n=t.pending_buf_size-n>65535?65535:t.pending_buf_size-n,s=n>t.w_size?t.w_size:n,i=t.strstart-t.block_start,(i>=s||(i||e===X)&&e!==P&&0===t.strm.avail_in&&i<=n)&&(a=i>n?n:i,r=e===X&&0===t.strm.avail_in&&a===i?1:0,H(t,t.block_start,a,r),t.block_start+=a,ct(t.strm)),r?3:1)},vt=(t,e)=>{let a,i;for(;;){if(t.lookahead<262){if(pt(t),t.lookahead<262&&e===P)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-262&&(t.match_length=gt(t,a)),t.match_length>=3)if(i=j(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=ft(t,t.ins_h,t.window[t.strstart+1]);else i=j(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(i&&(ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2},yt=(t,e)=>{let a,i,n;for(;;){if(t.lookahead<262){if(pt(t),t.lookahead<262&&e===P)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-262&&(t.match_length=gt(t,a),t.match_length<=5&&(t.strategy===et||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){n=t.strstart+t.lookahead-3,i=j(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=n&&(t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,i&&(ut(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if(i=j(t,0,t.window[t.strstart-1]),i&&ut(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(i=j(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2};function xt(t,e,a,i,n){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=i,this.func=n}const zt=[new xt(0,0,0,0,kt),new xt(4,4,8,4,vt),new xt(4,5,16,8,vt),new xt(4,6,32,32,vt),new xt(4,4,16,16,yt),new xt(8,16,32,32,yt),new xt(8,16,128,128,yt),new xt(8,32,128,256,yt),new xt(32,128,258,1024,yt),new xt(32,258,258,4096,yt)];function At(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=ot,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),dt(this.dyn_ltree),dt(this.dyn_dtree),dt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),dt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),dt(this.depth),this.sym_buf=0,this.lit_bufsize=0,this.sym_next=0,this.sym_end=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}const Et=t=>{if(!t)return 1;const e=t.state;return!e||e.strm!==t||42!==e.status&&57!==e.status&&69!==e.status&&73!==e.status&&91!==e.status&&103!==e.status&&113!==e.status&&666!==e.status?1:0},Rt=t=>{if(Et(t))return lt(t,Q);t.total_in=t.total_out=0,t.data_type=rt;const e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=2===e.wrap?57:e.wrap?42:113,t.adler=2===e.wrap?0:1,e.last_flush=-2,C(e),q},Zt=t=>{const e=Rt(t);var a;return e===q&&((a=t.state).window_size=2*a.w_size,dt(a.head),a.max_lazy_match=zt[a.level].max_lazy,a.good_match=zt[a.level].good_length,a.nice_match=zt[a.level].nice_length,a.max_chain_length=zt[a.level].max_chain,a.strstart=0,a.block_start=0,a.lookahead=0,a.insert=0,a.match_length=a.prev_length=2,a.match_available=0,a.ins_h=0),e},Ut=(t,e,a,i,n,s)=>{if(!t)return Q;let r=1;if(e===tt&&(e=6),i<0?(r=0,i=-i):i>15&&(r=2,i-=16),n<1||n>9||a!==ot||i<8||i>15||e<0||e>9||s<0||s>nt||8===i&&1!==r)return lt(t,Q);8===i&&(i=9);const o=new At;return t.state=o,o.strm=t,o.status=42,o.wrap=r,o.gzhead=null,o.w_bits=i,o.w_size=1<<o.w_bits,o.w_mask=o.w_size-1,o.hash_bits=n+7,o.hash_size=1<<o.hash_bits,o.hash_mask=o.hash_size-1,o.hash_shift=~~((o.hash_bits+3-1)/3),o.window=new Uint8Array(2*o.w_size),o.head=new Uint16Array(o.hash_size),o.prev=new Uint16Array(o.w_size),o.lit_bufsize=1<<n+6,o.pending_buf_size=4*o.lit_bufsize,o.pending_buf=new Uint8Array(o.pending_buf_size),o.sym_buf=o.lit_bufsize,o.sym_end=3*(o.lit_bufsize-1),o.level=e,o.strategy=s,o.method=a,Zt(t)};var St={deflateInit:(t,e)=>Ut(t,e,ot,15,8,st),deflateInit2:Ut,deflateReset:Zt,deflateResetKeep:Rt,deflateSetHeader:(t,e)=>Et(t)||2!==t.state.wrap?Q:(t.state.gzhead=e,q),deflate:(t,e)=>{if(Et(t)||e>W||e<0)return t?lt(t,Q):Q;const a=t.state;if(!t.output||0!==t.avail_in&&!t.input||666===a.status&&e!==X)return lt(t,0===t.avail_out?$:Q);const i=a.last_flush;if(a.last_flush=e,0!==a.pending){if(ct(t),0===t.avail_out)return a.last_flush=-1,q}else if(0===t.avail_in&&ht(e)<=ht(i)&&e!==X)return lt(t,$);if(666===a.status&&0!==t.avail_in)return lt(t,$);if(42===a.status&&0===a.wrap&&(a.status=113),42===a.status){let e=ot+(a.w_bits-8<<4)<<8,i=-1;if(i=a.strategy>=at||a.level<2?0:a.level<6?1:6===a.level?2:3,e|=i<<6,0!==a.strstart&&(e|=32),e+=31-e%31,mt(a,e),0!==a.strstart&&(mt(a,t.adler>>>16),mt(a,65535&t.adler)),t.adler=1,a.status=113,ct(t),0!==a.pending)return a.last_flush=-1,q}if(57===a.status)if(t.adler=0,wt(a,31),wt(a,139),wt(a,8),a.gzhead)wt(a,(a.gzhead.text?1:0)+(a.gzhead.hcrc?2:0)+(a.gzhead.extra?4:0)+(a.gzhead.name?8:0)+(a.gzhead.comment?16:0)),wt(a,255&a.gzhead.time),wt(a,a.gzhead.time>>8&255),wt(a,a.gzhead.time>>16&255),wt(a,a.gzhead.time>>24&255),wt(a,9===a.level?2:a.strategy>=at||a.level<2?4:0),wt(a,255&a.gzhead.os),a.gzhead.extra&&a.gzhead.extra.length&&(wt(a,255&a.gzhead.extra.length),wt(a,a.gzhead.extra.length>>8&255)),a.gzhead.hcrc&&(t.adler=N(t.adler,a.pending_buf,a.pending,0)),a.gzindex=0,a.status=69;else if(wt(a,0),wt(a,0),wt(a,0),wt(a,0),wt(a,0),wt(a,9===a.level?2:a.strategy>=at||a.level<2?4:0),wt(a,3),a.status=113,ct(t),0!==a.pending)return a.last_flush=-1,q;if(69===a.status){if(a.gzhead.extra){let e=a.pending,i=(65535&a.gzhead.extra.length)-a.gzindex;for(;a.pending+i>a.pending_buf_size;){let n=a.pending_buf_size-a.pending;if(a.pending_buf.set(a.gzhead.extra.subarray(a.gzindex,a.gzindex+n),a.pending),a.pending=a.pending_buf_size,a.gzhead.hcrc&&a.pending>e&&(t.adler=N(t.adler,a.pending_buf,a.pending-e,e)),a.gzindex+=n,ct(t),0!==a.pending)return a.last_flush=-1,q;e=0,i-=n}let n=new Uint8Array(a.gzhead.extra);a.pending_buf.set(n.subarray(a.gzindex,a.gzindex+i),a.pending),a.pending+=i,a.gzhead.hcrc&&a.pending>e&&(t.adler=N(t.adler,a.pending_buf,a.pending-e,e)),a.gzindex=0}a.status=73}if(73===a.status){if(a.gzhead.name){let e,i=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i)),ct(t),0!==a.pending)return a.last_flush=-1,q;i=0}e=a.gzindex<a.gzhead.name.length?255&a.gzhead.name.charCodeAt(a.gzindex++):0,wt(a,e)}while(0!==e);a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i)),a.gzindex=0}a.status=91}if(91===a.status){if(a.gzhead.comment){let e,i=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i)),ct(t),0!==a.pending)return a.last_flush=-1,q;i=0}e=a.gzindex<a.gzhead.comment.length?255&a.gzhead.comment.charCodeAt(a.gzindex++):0,wt(a,e)}while(0!==e);a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i))}a.status=103}if(103===a.status){if(a.gzhead.hcrc){if(a.pending+2>a.pending_buf_size&&(ct(t),0!==a.pending))return a.last_flush=-1,q;wt(a,255&t.adler),wt(a,t.adler>>8&255),t.adler=0}if(a.status=113,ct(t),0!==a.pending)return a.last_flush=-1,q}if(0!==t.avail_in||0!==a.lookahead||e!==P&&666!==a.status){let i=0===a.level?kt(a,e):a.strategy===at?((t,e)=>{let a;for(;;){if(0===t.lookahead&&(pt(t),0===t.lookahead)){if(e===P)return 1;break}if(t.match_length=0,a=j(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2})(a,e):a.strategy===it?((t,e)=>{let a,i,n,s;const r=t.window;for(;;){if(t.lookahead<=258){if(pt(t),t.lookahead<=258&&e===P)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=t.strstart-1,i=r[n],i===r[++n]&&i===r[++n]&&i===r[++n])){s=t.strstart+258;do{}while(i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&n<s);t.match_length=258-(s-n),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=j(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=j(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2})(a,e):zt[a.level].func(a,e);if(3!==i&&4!==i||(a.status=666),1===i||3===i)return 0===t.avail_out&&(a.last_flush=-1),q;if(2===i&&(e===Y?K(a):e!==W&&(H(a,0,0,!1),e===G&&(dt(a.head),0===a.lookahead&&(a.strstart=0,a.block_start=0,a.insert=0))),ct(t),0===t.avail_out))return a.last_flush=-1,q}return e!==X?q:a.wrap<=0?J:(2===a.wrap?(wt(a,255&t.adler),wt(a,t.adler>>8&255),wt(a,t.adler>>16&255),wt(a,t.adler>>24&255),wt(a,255&t.total_in),wt(a,t.total_in>>8&255),wt(a,t.total_in>>16&255),wt(a,t.total_in>>24&255)):(mt(a,t.adler>>>16),mt(a,65535&t.adler)),ct(t),a.wrap>0&&(a.wrap=-a.wrap),0!==a.pending?q:J)},deflateEnd:t=>{if(Et(t))return Q;const e=t.state.status;return t.state=null,113===e?lt(t,V):q},deflateSetDictionary:(t,e)=>{let a=e.length;if(Et(t))return Q;const i=t.state,n=i.wrap;if(2===n||1===n&&42!==i.status||i.lookahead)return Q;if(1===n&&(t.adler=F(t.adler,e,a,0)),i.wrap=0,a>=i.w_size){0===n&&(dt(i.head),i.strstart=0,i.block_start=0,i.insert=0);let t=new Uint8Array(i.w_size);t.set(e.subarray(a-i.w_size,a),0),e=t,a=i.w_size}const s=t.avail_in,r=t.next_in,o=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,pt(i);i.lookahead>=3;){let t=i.strstart,e=i.lookahead-2;do{i.ins_h=ft(i,i.ins_h,i.window[t+3-1]),i.prev[t&i.w_mask]=i.head[i.ins_h],i.head[i.ins_h]=t,t++}while(--e);i.strstart=t,i.lookahead=2,pt(i)}return i.strstart+=i.lookahead,i.block_start=i.strstart,i.insert=i.lookahead,i.lookahead=0,i.match_length=i.prev_length=2,i.match_available=0,t.next_in=r,t.input=o,t.avail_in=s,i.wrap=n,q},deflateInfo:"pako deflate (from Nodeca project)"};const Dt=(t,e)=>Object.prototype.hasOwnProperty.call(t,e);var Tt=function(t){const e=Array.prototype.slice.call(arguments,1);for(;e.length;){const a=e.shift();if(a){if("object"!=typeof a)throw new TypeError(a+"must be non-object");for(const e in a)Dt(a,e)&&(t[e]=a[e])}}return t},Ot=t=>{let e=0;for(let a=0,i=t.length;a<i;a++)e+=t[a].length;const a=new Uint8Array(e);for(let e=0,i=0,n=t.length;e<n;e++){let n=t[e];a.set(n,i),i+=n.length}return a};let Ft=!0;try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(t){Ft=!1}const Lt=new Uint8Array(256);for(let t=0;t<256;t++)Lt[t]=t>=252?6:t>=248?5:t>=240?4:t>=224?3:t>=192?2:1;Lt[254]=Lt[254]=1;var Nt=t=>{if("function"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);let e,a,i,n,s,r=t.length,o=0;for(n=0;n<r;n++)a=t.charCodeAt(n),55296==(64512&a)&&n+1<r&&(i=t.charCodeAt(n+1),56320==(64512&i)&&(a=65536+(a-55296<<10)+(i-56320),n++)),o+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(o),s=0,n=0;s<o;n++)a=t.charCodeAt(n),55296==(64512&a)&&n+1<r&&(i=t.charCodeAt(n+1),56320==(64512&i)&&(a=65536+(a-55296<<10)+(i-56320),n++)),a<128?e[s++]=a:a<2048?(e[s++]=192|a>>>6,e[s++]=128|63&a):a<65536?(e[s++]=224|a>>>12,e[s++]=128|a>>>6&63,e[s++]=128|63&a):(e[s++]=240|a>>>18,e[s++]=128|a>>>12&63,e[s++]=128|a>>>6&63,e[s++]=128|63&a);return e},It=(t,e)=>{const a=e||t.length;if("function"==typeof TextDecoder&&TextDecoder.prototype.decode)return(new TextDecoder).decode(t.subarray(0,e));let i,n;const s=new Array(2*a);for(n=0,i=0;i<a;){let e=t[i++];if(e<128){s[n++]=e;continue}let r=Lt[e];if(r>4)s[n++]=65533,i+=r-1;else{for(e&=2===r?31:3===r?15:7;r>1&&i<a;)e=e<<6|63&t[i++],r--;r>1?s[n++]=65533:e<65536?s[n++]=e:(e-=65536,s[n++]=55296|e>>10&1023,s[n++]=56320|1023&e)}}return((t,e)=>{if(e<65534&&t.subarray&&Ft)return String.fromCharCode.apply(null,t.length===e?t:t.subarray(0,e));let a="";for(let i=0;i<e;i++)a+=String.fromCharCode(t[i]);return a})(s,n)},Bt=(t,e)=>{(e=e||t.length)>t.length&&(e=t.length);let a=e-1;for(;a>=0&&128==(192&t[a]);)a--;return a<0||0===a?e:a+Lt[t[a]]>e?a:e};var Ct=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0};const Ht=Object.prototype.toString,{Z_NO_FLUSH:Mt,Z_SYNC_FLUSH:jt,Z_FULL_FLUSH:Kt,Z_FINISH:Pt,Z_OK:Yt,Z_STREAM_END:Gt,Z_DEFAULT_COMPRESSION:Xt,Z_DEFAULT_STRATEGY:Wt,Z_DEFLATED:qt}=B;function Jt(t){this.options=Tt({level:Xt,method:qt,chunkSize:16384,windowBits:15,memLevel:8,strategy:Wt},t||{});let e=this.options;e.raw&&e.windowBits>0?e.windowBits=-e.windowBits:e.gzip&&e.windowBits>0&&e.windowBits<16&&(e.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;let a=St.deflateInit2(this.strm,e.level,e.method,e.windowBits,e.memLevel,e.strategy);if(a!==Yt)throw new Error(I[a]);if(e.header&&St.deflateSetHeader(this.strm,e.header),e.dictionary){let t;if(t="string"==typeof e.dictionary?Nt(e.dictionary):"[object ArrayBuffer]"===Ht.call(e.dictionary)?new Uint8Array(e.dictionary):e.dictionary,a=St.deflateSetDictionary(this.strm,t),a!==Yt)throw new Error(I[a]);this._dict_set=!0}}function Qt(t,e){const a=new Jt(e);if(a.push(t,!0),a.err)throw a.msg||I[a.err];return a.result}Jt.prototype.push=function(t,e){const a=this.strm,i=this.options.chunkSize;let n,s;if(this.ended)return!1;for(s=e===~~e?e:!0===e?Pt:Mt,"string"==typeof t?a.input=Nt(t):"[object ArrayBuffer]"===Ht.call(t)?a.input=new Uint8Array(t):a.input=t,a.next_in=0,a.avail_in=a.input.length;;)if(0===a.avail_out&&(a.output=new Uint8Array(i),a.next_out=0,a.avail_out=i),(s===jt||s===Kt)&&a.avail_out<=6)this.onData(a.output.subarray(0,a.next_out)),a.avail_out=0;else{if(n=St.deflate(a,s),n===Gt)return a.next_out>0&&this.onData(a.output.subarray(0,a.next_out)),n=St.deflateEnd(this.strm),this.onEnd(n),this.ended=!0,n===Yt;if(0!==a.avail_out){if(s>0&&a.next_out>0)this.onData(a.output.subarray(0,a.next_out)),a.avail_out=0;else if(0===a.avail_in)break}else this.onData(a.output)}return!0},Jt.prototype.onData=function(t){this.chunks.push(t)},Jt.prototype.onEnd=function(t){t===Yt&&(this.result=Ot(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg};var Vt={Deflate:Jt,deflate:Qt,deflateRaw:function(t,e){return(e=e||{}).raw=!0,Qt(t,e)},gzip:function(t,e){return(e=e||{}).gzip=!0,Qt(t,e)},constants:B};var $t=function(t,e){let a,i,n,s,r,o,l,h,d,_,f,c,u,w,m,b,g,p,k,v,y,x,z,A;const E=t.state;a=t.next_in,z=t.input,i=a+(t.avail_in-5),n=t.next_out,A=t.output,s=n-(e-t.avail_out),r=n+(t.avail_out-257),o=E.dmax,l=E.wsize,h=E.whave,d=E.wnext,_=E.window,f=E.hold,c=E.bits,u=E.lencode,w=E.distcode,m=(1<<E.lenbits)-1,b=(1<<E.distbits)-1;t:do{c<15&&(f+=z[a++]<<c,c+=8,f+=z[a++]<<c,c+=8),g=u[f&m];e:for(;;){if(p=g>>>24,f>>>=p,c-=p,p=g>>>16&255,0===p)A[n++]=65535&g;else{if(!(16&p)){if(0==(64&p)){g=u[(65535&g)+(f&(1<<p)-1)];continue e}if(32&p){E.mode=16191;break t}t.msg="invalid literal/length code",E.mode=16209;break t}k=65535&g,p&=15,p&&(c<p&&(f+=z[a++]<<c,c+=8),k+=f&(1<<p)-1,f>>>=p,c-=p),c<15&&(f+=z[a++]<<c,c+=8,f+=z[a++]<<c,c+=8),g=w[f&b];a:for(;;){if(p=g>>>24,f>>>=p,c-=p,p=g>>>16&255,!(16&p)){if(0==(64&p)){g=w[(65535&g)+(f&(1<<p)-1)];continue a}t.msg="invalid distance code",E.mode=16209;break t}if(v=65535&g,p&=15,c<p&&(f+=z[a++]<<c,c+=8,c<p&&(f+=z[a++]<<c,c+=8)),v+=f&(1<<p)-1,v>o){t.msg="invalid distance too far back",E.mode=16209;break t}if(f>>>=p,c-=p,p=n-s,v>p){if(p=v-p,p>h&&E.sane){t.msg="invalid distance too far back",E.mode=16209;break t}if(y=0,x=_,0===d){if(y+=l-p,p<k){k-=p;do{A[n++]=_[y++]}while(--p);y=n-v,x=A}}else if(d<p){if(y+=l+d-p,p-=d,p<k){k-=p;do{A[n++]=_[y++]}while(--p);if(y=0,d<k){p=d,k-=p;do{A[n++]=_[y++]}while(--p);y=n-v,x=A}}}else if(y+=d-p,p<k){k-=p;do{A[n++]=_[y++]}while(--p);y=n-v,x=A}for(;k>2;)A[n++]=x[y++],A[n++]=x[y++],A[n++]=x[y++],k-=3;k&&(A[n++]=x[y++],k>1&&(A[n++]=x[y++]))}else{y=n-v;do{A[n++]=A[y++],A[n++]=A[y++],A[n++]=A[y++],k-=3}while(k>2);k&&(A[n++]=A[y++],k>1&&(A[n++]=A[y++]))}break}}break}}while(a<i&&n<r);k=c>>3,a-=k,c-=k<<3,f&=(1<<c)-1,t.next_in=a,t.next_out=n,t.avail_in=a<i?i-a+5:5-(a-i),t.avail_out=n<r?r-n+257:257-(n-r),E.hold=f,E.bits=c};const te=new Uint16Array([3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0]),ee=new Uint8Array([16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78]),ae=new Uint16Array([1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0]),ie=new Uint8Array([16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64]);var ne=(t,e,a,i,n,s,r,o)=>{const l=o.bits;let h,d,_,f,c,u,w=0,m=0,b=0,g=0,p=0,k=0,v=0,y=0,x=0,z=0,A=null;const E=new Uint16Array(16),R=new Uint16Array(16);let Z,U,S,D=null;for(w=0;w<=15;w++)E[w]=0;for(m=0;m<i;m++)E[e[a+m]]++;for(p=l,g=15;g>=1&&0===E[g];g--);if(p>g&&(p=g),0===g)return n[s++]=20971520,n[s++]=20971520,o.bits=1,0;for(b=1;b<g&&0===E[b];b++);for(p<b&&(p=b),y=1,w=1;w<=15;w++)if(y<<=1,y-=E[w],y<0)return-1;if(y>0&&(0===t||1!==g))return-1;for(R[1]=0,w=1;w<15;w++)R[w+1]=R[w]+E[w];for(m=0;m<i;m++)0!==e[a+m]&&(r[R[e[a+m]]++]=m);if(0===t?(A=D=r,u=20):1===t?(A=te,D=ee,u=257):(A=ae,D=ie,u=0),z=0,m=0,w=b,c=s,k=p,v=0,_=-1,x=1<<p,f=x-1,1===t&&x>852||2===t&&x>592)return 1;for(;;){Z=w-v,r[m]+1<u?(U=0,S=r[m]):r[m]>=u?(U=D[r[m]-u],S=A[r[m]-u]):(U=96,S=0),h=1<<w-v,d=1<<k,b=d;do{d-=h,n[c+(z>>v)+d]=Z<<24|U<<16|S|0}while(0!==d);for(h=1<<w-1;z&h;)h>>=1;if(0!==h?(z&=h-1,z+=h):z=0,m++,0==--E[w]){if(w===g)break;w=e[a+r[m]]}if(w>p&&(z&f)!==_){for(0===v&&(v=p),c+=b,k=w-v,y=1<<k;k+v<g&&(y-=E[k+v],!(y<=0));)k++,y<<=1;if(x+=1<<k,1===t&&x>852||2===t&&x>592)return 1;_=z&f,n[_]=p<<24|k<<16|c-s|0}}return 0!==z&&(n[c+z]=w-v<<24|64<<16|0),o.bits=p,0};const{Z_FINISH:se,Z_BLOCK:re,Z_TREES:oe,Z_OK:le,Z_STREAM_END:he,Z_NEED_DICT:de,Z_STREAM_ERROR:_e,Z_DATA_ERROR:fe,Z_MEM_ERROR:ce,Z_BUF_ERROR:ue,Z_DEFLATED:we}=B,me=16209,be=t=>(t>>>24&255)+(t>>>8&65280)+((65280&t)<<8)+((255&t)<<24);function ge(){this.strm=null,this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new Uint16Array(320),this.work=new Uint16Array(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}const pe=t=>{if(!t)return 1;const e=t.state;return!e||e.strm!==t||e.mode<16180||e.mode>16211?1:0},ke=t=>{if(pe(t))return _e;const e=t.state;return t.total_in=t.total_out=e.total=0,t.msg="",e.wrap&&(t.adler=1&e.wrap),e.mode=16180,e.last=0,e.havedict=0,e.flags=-1,e.dmax=32768,e.head=null,e.hold=0,e.bits=0,e.lencode=e.lendyn=new Int32Array(852),e.distcode=e.distdyn=new Int32Array(592),e.sane=1,e.back=-1,le},ve=t=>{if(pe(t))return _e;const e=t.state;return e.wsize=0,e.whave=0,e.wnext=0,ke(t)},ye=(t,e)=>{let a;if(pe(t))return _e;const i=t.state;return e<0?(a=0,e=-e):(a=5+(e>>4),e<48&&(e&=15)),e&&(e<8||e>15)?_e:(null!==i.window&&i.wbits!==e&&(i.window=null),i.wrap=a,i.wbits=e,ve(t))},xe=(t,e)=>{if(!t)return _e;const a=new ge;t.state=a,a.strm=t,a.window=null,a.mode=16180;const i=ye(t,e);return i!==le&&(t.state=null),i};let ze,Ae,Ee=!0;const Re=t=>{if(Ee){ze=new Int32Array(512),Ae=new Int32Array(32);let e=0;for(;e<144;)t.lens[e++]=8;for(;e<256;)t.lens[e++]=9;for(;e<280;)t.lens[e++]=7;for(;e<288;)t.lens[e++]=8;for(ne(1,t.lens,0,288,ze,0,t.work,{bits:9}),e=0;e<32;)t.lens[e++]=5;ne(2,t.lens,0,32,Ae,0,t.work,{bits:5}),Ee=!1}t.lencode=ze,t.lenbits=9,t.distcode=Ae,t.distbits=5},Ze=(t,e,a,i)=>{let n;const s=t.state;return null===s.window&&(s.wsize=1<<s.wbits,s.wnext=0,s.whave=0,s.window=new Uint8Array(s.wsize)),i>=s.wsize?(s.window.set(e.subarray(a-s.wsize,a),0),s.wnext=0,s.whave=s.wsize):(n=s.wsize-s.wnext,n>i&&(n=i),s.window.set(e.subarray(a-i,a-i+n),s.wnext),(i-=n)?(s.window.set(e.subarray(a-i,a),0),s.wnext=i,s.whave=s.wsize):(s.wnext+=n,s.wnext===s.wsize&&(s.wnext=0),s.whave<s.wsize&&(s.whave+=n))),0};var Ue={inflateReset:ve,inflateReset2:ye,inflateResetKeep:ke,inflateInit:t=>xe(t,15),inflateInit2:xe,inflate:(t,e)=>{let a,i,n,s,r,o,l,h,d,_,f,c,u,w,m,b,g,p,k,v,y,x,z=0;const A=new Uint8Array(4);let E,R;const Z=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]);if(pe(t)||!t.output||!t.input&&0!==t.avail_in)return _e;a=t.state,16191===a.mode&&(a.mode=16192),r=t.next_out,n=t.output,l=t.avail_out,s=t.next_in,i=t.input,o=t.avail_in,h=a.hold,d=a.bits,_=o,f=l,x=le;t:for(;;)switch(a.mode){case 16180:if(0===a.wrap){a.mode=16192;break}for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(2&a.wrap&&35615===h){0===a.wbits&&(a.wbits=15),a.check=0,A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0),h=0,d=0,a.mode=16181;break}if(a.head&&(a.head.done=!1),!(1&a.wrap)||(((255&h)<<8)+(h>>8))%31){t.msg="incorrect header check",a.mode=me;break}if((15&h)!==we){t.msg="unknown compression method",a.mode=me;break}if(h>>>=4,d-=4,y=8+(15&h),0===a.wbits&&(a.wbits=y),y>15||y>a.wbits){t.msg="invalid window size",a.mode=me;break}a.dmax=1<<a.wbits,a.flags=0,t.adler=a.check=1,a.mode=512&h?16189:16191,h=0,d=0;break;case 16181:for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(a.flags=h,(255&a.flags)!==we){t.msg="unknown compression method",a.mode=me;break}if(57344&a.flags){t.msg="unknown header flags set",a.mode=me;break}a.head&&(a.head.text=h>>8&1),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0)),h=0,d=0,a.mode=16182;case 16182:for(;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.head&&(a.head.time=h),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,A[2]=h>>>16&255,A[3]=h>>>24&255,a.check=N(a.check,A,4,0)),h=0,d=0,a.mode=16183;case 16183:for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.head&&(a.head.xflags=255&h,a.head.os=h>>8),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0)),h=0,d=0,a.mode=16184;case 16184:if(1024&a.flags){for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.length=h,a.head&&(a.head.extra_len=h),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0)),h=0,d=0}else a.head&&(a.head.extra=null);a.mode=16185;case 16185:if(1024&a.flags&&(c=a.length,c>o&&(c=o),c&&(a.head&&(y=a.head.extra_len-a.length,a.head.extra||(a.head.extra=new Uint8Array(a.head.extra_len)),a.head.extra.set(i.subarray(s,s+c),y)),512&a.flags&&4&a.wrap&&(a.check=N(a.check,i,c,s)),o-=c,s+=c,a.length-=c),a.length))break t;a.length=0,a.mode=16186;case 16186:if(2048&a.flags){if(0===o)break t;c=0;do{y=i[s+c++],a.head&&y&&a.length<65536&&(a.head.name+=String.fromCharCode(y))}while(y&&c<o);if(512&a.flags&&4&a.wrap&&(a.check=N(a.check,i,c,s)),o-=c,s+=c,y)break t}else a.head&&(a.head.name=null);a.length=0,a.mode=16187;case 16187:if(4096&a.flags){if(0===o)break t;c=0;do{y=i[s+c++],a.head&&y&&a.length<65536&&(a.head.comment+=String.fromCharCode(y))}while(y&&c<o);if(512&a.flags&&4&a.wrap&&(a.check=N(a.check,i,c,s)),o-=c,s+=c,y)break t}else a.head&&(a.head.comment=null);a.mode=16188;case 16188:if(512&a.flags){for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(4&a.wrap&&h!==(65535&a.check)){t.msg="header crc mismatch",a.mode=me;break}h=0,d=0}a.head&&(a.head.hcrc=a.flags>>9&1,a.head.done=!0),t.adler=a.check=0,a.mode=16191;break;case 16189:for(;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}t.adler=a.check=be(h),h=0,d=0,a.mode=16190;case 16190:if(0===a.havedict)return t.next_out=r,t.avail_out=l,t.next_in=s,t.avail_in=o,a.hold=h,a.bits=d,de;t.adler=a.check=1,a.mode=16191;case 16191:if(e===re||e===oe)break t;case 16192:if(a.last){h>>>=7&d,d-=7&d,a.mode=16206;break}for(;d<3;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}switch(a.last=1&h,h>>>=1,d-=1,3&h){case 0:a.mode=16193;break;case 1:if(Re(a),a.mode=16199,e===oe){h>>>=2,d-=2;break t}break;case 2:a.mode=16196;break;case 3:t.msg="invalid block type",a.mode=me}h>>>=2,d-=2;break;case 16193:for(h>>>=7&d,d-=7&d;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if((65535&h)!=(h>>>16^65535)){t.msg="invalid stored block lengths",a.mode=me;break}if(a.length=65535&h,h=0,d=0,a.mode=16194,e===oe)break t;case 16194:a.mode=16195;case 16195:if(c=a.length,c){if(c>o&&(c=o),c>l&&(c=l),0===c)break t;n.set(i.subarray(s,s+c),r),o-=c,s+=c,l-=c,r+=c,a.length-=c;break}a.mode=16191;break;case 16196:for(;d<14;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(a.nlen=257+(31&h),h>>>=5,d-=5,a.ndist=1+(31&h),h>>>=5,d-=5,a.ncode=4+(15&h),h>>>=4,d-=4,a.nlen>286||a.ndist>30){t.msg="too many length or distance symbols",a.mode=me;break}a.have=0,a.mode=16197;case 16197:for(;a.have<a.ncode;){for(;d<3;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.lens[Z[a.have++]]=7&h,h>>>=3,d-=3}for(;a.have<19;)a.lens[Z[a.have++]]=0;if(a.lencode=a.lendyn,a.lenbits=7,E={bits:a.lenbits},x=ne(0,a.lens,0,19,a.lencode,0,a.work,E),a.lenbits=E.bits,x){t.msg="invalid code lengths set",a.mode=me;break}a.have=0,a.mode=16198;case 16198:for(;a.have<a.nlen+a.ndist;){for(;z=a.lencode[h&(1<<a.lenbits)-1],m=z>>>24,b=z>>>16&255,g=65535&z,!(m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(g<16)h>>>=m,d-=m,a.lens[a.have++]=g;else{if(16===g){for(R=m+2;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(h>>>=m,d-=m,0===a.have){t.msg="invalid bit length repeat",a.mode=me;break}y=a.lens[a.have-1],c=3+(3&h),h>>>=2,d-=2}else if(17===g){for(R=m+3;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=m,d-=m,y=0,c=3+(7&h),h>>>=3,d-=3}else{for(R=m+7;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=m,d-=m,y=0,c=11+(127&h),h>>>=7,d-=7}if(a.have+c>a.nlen+a.ndist){t.msg="invalid bit length repeat",a.mode=me;break}for(;c--;)a.lens[a.have++]=y}}if(a.mode===me)break;if(0===a.lens[256]){t.msg="invalid code -- missing end-of-block",a.mode=me;break}if(a.lenbits=9,E={bits:a.lenbits},x=ne(1,a.lens,0,a.nlen,a.lencode,0,a.work,E),a.lenbits=E.bits,x){t.msg="invalid literal/lengths set",a.mode=me;break}if(a.distbits=6,a.distcode=a.distdyn,E={bits:a.distbits},x=ne(2,a.lens,a.nlen,a.ndist,a.distcode,0,a.work,E),a.distbits=E.bits,x){t.msg="invalid distances set",a.mode=me;break}if(a.mode=16199,e===oe)break t;case 16199:a.mode=16200;case 16200:if(o>=6&&l>=258){t.next_out=r,t.avail_out=l,t.next_in=s,t.avail_in=o,a.hold=h,a.bits=d,$t(t,f),r=t.next_out,n=t.output,l=t.avail_out,s=t.next_in,i=t.input,o=t.avail_in,h=a.hold,d=a.bits,16191===a.mode&&(a.back=-1);break}for(a.back=0;z=a.lencode[h&(1<<a.lenbits)-1],m=z>>>24,b=z>>>16&255,g=65535&z,!(m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(b&&0==(240&b)){for(p=m,k=b,v=g;z=a.lencode[v+((h&(1<<p+k)-1)>>p)],m=z>>>24,b=z>>>16&255,g=65535&z,!(p+m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=p,d-=p,a.back+=p}if(h>>>=m,d-=m,a.back+=m,a.length=g,0===b){a.mode=16205;break}if(32&b){a.back=-1,a.mode=16191;break}if(64&b){t.msg="invalid literal/length code",a.mode=me;break}a.extra=15&b,a.mode=16201;case 16201:if(a.extra){for(R=a.extra;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.length+=h&(1<<a.extra)-1,h>>>=a.extra,d-=a.extra,a.back+=a.extra}a.was=a.length,a.mode=16202;case 16202:for(;z=a.distcode[h&(1<<a.distbits)-1],m=z>>>24,b=z>>>16&255,g=65535&z,!(m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(0==(240&b)){for(p=m,k=b,v=g;z=a.distcode[v+((h&(1<<p+k)-1)>>p)],m=z>>>24,b=z>>>16&255,g=65535&z,!(p+m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=p,d-=p,a.back+=p}if(h>>>=m,d-=m,a.back+=m,64&b){t.msg="invalid distance code",a.mode=me;break}a.offset=g,a.extra=15&b,a.mode=16203;case 16203:if(a.extra){for(R=a.extra;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.offset+=h&(1<<a.extra)-1,h>>>=a.extra,d-=a.extra,a.back+=a.extra}if(a.offset>a.dmax){t.msg="invalid distance too far back",a.mode=me;break}a.mode=16204;case 16204:if(0===l)break t;if(c=f-l,a.offset>c){if(c=a.offset-c,c>a.whave&&a.sane){t.msg="invalid distance too far back",a.mode=me;break}c>a.wnext?(c-=a.wnext,u=a.wsize-c):u=a.wnext-c,c>a.length&&(c=a.length),w=a.window}else w=n,u=r-a.offset,c=a.length;c>l&&(c=l),l-=c,a.length-=c;do{n[r++]=w[u++]}while(--c);0===a.length&&(a.mode=16200);break;case 16205:if(0===l)break t;n[r++]=a.length,l--,a.mode=16200;break;case 16206:if(a.wrap){for(;d<32;){if(0===o)break t;o--,h|=i[s++]<<d,d+=8}if(f-=l,t.total_out+=f,a.total+=f,4&a.wrap&&f&&(t.adler=a.check=a.flags?N(a.check,n,f,r-f):F(a.check,n,f,r-f)),f=l,4&a.wrap&&(a.flags?h:be(h))!==a.check){t.msg="incorrect data check",a.mode=me;break}h=0,d=0}a.mode=16207;case 16207:if(a.wrap&&a.flags){for(;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(4&a.wrap&&h!==(4294967295&a.total)){t.msg="incorrect length check",a.mode=me;break}h=0,d=0}a.mode=16208;case 16208:x=he;break t;case me:x=fe;break t;case 16210:return ce;default:return _e}return t.next_out=r,t.avail_out=l,t.next_in=s,t.avail_in=o,a.hold=h,a.bits=d,(a.wsize||f!==t.avail_out&&a.mode<me&&(a.mode<16206||e!==se))&&Ze(t,t.output,t.next_out,f-t.avail_out),_-=t.avail_in,f-=t.avail_out,t.total_in+=_,t.total_out+=f,a.total+=f,4&a.wrap&&f&&(t.adler=a.check=a.flags?N(a.check,n,f,t.next_out-f):F(a.check,n,f,t.next_out-f)),t.data_type=a.bits+(a.last?64:0)+(16191===a.mode?128:0)+(16199===a.mode||16194===a.mode?256:0),(0===_&&0===f||e===se)&&x===le&&(x=ue),x},inflateEnd:t=>{if(pe(t))return _e;let e=t.state;return e.window&&(e.window=null),t.state=null,le},inflateGetHeader:(t,e)=>{if(pe(t))return _e;const a=t.state;return 0==(2&a.wrap)?_e:(a.head=e,e.done=!1,le)},inflateSetDictionary:(t,e)=>{const a=e.length;let i,n,s;return pe(t)?_e:(i=t.state,0!==i.wrap&&16190!==i.mode?_e:16190===i.mode&&(n=1,n=F(n,e,a,0),n!==i.check)?fe:(s=Ze(t,e,a,a),s?(i.mode=16210,ce):(i.havedict=1,le)))},inflateInfo:"pako inflate (from Nodeca project)"};var Se=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1};const De=Object.prototype.toString,{Z_NO_FLUSH:Te,Z_FINISH:Oe,Z_OK:Fe,Z_STREAM_END:Le,Z_NEED_DICT:Ne,Z_STREAM_ERROR:Ie,Z_DATA_ERROR:Be,Z_MEM_ERROR:Ce}=B;function He(t){this.options=Tt({chunkSize:65536,windowBits:15,to:""},t||{});const e=this.options;e.raw&&e.windowBits>=0&&e.windowBits<16&&(e.windowBits=-e.windowBits,0===e.windowBits&&(e.windowBits=-15)),!(e.windowBits>=0&&e.windowBits<16)||t&&t.windowBits||(e.windowBits+=32),e.windowBits>15&&e.windowBits<48&&0==(15&e.windowBits)&&(e.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;let a=Ue.inflateInit2(this.strm,e.windowBits);if(a!==Fe)throw new Error(I[a]);if(this.header=new Se,Ue.inflateGetHeader(this.strm,this.header),e.dictionary&&("string"==typeof e.dictionary?e.dictionary=Nt(e.dictionary):"[object ArrayBuffer]"===De.call(e.dictionary)&&(e.dictionary=new Uint8Array(e.dictionary)),e.raw&&(a=Ue.inflateSetDictionary(this.strm,e.dictionary),a!==Fe)))throw new Error(I[a])}He.prototype.push=function(t,e){const a=this.strm,i=this.options.chunkSize,n=this.options.dictionary;let s,r,o;if(this.ended)return!1;for(r=e===~~e?e:!0===e?Oe:Te,"[object ArrayBuffer]"===De.call(t)?a.input=new Uint8Array(t):a.input=t,a.next_in=0,a.avail_in=a.input.length;;){for(0===a.avail_out&&(a.output=new Uint8Array(i),a.next_out=0,a.avail_out=i),s=Ue.inflate(a,r),s===Ne&&n&&(s=Ue.inflateSetDictionary(a,n),s===Fe?s=Ue.inflate(a,r):s===Be&&(s=Ne));a.avail_in>0&&s===Le&&a.state.wrap>0&&0!==t[a.next_in];)Ue.inflateReset(a),s=Ue.inflate(a,r);switch(s){case Ie:case Be:case Ne:case Ce:return this.onEnd(s),this.ended=!0,!1}if(o=a.avail_out,a.next_out&&(0===a.avail_out||s===Le))if("string"===this.options.to){let t=Bt(a.output,a.next_out),e=a.next_out-t,n=It(a.output,t);a.next_out=e,a.avail_out=i-e,e&&a.output.set(a.output.subarray(t,t+e),0),this.onData(n)}else this.onData(a.output.length===a.next_out?a.output:a.output.subarray(0,a.next_out));if(s!==Fe||0!==o){if(s===Le)return s=Ue.inflateEnd(this.strm),this.onEnd(s),this.ended=!0,!0;if(0===a.avail_in)break}}return!0},He.prototype.onData=function(t){this.chunks.push(t)},He.prototype.onEnd=function(t){t===Fe&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=Ot(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg};const{Deflate:Me,deflate:je,deflateRaw:Ke,gzip:Pe}=Vt;var Ye=Me,Ge=je,Xe=B;const We=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const e=this._hasEvents?",":"";this.deflate.push(e+t,Xe.Z_SYNC_FLUSH),this._hasEvents=!0}finish(){if(this.deflate.push("]",Xe.Z_FINISH),this.deflate.err)throw this.deflate.err;const t=this.deflate.result;return this._init(),t}_init(){this._hasEvents=!1,this.deflate=new Ye,this.deflate.push("[",Xe.Z_NO_FLUSH)}},qe={clear:()=>{We.clear()},addEvent:t=>We.addEvent(t),finish:()=>We.finish(),compress:t=>function(t){return Ge(t)}(t)};addEventListener("message",(function(t){const e=t.data.method,a=t.data.id,i=t.data.arg;if(e in qe&&"function"==typeof qe[e])try{const t=qe[e](i);postMessage({id:a,method:e,success:!0,response:t})}catch(t){postMessage({id:a,method:e,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $43b02a39892a2119$var$e() {
    const e = new Blob([
        $43b02a39892a2119$var$r
    ]);
    return URL.createObjectURL(e);
}
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $43b02a39892a2119$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $43b02a39892a2119$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ constructor(){
        this.events = [];
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return "sync";
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.events = [];
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $43b02a39892a2119$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $43b02a39892a2119$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener("message", ({ data: data  })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener("error", (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Replay] Destroying compression worker");
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data  })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener("message", listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error("[Replay]", response.response);
                    reject(new Error("Error in compression worker"));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener("message", listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $43b02a39892a2119$var$EventBufferCompressionWorker {
    constructor(worker){
        this._worker = new $43b02a39892a2119$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return "worker";
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */ addEvent(event) {
        const timestamp = $43b02a39892a2119$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        return this._sendEventToWorker(event);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._worker.postMessage("clear");
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(event) {
        return this._worker.postMessage("addEvent", JSON.stringify(event));
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage("finish");
        this._earliestTimestamp = null;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $43b02a39892a2119$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $43b02a39892a2119$var$EventBufferArray();
        this._compression = new $43b02a39892a2119$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Replay] Failed to load the compression worker, falling back to simple buffer");
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events  } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
        } catch (error) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn("[Replay] Failed to add events when switching buffers.", error);
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $43b02a39892a2119$var$createEventBuffer({ useCompression: useCompression  }) {
    // eslint-disable-next-line no-restricted-globals
    if (useCompression && window.Worker) try {
        const workerUrl = $43b02a39892a2119$var$e();
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Replay] Using compression worker");
        const worker = new Worker(workerUrl);
        return new $43b02a39892a2119$var$EventBufferProxy(worker);
    } catch (error) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Replay] Failed to create compression worker");
    // Fall back to use simple event buffer array
    }
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Replay] Using simple buffer");
    return new $43b02a39892a2119$var$EventBufferArray();
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $43b02a39892a2119$var$clearSession(replay) {
    $43b02a39892a2119$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $43b02a39892a2119$var$deleteSession() {
    const hasSessionStorage = "sessionStorage" in $43b02a39892a2119$var$WINDOW;
    if (!hasSessionStorage) return;
    try {
        $43b02a39892a2119$var$WINDOW.sessionStorage.removeItem($43b02a39892a2119$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $43b02a39892a2119$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $43b02a39892a2119$var$isSessionExpired(session, timeouts, targetTime = +new Date()) {
    return(// First, check that maximum session length has not been exceeded
    $43b02a39892a2119$var$isExpired(session.started, timeouts.maxSessionLife, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $43b02a39892a2119$var$isExpired(session.lastActivity, timeouts.sessionIdleExpire, targetTime));
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $43b02a39892a2119$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Save a session to session storage.
 */ function $43b02a39892a2119$var$saveSession(session) {
    const hasSessionStorage = "sessionStorage" in $43b02a39892a2119$var$WINDOW;
    if (!hasSessionStorage) return;
    try {
        $43b02a39892a2119$var$WINDOW.sessionStorage.setItem($43b02a39892a2119$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get a session with defaults & applied sampling.
 */ function $43b02a39892a2119$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $iMHif.uuid4)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        shouldRefresh: true
    };
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $43b02a39892a2119$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $43b02a39892a2119$var$isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $43b02a39892a2119$var$createSession({ sessionSampleRate: sessionSampleRate , allowBuffering: allowBuffering , stickySession: stickySession = false  }) {
    const sampled = $43b02a39892a2119$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $43b02a39892a2119$var$makeSession({
        sampled: sampled
    });
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log(`[Replay] Creating new session: ${session.id}`);
    if (stickySession) $43b02a39892a2119$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $43b02a39892a2119$var$fetchSession() {
    const hasSessionStorage = "sessionStorage" in $43b02a39892a2119$var$WINDOW;
    if (!hasSessionStorage) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $43b02a39892a2119$var$WINDOW.sessionStorage.getItem($43b02a39892a2119$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        return $43b02a39892a2119$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Get or create a session
 */ function $43b02a39892a2119$var$getSession({ timeouts: timeouts , currentSession: currentSession , stickySession: stickySession , sessionSampleRate: sessionSampleRate , allowBuffering: allowBuffering  }) {
    // If session exists and is passed, use it instead of always hitting session storage
    const session = currentSession || stickySession && $43b02a39892a2119$var$fetchSession();
    if (session) {
        // If there is a session, check if it is valid (e.g. "last activity" time
        // should be within the "session idle time", and "session started" time is
        // within "max session time").
        const isExpired = $43b02a39892a2119$var$isSessionExpired(session, timeouts);
        if (!isExpired) return {
            type: "saved",
            session: session
        };
        else if (!session.shouldRefresh) {
            // In this case, stop
            // This is the case if we have an error session that is completed (=triggered an error)
            const discardedSession = $43b02a39892a2119$var$makeSession({
                sampled: false
            });
            return {
                type: "new",
                session: discardedSession
            };
        } else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Replay] Session has expired");
    // Otherwise continue to create a new session
    }
    const newSession = $43b02a39892a2119$var$createSession({
        stickySession: stickySession,
        sessionSampleRate: sessionSampleRate,
        allowBuffering: allowBuffering
    });
    return {
        type: "new",
        session: newSession
    };
}
/* eslint-disable @typescript-eslint/naming-convention */ var $43b02a39892a2119$var$EventType;
(function(EventType) {
    const DomContentLoaded = 0;
    EventType[EventType["DomContentLoaded"] = DomContentLoaded] = "DomContentLoaded";
    const Load = 1;
    EventType[EventType["Load"] = Load] = "Load";
    const FullSnapshot = 2;
    EventType[EventType["FullSnapshot"] = FullSnapshot] = "FullSnapshot";
    const IncrementalSnapshot = 3;
    EventType[EventType["IncrementalSnapshot"] = IncrementalSnapshot] = "IncrementalSnapshot";
    const Meta = 4;
    EventType[EventType["Meta"] = Meta] = "Meta";
    const Custom = 5;
    EventType[EventType["Custom"] = Custom] = "Custom";
    const Plugin = 6;
    EventType[EventType["Plugin"] = Plugin] = "Plugin";
})($43b02a39892a2119$var$EventType || ($43b02a39892a2119$var$EventType = {}));
/**
 * This is a partial copy of rrweb's eventWithTime type which only contains the properties
 * we specifcally need in the SDK.
 */ /**
 * Add an event to the event buffer.
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ async function $43b02a39892a2119$var$addEvent(replay, event, isCheckout) {
    if (!replay.eventBuffer) // This implies that `_isEnabled` is false
    return null;
    if (replay.isPaused()) // Do not add to event buffer when recording is paused
    return null;
    const timestampInMs = $43b02a39892a2119$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return null;
    try {
        if (isCheckout) replay.eventBuffer.clear();
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = typeof replayOptions.beforeAddRecordingEvent === "function" && event.type === $43b02a39892a2119$var$EventType.Custom ? replayOptions.beforeAddRecordingEvent(event) : event;
        if (!eventAfterPossibleCallback) return;
        return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error(error);
        await replay.stop("addEvent");
        const client = (0, $kDFdm.getCurrentHub)().getClient();
        if (client) client.recordDroppedEvent("internal_sdk_error", "replay");
    }
}
/** If the event is an error event */ function $43b02a39892a2119$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $43b02a39892a2119$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/** If the event is an replay event */ function $43b02a39892a2119$var$isReplayEvent(event) {
    return event.type === "replay_event";
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $43b02a39892a2119$var$handleAfterSendEvent(replay) {
    // Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
    // TODO (v8): remove this check as it will no longer be necessary
    const enforceStatusCode = $43b02a39892a2119$var$isBaseTransportSend();
    return (event, sendResponse)=>{
        if (!$43b02a39892a2119$var$isErrorEvent(event) && !$43b02a39892a2119$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (enforceStatusCode && (!statusCode || statusCode < 200 || statusCode >= 300)) return;
        // Collect traceIds in _context regardless of `recordingMode`
        // In error mode, _context gets cleared on every checkout
        if ($43b02a39892a2119$var$isTransactionEvent(event) && event.contexts && event.contexts.trace && event.contexts.trace.trace_id) {
            replay.getContext().traceIds.add(event.contexts.trace.trace_id);
            return;
        }
        // Everything below is just for error events
        if (!$43b02a39892a2119$var$isErrorEvent(event)) return;
        // Add error to list of errorIds of replay. This is ok to do even if not
        // sampled because context will get reset at next checkout.
        // XXX: There is also a race condition where it's possible to capture an
        // error to Sentry before Replay SDK has loaded, but response returns after
        // it was loaded, and this gets called.
        if (event.event_id) replay.getContext().errorIds.add(event.event_id);
        // If error event is tagged with replay id it means it was sampled (when in buffer mode)
        // Need to be very careful that this does not cause an infinite loop
        if (replay.recordingMode === "buffer" && event.tags && event.tags.replayId) setTimeout(()=>{
            replay.sendBufferedReplayOrFlush();
        });
    };
}
function $43b02a39892a2119$var$isBaseTransportSend() {
    const client = (0, $kDFdm.getCurrentHub)().getClient();
    if (!client) return false;
    const transport = client.getTransport();
    if (!transport) return false;
    return transport.send.__sentry__baseTransport__ || false;
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $43b02a39892a2119$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-ignore this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    // Check if any exception originates from rrweb
    return event.exception.values.some((exception)=>{
        if (!exception.stacktrace || !exception.stacktrace.frames || !exception.stacktrace.frames.length) return false;
        return exception.stacktrace.frames.some((frame)=>frame.filename && frame.filename.includes("/rrweb/src/"));
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $43b02a39892a2119$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== "buffer") return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $43b02a39892a2119$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $43b02a39892a2119$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addGlobalEventProcessor(listener)`.
 */ function $43b02a39892a2119$var$handleGlobalEventListener(replay, includeAfterSendEventHandling = false) {
    const afterSendHandler = includeAfterSendEventHandling ? $43b02a39892a2119$var$handleAfterSendEvent(replay) : undefined;
    return (event, hint)=>{
        if ($43b02a39892a2119$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors & transactions, nothing else
        if (!$43b02a39892a2119$var$isErrorEvent(event) && !$43b02a39892a2119$var$isTransactionEvent(event)) return event;
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($43b02a39892a2119$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Replay] Ignoring error from rrweb internals", event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $43b02a39892a2119$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        // In cases where a custom client is used that does not support the new hooks (yet),
        // we manually call this hook method here
        if (afterSendHandler) // Pretend the error had a 200 response so we always capture it
        afterSendHandler(event, {
            statusCode: 200
        });
        return event;
    };
}
/**
 * Create a "span" for each performance entry.
 */ function $43b02a39892a2119$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type , start: start , end: end , name: name , data: data  })=>{
        const response = replay.throttledAddEvent({
            type: $43b02a39892a2119$var$EventType$1.Custom,
            timestamp: start,
            data: {
                tag: "performanceSpan",
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === "string" ? Promise.resolve(null) : response;
    });
}
function $43b02a39892a2119$var$handleHistory(handlerData) {
    const { from: from , to: to  } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: "navigation.push",
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addInstrumentationHandler('history', listener)`.
 */ function $43b02a39892a2119$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $43b02a39892a2119$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $43b02a39892a2119$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $43b02a39892a2119$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && replay.getOptions()._experiments.traceInternals) return false;
    return $43b02a39892a2119$var$_isSentryRequest(url);
}
/**
 * Checks wether a given URL belongs to the configured Sentry DSN.
 */ function $43b02a39892a2119$var$_isSentryRequest(url) {
    const client = (0, $kDFdm.getCurrentHub)().getClient();
    const dsn = client && client.getDsn();
    return dsn ? url.includes(dsn.host) : false;
}
/** Add a performance entry breadcrumb */ function $43b02a39892a2119$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($43b02a39892a2119$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $43b02a39892a2119$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** only exported for tests */ function $43b02a39892a2119$var$handleFetch(handlerData) {
    const { startTimestamp: startTimestamp , endTimestamp: endTimestamp , fetchData: fetchData , response: response  } = handlerData;
    if (!endTimestamp) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method , url: url  } = fetchData;
    return {
        type: "resource.fetch",
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method: method,
            statusCode: response && response.status
        }
    };
}
/**
 * Returns a listener to be added to `addInstrumentationHandler('fetch', listener)`.
 */ function $43b02a39892a2119$var$handleFetchSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $43b02a39892a2119$var$handleFetch(handlerData);
        $43b02a39892a2119$var$addNetworkBreadcrumb(replay, result);
    };
}
/** only exported for tests */ function $43b02a39892a2119$var$handleXhr(handlerData) {
    const { startTimestamp: startTimestamp , endTimestamp: endTimestamp , xhr: xhr  } = handlerData;
    const sentryXhrData = xhr[0, $cIWhk.SENTRY_XHR_DATA_KEY];
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method , url: url , status_code: statusCode  } = sentryXhrData;
    if (url === undefined) return null;
    return {
        type: "resource.xhr",
        name: url,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        data: {
            method: method,
            statusCode: statusCode
        }
    };
}
/**
 * Returns a listener to be added to `addInstrumentationHandler('xhr', listener)`.
 */ function $43b02a39892a2119$var$handleXhrSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $43b02a39892a2119$var$handleXhr(handlerData);
        $43b02a39892a2119$var$addNetworkBreadcrumb(replay, result);
    };
}
const $43b02a39892a2119$var$OBJ = 10;
const $43b02a39892a2119$var$OBJ_KEY = 11;
const $43b02a39892a2119$var$OBJ_KEY_STR = 12;
const $43b02a39892a2119$var$OBJ_VAL = 13;
const $43b02a39892a2119$var$OBJ_VAL_STR = 14;
const $43b02a39892a2119$var$OBJ_VAL_COMPLETED = 15;
const $43b02a39892a2119$var$ARR = 20;
const $43b02a39892a2119$var$ARR_VAL = 21;
const $43b02a39892a2119$var$ARR_VAL_STR = 22;
const $43b02a39892a2119$var$ARR_VAL_COMPLETED = 23;
const $43b02a39892a2119$var$ALLOWED_PRIMITIVES = [
    "true",
    "false",
    "null"
];
/**
 * Complete an incomplete JSON string.
 * This will ensure that the last element always has a `"~~"` to indicate it was truncated.
 * For example, `[1,2,` will be completed to `[1,2,"~~"]`
 * and `{"aa":"b` will be completed to `{"aa":"b~~"}`
 */ function $43b02a39892a2119$var$completeJson(incompleteJson, stack) {
    if (!stack.length) return incompleteJson;
    let json = incompleteJson;
    // Most checks are only needed for the last step in the stack
    const lastPos = stack.length - 1;
    const lastStep = stack[lastPos];
    json = $43b02a39892a2119$var$_fixLastStep(json, lastStep);
    // Complete remaining steps - just add closing brackets
    for(let i = lastPos; i >= 0; i--){
        const step = stack[i];
        switch(step){
            case $43b02a39892a2119$var$OBJ:
                json = `${json}}`;
                break;
            case $43b02a39892a2119$var$ARR:
                json = `${json}]`;
                break;
        }
    }
    return json;
}
function $43b02a39892a2119$var$_fixLastStep(json, lastStep) {
    switch(lastStep){
        // Object cases
        case $43b02a39892a2119$var$OBJ:
            return `${json}"~~":"~~"`;
        case $43b02a39892a2119$var$OBJ_KEY:
            return `${json}:"~~"`;
        case $43b02a39892a2119$var$OBJ_KEY_STR:
            return `${json}~~":"~~"`;
        case $43b02a39892a2119$var$OBJ_VAL:
            return $43b02a39892a2119$var$_maybeFixIncompleteObjValue(json);
        case $43b02a39892a2119$var$OBJ_VAL_STR:
            return `${json}~~"`;
        case $43b02a39892a2119$var$OBJ_VAL_COMPLETED:
            return `${json},"~~":"~~"`;
        // Array cases
        case $43b02a39892a2119$var$ARR:
            return `${json}"~~"`;
        case $43b02a39892a2119$var$ARR_VAL:
            return $43b02a39892a2119$var$_maybeFixIncompleteArrValue(json);
        case $43b02a39892a2119$var$ARR_VAL_STR:
            return `${json}~~"`;
        case $43b02a39892a2119$var$ARR_VAL_COMPLETED:
            return `${json},"~~"`;
    }
    return json;
}
function $43b02a39892a2119$var$_maybeFixIncompleteArrValue(json) {
    const pos = $43b02a39892a2119$var$_findLastArrayDelimiter(json);
    if (pos > -1) {
        const part = json.slice(pos + 1);
        if ($43b02a39892a2119$var$ALLOWED_PRIMITIVES.includes(part.trim())) return `${json},"~~"`;
        // Everything else is replaced with `"~~"`
        return `${json.slice(0, pos + 1)}"~~"`;
    }
    // fallback, this shouldn't happen, to be save
    return json;
}
function $43b02a39892a2119$var$_findLastArrayDelimiter(json) {
    for(let i = json.length - 1; i >= 0; i--){
        const char = json[i];
        if (char === "," || char === "[") return i;
    }
    return -1;
}
function $43b02a39892a2119$var$_maybeFixIncompleteObjValue(json) {
    const startPos = json.lastIndexOf(":");
    const part = json.slice(startPos + 1);
    if ($43b02a39892a2119$var$ALLOWED_PRIMITIVES.includes(part.trim())) return `${json},"~~":"~~"`;
    // Everything else is replaced with `"~~"`
    // This also means we do not have incomplete numbers, e.g `[1` is replaced with `["~~"]`
    return `${json.slice(0, startPos + 1)}"~~"`;
}
/**
 * Evaluate an (incomplete) JSON string.
 */ function $43b02a39892a2119$var$evaluateJson(json) {
    const stack = [];
    for(let pos = 0; pos < json.length; pos++)$43b02a39892a2119$var$_evaluateJsonPos(stack, json, pos);
    return stack;
}
function $43b02a39892a2119$var$_evaluateJsonPos(stack, json, pos) {
    const curStep = stack[stack.length - 1];
    const char = json[pos];
    const whitespaceRegex = /\s/;
    if (whitespaceRegex.test(char)) return;
    if (char === '"' && !$43b02a39892a2119$var$_isEscaped(json, pos)) {
        $43b02a39892a2119$var$_handleQuote(stack, curStep);
        return;
    }
    switch(char){
        case "{":
            $43b02a39892a2119$var$_handleObj(stack, curStep);
            break;
        case "[":
            $43b02a39892a2119$var$_handleArr(stack, curStep);
            break;
        case ":":
            $43b02a39892a2119$var$_handleColon(stack, curStep);
            break;
        case ",":
            $43b02a39892a2119$var$_handleComma(stack, curStep);
            break;
        case "}":
            $43b02a39892a2119$var$_handleObjClose(stack, curStep);
            break;
        case "]":
            $43b02a39892a2119$var$_handleArrClose(stack, curStep);
            break;
    }
}
function $43b02a39892a2119$var$_handleQuote(stack, curStep) {
    // End of obj value
    if (curStep === $43b02a39892a2119$var$OBJ_VAL_STR) {
        stack.pop();
        stack.push($43b02a39892a2119$var$OBJ_VAL_COMPLETED);
        return;
    }
    // End of arr value
    if (curStep === $43b02a39892a2119$var$ARR_VAL_STR) {
        stack.pop();
        stack.push($43b02a39892a2119$var$ARR_VAL_COMPLETED);
        return;
    }
    // Start of obj value
    if (curStep === $43b02a39892a2119$var$OBJ_VAL) {
        stack.push($43b02a39892a2119$var$OBJ_VAL_STR);
        return;
    }
    // Start of arr value
    if (curStep === $43b02a39892a2119$var$ARR_VAL) {
        stack.push($43b02a39892a2119$var$ARR_VAL_STR);
        return;
    }
    // Start of obj key
    if (curStep === $43b02a39892a2119$var$OBJ) {
        stack.push($43b02a39892a2119$var$OBJ_KEY_STR);
        return;
    }
    // End of obj key
    if (curStep === $43b02a39892a2119$var$OBJ_KEY_STR) {
        stack.pop();
        stack.push($43b02a39892a2119$var$OBJ_KEY);
        return;
    }
}
function $43b02a39892a2119$var$_handleObj(stack, curStep) {
    // Initial object
    if (!curStep) {
        stack.push($43b02a39892a2119$var$OBJ);
        return;
    }
    // New object as obj value
    if (curStep === $43b02a39892a2119$var$OBJ_VAL) {
        stack.push($43b02a39892a2119$var$OBJ);
        return;
    }
    // New object as array element
    if (curStep === $43b02a39892a2119$var$ARR_VAL) stack.push($43b02a39892a2119$var$OBJ);
    // New object as first array element
    if (curStep === $43b02a39892a2119$var$ARR) {
        stack.push($43b02a39892a2119$var$OBJ);
        return;
    }
}
function $43b02a39892a2119$var$_handleArr(stack, curStep) {
    // Initial array
    if (!curStep) {
        stack.push($43b02a39892a2119$var$ARR);
        stack.push($43b02a39892a2119$var$ARR_VAL);
        return;
    }
    // New array as obj value
    if (curStep === $43b02a39892a2119$var$OBJ_VAL) {
        stack.push($43b02a39892a2119$var$ARR);
        stack.push($43b02a39892a2119$var$ARR_VAL);
        return;
    }
    // New array as array element
    if (curStep === $43b02a39892a2119$var$ARR_VAL) {
        stack.push($43b02a39892a2119$var$ARR);
        stack.push($43b02a39892a2119$var$ARR_VAL);
    }
    // New array as first array element
    if (curStep === $43b02a39892a2119$var$ARR) {
        stack.push($43b02a39892a2119$var$ARR);
        stack.push($43b02a39892a2119$var$ARR_VAL);
        return;
    }
}
function $43b02a39892a2119$var$_handleColon(stack, curStep) {
    if (curStep === $43b02a39892a2119$var$OBJ_KEY) {
        stack.pop();
        stack.push($43b02a39892a2119$var$OBJ_VAL);
    }
}
function $43b02a39892a2119$var$_handleComma(stack, curStep) {
    // Comma after obj value
    if (curStep === $43b02a39892a2119$var$OBJ_VAL) {
        stack.pop();
        return;
    }
    if (curStep === $43b02a39892a2119$var$OBJ_VAL_COMPLETED) {
        // Pop OBJ_VAL_COMPLETED & OBJ_VAL
        stack.pop();
        stack.pop();
        return;
    }
    // Comma after arr value
    if (curStep === $43b02a39892a2119$var$ARR_VAL) // do nothing - basically we'd pop ARR_VAL but add it right back
    return;
    if (curStep === $43b02a39892a2119$var$ARR_VAL_COMPLETED) {
        // Pop ARR_VAL_COMPLETED
        stack.pop();
        // basically we'd pop ARR_VAL but add it right back
        return;
    }
}
function $43b02a39892a2119$var$_handleObjClose(stack, curStep) {
    // Empty object {}
    if (curStep === $43b02a39892a2119$var$OBJ) stack.pop();
    // Object with element
    if (curStep === $43b02a39892a2119$var$OBJ_VAL) {
        // Pop OBJ_VAL, OBJ
        stack.pop();
        stack.pop();
    }
    // Obj with element
    if (curStep === $43b02a39892a2119$var$OBJ_VAL_COMPLETED) {
        // Pop OBJ_VAL_COMPLETED, OBJ_VAL, OBJ
        stack.pop();
        stack.pop();
        stack.pop();
    }
    // if was obj value, complete it
    if (stack[stack.length - 1] === $43b02a39892a2119$var$OBJ_VAL) stack.push($43b02a39892a2119$var$OBJ_VAL_COMPLETED);
    // if was arr value, complete it
    if (stack[stack.length - 1] === $43b02a39892a2119$var$ARR_VAL) stack.push($43b02a39892a2119$var$ARR_VAL_COMPLETED);
}
function $43b02a39892a2119$var$_handleArrClose(stack, curStep) {
    // Empty array []
    if (curStep === $43b02a39892a2119$var$ARR) stack.pop();
    // Array with element
    if (curStep === $43b02a39892a2119$var$ARR_VAL) {
        // Pop ARR_VAL, ARR
        stack.pop();
        stack.pop();
    }
    // Array with element
    if (curStep === $43b02a39892a2119$var$ARR_VAL_COMPLETED) {
        // Pop ARR_VAL_COMPLETED, ARR_VAL, ARR
        stack.pop();
        stack.pop();
        stack.pop();
    }
    // if was obj value, complete it
    if (stack[stack.length - 1] === $43b02a39892a2119$var$OBJ_VAL) stack.push($43b02a39892a2119$var$OBJ_VAL_COMPLETED);
    // if was arr value, complete it
    if (stack[stack.length - 1] === $43b02a39892a2119$var$ARR_VAL) stack.push($43b02a39892a2119$var$ARR_VAL_COMPLETED);
}
function $43b02a39892a2119$var$_isEscaped(str, pos) {
    const previousChar = str[pos - 1];
    return previousChar === "\\" && !$43b02a39892a2119$var$_isEscaped(str, pos - 1);
}
/* eslint-disable max-lines */ /**
 * Takes an incomplete JSON string, and returns a hopefully valid JSON string.
 * Note that this _can_ fail, so you should check the return value is valid JSON.
 */ function $43b02a39892a2119$var$fixJson(incompleteJson) {
    const stack = $43b02a39892a2119$var$evaluateJson(incompleteJson);
    return $43b02a39892a2119$var$completeJson(incompleteJson, stack);
}
/** Get the size of a body. */ function $43b02a39892a2119$var$getBodySize(body, textEncoder) {
    if (!body) return undefined;
    try {
        if (typeof body === "string") return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $43b02a39892a2119$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $43b02a39892a2119$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $43b02a39892a2119$var$getBodyString(body) {
    if (typeof body === "string") return body;
    if (body instanceof URLSearchParams) return body.toString();
    if (body instanceof FormData) return $43b02a39892a2119$var$_serializeFormData(body);
    return undefined;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $43b02a39892a2119$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp , endTimestamp: endTimestamp , url: url , method: method , statusCode: statusCode , request: request , response: response  } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $jl9W5.dropUndefinedKeys)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $43b02a39892a2119$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                "URL_SKIPPED"
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $43b02a39892a2119$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody , warnings: warnings  } = $43b02a39892a2119$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $43b02a39892a2119$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.keys(headers).reduce((filteredHeaders, key)=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = headers[key];
        return filteredHeaders;
    }, {});
}
function $43b02a39892a2119$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-ignore passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $43b02a39892a2119$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== "string") return {
        body: body,
        warnings: []
    };
    const exceedsSizeLimit = body.length > $43b02a39892a2119$var$NETWORK_BODY_MAX_SIZE;
    if ($43b02a39892a2119$var$_strIsProbablyJson(body)) try {
        const json = exceedsSizeLimit ? $43b02a39892a2119$var$fixJson(body.slice(0, $43b02a39892a2119$var$NETWORK_BODY_MAX_SIZE)) : body;
        const normalizedBody = JSON.parse(json);
        return {
            body: normalizedBody,
            warnings: exceedsSizeLimit ? [
                "JSON_TRUNCATED"
            ] : []
        };
    } catch (e3) {
        return {
            body: exceedsSizeLimit ? `${body.slice(0, $43b02a39892a2119$var$NETWORK_BODY_MAX_SIZE)}…` : body,
            warnings: exceedsSizeLimit ? [
                "INVALID_JSON",
                "TEXT_TRUNCATED"
            ] : [
                "INVALID_JSON"
            ]
        };
    }
    return {
        body: exceedsSizeLimit ? `${body.slice(0, $43b02a39892a2119$var$NETWORK_BODY_MAX_SIZE)}…` : body,
        warnings: exceedsSizeLimit ? [
            "TEXT_TRUNCATED"
        ] : []
    };
}
function $43b02a39892a2119$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === "[" && last === "]" || first === "{" && last === "}";
}
/** Match an URL against a list of strings/Regex. */ function $43b02a39892a2119$var$urlMatches(url, urls) {
    const fullUrl = $43b02a39892a2119$var$getFullUrl(url);
    return (0, $geIBs.stringMatchesSomePattern)(fullUrl, urls);
}
/** exported for tests */ function $43b02a39892a2119$var$getFullUrl(url, baseURI = $43b02a39892a2119$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith($43b02a39892a2119$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith("/") && fullUrl.endsWith("/")) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $43b02a39892a2119$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $43b02a39892a2119$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $43b02a39892a2119$var$makeNetworkReplayBreadcrumb("resource.fetch", data);
        $43b02a39892a2119$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error("[Replay] Failed to capture fetch breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $43b02a39892a2119$var$enrichFetchBreadcrumb(breadcrumb, hint, options) {
    const { input: input , response: response  } = hint;
    const body = $43b02a39892a2119$var$_getFetchRequestArgBody(input);
    const reqSize = $43b02a39892a2119$var$getBodySize(body, options.textEncoder);
    const resSize = response ? $43b02a39892a2119$var$parseContentLengthHeader(response.headers.get("content-length")) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $43b02a39892a2119$var$_prepareFetchData(breadcrumb, hint, options) {
    const { startTimestamp: startTimestamp , endTimestamp: endTimestamp  } = hint;
    const { url: url , method: method , status_code: statusCode = 0 , request_body_size: requestBodySize , response_body_size: responseBodySize  } = breadcrumb.data;
    const captureDetails = $43b02a39892a2119$var$urlMatches(url, options.networkDetailAllowUrls);
    const request = captureDetails ? $43b02a39892a2119$var$_getRequestInfo(options, hint.input, requestBodySize) : $43b02a39892a2119$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $43b02a39892a2119$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $43b02a39892a2119$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies , networkRequestHeaders: networkRequestHeaders  }, input, requestBodySize) {
    const headers = $43b02a39892a2119$var$getRequestHeaders(input, networkRequestHeaders);
    if (!networkCaptureBodies) return $43b02a39892a2119$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $43b02a39892a2119$var$_getFetchRequestArgBody(input);
    const bodyStr = $43b02a39892a2119$var$getBodyString(requestBody);
    return $43b02a39892a2119$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
}
async function $43b02a39892a2119$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies , textEncoder: textEncoder , networkResponseHeaders: networkResponseHeaders  }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $43b02a39892a2119$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = $43b02a39892a2119$var$getAllHeaders(response.headers, networkResponseHeaders);
    if (!networkCaptureBodies && responseBodySize !== undefined) return $43b02a39892a2119$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    // Only clone the response if we need to
    try {
        // We have to clone this, as the body can only be read once
        const res = response.clone();
        const bodyText = await $43b02a39892a2119$var$_parseFetchBody(res);
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $43b02a39892a2119$var$getBodySize(bodyText, textEncoder) : responseBodySize;
        if (!captureDetails) return $43b02a39892a2119$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $43b02a39892a2119$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $43b02a39892a2119$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (e) {
        // fallback
        return $43b02a39892a2119$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $43b02a39892a2119$var$_parseFetchBody(response) {
    try {
        return await response.text();
    } catch (e2) {
        return undefined;
    }
}
function $43b02a39892a2119$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== "object") return undefined;
    return fetchArgs[1].body;
}
function $43b02a39892a2119$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $43b02a39892a2119$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") return $43b02a39892a2119$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $43b02a39892a2119$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $43b02a39892a2119$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $43b02a39892a2119$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $43b02a39892a2119$var$getAllowedHeaders(headers, allowedHeaders);
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $43b02a39892a2119$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $43b02a39892a2119$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $43b02a39892a2119$var$makeNetworkReplayBreadcrumb("resource.xhr", data);
        $43b02a39892a2119$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error("[Replay] Failed to capture fetch breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $43b02a39892a2119$var$enrichXhrBreadcrumb(breadcrumb, hint, options) {
    const { xhr: xhr , input: input  } = hint;
    const reqSize = $43b02a39892a2119$var$getBodySize(input, options.textEncoder);
    const resSize = xhr.getResponseHeader("content-length") ? $43b02a39892a2119$var$parseContentLengthHeader(xhr.getResponseHeader("content-length")) : $43b02a39892a2119$var$getBodySize(xhr.response, options.textEncoder);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $43b02a39892a2119$var$_prepareXhrData(breadcrumb, hint, options) {
    const { startTimestamp: startTimestamp , endTimestamp: endTimestamp , input: input , xhr: xhr  } = hint;
    const { url: url , method: method , status_code: statusCode = 0 , request_body_size: requestBodySize , response_body_size: responseBodySize  } = breadcrumb.data;
    if (!url) return null;
    if (!$43b02a39892a2119$var$urlMatches(url, options.networkDetailAllowUrls)) {
        const request = $43b02a39892a2119$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $43b02a39892a2119$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $cIWhk.SENTRY_XHR_DATA_KEY];
    const networkRequestHeaders = xhrInfo ? $43b02a39892a2119$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $43b02a39892a2119$var$getAllowedHeaders($43b02a39892a2119$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const request = $43b02a39892a2119$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, options.networkCaptureBodies ? $43b02a39892a2119$var$getBodyString(input) : undefined);
    const response = $43b02a39892a2119$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, options.networkCaptureBodies ? hint.xhr.responseText : undefined);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $43b02a39892a2119$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $43b02a39892a2119$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $kDFdm.getCurrentHub)().getClient();
    try {
        const textEncoder = new TextEncoder();
        const { networkDetailAllowUrls: networkDetailAllowUrls , networkCaptureBodies: networkCaptureBodies , networkRequestHeaders: networkRequestHeaders , networkResponseHeaders: networkResponseHeaders  } = replay.getOptions();
        const options = {
            replay: replay,
            textEncoder: textEncoder,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client && client.on) client.on("beforeAddBreadcrumb", (breadcrumb, hint)=>$43b02a39892a2119$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
        else {
            // Fallback behavior
            (0, $cIWhk.addInstrumentationHandler)("fetch", $43b02a39892a2119$var$handleFetchSpanListener(replay));
            (0, $cIWhk.addInstrumentationHandler)("xhr", $43b02a39892a2119$var$handleXhrSpanListener(replay));
        }
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $43b02a39892a2119$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($43b02a39892a2119$var$_isXhrBreadcrumb(breadcrumb) && $43b02a39892a2119$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $43b02a39892a2119$var$enrichXhrBreadcrumb(breadcrumb, hint, options);
            $43b02a39892a2119$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($43b02a39892a2119$var$_isFetchBreadcrumb(breadcrumb) && $43b02a39892a2119$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $43b02a39892a2119$var$enrichFetchBreadcrumb(breadcrumb, hint, options);
            $43b02a39892a2119$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn("Error when enriching network breadcrumb");
    }
}
function $43b02a39892a2119$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === "xhr";
}
function $43b02a39892a2119$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === "fetch";
}
function $43b02a39892a2119$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $43b02a39892a2119$var$_isFetchHint(hint) {
    return hint && hint.response;
}
let $43b02a39892a2119$var$_LAST_BREADCRUMB = null;
const $43b02a39892a2119$var$handleScopeListener = (replay)=>(scope)=>{
        if (!replay.isEnabled()) return;
        const result = $43b02a39892a2119$var$handleScope(scope);
        if (!result) return;
        $43b02a39892a2119$var$addBreadcrumbEvent(replay, result);
    };
/**
 * An event handler to handle scope changes.
 */ function $43b02a39892a2119$var$handleScope(scope) {
    // TODO (v8): Remove this guard. This was put in place because we introduced
    // Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
    // For now, we'll just return null if the method doesn't exist but we should eventually
    // get rid of this guard.
    const newBreadcrumb = scope.getLastBreadcrumb && scope.getLastBreadcrumb();
    // Listener can be called when breadcrumbs have not changed, so we store the
    // reference to the last crumb and only return a crumb if it has changed
    if ($43b02a39892a2119$var$_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) return null;
    $43b02a39892a2119$var$_LAST_BREADCRUMB = newBreadcrumb;
    if (newBreadcrumb.category && ([
        "fetch",
        "xhr",
        "sentry.event",
        "sentry.transaction"
    ].includes(newBreadcrumb.category) || newBreadcrumb.category.startsWith("ui."))) return null;
    if (newBreadcrumb.category === "console") return $43b02a39892a2119$var$normalizeConsoleBreadcrumb(newBreadcrumb);
    return $43b02a39892a2119$var$createBreadcrumb(newBreadcrumb);
}
/** exported for tests only */ function $43b02a39892a2119$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $43b02a39892a2119$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === "string") {
            if (arg.length > $43b02a39892a2119$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $43b02a39892a2119$var$CONSOLE_ARG_MAX_SIZE)}…`;
            }
            return arg;
        }
        if (typeof arg === "object") try {
            const normalizedArg = (0, $fa9ac95e0af8817a$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $43b02a39892a2119$var$CONSOLE_ARG_MAX_SIZE) {
                const fixedJson = $43b02a39892a2119$var$fixJson(stringified.slice(0, $43b02a39892a2119$var$CONSOLE_ARG_MAX_SIZE));
                const json = JSON.parse(fixedJson);
                // We only set this after JSON.parse() was successfull, so we know we didn't run into `catch`
                isTruncated = true;
                return json;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $43b02a39892a2119$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        "CONSOLE_ARG_TRUNCATED"
                    ]
                }
            } : {}
        }
    });
}
/**
 * Add global listeners that cannot be removed.
 */ function $43b02a39892a2119$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const scope = (0, $kDFdm.getCurrentHub)().getScope();
    const client = (0, $kDFdm.getCurrentHub)().getClient();
    if (scope) scope.addScopeListener($43b02a39892a2119$var$handleScopeListener(replay));
    (0, $cIWhk.addInstrumentationHandler)("dom", $43b02a39892a2119$var$handleDomListener(replay));
    (0, $cIWhk.addInstrumentationHandler)("history", $43b02a39892a2119$var$handleHistorySpanListener(replay));
    $43b02a39892a2119$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    (0, $f3hBG.addGlobalEventProcessor)($43b02a39892a2119$var$handleGlobalEventListener(replay, !$43b02a39892a2119$var$hasHooks(client)));
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if ($43b02a39892a2119$var$hasHooks(client)) {
        client.on("afterSendEvent", $43b02a39892a2119$var$handleAfterSendEvent(replay));
        client.on("createDsc", (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === "session") dsc.replay_id = replayId;
        });
        client.on("startTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We may be missing the initial startTransaction due to timing issues,
        // so we capture it on finish again.
        client.on("finishTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $43b02a39892a2119$var$hasHooks(client) {
    return !!(client && client.on);
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $43b02a39892a2119$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($43b02a39892a2119$var$createPerformanceSpans(replay, [
            // @ts-ignore memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $43b02a39892a2119$var$createMemoryEntry($43b02a39892a2119$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $43b02a39892a2119$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit , totalJSHeapSize: totalJSHeapSize , usedJSHeapSize: usedJSHeapSize  } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: "memory",
        name: "memory",
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
// Map entryType -> function to normalize data for event
// @ts-ignore TODO: entry type does not fit the create* functions entry type
const $43b02a39892a2119$var$ENTRY_TYPES = {
    // @ts-ignore TODO: entry type does not fit the create* functions entry type
    resource: $43b02a39892a2119$var$createResourceEntry,
    paint: $43b02a39892a2119$var$createPaintEntry,
    // @ts-ignore TODO: entry type does not fit the create* functions entry type
    navigation: $43b02a39892a2119$var$createNavigationEntry,
    // @ts-ignore TODO: entry type does not fit the create* functions entry type
    ["largest-contentful-paint"]: $43b02a39892a2119$var$createLargestContentfulPaint
};
/**
 * Create replay performance entries from the browser performance entries.
 */ function $43b02a39892a2119$var$createPerformanceEntries(entries) {
    return entries.map($43b02a39892a2119$var$createPerformanceEntry).filter(Boolean);
}
function $43b02a39892a2119$var$createPerformanceEntry(entry) {
    if ($43b02a39892a2119$var$ENTRY_TYPES[entry.entryType] === undefined) return null;
    return $43b02a39892a2119$var$ENTRY_TYPES[entry.entryType](entry);
}
function $43b02a39892a2119$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $52JFH.browserPerformanceTimeOrigin) || $43b02a39892a2119$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $43b02a39892a2119$var$createPaintEntry(entry) {
    const { duration: duration , entryType: entryType , name: name , startTime: startTime  } = entry;
    const start = $43b02a39892a2119$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $43b02a39892a2119$var$createNavigationEntry(entry) {
    const { entryType: entryType , name: name , decodedBodySize: decodedBodySize , duration: duration , domComplete: domComplete , encodedBodySize: encodedBodySize , domContentLoadedEventStart: domContentLoadedEventStart , domContentLoadedEventEnd: domContentLoadedEventEnd , domInteractive: domInteractive , loadEventStart: loadEventStart , loadEventEnd: loadEventEnd , redirectCount: redirectCount , startTime: startTime , transferSize: transferSize , type: type  } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $43b02a39892a2119$var$getAbsoluteTime(startTime),
        end: $43b02a39892a2119$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $43b02a39892a2119$var$createResourceEntry(entry) {
    const { entryType: entryType , initiatorType: initiatorType , name: name , responseEnd: responseEnd , startTime: startTime , decodedBodySize: decodedBodySize , encodedBodySize: encodedBodySize , responseStatus: responseStatus , transferSize: transferSize  } = entry;
    // Core SDK handles these
    if ([
        "fetch",
        "xmlhttprequest"
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $43b02a39892a2119$var$getAbsoluteTime(startTime),
        end: $43b02a39892a2119$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
function $43b02a39892a2119$var$createLargestContentfulPaint(entry) {
    const { entryType: entryType , startTime: startTime , size: size  } = entry;
    let startTimeOrNavigationActivation = 0;
    if ($43b02a39892a2119$var$WINDOW.performance) {
        const navEntry = $43b02a39892a2119$var$WINDOW.performance.getEntriesByType("navigation")[0];
        // See https://github.com/GoogleChrome/web-vitals/blob/9f11c4c6578fb4c5ee6fa4e32b9d1d756475f135/src/lib/getActivationStart.ts#L21
        startTimeOrNavigationActivation = navEntry && navEntry.activationStart || 0;
    }
    // value is in ms
    const value = Math.max(startTime - startTimeOrNavigationActivation, 0);
    // LCP doesn't have a "duration", it just happens at a single point in time.
    // But the UI expects both, so use end (in seconds) for both timestamps.
    const end = $43b02a39892a2119$var$getAbsoluteTime(startTimeOrNavigationActivation) + value / 1000;
    return {
        type: entryType,
        name: entryType,
        start: end,
        end: end,
        data: {
            value: value,
            size: size,
            // Not sure why this errors, Node should be correct (Argument of type 'Node' is not assignable to parameter of type 'INode')
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            nodeId: $43b02a39892a2119$var$record.mirror.getId(entry.element)
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $43b02a39892a2119$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeout(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $43b02a39892a2119$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn("[Replay] Received replay event after session expired.");
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === "buffer" && isCheckout) replay.setInitialState();
            $43b02a39892a2119$var$addEvent(replay, event, isCheckout);
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            $43b02a39892a2119$var$addSettingsEvent(replay, isCheckout);
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (replay.session && replay.session.previousSessionId) return true;
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === "buffer" && replay.session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    replay.session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $43b02a39892a2119$var$saveSession(replay.session);
                }
            }
            const options = replay.getOptions();
            // TODO: We want this as an experiment so that we can test
            // internally and create metrics before making this the default
            if (options._experiments.delayFlushOnCheckout) {
                // If the full snapshot is due to an initial load, we will not have
                // a previous session ID. In this case, we want to buffer events
                // for a set amount of time before flushing. This can help avoid
                // capturing replays of users that immediately close the window.
                setTimeout(()=>replay.conditionalFlush(), options._experiments.delayFlushOnCheckout);
                // Cancel any previously debounced flushes to ensure there are no [near]
                // simultaneous flushes happening. The latter request should be
                // insignificant in this case, so wait for additional user interaction to
                // trigger a new flush.
                //
                // This can happen because there's no guarantee that a recording event
                // happens first. e.g. a mouse click can happen and trigger a debounced
                // flush before the checkout.
                replay.cancelFlush();
                return true;
            }
            // Flush immediately so that we do not miss the first segment, otherwise
            // it can prevent loading on the UI. This will cause an increase in short
            // replays (e.g. opening and closing a tab quickly), but these can be
            // filtered on the UI.
            if (replay.recordingMode === "session") replay.flushImmediate();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $43b02a39892a2119$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $43b02a39892a2119$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: "options",
            payload: {
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $43b02a39892a2119$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return Promise.resolve(null);
    return $43b02a39892a2119$var$addEvent(replay, $43b02a39892a2119$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $43b02a39892a2119$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $1d1870952790bd6e$export$f93f7f385160c44e)((0, $1d1870952790bd6e$export$92b6093782fe661b)(replayEvent, (0, $1d1870952790bd6e$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: "replay_event"
            },
            replayEvent
        ],
        [
            {
                type: "replay_recording",
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $43b02a39892a2119$var$prepareRecordingData({ recordingData: recordingData , headers: headers  }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === "string") payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $43b02a39892a2119$var$prepareReplayEvent({ client: client , scope: scope , replayId: event_id , event: event  }) {
    const integrations = typeof client._integrations === "object" && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const preparedEvent = await (0, $2c3657f9007b6f81$export$2d67fb380bd11267)(client.getOptions(), event, {
        event_id: event_id,
        integrations: integrations
    }, scope);
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || "javascript";
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata && client.getSdkMetadata();
    const { name: name , version: version  } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || "sentry.javascript.unknown",
        version: version || "0.0.0"
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $43b02a39892a2119$var$sendReplayRequest({ recordingData: recordingData , replayId: replayId , segmentId: segment_id , eventContext: eventContext , timestamp: timestamp , session: session  }) {
    const preparedRecordingData = $43b02a39892a2119$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls , errorIds: errorIds , traceIds: traceIds , initialTimestamp: initialTimestamp  } = eventContext;
    const hub = (0, $kDFdm.getCurrentHub)();
    const client = hub.getClient();
    const scope = hub.getScope();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !scope || !transport || !dsn || !session.sampled) return;
    const baseEvent = {
        type: $43b02a39892a2119$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $43b02a39892a2119$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent("event_processor", "replay", baseEvent);
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("An event processor returned `null`, will not send event.");
        return;
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ const envelope = $43b02a39892a2119$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($43b02a39892a2119$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-ignore This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
    if (!response) return response;
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new $43b02a39892a2119$var$TransportStatusCodeError(response.statusCode);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $43b02a39892a2119$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $43b02a39892a2119$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $43b02a39892a2119$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData , options: options  } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $43b02a39892a2119$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $43b02a39892a2119$var$TransportStatusCodeError) throw err;
        // Capture error for every failed replay
        (0, $6a14300e075c8f51$export$2f04de43fe27971a)("Replays", {
            _retryCount: retryConfig.count
        });
        if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && options._experiments && options._experiments.captureExceptions) (0, $6a14300e075c8f51$export$f5282963edea4a68)(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $43b02a39892a2119$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$43b02a39892a2119$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-ignore This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return await new Promise((resolve, reject)=>{
            setTimeout(async ()=>{
                try {
                    await $43b02a39892a2119$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $43b02a39892a2119$var$THROTTLED = "__THROTTLED";
const $43b02a39892a2119$var$SKIPPED = "__SKIPPED";
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $43b02a39892a2119$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $43b02a39892a2119$var$SKIPPED : $43b02a39892a2119$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $43b02a39892a2119$var$ReplayContainer {
    __init() {
        this.eventBuffer = null;
    }
    /**
   * List of PerformanceEntry from PerformanceObserver
   */ __init2() {
        this.performanceEvents = [];
    }
    /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ __init3() {
        this.recordingMode = "session";
    }
    /**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ __init4() {
        this.timeouts = {
            sessionIdlePause: $43b02a39892a2119$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $43b02a39892a2119$var$SESSION_IDLE_EXPIRE_DURATION,
            maxSessionLife: $43b02a39892a2119$var$MAX_SESSION_LIFE
        };
    }
    /**
   * Options to pass to `rrweb.record()`
   */ __init5() {
        this._performanceObserver = null;
    }
    __init6() {
        this._flushLock = null;
    }
    /**
   * Timestamp of the last user activity. This lives across sessions.
   */ __init7() {
        this._lastActivity = Date.now();
    }
    /**
   * Is the integration currently active?
   */ __init8() {
        this._isEnabled = false;
    }
    /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ __init9() {
        this._isPaused = false;
    }
    /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ __init10() {
        this._hasInitializedCoreListeners = false;
    }
    /**
   * Function to stop recording
   */ __init11() {
        this._stopRecording = null;
    }
    __init12() {
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ""
        };
    }
    constructor({ options: options , recordingOptions: recordingOptions  }){
        $43b02a39892a2119$var$ReplayContainer.prototype.__init.call(this);
        $43b02a39892a2119$var$ReplayContainer.prototype.__init2.call(this);
        $43b02a39892a2119$var$ReplayContainer.prototype.__init3.call(this);
        $43b02a39892a2119$var$ReplayContainer.prototype.__init4.call(this);
        $43b02a39892a2119$var$ReplayContainer.prototype.__init5.call(this);
        $43b02a39892a2119$var$ReplayContainer.prototype.__init6.call(this);
        $43b02a39892a2119$var$ReplayContainer.prototype.__init7.call(this);
        $43b02a39892a2119$var$ReplayContainer.prototype.__init8.call(this);
        $43b02a39892a2119$var$ReplayContainer.prototype.__init9.call(this);
        $43b02a39892a2119$var$ReplayContainer.prototype.__init10.call(this);
        $43b02a39892a2119$var$ReplayContainer.prototype.__init11.call(this);
        $43b02a39892a2119$var$ReplayContainer.prototype.__init12.call(this);
        $43b02a39892a2119$var$ReplayContainer.prototype.__init13.call(this);
        $43b02a39892a2119$var$ReplayContainer.prototype.__init14.call(this);
        $43b02a39892a2119$var$ReplayContainer.prototype.__init15.call(this);
        $43b02a39892a2119$var$ReplayContainer.prototype.__init16.call(this);
        $43b02a39892a2119$var$ReplayContainer.prototype.__init17.call(this);
        $43b02a39892a2119$var$ReplayContainer.prototype.__init18.call(this);
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $43b02a39892a2119$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $43b02a39892a2119$var$throttle((event, isCheckout)=>$43b02a39892a2119$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling() {
        const { errorSampleRate: errorSampleRate , sessionSampleRate: sessionSampleRate  } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        if (errorSampleRate <= 0 && sessionSampleRate <= 0) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        const isSessionSampled = this._loadAndCheckSession();
        if (!isSessionSampled) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        if (!this.session) {
            // This should not happen, something wrong has occurred
            this._handleException(new Error("Unable to initialize and create session"));
            return;
        }
        if (this.session.sampled && this.session.sampled !== "session") // If not sampled as session-based, then recording mode will be `buffer`
        // Note that we don't explicitly check if `sampled === 'buffer'` because we
        // could have sessions from Session storage that are still `error` from
        // prior SDK version.
        this.recordingMode = "buffer";
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === "session") throw new Error("Replay recording is already in progress");
        if (this._isEnabled && this.recordingMode === "buffer") throw new Error("Replay buffering is in progress, call `flush()` to save the replay");
        const previousSessionId = this.session && this.session.id;
        const { session: session  } = $43b02a39892a2119$var$getSession({
            timeouts: this.timeouts,
            stickySession: Boolean(this._options.stickySession),
            currentSession: this.session,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        session.previousSessionId = previousSessionId;
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) throw new Error("Replay recording is already in progress");
        const previousSessionId = this.session && this.session.id;
        const { session: session  } = $43b02a39892a2119$var$getSession({
            timeouts: this.timeouts,
            stickySession: Boolean(this._options.stickySession),
            currentSession: this.session,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        session.previousSessionId = previousSessionId;
        this.session = session;
        this.recordingMode = "buffer";
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            this._stopRecording = $43b02a39892a2119$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === "buffer" && {
                    checkoutEveryNms: $43b02a39892a2119$var$BUFFER_CHECKOUT_TIME
                },
                emit: $43b02a39892a2119$var$getHandleRecordingEmit(this),
                onMutation: this._onMutationHandler
            });
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this._handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop(reason) {
        if (!this._isEnabled) return;
        try {
            if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) {
                const msg = `[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ""}`;
                // When `traceInternals` is enabled, we want to log this to the console
                // Else, use the regular debug output
                // eslint-disable-next-line
                const log = this.getOptions()._experiments.traceInternals ? console.warn : (0, $3lHwZ.logger).log;
                log(msg);
            }
            // We can't move `_isEnabled` after awaiting a flush, otherwise we can
            // enter into an infinite loop when `stop()` is called while flushing.
            this._isEnabled = false;
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (this.recordingMode === "session") await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $43b02a39892a2119$var$clearSession(this);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        this._isPaused = true;
        this.stopRecording();
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._loadAndCheckSession()) return;
        this._isPaused = false;
        this.startRecording();
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true  } = {}) {
        if (this.recordingMode === "session") return this.flushImmediate();
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // Re-start recording, but in "session" recording mode
        // Reset all "capture on error" configuration before
        // starting a new recording
        this.recordingMode = "session";
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this.session.shouldRefresh = false;
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === "buffer") return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._loadAndCheckSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === "buffer") return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current sesion (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        const oldSessionId = this.getSessionId();
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $43b02a39892a2119$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._loadAndCheckSession()) return;
        // Session was expired if session ids do not match
        const expired = oldSessionId !== this.getSessionId();
        if (!expired) return true;
        // Session is expired, trigger a full snapshot (which will create a new session)
        this._triggerFullSnapshot();
        return false;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$43b02a39892a2119$var$WINDOW.location.pathname}${$43b02a39892a2119$var$WINDOW.location.hash}${$43b02a39892a2119$var$WINDOW.location.search}`;
        const url = `${$43b02a39892a2119$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEvents = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $43b02a39892a2119$var$THROTTLED) {
            const breadcrumb = $43b02a39892a2119$var$createBreadcrumb({
                category: "replay.throttled"
            });
            this.addUpdate(()=>{
                $43b02a39892a2119$var$addEvent(this, {
                    type: $43b02a39892a2119$var$EventType$1.Custom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: "breadcrumb",
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        const lastTransaction = this.lastTransaction || (0, $kDFdm.getCurrentHub)().getScope().getTransaction();
        if (!lastTransaction || ![
            "route",
            "custom"
        ].includes(lastTransaction.metadata.source)) return undefined;
        return lastTransaction.name;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $43b02a39892a2119$var$createEventBuffer({
            useCompression: this._options.useCompression
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this.startRecording();
    }
    /** A wrapper to conditionally capture exceptions. */ _handleException(error) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error("[Replay]", error);
        if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && this._options._experiments && this._options._experiments.captureExceptions) (0, $6a14300e075c8f51$export$f5282963edea4a68)(error);
    }
    /**
   * Loads (or refreshes) the current session.
   * Returns false if session is not recorded.
   */ _loadAndCheckSession() {
        const { type: type , session: session  } = $43b02a39892a2119$var$getSession({
            timeouts: this.timeouts,
            stickySession: Boolean(this._options.stickySession),
            currentSession: this.session,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: this._options.errorSampleRate > 0
        });
        // If session was newly created (i.e. was not loaded from storage), then
        // enable flag to create the root replay
        if (type === "new") this.setInitialState();
        const currentSessionId = this.getSessionId();
        if (session.id !== currentSessionId) session.previousSessionId = currentSessionId;
        this.session = session;
        if (!this.session.sampled) {
            this.stop("session unsampled");
            return false;
        }
        return true;
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $43b02a39892a2119$var$WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
            $43b02a39892a2119$var$WINDOW.addEventListener("blur", this._handleWindowBlur);
            $43b02a39892a2119$var$WINDOW.addEventListener("focus", this._handleWindowFocus);
            $43b02a39892a2119$var$WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $43b02a39892a2119$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this._handleException(err);
        }
        // PerformanceObserver //
        if (!("PerformanceObserver" in $43b02a39892a2119$var$WINDOW)) return;
        this._performanceObserver = $43b02a39892a2119$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $43b02a39892a2119$var$WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
            $43b02a39892a2119$var$WINDOW.removeEventListener("blur", this._handleWindowBlur);
            $43b02a39892a2119$var$WINDOW.removeEventListener("focus", this._handleWindowFocus);
            $43b02a39892a2119$var$WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
            if (this._performanceObserver) {
                this._performanceObserver.disconnect();
                this._performanceObserver = null;
            }
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init13() {
        this._handleVisibilityChange = ()=>{
            if ($43b02a39892a2119$var$WINDOW.document.visibilityState === "visible") this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init14() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $43b02a39892a2119$var$createBreadcrumb({
                category: "ui.blur"
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init15() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $43b02a39892a2119$var$createBreadcrumb({
                category: "ui.focus"
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init16() {
        this._handleKeyboardEvent = (event)=>{
            $43b02a39892a2119$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $43b02a39892a2119$var$isSessionExpired(this.session, this.timeouts);
        if (breadcrumb && !expired) this._createCustomBreadcrumb(breadcrumb);
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Replay] Document has become active, but session has expired");
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Trigger rrweb to take a full snapshot which will cause this plugin to
   * create a new Replay event.
   */ _triggerFullSnapshot(checkout = true) {
        try {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Replay] Taking full rrweb snapshot");
            $43b02a39892a2119$var$record.takeFullSnapshot(checkout);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            this.throttledAddEvent({
                type: $43b02a39892a2119$var$EventType$1.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: "breadcrumb",
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEvents`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        // Copy and reset entries before processing
        const entries = [
            ...this.performanceEvents
        ];
        this.performanceEvents = [];
        return Promise.all($43b02a39892a2119$var$createPerformanceSpans(this, $43b02a39892a2119$var$createPerformanceEntries(entries)));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session , eventBuffer: eventBuffer  } = this;
        if (!session || !eventBuffer) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        if (!this.session || !this.eventBuffer) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error("[Replay] No session or eventBuffer found to flush.");
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $43b02a39892a2119$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            // NOTE: Copy values from instance members, as it's possible they could
            // change before the flush finishes.
            const replayId = this.session.id;
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            await $43b02a39892a2119$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                options: this.getOptions(),
                timestamp: Date.now()
            });
        } catch (err) {
            this._handleException(err);
            this.stop("sendReplay");
            const client = (0, $kDFdm.getCurrentHub)().getClient();
            if (client) client.recordDroppedEvent("send_error", "replay");
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init17() {
        this._flush = async ({ force: force = false  } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error("[Replay] Attempting to finish replay event after session expired.");
                return;
            }
            if (!this.session) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error("[Replay] No session found to flush.");
                return;
            }
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // this._flushLock acts as a lock so that future calls to `_flush()`
            // will be blocked until this promise resolves
            if (!this._flushLock) {
                this._flushLock = this._runFlush();
                await this._flushLock;
                this._flushLock = null;
                return;
            }
            // Wait for previous flush to finish, then call the debounced `_flush()`.
            // It's possible there are other flush requests queued and waiting for it
            // to resolve. We want to reduce all outstanding requests (as well as any
            // new flush requests that occur within a second of the locked flush
            // completing) into a single flush.
            try {
                await this._flushLock;
            } catch (err) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error(err);
            } finally{
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $43b02a39892a2119$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init18() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $43b02a39892a2119$var$createBreadcrumb({
                    category: "replay.mutations",
                    data: {
                        count: count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                this.stop("mutationLimit");
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function $43b02a39892a2119$var$getOption(selectors, defaultSelectors, deprecatedClassOption, deprecatedSelectorOption) {
    const deprecatedSelectors = typeof deprecatedSelectorOption === "string" ? deprecatedSelectorOption.split(",") : [];
    const allSelectors = [
        ...selectors,
        // @deprecated
        ...deprecatedSelectors,
        // sentry defaults
        ...defaultSelectors
    ];
    // @deprecated
    if (typeof deprecatedClassOption !== "undefined") {
        // NOTE: No support for RegExp
        if (typeof deprecatedClassOption === "string") allSelectors.push(`.${deprecatedClassOption}`);
        // eslint-disable-next-line no-console
        console.warn("[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.");
    }
    return allSelectors.join(",");
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $43b02a39892a2119$var$getPrivacyOptions({ mask: mask , unmask: unmask , block: block , unblock: unblock , ignore: ignore , blockClass: // eslint-disable-next-line deprecation/deprecation
blockClass , blockSelector: // eslint-disable-next-line deprecation/deprecation
blockSelector , maskTextClass: // eslint-disable-next-line deprecation/deprecation
maskTextClass , maskTextSelector: // eslint-disable-next-line deprecation/deprecation
maskTextSelector , ignoreClass: // eslint-disable-next-line deprecation/deprecation
ignoreClass  }) {
    const defaultBlockedElements = [
        'base[href="/"]'
    ];
    const maskSelector = $43b02a39892a2119$var$getOption(mask, [
        ".sentry-mask",
        "[data-sentry-mask]"
    ], maskTextClass, maskTextSelector);
    const unmaskSelector = $43b02a39892a2119$var$getOption(unmask, [
        ".sentry-unmask",
        "[data-sentry-unmask]"
    ]);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        maskInputSelector: maskSelector,
        unmaskInputSelector: unmaskSelector,
        blockSelector: $43b02a39892a2119$var$getOption(block, [
            ".sentry-block",
            "[data-sentry-block]",
            ...defaultBlockedElements
        ], blockClass, blockSelector),
        unblockSelector: $43b02a39892a2119$var$getOption(unblock, [
            ".sentry-unblock",
            "[data-sentry-unblock]"
        ]),
        ignoreSelector: $43b02a39892a2119$var$getOption(ignore, [
            ".sentry-ignore",
            "[data-sentry-ignore]",
            'input[type="file"]'
        ], ignoreClass)
    };
    if (blockClass instanceof RegExp) options.blockClass = blockClass;
    if (maskTextClass instanceof RegExp) options.maskTextClass = maskTextClass;
    return options;
}
/**
 * Returns true if we are in the browser.
 */ function $43b02a39892a2119$var$isBrowser() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== "undefined" && (!(0, $6QG3c.isNodeEnv)() || $43b02a39892a2119$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $43b02a39892a2119$var$isElectronNodeRenderer() {
    return typeof $e67mm !== "undefined" && $e67mm.type === "renderer";
}
const $43b02a39892a2119$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $43b02a39892a2119$var$DEFAULT_NETWORK_HEADERS = [
    "content-length",
    "content-type",
    "accept"
];
let $43b02a39892a2119$var$_initialized = false;
/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 */ class $43b02a39892a2119$export$a35c789ed37ee0f7 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Replay";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $43b02a39892a2119$export$a35c789ed37ee0f7.id;
    }
    /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $43b02a39892a2119$var$DEFAULT_FLUSH_MIN_DELAY , flushMaxDelay: flushMaxDelay = $43b02a39892a2119$var$DEFAULT_FLUSH_MAX_DELAY , stickySession: stickySession = true , useCompression: useCompression = true , _experiments: _experiments = {} , sessionSampleRate: sessionSampleRate , errorSampleRate: errorSampleRate , maskAllText: maskAllText = true , maskAllInputs: maskAllInputs = true , blockAllMedia: blockAllMedia = true , mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750 , mutationLimit: mutationLimit = 10000 , networkDetailAllowUrls: networkDetailAllowUrls = [] , networkCaptureBodies: networkCaptureBodies = true , networkRequestHeaders: networkRequestHeaders = [] , networkResponseHeaders: networkResponseHeaders = [] , mask: mask = [] , unmask: unmask = [] , block: block = [] , unblock: unblock = [] , ignore: ignore = [] , maskFn: maskFn , beforeAddRecordingEvent: beforeAddRecordingEvent , blockClass: // eslint-disable-next-line deprecation/deprecation
    blockClass , blockSelector: // eslint-disable-next-line deprecation/deprecation
    blockSelector , maskInputOptions: // eslint-disable-next-line deprecation/deprecation
    maskInputOptions , maskTextClass: // eslint-disable-next-line deprecation/deprecation
    maskTextClass , maskTextSelector: // eslint-disable-next-line deprecation/deprecation
    maskTextSelector , ignoreClass: // eslint-disable-next-line deprecation/deprecation
    ignoreClass  } = {}){
        $43b02a39892a2119$export$a35c789ed37ee0f7.prototype.__init.call(this);
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                ...maskInputOptions || {},
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            ...$43b02a39892a2119$var$getPrivacyOptions({
                mask: mask,
                unmask: unmask,
                block: block,
                unblock: unblock,
                ignore: ignore,
                blockClass: blockClass,
                blockSelector: blockSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                ignoreClass: ignoreClass
            }),
            // Our defaults
            slimDOMOptions: "all",
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            stickySession: stickySession,
            sessionSampleRate: sessionSampleRate,
            errorSampleRate: errorSampleRate,
            useCompression: useCompression,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $43b02a39892a2119$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $43b02a39892a2119$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            _experiments: _experiments
        };
        if (typeof sessionSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`);
            this._initialOptions.sessionSampleRate = sessionSampleRate;
        }
        if (typeof errorSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`);
            this._initialOptions.errorSampleRate = errorSampleRate;
        }
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $43b02a39892a2119$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$43b02a39892a2119$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && $43b02a39892a2119$var$isBrowser()) throw new Error("Multiple Sentry Session Replay instances are not supported");
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $43b02a39892a2119$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $43b02a39892a2119$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ setupOnce() {
        if (!$43b02a39892a2119$var$isBrowser()) return;
        this._setup();
        // Once upon a time, we tried to create a transaction in `setupOnce` and it would
        // potentially create a transaction before some native SDK integrations have run
        // and applied their own global event processor. An example is:
        // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
        //
        // So we call `this._initialize()` in next event loop as a workaround to wait for other
        // global event processors to finish. This is no longer needed, but keeping it
        // here to avoid any future issues.
        setTimeout(()=>this._initialize());
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop();
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay || !this._replay.isEnabled()) return Promise.resolve();
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Initializes replay.
   */ _initialize() {
        if (!this._replay) return;
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup() {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $43b02a39892a2119$var$loadReplayOptionsFromClient(this._initialOptions);
        this._replay = new $43b02a39892a2119$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
}
$43b02a39892a2119$export$a35c789ed37ee0f7.__initStatic();
/** Parse Replay-related options from SDK options */ function $43b02a39892a2119$var$loadReplayOptionsFromClient(initialOptions) {
    const client = (0, $kDFdm.getCurrentHub)().getClient();
    const opt = client && client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $jl9W5.dropUndefinedKeys)(initialOptions)
    };
    if (!opt) {
        // eslint-disable-next-line no-console
        console.warn("SDK client is not available.");
        return finalOptions;
    }
    if (initialOptions.sessionSampleRate == null && // TODO remove once deprecated rates are removed
    initialOptions.errorSampleRate == null && // TODO remove once deprecated rates are removed
    opt.replaysSessionSampleRate == null && opt.replaysOnErrorSampleRate == null) // eslint-disable-next-line no-console
    console.warn("Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.");
    if (typeof opt.replaysSessionSampleRate === "number") finalOptions.sessionSampleRate = opt.replaysSessionSampleRate;
    if (typeof opt.replaysOnErrorSampleRate === "number") finalOptions.errorSampleRate = opt.replaysOnErrorSampleRate;
    return finalOptions;
}
function $43b02a39892a2119$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$43b02a39892a2119$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}



var $5Jhw0 = parcelRequire("5Jhw0");/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $d39a9d34810cbd78$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}



var $iMHif = parcelRequire("iMHif");
var $jl9W5 = parcelRequire("jl9W5");
var $d2unA = parcelRequire("d2unA");
var $6QG3c = parcelRequire("6QG3c");
var $3lHwZ = parcelRequire("3lHwZ");

/**
 * Check if Sentry auto-instrumentation should be disabled.
 *
 * @param getCurrentHub A method to fetch the current hub
 * @returns boolean
 */ function $bf9aff04975118a7$export$34db76d03eb96b7e(getCurrentHub) {
    const clientOptions = (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
        getCurrentHub,
        "call",
        (_)=>_(),
        "access",
        (_2)=>_2.getClient,
        "call",
        (_3)=>_3(),
        "optionalAccess",
        (_4)=>_4.getOptions,
        "call",
        (_5)=>_5()
    ]);
    const instrumenter = (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
        clientOptions,
        "optionalAccess",
        (_6)=>_6.instrumenter
    ]) || "sentry";
    return instrumenter !== "sentry";
}


/** Tracing integration for Apollo */ class $9db1d7cf4c1db420$export$3db3e396472fda8d {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Apollo";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $9db1d7cf4c1db420$export$3db3e396472fda8d.id;
    }
    /**
   * @inheritDoc
   */ constructor(options = {
        useNestjs: false
    }){
        $9db1d7cf4c1db420$export$3db3e396472fda8d.prototype.__init.call(this);
        this._useNest = !!options.useNestjs;
    }
    /** @inheritdoc */ loadDependency() {
        if (this._useNest) this._module = this._module || (0, $6QG3c.loadModule)("@nestjs/graphql");
        else this._module = this._module || (0, $6QG3c.loadModule)("apollo-server-core");
        return this._module;
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $bf9aff04975118a7$export$34db76d03eb96b7e)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("Apollo Integration is skipped because of instrumenter configuration.");
            return;
        }
        if (this._useNest) {
            const pkg = this.loadDependency();
            if (!pkg) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error("Apollo-NestJS Integration was unable to require @nestjs/graphql package.");
                return;
            }
            /**
       * Iterate over resolvers of NestJS ResolversExplorerService before schemas are constructed.
       */ (0, $jl9W5.fill)(pkg.GraphQLFactory.prototype, "mergeWithSchema", function(orig) {
                return function(...args) {
                    (0, $jl9W5.fill)(this.resolversExplorerService, "explore", function(orig) {
                        return function() {
                            const resolvers = (0, $iMHif.arrayify)(orig.call(this));
                            const instrumentedResolvers = $9db1d7cf4c1db420$var$instrumentResolvers(resolvers, getCurrentHub);
                            return instrumentedResolvers;
                        };
                    });
                    return orig.call(this, ...args);
                };
            });
        } else {
            const pkg = this.loadDependency();
            if (!pkg) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error("Apollo Integration was unable to require apollo-server-core package.");
                return;
            }
            /**
       * Iterate over resolvers of the ApolloServer instance before schemas are constructed.
       */ (0, $jl9W5.fill)(pkg.ApolloServerBase.prototype, "constructSchema", function(orig) {
                return function() {
                    if (!this.config.resolvers) {
                        if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) {
                            if (this.config.schema) {
                                (0, $3lHwZ.logger).warn("Apollo integration is not able to trace `ApolloServer` instances constructed via `schema` property.If you are using NestJS with Apollo, please use `Sentry.Integrations.Apollo({ useNestjs: true })` instead.");
                                (0, $3lHwZ.logger).warn();
                            } else if (this.config.modules) (0, $3lHwZ.logger).warn("Apollo integration is not able to trace `ApolloServer` instances constructed via `modules` property.");
                            (0, $3lHwZ.logger).error("Skipping tracing as no resolvers found on the `ApolloServer` instance.");
                        }
                        return orig.call(this);
                    }
                    const resolvers = (0, $iMHif.arrayify)(this.config.resolvers);
                    this.config.resolvers = $9db1d7cf4c1db420$var$instrumentResolvers(resolvers, getCurrentHub);
                    return orig.call(this);
                };
            });
        }
    }
}
$9db1d7cf4c1db420$export$3db3e396472fda8d.__initStatic();
function $9db1d7cf4c1db420$var$instrumentResolvers(resolvers, getCurrentHub) {
    return resolvers.map((model)=>{
        Object.keys(model).forEach((resolverGroupName)=>{
            Object.keys(model[resolverGroupName]).forEach((resolverName)=>{
                if (typeof model[resolverGroupName][resolverName] !== "function") return;
                $9db1d7cf4c1db420$var$wrapResolver(model, resolverGroupName, resolverName, getCurrentHub);
            });
        });
        return model;
    });
}
/**
 * Wrap a single resolver which can be a parent of other resolvers and/or db operations.
 */ function $9db1d7cf4c1db420$var$wrapResolver(model, resolverGroupName, resolverName, getCurrentHub) {
    (0, $jl9W5.fill)(model[resolverGroupName], resolverName, function(orig) {
        return function(...args) {
            const scope = getCurrentHub().getScope();
            const parentSpan = (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                scope,
                "optionalAccess",
                (_2)=>_2.getSpan,
                "call",
                (_3)=>_3()
            ]);
            const span = (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                parentSpan,
                "optionalAccess",
                (_4)=>_4.startChild,
                "call",
                (_5)=>_5({
                        description: `${resolverGroupName}.${resolverName}`,
                        op: "graphql.resolve"
                    })
            ]);
            const rv = orig.call(this, ...args);
            if ((0, $d2unA.isThenable)(rv)) return rv.then((res)=>{
                (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                    span,
                    "optionalAccess",
                    (_6)=>_6.finish,
                    "call",
                    (_7)=>_7()
                ]);
                return res;
            });
            (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                span,
                "optionalAccess",
                (_8)=>_8.finish,
                "call",
                (_9)=>_9()
            ]);
            return rv;
        };
    });
}


var $78QsC = parcelRequire("78QsC");const $e558e93c06fc1d9e$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $e558e93c06fc1d9e$export$8e9a29865c0a1226(traceparent) {
    const matches = traceparent.match($e558e93c06fc1d9e$export$394a210812ba3012);
    if (!traceparent || !matches) // empty string or no matches is invalid traceparent data
    return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}


var $7JOCn = parcelRequire("7JOCn");
var $5vcgO = parcelRequire("5vcgO");

var $d2unA = parcelRequire("d2unA");

var $3lHwZ = parcelRequire("3lHwZ");
const $046f783c95a5d4ad$export$9ca9946bd449ac06 = "baggage";
const $046f783c95a5d4ad$export$6e69537d67fa20f = "sentry-";
const $046f783c95a5d4ad$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $046f783c95a5d4ad$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $046f783c95a5d4ad$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $d2unA.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $046f783c95a5d4ad$var$baggageHeaderToObject(curr);
        return {
            ...acc,
            ...currBaggageObject
        };
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $046f783c95a5d4ad$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($046f783c95a5d4ad$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($046f783c95a5d4ad$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $046f783c95a5d4ad$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$046f783c95a5d4ad$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $046f783c95a5d4ad$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $046f783c95a5d4ad$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $046f783c95a5d4ad$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $046f783c95a5d4ad$export$bdd844ddb2def819) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}


var $iTlxf = parcelRequire("iTlxf");
var $3lHwZ = parcelRequire("3lHwZ");

var $7JOCn = parcelRequire("7JOCn");

var $3lHwZ = parcelRequire("3lHwZ");

var $bayd0 = parcelRequire("bayd0");
const $909d97243a7baaab$export$56d8a8a25bd48b81 = (0, $bayd0.GLOBAL_OBJ);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $ea62d8976b1bf2a8$export$6f18f55521af71a1() {
    if ((0, $909d97243a7baaab$export$56d8a8a25bd48b81) && (0, $909d97243a7baaab$export$56d8a8a25bd48b81).document) (0, $909d97243a7baaab$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        const activeTransaction = (0, $7JOCn.getActiveTransaction)();
        if ((0, $909d97243a7baaab$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = "cancelled";
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!activeTransaction.status) activeTransaction.setStatus(statusType);
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.finish();
        }
    });
    else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}



var $7JOCn = parcelRequire("7JOCn");

var $52JFH = parcelRequire("52JFH");
var $iTlxf = parcelRequire("iTlxf");
var $3lHwZ = parcelRequire("3lHwZ");

const $30d8b8eb995c33fa$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $d86feac838119868$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $14235d44a0aa2a7e$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $909d97243a7baaab$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $909d97243a7baaab$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(const key in timing)if (key !== "navigationStart" && key !== "toJSON") navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $14235d44a0aa2a7e$export$6431553786c94949 = ()=>{
    if ((0, $909d97243a7baaab$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $909d97243a7baaab$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || $14235d44a0aa2a7e$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $909d97243a7baaab$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4a71edfe0d605336$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $14235d44a0aa2a7e$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $507c2510e2724118$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $14235d44a0aa2a7e$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $909d97243a7baaab$export$56d8a8a25bd48b81).document.prerendering || (0, $4a71edfe0d605336$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else navigationType = navEntry.type.replace(/_/g, "-");
    }
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: (0, $d86feac838119868$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $f54eda09e61f9c79$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e1e162b07d252a50$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $909d97243a7baaab$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener("visibilitychange", onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener("pagehide", onHiddenOrPageHide, true);
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $669bc507acbf4600$export$a7873055838e5ad8 = (onReport)=>{
    const metric = (0, $507c2510e2724118$export$3c29b44508a0612b)("CLS", 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $f54eda09e61f9c79$export$d1203567a167490e)("layout-shift", handleEntries);
    if (po) {
        report = (0, $30d8b8eb995c33fa$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $e1e162b07d252a50$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $d36a687ffea5c9ef$var$firstHiddenTime = -1;
const $d36a687ffea5c9ef$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    return (0, $909d97243a7baaab$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && !(0, $909d97243a7baaab$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $d36a687ffea5c9ef$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $e1e162b07d252a50$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp  })=>{
        $d36a687ffea5c9ef$var$firstHiddenTime = timeStamp;
    }, true);
};
const $d36a687ffea5c9ef$export$443f86b2c77012c4 = ()=>{
    if ($d36a687ffea5c9ef$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $d36a687ffea5c9ef$var$firstHiddenTime = $d36a687ffea5c9ef$var$initHiddenTime();
        $d36a687ffea5c9ef$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $d36a687ffea5c9ef$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $a213474ff840288b$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $d36a687ffea5c9ef$export$443f86b2c77012c4)();
    const metric = (0, $507c2510e2724118$export$3c29b44508a0612b)("FID");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $f54eda09e61f9c79$export$d1203567a167490e)("first-input", handleEntries);
    report = (0, $30d8b8eb995c33fa$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $e1e162b07d252a50$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $39e727b1a30e4519$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $39e727b1a30e4519$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $d36a687ffea5c9ef$export$443f86b2c77012c4)();
    const metric = (0, $507c2510e2724118$export$3c29b44508a0612b)("LCP");
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $4a71edfe0d605336$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $f54eda09e61f9c79$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
    if (po) {
        report = (0, $30d8b8eb995c33fa$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$39e727b1a30e4519$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $39e727b1a30e4519$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach((type)=>{
            addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $e1e162b07d252a50$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};




/**
 * Checks if a given value is a valid measurement value.
 */ function $7cc9c0b1a2add14b$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $7cc9c0b1a2add14b$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp , ...ctx }) {
    if (startTimestamp && transaction.startTimestamp > startTimestamp) transaction.startTimestamp = startTimestamp;
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}


/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $fa61df0a0d10380c$var$msToSec(time) {
    return time / 1000;
}
function $fa61df0a0d10380c$var$getBrowserPerformanceAPI() {
    return (0, $909d97243a7baaab$export$56d8a8a25bd48b81) && (0, $909d97243a7baaab$export$56d8a8a25bd48b81).addEventListener && (0, $909d97243a7baaab$export$56d8a8a25bd48b81).performance;
}
let $fa61df0a0d10380c$var$_performanceCursor = 0;
let $fa61df0a0d10380c$var$_measurements = {};
let $fa61df0a0d10380c$var$_lcpEntry;
let $fa61df0a0d10380c$var$_clsEntry;
/**
 * Start tracking web vitals
 *
 * @returns A function that forces web vitals collection
 */ function $fa61df0a0d10380c$export$7c69f0412d101b88() {
    const performance = $fa61df0a0d10380c$var$getBrowserPerformanceAPI();
    if (performance && (0, $52JFH.browserPerformanceTimeOrigin)) {
        if (performance.mark) (0, $909d97243a7baaab$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        $fa61df0a0d10380c$var$_trackFID();
        const clsCallback = $fa61df0a0d10380c$var$_trackCLS();
        const lcpCallback = $fa61df0a0d10380c$var$_trackLCP();
        return ()=>{
            if (clsCallback) clsCallback();
            if (lcpCallback) lcpCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $fa61df0a0d10380c$export$f396d19077034ad2() {
    const entryHandler = (entries)=>{
        for (const entry of entries){
            const transaction = (0, $7JOCn.getActiveTransaction)();
            if (!transaction) return;
            const startTime = $fa61df0a0d10380c$var$msToSec((0, $52JFH.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = $fa61df0a0d10380c$var$msToSec(entry.duration);
            transaction.startChild({
                description: "Main UI thread blocked",
                op: "ui.long-task",
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    };
    (0, $f54eda09e61f9c79$export$d1203567a167490e)("longtask", entryHandler);
}
/**
 * Start tracking interaction events.
 */ function $fa61df0a0d10380c$export$e27543e0976315e4() {
    const entryHandler = (entries)=>{
        for (const entry of entries){
            const transaction = (0, $7JOCn.getActiveTransaction)();
            if (!transaction) return;
            if (entry.name === "click") {
                const startTime = $fa61df0a0d10380c$var$msToSec((0, $52JFH.browserPerformanceTimeOrigin) + entry.startTime);
                const duration = $fa61df0a0d10380c$var$msToSec(entry.duration);
                transaction.startChild({
                    description: (0, $iTlxf.htmlTreeAsString)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                });
            }
        }
    };
    (0, $f54eda09e61f9c79$export$d1203567a167490e)("event", entryHandler, {
        durationThreshold: 0
    });
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $fa61df0a0d10380c$var$_trackCLS() {
    // See:
    // https://web.dev/evolving-cls/
    // https://web.dev/cls-web-tooling/
    return (0, $669bc507acbf4600$export$a7873055838e5ad8)((metric)=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Measurements] Adding CLS");
        $fa61df0a0d10380c$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $fa61df0a0d10380c$var$_clsEntry = entry;
    });
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $fa61df0a0d10380c$var$_trackLCP() {
    return (0, $39e727b1a30e4519$export$947b1626ab8d5632)((metric)=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Measurements] Adding LCP");
        $fa61df0a0d10380c$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $fa61df0a0d10380c$var$_lcpEntry = entry;
    });
}
/** Starts tracking the First Input Delay on the current page. */ function $fa61df0a0d10380c$var$_trackFID() {
    (0, $a213474ff840288b$export$39705a25c49af873)((metric)=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        const timeOrigin = $fa61df0a0d10380c$var$msToSec((0, $52JFH.browserPerformanceTimeOrigin));
        const startTime = $fa61df0a0d10380c$var$msToSec(entry.startTime);
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Measurements] Adding FID");
        $fa61df0a0d10380c$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $fa61df0a0d10380c$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
/** Add performance related spans to a transaction */ function $fa61df0a0d10380c$export$5f8fa6b3467a7443(transaction) {
    const performance = $fa61df0a0d10380c$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $909d97243a7baaab$export$56d8a8a25bd48b81).performance.getEntries || !(0, $52JFH.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = $fa61df0a0d10380c$var$msToSec((0, $52JFH.browserPerformanceTimeOrigin));
    const performanceEntries = performance.getEntries();
    let responseStartTimestamp;
    let requestStartTimestamp;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($fa61df0a0d10380c$var$_performanceCursor).forEach((entry)=>{
        const startTime = $fa61df0a0d10380c$var$msToSec(entry.startTime);
        const duration = $fa61df0a0d10380c$var$msToSec(entry.duration);
        if (transaction.op === "navigation" && timeOrigin + startTime < transaction.startTimestamp) return;
        switch(entry.entryType){
            case "navigation":
                $fa61df0a0d10380c$var$_addNavigationSpans(transaction, entry, timeOrigin);
                responseStartTimestamp = timeOrigin + $fa61df0a0d10380c$var$msToSec(entry.responseStart);
                requestStartTimestamp = timeOrigin + $fa61df0a0d10380c$var$msToSec(entry.requestStart);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $fa61df0a0d10380c$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $d36a687ffea5c9ef$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Measurements] Adding FP");
                        $fa61df0a0d10380c$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Measurements] Adding FCP");
                        $fa61df0a0d10380c$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                {
                    const resourceName = entry.name.replace((0, $909d97243a7baaab$export$56d8a8a25bd48b81).location.origin, "");
                    $fa61df0a0d10380c$export$c82fe1a70634f317(transaction, entry, resourceName, startTime, duration, timeOrigin);
                    break;
                }
        }
    });
    $fa61df0a0d10380c$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $fa61df0a0d10380c$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (transaction.op === "pageload") {
        // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
        // start of the response in milliseconds
        if (typeof responseStartTimestamp === "number") {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Measurements] Adding TTFB");
            $fa61df0a0d10380c$var$_measurements["ttfb"] = {
                value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
                unit: "millisecond"
            };
            if (typeof requestStartTimestamp === "number" && requestStartTimestamp <= responseStartTimestamp) // Capture the time spent making the request and receiving the first byte of the response.
            // This is the time between the start of the request and the start of the response in milliseconds.
            $fa61df0a0d10380c$var$_measurements["ttfb.requestTime"] = {
                value: (responseStartTimestamp - requestStartTimestamp) * 1000,
                unit: "millisecond"
            };
        }
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach((name)=>{
            if (!$fa61df0a0d10380c$var$_measurements[name] || timeOrigin >= transaction.startTimestamp) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $fa61df0a0d10380c$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $fa61df0a0d10380c$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
            const delta = normalizedValue - oldValue;
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $fa61df0a0d10380c$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $fa61df0a0d10380c$var$_measurements["mark.fid"];
        if (fidMark && $fa61df0a0d10380c$var$_measurements["fid"]) {
            // create span for FID
            (0, $7cc9c0b1a2add14b$export$8bd469e1f37aa721)(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + $fa61df0a0d10380c$var$msToSec($fa61df0a0d10380c$var$_measurements["fid"].value),
                op: "ui.action",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $fa61df0a0d10380c$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in $fa61df0a0d10380c$var$_measurements)) delete $fa61df0a0d10380c$var$_measurements.cls;
        Object.keys($fa61df0a0d10380c$var$_measurements).forEach((measurementName)=>{
            transaction.setMeasurement(measurementName, $fa61df0a0d10380c$var$_measurements[measurementName].value, $fa61df0a0d10380c$var$_measurements[measurementName].unit);
        });
        $fa61df0a0d10380c$var$_tagMetricInfo(transaction);
    }
    $fa61df0a0d10380c$var$_lcpEntry = undefined;
    $fa61df0a0d10380c$var$_clsEntry = undefined;
    $fa61df0a0d10380c$var$_measurements = {};
}
/** Create measure related spans */ function $fa61df0a0d10380c$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $7cc9c0b1a2add14b$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $fa61df0a0d10380c$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $fa61df0a0d10380c$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $fa61df0a0d10380c$var$_addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $fa61df0a0d10380c$var$_addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $fa61df0a0d10380c$var$_addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    $fa61df0a0d10380c$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $fa61df0a0d10380c$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $7cc9c0b1a2add14b$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        description: description || event,
        startTimestamp: timeOrigin + $fa61df0a0d10380c$var$msToSec(start),
        endTimestamp: timeOrigin + $fa61df0a0d10380c$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $fa61df0a0d10380c$var$_addRequest(transaction, entry, timeOrigin) {
    (0, $7cc9c0b1a2add14b$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        description: "request",
        startTimestamp: timeOrigin + $fa61df0a0d10380c$var$msToSec(entry.requestStart),
        endTimestamp: timeOrigin + $fa61df0a0d10380c$var$msToSec(entry.responseEnd)
    });
    (0, $7cc9c0b1a2add14b$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        description: "response",
        startTimestamp: timeOrigin + $fa61df0a0d10380c$var$msToSec(entry.responseStart),
        endTimestamp: timeOrigin + $fa61df0a0d10380c$var$msToSec(entry.responseEnd)
    });
}
/** Create resource-related spans */ function $fa61df0a0d10380c$export$c82fe1a70634f317(transaction, entry, resourceName, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    if ("transferSize" in entry) data["http.response_transfer_size"] = entry.transferSize;
    if ("encodedBodySize" in entry) data["http.response_content_length"] = entry.encodedBodySize;
    if ("decodedBodySize" in entry) data["http.decoded_response_content_length"] = entry.decodedBodySize;
    if ("renderBlockingStatus" in entry) data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $7cc9c0b1a2add14b$export$8bd469e1f37aa721)(transaction, {
        description: resourceName,
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $fa61df0a0d10380c$var$_trackNavigator(transaction) {
    const navigator = (0, $909d97243a7baaab$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) transaction.setTag("effectiveConnectionType", connection.effectiveType);
        if (connection.type) transaction.setTag("connectionType", connection.type);
        if ((0, $7cc9c0b1a2add14b$export$27169ccae1b439e3)(connection.rtt)) $fa61df0a0d10380c$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $7cc9c0b1a2add14b$export$27169ccae1b439e3)(navigator.deviceMemory)) transaction.setTag("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $7cc9c0b1a2add14b$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $fa61df0a0d10380c$var$_tagMetricInfo(transaction) {
    if ($fa61df0a0d10380c$var$_lcpEntry) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($fa61df0a0d10380c$var$_lcpEntry.element) transaction.setTag("lcp.element", (0, $iTlxf.htmlTreeAsString)($fa61df0a0d10380c$var$_lcpEntry.element));
        if ($fa61df0a0d10380c$var$_lcpEntry.id) transaction.setTag("lcp.id", $fa61df0a0d10380c$var$_lcpEntry.id);
        if ($fa61df0a0d10380c$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        transaction.setTag("lcp.url", $fa61df0a0d10380c$var$_lcpEntry.url.trim().slice(0, 200));
        transaction.setTag("lcp.size", $fa61df0a0d10380c$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($fa61df0a0d10380c$var$_clsEntry && $fa61df0a0d10380c$var$_clsEntry.sources) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("[Measurements] Adding CLS Data");
        $fa61df0a0d10380c$var$_clsEntry.sources.forEach((source, index)=>transaction.setTag(`cls.source.${index + 1}`, (0, $iTlxf.htmlTreeAsString)(source.node)));
    }
}



var $kDFdm = parcelRequire("kDFdm");
var $1DvVX = parcelRequire("1DvVX");

var $cIWhk = parcelRequire("cIWhk");
var $d2unA = parcelRequire("d2unA");
var $geIBs = parcelRequire("geIBs");
/* eslint-disable max-lines */ const $343ed8995d3b3c18$export$15bd0305d05ad07b = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $343ed8995d3b3c18$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    // TODO (v8): Remove this property
    tracingOrigins: $343ed8995d3b3c18$export$15bd0305d05ad07b,
    tracePropagationTargets: $343ed8995d3b3c18$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $343ed8995d3b3c18$export$864489cb3478db3e(_options) {
    // eslint-disable-next-line deprecation/deprecation
    const { traceFetch: traceFetch , traceXHR: traceXHR , tracePropagationTargets: tracePropagationTargets , tracingOrigins: tracingOrigins , shouldCreateSpanForRequest: shouldCreateSpanForRequest  } = {
        traceFetch: $343ed8995d3b3c18$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $343ed8995d3b3c18$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$343ed8995d3b3c18$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $cIWhk.addInstrumentationHandler)("fetch", (handlerData)=>{
        $343ed8995d3b3c18$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
    if (traceXHR) (0, $cIWhk.addInstrumentationHandler)("xhr", (handlerData)=>{
        $343ed8995d3b3c18$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $343ed8995d3b3c18$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $geIBs.stringMatchesSomePattern)(url, tracePropagationTargets || $343ed8995d3b3c18$export$15bd0305d05ad07b);
}
/**
 * Create and track fetch request spans
 */ function $343ed8995d3b3c18$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    if (!(0, $1DvVX.hasTracingEnabled)() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) return;
    if (handlerData.endTimestamp) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            if (handlerData.response) {
                // TODO (kmclb) remove this once types PR goes through
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                span.setHttpStatus(handlerData.response.status);
                const contentLength = // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
                const contentLengthNum = parseInt(contentLength);
                if (contentLengthNum > 0) span.setData("http.response_content_length", contentLengthNum);
            } else if (handlerData.error) span.setStatus("internal_error");
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    const currentScope = (0, $kDFdm.getCurrentHub)().getScope();
    const currentSpan = currentScope && currentScope.getSpan();
    const activeTransaction = currentSpan && currentSpan.transaction;
    if (currentSpan && activeTransaction) {
        const { method: method , url: url  } = handlerData.fetchData;
        const span = currentSpan.startChild({
            data: {
                url: url,
                type: "fetch",
                "http.method": method
            },
            description: `${method} ${url}`,
            op: "http.client"
        });
        handlerData.fetchData.__span = span.spanId;
        spans[span.spanId] = span;
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        if (shouldAttachHeaders(handlerData.fetchData.url)) options.headers = $343ed8995d3b3c18$export$6717acf674206871(request, activeTransaction.getDynamicSamplingContext(), span, options);
    }
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $343ed8995d3b3c18$export$6717acf674206871(request, dynamicSamplingContext, span, options) {
    const sentryBaggageHeader = (0, $046f783c95a5d4ad$export$56766feef403f365)(dynamicSamplingContext);
    const sentryTraceHeader = span.toTraceparent();
    const headers = typeof Request !== "undefined" && (0, $d2unA.isInstanceOf)(request, Request) ? request.headers : options.headers;
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $d2unA.isInstanceOf)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $046f783c95a5d4ad$export$9ca9946bd449ac06), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $046f783c95a5d4ad$export$9ca9946bd449ac06),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}
/**
 * Create and track xhr request spans
 */ function $343ed8995d3b3c18$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $cIWhk.SENTRY_XHR_DATA_KEY];
    if (!(0, $1DvVX.hasTracingEnabled)() || xhr && xhr.__sentry_own_request__ || !(xhr && sentryXhrData && shouldCreateSpan(sentryXhrData.url))) return;
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            span.setHttpStatus(sentryXhrData.status_code);
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    const currentScope = (0, $kDFdm.getCurrentHub)().getScope();
    const currentSpan = currentScope && currentScope.getSpan();
    const activeTransaction = currentSpan && currentSpan.transaction;
    if (currentSpan && activeTransaction) {
        const span = currentSpan.startChild({
            data: {
                ...sentryXhrData.data,
                type: "xhr",
                "http.method": sentryXhrData.method,
                url: sentryXhrData.url
            },
            description: `${sentryXhrData.method} ${sentryXhrData.url}`,
            op: "http.client"
        });
        xhr.__sentry_xhr_span_id__ = span.spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
        if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url)) try {
            xhr.setRequestHeader("sentry-trace", span.toTraceparent());
            const dynamicSamplingContext = activeTransaction.getDynamicSamplingContext();
            const sentryBaggageHeader = (0, $046f783c95a5d4ad$export$56766feef403f365)(dynamicSamplingContext);
            if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
            // We can therefore simply set a baggage header without checking what was there before
            // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
            xhr.setRequestHeader((0, $046f783c95a5d4ad$export$9ca9946bd449ac06), sentryBaggageHeader);
        } catch (_) {
        // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
        }
    }
}



var $cIWhk = parcelRequire("cIWhk");
var $52JFH = parcelRequire("52JFH");
var $3lHwZ = parcelRequire("3lHwZ");

/**
 * Default function implementing pageload and navigation transactions
 */ function $a02d342278ee3c13$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $909d97243a7baaab$export$56d8a8a25bd48b81) || !(0, $909d97243a7baaab$export$56d8a8a25bd48b81).location) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn("Could not initialize routing instrumentation due to invalid location");
        return;
    }
    let startingUrl = (0, $909d97243a7baaab$export$56d8a8a25bd48b81).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $909d97243a7baaab$export$56d8a8a25bd48b81).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $52JFH.browserPerformanceTimeOrigin) ? (0, $52JFH.browserPerformanceTimeOrigin) / 1000 : undefined,
        op: "pageload",
        metadata: {
            source: "url"
        }
    });
    if (startTransactionOnLocationChange) (0, $cIWhk.addInstrumentationHandler)("history", ({ to: to , from: from  })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.finish();
            }
            activeTransaction = customStartTransaction({
                name: (0, $909d97243a7baaab$export$56d8a8a25bd48b81).location.pathname,
                op: "navigation",
                metadata: {
                    source: "url"
                }
            });
        }
    });
}



const $8b34a7b6bfadb479$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ const $8b34a7b6bfadb479$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $5vcgO.TRACING_DEFAULTS),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $a02d342278ee3c13$export$86649cc09fe75143),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    _experiments: {},
    ...(0, $343ed8995d3b3c18$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */ class $8b34a7b6bfadb479$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ __init() {
        this.name = $8b34a7b6bfadb479$export$bbd2089f30bd3708;
    }
    constructor(_options){
        $8b34a7b6bfadb479$export$46d3bbd0375f5fa4.prototype.__init.call(this);
        (0, $78QsC.addTracingExtensions)();
        this.options = {
            ...$8b34a7b6bfadb479$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $fa61df0a0d10380c$export$7c69f0412d101b88)();
        if (this.options.enableLongTask) (0, $fa61df0a0d10380c$export$f396d19077034ad2)();
        if (this.options._experiments.enableInteractions) (0, $fa61df0a0d10380c$export$e27543e0976315e4)();
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const { routingInstrumentation: instrumentRouting , startTransactionOnLocationChange: startTransactionOnLocationChange , startTransactionOnPageLoad: startTransactionOnPageLoad , markBackgroundTransactions: markBackgroundTransactions , traceFetch: traceFetch , traceXHR: traceXHR , tracePropagationTargets: tracePropagationTargets , shouldCreateSpanForRequest: shouldCreateSpanForRequest , _experiments: _experiments  } = this.options;
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $ea62d8976b1bf2a8$export$6f18f55521af71a1)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        (0, $343ed8995d3b3c18$export$864489cb3478db3e)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const { beforeNavigate: beforeNavigate , idleTimeout: idleTimeout , finalTimeout: finalTimeout , heartbeatInterval: heartbeatInterval  } = this.options;
        const isPageloadTransaction = context.op === "pageload";
        const sentryTraceMetaTagValue = isPageloadTransaction ? $8b34a7b6bfadb479$export$f147b32b03c9cf11("sentry-trace") : null;
        const baggageMetaTagValue = isPageloadTransaction ? $8b34a7b6bfadb479$export$f147b32b03c9cf11("baggage") : null;
        const traceParentData = sentryTraceMetaTagValue ? (0, $e558e93c06fc1d9e$export$8e9a29865c0a1226)(sentryTraceMetaTagValue) : undefined;
        const dynamicSamplingContext = baggageMetaTagValue ? (0, $046f783c95a5d4ad$export$5b96ee2c8421f107)(baggageMetaTagValue) : undefined;
        const expandedContext = {
            ...context,
            ...traceParentData,
            metadata: {
                ...context.metadata,
                dynamicSamplingContext: traceParentData && !dynamicSamplingContext ? {} : dynamicSamplingContext
            },
            trimEnd: true
        };
        const modifiedContext = typeof beforeNavigate === "function" ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        this._latestRouteName = finalContext.name;
        this._latestRouteSource = finalContext.metadata && finalContext.metadata.source;
        if (finalContext.sampled === false) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const hub = this._getCurrentHub();
        const { location: location  } = (0, $909d97243a7baaab$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $78QsC.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $fa61df0a0d10380c$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout , finalTimeout: finalTimeout , heartbeatInterval: heartbeatInterval  } = this.options;
            const op = "ui.action.click";
            const currentTransaction = (0, $7JOCn.getActiveTransaction)();
            if (currentTransaction && currentTransaction.op && [
                "navigation",
                "pageload"
            ].includes(currentTransaction.op)) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason("interactionInterrupted");
                inflightInteractionTransaction.finish();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRouteName) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location  } = (0, $909d97243a7baaab$export$56d8a8a25bd48b81);
            const context = {
                name: this._latestRouteName,
                op: op,
                trimEnd: true,
                metadata: {
                    source: this._latestRouteSource || "url"
                }
            };
            inflightInteractionTransaction = (0, $78QsC.startIdleTransaction)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            "click"
        ].forEach((type)=>{
            addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
}
/** Returns the value of a meta tag */ function $8b34a7b6bfadb479$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $iTlxf.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : null;
}



var $d2unA = parcelRequire("d2unA");


const $707d688d11665c6a$var$DEFAULT_INCLUDES = {
    ip: false,
    request: true,
    transaction: true,
    user: true
};
const $707d688d11665c6a$var$DEFAULT_REQUEST_INCLUDES = [
    "cookies",
    "data",
    "headers",
    "method",
    "query_string",
    "url"
];
const $707d688d11665c6a$var$DEFAULT_USER_INCLUDES = [
    "id",
    "username",
    "email"
];
/**
 * Sets parameterized route as transaction name e.g.: `GET /users/:id`
 * Also adds more context data on the transaction from the request
 */ function $707d688d11665c6a$export$1973410ef8793cd6(transaction, req, deps) {
    if (!transaction) return;
    if (!transaction.metadata.source || transaction.metadata.source === "url") // Attempt to grab a parameterized route off of the request
    transaction.setName(...$707d688d11665c6a$export$8c5ebee2e5bb9575(req, {
        path: true,
        method: true
    }));
    transaction.setData("url", req.originalUrl || req.url);
    if (req.baseUrl) transaction.setData("baseUrl", req.baseUrl);
    transaction.setData("query", $707d688d11665c6a$var$extractQueryParams(req, deps));
}
/**
 * Extracts a complete and parameterized path from the request object and uses it to construct transaction name.
 * If the parameterized transaction name cannot be extracted, we fall back to the raw URL.
 *
 * Additionally, this function determines and returns the transaction name source
 *
 * eg. GET /mountpoint/user/:id
 *
 * @param req A request object
 * @param options What to include in the transaction name (method, path, or a custom route name to be
 *                used instead of the request's route)
 *
 * @returns A tuple of the fully constructed transaction name [0] and its source [1] (can be either 'route' or 'url')
 */ function $707d688d11665c6a$export$8c5ebee2e5bb9575(req, options = {}) {
    const method = req.method && req.method.toUpperCase();
    let path = "";
    let source = "url";
    // Check to see if there's a parameterized route we can use (as there is in Express)
    if (options.customRoute || req.route) {
        path = options.customRoute || `${req.baseUrl || ""}${req.route && req.route.path}`;
        source = "route";
    } else if (req.originalUrl || req.url) path = (0, $0ea526eae9bcadb2$export$ce084c78234bd35)(req.originalUrl || req.url || "");
    let name = "";
    if (options.method && method) name += method;
    if (options.method && options.path) name += " ";
    if (options.path && path) name += path;
    return [
        name,
        source
    ];
}
/** JSDoc */ function $707d688d11665c6a$var$extractTransaction(req, type) {
    switch(type){
        case "path":
            return $707d688d11665c6a$export$8c5ebee2e5bb9575(req, {
                path: true
            })[0];
        case "handler":
            return req.route && req.route.stack && req.route.stack[0] && req.route.stack[0].name || "<anonymous>";
        case "methodPath":
        default:
            return $707d688d11665c6a$export$8c5ebee2e5bb9575(req, {
                path: true,
                method: true
            })[0];
    }
}
/** JSDoc */ function $707d688d11665c6a$var$extractUserData(user, keys) {
    const extractedUser = {};
    const attributes = Array.isArray(keys) ? keys : $707d688d11665c6a$var$DEFAULT_USER_INCLUDES;
    attributes.forEach((key)=>{
        if (user && key in user) extractedUser[key] = user[key];
    });
    return extractedUser;
}
/**
 * Normalize data from the request object, accounting for framework differences.
 *
 * @param req The request object from which to extract data
 * @param options.include An optional array of keys to include in the normalized data. Defaults to
 * DEFAULT_REQUEST_INCLUDES if not provided.
 * @param options.deps Injected, platform-specific dependencies
 * @returns An object containing normalized request data
 */ function $707d688d11665c6a$export$b5c5d78255f11c84(req, options) {
    const { include: include = $707d688d11665c6a$var$DEFAULT_REQUEST_INCLUDES , deps: deps  } = options || {};
    const requestData = {};
    // headers:
    //   node, express, koa, nextjs: req.headers
    const headers = req.headers || {};
    // method:
    //   node, express, koa, nextjs: req.method
    const method = req.method;
    // host:
    //   express: req.hostname in > 4 and req.host in < 4
    //   koa: req.host
    //   node, nextjs: req.headers.host
    const host = req.hostname || req.host || headers.host || "<no host>";
    // protocol:
    //   node, nextjs: <n/a>
    //   express, koa: req.protocol
    const protocol = req.protocol === "https" || req.socket && req.socket.encrypted ? "https" : "http";
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    const originalUrl = req.originalUrl || req.url || "";
    // absolute url
    const absoluteUrl = `${protocol}://${host}${originalUrl}`;
    include.forEach((key)=>{
        switch(key){
            case "headers":
                requestData.headers = headers;
                break;
            case "method":
                requestData.method = method;
                break;
            case "url":
                requestData.url = absoluteUrl;
                break;
            case "cookies":
                // cookies:
                //   node, express, koa: req.headers.cookie
                //   vercel, sails.js, express (w/ cookie middleware), nextjs: req.cookies
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.cookies = // TODO (v8 / #5257): We're only sending the empty object for backwards compatibility, so the last bit can
                // come off in v8
                req.cookies || headers.cookie && deps && deps.cookie && deps.cookie.parse(headers.cookie) || {};
                break;
            case "query_string":
                // query string:
                //   node: req.url (raw)
                //   express, koa, nextjs: req.query
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.query_string = $707d688d11665c6a$var$extractQueryParams(req, deps);
                break;
            case "data":
                if (method === "GET" || method === "HEAD") break;
                // body data:
                //   express, koa, nextjs: req.body
                //
                //   when using node by itself, you have to read the incoming stream(see
                //   https://nodejs.dev/learn/get-http-request-body-data-using-nodejs); if a user is doing that, we can't know
                //   where they're going to store the final result, so they'll have to capture this data themselves
                if (req.body !== undefined) requestData.data = (0, $d2unA.isString)(req.body) ? req.body : JSON.stringify((0, $fa9ac95e0af8817a$export$a3295358bff77e)(req.body));
                break;
            default:
                if (({}).hasOwnProperty.call(req, key)) requestData[key] = req[key];
        }
    });
    return requestData;
}
/**
 * Options deciding what parts of the request to use when enhancing an event
 */ /**
 * Add data from the given request to the given event
 *
 * @param event The event to which the request data will be added
 * @param req Request object
 * @param options.include Flags to control what data is included
 * @param options.deps Injected platform-specific dependencies
 * @hidden
 */ function $707d688d11665c6a$export$e560aeb323d2791d(event, req, options) {
    const include = {
        ...$707d688d11665c6a$var$DEFAULT_INCLUDES,
        ...options && options.include
    };
    if (include.request) {
        const extractedRequestData = Array.isArray(include.request) ? $707d688d11665c6a$export$b5c5d78255f11c84(req, {
            include: include.request,
            deps: options && options.deps
        }) : $707d688d11665c6a$export$b5c5d78255f11c84(req, {
            deps: options && options.deps
        });
        event.request = {
            ...event.request,
            ...extractedRequestData
        };
    }
    if (include.user) {
        const extractedUser = req.user && (0, $d2unA.isPlainObject)(req.user) ? $707d688d11665c6a$var$extractUserData(req.user, include.user) : {};
        if (Object.keys(extractedUser).length) event.user = {
            ...event.user,
            ...extractedUser
        };
    }
    // client ip:
    //   node, nextjs: req.socket.remoteAddress
    //   express, koa: req.ip
    if (include.ip) {
        const ip = req.ip || req.socket && req.socket.remoteAddress;
        if (ip) event.user = {
            ...event.user,
            ip_address: ip
        };
    }
    if (include.transaction && !event.transaction) // TODO do we even need this anymore?
    // TODO make this work for nextjs
    event.transaction = $707d688d11665c6a$var$extractTransaction(req, include.transaction);
    return event;
}
function $707d688d11665c6a$var$extractQueryParams(req, deps) {
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    let originalUrl = req.originalUrl || req.url || "";
    if (!originalUrl) return;
    // The `URL` constructor can't handle internal URLs of the form `/some/path/here`, so stick a dummy protocol and
    // hostname on the beginning. Since the point here is just to grab the query string, it doesn't matter what we use.
    if (originalUrl.startsWith("/")) originalUrl = `http://dogs.are.great${originalUrl}`;
    return req.query || (URL, new URL(originalUrl).search.replace("?", "")) || // In Node 8, `URL` isn't in the global scope, so we have to use the built-in module from Node
    deps && deps.url && deps.url.parse(originalUrl).query || undefined;
}


var $d2unA = parcelRequire("d2unA");
var $3lHwZ = parcelRequire("3lHwZ");

/**
 * Express integration
 *
 * Provides an request and error handler for Express framework as well as tracing capabilities
 */ class $02bf5b506c7e167f$export$6dafdd8fec05099d {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Express";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $02bf5b506c7e167f$export$6dafdd8fec05099d.id;
    }
    /**
   * Express App instance
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        $02bf5b506c7e167f$export$6dafdd8fec05099d.prototype.__init.call(this);
        this._router = options.router || options.app;
        this._methods = (Array.isArray(options.methods) ? options.methods : []).concat("use");
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if (!this._router) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error("ExpressIntegration is missing an Express instance");
            return;
        }
        if ((0, $bf9aff04975118a7$export$34db76d03eb96b7e)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("Express Integration is skipped because of instrumenter configuration.");
            return;
        }
        $02bf5b506c7e167f$var$instrumentMiddlewares(this._router, this._methods);
        $02bf5b506c7e167f$var$instrumentRouter(this._router);
    }
}
$02bf5b506c7e167f$export$6dafdd8fec05099d.__initStatic();
/**
 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
 * and finishes it once the middleware is done invoking.
 *
 * Express middlewares have 3 various forms, thus we have to take care of all of them:
 * // sync
 * app.use(function (req, res) { ... })
 * // async
 * app.use(function (req, res, next) { ... })
 * // error handler
 * app.use(function (err, req, res, next) { ... })
 *
 * They all internally delegate to the `router[method]` of the given application instance.
 */ // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
function $02bf5b506c7e167f$var$wrap(fn, method) {
    const arity = fn.length;
    switch(arity){
        case 2:
            return function(req, res) {
                const transaction = res.__sentry_transaction;
                if (transaction) {
                    const span = transaction.startChild({
                        description: fn.name,
                        op: `middleware.express.${method}`
                    });
                    res.once("finish", ()=>{
                        span.finish();
                    });
                }
                return fn.call(this, req, res);
            };
        case 3:
            return function(req, res, next) {
                const transaction = res.__sentry_transaction;
                const span = (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                    transaction,
                    "optionalAccess",
                    (_2)=>_2.startChild,
                    "call",
                    (_3)=>_3({
                            description: fn.name,
                            op: `middleware.express.${method}`
                        })
                ]);
                fn.call(this, req, res, function(...args) {
                    (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_4)=>_4.finish,
                        "call",
                        (_5)=>_5()
                    ]);
                    next.call(this, ...args);
                });
            };
        case 4:
            return function(err, req, res, next) {
                const transaction = res.__sentry_transaction;
                const span = (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                    transaction,
                    "optionalAccess",
                    (_6)=>_6.startChild,
                    "call",
                    (_7)=>_7({
                            description: fn.name,
                            op: `middleware.express.${method}`
                        })
                ]);
                fn.call(this, err, req, res, function(...args) {
                    (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_8)=>_8.finish,
                        "call",
                        (_9)=>_9()
                    ]);
                    next.call(this, ...args);
                });
            };
        default:
            throw new Error(`Express middleware takes 2-4 arguments. Got: ${arity}`);
    }
}
/**
 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
 * and wraps every function, as well as array of functions with a call to our `wrap` method.
 * We have to take care of the arrays as well as iterate over all of the arguments,
 * as `app.use` can accept middlewares in few various forms.
 *
 * app.use([<path>], <fn>)
 * app.use([<path>], <fn>, ...<fn>)
 * app.use([<path>], ...<fn>[])
 */ function $02bf5b506c7e167f$var$wrapMiddlewareArgs(args, method) {
    return args.map((arg)=>{
        if (typeof arg === "function") return $02bf5b506c7e167f$var$wrap(arg, method);
        if (Array.isArray(arg)) return arg.map((a)=>{
            if (typeof a === "function") return $02bf5b506c7e167f$var$wrap(a, method);
            return a;
        });
        return arg;
    });
}
/**
 * Patches original router to utilize our tracing functionality
 */ function $02bf5b506c7e167f$var$patchMiddleware(router, method) {
    const originalCallback = router[method];
    router[method] = function(...args) {
        return originalCallback.call(this, ...$02bf5b506c7e167f$var$wrapMiddlewareArgs(args, method));
    };
    return router;
}
/**
 * Patches original router methods
 */ function $02bf5b506c7e167f$var$instrumentMiddlewares(router, methods = []) {
    methods.forEach((method)=>$02bf5b506c7e167f$var$patchMiddleware(router, method));
}
/**
 * Patches the prototype of Express.Router to accumulate the resolved route
 * if a layer instance's `match` function was called and it returned a successful match.
 *
 * @see https://github.com/expressjs/express/blob/master/lib/router/index.js
 *
 * @param appOrRouter the router instance which can either be an app (i.e. top-level) or a (nested) router.
 */ function $02bf5b506c7e167f$var$instrumentRouter(appOrRouter) {
    // This is how we can distinguish between app and routers
    const isApp = "settings" in appOrRouter;
    // In case the app's top-level router hasn't been initialized yet, we have to do it now
    if (isApp && appOrRouter._router === undefined && appOrRouter.lazyrouter) appOrRouter.lazyrouter();
    const router = isApp ? appOrRouter._router : appOrRouter;
    if (!router) {
        /*
    If we end up here, this means likely that this integration is used with Express 3 or Express 5.
    For now, we don't support these versions (3 is very old and 5 is still in beta). To support Express 5,
    we'd need to make more changes to the routing instrumentation because the router is no longer part of
    the Express core package but maintained in its own package. The new router has different function
    signatures and works slightly differently, demanding more changes than just taking the router from
    `app.router` instead of `app._router`.
    @see https://github.com/pillarjs/router

    TODO: Proper Express 5 support
    */ (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).debug("Cannot instrument router for URL Parameterization (did not find a valid router).");
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).debug("Routing instrumentation is currently only supported in Express 4.");
        return;
    }
    const routerProto = Object.getPrototypeOf(router);
    const originalProcessParams = routerProto.process_params;
    routerProto.process_params = function process_params(layer, called, req, res, done) {
        // Base case: We're in the first part of the URL (thus we start with the root '/')
        if (!req._reconstructedRoute) req._reconstructedRoute = "";
        // If the layer's partial route has params, is a regex or an array, the route is stored in layer.route.
        const { layerRoutePath: layerRoutePath , isRegex: isRegex , isArray: isArray , numExtraSegments: numExtraSegments  } = $02bf5b506c7e167f$var$getLayerRoutePathInfo(layer);
        if (layerRoutePath || isRegex || isArray) req._hasParameters = true;
        // Otherwise, the hardcoded path (i.e. a partial route without params) is stored in layer.path
        const partialRoute = layerRoutePath || layer.path || "";
        // Normalize the partial route so that it doesn't contain leading or trailing slashes
        // and exclude empty or '*' wildcard routes.
        // The exclusion of '*' routes is our best effort to not "pollute" the transaction name
        // with interim handlers (e.g. ones that check authentication or do other middleware stuff).
        // We want to end up with the parameterized URL of the incoming request without any extraneous path segments.
        const finalPartialRoute = partialRoute.split("/").filter((segment)=>segment.length > 0 && (isRegex || isArray || !segment.includes("*"))).join("/");
        // If we found a valid partial URL, we append it to the reconstructed route
        if (finalPartialRoute && finalPartialRoute.length > 0) // If the partial route is from a regex route, we append a '/' to close the regex
        req._reconstructedRoute += `/${finalPartialRoute}${isRegex ? "/" : ""}`;
        // Now we check if we are in the "last" part of the route. We determine this by comparing the
        // number of URL segments from the original URL to that of our reconstructed parameterized URL.
        // If we've reached our final destination, we update the transaction name.
        const urlLength = (0, $0ea526eae9bcadb2$export$69dd85280a8d374c)(req.originalUrl || "") + numExtraSegments;
        const routeLength = (0, $0ea526eae9bcadb2$export$69dd85280a8d374c)(req._reconstructedRoute);
        if (urlLength === routeLength) {
            if (!req._hasParameters) {
                if (req._reconstructedRoute !== req.originalUrl) req._reconstructedRoute = req.originalUrl ? (0, $0ea526eae9bcadb2$export$ce084c78234bd35)(req.originalUrl) : req.originalUrl;
            }
            const transaction = res.__sentry_transaction;
            if (transaction && transaction.metadata.source !== "custom") {
                // If the request URL is '/' or empty, the reconstructed route will be empty.
                // Therefore, we fall back to setting the final route to '/' in this case.
                const finalRoute = req._reconstructedRoute || "/";
                transaction.setName(...(0, $707d688d11665c6a$export$8c5ebee2e5bb9575)(req, {
                    path: true,
                    method: true,
                    customRoute: finalRoute
                }));
            }
        }
        return originalProcessParams.call(this, layer, called, req, res, done);
    };
}
/**
 * Extracts and stringifies the layer's route which can either be a string with parameters (`users/:id`),
 * a RegEx (`/test/`) or an array of strings and regexes (`['/path1', /\/path[2-5]/, /path/:id]`). Additionally
 * returns extra information about the route, such as if the route is defined as regex or as an array.
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns an object containing the stringified route, a flag determining if the route was a regex
 *          and the number of extra segments to the matched path that are additionally in the route,
 *          if the route was an array (defaults to 0).
 */ function $02bf5b506c7e167f$var$getLayerRoutePathInfo(layer) {
    const lrp = (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
        layer,
        "access",
        (_10)=>_10.route,
        "optionalAccess",
        (_11)=>_11.path
    ]);
    const isRegex = (0, $d2unA.isRegExp)(lrp);
    const isArray = Array.isArray(lrp);
    if (!lrp) return {
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: 0
    };
    const numExtraSegments = isArray ? Math.max($02bf5b506c7e167f$var$getNumberOfArrayUrlSegments(lrp) - (0, $0ea526eae9bcadb2$export$69dd85280a8d374c)(layer.path || ""), 0) : 0;
    const layerRoutePath = $02bf5b506c7e167f$var$getLayerRoutePathString(isArray, lrp);
    return {
        layerRoutePath: layerRoutePath,
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: numExtraSegments
    };
}
/**
 * Returns the number of URL segments in an array of routes
 *
 * Example: ['/api/test', /\/api\/post[0-9]/, '/users/:id/details`] -> 7
 */ function $02bf5b506c7e167f$var$getNumberOfArrayUrlSegments(routesArray) {
    return routesArray.reduce((accNumSegments, currentRoute)=>{
        // array members can be a RegEx -> convert them toString
        return accNumSegments + (0, $0ea526eae9bcadb2$export$69dd85280a8d374c)(currentRoute.toString());
    }, 0);
}
/**
 * Extracts and returns the stringified version of the layers route path
 * Handles route arrays (by joining the paths together) as well as RegExp and normal
 * string values (in the latter case the toString conversion is technically unnecessary but
 * it doesn't hurt us either).
 */ function $02bf5b506c7e167f$var$getLayerRoutePathString(isArray, lrp) {
    if (isArray) return lrp.map((r)=>r.toString()).join(",");
    return lrp && lrp.toString();
}


var $7JOCn = parcelRequire("7JOCn");

var $jl9W5 = parcelRequire("jl9W5");
var $d2unA = parcelRequire("d2unA");
var $6QG3c = parcelRequire("6QG3c");
var $3lHwZ = parcelRequire("3lHwZ");

/** Tracing integration for graphql package */ class $3943438ea2cdb67f$export$b735d011553f1049 {
    constructor(){
        $3943438ea2cdb67f$export$b735d011553f1049.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "GraphQL";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $3943438ea2cdb67f$export$b735d011553f1049.id;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $6QG3c.loadModule)("graphql/execution/execute.js");
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $bf9aff04975118a7$export$34db76d03eb96b7e)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("GraphQL Integration is skipped because of instrumenter configuration.");
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error("GraphQL Integration was unable to require graphql/execution package.");
            return;
        }
        (0, $jl9W5.fill)(pkg, "execute", function(orig) {
            return function(...args) {
                const scope = getCurrentHub().getScope();
                const parentSpan = (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                    scope,
                    "optionalAccess",
                    (_2)=>_2.getSpan,
                    "call",
                    (_3)=>_3()
                ]);
                const span = (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                    parentSpan,
                    "optionalAccess",
                    (_4)=>_4.startChild,
                    "call",
                    (_5)=>_5({
                            description: "execute",
                            op: "graphql.execute"
                        })
                ]);
                (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                    scope,
                    "optionalAccess",
                    (_6)=>_6.setSpan,
                    "call",
                    (_7)=>_7(span)
                ]);
                const rv = orig.call(this, ...args);
                if ((0, $d2unA.isThenable)(rv)) return rv.then((res)=>{
                    (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_8)=>_8.finish,
                        "call",
                        (_9)=>_9()
                    ]);
                    (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                        scope,
                        "optionalAccess",
                        (_10)=>_10.setSpan,
                        "call",
                        (_11)=>_11(parentSpan)
                    ]);
                    return res;
                });
                (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                    span,
                    "optionalAccess",
                    (_12)=>_12.finish,
                    "call",
                    (_13)=>_13()
                ]);
                (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                    scope,
                    "optionalAccess",
                    (_14)=>_14.setSpan,
                    "call",
                    (_15)=>_15(parentSpan)
                ]);
                return rv;
            };
        });
    }
}
$3943438ea2cdb67f$export$b735d011553f1049.__initStatic();


var $1DvVX = parcelRequire("1DvVX");
var $5vcgO = parcelRequire("5vcgO");

var $jl9W5 = parcelRequire("jl9W5");
var $d2unA = parcelRequire("d2unA");
var $6QG3c = parcelRequire("6QG3c");
var $3lHwZ = parcelRequire("3lHwZ");

// This allows us to use the same array for both defaults options and the type itself.
// (note `as const` at the end to make it a union of string literal types (i.e. "a" | "b" | ... )
// and not just a string[])
const $f90d389ba9000bfb$var$OPERATIONS = [
    "aggregate",
    "bulkWrite",
    "countDocuments",
    "createIndex",
    "createIndexes",
    "deleteMany",
    "deleteOne",
    "distinct",
    "drop",
    "dropIndex",
    "dropIndexes",
    "estimatedDocumentCount",
    "find",
    "findOne",
    "findOneAndDelete",
    "findOneAndReplace",
    "findOneAndUpdate",
    "indexes",
    "indexExists",
    "indexInformation",
    "initializeOrderedBulkOp",
    "insertMany",
    "insertOne",
    "isCapped",
    "mapReduce",
    "options",
    "parallelCollectionScan",
    "rename",
    "replaceOne",
    "stats",
    "updateMany",
    "updateOne"
];
// All of the operations above take `options` and `callback` as their final parameters, but some of them
// take additional parameters as well. For those operations, this is a map of
// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
// positional arguments when we add them to the span's `data` object later
const $f90d389ba9000bfb$var$OPERATION_SIGNATURES = {
    // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
    // see https://github.com/getsentry/sentry-javascript/pull/3102
    bulkWrite: [
        "operations"
    ],
    countDocuments: [
        "query"
    ],
    createIndex: [
        "fieldOrSpec"
    ],
    createIndexes: [
        "indexSpecs"
    ],
    deleteMany: [
        "filter"
    ],
    deleteOne: [
        "filter"
    ],
    distinct: [
        "key",
        "query"
    ],
    dropIndex: [
        "indexName"
    ],
    find: [
        "query"
    ],
    findOne: [
        "query"
    ],
    findOneAndDelete: [
        "filter"
    ],
    findOneAndReplace: [
        "filter",
        "replacement"
    ],
    findOneAndUpdate: [
        "filter",
        "update"
    ],
    indexExists: [
        "indexes"
    ],
    insertMany: [
        "docs"
    ],
    insertOne: [
        "doc"
    ],
    mapReduce: [
        "map",
        "reduce"
    ],
    rename: [
        "newName"
    ],
    replaceOne: [
        "filter",
        "doc"
    ],
    updateMany: [
        "filter",
        "update"
    ],
    updateOne: [
        "filter",
        "update"
    ]
};
function $f90d389ba9000bfb$var$isCursor(maybeCursor) {
    return maybeCursor && typeof maybeCursor === "object" && maybeCursor.once && typeof maybeCursor.once === "function";
}
/** Tracing integration for mongo package */ class $f90d389ba9000bfb$export$968aa4360b02a334 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Mongo";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $f90d389ba9000bfb$export$968aa4360b02a334.id;
    }
    /**
   * @inheritDoc
   */ constructor(options = {}){
        $f90d389ba9000bfb$export$968aa4360b02a334.prototype.__init.call(this);
        this._operations = Array.isArray(options.operations) ? options.operations : $f90d389ba9000bfb$var$OPERATIONS;
        this._describeOperations = "describeOperations" in options ? options.describeOperations : true;
        this._useMongoose = !!options.useMongoose;
    }
    /** @inheritdoc */ loadDependency() {
        const moduleName = this._useMongoose ? "mongoose" : "mongodb";
        return this._module = this._module || (0, $6QG3c.loadModule)(moduleName);
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $bf9aff04975118a7$export$34db76d03eb96b7e)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("Mongo Integration is skipped because of instrumenter configuration.");
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            const moduleName = this._useMongoose ? "mongoose" : "mongodb";
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error(`Mongo Integration was unable to require \`${moduleName}\` package.`);
            return;
        }
        this._instrumentOperations(pkg.Collection, this._operations, getCurrentHub);
    }
    /**
   * Patches original collection methods
   */ _instrumentOperations(collection, operations, getCurrentHub) {
        operations.forEach((operation)=>this._patchOperation(collection, operation, getCurrentHub));
    }
    /**
   * Patches original collection to utilize our tracing functionality
   */ _patchOperation(collection, operation, getCurrentHub) {
        if (!(operation in collection.prototype)) return;
        const getSpanContext = this._getSpanContextFromOperationArguments.bind(this);
        (0, $jl9W5.fill)(collection.prototype, operation, function(orig) {
            return function(...args) {
                const lastArg = args[args.length - 1];
                const scope = getCurrentHub().getScope();
                const parentSpan = (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                    scope,
                    "optionalAccess",
                    (_2)=>_2.getSpan,
                    "call",
                    (_3)=>_3()
                ]);
                // Check if the operation was passed a callback. (mapReduce requires a different check, as
                // its (non-callback) arguments can also be functions.)
                if (typeof lastArg !== "function" || operation === "mapReduce" && args.length === 2) {
                    const span = (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                        parentSpan,
                        "optionalAccess",
                        (_4)=>_4.startChild,
                        "call",
                        (_5)=>_5(getSpanContext(this, operation, args))
                    ]);
                    const maybePromiseOrCursor = orig.call(this, ...args);
                    if ((0, $d2unA.isThenable)(maybePromiseOrCursor)) return maybePromiseOrCursor.then((res)=>{
                        (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                            span,
                            "optionalAccess",
                            (_6)=>_6.finish,
                            "call",
                            (_7)=>_7()
                        ]);
                        return res;
                    });
                    else if ($f90d389ba9000bfb$var$isCursor(maybePromiseOrCursor)) {
                        const cursor = maybePromiseOrCursor;
                        try {
                            cursor.once("close", ()=>{
                                (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                                    span,
                                    "optionalAccess",
                                    (_8)=>_8.finish,
                                    "call",
                                    (_9)=>_9()
                                ]);
                            });
                        } catch (e) {
                            // If the cursor is already closed, `once` will throw an error. In that case, we can
                            // finish the span immediately.
                            (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                                span,
                                "optionalAccess",
                                (_10)=>_10.finish,
                                "call",
                                (_11)=>_11()
                            ]);
                        }
                        return cursor;
                    } else {
                        (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                            span,
                            "optionalAccess",
                            (_12)=>_12.finish,
                            "call",
                            (_13)=>_13()
                        ]);
                        return maybePromiseOrCursor;
                    }
                }
                const span = (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                    parentSpan,
                    "optionalAccess",
                    (_14)=>_14.startChild,
                    "call",
                    (_15)=>_15(getSpanContext(this, operation, args.slice(0, -1)))
                ]);
                return orig.call(this, ...args.slice(0, -1), function(err, result) {
                    (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_16)=>_16.finish,
                        "call",
                        (_17)=>_17()
                    ]);
                    lastArg(err, result);
                });
            };
        });
    }
    /**
   * Form a SpanContext based on the user input to a given operation.
   */ _getSpanContextFromOperationArguments(collection, operation, args) {
        const data = {
            collectionName: collection.collectionName,
            dbName: collection.dbName,
            namespace: collection.namespace,
            "db.system": "mongodb"
        };
        const spanContext = {
            op: "db",
            description: operation,
            data: data
        };
        // If the operation takes no arguments besides `options` and `callback`, or if argument
        // collection is disabled for this operation, just return early.
        const signature = $f90d389ba9000bfb$var$OPERATION_SIGNATURES[operation];
        const shouldDescribe = Array.isArray(this._describeOperations) ? this._describeOperations.includes(operation) : this._describeOperations;
        if (!signature || !shouldDescribe) return spanContext;
        try {
            // Special case for `mapReduce`, as the only one accepting functions as arguments.
            if (operation === "mapReduce") {
                const [map, reduce] = args;
                data[signature[0]] = typeof map === "string" ? map : map.name || "<anonymous>";
                data[signature[1]] = typeof reduce === "string" ? reduce : reduce.name || "<anonymous>";
            } else for(let i = 0; i < signature.length; i++)data[signature[i]] = JSON.stringify(args[i]);
        } catch (_oO) {
        // no-empty
        }
        return spanContext;
    }
}
$f90d389ba9000bfb$export$968aa4360b02a334.__initStatic();



var $jl9W5 = parcelRequire("jl9W5");
var $6QG3c = parcelRequire("6QG3c");
var $3lHwZ = parcelRequire("3lHwZ");

/** Tracing integration for node-mysql package */ class $78a29235e00a0e98$export$a2cc26ff91a3f8ad {
    constructor(){
        $78a29235e00a0e98$export$a2cc26ff91a3f8ad.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Mysql";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $78a29235e00a0e98$export$a2cc26ff91a3f8ad.id;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $6QG3c.loadModule)("mysql/lib/Connection.js");
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $bf9aff04975118a7$export$34db76d03eb96b7e)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("Mysql Integration is skipped because of instrumenter configuration.");
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error("Mysql Integration was unable to require `mysql` package.");
            return;
        }
        // The original function will have one of these signatures:
        //    function (callback) => void
        //    function (options, callback) => void
        //    function (options, values, callback) => void
        (0, $jl9W5.fill)(pkg, "createQuery", function(orig) {
            return function(options, values, callback) {
                const scope = getCurrentHub().getScope();
                const parentSpan = (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                    scope,
                    "optionalAccess",
                    (_2)=>_2.getSpan,
                    "call",
                    (_3)=>_3()
                ]);
                const span = (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                    parentSpan,
                    "optionalAccess",
                    (_4)=>_4.startChild,
                    "call",
                    (_5)=>_5({
                            description: typeof options === "string" ? options : options.sql,
                            op: "db",
                            data: {
                                "db.system": "mysql"
                            }
                        })
                ]);
                if (typeof callback === "function") return orig.call(this, options, values, function(err, result, fields) {
                    (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_6)=>_6.finish,
                        "call",
                        (_7)=>_7()
                    ]);
                    callback(err, result, fields);
                });
                if (typeof values === "function") return orig.call(this, options, function(err, result, fields) {
                    (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_8)=>_8.finish,
                        "call",
                        (_9)=>_9()
                    ]);
                    values(err, result, fields);
                });
                return orig.call(this, options, values, callback);
            };
        });
    }
}
$78a29235e00a0e98$export$a2cc26ff91a3f8ad.__initStatic();



var $jl9W5 = parcelRequire("jl9W5");
var $d2unA = parcelRequire("d2unA");
var $6QG3c = parcelRequire("6QG3c");
var $3lHwZ = parcelRequire("3lHwZ");

/** Tracing integration for node-postgres package */ class $60b488e42c361599$export$806ddb599177abc4 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Postgres";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $60b488e42c361599$export$806ddb599177abc4.id;
    }
    constructor(options = {}){
        $60b488e42c361599$export$806ddb599177abc4.prototype.__init.call(this);
        this._usePgNative = !!options.usePgNative;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $6QG3c.loadModule)("pg");
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $bf9aff04975118a7$export$34db76d03eb96b7e)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("Postgres Integration is skipped because of instrumenter configuration.");
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error("Postgres Integration was unable to require `pg` package.");
            return;
        }
        if (this._usePgNative && !(0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
            pkg,
            "access",
            (_2)=>_2.native,
            "optionalAccess",
            (_3)=>_3.Client
        ])) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error("Postgres Integration was unable to access 'pg-native' bindings.");
            return;
        }
        const { Client: Client  } = this._usePgNative ? pkg.native : pkg;
        /**
     * function (query, callback) => void
     * function (query, params, callback) => void
     * function (query) => Promise
     * function (query, params) => Promise
     * function (pg.Cursor) => pg.Cursor
     */ (0, $jl9W5.fill)(Client.prototype, "query", function(orig) {
            return function(config, values, callback) {
                const scope = getCurrentHub().getScope();
                const parentSpan = (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                    scope,
                    "optionalAccess",
                    (_4)=>_4.getSpan,
                    "call",
                    (_5)=>_5()
                ]);
                const span = (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                    parentSpan,
                    "optionalAccess",
                    (_6)=>_6.startChild,
                    "call",
                    (_7)=>_7({
                            description: typeof config === "string" ? config : config.text,
                            op: "db",
                            data: {
                                "db.system": "postgresql"
                            }
                        })
                ]);
                if (typeof callback === "function") return orig.call(this, config, values, function(err, result) {
                    (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_8)=>_8.finish,
                        "call",
                        (_9)=>_9()
                    ]);
                    callback(err, result);
                });
                if (typeof values === "function") return orig.call(this, config, function(err, result) {
                    (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_10)=>_10.finish,
                        "call",
                        (_11)=>_11()
                    ]);
                    values(err, result);
                });
                const rv = typeof values !== "undefined" ? orig.call(this, config, values) : orig.call(this, config);
                if ((0, $d2unA.isThenable)(rv)) return rv.then((res)=>{
                    (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                        span,
                        "optionalAccess",
                        (_12)=>_12.finish,
                        "call",
                        (_13)=>_13()
                    ]);
                    return res;
                });
                (0, $d39a9d34810cbd78$export$3cc482e6b02f32f7)([
                    span,
                    "optionalAccess",
                    (_14)=>_14.finish,
                    "call",
                    (_15)=>_15()
                ]);
                return rv;
            };
        });
    }
}
$60b488e42c361599$export$806ddb599177abc4.__initStatic();


var $d2unA = parcelRequire("d2unA");

var $kDFdm = parcelRequire("kDFdm");
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`, this function
 * will not generate spans, and the `span` returned from the callback may be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 */ function $ba0259fbe569565a$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}) {
    const ctx = {
        ...context
    };
    // If a name is set and a description is not, set the description to the name.
    if (ctx.name !== undefined && ctx.description === undefined) ctx.description = ctx.name;
    const hub = (0, $kDFdm.getCurrentHub)();
    const scope = hub.getScope();
    const parentSpan = scope.getSpan();
    const activeSpan = parentSpan ? parentSpan.startChild(ctx) : hub.startTransaction(ctx);
    scope.setSpan(activeSpan);
    function finishAndSetSpan() {
        activeSpan && activeSpan.finish();
        hub.getScope().setSpan(parentSpan);
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback(activeSpan);
    } catch (e) {
        activeSpan && activeSpan.setStatus("internal_error");
        onError(e);
        finishAndSetSpan();
        throw e;
    }
    if ((0, $d2unA.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishAndSetSpan();
    }, (e)=>{
        activeSpan && activeSpan.setStatus("internal_error");
        onError(e);
        finishAndSetSpan();
    });
    else finishAndSetSpan();
    return maybePromiseResult;
}



var $3lHwZ = parcelRequire("3lHwZ");

function $ecfd4a36310d0c6b$var$isValidPrismaClient(possibleClient) {
    return possibleClient && !!possibleClient["$use"];
}
/** Tracing integration for @prisma/client package */ class $ecfd4a36310d0c6b$export$e300e6f4779d55c2 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Prisma";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $ecfd4a36310d0c6b$export$e300e6f4779d55c2.id;
    }
    /**
   * Prisma ORM Client Instance
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        $ecfd4a36310d0c6b$export$e300e6f4779d55c2.prototype.__init.call(this);
        if ($ecfd4a36310d0c6b$var$isValidPrismaClient(options.client)) this._client = options.client;
        else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).warn(`Unsupported Prisma client provided to PrismaIntegration. Provided client: ${JSON.stringify(options.client)}`);
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if (!this._client) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).error("PrismaIntegration is missing a Prisma Client Instance");
            return;
        }
        if ((0, $bf9aff04975118a7$export$34db76d03eb96b7e)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $3lHwZ.logger).log("Prisma Integration is skipped because of instrumenter configuration.");
            return;
        }
        this._client.$use((params, next)=>{
            const action = params.action;
            const model = params.model;
            return (0, $ba0259fbe569565a$export$357889f174732d38)({
                name: model ? `${model} ${action}` : action,
                op: "db.sql.prisma",
                data: {
                    "db.system": "prisma"
                }
            }, ()=>next(params));
        });
    }
}
$ecfd4a36310d0c6b$export$e300e6f4779d55c2.__initStatic();


var $iT1V4 = parcelRequire("iT1V4");/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ // eslint-disable-next-line import/export
var $1dda3611251a06d8$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = "ok";
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = "deadline_exceeded";
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = "unauthenticated";
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = "permission_denied";
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = "not_found";
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = "resource_exhausted";
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = "invalid_argument";
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = "unimplemented";
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = "unavailable";
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = "internal_error";
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = "unknown_error";
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = "cancelled";
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = "already_exists";
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = "failed_precondition";
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = "aborted";
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = "out_of_range";
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = "data_loss";
    SpanStatus["DataLoss"] = DataLoss;
})($1dda3611251a06d8$export$beb8e6a823e89c5d || ($1dda3611251a06d8$export$beb8e6a823e89c5d = {}));


var $78QsC = parcelRequire("78QsC");
var $lOd6Z = parcelRequire("lOd6Z");
// BrowserTracing is already exported as part of `Integrations` below (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
 *
 * import { BrowserTracing } from '@sentry/browser';
 * new BrowserTracing()
 */ const $945fb719f1ce2a3f$export$46d3bbd0375f5fa4 = (0, $8b34a7b6bfadb479$export$46d3bbd0375f5fa4);
// BrowserTracing is already exported as part of `Integrations` below (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
 *
 * import { BrowserTracing } from '@sentry/browser';
 * new BrowserTracing()
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $945fb719f1ce2a3f$export$5a20b45239a3c0a6 = (0, $5Jhw0.addExtensionMethods);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `getActiveTransaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $945fb719f1ce2a3f$export$a7feb32fdd923295 = (0, $7JOCn.getActiveTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `extractTraceparentData` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $945fb719f1ce2a3f$export$8e9a29865c0a1226 = (0, $e558e93c06fc1d9e$export$8e9a29865c0a1226);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `spanStatusfromHttpCode` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $945fb719f1ce2a3f$export$ac65c70d78fcdb55 = (0, $iT1V4.spanStatusfromHttpCode);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `SpanStatusType` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Transaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $945fb719f1ce2a3f$export$febc5573c75cefb0 = (0, $lOd6Z.Transaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Transaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Span` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $945fb719f1ce2a3f$export$5f1714a13ed34c01 = (0, $iT1V4.Span);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Span` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $945fb719f1ce2a3f$export$bbd2089f30bd3708 = (0, $8b34a7b6bfadb479$export$bbd2089f30bd3708);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `defaultRequestInstrumentationOptions` can be imported from `@sentry/browser`, or your framework SDK
 */ const $945fb719f1ce2a3f$export$cc17fb3c0bc95cd7 = (0, $343ed8995d3b3c18$export$cc17fb3c0bc95cd7);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `hasTracingEnabled` can be imported from `@sentry/utils`
 */ const $945fb719f1ce2a3f$export$5008da00b1b6dee6 = (0, $1DvVX.hasTracingEnabled);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `stripUrlQueryAndFragment` can be imported from `@sentry/utils`
 */ const $945fb719f1ce2a3f$export$ce084c78234bd35 = (0, $0ea526eae9bcadb2$export$ce084c78234bd35);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `TRACEPARENT_REGEXP` can be imported from `@sentry/utils`
 */ const $945fb719f1ce2a3f$export$394a210812ba3012 = (0, $e558e93c06fc1d9e$export$394a210812ba3012);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $945fb719f1ce2a3f$export$b279e6bd7040371f = (0, $5vcgO.IdleTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $945fb719f1ce2a3f$export$864489cb3478db3e = (0, $343ed8995d3b3c18$export$864489cb3478db3e);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $945fb719f1ce2a3f$export$479dbd817e392a4f = (0, $78QsC.startIdleTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ // eslint-disable-next-line deprecation/deprecation
const $945fb719f1ce2a3f$export$beb8e6a823e89c5d = (0, $1dda3611251a06d8$export$beb8e6a823e89c5d);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ // eslint-disable-next-line deprecation/deprecation
const $945fb719f1ce2a3f$export$99d02219d259eb94 = {
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
   *
   * import { BrowserTracing } from '@sentry/browser';
   * new BrowserTracing()
   */ // eslint-disable-next-line deprecation/deprecation
    BrowserTracing: $945fb719f1ce2a3f$export$46d3bbd0375f5fa4,
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Apollo` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Apollo({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Apollo: (0, $9db1d7cf4c1db420$export$3db3e396472fda8d),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Express` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Express({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Express: (0, $02bf5b506c7e167f$export$6dafdd8fec05099d),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `GraphQL` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.GraphQL({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    GraphQL: (0, $3943438ea2cdb67f$export$b735d011553f1049),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Mongo` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Mongo({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Mongo: (0, $f90d389ba9000bfb$export$968aa4360b02a334),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Mysql` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Mysql({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Mysql: (0, $78a29235e00a0e98$export$a2cc26ff91a3f8ad),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Postgres` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Postgres({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Postgres: (0, $60b488e42c361599$export$806ddb599177abc4),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Prisma` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Prisma({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Prisma: (0, $ecfd4a36310d0c6b$export$e300e6f4779d55c2)
};
// Treeshakable guard to remove all code related to tracing
// Guard for tree
if (typeof __SENTRY_TRACING__ === "undefined" || __SENTRY_TRACING__) // We are patching the global object with our hub extension methods
(0, $5Jhw0.addExtensionMethods)();



var $3lHwZ = parcelRequire("3lHwZ");
var $jl9W5 = parcelRequire("jl9W5");
var $bayd0 = parcelRequire("bayd0");
var $geIBs = parcelRequire("geIBs");
/** Send Console API calls as Sentry Events */ class $33e1642a8363d690$export$25a43cb5b5c58c08 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "CaptureConsole";
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $33e1642a8363d690$export$25a43cb5b5c58c08.id;
    }
    /**
   * @inheritDoc
   */ __init2() {
        this._levels = (0, $3lHwZ.CONSOLE_LEVELS);
    }
    /**
   * @inheritDoc
   */ constructor(options = {}){
        $33e1642a8363d690$export$25a43cb5b5c58c08.prototype.__init.call(this);
        $33e1642a8363d690$export$25a43cb5b5c58c08.prototype.__init2.call(this);
        if (options.levels) this._levels = options.levels;
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if (!("console" in (0, $bayd0.GLOBAL_OBJ))) return;
        this._levels.forEach((level)=>{
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            if (!(level in (0, $bayd0.GLOBAL_OBJ).console)) return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            (0, $jl9W5.fill)((0, $bayd0.GLOBAL_OBJ).console, level, (originalConsoleMethod)=>(...args)=>{
                    const hub = getCurrentHub();
                    if (hub.getIntegration($33e1642a8363d690$export$25a43cb5b5c58c08)) hub.withScope((scope)=>{
                        scope.setLevel((0, $f76e950a18c30a8f$export$d771ef054122c30a)(level));
                        scope.setExtra("arguments", args);
                        scope.addEventProcessor((event)=>{
                            event.logger = "console";
                            return event;
                        });
                        let message = (0, $geIBs.safeJoin)(args, " ");
                        if (level === "assert") {
                            if (args[0] === false) {
                                message = `Assertion failed: ${(0, $geIBs.safeJoin)(args.slice(1), " ") || "console.assert"}`;
                                scope.setExtra("arguments", args.slice(1));
                                hub.captureMessage(message);
                            }
                        } else if (level === "error" && args[0] instanceof Error) hub.captureException(args[0]);
                        else hub.captureMessage(message);
                    });
                    // this fails for some browsers. :(
                    if (originalConsoleMethod) originalConsoleMethod.apply((0, $bayd0.GLOBAL_OBJ).console, args);
                });
        });
    }
}
$33e1642a8363d690$export$25a43cb5b5c58c08.__initStatic();


var $21a020c73fae2a9e$exports = {};
"use strict";
// TODO: Remove this module from `core-js@4` since it's split to modules listed below
"use strict";
var $0365e955907213bd$exports = {};
var $1a6e68c95df7d4df$exports = {};
var $1a6e68c95df7d4df$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$1a6e68c95df7d4df$exports = // eslint-disable-next-line es/no-global-this -- safe
$1a6e68c95df7d4df$var$check(typeof globalThis == "object" && globalThis) || $1a6e68c95df7d4df$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$1a6e68c95df7d4df$var$check(typeof self == "object" && self) || $1a6e68c95df7d4df$var$check(typeof $parcel$global == "object" && $parcel$global) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || $1a6e68c95df7d4df$exports || Function("return this")();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $dc708c9bcef7b78f$export$2d1720544b23b823;
var $0ab298e69b752e0a$exports = {};
var $4cefcb1c1c1fa750$exports = {};
$4cefcb1c1c1fa750$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$0ab298e69b752e0a$exports = !$4cefcb1c1c1fa750$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});


var $3b5393d57c251c61$exports = {};
var $05c82362c0ced3b1$exports = {};

$05c82362c0ced3b1$exports = !$4cefcb1c1c1fa750$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $3b5393d57c251c61$var$call = Function.prototype.call;
$3b5393d57c251c61$exports = $05c82362c0ced3b1$exports ? $3b5393d57c251c61$var$call.bind($3b5393d57c251c61$var$call) : function() {
    return $3b5393d57c251c61$var$call.apply($3b5393d57c251c61$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $369ff2248a9e8d32$export$2d1720544b23b823;
"use strict";
var $369ff2248a9e8d32$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $369ff2248a9e8d32$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $369ff2248a9e8d32$var$NASHORN_BUG = $369ff2248a9e8d32$var$getOwnPropertyDescriptor && !$369ff2248a9e8d32$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$369ff2248a9e8d32$export$2d1720544b23b823 = $369ff2248a9e8d32$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $369ff2248a9e8d32$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $369ff2248a9e8d32$var$$propertyIsEnumerable;


var $d6bcb34392440d40$exports = {};
$d6bcb34392440d40$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $b497231b90dfbcaa$exports = {};
// toObject with fallback for non-array-like ES3 strings
var $77acd9fe92ee403a$exports = {};
var $c510c74e58563f95$exports = {};

var $c510c74e58563f95$var$FunctionPrototype = Function.prototype;
var $c510c74e58563f95$var$call = $c510c74e58563f95$var$FunctionPrototype.call;
var $c510c74e58563f95$var$uncurryThisWithBind = $05c82362c0ced3b1$exports && $c510c74e58563f95$var$FunctionPrototype.bind.bind($c510c74e58563f95$var$call, $c510c74e58563f95$var$call);
$c510c74e58563f95$exports = $05c82362c0ced3b1$exports ? $c510c74e58563f95$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $c510c74e58563f95$var$call.apply(fn, arguments);
    };
};



var $ee4d29ebca1023f3$exports = {};

var $ee4d29ebca1023f3$var$toString = $c510c74e58563f95$exports({}.toString);
var $ee4d29ebca1023f3$var$stringSlice = $c510c74e58563f95$exports("".slice);
$ee4d29ebca1023f3$exports = function(it) {
    return $ee4d29ebca1023f3$var$stringSlice($ee4d29ebca1023f3$var$toString(it), 8, -1);
};


var $77acd9fe92ee403a$var$$Object = Object;
var $77acd9fe92ee403a$var$split = $c510c74e58563f95$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$77acd9fe92ee403a$exports = $4cefcb1c1c1fa750$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$77acd9fe92ee403a$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $ee4d29ebca1023f3$exports(it) == "String" ? $77acd9fe92ee403a$var$split(it, "") : $77acd9fe92ee403a$var$$Object(it);
} : $77acd9fe92ee403a$var$$Object;


var $ac95046ddf1ecaa1$exports = {};
var $784d9540a0abf25d$exports = {};
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$784d9540a0abf25d$exports = function(it) {
    return it === null || it === undefined;
};


var $ac95046ddf1ecaa1$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$ac95046ddf1ecaa1$exports = function(it) {
    if ($784d9540a0abf25d$exports(it)) throw $ac95046ddf1ecaa1$var$$TypeError("Can't call method on " + it);
    return it;
};


$b497231b90dfbcaa$exports = function(it) {
    return $77acd9fe92ee403a$exports($ac95046ddf1ecaa1$exports(it));
};


var $df8c871456bcdfdf$exports = {};
var $49e56ced23df1333$exports = {};

var $dfdc56bc53f57e69$exports = {};
var $c1d5f87f1e56c4cc$exports = {};
var $552b1d897fc262b8$exports = {};
var $552b1d897fc262b8$var$documentAll = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var $552b1d897fc262b8$var$IS_HTMLDDA = typeof $552b1d897fc262b8$var$documentAll == "undefined" && $552b1d897fc262b8$var$documentAll !== undefined;
$552b1d897fc262b8$exports = {
    all: $552b1d897fc262b8$var$documentAll,
    IS_HTMLDDA: $552b1d897fc262b8$var$IS_HTMLDDA
};


var $c1d5f87f1e56c4cc$var$documentAll = $552b1d897fc262b8$exports.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
$c1d5f87f1e56c4cc$exports = $552b1d897fc262b8$exports.IS_HTMLDDA ? function(argument) {
    return typeof argument == "function" || argument === $c1d5f87f1e56c4cc$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};



var $dfdc56bc53f57e69$var$documentAll = $552b1d897fc262b8$exports.all;
$dfdc56bc53f57e69$exports = $552b1d897fc262b8$exports.IS_HTMLDDA ? function(it) {
    return typeof it == "object" ? it !== null : $c1d5f87f1e56c4cc$exports(it) || it === $dfdc56bc53f57e69$var$documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : $c1d5f87f1e56c4cc$exports(it);
};


var $0d71f82f3bc811d0$exports = {};
var $ba2da80b68ee643e$exports = {};


var $ba2da80b68ee643e$var$aFunction = function(argument) {
    return $c1d5f87f1e56c4cc$exports(argument) ? argument : undefined;
};
$ba2da80b68ee643e$exports = function(namespace, method) {
    return arguments.length < 2 ? $ba2da80b68ee643e$var$aFunction($1a6e68c95df7d4df$exports[namespace]) : $1a6e68c95df7d4df$exports[namespace] && $1a6e68c95df7d4df$exports[namespace][method];
};



var $b82c3d945f0459c1$exports = {};

$b82c3d945f0459c1$exports = $c510c74e58563f95$exports({}.isPrototypeOf);


var $83e6eb75561acc9f$exports = {};
/* eslint-disable es/no-symbol -- required for testing */ var $5c26fe98edd631fb$exports = {};
/* eslint-disable es/no-symbol -- required for testing */ var $44f41d0bd747502d$exports = {};

var $59d28ac8b8f97183$exports = {};
$59d28ac8b8f97183$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $44f41d0bd747502d$var$process = $1a6e68c95df7d4df$exports.process;
var $44f41d0bd747502d$var$Deno = $1a6e68c95df7d4df$exports.Deno;
var $44f41d0bd747502d$var$versions = $44f41d0bd747502d$var$process && $44f41d0bd747502d$var$process.versions || $44f41d0bd747502d$var$Deno && $44f41d0bd747502d$var$Deno.version;
var $44f41d0bd747502d$var$v8 = $44f41d0bd747502d$var$versions && $44f41d0bd747502d$var$versions.v8;
var $44f41d0bd747502d$var$match, $44f41d0bd747502d$var$version;
if ($44f41d0bd747502d$var$v8) {
    $44f41d0bd747502d$var$match = $44f41d0bd747502d$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $44f41d0bd747502d$var$version = $44f41d0bd747502d$var$match[0] > 0 && $44f41d0bd747502d$var$match[0] < 4 ? 1 : +($44f41d0bd747502d$var$match[0] + $44f41d0bd747502d$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$44f41d0bd747502d$var$version && $59d28ac8b8f97183$exports) {
    $44f41d0bd747502d$var$match = $59d28ac8b8f97183$exports.match(/Edge\/(\d+)/);
    if (!$44f41d0bd747502d$var$match || $44f41d0bd747502d$var$match[1] >= 74) {
        $44f41d0bd747502d$var$match = $59d28ac8b8f97183$exports.match(/Chrome\/(\d+)/);
        if ($44f41d0bd747502d$var$match) $44f41d0bd747502d$var$version = +$44f41d0bd747502d$var$match[1];
    }
}
$44f41d0bd747502d$exports = $44f41d0bd747502d$var$version;




var $5c26fe98edd631fb$var$$String = $1a6e68c95df7d4df$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$5c26fe98edd631fb$exports = !!Object.getOwnPropertySymbols && !$4cefcb1c1c1fa750$exports(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$5c26fe98edd631fb$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $44f41d0bd747502d$exports && $44f41d0bd747502d$exports < 41;
});


$83e6eb75561acc9f$exports = $5c26fe98edd631fb$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $0d71f82f3bc811d0$var$$Object = Object;
$0d71f82f3bc811d0$exports = $83e6eb75561acc9f$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $ba2da80b68ee643e$exports("Symbol");
    return $c1d5f87f1e56c4cc$exports($Symbol) && $b82c3d945f0459c1$exports($Symbol.prototype, $0d71f82f3bc811d0$var$$Object(it));
};


var $884b8a4433456f65$exports = {};
var $4a6b57cf563748d0$exports = {};

var $f3ce16a57f0d7972$exports = {};
var $f3ce16a57f0d7972$var$$String = String;
$f3ce16a57f0d7972$exports = function(argument) {
    try {
        return $f3ce16a57f0d7972$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $4a6b57cf563748d0$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$4a6b57cf563748d0$exports = function(argument) {
    if ($c1d5f87f1e56c4cc$exports(argument)) return argument;
    throw $4a6b57cf563748d0$var$$TypeError($f3ce16a57f0d7972$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$884b8a4433456f65$exports = function(V, P) {
    var func = V[P];
    return $784d9540a0abf25d$exports(func) ? undefined : $4a6b57cf563748d0$exports(func);
};


var $ac315fa953da3cec$exports = {};



var $ac315fa953da3cec$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$ac315fa953da3cec$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $c1d5f87f1e56c4cc$exports(fn = input.toString) && !$dfdc56bc53f57e69$exports(val = $3b5393d57c251c61$exports(fn, input))) return val;
    if ($c1d5f87f1e56c4cc$exports(fn = input.valueOf) && !$dfdc56bc53f57e69$exports(val = $3b5393d57c251c61$exports(fn, input))) return val;
    if (pref !== "string" && $c1d5f87f1e56c4cc$exports(fn = input.toString) && !$dfdc56bc53f57e69$exports(val = $3b5393d57c251c61$exports(fn, input))) return val;
    throw $ac315fa953da3cec$var$$TypeError("Can't convert object to primitive value");
};


var $5cfcb69f0877711f$exports = {};

var $5b6f77fe4ecb64db$exports = {};
var $fef1920ae5260386$exports = {};
$fef1920ae5260386$exports = false;


var $8f9505b7a708ebaf$exports = {};

var $efb09e2fcc734bba$exports = {};

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $efb09e2fcc734bba$var$defineProperty = Object.defineProperty;
$efb09e2fcc734bba$exports = function(key, value) {
    try {
        $efb09e2fcc734bba$var$defineProperty($1a6e68c95df7d4df$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $1a6e68c95df7d4df$exports[key] = value;
    }
    return value;
};


var $8f9505b7a708ebaf$var$SHARED = "__core-js_shared__";
var $8f9505b7a708ebaf$var$store = $1a6e68c95df7d4df$exports[$8f9505b7a708ebaf$var$SHARED] || $efb09e2fcc734bba$exports($8f9505b7a708ebaf$var$SHARED, {});
$8f9505b7a708ebaf$exports = $8f9505b7a708ebaf$var$store;


($5b6f77fe4ecb64db$exports = function(key, value) {
    return $8f9505b7a708ebaf$exports[key] || ($8f9505b7a708ebaf$exports[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.30.2",
    mode: $fef1920ae5260386$exports ? "pure" : "global",
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.30.2/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


var $ef59b581f0d1672b$exports = {};

var $cc6f28a96f61f0ea$exports = {};

var $cc6f28a96f61f0ea$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$cc6f28a96f61f0ea$exports = function(argument) {
    return $cc6f28a96f61f0ea$var$$Object($ac95046ddf1ecaa1$exports(argument));
};


var $ef59b581f0d1672b$var$hasOwnProperty = $c510c74e58563f95$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$ef59b581f0d1672b$exports = Object.hasOwn || function hasOwn(it, key) {
    return $ef59b581f0d1672b$var$hasOwnProperty($cc6f28a96f61f0ea$exports(it), key);
};


var $8e860c2fd7cf6ff6$exports = {};

var $8e860c2fd7cf6ff6$var$id = 0;
var $8e860c2fd7cf6ff6$var$postfix = Math.random();
var $8e860c2fd7cf6ff6$var$toString = $c510c74e58563f95$exports(1.0.toString);
$8e860c2fd7cf6ff6$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $8e860c2fd7cf6ff6$var$toString(++$8e860c2fd7cf6ff6$var$id + $8e860c2fd7cf6ff6$var$postfix, 36);
};




var $5cfcb69f0877711f$var$Symbol = $1a6e68c95df7d4df$exports.Symbol;
var $5cfcb69f0877711f$var$WellKnownSymbolsStore = $5b6f77fe4ecb64db$exports("wks");
var $5cfcb69f0877711f$var$createWellKnownSymbol = $83e6eb75561acc9f$exports ? $5cfcb69f0877711f$var$Symbol["for"] || $5cfcb69f0877711f$var$Symbol : $5cfcb69f0877711f$var$Symbol && $5cfcb69f0877711f$var$Symbol.withoutSetter || $8e860c2fd7cf6ff6$exports;
$5cfcb69f0877711f$exports = function(name) {
    if (!$ef59b581f0d1672b$exports($5cfcb69f0877711f$var$WellKnownSymbolsStore, name)) $5cfcb69f0877711f$var$WellKnownSymbolsStore[name] = $5c26fe98edd631fb$exports && $ef59b581f0d1672b$exports($5cfcb69f0877711f$var$Symbol, name) ? $5cfcb69f0877711f$var$Symbol[name] : $5cfcb69f0877711f$var$createWellKnownSymbol("Symbol." + name);
    return $5cfcb69f0877711f$var$WellKnownSymbolsStore[name];
};


var $49e56ced23df1333$var$$TypeError = TypeError;
var $49e56ced23df1333$var$TO_PRIMITIVE = $5cfcb69f0877711f$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$49e56ced23df1333$exports = function(input, pref) {
    if (!$dfdc56bc53f57e69$exports(input) || $0d71f82f3bc811d0$exports(input)) return input;
    var exoticToPrim = $884b8a4433456f65$exports(input, $49e56ced23df1333$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $3b5393d57c251c61$exports(exoticToPrim, input, pref);
        if (!$dfdc56bc53f57e69$exports(result) || $0d71f82f3bc811d0$exports(result)) return result;
        throw $49e56ced23df1333$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $ac315fa953da3cec$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$df8c871456bcdfdf$exports = function(argument) {
    var key = $49e56ced23df1333$exports(argument, "string");
    return $0d71f82f3bc811d0$exports(key) ? key : key + "";
};



var $bbf6cd6b9827d422$exports = {};


var $50f1c27ed88e8707$exports = {};


var $50f1c27ed88e8707$var$document = $1a6e68c95df7d4df$exports.document;
// typeof document.createElement is 'object' in old IE
var $50f1c27ed88e8707$var$EXISTS = $dfdc56bc53f57e69$exports($50f1c27ed88e8707$var$document) && $dfdc56bc53f57e69$exports($50f1c27ed88e8707$var$document.createElement);
$50f1c27ed88e8707$exports = function(it) {
    return $50f1c27ed88e8707$var$EXISTS ? $50f1c27ed88e8707$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$bbf6cd6b9827d422$exports = !$0ab298e69b752e0a$exports && !$4cefcb1c1c1fa750$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($50f1c27ed88e8707$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $dc708c9bcef7b78f$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$dc708c9bcef7b78f$export$2d1720544b23b823 = $0ab298e69b752e0a$exports ? $dc708c9bcef7b78f$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $b497231b90dfbcaa$exports(O);
    P = $df8c871456bcdfdf$exports(P);
    if ($bbf6cd6b9827d422$exports) try {
        return $dc708c9bcef7b78f$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($ef59b581f0d1672b$exports(O, P)) return $d6bcb34392440d40$exports(!$3b5393d57c251c61$exports($369ff2248a9e8d32$export$2d1720544b23b823, O, P), O[P]);
};


var $0365e955907213bd$require$getOwnPropertyDescriptor = $dc708c9bcef7b78f$export$2d1720544b23b823;
var $4716626f874fe5a3$exports = {};

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $783b6a5a940dee05$export$2d1720544b23b823;


var $3a1a75f466046406$exports = {};


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$3a1a75f466046406$exports = $0ab298e69b752e0a$exports && $4cefcb1c1c1fa750$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});


var $830db860a045bbb5$exports = {};

var $830db860a045bbb5$var$$String = String;
var $830db860a045bbb5$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$830db860a045bbb5$exports = function(argument) {
    if ($dfdc56bc53f57e69$exports(argument)) return argument;
    throw $830db860a045bbb5$var$$TypeError($830db860a045bbb5$var$$String(argument) + " is not an object");
};



var $783b6a5a940dee05$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $783b6a5a940dee05$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $783b6a5a940dee05$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $783b6a5a940dee05$var$ENUMERABLE = "enumerable";
var $783b6a5a940dee05$var$CONFIGURABLE = "configurable";
var $783b6a5a940dee05$var$WRITABLE = "writable";
$783b6a5a940dee05$export$2d1720544b23b823 = $0ab298e69b752e0a$exports ? $3a1a75f466046406$exports ? function defineProperty(O, P, Attributes) {
    $830db860a045bbb5$exports(O);
    P = $df8c871456bcdfdf$exports(P);
    $830db860a045bbb5$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $783b6a5a940dee05$var$WRITABLE in Attributes && !Attributes[$783b6a5a940dee05$var$WRITABLE]) {
        var current = $783b6a5a940dee05$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$783b6a5a940dee05$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $783b6a5a940dee05$var$CONFIGURABLE in Attributes ? Attributes[$783b6a5a940dee05$var$CONFIGURABLE] : current[$783b6a5a940dee05$var$CONFIGURABLE],
                enumerable: $783b6a5a940dee05$var$ENUMERABLE in Attributes ? Attributes[$783b6a5a940dee05$var$ENUMERABLE] : current[$783b6a5a940dee05$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $783b6a5a940dee05$var$$defineProperty(O, P, Attributes);
} : $783b6a5a940dee05$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $830db860a045bbb5$exports(O);
    P = $df8c871456bcdfdf$exports(P);
    $830db860a045bbb5$exports(Attributes);
    if ($bbf6cd6b9827d422$exports) try {
        return $783b6a5a940dee05$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $783b6a5a940dee05$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};



$4716626f874fe5a3$exports = $0ab298e69b752e0a$exports ? function(object, key, value) {
    return $783b6a5a940dee05$export$2d1720544b23b823(object, key, $d6bcb34392440d40$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $eeb1abced7a4b5b5$exports = {};


var $e133b70f97609f28$exports = {};





var $93a445032aaa8001$exports = {};


var $93a445032aaa8001$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $93a445032aaa8001$var$getDescriptor = $0ab298e69b752e0a$exports && Object.getOwnPropertyDescriptor;
var $93a445032aaa8001$var$EXISTS = $ef59b581f0d1672b$exports($93a445032aaa8001$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $93a445032aaa8001$var$PROPER = $93a445032aaa8001$var$EXISTS && (function something() {}).name === "something";
var $93a445032aaa8001$var$CONFIGURABLE = $93a445032aaa8001$var$EXISTS && (!$0ab298e69b752e0a$exports || $0ab298e69b752e0a$exports && $93a445032aaa8001$var$getDescriptor($93a445032aaa8001$var$FunctionPrototype, "name").configurable);
$93a445032aaa8001$exports = {
    EXISTS: $93a445032aaa8001$var$EXISTS,
    PROPER: $93a445032aaa8001$var$PROPER,
    CONFIGURABLE: $93a445032aaa8001$var$CONFIGURABLE
};


var $e133b70f97609f28$require$CONFIGURABLE_FUNCTION_NAME = $93a445032aaa8001$exports.CONFIGURABLE;
var $1076c59a7c633d48$exports = {};



var $1076c59a7c633d48$var$functionToString = $c510c74e58563f95$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$c1d5f87f1e56c4cc$exports($8f9505b7a708ebaf$exports.inspectSource)) $8f9505b7a708ebaf$exports.inspectSource = function(it) {
    return $1076c59a7c633d48$var$functionToString(it);
};
$1076c59a7c633d48$exports = $8f9505b7a708ebaf$exports.inspectSource;


var $dbe54846b72f85d1$exports = {};
var $95fde8eb0bd69064$exports = {};


var $95fde8eb0bd69064$var$WeakMap = $1a6e68c95df7d4df$exports.WeakMap;
$95fde8eb0bd69064$exports = $c1d5f87f1e56c4cc$exports($95fde8eb0bd69064$var$WeakMap) && /native code/.test(String($95fde8eb0bd69064$var$WeakMap));







var $2da5e4152f22a70d$exports = {};


var $2da5e4152f22a70d$var$keys = $5b6f77fe4ecb64db$exports("keys");
$2da5e4152f22a70d$exports = function(key) {
    return $2da5e4152f22a70d$var$keys[key] || ($2da5e4152f22a70d$var$keys[key] = $8e860c2fd7cf6ff6$exports(key));
};


var $2522edb48098e72d$exports = {};
$2522edb48098e72d$exports = {};


var $dbe54846b72f85d1$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $dbe54846b72f85d1$var$TypeError = $1a6e68c95df7d4df$exports.TypeError;
var $dbe54846b72f85d1$var$WeakMap = $1a6e68c95df7d4df$exports.WeakMap;
var $dbe54846b72f85d1$var$set, $dbe54846b72f85d1$var$get, $dbe54846b72f85d1$var$has;
var $dbe54846b72f85d1$var$enforce = function(it) {
    return $dbe54846b72f85d1$var$has(it) ? $dbe54846b72f85d1$var$get(it) : $dbe54846b72f85d1$var$set(it, {});
};
var $dbe54846b72f85d1$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$dfdc56bc53f57e69$exports(it) || (state = $dbe54846b72f85d1$var$get(it)).type !== TYPE) throw $dbe54846b72f85d1$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($95fde8eb0bd69064$exports || $8f9505b7a708ebaf$exports.state) {
    var $dbe54846b72f85d1$var$store = $8f9505b7a708ebaf$exports.state || ($8f9505b7a708ebaf$exports.state = new $dbe54846b72f85d1$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $dbe54846b72f85d1$var$store.get = $dbe54846b72f85d1$var$store.get;
    $dbe54846b72f85d1$var$store.has = $dbe54846b72f85d1$var$store.has;
    $dbe54846b72f85d1$var$store.set = $dbe54846b72f85d1$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $dbe54846b72f85d1$var$set = function(it, metadata) {
        if ($dbe54846b72f85d1$var$store.has(it)) throw $dbe54846b72f85d1$var$TypeError($dbe54846b72f85d1$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $dbe54846b72f85d1$var$store.set(it, metadata);
        return metadata;
    };
    $dbe54846b72f85d1$var$get = function(it) {
        return $dbe54846b72f85d1$var$store.get(it) || {};
    };
    $dbe54846b72f85d1$var$has = function(it) {
        return $dbe54846b72f85d1$var$store.has(it);
    };
} else {
    var $dbe54846b72f85d1$var$STATE = $2da5e4152f22a70d$exports("state");
    $2522edb48098e72d$exports[$dbe54846b72f85d1$var$STATE] = true;
    $dbe54846b72f85d1$var$set = function(it, metadata) {
        if ($ef59b581f0d1672b$exports(it, $dbe54846b72f85d1$var$STATE)) throw $dbe54846b72f85d1$var$TypeError($dbe54846b72f85d1$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $4716626f874fe5a3$exports(it, $dbe54846b72f85d1$var$STATE, metadata);
        return metadata;
    };
    $dbe54846b72f85d1$var$get = function(it) {
        return $ef59b581f0d1672b$exports(it, $dbe54846b72f85d1$var$STATE) ? it[$dbe54846b72f85d1$var$STATE] : {};
    };
    $dbe54846b72f85d1$var$has = function(it) {
        return $ef59b581f0d1672b$exports(it, $dbe54846b72f85d1$var$STATE);
    };
}
$dbe54846b72f85d1$exports = {
    set: $dbe54846b72f85d1$var$set,
    get: $dbe54846b72f85d1$var$get,
    has: $dbe54846b72f85d1$var$has,
    enforce: $dbe54846b72f85d1$var$enforce,
    getterFor: $dbe54846b72f85d1$var$getterFor
};


var $e133b70f97609f28$var$enforceInternalState = $dbe54846b72f85d1$exports.enforce;
var $e133b70f97609f28$var$getInternalState = $dbe54846b72f85d1$exports.get;
var $e133b70f97609f28$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $e133b70f97609f28$var$defineProperty = Object.defineProperty;
var $e133b70f97609f28$var$stringSlice = $c510c74e58563f95$exports("".slice);
var $e133b70f97609f28$var$replace = $c510c74e58563f95$exports("".replace);
var $e133b70f97609f28$var$join = $c510c74e58563f95$exports([].join);
var $e133b70f97609f28$var$CONFIGURABLE_LENGTH = $0ab298e69b752e0a$exports && !$4cefcb1c1c1fa750$exports(function() {
    return $e133b70f97609f28$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $e133b70f97609f28$var$TEMPLATE = String(String).split("String");
var $e133b70f97609f28$var$makeBuiltIn = $e133b70f97609f28$exports = function(value, name, options) {
    if ($e133b70f97609f28$var$stringSlice($e133b70f97609f28$var$$String(name), 0, 7) === "Symbol(") name = "[" + $e133b70f97609f28$var$replace($e133b70f97609f28$var$$String(name), /^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$ef59b581f0d1672b$exports(value, "name") || $e133b70f97609f28$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($0ab298e69b752e0a$exports) $e133b70f97609f28$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($e133b70f97609f28$var$CONFIGURABLE_LENGTH && options && $ef59b581f0d1672b$exports(options, "arity") && value.length !== options.arity) $e133b70f97609f28$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $ef59b581f0d1672b$exports(options, "constructor") && options.constructor) {
            if ($0ab298e69b752e0a$exports) $e133b70f97609f28$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $e133b70f97609f28$var$enforceInternalState(value);
    if (!$ef59b581f0d1672b$exports(state, "source")) state.source = $e133b70f97609f28$var$join($e133b70f97609f28$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $e133b70f97609f28$var$makeBuiltIn(function toString() {
    return $c1d5f87f1e56c4cc$exports(this) && $e133b70f97609f28$var$getInternalState(this).source || $1076c59a7c633d48$exports(this);
}, "toString");



$eeb1abced7a4b5b5$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($c1d5f87f1e56c4cc$exports(value)) $e133b70f97609f28$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $efb09e2fcc734bba$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $783b6a5a940dee05$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $503095dd4fa66979$exports = {};

var $99a285ce7f6da130$exports = {};


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $cdc111d4fc429a99$export$2d1720544b23b823;
var $e65d25acc19ca151$exports = {};



var $3b631fee8f1ba65e$exports = {};

var $125a12a61907520f$exports = {};
var $7167297f49b8d757$exports = {};
var $a71fa4672570b675$exports = {};
var $a71fa4672570b675$var$ceil = Math.ceil;
var $a71fa4672570b675$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$a71fa4672570b675$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $a71fa4672570b675$var$floor : $a71fa4672570b675$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$7167297f49b8d757$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $a71fa4672570b675$exports(number);
};


var $125a12a61907520f$var$max = Math.max;
var $125a12a61907520f$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$125a12a61907520f$exports = function(index, length) {
    var integer = $7167297f49b8d757$exports(index);
    return integer < 0 ? $125a12a61907520f$var$max(integer + length, 0) : $125a12a61907520f$var$min(integer, length);
};


var $ec53954e5de19898$exports = {};
var $c2922a7ee9a4ab10$exports = {};

var $c2922a7ee9a4ab10$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$c2922a7ee9a4ab10$exports = function(argument) {
    return argument > 0 ? $c2922a7ee9a4ab10$var$min($7167297f49b8d757$exports(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$ec53954e5de19898$exports = function(obj) {
    return $c2922a7ee9a4ab10$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $3b631fee8f1ba65e$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $b497231b90dfbcaa$exports($this);
        var length = $ec53954e5de19898$exports(O);
        var index = $125a12a61907520f$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$3b631fee8f1ba65e$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $3b631fee8f1ba65e$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $3b631fee8f1ba65e$var$createMethod(false)
};


var $e65d25acc19ca151$require$indexOf = $3b631fee8f1ba65e$exports.indexOf;

var $e65d25acc19ca151$var$push = $c510c74e58563f95$exports([].push);
$e65d25acc19ca151$exports = function(object, names) {
    var O = $b497231b90dfbcaa$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$ef59b581f0d1672b$exports($2522edb48098e72d$exports, key) && $ef59b581f0d1672b$exports(O, key) && $e65d25acc19ca151$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($ef59b581f0d1672b$exports(O, key = names[i++])) ~$e65d25acc19ca151$require$indexOf(result, key) || $e65d25acc19ca151$var$push(result, key);
    return result;
};


var $edf2266aed3a0fbe$exports = {};
// IE8- don't enum bug keys
$edf2266aed3a0fbe$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $cdc111d4fc429a99$var$hiddenKeys = $edf2266aed3a0fbe$exports.concat("length", "prototype");
$cdc111d4fc429a99$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $e65d25acc19ca151$exports(O, $cdc111d4fc429a99$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $8d61c7ace25f8e17$export$2d1720544b23b823;
$8d61c7ace25f8e17$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $99a285ce7f6da130$var$concat = $c510c74e58563f95$exports([].concat);
// all object keys, includes non-enumerable and symbols
$99a285ce7f6da130$exports = $ba2da80b68ee643e$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $cdc111d4fc429a99$export$2d1720544b23b823($830db860a045bbb5$exports(it));
    var getOwnPropertySymbols = $8d61c7ace25f8e17$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $99a285ce7f6da130$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$503095dd4fa66979$exports = function(target, source, exceptions) {
    var keys = $99a285ce7f6da130$exports(source);
    var defineProperty = $783b6a5a940dee05$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $dc708c9bcef7b78f$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$ef59b581f0d1672b$exports(target, key) && !(exceptions && $ef59b581f0d1672b$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $87321f98e08714ab$exports = {};


var $87321f98e08714ab$var$replacement = /#|\.prototype\./;
var $87321f98e08714ab$var$isForced = function(feature, detection) {
    var value = $87321f98e08714ab$var$data[$87321f98e08714ab$var$normalize(feature)];
    return value == $87321f98e08714ab$var$POLYFILL ? true : value == $87321f98e08714ab$var$NATIVE ? false : $c1d5f87f1e56c4cc$exports(detection) ? $4cefcb1c1c1fa750$exports(detection) : !!detection;
};
var $87321f98e08714ab$var$normalize = $87321f98e08714ab$var$isForced.normalize = function(string) {
    return String(string).replace($87321f98e08714ab$var$replacement, ".").toLowerCase();
};
var $87321f98e08714ab$var$data = $87321f98e08714ab$var$isForced.data = {};
var $87321f98e08714ab$var$NATIVE = $87321f98e08714ab$var$isForced.NATIVE = "N";
var $87321f98e08714ab$var$POLYFILL = $87321f98e08714ab$var$isForced.POLYFILL = "P";
$87321f98e08714ab$exports = $87321f98e08714ab$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $0365e955907213bd$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $1a6e68c95df7d4df$exports;
    else if (STATIC) target = $1a6e68c95df7d4df$exports[TARGET] || $efb09e2fcc734bba$exports(TARGET, {});
    else target = ($1a6e68c95df7d4df$exports[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $0365e955907213bd$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $87321f98e08714ab$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $503095dd4fa66979$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $4716626f874fe5a3$exports(sourceProperty, "sham", true);
        $eeb1abced7a4b5b5$exports(target, key, sourceProperty, options);
    }
};














var $53d734af07b69aa7$exports = {};
var $79ec051cbbc13a5e$exports = {};
var $8753fad30d68c98e$exports = {};

var $8753fad30d68c98e$var$TO_STRING_TAG = $5cfcb69f0877711f$exports("toStringTag");
var $8753fad30d68c98e$var$test = {};
$8753fad30d68c98e$var$test[$8753fad30d68c98e$var$TO_STRING_TAG] = "z";
$8753fad30d68c98e$exports = String($8753fad30d68c98e$var$test) === "[object z]";





var $79ec051cbbc13a5e$var$TO_STRING_TAG = $5cfcb69f0877711f$exports("toStringTag");
var $79ec051cbbc13a5e$var$$Object = Object;
// ES3 wrong here
var $79ec051cbbc13a5e$var$CORRECT_ARGUMENTS = $ee4d29ebca1023f3$exports(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $79ec051cbbc13a5e$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$79ec051cbbc13a5e$exports = $8753fad30d68c98e$exports ? $ee4d29ebca1023f3$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $79ec051cbbc13a5e$var$tryGet(O = $79ec051cbbc13a5e$var$$Object(it), $79ec051cbbc13a5e$var$TO_STRING_TAG)) == "string" ? tag : $79ec051cbbc13a5e$var$CORRECT_ARGUMENTS ? $ee4d29ebca1023f3$exports(O) : (result = $ee4d29ebca1023f3$exports(O)) == "Object" && $c1d5f87f1e56c4cc$exports(O.callee) ? "Arguments" : result;
};


var $53d734af07b69aa7$var$$String = String;
$53d734af07b69aa7$exports = function(argument) {
    if ($79ec051cbbc13a5e$exports(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $53d734af07b69aa7$var$$String(argument);
};



var $290768129b19866b$exports = {};
/* global ActiveXObject -- old IE, WSH */ 
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $43b765e73dea31e3$export$2d1720544b23b823;





var $8fa2ece3d22ab2a0$exports = {};


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$8fa2ece3d22ab2a0$exports = Object.keys || function keys(O) {
    return $e65d25acc19ca151$exports(O, $edf2266aed3a0fbe$exports);
};


$43b765e73dea31e3$export$2d1720544b23b823 = $0ab298e69b752e0a$exports && !$3a1a75f466046406$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $830db860a045bbb5$exports(O);
    var props = $b497231b90dfbcaa$exports(Properties);
    var keys = $8fa2ece3d22ab2a0$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$783b6a5a940dee05$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $c923381aa0cbb3ad$exports = {};

$c923381aa0cbb3ad$exports = $ba2da80b68ee643e$exports("document", "documentElement");




var $290768129b19866b$var$GT = ">";
var $290768129b19866b$var$LT = "<";
var $290768129b19866b$var$PROTOTYPE = "prototype";
var $290768129b19866b$var$SCRIPT = "script";
var $290768129b19866b$var$IE_PROTO = $2da5e4152f22a70d$exports("IE_PROTO");
var $290768129b19866b$var$EmptyConstructor = function() {};
var $290768129b19866b$var$scriptTag = function(content) {
    return $290768129b19866b$var$LT + $290768129b19866b$var$SCRIPT + $290768129b19866b$var$GT + content + $290768129b19866b$var$LT + "/" + $290768129b19866b$var$SCRIPT + $290768129b19866b$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $290768129b19866b$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($290768129b19866b$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $290768129b19866b$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $50f1c27ed88e8707$exports("iframe");
    var JS = "java" + $290768129b19866b$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $c923381aa0cbb3ad$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($290768129b19866b$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $290768129b19866b$var$activeXDocument;
var $290768129b19866b$var$NullProtoObject = function() {
    try {
        $290768129b19866b$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $290768129b19866b$var$NullProtoObject = typeof document != "undefined" ? document.domain && $290768129b19866b$var$activeXDocument ? $290768129b19866b$var$NullProtoObjectViaActiveX($290768129b19866b$var$activeXDocument) // old IE
     : $290768129b19866b$var$NullProtoObjectViaIFrame() : $290768129b19866b$var$NullProtoObjectViaActiveX($290768129b19866b$var$activeXDocument); // WSH
    var length = $edf2266aed3a0fbe$exports.length;
    while(length--)delete $290768129b19866b$var$NullProtoObject[$290768129b19866b$var$PROTOTYPE][$edf2266aed3a0fbe$exports[length]];
    return $290768129b19866b$var$NullProtoObject();
};
$2522edb48098e72d$exports[$290768129b19866b$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
$290768129b19866b$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $290768129b19866b$var$EmptyConstructor[$290768129b19866b$var$PROTOTYPE] = $830db860a045bbb5$exports(O);
        result = new $290768129b19866b$var$EmptyConstructor();
        $290768129b19866b$var$EmptyConstructor[$290768129b19866b$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$290768129b19866b$var$IE_PROTO] = O;
    } else result = $290768129b19866b$var$NullProtoObject();
    return Properties === undefined ? result : $43b765e73dea31e3$export$2d1720544b23b823(result, Properties);
};




/* eslint-disable es/no-object-getownpropertynames -- safe */ // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $2c014ad5d62fc6d4$export$2d1720544b23b823;



var $2c014ad5d62fc6d4$require$$getOwnPropertyNames = $cdc111d4fc429a99$export$2d1720544b23b823;
var $df6d3dbc942f438e$exports = {};


var $1d4c3fb4ee6719a3$exports = {};
"use strict";



$1d4c3fb4ee6719a3$exports = function(object, key, value) {
    var propertyKey = $df8c871456bcdfdf$exports(key);
    if (propertyKey in object) $783b6a5a940dee05$export$2d1720544b23b823(object, propertyKey, $d6bcb34392440d40$exports(0, value));
    else object[propertyKey] = value;
};


var $df6d3dbc942f438e$var$$Array = Array;
var $df6d3dbc942f438e$var$max = Math.max;
$df6d3dbc942f438e$exports = function(O, start, end) {
    var length = $ec53954e5de19898$exports(O);
    var k = $125a12a61907520f$exports(start, length);
    var fin = $125a12a61907520f$exports(end === undefined ? length : end, length);
    var result = $df6d3dbc942f438e$var$$Array($df6d3dbc942f438e$var$max(fin - k, 0));
    for(var n = 0; k < fin; k++, n++)$1d4c3fb4ee6719a3$exports(result, n, O[k]);
    result.length = n;
    return result;
};


var $2c014ad5d62fc6d4$var$windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $2c014ad5d62fc6d4$var$getWindowNames = function(it) {
    try {
        return $2c014ad5d62fc6d4$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $df6d3dbc942f438e$exports($2c014ad5d62fc6d4$var$windowNames);
    }
};
$2c014ad5d62fc6d4$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $2c014ad5d62fc6d4$var$windowNames && $ee4d29ebca1023f3$exports(it) == "Window" ? $2c014ad5d62fc6d4$var$getWindowNames(it) : $2c014ad5d62fc6d4$require$$getOwnPropertyNames($b497231b90dfbcaa$exports(it));
};








var $54b1e35819861675$exports = {};


$54b1e35819861675$exports = function(target, name, descriptor) {
    if (descriptor.get) $e133b70f97609f28$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $e133b70f97609f28$exports(descriptor.set, name, {
        setter: true
    });
    return $783b6a5a940dee05$export$2d1720544b23b823(target, name, descriptor);
};







var $4a61484ccb755cc5$export$2d1720544b23b823;

$4a61484ccb755cc5$export$2d1720544b23b823 = $5cfcb69f0877711f$exports;


var $c4d506ca25aae994$exports = {};
var $bee7a5ff7821416e$exports = {};

$bee7a5ff7821416e$exports = $1a6e68c95df7d4df$exports;





var $c4d506ca25aae994$require$defineProperty = $783b6a5a940dee05$export$2d1720544b23b823;
$c4d506ca25aae994$exports = function(NAME) {
    var Symbol = $bee7a5ff7821416e$exports.Symbol || ($bee7a5ff7821416e$exports.Symbol = {});
    if (!$ef59b581f0d1672b$exports(Symbol, NAME)) $c4d506ca25aae994$require$defineProperty(Symbol, NAME, {
        value: $4a61484ccb755cc5$export$2d1720544b23b823(NAME)
    });
};


var $58588f6619c288ba$exports = {};




$58588f6619c288ba$exports = function() {
    var Symbol = $ba2da80b68ee643e$exports("Symbol");
    var SymbolPrototype = Symbol && Symbol.prototype;
    var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
    var TO_PRIMITIVE = $5cfcb69f0877711f$exports("toPrimitive");
    if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    $eeb1abced7a4b5b5$exports(SymbolPrototype, TO_PRIMITIVE, function(hint) {
        return $3b5393d57c251c61$exports(valueOf, this);
    }, {
        arity: 1
    });
};


var $ec32ac1e3fb4a1a1$exports = {};

var $ec32ac1e3fb4a1a1$require$defineProperty = $783b6a5a940dee05$export$2d1720544b23b823;


var $ec32ac1e3fb4a1a1$var$TO_STRING_TAG = $5cfcb69f0877711f$exports("toStringTag");
$ec32ac1e3fb4a1a1$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$ef59b581f0d1672b$exports(target, $ec32ac1e3fb4a1a1$var$TO_STRING_TAG)) $ec32ac1e3fb4a1a1$require$defineProperty(target, $ec32ac1e3fb4a1a1$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};



var $0c96980c391de2dd$exports = {};
var $130f24665ebee510$exports = {};
var $31a67080629c484a$exports = {};


$31a67080629c484a$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($ee4d29ebca1023f3$exports(fn) === "Function") return $c510c74e58563f95$exports(fn);
};




var $130f24665ebee510$var$bind = $31a67080629c484a$exports($31a67080629c484a$exports.bind);
// optional / simple context binding
$130f24665ebee510$exports = function(fn, that) {
    $4a6b57cf563748d0$exports(fn);
    return that === undefined ? fn : $05c82362c0ced3b1$exports ? $130f24665ebee510$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};






var $1ee0284d6e87ccd9$exports = {};
var $341cbac749f117a1$exports = {};
var $2292f8893faf17d1$exports = {};

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
$2292f8893faf17d1$exports = Array.isArray || function isArray(argument) {
    return $ee4d29ebca1023f3$exports(argument) == "Array";
};


var $f09b11ea7290b6eb$exports = {};






var $f09b11ea7290b6eb$var$noop = function() {};
var $f09b11ea7290b6eb$var$empty = [];
var $f09b11ea7290b6eb$var$construct = $ba2da80b68ee643e$exports("Reflect", "construct");
var $f09b11ea7290b6eb$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $f09b11ea7290b6eb$var$exec = $c510c74e58563f95$exports($f09b11ea7290b6eb$var$constructorRegExp.exec);
var $f09b11ea7290b6eb$var$INCORRECT_TO_STRING = !$f09b11ea7290b6eb$var$constructorRegExp.exec($f09b11ea7290b6eb$var$noop);
var $f09b11ea7290b6eb$var$isConstructorModern = function isConstructor(argument) {
    if (!$c1d5f87f1e56c4cc$exports(argument)) return false;
    try {
        $f09b11ea7290b6eb$var$construct($f09b11ea7290b6eb$var$noop, $f09b11ea7290b6eb$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $f09b11ea7290b6eb$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$c1d5f87f1e56c4cc$exports(argument)) return false;
    switch($79ec051cbbc13a5e$exports(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $f09b11ea7290b6eb$var$INCORRECT_TO_STRING || !!$f09b11ea7290b6eb$var$exec($f09b11ea7290b6eb$var$constructorRegExp, $1076c59a7c633d48$exports(argument));
    } catch (error) {
        return true;
    }
};
$f09b11ea7290b6eb$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
$f09b11ea7290b6eb$exports = !$f09b11ea7290b6eb$var$construct || $4cefcb1c1c1fa750$exports(function() {
    var called;
    return $f09b11ea7290b6eb$var$isConstructorModern($f09b11ea7290b6eb$var$isConstructorModern.call) || !$f09b11ea7290b6eb$var$isConstructorModern(Object) || !$f09b11ea7290b6eb$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $f09b11ea7290b6eb$var$isConstructorLegacy : $f09b11ea7290b6eb$var$isConstructorModern;




var $341cbac749f117a1$var$SPECIES = $5cfcb69f0877711f$exports("species");
var $341cbac749f117a1$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$341cbac749f117a1$exports = function(originalArray) {
    var C;
    if ($2292f8893faf17d1$exports(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($f09b11ea7290b6eb$exports(C) && (C === $341cbac749f117a1$var$$Array || $2292f8893faf17d1$exports(C.prototype))) C = undefined;
        else if ($dfdc56bc53f57e69$exports(C)) {
            C = C[$341cbac749f117a1$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $341cbac749f117a1$var$$Array : C;
};


// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$1ee0284d6e87ccd9$exports = function(originalArray, length) {
    return new ($341cbac749f117a1$exports(originalArray))(length === 0 ? 0 : length);
};


var $0c96980c391de2dd$var$push = $c510c74e58563f95$exports([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $0c96980c391de2dd$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var IS_FILTER_REJECT = TYPE == 7;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $cc6f28a96f61f0ea$exports($this);
        var self = $77acd9fe92ee403a$exports(O);
        var boundFunction = $130f24665ebee510$exports(callbackfn, that);
        var length = $ec53954e5de19898$exports(self);
        var index = 0;
        var create = specificCreate || $1ee0284d6e87ccd9$exports;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $0c96980c391de2dd$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $0c96980c391de2dd$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
$0c96980c391de2dd$exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $0c96980c391de2dd$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $0c96980c391de2dd$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $0c96980c391de2dd$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $0c96980c391de2dd$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $0c96980c391de2dd$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $0c96980c391de2dd$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $0c96980c391de2dd$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $0c96980c391de2dd$var$createMethod(7)
};


var $8eeb2d6c7280d019$require$$forEach = $0c96980c391de2dd$exports.forEach;
var $8eeb2d6c7280d019$var$HIDDEN = $2da5e4152f22a70d$exports("hidden");
var $8eeb2d6c7280d019$var$SYMBOL = "Symbol";
var $8eeb2d6c7280d019$var$PROTOTYPE = "prototype";
var $8eeb2d6c7280d019$var$setInternalState = $dbe54846b72f85d1$exports.set;
var $8eeb2d6c7280d019$var$getInternalState = $dbe54846b72f85d1$exports.getterFor($8eeb2d6c7280d019$var$SYMBOL);
var $8eeb2d6c7280d019$var$ObjectPrototype = Object[$8eeb2d6c7280d019$var$PROTOTYPE];
var $8eeb2d6c7280d019$var$$Symbol = $1a6e68c95df7d4df$exports.Symbol;
var $8eeb2d6c7280d019$var$SymbolPrototype = $8eeb2d6c7280d019$var$$Symbol && $8eeb2d6c7280d019$var$$Symbol[$8eeb2d6c7280d019$var$PROTOTYPE];
var $8eeb2d6c7280d019$var$TypeError = $1a6e68c95df7d4df$exports.TypeError;
var $8eeb2d6c7280d019$var$QObject = $1a6e68c95df7d4df$exports.QObject;
var $8eeb2d6c7280d019$var$nativeGetOwnPropertyDescriptor = $dc708c9bcef7b78f$export$2d1720544b23b823;
var $8eeb2d6c7280d019$var$nativeDefineProperty = $783b6a5a940dee05$export$2d1720544b23b823;
var $8eeb2d6c7280d019$var$nativeGetOwnPropertyNames = $2c014ad5d62fc6d4$export$2d1720544b23b823;
var $8eeb2d6c7280d019$var$nativePropertyIsEnumerable = $369ff2248a9e8d32$export$2d1720544b23b823;
var $8eeb2d6c7280d019$var$push = $c510c74e58563f95$exports([].push);
var $8eeb2d6c7280d019$var$AllSymbols = $5b6f77fe4ecb64db$exports("symbols");
var $8eeb2d6c7280d019$var$ObjectPrototypeSymbols = $5b6f77fe4ecb64db$exports("op-symbols");
var $8eeb2d6c7280d019$var$WellKnownSymbolsStore = $5b6f77fe4ecb64db$exports("wks");
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $8eeb2d6c7280d019$var$USE_SETTER = !$8eeb2d6c7280d019$var$QObject || !$8eeb2d6c7280d019$var$QObject[$8eeb2d6c7280d019$var$PROTOTYPE] || !$8eeb2d6c7280d019$var$QObject[$8eeb2d6c7280d019$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $8eeb2d6c7280d019$var$setSymbolDescriptor = $0ab298e69b752e0a$exports && $4cefcb1c1c1fa750$exports(function() {
    return $290768129b19866b$exports($8eeb2d6c7280d019$var$nativeDefineProperty({}, "a", {
        get: function() {
            return $8eeb2d6c7280d019$var$nativeDefineProperty(this, "a", {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(O, P, Attributes) {
    var ObjectPrototypeDescriptor = $8eeb2d6c7280d019$var$nativeGetOwnPropertyDescriptor($8eeb2d6c7280d019$var$ObjectPrototype, P);
    if (ObjectPrototypeDescriptor) delete $8eeb2d6c7280d019$var$ObjectPrototype[P];
    $8eeb2d6c7280d019$var$nativeDefineProperty(O, P, Attributes);
    if (ObjectPrototypeDescriptor && O !== $8eeb2d6c7280d019$var$ObjectPrototype) $8eeb2d6c7280d019$var$nativeDefineProperty($8eeb2d6c7280d019$var$ObjectPrototype, P, ObjectPrototypeDescriptor);
} : $8eeb2d6c7280d019$var$nativeDefineProperty;
var $8eeb2d6c7280d019$var$wrap = function(tag, description) {
    var symbol = $8eeb2d6c7280d019$var$AllSymbols[tag] = $290768129b19866b$exports($8eeb2d6c7280d019$var$SymbolPrototype);
    $8eeb2d6c7280d019$var$setInternalState(symbol, {
        type: $8eeb2d6c7280d019$var$SYMBOL,
        tag: tag,
        description: description
    });
    if (!$0ab298e69b752e0a$exports) symbol.description = description;
    return symbol;
};
var $8eeb2d6c7280d019$var$$defineProperty = function defineProperty(O, P, Attributes) {
    if (O === $8eeb2d6c7280d019$var$ObjectPrototype) $8eeb2d6c7280d019$var$$defineProperty($8eeb2d6c7280d019$var$ObjectPrototypeSymbols, P, Attributes);
    $830db860a045bbb5$exports(O);
    var key = $df8c871456bcdfdf$exports(P);
    $830db860a045bbb5$exports(Attributes);
    if ($ef59b581f0d1672b$exports($8eeb2d6c7280d019$var$AllSymbols, key)) {
        if (!Attributes.enumerable) {
            if (!$ef59b581f0d1672b$exports(O, $8eeb2d6c7280d019$var$HIDDEN)) $8eeb2d6c7280d019$var$nativeDefineProperty(O, $8eeb2d6c7280d019$var$HIDDEN, $d6bcb34392440d40$exports(1, {}));
            O[$8eeb2d6c7280d019$var$HIDDEN][key] = true;
        } else {
            if ($ef59b581f0d1672b$exports(O, $8eeb2d6c7280d019$var$HIDDEN) && O[$8eeb2d6c7280d019$var$HIDDEN][key]) O[$8eeb2d6c7280d019$var$HIDDEN][key] = false;
            Attributes = $290768129b19866b$exports(Attributes, {
                enumerable: $d6bcb34392440d40$exports(0, false)
            });
        }
        return $8eeb2d6c7280d019$var$setSymbolDescriptor(O, key, Attributes);
    }
    return $8eeb2d6c7280d019$var$nativeDefineProperty(O, key, Attributes);
};
var $8eeb2d6c7280d019$var$$defineProperties = function defineProperties(O, Properties) {
    $830db860a045bbb5$exports(O);
    var properties = $b497231b90dfbcaa$exports(Properties);
    var keys = $8fa2ece3d22ab2a0$exports(properties).concat($8eeb2d6c7280d019$var$$getOwnPropertySymbols(properties));
    $8eeb2d6c7280d019$require$$forEach(keys, function(key) {
        if (!$0ab298e69b752e0a$exports || $3b5393d57c251c61$exports($8eeb2d6c7280d019$var$$propertyIsEnumerable, properties, key)) $8eeb2d6c7280d019$var$$defineProperty(O, key, properties[key]);
    });
    return O;
};
var $8eeb2d6c7280d019$var$$create = function create(O, Properties) {
    return Properties === undefined ? $290768129b19866b$exports(O) : $8eeb2d6c7280d019$var$$defineProperties($290768129b19866b$exports(O), Properties);
};
var $8eeb2d6c7280d019$var$$propertyIsEnumerable = function propertyIsEnumerable(V) {
    var P = $df8c871456bcdfdf$exports(V);
    var enumerable = $3b5393d57c251c61$exports($8eeb2d6c7280d019$var$nativePropertyIsEnumerable, this, P);
    if (this === $8eeb2d6c7280d019$var$ObjectPrototype && $ef59b581f0d1672b$exports($8eeb2d6c7280d019$var$AllSymbols, P) && !$ef59b581f0d1672b$exports($8eeb2d6c7280d019$var$ObjectPrototypeSymbols, P)) return false;
    return enumerable || !$ef59b581f0d1672b$exports(this, P) || !$ef59b581f0d1672b$exports($8eeb2d6c7280d019$var$AllSymbols, P) || $ef59b581f0d1672b$exports(this, $8eeb2d6c7280d019$var$HIDDEN) && this[$8eeb2d6c7280d019$var$HIDDEN][P] ? enumerable : true;
};
var $8eeb2d6c7280d019$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
    var it = $b497231b90dfbcaa$exports(O);
    var key = $df8c871456bcdfdf$exports(P);
    if (it === $8eeb2d6c7280d019$var$ObjectPrototype && $ef59b581f0d1672b$exports($8eeb2d6c7280d019$var$AllSymbols, key) && !$ef59b581f0d1672b$exports($8eeb2d6c7280d019$var$ObjectPrototypeSymbols, key)) return;
    var descriptor = $8eeb2d6c7280d019$var$nativeGetOwnPropertyDescriptor(it, key);
    if (descriptor && $ef59b581f0d1672b$exports($8eeb2d6c7280d019$var$AllSymbols, key) && !($ef59b581f0d1672b$exports(it, $8eeb2d6c7280d019$var$HIDDEN) && it[$8eeb2d6c7280d019$var$HIDDEN][key])) descriptor.enumerable = true;
    return descriptor;
};
var $8eeb2d6c7280d019$var$$getOwnPropertyNames = function getOwnPropertyNames(O) {
    var names = $8eeb2d6c7280d019$var$nativeGetOwnPropertyNames($b497231b90dfbcaa$exports(O));
    var result = [];
    $8eeb2d6c7280d019$require$$forEach(names, function(key) {
        if (!$ef59b581f0d1672b$exports($8eeb2d6c7280d019$var$AllSymbols, key) && !$ef59b581f0d1672b$exports($2522edb48098e72d$exports, key)) $8eeb2d6c7280d019$var$push(result, key);
    });
    return result;
};
var $8eeb2d6c7280d019$var$$getOwnPropertySymbols = function(O) {
    var IS_OBJECT_PROTOTYPE = O === $8eeb2d6c7280d019$var$ObjectPrototype;
    var names = $8eeb2d6c7280d019$var$nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? $8eeb2d6c7280d019$var$ObjectPrototypeSymbols : $b497231b90dfbcaa$exports(O));
    var result = [];
    $8eeb2d6c7280d019$require$$forEach(names, function(key) {
        if ($ef59b581f0d1672b$exports($8eeb2d6c7280d019$var$AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || $ef59b581f0d1672b$exports($8eeb2d6c7280d019$var$ObjectPrototype, key))) $8eeb2d6c7280d019$var$push(result, $8eeb2d6c7280d019$var$AllSymbols[key]);
    });
    return result;
};
// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!$5c26fe98edd631fb$exports) {
    $8eeb2d6c7280d019$var$$Symbol = function Symbol() {
        if ($b82c3d945f0459c1$exports($8eeb2d6c7280d019$var$SymbolPrototype, this)) throw $8eeb2d6c7280d019$var$TypeError("Symbol is not a constructor");
        var description = !arguments.length || arguments[0] === undefined ? undefined : $53d734af07b69aa7$exports(arguments[0]);
        var tag = $8e860c2fd7cf6ff6$exports(description);
        var setter = function(value) {
            if (this === $8eeb2d6c7280d019$var$ObjectPrototype) $3b5393d57c251c61$exports(setter, $8eeb2d6c7280d019$var$ObjectPrototypeSymbols, value);
            if ($ef59b581f0d1672b$exports(this, $8eeb2d6c7280d019$var$HIDDEN) && $ef59b581f0d1672b$exports(this[$8eeb2d6c7280d019$var$HIDDEN], tag)) this[$8eeb2d6c7280d019$var$HIDDEN][tag] = false;
            $8eeb2d6c7280d019$var$setSymbolDescriptor(this, tag, $d6bcb34392440d40$exports(1, value));
        };
        if ($0ab298e69b752e0a$exports && $8eeb2d6c7280d019$var$USE_SETTER) $8eeb2d6c7280d019$var$setSymbolDescriptor($8eeb2d6c7280d019$var$ObjectPrototype, tag, {
            configurable: true,
            set: setter
        });
        return $8eeb2d6c7280d019$var$wrap(tag, description);
    };
    $8eeb2d6c7280d019$var$SymbolPrototype = $8eeb2d6c7280d019$var$$Symbol[$8eeb2d6c7280d019$var$PROTOTYPE];
    $eeb1abced7a4b5b5$exports($8eeb2d6c7280d019$var$SymbolPrototype, "toString", function toString() {
        return $8eeb2d6c7280d019$var$getInternalState(this).tag;
    });
    $eeb1abced7a4b5b5$exports($8eeb2d6c7280d019$var$$Symbol, "withoutSetter", function(description) {
        return $8eeb2d6c7280d019$var$wrap($8e860c2fd7cf6ff6$exports(description), description);
    });
    $369ff2248a9e8d32$export$2d1720544b23b823 = $8eeb2d6c7280d019$var$$propertyIsEnumerable;
    $783b6a5a940dee05$export$2d1720544b23b823 = $8eeb2d6c7280d019$var$$defineProperty;
    $43b765e73dea31e3$export$2d1720544b23b823 = $8eeb2d6c7280d019$var$$defineProperties;
    $dc708c9bcef7b78f$export$2d1720544b23b823 = $8eeb2d6c7280d019$var$$getOwnPropertyDescriptor;
    $cdc111d4fc429a99$export$2d1720544b23b823 = $2c014ad5d62fc6d4$export$2d1720544b23b823 = $8eeb2d6c7280d019$var$$getOwnPropertyNames;
    $8d61c7ace25f8e17$export$2d1720544b23b823 = $8eeb2d6c7280d019$var$$getOwnPropertySymbols;
    $4a61484ccb755cc5$export$2d1720544b23b823 = function(name) {
        return $8eeb2d6c7280d019$var$wrap($5cfcb69f0877711f$exports(name), name);
    };
    if ($0ab298e69b752e0a$exports) {
        // https://github.com/tc39/proposal-Symbol-description
        $54b1e35819861675$exports($8eeb2d6c7280d019$var$SymbolPrototype, "description", {
            configurable: true,
            get: function description() {
                return $8eeb2d6c7280d019$var$getInternalState(this).description;
            }
        });
        if (!$fef1920ae5260386$exports) $eeb1abced7a4b5b5$exports($8eeb2d6c7280d019$var$ObjectPrototype, "propertyIsEnumerable", $8eeb2d6c7280d019$var$$propertyIsEnumerable, {
            unsafe: true
        });
    }
}
$0365e955907213bd$exports({
    global: true,
    constructor: true,
    wrap: true,
    forced: !$5c26fe98edd631fb$exports,
    sham: !$5c26fe98edd631fb$exports
}, {
    Symbol: $8eeb2d6c7280d019$var$$Symbol
});
$8eeb2d6c7280d019$require$$forEach($8fa2ece3d22ab2a0$exports($8eeb2d6c7280d019$var$WellKnownSymbolsStore), function(name) {
    $c4d506ca25aae994$exports(name);
});
$0365e955907213bd$exports({
    target: $8eeb2d6c7280d019$var$SYMBOL,
    stat: true,
    forced: !$5c26fe98edd631fb$exports
}, {
    useSetter: function() {
        $8eeb2d6c7280d019$var$USE_SETTER = true;
    },
    useSimple: function() {
        $8eeb2d6c7280d019$var$USE_SETTER = false;
    }
});
$0365e955907213bd$exports({
    target: "Object",
    stat: true,
    forced: !$5c26fe98edd631fb$exports,
    sham: !$0ab298e69b752e0a$exports
}, {
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    create: $8eeb2d6c7280d019$var$$create,
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    defineProperty: $8eeb2d6c7280d019$var$$defineProperty,
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    defineProperties: $8eeb2d6c7280d019$var$$defineProperties,
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
    getOwnPropertyDescriptor: $8eeb2d6c7280d019$var$$getOwnPropertyDescriptor
});
$0365e955907213bd$exports({
    target: "Object",
    stat: true,
    forced: !$5c26fe98edd631fb$exports
}, {
    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    getOwnPropertyNames: $8eeb2d6c7280d019$var$$getOwnPropertyNames
});
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$58588f6619c288ba$exports();
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$ec32ac1e3fb4a1a1$exports($8eeb2d6c7280d019$var$$Symbol, $8eeb2d6c7280d019$var$SYMBOL);
$2522edb48098e72d$exports[$8eeb2d6c7280d019$var$HIDDEN] = true;







var $4038b4c375c2cdb4$exports = {};

/* eslint-disable es/no-symbol -- safe */ $4038b4c375c2cdb4$exports = $5c26fe98edd631fb$exports && !!Symbol["for"] && !!Symbol.keyFor;


var $9f4ada88e9800554$var$StringToSymbolRegistry = $5b6f77fe4ecb64db$exports("string-to-symbol-registry");
var $9f4ada88e9800554$var$SymbolToStringRegistry = $5b6f77fe4ecb64db$exports("symbol-to-string-registry");
// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$0365e955907213bd$exports({
    target: "Symbol",
    stat: true,
    forced: !$4038b4c375c2cdb4$exports
}, {
    "for": function(key) {
        var string = $53d734af07b69aa7$exports(key);
        if ($ef59b581f0d1672b$exports($9f4ada88e9800554$var$StringToSymbolRegistry, string)) return $9f4ada88e9800554$var$StringToSymbolRegistry[string];
        var symbol = $ba2da80b68ee643e$exports("Symbol")(string);
        $9f4ada88e9800554$var$StringToSymbolRegistry[string] = symbol;
        $9f4ada88e9800554$var$SymbolToStringRegistry[symbol] = string;
        return symbol;
    }
});








var $b7ea50a0eba8fdc0$var$SymbolToStringRegistry = $5b6f77fe4ecb64db$exports("symbol-to-string-registry");
// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$0365e955907213bd$exports({
    target: "Symbol",
    stat: true,
    forced: !$4038b4c375c2cdb4$exports
}, {
    keyFor: function keyFor(sym) {
        if (!$0d71f82f3bc811d0$exports(sym)) throw TypeError($f3ce16a57f0d7972$exports(sym) + " is not a symbol");
        if ($ef59b581f0d1672b$exports($b7ea50a0eba8fdc0$var$SymbolToStringRegistry, sym)) return $b7ea50a0eba8fdc0$var$SymbolToStringRegistry[sym];
    }
});




var $17764d41e6b47061$exports = {};

var $17764d41e6b47061$var$FunctionPrototype = Function.prototype;
var $17764d41e6b47061$var$apply = $17764d41e6b47061$var$FunctionPrototype.apply;
var $17764d41e6b47061$var$call = $17764d41e6b47061$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$17764d41e6b47061$exports = typeof Reflect == "object" && Reflect.apply || ($05c82362c0ced3b1$exports ? $17764d41e6b47061$var$call.bind($17764d41e6b47061$var$apply) : function() {
    return $17764d41e6b47061$var$call.apply($17764d41e6b47061$var$apply, arguments);
});







var $05068435b6a808dd$exports = {};

$05068435b6a808dd$exports = $c510c74e58563f95$exports([].slice);


var $4c2600e1fd9b5dab$exports = {};





var $4c2600e1fd9b5dab$var$push = $c510c74e58563f95$exports([].push);
$4c2600e1fd9b5dab$exports = function(replacer) {
    if ($c1d5f87f1e56c4cc$exports(replacer)) return replacer;
    if (!$2292f8893faf17d1$exports(replacer)) return;
    var rawLength = replacer.length;
    var keys = [];
    for(var i = 0; i < rawLength; i++){
        var element = replacer[i];
        if (typeof element == "string") $4c2600e1fd9b5dab$var$push(keys, element);
        else if (typeof element == "number" || $ee4d29ebca1023f3$exports(element) == "Number" || $ee4d29ebca1023f3$exports(element) == "String") $4c2600e1fd9b5dab$var$push(keys, $53d734af07b69aa7$exports(element));
    }
    var keysLength = keys.length;
    var root = true;
    return function(key, value) {
        if (root) {
            root = false;
            return value;
        }
        if ($2292f8893faf17d1$exports(this)) return value;
        for(var j = 0; j < keysLength; j++)if (keys[j] === key) return value;
    };
};



var $85e47a21f36101a3$var$$String = String;
var $85e47a21f36101a3$var$$stringify = $ba2da80b68ee643e$exports("JSON", "stringify");
var $85e47a21f36101a3$var$exec = $c510c74e58563f95$exports(/./.exec);
var $85e47a21f36101a3$var$charAt = $c510c74e58563f95$exports("".charAt);
var $85e47a21f36101a3$var$charCodeAt = $c510c74e58563f95$exports("".charCodeAt);
var $85e47a21f36101a3$var$replace = $c510c74e58563f95$exports("".replace);
var $85e47a21f36101a3$var$numberToString = $c510c74e58563f95$exports(1.0.toString);
var $85e47a21f36101a3$var$tester = /[\uD800-\uDFFF]/g;
var $85e47a21f36101a3$var$low = /^[\uD800-\uDBFF]$/;
var $85e47a21f36101a3$var$hi = /^[\uDC00-\uDFFF]$/;
var $85e47a21f36101a3$var$WRONG_SYMBOLS_CONVERSION = !$5c26fe98edd631fb$exports || $4cefcb1c1c1fa750$exports(function() {
    var symbol = $ba2da80b68ee643e$exports("Symbol")();
    // MS Edge converts symbol values to JSON as {}
    return $85e47a21f36101a3$var$$stringify([
        symbol
    ]) != "[null]" || $85e47a21f36101a3$var$$stringify({
        a: symbol
    }) != "{}" || $85e47a21f36101a3$var$$stringify(Object(symbol)) != "{}";
});
// https://github.com/tc39/proposal-well-formed-stringify
var $85e47a21f36101a3$var$ILL_FORMED_UNICODE = $4cefcb1c1c1fa750$exports(function() {
    return $85e47a21f36101a3$var$$stringify("\uDF06\uD834") !== '"\udf06\ud834"' || $85e47a21f36101a3$var$$stringify("\uDEAD") !== '"\udead"';
});
var $85e47a21f36101a3$var$stringifyWithSymbolsFix = function(it, replacer) {
    var args = $05068435b6a808dd$exports(arguments);
    var $replacer = $4c2600e1fd9b5dab$exports(replacer);
    if (!$c1d5f87f1e56c4cc$exports($replacer) && (it === undefined || $0d71f82f3bc811d0$exports(it))) return; // IE8 returns string on undefined
    args[1] = function(key, value) {
        // some old implementations (like WebKit) could pass numbers as keys
        if ($c1d5f87f1e56c4cc$exports($replacer)) value = $3b5393d57c251c61$exports($replacer, this, $85e47a21f36101a3$var$$String(key), value);
        if (!$0d71f82f3bc811d0$exports(value)) return value;
    };
    return $17764d41e6b47061$exports($85e47a21f36101a3$var$$stringify, null, args);
};
var $85e47a21f36101a3$var$fixIllFormed = function(match, offset, string) {
    var prev = $85e47a21f36101a3$var$charAt(string, offset - 1);
    var next = $85e47a21f36101a3$var$charAt(string, offset + 1);
    if ($85e47a21f36101a3$var$exec($85e47a21f36101a3$var$low, match) && !$85e47a21f36101a3$var$exec($85e47a21f36101a3$var$hi, next) || $85e47a21f36101a3$var$exec($85e47a21f36101a3$var$hi, match) && !$85e47a21f36101a3$var$exec($85e47a21f36101a3$var$low, prev)) return "\\u" + $85e47a21f36101a3$var$numberToString($85e47a21f36101a3$var$charCodeAt(match, 0), 16);
    return match;
};
if ($85e47a21f36101a3$var$$stringify) // `JSON.stringify` method
// https://tc39.es/ecma262/#sec-json.stringify
$0365e955907213bd$exports({
    target: "JSON",
    stat: true,
    arity: 3,
    forced: $85e47a21f36101a3$var$WRONG_SYMBOLS_CONVERSION || $85e47a21f36101a3$var$ILL_FORMED_UNICODE
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
        var args = $05068435b6a808dd$exports(arguments);
        var result = $17764d41e6b47061$exports($85e47a21f36101a3$var$WRONG_SYMBOLS_CONVERSION ? $85e47a21f36101a3$var$stringifyWithSymbolsFix : $85e47a21f36101a3$var$$stringify, null, args);
        return $85e47a21f36101a3$var$ILL_FORMED_UNICODE && typeof result == "string" ? $85e47a21f36101a3$var$replace(result, $85e47a21f36101a3$var$tester, $85e47a21f36101a3$var$fixIllFormed) : result;
    }
});







// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $b1b86c2edc9731ef$var$FORCED = !$5c26fe98edd631fb$exports || $4cefcb1c1c1fa750$exports(function() {
    $8d61c7ace25f8e17$export$2d1720544b23b823(1);
});
// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$0365e955907213bd$exports({
    target: "Object",
    stat: true,
    forced: $b1b86c2edc9731ef$var$FORCED
}, {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        var $getOwnPropertySymbols = $8d61c7ace25f8e17$export$2d1720544b23b823;
        return $getOwnPropertySymbols ? $getOwnPropertySymbols($cc6f28a96f61f0ea$exports(it)) : [];
    }
});




// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description
"use strict";










var $96801ef0d1f8039d$var$NativeSymbol = $1a6e68c95df7d4df$exports.Symbol;
var $96801ef0d1f8039d$var$SymbolPrototype = $96801ef0d1f8039d$var$NativeSymbol && $96801ef0d1f8039d$var$NativeSymbol.prototype;
if ($0ab298e69b752e0a$exports && $c1d5f87f1e56c4cc$exports($96801ef0d1f8039d$var$NativeSymbol) && (!("description" in $96801ef0d1f8039d$var$SymbolPrototype) || // Safari 12 bug
$96801ef0d1f8039d$var$NativeSymbol().description !== undefined)) {
    var $96801ef0d1f8039d$var$EmptyStringDescriptionStore = {};
    // wrap Symbol constructor for correct work with undefined description
    var $96801ef0d1f8039d$var$SymbolWrapper = function Symbol() {
        var description = arguments.length < 1 || arguments[0] === undefined ? undefined : $53d734af07b69aa7$exports(arguments[0]);
        var result = $b82c3d945f0459c1$exports($96801ef0d1f8039d$var$SymbolPrototype, this) ? new $96801ef0d1f8039d$var$NativeSymbol(description) : description === undefined ? $96801ef0d1f8039d$var$NativeSymbol() : $96801ef0d1f8039d$var$NativeSymbol(description);
        if (description === "") $96801ef0d1f8039d$var$EmptyStringDescriptionStore[result] = true;
        return result;
    };
    $503095dd4fa66979$exports($96801ef0d1f8039d$var$SymbolWrapper, $96801ef0d1f8039d$var$NativeSymbol);
    $96801ef0d1f8039d$var$SymbolWrapper.prototype = $96801ef0d1f8039d$var$SymbolPrototype;
    $96801ef0d1f8039d$var$SymbolPrototype.constructor = $96801ef0d1f8039d$var$SymbolWrapper;
    var $96801ef0d1f8039d$var$NATIVE_SYMBOL = String($96801ef0d1f8039d$var$NativeSymbol("test")) == "Symbol(test)";
    var $96801ef0d1f8039d$var$thisSymbolValue = $c510c74e58563f95$exports($96801ef0d1f8039d$var$SymbolPrototype.valueOf);
    var $96801ef0d1f8039d$var$symbolDescriptiveString = $c510c74e58563f95$exports($96801ef0d1f8039d$var$SymbolPrototype.toString);
    var $96801ef0d1f8039d$var$regexp = /^Symbol\((.*)\)[^)]+$/;
    var $96801ef0d1f8039d$var$replace = $c510c74e58563f95$exports("".replace);
    var $96801ef0d1f8039d$var$stringSlice = $c510c74e58563f95$exports("".slice);
    $54b1e35819861675$exports($96801ef0d1f8039d$var$SymbolPrototype, "description", {
        configurable: true,
        get: function description() {
            var symbol = $96801ef0d1f8039d$var$thisSymbolValue(this);
            if ($ef59b581f0d1672b$exports($96801ef0d1f8039d$var$EmptyStringDescriptionStore, symbol)) return "";
            var string = $96801ef0d1f8039d$var$symbolDescriptiveString(symbol);
            var desc = $96801ef0d1f8039d$var$NATIVE_SYMBOL ? $96801ef0d1f8039d$var$stringSlice(string, 7, -1) : $96801ef0d1f8039d$var$replace(string, $96801ef0d1f8039d$var$regexp, "$1");
            return desc === "" ? undefined : desc;
        }
    });
    $0365e955907213bd$exports({
        global: true,
        constructor: true,
        forced: true
    }, {
        Symbol: $96801ef0d1f8039d$var$SymbolWrapper
    });
}



// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
$c4d506ca25aae994$exports("asyncIterator");



// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
$c4d506ca25aae994$exports("hasInstance");



// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
$c4d506ca25aae994$exports("isConcatSpreadable");



// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
$c4d506ca25aae994$exports("iterator");



// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
$c4d506ca25aae994$exports("match");



// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
$c4d506ca25aae994$exports("replace");



// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
$c4d506ca25aae994$exports("search");



// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
$c4d506ca25aae994$exports("species");



// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
$c4d506ca25aae994$exports("split");




// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
$c4d506ca25aae994$exports("toPrimitive");
// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
$58588f6619c288ba$exports();





// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
$c4d506ca25aae994$exports("toStringTag");
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
$ec32ac1e3fb4a1a1$exports($ba2da80b68ee643e$exports("Symbol"), "Symbol");



// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
$c4d506ca25aae994$exports("unscopables");


"use strict";






var $e9f6a031658ff48e$exports = {};
var $e9f6a031658ff48e$var$$TypeError = TypeError;
var $e9f6a031658ff48e$var$MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
$e9f6a031658ff48e$exports = function(it) {
    if (it > $e9f6a031658ff48e$var$MAX_SAFE_INTEGER) throw $e9f6a031658ff48e$var$$TypeError("Maximum allowed index exceeded");
    return it;
};




var $4763ece7a791305e$exports = {};



var $4763ece7a791305e$var$SPECIES = $5cfcb69f0877711f$exports("species");
$4763ece7a791305e$exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return $44f41d0bd747502d$exports >= 51 || !$4cefcb1c1c1fa750$exports(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[$4763ece7a791305e$var$SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};




var $2f0566c6a0fe496f$var$IS_CONCAT_SPREADABLE = $5cfcb69f0877711f$exports("isConcatSpreadable");
// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var $2f0566c6a0fe496f$var$IS_CONCAT_SPREADABLE_SUPPORT = $44f41d0bd747502d$exports >= 51 || !$4cefcb1c1c1fa750$exports(function() {
    var array = [];
    array[$2f0566c6a0fe496f$var$IS_CONCAT_SPREADABLE] = false;
    return array.concat()[0] !== array;
});
var $2f0566c6a0fe496f$var$isConcatSpreadable = function(O) {
    if (!$dfdc56bc53f57e69$exports(O)) return false;
    var spreadable = O[$2f0566c6a0fe496f$var$IS_CONCAT_SPREADABLE];
    return spreadable !== undefined ? !!spreadable : $2292f8893faf17d1$exports(O);
};
var $2f0566c6a0fe496f$var$FORCED = !$2f0566c6a0fe496f$var$IS_CONCAT_SPREADABLE_SUPPORT || !$4763ece7a791305e$exports("concat");
// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$0365e955907213bd$exports({
    target: "Array",
    proto: true,
    arity: 1,
    forced: $2f0566c6a0fe496f$var$FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    concat: function concat(arg) {
        var O = $cc6f28a96f61f0ea$exports(this);
        var A = $1ee0284d6e87ccd9$exports(O, 0);
        var n = 0;
        var i, k, length, len, E;
        for(i = -1, length = arguments.length; i < length; i++){
            E = i === -1 ? O : arguments[i];
            if ($2f0566c6a0fe496f$var$isConcatSpreadable(E)) {
                len = $ec53954e5de19898$exports(E);
                $e9f6a031658ff48e$exports(n + len);
                for(k = 0; k < len; k++, n++)if (k in E) $1d4c3fb4ee6719a3$exports(A, n, E[k]);
            } else {
                $e9f6a031658ff48e$exports(n + 1);
                $1d4c3fb4ee6719a3$exports(A, n++, E);
            }
        }
        A.length = n;
        return A;
    }
});



var $347339e081515603$exports = {};
"use strict";



var $33d453bccf934899$exports = {};
"use strict";

var $33d453bccf934899$var$$TypeError = TypeError;
$33d453bccf934899$exports = function(O, P) {
    if (!delete O[P]) throw $33d453bccf934899$var$$TypeError("Cannot delete property " + $f3ce16a57f0d7972$exports(P) + " of " + $f3ce16a57f0d7972$exports(O));
};


var $347339e081515603$var$min = Math.min;
// `Array.prototype.copyWithin` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
// eslint-disable-next-line es/no-array-prototype-copywithin -- safe
$347339e081515603$exports = [].copyWithin || function copyWithin(target /* = 0 */ , start /* = 0, end = @length */ ) {
    var O = $cc6f28a96f61f0ea$exports(this);
    var len = $ec53954e5de19898$exports(O);
    var to = $125a12a61907520f$exports(target, len);
    var from = $125a12a61907520f$exports(start, len);
    var end = arguments.length > 2 ? arguments[2] : undefined;
    var count = $347339e081515603$var$min((end === undefined ? len : $125a12a61907520f$exports(end, len)) - from, len - to);
    var inc = 1;
    if (from < to && to < from + count) {
        inc = -1;
        from += count - 1;
        to += count - 1;
    }
    while(count-- > 0){
        if (from in O) O[to] = O[from];
        else $33d453bccf934899$exports(O, to);
        to += inc;
        from += inc;
    }
    return O;
};


var $e8b19438ffa45e5c$exports = {};



var $e8b19438ffa45e5c$require$defineProperty = $783b6a5a940dee05$export$2d1720544b23b823;
var $e8b19438ffa45e5c$var$UNSCOPABLES = $5cfcb69f0877711f$exports("unscopables");
var $e8b19438ffa45e5c$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($e8b19438ffa45e5c$var$ArrayPrototype[$e8b19438ffa45e5c$var$UNSCOPABLES] == undefined) $e8b19438ffa45e5c$require$defineProperty($e8b19438ffa45e5c$var$ArrayPrototype, $e8b19438ffa45e5c$var$UNSCOPABLES, {
    configurable: true,
    value: $290768129b19866b$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$e8b19438ffa45e5c$exports = function(key) {
    $e8b19438ffa45e5c$var$ArrayPrototype[$e8b19438ffa45e5c$var$UNSCOPABLES][key] = true;
};


// `Array.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
$0365e955907213bd$exports({
    target: "Array",
    proto: true
}, {
    copyWithin: $347339e081515603$exports
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$e8b19438ffa45e5c$exports("copyWithin");


"use strict";


var $1a23f8e9a57ebc2e$require$$every = $0c96980c391de2dd$exports.every;
var $81234675cbe7bec2$exports = {};
"use strict";

$81234675cbe7bec2$exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $4cefcb1c1c1fa750$exports(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};


var $1a23f8e9a57ebc2e$var$STRICT_METHOD = $81234675cbe7bec2$exports("every");
// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
$0365e955907213bd$exports({
    target: "Array",
    proto: true,
    forced: !$1a23f8e9a57ebc2e$var$STRICT_METHOD
}, {
    every: function every(callbackfn /* , thisArg */ ) {
        return $1a23f8e9a57ebc2e$require$$every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});



var $89c606f05ba71d51$exports = {};
"use strict";



// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
$89c606f05ba71d51$exports = function fill(value /* , start = 0, end = @length */ ) {
    var O = $cc6f28a96f61f0ea$exports(this);
    var length = $ec53954e5de19898$exports(O);
    var argumentsLength = arguments.length;
    var index = $125a12a61907520f$exports(argumentsLength > 1 ? arguments[1] : undefined, length);
    var end = argumentsLength > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : $125a12a61907520f$exports(end, length);
    while(endPos > index)O[index++] = value;
    return O;
};



// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$0365e955907213bd$exports({
    target: "Array",
    proto: true
}, {
    fill: $89c606f05ba71d51$exports
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$e8b19438ffa45e5c$exports("fill");


"use strict";


var $a7f1a0b8e8bfa009$require$$filter = $0c96980c391de2dd$exports.filter;

var $a7f1a0b8e8bfa009$var$HAS_SPECIES_SUPPORT = $4763ece7a791305e$exports("filter");
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$0365e955907213bd$exports({
    target: "Array",
    proto: true,
    forced: !$a7f1a0b8e8bfa009$var$HAS_SPECIES_SUPPORT
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $a7f1a0b8e8bfa009$require$$filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});


"use strict";


var $1c7fb913428cb7e2$require$$find = $0c96980c391de2dd$exports.find;

var $1c7fb913428cb7e2$var$FIND = "find";
var $1c7fb913428cb7e2$var$SKIPS_HOLES = true;
// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-find -- testing
if ($1c7fb913428cb7e2$var$FIND in []) Array(1)[$1c7fb913428cb7e2$var$FIND](function() {
    $1c7fb913428cb7e2$var$SKIPS_HOLES = false;
});
// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$0365e955907213bd$exports({
    target: "Array",
    proto: true,
    forced: $1c7fb913428cb7e2$var$SKIPS_HOLES
}, {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $1c7fb913428cb7e2$require$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$e8b19438ffa45e5c$exports($1c7fb913428cb7e2$var$FIND);


"use strict";


var $dd0c4d0b9e9889f4$require$$findIndex = $0c96980c391de2dd$exports.findIndex;

var $dd0c4d0b9e9889f4$var$FIND_INDEX = "findIndex";
var $dd0c4d0b9e9889f4$var$SKIPS_HOLES = true;
// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-findindex -- testing
if ($dd0c4d0b9e9889f4$var$FIND_INDEX in []) Array(1)[$dd0c4d0b9e9889f4$var$FIND_INDEX](function() {
    $dd0c4d0b9e9889f4$var$SKIPS_HOLES = false;
});
// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$0365e955907213bd$exports({
    target: "Array",
    proto: true,
    forced: $dd0c4d0b9e9889f4$var$SKIPS_HOLES
}, {
    findIndex: function findIndex(callbackfn /* , that = undefined */ ) {
        return $dd0c4d0b9e9889f4$require$$findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$e8b19438ffa45e5c$exports($dd0c4d0b9e9889f4$var$FIND_INDEX);


"use strict";

var $929b68d623827c35$exports = {};
"use strict";




// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var $929b68d623827c35$var$flattenIntoArray = function(target, original, source, sourceLen, start, depth, mapper, thisArg) {
    var targetIndex = start;
    var sourceIndex = 0;
    var mapFn = mapper ? $130f24665ebee510$exports(mapper, thisArg) : false;
    var element, elementLen;
    while(sourceIndex < sourceLen){
        if (sourceIndex in source) {
            element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
            if (depth > 0 && $2292f8893faf17d1$exports(element)) {
                elementLen = $ec53954e5de19898$exports(element);
                targetIndex = $929b68d623827c35$var$flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
            } else {
                $e9f6a031658ff48e$exports(targetIndex + 1);
                target[targetIndex] = element;
            }
            targetIndex++;
        }
        sourceIndex++;
    }
    return targetIndex;
};
$929b68d623827c35$exports = $929b68d623827c35$var$flattenIntoArray;






// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$0365e955907213bd$exports({
    target: "Array",
    proto: true
}, {
    flat: function flat() {
        var depthArg = arguments.length ? arguments[0] : undefined;
        var O = $cc6f28a96f61f0ea$exports(this);
        var sourceLen = $ec53954e5de19898$exports(O);
        var A = $1ee0284d6e87ccd9$exports(O, 0);
        A.length = $929b68d623827c35$exports(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : $7167297f49b8d757$exports(depthArg));
        return A;
    }
});


"use strict";






// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$0365e955907213bd$exports({
    target: "Array",
    proto: true
}, {
    flatMap: function flatMap(callbackfn /* , thisArg */ ) {
        var O = $cc6f28a96f61f0ea$exports(this);
        var sourceLen = $ec53954e5de19898$exports(O);
        var A;
        $4a6b57cf563748d0$exports(callbackfn);
        A = $1ee0284d6e87ccd9$exports(O, 0);
        A.length = $929b68d623827c35$exports(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        return A;
    }
});


"use strict";

var $29589bea0602ccd7$exports = {};
"use strict";

var $29589bea0602ccd7$require$$forEach = $0c96980c391de2dd$exports.forEach;

var $29589bea0602ccd7$var$STRICT_METHOD = $81234675cbe7bec2$exports("forEach");
// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
$29589bea0602ccd7$exports = !$29589bea0602ccd7$var$STRICT_METHOD ? function forEach(callbackfn /* , thisArg */ ) {
    return $29589bea0602ccd7$require$$forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
$0365e955907213bd$exports({
    target: "Array",
    proto: true,
    forced: [].forEach != $29589bea0602ccd7$exports
}, {
    forEach: $29589bea0602ccd7$exports
});



var $b254321061bc56b9$exports = {};
"use strict";



var $49970bad13e22e14$exports = {};

var $d5d9b8900d3fd87c$exports = {};



$d5d9b8900d3fd87c$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $830db860a045bbb5$exports(iterator);
    try {
        innerResult = $884b8a4433456f65$exports(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $3b5393d57c251c61$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $830db860a045bbb5$exports(innerResult);
    return value;
};


// call something on iterator step with safe closing on error
$49970bad13e22e14$exports = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn($830db860a045bbb5$exports(value)[0], value[1]) : fn(value);
    } catch (error) {
        $d5d9b8900d3fd87c$exports(iterator, "throw", error);
    }
};


var $3a74e6d6b81c5829$exports = {};

var $7ba582c34e449c4f$exports = {};
$7ba582c34e449c4f$exports = {};


var $3a74e6d6b81c5829$var$ITERATOR = $5cfcb69f0877711f$exports("iterator");
var $3a74e6d6b81c5829$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$3a74e6d6b81c5829$exports = function(it) {
    return it !== undefined && ($7ba582c34e449c4f$exports.Array === it || $3a74e6d6b81c5829$var$ArrayPrototype[$3a74e6d6b81c5829$var$ITERATOR] === it);
};





var $a2edd71662804e98$exports = {};




var $a8ef08465170b254$exports = {};





var $a8ef08465170b254$var$ITERATOR = $5cfcb69f0877711f$exports("iterator");
$a8ef08465170b254$exports = function(it) {
    if (!$784d9540a0abf25d$exports(it)) return $884b8a4433456f65$exports(it, $a8ef08465170b254$var$ITERATOR) || $884b8a4433456f65$exports(it, "@@iterator") || $7ba582c34e449c4f$exports[$79ec051cbbc13a5e$exports(it)];
};


var $a2edd71662804e98$var$$TypeError = TypeError;
$a2edd71662804e98$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $a8ef08465170b254$exports(argument) : usingIterator;
    if ($4a6b57cf563748d0$exports(iteratorMethod)) return $830db860a045bbb5$exports($3b5393d57c251c61$exports(iteratorMethod, argument));
    throw $a2edd71662804e98$var$$TypeError($f3ce16a57f0d7972$exports(argument) + " is not iterable");
};



var $b254321061bc56b9$var$$Array = Array;
// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
$b254321061bc56b9$exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
    var O = $cc6f28a96f61f0ea$exports(arrayLike);
    var IS_CONSTRUCTOR = $f09b11ea7290b6eb$exports(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = $130f24665ebee510$exports(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var iteratorMethod = $a8ef08465170b254$exports(O);
    var index = 0;
    var length, result, step, iterator, next, value;
    // if the target is not iterable or it's an array with the default iterator - use a simple case
    if (iteratorMethod && !(this === $b254321061bc56b9$var$$Array && $3a74e6d6b81c5829$exports(iteratorMethod))) {
        iterator = $a2edd71662804e98$exports(O, iteratorMethod);
        next = iterator.next;
        result = IS_CONSTRUCTOR ? new this() : [];
        for(; !(step = $3b5393d57c251c61$exports(next, iterator)).done; index++){
            value = mapping ? $49970bad13e22e14$exports(iterator, mapfn, [
                step.value,
                index
            ], true) : step.value;
            $1d4c3fb4ee6719a3$exports(result, index, value);
        }
    } else {
        length = $ec53954e5de19898$exports(O);
        result = IS_CONSTRUCTOR ? new this(length) : $b254321061bc56b9$var$$Array(length);
        for(; length > index; index++){
            value = mapping ? mapfn(O[index], index) : O[index];
            $1d4c3fb4ee6719a3$exports(result, index, value);
        }
    }
    result.length = index;
    return result;
};


var $cc6f301ab97f18d4$exports = {};

var $cc6f301ab97f18d4$var$ITERATOR = $5cfcb69f0877711f$exports("iterator");
var $cc6f301ab97f18d4$var$SAFE_CLOSING = false;
try {
    var $cc6f301ab97f18d4$var$called = 0;
    var $cc6f301ab97f18d4$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$cc6f301ab97f18d4$var$called++
            };
        },
        "return": function() {
            $cc6f301ab97f18d4$var$SAFE_CLOSING = true;
        }
    };
    $cc6f301ab97f18d4$var$iteratorWithReturn[$cc6f301ab97f18d4$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($cc6f301ab97f18d4$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$cc6f301ab97f18d4$exports = function(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$cc6f301ab97f18d4$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$cc6f301ab97f18d4$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};


var $c98c2082c70a3894$var$INCORRECT_ITERATION = !$cc6f301ab97f18d4$exports(function(iterable) {
    // eslint-disable-next-line es/no-array-from -- required for testing
    Array.from(iterable);
});
// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$0365e955907213bd$exports({
    target: "Array",
    stat: true,
    forced: $c98c2082c70a3894$var$INCORRECT_ITERATION
}, {
    from: $b254321061bc56b9$exports
});


"use strict";


var $4b50ce9a1665a023$require$$includes = $3b631fee8f1ba65e$exports.includes;


// FF99+ bug
var $4b50ce9a1665a023$var$BROKEN_ON_SPARSE = $4cefcb1c1c1fa750$exports(function() {
    // eslint-disable-next-line es/no-array-prototype-includes -- detection
    return !Array(1).includes();
});
// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$0365e955907213bd$exports({
    target: "Array",
    proto: true,
    forced: $4b50ce9a1665a023$var$BROKEN_ON_SPARSE
}, {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $4b50ce9a1665a023$require$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$e8b19438ffa45e5c$exports("includes");


"use strict";



var $5f646ef961025f7c$require$$indexOf = $3b631fee8f1ba65e$exports.indexOf;

var $5f646ef961025f7c$var$nativeIndexOf = $31a67080629c484a$exports([].indexOf);
var $5f646ef961025f7c$var$NEGATIVE_ZERO = !!$5f646ef961025f7c$var$nativeIndexOf && 1 / $5f646ef961025f7c$var$nativeIndexOf([
    1
], 1, -0) < 0;
var $5f646ef961025f7c$var$FORCED = $5f646ef961025f7c$var$NEGATIVE_ZERO || !$81234675cbe7bec2$exports("indexOf");
// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$0365e955907213bd$exports({
    target: "Array",
    proto: true,
    forced: $5f646ef961025f7c$var$FORCED
}, {
    indexOf: function indexOf(searchElement /* , fromIndex = 0 */ ) {
        var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
        return $5f646ef961025f7c$var$NEGATIVE_ZERO ? $5f646ef961025f7c$var$nativeIndexOf(this, searchElement, fromIndex) || 0 : $5f646ef961025f7c$require$$indexOf(this, searchElement, fromIndex);
    }
});




// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
$0365e955907213bd$exports({
    target: "Array",
    stat: true
}, {
    isArray: $2292f8893faf17d1$exports
});


var $5b481a5e03898dba$exports = {};
"use strict";





var $5b481a5e03898dba$require$defineProperty = $783b6a5a940dee05$export$2d1720544b23b823;
var $d9091fe3c4cc4bc8$exports = {};
"use strict";





var $7d1f368d6c8845ca$exports = {};
"use strict";
var $5f0507b8abbc6c08$exports = {};
"use strict";




var $a30ba929b298478d$exports = {};




var $4636f67dfb0688c7$exports = {};

$4636f67dfb0688c7$exports = !$4cefcb1c1c1fa750$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $a30ba929b298478d$var$IE_PROTO = $2da5e4152f22a70d$exports("IE_PROTO");
var $a30ba929b298478d$var$$Object = Object;
var $a30ba929b298478d$var$ObjectPrototype = $a30ba929b298478d$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$a30ba929b298478d$exports = $4636f67dfb0688c7$exports ? $a30ba929b298478d$var$$Object.getPrototypeOf : function(O) {
    var object = $cc6f28a96f61f0ea$exports(O);
    if ($ef59b581f0d1672b$exports(object, $a30ba929b298478d$var$IE_PROTO)) return object[$a30ba929b298478d$var$IE_PROTO];
    var constructor = object.constructor;
    if ($c1d5f87f1e56c4cc$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $a30ba929b298478d$var$$Object ? $a30ba929b298478d$var$ObjectPrototype : null;
};





var $5f0507b8abbc6c08$var$ITERATOR = $5cfcb69f0877711f$exports("iterator");
var $5f0507b8abbc6c08$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $5f0507b8abbc6c08$var$IteratorPrototype, $5f0507b8abbc6c08$var$PrototypeOfArrayIteratorPrototype, $5f0507b8abbc6c08$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $5f0507b8abbc6c08$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $5f0507b8abbc6c08$var$arrayIterator)) $5f0507b8abbc6c08$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $5f0507b8abbc6c08$var$PrototypeOfArrayIteratorPrototype = $a30ba929b298478d$exports($a30ba929b298478d$exports($5f0507b8abbc6c08$var$arrayIterator));
        if ($5f0507b8abbc6c08$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $5f0507b8abbc6c08$var$IteratorPrototype = $5f0507b8abbc6c08$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $5f0507b8abbc6c08$var$NEW_ITERATOR_PROTOTYPE = !$dfdc56bc53f57e69$exports($5f0507b8abbc6c08$var$IteratorPrototype) || $4cefcb1c1c1fa750$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $5f0507b8abbc6c08$var$IteratorPrototype[$5f0507b8abbc6c08$var$ITERATOR].call(test) !== test;
});
if ($5f0507b8abbc6c08$var$NEW_ITERATOR_PROTOTYPE) $5f0507b8abbc6c08$var$IteratorPrototype = {};
else if ($fef1920ae5260386$exports) $5f0507b8abbc6c08$var$IteratorPrototype = $290768129b19866b$exports($5f0507b8abbc6c08$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$c1d5f87f1e56c4cc$exports($5f0507b8abbc6c08$var$IteratorPrototype[$5f0507b8abbc6c08$var$ITERATOR])) $eeb1abced7a4b5b5$exports($5f0507b8abbc6c08$var$IteratorPrototype, $5f0507b8abbc6c08$var$ITERATOR, function() {
    return this;
});
$5f0507b8abbc6c08$exports = {
    IteratorPrototype: $5f0507b8abbc6c08$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $5f0507b8abbc6c08$var$BUGGY_SAFARI_ITERATORS
};


var $7d1f368d6c8845ca$require$IteratorPrototype = $5f0507b8abbc6c08$exports.IteratorPrototype;




var $7d1f368d6c8845ca$var$returnThis = function() {
    return this;
};
$7d1f368d6c8845ca$exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $290768129b19866b$exports($7d1f368d6c8845ca$require$IteratorPrototype, {
        next: $d6bcb34392440d40$exports(+!ENUMERABLE_NEXT, next)
    });
    $ec32ac1e3fb4a1a1$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $7ba582c34e449c4f$exports[TO_STRING_TAG] = $7d1f368d6c8845ca$var$returnThis;
    return IteratorConstructor;
};



var $a922355a1bcefb04$exports = {};
/* eslint-disable no-proto -- safe */ var $4f780b8a894d7e25$exports = {};


$4f780b8a894d7e25$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $c510c74e58563f95$exports($4a6b57cf563748d0$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};



var $a6e7af22227d61ef$exports = {};

var $a6e7af22227d61ef$var$$String = String;
var $a6e7af22227d61ef$var$$TypeError = TypeError;
$a6e7af22227d61ef$exports = function(argument) {
    if (typeof argument == "object" || $c1d5f87f1e56c4cc$exports(argument)) return argument;
    throw $a6e7af22227d61ef$var$$TypeError("Can't set " + $a6e7af22227d61ef$var$$String(argument) + " as a prototype");
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$a922355a1bcefb04$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $4f780b8a894d7e25$exports(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $830db860a045bbb5$exports(O);
        $a6e7af22227d61ef$exports(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);








var $d9091fe3c4cc4bc8$var$PROPER_FUNCTION_NAME = $93a445032aaa8001$exports.PROPER;
var $d9091fe3c4cc4bc8$var$CONFIGURABLE_FUNCTION_NAME = $93a445032aaa8001$exports.CONFIGURABLE;
var $d9091fe3c4cc4bc8$var$IteratorPrototype = $5f0507b8abbc6c08$exports.IteratorPrototype;
var $d9091fe3c4cc4bc8$var$BUGGY_SAFARI_ITERATORS = $5f0507b8abbc6c08$exports.BUGGY_SAFARI_ITERATORS;
var $d9091fe3c4cc4bc8$var$ITERATOR = $5cfcb69f0877711f$exports("iterator");
var $d9091fe3c4cc4bc8$var$KEYS = "keys";
var $d9091fe3c4cc4bc8$var$VALUES = "values";
var $d9091fe3c4cc4bc8$var$ENTRIES = "entries";
var $d9091fe3c4cc4bc8$var$returnThis = function() {
    return this;
};
$d9091fe3c4cc4bc8$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $7d1f368d6c8845ca$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$d9091fe3c4cc4bc8$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $d9091fe3c4cc4bc8$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $d9091fe3c4cc4bc8$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $d9091fe3c4cc4bc8$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$d9091fe3c4cc4bc8$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$d9091fe3c4cc4bc8$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $a30ba929b298478d$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$fef1920ae5260386$exports && $a30ba929b298478d$exports(CurrentIteratorPrototype) !== $d9091fe3c4cc4bc8$var$IteratorPrototype) {
                if ($a922355a1bcefb04$exports) $a922355a1bcefb04$exports(CurrentIteratorPrototype, $d9091fe3c4cc4bc8$var$IteratorPrototype);
                else if (!$c1d5f87f1e56c4cc$exports(CurrentIteratorPrototype[$d9091fe3c4cc4bc8$var$ITERATOR])) $eeb1abced7a4b5b5$exports(CurrentIteratorPrototype, $d9091fe3c4cc4bc8$var$ITERATOR, $d9091fe3c4cc4bc8$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $ec32ac1e3fb4a1a1$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($fef1920ae5260386$exports) $7ba582c34e449c4f$exports[TO_STRING_TAG] = $d9091fe3c4cc4bc8$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($d9091fe3c4cc4bc8$var$PROPER_FUNCTION_NAME && DEFAULT == $d9091fe3c4cc4bc8$var$VALUES && nativeIterator && nativeIterator.name !== $d9091fe3c4cc4bc8$var$VALUES) {
        if (!$fef1920ae5260386$exports && $d9091fe3c4cc4bc8$var$CONFIGURABLE_FUNCTION_NAME) $4716626f874fe5a3$exports(IterablePrototype, "name", $d9091fe3c4cc4bc8$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $3b5393d57c251c61$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($d9091fe3c4cc4bc8$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($d9091fe3c4cc4bc8$var$KEYS),
            entries: getIterationMethod($d9091fe3c4cc4bc8$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($d9091fe3c4cc4bc8$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $eeb1abced7a4b5b5$exports(IterablePrototype, KEY, methods[KEY]);
        } else $0365e955907213bd$exports({
            target: NAME,
            proto: true,
            forced: $d9091fe3c4cc4bc8$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$fef1920ae5260386$exports || FORCED) && IterablePrototype[$d9091fe3c4cc4bc8$var$ITERATOR] !== defaultIterator) $eeb1abced7a4b5b5$exports(IterablePrototype, $d9091fe3c4cc4bc8$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $7ba582c34e449c4f$exports[NAME] = defaultIterator;
    return methods;
};


var $25360ca3df62dca5$exports = {};
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
$25360ca3df62dca5$exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};




var $5b481a5e03898dba$var$ARRAY_ITERATOR = "Array Iterator";
var $5b481a5e03898dba$var$setInternalState = $dbe54846b72f85d1$exports.set;
var $5b481a5e03898dba$var$getInternalState = $dbe54846b72f85d1$exports.getterFor($5b481a5e03898dba$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$5b481a5e03898dba$exports = $d9091fe3c4cc4bc8$exports(Array, "Array", function(iterated, kind) {
    $5b481a5e03898dba$var$setInternalState(this, {
        type: $5b481a5e03898dba$var$ARRAY_ITERATOR,
        target: $b497231b90dfbcaa$exports(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $5b481a5e03898dba$var$getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return $25360ca3df62dca5$exports(undefined, true);
    }
    if (kind == "keys") return $25360ca3df62dca5$exports(index, false);
    if (kind == "values") return $25360ca3df62dca5$exports(target[index], false);
    return $25360ca3df62dca5$exports([
        index,
        target[index]
    ], false);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $5b481a5e03898dba$var$values = $7ba582c34e449c4f$exports.Arguments = $7ba582c34e449c4f$exports.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$e8b19438ffa45e5c$exports("keys");
$e8b19438ffa45e5c$exports("values");
$e8b19438ffa45e5c$exports("entries");
// V8 ~ Chrome 45- bug
if (!$fef1920ae5260386$exports && $0ab298e69b752e0a$exports && $5b481a5e03898dba$var$values.name !== "values") try {
    $5b481a5e03898dba$require$defineProperty($5b481a5e03898dba$var$values, "name", {
        value: "values"
    });
} catch (error) {}


"use strict";





var $5c9a629ec4306cd8$var$nativeJoin = $c510c74e58563f95$exports([].join);
var $5c9a629ec4306cd8$var$ES3_STRINGS = $77acd9fe92ee403a$exports != Object;
var $5c9a629ec4306cd8$var$FORCED = $5c9a629ec4306cd8$var$ES3_STRINGS || !$81234675cbe7bec2$exports("join", ",");
// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$0365e955907213bd$exports({
    target: "Array",
    proto: true,
    forced: $5c9a629ec4306cd8$var$FORCED
}, {
    join: function join(separator) {
        return $5c9a629ec4306cd8$var$nativeJoin($b497231b90dfbcaa$exports(this), separator === undefined ? "," : separator);
    }
});



var $de6f1142e53db5c4$exports = {};
"use strict";





var $de6f1142e53db5c4$var$min = Math.min;
var $de6f1142e53db5c4$var$$lastIndexOf = [].lastIndexOf;
var $de6f1142e53db5c4$var$NEGATIVE_ZERO = !!$de6f1142e53db5c4$var$$lastIndexOf && 1 / [
    1
].lastIndexOf(1, -0) < 0;
var $de6f1142e53db5c4$var$STRICT_METHOD = $81234675cbe7bec2$exports("lastIndexOf");
var $de6f1142e53db5c4$var$FORCED = $de6f1142e53db5c4$var$NEGATIVE_ZERO || !$de6f1142e53db5c4$var$STRICT_METHOD;
// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
$de6f1142e53db5c4$exports = $de6f1142e53db5c4$var$FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */ ) {
    // convert -0 to +0
    if ($de6f1142e53db5c4$var$NEGATIVE_ZERO) return $17764d41e6b47061$exports($de6f1142e53db5c4$var$$lastIndexOf, this, arguments) || 0;
    var O = $b497231b90dfbcaa$exports(this);
    var length = $ec53954e5de19898$exports(O);
    var index = length - 1;
    if (arguments.length > 1) index = $de6f1142e53db5c4$var$min(index, $7167297f49b8d757$exports(arguments[1]));
    if (index < 0) index = length + index;
    for(; index >= 0; index--)if (index in O && O[index] === searchElement) return index || 0;
    return -1;
} : $de6f1142e53db5c4$var$$lastIndexOf;


// `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing
$0365e955907213bd$exports({
    target: "Array",
    proto: true,
    forced: $de6f1142e53db5c4$exports !== [].lastIndexOf
}, {
    lastIndexOf: $de6f1142e53db5c4$exports
});


"use strict";


var $a8a05d876fd038cd$require$$map = $0c96980c391de2dd$exports.map;

var $a8a05d876fd038cd$var$HAS_SPECIES_SUPPORT = $4763ece7a791305e$exports("map");
// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$0365e955907213bd$exports({
    target: "Array",
    proto: true,
    forced: !$a8a05d876fd038cd$var$HAS_SPECIES_SUPPORT
}, {
    map: function map(callbackfn /* , thisArg */ ) {
        return $a8a05d876fd038cd$require$$map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});


"use strict";




var $307a1696263e2d96$var$$Array = Array;
var $307a1696263e2d96$var$ISNT_GENERIC = $4cefcb1c1c1fa750$exports(function() {
    function F() {}
    // eslint-disable-next-line es/no-array-of -- safe
    return !($307a1696263e2d96$var$$Array.of.call(F) instanceof F);
});
// `Array.of` method
// https://tc39.es/ecma262/#sec-array.of
// WebKit Array.of isn't generic
$0365e955907213bd$exports({
    target: "Array",
    stat: true,
    forced: $307a1696263e2d96$var$ISNT_GENERIC
}, {
    of: function of() {
        var index = 0;
        var argumentsLength = arguments.length;
        var result = new ($f09b11ea7290b6eb$exports(this) ? this : $307a1696263e2d96$var$$Array)(argumentsLength);
        while(argumentsLength > index)$1d4c3fb4ee6719a3$exports(result, index, arguments[index++]);
        result.length = argumentsLength;
        return result;
    }
});


"use strict";

var $0a70de46188cd26d$exports = {};




var $0a70de46188cd26d$var$$TypeError = TypeError;
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $0a70de46188cd26d$var$createMethod = function(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        $4a6b57cf563748d0$exports(callbackfn);
        var O = $cc6f28a96f61f0ea$exports(that);
        var self = $77acd9fe92ee403a$exports(O);
        var length = $ec53954e5de19898$exports(O);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self) {
                memo = self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw $0a70de46188cd26d$var$$TypeError("Reduce of empty array with no initial value");
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
        return memo;
    };
};
$0a70de46188cd26d$exports = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $0a70de46188cd26d$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $0a70de46188cd26d$var$createMethod(true)
};


var $72a98c039ed8d3a7$require$$reduce = $0a70de46188cd26d$exports.left;


var $9eb47e38a97c42de$exports = {};

var $e67mm = parcelRequire("e67mm");

$9eb47e38a97c42de$exports = typeof $e67mm != "undefined" && $ee4d29ebca1023f3$exports($e67mm) == "process";


// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $72a98c039ed8d3a7$var$CHROME_BUG = !$9eb47e38a97c42de$exports && $44f41d0bd747502d$exports > 79 && $44f41d0bd747502d$exports < 83;
var $72a98c039ed8d3a7$var$FORCED = $72a98c039ed8d3a7$var$CHROME_BUG || !$81234675cbe7bec2$exports("reduce");
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$0365e955907213bd$exports({
    target: "Array",
    proto: true,
    forced: $72a98c039ed8d3a7$var$FORCED
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $72a98c039ed8d3a7$require$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});


"use strict";


var $946bbdb2f2cb3376$require$$reduceRight = $0a70de46188cd26d$exports.right;



// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $946bbdb2f2cb3376$var$CHROME_BUG = !$9eb47e38a97c42de$exports && $44f41d0bd747502d$exports > 79 && $44f41d0bd747502d$exports < 83;
var $946bbdb2f2cb3376$var$FORCED = $946bbdb2f2cb3376$var$CHROME_BUG || !$81234675cbe7bec2$exports("reduceRight");
// `Array.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-array.prototype.reduceright
$0365e955907213bd$exports({
    target: "Array",
    proto: true,
    forced: $946bbdb2f2cb3376$var$FORCED
}, {
    reduceRight: function reduceRight(callbackfn /* , initialValue */ ) {
        return $946bbdb2f2cb3376$require$$reduceRight(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
    }
});


"use strict";



var $26d66a9312242ff8$var$nativeReverse = $c510c74e58563f95$exports([].reverse);
var $26d66a9312242ff8$var$test = [
    1,
    2
];
// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$0365e955907213bd$exports({
    target: "Array",
    proto: true,
    forced: String($26d66a9312242ff8$var$test) === String($26d66a9312242ff8$var$test.reverse())
}, {
    reverse: function reverse() {
        // eslint-disable-next-line no-self-assign -- dirty hack
        if ($2292f8893faf17d1$exports(this)) this.length = this.length;
        return $26d66a9312242ff8$var$nativeReverse(this);
    }
});


"use strict";











var $587e1828e61d919c$var$HAS_SPECIES_SUPPORT = $4763ece7a791305e$exports("slice");
var $587e1828e61d919c$var$SPECIES = $5cfcb69f0877711f$exports("species");
var $587e1828e61d919c$var$$Array = Array;
var $587e1828e61d919c$var$max = Math.max;
// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$0365e955907213bd$exports({
    target: "Array",
    proto: true,
    forced: !$587e1828e61d919c$var$HAS_SPECIES_SUPPORT
}, {
    slice: function slice(start, end) {
        var O = $b497231b90dfbcaa$exports(this);
        var length = $ec53954e5de19898$exports(O);
        var k = $125a12a61907520f$exports(start, length);
        var fin = $125a12a61907520f$exports(end === undefined ? length : end, length);
        // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
        var Constructor, result, n;
        if ($2292f8893faf17d1$exports(O)) {
            Constructor = O.constructor;
            // cross-realm fallback
            if ($f09b11ea7290b6eb$exports(Constructor) && (Constructor === $587e1828e61d919c$var$$Array || $2292f8893faf17d1$exports(Constructor.prototype))) Constructor = undefined;
            else if ($dfdc56bc53f57e69$exports(Constructor)) {
                Constructor = Constructor[$587e1828e61d919c$var$SPECIES];
                if (Constructor === null) Constructor = undefined;
            }
            if (Constructor === $587e1828e61d919c$var$$Array || Constructor === undefined) return $05068435b6a808dd$exports(O, k, fin);
        }
        result = new (Constructor === undefined ? $587e1828e61d919c$var$$Array : Constructor)($587e1828e61d919c$var$max(fin - k, 0));
        for(n = 0; k < fin; k++, n++)if (k in O) $1d4c3fb4ee6719a3$exports(result, n, O[k]);
        result.length = n;
        return result;
    }
});


"use strict";


var $5ed08152b0dd0b20$require$$some = $0c96980c391de2dd$exports.some;

var $5ed08152b0dd0b20$var$STRICT_METHOD = $81234675cbe7bec2$exports("some");
// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
$0365e955907213bd$exports({
    target: "Array",
    proto: true,
    forced: !$5ed08152b0dd0b20$var$STRICT_METHOD
}, {
    some: function some(callbackfn /* , thisArg */ ) {
        return $5ed08152b0dd0b20$require$$some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});


"use strict";








var $1867dfc0c25c2052$exports = {};

var $1867dfc0c25c2052$var$floor = Math.floor;
var $1867dfc0c25c2052$var$mergeSort = function(array, comparefn) {
    var length = array.length;
    var middle = $1867dfc0c25c2052$var$floor(length / 2);
    return length < 8 ? $1867dfc0c25c2052$var$insertionSort(array, comparefn) : $1867dfc0c25c2052$var$merge(array, $1867dfc0c25c2052$var$mergeSort($df6d3dbc942f438e$exports(array, 0, middle), comparefn), $1867dfc0c25c2052$var$mergeSort($df6d3dbc942f438e$exports(array, middle), comparefn), comparefn);
};
var $1867dfc0c25c2052$var$insertionSort = function(array, comparefn) {
    var length = array.length;
    var i = 1;
    var element, j;
    while(i < length){
        j = i;
        element = array[i];
        while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
        if (j !== i++) array[j] = element;
    }
    return array;
};
var $1867dfc0c25c2052$var$merge = function(array, left, right, comparefn) {
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;
    while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    return array;
};
$1867dfc0c25c2052$exports = $1867dfc0c25c2052$var$mergeSort;



var $f42060667397ebc3$exports = {};

var $f42060667397ebc3$var$firefox = $59d28ac8b8f97183$exports.match(/firefox\/(\d+)/i);
$f42060667397ebc3$exports = !!$f42060667397ebc3$var$firefox && +$f42060667397ebc3$var$firefox[1];


var $1449583c7adb3089$exports = {};

$1449583c7adb3089$exports = /MSIE|Trident/.test($59d28ac8b8f97183$exports);



var $b8c60ffaf51233fe$exports = {};

var $b8c60ffaf51233fe$var$webkit = $59d28ac8b8f97183$exports.match(/AppleWebKit\/(\d+)\./);
$b8c60ffaf51233fe$exports = !!$b8c60ffaf51233fe$var$webkit && +$b8c60ffaf51233fe$var$webkit[1];


var $341ad4a5a36eafb7$var$test = [];
var $341ad4a5a36eafb7$var$nativeSort = $c510c74e58563f95$exports($341ad4a5a36eafb7$var$test.sort);
var $341ad4a5a36eafb7$var$push = $c510c74e58563f95$exports($341ad4a5a36eafb7$var$test.push);
// IE8-
var $341ad4a5a36eafb7$var$FAILS_ON_UNDEFINED = $4cefcb1c1c1fa750$exports(function() {
    $341ad4a5a36eafb7$var$test.sort(undefined);
});
// V8 bug
var $341ad4a5a36eafb7$var$FAILS_ON_NULL = $4cefcb1c1c1fa750$exports(function() {
    $341ad4a5a36eafb7$var$test.sort(null);
});
// Old WebKit
var $341ad4a5a36eafb7$var$STRICT_METHOD = $81234675cbe7bec2$exports("sort");
var $341ad4a5a36eafb7$var$STABLE_SORT = !$4cefcb1c1c1fa750$exports(function() {
    // feature detection can be too slow, so check engines versions
    if ($44f41d0bd747502d$exports) return $44f41d0bd747502d$exports < 70;
    if ($f42060667397ebc3$exports && $f42060667397ebc3$exports > 3) return;
    if ($1449583c7adb3089$exports) return true;
    if ($b8c60ffaf51233fe$exports) return $b8c60ffaf51233fe$exports < 603;
    var result = "";
    var code, chr, value, index;
    // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
    for(code = 65; code < 76; code++){
        chr = String.fromCharCode(code);
        switch(code){
            case 66:
            case 69:
            case 70:
            case 72:
                value = 3;
                break;
            case 68:
            case 71:
                value = 4;
                break;
            default:
                value = 2;
        }
        for(index = 0; index < 47; index++)$341ad4a5a36eafb7$var$test.push({
            k: chr + index,
            v: value
        });
    }
    $341ad4a5a36eafb7$var$test.sort(function(a, b) {
        return b.v - a.v;
    });
    for(index = 0; index < $341ad4a5a36eafb7$var$test.length; index++){
        chr = $341ad4a5a36eafb7$var$test[index].k.charAt(0);
        if (result.charAt(result.length - 1) !== chr) result += chr;
    }
    return result !== "DGBEFHACIJK";
});
var $341ad4a5a36eafb7$var$FORCED = $341ad4a5a36eafb7$var$FAILS_ON_UNDEFINED || !$341ad4a5a36eafb7$var$FAILS_ON_NULL || !$341ad4a5a36eafb7$var$STRICT_METHOD || !$341ad4a5a36eafb7$var$STABLE_SORT;
var $341ad4a5a36eafb7$var$getSortCompare = function(comparefn) {
    return function(x, y) {
        if (y === undefined) return -1;
        if (x === undefined) return 1;
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        return $53d734af07b69aa7$exports(x) > $53d734af07b69aa7$exports(y) ? 1 : -1;
    };
};
// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$0365e955907213bd$exports({
    target: "Array",
    proto: true,
    forced: $341ad4a5a36eafb7$var$FORCED
}, {
    sort: function sort(comparefn) {
        if (comparefn !== undefined) $4a6b57cf563748d0$exports(comparefn);
        var array = $cc6f28a96f61f0ea$exports(this);
        if ($341ad4a5a36eafb7$var$STABLE_SORT) return comparefn === undefined ? $341ad4a5a36eafb7$var$nativeSort(array) : $341ad4a5a36eafb7$var$nativeSort(array, comparefn);
        var items = [];
        var arrayLength = $ec53954e5de19898$exports(array);
        var itemsLength, index;
        for(index = 0; index < arrayLength; index++)if (index in array) $341ad4a5a36eafb7$var$push(items, array[index]);
        $1867dfc0c25c2052$exports(items, $341ad4a5a36eafb7$var$getSortCompare(comparefn));
        itemsLength = $ec53954e5de19898$exports(items);
        index = 0;
        while(index < itemsLength)array[index] = items[index++];
        while(index < arrayLength)$33d453bccf934899$exports(array, index++);
        return array;
    }
});


var $60a2ce15ea97c905$exports = {};
"use strict";




var $60a2ce15ea97c905$var$SPECIES = $5cfcb69f0877711f$exports("species");
$60a2ce15ea97c905$exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $ba2da80b68ee643e$exports(CONSTRUCTOR_NAME);
    if ($0ab298e69b752e0a$exports && Constructor && !Constructor[$60a2ce15ea97c905$var$SPECIES]) $54b1e35819861675$exports(Constructor, $60a2ce15ea97c905$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};


// `Array[@@species]` getter
// https://tc39.es/ecma262/#sec-get-array-@@species
$60a2ce15ea97c905$exports("Array");


"use strict";





var $4b30f91e26acd0da$exports = {};
"use strict";


var $4b30f91e26acd0da$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $4b30f91e26acd0da$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Safari < 13 does not throw an error in this case
var $4b30f91e26acd0da$var$SILENT_ON_NON_WRITABLE_LENGTH_SET = $0ab298e69b752e0a$exports && !function() {
    // makes no sense without proper strict mode support
    if (this !== undefined) return true;
    try {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty([], "length", {
            writable: false
        }).length = 1;
    } catch (error) {
        return error instanceof TypeError;
    }
}();
$4b30f91e26acd0da$exports = $4b30f91e26acd0da$var$SILENT_ON_NON_WRITABLE_LENGTH_SET ? function(O, length) {
    if ($2292f8893faf17d1$exports(O) && !$4b30f91e26acd0da$var$getOwnPropertyDescriptor(O, "length").writable) throw $4b30f91e26acd0da$var$$TypeError("Cannot set read only .length");
    return O.length = length;
} : function(O, length) {
    return O.length = length;
};







var $904b8779a3e2ae79$var$HAS_SPECIES_SUPPORT = $4763ece7a791305e$exports("splice");
var $904b8779a3e2ae79$var$max = Math.max;
var $904b8779a3e2ae79$var$min = Math.min;
// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$0365e955907213bd$exports({
    target: "Array",
    proto: true,
    forced: !$904b8779a3e2ae79$var$HAS_SPECIES_SUPPORT
}, {
    splice: function splice(start, deleteCount /* , ...items */ ) {
        var O = $cc6f28a96f61f0ea$exports(this);
        var len = $ec53954e5de19898$exports(O);
        var actualStart = $125a12a61907520f$exports(start, len);
        var argumentsLength = arguments.length;
        var insertCount, actualDeleteCount, A, k, from, to;
        if (argumentsLength === 0) insertCount = actualDeleteCount = 0;
        else if (argumentsLength === 1) {
            insertCount = 0;
            actualDeleteCount = len - actualStart;
        } else {
            insertCount = argumentsLength - 2;
            actualDeleteCount = $904b8779a3e2ae79$var$min($904b8779a3e2ae79$var$max($7167297f49b8d757$exports(deleteCount), 0), len - actualStart);
        }
        $e9f6a031658ff48e$exports(len + insertCount - actualDeleteCount);
        A = $1ee0284d6e87ccd9$exports(O, actualDeleteCount);
        for(k = 0; k < actualDeleteCount; k++){
            from = actualStart + k;
            if (from in O) $1d4c3fb4ee6719a3$exports(A, k, O[from]);
        }
        A.length = actualDeleteCount;
        if (insertCount < actualDeleteCount) {
            for(k = actualStart; k < len - actualDeleteCount; k++){
                from = k + actualDeleteCount;
                to = k + insertCount;
                if (from in O) O[to] = O[from];
                else $33d453bccf934899$exports(O, to);
            }
            for(k = len; k > len - actualDeleteCount + insertCount; k--)$33d453bccf934899$exports(O, k - 1);
        } else if (insertCount > actualDeleteCount) for(k = len - actualDeleteCount; k > actualStart; k--){
            from = k + actualDeleteCount - 1;
            to = k + insertCount - 1;
            if (from in O) O[to] = O[from];
            else $33d453bccf934899$exports(O, to);
        }
        for(k = 0; k < insertCount; k++)O[k + actualStart] = arguments[k + 2];
        $4b30f91e26acd0da$exports(O, len - actualDeleteCount + insertCount);
        return A;
    }
});


// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$e8b19438ffa45e5c$exports("flat");


// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$e8b19438ffa45e5c$exports("flatMap");


"use strict";


var $007b66ce508dac9e$exports = {};
"use strict";



var $ef544a74b30cdd0b$exports = {};
// eslint-disable-next-line es/no-typed-arrays -- safe
$ef544a74b30cdd0b$exports = typeof ArrayBuffer != "undefined" && typeof DataView != "undefined";





var $be8b41c0f3f6adf6$exports = {};

$be8b41c0f3f6adf6$exports = function(target, src, options) {
    for(var key in src)$eeb1abced7a4b5b5$exports(target, key, src[key], options);
    return target;
};



var $a5a0f9cce104c4f5$exports = {};

var $a5a0f9cce104c4f5$var$$TypeError = TypeError;
$a5a0f9cce104c4f5$exports = function(it, Prototype) {
    if ($b82c3d945f0459c1$exports(Prototype, it)) return it;
    throw $a5a0f9cce104c4f5$var$$TypeError("Incorrect invocation");
};




var $44e5d8e78700c624$exports = {};


var $44e5d8e78700c624$var$$RangeError = RangeError;
// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
$44e5d8e78700c624$exports = function(it) {
    if (it === undefined) return 0;
    var number = $7167297f49b8d757$exports(it);
    var length = $c2922a7ee9a4ab10$exports(number);
    if (number !== length) throw $44e5d8e78700c624$var$$RangeError("Wrong length or index");
    return length;
};


var $ebce8564faba8af1$exports = {};
// IEEE754 conversions based on https://github.com/feross/ieee754
var $ebce8564faba8af1$var$$Array = Array;
var $ebce8564faba8af1$var$abs = Math.abs;
var $ebce8564faba8af1$var$pow = Math.pow;
var $ebce8564faba8af1$var$floor = Math.floor;
var $ebce8564faba8af1$var$log = Math.log;
var $ebce8564faba8af1$var$LN2 = Math.LN2;
var $ebce8564faba8af1$var$pack = function(number, mantissaLength, bytes) {
    var buffer = $ebce8564faba8af1$var$$Array(bytes);
    var exponentLength = bytes * 8 - mantissaLength - 1;
    var eMax = (1 << exponentLength) - 1;
    var eBias = eMax >> 1;
    var rt = mantissaLength === 23 ? $ebce8564faba8af1$var$pow(2, -24) - $ebce8564faba8af1$var$pow(2, -77) : 0;
    var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
    var index = 0;
    var exponent, mantissa, c;
    number = $ebce8564faba8af1$var$abs(number);
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number != number || number === Infinity) {
        // eslint-disable-next-line no-self-compare -- NaN check
        mantissa = number != number ? 1 : 0;
        exponent = eMax;
    } else {
        exponent = $ebce8564faba8af1$var$floor($ebce8564faba8af1$var$log(number) / $ebce8564faba8af1$var$LN2);
        c = $ebce8564faba8af1$var$pow(2, -exponent);
        if (number * c < 1) {
            exponent--;
            c *= 2;
        }
        if (exponent + eBias >= 1) number += rt / c;
        else number += rt * $ebce8564faba8af1$var$pow(2, 1 - eBias);
        if (number * c >= 2) {
            exponent++;
            c /= 2;
        }
        if (exponent + eBias >= eMax) {
            mantissa = 0;
            exponent = eMax;
        } else if (exponent + eBias >= 1) {
            mantissa = (number * c - 1) * $ebce8564faba8af1$var$pow(2, mantissaLength);
            exponent = exponent + eBias;
        } else {
            mantissa = number * $ebce8564faba8af1$var$pow(2, eBias - 1) * $ebce8564faba8af1$var$pow(2, mantissaLength);
            exponent = 0;
        }
    }
    while(mantissaLength >= 8){
        buffer[index++] = mantissa & 255;
        mantissa /= 256;
        mantissaLength -= 8;
    }
    exponent = exponent << mantissaLength | mantissa;
    exponentLength += mantissaLength;
    while(exponentLength > 0){
        buffer[index++] = exponent & 255;
        exponent /= 256;
        exponentLength -= 8;
    }
    buffer[--index] |= sign * 128;
    return buffer;
};
var $ebce8564faba8af1$var$unpack = function(buffer, mantissaLength) {
    var bytes = buffer.length;
    var exponentLength = bytes * 8 - mantissaLength - 1;
    var eMax = (1 << exponentLength) - 1;
    var eBias = eMax >> 1;
    var nBits = exponentLength - 7;
    var index = bytes - 1;
    var sign = buffer[index--];
    var exponent = sign & 127;
    var mantissa;
    sign >>= 7;
    while(nBits > 0){
        exponent = exponent * 256 + buffer[index--];
        nBits -= 8;
    }
    mantissa = exponent & (1 << -nBits) - 1;
    exponent >>= -nBits;
    nBits += mantissaLength;
    while(nBits > 0){
        mantissa = mantissa * 256 + buffer[index--];
        nBits -= 8;
    }
    if (exponent === 0) exponent = 1 - eBias;
    else if (exponent === eMax) return mantissa ? NaN : sign ? -Infinity : Infinity;
    else {
        mantissa = mantissa + $ebce8564faba8af1$var$pow(2, mantissaLength);
        exponent = exponent - eBias;
    }
    return (sign ? -1 : 1) * mantissa * $ebce8564faba8af1$var$pow(2, exponent - mantissaLength);
};
$ebce8564faba8af1$exports = {
    pack: $ebce8564faba8af1$var$pack,
    unpack: $ebce8564faba8af1$var$unpack
};





var $007b66ce508dac9e$require$getOwnPropertyNames = $cdc111d4fc429a99$export$2d1720544b23b823;




var $007b66ce508dac9e$var$PROPER_FUNCTION_NAME = $93a445032aaa8001$exports.PROPER;
var $007b66ce508dac9e$var$CONFIGURABLE_FUNCTION_NAME = $93a445032aaa8001$exports.CONFIGURABLE;
var $007b66ce508dac9e$var$ARRAY_BUFFER = "ArrayBuffer";
var $007b66ce508dac9e$var$DATA_VIEW = "DataView";
var $007b66ce508dac9e$var$PROTOTYPE = "prototype";
var $007b66ce508dac9e$var$WRONG_LENGTH = "Wrong length";
var $007b66ce508dac9e$var$WRONG_INDEX = "Wrong index";
var $007b66ce508dac9e$var$getInternalArrayBufferState = $dbe54846b72f85d1$exports.getterFor($007b66ce508dac9e$var$ARRAY_BUFFER);
var $007b66ce508dac9e$var$getInternalDataViewState = $dbe54846b72f85d1$exports.getterFor($007b66ce508dac9e$var$DATA_VIEW);
var $007b66ce508dac9e$var$setInternalState = $dbe54846b72f85d1$exports.set;
var $007b66ce508dac9e$var$NativeArrayBuffer = $1a6e68c95df7d4df$exports[$007b66ce508dac9e$var$ARRAY_BUFFER];
var $007b66ce508dac9e$var$$ArrayBuffer = $007b66ce508dac9e$var$NativeArrayBuffer;
var $007b66ce508dac9e$var$ArrayBufferPrototype = $007b66ce508dac9e$var$$ArrayBuffer && $007b66ce508dac9e$var$$ArrayBuffer[$007b66ce508dac9e$var$PROTOTYPE];
var $007b66ce508dac9e$var$$DataView = $1a6e68c95df7d4df$exports[$007b66ce508dac9e$var$DATA_VIEW];
var $007b66ce508dac9e$var$DataViewPrototype = $007b66ce508dac9e$var$$DataView && $007b66ce508dac9e$var$$DataView[$007b66ce508dac9e$var$PROTOTYPE];
var $007b66ce508dac9e$var$ObjectPrototype = Object.prototype;
var $007b66ce508dac9e$var$Array = $1a6e68c95df7d4df$exports.Array;
var $007b66ce508dac9e$var$RangeError = $1a6e68c95df7d4df$exports.RangeError;
var $007b66ce508dac9e$var$fill = $c510c74e58563f95$exports($89c606f05ba71d51$exports);
var $007b66ce508dac9e$var$reverse = $c510c74e58563f95$exports([].reverse);
var $007b66ce508dac9e$var$packIEEE754 = $ebce8564faba8af1$exports.pack;
var $007b66ce508dac9e$var$unpackIEEE754 = $ebce8564faba8af1$exports.unpack;
var $007b66ce508dac9e$var$packInt8 = function(number) {
    return [
        number & 0xFF
    ];
};
var $007b66ce508dac9e$var$packInt16 = function(number) {
    return [
        number & 0xFF,
        number >> 8 & 0xFF
    ];
};
var $007b66ce508dac9e$var$packInt32 = function(number) {
    return [
        number & 0xFF,
        number >> 8 & 0xFF,
        number >> 16 & 0xFF,
        number >> 24 & 0xFF
    ];
};
var $007b66ce508dac9e$var$unpackInt32 = function(buffer) {
    return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};
var $007b66ce508dac9e$var$packFloat32 = function(number) {
    return $007b66ce508dac9e$var$packIEEE754(number, 23, 4);
};
var $007b66ce508dac9e$var$packFloat64 = function(number) {
    return $007b66ce508dac9e$var$packIEEE754(number, 52, 8);
};
var $007b66ce508dac9e$var$addGetter = function(Constructor, key, getInternalState) {
    $54b1e35819861675$exports(Constructor[$007b66ce508dac9e$var$PROTOTYPE], key, {
        configurable: true,
        get: function() {
            return getInternalState(this)[key];
        }
    });
};
var $007b66ce508dac9e$var$get = function(view, count, index, isLittleEndian) {
    var intIndex = $44e5d8e78700c624$exports(index);
    var store = $007b66ce508dac9e$var$getInternalDataViewState(view);
    if (intIndex + count > store.byteLength) throw $007b66ce508dac9e$var$RangeError($007b66ce508dac9e$var$WRONG_INDEX);
    var bytes = store.bytes;
    var start = intIndex + store.byteOffset;
    var pack = $df6d3dbc942f438e$exports(bytes, start, start + count);
    return isLittleEndian ? pack : $007b66ce508dac9e$var$reverse(pack);
};
var $007b66ce508dac9e$var$set = function(view, count, index, conversion, value, isLittleEndian) {
    var intIndex = $44e5d8e78700c624$exports(index);
    var store = $007b66ce508dac9e$var$getInternalDataViewState(view);
    if (intIndex + count > store.byteLength) throw $007b66ce508dac9e$var$RangeError($007b66ce508dac9e$var$WRONG_INDEX);
    var bytes = store.bytes;
    var start = intIndex + store.byteOffset;
    var pack = conversion(+value);
    for(var i = 0; i < count; i++)bytes[start + i] = pack[isLittleEndian ? i : count - i - 1];
};
if (!$ef544a74b30cdd0b$exports) {
    $007b66ce508dac9e$var$$ArrayBuffer = function ArrayBuffer(length) {
        $a5a0f9cce104c4f5$exports(this, $007b66ce508dac9e$var$ArrayBufferPrototype);
        var byteLength = $44e5d8e78700c624$exports(length);
        $007b66ce508dac9e$var$setInternalState(this, {
            type: $007b66ce508dac9e$var$ARRAY_BUFFER,
            bytes: $007b66ce508dac9e$var$fill($007b66ce508dac9e$var$Array(byteLength), 0),
            byteLength: byteLength
        });
        if (!$0ab298e69b752e0a$exports) {
            this.byteLength = byteLength;
            this.detached = false;
        }
    };
    $007b66ce508dac9e$var$ArrayBufferPrototype = $007b66ce508dac9e$var$$ArrayBuffer[$007b66ce508dac9e$var$PROTOTYPE];
    $007b66ce508dac9e$var$$DataView = function DataView(buffer, byteOffset, byteLength) {
        $a5a0f9cce104c4f5$exports(this, $007b66ce508dac9e$var$DataViewPrototype);
        $a5a0f9cce104c4f5$exports(buffer, $007b66ce508dac9e$var$ArrayBufferPrototype);
        var bufferState = $007b66ce508dac9e$var$getInternalArrayBufferState(buffer);
        var bufferLength = bufferState.byteLength;
        var offset = $7167297f49b8d757$exports(byteOffset);
        if (offset < 0 || offset > bufferLength) throw $007b66ce508dac9e$var$RangeError("Wrong offset");
        byteLength = byteLength === undefined ? bufferLength - offset : $c2922a7ee9a4ab10$exports(byteLength);
        if (offset + byteLength > bufferLength) throw $007b66ce508dac9e$var$RangeError($007b66ce508dac9e$var$WRONG_LENGTH);
        $007b66ce508dac9e$var$setInternalState(this, {
            type: $007b66ce508dac9e$var$DATA_VIEW,
            buffer: buffer,
            byteLength: byteLength,
            byteOffset: offset,
            bytes: bufferState.bytes
        });
        if (!$0ab298e69b752e0a$exports) {
            this.buffer = buffer;
            this.byteLength = byteLength;
            this.byteOffset = offset;
        }
    };
    $007b66ce508dac9e$var$DataViewPrototype = $007b66ce508dac9e$var$$DataView[$007b66ce508dac9e$var$PROTOTYPE];
    if ($0ab298e69b752e0a$exports) {
        $007b66ce508dac9e$var$addGetter($007b66ce508dac9e$var$$ArrayBuffer, "byteLength", $007b66ce508dac9e$var$getInternalArrayBufferState);
        $007b66ce508dac9e$var$addGetter($007b66ce508dac9e$var$$DataView, "buffer", $007b66ce508dac9e$var$getInternalDataViewState);
        $007b66ce508dac9e$var$addGetter($007b66ce508dac9e$var$$DataView, "byteLength", $007b66ce508dac9e$var$getInternalDataViewState);
        $007b66ce508dac9e$var$addGetter($007b66ce508dac9e$var$$DataView, "byteOffset", $007b66ce508dac9e$var$getInternalDataViewState);
    }
    $be8b41c0f3f6adf6$exports($007b66ce508dac9e$var$DataViewPrototype, {
        getInt8: function getInt8(byteOffset) {
            return $007b66ce508dac9e$var$get(this, 1, byteOffset)[0] << 24 >> 24;
        },
        getUint8: function getUint8(byteOffset) {
            return $007b66ce508dac9e$var$get(this, 1, byteOffset)[0];
        },
        getInt16: function getInt16(byteOffset /* , littleEndian */ ) {
            var bytes = $007b66ce508dac9e$var$get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
            return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
        },
        getUint16: function getUint16(byteOffset /* , littleEndian */ ) {
            var bytes = $007b66ce508dac9e$var$get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
            return bytes[1] << 8 | bytes[0];
        },
        getInt32: function getInt32(byteOffset /* , littleEndian */ ) {
            return $007b66ce508dac9e$var$unpackInt32($007b66ce508dac9e$var$get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined));
        },
        getUint32: function getUint32(byteOffset /* , littleEndian */ ) {
            return $007b66ce508dac9e$var$unpackInt32($007b66ce508dac9e$var$get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined)) >>> 0;
        },
        getFloat32: function getFloat32(byteOffset /* , littleEndian */ ) {
            return $007b66ce508dac9e$var$unpackIEEE754($007b66ce508dac9e$var$get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 23);
        },
        getFloat64: function getFloat64(byteOffset /* , littleEndian */ ) {
            return $007b66ce508dac9e$var$unpackIEEE754($007b66ce508dac9e$var$get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 52);
        },
        setInt8: function setInt8(byteOffset, value) {
            $007b66ce508dac9e$var$set(this, 1, byteOffset, $007b66ce508dac9e$var$packInt8, value);
        },
        setUint8: function setUint8(byteOffset, value) {
            $007b66ce508dac9e$var$set(this, 1, byteOffset, $007b66ce508dac9e$var$packInt8, value);
        },
        setInt16: function setInt16(byteOffset, value /* , littleEndian */ ) {
            $007b66ce508dac9e$var$set(this, 2, byteOffset, $007b66ce508dac9e$var$packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
        },
        setUint16: function setUint16(byteOffset, value /* , littleEndian */ ) {
            $007b66ce508dac9e$var$set(this, 2, byteOffset, $007b66ce508dac9e$var$packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
        },
        setInt32: function setInt32(byteOffset, value /* , littleEndian */ ) {
            $007b66ce508dac9e$var$set(this, 4, byteOffset, $007b66ce508dac9e$var$packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
        },
        setUint32: function setUint32(byteOffset, value /* , littleEndian */ ) {
            $007b66ce508dac9e$var$set(this, 4, byteOffset, $007b66ce508dac9e$var$packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
        },
        setFloat32: function setFloat32(byteOffset, value /* , littleEndian */ ) {
            $007b66ce508dac9e$var$set(this, 4, byteOffset, $007b66ce508dac9e$var$packFloat32, value, arguments.length > 2 ? arguments[2] : undefined);
        },
        setFloat64: function setFloat64(byteOffset, value /* , littleEndian */ ) {
            $007b66ce508dac9e$var$set(this, 8, byteOffset, $007b66ce508dac9e$var$packFloat64, value, arguments.length > 2 ? arguments[2] : undefined);
        }
    });
} else {
    var $007b66ce508dac9e$var$INCORRECT_ARRAY_BUFFER_NAME = $007b66ce508dac9e$var$PROPER_FUNCTION_NAME && $007b66ce508dac9e$var$NativeArrayBuffer.name !== $007b66ce508dac9e$var$ARRAY_BUFFER;
    /* eslint-disable no-new -- required for testing */ if (!$4cefcb1c1c1fa750$exports(function() {
        $007b66ce508dac9e$var$NativeArrayBuffer(1);
    }) || !$4cefcb1c1c1fa750$exports(function() {
        new $007b66ce508dac9e$var$NativeArrayBuffer(-1);
    }) || $4cefcb1c1c1fa750$exports(function() {
        new $007b66ce508dac9e$var$NativeArrayBuffer();
        new $007b66ce508dac9e$var$NativeArrayBuffer(1.5);
        new $007b66ce508dac9e$var$NativeArrayBuffer(NaN);
        return $007b66ce508dac9e$var$NativeArrayBuffer.length != 1 || $007b66ce508dac9e$var$INCORRECT_ARRAY_BUFFER_NAME && !$007b66ce508dac9e$var$CONFIGURABLE_FUNCTION_NAME;
    })) {
        /* eslint-enable no-new -- required for testing */ $007b66ce508dac9e$var$$ArrayBuffer = function ArrayBuffer(length) {
            $a5a0f9cce104c4f5$exports(this, $007b66ce508dac9e$var$ArrayBufferPrototype);
            return new $007b66ce508dac9e$var$NativeArrayBuffer($44e5d8e78700c624$exports(length));
        };
        $007b66ce508dac9e$var$$ArrayBuffer[$007b66ce508dac9e$var$PROTOTYPE] = $007b66ce508dac9e$var$ArrayBufferPrototype;
        for(var $007b66ce508dac9e$var$keys = $007b66ce508dac9e$require$getOwnPropertyNames($007b66ce508dac9e$var$NativeArrayBuffer), $007b66ce508dac9e$var$j = 0, $007b66ce508dac9e$var$key; $007b66ce508dac9e$var$keys.length > $007b66ce508dac9e$var$j;)if (!(($007b66ce508dac9e$var$key = $007b66ce508dac9e$var$keys[$007b66ce508dac9e$var$j++]) in $007b66ce508dac9e$var$$ArrayBuffer)) $4716626f874fe5a3$exports($007b66ce508dac9e$var$$ArrayBuffer, $007b66ce508dac9e$var$key, $007b66ce508dac9e$var$NativeArrayBuffer[$007b66ce508dac9e$var$key]);
        $007b66ce508dac9e$var$ArrayBufferPrototype.constructor = $007b66ce508dac9e$var$$ArrayBuffer;
    } else if ($007b66ce508dac9e$var$INCORRECT_ARRAY_BUFFER_NAME && $007b66ce508dac9e$var$CONFIGURABLE_FUNCTION_NAME) $4716626f874fe5a3$exports($007b66ce508dac9e$var$NativeArrayBuffer, "name", $007b66ce508dac9e$var$ARRAY_BUFFER);
    // WebKit bug - the same parent prototype for typed arrays and data view
    if ($a922355a1bcefb04$exports && $a30ba929b298478d$exports($007b66ce508dac9e$var$DataViewPrototype) !== $007b66ce508dac9e$var$ObjectPrototype) $a922355a1bcefb04$exports($007b66ce508dac9e$var$DataViewPrototype, $007b66ce508dac9e$var$ObjectPrototype);
    // iOS Safari 7.x bug
    var $007b66ce508dac9e$var$testView = new $007b66ce508dac9e$var$$DataView(new $007b66ce508dac9e$var$$ArrayBuffer(2));
    var $007b66ce508dac9e$var$$setInt8 = $c510c74e58563f95$exports($007b66ce508dac9e$var$DataViewPrototype.setInt8);
    $007b66ce508dac9e$var$testView.setInt8(0, 2147483648);
    $007b66ce508dac9e$var$testView.setInt8(1, 2147483649);
    if ($007b66ce508dac9e$var$testView.getInt8(0) || !$007b66ce508dac9e$var$testView.getInt8(1)) $be8b41c0f3f6adf6$exports($007b66ce508dac9e$var$DataViewPrototype, {
        setInt8: function setInt8(byteOffset, value) {
            $007b66ce508dac9e$var$$setInt8(this, byteOffset, value << 24 >> 24);
        },
        setUint8: function setUint8(byteOffset, value) {
            $007b66ce508dac9e$var$$setInt8(this, byteOffset, value << 24 >> 24);
        }
    }, {
        unsafe: true
    });
}
$ec32ac1e3fb4a1a1$exports($007b66ce508dac9e$var$$ArrayBuffer, $007b66ce508dac9e$var$ARRAY_BUFFER);
$ec32ac1e3fb4a1a1$exports($007b66ce508dac9e$var$$DataView, $007b66ce508dac9e$var$DATA_VIEW);
$007b66ce508dac9e$exports = {
    ArrayBuffer: $007b66ce508dac9e$var$$ArrayBuffer,
    DataView: $007b66ce508dac9e$var$$DataView
};



var $50e8309fcb226f0a$var$ARRAY_BUFFER = "ArrayBuffer";
var $50e8309fcb226f0a$var$ArrayBuffer = $007b66ce508dac9e$exports[$50e8309fcb226f0a$var$ARRAY_BUFFER];
var $50e8309fcb226f0a$var$NativeArrayBuffer = $1a6e68c95df7d4df$exports[$50e8309fcb226f0a$var$ARRAY_BUFFER];
// `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor
$0365e955907213bd$exports({
    global: true,
    constructor: true,
    forced: $50e8309fcb226f0a$var$NativeArrayBuffer !== $50e8309fcb226f0a$var$ArrayBuffer
}, {
    ArrayBuffer: $50e8309fcb226f0a$var$ArrayBuffer
});
$60a2ce15ea97c905$exports($50e8309fcb226f0a$var$ARRAY_BUFFER);



var $a8e31709e413942c$exports = {};
"use strict";

















var $a8e31709e413942c$var$enforceInternalState = $dbe54846b72f85d1$exports.enforce;
var $a8e31709e413942c$var$getInternalState = $dbe54846b72f85d1$exports.get;
var $a8e31709e413942c$var$Int8Array = $1a6e68c95df7d4df$exports.Int8Array;
var $a8e31709e413942c$var$Int8ArrayPrototype = $a8e31709e413942c$var$Int8Array && $a8e31709e413942c$var$Int8Array.prototype;
var $a8e31709e413942c$var$Uint8ClampedArray = $1a6e68c95df7d4df$exports.Uint8ClampedArray;
var $a8e31709e413942c$var$Uint8ClampedArrayPrototype = $a8e31709e413942c$var$Uint8ClampedArray && $a8e31709e413942c$var$Uint8ClampedArray.prototype;
var $a8e31709e413942c$var$TypedArray = $a8e31709e413942c$var$Int8Array && $a30ba929b298478d$exports($a8e31709e413942c$var$Int8Array);
var $a8e31709e413942c$var$TypedArrayPrototype = $a8e31709e413942c$var$Int8ArrayPrototype && $a30ba929b298478d$exports($a8e31709e413942c$var$Int8ArrayPrototype);
var $a8e31709e413942c$var$ObjectPrototype = Object.prototype;
var $a8e31709e413942c$var$TypeError = $1a6e68c95df7d4df$exports.TypeError;
var $a8e31709e413942c$var$TO_STRING_TAG = $5cfcb69f0877711f$exports("toStringTag");
var $a8e31709e413942c$var$TYPED_ARRAY_TAG = $8e860c2fd7cf6ff6$exports("TYPED_ARRAY_TAG");
var $a8e31709e413942c$var$TYPED_ARRAY_CONSTRUCTOR = "TypedArrayConstructor";
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var $a8e31709e413942c$var$NATIVE_ARRAY_BUFFER_VIEWS = $ef544a74b30cdd0b$exports && !!$a922355a1bcefb04$exports && $79ec051cbbc13a5e$exports($1a6e68c95df7d4df$exports.opera) !== "Opera";
var $a8e31709e413942c$var$TYPED_ARRAY_TAG_REQUIRED = false;
var $a8e31709e413942c$var$NAME, $a8e31709e413942c$var$Constructor, $a8e31709e413942c$var$Prototype;
var $a8e31709e413942c$var$TypedArrayConstructorsList = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
};
var $a8e31709e413942c$var$BigIntArrayConstructorsList = {
    BigInt64Array: 8,
    BigUint64Array: 8
};
var $a8e31709e413942c$var$isView = function isView(it) {
    if (!$dfdc56bc53f57e69$exports(it)) return false;
    var klass = $79ec051cbbc13a5e$exports(it);
    return klass === "DataView" || $ef59b581f0d1672b$exports($a8e31709e413942c$var$TypedArrayConstructorsList, klass) || $ef59b581f0d1672b$exports($a8e31709e413942c$var$BigIntArrayConstructorsList, klass);
};
var $a8e31709e413942c$var$getTypedArrayConstructor = function(it) {
    var proto = $a30ba929b298478d$exports(it);
    if (!$dfdc56bc53f57e69$exports(proto)) return;
    var state = $a8e31709e413942c$var$getInternalState(proto);
    return state && $ef59b581f0d1672b$exports(state, $a8e31709e413942c$var$TYPED_ARRAY_CONSTRUCTOR) ? state[$a8e31709e413942c$var$TYPED_ARRAY_CONSTRUCTOR] : $a8e31709e413942c$var$getTypedArrayConstructor(proto);
};
var $a8e31709e413942c$var$isTypedArray = function(it) {
    if (!$dfdc56bc53f57e69$exports(it)) return false;
    var klass = $79ec051cbbc13a5e$exports(it);
    return $ef59b581f0d1672b$exports($a8e31709e413942c$var$TypedArrayConstructorsList, klass) || $ef59b581f0d1672b$exports($a8e31709e413942c$var$BigIntArrayConstructorsList, klass);
};
var $a8e31709e413942c$var$aTypedArray = function(it) {
    if ($a8e31709e413942c$var$isTypedArray(it)) return it;
    throw $a8e31709e413942c$var$TypeError("Target is not a typed array");
};
var $a8e31709e413942c$var$aTypedArrayConstructor = function(C) {
    if ($c1d5f87f1e56c4cc$exports(C) && (!$a922355a1bcefb04$exports || $b82c3d945f0459c1$exports($a8e31709e413942c$var$TypedArray, C))) return C;
    throw $a8e31709e413942c$var$TypeError($f3ce16a57f0d7972$exports(C) + " is not a typed array constructor");
};
var $a8e31709e413942c$var$exportTypedArrayMethod = function(KEY, property, forced, options) {
    if (!$0ab298e69b752e0a$exports) return;
    if (forced) for(var ARRAY in $a8e31709e413942c$var$TypedArrayConstructorsList){
        var TypedArrayConstructor = $1a6e68c95df7d4df$exports[ARRAY];
        if (TypedArrayConstructor && $ef59b581f0d1672b$exports(TypedArrayConstructor.prototype, KEY)) try {
            delete TypedArrayConstructor.prototype[KEY];
        } catch (error) {
            // old WebKit bug - some methods are non-configurable
            try {
                TypedArrayConstructor.prototype[KEY] = property;
            } catch (error2) {}
        }
    }
    if (!$a8e31709e413942c$var$TypedArrayPrototype[KEY] || forced) $eeb1abced7a4b5b5$exports($a8e31709e413942c$var$TypedArrayPrototype, KEY, forced ? property : $a8e31709e413942c$var$NATIVE_ARRAY_BUFFER_VIEWS && $a8e31709e413942c$var$Int8ArrayPrototype[KEY] || property, options);
};
var $a8e31709e413942c$var$exportTypedArrayStaticMethod = function(KEY, property, forced) {
    var ARRAY, TypedArrayConstructor;
    if (!$0ab298e69b752e0a$exports) return;
    if ($a922355a1bcefb04$exports) {
        if (forced) for(ARRAY in $a8e31709e413942c$var$TypedArrayConstructorsList){
            TypedArrayConstructor = $1a6e68c95df7d4df$exports[ARRAY];
            if (TypedArrayConstructor && $ef59b581f0d1672b$exports(TypedArrayConstructor, KEY)) try {
                delete TypedArrayConstructor[KEY];
            } catch (error) {}
        }
        if (!$a8e31709e413942c$var$TypedArray[KEY] || forced) // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
        try {
            return $eeb1abced7a4b5b5$exports($a8e31709e413942c$var$TypedArray, KEY, forced ? property : $a8e31709e413942c$var$NATIVE_ARRAY_BUFFER_VIEWS && $a8e31709e413942c$var$TypedArray[KEY] || property);
        } catch (error) {}
        else return;
    }
    for(ARRAY in $a8e31709e413942c$var$TypedArrayConstructorsList){
        TypedArrayConstructor = $1a6e68c95df7d4df$exports[ARRAY];
        if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) $eeb1abced7a4b5b5$exports(TypedArrayConstructor, KEY, property);
    }
};
for($a8e31709e413942c$var$NAME in $a8e31709e413942c$var$TypedArrayConstructorsList){
    $a8e31709e413942c$var$Constructor = $1a6e68c95df7d4df$exports[$a8e31709e413942c$var$NAME];
    $a8e31709e413942c$var$Prototype = $a8e31709e413942c$var$Constructor && $a8e31709e413942c$var$Constructor.prototype;
    if ($a8e31709e413942c$var$Prototype) $a8e31709e413942c$var$enforceInternalState($a8e31709e413942c$var$Prototype)[$a8e31709e413942c$var$TYPED_ARRAY_CONSTRUCTOR] = $a8e31709e413942c$var$Constructor;
    else $a8e31709e413942c$var$NATIVE_ARRAY_BUFFER_VIEWS = false;
}
for($a8e31709e413942c$var$NAME in $a8e31709e413942c$var$BigIntArrayConstructorsList){
    $a8e31709e413942c$var$Constructor = $1a6e68c95df7d4df$exports[$a8e31709e413942c$var$NAME];
    $a8e31709e413942c$var$Prototype = $a8e31709e413942c$var$Constructor && $a8e31709e413942c$var$Constructor.prototype;
    if ($a8e31709e413942c$var$Prototype) $a8e31709e413942c$var$enforceInternalState($a8e31709e413942c$var$Prototype)[$a8e31709e413942c$var$TYPED_ARRAY_CONSTRUCTOR] = $a8e31709e413942c$var$Constructor;
}
// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!$a8e31709e413942c$var$NATIVE_ARRAY_BUFFER_VIEWS || !$c1d5f87f1e56c4cc$exports($a8e31709e413942c$var$TypedArray) || $a8e31709e413942c$var$TypedArray === Function.prototype) {
    // eslint-disable-next-line no-shadow -- safe
    $a8e31709e413942c$var$TypedArray = function TypedArray() {
        throw $a8e31709e413942c$var$TypeError("Incorrect invocation");
    };
    if ($a8e31709e413942c$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($a8e31709e413942c$var$NAME in $a8e31709e413942c$var$TypedArrayConstructorsList)if ($1a6e68c95df7d4df$exports[$a8e31709e413942c$var$NAME]) $a922355a1bcefb04$exports($1a6e68c95df7d4df$exports[$a8e31709e413942c$var$NAME], $a8e31709e413942c$var$TypedArray);
    }
}
if (!$a8e31709e413942c$var$NATIVE_ARRAY_BUFFER_VIEWS || !$a8e31709e413942c$var$TypedArrayPrototype || $a8e31709e413942c$var$TypedArrayPrototype === $a8e31709e413942c$var$ObjectPrototype) {
    $a8e31709e413942c$var$TypedArrayPrototype = $a8e31709e413942c$var$TypedArray.prototype;
    if ($a8e31709e413942c$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        for($a8e31709e413942c$var$NAME in $a8e31709e413942c$var$TypedArrayConstructorsList)if ($1a6e68c95df7d4df$exports[$a8e31709e413942c$var$NAME]) $a922355a1bcefb04$exports($1a6e68c95df7d4df$exports[$a8e31709e413942c$var$NAME].prototype, $a8e31709e413942c$var$TypedArrayPrototype);
    }
}
// WebKit bug - one more object in Uint8ClampedArray prototype chain
if ($a8e31709e413942c$var$NATIVE_ARRAY_BUFFER_VIEWS && $a30ba929b298478d$exports($a8e31709e413942c$var$Uint8ClampedArrayPrototype) !== $a8e31709e413942c$var$TypedArrayPrototype) $a922355a1bcefb04$exports($a8e31709e413942c$var$Uint8ClampedArrayPrototype, $a8e31709e413942c$var$TypedArrayPrototype);
if ($0ab298e69b752e0a$exports && !$ef59b581f0d1672b$exports($a8e31709e413942c$var$TypedArrayPrototype, $a8e31709e413942c$var$TO_STRING_TAG)) {
    $a8e31709e413942c$var$TYPED_ARRAY_TAG_REQUIRED = true;
    $54b1e35819861675$exports($a8e31709e413942c$var$TypedArrayPrototype, $a8e31709e413942c$var$TO_STRING_TAG, {
        configurable: true,
        get: function() {
            return $dfdc56bc53f57e69$exports(this) ? this[$a8e31709e413942c$var$TYPED_ARRAY_TAG] : undefined;
        }
    });
    for($a8e31709e413942c$var$NAME in $a8e31709e413942c$var$TypedArrayConstructorsList)if ($1a6e68c95df7d4df$exports[$a8e31709e413942c$var$NAME]) $4716626f874fe5a3$exports($1a6e68c95df7d4df$exports[$a8e31709e413942c$var$NAME], $a8e31709e413942c$var$TYPED_ARRAY_TAG, $a8e31709e413942c$var$NAME);
}
$a8e31709e413942c$exports = {
    NATIVE_ARRAY_BUFFER_VIEWS: $a8e31709e413942c$var$NATIVE_ARRAY_BUFFER_VIEWS,
    TYPED_ARRAY_TAG: $a8e31709e413942c$var$TYPED_ARRAY_TAG_REQUIRED && $a8e31709e413942c$var$TYPED_ARRAY_TAG,
    aTypedArray: $a8e31709e413942c$var$aTypedArray,
    aTypedArrayConstructor: $a8e31709e413942c$var$aTypedArrayConstructor,
    exportTypedArrayMethod: $a8e31709e413942c$var$exportTypedArrayMethod,
    exportTypedArrayStaticMethod: $a8e31709e413942c$var$exportTypedArrayStaticMethod,
    getTypedArrayConstructor: $a8e31709e413942c$var$getTypedArrayConstructor,
    isView: $a8e31709e413942c$var$isView,
    isTypedArray: $a8e31709e413942c$var$isTypedArray,
    TypedArray: $a8e31709e413942c$var$TypedArray,
    TypedArrayPrototype: $a8e31709e413942c$var$TypedArrayPrototype
};


var $97b784ad7bb0b78a$var$NATIVE_ARRAY_BUFFER_VIEWS = $a8e31709e413942c$exports.NATIVE_ARRAY_BUFFER_VIEWS;
// `ArrayBuffer.isView` method
// https://tc39.es/ecma262/#sec-arraybuffer.isview
$0365e955907213bd$exports({
    target: "ArrayBuffer",
    stat: true,
    forced: !$97b784ad7bb0b78a$var$NATIVE_ARRAY_BUFFER_VIEWS
}, {
    isView: $a8e31709e413942c$exports.isView
});


"use strict";







var $a926216b9de7547b$exports = {};

var $7cef700a0727b620$exports = {};


var $7cef700a0727b620$var$$TypeError = TypeError;
// `Assert: IsConstructor(argument) is true`
$7cef700a0727b620$exports = function(argument) {
    if ($f09b11ea7290b6eb$exports(argument)) return argument;
    throw $7cef700a0727b620$var$$TypeError($f3ce16a57f0d7972$exports(argument) + " is not a constructor");
};




var $a926216b9de7547b$var$SPECIES = $5cfcb69f0877711f$exports("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
$a926216b9de7547b$exports = function(O, defaultConstructor) {
    var C = $830db860a045bbb5$exports(O).constructor;
    var S;
    return C === undefined || $784d9540a0abf25d$exports(S = $830db860a045bbb5$exports(C)[$a926216b9de7547b$var$SPECIES]) ? defaultConstructor : $7cef700a0727b620$exports(S);
};


var $87d8ccc6c1bba5c7$var$ArrayBuffer = $007b66ce508dac9e$exports.ArrayBuffer;
var $87d8ccc6c1bba5c7$var$DataView = $007b66ce508dac9e$exports.DataView;
var $87d8ccc6c1bba5c7$var$DataViewPrototype = $87d8ccc6c1bba5c7$var$DataView.prototype;
var $87d8ccc6c1bba5c7$var$nativeArrayBufferSlice = $31a67080629c484a$exports($87d8ccc6c1bba5c7$var$ArrayBuffer.prototype.slice);
var $87d8ccc6c1bba5c7$var$getUint8 = $31a67080629c484a$exports($87d8ccc6c1bba5c7$var$DataViewPrototype.getUint8);
var $87d8ccc6c1bba5c7$var$setUint8 = $31a67080629c484a$exports($87d8ccc6c1bba5c7$var$DataViewPrototype.setUint8);
var $87d8ccc6c1bba5c7$var$INCORRECT_SLICE = $4cefcb1c1c1fa750$exports(function() {
    return !new $87d8ccc6c1bba5c7$var$ArrayBuffer(2).slice(1, undefined).byteLength;
});
// `ArrayBuffer.prototype.slice` method
// https://tc39.es/ecma262/#sec-arraybuffer.prototype.slice
$0365e955907213bd$exports({
    target: "ArrayBuffer",
    proto: true,
    unsafe: true,
    forced: $87d8ccc6c1bba5c7$var$INCORRECT_SLICE
}, {
    slice: function slice(start, end) {
        if ($87d8ccc6c1bba5c7$var$nativeArrayBufferSlice && end === undefined) return $87d8ccc6c1bba5c7$var$nativeArrayBufferSlice($830db860a045bbb5$exports(this), start); // FF fix
        var length = $830db860a045bbb5$exports(this).byteLength;
        var first = $125a12a61907520f$exports(start, length);
        var fin = $125a12a61907520f$exports(end === undefined ? length : end, length);
        var result = new ($a926216b9de7547b$exports(this, $87d8ccc6c1bba5c7$var$ArrayBuffer))($c2922a7ee9a4ab10$exports(fin - first));
        var viewSource = new $87d8ccc6c1bba5c7$var$DataView(this);
        var viewTarget = new $87d8ccc6c1bba5c7$var$DataView(result);
        var index = 0;
        while(first < fin)$87d8ccc6c1bba5c7$var$setUint8(viewTarget, index++, $87d8ccc6c1bba5c7$var$getUint8(viewSource, first++));
        return result;
    }
});


// TODO: Remove this module from `core-js@4` since it's replaced to module below



// `DataView` constructor
// https://tc39.es/ecma262/#sec-dataview-constructor
$0365e955907213bd$exports({
    global: true,
    constructor: true,
    forced: !$ef544a74b30cdd0b$exports
}, {
    DataView: $007b66ce508dac9e$exports.DataView
});




// TODO: Remove from `core-js@4`


var $6949ace7d0874d28$var$$Date = Date;
var $6949ace7d0874d28$var$thisTimeValue = $c510c74e58563f95$exports($6949ace7d0874d28$var$$Date.prototype.getTime);
// `Date.now` method
// https://tc39.es/ecma262/#sec-date.now
$0365e955907213bd$exports({
    target: "Date",
    stat: true
}, {
    now: function now() {
        return $6949ace7d0874d28$var$thisTimeValue(new $6949ace7d0874d28$var$$Date());
    }
});



var $cc089ce25a29b324$exports = {};
"use strict";


var $bd1f2c751add4c9f$exports = {};
// https://github.com/tc39/proposal-string-pad-start-end



var $42370b6b571de72c$exports = {};
"use strict";



var $42370b6b571de72c$var$$RangeError = RangeError;
// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
$42370b6b571de72c$exports = function repeat(count) {
    var str = $53d734af07b69aa7$exports($ac95046ddf1ecaa1$exports(this));
    var result = "";
    var n = $7167297f49b8d757$exports(count);
    if (n < 0 || n == Infinity) throw $42370b6b571de72c$var$$RangeError("Wrong number of repetitions");
    for(; n > 0; (n >>>= 1) && (str += str))if (n & 1) result += str;
    return result;
};



var $bd1f2c751add4c9f$var$repeat = $c510c74e58563f95$exports($42370b6b571de72c$exports);
var $bd1f2c751add4c9f$var$stringSlice = $c510c74e58563f95$exports("".slice);
var $bd1f2c751add4c9f$var$ceil = Math.ceil;
// `String.prototype.{ padStart, padEnd }` methods implementation
var $bd1f2c751add4c9f$var$createMethod = function(IS_END) {
    return function($this, maxLength, fillString) {
        var S = $53d734af07b69aa7$exports($ac95046ddf1ecaa1$exports($this));
        var intMaxLength = $c2922a7ee9a4ab10$exports(maxLength);
        var stringLength = S.length;
        var fillStr = fillString === undefined ? " " : $53d734af07b69aa7$exports(fillString);
        var fillLen, stringFiller;
        if (intMaxLength <= stringLength || fillStr == "") return S;
        fillLen = intMaxLength - stringLength;
        stringFiller = $bd1f2c751add4c9f$var$repeat(fillStr, $bd1f2c751add4c9f$var$ceil(fillLen / fillStr.length));
        if (stringFiller.length > fillLen) stringFiller = $bd1f2c751add4c9f$var$stringSlice(stringFiller, 0, fillLen);
        return IS_END ? S + stringFiller : stringFiller + S;
    };
};
$bd1f2c751add4c9f$exports = {
    // `String.prototype.padStart` method
    // https://tc39.es/ecma262/#sec-string.prototype.padstart
    start: $bd1f2c751add4c9f$var$createMethod(false),
    // `String.prototype.padEnd` method
    // https://tc39.es/ecma262/#sec-string.prototype.padend
    end: $bd1f2c751add4c9f$var$createMethod(true)
};


var $cc089ce25a29b324$require$padStart = $bd1f2c751add4c9f$exports.start;
var $cc089ce25a29b324$var$$RangeError = RangeError;
var $cc089ce25a29b324$var$$isFinite = isFinite;
var $cc089ce25a29b324$var$abs = Math.abs;
var $cc089ce25a29b324$var$DatePrototype = Date.prototype;
var $cc089ce25a29b324$var$nativeDateToISOString = $cc089ce25a29b324$var$DatePrototype.toISOString;
var $cc089ce25a29b324$var$thisTimeValue = $c510c74e58563f95$exports($cc089ce25a29b324$var$DatePrototype.getTime);
var $cc089ce25a29b324$var$getUTCDate = $c510c74e58563f95$exports($cc089ce25a29b324$var$DatePrototype.getUTCDate);
var $cc089ce25a29b324$var$getUTCFullYear = $c510c74e58563f95$exports($cc089ce25a29b324$var$DatePrototype.getUTCFullYear);
var $cc089ce25a29b324$var$getUTCHours = $c510c74e58563f95$exports($cc089ce25a29b324$var$DatePrototype.getUTCHours);
var $cc089ce25a29b324$var$getUTCMilliseconds = $c510c74e58563f95$exports($cc089ce25a29b324$var$DatePrototype.getUTCMilliseconds);
var $cc089ce25a29b324$var$getUTCMinutes = $c510c74e58563f95$exports($cc089ce25a29b324$var$DatePrototype.getUTCMinutes);
var $cc089ce25a29b324$var$getUTCMonth = $c510c74e58563f95$exports($cc089ce25a29b324$var$DatePrototype.getUTCMonth);
var $cc089ce25a29b324$var$getUTCSeconds = $c510c74e58563f95$exports($cc089ce25a29b324$var$DatePrototype.getUTCSeconds);
// `Date.prototype.toISOString` method implementation
// https://tc39.es/ecma262/#sec-date.prototype.toisostring
// PhantomJS / old WebKit fails here:
$cc089ce25a29b324$exports = $4cefcb1c1c1fa750$exports(function() {
    return $cc089ce25a29b324$var$nativeDateToISOString.call(new Date(-50000000000000 - 1)) != "0385-07-25T07:06:39.999Z";
}) || !$4cefcb1c1c1fa750$exports(function() {
    $cc089ce25a29b324$var$nativeDateToISOString.call(new Date(NaN));
}) ? function toISOString() {
    if (!$cc089ce25a29b324$var$$isFinite($cc089ce25a29b324$var$thisTimeValue(this))) throw $cc089ce25a29b324$var$$RangeError("Invalid time value");
    var date = this;
    var year = $cc089ce25a29b324$var$getUTCFullYear(date);
    var milliseconds = $cc089ce25a29b324$var$getUTCMilliseconds(date);
    var sign = year < 0 ? "-" : year > 9999 ? "+" : "";
    return sign + $cc089ce25a29b324$require$padStart($cc089ce25a29b324$var$abs(year), sign ? 6 : 4, 0) + "-" + $cc089ce25a29b324$require$padStart($cc089ce25a29b324$var$getUTCMonth(date) + 1, 2, 0) + "-" + $cc089ce25a29b324$require$padStart($cc089ce25a29b324$var$getUTCDate(date), 2, 0) + "T" + $cc089ce25a29b324$require$padStart($cc089ce25a29b324$var$getUTCHours(date), 2, 0) + ":" + $cc089ce25a29b324$require$padStart($cc089ce25a29b324$var$getUTCMinutes(date), 2, 0) + ":" + $cc089ce25a29b324$require$padStart($cc089ce25a29b324$var$getUTCSeconds(date), 2, 0) + "." + $cc089ce25a29b324$require$padStart(milliseconds, 3, 0) + "Z";
} : $cc089ce25a29b324$var$nativeDateToISOString;


// `Date.prototype.toISOString` method
// https://tc39.es/ecma262/#sec-date.prototype.toisostring
// PhantomJS / old WebKit has a broken implementations
$0365e955907213bd$exports({
    target: "Date",
    proto: true,
    forced: Date.prototype.toISOString !== $cc089ce25a29b324$exports
}, {
    toISOString: $cc089ce25a29b324$exports
});


"use strict";




var $e07e0f27bc39d88a$var$FORCED = $4cefcb1c1c1fa750$exports(function() {
    return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({
        toISOString: function() {
            return 1;
        }
    }) !== 1;
});
// `Date.prototype.toJSON` method
// https://tc39.es/ecma262/#sec-date.prototype.tojson
$0365e955907213bd$exports({
    target: "Date",
    proto: true,
    arity: 1,
    forced: $e07e0f27bc39d88a$var$FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    toJSON: function toJSON(key) {
        var O = $cc6f28a96f61f0ea$exports(this);
        var pv = $49e56ced23df1333$exports(O, "number");
        return typeof pv == "number" && !isFinite(pv) ? null : O.toISOString();
    }
});




var $d62666c1d4d2c899$exports = {};
"use strict";


var $d62666c1d4d2c899$var$$TypeError = TypeError;
// `Date.prototype[@@toPrimitive](hint)` method implementation
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
$d62666c1d4d2c899$exports = function(hint) {
    $830db860a045bbb5$exports(this);
    if (hint === "string" || hint === "default") hint = "string";
    else if (hint !== "number") throw $d62666c1d4d2c899$var$$TypeError("Incorrect hint");
    return $ac315fa953da3cec$exports(this, hint);
};



var $e8681f4e1f2fc47e$var$TO_PRIMITIVE = $5cfcb69f0877711f$exports("toPrimitive");
var $e8681f4e1f2fc47e$var$DatePrototype = Date.prototype;
// `Date.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
if (!$ef59b581f0d1672b$exports($e8681f4e1f2fc47e$var$DatePrototype, $e8681f4e1f2fc47e$var$TO_PRIMITIVE)) $eeb1abced7a4b5b5$exports($e8681f4e1f2fc47e$var$DatePrototype, $e8681f4e1f2fc47e$var$TO_PRIMITIVE, $d62666c1d4d2c899$exports);


// TODO: Remove from `core-js@4`


var $eec143558e9155ca$var$DatePrototype = Date.prototype;
var $eec143558e9155ca$var$INVALID_DATE = "Invalid Date";
var $eec143558e9155ca$var$TO_STRING = "toString";
var $eec143558e9155ca$var$nativeDateToString = $c510c74e58563f95$exports($eec143558e9155ca$var$DatePrototype[$eec143558e9155ca$var$TO_STRING]);
var $eec143558e9155ca$var$thisTimeValue = $c510c74e58563f95$exports($eec143558e9155ca$var$DatePrototype.getTime);
// `Date.prototype.toString` method
// https://tc39.es/ecma262/#sec-date.prototype.tostring
if (String(new Date(NaN)) != $eec143558e9155ca$var$INVALID_DATE) $eeb1abced7a4b5b5$exports($eec143558e9155ca$var$DatePrototype, $eec143558e9155ca$var$TO_STRING, function toString() {
    var value = $eec143558e9155ca$var$thisTimeValue(this);
    // eslint-disable-next-line no-self-compare -- NaN check
    return value === value ? $eec143558e9155ca$var$nativeDateToString(this) : $eec143558e9155ca$var$INVALID_DATE;
});


// TODO: Remove from `core-js@4`

var $2e10dedf6e7e691c$exports = {};
"use strict";






var $2e10dedf6e7e691c$var$$Function = Function;
var $2e10dedf6e7e691c$var$concat = $c510c74e58563f95$exports([].concat);
var $2e10dedf6e7e691c$var$join = $c510c74e58563f95$exports([].join);
var $2e10dedf6e7e691c$var$factories = {};
var $2e10dedf6e7e691c$var$construct = function(C, argsLength, args) {
    if (!$ef59b581f0d1672b$exports($2e10dedf6e7e691c$var$factories, argsLength)) {
        for(var list = [], i = 0; i < argsLength; i++)list[i] = "a[" + i + "]";
        $2e10dedf6e7e691c$var$factories[argsLength] = $2e10dedf6e7e691c$var$$Function("C,a", "return new C(" + $2e10dedf6e7e691c$var$join(list, ",") + ")");
    }
    return $2e10dedf6e7e691c$var$factories[argsLength](C, args);
};
// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
$2e10dedf6e7e691c$exports = $05c82362c0ced3b1$exports ? $2e10dedf6e7e691c$var$$Function.bind : function bind(that /* , ...args */ ) {
    var F = $4a6b57cf563748d0$exports(this);
    var Prototype = F.prototype;
    var partArgs = $05068435b6a808dd$exports(arguments, 1);
    var boundFunction = function bound() {
        var args = $2e10dedf6e7e691c$var$concat(partArgs, $05068435b6a808dd$exports(arguments));
        return this instanceof boundFunction ? $2e10dedf6e7e691c$var$construct(F, args.length, args) : F.apply(that, args);
    };
    if ($dfdc56bc53f57e69$exports(Prototype)) boundFunction.prototype = Prototype;
    return boundFunction;
};


// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
$0365e955907213bd$exports({
    target: "Function",
    proto: true,
    forced: Function.bind !== $2e10dedf6e7e691c$exports
}, {
    bind: $2e10dedf6e7e691c$exports
});


"use strict";






var $fdc67cc5e1cf8bdc$var$HAS_INSTANCE = $5cfcb69f0877711f$exports("hasInstance");
var $fdc67cc5e1cf8bdc$var$FunctionPrototype = Function.prototype;
// `Function.prototype[@@hasInstance]` method
// https://tc39.es/ecma262/#sec-function.prototype-@@hasinstance
if (!($fdc67cc5e1cf8bdc$var$HAS_INSTANCE in $fdc67cc5e1cf8bdc$var$FunctionPrototype)) $783b6a5a940dee05$export$2d1720544b23b823($fdc67cc5e1cf8bdc$var$FunctionPrototype, $fdc67cc5e1cf8bdc$var$HAS_INSTANCE, {
    value: $e133b70f97609f28$exports(function(O) {
        if (!$c1d5f87f1e56c4cc$exports(this) || !$dfdc56bc53f57e69$exports(O)) return false;
        var P = this.prototype;
        if (!$dfdc56bc53f57e69$exports(P)) return O instanceof this;
        // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
        while(O = $a30ba929b298478d$exports(O))if (P === O) return true;
        return false;
    }, $fdc67cc5e1cf8bdc$var$HAS_INSTANCE)
});




var $bd50097735d78947$require$FUNCTION_NAME_EXISTS = $93a445032aaa8001$exports.EXISTS;


var $bd50097735d78947$var$FunctionPrototype = Function.prototype;
var $bd50097735d78947$var$functionToString = $c510c74e58563f95$exports($bd50097735d78947$var$FunctionPrototype.toString);
var $bd50097735d78947$var$nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var $bd50097735d78947$var$regExpExec = $c510c74e58563f95$exports($bd50097735d78947$var$nameRE.exec);
var $bd50097735d78947$var$NAME = "name";
// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if ($0ab298e69b752e0a$exports && !$bd50097735d78947$require$FUNCTION_NAME_EXISTS) $54b1e35819861675$exports($bd50097735d78947$var$FunctionPrototype, $bd50097735d78947$var$NAME, {
    configurable: true,
    get: function() {
        try {
            return $bd50097735d78947$var$regExpExec($bd50097735d78947$var$nameRE, $bd50097735d78947$var$functionToString(this))[1];
        } catch (error) {
            return "";
        }
    }
});




// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
$ec32ac1e3fb4a1a1$exports($1a6e68c95df7d4df$exports.JSON, "JSON", true);


// TODO: Remove this module from `core-js@4` since it's replaced to module below
"use strict";
var $112b243b75bec4f7$exports = {};
"use strict";





var $23b16ea0b64c4091$exports = {};






var $23b16ea0b64c4091$require$defineProperty = $783b6a5a940dee05$export$2d1720544b23b823;


var $e5cb1b88d7f5b8cb$exports = {};



var $a7395b80581c8cc5$exports = {};
// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it

$a7395b80581c8cc5$exports = $4cefcb1c1c1fa750$exports(function() {
    if (typeof ArrayBuffer == "function") {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, "a", {
            value: 8
        });
    }
});


// eslint-disable-next-line es/no-object-isextensible -- safe
var $e5cb1b88d7f5b8cb$var$$isExtensible = Object.isExtensible;
var $e5cb1b88d7f5b8cb$var$FAILS_ON_PRIMITIVES = $4cefcb1c1c1fa750$exports(function() {
    $e5cb1b88d7f5b8cb$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
$e5cb1b88d7f5b8cb$exports = $e5cb1b88d7f5b8cb$var$FAILS_ON_PRIMITIVES || $a7395b80581c8cc5$exports ? function isExtensible(it) {
    if (!$dfdc56bc53f57e69$exports(it)) return false;
    if ($a7395b80581c8cc5$exports && $ee4d29ebca1023f3$exports(it) == "ArrayBuffer") return false;
    return $e5cb1b88d7f5b8cb$var$$isExtensible ? $e5cb1b88d7f5b8cb$var$$isExtensible(it) : true;
} : $e5cb1b88d7f5b8cb$var$$isExtensible;



var $e00e52bc2d436bf2$exports = {};

$e00e52bc2d436bf2$exports = !$4cefcb1c1c1fa750$exports(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});


var $23b16ea0b64c4091$var$REQUIRED = false;
var $23b16ea0b64c4091$var$METADATA = $8e860c2fd7cf6ff6$exports("meta");
var $23b16ea0b64c4091$var$id = 0;
var $23b16ea0b64c4091$var$setMetadata = function(it) {
    $23b16ea0b64c4091$require$defineProperty(it, $23b16ea0b64c4091$var$METADATA, {
        value: {
            objectID: "O" + $23b16ea0b64c4091$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $23b16ea0b64c4091$var$fastKey = function(it, create) {
    // return a primitive with prefix
    if (!$dfdc56bc53f57e69$exports(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
    if (!$ef59b581f0d1672b$exports(it, $23b16ea0b64c4091$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$e5cb1b88d7f5b8cb$exports(it)) return "F";
        // not necessary to add metadata
        if (!create) return "E";
        // add missing metadata
        $23b16ea0b64c4091$var$setMetadata(it);
    // return object ID
    }
    return it[$23b16ea0b64c4091$var$METADATA].objectID;
};
var $23b16ea0b64c4091$var$getWeakData = function(it, create) {
    if (!$ef59b581f0d1672b$exports(it, $23b16ea0b64c4091$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$e5cb1b88d7f5b8cb$exports(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $23b16ea0b64c4091$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$23b16ea0b64c4091$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $23b16ea0b64c4091$var$onFreeze = function(it) {
    if ($e00e52bc2d436bf2$exports && $23b16ea0b64c4091$var$REQUIRED && $e5cb1b88d7f5b8cb$exports(it) && !$ef59b581f0d1672b$exports(it, $23b16ea0b64c4091$var$METADATA)) $23b16ea0b64c4091$var$setMetadata(it);
    return it;
};
var $23b16ea0b64c4091$var$enable = function() {
    $23b16ea0b64c4091$var$meta.enable = function() {};
    $23b16ea0b64c4091$var$REQUIRED = true;
    var getOwnPropertyNames = $cdc111d4fc429a99$export$2d1720544b23b823;
    var splice = $c510c74e58563f95$exports([].splice);
    var test = {};
    test[$23b16ea0b64c4091$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $cdc111d4fc429a99$export$2d1720544b23b823 = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $23b16ea0b64c4091$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $0365e955907213bd$exports({
            target: "Object",
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $2c014ad5d62fc6d4$export$2d1720544b23b823
        });
    }
};
var $23b16ea0b64c4091$var$meta = $23b16ea0b64c4091$exports = {
    enable: $23b16ea0b64c4091$var$enable,
    fastKey: $23b16ea0b64c4091$var$fastKey,
    getWeakData: $23b16ea0b64c4091$var$getWeakData,
    onFreeze: $23b16ea0b64c4091$var$onFreeze
};
$2522edb48098e72d$exports[$23b16ea0b64c4091$var$METADATA] = true;


var $7519ce181fecbd34$exports = {};










var $7519ce181fecbd34$var$$TypeError = TypeError;
var $7519ce181fecbd34$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $7519ce181fecbd34$var$ResultPrototype = $7519ce181fecbd34$var$Result.prototype;
$7519ce181fecbd34$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $130f24665ebee510$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $d5d9b8900d3fd87c$exports(iterator, "normal", condition);
        return new $7519ce181fecbd34$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $830db860a045bbb5$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $a8ef08465170b254$exports(iterable);
        if (!iterFn) throw $7519ce181fecbd34$var$$TypeError($f3ce16a57f0d7972$exports(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($3a74e6d6b81c5829$exports(iterFn)) {
            for(index = 0, length = $ec53954e5de19898$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $b82c3d945f0459c1$exports($7519ce181fecbd34$var$ResultPrototype, result)) return result;
            }
            return new $7519ce181fecbd34$var$Result(false);
        }
        iterator = $a2edd71662804e98$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $3b5393d57c251c61$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $d5d9b8900d3fd87c$exports(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $b82c3d945f0459c1$exports($7519ce181fecbd34$var$ResultPrototype, result)) return result;
    }
    return new $7519ce181fecbd34$var$Result(false);
};









var $93beb66cab49b410$exports = {};



// makes subclassing work correct for wrapped built-ins
$93beb66cab49b410$exports = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    $a922355a1bcefb04$exports && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    $c1d5f87f1e56c4cc$exports(NewTarget = dummy.constructor) && NewTarget !== Wrapper && $dfdc56bc53f57e69$exports(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) $a922355a1bcefb04$exports($this, NewTargetPrototype);
    return $this;
};


$112b243b75bec4f7$exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
    var ADDER = IS_MAP ? "set" : "add";
    var NativeConstructor = $1a6e68c95df7d4df$exports[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};
    var fixMethod = function(KEY) {
        var uncurriedNativeMethod = $c510c74e58563f95$exports(NativePrototype[KEY]);
        $eeb1abced7a4b5b5$exports(NativePrototype, KEY, KEY == "add" ? function add(value) {
            uncurriedNativeMethod(this, value === 0 ? 0 : value);
            return this;
        } : KEY == "delete" ? function(key) {
            return IS_WEAK && !$dfdc56bc53f57e69$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY == "get" ? function get(key) {
            return IS_WEAK && !$dfdc56bc53f57e69$exports(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY == "has" ? function has(key) {
            return IS_WEAK && !$dfdc56bc53f57e69$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : function set(key, value) {
            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
            return this;
        });
    };
    var REPLACE = $87321f98e08714ab$exports(CONSTRUCTOR_NAME, !$c1d5f87f1e56c4cc$exports(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$4cefcb1c1c1fa750$exports(function() {
        new NativeConstructor().entries().next();
    })));
    if (REPLACE) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $23b16ea0b64c4091$exports.enable();
    } else if ($87321f98e08714ab$exports(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $4cefcb1c1c1fa750$exports(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new -- required for testing
        var ACCEPT_ITERABLES = $cc6f301ab97f18d4$exports(function(iterable) {
            new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $4cefcb1c1c1fa750$exports(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new NativeConstructor();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
                $a5a0f9cce104c4f5$exports(dummy, NativePrototype);
                var that = $93beb66cab49b410$exports(new NativeConstructor(), dummy, Constructor);
                if (!$784d9540a0abf25d$exports(iterable)) $7519ce181fecbd34$exports(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
                return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod("delete");
            fixMethod("has");
            IS_MAP && fixMethod("get");
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }
    exported[CONSTRUCTOR_NAME] = Constructor;
    $0365e955907213bd$exports({
        global: true,
        constructor: true,
        forced: Constructor != NativeConstructor
    }, exported);
    $ec32ac1e3fb4a1a1$exports(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};


var $5c9af116049ea387$exports = {};
"use strict";












var $5c9af116049ea387$require$fastKey = $23b16ea0b64c4091$exports.fastKey;

var $5c9af116049ea387$var$setInternalState = $dbe54846b72f85d1$exports.set;
var $5c9af116049ea387$var$internalStateGetterFor = $dbe54846b72f85d1$exports.getterFor;
$5c9af116049ea387$exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $a5a0f9cce104c4f5$exports(that, Prototype);
            $5c9af116049ea387$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                index: $290768129b19866b$exports(null),
                first: undefined,
                last: undefined,
                size: 0
            });
            if (!$0ab298e69b752e0a$exports) that.size = 0;
            if (!$784d9540a0abf25d$exports(iterable)) $7519ce181fecbd34$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $5c9af116049ea387$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var entry = getEntry(that, key);
            var previous, index;
            // change existing entry
            if (entry) entry.value = value;
            else {
                state.last = entry = {
                    index: index = $5c9af116049ea387$require$fastKey(key, true),
                    key: key,
                    value: value,
                    previous: previous = state.last,
                    next: undefined,
                    removed: false
                };
                if (!state.first) state.first = entry;
                if (previous) previous.next = entry;
                if ($0ab298e69b752e0a$exports) state.size++;
                else that.size++;
                // add to index
                if (index !== "F") state.index[index] = entry;
            }
            return that;
        };
        var getEntry = function(that, key) {
            var state = getInternalState(that);
            // fast case
            var index = $5c9af116049ea387$require$fastKey(key);
            var entry;
            if (index !== "F") return state.index[index];
            // frozen object case
            for(entry = state.first; entry; entry = entry.next){
                if (entry.key == key) return entry;
            }
        };
        $be8b41c0f3f6adf6$exports(Prototype, {
            // `{ Map, Set }.prototype.clear()` methods
            // https://tc39.es/ecma262/#sec-map.prototype.clear
            // https://tc39.es/ecma262/#sec-set.prototype.clear
            clear: function clear() {
                var that = this;
                var state = getInternalState(that);
                var data = state.index;
                var entry = state.first;
                while(entry){
                    entry.removed = true;
                    if (entry.previous) entry.previous = entry.previous.next = undefined;
                    delete data[entry.index];
                    entry = entry.next;
                }
                state.first = state.last = undefined;
                if ($0ab298e69b752e0a$exports) state.size = 0;
                else that.size = 0;
            },
            // `{ Map, Set }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.delete
            // https://tc39.es/ecma262/#sec-set.prototype.delete
            "delete": function(key) {
                var that = this;
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                if (entry) {
                    var next = entry.next;
                    var prev = entry.previous;
                    delete state.index[entry.index];
                    entry.removed = true;
                    if (prev) prev.next = next;
                    if (next) next.previous = prev;
                    if (state.first == entry) state.first = next;
                    if (state.last == entry) state.last = prev;
                    if ($0ab298e69b752e0a$exports) state.size--;
                    else that.size--;
                }
                return !!entry;
            },
            // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.foreach
            // https://tc39.es/ecma262/#sec-set.prototype.foreach
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                var state = getInternalState(this);
                var boundFunction = $130f24665ebee510$exports(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                var entry;
                while(entry = entry ? entry.next : state.first){
                    boundFunction(entry.value, entry.key, this);
                    // revert to the last existing entry
                    while(entry && entry.removed)entry = entry.previous;
                }
            },
            // `{ Map, Set}.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.has
            // https://tc39.es/ecma262/#sec-set.prototype.has
            has: function has(key) {
                return !!getEntry(this, key);
            }
        });
        $be8b41c0f3f6adf6$exports(Prototype, IS_MAP ? {
            // `Map.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-map.prototype.get
            get: function get(key) {
                var entry = getEntry(this, key);
                return entry && entry.value;
            },
            // `Map.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-map.prototype.set
            set: function set(key, value) {
                return define(this, key === 0 ? 0 : key, value);
            }
        } : {
            // `Set.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-set.prototype.add
            add: function add(value) {
                return define(this, value = value === 0 ? 0 : value, value);
            }
        });
        if ($0ab298e69b752e0a$exports) $54b1e35819861675$exports(Prototype, "size", {
            configurable: true,
            get: function() {
                return getInternalState(this).size;
            }
        });
        return Constructor;
    },
    setStrong: function(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
        var ITERATOR_NAME = CONSTRUCTOR_NAME + " Iterator";
        var getInternalCollectionState = $5c9af116049ea387$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var getInternalIteratorState = $5c9af116049ea387$var$internalStateGetterFor(ITERATOR_NAME);
        // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
        // https://tc39.es/ecma262/#sec-map.prototype.entries
        // https://tc39.es/ecma262/#sec-map.prototype.keys
        // https://tc39.es/ecma262/#sec-map.prototype.values
        // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
        // https://tc39.es/ecma262/#sec-set.prototype.entries
        // https://tc39.es/ecma262/#sec-set.prototype.keys
        // https://tc39.es/ecma262/#sec-set.prototype.values
        // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
        $d9091fe3c4cc4bc8$exports(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
            $5c9af116049ea387$var$setInternalState(this, {
                type: ITERATOR_NAME,
                target: iterated,
                state: getInternalCollectionState(iterated),
                kind: kind,
                last: undefined
            });
        }, function() {
            var state = getInternalIteratorState(this);
            var kind = state.kind;
            var entry = state.last;
            // revert to the last existing entry
            while(entry && entry.removed)entry = entry.previous;
            // get next entry
            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                // or finish the iteration
                state.target = undefined;
                return $25360ca3df62dca5$exports(undefined, true);
            }
            // return step by kind
            if (kind == "keys") return $25360ca3df62dca5$exports(entry.key, false);
            if (kind == "values") return $25360ca3df62dca5$exports(entry.value, false);
            return $25360ca3df62dca5$exports([
                entry.key,
                entry.value
            ], false);
        }, IS_MAP ? "entries" : "values", !IS_MAP, true);
        // `{ Map, Set }.prototype[@@species]` accessors
        // https://tc39.es/ecma262/#sec-get-map-@@species
        // https://tc39.es/ecma262/#sec-get-set-@@species
        $60a2ce15ea97c905$exports(CONSTRUCTOR_NAME);
    }
};


// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
$112b243b75bec4f7$exports("Map", function(init) {
    return function Map() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $5c9af116049ea387$exports);





var $3948c8a0f48d44b6$exports = {};
var $3948c8a0f48d44b6$var$log = Math.log;
// `Math.log1p` method implementation
// https://tc39.es/ecma262/#sec-math.log1p
// eslint-disable-next-line es/no-math-log1p -- safe
$3948c8a0f48d44b6$exports = Math.log1p || function log1p(x) {
    var n = +x;
    return n > -0.00000001 && n < 1e-8 ? n - n * n / 2 : $3948c8a0f48d44b6$var$log(1 + n);
};


// eslint-disable-next-line es/no-math-acosh -- required for testing
var $3d6f14c5d14e61d3$var$$acosh = Math.acosh;
var $3d6f14c5d14e61d3$var$log = Math.log;
var $3d6f14c5d14e61d3$var$sqrt = Math.sqrt;
var $3d6f14c5d14e61d3$var$LN2 = Math.LN2;
var $3d6f14c5d14e61d3$var$FORCED = !$3d6f14c5d14e61d3$var$$acosh || Math.floor($3d6f14c5d14e61d3$var$$acosh(Number.MAX_VALUE)) != 710 || $3d6f14c5d14e61d3$var$$acosh(Infinity) != Infinity;
// `Math.acosh` method
// https://tc39.es/ecma262/#sec-math.acosh
$0365e955907213bd$exports({
    target: "Math",
    stat: true,
    forced: $3d6f14c5d14e61d3$var$FORCED
}, {
    acosh: function acosh(x) {
        var n = +x;
        return n < 1 ? NaN : n > 94906265.62425156 ? $3d6f14c5d14e61d3$var$log(n) + $3d6f14c5d14e61d3$var$LN2 : $3948c8a0f48d44b6$exports(n - 1 + $3d6f14c5d14e61d3$var$sqrt(n - 1) * $3d6f14c5d14e61d3$var$sqrt(n + 1));
    }
});



// eslint-disable-next-line es/no-math-asinh -- required for testing
var $9cce6dfe0816c44e$var$$asinh = Math.asinh;
var $9cce6dfe0816c44e$var$log = Math.log;
var $9cce6dfe0816c44e$var$sqrt = Math.sqrt;
function $9cce6dfe0816c44e$var$asinh(x) {
    var n = +x;
    return !isFinite(n) || n == 0 ? n : n < 0 ? -$9cce6dfe0816c44e$var$asinh(-n) : $9cce6dfe0816c44e$var$log(n + $9cce6dfe0816c44e$var$sqrt(n * n + 1));
}
var $9cce6dfe0816c44e$var$FORCED = !($9cce6dfe0816c44e$var$$asinh && 1 / $9cce6dfe0816c44e$var$$asinh(0) > 0);
// `Math.asinh` method
// https://tc39.es/ecma262/#sec-math.asinh
// Tor Browser bug: Math.asinh(0) -> -0
$0365e955907213bd$exports({
    target: "Math",
    stat: true,
    forced: $9cce6dfe0816c44e$var$FORCED
}, {
    asinh: $9cce6dfe0816c44e$var$asinh
});



// eslint-disable-next-line es/no-math-atanh -- required for testing
var $4f491979981e173d$var$$atanh = Math.atanh;
var $4f491979981e173d$var$log = Math.log;
var $4f491979981e173d$var$FORCED = !($4f491979981e173d$var$$atanh && 1 / $4f491979981e173d$var$$atanh(-0) < 0);
// `Math.atanh` method
// https://tc39.es/ecma262/#sec-math.atanh
// Tor Browser bug: Math.atanh(-0) -> 0
$0365e955907213bd$exports({
    target: "Math",
    stat: true,
    forced: $4f491979981e173d$var$FORCED
}, {
    atanh: function atanh(x) {
        var n = +x;
        return n == 0 ? n : $4f491979981e173d$var$log((1 + n) / (1 - n)) / 2;
    }
});



var $a7545cf1eb6150c4$exports = {};
// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe
$a7545cf1eb6150c4$exports = Math.sign || function sign(x) {
    var n = +x;
    // eslint-disable-next-line no-self-compare -- NaN check
    return n == 0 || n != n ? n : n < 0 ? -1 : 1;
};


var $0fc17704c9d3e0bd$var$abs = Math.abs;
var $0fc17704c9d3e0bd$var$pow = Math.pow;
// `Math.cbrt` method
// https://tc39.es/ecma262/#sec-math.cbrt
$0365e955907213bd$exports({
    target: "Math",
    stat: true
}, {
    cbrt: function cbrt(x) {
        var n = +x;
        return $a7545cf1eb6150c4$exports(n) * $0fc17704c9d3e0bd$var$pow($0fc17704c9d3e0bd$var$abs(n), 1 / 3);
    }
});



var $49cab821a68f616c$var$floor = Math.floor;
var $49cab821a68f616c$var$log = Math.log;
var $49cab821a68f616c$var$LOG2E = Math.LOG2E;
// `Math.clz32` method
// https://tc39.es/ecma262/#sec-math.clz32
$0365e955907213bd$exports({
    target: "Math",
    stat: true
}, {
    clz32: function clz32(x) {
        var n = x >>> 0;
        return n ? 31 - $49cab821a68f616c$var$floor($49cab821a68f616c$var$log(n + 0.5) * $49cab821a68f616c$var$LOG2E) : 32;
    }
});



var $12ca5792caac9670$exports = {};
// eslint-disable-next-line es/no-math-expm1 -- safe
var $12ca5792caac9670$var$$expm1 = Math.expm1;
var $12ca5792caac9670$var$exp = Math.exp;
// `Math.expm1` method implementation
// https://tc39.es/ecma262/#sec-math.expm1
$12ca5792caac9670$exports = !$12ca5792caac9670$var$$expm1 || $12ca5792caac9670$var$$expm1(10) > 22025.465794806719 || $12ca5792caac9670$var$$expm1(10) < 22025.4657948067165168 || $12ca5792caac9670$var$$expm1(-0.00000000000000002) != -0.00000000000000002 ? function expm1(x) {
    var n = +x;
    return n == 0 ? n : n > -0.000001 && n < 1e-6 ? n + n * n / 2 : $12ca5792caac9670$var$exp(n) - 1;
} : $12ca5792caac9670$var$$expm1;


// eslint-disable-next-line es/no-math-cosh -- required for testing
var $a32a9728ffe42eb7$var$$cosh = Math.cosh;
var $a32a9728ffe42eb7$var$abs = Math.abs;
var $a32a9728ffe42eb7$var$E = Math.E;
var $a32a9728ffe42eb7$var$FORCED = !$a32a9728ffe42eb7$var$$cosh || $a32a9728ffe42eb7$var$$cosh(710) === Infinity;
// `Math.cosh` method
// https://tc39.es/ecma262/#sec-math.cosh
$0365e955907213bd$exports({
    target: "Math",
    stat: true,
    forced: $a32a9728ffe42eb7$var$FORCED
}, {
    cosh: function cosh(x) {
        var t = $12ca5792caac9670$exports($a32a9728ffe42eb7$var$abs(x) - 1) + 1;
        return (t + 1 / (t * $a32a9728ffe42eb7$var$E * $a32a9728ffe42eb7$var$E)) * ($a32a9728ffe42eb7$var$E / 2);
    }
});




// `Math.expm1` method
// https://tc39.es/ecma262/#sec-math.expm1
// eslint-disable-next-line es/no-math-expm1 -- required for testing
$0365e955907213bd$exports({
    target: "Math",
    stat: true,
    forced: $12ca5792caac9670$exports != Math.expm1
}, {
    expm1: $12ca5792caac9670$exports
});



var $a0f384345c06230f$exports = {};

var $a0f384345c06230f$var$abs = Math.abs;
var $a0f384345c06230f$var$pow = Math.pow;
var $a0f384345c06230f$var$EPSILON = $a0f384345c06230f$var$pow(2, -52);
var $a0f384345c06230f$var$EPSILON32 = $a0f384345c06230f$var$pow(2, -23);
var $a0f384345c06230f$var$MAX32 = $a0f384345c06230f$var$pow(2, 127) * (2 - $a0f384345c06230f$var$EPSILON32);
var $a0f384345c06230f$var$MIN32 = $a0f384345c06230f$var$pow(2, -126);
var $a0f384345c06230f$var$roundTiesToEven = function(n) {
    return n + 1 / $a0f384345c06230f$var$EPSILON - 1 / $a0f384345c06230f$var$EPSILON;
};
// `Math.fround` method implementation
// https://tc39.es/ecma262/#sec-math.fround
// eslint-disable-next-line es/no-math-fround -- safe
$a0f384345c06230f$exports = Math.fround || function fround(x) {
    var n = +x;
    var $abs = $a0f384345c06230f$var$abs(n);
    var $sign = $a7545cf1eb6150c4$exports(n);
    var a, result;
    if ($abs < $a0f384345c06230f$var$MIN32) return $sign * $a0f384345c06230f$var$roundTiesToEven($abs / $a0f384345c06230f$var$MIN32 / $a0f384345c06230f$var$EPSILON32) * $a0f384345c06230f$var$MIN32 * $a0f384345c06230f$var$EPSILON32;
    a = (1 + $a0f384345c06230f$var$EPSILON32 / $a0f384345c06230f$var$EPSILON) * $abs;
    result = a - (a - $abs);
    // eslint-disable-next-line no-self-compare -- NaN check
    if (result > $a0f384345c06230f$var$MAX32 || result != result) return $sign * Infinity;
    return $sign * result;
};


// `Math.fround` method
// https://tc39.es/ecma262/#sec-math.fround
$0365e955907213bd$exports({
    target: "Math",
    stat: true
}, {
    fround: $a0f384345c06230f$exports
});



// eslint-disable-next-line es/no-math-hypot -- required for testing
var $03379eb0f723750b$var$$hypot = Math.hypot;
var $03379eb0f723750b$var$abs = Math.abs;
var $03379eb0f723750b$var$sqrt = Math.sqrt;
// Chrome 77 bug
// https://bugs.chromium.org/p/v8/issues/detail?id=9546
var $03379eb0f723750b$var$FORCED = !!$03379eb0f723750b$var$$hypot && $03379eb0f723750b$var$$hypot(Infinity, NaN) !== Infinity;
// `Math.hypot` method
// https://tc39.es/ecma262/#sec-math.hypot
$0365e955907213bd$exports({
    target: "Math",
    stat: true,
    arity: 2,
    forced: $03379eb0f723750b$var$FORCED
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    hypot: function hypot(value1, value2) {
        var sum = 0;
        var i = 0;
        var aLen = arguments.length;
        var larg = 0;
        var arg, div;
        while(i < aLen){
            arg = $03379eb0f723750b$var$abs(arguments[i++]);
            if (larg < arg) {
                div = larg / arg;
                sum = sum * div * div + 1;
                larg = arg;
            } else if (arg > 0) {
                div = arg / larg;
                sum += div * div;
            } else sum += arg;
        }
        return larg === Infinity ? Infinity : larg * $03379eb0f723750b$var$sqrt(sum);
    }
});




// eslint-disable-next-line es/no-math-imul -- required for testing
var $8f96dd3fec2b2b22$var$$imul = Math.imul;
var $8f96dd3fec2b2b22$var$FORCED = $4cefcb1c1c1fa750$exports(function() {
    return $8f96dd3fec2b2b22$var$$imul(0xFFFFFFFF, 5) != -5 || $8f96dd3fec2b2b22$var$$imul.length != 2;
});
// `Math.imul` method
// https://tc39.es/ecma262/#sec-math.imul
// some WebKit versions fails with big numbers, some has wrong arity
$0365e955907213bd$exports({
    target: "Math",
    stat: true,
    forced: $8f96dd3fec2b2b22$var$FORCED
}, {
    imul: function imul(x, y) {
        var UINT16 = 0xFFFF;
        var xn = +x;
        var yn = +y;
        var xl = UINT16 & xn;
        var yl = UINT16 & yn;
        return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
    }
});



var $471d222518661b8e$exports = {};
var $471d222518661b8e$var$log = Math.log;
var $471d222518661b8e$var$LOG10E = Math.LOG10E;
// eslint-disable-next-line es/no-math-log10 -- safe
$471d222518661b8e$exports = Math.log10 || function log10(x) {
    return $471d222518661b8e$var$log(x) * $471d222518661b8e$var$LOG10E;
};


// `Math.log10` method
// https://tc39.es/ecma262/#sec-math.log10
$0365e955907213bd$exports({
    target: "Math",
    stat: true
}, {
    log10: $471d222518661b8e$exports
});




// `Math.log1p` method
// https://tc39.es/ecma262/#sec-math.log1p
$0365e955907213bd$exports({
    target: "Math",
    stat: true
}, {
    log1p: $3948c8a0f48d44b6$exports
});



var $c753d80ec29d6698$var$log = Math.log;
var $c753d80ec29d6698$var$LN2 = Math.LN2;
// `Math.log2` method
// https://tc39.es/ecma262/#sec-math.log2
$0365e955907213bd$exports({
    target: "Math",
    stat: true
}, {
    log2: function log2(x) {
        return $c753d80ec29d6698$var$log(x) / $c753d80ec29d6698$var$LN2;
    }
});




// `Math.sign` method
// https://tc39.es/ecma262/#sec-math.sign
$0365e955907213bd$exports({
    target: "Math",
    stat: true
}, {
    sign: $a7545cf1eb6150c4$exports
});





var $0b41e7aa18d90490$var$abs = Math.abs;
var $0b41e7aa18d90490$var$exp = Math.exp;
var $0b41e7aa18d90490$var$E = Math.E;
var $0b41e7aa18d90490$var$FORCED = $4cefcb1c1c1fa750$exports(function() {
    // eslint-disable-next-line es/no-math-sinh -- required for testing
    return Math.sinh(-0.00000000000000002) != -0.00000000000000002;
});
// `Math.sinh` method
// https://tc39.es/ecma262/#sec-math.sinh
// V8 near Chromium 38 has a problem with very small numbers
$0365e955907213bd$exports({
    target: "Math",
    stat: true,
    forced: $0b41e7aa18d90490$var$FORCED
}, {
    sinh: function sinh(x) {
        var n = +x;
        return $0b41e7aa18d90490$var$abs(n) < 1 ? ($12ca5792caac9670$exports(n) - $12ca5792caac9670$exports(-n)) / 2 : ($0b41e7aa18d90490$var$exp(n - 1) - $0b41e7aa18d90490$var$exp(-n - 1)) * ($0b41e7aa18d90490$var$E / 2);
    }
});




var $47823b7613c7a7a0$var$exp = Math.exp;
// `Math.tanh` method
// https://tc39.es/ecma262/#sec-math.tanh
$0365e955907213bd$exports({
    target: "Math",
    stat: true
}, {
    tanh: function tanh(x) {
        var n = +x;
        var a = $12ca5792caac9670$exports(n);
        var b = $12ca5792caac9670$exports(-n);
        return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / ($47823b7613c7a7a0$var$exp(n) + $47823b7613c7a7a0$var$exp(-n));
    }
});



// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
$ec32ac1e3fb4a1a1$exports(Math, "Math", true);




// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
$0365e955907213bd$exports({
    target: "Math",
    stat: true
}, {
    trunc: $a71fa4672570b675$exports
});


"use strict";














var $d24686ad7434f920$require$getOwnPropertyNames = $cdc111d4fc429a99$export$2d1720544b23b823;

var $d24686ad7434f920$require$getOwnPropertyDescriptor = $dc708c9bcef7b78f$export$2d1720544b23b823;

var $d24686ad7434f920$require$defineProperty = $783b6a5a940dee05$export$2d1720544b23b823;
var $fcae696fef92609f$exports = {};

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
$fcae696fef92609f$exports = $c510c74e58563f95$exports(1.0.valueOf);


var $414e726332f379ed$exports = {};



var $8028e84d9131b882$exports = {};
// a string of all valid unicode whitespaces
$8028e84d9131b882$exports = "	\n\v\f\r \xa0              　\u2028\u2029\uFEFF";


var $414e726332f379ed$var$replace = $c510c74e58563f95$exports("".replace);
var $414e726332f379ed$var$ltrim = RegExp("^[" + $8028e84d9131b882$exports + "]+");
var $414e726332f379ed$var$rtrim = RegExp("(^|[^" + $8028e84d9131b882$exports + "])[" + $8028e84d9131b882$exports + "]+$");
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $414e726332f379ed$var$createMethod = function(TYPE) {
    return function($this) {
        var string = $53d734af07b69aa7$exports($ac95046ddf1ecaa1$exports($this));
        if (TYPE & 1) string = $414e726332f379ed$var$replace(string, $414e726332f379ed$var$ltrim, "");
        if (TYPE & 2) string = $414e726332f379ed$var$replace(string, $414e726332f379ed$var$rtrim, "$1");
        return string;
    };
};
$414e726332f379ed$exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $414e726332f379ed$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $414e726332f379ed$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $414e726332f379ed$var$createMethod(3)
};


var $d24686ad7434f920$require$trim = $414e726332f379ed$exports.trim;
var $d24686ad7434f920$var$NUMBER = "Number";
var $d24686ad7434f920$var$NativeNumber = $1a6e68c95df7d4df$exports[$d24686ad7434f920$var$NUMBER];
var $d24686ad7434f920$var$PureNumberNamespace = $bee7a5ff7821416e$exports[$d24686ad7434f920$var$NUMBER];
var $d24686ad7434f920$var$NumberPrototype = $d24686ad7434f920$var$NativeNumber.prototype;
var $d24686ad7434f920$var$TypeError = $1a6e68c95df7d4df$exports.TypeError;
var $d24686ad7434f920$var$stringSlice = $c510c74e58563f95$exports("".slice);
var $d24686ad7434f920$var$charCodeAt = $c510c74e58563f95$exports("".charCodeAt);
// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var $d24686ad7434f920$var$toNumeric = function(value) {
    var primValue = $49e56ced23df1333$exports(value, "number");
    return typeof primValue == "bigint" ? primValue : $d24686ad7434f920$var$toNumber(primValue);
};
// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var $d24686ad7434f920$var$toNumber = function(argument) {
    var it = $49e56ced23df1333$exports(argument, "number");
    var first, third, radix, maxCode, digits, length, index, code;
    if ($0d71f82f3bc811d0$exports(it)) throw $d24686ad7434f920$var$TypeError("Cannot convert a Symbol value to a number");
    if (typeof it == "string" && it.length > 2) {
        it = $d24686ad7434f920$require$trim(it);
        first = $d24686ad7434f920$var$charCodeAt(it, 0);
        if (first === 43 || first === 45) {
            third = $d24686ad7434f920$var$charCodeAt(it, 2);
            if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
        } else if (first === 48) {
            switch($d24686ad7434f920$var$charCodeAt(it, 1)){
                case 66:
                case 98:
                    radix = 2;
                    maxCode = 49;
                    break; // fast equal of /^0b[01]+$/i
                case 79:
                case 111:
                    radix = 8;
                    maxCode = 55;
                    break; // fast equal of /^0o[0-7]+$/i
                default:
                    return +it;
            }
            digits = $d24686ad7434f920$var$stringSlice(it, 2);
            length = digits.length;
            for(index = 0; index < length; index++){
                code = $d24686ad7434f920$var$charCodeAt(digits, index);
                // parseInt parses a string to a first unavailable symbol
                // but ToNumber should return NaN if a string contains unavailable symbols
                if (code < 48 || code > maxCode) return NaN;
            }
            return parseInt(digits, radix);
        }
    }
    return +it;
};
var $d24686ad7434f920$var$FORCED = $87321f98e08714ab$exports($d24686ad7434f920$var$NUMBER, !$d24686ad7434f920$var$NativeNumber(" 0o1") || !$d24686ad7434f920$var$NativeNumber("0b1") || $d24686ad7434f920$var$NativeNumber("+0x1"));
var $d24686ad7434f920$var$calledWithNew = function(dummy) {
    // includes check on 1..constructor(foo) case
    return $b82c3d945f0459c1$exports($d24686ad7434f920$var$NumberPrototype, dummy) && $4cefcb1c1c1fa750$exports(function() {
        $fcae696fef92609f$exports(dummy);
    });
};
// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
var $d24686ad7434f920$var$NumberWrapper = function Number(value) {
    var n = arguments.length < 1 ? 0 : $d24686ad7434f920$var$NativeNumber($d24686ad7434f920$var$toNumeric(value));
    return $d24686ad7434f920$var$calledWithNew(this) ? $93beb66cab49b410$exports(Object(n), this, $d24686ad7434f920$var$NumberWrapper) : n;
};
$d24686ad7434f920$var$NumberWrapper.prototype = $d24686ad7434f920$var$NumberPrototype;
if ($d24686ad7434f920$var$FORCED && !$fef1920ae5260386$exports) $d24686ad7434f920$var$NumberPrototype.constructor = $d24686ad7434f920$var$NumberWrapper;
$0365e955907213bd$exports({
    global: true,
    constructor: true,
    wrap: true,
    forced: $d24686ad7434f920$var$FORCED
}, {
    Number: $d24686ad7434f920$var$NumberWrapper
});
// Use `internal/copy-constructor-properties` helper in `core-js@4`
var $d24686ad7434f920$var$copyConstructorProperties = function(target, source) {
    for(var keys = $0ab298e69b752e0a$exports ? $d24686ad7434f920$require$getOwnPropertyNames(source) : // ES3:
    "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(","), j = 0, key; keys.length > j; j++)if ($ef59b581f0d1672b$exports(source, key = keys[j]) && !$ef59b581f0d1672b$exports(target, key)) $d24686ad7434f920$require$defineProperty(target, key, $d24686ad7434f920$require$getOwnPropertyDescriptor(source, key));
};
if ($fef1920ae5260386$exports && $d24686ad7434f920$var$PureNumberNamespace) $d24686ad7434f920$var$copyConstructorProperties($bee7a5ff7821416e$exports[$d24686ad7434f920$var$NUMBER], $d24686ad7434f920$var$PureNumberNamespace);
if ($d24686ad7434f920$var$FORCED || $fef1920ae5260386$exports) $d24686ad7434f920$var$copyConstructorProperties($bee7a5ff7821416e$exports[$d24686ad7434f920$var$NUMBER], $d24686ad7434f920$var$NativeNumber);



// `Number.EPSILON` constant
// https://tc39.es/ecma262/#sec-number.epsilon
$0365e955907213bd$exports({
    target: "Number",
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    EPSILON: Math.pow(2, -52)
});



var $c283f4f7f3fd90de$exports = {};

var $c283f4f7f3fd90de$var$globalIsFinite = $1a6e68c95df7d4df$exports.isFinite;
// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
// eslint-disable-next-line es/no-number-isfinite -- safe
$c283f4f7f3fd90de$exports = Number.isFinite || function isFinite(it) {
    return typeof it == "number" && $c283f4f7f3fd90de$var$globalIsFinite(it);
};


// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
$0365e955907213bd$exports({
    target: "Number",
    stat: true
}, {
    isFinite: $c283f4f7f3fd90de$exports
});



var $7425af5a016c6a9f$exports = {};

var $7425af5a016c6a9f$var$floor = Math.floor;
// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
$7425af5a016c6a9f$exports = Number.isInteger || function isInteger(it) {
    return !$dfdc56bc53f57e69$exports(it) && isFinite(it) && $7425af5a016c6a9f$var$floor(it) === it;
};


// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$0365e955907213bd$exports({
    target: "Number",
    stat: true
}, {
    isInteger: $7425af5a016c6a9f$exports
});



// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
$0365e955907213bd$exports({
    target: "Number",
    stat: true
}, {
    isNaN: function isNaN(number) {
        // eslint-disable-next-line no-self-compare -- NaN check
        return number != number;
    }
});




var $a0787b72c1b76114$var$abs = Math.abs;
// `Number.isSafeInteger` method
// https://tc39.es/ecma262/#sec-number.issafeinteger
$0365e955907213bd$exports({
    target: "Number",
    stat: true
}, {
    isSafeInteger: function isSafeInteger(number) {
        return $7425af5a016c6a9f$exports(number) && $a0787b72c1b76114$var$abs(number) <= 0x1FFFFFFFFFFFFF;
    }
});



// `Number.MAX_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.max_safe_integer
$0365e955907213bd$exports({
    target: "Number",
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
});



// `Number.MIN_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.min_safe_integer
$0365e955907213bd$exports({
    target: "Number",
    stat: true,
    nonConfigurable: true,
    nonWritable: true
}, {
    MIN_SAFE_INTEGER: -9007199254740991
});



var $3d817ce120df96a0$exports = {};





var $3d817ce120df96a0$require$trim = $414e726332f379ed$exports.trim;

var $3d817ce120df96a0$var$charAt = $c510c74e58563f95$exports("".charAt);
var $3d817ce120df96a0$var$$parseFloat = $1a6e68c95df7d4df$exports.parseFloat;
var $3d817ce120df96a0$var$Symbol = $1a6e68c95df7d4df$exports.Symbol;
var $3d817ce120df96a0$var$ITERATOR = $3d817ce120df96a0$var$Symbol && $3d817ce120df96a0$var$Symbol.iterator;
var $3d817ce120df96a0$var$FORCED = 1 / $3d817ce120df96a0$var$$parseFloat($8028e84d9131b882$exports + "-0") !== -Infinity || $3d817ce120df96a0$var$ITERATOR && !$4cefcb1c1c1fa750$exports(function() {
    $3d817ce120df96a0$var$$parseFloat(Object($3d817ce120df96a0$var$ITERATOR));
});
// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$3d817ce120df96a0$exports = $3d817ce120df96a0$var$FORCED ? function parseFloat(string) {
    var trimmedString = $3d817ce120df96a0$require$trim($53d734af07b69aa7$exports(string));
    var result = $3d817ce120df96a0$var$$parseFloat(trimmedString);
    return result === 0 && $3d817ce120df96a0$var$charAt(trimmedString, 0) == "-" ? -0 : result;
} : $3d817ce120df96a0$var$$parseFloat;


// `Number.parseFloat` method
// https://tc39.es/ecma262/#sec-number.parseFloat
// eslint-disable-next-line es/no-number-parsefloat -- required for testing
$0365e955907213bd$exports({
    target: "Number",
    stat: true,
    forced: Number.parseFloat != $3d817ce120df96a0$exports
}, {
    parseFloat: $3d817ce120df96a0$exports
});



var $687b340f6e6848e4$exports = {};





var $687b340f6e6848e4$require$trim = $414e726332f379ed$exports.trim;

var $687b340f6e6848e4$var$$parseInt = $1a6e68c95df7d4df$exports.parseInt;
var $687b340f6e6848e4$var$Symbol = $1a6e68c95df7d4df$exports.Symbol;
var $687b340f6e6848e4$var$ITERATOR = $687b340f6e6848e4$var$Symbol && $687b340f6e6848e4$var$Symbol.iterator;
var $687b340f6e6848e4$var$hex = /^[+-]?0x/i;
var $687b340f6e6848e4$var$exec = $c510c74e58563f95$exports($687b340f6e6848e4$var$hex.exec);
var $687b340f6e6848e4$var$FORCED = $687b340f6e6848e4$var$$parseInt($8028e84d9131b882$exports + "08") !== 8 || $687b340f6e6848e4$var$$parseInt($8028e84d9131b882$exports + "0x16") !== 22 || $687b340f6e6848e4$var$ITERATOR && !$4cefcb1c1c1fa750$exports(function() {
    $687b340f6e6848e4$var$$parseInt(Object($687b340f6e6848e4$var$ITERATOR));
});
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$687b340f6e6848e4$exports = $687b340f6e6848e4$var$FORCED ? function parseInt(string, radix) {
    var S = $687b340f6e6848e4$require$trim($53d734af07b69aa7$exports(string));
    return $687b340f6e6848e4$var$$parseInt(S, radix >>> 0 || ($687b340f6e6848e4$var$exec($687b340f6e6848e4$var$hex, S) ? 16 : 10));
} : $687b340f6e6848e4$var$$parseInt;


// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing
$0365e955907213bd$exports({
    target: "Number",
    stat: true,
    forced: Number.parseInt != $687b340f6e6848e4$exports
}, {
    parseInt: $687b340f6e6848e4$exports
});


"use strict";






var $0fbd987cbf0e9028$var$$RangeError = RangeError;
var $0fbd987cbf0e9028$var$$String = String;
var $0fbd987cbf0e9028$var$floor = Math.floor;
var $0fbd987cbf0e9028$var$repeat = $c510c74e58563f95$exports($42370b6b571de72c$exports);
var $0fbd987cbf0e9028$var$stringSlice = $c510c74e58563f95$exports("".slice);
var $0fbd987cbf0e9028$var$nativeToFixed = $c510c74e58563f95$exports(1.0.toFixed);
var $0fbd987cbf0e9028$var$pow = function(x, n, acc) {
    return n === 0 ? acc : n % 2 === 1 ? $0fbd987cbf0e9028$var$pow(x, n - 1, acc * x) : $0fbd987cbf0e9028$var$pow(x * x, n / 2, acc);
};
var $0fbd987cbf0e9028$var$log = function(x) {
    var n = 0;
    var x2 = x;
    while(x2 >= 4096){
        n += 12;
        x2 /= 4096;
    }
    while(x2 >= 2){
        n += 1;
        x2 /= 2;
    }
    return n;
};
var $0fbd987cbf0e9028$var$multiply = function(data, n, c) {
    var index = -1;
    var c2 = c;
    while(++index < 6){
        c2 += n * data[index];
        data[index] = c2 % 1e7;
        c2 = $0fbd987cbf0e9028$var$floor(c2 / 1e7);
    }
};
var $0fbd987cbf0e9028$var$divide = function(data, n) {
    var index = 6;
    var c = 0;
    while(--index >= 0){
        c += data[index];
        data[index] = $0fbd987cbf0e9028$var$floor(c / n);
        c = c % n * 1e7;
    }
};
var $0fbd987cbf0e9028$var$dataToString = function(data) {
    var index = 6;
    var s = "";
    while(--index >= 0)if (s !== "" || index === 0 || data[index] !== 0) {
        var t = $0fbd987cbf0e9028$var$$String(data[index]);
        s = s === "" ? t : s + $0fbd987cbf0e9028$var$repeat("0", 7 - t.length) + t;
    }
    return s;
};
var $0fbd987cbf0e9028$var$FORCED = $4cefcb1c1c1fa750$exports(function() {
    return $0fbd987cbf0e9028$var$nativeToFixed(0.00008, 3) !== "0.000" || $0fbd987cbf0e9028$var$nativeToFixed(0.9, 0) !== "1" || $0fbd987cbf0e9028$var$nativeToFixed(1.255, 2) !== "1.25" || $0fbd987cbf0e9028$var$nativeToFixed(1000000000000000128.0, 0) !== "1000000000000000128";
}) || !$4cefcb1c1c1fa750$exports(function() {
    // V8 ~ Android 4.3-
    $0fbd987cbf0e9028$var$nativeToFixed({});
});
// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$0365e955907213bd$exports({
    target: "Number",
    proto: true,
    forced: $0fbd987cbf0e9028$var$FORCED
}, {
    toFixed: function toFixed(fractionDigits) {
        var number = $fcae696fef92609f$exports(this);
        var fractDigits = $7167297f49b8d757$exports(fractionDigits);
        var data = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var sign = "";
        var result = "0";
        var e, z, j, k;
        // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
        if (fractDigits < 0 || fractDigits > 20) throw $0fbd987cbf0e9028$var$$RangeError("Incorrect fraction digits");
        // eslint-disable-next-line no-self-compare -- NaN check
        if (number != number) return "NaN";
        if (number <= -1000000000000000000000 || number >= 1e21) return $0fbd987cbf0e9028$var$$String(number);
        if (number < 0) {
            sign = "-";
            number = -number;
        }
        if (number > 1e-21) {
            e = $0fbd987cbf0e9028$var$log(number * $0fbd987cbf0e9028$var$pow(2, 69, 1)) - 69;
            z = e < 0 ? number * $0fbd987cbf0e9028$var$pow(2, -e, 1) : number / $0fbd987cbf0e9028$var$pow(2, e, 1);
            z *= 0x10000000000000;
            e = 52 - e;
            if (e > 0) {
                $0fbd987cbf0e9028$var$multiply(data, 0, z);
                j = fractDigits;
                while(j >= 7){
                    $0fbd987cbf0e9028$var$multiply(data, 1e7, 0);
                    j -= 7;
                }
                $0fbd987cbf0e9028$var$multiply(data, $0fbd987cbf0e9028$var$pow(10, j, 1), 0);
                j = e - 1;
                while(j >= 23){
                    $0fbd987cbf0e9028$var$divide(data, 8388608);
                    j -= 23;
                }
                $0fbd987cbf0e9028$var$divide(data, 1 << j);
                $0fbd987cbf0e9028$var$multiply(data, 1, 1);
                $0fbd987cbf0e9028$var$divide(data, 2);
                result = $0fbd987cbf0e9028$var$dataToString(data);
            } else {
                $0fbd987cbf0e9028$var$multiply(data, 0, z);
                $0fbd987cbf0e9028$var$multiply(data, 1 << -e, 0);
                result = $0fbd987cbf0e9028$var$dataToString(data) + $0fbd987cbf0e9028$var$repeat("0", fractDigits);
            }
        }
        if (fractDigits > 0) {
            k = result.length;
            result = sign + (k <= fractDigits ? "0." + $0fbd987cbf0e9028$var$repeat("0", fractDigits - k) + result : $0fbd987cbf0e9028$var$stringSlice(result, 0, k - fractDigits) + "." + $0fbd987cbf0e9028$var$stringSlice(result, k - fractDigits));
        } else result = sign + result;
        return result;
    }
});


"use strict";




var $fa86843a30406ffe$var$nativeToPrecision = $c510c74e58563f95$exports(1.0.toPrecision);
var $fa86843a30406ffe$var$FORCED = $4cefcb1c1c1fa750$exports(function() {
    // IE7-
    return $fa86843a30406ffe$var$nativeToPrecision(1, undefined) !== "1";
}) || !$4cefcb1c1c1fa750$exports(function() {
    // V8 ~ Android 4.3-
    $fa86843a30406ffe$var$nativeToPrecision({});
});
// `Number.prototype.toPrecision` method
// https://tc39.es/ecma262/#sec-number.prototype.toprecision
$0365e955907213bd$exports({
    target: "Number",
    proto: true,
    forced: $fa86843a30406ffe$var$FORCED
}, {
    toPrecision: function toPrecision(precision) {
        return precision === undefined ? $fa86843a30406ffe$var$nativeToPrecision($fcae696fef92609f$exports(this)) : $fa86843a30406ffe$var$nativeToPrecision($fcae696fef92609f$exports(this), precision);
    }
});



var $450e0c3510042936$exports = {};
"use strict";









// eslint-disable-next-line es/no-object-assign -- safe
var $450e0c3510042936$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $450e0c3510042936$var$defineProperty = Object.defineProperty;
var $450e0c3510042936$var$concat = $c510c74e58563f95$exports([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
$450e0c3510042936$exports = !$450e0c3510042936$var$$assign || $4cefcb1c1c1fa750$exports(function() {
    // should have correct order of operations (Edge bug)
    if ($0ab298e69b752e0a$exports && $450e0c3510042936$var$$assign({
        b: 1
    }, $450e0c3510042936$var$$assign($450e0c3510042936$var$defineProperty({}, "a", {
        enumerable: true,
        get: function() {
            $450e0c3510042936$var$defineProperty(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol();
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $450e0c3510042936$var$$assign({}, A)[symbol] != 7 || $8fa2ece3d22ab2a0$exports($450e0c3510042936$var$$assign({}, B)).join("") != alphabet;
}) ? function assign(target, source) {
    var T = $cc6f28a96f61f0ea$exports(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $8d61c7ace25f8e17$export$2d1720544b23b823;
    var propertyIsEnumerable = $369ff2248a9e8d32$export$2d1720544b23b823;
    while(argumentsLength > index){
        var S = $77acd9fe92ee403a$exports(arguments[index++]);
        var keys = getOwnPropertySymbols ? $450e0c3510042936$var$concat($8fa2ece3d22ab2a0$exports(S), getOwnPropertySymbols(S)) : $8fa2ece3d22ab2a0$exports(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$0ab298e69b752e0a$exports || $3b5393d57c251c61$exports(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $450e0c3510042936$var$$assign;


// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$0365e955907213bd$exports({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $450e0c3510042936$exports
}, {
    assign: $450e0c3510042936$exports
});


// TODO: Remove from `core-js@4`



// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
$0365e955907213bd$exports({
    target: "Object",
    stat: true,
    sham: !$0ab298e69b752e0a$exports
}, {
    create: $290768129b19866b$exports
});


"use strict";


var $bd1b4b0484c07053$exports = {};
"use strict";




// Forced replacement object prototype accessors methods
$bd1b4b0484c07053$exports = $fef1920ae5260386$exports || !$4cefcb1c1c1fa750$exports(function() {
    // This feature detection crashes old WebKit
    // https://github.com/zloirock/core-js/issues/232
    if ($b8c60ffaf51233fe$exports && $b8c60ffaf51233fe$exports < 535) return;
    var key = Math.random();
    // In FF throws only define methods
    // eslint-disable-next-line no-undef, no-useless-call, es/no-legacy-object-prototype-accessor-methods -- required for testing
    __defineSetter__.call(null, key, function() {});
    delete $1a6e68c95df7d4df$exports[key];
});





// `Object.prototype.__defineGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineGetter__
if ($0ab298e69b752e0a$exports) $0365e955907213bd$exports({
    target: "Object",
    proto: true,
    forced: $bd1b4b0484c07053$exports
}, {
    __defineGetter__: function __defineGetter__(P, getter) {
        $783b6a5a940dee05$export$2d1720544b23b823($cc6f28a96f61f0ea$exports(this), P, {
            get: $4a6b57cf563748d0$exports(getter),
            enumerable: true,
            configurable: true
        });
    }
});





var $cc0fbfdc498f5570$require$defineProperties = $43b765e73dea31e3$export$2d1720544b23b823;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$0365e955907213bd$exports({
    target: "Object",
    stat: true,
    forced: Object.defineProperties !== $cc0fbfdc498f5570$require$defineProperties,
    sham: !$0ab298e69b752e0a$exports
}, {
    defineProperties: $cc0fbfdc498f5570$require$defineProperties
});





var $8e3b4fdabfab6a6f$require$defineProperty = $783b6a5a940dee05$export$2d1720544b23b823;
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
// eslint-disable-next-line es/no-object-defineproperty -- safe
$0365e955907213bd$exports({
    target: "Object",
    stat: true,
    forced: Object.defineProperty !== $8e3b4fdabfab6a6f$require$defineProperty,
    sham: !$0ab298e69b752e0a$exports
}, {
    defineProperty: $8e3b4fdabfab6a6f$require$defineProperty
});


"use strict";






// `Object.prototype.__defineSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineSetter__
if ($0ab298e69b752e0a$exports) $0365e955907213bd$exports({
    target: "Object",
    proto: true,
    forced: $bd1b4b0484c07053$exports
}, {
    __defineSetter__: function __defineSetter__(P, setter) {
        $783b6a5a940dee05$export$2d1720544b23b823($cc6f28a96f61f0ea$exports(this), P, {
            set: $4a6b57cf563748d0$exports(setter),
            enumerable: true,
            configurable: true
        });
    }
});



var $751626df7d55f102$exports = {};





var $751626df7d55f102$require$$propertyIsEnumerable = $369ff2248a9e8d32$export$2d1720544b23b823;
var $751626df7d55f102$var$propertyIsEnumerable = $c510c74e58563f95$exports($751626df7d55f102$require$$propertyIsEnumerable);
var $751626df7d55f102$var$push = $c510c74e58563f95$exports([].push);
// `Object.{ entries, values }` methods implementation
var $751626df7d55f102$var$createMethod = function(TO_ENTRIES) {
    return function(it) {
        var O = $b497231b90dfbcaa$exports(it);
        var keys = $8fa2ece3d22ab2a0$exports(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$0ab298e69b752e0a$exports || $751626df7d55f102$var$propertyIsEnumerable(O, key)) $751626df7d55f102$var$push(result, TO_ENTRIES ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};
$751626df7d55f102$exports = {
    // `Object.entries` method
    // https://tc39.es/ecma262/#sec-object.entries
    entries: $751626df7d55f102$var$createMethod(true),
    // `Object.values` method
    // https://tc39.es/ecma262/#sec-object.values
    values: $751626df7d55f102$var$createMethod(false)
};


var $2935794866680abc$require$$entries = $751626df7d55f102$exports.entries;
// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$0365e955907213bd$exports({
    target: "Object",
    stat: true
}, {
    entries: function entries(O) {
        return $2935794866680abc$require$$entries(O);
    }
});







var $995ad6b786320465$require$onFreeze = $23b16ea0b64c4091$exports.onFreeze;
// eslint-disable-next-line es/no-object-freeze -- safe
var $995ad6b786320465$var$$freeze = Object.freeze;
var $995ad6b786320465$var$FAILS_ON_PRIMITIVES = $4cefcb1c1c1fa750$exports(function() {
    $995ad6b786320465$var$$freeze(1);
});
// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$0365e955907213bd$exports({
    target: "Object",
    stat: true,
    forced: $995ad6b786320465$var$FAILS_ON_PRIMITIVES,
    sham: !$e00e52bc2d436bf2$exports
}, {
    freeze: function freeze(it) {
        return $995ad6b786320465$var$$freeze && $dfdc56bc53f57e69$exports(it) ? $995ad6b786320465$var$$freeze($995ad6b786320465$require$onFreeze(it)) : it;
    }
});





// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$0365e955907213bd$exports({
    target: "Object",
    stat: true
}, {
    fromEntries: function fromEntries(iterable) {
        var obj = {};
        $7519ce181fecbd34$exports(iterable, function(k, v) {
            $1d4c3fb4ee6719a3$exports(obj, k, v);
        }, {
            AS_ENTRIES: true
        });
        return obj;
    }
});






var $2f1c78b25757c199$require$nativeGetOwnPropertyDescriptor = $dc708c9bcef7b78f$export$2d1720544b23b823;

var $2f1c78b25757c199$var$FORCED = !$0ab298e69b752e0a$exports || $4cefcb1c1c1fa750$exports(function() {
    $2f1c78b25757c199$require$nativeGetOwnPropertyDescriptor(1);
});
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$0365e955907213bd$exports({
    target: "Object",
    stat: true,
    forced: $2f1c78b25757c199$var$FORCED,
    sham: !$0ab298e69b752e0a$exports
}, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
        return $2f1c78b25757c199$require$nativeGetOwnPropertyDescriptor($b497231b90dfbcaa$exports(it), key);
    }
});








// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$0365e955907213bd$exports({
    target: "Object",
    stat: true,
    sham: !$0ab298e69b752e0a$exports
}, {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
        var O = $b497231b90dfbcaa$exports(object);
        var getOwnPropertyDescriptor = $dc708c9bcef7b78f$export$2d1720544b23b823;
        var keys = $99a285ce7f6da130$exports(O);
        var result = {};
        var index = 0;
        var key, descriptor;
        while(keys.length > index){
            descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
            if (descriptor !== undefined) $1d4c3fb4ee6719a3$exports(result, key, descriptor);
        }
        return result;
    }
});





var $787ce749751a2666$require$getOwnPropertyNames = $2c014ad5d62fc6d4$export$2d1720544b23b823;
// eslint-disable-next-line es/no-object-getownpropertynames -- required for testing
var $787ce749751a2666$var$FAILS_ON_PRIMITIVES = $4cefcb1c1c1fa750$exports(function() {
    return !Object.getOwnPropertyNames(1);
});
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
$0365e955907213bd$exports({
    target: "Object",
    stat: true,
    forced: $787ce749751a2666$var$FAILS_ON_PRIMITIVES
}, {
    getOwnPropertyNames: $787ce749751a2666$require$getOwnPropertyNames
});







var $6c44f8b799a91bd4$var$FAILS_ON_PRIMITIVES = $4cefcb1c1c1fa750$exports(function() {
    $a30ba929b298478d$exports(1);
});
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$0365e955907213bd$exports({
    target: "Object",
    stat: true,
    forced: $6c44f8b799a91bd4$var$FAILS_ON_PRIMITIVES,
    sham: !$4636f67dfb0688c7$exports
}, {
    getPrototypeOf: function getPrototypeOf(it) {
        return $a30ba929b298478d$exports($cc6f28a96f61f0ea$exports(it));
    }
});



var $1e9f246f8dc0eea3$exports = {};
// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
$1e9f246f8dc0eea3$exports = Object.is || function is(x, y) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


// `Object.is` method
// https://tc39.es/ecma262/#sec-object.is
$0365e955907213bd$exports({
    target: "Object",
    stat: true
}, {
    is: $1e9f246f8dc0eea3$exports
});




// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
// eslint-disable-next-line es/no-object-isextensible -- safe
$0365e955907213bd$exports({
    target: "Object",
    stat: true,
    forced: Object.isExtensible !== $e5cb1b88d7f5b8cb$exports
}, {
    isExtensible: $e5cb1b88d7f5b8cb$exports
});







// eslint-disable-next-line es/no-object-isfrozen -- safe
var $6aa01496fbcbd6e6$var$$isFrozen = Object.isFrozen;
var $6aa01496fbcbd6e6$var$FORCED = $a7395b80581c8cc5$exports || $4cefcb1c1c1fa750$exports(function() {
    $6aa01496fbcbd6e6$var$$isFrozen(1);
});
// `Object.isFrozen` method
// https://tc39.es/ecma262/#sec-object.isfrozen
$0365e955907213bd$exports({
    target: "Object",
    stat: true,
    forced: $6aa01496fbcbd6e6$var$FORCED
}, {
    isFrozen: function isFrozen(it) {
        if (!$dfdc56bc53f57e69$exports(it)) return true;
        if ($a7395b80581c8cc5$exports && $ee4d29ebca1023f3$exports(it) == "ArrayBuffer") return true;
        return $6aa01496fbcbd6e6$var$$isFrozen ? $6aa01496fbcbd6e6$var$$isFrozen(it) : false;
    }
});







// eslint-disable-next-line es/no-object-issealed -- safe
var $e3b8162e4ba81399$var$$isSealed = Object.isSealed;
var $e3b8162e4ba81399$var$FORCED = $a7395b80581c8cc5$exports || $4cefcb1c1c1fa750$exports(function() {
    $e3b8162e4ba81399$var$$isSealed(1);
});
// `Object.isSealed` method
// https://tc39.es/ecma262/#sec-object.issealed
$0365e955907213bd$exports({
    target: "Object",
    stat: true,
    forced: $e3b8162e4ba81399$var$FORCED
}, {
    isSealed: function isSealed(it) {
        if (!$dfdc56bc53f57e69$exports(it)) return true;
        if ($a7395b80581c8cc5$exports && $ee4d29ebca1023f3$exports(it) == "ArrayBuffer") return true;
        return $e3b8162e4ba81399$var$$isSealed ? $e3b8162e4ba81399$var$$isSealed(it) : false;
    }
});






var $7121af2641c2872a$var$FAILS_ON_PRIMITIVES = $4cefcb1c1c1fa750$exports(function() {
    $8fa2ece3d22ab2a0$exports(1);
});
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$0365e955907213bd$exports({
    target: "Object",
    stat: true,
    forced: $7121af2641c2872a$var$FAILS_ON_PRIMITIVES
}, {
    keys: function keys(it) {
        return $8fa2ece3d22ab2a0$exports($cc6f28a96f61f0ea$exports(it));
    }
});


"use strict";







var $7ea00dbb0af08258$require$getOwnPropertyDescriptor = $dc708c9bcef7b78f$export$2d1720544b23b823;
// `Object.prototype.__lookupGetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupGetter__
if ($0ab298e69b752e0a$exports) $0365e955907213bd$exports({
    target: "Object",
    proto: true,
    forced: $bd1b4b0484c07053$exports
}, {
    __lookupGetter__: function __lookupGetter__(P) {
        var O = $cc6f28a96f61f0ea$exports(this);
        var key = $df8c871456bcdfdf$exports(P);
        var desc;
        do {
            if (desc = $7ea00dbb0af08258$require$getOwnPropertyDescriptor(O, key)) return desc.get;
        }while (O = $a30ba929b298478d$exports(O));
    }
});


"use strict";







var $69225ada49f639b5$require$getOwnPropertyDescriptor = $dc708c9bcef7b78f$export$2d1720544b23b823;
// `Object.prototype.__lookupSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupSetter__
if ($0ab298e69b752e0a$exports) $0365e955907213bd$exports({
    target: "Object",
    proto: true,
    forced: $bd1b4b0484c07053$exports
}, {
    __lookupSetter__: function __lookupSetter__(P) {
        var O = $cc6f28a96f61f0ea$exports(this);
        var key = $df8c871456bcdfdf$exports(P);
        var desc;
        do {
            if (desc = $69225ada49f639b5$require$getOwnPropertyDescriptor(O, key)) return desc.set;
        }while (O = $a30ba929b298478d$exports(O));
    }
});





var $729039159b7ac606$require$onFreeze = $23b16ea0b64c4091$exports.onFreeze;


// eslint-disable-next-line es/no-object-preventextensions -- safe
var $729039159b7ac606$var$$preventExtensions = Object.preventExtensions;
var $729039159b7ac606$var$FAILS_ON_PRIMITIVES = $4cefcb1c1c1fa750$exports(function() {
    $729039159b7ac606$var$$preventExtensions(1);
});
// `Object.preventExtensions` method
// https://tc39.es/ecma262/#sec-object.preventextensions
$0365e955907213bd$exports({
    target: "Object",
    stat: true,
    forced: $729039159b7ac606$var$FAILS_ON_PRIMITIVES,
    sham: !$e00e52bc2d436bf2$exports
}, {
    preventExtensions: function preventExtensions(it) {
        return $729039159b7ac606$var$$preventExtensions && $dfdc56bc53f57e69$exports(it) ? $729039159b7ac606$var$$preventExtensions($729039159b7ac606$require$onFreeze(it)) : it;
    }
});





var $64def055ada81251$require$onFreeze = $23b16ea0b64c4091$exports.onFreeze;


// eslint-disable-next-line es/no-object-seal -- safe
var $64def055ada81251$var$$seal = Object.seal;
var $64def055ada81251$var$FAILS_ON_PRIMITIVES = $4cefcb1c1c1fa750$exports(function() {
    $64def055ada81251$var$$seal(1);
});
// `Object.seal` method
// https://tc39.es/ecma262/#sec-object.seal
$0365e955907213bd$exports({
    target: "Object",
    stat: true,
    forced: $64def055ada81251$var$FAILS_ON_PRIMITIVES,
    sham: !$e00e52bc2d436bf2$exports
}, {
    seal: function seal(it) {
        return $64def055ada81251$var$$seal && $dfdc56bc53f57e69$exports(it) ? $64def055ada81251$var$$seal($64def055ada81251$require$onFreeze(it)) : it;
    }
});




// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$0365e955907213bd$exports({
    target: "Object",
    stat: true
}, {
    setPrototypeOf: $a922355a1bcefb04$exports
});




var $10af2dc5ad531e9c$exports = {};
"use strict";


// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
$10af2dc5ad531e9c$exports = $8753fad30d68c98e$exports ? ({}).toString : function toString() {
    return "[object " + $79ec051cbbc13a5e$exports(this) + "]";
};


// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!$8753fad30d68c98e$exports) $eeb1abced7a4b5b5$exports(Object.prototype, "toString", $10af2dc5ad531e9c$exports, {
    unsafe: true
});




var $7a985c968e61bb2a$require$$values = $751626df7d55f102$exports.values;
// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$0365e955907213bd$exports({
    target: "Object",
    stat: true
}, {
    values: function values(O) {
        return $7a985c968e61bb2a$require$$values(O);
    }
});




// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$0365e955907213bd$exports({
    global: true,
    forced: parseFloat != $3d817ce120df96a0$exports
}, {
    parseFloat: $3d817ce120df96a0$exports
});




// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$0365e955907213bd$exports({
    global: true,
    forced: parseInt != $687b340f6e6848e4$exports
}, {
    parseInt: $687b340f6e6848e4$exports
});


// TODO: Remove this module from `core-js@4` since it's split to modules listed below
"use strict";














var $80e525653e14cf75$exports = {};









var $f035ac7c9e51e69e$exports = {};
var $f035ac7c9e51e69e$var$$TypeError = TypeError;
$f035ac7c9e51e69e$exports = function(passed, required) {
    if (passed < required) throw $f035ac7c9e51e69e$var$$TypeError("Not enough arguments");
    return passed;
};


var $b3e1cc5a0df92eb8$exports = {};

// eslint-disable-next-line redos/no-vulnerable -- safe
$b3e1cc5a0df92eb8$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($59d28ac8b8f97183$exports);



var $80e525653e14cf75$var$set = $1a6e68c95df7d4df$exports.setImmediate;
var $80e525653e14cf75$var$clear = $1a6e68c95df7d4df$exports.clearImmediate;
var $80e525653e14cf75$var$process = $1a6e68c95df7d4df$exports.process;
var $80e525653e14cf75$var$Dispatch = $1a6e68c95df7d4df$exports.Dispatch;
var $80e525653e14cf75$var$Function = $1a6e68c95df7d4df$exports.Function;
var $80e525653e14cf75$var$MessageChannel = $1a6e68c95df7d4df$exports.MessageChannel;
var $80e525653e14cf75$var$String = $1a6e68c95df7d4df$exports.String;
var $80e525653e14cf75$var$counter = 0;
var $80e525653e14cf75$var$queue = {};
var $80e525653e14cf75$var$ONREADYSTATECHANGE = "onreadystatechange";
var $80e525653e14cf75$var$$location, $80e525653e14cf75$var$defer, $80e525653e14cf75$var$channel, $80e525653e14cf75$var$port;
$4cefcb1c1c1fa750$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $80e525653e14cf75$var$$location = $1a6e68c95df7d4df$exports.location;
});
var $80e525653e14cf75$var$run = function(id) {
    if ($ef59b581f0d1672b$exports($80e525653e14cf75$var$queue, id)) {
        var fn = $80e525653e14cf75$var$queue[id];
        delete $80e525653e14cf75$var$queue[id];
        fn();
    }
};
var $80e525653e14cf75$var$runner = function(id) {
    return function() {
        $80e525653e14cf75$var$run(id);
    };
};
var $80e525653e14cf75$var$eventListener = function(event) {
    $80e525653e14cf75$var$run(event.data);
};
var $80e525653e14cf75$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $1a6e68c95df7d4df$exports.postMessage($80e525653e14cf75$var$String(id), $80e525653e14cf75$var$$location.protocol + "//" + $80e525653e14cf75$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$80e525653e14cf75$var$set || !$80e525653e14cf75$var$clear) {
    $80e525653e14cf75$var$set = function setImmediate(handler) {
        $f035ac7c9e51e69e$exports(arguments.length, 1);
        var fn = $c1d5f87f1e56c4cc$exports(handler) ? handler : $80e525653e14cf75$var$Function(handler);
        var args = $05068435b6a808dd$exports(arguments, 1);
        $80e525653e14cf75$var$queue[++$80e525653e14cf75$var$counter] = function() {
            $17764d41e6b47061$exports(fn, undefined, args);
        };
        $80e525653e14cf75$var$defer($80e525653e14cf75$var$counter);
        return $80e525653e14cf75$var$counter;
    };
    $80e525653e14cf75$var$clear = function clearImmediate(id) {
        delete $80e525653e14cf75$var$queue[id];
    };
    // Node.js 0.8-
    if ($9eb47e38a97c42de$exports) $80e525653e14cf75$var$defer = function(id) {
        $80e525653e14cf75$var$process.nextTick($80e525653e14cf75$var$runner(id));
    };
    else if ($80e525653e14cf75$var$Dispatch && $80e525653e14cf75$var$Dispatch.now) $80e525653e14cf75$var$defer = function(id) {
        $80e525653e14cf75$var$Dispatch.now($80e525653e14cf75$var$runner(id));
    };
    else if ($80e525653e14cf75$var$MessageChannel && !$b3e1cc5a0df92eb8$exports) {
        $80e525653e14cf75$var$channel = new $80e525653e14cf75$var$MessageChannel();
        $80e525653e14cf75$var$port = $80e525653e14cf75$var$channel.port2;
        $80e525653e14cf75$var$channel.port1.onmessage = $80e525653e14cf75$var$eventListener;
        $80e525653e14cf75$var$defer = $130f24665ebee510$exports($80e525653e14cf75$var$port.postMessage, $80e525653e14cf75$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($1a6e68c95df7d4df$exports.addEventListener && $c1d5f87f1e56c4cc$exports($1a6e68c95df7d4df$exports.postMessage) && !$1a6e68c95df7d4df$exports.importScripts && $80e525653e14cf75$var$$location && $80e525653e14cf75$var$$location.protocol !== "file:" && !$4cefcb1c1c1fa750$exports($80e525653e14cf75$var$globalPostMessageDefer)) {
        $80e525653e14cf75$var$defer = $80e525653e14cf75$var$globalPostMessageDefer;
        $1a6e68c95df7d4df$exports.addEventListener("message", $80e525653e14cf75$var$eventListener, false);
    // IE8-
    } else if ($80e525653e14cf75$var$ONREADYSTATECHANGE in $50f1c27ed88e8707$exports("script")) $80e525653e14cf75$var$defer = function(id) {
        $c923381aa0cbb3ad$exports.appendChild($50f1c27ed88e8707$exports("script"))[$80e525653e14cf75$var$ONREADYSTATECHANGE] = function() {
            $c923381aa0cbb3ad$exports.removeChild(this);
            $80e525653e14cf75$var$run(id);
        };
    };
    else $80e525653e14cf75$var$defer = function(id) {
        setTimeout($80e525653e14cf75$var$runner(id), 0);
    };
}
$80e525653e14cf75$exports = {
    set: $80e525653e14cf75$var$set,
    clear: $80e525653e14cf75$var$clear
};


var $abb03eab05ca18b6$require$task = $80e525653e14cf75$exports.set;
var $5cb8439839cdfcfe$exports = {};



var $5cb8439839cdfcfe$require$getOwnPropertyDescriptor = $dc708c9bcef7b78f$export$2d1720544b23b823;

var $5cb8439839cdfcfe$require$macrotask = $80e525653e14cf75$exports.set;
var $7f17cb7ac3fa1431$exports = {};
var $7f17cb7ac3fa1431$var$Queue = function() {
    this.head = null;
    this.tail = null;
};
$7f17cb7ac3fa1431$var$Queue.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        var tail = this.tail;
        if (tail) tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            var next = this.head = entry.next;
            if (next === null) this.tail = null;
            return entry.item;
        }
    }
};
$7f17cb7ac3fa1431$exports = $7f17cb7ac3fa1431$var$Queue;



var $778762fc77d0ea39$exports = {};

$778762fc77d0ea39$exports = /ipad|iphone|ipod/i.test($59d28ac8b8f97183$exports) && typeof Pebble != "undefined";


var $b3d4c85412513373$exports = {};

$b3d4c85412513373$exports = /web0s(?!.*chrome)/i.test($59d28ac8b8f97183$exports);



var $5cb8439839cdfcfe$var$MutationObserver = $1a6e68c95df7d4df$exports.MutationObserver || $1a6e68c95df7d4df$exports.WebKitMutationObserver;
var $5cb8439839cdfcfe$var$document = $1a6e68c95df7d4df$exports.document;
var $5cb8439839cdfcfe$var$process = $1a6e68c95df7d4df$exports.process;
var $5cb8439839cdfcfe$var$Promise = $1a6e68c95df7d4df$exports.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $5cb8439839cdfcfe$var$queueMicrotaskDescriptor = $5cb8439839cdfcfe$require$getOwnPropertyDescriptor($1a6e68c95df7d4df$exports, "queueMicrotask");
var $5cb8439839cdfcfe$var$microtask = $5cb8439839cdfcfe$var$queueMicrotaskDescriptor && $5cb8439839cdfcfe$var$queueMicrotaskDescriptor.value;
var $5cb8439839cdfcfe$var$notify, $5cb8439839cdfcfe$var$toggle, $5cb8439839cdfcfe$var$node, $5cb8439839cdfcfe$var$promise, $5cb8439839cdfcfe$var$then;
// modern engines have queueMicrotask method
if (!$5cb8439839cdfcfe$var$microtask) {
    var $5cb8439839cdfcfe$var$queue = new $7f17cb7ac3fa1431$exports();
    var $5cb8439839cdfcfe$var$flush = function() {
        var parent, fn;
        if ($9eb47e38a97c42de$exports && (parent = $5cb8439839cdfcfe$var$process.domain)) parent.exit();
        while(fn = $5cb8439839cdfcfe$var$queue.get())try {
            fn();
        } catch (error) {
            if ($5cb8439839cdfcfe$var$queue.head) $5cb8439839cdfcfe$var$notify();
            throw error;
        }
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$b3e1cc5a0df92eb8$exports && !$9eb47e38a97c42de$exports && !$b3d4c85412513373$exports && $5cb8439839cdfcfe$var$MutationObserver && $5cb8439839cdfcfe$var$document) {
        $5cb8439839cdfcfe$var$toggle = true;
        $5cb8439839cdfcfe$var$node = $5cb8439839cdfcfe$var$document.createTextNode("");
        new $5cb8439839cdfcfe$var$MutationObserver($5cb8439839cdfcfe$var$flush).observe($5cb8439839cdfcfe$var$node, {
            characterData: true
        });
        $5cb8439839cdfcfe$var$notify = function() {
            $5cb8439839cdfcfe$var$node.data = $5cb8439839cdfcfe$var$toggle = !$5cb8439839cdfcfe$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$778762fc77d0ea39$exports && $5cb8439839cdfcfe$var$Promise && $5cb8439839cdfcfe$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $5cb8439839cdfcfe$var$promise = $5cb8439839cdfcfe$var$Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $5cb8439839cdfcfe$var$promise.constructor = $5cb8439839cdfcfe$var$Promise;
        $5cb8439839cdfcfe$var$then = $130f24665ebee510$exports($5cb8439839cdfcfe$var$promise.then, $5cb8439839cdfcfe$var$promise);
        $5cb8439839cdfcfe$var$notify = function() {
            $5cb8439839cdfcfe$var$then($5cb8439839cdfcfe$var$flush);
        };
    // Node.js without promises
    } else if ($9eb47e38a97c42de$exports) $5cb8439839cdfcfe$var$notify = function() {
        $5cb8439839cdfcfe$var$process.nextTick($5cb8439839cdfcfe$var$flush);
    };
    else {
        // `webpack` dev server bug on IE global methods - use bind(fn, global)
        $5cb8439839cdfcfe$require$macrotask = $130f24665ebee510$exports($5cb8439839cdfcfe$require$macrotask, $1a6e68c95df7d4df$exports);
        $5cb8439839cdfcfe$var$notify = function() {
            $5cb8439839cdfcfe$require$macrotask($5cb8439839cdfcfe$var$flush);
        };
    }
    $5cb8439839cdfcfe$var$microtask = function(fn) {
        if (!$5cb8439839cdfcfe$var$queue.head) $5cb8439839cdfcfe$var$notify();
        $5cb8439839cdfcfe$var$queue.add(fn);
    };
}
$5cb8439839cdfcfe$exports = $5cb8439839cdfcfe$var$microtask;


var $ef84f76b07949076$exports = {};
$ef84f76b07949076$exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length == 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};


var $14002cd4988fb917$exports = {};
$14002cd4988fb917$exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};




var $37136c29bd486c9f$exports = {};

$37136c29bd486c9f$exports = $1a6e68c95df7d4df$exports.Promise;


var $3c99de021ee04639$exports = {};






var $8dfa793d31e3850d$exports = {};
var $919b2117c56aa774$exports = {};
/* global Deno -- Deno case */ $919b2117c56aa774$exports = typeof Deno == "object" && Deno && typeof Deno.version == "object";



$8dfa793d31e3850d$exports = !$919b2117c56aa774$exports && !$9eb47e38a97c42de$exports && typeof window == "object" && typeof document == "object";





var $3c99de021ee04639$var$NativePromisePrototype = $37136c29bd486c9f$exports && $37136c29bd486c9f$exports.prototype;
var $3c99de021ee04639$var$SPECIES = $5cfcb69f0877711f$exports("species");
var $3c99de021ee04639$var$SUBCLASSING = false;
var $3c99de021ee04639$var$NATIVE_PROMISE_REJECTION_EVENT = $c1d5f87f1e56c4cc$exports($1a6e68c95df7d4df$exports.PromiseRejectionEvent);
var $3c99de021ee04639$var$FORCED_PROMISE_CONSTRUCTOR = $87321f98e08714ab$exports("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $1076c59a7c633d48$exports($37136c29bd486c9f$exports);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($37136c29bd486c9f$exports);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $44f41d0bd747502d$exports === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if ($fef1920ae5260386$exports && !($3c99de021ee04639$var$NativePromisePrototype["catch"] && $3c99de021ee04639$var$NativePromisePrototype["finally"])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!$44f41d0bd747502d$exports || $44f41d0bd747502d$exports < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new $37136c29bd486c9f$exports(function(resolve) {
            resolve(1);
        });
        var FakePromise = function(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[$3c99de021ee04639$var$SPECIES] = FakePromise;
        $3c99de021ee04639$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!$3c99de021ee04639$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && ($8dfa793d31e3850d$exports || $919b2117c56aa774$exports) && !$3c99de021ee04639$var$NATIVE_PROMISE_REJECTION_EVENT;
});
$3c99de021ee04639$exports = {
    CONSTRUCTOR: $3c99de021ee04639$var$FORCED_PROMISE_CONSTRUCTOR,
    REJECTION_EVENT: $3c99de021ee04639$var$NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: $3c99de021ee04639$var$SUBCLASSING
};


// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $7c20825aa9833af8$export$2d1720544b23b823;
"use strict";

var $7c20825aa9833af8$var$$TypeError = TypeError;
var $7c20825aa9833af8$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw $7c20825aa9833af8$var$$TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $4a6b57cf563748d0$exports(resolve);
    this.reject = $4a6b57cf563748d0$exports(reject);
};
$7c20825aa9833af8$export$2d1720544b23b823 = function(C) {
    return new $7c20825aa9833af8$var$PromiseCapability(C);
};


var $abb03eab05ca18b6$var$PROMISE = "Promise";
var $abb03eab05ca18b6$var$FORCED_PROMISE_CONSTRUCTOR = $3c99de021ee04639$exports.CONSTRUCTOR;
var $abb03eab05ca18b6$var$NATIVE_PROMISE_REJECTION_EVENT = $3c99de021ee04639$exports.REJECTION_EVENT;
var $abb03eab05ca18b6$var$NATIVE_PROMISE_SUBCLASSING = $3c99de021ee04639$exports.SUBCLASSING;
var $abb03eab05ca18b6$var$getInternalPromiseState = $dbe54846b72f85d1$exports.getterFor($abb03eab05ca18b6$var$PROMISE);
var $abb03eab05ca18b6$var$setInternalState = $dbe54846b72f85d1$exports.set;
var $abb03eab05ca18b6$var$NativePromisePrototype = $37136c29bd486c9f$exports && $37136c29bd486c9f$exports.prototype;
var $abb03eab05ca18b6$var$PromiseConstructor = $37136c29bd486c9f$exports;
var $abb03eab05ca18b6$var$PromisePrototype = $abb03eab05ca18b6$var$NativePromisePrototype;
var $abb03eab05ca18b6$var$TypeError = $1a6e68c95df7d4df$exports.TypeError;
var $abb03eab05ca18b6$var$document = $1a6e68c95df7d4df$exports.document;
var $abb03eab05ca18b6$var$process = $1a6e68c95df7d4df$exports.process;
var $abb03eab05ca18b6$var$newPromiseCapability = $7c20825aa9833af8$export$2d1720544b23b823;
var $abb03eab05ca18b6$var$newGenericPromiseCapability = $abb03eab05ca18b6$var$newPromiseCapability;
var $abb03eab05ca18b6$var$DISPATCH_EVENT = !!($abb03eab05ca18b6$var$document && $abb03eab05ca18b6$var$document.createEvent && $1a6e68c95df7d4df$exports.dispatchEvent);
var $abb03eab05ca18b6$var$UNHANDLED_REJECTION = "unhandledrejection";
var $abb03eab05ca18b6$var$REJECTION_HANDLED = "rejectionhandled";
var $abb03eab05ca18b6$var$PENDING = 0;
var $abb03eab05ca18b6$var$FULFILLED = 1;
var $abb03eab05ca18b6$var$REJECTED = 2;
var $abb03eab05ca18b6$var$HANDLED = 1;
var $abb03eab05ca18b6$var$UNHANDLED = 2;
var $abb03eab05ca18b6$var$Internal, $abb03eab05ca18b6$var$OwnPromiseCapability, $abb03eab05ca18b6$var$PromiseWrapper, $abb03eab05ca18b6$var$nativeThen;
// helpers
var $abb03eab05ca18b6$var$isThenable = function(it) {
    var then;
    return $dfdc56bc53f57e69$exports(it) && $c1d5f87f1e56c4cc$exports(then = it.then) ? then : false;
};
var $abb03eab05ca18b6$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state == $abb03eab05ca18b6$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $abb03eab05ca18b6$var$UNHANDLED) $abb03eab05ca18b6$var$onHandleUnhandled(state);
                state.rejection = $abb03eab05ca18b6$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject($abb03eab05ca18b6$var$TypeError("Promise-chain cycle"));
            else if (then = $abb03eab05ca18b6$var$isThenable(result)) $3b5393d57c251c61$exports(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $abb03eab05ca18b6$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $5cb8439839cdfcfe$exports(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$abb03eab05ca18b6$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $abb03eab05ca18b6$var$onUnhandled(state);
    });
};
var $abb03eab05ca18b6$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($abb03eab05ca18b6$var$DISPATCH_EVENT) {
        event = $abb03eab05ca18b6$var$document.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $1a6e68c95df7d4df$exports.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$abb03eab05ca18b6$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $1a6e68c95df7d4df$exports["on" + name])) handler(event);
    else if (name === $abb03eab05ca18b6$var$UNHANDLED_REJECTION) $ef84f76b07949076$exports("Unhandled promise rejection", reason);
};
var $abb03eab05ca18b6$var$onUnhandled = function(state) {
    $3b5393d57c251c61$exports($abb03eab05ca18b6$require$task, $1a6e68c95df7d4df$exports, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $abb03eab05ca18b6$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $14002cd4988fb917$exports(function() {
                if ($9eb47e38a97c42de$exports) $abb03eab05ca18b6$var$process.emit("unhandledRejection", value, promise);
                else $abb03eab05ca18b6$var$dispatchEvent($abb03eab05ca18b6$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $9eb47e38a97c42de$exports || $abb03eab05ca18b6$var$isUnhandled(state) ? $abb03eab05ca18b6$var$UNHANDLED : $abb03eab05ca18b6$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $abb03eab05ca18b6$var$isUnhandled = function(state) {
    return state.rejection !== $abb03eab05ca18b6$var$HANDLED && !state.parent;
};
var $abb03eab05ca18b6$var$onHandleUnhandled = function(state) {
    $3b5393d57c251c61$exports($abb03eab05ca18b6$require$task, $1a6e68c95df7d4df$exports, function() {
        var promise = state.facade;
        if ($9eb47e38a97c42de$exports) $abb03eab05ca18b6$var$process.emit("rejectionHandled", promise);
        else $abb03eab05ca18b6$var$dispatchEvent($abb03eab05ca18b6$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $abb03eab05ca18b6$var$bind = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $abb03eab05ca18b6$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $abb03eab05ca18b6$var$REJECTED;
    $abb03eab05ca18b6$var$notify(state, true);
};
var $abb03eab05ca18b6$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw $abb03eab05ca18b6$var$TypeError("Promise can't be resolved itself");
        var then = $abb03eab05ca18b6$var$isThenable(value);
        if (then) $5cb8439839cdfcfe$exports(function() {
            var wrapper = {
                done: false
            };
            try {
                $3b5393d57c251c61$exports(then, value, $abb03eab05ca18b6$var$bind($abb03eab05ca18b6$var$internalResolve, wrapper, state), $abb03eab05ca18b6$var$bind($abb03eab05ca18b6$var$internalReject, wrapper, state));
            } catch (error) {
                $abb03eab05ca18b6$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $abb03eab05ca18b6$var$FULFILLED;
            $abb03eab05ca18b6$var$notify(state, false);
        }
    } catch (error) {
        $abb03eab05ca18b6$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($abb03eab05ca18b6$var$FORCED_PROMISE_CONSTRUCTOR) {
    // 25.4.3.1 Promise(executor)
    $abb03eab05ca18b6$var$PromiseConstructor = function Promise(executor) {
        $a5a0f9cce104c4f5$exports(this, $abb03eab05ca18b6$var$PromisePrototype);
        $4a6b57cf563748d0$exports(executor);
        $3b5393d57c251c61$exports($abb03eab05ca18b6$var$Internal, this);
        var state = $abb03eab05ca18b6$var$getInternalPromiseState(this);
        try {
            executor($abb03eab05ca18b6$var$bind($abb03eab05ca18b6$var$internalResolve, state), $abb03eab05ca18b6$var$bind($abb03eab05ca18b6$var$internalReject, state));
        } catch (error) {
            $abb03eab05ca18b6$var$internalReject(state, error);
        }
    };
    $abb03eab05ca18b6$var$PromisePrototype = $abb03eab05ca18b6$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $abb03eab05ca18b6$var$Internal = function Promise(executor) {
        $abb03eab05ca18b6$var$setInternalState(this, {
            type: $abb03eab05ca18b6$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $7f17cb7ac3fa1431$exports(),
            rejection: false,
            state: $abb03eab05ca18b6$var$PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $abb03eab05ca18b6$var$Internal.prototype = $eeb1abced7a4b5b5$exports($abb03eab05ca18b6$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $abb03eab05ca18b6$var$getInternalPromiseState(this);
        var reaction = $abb03eab05ca18b6$var$newPromiseCapability($a926216b9de7547b$exports(this, $abb03eab05ca18b6$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $c1d5f87f1e56c4cc$exports(onFulfilled) ? onFulfilled : true;
        reaction.fail = $c1d5f87f1e56c4cc$exports(onRejected) && onRejected;
        reaction.domain = $9eb47e38a97c42de$exports ? $abb03eab05ca18b6$var$process.domain : undefined;
        if (state.state == $abb03eab05ca18b6$var$PENDING) state.reactions.add(reaction);
        else $5cb8439839cdfcfe$exports(function() {
            $abb03eab05ca18b6$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $abb03eab05ca18b6$var$OwnPromiseCapability = function() {
        var promise = new $abb03eab05ca18b6$var$Internal();
        var state = $abb03eab05ca18b6$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $abb03eab05ca18b6$var$bind($abb03eab05ca18b6$var$internalResolve, state);
        this.reject = $abb03eab05ca18b6$var$bind($abb03eab05ca18b6$var$internalReject, state);
    };
    $7c20825aa9833af8$export$2d1720544b23b823 = $abb03eab05ca18b6$var$newPromiseCapability = function(C) {
        return C === $abb03eab05ca18b6$var$PromiseConstructor || C === $abb03eab05ca18b6$var$PromiseWrapper ? new $abb03eab05ca18b6$var$OwnPromiseCapability(C) : $abb03eab05ca18b6$var$newGenericPromiseCapability(C);
    };
    if (!$fef1920ae5260386$exports && $c1d5f87f1e56c4cc$exports($37136c29bd486c9f$exports) && $abb03eab05ca18b6$var$NativePromisePrototype !== Object.prototype) {
        $abb03eab05ca18b6$var$nativeThen = $abb03eab05ca18b6$var$NativePromisePrototype.then;
        if (!$abb03eab05ca18b6$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $eeb1abced7a4b5b5$exports($abb03eab05ca18b6$var$NativePromisePrototype, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $abb03eab05ca18b6$var$PromiseConstructor(function(resolve, reject) {
                $3b5393d57c251c61$exports($abb03eab05ca18b6$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $abb03eab05ca18b6$var$NativePromisePrototype.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($a922355a1bcefb04$exports) $a922355a1bcefb04$exports($abb03eab05ca18b6$var$NativePromisePrototype, $abb03eab05ca18b6$var$PromisePrototype);
    }
}
$0365e955907213bd$exports({
    global: true,
    constructor: true,
    wrap: true,
    forced: $abb03eab05ca18b6$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    Promise: $abb03eab05ca18b6$var$PromiseConstructor
});
$ec32ac1e3fb4a1a1$exports($abb03eab05ca18b6$var$PromiseConstructor, $abb03eab05ca18b6$var$PROMISE, false, true);
$60a2ce15ea97c905$exports($abb03eab05ca18b6$var$PROMISE);


"use strict";






var $40af44efa5338817$exports = {};



var $40af44efa5338817$require$FORCED_PROMISE_CONSTRUCTOR = $3c99de021ee04639$exports.CONSTRUCTOR;
$40af44efa5338817$exports = $40af44efa5338817$require$FORCED_PROMISE_CONSTRUCTOR || !$cc6f301ab97f18d4$exports(function(iterable) {
    $37136c29bd486c9f$exports.all(iterable).then(undefined, function() {});
});


// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$0365e955907213bd$exports({
    target: "Promise",
    stat: true,
    forced: $40af44efa5338817$exports
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $7c20825aa9833af8$export$2d1720544b23b823(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $14002cd4988fb917$exports(function() {
            var $promiseResolve = $4a6b57cf563748d0$exports(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $7519ce181fecbd34$exports(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $3b5393d57c251c61$exports($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});


"use strict";



var $3179b55d68020e31$require$FORCED_PROMISE_CONSTRUCTOR = $3c99de021ee04639$exports.CONSTRUCTOR;




var $3179b55d68020e31$var$NativePromisePrototype = $37136c29bd486c9f$exports && $37136c29bd486c9f$exports.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$0365e955907213bd$exports({
    target: "Promise",
    proto: true,
    forced: $3179b55d68020e31$require$FORCED_PROMISE_CONSTRUCTOR,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!$fef1920ae5260386$exports && $c1d5f87f1e56c4cc$exports($37136c29bd486c9f$exports)) {
    var $3179b55d68020e31$var$method = $ba2da80b68ee643e$exports("Promise").prototype["catch"];
    if ($3179b55d68020e31$var$NativePromisePrototype["catch"] !== $3179b55d68020e31$var$method) $eeb1abced7a4b5b5$exports($3179b55d68020e31$var$NativePromisePrototype, "catch", $3179b55d68020e31$var$method, {
        unsafe: true
    });
}


"use strict";







// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$0365e955907213bd$exports({
    target: "Promise",
    stat: true,
    forced: $40af44efa5338817$exports
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $7c20825aa9833af8$export$2d1720544b23b823(C);
        var reject = capability.reject;
        var result = $14002cd4988fb917$exports(function() {
            var $promiseResolve = $4a6b57cf563748d0$exports(C.resolve);
            $7519ce181fecbd34$exports(iterable, function(promise) {
                $3b5393d57c251c61$exports($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});


"use strict";




var $9ae533ab858f8105$require$FORCED_PROMISE_CONSTRUCTOR = $3c99de021ee04639$exports.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$0365e955907213bd$exports({
    target: "Promise",
    stat: true,
    forced: $9ae533ab858f8105$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    reject: function reject(r) {
        var capability = $7c20825aa9833af8$export$2d1720544b23b823(this);
        $3b5393d57c251c61$exports(capability.reject, undefined, r);
        return capability.promise;
    }
});


"use strict";





var $d19895244de85db3$require$FORCED_PROMISE_CONSTRUCTOR = $3c99de021ee04639$exports.CONSTRUCTOR;
var $940857d37c6f0112$exports = {};



$940857d37c6f0112$exports = function(C, x) {
    $830db860a045bbb5$exports(C);
    if ($dfdc56bc53f57e69$exports(x) && x.constructor === C) return x;
    var promiseCapability = $7c20825aa9833af8$export$2d1720544b23b823(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};


var $d19895244de85db3$var$PromiseConstructorWrapper = $ba2da80b68ee643e$exports("Promise");
var $d19895244de85db3$var$CHECK_WRAPPER = $fef1920ae5260386$exports && !$d19895244de85db3$require$FORCED_PROMISE_CONSTRUCTOR;
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$0365e955907213bd$exports({
    target: "Promise",
    stat: true,
    forced: $fef1920ae5260386$exports || $d19895244de85db3$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $940857d37c6f0112$exports($d19895244de85db3$var$CHECK_WRAPPER && this === $d19895244de85db3$var$PromiseConstructorWrapper ? $37136c29bd486c9f$exports : this, x);
    }
});




"use strict";









var $e3605c42391e62e1$var$NativePromisePrototype = $37136c29bd486c9f$exports && $37136c29bd486c9f$exports.prototype;
// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var $e3605c42391e62e1$var$NON_GENERIC = !!$37136c29bd486c9f$exports && $4cefcb1c1c1fa750$exports(function() {
    // eslint-disable-next-line unicorn/no-thenable -- required for testing
    $e3605c42391e62e1$var$NativePromisePrototype["finally"].call({
        then: function() {}
    }, function() {});
});
// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$0365e955907213bd$exports({
    target: "Promise",
    proto: true,
    real: true,
    forced: $e3605c42391e62e1$var$NON_GENERIC
}, {
    "finally": function(onFinally) {
        var C = $a926216b9de7547b$exports(this, $ba2da80b68ee643e$exports("Promise"));
        var isFunction = $c1d5f87f1e56c4cc$exports(onFinally);
        return this.then(isFunction ? function(x) {
            return $940857d37c6f0112$exports(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $940857d37c6f0112$exports(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});
// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!$fef1920ae5260386$exports && $c1d5f87f1e56c4cc$exports($37136c29bd486c9f$exports)) {
    var $e3605c42391e62e1$var$method = $ba2da80b68ee643e$exports("Promise").prototype["finally"];
    if ($e3605c42391e62e1$var$NativePromisePrototype["finally"] !== $e3605c42391e62e1$var$method) $eeb1abced7a4b5b5$exports($e3605c42391e62e1$var$NativePromisePrototype, "finally", $e3605c42391e62e1$var$method, {
        unsafe: true
    });
}







// MS Edge argumentsList argument is optional
var $93a858bd92bd604d$var$OPTIONAL_ARGUMENTS_LIST = !$4cefcb1c1c1fa750$exports(function() {
    // eslint-disable-next-line es/no-reflect -- required for testing
    Reflect.apply(function() {});
});
// `Reflect.apply` method
// https://tc39.es/ecma262/#sec-reflect.apply
$0365e955907213bd$exports({
    target: "Reflect",
    stat: true,
    forced: $93a858bd92bd604d$var$OPTIONAL_ARGUMENTS_LIST
}, {
    apply: function apply(target, thisArgument, argumentsList) {
        return $17764d41e6b47061$exports($4a6b57cf563748d0$exports(target), thisArgument, $830db860a045bbb5$exports(argumentsList));
    }
});











var $e4603b994fe465e0$var$nativeConstruct = $ba2da80b68ee643e$exports("Reflect", "construct");
var $e4603b994fe465e0$var$ObjectPrototype = Object.prototype;
var $e4603b994fe465e0$var$push = [].push;
// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var $e4603b994fe465e0$var$NEW_TARGET_BUG = $4cefcb1c1c1fa750$exports(function() {
    function F() {}
    return !($e4603b994fe465e0$var$nativeConstruct(function() {}, [], F) instanceof F);
});
var $e4603b994fe465e0$var$ARGS_BUG = !$4cefcb1c1c1fa750$exports(function() {
    $e4603b994fe465e0$var$nativeConstruct(function() {});
});
var $e4603b994fe465e0$var$FORCED = $e4603b994fe465e0$var$NEW_TARGET_BUG || $e4603b994fe465e0$var$ARGS_BUG;
$0365e955907213bd$exports({
    target: "Reflect",
    stat: true,
    forced: $e4603b994fe465e0$var$FORCED,
    sham: $e4603b994fe465e0$var$FORCED
}, {
    construct: function construct(Target, args /* , newTarget */ ) {
        $7cef700a0727b620$exports(Target);
        $830db860a045bbb5$exports(args);
        var newTarget = arguments.length < 3 ? Target : $7cef700a0727b620$exports(arguments[2]);
        if ($e4603b994fe465e0$var$ARGS_BUG && !$e4603b994fe465e0$var$NEW_TARGET_BUG) return $e4603b994fe465e0$var$nativeConstruct(Target, args, newTarget);
        if (Target == newTarget) {
            // w/o altered newTarget, optimization for 0-4 arguments
            switch(args.length){
                case 0:
                    return new Target();
                case 1:
                    return new Target(args[0]);
                case 2:
                    return new Target(args[0], args[1]);
                case 3:
                    return new Target(args[0], args[1], args[2]);
                case 4:
                    return new Target(args[0], args[1], args[2], args[3]);
            }
            // w/o altered newTarget, lot of arguments case
            var $args = [
                null
            ];
            $17764d41e6b47061$exports($e4603b994fe465e0$var$push, $args, args);
            return new ($17764d41e6b47061$exports($2e10dedf6e7e691c$exports, Target, $args))();
        }
        // with altered newTarget, not support built-in constructors
        var proto = newTarget.prototype;
        var instance = $290768129b19866b$exports($dfdc56bc53f57e69$exports(proto) ? proto : $e4603b994fe465e0$var$ObjectPrototype);
        var result = $17764d41e6b47061$exports(Target, instance, args);
        return $dfdc56bc53f57e69$exports(result) ? result : instance;
    }
});








// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
var $672e977bb734a115$var$ERROR_INSTEAD_OF_FALSE = $4cefcb1c1c1fa750$exports(function() {
    // eslint-disable-next-line es/no-reflect -- required for testing
    Reflect.defineProperty($783b6a5a940dee05$export$2d1720544b23b823({}, 1, {
        value: 1
    }), 1, {
        value: 2
    });
});
// `Reflect.defineProperty` method
// https://tc39.es/ecma262/#sec-reflect.defineproperty
$0365e955907213bd$exports({
    target: "Reflect",
    stat: true,
    forced: $672e977bb734a115$var$ERROR_INSTEAD_OF_FALSE,
    sham: !$0ab298e69b752e0a$exports
}, {
    defineProperty: function defineProperty(target, propertyKey, attributes) {
        $830db860a045bbb5$exports(target);
        var key = $df8c871456bcdfdf$exports(propertyKey);
        $830db860a045bbb5$exports(attributes);
        try {
            $783b6a5a940dee05$export$2d1720544b23b823(target, key, attributes);
            return true;
        } catch (error) {
            return false;
        }
    }
});





var $edf9afe84d85199c$require$getOwnPropertyDescriptor = $dc708c9bcef7b78f$export$2d1720544b23b823;
// `Reflect.deleteProperty` method
// https://tc39.es/ecma262/#sec-reflect.deleteproperty
$0365e955907213bd$exports({
    target: "Reflect",
    stat: true
}, {
    deleteProperty: function deleteProperty(target, propertyKey) {
        var descriptor = $edf9afe84d85199c$require$getOwnPropertyDescriptor($830db860a045bbb5$exports(target), propertyKey);
        return descriptor && !descriptor.configurable ? false : delete target[propertyKey];
    }
});






var $cb9a5790f24fe77e$exports = {};

$cb9a5790f24fe77e$exports = function(descriptor) {
    return descriptor !== undefined && ($ef59b581f0d1672b$exports(descriptor, "value") || $ef59b581f0d1672b$exports(descriptor, "writable"));
};




// `Reflect.get` method
// https://tc39.es/ecma262/#sec-reflect.get
function $843ecb837656b695$var$get(target, propertyKey /* , receiver */ ) {
    var receiver = arguments.length < 3 ? target : arguments[2];
    var descriptor, prototype;
    if ($830db860a045bbb5$exports(target) === receiver) return target[propertyKey];
    descriptor = $dc708c9bcef7b78f$export$2d1720544b23b823(target, propertyKey);
    if (descriptor) return $cb9a5790f24fe77e$exports(descriptor) ? descriptor.value : descriptor.get === undefined ? undefined : $3b5393d57c251c61$exports(descriptor.get, receiver);
    if ($dfdc56bc53f57e69$exports(prototype = $a30ba929b298478d$exports(target))) return $843ecb837656b695$var$get(prototype, propertyKey, receiver);
}
$0365e955907213bd$exports({
    target: "Reflect",
    stat: true
}, {
    get: $843ecb837656b695$var$get
});






// `Reflect.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-reflect.getownpropertydescriptor
$0365e955907213bd$exports({
    target: "Reflect",
    stat: true,
    sham: !$0ab298e69b752e0a$exports
}, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
        return $dc708c9bcef7b78f$export$2d1720544b23b823($830db860a045bbb5$exports(target), propertyKey);
    }
});






// `Reflect.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.getprototypeof
$0365e955907213bd$exports({
    target: "Reflect",
    stat: true,
    sham: !$4636f67dfb0688c7$exports
}, {
    getPrototypeOf: function getPrototypeOf(target) {
        return $a30ba929b298478d$exports($830db860a045bbb5$exports(target));
    }
});



// `Reflect.has` method
// https://tc39.es/ecma262/#sec-reflect.has
$0365e955907213bd$exports({
    target: "Reflect",
    stat: true
}, {
    has: function has(target, propertyKey) {
        return propertyKey in target;
    }
});





// `Reflect.isExtensible` method
// https://tc39.es/ecma262/#sec-reflect.isextensible
$0365e955907213bd$exports({
    target: "Reflect",
    stat: true
}, {
    isExtensible: function isExtensible(target) {
        $830db860a045bbb5$exports(target);
        return $e5cb1b88d7f5b8cb$exports(target);
    }
});




// `Reflect.ownKeys` method
// https://tc39.es/ecma262/#sec-reflect.ownkeys
$0365e955907213bd$exports({
    target: "Reflect",
    stat: true
}, {
    ownKeys: $99a285ce7f6da130$exports
});






// `Reflect.preventExtensions` method
// https://tc39.es/ecma262/#sec-reflect.preventextensions
$0365e955907213bd$exports({
    target: "Reflect",
    stat: true,
    sham: !$e00e52bc2d436bf2$exports
}, {
    preventExtensions: function preventExtensions(target) {
        $830db860a045bbb5$exports(target);
        try {
            var objectPreventExtensions = $ba2da80b68ee643e$exports("Object", "preventExtensions");
            if (objectPreventExtensions) objectPreventExtensions(target);
            return true;
        } catch (error) {
            return false;
        }
    }
});












// `Reflect.set` method
// https://tc39.es/ecma262/#sec-reflect.set
function $7aad524a04a521e5$var$set(target, propertyKey, V /* , receiver */ ) {
    var receiver = arguments.length < 4 ? target : arguments[3];
    var ownDescriptor = $dc708c9bcef7b78f$export$2d1720544b23b823($830db860a045bbb5$exports(target), propertyKey);
    var existingDescriptor, prototype, setter;
    if (!ownDescriptor) {
        if ($dfdc56bc53f57e69$exports(prototype = $a30ba929b298478d$exports(target))) return $7aad524a04a521e5$var$set(prototype, propertyKey, V, receiver);
        ownDescriptor = $d6bcb34392440d40$exports(0);
    }
    if ($cb9a5790f24fe77e$exports(ownDescriptor)) {
        if (ownDescriptor.writable === false || !$dfdc56bc53f57e69$exports(receiver)) return false;
        if (existingDescriptor = $dc708c9bcef7b78f$export$2d1720544b23b823(receiver, propertyKey)) {
            if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
            existingDescriptor.value = V;
            $783b6a5a940dee05$export$2d1720544b23b823(receiver, propertyKey, existingDescriptor);
        } else $783b6a5a940dee05$export$2d1720544b23b823(receiver, propertyKey, $d6bcb34392440d40$exports(0, V));
    } else {
        setter = ownDescriptor.set;
        if (setter === undefined) return false;
        $3b5393d57c251c61$exports(setter, receiver, V);
    }
    return true;
}
// MS Edge 17-18 Reflect.set allows setting the property to object
// with non-writable property on the prototype
var $7aad524a04a521e5$var$MS_EDGE_BUG = $4cefcb1c1c1fa750$exports(function() {
    var Constructor = function() {};
    var object = $783b6a5a940dee05$export$2d1720544b23b823(new Constructor(), "a", {
        configurable: true
    });
    // eslint-disable-next-line es/no-reflect -- required for testing
    return Reflect.set(Constructor.prototype, "a", 1, object) !== false;
});
$0365e955907213bd$exports({
    target: "Reflect",
    stat: true,
    forced: $7aad524a04a521e5$var$MS_EDGE_BUG
}, {
    set: $7aad524a04a521e5$var$set
});






// `Reflect.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.setprototypeof
if ($a922355a1bcefb04$exports) $0365e955907213bd$exports({
    target: "Reflect",
    stat: true
}, {
    setPrototypeOf: function setPrototypeOf(target, proto) {
        $830db860a045bbb5$exports(target);
        $a6e7af22227d61ef$exports(proto);
        try {
            $a922355a1bcefb04$exports(target, proto);
            return true;
        } catch (error) {
            return false;
        }
    }
});









var $cd590ddc760cba04$require$getOwnPropertyNames = $cdc111d4fc429a99$export$2d1720544b23b823;

var $c9cb68697881ddf0$exports = {};



var $c9cb68697881ddf0$var$MATCH = $5cfcb69f0877711f$exports("match");
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
$c9cb68697881ddf0$exports = function(it) {
    var isRegExp;
    return $dfdc56bc53f57e69$exports(it) && ((isRegExp = it[$c9cb68697881ddf0$var$MATCH]) !== undefined ? !!isRegExp : $ee4d29ebca1023f3$exports(it) == "RegExp");
};



var $147846bfa9e9c5c4$exports = {};



var $f38526c7c8e4b4dc$exports = {};
"use strict";

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$f38526c7c8e4b4dc$exports = function() {
    var that = $830db860a045bbb5$exports(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};


var $147846bfa9e9c5c4$var$RegExpPrototype = RegExp.prototype;
$147846bfa9e9c5c4$exports = function(R) {
    var flags = R.flags;
    return flags === undefined && !("flags" in $147846bfa9e9c5c4$var$RegExpPrototype) && !$ef59b581f0d1672b$exports(R, "flags") && $b82c3d945f0459c1$exports($147846bfa9e9c5c4$var$RegExpPrototype, R) ? $3b5393d57c251c61$exports($f38526c7c8e4b4dc$exports, R) : flags;
};


var $21b967d847dbc4bc$exports = {};


// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $21b967d847dbc4bc$var$$RegExp = $1a6e68c95df7d4df$exports.RegExp;
var $21b967d847dbc4bc$var$UNSUPPORTED_Y = $4cefcb1c1c1fa750$exports(function() {
    var re = $21b967d847dbc4bc$var$$RegExp("a", "y");
    re.lastIndex = 2;
    return re.exec("abcd") != null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $21b967d847dbc4bc$var$MISSED_STICKY = $21b967d847dbc4bc$var$UNSUPPORTED_Y || $4cefcb1c1c1fa750$exports(function() {
    return !$21b967d847dbc4bc$var$$RegExp("a", "y").sticky;
});
var $21b967d847dbc4bc$var$BROKEN_CARET = $21b967d847dbc4bc$var$UNSUPPORTED_Y || $4cefcb1c1c1fa750$exports(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $21b967d847dbc4bc$var$$RegExp("^r", "gy");
    re.lastIndex = 2;
    return re.exec("str") != null;
});
$21b967d847dbc4bc$exports = {
    BROKEN_CARET: $21b967d847dbc4bc$var$BROKEN_CARET,
    MISSED_STICKY: $21b967d847dbc4bc$var$MISSED_STICKY,
    UNSUPPORTED_Y: $21b967d847dbc4bc$var$UNSUPPORTED_Y
};


var $4232ba3c32a60c70$exports = {};

var $4232ba3c32a60c70$require$defineProperty = $783b6a5a940dee05$export$2d1720544b23b823;
$4232ba3c32a60c70$exports = function(Target, Source, key) {
    key in Target || $4232ba3c32a60c70$require$defineProperty(Target, key, {
        configurable: true,
        get: function() {
            return Source[key];
        },
        set: function(it) {
            Source[key] = it;
        }
    });
};






var $cd590ddc760cba04$require$enforceInternalState = $dbe54846b72f85d1$exports.enforce;


var $21555afe00fafda5$exports = {};


// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $21555afe00fafda5$var$$RegExp = $1a6e68c95df7d4df$exports.RegExp;
$21555afe00fafda5$exports = $4cefcb1c1c1fa750$exports(function() {
    var re = $21555afe00fafda5$var$$RegExp(".", "s");
    return !(re.dotAll && re.exec("\n") && re.flags === "s");
});


var $d91d33d5b6458970$exports = {};


// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $d91d33d5b6458970$var$$RegExp = $1a6e68c95df7d4df$exports.RegExp;
$d91d33d5b6458970$exports = $4cefcb1c1c1fa750$exports(function() {
    var re = $d91d33d5b6458970$var$$RegExp("(?<a>b)", "g");
    return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});


var $cd590ddc760cba04$var$MATCH = $5cfcb69f0877711f$exports("match");
var $cd590ddc760cba04$var$NativeRegExp = $1a6e68c95df7d4df$exports.RegExp;
var $cd590ddc760cba04$var$RegExpPrototype = $cd590ddc760cba04$var$NativeRegExp.prototype;
var $cd590ddc760cba04$var$SyntaxError = $1a6e68c95df7d4df$exports.SyntaxError;
var $cd590ddc760cba04$var$exec = $c510c74e58563f95$exports($cd590ddc760cba04$var$RegExpPrototype.exec);
var $cd590ddc760cba04$var$charAt = $c510c74e58563f95$exports("".charAt);
var $cd590ddc760cba04$var$replace = $c510c74e58563f95$exports("".replace);
var $cd590ddc760cba04$var$stringIndexOf = $c510c74e58563f95$exports("".indexOf);
var $cd590ddc760cba04$var$stringSlice = $c510c74e58563f95$exports("".slice);
// TODO: Use only proper RegExpIdentifierName
var $cd590ddc760cba04$var$IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var $cd590ddc760cba04$var$re1 = /a/g;
var $cd590ddc760cba04$var$re2 = /a/g;
// "new" should create a new object, old webkit bug
var $cd590ddc760cba04$var$CORRECT_NEW = new $cd590ddc760cba04$var$NativeRegExp($cd590ddc760cba04$var$re1) !== $cd590ddc760cba04$var$re1;
var $cd590ddc760cba04$var$MISSED_STICKY = $21b967d847dbc4bc$exports.MISSED_STICKY;
var $cd590ddc760cba04$var$UNSUPPORTED_Y = $21b967d847dbc4bc$exports.UNSUPPORTED_Y;
var $cd590ddc760cba04$var$BASE_FORCED = $0ab298e69b752e0a$exports && (!$cd590ddc760cba04$var$CORRECT_NEW || $cd590ddc760cba04$var$MISSED_STICKY || $21555afe00fafda5$exports || $d91d33d5b6458970$exports || $4cefcb1c1c1fa750$exports(function() {
    $cd590ddc760cba04$var$re2[$cd590ddc760cba04$var$MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return $cd590ddc760cba04$var$NativeRegExp($cd590ddc760cba04$var$re1) != $cd590ddc760cba04$var$re1 || $cd590ddc760cba04$var$NativeRegExp($cd590ddc760cba04$var$re2) == $cd590ddc760cba04$var$re2 || $cd590ddc760cba04$var$NativeRegExp($cd590ddc760cba04$var$re1, "i") != "/a/i";
}));
var $cd590ddc760cba04$var$handleDotAll = function(string) {
    var length = string.length;
    var index = 0;
    var result = "";
    var brackets = false;
    var chr;
    for(; index <= length; index++){
        chr = $cd590ddc760cba04$var$charAt(string, index);
        if (chr === "\\") {
            result += chr + $cd590ddc760cba04$var$charAt(string, ++index);
            continue;
        }
        if (!brackets && chr === ".") result += "[\\s\\S]";
        else {
            if (chr === "[") brackets = true;
            else if (chr === "]") brackets = false;
            result += chr;
        }
    }
    return result;
};
var $cd590ddc760cba04$var$handleNCG = function(string) {
    var length = string.length;
    var index = 0;
    var result = "";
    var named = [];
    var names = {};
    var brackets = false;
    var ncg = false;
    var groupid = 0;
    var groupname = "";
    var chr;
    for(; index <= length; index++){
        chr = $cd590ddc760cba04$var$charAt(string, index);
        if (chr === "\\") chr = chr + $cd590ddc760cba04$var$charAt(string, ++index);
        else if (chr === "]") brackets = false;
        else if (!brackets) switch(true){
            case chr === "[":
                brackets = true;
                break;
            case chr === "(":
                if ($cd590ddc760cba04$var$exec($cd590ddc760cba04$var$IS_NCG, $cd590ddc760cba04$var$stringSlice(string, index + 1))) {
                    index += 2;
                    ncg = true;
                }
                result += chr;
                groupid++;
                continue;
            case chr === ">" && ncg:
                if (groupname === "" || $ef59b581f0d1672b$exports(names, groupname)) throw new $cd590ddc760cba04$var$SyntaxError("Invalid capture group name");
                names[groupname] = true;
                named[named.length] = [
                    groupname,
                    groupid
                ];
                ncg = false;
                groupname = "";
                continue;
        }
        if (ncg) groupname += chr;
        else result += chr;
    }
    return [
        result,
        named
    ];
};
// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if ($87321f98e08714ab$exports("RegExp", $cd590ddc760cba04$var$BASE_FORCED)) {
    var $cd590ddc760cba04$var$RegExpWrapper = function RegExp(pattern, flags) {
        var thisIsRegExp = $b82c3d945f0459c1$exports($cd590ddc760cba04$var$RegExpPrototype, this);
        var patternIsRegExp = $c9cb68697881ddf0$exports(pattern);
        var flagsAreUndefined = flags === undefined;
        var groups = [];
        var rawPattern = pattern;
        var rawFlags, dotAll, sticky, handled, result, state;
        if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === $cd590ddc760cba04$var$RegExpWrapper) return pattern;
        if (patternIsRegExp || $b82c3d945f0459c1$exports($cd590ddc760cba04$var$RegExpPrototype, pattern)) {
            pattern = pattern.source;
            if (flagsAreUndefined) flags = $147846bfa9e9c5c4$exports(rawPattern);
        }
        pattern = pattern === undefined ? "" : $53d734af07b69aa7$exports(pattern);
        flags = flags === undefined ? "" : $53d734af07b69aa7$exports(flags);
        rawPattern = pattern;
        if ($21555afe00fafda5$exports && "dotAll" in $cd590ddc760cba04$var$re1) {
            dotAll = !!flags && $cd590ddc760cba04$var$stringIndexOf(flags, "s") > -1;
            if (dotAll) flags = $cd590ddc760cba04$var$replace(flags, /s/g, "");
        }
        rawFlags = flags;
        if ($cd590ddc760cba04$var$MISSED_STICKY && "sticky" in $cd590ddc760cba04$var$re1) {
            sticky = !!flags && $cd590ddc760cba04$var$stringIndexOf(flags, "y") > -1;
            if (sticky && $cd590ddc760cba04$var$UNSUPPORTED_Y) flags = $cd590ddc760cba04$var$replace(flags, /y/g, "");
        }
        if ($d91d33d5b6458970$exports) {
            handled = $cd590ddc760cba04$var$handleNCG(pattern);
            pattern = handled[0];
            groups = handled[1];
        }
        result = $93beb66cab49b410$exports($cd590ddc760cba04$var$NativeRegExp(pattern, flags), thisIsRegExp ? this : $cd590ddc760cba04$var$RegExpPrototype, $cd590ddc760cba04$var$RegExpWrapper);
        if (dotAll || sticky || groups.length) {
            state = $cd590ddc760cba04$require$enforceInternalState(result);
            if (dotAll) {
                state.dotAll = true;
                state.raw = $cd590ddc760cba04$var$RegExpWrapper($cd590ddc760cba04$var$handleDotAll(pattern), rawFlags);
            }
            if (sticky) state.sticky = true;
            if (groups.length) state.groups = groups;
        }
        if (pattern !== rawPattern) try {
            // fails in old engines, but we have no alternatives for unsupported regex syntax
            $4716626f874fe5a3$exports(result, "source", rawPattern === "" ? "(?:)" : rawPattern);
        } catch (error) {}
        return result;
    };
    for(var $cd590ddc760cba04$var$keys = $cd590ddc760cba04$require$getOwnPropertyNames($cd590ddc760cba04$var$NativeRegExp), $cd590ddc760cba04$var$index = 0; $cd590ddc760cba04$var$keys.length > $cd590ddc760cba04$var$index;)$4232ba3c32a60c70$exports($cd590ddc760cba04$var$RegExpWrapper, $cd590ddc760cba04$var$NativeRegExp, $cd590ddc760cba04$var$keys[$cd590ddc760cba04$var$index++]);
    $cd590ddc760cba04$var$RegExpPrototype.constructor = $cd590ddc760cba04$var$RegExpWrapper;
    $cd590ddc760cba04$var$RegExpWrapper.prototype = $cd590ddc760cba04$var$RegExpPrototype;
    $eeb1abced7a4b5b5$exports($1a6e68c95df7d4df$exports, "RegExp", $cd590ddc760cba04$var$RegExpWrapper, {
        constructor: true
    });
}
// https://tc39.es/ecma262/#sec-get-regexp-@@species
$60a2ce15ea97c905$exports("RegExp");


"use strict";

var $235120e4036035d9$exports = {};
"use strict";








var $235120e4036035d9$require$getInternalState = $dbe54846b72f85d1$exports.get;


var $235120e4036035d9$var$nativeReplace = $5b6f77fe4ecb64db$exports("native-string-replace", String.prototype.replace);
var $235120e4036035d9$var$nativeExec = RegExp.prototype.exec;
var $235120e4036035d9$var$patchedExec = $235120e4036035d9$var$nativeExec;
var $235120e4036035d9$var$charAt = $c510c74e58563f95$exports("".charAt);
var $235120e4036035d9$var$indexOf = $c510c74e58563f95$exports("".indexOf);
var $235120e4036035d9$var$replace = $c510c74e58563f95$exports("".replace);
var $235120e4036035d9$var$stringSlice = $c510c74e58563f95$exports("".slice);
var $235120e4036035d9$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $3b5393d57c251c61$exports($235120e4036035d9$var$nativeExec, re1, "a");
    $3b5393d57c251c61$exports($235120e4036035d9$var$nativeExec, re2, "a");
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $235120e4036035d9$var$UNSUPPORTED_Y = $21b967d847dbc4bc$exports.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $235120e4036035d9$var$NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
var $235120e4036035d9$var$PATCH = $235120e4036035d9$var$UPDATES_LAST_INDEX_WRONG || $235120e4036035d9$var$NPCG_INCLUDED || $235120e4036035d9$var$UNSUPPORTED_Y || $21555afe00fafda5$exports || $d91d33d5b6458970$exports;
if ($235120e4036035d9$var$PATCH) $235120e4036035d9$var$patchedExec = function exec(string) {
    var re = this;
    var state = $235120e4036035d9$require$getInternalState(re);
    var str = $53d734af07b69aa7$exports(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $3b5393d57c251c61$exports($235120e4036035d9$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $235120e4036035d9$var$UNSUPPORTED_Y && re.sticky;
    var flags = $3b5393d57c251c61$exports($f38526c7c8e4b4dc$exports, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $235120e4036035d9$var$replace(flags, "y", "");
        if ($235120e4036035d9$var$indexOf(flags, "g") === -1) flags += "g";
        strCopy = $235120e4036035d9$var$stringSlice(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && $235120e4036035d9$var$charAt(str, re.lastIndex - 1) !== "\n")) {
            source = "(?: " + source + ")";
            strCopy = " " + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp("^(?:" + source + ")", flags);
    }
    if ($235120e4036035d9$var$NPCG_INCLUDED) reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    if ($235120e4036035d9$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $3b5393d57c251c61$exports($235120e4036035d9$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = $235120e4036035d9$var$stringSlice(match.input, charsAdded);
            match[0] = $235120e4036035d9$var$stringSlice(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($235120e4036035d9$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($235120e4036035d9$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
    $3b5393d57c251c61$exports($235120e4036035d9$var$nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $290768129b19866b$exports(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
$235120e4036035d9$exports = $235120e4036035d9$var$patchedExec;


// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$0365e955907213bd$exports({
    target: "RegExp",
    proto: true,
    forced: /./.exec !== $235120e4036035d9$exports
}, {
    exec: $235120e4036035d9$exports
});







// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var $6c12af4fa1f27443$var$RegExp = $1a6e68c95df7d4df$exports.RegExp;
var $6c12af4fa1f27443$var$RegExpPrototype = $6c12af4fa1f27443$var$RegExp.prototype;
var $6c12af4fa1f27443$var$FORCED = $0ab298e69b752e0a$exports && $4cefcb1c1c1fa750$exports(function() {
    var INDICES_SUPPORT = true;
    try {
        $6c12af4fa1f27443$var$RegExp(".", "d");
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = "";
    var expected = INDICES_SUPPORT ? "dgimsy" : "gimsy";
    var addGetter = function(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: "s",
        global: "g",
        ignoreCase: "i",
        multiline: "m",
        sticky: "y"
    };
    if (INDICES_SUPPORT) pairs.hasIndices = "d";
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor($6c12af4fa1f27443$var$RegExpPrototype, "flags").get.call(O);
    return result !== expected || calls !== expected;
});
// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if ($6c12af4fa1f27443$var$FORCED) $54b1e35819861675$exports($6c12af4fa1f27443$var$RegExpPrototype, "flags", {
    configurable: true,
    get: $f38526c7c8e4b4dc$exports
});


"use strict";

var $7d72aa2ba44ae6c2$require$PROPER_FUNCTION_NAME = $93a445032aaa8001$exports.PROPER;





var $7d72aa2ba44ae6c2$var$TO_STRING = "toString";
var $7d72aa2ba44ae6c2$var$RegExpPrototype = RegExp.prototype;
var $7d72aa2ba44ae6c2$var$nativeToString = $7d72aa2ba44ae6c2$var$RegExpPrototype[$7d72aa2ba44ae6c2$var$TO_STRING];
var $7d72aa2ba44ae6c2$var$NOT_GENERIC = $4cefcb1c1c1fa750$exports(function() {
    return $7d72aa2ba44ae6c2$var$nativeToString.call({
        source: "a",
        flags: "b"
    }) != "/a/b";
});
// FF44- RegExp#toString has a wrong name
var $7d72aa2ba44ae6c2$var$INCORRECT_NAME = $7d72aa2ba44ae6c2$require$PROPER_FUNCTION_NAME && $7d72aa2ba44ae6c2$var$nativeToString.name != $7d72aa2ba44ae6c2$var$TO_STRING;
// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if ($7d72aa2ba44ae6c2$var$NOT_GENERIC || $7d72aa2ba44ae6c2$var$INCORRECT_NAME) $eeb1abced7a4b5b5$exports(RegExp.prototype, $7d72aa2ba44ae6c2$var$TO_STRING, function toString() {
    var R = $830db860a045bbb5$exports(this);
    var pattern = $53d734af07b69aa7$exports(R.source);
    var flags = $53d734af07b69aa7$exports($147846bfa9e9c5c4$exports(R));
    return "/" + pattern + "/" + flags;
}, {
    unsafe: true
});


// TODO: Remove this module from `core-js@4` since it's replaced to module below
"use strict";


// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
$112b243b75bec4f7$exports("Set", function(init) {
    return function Set() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $5c9af116049ea387$exports);




"use strict";

var $3f5631712605e16e$exports = {};




var $3f5631712605e16e$var$charAt = $c510c74e58563f95$exports("".charAt);
var $3f5631712605e16e$var$charCodeAt = $c510c74e58563f95$exports("".charCodeAt);
var $3f5631712605e16e$var$stringSlice = $c510c74e58563f95$exports("".slice);
var $3f5631712605e16e$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $53d734af07b69aa7$exports($ac95046ddf1ecaa1$exports($this));
        var position = $7167297f49b8d757$exports(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $3f5631712605e16e$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $3f5631712605e16e$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $3f5631712605e16e$var$charAt(S, position) : first : CONVERT_TO_STRING ? $3f5631712605e16e$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
$3f5631712605e16e$exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $3f5631712605e16e$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $3f5631712605e16e$var$createMethod(true)
};


var $8fffe2278f9ea03e$require$codeAt = $3f5631712605e16e$exports.codeAt;
// `String.prototype.codePointAt` method
// https://tc39.es/ecma262/#sec-string.prototype.codepointat
$0365e955907213bd$exports({
    target: "String",
    proto: true
}, {
    codePointAt: function codePointAt(pos) {
        return $8fffe2278f9ea03e$require$codeAt(this, pos);
    }
});


"use strict";



var $32d33b60929c3e07$require$getOwnPropertyDescriptor = $dc708c9bcef7b78f$export$2d1720544b23b823;


var $a652837787df1ab9$exports = {};

var $a652837787df1ab9$var$$TypeError = TypeError;
$a652837787df1ab9$exports = function(it) {
    if ($c9cb68697881ddf0$exports(it)) throw $a652837787df1ab9$var$$TypeError("The method doesn't accept regular expressions");
    return it;
};



var $c4a09ba1216acb61$exports = {};

var $c4a09ba1216acb61$var$MATCH = $5cfcb69f0877711f$exports("match");
$c4a09ba1216acb61$exports = function(METHOD_NAME) {
    var regexp = /./;
    try {
        "/./"[METHOD_NAME](regexp);
    } catch (error1) {
        try {
            regexp[$c4a09ba1216acb61$var$MATCH] = false;
            return "/./"[METHOD_NAME](regexp);
        } catch (error2) {}
    }
    return false;
};



// eslint-disable-next-line es/no-string-prototype-endswith -- safe
var $32d33b60929c3e07$var$nativeEndsWith = $31a67080629c484a$exports("".endsWith);
var $32d33b60929c3e07$var$slice = $31a67080629c484a$exports("".slice);
var $32d33b60929c3e07$var$min = Math.min;
var $32d33b60929c3e07$var$CORRECT_IS_REGEXP_LOGIC = $c4a09ba1216acb61$exports("endsWith");
// https://github.com/zloirock/core-js/pull/702
var $32d33b60929c3e07$var$MDN_POLYFILL_BUG = !$fef1920ae5260386$exports && !$32d33b60929c3e07$var$CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = $32d33b60929c3e07$require$getOwnPropertyDescriptor(String.prototype, "endsWith");
    return descriptor && !descriptor.writable;
}();
// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    forced: !$32d33b60929c3e07$var$MDN_POLYFILL_BUG && !$32d33b60929c3e07$var$CORRECT_IS_REGEXP_LOGIC
}, {
    endsWith: function endsWith(searchString /* , endPosition = @length */ ) {
        var that = $53d734af07b69aa7$exports($ac95046ddf1ecaa1$exports(this));
        $a652837787df1ab9$exports(searchString);
        var endPosition = arguments.length > 1 ? arguments[1] : undefined;
        var len = that.length;
        var end = endPosition === undefined ? len : $32d33b60929c3e07$var$min($c2922a7ee9a4ab10$exports(endPosition), len);
        var search = $53d734af07b69aa7$exports(searchString);
        return $32d33b60929c3e07$var$nativeEndsWith ? $32d33b60929c3e07$var$nativeEndsWith(that, search, end) : $32d33b60929c3e07$var$slice(that, end - search.length, end) === search;
    }
});





var $7a7925713628efc7$var$$RangeError = RangeError;
var $7a7925713628efc7$var$fromCharCode = String.fromCharCode;
// eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
var $7a7925713628efc7$var$$fromCodePoint = String.fromCodePoint;
var $7a7925713628efc7$var$join = $c510c74e58563f95$exports([].join);
// length should be 1, old FF problem
var $7a7925713628efc7$var$INCORRECT_LENGTH = !!$7a7925713628efc7$var$$fromCodePoint && $7a7925713628efc7$var$$fromCodePoint.length != 1;
// `String.fromCodePoint` method
// https://tc39.es/ecma262/#sec-string.fromcodepoint
$0365e955907213bd$exports({
    target: "String",
    stat: true,
    arity: 1,
    forced: $7a7925713628efc7$var$INCORRECT_LENGTH
}, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    fromCodePoint: function fromCodePoint(x) {
        var elements = [];
        var length = arguments.length;
        var i = 0;
        var code;
        while(length > i){
            code = +arguments[i++];
            if ($125a12a61907520f$exports(code, 0x10FFFF) !== code) throw $7a7925713628efc7$var$$RangeError(code + " is not a valid code point");
            elements[i] = code < 0x10000 ? $7a7925713628efc7$var$fromCharCode(code) : $7a7925713628efc7$var$fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
        }
        return $7a7925713628efc7$var$join(elements, "");
    }
});


"use strict";






var $8ef0907134d08797$var$stringIndexOf = $c510c74e58563f95$exports("".indexOf);
// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    forced: !$c4a09ba1216acb61$exports("includes")
}, {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$8ef0907134d08797$var$stringIndexOf($53d734af07b69aa7$exports($ac95046ddf1ecaa1$exports(this)), $53d734af07b69aa7$exports($a652837787df1ab9$exports(searchString)), arguments.length > 1 ? arguments[1] : undefined);
    }
});


"use strict";

var $312f2df1b6a7c35f$require$charAt = $3f5631712605e16e$exports.charAt;




var $312f2df1b6a7c35f$var$STRING_ITERATOR = "String Iterator";
var $312f2df1b6a7c35f$var$setInternalState = $dbe54846b72f85d1$exports.set;
var $312f2df1b6a7c35f$var$getInternalState = $dbe54846b72f85d1$exports.getterFor($312f2df1b6a7c35f$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$d9091fe3c4cc4bc8$exports(String, "String", function(iterated) {
    $312f2df1b6a7c35f$var$setInternalState(this, {
        type: $312f2df1b6a7c35f$var$STRING_ITERATOR,
        string: $53d734af07b69aa7$exports(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $312f2df1b6a7c35f$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $25360ca3df62dca5$exports(undefined, true);
    point = $312f2df1b6a7c35f$require$charAt(string, index);
    state.index += point.length;
    return $25360ca3df62dca5$exports(point, false);
});


"use strict";

var $9a53fa851c6af666$exports = {};
"use strict";







var $9a53fa851c6af666$var$SPECIES = $5cfcb69f0877711f$exports("species");
var $9a53fa851c6af666$var$RegExpPrototype = RegExp.prototype;
$9a53fa851c6af666$exports = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $5cfcb69f0877711f$exports(KEY);
    var DELEGATES_TO_SYMBOL = !$4cefcb1c1c1fa750$exports(function() {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ""[KEY](O) != 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$4cefcb1c1c1fa750$exports(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === "split") {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$9a53fa851c6af666$var$SPECIES] = function() {
                return re;
            };
            re.flags = "";
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]("");
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var uncurriedNativeRegExpMethod = $31a67080629c484a$exports(/./[SYMBOL]);
        var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var uncurriedNativeMethod = $31a67080629c484a$exports(nativeMethod);
            var $exec = regexp.exec;
            if ($exec === $235120e4036035d9$exports || $exec === $9a53fa851c6af666$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: uncurriedNativeRegExpMethod(regexp, str, arg2)
                };
                return {
                    done: true,
                    value: uncurriedNativeMethod(str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $eeb1abced7a4b5b5$exports(String.prototype, KEY, methods[0]);
        $eeb1abced7a4b5b5$exports($9a53fa851c6af666$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $4716626f874fe5a3$exports($9a53fa851c6af666$var$RegExpPrototype[SYMBOL], "sham", true);
};








var $1f8a2df3b9d5edba$exports = {};
"use strict";

var $1f8a2df3b9d5edba$require$charAt = $3f5631712605e16e$exports.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
$1f8a2df3b9d5edba$exports = function(S, index, unicode) {
    return index + (unicode ? $1f8a2df3b9d5edba$require$charAt(S, index).length : 1);
};


var $ceb00ae1ac3684ba$exports = {};





var $ceb00ae1ac3684ba$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
$ceb00ae1ac3684ba$exports = function(R, S) {
    var exec = R.exec;
    if ($c1d5f87f1e56c4cc$exports(exec)) {
        var result = $3b5393d57c251c61$exports(exec, R, S);
        if (result !== null) $830db860a045bbb5$exports(result);
        return result;
    }
    if ($ee4d29ebca1023f3$exports(R) === "RegExp") return $3b5393d57c251c61$exports($235120e4036035d9$exports, R, S);
    throw $ceb00ae1ac3684ba$var$$TypeError("RegExp#exec called on incompatible receiver");
};


// @@match logic
$9a53fa851c6af666$exports("match", function(MATCH, nativeMatch, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.es/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = $ac95046ddf1ecaa1$exports(this);
            var matcher = $784d9540a0abf25d$exports(regexp) ? undefined : $884b8a4433456f65$exports(regexp, MATCH);
            return matcher ? $3b5393d57c251c61$exports(matcher, regexp, O) : new RegExp(regexp)[MATCH]($53d734af07b69aa7$exports(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
        function(string) {
            var rx = $830db860a045bbb5$exports(this);
            var S = $53d734af07b69aa7$exports(string);
            var res = maybeCallNative(nativeMatch, rx, S);
            if (res.done) return res.value;
            if (!rx.global) return $ceb00ae1ac3684ba$exports(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = $ceb00ae1ac3684ba$exports(rx, S)) !== null){
                var matchStr = $53d734af07b69aa7$exports(result[0]);
                A[n] = matchStr;
                if (matchStr === "") rx.lastIndex = $1f8a2df3b9d5edba$exports(S, $c2922a7ee9a4ab10$exports(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});


"use strict";


var $1660db26fbb374f9$require$$padEnd = $bd1f2c751add4c9f$exports.end;
var $6a0fcd4c13e6100a$exports = {};
// https://github.com/zloirock/core-js/issues/280

$6a0fcd4c13e6100a$exports = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test($59d28ac8b8f97183$exports);


// `String.prototype.padEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.padend
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    forced: $6a0fcd4c13e6100a$exports
}, {
    padEnd: function padEnd(maxLength /* , fillString = ' ' */ ) {
        return $1660db26fbb374f9$require$$padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
    }
});


"use strict";


var $fa2f2b942e27367e$require$$padStart = $bd1f2c751add4c9f$exports.start;

// `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    forced: $6a0fcd4c13e6100a$exports
}, {
    padStart: function padStart(maxLength /* , fillString = ' ' */ ) {
        return $fa2f2b942e27367e$require$$padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
    }
});








var $aa946ba1648fd143$var$push = $c510c74e58563f95$exports([].push);
var $aa946ba1648fd143$var$join = $c510c74e58563f95$exports([].join);
// `String.raw` method
// https://tc39.es/ecma262/#sec-string.raw
$0365e955907213bd$exports({
    target: "String",
    stat: true
}, {
    raw: function raw(template) {
        var rawTemplate = $b497231b90dfbcaa$exports($cc6f28a96f61f0ea$exports(template).raw);
        var literalSegments = $ec53954e5de19898$exports(rawTemplate);
        if (!literalSegments) return "";
        var argumentsLength = arguments.length;
        var elements = [];
        var i = 0;
        while(true){
            $aa946ba1648fd143$var$push(elements, $53d734af07b69aa7$exports(rawTemplate[i++]));
            if (i === literalSegments) return $aa946ba1648fd143$var$join(elements, "");
            if (i < argumentsLength) $aa946ba1648fd143$var$push(elements, $53d734af07b69aa7$exports(arguments[i]));
        }
    }
});




// `String.prototype.repeat` method
// https://tc39.es/ecma262/#sec-string.prototype.repeat
$0365e955907213bd$exports({
    target: "String",
    proto: true
}, {
    repeat: $42370b6b571de72c$exports
});


"use strict";














var $f9df476e5397fc75$exports = {};


var $f9df476e5397fc75$var$floor = Math.floor;
var $f9df476e5397fc75$var$charAt = $c510c74e58563f95$exports("".charAt);
var $f9df476e5397fc75$var$replace = $c510c74e58563f95$exports("".replace);
var $f9df476e5397fc75$var$stringSlice = $c510c74e58563f95$exports("".slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var $f9df476e5397fc75$var$SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var $f9df476e5397fc75$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
$f9df476e5397fc75$exports = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = $f9df476e5397fc75$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = $cc6f28a96f61f0ea$exports(namedCaptures);
        symbols = $f9df476e5397fc75$var$SUBSTITUTION_SYMBOLS;
    }
    return $f9df476e5397fc75$var$replace(replacement, symbols, function(match, ch) {
        var capture;
        switch($f9df476e5397fc75$var$charAt(ch, 0)){
            case "$":
                return "$";
            case "&":
                return matched;
            case "`":
                return $f9df476e5397fc75$var$stringSlice(str, 0, position);
            case "'":
                return $f9df476e5397fc75$var$stringSlice(str, tailPos);
            case "<":
                capture = namedCaptures[$f9df476e5397fc75$var$stringSlice(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = $f9df476e5397fc75$var$floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? $f9df476e5397fc75$var$charAt(ch, 1) : captures[f - 1] + $f9df476e5397fc75$var$charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? "" : capture;
    });
};




var $0f8b97201c72647c$var$REPLACE = $5cfcb69f0877711f$exports("replace");
var $0f8b97201c72647c$var$max = Math.max;
var $0f8b97201c72647c$var$min = Math.min;
var $0f8b97201c72647c$var$concat = $c510c74e58563f95$exports([].concat);
var $0f8b97201c72647c$var$push = $c510c74e58563f95$exports([].push);
var $0f8b97201c72647c$var$stringIndexOf = $c510c74e58563f95$exports("".indexOf);
var $0f8b97201c72647c$var$stringSlice = $c510c74e58563f95$exports("".slice);
var $0f8b97201c72647c$var$maybeToString = function(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var $0f8b97201c72647c$var$REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return "a".replace(/./, "$0") === "$0";
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var $0f8b97201c72647c$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[$0f8b97201c72647c$var$REPLACE]) return /./[$0f8b97201c72647c$var$REPLACE]("a", "$0") === "";
    return false;
}();
var $0f8b97201c72647c$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$4cefcb1c1c1fa750$exports(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: "7"
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return "".replace(re, "$<a>") !== "7";
});
// @@replace logic
$9a53fa851c6af666$exports("replace", function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = $0f8b97201c72647c$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = $ac95046ddf1ecaa1$exports(this);
            var replacer = $784d9540a0abf25d$exports(searchValue) ? undefined : $884b8a4433456f65$exports(searchValue, $0f8b97201c72647c$var$REPLACE);
            return replacer ? $3b5393d57c251c61$exports(replacer, searchValue, O, replaceValue) : $3b5393d57c251c61$exports(nativeReplace, $53d734af07b69aa7$exports(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = $830db860a045bbb5$exports(this);
            var S = $53d734af07b69aa7$exports(string);
            if (typeof replaceValue == "string" && $0f8b97201c72647c$var$stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && $0f8b97201c72647c$var$stringIndexOf(replaceValue, "$<") === -1) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var functionalReplace = $c1d5f87f1e56c4cc$exports(replaceValue);
            if (!functionalReplace) replaceValue = $53d734af07b69aa7$exports(replaceValue);
            var global = rx.global;
            if (global) {
                var fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            while(true){
                var result = $ceb00ae1ac3684ba$exports(rx, S);
                if (result === null) break;
                $0f8b97201c72647c$var$push(results, result);
                if (!global) break;
                var matchStr = $53d734af07b69aa7$exports(result[0]);
                if (matchStr === "") rx.lastIndex = $1f8a2df3b9d5edba$exports(S, $c2922a7ee9a4ab10$exports(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = "";
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = $53d734af07b69aa7$exports(result[0]);
                var position = $0f8b97201c72647c$var$max($0f8b97201c72647c$var$min($7167297f49b8d757$exports(result.index), S.length), 0);
                var captures = [];
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)$0f8b97201c72647c$var$push(captures, $0f8b97201c72647c$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = $0f8b97201c72647c$var$concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) $0f8b97201c72647c$var$push(replacerArgs, namedCaptures);
                    var replacement = $53d734af07b69aa7$exports($17764d41e6b47061$exports(replaceValue, undefined, replacerArgs));
                } else replacement = $f9df476e5397fc75$exports(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += $0f8b97201c72647c$var$stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + $0f8b97201c72647c$var$stringSlice(S, nextSourcePosition);
        }
    ];
}, !$0f8b97201c72647c$var$REPLACE_SUPPORTS_NAMED_GROUPS || !$0f8b97201c72647c$var$REPLACE_KEEPS_$0 || $0f8b97201c72647c$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


"use strict";









// @@search logic
$9a53fa851c6af666$exports("search", function(SEARCH, nativeSearch, maybeCallNative) {
    return [
        // `String.prototype.search` method
        // https://tc39.es/ecma262/#sec-string.prototype.search
        function search(regexp) {
            var O = $ac95046ddf1ecaa1$exports(this);
            var searcher = $784d9540a0abf25d$exports(regexp) ? undefined : $884b8a4433456f65$exports(regexp, SEARCH);
            return searcher ? $3b5393d57c251c61$exports(searcher, regexp, O) : new RegExp(regexp)[SEARCH]($53d734af07b69aa7$exports(O));
        },
        // `RegExp.prototype[@@search]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
        function(string) {
            var rx = $830db860a045bbb5$exports(this);
            var S = $53d734af07b69aa7$exports(string);
            var res = maybeCallNative(nativeSearch, rx, S);
            if (res.done) return res.value;
            var previousLastIndex = rx.lastIndex;
            if (!$1e9f246f8dc0eea3$exports(previousLastIndex, 0)) rx.lastIndex = 0;
            var result = $ceb00ae1ac3684ba$exports(rx, S);
            if (!$1e9f246f8dc0eea3$exports(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
            return result === null ? -1 : result.index;
        }
    ];
});


"use strict";


















var $53fd187d688ca0d2$var$UNSUPPORTED_Y = $21b967d847dbc4bc$exports.UNSUPPORTED_Y;
var $53fd187d688ca0d2$var$MAX_UINT32 = 0xFFFFFFFF;
var $53fd187d688ca0d2$var$min = Math.min;
var $53fd187d688ca0d2$var$$push = [].push;
var $53fd187d688ca0d2$var$exec = $c510c74e58563f95$exports(/./.exec);
var $53fd187d688ca0d2$var$push = $c510c74e58563f95$exports($53fd187d688ca0d2$var$$push);
var $53fd187d688ca0d2$var$stringSlice = $c510c74e58563f95$exports("".slice);
// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var $53fd187d688ca0d2$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !$4cefcb1c1c1fa750$exports(function() {
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    var re = /(?:)/;
    var originalExec = re.exec;
    re.exec = function() {
        return originalExec.apply(this, arguments);
    };
    var result = "ab".split(re);
    return result.length !== 2 || result[0] !== "a" || result[1] !== "b";
});
// @@split logic
$9a53fa851c6af666$exports("split", function(SPLIT, nativeSplit, maybeCallNative) {
    var internalSplit;
    if ("abbc".split(/(b)*/)[1] == "c" || // eslint-disable-next-line regexp/no-empty-group -- required for testing
    "test".split(/(?:)/, -1).length != 4 || "ab".split(/(?:ab)*/).length != 2 || ".".split(/(.?)(.?)/).length != 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    ".".split(/()()/).length > 1 || "".split(/.?/).length) // based on es5-shim implementation, need to rework it
    internalSplit = function(separator, limit) {
        var string = $53d734af07b69aa7$exports($ac95046ddf1ecaa1$exports(this));
        var lim = limit === undefined ? $53fd187d688ca0d2$var$MAX_UINT32 : limit >>> 0;
        if (lim === 0) return [];
        if (separator === undefined) return [
            string
        ];
        // If `separator` is not a regex, use native split
        if (!$c9cb68697881ddf0$exports(separator)) return $3b5393d57c251c61$exports(nativeSplit, string, separator, lim);
        var output = [];
        var flags = (separator.ignoreCase ? "i" : "") + (separator.multiline ? "m" : "") + (separator.unicode ? "u" : "") + (separator.sticky ? "y" : "");
        var lastLastIndex = 0;
        // Make `global` and avoid `lastIndex` issues by working with a copy
        var separatorCopy = new RegExp(separator.source, flags + "g");
        var match, lastIndex, lastLength;
        while(match = $3b5393d57c251c61$exports($235120e4036035d9$exports, separatorCopy, string)){
            lastIndex = separatorCopy.lastIndex;
            if (lastIndex > lastLastIndex) {
                $53fd187d688ca0d2$var$push(output, $53fd187d688ca0d2$var$stringSlice(string, lastLastIndex, match.index));
                if (match.length > 1 && match.index < string.length) $17764d41e6b47061$exports($53fd187d688ca0d2$var$$push, output, $df6d3dbc942f438e$exports(match, 1));
                lastLength = match[0].length;
                lastLastIndex = lastIndex;
                if (output.length >= lim) break;
            }
            if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
        }
        if (lastLastIndex === string.length) {
            if (lastLength || !$53fd187d688ca0d2$var$exec(separatorCopy, "")) $53fd187d688ca0d2$var$push(output, "");
        } else $53fd187d688ca0d2$var$push(output, $53fd187d688ca0d2$var$stringSlice(string, lastLastIndex));
        return output.length > lim ? $df6d3dbc942f438e$exports(output, 0, lim) : output;
    };
    else if ("0".split(undefined, 0).length) internalSplit = function(separator, limit) {
        return separator === undefined && limit === 0 ? [] : $3b5393d57c251c61$exports(nativeSplit, this, separator, limit);
    };
    else internalSplit = nativeSplit;
    return [
        // `String.prototype.split` method
        // https://tc39.es/ecma262/#sec-string.prototype.split
        function split(separator, limit) {
            var O = $ac95046ddf1ecaa1$exports(this);
            var splitter = $784d9540a0abf25d$exports(separator) ? undefined : $884b8a4433456f65$exports(separator, SPLIT);
            return splitter ? $3b5393d57c251c61$exports(splitter, separator, O, limit) : $3b5393d57c251c61$exports(internalSplit, $53d734af07b69aa7$exports(O), separator, limit);
        },
        // `RegExp.prototype[@@split]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
        //
        // NOTE: This cannot be properly polyfilled in engines that don't support
        // the 'y' flag.
        function(string, limit) {
            var rx = $830db860a045bbb5$exports(this);
            var S = $53d734af07b69aa7$exports(string);
            var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
            if (res.done) return res.value;
            var C = $a926216b9de7547b$exports(rx, RegExp);
            var unicodeMatching = rx.unicode;
            var flags = (rx.ignoreCase ? "i" : "") + (rx.multiline ? "m" : "") + (rx.unicode ? "u" : "") + ($53fd187d688ca0d2$var$UNSUPPORTED_Y ? "g" : "y");
            // ^(? + rx + ) is needed, in combination with some S slicing, to
            // simulate the 'y' flag.
            var splitter = new C($53fd187d688ca0d2$var$UNSUPPORTED_Y ? "^(?:" + rx.source + ")" : rx, flags);
            var lim = limit === undefined ? $53fd187d688ca0d2$var$MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (S.length === 0) return $ceb00ae1ac3684ba$exports(splitter, S) === null ? [
                S
            ] : [];
            var p = 0;
            var q = 0;
            var A = [];
            while(q < S.length){
                splitter.lastIndex = $53fd187d688ca0d2$var$UNSUPPORTED_Y ? 0 : q;
                var z = $ceb00ae1ac3684ba$exports(splitter, $53fd187d688ca0d2$var$UNSUPPORTED_Y ? $53fd187d688ca0d2$var$stringSlice(S, q) : S);
                var e;
                if (z === null || (e = $53fd187d688ca0d2$var$min($c2922a7ee9a4ab10$exports(splitter.lastIndex + ($53fd187d688ca0d2$var$UNSUPPORTED_Y ? q : 0)), S.length)) === p) q = $1f8a2df3b9d5edba$exports(S, q, unicodeMatching);
                else {
                    $53fd187d688ca0d2$var$push(A, $53fd187d688ca0d2$var$stringSlice(S, p, q));
                    if (A.length === lim) return A;
                    for(var i = 1; i <= z.length - 1; i++){
                        $53fd187d688ca0d2$var$push(A, z[i]);
                        if (A.length === lim) return A;
                    }
                    q = p = e;
                }
            }
            $53fd187d688ca0d2$var$push(A, $53fd187d688ca0d2$var$stringSlice(S, p));
            return A;
        }
    ];
}, !$53fd187d688ca0d2$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, $53fd187d688ca0d2$var$UNSUPPORTED_Y);


"use strict";



var $1ec22a86fe0cc73b$require$getOwnPropertyDescriptor = $dc708c9bcef7b78f$export$2d1720544b23b823;






// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var $1ec22a86fe0cc73b$var$nativeStartsWith = $31a67080629c484a$exports("".startsWith);
var $1ec22a86fe0cc73b$var$stringSlice = $31a67080629c484a$exports("".slice);
var $1ec22a86fe0cc73b$var$min = Math.min;
var $1ec22a86fe0cc73b$var$CORRECT_IS_REGEXP_LOGIC = $c4a09ba1216acb61$exports("startsWith");
// https://github.com/zloirock/core-js/pull/702
var $1ec22a86fe0cc73b$var$MDN_POLYFILL_BUG = !$fef1920ae5260386$exports && !$1ec22a86fe0cc73b$var$CORRECT_IS_REGEXP_LOGIC && !!function() {
    var descriptor = $1ec22a86fe0cc73b$require$getOwnPropertyDescriptor(String.prototype, "startsWith");
    return descriptor && !descriptor.writable;
}();
// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    forced: !$1ec22a86fe0cc73b$var$MDN_POLYFILL_BUG && !$1ec22a86fe0cc73b$var$CORRECT_IS_REGEXP_LOGIC
}, {
    startsWith: function startsWith(searchString /* , position = 0 */ ) {
        var that = $53d734af07b69aa7$exports($ac95046ddf1ecaa1$exports(this));
        $a652837787df1ab9$exports(searchString);
        var index = $c2922a7ee9a4ab10$exports($1ec22a86fe0cc73b$var$min(arguments.length > 1 ? arguments[1] : undefined, that.length));
        var search = $53d734af07b69aa7$exports(searchString);
        return $1ec22a86fe0cc73b$var$nativeStartsWith ? $1ec22a86fe0cc73b$var$nativeStartsWith(that, search, index) : $1ec22a86fe0cc73b$var$stringSlice(that, index, index + search.length) === search;
    }
});


"use strict";


var $d43006b30823e536$require$$trim = $414e726332f379ed$exports.trim;
var $bbf8b0cd083dcc8b$exports = {};

var $bbf8b0cd083dcc8b$require$PROPER_FUNCTION_NAME = $93a445032aaa8001$exports.PROPER;


var $bbf8b0cd083dcc8b$var$non = "​\x85᠎";
// check that a method works with the correct list
// of whitespaces and has a correct name
$bbf8b0cd083dcc8b$exports = function(METHOD_NAME) {
    return $4cefcb1c1c1fa750$exports(function() {
        return !!$8028e84d9131b882$exports[METHOD_NAME]() || $bbf8b0cd083dcc8b$var$non[METHOD_NAME]() !== $bbf8b0cd083dcc8b$var$non || $bbf8b0cd083dcc8b$require$PROPER_FUNCTION_NAME && $8028e84d9131b882$exports[METHOD_NAME].name !== METHOD_NAME;
    });
};


// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    forced: $bbf8b0cd083dcc8b$exports("trim")
}, {
    trim: function trim() {
        return $d43006b30823e536$require$$trim(this);
    }
});


// TODO: Remove this line from `core-js@4`

var $0677d5eda9d6854a$exports = {};
"use strict";

var $0677d5eda9d6854a$require$$trimEnd = $414e726332f379ed$exports.end;

// `String.prototype.{ trimEnd, trimRight }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// https://tc39.es/ecma262/#String.prototype.trimright
$0677d5eda9d6854a$exports = $bbf8b0cd083dcc8b$exports("trimEnd") ? function trimEnd() {
    return $0677d5eda9d6854a$require$$trimEnd(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : "".trimEnd;


// `String.prototype.trimRight` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    name: "trimEnd",
    forced: "".trimRight !== $0677d5eda9d6854a$exports
}, {
    trimRight: $0677d5eda9d6854a$exports
});




// `String.prototype.trimEnd` method
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    name: "trimEnd",
    forced: "".trimEnd !== $0677d5eda9d6854a$exports
}, {
    trimEnd: $0677d5eda9d6854a$exports
});


// TODO: Remove this line from `core-js@4`

var $ec7b709232cf8ddb$exports = {};
"use strict";

var $ec7b709232cf8ddb$require$$trimStart = $414e726332f379ed$exports.start;

// `String.prototype.{ trimStart, trimLeft }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// https://tc39.es/ecma262/#String.prototype.trimleft
$ec7b709232cf8ddb$exports = $bbf8b0cd083dcc8b$exports("trimStart") ? function trimStart() {
    return $ec7b709232cf8ddb$require$$trimStart(this);
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : "".trimStart;


// `String.prototype.trimLeft` method
// https://tc39.es/ecma262/#sec-string.prototype.trimleft
// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    name: "trimStart",
    forced: "".trimLeft !== $ec7b709232cf8ddb$exports
}, {
    trimLeft: $ec7b709232cf8ddb$exports
});




// `String.prototype.trimStart` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    name: "trimStart",
    forced: "".trimStart !== $ec7b709232cf8ddb$exports
}, {
    trimStart: $ec7b709232cf8ddb$exports
});


"use strict";

var $068cda33071c38aa$exports = {};



var $068cda33071c38aa$var$quot = /"/g;
var $068cda33071c38aa$var$replace = $c510c74e58563f95$exports("".replace);
// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
$068cda33071c38aa$exports = function(string, tag, attribute, value) {
    var S = $53d734af07b69aa7$exports($ac95046ddf1ecaa1$exports(string));
    var p1 = "<" + tag;
    if (attribute !== "") p1 += " " + attribute + '="' + $068cda33071c38aa$var$replace($53d734af07b69aa7$exports(value), $068cda33071c38aa$var$quot, "&quot;") + '"';
    return p1 + ">" + S + "</" + tag + ">";
};


var $b9343fa4794e2e47$exports = {};

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
$b9343fa4794e2e47$exports = function(METHOD_NAME) {
    return $4cefcb1c1c1fa750$exports(function() {
        var test = ""[METHOD_NAME]('"');
        return test !== test.toLowerCase() || test.split('"').length > 3;
    });
};


// `String.prototype.anchor` method
// https://tc39.es/ecma262/#sec-string.prototype.anchor
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    forced: $b9343fa4794e2e47$exports("anchor")
}, {
    anchor: function anchor(name) {
        return $068cda33071c38aa$exports(this, "a", "name", name);
    }
});


"use strict";



// `String.prototype.big` method
// https://tc39.es/ecma262/#sec-string.prototype.big
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    forced: $b9343fa4794e2e47$exports("big")
}, {
    big: function big() {
        return $068cda33071c38aa$exports(this, "big", "", "");
    }
});


"use strict";



// `String.prototype.blink` method
// https://tc39.es/ecma262/#sec-string.prototype.blink
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    forced: $b9343fa4794e2e47$exports("blink")
}, {
    blink: function blink() {
        return $068cda33071c38aa$exports(this, "blink", "", "");
    }
});


"use strict";



// `String.prototype.bold` method
// https://tc39.es/ecma262/#sec-string.prototype.bold
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    forced: $b9343fa4794e2e47$exports("bold")
}, {
    bold: function bold() {
        return $068cda33071c38aa$exports(this, "b", "", "");
    }
});


"use strict";



// `String.prototype.fixed` method
// https://tc39.es/ecma262/#sec-string.prototype.fixed
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    forced: $b9343fa4794e2e47$exports("fixed")
}, {
    fixed: function fixed() {
        return $068cda33071c38aa$exports(this, "tt", "", "");
    }
});


"use strict";



// `String.prototype.fontcolor` method
// https://tc39.es/ecma262/#sec-string.prototype.fontcolor
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    forced: $b9343fa4794e2e47$exports("fontcolor")
}, {
    fontcolor: function fontcolor(color) {
        return $068cda33071c38aa$exports(this, "font", "color", color);
    }
});


"use strict";



// `String.prototype.fontsize` method
// https://tc39.es/ecma262/#sec-string.prototype.fontsize
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    forced: $b9343fa4794e2e47$exports("fontsize")
}, {
    fontsize: function fontsize(size) {
        return $068cda33071c38aa$exports(this, "font", "size", size);
    }
});


"use strict";



// `String.prototype.italics` method
// https://tc39.es/ecma262/#sec-string.prototype.italics
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    forced: $b9343fa4794e2e47$exports("italics")
}, {
    italics: function italics() {
        return $068cda33071c38aa$exports(this, "i", "", "");
    }
});


"use strict";



// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    forced: $b9343fa4794e2e47$exports("link")
}, {
    link: function link(url) {
        return $068cda33071c38aa$exports(this, "a", "href", url);
    }
});


"use strict";



// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    forced: $b9343fa4794e2e47$exports("small")
}, {
    small: function small() {
        return $068cda33071c38aa$exports(this, "small", "", "");
    }
});


"use strict";



// `String.prototype.strike` method
// https://tc39.es/ecma262/#sec-string.prototype.strike
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    forced: $b9343fa4794e2e47$exports("strike")
}, {
    strike: function strike() {
        return $068cda33071c38aa$exports(this, "strike", "", "");
    }
});


"use strict";



// `String.prototype.sub` method
// https://tc39.es/ecma262/#sec-string.prototype.sub
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    forced: $b9343fa4794e2e47$exports("sub")
}, {
    sub: function sub() {
        return $068cda33071c38aa$exports(this, "sub", "", "");
    }
});


"use strict";



// `String.prototype.sup` method
// https://tc39.es/ecma262/#sec-string.prototype.sup
$0365e955907213bd$exports({
    target: "String",
    proto: true,
    forced: $b9343fa4794e2e47$exports("sup")
}, {
    sup: function sup() {
        return $068cda33071c38aa$exports(this, "sup", "", "");
    }
});


var $ce7423435ca54fad$exports = {};
"use strict";




var $bfc1573910ea5c36$exports = {};
/* eslint-disable no-new -- required for testing */ 



var $bfc1573910ea5c36$require$NATIVE_ARRAY_BUFFER_VIEWS = $a8e31709e413942c$exports.NATIVE_ARRAY_BUFFER_VIEWS;
var $bfc1573910ea5c36$var$ArrayBuffer = $1a6e68c95df7d4df$exports.ArrayBuffer;
var $bfc1573910ea5c36$var$Int8Array = $1a6e68c95df7d4df$exports.Int8Array;
$bfc1573910ea5c36$exports = !$bfc1573910ea5c36$require$NATIVE_ARRAY_BUFFER_VIEWS || !$4cefcb1c1c1fa750$exports(function() {
    $bfc1573910ea5c36$var$Int8Array(1);
}) || !$4cefcb1c1c1fa750$exports(function() {
    new $bfc1573910ea5c36$var$Int8Array(-1);
}) || !$cc6f301ab97f18d4$exports(function(iterable) {
    new $bfc1573910ea5c36$var$Int8Array();
    new $bfc1573910ea5c36$var$Int8Array(null);
    new $bfc1573910ea5c36$var$Int8Array(1.5);
    new $bfc1573910ea5c36$var$Int8Array(iterable);
}, true) || $4cefcb1c1c1fa750$exports(function() {
    // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
    return new $bfc1573910ea5c36$var$Int8Array(new $bfc1573910ea5c36$var$ArrayBuffer(2), 1, undefined).length !== 1;
});










var $80465ccc3b649a7e$exports = {};
var $382b9cb9bf75cb52$exports = {};

var $382b9cb9bf75cb52$var$$RangeError = RangeError;
$382b9cb9bf75cb52$exports = function(it) {
    var result = $7167297f49b8d757$exports(it);
    if (result < 0) throw $382b9cb9bf75cb52$var$$RangeError("The argument can't be less than 0");
    return result;
};


var $80465ccc3b649a7e$var$$RangeError = RangeError;
$80465ccc3b649a7e$exports = function(it, BYTES) {
    var offset = $382b9cb9bf75cb52$exports(it);
    if (offset % BYTES) throw $80465ccc3b649a7e$var$$RangeError("Wrong offset");
    return offset;
};











var $ce7423435ca54fad$require$getOwnPropertyNames = $cdc111d4fc429a99$export$2d1720544b23b823;
var $aa6d3da0eb766a82$exports = {};








var $6f59ecb0b3afd5cc$exports = {};

$6f59ecb0b3afd5cc$exports = function(it) {
    var klass = $79ec051cbbc13a5e$exports(it);
    return klass == "BigInt64Array" || klass == "BigUint64Array";
};



var $aa6d3da0eb766a82$require$aTypedArrayConstructor = $a8e31709e413942c$exports.aTypedArrayConstructor;
var $6c06d186fb27caad$exports = {};

var $6c06d186fb27caad$var$$TypeError = TypeError;
// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
$6c06d186fb27caad$exports = function(argument) {
    var prim = $49e56ced23df1333$exports(argument, "number");
    if (typeof prim == "number") throw $6c06d186fb27caad$var$$TypeError("Can't convert number to bigint");
    // eslint-disable-next-line es/no-bigint -- safe
    return BigInt(prim);
};


$aa6d3da0eb766a82$exports = function from(source /* , mapfn, thisArg */ ) {
    var C = $7cef700a0727b620$exports(this);
    var O = $cc6f28a96f61f0ea$exports(source);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iteratorMethod = $a8ef08465170b254$exports(O);
    var i, length, result, thisIsBigIntArray, value, step, iterator, next;
    if (iteratorMethod && !$3a74e6d6b81c5829$exports(iteratorMethod)) {
        iterator = $a2edd71662804e98$exports(O, iteratorMethod);
        next = iterator.next;
        O = [];
        while(!(step = $3b5393d57c251c61$exports(next, iterator)).done)O.push(step.value);
    }
    if (mapping && argumentsLength > 2) mapfn = $130f24665ebee510$exports(mapfn, arguments[2]);
    length = $ec53954e5de19898$exports(O);
    result = new ($aa6d3da0eb766a82$require$aTypedArrayConstructor(C))(length);
    thisIsBigIntArray = $6f59ecb0b3afd5cc$exports(result);
    for(i = 0; length > i; i++){
        value = mapping ? mapfn(O[i], i) : O[i];
        // FF30- typed arrays doesn't properly convert objects to typed array values
        result[i] = thisIsBigIntArray ? $6c06d186fb27caad$exports(value) : +value;
    }
    return result;
};



var $ce7423435ca54fad$require$forEach = $0c96980c391de2dd$exports.forEach;






var $ce7423435ca54fad$var$getInternalState = $dbe54846b72f85d1$exports.get;
var $ce7423435ca54fad$var$setInternalState = $dbe54846b72f85d1$exports.set;
var $ce7423435ca54fad$var$enforceInternalState = $dbe54846b72f85d1$exports.enforce;
var $ce7423435ca54fad$var$nativeDefineProperty = $783b6a5a940dee05$export$2d1720544b23b823;
var $ce7423435ca54fad$var$nativeGetOwnPropertyDescriptor = $dc708c9bcef7b78f$export$2d1720544b23b823;
var $ce7423435ca54fad$var$round = Math.round;
var $ce7423435ca54fad$var$RangeError = $1a6e68c95df7d4df$exports.RangeError;
var $ce7423435ca54fad$var$ArrayBuffer = $007b66ce508dac9e$exports.ArrayBuffer;
var $ce7423435ca54fad$var$ArrayBufferPrototype = $ce7423435ca54fad$var$ArrayBuffer.prototype;
var $ce7423435ca54fad$var$DataView = $007b66ce508dac9e$exports.DataView;
var $ce7423435ca54fad$var$NATIVE_ARRAY_BUFFER_VIEWS = $a8e31709e413942c$exports.NATIVE_ARRAY_BUFFER_VIEWS;
var $ce7423435ca54fad$var$TYPED_ARRAY_TAG = $a8e31709e413942c$exports.TYPED_ARRAY_TAG;
var $ce7423435ca54fad$var$TypedArray = $a8e31709e413942c$exports.TypedArray;
var $ce7423435ca54fad$var$TypedArrayPrototype = $a8e31709e413942c$exports.TypedArrayPrototype;
var $ce7423435ca54fad$var$aTypedArrayConstructor = $a8e31709e413942c$exports.aTypedArrayConstructor;
var $ce7423435ca54fad$var$isTypedArray = $a8e31709e413942c$exports.isTypedArray;
var $ce7423435ca54fad$var$BYTES_PER_ELEMENT = "BYTES_PER_ELEMENT";
var $ce7423435ca54fad$var$WRONG_LENGTH = "Wrong length";
var $ce7423435ca54fad$var$fromList = function(C, list) {
    $ce7423435ca54fad$var$aTypedArrayConstructor(C);
    var index = 0;
    var length = list.length;
    var result = new C(length);
    while(length > index)result[index] = list[index++];
    return result;
};
var $ce7423435ca54fad$var$addGetter = function(it, key) {
    $54b1e35819861675$exports(it, key, {
        configurable: true,
        get: function() {
            return $ce7423435ca54fad$var$getInternalState(this)[key];
        }
    });
};
var $ce7423435ca54fad$var$isArrayBuffer = function(it) {
    var klass;
    return $b82c3d945f0459c1$exports($ce7423435ca54fad$var$ArrayBufferPrototype, it) || (klass = $79ec051cbbc13a5e$exports(it)) == "ArrayBuffer" || klass == "SharedArrayBuffer";
};
var $ce7423435ca54fad$var$isTypedArrayIndex = function(target, key) {
    return $ce7423435ca54fad$var$isTypedArray(target) && !$0d71f82f3bc811d0$exports(key) && key in target && $7425af5a016c6a9f$exports(+key) && key >= 0;
};
var $ce7423435ca54fad$var$wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
    key = $df8c871456bcdfdf$exports(key);
    return $ce7423435ca54fad$var$isTypedArrayIndex(target, key) ? $d6bcb34392440d40$exports(2, target[key]) : $ce7423435ca54fad$var$nativeGetOwnPropertyDescriptor(target, key);
};
var $ce7423435ca54fad$var$wrappedDefineProperty = function defineProperty(target, key, descriptor) {
    key = $df8c871456bcdfdf$exports(key);
    if ($ce7423435ca54fad$var$isTypedArrayIndex(target, key) && $dfdc56bc53f57e69$exports(descriptor) && $ef59b581f0d1672b$exports(descriptor, "value") && !$ef59b581f0d1672b$exports(descriptor, "get") && !$ef59b581f0d1672b$exports(descriptor, "set") && !descriptor.configurable && (!$ef59b581f0d1672b$exports(descriptor, "writable") || descriptor.writable) && (!$ef59b581f0d1672b$exports(descriptor, "enumerable") || descriptor.enumerable)) {
        target[key] = descriptor.value;
        return target;
    }
    return $ce7423435ca54fad$var$nativeDefineProperty(target, key, descriptor);
};
if ($0ab298e69b752e0a$exports) {
    if (!$ce7423435ca54fad$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        $dc708c9bcef7b78f$export$2d1720544b23b823 = $ce7423435ca54fad$var$wrappedGetOwnPropertyDescriptor;
        $783b6a5a940dee05$export$2d1720544b23b823 = $ce7423435ca54fad$var$wrappedDefineProperty;
        $ce7423435ca54fad$var$addGetter($ce7423435ca54fad$var$TypedArrayPrototype, "buffer");
        $ce7423435ca54fad$var$addGetter($ce7423435ca54fad$var$TypedArrayPrototype, "byteOffset");
        $ce7423435ca54fad$var$addGetter($ce7423435ca54fad$var$TypedArrayPrototype, "byteLength");
        $ce7423435ca54fad$var$addGetter($ce7423435ca54fad$var$TypedArrayPrototype, "length");
    }
    $0365e955907213bd$exports({
        target: "Object",
        stat: true,
        forced: !$ce7423435ca54fad$var$NATIVE_ARRAY_BUFFER_VIEWS
    }, {
        getOwnPropertyDescriptor: $ce7423435ca54fad$var$wrappedGetOwnPropertyDescriptor,
        defineProperty: $ce7423435ca54fad$var$wrappedDefineProperty
    });
    $ce7423435ca54fad$exports = function(TYPE, wrapper, CLAMPED) {
        var BYTES = TYPE.match(/\d+/)[0] / 8;
        var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? "Clamped" : "") + "Array";
        var GETTER = "get" + TYPE;
        var SETTER = "set" + TYPE;
        var NativeTypedArrayConstructor = $1a6e68c95df7d4df$exports[CONSTRUCTOR_NAME];
        var TypedArrayConstructor = NativeTypedArrayConstructor;
        var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
        var exported = {};
        var getter = function(that, index) {
            var data = $ce7423435ca54fad$var$getInternalState(that);
            return data.view[GETTER](index * BYTES + data.byteOffset, true);
        };
        var setter = function(that, index, value) {
            var data = $ce7423435ca54fad$var$getInternalState(that);
            if (CLAMPED) value = (value = $ce7423435ca54fad$var$round(value)) < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
            data.view[SETTER](index * BYTES + data.byteOffset, value, true);
        };
        var addElement = function(that, index) {
            $ce7423435ca54fad$var$nativeDefineProperty(that, index, {
                get: function() {
                    return getter(this, index);
                },
                set: function(value) {
                    return setter(this, index, value);
                },
                enumerable: true
            });
        };
        if (!$ce7423435ca54fad$var$NATIVE_ARRAY_BUFFER_VIEWS) {
            TypedArrayConstructor = wrapper(function(that, data, offset, $length) {
                $a5a0f9cce104c4f5$exports(that, TypedArrayConstructorPrototype);
                var index = 0;
                var byteOffset = 0;
                var buffer, byteLength, length;
                if (!$dfdc56bc53f57e69$exports(data)) {
                    length = $44e5d8e78700c624$exports(data);
                    byteLength = length * BYTES;
                    buffer = new $ce7423435ca54fad$var$ArrayBuffer(byteLength);
                } else if ($ce7423435ca54fad$var$isArrayBuffer(data)) {
                    buffer = data;
                    byteOffset = $80465ccc3b649a7e$exports(offset, BYTES);
                    var $len = data.byteLength;
                    if ($length === undefined) {
                        if ($len % BYTES) throw $ce7423435ca54fad$var$RangeError($ce7423435ca54fad$var$WRONG_LENGTH);
                        byteLength = $len - byteOffset;
                        if (byteLength < 0) throw $ce7423435ca54fad$var$RangeError($ce7423435ca54fad$var$WRONG_LENGTH);
                    } else {
                        byteLength = $c2922a7ee9a4ab10$exports($length) * BYTES;
                        if (byteLength + byteOffset > $len) throw $ce7423435ca54fad$var$RangeError($ce7423435ca54fad$var$WRONG_LENGTH);
                    }
                    length = byteLength / BYTES;
                } else if ($ce7423435ca54fad$var$isTypedArray(data)) return $ce7423435ca54fad$var$fromList(TypedArrayConstructor, data);
                else return $3b5393d57c251c61$exports($aa6d3da0eb766a82$exports, TypedArrayConstructor, data);
                $ce7423435ca54fad$var$setInternalState(that, {
                    buffer: buffer,
                    byteOffset: byteOffset,
                    byteLength: byteLength,
                    length: length,
                    view: new $ce7423435ca54fad$var$DataView(buffer)
                });
                while(index < length)addElement(that, index++);
            });
            if ($a922355a1bcefb04$exports) $a922355a1bcefb04$exports(TypedArrayConstructor, $ce7423435ca54fad$var$TypedArray);
            TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = $290768129b19866b$exports($ce7423435ca54fad$var$TypedArrayPrototype);
        } else if ($bfc1573910ea5c36$exports) {
            TypedArrayConstructor = wrapper(function(dummy, data, typedArrayOffset, $length) {
                $a5a0f9cce104c4f5$exports(dummy, TypedArrayConstructorPrototype);
                return $93beb66cab49b410$exports(function() {
                    if (!$dfdc56bc53f57e69$exports(data)) return new NativeTypedArrayConstructor($44e5d8e78700c624$exports(data));
                    if ($ce7423435ca54fad$var$isArrayBuffer(data)) return $length !== undefined ? new NativeTypedArrayConstructor(data, $80465ccc3b649a7e$exports(typedArrayOffset, BYTES), $length) : typedArrayOffset !== undefined ? new NativeTypedArrayConstructor(data, $80465ccc3b649a7e$exports(typedArrayOffset, BYTES)) : new NativeTypedArrayConstructor(data);
                    if ($ce7423435ca54fad$var$isTypedArray(data)) return $ce7423435ca54fad$var$fromList(TypedArrayConstructor, data);
                    return $3b5393d57c251c61$exports($aa6d3da0eb766a82$exports, TypedArrayConstructor, data);
                }(), dummy, TypedArrayConstructor);
            });
            if ($a922355a1bcefb04$exports) $a922355a1bcefb04$exports(TypedArrayConstructor, $ce7423435ca54fad$var$TypedArray);
            $ce7423435ca54fad$require$forEach($ce7423435ca54fad$require$getOwnPropertyNames(NativeTypedArrayConstructor), function(key) {
                if (!(key in TypedArrayConstructor)) $4716626f874fe5a3$exports(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
            });
            TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
        }
        if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) $4716626f874fe5a3$exports(TypedArrayConstructorPrototype, "constructor", TypedArrayConstructor);
        $ce7423435ca54fad$var$enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;
        if ($ce7423435ca54fad$var$TYPED_ARRAY_TAG) $4716626f874fe5a3$exports(TypedArrayConstructorPrototype, $ce7423435ca54fad$var$TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
        var FORCED = TypedArrayConstructor != NativeTypedArrayConstructor;
        exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;
        $0365e955907213bd$exports({
            global: true,
            constructor: true,
            forced: FORCED,
            sham: !$ce7423435ca54fad$var$NATIVE_ARRAY_BUFFER_VIEWS
        }, exported);
        if (!($ce7423435ca54fad$var$BYTES_PER_ELEMENT in TypedArrayConstructor)) $4716626f874fe5a3$exports(TypedArrayConstructor, $ce7423435ca54fad$var$BYTES_PER_ELEMENT, BYTES);
        if (!($ce7423435ca54fad$var$BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) $4716626f874fe5a3$exports(TypedArrayConstructorPrototype, $ce7423435ca54fad$var$BYTES_PER_ELEMENT, BYTES);
        $60a2ce15ea97c905$exports(CONSTRUCTOR_NAME);
    };
} else $ce7423435ca54fad$exports = function() {};


// `Float32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$ce7423435ca54fad$exports("Float32", function(init) {
    return function Float32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



// `Float64Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$ce7423435ca54fad$exports("Float64", function(init) {
    return function Float64Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



// `Int8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$ce7423435ca54fad$exports("Int8", function(init) {
    return function Int8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



// `Int16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$ce7423435ca54fad$exports("Int16", function(init) {
    return function Int16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



// `Int32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$ce7423435ca54fad$exports("Int32", function(init) {
    return function Int32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$ce7423435ca54fad$exports("Uint8", function(init) {
    return function Uint8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



// `Uint8ClampedArray` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$ce7423435ca54fad$exports("Uint8", function(init) {
    return function Uint8ClampedArray(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
}, true);



// `Uint16Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$ce7423435ca54fad$exports("Uint16", function(init) {
    return function Uint16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



// `Uint32Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$ce7423435ca54fad$exports("Uint32", function(init) {
    return function Uint32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


"use strict";



var $c4580fa2788f2c87$var$u$ArrayCopyWithin = $c510c74e58563f95$exports($347339e081515603$exports);
var $c4580fa2788f2c87$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $c4580fa2788f2c87$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
$c4580fa2788f2c87$var$exportTypedArrayMethod("copyWithin", function copyWithin(target, start /* , end */ ) {
    return $c4580fa2788f2c87$var$u$ArrayCopyWithin($c4580fa2788f2c87$var$aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
});


"use strict";


var $c9f53f05bcf13a5c$require$$every = $0c96980c391de2dd$exports.every;
var $c9f53f05bcf13a5c$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $c9f53f05bcf13a5c$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.every` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
$c9f53f05bcf13a5c$var$exportTypedArrayMethod("every", function every(callbackfn /* , thisArg */ ) {
    return $c9f53f05bcf13a5c$require$$every($c9f53f05bcf13a5c$var$aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


"use strict";







var $dc906ec18eb57cf2$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $dc906ec18eb57cf2$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
var $dc906ec18eb57cf2$var$slice = $c510c74e58563f95$exports("".slice);
// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
var $dc906ec18eb57cf2$var$CONVERSION_BUG = $4cefcb1c1c1fa750$exports(function() {
    var count = 0;
    // eslint-disable-next-line es/no-typed-arrays -- safe
    new Int8Array(2).fill({
        valueOf: function() {
            return count++;
        }
    });
    return count !== 1;
});
// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
$dc906ec18eb57cf2$var$exportTypedArrayMethod("fill", function fill(value /* , start, end */ ) {
    var length = arguments.length;
    $dc906ec18eb57cf2$var$aTypedArray(this);
    var actualValue = $dc906ec18eb57cf2$var$slice($79ec051cbbc13a5e$exports(this), 0, 3) === "Big" ? $6c06d186fb27caad$exports(value) : +value;
    return $3b5393d57c251c61$exports($89c606f05ba71d51$exports, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
}, $dc906ec18eb57cf2$var$CONVERSION_BUG);


"use strict";


var $67827e18a023e1e3$require$$filter = $0c96980c391de2dd$exports.filter;
var $68e832cfd70905b8$exports = {};
var $b9f89b50b36488b9$exports = {};

$b9f89b50b36488b9$exports = function(Constructor, list) {
    var index = 0;
    var length = $ec53954e5de19898$exports(list);
    var result = new Constructor(length);
    while(length > index)result[index] = list[index++];
    return result;
};


var $a2e46773e4fde89c$exports = {};


var $a2e46773e4fde89c$var$aTypedArrayConstructor = $a8e31709e413942c$exports.aTypedArrayConstructor;
var $a2e46773e4fde89c$var$getTypedArrayConstructor = $a8e31709e413942c$exports.getTypedArrayConstructor;
// a part of `TypedArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#typedarray-species-create
$a2e46773e4fde89c$exports = function(originalArray) {
    return $a2e46773e4fde89c$var$aTypedArrayConstructor($a926216b9de7547b$exports(originalArray, $a2e46773e4fde89c$var$getTypedArrayConstructor(originalArray)));
};


$68e832cfd70905b8$exports = function(instance, list) {
    return $b9f89b50b36488b9$exports($a2e46773e4fde89c$exports(instance), list);
};


var $67827e18a023e1e3$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $67827e18a023e1e3$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.filter` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
$67827e18a023e1e3$var$exportTypedArrayMethod("filter", function filter(callbackfn /* , thisArg */ ) {
    var list = $67827e18a023e1e3$require$$filter($67827e18a023e1e3$var$aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return $68e832cfd70905b8$exports(this, list);
});


"use strict";


var $7d3eef9f0d2a9417$require$$find = $0c96980c391de2dd$exports.find;
var $7d3eef9f0d2a9417$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $7d3eef9f0d2a9417$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.find` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
$7d3eef9f0d2a9417$var$exportTypedArrayMethod("find", function find(predicate /* , thisArg */ ) {
    return $7d3eef9f0d2a9417$require$$find($7d3eef9f0d2a9417$var$aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


"use strict";


var $48a15260fd1feac2$require$$findIndex = $0c96980c391de2dd$exports.findIndex;
var $48a15260fd1feac2$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $48a15260fd1feac2$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
$48a15260fd1feac2$var$exportTypedArrayMethod("findIndex", function findIndex(predicate /* , thisArg */ ) {
    return $48a15260fd1feac2$require$$findIndex($48a15260fd1feac2$var$aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


"use strict";


var $0c05ec8f28828ee2$require$$forEach = $0c96980c391de2dd$exports.forEach;
var $0c05ec8f28828ee2$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $0c05ec8f28828ee2$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.forEach` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
$0c05ec8f28828ee2$var$exportTypedArrayMethod("forEach", function forEach(callbackfn /* , thisArg */ ) {
    $0c05ec8f28828ee2$require$$forEach($0c05ec8f28828ee2$var$aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


"use strict";


var $543f8e5a9d7fabeb$require$exportTypedArrayStaticMethod = $a8e31709e413942c$exports.exportTypedArrayStaticMethod;

// `%TypedArray%.from` method
// https://tc39.es/ecma262/#sec-%typedarray%.from
$543f8e5a9d7fabeb$require$exportTypedArrayStaticMethod("from", $aa6d3da0eb766a82$exports, $bfc1573910ea5c36$exports);


"use strict";


var $5b2716cc63399279$require$$includes = $3b631fee8f1ba65e$exports.includes;
var $5b2716cc63399279$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $5b2716cc63399279$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.includes` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
$5b2716cc63399279$var$exportTypedArrayMethod("includes", function includes(searchElement /* , fromIndex */ ) {
    return $5b2716cc63399279$require$$includes($5b2716cc63399279$var$aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


"use strict";


var $5d8b2c716ba1ab03$require$$indexOf = $3b631fee8f1ba65e$exports.indexOf;
var $5d8b2c716ba1ab03$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $5d8b2c716ba1ab03$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
$5d8b2c716ba1ab03$var$exportTypedArrayMethod("indexOf", function indexOf(searchElement /* , fromIndex */ ) {
    return $5d8b2c716ba1ab03$require$$indexOf($5d8b2c716ba1ab03$var$aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


"use strict";






var $07c34962846a0b46$var$ITERATOR = $5cfcb69f0877711f$exports("iterator");
var $07c34962846a0b46$var$Uint8Array = $1a6e68c95df7d4df$exports.Uint8Array;
var $07c34962846a0b46$var$arrayValues = $c510c74e58563f95$exports($5b481a5e03898dba$exports.values);
var $07c34962846a0b46$var$arrayKeys = $c510c74e58563f95$exports($5b481a5e03898dba$exports.keys);
var $07c34962846a0b46$var$arrayEntries = $c510c74e58563f95$exports($5b481a5e03898dba$exports.entries);
var $07c34962846a0b46$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $07c34962846a0b46$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
var $07c34962846a0b46$var$TypedArrayPrototype = $07c34962846a0b46$var$Uint8Array && $07c34962846a0b46$var$Uint8Array.prototype;
var $07c34962846a0b46$var$GENERIC = !$4cefcb1c1c1fa750$exports(function() {
    $07c34962846a0b46$var$TypedArrayPrototype[$07c34962846a0b46$var$ITERATOR].call([
        1
    ]);
});
var $07c34962846a0b46$var$ITERATOR_IS_VALUES = !!$07c34962846a0b46$var$TypedArrayPrototype && $07c34962846a0b46$var$TypedArrayPrototype.values && $07c34962846a0b46$var$TypedArrayPrototype[$07c34962846a0b46$var$ITERATOR] === $07c34962846a0b46$var$TypedArrayPrototype.values && $07c34962846a0b46$var$TypedArrayPrototype.values.name === "values";
var $07c34962846a0b46$var$typedArrayValues = function values() {
    return $07c34962846a0b46$var$arrayValues($07c34962846a0b46$var$aTypedArray(this));
};
// `%TypedArray%.prototype.entries` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
$07c34962846a0b46$var$exportTypedArrayMethod("entries", function entries() {
    return $07c34962846a0b46$var$arrayEntries($07c34962846a0b46$var$aTypedArray(this));
}, $07c34962846a0b46$var$GENERIC);
// `%TypedArray%.prototype.keys` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
$07c34962846a0b46$var$exportTypedArrayMethod("keys", function keys() {
    return $07c34962846a0b46$var$arrayKeys($07c34962846a0b46$var$aTypedArray(this));
}, $07c34962846a0b46$var$GENERIC);
// `%TypedArray%.prototype.values` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
$07c34962846a0b46$var$exportTypedArrayMethod("values", $07c34962846a0b46$var$typedArrayValues, $07c34962846a0b46$var$GENERIC || !$07c34962846a0b46$var$ITERATOR_IS_VALUES, {
    name: "values"
});
// `%TypedArray%.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
$07c34962846a0b46$var$exportTypedArrayMethod($07c34962846a0b46$var$ITERATOR, $07c34962846a0b46$var$typedArrayValues, $07c34962846a0b46$var$GENERIC || !$07c34962846a0b46$var$ITERATOR_IS_VALUES, {
    name: "values"
});


"use strict";


var $de9d7e1873122ef8$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $de9d7e1873122ef8$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
var $de9d7e1873122ef8$var$$join = $c510c74e58563f95$exports([].join);
// `%TypedArray%.prototype.join` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
$de9d7e1873122ef8$var$exportTypedArrayMethod("join", function join(separator) {
    return $de9d7e1873122ef8$var$$join($de9d7e1873122ef8$var$aTypedArray(this), separator);
});


"use strict";



var $6dd86f0ea008ff05$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $6dd86f0ea008ff05$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
$6dd86f0ea008ff05$var$exportTypedArrayMethod("lastIndexOf", function lastIndexOf(searchElement /* , fromIndex */ ) {
    var length = arguments.length;
    return $17764d41e6b47061$exports($de6f1142e53db5c4$exports, $6dd86f0ea008ff05$var$aTypedArray(this), length > 1 ? [
        searchElement,
        arguments[1]
    ] : [
        searchElement
    ]);
});


"use strict";


var $b3475034b73425ce$require$$map = $0c96980c391de2dd$exports.map;

var $b3475034b73425ce$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $b3475034b73425ce$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.map` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
$b3475034b73425ce$var$exportTypedArrayMethod("map", function map(mapfn /* , thisArg */ ) {
    return $b3475034b73425ce$require$$map($b3475034b73425ce$var$aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function(O, length) {
        return new ($a2e46773e4fde89c$exports(O))(length);
    });
});


"use strict";


var $ba00a5771b126db0$var$aTypedArrayConstructor = $a8e31709e413942c$exports.aTypedArrayConstructor;
var $ba00a5771b126db0$var$exportTypedArrayStaticMethod = $a8e31709e413942c$exports.exportTypedArrayStaticMethod;
// `%TypedArray%.of` method
// https://tc39.es/ecma262/#sec-%typedarray%.of
$ba00a5771b126db0$var$exportTypedArrayStaticMethod("of", function of() {
    var index = 0;
    var length = arguments.length;
    var result = new ($ba00a5771b126db0$var$aTypedArrayConstructor(this))(length);
    while(length > index)result[index] = arguments[index++];
    return result;
}, $bfc1573910ea5c36$exports);


"use strict";


var $eef0d72cd28b9ad1$require$$reduce = $0a70de46188cd26d$exports.left;
var $eef0d72cd28b9ad1$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $eef0d72cd28b9ad1$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.reduce` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
$eef0d72cd28b9ad1$var$exportTypedArrayMethod("reduce", function reduce(callbackfn /* , initialValue */ ) {
    var length = arguments.length;
    return $eef0d72cd28b9ad1$require$$reduce($eef0d72cd28b9ad1$var$aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});


"use strict";


var $65209fc286823c01$require$$reduceRight = $0a70de46188cd26d$exports.right;
var $65209fc286823c01$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $65209fc286823c01$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
$65209fc286823c01$var$exportTypedArrayMethod("reduceRight", function reduceRight(callbackfn /* , initialValue */ ) {
    var length = arguments.length;
    return $65209fc286823c01$require$$reduceRight($65209fc286823c01$var$aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});


"use strict";

var $b391a36f333b556e$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $b391a36f333b556e$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
var $b391a36f333b556e$var$floor = Math.floor;
// `%TypedArray%.prototype.reverse` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
$b391a36f333b556e$var$exportTypedArrayMethod("reverse", function reverse() {
    var that = this;
    var length = $b391a36f333b556e$var$aTypedArray(that).length;
    var middle = $b391a36f333b556e$var$floor(length / 2);
    var index = 0;
    var value;
    while(index < middle){
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
    }
    return that;
});


"use strict";







var $4684c9b70024ab13$var$RangeError = $1a6e68c95df7d4df$exports.RangeError;
var $4684c9b70024ab13$var$Int8Array = $1a6e68c95df7d4df$exports.Int8Array;
var $4684c9b70024ab13$var$Int8ArrayPrototype = $4684c9b70024ab13$var$Int8Array && $4684c9b70024ab13$var$Int8Array.prototype;
var $4684c9b70024ab13$var$$set = $4684c9b70024ab13$var$Int8ArrayPrototype && $4684c9b70024ab13$var$Int8ArrayPrototype.set;
var $4684c9b70024ab13$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $4684c9b70024ab13$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
var $4684c9b70024ab13$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !$4cefcb1c1c1fa750$exports(function() {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    var array = new Uint8ClampedArray(2);
    $3b5393d57c251c61$exports($4684c9b70024ab13$var$$set, array, {
        length: 1,
        0: 3
    }, 1);
    return array[1] !== 3;
});
// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var $4684c9b70024ab13$var$TO_OBJECT_BUG = $4684c9b70024ab13$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && $a8e31709e413942c$exports.NATIVE_ARRAY_BUFFER_VIEWS && $4cefcb1c1c1fa750$exports(function() {
    var array = new $4684c9b70024ab13$var$Int8Array(2);
    array.set(1);
    array.set("2", 1);
    return array[0] !== 0 || array[1] !== 2;
});
// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
$4684c9b70024ab13$var$exportTypedArrayMethod("set", function set(arrayLike /* , offset */ ) {
    $4684c9b70024ab13$var$aTypedArray(this);
    var offset = $80465ccc3b649a7e$exports(arguments.length > 1 ? arguments[1] : undefined, 1);
    var src = $cc6f28a96f61f0ea$exports(arrayLike);
    if ($4684c9b70024ab13$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return $3b5393d57c251c61$exports($4684c9b70024ab13$var$$set, this, src, offset);
    var length = this.length;
    var len = $ec53954e5de19898$exports(src);
    var index = 0;
    if (len + offset > length) throw $4684c9b70024ab13$var$RangeError("Wrong length");
    while(index < len)this[offset + index] = src[index++];
}, !$4684c9b70024ab13$var$WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || $4684c9b70024ab13$var$TO_OBJECT_BUG);


"use strict";




var $42dfdd67d76e8a32$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $42dfdd67d76e8a32$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
var $42dfdd67d76e8a32$var$FORCED = $4cefcb1c1c1fa750$exports(function() {
    // eslint-disable-next-line es/no-typed-arrays -- required for testing
    new Int8Array(1).slice();
});
// `%TypedArray%.prototype.slice` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
$42dfdd67d76e8a32$var$exportTypedArrayMethod("slice", function slice(start, end) {
    var list = $05068435b6a808dd$exports($42dfdd67d76e8a32$var$aTypedArray(this), start, end);
    var C = $a2e46773e4fde89c$exports(this);
    var index = 0;
    var length = list.length;
    var result = new C(length);
    while(length > index)result[index] = list[index++];
    return result;
}, $42dfdd67d76e8a32$var$FORCED);


"use strict";


var $2afa7d5568faf7f5$require$$some = $0c96980c391de2dd$exports.some;
var $2afa7d5568faf7f5$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $2afa7d5568faf7f5$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.some` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
$2afa7d5568faf7f5$var$exportTypedArrayMethod("some", function some(callbackfn /* , thisArg */ ) {
    return $2afa7d5568faf7f5$require$$some($2afa7d5568faf7f5$var$aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


"use strict";










var $5e992dd636ff0272$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $5e992dd636ff0272$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
var $5e992dd636ff0272$var$Uint16Array = $1a6e68c95df7d4df$exports.Uint16Array;
var $5e992dd636ff0272$var$nativeSort = $5e992dd636ff0272$var$Uint16Array && $31a67080629c484a$exports($5e992dd636ff0272$var$Uint16Array.prototype.sort);
// WebKit
var $5e992dd636ff0272$var$ACCEPT_INCORRECT_ARGUMENTS = !!$5e992dd636ff0272$var$nativeSort && !($4cefcb1c1c1fa750$exports(function() {
    $5e992dd636ff0272$var$nativeSort(new $5e992dd636ff0272$var$Uint16Array(2), null);
}) && $4cefcb1c1c1fa750$exports(function() {
    $5e992dd636ff0272$var$nativeSort(new $5e992dd636ff0272$var$Uint16Array(2), {});
}));
var $5e992dd636ff0272$var$STABLE_SORT = !!$5e992dd636ff0272$var$nativeSort && !$4cefcb1c1c1fa750$exports(function() {
    // feature detection can be too slow, so check engines versions
    if ($44f41d0bd747502d$exports) return $44f41d0bd747502d$exports < 74;
    if ($f42060667397ebc3$exports) return $f42060667397ebc3$exports < 67;
    if ($1449583c7adb3089$exports) return true;
    if ($b8c60ffaf51233fe$exports) return $b8c60ffaf51233fe$exports < 602;
    var array = new $5e992dd636ff0272$var$Uint16Array(516);
    var expected = Array(516);
    var index, mod;
    for(index = 0; index < 516; index++){
        mod = index % 4;
        array[index] = 515 - index;
        expected[index] = index - 2 * mod + 3;
    }
    $5e992dd636ff0272$var$nativeSort(array, function(a, b) {
        return (a / 4 | 0) - (b / 4 | 0);
    });
    for(index = 0; index < 516; index++){
        if (array[index] !== expected[index]) return true;
    }
});
var $5e992dd636ff0272$var$getSortCompare = function(comparefn) {
    return function(x, y) {
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        // eslint-disable-next-line no-self-compare -- NaN check
        if (y !== y) return -1;
        // eslint-disable-next-line no-self-compare -- NaN check
        if (x !== x) return 1;
        if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
        return x > y;
    };
};
// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
$5e992dd636ff0272$var$exportTypedArrayMethod("sort", function sort(comparefn) {
    if (comparefn !== undefined) $4a6b57cf563748d0$exports(comparefn);
    if ($5e992dd636ff0272$var$STABLE_SORT) return $5e992dd636ff0272$var$nativeSort(this, comparefn);
    return $1867dfc0c25c2052$exports($5e992dd636ff0272$var$aTypedArray(this), $5e992dd636ff0272$var$getSortCompare(comparefn));
}, !$5e992dd636ff0272$var$STABLE_SORT || $5e992dd636ff0272$var$ACCEPT_INCORRECT_ARGUMENTS);


"use strict";




var $9184f2e8156704d2$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $9184f2e8156704d2$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
// `%TypedArray%.prototype.subarray` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
$9184f2e8156704d2$var$exportTypedArrayMethod("subarray", function subarray(begin, end) {
    var O = $9184f2e8156704d2$var$aTypedArray(this);
    var length = O.length;
    var beginIndex = $125a12a61907520f$exports(begin, length);
    var C = $a2e46773e4fde89c$exports(O);
    return new C(O.buffer, O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT, $c2922a7ee9a4ab10$exports((end === undefined ? length : $125a12a61907520f$exports(end, length)) - beginIndex));
});


"use strict";





var $5772f10a3cf2cacb$var$Int8Array = $1a6e68c95df7d4df$exports.Int8Array;
var $5772f10a3cf2cacb$var$aTypedArray = $a8e31709e413942c$exports.aTypedArray;
var $5772f10a3cf2cacb$var$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;
var $5772f10a3cf2cacb$var$$toLocaleString = [].toLocaleString;
// iOS Safari 6.x fails here
var $5772f10a3cf2cacb$var$TO_LOCALE_STRING_BUG = !!$5772f10a3cf2cacb$var$Int8Array && $4cefcb1c1c1fa750$exports(function() {
    $5772f10a3cf2cacb$var$$toLocaleString.call(new $5772f10a3cf2cacb$var$Int8Array(1));
});
var $5772f10a3cf2cacb$var$FORCED = $4cefcb1c1c1fa750$exports(function() {
    return [
        1,
        2
    ].toLocaleString() != new $5772f10a3cf2cacb$var$Int8Array([
        1,
        2
    ]).toLocaleString();
}) || !$4cefcb1c1c1fa750$exports(function() {
    $5772f10a3cf2cacb$var$Int8Array.prototype.toLocaleString.call([
        1,
        2
    ]);
});
// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
$5772f10a3cf2cacb$var$exportTypedArrayMethod("toLocaleString", function toLocaleString() {
    return $17764d41e6b47061$exports($5772f10a3cf2cacb$var$$toLocaleString, $5772f10a3cf2cacb$var$TO_LOCALE_STRING_BUG ? $05068435b6a808dd$exports($5772f10a3cf2cacb$var$aTypedArray(this)) : $5772f10a3cf2cacb$var$aTypedArray(this), $05068435b6a808dd$exports(arguments));
}, $5772f10a3cf2cacb$var$FORCED);


"use strict";

var $31c4e9a72f08f3f6$require$exportTypedArrayMethod = $a8e31709e413942c$exports.exportTypedArrayMethod;



var $31c4e9a72f08f3f6$var$Uint8Array = $1a6e68c95df7d4df$exports.Uint8Array;
var $31c4e9a72f08f3f6$var$Uint8ArrayPrototype = $31c4e9a72f08f3f6$var$Uint8Array && $31c4e9a72f08f3f6$var$Uint8Array.prototype || {};
var $31c4e9a72f08f3f6$var$arrayToString = [].toString;
var $31c4e9a72f08f3f6$var$join = $c510c74e58563f95$exports([].join);
if ($4cefcb1c1c1fa750$exports(function() {
    $31c4e9a72f08f3f6$var$arrayToString.call({});
})) $31c4e9a72f08f3f6$var$arrayToString = function toString() {
    return $31c4e9a72f08f3f6$var$join(this);
};
var $31c4e9a72f08f3f6$var$IS_NOT_ARRAY_METHOD = $31c4e9a72f08f3f6$var$Uint8ArrayPrototype.toString != $31c4e9a72f08f3f6$var$arrayToString;
// `%TypedArray%.prototype.toString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
$31c4e9a72f08f3f6$require$exportTypedArrayMethod("toString", $31c4e9a72f08f3f6$var$arrayToString, $31c4e9a72f08f3f6$var$IS_NOT_ARRAY_METHOD);


// TODO: Remove this module from `core-js@4` since it's replaced to module below
"use strict";






var $bc72a88496c2af24$exports = {};
"use strict";



var $bc72a88496c2af24$require$getWeakData = $23b16ea0b64c4091$exports.getWeakData;








var $bc72a88496c2af24$var$setInternalState = $dbe54846b72f85d1$exports.set;
var $bc72a88496c2af24$var$internalStateGetterFor = $dbe54846b72f85d1$exports.getterFor;
var $bc72a88496c2af24$var$find = $0c96980c391de2dd$exports.find;
var $bc72a88496c2af24$var$findIndex = $0c96980c391de2dd$exports.findIndex;
var $bc72a88496c2af24$var$splice = $c510c74e58563f95$exports([].splice);
var $bc72a88496c2af24$var$id = 0;
// fallback for uncaught frozen keys
var $bc72a88496c2af24$var$uncaughtFrozenStore = function(state) {
    return state.frozen || (state.frozen = new $bc72a88496c2af24$var$UncaughtFrozenStore());
};
var $bc72a88496c2af24$var$UncaughtFrozenStore = function() {
    this.entries = [];
};
var $bc72a88496c2af24$var$findUncaughtFrozen = function(store, key) {
    return $bc72a88496c2af24$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$bc72a88496c2af24$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $bc72a88496c2af24$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$bc72a88496c2af24$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $bc72a88496c2af24$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    "delete": function(key) {
        var index = $bc72a88496c2af24$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $bc72a88496c2af24$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
$bc72a88496c2af24$exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $a5a0f9cce104c4f5$exports(that, Prototype);
            $bc72a88496c2af24$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $bc72a88496c2af24$var$id++,
                frozen: undefined
            });
            if (!$784d9540a0abf25d$exports(iterable)) $7519ce181fecbd34$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $bc72a88496c2af24$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var data = $bc72a88496c2af24$require$getWeakData($830db860a045bbb5$exports(key), true);
            if (data === true) $bc72a88496c2af24$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $be8b41c0f3f6adf6$exports(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            "delete": function(key) {
                var state = getInternalState(this);
                if (!$dfdc56bc53f57e69$exports(key)) return false;
                var data = $bc72a88496c2af24$require$getWeakData(key);
                if (data === true) return $bc72a88496c2af24$var$uncaughtFrozenStore(state)["delete"](key);
                return data && $ef59b581f0d1672b$exports(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$dfdc56bc53f57e69$exports(key)) return false;
                var data = $bc72a88496c2af24$require$getWeakData(key);
                if (data === true) return $bc72a88496c2af24$var$uncaughtFrozenStore(state).has(key);
                return data && $ef59b581f0d1672b$exports(data, state.id);
            }
        });
        $be8b41c0f3f6adf6$exports(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($dfdc56bc53f57e69$exports(key)) {
                    var data = $bc72a88496c2af24$require$getWeakData(key);
                    if (data === true) return $bc72a88496c2af24$var$uncaughtFrozenStore(state).get(key);
                    return data ? data[state.id] : undefined;
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};




var $a0e6158dab694c27$require$enforceInternalState = $dbe54846b72f85d1$exports.enforce;


var $a0e6158dab694c27$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $a0e6158dab694c27$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $a0e6158dab694c27$var$isExtensible = $a0e6158dab694c27$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $a0e6158dab694c27$var$isFrozen = $a0e6158dab694c27$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $a0e6158dab694c27$var$isSealed = $a0e6158dab694c27$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $a0e6158dab694c27$var$freeze = $a0e6158dab694c27$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $a0e6158dab694c27$var$seal = $a0e6158dab694c27$var$$Object.seal;
var $a0e6158dab694c27$var$FROZEN = {};
var $a0e6158dab694c27$var$SEALED = {};
var $a0e6158dab694c27$var$IS_IE11 = !$1a6e68c95df7d4df$exports.ActiveXObject && "ActiveXObject" in $1a6e68c95df7d4df$exports;
var $a0e6158dab694c27$var$InternalWeakMap;
var $a0e6158dab694c27$var$wrapper = function(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $a0e6158dab694c27$var$$WeakMap = $112b243b75bec4f7$exports("WeakMap", $a0e6158dab694c27$var$wrapper, $bc72a88496c2af24$exports);
var $a0e6158dab694c27$var$WeakMapPrototype = $a0e6158dab694c27$var$$WeakMap.prototype;
var $a0e6158dab694c27$var$nativeSet = $c510c74e58563f95$exports($a0e6158dab694c27$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $a0e6158dab694c27$var$hasMSEdgeFreezingBug = function() {
    return $e00e52bc2d436bf2$exports && $4cefcb1c1c1fa750$exports(function() {
        var frozenArray = $a0e6158dab694c27$var$freeze([]);
        $a0e6158dab694c27$var$nativeSet(new $a0e6158dab694c27$var$$WeakMap(), frozenArray, 1);
        return !$a0e6158dab694c27$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($95fde8eb0bd69064$exports) {
    if ($a0e6158dab694c27$var$IS_IE11) {
        $a0e6158dab694c27$var$InternalWeakMap = $bc72a88496c2af24$exports.getConstructor($a0e6158dab694c27$var$wrapper, "WeakMap", true);
        $23b16ea0b64c4091$exports.enable();
        var $a0e6158dab694c27$var$nativeDelete = $c510c74e58563f95$exports($a0e6158dab694c27$var$WeakMapPrototype["delete"]);
        var $a0e6158dab694c27$var$nativeHas = $c510c74e58563f95$exports($a0e6158dab694c27$var$WeakMapPrototype.has);
        var $a0e6158dab694c27$var$nativeGet = $c510c74e58563f95$exports($a0e6158dab694c27$var$WeakMapPrototype.get);
        $be8b41c0f3f6adf6$exports($a0e6158dab694c27$var$WeakMapPrototype, {
            "delete": function(key) {
                if ($dfdc56bc53f57e69$exports(key) && !$a0e6158dab694c27$var$isExtensible(key)) {
                    var state = $a0e6158dab694c27$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $a0e6158dab694c27$var$InternalWeakMap();
                    return $a0e6158dab694c27$var$nativeDelete(this, key) || state.frozen["delete"](key);
                }
                return $a0e6158dab694c27$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($dfdc56bc53f57e69$exports(key) && !$a0e6158dab694c27$var$isExtensible(key)) {
                    var state = $a0e6158dab694c27$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $a0e6158dab694c27$var$InternalWeakMap();
                    return $a0e6158dab694c27$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $a0e6158dab694c27$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($dfdc56bc53f57e69$exports(key) && !$a0e6158dab694c27$var$isExtensible(key)) {
                    var state = $a0e6158dab694c27$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $a0e6158dab694c27$var$InternalWeakMap();
                    return $a0e6158dab694c27$var$nativeHas(this, key) ? $a0e6158dab694c27$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $a0e6158dab694c27$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($dfdc56bc53f57e69$exports(key) && !$a0e6158dab694c27$var$isExtensible(key)) {
                    var state = $a0e6158dab694c27$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $a0e6158dab694c27$var$InternalWeakMap();
                    $a0e6158dab694c27$var$nativeHas(this, key) ? $a0e6158dab694c27$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $a0e6158dab694c27$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($a0e6158dab694c27$var$hasMSEdgeFreezingBug()) $be8b41c0f3f6adf6$exports($a0e6158dab694c27$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($a0e6158dab694c27$var$isArray(key)) {
                if ($a0e6158dab694c27$var$isFrozen(key)) arrayIntegrityLevel = $a0e6158dab694c27$var$FROZEN;
                else if ($a0e6158dab694c27$var$isSealed(key)) arrayIntegrityLevel = $a0e6158dab694c27$var$SEALED;
            }
            $a0e6158dab694c27$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel == $a0e6158dab694c27$var$FROZEN) $a0e6158dab694c27$var$freeze(key);
            if (arrayIntegrityLevel == $a0e6158dab694c27$var$SEALED) $a0e6158dab694c27$var$seal(key);
            return this;
        }
    });
}




// TODO: Remove this module from `core-js@4` since it's replaced to module below
"use strict";


// `WeakSet` constructor
// https://tc39.es/ecma262/#sec-weakset-constructor
$112b243b75bec4f7$exports("WeakSet", function(init) {
    return function WeakSet() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
}, $bc72a88496c2af24$exports);





var $08a6592e5fd9dd2d$exports = {};
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
$08a6592e5fd9dd2d$exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};


var $3b627c902984a4c8$exports = {};
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`

var $3b627c902984a4c8$var$classList = $50f1c27ed88e8707$exports("span").classList;
var $3b627c902984a4c8$var$DOMTokenListPrototype = $3b627c902984a4c8$var$classList && $3b627c902984a4c8$var$classList.constructor && $3b627c902984a4c8$var$classList.constructor.prototype;
$3b627c902984a4c8$exports = $3b627c902984a4c8$var$DOMTokenListPrototype === Object.prototype ? undefined : $3b627c902984a4c8$var$DOMTokenListPrototype;




var $be42e88c3df127ad$var$handlePrototype = function(CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype && CollectionPrototype.forEach !== $29589bea0602ccd7$exports) try {
        $4716626f874fe5a3$exports(CollectionPrototype, "forEach", $29589bea0602ccd7$exports);
    } catch (error) {
        CollectionPrototype.forEach = $29589bea0602ccd7$exports;
    }
};
for(var $be42e88c3df127ad$var$COLLECTION_NAME in $08a6592e5fd9dd2d$exports)if ($08a6592e5fd9dd2d$exports[$be42e88c3df127ad$var$COLLECTION_NAME]) $be42e88c3df127ad$var$handlePrototype($1a6e68c95df7d4df$exports[$be42e88c3df127ad$var$COLLECTION_NAME] && $1a6e68c95df7d4df$exports[$be42e88c3df127ad$var$COLLECTION_NAME].prototype);
$be42e88c3df127ad$var$handlePrototype($3b627c902984a4c8$exports);








var $7502bceac938c158$var$ITERATOR = $5cfcb69f0877711f$exports("iterator");
var $7502bceac938c158$var$TO_STRING_TAG = $5cfcb69f0877711f$exports("toStringTag");
var $7502bceac938c158$var$ArrayValues = $5b481a5e03898dba$exports.values;
var $7502bceac938c158$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$7502bceac938c158$var$ITERATOR] !== $7502bceac938c158$var$ArrayValues) try {
            $4716626f874fe5a3$exports(CollectionPrototype, $7502bceac938c158$var$ITERATOR, $7502bceac938c158$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$7502bceac938c158$var$ITERATOR] = $7502bceac938c158$var$ArrayValues;
        }
        if (!CollectionPrototype[$7502bceac938c158$var$TO_STRING_TAG]) $4716626f874fe5a3$exports(CollectionPrototype, $7502bceac938c158$var$TO_STRING_TAG, COLLECTION_NAME);
        if ($08a6592e5fd9dd2d$exports[COLLECTION_NAME]) for(var METHOD_NAME in $5b481a5e03898dba$exports){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $5b481a5e03898dba$exports[METHOD_NAME]) try {
                $4716626f874fe5a3$exports(CollectionPrototype, METHOD_NAME, $5b481a5e03898dba$exports[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $5b481a5e03898dba$exports[METHOD_NAME];
            }
        }
    }
};
for(var $7502bceac938c158$var$COLLECTION_NAME in $08a6592e5fd9dd2d$exports)$7502bceac938c158$var$handlePrototype($1a6e68c95df7d4df$exports[$7502bceac938c158$var$COLLECTION_NAME] && $1a6e68c95df7d4df$exports[$7502bceac938c158$var$COLLECTION_NAME].prototype, $7502bceac938c158$var$COLLECTION_NAME);
$7502bceac938c158$var$handlePrototype($3b627c902984a4c8$exports, "DOMTokenList");


// TODO: Remove this module from `core-js@4` since it's split to modules listed below



var $e1c136237d79568b$require$clearImmediate = $80e525653e14cf75$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$0365e955907213bd$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $1a6e68c95df7d4df$exports.clearImmediate !== $e1c136237d79568b$require$clearImmediate
}, {
    clearImmediate: $e1c136237d79568b$require$clearImmediate
});





var $d277153acfdaee00$require$setTask = $80e525653e14cf75$exports.set;
var $23917205cf34042a$exports = {};
"use strict";



var $6f4ac0fd0abfa8c1$exports = {};
/* global Bun -- Deno case */ $6f4ac0fd0abfa8c1$exports = typeof Bun == "function" && Bun && typeof Bun.version == "string";





var $23917205cf34042a$var$Function = $1a6e68c95df7d4df$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $23917205cf34042a$var$WRAP = /MSIE .\./.test($59d28ac8b8f97183$exports) || $6f4ac0fd0abfa8c1$exports && function() {
    var version = $1a6e68c95df7d4df$exports.Bun.version.split(".");
    return version.length < 3 || version[0] == 0 && (version[1] < 3 || version[1] == 3 && version[2] == 0);
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$23917205cf34042a$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $23917205cf34042a$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $f035ac7c9e51e69e$exports(arguments.length, 1) > firstParamIndex;
        var fn = $c1d5f87f1e56c4cc$exports(handler) ? handler : $23917205cf34042a$var$Function(handler);
        var params = boundArgs ? $05068435b6a808dd$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $17764d41e6b47061$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $d277153acfdaee00$var$setImmediate = $1a6e68c95df7d4df$exports.setImmediate ? $23917205cf34042a$exports($d277153acfdaee00$require$setTask, false) : $d277153acfdaee00$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$0365e955907213bd$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $1a6e68c95df7d4df$exports.setImmediate !== $d277153acfdaee00$var$setImmediate
}, {
    setImmediate: $d277153acfdaee00$var$setImmediate
});










var $745e72c8da8a16a7$var$process = $1a6e68c95df7d4df$exports.process;
// `queueMicrotask` method
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-queuemicrotask
$0365e955907213bd$exports({
    global: true,
    enumerable: true,
    dontCallGetSet: true
}, {
    queueMicrotask: function queueMicrotask(fn) {
        $f035ac7c9e51e69e$exports(arguments.length, 1);
        $4a6b57cf563748d0$exports(fn);
        var domain = $9eb47e38a97c42de$exports && $745e72c8da8a16a7$var$process.domain;
        $5cb8439839cdfcfe$exports(domain ? domain.bind(fn) : fn);
    }
});


// TODO: Remove this module from `core-js@4` since it's split to modules listed below



var $6e1dd62f5a24f069$var$setInterval = $23917205cf34042a$exports($1a6e68c95df7d4df$exports.setInterval, true);
// Bun / IE9- setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
$0365e955907213bd$exports({
    global: true,
    bind: true,
    forced: $1a6e68c95df7d4df$exports.setInterval !== $6e1dd62f5a24f069$var$setInterval
}, {
    setInterval: $6e1dd62f5a24f069$var$setInterval
});





var $575508092209e454$var$setTimeout = $23917205cf34042a$exports($1a6e68c95df7d4df$exports.setTimeout, true);
// Bun / IE9- setTimeout additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
$0365e955907213bd$exports({
    global: true,
    bind: true,
    forced: $1a6e68c95df7d4df$exports.setTimeout !== $575508092209e454$var$setTimeout
}, {
    setTimeout: $575508092209e454$var$setTimeout
});




// TODO: Remove this module from `core-js@4` since it's replaced to module below
"use strict";



var $b844cc14116d1191$exports = {};




var $b844cc14116d1191$var$ITERATOR = $5cfcb69f0877711f$exports("iterator");
$b844cc14116d1191$exports = !$4cefcb1c1c1fa750$exports(function() {
    // eslint-disable-next-line unicorn/relative-url-style -- required for testing
    var url = new URL("b?a=1&b=2&c=3", "http://a");
    var searchParams = url.searchParams;
    var result = "";
    url.pathname = "c%20d";
    searchParams.forEach(function(value, key) {
        searchParams["delete"]("b");
        result += key + value;
    });
    return $fef1920ae5260386$exports && !url.toJSON || !searchParams.size && ($fef1920ae5260386$exports || !$0ab298e69b752e0a$exports) || !searchParams.sort || url.href !== "http://a/c%20d?a=1&c=3" || searchParams.get("c") !== "3" || String(new URLSearchParams("?a=1")) !== "a=1" || !searchParams[$b844cc14116d1191$var$ITERATOR] || new URL("https://a@b").username !== "a" || new URLSearchParams(new URLSearchParams("a=b")).get("a") !== "b" || new URL("http://тест").host !== "xn--e1aybc" || new URL("http://a#б").hash !== "#%D0%B1" || result !== "a1c3" || new URL("http://x", undefined).host !== "x";
});













var $e609253e41b01d42$require$codeAt = $3f5631712605e16e$exports.codeAt;
var $47b3790baa06f789$exports = {};
// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js

var $47b3790baa06f789$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var $47b3790baa06f789$var$base = 36;
var $47b3790baa06f789$var$tMin = 1;
var $47b3790baa06f789$var$tMax = 26;
var $47b3790baa06f789$var$skew = 38;
var $47b3790baa06f789$var$damp = 700;
var $47b3790baa06f789$var$initialBias = 72;
var $47b3790baa06f789$var$initialN = 128; // 0x80
var $47b3790baa06f789$var$delimiter = "-"; // '\x2D'
var $47b3790baa06f789$var$regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var $47b3790baa06f789$var$regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var $47b3790baa06f789$var$OVERFLOW_ERROR = "Overflow: input needs wider integers to process";
var $47b3790baa06f789$var$baseMinusTMin = $47b3790baa06f789$var$base - $47b3790baa06f789$var$tMin;
var $47b3790baa06f789$var$$RangeError = RangeError;
var $47b3790baa06f789$var$exec = $c510c74e58563f95$exports($47b3790baa06f789$var$regexSeparators.exec);
var $47b3790baa06f789$var$floor = Math.floor;
var $47b3790baa06f789$var$fromCharCode = String.fromCharCode;
var $47b3790baa06f789$var$charCodeAt = $c510c74e58563f95$exports("".charCodeAt);
var $47b3790baa06f789$var$join = $c510c74e58563f95$exports([].join);
var $47b3790baa06f789$var$push = $c510c74e58563f95$exports([].push);
var $47b3790baa06f789$var$replace = $c510c74e58563f95$exports("".replace);
var $47b3790baa06f789$var$split = $c510c74e58563f95$exports("".split);
var $47b3790baa06f789$var$toLowerCase = $c510c74e58563f95$exports("".toLowerCase);
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */ var $47b3790baa06f789$var$ucs2decode = function(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = $47b3790baa06f789$var$charCodeAt(string, counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            var extra = $47b3790baa06f789$var$charCodeAt(string, counter++);
            if ((extra & 0xFC00) == 0xDC00) $47b3790baa06f789$var$push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                $47b3790baa06f789$var$push(output, value);
                counter--;
            }
        } else $47b3790baa06f789$var$push(output, value);
    }
    return output;
};
/**
 * Converts a digit/integer into a basic code point.
 */ var $47b3790baa06f789$var$digitToBasic = function(digit) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */ var $47b3790baa06f789$var$adapt = function(delta, numPoints, firstTime) {
    var k = 0;
    delta = firstTime ? $47b3790baa06f789$var$floor(delta / $47b3790baa06f789$var$damp) : delta >> 1;
    delta += $47b3790baa06f789$var$floor(delta / numPoints);
    while(delta > $47b3790baa06f789$var$baseMinusTMin * $47b3790baa06f789$var$tMax >> 1){
        delta = $47b3790baa06f789$var$floor(delta / $47b3790baa06f789$var$baseMinusTMin);
        k += $47b3790baa06f789$var$base;
    }
    return $47b3790baa06f789$var$floor(k + ($47b3790baa06f789$var$baseMinusTMin + 1) * delta / (delta + $47b3790baa06f789$var$skew));
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */ var $47b3790baa06f789$var$encode = function(input) {
    var output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $47b3790baa06f789$var$ucs2decode(input);
    // Cache the length.
    var inputLength = input.length;
    // Initialize the state.
    var n = $47b3790baa06f789$var$initialN;
    var delta = 0;
    var bias = $47b3790baa06f789$var$initialBias;
    var i, currentValue;
    // Handle the basic code points.
    for(i = 0; i < input.length; i++){
        currentValue = input[i];
        if (currentValue < 0x80) $47b3790baa06f789$var$push(output, $47b3790baa06f789$var$fromCharCode(currentValue));
    }
    var basicLength = output.length; // number of basic code points.
    var handledCPCount = basicLength; // number of code points that have been handled;
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) $47b3790baa06f789$var$push(output, $47b3790baa06f789$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next larger one:
        var m = $47b3790baa06f789$var$maxInt;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue >= n && currentValue < m) m = currentValue;
        }
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
        var handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $47b3790baa06f789$var$floor(($47b3790baa06f789$var$maxInt - delta) / handledCPCountPlusOne)) throw $47b3790baa06f789$var$$RangeError($47b3790baa06f789$var$OVERFLOW_ERROR);
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue < n && ++delta > $47b3790baa06f789$var$maxInt) throw $47b3790baa06f789$var$$RangeError($47b3790baa06f789$var$OVERFLOW_ERROR);
            if (currentValue == n) {
                // Represent delta as a generalized variable-length integer.
                var q = delta;
                var k = $47b3790baa06f789$var$base;
                while(true){
                    var t = k <= bias ? $47b3790baa06f789$var$tMin : k >= bias + $47b3790baa06f789$var$tMax ? $47b3790baa06f789$var$tMax : k - bias;
                    if (q < t) break;
                    var qMinusT = q - t;
                    var baseMinusT = $47b3790baa06f789$var$base - t;
                    $47b3790baa06f789$var$push(output, $47b3790baa06f789$var$fromCharCode($47b3790baa06f789$var$digitToBasic(t + qMinusT % baseMinusT)));
                    q = $47b3790baa06f789$var$floor(qMinusT / baseMinusT);
                    k += $47b3790baa06f789$var$base;
                }
                $47b3790baa06f789$var$push(output, $47b3790baa06f789$var$fromCharCode($47b3790baa06f789$var$digitToBasic(q)));
                bias = $47b3790baa06f789$var$adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                delta = 0;
                handledCPCount++;
            }
        }
        delta++;
        n++;
    }
    return $47b3790baa06f789$var$join(output, "");
};
$47b3790baa06f789$exports = function(input) {
    var encoded = [];
    var labels = $47b3790baa06f789$var$split($47b3790baa06f789$var$replace($47b3790baa06f789$var$toLowerCase(input), $47b3790baa06f789$var$regexSeparators, "."), ".");
    var i, label;
    for(i = 0; i < labels.length; i++){
        label = labels[i];
        $47b3790baa06f789$var$push(encoded, $47b3790baa06f789$var$exec($47b3790baa06f789$var$regexNonASCII, label) ? "xn--" + $47b3790baa06f789$var$encode(label) : label);
    }
    return $47b3790baa06f789$var$join(encoded, ".");
};





var $50e11b476cac33b7$exports = {};
"use strict";




























var $50e11b476cac33b7$var$ITERATOR = $5cfcb69f0877711f$exports("iterator");
var $50e11b476cac33b7$var$URL_SEARCH_PARAMS = "URLSearchParams";
var $50e11b476cac33b7$var$URL_SEARCH_PARAMS_ITERATOR = $50e11b476cac33b7$var$URL_SEARCH_PARAMS + "Iterator";
var $50e11b476cac33b7$var$setInternalState = $dbe54846b72f85d1$exports.set;
var $50e11b476cac33b7$var$getInternalParamsState = $dbe54846b72f85d1$exports.getterFor($50e11b476cac33b7$var$URL_SEARCH_PARAMS);
var $50e11b476cac33b7$var$getInternalIteratorState = $dbe54846b72f85d1$exports.getterFor($50e11b476cac33b7$var$URL_SEARCH_PARAMS_ITERATOR);
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $50e11b476cac33b7$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Avoid NodeJS experimental warning
var $50e11b476cac33b7$var$safeGetBuiltIn = function(name) {
    if (!$0ab298e69b752e0a$exports) return $1a6e68c95df7d4df$exports[name];
    var descriptor = $50e11b476cac33b7$var$getOwnPropertyDescriptor($1a6e68c95df7d4df$exports, name);
    return descriptor && descriptor.value;
};
var $50e11b476cac33b7$var$nativeFetch = $50e11b476cac33b7$var$safeGetBuiltIn("fetch");
var $50e11b476cac33b7$var$NativeRequest = $50e11b476cac33b7$var$safeGetBuiltIn("Request");
var $50e11b476cac33b7$var$Headers = $50e11b476cac33b7$var$safeGetBuiltIn("Headers");
var $50e11b476cac33b7$var$RequestPrototype = $50e11b476cac33b7$var$NativeRequest && $50e11b476cac33b7$var$NativeRequest.prototype;
var $50e11b476cac33b7$var$HeadersPrototype = $50e11b476cac33b7$var$Headers && $50e11b476cac33b7$var$Headers.prototype;
var $50e11b476cac33b7$var$RegExp = $1a6e68c95df7d4df$exports.RegExp;
var $50e11b476cac33b7$var$TypeError = $1a6e68c95df7d4df$exports.TypeError;
var $50e11b476cac33b7$var$decodeURIComponent = $1a6e68c95df7d4df$exports.decodeURIComponent;
var $50e11b476cac33b7$var$encodeURIComponent = $1a6e68c95df7d4df$exports.encodeURIComponent;
var $50e11b476cac33b7$var$charAt = $c510c74e58563f95$exports("".charAt);
var $50e11b476cac33b7$var$join = $c510c74e58563f95$exports([].join);
var $50e11b476cac33b7$var$push = $c510c74e58563f95$exports([].push);
var $50e11b476cac33b7$var$replace = $c510c74e58563f95$exports("".replace);
var $50e11b476cac33b7$var$shift = $c510c74e58563f95$exports([].shift);
var $50e11b476cac33b7$var$splice = $c510c74e58563f95$exports([].splice);
var $50e11b476cac33b7$var$split = $c510c74e58563f95$exports("".split);
var $50e11b476cac33b7$var$stringSlice = $c510c74e58563f95$exports("".slice);
var $50e11b476cac33b7$var$plus = /\+/g;
var $50e11b476cac33b7$var$sequences = Array(4);
var $50e11b476cac33b7$var$percentSequence = function(bytes) {
    return $50e11b476cac33b7$var$sequences[bytes - 1] || ($50e11b476cac33b7$var$sequences[bytes - 1] = $50e11b476cac33b7$var$RegExp("((?:%[\\da-f]{2}){" + bytes + "})", "gi"));
};
var $50e11b476cac33b7$var$percentDecode = function(sequence) {
    try {
        return $50e11b476cac33b7$var$decodeURIComponent(sequence);
    } catch (error) {
        return sequence;
    }
};
var $50e11b476cac33b7$var$deserialize = function(it) {
    var result = $50e11b476cac33b7$var$replace(it, $50e11b476cac33b7$var$plus, " ");
    var bytes = 4;
    try {
        return $50e11b476cac33b7$var$decodeURIComponent(result);
    } catch (error) {
        while(bytes)result = $50e11b476cac33b7$var$replace(result, $50e11b476cac33b7$var$percentSequence(bytes--), $50e11b476cac33b7$var$percentDecode);
        return result;
    }
};
var $50e11b476cac33b7$var$find = /[!'()~]|%20/g;
var $50e11b476cac33b7$var$replacements = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
};
var $50e11b476cac33b7$var$replacer = function(match) {
    return $50e11b476cac33b7$var$replacements[match];
};
var $50e11b476cac33b7$var$serialize = function(it) {
    return $50e11b476cac33b7$var$replace($50e11b476cac33b7$var$encodeURIComponent(it), $50e11b476cac33b7$var$find, $50e11b476cac33b7$var$replacer);
};
var $50e11b476cac33b7$var$URLSearchParamsIterator = $7d1f368d6c8845ca$exports(function Iterator(params, kind) {
    $50e11b476cac33b7$var$setInternalState(this, {
        type: $50e11b476cac33b7$var$URL_SEARCH_PARAMS_ITERATOR,
        iterator: $a2edd71662804e98$exports($50e11b476cac33b7$var$getInternalParamsState(params).entries),
        kind: kind
    });
}, "Iterator", function next() {
    var state = $50e11b476cac33b7$var$getInternalIteratorState(this);
    var kind = state.kind;
    var step = state.iterator.next();
    var entry = step.value;
    if (!step.done) step.value = kind === "keys" ? entry.key : kind === "values" ? entry.value : [
        entry.key,
        entry.value
    ];
    return step;
}, true);
var $50e11b476cac33b7$var$URLSearchParamsState = function(init) {
    this.entries = [];
    this.url = null;
    if (init !== undefined) {
        if ($dfdc56bc53f57e69$exports(init)) this.parseObject(init);
        else this.parseQuery(typeof init == "string" ? $50e11b476cac33b7$var$charAt(init, 0) === "?" ? $50e11b476cac33b7$var$stringSlice(init, 1) : init : $53d734af07b69aa7$exports(init));
    }
};
$50e11b476cac33b7$var$URLSearchParamsState.prototype = {
    type: $50e11b476cac33b7$var$URL_SEARCH_PARAMS,
    bindURL: function(url) {
        this.url = url;
        this.update();
    },
    parseObject: function(object) {
        var iteratorMethod = $a8ef08465170b254$exports(object);
        var iterator, next, step, entryIterator, entryNext, first, second;
        if (iteratorMethod) {
            iterator = $a2edd71662804e98$exports(object, iteratorMethod);
            next = iterator.next;
            while(!(step = $3b5393d57c251c61$exports(next, iterator)).done){
                entryIterator = $a2edd71662804e98$exports($830db860a045bbb5$exports(step.value));
                entryNext = entryIterator.next;
                if ((first = $3b5393d57c251c61$exports(entryNext, entryIterator)).done || (second = $3b5393d57c251c61$exports(entryNext, entryIterator)).done || !$3b5393d57c251c61$exports(entryNext, entryIterator).done) throw $50e11b476cac33b7$var$TypeError("Expected sequence with length 2");
                $50e11b476cac33b7$var$push(this.entries, {
                    key: $53d734af07b69aa7$exports(first.value),
                    value: $53d734af07b69aa7$exports(second.value)
                });
            }
        } else for(var key in object)if ($ef59b581f0d1672b$exports(object, key)) $50e11b476cac33b7$var$push(this.entries, {
            key: key,
            value: $53d734af07b69aa7$exports(object[key])
        });
    },
    parseQuery: function(query) {
        if (query) {
            var attributes = $50e11b476cac33b7$var$split(query, "&");
            var index = 0;
            var attribute, entry;
            while(index < attributes.length){
                attribute = attributes[index++];
                if (attribute.length) {
                    entry = $50e11b476cac33b7$var$split(attribute, "=");
                    $50e11b476cac33b7$var$push(this.entries, {
                        key: $50e11b476cac33b7$var$deserialize($50e11b476cac33b7$var$shift(entry)),
                        value: $50e11b476cac33b7$var$deserialize($50e11b476cac33b7$var$join(entry, "="))
                    });
                }
            }
        }
    },
    serialize: function() {
        var entries = this.entries;
        var result = [];
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            $50e11b476cac33b7$var$push(result, $50e11b476cac33b7$var$serialize(entry.key) + "=" + $50e11b476cac33b7$var$serialize(entry.value));
        }
        return $50e11b476cac33b7$var$join(result, "&");
    },
    update: function() {
        this.entries.length = 0;
        this.parseQuery(this.url.query);
    },
    updateURL: function() {
        if (this.url) this.url.update();
    }
};
// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var $50e11b476cac33b7$var$URLSearchParamsConstructor = function URLSearchParams() {
    $a5a0f9cce104c4f5$exports(this, $50e11b476cac33b7$var$URLSearchParamsPrototype);
    var init = arguments.length > 0 ? arguments[0] : undefined;
    var state = $50e11b476cac33b7$var$setInternalState(this, new $50e11b476cac33b7$var$URLSearchParamsState(init));
    if (!$0ab298e69b752e0a$exports) this.length = state.entries.length;
};
var $50e11b476cac33b7$var$URLSearchParamsPrototype = $50e11b476cac33b7$var$URLSearchParamsConstructor.prototype;
$be8b41c0f3f6adf6$exports($50e11b476cac33b7$var$URLSearchParamsPrototype, {
    // `URLSearchParams.prototype.append` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-append
    append: function append(name, value) {
        $f035ac7c9e51e69e$exports(arguments.length, 2);
        var state = $50e11b476cac33b7$var$getInternalParamsState(this);
        $50e11b476cac33b7$var$push(state.entries, {
            key: $53d734af07b69aa7$exports(name),
            value: $53d734af07b69aa7$exports(value)
        });
        if (!$0ab298e69b752e0a$exports) this.length++;
        state.updateURL();
    },
    // `URLSearchParams.prototype.delete` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
    "delete": function(name) {
        $f035ac7c9e51e69e$exports(arguments.length, 1);
        var state = $50e11b476cac33b7$var$getInternalParamsState(this);
        var entries = state.entries;
        var key = $53d734af07b69aa7$exports(name);
        var index = 0;
        while(index < entries.length)if (entries[index].key === key) $50e11b476cac33b7$var$splice(entries, index, 1);
        else index++;
        if (!$0ab298e69b752e0a$exports) this.length = entries.length;
        state.updateURL();
    },
    // `URLSearchParams.prototype.get` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-get
    get: function get(name) {
        $f035ac7c9e51e69e$exports(arguments.length, 1);
        var entries = $50e11b476cac33b7$var$getInternalParamsState(this).entries;
        var key = $53d734af07b69aa7$exports(name);
        var index = 0;
        for(; index < entries.length; index++){
            if (entries[index].key === key) return entries[index].value;
        }
        return null;
    },
    // `URLSearchParams.prototype.getAll` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
    getAll: function getAll(name) {
        $f035ac7c9e51e69e$exports(arguments.length, 1);
        var entries = $50e11b476cac33b7$var$getInternalParamsState(this).entries;
        var key = $53d734af07b69aa7$exports(name);
        var result = [];
        var index = 0;
        for(; index < entries.length; index++)if (entries[index].key === key) $50e11b476cac33b7$var$push(result, entries[index].value);
        return result;
    },
    // `URLSearchParams.prototype.has` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-has
    has: function has(name) {
        $f035ac7c9e51e69e$exports(arguments.length, 1);
        var entries = $50e11b476cac33b7$var$getInternalParamsState(this).entries;
        var key = $53d734af07b69aa7$exports(name);
        var index = 0;
        while(index < entries.length){
            if (entries[index++].key === key) return true;
        }
        return false;
    },
    // `URLSearchParams.prototype.set` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-set
    set: function set(name, value) {
        $f035ac7c9e51e69e$exports(arguments.length, 1);
        var state = $50e11b476cac33b7$var$getInternalParamsState(this);
        var entries = state.entries;
        var found = false;
        var key = $53d734af07b69aa7$exports(name);
        var val = $53d734af07b69aa7$exports(value);
        var index = 0;
        var entry;
        for(; index < entries.length; index++){
            entry = entries[index];
            if (entry.key === key) {
                if (found) $50e11b476cac33b7$var$splice(entries, index--, 1);
                else {
                    found = true;
                    entry.value = val;
                }
            }
        }
        if (!found) $50e11b476cac33b7$var$push(entries, {
            key: key,
            value: val
        });
        if (!$0ab298e69b752e0a$exports) this.length = entries.length;
        state.updateURL();
    },
    // `URLSearchParams.prototype.sort` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
    sort: function sort() {
        var state = $50e11b476cac33b7$var$getInternalParamsState(this);
        $1867dfc0c25c2052$exports(state.entries, function(a, b) {
            return a.key > b.key ? 1 : -1;
        });
        state.updateURL();
    },
    // `URLSearchParams.prototype.forEach` method
    forEach: function forEach(callback /* , thisArg */ ) {
        var entries = $50e11b476cac33b7$var$getInternalParamsState(this).entries;
        var boundFunction = $130f24665ebee510$exports(callback, arguments.length > 1 ? arguments[1] : undefined);
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            boundFunction(entry.value, entry.key, this);
        }
    },
    // `URLSearchParams.prototype.keys` method
    keys: function keys() {
        return new $50e11b476cac33b7$var$URLSearchParamsIterator(this, "keys");
    },
    // `URLSearchParams.prototype.values` method
    values: function values() {
        return new $50e11b476cac33b7$var$URLSearchParamsIterator(this, "values");
    },
    // `URLSearchParams.prototype.entries` method
    entries: function entries() {
        return new $50e11b476cac33b7$var$URLSearchParamsIterator(this, "entries");
    }
}, {
    enumerable: true
});
// `URLSearchParams.prototype[@@iterator]` method
$eeb1abced7a4b5b5$exports($50e11b476cac33b7$var$URLSearchParamsPrototype, $50e11b476cac33b7$var$ITERATOR, $50e11b476cac33b7$var$URLSearchParamsPrototype.entries, {
    name: "entries"
});
// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
$eeb1abced7a4b5b5$exports($50e11b476cac33b7$var$URLSearchParamsPrototype, "toString", function toString() {
    return $50e11b476cac33b7$var$getInternalParamsState(this).serialize();
}, {
    enumerable: true
});
// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if ($0ab298e69b752e0a$exports) $54b1e35819861675$exports($50e11b476cac33b7$var$URLSearchParamsPrototype, "size", {
    get: function size() {
        return $50e11b476cac33b7$var$getInternalParamsState(this).entries.length;
    },
    configurable: true,
    enumerable: true
});
$ec32ac1e3fb4a1a1$exports($50e11b476cac33b7$var$URLSearchParamsConstructor, $50e11b476cac33b7$var$URL_SEARCH_PARAMS);
$0365e955907213bd$exports({
    global: true,
    constructor: true,
    forced: !$b844cc14116d1191$exports
}, {
    URLSearchParams: $50e11b476cac33b7$var$URLSearchParamsConstructor
});
// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!$b844cc14116d1191$exports && $c1d5f87f1e56c4cc$exports($50e11b476cac33b7$var$Headers)) {
    var $50e11b476cac33b7$var$headersHas = $c510c74e58563f95$exports($50e11b476cac33b7$var$HeadersPrototype.has);
    var $50e11b476cac33b7$var$headersSet = $c510c74e58563f95$exports($50e11b476cac33b7$var$HeadersPrototype.set);
    var $50e11b476cac33b7$var$wrapRequestOptions = function(init) {
        if ($dfdc56bc53f57e69$exports(init)) {
            var body = init.body;
            var headers;
            if ($79ec051cbbc13a5e$exports(body) === $50e11b476cac33b7$var$URL_SEARCH_PARAMS) {
                headers = init.headers ? new $50e11b476cac33b7$var$Headers(init.headers) : new $50e11b476cac33b7$var$Headers();
                if (!$50e11b476cac33b7$var$headersHas(headers, "content-type")) $50e11b476cac33b7$var$headersSet(headers, "content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                return $290768129b19866b$exports(init, {
                    body: $d6bcb34392440d40$exports(0, $53d734af07b69aa7$exports(body)),
                    headers: $d6bcb34392440d40$exports(0, headers)
                });
            }
        }
        return init;
    };
    if ($c1d5f87f1e56c4cc$exports($50e11b476cac33b7$var$nativeFetch)) $0365e955907213bd$exports({
        global: true,
        enumerable: true,
        dontCallGetSet: true,
        forced: true
    }, {
        fetch: function fetch(input /* , init */ ) {
            return $50e11b476cac33b7$var$nativeFetch(input, arguments.length > 1 ? $50e11b476cac33b7$var$wrapRequestOptions(arguments[1]) : {});
        }
    });
    if ($c1d5f87f1e56c4cc$exports($50e11b476cac33b7$var$NativeRequest)) {
        var $50e11b476cac33b7$var$RequestConstructor = function Request(input /* , init */ ) {
            $a5a0f9cce104c4f5$exports(this, $50e11b476cac33b7$var$RequestPrototype);
            return new $50e11b476cac33b7$var$NativeRequest(input, arguments.length > 1 ? $50e11b476cac33b7$var$wrapRequestOptions(arguments[1]) : {});
        };
        $50e11b476cac33b7$var$RequestPrototype.constructor = $50e11b476cac33b7$var$RequestConstructor;
        $50e11b476cac33b7$var$RequestConstructor.prototype = $50e11b476cac33b7$var$RequestPrototype;
        $0365e955907213bd$exports({
            global: true,
            constructor: true,
            dontCallGetSet: true,
            forced: true
        }, {
            Request: $50e11b476cac33b7$var$RequestConstructor
        });
    }
}
$50e11b476cac33b7$exports = {
    URLSearchParams: $50e11b476cac33b7$var$URLSearchParamsConstructor,
    getState: $50e11b476cac33b7$var$getInternalParamsState
};



var $e609253e41b01d42$var$setInternalState = $dbe54846b72f85d1$exports.set;
var $e609253e41b01d42$var$getInternalURLState = $dbe54846b72f85d1$exports.getterFor("URL");
var $e609253e41b01d42$var$URLSearchParams = $50e11b476cac33b7$exports.URLSearchParams;
var $e609253e41b01d42$var$getInternalSearchParamsState = $50e11b476cac33b7$exports.getState;
var $e609253e41b01d42$var$NativeURL = $1a6e68c95df7d4df$exports.URL;
var $e609253e41b01d42$var$TypeError = $1a6e68c95df7d4df$exports.TypeError;
var $e609253e41b01d42$var$parseInt = $1a6e68c95df7d4df$exports.parseInt;
var $e609253e41b01d42$var$floor = Math.floor;
var $e609253e41b01d42$var$pow = Math.pow;
var $e609253e41b01d42$var$charAt = $c510c74e58563f95$exports("".charAt);
var $e609253e41b01d42$var$exec = $c510c74e58563f95$exports(/./.exec);
var $e609253e41b01d42$var$join = $c510c74e58563f95$exports([].join);
var $e609253e41b01d42$var$numberToString = $c510c74e58563f95$exports(1.0.toString);
var $e609253e41b01d42$var$pop = $c510c74e58563f95$exports([].pop);
var $e609253e41b01d42$var$push = $c510c74e58563f95$exports([].push);
var $e609253e41b01d42$var$replace = $c510c74e58563f95$exports("".replace);
var $e609253e41b01d42$var$shift = $c510c74e58563f95$exports([].shift);
var $e609253e41b01d42$var$split = $c510c74e58563f95$exports("".split);
var $e609253e41b01d42$var$stringSlice = $c510c74e58563f95$exports("".slice);
var $e609253e41b01d42$var$toLowerCase = $c510c74e58563f95$exports("".toLowerCase);
var $e609253e41b01d42$var$unshift = $c510c74e58563f95$exports([].unshift);
var $e609253e41b01d42$var$INVALID_AUTHORITY = "Invalid authority";
var $e609253e41b01d42$var$INVALID_SCHEME = "Invalid scheme";
var $e609253e41b01d42$var$INVALID_HOST = "Invalid host";
var $e609253e41b01d42$var$INVALID_PORT = "Invalid port";
var $e609253e41b01d42$var$ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var $e609253e41b01d42$var$ALPHANUMERIC = /[\d+-.a-z]/i;
var $e609253e41b01d42$var$DIGIT = /\d/;
var $e609253e41b01d42$var$HEX_START = /^0x/i;
var $e609253e41b01d42$var$OCT = /^[0-7]+$/;
var $e609253e41b01d42$var$DEC = /^\d+$/;
var $e609253e41b01d42$var$HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */ var $e609253e41b01d42$var$FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var $e609253e41b01d42$var$FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var $e609253e41b01d42$var$LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var $e609253e41b01d42$var$TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var $e609253e41b01d42$var$TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */ var $e609253e41b01d42$var$EOF;
// https://url.spec.whatwg.org/#ipv4-number-parser
var $e609253e41b01d42$var$parseIPv4 = function(input) {
    var parts = $e609253e41b01d42$var$split(input, ".");
    var partsLength, numbers, index, part, radix, number, ipv4;
    if (parts.length && parts[parts.length - 1] == "") parts.length--;
    partsLength = parts.length;
    if (partsLength > 4) return input;
    numbers = [];
    for(index = 0; index < partsLength; index++){
        part = parts[index];
        if (part == "") return input;
        radix = 10;
        if (part.length > 1 && $e609253e41b01d42$var$charAt(part, 0) == "0") {
            radix = $e609253e41b01d42$var$exec($e609253e41b01d42$var$HEX_START, part) ? 16 : 8;
            part = $e609253e41b01d42$var$stringSlice(part, radix == 8 ? 1 : 2);
        }
        if (part === "") number = 0;
        else {
            if (!$e609253e41b01d42$var$exec(radix == 10 ? $e609253e41b01d42$var$DEC : radix == 8 ? $e609253e41b01d42$var$OCT : $e609253e41b01d42$var$HEX, part)) return input;
            number = $e609253e41b01d42$var$parseInt(part, radix);
        }
        $e609253e41b01d42$var$push(numbers, number);
    }
    for(index = 0; index < partsLength; index++){
        number = numbers[index];
        if (index == partsLength - 1) {
            if (number >= $e609253e41b01d42$var$pow(256, 5 - partsLength)) return null;
        } else if (number > 255) return null;
    }
    ipv4 = $e609253e41b01d42$var$pop(numbers);
    for(index = 0; index < numbers.length; index++)ipv4 += numbers[index] * $e609253e41b01d42$var$pow(256, 3 - index);
    return ipv4;
};
// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var $e609253e41b01d42$var$parseIPv6 = function(input) {
    var address = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var pieceIndex = 0;
    var compress = null;
    var pointer = 0;
    var value, length, numbersSeen, ipv4Piece, number, swaps, swap;
    var chr = function() {
        return $e609253e41b01d42$var$charAt(input, pointer);
    };
    if (chr() == ":") {
        if ($e609253e41b01d42$var$charAt(input, 1) != ":") return;
        pointer += 2;
        pieceIndex++;
        compress = pieceIndex;
    }
    while(chr()){
        if (pieceIndex == 8) return;
        if (chr() == ":") {
            if (compress !== null) return;
            pointer++;
            pieceIndex++;
            compress = pieceIndex;
            continue;
        }
        value = length = 0;
        while(length < 4 && $e609253e41b01d42$var$exec($e609253e41b01d42$var$HEX, chr())){
            value = value * 16 + $e609253e41b01d42$var$parseInt(chr(), 16);
            pointer++;
            length++;
        }
        if (chr() == ".") {
            if (length == 0) return;
            pointer -= length;
            if (pieceIndex > 6) return;
            numbersSeen = 0;
            while(chr()){
                ipv4Piece = null;
                if (numbersSeen > 0) {
                    if (chr() == "." && numbersSeen < 4) pointer++;
                    else return;
                }
                if (!$e609253e41b01d42$var$exec($e609253e41b01d42$var$DIGIT, chr())) return;
                while($e609253e41b01d42$var$exec($e609253e41b01d42$var$DIGIT, chr())){
                    number = $e609253e41b01d42$var$parseInt(chr(), 10);
                    if (ipv4Piece === null) ipv4Piece = number;
                    else if (ipv4Piece == 0) return;
                    else ipv4Piece = ipv4Piece * 10 + number;
                    if (ipv4Piece > 255) return;
                    pointer++;
                }
                address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
                numbersSeen++;
                if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
            }
            if (numbersSeen != 4) return;
            break;
        } else if (chr() == ":") {
            pointer++;
            if (!chr()) return;
        } else if (chr()) return;
        address[pieceIndex++] = value;
    }
    if (compress !== null) {
        swaps = pieceIndex - compress;
        pieceIndex = 7;
        while(pieceIndex != 0 && swaps > 0){
            swap = address[pieceIndex];
            address[pieceIndex--] = address[compress + swaps - 1];
            address[compress + --swaps] = swap;
        }
    } else if (pieceIndex != 8) return;
    return address;
};
var $e609253e41b01d42$var$findLongestZeroSequence = function(ipv6) {
    var maxIndex = null;
    var maxLength = 1;
    var currStart = null;
    var currLength = 0;
    var index = 0;
    for(; index < 8; index++)if (ipv6[index] !== 0) {
        if (currLength > maxLength) {
            maxIndex = currStart;
            maxLength = currLength;
        }
        currStart = null;
        currLength = 0;
    } else {
        if (currStart === null) currStart = index;
        ++currLength;
    }
    if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
    }
    return maxIndex;
};
// https://url.spec.whatwg.org/#host-serializing
var $e609253e41b01d42$var$serializeHost = function(host) {
    var result, index, compress, ignore0;
    // ipv4
    if (typeof host == "number") {
        result = [];
        for(index = 0; index < 4; index++){
            $e609253e41b01d42$var$unshift(result, host % 256);
            host = $e609253e41b01d42$var$floor(host / 256);
        }
        return $e609253e41b01d42$var$join(result, ".");
    // ipv6
    } else if (typeof host == "object") {
        result = "";
        compress = $e609253e41b01d42$var$findLongestZeroSequence(host);
        for(index = 0; index < 8; index++){
            if (ignore0 && host[index] === 0) continue;
            if (ignore0) ignore0 = false;
            if (compress === index) {
                result += index ? ":" : "::";
                ignore0 = true;
            } else {
                result += $e609253e41b01d42$var$numberToString(host[index], 16);
                if (index < 7) result += ":";
            }
        }
        return "[" + result + "]";
    }
    return host;
};
var $e609253e41b01d42$var$C0ControlPercentEncodeSet = {};
var $e609253e41b01d42$var$fragmentPercentEncodeSet = $450e0c3510042936$exports({}, $e609253e41b01d42$var$C0ControlPercentEncodeSet, {
    " ": 1,
    '"': 1,
    "<": 1,
    ">": 1,
    "`": 1
});
var $e609253e41b01d42$var$pathPercentEncodeSet = $450e0c3510042936$exports({}, $e609253e41b01d42$var$fragmentPercentEncodeSet, {
    "#": 1,
    "?": 1,
    "{": 1,
    "}": 1
});
var $e609253e41b01d42$var$userinfoPercentEncodeSet = $450e0c3510042936$exports({}, $e609253e41b01d42$var$pathPercentEncodeSet, {
    "/": 1,
    ":": 1,
    ";": 1,
    "=": 1,
    "@": 1,
    "[": 1,
    "\\": 1,
    "]": 1,
    "^": 1,
    "|": 1
});
var $e609253e41b01d42$var$percentEncode = function(chr, set) {
    var code = $e609253e41b01d42$require$codeAt(chr, 0);
    return code > 0x20 && code < 0x7F && !$ef59b581f0d1672b$exports(set, chr) ? chr : encodeURIComponent(chr);
};
// https://url.spec.whatwg.org/#special-scheme
var $e609253e41b01d42$var$specialSchemes = {
    ftp: 21,
    file: null,
    http: 80,
    https: 443,
    ws: 80,
    wss: 443
};
// https://url.spec.whatwg.org/#windows-drive-letter
var $e609253e41b01d42$var$isWindowsDriveLetter = function(string, normalized) {
    var second;
    return string.length == 2 && $e609253e41b01d42$var$exec($e609253e41b01d42$var$ALPHA, $e609253e41b01d42$var$charAt(string, 0)) && ((second = $e609253e41b01d42$var$charAt(string, 1)) == ":" || !normalized && second == "|");
};
// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var $e609253e41b01d42$var$startsWithWindowsDriveLetter = function(string) {
    var third;
    return string.length > 1 && $e609253e41b01d42$var$isWindowsDriveLetter($e609253e41b01d42$var$stringSlice(string, 0, 2)) && (string.length == 2 || (third = $e609253e41b01d42$var$charAt(string, 2)) === "/" || third === "\\" || third === "?" || third === "#");
};
// https://url.spec.whatwg.org/#single-dot-path-segment
var $e609253e41b01d42$var$isSingleDot = function(segment) {
    return segment === "." || $e609253e41b01d42$var$toLowerCase(segment) === "%2e";
};
// https://url.spec.whatwg.org/#double-dot-path-segment
var $e609253e41b01d42$var$isDoubleDot = function(segment) {
    segment = $e609253e41b01d42$var$toLowerCase(segment);
    return segment === ".." || segment === "%2e." || segment === ".%2e" || segment === "%2e%2e";
};
// States:
var $e609253e41b01d42$var$SCHEME_START = {};
var $e609253e41b01d42$var$SCHEME = {};
var $e609253e41b01d42$var$NO_SCHEME = {};
var $e609253e41b01d42$var$SPECIAL_RELATIVE_OR_AUTHORITY = {};
var $e609253e41b01d42$var$PATH_OR_AUTHORITY = {};
var $e609253e41b01d42$var$RELATIVE = {};
var $e609253e41b01d42$var$RELATIVE_SLASH = {};
var $e609253e41b01d42$var$SPECIAL_AUTHORITY_SLASHES = {};
var $e609253e41b01d42$var$SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var $e609253e41b01d42$var$AUTHORITY = {};
var $e609253e41b01d42$var$HOST = {};
var $e609253e41b01d42$var$HOSTNAME = {};
var $e609253e41b01d42$var$PORT = {};
var $e609253e41b01d42$var$FILE = {};
var $e609253e41b01d42$var$FILE_SLASH = {};
var $e609253e41b01d42$var$FILE_HOST = {};
var $e609253e41b01d42$var$PATH_START = {};
var $e609253e41b01d42$var$PATH = {};
var $e609253e41b01d42$var$CANNOT_BE_A_BASE_URL_PATH = {};
var $e609253e41b01d42$var$QUERY = {};
var $e609253e41b01d42$var$FRAGMENT = {};
var $e609253e41b01d42$var$URLState = function(url, isBase, base) {
    var urlString = $53d734af07b69aa7$exports(url);
    var baseState, failure, searchParams;
    if (isBase) {
        failure = this.parse(urlString);
        if (failure) throw $e609253e41b01d42$var$TypeError(failure);
        this.searchParams = null;
    } else {
        if (base !== undefined) baseState = new $e609253e41b01d42$var$URLState(base, true);
        failure = this.parse(urlString, null, baseState);
        if (failure) throw $e609253e41b01d42$var$TypeError(failure);
        searchParams = $e609253e41b01d42$var$getInternalSearchParamsState(new $e609253e41b01d42$var$URLSearchParams());
        searchParams.bindURL(this);
        this.searchParams = searchParams;
    }
};
$e609253e41b01d42$var$URLState.prototype = {
    type: "URL",
    // https://url.spec.whatwg.org/#url-parsing
    // eslint-disable-next-line max-statements -- TODO
    parse: function(input, stateOverride, base) {
        var url = this;
        var state = stateOverride || $e609253e41b01d42$var$SCHEME_START;
        var pointer = 0;
        var buffer = "";
        var seenAt = false;
        var seenBracket = false;
        var seenPasswordToken = false;
        var codePoints, chr, bufferCodePoints, failure;
        input = $53d734af07b69aa7$exports(input);
        if (!stateOverride) {
            url.scheme = "";
            url.username = "";
            url.password = "";
            url.host = null;
            url.port = null;
            url.path = [];
            url.query = null;
            url.fragment = null;
            url.cannotBeABaseURL = false;
            input = $e609253e41b01d42$var$replace(input, $e609253e41b01d42$var$LEADING_C0_CONTROL_OR_SPACE, "");
            input = $e609253e41b01d42$var$replace(input, $e609253e41b01d42$var$TRAILING_C0_CONTROL_OR_SPACE, "$1");
        }
        input = $e609253e41b01d42$var$replace(input, $e609253e41b01d42$var$TAB_AND_NEW_LINE, "");
        codePoints = $b254321061bc56b9$exports(input);
        while(pointer <= codePoints.length){
            chr = codePoints[pointer];
            switch(state){
                case $e609253e41b01d42$var$SCHEME_START:
                    if (chr && $e609253e41b01d42$var$exec($e609253e41b01d42$var$ALPHA, chr)) {
                        buffer += $e609253e41b01d42$var$toLowerCase(chr);
                        state = $e609253e41b01d42$var$SCHEME;
                    } else if (!stateOverride) {
                        state = $e609253e41b01d42$var$NO_SCHEME;
                        continue;
                    } else return $e609253e41b01d42$var$INVALID_SCHEME;
                    break;
                case $e609253e41b01d42$var$SCHEME:
                    if (chr && ($e609253e41b01d42$var$exec($e609253e41b01d42$var$ALPHANUMERIC, chr) || chr == "+" || chr == "-" || chr == ".")) buffer += $e609253e41b01d42$var$toLowerCase(chr);
                    else if (chr == ":") {
                        if (stateOverride && (url.isSpecial() != $ef59b581f0d1672b$exports($e609253e41b01d42$var$specialSchemes, buffer) || buffer == "file" && (url.includesCredentials() || url.port !== null) || url.scheme == "file" && !url.host)) return;
                        url.scheme = buffer;
                        if (stateOverride) {
                            if (url.isSpecial() && $e609253e41b01d42$var$specialSchemes[url.scheme] == url.port) url.port = null;
                            return;
                        }
                        buffer = "";
                        if (url.scheme == "file") state = $e609253e41b01d42$var$FILE;
                        else if (url.isSpecial() && base && base.scheme == url.scheme) state = $e609253e41b01d42$var$SPECIAL_RELATIVE_OR_AUTHORITY;
                        else if (url.isSpecial()) state = $e609253e41b01d42$var$SPECIAL_AUTHORITY_SLASHES;
                        else if (codePoints[pointer + 1] == "/") {
                            state = $e609253e41b01d42$var$PATH_OR_AUTHORITY;
                            pointer++;
                        } else {
                            url.cannotBeABaseURL = true;
                            $e609253e41b01d42$var$push(url.path, "");
                            state = $e609253e41b01d42$var$CANNOT_BE_A_BASE_URL_PATH;
                        }
                    } else if (!stateOverride) {
                        buffer = "";
                        state = $e609253e41b01d42$var$NO_SCHEME;
                        pointer = 0;
                        continue;
                    } else return $e609253e41b01d42$var$INVALID_SCHEME;
                    break;
                case $e609253e41b01d42$var$NO_SCHEME:
                    if (!base || base.cannotBeABaseURL && chr != "#") return $e609253e41b01d42$var$INVALID_SCHEME;
                    if (base.cannotBeABaseURL && chr == "#") {
                        url.scheme = base.scheme;
                        url.path = $df6d3dbc942f438e$exports(base.path);
                        url.query = base.query;
                        url.fragment = "";
                        url.cannotBeABaseURL = true;
                        state = $e609253e41b01d42$var$FRAGMENT;
                        break;
                    }
                    state = base.scheme == "file" ? $e609253e41b01d42$var$FILE : $e609253e41b01d42$var$RELATIVE;
                    continue;
                case $e609253e41b01d42$var$SPECIAL_RELATIVE_OR_AUTHORITY:
                    if (chr == "/" && codePoints[pointer + 1] == "/") {
                        state = $e609253e41b01d42$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                        pointer++;
                    } else {
                        state = $e609253e41b01d42$var$RELATIVE;
                        continue;
                    }
                    break;
                case $e609253e41b01d42$var$PATH_OR_AUTHORITY:
                    if (chr == "/") {
                        state = $e609253e41b01d42$var$AUTHORITY;
                        break;
                    } else {
                        state = $e609253e41b01d42$var$PATH;
                        continue;
                    }
                case $e609253e41b01d42$var$RELATIVE:
                    url.scheme = base.scheme;
                    if (chr == $e609253e41b01d42$var$EOF) {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $df6d3dbc942f438e$exports(base.path);
                        url.query = base.query;
                    } else if (chr == "/" || chr == "\\" && url.isSpecial()) state = $e609253e41b01d42$var$RELATIVE_SLASH;
                    else if (chr == "?") {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $df6d3dbc942f438e$exports(base.path);
                        url.query = "";
                        state = $e609253e41b01d42$var$QUERY;
                    } else if (chr == "#") {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $df6d3dbc942f438e$exports(base.path);
                        url.query = base.query;
                        url.fragment = "";
                        state = $e609253e41b01d42$var$FRAGMENT;
                    } else {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $df6d3dbc942f438e$exports(base.path);
                        url.path.length--;
                        state = $e609253e41b01d42$var$PATH;
                        continue;
                    }
                    break;
                case $e609253e41b01d42$var$RELATIVE_SLASH:
                    if (url.isSpecial() && (chr == "/" || chr == "\\")) state = $e609253e41b01d42$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    else if (chr == "/") state = $e609253e41b01d42$var$AUTHORITY;
                    else {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        state = $e609253e41b01d42$var$PATH;
                        continue;
                    }
                    break;
                case $e609253e41b01d42$var$SPECIAL_AUTHORITY_SLASHES:
                    state = $e609253e41b01d42$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    if (chr != "/" || $e609253e41b01d42$var$charAt(buffer, pointer + 1) != "/") continue;
                    pointer++;
                    break;
                case $e609253e41b01d42$var$SPECIAL_AUTHORITY_IGNORE_SLASHES:
                    if (chr != "/" && chr != "\\") {
                        state = $e609253e41b01d42$var$AUTHORITY;
                        continue;
                    }
                    break;
                case $e609253e41b01d42$var$AUTHORITY:
                    if (chr == "@") {
                        if (seenAt) buffer = "%40" + buffer;
                        seenAt = true;
                        bufferCodePoints = $b254321061bc56b9$exports(buffer);
                        for(var i = 0; i < bufferCodePoints.length; i++){
                            var codePoint = bufferCodePoints[i];
                            if (codePoint == ":" && !seenPasswordToken) {
                                seenPasswordToken = true;
                                continue;
                            }
                            var encodedCodePoints = $e609253e41b01d42$var$percentEncode(codePoint, $e609253e41b01d42$var$userinfoPercentEncodeSet);
                            if (seenPasswordToken) url.password += encodedCodePoints;
                            else url.username += encodedCodePoints;
                        }
                        buffer = "";
                    } else if (chr == $e609253e41b01d42$var$EOF || chr == "/" || chr == "?" || chr == "#" || chr == "\\" && url.isSpecial()) {
                        if (seenAt && buffer == "") return $e609253e41b01d42$var$INVALID_AUTHORITY;
                        pointer -= $b254321061bc56b9$exports(buffer).length + 1;
                        buffer = "";
                        state = $e609253e41b01d42$var$HOST;
                    } else buffer += chr;
                    break;
                case $e609253e41b01d42$var$HOST:
                case $e609253e41b01d42$var$HOSTNAME:
                    if (stateOverride && url.scheme == "file") {
                        state = $e609253e41b01d42$var$FILE_HOST;
                        continue;
                    } else if (chr == ":" && !seenBracket) {
                        if (buffer == "") return $e609253e41b01d42$var$INVALID_HOST;
                        failure = url.parseHost(buffer);
                        if (failure) return failure;
                        buffer = "";
                        state = $e609253e41b01d42$var$PORT;
                        if (stateOverride == $e609253e41b01d42$var$HOSTNAME) return;
                    } else if (chr == $e609253e41b01d42$var$EOF || chr == "/" || chr == "?" || chr == "#" || chr == "\\" && url.isSpecial()) {
                        if (url.isSpecial() && buffer == "") return $e609253e41b01d42$var$INVALID_HOST;
                        if (stateOverride && buffer == "" && (url.includesCredentials() || url.port !== null)) return;
                        failure = url.parseHost(buffer);
                        if (failure) return failure;
                        buffer = "";
                        state = $e609253e41b01d42$var$PATH_START;
                        if (stateOverride) return;
                        continue;
                    } else {
                        if (chr == "[") seenBracket = true;
                        else if (chr == "]") seenBracket = false;
                        buffer += chr;
                    }
                    break;
                case $e609253e41b01d42$var$PORT:
                    if ($e609253e41b01d42$var$exec($e609253e41b01d42$var$DIGIT, chr)) buffer += chr;
                    else if (chr == $e609253e41b01d42$var$EOF || chr == "/" || chr == "?" || chr == "#" || chr == "\\" && url.isSpecial() || stateOverride) {
                        if (buffer != "") {
                            var port = $e609253e41b01d42$var$parseInt(buffer, 10);
                            if (port > 0xFFFF) return $e609253e41b01d42$var$INVALID_PORT;
                            url.port = url.isSpecial() && port === $e609253e41b01d42$var$specialSchemes[url.scheme] ? null : port;
                            buffer = "";
                        }
                        if (stateOverride) return;
                        state = $e609253e41b01d42$var$PATH_START;
                        continue;
                    } else return $e609253e41b01d42$var$INVALID_PORT;
                    break;
                case $e609253e41b01d42$var$FILE:
                    url.scheme = "file";
                    if (chr == "/" || chr == "\\") state = $e609253e41b01d42$var$FILE_SLASH;
                    else if (base && base.scheme == "file") {
                        if (chr == $e609253e41b01d42$var$EOF) {
                            url.host = base.host;
                            url.path = $df6d3dbc942f438e$exports(base.path);
                            url.query = base.query;
                        } else if (chr == "?") {
                            url.host = base.host;
                            url.path = $df6d3dbc942f438e$exports(base.path);
                            url.query = "";
                            state = $e609253e41b01d42$var$QUERY;
                        } else if (chr == "#") {
                            url.host = base.host;
                            url.path = $df6d3dbc942f438e$exports(base.path);
                            url.query = base.query;
                            url.fragment = "";
                            state = $e609253e41b01d42$var$FRAGMENT;
                        } else {
                            if (!$e609253e41b01d42$var$startsWithWindowsDriveLetter($e609253e41b01d42$var$join($df6d3dbc942f438e$exports(codePoints, pointer), ""))) {
                                url.host = base.host;
                                url.path = $df6d3dbc942f438e$exports(base.path);
                                url.shortenPath();
                            }
                            state = $e609253e41b01d42$var$PATH;
                            continue;
                        }
                    } else {
                        state = $e609253e41b01d42$var$PATH;
                        continue;
                    }
                    break;
                case $e609253e41b01d42$var$FILE_SLASH:
                    if (chr == "/" || chr == "\\") {
                        state = $e609253e41b01d42$var$FILE_HOST;
                        break;
                    }
                    if (base && base.scheme == "file" && !$e609253e41b01d42$var$startsWithWindowsDriveLetter($e609253e41b01d42$var$join($df6d3dbc942f438e$exports(codePoints, pointer), ""))) {
                        if ($e609253e41b01d42$var$isWindowsDriveLetter(base.path[0], true)) $e609253e41b01d42$var$push(url.path, base.path[0]);
                        else url.host = base.host;
                    }
                    state = $e609253e41b01d42$var$PATH;
                    continue;
                case $e609253e41b01d42$var$FILE_HOST:
                    if (chr == $e609253e41b01d42$var$EOF || chr == "/" || chr == "\\" || chr == "?" || chr == "#") {
                        if (!stateOverride && $e609253e41b01d42$var$isWindowsDriveLetter(buffer)) state = $e609253e41b01d42$var$PATH;
                        else if (buffer == "") {
                            url.host = "";
                            if (stateOverride) return;
                            state = $e609253e41b01d42$var$PATH_START;
                        } else {
                            failure = url.parseHost(buffer);
                            if (failure) return failure;
                            if (url.host == "localhost") url.host = "";
                            if (stateOverride) return;
                            buffer = "";
                            state = $e609253e41b01d42$var$PATH_START;
                        }
                        continue;
                    } else buffer += chr;
                    break;
                case $e609253e41b01d42$var$PATH_START:
                    if (url.isSpecial()) {
                        state = $e609253e41b01d42$var$PATH;
                        if (chr != "/" && chr != "\\") continue;
                    } else if (!stateOverride && chr == "?") {
                        url.query = "";
                        state = $e609253e41b01d42$var$QUERY;
                    } else if (!stateOverride && chr == "#") {
                        url.fragment = "";
                        state = $e609253e41b01d42$var$FRAGMENT;
                    } else if (chr != $e609253e41b01d42$var$EOF) {
                        state = $e609253e41b01d42$var$PATH;
                        if (chr != "/") continue;
                    }
                    break;
                case $e609253e41b01d42$var$PATH:
                    if (chr == $e609253e41b01d42$var$EOF || chr == "/" || chr == "\\" && url.isSpecial() || !stateOverride && (chr == "?" || chr == "#")) {
                        if ($e609253e41b01d42$var$isDoubleDot(buffer)) {
                            url.shortenPath();
                            if (chr != "/" && !(chr == "\\" && url.isSpecial())) $e609253e41b01d42$var$push(url.path, "");
                        } else if ($e609253e41b01d42$var$isSingleDot(buffer)) {
                            if (chr != "/" && !(chr == "\\" && url.isSpecial())) $e609253e41b01d42$var$push(url.path, "");
                        } else {
                            if (url.scheme == "file" && !url.path.length && $e609253e41b01d42$var$isWindowsDriveLetter(buffer)) {
                                if (url.host) url.host = "";
                                buffer = $e609253e41b01d42$var$charAt(buffer, 0) + ":"; // normalize windows drive letter
                            }
                            $e609253e41b01d42$var$push(url.path, buffer);
                        }
                        buffer = "";
                        if (url.scheme == "file" && (chr == $e609253e41b01d42$var$EOF || chr == "?" || chr == "#")) while(url.path.length > 1 && url.path[0] === "")$e609253e41b01d42$var$shift(url.path);
                        if (chr == "?") {
                            url.query = "";
                            state = $e609253e41b01d42$var$QUERY;
                        } else if (chr == "#") {
                            url.fragment = "";
                            state = $e609253e41b01d42$var$FRAGMENT;
                        }
                    } else buffer += $e609253e41b01d42$var$percentEncode(chr, $e609253e41b01d42$var$pathPercentEncodeSet);
                    break;
                case $e609253e41b01d42$var$CANNOT_BE_A_BASE_URL_PATH:
                    if (chr == "?") {
                        url.query = "";
                        state = $e609253e41b01d42$var$QUERY;
                    } else if (chr == "#") {
                        url.fragment = "";
                        state = $e609253e41b01d42$var$FRAGMENT;
                    } else if (chr != $e609253e41b01d42$var$EOF) url.path[0] += $e609253e41b01d42$var$percentEncode(chr, $e609253e41b01d42$var$C0ControlPercentEncodeSet);
                    break;
                case $e609253e41b01d42$var$QUERY:
                    if (!stateOverride && chr == "#") {
                        url.fragment = "";
                        state = $e609253e41b01d42$var$FRAGMENT;
                    } else if (chr != $e609253e41b01d42$var$EOF) {
                        if (chr == "'" && url.isSpecial()) url.query += "%27";
                        else if (chr == "#") url.query += "%23";
                        else url.query += $e609253e41b01d42$var$percentEncode(chr, $e609253e41b01d42$var$C0ControlPercentEncodeSet);
                    }
                    break;
                case $e609253e41b01d42$var$FRAGMENT:
                    if (chr != $e609253e41b01d42$var$EOF) url.fragment += $e609253e41b01d42$var$percentEncode(chr, $e609253e41b01d42$var$fragmentPercentEncodeSet);
                    break;
            }
            pointer++;
        }
    },
    // https://url.spec.whatwg.org/#host-parsing
    parseHost: function(input) {
        var result, codePoints, index;
        if ($e609253e41b01d42$var$charAt(input, 0) == "[") {
            if ($e609253e41b01d42$var$charAt(input, input.length - 1) != "]") return $e609253e41b01d42$var$INVALID_HOST;
            result = $e609253e41b01d42$var$parseIPv6($e609253e41b01d42$var$stringSlice(input, 1, -1));
            if (!result) return $e609253e41b01d42$var$INVALID_HOST;
            this.host = result;
        // opaque host
        } else if (!this.isSpecial()) {
            if ($e609253e41b01d42$var$exec($e609253e41b01d42$var$FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return $e609253e41b01d42$var$INVALID_HOST;
            result = "";
            codePoints = $b254321061bc56b9$exports(input);
            for(index = 0; index < codePoints.length; index++)result += $e609253e41b01d42$var$percentEncode(codePoints[index], $e609253e41b01d42$var$C0ControlPercentEncodeSet);
            this.host = result;
        } else {
            input = $47b3790baa06f789$exports(input);
            if ($e609253e41b01d42$var$exec($e609253e41b01d42$var$FORBIDDEN_HOST_CODE_POINT, input)) return $e609253e41b01d42$var$INVALID_HOST;
            result = $e609253e41b01d42$var$parseIPv4(input);
            if (result === null) return $e609253e41b01d42$var$INVALID_HOST;
            this.host = result;
        }
    },
    // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
    cannotHaveUsernamePasswordPort: function() {
        return !this.host || this.cannotBeABaseURL || this.scheme == "file";
    },
    // https://url.spec.whatwg.org/#include-credentials
    includesCredentials: function() {
        return this.username != "" || this.password != "";
    },
    // https://url.spec.whatwg.org/#is-special
    isSpecial: function() {
        return $ef59b581f0d1672b$exports($e609253e41b01d42$var$specialSchemes, this.scheme);
    },
    // https://url.spec.whatwg.org/#shorten-a-urls-path
    shortenPath: function() {
        var path = this.path;
        var pathSize = path.length;
        if (pathSize && (this.scheme != "file" || pathSize != 1 || !$e609253e41b01d42$var$isWindowsDriveLetter(path[0], true))) path.length--;
    },
    // https://url.spec.whatwg.org/#concept-url-serializer
    serialize: function() {
        var url = this;
        var scheme = url.scheme;
        var username = url.username;
        var password = url.password;
        var host = url.host;
        var port = url.port;
        var path = url.path;
        var query = url.query;
        var fragment = url.fragment;
        var output = scheme + ":";
        if (host !== null) {
            output += "//";
            if (url.includesCredentials()) output += username + (password ? ":" + password : "") + "@";
            output += $e609253e41b01d42$var$serializeHost(host);
            if (port !== null) output += ":" + port;
        } else if (scheme == "file") output += "//";
        output += url.cannotBeABaseURL ? path[0] : path.length ? "/" + $e609253e41b01d42$var$join(path, "/") : "";
        if (query !== null) output += "?" + query;
        if (fragment !== null) output += "#" + fragment;
        return output;
    },
    // https://url.spec.whatwg.org/#dom-url-href
    setHref: function(href) {
        var failure = this.parse(href);
        if (failure) throw $e609253e41b01d42$var$TypeError(failure);
        this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-origin
    getOrigin: function() {
        var scheme = this.scheme;
        var port = this.port;
        if (scheme == "blob") try {
            return new $e609253e41b01d42$var$URLConstructor(scheme.path[0]).origin;
        } catch (error) {
            return "null";
        }
        if (scheme == "file" || !this.isSpecial()) return "null";
        return scheme + "://" + $e609253e41b01d42$var$serializeHost(this.host) + (port !== null ? ":" + port : "");
    },
    // https://url.spec.whatwg.org/#dom-url-protocol
    getProtocol: function() {
        return this.scheme + ":";
    },
    setProtocol: function(protocol) {
        this.parse($53d734af07b69aa7$exports(protocol) + ":", $e609253e41b01d42$var$SCHEME_START);
    },
    // https://url.spec.whatwg.org/#dom-url-username
    getUsername: function() {
        return this.username;
    },
    setUsername: function(username) {
        var codePoints = $b254321061bc56b9$exports($53d734af07b69aa7$exports(username));
        if (this.cannotHaveUsernamePasswordPort()) return;
        this.username = "";
        for(var i = 0; i < codePoints.length; i++)this.username += $e609253e41b01d42$var$percentEncode(codePoints[i], $e609253e41b01d42$var$userinfoPercentEncodeSet);
    },
    // https://url.spec.whatwg.org/#dom-url-password
    getPassword: function() {
        return this.password;
    },
    setPassword: function(password) {
        var codePoints = $b254321061bc56b9$exports($53d734af07b69aa7$exports(password));
        if (this.cannotHaveUsernamePasswordPort()) return;
        this.password = "";
        for(var i = 0; i < codePoints.length; i++)this.password += $e609253e41b01d42$var$percentEncode(codePoints[i], $e609253e41b01d42$var$userinfoPercentEncodeSet);
    },
    // https://url.spec.whatwg.org/#dom-url-host
    getHost: function() {
        var host = this.host;
        var port = this.port;
        return host === null ? "" : port === null ? $e609253e41b01d42$var$serializeHost(host) : $e609253e41b01d42$var$serializeHost(host) + ":" + port;
    },
    setHost: function(host) {
        if (this.cannotBeABaseURL) return;
        this.parse(host, $e609253e41b01d42$var$HOST);
    },
    // https://url.spec.whatwg.org/#dom-url-hostname
    getHostname: function() {
        var host = this.host;
        return host === null ? "" : $e609253e41b01d42$var$serializeHost(host);
    },
    setHostname: function(hostname) {
        if (this.cannotBeABaseURL) return;
        this.parse(hostname, $e609253e41b01d42$var$HOSTNAME);
    },
    // https://url.spec.whatwg.org/#dom-url-port
    getPort: function() {
        var port = this.port;
        return port === null ? "" : $53d734af07b69aa7$exports(port);
    },
    setPort: function(port) {
        if (this.cannotHaveUsernamePasswordPort()) return;
        port = $53d734af07b69aa7$exports(port);
        if (port == "") this.port = null;
        else this.parse(port, $e609253e41b01d42$var$PORT);
    },
    // https://url.spec.whatwg.org/#dom-url-pathname
    getPathname: function() {
        var path = this.path;
        return this.cannotBeABaseURL ? path[0] : path.length ? "/" + $e609253e41b01d42$var$join(path, "/") : "";
    },
    setPathname: function(pathname) {
        if (this.cannotBeABaseURL) return;
        this.path = [];
        this.parse(pathname, $e609253e41b01d42$var$PATH_START);
    },
    // https://url.spec.whatwg.org/#dom-url-search
    getSearch: function() {
        var query = this.query;
        return query ? "?" + query : "";
    },
    setSearch: function(search) {
        search = $53d734af07b69aa7$exports(search);
        if (search == "") this.query = null;
        else {
            if ("?" == $e609253e41b01d42$var$charAt(search, 0)) search = $e609253e41b01d42$var$stringSlice(search, 1);
            this.query = "";
            this.parse(search, $e609253e41b01d42$var$QUERY);
        }
        this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-searchparams
    getSearchParams: function() {
        return this.searchParams.facade;
    },
    // https://url.spec.whatwg.org/#dom-url-hash
    getHash: function() {
        var fragment = this.fragment;
        return fragment ? "#" + fragment : "";
    },
    setHash: function(hash) {
        hash = $53d734af07b69aa7$exports(hash);
        if (hash == "") {
            this.fragment = null;
            return;
        }
        if ("#" == $e609253e41b01d42$var$charAt(hash, 0)) hash = $e609253e41b01d42$var$stringSlice(hash, 1);
        this.fragment = "";
        this.parse(hash, $e609253e41b01d42$var$FRAGMENT);
    },
    update: function() {
        this.query = this.searchParams.serialize() || null;
    }
};
// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var $e609253e41b01d42$var$URLConstructor = function URL(url /* , base */ ) {
    var that = $a5a0f9cce104c4f5$exports(this, $e609253e41b01d42$var$URLPrototype);
    var base = $f035ac7c9e51e69e$exports(arguments.length, 1) > 1 ? arguments[1] : undefined;
    var state = $e609253e41b01d42$var$setInternalState(that, new $e609253e41b01d42$var$URLState(url, false, base));
    if (!$0ab298e69b752e0a$exports) {
        that.href = state.serialize();
        that.origin = state.getOrigin();
        that.protocol = state.getProtocol();
        that.username = state.getUsername();
        that.password = state.getPassword();
        that.host = state.getHost();
        that.hostname = state.getHostname();
        that.port = state.getPort();
        that.pathname = state.getPathname();
        that.search = state.getSearch();
        that.searchParams = state.getSearchParams();
        that.hash = state.getHash();
    }
};
var $e609253e41b01d42$var$URLPrototype = $e609253e41b01d42$var$URLConstructor.prototype;
var $e609253e41b01d42$var$accessorDescriptor = function(getter, setter) {
    return {
        get: function() {
            return $e609253e41b01d42$var$getInternalURLState(this)[getter]();
        },
        set: setter && function(value) {
            return $e609253e41b01d42$var$getInternalURLState(this)[setter](value);
        },
        configurable: true,
        enumerable: true
    };
};
if ($0ab298e69b752e0a$exports) {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    $54b1e35819861675$exports($e609253e41b01d42$var$URLPrototype, "href", $e609253e41b01d42$var$accessorDescriptor("serialize", "setHref"));
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    $54b1e35819861675$exports($e609253e41b01d42$var$URLPrototype, "origin", $e609253e41b01d42$var$accessorDescriptor("getOrigin"));
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    $54b1e35819861675$exports($e609253e41b01d42$var$URLPrototype, "protocol", $e609253e41b01d42$var$accessorDescriptor("getProtocol", "setProtocol"));
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    $54b1e35819861675$exports($e609253e41b01d42$var$URLPrototype, "username", $e609253e41b01d42$var$accessorDescriptor("getUsername", "setUsername"));
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    $54b1e35819861675$exports($e609253e41b01d42$var$URLPrototype, "password", $e609253e41b01d42$var$accessorDescriptor("getPassword", "setPassword"));
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    $54b1e35819861675$exports($e609253e41b01d42$var$URLPrototype, "host", $e609253e41b01d42$var$accessorDescriptor("getHost", "setHost"));
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    $54b1e35819861675$exports($e609253e41b01d42$var$URLPrototype, "hostname", $e609253e41b01d42$var$accessorDescriptor("getHostname", "setHostname"));
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    $54b1e35819861675$exports($e609253e41b01d42$var$URLPrototype, "port", $e609253e41b01d42$var$accessorDescriptor("getPort", "setPort"));
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    $54b1e35819861675$exports($e609253e41b01d42$var$URLPrototype, "pathname", $e609253e41b01d42$var$accessorDescriptor("getPathname", "setPathname"));
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    $54b1e35819861675$exports($e609253e41b01d42$var$URLPrototype, "search", $e609253e41b01d42$var$accessorDescriptor("getSearch", "setSearch"));
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    $54b1e35819861675$exports($e609253e41b01d42$var$URLPrototype, "searchParams", $e609253e41b01d42$var$accessorDescriptor("getSearchParams"));
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    $54b1e35819861675$exports($e609253e41b01d42$var$URLPrototype, "hash", $e609253e41b01d42$var$accessorDescriptor("getHash", "setHash"));
}
// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$eeb1abced7a4b5b5$exports($e609253e41b01d42$var$URLPrototype, "toJSON", function toJSON() {
    return $e609253e41b01d42$var$getInternalURLState(this).serialize();
}, {
    enumerable: true
});
// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
$eeb1abced7a4b5b5$exports($e609253e41b01d42$var$URLPrototype, "toString", function toString() {
    return $e609253e41b01d42$var$getInternalURLState(this).serialize();
}, {
    enumerable: true
});
if ($e609253e41b01d42$var$NativeURL) {
    var $e609253e41b01d42$var$nativeCreateObjectURL = $e609253e41b01d42$var$NativeURL.createObjectURL;
    var $e609253e41b01d42$var$nativeRevokeObjectURL = $e609253e41b01d42$var$NativeURL.revokeObjectURL;
    // `URL.createObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
    if ($e609253e41b01d42$var$nativeCreateObjectURL) $eeb1abced7a4b5b5$exports($e609253e41b01d42$var$URLConstructor, "createObjectURL", $130f24665ebee510$exports($e609253e41b01d42$var$nativeCreateObjectURL, $e609253e41b01d42$var$NativeURL));
    // `URL.revokeObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
    if ($e609253e41b01d42$var$nativeRevokeObjectURL) $eeb1abced7a4b5b5$exports($e609253e41b01d42$var$URLConstructor, "revokeObjectURL", $130f24665ebee510$exports($e609253e41b01d42$var$nativeRevokeObjectURL, $e609253e41b01d42$var$NativeURL));
}
$ec32ac1e3fb4a1a1$exports($e609253e41b01d42$var$URLConstructor, "URL");
$0365e955907213bd$exports({
    global: true,
    constructor: true,
    forced: !$b844cc14116d1191$exports,
    sham: !$0ab298e69b752e0a$exports
}, {
    URL: $e609253e41b01d42$var$URLConstructor
});




"use strict";


// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$0365e955907213bd$exports({
    target: "URL",
    proto: true,
    enumerable: true
}, {
    toJSON: function toJSON() {
        return $3b5393d57c251c61$exports(URL.prototype.toString, this);
    }
});


// TODO: Remove this module from `core-js@4` since it's replaced to module below



Object.defineProperty($21a020c73fae2a9e$exports, "__esModule", {
    value: true
});
Object.defineProperty($21a020c73fae2a9e$exports, "TagManager", {
    enumerable: true,
    get: function get() {
        return $21a020c73fae2a9e$var$_TagManager["default"];
    }
});
Object.defineProperty($21a020c73fae2a9e$exports, "ECommerce", {
    enumerable: true,
    get: function get() {
        return $21a020c73fae2a9e$var$_ECommerce["default"];
    }
});
var $81ec44fcffb8d8fd$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $81ec44fcffb8d8fd$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $81ec44fcffb8d8fd$exports));
try {
    regeneratorRuntime = $81ec44fcffb8d8fd$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $81ec44fcffb8d8fd$var$runtime;
    else Function("r", "regeneratorRuntime = r")($81ec44fcffb8d8fd$var$runtime);
}



var $21a020c73fae2a9e$var$_TagManager = $21a020c73fae2a9e$var$_interopRequireDefault((parcelRequire("ghI6l")));

var $21a020c73fae2a9e$var$_ECommerce = $21a020c73fae2a9e$var$_interopRequireDefault((parcelRequire("2EKye")));
function $21a020c73fae2a9e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}



var $3DnwL = parcelRequire("3DnwL");

var $fV3WI = parcelRequire("fV3WI");
"use strict";
function $79741fc7985fcbd5$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $0ceee85252e3e76f$var$toString  } = Object.prototype;
const { getPrototypeOf: $0ceee85252e3e76f$var$getPrototypeOf  } = Object;
const $0ceee85252e3e76f$var$kindOf = ((cache)=>(thing)=>{
        const str = $0ceee85252e3e76f$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $0ceee85252e3e76f$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$0ceee85252e3e76f$var$kindOf(thing) === type;
};
const $0ceee85252e3e76f$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $0ceee85252e3e76f$var$isArray  } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $0ceee85252e3e76f$var$isUndefined = $0ceee85252e3e76f$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $0ceee85252e3e76f$var$isBuffer(val) {
    return val !== null && !$0ceee85252e3e76f$var$isUndefined(val) && val.constructor !== null && !$0ceee85252e3e76f$var$isUndefined(val.constructor) && $0ceee85252e3e76f$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $0ceee85252e3e76f$var$isArrayBuffer = $0ceee85252e3e76f$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $0ceee85252e3e76f$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $0ceee85252e3e76f$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $0ceee85252e3e76f$var$isString = $0ceee85252e3e76f$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $0ceee85252e3e76f$var$isFunction = $0ceee85252e3e76f$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $0ceee85252e3e76f$var$isNumber = $0ceee85252e3e76f$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $0ceee85252e3e76f$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $0ceee85252e3e76f$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $0ceee85252e3e76f$var$isPlainObject = (val)=>{
    if ($0ceee85252e3e76f$var$kindOf(val) !== "object") return false;
    const prototype = $0ceee85252e3e76f$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $0ceee85252e3e76f$var$isDate = $0ceee85252e3e76f$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $0ceee85252e3e76f$var$isFile = $0ceee85252e3e76f$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $0ceee85252e3e76f$var$isBlob = $0ceee85252e3e76f$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $0ceee85252e3e76f$var$isFileList = $0ceee85252e3e76f$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $0ceee85252e3e76f$var$isStream = (val)=>$0ceee85252e3e76f$var$isObject(val) && $0ceee85252e3e76f$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $0ceee85252e3e76f$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $0ceee85252e3e76f$var$isFunction(thing.append) && ((kind = $0ceee85252e3e76f$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $0ceee85252e3e76f$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $0ceee85252e3e76f$var$isURLSearchParams = $0ceee85252e3e76f$var$kindOfTest("URLSearchParams");
const [$0ceee85252e3e76f$var$isReadableStream, $0ceee85252e3e76f$var$isRequest, $0ceee85252e3e76f$var$isResponse, $0ceee85252e3e76f$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($0ceee85252e3e76f$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $0ceee85252e3e76f$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $0ceee85252e3e76f$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false  } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($0ceee85252e3e76f$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $0ceee85252e3e76f$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $0ceee85252e3e76f$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $0ceee85252e3e76f$var$isContextDefined = (context)=>!$0ceee85252e3e76f$var$isUndefined(context) && context !== $0ceee85252e3e76f$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $0ceee85252e3e76f$var$merge() {
    const { caseless: caseless  } = $0ceee85252e3e76f$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $0ceee85252e3e76f$var$findKey(result, key) || key;
        if ($0ceee85252e3e76f$var$isPlainObject(result[targetKey]) && $0ceee85252e3e76f$var$isPlainObject(val)) result[targetKey] = $0ceee85252e3e76f$var$merge(result[targetKey], val);
        else if ($0ceee85252e3e76f$var$isPlainObject(val)) result[targetKey] = $0ceee85252e3e76f$var$merge({}, val);
        else if ($0ceee85252e3e76f$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $0ceee85252e3e76f$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $0ceee85252e3e76f$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys  } = {})=>{
    $0ceee85252e3e76f$var$forEach(b, (val, key)=>{
        if (thisArg && $0ceee85252e3e76f$var$isFunction(val)) a[key] = (0, $79741fc7985fcbd5$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $0ceee85252e3e76f$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $0ceee85252e3e76f$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $0ceee85252e3e76f$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $0ceee85252e3e76f$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $0ceee85252e3e76f$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $0ceee85252e3e76f$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($0ceee85252e3e76f$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$0ceee85252e3e76f$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $0ceee85252e3e76f$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $0ceee85252e3e76f$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $0ceee85252e3e76f$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $0ceee85252e3e76f$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $0ceee85252e3e76f$var$isHTMLForm = $0ceee85252e3e76f$var$kindOfTest("HTMLFormElement");
const $0ceee85252e3e76f$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $0ceee85252e3e76f$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty  })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $0ceee85252e3e76f$var$isRegExp = $0ceee85252e3e76f$var$kindOfTest("RegExp");
const $0ceee85252e3e76f$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $0ceee85252e3e76f$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $0ceee85252e3e76f$var$freezeMethods = (obj)=>{
    $0ceee85252e3e76f$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($0ceee85252e3e76f$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$0ceee85252e3e76f$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $0ceee85252e3e76f$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $0ceee85252e3e76f$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $0ceee85252e3e76f$var$noop = ()=>{};
const $0ceee85252e3e76f$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $0ceee85252e3e76f$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $0ceee85252e3e76f$var$DIGIT = "0123456789";
const $0ceee85252e3e76f$var$ALPHABET = {
    DIGIT: $0ceee85252e3e76f$var$DIGIT,
    ALPHA: $0ceee85252e3e76f$var$ALPHA,
    ALPHA_DIGIT: $0ceee85252e3e76f$var$ALPHA + $0ceee85252e3e76f$var$ALPHA.toUpperCase() + $0ceee85252e3e76f$var$DIGIT
};
const $0ceee85252e3e76f$var$generateString = (size = 16, alphabet = $0ceee85252e3e76f$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length  } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $0ceee85252e3e76f$var$isSpecCompliantForm(thing) {
    return !!(thing && $0ceee85252e3e76f$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $0ceee85252e3e76f$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($0ceee85252e3e76f$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $0ceee85252e3e76f$var$isArray(source) ? [] : {};
                $0ceee85252e3e76f$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$0ceee85252e3e76f$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $0ceee85252e3e76f$var$isAsyncFn = $0ceee85252e3e76f$var$kindOfTest("AsyncFunction");
const $0ceee85252e3e76f$var$isThenable = (thing)=>thing && ($0ceee85252e3e76f$var$isObject(thing) || $0ceee85252e3e76f$var$isFunction(thing)) && $0ceee85252e3e76f$var$isFunction(thing.then) && $0ceee85252e3e76f$var$isFunction(thing.catch);
var $0ceee85252e3e76f$export$2e2bcd8739ae039 = {
    isArray: $0ceee85252e3e76f$var$isArray,
    isArrayBuffer: $0ceee85252e3e76f$var$isArrayBuffer,
    isBuffer: $0ceee85252e3e76f$var$isBuffer,
    isFormData: $0ceee85252e3e76f$var$isFormData,
    isArrayBufferView: $0ceee85252e3e76f$var$isArrayBufferView,
    isString: $0ceee85252e3e76f$var$isString,
    isNumber: $0ceee85252e3e76f$var$isNumber,
    isBoolean: $0ceee85252e3e76f$var$isBoolean,
    isObject: $0ceee85252e3e76f$var$isObject,
    isPlainObject: $0ceee85252e3e76f$var$isPlainObject,
    isReadableStream: $0ceee85252e3e76f$var$isReadableStream,
    isRequest: $0ceee85252e3e76f$var$isRequest,
    isResponse: $0ceee85252e3e76f$var$isResponse,
    isHeaders: $0ceee85252e3e76f$var$isHeaders,
    isUndefined: $0ceee85252e3e76f$var$isUndefined,
    isDate: $0ceee85252e3e76f$var$isDate,
    isFile: $0ceee85252e3e76f$var$isFile,
    isBlob: $0ceee85252e3e76f$var$isBlob,
    isRegExp: $0ceee85252e3e76f$var$isRegExp,
    isFunction: $0ceee85252e3e76f$var$isFunction,
    isStream: $0ceee85252e3e76f$var$isStream,
    isURLSearchParams: $0ceee85252e3e76f$var$isURLSearchParams,
    isTypedArray: $0ceee85252e3e76f$var$isTypedArray,
    isFileList: $0ceee85252e3e76f$var$isFileList,
    forEach: $0ceee85252e3e76f$var$forEach,
    merge: $0ceee85252e3e76f$var$merge,
    extend: $0ceee85252e3e76f$var$extend,
    trim: $0ceee85252e3e76f$var$trim,
    stripBOM: $0ceee85252e3e76f$var$stripBOM,
    inherits: $0ceee85252e3e76f$var$inherits,
    toFlatObject: $0ceee85252e3e76f$var$toFlatObject,
    kindOf: $0ceee85252e3e76f$var$kindOf,
    kindOfTest: $0ceee85252e3e76f$var$kindOfTest,
    endsWith: $0ceee85252e3e76f$var$endsWith,
    toArray: $0ceee85252e3e76f$var$toArray,
    forEachEntry: $0ceee85252e3e76f$var$forEachEntry,
    matchAll: $0ceee85252e3e76f$var$matchAll,
    isHTMLForm: $0ceee85252e3e76f$var$isHTMLForm,
    hasOwnProperty: $0ceee85252e3e76f$var$hasOwnProperty,
    hasOwnProp: $0ceee85252e3e76f$var$hasOwnProperty,
    reduceDescriptors: $0ceee85252e3e76f$var$reduceDescriptors,
    freezeMethods: $0ceee85252e3e76f$var$freezeMethods,
    toObjectSet: $0ceee85252e3e76f$var$toObjectSet,
    toCamelCase: $0ceee85252e3e76f$var$toCamelCase,
    noop: $0ceee85252e3e76f$var$noop,
    toFiniteNumber: $0ceee85252e3e76f$var$toFiniteNumber,
    findKey: $0ceee85252e3e76f$var$findKey,
    global: $0ceee85252e3e76f$var$_global,
    isContextDefined: $0ceee85252e3e76f$var$isContextDefined,
    ALPHABET: $0ceee85252e3e76f$var$ALPHABET,
    generateString: $0ceee85252e3e76f$var$generateString,
    isSpecCompliantForm: $0ceee85252e3e76f$var$isSpecCompliantForm,
    toJSONObject: $0ceee85252e3e76f$var$toJSONObject,
    isAsyncFn: $0ceee85252e3e76f$var$isAsyncFn,
    isThenable: $0ceee85252e3e76f$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $4ac9b08ec3b016e4$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).inherits($4ac9b08ec3b016e4$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $4ac9b08ec3b016e4$var$prototype = $4ac9b08ec3b016e4$var$AxiosError.prototype;
const $4ac9b08ec3b016e4$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $4ac9b08ec3b016e4$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4ac9b08ec3b016e4$var$AxiosError, $4ac9b08ec3b016e4$var$descriptors);
Object.defineProperty($4ac9b08ec3b016e4$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$4ac9b08ec3b016e4$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($4ac9b08ec3b016e4$var$prototype);
    (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $4ac9b08ec3b016e4$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $4ac9b08ec3b016e4$export$2e2bcd8739ae039 = $4ac9b08ec3b016e4$var$AxiosError;


// eslint-disable-next-line strict
var $d8683b6a004111bf$export$2e2bcd8739ae039 = null;



var $5oOz5 = parcelRequire("5oOz5");
var $e2918f45ec21e205$require$Buffer = $5oOz5.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e2918f45ec21e205$var$isVisitable(thing) {
    return (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e2918f45ec21e205$var$removeBrackets(key) {
    return (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e2918f45ec21e205$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e2918f45ec21e205$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e2918f45ec21e205$var$isFlatArray(arr) {
    return (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e2918f45ec21e205$var$isVisitable);
}
const $e2918f45ec21e205$var$predicates = (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).toFlatObject((0, $0ceee85252e3e76f$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e2918f45ec21e205$var$toFormData(obj, formData, options) {
    if (!(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $d8683b6a004111bf$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $e2918f45ec21e205$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isArray(value) && $e2918f45ec21e205$var$isFlatArray(value) || ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isFileList(value) || (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e2918f45ec21e205$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e2918f45ec21e205$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($e2918f45ec21e205$var$isVisitable(value)) return true;
        formData.append($e2918f45ec21e205$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e2918f45ec21e205$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e2918f45ec21e205$var$isVisitable
    });
    function build(value, path) {
        if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $e2918f45ec21e205$export$2e2bcd8739ae039 = $e2918f45ec21e205$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $7e008d03db00e16e$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $7e008d03db00e16e$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e2918f45ec21e205$export$2e2bcd8739ae039)(params, this, options);
}
const $7e008d03db00e16e$var$prototype = $7e008d03db00e16e$var$AxiosURLSearchParams.prototype;
$7e008d03db00e16e$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$7e008d03db00e16e$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $7e008d03db00e16e$var$encode);
    } : $7e008d03db00e16e$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $7e008d03db00e16e$export$2e2bcd8739ae039 = $7e008d03db00e16e$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $ff416d6ce81d6608$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $ff416d6ce81d6608$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $ff416d6ce81d6608$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $7e008d03db00e16e$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $069703744a46ee24$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $069703744a46ee24$export$2e2bcd8739ae039 = $069703744a46ee24$var$InterceptorManager;





"use strict";
var $a0755868327a2a56$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $94be303ec081930a$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $7e008d03db00e16e$export$2e2bcd8739ae039);


"use strict";
var $631d2e665cb9f8f5$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $00e00b626502863f$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $8996fc9db7be9fc9$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $94be303ec081930a$export$2e2bcd8739ae039,
        FormData: $631d2e665cb9f8f5$export$2e2bcd8739ae039,
        Blob: $00e00b626502863f$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $d01c4e9313c6a51f$exports = {};

$parcel$export($d01c4e9313c6a51f$exports, "hasBrowserEnv", function () { return $d01c4e9313c6a51f$export$c4996c4b7b93b0bf; });
$parcel$export($d01c4e9313c6a51f$exports, "hasStandardBrowserEnv", function () { return $d01c4e9313c6a51f$export$c0bcc9250309d66; });
$parcel$export($d01c4e9313c6a51f$exports, "hasStandardBrowserWebWorkerEnv", function () { return $d01c4e9313c6a51f$export$c81692cf5af97dac; });
$parcel$export($d01c4e9313c6a51f$exports, "origin", function () { return $d01c4e9313c6a51f$export$f710a83a91838a36; });
const $d01c4e9313c6a51f$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $d01c4e9313c6a51f$export$c0bcc9250309d66 = ((product)=>{
    return $d01c4e9313c6a51f$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $d01c4e9313c6a51f$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $d01c4e9313c6a51f$export$f710a83a91838a36 = $d01c4e9313c6a51f$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $0db823b3c0009c6a$export$2e2bcd8739ae039 = {
    ...$d01c4e9313c6a51f$exports,
    ...(0, $8996fc9db7be9fc9$export$2e2bcd8739ae039)
};


"use strict";
function $28f799e22a73ce82$export$2e2bcd8739ae039(data, options) {
    return (0, $e2918f45ec21e205$export$2e2bcd8739ae039)(data, new (0, $0db823b3c0009c6a$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $0db823b3c0009c6a$export$2e2bcd8739ae039).isNode && (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $9b4ad14e489b601b$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $9b4ad14e489b601b$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $9b4ad14e489b601b$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $9b4ad14e489b601b$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isFormData(formData) && (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($9b4ad14e489b601b$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $9b4ad14e489b601b$export$2e2bcd8739ae039 = $9b4ad14e489b601b$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $7479367f9f542a74$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $7479367f9f542a74$var$defaults = {
    transitional: (0, $a0755868327a2a56$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $9b4ad14e489b601b$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isBuffer(data) || (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isStream(data) || (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isFile(data) || (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isBlob(data) || (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $28f799e22a73ce82$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $e2918f45ec21e205$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $7479367f9f542a74$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $7479367f9f542a74$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isResponse(data) || (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039).from(e, (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $0db823b3c0009c6a$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $0db823b3c0009c6a$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $7479367f9f542a74$var$defaults.headers[method] = {};
});
var $7479367f9f542a74$export$2e2bcd8739ae039 = $7479367f9f542a74$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $b72d10db15ae2d1f$var$ignoreDuplicateOf = (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $b72d10db15ae2d1f$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $b72d10db15ae2d1f$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $1469a411a9078071$var$$internals = Symbol("internals");
function $1469a411a9078071$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $1469a411a9078071$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isArray(value) ? value.map($1469a411a9078071$var$normalizeValue) : String(value);
}
function $1469a411a9078071$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $1469a411a9078071$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $1469a411a9078071$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $1469a411a9078071$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $1469a411a9078071$var$buildAccessors(obj, header) {
    const accessorName = (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $1469a411a9078071$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $1469a411a9078071$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $1469a411a9078071$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$1469a411a9078071$var$isValidHeaderName(header)) setHeaders((0, $b72d10db15ae2d1f$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $1469a411a9078071$var$normalizeHeader(header);
        if (header) {
            const key = (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $1469a411a9078071$var$parseTokens(value);
                if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $1469a411a9078071$var$normalizeHeader(header);
        if (header) {
            const key = (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $1469a411a9078071$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $1469a411a9078071$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $1469a411a9078071$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $1469a411a9078071$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $1469a411a9078071$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $1469a411a9078071$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $1469a411a9078071$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$1469a411a9078071$var$$internals] = this[$1469a411a9078071$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $1469a411a9078071$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $1469a411a9078071$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$1469a411a9078071$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).reduceDescriptors($1469a411a9078071$var$AxiosHeaders.prototype, ({ value: value  }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).freezeMethods($1469a411a9078071$var$AxiosHeaders);
var $1469a411a9078071$export$2e2bcd8739ae039 = $1469a411a9078071$var$AxiosHeaders;


"use strict";
function $195d74da069f6982$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $7479367f9f542a74$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $1469a411a9078071$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $7a417ac17d7043b3$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $38fb7ca07899219b$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).inherits($38fb7ca07899219b$var$CanceledError, (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $38fb7ca07899219b$export$2e2bcd8739ae039 = $38fb7ca07899219b$var$CanceledError;







"use strict";
function $6b891d553078f6b3$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $e739fb184fe603b7$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $86beae8fd702c75f$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $86beae8fd702c75f$export$2e2bcd8739ae039 = $86beae8fd702c75f$var$speedometer;


"use strict";
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $ba1864c9cc1df24a$var$throttle(fn, freq) {
    let timestamp = 0;
    const threshold = 1000 / freq;
    let timer = null;
    return function throttled() {
        const force = this === true;
        const now = Date.now();
        if (force || now - timestamp > threshold) {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            timestamp = now;
            return fn.apply(null, arguments);
        }
        if (!timer) timer = setTimeout(()=>{
            timer = null;
            timestamp = Date.now();
            return fn.apply(null, arguments);
        }, threshold - (now - timestamp));
    };
}
var $ba1864c9cc1df24a$export$2e2bcd8739ae039 = $ba1864c9cc1df24a$var$throttle;


var $941d62d05ef25b88$export$2e2bcd8739ae039 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $86beae8fd702c75f$export$2e2bcd8739ae039)(50, 250);
    return (0, $ba1864c9cc1df24a$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    }, freq);
};






"use strict";
var $3272d162da4983a8$export$2e2bcd8739ae039 = (0, $0db823b3c0009c6a$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();




var $600e102e4adad3b5$export$2e2bcd8739ae039 = (0, $0db823b3c0009c6a$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


"use strict";
function $f34bf030cc02e581$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $7dd2a761eb6e1cdd$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $d335b8a0101cf12c$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $f34bf030cc02e581$export$2e2bcd8739ae039)(requestedURL)) return (0, $7dd2a761eb6e1cdd$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
const $03e7ac9d573e4c2e$var$headersToObject = (thing)=>thing instanceof (0, $1469a411a9078071$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $03e7ac9d573e4c2e$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isPlainObject(target) && (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($03e7ac9d573e4c2e$var$headersToObject(a), $03e7ac9d573e4c2e$var$headersToObject(b), true)
    };
    (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $42b519efb64bd6d7$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $03e7ac9d573e4c2e$export$2e2bcd8739ae039)({}, config);
    let { data: data , withXSRFToken: withXSRFToken , xsrfHeaderName: xsrfHeaderName , xsrfCookieName: xsrfCookieName , headers: headers , auth: auth  } = newConfig;
    newConfig.headers = headers = (0, $1469a411a9078071$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $ff416d6ce81d6608$export$2e2bcd8739ae039)((0, $d335b8a0101cf12c$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $0db823b3c0009c6a$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $0db823b3c0009c6a$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $0db823b3c0009c6a$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $3272d162da4983a8$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $600e102e4adad3b5$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $3f09bc1e3a357562$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $3f09bc1e3a357562$export$2e2bcd8739ae039 = $3f09bc1e3a357562$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $42b519efb64bd6d7$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $1469a411a9078071$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType  } = _config;
        let onCanceled;
        function done() {
            if (_config.cancelToken) _config.cancelToken.unsubscribe(onCanceled);
            if (_config.signal) _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $1469a411a9078071$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $6b891d553078f6b3$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039)("Request aborted", (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039).ECONNABORTED, _config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039)("Network Error", (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039).ERR_NETWORK, _config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $a0755868327a2a56$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039).ECONNABORTED, _config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (typeof _config.onDownloadProgress === "function") request.addEventListener("progress", (0, $941d62d05ef25b88$export$2e2bcd8739ae039)(_config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof _config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", (0, $941d62d05ef25b88$export$2e2bcd8739ae039)(_config.onUploadProgress));
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $38fb7ca07899219b$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $e739fb184fe603b7$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $0db823b3c0009c6a$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};







const $2a6bd2b825b07947$var$composeSignals = (signals, timeout)=>{
    let controller = new AbortController();
    let aborted;
    const onabort = function(cancel) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = cancel instanceof Error ? cancel : this.reason;
            controller.abort(err instanceof (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039) ? err : new (0, $38fb7ca07899219b$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        onabort(new (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (signals) {
            timer && clearTimeout(timer);
            timer = null;
            signals.forEach((signal)=>{
                signal && (signal.removeEventListener ? signal.removeEventListener("abort", onabort) : signal.unsubscribe(onabort));
            });
            signals = null;
        }
    };
    signals.forEach((signal)=>signal && signal.addEventListener && signal.addEventListener("abort", onabort));
    const { signal: signal  } = controller;
    signal.unsubscribe = unsubscribe;
    return [
        signal,
        ()=>{
            timer && clearTimeout(timer);
            timer = null;
        }
    ];
};
var $2a6bd2b825b07947$export$2e2bcd8739ae039 = $2a6bd2b825b07947$var$composeSignals;


const $0b62466b3669c6c9$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $0b62466b3669c6c9$export$f9f241124ee3198e = async function*(iterable, chunkSize, encode) {
    for await (const chunk of iterable)yield* $0b62466b3669c6c9$export$71b051935044bd5d(ArrayBuffer.isView(chunk) ? chunk : await encode(String(chunk)), chunkSize);
};
const $0b62466b3669c6c9$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish, encode)=>{
    const iterator = $0b62466b3669c6c9$export$f9f241124ee3198e(stream, chunkSize, encode);
    let bytes = 0;
    return new ReadableStream({
        type: "bytes",
        async pull (controller) {
            const { done: done , value: value  } = await iterator.next();
            if (done) {
                controller.close();
                onFinish();
                return;
            }
            let len = value.byteLength;
            onProgress && onProgress(bytes += len);
            controller.enqueue(new Uint8Array(value));
        },
        cancel (reason) {
            onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $6e1686c075ed877f$var$fetchProgressDecorator = (total, fn)=>{
    const lengthComputable = total != null;
    return (loaded)=>setTimeout(()=>fn({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }));
};
const $6e1686c075ed877f$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $6e1686c075ed877f$var$isReadableStreamSupported = $6e1686c075ed877f$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $6e1686c075ed877f$var$encodeText = $6e1686c075ed877f$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $6e1686c075ed877f$var$supportsRequestStream = $6e1686c075ed877f$var$isReadableStreamSupported && (()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $0db823b3c0009c6a$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
})();
const $6e1686c075ed877f$var$DEFAULT_CHUNK_SIZE = 65536;
const $6e1686c075ed877f$var$supportsResponseStream = $6e1686c075ed877f$var$isReadableStreamSupported && !!(()=>{
    try {
        return (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isReadableStream(new Response("").body);
    } catch (err) {
    // return undefined
    }
})();
const $6e1686c075ed877f$var$resolvers = {
    stream: $6e1686c075ed877f$var$supportsResponseStream && ((res)=>res.body)
};
$6e1686c075ed877f$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$6e1686c075ed877f$var$resolvers[type] && ($6e1686c075ed877f$var$resolvers[type] = (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $6e1686c075ed877f$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isSpecCompliantForm(body)) return (await new Request(body).arrayBuffer()).byteLength;
    if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isArrayBufferView(body)) return body.byteLength;
    if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
    if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isString(body)) return (await $6e1686c075ed877f$var$encodeText(body)).byteLength;
};
const $6e1686c075ed877f$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $6e1686c075ed877f$var$getBodyLength(body) : length;
};
var $6e1686c075ed877f$export$2e2bcd8739ae039 = $6e1686c075ed877f$var$isFetchSupported && (async (config)=>{
    let { url: url , method: method , data: data , signal: signal , cancelToken: cancelToken , timeout: timeout , onDownloadProgress: onDownloadProgress , onUploadProgress: onUploadProgress , responseType: responseType , headers: headers , withCredentials: withCredentials = "same-origin" , fetchOptions: fetchOptions  } = (0, $42b519efb64bd6d7$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let [composedSignal, stopTimeout] = signal || cancelToken || timeout ? (0, $2a6bd2b825b07947$export$2e2bcd8739ae039)([
        signal,
        cancelToken
    ], timeout) : [];
    let finished, request;
    const onFinish = ()=>{
        !finished && setTimeout(()=>{
            composedSignal && composedSignal.unsubscribe();
        });
        finished = true;
    };
    let requestContentLength;
    try {
        if (onUploadProgress && $6e1686c075ed877f$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $6e1686c075ed877f$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) data = (0, $0b62466b3669c6c9$export$b0119225647bd83)(_request.body, $6e1686c075ed877f$var$DEFAULT_CHUNK_SIZE, $6e1686c075ed877f$var$fetchProgressDecorator(requestContentLength, (0, $941d62d05ef25b88$export$2e2bcd8739ae039)(onUploadProgress)), null, $6e1686c075ed877f$var$encodeText);
        }
        if (!(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "cors" : "omit";
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            withCredentials: withCredentials
        });
        let response = await fetch(request);
        const isStreamResponse = $6e1686c075ed877f$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($6e1686c075ed877f$var$supportsResponseStream && (onDownloadProgress || isStreamResponse)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
            response = new Response((0, $0b62466b3669c6c9$export$b0119225647bd83)(response.body, $6e1686c075ed877f$var$DEFAULT_CHUNK_SIZE, onDownloadProgress && $6e1686c075ed877f$var$fetchProgressDecorator(responseContentLength, (0, $941d62d05ef25b88$export$2e2bcd8739ae039)(onDownloadProgress, true)), isStreamResponse && onFinish, $6e1686c075ed877f$var$encodeText), options);
        }
        responseType = responseType || "text";
        let responseData = await $6e1686c075ed877f$var$resolvers[(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).findKey($6e1686c075ed877f$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && onFinish();
        stopTimeout && stopTimeout();
        return await new Promise((resolve, reject)=>{
            (0, $6b891d553078f6b3$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $1469a411a9078071$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        onFinish();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039)("Network Error", (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $e8452a9d2a7282f3$var$knownAdapters = {
    http: (0, $d8683b6a004111bf$export$2e2bcd8739ae039),
    xhr: (0, $3f09bc1e3a357562$export$2e2bcd8739ae039),
    fetch: (0, $6e1686c075ed877f$export$2e2bcd8739ae039)
};
(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).forEach($e8452a9d2a7282f3$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $e8452a9d2a7282f3$var$renderReason = (reason)=>`- ${reason}`;
const $e8452a9d2a7282f3$var$isResolvedHandle = (adapter)=>(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $e8452a9d2a7282f3$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length  } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$e8452a9d2a7282f3$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $e8452a9d2a7282f3$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($e8452a9d2a7282f3$var$renderReason).join("\n") : " " + $e8452a9d2a7282f3$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $e8452a9d2a7282f3$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $103e6e22da5432b7$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $38fb7ca07899219b$export$2e2bcd8739ae039)(null, config);
}
function $103e6e22da5432b7$export$2e2bcd8739ae039(config) {
    $103e6e22da5432b7$var$throwIfCancellationRequested(config);
    config.headers = (0, $1469a411a9078071$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $195d74da069f6982$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $e8452a9d2a7282f3$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $7479367f9f542a74$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $103e6e22da5432b7$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $195d74da069f6982$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $1469a411a9078071$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $7a417ac17d7043b3$export$2e2bcd8739ae039)(reason)) {
            $103e6e22da5432b7$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $195d74da069f6982$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $1469a411a9078071$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $eb4b9daa067f0bd4$export$a4ad2735b021c132 = "1.7.2";



"use strict";
const $fee63ebd223fd372$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $fee63ebd223fd372$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $fee63ebd223fd372$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $fee63ebd223fd372$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $eb4b9daa067f0bd4$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$fee63ebd223fd372$var$deprecatedWarnings[opt]) {
            $fee63ebd223fd372$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $fee63ebd223fd372$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039)("options must be an object", (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $fee63ebd223fd372$export$2e2bcd8739ae039 = {
    assertOptions: $fee63ebd223fd372$var$assertOptions,
    validators: $fee63ebd223fd372$var$validators
};



"use strict";
const $0c27d7368f2b8698$var$validators = (0, $fee63ebd223fd372$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $0c27d7368f2b8698$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $069703744a46ee24$export$2e2bcd8739ae039)(),
            response: new (0, $069703744a46ee24$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $03e7ac9d573e4c2e$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional , paramsSerializer: paramsSerializer , headers: headers  } = config;
        if (transitional !== undefined) (0, $fee63ebd223fd372$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $0c27d7368f2b8698$var$validators.transitional($0c27d7368f2b8698$var$validators.boolean),
            forcedJSONParsing: $0c27d7368f2b8698$var$validators.transitional($0c27d7368f2b8698$var$validators.boolean),
            clarifyTimeoutError: $0c27d7368f2b8698$var$validators.transitional($0c27d7368f2b8698$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $fee63ebd223fd372$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $0c27d7368f2b8698$var$validators.function,
                serialize: $0c27d7368f2b8698$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $1469a411a9078071$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $103e6e22da5432b7$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $103e6e22da5432b7$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $03e7ac9d573e4c2e$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $d335b8a0101cf12c$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $ff416d6ce81d6608$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $0c27d7368f2b8698$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $03e7ac9d573e4c2e$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $0ceee85252e3e76f$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $03e7ac9d573e4c2e$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $0c27d7368f2b8698$var$Axios.prototype[method] = generateHTTPMethod();
    $0c27d7368f2b8698$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $0c27d7368f2b8698$export$2e2bcd8739ae039 = $0c27d7368f2b8698$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $9c79df427a1c4eae$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $38fb7ca07899219b$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $9c79df427a1c4eae$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $9c79df427a1c4eae$export$2e2bcd8739ae039 = $9c79df427a1c4eae$var$CancelToken;






"use strict";
function $7eabcc2357c4c389$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $1154d1f720e814c0$export$2e2bcd8739ae039(payload) {
    return (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $bbcc7ac24abc1bec$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($bbcc7ac24abc1bec$var$HttpStatusCode).forEach(([key, value])=>{
    $bbcc7ac24abc1bec$var$HttpStatusCode[value] = key;
});
var $bbcc7ac24abc1bec$export$2e2bcd8739ae039 = $bbcc7ac24abc1bec$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $1fe178238660350a$var$createInstance(defaultConfig) {
    const context = new (0, $0c27d7368f2b8698$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $79741fc7985fcbd5$export$2e2bcd8739ae039)((0, $0c27d7368f2b8698$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).extend(instance, (0, $0c27d7368f2b8698$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $0ceee85252e3e76f$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $1fe178238660350a$var$createInstance((0, $03e7ac9d573e4c2e$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $1fe178238660350a$var$axios = $1fe178238660350a$var$createInstance((0, $7479367f9f542a74$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$1fe178238660350a$var$axios.Axios = (0, $0c27d7368f2b8698$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$1fe178238660350a$var$axios.CanceledError = (0, $38fb7ca07899219b$export$2e2bcd8739ae039);
$1fe178238660350a$var$axios.CancelToken = (0, $9c79df427a1c4eae$export$2e2bcd8739ae039);
$1fe178238660350a$var$axios.isCancel = (0, $7a417ac17d7043b3$export$2e2bcd8739ae039);
$1fe178238660350a$var$axios.VERSION = (0, $eb4b9daa067f0bd4$export$a4ad2735b021c132);
$1fe178238660350a$var$axios.toFormData = (0, $e2918f45ec21e205$export$2e2bcd8739ae039);
// Expose AxiosError class
$1fe178238660350a$var$axios.AxiosError = (0, $4ac9b08ec3b016e4$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$1fe178238660350a$var$axios.Cancel = $1fe178238660350a$var$axios.CanceledError;
// Expose all/spread
$1fe178238660350a$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$1fe178238660350a$var$axios.spread = (0, $7eabcc2357c4c389$export$2e2bcd8739ae039);
// Expose isAxiosError
$1fe178238660350a$var$axios.isAxiosError = (0, $1154d1f720e814c0$export$2e2bcd8739ae039);
// Expose mergeConfig
$1fe178238660350a$var$axios.mergeConfig = (0, $03e7ac9d573e4c2e$export$2e2bcd8739ae039);
$1fe178238660350a$var$axios.AxiosHeaders = (0, $1469a411a9078071$export$2e2bcd8739ae039);
$1fe178238660350a$var$axios.formToJSON = (thing)=>(0, $9b4ad14e489b601b$export$2e2bcd8739ae039)((0, $0ceee85252e3e76f$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$1fe178238660350a$var$axios.getAdapter = (0, $e8452a9d2a7282f3$export$2e2bcd8739ae039).getAdapter;
$1fe178238660350a$var$axios.HttpStatusCode = (0, $bbcc7ac24abc1bec$export$2e2bcd8739ae039);
$1fe178238660350a$var$axios.default = $1fe178238660350a$var$axios;
var // this module should only have a default export
$1fe178238660350a$export$2e2bcd8739ae039 = $1fe178238660350a$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $972b70aa84cf6f14$export$1c00760e9e5a4e95 , AxiosError: $972b70aa84cf6f14$export$c1fbed17c2f6a328 , CanceledError: $972b70aa84cf6f14$export$1ab0c6b20d94fa14 , isCancel: $972b70aa84cf6f14$export$3b22524397b493c6 , CancelToken: $972b70aa84cf6f14$export$fd08e3cb425f0d61 , VERSION: $972b70aa84cf6f14$export$a4ad2735b021c132 , all: $972b70aa84cf6f14$export$84bf76cd7afc7469 , Cancel: $972b70aa84cf6f14$export$848c9b7ead0df967 , isAxiosError: $972b70aa84cf6f14$export$fbafdbe06a5b5a9a , spread: $972b70aa84cf6f14$export$3ae0fd4797ed47c8 , toFormData: $972b70aa84cf6f14$export$10ae0d317ea97f8b , AxiosHeaders: $972b70aa84cf6f14$export$4e7d6ff0f3e6520 , HttpStatusCode: $972b70aa84cf6f14$export$a972f69c851492b3 , formToJSON: $972b70aa84cf6f14$export$86d7c59254d6a2c9 , getAdapter: $972b70aa84cf6f14$export$17ddc20a97d669e2 , mergeConfig: $972b70aa84cf6f14$export$7ec1ebcfa9d8bd6a  } = (0, $1fe178238660350a$export$2e2bcd8739ae039);


var $478d1a5c1a4e6ad0$exports = {};
"use strict";
const $478d1a5c1a4e6ad0$var$denyList = new Set([
    "ENOTFOUND",
    "ENETUNREACH",
    // SSL errors from https://github.com/nodejs/node/blob/fc8e3e2cdc521978351de257030db0076d79e0ab/src/crypto/crypto_common.cc#L301-L328
    "UNABLE_TO_GET_ISSUER_CERT",
    "UNABLE_TO_GET_CRL",
    "UNABLE_TO_DECRYPT_CERT_SIGNATURE",
    "UNABLE_TO_DECRYPT_CRL_SIGNATURE",
    "UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY",
    "CERT_SIGNATURE_FAILURE",
    "CRL_SIGNATURE_FAILURE",
    "CERT_NOT_YET_VALID",
    "CERT_HAS_EXPIRED",
    "CRL_NOT_YET_VALID",
    "CRL_HAS_EXPIRED",
    "ERROR_IN_CERT_NOT_BEFORE_FIELD",
    "ERROR_IN_CERT_NOT_AFTER_FIELD",
    "ERROR_IN_CRL_LAST_UPDATE_FIELD",
    "ERROR_IN_CRL_NEXT_UPDATE_FIELD",
    "OUT_OF_MEM",
    "DEPTH_ZERO_SELF_SIGNED_CERT",
    "SELF_SIGNED_CERT_IN_CHAIN",
    "UNABLE_TO_GET_ISSUER_CERT_LOCALLY",
    "UNABLE_TO_VERIFY_LEAF_SIGNATURE",
    "CERT_CHAIN_TOO_LONG",
    "CERT_REVOKED",
    "INVALID_CA",
    "PATH_LENGTH_EXCEEDED",
    "INVALID_PURPOSE",
    "CERT_UNTRUSTED",
    "CERT_REJECTED",
    "HOSTNAME_MISMATCH"
]);
// TODO: Use `error?.code` when targeting Node.js 14
$478d1a5c1a4e6ad0$exports = (error)=>!$478d1a5c1a4e6ad0$var$denyList.has(error && error.code);


const $1e446b88ae152757$export$76a88f7de6507443 = "axios-retry";
function $1e446b88ae152757$export$476aa014e2fd89d5(error) {
    const CODE_EXCLUDE_LIST = [
        "ERR_CANCELED",
        "ECONNABORTED"
    ];
    if (error.response) return false;
    if (!error.code) return false;
    // Prevents retrying timed out & cancelled requests
    if (CODE_EXCLUDE_LIST.includes(error.code)) return false;
    // Prevents retrying unsafe errors
    return (0, (/*@__PURE__*/$parcel$interopDefault($478d1a5c1a4e6ad0$exports)))(error);
}
const $1e446b88ae152757$var$SAFE_HTTP_METHODS = [
    "get",
    "head",
    "options"
];
const $1e446b88ae152757$var$IDEMPOTENT_HTTP_METHODS = $1e446b88ae152757$var$SAFE_HTTP_METHODS.concat([
    "put",
    "delete"
]);
function $1e446b88ae152757$export$5f1dc21fa925930b(error) {
    return error.code !== "ECONNABORTED" && (!error.response || error.response.status === 429 || error.response.status >= 500 && error.response.status <= 599);
}
function $1e446b88ae152757$export$693cf906fd8817e5(error) {
    if (!error.config?.method) // Cannot determine if the request can be retried
    return false;
    return $1e446b88ae152757$export$5f1dc21fa925930b(error) && $1e446b88ae152757$var$SAFE_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
function $1e446b88ae152757$export$d26799ad4978234d(error) {
    if (!error.config?.method) // Cannot determine if the request can be retried
    return false;
    return $1e446b88ae152757$export$5f1dc21fa925930b(error) && $1e446b88ae152757$var$IDEMPOTENT_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
function $1e446b88ae152757$export$606bf0a2b170eb2(error) {
    return $1e446b88ae152757$export$476aa014e2fd89d5(error) || $1e446b88ae152757$export$d26799ad4978234d(error);
}
function $1e446b88ae152757$export$e981df388f003617(error) {
    const retryAfterHeader = error?.response?.headers["retry-after"];
    if (!retryAfterHeader) return 0;
    // if the retry after header is a number, convert it to milliseconds
    let retryAfterMs = (Number(retryAfterHeader) || 0) * 1000;
    // If the retry after header is a date, get the number of milliseconds until that date
    if (retryAfterMs === 0) retryAfterMs = (new Date(retryAfterHeader).valueOf() || 0) - Date.now();
    return Math.max(0, retryAfterMs);
}
function $1e446b88ae152757$var$noDelay(_retryNumber = 0, error) {
    return Math.max(0, $1e446b88ae152757$export$e981df388f003617(error));
}
function $1e446b88ae152757$export$ce2bf54576c66713(retryNumber = 0, error, delayFactor = 100) {
    const calculatedDelay = 2 ** retryNumber * delayFactor;
    const delay = Math.max(calculatedDelay, $1e446b88ae152757$export$e981df388f003617(error));
    const randomSum = delay * 0.2 * Math.random(); // 0-20% of the delay
    return delay + randomSum;
}
const $1e446b88ae152757$export$93ca5d3f8675ae4c = {
    retries: 3,
    retryCondition: $1e446b88ae152757$export$606bf0a2b170eb2,
    retryDelay: $1e446b88ae152757$var$noDelay,
    shouldResetTimeout: false,
    onRetry: ()=>{},
    onMaxRetryTimesExceeded: ()=>{},
    validateResponse: null
};
function $1e446b88ae152757$var$getRequestOptions(config, defaultOptions) {
    return {
        ...$1e446b88ae152757$export$93ca5d3f8675ae4c,
        ...defaultOptions,
        ...config[$1e446b88ae152757$export$76a88f7de6507443]
    };
}
function $1e446b88ae152757$var$setCurrentState(config, defaultOptions) {
    const currentState = $1e446b88ae152757$var$getRequestOptions(config, defaultOptions || {});
    currentState.retryCount = currentState.retryCount || 0;
    currentState.lastRequestTime = currentState.lastRequestTime || Date.now();
    config[$1e446b88ae152757$export$76a88f7de6507443] = currentState;
    return currentState;
}
function $1e446b88ae152757$var$fixConfig(axiosInstance, config) {
    // @ts-ignore
    if (axiosInstance.defaults.agent === config.agent) // @ts-ignore
    delete config.agent;
    if (axiosInstance.defaults.httpAgent === config.httpAgent) delete config.httpAgent;
    if (axiosInstance.defaults.httpsAgent === config.httpsAgent) delete config.httpsAgent;
}
async function $1e446b88ae152757$var$shouldRetry(currentState, error) {
    const { retries: retries , retryCondition: retryCondition  } = currentState;
    const shouldRetryOrPromise = (currentState.retryCount || 0) < retries && retryCondition(error);
    // This could be a promise
    if (typeof shouldRetryOrPromise === "object") try {
        const shouldRetryPromiseResult = await shouldRetryOrPromise;
        // keep return true unless shouldRetryPromiseResult return false for compatibility
        return shouldRetryPromiseResult !== false;
    } catch (_err) {
        return false;
    }
    return shouldRetryOrPromise;
}
async function $1e446b88ae152757$var$handleRetry(axiosInstance, currentState, error, config) {
    currentState.retryCount += 1;
    const { retryDelay: retryDelay , shouldResetTimeout: shouldResetTimeout , onRetry: onRetry  } = currentState;
    const delay = retryDelay(currentState.retryCount, error);
    // Axios fails merging this configuration to the default configuration because it has an issue
    // with circular structures: https://github.com/mzabriskie/axios/issues/370
    $1e446b88ae152757$var$fixConfig(axiosInstance, config);
    if (!shouldResetTimeout && config.timeout && currentState.lastRequestTime) {
        const lastRequestDuration = Date.now() - currentState.lastRequestTime;
        const timeout = config.timeout - lastRequestDuration - delay;
        if (timeout <= 0) return Promise.reject(error);
        config.timeout = timeout;
    }
    config.transformRequest = [
        (data)=>data
    ];
    await onRetry(currentState.retryCount, error, config);
    if (config.signal?.aborted) return Promise.resolve(axiosInstance(config));
    return new Promise((resolve)=>{
        const abortListener = ()=>{
            clearTimeout(timeout);
            resolve(axiosInstance(config));
        };
        const timeout = setTimeout(()=>{
            resolve(axiosInstance(config));
            if (config.signal?.removeEventListener) config.signal.removeEventListener("abort", abortListener);
        }, delay);
        if (config.signal?.addEventListener) config.signal.addEventListener("abort", abortListener, {
            once: true
        });
    });
}
async function $1e446b88ae152757$var$handleMaxRetryTimesExceeded(currentState, error) {
    if (currentState.retryCount >= currentState.retries) await currentState.onMaxRetryTimesExceeded(error, currentState.retryCount);
}
const $1e446b88ae152757$var$axiosRetry = (axiosInstance, defaultOptions)=>{
    const requestInterceptorId = axiosInstance.interceptors.request.use((config)=>{
        $1e446b88ae152757$var$setCurrentState(config, defaultOptions);
        if (config[$1e446b88ae152757$export$76a88f7de6507443]?.validateResponse) // by setting this, all HTTP responses will be go through the error interceptor first
        config.validateStatus = ()=>false;
        return config;
    });
    const responseInterceptorId = axiosInstance.interceptors.response.use(null, async (error)=>{
        const { config: config  } = error;
        // If we have no information to retry the request
        if (!config) return Promise.reject(error);
        const currentState = $1e446b88ae152757$var$setCurrentState(config, defaultOptions);
        if (error.response && currentState.validateResponse?.(error.response)) // no issue with response
        return error.response;
        if (await $1e446b88ae152757$var$shouldRetry(currentState, error)) return $1e446b88ae152757$var$handleRetry(axiosInstance, currentState, error, config);
        await $1e446b88ae152757$var$handleMaxRetryTimesExceeded(currentState, error);
        return Promise.reject(error);
    });
    return {
        requestInterceptorId: requestInterceptorId,
        responseInterceptorId: responseInterceptorId
    };
};
// Compatibility with CommonJS
$1e446b88ae152757$var$axiosRetry.isNetworkError = $1e446b88ae152757$export$476aa014e2fd89d5;
$1e446b88ae152757$var$axiosRetry.isSafeRequestError = $1e446b88ae152757$export$693cf906fd8817e5;
$1e446b88ae152757$var$axiosRetry.isIdempotentRequestError = $1e446b88ae152757$export$d26799ad4978234d;
$1e446b88ae152757$var$axiosRetry.isNetworkOrIdempotentRequestError = $1e446b88ae152757$export$606bf0a2b170eb2;
$1e446b88ae152757$var$axiosRetry.exponentialDelay = $1e446b88ae152757$export$ce2bf54576c66713;
$1e446b88ae152757$var$axiosRetry.isRetryableError = $1e446b88ae152757$export$5f1dc21fa925930b;
var $1e446b88ae152757$export$2e2bcd8739ae039 = $1e446b88ae152757$var$axiosRetry;


const $0088095d23aef55b$var$denyList = new Set([
    "ENOTFOUND",
    "ENETUNREACH",
    // SSL errors from https://github.com/nodejs/node/blob/fc8e3e2cdc521978351de257030db0076d79e0ab/src/crypto/crypto_common.cc#L301-L328
    "UNABLE_TO_GET_ISSUER_CERT",
    "UNABLE_TO_GET_CRL",
    "UNABLE_TO_DECRYPT_CERT_SIGNATURE",
    "UNABLE_TO_DECRYPT_CRL_SIGNATURE",
    "UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY",
    "CERT_SIGNATURE_FAILURE",
    "CRL_SIGNATURE_FAILURE",
    "CERT_NOT_YET_VALID",
    "CERT_HAS_EXPIRED",
    "CRL_NOT_YET_VALID",
    "CRL_HAS_EXPIRED",
    "ERROR_IN_CERT_NOT_BEFORE_FIELD",
    "ERROR_IN_CERT_NOT_AFTER_FIELD",
    "ERROR_IN_CRL_LAST_UPDATE_FIELD",
    "ERROR_IN_CRL_NEXT_UPDATE_FIELD",
    "OUT_OF_MEM",
    "DEPTH_ZERO_SELF_SIGNED_CERT",
    "SELF_SIGNED_CERT_IN_CHAIN",
    "UNABLE_TO_GET_ISSUER_CERT_LOCALLY",
    "UNABLE_TO_VERIFY_LEAF_SIGNATURE",
    "CERT_CHAIN_TOO_LONG",
    "CERT_REVOKED",
    "INVALID_CA",
    "PATH_LENGTH_EXCEEDED",
    "INVALID_PURPOSE",
    "CERT_UNTRUSTED",
    "CERT_REJECTED",
    "HOSTNAME_MISMATCH"
]);
function $0088095d23aef55b$export$2e2bcd8739ae039(error) {
    return !$0088095d23aef55b$var$denyList.has(error && error.code);
}


function $64fb0c91ac855ea6$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $64fb0c91ac855ea6$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $64fb0c91ac855ea6$var$$56a3d902aefbaef7$exports = {};
var $64fb0c91ac855ea6$var$$f48b1fd42b475868$exports = {};
$64fb0c91ac855ea6$var$$parcel$export($64fb0c91ac855ea6$var$$f48b1fd42b475868$exports, "initializeClient", ()=>$64fb0c91ac855ea6$export$299f86cb8e894b79);
var $64fb0c91ac855ea6$var$$fa7cf714a7f36a56$exports = {};
$64fb0c91ac855ea6$var$$parcel$export($64fb0c91ac855ea6$var$$fa7cf714a7f36a56$exports, "cleanTypenameLink", ()=>$64fb0c91ac855ea6$export$df1777e9719ef5a8);
$64fb0c91ac855ea6$var$$parcel$export($64fb0c91ac855ea6$var$$fa7cf714a7f36a56$exports, "errorLink", ()=>$64fb0c91ac855ea6$export$b5813bf6289ecad);
$64fb0c91ac855ea6$var$$parcel$export($64fb0c91ac855ea6$var$$fa7cf714a7f36a56$exports, "retryLink", ()=>$64fb0c91ac855ea6$export$a51db439a65b48ef);
const $64fb0c91ac855ea6$export$df1777e9719ef5a8 = new (0, $29b9899e03084364$export$2fed3d61f740bc7f)((operation, forward)=>{
    const omitTypename = (key, value)=>key === "__typename" ? undefined : value;
    if (operation.variables && !operation.variables.file) operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename);
    return forward(operation);
});
const $64fb0c91ac855ea6$export$b5813bf6289ecad = (handleError)=>(0, $a11faa240a7c3670$export$2288787135a8f66e)(({ networkError: networkError , graphQLErrors: graphQLErrors  })=>{
        graphQLErrors && console.error("API Error: graphQLErrors", JSON.stringify(graphQLErrors));
        networkError && console.error("API Error: networkError", JSON.stringify(networkError));
        if (!handleError) return;
        if (networkError) {
            const error = networkError;
            if (error?.statusCode === 401) {
                handleError({
                    type: "AUTH_EXPIRED",
                    message: error.message,
                    payload: {
                        redirectUrl: error.result.error.redirectUrl
                    }
                });
                return;
            }
            handleError({
                type: "UNKNOWN_ERROR",
                message: error.message
            });
        }
        if (graphQLErrors) handleError({
            type: "UNKNOWN_ERROR",
            message: graphQLErrors[0].message
        });
    });
const $64fb0c91ac855ea6$export$a51db439a65b48ef = (retryCondition)=>new (0, $ef5434c5fe0a2bce$export$943d544ad120494a)({
        delay: {
            initial: 300,
            max: Infinity,
            jitter: true
        },
        attempts: {
            max: 3,
            retryIf: (error, _operation)=>retryCondition ? retryCondition(error, _operation) : !!error.networkError
        }
    });
const $64fb0c91ac855ea6$var$$f48b1fd42b475868$var$baseAuthOptions = {
    type: (0, $ed43c0849025d39c$exports.AUTH_TYPE).NONE
};
const $64fb0c91ac855ea6$var$$f48b1fd42b475868$var$authMiddleware = (csrfCookieName)=>new (0, $29b9899e03084364$export$2fed3d61f740bc7f)((operation, forward)=>{
        csrfCookieName && operation.setContext(({ headers: headers = {}  })=>({
                headers: {
                    ...headers,
                    "x-csrf": (0, $9efa2e8b576f37ff$exports.get)(csrfCookieName)
                }
            }));
        return forward(operation);
    });
const $64fb0c91ac855ea6$var$$f48b1fd42b475868$var$getEndpointLinks = (endpoints)=>{
    let link = null;
    endpoints.forEach((endpoint)=>{
        if (!endpoint.clientName) throw new Error("clientName is required for all endpoints");
        if (!endpoint.url) throw new Error("url is required for all endpoints");
        if (!link) link = new (0, $4071829aa7d2097e$export$f4bbf1aec241cc1)({
            uri: endpoint.url
        });
        const newLink = new (0, $4071829aa7d2097e$export$f4bbf1aec241cc1)({
            uri: endpoint.url
        });
        link = (0, $29b9899e03084364$export$2fed3d61f740bc7f).split((operation)=>operation.getContext().clientName === endpoint.clientName, newLink, link);
    });
    if (!link) throw new Error("No link was created for the client. Make sure you're passing in endpoints");
    return link;
};
const $64fb0c91ac855ea6$export$299f86cb8e894b79 = ({ endpoints: endpoints , cache: cache , authOptions: authOptions = {} , region: region = "AWS_REGION" , links: links = [] , retryCondition: retryCondition , csrfCookieName: csrfCookieName  })=>{
    // use the primary endpoint as the default for auth link
    const firstEndpointUrl = endpoints[0].url;
    const config = {
        url: firstEndpointUrl,
        region: region,
        auth: {
            ...$64fb0c91ac855ea6$var$$f48b1fd42b475868$var$baseAuthOptions,
            ...authOptions
        }
    };
    const link = (0, $1b68500f0c3c9369$export$ee1b3e54f0441b22)($64fb0c91ac855ea6$var$$f48b1fd42b475868$var$authMiddleware(csrfCookieName), (0, $29b9899e03084364$export$2fed3d61f740bc7f).from([
        (0, $ed43c0849025d39c$exports.createAuthLink)(config),
        ...links,
        $64fb0c91ac855ea6$export$a51db439a65b48ef(retryCondition),
        $64fb0c91ac855ea6$var$$f48b1fd42b475868$var$getEndpointLinks(endpoints)
    ]));
    return new (0, $7209d71eed1c6aae$export$13f5a5f0f1dbab88)({
        link: link,
        cache: cache
    });
};
$64fb0c91ac855ea6$var$$parcel$exportWildcard($64fb0c91ac855ea6$var$$56a3d902aefbaef7$exports, $64fb0c91ac855ea6$var$$f48b1fd42b475868$exports);
$64fb0c91ac855ea6$var$$parcel$exportWildcard($64fb0c91ac855ea6$var$$56a3d902aefbaef7$exports, $64fb0c91ac855ea6$var$$fa7cf714a7f36a56$exports);
var $64fb0c91ac855ea6$var$$ab1d09b35ee4d28e$exports = {};
var $64fb0c91ac855ea6$var$$11e93fc0808db3ba$exports = {};
$64fb0c91ac855ea6$var$$parcel$export($64fb0c91ac855ea6$var$$11e93fc0808db3ba$exports, "SentrySetContext", ()=>$64fb0c91ac855ea6$export$d1f20e18d63133cd);
$64fb0c91ac855ea6$var$$parcel$export($64fb0c91ac855ea6$var$$11e93fc0808db3ba$exports, "SentryInit", ()=>$64fb0c91ac855ea6$export$dc1f4e41fb91cdb3);
$64fb0c91ac855ea6$var$$parcel$export($64fb0c91ac855ea6$var$$11e93fc0808db3ba$exports, "SentryErrorBoundary", ()=>$64fb0c91ac855ea6$export$b69d0d92862de18b);
const $64fb0c91ac855ea6$export$d1f20e18d63133cd = (name, context)=>{
    (0, $6a14300e075c8f51$export$2f04de43fe27971a)(name, context);
};
const $64fb0c91ac855ea6$export$dc1f4e41fb91cdb3 = ({ dsn: dsn , release: release , environment: environment , integrations: integrations = []  })=>{
    const applyIntegrations = [
        new (0, $945fb719f1ce2a3f$export$99d02219d259eb94).BrowserTracing(),
        new (0, $33e1642a8363d690$export$25a43cb5b5c58c08)({
            // array of methods that should be captured
            // defaults to ['log', 'info', 'warn', 'error', 'debug', 'assert']
            levels: [
                "error"
            ]
        })
    ];
    integrations?.includes("Replay") && applyIntegrations.push(new (0, $43b02a39892a2119$export$a35c789ed37ee0f7)({
        maskAllText: true,
        blockAllMedia: true
    }));
    return (0, $8b48b57f3fb14717$export$2cd8252107eb640b)({
        dsn: dsn,
        release: release,
        environment: environment,
        // since v6 of sentry there is an issue withg sessionTracking, so this needs to be disabled until they fix it
        // see https://github.com/getsentry/sentry-javascript/issues/3234
        autoSessionTracking: false,
        integrations: applyIntegrations,
        replaysOnErrorSampleRate: 1.0
    });
};
const $64fb0c91ac855ea6$export$b69d0d92862de18b = (0, $e345b001154c27fb$export$e926676385687eaf);
$64fb0c91ac855ea6$var$$parcel$exportWildcard($64fb0c91ac855ea6$var$$ab1d09b35ee4d28e$exports, $64fb0c91ac855ea6$var$$11e93fc0808db3ba$exports);
var $64fb0c91ac855ea6$var$$81968871348e6881$exports = {};
var $64fb0c91ac855ea6$var$$d178f8e5a140a4cb$exports = {};
$64fb0c91ac855ea6$var$$parcel$export($64fb0c91ac855ea6$var$$d178f8e5a140a4cb$exports, "GtmInit", ()=>$64fb0c91ac855ea6$export$f7901ac6728a4343);
const $64fb0c91ac855ea6$export$f7901ac6728a4343 = (0, $21a020c73fae2a9e$exports.TagManager).init;
$64fb0c91ac855ea6$var$$parcel$exportWildcard($64fb0c91ac855ea6$var$$81968871348e6881$exports, $64fb0c91ac855ea6$var$$d178f8e5a140a4cb$exports);
var $64fb0c91ac855ea6$var$$ce6e67bebedf0d34$exports = {};
var $64fb0c91ac855ea6$var$$d4ce90cc32517378$exports = {};
var $64fb0c91ac855ea6$var$$61e8ef3140005bc0$exports = {};
$64fb0c91ac855ea6$var$$parcel$export($64fb0c91ac855ea6$var$$61e8ef3140005bc0$exports, "Logo", ()=>$64fb0c91ac855ea6$export$e6ff31bff12b7ff4);
const $64fb0c91ac855ea6$export$e6ff31bff12b7ff4 = ({ claim: claim = true , claimText: claimText = "Mietnebenkosten korrekt?" , height: height = 35 , width: width = 122 , title: title = "Nebenkostenabrechnung pr\xfcfen lassen bei MINEKO" , textColor: textColor = "#383839" , iconColor0: iconColor0 = "#6fbc4d" , iconColor1: iconColor1 = "#16a085" , onClick: onClick , className: className  })=>(0, $3DnwL.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 854.7 255",
        version: "1",
        width: width,
        height: height,
        "aria-labelledby": title,
        className: className,
        onClick: onClick,
        children: [
            (0, $3DnwL.jsx)("title", {
                id: title,
                children: title
            }),
            (0, $3DnwL.jsxs)("linearGradient", {
                id: "SVGID_1_",
                x1: "652.1",
                x2: "853.1",
                y1: "84.75",
                y2: "84.75",
                gradientUnits: "userSpaceOnUse",
                children: [
                    (0, $3DnwL.jsx)("stop", {
                        offset: "0",
                        stopColor: iconColor0
                    }),
                    (0, $3DnwL.jsx)("stop", {
                        offset: "1",
                        stopColor: iconColor1
                    })
                ]
            }),
            (0, $3DnwL.jsx)("path", {
                fill: "url(#SVGID_1_)",
                d: "M652.1 78.8h29.4l28.6 33.6L826.3 3h26.8L705.7 166.5z"
            }),
            (0, $3DnwL.jsxs)("g", {
                children: [
                    (0, $3DnwL.jsx)("path", {
                        fill: textColor,
                        d: "M673.5 130.1c-1.1 0-2.1.2-2.9.2-23.4 0-42.1-18.9-42.1-42.1 0-23.4 18.9-42.1 42.1-42.1 23.4 0 42.1 18.9 42.1 42.1 0 3.4-.4 6.5-1.1 9.7l29.5-27.8c-8-31.4-36.6-54.7-70.5-54.7C630.4 15.4 598 48 598 88c0 40.2 32.6 72.6 72.6 72.6 6.9 0 13.7-1.1 20.2-2.7l-17.3-27.8z"
                    }),
                    (0, $3DnwL.jsx)("path", {
                        fill: textColor,
                        d: "M128 160c-2.1-54.7-3.4-91.8-3.4-111.3h-.6c-3.4 14.7-14.5 50.9-33.5 109H65.9c-11.4-40-18.1-64.6-20.4-73.7-2.3-9-4.8-20.8-7.8-35.4h-.4c-.8 27.6-1.7 47.4-2.3 59.6L32.3 160H2.8l8.8-137.9h42.9c10.5 35.1 16.8 57 19.2 65.2 2.1 8.4 4.2 18.3 6.5 29.9h.8c5.1-21.3 9.3-37.3 12.8-48l15.8-47.1h42.1l7.4 137.9H128zM181.7 22.2h31.8V160h-31.8V22.2zM267.8 160h-29.3V22.2h37.7l33.3 56.4c6.3 10.9 13 24.8 20 41.9h.4c-1.7-14.5-2.5-33.5-2.5-56.8V22.2h29.3V160h-33.5c-23.4-40.6-37.3-65-41.9-73.5-4.4-8.4-9.3-18.1-14.1-29.3h-.8c1.1 17.5 1.5 37.5 1.5 60l-.1 42.8zM462.4 76.5V102h-53v32.4h59.1V160h-90.7V22.2h87.8v25.7h-56.2v28.4h53v.2zM487.9 160V22.2h31.4V83c4.2-6.1 8-11.8 11.4-16.4l31.6-44.2h39.4l-47.1 58.5 49.9 79.3h-37l-35.6-59.8-12.2 14.7v45l-31.8-.1z"
                    })
                ]
            }),
            claim && (0, $3DnwL.jsx)("g", {
                children: (0, $3DnwL.jsx)("text", {
                    x: "0",
                    y: "241",
                    style: {
                        letterSpacing: "-1pt"
                    },
                    fontSize: 70,
                    fontFamily: "Meta",
                    fill: textColor,
                    children: claimText
                })
            })
        ]
    });
$64fb0c91ac855ea6$var$$parcel$exportWildcard($64fb0c91ac855ea6$var$$d4ce90cc32517378$exports, $64fb0c91ac855ea6$var$$61e8ef3140005bc0$exports);
$64fb0c91ac855ea6$var$$parcel$exportWildcard($64fb0c91ac855ea6$var$$ce6e67bebedf0d34$exports, $64fb0c91ac855ea6$var$$d4ce90cc32517378$exports);
var $64fb0c91ac855ea6$var$$78d5c0953e7bc63d$exports = {};
var $64fb0c91ac855ea6$var$$84b0b1bc83367e92$exports = {};
$64fb0c91ac855ea6$var$$parcel$export($64fb0c91ac855ea6$var$$84b0b1bc83367e92$exports, "FeatureTrackingContext", ()=>$64fb0c91ac855ea6$export$1d2ebc028bffa5d1);
$64fb0c91ac855ea6$var$$parcel$export($64fb0c91ac855ea6$var$$84b0b1bc83367e92$exports, "useTrackFeature", ()=>$64fb0c91ac855ea6$export$aee829cd601bef67);
const $64fb0c91ac855ea6$export$1d2ebc028bffa5d1 = (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createContext(null);
const $64fb0c91ac855ea6$export$aee829cd601bef67 = ()=>{
    const appName = (0, $fV3WI.useContext)($64fb0c91ac855ea6$export$1d2ebc028bffa5d1);
    const handleTracking = (featureId, eventType, payload, entityId)=>{
        if (!appName) throw new Error("App name is missing, have you wrapped this component inside the FeatureTrackingContext.Provider?");
        try {
            fetch(`/capture-event`, {
                method: "POST",
                body: JSON.stringify({
                    featureId: featureId,
                    appName: appName,
                    timestamp: new Date().toISOString(),
                    eventType: eventType,
                    payload: payload,
                    ...entityId && {
                        entityId: entityId
                    }
                })
            });
        } catch (e) {
            console.error(e);
        }
    };
    return {
        track: handleTracking
    };
};
$64fb0c91ac855ea6$var$$parcel$exportWildcard($64fb0c91ac855ea6$var$$78d5c0953e7bc63d$exports, $64fb0c91ac855ea6$var$$84b0b1bc83367e92$exports);
var $64fb0c91ac855ea6$var$$992b42a5fa09e36f$exports = {};
var $64fb0c91ac855ea6$var$$2b4247042284824d$exports = {};
$64fb0c91ac855ea6$var$$parcel$export($64fb0c91ac855ea6$var$$2b4247042284824d$exports, "retryCondition", ()=>$64fb0c91ac855ea6$export$7bcc93217746b74e);
$64fb0c91ac855ea6$var$$parcel$export($64fb0c91ac855ea6$var$$2b4247042284824d$exports, "Axios", ()=>$64fb0c91ac855ea6$export$1c00760e9e5a4e95);
const $64fb0c91ac855ea6$export$7bcc93217746b74e = (error)=>error.isAxiosError && (0, $0088095d23aef55b$export$2e2bcd8739ae039)(error);
const $64fb0c91ac855ea6$export$1c00760e9e5a4e95 = {
    setRetry: (retries)=>(0, $1e446b88ae152757$export$2e2bcd8739ae039)((0, $1fe178238660350a$export$2e2bcd8739ae039), {
            retryDelay: (0, $1e446b88ae152757$export$2e2bcd8739ae039).exponentialDelay,
            retries: retries ?? 8,
            retryCondition: $64fb0c91ac855ea6$export$7bcc93217746b74e
        })
};
$64fb0c91ac855ea6$var$$parcel$exportWildcard($64fb0c91ac855ea6$var$$992b42a5fa09e36f$exports, $64fb0c91ac855ea6$var$$2b4247042284824d$exports);



var $dYG3T = parcelRequire("dYG3T");

var $fV3WI = parcelRequire("fV3WI");


var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $69iCy = parcelRequire("69iCy");
var $js0sS = parcelRequire("js0sS");
var $auxfn = parcelRequire("auxfn");

var $3IDET = parcelRequire("3IDET");

var $4auXB = parcelRequire("4auXB");
const $68d484dcb54a86c7$var$styled = (0, $4auXB.default)();
var $68d484dcb54a86c7$export$2e2bcd8739ae039 = $68d484dcb54a86c7$var$styled;



var $34rWH = parcelRequire("34rWH");

var $3DnwL = parcelRequire("3DnwL");
const $4be17a32db0a15ce$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "fixed",
    "maxWidth",
    "classes"
];
const $4be17a32db0a15ce$var$defaultTheme = (0, $34rWH.default)();
const $4be17a32db0a15ce$var$defaultCreateStyledComponent = (0, $68d484dcb54a86c7$export$2e2bcd8739ae039)("div", {
    name: "MuiContainer",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $69iCy.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $4be17a32db0a15ce$var$useThemePropsDefault = (inProps)=>(0, $3IDET.default)({
        props: inProps,
        name: "MuiContainer",
        defaultTheme: $4be17a32db0a15ce$var$defaultTheme
    });
const $4be17a32db0a15ce$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $auxfn.default)(componentName, slot);
    };
    const { classes: classes , fixed: fixed , disableGutters: disableGutters , maxWidth: maxWidth  } = ownerState;
    const slots = {
        root: [
            "root",
            maxWidth && `maxWidth${(0, $69iCy.default)(String(maxWidth))}`,
            fixed && "fixed",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $js0sS.default)(slots, getContainerUtilityClass, classes);
};
function $4be17a32db0a15ce$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $4be17a32db0a15ce$var$defaultCreateStyledComponent , useThemeProps: useThemeProps = $4be17a32db0a15ce$var$useThemePropsDefault , componentName: componentName = "MuiContainer"  } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({
            width: "100%",
            marginLeft: "auto",
            boxSizing: "border-box",
            marginRight: "auto",
            display: "block"
        }, !ownerState.disableGutters && {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up("sm")]: {
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3)
            }
        }), ({ theme: theme , ownerState: ownerState  })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({}, ownerState.maxWidth === "xs" && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up("xs")]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: Math.max(theme.breakpoints.values.xs, 444)
            }
        }, ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
        ownerState.maxWidth !== "xs" && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up(ownerState.maxWidth)]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
            }
        }));
    const Container = /*#__PURE__*/ $fV3WI.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className , component: component = "div" , disableGutters: disableGutters = false , fixed: fixed = false , maxWidth: maxWidth = "lg"  } = props, other = (0, $64S8Y.default)(props, $4be17a32db0a15ce$var$_excluded);
        const ownerState = (0, $j5tUA.default)({}, props, {
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        });
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $4be17a32db0a15ce$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $3DnwL.jsx)(ContainerRoot, (0, $j5tUA.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $h0s6D.default)(classes.root, className),
            ref: ref
        }, other)));
    });
    return Container;
}



var $ZXS89 = parcelRequire("ZXS89");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");
const $826570d6abfe5872$var$Container = (0, $4be17a32db0a15ce$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $aF4Kv.default)("div", {
        name: "MuiContainer",
        slot: "Root",
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState  } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $ZXS89.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $05gnM.default)({
            props: inProps,
            name: "MuiContainer"
        })
});
var $826570d6abfe5872$export$2e2bcd8739ae039 = $826570d6abfe5872$var$Container;



var $dYG3T = parcelRequire("dYG3T");

var $fV3WI = parcelRequire("fV3WI");

var $hhXI3 = parcelRequire("hhXI3");
var $85ab07aeb606538c$exports = {};
"use strict";
var $f277321f3a7f4dd2$exports = {};
function $f277321f3a7f4dd2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$f277321f3a7f4dd2$exports = $f277321f3a7f4dd2$var$_interopRequireDefault, $f277321f3a7f4dd2$exports.__esModule = true, $f277321f3a7f4dd2$exports["default"] = $f277321f3a7f4dd2$exports;


Object.defineProperty($85ab07aeb606538c$exports, "__esModule", {
    value: true
});
$85ab07aeb606538c$exports.default = void 0;

var $85ab07aeb606538c$var$_createSvgIcon = $f277321f3a7f4dd2$exports((parcelRequire("d4TrX")));

var $3DnwL = parcelRequire("3DnwL");
var $85ab07aeb606538c$var$_default = (0, $85ab07aeb606538c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $3DnwL.jsx)("path", {
    d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
}), "KeyboardArrowDown");
$85ab07aeb606538c$exports.default = $85ab07aeb606538c$var$_default;


var $49385efa3618cacc$exports = {};
"use strict";

Object.defineProperty($49385efa3618cacc$exports, "__esModule", {
    value: true
});
$49385efa3618cacc$exports.default = void 0;

var $49385efa3618cacc$var$_createSvgIcon = $f277321f3a7f4dd2$exports((parcelRequire("d4TrX")));

var $3DnwL = parcelRequire("3DnwL");
var $49385efa3618cacc$var$_default = (0, $49385efa3618cacc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $3DnwL.jsx)("path", {
    d: "M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"
}), "KeyboardArrowUp");
$49385efa3618cacc$exports.default = $49385efa3618cacc$var$_default;



var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");

var $h0s6D = parcelRequire("h0s6D");


var $bzLsd = parcelRequire("bzLsd");


var $js0sS = parcelRequire("js0sS");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");

var $jvsL9 = parcelRequire("jvsL9");

var $8Ewcq = parcelRequire("8Ewcq");

var $4uBZf = parcelRequire("4uBZf");

var $czyq6 = parcelRequire("czyq6");

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $e1deb31b48f656cc$export$5162da8f798e0959(slot) {
    return (0, $auxfn.default)("MuiCollapse", slot);
}
const $e1deb31b48f656cc$var$collapseClasses = (0, $dxVxC.default)("MuiCollapse", [
    "root",
    "horizontal",
    "vertical",
    "entered",
    "hidden",
    "wrapper",
    "wrapperInner"
]);
var $e1deb31b48f656cc$export$2e2bcd8739ae039 = $e1deb31b48f656cc$var$collapseClasses;



var $3DnwL = parcelRequire("3DnwL");
const $588b467cc1332c88$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $588b467cc1332c88$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            `${orientation}`
        ],
        entered: [
            "entered"
        ],
        hidden: [
            "hidden"
        ],
        wrapper: [
            "wrapper",
            `${orientation}`
        ],
        wrapperInner: [
            "wrapperInner",
            `${orientation}`
        ]
    };
    return (0, $js0sS.default)(slots, (0, $e1deb31b48f656cc$export$5162da8f798e0959), classes);
};
const $588b467cc1332c88$var$CollapseRoot = (0, $aF4Kv.default)("div", {
    name: "MuiCollapse",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === "entered" && styles.entered,
            ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && styles.hidden
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({
        height: 0,
        overflow: "hidden",
        transition: theme.transitions.create("height")
    }, ownerState.orientation === "horizontal" && {
        height: "auto",
        width: 0,
        transition: theme.transitions.create("width")
    }, ownerState.state === "entered" && (0, $j5tUA.default)({
        height: "auto",
        overflow: "visible"
    }, ownerState.orientation === "horizontal" && {
        width: "auto"
    }), ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && {
        visibility: "hidden"
    }));
const $588b467cc1332c88$var$CollapseWrapper = (0, $aF4Kv.default)("div", {
    name: "MuiCollapse",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState  })=>(0, $j5tUA.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: "flex",
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
const $588b467cc1332c88$var$CollapseWrapperInner = (0, $aF4Kv.default)("div", {
    name: "MuiCollapse",
    slot: "WrapperInner",
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState  })=>(0, $j5tUA.default)({
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $588b467cc1332c88$var$Collapse = /*#__PURE__*/ $fV3WI.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiCollapse"
    });
    const { addEndListener: addEndListener , children: children , className: className , collapsedSize: collapsedSizeProp = "0px" , component: component , easing: easing , in: inProp , onEnter: onEnter , onEntered: onEntered , onEntering: onEntering , onExit: onExit , onExited: onExited , onExiting: onExiting , orientation: orientation = "vertical" , style: style , timeout: timeout = (0, $jvsL9.duration).standard , TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $bzLsd.default)  } = props, other = (0, $64S8Y.default)(props, $588b467cc1332c88$var$_excluded);
    const ownerState = (0, $j5tUA.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $588b467cc1332c88$var$useUtilityClasses(ownerState);
    const theme = (0, $4uBZf.default)();
    const timer = $fV3WI.useRef();
    const wrapperRef = $fV3WI.useRef(null);
    const autoTransitionDuration = $fV3WI.useRef();
    const collapsedSize = typeof collapsedSizeProp === "number" ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === "horizontal";
    const size = isHorizontal ? "width" : "height";
    $fV3WI.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    const nodeRef = $fV3WI.useRef(null);
    const handleRef = (0, $czyq6.default)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? "clientWidth" : "clientHeight"] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = "absolute";
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = "";
        const { duration: transitionDuration , easing: transitionTimingFunction  } = (0, $8Ewcq.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        if (timeout === "auto") {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = "auto";
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration , easing: transitionTimingFunction  } = (0, $8Ewcq.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        if (timeout === "auto") {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.current = setTimeout(next, autoTransitionDuration.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $3DnwL.jsx)(TransitionComponent, (0, $j5tUA.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $3DnwL.jsx)($588b467cc1332c88$var$CollapseRoot, (0, $j5tUA.default)({
                as: component,
                className: (0, $h0s6D.default)(classes.root, className, {
                    "entered": classes.entered,
                    "exited": !inProp && collapsedSize === "0px" && classes.hidden
                }[state]),
                style: (0, $j5tUA.default)({
                    [isHorizontal ? "minWidth" : "minHeight"]: collapsedSize
                }, style),
                ownerState: (0, $j5tUA.default)({}, ownerState, {
                    state: state
                }),
                ref: handleRef
            }, childProps, {
                children: /*#__PURE__*/ (0, $3DnwL.jsx)($588b467cc1332c88$var$CollapseWrapper, {
                    ownerState: (0, $j5tUA.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $3DnwL.jsx)($588b467cc1332c88$var$CollapseWrapperInner, {
                        ownerState: (0, $j5tUA.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$588b467cc1332c88$var$Collapse.muiSupportAuto = true;
var $588b467cc1332c88$export$2e2bcd8739ae039 = $588b467cc1332c88$var$Collapse;



var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");


var $js0sS = parcelRequire("js0sS");

var $74s0b = parcelRequire("74s0b");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");

var $gScpF = parcelRequire("gScpF");

var $ZXS89 = parcelRequire("ZXS89");

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $098270b17a99b227$export$5e8702d71474f093(slot) {
    return (0, $auxfn.default)("MuiIconButton", slot);
}
const $098270b17a99b227$var$iconButtonClasses = (0, $dxVxC.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $098270b17a99b227$export$2e2bcd8739ae039 = $098270b17a99b227$var$iconButtonClasses;



var $3DnwL = parcelRequire("3DnwL");
const $96e62cba67d8fc25$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $96e62cba67d8fc25$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disabled: disabled , color: color , edge: edge , size: size  } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $ZXS89.default)(color)}`,
            edge && `edge${(0, $ZXS89.default)(edge)}`,
            `size${(0, $ZXS89.default)(size)}`
        ]
    };
    return (0, $js0sS.default)(slots, (0, $098270b17a99b227$export$5e8702d71474f093), classes);
};
const $96e62cba67d8fc25$var$IconButtonRoot = (0, $aF4Kv.default)((0, $gScpF.default), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $ZXS89.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $ZXS89.default)(ownerState.edge)}`],
            styles[`size${(0, $ZXS89.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $74s0b.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme , ownerState: ownerState  })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $j5tUA.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $j5tUA.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $j5tUA.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $74s0b.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $098270b17a99b227$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $96e62cba67d8fc25$var$IconButton = /*#__PURE__*/ $fV3WI.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false , children: children , className: className , color: color = "default" , disabled: disabled = false , disableFocusRipple: disableFocusRipple = false , size: size = "medium"  } = props, other = (0, $64S8Y.default)(props, $96e62cba67d8fc25$var$_excluded);
    const ownerState = (0, $j5tUA.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $96e62cba67d8fc25$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3DnwL.jsx)($96e62cba67d8fc25$var$IconButtonRoot, (0, $j5tUA.default)({
        className: (0, $h0s6D.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children
    }));
});
var $96e62cba67d8fc25$export$2e2bcd8739ae039 = $96e62cba67d8fc25$var$IconButton;


const $9598405fe90d409a$var$CollapseIcon = ({ open: open  })=>(0, $dYG3T.jsx)((0, $96e62cba67d8fc25$export$2e2bcd8739ae039), {
        role: "button",
        size: "small",
        children: open ? (0, $dYG3T.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($49385efa3618cacc$exports))), {}) : (0, $dYG3T.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($85ab07aeb606538c$exports))), {})
    });
const $9598405fe90d409a$var$collapseHeaderStyles = (0, $hhXI3.css)`
  padding: 20px;
  display: flex;
  cursor: pointer;
  width: 100%;
  justify-content: space-between;
  align-content: center;
  align-items: center;
`;
const $9598405fe90d409a$var$CollapseHeader = ({ onChange: onChange , open: open , children: children  })=>(0, $dYG3T.jsxs)("div", {
        css: $9598405fe90d409a$var$collapseHeaderStyles,
        onClick: ()=>onChange(),
        children: [
            children,
            (0, $dYG3T.jsx)($9598405fe90d409a$var$CollapseIcon, {
                open: open
            })
        ]
    });
const $9598405fe90d409a$var$collapseStyles = (0, $hhXI3.css)`
  padding: 0 20px;
`;
const $9598405fe90d409a$export$78768a9af065a7b = ({ header: header , children: children , defaultCollapsed: defaultCollapsed = false , ...rest })=>{
    const [open, setOpen] = (0, $fV3WI.useState)(!defaultCollapsed);
    const handleChange = ()=>{
        setOpen(!open);
    };
    return (0, $dYG3T.jsxs)("div", {
        ...rest,
        children: [
            (0, $dYG3T.jsx)($9598405fe90d409a$var$CollapseHeader, {
                onChange: handleChange,
                open: open,
                children: header
            }),
            (0, $dYG3T.jsx)((0, $588b467cc1332c88$export$2e2bcd8739ae039), {
                in: open,
                timeout: "auto",
                css: $9598405fe90d409a$var$collapseStyles,
                children: children
            })
        ]
    });
};





var $dYG3T = parcelRequire("dYG3T");

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $js0sS = parcelRequire("js0sS");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");

var $ZXS89 = parcelRequire("ZXS89");

var $eKfJS = parcelRequire("eKfJS");

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $c5f4b4eb2efb084e$export$47a2da616e55e8e9(slot) {
    return (0, $auxfn.default)("MuiAppBar", slot);
}
const $c5f4b4eb2efb084e$var$appBarClasses = (0, $dxVxC.default)("MuiAppBar", [
    "root",
    "positionFixed",
    "positionAbsolute",
    "positionSticky",
    "positionStatic",
    "positionRelative",
    "colorDefault",
    "colorPrimary",
    "colorSecondary",
    "colorInherit",
    "colorTransparent"
]);
var $c5f4b4eb2efb084e$export$2e2bcd8739ae039 = $c5f4b4eb2efb084e$var$appBarClasses;



var $3DnwL = parcelRequire("3DnwL");
const $78443e830542c7c8$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $78443e830542c7c8$var$useUtilityClasses = (ownerState)=>{
    const { color: color , position: position , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $ZXS89.default)(color)}`,
            `position${(0, $ZXS89.default)(position)}`
        ]
    };
    return (0, $js0sS.default)(slots, (0, $c5f4b4eb2efb084e$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $78443e830542c7c8$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(")", "")}, ${var2})` : var2;
const $78443e830542c7c8$var$AppBarRoot = (0, $aF4Kv.default)((0, $eKfJS.default), {
    name: "MuiAppBar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            styles[`position${(0, $ZXS89.default)(ownerState.position)}`],
            styles[`color${(0, $ZXS89.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    const backgroundColorDefault = theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $j5tUA.default)({
        display: "flex",
        flexDirection: "column",
        width: "100%",
        boxSizing: "border-box",
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === "fixed" && {
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0,
        "@media print": {
            // Prevent the app bar to be visible on each printed page.
            position: "absolute"
        }
    }, ownerState.position === "absolute" && {
        position: "absolute",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "sticky" && {
        // ⚠️ sticky is not supported by IE11.
        position: "sticky",
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: "auto",
        right: 0
    }, ownerState.position === "static" && {
        position: "static"
    }, ownerState.position === "relative" && {
        position: "relative"
    }, !theme.vars && (0, $j5tUA.default)({}, ownerState.color === "default" && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== "default" && ownerState.color !== "inherit" && ownerState.color !== "transparent" && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, theme.palette.mode === "dark" && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === "transparent" && (0, $j5tUA.default)({
        backgroundColor: "transparent",
        color: "inherit"
    }, theme.palette.mode === "dark" && {
        backgroundImage: "none"
    })), theme.vars && (0, $j5tUA.default)({}, ownerState.color === "default" && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $78443e830542c7c8$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $78443e830542c7c8$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        "--AppBar-background": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $78443e830542c7c8$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        "--AppBar-color": ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $78443e830542c7c8$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, {
        backgroundColor: "var(--AppBar-background)",
        color: ownerState.color === "inherit" ? "inherit" : "var(--AppBar-color)"
    }, ownerState.color === "transparent" && {
        backgroundImage: "none",
        backgroundColor: "transparent",
        color: "inherit"
    }));
});
const $78443e830542c7c8$var$AppBar = /*#__PURE__*/ $fV3WI.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiAppBar"
    });
    const { className: className , color: color = "primary" , enableColorOnDark: enableColorOnDark = false , position: position = "fixed"  } = props, other = (0, $64S8Y.default)(props, $78443e830542c7c8$var$_excluded);
    const ownerState = (0, $j5tUA.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $78443e830542c7c8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3DnwL.jsx)($78443e830542c7c8$var$AppBarRoot, (0, $j5tUA.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $h0s6D.default)(classes.root, className, position === "fixed" && "mui-fixed"),
        ref: ref
    }, other));
});
var $78443e830542c7c8$export$2e2bcd8739ae039 = $78443e830542c7c8$var$AppBar;


var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $js0sS = parcelRequire("js0sS");

var $05gnM = parcelRequire("05gnM");

var $aF4Kv = parcelRequire("aF4Kv");

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $318a2fca05fea484$export$b12cb262231eef32(slot) {
    return (0, $auxfn.default)("MuiToolbar", slot);
}
const $318a2fca05fea484$var$toolbarClasses = (0, $dxVxC.default)("MuiToolbar", [
    "root",
    "gutters",
    "regular",
    "dense"
]);
var $318a2fca05fea484$export$2e2bcd8739ae039 = $318a2fca05fea484$var$toolbarClasses;



var $3DnwL = parcelRequire("3DnwL");
const $3757bf86ac46d7d5$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $3757bf86ac46d7d5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disableGutters: disableGutters , variant: variant  } = ownerState;
    const slots = {
        root: [
            "root",
            !disableGutters && "gutters",
            variant
        ]
    };
    return (0, $js0sS.default)(slots, (0, $318a2fca05fea484$export$b12cb262231eef32), classes);
};
const $3757bf86ac46d7d5$var$ToolbarRoot = (0, $aF4Kv.default)("div", {
    name: "MuiToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({
        position: "relative",
        display: "flex",
        alignItems: "center"
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === "dense" && {
        minHeight: 48
    }), ({ theme: theme , ownerState: ownerState  })=>ownerState.variant === "regular" && theme.mixins.toolbar);
const $3757bf86ac46d7d5$var$Toolbar = /*#__PURE__*/ $fV3WI.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiToolbar"
    });
    const { className: className , component: component = "div" , disableGutters: disableGutters = false , variant: variant = "regular"  } = props, other = (0, $64S8Y.default)(props, $3757bf86ac46d7d5$var$_excluded);
    const ownerState = (0, $j5tUA.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $3757bf86ac46d7d5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3DnwL.jsx)($3757bf86ac46d7d5$var$ToolbarRoot, (0, $j5tUA.default)({
        as: component,
        className: (0, $h0s6D.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $3757bf86ac46d7d5$export$2e2bcd8739ae039 = $3757bf86ac46d7d5$var$Toolbar;


var $4uBZf = parcelRequire("4uBZf");

var $hhXI3 = parcelRequire("hhXI3");
const $fc47552009a143b3$var$toolbarStyles = (theme)=>(0, $hhXI3.css)`
  box-sizing: border-box;
  ${theme.breakpoints.down("md")} {
    padding-left: 13px;
    padding-right: 13px;
  }
`;
const $fc47552009a143b3$export$8b251419efc915eb = ({ children: children , toolbarProps: toolbarProps , ...rest })=>{
    const theme = (0, $4uBZf.default)();
    return (0, $dYG3T.jsx)((0, $78443e830542c7c8$export$2e2bcd8739ae039), {
        position: "sticky",
        color: "inherit",
        variant: "outlined",
        elevation: 0,
        ...rest,
        children: (0, $dYG3T.jsx)((0, $3757bf86ac46d7d5$export$2e2bcd8739ae039), {
            css: $fc47552009a143b3$var$toolbarStyles(theme),
            ...toolbarProps,
            children: children
        })
    });
};





var $dYG3T = parcelRequire("dYG3T");

var $8qu0S = parcelRequire("8qu0S");

var $7wjDG = parcelRequire("7wjDG");

var $hhXI3 = parcelRequire("hhXI3");

var $4uBZf = parcelRequire("4uBZf");
const $fc2ca009a1ed8848$var$backdropStyles = (theme)=>(0, $hhXI3.css)`
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: ${theme.zIndex.drawer + 1};
`;
const $fc2ca009a1ed8848$export$3fb99980b01d36b1 = ({ loading: loading , children: children , ...rest })=>{
    const theme = (0, $4uBZf.default)();
    return (0, $dYG3T.jsxs)((0, $8qu0S.default), {
        open: loading,
        css: $fc2ca009a1ed8848$var$backdropStyles(theme),
        ...rest,
        children: [
            (0, $dYG3T.jsx)((0, $7wjDG.default), {
                "aria-busy": loading,
                role: "progressbar",
                color: "primary"
            }),
            children
        ]
    });
};





var $dYG3T = parcelRequire("dYG3T");

var $fV3WI = parcelRequire("fV3WI");

var $gVgA5 = parcelRequire("gVgA5");

var $45fbe38345ef42c3$export$db0345794bfc14ed = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    [
        "aac",
        "audio/aac"
    ],
    [
        "abw",
        "application/x-abiword"
    ],
    [
        "arc",
        "application/x-freearc"
    ],
    [
        "avif",
        "image/avif"
    ],
    [
        "avi",
        "video/x-msvideo"
    ],
    [
        "azw",
        "application/vnd.amazon.ebook"
    ],
    [
        "bin",
        "application/octet-stream"
    ],
    [
        "bmp",
        "image/bmp"
    ],
    [
        "bz",
        "application/x-bzip"
    ],
    [
        "bz2",
        "application/x-bzip2"
    ],
    [
        "cda",
        "application/x-cdf"
    ],
    [
        "csh",
        "application/x-csh"
    ],
    [
        "css",
        "text/css"
    ],
    [
        "csv",
        "text/csv"
    ],
    [
        "doc",
        "application/msword"
    ],
    [
        "docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ],
    [
        "eot",
        "application/vnd.ms-fontobject"
    ],
    [
        "epub",
        "application/epub+zip"
    ],
    [
        "gz",
        "application/gzip"
    ],
    [
        "gif",
        "image/gif"
    ],
    [
        "heic",
        "image/heic"
    ],
    [
        "heif",
        "image/heif"
    ],
    [
        "htm",
        "text/html"
    ],
    [
        "html",
        "text/html"
    ],
    [
        "ico",
        "image/vnd.microsoft.icon"
    ],
    [
        "ics",
        "text/calendar"
    ],
    [
        "jar",
        "application/java-archive"
    ],
    [
        "jpeg",
        "image/jpeg"
    ],
    [
        "jpg",
        "image/jpeg"
    ],
    [
        "js",
        "text/javascript"
    ],
    [
        "json",
        "application/json"
    ],
    [
        "jsonld",
        "application/ld+json"
    ],
    [
        "mid",
        "audio/midi"
    ],
    [
        "midi",
        "audio/midi"
    ],
    [
        "mjs",
        "text/javascript"
    ],
    [
        "mp3",
        "audio/mpeg"
    ],
    [
        "mp4",
        "video/mp4"
    ],
    [
        "mpeg",
        "video/mpeg"
    ],
    [
        "mpkg",
        "application/vnd.apple.installer+xml"
    ],
    [
        "odp",
        "application/vnd.oasis.opendocument.presentation"
    ],
    [
        "ods",
        "application/vnd.oasis.opendocument.spreadsheet"
    ],
    [
        "odt",
        "application/vnd.oasis.opendocument.text"
    ],
    [
        "oga",
        "audio/ogg"
    ],
    [
        "ogv",
        "video/ogg"
    ],
    [
        "ogx",
        "application/ogg"
    ],
    [
        "opus",
        "audio/opus"
    ],
    [
        "otf",
        "font/otf"
    ],
    [
        "png",
        "image/png"
    ],
    [
        "pdf",
        "application/pdf"
    ],
    [
        "php",
        "application/x-httpd-php"
    ],
    [
        "ppt",
        "application/vnd.ms-powerpoint"
    ],
    [
        "pptx",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    ],
    [
        "rar",
        "application/vnd.rar"
    ],
    [
        "rtf",
        "application/rtf"
    ],
    [
        "sh",
        "application/x-sh"
    ],
    [
        "svg",
        "image/svg+xml"
    ],
    [
        "swf",
        "application/x-shockwave-flash"
    ],
    [
        "tar",
        "application/x-tar"
    ],
    [
        "tif",
        "image/tiff"
    ],
    [
        "tiff",
        "image/tiff"
    ],
    [
        "ts",
        "video/mp2t"
    ],
    [
        "ttf",
        "font/ttf"
    ],
    [
        "txt",
        "text/plain"
    ],
    [
        "vsd",
        "application/vnd.visio"
    ],
    [
        "wav",
        "audio/wav"
    ],
    [
        "weba",
        "audio/webm"
    ],
    [
        "webm",
        "video/webm"
    ],
    [
        "webp",
        "image/webp"
    ],
    [
        "woff",
        "font/woff"
    ],
    [
        "woff2",
        "font/woff2"
    ],
    [
        "xhtml",
        "application/xhtml+xml"
    ],
    [
        "xls",
        "application/vnd.ms-excel"
    ],
    [
        "xlsx",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ],
    [
        "xml",
        "application/xml"
    ],
    [
        "xul",
        "application/vnd.mozilla.xul+xml"
    ],
    [
        "zip",
        "application/zip"
    ],
    [
        "7z",
        "application/x-7z-compressed"
    ],
    // Others
    [
        "mkv",
        "video/x-matroska"
    ],
    [
        "mov",
        "video/quicktime"
    ],
    [
        "msg",
        "application/vnd.ms-outlook"
    ]
]);
function $45fbe38345ef42c3$export$8cc09085015f0dc7(file, path) {
    var f = $45fbe38345ef42c3$var$withMimeType(file);
    if (typeof f.path !== "string") {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, "path", {
            value: typeof path === "string" ? path : typeof webkitRelativePath === "string" && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function $45fbe38345ef42c3$var$withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf(".") !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split(".").pop().toLowerCase();
        var type = $45fbe38345ef42c3$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, "type", {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}


var $1a3bd4adf018f8a8$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    ".DS_Store",
    "Thumbs.db" // Windows
];
function $1a3bd4adf018f8a8$export$a36e16046ae8f1bb(evt) {
    return (0, $1aaf9c65fb7afb7d$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $1aaf9c65fb7afb7d$export$67ebef60e6f28a6)(this, function(_a) {
            if ($1a3bd4adf018f8a8$var$isObject(evt) && $1a3bd4adf018f8a8$var$isDataTransfer(evt.dataTransfer)) return [
                2 /*return*/ ,
                $1a3bd4adf018f8a8$var$getDataTransferFiles(evt.dataTransfer, evt.type)
            ];
            else if ($1a3bd4adf018f8a8$var$isChangeEvt(evt)) return [
                2 /*return*/ ,
                $1a3bd4adf018f8a8$var$getInputFiles(evt)
            ];
            else if (Array.isArray(evt) && evt.every(function(item) {
                return "getFile" in item && typeof item.getFile === "function";
            })) return [
                2 /*return*/ ,
                $1a3bd4adf018f8a8$var$getFsHandleFiles(evt)
            ];
            return [
                2 /*return*/ ,
                []
            ];
        });
    });
}
function $1a3bd4adf018f8a8$var$isDataTransfer(value) {
    return $1a3bd4adf018f8a8$var$isObject(value);
}
function $1a3bd4adf018f8a8$var$isChangeEvt(value) {
    return $1a3bd4adf018f8a8$var$isObject(value) && $1a3bd4adf018f8a8$var$isObject(value.target);
}
function $1a3bd4adf018f8a8$var$isObject(v) {
    return typeof v === "object" && v !== null;
}
function $1a3bd4adf018f8a8$var$getInputFiles(evt) {
    return $1a3bd4adf018f8a8$var$fromList(evt.target.files).map(function(file) {
        return (0, $45fbe38345ef42c3$export$8cc09085015f0dc7)(file);
    });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function $1a3bd4adf018f8a8$var$getFsHandleFiles(handles) {
    return (0, $1aaf9c65fb7afb7d$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var files;
        return (0, $1aaf9c65fb7afb7d$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        Promise.all(handles.map(function(h) {
                            return h.getFile();
                        }))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        files.map(function(file) {
                            return (0, $45fbe38345ef42c3$export$8cc09085015f0dc7)(file);
                        })
                    ];
            }
        });
    });
}
function $1a3bd4adf018f8a8$var$getDataTransferFiles(dt, type) {
    return (0, $1aaf9c65fb7afb7d$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var items, files;
        return (0, $1aaf9c65fb7afb7d$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!dt.items) return [
                        3 /*break*/ ,
                        2
                    ];
                    items = $1a3bd4adf018f8a8$var$fromList(dt.items).filter(function(item) {
                        return item.kind === "file";
                    });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== "drop") return [
                        2 /*return*/ ,
                        items
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(items.map($1a3bd4adf018f8a8$var$toFilePromises))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        $1a3bd4adf018f8a8$var$noIgnoredFiles($1a3bd4adf018f8a8$var$flatten(files))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        $1a3bd4adf018f8a8$var$noIgnoredFiles($1a3bd4adf018f8a8$var$fromList(dt.files).map(function(file) {
                            return (0, $45fbe38345ef42c3$export$8cc09085015f0dc7)(file);
                        }))
                    ];
            }
        });
    });
}
function $1a3bd4adf018f8a8$var$noIgnoredFiles(files) {
    return files.filter(function(file) {
        return $1a3bd4adf018f8a8$var$FILES_TO_IGNORE.indexOf(file.name) === -1;
    });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $1a3bd4adf018f8a8$var$fromList(items) {
    if (items === null) return [];
    var files = [];
    // tslint:disable: prefer-for-of
    for(var i = 0; i < items.length; i++){
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $1a3bd4adf018f8a8$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== "function") return $1a3bd4adf018f8a8$var$fromDataTransferItem(item);
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $1a3bd4adf018f8a8$var$fromDirEntry(entry);
    return $1a3bd4adf018f8a8$var$fromDataTransferItem(item);
}
function $1a3bd4adf018f8a8$var$flatten(items) {
    return items.reduce(function(acc, files) {
        return (0, $1aaf9c65fb7afb7d$export$1216008129fb82ed)((0, $1aaf9c65fb7afb7d$export$1216008129fb82ed)([], (0, $1aaf9c65fb7afb7d$export$8d051b38c9118094)(acc), false), (0, $1aaf9c65fb7afb7d$export$8d051b38c9118094)(Array.isArray(files) ? $1a3bd4adf018f8a8$var$flatten(files) : [
            files
        ]), false);
    }, []);
}
function $1a3bd4adf018f8a8$var$fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) return Promise.reject("".concat(item, " is not a File"));
    var fwp = (0, $45fbe38345ef42c3$export$8cc09085015f0dc7)(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $1a3bd4adf018f8a8$var$fromEntry(entry) {
    return (0, $1aaf9c65fb7afb7d$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $1aaf9c65fb7afb7d$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                entry.isDirectory ? $1a3bd4adf018f8a8$var$fromDirEntry(entry) : $1a3bd4adf018f8a8$var$fromFileEntry(entry)
            ];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $1a3bd4adf018f8a8$var$fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function(resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function(batch) {
                return (0, $1aaf9c65fb7afb7d$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                    var files, err_1, items;
                    return (0, $1aaf9c65fb7afb7d$export$67ebef60e6f28a6)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!batch.length) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(entries)
                                ];
                            case 2:
                                files = _a.sent();
                                resolve(files);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                reject(err_1);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                items = Promise.all(batch.map($1a3bd4adf018f8a8$var$fromEntry));
                                entries.push(items);
                                // Continue reading
                                readEntries();
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, function(err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $1a3bd4adf018f8a8$var$fromFileEntry(entry) {
    return (0, $1aaf9c65fb7afb7d$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $1aaf9c65fb7afb7d$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    entry.file(function(file) {
                        var fwp = (0, $45fbe38345ef42c3$export$8cc09085015f0dc7)(file, entry.fullPath);
                        resolve(fwp);
                    }, function(err) {
                        reject(err);
                    });
                })
            ];
        });
    });
}




var $74e334fca223059c$export$1e511d4a378977f5;
var $74e334fca223059c$export$2e2bcd8739ae039;
"use strict";
$74e334fca223059c$export$1e511d4a378977f5 = true;
$74e334fca223059c$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
        var fileName = file.name || "";
        var mimeType = (file.type || "").toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, "");
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === ".") return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith("/*")) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, "");
            return mimeType === validType;
        });
    }
    return true;
};


function $9e73a3a19ec78e86$var$_toConsumableArray(arr) {
    return $9e73a3a19ec78e86$var$_arrayWithoutHoles(arr) || $9e73a3a19ec78e86$var$_iterableToArray(arr) || $9e73a3a19ec78e86$var$_unsupportedIterableToArray(arr) || $9e73a3a19ec78e86$var$_nonIterableSpread();
}
function $9e73a3a19ec78e86$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9e73a3a19ec78e86$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9e73a3a19ec78e86$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9e73a3a19ec78e86$var$_arrayLikeToArray(arr);
}
function $9e73a3a19ec78e86$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9e73a3a19ec78e86$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9e73a3a19ec78e86$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9e73a3a19ec78e86$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9e73a3a19ec78e86$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9e73a3a19ec78e86$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9e73a3a19ec78e86$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9e73a3a19ec78e86$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9e73a3a19ec78e86$var$_typeof(obj);
}
function $9e73a3a19ec78e86$var$_slicedToArray(arr, i) {
    return $9e73a3a19ec78e86$var$_arrayWithHoles(arr) || $9e73a3a19ec78e86$var$_iterableToArrayLimit(arr, i) || $9e73a3a19ec78e86$var$_unsupportedIterableToArray(arr, i) || $9e73a3a19ec78e86$var$_nonIterableRest();
}
function $9e73a3a19ec78e86$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9e73a3a19ec78e86$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9e73a3a19ec78e86$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9e73a3a19ec78e86$var$_arrayLikeToArray(o, minLen);
}
function $9e73a3a19ec78e86$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9e73a3a19ec78e86$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $9e73a3a19ec78e86$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $9e73a3a19ec78e86$export$d2c35cc369247232 = "file-invalid-type";
var $9e73a3a19ec78e86$export$d7bd1185abe1e87c = "file-too-large";
var $9e73a3a19ec78e86$export$8bd5ec6ed990dc9 = "file-too-small";
var $9e73a3a19ec78e86$export$3271ef1d2dd155f9 = "too-many-files";
var $9e73a3a19ec78e86$export$d4e71bc0b80dc0fb = {
    FileInvalidType: $9e73a3a19ec78e86$export$d2c35cc369247232,
    FileTooLarge: $9e73a3a19ec78e86$export$d7bd1185abe1e87c,
    FileTooSmall: $9e73a3a19ec78e86$export$8bd5ec6ed990dc9,
    TooManyFiles: $9e73a3a19ec78e86$export$3271ef1d2dd155f9
}; // File Errors
var $9e73a3a19ec78e86$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr(accept) {
    accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
    var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
    return {
        code: $9e73a3a19ec78e86$export$d2c35cc369247232,
        message: "File type must be ".concat(messageSuffix)
    };
};
var $9e73a3a19ec78e86$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $9e73a3a19ec78e86$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
    };
};
var $9e73a3a19ec78e86$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $9e73a3a19ec78e86$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
    };
};
var $9e73a3a19ec78e86$export$1e1e1b6120329fe = {
    code: $9e73a3a19ec78e86$export$3271ef1d2dd155f9,
    message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
function $9e73a3a19ec78e86$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || (0, $74e334fca223059c$export$2e2bcd8739ae039)(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : $9e73a3a19ec78e86$export$bc0bbda045f09b5a(accept)
    ];
}
function $9e73a3a19ec78e86$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($9e73a3a19ec78e86$var$isDefined(file.size)) {
        if ($9e73a3a19ec78e86$var$isDefined(minSize) && $9e73a3a19ec78e86$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $9e73a3a19ec78e86$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $9e73a3a19ec78e86$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($9e73a3a19ec78e86$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $9e73a3a19ec78e86$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($9e73a3a19ec78e86$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $9e73a3a19ec78e86$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $9e73a3a19ec78e86$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $9e73a3a19ec78e86$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $9e73a3a19ec78e86$export$b511db3632effe58(file, accept), _fileAccepted2 = $9e73a3a19ec78e86$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $9e73a3a19ec78e86$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $9e73a3a19ec78e86$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        var customErrors = validator ? validator(file) : null;
        return accepted && sizeMatch && !customErrors;
    });
} // React's synthetic events has event.isPropagationStopped,
function $9e73a3a19ec78e86$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $9e73a3a19ec78e86$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $9e73a3a19ec78e86$export$f9006bf02b243736(item) {
    return $9e73a3a19ec78e86$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $9e73a3a19ec78e86$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $9e73a3a19ec78e86$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $9e73a3a19ec78e86$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $9e73a3a19ec78e86$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $9e73a3a19ec78e86$var$isIe(userAgent) || $9e73a3a19ec78e86$var$isEdge(userAgent);
}
function $9e73a3a19ec78e86$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$9e73a3a19ec78e86$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $9e73a3a19ec78e86$export$8d6d6472146de265(event);
        });
    };
}
function $9e73a3a19ec78e86$export$858af2af50e1eaf8() {
    return "showOpenFilePicker" in window;
}
function $9e73a3a19ec78e86$export$8ce4bd13c494743e(accept) {
    if ($9e73a3a19ec78e86$var$isDefined(accept)) {
        var acceptForPicker = Object.entries(accept).filter(function(_ref2) {
            var _ref3 = $9e73a3a19ec78e86$var$_slicedToArray(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
            var ok = true;
            if (!$9e73a3a19ec78e86$export$69c8ec3250e1cfbf(mimeType)) {
                console.warn('Skipped "'.concat(mimeType, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.'));
                ok = false;
            }
            if (!Array.isArray(ext) || !ext.every($9e73a3a19ec78e86$export$42c2be5a6d408120)) {
                console.warn('Skipped "'.concat(mimeType, '" because an invalid file extension was provided.'));
                ok = false;
            }
            return ok;
        }).reduce(function(agg, _ref4) {
            var _ref5 = $9e73a3a19ec78e86$var$_slicedToArray(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
            return $9e73a3a19ec78e86$var$_objectSpread($9e73a3a19ec78e86$var$_objectSpread({}, agg), {}, $9e73a3a19ec78e86$var$_defineProperty({}, mimeType, ext));
        }, {});
        return [
            {
                // description is required due to https://crbug.com/1264708
                description: "Files",
                accept: acceptForPicker
            }
        ];
    }
    return accept;
}
function $9e73a3a19ec78e86$export$1278288bcefb97b9(accept) {
    if ($9e73a3a19ec78e86$var$isDefined(accept)) return Object.entries(accept).reduce(function(a, _ref6) {
        var _ref7 = $9e73a3a19ec78e86$var$_slicedToArray(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
        return [].concat($9e73a3a19ec78e86$var$_toConsumableArray(a), [
            mimeType
        ], $9e73a3a19ec78e86$var$_toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function(v) {
        return $9e73a3a19ec78e86$export$69c8ec3250e1cfbf(v) || $9e73a3a19ec78e86$export$42c2be5a6d408120(v);
    }).join(",");
    return undefined;
}
function $9e73a3a19ec78e86$export$72580c77a176a18f(v) {
    return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function $9e73a3a19ec78e86$export$c4f82d4432e209a9(v) {
    return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function $9e73a3a19ec78e86$export$69c8ec3250e1cfbf(v) {
    return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
function $9e73a3a19ec78e86$export$42c2be5a6d408120(v) {
    return /^.*\.[\w]+$/.test(v);
} /**
 * @typedef {Object.<string, string[]>} AcceptProp
 */  /**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */  /**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */ 



var $760b773abd42ca42$var$_excluded = [
    "children"
], $760b773abd42ca42$var$_excluded2 = [
    "open"
], $760b773abd42ca42$var$_excluded3 = [
    "refKey",
    "role",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], $760b773abd42ca42$var$_excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function $760b773abd42ca42$var$_toConsumableArray(arr) {
    return $760b773abd42ca42$var$_arrayWithoutHoles(arr) || $760b773abd42ca42$var$_iterableToArray(arr) || $760b773abd42ca42$var$_unsupportedIterableToArray(arr) || $760b773abd42ca42$var$_nonIterableSpread();
}
function $760b773abd42ca42$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $760b773abd42ca42$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $760b773abd42ca42$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $760b773abd42ca42$var$_arrayLikeToArray(arr);
}
function $760b773abd42ca42$var$_slicedToArray(arr, i) {
    return $760b773abd42ca42$var$_arrayWithHoles(arr) || $760b773abd42ca42$var$_iterableToArrayLimit(arr, i) || $760b773abd42ca42$var$_unsupportedIterableToArray(arr, i) || $760b773abd42ca42$var$_nonIterableRest();
}
function $760b773abd42ca42$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $760b773abd42ca42$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $760b773abd42ca42$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $760b773abd42ca42$var$_arrayLikeToArray(o, minLen);
}
function $760b773abd42ca42$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $760b773abd42ca42$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $760b773abd42ca42$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $760b773abd42ca42$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $760b773abd42ca42$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $760b773abd42ca42$var$ownKeys(Object(source), !0).forEach(function(key) {
            $760b773abd42ca42$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $760b773abd42ca42$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $760b773abd42ca42$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $760b773abd42ca42$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $760b773abd42ca42$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $760b773abd42ca42$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $760b773abd42ca42$var$Dropzone = /*#__PURE__*/ (0, $fV3WI.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $760b773abd42ca42$var$_objectWithoutProperties(_ref, $760b773abd42ca42$var$_excluded);
    var _useDropzone = $760b773abd42ca42$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $760b773abd42ca42$var$_objectWithoutProperties(_useDropzone, $760b773abd42ca42$var$_excluded2);
    (0, $fV3WI.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createElement((0, $fV3WI.Fragment), null, children($760b773abd42ca42$var$_objectSpread($760b773abd42ca42$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$760b773abd42ca42$var$Dropzone.displayName = "Dropzone"; // Add default props for react-docgen
var $760b773abd42ca42$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $1a3bd4adf018f8a8$export$a36e16046ae8f1bb),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: true,
    autoFocus: false
};
$760b773abd42ca42$var$Dropzone.defaultProps = $760b773abd42ca42$var$defaultProps;
$760b773abd42ca42$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).func,
    /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).string)),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).func,
    /**
   * Cb for when opening the file dialog
   */ onFileDialogOpen: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).func,
    /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */ useFsAccessApi: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).bool,
    /**
   * Set to true to focus the root element on render
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).bool,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).func,
    /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).func,
    /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */ validator: (0, (/*@__PURE__*/$parcel$interopDefault($gVgA5))).func
};
var $760b773abd42ca42$export$2e2bcd8739ae039 = $760b773abd42ca42$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ /**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */ var $760b773abd42ca42$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    acceptedFiles: [],
    fileRejections: []
};
function $760b773abd42ca42$export$cd49c0ecc5be9f36() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$props = $760b773abd42ca42$var$_objectSpread($760b773abd42ca42$var$_objectSpread({}, $760b773abd42ca42$var$defaultProps), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
    var acceptAttr = (0, $fV3WI.useMemo)(function() {
        return (0, $9e73a3a19ec78e86$export$1278288bcefb97b9)(accept);
    }, [
        accept
    ]);
    var pickerTypes = (0, $fV3WI.useMemo)(function() {
        return (0, $9e73a3a19ec78e86$export$8ce4bd13c494743e)(accept);
    }, [
        accept
    ]);
    var onFileDialogOpenCb = (0, $fV3WI.useMemo)(function() {
        return typeof onFileDialogOpen === "function" ? onFileDialogOpen : $760b773abd42ca42$var$noop;
    }, [
        onFileDialogOpen
    ]);
    var onFileDialogCancelCb = (0, $fV3WI.useMemo)(function() {
        return typeof onFileDialogCancel === "function" ? onFileDialogCancel : $760b773abd42ca42$var$noop;
    }, [
        onFileDialogCancel
    ]);
    /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */ var rootRef = (0, $fV3WI.useRef)(null);
    var inputRef = (0, $fV3WI.useRef)(null);
    var _useReducer = (0, $fV3WI.useReducer)($760b773abd42ca42$var$reducer, $760b773abd42ca42$var$initialState), _useReducer2 = $760b773abd42ca42$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
    var fsAccessApiWorksRef = (0, $fV3WI.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && (0, $9e73a3a19ec78e86$export$858af2af50e1eaf8)()); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    onFileDialogCancelCb();
                }
            }
        }, 300);
    };
    (0, $fV3WI.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancelCb,
        fsAccessApiWorksRef
    ]);
    var dragTargetsRef = (0, $fV3WI.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $fV3WI.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $9e73a3a19ec78e86$export$2ead263d6635cecc), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $9e73a3a19ec78e86$export$2ead263d6635cecc));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]); // Auto focus the root when autoFocus is true
    (0, $fV3WI.useEffect)(function() {
        if (!disabled && autoFocus && rootRef.current) rootRef.current.focus();
        return function() {};
    }, [
        rootRef,
        autoFocus,
        disabled
    ]);
    var onErrCb = (0, $fV3WI.useCallback)(function(e) {
        if (onError) onError(e);
        else // Let the user know something's gone wrong if they haven't provided the onError cb.
        console.error(e);
    }, [
        onError
    ]);
    var onDragEnterCb = (0, $fV3WI.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($760b773abd42ca42$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $9e73a3a19ec78e86$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $9e73a3a19ec78e86$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            var fileCount = files.length;
            var isDragAccept = fileCount > 0 && (0, $9e73a3a19ec78e86$export$6a0bb4322c81a197)({
                files: files,
                accept: acceptAttr,
                minSize: minSize,
                maxSize: maxSize,
                multiple: multiple,
                maxFiles: maxFiles,
                validator: validator
            });
            var isDragReject = fileCount > 0 && !isDragAccept;
            dispatch({
                isDragAccept: isDragAccept,
                isDragReject: isDragReject,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        }).catch(function(e) {
            return onErrCb(e);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        onErrCb,
        noDragEventsBubbling,
        acceptAttr,
        minSize,
        maxSize,
        multiple,
        maxFiles,
        validator
    ]);
    var onDragOverCb = (0, $fV3WI.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, $9e73a3a19ec78e86$export$52f1fc875a1e5986)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $fV3WI.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            type: "setDraggedFiles",
            isDragActive: false,
            isDragAccept: false,
            isDragReject: false
        });
        if ((0, $9e73a3a19ec78e86$export$52f1fc875a1e5986)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var setFiles = (0, $fV3WI.useCallback)(function(files, event) {
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
            var _fileAccepted = (0, $9e73a3a19ec78e86$export$b511db3632effe58)(file, acceptAttr), _fileAccepted2 = $760b773abd42ca42$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
            var _fileMatchSize = (0, $9e73a3a19ec78e86$export$860631d45ba43fd9)(file, minSize, maxSize), _fileMatchSize2 = $760b773abd42ca42$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
            var customErrors = validator ? validator(file) : null;
            if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
            else {
                var errors = [
                    acceptError,
                    sizeError
                ];
                if (customErrors) errors = errors.concat(customErrors);
                fileRejections.push({
                    file: file,
                    errors: errors.filter(function(e) {
                        return e;
                    })
                });
            }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            // Reject everything and empty accepted files
            acceptedFiles.forEach(function(file) {
                fileRejections.push({
                    file: file,
                    errors: [
                        (0, $9e73a3a19ec78e86$export$1e1e1b6120329fe)
                    ]
                });
            });
            acceptedFiles.splice(0);
        }
        dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            type: "setFiles"
        });
        if (onDrop) onDrop(acceptedFiles, fileRejections, event);
        if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
        if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
    }, [
        dispatch,
        multiple,
        acceptAttr,
        minSize,
        maxSize,
        maxFiles,
        onDrop,
        onDropAccepted,
        onDropRejected,
        validator
    ]);
    var onDropCb = (0, $fV3WI.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $9e73a3a19ec78e86$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $9e73a3a19ec78e86$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            setFiles(files, event);
        }).catch(function(e) {
            return onErrCb(e);
        });
        dispatch({
            type: "reset"
        });
    }, [
        getFilesFromEvent,
        setFiles,
        onErrCb,
        noDragEventsBubbling
    ]); // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $fV3WI.useCallback)(function() {
        // No point to use FS access APIs if context is not secure
        // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
        if (fsAccessApiWorksRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
            var opts = {
                multiple: multiple,
                types: pickerTypes
            };
            window.showOpenFilePicker(opts).then(function(handles) {
                return getFilesFromEvent(handles);
            }).then(function(files) {
                setFiles(files, null);
                dispatch({
                    type: "closeDialog"
                });
            }).catch(function(e) {
                // AbortError means the user canceled
                if ((0, $9e73a3a19ec78e86$export$72580c77a176a18f)(e)) {
                    onFileDialogCancelCb(e);
                    dispatch({
                        type: "closeDialog"
                    });
                } else if ((0, $9e73a3a19ec78e86$export$c4f82d4432e209a9)(e)) {
                    fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
                    // Try using the input
                    if (inputRef.current) {
                        inputRef.current.value = null;
                        inputRef.current.click();
                    } else onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
                } else onErrCb(e);
            });
            return;
        }
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch,
        onFileDialogOpenCb,
        onFileDialogCancelCb,
        useFsAccessApi,
        setFiles,
        onErrCb,
        pickerTypes,
        multiple
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $fV3WI.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        openFileDialog
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $fV3WI.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $fV3WI.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $fV3WI.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $9e73a3a19ec78e86$export$d3498e653911f962)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        noClick,
        openFileDialog
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $fV3WI.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $760b773abd42ca42$var$_objectWithoutProperties(_ref2, $760b773abd42ca42$var$_excluded3);
            return $760b773abd42ca42$var$_objectSpread($760b773abd42ca42$var$_objectSpread($760b773abd42ca42$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $9e73a3a19ec78e86$export$b9ecd428b558ff10)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $9e73a3a19ec78e86$export$b9ecd428b558ff10)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $9e73a3a19ec78e86$export$b9ecd428b558ff10)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $9e73a3a19ec78e86$export$b9ecd428b558ff10)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $9e73a3a19ec78e86$export$b9ecd428b558ff10)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $9e73a3a19ec78e86$export$b9ecd428b558ff10)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $9e73a3a19ec78e86$export$b9ecd428b558ff10)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $9e73a3a19ec78e86$export$b9ecd428b558ff10)(onDrop, onDropCb)),
                role: typeof role === "string" && role !== "" ? role : "presentation"
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $fV3WI.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $fV3WI.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $760b773abd42ca42$var$_objectWithoutProperties(_ref3, $760b773abd42ca42$var$_excluded4);
            var inputProps = $760b773abd42ca42$var$_defineProperty({
                accept: acceptAttr,
                multiple: multiple,
                type: "file",
                style: {
                    display: "none"
                },
                onChange: composeHandler((0, $9e73a3a19ec78e86$export$b9ecd428b558ff10)(onChange, onDropCb)),
                onClick: composeHandler((0, $9e73a3a19ec78e86$export$b9ecd428b558ff10)(onClick, onInputElementClick)),
                tabIndex: -1
            }, refKey, inputRef);
            return $760b773abd42ca42$var$_objectSpread($760b773abd42ca42$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    return $760b773abd42ca42$var$_objectSpread($760b773abd42ca42$var$_objectSpread({}, state), {}, {
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */ function $760b773abd42ca42$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $760b773abd42ca42$var$_objectSpread($760b773abd42ca42$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return $760b773abd42ca42$var$_objectSpread($760b773abd42ca42$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return $760b773abd42ca42$var$_objectSpread($760b773abd42ca42$var$_objectSpread({}, $760b773abd42ca42$var$initialState), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $760b773abd42ca42$var$_objectSpread($760b773abd42ca42$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            return $760b773abd42ca42$var$_objectSpread($760b773abd42ca42$var$_objectSpread({}, state), {}, {
                isDragActive: action.isDragActive,
                isDragAccept: action.isDragAccept,
                isDragReject: action.isDragReject
            });
        case "setFiles":
            return $760b773abd42ca42$var$_objectSpread($760b773abd42ca42$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections
            });
        case "reset":
            return $760b773abd42ca42$var$_objectSpread({}, $760b773abd42ca42$var$initialState);
        default:
            return state;
    }
}
function $760b773abd42ca42$var$noop() {}




var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $dbzFE = parcelRequire("dbzFE");
var $js0sS = parcelRequire("js0sS");
var $auxfn = parcelRequire("auxfn");


var $3IDET = parcelRequire("3IDET");

var $ezkpc = parcelRequire("ezkpc");

var $34rWH = parcelRequire("34rWH");

var $265Xa = parcelRequire("265Xa");

var $ioiN6 = parcelRequire("ioiN6");

var $3DnwL = parcelRequire("3DnwL");
const $530998063df8f2d1$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $530998063df8f2d1$var$defaultTheme = (0, $34rWH.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $530998063df8f2d1$var$defaultCreateStyledComponent = (0, $68d484dcb54a86c7$export$2e2bcd8739ae039)("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $530998063df8f2d1$var$useThemePropsDefault(props) {
    return (0, $3IDET.default)({
        props: props,
        name: "MuiStack",
        defaultTheme: $530998063df8f2d1$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $530998063df8f2d1$var$joinChildren(children, separator) {
    const childrenArray = $fV3WI.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $fV3WI.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $530998063df8f2d1$var$getSideFromDirection = (direction)=>{
    return ({
        row: "Left",
        "row-reverse": "Right",
        column: "Top",
        "column-reverse": "Bottom"
    })[direction];
};
const $530998063df8f2d1$export$1d567c320f4763bc = ({ ownerState: ownerState , theme: theme  })=>{
    let styles = (0, $j5tUA.default)({
        display: "flex",
        flexDirection: "column"
    }, (0, $265Xa.handleBreakpoints)({
        theme: theme
    }, (0, $265Xa.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $ioiN6.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $265Xa.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $265Xa.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === "object") Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $ioiN6.getValue)(transformer, propValue)
            };
            return {
                "& > :not(style) + :not(style)": {
                    margin: 0,
                    [`margin${$530998063df8f2d1$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $ioiN6.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $dbzFE.default)(styles, (0, $265Xa.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $265Xa.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $530998063df8f2d1$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $530998063df8f2d1$var$defaultCreateStyledComponent , useThemeProps: useThemeProps = $530998063df8f2d1$var$useThemePropsDefault , componentName: componentName = "MuiStack"  } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                "root"
            ]
        };
        return (0, $js0sS.default)(slots, (slot)=>(0, $auxfn.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($530998063df8f2d1$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $fV3WI.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $ezkpc.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = "div" , direction: direction = "column" , spacing: spacing = 0 , divider: divider , children: children , className: className , useFlexGap: useFlexGap = false  } = props, other = (0, $64S8Y.default)(props, $530998063df8f2d1$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $3DnwL.jsx)(StackRoot, (0, $j5tUA.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $h0s6D.default)(classes.root, className)
        }, other, {
            children: divider ? $530998063df8f2d1$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");
const $16af95e7f7630780$var$Stack = (0, $530998063df8f2d1$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $aF4Kv.default)("div", {
        name: "MuiStack",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $05gnM.default)({
            props: inProps,
            name: "MuiStack"
        })
});
var $16af95e7f7630780$export$2e2bcd8739ae039 = $16af95e7f7630780$var$Stack;


var $hScOl = parcelRequire("hScOl");
var $4uBZf = parcelRequire("4uBZf");

var $iEw4v = parcelRequire("iEw4v");

var $3DnwL = parcelRequire("3DnwL");
var $3f8214964299ecc7$export$2e2bcd8739ae039 = (0, $iEw4v.default)(/*#__PURE__*/ (0, $3DnwL.jsx)("path", {
    d: "M24 15c0-2.64-2.05-4.78-4.65-4.96C18.67 6.59 15.64 4 12 4c-1.33 0-2.57.36-3.65.97l1.49 1.49C10.51 6.17 11.23 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 .99-.48 1.85-1.21 2.4l1.41 1.41c1.09-.92 1.8-2.27 1.8-3.81zM4.41 3.86 3 5.27l2.77 2.77h-.42C2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h11.73l2 2 1.41-1.41L4.41 3.86zM6 18c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73l8 8H6z"
}), "CloudOffOutlined");


var $iEw4v = parcelRequire("iEw4v");

var $3DnwL = parcelRequire("3DnwL");
var $1e006b872672c340$export$2e2bcd8739ae039 = (0, $iEw4v.default)(/*#__PURE__*/ (0, $3DnwL.jsx)("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
}), "CloudUpload");



var $hhXI3 = parcelRequire("hhXI3");
const $940c81dcb1c55018$var$getStyles = (theme)=>({
        select: (0, $hhXI3.css)`
    color: ${theme.palette.secondary.main};
    text-decoration: underline;
    cursor: pointer;
  `,
        icon: (0, $hhXI3.css)`
    font-size: 60px;
  `,
        root: (0, $hhXI3.css)`
    background-color: ${theme.extraColors.secondaryContrast}ff;
    outline: 2px dashed #0000001f;
    outline-offset: -10px;
    width: 100%;
    transition: 0.1s;
  `,
        rootActive: (0, $hhXI3.css)`
    background-color: ${theme.extraColors.secondaryContrast}80;
    outline: 2px dashed #0000001f;
    outline-offset: -15px;
    width: 100%;
    transition: 0.1s;
  `
    });
const $940c81dcb1c55018$export$97f31a830c1b39e6 = ({ AcceptFiles: AcceptFiles , acceptFilesText: acceptFilesText , chooseFilesText: chooseFilesText , dropFilesText: dropFilesText , onDrop: onDrop , rejectFilesText: rejectFilesText  })=>{
    const theme = (0, $4uBZf.default)();
    const styles = $940c81dcb1c55018$var$getStyles(theme);
    return (0, $dYG3T.jsx)((0, $760b773abd42ca42$export$2e2bcd8739ae039), {
        onDrop: onDrop,
        accept: AcceptFiles,
        children: ({ getRootProps: getRootProps , getInputProps: getInputProps , isDragActive: isDragActive , isDragReject: isDragReject  })=>(0, $dYG3T.jsxs)("div", {
                css: isDragActive ? styles.rootActive : styles.root,
                ...getRootProps(),
                "data-id": "drop-zone",
                children: [
                    (0, $dYG3T.jsx)("input", {
                        ...getInputProps(),
                        "data-id": "drop-input"
                    }),
                    (0, $dYG3T.jsxs)((0, $16af95e7f7630780$export$2e2bcd8739ae039), {
                        justifyContent: "center",
                        alignItems: "center",
                        spacing: 1,
                        padding: 3,
                        children: [
                            isDragReject ? (0, $dYG3T.jsx)((0, $3f8214964299ecc7$export$2e2bcd8739ae039), {
                                css: styles.icon,
                                color: "error"
                            }) : (0, $dYG3T.jsx)((0, $1e006b872672c340$export$2e2bcd8739ae039), {
                                css: styles.icon,
                                color: "success"
                            }),
                            (0, $dYG3T.jsx)((0, $16af95e7f7630780$export$2e2bcd8739ae039), {
                                direction: "row",
                                spacing: 0.5,
                                children: isDragReject ? (0, $dYG3T.jsx)((0, $hScOl.default), {
                                    color: "error",
                                    children: rejectFilesText
                                }) : (0, $dYG3T.jsxs)((0, $dYG3T.Fragment), {
                                    children: [
                                        (0, $dYG3T.jsx)((0, $hScOl.default), {
                                            children: dropFilesText
                                        }),
                                        (0, $dYG3T.jsx)((0, $hScOl.default), {
                                            css: styles.select,
                                            children: chooseFilesText
                                        })
                                    ]
                                })
                            }),
                            (0, $dYG3T.jsx)((0, $16af95e7f7630780$export$2e2bcd8739ae039), {
                                direction: "row",
                                spacing: 0.5,
                                children: (0, $dYG3T.jsx)((0, $hScOl.default), {
                                    color: "GrayText",
                                    variant: "caption",
                                    children: acceptFilesText
                                })
                            })
                        ]
                    })
                ]
            })
    });
};





var $dYG3T = parcelRequire("dYG3T");

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $js0sS = parcelRequire("js0sS");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");
parcelRequire("fV3WI");

var $iEw4v = parcelRequire("iEw4v");

var $3DnwL = parcelRequire("3DnwL");
var $71131e471aa6db30$export$2e2bcd8739ae039 = (0, $iEw4v.default)(/*#__PURE__*/ (0, $3DnwL.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");



var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $f1f2d5b1984068a0$export$ffd560f22c0ecf04(slot) {
    return (0, $auxfn.default)("MuiAvatar", slot);
}
const $f1f2d5b1984068a0$var$avatarClasses = (0, $dxVxC.default)("MuiAvatar", [
    "root",
    "colorDefault",
    "circular",
    "rounded",
    "square",
    "img",
    "fallback"
]);
var $f1f2d5b1984068a0$export$2e2bcd8739ae039 = $f1f2d5b1984068a0$var$avatarClasses;



var $3DnwL = parcelRequire("3DnwL");
const $8a159c41c3dda38f$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $8a159c41c3dda38f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , variant: variant , colorDefault: colorDefault  } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            colorDefault && "colorDefault"
        ],
        img: [
            "img"
        ],
        fallback: [
            "fallback"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $f1f2d5b1984068a0$export$ffd560f22c0ecf04), classes);
};
const $8a159c41c3dda38f$var$AvatarRoot = (0, $aF4Kv.default)("div", {
    name: "MuiAvatar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: "50%",
        overflow: "hidden",
        userSelect: "none"
    }, ownerState.variant === "rounded" && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.variant === "square" && {
        borderRadius: 0
    }, ownerState.colorDefault && (0, $j5tUA.default)({
        color: (theme.vars || theme).palette.background.default
    }, theme.vars ? {
        backgroundColor: theme.vars.palette.Avatar.defaultBg
    } : {
        backgroundColor: theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[600]
    })));
const $8a159c41c3dda38f$var$AvatarImg = (0, $aF4Kv.default)("img", {
    name: "MuiAvatar",
    slot: "Img",
    overridesResolver: (props, styles)=>styles.img
})({
    width: "100%",
    height: "100%",
    textAlign: "center",
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: "cover",
    // Hide alt text.
    color: "transparent",
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $8a159c41c3dda38f$var$AvatarFallback = (0, $aF4Kv.default)((0, $71131e471aa6db30$export$2e2bcd8739ae039), {
    name: "MuiAvatar",
    slot: "Fallback",
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: "75%",
    height: "75%"
});
function $8a159c41c3dda38f$var$useLoaded({ crossOrigin: crossOrigin , referrerPolicy: referrerPolicy , src: src , srcSet: srcSet  }) {
    const [loaded, setLoaded] = $fV3WI.useState(false);
    $fV3WI.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded("loaded");
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded("error");
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $8a159c41c3dda38f$var$Avatar = /*#__PURE__*/ $fV3WI.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiAvatar"
    });
    const { alt: alt , children: childrenProp , className: className , component: component = "div" , imgProps: imgProps , sizes: sizes , src: src , srcSet: srcSet , variant: variant = "circular"  } = props, other = (0, $64S8Y.default)(props, $8a159c41c3dda38f$var$_excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $8a159c41c3dda38f$var$useLoaded((0, $j5tUA.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== "error";
    const ownerState = (0, $j5tUA.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $8a159c41c3dda38f$var$useUtilityClasses(ownerState);
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $3DnwL.jsx)($8a159c41c3dda38f$var$AvatarImg, (0, $j5tUA.default)({
        alt: alt,
        src: src,
        srcSet: srcSet,
        sizes: sizes,
        ownerState: ownerState,
        className: classes.img
    }, imgProps));
    else if (childrenProp != null) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $3DnwL.jsx)($8a159c41c3dda38f$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $3DnwL.jsx)($8a159c41c3dda38f$var$AvatarRoot, (0, $j5tUA.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $h0s6D.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $8a159c41c3dda38f$export$2e2bcd8739ae039 = $8a159c41c3dda38f$var$Avatar;


var $7KC5x = parcelRequire("7KC5x");
var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $js0sS = parcelRequire("js0sS");

var $74s0b = parcelRequire("74s0b");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $f19673036c0c8d66$export$46f01d01378ec5a2(slot) {
    return (0, $auxfn.default)("MuiDivider", slot);
}
const $f19673036c0c8d66$var$dividerClasses = (0, $dxVxC.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $f19673036c0c8d66$export$2e2bcd8739ae039 = $f19673036c0c8d66$var$dividerClasses;



var $3DnwL = parcelRequire("3DnwL");
const $c61e41c27a6fbffc$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $c61e41c27a6fbffc$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute , children: children , classes: classes , flexItem: flexItem , light: light , orientation: orientation , textAlign: textAlign , variant: variant  } = ownerState;
    const slots = {
        root: [
            "root",
            absolute && "absolute",
            variant,
            light && "light",
            orientation === "vertical" && "vertical",
            flexItem && "flexItem",
            children && "withChildren",
            children && orientation === "vertical" && "withChildrenVertical",
            textAlign === "right" && orientation !== "vertical" && "textAlignRight",
            textAlign === "left" && orientation !== "vertical" && "textAlignLeft"
        ],
        wrapper: [
            "wrapper",
            orientation === "vertical" && "wrapperVertical"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $f19673036c0c8d66$export$46f01d01378ec5a2), classes);
};
const $c61e41c27a6fbffc$var$DividerRoot = (0, $aF4Kv.default)("div", {
    name: "MuiDivider",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === "vertical" && styles.withChildrenVertical,
            ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && styles.textAlignRight,
            ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && styles.textAlignLeft
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: "solid",
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: "thin"
    }, ownerState.absolute && {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%"
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $74s0b.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === "inset" && {
        marginLeft: 72
    }, ownerState.variant === "middle" && ownerState.orientation === "horizontal" && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === "middle" && ownerState.orientation === "vertical" && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === "vertical" && {
        height: "100%",
        borderBottomWidth: 0,
        borderRightWidth: "thin"
    }, ownerState.flexItem && {
        alignSelf: "stretch",
        height: "auto"
    }), ({ ownerState: ownerState  })=>(0, $j5tUA.default)({}, ownerState.children && {
        display: "flex",
        whiteSpace: "nowrap",
        textAlign: "center",
        border: 0,
        "&::before, &::after": {
            content: '""',
            alignSelf: "center"
        }
    }), ({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({}, ownerState.children && ownerState.orientation !== "vertical" && {
        "&::before, &::after": {
            width: "100%",
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({}, ownerState.children && ownerState.orientation === "vertical" && {
        flexDirection: "column",
        "&::before, &::after": {
            height: "100%",
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ ownerState: ownerState  })=>(0, $j5tUA.default)({}, ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "90%"
        },
        "&::after": {
            width: "10%"
        }
    }, ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "10%"
        },
        "&::after": {
            width: "90%"
        }
    }));
const $c61e41c27a6fbffc$var$DividerWrapper = (0, $aF4Kv.default)("span", {
    name: "MuiDivider",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.wrapper,
            ownerState.orientation === "vertical" && styles.wrapperVertical
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({
        display: "inline-block",
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === "vertical" && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $c61e41c27a6fbffc$var$Divider = /*#__PURE__*/ $fV3WI.forwardRef(function Divider(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiDivider"
    });
    const { absolute: absolute = false , children: children , className: className , component: component = children ? "div" : "hr" , flexItem: flexItem = false , light: light = false , orientation: orientation = "horizontal" , role: role = component !== "hr" ? "separator" : undefined , textAlign: textAlign = "center" , variant: variant = "fullWidth"  } = props, other = (0, $64S8Y.default)(props, $c61e41c27a6fbffc$var$_excluded);
    const ownerState = (0, $j5tUA.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $c61e41c27a6fbffc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3DnwL.jsx)($c61e41c27a6fbffc$var$DividerRoot, (0, $j5tUA.default)({
        as: component,
        className: (0, $h0s6D.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $3DnwL.jsx)($c61e41c27a6fbffc$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
var $c61e41c27a6fbffc$export$2e2bcd8739ae039 = $c61e41c27a6fbffc$var$Divider;


var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $js0sS = parcelRequire("js0sS");

var $hhXI3 = parcelRequire("hhXI3");
var $74s0b = parcelRequire("74s0b");

var $ZXS89 = parcelRequire("ZXS89");

var $4uBZf = parcelRequire("4uBZf");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $fdd2ba6cb45ff774$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $auxfn.default)("MuiLinearProgress", slot);
}
const $fdd2ba6cb45ff774$var$linearProgressClasses = (0, $dxVxC.default)("MuiLinearProgress", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "determinate",
    "indeterminate",
    "buffer",
    "query",
    "dashed",
    "dashedColorPrimary",
    "dashedColorSecondary",
    "bar",
    "barColorPrimary",
    "barColorSecondary",
    "bar1Indeterminate",
    "bar1Determinate",
    "bar1Buffer",
    "bar2Indeterminate",
    "bar2Buffer"
]);
var $fdd2ba6cb45ff774$export$2e2bcd8739ae039 = $fdd2ba6cb45ff774$var$linearProgressClasses;



var $3DnwL = parcelRequire("3DnwL");
const $44b484cb328c4d91$var$_excluded = [
    "className",
    "color",
    "value",
    "valueBuffer",
    "variant"
];
let $44b484cb328c4d91$var$_ = (t)=>t, $44b484cb328c4d91$var$_t, $44b484cb328c4d91$var$_t2, $44b484cb328c4d91$var$_t3, $44b484cb328c4d91$var$_t4, $44b484cb328c4d91$var$_t5, $44b484cb328c4d91$var$_t6;
const $44b484cb328c4d91$var$TRANSITION_DURATION = 4; // seconds
const $44b484cb328c4d91$var$indeterminate1Keyframe = (0, $hhXI3.keyframes)($44b484cb328c4d91$var$_t || ($44b484cb328c4d91$var$_t = $44b484cb328c4d91$var$_`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`));
const $44b484cb328c4d91$var$indeterminate2Keyframe = (0, $hhXI3.keyframes)($44b484cb328c4d91$var$_t2 || ($44b484cb328c4d91$var$_t2 = $44b484cb328c4d91$var$_`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`));
const $44b484cb328c4d91$var$bufferKeyframe = (0, $hhXI3.keyframes)($44b484cb328c4d91$var$_t3 || ($44b484cb328c4d91$var$_t3 = $44b484cb328c4d91$var$_`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`));
const $44b484cb328c4d91$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , variant: variant , color: color  } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $ZXS89.default)(color)}`,
            variant
        ],
        dashed: [
            "dashed",
            `dashedColor${(0, $ZXS89.default)(color)}`
        ],
        bar1: [
            "bar",
            `barColor${(0, $ZXS89.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar1Indeterminate",
            variant === "determinate" && "bar1Determinate",
            variant === "buffer" && "bar1Buffer"
        ],
        bar2: [
            "bar",
            variant !== "buffer" && `barColor${(0, $ZXS89.default)(color)}`,
            variant === "buffer" && `color${(0, $ZXS89.default)(color)}`,
            (variant === "indeterminate" || variant === "query") && "bar2Indeterminate",
            variant === "buffer" && "bar2Buffer"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $fdd2ba6cb45ff774$export$bc8a6ea1eb17d7c6), classes);
};
const $44b484cb328c4d91$var$getColorShade = (theme, color)=>{
    if (color === "inherit") return "currentColor";
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === "light" ? (0, $74s0b.lighten)(theme.palette[color].main, 0.62) : (0, $74s0b.darken)(theme.palette[color].main, 0.5);
};
const $44b484cb328c4d91$var$LinearProgressRoot = (0, $aF4Kv.default)("span", {
    name: "MuiLinearProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            styles[`color${(0, $ZXS89.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})(({ ownerState: ownerState , theme: theme  })=>(0, $j5tUA.default)({
        position: "relative",
        overflow: "hidden",
        display: "block",
        height: 4,
        zIndex: 0,
        // Fix Safari's bug during composition of different paint.
        "@media print": {
            colorAdjust: "exact"
        },
        backgroundColor: $44b484cb328c4d91$var$getColorShade(theme, ownerState.color)
    }, ownerState.color === "inherit" && ownerState.variant !== "buffer" && {
        backgroundColor: "none",
        "&::before": {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "currentColor",
            opacity: 0.3
        }
    }, ownerState.variant === "buffer" && {
        backgroundColor: "transparent"
    }, ownerState.variant === "query" && {
        transform: "rotate(180deg)"
    }));
const $44b484cb328c4d91$var$LinearProgressDashed = (0, $aF4Kv.default)("span", {
    name: "MuiLinearProgress",
    slot: "Dashed",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $ZXS89.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState , theme: theme  })=>{
    const backgroundColor = $44b484cb328c4d91$var$getColorShade(theme, ownerState.color);
    return (0, $j5tUA.default)({
        position: "absolute",
        marginTop: 0,
        height: "100%",
        width: "100%"
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, {
        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
        backgroundSize: "10px 10px",
        backgroundPosition: "0 -23px"
    });
}, (0, $hhXI3.css)($44b484cb328c4d91$var$_t4 || ($44b484cb328c4d91$var$_t4 = $44b484cb328c4d91$var$_`
    animation: ${0} 3s infinite linear;
  `), $44b484cb328c4d91$var$bufferKeyframe));
const $44b484cb328c4d91$var$LinearProgressBar1 = (0, $aF4Kv.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar1",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $ZXS89.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar1Indeterminate,
            ownerState.variant === "determinate" && styles.bar1Determinate,
            ownerState.variant === "buffer" && styles.bar1Buffer
        ];
    }
})(({ ownerState: ownerState , theme: theme  })=>(0, $j5tUA.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left",
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "determinate" && {
        transition: `transform .${$44b484cb328c4d91$var$TRANSITION_DURATION}s linear`
    }, ownerState.variant === "buffer" && {
        zIndex: 1,
        transition: `transform .${$44b484cb328c4d91$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState  })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, $hhXI3.css)($44b484cb328c4d91$var$_t5 || ($44b484cb328c4d91$var$_t5 = $44b484cb328c4d91$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), $44b484cb328c4d91$var$indeterminate1Keyframe));
const $44b484cb328c4d91$var$LinearProgressBar2 = (0, $aF4Kv.default)("span", {
    name: "MuiLinearProgress",
    slot: "Bar2",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $ZXS89.default)(ownerState.color)}`],
            (ownerState.variant === "indeterminate" || ownerState.variant === "query") && styles.bar2Indeterminate,
            ownerState.variant === "buffer" && styles.bar2Buffer
        ];
    }
})(({ ownerState: ownerState , theme: theme  })=>(0, $j5tUA.default)({
        width: "100%",
        position: "absolute",
        left: 0,
        bottom: 0,
        top: 0,
        transition: "transform 0.2s linear",
        transformOrigin: "left"
    }, ownerState.variant !== "buffer" && {
        backgroundColor: ownerState.color === "inherit" ? "currentColor" : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        opacity: 0.3
    }, ownerState.variant === "buffer" && {
        backgroundColor: $44b484cb328c4d91$var$getColorShade(theme, ownerState.color),
        transition: `transform .${$44b484cb328c4d91$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState  })=>(ownerState.variant === "indeterminate" || ownerState.variant === "query") && (0, $hhXI3.css)($44b484cb328c4d91$var$_t6 || ($44b484cb328c4d91$var$_t6 = $44b484cb328c4d91$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), $44b484cb328c4d91$var$indeterminate2Keyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $44b484cb328c4d91$var$LinearProgress = /*#__PURE__*/ $fV3WI.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiLinearProgress"
    });
    const { className: className , color: color = "primary" , value: value , valueBuffer: valueBuffer , variant: variant = "indeterminate"  } = props, other = (0, $64S8Y.default)(props, $44b484cb328c4d91$var$_excluded);
    const ownerState = (0, $j5tUA.default)({}, props, {
        color: color,
        variant: variant
    });
    const classes = $44b484cb328c4d91$var$useUtilityClasses(ownerState);
    const theme = (0, $4uBZf.default)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === "determinate" || variant === "buffer") {
        if (value !== undefined) {
            rootProps["aria-valuenow"] = Math.round(value);
            rootProps["aria-valuemin"] = 0;
            rootProps["aria-valuemax"] = 100;
            let transform = value - 100;
            if (theme.direction === "rtl") transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === "buffer") {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (theme.direction === "rtl") transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $3DnwL.jsxs)($44b484cb328c4d91$var$LinearProgressRoot, (0, $j5tUA.default)({
        className: (0, $h0s6D.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar"
    }, rootProps, {
        ref: ref
    }, other, {
        children: [
            variant === "buffer" ? /*#__PURE__*/ (0, $3DnwL.jsx)($44b484cb328c4d91$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $3DnwL.jsx)($44b484cb328c4d91$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === "determinate" ? null : /*#__PURE__*/ (0, $3DnwL.jsx)($44b484cb328c4d91$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    }));
});
var $44b484cb328c4d91$export$2e2bcd8739ae039 = $44b484cb328c4d91$var$LinearProgress;


var $hScOl = parcelRequire("hScOl");

var $iEw4v = parcelRequire("iEw4v");

var $3DnwL = parcelRequire("3DnwL");
var $7ab220e9b67f0b1d$export$2e2bcd8739ae039 = (0, $iEw4v.default)(/*#__PURE__*/ (0, $3DnwL.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");


var $iEw4v = parcelRequire("iEw4v");

var $3DnwL = parcelRequire("3DnwL");
var $15bb1df11d212210$export$2e2bcd8739ae039 = (0, $iEw4v.default)(/*#__PURE__*/ (0, $3DnwL.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline");


var $iEw4v = parcelRequire("iEw4v");

var $3DnwL = parcelRequire("3DnwL");
var $c7ad0700cadc67dd$export$2e2bcd8739ae039 = (0, $iEw4v.default)(/*#__PURE__*/ (0, $3DnwL.jsx)("path", {
    d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zm-9.18-6.95L7.4 14.46 10.94 18l5.66-5.66-1.41-1.41-4.24 4.24-2.13-2.12z"
}), "TaskOutlined");


var $iEw4v = parcelRequire("iEw4v");

var $3DnwL = parcelRequire("3DnwL");
var $4f834bc7c2c641c3$export$2e2bcd8739ae039 = (0, $iEw4v.default)(/*#__PURE__*/ (0, $3DnwL.jsx)("path", {
    d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z"
}), "UploadFile");


const $47232631e3e82410$export$e1a3971de07c83b5 = (bytes, decimals = 2)=>{
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = [
        "Bytes",
        "kB",
        "MB",
        "GB"
    ];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + " " + sizes[i];
};


const $50aa5a07bb9d7922$var$LinearProgressWithLabel = (props)=>{
    return (0, $dYG3T.jsxs)((0, $16af95e7f7630780$export$2e2bcd8739ae039), {
        direction: "row",
        alignItems: "center",
        spacing: 2,
        children: [
            (0, $dYG3T.jsx)((0, $7KC5x.default), {
                width: "100%",
                children: (0, $dYG3T.jsx)((0, $44b484cb328c4d91$export$2e2bcd8739ae039), {
                    variant: "determinate",
                    ...props
                })
            }),
            (0, $dYG3T.jsx)((0, $7KC5x.default), {
                justifyContent: "flex-end",
                children: (0, $dYG3T.jsx)((0, $hScOl.default), {
                    variant: "body2",
                    color: "text.secondary",
                    children: `${Math.round(props.value)}%`
                })
            })
        ]
    });
};
const $50aa5a07bb9d7922$export$80e1d326f202f55f = (props)=>{
    const { error: error , fileName: fileName , fileSizeInBytes: fileSizeInBytes , onDelete: onDelete , progress: progress , showDivider: showDivider = false  } = props;
    const formatedFileSize = (0, $47232631e3e82410$export$e1a3971de07c83b5)(fileSizeInBytes);
    const handleDelete = ()=>onDelete();
    return (0, $dYG3T.jsxs)((0, $dYG3T.Fragment), {
        children: [
            (0, $dYG3T.jsxs)((0, $16af95e7f7630780$export$2e2bcd8739ae039), {
                paddingY: 2,
                spacing: 2,
                direction: "row",
                bgcolor: "#fff",
                children: [
                    (0, $dYG3T.jsx)((0, $8a159c41c3dda38f$export$2e2bcd8739ae039), {
                        sx: {
                            bgcolor: "transparent"
                        },
                        children: error ? (0, $dYG3T.jsx)((0, $15bb1df11d212210$export$2e2bcd8739ae039), {
                            color: "error",
                            "data-id": "errorIcon",
                            fontSize: "large"
                        }) : progress < 100 ? (0, $dYG3T.jsx)((0, $4f834bc7c2c641c3$export$2e2bcd8739ae039), {
                            color: "success",
                            "data-id": "progressIcon",
                            fontSize: "large"
                        }) : (0, $dYG3T.jsx)((0, $c7ad0700cadc67dd$export$2e2bcd8739ae039), {
                            color: "success",
                            "data-id": "successIcon",
                            fontSize: "large"
                        })
                    }),
                    (0, $dYG3T.jsxs)((0, $16af95e7f7630780$export$2e2bcd8739ae039), {
                        direction: "column",
                        width: "100%",
                        children: [
                            (0, $dYG3T.jsxs)((0, $16af95e7f7630780$export$2e2bcd8739ae039), {
                                spacing: 1,
                                direction: "row",
                                children: [
                                    (0, $dYG3T.jsx)((0, $hScOl.default), {
                                        variant: "body2",
                                        children: fileName
                                    }),
                                    (0, $dYG3T.jsx)((0, $hScOl.default), {
                                        variant: "body2",
                                        color: "text.secondary",
                                        children: formatedFileSize
                                    }),
                                    error && (0, $dYG3T.jsx)((0, $hScOl.default), {
                                        variant: "body2",
                                        color: "error",
                                        children: error
                                    })
                                ]
                            }),
                            (0, $dYG3T.jsx)($50aa5a07bb9d7922$var$LinearProgressWithLabel, {
                                value: progress,
                                color: !error ? "secondary" : "error"
                            })
                        ]
                    }),
                    (0, $dYG3T.jsx)((0, $96e62cba67d8fc25$export$2e2bcd8739ae039), {
                        onClick: handleDelete,
                        "data-id": "deleteButton",
                        children: (0, $dYG3T.jsx)((0, $7ab220e9b67f0b1d$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            showDivider && (0, $dYG3T.jsx)((0, $c61e41c27a6fbffc$export$2e2bcd8739ae039), {})
        ]
    });
};



var $fV3WI = parcelRequire("fV3WI");
const $8479b8e6a72d4255$export$51e724cad662ecb3 = ()=>{
    const [progress, setProgress] = (0, $fV3WI.useState)(0);
    const onUploadProgressChange = ({ loaded: loaded , total: total  })=>{
        const newProgress = Math.round(100 * loaded / total);
        setProgress(newProgress);
    };
    return {
        progress: progress,
        onUploadProgressChange: onUploadProgressChange
    };
};





var $dYG3T = parcelRequire("dYG3T");

var $iEw4v = parcelRequire("iEw4v");

var $3DnwL = parcelRequire("3DnwL");
var $1cf50006b72bbc54$export$2e2bcd8739ae039 = (0, $iEw4v.default)(/*#__PURE__*/ (0, $3DnwL.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20z"
}), "AccountCircle");



var $6r3xg = parcelRequire("6r3xg");
var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $js0sS = parcelRequire("js0sS");

var $74s0b = parcelRequire("74s0b");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");

var $fdeY0 = parcelRequire("fdeY0");

var $gScpF = parcelRequire("gScpF");

var $fR16U = parcelRequire("fR16U");

var $czyq6 = parcelRequire("czyq6");


var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $e46c8e52fdfa118c$export$81478e24460c57f2(slot) {
    return (0, $auxfn.default)("MuiListItemIcon", slot);
}
const $e46c8e52fdfa118c$var$listItemIconClasses = (0, $dxVxC.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $e46c8e52fdfa118c$export$2e2bcd8739ae039 = $e46c8e52fdfa118c$var$listItemIconClasses;



var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $b51f26828d0a0ed1$export$1061006a0db3aeb5(slot) {
    return (0, $auxfn.default)("MuiListItemText", slot);
}
const $b51f26828d0a0ed1$var$listItemTextClasses = (0, $dxVxC.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $b51f26828d0a0ed1$export$2e2bcd8739ae039 = $b51f26828d0a0ed1$var$listItemTextClasses;



var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $c6f2f4640250961f$export$515f8c67b5305377(slot) {
    return (0, $auxfn.default)("MuiMenuItem", slot);
}
const $c6f2f4640250961f$var$menuItemClasses = (0, $dxVxC.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $c6f2f4640250961f$export$2e2bcd8739ae039 = $c6f2f4640250961f$var$menuItemClasses;



var $3DnwL = parcelRequire("3DnwL");
const $11ea057b8214369c$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $11ea057b8214369c$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState  } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $11ea057b8214369c$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled , dense: dense , divider: divider , disableGutters: disableGutters , selected: selected , classes: classes  } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $js0sS.default)(slots, (0, $c6f2f4640250961f$export$515f8c67b5305377), classes);
    return (0, $j5tUA.default)({}, classes, composedClasses);
};
const $11ea057b8214369c$var$MenuItemRoot = (0, $aF4Kv.default)((0, $gScpF.default), {
    shouldForwardProp: (prop)=>(0, $aF4Kv.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $11ea057b8214369c$export$4334bb34c76fef24
})(({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $c6f2f4640250961f$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $74s0b.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $c6f2f4640250961f$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $74s0b.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $c6f2f4640250961f$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $74s0b.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $74s0b.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $c6f2f4640250961f$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $c6f2f4640250961f$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $f19673036c0c8d66$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $f19673036c0c8d66$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $b51f26828d0a0ed1$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $b51f26828d0a0ed1$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $e46c8e52fdfa118c$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, $j5tUA.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $e46c8e52fdfa118c$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const $11ea057b8214369c$var$MenuItem = /*#__PURE__*/ $fV3WI.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false , component: component = "li" , dense: dense = false , divider: divider = false , disableGutters: disableGutters = false , focusVisibleClassName: focusVisibleClassName , role: role = "menuitem" , tabIndex: tabIndexProp , className: className  } = props, other = (0, $64S8Y.default)(props, $11ea057b8214369c$var$_excluded);
    const context = $fV3WI.useContext((0, $fdeY0.default));
    const childContext = $fV3WI.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $fV3WI.useRef(null);
    (0, $fR16U.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $j5tUA.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $11ea057b8214369c$var$useUtilityClasses(props);
    const handleRef = (0, $czyq6.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $3DnwL.jsx)((0, $fdeY0.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $3DnwL.jsx)($11ea057b8214369c$var$MenuItemRoot, (0, $j5tUA.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $h0s6D.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $h0s6D.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $11ea057b8214369c$export$2e2bcd8739ae039 = $11ea057b8214369c$var$MenuItem;



var $fV3WI = parcelRequire("fV3WI");

var $hhXI3 = parcelRequire("hhXI3");
const $f195f6188684eb1a$var$rootStyles = (0, $hhXI3.css)`
  display: flex;
`;
const $f195f6188684eb1a$var$iconWrapperStyles = (0, $hhXI3.css)`
  position: relative;
`;
const $f195f6188684eb1a$export$72d0b49a56703654 = ({ avatar: avatar , userMenuHeadline: userMenuHeadline , menuProps: menuProps , menuItems: menuItems = [] , ...rest })=>{
    const [anchorEl, setAnchorEl] = (0, $fV3WI.useState)(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const closeMenu = ()=>{
        setAnchorEl(null);
    };
    return (0, $dYG3T.jsxs)("div", {
        css: $f195f6188684eb1a$var$rootStyles,
        ...rest,
        children: [
            userMenuHeadline,
            (0, $dYG3T.jsxs)("div", {
                css: $f195f6188684eb1a$var$iconWrapperStyles,
                children: [
                    (0, $dYG3T.jsx)((0, $96e62cba67d8fc25$export$2e2bcd8739ae039), {
                        role: "button",
                        "aria-controls": "menu-appbar",
                        "aria-haspopup": "true",
                        onClick: handleClick,
                        color: "secondary",
                        children: avatar ?? (0, $dYG3T.jsx)((0, $1cf50006b72bbc54$export$2e2bcd8739ae039), {
                            role: "img"
                        })
                    }),
                    (0, $dYG3T.jsx)((0, $6r3xg.default), {
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "right"
                        },
                        keepMounted: true,
                        transformOrigin: {
                            vertical: "top",
                            horizontal: "right"
                        },
                        ...menuProps,
                        anchorEl: anchorEl,
                        open: open,
                        onClose: closeMenu,
                        children: menuItems.map((item)=>(0, $dYG3T.jsx)((0, $11ea057b8214369c$export$2e2bcd8739ae039), {
                                onClick: item.onClick,
                                children: item.node
                            }, item.key))
                    })
                ]
            })
        ]
    });
};





var $dYG3T = parcelRequire("dYG3T");

var $fV3WI = parcelRequire("fV3WI");

var $hhXI3 = parcelRequire("hhXI3");

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");


var $js0sS = parcelRequire("js0sS");
var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");

var $zuYi8 = parcelRequire("zuYi8");
var $YB8rF = parcelRequire("YB8rF");
var $4lsKM = parcelRequire("4lsKM");
var $58XPl = parcelRequire("58XPl");
var $fV3WI = parcelRequire("fV3WI");
const $e7cf3686da3e4ea5$var$usePreviousProps = (value)=>{
    const ref = $fV3WI.useRef({});
    $fV3WI.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $e7cf3686da3e4ea5$export$2e2bcd8739ae039 = $e7cf3686da3e4ea5$var$usePreviousProps;


// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function $d3410e6df796244e$var$stripDiacritics(string) {
    return typeof string.normalize !== "undefined" ? string.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : string;
}
function $d3410e6df796244e$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true , ignoreCase: ignoreCase = true , limit: limit , matchFrom: matchFrom = "any" , stringify: stringify , trim: trim = false  } = config;
    return (options, { inputValue: inputValue , getOptionLabel: getOptionLabel  })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $d3410e6df796244e$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $d3410e6df796244e$var$stripDiacritics(candidate);
            return matchFrom === "start" ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === "number" ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
// To replace with .findIndex() once we stop IE11 support.
function $d3410e6df796244e$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $d3410e6df796244e$var$defaultFilterOptions = $d3410e6df796244e$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $d3410e6df796244e$var$pageSize = 5;
const $d3410e6df796244e$var$defaultIsActiveElementInListbox = (listboxRef)=>{
    var _listboxRef$current$p;
    return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
function $d3410e6df796244e$export$2e2bcd8739ae039(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $d3410e6df796244e$var$defaultIsActiveElementInListbox , unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = "Mui" , autoComplete: autoComplete = false , autoHighlight: autoHighlight = false , autoSelect: autoSelect = false , blurOnSelect: blurOnSelect = false , clearOnBlur: clearOnBlur = !props.freeSolo , clearOnEscape: clearOnEscape = false , componentName: componentName = "useAutocomplete" , defaultValue: defaultValue = props.multiple ? [] : null , disableClearable: disableClearable = false , disableCloseOnSelect: disableCloseOnSelect = false , disabled: disabledProp , disabledItemsFocusable: disabledItemsFocusable = false , disableListWrap: disableListWrap = false , filterOptions: filterOptions = $d3410e6df796244e$var$defaultFilterOptions , filterSelectedOptions: filterSelectedOptions = false , freeSolo: freeSolo = false , getOptionDisabled: getOptionDisabled , getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    } , groupBy: groupBy , handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo , id: idProp , includeInputInList: includeInputInList = false , inputValue: inputValueProp , isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value , multiple: multiple = false , onChange: onChange , onClose: onClose , onHighlightChange: onHighlightChange , onInputChange: onInputChange , onOpen: onOpen , open: openProp , openOnFocus: openOnFocus = false , options: options , readOnly: readOnly = false , selectOnFocus: selectOnFocus = !props.freeSolo , value: valueProp  } = props;
    const id = (0, $58XPl.default)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== "string") return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $fV3WI.useRef(false);
    const firstFocus = $fV3WI.useRef(true);
    const inputRef = $fV3WI.useRef(null);
    const listboxRef = $fV3WI.useRef(null);
    const [anchorEl, setAnchorEl] = $fV3WI.useState(null);
    const [focusedTag, setFocusedTag] = $fV3WI.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $fV3WI.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $YB8rF.default)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $YB8rF.default)({
        controlled: inputValueProp,
        default: "",
        name: componentName,
        state: "inputValue"
    });
    const [focused, setFocused] = $fV3WI.useState(false);
    const resetInputValue = $fV3WI.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = "";
        else if (newValue == null) newInputValue = "";
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === "string" ? optionLabel : "";
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, "reset");
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $YB8rF.default)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: "open"
    });
    const [inputPristine, setInputPristine] = $fV3WI.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? "" : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $e7cf3686da3e4ea5$export$2e2bcd8739ae039)({
        filteredOptions: filteredOptions,
        value: value
    });
    $fV3WI.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $4lsKM.default)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $fV3WI.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === "next" && nextFocus === filteredOptions.length || direction === "previous" && nextFocus === -1) return -1;
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute("aria-disabled") === "true";
            if (option && !option.hasAttribute("tabindex") || nextFocusDisabled) // Move to the next element.
            nextFocus += direction === "next" ? 1 : -1;
            else return nextFocus;
        }
    }
    const setHighlightedIndex = (0, $4lsKM.default)(({ event: event , index: index , reason: reason = "auto"  })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute("aria-activedescendant");
        else inputRef.current.setAttribute("aria-activedescendant", `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute("role") !== "listbox") listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === "keyboard") option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        //
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== "mouse") {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $4lsKM.default)(({ event: event , diff: diff , direction: direction = "next" , reason: reason = "auto"  })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === "reset") return defaultHighlighted;
            if (diff === "start") return 0;
            if (diff === "end") return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== "reset") {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const checkHighlightedOptionExists = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : "";
            const label2 = value2 ? getOptionLabel(value2) : "";
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) {
                const previousHighlightedOptionExists = filteredOptions.some((option)=>{
                    return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
                });
                if (previousHighlightedOptionExists) return true;
            }
        }
        return false;
    };
    const syncHighlightedIndex = $fV3WI.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value hasn't changed
        // If it exists and the value hasn't changed, return, otherwise continue execution
        if (checkHighlightedOptionExists()) return;
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: "reset"
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && $d3410e6df796244e$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $d3410e6df796244e$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: "reset"
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $4lsKM.default)((node)=>{
        (0, $zuYi8.default)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $fV3WI.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $fV3WI.useRef(false);
    const selectNewValue = (event, option, reasonProp = "selectOption", origin = "options")=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = $d3410e6df796244e$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== "freeSolo") {
                newValue.splice(itemIndex, 1);
                reason = "removeOption";
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === "touch" && isTouch.current || blurOnSelect === "mouse" && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === "next" && nextFocus === value.length || direction === "previous" && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute("tabindex") || option.disabled || option.getAttribute("aria-disabled") === "true") nextFocus += direction === "next" ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === "") handleClose(event, "toggleInput");
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === "" && direction === "previous") nextTag = value.length - 1;
        } else {
            nextTag += direction === "next" ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState("");
        if (onInputChange) onInputChange(event, "", "clear");
        handleValue(event, multiple ? [] : null, "clear");
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                "ArrowLeft",
                "ArrowRight"
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case "Home":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "start",
                            direction: "next",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "End":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "end",
                            direction: "previous",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "PageUp":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$d3410e6df796244e$var$pageSize,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "PageDown":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $d3410e6df796244e$var$pageSize,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowDown":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowUp":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowLeft":
                    handleFocusTag(event, "previous");
                    break;
                case "ArrowRight":
                    handleFocusTag(event, "next");
                    break;
                case "Enter":
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, "selectOption");
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== "" && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, "createOption", "freeSolo");
                    }
                    break;
                case "Escape":
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, "escape");
                    } else if (clearOnEscape && (inputValue !== "" || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case "Backspace":
                    if (multiple && !readOnly && inputValue === "" && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                case "Delete":
                    if (multiple && !readOnly && inputValue === "" && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], "blur");
        else if (autoSelect && freeSolo && inputValue !== "") selectNewValue(event, inputValue, "blur", "freeSolo");
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, "blur");
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, "input");
        }
        if (newValue === "") {
            if (!disableClearable && !multiple) handleValue(event, null, "clear");
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: "mouse"
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute("data-option-index")),
            reason: "touch"
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        selectNewValue(event, filteredOptions[index], "selectOption");
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, "removeOption", {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, "toggleInput");
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute("id") !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (inputValue === "" || !open) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $j5tUA.default)({
                "aria-owns": listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                "aria-activedescendant": popupOpen ? "" : null,
                "aria-autocomplete": autoComplete ? "both" : "list",
                "aria-controls": listboxAvailable ? `${id}-listbox` : undefined,
                "aria-expanded": listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: "off",
                ref: inputRef,
                autoCapitalize: "none",
                spellCheck: "false",
                role: "combobox",
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index  })=>(0, $j5tUA.default)({
                key: index,
                "data-tag-index": index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: "listbox",
                id: `${id}-listbox`,
                "aria-labelledby": `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index , option: option  })=>{
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: getOptionLabel(option),
                tabIndex: -1,
                role: "option",
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                "data-option-index": index,
                "aria-disabled": disabled,
                "aria-selected": selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}



var $74s0b = parcelRequire("74s0b");

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $fV3WI = parcelRequire("fV3WI");

var $77gjj = parcelRequire("77gjj");
var $3kcer = parcelRequire("3kcer");
var $eFiOq = parcelRequire("eFiOq");
function $3fab8825950a82f9$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $2ad0ca71d8144d57$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $3fab8825950a82f9$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $2ad0ca71d8144d57$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $3fab8825950a82f9$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $2ad0ca71d8144d57$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $3fab8825950a82f9$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $ef1a6175f73540f2$export$8960430cfd85939f = Math.max;
var $ef1a6175f73540f2$export$96ec731ed4dcb222 = Math.min;
var $ef1a6175f73540f2$export$2077e0241d6afd3c = Math.round;



function $4e6dd1085f84b510$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $cacb7f875e082599$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $4e6dd1085f84b510$export$2e2bcd8739ae039)());
}


function $d7f1ce2dd98de274$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $2ad0ca71d8144d57$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $ef1a6175f73540f2$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $ef1a6175f73540f2$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $2ad0ca71d8144d57$export$45a5e7f76e0caa8d)(element) ? (0, $3fab8825950a82f9$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $cacb7f875e082599$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $8e5f5bdb2e5a0dbf$export$2e2bcd8739ae039(node) {
    var win = (0, $3fab8825950a82f9$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $7bc362a6ddbf8905$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $3eccb0cf2ae9222d$export$2e2bcd8739ae039(node) {
    if (node === (0, $3fab8825950a82f9$export$2e2bcd8739ae039)(node) || !(0, $2ad0ca71d8144d57$export$1b3bfaa9684536aa)(node)) return (0, $8e5f5bdb2e5a0dbf$export$2e2bcd8739ae039)(node);
    else return (0, $7bc362a6ddbf8905$export$2e2bcd8739ae039)(node);
}


function $abcc2eeb0c72745a$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $dbc0ac6780c0a49e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $2ad0ca71d8144d57$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $f4d6486e843923dd$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $d7f1ce2dd98de274$export$2e2bcd8739ae039)((0, $dbc0ac6780c0a49e$export$2e2bcd8739ae039)(element)).left + (0, $8e5f5bdb2e5a0dbf$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $d23be08f9d4cadce$export$2e2bcd8739ae039(element) {
    return (0, $3fab8825950a82f9$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $5f8f2d4e24df1fd1$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $d23be08f9d4cadce$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $8b8d48b87cd982ed$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $ef1a6175f73540f2$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $ef1a6175f73540f2$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $8b8d48b87cd982ed$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $2ad0ca71d8144d57$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $2ad0ca71d8144d57$export$1b3bfaa9684536aa)(offsetParent) && $8b8d48b87cd982ed$var$isElementScaled(offsetParent);
    var documentElement = (0, $dbc0ac6780c0a49e$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $d7f1ce2dd98de274$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $abcc2eeb0c72745a$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $5f8f2d4e24df1fd1$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $3eccb0cf2ae9222d$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $2ad0ca71d8144d57$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $d7f1ce2dd98de274$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $f4d6486e843923dd$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $4d50cfbddb2e4e31$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $d7f1ce2dd98de274$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $ad39cdb4dc444143$export$2e2bcd8739ae039(element) {
    if ((0, $abcc2eeb0c72745a$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $2ad0ca71d8144d57$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $dbc0ac6780c0a49e$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $b44baac7832998c0$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $abcc2eeb0c72745a$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $2ad0ca71d8144d57$export$1b3bfaa9684536aa)(node) && (0, $5f8f2d4e24df1fd1$export$2e2bcd8739ae039)(node)) return node;
    return $b44baac7832998c0$export$2e2bcd8739ae039((0, $ad39cdb4dc444143$export$2e2bcd8739ae039)(node));
}





function $c3af30cb88ace6ad$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $b44baac7832998c0$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $3fab8825950a82f9$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $5f8f2d4e24df1fd1$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($c3af30cb88ace6ad$export$2e2bcd8739ae039((0, $ad39cdb4dc444143$export$2e2bcd8739ae039)(target)));
}







function $ae5ee0a07cf4bc4f$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $abcc2eeb0c72745a$export$2e2bcd8739ae039)(element)) >= 0;
}




function $beeb6a73391eb701$var$getTrueOffsetParent(element) {
    if (!(0, $2ad0ca71d8144d57$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $d23be08f9d4cadce$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $beeb6a73391eb701$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $4e6dd1085f84b510$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $4e6dd1085f84b510$export$2e2bcd8739ae039)());
    if (isIE && (0, $2ad0ca71d8144d57$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $d23be08f9d4cadce$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $ad39cdb4dc444143$export$2e2bcd8739ae039)(element);
    if ((0, $2ad0ca71d8144d57$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $2ad0ca71d8144d57$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $abcc2eeb0c72745a$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $d23be08f9d4cadce$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $beeb6a73391eb701$export$2e2bcd8739ae039(element) {
    var window = (0, $3fab8825950a82f9$export$2e2bcd8739ae039)(element);
    var offsetParent = $beeb6a73391eb701$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $ae5ee0a07cf4bc4f$export$2e2bcd8739ae039)(offsetParent) && (0, $d23be08f9d4cadce$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $beeb6a73391eb701$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $abcc2eeb0c72745a$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $abcc2eeb0c72745a$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $d23be08f9d4cadce$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $beeb6a73391eb701$var$getContainingBlock(element) || window;
}


var $ffa55223754ae635$export$1e95b668f3b82d = "top";
var $ffa55223754ae635$export$40e543e69a8b3fbb = "bottom";
var $ffa55223754ae635$export$79ffe56a765070d2 = "right";
var $ffa55223754ae635$export$eabcd2c8791e7bf4 = "left";
var $ffa55223754ae635$export$dfb5619354ba860 = "auto";
var $ffa55223754ae635$export$aec2ce47c367b8c3 = [
    $ffa55223754ae635$export$1e95b668f3b82d,
    $ffa55223754ae635$export$40e543e69a8b3fbb,
    $ffa55223754ae635$export$79ffe56a765070d2,
    $ffa55223754ae635$export$eabcd2c8791e7bf4
];
var $ffa55223754ae635$export$b3571188c770cc5a = "start";
var $ffa55223754ae635$export$bd5df0f255a350f8 = "end";
var $ffa55223754ae635$export$390fd549c5303b4d = "clippingParents";
var $ffa55223754ae635$export$d7b7311ec04a3e8f = "viewport";
var $ffa55223754ae635$export$ae5ab1c730825774 = "popper";
var $ffa55223754ae635$export$ca50aac9f3ba507f = "reference";
var $ffa55223754ae635$export$368f9a87e87fa4e1 = /*#__PURE__*/ $ffa55223754ae635$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $ffa55223754ae635$export$b3571188c770cc5a,
        placement + "-" + $ffa55223754ae635$export$bd5df0f255a350f8
    ]);
}, []);
var $ffa55223754ae635$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($ffa55223754ae635$export$aec2ce47c367b8c3, [
    $ffa55223754ae635$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $ffa55223754ae635$export$b3571188c770cc5a,
        placement + "-" + $ffa55223754ae635$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $ffa55223754ae635$export$421679a7c3d56e = "beforeRead";
var $ffa55223754ae635$export$aafa59e2e03f2942 = "read";
var $ffa55223754ae635$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $ffa55223754ae635$export$c65e99957a05207c = "beforeMain";
var $ffa55223754ae635$export$f22da7240b7add18 = "main";
var $ffa55223754ae635$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $ffa55223754ae635$export$8d4d2d70e7d46032 = "beforeWrite";
var $ffa55223754ae635$export$68d8715fc104d294 = "write";
var $ffa55223754ae635$export$70a6e5159acce2e6 = "afterWrite";
var $ffa55223754ae635$export$d087d3878fdf71d5 = [
    $ffa55223754ae635$export$421679a7c3d56e,
    $ffa55223754ae635$export$aafa59e2e03f2942,
    $ffa55223754ae635$export$6964f6c886723980,
    $ffa55223754ae635$export$c65e99957a05207c,
    $ffa55223754ae635$export$f22da7240b7add18,
    $ffa55223754ae635$export$bab79516f2d662fe,
    $ffa55223754ae635$export$8d4d2d70e7d46032,
    $ffa55223754ae635$export$68d8715fc104d294,
    $ffa55223754ae635$export$70a6e5159acce2e6
];


function $e03fb162863657a3$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $e03fb162863657a3$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $e03fb162863657a3$var$order(modifiers); // order based on phase
    return (0, $ffa55223754ae635$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $23362197c8253d55$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $951a62127feb61db$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $5d3dcd762d7d6cfd$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $5d3dcd762d7d6cfd$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $5d3dcd762d7d6cfd$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $5d3dcd762d7d6cfd$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $5d3dcd762d7d6cfd$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $2ad0ca71d8144d57$export$45a5e7f76e0caa8d)(reference) ? (0, $c3af30cb88ace6ad$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $c3af30cb88ace6ad$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $c3af30cb88ace6ad$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $e03fb162863657a3$export$2e2bcd8739ae039)((0, $951a62127feb61db$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$5d3dcd762d7d6cfd$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $8b8d48b87cd982ed$export$2e2bcd8739ae039)(reference, (0, $beeb6a73391eb701$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $4d50cfbddb2e4e31$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $23362197c8253d55$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$5d3dcd762d7d6cfd$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $5d3dcd762d7d6cfd$export$8f7491d57c8f97a9 = /*#__PURE__*/ $5d3dcd762d7d6cfd$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $cb0cb9a0a562e4dc$var$passive = {
    passive: true
};
function $cb0cb9a0a562e4dc$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $3fab8825950a82f9$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $cb0cb9a0a562e4dc$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $cb0cb9a0a562e4dc$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $cb0cb9a0a562e4dc$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $cb0cb9a0a562e4dc$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $cb0cb9a0a562e4dc$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $cb0cb9a0a562e4dc$var$effect,
    data: {}
};



function $a4625d03b19ae5ca$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $f26654f0ab903c84$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $8535f32a0f39d1b4$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $d929bacada38af1f$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $a4625d03b19ae5ca$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $f26654f0ab903c84$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $ffa55223754ae635$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $ffa55223754ae635$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $ffa55223754ae635$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $ffa55223754ae635$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $8535f32a0f39d1b4$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $ffa55223754ae635$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $ffa55223754ae635$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $0e0a73c3e62d9a8c$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $d929bacada38af1f$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $0e0a73c3e62d9a8c$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $0e0a73c3e62d9a8c$var$popperOffsets,
    data: {}
};










var $ae65f833e15cf48b$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $ae65f833e15cf48b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $ef1a6175f73540f2$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $ef1a6175f73540f2$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $ae65f833e15cf48b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $ffa55223754ae635$export$eabcd2c8791e7bf4);
    var sideY = (0, $ffa55223754ae635$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $beeb6a73391eb701$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $3fab8825950a82f9$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $dbc0ac6780c0a49e$export$2e2bcd8739ae039)(popper);
            if ((0, $d23be08f9d4cadce$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $ffa55223754ae635$export$1e95b668f3b82d) || (placement === (0, $ffa55223754ae635$export$eabcd2c8791e7bf4) || placement === (0, $ffa55223754ae635$export$79ffe56a765070d2)) && variation === (0, $ffa55223754ae635$export$bd5df0f255a350f8)) {
            sideY = (0, $ffa55223754ae635$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $ffa55223754ae635$export$eabcd2c8791e7bf4) || (placement === (0, $ffa55223754ae635$export$1e95b668f3b82d) || placement === (0, $ffa55223754ae635$export$40e543e69a8b3fbb)) && variation === (0, $ffa55223754ae635$export$bd5df0f255a350f8)) {
            sideX = (0, $ffa55223754ae635$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $ae65f833e15cf48b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $ae65f833e15cf48b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $3fab8825950a82f9$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $ae65f833e15cf48b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $a4625d03b19ae5ca$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $f26654f0ab903c84$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $ae65f833e15cf48b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $ae65f833e15cf48b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ae65f833e15cf48b$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $ae65f833e15cf48b$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $636954caa4439824$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $2ad0ca71d8144d57$export$1b3bfaa9684536aa)(element) || !(0, $abcc2eeb0c72745a$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $636954caa4439824$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $2ad0ca71d8144d57$export$1b3bfaa9684536aa)(element) || !(0, $abcc2eeb0c72745a$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $636954caa4439824$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $636954caa4439824$var$applyStyles,
    effect: $636954caa4439824$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $d6e3d775eff64678$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $a4625d03b19ae5ca$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $ffa55223754ae635$export$eabcd2c8791e7bf4),
        (0, $ffa55223754ae635$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $ffa55223754ae635$export$eabcd2c8791e7bf4),
        (0, $ffa55223754ae635$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $d6e3d775eff64678$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $ffa55223754ae635$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $d6e3d775eff64678$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $d6e3d775eff64678$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $d6e3d775eff64678$var$offset
};


var $c7a612ae10d4bb72$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $c7a612ae10d4bb72$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $c7a612ae10d4bb72$var$hash[matched];
    });
}



var $589cd792e8b2f994$var$hash = {
    start: "end",
    end: "start"
};
function $589cd792e8b2f994$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $589cd792e8b2f994$var$hash[matched];
    });
}







function $049e5cdef59c3d92$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $3fab8825950a82f9$export$2e2bcd8739ae039)(element);
    var html = (0, $dbc0ac6780c0a49e$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $cacb7f875e082599$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $f4d6486e843923dd$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $1c3e18d2c7ffed13$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $dbc0ac6780c0a49e$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $8e5f5bdb2e5a0dbf$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $ef1a6175f73540f2$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $ef1a6175f73540f2$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $f4d6486e843923dd$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $d23be08f9d4cadce$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $ef1a6175f73540f2$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $9ea7f4bf1accadc7$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $2ad0ca71d8144d57$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $7abb0b89677ad6d1$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $149adb1babd65d24$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $d7f1ce2dd98de274$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $149adb1babd65d24$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $ffa55223754ae635$export$d7b7311ec04a3e8f) ? (0, $7abb0b89677ad6d1$export$2e2bcd8739ae039)((0, $049e5cdef59c3d92$export$2e2bcd8739ae039)(element, strategy)) : (0, $2ad0ca71d8144d57$export$45a5e7f76e0caa8d)(clippingParent) ? $149adb1babd65d24$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $7abb0b89677ad6d1$export$2e2bcd8739ae039)((0, $1c3e18d2c7ffed13$export$2e2bcd8739ae039)((0, $dbc0ac6780c0a49e$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $149adb1babd65d24$var$getClippingParents(element) {
    var clippingParents = (0, $c3af30cb88ace6ad$export$2e2bcd8739ae039)((0, $ad39cdb4dc444143$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $d23be08f9d4cadce$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $2ad0ca71d8144d57$export$1b3bfaa9684536aa)(element) ? (0, $beeb6a73391eb701$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $2ad0ca71d8144d57$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $2ad0ca71d8144d57$export$45a5e7f76e0caa8d)(clippingParent) && (0, $9ea7f4bf1accadc7$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $abcc2eeb0c72745a$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $149adb1babd65d24$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $149adb1babd65d24$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $149adb1babd65d24$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $ef1a6175f73540f2$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $ef1a6175f73540f2$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $ef1a6175f73540f2$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $ef1a6175f73540f2$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $149adb1babd65d24$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $8cb1bb6384c9727d$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $f3ffb31ac17d556b$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $8cb1bb6384c9727d$export$2e2bcd8739ae039)(), paddingObject);
}


function $a6eb5d436f07b7ad$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $0b1d5bfb60272093$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $ffa55223754ae635$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $ffa55223754ae635$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $ffa55223754ae635$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $f3ffb31ac17d556b$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $a6eb5d436f07b7ad$export$2e2bcd8739ae039)(padding, (0, $ffa55223754ae635$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $ffa55223754ae635$export$ae5ab1c730825774) ? (0, $ffa55223754ae635$export$ca50aac9f3ba507f) : (0, $ffa55223754ae635$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $149adb1babd65d24$export$2e2bcd8739ae039)((0, $2ad0ca71d8144d57$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $dbc0ac6780c0a49e$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $d7f1ce2dd98de274$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $d929bacada38af1f$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $7abb0b89677ad6d1$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $ffa55223754ae635$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $ffa55223754ae635$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $ffa55223754ae635$export$79ffe56a765070d2),
                (0, $ffa55223754ae635$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $ffa55223754ae635$export$1e95b668f3b82d),
                (0, $ffa55223754ae635$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $43480a6296884c0d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $ffa55223754ae635$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $f26654f0ab903c84$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $ffa55223754ae635$export$368f9a87e87fa4e1) : (0, $ffa55223754ae635$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $f26654f0ab903c84$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $ffa55223754ae635$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $0b1d5bfb60272093$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $a4625d03b19ae5ca$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $6a47d6081333c260$var$getExpandedFallbackPlacements(placement) {
    if ((0, $a4625d03b19ae5ca$export$2e2bcd8739ae039)(placement) === (0, $ffa55223754ae635$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $c7a612ae10d4bb72$export$2e2bcd8739ae039)(placement);
    return [
        (0, $589cd792e8b2f994$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $589cd792e8b2f994$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $6a47d6081333c260$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $a4625d03b19ae5ca$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $c7a612ae10d4bb72$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $6a47d6081333c260$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $a4625d03b19ae5ca$export$2e2bcd8739ae039)(placement) === (0, $ffa55223754ae635$export$dfb5619354ba860) ? (0, $43480a6296884c0d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $a4625d03b19ae5ca$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $f26654f0ab903c84$export$2e2bcd8739ae039)(placement) === (0, $ffa55223754ae635$export$b3571188c770cc5a);
        var isVertical = [
            (0, $ffa55223754ae635$export$1e95b668f3b82d),
            (0, $ffa55223754ae635$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $0b1d5bfb60272093$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $ffa55223754ae635$export$79ffe56a765070d2) : (0, $ffa55223754ae635$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $ffa55223754ae635$export$40e543e69a8b3fbb) : (0, $ffa55223754ae635$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $c7a612ae10d4bb72$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $c7a612ae10d4bb72$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $6a47d6081333c260$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $6a47d6081333c260$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $4103095e48312e72$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $41341b3155daaccd$export$f28d906d67a997f3(min, value, max) {
    return (0, $ef1a6175f73540f2$export$8960430cfd85939f)(min, (0, $ef1a6175f73540f2$export$96ec731ed4dcb222)(value, max));
}
function $41341b3155daaccd$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $41341b3155daaccd$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $8428b54b8622878a$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $0b1d5bfb60272093$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $a4625d03b19ae5ca$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $f26654f0ab903c84$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $8535f32a0f39d1b4$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $4103095e48312e72$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $ffa55223754ae635$export$1e95b668f3b82d) : (0, $ffa55223754ae635$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $ffa55223754ae635$export$40e543e69a8b3fbb) : (0, $ffa55223754ae635$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $ffa55223754ae635$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $ffa55223754ae635$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $4d50cfbddb2e4e31$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $8cb1bb6384c9727d$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $41341b3155daaccd$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $beeb6a73391eb701$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $41341b3155daaccd$export$f28d906d67a997f3)(tether ? (0, $ef1a6175f73540f2$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $ef1a6175f73540f2$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $ffa55223754ae635$export$1e95b668f3b82d) : (0, $ffa55223754ae635$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $ffa55223754ae635$export$40e543e69a8b3fbb) : (0, $ffa55223754ae635$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $ffa55223754ae635$export$1e95b668f3b82d),
            (0, $ffa55223754ae635$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $41341b3155daaccd$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $41341b3155daaccd$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8428b54b8622878a$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $8428b54b8622878a$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $17afcc5767508b5f$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $f3ffb31ac17d556b$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $a6eb5d436f07b7ad$export$2e2bcd8739ae039)(padding, (0, $ffa55223754ae635$export$aec2ce47c367b8c3)));
};
function $17afcc5767508b5f$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $a4625d03b19ae5ca$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $8535f32a0f39d1b4$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $ffa55223754ae635$export$eabcd2c8791e7bf4),
        (0, $ffa55223754ae635$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $17afcc5767508b5f$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $4d50cfbddb2e4e31$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $ffa55223754ae635$export$1e95b668f3b82d) : (0, $ffa55223754ae635$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $ffa55223754ae635$export$40e543e69a8b3fbb) : (0, $ffa55223754ae635$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $beeb6a73391eb701$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $41341b3155daaccd$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $17afcc5767508b5f$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $9ea7f4bf1accadc7$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $17afcc5767508b5f$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $17afcc5767508b5f$var$arrow,
    effect: $17afcc5767508b5f$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $e74f2e8fd3ec3fb5$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $e74f2e8fd3ec3fb5$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $ffa55223754ae635$export$1e95b668f3b82d),
        (0, $ffa55223754ae635$export$79ffe56a765070d2),
        (0, $ffa55223754ae635$export$40e543e69a8b3fbb),
        (0, $ffa55223754ae635$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $e74f2e8fd3ec3fb5$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $0b1d5bfb60272093$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $0b1d5bfb60272093$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $e74f2e8fd3ec3fb5$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $e74f2e8fd3ec3fb5$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $e74f2e8fd3ec3fb5$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $e74f2e8fd3ec3fb5$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $e74f2e8fd3ec3fb5$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $e74f2e8fd3ec3fb5$var$hide
};




var $a265b5cd2fdfe0d4$export$d34966752335dd47 = [
    (0, $cb0cb9a0a562e4dc$export$2e2bcd8739ae039),
    (0, $0e0a73c3e62d9a8c$export$2e2bcd8739ae039),
    (0, $ae65f833e15cf48b$export$2e2bcd8739ae039),
    (0, $636954caa4439824$export$2e2bcd8739ae039),
    (0, $d6e3d775eff64678$export$2e2bcd8739ae039),
    (0, $6a47d6081333c260$export$2e2bcd8739ae039),
    (0, $8428b54b8622878a$export$2e2bcd8739ae039),
    (0, $17afcc5767508b5f$export$2e2bcd8739ae039),
    (0, $e74f2e8fd3ec3fb5$export$2e2bcd8739ae039)
];
var $a265b5cd2fdfe0d4$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $5d3dcd762d7d6cfd$export$ed5e13716264f202)({
    defaultModifiers: $a265b5cd2fdfe0d4$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $js0sS = parcelRequire("js0sS");

var $7tRYJ = parcelRequire("7tRYJ");

var $auxfn = parcelRequire("auxfn");

var $dxVxC = parcelRequire("dxVxC");
function $af457c5c1811a8e0$export$1b69b6cd0fa638a1(slot) {
    return (0, $auxfn.default)("MuiPopper", slot);
}
const $af457c5c1811a8e0$var$popperClasses = (0, $dxVxC.default)("MuiPopper", [
    "root"
]);
var $af457c5c1811a8e0$export$2e2bcd8739ae039 = $af457c5c1811a8e0$var$popperClasses;



var $4NVxb = parcelRequire("4NVxb");

var $eyzqE = parcelRequire("eyzqE");

var $3DnwL = parcelRequire("3DnwL");
const $3276fb1d036e9d89$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $3276fb1d036e9d89$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $3276fb1d036e9d89$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $3276fb1d036e9d89$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function $3276fb1d036e9d89$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $3276fb1d036e9d89$var$isVirtualElement(element) {
    return !$3276fb1d036e9d89$var$isHTMLElement(element);
}
const $3276fb1d036e9d89$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $eyzqE.useClassNamesOverride)((0, $af457c5c1811a8e0$export$1b69b6cd0fa638a1)));
};
const $3276fb1d036e9d89$var$defaultPopperOptions = {};
const $3276fb1d036e9d89$var$PopperTooltip = /*#__PURE__*/ $fV3WI.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl , children: children , direction: direction , disablePortal: disablePortal , modifiers: modifiers , open: open , placement: initialPlacement , popperOptions: popperOptions , popperRef: popperRefProp , slotProps: slotProps = {} , slots: slots = {} , TransitionProps: TransitionProps  } = props, other = (0, $64S8Y.default)(props, $3276fb1d036e9d89$var$_excluded);
    const tooltipRef = $fV3WI.useRef(null);
    const ownRef = (0, $eFiOq.default)(tooltipRef, forwardedRef);
    const popperRef = $fV3WI.useRef(null);
    const handlePopperRef = (0, $eFiOq.default)(popperRef, popperRefProp);
    const handlePopperRefRef = $fV3WI.useRef(handlePopperRef);
    (0, $3kcer.default)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $fV3WI.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $3276fb1d036e9d89$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $fV3WI.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $fV3WI.useState($3276fb1d036e9d89$var$resolveAnchorEl(anchorEl));
    $fV3WI.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $fV3WI.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($3276fb1d036e9d89$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $3kcer.default)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state  })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $a265b5cd2fdfe0d4$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $j5tUA.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $3276fb1d036e9d89$var$useUtilityClasses();
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $4NVxb.default)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $3DnwL.jsx)(Root, (0, $j5tUA.default)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base/react-popper/components-api/#popper)
 */ const $3276fb1d036e9d89$var$Popper = /*#__PURE__*/ $fV3WI.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl , children: children , container: containerProp , direction: direction = "ltr" , disablePortal: disablePortal = false , keepMounted: keepMounted = false , modifiers: modifiers , open: open , placement: placement = "bottom" , popperOptions: popperOptions = $3276fb1d036e9d89$var$defaultPopperOptions , popperRef: popperRef , style: style , transition: transition = false , slotProps: slotProps = {} , slots: slots = {}  } = props, other = (0, $64S8Y.default)(props, $3276fb1d036e9d89$var$_excluded2);
    const [exited, setExited] = $fV3WI.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $3276fb1d036e9d89$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $3276fb1d036e9d89$var$isHTMLElement(resolvedAnchorEl) ? (0, $77gjj.default)(resolvedAnchorEl).body : (0, $77gjj.default)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $3DnwL.jsx)((0, $7tRYJ.default), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $3DnwL.jsx)($3276fb1d036e9d89$var$PopperTooltip, (0, $j5tUA.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $j5tUA.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
var $3276fb1d036e9d89$export$2e2bcd8739ae039 = $3276fb1d036e9d89$var$Popper;



var $3UagE = parcelRequire("3UagE");



var $fV3WI = parcelRequire("fV3WI");

var $aF4Kv = parcelRequire("aF4Kv");
var $05gnM = parcelRequire("05gnM");

var $3DnwL = parcelRequire("3DnwL");
const $31179200a20bcecf$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $31179200a20bcecf$var$PopperRoot = (0, $aF4Kv.default)((0, $3276fb1d036e9d89$export$2e2bcd8739ae039), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $31179200a20bcecf$var$Popper = /*#__PURE__*/ $fV3WI.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, $3UagE.default)();
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl: anchorEl , component: component , components: components , componentsProps: componentsProps , container: container , disablePortal: disablePortal , keepMounted: keepMounted , modifiers: modifiers , open: open , placement: placement , popperOptions: popperOptions , popperRef: popperRef , transition: transition , slots: slots , slotProps: slotProps  } = props, other = (0, $64S8Y.default)(props, $31179200a20bcecf$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $j5tUA.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $3DnwL.jsx)($31179200a20bcecf$var$PopperRoot, (0, $j5tUA.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $31179200a20bcecf$export$2e2bcd8739ae039 = $31179200a20bcecf$var$Popper;



var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $js0sS = parcelRequire("js0sS");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");

var $ZXS89 = parcelRequire("ZXS89");

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $be9273f7c38b6d4e$export$6816d4fc0981ec7(slot) {
    return (0, $auxfn.default)("MuiListSubheader", slot);
}
const $be9273f7c38b6d4e$var$listSubheaderClasses = (0, $dxVxC.default)("MuiListSubheader", [
    "root",
    "colorPrimary",
    "colorInherit",
    "gutters",
    "inset",
    "sticky"
]);
var $be9273f7c38b6d4e$export$2e2bcd8739ae039 = $be9273f7c38b6d4e$var$listSubheaderClasses;



var $3DnwL = parcelRequire("3DnwL");
const $5d8a90dd53907051$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $5d8a90dd53907051$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , color: color , disableGutters: disableGutters , inset: inset , disableSticky: disableSticky  } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "default" && `color${(0, $ZXS89.default)(color)}`,
            !disableGutters && "gutters",
            inset && "inset",
            !disableSticky && "sticky"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $be9273f7c38b6d4e$export$6816d4fc0981ec7), classes);
};
const $5d8a90dd53907051$var$ListSubheaderRoot = (0, $aF4Kv.default)("li", {
    name: "MuiListSubheader",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $ZXS89.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({
        boxSizing: "border-box",
        lineHeight: "48px",
        listStyle: "none",
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === "primary" && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: "sticky",
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $5d8a90dd53907051$var$ListSubheader = /*#__PURE__*/ $fV3WI.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiListSubheader"
    });
    const { className: className , color: color = "default" , component: component = "li" , disableGutters: disableGutters = false , disableSticky: disableSticky = false , inset: inset = false  } = props, other = (0, $64S8Y.default)(props, $5d8a90dd53907051$var$_excluded);
    const ownerState = (0, $j5tUA.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $5d8a90dd53907051$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3DnwL.jsx)($5d8a90dd53907051$var$ListSubheaderRoot, (0, $j5tUA.default)({
        as: component,
        className: (0, $h0s6D.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$5d8a90dd53907051$var$ListSubheader.muiSkipListHighlight = true;
var $5d8a90dd53907051$export$2e2bcd8739ae039 = $5d8a90dd53907051$var$ListSubheader;



var $eKfJS = parcelRequire("eKfJS");


var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $js0sS = parcelRequire("js0sS");

var $74s0b = parcelRequire("74s0b");
parcelRequire("fV3WI");

var $iEw4v = parcelRequire("iEw4v");

var $3DnwL = parcelRequire("3DnwL");
var $c1769e94e891ab16$export$2e2bcd8739ae039 = (0, $iEw4v.default)(/*#__PURE__*/ (0, $3DnwL.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");



var $czyq6 = parcelRequire("czyq6");


var $ZXS89 = parcelRequire("ZXS89");

var $gScpF = parcelRequire("gScpF");

var $05gnM = parcelRequire("05gnM");

var $aF4Kv = parcelRequire("aF4Kv");

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $a736117d0b20e1f6$export$31444911e4ee6fdd(slot) {
    return (0, $auxfn.default)("MuiChip", slot);
}
const $a736117d0b20e1f6$var$chipClasses = (0, $dxVxC.default)("MuiChip", [
    "root",
    "sizeSmall",
    "sizeMedium",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "disabled",
    "clickable",
    "clickableColorPrimary",
    "clickableColorSecondary",
    "deletable",
    "deletableColorPrimary",
    "deletableColorSecondary",
    "outlined",
    "filled",
    "outlinedPrimary",
    "outlinedSecondary",
    "filledPrimary",
    "filledSecondary",
    "avatar",
    "avatarSmall",
    "avatarMedium",
    "avatarColorPrimary",
    "avatarColorSecondary",
    "icon",
    "iconSmall",
    "iconMedium",
    "iconColorPrimary",
    "iconColorSecondary",
    "label",
    "labelSmall",
    "labelMedium",
    "deleteIcon",
    "deleteIconSmall",
    "deleteIconMedium",
    "deleteIconColorPrimary",
    "deleteIconColorSecondary",
    "deleteIconOutlinedColorPrimary",
    "deleteIconOutlinedColorSecondary",
    "deleteIconFilledColorPrimary",
    "deleteIconFilledColorSecondary",
    "focusVisible"
]);
var $a736117d0b20e1f6$export$2e2bcd8739ae039 = $a736117d0b20e1f6$var$chipClasses;



var $3DnwL = parcelRequire("3DnwL");
const $e0ce19c7048b5103$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $e0ce19c7048b5103$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disabled: disabled , size: size , color: color , iconColor: iconColor , onDelete: onDelete , clickable: clickable , variant: variant  } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            disabled && "disabled",
            `size${(0, $ZXS89.default)(size)}`,
            `color${(0, $ZXS89.default)(color)}`,
            clickable && "clickable",
            clickable && `clickableColor${(0, $ZXS89.default)(color)}`,
            onDelete && "deletable",
            onDelete && `deletableColor${(0, $ZXS89.default)(color)}`,
            `${variant}${(0, $ZXS89.default)(color)}`
        ],
        label: [
            "label",
            `label${(0, $ZXS89.default)(size)}`
        ],
        avatar: [
            "avatar",
            `avatar${(0, $ZXS89.default)(size)}`,
            `avatarColor${(0, $ZXS89.default)(color)}`
        ],
        icon: [
            "icon",
            `icon${(0, $ZXS89.default)(size)}`,
            `iconColor${(0, $ZXS89.default)(iconColor)}`
        ],
        deleteIcon: [
            "deleteIcon",
            `deleteIcon${(0, $ZXS89.default)(size)}`,
            `deleteIconColor${(0, $ZXS89.default)(color)}`,
            `deleteIcon${(0, $ZXS89.default)(variant)}Color${(0, $ZXS89.default)(color)}`
        ]
    };
    return (0, $js0sS.default)(slots, (0, $a736117d0b20e1f6$export$31444911e4ee6fdd), classes);
};
const $e0ce19c7048b5103$var$ChipRoot = (0, $aF4Kv.default)("div", {
    name: "MuiChip",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        const { color: color , iconColor: iconColor , clickable: clickable , onDelete: onDelete , size: size , variant: variant  } = ownerState;
        return [
            {
                [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $ZXS89.default)(size)}`]
            },
            {
                [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $ZXS89.default)(color)}`]
            },
            {
                [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $ZXS89.default)(size)}`]
            },
            {
                [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $ZXS89.default)(iconColor)}`]
            },
            {
                [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $ZXS89.default)(size)}`]
            },
            {
                [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $ZXS89.default)(color)}`]
            },
            {
                [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $ZXS89.default)(variant)}Color${(0, $ZXS89.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $ZXS89.default)(size)}`],
            styles[`color${(0, $ZXS89.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== "default" && styles[`clickableColor${(0, $ZXS89.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== "default" && styles[`deletableColor${(0, $ZXS89.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $ZXS89.default)(color)}`]
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>{
    const textColor = theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $j5tUA.default)({
        maxWidth: "100%",
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: "nowrap",
        transition: theme.transitions.create([
            "background-color",
            "box-shadow"
        ]),
        // label will inherit this from root, then `clickable` class overrides this for both
        cursor: "default",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: "none",
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: "middle",
        boxSizing: "border-box",
        [`&.${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: "none"
        },
        [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).icon}`]: (0, $j5tUA.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === "small" && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $j5tUA.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== "default" && {
            color: "inherit"
        })),
        [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).deleteIcon}`]: (0, $j5tUA.default)({
            WebkitTapHighlightColor: "transparent",
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $74s0b.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: "pointer",
            margin: "0 5px 0 -6px",
            "&:hover": {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $74s0b.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === "small" && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== "default" && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $74s0b.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === "small" && {
        height: 24
    }, ownerState.color !== "default" && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $74s0b.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== "default" && {
        [`&.${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({}, ownerState.clickable && {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $74s0b.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $74s0b.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        "&:active": {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== "default" && {
        [`&:hover, &.${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({}, ownerState.variant === "outlined" && {
        backgroundColor: "transparent",
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === "outlined" && ownerState.color !== "default" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $74s0b.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $74s0b.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $74s0b.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $a736117d0b20e1f6$export$2e2bcd8739ae039).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $74s0b.alpha)(theme.palette[ownerState.color].main, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $e0ce19c7048b5103$var$ChipLabel = (0, $aF4Kv.default)("span", {
    name: "MuiChip",
    slot: "Label",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        const { size: size  } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $ZXS89.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState  })=>(0, $j5tUA.default)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: "nowrap"
    }, ownerState.size === "small" && {
        paddingLeft: 8,
        paddingRight: 8
    }));
function $e0ce19c7048b5103$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $e0ce19c7048b5103$var$Chip = /*#__PURE__*/ $fV3WI.forwardRef(function Chip(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiChip"
    });
    const { avatar: avatarProp , className: className , clickable: clickableProp , color: color = "default" , component: ComponentProp , deleteIcon: deleteIconProp , disabled: disabled = false , icon: iconProp , label: label , onClick: onClick , onDelete: onDelete , onKeyDown: onKeyDown , onKeyUp: onKeyUp , size: size = "medium" , variant: variant = "filled" , tabIndex: tabIndex , skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
      } = props, other = (0, $64S8Y.default)(props, $e0ce19c7048b5103$var$_excluded);
    const chipRef = $fV3WI.useRef(null);
    const handleRef = (0, $czyq6.default)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $e0ce19c7048b5103$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $e0ce19c7048b5103$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === "Escape" && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $gScpF.default) : ComponentProp || "div";
    const ownerState = (0, $j5tUA.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $fV3WI.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $e0ce19c7048b5103$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $gScpF.default) ? (0, $j5tUA.default)({
        component: ComponentProp || "div",
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $fV3WI.isValidElement(deleteIconProp) ? /*#__PURE__*/ $fV3WI.cloneElement(deleteIconProp, {
        className: (0, $h0s6D.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $3DnwL.jsx)((0, $c1769e94e891ab16$export$2e2bcd8739ae039), {
        className: (0, $h0s6D.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $fV3WI.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $fV3WI.cloneElement(avatarProp, {
        className: (0, $h0s6D.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $fV3WI.isValidElement(iconProp)) icon = /*#__PURE__*/ $fV3WI.cloneElement(iconProp, {
        className: (0, $h0s6D.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $3DnwL.jsxs)($e0ce19c7048b5103$var$ChipRoot, (0, $j5tUA.default)({
        as: component,
        className: (0, $h0s6D.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $3DnwL.jsx)($e0ce19c7048b5103$var$ChipLabel, {
                className: (0, $h0s6D.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $e0ce19c7048b5103$export$2e2bcd8739ae039 = $e0ce19c7048b5103$var$Chip;



var $eMZla = parcelRequire("eMZla");

var $bm0ya = parcelRequire("bm0ya");

var $7uK9m = parcelRequire("7uK9m");

var $6DfYo = parcelRequire("6DfYo");
parcelRequire("fV3WI");

var $iEw4v = parcelRequire("iEw4v");

var $3DnwL = parcelRequire("3DnwL");
var $702cdf9d2dcbcbc0$export$2e2bcd8739ae039 = (0, $iEw4v.default)(/*#__PURE__*/ (0, $3DnwL.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");



var $1yAKJ = parcelRequire("1yAKJ");

var $05gnM = parcelRequire("05gnM");

var $aF4Kv = parcelRequire("aF4Kv");

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $a58aa58b12fc1e79$export$8ee01529667e66d9(slot) {
    return (0, $auxfn.default)("MuiAutocomplete", slot);
}
const $a58aa58b12fc1e79$var$autocompleteClasses = (0, $dxVxC.default)("MuiAutocomplete", [
    "root",
    "expanded",
    "fullWidth",
    "focused",
    "focusVisible",
    "tag",
    "tagSizeSmall",
    "tagSizeMedium",
    "hasPopupIcon",
    "hasClearIcon",
    "inputRoot",
    "input",
    "inputFocused",
    "endAdornment",
    "clearIndicator",
    "popupIndicator",
    "popupIndicatorOpen",
    "popper",
    "popperDisablePortal",
    "paper",
    "listbox",
    "loading",
    "noOptions",
    "option",
    "groupLabel",
    "groupUl"
]);
var $a58aa58b12fc1e79$export$2e2bcd8739ae039 = $a58aa58b12fc1e79$var$autocompleteClasses;



var $ZXS89 = parcelRequire("ZXS89");

var $czyq6 = parcelRequire("czyq6");

var $3DnwL = parcelRequire("3DnwL");
var $f552d147b67b6cf0$var$_ClearIcon, $f552d147b67b6cf0$var$_ArrowDropDownIcon;
const $f552d147b67b6cf0$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "slotProps",
    "value"
], $f552d147b67b6cf0$var$_excluded2 = [
    "ref"
];
const $f552d147b67b6cf0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disablePortal: disablePortal , expanded: expanded , focused: focused , fullWidth: fullWidth , hasClearIcon: hasClearIcon , hasPopupIcon: hasPopupIcon , inputFocused: inputFocused , popupOpen: popupOpen , size: size  } = ownerState;
    const slots = {
        root: [
            "root",
            expanded && "expanded",
            focused && "focused",
            fullWidth && "fullWidth",
            hasClearIcon && "hasClearIcon",
            hasPopupIcon && "hasPopupIcon"
        ],
        inputRoot: [
            "inputRoot"
        ],
        input: [
            "input",
            inputFocused && "inputFocused"
        ],
        tag: [
            "tag",
            `tagSize${(0, $ZXS89.default)(size)}`
        ],
        endAdornment: [
            "endAdornment"
        ],
        clearIndicator: [
            "clearIndicator"
        ],
        popupIndicator: [
            "popupIndicator",
            popupOpen && "popupIndicatorOpen"
        ],
        popper: [
            "popper",
            disablePortal && "popperDisablePortal"
        ],
        paper: [
            "paper"
        ],
        listbox: [
            "listbox"
        ],
        loading: [
            "loading"
        ],
        noOptions: [
            "noOptions"
        ],
        option: [
            "option"
        ],
        groupLabel: [
            "groupLabel"
        ],
        groupUl: [
            "groupUl"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $a58aa58b12fc1e79$export$8ee01529667e66d9), classes);
};
const $f552d147b67b6cf0$var$AutocompleteRoot = (0, $aF4Kv.default)("div", {
    name: "MuiAutocomplete",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        const { fullWidth: fullWidth , hasClearIcon: hasClearIcon , hasPopupIcon: hasPopupIcon , inputFocused: inputFocused , size: size  } = ownerState;
        return [
            {
                [`& .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).tag}`]: styles.tag
            },
            {
                [`& .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).tag}`]: styles[`tagSize${(0, $ZXS89.default)(size)}`]
            },
            {
                [`& .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).input}`]: styles.input
            },
            {
                [`& .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})(({ ownerState: ownerState  })=>(0, $j5tUA.default)({
        [`&.${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).focused} .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).clearIndicator}`]: {
            visibility: "visible"
        },
        /* Avoid double tap issue on iOS */ "@media (pointer: fine)": {
            [`&:hover .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).clearIndicator}`]: {
                visibility: "visible"
            }
        }
    }, ownerState.fullWidth && {
        width: "100%"
    }, {
        [`& .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).tag}`]: (0, $j5tUA.default)({
            margin: 3,
            maxWidth: "calc(100% - 6px)"
        }, ownerState.size === "small" && {
            margin: 2,
            maxWidth: "calc(100% - 4px)"
        }),
        [`& .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).inputRoot}`]: {
            flexWrap: "wrap",
            [`.${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 30
            },
            [`.${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 56
            },
            [`& .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).input}`]: {
                width: 0,
                minWidth: 30
            }
        },
        [`& .${(0, $eMZla.default).root}`]: {
            paddingBottom: 1,
            "& .MuiInput-input": {
                padding: "4px 4px 4px 0px"
            }
        },
        [`& .${(0, $eMZla.default).root}.${(0, $bm0ya.default).sizeSmall}`]: {
            [`& .${(0, $eMZla.default).input}`]: {
                padding: "2px 4px 3px 0"
            }
        },
        [`& .${(0, $7uK9m.default).root}`]: {
            padding: 9,
            [`.${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 39
            },
            [`.${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 65
            },
            [`& .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).input}`]: {
                padding: "7.5px 4px 7.5px 5px"
            },
            [`& .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).endAdornment}`]: {
                right: 9
            }
        },
        [`& .${(0, $7uK9m.default).root}.${(0, $bm0ya.default).sizeSmall}`]: {
            // Don't specify paddingRight, as it overrides the default value set when there is only
            // one of the popup or clear icon as the specificity is equal so the latter one wins
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            [`& .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).input}`]: {
                padding: "2.5px 4px 2.5px 8px"
            }
        },
        [`& .${(0, $6DfYo.default).root}`]: {
            paddingTop: 19,
            paddingLeft: 8,
            [`.${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 39
            },
            [`.${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).hasClearIcon}&`]: {
                paddingRight: 65
            },
            [`& .${(0, $6DfYo.default).input}`]: {
                padding: "7px 4px"
            },
            [`& .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).endAdornment}`]: {
                right: 9
            }
        },
        [`& .${(0, $6DfYo.default).root}.${(0, $bm0ya.default).sizeSmall}`]: {
            paddingBottom: 1,
            [`& .${(0, $6DfYo.default).input}`]: {
                padding: "2.5px 4px"
            }
        },
        [`& .${(0, $bm0ya.default).hiddenLabel}`]: {
            paddingTop: 8
        },
        [`& .${(0, $6DfYo.default).root}.${(0, $bm0ya.default).hiddenLabel}`]: {
            paddingTop: 0,
            paddingBottom: 0,
            [`& .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).input}`]: {
                paddingTop: 16,
                paddingBottom: 17
            }
        },
        [`& .${(0, $6DfYo.default).root}.${(0, $bm0ya.default).hiddenLabel}.${(0, $bm0ya.default).sizeSmall}`]: {
            [`& .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).input}`]: {
                paddingTop: 8,
                paddingBottom: 9
            }
        },
        [`& .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).input}`]: (0, $j5tUA.default)({
            flexGrow: 1,
            textOverflow: "ellipsis",
            opacity: 0
        }, ownerState.inputFocused && {
            opacity: 1
        })
    }));
const $f552d147b67b6cf0$var$AutocompleteEndAdornment = (0, $aF4Kv.default)("div", {
    name: "MuiAutocomplete",
    slot: "EndAdornment",
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: "absolute",
    right: 0,
    top: "calc(50% - 14px)" // Center vertically
});
const $f552d147b67b6cf0$var$AutocompleteClearIndicator = (0, $aF4Kv.default)((0, $96e62cba67d8fc25$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "ClearIndicator",
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: "hidden"
});
const $f552d147b67b6cf0$var$AutocompletePopupIndicator = (0, $aF4Kv.default)((0, $96e62cba67d8fc25$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "PopupIndicator",
    overridesResolver: ({ ownerState: ownerState  }, styles)=>(0, $j5tUA.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})(({ ownerState: ownerState  })=>(0, $j5tUA.default)({
        padding: 2,
        marginRight: -2
    }, ownerState.popupOpen && {
        transform: "rotate(180deg)"
    }));
const $f552d147b67b6cf0$var$AutocompletePopper = (0, $aF4Kv.default)((0, $31179200a20bcecf$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            {
                [`& .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({
        zIndex: (theme.vars || theme).zIndex.modal
    }, ownerState.disablePortal && {
        position: "absolute"
    }));
const $f552d147b67b6cf0$var$AutocompletePaper = (0, $aF4Kv.default)((0, $eKfJS.default), {
    name: "MuiAutocomplete",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme  })=>(0, $j5tUA.default)({}, theme.typography.body1, {
        overflow: "auto"
    }));
const $f552d147b67b6cf0$var$AutocompleteLoading = (0, $aF4Kv.default)("div", {
    name: "MuiAutocomplete",
    slot: "Loading",
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme  })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $f552d147b67b6cf0$var$AutocompleteNoOptions = (0, $aF4Kv.default)("div", {
    name: "MuiAutocomplete",
    slot: "NoOptions",
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme  })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $f552d147b67b6cf0$var$AutocompleteListbox = (0, $aF4Kv.default)("div", {
    name: "MuiAutocomplete",
    slot: "Listbox",
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme  })=>({
        listStyle: "none",
        margin: 0,
        padding: "8px 0",
        maxHeight: "40vh",
        overflow: "auto",
        position: "relative",
        [`& .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).option}`]: {
            minHeight: 48,
            display: "flex",
            overflow: "hidden",
            justifyContent: "flex-start",
            alignItems: "center",
            cursor: "pointer",
            paddingTop: 6,
            boxSizing: "border-box",
            outline: "0",
            WebkitTapHighlightColor: "transparent",
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up("sm")]: {
                minHeight: "auto"
            },
            [`&.${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: "none"
            },
            [`&.${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $74s0b.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $74s0b.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $74s0b.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $f552d147b67b6cf0$var$AutocompleteGroupLabel = (0, $aF4Kv.default)((0, $5d8a90dd53907051$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "GroupLabel",
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme  })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    }));
const $f552d147b67b6cf0$var$AutocompleteGroupUl = (0, $aF4Kv.default)("ul", {
    name: "MuiAutocomplete",
    slot: "GroupUl",
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $a58aa58b12fc1e79$export$2e2bcd8739ae039).option}`]: {
        paddingLeft: 24
    }
});
const $f552d147b67b6cf0$var$Autocomplete = /*#__PURE__*/ $fV3WI.forwardRef(function Autocomplete(inProps, ref) {
    var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiAutocomplete"
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false , autoHighlight: autoHighlight = false , autoSelect: autoSelect = false , blurOnSelect: blurOnSelect = false , ChipProps: ChipProps , className: className , clearIcon: clearIcon = $f552d147b67b6cf0$var$_ClearIcon || ($f552d147b67b6cf0$var$_ClearIcon = /*#__PURE__*/ (0, $3DnwL.jsx)((0, $702cdf9d2dcbcbc0$export$2e2bcd8739ae039), {
        fontSize: "small"
    })) , clearOnBlur: clearOnBlur = !props.freeSolo , clearOnEscape: clearOnEscape = false , clearText: clearText = "Clear" , closeText: closeText = "Close" , componentsProps: componentsProps = {} , defaultValue: defaultValue = props.multiple ? [] : null , disableClearable: disableClearable = false , disableCloseOnSelect: disableCloseOnSelect = false , disabled: disabled = false , disabledItemsFocusable: disabledItemsFocusable = false , disableListWrap: disableListWrap = false , disablePortal: disablePortal = false , filterSelectedOptions: filterSelectedOptions = false , forcePopupIcon: forcePopupIcon = "auto" , freeSolo: freeSolo = false , fullWidth: fullWidth = false , getLimitTagsText: getLimitTagsText = (more)=>`+${more}` , getOptionLabel: getOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    } , groupBy: groupBy , handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo , includeInputInList: includeInputInList = false , limitTags: limitTags = -1 , ListboxComponent: ListboxComponent = "ul" , ListboxProps: ListboxProps , loading: loading = false , loadingText: loadingText = "Loading…" , multiple: multiple = false , noOptionsText: noOptionsText = "No options" , openOnFocus: openOnFocus = false , openText: openText = "Open" , PaperComponent: PaperComponent = (0, $eKfJS.default) , PopperComponent: PopperComponent = (0, $31179200a20bcecf$export$2e2bcd8739ae039) , popupIcon: popupIcon = $f552d147b67b6cf0$var$_ArrowDropDownIcon || ($f552d147b67b6cf0$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $3DnwL.jsx)((0, $1yAKJ.default), {})) , readOnly: readOnly = false , renderGroup: renderGroupProp , renderInput: renderInput , renderOption: renderOptionProp , renderTags: renderTags , selectOnFocus: selectOnFocus = !props.freeSolo , size: size = "medium" , slotProps: slotProps = {}  } = props, other = (0, $64S8Y.default)(props, $f552d147b67b6cf0$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps , getInputProps: getInputProps , getInputLabelProps: getInputLabelProps , getPopupIndicatorProps: getPopupIndicatorProps , getClearProps: getClearProps , getTagProps: getTagProps , getListboxProps: getListboxProps , getOptionProps: getOptionProps , value: value , dirty: dirty , expanded: expanded , id: id , popupOpen: popupOpen , focused: focused , focusedTag: focusedTag , anchorEl: anchorEl , setAnchorEl: setAnchorEl , inputValue: inputValue , groupedOptions: groupedOptions  } = (0, $d3410e6df796244e$export$2e2bcd8739ae039)((0, $j5tUA.default)({}, props, {
        componentName: "Autocomplete"
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown  } = getInputProps();
    const { ref: externalListboxRef  } = ListboxProps != null ? ListboxProps : {};
    const _getListboxProps = getListboxProps(), { ref: listboxRef  } = _getListboxProps, otherListboxProps = (0, $64S8Y.default)(_getListboxProps, $f552d147b67b6cf0$var$_excluded2);
    const combinedListboxRef = (0, $czyq6.default)(listboxRef, externalListboxRef);
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, $j5tUA.default)({}, props, {
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $f552d147b67b6cf0$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $j5tUA.default)({
                className: classes.tag,
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>/*#__PURE__*/ (0, $3DnwL.jsx)((0, $e0ce19c7048b5103$export$2e2bcd8739ae039), (0, $j5tUA.default)({
                label: getOptionLabel(option),
                size: size
            }, getCustomizedTagProps({
                index: index
            }), ChipProps)));
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $3DnwL.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $3DnwL.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $3DnwL.jsx)($f552d147b67b6cf0$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $3DnwL.jsx)($f552d147b67b6cf0$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>/*#__PURE__*/ (0, $3DnwL.jsx)("li", (0, $j5tUA.default)({}, props2, {
            children: getOptionLabel(option)
        }));
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $j5tUA.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps["aria-selected"],
            index: index,
            inputValue: inputValue
        });
    };
    const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
    const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
    const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
    const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
    return /*#__PURE__*/ (0, $3DnwL.jsxs)($fV3WI.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3DnwL.jsx)($f552d147b67b6cf0$var$AutocompleteRoot, (0, $j5tUA.default)({
                ref: ref,
                className: (0, $h0s6D.default)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === "small" ? "small" : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: (0, $j5tUA.default)({
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onClick: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        }
                    }, (hasClearIcon || hasPopupIcon) && {
                        endAdornment: /*#__PURE__*/ (0, $3DnwL.jsxs)($f552d147b67b6cf0$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $3DnwL.jsx)($f552d147b67b6cf0$var$AutocompleteClearIndicator, (0, $j5tUA.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, clearIndicatorSlotProps, {
                                    className: (0, $h0s6D.default)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $3DnwL.jsx)($f552d147b67b6cf0$var$AutocompletePopupIndicator, (0, $j5tUA.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    ownerState: ownerState
                                }, popupIndicatorSlotProps, {
                                    className: (0, $h0s6D.default)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    }),
                    inputProps: (0, $j5tUA.default)({
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            anchorEl ? /*#__PURE__*/ (0, $3DnwL.jsx)($f552d147b67b6cf0$var$AutocompletePopper, (0, $j5tUA.default)({
                as: PopperComponent,
                disablePortal: disablePortal,
                style: {
                    width: anchorEl ? anchorEl.clientWidth : null
                },
                ownerState: ownerState,
                role: "presentation",
                anchorEl: anchorEl,
                open: popupOpen
            }, popperSlotProps, {
                className: (0, $h0s6D.default)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
                children: /*#__PURE__*/ (0, $3DnwL.jsxs)($f552d147b67b6cf0$var$AutocompletePaper, (0, $j5tUA.default)({
                    ownerState: ownerState,
                    as: PaperComponent
                }, paperSlotProps, {
                    className: (0, $h0s6D.default)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $3DnwL.jsx)($f552d147b67b6cf0$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $3DnwL.jsx)($f552d147b67b6cf0$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $3DnwL.jsx)($f552d147b67b6cf0$var$AutocompleteListbox, (0, $j5tUA.default)({
                            as: ListboxComponent,
                            className: classes.listbox,
                            ownerState: ownerState
                        }, otherListboxProps, ListboxProps, {
                            ref: combinedListboxRef,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        })) : null
                    ]
                }))
            })) : null
        ]
    });
});
var $f552d147b67b6cf0$export$2e2bcd8739ae039 = $f552d147b67b6cf0$var$Autocomplete;


var $76UN0 = parcelRequire("76UN0");
var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $js0sS = parcelRequire("js0sS");

var $74s0b = parcelRequire("74s0b");

var $ZXS89 = parcelRequire("ZXS89");

var $fV3WI = parcelRequire("fV3WI");
/**
 * @ignore - internal component.
 */ const $5a7a36dccf3f3533$var$TableContext = /*#__PURE__*/ $fV3WI.createContext();
var $5a7a36dccf3f3533$export$2e2bcd8739ae039 = $5a7a36dccf3f3533$var$TableContext;



var $fV3WI = parcelRequire("fV3WI");
/**
 * @ignore - internal component.
 */ const $459358929751b2f8$var$Tablelvl2Context = /*#__PURE__*/ $fV3WI.createContext();
var $459358929751b2f8$export$2e2bcd8739ae039 = $459358929751b2f8$var$Tablelvl2Context;



var $05gnM = parcelRequire("05gnM");

var $aF4Kv = parcelRequire("aF4Kv");

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $79acf26d10b21d71$export$33a0f07a16a10b1b(slot) {
    return (0, $auxfn.default)("MuiTableCell", slot);
}
const $79acf26d10b21d71$var$tableCellClasses = (0, $dxVxC.default)("MuiTableCell", [
    "root",
    "head",
    "body",
    "footer",
    "sizeSmall",
    "sizeMedium",
    "paddingCheckbox",
    "paddingNone",
    "alignLeft",
    "alignCenter",
    "alignRight",
    "alignJustify",
    "stickyHeader"
]);
var $79acf26d10b21d71$export$2e2bcd8739ae039 = $79acf26d10b21d71$var$tableCellClasses;



var $3DnwL = parcelRequire("3DnwL");
const $6920591e12eb2f84$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $6920591e12eb2f84$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , variant: variant , align: align , padding: padding , size: size , stickyHeader: stickyHeader  } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            stickyHeader && "stickyHeader",
            align !== "inherit" && `align${(0, $ZXS89.default)(align)}`,
            padding !== "normal" && `padding${(0, $ZXS89.default)(padding)}`,
            `size${(0, $ZXS89.default)(size)}`
        ]
    };
    return (0, $js0sS.default)(slots, (0, $79acf26d10b21d71$export$33a0f07a16a10b1b), classes);
};
const $6920591e12eb2f84$var$TableCellRoot = (0, $aF4Kv.default)("td", {
    name: "MuiTableCell",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $ZXS89.default)(ownerState.size)}`],
            ownerState.padding !== "normal" && styles[`padding${(0, $ZXS89.default)(ownerState.padding)}`],
            ownerState.align !== "inherit" && styles[`align${(0, $ZXS89.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({}, theme.typography.body2, {
        display: "table-cell",
        verticalAlign: "inherit",
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === "light" ? (0, $74s0b.lighten)((0, $74s0b.alpha)(theme.palette.divider, 1), 0.88) : (0, $74s0b.darken)((0, $74s0b.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: "left",
        padding: 16
    }, ownerState.variant === "head" && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === "body" && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === "footer" && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === "small" && {
        padding: "6px 16px",
        [`&.${(0, $79acf26d10b21d71$export$2e2bcd8739ae039).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: "0 12px 0 16px",
            "& > *": {
                padding: 0
            }
        }
    }, ownerState.padding === "checkbox" && {
        width: 48,
        // prevent the checkbox column from growing
        padding: "0 0 0 4px"
    }, ownerState.padding === "none" && {
        padding: 0
    }, ownerState.align === "left" && {
        textAlign: "left"
    }, ownerState.align === "center" && {
        textAlign: "center"
    }, ownerState.align === "right" && {
        textAlign: "right",
        flexDirection: "row-reverse"
    }, ownerState.align === "justify" && {
        textAlign: "justify"
    }, ownerState.stickyHeader && {
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $6920591e12eb2f84$var$TableCell = /*#__PURE__*/ $fV3WI.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiTableCell"
    });
    const { align: align = "inherit" , className: className , component: componentProp , padding: paddingProp , scope: scopeProp , size: sizeProp , sortDirection: sortDirection , variant: variantProp  } = props, other = (0, $64S8Y.default)(props, $6920591e12eb2f84$var$_excluded);
    const table = $fV3WI.useContext((0, $5a7a36dccf3f3533$export$2e2bcd8739ae039));
    const tablelvl2 = $fV3WI.useContext((0, $459358929751b2f8$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === "head";
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? "th" : "td";
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === "td") scope = undefined;
    else if (!scope && isHeadCell) scope = "col";
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $j5tUA.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : "normal"),
        size: sizeProp || (table && table.size ? table.size : "medium"),
        sortDirection: sortDirection,
        stickyHeader: variant === "head" && table && table.stickyHeader,
        variant: variant
    });
    const classes = $6920591e12eb2f84$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === "asc" ? "ascending" : "descending";
    return /*#__PURE__*/ (0, $3DnwL.jsx)($6920591e12eb2f84$var$TableCellRoot, (0, $j5tUA.default)({
        as: component,
        ref: ref,
        className: (0, $h0s6D.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
var $6920591e12eb2f84$export$2e2bcd8739ae039 = $6920591e12eb2f84$var$TableCell;



var $fV3WI = parcelRequire("fV3WI");

var $3DnwL = parcelRequire("3DnwL");
function $259d22925ba6a5af$var$_extends() {
    $259d22925ba6a5af$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $259d22925ba6a5af$var$_extends.apply(this, arguments);
}
var $259d22925ba6a5af$var$reservedModifierKeywords = [
    "shift",
    "alt",
    "meta",
    "mod",
    "ctrl"
];
var $259d22925ba6a5af$var$mappedKeys = {
    esc: "escape",
    "return": "enter",
    ".": "period",
    ",": "comma",
    "-": "slash",
    " ": "space",
    "`": "backquote",
    "#": "backslash",
    "+": "bracketright",
    ShiftLeft: "shift",
    ShiftRight: "shift",
    AltLeft: "alt",
    AltRight: "alt",
    MetaLeft: "meta",
    MetaRight: "meta",
    OSLeft: "meta",
    OSRight: "meta",
    ControlLeft: "ctrl",
    ControlRight: "ctrl"
};
function $259d22925ba6a5af$var$mapKey(key) {
    return ($259d22925ba6a5af$var$mappedKeys[key] || key).trim().toLowerCase().replace(/key|digit|numpad|arrow/, "");
}
function $259d22925ba6a5af$var$isHotkeyModifier(key) {
    return $259d22925ba6a5af$var$reservedModifierKeywords.includes(key);
}
function $259d22925ba6a5af$var$parseKeysHookInput(keys, splitKey) {
    if (splitKey === void 0) splitKey = ",";
    return keys.split(splitKey);
}
function $259d22925ba6a5af$var$parseHotkey(hotkey, combinationKey, description) {
    if (combinationKey === void 0) combinationKey = "+";
    var keys = hotkey.toLocaleLowerCase().split(combinationKey).map(function(k) {
        return $259d22925ba6a5af$var$mapKey(k);
    });
    var modifiers = {
        alt: keys.includes("alt"),
        ctrl: keys.includes("ctrl") || keys.includes("control"),
        shift: keys.includes("shift"),
        meta: keys.includes("meta"),
        mod: keys.includes("mod")
    };
    var singleCharKeys = keys.filter(function(k) {
        return !$259d22925ba6a5af$var$reservedModifierKeywords.includes(k);
    });
    return $259d22925ba6a5af$var$_extends({}, modifiers, {
        keys: singleCharKeys,
        description: description
    });
}
(function() {
    if (typeof document !== "undefined") {
        document.addEventListener("keydown", function(e) {
            if (e.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            $259d22925ba6a5af$var$pushToCurrentlyPressedKeys([
                $259d22925ba6a5af$var$mapKey(e.key),
                $259d22925ba6a5af$var$mapKey(e.code)
            ]);
        });
        document.addEventListener("keyup", function(e) {
            if (e.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            $259d22925ba6a5af$var$removeFromCurrentlyPressedKeys([
                $259d22925ba6a5af$var$mapKey(e.key),
                $259d22925ba6a5af$var$mapKey(e.code)
            ]);
        });
    }
    if (typeof window !== "undefined") window.addEventListener("blur", function() {
        $259d22925ba6a5af$var$currentlyPressedKeys.clear();
    });
})();
var $259d22925ba6a5af$var$currentlyPressedKeys = /*#__PURE__*/ new Set();
function $259d22925ba6a5af$export$eae3d25ef8fab782(key, splitKey) {
    if (splitKey === void 0) splitKey = ",";
    var hotkeyArray = Array.isArray(key) ? key : key.split(splitKey);
    return hotkeyArray.every(function(hotkey) {
        return $259d22925ba6a5af$var$currentlyPressedKeys.has(hotkey.trim().toLowerCase());
    });
}
function $259d22925ba6a5af$var$pushToCurrentlyPressedKeys(key) {
    var hotkeyArray = Array.isArray(key) ? key : [
        key
    ];
    /*
  Due to a weird behavior on macOS we need to clear the set if the user pressed down the meta key and presses another key.
  https://stackoverflow.com/questions/11818637/why-does-javascript-drop-keyup-events-when-the-metakey-is-pressed-on-mac-browser
  Otherwise the set will hold all ever pressed keys while the meta key is down which leads to wrong results.
   */ if ($259d22925ba6a5af$var$currentlyPressedKeys.has("meta")) $259d22925ba6a5af$var$currentlyPressedKeys.forEach(function(key) {
        return !$259d22925ba6a5af$var$isHotkeyModifier(key) && $259d22925ba6a5af$var$currentlyPressedKeys["delete"](key.toLowerCase());
    });
    hotkeyArray.forEach(function(hotkey) {
        return $259d22925ba6a5af$var$currentlyPressedKeys.add(hotkey.toLowerCase());
    });
}
function $259d22925ba6a5af$var$removeFromCurrentlyPressedKeys(key) {
    var hotkeyArray = Array.isArray(key) ? key : [
        key
    ];
    /*
  Due to a weird behavior on macOS we need to clear the set if the user pressed down the meta key and presses another key.
  https://stackoverflow.com/questions/11818637/why-does-javascript-drop-keyup-events-when-the-metakey-is-pressed-on-mac-browser
  Otherwise the set will hold all ever pressed keys while the meta key is down which leads to wrong results.
   */ if (key === "meta") $259d22925ba6a5af$var$currentlyPressedKeys.clear();
    else hotkeyArray.forEach(function(hotkey) {
        return $259d22925ba6a5af$var$currentlyPressedKeys["delete"](hotkey.toLowerCase());
    });
}
function $259d22925ba6a5af$var$maybePreventDefault(e, hotkey, preventDefault) {
    if (typeof preventDefault === "function" && preventDefault(e, hotkey) || preventDefault === true) e.preventDefault();
}
function $259d22925ba6a5af$var$isHotkeyEnabled(e, hotkey, enabled) {
    if (typeof enabled === "function") return enabled(e, hotkey);
    return enabled === true || enabled === undefined;
}
function $259d22925ba6a5af$var$isKeyboardEventTriggeredByInput(ev) {
    return $259d22925ba6a5af$var$isHotkeyEnabledOnTag(ev, [
        "input",
        "textarea",
        "select"
    ]);
}
function $259d22925ba6a5af$var$isHotkeyEnabledOnTag(_ref, enabledOnTags) {
    var target = _ref.target;
    if (enabledOnTags === void 0) enabledOnTags = false;
    var targetTagName = target && target.tagName;
    if (enabledOnTags instanceof Array) return Boolean(targetTagName && enabledOnTags && enabledOnTags.some(function(tag) {
        return tag.toLowerCase() === targetTagName.toLowerCase();
    }));
    return Boolean(targetTagName && enabledOnTags && enabledOnTags === true);
}
function $259d22925ba6a5af$var$isScopeActive(activeScopes, scopes) {
    if (activeScopes.length === 0 && scopes) {
        console.warn('A hotkey has the "scopes" option set, however no active scopes were found. If you want to use the global scopes feature, you need to wrap your app in a <HotkeysProvider>');
        return true;
    }
    if (!scopes) return true;
    return activeScopes.some(function(scope) {
        return scopes.includes(scope);
    }) || activeScopes.includes("*");
}
var $259d22925ba6a5af$var$isHotkeyMatchingKeyboardEvent = function isHotkeyMatchingKeyboardEvent(e, hotkey, ignoreModifiers) {
    if (ignoreModifiers === void 0) ignoreModifiers = false;
    var alt = hotkey.alt, meta = hotkey.meta, mod = hotkey.mod, shift = hotkey.shift, ctrl = hotkey.ctrl, keys = hotkey.keys;
    var pressedKeyUppercase = e.key, code = e.code, ctrlKey = e.ctrlKey, metaKey = e.metaKey, shiftKey = e.shiftKey, altKey = e.altKey;
    var keyCode = $259d22925ba6a5af$var$mapKey(code);
    var pressedKey = pressedKeyUppercase.toLowerCase();
    if (!ignoreModifiers) {
        // We check the pressed keys for compatibility with the keyup event. In keyup events the modifier flags are not set.
        if (alt === !altKey && pressedKey !== "alt") return false;
        if (shift === !shiftKey && pressedKey !== "shift") return false;
        // Mod is a special key name that is checking for meta on macOS and ctrl on other platforms
        if (mod) {
            if (!metaKey && !ctrlKey) return false;
        } else {
            if (meta === !metaKey && pressedKey !== "meta" && pressedKey !== "os") return false;
            if (ctrl === !ctrlKey && pressedKey !== "ctrl" && pressedKey !== "control") return false;
        }
    }
    // All modifiers are correct, now check the key
    // If the key is set, we check for the key
    if (keys && keys.length === 1 && (keys.includes(pressedKey) || keys.includes(keyCode))) return true;
    else if (keys) // Check if all keys are present in pressedDownKeys set
    return $259d22925ba6a5af$export$eae3d25ef8fab782(keys);
    else if (!keys) // If the key is not set, we only listen for modifiers, that check went alright, so we return true
    return true;
    // There is nothing that matches.
    return false;
};
var $259d22925ba6a5af$var$BoundHotkeysProxyProvider = /*#__PURE__*/ (0, $fV3WI.createContext)(undefined);
var $259d22925ba6a5af$var$useBoundHotkeysProxy = function useBoundHotkeysProxy() {
    return (0, $fV3WI.useContext)($259d22925ba6a5af$var$BoundHotkeysProxyProvider);
};
function $259d22925ba6a5af$var$BoundHotkeysProxyProviderProvider(_ref) {
    var addHotkey = _ref.addHotkey, removeHotkey = _ref.removeHotkey, children = _ref.children;
    return /*#__PURE__*/ (0, $3DnwL.jsx)($259d22925ba6a5af$var$BoundHotkeysProxyProvider.Provider, {
        value: {
            addHotkey: addHotkey,
            removeHotkey: removeHotkey
        },
        children: children
    });
}
function $259d22925ba6a5af$var$deepEqual(x, y) {
    //@ts-ignore
    return x && y && typeof x === "object" && typeof y === "object" ? Object.keys(x).length === Object.keys(y).length && //@ts-ignore
    Object.keys(x).reduce(function(isEqual, key) {
        return isEqual && $259d22925ba6a5af$var$deepEqual(x[key], y[key]);
    }, true) : x === y;
}
var $259d22925ba6a5af$var$HotkeysContext = /*#__PURE__*/ (0, $fV3WI.createContext)({
    hotkeys: [],
    enabledScopes: [],
    toggleScope: function toggleScope() {},
    enableScope: function enableScope() {},
    disableScope: function disableScope() {}
});
var $259d22925ba6a5af$export$183c7bf336967877 = function useHotkeysContext() {
    return (0, $fV3WI.useContext)($259d22925ba6a5af$var$HotkeysContext);
};
var $259d22925ba6a5af$export$9d58aaad435254c0 = function HotkeysProvider(_ref) {
    var _ref$initiallyActiveS = _ref.initiallyActiveScopes, initiallyActiveScopes = _ref$initiallyActiveS === void 0 ? [
        "*"
    ] : _ref$initiallyActiveS, children = _ref.children;
    var _useState = (0, $fV3WI.useState)((initiallyActiveScopes == null ? void 0 : initiallyActiveScopes.length) > 0 ? initiallyActiveScopes : [
        "*"
    ]), internalActiveScopes = _useState[0], setInternalActiveScopes = _useState[1];
    var _useState2 = (0, $fV3WI.useState)([]), boundHotkeys = _useState2[0], setBoundHotkeys = _useState2[1];
    var enableScope = (0, $fV3WI.useCallback)(function(scope) {
        setInternalActiveScopes(function(prev) {
            if (prev.includes("*")) return [
                scope
            ];
            return Array.from(new Set([].concat(prev, [
                scope
            ])));
        });
    }, []);
    var disableScope = (0, $fV3WI.useCallback)(function(scope) {
        setInternalActiveScopes(function(prev) {
            if (prev.filter(function(s) {
                return s !== scope;
            }).length === 0) return [
                "*"
            ];
            else return prev.filter(function(s) {
                return s !== scope;
            });
        });
    }, []);
    var toggleScope = (0, $fV3WI.useCallback)(function(scope) {
        setInternalActiveScopes(function(prev) {
            if (prev.includes(scope)) {
                if (prev.filter(function(s) {
                    return s !== scope;
                }).length === 0) return [
                    "*"
                ];
                else return prev.filter(function(s) {
                    return s !== scope;
                });
            } else {
                if (prev.includes("*")) return [
                    scope
                ];
                return Array.from(new Set([].concat(prev, [
                    scope
                ])));
            }
        });
    }, []);
    var addBoundHotkey = (0, $fV3WI.useCallback)(function(hotkey) {
        setBoundHotkeys(function(prev) {
            return [].concat(prev, [
                hotkey
            ]);
        });
    }, []);
    var removeBoundHotkey = (0, $fV3WI.useCallback)(function(hotkey) {
        setBoundHotkeys(function(prev) {
            return prev.filter(function(h) {
                return !$259d22925ba6a5af$var$deepEqual(h, hotkey);
            });
        });
    }, []);
    return /*#__PURE__*/ (0, $3DnwL.jsx)($259d22925ba6a5af$var$HotkeysContext.Provider, {
        value: {
            enabledScopes: internalActiveScopes,
            hotkeys: boundHotkeys,
            enableScope: enableScope,
            disableScope: disableScope,
            toggleScope: toggleScope
        },
        children: /*#__PURE__*/ (0, $3DnwL.jsx)($259d22925ba6a5af$var$BoundHotkeysProxyProviderProvider, {
            addHotkey: addBoundHotkey,
            removeHotkey: removeBoundHotkey,
            children: children
        })
    });
};
function $259d22925ba6a5af$var$useDeepEqualMemo(value) {
    var ref = (0, $fV3WI.useRef)(undefined);
    if (!$259d22925ba6a5af$var$deepEqual(ref.current, value)) ref.current = value;
    return ref.current;
}
var $259d22925ba6a5af$var$stopPropagation = function stopPropagation(e) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();
};
var $259d22925ba6a5af$var$useSafeLayoutEffect = typeof window !== "undefined" ? (0, $fV3WI.useLayoutEffect) : (0, $fV3WI.useEffect);
function $259d22925ba6a5af$export$1b0c17123b4f3646(keys, callback, options, dependencies) {
    var ref = (0, $fV3WI.useRef)(null);
    var hasTriggeredRef = (0, $fV3WI.useRef)(false);
    var _options = !(options instanceof Array) ? options : !(dependencies instanceof Array) ? dependencies : undefined;
    var _keys = keys instanceof Array ? keys.join(_options == null ? void 0 : _options.splitKey) : keys;
    var _deps = options instanceof Array ? options : dependencies instanceof Array ? dependencies : undefined;
    var memoisedCB = (0, $fV3WI.useCallback)(callback, _deps != null ? _deps : []);
    var cbRef = (0, $fV3WI.useRef)(memoisedCB);
    if (_deps) cbRef.current = memoisedCB;
    else cbRef.current = callback;
    var memoisedOptions = $259d22925ba6a5af$var$useDeepEqualMemo(_options);
    var _useHotkeysContext = $259d22925ba6a5af$export$183c7bf336967877(), enabledScopes = _useHotkeysContext.enabledScopes;
    var proxy = $259d22925ba6a5af$var$useBoundHotkeysProxy();
    $259d22925ba6a5af$var$useSafeLayoutEffect(function() {
        if ((memoisedOptions == null ? void 0 : memoisedOptions.enabled) === false || !$259d22925ba6a5af$var$isScopeActive(enabledScopes, memoisedOptions == null ? void 0 : memoisedOptions.scopes)) return;
        var listener = function listener(e, isKeyUp) {
            var _e$target;
            if (isKeyUp === void 0) isKeyUp = false;
            if ($259d22925ba6a5af$var$isKeyboardEventTriggeredByInput(e) && !$259d22925ba6a5af$var$isHotkeyEnabledOnTag(e, memoisedOptions == null ? void 0 : memoisedOptions.enableOnFormTags)) return;
            if (memoisedOptions != null && memoisedOptions.ignoreEventWhen != null && memoisedOptions.ignoreEventWhen(e)) return;
            // TODO: SINCE THE EVENT IS NOW ATTACHED TO THE REF, THE ACTIVE ELEMENT CAN NEVER BE INSIDE THE REF. THE HOTKEY ONLY TRIGGERS IF THE
            // REF IS THE ACTIVE ELEMENT. THIS IS A PROBLEM SINCE FOCUSED SUB COMPONENTS WON'T TRIGGER THE HOTKEY.
            if (ref.current !== null && document.activeElement !== ref.current && !ref.current.contains(document.activeElement)) {
                $259d22925ba6a5af$var$stopPropagation(e);
                return;
            }
            if ((_e$target = e.target) != null && _e$target.isContentEditable && !(memoisedOptions != null && memoisedOptions.enableOnContentEditable)) return;
            $259d22925ba6a5af$var$parseKeysHookInput(_keys, memoisedOptions == null ? void 0 : memoisedOptions.splitKey).forEach(function(key) {
                var _hotkey$keys;
                var hotkey = $259d22925ba6a5af$var$parseHotkey(key, memoisedOptions == null ? void 0 : memoisedOptions.combinationKey);
                if ($259d22925ba6a5af$var$isHotkeyMatchingKeyboardEvent(e, hotkey, memoisedOptions == null ? void 0 : memoisedOptions.ignoreModifiers) || (_hotkey$keys = hotkey.keys) != null && _hotkey$keys.includes("*")) {
                    if (isKeyUp && hasTriggeredRef.current) return;
                    $259d22925ba6a5af$var$maybePreventDefault(e, hotkey, memoisedOptions == null ? void 0 : memoisedOptions.preventDefault);
                    if (!$259d22925ba6a5af$var$isHotkeyEnabled(e, hotkey, memoisedOptions == null ? void 0 : memoisedOptions.enabled)) {
                        $259d22925ba6a5af$var$stopPropagation(e);
                        return;
                    }
                    // Execute the user callback for that hotkey
                    cbRef.current(e, hotkey);
                    if (!isKeyUp) hasTriggeredRef.current = true;
                }
            });
        };
        var handleKeyDown = function handleKeyDown(event) {
            if (event.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            $259d22925ba6a5af$var$pushToCurrentlyPressedKeys($259d22925ba6a5af$var$mapKey(event.code));
            if ((memoisedOptions == null ? void 0 : memoisedOptions.keydown) === undefined && (memoisedOptions == null ? void 0 : memoisedOptions.keyup) !== true || memoisedOptions != null && memoisedOptions.keydown) listener(event);
        };
        var handleKeyUp = function handleKeyUp(event) {
            if (event.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
            return;
            $259d22925ba6a5af$var$removeFromCurrentlyPressedKeys($259d22925ba6a5af$var$mapKey(event.code));
            hasTriggeredRef.current = false;
            if (memoisedOptions != null && memoisedOptions.keyup) listener(event, true);
        };
        var domNode = ref.current || (_options == null ? void 0 : _options.document) || document;
        // @ts-ignore
        domNode.addEventListener("keyup", handleKeyUp);
        // @ts-ignore
        domNode.addEventListener("keydown", handleKeyDown);
        if (proxy) $259d22925ba6a5af$var$parseKeysHookInput(_keys, memoisedOptions == null ? void 0 : memoisedOptions.splitKey).forEach(function(key) {
            return proxy.addHotkey($259d22925ba6a5af$var$parseHotkey(key, memoisedOptions == null ? void 0 : memoisedOptions.combinationKey, memoisedOptions == null ? void 0 : memoisedOptions.description));
        });
        return function() {
            // @ts-ignore
            domNode.removeEventListener("keyup", handleKeyUp);
            // @ts-ignore
            domNode.removeEventListener("keydown", handleKeyDown);
            if (proxy) $259d22925ba6a5af$var$parseKeysHookInput(_keys, memoisedOptions == null ? void 0 : memoisedOptions.splitKey).forEach(function(key) {
                return proxy.removeHotkey($259d22925ba6a5af$var$parseHotkey(key, memoisedOptions == null ? void 0 : memoisedOptions.combinationKey, memoisedOptions == null ? void 0 : memoisedOptions.description));
            });
        };
    }, [
        _keys,
        memoisedOptions,
        enabledScopes
    ]);
    return ref;
}
function $259d22925ba6a5af$export$175b3984f625ab17() {
    var _useState = (0, $fV3WI.useState)(new Set()), keys = _useState[0], setKeys = _useState[1];
    var _useState2 = (0, $fV3WI.useState)(false), isRecording = _useState2[0], setIsRecording = _useState2[1];
    var handler = (0, $fV3WI.useCallback)(function(event) {
        if (event.key === undefined) // Synthetic event (e.g., Chrome autofill).  Ignore.
        return;
        event.preventDefault();
        event.stopPropagation();
        setKeys(function(prev) {
            var newKeys = new Set(prev);
            newKeys.add($259d22925ba6a5af$var$mapKey(event.code));
            return newKeys;
        });
    }, []);
    var stop = (0, $fV3WI.useCallback)(function() {
        if (typeof document !== "undefined") {
            document.removeEventListener("keydown", handler);
            setIsRecording(false);
        }
    }, [
        handler
    ]);
    var start = (0, $fV3WI.useCallback)(function() {
        setKeys(new Set());
        if (typeof document !== "undefined") {
            stop();
            document.addEventListener("keydown", handler);
            setIsRecording(true);
        }
    }, [
        handler,
        stop
    ]);
    return [
        keys,
        {
            start: start,
            stop: stop,
            isRecording: isRecording
        }
    ];
}


/**
 * A function that always returns `false`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.T
 * @example
 *
 *      R.F(); //=> false
 */ var $4a2bfca970e00eff$var$F = function() {
    return false;
};
var $4a2bfca970e00eff$export$2e2bcd8739ae039 = $4a2bfca970e00eff$var$F;


/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.F
 * @example
 *
 *      R.T(); //=> true
 */ var $2a187f9f818b73d5$var$T = function() {
    return true;
};
var $2a187f9f818b73d5$export$2e2bcd8739ae039 = $2a187f9f818b73d5$var$T;


/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of
 * their positions.
 *
 * If `g` is a curried ternary function and `_` is `R.__`, the following are
 * equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2, _)(1, 3)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @name __
 * @constant
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @example
 *
 *      const greet = R.replace('{name}', R.__, 'Hello, {name}!');
 *      greet('Alice'); //=> 'Hello, Alice!'
 */ var $e712d1d2964e3962$export$2e2bcd8739ae039 = {
    "@@functional/placeholder": true
};


function $e08266ee44d5fcd3$export$2e2bcd8739ae039(a) {
    return a != null && typeof a === "object" && a["@@functional/placeholder"] === true;
}


function $25856e1e32547272$export$2e2bcd8739ae039(fn) {
    return function f1(a) {
        if (arguments.length === 0 || (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(a)) return f1;
        else return fn.apply(this, arguments);
    };
}



function $00e54140c2625599$export$2e2bcd8739ae039(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(a) ? f2 : (0, $25856e1e32547272$export$2e2bcd8739ae039)(function(_b) {
                    return fn(a, _b);
                });
            default:
                return (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(a) && (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(b) ? f2 : (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(a) ? (0, $25856e1e32547272$export$2e2bcd8739ae039)(function(_a) {
                    return fn(_a, b);
                }) : (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(b) ? (0, $25856e1e32547272$export$2e2bcd8739ae039)(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}


/**
 * Adds two values.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a
 * @param {Number} b
 * @return {Number}
 * @see R.subtract
 * @example
 *
 *      R.add(2, 3);       //=>  5
 *      R.add(7)(10);      //=> 17
 */ var $5478c02438a847eb$var$add = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function add(a, b) {
    return Number(a) + Number(b);
});
var $5478c02438a847eb$export$2e2bcd8739ae039 = $5478c02438a847eb$var$add;


/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */ function $177bce200a9ffba1$export$2e2bcd8739ae039(set1, set2) {
    set1 = set1 || [];
    set2 = set2 || [];
    var idx;
    var len1 = set1.length;
    var len2 = set2.length;
    var result = [];
    idx = 0;
    while(idx < len1){
        result[result.length] = set1[idx];
        idx += 1;
    }
    idx = 0;
    while(idx < len2){
        result[result.length] = set2[idx];
        idx += 1;
    }
    return result;
}



function $25d67f9135fe3bce$export$2e2bcd8739ae039(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
    }
}






function $04acb407ec8a4632$export$2e2bcd8739ae039(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!(0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!(0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(result)) left -= 1;
            combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : (0, $25d67f9135fe3bce$export$2e2bcd8739ae039)(left, $04acb407ec8a4632$export$2e2bcd8739ae039(length, combined, fn));
    };
}


/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $8bd7b963d2d08f64$var$curryN = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function curryN(length, fn) {
    if (length === 1) return (0, $25856e1e32547272$export$2e2bcd8739ae039)(fn);
    return (0, $25d67f9135fe3bce$export$2e2bcd8739ae039)(length, (0, $04acb407ec8a4632$export$2e2bcd8739ae039)(length, [], fn));
});
var $8bd7b963d2d08f64$export$2e2bcd8739ae039 = $8bd7b963d2d08f64$var$curryN;


/**
 * Creates a new list iteration function from an existing one by adding two new
 * parameters to its callback function: the current index, and the entire list.
 *
 * This would turn, for instance, [`R.map`](#map) function into one that
 * more closely resembles `Array.prototype.map`. Note that this will only work
 * for functions in which the iteration callback function is the first
 * parameter, and where the list is the last parameter. (This latter might be
 * unimportant if the list parameter is not used.)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Function
 * @category List
 * @sig (((a ...) -> b) ... -> [a] -> *) -> (((a ..., Int, [a]) -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      const mapIndexed = R.addIndex(R.map);
 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */ var $47a3c77cf252827c$var$addIndex = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function addIndex(fn) {
    return (0, $8bd7b963d2d08f64$export$2e2bcd8739ae039)(fn.length, function() {
        var idx = 0;
        var origFn = arguments[0];
        var list = arguments[arguments.length - 1];
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = function() {
            var result = origFn.apply(this, (0, $177bce200a9ffba1$export$2e2bcd8739ae039)(arguments, [
                idx,
                list
            ]));
            idx += 1;
            return result;
        };
        return fn.apply(this, args);
    });
});
var $47a3c77cf252827c$export$2e2bcd8739ae039 = $47a3c77cf252827c$var$addIndex;





/**
 * As with `addIndex`, `addIndexRight` creates a new list iteration function
 * from an existing one by adding two new parameters to its callback function:
 * the current index, and the entire list.
 *
 * Unlike `addIndex`, `addIndexRight` iterates from the right to the left.
 *
 * @func
 * @memberOf R
 * @since v0.29.0
 * @category Function
 * @category List
 * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      const revmap = (fn, ary) => R.map(fn, R.reverse(ary));
 *      const revmapIndexed = R.addIndexRight(revmap);
 *      revmapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> [ '5-r', '4-a', '3-b', '2-o', '1-o', '0-f' ]
 */ var $c8fb67de46925951$var$addIndexRight = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function addIndex(fn) {
    return (0, $8bd7b963d2d08f64$export$2e2bcd8739ae039)(fn.length, function() {
        var origFn = arguments[0];
        var list = arguments[arguments.length - 1];
        var idx = list.length - 1;
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = function() {
            var result = origFn.apply(this, (0, $177bce200a9ffba1$export$2e2bcd8739ae039)(arguments, [
                idx,
                list
            ]));
            idx -= 1;
            return result;
        };
        return fn.apply(this, args);
    });
});
var $c8fb67de46925951$export$2e2bcd8739ae039 = $c8fb67de46925951$var$addIndexRight;






function $4bb904cf9cab93c5$export$2e2bcd8739ae039(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(a) ? f3 : (0, $00e54140c2625599$export$2e2bcd8739ae039)(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(a) && (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(b) ? f3 : (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(a) ? (0, $00e54140c2625599$export$2e2bcd8739ae039)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(b) ? (0, $00e54140c2625599$export$2e2bcd8739ae039)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $25856e1e32547272$export$2e2bcd8739ae039)(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(a) && (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(b) && (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(c) ? f3 : (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(a) && (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(b) ? (0, $00e54140c2625599$export$2e2bcd8739ae039)(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(a) && (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(c) ? (0, $00e54140c2625599$export$2e2bcd8739ae039)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(b) && (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(c) ? (0, $00e54140c2625599$export$2e2bcd8739ae039)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(a) ? (0, $25856e1e32547272$export$2e2bcd8739ae039)(function(_a) {
                    return fn(_a, b, c);
                }) : (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(b) ? (0, $25856e1e32547272$export$2e2bcd8739ae039)(function(_b) {
                    return fn(a, _b, c);
                }) : (0, $e08266ee44d5fcd3$export$2e2bcd8739ae039)(c) ? (0, $25856e1e32547272$export$2e2bcd8739ae039)(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}


/**
 * Applies a function to the value at the given index of an array, returning a
 * new copy of the array with the element at the given index replaced with the
 * result of the function application.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> (a -> a) -> [a] -> [a]
 * @param {Number} idx The index.
 * @param {Function} fn The function to apply.
 * @param {Array|Arguments} list An array-like object whose value
 *        at the supplied index will be replaced.
 * @return {Array} A copy of the supplied array-like object with
 *         the element at index `idx` replaced with the value
 *         returned by applying `fn` to the existing element.
 * @see R.update
 * @example
 *
 *      R.adjust(1, R.toUpper, ['a', 'b', 'c', 'd']);      //=> ['a', 'B', 'c', 'd']
 *      R.adjust(-1, R.toUpper, ['a', 'b', 'c', 'd']);     //=> ['a', 'b', 'c', 'D']
 * @symb R.adjust(-1, f, [a, b]) = [a, f(b)]
 * @symb R.adjust(0, f, [a, b]) = [f(a), b]
 */ var $491cea0ccb4d4362$var$adjust = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function adjust(idx, fn, list) {
    var len = list.length;
    if (idx >= len || idx < -len) return list;
    var _idx = (len + idx) % len;
    var _list = (0, $177bce200a9ffba1$export$2e2bcd8739ae039)(list);
    _list[_idx] = fn(list[_idx]);
    return _list;
});
var $491cea0ccb4d4362$export$2e2bcd8739ae039 = $491cea0ccb4d4362$var$adjust;



/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */ var $6011f766ba1d1c66$export$2e2bcd8739ae039 = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === "[object Array]";
};


function $7f9038c575da3221$export$2e2bcd8739ae039(obj) {
    return obj != null && typeof obj["@@transducer/step"] === "function";
}


function $a95c0274f29d12e1$export$2e2bcd8739ae039(methodNames, transducerCreator, fn) {
    return function() {
        if (arguments.length === 0) return fn();
        var obj = arguments[arguments.length - 1];
        if (!(0, $6011f766ba1d1c66$export$2e2bcd8739ae039)(obj)) {
            var idx = 0;
            while(idx < methodNames.length){
                if (typeof obj[methodNames[idx]] === "function") return obj[methodNames[idx]].apply(obj, Array.prototype.slice.call(arguments, 0, -1));
                idx += 1;
            }
            if ((0, $7f9038c575da3221$export$2e2bcd8739ae039)(obj)) {
                var transducer = transducerCreator.apply(null, Array.prototype.slice.call(arguments, 0, -1));
                return transducer(obj);
            }
        }
        return fn.apply(this, arguments);
    };
}


function $3dad6d215f19c210$export$2e2bcd8739ae039(x) {
    return x && x["@@transducer/reduced"] ? x : {
        "@@transducer/value": x,
        "@@transducer/reduced": true
    };
}


var $76082f074ee8544d$export$2e2bcd8739ae039 = {
    init: function() {
        return this.xf["@@transducer/init"]();
    },
    result: function(result) {
        return this.xf["@@transducer/result"](result);
    }
};


var $dd4ffbbce0a25d69$var$XAll = /*#__PURE__*/ function() {
    function XAll(f, xf) {
        this.xf = xf;
        this.f = f;
        this.all = true;
    }
    XAll.prototype["@@transducer/init"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XAll.prototype["@@transducer/result"] = function(result) {
        if (this.all) result = this.xf["@@transducer/step"](result, true);
        return this.xf["@@transducer/result"](result);
    };
    XAll.prototype["@@transducer/step"] = function(result, input) {
        if (!this.f(input)) {
            this.all = false;
            result = (0, $3dad6d215f19c210$export$2e2bcd8739ae039)(this.xf["@@transducer/step"](result, false));
        }
        return result;
    };
    return XAll;
}();
function $dd4ffbbce0a25d69$export$2e2bcd8739ae039(f) {
    return function(xf) {
        return new $dd4ffbbce0a25d69$var$XAll(f, xf);
    };
}


/**
 * Returns `true` if all elements of the list match the predicate, `false` if
 * there are any that don't.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
 *         otherwise.
 * @see R.any, R.none, R.transduce
 * @example
 *
 *      const equals3 = R.equals(3);
 *      R.all(equals3)([3, 3, 3, 3]); //=> true
 *      R.all(equals3)([3, 3, 1, 3]); //=> false
 */ var $1d12b48175cb34a5$var$all = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([
    "all"
], (0, $dd4ffbbce0a25d69$export$2e2bcd8739ae039), function all(fn, list) {
    var idx = 0;
    while(idx < list.length){
        if (!fn(list[idx])) return false;
        idx += 1;
    }
    return true;
}));
var $1d12b48175cb34a5$export$2e2bcd8739ae039 = $1d12b48175cb34a5$var$all;







function $68816b8daa6f7201$export$2e2bcd8739ae039(iter) {
    var list = [];
    var next;
    while(!(next = iter.next()).done)list.push(next.value);
    return list;
}


function $c11f7b7011b9d6c6$export$2e2bcd8739ae039(pred, x, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (pred(x, list[idx])) return true;
        idx += 1;
    }
    return false;
}


function $cf04a592ec0bbaa8$export$2e2bcd8739ae039(f) {
    // String(x => x) evaluates to "x => x", so the pattern may not match.
    var match = String(f).match(/^function (\w*)/);
    return match == null ? "" : match[1];
}


function $ca32895e0ecf33fa$export$2e2bcd8739ae039(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}


// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $d08932e9ee9cd837$var$_objectIs(a, b) {
    // SameValue algorithm
    if (a === b) // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
    else // Step 6.a: NaN == NaN
    return a !== a && b !== b;
}
var $d08932e9ee9cd837$export$2e2bcd8739ae039 = typeof Object.is === "function" ? Object.is : $d08932e9ee9cd837$var$_objectIs;





var $546fb9b8321968ae$var$toString = Object.prototype.toString;
var $546fb9b8321968ae$var$_isArguments = /*#__PURE__*/ function() {
    return $546fb9b8321968ae$var$toString.call(arguments) === "[object Arguments]" ? function _isArguments(x) {
        return $546fb9b8321968ae$var$toString.call(x) === "[object Arguments]";
    } : function _isArguments(x) {
        return (0, $ca32895e0ecf33fa$export$2e2bcd8739ae039)("callee", x);
    };
}();
var $546fb9b8321968ae$export$2e2bcd8739ae039 = $546fb9b8321968ae$var$_isArguments;


var $f952fda84f71812a$var$hasEnumBug = !/*#__PURE__*/ ({
    toString: null
}).propertyIsEnumerable("toString");
var $f952fda84f71812a$var$nonEnumerableProps = [
    "constructor",
    "valueOf",
    "isPrototypeOf",
    "toString",
    "propertyIsEnumerable",
    "hasOwnProperty",
    "toLocaleString"
]; // Safari bug
var $f952fda84f71812a$var$hasArgsEnumBug = /*#__PURE__*/ function() {
    "use strict";
    return arguments.propertyIsEnumerable("length");
}();
var $f952fda84f71812a$var$contains = function contains(list, item) {
    var idx = 0;
    while(idx < list.length){
        if (list[idx] === item) return true;
        idx += 1;
    }
    return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values, R.toPairs
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */ var $f952fda84f71812a$var$keys = typeof Object.keys === "function" && !$f952fda84f71812a$var$hasArgsEnumBug ? /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function keys(obj) {
    return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function keys(obj) {
    if (Object(obj) !== obj) return [];
    var prop, nIdx;
    var ks = [];
    var checkArgsLength = $f952fda84f71812a$var$hasArgsEnumBug && (0, $546fb9b8321968ae$export$2e2bcd8739ae039)(obj);
    for(prop in obj)if ((0, $ca32895e0ecf33fa$export$2e2bcd8739ae039)(prop, obj) && (!checkArgsLength || prop !== "length")) ks[ks.length] = prop;
    if ($f952fda84f71812a$var$hasEnumBug) {
        nIdx = $f952fda84f71812a$var$nonEnumerableProps.length - 1;
        while(nIdx >= 0){
            prop = $f952fda84f71812a$var$nonEnumerableProps[nIdx];
            if ((0, $ca32895e0ecf33fa$export$2e2bcd8739ae039)(prop, obj) && !$f952fda84f71812a$var$contains(ks, prop)) ks[ks.length] = prop;
            nIdx -= 1;
        }
    }
    return ks;
});
var $f952fda84f71812a$export$2e2bcd8739ae039 = $f952fda84f71812a$var$keys;



/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig * -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */ var $36c6d07ce28c1b88$var$type = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function type(val) {
    return val === null ? "Null" : val === undefined ? "Undefined" : Object.prototype.toString.call(val).slice(8, -1);
});
var $36c6d07ce28c1b88$export$2e2bcd8739ae039 = $36c6d07ce28c1b88$var$type;


/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparison of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */ function $e6d751f39c4036fe$var$_uniqContentEquals(aIterator, bIterator, stackA, stackB) {
    var a = (0, $68816b8daa6f7201$export$2e2bcd8739ae039)(aIterator);
    var b = (0, $68816b8daa6f7201$export$2e2bcd8739ae039)(bIterator);
    function eq(_a, _b) {
        return $e6d751f39c4036fe$export$2e2bcd8739ae039(_a, _b, stackA.slice(), stackB.slice());
    } // if *a* array contains any element that is not included in *b*
    return !(0, $c11f7b7011b9d6c6$export$2e2bcd8739ae039)(function(b, aItem) {
        return !(0, $c11f7b7011b9d6c6$export$2e2bcd8739ae039)(eq, aItem, b);
    }, b, a);
}
function $e6d751f39c4036fe$export$2e2bcd8739ae039(a, b, stackA, stackB) {
    if ((0, $d08932e9ee9cd837$export$2e2bcd8739ae039)(a, b)) return true;
    var typeA = (0, $36c6d07ce28c1b88$export$2e2bcd8739ae039)(a);
    if (typeA !== (0, $36c6d07ce28c1b88$export$2e2bcd8739ae039)(b)) return false;
    if (typeof a["fantasy-land/equals"] === "function" || typeof b["fantasy-land/equals"] === "function") return typeof a["fantasy-land/equals"] === "function" && a["fantasy-land/equals"](b) && typeof b["fantasy-land/equals"] === "function" && b["fantasy-land/equals"](a);
    if (typeof a.equals === "function" || typeof b.equals === "function") return typeof a.equals === "function" && a.equals(b) && typeof b.equals === "function" && b.equals(a);
    switch(typeA){
        case "Arguments":
        case "Array":
        case "Object":
            if (typeof a.constructor === "function" && (0, $cf04a592ec0bbaa8$export$2e2bcd8739ae039)(a.constructor) === "Promise") return a === b;
            break;
        case "Boolean":
        case "Number":
        case "String":
            if (!(typeof a === typeof b && (0, $d08932e9ee9cd837$export$2e2bcd8739ae039)(a.valueOf(), b.valueOf()))) return false;
            break;
        case "Date":
            if (!(0, $d08932e9ee9cd837$export$2e2bcd8739ae039)(a.valueOf(), b.valueOf())) return false;
            break;
        case "Error":
            return a.name === b.name && a.message === b.message;
        case "RegExp":
            if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) return false;
            break;
    }
    var idx = stackA.length - 1;
    while(idx >= 0){
        if (stackA[idx] === a) return stackB[idx] === b;
        idx -= 1;
    }
    switch(typeA){
        case "Map":
            if (a.size !== b.size) return false;
            return $e6d751f39c4036fe$var$_uniqContentEquals(a.entries(), b.entries(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case "Set":
            if (a.size !== b.size) return false;
            return $e6d751f39c4036fe$var$_uniqContentEquals(a.values(), b.values(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case "Arguments":
        case "Array":
        case "Object":
        case "Boolean":
        case "Number":
        case "String":
        case "Date":
        case "Error":
        case "RegExp":
        case "Int8Array":
        case "Uint8Array":
        case "Uint8ClampedArray":
        case "Int16Array":
        case "Uint16Array":
        case "Int32Array":
        case "Uint32Array":
        case "Float32Array":
        case "Float64Array":
        case "ArrayBuffer":
            break;
        default:
            // Values of other types are only equal if identical.
            return false;
    }
    var keysA = (0, $f952fda84f71812a$export$2e2bcd8739ae039)(a);
    if (keysA.length !== (0, $f952fda84f71812a$export$2e2bcd8739ae039)(b).length) return false;
    var extendedStackA = stackA.concat([
        a
    ]);
    var extendedStackB = stackB.concat([
        b
    ]);
    idx = keysA.length - 1;
    while(idx >= 0){
        var key = keysA[idx];
        if (!((0, $ca32895e0ecf33fa$export$2e2bcd8739ae039)(key, b) && $e6d751f39c4036fe$export$2e2bcd8739ae039(b[key], a[key], extendedStackA, extendedStackB))) return false;
        idx -= 1;
    }
    return true;
}


/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      const a = {}; a.v = a;
 *      const b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */ var $1cb60074c12b9394$var$equals = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function equals(a, b) {
    return (0, $e6d751f39c4036fe$export$2e2bcd8739ae039)(a, b, [], []);
});
var $1cb60074c12b9394$export$2e2bcd8739ae039 = $1cb60074c12b9394$var$equals;


function $a6ee5426c8bff187$export$2e2bcd8739ae039(list, a, idx) {
    var inf, item; // Array.prototype.indexOf doesn't exist below IE9
    if (typeof list.indexOf === "function") switch(typeof a){
        case "number":
            if (a === 0) {
                // manually crawl the list to distinguish between +0 and -0
                inf = 1 / a;
                while(idx < list.length){
                    item = list[idx];
                    if (item === 0 && 1 / item === inf) return idx;
                    idx += 1;
                }
                return -1;
            } else if (a !== a) {
                // NaN
                while(idx < list.length){
                    item = list[idx];
                    if (typeof item === "number" && item !== item) return idx;
                    idx += 1;
                }
                return -1;
            } // non-zero numbers can utilise Set
            return list.indexOf(a, idx);
        // all these types can utilise Set
        case "string":
        case "boolean":
        case "function":
        case "undefined":
            return list.indexOf(a, idx);
        case "object":
            if (a === null) // null can utilise Set
            return list.indexOf(a, idx);
    }
     // anything else not covered above, defer to R.equals
    while(idx < list.length){
        if ((0, $1cb60074c12b9394$export$2e2bcd8739ae039)(list[idx], a)) return idx;
        idx += 1;
    }
    return -1;
}


function $6df6bac8cac02133$export$2e2bcd8739ae039(a, list) {
    return (0, $a6ee5426c8bff187$export$2e2bcd8739ae039)(list, a, 0) >= 0;
}


function $62919b2573dc55d5$export$2e2bcd8739ae039(fn, functor) {
    var idx = 0;
    var len = functor.length;
    var result = Array(len);
    while(idx < len){
        result[idx] = fn(functor[idx]);
        idx += 1;
    }
    return result;
}


function $2a38781964d5ad29$export$2e2bcd8739ae039(s) {
    var escaped = s.replace(/\\/g, "\\\\").replace(/[\b]/g, "\\b") // \b matches word boundary; [\b] matches backspace
    .replace(/\f/g, "\\f").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/\0/g, "\\0");
    return '"' + escaped.replace(/"/g, '\\"') + '"';
}


/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */ var $4df887e48121479a$var$pad = function pad(n) {
    return (n < 10 ? "0" : "") + n;
};
var $4df887e48121479a$var$_toISOString = typeof Date.prototype.toISOString === "function" ? function _toISOString(d) {
    return d.toISOString();
} : function _toISOString(d) {
    return d.getUTCFullYear() + "-" + $4df887e48121479a$var$pad(d.getUTCMonth() + 1) + "-" + $4df887e48121479a$var$pad(d.getUTCDate()) + "T" + $4df887e48121479a$var$pad(d.getUTCHours()) + ":" + $4df887e48121479a$var$pad(d.getUTCMinutes()) + ":" + $4df887e48121479a$var$pad(d.getUTCSeconds()) + "." + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + "Z";
};
var $4df887e48121479a$export$2e2bcd8739ae039 = $4df887e48121479a$var$_toISOString;



function $76b671d1ea92e335$export$2e2bcd8739ae039(f) {
    return function() {
        return !f.apply(this, arguments);
    };
}



function $ca7fefc233c4118f$export$2e2bcd8739ae039(reducer, acc, list) {
    var index = 0;
    var length = list.length;
    while(index < length){
        acc = reducer(acc, list[index]);
        index += 1;
    }
    return acc;
}




function $d9b5d234510a096f$export$2e2bcd8739ae039(fn, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    while(idx < len){
        if (fn(list[idx])) result[result.length] = list[idx];
        idx += 1;
    }
    return result;
}


function $fd0ff931a83ae834$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object Object]";
}



var $73a6ba26e08918bd$var$XFilter = /*#__PURE__*/ function() {
    function XFilter(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFilter.prototype["@@transducer/init"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XFilter.prototype["@@transducer/result"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).result;
    XFilter.prototype["@@transducer/step"] = function(result, input) {
        return this.f(input) ? this.xf["@@transducer/step"](result, input) : result;
    };
    return XFilter;
}();
function $73a6ba26e08918bd$export$2e2bcd8739ae039(f) {
    return function(xf) {
        return new $73a6ba26e08918bd$var$XFilter(f, xf);
    };
}



/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @category Object
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var $a81a10b9c9f23cb7$var$filter = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([
    "fantasy-land/filter",
    "filter"
], (0, $73a6ba26e08918bd$export$2e2bcd8739ae039), function(pred, filterable) {
    return (0, $fd0ff931a83ae834$export$2e2bcd8739ae039)(filterable) ? (0, $ca7fefc233c4118f$export$2e2bcd8739ae039)(function(acc, key) {
        if (pred(filterable[key])) acc[key] = filterable[key];
        return acc;
    }, {}, (0, $f952fda84f71812a$export$2e2bcd8739ae039)(filterable)) : (0, $d9b5d234510a096f$export$2e2bcd8739ae039)(pred, filterable);
}));
var $a81a10b9c9f23cb7$export$2e2bcd8739ae039 = $a81a10b9c9f23cb7$var$filter;


/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      const isOdd = (n) => n % 2 !== 0;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var $89ddad7dee8f4db5$var$reject = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function reject(pred, filterable) {
    return (0, $a81a10b9c9f23cb7$export$2e2bcd8739ae039)((0, $76b671d1ea92e335$export$2e2bcd8739ae039)(pred), filterable);
});
var $89ddad7dee8f4db5$export$2e2bcd8739ae039 = $89ddad7dee8f4db5$var$reject;


function $74b5b553822d1b00$export$2e2bcd8739ae039(x, seen) {
    var recur = function recur(y) {
        var xs = seen.concat([
            x
        ]);
        return (0, $6df6bac8cac02133$export$2e2bcd8739ae039)(y, xs) ? "<Circular>" : $74b5b553822d1b00$export$2e2bcd8739ae039(y, xs);
    }; //  mapPairs :: (Object, [String]) -> [String]
    var mapPairs = function(obj, keys) {
        return (0, $62919b2573dc55d5$export$2e2bcd8739ae039)(function(k) {
            return (0, $2a38781964d5ad29$export$2e2bcd8739ae039)(k) + ": " + recur(obj[k]);
        }, keys.slice().sort());
    };
    switch(Object.prototype.toString.call(x)){
        case "[object Arguments]":
            return "(function() { return arguments; }(" + (0, $62919b2573dc55d5$export$2e2bcd8739ae039)(recur, x).join(", ") + "))";
        case "[object Array]":
            return "[" + (0, $62919b2573dc55d5$export$2e2bcd8739ae039)(recur, x).concat(mapPairs(x, (0, $89ddad7dee8f4db5$export$2e2bcd8739ae039)(function(k) {
                return /^\d+$/.test(k);
            }, (0, $f952fda84f71812a$export$2e2bcd8739ae039)(x)))).join(", ") + "]";
        case "[object Boolean]":
            return typeof x === "object" ? "new Boolean(" + recur(x.valueOf()) + ")" : x.toString();
        case "[object Date]":
            return "new Date(" + (isNaN(x.valueOf()) ? recur(NaN) : (0, $2a38781964d5ad29$export$2e2bcd8739ae039)((0, $4df887e48121479a$export$2e2bcd8739ae039)(x))) + ")";
        case "[object Map]":
            return "new Map(" + recur(Array.from(x)) + ")";
        case "[object Null]":
            return "null";
        case "[object Number]":
            return typeof x === "object" ? "new Number(" + recur(x.valueOf()) + ")" : 1 / x === -Infinity ? "-0" : x.toString(10);
        case "[object Set]":
            return "new Set(" + recur(Array.from(x).sort()) + ")";
        case "[object String]":
            return typeof x === "object" ? "new String(" + recur(x.valueOf()) + ")" : (0, $2a38781964d5ad29$export$2e2bcd8739ae039)(x);
        case "[object Undefined]":
            return "undefined";
        default:
            if (typeof x.toString === "function") {
                var repr = x.toString();
                if (repr !== "[object Object]") return repr;
            }
            return "{" + mapPairs(x, (0, $f952fda84f71812a$export$2e2bcd8739ae039)(x)).join(", ") + "}";
    }
}


/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */ var $c62f1cf5b0b06d2c$var$toString = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function toString(val) {
    return (0, $74b5b553822d1b00$export$2e2bcd8739ae039)(val, []);
});
var $c62f1cf5b0b06d2c$export$2e2bcd8739ae039 = $c62f1cf5b0b06d2c$var$toString;


/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */ var $9170e2306954e853$var$max = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function max(a, b) {
    if (a === b) return b;
    function safeMax(x, y) {
        if (x > y !== y > x) return y > x ? y : x;
        return undefined;
    }
    var maxByValue = safeMax(a, b);
    if (maxByValue !== undefined) return maxByValue;
    var maxByType = safeMax(typeof a, typeof b);
    if (maxByType !== undefined) return maxByType === typeof a ? a : b;
    var stringA = (0, $c62f1cf5b0b06d2c$export$2e2bcd8739ae039)(a);
    var maxByStringValue = safeMax(stringA, (0, $c62f1cf5b0b06d2c$export$2e2bcd8739ae039)(b));
    if (maxByStringValue !== undefined) return maxByStringValue === stringA ? a : b;
    return b;
});
var $9170e2306954e853$export$2e2bcd8739ae039 = $9170e2306954e853$var$max;








var $63490adedc3b2b32$var$XMap = /*#__PURE__*/ function() {
    function XMap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XMap.prototype["@@transducer/init"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XMap.prototype["@@transducer/result"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).result;
    XMap.prototype["@@transducer/step"] = function(result, input) {
        return this.xf["@@transducer/step"](result, this.f(input));
    };
    return XMap;
}();
var $63490adedc3b2b32$var$_xmap = function _xmap(f) {
    return function(xf) {
        return new $63490adedc3b2b32$var$XMap(f, xf);
    };
};
var $63490adedc3b2b32$export$2e2bcd8739ae039 = $63490adedc3b2b32$var$_xmap;




/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex, R.pluck, R.project
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */ var $46e97bbca4e2864f$var$map = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([
    "fantasy-land/map",
    "map"
], (0, $63490adedc3b2b32$export$2e2bcd8739ae039), function map(fn, functor) {
    switch(Object.prototype.toString.call(functor)){
        case "[object Function]":
            return (0, $8bd7b963d2d08f64$export$2e2bcd8739ae039)(functor.length, function() {
                return fn.call(this, functor.apply(this, arguments));
            });
        case "[object Object]":
            return (0, $ca7fefc233c4118f$export$2e2bcd8739ae039)(function(acc, key) {
                acc[key] = fn(functor[key]);
                return acc;
            }, {}, (0, $f952fda84f71812a$export$2e2bcd8739ae039)(functor));
        default:
            return (0, $62919b2573dc55d5$export$2e2bcd8739ae039)(fn, functor);
    }
}));
var $46e97bbca4e2864f$export$2e2bcd8739ae039 = $46e97bbca4e2864f$var$map;



/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */ var $8895c4c9dcfccbb6$export$2e2bcd8739ae039 = Number.isInteger || function _isInteger(n) {
    return n << 0 === n;
};



function $562424274e50089c$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object String]";
}


/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      const list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */ var $6c38596ac956df55$var$nth = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function nth(offset, list) {
    var idx = offset < 0 ? list.length + offset : offset;
    return (0, $562424274e50089c$export$2e2bcd8739ae039)(list) ? list.charAt(idx) : list[idx];
});
var $6c38596ac956df55$export$2e2bcd8739ae039 = $6c38596ac956df55$var$nth;


/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx -> {s: a} -> a | Undefined
 * @param {String|Number} p The property name or array index
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path, R.props, R.pluck, R.project, R.nth
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 *      R.prop(0, [100]); //=> 100
 *      R.compose(R.inc, R.prop('x'))({ x: 3 }) //=> 4
 */ var $f421bed41196907e$var$prop = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function prop(p, obj) {
    if (obj == null) return;
    return (0, $8895c4c9dcfccbb6$export$2e2bcd8739ae039)(p) ? (0, $6c38596ac956df55$export$2e2bcd8739ae039)(p, obj) : obj[p];
});
var $f421bed41196907e$export$2e2bcd8739ae039 = $f421bed41196907e$var$prop;


/**
 * Returns a new list by plucking the same named property off all objects in
 * the list supplied.
 *
 * `pluck` will work on
 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => k -> f {k: v} -> f v
 * @param {Number|String} key The key name to pluck off of each object.
 * @param {Array} f The array or functor to consider.
 * @return {Array} The list of values for the given key.
 * @see R.project, R.prop, R.props
 * @example
 *
 *      var getAges = R.pluck('age');
 *      getAges([{name: 'fred', age: 29}, {name: 'wilma', age: 27}]); //=> [29, 27]
 *
 *      R.pluck(0, [[1, 2], [3, 4]]);               //=> [1, 3]
 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
 */ var $4d87c8cda52638c8$var$pluck = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function pluck(p, list) {
    return (0, $46e97bbca4e2864f$export$2e2bcd8739ae039)((0, $f421bed41196907e$export$2e2bcd8739ae039)(p), list);
});
var $4d87c8cda52638c8$export$2e2bcd8739ae039 = $4d87c8cda52638c8$var$pluck;






/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 *      _isArrayLike({nodeType: 1, length: 1}) // => false
 */ var $94545b0f2c5b5e42$var$_isArrayLike = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function isArrayLike(x) {
    if ((0, $6011f766ba1d1c66$export$2e2bcd8739ae039)(x)) return true;
    if (!x) return false;
    if (typeof x !== "object") return false;
    if ((0, $562424274e50089c$export$2e2bcd8739ae039)(x)) return false;
    if (x.length === 0) return true;
    if (x.length > 0) return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    return false;
});
var $94545b0f2c5b5e42$export$2e2bcd8739ae039 = $94545b0f2c5b5e42$var$_isArrayLike;


var $a9035ffe50e55a09$var$symIterator = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
function $a9035ffe50e55a09$export$2e2bcd8739ae039(arrayReduce, methodReduce, iterableReduce) {
    return function _reduce(xf, acc, list) {
        if ((0, $94545b0f2c5b5e42$export$2e2bcd8739ae039)(list)) return arrayReduce(xf, acc, list);
        if (list == null) return acc;
        if (typeof list["fantasy-land/reduce"] === "function") return methodReduce(xf, acc, list, "fantasy-land/reduce");
        if (list[$a9035ffe50e55a09$var$symIterator] != null) return iterableReduce(xf, acc, list[$a9035ffe50e55a09$var$symIterator]());
        if (typeof list.next === "function") return iterableReduce(xf, acc, list);
        if (typeof list.reduce === "function") return methodReduce(xf, acc, list, "reduce");
        throw new TypeError("reduce: list must be array or iterable");
    };
}


function $77094be990056047$export$2e2bcd8739ae039(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        acc = xf["@@transducer/step"](acc, list[idx]);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        idx += 1;
    }
    return xf["@@transducer/result"](acc);
}




/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */ var $bf4f5b4ff0d7b37f$var$bind = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function bind(fn, thisObj) {
    return (0, $25d67f9135fe3bce$export$2e2bcd8739ae039)(fn.length, function() {
        return fn.apply(thisObj, arguments);
    });
});
var $bf4f5b4ff0d7b37f$export$2e2bcd8739ae039 = $bf4f5b4ff0d7b37f$var$bind;


function $fc6ace3187be0136$var$_xIterableReduce(xf, acc, iter) {
    var step = iter.next();
    while(!step.done){
        acc = xf["@@transducer/step"](acc, step.value);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        step = iter.next();
    }
    return xf["@@transducer/result"](acc);
}
function $fc6ace3187be0136$var$_xMethodReduce(xf, acc, obj, methodName) {
    return xf["@@transducer/result"](obj[methodName]((0, $bf4f5b4ff0d7b37f$export$2e2bcd8739ae039)(xf["@@transducer/step"], xf), acc));
}
var $fc6ace3187be0136$var$_xReduce = /*#__PURE__*/ (0, $a9035ffe50e55a09$export$2e2bcd8739ae039)((0, $77094be990056047$export$2e2bcd8739ae039), $fc6ace3187be0136$var$_xMethodReduce, $fc6ace3187be0136$var$_xIterableReduce);
var $fc6ace3187be0136$export$2e2bcd8739ae039 = $fc6ace3187be0136$var$_xReduce;


var $9ac0dab179ed11f0$var$XWrap = /*#__PURE__*/ function() {
    function XWrap(fn) {
        this.f = fn;
    }
    XWrap.prototype["@@transducer/init"] = function() {
        throw new Error("init not implemented on XWrap");
    };
    XWrap.prototype["@@transducer/result"] = function(acc) {
        return acc;
    };
    XWrap.prototype["@@transducer/step"] = function(acc, x) {
        return this.f(acc, x);
    };
    return XWrap;
}();
function $9ac0dab179ed11f0$export$2e2bcd8739ae039(fn) {
    return new $9ac0dab179ed11f0$var$XWrap(fn);
}


/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Be cautious of mutating and returning the accumulator. If you reuse it across
 * invocations, it will continue to accumulate onto the same value. The general
 * recommendation is to always return a new value. If you can't do so for
 * performance reasons, then be sure to reinitialize the accumulator on each
 * invocation.
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */ var $15e42530af719b84$var$reduce = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function(xf, acc, list) {
    return (0, $fc6ace3187be0136$export$2e2bcd8739ae039)(typeof xf === "function" ? (0, $9ac0dab179ed11f0$export$2e2bcd8739ae039)(xf) : xf, acc, list);
});
var $15e42530af719b84$export$2e2bcd8739ae039 = $15e42530af719b84$var$reduce;


/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if every one of the provided predicates is satisfied
 * by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.anyPass, R.both
 * @example
 *
 *      const isQueen = R.propEq('rank', 'Q');
 *      const isSpade = R.propEq('suit', '♠︎');
 *      const isQueenOfSpades = R.allPass([isQueen, isSpade]);
 *
 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
 */ var $c6454db43b3b452e$var$allPass = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function allPass(preds) {
    return (0, $8bd7b963d2d08f64$export$2e2bcd8739ae039)((0, $15e42530af719b84$export$2e2bcd8739ae039)((0, $9170e2306954e853$export$2e2bcd8739ae039), 0, (0, $4d87c8cda52638c8$export$2e2bcd8739ae039)("length", preds)), function() {
        var idx = 0;
        var len = preds.length;
        while(idx < len){
            if (!preds[idx].apply(this, arguments)) return false;
            idx += 1;
        }
        return true;
    });
});
var $c6454db43b3b452e$export$2e2bcd8739ae039 = $c6454db43b3b452e$var$allPass;



/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      const t = R.always('Tee');
 *      t(); //=> 'Tee'
 */ var $0c56c4792563d166$var$always = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function always(val) {
    return function() {
        return val;
    };
});
var $0c56c4792563d166$export$2e2bcd8739ae039 = $0c56c4792563d166$var$always;



/**
 * Returns the first argument if it is falsy, otherwise the second argument.
 * Acts as the boolean `and` statement if both inputs are `Boolean`s.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any}
 * @see R.both, R.or
 * @example
 *
 *      R.and(true, true); //=> true
 *      R.and(true, false); //=> false
 *      R.and(false, true); //=> false
 *      R.and(false, false); //=> false
 */ var $a3d8a99c7a73ea7b$var$and = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function and(a, b) {
    return a && b;
});
var $a3d8a99c7a73ea7b$export$2e2bcd8739ae039 = $a3d8a99c7a73ea7b$var$and;






var $f9b7fb500a1c3b61$var$XAny = /*#__PURE__*/ function() {
    function XAny(f, xf) {
        this.xf = xf;
        this.f = f;
        this.any = false;
    }
    XAny.prototype["@@transducer/init"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XAny.prototype["@@transducer/result"] = function(result) {
        if (!this.any) result = this.xf["@@transducer/step"](result, false);
        return this.xf["@@transducer/result"](result);
    };
    XAny.prototype["@@transducer/step"] = function(result, input) {
        if (this.f(input)) {
            this.any = true;
            result = (0, $3dad6d215f19c210$export$2e2bcd8739ae039)(this.xf["@@transducer/step"](result, true));
        }
        return result;
    };
    return XAny;
}();
function $f9b7fb500a1c3b61$export$2e2bcd8739ae039(f) {
    return function(xf) {
        return new $f9b7fb500a1c3b61$var$XAny(f, xf);
    };
}


/**
 * Returns `true` if at least one of the elements of the list match the predicate,
 * `false` otherwise.
 *
 * Dispatches to the `any` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
 *         otherwise.
 * @see R.all, R.none, R.transduce
 * @example
 *
 *      const lessThan0 = R.flip(R.lt)(0);
 *      const lessThan2 = R.flip(R.lt)(2);
 *      R.any(lessThan0)([1, 2]); //=> false
 *      R.any(lessThan2)([1, 2]); //=> true
 */ var $f4aab0eed5f4fc76$var$any = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([
    "any"
], (0, $f9b7fb500a1c3b61$export$2e2bcd8739ae039), function any(fn, list) {
    var idx = 0;
    while(idx < list.length){
        if (fn(list[idx])) return true;
        idx += 1;
    }
    return false;
}));
var $f4aab0eed5f4fc76$export$2e2bcd8739ae039 = $f4aab0eed5f4fc76$var$any;







/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if at least one of the provided predicates is
 * satisfied by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.allPass, R.either
 * @example
 *
 *      const isClub = R.propEq('suit', '♣');
 *      const isSpade = R.propEq('suit', '♠');
 *      const isBlackCard = R.anyPass([isClub, isSpade]);
 *
 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
 */ var $1ab4fbacec2785f9$var$anyPass = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function anyPass(preds) {
    return (0, $8bd7b963d2d08f64$export$2e2bcd8739ae039)((0, $15e42530af719b84$export$2e2bcd8739ae039)((0, $9170e2306954e853$export$2e2bcd8739ae039), 0, (0, $4d87c8cda52638c8$export$2e2bcd8739ae039)("length", preds)), function() {
        var idx = 0;
        var len = preds.length;
        while(idx < len){
            if (preds[idx].apply(this, arguments)) return true;
            idx += 1;
        }
        return false;
    });
});
var $1ab4fbacec2785f9$export$2e2bcd8739ae039 = $1ab4fbacec2785f9$var$anyPass;






function $d4bf23f46bf85457$var$_iterableReduce(reducer, acc, iter) {
    var step = iter.next();
    while(!step.done){
        acc = reducer(acc, step.value);
        step = iter.next();
    }
    return acc;
}
function $d4bf23f46bf85457$var$_methodReduce(reducer, acc, obj, methodName) {
    return obj[methodName](reducer, acc);
}
var $d4bf23f46bf85457$var$_reduce = /*#__PURE__*/ (0, $a9035ffe50e55a09$export$2e2bcd8739ae039)((0, $ca7fefc233c4118f$export$2e2bcd8739ae039), $d4bf23f46bf85457$var$_methodReduce, $d4bf23f46bf85457$var$_iterableReduce);
var $d4bf23f46bf85457$export$2e2bcd8739ae039 = $d4bf23f46bf85457$var$_reduce;



/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the first argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @sig (r -> a -> b) -> (r -> a) -> (r -> b)
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 *
 *      // R.ap can also be used as S combinator
 *      // when only two functions are passed
 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */ var $872b35ed3c11e862$var$ap = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function ap(applyF, applyX) {
    return typeof applyX["fantasy-land/ap"] === "function" ? applyX["fantasy-land/ap"](applyF) : typeof applyF.ap === "function" ? applyF.ap(applyX) : typeof applyF === "function" ? function(x) {
        return applyF(x)(applyX(x));
    } : (0, $d4bf23f46bf85457$export$2e2bcd8739ae039)(function(acc, f) {
        return (0, $177bce200a9ffba1$export$2e2bcd8739ae039)(acc, (0, $46e97bbca4e2864f$export$2e2bcd8739ae039)(f, applyX));
    }, [], applyF);
});
var $872b35ed3c11e862$export$2e2bcd8739ae039 = $872b35ed3c11e862$var$ap;


function $b57e7060e0243a5c$export$2e2bcd8739ae039(n, list) {
    var idx = 0;
    var limit = list.length - (n - 1);
    var acc = new Array(limit >= 0 ? limit : 0);
    while(idx < limit){
        acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
        idx += 1;
    }
    return acc;
}






var $a295a4740e0ee720$var$XAperture = /*#__PURE__*/ function() {
    function XAperture(n, xf) {
        this.xf = xf;
        this.pos = 0;
        this.full = false;
        this.acc = new Array(n);
    }
    XAperture.prototype["@@transducer/init"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XAperture.prototype["@@transducer/result"] = function(result) {
        this.acc = null;
        return this.xf["@@transducer/result"](result);
    };
    XAperture.prototype["@@transducer/step"] = function(result, input) {
        this.store(input);
        return this.full ? this.xf["@@transducer/step"](result, this.getCopy()) : result;
    };
    XAperture.prototype.store = function(input) {
        this.acc[this.pos] = input;
        this.pos += 1;
        if (this.pos === this.acc.length) {
            this.pos = 0;
            this.full = true;
        }
    };
    XAperture.prototype.getCopy = function() {
        return (0, $177bce200a9ffba1$export$2e2bcd8739ae039)(Array.prototype.slice.call(this.acc, this.pos), Array.prototype.slice.call(this.acc, 0, this.pos));
    };
    return XAperture;
}();
function $a295a4740e0ee720$export$2e2bcd8739ae039(n) {
    return function(xf) {
        return new $a295a4740e0ee720$var$XAperture(n, xf);
    };
}


/**
 * Returns a new list, composed of n-tuples of consecutive elements. If `n` is
 * greater than the length of the list, an empty list is returned.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @param {Number} n The size of the tuples to create
 * @param {Array} list The list to split into `n`-length tuples
 * @return {Array} The resulting list of `n`-length tuples
 * @see R.transduce
 * @example
 *
 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
 */ var $eb0eb60351fbf412$var$aperture = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([], (0, $a295a4740e0ee720$export$2e2bcd8739ae039), (0, $b57e7060e0243a5c$export$2e2bcd8739ae039)));
var $eb0eb60351fbf412$export$2e2bcd8739ae039 = $eb0eb60351fbf412$var$aperture;




/**
 * Returns a new list containing the contents of the given list, followed by
 * the given element.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The element to add to the end of the new list.
 * @param {Array} list The list of elements to add a new item to.
 *        list.
 * @return {Array} A new list containing the elements of the old list followed by `el`.
 * @see R.prepend
 * @example
 *
 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
 *      R.append('tests', []); //=> ['tests']
 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
 */ var $0a32745b2bdcf705$var$append = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function append(el, list) {
    return (0, $177bce200a9ffba1$export$2e2bcd8739ae039)(list, [
        el
    ]);
});
var $0a32745b2bdcf705$export$2e2bcd8739ae039 = $0a32745b2bdcf705$var$append;



/**
 * Applies function `fn` to the argument list `args`. This is useful for
 * creating a fixed-arity function from a variadic function. `fn` should be a
 * bound function if context is significant.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> a) -> [*] -> a
 * @param {Function} fn The function which will be called with `args`
 * @param {Array} args The arguments to call `fn` with
 * @return {*} result The result, equivalent to `fn(...args)`
 * @see R.call, R.unapply
 * @example
 *
 *      const nums = [1, 2, 3, -99, 42, 6, 7];
 *      R.apply(Math.max, nums); //=> 42
 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
 */ var $e39e8276c535a661$var$apply = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function apply(fn, args) {
    return fn.apply(this, args);
});
var $e39e8276c535a661$export$2e2bcd8739ae039 = $e39e8276c535a661$var$apply;












/**
 * Returns a list of all the enumerable own properties of the supplied object.
 * Note that the order of the output array is not guaranteed across different
 * JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own properties.
 * @see R.valuesIn, R.keys, R.toPairs
 * @example
 *
 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
 */ var $75ec53c87aed334b$var$values = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function values(obj) {
    var props = (0, $f952fda84f71812a$export$2e2bcd8739ae039)(obj);
    var len = props.length;
    var vals = [];
    var idx = 0;
    while(idx < len){
        vals[idx] = obj[props[idx]];
        idx += 1;
    }
    return vals;
});
var $75ec53c87aed334b$export$2e2bcd8739ae039 = $75ec53c87aed334b$var$values;


// delegating calls to .map
function $3b7d6dd9ac95f680$var$mapValues(fn, obj) {
    return (0, $6011f766ba1d1c66$export$2e2bcd8739ae039)(obj) ? obj.map(fn) : (0, $f952fda84f71812a$export$2e2bcd8739ae039)(obj).reduce(function(acc, key) {
        acc[key] = fn(obj[key]);
        return acc;
    }, {});
}
/**
 * Given a spec object recursively mapping properties to functions, creates a
 * function producing an object of the same structure, by mapping each property
 * to the result of calling its associated function with the supplied arguments.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
 * @param {Object} spec an object recursively mapping properties to functions for
 *        producing the values for these properties.
 * @return {Function} A function that returns an object of the same structure
 * as `spec', with each property set to the value returned by calling its
 * associated function with the supplied arguments.
 * @see R.converge, R.juxt
 * @example
 *
 *      const getMetrics = R.applySpec({
 *        sum: R.add,
 *        nested: { mul: R.multiply }
 *      });
 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
 */ var $3b7d6dd9ac95f680$var$applySpec = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function applySpec(spec) {
    spec = $3b7d6dd9ac95f680$var$mapValues(function(v) {
        return typeof v == "function" ? v : applySpec(v);
    }, spec);
    return (0, $8bd7b963d2d08f64$export$2e2bcd8739ae039)((0, $15e42530af719b84$export$2e2bcd8739ae039)((0, $9170e2306954e853$export$2e2bcd8739ae039), 0, (0, $4d87c8cda52638c8$export$2e2bcd8739ae039)("length", (0, $75ec53c87aed334b$export$2e2bcd8739ae039)(spec))), function() {
        var args = arguments;
        return $3b7d6dd9ac95f680$var$mapValues(function(f) {
            return (0, $e39e8276c535a661$export$2e2bcd8739ae039)(f, args);
        }, spec);
    });
});
var $3b7d6dd9ac95f680$export$2e2bcd8739ae039 = $3b7d6dd9ac95f680$var$applySpec;



/**
 * Takes a value and applies a function to it.
 *
 * This function is also known as the `thrush` combinator.
 *
 * @func
 * @memberOf R
 * @since v0.25.0
 * @category Function
 * @sig a -> (a -> b) -> b
 * @param {*} x The value
 * @param {Function} f The function to apply
 * @return {*} The result of applying `f` to `x`
 * @example
 *
 *      const t42 = R.applyTo(42);
 *      t42(R.identity); //=> 42
 *      t42(R.add(1)); //=> 43
 */ var $cce626b841e4fe93$var$applyTo = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function applyTo(x, f) {
    return f(x);
});
var $cce626b841e4fe93$export$2e2bcd8739ae039 = $cce626b841e4fe93$var$applyTo;



/**
 * Makes an ascending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
 * @see R.descend
 * @example
 *
 *      const byAge = R.ascend(R.prop('age'));
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByYoungestFirst = R.sort(byAge, people);
 *        //=> [{ name: 'Mikhail', age: 62 },{ name: 'Emma', age: 70 }, { name: 'Peter', age: 78 }]
 */ var $49898a798e7457d1$var$ascend = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function ascend(fn, a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa < bb ? -1 : aa > bb ? 1 : 0;
});
var $49898a798e7457d1$export$2e2bcd8739ae039 = $49898a798e7457d1$var$ascend;








function $d627dd4056b0db98$export$2e2bcd8739ae039(prop, val, obj) {
    if ((0, $8895c4c9dcfccbb6$export$2e2bcd8739ae039)(prop) && (0, $6011f766ba1d1c66$export$2e2bcd8739ae039)(obj)) {
        var arr = [].concat(obj);
        arr[prop] = val;
        return arr;
    }
    var result = {};
    for(var p in obj)result[p] = obj[p];
    result[prop] = val;
    return result;
}



/**
 * Checks if the input value is `null` or `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
 * @example
 *
 *      R.isNil(null); //=> true
 *      R.isNil(undefined); //=> true
 *      R.isNil(0); //=> false
 *      R.isNil([]); //=> false
 */ var $9cd3c11cb6777784$var$isNil = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function isNil(x) {
    return x == null;
});
var $9cd3c11cb6777784$export$2e2bcd8739ae039 = $9cd3c11cb6777784$var$isNil;


/**
 * Makes a shallow clone of an object, setting or overriding the nodes required
 * to create the given path, and placing the specific value at the tail end of
 * that path. Note that this copies and flattens prototype properties onto the
 * new object as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> a -> {a} -> {a}
 * @param {Array} path the path to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except along the specified path.
 * @see R.dissocPath
 * @example
 *
 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
 *
 *      // Any missing or non-object keys in path will be overridden
 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
 */ var $0aabea20b9ad92d2$var$assocPath = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function assocPath(path, val, obj) {
    if (path.length === 0) return val;
    var idx = path[0];
    if (path.length > 1) {
        var nextObj = !(0, $9cd3c11cb6777784$export$2e2bcd8739ae039)(obj) && (0, $ca32895e0ecf33fa$export$2e2bcd8739ae039)(idx, obj) && typeof obj[idx] === "object" ? obj[idx] : (0, $8895c4c9dcfccbb6$export$2e2bcd8739ae039)(path[1]) ? [] : {};
        val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
    }
    return (0, $d627dd4056b0db98$export$2e2bcd8739ae039)(idx, val, obj);
});
var $0aabea20b9ad92d2$export$2e2bcd8739ae039 = $0aabea20b9ad92d2$var$assocPath;


/**
 * Makes a shallow clone of an object, setting or overriding the specified
 * property with the given value. Note that this copies and flattens prototype
 * properties onto the new object as well. All non-primitive properties are
 * copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig Idx -> a -> {k: v} -> {k: v}
 * @param {String|Number} prop The property name to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except for the changed property.
 * @see R.dissoc, R.pick
 * @example
 *
 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
 */ var $ac9a81c9bab1cafa$var$assoc = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function assoc(prop, val, obj) {
    return (0, $0aabea20b9ad92d2$export$2e2bcd8739ae039)([
        prop
    ], val, obj);
});
var $ac9a81c9bab1cafa$export$2e2bcd8739ae039 = $ac9a81c9bab1cafa$var$assoc;





/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly `n` parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} n The desired arity of the new function.
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity `n`.
 * @see R.binary, R.unary
 * @example
 *
 *      const takesTwoArgs = (a, b) => [a, b];
 *
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      const takesOneArg = R.nAry(1, takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only `n` arguments are passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.nAry(0, f)(a, b) = f()
 * @symb R.nAry(1, f)(a, b) = f(a)
 * @symb R.nAry(2, f)(a, b) = f(a, b)
 */ var $64ef23e24577f0f1$var$nAry = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function nAry(n, fn) {
    switch(n){
        case 0:
            return function() {
                return fn.call(this);
            };
        case 1:
            return function(a0) {
                return fn.call(this, a0);
            };
        case 2:
            return function(a0, a1) {
                return fn.call(this, a0, a1);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.call(this, a0, a1, a2);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.call(this, a0, a1, a2, a3);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.call(this, a0, a1, a2, a3, a4);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.call(this, a0, a1, a2, a3, a4, a5);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);
            };
        default:
            throw new Error("First argument to nAry must be a non-negative integer no greater than ten");
    }
});
var $64ef23e24577f0f1$export$2e2bcd8739ae039 = $64ef23e24577f0f1$var$nAry;


/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 2 parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (a -> b -> c -> ... -> z) -> ((a, b) -> z)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 2.
 * @see R.nAry, R.unary
 * @example
 *
 *      const takesThreeArgs = function(a, b, c) {
 *        return [a, b, c];
 *      };
 *      takesThreeArgs.length; //=> 3
 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
 *
 *      const takesTwoArgs = R.binary(takesThreeArgs);
 *      takesTwoArgs.length; //=> 2
 *      // Only 2 arguments are passed to the wrapped function
 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
 * @symb R.binary(f)(a, b, c) = f(a, b)
 */ var $c01acc2c309da3d9$var$binary = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function binary(fn) {
    return (0, $64ef23e24577f0f1$export$2e2bcd8739ae039)(2, fn);
});
var $c01acc2c309da3d9$export$2e2bcd8739ae039 = $c01acc2c309da3d9$var$binary;




function $3cb1b5de2bca6cb6$export$2e2bcd8739ae039(x) {
    var type = Object.prototype.toString.call(x);
    return type === "[object Function]" || type === "[object AsyncFunction]" || type === "[object GeneratorFunction]" || type === "[object AsyncGeneratorFunction]";
}









/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      const madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */ var $5a38cec7cc080e38$var$liftN = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function liftN(arity, fn) {
    var lifted = (0, $8bd7b963d2d08f64$export$2e2bcd8739ae039)(arity, fn);
    return (0, $8bd7b963d2d08f64$export$2e2bcd8739ae039)(arity, function() {
        return (0, $ca7fefc233c4118f$export$2e2bcd8739ae039)((0, $872b35ed3c11e862$export$2e2bcd8739ae039), (0, $46e97bbca4e2864f$export$2e2bcd8739ae039)(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
    });
});
var $5a38cec7cc080e38$export$2e2bcd8739ae039 = $5a38cec7cc080e38$var$liftN;


/**
 * "lifts" a function of arity >= 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      const madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([100, 200], [30, 40], [5, 6, 7]); //=> [135, 136, 137, 145, 146, 147, 235, 236, 237, 245, 246, 247]
 *
 *      const madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([10, 20], [1], [2, 3], [4], [100, 200]); //=> [117, 217, 118, 218, 127, 227, 128, 228]
 */ var $199d21449f525f36$var$lift = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function lift(fn) {
    return (0, $5a38cec7cc080e38$export$2e2bcd8739ae039)(fn.length, fn);
});
var $199d21449f525f36$export$2e2bcd8739ae039 = $199d21449f525f36$var$lift;


/**
 * A function which calls the two provided functions and returns the `&&`
 * of the results.
 * It returns the result of the first function if it is false-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * false-y value.
 *
 * In addition to functions, `R.both` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f A predicate
 * @param {Function} g Another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
 * @see R.either, R.allPass, R.and
 * @example
 *
 *      const gt10 = R.gt(R.__, 10)
 *      const lt20 = R.lt(R.__, 20)
 *      const f = R.both(gt10, lt20);
 *      f(15); //=> true
 *      f(30); //=> false
 *
 *      R.both(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(false)
 *      R.both([false, false, 'a'], [11]); //=> [false, false, 11]
 */ var $15c2c13d0529ab85$var$both = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function both(f, g) {
    return (0, $3cb1b5de2bca6cb6$export$2e2bcd8739ae039)(f) ? function _both() {
        return f.apply(this, arguments) && g.apply(this, arguments);
    } : (0, $199d21449f525f36$export$2e2bcd8739ae039)((0, $a3d8a99c7a73ea7b$export$2e2bcd8739ae039))(f, g);
});
var $15c2c13d0529ab85$export$2e2bcd8739ae039 = $15c2c13d0529ab85$var$both;



/**
 * Returns the result of calling its first argument with the remaining
 * arguments. This is occasionally useful as a converging function for
 * [`R.converge`](#converge): the first branch can produce a function while the
 * remaining branches produce values to be passed to that function as its
 * arguments.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig ((*... -> a), *...) -> a
 * @param {Function} fn The function to apply to the remaining arguments.
 * @param {...*} args Any number of positional arguments.
 * @return {*}
 * @see R.apply
 * @example
 *
 *      R.call(R.add, 1, 2); //=> 3
 *
 *      const indentN = R.pipe(
 *        R.repeat(' '),
 *        R.join(''),
 *        R.replace(/^(?!$)/gm)
 *      );
 *
 *      const format = R.converge(
 *        R.call,
 *        [
 *          R.pipe(R.prop('indent'), indentN),
 *          R.prop('value')
 *        ]
 *      );
 *
 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
 * @symb R.call(f, a, b) = f(a, b)
 */ var $7ecc10519b6e40dc$var$call = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function call(fn) {
    return fn.apply(this, Array.prototype.slice.call(arguments, 1));
});
var $7ecc10519b6e40dc$export$2e2bcd8739ae039 = $7ecc10519b6e40dc$var$call;





function $8057b2e3915e5f14$export$2e2bcd8739ae039(recursive) {
    return function flatt(list) {
        var value, jlen, j;
        var result = [];
        var idx = 0;
        var ilen = list.length;
        while(idx < ilen){
            if ((0, $94545b0f2c5b5e42$export$2e2bcd8739ae039)(list[idx])) {
                value = recursive ? flatt(list[idx]) : list[idx];
                j = 0;
                jlen = value.length;
                while(j < jlen){
                    result[result.length] = value[j];
                    j += 1;
                }
            } else result[result.length] = list[idx];
            idx += 1;
        }
        return result;
    };
}


function $96f283436d2dc595$export$2e2bcd8739ae039(x) {
    return {
        "@@transducer/value": x,
        "@@transducer/reduced": true
    };
}






var $1f9a3379edec6f6f$var$tInit = "@@transducer/init";
var $1f9a3379edec6f6f$var$tStep = "@@transducer/step";
var $1f9a3379edec6f6f$var$tResult = "@@transducer/result";
var $1f9a3379edec6f6f$var$XPreservingReduced = /*#__PURE__*/ function() {
    function XPreservingReduced(xf) {
        this.xf = xf;
    }
    XPreservingReduced.prototype[$1f9a3379edec6f6f$var$tInit] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XPreservingReduced.prototype[$1f9a3379edec6f6f$var$tResult] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).result;
    XPreservingReduced.prototype[$1f9a3379edec6f6f$var$tStep] = function(result, input) {
        var ret = this.xf[$1f9a3379edec6f6f$var$tStep](result, input);
        return ret["@@transducer/reduced"] ? (0, $96f283436d2dc595$export$2e2bcd8739ae039)(ret) : ret;
    };
    return XPreservingReduced;
}();
var $1f9a3379edec6f6f$var$XFlatCat = /*#__PURE__*/ function() {
    function XFlatCat(xf) {
        this.xf = new $1f9a3379edec6f6f$var$XPreservingReduced(xf);
    }
    XFlatCat.prototype[$1f9a3379edec6f6f$var$tInit] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XFlatCat.prototype[$1f9a3379edec6f6f$var$tResult] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).result;
    XFlatCat.prototype[$1f9a3379edec6f6f$var$tStep] = function(result, input) {
        return !(0, $94545b0f2c5b5e42$export$2e2bcd8739ae039)(input) ? (0, $77094be990056047$export$2e2bcd8739ae039)(this.xf, result, [
            input
        ]) : (0, $fc6ace3187be0136$export$2e2bcd8739ae039)(this.xf, result, input);
    };
    return XFlatCat;
}();
var $1f9a3379edec6f6f$var$_flatCat = function _xcat(xf) {
    return new $1f9a3379edec6f6f$var$XFlatCat(xf);
};
var $1f9a3379edec6f6f$export$2e2bcd8739ae039 = $1f9a3379edec6f6f$var$_flatCat;



function $f71cc1657e72453e$export$2e2bcd8739ae039(f) {
    return function(xf) {
        return (0, $63490adedc3b2b32$export$2e2bcd8739ae039)(f)((0, $1f9a3379edec6f6f$export$2e2bcd8739ae039)(xf));
    };
}



/**
 * `chain` maps a function over a list and concatenates the results. `chain`
 * is also known as `flatMap` in some libraries.
 *
 * Dispatches to the `chain` method of the second argument, if present,
 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
 *
 * If second argument is a function, `chain(f, g)(x)` is equivalent to `f(g(x), x)`.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain m => (a -> m b) -> m a -> m b
 * @param {Function} fn The function to map with
 * @param {Array} list The list to map over
 * @return {Array} The result of flat-mapping `list` with `fn`
 * @example
 *
 *      const duplicate = n => [n, n];
 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
 *
 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
 */ var $58070c59674af918$var$chain = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([
    "fantasy-land/chain",
    "chain"
], (0, $f71cc1657e72453e$export$2e2bcd8739ae039), function chain(fn, monad) {
    if (typeof monad === "function") return function(x) {
        return fn(monad(x))(x);
    };
    return (0, $8057b2e3915e5f14$export$2e2bcd8739ae039)(false)((0, $46e97bbca4e2864f$export$2e2bcd8739ae039)(fn, monad));
}));
var $58070c59674af918$export$2e2bcd8739ae039 = $58070c59674af918$var$chain;



/**
 * Restricts a number to be within a range.
 *
 * Also works for other ordered types such as Strings and Dates.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Relation
 * @sig Ord a => a -> a -> a -> a
 * @param {Number} minimum The lower limit of the clamp (inclusive)
 * @param {Number} maximum The upper limit of the clamp (inclusive)
 * @param {Number} value Value to be clamped
 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
 * @example
 *
 *      R.clamp(1, 10, -5) // => 1
 *      R.clamp(1, 10, 15) // => 10
 *      R.clamp(1, 10, 4)  // => 4
 */ var $00b923482b9db37c$var$clamp = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function clamp(min, max, value) {
    if (min > max) throw new Error("min must not be greater than max in clamp(min, max, value)");
    return value < min ? min : value > max ? max : value;
});
var $00b923482b9db37c$export$2e2bcd8739ae039 = $00b923482b9db37c$var$clamp;


function $eab78890c78f3c65$export$2e2bcd8739ae039(pattern) {
    return new RegExp(pattern.source, pattern.flags ? pattern.flags : (pattern.global ? "g" : "") + (pattern.ignoreCase ? "i" : "") + (pattern.multiline ? "m" : "") + (pattern.sticky ? "y" : "") + (pattern.unicode ? "u" : "") + (pattern.dotAll ? "s" : ""));
}



function $71dce7a34b6bfe2c$export$2e2bcd8739ae039(value, deep, map) {
    map || (map = new $71dce7a34b6bfe2c$var$_ObjectMap()); // this avoids the slower switch with a quick if decision removing some milliseconds in each run.
    if ($71dce7a34b6bfe2c$var$_isPrimitive(value)) return value;
    var copy = function copy(copiedValue) {
        // Check for circular and same references on the object graph and return its corresponding clone.
        var cachedCopy = map.get(value);
        if (cachedCopy) return cachedCopy;
        map.set(value, copiedValue);
        for(var key in value)if (Object.prototype.hasOwnProperty.call(value, key)) copiedValue[key] = deep ? $71dce7a34b6bfe2c$export$2e2bcd8739ae039(value[key], true, map) : value[key];
        return copiedValue;
    };
    switch((0, $36c6d07ce28c1b88$export$2e2bcd8739ae039)(value)){
        case "Object":
            return copy(Object.create(Object.getPrototypeOf(value)));
        case "Array":
            return copy([]);
        case "Date":
            return new Date(value.valueOf());
        case "RegExp":
            return (0, $eab78890c78f3c65$export$2e2bcd8739ae039)(value);
        case "Int8Array":
        case "Uint8Array":
        case "Uint8ClampedArray":
        case "Int16Array":
        case "Uint16Array":
        case "Int32Array":
        case "Uint32Array":
        case "Float32Array":
        case "Float64Array":
        case "BigInt64Array":
        case "BigUint64Array":
            return value.slice();
        default:
            return value;
    }
}
function $71dce7a34b6bfe2c$var$_isPrimitive(param) {
    var type = typeof param;
    return param == null || type != "object" && type != "function";
}
var $71dce7a34b6bfe2c$var$_ObjectMap = /*#__PURE__*/ function() {
    function _ObjectMap() {
        this.map = {};
        this.length = 0;
    }
    _ObjectMap.prototype.set = function(key, value) {
        const hashedKey = this.hash(key);
        let bucket = this.map[hashedKey];
        if (!bucket) this.map[hashedKey] = bucket = [];
        bucket.push([
            key,
            value
        ]);
        this.length += 1;
    };
    _ObjectMap.prototype.hash = function(key) {
        let hashedKey = [];
        for(var value in key)hashedKey.push(Object.prototype.toString.call(key[value]));
        return hashedKey.join();
    };
    _ObjectMap.prototype.get = function(key) {
        /**
     * depending on the number of objects to be cloned is faster to just iterate over the items in the map just because the hash function is so costly,
     * on my tests this number is 180, anything above that using the hash function is faster.
     */ if (this.length <= 180) {
            for(const p in this.map){
                const bucket = this.map[p];
                for(let i = 0; i < bucket.length; i += 1){
                    const element = bucket[i];
                    if (element[0] === key) return element[1];
                }
            }
            return;
        }
        const hashedKey = this.hash(key);
        const bucket = this.map[hashedKey];
        if (!bucket) return;
        for(let i = 0; i < bucket.length; i += 1){
            const element = bucket[i];
            if (element[0] === key) return element[1];
        }
    };
    return _ObjectMap;
}();



/**
 * Creates a deep copy of the source that can be used in place of the source
 * object without retaining any references to it.
 * The source object may contain (nested) `Array`s and `Object`s,
 * `Number`s, `String`s, `Boolean`s and `Date`s.
 * `Function`s are assigned by reference rather than copied.
 *
 * Dispatches to a `clone` method if present.
 *
 * Note that if the source object has multiple nodes that share a reference,
 * the returned object will have the same structure, but the references will
 * be pointed to the location within the cloned value.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {*} -> {*}
 * @param {*} value The object or array to clone
 * @return {*} A deeply cloned copy of `val`
 * @example
 *
 *      const objects = [{}, {}, {}];
 *      const objectsClone = R.clone(objects);
 *      objects === objectsClone; //=> false
 *      objects[0] === objectsClone[0]; //=> false
 */ var $5c54b4ed00f92e13$var$clone = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function clone(value) {
    return value != null && typeof value.clone === "function" ? value.clone() : (0, $71dce7a34b6bfe2c$export$2e2bcd8739ae039)(value, true);
});
var $5c54b4ed00f92e13$export$2e2bcd8739ae039 = $5c54b4ed00f92e13$var$clone;




/**
 * Splits a list into sub-lists, based on the result of calling a key-returning function on each element,
 * and grouping the results according to values returned.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category List
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx a => (b -> a) -> [b] -> [[b]]
 * @param {Function} fn Function :: a -> Idx
 * @param {Array} list The array to group
 * @return {Array}
 *    An array of arrays where each sub-array contains items for which
 *    the String-returning function has returned the same value.
 * @see R.groupBy, R.partition
 * @example
 *      R.collectBy(R.prop('type'), [
 *        {type: 'breakfast', item: '☕️'},
 *        {type: 'lunch', item: '🌯'},
 *        {type: 'dinner', item: '🍝'},
 *        {type: 'breakfast', item: '🥐'},
 *        {type: 'lunch', item: '🍕'}
 *      ]);
 *
 *      // [ [ {type: 'breakfast', item: '☕️'},
 *      //     {type: 'breakfast', item: '🥐'} ],
 *      //   [ {type: 'lunch', item: '🌯'},
 *      //     {type: 'lunch', item: '🍕'} ],
 *      //   [ {type: 'dinner', item: '🍝'} ] ]
 */ var $35886fc076a21590$var$collectBy = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function collectBy(fn, list) {
    var group = (0, $d4bf23f46bf85457$export$2e2bcd8739ae039)(function(o, x) {
        var tag = fn(x);
        if (o[tag] === undefined) o[tag] = [];
        o[tag].push(x);
        return o;
    }, {}, list);
    var newList = [];
    for(var tag in group)newList.push(group[tag]);
    return newList;
});
var $35886fc076a21590$export$2e2bcd8739ae039 = $35886fc076a21590$var$collectBy;



/**
 * Makes a comparator function out of a function that reports whether the first
 * element is less than the second.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b) -> Boolean) -> ((a, b) -> Number)
 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
 * is less than the second, `false` otherwise
 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
 * @example
 *
 *      const byAge = R.comparator((a, b) => a.age < b.age);
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByIncreasingAge = R.sort(byAge, people);
 *        //=> [{ name: 'Mikhail', age: 62 },{ name: 'Emma', age: 70 }, { name: 'Peter', age: 78 }]
 */ var $07f16dd3307207b2$var$comparator = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function comparator(pred) {
    return function(a, b) {
        return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
    };
});
var $07f16dd3307207b2$export$2e2bcd8739ae039 = $07f16dd3307207b2$var$comparator;




/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */ var $4e3f7226d4a2a658$var$not = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function not(a) {
    return !a;
});
var $4e3f7226d4a2a658$export$2e2bcd8739ae039 = $4e3f7226d4a2a658$var$not;


/**
 * Takes a function `f` and returns a function `g` such that if called with the same arguments
 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
 *
 * `R.complement` may be applied to any functor
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> *) -> (*... -> Boolean)
 * @param {Function} f
 * @return {Function}
 * @see R.not
 * @example
 *
 *      const isNotNil = R.complement(R.isNil);
 *      R.isNil(null); //=> true
 *      isNotNil(null); //=> false
 *      R.isNil(7); //=> false
 *      isNotNil(7); //=> true
 */ var $b5deb87cb68955a8$var$complement = /*#__PURE__*/ (0, $199d21449f525f36$export$2e2bcd8739ae039)((0, $4e3f7226d4a2a658$export$2e2bcd8739ae039));
var $b5deb87cb68955a8$export$2e2bcd8739ae039 = $b5deb87cb68955a8$var$complement;



function $96cdc4266513e0ea$export$2e2bcd8739ae039(f, g) {
    return function() {
        return g.call(this, f.apply(this, arguments));
    };
}




function $3992793a26ae17b7$export$2e2bcd8739ae039(methodname, fn) {
    return function() {
        var length = arguments.length;
        if (length === 0) return fn();
        var obj = arguments[length - 1];
        return (0, $6011f766ba1d1c66$export$2e2bcd8739ae039)(obj) || typeof obj[methodname] !== "function" ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
}





/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */ var $8c8a51bb580162a2$var$slice = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3992793a26ae17b7$export$2e2bcd8739ae039)("slice", function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
var $8c8a51bb580162a2$export$2e2bcd8739ae039 = $8c8a51bb580162a2$var$slice;


/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */ var $9c9465a7318d5e7e$var$tail = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3992793a26ae17b7$export$2e2bcd8739ae039)("tail", /*#__PURE__*/ (0, $8c8a51bb580162a2$export$2e2bcd8739ae039)(1, Infinity)));
var $9c9465a7318d5e7e$export$2e2bcd8739ae039 = $9c9465a7318d5e7e$var$tail;


function $9b6e48c21d14460d$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("pipe requires at least one argument");
    return (0, $25d67f9135fe3bce$export$2e2bcd8739ae039)(arguments[0].length, (0, $15e42530af719b84$export$2e2bcd8739ae039)((0, $96cdc4266513e0ea$export$2e2bcd8739ae039), arguments[0], (0, $9c9465a7318d5e7e$export$2e2bcd8739ae039)(arguments)));
}




/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */ var $28d963acd164b9b4$var$reverse = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function reverse(list) {
    return (0, $562424274e50089c$export$2e2bcd8739ae039)(list) ? list.split("").reverse().join("") : Array.prototype.slice.call(list, 0).reverse();
});
var $28d963acd164b9b4$export$2e2bcd8739ae039 = $28d963acd164b9b4$var$reverse;


function $85fe9a8e58cb3d1b$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("compose requires at least one argument");
    return (0, $9b6e48c21d14460d$export$2e2bcd8739ae039).apply(this, (0, $28d963acd164b9b4$export$2e2bcd8739ae039)(arguments));
}






/**
 * Returns the first element of the given list or string. In some libraries
 * this function is named `first`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {Array|String} list
 * @return {*}
 * @see R.tail, R.init, R.last
 * @example
 *
 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
 *      R.head([]); //=> undefined
 *
 *      R.head('abc'); //=> 'a'
 *      R.head(''); //=> ''
 */ var $e42cf772adf9350b$var$head = /*#__PURE__*/ (0, $6c38596ac956df55$export$2e2bcd8739ae039)(0);
var $e42cf772adf9350b$export$2e2bcd8739ae039 = $e42cf772adf9350b$var$head;





function $b3328d336dcab159$export$2e2bcd8739ae039(x) {
    return x;
}


/**
 * A function that does nothing but return the parameter supplied to it. Good
 * as a default or placeholder function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> a
 * @param {*} x The value to return.
 * @return {*} The input value, `x`.
 * @example
 *
 *      R.identity(1); //=> 1
 *
 *      const obj = {};
 *      R.identity(obj) === obj; //=> true
 * @symb R.identity(a) = a
 */ var $6303b64a517886ce$var$identity = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)((0, $b3328d336dcab159$export$2e2bcd8739ae039));
var $6303b64a517886ce$export$2e2bcd8739ae039 = $6303b64a517886ce$var$identity;


/**
 * Performs left-to-right function composition using transforming function. The first function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of pipeWith is not automatically curried. Transforming function is not used on the
 * first argument.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig ((* -> *), [((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)]) -> ((a, b, ..., n) -> z)
 * @param {Function} transformer The transforming function
 * @param {Array} functions The functions to pipe
 * @return {Function}
 * @see R.composeWith, R.pipe
 * @example
 *
 *      const pipeWhileNotNil = R.pipeWith((f, res) => R.isNil(res) ? res : f(res));
 *      const f = pipeWhileNotNil([Math.pow, R.negate, R.inc])
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipeWith(f)([g, h, i])(...args) = f(i, f(h, g(...args)))
 */ var $881adb9a000a4b17$var$pipeWith = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function pipeWith(xf, list) {
    if (list.length <= 0) return 0, $6303b64a517886ce$export$2e2bcd8739ae039;
    var headList = (0, $e42cf772adf9350b$export$2e2bcd8739ae039)(list);
    var tailList = (0, $9c9465a7318d5e7e$export$2e2bcd8739ae039)(list);
    return (0, $25d67f9135fe3bce$export$2e2bcd8739ae039)(headList.length, function() {
        return (0, $d4bf23f46bf85457$export$2e2bcd8739ae039)(function(result, f) {
            return xf.call(this, f, result);
        }, headList.apply(this, arguments), tailList);
    });
});
var $881adb9a000a4b17$export$2e2bcd8739ae039 = $881adb9a000a4b17$var$pipeWith;



/**
 * Performs right-to-left function composition using transforming function. The last function may have
 * any arity; the remaining functions must be unary. Unlike `compose`, functions are passed in an array.
 *
 * **Note:** The result of composeWith is not automatically curried. Transforming function is not used
 * on the last argument.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig ((* -> *), [(y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)]) -> ((a, b, ..., n) -> z)
 * @param {Function} transformer The transforming function
 * @param {Array} functions The functions to compose
 * @return {Function}
 * @see R.compose, R.pipeWith
 * @example
 *
 *      const composeWhileNotNil = R.composeWith((f, res) => R.isNil(res) ? res : f(res));
 *
 *      composeWhileNotNil([R.inc, R.prop('age')])({age: 1}) //=> 2
 *      composeWhileNotNil([R.inc, R.prop('age')])({}) //=> undefined
 *
 * @symb R.composeWith(f)([g, h, i])(...args) = f(g, f(h, i(...args)))
 */ var $eeffcdc6d26d98c8$var$composeWith = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function composeWith(xf, list) {
    return (0, $881adb9a000a4b17$export$2e2bcd8739ae039).apply(this, [
        xf,
        (0, $28d963acd164b9b4$export$2e2bcd8739ae039)(list)
    ]);
});
var $eeffcdc6d26d98c8$export$2e2bcd8739ae039 = $eeffcdc6d26d98c8$var$composeWith;







/**
 * Returns the result of concatenating the given lists or strings.
 *
 * Note: `R.concat` expects both arguments to be of the same type,
 * unlike the native `Array.prototype.concat` method. It will throw
 * an error if you `concat` an Array with a non-Array value.
 *
 * Dispatches to the `concat` method of the first argument, if present.
 * Can also concatenate two members of a [fantasy-land
 * compatible semigroup](https://github.com/fantasyland/fantasy-land#semigroup).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @sig String -> String -> String
 * @param {Array|String} firstList The first list
 * @param {Array|String} secondList The second list
 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
 * `secondList`.
 *
 * @example
 *
 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 *      R.concat([], []); //=> []
 */ var $471c6227d5038add$var$concat = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function concat(a, b) {
    if ((0, $6011f766ba1d1c66$export$2e2bcd8739ae039)(a)) {
        if ((0, $6011f766ba1d1c66$export$2e2bcd8739ae039)(b)) return a.concat(b);
        throw new TypeError((0, $c62f1cf5b0b06d2c$export$2e2bcd8739ae039)(b) + " is not an array");
    }
    if ((0, $562424274e50089c$export$2e2bcd8739ae039)(a)) {
        if ((0, $562424274e50089c$export$2e2bcd8739ae039)(b)) return a + b;
        throw new TypeError((0, $c62f1cf5b0b06d2c$export$2e2bcd8739ae039)(b) + " is not a string");
    }
    if (a != null && (0, $3cb1b5de2bca6cb6$export$2e2bcd8739ae039)(a["fantasy-land/concat"])) return a["fantasy-land/concat"](b);
    if (a != null && (0, $3cb1b5de2bca6cb6$export$2e2bcd8739ae039)(a.concat)) return a.concat(b);
    throw new TypeError((0, $c62f1cf5b0b06d2c$export$2e2bcd8739ae039)(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
});
var $471c6227d5038add$export$2e2bcd8739ae039 = $471c6227d5038add$var$concat;







/**
 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
 * to `fn` are applied to each of the predicates in turn until one returns a
 * "truthy" value, at which point `fn` returns the result of applying its
 * arguments to the corresponding transformer. If none of the predicates
 * matches, `fn` returns undefined.
 *
 * **Please note**: This is not a direct substitute for a `switch` statement.
 * Remember that both elements of every pair passed to `cond` are *functions*,
 * and `cond` returns a function.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Logic
 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
 * @param {Array} pairs A list of [predicate, transformer]
 * @return {Function}
 * @see R.ifElse, R.unless, R.when
 * @example
 *
 *      const fn = R.cond([
 *        [R.equals(0),   R.always('water freezes at 0°C')],
 *        [R.equals(100), R.always('water boils at 100°C')],
 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
 *      ]);
 *      fn(0); //=> 'water freezes at 0°C'
 *      fn(50); //=> 'nothing special happens at 50°C'
 *      fn(100); //=> 'water boils at 100°C'
 */ var $d736906110083e3a$var$cond = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function cond(pairs) {
    var arity = (0, $15e42530af719b84$export$2e2bcd8739ae039)((0, $9170e2306954e853$export$2e2bcd8739ae039), 0, (0, $46e97bbca4e2864f$export$2e2bcd8739ae039)(function(pair) {
        return pair[0].length;
    }, pairs));
    return (0, $25d67f9135fe3bce$export$2e2bcd8739ae039)(arity, function() {
        var idx = 0;
        while(idx < pairs.length){
            if (pairs[idx][0].apply(this, arguments)) return pairs[idx][1].apply(this, arguments);
            idx += 1;
        }
    });
});
var $d736906110083e3a$export$2e2bcd8739ae039 = $d736906110083e3a$var$cond;






/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * Please note that default parameters don't count towards a [function arity](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/length)
 * and therefore `curry` won't work well with those:
 *
 * ```
 * const h = R.curry((a, b, c = 2) => a + b + c);
 *
 * h(40);
 * //=> function (waits for `b`)
 *
 * h(39)(1);
 * //=> 42
 *
 * h(1)(2, 3);
 * //=> 6
 *
 * h(1)(2)(7);
 * //=> Error! (`3` is not a function!)
 * ```
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN, R.partial
 * @example
 *
 *      const addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      const curriedAddFourNumbers = R.curry(addFourNumbers);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $4173ee961b2fe294$var$curry = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function curry(fn) {
    return (0, $8bd7b963d2d08f64$export$2e2bcd8739ae039)(fn.length, fn);
});
var $4173ee961b2fe294$export$2e2bcd8739ae039 = $4173ee961b2fe294$var$curry;



/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type. The arity of the function
 * returned is specified to allow using variadic constructor functions.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Function
 * @sig Number -> (* -> {*}) -> (* -> {*})
 * @param {Number} n The arity of the constructor function.
 * @param {Function} Fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @example
 *
 *      // Variadic Constructor function
 *      function Salad() {
 *        this.ingredients = arguments;
 *      }
 *
 *      Salad.prototype.recipe = function() {
 *        const instructions = R.map(ingredient => 'Add a dollop of ' + ingredient, this.ingredients);
 *        return R.join('\n', instructions);
 *      };
 *
 *      const ThreeLayerSalad = R.constructN(3, Salad);
 *
 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
 *      const salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup');
 *
 *      console.log(salad.recipe());
 *      // Add a dollop of Mayonnaise
 *      // Add a dollop of Potato Chips
 *      // Add a dollop of Ketchup
 */ var $7c2de1887ed8584e$var$constructN = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function constructN(n, Fn) {
    if (n > 10) throw new Error("Constructor with greater than ten arguments");
    if (n === 0) return function() {
        return new Fn();
    };
    return (0, $4173ee961b2fe294$export$2e2bcd8739ae039)((0, $64ef23e24577f0f1$export$2e2bcd8739ae039)(n, function($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
        switch(n){
            case 1:
                return new Fn($0);
            case 2:
                return new Fn($0, $1);
            case 3:
                return new Fn($0, $1, $2);
            case 4:
                return new Fn($0, $1, $2, $3);
            case 5:
                return new Fn($0, $1, $2, $3, $4);
            case 6:
                return new Fn($0, $1, $2, $3, $4, $5);
            case 7:
                return new Fn($0, $1, $2, $3, $4, $5, $6);
            case 8:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
            case 9:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
            case 10:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
        }
    }));
});
var $7c2de1887ed8584e$export$2e2bcd8739ae039 = $7c2de1887ed8584e$var$constructN;


/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> {*}) -> (* -> {*})
 * @param {Function} fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @see R.invoker
 * @example
 *
 *      // Constructor function
 *      function Animal(kind) {
 *        this.kind = kind;
 *      };
 *      Animal.prototype.sighting = function() {
 *        return "It's a " + this.kind + "!";
 *      }
 *
 *      const AnimalConstructor = R.construct(Animal)
 *
 *      // Notice we no longer need the 'new' keyword:
 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
 *
 *      const animalTypes = ["Lion", "Tiger", "Bear"];
 *      const animalSighting = R.invoker(0, 'sighting');
 *      const sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
 */ var $af6e4bd9a8ae2893$var$construct = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function construct(Fn) {
    return (0, $7c2de1887ed8584e$export$2e2bcd8739ae039)(Fn.length, Fn);
});
var $af6e4bd9a8ae2893$export$2e2bcd8739ae039 = $af6e4bd9a8ae2893$var$construct;









/**
 * Accepts a converging function and a list of branching functions and returns
 * a new function. The arity of the new function is the same as the arity of
 * the longest branching function. When invoked, this new function is applied
 * to some arguments, and each branching function is applied to those same
 * arguments. The results of each branching function are passed as arguments
 * to the converging function to produce the return value.
 *
 * @func
 * @memberOf R
 * @since v0.4.2
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [((a, b, ...) -> x1), ((a, b, ...) -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} after A function. `after` will be invoked with the return values of
 *        `fn1` and `fn2` as its arguments.
 * @param {Array} functions A list of functions.
 * @return {Function} A new function.
 * @see R.useWith
 * @example
 *
 *      const average = R.converge(R.divide, [R.sum, R.length])
 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
 *
 *      const strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
 *      strangeConcat("Yodel") //=> "YODELyodel"
 *
 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
 */ var $8635059754596aea$var$converge = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function converge(after, fns) {
    return (0, $8bd7b963d2d08f64$export$2e2bcd8739ae039)((0, $15e42530af719b84$export$2e2bcd8739ae039)((0, $9170e2306954e853$export$2e2bcd8739ae039), 0, (0, $4d87c8cda52638c8$export$2e2bcd8739ae039)("length", fns)), function() {
        var args = arguments;
        var context = this;
        return after.apply(context, (0, $62919b2573dc55d5$export$2e2bcd8739ae039)(function(fn) {
            return fn.apply(context, args);
        }, fns));
    });
});
var $8635059754596aea$export$2e2bcd8739ae039 = $8635059754596aea$var$converge;




/**
 * Returns the number of items in a given `list` matching the predicate `f`
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} predicate to match items against
 * @return {Array} list of items to count in
 * @example
 *
 *      const even = x => x % 2 == 0;
 *
 *      R.count(even, [1, 2, 3, 4, 5]); // => 2
 *      R.map(R.count(even), [[1, 1, 1], [2, 3, 4, 5], [6]]); // => [0, 2, 1]
 */ var $df07b296093309ba$var$count = /*#__PURE__*/ (0, $4173ee961b2fe294$export$2e2bcd8739ae039)(function(pred, list) {
    return (0, $d4bf23f46bf85457$export$2e2bcd8739ae039)(function(a, e) {
        return pred(e) ? a + 1 : a;
    }, 0, list);
});
var $df07b296093309ba$export$2e2bcd8739ae039 = $df07b296093309ba$var$count;











var $0c02da021959018a$var$XReduceBy = /*#__PURE__*/ function() {
    function XReduceBy(valueFn, valueAcc, keyFn, xf) {
        this.valueFn = valueFn;
        this.valueAcc = valueAcc;
        this.keyFn = keyFn;
        this.xf = xf;
        this.inputs = {};
    }
    XReduceBy.prototype["@@transducer/init"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XReduceBy.prototype["@@transducer/result"] = function(result) {
        var key;
        for(key in this.inputs)if ((0, $ca32895e0ecf33fa$export$2e2bcd8739ae039)(key, this.inputs)) {
            result = this.xf["@@transducer/step"](result, this.inputs[key]);
            if (result["@@transducer/reduced"]) {
                result = result["@@transducer/value"];
                break;
            }
        }
        this.inputs = null;
        return this.xf["@@transducer/result"](result);
    };
    XReduceBy.prototype["@@transducer/step"] = function(result, input) {
        var key = this.keyFn(input);
        this.inputs[key] = this.inputs[key] || [
            key,
            (0, $71dce7a34b6bfe2c$export$2e2bcd8739ae039)(this.valueAcc, false)
        ];
        this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
        return result;
    };
    return XReduceBy;
}();
function $0c02da021959018a$export$2e2bcd8739ae039(valueFn, valueAcc, keyFn) {
    return function(xf) {
        return new $0c02da021959018a$var$XReduceBy(valueFn, valueAcc, keyFn, xf);
    };
}



/**
 * Groups the elements of the list according to the result of calling
 * the String-returning function `keyFn` on each element and reduces the elements
 * of each group to a single value via the reducer function `valueFn`.
 *
 * The value function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to short circuit the iteration.
 *
 * This function is basically a more general [`groupBy`](#groupBy) function.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category List
 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
 * @param {Function} valueFn The function that reduces the elements of each group to a single
 *        value. Receives two values, accumulator for a particular group and the current element.
 * @param {*} acc The (initial) accumulator value for each group.
 * @param {Function} keyFn The function that maps the list's element into a key.
 * @param {Array} list The array to group.
 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
 *         `valueFn` for elements which produced that key when passed to `keyFn`.
 * @see R.groupBy, R.reduce, R.reduced
 * @example
 *
 *      const groupNames = (acc, {name}) => acc.concat(name)
 *      const toGrade = ({score}) =>
 *        score < 65 ? 'F' :
 *        score < 70 ? 'D' :
 *        score < 80 ? 'C' :
 *        score < 90 ? 'B' : 'A'
 *
 *      var students = [
 *        {name: 'Abby', score: 83},
 *        {name: 'Bart', score: 62},
 *        {name: 'Curt', score: 88},
 *        {name: 'Dora', score: 92},
 *      ]
 *
 *      reduceBy(groupNames, [], toGrade, students)
 *      //=> {"A": ["Dora"], "B": ["Abby", "Curt"], "F": ["Bart"]}
 */ var $d94b7ddb8c5b845d$var$reduceBy = /*#__PURE__*/ (0, $04acb407ec8a4632$export$2e2bcd8739ae039)(4, [], /*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([], (0, $0c02da021959018a$export$2e2bcd8739ae039), function reduceBy(valueFn, valueAcc, keyFn, list) {
    var xf = (0, $9ac0dab179ed11f0$export$2e2bcd8739ae039)(function(acc, elt) {
        var key = keyFn(elt);
        var value = valueFn((0, $ca32895e0ecf33fa$export$2e2bcd8739ae039)(key, acc) ? acc[key] : (0, $71dce7a34b6bfe2c$export$2e2bcd8739ae039)(valueAcc, false), elt);
        if (value && value["@@transducer/reduced"]) return (0, $3dad6d215f19c210$export$2e2bcd8739ae039)(acc);
        acc[key] = value;
        return acc;
    });
    return (0, $fc6ace3187be0136$export$2e2bcd8739ae039)(xf, {}, list);
}));
var $d94b7ddb8c5b845d$export$2e2bcd8739ae039 = $d94b7ddb8c5b845d$var$reduceBy;


/**
 * Counts the elements of a list according to how many match each value of a
 * key generated by the supplied function. Returns an object mapping the keys
 * produced by `fn` to the number of occurrences in the list. Note that all
 * keys are coerced to strings because of how JavaScript objects work.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> String) -> [a] -> {*}
 * @param {Function} fn The function used to map values to keys.
 * @param {Array} list The list to count elements from.
 * @return {Object} An object mapping keys to number of occurrences in the list.
 * @example
 *
 *      const numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
 *
 *      const letters = ['a', 'b', 'A', 'a', 'B', 'c'];
 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
 */ var $4dc4a73ab290c8cb$var$countBy = /*#__PURE__*/ (0, $d94b7ddb8c5b845d$export$2e2bcd8739ae039)(function(acc, elem) {
    return acc + 1;
}, 0);
var $4dc4a73ab290c8cb$export$2e2bcd8739ae039 = $4dc4a73ab290c8cb$var$countBy;





/**
 * Decrements its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n - 1
 * @see R.inc
 * @example
 *
 *      R.dec(42); //=> 41
 */ var $321a661201ae5547$var$dec = /*#__PURE__*/ (0, $5478c02438a847eb$export$2e2bcd8739ae039)(-1);
var $321a661201ae5547$export$2e2bcd8739ae039 = $321a661201ae5547$var$dec;



/**
 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
 * otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {a} default The default value.
 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
 * @example
 *
 *      const defaultTo42 = R.defaultTo(42);
 *
 *      defaultTo42(null);  //=> 42
 *      defaultTo42(undefined);  //=> 42
 *      defaultTo42(false);  //=> false
 *      defaultTo42('Ramda');  //=> 'Ramda'
 *      // parseInt('string') results in NaN
 *      defaultTo42(parseInt('string')); //=> 42
 */ var $05d273f6dccce24e$var$defaultTo = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function defaultTo(d, v) {
    return v == null || v !== v ? d : v;
});
var $05d273f6dccce24e$export$2e2bcd8739ae039 = $05d273f6dccce24e$var$defaultTo;



/**
 * Makes a descending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
 * @see R.ascend
 * @example
 *
 *      const byAge = R.descend(R.prop('age'));
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByOldestFirst = R.sort(byAge, people);
 *        //=> [{ name: 'Peter', age: 78 }, { name: 'Emma', age: 70 }, { name: 'Mikhail', age: 62 }]
 */ var $cb00146a793e8922$var$descend = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function descend(fn, a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa > bb ? -1 : aa < bb ? 1 : 0;
});
var $cb00146a793e8922$export$2e2bcd8739ae039 = $cb00146a793e8922$var$descend;




var $cb0aea426cd8ce0d$var$_Set = /*#__PURE__*/ function() {
    function _Set() {
        /* globals Set */ this._nativeSet = typeof Set === "function" ? new Set() : null;
        this._items = {};
    }
    // until we figure out why jsdoc chokes on this
    // @param item The item to add to the Set
    // @returns {boolean} true if the item did not exist prior, otherwise false
    //
    _Set.prototype.add = function(item) {
        return !$cb0aea426cd8ce0d$var$hasOrAdd(item, true, this);
    }; //
    // @param item The item to check for existence in the Set
    // @returns {boolean} true if the item exists in the Set, otherwise false
    //
    _Set.prototype.has = function(item) {
        return $cb0aea426cd8ce0d$var$hasOrAdd(item, false, this);
    }; //
    // Combines the logic for checking whether an item is a member of the set and
    // for adding a new item to the set.
    //
    // @param item       The item to check or add to the Set instance.
    // @param shouldAdd  If true, the item will be added to the set if it doesn't
    //                   already exist.
    // @param set        The set instance to check or add to.
    // @return {boolean} true if the item already existed, otherwise false.
    //
    return _Set;
}();
function $cb0aea426cd8ce0d$var$hasOrAdd(item, shouldAdd, set) {
    var type = typeof item;
    var prevSize, newSize;
    switch(type){
        case "string":
        case "number":
            // distinguish between +0 and -0
            if (item === 0 && 1 / item === -Infinity) {
                if (set._items["-0"]) return true;
                else {
                    if (shouldAdd) set._items["-0"] = true;
                    return false;
                }
            } // these types can all utilise the native Set
            if (set._nativeSet !== null) {
                if (shouldAdd) {
                    prevSize = set._nativeSet.size;
                    set._nativeSet.add(item);
                    newSize = set._nativeSet.size;
                    return newSize === prevSize;
                } else return set._nativeSet.has(item);
            } else {
                if (!(type in set._items)) {
                    if (shouldAdd) {
                        set._items[type] = {};
                        set._items[type][item] = true;
                    }
                    return false;
                } else if (item in set._items[type]) return true;
                else {
                    if (shouldAdd) set._items[type][item] = true;
                    return false;
                }
            }
        case "boolean":
            // set._items['boolean'] holds a two element array
            // representing [ falseExists, trueExists ]
            if (type in set._items) {
                var bIdx = item ? 1 : 0;
                if (set._items[type][bIdx]) return true;
                else {
                    if (shouldAdd) set._items[type][bIdx] = true;
                    return false;
                }
            } else {
                if (shouldAdd) set._items[type] = item ? [
                    false,
                    true
                ] : [
                    true,
                    false
                ];
                return false;
            }
        case "function":
            // compare functions for reference equality
            if (set._nativeSet !== null) {
                if (shouldAdd) {
                    prevSize = set._nativeSet.size;
                    set._nativeSet.add(item);
                    newSize = set._nativeSet.size;
                    return newSize === prevSize;
                } else return set._nativeSet.has(item);
            } else {
                if (!(type in set._items)) {
                    if (shouldAdd) set._items[type] = [
                        item
                    ];
                    return false;
                }
                if (!(0, $6df6bac8cac02133$export$2e2bcd8739ae039)(item, set._items[type])) {
                    if (shouldAdd) set._items[type].push(item);
                    return false;
                }
                return true;
            }
        case "undefined":
            if (set._items[type]) return true;
            else {
                if (shouldAdd) set._items[type] = true;
                return false;
            }
        case "object":
            if (item === null) {
                if (!set._items["null"]) {
                    if (shouldAdd) set._items["null"] = true;
                    return false;
                }
                return true;
            }
        /* falls through */ default:
            // reduce the search size of heterogeneous sets by creating buckets
            // for each type.
            type = Object.prototype.toString.call(item);
            if (!(type in set._items)) {
                if (shouldAdd) set._items[type] = [
                    item
                ];
                return false;
            } // scan through all previously applied items
            if (!(0, $6df6bac8cac02133$export$2e2bcd8739ae039)(item, set._items[type])) {
                if (shouldAdd) set._items[type].push(item);
                return false;
            }
            return true;
    }
} // A simple Set type that honours R.equals semantics
var $cb0aea426cd8ce0d$export$2e2bcd8739ae039 = $cb0aea426cd8ce0d$var$_Set;


/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Objects and Arrays are compared in terms of
 * value equality, not reference equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith, R.without
 * @example
 *
 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
 */ var $c3fc704c251e44e1$var$difference = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function difference(first, second) {
    var out = [];
    var idx = 0;
    var firstLen = first.length;
    var secondLen = second.length;
    var toFilterOut = new (0, $cb0aea426cd8ce0d$export$2e2bcd8739ae039)();
    for(var i = 0; i < secondLen; i += 1)toFilterOut.add(second[i]);
    while(idx < firstLen){
        if (toFilterOut.add(first[idx])) out[out.length] = first[idx];
        idx += 1;
    }
    return out;
});
var $c3fc704c251e44e1$export$2e2bcd8739ae039 = $c3fc704c251e44e1$var$difference;




/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Duplication is determined according to the
 * value returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
 * @example
 *
 *      const cmp = (x, y) => x.a === y.a;
 *      const l1 = [{a: 1}, {a: 2}, {a: 3}];
 *      const l2 = [{a: 3}, {a: 4}];
 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
 *
 *      R.differenceWith(R.equals, [1, 2, 3, 3, 3], []); //=> [1, 2, 3]
 *      R.differenceWith(R.equals, [1, 2, 3, 3, 3], [1]); //=> [2, 3]
 */ var $98850934d5cdaf0b$var$differenceWith = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function differenceWith(pred, first, second) {
    var out = [];
    var idx = 0;
    var firstLen = first.length;
    while(idx < firstLen){
        if (!(0, $c11f7b7011b9d6c6$export$2e2bcd8739ae039)(pred, first[idx], second) && !(0, $c11f7b7011b9d6c6$export$2e2bcd8739ae039)(pred, first[idx], out)) out.push(first[idx]);
        idx += 1;
    }
    return out;
});
var $98850934d5cdaf0b$export$2e2bcd8739ae039 = $98850934d5cdaf0b$var$differenceWith;







/**
 * Removes the sub-list of `list` starting at index `start` and containing
 * `count` elements. _Note that this is not destructive_: it returns a copy of
 * the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} start The position to start removing elements
 * @param {Number} count The number of elements to remove
 * @param {Array} list The list to remove from
 * @return {Array} A new Array with `count` elements from `start` removed.
 * @see R.without
 * @example
 *
 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
 */ var $3a7a1cde4017367f$var$remove = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function remove(start, count, list) {
    var result = Array.prototype.slice.call(list, 0);
    result.splice(start, count);
    return result;
});
var $3a7a1cde4017367f$export$2e2bcd8739ae039 = $3a7a1cde4017367f$var$remove;


function $1ee3739d38cd6c20$export$2e2bcd8739ae039(prop, obj) {
    if (obj == null) return obj;
    if ((0, $8895c4c9dcfccbb6$export$2e2bcd8739ae039)(prop) && (0, $6011f766ba1d1c66$export$2e2bcd8739ae039)(obj)) return (0, $3a7a1cde4017367f$export$2e2bcd8739ae039)(prop, 1, obj);
    var result = {};
    for(var p in obj)result[p] = obj[p];
    delete result[prop];
    return result;
}





/**
 * Makes a shallow clone of an object. Note that this copies and flattens
 * prototype properties onto the new object as well. All non-primitive
 * properties are copied by reference.
 *
 * @private
 * @param {String|Integer} prop The prop operating
 * @param {Object|Array} obj The object to clone
 * @return {Object|Array} A new object equivalent to the original.
 */ function $d9e227d9e9b2a2cf$var$_shallowCloneObject(prop, obj) {
    if ((0, $8895c4c9dcfccbb6$export$2e2bcd8739ae039)(prop) && (0, $6011f766ba1d1c66$export$2e2bcd8739ae039)(obj)) return [].concat(obj);
    var result = {};
    for(var p in obj)result[p] = obj[p];
    return result;
}
/**
 * Makes a shallow clone of an object, omitting the property at the given path.
 * Note that this copies and flattens prototype properties onto the new object
 * as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.11.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> {k: v} -> {k: v}
 * @param {Array} path The path to the value to omit
 * @param {Object} obj The object to clone
 * @return {Object} A new object without the property at path
 * @see R.assocPath
 * @example
 *
 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
 */ var $d9e227d9e9b2a2cf$var$dissocPath = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function dissocPath(path, obj) {
    if (obj == null) return obj;
    switch(path.length){
        case 0:
            return obj;
        case 1:
            return (0, $1ee3739d38cd6c20$export$2e2bcd8739ae039)(path[0], obj);
        default:
            var head = path[0];
            var tail = Array.prototype.slice.call(path, 1);
            if (obj[head] == null) return $d9e227d9e9b2a2cf$var$_shallowCloneObject(head, obj);
            else return (0, $ac9a81c9bab1cafa$export$2e2bcd8739ae039)(head, dissocPath(tail, obj[head]), obj);
    }
});
var $d9e227d9e9b2a2cf$export$2e2bcd8739ae039 = $d9e227d9e9b2a2cf$var$dissocPath;


/**
 * Returns a new object that does not contain a `prop` property.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Object
 * @sig String -> {k: v} -> {k: v}
 * @param {String} prop The name of the property to dissociate
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original but without the specified property
 * @see R.assoc, R.omit
 * @example
 *
 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
 */ var $7475ea591c20b36b$var$dissoc = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function dissoc(prop, obj) {
    return (0, $d9e227d9e9b2a2cf$export$2e2bcd8739ae039)([
        prop
    ], obj);
});
var $7475ea591c20b36b$export$2e2bcd8739ae039 = $7475ea591c20b36b$var$dissoc;




/**
 * Divides two numbers. Equivalent to `a / b`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a / b`.
 * @see R.multiply
 * @example
 *
 *      R.divide(71, 100); //=> 0.71
 *
 *      const half = R.divide(R.__, 2);
 *      half(42); //=> 21
 *
 *      const reciprocal = R.divide(1);
 *      reciprocal(4);   //=> 0.25
 */ var $7131954c0bca9931$var$divide = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function divide(a, b) {
    return a / b;
});
var $7131954c0bca9931$export$2e2bcd8739ae039 = $7131954c0bca9931$var$divide;





var $ef7a65fdc3a31fc1$var$XDrop = /*#__PURE__*/ function() {
    function XDrop(n, xf) {
        this.xf = xf;
        this.n = n;
    }
    XDrop.prototype["@@transducer/init"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XDrop.prototype["@@transducer/result"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).result;
    XDrop.prototype["@@transducer/step"] = function(result, input) {
        if (this.n > 0) {
            this.n -= 1;
            return result;
        }
        return this.xf["@@transducer/step"](result, input);
    };
    return XDrop;
}();
function $ef7a65fdc3a31fc1$export$2e2bcd8739ae039(n) {
    return function(xf) {
        return new $ef7a65fdc3a31fc1$var$XDrop(n, xf);
    };
}



/**
 * Returns all but the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `drop` method).
 *
 * Dispatches to the `drop` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*} A copy of list without the first `n` elements
 * @see R.take, R.transduce, R.dropLast, R.dropWhile
 * @example
 *
 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(3, 'ramda');               //=> 'da'
 */ var $6ea7d62bfb601550$var$drop = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([
    "drop"
], (0, $ef7a65fdc3a31fc1$export$2e2bcd8739ae039), function drop(n, xs) {
    return (0, $8c8a51bb580162a2$export$2e2bcd8739ae039)(Math.max(0, n), Infinity, xs);
}));
var $6ea7d62bfb601550$export$2e2bcd8739ae039 = $6ea7d62bfb601550$var$drop;








var $b33175f997f36da2$var$XTake = /*#__PURE__*/ function() {
    function XTake(n, xf) {
        this.xf = xf;
        this.n = n;
        this.i = 0;
    }
    XTake.prototype["@@transducer/init"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XTake.prototype["@@transducer/result"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).result;
    XTake.prototype["@@transducer/step"] = function(result, input) {
        this.i += 1;
        var ret = this.n === 0 ? result : this.xf["@@transducer/step"](result, input);
        return this.n >= 0 && this.i >= this.n ? (0, $3dad6d215f19c210$export$2e2bcd8739ae039)(ret) : ret;
    };
    return XTake;
}();
function $b33175f997f36da2$export$2e2bcd8739ae039(n) {
    return function(xf) {
        return new $b33175f997f36da2$var$XTake(n, xf);
    };
}



/**
 * Returns the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `take` method).
 *
 * Dispatches to the `take` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*}
 * @see R.drop
 * @example
 *
 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(3, 'ramda');               //=> 'ram'
 *
 *      const personnel = [
 *        'Dave Brubeck',
 *        'Paul Desmond',
 *        'Eugene Wright',
 *        'Joe Morello',
 *        'Gerry Mulligan',
 *        'Bob Bates',
 *        'Joe Dodge',
 *        'Ron Crotty'
 *      ];
 *
 *      const takeFive = R.take(5);
 *      takeFive(personnel);
 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
 * @symb R.take(-1, [a, b]) = [a, b]
 * @symb R.take(0, [a, b]) = []
 * @symb R.take(1, [a, b]) = [a]
 * @symb R.take(2, [a, b]) = [a, b]
 */ var $f2b35373e36ddcac$var$take = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([
    "take"
], (0, $b33175f997f36da2$export$2e2bcd8739ae039), function take(n, xs) {
    return (0, $8c8a51bb580162a2$export$2e2bcd8739ae039)(0, n < 0 ? Infinity : n, xs);
}));
var $f2b35373e36ddcac$export$2e2bcd8739ae039 = $f2b35373e36ddcac$var$take;


function $69f46b7bae9e3302$export$2e2bcd8739ae039(n, xs) {
    return (0, $f2b35373e36ddcac$export$2e2bcd8739ae039)(n < xs.length ? xs.length - n : 0, xs);
}



var $ced71eb98c558e9a$var$XDropLast = /*#__PURE__*/ function() {
    function XDropLast(n, xf) {
        if (n <= 0) return xf;
        this.xf = xf;
        this.pos = 0;
        this.full = false;
        this.acc = new Array(n);
    }
    XDropLast.prototype["@@transducer/init"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XDropLast.prototype["@@transducer/result"] = function(result) {
        this.acc = null;
        return this.xf["@@transducer/result"](result);
    };
    XDropLast.prototype["@@transducer/step"] = function(result, input) {
        if (this.full) result = this.xf["@@transducer/step"](result, this.acc[this.pos]);
        this.store(input);
        return result;
    };
    XDropLast.prototype.store = function(input) {
        this.acc[this.pos] = input;
        this.pos += 1;
        if (this.pos === this.acc.length) {
            this.pos = 0;
            this.full = true;
        }
    };
    return XDropLast;
}();
function $ced71eb98c558e9a$export$2e2bcd8739ae039(n) {
    return function(xf) {
        return new $ced71eb98c558e9a$var$XDropLast(n, xf);
    };
}


/**
 * Returns a list containing all but the last `n` elements of the given `list`.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements of `list` to skip.
 * @param {Array} list The list of elements to consider.
 * @return {Array} A copy of the list with only the first `list.length - n` elements
 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
 * @example
 *
 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(3, 'ramda');               //=> 'ra'
 */ var $e7fa35ea7566c3b3$var$dropLast = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([], (0, $ced71eb98c558e9a$export$2e2bcd8739ae039), (0, $69f46b7bae9e3302$export$2e2bcd8739ae039)));
var $e7fa35ea7566c3b3$export$2e2bcd8739ae039 = $e7fa35ea7566c3b3$var$dropLast;





function $5cab81e2914a28bc$export$2e2bcd8739ae039(pred, xs) {
    var idx = xs.length - 1;
    while(idx >= 0 && pred(xs[idx]))idx -= 1;
    return (0, $8c8a51bb580162a2$export$2e2bcd8739ae039)(0, idx + 1, xs);
}




var $704c84fa681329a4$var$XDropLastWhile = /*#__PURE__*/ function() {
    function XDropLastWhile(fn, xf) {
        this.f = fn;
        this.retained = [];
        this.xf = xf;
    }
    XDropLastWhile.prototype["@@transducer/init"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XDropLastWhile.prototype["@@transducer/result"] = function(result) {
        this.retained = null;
        return this.xf["@@transducer/result"](result);
    };
    XDropLastWhile.prototype["@@transducer/step"] = function(result, input) {
        return this.f(input) ? this.retain(result, input) : this.flush(result, input);
    };
    XDropLastWhile.prototype.flush = function(result, input) {
        result = (0, $fc6ace3187be0136$export$2e2bcd8739ae039)(this.xf, result, this.retained);
        this.retained = [];
        return this.xf["@@transducer/step"](result, input);
    };
    XDropLastWhile.prototype.retain = function(result, input) {
        this.retained.push(input);
        return result;
    };
    return XDropLastWhile;
}();
function $704c84fa681329a4$export$2e2bcd8739ae039(fn) {
    return function(xf) {
        return new $704c84fa681329a4$var$XDropLastWhile(fn, xf);
    };
}


/**
 * Returns a new list excluding all the tailing elements of a given list which
 * satisfy the supplied predicate function. It passes each value from the right
 * to the supplied predicate function, skipping elements until the predicate
 * function returns a `falsy` value. The predicate function is applied to one argument:
 * *(value)*.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} predicate The function to be called on each element
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
 * @example
 *
 *      const lteThree = x => x <= 3;
 *
 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
 *
 *      R.dropLastWhile(x => x !== 'd' , 'Ramda'); //=> 'Ramd'
 */ var $566917b18cfe8da8$var$dropLastWhile = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([], (0, $704c84fa681329a4$export$2e2bcd8739ae039), (0, $5cab81e2914a28bc$export$2e2bcd8739ae039)));
var $566917b18cfe8da8$export$2e2bcd8739ae039 = $566917b18cfe8da8$var$dropLastWhile;





var $d33a68e018175809$var$XDropRepeatsWith = /*#__PURE__*/ function() {
    function XDropRepeatsWith(pred, xf) {
        this.xf = xf;
        this.pred = pred;
        this.lastValue = undefined;
        this.seenFirstValue = false;
    }
    XDropRepeatsWith.prototype["@@transducer/init"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XDropRepeatsWith.prototype["@@transducer/result"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).result;
    XDropRepeatsWith.prototype["@@transducer/step"] = function(result, input) {
        var sameAsLast = false;
        if (!this.seenFirstValue) this.seenFirstValue = true;
        else if (this.pred(this.lastValue, input)) sameAsLast = true;
        this.lastValue = input;
        return sameAsLast ? result : this.xf["@@transducer/step"](result, input);
    };
    return XDropRepeatsWith;
}();
function $d33a68e018175809$export$2e2bcd8739ae039(pred) {
    return function(xf) {
        return new $d33a68e018175809$var$XDropRepeatsWith(pred, xf);
    };
}






/**
 * Returns the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.init, R.head, R.tail
 * @example
 *
 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
 *      R.last([]); //=> undefined
 *
 *      R.last('abc'); //=> 'c'
 *      R.last(''); //=> ''
 */ var $c4d4f478ccefb852$var$last = /*#__PURE__*/ (0, $6c38596ac956df55$export$2e2bcd8739ae039)(-1);
var $c4d4f478ccefb852$export$2e2bcd8739ae039 = $c4d4f478ccefb852$var$last;


/**
 * Returns a new list without any consecutively repeating elements. Equality is
 * determined by applying the supplied predicate to each pair of consecutive elements. The
 * first element in a series of equal elements will be preserved.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *      const l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
 */ var $e211bb89112236ca$var$dropRepeatsWith = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([], (0, $d33a68e018175809$export$2e2bcd8739ae039), function dropRepeatsWith(pred, list) {
    var result = [];
    var idx = 1;
    var len = list.length;
    if (len !== 0) {
        result[0] = list[0];
        while(idx < len){
            if (!pred((0, $c4d4f478ccefb852$export$2e2bcd8739ae039)(result), list[idx])) result[result.length] = list[idx];
            idx += 1;
        }
    }
    return result;
}));
var $e211bb89112236ca$export$2e2bcd8739ae039 = $e211bb89112236ca$var$dropRepeatsWith;



/**
 * Returns a new list without any consecutively repeating elements.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
 */ var $be928f055125891a$var$dropRepeats = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([], function() {
    return (0, $d33a68e018175809$export$2e2bcd8739ae039)((0, $1cb60074c12b9394$export$2e2bcd8739ae039));
}, /*#__PURE__*/ (0, $e211bb89112236ca$export$2e2bcd8739ae039)((0, $1cb60074c12b9394$export$2e2bcd8739ae039))));
var $be928f055125891a$export$2e2bcd8739ae039 = $be928f055125891a$var$dropRepeats;








/**
 * Takes a function and two values in its domain and returns `true` if the
 * values map to the same value in the codomain; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Relation
 * @sig (a -> b) -> a -> a -> Boolean
 * @param {Function} f
 * @param {*} x
 * @param {*} y
 * @return {Boolean}
 * @example
 *
 *      R.eqBy(Math.abs, 5, -5); //=> true
 */ var $0bf262247bffa2c4$var$eqBy = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function eqBy(f, x, y) {
    return (0, $1cb60074c12b9394$export$2e2bcd8739ae039)(f(x), f(y));
});
var $0bf262247bffa2c4$export$2e2bcd8739ae039 = $0bf262247bffa2c4$var$eqBy;


/**
 * Returns a new list without any consecutively repeating elements,
 * based upon the value returned by applying the supplied function to
 * each list element. [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.29.0
 * @category List
 * @sig (a -> b) -> [a] -> [a]
 * @param {Function} fn A function used to produce a value to use during comparisons.
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *     R.dropRepeatsBy(Math.abs, [1, -1, -1, 2, 3, -4, 4, 2, 2]); //=> [1, 2, 3, -4, 2]
 */ var $e4f88be9058da6a1$var$dropRepeatsBy = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function(fn, list) {
    return (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([], function() {
        return (0, $d33a68e018175809$export$2e2bcd8739ae039)((0, $0bf262247bffa2c4$export$2e2bcd8739ae039)(fn));
    }, (0, $e211bb89112236ca$export$2e2bcd8739ae039)((0, $0bf262247bffa2c4$export$2e2bcd8739ae039)(fn)))(list);
});
var $e4f88be9058da6a1$export$2e2bcd8739ae039 = $e4f88be9058da6a1$var$dropRepeatsBy;






var $39815da682d9e1b5$var$XDropWhile = /*#__PURE__*/ function() {
    function XDropWhile(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XDropWhile.prototype["@@transducer/init"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XDropWhile.prototype["@@transducer/result"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).result;
    XDropWhile.prototype["@@transducer/step"] = function(result, input) {
        if (this.f) {
            if (this.f(input)) return result;
            this.f = null;
        }
        return this.xf["@@transducer/step"](result, input);
    };
    return XDropWhile;
}();
function $39815da682d9e1b5$export$2e2bcd8739ae039(f) {
    return function(xf) {
        return new $39815da682d9e1b5$var$XDropWhile(f, xf);
    };
}



/**
 * Returns a new list excluding the leading elements of a given list which
 * satisfy the supplied predicate function. It passes each value to the supplied
 * predicate function, skipping elements while the predicate function returns
 * `true`. The predicate function is applied to one argument: *(value)*.
 *
 * Dispatches to the `dropWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.takeWhile, R.transduce, R.addIndex
 * @example
 *
 *      const lteTwo = x => x <= 2;
 *
 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
 *
 *      R.dropWhile(x => x !== 'd' , 'Ramda'); //=> 'da'
 */ var $44c47301111de98b$var$dropWhile = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([
    "dropWhile"
], (0, $39815da682d9e1b5$export$2e2bcd8739ae039), function dropWhile(pred, xs) {
    var idx = 0;
    var len = xs.length;
    while(idx < len && pred(xs[idx]))idx += 1;
    return (0, $8c8a51bb580162a2$export$2e2bcd8739ae039)(idx, Infinity, xs);
}));
var $44c47301111de98b$export$2e2bcd8739ae039 = $44c47301111de98b$var$dropWhile;






/**
 * Returns the first argument if it is truthy, otherwise the second argument.
 * Acts as the boolean `or` statement if both inputs are `Boolean`s.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any}
 * @see R.either, R.and
 * @example
 *
 *      R.or(true, true); //=> true
 *      R.or(true, false); //=> true
 *      R.or(false, true); //=> true
 *      R.or(false, false); //=> false
 */ var $88697a6ac55b5b6a$var$or = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function or(a, b) {
    return a || b;
});
var $88697a6ac55b5b6a$export$2e2bcd8739ae039 = $88697a6ac55b5b6a$var$or;


/**
 * A function wrapping calls to the two functions in an `||` operation,
 * returning the result of the first function if it is truth-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * truth-y value.
 *
 * In addition to functions, `R.either` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f a predicate
 * @param {Function} g another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
 * @see R.both, R.anyPass, R.or
 * @example
 *
 *      const gt10 = x => x > 10;
 *      const even = x => x % 2 === 0;
 *      const f = R.either(gt10, even);
 *      f(101); //=> true
 *      f(8); //=> true
 *
 *      R.either(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(55)
 *      R.either([false, false, 'a'], [11]) // => [11, 11, "a"]
 */ var $71c7cb258d47e37c$var$either = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function either(f, g) {
    return (0, $3cb1b5de2bca6cb6$export$2e2bcd8739ae039)(f) ? function _either() {
        return f.apply(this, arguments) || g.apply(this, arguments);
    } : (0, $199d21449f525f36$export$2e2bcd8739ae039)((0, $88697a6ac55b5b6a$export$2e2bcd8739ae039))(f, g);
});
var $71c7cb258d47e37c$export$2e2bcd8739ae039 = $71c7cb258d47e37c$var$either;







/**
 * Tests whether or not an object is a typed array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is a typed array, `false` otherwise.
 * @example
 *
 *      _isTypedArray(new Uint8Array([])); //=> true
 *      _isTypedArray(new Float32Array([])); //=> true
 *      _isTypedArray([]); //=> false
 *      _isTypedArray(null); //=> false
 *      _isTypedArray({}); //=> false
 */ function $71d85dd218e5a3bb$export$2e2bcd8739ae039(val) {
    var type = Object.prototype.toString.call(val);
    return type === "[object Uint8ClampedArray]" || type === "[object Int8Array]" || type === "[object Uint8Array]" || type === "[object Int16Array]" || type === "[object Uint16Array]" || type === "[object Int32Array]" || type === "[object Uint32Array]" || type === "[object Float32Array]" || type === "[object Float64Array]" || type === "[object BigInt64Array]" || type === "[object BigUint64Array]";
}


/**
 * Returns the empty value of its argument's type. Ramda defines the empty
 * value of Array (`[]`), Object (`{}`), String (`''`),
 * TypedArray (`Uint8Array []`, `Float32Array []`, etc), and Arguments. Other
 * types are supported if they define `<Type>.empty`,
 * `<Type>.prototype.empty` or implement the
 * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
 *
 * Dispatches to the `empty` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> a
 * @param {*} x
 * @return {*}
 * @example
 *
 *      R.empty(Just(42));               //=> Nothing()
 *      R.empty([1, 2, 3]);              //=> []
 *      R.empty('unicorns');             //=> ''
 *      R.empty({x: 1, y: 2});           //=> {}
 *      R.empty(Uint8Array.from('123')); //=> Uint8Array []
 */ var $4c1f193562ea9302$var$empty = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function empty(x) {
    return x != null && typeof x["fantasy-land/empty"] === "function" ? x["fantasy-land/empty"]() : x != null && x.constructor != null && typeof x.constructor["fantasy-land/empty"] === "function" ? x.constructor["fantasy-land/empty"]() : x != null && typeof x.empty === "function" ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === "function" ? x.constructor.empty() : (0, $6011f766ba1d1c66$export$2e2bcd8739ae039)(x) ? [] : (0, $562424274e50089c$export$2e2bcd8739ae039)(x) ? "" : (0, $fd0ff931a83ae834$export$2e2bcd8739ae039)(x) ? {} : (0, $546fb9b8321968ae$export$2e2bcd8739ae039)(x) ? function() {
        return arguments;
    }() : (0, $71d85dd218e5a3bb$export$2e2bcd8739ae039)(x) ? x.constructor.from("") : void 0 // else
    ;
});
var $4c1f193562ea9302$export$2e2bcd8739ae039 = $4c1f193562ea9302$var$empty;






/**
 * Returns a new list containing the last `n` elements of the given list.
 * If `n > list.length`, returns a list of `list.length` elements.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements to return.
 * @param {Array} xs The collection to consider.
 * @return {Array}
 * @see R.dropLast
 * @example
 *
 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(3, 'ramda');               //=> 'mda'
 */ var $207854a14cd31423$var$takeLast = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function takeLast(n, xs) {
    return (0, $6ea7d62bfb601550$export$2e2bcd8739ae039)(n >= 0 ? xs.length - n : 0, xs);
});
var $207854a14cd31423$export$2e2bcd8739ae039 = $207854a14cd31423$var$takeLast;


/**
 * Checks if a list ends with the provided sublist.
 *
 * Similarly, checks if a string ends with the provided substring.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> [a] -> Boolean
 * @sig String -> String -> Boolean
 * @param {*} suffix
 * @param {*} list
 * @return {Boolean}
 * @see R.startsWith
 * @example
 *
 *      R.endsWith('c', 'abc')                //=> true
 *      R.endsWith('b', 'abc')                //=> false
 *      R.endsWith(['c'], ['a', 'b', 'c'])    //=> true
 *      R.endsWith(['b'], ['a', 'b', 'c'])    //=> false
 */ var $38b5f146b3aa7881$var$endsWith = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function(suffix, list) {
    return (0, $1cb60074c12b9394$export$2e2bcd8739ae039)((0, $207854a14cd31423$export$2e2bcd8739ae039)(suffix.length, list), suffix);
});
var $38b5f146b3aa7881$export$2e2bcd8739ae039 = $38b5f146b3aa7881$var$endsWith;





/**
 * Reports whether two objects have the same value, in [`R.equals`](#equals)
 * terms, for the specified property. Useful as a curried predicate.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig k -> {k: v} -> {k: v} -> Boolean
 * @param {String} prop The name of the property to compare
 * @param {Object} obj1
 * @param {Object} obj2
 * @return {Boolean}
 *
 * @example
 *
 *      const o1 = { a: 1, b: 2, c: 3, d: 4 };
 *      const o2 = { a: 10, b: 20, c: 3, d: 40 };
 *      R.eqProps('a', o1, o2); //=> false
 *      R.eqProps('c', o1, o2); //=> true
 */ var $18137c040752a161$var$eqProps = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function eqProps(prop, obj1, obj2) {
    return (0, $1cb60074c12b9394$export$2e2bcd8739ae039)(obj1[prop], obj2[prop]);
});
var $18137c040752a161$export$2e2bcd8739ae039 = $18137c040752a161$var$eqProps;






/**
 * Creates a new object by recursively evolving a shallow copy of `object`,
 * according to the `transformation` functions. All non-primitive properties
 * are copied by reference.
 *
 * A `transformation` function will not be invoked if its corresponding key
 * does not exist in the evolved object.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
 * @param {Object} transformations The object specifying transformation functions to apply
 *        to the object.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const tomato = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
 *      const transformations = {
 *        firstName: R.trim,
 *        lastName: R.trim, // Will not get invoked.
 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
 *      };
 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
 */ var $04ca3f40b52fd34d$var$evolve = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function evolve(transformations, object) {
    if (!(0, $fd0ff931a83ae834$export$2e2bcd8739ae039)(object) && !(0, $6011f766ba1d1c66$export$2e2bcd8739ae039)(object)) return object;
    var result = object instanceof Array ? [] : {};
    var transformation, key, type;
    for(key in object){
        transformation = transformations[key];
        type = typeof transformation;
        result[key] = type === "function" ? transformation(object[key]) : transformation && type === "object" ? evolve(transformation, object[key]) : object[key];
    }
    return result;
});
var $04ca3f40b52fd34d$export$2e2bcd8739ae039 = $04ca3f40b52fd34d$var$evolve;







var $71c834df580bdea6$var$XFind = /*#__PURE__*/ function() {
    function XFind(f, xf) {
        this.xf = xf;
        this.f = f;
        this.found = false;
    }
    XFind.prototype["@@transducer/init"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XFind.prototype["@@transducer/result"] = function(result) {
        if (!this.found) result = this.xf["@@transducer/step"](result, void 0);
        return this.xf["@@transducer/result"](result);
    };
    XFind.prototype["@@transducer/step"] = function(result, input) {
        if (this.f(input)) {
            this.found = true;
            result = (0, $3dad6d215f19c210$export$2e2bcd8739ae039)(this.xf["@@transducer/step"](result, input));
        }
        return result;
    };
    return XFind;
}();
function $71c834df580bdea6$export$2e2bcd8739ae039(f) {
    return function(xf) {
        return new $71c834df580bdea6$var$XFind(f, xf);
    };
}


/**
 * Returns the first element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Dispatches to the `find` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 *        desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
 *      R.find(R.propEq('a', 4))(xs); //=> undefined
 */ var $28886d3a1a552b45$var$find = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([
    "find"
], (0, $71c834df580bdea6$export$2e2bcd8739ae039), function find(fn, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (fn(list[idx])) return list[idx];
        idx += 1;
    }
}));
var $28886d3a1a552b45$export$2e2bcd8739ae039 = $28886d3a1a552b45$var$find;






var $1920a34702946cfe$var$XFindIndex = /*#__PURE__*/ function() {
    function XFindIndex(f, xf) {
        this.xf = xf;
        this.f = f;
        this.idx = -1;
        this.found = false;
    }
    XFindIndex.prototype["@@transducer/init"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XFindIndex.prototype["@@transducer/result"] = function(result) {
        if (!this.found) result = this.xf["@@transducer/step"](result, -1);
        return this.xf["@@transducer/result"](result);
    };
    XFindIndex.prototype["@@transducer/step"] = function(result, input) {
        this.idx += 1;
        if (this.f(input)) {
            this.found = true;
            result = (0, $3dad6d215f19c210$export$2e2bcd8739ae039)(this.xf["@@transducer/step"](result, this.idx));
        }
        return result;
    };
    return XFindIndex;
}();
function $1920a34702946cfe$export$2e2bcd8739ae039(f) {
    return function(xf) {
        return new $1920a34702946cfe$var$XFindIndex(f, xf);
    };
}


/**
 * Returns the index of the first element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce, R.indexOf
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
 */ var $bb8b401e772941a7$var$findIndex = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([], (0, $1920a34702946cfe$export$2e2bcd8739ae039), function findIndex(fn, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (fn(list[idx])) return idx;
        idx += 1;
    }
    return -1;
}));
var $bb8b401e772941a7$export$2e2bcd8739ae039 = $bb8b401e772941a7$var$findIndex;





var $6494483b58c27f6e$var$XFindLast = /*#__PURE__*/ function() {
    function XFindLast(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFindLast.prototype["@@transducer/init"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XFindLast.prototype["@@transducer/result"] = function(result) {
        return this.xf["@@transducer/result"](this.xf["@@transducer/step"](result, this.last));
    };
    XFindLast.prototype["@@transducer/step"] = function(result, input) {
        if (this.f(input)) this.last = input;
        return result;
    };
    return XFindLast;
}();
function $6494483b58c27f6e$export$2e2bcd8739ae039(f) {
    return function(xf) {
        return new $6494483b58c27f6e$var$XFindLast(f, xf);
    };
}


/**
 * Returns the last element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
 */ var $392d85a915455215$var$findLast = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([], (0, $6494483b58c27f6e$export$2e2bcd8739ae039), function findLast(fn, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        if (fn(list[idx])) return list[idx];
        idx -= 1;
    }
}));
var $392d85a915455215$export$2e2bcd8739ae039 = $392d85a915455215$var$findLast;





var $3304e4f701ad8d55$var$XFindLastIndex = /*#__PURE__*/ function() {
    function XFindLastIndex(f, xf) {
        this.xf = xf;
        this.f = f;
        this.idx = -1;
        this.lastIdx = -1;
    }
    XFindLastIndex.prototype["@@transducer/init"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XFindLastIndex.prototype["@@transducer/result"] = function(result) {
        return this.xf["@@transducer/result"](this.xf["@@transducer/step"](result, this.lastIdx));
    };
    XFindLastIndex.prototype["@@transducer/step"] = function(result, input) {
        this.idx += 1;
        if (this.f(input)) this.lastIdx = this.idx;
        return result;
    };
    return XFindLastIndex;
}();
function $3304e4f701ad8d55$export$2e2bcd8739ae039(f) {
    return function(xf) {
        return new $3304e4f701ad8d55$var$XFindLastIndex(f, xf);
    };
}


/**
 * Returns the index of the last element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce, R.lastIndexOf
 * @example
 *
 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
 */ var $204234d3f61693d0$var$findLastIndex = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([], (0, $3304e4f701ad8d55$export$2e2bcd8739ae039), function findLastIndex(fn, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        if (fn(list[idx])) return idx;
        idx -= 1;
    }
    return -1;
}));
var $204234d3f61693d0$export$2e2bcd8739ae039 = $204234d3f61693d0$var$findLastIndex;




/**
 * Returns a new list by pulling every item out of it (and all its sub-arrays)
 * and putting them in a new array, depth-first.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b]
 * @param {Array} list The array to consider.
 * @return {Array} The flattened list.
 * @see R.unnest
 * @example
 *
 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
 */ var $7ea08f8524589b9b$var$flatten = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $8057b2e3915e5f14$export$2e2bcd8739ae039)(true));
var $7ea08f8524589b9b$export$2e2bcd8739ae039 = $7ea08f8524589b9b$var$flatten;




/**
 * Returns a new function much like the supplied one, except that the first two
 * arguments' order is reversed.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b, c, ...) -> z) -> (b -> a -> c -> ... -> z)
 * @param {Function} fn The function to invoke with its first two parameters reversed.
 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
 * @example
 *
 *      const mergeThree = (a, b, c) => [].concat(a, b, c);
 *
 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
 *
 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
 * @symb R.flip(f)(a, b, c) = f(b, a, c)
 */ var $a6868a897e7652d6$var$flip = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function flip(fn) {
    return (0, $8bd7b963d2d08f64$export$2e2bcd8739ae039)(fn.length, function(a, b) {
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = b;
        args[1] = a;
        return fn.apply(this, args);
    });
});
var $a6868a897e7652d6$export$2e2bcd8739ae039 = $a6868a897e7652d6$var$flip;




/**
 * Iterate over an input `list`, calling a provided function `fn` for each
 * element in the list.
 *
 * `fn` receives one argument: *(value)*.
 *
 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.forEach` method. For more
 * details on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
 *
 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
 * the original array. In some libraries this function is named `each`.
 *
 * Dispatches to the `forEach` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> *) -> [a] -> [a]
 * @param {Function} fn The function to invoke. Receives one argument, `value`.
 * @param {Array} list The list to iterate over.
 * @return {Array} The original list.
 * @see R.addIndex
 * @example
 *
 *      const printXPlusFive = x => console.log(x + 5);
 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
 *      // logs 6
 *      // logs 7
 *      // logs 8
 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
 */ var $6ed2a605b0683a28$var$forEach = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3992793a26ae17b7$export$2e2bcd8739ae039)("forEach", function forEach(fn, list) {
    var len = list.length;
    var idx = 0;
    while(idx < len){
        fn(list[idx]);
        idx += 1;
    }
    return list;
}));
var $6ed2a605b0683a28$export$2e2bcd8739ae039 = $6ed2a605b0683a28$var$forEach;




/**
 * Iterate over an input `object`, calling a provided function `fn` for each
 * key and value in the object.
 *
 * `fn` receives three argument: *(value, key, obj)*.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Object
 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
 * @param {Object} obj The object to iterate over.
 * @return {Object} The original object.
 * @example
 *
 *      const printKeyConcatValue = (value, key) => console.log(key + ':' + value);
 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
 *      // logs x:1
 *      // logs y:2
 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
 */ var $c8dedb1725b259b7$var$forEachObjIndexed = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function forEachObjIndexed(fn, obj) {
    var keyList = (0, $f952fda84f71812a$export$2e2bcd8739ae039)(obj);
    var idx = 0;
    while(idx < keyList.length){
        var key = keyList[idx];
        fn(obj[key], key, obj);
        idx += 1;
    }
    return obj;
});
var $c8dedb1725b259b7$export$2e2bcd8739ae039 = $c8dedb1725b259b7$var$forEachObjIndexed;



/**
 * Creates a new object from a list key-value pairs. If a key appears in
 * multiple pairs, the rightmost pair is included in the object.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [[k,v]] -> {k: v}
 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
 * @return {Object} The object made by pairing up `keys` and `values`.
 * @see R.toPairs, R.pair
 * @example
 *
 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
 */ var $5917c8cf3d0352ed$var$fromPairs = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function fromPairs(pairs) {
    var result = {};
    var idx = 0;
    while(idx < pairs.length){
        result[pairs[idx][0]] = pairs[idx][1];
        idx += 1;
    }
    return result;
});
var $5917c8cf3d0352ed$export$2e2bcd8739ae039 = $5917c8cf3d0352ed$var$fromPairs;





/**
 * Splits a list into sub-lists stored in an object, based on the result of
 * calling a key-returning function on each element, and grouping the
 * results according to values returned.
 *
 * Dispatches to the `groupBy` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx a => (b -> a) -> [b] -> {a: [b]}
 * @param {Function} fn Function :: a -> Idx
 * @param {Array} list The array to group
 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
 *         that produced that key when passed to `fn`.
 * @see R.reduceBy, R.transduce, R.indexBy, R.collectBy
 * @example
 *
 *      const byGrade = R.groupBy(function(student) {
 *        const score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      const students = [{name: 'Abby', score: 84},
 *                      {name: 'Eddy', score: 58},
 *                      // ...
 *                      {name: 'Jack', score: 69}];
 *      byGrade(students);
 *      // {
 *      //   'A': [{name: 'Dianne', score: 99}],
 *      //   'B': [{name: 'Abby', score: 84}]
 *      //   // ...,
 *      //   'F': [{name: 'Eddy', score: 58}]
 *      // }
 */ var $b4c439f5d68834f6$var$groupBy = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3992793a26ae17b7$export$2e2bcd8739ae039)("groupBy", /*#__PURE__*/ (0, $d94b7ddb8c5b845d$export$2e2bcd8739ae039)(function(acc, item) {
    acc.push(item);
    return acc;
}, [])));
var $b4c439f5d68834f6$export$2e2bcd8739ae039 = $b4c439f5d68834f6$var$groupBy;



/**
 * Takes a list and returns a list of lists where each sublist's elements are
 * all satisfied pairwise comparison according to the provided function.
 * Only adjacent elements are passed to the comparison function.
 *
 * @func
 * @memberOf R
 * @since v0.21.0
 * @category List
 * @sig ((a, a) → Boolean) → [a] → [[a]]
 * @param {Function} fn Function for determining whether two given (adjacent)
 *        elements should be in the same group
 * @param {Array} list The array to group. Also accepts a string, which will be
 *        treated as a list of characters.
 * @return {List} A list that contains sublists of elements,
 *         whose concatenations are equal to the original list.
 * @example
 *
 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a + 1 === b, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0, 1], [1, 2, 3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
 *
 * const isVowel = R.test(/^[aeiou]$/i);
 * R.groupWith(R.eqBy(isVowel), 'aestiou')
 * //=> ['ae', 'st', 'iou']
 */ var $91de41e1d38f786c$var$groupWith = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function(fn, list) {
    var res = [];
    var idx = 0;
    var len = list.length;
    while(idx < len){
        var nextidx = idx + 1;
        while(nextidx < len && fn(list[nextidx - 1], list[nextidx]))nextidx += 1;
        res.push(list.slice(idx, nextidx));
        idx = nextidx;
    }
    return res;
});
var $91de41e1d38f786c$export$2e2bcd8739ae039 = $91de41e1d38f786c$var$groupWith;



/**
 * Returns `true` if the first argument is greater than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.lt
 * @example
 *
 *      R.gt(2, 1); //=> true
 *      R.gt(2, 2); //=> false
 *      R.gt(2, 3); //=> false
 *      R.gt('a', 'z'); //=> false
 *      R.gt('z', 'a'); //=> true
 */ var $eaf55a950e4a40ee$var$gt = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function gt(a, b) {
    return a > b;
});
var $eaf55a950e4a40ee$export$2e2bcd8739ae039 = $eaf55a950e4a40ee$var$gt;



/**
 * Returns `true` if the first argument is greater than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.lte
 * @example
 *
 *      R.gte(2, 1); //=> true
 *      R.gte(2, 2); //=> true
 *      R.gte(2, 3); //=> false
 *      R.gte('a', 'z'); //=> false
 *      R.gte('z', 'a'); //=> true
 */ var $047d9432f77ca0c0$var$gte = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function gte(a, b) {
    return a >= b;
});
var $047d9432f77ca0c0$export$2e2bcd8739ae039 = $047d9432f77ca0c0$var$gte;






/**
 * Returns whether or not a path exists in an object. Only the object's
 * own properties are checked.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> {a} -> Boolean
 * @param {Array} path The path to use.
 * @param {Object} obj The object to check the path in.
 * @return {Boolean} Whether the path exists.
 * @see R.has
 * @example
 *
 *      R.hasPath(['a', 'b'], {a: {b: 2}});         // => true
 *      R.hasPath(['a', 'b'], {a: {b: undefined}}); // => true
 *      R.hasPath(['a', 'b'], {a: {c: 2}});         // => false
 *      R.hasPath(['a', 'b'], {});                  // => false
 */ var $e57c9200cffea817$var$hasPath = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function hasPath(_path, obj) {
    if (_path.length === 0 || (0, $9cd3c11cb6777784$export$2e2bcd8739ae039)(obj)) return false;
    var val = obj;
    var idx = 0;
    while(idx < _path.length){
        if (!(0, $9cd3c11cb6777784$export$2e2bcd8739ae039)(val) && (0, $ca32895e0ecf33fa$export$2e2bcd8739ae039)(_path[idx], val)) {
            val = val[_path[idx]];
            idx += 1;
        } else return false;
    }
    return true;
});
var $e57c9200cffea817$export$2e2bcd8739ae039 = $e57c9200cffea817$var$hasPath;


/**
 * Returns whether or not an object has an own property with the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      const hasName = R.has('name');
 *      hasName({name: 'alice'});   //=> true
 *      hasName({name: 'bob'});     //=> true
 *      hasName({});                //=> false
 *
 *      const point = {x: 0, y: 0};
 *      const pointHas = R.has(R.__, point);
 *      pointHas('x');  //=> true
 *      pointHas('y');  //=> true
 *      pointHas('z');  //=> false
 */ var $e4a002e2644712e6$var$has = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function has(prop, obj) {
    return (0, $e57c9200cffea817$export$2e2bcd8739ae039)([
        prop
    ], obj);
});
var $e4a002e2644712e6$export$2e2bcd8739ae039 = $e4a002e2644712e6$var$has;




/**
 * Returns whether or not an object or its prototype chain has a property with
 * the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      function Rectangle(width, height) {
 *        this.width = width;
 *        this.height = height;
 *      }
 *      Rectangle.prototype.area = function() {
 *        return this.width * this.height;
 *      };
 *
 *      const square = new Rectangle(2, 2);
 *      R.hasIn('width', square);  //=> true
 *      R.hasIn('area', square);  //=> true
 */ var $3fb200bc9316d336$var$hasIn = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function hasIn(prop, obj) {
    if ((0, $9cd3c11cb6777784$export$2e2bcd8739ae039)(obj)) return false;
    return prop in obj;
});
var $3fb200bc9316d336$export$2e2bcd8739ae039 = $3fb200bc9316d336$var$hasIn;





/**
 * Returns true if its arguments are identical, false otherwise. Values are
 * identical if they reference the same memory. `NaN` is identical to `NaN`;
 * `0` and `-0` are not identical.
 *
 * Note this is merely a curried version of ES6 `Object.is`.
 *
 * `identical` does not support the `__` placeholder.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      const o = {};
 *      R.identical(o, o); //=> true
 *      R.identical(1, 1); //=> true
 *      R.identical(1, '1'); //=> false
 *      R.identical([], []); //=> false
 *      R.identical(0, -0); //=> false
 *      R.identical(NaN, NaN); //=> true
 */ var $e3a9cb5de45ac06c$var$identical = function(a, b) {
    switch(arguments.length){
        case 0:
            return $e3a9cb5de45ac06c$var$identical;
        case 1:
            return function() {
                return function unaryIdentical(_b) {
                    switch(arguments.length){
                        case 0:
                            return unaryIdentical;
                        default:
                            return (0, $d08932e9ee9cd837$export$2e2bcd8739ae039)(a, _b);
                    }
                };
            }();
        default:
            return (0, $d08932e9ee9cd837$export$2e2bcd8739ae039)(a, b);
    }
}; // In order to support Cross-origin Window objects as arguments to identical,
var // it cannot be implemented as _curry2(_objectIs).
// The reason is that _curry2 checks if a function argument is the placeholder __
// by accessing a paritcular property. However, across URL origins access
// to most properties of Window is forbidden.
$e3a9cb5de45ac06c$export$2e2bcd8739ae039 = $e3a9cb5de45ac06c$var$identical;





/**
 * Creates a function that will process either the `onTrue` or the `onFalse`
 * function depending upon the result of the `condition` predicate.
 *
 * Note that `ifElse` takes its arity from the longest of the three functions passed to it.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
 * @param {Function} condition A predicate function
 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
 * @return {Function} A new function that will process either the `onTrue` or the `onFalse`
 *                    function depending upon the result of the `condition` predicate.
 * @see R.unless, R.when, R.cond
 * @example
 *
 *      const incCount = R.ifElse(
 *        R.has('count'),
 *        R.over(R.lensProp('count'), R.inc),
 *        R.assoc('count', 1)
 *      );
 *      incCount({ count: 1 }); //=> { count: 2 }
 *      incCount({});           //=> { count: 1 }
 */ var $4d35ada6eaad9b09$var$ifElse = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function ifElse(condition, onTrue, onFalse) {
    return (0, $8bd7b963d2d08f64$export$2e2bcd8739ae039)(Math.max(condition.length, onTrue.length, onFalse.length), function _ifElse() {
        return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
    });
});
var $4d35ada6eaad9b09$export$2e2bcd8739ae039 = $4d35ada6eaad9b09$var$ifElse;



/**
 * Increments its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n + 1
 * @see R.dec
 * @example
 *
 *      R.inc(42); //=> 43
 */ var $c24abe8dbc1c95be$var$inc = /*#__PURE__*/ (0, $5478c02438a847eb$export$2e2bcd8739ae039)(1);
var $c24abe8dbc1c95be$export$2e2bcd8739ae039 = $c24abe8dbc1c95be$var$inc;




/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 * Also works with strings.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.any
 * @example
 *
 *      R.includes(3, [1, 2, 3]); //=> true
 *      R.includes(4, [1, 2, 3]); //=> false
 *      R.includes({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.includes([42], [[42]]); //=> true
 *      R.includes('ba', 'banana'); //=>true
 */ var $664ee47dd5536379$var$includes = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)((0, $6df6bac8cac02133$export$2e2bcd8739ae039));
var $664ee47dd5536379$export$2e2bcd8739ae039 = $664ee47dd5536379$var$includes;



/**
 * Given a function that generates a key, turns a list of objects into an
 * object indexing the objects by the given key. Note that if multiple
 * objects generate the same value for the indexing key only the last value
 * will be included in the generated object.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx a => (b -> a) -> [b] -> {a: b}
 * @param {Function} fn Function :: a -> Idx
 * @param {Array} array The array of objects to index
 * @return {Object} An object indexing each array element by the given property.
 * @see R.groupBy
 * @example
 *
 *      const list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
 *      R.indexBy(R.prop('id'), list);
 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
 */ var $30fb85785d18a187$var$indexBy = /*#__PURE__*/ (0, $d94b7ddb8c5b845d$export$2e2bcd8739ae039)(function(acc, elem) {
    return elem;
}, null);
var $30fb85785d18a187$export$2e2bcd8739ae039 = $30fb85785d18a187$var$indexBy;





/**
 * Returns the position of the first occurrence of an item in an array, or -1
 * if the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.lastIndexOf, R.findIndex
 * @example
 *
 *      R.indexOf(3, [1,2,3,4]); //=> 2
 *      R.indexOf(10, [1,2,3,4]); //=> -1
 */ var $2e916509fefaea43$var$indexOf = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function indexOf(target, xs) {
    return typeof xs.indexOf === "function" && !(0, $6011f766ba1d1c66$export$2e2bcd8739ae039)(xs) ? xs.indexOf(target) : (0, $a6ee5426c8bff187$export$2e2bcd8739ae039)(xs, target, 0);
});
var $2e916509fefaea43$export$2e2bcd8739ae039 = $2e916509fefaea43$var$indexOf;



/**
 * Returns all but the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.last, R.head, R.tail
 * @example
 *
 *      R.init([1, 2, 3]);  //=> [1, 2]
 *      R.init([1, 2]);     //=> [1]
 *      R.init([1]);        //=> []
 *      R.init([]);         //=> []
 *
 *      R.init('abc');  //=> 'ab'
 *      R.init('ab');   //=> 'a'
 *      R.init('a');    //=> ''
 *      R.init('');     //=> ''
 */ var $6e1be8b57924cc5b$var$init = /*#__PURE__*/ (0, $8c8a51bb580162a2$export$2e2bcd8739ae039)(0, -1);
var $6e1be8b57924cc5b$export$2e2bcd8739ae039 = $6e1be8b57924cc5b$var$init;





/**
 * Takes a predicate `pred`, a list `xs`, and a list `ys`, and returns a list
 * `xs'` comprising each of the elements of `xs` which is equal to one or more
 * elements of `ys` according to `pred`.
 *
 * `pred` must be a binary function expecting an element from each list.
 *
 * `xs`, `ys`, and `xs'` are treated as sets, semantically, so ordering should
 * not be significant, but since `xs'` is ordered the implementation guarantees
 * that its values are in the same order as they appear in `xs`. Duplicates are
 * not removed, so `xs'` may contain duplicates if `xs` contains duplicates.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Relation
 * @sig ((a, b) -> Boolean) -> [a] -> [b] -> [a]
 * @param {Function} pred
 * @param {Array} xs
 * @param {Array} ys
 * @return {Array}
 * @see R.intersection
 * @example
 *
 *      R.innerJoin(
 *        (record, id) => record.id === id,
 *        [{id: 824, name: 'Richie Furay'},
 *         {id: 956, name: 'Dewey Martin'},
 *         {id: 313, name: 'Bruce Palmer'},
 *         {id: 456, name: 'Stephen Stills'},
 *         {id: 177, name: 'Neil Young'}],
 *        [177, 456, 999]
 *      );
 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
 */ var $325f1a0d8c4e5d8d$var$innerJoin = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function innerJoin(pred, xs, ys) {
    return (0, $d9b5d234510a096f$export$2e2bcd8739ae039)(function(x) {
        return (0, $c11f7b7011b9d6c6$export$2e2bcd8739ae039)(pred, x, ys);
    }, xs);
});
var $325f1a0d8c4e5d8d$export$2e2bcd8739ae039 = $325f1a0d8c4e5d8d$var$innerJoin;



/**
 * Inserts the supplied element into the list, at the specified `index`. _Note that

 * this is not destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} index The position to insert the element
 * @param {*} elt The element to insert into the Array
 * @param {Array} list The list to insert into
 * @return {Array} A new Array with `elt` inserted at `index`.
 * @example
 *
 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
 */ var $e35ed33dd9edc84a$var$insert = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function insert(idx, elt, list) {
    idx = idx < list.length && idx >= 0 ? idx : list.length;
    var result = Array.prototype.slice.call(list, 0);
    result.splice(idx, 0, elt);
    return result;
});
var $e35ed33dd9edc84a$export$2e2bcd8739ae039 = $e35ed33dd9edc84a$var$insert;



/**
 * Inserts the sub-list into the list, at the specified `index`. _Note that this is not
 * destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig Number -> [a] -> [a] -> [a]
 * @param {Number} index The position to insert the sub-list
 * @param {Array} elts The sub-list to insert into the Array
 * @param {Array} list The list to insert the sub-list into
 * @return {Array} A new Array with `elts` inserted starting at `index`.
 * @example
 *
 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
 */ var $703d79230356a895$var$insertAll = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function insertAll(idx, elts, list) {
    idx = idx < list.length && idx >= 0 ? idx : list.length;
    return [].concat(Array.prototype.slice.call(list, 0, idx), elts, Array.prototype.slice.call(list, idx));
});
var $703d79230356a895$export$2e2bcd8739ae039 = $703d79230356a895$var$insertAll;











var $0c9e25a5cd4aeac6$var$XUniqBy = /*#__PURE__*/ function() {
    function XUniqBy(f, xf) {
        this.xf = xf;
        this.f = f;
        this.set = new (0, $cb0aea426cd8ce0d$export$2e2bcd8739ae039)();
    }
    XUniqBy.prototype["@@transducer/init"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XUniqBy.prototype["@@transducer/result"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).result;
    XUniqBy.prototype["@@transducer/step"] = function(result, input) {
        return this.set.add(this.f(input)) ? this.xf["@@transducer/step"](result, input) : result;
    };
    return XUniqBy;
}();
function $0c9e25a5cd4aeac6$export$2e2bcd8739ae039(f) {
    return function(xf) {
        return new $0c9e25a5cd4aeac6$var$XUniqBy(f, xf);
    };
}


/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied function to
 * each list element. Prefers the first item if the supplied function produces
 * the same value on two items. [`R.equals`](#equals) is used for comparison.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> b) -> [a] -> [a]
 * @param {Function} fn A function used to produce a value to use during comparisons.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
 */ var $81ea5a9557f65c9c$var$uniqBy = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([], (0, $0c9e25a5cd4aeac6$export$2e2bcd8739ae039), function(fn, list) {
    var set = new (0, $cb0aea426cd8ce0d$export$2e2bcd8739ae039)();
    var result = [];
    var idx = 0;
    var appliedItem, item;
    while(idx < list.length){
        item = list[idx];
        appliedItem = fn(item);
        if (set.add(appliedItem)) result.push(item);
        idx += 1;
    }
    return result;
}));
var $81ea5a9557f65c9c$export$2e2bcd8739ae039 = $81ea5a9557f65c9c$var$uniqBy;


/**
 * Returns a new list containing only one copy of each element in the original
 * list. [`R.equals`](#equals) is used to determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
 *      R.uniq([1, '1']);     //=> [1, '1']
 *      R.uniq([[42], [42]]); //=> [[42]]
 */ var $5cfd47e1a86155fb$var$uniq = /*#__PURE__*/ (0, $81ea5a9557f65c9c$export$2e2bcd8739ae039)((0, $6303b64a517886ce$export$2e2bcd8739ae039));
var $5cfd47e1a86155fb$export$2e2bcd8739ae039 = $5cfd47e1a86155fb$var$uniq;


/**
 * Combines two lists into a set (i.e. no duplicates) composed of those
 * elements common to both lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The list of elements found in both `list1` and `list2`.
 * @see R.innerJoin
 * @example
 *
 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
 */ var $3dad0da183c4f5c5$var$intersection = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function intersection(list1, list2) {
    var toKeep = new (0, $cb0aea426cd8ce0d$export$2e2bcd8739ae039)();
    for(var i = 0; i < list1.length; i += 1)toKeep.add(list1[i]);
    return (0, $5cfd47e1a86155fb$export$2e2bcd8739ae039)((0, $d9b5d234510a096f$export$2e2bcd8739ae039)(toKeep.has.bind(toKeep), list2));
});
var $3dad0da183c4f5c5$export$2e2bcd8739ae039 = $3dad0da183c4f5c5$var$intersection;




/**
 * Creates a new list with the separator interposed between elements.
 *
 * Dispatches to the `intersperse` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} separator The element to add to the list.
 * @param {Array} list The list to be interposed.
 * @return {Array} The new list.
 * @example
 *
 *      R.intersperse('a', ['b', 'n', 'n', 's']); //=> ['b', 'a', 'n', 'a', 'n', 'a', 's']
 */ var $67d39466f2b23854$var$intersperse = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3992793a26ae17b7$export$2e2bcd8739ae039)("intersperse", function intersperse(separator, list) {
    var out = [];
    var idx = 0;
    var length = list.length;
    while(idx < length){
        if (idx === length - 1) out.push(list[idx]);
        else out.push(list[idx], separator);
        idx += 1;
    }
    return out;
}));
var $67d39466f2b23854$export$2e2bcd8739ae039 = $67d39466f2b23854$var$intersperse;






function $2fe89b24c64d55b8$var$_objectAssign(target) {
    if (target == null) throw new TypeError("Cannot convert undefined or null to object");
    var output = Object(target);
    var idx = 1;
    var length = arguments.length;
    while(idx < length){
        var source = arguments[idx];
        if (source != null) {
            for(var nextKey in source)if ((0, $ca32895e0ecf33fa$export$2e2bcd8739ae039)(nextKey, source)) output[nextKey] = source[nextKey];
        }
        idx += 1;
    }
    return output;
}
var $2fe89b24c64d55b8$export$2e2bcd8739ae039 = typeof Object.assign === "function" ? Object.assign : $2fe89b24c64d55b8$var$_objectAssign;






/**
 * Creates an object containing a single key:value pair.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @sig String -> a -> {String:a}
 * @param {String} key
 * @param {*} val
 * @return {Object}
 * @see R.pair
 * @example
 *
 *      const matchPhrases = R.compose(
 *        R.objOf('must'),
 *        R.map(R.objOf('match_phrase'))
 *      );
 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
 */ var $e61415d009026d3f$var$objOf = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function objOf(key, val) {
    var obj = {};
    obj[key] = val;
    return obj;
});
var $e61415d009026d3f$export$2e2bcd8739ae039 = $e61415d009026d3f$var$objOf;


var $19662bec5c57d5eb$var$_stepCatArray = {
    "@@transducer/init": Array,
    "@@transducer/step": function(xs, x) {
        xs.push(x);
        return xs;
    },
    "@@transducer/result": (0, $b3328d336dcab159$export$2e2bcd8739ae039)
};
var $19662bec5c57d5eb$var$_stepCatString = {
    "@@transducer/init": String,
    "@@transducer/step": function(a, b) {
        return a + b;
    },
    "@@transducer/result": (0, $b3328d336dcab159$export$2e2bcd8739ae039)
};
var $19662bec5c57d5eb$var$_stepCatObject = {
    "@@transducer/init": Object,
    "@@transducer/step": function(result, input) {
        return (0, $2fe89b24c64d55b8$export$2e2bcd8739ae039)(result, (0, $94545b0f2c5b5e42$export$2e2bcd8739ae039)(input) ? (0, $e61415d009026d3f$export$2e2bcd8739ae039)(input[0], input[1]) : input);
    },
    "@@transducer/result": (0, $b3328d336dcab159$export$2e2bcd8739ae039)
};
function $19662bec5c57d5eb$export$2e2bcd8739ae039(obj) {
    if ((0, $7f9038c575da3221$export$2e2bcd8739ae039)(obj)) return obj;
    if ((0, $94545b0f2c5b5e42$export$2e2bcd8739ae039)(obj)) return $19662bec5c57d5eb$var$_stepCatArray;
    if (typeof obj === "string") return $19662bec5c57d5eb$var$_stepCatString;
    if (typeof obj === "object") return $19662bec5c57d5eb$var$_stepCatObject;
    throw new Error("Cannot create transformer for " + obj);
}


/**
 * Transforms the items of the list with the transducer and appends the
 * transformed items to the accumulator using an appropriate iterator function
 * based on the accumulator type.
 *
 * The accumulator can be an array, string, object or a transformer. Iterated
 * items will be appended to arrays and concatenated to strings. Objects will
 * be merged directly or 2-item arrays will be merged as key, value pairs.
 *
 * The accumulator can also be a transformer object that provides a 2-arity
 * reducing iterator function, step, 0-arity initial value function, init, and
 * 1-arity result extraction function result. The step function is used as the
 * iterator function in reduce. The result function is used to convert the
 * final accumulator into the return type and in most cases is R.identity. The
 * init function is used to provide the initial accumulator.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the
 * transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig a -> (b -> b) -> [c] -> a
 * @param {*} acc The initial accumulator value.
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.transduce
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
 *
 *      R.into([], transducer, numbers); //=> [2, 3]
 *
 *      const intoArray = R.into([]);
 *      intoArray(transducer, numbers); //=> [2, 3]
 */ var $bd4c6cd84833e988$var$into = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function into(acc, transducer, list) {
    var xf = transducer((0, $7f9038c575da3221$export$2e2bcd8739ae039)(acc) ? acc : (0, $19662bec5c57d5eb$export$2e2bcd8739ae039)(acc));
    return (0, $fc6ace3187be0136$export$2e2bcd8739ae039)(xf, xf["@@transducer/init"](), list);
});
var $bd4c6cd84833e988$export$2e2bcd8739ae039 = $bd4c6cd84833e988$var$into;





/**
 * Same as [`R.invertObj`](#invertObj), however this accounts for objects with
 * duplicate values by putting the values into an array.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: [ s, ... ]}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object with keys in an array.
 * @see R.invertObj
 * @example
 *
 *      const raceResultsByFirstName = {
 *        first: 'alice',
 *        second: 'jake',
 *        third: 'alice',
 *      };
 *      R.invert(raceResultsByFirstName);
 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
 */ var $97af06e580725fb2$var$invert = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function invert(obj) {
    var props = (0, $f952fda84f71812a$export$2e2bcd8739ae039)(obj);
    var len = props.length;
    var idx = 0;
    var out = {};
    while(idx < len){
        var key = props[idx];
        var val = obj[key];
        var list = (0, $ca32895e0ecf33fa$export$2e2bcd8739ae039)(val, out) ? out[val] : out[val] = [];
        list[list.length] = key;
        idx += 1;
    }
    return out;
});
var $97af06e580725fb2$export$2e2bcd8739ae039 = $97af06e580725fb2$var$invert;




/**
 * Returns a new object with the keys of the given object as values, and the
 * values of the given object, which are coerced to strings, as keys. Note
 * that the last key found is preferred when handling the same value.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: s}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object
 * @see R.invert
 * @example
 *
 *      const raceResults = {
 *        first: 'alice',
 *        second: 'jake'
 *      };
 *      R.invertObj(raceResults);
 *      //=> { 'alice': 'first', 'jake':'second' }
 *
 *      // Alternatively:
 *      const raceResults = ['alice', 'jake'];
 *      R.invertObj(raceResults);
 *      //=> { 'alice': '0', 'jake':'1' }
 */ var $7bd53a9e3bb38cd8$var$invertObj = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function invertObj(obj) {
    var props = (0, $f952fda84f71812a$export$2e2bcd8739ae039)(obj);
    var len = props.length;
    var idx = 0;
    var out = {};
    while(idx < len){
        var key = props[idx];
        out[obj[key]] = key;
        idx += 1;
    }
    return out;
});
var $7bd53a9e3bb38cd8$export$2e2bcd8739ae039 = $7bd53a9e3bb38cd8$var$invertObj;






/**
 * Given an `arity` (Number) and a `name` (String) the `invoker` function
 * returns a curried function that takes `arity` arguments and a `context`
 * object. It will "invoke" the `name`'d function (a method) on the `context`
 * object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
 * @param {Number} arity Number of arguments the returned function should take
 *        before the target object.
 * @param {String} method Name of any of the target object's methods to call.
 * @return {Function} A new curried function.
 * @see R.construct
 * @example
 *      // A function with no arguments
 *      const asJson = invoker(0, "json")
 *      // Just like calling .then((response) => response.json())
 *      fetch("http://example.com/index.json").then(asJson)
 *
 *      // A function with one argument
 *      const sliceFrom = invoker(1, 'slice');
 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
 *
 *      // A function with two arguments
 *      const sliceFrom6 = invoker(2, 'slice')(6);
 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
 *
 *      // NOTE: You can't simply pass some of the arguments to the initial invoker function.
 *      const firstCreditCardSection = invoker(2, "slice", 0, 4)
 *      firstCreditCardSection("4242 4242 4242 4242") // => Function<...>
 *
 *      // Since invoker returns a curried function, you may partially apply it to create the function you need.
 *      const firstCreditCardSection = invoker(2, "slice")(0, 4)
 *      firstCreditCardSection("4242 4242 4242 4242") // => "4242"
 *
 * @symb R.invoker(0, 'method')(o) = o['method']()
 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
 */ var $cda97c466e8b3a0b$var$invoker = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function invoker(arity, method) {
    return (0, $8bd7b963d2d08f64$export$2e2bcd8739ae039)(arity + 1, function() {
        var target = arguments[arity];
        if (target != null && (0, $3cb1b5de2bca6cb6$export$2e2bcd8739ae039)(target[method])) return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
        throw new TypeError((0, $c62f1cf5b0b06d2c$export$2e2bcd8739ae039)(target) + ' does not have a method named "' + method + '"');
    });
});
var $cda97c466e8b3a0b$export$2e2bcd8739ae039 = $cda97c466e8b3a0b$var$invoker;



/**
 * See if an object (i.e. `val`) is an instance of the supplied constructor. This
 * function will check up the inheritance chain, if any.
 * If `val` was created using `Object.create`, `R.is(Object, val) === true`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Type
 * @sig (* -> {*}) -> a -> Boolean
 * @param {Object} ctor A constructor
 * @param {*} val The value to test
 * @return {Boolean}
 * @example
 *
 *      R.is(Object, {}); //=> true
 *      R.is(Number, 1); //=> true
 *      R.is(Object, 1); //=> false
 *      R.is(String, 's'); //=> true
 *      R.is(String, new String('')); //=> true
 *      R.is(Object, new String('')); //=> true
 *      R.is(Object, 's'); //=> false
 *      R.is(Number, {}); //=> false
 */ var $b1db11aa543da3ec$var$is = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function is(Ctor, val) {
    return val instanceof Ctor || val != null && (val.constructor === Ctor || Ctor.name === "Object" && typeof val === "object");
});
var $b1db11aa543da3ec$export$2e2bcd8739ae039 = $b1db11aa543da3ec$var$is;





/**
 * Returns `true` if the given value is its type's empty value; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> Boolean
 * @param {*} x
 * @return {Boolean}
 * @see R.empty
 * @example
 *
 *      R.isEmpty([1, 2, 3]);           //=> false
 *      R.isEmpty([]);                  //=> true
 *      R.isEmpty('');                  //=> true
 *      R.isEmpty(null);                //=> false
 *      R.isEmpty({});                  //=> true
 *      R.isEmpty({length: 0});         //=> false
 *      R.isEmpty(Uint8Array.from('')); //=> true
 */ var $a6585033d1ecf223$var$isEmpty = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function isEmpty(x) {
    return x != null && (0, $1cb60074c12b9394$export$2e2bcd8739ae039)(x, (0, $4c1f193562ea9302$export$2e2bcd8739ae039)(x));
});
var $a6585033d1ecf223$export$2e2bcd8739ae039 = $a6585033d1ecf223$var$isEmpty;





/**
 * Checks if the input value is not `null` and not `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.29.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is not `undefined` or not `null`, otherwise `false`.
 * @example
 *
 *      R.isNotNil(null); //=> false
 *      R.isNotNil(undefined); //=> false
 *      R.isNotNil(0); //=> true
 *      R.isNotNil([]); //=> true
 */ var $02a66ec43990e6b7$var$isNotNil = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function isNotNil(x) {
    return !(0, $9cd3c11cb6777784$export$2e2bcd8739ae039)(x);
});
var $02a66ec43990e6b7$export$2e2bcd8739ae039 = $02a66ec43990e6b7$var$isNotNil;



/**
 * Returns a string made by inserting the `separator` between each element and
 * concatenating all the elements into a single string.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig String -> [a] -> String
 * @param {Number|String} separator The string used to separate the elements.
 * @param {Array} xs The elements to join into a string.
 * @return {String} str The string made by concatenating `xs` with `separator`.
 * @see R.split
 * @example
 *
 *      const spacer = R.join(' ');
 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
 */ var $5e021b3854cd2d49$var$join = /*#__PURE__*/ (0, $cda97c466e8b3a0b$export$2e2bcd8739ae039)(1, "join");
var $5e021b3854cd2d49$export$2e2bcd8739ae039 = $5e021b3854cd2d49$var$join;




/**
 * juxt applies a list of functions to a list of values.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Function
 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
 * @param {Array} fns An array of functions
 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
 * @see R.applySpec
 * @example
 *
 *      const getRange = R.juxt([Math.min, Math.max]);
 *      getRange(3, 4, 9, -3); //=> [-3, 9]
 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
 */ var $9e1961f5984d4953$var$juxt = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function juxt(fns) {
    return (0, $8635059754596aea$export$2e2bcd8739ae039)(function() {
        return Array.prototype.slice.call(arguments, 0);
    }, fns);
});
var $9e1961f5984d4953$export$2e2bcd8739ae039 = $9e1961f5984d4953$var$juxt;




/**
 * Returns a list containing the names of all the properties of the supplied
 * object, including prototype properties.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own and prototype properties.
 * @see R.keys, R.valuesIn
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.keysIn(f); //=> ['x', 'y']
 */ var $7e8379a2371dae4d$var$keysIn = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function keysIn(obj) {
    var prop;
    var ks = [];
    for(prop in obj)ks[ks.length] = prop;
    return ks;
});
var $7e8379a2371dae4d$export$2e2bcd8739ae039 = $7e8379a2371dae4d$var$keysIn;






/**
 * Returns the position of the last occurrence of an item in an array, or -1 if
 * the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.indexOf, R.findLastIndex
 * @example
 *
 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
 */ var $0d4a84a4dfcde22c$var$lastIndexOf = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function lastIndexOf(target, xs) {
    if (typeof xs.lastIndexOf === "function" && !(0, $6011f766ba1d1c66$export$2e2bcd8739ae039)(xs)) return xs.lastIndexOf(target);
    else {
        var idx = xs.length - 1;
        while(idx >= 0){
            if ((0, $1cb60074c12b9394$export$2e2bcd8739ae039)(xs[idx], target)) return idx;
            idx -= 1;
        }
        return -1;
    }
});
var $0d4a84a4dfcde22c$export$2e2bcd8739ae039 = $0d4a84a4dfcde22c$var$lastIndexOf;



function $4782a03023189f78$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object Number]";
}


/**
 * Returns the number of elements in the array by returning `list.length`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [a] -> Number
 * @param {Array} list The array to inspect.
 * @return {Number} The length of the array.
 * @example
 *
 *      R.length([]); //=> 0
 *      R.length([1, 2, 3]); //=> 3
 */ var $39d327f6450eab17$var$length = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function length(list) {
    return list != null && (0, $4782a03023189f78$export$2e2bcd8739ae039)(list.length) ? list.length : NaN;
});
var $39d327f6450eab17$export$2e2bcd8739ae039 = $39d327f6450eab17$var$length;




/**
 * Returns a lens for the given getter and setter functions. The getter "gets"
 * the value of the focus; the setter "sets" the value of the focus. The setter
 * should not mutate the data structure.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
 * @param {Function} getter
 * @param {Function} setter
 * @return {Lens}
 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
 * @example
 *
 *      const xLens = R.lens(R.prop('x'), R.assoc('x'));
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */ var $0944222f275f4ec3$var$lens = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function lens(getter, setter) {
    return function(toFunctorFn) {
        return function(target) {
            return (0, $46e97bbca4e2864f$export$2e2bcd8739ae039)(function(focus) {
                return setter(focus, target);
            }, toFunctorFn(getter(target)));
        };
    };
});
var $0944222f275f4ec3$export$2e2bcd8739ae039 = $0944222f275f4ec3$var$lens;








/**
 * Returns a new copy of the array with the element at the provided index
 * replaced with the given value.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} idx The index to update.
 * @param {*} x The value to exist at the given index of the returned array.
 * @param {Array|Arguments} list The source array-like object to be updated.
 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
 * @see R.adjust
 * @example
 *
 *      R.update(1, '_', ['a', 'b', 'c']);      //=> ['a', '_', 'c']
 *      R.update(-1, '_', ['a', 'b', 'c']);     //=> ['a', 'b', '_']
 * @symb R.update(-1, a, [b, c]) = [b, a]
 * @symb R.update(0, a, [b, c]) = [a, c]
 * @symb R.update(1, a, [b, c]) = [b, a]
 */ var $feb3f7bec67aa13e$var$update = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function update(idx, x, list) {
    return (0, $491cea0ccb4d4362$export$2e2bcd8739ae039)(idx, (0, $0c56c4792563d166$export$2e2bcd8739ae039)(x), list);
});
var $feb3f7bec67aa13e$export$2e2bcd8739ae039 = $feb3f7bec67aa13e$var$update;


/**
 * Returns a lens whose focus is the specified index.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Number -> Lens s a
 * @param {Number} n
 * @return {Lens}
 * @see R.view, R.set, R.over, R.nth
 * @example
 *
 *      const headLens = R.lensIndex(0);
 *
 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
 */ var $1e0968c5b5a1e208$var$lensIndex = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function lensIndex(n) {
    return (0, $0944222f275f4ec3$export$2e2bcd8739ae039)((0, $6c38596ac956df55$export$2e2bcd8739ae039)(n), (0, $feb3f7bec67aa13e$export$2e2bcd8739ae039)(n));
});
var $1e0968c5b5a1e208$export$2e2bcd8739ae039 = $1e0968c5b5a1e208$var$lensIndex;









/**
 * Retrieves the values at given paths of an object.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Object
 * @typedefn Idx = [String | Int | Symbol]
 * @sig [Idx] -> {a} -> [a | Undefined]
 * @param {Array} pathsArray The array of paths to be fetched.
 * @param {Object} obj The object to retrieve the nested properties from.
 * @return {Array} A list consisting of values at paths specified by "pathsArray".
 * @see R.path
 * @example
 *
 *      R.paths([['a', 'b'], ['p', 0, 'q']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, 3]
 *      R.paths([['a', 'b'], ['p', 'r']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, undefined]
 */ var $10d6b6f4b80c9b23$var$paths = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function paths(pathsArray, obj) {
    return pathsArray.map(function(paths) {
        var val = obj;
        var idx = 0;
        var p;
        while(idx < paths.length){
            if (val == null) return;
            p = paths[idx];
            val = (0, $8895c4c9dcfccbb6$export$2e2bcd8739ae039)(p) ? (0, $6c38596ac956df55$export$2e2bcd8739ae039)(p, val) : val[p];
            idx += 1;
        }
        return val;
    });
});
var $10d6b6f4b80c9b23$export$2e2bcd8739ae039 = $10d6b6f4b80c9b23$var$paths;


/**
 * Retrieves the value at a given path. The nodes of the path can be arbitrary strings or non-negative integers.
 * For anything else, the value is unspecified. Integer paths are meant to index arrays, strings are meant for objects.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> {a} -> a | Undefined
 * @sig Idx = String | NonNegativeInt
 * @param {Array} path The path to use.
 * @param {Object} obj The object or array to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop, R.nth, R.assocPath, R.dissocPath
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 *      R.path(['a', 'b', 0], {a: {b: [1, 2, 3]}}); //=> 1
 *      R.path(['a', 'b', -2], {a: {b: [1, 2, 3]}}); //=> 2
 *      R.path([2], {'2': 2}); //=> 2
 *      R.path([-2], {'-2': 'a'}); //=> undefined
 */ var $68c047577bfeff4b$var$path = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function path(pathAr, obj) {
    return (0, $10d6b6f4b80c9b23$export$2e2bcd8739ae039)([
        pathAr
    ], obj)[0];
});
var $68c047577bfeff4b$export$2e2bcd8739ae039 = $68c047577bfeff4b$var$path;


/**
 * Returns a lens whose focus is the specified path.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig [Idx] -> Lens s a
 * @param {Array} path The path to use.
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const xHeadYLens = R.lensPath(['x', 0, 'y']);
 *
 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> 2
 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
 */ var $7494ccf0d6d41ea9$var$lensPath = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function lensPath(p) {
    return (0, $0944222f275f4ec3$export$2e2bcd8739ae039)((0, $68c047577bfeff4b$export$2e2bcd8739ae039)(p), (0, $0aabea20b9ad92d2$export$2e2bcd8739ae039)(p));
});
var $7494ccf0d6d41ea9$export$2e2bcd8739ae039 = $7494ccf0d6d41ea9$var$lensPath;






/**
 * Returns a lens whose focus is the specified property.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig String -> Lens s a
 * @param {String} k
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */ var $4ad9375c19bb38ad$var$lensProp = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function lensProp(k) {
    return (0, $0944222f275f4ec3$export$2e2bcd8739ae039)((0, $f421bed41196907e$export$2e2bcd8739ae039)(k), (0, $ac9a81c9bab1cafa$export$2e2bcd8739ae039)(k));
});
var $4ad9375c19bb38ad$export$2e2bcd8739ae039 = $4ad9375c19bb38ad$var$lensProp;





/**
 * Returns `true` if the first argument is less than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.gt
 * @example
 *
 *      R.lt(2, 1); //=> false
 *      R.lt(2, 2); //=> false
 *      R.lt(2, 3); //=> true
 *      R.lt('a', 'z'); //=> true
 *      R.lt('z', 'a'); //=> false
 */ var $cf7433fde1723455$var$lt = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function lt(a, b) {
    return a < b;
});
var $cf7433fde1723455$export$2e2bcd8739ae039 = $cf7433fde1723455$var$lt;



/**
 * Returns `true` if the first argument is less than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.gte
 * @example
 *
 *      R.lte(2, 1); //=> false
 *      R.lte(2, 2); //=> true
 *      R.lte(2, 3); //=> true
 *      R.lte('a', 'z'); //=> true
 *      R.lte('z', 'a'); //=> false
 */ var $ff8a4e4a7e226487$var$lte = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function lte(a, b) {
    return a <= b;
});
var $ff8a4e4a7e226487$export$2e2bcd8739ae039 = $ff8a4e4a7e226487$var$lte;




/**
 * The `mapAccum` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from left to right, and returning a final value of this
 * accumulator together with the new list.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.scan, R.addIndex, R.mapAccumRight
 * @example
 *
 *      const digits = ['1', '2', '3', '4'];
 *      const appender = (a, b) => [a + b, a + b];
 *
 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
 * @symb R.mapAccum(f, a, [b, c, d]) = [
 *   f(f(f(a, b)[0], c)[0], d)[0],
 *   [
 *     f(a, b)[1],
 *     f(f(a, b)[0], c)[1],
 *     f(f(f(a, b)[0], c)[0], d)[1]
 *   ]
 * ]
 */ var $addbb4a076f800a0$var$mapAccum = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function mapAccum(fn, acc, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    var tuple = [
        acc
    ];
    while(idx < len){
        tuple = fn(tuple[0], list[idx]);
        result[idx] = tuple[1];
        idx += 1;
    }
    return [
        tuple[0],
        result
    ];
});
var $addbb4a076f800a0$export$2e2bcd8739ae039 = $addbb4a076f800a0$var$mapAccum;



/**
 * The `mapAccumRight` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from right to left, and returning a final value of this
 * accumulator together with the new list.
 *
 * Similar to [`mapAccum`](#mapAccum), except moves through the input list from
 * the right to the left.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.addIndex, R.mapAccum
 * @example
 *
 *      const digits = ['1', '2', '3', '4'];
 *      const appender = (a, b) => [b + a, b + a];
 *
 *      R.mapAccumRight(appender, 5, digits); //=> ['12345', ['12345', '2345', '345', '45']]
 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
 *   f(f(f(a, d)[0], c)[0], b)[0],
 *   [
 *     f(a, d)[1],
 *     f(f(a, d)[0], c)[1],
 *     f(f(f(a, d)[0], c)[0], b)[1]
 *   ]
 * ]
 */ var $b565ee7846b3d406$var$mapAccumRight = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function mapAccumRight(fn, acc, list) {
    var idx = list.length - 1;
    var result = [];
    var tuple = [
        acc
    ];
    while(idx >= 0){
        tuple = fn(tuple[0], list[idx]);
        result[idx] = tuple[1];
        idx -= 1;
    }
    return [
        tuple[0],
        result
    ];
});
var $b565ee7846b3d406$export$2e2bcd8739ae039 = $b565ee7846b3d406$var$mapAccumRight;





/**
 * An Object-specific version of [`map`](#map). The function is applied to three
 * arguments: *(value, key, obj)*. If only the value is significant, use
 * [`map`](#map) instead.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig ((*, String, Object) -> *) -> Object -> Object
 * @param {Function} fn
 * @param {Object} obj
 * @return {Object}
 * @see R.map
 * @example
 *
 *      const xyz = { x: 1, y: 2, z: 3 };
 *      const prependKeyAndDouble = (num, key, obj) => key + (num * 2);
 *
 *      R.mapObjIndexed(prependKeyAndDouble, xyz); //=> { x: 'x2', y: 'y4', z: 'z6' }
 */ var $ff259604b1b55863$var$mapObjIndexed = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function mapObjIndexed(fn, obj) {
    return (0, $ca7fefc233c4118f$export$2e2bcd8739ae039)(function(acc, key) {
        acc[key] = fn(obj[key], key, obj);
        return acc;
    }, {}, (0, $f952fda84f71812a$export$2e2bcd8739ae039)(obj));
});
var $ff259604b1b55863$export$2e2bcd8739ae039 = $ff259604b1b55863$var$mapObjIndexed;



/**
 * Tests a regular expression against a String. Note that this function will
 * return an empty array when there are no matches. This differs from
 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
 * which returns `null` when there are no matches.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig RegExp -> String -> [String | Undefined]
 * @param {RegExp} rx A regular expression.
 * @param {String} str The string to match against
 * @return {Array} The list of matches or empty array.
 * @see R.test
 * @example
 *
 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
 *      R.match(/a/, 'b'); //=> []
 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
 */ var $61a7a6248d286d8b$var$match = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function match(rx, str) {
    return str.match(rx) || [];
});
var $61a7a6248d286d8b$export$2e2bcd8739ae039 = $61a7a6248d286d8b$var$match;




/**
 * `mathMod` behaves like the modulo operator should mathematically, unlike the
 * `%` operator (and by extension, [`R.modulo`](#modulo)). So while
 * `-17 % 5` is `-2`, `mathMod(-17, 5)` is `3`. `mathMod` requires Integer
 * arguments, and returns NaN when the modulus is zero or negative.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} m The dividend.
 * @param {Number} p the modulus.
 * @return {Number} The result of `b mod a`.
 * @see R.modulo
 * @example
 *
 *      R.mathMod(-17, 5);  //=> 3
 *      R.mathMod(17, 5);   //=> 2
 *      R.mathMod(17, -5);  //=> NaN
 *      R.mathMod(17, 0);   //=> NaN
 *      R.mathMod(17.2, 5); //=> NaN
 *      R.mathMod(17, 5.3); //=> NaN
 *
 *      const clock = R.mathMod(R.__, 12);
 *      clock(15); //=> 3
 *      clock(24); //=> 0
 *
 *      const seventeenMod = R.mathMod(17);
 *      seventeenMod(3);  //=> 2
 *      seventeenMod(4);  //=> 1
 *      seventeenMod(10); //=> 7
 */ var $5c4d4381f3282f11$var$mathMod = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function mathMod(m, p) {
    if (!(0, $8895c4c9dcfccbb6$export$2e2bcd8739ae039)(m)) return NaN;
    if (!(0, $8895c4c9dcfccbb6$export$2e2bcd8739ae039)(p) || p < 1) return NaN;
    return (m % p + p) % p;
});
var $5c4d4381f3282f11$export$2e2bcd8739ae039 = $5c4d4381f3282f11$var$mathMod;





/**
 * Takes a function and two values, and returns whichever value produces the
 * larger result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.max, R.minBy
 * @example
 *
 *      //  square :: Number -> Number
 *      const square = n => n * n;
 *
 *      R.maxBy(square, -3, 2); //=> -3
 *
 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
 *      R.reduce(R.maxBy(square), 0, []); //=> 0
 */ var $d4bccbc04c9e34c6$var$maxBy = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function maxBy(f, a, b) {
    var resultB = f(b);
    return (0, $9170e2306954e853$export$2e2bcd8739ae039)(f(a), resultB) === resultB ? b : a;
});
var $d4bccbc04c9e34c6$export$2e2bcd8739ae039 = $d4bccbc04c9e34c6$var$maxBy;





/**
 * Adds together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The sum of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.sum([2,4,6,8,100,1]); //=> 121
 */ var $2c069fcb5aceb4bf$var$sum = /*#__PURE__*/ (0, $15e42530af719b84$export$2e2bcd8739ae039)((0, $5478c02438a847eb$export$2e2bcd8739ae039), 0);
var $2c069fcb5aceb4bf$export$2e2bcd8739ae039 = $2c069fcb5aceb4bf$var$sum;


/**
 * Returns the mean of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.median
 * @example
 *
 *      R.mean([2, 7, 9]); //=> 6
 *      R.mean([]); //=> NaN
 */ var $8aa43f1189254b59$var$mean = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function mean(list) {
    return (0, $2c069fcb5aceb4bf$export$2e2bcd8739ae039)(list) / list.length;
});
var $8aa43f1189254b59$export$2e2bcd8739ae039 = $8aa43f1189254b59$var$mean;




/**
 * Returns the median of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.mean
 * @example
 *
 *      R.median([2, 9, 7]); //=> 7
 *      R.median([7, 2, 10, 9]); //=> 8
 *      R.median([]); //=> NaN
 */ var $442d3c430479dea2$var$median = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function median(list) {
    var len = list.length;
    if (len === 0) return NaN;
    var width = 2 - len % 2;
    var idx = (len - width) / 2;
    return (0, $8aa43f1189254b59$export$2e2bcd8739ae039)(Array.prototype.slice.call(list, 0).sort(function(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    }).slice(idx, idx + width));
});
var $442d3c430479dea2$export$2e2bcd8739ae039 = $442d3c430479dea2$var$median;





/**
 * Takes a string-returning function `keyGen` and a function `fn` and returns
 * a new function that returns cached results for subsequent
 * calls with the same arguments.
 *
 * When the function is invoked, `keyGen` is applied to the same arguments
 * and its result becomes the cache key. If the cache contains something
 * under that key, the function simply returns it and does not invoke `fn` at all.
 *
 * Otherwise `fn` is applied to the same arguments and its return value
 * is cached under that key and returned by the function.
 *
 * Care must be taken when implementing `keyGen` to avoid key collision,
 * or if tracking references, memory leaks and mutating arguments.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
 * @param {Function} keyGen The function to generate the cache key.
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @example
 *      const withAge = memoizeWith(o => `${o.birth}/${o.death}`, ({birth, death}) => {
 *      //                          ^^^^^^^^^^^^^^^^^^^^^^^^^^^^  ^^^^^^^^^^^^^^^^^^^^^
 *      //                          keyGen                        fn
 *        console.log(`computing age for ${birth}/${death}`);
 *        return ({birth, death, age: death - birth});
 *      });
 *
 *      withAge({birth: 1921, death: 1999});
 *      //=> LOG: computing age for 1921/1999
 *      //=> {birth: 1921, death: 1999, age: 78} (returned from fn)
 *
 *      withAge({birth: 1921, death: 1999});
 *      //=> {birth: 1921, death: 1999, age: 78} (returned from cache)
 */ var $089abcecad92ce38$var$memoizeWith = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function memoizeWith(keyGen, fn) {
    var cache = {};
    return (0, $25d67f9135fe3bce$export$2e2bcd8739ae039)(fn.length, function() {
        var key = keyGen.apply(this, arguments);
        if (!(0, $ca32895e0ecf33fa$export$2e2bcd8739ae039)(key, cache)) cache[key] = fn.apply(this, arguments);
        return cache[key];
    });
});
var $089abcecad92ce38$export$2e2bcd8739ae039 = $089abcecad92ce38$var$memoizeWith;




/**
 * Creates one new object with the own properties from a list of objects.
 * If a key exists in more than one object, the value from the last
 * object it exists in will be used.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig [{k: v}] -> {k: v}
 * @param {Array} list An array of objects
 * @return {Object} A merged object.
 * @see R.reduce
 * @example
 *
 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
 */ var $247d6bbb93c1ec55$var$mergeAll = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function mergeAll(list) {
    return (0, $2fe89b24c64d55b8$export$2e2bcd8739ae039).apply(null, [
        {}
    ].concat(list));
});
var $247d6bbb93c1ec55$export$2e2bcd8739ae039 = $247d6bbb93c1ec55$var$mergeAll;







/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */ var $0722ac1005bc0d68$var$mergeWithKey = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function mergeWithKey(fn, l, r) {
    var result = {};
    var k;
    l = l || {};
    r = r || {};
    for(k in l)if ((0, $ca32895e0ecf33fa$export$2e2bcd8739ae039)(k, l)) result[k] = (0, $ca32895e0ecf33fa$export$2e2bcd8739ae039)(k, r) ? fn(k, l[k], r[k]) : l[k];
    for(k in r)if ((0, $ca32895e0ecf33fa$export$2e2bcd8739ae039)(k, r) && !(0, $ca32895e0ecf33fa$export$2e2bcd8739ae039)(k, result)) result[k] = r[k];
    return result;
});
var $0722ac1005bc0d68$export$2e2bcd8739ae039 = $0722ac1005bc0d68$var$mergeWithKey;


/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */ var $194ce24a99c449be$var$mergeDeepWithKey = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function mergeDeepWithKey(fn, lObj, rObj) {
    return (0, $0722ac1005bc0d68$export$2e2bcd8739ae039)(function(k, lVal, rVal) {
        if ((0, $fd0ff931a83ae834$export$2e2bcd8739ae039)(lVal) && (0, $fd0ff931a83ae834$export$2e2bcd8739ae039)(rVal)) return mergeDeepWithKey(fn, lVal, rVal);
        else return fn(k, lVal, rVal);
    }, lObj, rObj);
});
var $194ce24a99c449be$export$2e2bcd8739ae039 = $194ce24a99c449be$var$mergeDeepWithKey;


/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                      { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
 */ var $df870da81e22353c$var$mergeDeepLeft = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function mergeDeepLeft(lObj, rObj) {
    return (0, $194ce24a99c449be$export$2e2bcd8739ae039)(function(k, lVal, rVal) {
        return lVal;
    }, lObj, rObj);
});
var $df870da81e22353c$export$2e2bcd8739ae039 = $df870da81e22353c$var$mergeDeepLeft;




/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                       { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
 */ var $abe4acf7536815ea$var$mergeDeepRight = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function mergeDeepRight(lObj, rObj) {
    return (0, $194ce24a99c449be$export$2e2bcd8739ae039)(function(k, lVal, rVal) {
        return rVal;
    }, lObj, rObj);
});
var $abe4acf7536815ea$export$2e2bcd8739ae039 = $abe4acf7536815ea$var$mergeDeepRight;




/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to associated values using the
 *   resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepWith(R.concat,
 *                      { a: true, c: { values: [10, 20] }},
 *                      { b: true, c: { values: [15, 35] }});
 *      //=> { a: true, b: true, c: { values: [10, 20, 15, 35] }}
 */ var $71753b1b185078d8$var$mergeDeepWith = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function mergeDeepWith(fn, lObj, rObj) {
    return (0, $194ce24a99c449be$export$2e2bcd8739ae039)(function(k, lVal, rVal) {
        return fn(lVal, rVal);
    }, lObj, rObj);
});
var $71753b1b185078d8$export$2e2bcd8739ae039 = $71753b1b185078d8$var$mergeDeepWith;





/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeRight, R.mergeDeepLeft, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeLeft({ 'age': 40 }, { 'name': 'fred', 'age': 10 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const resetToDefault = R.mergeLeft({x: 0});
 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeLeft(a, b) = {...b, ...a}
 */ var $38ca81791a425b90$var$mergeLeft = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function mergeLeft(l, r) {
    return (0, $2fe89b24c64d55b8$export$2e2bcd8739ae039)({}, r, l);
});
var $38ca81791a425b90$export$2e2bcd8739ae039 = $38ca81791a425b90$var$mergeLeft;




/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeLeft, R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeRight({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const withDefaults = R.mergeRight({x: 0, y: 0});
 *      withDefaults({y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeRight(a, b) = {...a, ...b}
 */ var $4d773d00f3e62aba$var$mergeRight = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function mergeRight(l, r) {
    return (0, $2fe89b24c64d55b8$export$2e2bcd8739ae039)({}, l, r);
});
var $4d773d00f3e62aba$export$2e2bcd8739ae039 = $4d773d00f3e62aba$var$mergeRight;




/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the values
 * associated with the key in each object, with the result being used as the
 * value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWith, R.merge, R.mergeWithKey
 * @example
 *
 *      R.mergeWith(R.concat,
 *                  { a: true, values: [10, 20] },
 *                  { b: true, values: [15, 35] });
 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
 */ var $c8a9a25ba222a55c$var$mergeWith = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function mergeWith(fn, l, r) {
    return (0, $0722ac1005bc0d68$export$2e2bcd8739ae039)(function(_, _l, _r) {
        return fn(_l, _r);
    }, l, r);
});
var $c8a9a25ba222a55c$export$2e2bcd8739ae039 = $c8a9a25ba222a55c$var$mergeWith;





/**
 * Returns the smaller of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.minBy, R.max
 * @example
 *
 *      R.min(789, 123); //=> 123
 *      R.min('a', 'b'); //=> 'a'
 */ var $9f0f6ae69d1e3ad2$var$min = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function min(a, b) {
    if (a === b) return a;
    function safeMin(x, y) {
        if (x < y !== y < x) return y < x ? y : x;
        return undefined;
    }
    var minByValue = safeMin(a, b);
    if (minByValue !== undefined) return minByValue;
    var minByType = safeMin(typeof a, typeof b);
    if (minByType !== undefined) return minByType === typeof a ? a : b;
    var stringA = (0, $c62f1cf5b0b06d2c$export$2e2bcd8739ae039)(a);
    var minByStringValue = safeMin(stringA, (0, $c62f1cf5b0b06d2c$export$2e2bcd8739ae039)(b));
    if (minByStringValue !== undefined) return minByStringValue === stringA ? a : b;
    return a;
});
var $9f0f6ae69d1e3ad2$export$2e2bcd8739ae039 = $9f0f6ae69d1e3ad2$var$min;




/**
 * Takes a function and two values, and returns whichever value produces the
 * smaller result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.min, R.maxBy
 * @example
 *
 *      //  square :: Number -> Number
 *      const square = n => n * n;
 *
 *      R.minBy(square, -3, 2); //=> 2
 *
 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
 */ var $94585e0e7054e35b$var$minBy = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function minBy(f, a, b) {
    var resultB = f(b);
    return (0, $9f0f6ae69d1e3ad2$export$2e2bcd8739ae039)(f(a), resultB) === resultB ? b : a;
});
var $94585e0e7054e35b$export$2e2bcd8739ae039 = $94585e0e7054e35b$var$minBy;










function $85368d02c5af02fb$export$2e2bcd8739ae039(prop, fn, obj) {
    if ((0, $8895c4c9dcfccbb6$export$2e2bcd8739ae039)(prop) && (0, $6011f766ba1d1c66$export$2e2bcd8739ae039)(obj)) {
        var arr = [].concat(obj);
        arr[prop] = fn(arr[prop]);
        return arr;
    }
    var result = {};
    for(var p in obj)result[p] = obj[p];
    result[prop] = fn(result[prop]);
    return result;
}


/**
 * Creates a shallow clone of the passed object by applying an `fn` function
 * to the value at the given path.
 *
 * The function will not be invoked, and the object will not change
 * if its corresponding path does not exist in the object.
 * All non-primitive properties are copied to the new object by reference.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Object
 * @sig [Idx] -> (v -> v) -> {k: v} -> {k: v}
 * @param {Array} path The path to be modified.
 * @param {Function} fn The function to apply to the path.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const person = {name: 'James', address: { zipCode: '90216' }};
 *      R.modifyPath(['address', 'zipCode'], R.reverse, person); //=> {name: 'James', address: { zipCode: '61209' }}
 *
 *      // Can handle arrays too
 *      const person = {name: 'James', addresses: [{ zipCode: '90216' }]};
 *      R.modifyPath(['addresses', 0, 'zipCode'], R.reverse, person); //=> {name: 'James', addresses: [{ zipCode: '61209' }]}
 */ var $85a7337beadb23f2$var$modifyPath = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function modifyPath(path, fn, object) {
    if (!(0, $fd0ff931a83ae834$export$2e2bcd8739ae039)(object) && !(0, $6011f766ba1d1c66$export$2e2bcd8739ae039)(object) || path.length === 0) return object;
    var idx = path[0];
    if (!(0, $ca32895e0ecf33fa$export$2e2bcd8739ae039)(idx, object)) return object;
    if (path.length === 1) return (0, $85368d02c5af02fb$export$2e2bcd8739ae039)(idx, fn, object);
    var val = modifyPath(Array.prototype.slice.call(path, 1), fn, object[idx]);
    if (val === object[idx]) return object;
    return (0, $d627dd4056b0db98$export$2e2bcd8739ae039)(idx, val, object);
});
var $85a7337beadb23f2$export$2e2bcd8739ae039 = $85a7337beadb23f2$var$modifyPath;


/**
 * Creates a copy of the passed object by applying an `fn` function to the given `prop` property.
 *
 * The function will not be invoked, and the object will not change
 * if its corresponding property does not exist in the object.
 * All non-primitive properties are copied to the new object by reference.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Object
 * @sig Idx -> (v -> v) -> {k: v} -> {k: v}
 * @param {String|Number} prop The property to be modified.
 * @param {Function} fn The function to apply to the property.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const person = {name: 'James', age: 20, pets: ['dog', 'cat']};
 *      R.modify('age', R.add(1), person); //=> {name: 'James', age: 21, pets: ['dog', 'cat']}
 *      R.modify('pets', R.append('turtle'), person); //=> {name: 'James', age: 20, pets: ['dog', 'cat', 'turtle']}
 */ var $547e0d1fe34681d6$var$modify = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function modify(prop, fn, object) {
    return (0, $85a7337beadb23f2$export$2e2bcd8739ae039)([
        prop
    ], fn, object);
});
var $547e0d1fe34681d6$export$2e2bcd8739ae039 = $547e0d1fe34681d6$var$modify;




/**
 * Divides the first parameter by the second and returns the remainder. Note
 * that this function preserves the JavaScript-style behavior for modulo. For
 * mathematical modulo see [`mathMod`](#mathMod).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The value to the divide.
 * @param {Number} b The pseudo-modulus
 * @return {Number} The result of `b % a`.
 * @see R.mathMod
 * @example
 *
 *      R.modulo(17, 3); //=> 2
 *      // JS behavior:
 *      R.modulo(-17, 3); //=> -2
 *      R.modulo(17, -3); //=> 2
 *
 *      const isOdd = R.modulo(R.__, 2);
 *      isOdd(42); //=> 0
 *      isOdd(21); //=> 1
 */ var $85ce768b76f7d35c$var$modulo = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function modulo(a, b) {
    return a % b;
});
var $85ce768b76f7d35c$export$2e2bcd8739ae039 = $85ce768b76f7d35c$var$modulo;



/**
 * Move an item, at index `from`, to index `to`, in a list of elements.
 * A new list will be created containing the new elements order.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} from The source index
 * @param {Number} to The destination index
 * @param {Array} list The list which will serve to realise the move
 * @return {Array} The new list reordered
 * @example
 *
 *      R.move(0, 2, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['b', 'c', 'a', 'd', 'e', 'f']
 *      R.move(-1, 0, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['f', 'a', 'b', 'c', 'd', 'e'] list rotation
 */ var $cf3de03a1444be25$var$move = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function(from, to, list) {
    var length = list.length;
    var result = list.slice();
    var positiveFrom = from < 0 ? length + from : from;
    var positiveTo = to < 0 ? length + to : to;
    var item = result.splice(positiveFrom, 1);
    return positiveFrom < 0 || positiveFrom >= list.length || positiveTo < 0 || positiveTo >= list.length ? list : [].concat(result.slice(0, positiveTo)).concat(item).concat(result.slice(positiveTo, list.length));
});
var $cf3de03a1444be25$export$2e2bcd8739ae039 = $cf3de03a1444be25$var$move;



/**
 * Multiplies two numbers. Equivalent to `a * b` but curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a * b`.
 * @see R.divide
 * @example
 *
 *      const double = R.multiply(2);
 *      const triple = R.multiply(3);
 *      double(3);       //=>  6
 *      triple(4);       //=> 12
 *      R.multiply(2, 5);  //=> 10
 */ var $e67eec62bc824e5e$var$multiply = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function multiply(a, b) {
    return a * b;
});
var $e67eec62bc824e5e$export$2e2bcd8739ae039 = $e67eec62bc824e5e$var$multiply;



var $e202ce239837c783$exports = {};


/**
 * Takes a function `f` and an object, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the object
 * provided initially merged deeply (right) with the object provided as an argument to `g`.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Function
 * @sig (({ a, b, c, ..., n }) -> x) -> { a, b, c, ...} -> ({ d, e, f, ..., n } -> x)
 * @param {Function} f
 * @param {Object} props
 * @return {Function}
 * @see R.partial, R.partialRight, R.curry, R.mergeDeepRight
 * @example
 *
 *      const multiply2 = ({ a, b }) => a * b;
 *      const double = R.partialObject(multiply2, { a: 2 });
 *      double({ b: 2 }); //=> 4
 *
 *      const greet = ({ salutation, title, firstName, lastName }) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const sayHello = R.partialObject(greet, { salutation: 'Hello' });
 *      const sayHelloToMs = R.partialObject(sayHello, { title: 'Ms.' });
 *      sayHelloToMs({ firstName: 'Jane', lastName: 'Jones' }); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialObject(f, { a, b })({ c, d }) = f({ a, b, c, d })
 */ var $e202ce239837c783$var$partialObject = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)((f, o)=>(props)=>f.call(undefined, (0, $abe4acf7536815ea$export$2e2bcd8739ae039)(o, props)));
var $e202ce239837c783$export$2e2bcd8739ae039 = $e202ce239837c783$var$partialObject;



/**
 * Negates its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number}
 * @example
 *
 *      R.negate(42); //=> -42
 */ var $ed436f326d611cb9$var$negate = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function negate(n) {
    return -n;
});
var $ed436f326d611cb9$export$2e2bcd8739ae039 = $ed436f326d611cb9$var$negate;





/**
 * Returns `true` if no elements of the list match the predicate, `false`
 * otherwise.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
 * @see R.all, R.any
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *      const isOdd = n => n % 2 !== 0;
 *
 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
 *      R.none(isOdd, [1, 3, 5, 7, 8, 11]); //=> false
 */ var $4863a67ceaa59411$var$none = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function none(fn, input) {
    return (0, $1d12b48175cb34a5$export$2e2bcd8739ae039)((0, $76b671d1ea92e335$export$2e2bcd8739ae039)(fn), input);
});
var $4863a67ceaa59411$export$2e2bcd8739ae039 = $4863a67ceaa59411$var$none;







/**
 * Returns a function which returns its nth argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig Number -> *... -> *
 * @param {Number} n
 * @return {Function}
 * @example
 *
 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
 * @symb R.nthArg(-1)(a, b, c) = c
 * @symb R.nthArg(0)(a, b, c) = a
 * @symb R.nthArg(1)(a, b, c) = b
 */ var $811c1ada9ddc69a3$var$nthArg = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function nthArg(n) {
    var arity = n < 0 ? 1 : n + 1;
    return (0, $8bd7b963d2d08f64$export$2e2bcd8739ae039)(arity, function() {
        return (0, $6c38596ac956df55$export$2e2bcd8739ae039)(n, arguments);
    });
});
var $811c1ada9ddc69a3$export$2e2bcd8739ae039 = $811c1ada9ddc69a3$var$nthArg;



/**
 * `o` is a curried composition function that returns a unary function.
 * Like [`compose`](#compose), `o` performs right-to-left function composition.
 * Unlike [`compose`](#compose), the rightmost function passed to `o` will be
 * invoked with only one argument. Also, unlike [`compose`](#compose), `o` is
 * limited to accepting only 2 unary functions. The name o was chosen because
 * of its similarity to the mathematical composition operator ∘.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (b -> c) -> (a -> b) -> a -> c
 * @param {Function} f
 * @param {Function} g
 * @return {Function}
 * @see R.compose, R.pipe
 * @example
 *
 *      const classyGreeting = name => "The name's " + name.last + ", " + name.first + " " + name.last
 *      const yellGreeting = R.o(R.toUpper, classyGreeting);
 *      yellGreeting({first: 'James', last: 'Bond'}); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.o(R.multiply(10), R.add(10))(-4) //=> 60
 *
 * @symb R.o(f, g, x) = f(g(x))
 */ var $b81f5b256d221597$var$o = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function o(f, g, x) {
    return f(g(x));
});
var $b81f5b256d221597$export$2e2bcd8739ae039 = $b81f5b256d221597$var$o;




/**
 * Given a constructor and a value, returns a new instance of that constructor
 * containing the value.
 *
 * Dispatches to the `fantasy-land/of` method of the constructor first (if present)
 * or to the `of` method last (if present). When neither are present, wraps the
 * value in an array.
 *
 * Note this `of` is different from the ES6 `of`; See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig (* -> {*}) -> a -> {a}
 * @param {Object} Ctor A constructor
 * @param {*} val any value
 * @return {*} An instance of the `Ctor` wrapping `val`.
 * @example
 *
 *      R.of(Array, 42);   //=> [42]
 *      R.of(Array, [42]); //=> [[42]]
 *      R.of(Maybe, 42);   //=> Maybe.Just(42)
 */ var $cba8941d38a29cf6$var$of = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function of(Ctor, val) {
    return typeof Ctor["fantasy-land/of"] === "function" ? Ctor["fantasy-land/of"](val) : typeof Ctor.of === "function" ? Ctor.of(val) : [
        val
    ];
});
var $cba8941d38a29cf6$export$2e2bcd8739ae039 = $cba8941d38a29cf6$var$of;



/**
 * Returns a partial copy of an object omitting the keys specified.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [String] -> {String: *} -> {String: *}
 * @param {Array} names an array of String property names to omit from the new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with properties from `names` not on it.
 * @see R.pick
 * @example
 *
 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
 */ var $7a3d33e3fe61d4b0$var$omit = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function omit(names, obj) {
    var result = {};
    var index = {};
    var idx = 0;
    var len = names.length;
    while(idx < len){
        index[names[idx]] = 1;
        idx += 1;
    }
    for(var prop in obj)if (!index.hasOwnProperty(prop)) result[prop] = obj[prop];
    return result;
});
var $7a3d33e3fe61d4b0$export$2e2bcd8739ae039 = $7a3d33e3fe61d4b0$var$omit;



/**
 * Takes a binary function `f`, a unary function `g`, and two values.
 * Applies `g` to each value, then applies the result of each to `f`.
 *
 * Also known as the P combinator.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Function
 * @sig ((a, a) -> b) -> (c -> a) -> c -> c -> b
 * @param {Function} f a binary function
 * @param {Function} g a unary function
 * @param {any} a any value
 * @param {any} b any value
 * @return {any} The result of `f`
 * @example
 *
 *      const eqBy = R.on((a, b) => a === b);
 *      eqBy(R.prop('a'), {b:0, a:1}, {a:1}) //=> true;
 *
 *      const containsInsensitive = R.on(R.includes, R.toLower);
 *      containsInsensitive('o', 'FOO'); //=> true
 * @symb R.on(f, g, a, b) = f(g(a), g(b))
 */ var $9f0976afd4366a26$var$on = /*#__PURE__*/ (0, $04acb407ec8a4632$export$2e2bcd8739ae039)(4, [], function on(f, g, a, b) {
    return f(g(a), g(b));
});
var $9f0976afd4366a26$export$2e2bcd8739ae039 = $9f0976afd4366a26$var$on;




/**
 * Accepts a function `fn` and returns a function that guards invocation of
 * `fn` such that `fn` can only ever be called once, no matter how many times
 * the returned function is invoked. The first value calculated is returned in
 * subsequent invocations.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a... -> b) -> (a... -> b)
 * @param {Function} fn The function to wrap in a call-only-once wrapper.
 * @return {Function} The wrapped function.
 * @example
 *
 *      const addOneOnce = R.once(x => x + 1);
 *      addOneOnce(10); //=> 11
 *      addOneOnce(addOneOnce(50)); //=> 11
 */ var $918e82fb553ea2fd$var$once = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function once(fn) {
    var called = false;
    var result;
    return (0, $25d67f9135fe3bce$export$2e2bcd8739ae039)(fn.length, function() {
        if (called) return result;
        called = true;
        result = fn.apply(this, arguments);
        return result;
    });
});
var $918e82fb553ea2fd$export$2e2bcd8739ae039 = $918e82fb553ea2fd$var$once;






function $54de632a6d3dc244$export$2e2bcd8739ae039(name, p) {
    if (p == null || !(0, $3cb1b5de2bca6cb6$export$2e2bcd8739ae039)(p.then)) throw new TypeError("`" + name + "` expected a Promise, received " + (0, $74b5b553822d1b00$export$2e2bcd8739ae039)(p, []));
}


/**
 * Returns the result of applying the onFailure function to the value inside
 * a failed promise. This is useful for handling rejected promises
 * inside function compositions.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig (e -> b) -> (Promise e a) -> (Promise e b)
 * @sig (e -> (Promise f b)) -> (Promise e a) -> (Promise f b)
 * @param {Function} onFailure The function to apply. Can return a value or a promise of a value.
 * @param {Promise} p
 * @return {Promise} The result of calling `p.then(null, onFailure)`
 * @see R.andThen
 * @example
 *
 *      const failedFetch = id => Promise.reject('bad ID');
 *      const useDefault = () => ({ firstName: 'Bob', lastName: 'Loblaw' });
 *
 *      //recoverFromFailure :: String -> Promise ({ firstName, lastName })
 *      const recoverFromFailure = R.pipe(
 *        failedFetch,
 *        R.otherwise(useDefault),
 *        R.andThen(R.pick(['firstName', 'lastName'])),
 *      );
 *      recoverFromFailure(12345).then(console.log);
 */ var $b7b63d19037ed819$var$otherwise = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function otherwise(f, p) {
    (0, $54de632a6d3dc244$export$2e2bcd8739ae039)("otherwise", p);
    return p.then(null, f);
});
var $b7b63d19037ed819$export$2e2bcd8739ae039 = $b7b63d19037ed819$var$otherwise;



// transforms the held value with the provided function.
var $68fb36610bcecb96$var$Identity = function(x) {
    return {
        value: x,
        map: function(f) {
            return $68fb36610bcecb96$var$Identity(f(x));
        }
    };
};
/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the result of applying the given function to
 * the focused value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> (a -> a) -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.view, R.set, R.lens, R.lensIndex, R.lensProp, R.lensPath
 * @example
 *
 *      const headLens = R.lensIndex(0);
 *
 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
 */ var $68fb36610bcecb96$var$over = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function over(lens, f, x) {
    // The value returned by the getter function is first transformed with `f`,
    // then set as the value of an `Identity`. This is then mapped over with the
    // setter function of the lens.
    return lens(function(y) {
        return $68fb36610bcecb96$var$Identity(f(y));
    })(x).value;
});
var $68fb36610bcecb96$export$2e2bcd8739ae039 = $68fb36610bcecb96$var$over;



/**
 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category List
 * @sig a -> b -> (a,b)
 * @param {*} fst
 * @param {*} snd
 * @return {Array}
 * @see R.objOf, R.of
 * @example
 *
 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
 */ var $378f300b6a9b3163$var$pair = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function pair(fst, snd) {
    return [
        fst,
        snd
    ];
});
var $378f300b6a9b3163$export$2e2bcd8739ae039 = $378f300b6a9b3163$var$pair;





function $477f0c702f7d7908$export$2e2bcd8739ae039(concat) {
    return (0, $00e54140c2625599$export$2e2bcd8739ae039)(function(fn, args) {
        return (0, $25d67f9135fe3bce$export$2e2bcd8739ae039)(Math.max(0, fn.length - args.length), function() {
            return fn.apply(this, concat(args, arguments));
        });
    });
}


/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided initially followed by the arguments provided to `g`.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partialRight, R.curry
 * @example
 *
 *      const multiply2 = (a, b) => a * b;
 *      const double = R.partial(multiply2, [2]);
 *      double(3); //=> 6
 *
 *      const greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const sayHello = R.partial(greet, ['Hello']);
 *      const sayHelloToMs = R.partial(sayHello, ['Ms.']);
 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
 */ var $e884e14039ae4eb2$var$partial = /*#__PURE__*/ (0, $477f0c702f7d7908$export$2e2bcd8739ae039)((0, $177bce200a9ffba1$export$2e2bcd8739ae039));
var $e884e14039ae4eb2$export$2e2bcd8739ae039 = $e884e14039ae4eb2$var$partial;





/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided to `g` followed by the arguments provided initially.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partial
 * @example
 *
 *      const greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
 *
 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
 */ var $686ed40d375a2937$var$partialRight = /*#__PURE__*/ (0, $477f0c702f7d7908$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a6868a897e7652d6$export$2e2bcd8739ae039)((0, $177bce200a9ffba1$export$2e2bcd8739ae039)));
var $686ed40d375a2937$export$2e2bcd8739ae039 = $686ed40d375a2937$var$partialRight;





/**
 * Takes a predicate and a list or other `Filterable` object and returns the
 * pair of filterable objects of the same type of elements which do and do not
 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
 * @param {Function} pred A predicate to determine which side the element belongs to.
 * @param {Array} filterable the list (or other filterable) to partition.
 * @return {Array} An array, containing first the subset of elements that satisfy the
 *         predicate, and second the subset of elements that do not satisfy.
 * @see R.filter, R.reject
 * @example
 *
 *      R.partition(R.includes('s'), ['sss', 'ttt', 'foo', 'bars']);
 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
 *
 *      R.partition(R.includes('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
 */ var $3f03ce43c087cbb0$var$partition = /*#__PURE__*/ (0, $9e1961f5984d4953$export$2e2bcd8739ae039)([
    (0, $a81a10b9c9f23cb7$export$2e2bcd8739ae039),
    (0, $89ddad7dee8f4db5$export$2e2bcd8739ae039)
]);
var $3f03ce43c087cbb0$export$2e2bcd8739ae039 = $3f03ce43c087cbb0$var$partition;







/**
 * Determines whether a nested path on an object has a specific value, in
 * [`R.equals`](#equals) terms. Most likely used to filter a list.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Relation
 * @typedefn Idx = String | Int | Symbol
 * @sig a -> [Idx] -> {a} -> Boolean
 * @param {*} val The value to compare the nested property with
 * @param {Array} path The path of the nested property to use
 * @param {Object} obj The object to check the nested property in
 * @return {Boolean} `true` if the value equals the nested object property,
 *         `false` otherwise.
 * @see R.whereEq, R.propEq, R.pathSatisfies, R.equals
 * @example
 *
 *      const user1 = { address: { zipCode: 90210 } };
 *      const user2 = { address: { zipCode: 55555 } };
 *      const user3 = { name: 'Bob' };
 *      const users = [ user1, user2, user3 ];
 *      const isFamous = R.pathEq(90210, ['address', 'zipCode']);
 *      R.filter(isFamous, users); //=> [ user1 ]
 */ var $156cffbe5b8afa06$var$pathEq = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function pathEq(val, _path, obj) {
    return (0, $1cb60074c12b9394$export$2e2bcd8739ae039)((0, $68c047577bfeff4b$export$2e2bcd8739ae039)(_path, obj), val);
});
var $156cffbe5b8afa06$export$2e2bcd8739ae039 = $156cffbe5b8afa06$var$pathEq;





/**
 * If the given, non-null object has a value at the given path, returns the
 * value at that path. Otherwise returns the provided default value.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig a -> [Idx] -> {a} -> a
 * @param {*} d The default value.
 * @param {Array} p The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path` of the supplied object or the default value.
 * @example
 *
 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
 */ var $9f1f0d56d9f0b505$var$pathOr = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function pathOr(d, p, obj) {
    return (0, $05d273f6dccce24e$export$2e2bcd8739ae039)(d, (0, $68c047577bfeff4b$export$2e2bcd8739ae039)(p, obj));
});
var $9f1f0d56d9f0b505$export$2e2bcd8739ae039 = $9f1f0d56d9f0b505$var$pathOr;




/**
 * Returns `true` if the specified object property at given path satisfies the
 * given predicate; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Logic
 * @typedefn Idx = String | Int | Symbol
 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
 * @param {Function} pred
 * @param {Array} propPath
 * @param {*} obj
 * @return {Boolean}
 * @see R.propSatisfies, R.path
 * @example
 *
 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
 *      R.pathSatisfies(R.is(Object), [], {x: {y: 2}}); //=> true
 */ var $6822a9c64849ac35$var$pathSatisfies = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function pathSatisfies(pred, propPath, obj) {
    return pred((0, $68c047577bfeff4b$export$2e2bcd8739ae039)(propPath, obj));
});
var $6822a9c64849ac35$export$2e2bcd8739ae039 = $6822a9c64849ac35$var$pathSatisfies;



/**
 * Returns a partial copy of an object containing only the keys specified. If
 * the key does not exist, the property is ignored.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.omit, R.props
 * @example
 *
 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
 */ var $4c83bcaf492255d7$var$pick = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function pick(names, obj) {
    var result = {};
    var idx = 0;
    while(idx < names.length){
        if (names[idx] in obj) result[names[idx]] = obj[names[idx]];
        idx += 1;
    }
    return result;
});
var $4c83bcaf492255d7$export$2e2bcd8739ae039 = $4c83bcaf492255d7$var$pick;



/**
 * Similar to `pick` except that this one includes a `key: undefined` pair for
 * properties that don't exist.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.pick
 * @example
 *
 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
 */ var $3f60d8a8c42814ab$var$pickAll = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function pickAll(names, obj) {
    var result = {};
    var idx = 0;
    var len = names.length;
    while(idx < len){
        var name = names[idx];
        result[name] = obj[name];
        idx += 1;
    }
    return result;
});
var $3f60d8a8c42814ab$export$2e2bcd8739ae039 = $3f60d8a8c42814ab$var$pickAll;



/**
 * Returns a partial copy of an object containing only the keys that satisfy
 * the supplied predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig ((v, k) -> Boolean) -> {k: v} -> {k: v}
 * @param {Function} pred A predicate to determine whether or not a key
 *        should be included on the output object.
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties that satisfy `pred`
 *         on it.
 * @see R.pick, R.filter
 * @example
 *
 *      const isUpperCase = (val, key) => key.toUpperCase() === key;
 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
 */ var $6a989b3f59fd032e$var$pickBy = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function pickBy(test, obj) {
    var result = {};
    for(var prop in obj)if (test(obj[prop], prop, obj)) result[prop] = obj[prop];
    return result;
});
var $6a989b3f59fd032e$export$2e2bcd8739ae039 = $6a989b3f59fd032e$var$pickBy;







/**
 * Returns a new list with the given element at the front, followed by the
 * contents of the list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The item to add to the head of the output list.
 * @param {Array} list The array to add to the tail of the output list.
 * @return {Array} A new array.
 * @see R.append
 * @example
 *
 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
 */ var $d93c457640bf453d$var$prepend = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function prepend(el, list) {
    return (0, $177bce200a9ffba1$export$2e2bcd8739ae039)([
        el
    ], list);
});
var $d93c457640bf453d$export$2e2bcd8739ae039 = $d93c457640bf453d$var$prepend;




/**
 * Multiplies together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The product of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.product([2,4,6,8,100,1]); //=> 38400
 */ var $d598b6100fb708e5$var$product = /*#__PURE__*/ (0, $15e42530af719b84$export$2e2bcd8739ae039)((0, $e67eec62bc824e5e$export$2e2bcd8739ae039), 1);
var $d598b6100fb708e5$export$2e2bcd8739ae039 = $d598b6100fb708e5$var$product;







/**
 * Accepts a function `fn` and a list of transformer functions and returns a
 * new curried function. When the new function is invoked, it calls the
 * function `fn` with parameters consisting of the result of calling each
 * supplied handler on successive arguments to the new function.
 *
 * If more arguments are passed to the returned function than transformer
 * functions, those arguments are passed directly to `fn` as additional
 * parameters. If you expect additional arguments that don't need to be
 * transformed, although you can ignore them, it's best to pass an identity
 * function so that the new function reports the correct arity.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} fn The function to wrap.
 * @param {Array} transformers A list of transformer functions
 * @return {Function} The wrapped function.
 * @see R.converge
 * @example
 *
 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
 */ var $e37826fd2f555451$var$useWith = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function useWith(fn, transformers) {
    return (0, $8bd7b963d2d08f64$export$2e2bcd8739ae039)(transformers.length, function() {
        var args = [];
        var idx = 0;
        while(idx < transformers.length){
            args.push(transformers[idx].call(this, arguments[idx]));
            idx += 1;
        }
        return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
    });
});
var $e37826fd2f555451$export$2e2bcd8739ae039 = $e37826fd2f555451$var$useWith;


/**
 * Reasonable analog to SQL `select` statement.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @category Relation
 * @sig [k] -> [{k: v}] -> [{k: v}]
 * @param {Array} props The property names to project
 * @param {Array} objs The objects to query
 * @return {Array} An array of objects with just the `props` properties.
 * @see R.pluck, R.props, R.prop
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
 *      const kids = [abby, fred];
 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
 */ var $46ddb7d1bf19c9df$var$project = /*#__PURE__*/ (0, $e37826fd2f555451$export$2e2bcd8739ae039)((0, $62919b2573dc55d5$export$2e2bcd8739ae039), [
    (0, $3f60d8a8c42814ab$export$2e2bcd8739ae039),
    (0, $6303b64a517886ce$export$2e2bcd8739ae039)
]); // passing `identity` gives correct arity
var $46ddb7d1bf19c9df$export$2e2bcd8739ae039 = $46ddb7d1bf19c9df$var$project;




function $35ef0b358eefde23$export$2e2bcd8739ae039(f, g, profunctor) {
    return function(x) {
        return g(profunctor(f(x)));
    };
}




var $9f236ce28321e63c$var$XPromap = /*#__PURE__*/ function() {
    function XPromap(f, g, xf) {
        this.xf = xf;
        this.f = f;
        this.g = g;
    }
    XPromap.prototype["@@transducer/init"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XPromap.prototype["@@transducer/result"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).result;
    XPromap.prototype["@@transducer/step"] = function(result, input) {
        return this.xf["@@transducer/step"](result, (0, $35ef0b358eefde23$export$2e2bcd8739ae039)(this.f, this.g, input));
    };
    return XPromap;
}();
function $9f236ce28321e63c$export$2e2bcd8739ae039(f, g) {
    return function(xf) {
        return new $9f236ce28321e63c$var$XPromap(f, g, xf);
    };
}


/**
 * Takes two functions as pre- and post- processors respectively for a third function,
 * i.e. `promap(f, g, h)(x) === g(h(f(x)))`.
 *
 * Dispatches to the `promap` method of the third argument, if present,
 * according to the [FantasyLand Profunctor spec](https://github.com/fantasyland/fantasy-land#profunctor).
 *
 * Acts as a transducer if a transformer is given in profunctor position.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Function
 * @sig (a -> b) -> (c -> d) -> (b -> c) -> (a -> d)
 * @sig Profunctor p => (a -> b) -> (c -> d) -> p b c -> p a d
 * @param {Function} f The preprocessor function, a -> b
 * @param {Function} g The postprocessor function, c -> d
 * @param {Profunctor} profunctor The profunctor instance to be promapped, e.g. b -> c
 * @return {Profunctor} The new profunctor instance, e.g. a -> d
 * @see R.transduce
 * @example
 *
 *      const decodeChar = R.promap(s => s.charCodeAt(), String.fromCharCode, R.add(-8))
 *      const decodeString = R.promap(R.split(''), R.join(''), R.map(decodeChar))
 *      decodeString("ziuli") //=> "ramda"
 *
 * @symb R.promap(f, g, h) = x => g(h(f(x)))
 * @symb R.promap(f, g, profunctor) = profunctor.promap(f, g)
 */ var $56c1732825dc7415$var$promap = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([
    "fantasy-land/promap",
    "promap"
], (0, $9f236ce28321e63c$export$2e2bcd8739ae039), (0, $35ef0b358eefde23$export$2e2bcd8739ae039)));
var $56c1732825dc7415$export$2e2bcd8739ae039 = $56c1732825dc7415$var$promap;






/**
 * Returns `true` if the specified object property is equal, in
 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
 * You can test multiple properties with [`R.whereEq`](#whereEq),
 * and test nested path property with [`R.pathEq`](#pathEq).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig a -> String -> Object -> Boolean
 * @param {*} val The value to compare the property with
 * @param {String} name the specified object property's key
 * @param {*} obj The object to check the property in
 * @return {Boolean} `true` if the value equals the specified object property,
 *         `false` otherwise.
 * @see R.whereEq, R.pathEq, R.propSatisfies, R.equals
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond'};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown'};
 *      const rusty = {name: 'Rusty', age: 10, hair: 'brown'};
 *      const alois = {name: 'Alois', age: 15, disposition: 'surly'};
 *      const kids = [abby, fred, rusty, alois];
 *      const hasBrownHair = R.propEq('brown', 'hair');
 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
 */ var $678d3c8cae28a01b$var$propEq = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function propEq(val, name, obj) {
    return (0, $1cb60074c12b9394$export$2e2bcd8739ae039)(val, (0, $f421bed41196907e$export$2e2bcd8739ae039)(name, obj));
});
var $678d3c8cae28a01b$export$2e2bcd8739ae039 = $678d3c8cae28a01b$var$propEq;





/**
 * Returns `true` if the specified object property is of the given type;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Type
 * @sig Type -> String -> Object -> Boolean
 * @param {Function} type
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.is, R.propSatisfies
 * @example
 *
 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
 *      R.propIs(Number, 'x', {});            //=> false
 */ var $3f7761f5e5433903$var$propIs = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function propIs(type, name, obj) {
    return (0, $b1db11aa543da3ec$export$2e2bcd8739ae039)(type, (0, $f421bed41196907e$export$2e2bcd8739ae039)(name, obj));
});
var $3f7761f5e5433903$export$2e2bcd8739ae039 = $3f7761f5e5433903$var$propIs;





/**
 * Return the specified property of the given non-null object if the property
 * is present and it's value is not `null`, `undefined` or `NaN`.
 *
 * Otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Object
 * @sig a -> String -> Object -> a
 * @param {*} val The default value.
 * @param {String} p The name of the property to return.
 * @param {Object} obj The object to query.
 * @return {*} The value of given property of the supplied object or the default value.
 * @example
 *
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const favorite = R.prop('favoriteLibrary');
 *      const favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
 *
 *      favorite(alice);  //=> undefined
 *      favoriteWithDefault(alice);  //=> 'Ramda'
 */ var $d79b52257046ef9c$var$propOr = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function propOr(val, p, obj) {
    return (0, $05d273f6dccce24e$export$2e2bcd8739ae039)(val, (0, $f421bed41196907e$export$2e2bcd8739ae039)(p, obj));
});
var $d79b52257046ef9c$export$2e2bcd8739ae039 = $d79b52257046ef9c$var$propOr;




/**
 * Returns `true` if the specified object property satisfies the given
 * predicate; `false` otherwise. You can test multiple properties with
 * [`R.where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Logic
 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
 * @param {Function} pred
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.where, R.propEq, R.propIs
 * @example
 *
 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
 */ var $9e71cdfdc333f0cb$var$propSatisfies = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function propSatisfies(pred, name, obj) {
    return pred((0, $f421bed41196907e$export$2e2bcd8739ae039)(name, obj));
});
var $9e71cdfdc333f0cb$export$2e2bcd8739ae039 = $9e71cdfdc333f0cb$var$propSatisfies;




/**
 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> [v]
 * @param {Array} ps The property names to fetch
 * @param {Object} obj The object to query
 * @return {Array} The corresponding values or partially applied function.
 * @see R.prop, R.pluck, R.project
 * @example
 *
 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
 *
 *      const fullName = R.compose(R.join(' '), R.props(['first', 'last']));
 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
 */ var $896c77f735dcce8d$var$props = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function props(ps, obj) {
    return ps.map(function(p) {
        return (0, $68c047577bfeff4b$export$2e2bcd8739ae039)([
            p
        ], obj);
    });
});
var $896c77f735dcce8d$export$2e2bcd8739ae039 = $896c77f735dcce8d$var$props;




/**
 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> Number -> [Number]
 * @param {Number} from The first number in the list.
 * @param {Number} to One more than the last number in the list.
 * @return {Array} The list of numbers in the set `[a, b)`.
 * @example
 *
 *      R.range(1, 5);    //=> [1, 2, 3, 4]
 *      R.range(50, 53);  //=> [50, 51, 52]
 */ var $2278464e06162038$var$range = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function range(from, to) {
    if (!((0, $4782a03023189f78$export$2e2bcd8739ae039)(from) && (0, $4782a03023189f78$export$2e2bcd8739ae039)(to))) throw new TypeError("Both arguments to range must be numbers");
    var result = [];
    var n = from;
    while(n < to){
        result.push(n);
        n += 1;
    }
    return result;
});
var $2278464e06162038$export$2e2bcd8739ae039 = $2278464e06162038$var$range;





/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * Similar to [`reduce`](#reduce), except moves through the input list from the
 * right to the left.
 *
 * The iterator function receives two values: *(value, acc)*, while the arguments'
 * order of `reduce`'s iterator function is *(acc, value)*. `reduceRight` may use [`reduced`](#reduced)
 * to short circuit the iteration.
 *
 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduceRight` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
 *
 * Be cautious of mutating and returning the accumulator. If you reuse it across
 * invocations, it will continue to accumulate onto the same value. The general
 * recommendation is to always return a new value. If you can't do so for
 * performance reasons, then be sure to reinitialize the accumulator on each
 * invocation.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> b) -> b -> [a] -> b
 * @param {Function} fn The iterator function. Receives two values, the current element from the array
 *        and the accumulator.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.addIndex, R.reduced
 * @example
 *
 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
 *      //    -               -2
 *      //   / \              / \
 *      //  1   -            1   3
 *      //     / \              / \
 *      //    2   -     ==>    2  -1
 *      //       / \              / \
 *      //      3   -            3   4
 *      //         / \              / \
 *      //        4   0            4   0
 *
 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
 */ var $388f153d50349f5e$var$reduceRight = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function reduceRight(fn, acc, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        acc = fn(list[idx], acc);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        idx -= 1;
    }
    return acc;
});
var $388f153d50349f5e$export$2e2bcd8739ae039 = $388f153d50349f5e$var$reduceRight;






/**
 * Like [`reduce`](#reduce), `reduceWhile` returns a single item by iterating
 * through the list, successively calling the iterator function. `reduceWhile`
 * also takes a predicate that is evaluated before each step. If the predicate
 * returns `false`, it "short-circuits" the iteration and returns the current
 * value of the accumulator. `reduceWhile` may alternatively be short-circuited
 * via [`reduced`](#reduced).
 *
 * @func
 * @memberOf R
 * @since v0.22.0
 * @category List
 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} pred The predicate. It is passed the accumulator and the
 *        current element.
 * @param {Function} fn The iterator function. Receives two values, the
 *        accumulator and the current element.
 * @param {*} a The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced
 * @example
 *
 *      const isOdd = (acc, x) => x % 2 !== 0;
 *      const xs = [1, 3, 5, 60, 777, 800];
 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
 *
 *      const ys = [2, 4, 6]
 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
 */ var $401b31edc5f98cc9$var$reduceWhile = /*#__PURE__*/ (0, $04acb407ec8a4632$export$2e2bcd8739ae039)(4, [], function _reduceWhile(pred, fn, a, list) {
    var xf = (0, $9ac0dab179ed11f0$export$2e2bcd8739ae039)(function(acc, x) {
        return pred(acc, x) ? fn(acc, x) : (0, $3dad6d215f19c210$export$2e2bcd8739ae039)(acc);
    });
    return (0, $fc6ace3187be0136$export$2e2bcd8739ae039)(xf, a, list);
});
var $401b31edc5f98cc9$export$2e2bcd8739ae039 = $401b31edc5f98cc9$var$reduceWhile;




/**
 * Returns a value wrapped to indicate that it is the final value of the reduce
 * and transduce functions. The returned value should be considered a black
 * box: the internal structure is not guaranteed to be stable.
 *
 * This optimization is available to the below functions:
 * - [`reduce`](#reduce)
 * - [`reduceWhile`](#reduceWhile)
 * - [`reduceBy`](#reduceBy)
 * - [`reduceRight`](#reduceRight)
 * - [`transduce`](#transduce)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category List
 * @sig a -> *
 * @param {*} x The final value of the reduce.
 * @return {*} The wrapped value.
 * @see R.reduce, R.reduceWhile, R.reduceBy, R.reduceRight, R.transduce
 * @example
 *
 *     R.reduce(
 *       (acc, item) => item > 3 ? R.reduced(acc) : acc.concat(item),
 *       [],
 *       [1, 2, 3, 4, 5]) // [1, 2, 3]
 */ var $6b46b4088e302c92$var$reduced = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)((0, $3dad6d215f19c210$export$2e2bcd8739ae039));
var $6b46b4088e302c92$export$2e2bcd8739ae039 = $6b46b4088e302c92$var$reduced;







/**
 * Calls an input function `n` times, returning an array containing the results
 * of those function calls.
 *
 * `fn` is passed one argument: The current value of `n`, which begins at `0`
 * and is gradually incremented to `n - 1`.
 *
 * @func
 * @memberOf R
 * @since v0.2.3
 * @category List
 * @sig (Number -> a) -> Number -> [a]
 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
 * @return {Array} An array containing the return values of all calls to `fn`.
 * @see R.repeat
 * @example
 *
 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
 * @symb R.times(f, 0) = []
 * @symb R.times(f, 1) = [f(0)]
 * @symb R.times(f, 2) = [f(0), f(1)]
 */ var $d005a58ff409715c$var$times = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function times(fn, n) {
    var len = Number(n);
    var idx = 0;
    var list;
    if (len < 0 || isNaN(len)) throw new RangeError("n must be a non-negative number");
    list = [];
    while(idx < len){
        list.push(fn(idx));
        idx += 1;
    }
    return list;
});
var $d005a58ff409715c$export$2e2bcd8739ae039 = $d005a58ff409715c$var$times;


/**
 * Returns a fixed list of size `n` containing a specified identical value.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig a -> n -> [a]
 * @param {*} value The value to repeat.
 * @param {Number} n The desired size of the output list.
 * @return {Array} A new array containing `n` `value`s.
 * @see R.times
 * @example
 *
 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
 *
 *      const obj = {};
 *      const repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
 * @symb R.repeat(a, 0) = []
 * @symb R.repeat(a, 1) = [a]
 * @symb R.repeat(a, 2) = [a, a]
 */ var $86acb56985e67212$var$repeat = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function repeat(value, n) {
    return (0, $d005a58ff409715c$export$2e2bcd8739ae039)((0, $0c56c4792563d166$export$2e2bcd8739ae039)(value), n);
});
var $86acb56985e67212$export$2e2bcd8739ae039 = $86acb56985e67212$var$repeat;



/**
 * Replace a substring or regex match in a string with a replacement.
 *
 * The first two parameters correspond to the parameters of the
 * `String.prototype.replace()` function, so the second parameter can also be a
 * function.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category String
 * @sig RegExp|String -> String -> String -> String
 * @param {RegExp|String} pattern A regular expression or a substring to match.
 * @param {String} replacement The string to replace the matches with.
 * @param {String} str The String to do the search and replacement in.
 * @return {String} The result.
 * @example
 *
 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *
 *      // Use the "g" (global) flag to replace all occurrences:
 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
 */ var $a67183dc98e6ea0b$var$replace = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function replace(regex, replacement, str) {
    return str.replace(regex, replacement);
});
var $a67183dc98e6ea0b$export$2e2bcd8739ae039 = $a67183dc98e6ea0b$var$replace;







var $cf45b6b092ee2595$var$tInit = "@@transducer/init";
var $cf45b6b092ee2595$var$tStep = "@@transducer/step";
var $cf45b6b092ee2595$var$XScan = /*#__PURE__*/ function() {
    function XScan(reducer, acc, xf) {
        this.xf = xf;
        this.f = reducer;
        this.acc = acc;
    }
    XScan.prototype[$cf45b6b092ee2595$var$tInit] = function() {
        return this.xf[$cf45b6b092ee2595$var$tStep](this.xf[$cf45b6b092ee2595$var$tInit](), this.acc);
    };
    XScan.prototype["@@transducer/result"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).result;
    XScan.prototype[$cf45b6b092ee2595$var$tStep] = function(result, input) {
        if (result["@@transducer/reduced"]) return result;
        this.acc = this.f(this.acc, input);
        return this.xf[$cf45b6b092ee2595$var$tStep](result, this.acc);
    };
    return XScan;
}();
var $cf45b6b092ee2595$var$_xscan = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function _xscan(reducer, acc, xf) {
    return new $cf45b6b092ee2595$var$XScan(reducer, acc, xf);
});
var $cf45b6b092ee2595$export$2e2bcd8739ae039 = $cf45b6b092ee2595$var$_xscan;


/**
 * Scan is similar to [`reduce`](#reduce), but returns a list of successively
 * reduced values from the left.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> [a]
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {Array} A list of all intermediately reduced values.
 * @see R.reduce, R.mapAccum
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
 */ var $157c86bf6d88eceb$var$scan = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([], (0, $cf45b6b092ee2595$export$2e2bcd8739ae039), function scan(fn, acc, list) {
    var idx = 0;
    var len = list.length;
    var result = [
        acc
    ];
    while(idx < len){
        acc = fn(acc, list[idx]);
        result[idx + 1] = acc;
        idx += 1;
    }
    return result;
}));
var $157c86bf6d88eceb$export$2e2bcd8739ae039 = $157c86bf6d88eceb$var$scan;








/**
 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
 * Applicative of Traversable.
 *
 * Dispatches to the `"fantasy-land/traverse"` or the `traverse` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig fantasy-land/of :: TypeRep f => f ~> a -> f a
 * @sig (Applicative f, Traversable t) => TypeRep f -> t (f a) -> f (t a)
 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
 * @param {Object|Function} TypeRepresentative with an `of` or `fantasy-land/of` method
 * @param {*} traversable
 * @return {*}
 * @see R.traverse
 * @example
 *
 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
 *
 *      R.sequence(R.of(Array), Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
 *      R.sequence(R.of(Array), Nothing());       //=> [Nothing()]
 */ var $d67445dea18684de$var$sequence = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function sequence(F, traversable) {
    var of = typeof F["fantasy-land/of"] === "function" ? F["fantasy-land/of"] : typeof F.of === "function" ? F.of : F;
    var TypeRep = {
        "fantasy-land/of": of
    };
    return typeof traversable["fantasy-land/traverse"] === "function" ? traversable["fantasy-land/traverse"](TypeRep, (0, $b3328d336dcab159$export$2e2bcd8739ae039)) : typeof traversable.traverse === "function" ? traversable.traverse(TypeRep, (0, $b3328d336dcab159$export$2e2bcd8739ae039)) : (0, $388f153d50349f5e$export$2e2bcd8739ae039)(function(x, acc) {
        return (0, $872b35ed3c11e862$export$2e2bcd8739ae039)((0, $46e97bbca4e2864f$export$2e2bcd8739ae039)((0, $d93c457640bf453d$export$2e2bcd8739ae039), x), acc);
    }, of([]), traversable);
});
var $d67445dea18684de$export$2e2bcd8739ae039 = $d67445dea18684de$var$sequence;





/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the given value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> a -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.view, R.over, R.lens, R.lensIndex, R.lensProp, R.lensPath
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
 */ var $60baa39fcd7d0f82$var$set = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function set(lens, v, x) {
    return (0, $68fb36610bcecb96$export$2e2bcd8739ae039)(lens, (0, $0c56c4792563d166$export$2e2bcd8739ae039)(v), x);
});
var $60baa39fcd7d0f82$export$2e2bcd8739ae039 = $60baa39fcd7d0f82$var$set;




/**
 * Returns a copy of the list, sorted according to the comparator function,
 * which should accept two values at a time and return a negative number if the
 * first value is smaller, a positive number if it's larger, and zero if they
 * are equal. Please note that this is a **copy** of the list. It does not
 * modify the original.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, a) -> Number) -> [a] -> [a]
 * @param {Function} comparator A sorting function :: a -> b -> Int
 * @param {Array} list The list to sort
 * @return {Array} a new array with its elements sorted by the comparator function.
 * @see R.ascend, R.descend
 * @example
 *
 *      const diff = function(a, b) { return a - b; };
 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
 */ var $d44eee8691ab603d$var$sort = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function sort(comparator, list) {
    return Array.prototype.slice.call(list, 0).sort(comparator);
});
var $d44eee8691ab603d$export$2e2bcd8739ae039 = $d44eee8691ab603d$var$sort;



/**
 * Sorts the list according to the supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord b => (a -> b) -> [a] -> [a]
 * @param {Function} fn
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted by the keys generated by `fn`.
 * @example
 *
 *      const sortByFirstItem = R.sortBy(R.prop(0));
 *      const pairs = [[-1, 1], [-2, 2], [-3, 3]];
 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
 *
 *      const sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const bob = {
 *        name: 'Bob',
 *        age: -10
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 314.159
 *      };
 *      const people = [clara, bob, alice];
 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
 */ var $e914f0ce9046550e$var$sortBy = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function sortBy(fn, list) {
    return Array.prototype.slice.call(list, 0).sort(function(a, b) {
        var aa = fn(a);
        var bb = fn(b);
        return aa < bb ? -1 : aa > bb ? 1 : 0;
    });
});
var $e914f0ce9046550e$export$2e2bcd8739ae039 = $e914f0ce9046550e$var$sortBy;



/**
 * Sorts a list according to a list of comparators.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Relation
 * @sig [(a, a) -> Number] -> [a] -> [a]
 * @param {Array} functions A list of comparator functions.
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted according to the comarator functions.
 * @see R.ascend, R.descend
 * @example
 *
 *      const alice = {
 *        name: 'alice',
 *        age: 40
 *      };
 *      const bob = {
 *        name: 'bob',
 *        age: 30
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 40
 *      };
 *      const people = [clara, bob, alice];
 *      const ageNameSort = R.sortWith([
 *        R.descend(R.prop('age')),
 *        R.ascend(R.prop('name'))
 *      ]);
 *      ageNameSort(people); //=> [alice, clara, bob]
 */ var $59dc10ed99e3393c$var$sortWith = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function sortWith(fns, list) {
    return Array.prototype.slice.call(list, 0).sort(function(a, b) {
        var result = 0;
        var i = 0;
        while(result === 0 && i < fns.length){
            result = fns[i](a, b);
            i += 1;
        }
        return result;
    });
});
var $59dc10ed99e3393c$export$2e2bcd8739ae039 = $59dc10ed99e3393c$var$sortWith;



/**
 * Splits a string into an array of strings based on the given
 * separator.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig (String | RegExp) -> String -> [String]
 * @param {String|RegExp} sep The pattern.
 * @param {String} str The string to separate into an array.
 * @return {Array} The array of strings from `str` separated by `sep`.
 * @see R.join
 * @example
 *
 *      const pathComponents = R.split('/');
 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
 *
 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
 */ var $9a1079b8b6ff0f26$var$split = /*#__PURE__*/ (0, $cda97c466e8b3a0b$export$2e2bcd8739ae039)(1, "split");
var $9a1079b8b6ff0f26$export$2e2bcd8739ae039 = $9a1079b8b6ff0f26$var$split;





/**
 * Splits a given list or string at a given index.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig Number -> [a] -> [[a], [a]]
 * @sig Number -> String -> [String, String]
 * @param {Number} index The index where the array/string is split.
 * @param {Array|String} array The array/string to be split.
 * @return {Array}
 * @example
 *
 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
 */ var $bcba1a845dfc651c$var$splitAt = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function splitAt(index, array) {
    return [
        (0, $8c8a51bb580162a2$export$2e2bcd8739ae039)(0, index, array),
        (0, $8c8a51bb580162a2$export$2e2bcd8739ae039)(index, (0, $39d327f6450eab17$export$2e2bcd8739ae039)(array), array)
    ];
});
var $bcba1a845dfc651c$export$2e2bcd8739ae039 = $bcba1a845dfc651c$var$splitAt;




/**
 * Splits a collection into slices of the specified length.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @sig Number -> String -> [String]
 * @param {Number} n
 * @param {Array} list
 * @return {Array}
 * @example
 *
 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
 */ var $b3f25a709db7804e$var$splitEvery = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function splitEvery(n, list) {
    if (n <= 0) throw new Error("First argument to splitEvery must be a positive integer");
    var result = [];
    var idx = 0;
    while(idx < list.length)result.push((0, $8c8a51bb580162a2$export$2e2bcd8739ae039)(idx, idx += n, list));
    return result;
});
var $b3f25a709db7804e$export$2e2bcd8739ae039 = $b3f25a709db7804e$var$splitEvery;



/**
 * Takes a list and a predicate and returns a pair of lists with the following properties:
 *
 *  - the result of concatenating the two output lists is equivalent to the input list;
 *  - none of the elements of the first output list satisfies the predicate; and
 *  - if the second output list is non-empty, its first element satisfies the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
 * @param {Function} pred The predicate that determines where the array is split.
 * @param {Array} list The array to be split.
 * @return {Array}
 * @example
 *
 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
 */ var $1a8d8d9ba9b97f98$var$splitWhen = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function splitWhen(pred, list) {
    var idx = 0;
    var len = list.length;
    var prefix = [];
    while(idx < len && !pred(list[idx])){
        prefix.push(list[idx]);
        idx += 1;
    }
    return [
        prefix,
        Array.prototype.slice.call(list, idx)
    ];
});
var $1a8d8d9ba9b97f98$export$2e2bcd8739ae039 = $1a8d8d9ba9b97f98$var$splitWhen;



/**
 * Splits an array into slices on every occurrence of a value.
 *
 * @func
 * @memberOf R
 * @since v0.26.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> [[a]]
 * @param {Function} pred The predicate that determines where the array is split.
 * @param {Array} list The array to be split.
 * @return {Array}
 * @example
 *
 *      R.splitWhenever(R.equals(2), [1, 2, 3, 2, 4, 5, 2, 6, 7]); //=> [[1], [3], [4, 5], [6, 7]]
 */ var $173352799fa6ee07$var$splitWhenever = /*#__PURE__*/ (0, $04acb407ec8a4632$export$2e2bcd8739ae039)(2, [], function splitWhenever(pred, list) {
    var acc = [];
    var curr = [];
    for(var i = 0; i < list.length; i = i + 1){
        if (!pred(list[i])) curr.push(list[i]);
        if ((i < list.length - 1 && pred(list[i + 1]) || i === list.length - 1) && curr.length > 0) {
            acc.push(curr);
            curr = [];
        }
    }
    return acc;
});
var $173352799fa6ee07$export$2e2bcd8739ae039 = $173352799fa6ee07$var$splitWhenever;





/**
 * Checks if a list starts with the provided sublist.
 *
 * Similarly, checks if a string starts with the provided substring.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> [a] -> Boolean
 * @sig String -> String -> Boolean
 * @param {*} prefix
 * @param {*} list
 * @return {Boolean}
 * @see R.endsWith
 * @example
 *
 *      R.startsWith('a', 'abc')                //=> true
 *      R.startsWith('b', 'abc')                //=> false
 *      R.startsWith(['a'], ['a', 'b', 'c'])    //=> true
 *      R.startsWith(['b'], ['a', 'b', 'c'])    //=> false
 */ var $5afc50d7cc339978$var$startsWith = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function(prefix, list) {
    return (0, $1cb60074c12b9394$export$2e2bcd8739ae039)((0, $f2b35373e36ddcac$export$2e2bcd8739ae039)(prefix.length, list), prefix);
});
var $5afc50d7cc339978$export$2e2bcd8739ae039 = $5afc50d7cc339978$var$startsWith;



/**
 * Subtracts its second argument from its first argument.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a - b`.
 * @see R.add
 * @example
 *
 *      R.subtract(10, 8); //=> 2
 *
 *      const minus5 = R.subtract(R.__, 5);
 *      minus5(17); //=> 12
 *
 *      const complementaryAngle = R.subtract(90);
 *      complementaryAngle(30); //=> 60
 *      complementaryAngle(72); //=> 18
 */ var $601532b2b4d4b5f7$var$subtract = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function subtract(a, b) {
    return Number(a) - Number(b);
});
var $601532b2b4d4b5f7$export$2e2bcd8739ae039 = $601532b2b4d4b5f7$var$subtract;







var $78e0052c60332ffe$var$swapObject = function(indexA, indexB, o) {
    var copy = (0, $5c54b4ed00f92e13$export$2e2bcd8739ae039)(o);
    var properties = Object.getOwnPropertyNames(copy);
    if (properties.includes(indexA) && properties.includes(indexB)) {
        var tmp = copy[indexA];
        copy[indexA] = copy[indexB];
        copy[indexB] = tmp;
    }
    return copy;
};
var $78e0052c60332ffe$var$swapList = function(indexA, indexB, list) {
    var length = list.length;
    var result = list.slice();
    var positiveIndexA = indexA < 0 ? length + indexA : indexA;
    var positiveIndexB = indexB < 0 ? length + indexB : indexB;
    var positiveMin = Math.min(positiveIndexA, positiveIndexB);
    var positiveMax = Math.max(positiveIndexA, positiveIndexB);
    if (positiveIndexA < 0 || positiveIndexA > length) return result;
    if (positiveIndexB < 0 || positiveIndexB > length) return result;
    if (positiveIndexA === positiveIndexB) return result;
    result = [].concat(result.slice(0, positiveMin)).concat(result[positiveMax]).concat(result.slice(positiveMin + 1, positiveMax)).concat(result[positiveMin]).concat(result.slice(positiveMax + 1, length));
    return result;
};
var $78e0052c60332ffe$var$swapString = function(indexA, indexB, s) {
    var result = $78e0052c60332ffe$var$swapList(indexA, indexB, s);
    return (0, $6011f766ba1d1c66$export$2e2bcd8739ae039)(result) ? result.join("") : result;
};
/**
 * Swap an item, at index `indexA` with another item, at index `indexB`, in an object or a list of elements.
 * A new result will be created containing the new elements order.
 *
 * @func
 * @memberOf R
 * @since v0.29.0
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number|string|Object} indexA The first index
 * @param {Number|string|Object} indexB The second index
 * @param {Array|Object} o Either the object or list which will serve to realise the swap
 * @return {Array|Object} The new object or list reordered
 * @example
 *
 *      R.swap(0, 2, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['c', 'b', 'a', 'd', 'e', 'f']
 *      R.swap(-1, 0, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['f', 'b', 'c', 'd', 'e', 'a'] list rotation
 *      R.swap('a', 'b', {a: 1, b: 2}); //=> {a: 2, b: 2}
 *      R.swap(0, 2, 'foo'); //=> 'oof'
 */ var $78e0052c60332ffe$var$swap = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function(indexA, indexB, o) {
    if ((0, $6011f766ba1d1c66$export$2e2bcd8739ae039)(o)) return $78e0052c60332ffe$var$swapList(indexA, indexB, o);
    else if ((0, $562424274e50089c$export$2e2bcd8739ae039)(o)) return $78e0052c60332ffe$var$swapString(indexA, indexB, o);
    else return $78e0052c60332ffe$var$swapObject(indexA, indexB, o);
});
var $78e0052c60332ffe$export$2e2bcd8739ae039 = $78e0052c60332ffe$var$swap;





/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
 * @example
 *
 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
 */ var $451707bef79faf93$var$symmetricDifference = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function symmetricDifference(list1, list2) {
    return (0, $471c6227d5038add$export$2e2bcd8739ae039)((0, $c3fc704c251e44e1$export$2e2bcd8739ae039)(list1, list2), (0, $c3fc704c251e44e1$export$2e2bcd8739ae039)(list2, list1));
});
var $451707bef79faf93$export$2e2bcd8739ae039 = $451707bef79faf93$var$symmetricDifference;





/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both. Duplication is determined according to the value
 * returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifference, R.difference, R.differenceWith
 * @example
 *
 *      const eqA = R.eqBy(R.prop('a'));
 *      const l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
 *      const l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
 */ var $9d506c629a9f1441$var$symmetricDifferenceWith = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function symmetricDifferenceWith(pred, list1, list2) {
    return (0, $471c6227d5038add$export$2e2bcd8739ae039)((0, $98850934d5cdaf0b$export$2e2bcd8739ae039)(pred, list1, list2), (0, $98850934d5cdaf0b$export$2e2bcd8739ae039)(pred, list2, list1));
});
var $9d506c629a9f1441$export$2e2bcd8739ae039 = $9d506c629a9f1441$var$symmetricDifferenceWith;







/**
 * Returns a new list containing the last `n` elements of a given list, passing
 * each value to the supplied predicate function, and terminating when the
 * predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropLastWhile, R.addIndex
 * @example
 *
 *      const isNotOne = x => x !== 1;
 *
 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
 *
 *      R.takeLastWhile(x => x !== 'R' , 'Ramda'); //=> 'amda'
 */ var $1e5de57403338fe8$var$takeLastWhile = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function takeLastWhile(fn, xs) {
    var idx = xs.length - 1;
    while(idx >= 0 && fn(xs[idx]))idx -= 1;
    return (0, $8c8a51bb580162a2$export$2e2bcd8739ae039)(idx + 1, Infinity, xs);
});
var $1e5de57403338fe8$export$2e2bcd8739ae039 = $1e5de57403338fe8$var$takeLastWhile;






var $3da1165fa7fc0d31$var$XTakeWhile = /*#__PURE__*/ function() {
    function XTakeWhile(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XTakeWhile.prototype["@@transducer/init"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XTakeWhile.prototype["@@transducer/result"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).result;
    XTakeWhile.prototype["@@transducer/step"] = function(result, input) {
        return this.f(input) ? this.xf["@@transducer/step"](result, input) : (0, $3dad6d215f19c210$export$2e2bcd8739ae039)(result);
    };
    return XTakeWhile;
}();
function $3da1165fa7fc0d31$export$2e2bcd8739ae039(f) {
    return function(xf) {
        return new $3da1165fa7fc0d31$var$XTakeWhile(f, xf);
    };
}



/**
 * Returns a new list containing the first `n` elements of a given list,
 * passing each value to the supplied predicate function, and terminating when
 * the predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * Dispatches to the `takeWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropWhile, R.transduce, R.addIndex
 * @example
 *
 *      const isNotFour = x => x !== 4;
 *
 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
 *
 *      R.takeWhile(x => x !== 'd' , 'Ramda'); //=> 'Ram'
 */ var $bd037b6730d2aaa2$var$takeWhile = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([
    "takeWhile"
], (0, $3da1165fa7fc0d31$export$2e2bcd8739ae039), function takeWhile(fn, xs) {
    var idx = 0;
    var len = xs.length;
    while(idx < len && fn(xs[idx]))idx += 1;
    return (0, $8c8a51bb580162a2$export$2e2bcd8739ae039)(0, idx, xs);
}));
var $bd037b6730d2aaa2$export$2e2bcd8739ae039 = $bd037b6730d2aaa2$var$takeWhile;





var $a7d89efbdb7655fb$var$XTap = /*#__PURE__*/ function() {
    function XTap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XTap.prototype["@@transducer/init"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XTap.prototype["@@transducer/result"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).result;
    XTap.prototype["@@transducer/step"] = function(result, input) {
        this.f(input);
        return this.xf["@@transducer/step"](result, input);
    };
    return XTap;
}();
function $a7d89efbdb7655fb$export$2e2bcd8739ae039(f) {
    return function(xf) {
        return new $a7d89efbdb7655fb$var$XTap(f, xf);
    };
}


/**
 * Runs the given function with the supplied object, then returns the object.
 *
 * Acts as a transducer if a transformer is given as second parameter.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a -> *) -> a -> a
 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
 * @param {*} x
 * @return {*} `x`.
 * @example
 *
 *      const sayX = x => console.log('x is ' + x);
 *      R.tap(sayX, 100); //=> 100
 *      // logs 'x is 100'
 * @symb R.tap(f, a) = (f(a), a)
 */ var $22154cea8e11f7c2$var$tap = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([], (0, $a7d89efbdb7655fb$export$2e2bcd8739ae039), function tap(fn, x) {
    fn(x);
    return x;
}));
var $22154cea8e11f7c2$export$2e2bcd8739ae039 = $22154cea8e11f7c2$var$tap;




function $d7288811d9e7f1b0$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object RegExp]";
}



/**
 * Determines whether a given string matches a given regular expression.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category String
 * @sig RegExp -> String -> Boolean
 * @param {RegExp} pattern
 * @param {String} str
 * @return {Boolean}
 * @see R.match
 * @example
 *
 *      R.test(/^x/, 'xyz'); //=> true
 *      R.test(/^y/, 'xyz'); //=> false
 */ var $b0f5306f58d22217$var$test = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function test(pattern, str) {
    if (!(0, $d7288811d9e7f1b0$export$2e2bcd8739ae039)(pattern)) throw new TypeError("‘test’ requires a value of type RegExp as its first argument; received " + (0, $c62f1cf5b0b06d2c$export$2e2bcd8739ae039)(pattern));
    return (0, $eab78890c78f3c65$export$2e2bcd8739ae039)(pattern).test(str);
});
var $b0f5306f58d22217$export$2e2bcd8739ae039 = $b0f5306f58d22217$var$test;




/**
 * Returns the result of applying the onSuccess function to the value inside
 * a successfully resolved promise. This is useful for working with promises
 * inside function compositions.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Function
 * @sig (a -> b) -> (Promise e a) -> (Promise e b)
 * @sig (a -> (Promise e b)) -> (Promise e a) -> (Promise e b)
 * @param {Function} onSuccess The function to apply. Can return a value or a promise of a value.
 * @param {Promise} p
 * @return {Promise} The result of calling `p.then(onSuccess)`
 * @see R.otherwise
 * @example
 *
 *      const makeQuery = email => ({ query: { email }});
 *      const fetchMember = request =>
 *        Promise.resolve({ firstName: 'Bob', lastName: 'Loblaw', id: 42 });
 *
 *      //getMemberName :: String -> Promise ({ firstName, lastName })
 *      const getMemberName = R.pipe(
 *        makeQuery,
 *        fetchMember,
 *        R.andThen(R.pick(['firstName', 'lastName']))
 *      );
 *
 *      getMemberName('bob@gmail.com').then(console.log);
 */ var $3921a70d59515dba$var$andThen = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function andThen(f, p) {
    (0, $54de632a6d3dc244$export$2e2bcd8739ae039)("andThen", p);
    return p.then(f);
});
var $3921a70d59515dba$export$2e2bcd8739ae039 = $3921a70d59515dba$var$andThen;




/**
 * The lower case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @see R.toUpper
 * @example
 *
 *      R.toLower('XYZ'); //=> 'xyz'
 */ var $40521d1b04cc636b$var$toLower = /*#__PURE__*/ (0, $cda97c466e8b3a0b$export$2e2bcd8739ae039)(0, "toLowerCase");
var $40521d1b04cc636b$export$2e2bcd8739ae039 = $40521d1b04cc636b$var$toLower;




/**
 * Converts an object into an array of key, value arrays. Only the object's
 * own properties are used.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own properties.
 * @see R.fromPairs, R.keys, R.values
 * @example
 *
 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
 */ var $5ac72c8a33f953f8$var$toPairs = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function toPairs(obj) {
    var pairs = [];
    for(var prop in obj)if ((0, $ca32895e0ecf33fa$export$2e2bcd8739ae039)(prop, obj)) pairs[pairs.length] = [
        prop,
        obj[prop]
    ];
    return pairs;
});
var $5ac72c8a33f953f8$export$2e2bcd8739ae039 = $5ac72c8a33f953f8$var$toPairs;



/**
 * Converts an object into an array of key, value arrays. The object's own
 * properties and prototype properties are used. Note that the order of the
 * output array is not guaranteed to be consistent across different JS
 * platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own
 *         and prototype properties.
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
 */ var $40867432a24f9aa8$var$toPairsIn = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function toPairsIn(obj) {
    var pairs = [];
    for(var prop in obj)pairs[pairs.length] = [
        prop,
        obj[prop]
    ];
    return pairs;
});
var $40867432a24f9aa8$export$2e2bcd8739ae039 = $40867432a24f9aa8$var$toPairsIn;




/**
 * The upper case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to upper case.
 * @return {String} The upper case version of `str`.
 * @see R.toLower
 * @example
 *
 *      R.toUpper('abc'); //=> 'ABC'
 */ var $8003e3cefb098568$var$toUpper = /*#__PURE__*/ (0, $cda97c466e8b3a0b$export$2e2bcd8739ae039)(0, "toUpperCase");
var $8003e3cefb098568$export$2e2bcd8739ae039 = $8003e3cefb098568$var$toUpper;





/**
 * Initializes a transducer using supplied iterator function. Returns a single
 * item by iterating through the list, successively calling the transformed
 * iterator function and passing it an accumulator value and the current value
 * from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It will be
 * wrapped as a transformer to initialize the transducer. A transformer can be
 * passed directly in place of an iterator function. In both cases, iteration
 * may be stopped early with the [`R.reduced`](#reduced) function.
 *
 * A transducer is a function that accepts a transformer and returns a
 * transformer and can be composed directly.
 *
 * A transformer is an object that provides a 2-arity reducing iterator
 * function, step, 0-arity initial value function, init, and 1-arity result
 * extraction function, result. The step function is used as the iterator
 * function in reduce. The result function is used to convert the final
 * accumulator into the return type and in most cases is
 * [`R.identity`](#identity). The init function can be used to provide an
 * initial accumulator, but is ignored by transduce.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (c -> c) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array. Wrapped as transformer, if necessary, and used to
 *        initialize the transducer
 * @param {*} acc The initial accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced, R.into
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
 *
 *      const isOdd = (x) => x % 2 !== 0;
 *      const firstOddTransducer = R.compose(R.filter(isOdd), R.take(1));
 *      R.transduce(firstOddTransducer, R.flip(R.append), [], R.range(0, 100)); //=> [1]
 */ var $ea9457470b8bd31d$var$transduce = /*#__PURE__*/ (0, $8bd7b963d2d08f64$export$2e2bcd8739ae039)(4, function transduce(xf, fn, acc, list) {
    return (0, $fc6ace3187be0136$export$2e2bcd8739ae039)(xf(typeof fn === "function" ? (0, $9ac0dab179ed11f0$export$2e2bcd8739ae039)(fn) : fn), acc, list);
});
var $ea9457470b8bd31d$export$2e2bcd8739ae039 = $ea9457470b8bd31d$var$transduce;



/**
 * Transposes the rows and columns of a 2D list.
 * When passed a list of `n` lists of length `x`,
 * returns a list of `x` lists of length `n`.
 *
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [[a]] -> [[a]]
 * @param {Array} list A 2D list
 * @return {Array} A 2D list
 * @example
 *
 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 *
 *      // If some of the rows are shorter than the following rows, their elements are skipped:
 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
 */ var $bc83cca58ac94ff9$var$transpose = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function transpose(outerlist) {
    var i = 0;
    var result = [];
    while(i < outerlist.length){
        var innerlist = outerlist[i];
        var j = 0;
        while(j < innerlist.length){
            if (typeof result[j] === "undefined") result[j] = [];
            result[j].push(innerlist[j]);
            j += 1;
        }
        i += 1;
    }
    return result;
});
var $bc83cca58ac94ff9$export$2e2bcd8739ae039 = $bc83cca58ac94ff9$var$transpose;





/**
 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
 * into an Applicative of Traversable.
 *
 * Dispatches to the `traverse` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig fantasy-land/of :: TypeRep f => f ~> a -> f a
 * @sig (Applicative f, Traversable t) => TypeRep f -> (a -> f b) -> t a -> f (t b)
 * @sig (Applicative f, Traversable t) => (b -> f b) -> (a -> f b) -> t a -> f (t b)
 * @param {Object|Function} TypeRepresentative with an `of` or `fantasy-land/of` method
 * @param {Function} f
 * @param {*} traversable
 * @return {*}
 * @see R.sequence
 * @example
 *
 *      // Returns `Maybe.Nothing` if the given divisor is `0`
 *      const safeDiv = n => d => d === 0 ? Maybe.Nothing() : Maybe.Just(n / d)
 *
 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Maybe.Just([5, 2.5, 2])
 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Maybe.Nothing
 *
 *      // Using a Type Representative
 *      R.traverse(Maybe, safeDiv(10), Right(4)); //=> Just(Right(2.5))
 *      R.traverse(Maybe, safeDiv(10), Right(0)); //=> Nothing
 *      R.traverse(Maybe, safeDiv(10), Left("X")); //=> Just(Left("X"))
 */ var $c8c0b97145c077ee$var$traverse = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function traverse(F, f, traversable) {
    var of = typeof F["fantasy-land/of"] === "function" ? F["fantasy-land/of"] : typeof F.of === "function" ? F.of : F;
    var TypeRep = {
        "fantasy-land/of": of
    };
    return typeof traversable["fantasy-land/traverse"] === "function" ? traversable["fantasy-land/traverse"](TypeRep, f) : typeof traversable.traverse === "function" ? traversable.traverse(TypeRep, f) : (0, $d67445dea18684de$export$2e2bcd8739ae039)(TypeRep, (0, $46e97bbca4e2864f$export$2e2bcd8739ae039)(f, traversable));
});
var $c8c0b97145c077ee$export$2e2bcd8739ae039 = $c8c0b97145c077ee$var$traverse;



var $010f4d0356e49d12$var$ws = "	\n\v\f\r \xa0              　\u2028\u2029\uFEFF";
var $010f4d0356e49d12$var$zeroWidth = "​";
var $010f4d0356e49d12$var$hasProtoTrim = typeof String.prototype.trim === "function";
/**
 * Removes (strips) whitespace from both ends of the string.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to trim.
 * @return {String} Trimmed version of `str`.
 * @example
 *
 *      R.trim('   xyz  '); //=> 'xyz'
 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
 */ var $010f4d0356e49d12$var$trim = !$010f4d0356e49d12$var$hasProtoTrim || /*#__PURE__*/ $010f4d0356e49d12$var$ws.trim() || !/*#__PURE__*/ $010f4d0356e49d12$var$zeroWidth.trim() ? /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function trim(str) {
    var beginRx = new RegExp("^[" + $010f4d0356e49d12$var$ws + "][" + $010f4d0356e49d12$var$ws + "]*");
    var endRx = new RegExp("[" + $010f4d0356e49d12$var$ws + "][" + $010f4d0356e49d12$var$ws + "]*$");
    return str.replace(beginRx, "").replace(endRx, "");
}) : /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function trim(str) {
    return str.trim();
});
var $010f4d0356e49d12$export$2e2bcd8739ae039 = $010f4d0356e49d12$var$trim;





/**
 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
 * function evaluates the `tryer`; if it does not throw, it simply returns the
 * result. If the `tryer` *does* throw, the returned function evaluates the
 * `catcher` function and returns its result. Note that for effective
 * composition with this function, both the `tryer` and `catcher` functions
 * must return the same type of results.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
 * @param {Function} tryer The function that may throw.
 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
 * @return {Function} A new function that will catch exceptions and send them to the catcher.
 * @example
 *
 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
 *      R.tryCatch(() => { throw 'foo'}, R.always('caught'))('bar') // =>
 *      'caught'
 *      R.tryCatch(R.times(R.identity), R.always([]))('s') // => []
 *      R.tryCatch(() => { throw 'this is not a valid value'}, (err, value)=>({error : err,  value }))('bar') // => {'error': 'this is not a valid value', 'value': 'bar'}
 */ var $fde04d1d4e417ff1$var$tryCatch = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function _tryCatch(tryer, catcher) {
    return (0, $25d67f9135fe3bce$export$2e2bcd8739ae039)(tryer.length, function() {
        try {
            return tryer.apply(this, arguments);
        } catch (e) {
            return catcher.apply(this, (0, $177bce200a9ffba1$export$2e2bcd8739ae039)([
                e
            ], arguments));
        }
    });
});
var $fde04d1d4e417ff1$export$2e2bcd8739ae039 = $fde04d1d4e417ff1$var$tryCatch;




/**
 * Takes a function `fn`, which takes a single array argument, and returns a
 * function which:
 *
 *   - takes any number of positional arguments;
 *   - passes these arguments to `fn` as an array; and
 *   - returns the result.
 *
 * In other words, `R.unapply` derives a variadic function from a function which
 * takes an array. `R.unapply` is the inverse of [`R.apply`](#apply).
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Function
 * @sig ([*...] -> a) -> (*... -> a)
 * @param {Function} fn
 * @return {Function}
 * @see R.apply
 * @example
 *
 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
 * @symb R.unapply(f)(a, b) = f([a, b])
 */ var $9fe12e4ba2a87ea6$var$unapply = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function unapply(fn) {
    return function() {
        return fn(Array.prototype.slice.call(arguments, 0));
    };
});
var $9fe12e4ba2a87ea6$export$2e2bcd8739ae039 = $9fe12e4ba2a87ea6$var$unapply;




/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 1 parameter. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (a -> b -> c -> ... -> z) -> (a -> z)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 1.
 * @see R.binary, R.nAry
 * @example
 *
 *      const takesTwoArgs = function(a, b) {
 *        return [a, b];
 *      };
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      const takesOneArg = R.unary(takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only 1 argument is passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.unary(f)(a, b, c) = f(a)
 */ var $d233905322568daf$var$unary = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function unary(fn) {
    return (0, $64ef23e24577f0f1$export$2e2bcd8739ae039)(1, fn);
});
var $d233905322568daf$export$2e2bcd8739ae039 = $d233905322568daf$var$unary;




/**
 * Returns a function of arity `n` from a (manually) curried function.
 * Note that, the returned function is actually a ramda style
 * curryied function, which can accept one or more arguments in each
 * function calling.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Function
 * @sig Number -> (a -> b -> c ... -> z) -> ((a -> b -> c ...) -> z)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to uncurry.
 * @return {Function} A new function.
 * @see R.curry, R.curryN
 * @example
 *
 *      const addFour = a => b => c => d => a + b + c + d;
 *
 *      const uncurriedAddFour = R.uncurryN(4, addFour);
 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
 */ var $d086f127f45bf924$var$uncurryN = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function uncurryN(depth, fn) {
    return (0, $8bd7b963d2d08f64$export$2e2bcd8739ae039)(depth, function() {
        var currentDepth = 1;
        var value = fn;
        var idx = 0;
        var endIdx;
        while(currentDepth <= depth && typeof value === "function"){
            endIdx = currentDepth === depth ? arguments.length : idx + value.length;
            value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
            currentDepth += 1;
            idx = endIdx;
        }
        return value;
    });
});
var $d086f127f45bf924$export$2e2bcd8739ae039 = $d086f127f45bf924$var$uncurryN;



/**
 * Builds a list from a seed value. Accepts an iterator function, which returns
 * either false to stop iteration or an array of length 2 containing the value
 * to add to the resulting list and the seed to be used in the next call to the
 * iterator function.
 *
 * The iterator function receives one argument: *(seed)*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (a -> [b]) -> * -> [b]
 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
 *        either false to quit iteration or an array of length two to proceed. The element
 *        at index 0 of this array will be added to the resulting array, and the element
 *        at index 1 will be passed to the next call to `fn`.
 * @param {*} seed The seed value.
 * @return {Array} The final list.
 * @example
 *
 *      const f = n => n > 50 ? false : [-n, n + 10];
 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
 */ var $a0f807c23599d7ca$var$unfold = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function unfold(fn, seed) {
    var pair = fn(seed);
    var result = [];
    while(pair && pair.length){
        result[result.length] = pair[0];
        pair = fn(pair[1]);
    }
    return result;
});
var $a0f807c23599d7ca$export$2e2bcd8739ae039 = $a0f807c23599d7ca$var$unfold;






/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @example
 *
 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
 */ var $39a624dfd49baf3a$var$union = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $85fe9a8e58cb3d1b$export$2e2bcd8739ae039)((0, $5cfd47e1a86155fb$export$2e2bcd8739ae039), (0, $177bce200a9ffba1$export$2e2bcd8739ae039)));
var $39a624dfd49baf3a$export$2e2bcd8739ae039 = $39a624dfd49baf3a$var$union;









var $df6cf52484e1fa3a$var$XUniqWith = /*#__PURE__*/ function() {
    function XUniqWith(pred, xf) {
        this.xf = xf;
        this.pred = pred;
        this.items = [];
    }
    XUniqWith.prototype["@@transducer/init"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).init;
    XUniqWith.prototype["@@transducer/result"] = (0, $76082f074ee8544d$export$2e2bcd8739ae039).result;
    XUniqWith.prototype["@@transducer/step"] = function(result, input) {
        if ((0, $c11f7b7011b9d6c6$export$2e2bcd8739ae039)(this.pred, input, this.items)) return result;
        else {
            this.items.push(input);
            return this.xf["@@transducer/step"](result, input);
        }
    };
    return XUniqWith;
}();
function $df6cf52484e1fa3a$export$2e2bcd8739ae039(pred) {
    return function(xf) {
        return new $df6cf52484e1fa3a$var$XUniqWith(pred, xf);
    };
}


/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied predicate to
 * two list elements. Prefers the first item if two items compare equal based
 * on the predicate.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      const strEq = R.eqBy(String);
 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
 */ var $97015197a611e2a0$var$uniqWith = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a95c0274f29d12e1$export$2e2bcd8739ae039)([], (0, $df6cf52484e1fa3a$export$2e2bcd8739ae039), function(pred, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    var item;
    while(idx < len){
        item = list[idx];
        if (!(0, $c11f7b7011b9d6c6$export$2e2bcd8739ae039)(pred, item, result)) result[result.length] = item;
        idx += 1;
    }
    return result;
}));
var $97015197a611e2a0$export$2e2bcd8739ae039 = $97015197a611e2a0$var$uniqWith;


/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list. Duplication is determined according to the value returned by
 * applying the supplied predicate to two list elements. If an element exists
 * in both lists, the first element from the first list will be used.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [*] -> [*] -> [*]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @see R.union
 * @example
 *
 *      const l1 = [{a: 1}, {a: 2}];
 *      const l2 = [{a: 1}, {a: 4}];
 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
 */ var $2f4ec0f91dc10f7c$var$unionWith = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function unionWith(pred, list1, list2) {
    return (0, $97015197a611e2a0$export$2e2bcd8739ae039)(pred, (0, $177bce200a9ffba1$export$2e2bcd8739ae039)(list1, list2));
});
var $2f4ec0f91dc10f7c$export$2e2bcd8739ae039 = $2f4ec0f91dc10f7c$var$unionWith;






/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is not satisfied, the function will return the result of
 * calling the `whenFalseFn` function with the same argument. If the predicate
 * is satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> b) -> a -> a | b
 * @param {Function} pred        A predicate function
 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
 *                               to a falsy value.
 * @param {*}        x           An object to test with the `pred` function and
 *                               pass to `whenFalseFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
 * @see R.ifElse, R.when, R.cond
 * @example
 *
 *      let safeInc = R.unless(R.isNil, R.inc);
 *      safeInc(null); //=> null
 *      safeInc(1); //=> 2
 */ var $f931ff1bfc6975de$var$unless = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function unless(pred, whenFalseFn, x) {
    return pred(x) ? x : whenFalseFn(x);
});
var $f931ff1bfc6975de$export$2e2bcd8739ae039 = $f931ff1bfc6975de$var$unless;




/**
 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain c => c (c a) -> c a
 * @param {*} list
 * @return {*}
 * @see R.flatten, R.chain
 * @example
 *
 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
 */ var $a206f6f1fbf4c767$var$unnest = /*#__PURE__*/ (0, $58070c59674af918$export$2e2bcd8739ae039)((0, $b3328d336dcab159$export$2e2bcd8739ae039));
var $a206f6f1fbf4c767$export$2e2bcd8739ae039 = $a206f6f1fbf4c767$var$unnest;



/**
 * Takes a predicate, a transformation function, and an initial value,
 * and returns a value of the same type as the initial value.
 * It does so by applying the transformation until the predicate is satisfied,
 * at which point it returns the satisfactory value.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred A predicate function
 * @param {Function} fn The iterator function
 * @param {*} init Initial value
 * @return {*} Final value that satisfies predicate
 * @example
 *
 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
 */ var $7b698fef60d252da$var$until = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function until(pred, fn, init) {
    var val = init;
    while(!pred(val))val = fn(val);
    return val;
});
var $7b698fef60d252da$export$2e2bcd8739ae039 = $7b698fef60d252da$var$until;






/**
 *
 * Deconstructs an array field from the input documents to output a document for each element.
 * Each output document is the input document with the value of the array field replaced by the element.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Object
 * @sig String -> {k: [v]} -> [{k: v}]
 * @param {String} key The key to determine which property of the object should be unwind
 * @param {Object} object The object containing list under property named as key which is to unwind
 * @return {List} A new list of object containing the value of input key having list replaced by each element in the object.
 * @example
 *
 * R.unwind('hobbies', {
 *   name: 'alice',
 *   hobbies: ['Golf', 'Hacking'],
 *   colors: ['red', 'green'],
 * });
 * // [
 * //   { name: 'alice', hobbies: 'Golf', colors: ['red', 'green'] },
 * //   { name: 'alice', hobbies: 'Hacking', colors: ['red', 'green'] }
 * // ]
 */ var $08f5fe8ecbcb6560$var$unwind = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function(key, object) {
    // If key is not in object or key is not as a list in object
    if (!(key in object && (0, $6011f766ba1d1c66$export$2e2bcd8739ae039)(object[key]))) return [
        object
    ];
     // Map over object[key] which is a list and assoc each element with key
    return (0, $62919b2573dc55d5$export$2e2bcd8739ae039)(function(item) {
        return (0, $d627dd4056b0db98$export$2e2bcd8739ae039)(key, item, object);
    }, object[key]);
});
var $08f5fe8ecbcb6560$export$2e2bcd8739ae039 = $08f5fe8ecbcb6560$var$unwind;






/**
 * Returns a list of all the properties, including prototype properties, of the
 * supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own and prototype properties.
 * @see R.values, R.keysIn
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.valuesIn(f); //=> ['X', 'Y']
 */ var $edff3afab03f875f$var$valuesIn = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function valuesIn(obj) {
    var prop;
    var vs = [];
    for(prop in obj)vs[vs.length] = obj[prop];
    return vs;
});
var $edff3afab03f875f$export$2e2bcd8739ae039 = $edff3afab03f875f$var$valuesIn;



var $198986dc20ad9f98$var$Const = function(x) {
    return {
        value: x,
        "fantasy-land/map": function() {
            return this;
        }
    };
};
/**
 * Returns a "view" of the given data structure, determined by the given lens.
 * The lens's focus determines which portion of the data structure is visible.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> s -> a
 * @param {Lens} lens
 * @param {*} x
 * @return {*}
 * @see R.set, R.over, R.lens, R.lensIndex, R.lensProp, R.lensPath
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});  //=> 1
 *      R.view(xLens, {x: 4, y: 2});  //=> 4
 */ var $198986dc20ad9f98$var$view = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function view(lens, x) {
    // Using `Const` effectively ignores the setter function of the `lens`,
    // leaving the value returned by the getter function unmodified.
    return lens($198986dc20ad9f98$var$Const)(x).value;
});
var $198986dc20ad9f98$export$2e2bcd8739ae039 = $198986dc20ad9f98$var$view;



/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is satisfied, the function will return the result of calling
 * the `whenTrueFn` function with the same argument. If the predicate is not
 * satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> b) -> a -> a | b
 * @param {Function} pred       A predicate function
 * @param {Function} whenTrueFn A function to invoke when the `condition`
 *                              evaluates to a truthy value.
 * @param {*}        x          An object to test with the `pred` function and
 *                              pass to `whenTrueFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
 * @see R.ifElse, R.unless, R.cond
 * @example
 *
 *      // truncate :: String -> String
 *      const truncate = R.when(
 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
 *        R.pipe(R.take(10), R.append('…'), R.join(''))
 *      );
 *      truncate('12345');         //=> '12345'
 *      truncate('0123456789ABC'); //=> '0123456789…'
 */ var $eb1e7d489f46831b$var$when = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function when(pred, whenTrueFn, x) {
    return pred(x) ? whenTrueFn(x) : x;
});
var $eb1e7d489f46831b$export$2e2bcd8739ae039 = $eb1e7d489f46831b$var$when;




/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec. Each of the spec's own properties must be a predicate function.
 * Each predicate is applied to the value of the corresponding property of the
 * test object. `where` returns true if all the predicates return true, false
 * otherwise.
 *
 * `where` is well suited to declaratively expressing constraints for other
 * functions such as [`filter`](#filter) and [`find`](#find).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Object
 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propSatisfies, R.whereEq
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.where({
 *        a: R.equals('foo'),
 *        b: R.complement(R.equals('bar')),
 *        x: R.gt(R.__, 10),
 *        y: R.lt(R.__, 20)
 *      });
 *
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
 */ var $33a2c86292c0c79c$var$where = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function where(spec, testObj) {
    for(var prop in spec){
        if ((0, $ca32895e0ecf33fa$export$2e2bcd8739ae039)(prop, spec) && !spec[prop](testObj[prop])) return false;
    }
    return true;
});
var $33a2c86292c0c79c$export$2e2bcd8739ae039 = $33a2c86292c0c79c$var$where;




/**
 * Takes a spec object and a test object; each of the spec's own properties must be a predicate function.
 * Each predicate is applied to the value of the corresponding property of the
 * test object. `whereAny` returns true if at least one of the predicates return true,
 * false otherwise.
 *
 * `whereAny` is well suited to declaratively expressing constraints for other
 * functions such as [`filter`](#filter) and [`find`](#find).
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Object
 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propSatisfies, R.where
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.whereAny({
 *        a: R.equals('foo'),
 *        b: R.complement(R.equals('xxx')),
 *        x: R.gt(R.__, 10),
 *        y: R.lt(R.__, 20)
 *      });
 *
 *      pred({a: 'foo', b: 'xxx', x: 8, y: 34}); //=> true
 *      pred({a: 'xxx', b: 'xxx', x: 9, y: 21}); //=> false
 *      pred({a: 'bar', b: 'xxx', x: 10, y: 20}); //=> false
 *      pred({a: 'foo', b: 'bar', x: 10, y: 20}); //=> true
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> true
 */ var $508d49b026c7bae0$var$whereAny = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function whereAny(spec, testObj) {
    for(var prop in spec){
        if ((0, $ca32895e0ecf33fa$export$2e2bcd8739ae039)(prop, spec) && spec[prop](testObj[prop])) return true;
    }
    return false;
});
var $508d49b026c7bae0$export$2e2bcd8739ae039 = $508d49b026c7bae0$var$whereAny;






/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec, false otherwise. An object satisfies the spec if, for each of the
 * spec's own properties, accessing that property of the object gives the same
 * value (in [`R.equals`](#equals) terms) as accessing that property of the
 * spec.
 *
 * `whereEq` is a specialization of [`where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @sig {String: *} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propEq, R.where
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.whereEq({a: 1, b: 2});
 *
 *      pred({a: 1});              //=> false
 *      pred({a: 1, b: 2});        //=> true
 *      pred({a: 1, b: 2, c: 3});  //=> true
 *      pred({a: 1, b: 1});        //=> false
 */ var $e84b0253ec3a4d0b$var$whereEq = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function whereEq(spec, testObj) {
    return (0, $33a2c86292c0c79c$export$2e2bcd8739ae039)((0, $46e97bbca4e2864f$export$2e2bcd8739ae039)((0, $1cb60074c12b9394$export$2e2bcd8739ae039), spec), testObj);
});
var $e84b0253ec3a4d0b$export$2e2bcd8739ae039 = $e84b0253ec3a4d0b$var$whereEq;





/**
 * Returns a new list without values in the first argument.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @param {Array} list1 The values to be removed from `list2`.
 * @param {Array} list2 The array to remove values from.
 * @return {Array} The new array without values in `list1`.
 * @see R.transduce, R.difference, R.remove
 * @example
 *
 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
 */ var $77c6b809e474b8b9$var$without = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function without(xs, list) {
    var toRemove = new (0, $cb0aea426cd8ce0d$export$2e2bcd8739ae039)();
    for(var i = 0; i < xs.length; i += 1)toRemove.add(xs[i]);
    return (0, $89ddad7dee8f4db5$export$2e2bcd8739ae039)(toRemove.has.bind(toRemove), list);
});
var $77c6b809e474b8b9$export$2e2bcd8739ae039 = $77c6b809e474b8b9$var$without;



/**
 * Exclusive disjunction logical operation.
 * Returns `true` if one of the arguments is truthy and the other is falsy.
 * Otherwise, it returns `false`.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Logic
 * @sig a -> b -> Boolean
 * @param {Any} a
 * @param {Any} b
 * @return {Boolean} true if one of the arguments is truthy and the other is falsy
 * @see R.or, R.and
 * @example
 *
 *      R.xor(true, true); //=> false
 *      R.xor(true, false); //=> true
 *      R.xor(false, true); //=> true
 *      R.xor(false, false); //=> false
 */ var $7efc723d179732dc$var$xor = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function xor(a, b) {
    return Boolean(!a ^ !b);
});
var $7efc723d179732dc$export$2e2bcd8739ae039 = $7efc723d179732dc$var$xor;



/**
 * Creates a new list out of the two supplied by creating each possible pair
 * from the lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The list made by combining each possible pair from
 *         `as` and `bs` into pairs (`[a, b]`).
 * @example
 *
 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
 */ var $16f3f2f69dc60936$var$xprod = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function xprod(a, b) {
    // = xprodWith(prepend); (takes about 3 times as long...)
    var idx = 0;
    var ilen = a.length;
    var j;
    var jlen = b.length;
    var result = [];
    while(idx < ilen){
        j = 0;
        while(j < jlen){
            result[result.length] = [
                a[idx],
                b[j]
            ];
            j += 1;
        }
        idx += 1;
    }
    return result;
});
var $16f3f2f69dc60936$export$2e2bcd8739ae039 = $16f3f2f69dc60936$var$xprod;



/**
 * Creates a new list out of the two supplied by pairing up equally-positioned
 * items from both lists. The returned list is truncated to the length of the
 * shorter of the two input lists.
 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
 * @example
 *
 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
 */ var $e5b116f8a972b3b4$var$zip = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function zip(a, b) {
    var rv = [];
    var idx = 0;
    var len = Math.min(a.length, b.length);
    while(idx < len){
        rv[idx] = [
            a[idx],
            b[idx]
        ];
        idx += 1;
    }
    return rv;
});
var $e5b116f8a972b3b4$export$2e2bcd8739ae039 = $e5b116f8a972b3b4$var$zip;



/**
 * Creates a new object out of a list of keys and a list of values.
 * Key/value pairing is truncated to the length of the shorter of the two lists.
 * Note: `zipObj` is equivalent to `pipe(zip, fromPairs)`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [String] -> [*] -> {String: *}
 * @param {Array} keys The array that will be properties on the output object.
 * @param {Array} values The list of values on the output object.
 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
 * @example
 *
 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
 */ var $7c38c1decc5a5b42$var$zipObj = /*#__PURE__*/ (0, $00e54140c2625599$export$2e2bcd8739ae039)(function zipObj(keys, values) {
    var idx = 0;
    var len = Math.min(keys.length, values.length);
    var out = {};
    while(idx < len){
        out[keys[idx]] = values[idx];
        idx += 1;
    }
    return out;
});
var $7c38c1decc5a5b42$export$2e2bcd8739ae039 = $7c38c1decc5a5b42$var$zipObj;



/**
 * Creates a new list out of the two supplied by applying the function to each
 * equally-positioned pair in the lists. The returned list is truncated to the
 * length of the shorter of the two input lists.
 *
 * @function
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> c) -> [a] -> [b] -> [c]
 * @param {Function} fn The function used to combine the two elements into one value.
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
 *         using `fn`.
 * @example
 *
 *      const f = (x, y) => {
 *        // ...
 *      };
 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
 */ var $c0de705edd9df31f$var$zipWith = /*#__PURE__*/ (0, $4bb904cf9cab93c5$export$2e2bcd8739ae039)(function zipWith(fn, a, b) {
    var rv = [];
    var idx = 0;
    var len = Math.min(a.length, b.length);
    while(idx < len){
        rv[idx] = fn(a[idx], b[idx]);
        idx += 1;
    }
    return rv;
});
var $c0de705edd9df31f$export$2e2bcd8739ae039 = $c0de705edd9df31f$var$zipWith;




/**
 * Creates a thunk out of a function. A thunk delays a calculation until
 * its result is needed, providing lazy evaluation of arguments.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig ((a, b, ..., j) -> k) -> (a, b, ..., j) -> (() -> k)
 * @param {Function} fn A function to wrap in a thunk
 * @return {Function} Expects arguments for `fn` and returns a new function
 *  that, when called, applies those arguments to `fn`.
 * @see R.partial, R.partialRight
 * @example
 *
 *      R.thunkify(R.identity)(42)(); //=> 42
 *      R.thunkify((a, b) => a + b)(25, 17)(); //=> 42
 */ var $a9e3a2f79dc37a96$var$thunkify = /*#__PURE__*/ (0, $25856e1e32547272$export$2e2bcd8739ae039)(function thunkify(fn) {
    return (0, $8bd7b963d2d08f64$export$2e2bcd8739ae039)(fn.length, function createThunk() {
        var fnArgs = arguments;
        return function invokeThunk() {
            return fn.apply(this, fnArgs);
        };
    });
});
var $a9e3a2f79dc37a96$export$2e2bcd8739ae039 = $a9e3a2f79dc37a96$var$thunkify;




const $b86d29183fa64a1e$export$962d35eb2c1560e7 = "\n";


const $4210cf16c9ec622b$var$ALPHABET_CHARS = [
    "q",
    "w",
    "e",
    "r",
    "t",
    "y",
    "u",
    "i",
    "o",
    "p",
    "a",
    "s",
    "d",
    "f",
    "g",
    "h",
    "j",
    "k",
    "l",
    "z",
    "x",
    "c",
    "v",
    "b",
    "n",
    "m",
    "\xe4",
    "\xdf",
    "\xf6",
    "\xfc"
];
const $4210cf16c9ec622b$var$SHIFT_KEYS_ALPHABET_CHAS = $4210cf16c9ec622b$var$ALPHABET_CHARS.map((char)=>`shift+${char}`);
const $4210cf16c9ec622b$var$ALL_CAPS_ALPHABET_CHARS = $4210cf16c9ec622b$var$ALPHABET_CHARS.map((char)=>char.toUpperCase());
const $4210cf16c9ec622b$var$nums = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9
];
const $4210cf16c9ec622b$export$491f90ff05019fc4 = $4210cf16c9ec622b$var$ALPHABET_CHARS.join(",").concat($4210cf16c9ec622b$var$ALL_CAPS_ALPHABET_CHARS.join(",")).concat($4210cf16c9ec622b$var$SHIFT_KEYS_ALPHABET_CHAS.join(",")).concat($4210cf16c9ec622b$var$nums.join(","));
const $4210cf16c9ec622b$export$35c9ae3c728354cd = (cells)=>$9b6e48c21d14460d$export$2e2bcd8739ae039($e914f0ce9046550e$export$2e2bcd8739ae039($f421bed41196907e$export$2e2bcd8739ae039(1)), $e914f0ce9046550e$export$2e2bcd8739ae039($f421bed41196907e$export$2e2bcd8739ae039(0)))(cells);
const $4210cf16c9ec622b$var$getRange = (first, selected, staticCoordinate, type)=>{
    const [actualFirst, actualLast] = first > selected ? [
        selected,
        first
    ] : [
        first,
        selected
    ];
    const range = $9b6e48c21d14460d$export$2e2bcd8739ae039($2278464e06162038$export$2e2bcd8739ae039(actualFirst), $46e97bbca4e2864f$export$2e2bcd8739ae039((n)=>type === "col" ? [
            staticCoordinate,
            n
        ] : [
            n,
            staticCoordinate
        ]))(actualLast + 1);
    return range;
};
const $4210cf16c9ec622b$export$26242c60305faa8e = (firstSelectedCell, secondSelectedCell)=>{
    const [firstRow, firstCol] = firstSelectedCell;
    const [selectedRow, selectedCol] = secondSelectedCell;
    if (firstRow === selectedRow) return $4210cf16c9ec622b$var$getRange(firstCol, selectedCol, firstRow, "col");
    if (firstCol === selectedCol) return $4210cf16c9ec622b$var$getRange(firstRow, selectedRow, firstCol, "row");
    return null;
};
const $4210cf16c9ec622b$export$8f792b646207fb35 = (mutableData, selectedCells, clipText)=>{
    const values = clipText.split((0, $b86d29183fa64a1e$export$962d35eb2c1560e7));
    if (!values.length) return null;
    if (selectedCells.length === 1) {
        const [row, col] = selectedCells[0];
        mutableData[row][col] = clipText.replace("\n", " ").trim();
    } else selectedCells.forEach(([row, col], index)=>{
        const value = values.length > 1 ? values[index] : values[0];
        mutableData[row][col] = value?.trim() ?? mutableData[row][col];
    });
    return mutableData;
};


const $f3085c06f0de546d$var$formatNumber = (value)=>{
    if (value === null) return value;
    const parsed = parseFloat(value.toString());
    return Number.isNaN(parsed) ? null : parsed;
};
const $f3085c06f0de546d$var$cellStyles = (isSelected)=>(0, $hhXI3.css)`
  background-color: none;
  user-select: none;
  padding: 0 5px;
  position: relative;
  box-sizing: border-box;
  border-radius: 3px;
  ${isSelected && (0, $hhXI3.css)`
    border: 2px solid rgba(0, 0, 255, 0.6);
  `}
`;
const $f3085c06f0de546d$var$absolutePositioningStyles = (0, $hhXI3.css)`
  top: 0;
  left: 0;
  position: absolute;
`;
const $f3085c06f0de546d$var$inputStyles = ({ align: align , isAbsolute: isAbsolute = true  })=>(0, $hhXI3.css)`
  ${isAbsolute && $f3085c06f0de546d$var$absolutePositioningStyles}
  padding: 0 5px;
  border-radius: 0px;
  box-sizing: border-box;
  border: none;
  width: 100%;
  height: 100%;
  font-size: inherit;
  font-family: inherit;
  letter-spacing: inherit;
  outline: none;
  text-align: ${align};
  background-color: white;
`;
const $f3085c06f0de546d$var$TableCellWrapper = (0, $fV3WI.forwardRef)(({ children: children , ...rest }, ref)=>(0, $dYG3T.jsx)((0, $6920591e12eb2f84$export$2e2bcd8739ae039), {
        ref: ref,
        tabIndex: -1,
        ...rest,
        children: children
    }));
const $f3085c06f0de546d$var$TableEditableCellBase = ({ isSelected: isSelected , isActive: isActive , onClick: onClick , onValueChange: onValueChange , value: value , renderValue: renderValue , type: type = "text" , options: options , activateCell: activateCell , selectNextCell: selectNextCell , ...rest })=>{
    const [localValue, setLocalValue] = (0, $fV3WI.useState)(value?.toString() ?? "");
    const ref = (0, $259d22925ba6a5af$export$1b0c17123b4f3646)((0, $4210cf16c9ec622b$export$491f90ff05019fc4), (e)=>{
        if (activateCell && isSelected && !isActive) {
            e.preventDefault();
            setLocalValue(e.key);
            activateCell();
        }
    }, [
        isSelected,
        isActive
    ]);
    (0, $fV3WI.useEffect)(()=>{
        if (value) setLocalValue(value.toString());
    }, [
        value
    ]);
    const handleChange = (e)=>{
        setLocalValue(e.target.value);
    };
    const handleAutoCompleteChange = (_, newValue)=>{
        setLocalValue(newValue ?? "");
    };
    const triggerChange = ()=>{
        let value = localValue;
        if (type === "number") value = $f3085c06f0de546d$var$formatNumber(value);
        onValueChange(value);
    };
    const handleOnBlur = ()=>{
        if (localValue !== value?.toString()) triggerChange();
    };
    const handleKeyDown = (e)=>{
        switch(e.key){
            case "Enter":
                if (type === "autocomplete") break;
                e.preventDefault();
                triggerChange();
                selectNextCell && selectNextCell();
                break;
            case "Tab":
            case "Escape":
                e.preventDefault();
                triggerChange();
                break;
        }
    };
    if (isActive) switch(type){
        case "select":
            return (0, $dYG3T.jsx)($f3085c06f0de546d$var$TableCellWrapper, {
                ref: ref,
                css: $f3085c06f0de546d$var$cellStyles(isSelected),
                onClick: onClick,
                ...rest,
                children: (0, $dYG3T.jsx)((0, $76UN0.default), {
                    css: $f3085c06f0de546d$var$inputStyles({
                        align: rest.align
                    }),
                    native: true,
                    value: localValue,
                    onChange: handleChange,
                    onBlur: handleOnBlur,
                    children: options && options.map((option)=>(0, $dYG3T.jsx)("option", {
                            value: option,
                            children: option
                        }, option))
                })
            });
        case "autocomplete":
            return (0, $dYG3T.jsx)($f3085c06f0de546d$var$TableCellWrapper, {
                ref: ref,
                css: $f3085c06f0de546d$var$cellStyles(isSelected),
                onClick: onClick,
                ...rest,
                children: (0, $dYG3T.jsx)((0, $f552d147b67b6cf0$export$2e2bcd8739ae039), {
                    options: options ?? [],
                    openOnFocus: true,
                    css: $f3085c06f0de546d$var$inputStyles({
                        align: rest.align,
                        isAbsolute: true
                    }),
                    onChange: handleAutoCompleteChange,
                    onKeyDown: handleKeyDown,
                    inputValue: localValue,
                    renderInput: (params)=>(0, $dYG3T.jsx)("div", {
                            ref: params.InputProps.ref,
                            css: (0, $hhXI3.css)`
                    height: 100%;
                  `,
                            children: (0, $dYG3T.jsx)("input", {
                                type: "text",
                                autoFocus: true,
                                ...params.inputProps,
                                onChange: handleChange,
                                onBlur: handleOnBlur,
                                css: $f3085c06f0de546d$var$inputStyles({
                                    align: rest.align,
                                    isAbsolute: false
                                })
                            })
                        })
                })
            });
        case "number":
        case "text":
            return (0, $dYG3T.jsxs)($f3085c06f0de546d$var$TableCellWrapper, {
                ref: ref,
                css: $f3085c06f0de546d$var$cellStyles(isSelected),
                onClick: onClick,
                ...rest,
                children: [
                    (0, $dYG3T.jsx)("input", {
                        autoFocus: true,
                        css: $f3085c06f0de546d$var$inputStyles({
                            align: rest.align
                        }),
                        type: type,
                        value: localValue,
                        onBlur: handleOnBlur,
                        onChange: handleChange,
                        onKeyDown: handleKeyDown
                    }),
                    ";"
                ]
            });
        default:
            throw new Error(`Cell type ${type} is not supported`);
    }
    return (0, $dYG3T.jsx)($f3085c06f0de546d$var$TableCellWrapper, {
        ref: ref,
        css: $f3085c06f0de546d$var$cellStyles(isSelected),
        onClick: onClick,
        ...rest,
        children: renderValue ? renderValue(value) : value
    });
};
const $f3085c06f0de546d$export$dbd958071638235f = (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).memo($f3085c06f0de546d$var$TableEditableCellBase);



var $dYG3T = parcelRequire("dYG3T");

var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $js0sS = parcelRequire("js0sS");

var $74s0b = parcelRequire("74s0b");


var $05gnM = parcelRequire("05gnM");

var $aF4Kv = parcelRequire("aF4Kv");

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $cd986efa118f1958$export$ba0a6d6c28940107(slot) {
    return (0, $auxfn.default)("MuiTableRow", slot);
}
const $cd986efa118f1958$var$tableRowClasses = (0, $dxVxC.default)("MuiTableRow", [
    "root",
    "selected",
    "hover",
    "head",
    "footer"
]);
var $cd986efa118f1958$export$2e2bcd8739ae039 = $cd986efa118f1958$var$tableRowClasses;



var $3DnwL = parcelRequire("3DnwL");
const $a5d72eac563fe3a2$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $a5d72eac563fe3a2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , selected: selected , hover: hover , head: head , footer: footer  } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            hover && "hover",
            head && "head",
            footer && "footer"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $cd986efa118f1958$export$ba0a6d6c28940107), classes);
};
const $a5d72eac563fe3a2$var$TableRowRoot = (0, $aF4Kv.default)("tr", {
    name: "MuiTableRow",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme  })=>({
        color: "inherit",
        display: "table-row",
        verticalAlign: "middle",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $cd986efa118f1958$export$2e2bcd8739ae039).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $cd986efa118f1958$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $74s0b.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $74s0b.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $a5d72eac563fe3a2$var$defaultComponent = "tr";
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $a5d72eac563fe3a2$var$TableRow = /*#__PURE__*/ $fV3WI.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiTableRow"
    });
    const { className: className , component: component = $a5d72eac563fe3a2$var$defaultComponent , hover: hover = false , selected: selected = false  } = props, other = (0, $64S8Y.default)(props, $a5d72eac563fe3a2$var$_excluded);
    const tablelvl2 = $fV3WI.useContext((0, $459358929751b2f8$export$2e2bcd8739ae039));
    const ownerState = (0, $j5tUA.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === "head",
        footer: tablelvl2 && tablelvl2.variant === "footer"
    });
    const classes = $a5d72eac563fe3a2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3DnwL.jsx)($a5d72eac563fe3a2$var$TableRowRoot, (0, $j5tUA.default)({
        as: component,
        ref: ref,
        className: (0, $h0s6D.default)(classes.root, className),
        role: component === $a5d72eac563fe3a2$var$defaultComponent ? null : "row",
        ownerState: ownerState
    }, other));
});
var $a5d72eac563fe3a2$export$2e2bcd8739ae039 = $a5d72eac563fe3a2$var$TableRow;



var $dYG3T = parcelRequire("dYG3T");

var $hhXI3 = parcelRequire("hhXI3");

var $6eY2U = parcelRequire("6eY2U");
const $f8214a598d349198$var$checkboxStyles = (0, $hhXI3.css)`
  padding: 0;
`;
const $f8214a598d349198$export$78ce60f5c12dc00e = ({ ...rest })=>(0, $dYG3T.jsx)((0, $6eY2U.default), {
        size: "small",
        css: $f8214a598d349198$var$checkboxStyles,
        ...rest
    });



const $ae8658b37c77cbc8$export$bc6bea12f1e3b545 = ({ selectedRows: selectedRows , onSelectionChange: onSelectionChange , selectionIndex: selectionIndex , children: children , ...rest })=>{
    const isSelected = selectedRows.includes(selectionIndex);
    const handleCheckboxChange = (_, value)=>{
        onSelectionChange(selectionIndex, value);
    };
    const handleCheckboxClick = (event)=>{
        if (event.shiftKey) {
            const found = $d44eee8691ab603d$export$2e2bcd8739ae039($601532b2b4d4b5f7$export$2e2bcd8739ae039, selectedRows)?.[0];
            if ($9cd3c11cb6777784$export$2e2bcd8739ae039(found)) return;
            event.preventDefault();
            event.stopPropagation();
            const change = $4173ee961b2fe294$export$2e2bcd8739ae039(onSelectionChange);
            const first = found < selectionIndex ? found : selectionIndex;
            const last = found < selectionIndex ? selectionIndex + 1 : found;
            $9b6e48c21d14460d$export$2e2bcd8739ae039(// we get the range from the first index in the selectedRows and the current clicked index
            $2278464e06162038$export$2e2bcd8739ae039(first), // for each index in the range we invert the current selection
            $6ed2a605b0683a28$export$2e2bcd8739ae039(change($e712d1d2964e3962$export$2e2bcd8739ae039, !isSelected)))(last);
        }
    };
    return (0, $dYG3T.jsxs)((0, $a5d72eac563fe3a2$export$2e2bcd8739ae039), {
        selected: isSelected,
        ...rest,
        children: [
            (0, $dYG3T.jsx)((0, $6920591e12eb2f84$export$2e2bcd8739ae039), {
                onClick: handleCheckboxClick,
                children: (0, $dYG3T.jsx)((0, $f8214a598d349198$export$78ce60f5c12dc00e), {
                    checked: isSelected,
                    onChange: handleCheckboxChange,
                    "aria-label": "select row"
                })
            }),
            children
        ]
    });
};



var $fV3WI = parcelRequire("fV3WI");


/**
 * A custom Hook that returns an object of flags determining breakpoints currently triggered
 */ 
var $fV3WI = parcelRequire("fV3WI");

var $hCfWo = parcelRequire("hCfWo");
var $3UagE = parcelRequire("3UagE");

var $fR16U = parcelRequire("fR16U");
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $eebf11a60fb289aa$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $fV3WI.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $fR16U.default)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $eebf11a60fb289aa$var$maybeReactUseSyncExternalStore = $fV3WI.useSyncExternalStore;
function $eebf11a60fb289aa$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $fV3WI.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $fV3WI.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches  } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $fV3WI.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $eebf11a60fb289aa$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $eebf11a60fb289aa$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $3UagE.default)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const { defaultMatches: defaultMatches = false , matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null , ssrMatchMedia: ssrMatchMedia = null , noSsr: noSsr = false  } = (0, $hCfWo.default)({
        name: "MuiUseMediaQuery",
        props: options,
        theme: theme
    });
    let query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, "");
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $eebf11a60fb289aa$var$maybeReactUseSyncExternalStore !== undefined ? $eebf11a60fb289aa$var$useMediaQueryNew : $eebf11a60fb289aa$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}


var $4uBZf = parcelRequire("4uBZf");
const $ee11d7f6412d6f1a$export$40b907bbec956be5 = ()=>{
    const theme = (0, $4uBZf.default)();
    const isSmallScreen = (0, $eebf11a60fb289aa$export$2e2bcd8739ae039)(theme.breakpoints.down("sm"));
    const isVerySmallScreen = (0, $eebf11a60fb289aa$export$2e2bcd8739ae039)(theme.breakpoints.down("xs"));
    return {
        isVerySmallScreen: isVerySmallScreen,
        isSmallScreen: isSmallScreen
    };
};



const $9882ac8c974c769c$export$d59a452d6b3a29e2 = (callback, options)=>(0, $259d22925ba6a5af$export$1b0c17123b4f3646)("cmd+c, ctrl+c", callback, {
        enableOnFormTags: false,
        ...options
    });
const $9882ac8c974c769c$export$7de43c44fbe6c91a = (callback, options)=>(0, $259d22925ba6a5af$export$1b0c17123b4f3646)("cmd+x, ctrl+x", callback, {
        enableOnFormTags: false,
        ...options
    });
const $9882ac8c974c769c$export$ce487ebe0bfff757 = (callback, options)=>(0, $259d22925ba6a5af$export$1b0c17123b4f3646)("cmd+v, ctrl+v", callback, {
        enableOnFormTags: false,
        ...options
    });




const $1f42886ee9ed0728$export$c9058316764c140e = (...refs)=>{
    return (node)=>{
        for (const ref of refs)ref.current = node;
    };
};





const $ebad69d41759996b$export$c49fb32085d9bdda = ({ rowsCount: rowsCount , columnsCount: columnsCount , onCopy: onCopy , onCut: onCut , onPaste: onPaste  })=>{
    const [selectedCells, setSelectedCells] = (0, $fV3WI.useState)([]);
    const [activeCell, setActiveCell] = (0, $fV3WI.useState)(null);
    const isSelected = (row, col)=>selectedCells.some(([r, c])=>row === r && col === c);
    const isActive = (row, col)=>activeCell?.[0] === row && activeCell?.[1] === col;
    const copyRef = (0, $9882ac8c974c769c$export$d59a452d6b3a29e2)(()=>onCopy && onCopy({
            selectedCells: selectedCells,
            isActive: isActive
        }));
    const cutRef = (0, $9882ac8c974c769c$export$7de43c44fbe6c91a)(()=>onCut && onCut({
            selectedCells: selectedCells,
            isActive: isActive
        }));
    const pasteRef = (0, $9882ac8c974c769c$export$ce487ebe0bfff757)(()=>onPaste && onPaste({
            selectedCells: selectedCells,
            isActive: isActive
        }));
    const scopedCopyPasteRef = (0, $1f42886ee9ed0728$export$c9058316764c140e)(copyRef, pasteRef, cutRef);
    const handleCellClick = (row, col)=>(event)=>{
            const selection = [
                row,
                col
            ];
            event.preventDefault();
            if (event.metaKey && event.shiftKey) // implement mutliple range selection here
            return;
            if (event.metaKey || event.ctrlKey) {
                const newSelectedCells = isSelected(row, col) ? selectedCells.filter(([r, c])=>!(row === r && col === c)) : [
                    ...selectedCells,
                    selection
                ];
                setSelectedCells((0, $4210cf16c9ec622b$export$35c9ae3c728354cd)(newSelectedCells));
                return;
            }
            if (event.shiftKey) {
                event.preventDefault();
                const found = selectedCells.find(([, col])=>col === selection[1] || row === selection[0]);
                if (!found) return;
                const range = (0, $4210cf16c9ec622b$export$26242c60305faa8e)(found, selection);
                range && setSelectedCells(range);
                return;
            }
            if (isSelected(row, col)) {
                setActiveCell([
                    row,
                    col
                ]);
                return;
            }
            setActiveCell(null);
            setSelectedCells([
                selection
            ]);
        };
    const resetSelection = ()=>{
        setSelectedCells([]);
    };
    const resetActive = ()=>{
        setActiveCell(null);
    };
    const selectNextCell = (row, col, isTab)=>()=>{
            if (isTab) {
                const nextCol = col + 1;
                resetActive();
                nextCol < columnsCount && setSelectedCells([
                    [
                        row,
                        nextCol
                    ]
                ]);
                return;
            }
            const nextRow = row + 1;
            resetActive();
            nextRow < rowsCount && setSelectedCells([
                [
                    nextRow,
                    col
                ]
            ]);
        };
    const activateCell = (row, col)=>()=>setActiveCell([
                row,
                col
            ]);
    const navigateCell = (e)=>{
        e.preventDefault();
        if (selectedCells.length > 0) {
            const [row, col] = selectedCells[selectedCells.length - 1];
            if (isActive(row, col)) return;
            switch(e.key){
                case "ArrowUp":
                    row - 1 >= 0 && handleCellClick(row - 1, col)(e);
                    break;
                case "ArrowDown":
                    row + 1 < rowsCount && handleCellClick(row + 1, col)(e);
                    break;
                case "ArrowLeft":
                    col - 1 >= 0 && handleCellClick(row, col - 1)(e);
                    break;
                case "ArrowRight":
                    col + 1 < columnsCount && handleCellClick(row, col + 1)(e);
                    break;
            }
        }
    };
    (0, $259d22925ba6a5af$export$1b0c17123b4f3646)("up, down, right, left, shift+up, shift+down, shift+right, shiff+left", (e)=>{
        navigateCell(e);
    }, [
        handleCellClick,
        isActive,
        selectedCells
    ]);
    (0, $259d22925ba6a5af$export$1b0c17123b4f3646)("enter", (e)=>{
        if (selectedCells.length > 0) {
            const [row, col] = selectedCells[selectedCells.length - 1];
            if (isActive(row, col)) return;
            handleCellClick(row, col)(e);
        }
    }, [
        handleCellClick,
        isActive,
        selectedCells
    ]);
    (0, $259d22925ba6a5af$export$1b0c17123b4f3646)("tab", (e)=>{
        if (selectedCells.length > 0) {
            e.preventDefault();
            const [row, col] = selectedCells[selectedCells.length - 1];
            selectNextCell(row, col, true)();
            return;
        }
    }, {
        enableOnFormTags: [
            "input",
            "textarea",
            "select"
        ]
    }, [
        handleCellClick,
        isActive,
        selectedCells
    ]);
    return {
        isSelected: isSelected,
        isActive: isActive,
        handleCellClick: handleCellClick,
        selectedCells: selectedCells,
        selectNextCell: selectNextCell,
        resetSelection: resetSelection,
        resetActive: resetActive,
        activateCell: activateCell,
        scopedCopyPasteRef: scopedCopyPasteRef
    };
};





var $fV3WI = parcelRequire("fV3WI");
const $6a0cf350ff724bd5$export$9989d8b5155ba3be = ()=>{
    const [selected, setSelected] = (0, $fV3WI.useState)([]);
    const handleSelectionChange = (0, $fV3WI.useCallback)((index, checked)=>{
        if (checked) setSelected((selection)=>$9b6e48c21d14460d$export$2e2bcd8739ae039($0a32745b2bdcf705$export$2e2bcd8739ae039(index), $5cfd47e1a86155fb$export$2e2bcd8739ae039)(selection));
        else setSelected((selection)=>$89ddad7dee8f4db5$export$2e2bcd8739ae039($1cb60074c12b9394$export$2e2bcd8739ae039(index), selection));
    }, [
        setSelected
    ]);
    const reset = (0, $fV3WI.useCallback)(()=>setSelected([]), [
        setSelected
    ]);
    return {
        selected: selected,
        handleSelectionChange: handleSelectionChange,
        reset: reset
    };
};






var $dYG3T = parcelRequire("dYG3T");

var $fV3WI = parcelRequire("fV3WI");

var $6r3xg = parcelRequire("6r3xg");

var $hhXI3 = parcelRequire("hhXI3");
// inspired by https://github.com/azmenak/material-ui-nested-menu-item
const $b4e076fb37ffb045$var$primaryContentStyles = (0, $hhXI3.css)`
  display: flex;
  align-items: center;
`;
const $b4e076fb37ffb045$var$submenuStyles = (0, $hhXI3.css)`
  pointer-events: 'none';
`;
const $b4e076fb37ffb045$var$submenuItemsContainerStyles = (0, $hhXI3.css)`
  pointer-events: 'auto';
`;
const $b4e076fb37ffb045$export$a49133e888f99d9b = ({ label: label , children: children , dense: dense , ...rest })=>{
    const [isSubMenuOpen, setIsSubMenuOpen] = (0, $fV3WI.useState)(false);
    const menuItemRef = (0, $fV3WI.useRef)(null);
    const containerRef = (0, $fV3WI.useRef)(null);
    const handleSubMenuClose = ()=>{
        setIsSubMenuOpen(false);
    };
    const handleMouseEnter = ()=>{
        setIsSubMenuOpen(true);
    };
    const handleMouseLeave = ()=>{
        handleSubMenuClose();
    };
    const handleFocus = (event)=>{
        if (event.target === containerRef.current) setIsSubMenuOpen(true);
    };
    return (0, $dYG3T.jsxs)((0, $11ea057b8214369c$export$2e2bcd8739ae039), {
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        ...rest,
        children: [
            (0, $dYG3T.jsx)("div", {
                css: $b4e076fb37ffb045$var$primaryContentStyles,
                ref: menuItemRef,
                onMouseEnter: handleMouseEnter,
                children: label
            }),
            (0, $dYG3T.jsx)((0, $6r3xg.default), {
                MenuListProps: {
                    dense: dense
                },
                css: $b4e076fb37ffb045$var$submenuStyles,
                anchorEl: menuItemRef.current,
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "left"
                },
                open: isSubMenuOpen,
                disableAutoFocus: true,
                disableEnforceFocus: true,
                onMouseLeave: handleMouseLeave,
                onClose: handleSubMenuClose,
                children: (0, $dYG3T.jsx)("div", {
                    ref: containerRef,
                    css: $b4e076fb37ffb045$var$submenuItemsContainerStyles,
                    children: children
                })
            })
        ]
    });
};





var $dYG3T = parcelRequire("dYG3T");
const $53de3580765f8669$export$fb8d7f40caaeea67 = ({ error: error  })=>{
    return(// @TODO add some basic styling and a user friendly message
    (0, $dYG3T.jsxs)("details", {
        children: [
            error?.name,
            (0, $dYG3T.jsx)("br", {}),
            error?.message,
            (0, $dYG3T.jsx)("br", {}),
            error?.stack,
            (0, $dYG3T.jsx)("br", {})
        ]
    }));
};





var $dYG3T = parcelRequire("dYG3T");

var $b65DB = parcelRequire("b65DB");
var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $js0sS = parcelRequire("js0sS");

var $58XPl = parcelRequire("58XPl");

var $ZXS89 = parcelRequire("ZXS89");

var $1CLOS = parcelRequire("1CLOS");

var $6PHZV = parcelRequire("6PHZV");

var $eKfJS = parcelRequire("eKfJS");

var $05gnM = parcelRequire("05gnM");

var $aF4Kv = parcelRequire("aF4Kv");

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $f7e6d53bc69c1ec3$export$2177af0aa15c34c2(slot) {
    return (0, $auxfn.default)("MuiDialog", slot);
}
const $f7e6d53bc69c1ec3$var$dialogClasses = (0, $dxVxC.default)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
var $f7e6d53bc69c1ec3$export$2e2bcd8739ae039 = $f7e6d53bc69c1ec3$var$dialogClasses;



var $fV3WI = parcelRequire("fV3WI");
const $b98dca3ddf63b048$var$DialogContext = /*#__PURE__*/ $fV3WI.createContext({});
var $b98dca3ddf63b048$export$2e2bcd8739ae039 = $b98dca3ddf63b048$var$DialogContext;



var $8qu0S = parcelRequire("8qu0S");

var $4uBZf = parcelRequire("4uBZf");

var $3DnwL = parcelRequire("3DnwL");
const $7f7d8c7cac8328b5$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $7f7d8c7cac8328b5$var$DialogBackdrop = (0, $aF4Kv.default)((0, $8qu0S.default), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $7f7d8c7cac8328b5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , scroll: scroll , maxWidth: maxWidth , fullWidth: fullWidth , fullScreen: fullScreen  } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, $ZXS89.default)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, $ZXS89.default)(scroll)}`,
            `paperWidth${(0, $ZXS89.default)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $f7e6d53bc69c1ec3$export$2177af0aa15c34c2), classes);
};
const $7f7d8c7cac8328b5$var$DialogRoot = (0, $aF4Kv.default)((0, $1CLOS.default), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const $7f7d8c7cac8328b5$var$DialogContainer = (0, $aF4Kv.default)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.container,
            styles[`scroll${(0, $ZXS89.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState  })=>(0, $j5tUA.default)({
        height: "100%",
        "@media print": {
            height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === "paper" && {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.scroll === "body" && {
        overflowY: "auto",
        overflowX: "hidden",
        textAlign: "center",
        "&:after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0"
        }
    }));
const $7f7d8c7cac8328b5$var$DialogPaper = (0, $aF4Kv.default)((0, $eKfJS.default), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $ZXS89.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $ZXS89.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        // Fix IE11 issue, to remove at some point.
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        }
    }, ownerState.scroll === "paper" && {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)"
    }, ownerState.scroll === "body" && {
        display: "inline-block",
        verticalAlign: "middle",
        textAlign: "left" // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: "calc(100% - 64px)"
    }, ownerState.maxWidth === "xs" && {
        maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $f7e6d53bc69c1ec3$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== "xs" && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $f7e6d53bc69c1ec3$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.fullWidth && {
        width: "calc(100% - 64px)"
    }, ownerState.fullScreen && {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "none",
        borderRadius: 0,
        [`&.${(0, $f7e6d53bc69c1ec3$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: "100%"
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $7f7d8c7cac8328b5$var$Dialog = /*#__PURE__*/ $fV3WI.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, $4uBZf.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby , "aria-labelledby": ariaLabelledbyProp , BackdropComponent: BackdropComponent , BackdropProps: BackdropProps , children: children , className: className , disableEscapeKeyDown: disableEscapeKeyDown = false , fullScreen: fullScreen = false , fullWidth: fullWidth = false , maxWidth: maxWidth = "sm" , onBackdropClick: onBackdropClick , onClose: onClose , open: open , PaperComponent: PaperComponent = (0, $eKfJS.default) , PaperProps: PaperProps = {} , scroll: scroll = "paper" , TransitionComponent: TransitionComponent = (0, $6PHZV.default) , transitionDuration: transitionDuration = defaultTransitionDuration , TransitionProps: TransitionProps  } = props, other = (0, $64S8Y.default)(props, $7f7d8c7cac8328b5$var$_excluded);
    const ownerState = (0, $j5tUA.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $7f7d8c7cac8328b5$var$useUtilityClasses(ownerState);
    const backdropClick = $fV3WI.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, $58XPl.default)(ariaLabelledbyProp);
    const dialogContextValue = $fV3WI.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $3DnwL.jsx)($7f7d8c7cac8328b5$var$DialogRoot, (0, $j5tUA.default)({
        className: (0, $h0s6D.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $7f7d8c7cac8328b5$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $j5tUA.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $3DnwL.jsx)(TransitionComponent, (0, $j5tUA.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $3DnwL.jsx)($7f7d8c7cac8328b5$var$DialogContainer, {
                className: (0, $h0s6D.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $3DnwL.jsx)($7f7d8c7cac8328b5$var$DialogPaper, (0, $j5tUA.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $h0s6D.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $3DnwL.jsx)((0, $b98dca3ddf63b048$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $7f7d8c7cac8328b5$export$2e2bcd8739ae039 = $7f7d8c7cac8328b5$var$Dialog;


var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $js0sS = parcelRequire("js0sS");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $9a306adb40f8cfc3$export$5e57a444791c63be(slot) {
    return (0, $auxfn.default)("MuiDialogActions", slot);
}
const $9a306adb40f8cfc3$var$dialogActionsClasses = (0, $dxVxC.default)("MuiDialogActions", [
    "root",
    "spacing"
]);
var $9a306adb40f8cfc3$export$2e2bcd8739ae039 = $9a306adb40f8cfc3$var$dialogActionsClasses;



var $3DnwL = parcelRequire("3DnwL");
const $ffd11388a0fbd07b$var$_excluded = [
    "className",
    "disableSpacing"
];
const $ffd11388a0fbd07b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , disableSpacing: disableSpacing  } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $9a306adb40f8cfc3$export$5e57a444791c63be), classes);
};
const $ffd11388a0fbd07b$var$DialogActionsRoot = (0, $aF4Kv.default)("div", {
    name: "MuiDialogActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState  })=>(0, $j5tUA.default)({
        display: "flex",
        alignItems: "center",
        padding: 8,
        justifyContent: "flex-end",
        flex: "0 0 auto"
    }, !ownerState.disableSpacing && {
        "& > :not(:first-of-type)": {
            marginLeft: 8
        }
    }));
const $ffd11388a0fbd07b$var$DialogActions = /*#__PURE__*/ $fV3WI.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiDialogActions"
    });
    const { className: className , disableSpacing: disableSpacing = false  } = props, other = (0, $64S8Y.default)(props, $ffd11388a0fbd07b$var$_excluded);
    const ownerState = (0, $j5tUA.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $ffd11388a0fbd07b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3DnwL.jsx)($ffd11388a0fbd07b$var$DialogActionsRoot, (0, $j5tUA.default)({
        className: (0, $h0s6D.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $ffd11388a0fbd07b$export$2e2bcd8739ae039 = $ffd11388a0fbd07b$var$DialogActions;


var $64S8Y = parcelRequire("64S8Y");

var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $js0sS = parcelRequire("js0sS");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");

var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $90f9df1ce73a2d57$export$61b0ee1f05fb344e(slot) {
    return (0, $auxfn.default)("MuiDialogContent", slot);
}
const $90f9df1ce73a2d57$var$dialogContentClasses = (0, $dxVxC.default)("MuiDialogContent", [
    "root",
    "dividers"
]);
var $90f9df1ce73a2d57$export$2e2bcd8739ae039 = $90f9df1ce73a2d57$var$dialogContentClasses;



var $dxVxC = parcelRequire("dxVxC");

var $auxfn = parcelRequire("auxfn");
function $b095e3f0abb426eb$export$f5d2ec7e4c47e088(slot) {
    return (0, $auxfn.default)("MuiDialogTitle", slot);
}
const $b095e3f0abb426eb$var$dialogTitleClasses = (0, $dxVxC.default)("MuiDialogTitle", [
    "root"
]);
var $b095e3f0abb426eb$export$2e2bcd8739ae039 = $b095e3f0abb426eb$var$dialogTitleClasses;



var $3DnwL = parcelRequire("3DnwL");
const $cb4cf9d4fdf96bd2$var$_excluded = [
    "className",
    "dividers"
];
const $cb4cf9d4fdf96bd2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes , dividers: dividers  } = ownerState;
    const slots = {
        root: [
            "root",
            dividers && "dividers"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $90f9df1ce73a2d57$export$61b0ee1f05fb344e), classes);
};
const $cb4cf9d4fdf96bd2$var$DialogContentRoot = (0, $aF4Kv.default)("div", {
    name: "MuiDialogContent",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState  } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme , ownerState: ownerState  })=>(0, $j5tUA.default)({
        flex: "1 1 auto",
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        padding: "20px 24px"
    }, ownerState.dividers ? {
        padding: "16px 24px",
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $b095e3f0abb426eb$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $cb4cf9d4fdf96bd2$var$DialogContent = /*#__PURE__*/ $fV3WI.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiDialogContent"
    });
    const { className: className , dividers: dividers = false  } = props, other = (0, $64S8Y.default)(props, $cb4cf9d4fdf96bd2$var$_excluded);
    const ownerState = (0, $j5tUA.default)({}, props, {
        dividers: dividers
    });
    const classes = $cb4cf9d4fdf96bd2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3DnwL.jsx)($cb4cf9d4fdf96bd2$var$DialogContentRoot, (0, $j5tUA.default)({
        className: (0, $h0s6D.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $cb4cf9d4fdf96bd2$export$2e2bcd8739ae039 = $cb4cf9d4fdf96bd2$var$DialogContent;


var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");

var $fV3WI = parcelRequire("fV3WI");


var $h0s6D = parcelRequire("h0s6D");

var $js0sS = parcelRequire("js0sS");

var $hScOl = parcelRequire("hScOl");

var $aF4Kv = parcelRequire("aF4Kv");

var $05gnM = parcelRequire("05gnM");



var $3DnwL = parcelRequire("3DnwL");
const $c2c9bfb3e2cc0603$var$_excluded = [
    "className",
    "id"
];
const $c2c9bfb3e2cc0603$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes  } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $js0sS.default)(slots, (0, $b095e3f0abb426eb$export$f5d2ec7e4c47e088), classes);
};
const $c2c9bfb3e2cc0603$var$DialogTitleRoot = (0, $aF4Kv.default)((0, $hScOl.default), {
    name: "MuiDialogTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    padding: "16px 24px",
    flex: "0 0 auto"
});
const $c2c9bfb3e2cc0603$var$DialogTitle = /*#__PURE__*/ $fV3WI.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiDialogTitle"
    });
    const { className: className , id: idProp  } = props, other = (0, $64S8Y.default)(props, $c2c9bfb3e2cc0603$var$_excluded);
    const ownerState = props;
    const classes = $c2c9bfb3e2cc0603$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp  } = $fV3WI.useContext((0, $b98dca3ddf63b048$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $3DnwL.jsx)($c2c9bfb3e2cc0603$var$DialogTitleRoot, (0, $j5tUA.default)({
        component: "h2",
        className: (0, $h0s6D.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $c2c9bfb3e2cc0603$export$2e2bcd8739ae039 = $c2c9bfb3e2cc0603$var$DialogTitle;


var $4uBZf = parcelRequire("4uBZf");

var $iEw4v = parcelRequire("iEw4v");

var $3DnwL = parcelRequire("3DnwL");
var $6b2b45e458ec2a3d$export$2e2bcd8739ae039 = (0, $iEw4v.default)(/*#__PURE__*/ (0, $3DnwL.jsx)("path", {
    d: "M16.59 7.58 10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "CheckCircleOutline");


var $iEw4v = parcelRequire("iEw4v");

var $3DnwL = parcelRequire("3DnwL");
var $295eb3a77978c2dd$export$2e2bcd8739ae039 = (0, $iEw4v.default)(/*#__PURE__*/ (0, $3DnwL.jsx)("path", {
    d: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
}), "HelpOutline");


var $iEw4v = parcelRequire("iEw4v");

var $3DnwL = parcelRequire("3DnwL");
var $22ad942efae65db3$export$2e2bcd8739ae039 = (0, $iEw4v.default)([
    /*#__PURE__*/ (0, $3DnwL.jsx)("path", {
        d: "M12 5.99 19.53 19H4.47L12 5.99M12 2 1 21h22L12 2z"
    }, "0"),
    /*#__PURE__*/ (0, $3DnwL.jsx)("path", {
        d: "M13 16h-2v2h2zm0-6h-2v5h2z"
    }, "1")
], "WarningAmber");



var $hhXI3 = parcelRequire("hhXI3");
const $5f396a68e2ba3583$var$getAccentColor = (theme, variant)=>{
    const accentColorMap = {
        error: theme.palette.error.main,
        warning: theme.palette.warning.main,
        success: theme.palette.secondary.main,
        question: theme.palette.secondary.main
    };
    return accentColorMap[variant];
};
const $5f396a68e2ba3583$var$getStyles = (theme, variant)=>({
        dialog: (0, $hhXI3.css)`
    padding: 0;
    :before {
      display: block;
      content: '';
      width: 100%;
      height: 10px;
      background-color: ${$5f396a68e2ba3583$var$getAccentColor(theme, variant)};
    }
  `,
        dialogContent: (0, $hhXI3.css)`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  `,
        dialogText: (0, $hhXI3.css)`
    padding: 20px 24px;
  `,
        dialogTitle: (0, $hhXI3.css)`
    padding: 0;
    margin-bottom: ${theme.spacing(1)};
  `,
        dialogIcon: (0, $hhXI3.css)`
    width: 80px;
    height: 80px;
    margin: 20px 0 0 20px;
  `
    });
const $5f396a68e2ba3583$var$buttonColorMap = {
    error: "error",
    warning: "warning",
    success: "success",
    question: "success"
};
const $5f396a68e2ba3583$export$b8704437d11c7fe7 = (props)=>{
    const { onCancel: onCancel , onConfirm: onConfirm , variant: variant = "success" , dialogTitle: dialogTitle , children: children , cancelText: cancelText , confirmText: confirmText , disableConfirmButton: disableConfirmButton = false , ...rest } = props;
    const theme = (0, $4uBZf.default)();
    const styles = $5f396a68e2ba3583$var$getStyles(theme, variant);
    const dialogIconMap = {
        error: (0, $dYG3T.jsx)((0, $15bb1df11d212210$export$2e2bcd8739ae039), {
            color: "error",
            css: styles.dialogIcon
        }),
        warning: (0, $dYG3T.jsx)((0, $22ad942efae65db3$export$2e2bcd8739ae039), {
            color: "warning",
            css: styles.dialogIcon
        }),
        success: (0, $dYG3T.jsx)((0, $6b2b45e458ec2a3d$export$2e2bcd8739ae039), {
            color: "secondary",
            css: styles.dialogIcon
        }),
        question: (0, $dYG3T.jsx)((0, $295eb3a77978c2dd$export$2e2bcd8739ae039), {
            color: "secondary",
            css: styles.dialogIcon
        })
    };
    return (0, $dYG3T.jsxs)((0, $7f7d8c7cac8328b5$export$2e2bcd8739ae039), {
        ...rest,
        children: [
            (0, $dYG3T.jsx)((0, $cb4cf9d4fdf96bd2$export$2e2bcd8739ae039), {
                css: styles.dialog,
                children: (0, $dYG3T.jsxs)("div", {
                    css: styles.dialogContent,
                    children: [
                        dialogIconMap[variant],
                        (0, $dYG3T.jsxs)("div", {
                            css: styles.dialogText,
                            children: [
                                dialogTitle && (0, $dYG3T.jsx)((0, $c2c9bfb3e2cc0603$export$2e2bcd8739ae039), {
                                    css: styles.dialogTitle,
                                    children: dialogTitle
                                }),
                                children
                            ]
                        })
                    ]
                })
            }),
            (0, $dYG3T.jsx)((0, $c61e41c27a6fbffc$export$2e2bcd8739ae039), {
                light: true
            }),
            (0, $dYG3T.jsxs)((0, $ffd11388a0fbd07b$export$2e2bcd8739ae039), {
                children: [
                    (0, $dYG3T.jsx)((0, $b65DB.default), {
                        variant: "contained",
                        color: "inherit",
                        onClick: onCancel,
                        children: cancelText
                    }),
                    (0, $dYG3T.jsx)((0, $b65DB.default), {
                        variant: "contained",
                        color: $5f396a68e2ba3583$var$buttonColorMap[variant],
                        onClick: onConfirm,
                        disabled: disableConfirmButton,
                        children: confirmText
                    })
                ]
            })
        ]
    });
};







var $dYG3T = parcelRequire("dYG3T");

var $gb45a = parcelRequire("gb45a");
var $j5tUA = parcelRequire("j5tUA");

var $64S8Y = parcelRequire("64S8Y");
parcelRequire("fV3WI");


var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $fV3WI = parcelRequire("fV3WI");



var $fV3WI = parcelRequire("fV3WI");
const $3c971db4d85fc78a$var$ThemeContext = /*#__PURE__*/ $fV3WI.createContext(null);
var $3c971db4d85fc78a$export$2e2bcd8739ae039 = $3c971db4d85fc78a$var$ThemeContext;



var $fV3WI = parcelRequire("fV3WI");

function $cbfc61ecdb1969f1$export$2e2bcd8739ae039() {
    const theme = $fV3WI.useContext((0, $3c971db4d85fc78a$export$2e2bcd8739ae039));
    return theme;
}


const $3f958013545d73b1$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $3f958013545d73b1$export$2e2bcd8739ae039 = $3f958013545d73b1$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";



var $3DnwL = parcelRequire("3DnwL");
function $c870c5a089ded3cb$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $c870c5a089ded3cb$var$ThemeProvider(props) {
    const { children: children , theme: localTheme  } = props;
    const outerTheme = (0, $cbfc61ecdb1969f1$export$2e2bcd8739ae039)();
    const theme = $fV3WI.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $c870c5a089ded3cb$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $3f958013545d73b1$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $3DnwL.jsx)((0, $3c971db4d85fc78a$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $c870c5a089ded3cb$export$2e2bcd8739ae039 = $c870c5a089ded3cb$var$ThemeProvider;



parcelRequire("hhXI3");
var $lvueV = parcelRequire("lvueV");

var $3UagE = parcelRequire("3UagE");

var $3DnwL = parcelRequire("3DnwL");
const $7b21f442e5c6f3f5$var$EMPTY_THEME = {};
function $7b21f442e5c6f3f5$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $fV3WI.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $j5tUA.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $j5tUA.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $j5tUA.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $7b21f442e5c6f3f5$var$ThemeProvider(props) {
    const { children: children , theme: localTheme , themeId: themeId  } = props;
    const upperTheme = (0, $3UagE.default)($7b21f442e5c6f3f5$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $cbfc61ecdb1969f1$export$2e2bcd8739ae039)() || $7b21f442e5c6f3f5$var$EMPTY_THEME;
    const engineTheme = $7b21f442e5c6f3f5$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $7b21f442e5c6f3f5$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    return /*#__PURE__*/ (0, $3DnwL.jsx)((0, $c870c5a089ded3cb$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $3DnwL.jsx)((0, $lvueV.T).Provider, {
            value: engineTheme,
            children: children
        })
    });
}
var $7b21f442e5c6f3f5$export$2e2bcd8739ae039 = $7b21f442e5c6f3f5$var$ThemeProvider;



var $4owFt = parcelRequire("4owFt");

var $3DnwL = parcelRequire("3DnwL");
const $931c9ca4343df476$var$_excluded = [
    "theme"
];
function $931c9ca4343df476$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput  } = _ref, props = (0, $64S8Y.default)(_ref, $931c9ca4343df476$var$_excluded);
    const scopedTheme = themeInput[0, $4owFt.default];
    return /*#__PURE__*/ (0, $3DnwL.jsx)((0, $7b21f442e5c6f3f5$export$2e2bcd8739ae039), (0, $j5tUA.default)({}, props, {
        themeId: scopedTheme ? (0, $4owFt.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}



var $j5tUA = parcelRequire("j5tUA");

var $fV3WI = parcelRequire("fV3WI");


var $05gnM = parcelRequire("05gnM");

var $lbyvF = parcelRequire("lbyvF");

var $3DnwL = parcelRequire("3DnwL");
const $2d987f6d88638a57$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $j5tUA.default)({
        WebkitFontSmoothing: "antialiased",
        // Antialiasing.
        MozOsxFontSmoothing: "grayscale",
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: "border-box",
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: "100%"
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const $2d987f6d88638a57$export$32180ef41b15b513 = (theme)=>(0, $j5tUA.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        "@media print": {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $2d987f6d88638a57$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components, _theme$components$Mui;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, "")] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, $j5tUA.default)({
        html: $2d987f6d88638a57$export$c0bb0b647f701bb5(theme, enableColorScheme),
        "*, *::before, *::after": {
            boxSizing: "inherit"
        },
        "strong, b": {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $j5tUA.default)({
            margin: 0
        }, $2d987f6d88638a57$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            "&::backdrop": {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null ? void 0 : (_theme$components$Mui = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components$Mui.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $2d987f6d88638a57$var$CssBaseline(inProps) {
    const props = (0, $05gnM.default)({
        props: inProps,
        name: "MuiCssBaseline"
    });
    const { children: children , enableColorScheme: enableColorScheme = false  } = props;
    return /*#__PURE__*/ (0, $3DnwL.jsxs)($fV3WI.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3DnwL.jsx)((0, $lbyvF.default), {
                styles: (theme)=>$2d987f6d88638a57$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
var $2d987f6d88638a57$export$2e2bcd8739ae039 = $2d987f6d88638a57$var$CssBaseline;



var $aRufz = parcelRequire("aRufz");
const $cac3ef454e2023be$var$VARS = {
    colorWhite: "#fff",
    colorPrimary: "#67ae48",
    colorPrimaryLighter: "#6eb64f",
    colorPrimaryDarker: "#61a344",
    colorSecondary: "#1ba282",
    colorSecondaryLighter: "#6ec7b5",
    colorSecondaryContrast: "#f3f9f1",
    colorSecondaryDarker: "#178c70",
    colorSecondaryBg: "#d6ebe6",
    colorPrimaryBg: "#e0ebe4",
    colorSecondaryBgDarker: "#bedfd7",
    colorText: "#4a4a4a",
    colorTextTitle: "#666666",
    colorBackground: "#fff",
    colorError: "#f04e4e",
    colorGoogle: "#4d87ed",
    colorFacebook: "#415b93",
    colorProductHighlight: "#b5203a",
    customSpacing: "6.5px"
};
const $cac3ef454e2023be$export$bca14c5b3b88a9c9 = (0, $aRufz.default)({
    palette: {
        primary: {
            main: $cac3ef454e2023be$var$VARS.colorPrimary,
            light: $cac3ef454e2023be$var$VARS.colorPrimaryLighter,
            contrastText: $cac3ef454e2023be$var$VARS.colorWhite
        },
        secondary: {
            main: $cac3ef454e2023be$var$VARS.colorSecondary,
            light: $cac3ef454e2023be$var$VARS.colorSecondaryLighter,
            dark: $cac3ef454e2023be$var$VARS.colorSecondaryDarker,
            contrastText: $cac3ef454e2023be$var$VARS.colorWhite
        },
        success: {
            main: $cac3ef454e2023be$var$VARS.colorSecondary,
            light: $cac3ef454e2023be$var$VARS.colorSecondaryLighter,
            dark: $cac3ef454e2023be$var$VARS.colorSecondaryDarker,
            contrastText: $cac3ef454e2023be$var$VARS.colorWhite
        },
        background: {
            default: $cac3ef454e2023be$var$VARS.colorBackground
        },
        text: {
            primary: $cac3ef454e2023be$var$VARS.colorText
        },
        error: {
            main: $cac3ef454e2023be$var$VARS.colorError
        }
    },
    mixins: {
        toolbar: {
            height: "70px"
        }
    },
    typography: {
        fontFamily: "Open Sans, sans-serif",
        htmlFontSize: 16,
        fontSize: 14,
        allVariants: {
            letterSpacing: "-0.3px"
        }
    },
    extraColors: {
        secondaryContrast: $cac3ef454e2023be$var$VARS.colorSecondaryContrast,
        secondaryHover: $cac3ef454e2023be$var$VARS.colorSecondaryBg,
        productHighlight: $cac3ef454e2023be$var$VARS.colorProductHighlight,
        progressLeft: $cac3ef454e2023be$var$VARS.colorSecondaryLighter,
        progressRight: $cac3ef454e2023be$var$VARS.colorSecondary,
        headlineBackgroundLeft: $cac3ef454e2023be$var$VARS.colorPrimary,
        headlineBackgroundRight: $cac3ef454e2023be$var$VARS.colorSecondary,
        gradientLeft: $cac3ef454e2023be$var$VARS.colorPrimary,
        gradientRight: $cac3ef454e2023be$var$VARS.colorSecondary,
        helpButtonText: $cac3ef454e2023be$var$VARS.colorWhite,
        helpButtonBackground: $cac3ef454e2023be$var$VARS.colorSecondary,
        helpButtonBackgroundMobile: $cac3ef454e2023be$var$VARS.colorSecondaryDarker
    },
    components: {
        MuiButton: {
            defaultProps: {
                disableRipple: true,
                disableElevation: true
            },
            styleOverrides: {
                root: {
                    textTransform: "none",
                    fontSize: "15px",
                    fontWeight: "bold",
                    borderRadius: "3px"
                },
                containedPrimary: {
                    backgroundImage: `linear-gradient(to right, ${$cac3ef454e2023be$var$VARS.colorPrimary}, ${$cac3ef454e2023be$var$VARS.colorSecondary})`,
                    "&:hover": {
                        backgroundImage: `linear-gradient(to right, ${$cac3ef454e2023be$var$VARS.colorPrimaryLighter}, ${$cac3ef454e2023be$var$VARS.colorSecondaryLighter})`
                    },
                    "&.Mui-disabled": {
                        backgroundImage: "none"
                    }
                },
                containedSecondary: {
                    backgroundColor: $cac3ef454e2023be$var$VARS.colorSecondaryBg,
                    color: $cac3ef454e2023be$var$VARS.colorSecondary,
                    "&:hover": {
                        backgroundColor: $cac3ef454e2023be$var$VARS.colorSecondaryBgDarker
                    }
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: 13,
                    color: $cac3ef454e2023be$var$VARS.colorWhite,
                    backgroundColor: $cac3ef454e2023be$var$VARS.colorSecondary,
                    fontFamily: "inherit"
                }
            }
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    color: $cac3ef454e2023be$var$VARS.colorText,
                    fontWeight: "bold",
                    lineHeight: 1.5,
                    fontSize: 16
                }
            }
        },
        MuiTypography: {
            styleOverrides: {
                subtitle2: {
                    color: $cac3ef454e2023be$var$VARS.colorText,
                    fontSize: 14,
                    fontWeight: "normal",
                    lineHeight: 1.3
                },
                subtitle1: {
                    color: $cac3ef454e2023be$var$VARS.colorText,
                    fontSize: 16,
                    fontWeight: "normal",
                    lineHeight: 1.5
                },
                h6: {
                    color: $cac3ef454e2023be$var$VARS.colorText,
                    fontWeight: "bold",
                    lineHeight: 1.5,
                    fontSize: "14px"
                },
                h5: {
                    color: $cac3ef454e2023be$var$VARS.colorText,
                    fontWeight: "bold",
                    lineHeight: 1.5,
                    fontSize: "16px"
                },
                h4: {
                    color: $cac3ef454e2023be$var$VARS.colorText,
                    fontWeight: "bold",
                    lineHeight: 1.5,
                    fontSize: "18px"
                },
                h3: {
                    color: $cac3ef454e2023be$var$VARS.colorText,
                    fontWeight: "bold",
                    lineHeight: 1.5,
                    fontSize: "20px"
                },
                h2: {
                    color: $cac3ef454e2023be$var$VARS.colorTextTitle,
                    fontWeight: 600,
                    lineHeight: 1.5,
                    marginBottom: 8,
                    fontSize: "22px"
                },
                h1: {
                    color: $cac3ef454e2023be$var$VARS.colorText,
                    fontWeight: "bold",
                    lineHeight: 1.5,
                    fontSize: "24px"
                }
            }
        },
        MuiCssBaseline: {
            styleOverrides: {
                "@global": {
                    html: {
                        margin: 0,
                        padding: 0
                    },
                    body: {
                        margin: 0,
                        padding: 0,
                        fontSize: "16px",
                        color: $cac3ef454e2023be$var$VARS.colorText
                    },
                    "#root": {
                        height: "100%"
                    },
                    a: {
                        color: $cac3ef454e2023be$var$VARS.colorSecondary
                    },
                    "input:-webkit-autofill": {
                        transition: "background-color 5000s ease-in-out 0s, color 5000s ease-in-out 0s"
                    },
                    "input, select, textarea": {
                        fontSize: "16px"
                    },
                    "input[type=date]": {
                        cursor: "pointer"
                    },
                    "input[type=date]::-webkit-calendar-picker-indicator": {
                        cursor: "pointer"
                    }
                }
            }
        }
    }
});


const $0ab2683c60daa9b9$export$8889118937e2803c = ({ children: children , theme: theme  })=>{
    return (0, $dYG3T.jsx)((0, $gb45a.default), {
        injectFirst: true,
        children: (0, $dYG3T.jsxs)((0, $931c9ca4343df476$export$2e2bcd8739ae039), {
            theme: theme || (0, $cac3ef454e2023be$export$bca14c5b3b88a9c9),
            children: [
                (0, $dYG3T.jsx)((0, $2d987f6d88638a57$export$2e2bcd8739ae039), {}),
                " ",
                children
            ]
        })
    });
};










var $dYG3T = parcelRequire("dYG3T");
parcelRequire("fV3WI");

var $g32wE = parcelRequire("g32wE");
parcelRequire("1L1yK");
var $b3xDI = parcelRequire("b3xDI");

var $l3z4m = parcelRequire("l3z4m");
var $hScOl = parcelRequire("hScOl");


var $dYG3T = parcelRequire("dYG3T");
parcelRequire("fV3WI");

const $ab9ba85f05461744$export$e6ff31bff12b7ff4 = ({})=>/*#__PURE__*/ (0, $dYG3T.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 854.7 255",
        version: "1",
        width: 122,
        height: 35,
        "aria-labelledby": "Nebenkostenabrechnung pr\xfcfen lassen bei MINEKO",
        children: [
            /*#__PURE__*/ (0, $dYG3T.jsx)("title", {
                children: "Nebenkostenabrechnung pr\xfcfen lassen bei MINEKO"
            }),
            /*#__PURE__*/ (0, $dYG3T.jsxs)("linearGradient", {
                id: "SVGID_1_",
                x1: "652.1",
                x2: "853.1",
                y1: "84.75",
                y2: "84.75",
                gradientUnits: "userSpaceOnUse",
                children: [
                    /*#__PURE__*/ (0, $dYG3T.jsx)("stop", {
                        offset: "0",
                        stopColor: "#6fbc4d"
                    }),
                    /*#__PURE__*/ (0, $dYG3T.jsx)("stop", {
                        offset: "1",
                        stopColor: "#16a085"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dYG3T.jsx)("path", {
                fill: "url(#SVGID_1_)",
                d: "M652.1 78.8h29.4l28.6 33.6L826.3 3h26.8L705.7 166.5z"
            }),
            /*#__PURE__*/ (0, $dYG3T.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $dYG3T.jsx)("path", {
                        fill: "#383839",
                        d: "M673.5 130.1c-1.1 0-2.1.2-2.9.2-23.4 0-42.1-18.9-42.1-42.1 0-23.4 18.9-42.1 42.1-42.1 23.4 0 42.1 18.9 42.1 42.1 0 3.4-.4 6.5-1.1 9.7l29.5-27.8c-8-31.4-36.6-54.7-70.5-54.7C630.4 15.4 598 48 598 88c0 40.2 32.6 72.6 72.6 72.6 6.9 0 13.7-1.1 20.2-2.7l-17.3-27.8z"
                    }),
                    /*#__PURE__*/ (0, $dYG3T.jsx)("path", {
                        fill: "#383839",
                        d: "M128 160c-2.1-54.7-3.4-91.8-3.4-111.3h-.6c-3.4 14.7-14.5 50.9-33.5 109H65.9c-11.4-40-18.1-64.6-20.4-73.7-2.3-9-4.8-20.8-7.8-35.4h-.4c-.8 27.6-1.7 47.4-2.3 59.6L32.3 160H2.8l8.8-137.9h42.9c10.5 35.1 16.8 57 19.2 65.2 2.1 8.4 4.2 18.3 6.5 29.9h.8c5.1-21.3 9.3-37.3 12.8-48l15.8-47.1h42.1l7.4 137.9H128zM181.7 22.2h31.8V160h-31.8V22.2zM267.8 160h-29.3V22.2h37.7l33.3 56.4c6.3 10.9 13 24.8 20 41.9h.4c-1.7-14.5-2.5-33.5-2.5-56.8V22.2h29.3V160h-33.5c-23.4-40.6-37.3-65-41.9-73.5-4.4-8.4-9.3-18.1-14.1-29.3h-.8c1.1 17.5 1.5 37.5 1.5 60l-.1 42.8zM462.4 76.5V102h-53v32.4h59.1V160h-90.7V22.2h87.8v25.7h-56.2v28.4h53v.2zM487.9 160V22.2h31.4V83c4.2-6.1 8-11.8 11.4-16.4l31.6-44.2h39.4l-47.1 58.5 49.9 79.3h-37l-35.6-59.8-12.2 14.7v45l-31.8-.1z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dYG3T.jsx)("g", {
                children: /*#__PURE__*/ (0, $dYG3T.jsx)("text", {
                    x: "0",
                    y: "241",
                    style: {
                        letterSpacing: "-1pt"
                    },
                    fontSize: 70,
                    fontFamily: "Meta",
                    fill: "#383839",
                    children: "Mietnebenkosten korrekt?"
                })
            })
        ]
    });





var $hhXI3 = parcelRequire("hhXI3");
const $00411ecd1465972b$var$toolbarStyles = (0, $hhXI3.css)`
  display: flex;
  justify-content: space-between;
`;
const $00411ecd1465972b$var$loginLinkStyles = (0, $hhXI3.css)`
  text-decoration: none;
`;
const $00411ecd1465972b$var$Header = ()=>{
    const { t: t  } = (0, $b3xDI.useTranslation)();
    return /*#__PURE__*/ (0, $dYG3T.jsxs)((0, $fc47552009a143b3$export$8b251419efc915eb), {
        toolbarProps: {
            css: $00411ecd1465972b$var$toolbarStyles
        },
        children: [
            /*#__PURE__*/ (0, $dYG3T.jsx)((0, $ab9ba85f05461744$export$e6ff31bff12b7ff4), {}),
            /*#__PURE__*/ (0, $dYG3T.jsxs)((0, $hScOl.default), {
                variant: "body2",
                children: [
                    /*#__PURE__*/ (0, $dYG3T.jsxs)("span", {
                        children: [
                            t("Global.already_registered"),
                            "\xa0"
                        ]
                    }),
                    /*#__PURE__*/ (0, $dYG3T.jsx)((0, $l3z4m.default), {
                        component: (0, $g32wE.Link),
                        color: "secondary",
                        to: "/",
                        css: $00411ecd1465972b$var$loginLinkStyles,
                        children: /*#__PURE__*/ (0, $dYG3T.jsx)("b", {
                            children: t("Global.login_page")
                        })
                    })
                ]
            })
        ]
    });
};
var $00411ecd1465972b$export$2e2bcd8739ae039 = $00411ecd1465972b$var$Header;





var $aRufz = parcelRequire("aRufz");
const $5f09aed238bb6d48$var$VARS = {
    colorText: "#333333",
    colorTextTitle: "#666666",
    colorPrimary: "#00ffd0",
    colorPrimaryDarker: "#00d9b1",
    colorPrimaryLighter: "#00ffd0",
    colorSecondary: "#333333",
    colorSecondaryLighter: "#676767",
    colorSecondaryDarker: "#242424",
    colorSecondaryBg: "#f5f5f5",
    colorSecondaryBgDarker: "#eaeaea",
    colorBackground: "#ffffff",
    colorError: "#e74b3c",
    colorGoogle: "#4d87ed",
    colorFacebook: "#415b93",
    colorProductHighlight: "#b5203a",
    colorWhite: "#ffffff",
    customSpacing: "6.5px",
    colorDarkPrimary: "#006878",
    colorLightPrimary: "#e7fdf1"
};
const $5f09aed238bb6d48$export$bca14c5b3b88a9c9 = (0, $aRufz.default)({
    palette: {
        primary: {
            main: $5f09aed238bb6d48$var$VARS.colorPrimary,
            light: $5f09aed238bb6d48$var$VARS.colorPrimaryLighter,
            dark: $5f09aed238bb6d48$var$VARS.colorPrimaryDarker,
            contrastText: $5f09aed238bb6d48$var$VARS.colorText
        },
        secondary: {
            main: $5f09aed238bb6d48$var$VARS.colorSecondary,
            light: $5f09aed238bb6d48$var$VARS.colorSecondaryLighter,
            dark: $5f09aed238bb6d48$var$VARS.colorSecondaryDarker
        },
        background: {
            default: $5f09aed238bb6d48$var$VARS.colorBackground
        },
        text: {
            primary: $5f09aed238bb6d48$var$VARS.colorText
        },
        error: {
            main: $5f09aed238bb6d48$var$VARS.colorError
        }
    },
    typography: {
        fontFamily: "Open Sans, sans-serif",
        htmlFontSize: 16,
        fontSize: 14,
        allVariants: {
            letterSpacing: "-0.3px"
        }
    },
    extraColors: {
        secondaryHover: $5f09aed238bb6d48$var$VARS.colorSecondaryBg,
        productHighlight: $5f09aed238bb6d48$var$VARS.colorProductHighlight,
        progressLeft: $5f09aed238bb6d48$var$VARS.colorPrimary,
        progressRight: $5f09aed238bb6d48$var$VARS.colorPrimaryDarker,
        headlineBackgroundLeft: $5f09aed238bb6d48$var$VARS.colorLightPrimary,
        headlineBackgroundRight: $5f09aed238bb6d48$var$VARS.colorLightPrimary,
        gradientLeft: $5f09aed238bb6d48$var$VARS.colorPrimary,
        gradientRight: $5f09aed238bb6d48$var$VARS.colorPrimaryDarker,
        helpButtonText: $5f09aed238bb6d48$var$VARS.colorWhite,
        helpButtonBackground: $5f09aed238bb6d48$var$VARS.colorDarkPrimary,
        helpButtonBackgroundMobile: $5f09aed238bb6d48$var$VARS.colorDarkPrimary
    },
    components: {
        MuiButton: {
            defaultProps: {
                disableRipple: true,
                disableElevation: true
            },
            styleOverrides: {
                root: {
                    textTransform: "none",
                    fontSize: "15px",
                    fontWeight: "bold",
                    borderRadius: "3px"
                }
            }
        },
        MuiGrid: {
            styleOverrides: {
                item: {
                    padding: $5f09aed238bb6d48$var$VARS.customSpacing
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: 13,
                    color: $5f09aed238bb6d48$var$VARS.colorWhite,
                    backgroundColor: $5f09aed238bb6d48$var$VARS.colorSecondary,
                    fontFamily: "inherit"
                }
            }
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: $5f09aed238bb6d48$var$VARS.colorSecondary
                }
            }
        },
        MuiTypography: {
            styleOverrides: {
                subtitle2: {
                    color: $5f09aed238bb6d48$var$VARS.colorText,
                    fontSize: 14,
                    fontWeight: "normal",
                    lineHeight: 1.3
                },
                subtitle1: {
                    color: $5f09aed238bb6d48$var$VARS.colorText,
                    fontSize: 16,
                    fontWeight: "normal",
                    lineHeight: 1.5
                },
                h6: {
                    color: $5f09aed238bb6d48$var$VARS.colorText,
                    fontWeight: "bold",
                    lineHeight: 1.5
                },
                h5: {
                    color: $5f09aed238bb6d48$var$VARS.colorText,
                    fontWeight: "bold",
                    lineHeight: 1.5
                },
                h4: {
                    color: $5f09aed238bb6d48$var$VARS.colorText,
                    fontWeight: "bold",
                    lineHeight: 1.5
                },
                h3: {
                    color: $5f09aed238bb6d48$var$VARS.colorText,
                    fontWeight: "bold",
                    lineHeight: 1.5
                },
                h2: {
                    color: $5f09aed238bb6d48$var$VARS.colorTextTitle,
                    fontWeight: 600,
                    lineHeight: 1.5,
                    marginBottom: 8
                },
                h1: {
                    color: $5f09aed238bb6d48$var$VARS.colorText,
                    fontWeight: "bold",
                    lineHeight: 1.5
                }
            }
        },
        MuiCssBaseline: {
            styleOverrides: {
                "@global": {
                    html: {
                        margin: 0,
                        padding: 0
                    },
                    body: {
                        margin: 0,
                        padding: 0,
                        fontSize: "16px",
                        color: $5f09aed238bb6d48$var$VARS.colorText
                    },
                    "#root": {
                        height: "100%"
                    },
                    a: {
                        color: $5f09aed238bb6d48$var$VARS.colorSecondary
                    },
                    "input:-webkit-autofill": {
                        transition: "background-color 5000s ease-in-out 0s, color 5000s ease-in-out 0s"
                    },
                    "input, select, textarea": {
                        fontSize: "16px"
                    },
                    "input[type=date]": {
                        cursor: "pointer"
                    },
                    "input[type=date]::-webkit-calendar-picker-indicator": {
                        cursor: "pointer"
                    }
                }
            }
        }
    }
});


const $b73e241715094572$export$89cbf1a0881c8b9c = ()=>{
    switch(location.hostname){
        case "is24.staging.mineko.de":
        case "is24.mineko.de":
            return 0, $5f09aed238bb6d48$export$bca14c5b3b88a9c9;
        default:
            return undefined;
    }
};





var $hhXI3 = parcelRequire("hhXI3");
parcelRequire("g32wE");
var $8ffEw = parcelRequire("8ffEw");
var $g32wE = parcelRequire("g32wE");
var $8ffEw = parcelRequire("8ffEw");

var $dYG3T = parcelRequire("dYG3T");

var $fV3WI = parcelRequire("fV3WI");

var $f1uOs = parcelRequire("f1uOs");


var $iEw4v = parcelRequire("iEw4v");

var $3DnwL = parcelRequire("3DnwL");
var $510638894c8601d6$export$2e2bcd8739ae039 = (0, $iEw4v.default)(/*#__PURE__*/ (0, $3DnwL.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");


const $dab144e99c75e1d1$export$d1e619fddc3508ce = ({ children: children  })=>{
    const notistackRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fV3WI))).createRef();
    const onClickDismiss = (key)=>()=>{
            notistackRef?.current?.closeSnackbar(key);
        };
    return /*#__PURE__*/ (0, $dYG3T.jsx)((0, $f1uOs.SnackbarProvider), {
        ref: notistackRef,
        action: (key)=>/*#__PURE__*/ (0, $dYG3T.jsx)((0, $96e62cba67d8fc25$export$2e2bcd8739ae039), {
                color: "inherit",
                size: "small",
                onClick: onClickDismiss(key),
                children: /*#__PURE__*/ (0, $dYG3T.jsx)((0, $510638894c8601d6$export$2e2bcd8739ae039), {})
            }),
        maxSnack: 5,
        autoHideDuration: 10000,
        children: children
    });
};


parcelRequire("hc6sd");
var $lpNwr = parcelRequire("lpNwr");

var $2bgZK = parcelRequire("2bgZK");
parcelRequire("1L1yK");
var $b3xDI = parcelRequire("b3xDI");


var $dYG3T = parcelRequire("dYG3T");
parcelRequire("fV3WI");
parcelRequire("1L1yK");
var $b3xDI = parcelRequire("b3xDI");


var $4uBZf = parcelRequire("4uBZf");

var $hhXI3 = parcelRequire("hhXI3");
const $dcef17acc17f71e0$var$primaryTextStyles = (theme)=>(0, $hhXI3.css)`
  color: ${theme.palette.primary.main};
  font-weight: bold;
  margin-top: 12px;
`;
const $dcef17acc17f71e0$export$3b0d6d7590275603 = ()=>{
    const { t: t  } = (0, $b3xDI.useTranslation)();
    const theme = (0, $4uBZf.default)();
    return /*#__PURE__*/ (0, $dYG3T.jsx)((0, $fc2ca009a1ed8848$export$3fb99980b01d36b1), {
        loading: true,
        children: /*#__PURE__*/ (0, $dYG3T.jsx)("span", {
            css: $dcef17acc17f71e0$var$primaryTextStyles(theme),
            children: t("Global.please_wait")
        })
    });
};



var $dYG3T = parcelRequire("dYG3T");

var $fV3WI = parcelRequire("fV3WI");

var $6Sno5 = parcelRequire("6Sno5");

var $7KC5x = parcelRequire("7KC5x");

const $d1eaf688a2065782$var$Federate = /*#__PURE__*/ (0, $fV3WI.lazy)(()=>(parcelRequire("aKrmE")));
const $d1eaf688a2065782$export$6955bcca4cd3539f = ({ title: title , Component: Component , providers: providers  })=>{
    return /*#__PURE__*/ (0, $dYG3T.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $dYG3T.jsx)((0, $6Sno5.PageHeading), {
                children: title
            }),
            providers.email && /*#__PURE__*/ (0, $dYG3T.jsx)(Component, {}),
            (providers.google || providers.googleWorkspace) && /*#__PURE__*/ (0, $dYG3T.jsxs)("div", {
                children: [
                    providers.email && /*#__PURE__*/ (0, $dYG3T.jsx)((0, $7KC5x.default), {
                        px: 3,
                        children: /*#__PURE__*/ (0, $dYG3T.jsx)((0, $c61e41c27a6fbffc$export$2e2bcd8739ae039), {
                            children: "oder"
                        })
                    }),
                    providers.google && /*#__PURE__*/ (0, $dYG3T.jsx)($d1eaf688a2065782$var$Federate, {
                        provider: providers.google
                    }),
                    providers.googleWorkspace && /*#__PURE__*/ (0, $dYG3T.jsx)($d1eaf688a2065782$var$Federate, {
                        provider: providers.googleWorkspace
                    })
                ]
            })
        ]
    });
};



var $gAFWW = parcelRequire("gAFWW");

const $5bbc3efaad3f7fbe$var$Login = /*#__PURE__*/ (0, $fV3WI.lazy)(()=>(parcelRequire("7lqkF")));

const $5bbc3efaad3f7fbe$var$Register = /*#__PURE__*/ (0, $fV3WI.lazy)(()=>(parcelRequire("fnhb1")));

const $5bbc3efaad3f7fbe$var$Verify = /*#__PURE__*/ (0, $fV3WI.lazy)(()=>(parcelRequire("6RIdp")));

const $5bbc3efaad3f7fbe$var$ForgotPassword = /*#__PURE__*/ (0, $fV3WI.lazy)(()=>(parcelRequire("2iTIk")));
// in order to avoid old is24 users with 3rd party blocking being in an infinite error loop
// we emit this event to make is24 redirect the parent window
window.parent.postMessage({
    name: "do_redirect",
    value: location.href
}, "*");
const $5bbc3efaad3f7fbe$var$theme = (0, $b73e241715094572$export$89cbf1a0881c8b9c)();
const $5bbc3efaad3f7fbe$var$RedirectToDefaultRoute = ({ config: config  })=>{
    const navigate = (0, $8ffEw.useNavigate)();
    const { requestedUri: requestedUri  } = (0, $gAFWW.useQueryParams)();
    const isLogin = (0, $8ffEw.useMatch)("/");
    (0, $fV3WI.useEffect)(()=>{
        const shouldRedirect = config.defaultRegistrationRoutes.some((route)=>requestedUri?.includes(route));
        if (isLogin && shouldRedirect) navigate("/register");
    }, []);
    return null;
};
const $5bbc3efaad3f7fbe$var$containerStyles = (0, $hhXI3.css)`
  padding-top: 32px;
  padding-bottom: 32px;
`;
const $5bbc3efaad3f7fbe$export$7593eb0107a6096b = ()=>{
    const config = (0, $lpNwr.useConfig)();
    const { t: t  } = (0, $b3xDI.useTranslation)();
    (0, $fV3WI.useEffect)(()=>{
        if (config) {
            console.info(`Config loaded: ${config.APP_ENV}`);
            config.amplifyConfig && (0, $2bgZK.configure)({
                amplifyConfig: config.amplifyConfig
            });
            config.SENTRY_DSN && (0, $64fb0c91ac855ea6$export$dc1f4e41fb91cdb3)({
                dsn: config.SENTRY_DSN,
                release: window["VERSION"],
                environment: config.APP_ENV
            });
            config.gtm && (0, $21a020c73fae2a9e$exports.TagManager).init({
                containerId: config.gtm.REACT_APP_GTM_ID,
                preview: config.gtm.REACT_APP_GTM_PREVIEW,
                auth: config.gtm.REACT_APP_GTM_AUTH
            });
        }
    }, [
        config
    ]);
    return /*#__PURE__*/ (0, $dYG3T.jsx)((0, $0ab2683c60daa9b9$export$8889118937e2803c), {
        theme: $5bbc3efaad3f7fbe$var$theme,
        children: /*#__PURE__*/ (0, $dYG3T.jsx)((0, $dab144e99c75e1d1$export$d1e619fddc3508ce), {
            children: config ? /*#__PURE__*/ (0, $dYG3T.jsxs)((0, $g32wE.BrowserRouter), {
                basename: "/login/",
                children: [
                    /*#__PURE__*/ (0, $dYG3T.jsx)((0, $00411ecd1465972b$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $dYG3T.jsx)((0, $826570d6abfe5872$export$2e2bcd8739ae039), {
                        maxWidth: "sm",
                        css: $5bbc3efaad3f7fbe$var$containerStyles,
                        children: /*#__PURE__*/ (0, $dYG3T.jsx)((0, $fV3WI.Suspense), {
                            fallback: /*#__PURE__*/ (0, $dYG3T.jsx)((0, $dcef17acc17f71e0$export$3b0d6d7590275603), {}),
                            children: /*#__PURE__*/ (0, $dYG3T.jsxs)((0, $8ffEw.Routes), {
                                children: [
                                    /*#__PURE__*/ (0, $dYG3T.jsx)((0, $8ffEw.Route), {
                                        path: "/",
                                        element: /*#__PURE__*/ (0, $dYG3T.jsx)((0, $d1eaf688a2065782$export$6955bcca4cd3539f), {
                                            providers: config.identityProviders,
                                            title: t("Login.title"),
                                            Component: $5bbc3efaad3f7fbe$var$Login
                                        })
                                    }),
                                    config.isRegistrationEnabled && /*#__PURE__*/ (0, $dYG3T.jsx)((0, $8ffEw.Route), {
                                        path: "/register",
                                        element: /*#__PURE__*/ (0, $dYG3T.jsx)((0, $d1eaf688a2065782$export$6955bcca4cd3539f), {
                                            providers: config.identityProviders,
                                            title: t("Register.title"),
                                            Component: $5bbc3efaad3f7fbe$var$Register
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $dYG3T.jsx)((0, $8ffEw.Route), {
                                        path: "/forgot-password/*",
                                        element: /*#__PURE__*/ (0, $dYG3T.jsx)($5bbc3efaad3f7fbe$var$ForgotPassword, {})
                                    }),
                                    /*#__PURE__*/ (0, $dYG3T.jsx)((0, $8ffEw.Route), {
                                        path: "/verify",
                                        element: /*#__PURE__*/ (0, $dYG3T.jsx)($5bbc3efaad3f7fbe$var$Verify, {})
                                    }),
                                    /*#__PURE__*/ (0, $dYG3T.jsx)((0, $8ffEw.Route), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $dYG3T.jsx)((0, $8ffEw.Navigate), {
                                            to: "/",
                                            replace: true
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $dYG3T.jsx)($5bbc3efaad3f7fbe$var$RedirectToDefaultRoute, {
                        config: config
                    })
                ]
            }) : /*#__PURE__*/ (0, $dYG3T.jsx)((0, $dcef17acc17f71e0$export$3b0d6d7590275603), {})
        })
    });
};





const $6016fe75dc4289b6$var$PUBLIC_URL = "/login/";
const $6016fe75dc4289b6$var$configs = [
    {
        name: "APP",
        url: `${$6016fe75dc4289b6$var$PUBLIC_URL}config.json?v=${window["VERSION"]}`
    },
    {
        name: "ENV",
        url: `${$6016fe75dc4289b6$var$PUBLIC_URL}config/${location.hostname}.json?v=${window["VERSION"]}`
    }
];
const $6016fe75dc4289b6$var$App = ()=>{
    return /*#__PURE__*/ (0, $dYG3T.jsx)((0, $64fb0c91ac855ea6$export$b69d0d92862de18b), {
        fallback: ({ error: error  })=>/*#__PURE__*/ (0, $dYG3T.jsxs)("details", {
                children: [
                    error?.name,
                    /*#__PURE__*/ (0, $dYG3T.jsx)("br", {}),
                    error?.message,
                    /*#__PURE__*/ (0, $dYG3T.jsx)("br", {}),
                    error?.stack,
                    /*#__PURE__*/ (0, $dYG3T.jsx)("br", {})
                ]
            }),
        children: /*#__PURE__*/ (0, $dYG3T.jsx)((0, $gAFWW.ConfigProvider), {
            items: $6016fe75dc4289b6$var$configs,
            children: /*#__PURE__*/ (0, $dYG3T.jsx)((0, $5bbc3efaad3f7fbe$export$7593eb0107a6096b), {})
        })
    });
};
var $6016fe75dc4289b6$export$2e2bcd8739ae039 = $6016fe75dc4289b6$var$App;


var $0b05cf51e2255743$exports = {};
$0b05cf51e2255743$exports = JSON.parse('{"Global":{"submit":"Weiter","email":"E-Mail","code":"PIN","new_password":"Neues Passwort","set_password":"Passwort festlegen","first_name":"Vorname","last_name":"Name","male":"Herr","female":"Frau","register":"registrieren","login":"einloggen","login_page":"Login","register_page":"Registrieren","or":"oder","already_registered":"Bereits registriert?","please_wait":"Einen Moment bitte"},"Federate":{"withGoogle":"weiter mit Google"},"Verify":{"title":"Best\xe4tigung Ihrer E-Mailadresse","description":"Bitte best\xe4tigen Sie ihre E-Mailadresse, um alle Funktionen nutzen zu k\xf6nnen. Wir senden Ihnen eine E-Mail mit einem Link zur Verifizierung.","success":"Sie erhalten in K\xfcrze eine E-Mail mit einem Link zur Verifizierung."},"Validation":{"email":{"required":"Bitte geben Sie ihre E-Mailadresse ein.","format":"Ung\xfcltiges Format."},"code":{"required":"Bitte geben sie den PIN ein.","format":"Es m\xfcssen 6 Zahlen sein."},"password":{"required":"Bitte geben Sie ein Passwort ein.","format":"8 Zeichen aus Gro\xdf- und Kleinbuchstaben, sowie Zahlen.","format_strong":"8 Zeichen aus Gro\xdf- und Kleinbuchstaben, sowie Zahlen und Sonderzeichen. Folgende Sonderzeichen sind erlaubt: = + - ^ $ * . [ ] { } ( ) ? \\" ! @ # % & / \\\\ , > < \' : ; | _ ~ `"},"confirm_password":{"required":"Bitte wiederholen Sie das Passwort.","format":"Die eingegebenen Passw\xf6rter stimmen nicht \xfcberein."},"first_name":{"required":"Bitte geben Sie einen Vorname ein"},"last_name":{"required":"Bitte geben Sie einen Namen ein"},"salutation":{"required":"Bitte w\xe4hlen Sie eine Anrede"},"accept":{"required":"Bitte akzeptieren Sie unsere AGB und Datenschutzbestimmungen"}},"Login":{"title":"Jetzt einloggen","description":"Loggen Sie sich ein mit Ihrer E-Mail und dem von Ihnen definierten Passwort.","forgot_password":"Passwort vergessen?"},"Register":{"title":"Jetzt kostenlos registrieren","description":"Mit Ihrer Registrierung stehen Ihnen zahlreiche Funktionen rund um ihre Nebenkosten zur Verf\xfcgung. Daf\xfcr m\xfcssen  Sie ein kostenloses Konto einrichten.","terms":"Ich akzeptiere die <0>AGB</0> und <1>Datenschutzbestimmungen</1> der Mineko GmbH.","success":"Ihre Registrierung war erfolgreich, Sie werden gleich weitergeleitet.","email_invalid":"Diese E-Mailadresse ist ung\xfcltig. Bitte \xfcberpr\xfcfen Sie Ihre Eingabe.","email_did_you_mean":"Meinten Sie vielleicht {{email}}?","email_validation_in_progress":"Bitte warten Sie einen Moment, w\xe4hrend wir Ihre E-Mail-Adresse \xfcberpr\xfcfen."},"ChangePassword":{"title":"Passwort \xe4ndern","description":"Setzten Sie Ihr neues Passwort fest","forgot_password":"Passwort vergessen?"},"ForgotPassword":{"request_new_password":{"title":"Bitte E-Mail eintragen","description":"Wir senden Ihnen per E-Mail einen Link zum Zur\xfccksetzen Ihres Passworts zu.","password_request_success":"Sie erhalten in K\xfcrze eine E-Mail mit einem Link zum Zur\xfccksetzen Ihres Passworts."},"set_new_password":{"title":"Neues Passwort definieren","description":"Bitte legen Sie hier Ihr neues Passwort fest.","password_change_success":"Ihr Passwort wurde erfolgreich gespeichert, bitte loggen Sie sich mit Ihrem neuen Passwort ein.","no_email_received":"E-Mail nicht bekommen ?"}},"Errors":{"user_does_not_exist":"Diese E-Mailadresse ist noch nicht registriert","user_already_exist":"Diese E-Mailadresse ist bereits registriert","incorrect_password":"Passwort oder E-Mailadresse falsch","incorrect_password_format":"Bitte w\xe4hlen Sie ein anderes Passwort","invalid_phone_number_format":"Telefonnumer ist falsch","user_cannot_confirm":"E-Mailadresse konnte nicht best\xe4tigt werden. Bitte versuchen Sie es erneut oder kontaktieren Sie uns.","invalid_verfication_code":"Code / TAN ist bereits abgelaufen. Bitte fragen Sie einen neuen an.","username_client_id_combination_not_found":"Leider ist ein Fehler aufgetreten. Bitte \xfcberpr\xfcfen Sie ihre Eingabe.","not_yet_confirmed":"Bitte best\xe4tigen Sie zuerst ihre E-Mailadresse. Dazu haben wir Ihnen eine E-Mail zugesandt.","not_yet_confirmed_reset_password":"Sie m\xfcssen zuerst ihre E-Mailadresse best\xe4tigen, um ihr Passwort zur\xfcckzusetzen. Dazu haben wir Ihnen eine E-Mail zugesandt.","request_limit_exceeded":"Bitte versuchen Sie es in einigen Minuten erneut.","force_forgot_password":"Bitte setzen Sie Ihr Passwort zur\xfcck.","generic_error":"Leider ist etwas schief gelaufen. Bitte probiere Sie es erneut oder kontaktieren Sie uns.","unauthorized":"Ihr Link ist abgelaufen oder ung\xfcltig. Bitte fordern Sie einen neuen an.","temporary_password_expired":"Ihr initiales Passwort ist abgelaufen. Bitte nutzen sie die \'Passwort vergessen?\' Funktion, um ein neues Passwort zu setzen.","user_not_found_or_federated_external":"Passwort zur\xfccksetzen nicht m\xf6glich: Bitte \xfcberpr\xfcfen Sie Ihre E-Mail-Adresse oder nutzen Sie \'weiter mit Google\' um sich anzumelden.","user_disabled":"Passwort oder E-Mailadresse falsch"}}');


function $585203bb1ec2fc05$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $585203bb1ec2fc05$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $585203bb1ec2fc05$export$2e2bcd8739ae039(obj);
}


function $9b2069f8af3dae67$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}




function $05337a15f6ab9ca5$export$2e2bcd8739ae039(input, hint) {
    if ((0, $585203bb1ec2fc05$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $585203bb1ec2fc05$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $8ca41e3b036ca5f9$export$2e2bcd8739ae039(arg) {
    var key = (0, $05337a15f6ab9ca5$export$2e2bcd8739ae039)(arg, "string");
    return (0, $585203bb1ec2fc05$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $fee914f4bb6c3920$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $8ca41e3b036ca5f9$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $fee914f4bb6c3920$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $fee914f4bb6c3920$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fee914f4bb6c3920$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}



var $9Yx8X = parcelRequire("9Yx8X");

var $lY8R5 = parcelRequire("lY8R5");
function $c876cbf5100f388d$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $lY8R5.default)(subClass, superClass);
}




var $9Yx8X = parcelRequire("9Yx8X");
function $33f165a8dce26502$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $585203bb1ec2fc05$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $9Yx8X.default)(self);
}


function $17c5aa89e8309cbb$export$2e2bcd8739ae039(o) {
    $17c5aa89e8309cbb$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $17c5aa89e8309cbb$export$2e2bcd8739ae039(o);
}



function $4ebde95508d5945d$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $8ca41e3b036ca5f9$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $5805039aac492bd6$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $071de728f82e1a81$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $aad028386a6ae4f2$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $1dde72e597199ee4$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $aad028386a6ae4f2$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $aad028386a6ae4f2$export$2e2bcd8739ae039)(o, minLen);
}


function $ede43814836043b2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $810b29792fe7d20f$export$2e2bcd8739ae039(arr) {
    return (0, $5805039aac492bd6$export$2e2bcd8739ae039)(arr) || (0, $071de728f82e1a81$export$2e2bcd8739ae039)(arr) || (0, $1dde72e597199ee4$export$2e2bcd8739ae039)(arr) || (0, $ede43814836043b2$export$2e2bcd8739ae039)();
}


function $b64e1282585fe5dc$var$ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b64e1282585fe5dc$var$_objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b64e1282585fe5dc$var$ownKeys$6(Object(source), !0).forEach(function(key) {
            (0, $4ebde95508d5945d$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b64e1282585fe5dc$var$ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $b64e1282585fe5dc$var$consoleLogger = {
    type: "logger",
    log: function log(args) {
        this.output("log", args);
    },
    warn: function warn(args) {
        this.output("warn", args);
    },
    error: function error(args) {
        this.output("error", args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var $b64e1282585fe5dc$var$Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $9b2069f8af3dae67$export$2e2bcd8739ae039)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $fee914f4bb6c3920$export$2e2bcd8739ae039)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || "i18next:";
                this.logger = concreteLogger || $b64e1282585fe5dc$var$consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, "log", "", true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, "warn", "", true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, "error", "");
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === "string") args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, $b64e1282585fe5dc$var$_objectSpread$6($b64e1282585fe5dc$var$_objectSpread$6({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }), this.options));
            }
        },
        {
            key: "clone",
            value: function clone(options) {
                options = options || this.options;
                options.prefix = options.prefix || this.prefix;
                return new Logger(this.logger, options);
            }
        }
    ]);
    return Logger;
}();
var $b64e1282585fe5dc$var$baseLogger = new $b64e1282585fe5dc$var$Logger();
var $b64e1282585fe5dc$var$EventEmitter = function() {
    function EventEmitter() {
        (0, $9b2069f8af3dae67$export$2e2bcd8739ae039)(this, EventEmitter);
        this.observers = {};
    }
    (0, $fee914f4bb6c3920$export$2e2bcd8739ae039)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(" ").forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers["*"]) {
                    var _cloned = [].concat(this.observers["*"]);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function $b64e1282585fe5dc$var$defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $b64e1282585fe5dc$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $b64e1282585fe5dc$var$copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function $b64e1282585fe5dc$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    var stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $b64e1282585fe5dc$var$setPath(object, path, newValue) {
    var _getLastOfPath = $b64e1282585fe5dc$var$getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function $b64e1282585fe5dc$var$pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = $b64e1282585fe5dc$var$getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $b64e1282585fe5dc$var$getPath(object, path) {
    var _getLastOfPath3 = $b64e1282585fe5dc$var$getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function $b64e1282585fe5dc$var$getPathWithDefaults(data, defaultData, key) {
    var value = $b64e1282585fe5dc$var$getPath(data, key);
    if (value !== undefined) return value;
    return $b64e1282585fe5dc$var$getPath(defaultData, key);
}
function $b64e1282585fe5dc$var$deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $b64e1282585fe5dc$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $b64e1282585fe5dc$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $b64e1282585fe5dc$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $b64e1282585fe5dc$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, function(s) {
        return $b64e1282585fe5dc$var$_entityMap[s];
    });
    return data;
}
var $b64e1282585fe5dc$var$isIE10 = typeof window !== "undefined" && window.navigator && typeof window.navigator.userAgentData === "undefined" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
var $b64e1282585fe5dc$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
function $b64e1282585fe5dc$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    var possibleChars = $b64e1282585fe5dc$var$chars.filter(function(c) {
        return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
    });
    if (possibleChars.length === 0) return true;
    var r = new RegExp("(".concat(possibleChars.map(function(c) {
        return c === "?" ? "\\?" : c;
    }).join("|"), ")"));
    var matched = !r.test(key);
    if (!matched) {
        var ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $b64e1282585fe5dc$var$deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === "string") return mix;
                if (p && typeof mix[p] === "string") return mix[p];
            }
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return $b64e1282585fe5dc$var$deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
function $b64e1282585fe5dc$var$ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b64e1282585fe5dc$var$_objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b64e1282585fe5dc$var$ownKeys$5(Object(source), !0).forEach(function(key) {
            (0, $4ebde95508d5945d$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b64e1282585fe5dc$var$ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b64e1282585fe5dc$var$_createSuper$3(Derived) {
    var hasNativeReflectConstruct = $b64e1282585fe5dc$var$_isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, $17c5aa89e8309cbb$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $17c5aa89e8309cbb$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $33f165a8dce26502$export$2e2bcd8739ae039)(this, result);
    };
}
function $b64e1282585fe5dc$var$_isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $b64e1282585fe5dc$var$ResourceStore = function(_EventEmitter) {
    (0, $c876cbf5100f388d$export$2e2bcd8739ae039)(ResourceStore, _EventEmitter);
    var _super = $b64e1282585fe5dc$var$_createSuper$3(ResourceStore);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        (0, $9b2069f8af3dae67$export$2e2bcd8739ae039)(this, ResourceStore);
        _this = _super.call(this);
        if ($b64e1282585fe5dc$var$isIE10) $b64e1282585fe5dc$var$EventEmitter.call((0, $9Yx8X.default)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $fee914f4bb6c3920$export$2e2bcd8739ae039)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== "string") path = path.concat(key);
                if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) path = lng.split(".");
                var result = $b64e1282585fe5dc$var$getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== "string") return result;
                return $b64e1282585fe5dc$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                $b64e1282585fe5dc$var$setPath(this.data, path, value);
                if (!options.silent) this.emit("added", lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = $b64e1282585fe5dc$var$getPath(this.data, path) || {};
                if (deep) $b64e1282585fe5dc$var$deepExtend(pack, resources, overwrite);
                else pack = $b64e1282585fe5dc$var$_objectSpread$5($b64e1282585fe5dc$var$_objectSpread$5({}, pack), resources);
                $b64e1282585fe5dc$var$setPath(this.data, path, pack);
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit("removed", lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === "v1") return $b64e1282585fe5dc$var$_objectSpread$5($b64e1282585fe5dc$var$_objectSpread$5({}, {}), this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "hasLanguageSomeTranslations",
            value: function hasLanguageSomeTranslations(lng) {
                var data = this.getDataByLanguage(lng);
                var n = data && Object.keys(data) || [];
                return !!n.find(function(v) {
                    return data[v] && Object.keys(data[v]).length > 0;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}($b64e1282585fe5dc$var$EventEmitter);
var $b64e1282585fe5dc$var$postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
function $b64e1282585fe5dc$var$ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b64e1282585fe5dc$var$_objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b64e1282585fe5dc$var$ownKeys$4(Object(source), !0).forEach(function(key) {
            (0, $4ebde95508d5945d$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b64e1282585fe5dc$var$ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b64e1282585fe5dc$var$_createSuper$2(Derived) {
    var hasNativeReflectConstruct = $b64e1282585fe5dc$var$_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, $17c5aa89e8309cbb$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $17c5aa89e8309cbb$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $33f165a8dce26502$export$2e2bcd8739ae039)(this, result);
    };
}
function $b64e1282585fe5dc$var$_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $b64e1282585fe5dc$var$checkedLoadedFor = {};
var $b64e1282585fe5dc$var$Translator = function(_EventEmitter) {
    (0, $c876cbf5100f388d$export$2e2bcd8739ae039)(Translator, _EventEmitter);
    var _super = $b64e1282585fe5dc$var$_createSuper$2(Translator);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $9b2069f8af3dae67$export$2e2bcd8739ae039)(this, Translator);
        _this = _super.call(this);
        if ($b64e1282585fe5dc$var$isIE10) $b64e1282585fe5dc$var$EventEmitter.call((0, $9Yx8X.default)(_this));
        $b64e1282585fe5dc$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, (0, $9Yx8X.default)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        _this.logger = $b64e1282585fe5dc$var$baseLogger.create("translator");
        return _this;
    }
    (0, $fee914f4bb6c3920$export$2e2bcd8739ae039)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ":";
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS || [];
                var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
                var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$b64e1282585fe5dc$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
                if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $585203bb1ec2fc05$export$2e2bcd8739ae039)(options) !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if ((0, $585203bb1ec2fc05$export$2e2bcd8739ae039)(options) === "object") options = $b64e1282585fe5dc$var$_objectSpread$4({}, options);
                if (!options) options = {};
                if (keys === undefined || keys === null) return "";
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === "cimode") {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        if (returnDetails) return {
                            res: "".concat(namespace).concat(nsSeparator).concat(key),
                            usedKey: key,
                            exactUsedKey: key,
                            usedLng: lng,
                            usedNS: namespace
                        };
                        return "".concat(namespace).concat(nsSeparator).concat(key);
                    }
                    if (returnDetails) return {
                        res: key,
                        usedKey: key,
                        exactUsedKey: key,
                        usedLng: lng,
                        usedNS: namespace
                    };
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    "[object Number]",
                    "[object Function]",
                    "[object RegExp]"
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                        var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, $b64e1282585fe5dc$var$_objectSpread$4($b64e1282585fe5dc$var$_objectSpread$4({}, options), {}, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                        if (returnDetails) {
                            resolved.res = r;
                            return resolved;
                        }
                        return r;
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === "[object Array]";
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, $b64e1282585fe5dc$var$_objectSpread$4($b64e1282585fe5dc$var$_objectSpread$4({}, options), {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, $b64e1282585fe5dc$var$_objectSpread$4($b64e1282585fe5dc$var$_objectSpread$4({}, options), {}, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, specificDefaultValue) {
                            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                            _this2.emit("missingKey", l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language, options).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                        if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
                        else res = this.options.parseMissingKeyHandler(res);
                    }
                }
                if (returnDetails) {
                    resolved.res = res;
                    return resolved;
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, $b64e1282585fe5dc$var$_objectSpread$4($b64e1282585fe5dc$var$_objectSpread$4({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init($b64e1282585fe5dc$var$_objectSpread$4($b64e1282585fe5dc$var$_objectSpread$4({}, options), {
                        interpolation: $b64e1282585fe5dc$var$_objectSpread$4($b64e1282585fe5dc$var$_objectSpread$4({}, this.options.interpolation), options.interpolation)
                    }));
                    var skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== "string" ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = $b64e1282585fe5dc$var$_objectSpread$4($b64e1282585fe5dc$var$_objectSpread$4({}, this.options.interpolation.defaultVariables), data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = resolved.usedLng;
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === "string" ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $b64e1282585fe5dc$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? $b64e1282585fe5dc$var$_objectSpread$4({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === "string") keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
                    var needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!$b64e1282585fe5dc$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            $b64e1282585fe5dc$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), '" won\'t get resolved as namespace "').concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKeys = [
                                key
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
                                var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
                                if (needsPluralHandling) {
                                    finalKeys.push(key + pluralSuffix);
                                    if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                                }
                                if (needsContextHandling) {
                                    var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                                    finalKeys.push(contextKey);
                                    if (needsPluralHandling) {
                                        finalKeys.push(contextKey + pluralSuffix);
                                        if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                                    }
                                }
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = "defaultValue";
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}($b64e1282585fe5dc$var$EventEmitter);
function $b64e1282585fe5dc$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $b64e1282585fe5dc$var$LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $9b2069f8af3dae67$export$2e2bcd8739ae039)(this, LanguageUtil);
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $b64e1282585fe5dc$var$baseLogger.create("languageUtils");
    }
    (0, $fee914f4bb6c3920$export$2e2bcd8739ae039)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return null;
                var p = code.split("-");
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === "x") return null;
                return this.formatLanguageCode(p.join("-"));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return code;
                var p = code.split("-");
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    var specialCases = [
                        "hans",
                        "hant",
                        "latn",
                        "cyrl",
                        "cans",
                        "mong",
                        "arab"
                    ];
                    var p = code.split("-");
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $b64e1282585fe5dc$var$capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $b64e1282585fe5dc$var$capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $b64e1282585fe5dc$var$capitalize(p[2].toLowerCase());
                    }
                    return p.join("-");
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng === lngOnly) return supportedLng;
                        if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === "function") fallbacks = fallbacks(code);
                if (typeof fallbacks === "string") fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
                    if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var $b64e1282585fe5dc$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var $b64e1282585fe5dc$var$_rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
var $b64e1282585fe5dc$var$deprecatedJsonVersions = [
    "v1",
    "v2",
    "v3"
];
var $b64e1282585fe5dc$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $b64e1282585fe5dc$var$createRules() {
    var rules = {};
    $b64e1282585fe5dc$var$sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: $b64e1282585fe5dc$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var $b64e1282585fe5dc$var$PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $9b2069f8af3dae67$export$2e2bcd8739ae039)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $b64e1282585fe5dc$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $b64e1282585fe5dc$var$createRules();
    }
    (0, $fee914f4bb6c3920$export$2e2bcd8739ae039)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (this.shouldUseIntlApi()) try {
                    return new Intl.PluralRules(code, {
                        type: options.ordinal ? "ordinal" : "cardinal"
                    });
                } catch (_unused) {
                    return;
                }
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.getSuffixes(code, options).map(function(suffix) {
                    return "".concat(key).concat(suffix);
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) return [];
                if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
                    return $b64e1282585fe5dc$var$suffixesOrder[pluralCategory1] - $b64e1282585fe5dc$var$suffixesOrder[pluralCategory2];
                }).map(function(pluralCategory) {
                    return "".concat(_this.options.prepend).concat(pluralCategory);
                });
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number, options);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var rule = this.getRule(code, options);
                if (rule) {
                    if (this.shouldUseIntlApi()) return "".concat(this.options.prepend).concat(rule.select(count));
                    return this.getSuffixRetroCompatible(rule, count);
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return "";
            }
        },
        {
            key: "getSuffixRetroCompatible",
            value: function getSuffixRetroCompatible(rule, count) {
                var _this2 = this;
                var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                var suffix = rule.numbers[idx];
                if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                    if (suffix === 2) suffix = "plural";
                    else if (suffix === 1) suffix = "";
                }
                var returnSuffix = function returnSuffix() {
                    return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                };
                if (this.options.compatibilityJSON === "v1") {
                    if (suffix === 1) return "";
                    if (typeof suffix === "number") return "_plural_".concat(suffix.toString());
                    return returnSuffix();
                } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
                else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
            }
        },
        {
            key: "shouldUseIntlApi",
            value: function shouldUseIntlApi() {
                return !$b64e1282585fe5dc$var$deprecatedJsonVersions.includes(this.options.compatibilityJSON);
            }
        }
    ]);
    return PluralResolver;
}();
function $b64e1282585fe5dc$var$ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b64e1282585fe5dc$var$_objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b64e1282585fe5dc$var$ownKeys$3(Object(source), !0).forEach(function(key) {
            (0, $4ebde95508d5945d$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b64e1282585fe5dc$var$ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b64e1282585fe5dc$var$deepFindWithDefaults(data, defaultData, key) {
    var keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    var ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var path = $b64e1282585fe5dc$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
        path = $b64e1282585fe5dc$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $b64e1282585fe5dc$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
}
var $b64e1282585fe5dc$var$Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $9b2069f8af3dae67$export$2e2bcd8739ae039)(this, Interpolator);
        this.logger = $b64e1282585fe5dc$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $fee914f4bb6c3920$export$2e2bcd8739ae039)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : $b64e1282585fe5dc$var$escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? $b64e1282585fe5dc$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
                this.suffix = iOpts.suffix ? $b64e1282585fe5dc$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
                this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
                this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
                this.nestingPrefix = iOpts.nestingPrefix ? $b64e1282585fe5dc$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $b64e1282585fe5dc$var$regexEscape("$t(");
                this.nestingSuffix = iOpts.nestingSuffix ? $b64e1282585fe5dc$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $b64e1282585fe5dc$var$regexEscape(")");
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, "g");
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, "$$$$");
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = $b64e1282585fe5dc$var$deepFindWithDefaults(data, defaultData, key, _this.options.keySeparator, _this.options.ignoreJSONStructure);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, $b64e1282585fe5dc$var$_objectSpread$3($b64e1282585fe5dc$var$_objectSpread$3($b64e1282585fe5dc$var$_objectSpread$3({}, options), data), {}, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format($b64e1282585fe5dc$var$deepFindWithDefaults(data, defaultData, k, _this.options.keySeparator, _this.options.ignoreJSONStructure), f, lng, $b64e1282585fe5dc$var$_objectSpread$3($b64e1282585fe5dc$var$_objectSpread$3($b64e1282585fe5dc$var$_objectSpread$3({}, options), data), {}, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        var matchedVar = match[1].trim();
                        value = handleFormat(matchedVar);
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === "function") {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === "string" ? temp : "";
                            } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                            else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
                                value = "";
                            }
                        } else if (typeof value !== "string" && !_this.useRawValueToEscape) value = $b64e1282585fe5dc$var$makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += value.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    var matchedSingleQuotes = optionsString.match(/'/g);
                    var matchedDoubleQuotes = optionsString.match(/"/g);
                    if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = $b64e1282585fe5dc$var$_objectSpread$3($b64e1282585fe5dc$var$_objectSpread$3({}, inheritedOptions), clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    clonedOptions = $b64e1282585fe5dc$var$_objectSpread$3({}, options);
                    clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
                    clonedOptions.applyPostProcessor = false;
                    delete clonedOptions.defaultValue;
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== "string") return value;
                    if (typeof value !== "string") value = $b64e1282585fe5dc$var$makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = "";
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, $b64e1282585fe5dc$var$_objectSpread$3($b64e1282585fe5dc$var$_objectSpread$3({}, options), {}, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function $b64e1282585fe5dc$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b64e1282585fe5dc$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b64e1282585fe5dc$var$ownKeys$2(Object(source), !0).forEach(function(key) {
            (0, $4ebde95508d5945d$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b64e1282585fe5dc$var$ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b64e1282585fe5dc$var$parseFormatStr(formatStr) {
    var formatName = formatStr.toLowerCase().trim();
    var formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        var p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        var optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            var opts = optStr.split(";");
            opts.forEach(function(opt) {
                if (!opt) return;
                var _opt$split = opt.split(":"), _opt$split2 = (0, $810b29792fe7d20f$export$2e2bcd8739ae039)(_opt$split), key = _opt$split2[0], rest = _opt$split2.slice(1);
                var val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $b64e1282585fe5dc$var$createCachedFormatter(fn) {
    var cache = {};
    return function invokeFormatter(val, lng, options) {
        var key = lng + JSON.stringify(options);
        var formatter = cache[key];
        if (!formatter) {
            formatter = fn(lng, options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
var $b64e1282585fe5dc$var$Formatter = function() {
    function Formatter() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $9b2069f8af3dae67$export$2e2bcd8739ae039)(this, Formatter);
        this.logger = $b64e1282585fe5dc$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $b64e1282585fe5dc$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, $b64e1282585fe5dc$var$_objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            currency: $b64e1282585fe5dc$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, $b64e1282585fe5dc$var$_objectSpread$2($b64e1282585fe5dc$var$_objectSpread$2({}, opt), {}, {
                    style: "currency"
                }));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            datetime: $b64e1282585fe5dc$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.DateTimeFormat(lng, $b64e1282585fe5dc$var$_objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            relativetime: $b64e1282585fe5dc$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.RelativeTimeFormat(lng, $b64e1282585fe5dc$var$_objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val, opt.range || "day");
                };
            }),
            list: $b64e1282585fe5dc$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.ListFormat(lng, $b64e1282585fe5dc$var$_objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            })
        };
        this.init(options);
    }
    (0, $fee914f4bb6c3920$export$2e2bcd8739ae039)(Formatter, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var iOpts = options.interpolation;
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
            }
        },
        {
            key: "add",
            value: function add(name, fc) {
                this.formats[name.toLowerCase().trim()] = fc;
            }
        },
        {
            key: "addCached",
            value: function addCached(name, fc) {
                this.formats[name.toLowerCase().trim()] = $b64e1282585fe5dc$var$createCachedFormatter(fc);
            }
        },
        {
            key: "format",
            value: function format(value, _format, lng) {
                var _this = this;
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var formats = _format.split(this.formatSeparator);
                var result = formats.reduce(function(mem, f) {
                    var _parseFormatStr = $b64e1282585fe5dc$var$parseFormatStr(f), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
                    if (_this.formats[formatName]) {
                        var formatted = mem;
                        try {
                            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                            formatted = _this.formats[formatName](mem, l, $b64e1282585fe5dc$var$_objectSpread$2($b64e1282585fe5dc$var$_objectSpread$2($b64e1282585fe5dc$var$_objectSpread$2({}, formatOptions), options), valOptions));
                        } catch (error) {
                            _this.logger.warn(error);
                        }
                        return formatted;
                    } else _this.logger.warn("there was no format function for ".concat(formatName));
                    return mem;
                }, value);
                return result;
            }
        }
    ]);
    return Formatter;
}();
function $b64e1282585fe5dc$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b64e1282585fe5dc$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b64e1282585fe5dc$var$ownKeys$1(Object(source), !0).forEach(function(key) {
            (0, $4ebde95508d5945d$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b64e1282585fe5dc$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b64e1282585fe5dc$var$_createSuper$1(Derived) {
    var hasNativeReflectConstruct = $b64e1282585fe5dc$var$_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, $17c5aa89e8309cbb$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $17c5aa89e8309cbb$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $33f165a8dce26502$export$2e2bcd8739ae039)(this, result);
    };
}
function $b64e1282585fe5dc$var$_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b64e1282585fe5dc$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
var $b64e1282585fe5dc$var$Connector = function(_EventEmitter) {
    (0, $c876cbf5100f388d$export$2e2bcd8739ae039)(Connector, _EventEmitter);
    var _super = $b64e1282585fe5dc$var$_createSuper$1(Connector);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $9b2069f8af3dae67$export$2e2bcd8739ae039)(this, Connector);
        _this = _super.call(this);
        if ($b64e1282585fe5dc$var$isIE10) $b64e1282585fe5dc$var$EventEmitter.call((0, $9Yx8X.default)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = $b64e1282585fe5dc$var$baseLogger.create("backendConnector");
        _this.waitingReads = [];
        _this.maxParallelReads = options.maxParallelReads || 10;
        _this.readingCalls = 0;
        _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $fee914f4bb6c3920$export$2e2bcd8739ae039)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = {};
                var pending = {};
                var toLoadLanguages = {};
                var toLoadNamespaces = {};
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending[name] === undefined) pending[name] = true;
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending[name] === undefined) pending[name] = true;
                            if (toLoad[name] === undefined) toLoad[name] = true;
                            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages[lng] = true;
                });
                if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
                    pending: pending,
                    pendingCount: Object.keys(pending).length,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: Object.keys(toLoad),
                    pending: Object.keys(pending),
                    toLoadLanguages: Object.keys(toLoadLanguages),
                    toLoadNamespaces: Object.keys(toLoadNamespaces)
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit("failedLoading", lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    $b64e1282585fe5dc$var$pushPath(q.loaded, [
                        lng
                    ], ns);
                    $b64e1282585fe5dc$var$removePending(q, name);
                    if (err) q.errors.push(err);
                    if (q.pendingCount === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = {};
                            var loadedKeys = q.loaded[l];
                            if (loadedKeys.length) loadedKeys.forEach(function(n) {
                                if (loaded[l][n] === undefined) loaded[l][n] = true;
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit("loaded", loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                if (this.readingCalls >= this.maxParallelReads) {
                    this.waitingReads.push({
                        lng: lng,
                        ns: ns,
                        fcName: fcName,
                        tried: tried,
                        wait: wait,
                        callback: callback
                    });
                    return;
                }
                this.readingCalls++;
                var resolver = function resolver(err, data) {
                    _this3.readingCalls--;
                    if (_this3.waitingReads.length > 0) {
                        var next = _this3.waitingReads.shift();
                        _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
                    }
                    if (err && data && tried < _this3.maxRetries) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                };
                var fc = this.backend[fcName].bind(this.backend);
                if (fc.length === 2) {
                    try {
                        var r = fc(lng, ns);
                        if (r && typeof r.then === "function") r.then(function(data) {
                            return resolver(null, data);
                        })["catch"](resolver);
                        else resolver(null, r);
                    } catch (err) {
                        resolver(err);
                    }
                    return;
                }
                return fc(lng, ns, resolver);
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn("No backend was added via i18next.use. Will not load resources.");
                    return callback && callback();
                }
                if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, "read", undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function() {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                    return;
                }
                if (key === undefined || key === null || key === "") return;
                if (this.backend && this.backend.create) {
                    var opts = $b64e1282585fe5dc$var$_objectSpread$1($b64e1282585fe5dc$var$_objectSpread$1({}, options), {}, {
                        isUpdate: isUpdate
                    });
                    var fc = this.backend.create.bind(this.backend);
                    if (fc.length < 6) try {
                        var r;
                        if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                        else r = fc(languages, namespace, key, fallbackValue);
                        if (r && typeof r.then === "function") r.then(function(data) {
                            return clb(null, data);
                        })["catch"](clb);
                        else clb(null, r);
                    } catch (err) {
                        clb(err);
                    }
                    else fc(languages, namespace, key, fallbackValue, clb, opts);
                }
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}($b64e1282585fe5dc$var$EventEmitter);
function $b64e1282585fe5dc$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $585203bb1ec2fc05$export$2e2bcd8739ae039)(args[1]) === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if ((0, $585203bb1ec2fc05$export$2e2bcd8739ae039)(args[2]) === "object" || (0, $585203bb1ec2fc05$export$2e2bcd8739ae039)(args[3]) === "object") {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $b64e1282585fe5dc$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $b64e1282585fe5dc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b64e1282585fe5dc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b64e1282585fe5dc$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $4ebde95508d5945d$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b64e1282585fe5dc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b64e1282585fe5dc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b64e1282585fe5dc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $17c5aa89e8309cbb$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $17c5aa89e8309cbb$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $33f165a8dce26502$export$2e2bcd8739ae039)(this, result);
    };
}
function $b64e1282585fe5dc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b64e1282585fe5dc$var$noop() {}
function $b64e1282585fe5dc$var$bindMemberFunctions(inst) {
    var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(function(mem) {
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
var $b64e1282585fe5dc$var$I18n = function(_EventEmitter) {
    (0, $c876cbf5100f388d$export$2e2bcd8739ae039)(I18n, _EventEmitter);
    var _super = $b64e1282585fe5dc$var$_createSuper(I18n);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $9b2069f8af3dae67$export$2e2bcd8739ae039)(this, I18n);
        _this = _super.call(this);
        if ($b64e1282585fe5dc$var$isIE10) $b64e1282585fe5dc$var$EventEmitter.call((0, $9Yx8X.default)(_this));
        _this.options = $b64e1282585fe5dc$var$transformOptions(options);
        _this.services = {};
        _this.logger = $b64e1282585fe5dc$var$baseLogger;
        _this.modules = {
            external: []
        };
        $b64e1282585fe5dc$var$bindMemberFunctions((0, $9Yx8X.default)(_this));
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $33f165a8dce26502$export$2e2bcd8739ae039)(_this, (0, $9Yx8X.default)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $fee914f4bb6c3920$export$2e2bcd8739ae039)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === "function") {
                    callback = options;
                    options = {};
                }
                if (!options.defaultNS && options.defaultNS !== false && options.ns) {
                    if (typeof options.ns === "string") options.defaultNS = options.ns;
                    else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
                }
                var defOpts = $b64e1282585fe5dc$var$get();
                this.options = $b64e1282585fe5dc$var$_objectSpread($b64e1282585fe5dc$var$_objectSpread($b64e1282585fe5dc$var$_objectSpread({}, defOpts), this.options), $b64e1282585fe5dc$var$transformOptions(options));
                if (this.options.compatibilityAPI !== "v1") this.options.interpolation = $b64e1282585fe5dc$var$_objectSpread($b64e1282585fe5dc$var$_objectSpread({}, defOpts.interpolation), this.options.interpolation);
                if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
                if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === "function") return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) $b64e1282585fe5dc$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else $b64e1282585fe5dc$var$baseLogger.init(null, this.options);
                    var formatter;
                    if (this.modules.formatter) formatter = this.modules.formatter;
                    else if (typeof Intl !== "undefined") formatter = $b64e1282585fe5dc$var$Formatter;
                    var lu = new $b64e1282585fe5dc$var$LanguageUtil(this.options);
                    this.store = new $b64e1282585fe5dc$var$ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = $b64e1282585fe5dc$var$baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new $b64e1282585fe5dc$var$PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                        s.formatter = createClassOnDemand(formatter);
                        s.formatter.init(s, this.options);
                        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
                    }
                    s.interpolator = new $b64e1282585fe5dc$var$Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new $b64e1282585fe5dc$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on("*", function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new $b64e1282585fe5dc$var$Translator(this.services, this.options);
                    this.translator.on("*", function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                this.format = this.options.interpolation.format;
                if (!callback) callback = $b64e1282585fe5dc$var$noop;
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
                var storeApi = [
                    "getResource",
                    "hasResourceBundle",
                    "getResourceBundle",
                    "getDataByLanguage"
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    "addResource",
                    "addResources",
                    "addResourceBundle",
                    "removeResourceBundle"
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = $b64e1282585fe5dc$var$defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn("init: i18next is already initialized. You should call init just once!");
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log("initialized", _this2.options);
                        _this2.emit("initialized", _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== "v1" && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $b64e1282585fe5dc$var$noop;
                var usedCallback = callback;
                var usedLng = typeof language === "string" ? language : this.language;
                if (typeof language === "function") usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === "cimode") return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, function(e) {
                        if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
                        usedCallback(e);
                    });
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = $b64e1282585fe5dc$var$defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = $b64e1282585fe5dc$var$noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
                if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
                if (module.type === "backend") this.modules.backend = module;
                if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === "languageDetector") this.modules.languageDetector = module;
                if (module.type === "i18nFormat") this.modules.i18nFormat = module;
                if (module.type === "postProcessor") $b64e1282585fe5dc$var$postProcessor.addPostProcessor(module);
                if (module.type === "formatter") this.modules.formatter = module;
                if (module.type === "3rdParty") this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "setResolvedLanguage",
            value: function setResolvedLanguage(l) {
                if (!l || !this.languages) return;
                if ([
                    "cimode",
                    "dev"
                ].indexOf(l) > -1) return;
                for(var li = 0; li < this.languages.length; li++){
                    var lngInLngs = this.languages[li];
                    if ([
                        "cimode",
                        "dev"
                    ].indexOf(lngInLngs) > -1) continue;
                    if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                        this.resolvedLanguage = lngInLngs;
                        break;
                    }
                }
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = $b64e1282585fe5dc$var$defer();
                this.emit("languageChanging", lng);
                var setLngProps = function setLngProps(l) {
                    _this4.language = l;
                    _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                    _this4.resolvedLanguage = undefined;
                    _this4.setResolvedLanguage(l);
                };
                var done = function done(err, l) {
                    if (l) {
                        setLngProps(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit("languageChanged", l);
                        _this4.logger.log("languageChanged", l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === "string" ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) setLngProps(l);
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector && _this4.services.languageDetector.cacheUserLanguage) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
                    if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
                    else this.services.languageDetector.detect(setLng);
                } else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $585203bb1ec2fc05$export$2e2bcd8739ae039)(opts) !== "object") {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = $b64e1282585fe5dc$var$_objectSpread({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
                    var keySeparator = _this5.options.keySeparator || ".";
                    var resultKey;
                    if (options.keyPrefix && Array.isArray(key)) resultKey = key.map(function(k) {
                        return "".concat(options.keyPrefix).concat(keySeparator).concat(k);
                    });
                    else resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === "string") fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
                    return false;
                }
                var lng = options.lng || this.resolvedLanguage || this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === "cimode") return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = $b64e1282585fe5dc$var$defer();
                if (!this.options.ns) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                if (typeof ns === "string") ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = $b64e1282585fe5dc$var$defer();
                if (typeof lngs === "string") lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
                if (!lng) return "rtl";
                var rtlLngs = [
                    "ar",
                    "shu",
                    "sqr",
                    "ssh",
                    "xaa",
                    "yhd",
                    "yud",
                    "aao",
                    "abh",
                    "abv",
                    "acm",
                    "acq",
                    "acw",
                    "acx",
                    "acy",
                    "adf",
                    "ads",
                    "aeb",
                    "aec",
                    "afb",
                    "ajp",
                    "apc",
                    "apd",
                    "arb",
                    "arq",
                    "ars",
                    "ary",
                    "arz",
                    "auz",
                    "avl",
                    "ayh",
                    "ayl",
                    "ayn",
                    "ayp",
                    "bbz",
                    "pga",
                    "he",
                    "iw",
                    "ps",
                    "pbt",
                    "pbu",
                    "pst",
                    "prp",
                    "prd",
                    "ug",
                    "ur",
                    "ydd",
                    "yds",
                    "yih",
                    "ji",
                    "yi",
                    "hbo",
                    "men",
                    "xmn",
                    "fa",
                    "jpr",
                    "peo",
                    "pes",
                    "prs",
                    "dv",
                    "sam",
                    "ckb"
                ];
                var languageUtils = this.services && this.services.languageUtils || new $b64e1282585fe5dc$var$LanguageUtil($b64e1282585fe5dc$var$get());
                return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $b64e1282585fe5dc$var$noop;
                var mergedOptions = $b64e1282585fe5dc$var$_objectSpread($b64e1282585fe5dc$var$_objectSpread($b64e1282585fe5dc$var$_objectSpread({}, this.options), options), {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
                var membersToCopy = [
                    "store",
                    "services",
                    "language"
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = $b64e1282585fe5dc$var$_objectSpread({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new $b64e1282585fe5dc$var$Translator(clone.services, clone.options);
                clone.translator.on("*", function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages,
                    resolvedLanguage: this.resolvedLanguage
                };
            }
        }
    ]);
    return I18n;
}($b64e1282585fe5dc$var$EventEmitter);
(0, $4ebde95508d5945d$export$2e2bcd8739ae039)($b64e1282585fe5dc$var$I18n, "createInstance", function() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    return new $b64e1282585fe5dc$var$I18n(options, callback);
});
var $b64e1282585fe5dc$export$2e2bcd8739ae039 = $b64e1282585fe5dc$var$I18n.createInstance();
$b64e1282585fe5dc$export$2e2bcd8739ae039.createInstance = $b64e1282585fe5dc$var$I18n.createInstance;
var $b64e1282585fe5dc$export$99152e8d49ca4e7d = $b64e1282585fe5dc$export$2e2bcd8739ae039.createInstance;
var $b64e1282585fe5dc$export$147ec2801e896265 = $b64e1282585fe5dc$export$2e2bcd8739ae039.dir;
var $b64e1282585fe5dc$export$2cd8252107eb640b = $b64e1282585fe5dc$export$2e2bcd8739ae039.init;
var $b64e1282585fe5dc$export$d3d08d944062d7e = $b64e1282585fe5dc$export$2e2bcd8739ae039.loadResources;
var $b64e1282585fe5dc$export$a5d9bf5d83fcab09 = $b64e1282585fe5dc$export$2e2bcd8739ae039.reloadResources;
var $b64e1282585fe5dc$export$1f96ae73734a86cc = $b64e1282585fe5dc$export$2e2bcd8739ae039.use;
var $b64e1282585fe5dc$export$61465194746e7fd2 = $b64e1282585fe5dc$export$2e2bcd8739ae039.changeLanguage;
var $b64e1282585fe5dc$export$f90d180fc7da3b3b = $b64e1282585fe5dc$export$2e2bcd8739ae039.getFixedT;
var $b64e1282585fe5dc$export$625550452a3fa3ec = $b64e1282585fe5dc$export$2e2bcd8739ae039.t;
var $b64e1282585fe5dc$export$f7e9f41ea797a17 = $b64e1282585fe5dc$export$2e2bcd8739ae039.exists;
var $b64e1282585fe5dc$export$2b4b218e406d2d00 = $b64e1282585fe5dc$export$2e2bcd8739ae039.setDefaultNamespace;
var $b64e1282585fe5dc$export$93d9ee97c1ad3f31 = $b64e1282585fe5dc$export$2e2bcd8739ae039.hasLoadedNamespace;
var $b64e1282585fe5dc$export$83be934b53fff43b = $b64e1282585fe5dc$export$2e2bcd8739ae039.loadNamespaces;
var $b64e1282585fe5dc$export$8cd7e7a54fa865bc = $b64e1282585fe5dc$export$2e2bcd8739ae039.loadLanguages;


parcelRequire("1L1yK");
var $ajWkC = parcelRequire("ajWkC");
const $c3a17a7441d02192$var$resources = {
    de: {
        translation: {
            ...(0, (/*@__PURE__*/$parcel$interopDefault($0b05cf51e2255743$exports)))
        }
    }
};
(0, $b64e1282585fe5dc$export$2e2bcd8739ae039).use((0, $ajWkC.initReactI18next)).init({
    resources: $c3a17a7441d02192$var$resources,
    lng: "de",
    interpolation: {
        escapeValue: false
    }
});
var $c3a17a7441d02192$export$2e2bcd8739ae039 = (0, $b64e1282585fe5dc$export$2e2bcd8739ae039);


console.info(`Release: ${window["VERSION"]}`);
const $749f234016407540$export$34e0f9847d4c02dd = document.getElementById("root");
const $749f234016407540$var$root = (0, $3045335d06a4a99d$export$882461b6382ed46c)($749f234016407540$export$34e0f9847d4c02dd);
$749f234016407540$var$root.render(/*#__PURE__*/ (0, $dYG3T.jsx)((0, $6016fe75dc4289b6$export$2e2bcd8739ae039), {}));

})();
//# sourceMappingURL=index.d1448c15.js.map
